var p8 = Object.defineProperty;
var g8 = (n, c, u) => c in n ? p8(n, c, { enumerable: !0, configurable: !0, writable: !0, value: u }) : n[c] = u;
var As = (n, c, u) => g8(n, typeof c != "symbol" ? c + "" : c, u);
import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { Text, MobileDialog, Dialog, Avatar, DialogHeader, DialogBody, DialogFooter, Button, Heading, Radio, Checkbox, Loader, Chip } from "@babylonlabs-io/core-ui";
import _, { SupportedResult, ReadStatus, PlayStatus, viewSdk } from "@keystonehq/sdk";
import { SigningStargateClient } from "@cosmjs/stargate";
import De, { createContext, useMemo, useReducer, useEffect, useDebugValue, useCallback, useState, useContext, useRef, createElement, Suspense, memo, useLayoutEffect } from "react";
import { createPortal } from "react-dom";
import { twJoin, twMerge } from "tailwind-merge";
var buffer$3 = {}, base64Js$1 = {};
base64Js$1.byteLength = byteLength$1;
base64Js$1.toByteArray = toByteArray$1;
base64Js$1.fromByteArray = fromByteArray$1;
var lookup$1 = [], revLookup$1 = [], Arr$1 = typeof Uint8Array < "u" ? Uint8Array : Array, code$1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var i$b = 0, len$1 = code$1.length; i$b < len$1; ++i$b)
  lookup$1[i$b] = code$1[i$b], revLookup$1[code$1.charCodeAt(i$b)] = i$b;
revLookup$1[45] = 62;
revLookup$1[95] = 63;
function getLens$1(n) {
  var c = n.length;
  if (c % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var u = n.indexOf("=");
  u === -1 && (u = c);
  var p = u === c ? 0 : 4 - u % 4;
  return [u, p];
}
function byteLength$1(n) {
  var c = getLens$1(n), u = c[0], p = c[1];
  return (u + p) * 3 / 4 - p;
}
function _byteLength$1(n, c, u) {
  return (c + u) * 3 / 4 - u;
}
function toByteArray$1(n) {
  var c, u = getLens$1(n), p = u[0], a = u[1], A = new Arr$1(_byteLength$1(n, p, a)), b = 0, F = a > 0 ? p - 4 : p, le;
  for (le = 0; le < F; le += 4)
    c = revLookup$1[n.charCodeAt(le)] << 18 | revLookup$1[n.charCodeAt(le + 1)] << 12 | revLookup$1[n.charCodeAt(le + 2)] << 6 | revLookup$1[n.charCodeAt(le + 3)], A[b++] = c >> 16 & 255, A[b++] = c >> 8 & 255, A[b++] = c & 255;
  return a === 2 && (c = revLookup$1[n.charCodeAt(le)] << 2 | revLookup$1[n.charCodeAt(le + 1)] >> 4, A[b++] = c & 255), a === 1 && (c = revLookup$1[n.charCodeAt(le)] << 10 | revLookup$1[n.charCodeAt(le + 1)] << 4 | revLookup$1[n.charCodeAt(le + 2)] >> 2, A[b++] = c >> 8 & 255, A[b++] = c & 255), A;
}
function tripletToBase64$1(n) {
  return lookup$1[n >> 18 & 63] + lookup$1[n >> 12 & 63] + lookup$1[n >> 6 & 63] + lookup$1[n & 63];
}
function encodeChunk$1(n, c, u) {
  for (var p, a = [], A = c; A < u; A += 3)
    p = (n[A] << 16 & 16711680) + (n[A + 1] << 8 & 65280) + (n[A + 2] & 255), a.push(tripletToBase64$1(p));
  return a.join("");
}
function fromByteArray$1(n) {
  for (var c, u = n.length, p = u % 3, a = [], A = 16383, b = 0, F = u - p; b < F; b += A)
    a.push(encodeChunk$1(n, b, b + A > F ? F : b + A));
  return p === 1 ? (c = n[u - 1], a.push(
    lookup$1[c >> 2] + lookup$1[c << 4 & 63] + "=="
  )) : p === 2 && (c = (n[u - 2] << 8) + n[u - 1], a.push(
    lookup$1[c >> 10] + lookup$1[c >> 4 & 63] + lookup$1[c << 2 & 63] + "="
  )), a.join("");
}
var ieee754 = {};
ieee754.read = function(n, c, u, p, a) {
  var A, b, F = a * 8 - p - 1, le = (1 << F) - 1, L = le >> 1, pe = -7, $ = u ? a - 1 : 0, Ee = u ? -1 : 1, be = n[c + $];
  for ($ += Ee, A = be & (1 << -pe) - 1, be >>= -pe, pe += F; pe > 0; A = A * 256 + n[c + $], $ += Ee, pe -= 8)
    ;
  for (b = A & (1 << -pe) - 1, A >>= -pe, pe += p; pe > 0; b = b * 256 + n[c + $], $ += Ee, pe -= 8)
    ;
  if (A === 0)
    A = 1 - L;
  else {
    if (A === le)
      return b ? NaN : (be ? -1 : 1) * (1 / 0);
    b = b + Math.pow(2, p), A = A - L;
  }
  return (be ? -1 : 1) * b * Math.pow(2, A - p);
};
ieee754.write = function(n, c, u, p, a, A) {
  var b, F, le, L = A * 8 - a - 1, pe = (1 << L) - 1, $ = pe >> 1, Ee = a === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, be = p ? 0 : A - 1, He = p ? 1 : -1, Pe = c < 0 || c === 0 && 1 / c < 0 ? 1 : 0;
  for (c = Math.abs(c), isNaN(c) || c === 1 / 0 ? (F = isNaN(c) ? 1 : 0, b = pe) : (b = Math.floor(Math.log(c) / Math.LN2), c * (le = Math.pow(2, -b)) < 1 && (b--, le *= 2), b + $ >= 1 ? c += Ee / le : c += Ee * Math.pow(2, 1 - $), c * le >= 2 && (b++, le /= 2), b + $ >= pe ? (F = 0, b = pe) : b + $ >= 1 ? (F = (c * le - 1) * Math.pow(2, a), b = b + $) : (F = c * Math.pow(2, $ - 1) * Math.pow(2, a), b = 0)); a >= 8; n[u + be] = F & 255, be += He, F /= 256, a -= 8)
    ;
  for (b = b << a | F, L += a; L > 0; n[u + be] = b & 255, be += He, b /= 256, L -= 8)
    ;
  n[u + be - He] |= Pe * 128;
};
(function(n) {
  const c = base64Js$1, u = ieee754, p = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  n.Buffer = pe, n.SlowBuffer = xr, n.INSPECT_MAX_BYTES = 50;
  const a = 2147483647;
  n.kMaxLength = a;
  const { Uint8Array: A, ArrayBuffer: b, SharedArrayBuffer: F } = globalThis;
  pe.TYPED_ARRAY_SUPPORT = le(), !pe.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
    "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
  );
  function le() {
    try {
      const Hi = new A(1), di = { foo: function() {
        return 42;
      } };
      return Object.setPrototypeOf(di, A.prototype), Object.setPrototypeOf(Hi, di), Hi.foo() === 42;
    } catch {
      return !1;
    }
  }
  Object.defineProperty(pe.prototype, "parent", {
    enumerable: !0,
    get: function() {
      if (pe.isBuffer(this))
        return this.buffer;
    }
  }), Object.defineProperty(pe.prototype, "offset", {
    enumerable: !0,
    get: function() {
      if (pe.isBuffer(this))
        return this.byteOffset;
    }
  });
  function L(Hi) {
    if (Hi > a)
      throw new RangeError('The value "' + Hi + '" is invalid for option "size"');
    const di = new A(Hi);
    return Object.setPrototypeOf(di, pe.prototype), di;
  }
  function pe(Hi, di, Ui) {
    if (typeof Hi == "number") {
      if (typeof di == "string")
        throw new TypeError(
          'The "string" argument must be of type string. Received type number'
        );
      return He(Hi);
    }
    return $(Hi, di, Ui);
  }
  pe.poolSize = 8192;
  function $(Hi, di, Ui) {
    if (typeof Hi == "string")
      return Pe(Hi, di);
    if (b.isView(Hi))
      return ir(Hi);
    if (Hi == null)
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof Hi
      );
    if (Gn(Hi, b) || Hi && Gn(Hi.buffer, b) || typeof F < "u" && (Gn(Hi, F) || Hi && Gn(Hi.buffer, F)))
      return or(Hi, di, Ui);
    if (typeof Hi == "number")
      throw new TypeError(
        'The "value" argument must not be of type number. Received type number'
      );
    const ln = Hi.valueOf && Hi.valueOf();
    if (ln != null && ln !== Hi)
      return pe.from(ln, di, Ui);
    const Un = lr(Hi);
    if (Un) return Un;
    if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof Hi[Symbol.toPrimitive] == "function")
      return pe.from(Hi[Symbol.toPrimitive]("string"), di, Ui);
    throw new TypeError(
      "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof Hi
    );
  }
  pe.from = function(Hi, di, Ui) {
    return $(Hi, di, Ui);
  }, Object.setPrototypeOf(pe.prototype, A.prototype), Object.setPrototypeOf(pe, A);
  function Ee(Hi) {
    if (typeof Hi != "number")
      throw new TypeError('"size" argument must be of type number');
    if (Hi < 0)
      throw new RangeError('The value "' + Hi + '" is invalid for option "size"');
  }
  function be(Hi, di, Ui) {
    return Ee(Hi), Hi <= 0 ? L(Hi) : di !== void 0 ? typeof Ui == "string" ? L(Hi).fill(di, Ui) : L(Hi).fill(di) : L(Hi);
  }
  pe.alloc = function(Hi, di, Ui) {
    return be(Hi, di, Ui);
  };
  function He(Hi) {
    return Ee(Hi), L(Hi < 0 ? 0 : Ir(Hi) | 0);
  }
  pe.allocUnsafe = function(Hi) {
    return He(Hi);
  }, pe.allocUnsafeSlow = function(Hi) {
    return He(Hi);
  };
  function Pe(Hi, di) {
    if ((typeof di != "string" || di === "") && (di = "utf8"), !pe.isEncoding(di))
      throw new TypeError("Unknown encoding: " + di);
    const Ui = kr(Hi, di) | 0;
    let ln = L(Ui);
    const Un = ln.write(Hi, di);
    return Un !== Ui && (ln = ln.slice(0, Un)), ln;
  }
  function nr(Hi) {
    const di = Hi.length < 0 ? 0 : Ir(Hi.length) | 0, Ui = L(di);
    for (let ln = 0; ln < di; ln += 1)
      Ui[ln] = Hi[ln] & 255;
    return Ui;
  }
  function ir(Hi) {
    if (Gn(Hi, A)) {
      const di = new A(Hi);
      return or(di.buffer, di.byteOffset, di.byteLength);
    }
    return nr(Hi);
  }
  function or(Hi, di, Ui) {
    if (di < 0 || Hi.byteLength < di)
      throw new RangeError('"offset" is outside of buffer bounds');
    if (Hi.byteLength < di + (Ui || 0))
      throw new RangeError('"length" is outside of buffer bounds');
    let ln;
    return di === void 0 && Ui === void 0 ? ln = new A(Hi) : Ui === void 0 ? ln = new A(Hi, di) : ln = new A(Hi, di, Ui), Object.setPrototypeOf(ln, pe.prototype), ln;
  }
  function lr(Hi) {
    if (pe.isBuffer(Hi)) {
      const di = Ir(Hi.length) | 0, Ui = L(di);
      return Ui.length === 0 || Hi.copy(Ui, 0, 0, di), Ui;
    }
    if (Hi.length !== void 0)
      return typeof Hi.length != "number" || pn(Hi.length) ? L(0) : nr(Hi);
    if (Hi.type === "Buffer" && Array.isArray(Hi.data))
      return nr(Hi.data);
  }
  function Ir(Hi) {
    if (Hi >= a)
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + a.toString(16) + " bytes");
    return Hi | 0;
  }
  function xr(Hi) {
    return +Hi != Hi && (Hi = 0), pe.alloc(+Hi);
  }
  pe.isBuffer = function(di) {
    return di != null && di._isBuffer === !0 && di !== pe.prototype;
  }, pe.compare = function(di, Ui) {
    if (Gn(di, A) && (di = pe.from(di, di.offset, di.byteLength)), Gn(Ui, A) && (Ui = pe.from(Ui, Ui.offset, Ui.byteLength)), !pe.isBuffer(di) || !pe.isBuffer(Ui))
      throw new TypeError(
        'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
      );
    if (di === Ui) return 0;
    let ln = di.length, Un = Ui.length;
    for (let Bo = 0, co = Math.min(ln, Un); Bo < co; ++Bo)
      if (di[Bo] !== Ui[Bo]) {
        ln = di[Bo], Un = Ui[Bo];
        break;
      }
    return ln < Un ? -1 : Un < ln ? 1 : 0;
  }, pe.isEncoding = function(di) {
    switch (String(di).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, pe.concat = function(di, Ui) {
    if (!Array.isArray(di))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (di.length === 0)
      return pe.alloc(0);
    let ln;
    if (Ui === void 0)
      for (Ui = 0, ln = 0; ln < di.length; ++ln)
        Ui += di[ln].length;
    const Un = pe.allocUnsafe(Ui);
    let Bo = 0;
    for (ln = 0; ln < di.length; ++ln) {
      let co = di[ln];
      if (Gn(co, A))
        Bo + co.length > Un.length ? (pe.isBuffer(co) || (co = pe.from(co)), co.copy(Un, Bo)) : A.prototype.set.call(
          Un,
          co,
          Bo
        );
      else if (pe.isBuffer(co))
        co.copy(Un, Bo);
      else
        throw new TypeError('"list" argument must be an Array of Buffers');
      Bo += co.length;
    }
    return Un;
  };
  function kr(Hi, di) {
    if (pe.isBuffer(Hi))
      return Hi.length;
    if (b.isView(Hi) || Gn(Hi, b))
      return Hi.byteLength;
    if (typeof Hi != "string")
      throw new TypeError(
        'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof Hi
      );
    const Ui = Hi.length, ln = arguments.length > 2 && arguments[2] === !0;
    if (!ln && Ui === 0) return 0;
    let Un = !1;
    for (; ; )
      switch (di) {
        case "ascii":
        case "latin1":
        case "binary":
          return Ui;
        case "utf8":
        case "utf-8":
          return _n(Hi).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return Ui * 2;
        case "hex":
          return Ui >>> 1;
        case "base64":
          return Do(Hi).length;
        default:
          if (Un)
            return ln ? -1 : _n(Hi).length;
          di = ("" + di).toLowerCase(), Un = !0;
      }
  }
  pe.byteLength = kr;
  function Ce(Hi, di, Ui) {
    let ln = !1;
    if ((di === void 0 || di < 0) && (di = 0), di > this.length || ((Ui === void 0 || Ui > this.length) && (Ui = this.length), Ui <= 0) || (Ui >>>= 0, di >>>= 0, Ui <= di))
      return "";
    for (Hi || (Hi = "utf8"); ; )
      switch (Hi) {
        case "hex":
          return Hr(this, di, Ui);
        case "utf8":
        case "utf-8":
          return _r(this, di, Ui);
        case "ascii":
          return Te(this, di, Ui);
        case "latin1":
        case "binary":
          return Cr(this, di, Ui);
        case "base64":
          return yr(this, di, Ui);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return si(this, di, Ui);
        default:
          if (ln) throw new TypeError("Unknown encoding: " + Hi);
          Hi = (Hi + "").toLowerCase(), ln = !0;
      }
  }
  pe.prototype._isBuffer = !0;
  function tr(Hi, di, Ui) {
    const ln = Hi[di];
    Hi[di] = Hi[Ui], Hi[Ui] = ln;
  }
  pe.prototype.swap16 = function() {
    const di = this.length;
    if (di % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (let Ui = 0; Ui < di; Ui += 2)
      tr(this, Ui, Ui + 1);
    return this;
  }, pe.prototype.swap32 = function() {
    const di = this.length;
    if (di % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (let Ui = 0; Ui < di; Ui += 4)
      tr(this, Ui, Ui + 3), tr(this, Ui + 1, Ui + 2);
    return this;
  }, pe.prototype.swap64 = function() {
    const di = this.length;
    if (di % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (let Ui = 0; Ui < di; Ui += 8)
      tr(this, Ui, Ui + 7), tr(this, Ui + 1, Ui + 6), tr(this, Ui + 2, Ui + 5), tr(this, Ui + 3, Ui + 4);
    return this;
  }, pe.prototype.toString = function() {
    const di = this.length;
    return di === 0 ? "" : arguments.length === 0 ? _r(this, 0, di) : Ce.apply(this, arguments);
  }, pe.prototype.toLocaleString = pe.prototype.toString, pe.prototype.equals = function(di) {
    if (!pe.isBuffer(di)) throw new TypeError("Argument must be a Buffer");
    return this === di ? !0 : pe.compare(this, di) === 0;
  }, pe.prototype.inspect = function() {
    let di = "";
    const Ui = n.INSPECT_MAX_BYTES;
    return di = this.toString("hex", 0, Ui).replace(/(.{2})/g, "$1 ").trim(), this.length > Ui && (di += " ... "), "<Buffer " + di + ">";
  }, p && (pe.prototype[p] = pe.prototype.inspect), pe.prototype.compare = function(di, Ui, ln, Un, Bo) {
    if (Gn(di, A) && (di = pe.from(di, di.offset, di.byteLength)), !pe.isBuffer(di))
      throw new TypeError(
        'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof di
      );
    if (Ui === void 0 && (Ui = 0), ln === void 0 && (ln = di ? di.length : 0), Un === void 0 && (Un = 0), Bo === void 0 && (Bo = this.length), Ui < 0 || ln > di.length || Un < 0 || Bo > this.length)
      throw new RangeError("out of range index");
    if (Un >= Bo && Ui >= ln)
      return 0;
    if (Un >= Bo)
      return -1;
    if (Ui >= ln)
      return 1;
    if (Ui >>>= 0, ln >>>= 0, Un >>>= 0, Bo >>>= 0, this === di) return 0;
    let co = Bo - Un, To = ln - Ui;
    const xs = Math.min(co, To), Fo = this.slice(Un, Bo), Zo = di.slice(Ui, ln);
    for (let $s = 0; $s < xs; ++$s)
      if (Fo[$s] !== Zo[$s]) {
        co = Fo[$s], To = Zo[$s];
        break;
      }
    return co < To ? -1 : To < co ? 1 : 0;
  };
  function Fe(Hi, di, Ui, ln, Un) {
    if (Hi.length === 0) return -1;
    if (typeof Ui == "string" ? (ln = Ui, Ui = 0) : Ui > 2147483647 ? Ui = 2147483647 : Ui < -2147483648 && (Ui = -2147483648), Ui = +Ui, pn(Ui) && (Ui = Un ? 0 : Hi.length - 1), Ui < 0 && (Ui = Hi.length + Ui), Ui >= Hi.length) {
      if (Un) return -1;
      Ui = Hi.length - 1;
    } else if (Ui < 0)
      if (Un) Ui = 0;
      else return -1;
    if (typeof di == "string" && (di = pe.from(di, ln)), pe.isBuffer(di))
      return di.length === 0 ? -1 : Sr(Hi, di, Ui, ln, Un);
    if (typeof di == "number")
      return di = di & 255, typeof A.prototype.indexOf == "function" ? Un ? A.prototype.indexOf.call(Hi, di, Ui) : A.prototype.lastIndexOf.call(Hi, di, Ui) : Sr(Hi, [di], Ui, ln, Un);
    throw new TypeError("val must be string, number or Buffer");
  }
  function Sr(Hi, di, Ui, ln, Un) {
    let Bo = 1, co = Hi.length, To = di.length;
    if (ln !== void 0 && (ln = String(ln).toLowerCase(), ln === "ucs2" || ln === "ucs-2" || ln === "utf16le" || ln === "utf-16le")) {
      if (Hi.length < 2 || di.length < 2)
        return -1;
      Bo = 2, co /= 2, To /= 2, Ui /= 2;
    }
    function xs(Zo, $s) {
      return Bo === 1 ? Zo[$s] : Zo.readUInt16BE($s * Bo);
    }
    let Fo;
    if (Un) {
      let Zo = -1;
      for (Fo = Ui; Fo < co; Fo++)
        if (xs(Hi, Fo) === xs(di, Zo === -1 ? 0 : Fo - Zo)) {
          if (Zo === -1 && (Zo = Fo), Fo - Zo + 1 === To) return Zo * Bo;
        } else
          Zo !== -1 && (Fo -= Fo - Zo), Zo = -1;
    } else
      for (Ui + To > co && (Ui = co - To), Fo = Ui; Fo >= 0; Fo--) {
        let Zo = !0;
        for (let $s = 0; $s < To; $s++)
          if (xs(Hi, Fo + $s) !== xs(di, $s)) {
            Zo = !1;
            break;
          }
        if (Zo) return Fo;
      }
    return -1;
  }
  pe.prototype.includes = function(di, Ui, ln) {
    return this.indexOf(di, Ui, ln) !== -1;
  }, pe.prototype.indexOf = function(di, Ui, ln) {
    return Fe(this, di, Ui, ln, !0);
  }, pe.prototype.lastIndexOf = function(di, Ui, ln) {
    return Fe(this, di, Ui, ln, !1);
  };
  function er(Hi, di, Ui, ln) {
    Ui = Number(Ui) || 0;
    const Un = Hi.length - Ui;
    ln ? (ln = Number(ln), ln > Un && (ln = Un)) : ln = Un;
    const Bo = di.length;
    ln > Bo / 2 && (ln = Bo / 2);
    let co;
    for (co = 0; co < ln; ++co) {
      const To = parseInt(di.substr(co * 2, 2), 16);
      if (pn(To)) return co;
      Hi[Ui + co] = To;
    }
    return co;
  }
  function Ie(Hi, di, Ui, ln) {
    return gn(_n(di, Hi.length - Ui), Hi, Ui, ln);
  }
  function xe(Hi, di, Ui, ln) {
    return gn(On(di), Hi, Ui, ln);
  }
  function rr(Hi, di, Ui, ln) {
    return gn(Do(di), Hi, Ui, ln);
  }
  function ar(Hi, di, Ui, ln) {
    return gn(so(di, Hi.length - Ui), Hi, Ui, ln);
  }
  pe.prototype.write = function(di, Ui, ln, Un) {
    if (Ui === void 0)
      Un = "utf8", ln = this.length, Ui = 0;
    else if (ln === void 0 && typeof Ui == "string")
      Un = Ui, ln = this.length, Ui = 0;
    else if (isFinite(Ui))
      Ui = Ui >>> 0, isFinite(ln) ? (ln = ln >>> 0, Un === void 0 && (Un = "utf8")) : (Un = ln, ln = void 0);
    else
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    const Bo = this.length - Ui;
    if ((ln === void 0 || ln > Bo) && (ln = Bo), di.length > 0 && (ln < 0 || Ui < 0) || Ui > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    Un || (Un = "utf8");
    let co = !1;
    for (; ; )
      switch (Un) {
        case "hex":
          return er(this, di, Ui, ln);
        case "utf8":
        case "utf-8":
          return Ie(this, di, Ui, ln);
        case "ascii":
        case "latin1":
        case "binary":
          return xe(this, di, Ui, ln);
        case "base64":
          return rr(this, di, Ui, ln);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return ar(this, di, Ui, ln);
        default:
          if (co) throw new TypeError("Unknown encoding: " + Un);
          Un = ("" + Un).toLowerCase(), co = !0;
      }
  }, pe.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function yr(Hi, di, Ui) {
    return di === 0 && Ui === Hi.length ? c.fromByteArray(Hi) : c.fromByteArray(Hi.slice(di, Ui));
  }
  function _r(Hi, di, Ui) {
    Ui = Math.min(Hi.length, Ui);
    const ln = [];
    let Un = di;
    for (; Un < Ui; ) {
      const Bo = Hi[Un];
      let co = null, To = Bo > 239 ? 4 : Bo > 223 ? 3 : Bo > 191 ? 2 : 1;
      if (Un + To <= Ui) {
        let xs, Fo, Zo, $s;
        switch (To) {
          case 1:
            Bo < 128 && (co = Bo);
            break;
          case 2:
            xs = Hi[Un + 1], (xs & 192) === 128 && ($s = (Bo & 31) << 6 | xs & 63, $s > 127 && (co = $s));
            break;
          case 3:
            xs = Hi[Un + 1], Fo = Hi[Un + 2], (xs & 192) === 128 && (Fo & 192) === 128 && ($s = (Bo & 15) << 12 | (xs & 63) << 6 | Fo & 63, $s > 2047 && ($s < 55296 || $s > 57343) && (co = $s));
            break;
          case 4:
            xs = Hi[Un + 1], Fo = Hi[Un + 2], Zo = Hi[Un + 3], (xs & 192) === 128 && (Fo & 192) === 128 && (Zo & 192) === 128 && ($s = (Bo & 15) << 18 | (xs & 63) << 12 | (Fo & 63) << 6 | Zo & 63, $s > 65535 && $s < 1114112 && (co = $s));
        }
      }
      co === null ? (co = 65533, To = 1) : co > 65535 && (co -= 65536, ln.push(co >>> 10 & 1023 | 55296), co = 56320 | co & 1023), ln.push(co), Un += To;
    }
    return vr(ln);
  }
  const Or = 4096;
  function vr(Hi) {
    const di = Hi.length;
    if (di <= Or)
      return String.fromCharCode.apply(String, Hi);
    let Ui = "", ln = 0;
    for (; ln < di; )
      Ui += String.fromCharCode.apply(
        String,
        Hi.slice(ln, ln += Or)
      );
    return Ui;
  }
  function Te(Hi, di, Ui) {
    let ln = "";
    Ui = Math.min(Hi.length, Ui);
    for (let Un = di; Un < Ui; ++Un)
      ln += String.fromCharCode(Hi[Un] & 127);
    return ln;
  }
  function Cr(Hi, di, Ui) {
    let ln = "";
    Ui = Math.min(Hi.length, Ui);
    for (let Un = di; Un < Ui; ++Un)
      ln += String.fromCharCode(Hi[Un]);
    return ln;
  }
  function Hr(Hi, di, Ui) {
    const ln = Hi.length;
    (!di || di < 0) && (di = 0), (!Ui || Ui < 0 || Ui > ln) && (Ui = ln);
    let Un = "";
    for (let Bo = di; Bo < Ui; ++Bo)
      Un += hn[Hi[Bo]];
    return Un;
  }
  function si(Hi, di, Ui) {
    const ln = Hi.slice(di, Ui);
    let Un = "";
    for (let Bo = 0; Bo < ln.length - 1; Bo += 2)
      Un += String.fromCharCode(ln[Bo] + ln[Bo + 1] * 256);
    return Un;
  }
  pe.prototype.slice = function(di, Ui) {
    const ln = this.length;
    di = ~~di, Ui = Ui === void 0 ? ln : ~~Ui, di < 0 ? (di += ln, di < 0 && (di = 0)) : di > ln && (di = ln), Ui < 0 ? (Ui += ln, Ui < 0 && (Ui = 0)) : Ui > ln && (Ui = ln), Ui < di && (Ui = di);
    const Un = this.subarray(di, Ui);
    return Object.setPrototypeOf(Un, pe.prototype), Un;
  };
  function ui(Hi, di, Ui) {
    if (Hi % 1 !== 0 || Hi < 0) throw new RangeError("offset is not uint");
    if (Hi + di > Ui) throw new RangeError("Trying to access beyond buffer length");
  }
  pe.prototype.readUintLE = pe.prototype.readUIntLE = function(di, Ui, ln) {
    di = di >>> 0, Ui = Ui >>> 0, ln || ui(di, Ui, this.length);
    let Un = this[di], Bo = 1, co = 0;
    for (; ++co < Ui && (Bo *= 256); )
      Un += this[di + co] * Bo;
    return Un;
  }, pe.prototype.readUintBE = pe.prototype.readUIntBE = function(di, Ui, ln) {
    di = di >>> 0, Ui = Ui >>> 0, ln || ui(di, Ui, this.length);
    let Un = this[di + --Ui], Bo = 1;
    for (; Ui > 0 && (Bo *= 256); )
      Un += this[di + --Ui] * Bo;
    return Un;
  }, pe.prototype.readUint8 = pe.prototype.readUInt8 = function(di, Ui) {
    return di = di >>> 0, Ui || ui(di, 1, this.length), this[di];
  }, pe.prototype.readUint16LE = pe.prototype.readUInt16LE = function(di, Ui) {
    return di = di >>> 0, Ui || ui(di, 2, this.length), this[di] | this[di + 1] << 8;
  }, pe.prototype.readUint16BE = pe.prototype.readUInt16BE = function(di, Ui) {
    return di = di >>> 0, Ui || ui(di, 2, this.length), this[di] << 8 | this[di + 1];
  }, pe.prototype.readUint32LE = pe.prototype.readUInt32LE = function(di, Ui) {
    return di = di >>> 0, Ui || ui(di, 4, this.length), (this[di] | this[di + 1] << 8 | this[di + 2] << 16) + this[di + 3] * 16777216;
  }, pe.prototype.readUint32BE = pe.prototype.readUInt32BE = function(di, Ui) {
    return di = di >>> 0, Ui || ui(di, 4, this.length), this[di] * 16777216 + (this[di + 1] << 16 | this[di + 2] << 8 | this[di + 3]);
  }, pe.prototype.readBigUInt64LE = Rn(function(di) {
    di = di >>> 0, ri(di, "offset");
    const Ui = this[di], ln = this[di + 7];
    (Ui === void 0 || ln === void 0) && _i(di, this.length - 8);
    const Un = Ui + this[++di] * 2 ** 8 + this[++di] * 2 ** 16 + this[++di] * 2 ** 24, Bo = this[++di] + this[++di] * 2 ** 8 + this[++di] * 2 ** 16 + ln * 2 ** 24;
    return BigInt(Un) + (BigInt(Bo) << BigInt(32));
  }), pe.prototype.readBigUInt64BE = Rn(function(di) {
    di = di >>> 0, ri(di, "offset");
    const Ui = this[di], ln = this[di + 7];
    (Ui === void 0 || ln === void 0) && _i(di, this.length - 8);
    const Un = Ui * 2 ** 24 + this[++di] * 2 ** 16 + this[++di] * 2 ** 8 + this[++di], Bo = this[++di] * 2 ** 24 + this[++di] * 2 ** 16 + this[++di] * 2 ** 8 + ln;
    return (BigInt(Un) << BigInt(32)) + BigInt(Bo);
  }), pe.prototype.readIntLE = function(di, Ui, ln) {
    di = di >>> 0, Ui = Ui >>> 0, ln || ui(di, Ui, this.length);
    let Un = this[di], Bo = 1, co = 0;
    for (; ++co < Ui && (Bo *= 256); )
      Un += this[di + co] * Bo;
    return Bo *= 128, Un >= Bo && (Un -= Math.pow(2, 8 * Ui)), Un;
  }, pe.prototype.readIntBE = function(di, Ui, ln) {
    di = di >>> 0, Ui = Ui >>> 0, ln || ui(di, Ui, this.length);
    let Un = Ui, Bo = 1, co = this[di + --Un];
    for (; Un > 0 && (Bo *= 256); )
      co += this[di + --Un] * Bo;
    return Bo *= 128, co >= Bo && (co -= Math.pow(2, 8 * Ui)), co;
  }, pe.prototype.readInt8 = function(di, Ui) {
    return di = di >>> 0, Ui || ui(di, 1, this.length), this[di] & 128 ? (255 - this[di] + 1) * -1 : this[di];
  }, pe.prototype.readInt16LE = function(di, Ui) {
    di = di >>> 0, Ui || ui(di, 2, this.length);
    const ln = this[di] | this[di + 1] << 8;
    return ln & 32768 ? ln | 4294901760 : ln;
  }, pe.prototype.readInt16BE = function(di, Ui) {
    di = di >>> 0, Ui || ui(di, 2, this.length);
    const ln = this[di + 1] | this[di] << 8;
    return ln & 32768 ? ln | 4294901760 : ln;
  }, pe.prototype.readInt32LE = function(di, Ui) {
    return di = di >>> 0, Ui || ui(di, 4, this.length), this[di] | this[di + 1] << 8 | this[di + 2] << 16 | this[di + 3] << 24;
  }, pe.prototype.readInt32BE = function(di, Ui) {
    return di = di >>> 0, Ui || ui(di, 4, this.length), this[di] << 24 | this[di + 1] << 16 | this[di + 2] << 8 | this[di + 3];
  }, pe.prototype.readBigInt64LE = Rn(function(di) {
    di = di >>> 0, ri(di, "offset");
    const Ui = this[di], ln = this[di + 7];
    (Ui === void 0 || ln === void 0) && _i(di, this.length - 8);
    const Un = this[di + 4] + this[di + 5] * 2 ** 8 + this[di + 6] * 2 ** 16 + (ln << 24);
    return (BigInt(Un) << BigInt(32)) + BigInt(Ui + this[++di] * 2 ** 8 + this[++di] * 2 ** 16 + this[++di] * 2 ** 24);
  }), pe.prototype.readBigInt64BE = Rn(function(di) {
    di = di >>> 0, ri(di, "offset");
    const Ui = this[di], ln = this[di + 7];
    (Ui === void 0 || ln === void 0) && _i(di, this.length - 8);
    const Un = (Ui << 24) + // Overflow
    this[++di] * 2 ** 16 + this[++di] * 2 ** 8 + this[++di];
    return (BigInt(Un) << BigInt(32)) + BigInt(this[++di] * 2 ** 24 + this[++di] * 2 ** 16 + this[++di] * 2 ** 8 + ln);
  }), pe.prototype.readFloatLE = function(di, Ui) {
    return di = di >>> 0, Ui || ui(di, 4, this.length), u.read(this, di, !0, 23, 4);
  }, pe.prototype.readFloatBE = function(di, Ui) {
    return di = di >>> 0, Ui || ui(di, 4, this.length), u.read(this, di, !1, 23, 4);
  }, pe.prototype.readDoubleLE = function(di, Ui) {
    return di = di >>> 0, Ui || ui(di, 8, this.length), u.read(this, di, !0, 52, 8);
  }, pe.prototype.readDoubleBE = function(di, Ui) {
    return di = di >>> 0, Ui || ui(di, 8, this.length), u.read(this, di, !1, 52, 8);
  };
  function Li(Hi, di, Ui, ln, Un, Bo) {
    if (!pe.isBuffer(Hi)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (di > Un || di < Bo) throw new RangeError('"value" argument is out of bounds');
    if (Ui + ln > Hi.length) throw new RangeError("Index out of range");
  }
  pe.prototype.writeUintLE = pe.prototype.writeUIntLE = function(di, Ui, ln, Un) {
    if (di = +di, Ui = Ui >>> 0, ln = ln >>> 0, !Un) {
      const To = Math.pow(2, 8 * ln) - 1;
      Li(this, di, Ui, ln, To, 0);
    }
    let Bo = 1, co = 0;
    for (this[Ui] = di & 255; ++co < ln && (Bo *= 256); )
      this[Ui + co] = di / Bo & 255;
    return Ui + ln;
  }, pe.prototype.writeUintBE = pe.prototype.writeUIntBE = function(di, Ui, ln, Un) {
    if (di = +di, Ui = Ui >>> 0, ln = ln >>> 0, !Un) {
      const To = Math.pow(2, 8 * ln) - 1;
      Li(this, di, Ui, ln, To, 0);
    }
    let Bo = ln - 1, co = 1;
    for (this[Ui + Bo] = di & 255; --Bo >= 0 && (co *= 256); )
      this[Ui + Bo] = di / co & 255;
    return Ui + ln;
  }, pe.prototype.writeUint8 = pe.prototype.writeUInt8 = function(di, Ui, ln) {
    return di = +di, Ui = Ui >>> 0, ln || Li(this, di, Ui, 1, 255, 0), this[Ui] = di & 255, Ui + 1;
  }, pe.prototype.writeUint16LE = pe.prototype.writeUInt16LE = function(di, Ui, ln) {
    return di = +di, Ui = Ui >>> 0, ln || Li(this, di, Ui, 2, 65535, 0), this[Ui] = di & 255, this[Ui + 1] = di >>> 8, Ui + 2;
  }, pe.prototype.writeUint16BE = pe.prototype.writeUInt16BE = function(di, Ui, ln) {
    return di = +di, Ui = Ui >>> 0, ln || Li(this, di, Ui, 2, 65535, 0), this[Ui] = di >>> 8, this[Ui + 1] = di & 255, Ui + 2;
  }, pe.prototype.writeUint32LE = pe.prototype.writeUInt32LE = function(di, Ui, ln) {
    return di = +di, Ui = Ui >>> 0, ln || Li(this, di, Ui, 4, 4294967295, 0), this[Ui + 3] = di >>> 24, this[Ui + 2] = di >>> 16, this[Ui + 1] = di >>> 8, this[Ui] = di & 255, Ui + 4;
  }, pe.prototype.writeUint32BE = pe.prototype.writeUInt32BE = function(di, Ui, ln) {
    return di = +di, Ui = Ui >>> 0, ln || Li(this, di, Ui, 4, 4294967295, 0), this[Ui] = di >>> 24, this[Ui + 1] = di >>> 16, this[Ui + 2] = di >>> 8, this[Ui + 3] = di & 255, Ui + 4;
  };
  function Qi(Hi, di, Ui, ln, Un) {
    Wr(di, ln, Un, Hi, Ui, 7);
    let Bo = Number(di & BigInt(4294967295));
    Hi[Ui++] = Bo, Bo = Bo >> 8, Hi[Ui++] = Bo, Bo = Bo >> 8, Hi[Ui++] = Bo, Bo = Bo >> 8, Hi[Ui++] = Bo;
    let co = Number(di >> BigInt(32) & BigInt(4294967295));
    return Hi[Ui++] = co, co = co >> 8, Hi[Ui++] = co, co = co >> 8, Hi[Ui++] = co, co = co >> 8, Hi[Ui++] = co, Ui;
  }
  function wi(Hi, di, Ui, ln, Un) {
    Wr(di, ln, Un, Hi, Ui, 7);
    let Bo = Number(di & BigInt(4294967295));
    Hi[Ui + 7] = Bo, Bo = Bo >> 8, Hi[Ui + 6] = Bo, Bo = Bo >> 8, Hi[Ui + 5] = Bo, Bo = Bo >> 8, Hi[Ui + 4] = Bo;
    let co = Number(di >> BigInt(32) & BigInt(4294967295));
    return Hi[Ui + 3] = co, co = co >> 8, Hi[Ui + 2] = co, co = co >> 8, Hi[Ui + 1] = co, co = co >> 8, Hi[Ui] = co, Ui + 8;
  }
  pe.prototype.writeBigUInt64LE = Rn(function(di, Ui = 0) {
    return Qi(this, di, Ui, BigInt(0), BigInt("0xffffffffffffffff"));
  }), pe.prototype.writeBigUInt64BE = Rn(function(di, Ui = 0) {
    return wi(this, di, Ui, BigInt(0), BigInt("0xffffffffffffffff"));
  }), pe.prototype.writeIntLE = function(di, Ui, ln, Un) {
    if (di = +di, Ui = Ui >>> 0, !Un) {
      const xs = Math.pow(2, 8 * ln - 1);
      Li(this, di, Ui, ln, xs - 1, -xs);
    }
    let Bo = 0, co = 1, To = 0;
    for (this[Ui] = di & 255; ++Bo < ln && (co *= 256); )
      di < 0 && To === 0 && this[Ui + Bo - 1] !== 0 && (To = 1), this[Ui + Bo] = (di / co >> 0) - To & 255;
    return Ui + ln;
  }, pe.prototype.writeIntBE = function(di, Ui, ln, Un) {
    if (di = +di, Ui = Ui >>> 0, !Un) {
      const xs = Math.pow(2, 8 * ln - 1);
      Li(this, di, Ui, ln, xs - 1, -xs);
    }
    let Bo = ln - 1, co = 1, To = 0;
    for (this[Ui + Bo] = di & 255; --Bo >= 0 && (co *= 256); )
      di < 0 && To === 0 && this[Ui + Bo + 1] !== 0 && (To = 1), this[Ui + Bo] = (di / co >> 0) - To & 255;
    return Ui + ln;
  }, pe.prototype.writeInt8 = function(di, Ui, ln) {
    return di = +di, Ui = Ui >>> 0, ln || Li(this, di, Ui, 1, 127, -128), di < 0 && (di = 255 + di + 1), this[Ui] = di & 255, Ui + 1;
  }, pe.prototype.writeInt16LE = function(di, Ui, ln) {
    return di = +di, Ui = Ui >>> 0, ln || Li(this, di, Ui, 2, 32767, -32768), this[Ui] = di & 255, this[Ui + 1] = di >>> 8, Ui + 2;
  }, pe.prototype.writeInt16BE = function(di, Ui, ln) {
    return di = +di, Ui = Ui >>> 0, ln || Li(this, di, Ui, 2, 32767, -32768), this[Ui] = di >>> 8, this[Ui + 1] = di & 255, Ui + 2;
  }, pe.prototype.writeInt32LE = function(di, Ui, ln) {
    return di = +di, Ui = Ui >>> 0, ln || Li(this, di, Ui, 4, 2147483647, -2147483648), this[Ui] = di & 255, this[Ui + 1] = di >>> 8, this[Ui + 2] = di >>> 16, this[Ui + 3] = di >>> 24, Ui + 4;
  }, pe.prototype.writeInt32BE = function(di, Ui, ln) {
    return di = +di, Ui = Ui >>> 0, ln || Li(this, di, Ui, 4, 2147483647, -2147483648), di < 0 && (di = 4294967295 + di + 1), this[Ui] = di >>> 24, this[Ui + 1] = di >>> 16, this[Ui + 2] = di >>> 8, this[Ui + 3] = di & 255, Ui + 4;
  }, pe.prototype.writeBigInt64LE = Rn(function(di, Ui = 0) {
    return Qi(this, di, Ui, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  }), pe.prototype.writeBigInt64BE = Rn(function(di, Ui = 0) {
    return wi(this, di, Ui, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  function Ji(Hi, di, Ui, ln, Un, Bo) {
    if (Ui + ln > Hi.length) throw new RangeError("Index out of range");
    if (Ui < 0) throw new RangeError("Index out of range");
  }
  function mn(Hi, di, Ui, ln, Un) {
    return di = +di, Ui = Ui >>> 0, Un || Ji(Hi, di, Ui, 4), u.write(Hi, di, Ui, ln, 23, 4), Ui + 4;
  }
  pe.prototype.writeFloatLE = function(di, Ui, ln) {
    return mn(this, di, Ui, !0, ln);
  }, pe.prototype.writeFloatBE = function(di, Ui, ln) {
    return mn(this, di, Ui, !1, ln);
  };
  function pi(Hi, di, Ui, ln, Un) {
    return di = +di, Ui = Ui >>> 0, Un || Ji(Hi, di, Ui, 8), u.write(Hi, di, Ui, ln, 52, 8), Ui + 8;
  }
  pe.prototype.writeDoubleLE = function(di, Ui, ln) {
    return pi(this, di, Ui, !0, ln);
  }, pe.prototype.writeDoubleBE = function(di, Ui, ln) {
    return pi(this, di, Ui, !1, ln);
  }, pe.prototype.copy = function(di, Ui, ln, Un) {
    if (!pe.isBuffer(di)) throw new TypeError("argument should be a Buffer");
    if (ln || (ln = 0), !Un && Un !== 0 && (Un = this.length), Ui >= di.length && (Ui = di.length), Ui || (Ui = 0), Un > 0 && Un < ln && (Un = ln), Un === ln || di.length === 0 || this.length === 0) return 0;
    if (Ui < 0)
      throw new RangeError("targetStart out of bounds");
    if (ln < 0 || ln >= this.length) throw new RangeError("Index out of range");
    if (Un < 0) throw new RangeError("sourceEnd out of bounds");
    Un > this.length && (Un = this.length), di.length - Ui < Un - ln && (Un = di.length - Ui + ln);
    const Bo = Un - ln;
    return this === di && typeof A.prototype.copyWithin == "function" ? this.copyWithin(Ui, ln, Un) : A.prototype.set.call(
      di,
      this.subarray(ln, Un),
      Ui
    ), Bo;
  }, pe.prototype.fill = function(di, Ui, ln, Un) {
    if (typeof di == "string") {
      if (typeof Ui == "string" ? (Un = Ui, Ui = 0, ln = this.length) : typeof ln == "string" && (Un = ln, ln = this.length), Un !== void 0 && typeof Un != "string")
        throw new TypeError("encoding must be a string");
      if (typeof Un == "string" && !pe.isEncoding(Un))
        throw new TypeError("Unknown encoding: " + Un);
      if (di.length === 1) {
        const co = di.charCodeAt(0);
        (Un === "utf8" && co < 128 || Un === "latin1") && (di = co);
      }
    } else typeof di == "number" ? di = di & 255 : typeof di == "boolean" && (di = Number(di));
    if (Ui < 0 || this.length < Ui || this.length < ln)
      throw new RangeError("Out of range index");
    if (ln <= Ui)
      return this;
    Ui = Ui >>> 0, ln = ln === void 0 ? this.length : ln >>> 0, di || (di = 0);
    let Bo;
    if (typeof di == "number")
      for (Bo = Ui; Bo < ln; ++Bo)
        this[Bo] = di;
    else {
      const co = pe.isBuffer(di) ? di : pe.from(di, Un), To = co.length;
      if (To === 0)
        throw new TypeError('The value "' + di + '" is invalid for argument "value"');
      for (Bo = 0; Bo < ln - Ui; ++Bo)
        this[Bo + Ui] = co[Bo % To];
    }
    return this;
  };
  const ei = {};
  function Vr(Hi, di, Ui) {
    ei[Hi] = class extends Ui {
      constructor() {
        super(), Object.defineProperty(this, "message", {
          value: di.apply(this, arguments),
          writable: !0,
          configurable: !0
        }), this.name = `${this.name} [${Hi}]`, this.stack, delete this.name;
      }
      get code() {
        return Hi;
      }
      set code(Un) {
        Object.defineProperty(this, "code", {
          configurable: !0,
          enumerable: !0,
          value: Un,
          writable: !0
        });
      }
      toString() {
        return `${this.name} [${Hi}]: ${this.message}`;
      }
    };
  }
  Vr(
    "ERR_BUFFER_OUT_OF_BOUNDS",
    function(Hi) {
      return Hi ? `${Hi} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
    },
    RangeError
  ), Vr(
    "ERR_INVALID_ARG_TYPE",
    function(Hi, di) {
      return `The "${Hi}" argument must be of type number. Received type ${typeof di}`;
    },
    TypeError
  ), Vr(
    "ERR_OUT_OF_RANGE",
    function(Hi, di, Ui) {
      let ln = `The value of "${Hi}" is out of range.`, Un = Ui;
      return Number.isInteger(Ui) && Math.abs(Ui) > 2 ** 32 ? Un = qr(String(Ui)) : typeof Ui == "bigint" && (Un = String(Ui), (Ui > BigInt(2) ** BigInt(32) || Ui < -(BigInt(2) ** BigInt(32))) && (Un = qr(Un)), Un += "n"), ln += ` It must be ${di}. Received ${Un}`, ln;
    },
    RangeError
  );
  function qr(Hi) {
    let di = "", Ui = Hi.length;
    const ln = Hi[0] === "-" ? 1 : 0;
    for (; Ui >= ln + 4; Ui -= 3)
      di = `_${Hi.slice(Ui - 3, Ui)}${di}`;
    return `${Hi.slice(0, Ui)}${di}`;
  }
  function Zi(Hi, di, Ui) {
    ri(di, "offset"), (Hi[di] === void 0 || Hi[di + Ui] === void 0) && _i(di, Hi.length - (Ui + 1));
  }
  function Wr(Hi, di, Ui, ln, Un, Bo) {
    if (Hi > Ui || Hi < di) {
      const co = typeof di == "bigint" ? "n" : "";
      let To;
      throw di === 0 || di === BigInt(0) ? To = `>= 0${co} and < 2${co} ** ${(Bo + 1) * 8}${co}` : To = `>= -(2${co} ** ${(Bo + 1) * 8 - 1}${co}) and < 2 ** ${(Bo + 1) * 8 - 1}${co}`, new ei.ERR_OUT_OF_RANGE("value", To, Hi);
    }
    Zi(ln, Un, Bo);
  }
  function ri(Hi, di) {
    if (typeof Hi != "number")
      throw new ei.ERR_INVALID_ARG_TYPE(di, "number", Hi);
  }
  function _i(Hi, di, Ui) {
    throw Math.floor(Hi) !== Hi ? (ri(Hi, Ui), new ei.ERR_OUT_OF_RANGE("offset", "an integer", Hi)) : di < 0 ? new ei.ERR_BUFFER_OUT_OF_BOUNDS() : new ei.ERR_OUT_OF_RANGE(
      "offset",
      `>= 0 and <= ${di}`,
      Hi
    );
  }
  const Er = /[^+/0-9A-Za-z-_]/g;
  function Di(Hi) {
    if (Hi = Hi.split("=")[0], Hi = Hi.trim().replace(Er, ""), Hi.length < 2) return "";
    for (; Hi.length % 4 !== 0; )
      Hi = Hi + "=";
    return Hi;
  }
  function _n(Hi, di) {
    di = di || 1 / 0;
    let Ui;
    const ln = Hi.length;
    let Un = null;
    const Bo = [];
    for (let co = 0; co < ln; ++co) {
      if (Ui = Hi.charCodeAt(co), Ui > 55295 && Ui < 57344) {
        if (!Un) {
          if (Ui > 56319) {
            (di -= 3) > -1 && Bo.push(239, 191, 189);
            continue;
          } else if (co + 1 === ln) {
            (di -= 3) > -1 && Bo.push(239, 191, 189);
            continue;
          }
          Un = Ui;
          continue;
        }
        if (Ui < 56320) {
          (di -= 3) > -1 && Bo.push(239, 191, 189), Un = Ui;
          continue;
        }
        Ui = (Un - 55296 << 10 | Ui - 56320) + 65536;
      } else Un && (di -= 3) > -1 && Bo.push(239, 191, 189);
      if (Un = null, Ui < 128) {
        if ((di -= 1) < 0) break;
        Bo.push(Ui);
      } else if (Ui < 2048) {
        if ((di -= 2) < 0) break;
        Bo.push(
          Ui >> 6 | 192,
          Ui & 63 | 128
        );
      } else if (Ui < 65536) {
        if ((di -= 3) < 0) break;
        Bo.push(
          Ui >> 12 | 224,
          Ui >> 6 & 63 | 128,
          Ui & 63 | 128
        );
      } else if (Ui < 1114112) {
        if ((di -= 4) < 0) break;
        Bo.push(
          Ui >> 18 | 240,
          Ui >> 12 & 63 | 128,
          Ui >> 6 & 63 | 128,
          Ui & 63 | 128
        );
      } else
        throw new Error("Invalid code point");
    }
    return Bo;
  }
  function On(Hi) {
    const di = [];
    for (let Ui = 0; Ui < Hi.length; ++Ui)
      di.push(Hi.charCodeAt(Ui) & 255);
    return di;
  }
  function so(Hi, di) {
    let Ui, ln, Un;
    const Bo = [];
    for (let co = 0; co < Hi.length && !((di -= 2) < 0); ++co)
      Ui = Hi.charCodeAt(co), ln = Ui >> 8, Un = Ui % 256, Bo.push(Un), Bo.push(ln);
    return Bo;
  }
  function Do(Hi) {
    return c.toByteArray(Di(Hi));
  }
  function gn(Hi, di, Ui, ln) {
    let Un;
    for (Un = 0; Un < ln && !(Un + Ui >= di.length || Un >= Hi.length); ++Un)
      di[Un + Ui] = Hi[Un];
    return Un;
  }
  function Gn(Hi, di) {
    return Hi instanceof di || Hi != null && Hi.constructor != null && Hi.constructor.name != null && Hi.constructor.name === di.name;
  }
  function pn(Hi) {
    return Hi !== Hi;
  }
  const hn = function() {
    const Hi = "0123456789abcdef", di = new Array(256);
    for (let Ui = 0; Ui < 16; ++Ui) {
      const ln = Ui * 16;
      for (let Un = 0; Un < 16; ++Un)
        di[ln + Un] = Hi[Ui] + Hi[Un];
    }
    return di;
  }();
  function Rn(Hi) {
    return typeof BigInt > "u" ? vo : Hi;
  }
  function vo() {
    throw new Error("BigInt not supported");
  }
})(buffer$3);
const Buffer$f = buffer$3.Buffer, Blob$1 = buffer$3.Blob, BlobOptions = buffer$3.BlobOptions, Buffer$1$1 = buffer$3.Buffer, File = buffer$3.File, FileOptions$1 = buffer$3.FileOptions, INSPECT_MAX_BYTES = buffer$3.INSPECT_MAX_BYTES, SlowBuffer = buffer$3.SlowBuffer, TranscodeEncoding = buffer$3.TranscodeEncoding, atob$3 = buffer$3.atob, btoa$2 = buffer$3.btoa, constants$8 = buffer$3.constants, isAscii = buffer$3.isAscii, isUtf8 = buffer$3.isUtf8, kMaxLength = buffer$3.kMaxLength, kStringMaxLength = buffer$3.kStringMaxLength, resolveObjectURL = buffer$3.resolveObjectURL, transcode = buffer$3.transcode, dist$z = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Blob: Blob$1,
  BlobOptions,
  Buffer: Buffer$1$1,
  File,
  FileOptions: FileOptions$1,
  INSPECT_MAX_BYTES,
  SlowBuffer,
  TranscodeEncoding,
  atob: atob$3,
  btoa: btoa$2,
  constants: constants$8,
  default: Buffer$f,
  isAscii,
  isUtf8,
  kMaxLength,
  kStringMaxLength,
  resolveObjectURL,
  transcode
}, Symbol.toStringTag, { value: "Module" }));
function getDefaultExportFromCjs$1(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var browser$c = { exports: {} }, process = browser$c.exports = {}, cachedSetTimeout, cachedClearTimeout;
function defaultSetTimout() {
  throw new Error("setTimeout has not been defined");
}
function defaultClearTimeout() {
  throw new Error("clearTimeout has not been defined");
}
(function() {
  try {
    typeof setTimeout == "function" ? cachedSetTimeout = setTimeout : cachedSetTimeout = defaultSetTimout;
  } catch {
    cachedSetTimeout = defaultSetTimout;
  }
  try {
    typeof clearTimeout == "function" ? cachedClearTimeout = clearTimeout : cachedClearTimeout = defaultClearTimeout;
  } catch {
    cachedClearTimeout = defaultClearTimeout;
  }
})();
function runTimeout(n) {
  if (cachedSetTimeout === setTimeout)
    return setTimeout(n, 0);
  if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout)
    return cachedSetTimeout = setTimeout, setTimeout(n, 0);
  try {
    return cachedSetTimeout(n, 0);
  } catch {
    try {
      return cachedSetTimeout.call(null, n, 0);
    } catch {
      return cachedSetTimeout.call(this, n, 0);
    }
  }
}
function runClearTimeout(n) {
  if (cachedClearTimeout === clearTimeout)
    return clearTimeout(n);
  if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout)
    return cachedClearTimeout = clearTimeout, clearTimeout(n);
  try {
    return cachedClearTimeout(n);
  } catch {
    try {
      return cachedClearTimeout.call(null, n);
    } catch {
      return cachedClearTimeout.call(this, n);
    }
  }
}
var queue = [], draining = !1, currentQueue, queueIndex = -1;
function cleanUpNextTick() {
  !draining || !currentQueue || (draining = !1, currentQueue.length ? queue = currentQueue.concat(queue) : queueIndex = -1, queue.length && drainQueue());
}
function drainQueue() {
  if (!draining) {
    var n = runTimeout(cleanUpNextTick);
    draining = !0;
    for (var c = queue.length; c; ) {
      for (currentQueue = queue, queue = []; ++queueIndex < c; )
        currentQueue && currentQueue[queueIndex].run();
      queueIndex = -1, c = queue.length;
    }
    currentQueue = null, draining = !1, runClearTimeout(n);
  }
}
process.nextTick = function(n) {
  var c = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var u = 1; u < arguments.length; u++)
      c[u - 1] = arguments[u];
  queue.push(new Item(n, c)), queue.length === 1 && !draining && runTimeout(drainQueue);
};
function Item(n, c) {
  this.fun = n, this.array = c;
}
Item.prototype.run = function() {
  this.fun.apply(null, this.array);
};
process.title = "browser";
process.browser = !0;
process.env = {};
process.argv = [];
process.version = "";
process.versions = {};
function noop$3() {
}
process.on = noop$3;
process.addListener = noop$3;
process.once = noop$3;
process.off = noop$3;
process.removeListener = noop$3;
process.removeAllListeners = noop$3;
process.emit = noop$3;
process.prependListener = noop$3;
process.prependOnceListener = noop$3;
process.listeners = function(n) {
  return [];
};
process.binding = function(n) {
  throw new Error("process.binding is not supported");
};
process.cwd = function() {
  return "/";
};
process.chdir = function(n) {
  throw new Error("process.chdir is not supported");
};
process.umask = function() {
  return 0;
};
var browserExports = browser$c.exports;
const process$1 = /* @__PURE__ */ getDefaultExportFromCjs$1(browserExports);
var commonjsGlobal = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function getDefaultExportFromCjs(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
function getAugmentedNamespace(n) {
  if (n.__esModule) return n;
  var c = n.default;
  if (typeof c == "function") {
    var u = function p() {
      return this instanceof p ? Reflect.construct(c, arguments, this.constructor) : c.apply(this, arguments);
    };
    u.prototype = c.prototype;
  } else u = {};
  return Object.defineProperty(u, "__esModule", { value: !0 }), Object.keys(n).forEach(function(p) {
    var a = Object.getOwnPropertyDescriptor(n, p);
    Object.defineProperty(u, p, a.get ? a : {
      enumerable: !0,
      get: function() {
        return n[p];
      }
    });
  }), u;
}
var src$j = {}, address$1 = {}, networks$3 = {};
Object.defineProperty(networks$3, "__esModule", { value: !0 });
networks$3.testnet = networks$3.regtest = networks$3.bitcoin = void 0;
networks$3.bitcoin = {
  messagePrefix: `Bitcoin Signed Message:
`,
  bech32: "bc",
  bip32: {
    public: 76067358,
    private: 76066276
  },
  pubKeyHash: 0,
  scriptHash: 5,
  wif: 128
};
networks$3.regtest = {
  messagePrefix: `Bitcoin Signed Message:
`,
  bech32: "bcrt",
  bip32: {
    public: 70617039,
    private: 70615956
  },
  pubKeyHash: 111,
  scriptHash: 196,
  wif: 239
};
networks$3.testnet = {
  messagePrefix: `Bitcoin Signed Message:
`,
  bech32: "tb",
  bip32: {
    public: 70617039,
    private: 70615956
  },
  pubKeyHash: 111,
  scriptHash: 196,
  wif: 239
};
var payments$3 = {}, embed = {}, script$1 = {}, bip66$1 = {};
Object.defineProperty(bip66$1, "__esModule", { value: !0 });
bip66$1.encode = bip66$1.decode = bip66$1.check = void 0;
function check$i(n) {
  if (n.length < 8 || n.length > 72 || n[0] !== 48 || n[1] !== n.length - 2 || n[2] !== 2) return !1;
  const c = n[3];
  if (c === 0 || 5 + c >= n.length || n[4 + c] !== 2) return !1;
  const u = n[5 + c];
  return !(u === 0 || 6 + c + u !== n.length || n[4] & 128 || c > 1 && n[4] === 0 && !(n[5] & 128) || n[c + 6] & 128 || u > 1 && n[c + 6] === 0 && !(n[c + 7] & 128));
}
bip66$1.check = check$i;
function decode$v(n) {
  if (n.length < 8) throw new Error("DER sequence length is too short");
  if (n.length > 72) throw new Error("DER sequence length is too long");
  if (n[0] !== 48) throw new Error("Expected DER sequence");
  if (n[1] !== n.length - 2)
    throw new Error("DER sequence length is invalid");
  if (n[2] !== 2) throw new Error("Expected DER integer");
  const c = n[3];
  if (c === 0) throw new Error("R length is zero");
  if (5 + c >= n.length) throw new Error("R length is too long");
  if (n[4 + c] !== 2) throw new Error("Expected DER integer (2)");
  const u = n[5 + c];
  if (u === 0) throw new Error("S length is zero");
  if (6 + c + u !== n.length) throw new Error("S length is invalid");
  if (n[4] & 128) throw new Error("R value is negative");
  if (c > 1 && n[4] === 0 && !(n[5] & 128))
    throw new Error("R value excessively padded");
  if (n[c + 6] & 128) throw new Error("S value is negative");
  if (u > 1 && n[c + 6] === 0 && !(n[c + 7] & 128))
    throw new Error("S value excessively padded");
  return {
    r: n.slice(4, 4 + c),
    s: n.slice(6 + c)
  };
}
bip66$1.decode = decode$v;
function encode$v(n, c) {
  const u = n.length, p = c.length;
  if (u === 0) throw new Error("R length is zero");
  if (p === 0) throw new Error("S length is zero");
  if (u > 33) throw new Error("R length is too long");
  if (p > 33) throw new Error("S length is too long");
  if (n[0] & 128) throw new Error("R value is negative");
  if (c[0] & 128) throw new Error("S value is negative");
  if (u > 1 && n[0] === 0 && !(n[1] & 128))
    throw new Error("R value excessively padded");
  if (p > 1 && c[0] === 0 && !(c[1] & 128))
    throw new Error("S value excessively padded");
  const a = Buffer$f.allocUnsafe(6 + u + p);
  return a[0] = 48, a[1] = a.length - 2, a[2] = 2, a[3] = n.length, n.copy(a, 4), a[4 + u] = 2, a[5 + u] = c.length, c.copy(a, 6 + u), a;
}
bip66$1.encode = encode$v;
var ops = {};
Object.defineProperty(ops, "__esModule", { value: !0 });
ops.REVERSE_OPS = ops.OPS = void 0;
const OPS$8 = {
  OP_FALSE: 0,
  OP_0: 0,
  OP_PUSHDATA1: 76,
  OP_PUSHDATA2: 77,
  OP_PUSHDATA4: 78,
  OP_1NEGATE: 79,
  OP_RESERVED: 80,
  OP_TRUE: 81,
  OP_1: 81,
  OP_2: 82,
  OP_3: 83,
  OP_4: 84,
  OP_5: 85,
  OP_6: 86,
  OP_7: 87,
  OP_8: 88,
  OP_9: 89,
  OP_10: 90,
  OP_11: 91,
  OP_12: 92,
  OP_13: 93,
  OP_14: 94,
  OP_15: 95,
  OP_16: 96,
  OP_NOP: 97,
  OP_VER: 98,
  OP_IF: 99,
  OP_NOTIF: 100,
  OP_VERIF: 101,
  OP_VERNOTIF: 102,
  OP_ELSE: 103,
  OP_ENDIF: 104,
  OP_VERIFY: 105,
  OP_RETURN: 106,
  OP_TOALTSTACK: 107,
  OP_FROMALTSTACK: 108,
  OP_2DROP: 109,
  OP_2DUP: 110,
  OP_3DUP: 111,
  OP_2OVER: 112,
  OP_2ROT: 113,
  OP_2SWAP: 114,
  OP_IFDUP: 115,
  OP_DEPTH: 116,
  OP_DROP: 117,
  OP_DUP: 118,
  OP_NIP: 119,
  OP_OVER: 120,
  OP_PICK: 121,
  OP_ROLL: 122,
  OP_ROT: 123,
  OP_SWAP: 124,
  OP_TUCK: 125,
  OP_CAT: 126,
  OP_SUBSTR: 127,
  OP_LEFT: 128,
  OP_RIGHT: 129,
  OP_SIZE: 130,
  OP_INVERT: 131,
  OP_AND: 132,
  OP_OR: 133,
  OP_XOR: 134,
  OP_EQUAL: 135,
  OP_EQUALVERIFY: 136,
  OP_RESERVED1: 137,
  OP_RESERVED2: 138,
  OP_1ADD: 139,
  OP_1SUB: 140,
  OP_2MUL: 141,
  OP_2DIV: 142,
  OP_NEGATE: 143,
  OP_ABS: 144,
  OP_NOT: 145,
  OP_0NOTEQUAL: 146,
  OP_ADD: 147,
  OP_SUB: 148,
  OP_MUL: 149,
  OP_DIV: 150,
  OP_MOD: 151,
  OP_LSHIFT: 152,
  OP_RSHIFT: 153,
  OP_BOOLAND: 154,
  OP_BOOLOR: 155,
  OP_NUMEQUAL: 156,
  OP_NUMEQUALVERIFY: 157,
  OP_NUMNOTEQUAL: 158,
  OP_LESSTHAN: 159,
  OP_GREATERTHAN: 160,
  OP_LESSTHANOREQUAL: 161,
  OP_GREATERTHANOREQUAL: 162,
  OP_MIN: 163,
  OP_MAX: 164,
  OP_WITHIN: 165,
  OP_RIPEMD160: 166,
  OP_SHA1: 167,
  OP_SHA256: 168,
  OP_HASH160: 169,
  OP_HASH256: 170,
  OP_CODESEPARATOR: 171,
  OP_CHECKSIG: 172,
  OP_CHECKSIGVERIFY: 173,
  OP_CHECKMULTISIG: 174,
  OP_CHECKMULTISIGVERIFY: 175,
  OP_NOP1: 176,
  OP_NOP2: 177,
  OP_CHECKLOCKTIMEVERIFY: 177,
  OP_NOP3: 178,
  OP_CHECKSEQUENCEVERIFY: 178,
  OP_NOP4: 179,
  OP_NOP5: 180,
  OP_NOP6: 181,
  OP_NOP7: 182,
  OP_NOP8: 183,
  OP_NOP9: 184,
  OP_NOP10: 185,
  OP_CHECKSIGADD: 186,
  OP_PUBKEYHASH: 253,
  OP_PUBKEY: 254,
  OP_INVALIDOPCODE: 255
};
ops.OPS = OPS$8;
const REVERSE_OPS = {};
ops.REVERSE_OPS = REVERSE_OPS;
for (const n of Object.keys(OPS$8)) {
  const c = OPS$8[n];
  REVERSE_OPS[c] = n;
}
var push_data = {};
Object.defineProperty(push_data, "__esModule", { value: !0 });
push_data.decode = push_data.encode = push_data.encodingLength = void 0;
const ops_1 = ops;
function encodingLength$2(n) {
  return n < ops_1.OPS.OP_PUSHDATA1 ? 1 : n <= 255 ? 2 : n <= 65535 ? 3 : 5;
}
push_data.encodingLength = encodingLength$2;
function encode$u(n, c, u) {
  const p = encodingLength$2(c);
  return p === 1 ? n.writeUInt8(c, u) : p === 2 ? (n.writeUInt8(ops_1.OPS.OP_PUSHDATA1, u), n.writeUInt8(c, u + 1)) : p === 3 ? (n.writeUInt8(ops_1.OPS.OP_PUSHDATA2, u), n.writeUInt16LE(c, u + 1)) : (n.writeUInt8(ops_1.OPS.OP_PUSHDATA4, u), n.writeUInt32LE(c, u + 1)), p;
}
push_data.encode = encode$u;
function decode$u(n, c) {
  const u = n.readUInt8(c);
  let p, a;
  if (u < ops_1.OPS.OP_PUSHDATA1)
    p = u, a = 1;
  else if (u === ops_1.OPS.OP_PUSHDATA1) {
    if (c + 2 > n.length) return null;
    p = n.readUInt8(c + 1), a = 2;
  } else if (u === ops_1.OPS.OP_PUSHDATA2) {
    if (c + 3 > n.length) return null;
    p = n.readUInt16LE(c + 1), a = 3;
  } else {
    if (c + 5 > n.length) return null;
    if (u !== ops_1.OPS.OP_PUSHDATA4) throw new Error("Unexpected opcode");
    p = n.readUInt32LE(c + 1), a = 5;
  }
  return {
    opcode: u,
    number: p,
    size: a
  };
}
push_data.decode = decode$u;
var script_number = {};
Object.defineProperty(script_number, "__esModule", { value: !0 });
script_number.encode = script_number.decode = void 0;
function decode$t(n, c, u) {
  c = c || 4, u = u === void 0 ? !0 : u;
  const p = n.length;
  if (p === 0) return 0;
  if (p > c) throw new TypeError("Script number overflow");
  if (u && !(n[p - 1] & 127) && (p <= 1 || !(n[p - 2] & 128)))
    throw new Error("Non-minimally encoded script number");
  if (p === 5) {
    const A = n.readUInt32LE(0), b = n.readUInt8(4);
    return b & 128 ? -((b & -129) * 4294967296 + A) : b * 4294967296 + A;
  }
  let a = 0;
  for (let A = 0; A < p; ++A)
    a |= n[A] << 8 * A;
  return n[p - 1] & 128 ? -(a & ~(128 << 8 * (p - 1))) : a;
}
script_number.decode = decode$t;
function scriptNumSize(n) {
  return n > 2147483647 ? 5 : n > 8388607 ? 4 : n > 32767 ? 3 : n > 127 ? 2 : n > 0 ? 1 : 0;
}
function encode$t(n) {
  let c = Math.abs(n);
  const u = scriptNumSize(c), p = Buffer$f.allocUnsafe(u), a = n < 0;
  for (let A = 0; A < u; ++A)
    p.writeUInt8(c & 255, A), c >>= 8;
  return p[u - 1] & 128 ? p.writeUInt8(a ? 128 : 0, u - 1) : a && (p[u - 1] |= 128), p;
}
script_number.encode = encode$t;
var script_signature = {}, types$p = {};
const require$$0$5 = /* @__PURE__ */ getAugmentedNamespace(dist$z);
var types$o = {
  Array: function(n) {
    return n != null && n.constructor === Array;
  },
  Boolean: function(n) {
    return typeof n == "boolean";
  },
  Function: function(n) {
    return typeof n == "function";
  },
  Nil: function(n) {
    return n == null;
  },
  Number: function(n) {
    return typeof n == "number";
  },
  Object: function(n) {
    return typeof n == "object";
  },
  String: function(n) {
    return typeof n == "string";
  },
  "": function() {
    return !0;
  }
};
types$o.Null = types$o.Nil;
for (var typeName$1 in types$o)
  types$o[typeName$1].toJSON = (function(n) {
    return n;
  }).bind(null, typeName$1);
var native$6 = types$o, native$5 = native$6;
function getTypeName(n) {
  return n.name || n.toString().match(/function (.*?)\s*\(/)[1];
}
function getValueTypeName$1(n) {
  return native$5.Nil(n) ? "" : getTypeName(n.constructor);
}
function getValue(n) {
  return native$5.Function(n) ? "" : native$5.String(n) ? JSON.stringify(n) : n && native$5.Object(n) ? "" : n;
}
function captureStackTrace(n, c) {
  Error.captureStackTrace && Error.captureStackTrace(n, c);
}
function tfJSON$1(n) {
  return native$5.Function(n) ? n.toJSON ? n.toJSON() : getTypeName(n) : native$5.Array(n) ? "Array" : n && native$5.Object(n) ? "Object" : n !== void 0 ? n : "";
}
function tfErrorString(n, c, u) {
  var p = getValue(c);
  return "Expected " + tfJSON$1(n) + ", got" + (u !== "" ? " " + u : "") + (p !== "" ? " " + p : "");
}
function TfTypeError$1(n, c, u) {
  u = u || getValueTypeName$1(c), this.message = tfErrorString(n, c, u), captureStackTrace(this, TfTypeError$1), this.__type = n, this.__value = c, this.__valueTypeName = u;
}
TfTypeError$1.prototype = Object.create(Error.prototype);
TfTypeError$1.prototype.constructor = TfTypeError$1;
function tfPropertyErrorString(n, c, u, p, a) {
  var A = '" of type ';
  return c === "key" && (A = '" with key type '), tfErrorString('property "' + tfJSON$1(u) + A + tfJSON$1(n), p, a);
}
function TfPropertyTypeError$1(n, c, u, p, a) {
  n ? (a = a || getValueTypeName$1(p), this.message = tfPropertyErrorString(n, u, c, p, a)) : this.message = 'Unexpected property "' + c + '"', captureStackTrace(this, TfTypeError$1), this.__label = u, this.__property = c, this.__type = n, this.__value = p, this.__valueTypeName = a;
}
TfPropertyTypeError$1.prototype = Object.create(Error.prototype);
TfPropertyTypeError$1.prototype.constructor = TfTypeError$1;
function tfCustomError(n, c) {
  return new TfTypeError$1(n, {}, c);
}
function tfSubError$1(n, c, u) {
  return n instanceof TfPropertyTypeError$1 ? (c = c + "." + n.__property, n = new TfPropertyTypeError$1(
    n.__type,
    c,
    n.__label,
    n.__value,
    n.__valueTypeName
  )) : n instanceof TfTypeError$1 && (n = new TfPropertyTypeError$1(
    n.__type,
    c,
    u,
    n.__value,
    n.__valueTypeName
  )), captureStackTrace(n), n;
}
var errors$g = {
  TfTypeError: TfTypeError$1,
  TfPropertyTypeError: TfPropertyTypeError$1,
  tfCustomError,
  tfSubError: tfSubError$1,
  tfJSON: tfJSON$1,
  getValueTypeName: getValueTypeName$1
}, extra, hasRequiredExtra;
function requireExtra() {
  if (hasRequiredExtra) return extra;
  hasRequiredExtra = 1;
  var n = native$6, c = errors$g;
  function u(kr) {
    return Buffer$f.isBuffer(kr);
  }
  function p(kr) {
    return typeof kr == "string" && /^([0-9a-f]{2})+$/i.test(kr);
  }
  function a(kr, Ce) {
    var tr = kr.toJSON();
    function Fe(Sr) {
      if (!kr(Sr)) return !1;
      if (Sr.length === Ce) return !0;
      throw c.tfCustomError(tr + "(Length: " + Ce + ")", tr + "(Length: " + Sr.length + ")");
    }
    return Fe.toJSON = function() {
      return tr;
    }, Fe;
  }
  var A = a.bind(null, n.Array), b = a.bind(null, u), F = a.bind(null, p), le = a.bind(null, n.String);
  function L(kr, Ce, tr) {
    tr = tr || n.Number;
    function Fe(Sr, er) {
      return tr(Sr, er) && Sr > kr && Sr < Ce;
    }
    return Fe.toJSON = function() {
      return `${tr.toJSON()} between [${kr}, ${Ce}]`;
    }, Fe;
  }
  var pe = Math.pow(2, 53) - 1;
  function $(kr) {
    return typeof kr == "number" && isFinite(kr);
  }
  function Ee(kr) {
    return kr << 24 >> 24 === kr;
  }
  function be(kr) {
    return kr << 16 >> 16 === kr;
  }
  function He(kr) {
    return (kr | 0) === kr;
  }
  function Pe(kr) {
    return typeof kr == "number" && kr >= -pe && kr <= pe && Math.floor(kr) === kr;
  }
  function nr(kr) {
    return (kr & 255) === kr;
  }
  function ir(kr) {
    return (kr & 65535) === kr;
  }
  function or(kr) {
    return kr >>> 0 === kr;
  }
  function lr(kr) {
    return typeof kr == "number" && kr >= 0 && kr <= pe && Math.floor(kr) === kr;
  }
  var Ir = {
    ArrayN: A,
    Buffer: u,
    BufferN: b,
    Finite: $,
    Hex: p,
    HexN: F,
    Int8: Ee,
    Int16: be,
    Int32: He,
    Int53: Pe,
    Range: L,
    StringN: le,
    UInt8: nr,
    UInt16: ir,
    UInt32: or,
    UInt53: lr
  };
  for (var xr in Ir)
    Ir[xr].toJSON = (function(kr) {
      return kr;
    }).bind(null, xr);
  return extra = Ir, extra;
}
var ERRORS = errors$g, NATIVE = native$6, tfJSON = ERRORS.tfJSON, TfTypeError = ERRORS.TfTypeError, TfPropertyTypeError = ERRORS.TfPropertyTypeError, tfSubError = ERRORS.tfSubError, getValueTypeName = ERRORS.getValueTypeName, TYPES$1 = {
  arrayOf: function(c, u) {
    c = compile(c), u = u || {};
    function p(a, A) {
      return !NATIVE.Array(a) || NATIVE.Nil(a) || u.minLength !== void 0 && a.length < u.minLength || u.maxLength !== void 0 && a.length > u.maxLength || u.length !== void 0 && a.length !== u.length ? !1 : a.every(function(b, F) {
        try {
          return typeforce$5(c, b, A);
        } catch (le) {
          throw tfSubError(le, F);
        }
      });
    }
    return p.toJSON = function() {
      var a = "[" + tfJSON(c) + "]";
      return u.length !== void 0 ? a += "{" + u.length + "}" : (u.minLength !== void 0 || u.maxLength !== void 0) && (a += "{" + (u.minLength === void 0 ? 0 : u.minLength) + "," + (u.maxLength === void 0 ? 1 / 0 : u.maxLength) + "}"), a;
    }, p;
  },
  maybe: function n(c) {
    c = compile(c);
    function u(p, a) {
      return NATIVE.Nil(p) || c(p, a, n);
    }
    return u.toJSON = function() {
      return "?" + tfJSON(c);
    }, u;
  },
  map: function(c, u) {
    c = compile(c), u && (u = compile(u));
    function p(a, A) {
      if (!NATIVE.Object(a) || NATIVE.Nil(a)) return !1;
      for (var b in a) {
        try {
          u && typeforce$5(u, b, A);
        } catch (le) {
          throw tfSubError(le, b, "key");
        }
        try {
          var F = a[b];
          typeforce$5(c, F, A);
        } catch (le) {
          throw tfSubError(le, b);
        }
      }
      return !0;
    }
    return u ? p.toJSON = function() {
      return "{" + tfJSON(u) + ": " + tfJSON(c) + "}";
    } : p.toJSON = function() {
      return "{" + tfJSON(c) + "}";
    }, p;
  },
  object: function(c) {
    var u = {};
    for (var p in c)
      u[p] = compile(c[p]);
    function a(A, b) {
      if (!NATIVE.Object(A) || NATIVE.Nil(A)) return !1;
      var F;
      try {
        for (F in u) {
          var le = u[F], L = A[F];
          typeforce$5(le, L, b);
        }
      } catch (pe) {
        throw tfSubError(pe, F);
      }
      if (b) {
        for (F in A)
          if (!u[F])
            throw new TfPropertyTypeError(void 0, F);
      }
      return !0;
    }
    return a.toJSON = function() {
      return tfJSON(u);
    }, a;
  },
  anyOf: function() {
    var c = [].slice.call(arguments).map(compile);
    function u(p, a) {
      return c.some(function(A) {
        try {
          return typeforce$5(A, p, a);
        } catch {
          return !1;
        }
      });
    }
    return u.toJSON = function() {
      return c.map(tfJSON).join("|");
    }, u;
  },
  allOf: function() {
    var c = [].slice.call(arguments).map(compile);
    function u(p, a) {
      return c.every(function(A) {
        try {
          return typeforce$5(A, p, a);
        } catch {
          return !1;
        }
      });
    }
    return u.toJSON = function() {
      return c.map(tfJSON).join(" & ");
    }, u;
  },
  quacksLike: function(c) {
    function u(p) {
      return c === getValueTypeName(p);
    }
    return u.toJSON = function() {
      return c;
    }, u;
  },
  tuple: function() {
    var c = [].slice.call(arguments).map(compile);
    function u(p, a) {
      return NATIVE.Nil(p) || NATIVE.Nil(p.length) || a && p.length !== c.length ? !1 : c.every(function(A, b) {
        try {
          return typeforce$5(A, p[b], a);
        } catch (F) {
          throw tfSubError(F, b);
        }
      });
    }
    return u.toJSON = function() {
      return "(" + c.map(tfJSON).join(", ") + ")";
    }, u;
  },
  value: function(c) {
    function u(p) {
      return p === c;
    }
    return u.toJSON = function() {
      return c;
    }, u;
  }
};
TYPES$1.oneOf = TYPES$1.anyOf;
function compile(n) {
  if (NATIVE.String(n))
    return n[0] === "?" ? TYPES$1.maybe(n.slice(1)) : NATIVE[n] || TYPES$1.quacksLike(n);
  if (n && NATIVE.Object(n)) {
    if (NATIVE.Array(n)) {
      if (n.length !== 1) throw new TypeError("Expected compile() parameter of type Array of length 1");
      return TYPES$1.arrayOf(n[0]);
    }
    return TYPES$1.object(n);
  } else if (NATIVE.Function(n))
    return n;
  return TYPES$1.value(n);
}
function typeforce$5(n, c, u, p) {
  if (NATIVE.Function(n)) {
    if (n(c, u)) return !0;
    throw new TfTypeError(p || n, c);
  }
  return typeforce$5(compile(n), c, u);
}
for (var typeName in NATIVE)
  typeforce$5[typeName] = NATIVE[typeName];
for (typeName in TYPES$1)
  typeforce$5[typeName] = TYPES$1[typeName];
var EXTRA$1 = requireExtra();
for (typeName in EXTRA$1)
  typeforce$5[typeName] = EXTRA$1[typeName];
typeforce$5.compile = compile;
typeforce$5.TfTypeError = TfTypeError;
typeforce$5.TfPropertyTypeError = TfPropertyTypeError;
var typeforce_1 = typeforce$5;
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.oneOf = n.Null = n.BufferN = n.Function = n.UInt32 = n.UInt8 = n.tuple = n.maybe = n.Hex = n.Buffer = n.String = n.Boolean = n.Array = n.Number = n.Hash256bit = n.Hash160bit = n.Buffer256bit = n.isTaptree = n.isTapleaf = n.TAPLEAF_VERSION_MASK = n.Network = n.ECPoint = n.Satoshi = n.Signer = n.BIP32Path = n.UInt31 = n.isPoint = n.typeforce = void 0;
  const c = require$$0$5;
  n.typeforce = typeforce_1;
  const u = c.Buffer.alloc(32, 0), p = c.Buffer.from(
    "fffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f",
    "hex"
  );
  function a(be) {
    if (!c.Buffer.isBuffer(be) || be.length < 33) return !1;
    const He = be[0], Pe = be.slice(1, 33);
    if (Pe.compare(u) === 0 || Pe.compare(p) >= 0) return !1;
    if ((He === 2 || He === 3) && be.length === 33)
      return !0;
    const nr = be.slice(33);
    return nr.compare(u) === 0 || nr.compare(p) >= 0 ? !1 : He === 4 && be.length === 65;
  }
  n.isPoint = a;
  const A = Math.pow(2, 31) - 1;
  function b(be) {
    return n.typeforce.UInt32(be) && be <= A;
  }
  n.UInt31 = b;
  function F(be) {
    return n.typeforce.String(be) && !!be.match(/^(m\/)?(\d+'?\/)*\d+'?$/);
  }
  n.BIP32Path = F, F.toJSON = () => "BIP32 derivation path";
  function le(be) {
    return (n.typeforce.Buffer(be.publicKey) || typeof be.getPublicKey == "function") && typeof be.sign == "function";
  }
  n.Signer = le;
  const L = 21 * 1e14;
  function pe(be) {
    return n.typeforce.UInt53(be) && be <= L;
  }
  n.Satoshi = pe, n.ECPoint = n.typeforce.quacksLike("Point"), n.Network = n.typeforce.compile({
    messagePrefix: n.typeforce.oneOf(
      n.typeforce.Buffer,
      n.typeforce.String
    ),
    bip32: {
      public: n.typeforce.UInt32,
      private: n.typeforce.UInt32
    },
    pubKeyHash: n.typeforce.UInt8,
    scriptHash: n.typeforce.UInt8,
    wif: n.typeforce.UInt8
  }), n.TAPLEAF_VERSION_MASK = 254;
  function $(be) {
    return !be || !("output" in be) || !c.Buffer.isBuffer(be.output) ? !1 : be.version !== void 0 ? (be.version & n.TAPLEAF_VERSION_MASK) === be.version : !0;
  }
  n.isTapleaf = $;
  function Ee(be) {
    return (0, n.Array)(be) ? be.length !== 2 ? !1 : be.every((He) => Ee(He)) : $(be);
  }
  n.isTaptree = Ee, n.Buffer256bit = n.typeforce.BufferN(32), n.Hash160bit = n.typeforce.BufferN(20), n.Hash256bit = n.typeforce.BufferN(32), n.Number = n.typeforce.Number, n.Array = n.typeforce.Array, n.Boolean = n.typeforce.Boolean, n.String = n.typeforce.String, n.Buffer = n.typeforce.Buffer, n.Hex = n.typeforce.Hex, n.maybe = n.typeforce.maybe, n.tuple = n.typeforce.tuple, n.UInt8 = n.typeforce.UInt8, n.UInt32 = n.typeforce.UInt32, n.Function = n.typeforce.Function, n.BufferN = n.typeforce.BufferN, n.Null = n.typeforce.Null, n.oneOf = n.typeforce.oneOf;
})(types$p);
Object.defineProperty(script_signature, "__esModule", { value: !0 });
script_signature.encode = script_signature.decode = void 0;
const bip66 = bip66$1, types$n = types$p, { typeforce: typeforce$4 } = types$n, ZERO$3 = Buffer$f.alloc(1, 0);
function toDER(n) {
  let c = 0;
  for (; n[c] === 0; ) ++c;
  return c === n.length ? ZERO$3 : (n = n.slice(c), n[0] & 128 ? Buffer$f.concat([ZERO$3, n], 1 + n.length) : n);
}
function fromDER(n) {
  n[0] === 0 && (n = n.slice(1));
  const c = Buffer$f.alloc(32, 0), u = Math.max(0, 32 - n.length);
  return n.copy(c, u), c;
}
function decode$s(n) {
  const c = n.readUInt8(n.length - 1), u = c & -129;
  if (u <= 0 || u >= 4)
    throw new Error("Invalid hashType " + c);
  const p = bip66.decode(n.slice(0, -1)), a = fromDER(p.r), A = fromDER(p.s);
  return { signature: Buffer$f.concat([a, A], 64), hashType: c };
}
script_signature.decode = decode$s;
function encode$s(n, c) {
  typeforce$4(
    {
      signature: types$n.BufferN(64),
      hashType: types$n.UInt8
    },
    { signature: n, hashType: c }
  );
  const u = c & -129;
  if (u <= 0 || u >= 4)
    throw new Error("Invalid hashType " + c);
  const p = Buffer$f.allocUnsafe(1);
  p.writeUInt8(c, 0);
  const a = toDER(n.slice(0, 32)), A = toDER(n.slice(32, 64));
  return Buffer$f.concat([bip66.encode(a, A), p]);
}
script_signature.encode = encode$s;
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.signature = n.number = n.isCanonicalScriptSignature = n.isDefinedHashType = n.isCanonicalPubKey = n.toStack = n.fromASM = n.toASM = n.decompile = n.compile = n.countNonPushOnlyOPs = n.isPushOnly = n.OPS = void 0;
  const c = bip66$1, u = ops;
  Object.defineProperty(n, "OPS", {
    enumerable: !0,
    get: function() {
      return u.OPS;
    }
  });
  const p = push_data, a = script_number, A = script_signature, b = types$p, { typeforce: F } = b, le = u.OPS.OP_RESERVED;
  function L(Fe) {
    return b.Number(Fe) && (Fe === u.OPS.OP_0 || Fe >= u.OPS.OP_1 && Fe <= u.OPS.OP_16 || Fe === u.OPS.OP_1NEGATE);
  }
  function pe(Fe) {
    return b.Buffer(Fe) || L(Fe);
  }
  function $(Fe) {
    return b.Array(Fe) && Fe.every(pe);
  }
  n.isPushOnly = $;
  function Ee(Fe) {
    return Fe.length - Fe.filter(pe).length;
  }
  n.countNonPushOnlyOPs = Ee;
  function be(Fe) {
    if (Fe.length === 0) return u.OPS.OP_0;
    if (Fe.length === 1) {
      if (Fe[0] >= 1 && Fe[0] <= 16) return le + Fe[0];
      if (Fe[0] === 129) return u.OPS.OP_1NEGATE;
    }
  }
  function He(Fe) {
    return Buffer$f.isBuffer(Fe);
  }
  function Pe(Fe) {
    return b.Array(Fe);
  }
  function nr(Fe) {
    return Buffer$f.isBuffer(Fe);
  }
  function ir(Fe) {
    if (He(Fe)) return Fe;
    F(b.Array, Fe);
    const Sr = Fe.reduce((xe, rr) => nr(rr) ? rr.length === 1 && be(rr) !== void 0 ? xe + 1 : xe + p.encodingLength(rr.length) + rr.length : xe + 1, 0), er = Buffer$f.allocUnsafe(Sr);
    let Ie = 0;
    if (Fe.forEach((xe) => {
      if (nr(xe)) {
        const rr = be(xe);
        if (rr !== void 0) {
          er.writeUInt8(rr, Ie), Ie += 1;
          return;
        }
        Ie += p.encode(er, xe.length, Ie), xe.copy(er, Ie), Ie += xe.length;
      } else
        er.writeUInt8(xe, Ie), Ie += 1;
    }), Ie !== er.length) throw new Error("Could not decode chunks");
    return er;
  }
  n.compile = ir;
  function or(Fe) {
    if (Pe(Fe)) return Fe;
    F(b.Buffer, Fe);
    const Sr = [];
    let er = 0;
    for (; er < Fe.length; ) {
      const Ie = Fe[er];
      if (Ie > u.OPS.OP_0 && Ie <= u.OPS.OP_PUSHDATA4) {
        const xe = p.decode(Fe, er);
        if (xe === null || (er += xe.size, er + xe.number > Fe.length)) return null;
        const rr = Fe.slice(er, er + xe.number);
        er += xe.number;
        const ar = be(rr);
        ar !== void 0 ? Sr.push(ar) : Sr.push(rr);
      } else
        Sr.push(Ie), er += 1;
    }
    return Sr;
  }
  n.decompile = or;
  function lr(Fe) {
    return He(Fe) && (Fe = or(Fe)), Fe.map((Sr) => {
      if (nr(Sr)) {
        const er = be(Sr);
        if (er === void 0) return Sr.toString("hex");
        Sr = er;
      }
      return u.REVERSE_OPS[Sr];
    }).join(" ");
  }
  n.toASM = lr;
  function Ir(Fe) {
    return F(b.String, Fe), ir(
      Fe.split(" ").map((Sr) => u.OPS[Sr] !== void 0 ? u.OPS[Sr] : (F(b.Hex, Sr), Buffer$f.from(Sr, "hex")))
    );
  }
  n.fromASM = Ir;
  function xr(Fe) {
    return Fe = or(Fe), F($, Fe), Fe.map((Sr) => nr(Sr) ? Sr : Sr === u.OPS.OP_0 ? Buffer$f.allocUnsafe(0) : a.encode(Sr - le));
  }
  n.toStack = xr;
  function kr(Fe) {
    return b.isPoint(Fe);
  }
  n.isCanonicalPubKey = kr;
  function Ce(Fe) {
    const Sr = Fe & -129;
    return Sr > 0 && Sr < 4;
  }
  n.isDefinedHashType = Ce;
  function tr(Fe) {
    return !Buffer$f.isBuffer(Fe) || !Ce(Fe[Fe.length - 1]) ? !1 : c.check(Fe.slice(0, -1));
  }
  n.isCanonicalScriptSignature = tr, n.number = a, n.signature = A;
})(script$1);
var lazy$8 = {};
Object.defineProperty(lazy$8, "__esModule", { value: !0 });
lazy$8.value = lazy$8.prop = void 0;
function prop(n, c, u) {
  Object.defineProperty(n, c, {
    configurable: !0,
    enumerable: !0,
    get() {
      const p = u.call(this);
      return this[c] = p, p;
    },
    set(p) {
      Object.defineProperty(this, c, {
        configurable: !0,
        enumerable: !0,
        value: p,
        writable: !0
      });
    }
  });
}
lazy$8.prop = prop;
function value(n) {
  let c;
  return () => (c !== void 0 || (c = n()), c);
}
lazy$8.value = value;
Object.defineProperty(embed, "__esModule", { value: !0 });
embed.p2data = void 0;
const networks_1$8 = networks$3, bscript$b = script$1, types_1$g = types$p, lazy$7 = lazy$8, OPS$7 = bscript$b.OPS;
function stacksEqual$4(n, c) {
  return n.length !== c.length ? !1 : n.every((u, p) => u.equals(c[p]));
}
function p2data(n, c) {
  if (!n.data && !n.output) throw new TypeError("Not enough data");
  c = Object.assign({ validate: !0 }, c || {}), (0, types_1$g.typeforce)(
    {
      network: types_1$g.typeforce.maybe(types_1$g.typeforce.Object),
      output: types_1$g.typeforce.maybe(types_1$g.typeforce.Buffer),
      data: types_1$g.typeforce.maybe(
        types_1$g.typeforce.arrayOf(types_1$g.typeforce.Buffer)
      )
    },
    n
  );
  const p = { name: "embed", network: n.network || networks_1$8.bitcoin };
  if (lazy$7.prop(p, "output", () => {
    if (n.data)
      return bscript$b.compile([OPS$7.OP_RETURN].concat(n.data));
  }), lazy$7.prop(p, "data", () => {
    if (n.output)
      return bscript$b.decompile(n.output).slice(1);
  }), c.validate && n.output) {
    const a = bscript$b.decompile(n.output);
    if (a[0] !== OPS$7.OP_RETURN) throw new TypeError("Output is invalid");
    if (!a.slice(1).every(types_1$g.typeforce.Buffer))
      throw new TypeError("Output is invalid");
    if (n.data && !stacksEqual$4(n.data, p.data))
      throw new TypeError("Data mismatch");
  }
  return Object.assign(p, n);
}
embed.p2data = p2data;
var p2ms$2 = {};
Object.defineProperty(p2ms$2, "__esModule", { value: !0 });
p2ms$2.p2ms = void 0;
const networks_1$7 = networks$3, bscript$a = script$1, types_1$f = types$p, lazy$6 = lazy$8, OPS$6 = bscript$a.OPS, OP_INT_BASE = OPS$6.OP_RESERVED;
function stacksEqual$3(n, c) {
  return n.length !== c.length ? !1 : n.every((u, p) => u.equals(c[p]));
}
function p2ms$1(n, c) {
  if (!n.input && !n.output && !(n.pubkeys && n.m !== void 0) && !n.signatures)
    throw new TypeError("Not enough data");
  c = Object.assign({ validate: !0 }, c || {});
  function u(le) {
    return bscript$a.isCanonicalScriptSignature(le) || (c.allowIncomplete && le === OPS$6.OP_0) !== void 0;
  }
  (0, types_1$f.typeforce)(
    {
      network: types_1$f.typeforce.maybe(types_1$f.typeforce.Object),
      m: types_1$f.typeforce.maybe(types_1$f.typeforce.Number),
      n: types_1$f.typeforce.maybe(types_1$f.typeforce.Number),
      output: types_1$f.typeforce.maybe(types_1$f.typeforce.Buffer),
      pubkeys: types_1$f.typeforce.maybe(
        types_1$f.typeforce.arrayOf(types_1$f.isPoint)
      ),
      signatures: types_1$f.typeforce.maybe(
        types_1$f.typeforce.arrayOf(u)
      ),
      input: types_1$f.typeforce.maybe(types_1$f.typeforce.Buffer)
    },
    n
  );
  const a = { network: n.network || networks_1$7.bitcoin };
  let A = [], b = !1;
  function F(le) {
    b || (b = !0, A = bscript$a.decompile(le), a.m = A[0] - OP_INT_BASE, a.n = A[A.length - 2] - OP_INT_BASE, a.pubkeys = A.slice(1, -2));
  }
  if (lazy$6.prop(a, "output", () => {
    if (n.m && a.n && n.pubkeys)
      return bscript$a.compile(
        [].concat(
          OP_INT_BASE + n.m,
          n.pubkeys,
          OP_INT_BASE + a.n,
          OPS$6.OP_CHECKMULTISIG
        )
      );
  }), lazy$6.prop(a, "m", () => {
    if (a.output)
      return F(a.output), a.m;
  }), lazy$6.prop(a, "n", () => {
    if (a.pubkeys)
      return a.pubkeys.length;
  }), lazy$6.prop(a, "pubkeys", () => {
    if (n.output)
      return F(n.output), a.pubkeys;
  }), lazy$6.prop(a, "signatures", () => {
    if (n.input)
      return bscript$a.decompile(n.input).slice(1);
  }), lazy$6.prop(a, "input", () => {
    if (n.signatures)
      return bscript$a.compile([OPS$6.OP_0].concat(n.signatures));
  }), lazy$6.prop(a, "witness", () => {
    if (a.input)
      return [];
  }), lazy$6.prop(a, "name", () => {
    if (!(!a.m || !a.n))
      return `p2ms(${a.m} of ${a.n})`;
  }), c.validate) {
    if (n.output) {
      if (F(n.output), !types_1$f.typeforce.Number(A[0]))
        throw new TypeError("Output is invalid");
      if (!types_1$f.typeforce.Number(A[A.length - 2]))
        throw new TypeError("Output is invalid");
      if (A[A.length - 1] !== OPS$6.OP_CHECKMULTISIG)
        throw new TypeError("Output is invalid");
      if (a.m <= 0 || a.n > 16 || a.m > a.n || a.n !== A.length - 3)
        throw new TypeError("Output is invalid");
      if (!a.pubkeys.every((le) => (0, types_1$f.isPoint)(le)))
        throw new TypeError("Output is invalid");
      if (n.m !== void 0 && n.m !== a.m) throw new TypeError("m mismatch");
      if (n.n !== void 0 && n.n !== a.n) throw new TypeError("n mismatch");
      if (n.pubkeys && !stacksEqual$3(n.pubkeys, a.pubkeys))
        throw new TypeError("Pubkeys mismatch");
    }
    if (n.pubkeys) {
      if (n.n !== void 0 && n.n !== n.pubkeys.length)
        throw new TypeError("Pubkey count mismatch");
      if (a.n = n.pubkeys.length, a.n < a.m) throw new TypeError("Pubkey count cannot be less than m");
    }
    if (n.signatures) {
      if (n.signatures.length < a.m)
        throw new TypeError("Not enough signatures provided");
      if (n.signatures.length > a.m)
        throw new TypeError("Too many signatures provided");
    }
    if (n.input) {
      if (n.input[0] !== OPS$6.OP_0) throw new TypeError("Input is invalid");
      if (a.signatures.length === 0 || !a.signatures.every(u))
        throw new TypeError("Input has invalid signature(s)");
      if (n.signatures && !stacksEqual$3(n.signatures, a.signatures))
        throw new TypeError("Signature mismatch");
      if (n.m !== void 0 && n.m !== n.signatures.length)
        throw new TypeError("Signature count mismatch");
    }
  }
  return Object.assign(a, n);
}
p2ms$2.p2ms = p2ms$1;
var p2pk$3 = {};
Object.defineProperty(p2pk$3, "__esModule", { value: !0 });
p2pk$3.p2pk = void 0;
const networks_1$6 = networks$3, bscript$9 = script$1, types_1$e = types$p, lazy$5 = lazy$8, OPS$5 = bscript$9.OPS;
function p2pk$2(n, c) {
  if (!n.input && !n.output && !n.pubkey && !n.input && !n.signature)
    throw new TypeError("Not enough data");
  c = Object.assign({ validate: !0 }, c || {}), (0, types_1$e.typeforce)(
    {
      network: types_1$e.typeforce.maybe(types_1$e.typeforce.Object),
      output: types_1$e.typeforce.maybe(types_1$e.typeforce.Buffer),
      pubkey: types_1$e.typeforce.maybe(types_1$e.isPoint),
      signature: types_1$e.typeforce.maybe(bscript$9.isCanonicalScriptSignature),
      input: types_1$e.typeforce.maybe(types_1$e.typeforce.Buffer)
    },
    n
  );
  const u = lazy$5.value(() => bscript$9.decompile(n.input)), a = { name: "p2pk", network: n.network || networks_1$6.bitcoin };
  if (lazy$5.prop(a, "output", () => {
    if (n.pubkey)
      return bscript$9.compile([n.pubkey, OPS$5.OP_CHECKSIG]);
  }), lazy$5.prop(a, "pubkey", () => {
    if (n.output)
      return n.output.slice(1, -1);
  }), lazy$5.prop(a, "signature", () => {
    if (n.input)
      return u()[0];
  }), lazy$5.prop(a, "input", () => {
    if (n.signature)
      return bscript$9.compile([n.signature]);
  }), lazy$5.prop(a, "witness", () => {
    if (a.input)
      return [];
  }), c.validate) {
    if (n.output) {
      if (n.output[n.output.length - 1] !== OPS$5.OP_CHECKSIG)
        throw new TypeError("Output is invalid");
      if (!(0, types_1$e.isPoint)(a.pubkey))
        throw new TypeError("Output pubkey is invalid");
      if (n.pubkey && !n.pubkey.equals(a.pubkey))
        throw new TypeError("Pubkey mismatch");
    }
    if (n.signature && n.input && !n.input.equals(a.input))
      throw new TypeError("Signature mismatch");
    if (n.input) {
      if (u().length !== 1) throw new TypeError("Input is invalid");
      if (!bscript$9.isCanonicalScriptSignature(a.signature))
        throw new TypeError("Input has invalid signature");
    }
  }
  return Object.assign(a, n);
}
p2pk$3.p2pk = p2pk$2;
var p2pkh$3 = {}, crypto$9 = {}, ripemd160$6 = {}, legacy$1 = {}, _md$2 = {}, utils$O = {}, crypto$8 = {};
Object.defineProperty(crypto$8, "__esModule", { value: !0 });
crypto$8.crypto = void 0;
crypto$8.crypto = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0;
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.wrapXOFConstructorWithOpts = n.wrapConstructorWithOpts = n.wrapConstructor = n.Hash = n.nextTick = n.swap32IfBE = n.byteSwapIfBE = n.swap8IfBE = n.isLE = void 0, n.isBytes = u, n.anumber = p, n.abytes = a, n.ahash = A, n.aexists = b, n.aoutput = F, n.u8 = le, n.u32 = L, n.clean = pe, n.createView = $, n.rotr = Ee, n.rotl = be, n.byteSwap = He, n.byteSwap32 = Pe, n.bytesToHex = or, n.hexToBytes = xr, n.asyncLoop = Ce, n.utf8ToBytes = tr, n.bytesToUtf8 = Fe, n.toBytes = Sr, n.kdfInputToBytes = er, n.concatBytes = Ie, n.checkOpts = xe, n.createHasher = ar, n.createOptHasher = yr, n.createXOFer = _r, n.randomBytes = Or;
  const c = crypto$8;
  function u(vr) {
    return vr instanceof Uint8Array || ArrayBuffer.isView(vr) && vr.constructor.name === "Uint8Array";
  }
  function p(vr) {
    if (!Number.isSafeInteger(vr) || vr < 0)
      throw new Error("positive integer expected, got " + vr);
  }
  function a(vr, ...Te) {
    if (!u(vr))
      throw new Error("Uint8Array expected");
    if (Te.length > 0 && !Te.includes(vr.length))
      throw new Error("Uint8Array expected of length " + Te + ", got length=" + vr.length);
  }
  function A(vr) {
    if (typeof vr != "function" || typeof vr.create != "function")
      throw new Error("Hash should be wrapped by utils.createHasher");
    p(vr.outputLen), p(vr.blockLen);
  }
  function b(vr, Te = !0) {
    if (vr.destroyed)
      throw new Error("Hash instance has been destroyed");
    if (Te && vr.finished)
      throw new Error("Hash#digest() has already been called");
  }
  function F(vr, Te) {
    a(vr);
    const Cr = Te.outputLen;
    if (vr.length < Cr)
      throw new Error("digestInto() expects output buffer of length at least " + Cr);
  }
  function le(vr) {
    return new Uint8Array(vr.buffer, vr.byteOffset, vr.byteLength);
  }
  function L(vr) {
    return new Uint32Array(vr.buffer, vr.byteOffset, Math.floor(vr.byteLength / 4));
  }
  function pe(...vr) {
    for (let Te = 0; Te < vr.length; Te++)
      vr[Te].fill(0);
  }
  function $(vr) {
    return new DataView(vr.buffer, vr.byteOffset, vr.byteLength);
  }
  function Ee(vr, Te) {
    return vr << 32 - Te | vr >>> Te;
  }
  function be(vr, Te) {
    return vr << Te | vr >>> 32 - Te >>> 0;
  }
  n.isLE = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
  function He(vr) {
    return vr << 24 & 4278190080 | vr << 8 & 16711680 | vr >>> 8 & 65280 | vr >>> 24 & 255;
  }
  n.swap8IfBE = n.isLE ? (vr) => vr : (vr) => He(vr), n.byteSwapIfBE = n.swap8IfBE;
  function Pe(vr) {
    for (let Te = 0; Te < vr.length; Te++)
      vr[Te] = He(vr[Te]);
    return vr;
  }
  n.swap32IfBE = n.isLE ? (vr) => vr : Pe;
  const nr = /* @ts-ignore */ typeof Uint8Array.from([]).toHex == "function" && typeof Uint8Array.fromHex == "function", ir = /* @__PURE__ */ Array.from({ length: 256 }, (vr, Te) => Te.toString(16).padStart(2, "0"));
  function or(vr) {
    if (a(vr), nr)
      return vr.toHex();
    let Te = "";
    for (let Cr = 0; Cr < vr.length; Cr++)
      Te += ir[vr[Cr]];
    return Te;
  }
  const lr = { _0: 48, _9: 57, A: 65, F: 70, a: 97, f: 102 };
  function Ir(vr) {
    if (vr >= lr._0 && vr <= lr._9)
      return vr - lr._0;
    if (vr >= lr.A && vr <= lr.F)
      return vr - (lr.A - 10);
    if (vr >= lr.a && vr <= lr.f)
      return vr - (lr.a - 10);
  }
  function xr(vr) {
    if (typeof vr != "string")
      throw new Error("hex string expected, got " + typeof vr);
    if (nr)
      return Uint8Array.fromHex(vr);
    const Te = vr.length, Cr = Te / 2;
    if (Te % 2)
      throw new Error("hex string expected, got unpadded hex of length " + Te);
    const Hr = new Uint8Array(Cr);
    for (let si = 0, ui = 0; si < Cr; si++, ui += 2) {
      const Li = Ir(vr.charCodeAt(ui)), Qi = Ir(vr.charCodeAt(ui + 1));
      if (Li === void 0 || Qi === void 0) {
        const wi = vr[ui] + vr[ui + 1];
        throw new Error('hex string expected, got non-hex character "' + wi + '" at index ' + ui);
      }
      Hr[si] = Li * 16 + Qi;
    }
    return Hr;
  }
  const kr = async () => {
  };
  n.nextTick = kr;
  async function Ce(vr, Te, Cr) {
    let Hr = Date.now();
    for (let si = 0; si < vr; si++) {
      Cr(si);
      const ui = Date.now() - Hr;
      ui >= 0 && ui < Te || (await (0, n.nextTick)(), Hr += ui);
    }
  }
  function tr(vr) {
    if (typeof vr != "string")
      throw new Error("string expected");
    return new Uint8Array(new TextEncoder().encode(vr));
  }
  function Fe(vr) {
    return new TextDecoder().decode(vr);
  }
  function Sr(vr) {
    return typeof vr == "string" && (vr = tr(vr)), a(vr), vr;
  }
  function er(vr) {
    return typeof vr == "string" && (vr = tr(vr)), a(vr), vr;
  }
  function Ie(...vr) {
    let Te = 0;
    for (let Hr = 0; Hr < vr.length; Hr++) {
      const si = vr[Hr];
      a(si), Te += si.length;
    }
    const Cr = new Uint8Array(Te);
    for (let Hr = 0, si = 0; Hr < vr.length; Hr++) {
      const ui = vr[Hr];
      Cr.set(ui, si), si += ui.length;
    }
    return Cr;
  }
  function xe(vr, Te) {
    if (Te !== void 0 && {}.toString.call(Te) !== "[object Object]")
      throw new Error("options should be object or undefined");
    return Object.assign(vr, Te);
  }
  class rr {
  }
  n.Hash = rr;
  function ar(vr) {
    const Te = (Hr) => vr().update(Sr(Hr)).digest(), Cr = vr();
    return Te.outputLen = Cr.outputLen, Te.blockLen = Cr.blockLen, Te.create = () => vr(), Te;
  }
  function yr(vr) {
    const Te = (Hr, si) => vr(si).update(Sr(Hr)).digest(), Cr = vr({});
    return Te.outputLen = Cr.outputLen, Te.blockLen = Cr.blockLen, Te.create = (Hr) => vr(Hr), Te;
  }
  function _r(vr) {
    const Te = (Hr, si) => vr(si).update(Sr(Hr)).digest(), Cr = vr({});
    return Te.outputLen = Cr.outputLen, Te.blockLen = Cr.blockLen, Te.create = (Hr) => vr(Hr), Te;
  }
  n.wrapConstructor = ar, n.wrapConstructorWithOpts = yr, n.wrapXOFConstructorWithOpts = _r;
  function Or(vr = 32) {
    if (c.crypto && typeof c.crypto.getRandomValues == "function")
      return c.crypto.getRandomValues(new Uint8Array(vr));
    if (c.crypto && typeof c.crypto.randomBytes == "function")
      return Uint8Array.from(c.crypto.randomBytes(vr));
    throw new Error("crypto.getRandomValues must be defined");
  }
})(utils$O);
Object.defineProperty(_md$2, "__esModule", { value: !0 });
_md$2.SHA512_IV = _md$2.SHA384_IV = _md$2.SHA224_IV = _md$2.SHA256_IV = _md$2.HashMD = void 0;
_md$2.setBigUint64 = setBigUint64$7;
_md$2.Chi = Chi$7;
_md$2.Maj = Maj$7;
const utils_ts_1$9 = utils$O;
function setBigUint64$7(n, c, u, p) {
  if (typeof n.setBigUint64 == "function")
    return n.setBigUint64(c, u, p);
  const a = BigInt(32), A = BigInt(4294967295), b = Number(u >> a & A), F = Number(u & A), le = p ? 4 : 0, L = p ? 0 : 4;
  n.setUint32(c + le, b, p), n.setUint32(c + L, F, p);
}
function Chi$7(n, c, u) {
  return n & c ^ ~n & u;
}
function Maj$7(n, c, u) {
  return n & c ^ n & u ^ c & u;
}
let HashMD$3 = class extends utils_ts_1$9.Hash {
  constructor(c, u, p, a) {
    super(), this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.blockLen = c, this.outputLen = u, this.padOffset = p, this.isLE = a, this.buffer = new Uint8Array(c), this.view = (0, utils_ts_1$9.createView)(this.buffer);
  }
  update(c) {
    (0, utils_ts_1$9.aexists)(this), c = (0, utils_ts_1$9.toBytes)(c), (0, utils_ts_1$9.abytes)(c);
    const { view: u, buffer: p, blockLen: a } = this, A = c.length;
    for (let b = 0; b < A; ) {
      const F = Math.min(a - this.pos, A - b);
      if (F === a) {
        const le = (0, utils_ts_1$9.createView)(c);
        for (; a <= A - b; b += a)
          this.process(le, b);
        continue;
      }
      p.set(c.subarray(b, b + F), this.pos), this.pos += F, b += F, this.pos === a && (this.process(u, 0), this.pos = 0);
    }
    return this.length += c.length, this.roundClean(), this;
  }
  digestInto(c) {
    (0, utils_ts_1$9.aexists)(this), (0, utils_ts_1$9.aoutput)(c, this), this.finished = !0;
    const { buffer: u, view: p, blockLen: a, isLE: A } = this;
    let { pos: b } = this;
    u[b++] = 128, (0, utils_ts_1$9.clean)(this.buffer.subarray(b)), this.padOffset > a - b && (this.process(p, 0), b = 0);
    for (let $ = b; $ < a; $++)
      u[$] = 0;
    setBigUint64$7(p, a - 8, BigInt(this.length * 8), A), this.process(p, 0);
    const F = (0, utils_ts_1$9.createView)(c), le = this.outputLen;
    if (le % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const L = le / 4, pe = this.get();
    if (L > pe.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let $ = 0; $ < L; $++)
      F.setUint32(4 * $, pe[$], A);
  }
  digest() {
    const { buffer: c, outputLen: u } = this;
    this.digestInto(c);
    const p = c.slice(0, u);
    return this.destroy(), p;
  }
  _cloneInto(c) {
    c || (c = new this.constructor()), c.set(...this.get());
    const { blockLen: u, buffer: p, length: a, finished: A, destroyed: b, pos: F } = this;
    return c.destroyed = b, c.finished = A, c.length = a, c.pos = F, a % u && c.buffer.set(p), c;
  }
  clone() {
    return this._cloneInto();
  }
};
_md$2.HashMD = HashMD$3;
_md$2.SHA256_IV = Uint32Array.from([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]);
_md$2.SHA224_IV = Uint32Array.from([
  3238371032,
  914150663,
  812702999,
  4144912697,
  4290775857,
  1750603025,
  1694076839,
  3204075428
]);
_md$2.SHA384_IV = Uint32Array.from([
  3418070365,
  3238371032,
  1654270250,
  914150663,
  2438529370,
  812702999,
  355462360,
  4144912697,
  1731405415,
  4290775857,
  2394180231,
  1750603025,
  3675008525,
  1694076839,
  1203062813,
  3204075428
]);
_md$2.SHA512_IV = Uint32Array.from([
  1779033703,
  4089235720,
  3144134277,
  2227873595,
  1013904242,
  4271175723,
  2773480762,
  1595750129,
  1359893119,
  2917565137,
  2600822924,
  725511199,
  528734635,
  4215389547,
  1541459225,
  327033209
]);
Object.defineProperty(legacy$1, "__esModule", { value: !0 });
legacy$1.ripemd160 = legacy$1.RIPEMD160 = legacy$1.md5 = legacy$1.MD5 = legacy$1.sha1 = legacy$1.SHA1 = void 0;
const _md_ts_1$2 = _md$2, utils_ts_1$8 = utils$O, SHA1_IV = /* @__PURE__ */ Uint32Array.from([
  1732584193,
  4023233417,
  2562383102,
  271733878,
  3285377520
]), SHA1_W = /* @__PURE__ */ new Uint32Array(80);
let SHA1$1 = class extends _md_ts_1$2.HashMD {
  constructor() {
    super(64, 20, 8, !1), this.A = SHA1_IV[0] | 0, this.B = SHA1_IV[1] | 0, this.C = SHA1_IV[2] | 0, this.D = SHA1_IV[3] | 0, this.E = SHA1_IV[4] | 0;
  }
  get() {
    const { A: c, B: u, C: p, D: a, E: A } = this;
    return [c, u, p, a, A];
  }
  set(c, u, p, a, A) {
    this.A = c | 0, this.B = u | 0, this.C = p | 0, this.D = a | 0, this.E = A | 0;
  }
  process(c, u) {
    for (let le = 0; le < 16; le++, u += 4)
      SHA1_W[le] = c.getUint32(u, !1);
    for (let le = 16; le < 80; le++)
      SHA1_W[le] = (0, utils_ts_1$8.rotl)(SHA1_W[le - 3] ^ SHA1_W[le - 8] ^ SHA1_W[le - 14] ^ SHA1_W[le - 16], 1);
    let { A: p, B: a, C: A, D: b, E: F } = this;
    for (let le = 0; le < 80; le++) {
      let L, pe;
      le < 20 ? (L = (0, _md_ts_1$2.Chi)(a, A, b), pe = 1518500249) : le < 40 ? (L = a ^ A ^ b, pe = 1859775393) : le < 60 ? (L = (0, _md_ts_1$2.Maj)(a, A, b), pe = 2400959708) : (L = a ^ A ^ b, pe = 3395469782);
      const $ = (0, utils_ts_1$8.rotl)(p, 5) + L + F + pe + SHA1_W[le] | 0;
      F = b, b = A, A = (0, utils_ts_1$8.rotl)(a, 30), a = p, p = $;
    }
    p = p + this.A | 0, a = a + this.B | 0, A = A + this.C | 0, b = b + this.D | 0, F = F + this.E | 0, this.set(p, a, A, b, F);
  }
  roundClean() {
    (0, utils_ts_1$8.clean)(SHA1_W);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0), (0, utils_ts_1$8.clean)(this.buffer);
  }
};
legacy$1.SHA1 = SHA1$1;
legacy$1.sha1 = (0, utils_ts_1$8.createHasher)(() => new SHA1$1());
const p32$1 = /* @__PURE__ */ Math.pow(2, 32), K$6 = /* @__PURE__ */ Array.from({ length: 64 }, (n, c) => Math.floor(p32$1 * Math.abs(Math.sin(c + 1)))), MD5_IV = /* @__PURE__ */ SHA1_IV.slice(0, 4), MD5_W = /* @__PURE__ */ new Uint32Array(16);
let MD5$2 = class extends _md_ts_1$2.HashMD {
  constructor() {
    super(64, 16, 8, !0), this.A = MD5_IV[0] | 0, this.B = MD5_IV[1] | 0, this.C = MD5_IV[2] | 0, this.D = MD5_IV[3] | 0;
  }
  get() {
    const { A: c, B: u, C: p, D: a } = this;
    return [c, u, p, a];
  }
  set(c, u, p, a) {
    this.A = c | 0, this.B = u | 0, this.C = p | 0, this.D = a | 0;
  }
  process(c, u) {
    for (let F = 0; F < 16; F++, u += 4)
      MD5_W[F] = c.getUint32(u, !0);
    let { A: p, B: a, C: A, D: b } = this;
    for (let F = 0; F < 64; F++) {
      let le, L, pe;
      F < 16 ? (le = (0, _md_ts_1$2.Chi)(a, A, b), L = F, pe = [7, 12, 17, 22]) : F < 32 ? (le = (0, _md_ts_1$2.Chi)(b, a, A), L = (5 * F + 1) % 16, pe = [5, 9, 14, 20]) : F < 48 ? (le = a ^ A ^ b, L = (3 * F + 5) % 16, pe = [4, 11, 16, 23]) : (le = A ^ (a | ~b), L = 7 * F % 16, pe = [6, 10, 15, 21]), le = le + p + K$6[F] + MD5_W[L], p = b, b = A, A = a, a = a + (0, utils_ts_1$8.rotl)(le, pe[F % 4]);
    }
    p = p + this.A | 0, a = a + this.B | 0, A = A + this.C | 0, b = b + this.D | 0, this.set(p, a, A, b);
  }
  roundClean() {
    (0, utils_ts_1$8.clean)(MD5_W);
  }
  destroy() {
    this.set(0, 0, 0, 0), (0, utils_ts_1$8.clean)(this.buffer);
  }
};
legacy$1.MD5 = MD5$2;
legacy$1.md5 = (0, utils_ts_1$8.createHasher)(() => new MD5$2());
const Rho160$1 = /* @__PURE__ */ Uint8Array.from([
  7,
  4,
  13,
  1,
  10,
  6,
  15,
  3,
  12,
  0,
  9,
  5,
  2,
  14,
  11,
  8
]), Id160$1 = Uint8Array.from(new Array(16).fill(0).map((n, c) => c)), Pi160$1 = Id160$1.map((n) => (9 * n + 5) % 16), idxLR$1 = /* @__PURE__ */ (() => {
  const u = [[Id160$1], [Pi160$1]];
  for (let p = 0; p < 4; p++)
    for (let a of u)
      a.push(a[p].map((A) => Rho160$1[A]));
  return u;
})(), idxL$3 = idxLR$1[0], idxR$3 = idxLR$1[1], shifts160$1 = /* @__PURE__ */ [
  [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8],
  [12, 13, 11, 15, 6, 9, 9, 7, 12, 15, 11, 13, 7, 8, 7, 7],
  [13, 15, 14, 11, 7, 7, 6, 8, 13, 14, 13, 12, 5, 5, 6, 9],
  [14, 11, 12, 14, 8, 6, 5, 5, 15, 12, 15, 14, 9, 9, 8, 6],
  [15, 12, 13, 13, 9, 5, 8, 6, 14, 11, 12, 11, 8, 6, 5, 5]
].map((n) => Uint8Array.from(n)), shiftsL160$1 = /* @__PURE__ */ idxL$3.map((n, c) => n.map((u) => shifts160$1[c][u])), shiftsR160$1 = /* @__PURE__ */ idxR$3.map((n, c) => n.map((u) => shifts160$1[c][u])), Kl160$1 = /* @__PURE__ */ Uint32Array.from([
  0,
  1518500249,
  1859775393,
  2400959708,
  2840853838
]), Kr160$1 = /* @__PURE__ */ Uint32Array.from([
  1352829926,
  1548603684,
  1836072691,
  2053994217,
  0
]);
function ripemd_f$1(n, c, u, p) {
  return n === 0 ? c ^ u ^ p : n === 1 ? c & u | ~c & p : n === 2 ? (c | ~u) ^ p : n === 3 ? c & p | u & ~p : c ^ (u | ~p);
}
const BUF_160$1 = /* @__PURE__ */ new Uint32Array(16);
let RIPEMD160$6 = class extends _md_ts_1$2.HashMD {
  constructor() {
    super(64, 20, 8, !0), this.h0 = 1732584193, this.h1 = -271733879, this.h2 = -1732584194, this.h3 = 271733878, this.h4 = -1009589776;
  }
  get() {
    const { h0: c, h1: u, h2: p, h3: a, h4: A } = this;
    return [c, u, p, a, A];
  }
  set(c, u, p, a, A) {
    this.h0 = c | 0, this.h1 = u | 0, this.h2 = p | 0, this.h3 = a | 0, this.h4 = A | 0;
  }
  process(c, u) {
    for (let be = 0; be < 16; be++, u += 4)
      BUF_160$1[be] = c.getUint32(u, !0);
    let p = this.h0 | 0, a = p, A = this.h1 | 0, b = A, F = this.h2 | 0, le = F, L = this.h3 | 0, pe = L, $ = this.h4 | 0, Ee = $;
    for (let be = 0; be < 5; be++) {
      const He = 4 - be, Pe = Kl160$1[be], nr = Kr160$1[be], ir = idxL$3[be], or = idxR$3[be], lr = shiftsL160$1[be], Ir = shiftsR160$1[be];
      for (let xr = 0; xr < 16; xr++) {
        const kr = (0, utils_ts_1$8.rotl)(p + ripemd_f$1(be, A, F, L) + BUF_160$1[ir[xr]] + Pe, lr[xr]) + $ | 0;
        p = $, $ = L, L = (0, utils_ts_1$8.rotl)(F, 10) | 0, F = A, A = kr;
      }
      for (let xr = 0; xr < 16; xr++) {
        const kr = (0, utils_ts_1$8.rotl)(a + ripemd_f$1(He, b, le, pe) + BUF_160$1[or[xr]] + nr, Ir[xr]) + Ee | 0;
        a = Ee, Ee = pe, pe = (0, utils_ts_1$8.rotl)(le, 10) | 0, le = b, b = kr;
      }
    }
    this.set(this.h1 + F + pe | 0, this.h2 + L + Ee | 0, this.h3 + $ + a | 0, this.h4 + p + b | 0, this.h0 + A + le | 0);
  }
  roundClean() {
    (0, utils_ts_1$8.clean)(BUF_160$1);
  }
  destroy() {
    this.destroyed = !0, (0, utils_ts_1$8.clean)(this.buffer), this.set(0, 0, 0, 0, 0);
  }
};
legacy$1.RIPEMD160 = RIPEMD160$6;
legacy$1.ripemd160 = (0, utils_ts_1$8.createHasher)(() => new RIPEMD160$6());
Object.defineProperty(ripemd160$6, "__esModule", { value: !0 });
ripemd160$6.ripemd160 = ripemd160$6.RIPEMD160 = void 0;
const legacy_ts_1$1 = legacy$1;
ripemd160$6.RIPEMD160 = legacy_ts_1$1.RIPEMD160;
ripemd160$6.ripemd160 = legacy_ts_1$1.ripemd160;
var sha1$f = {};
Object.defineProperty(sha1$f, "__esModule", { value: !0 });
sha1$f.sha1 = sha1$f.SHA1 = void 0;
const legacy_ts_1 = legacy$1;
sha1$f.SHA1 = legacy_ts_1.SHA1;
sha1$f.sha1 = legacy_ts_1.sha1;
var sha256$g = {}, sha2 = {}, _u64$1 = {};
Object.defineProperty(_u64$1, "__esModule", { value: !0 });
_u64$1.toBig = _u64$1.shrSL = _u64$1.shrSH = _u64$1.rotrSL = _u64$1.rotrSH = _u64$1.rotrBL = _u64$1.rotrBH = _u64$1.rotr32L = _u64$1.rotr32H = _u64$1.rotlSL = _u64$1.rotlSH = _u64$1.rotlBL = _u64$1.rotlBH = _u64$1.add5L = _u64$1.add5H = _u64$1.add4L = _u64$1.add4H = _u64$1.add3L = _u64$1.add3H = void 0;
_u64$1.add = add$2;
_u64$1.fromBig = fromBig$2;
_u64$1.split = split$3;
const U32_MASK64$2 = /* @__PURE__ */ BigInt(2 ** 32 - 1), _32n$2 = /* @__PURE__ */ BigInt(32);
function fromBig$2(n, c = !1) {
  return c ? { h: Number(n & U32_MASK64$2), l: Number(n >> _32n$2 & U32_MASK64$2) } : { h: Number(n >> _32n$2 & U32_MASK64$2) | 0, l: Number(n & U32_MASK64$2) | 0 };
}
function split$3(n, c = !1) {
  const u = n.length;
  let p = new Uint32Array(u), a = new Uint32Array(u);
  for (let A = 0; A < u; A++) {
    const { h: b, l: F } = fromBig$2(n[A], c);
    [p[A], a[A]] = [b, F];
  }
  return [p, a];
}
const toBig$2 = (n, c) => BigInt(n >>> 0) << _32n$2 | BigInt(c >>> 0);
_u64$1.toBig = toBig$2;
const shrSH$2 = (n, c, u) => n >>> u;
_u64$1.shrSH = shrSH$2;
const shrSL$2 = (n, c, u) => n << 32 - u | c >>> u;
_u64$1.shrSL = shrSL$2;
const rotrSH$2 = (n, c, u) => n >>> u | c << 32 - u;
_u64$1.rotrSH = rotrSH$2;
const rotrSL$2 = (n, c, u) => n << 32 - u | c >>> u;
_u64$1.rotrSL = rotrSL$2;
const rotrBH$2 = (n, c, u) => n << 64 - u | c >>> u - 32;
_u64$1.rotrBH = rotrBH$2;
const rotrBL$2 = (n, c, u) => n >>> u - 32 | c << 64 - u;
_u64$1.rotrBL = rotrBL$2;
const rotr32H$2 = (n, c) => c;
_u64$1.rotr32H = rotr32H$2;
const rotr32L$2 = (n, c) => n;
_u64$1.rotr32L = rotr32L$2;
const rotlSH$2 = (n, c, u) => n << u | c >>> 32 - u;
_u64$1.rotlSH = rotlSH$2;
const rotlSL$2 = (n, c, u) => c << u | n >>> 32 - u;
_u64$1.rotlSL = rotlSL$2;
const rotlBH$2 = (n, c, u) => c << u - 32 | n >>> 64 - u;
_u64$1.rotlBH = rotlBH$2;
const rotlBL$2 = (n, c, u) => n << u - 32 | c >>> 64 - u;
_u64$1.rotlBL = rotlBL$2;
function add$2(n, c, u, p) {
  const a = (c >>> 0) + (p >>> 0);
  return { h: n + u + (a / 2 ** 32 | 0) | 0, l: a | 0 };
}
const add3L$2 = (n, c, u) => (n >>> 0) + (c >>> 0) + (u >>> 0);
_u64$1.add3L = add3L$2;
const add3H$2 = (n, c, u, p) => c + u + p + (n / 2 ** 32 | 0) | 0;
_u64$1.add3H = add3H$2;
const add4L$2 = (n, c, u, p) => (n >>> 0) + (c >>> 0) + (u >>> 0) + (p >>> 0);
_u64$1.add4L = add4L$2;
const add4H$2 = (n, c, u, p, a) => c + u + p + a + (n / 2 ** 32 | 0) | 0;
_u64$1.add4H = add4H$2;
const add5L$2 = (n, c, u, p, a) => (n >>> 0) + (c >>> 0) + (u >>> 0) + (p >>> 0) + (a >>> 0);
_u64$1.add5L = add5L$2;
const add5H$2 = (n, c, u, p, a, A) => c + u + p + a + A + (n / 2 ** 32 | 0) | 0;
_u64$1.add5H = add5H$2;
const u64$5 = {
  fromBig: fromBig$2,
  split: split$3,
  toBig: toBig$2,
  shrSH: shrSH$2,
  shrSL: shrSL$2,
  rotrSH: rotrSH$2,
  rotrSL: rotrSL$2,
  rotrBH: rotrBH$2,
  rotrBL: rotrBL$2,
  rotr32H: rotr32H$2,
  rotr32L: rotr32L$2,
  rotlSH: rotlSH$2,
  rotlSL: rotlSL$2,
  rotlBH: rotlBH$2,
  rotlBL: rotlBL$2,
  add: add$2,
  add3L: add3L$2,
  add3H: add3H$2,
  add4L: add4L$2,
  add4H: add4H$2,
  add5H: add5H$2,
  add5L: add5L$2
};
_u64$1.default = u64$5;
Object.defineProperty(sha2, "__esModule", { value: !0 });
sha2.sha512_224 = sha2.sha512_256 = sha2.sha384 = sha2.sha512 = sha2.sha224 = sha256$f = sha2.sha256 = sha2.SHA512_256 = sha2.SHA512_224 = sha2.SHA384 = sha2.SHA512 = sha2.SHA224 = sha2.SHA256 = void 0;
const _md_ts_1$1 = _md$2, u64$4 = _u64$1, utils_ts_1$7 = utils$O, SHA256_K$7 = /* @__PURE__ */ Uint32Array.from([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), SHA256_W$7 = /* @__PURE__ */ new Uint32Array(64);
let SHA256$9 = class extends _md_ts_1$1.HashMD {
  constructor(c = 32) {
    super(64, c, 8, !1), this.A = _md_ts_1$1.SHA256_IV[0] | 0, this.B = _md_ts_1$1.SHA256_IV[1] | 0, this.C = _md_ts_1$1.SHA256_IV[2] | 0, this.D = _md_ts_1$1.SHA256_IV[3] | 0, this.E = _md_ts_1$1.SHA256_IV[4] | 0, this.F = _md_ts_1$1.SHA256_IV[5] | 0, this.G = _md_ts_1$1.SHA256_IV[6] | 0, this.H = _md_ts_1$1.SHA256_IV[7] | 0;
  }
  get() {
    const { A: c, B: u, C: p, D: a, E: A, F: b, G: F, H: le } = this;
    return [c, u, p, a, A, b, F, le];
  }
  // prettier-ignore
  set(c, u, p, a, A, b, F, le) {
    this.A = c | 0, this.B = u | 0, this.C = p | 0, this.D = a | 0, this.E = A | 0, this.F = b | 0, this.G = F | 0, this.H = le | 0;
  }
  process(c, u) {
    for (let $ = 0; $ < 16; $++, u += 4)
      SHA256_W$7[$] = c.getUint32(u, !1);
    for (let $ = 16; $ < 64; $++) {
      const Ee = SHA256_W$7[$ - 15], be = SHA256_W$7[$ - 2], He = (0, utils_ts_1$7.rotr)(Ee, 7) ^ (0, utils_ts_1$7.rotr)(Ee, 18) ^ Ee >>> 3, Pe = (0, utils_ts_1$7.rotr)(be, 17) ^ (0, utils_ts_1$7.rotr)(be, 19) ^ be >>> 10;
      SHA256_W$7[$] = Pe + SHA256_W$7[$ - 7] + He + SHA256_W$7[$ - 16] | 0;
    }
    let { A: p, B: a, C: A, D: b, E: F, F: le, G: L, H: pe } = this;
    for (let $ = 0; $ < 64; $++) {
      const Ee = (0, utils_ts_1$7.rotr)(F, 6) ^ (0, utils_ts_1$7.rotr)(F, 11) ^ (0, utils_ts_1$7.rotr)(F, 25), be = pe + Ee + (0, _md_ts_1$1.Chi)(F, le, L) + SHA256_K$7[$] + SHA256_W$7[$] | 0, Pe = ((0, utils_ts_1$7.rotr)(p, 2) ^ (0, utils_ts_1$7.rotr)(p, 13) ^ (0, utils_ts_1$7.rotr)(p, 22)) + (0, _md_ts_1$1.Maj)(p, a, A) | 0;
      pe = L, L = le, le = F, F = b + be | 0, b = A, A = a, a = p, p = be + Pe | 0;
    }
    p = p + this.A | 0, a = a + this.B | 0, A = A + this.C | 0, b = b + this.D | 0, F = F + this.E | 0, le = le + this.F | 0, L = L + this.G | 0, pe = pe + this.H | 0, this.set(p, a, A, b, F, le, L, pe);
  }
  roundClean() {
    (0, utils_ts_1$7.clean)(SHA256_W$7);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), (0, utils_ts_1$7.clean)(this.buffer);
  }
};
sha2.SHA256 = SHA256$9;
let SHA224$5 = class extends SHA256$9 {
  constructor() {
    super(28), this.A = _md_ts_1$1.SHA224_IV[0] | 0, this.B = _md_ts_1$1.SHA224_IV[1] | 0, this.C = _md_ts_1$1.SHA224_IV[2] | 0, this.D = _md_ts_1$1.SHA224_IV[3] | 0, this.E = _md_ts_1$1.SHA224_IV[4] | 0, this.F = _md_ts_1$1.SHA224_IV[5] | 0, this.G = _md_ts_1$1.SHA224_IV[6] | 0, this.H = _md_ts_1$1.SHA224_IV[7] | 0;
  }
};
sha2.SHA224 = SHA224$5;
const K512 = u64$4.split([
  "0x428a2f98d728ae22",
  "0x7137449123ef65cd",
  "0xb5c0fbcfec4d3b2f",
  "0xe9b5dba58189dbbc",
  "0x3956c25bf348b538",
  "0x59f111f1b605d019",
  "0x923f82a4af194f9b",
  "0xab1c5ed5da6d8118",
  "0xd807aa98a3030242",
  "0x12835b0145706fbe",
  "0x243185be4ee4b28c",
  "0x550c7dc3d5ffb4e2",
  "0x72be5d74f27b896f",
  "0x80deb1fe3b1696b1",
  "0x9bdc06a725c71235",
  "0xc19bf174cf692694",
  "0xe49b69c19ef14ad2",
  "0xefbe4786384f25e3",
  "0x0fc19dc68b8cd5b5",
  "0x240ca1cc77ac9c65",
  "0x2de92c6f592b0275",
  "0x4a7484aa6ea6e483",
  "0x5cb0a9dcbd41fbd4",
  "0x76f988da831153b5",
  "0x983e5152ee66dfab",
  "0xa831c66d2db43210",
  "0xb00327c898fb213f",
  "0xbf597fc7beef0ee4",
  "0xc6e00bf33da88fc2",
  "0xd5a79147930aa725",
  "0x06ca6351e003826f",
  "0x142929670a0e6e70",
  "0x27b70a8546d22ffc",
  "0x2e1b21385c26c926",
  "0x4d2c6dfc5ac42aed",
  "0x53380d139d95b3df",
  "0x650a73548baf63de",
  "0x766a0abb3c77b2a8",
  "0x81c2c92e47edaee6",
  "0x92722c851482353b",
  "0xa2bfe8a14cf10364",
  "0xa81a664bbc423001",
  "0xc24b8b70d0f89791",
  "0xc76c51a30654be30",
  "0xd192e819d6ef5218",
  "0xd69906245565a910",
  "0xf40e35855771202a",
  "0x106aa07032bbd1b8",
  "0x19a4c116b8d2d0c8",
  "0x1e376c085141ab53",
  "0x2748774cdf8eeb99",
  "0x34b0bcb5e19b48a8",
  "0x391c0cb3c5c95a63",
  "0x4ed8aa4ae3418acb",
  "0x5b9cca4f7763e373",
  "0x682e6ff3d6b2b8a3",
  "0x748f82ee5defb2fc",
  "0x78a5636f43172f60",
  "0x84c87814a1f0ab72",
  "0x8cc702081a6439ec",
  "0x90befffa23631e28",
  "0xa4506cebde82bde9",
  "0xbef9a3f7b2c67915",
  "0xc67178f2e372532b",
  "0xca273eceea26619c",
  "0xd186b8c721c0c207",
  "0xeada7dd6cde0eb1e",
  "0xf57d4f7fee6ed178",
  "0x06f067aa72176fba",
  "0x0a637dc5a2c898a6",
  "0x113f9804bef90dae",
  "0x1b710b35131c471b",
  "0x28db77f523047d84",
  "0x32caab7b40c72493",
  "0x3c9ebe0a15c9bebc",
  "0x431d67c49c100d4c",
  "0x4cc5d4becb3e42b6",
  "0x597f299cfc657e2a",
  "0x5fcb6fab3ad6faec",
  "0x6c44198c4a475817"
].map((n) => BigInt(n))), SHA512_Kh$2 = K512[0], SHA512_Kl$2 = K512[1], SHA512_W_H$2 = /* @__PURE__ */ new Uint32Array(80), SHA512_W_L$2 = /* @__PURE__ */ new Uint32Array(80);
let SHA512$5 = class extends _md_ts_1$1.HashMD {
  constructor(c = 64) {
    super(128, c, 16, !1), this.Ah = _md_ts_1$1.SHA512_IV[0] | 0, this.Al = _md_ts_1$1.SHA512_IV[1] | 0, this.Bh = _md_ts_1$1.SHA512_IV[2] | 0, this.Bl = _md_ts_1$1.SHA512_IV[3] | 0, this.Ch = _md_ts_1$1.SHA512_IV[4] | 0, this.Cl = _md_ts_1$1.SHA512_IV[5] | 0, this.Dh = _md_ts_1$1.SHA512_IV[6] | 0, this.Dl = _md_ts_1$1.SHA512_IV[7] | 0, this.Eh = _md_ts_1$1.SHA512_IV[8] | 0, this.El = _md_ts_1$1.SHA512_IV[9] | 0, this.Fh = _md_ts_1$1.SHA512_IV[10] | 0, this.Fl = _md_ts_1$1.SHA512_IV[11] | 0, this.Gh = _md_ts_1$1.SHA512_IV[12] | 0, this.Gl = _md_ts_1$1.SHA512_IV[13] | 0, this.Hh = _md_ts_1$1.SHA512_IV[14] | 0, this.Hl = _md_ts_1$1.SHA512_IV[15] | 0;
  }
  // prettier-ignore
  get() {
    const { Ah: c, Al: u, Bh: p, Bl: a, Ch: A, Cl: b, Dh: F, Dl: le, Eh: L, El: pe, Fh: $, Fl: Ee, Gh: be, Gl: He, Hh: Pe, Hl: nr } = this;
    return [c, u, p, a, A, b, F, le, L, pe, $, Ee, be, He, Pe, nr];
  }
  // prettier-ignore
  set(c, u, p, a, A, b, F, le, L, pe, $, Ee, be, He, Pe, nr) {
    this.Ah = c | 0, this.Al = u | 0, this.Bh = p | 0, this.Bl = a | 0, this.Ch = A | 0, this.Cl = b | 0, this.Dh = F | 0, this.Dl = le | 0, this.Eh = L | 0, this.El = pe | 0, this.Fh = $ | 0, this.Fl = Ee | 0, this.Gh = be | 0, this.Gl = He | 0, this.Hh = Pe | 0, this.Hl = nr | 0;
  }
  process(c, u) {
    for (let lr = 0; lr < 16; lr++, u += 4)
      SHA512_W_H$2[lr] = c.getUint32(u), SHA512_W_L$2[lr] = c.getUint32(u += 4);
    for (let lr = 16; lr < 80; lr++) {
      const Ir = SHA512_W_H$2[lr - 15] | 0, xr = SHA512_W_L$2[lr - 15] | 0, kr = u64$4.rotrSH(Ir, xr, 1) ^ u64$4.rotrSH(Ir, xr, 8) ^ u64$4.shrSH(Ir, xr, 7), Ce = u64$4.rotrSL(Ir, xr, 1) ^ u64$4.rotrSL(Ir, xr, 8) ^ u64$4.shrSL(Ir, xr, 7), tr = SHA512_W_H$2[lr - 2] | 0, Fe = SHA512_W_L$2[lr - 2] | 0, Sr = u64$4.rotrSH(tr, Fe, 19) ^ u64$4.rotrBH(tr, Fe, 61) ^ u64$4.shrSH(tr, Fe, 6), er = u64$4.rotrSL(tr, Fe, 19) ^ u64$4.rotrBL(tr, Fe, 61) ^ u64$4.shrSL(tr, Fe, 6), Ie = u64$4.add4L(Ce, er, SHA512_W_L$2[lr - 7], SHA512_W_L$2[lr - 16]), xe = u64$4.add4H(Ie, kr, Sr, SHA512_W_H$2[lr - 7], SHA512_W_H$2[lr - 16]);
      SHA512_W_H$2[lr] = xe | 0, SHA512_W_L$2[lr] = Ie | 0;
    }
    let { Ah: p, Al: a, Bh: A, Bl: b, Ch: F, Cl: le, Dh: L, Dl: pe, Eh: $, El: Ee, Fh: be, Fl: He, Gh: Pe, Gl: nr, Hh: ir, Hl: or } = this;
    for (let lr = 0; lr < 80; lr++) {
      const Ir = u64$4.rotrSH($, Ee, 14) ^ u64$4.rotrSH($, Ee, 18) ^ u64$4.rotrBH($, Ee, 41), xr = u64$4.rotrSL($, Ee, 14) ^ u64$4.rotrSL($, Ee, 18) ^ u64$4.rotrBL($, Ee, 41), kr = $ & be ^ ~$ & Pe, Ce = Ee & He ^ ~Ee & nr, tr = u64$4.add5L(or, xr, Ce, SHA512_Kl$2[lr], SHA512_W_L$2[lr]), Fe = u64$4.add5H(tr, ir, Ir, kr, SHA512_Kh$2[lr], SHA512_W_H$2[lr]), Sr = tr | 0, er = u64$4.rotrSH(p, a, 28) ^ u64$4.rotrBH(p, a, 34) ^ u64$4.rotrBH(p, a, 39), Ie = u64$4.rotrSL(p, a, 28) ^ u64$4.rotrBL(p, a, 34) ^ u64$4.rotrBL(p, a, 39), xe = p & A ^ p & F ^ A & F, rr = a & b ^ a & le ^ b & le;
      ir = Pe | 0, or = nr | 0, Pe = be | 0, nr = He | 0, be = $ | 0, He = Ee | 0, { h: $, l: Ee } = u64$4.add(L | 0, pe | 0, Fe | 0, Sr | 0), L = F | 0, pe = le | 0, F = A | 0, le = b | 0, A = p | 0, b = a | 0;
      const ar = u64$4.add3L(Sr, Ie, rr);
      p = u64$4.add3H(ar, Fe, er, xe), a = ar | 0;
    }
    ({ h: p, l: a } = u64$4.add(this.Ah | 0, this.Al | 0, p | 0, a | 0)), { h: A, l: b } = u64$4.add(this.Bh | 0, this.Bl | 0, A | 0, b | 0), { h: F, l: le } = u64$4.add(this.Ch | 0, this.Cl | 0, F | 0, le | 0), { h: L, l: pe } = u64$4.add(this.Dh | 0, this.Dl | 0, L | 0, pe | 0), { h: $, l: Ee } = u64$4.add(this.Eh | 0, this.El | 0, $ | 0, Ee | 0), { h: be, l: He } = u64$4.add(this.Fh | 0, this.Fl | 0, be | 0, He | 0), { h: Pe, l: nr } = u64$4.add(this.Gh | 0, this.Gl | 0, Pe | 0, nr | 0), { h: ir, l: or } = u64$4.add(this.Hh | 0, this.Hl | 0, ir | 0, or | 0), this.set(p, a, A, b, F, le, L, pe, $, Ee, be, He, Pe, nr, ir, or);
  }
  roundClean() {
    (0, utils_ts_1$7.clean)(SHA512_W_H$2, SHA512_W_L$2);
  }
  destroy() {
    (0, utils_ts_1$7.clean)(this.buffer), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
  }
};
sha2.SHA512 = SHA512$5;
let SHA384$2 = class extends SHA512$5 {
  constructor() {
    super(48), this.Ah = _md_ts_1$1.SHA384_IV[0] | 0, this.Al = _md_ts_1$1.SHA384_IV[1] | 0, this.Bh = _md_ts_1$1.SHA384_IV[2] | 0, this.Bl = _md_ts_1$1.SHA384_IV[3] | 0, this.Ch = _md_ts_1$1.SHA384_IV[4] | 0, this.Cl = _md_ts_1$1.SHA384_IV[5] | 0, this.Dh = _md_ts_1$1.SHA384_IV[6] | 0, this.Dl = _md_ts_1$1.SHA384_IV[7] | 0, this.Eh = _md_ts_1$1.SHA384_IV[8] | 0, this.El = _md_ts_1$1.SHA384_IV[9] | 0, this.Fh = _md_ts_1$1.SHA384_IV[10] | 0, this.Fl = _md_ts_1$1.SHA384_IV[11] | 0, this.Gh = _md_ts_1$1.SHA384_IV[12] | 0, this.Gl = _md_ts_1$1.SHA384_IV[13] | 0, this.Hh = _md_ts_1$1.SHA384_IV[14] | 0, this.Hl = _md_ts_1$1.SHA384_IV[15] | 0;
  }
};
sha2.SHA384 = SHA384$2;
const T224_IV = /* @__PURE__ */ Uint32Array.from([
  2352822216,
  424955298,
  1944164710,
  2312950998,
  502970286,
  855612546,
  1738396948,
  1479516111,
  258812777,
  2077511080,
  2011393907,
  79989058,
  1067287976,
  1780299464,
  286451373,
  2446758561
]), T256_IV = /* @__PURE__ */ Uint32Array.from([
  573645204,
  4230739756,
  2673172387,
  3360449730,
  596883563,
  1867755857,
  2520282905,
  1497426621,
  2519219938,
  2827943907,
  3193839141,
  1401305490,
  721525244,
  746961066,
  246885852,
  2177182882
]);
let SHA512_224$1 = class extends SHA512$5 {
  constructor() {
    super(28), this.Ah = T224_IV[0] | 0, this.Al = T224_IV[1] | 0, this.Bh = T224_IV[2] | 0, this.Bl = T224_IV[3] | 0, this.Ch = T224_IV[4] | 0, this.Cl = T224_IV[5] | 0, this.Dh = T224_IV[6] | 0, this.Dl = T224_IV[7] | 0, this.Eh = T224_IV[8] | 0, this.El = T224_IV[9] | 0, this.Fh = T224_IV[10] | 0, this.Fl = T224_IV[11] | 0, this.Gh = T224_IV[12] | 0, this.Gl = T224_IV[13] | 0, this.Hh = T224_IV[14] | 0, this.Hl = T224_IV[15] | 0;
  }
};
sha2.SHA512_224 = SHA512_224$1;
let SHA512_256$1 = class extends SHA512$5 {
  constructor() {
    super(32), this.Ah = T256_IV[0] | 0, this.Al = T256_IV[1] | 0, this.Bh = T256_IV[2] | 0, this.Bl = T256_IV[3] | 0, this.Ch = T256_IV[4] | 0, this.Cl = T256_IV[5] | 0, this.Dh = T256_IV[6] | 0, this.Dl = T256_IV[7] | 0, this.Eh = T256_IV[8] | 0, this.El = T256_IV[9] | 0, this.Fh = T256_IV[10] | 0, this.Fl = T256_IV[11] | 0, this.Gh = T256_IV[12] | 0, this.Gl = T256_IV[13] | 0, this.Hh = T256_IV[14] | 0, this.Hl = T256_IV[15] | 0;
  }
};
sha2.SHA512_256 = SHA512_256$1;
var sha256$f = sha2.sha256 = (0, utils_ts_1$7.createHasher)(() => new SHA256$9());
sha2.sha224 = (0, utils_ts_1$7.createHasher)(() => new SHA224$5());
sha2.sha512 = (0, utils_ts_1$7.createHasher)(() => new SHA512$5());
sha2.sha384 = (0, utils_ts_1$7.createHasher)(() => new SHA384$2());
sha2.sha512_256 = (0, utils_ts_1$7.createHasher)(() => new SHA512_256$1());
sha2.sha512_224 = (0, utils_ts_1$7.createHasher)(() => new SHA512_224$1());
Object.defineProperty(sha256$g, "__esModule", { value: !0 });
sha256$g.sha224 = sha256$g.SHA224 = sha256$g.sha256 = sha256$g.SHA256 = void 0;
const sha2_ts_1$1 = sha2;
sha256$g.SHA256 = sha2_ts_1$1.SHA256;
sha256$g.sha256 = sha2_ts_1$1.sha256;
sha256$g.SHA224 = sha2_ts_1$1.SHA224;
sha256$g.sha224 = sha2_ts_1$1.sha224;
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.taggedHash = n.TAGGED_HASH_PREFIXES = n.TAGS = n.hash256 = n.hash160 = n.sha256 = n.sha1 = n.ripemd160 = void 0;
  const c = ripemd160$6, u = sha1$f, p = sha256$g;
  function a(pe) {
    return Buffer$f.from((0, c.ripemd160)(Uint8Array.from(pe)));
  }
  n.ripemd160 = a;
  function A(pe) {
    return Buffer$f.from((0, u.sha1)(Uint8Array.from(pe)));
  }
  n.sha1 = A;
  function b(pe) {
    return Buffer$f.from((0, p.sha256)(Uint8Array.from(pe)));
  }
  n.sha256 = b;
  function F(pe) {
    return Buffer$f.from(
      (0, c.ripemd160)((0, p.sha256)(Uint8Array.from(pe)))
    );
  }
  n.hash160 = F;
  function le(pe) {
    return Buffer$f.from(
      (0, p.sha256)((0, p.sha256)(Uint8Array.from(pe)))
    );
  }
  n.hash256 = le, n.TAGS = [
    "BIP0340/challenge",
    "BIP0340/aux",
    "BIP0340/nonce",
    "TapLeaf",
    "TapBranch",
    "TapSighash",
    "TapTweak",
    "KeyAgg list",
    "KeyAgg coefficient"
  ], n.TAGGED_HASH_PREFIXES = {
    "BIP0340/challenge": Buffer$f.from([
      123,
      181,
      45,
      122,
      159,
      239,
      88,
      50,
      62,
      177,
      191,
      122,
      64,
      125,
      179,
      130,
      210,
      243,
      242,
      216,
      27,
      177,
      34,
      79,
      73,
      254,
      81,
      143,
      109,
      72,
      211,
      124,
      123,
      181,
      45,
      122,
      159,
      239,
      88,
      50,
      62,
      177,
      191,
      122,
      64,
      125,
      179,
      130,
      210,
      243,
      242,
      216,
      27,
      177,
      34,
      79,
      73,
      254,
      81,
      143,
      109,
      72,
      211,
      124
    ]),
    "BIP0340/aux": Buffer$f.from([
      241,
      239,
      78,
      94,
      192,
      99,
      202,
      218,
      109,
      148,
      202,
      250,
      157,
      152,
      126,
      160,
      105,
      38,
      88,
      57,
      236,
      193,
      31,
      151,
      45,
      119,
      165,
      46,
      216,
      193,
      204,
      144,
      241,
      239,
      78,
      94,
      192,
      99,
      202,
      218,
      109,
      148,
      202,
      250,
      157,
      152,
      126,
      160,
      105,
      38,
      88,
      57,
      236,
      193,
      31,
      151,
      45,
      119,
      165,
      46,
      216,
      193,
      204,
      144
    ]),
    "BIP0340/nonce": Buffer$f.from([
      7,
      73,
      119,
      52,
      167,
      155,
      203,
      53,
      91,
      155,
      140,
      125,
      3,
      79,
      18,
      28,
      244,
      52,
      215,
      62,
      247,
      45,
      218,
      25,
      135,
      0,
      97,
      251,
      82,
      191,
      235,
      47,
      7,
      73,
      119,
      52,
      167,
      155,
      203,
      53,
      91,
      155,
      140,
      125,
      3,
      79,
      18,
      28,
      244,
      52,
      215,
      62,
      247,
      45,
      218,
      25,
      135,
      0,
      97,
      251,
      82,
      191,
      235,
      47
    ]),
    TapLeaf: Buffer$f.from([
      174,
      234,
      143,
      220,
      66,
      8,
      152,
      49,
      5,
      115,
      75,
      88,
      8,
      29,
      30,
      38,
      56,
      211,
      95,
      28,
      181,
      64,
      8,
      212,
      211,
      87,
      202,
      3,
      190,
      120,
      233,
      238,
      174,
      234,
      143,
      220,
      66,
      8,
      152,
      49,
      5,
      115,
      75,
      88,
      8,
      29,
      30,
      38,
      56,
      211,
      95,
      28,
      181,
      64,
      8,
      212,
      211,
      87,
      202,
      3,
      190,
      120,
      233,
      238
    ]),
    TapBranch: Buffer$f.from([
      25,
      65,
      161,
      242,
      229,
      110,
      185,
      95,
      162,
      169,
      241,
      148,
      190,
      92,
      1,
      247,
      33,
      111,
      51,
      237,
      130,
      176,
      145,
      70,
      52,
      144,
      208,
      91,
      245,
      22,
      160,
      21,
      25,
      65,
      161,
      242,
      229,
      110,
      185,
      95,
      162,
      169,
      241,
      148,
      190,
      92,
      1,
      247,
      33,
      111,
      51,
      237,
      130,
      176,
      145,
      70,
      52,
      144,
      208,
      91,
      245,
      22,
      160,
      21
    ]),
    TapSighash: Buffer$f.from([
      244,
      10,
      72,
      223,
      75,
      42,
      112,
      200,
      180,
      146,
      75,
      242,
      101,
      70,
      97,
      237,
      61,
      149,
      253,
      102,
      163,
      19,
      235,
      135,
      35,
      117,
      151,
      198,
      40,
      228,
      160,
      49,
      244,
      10,
      72,
      223,
      75,
      42,
      112,
      200,
      180,
      146,
      75,
      242,
      101,
      70,
      97,
      237,
      61,
      149,
      253,
      102,
      163,
      19,
      235,
      135,
      35,
      117,
      151,
      198,
      40,
      228,
      160,
      49
    ]),
    TapTweak: Buffer$f.from([
      232,
      15,
      225,
      99,
      156,
      156,
      160,
      80,
      227,
      175,
      27,
      57,
      193,
      67,
      198,
      62,
      66,
      156,
      188,
      235,
      21,
      217,
      64,
      251,
      181,
      197,
      161,
      244,
      175,
      87,
      197,
      233,
      232,
      15,
      225,
      99,
      156,
      156,
      160,
      80,
      227,
      175,
      27,
      57,
      193,
      67,
      198,
      62,
      66,
      156,
      188,
      235,
      21,
      217,
      64,
      251,
      181,
      197,
      161,
      244,
      175,
      87,
      197,
      233
    ]),
    "KeyAgg list": Buffer$f.from([
      72,
      28,
      151,
      28,
      60,
      11,
      70,
      215,
      240,
      178,
      117,
      174,
      89,
      141,
      78,
      44,
      126,
      215,
      49,
      156,
      89,
      74,
      92,
      110,
      199,
      158,
      160,
      212,
      153,
      2,
      148,
      240,
      72,
      28,
      151,
      28,
      60,
      11,
      70,
      215,
      240,
      178,
      117,
      174,
      89,
      141,
      78,
      44,
      126,
      215,
      49,
      156,
      89,
      74,
      92,
      110,
      199,
      158,
      160,
      212,
      153,
      2,
      148,
      240
    ]),
    "KeyAgg coefficient": Buffer$f.from([
      191,
      201,
      4,
      3,
      77,
      28,
      136,
      232,
      200,
      14,
      34,
      229,
      61,
      36,
      86,
      109,
      100,
      130,
      78,
      214,
      66,
      114,
      129,
      192,
      145,
      0,
      249,
      77,
      205,
      82,
      201,
      129,
      191,
      201,
      4,
      3,
      77,
      28,
      136,
      232,
      200,
      14,
      34,
      229,
      61,
      36,
      86,
      109,
      100,
      130,
      78,
      214,
      66,
      114,
      129,
      192,
      145,
      0,
      249,
      77,
      205,
      82,
      201,
      129
    ])
  };
  function L(pe, $) {
    return b(Buffer$f.concat([n.TAGGED_HASH_PREFIXES[pe], $]));
  }
  n.taggedHash = L;
})(crypto$9);
function base$l(n) {
  if (n.length >= 255)
    throw new TypeError("Alphabet too long");
  for (var c = new Uint8Array(256), u = 0; u < c.length; u++)
    c[u] = 255;
  for (var p = 0; p < n.length; p++) {
    var a = n.charAt(p), A = a.charCodeAt(0);
    if (c[A] !== 255)
      throw new TypeError(a + " is ambiguous");
    c[A] = p;
  }
  var b = n.length, F = n.charAt(0), le = Math.log(b) / Math.log(256), L = Math.log(256) / Math.log(b);
  function pe(be) {
    if (be instanceof Uint8Array || (ArrayBuffer.isView(be) ? be = new Uint8Array(be.buffer, be.byteOffset, be.byteLength) : Array.isArray(be) && (be = Uint8Array.from(be))), !(be instanceof Uint8Array))
      throw new TypeError("Expected Uint8Array");
    if (be.length === 0)
      return "";
    for (var He = 0, Pe = 0, nr = 0, ir = be.length; nr !== ir && be[nr] === 0; )
      nr++, He++;
    for (var or = (ir - nr) * L + 1 >>> 0, lr = new Uint8Array(or); nr !== ir; ) {
      for (var Ir = be[nr], xr = 0, kr = or - 1; (Ir !== 0 || xr < Pe) && kr !== -1; kr--, xr++)
        Ir += 256 * lr[kr] >>> 0, lr[kr] = Ir % b >>> 0, Ir = Ir / b >>> 0;
      if (Ir !== 0)
        throw new Error("Non-zero carry");
      Pe = xr, nr++;
    }
    for (var Ce = or - Pe; Ce !== or && lr[Ce] === 0; )
      Ce++;
    for (var tr = F.repeat(He); Ce < or; ++Ce)
      tr += n.charAt(lr[Ce]);
    return tr;
  }
  function $(be) {
    if (typeof be != "string")
      throw new TypeError("Expected String");
    if (be.length === 0)
      return new Uint8Array();
    for (var He = 0, Pe = 0, nr = 0; be[He] === F; )
      Pe++, He++;
    for (var ir = (be.length - He) * le + 1 >>> 0, or = new Uint8Array(ir); be[He]; ) {
      var lr = be.charCodeAt(He);
      if (lr > 255)
        return;
      var Ir = c[lr];
      if (Ir === 255)
        return;
      for (var xr = 0, kr = ir - 1; (Ir !== 0 || xr < nr) && kr !== -1; kr--, xr++)
        Ir += b * or[kr] >>> 0, or[kr] = Ir % 256 >>> 0, Ir = Ir / 256 >>> 0;
      if (Ir !== 0)
        throw new Error("Non-zero carry");
      nr = xr, He++;
    }
    for (var Ce = ir - nr; Ce !== ir && or[Ce] === 0; )
      Ce++;
    for (var tr = new Uint8Array(Pe + (ir - Ce)), Fe = Pe; Ce !== ir; )
      tr[Fe++] = or[Ce++];
    return tr;
  }
  function Ee(be) {
    var He = $(be);
    if (He)
      return He;
    throw new Error("Non-base" + b + " character");
  }
  return {
    encode: pe,
    decodeUnsafe: $,
    decode: Ee
  };
}
var src$i = base$l;
const basex$2 = src$i, ALPHABET$4 = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
var bs58$f = basex$2(ALPHABET$4), base58$4 = bs58$f, base$k = function(n) {
  function c(A) {
    var b = Uint8Array.from(A), F = n(b), le = b.length + 4, L = new Uint8Array(le);
    return L.set(b, 0), L.set(F.subarray(0, 4), b.length), base58$4.encode(L, le);
  }
  function u(A) {
    var b = A.slice(0, -4), F = A.slice(-4), le = n(b);
    if (!(F[0] ^ le[0] | F[1] ^ le[1] | F[2] ^ le[2] | F[3] ^ le[3]))
      return b;
  }
  function p(A) {
    var b = base58$4.decodeUnsafe(A);
    if (b)
      return u(b);
  }
  function a(A) {
    var b = base58$4.decode(A), F = u(b);
    if (!F) throw new Error("Invalid checksum");
    return F;
  }
  return {
    encode: c,
    decode: a,
    decodeUnsafe: p
  };
}, { sha256: sha256$e } = sha256$g, bs58checkBase$2 = base$k;
function sha256x2$3(n) {
  return sha256$e(sha256$e(n));
}
var bs58check$k = bs58checkBase$2(sha256x2$3);
Object.defineProperty(p2pkh$3, "__esModule", { value: !0 });
p2pkh$3.p2pkh = void 0;
const bcrypto$5 = crypto$9, networks_1$5 = networks$3, bscript$8 = script$1, types_1$d = types$p, lazy$4 = lazy$8, bs58check$j = bs58check$k, OPS$4 = bscript$8.OPS;
function p2pkh$2(n, c) {
  if (!n.address && !n.hash && !n.output && !n.pubkey && !n.input)
    throw new TypeError("Not enough data");
  c = Object.assign({ validate: !0 }, c || {}), (0, types_1$d.typeforce)(
    {
      network: types_1$d.typeforce.maybe(types_1$d.typeforce.Object),
      address: types_1$d.typeforce.maybe(types_1$d.typeforce.String),
      hash: types_1$d.typeforce.maybe(types_1$d.typeforce.BufferN(20)),
      output: types_1$d.typeforce.maybe(types_1$d.typeforce.BufferN(25)),
      pubkey: types_1$d.typeforce.maybe(types_1$d.isPoint),
      signature: types_1$d.typeforce.maybe(bscript$8.isCanonicalScriptSignature),
      input: types_1$d.typeforce.maybe(types_1$d.typeforce.Buffer)
    },
    n
  );
  const u = lazy$4.value(() => {
    const b = Buffer$f.from(bs58check$j.decode(n.address)), F = b.readUInt8(0), le = b.slice(1);
    return { version: F, hash: le };
  }), p = lazy$4.value(() => bscript$8.decompile(n.input)), a = n.network || networks_1$5.bitcoin, A = { name: "p2pkh", network: a };
  if (lazy$4.prop(A, "address", () => {
    if (!A.hash) return;
    const b = Buffer$f.allocUnsafe(21);
    return b.writeUInt8(a.pubKeyHash, 0), A.hash.copy(b, 1), bs58check$j.encode(b);
  }), lazy$4.prop(A, "hash", () => {
    if (n.output) return n.output.slice(3, 23);
    if (n.address) return u().hash;
    if (n.pubkey || A.pubkey) return bcrypto$5.hash160(n.pubkey || A.pubkey);
  }), lazy$4.prop(A, "output", () => {
    if (A.hash)
      return bscript$8.compile([
        OPS$4.OP_DUP,
        OPS$4.OP_HASH160,
        A.hash,
        OPS$4.OP_EQUALVERIFY,
        OPS$4.OP_CHECKSIG
      ]);
  }), lazy$4.prop(A, "pubkey", () => {
    if (n.input)
      return p()[1];
  }), lazy$4.prop(A, "signature", () => {
    if (n.input)
      return p()[0];
  }), lazy$4.prop(A, "input", () => {
    if (n.pubkey && n.signature)
      return bscript$8.compile([n.signature, n.pubkey]);
  }), lazy$4.prop(A, "witness", () => {
    if (A.input)
      return [];
  }), c.validate) {
    let b = Buffer$f.from([]);
    if (n.address) {
      if (u().version !== a.pubKeyHash)
        throw new TypeError("Invalid version or Network mismatch");
      if (u().hash.length !== 20) throw new TypeError("Invalid address");
      b = u().hash;
    }
    if (n.hash) {
      if (b.length > 0 && !b.equals(n.hash))
        throw new TypeError("Hash mismatch");
      b = n.hash;
    }
    if (n.output) {
      if (n.output.length !== 25 || n.output[0] !== OPS$4.OP_DUP || n.output[1] !== OPS$4.OP_HASH160 || n.output[2] !== 20 || n.output[23] !== OPS$4.OP_EQUALVERIFY || n.output[24] !== OPS$4.OP_CHECKSIG)
        throw new TypeError("Output is invalid");
      const F = n.output.slice(3, 23);
      if (b.length > 0 && !b.equals(F))
        throw new TypeError("Hash mismatch");
      b = F;
    }
    if (n.pubkey) {
      const F = bcrypto$5.hash160(n.pubkey);
      if (b.length > 0 && !b.equals(F))
        throw new TypeError("Hash mismatch");
      b = F;
    }
    if (n.input) {
      const F = p();
      if (F.length !== 2) throw new TypeError("Input is invalid");
      if (!bscript$8.isCanonicalScriptSignature(F[0]))
        throw new TypeError("Input has invalid signature");
      if (!(0, types_1$d.isPoint)(F[1]))
        throw new TypeError("Input has invalid pubkey");
      if (n.signature && !n.signature.equals(F[0]))
        throw new TypeError("Signature mismatch");
      if (n.pubkey && !n.pubkey.equals(F[1]))
        throw new TypeError("Pubkey mismatch");
      const le = bcrypto$5.hash160(F[1]);
      if (b.length > 0 && !b.equals(le))
        throw new TypeError("Hash mismatch");
    }
  }
  return Object.assign(A, n);
}
p2pkh$3.p2pkh = p2pkh$2;
var p2sh$3 = {};
Object.defineProperty(p2sh$3, "__esModule", { value: !0 });
p2sh$3.p2sh = void 0;
const bcrypto$4 = crypto$9, networks_1$4 = networks$3, bscript$7 = script$1, types_1$c = types$p, lazy$3 = lazy$8, bs58check$i = bs58check$k, OPS$3 = bscript$7.OPS;
function stacksEqual$2(n, c) {
  return n.length !== c.length ? !1 : n.every((u, p) => u.equals(c[p]));
}
function p2sh$2(n, c) {
  if (!n.address && !n.hash && !n.output && !n.redeem && !n.input)
    throw new TypeError("Not enough data");
  c = Object.assign({ validate: !0 }, c || {}), (0, types_1$c.typeforce)(
    {
      network: types_1$c.typeforce.maybe(types_1$c.typeforce.Object),
      address: types_1$c.typeforce.maybe(types_1$c.typeforce.String),
      hash: types_1$c.typeforce.maybe(types_1$c.typeforce.BufferN(20)),
      output: types_1$c.typeforce.maybe(types_1$c.typeforce.BufferN(23)),
      redeem: types_1$c.typeforce.maybe({
        network: types_1$c.typeforce.maybe(types_1$c.typeforce.Object),
        output: types_1$c.typeforce.maybe(types_1$c.typeforce.Buffer),
        input: types_1$c.typeforce.maybe(types_1$c.typeforce.Buffer),
        witness: types_1$c.typeforce.maybe(
          types_1$c.typeforce.arrayOf(types_1$c.typeforce.Buffer)
        )
      }),
      input: types_1$c.typeforce.maybe(types_1$c.typeforce.Buffer),
      witness: types_1$c.typeforce.maybe(
        types_1$c.typeforce.arrayOf(types_1$c.typeforce.Buffer)
      )
    },
    n
  );
  let u = n.network;
  u || (u = n.redeem && n.redeem.network || networks_1$4.bitcoin);
  const p = { network: u }, a = lazy$3.value(() => {
    const F = Buffer$f.from(bs58check$i.decode(n.address)), le = F.readUInt8(0), L = F.slice(1);
    return { version: le, hash: L };
  }), A = lazy$3.value(() => bscript$7.decompile(n.input)), b = lazy$3.value(() => {
    const F = A(), le = F[F.length - 1];
    return {
      network: u,
      output: le === OPS$3.OP_FALSE ? Buffer$f.from([]) : le,
      input: bscript$7.compile(F.slice(0, -1)),
      witness: n.witness || []
    };
  });
  if (lazy$3.prop(p, "address", () => {
    if (!p.hash) return;
    const F = Buffer$f.allocUnsafe(21);
    return F.writeUInt8(p.network.scriptHash, 0), p.hash.copy(F, 1), bs58check$i.encode(F);
  }), lazy$3.prop(p, "hash", () => {
    if (n.output) return n.output.slice(2, 22);
    if (n.address) return a().hash;
    if (p.redeem && p.redeem.output) return bcrypto$4.hash160(p.redeem.output);
  }), lazy$3.prop(p, "output", () => {
    if (p.hash)
      return bscript$7.compile([OPS$3.OP_HASH160, p.hash, OPS$3.OP_EQUAL]);
  }), lazy$3.prop(p, "redeem", () => {
    if (n.input)
      return b();
  }), lazy$3.prop(p, "input", () => {
    if (!(!n.redeem || !n.redeem.input || !n.redeem.output))
      return bscript$7.compile(
        [].concat(bscript$7.decompile(n.redeem.input), n.redeem.output)
      );
  }), lazy$3.prop(p, "witness", () => {
    if (p.redeem && p.redeem.witness) return p.redeem.witness;
    if (p.input) return [];
  }), lazy$3.prop(p, "name", () => {
    const F = ["p2sh"];
    return p.redeem !== void 0 && p.redeem.name !== void 0 && F.push(p.redeem.name), F.join("-");
  }), c.validate) {
    let F = Buffer$f.from([]);
    if (n.address) {
      if (a().version !== u.scriptHash)
        throw new TypeError("Invalid version or Network mismatch");
      if (a().hash.length !== 20) throw new TypeError("Invalid address");
      F = a().hash;
    }
    if (n.hash) {
      if (F.length > 0 && !F.equals(n.hash))
        throw new TypeError("Hash mismatch");
      F = n.hash;
    }
    if (n.output) {
      if (n.output.length !== 23 || n.output[0] !== OPS$3.OP_HASH160 || n.output[1] !== 20 || n.output[22] !== OPS$3.OP_EQUAL)
        throw new TypeError("Output is invalid");
      const L = n.output.slice(2, 22);
      if (F.length > 0 && !F.equals(L))
        throw new TypeError("Hash mismatch");
      F = L;
    }
    const le = (L) => {
      if (L.output) {
        const pe = bscript$7.decompile(L.output);
        if (!pe || pe.length < 1)
          throw new TypeError("Redeem.output too short");
        if (L.output.byteLength > 520)
          throw new TypeError(
            "Redeem.output unspendable if larger than 520 bytes"
          );
        if (bscript$7.countNonPushOnlyOPs(pe) > 201)
          throw new TypeError(
            "Redeem.output unspendable with more than 201 non-push ops"
          );
        const $ = bcrypto$4.hash160(L.output);
        if (F.length > 0 && !F.equals($))
          throw new TypeError("Hash mismatch");
        F = $;
      }
      if (L.input) {
        const pe = L.input.length > 0, $ = L.witness && L.witness.length > 0;
        if (!pe && !$) throw new TypeError("Empty input");
        if (pe && $)
          throw new TypeError("Input and witness provided");
        if (pe) {
          const Ee = bscript$7.decompile(L.input);
          if (!bscript$7.isPushOnly(Ee))
            throw new TypeError("Non push-only scriptSig");
        }
      }
    };
    if (n.input) {
      const L = A();
      if (!L || L.length < 1) throw new TypeError("Input too short");
      if (!Buffer$f.isBuffer(b().output))
        throw new TypeError("Input is invalid");
      le(b());
    }
    if (n.redeem) {
      if (n.redeem.network && n.redeem.network !== u)
        throw new TypeError("Network mismatch");
      if (n.input) {
        const L = b();
        if (n.redeem.output && !n.redeem.output.equals(L.output))
          throw new TypeError("Redeem.output mismatch");
        if (n.redeem.input && !n.redeem.input.equals(L.input))
          throw new TypeError("Redeem.input mismatch");
      }
      le(n.redeem);
    }
    if (n.witness && n.redeem && n.redeem.witness && !stacksEqual$2(n.redeem.witness, n.witness))
      throw new TypeError("Witness and redeem.witness mismatch");
  }
  return Object.assign(p, n);
}
p2sh$3.p2sh = p2sh$2;
var p2wpkh$3 = {}, dist$y = {};
Object.defineProperty(dist$y, "__esModule", { value: !0 });
dist$y.bech32m = dist$y.bech32 = void 0;
const ALPHABET$3 = "qpzry9x8gf2tvdw0s3jn54khce6mua7l", ALPHABET_MAP$1 = {};
for (let n = 0; n < ALPHABET$3.length; n++) {
  const c = ALPHABET$3.charAt(n);
  ALPHABET_MAP$1[c] = n;
}
function polymodStep$1(n) {
  const c = n >> 25;
  return (n & 33554431) << 5 ^ -(c >> 0 & 1) & 996825010 ^ -(c >> 1 & 1) & 642813549 ^ -(c >> 2 & 1) & 513874426 ^ -(c >> 3 & 1) & 1027748829 ^ -(c >> 4 & 1) & 705979059;
}
function prefixChk$1(n) {
  let c = 1;
  for (let u = 0; u < n.length; ++u) {
    const p = n.charCodeAt(u);
    if (p < 33 || p > 126)
      return "Invalid prefix (" + n + ")";
    c = polymodStep$1(c) ^ p >> 5;
  }
  c = polymodStep$1(c);
  for (let u = 0; u < n.length; ++u) {
    const p = n.charCodeAt(u);
    c = polymodStep$1(c) ^ p & 31;
  }
  return c;
}
function convert$3(n, c, u, p) {
  let a = 0, A = 0;
  const b = (1 << u) - 1, F = [];
  for (let le = 0; le < n.length; ++le)
    for (a = a << c | n[le], A += c; A >= u; )
      A -= u, F.push(a >> A & b);
  if (p)
    A > 0 && F.push(a << u - A & b);
  else {
    if (A >= c)
      return "Excess padding";
    if (a << u - A & b)
      return "Non-zero padding";
  }
  return F;
}
function toWords$1(n) {
  return convert$3(n, 8, 5, !0);
}
function fromWordsUnsafe$1(n) {
  const c = convert$3(n, 5, 8, !1);
  if (Array.isArray(c))
    return c;
}
function fromWords$1(n) {
  const c = convert$3(n, 5, 8, !1);
  if (Array.isArray(c))
    return c;
  throw new Error(c);
}
function getLibraryFromEncoding(n) {
  let c;
  n === "bech32" ? c = 1 : c = 734539939;
  function u(b, F, le) {
    if (le = le || 90, b.length + 7 + F.length > le)
      throw new TypeError("Exceeds length limit");
    b = b.toLowerCase();
    let L = prefixChk$1(b);
    if (typeof L == "string")
      throw new Error(L);
    let pe = b + "1";
    for (let $ = 0; $ < F.length; ++$) {
      const Ee = F[$];
      if (Ee >> 5)
        throw new Error("Non 5-bit word");
      L = polymodStep$1(L) ^ Ee, pe += ALPHABET$3.charAt(Ee);
    }
    for (let $ = 0; $ < 6; ++$)
      L = polymodStep$1(L);
    L ^= c;
    for (let $ = 0; $ < 6; ++$) {
      const Ee = L >> (5 - $) * 5 & 31;
      pe += ALPHABET$3.charAt(Ee);
    }
    return pe;
  }
  function p(b, F) {
    if (F = F || 90, b.length < 8)
      return b + " too short";
    if (b.length > F)
      return "Exceeds length limit";
    const le = b.toLowerCase(), L = b.toUpperCase();
    if (b !== le && b !== L)
      return "Mixed-case string " + b;
    b = le;
    const pe = b.lastIndexOf("1");
    if (pe === -1)
      return "No separator character for " + b;
    if (pe === 0)
      return "Missing prefix for " + b;
    const $ = b.slice(0, pe), Ee = b.slice(pe + 1);
    if (Ee.length < 6)
      return "Data too short";
    let be = prefixChk$1($);
    if (typeof be == "string")
      return be;
    const He = [];
    for (let Pe = 0; Pe < Ee.length; ++Pe) {
      const nr = Ee.charAt(Pe), ir = ALPHABET_MAP$1[nr];
      if (ir === void 0)
        return "Unknown character " + nr;
      be = polymodStep$1(be) ^ ir, !(Pe + 6 >= Ee.length) && He.push(ir);
    }
    return be !== c ? "Invalid checksum for " + b : { prefix: $, words: He };
  }
  function a(b, F) {
    const le = p(b, F);
    if (typeof le == "object")
      return le;
  }
  function A(b, F) {
    const le = p(b, F);
    if (typeof le == "object")
      return le;
    throw new Error(le);
  }
  return {
    decodeUnsafe: a,
    decode: A,
    encode: u,
    toWords: toWords$1,
    fromWordsUnsafe: fromWordsUnsafe$1,
    fromWords: fromWords$1
  };
}
dist$y.bech32 = getLibraryFromEncoding("bech32");
dist$y.bech32m = getLibraryFromEncoding("bech32m");
Object.defineProperty(p2wpkh$3, "__esModule", { value: !0 });
p2wpkh$3.p2wpkh = void 0;
const bcrypto$3 = crypto$9, networks_1$3 = networks$3, bscript$6 = script$1, types_1$b = types$p, lazy$2 = lazy$8, bech32_1$3 = dist$y, OPS$2 = bscript$6.OPS, EMPTY_BUFFER$2 = Buffer$f.alloc(0);
function p2wpkh$2(n, c) {
  if (!n.address && !n.hash && !n.output && !n.pubkey && !n.witness)
    throw new TypeError("Not enough data");
  c = Object.assign({ validate: !0 }, c || {}), (0, types_1$b.typeforce)(
    {
      address: types_1$b.typeforce.maybe(types_1$b.typeforce.String),
      hash: types_1$b.typeforce.maybe(types_1$b.typeforce.BufferN(20)),
      input: types_1$b.typeforce.maybe(types_1$b.typeforce.BufferN(0)),
      network: types_1$b.typeforce.maybe(types_1$b.typeforce.Object),
      output: types_1$b.typeforce.maybe(types_1$b.typeforce.BufferN(22)),
      pubkey: types_1$b.typeforce.maybe(types_1$b.isPoint),
      signature: types_1$b.typeforce.maybe(bscript$6.isCanonicalScriptSignature),
      witness: types_1$b.typeforce.maybe(
        types_1$b.typeforce.arrayOf(types_1$b.typeforce.Buffer)
      )
    },
    n
  );
  const u = lazy$2.value(() => {
    const A = bech32_1$3.bech32.decode(n.address), b = A.words.shift(), F = bech32_1$3.bech32.fromWords(A.words);
    return {
      version: b,
      prefix: A.prefix,
      data: Buffer$f.from(F)
    };
  }), p = n.network || networks_1$3.bitcoin, a = { name: "p2wpkh", network: p };
  if (lazy$2.prop(a, "address", () => {
    if (!a.hash) return;
    const A = bech32_1$3.bech32.toWords(a.hash);
    return A.unshift(0), bech32_1$3.bech32.encode(p.bech32, A);
  }), lazy$2.prop(a, "hash", () => {
    if (n.output) return n.output.slice(2, 22);
    if (n.address) return u().data;
    if (n.pubkey || a.pubkey) return bcrypto$3.hash160(n.pubkey || a.pubkey);
  }), lazy$2.prop(a, "output", () => {
    if (a.hash)
      return bscript$6.compile([OPS$2.OP_0, a.hash]);
  }), lazy$2.prop(a, "pubkey", () => {
    if (n.pubkey) return n.pubkey;
    if (n.witness)
      return n.witness[1];
  }), lazy$2.prop(a, "signature", () => {
    if (n.witness)
      return n.witness[0];
  }), lazy$2.prop(a, "input", () => {
    if (a.witness)
      return EMPTY_BUFFER$2;
  }), lazy$2.prop(a, "witness", () => {
    if (n.pubkey && n.signature)
      return [n.signature, n.pubkey];
  }), c.validate) {
    let A = Buffer$f.from([]);
    if (n.address) {
      if (p && p.bech32 !== u().prefix)
        throw new TypeError("Invalid prefix or Network mismatch");
      if (u().version !== 0)
        throw new TypeError("Invalid address version");
      if (u().data.length !== 20)
        throw new TypeError("Invalid address data");
      A = u().data;
    }
    if (n.hash) {
      if (A.length > 0 && !A.equals(n.hash))
        throw new TypeError("Hash mismatch");
      A = n.hash;
    }
    if (n.output) {
      if (n.output.length !== 22 || n.output[0] !== OPS$2.OP_0 || n.output[1] !== 20)
        throw new TypeError("Output is invalid");
      if (A.length > 0 && !A.equals(n.output.slice(2)))
        throw new TypeError("Hash mismatch");
      A = n.output.slice(2);
    }
    if (n.pubkey) {
      const b = bcrypto$3.hash160(n.pubkey);
      if (A.length > 0 && !A.equals(b))
        throw new TypeError("Hash mismatch");
      if (A = b, !(0, types_1$b.isPoint)(n.pubkey) || n.pubkey.length !== 33)
        throw new TypeError("Invalid pubkey for p2wpkh");
    }
    if (n.witness) {
      if (n.witness.length !== 2) throw new TypeError("Witness is invalid");
      if (!bscript$6.isCanonicalScriptSignature(n.witness[0]))
        throw new TypeError("Witness has invalid signature");
      if (!(0, types_1$b.isPoint)(n.witness[1]) || n.witness[1].length !== 33)
        throw new TypeError("Witness has invalid pubkey");
      if (n.signature && !n.signature.equals(n.witness[0]))
        throw new TypeError("Signature mismatch");
      if (n.pubkey && !n.pubkey.equals(n.witness[1]))
        throw new TypeError("Pubkey mismatch");
      const b = bcrypto$3.hash160(n.witness[1]);
      if (A.length > 0 && !A.equals(b))
        throw new TypeError("Hash mismatch");
    }
  }
  return Object.assign(a, n);
}
p2wpkh$3.p2wpkh = p2wpkh$2;
var p2wsh$3 = {};
Object.defineProperty(p2wsh$3, "__esModule", { value: !0 });
p2wsh$3.p2wsh = void 0;
const bcrypto$2 = crypto$9, networks_1$2 = networks$3, bscript$5 = script$1, types_1$a = types$p, lazy$1 = lazy$8, bech32_1$2 = dist$y, OPS$1 = bscript$5.OPS, EMPTY_BUFFER$1 = Buffer$f.alloc(0);
function stacksEqual$1(n, c) {
  return n.length !== c.length ? !1 : n.every((u, p) => u.equals(c[p]));
}
function chunkHasUncompressedPubkey(n) {
  return !!(Buffer$f.isBuffer(n) && n.length === 65 && n[0] === 4 && (0, types_1$a.isPoint)(n));
}
function p2wsh$2(n, c) {
  if (!n.address && !n.hash && !n.output && !n.redeem && !n.witness)
    throw new TypeError("Not enough data");
  c = Object.assign({ validate: !0 }, c || {}), (0, types_1$a.typeforce)(
    {
      network: types_1$a.typeforce.maybe(types_1$a.typeforce.Object),
      address: types_1$a.typeforce.maybe(types_1$a.typeforce.String),
      hash: types_1$a.typeforce.maybe(types_1$a.typeforce.BufferN(32)),
      output: types_1$a.typeforce.maybe(types_1$a.typeforce.BufferN(34)),
      redeem: types_1$a.typeforce.maybe({
        input: types_1$a.typeforce.maybe(types_1$a.typeforce.Buffer),
        network: types_1$a.typeforce.maybe(types_1$a.typeforce.Object),
        output: types_1$a.typeforce.maybe(types_1$a.typeforce.Buffer),
        witness: types_1$a.typeforce.maybe(
          types_1$a.typeforce.arrayOf(types_1$a.typeforce.Buffer)
        )
      }),
      input: types_1$a.typeforce.maybe(types_1$a.typeforce.BufferN(0)),
      witness: types_1$a.typeforce.maybe(
        types_1$a.typeforce.arrayOf(types_1$a.typeforce.Buffer)
      )
    },
    n
  );
  const u = lazy$1.value(() => {
    const b = bech32_1$2.bech32.decode(n.address), F = b.words.shift(), le = bech32_1$2.bech32.fromWords(b.words);
    return {
      version: F,
      prefix: b.prefix,
      data: Buffer$f.from(le)
    };
  }), p = lazy$1.value(() => bscript$5.decompile(n.redeem.input));
  let a = n.network;
  a || (a = n.redeem && n.redeem.network || networks_1$2.bitcoin);
  const A = { network: a };
  if (lazy$1.prop(A, "address", () => {
    if (!A.hash) return;
    const b = bech32_1$2.bech32.toWords(A.hash);
    return b.unshift(0), bech32_1$2.bech32.encode(a.bech32, b);
  }), lazy$1.prop(A, "hash", () => {
    if (n.output) return n.output.slice(2);
    if (n.address) return u().data;
    if (A.redeem && A.redeem.output) return bcrypto$2.sha256(A.redeem.output);
  }), lazy$1.prop(A, "output", () => {
    if (A.hash)
      return bscript$5.compile([OPS$1.OP_0, A.hash]);
  }), lazy$1.prop(A, "redeem", () => {
    if (n.witness)
      return {
        output: n.witness[n.witness.length - 1],
        input: EMPTY_BUFFER$1,
        witness: n.witness.slice(0, -1)
      };
  }), lazy$1.prop(A, "input", () => {
    if (A.witness)
      return EMPTY_BUFFER$1;
  }), lazy$1.prop(A, "witness", () => {
    if (n.redeem && n.redeem.input && n.redeem.input.length > 0 && n.redeem.output && n.redeem.output.length > 0) {
      const b = bscript$5.toStack(p());
      return A.redeem = Object.assign({ witness: b }, n.redeem), A.redeem.input = EMPTY_BUFFER$1, [].concat(b, n.redeem.output);
    }
    if (n.redeem && n.redeem.output && n.redeem.witness)
      return [].concat(n.redeem.witness, n.redeem.output);
  }), lazy$1.prop(A, "name", () => {
    const b = ["p2wsh"];
    return A.redeem !== void 0 && A.redeem.name !== void 0 && b.push(A.redeem.name), b.join("-");
  }), c.validate) {
    let b = Buffer$f.from([]);
    if (n.address) {
      if (u().prefix !== a.bech32)
        throw new TypeError("Invalid prefix or Network mismatch");
      if (u().version !== 0)
        throw new TypeError("Invalid address version");
      if (u().data.length !== 32)
        throw new TypeError("Invalid address data");
      b = u().data;
    }
    if (n.hash) {
      if (b.length > 0 && !b.equals(n.hash))
        throw new TypeError("Hash mismatch");
      b = n.hash;
    }
    if (n.output) {
      if (n.output.length !== 34 || n.output[0] !== OPS$1.OP_0 || n.output[1] !== 32)
        throw new TypeError("Output is invalid");
      const F = n.output.slice(2);
      if (b.length > 0 && !b.equals(F))
        throw new TypeError("Hash mismatch");
      b = F;
    }
    if (n.redeem) {
      if (n.redeem.network && n.redeem.network !== a)
        throw new TypeError("Network mismatch");
      if (n.redeem.input && n.redeem.input.length > 0 && n.redeem.witness && n.redeem.witness.length > 0)
        throw new TypeError("Ambiguous witness source");
      if (n.redeem.output) {
        const F = bscript$5.decompile(n.redeem.output);
        if (!F || F.length < 1)
          throw new TypeError("Redeem.output is invalid");
        if (n.redeem.output.byteLength > 3600)
          throw new TypeError(
            "Redeem.output unspendable if larger than 3600 bytes"
          );
        if (bscript$5.countNonPushOnlyOPs(F) > 201)
          throw new TypeError(
            "Redeem.output unspendable with more than 201 non-push ops"
          );
        const le = bcrypto$2.sha256(n.redeem.output);
        if (b.length > 0 && !b.equals(le))
          throw new TypeError("Hash mismatch");
        b = le;
      }
      if (n.redeem.input && !bscript$5.isPushOnly(p()))
        throw new TypeError("Non push-only scriptSig");
      if (n.witness && n.redeem.witness && !stacksEqual$1(n.witness, n.redeem.witness))
        throw new TypeError("Witness and redeem.witness mismatch");
      if (n.redeem.input && p().some(chunkHasUncompressedPubkey) || n.redeem.output && (bscript$5.decompile(n.redeem.output) || []).some(
        chunkHasUncompressedPubkey
      ))
        throw new TypeError(
          "redeem.input or redeem.output contains uncompressed pubkey"
        );
    }
    if (n.witness && n.witness.length > 0) {
      const F = n.witness[n.witness.length - 1];
      if (n.redeem && n.redeem.output && !n.redeem.output.equals(F))
        throw new TypeError("Witness and redeem.output mismatch");
      if (n.witness.some(chunkHasUncompressedPubkey) || (bscript$5.decompile(F) || []).some(chunkHasUncompressedPubkey))
        throw new TypeError("Witness contains uncompressed pubkey");
    }
  }
  return Object.assign(A, n);
}
p2wsh$3.p2wsh = p2wsh$2;
var p2tr$3 = {}, ecc_lib = {};
Object.defineProperty(ecc_lib, "__esModule", { value: !0 });
ecc_lib.getEccLib = ecc_lib.initEccLib = void 0;
const _ECCLIB_CACHE = {};
function initEccLib(n) {
  n ? n !== _ECCLIB_CACHE.eccLib && (verifyEcc(n), _ECCLIB_CACHE.eccLib = n) : _ECCLIB_CACHE.eccLib = n;
}
ecc_lib.initEccLib = initEccLib;
function getEccLib() {
  if (!_ECCLIB_CACHE.eccLib)
    throw new Error(
      "No ECC Library provided. You must call initEccLib() with a valid TinySecp256k1Interface instance"
    );
  return _ECCLIB_CACHE.eccLib;
}
ecc_lib.getEccLib = getEccLib;
const h$2 = (n) => Buffer$f.from(n, "hex");
function verifyEcc(n) {
  assert$u(typeof n.isXOnlyPoint == "function"), assert$u(
    n.isXOnlyPoint(
      h$2("79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798")
    )
  ), assert$u(
    n.isXOnlyPoint(
      h$2("fffffffffffffffffffffffffffffffffffffffffffffffffffffffeeffffc2e")
    )
  ), assert$u(
    n.isXOnlyPoint(
      h$2("f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9")
    )
  ), assert$u(
    n.isXOnlyPoint(
      h$2("0000000000000000000000000000000000000000000000000000000000000001")
    )
  ), assert$u(
    !n.isXOnlyPoint(
      h$2("0000000000000000000000000000000000000000000000000000000000000000")
    )
  ), assert$u(
    !n.isXOnlyPoint(
      h$2("fffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f")
    )
  ), assert$u(typeof n.xOnlyPointAddTweak == "function"), tweakAddVectors.forEach((c) => {
    const u = n.xOnlyPointAddTweak(h$2(c.pubkey), h$2(c.tweak));
    c.result === null ? assert$u(u === null) : (assert$u(u !== null), assert$u(u.parity === c.parity), assert$u(Buffer$f.from(u.xOnlyPubkey).equals(h$2(c.result))));
  });
}
function assert$u(n) {
  if (!n) throw new Error("ecc library invalid");
}
const tweakAddVectors = [
  {
    pubkey: "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
    tweak: "fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140",
    parity: -1,
    result: null
  },
  {
    pubkey: "1617d38ed8d8657da4d4761e8057bc396ea9e4b9d29776d4be096016dbd2509b",
    tweak: "a8397a935f0dfceba6ba9618f6451ef4d80637abf4e6af2669fbc9de6a8fd2ac",
    parity: 1,
    result: "e478f99dab91052ab39a33ea35fd5e6e4933f4d28023cd597c9a1f6760346adf"
  },
  {
    pubkey: "2c0b7cf95324a07d05398b240174dc0c2be444d96b159aa6c7f7b1e668680991",
    tweak: "823c3cd2142744b075a87eade7e1b8678ba308d566226a0056ca2b7a76f86b47",
    parity: 0,
    result: "9534f8dc8c6deda2dc007655981c78b49c5d96c778fbf363462a11ec9dfd948c"
  }
];
var bip341 = {}, bufferutils = {}, safeBuffer$1 = { exports: {} };
(function(n, c) {
  var u = require$$0$5, p = u.Buffer;
  function a(b, F) {
    for (var le in b)
      F[le] = b[le];
  }
  p.from && p.alloc && p.allocUnsafe && p.allocUnsafeSlow ? n.exports = u : (a(u, c), c.Buffer = A);
  function A(b, F, le) {
    return p(b, F, le);
  }
  A.prototype = Object.create(p.prototype), a(p, A), A.from = function(b, F, le) {
    if (typeof b == "number")
      throw new TypeError("Argument must not be a number");
    return p(b, F, le);
  }, A.alloc = function(b, F, le) {
    if (typeof b != "number")
      throw new TypeError("Argument must be a number");
    var L = p(b);
    return F !== void 0 ? typeof le == "string" ? L.fill(F, le) : L.fill(F) : L.fill(0), L;
  }, A.allocUnsafe = function(b) {
    if (typeof b != "number")
      throw new TypeError("Argument must be a number");
    return p(b);
  }, A.allocUnsafeSlow = function(b) {
    if (typeof b != "number")
      throw new TypeError("Argument must be a number");
    return u.SlowBuffer(b);
  };
})(safeBuffer$1, safeBuffer$1.exports);
var safeBufferExports = safeBuffer$1.exports, Buffer$e = safeBufferExports.Buffer, MAX_SAFE_INTEGER$3 = 9007199254740991;
function checkUInt53$1(n) {
  if (n < 0 || n > MAX_SAFE_INTEGER$3 || n % 1 !== 0) throw new RangeError("value out of range");
}
function encode$r(n, c, u) {
  if (checkUInt53$1(n), c || (c = Buffer$e.allocUnsafe(encodingLength$1(n))), !Buffer$e.isBuffer(c)) throw new TypeError("buffer must be a Buffer instance");
  return u || (u = 0), n < 253 ? (c.writeUInt8(n, u), encode$r.bytes = 1) : n <= 65535 ? (c.writeUInt8(253, u), c.writeUInt16LE(n, u + 1), encode$r.bytes = 3) : n <= 4294967295 ? (c.writeUInt8(254, u), c.writeUInt32LE(n, u + 1), encode$r.bytes = 5) : (c.writeUInt8(255, u), c.writeUInt32LE(n >>> 0, u + 1), c.writeUInt32LE(n / 4294967296 | 0, u + 5), encode$r.bytes = 9), c;
}
function decode$r(n, c) {
  if (!Buffer$e.isBuffer(n)) throw new TypeError("buffer must be a Buffer instance");
  c || (c = 0);
  var u = n.readUInt8(c);
  if (u < 253)
    return decode$r.bytes = 1, u;
  if (u === 253)
    return decode$r.bytes = 3, n.readUInt16LE(c + 1);
  if (u === 254)
    return decode$r.bytes = 5, n.readUInt32LE(c + 1);
  decode$r.bytes = 9;
  var p = n.readUInt32LE(c + 1), a = n.readUInt32LE(c + 5), A = a * 4294967296 + p;
  return checkUInt53$1(A), A;
}
function encodingLength$1(n) {
  return checkUInt53$1(n), n < 253 ? 1 : n <= 65535 ? 3 : n <= 4294967295 ? 5 : 9;
}
var varuintBitcoin = { encode: encode$r, decode: decode$r, encodingLength: encodingLength$1 };
Object.defineProperty(bufferutils, "__esModule", { value: !0 });
bufferutils.BufferReader = bufferutils.BufferWriter = bufferutils.cloneBuffer = bufferutils.reverseBuffer = bufferutils.writeUInt64LE = bufferutils.readUInt64LE = bufferutils.varuint = void 0;
const types$m = types$p, { typeforce: typeforce$3 } = types$m, varuint$8 = varuintBitcoin;
bufferutils.varuint = varuint$8;
function verifuint$1(n, c) {
  if (typeof n != "number")
    throw new Error("cannot write a non-number as a number");
  if (n < 0)
    throw new Error("specified a negative value for writing an unsigned value");
  if (n > c) throw new Error("RangeError: value out of range");
  if (Math.floor(n) !== n)
    throw new Error("value has a fractional component");
}
function readUInt64LE$1(n, c) {
  const u = n.readUInt32LE(c);
  let p = n.readUInt32LE(c + 4);
  return p *= 4294967296, verifuint$1(p + u, 9007199254740991), p + u;
}
bufferutils.readUInt64LE = readUInt64LE$1;
function writeUInt64LE$1(n, c, u) {
  return verifuint$1(c, 9007199254740991), n.writeInt32LE(c & -1, u), n.writeUInt32LE(Math.floor(c / 4294967296), u + 4), u + 8;
}
bufferutils.writeUInt64LE = writeUInt64LE$1;
function reverseBuffer$2(n) {
  if (n.length < 1) return n;
  let c = n.length - 1, u = 0;
  for (let p = 0; p < n.length / 2; p++)
    u = n[p], n[p] = n[c], n[c] = u, c--;
  return n;
}
bufferutils.reverseBuffer = reverseBuffer$2;
function cloneBuffer(n) {
  const c = Buffer$f.allocUnsafe(n.length);
  return n.copy(c), c;
}
bufferutils.cloneBuffer = cloneBuffer;
let BufferWriter$3 = class $p {
  static withCapacity(c) {
    return new $p(Buffer$f.alloc(c));
  }
  constructor(c, u = 0) {
    this.buffer = c, this.offset = u, typeforce$3(types$m.tuple(types$m.Buffer, types$m.UInt32), [c, u]);
  }
  writeUInt8(c) {
    this.offset = this.buffer.writeUInt8(c, this.offset);
  }
  writeInt32(c) {
    this.offset = this.buffer.writeInt32LE(c, this.offset);
  }
  writeUInt32(c) {
    this.offset = this.buffer.writeUInt32LE(c, this.offset);
  }
  writeUInt64(c) {
    this.offset = writeUInt64LE$1(this.buffer, c, this.offset);
  }
  writeVarInt(c) {
    varuint$8.encode(c, this.buffer, this.offset), this.offset += varuint$8.encode.bytes;
  }
  writeSlice(c) {
    if (this.buffer.length < this.offset + c.length)
      throw new Error("Cannot write slice out of bounds");
    this.offset += c.copy(this.buffer, this.offset);
  }
  writeVarSlice(c) {
    this.writeVarInt(c.length), this.writeSlice(c);
  }
  writeVector(c) {
    this.writeVarInt(c.length), c.forEach((u) => this.writeVarSlice(u));
  }
  end() {
    if (this.buffer.length === this.offset)
      return this.buffer;
    throw new Error(`buffer size ${this.buffer.length}, offset ${this.offset}`);
  }
};
bufferutils.BufferWriter = BufferWriter$3;
let BufferReader$3 = class {
  constructor(c, u = 0) {
    this.buffer = c, this.offset = u, typeforce$3(types$m.tuple(types$m.Buffer, types$m.UInt32), [c, u]);
  }
  readUInt8() {
    const c = this.buffer.readUInt8(this.offset);
    return this.offset++, c;
  }
  readInt32() {
    const c = this.buffer.readInt32LE(this.offset);
    return this.offset += 4, c;
  }
  readUInt32() {
    const c = this.buffer.readUInt32LE(this.offset);
    return this.offset += 4, c;
  }
  readUInt64() {
    const c = readUInt64LE$1(this.buffer, this.offset);
    return this.offset += 8, c;
  }
  readVarInt() {
    const c = varuint$8.decode(this.buffer, this.offset);
    return this.offset += varuint$8.decode.bytes, c;
  }
  readSlice(c) {
    if (this.buffer.length < this.offset + c)
      throw new Error("Cannot read slice out of bounds");
    const u = this.buffer.slice(this.offset, this.offset + c);
    return this.offset += c, u;
  }
  readVarSlice() {
    return this.readSlice(this.readVarInt());
  }
  readVector() {
    const c = this.readVarInt(), u = [];
    for (let p = 0; p < c; p++) u.push(this.readVarSlice());
    return u;
  }
};
bufferutils.BufferReader = BufferReader$3;
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.tweakKey = n.tapTweakHash = n.tapleafHash = n.findScriptPath = n.toHashTree = n.rootHashFromPath = n.MAX_TAPTREE_DEPTH = n.LEAF_VERSION_TAPSCRIPT = void 0;
  const c = require$$0$5, u = ecc_lib, p = crypto$9, a = bufferutils, A = types$p;
  n.LEAF_VERSION_TAPSCRIPT = 192, n.MAX_TAPTREE_DEPTH = 128;
  const b = (Pe) => "left" in Pe && "right" in Pe;
  function F(Pe, nr) {
    if (Pe.length < 33)
      throw new TypeError(
        `The control-block length is too small. Got ${Pe.length}, expected min 33.`
      );
    const ir = (Pe.length - 33) / 32;
    let or = nr;
    for (let lr = 0; lr < ir; lr++) {
      const Ir = Pe.slice(33 + 32 * lr, 65 + 32 * lr);
      or.compare(Ir) < 0 ? or = be(or, Ir) : or = be(Ir, or);
    }
    return or;
  }
  n.rootHashFromPath = F;
  function le(Pe) {
    if ((0, A.isTapleaf)(Pe))
      return { hash: pe(Pe) };
    const nr = [le(Pe[0]), le(Pe[1])];
    nr.sort((lr, Ir) => lr.hash.compare(Ir.hash));
    const [ir, or] = nr;
    return {
      hash: be(ir.hash, or.hash),
      left: ir,
      right: or
    };
  }
  n.toHashTree = le;
  function L(Pe, nr) {
    if (b(Pe)) {
      const ir = L(Pe.left, nr);
      if (ir !== void 0) return [...ir, Pe.right.hash];
      const or = L(Pe.right, nr);
      if (or !== void 0) return [...or, Pe.left.hash];
    } else if (Pe.hash.equals(nr))
      return [];
  }
  n.findScriptPath = L;
  function pe(Pe) {
    const nr = Pe.version || n.LEAF_VERSION_TAPSCRIPT;
    return p.taggedHash(
      "TapLeaf",
      c.Buffer.concat([
        c.Buffer.from([nr]),
        He(Pe.output)
      ])
    );
  }
  n.tapleafHash = pe;
  function $(Pe, nr) {
    return p.taggedHash(
      "TapTweak",
      c.Buffer.concat(nr ? [Pe, nr] : [Pe])
    );
  }
  n.tapTweakHash = $;
  function Ee(Pe, nr) {
    if (!c.Buffer.isBuffer(Pe) || Pe.length !== 32 || nr && nr.length !== 32) return null;
    const ir = $(Pe, nr), or = (0, u.getEccLib)().xOnlyPointAddTweak(Pe, ir);
    return !or || or.xOnlyPubkey === null ? null : {
      parity: or.parity,
      x: c.Buffer.from(or.xOnlyPubkey)
    };
  }
  n.tweakKey = Ee;
  function be(Pe, nr) {
    return p.taggedHash("TapBranch", c.Buffer.concat([Pe, nr]));
  }
  function He(Pe) {
    const nr = a.varuint.encodingLength(Pe.length), ir = c.Buffer.allocUnsafe(nr);
    return a.varuint.encode(Pe.length, ir), c.Buffer.concat([ir, Pe]);
  }
})(bip341);
Object.defineProperty(p2tr$3, "__esModule", { value: !0 });
p2tr$3.p2tr = void 0;
const buffer_1$o = require$$0$5, networks_1$1 = networks$3, bscript$4 = script$1, types_1$9 = types$p, ecc_lib_1 = ecc_lib, bip341_1$2 = bip341, lazy = lazy$8, bech32_1$1 = dist$y, OPS = bscript$4.OPS, TAPROOT_WITNESS_VERSION = 1, ANNEX_PREFIX = 80;
function p2tr$2(n, c) {
  if (!n.address && !n.output && !n.pubkey && !n.internalPubkey && !(n.witness && n.witness.length > 1))
    throw new TypeError("Not enough data");
  c = Object.assign({ validate: !0 }, c || {}), (0, types_1$9.typeforce)(
    {
      address: types_1$9.typeforce.maybe(types_1$9.typeforce.String),
      input: types_1$9.typeforce.maybe(types_1$9.typeforce.BufferN(0)),
      network: types_1$9.typeforce.maybe(types_1$9.typeforce.Object),
      output: types_1$9.typeforce.maybe(types_1$9.typeforce.BufferN(34)),
      internalPubkey: types_1$9.typeforce.maybe(types_1$9.typeforce.BufferN(32)),
      hash: types_1$9.typeforce.maybe(types_1$9.typeforce.BufferN(32)),
      pubkey: types_1$9.typeforce.maybe(types_1$9.typeforce.BufferN(32)),
      signature: types_1$9.typeforce.maybe(
        types_1$9.typeforce.anyOf(
          types_1$9.typeforce.BufferN(64),
          types_1$9.typeforce.BufferN(65)
        )
      ),
      witness: types_1$9.typeforce.maybe(
        types_1$9.typeforce.arrayOf(types_1$9.typeforce.Buffer)
      ),
      scriptTree: types_1$9.typeforce.maybe(types_1$9.isTaptree),
      redeem: types_1$9.typeforce.maybe({
        output: types_1$9.typeforce.maybe(types_1$9.typeforce.Buffer),
        redeemVersion: types_1$9.typeforce.maybe(types_1$9.typeforce.Number),
        witness: types_1$9.typeforce.maybe(
          types_1$9.typeforce.arrayOf(types_1$9.typeforce.Buffer)
        )
      }),
      redeemVersion: types_1$9.typeforce.maybe(types_1$9.typeforce.Number)
    },
    n
  );
  const u = lazy.value(() => {
    const F = bech32_1$1.bech32m.decode(n.address), le = F.words.shift(), L = bech32_1$1.bech32m.fromWords(F.words);
    return {
      version: le,
      prefix: F.prefix,
      data: buffer_1$o.Buffer.from(L)
    };
  }), p = lazy.value(() => {
    if (!(!n.witness || !n.witness.length))
      return n.witness.length >= 2 && n.witness[n.witness.length - 1][0] === ANNEX_PREFIX ? n.witness.slice(0, -1) : n.witness.slice();
  }), a = lazy.value(() => {
    if (n.scriptTree) return (0, bip341_1$2.toHashTree)(n.scriptTree);
    if (n.hash) return { hash: n.hash };
  }), A = n.network || networks_1$1.bitcoin, b = { name: "p2tr", network: A };
  if (lazy.prop(b, "address", () => {
    if (!b.pubkey) return;
    const F = bech32_1$1.bech32m.toWords(b.pubkey);
    return F.unshift(TAPROOT_WITNESS_VERSION), bech32_1$1.bech32m.encode(A.bech32, F);
  }), lazy.prop(b, "hash", () => {
    const F = a();
    if (F) return F.hash;
    const le = p();
    if (le && le.length > 1) {
      const L = le[le.length - 1], pe = L[0] & types_1$9.TAPLEAF_VERSION_MASK, $ = le[le.length - 2], Ee = (0, bip341_1$2.tapleafHash)({
        output: $,
        version: pe
      });
      return (0, bip341_1$2.rootHashFromPath)(L, Ee);
    }
    return null;
  }), lazy.prop(b, "output", () => {
    if (b.pubkey)
      return bscript$4.compile([OPS.OP_1, b.pubkey]);
  }), lazy.prop(b, "redeemVersion", () => n.redeemVersion ? n.redeemVersion : n.redeem && n.redeem.redeemVersion !== void 0 && n.redeem.redeemVersion !== null ? n.redeem.redeemVersion : bip341_1$2.LEAF_VERSION_TAPSCRIPT), lazy.prop(b, "redeem", () => {
    const F = p();
    if (!(!F || F.length < 2))
      return {
        output: F[F.length - 2],
        witness: F.slice(0, -2),
        redeemVersion: F[F.length - 1][0] & types_1$9.TAPLEAF_VERSION_MASK
      };
  }), lazy.prop(b, "pubkey", () => {
    if (n.pubkey) return n.pubkey;
    if (n.output) return n.output.slice(2);
    if (n.address) return u().data;
    if (b.internalPubkey) {
      const F = (0, bip341_1$2.tweakKey)(b.internalPubkey, b.hash);
      if (F) return F.x;
    }
  }), lazy.prop(b, "internalPubkey", () => {
    if (n.internalPubkey) return n.internalPubkey;
    const F = p();
    if (F && F.length > 1)
      return F[F.length - 1].slice(1, 33);
  }), lazy.prop(b, "signature", () => {
    if (n.signature) return n.signature;
    const F = p();
    if (!(!F || F.length !== 1))
      return F[0];
  }), lazy.prop(b, "witness", () => {
    if (n.witness) return n.witness;
    const F = a();
    if (F && n.redeem && n.redeem.output && n.internalPubkey) {
      const le = (0, bip341_1$2.tapleafHash)({
        output: n.redeem.output,
        version: b.redeemVersion
      }), L = (0, bip341_1$2.findScriptPath)(F, le);
      if (!L) return;
      const pe = (0, bip341_1$2.tweakKey)(n.internalPubkey, F.hash);
      if (!pe) return;
      const $ = buffer_1$o.Buffer.concat(
        [
          buffer_1$o.Buffer.from([b.redeemVersion | pe.parity]),
          n.internalPubkey
        ].concat(L)
      );
      return [n.redeem.output, $];
    }
    if (n.signature) return [n.signature];
  }), c.validate) {
    let F = buffer_1$o.Buffer.from([]);
    if (n.address) {
      if (A && A.bech32 !== u().prefix)
        throw new TypeError("Invalid prefix or Network mismatch");
      if (u().version !== TAPROOT_WITNESS_VERSION)
        throw new TypeError("Invalid address version");
      if (u().data.length !== 32)
        throw new TypeError("Invalid address data");
      F = u().data;
    }
    if (n.pubkey) {
      if (F.length > 0 && !F.equals(n.pubkey))
        throw new TypeError("Pubkey mismatch");
      F = n.pubkey;
    }
    if (n.output) {
      if (n.output.length !== 34 || n.output[0] !== OPS.OP_1 || n.output[1] !== 32)
        throw new TypeError("Output is invalid");
      if (F.length > 0 && !F.equals(n.output.slice(2)))
        throw new TypeError("Pubkey mismatch");
      F = n.output.slice(2);
    }
    if (n.internalPubkey) {
      const pe = (0, bip341_1$2.tweakKey)(n.internalPubkey, b.hash);
      if (F.length > 0 && !F.equals(pe.x))
        throw new TypeError("Pubkey mismatch");
      F = pe.x;
    }
    if (F && F.length && !(0, ecc_lib_1.getEccLib)().isXOnlyPoint(F))
      throw new TypeError("Invalid pubkey for p2tr");
    const le = a();
    if (n.hash && le && !n.hash.equals(le.hash))
      throw new TypeError("Hash mismatch");
    if (n.redeem && n.redeem.output && le) {
      const pe = (0, bip341_1$2.tapleafHash)({
        output: n.redeem.output,
        version: b.redeemVersion
      });
      if (!(0, bip341_1$2.findScriptPath)(le, pe))
        throw new TypeError("Redeem script not in tree");
    }
    const L = p();
    if (n.redeem && b.redeem) {
      if (n.redeem.redeemVersion && n.redeem.redeemVersion !== b.redeem.redeemVersion)
        throw new TypeError("Redeem.redeemVersion and witness mismatch");
      if (n.redeem.output) {
        if (bscript$4.decompile(n.redeem.output).length === 0)
          throw new TypeError("Redeem.output is invalid");
        if (b.redeem.output && !n.redeem.output.equals(b.redeem.output))
          throw new TypeError("Redeem.output and witness mismatch");
      }
      if (n.redeem.witness && b.redeem.witness && !stacksEqual(n.redeem.witness, b.redeem.witness))
        throw new TypeError("Redeem.witness and witness mismatch");
    }
    if (L && L.length)
      if (L.length === 1) {
        if (n.signature && !n.signature.equals(L[0]))
          throw new TypeError("Signature mismatch");
      } else {
        const pe = L[L.length - 1];
        if (pe.length < 33)
          throw new TypeError(
            `The control-block length is too small. Got ${pe.length}, expected min 33.`
          );
        if ((pe.length - 33) % 32 !== 0)
          throw new TypeError(
            `The control-block length of ${pe.length} is incorrect!`
          );
        const $ = (pe.length - 33) / 32;
        if ($ > 128)
          throw new TypeError(
            `The script path is too long. Got ${$}, expected max 128.`
          );
        const Ee = pe.slice(1, 33);
        if (n.internalPubkey && !n.internalPubkey.equals(Ee))
          throw new TypeError("Internal pubkey mismatch");
        if (!(0, ecc_lib_1.getEccLib)().isXOnlyPoint(Ee))
          throw new TypeError("Invalid internalPubkey for p2tr witness");
        const be = pe[0] & types_1$9.TAPLEAF_VERSION_MASK, He = L[L.length - 2], Pe = (0, bip341_1$2.tapleafHash)({
          output: He,
          version: be
        }), nr = (0, bip341_1$2.rootHashFromPath)(pe, Pe), ir = (0, bip341_1$2.tweakKey)(Ee, nr);
        if (!ir)
          throw new TypeError("Invalid outputKey for p2tr witness");
        if (F.length && !F.equals(ir.x))
          throw new TypeError("Pubkey mismatch for p2tr witness");
        if (ir.parity !== (pe[0] & 1))
          throw new Error("Incorrect parity");
      }
  }
  return Object.assign(b, n);
}
p2tr$3.p2tr = p2tr$2;
function stacksEqual(n, c) {
  return n.length !== c.length ? !1 : n.every((u, p) => u.equals(c[p]));
}
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.p2tr = n.p2wsh = n.p2wpkh = n.p2sh = n.p2pkh = n.p2pk = n.p2ms = n.embed = void 0;
  const c = embed;
  Object.defineProperty(n, "embed", {
    enumerable: !0,
    get: function() {
      return c.p2data;
    }
  });
  const u = p2ms$2;
  Object.defineProperty(n, "p2ms", {
    enumerable: !0,
    get: function() {
      return u.p2ms;
    }
  });
  const p = p2pk$3;
  Object.defineProperty(n, "p2pk", {
    enumerable: !0,
    get: function() {
      return p.p2pk;
    }
  });
  const a = p2pkh$3;
  Object.defineProperty(n, "p2pkh", {
    enumerable: !0,
    get: function() {
      return a.p2pkh;
    }
  });
  const A = p2sh$3;
  Object.defineProperty(n, "p2sh", {
    enumerable: !0,
    get: function() {
      return A.p2sh;
    }
  });
  const b = p2wpkh$3;
  Object.defineProperty(n, "p2wpkh", {
    enumerable: !0,
    get: function() {
      return b.p2wpkh;
    }
  });
  const F = p2wsh$3;
  Object.defineProperty(n, "p2wsh", {
    enumerable: !0,
    get: function() {
      return F.p2wsh;
    }
  });
  const le = p2tr$3;
  Object.defineProperty(n, "p2tr", {
    enumerable: !0,
    get: function() {
      return le.p2tr;
    }
  });
})(payments$3);
Object.defineProperty(address$1, "__esModule", { value: !0 });
address$1.toOutputScript = address$1.fromOutputScript = address$1.toBech32 = address$1.toBase58Check = address$1.fromBech32 = address$1.fromBase58Check = void 0;
const networks$2 = networks$3, payments$2 = payments$3, bscript$3 = script$1, types_1$8 = types$p, bech32_1 = dist$y, bs58check$h = bs58check$k, FUTURE_SEGWIT_MAX_SIZE = 40, FUTURE_SEGWIT_MIN_SIZE = 2, FUTURE_SEGWIT_MAX_VERSION = 16, FUTURE_SEGWIT_MIN_VERSION = 2, FUTURE_SEGWIT_VERSION_DIFF = 80, FUTURE_SEGWIT_VERSION_WARNING = "WARNING: Sending to a future segwit version address can lead to loss of funds. End users MUST be warned carefully in the GUI and asked if they wish to proceed with caution. Wallets should verify the segwit version from the output of fromBech32, then decide when it is safe to use which version of segwit.";
function _toFutureSegwitAddress(n, c) {
  const u = n.slice(2);
  if (u.length < FUTURE_SEGWIT_MIN_SIZE || u.length > FUTURE_SEGWIT_MAX_SIZE)
    throw new TypeError("Invalid program length for segwit address");
  const p = n[0] - FUTURE_SEGWIT_VERSION_DIFF;
  if (p < FUTURE_SEGWIT_MIN_VERSION || p > FUTURE_SEGWIT_MAX_VERSION)
    throw new TypeError("Invalid version for segwit address");
  if (n[1] !== u.length)
    throw new TypeError("Invalid script for segwit address");
  return console.warn(FUTURE_SEGWIT_VERSION_WARNING), toBech32$2(u, p, c.bech32);
}
function fromBase58Check(n) {
  const c = Buffer$f.from(bs58check$h.decode(n));
  if (c.length < 21) throw new TypeError(n + " is too short");
  if (c.length > 21) throw new TypeError(n + " is too long");
  const u = c.readUInt8(0), p = c.slice(1);
  return { version: u, hash: p };
}
address$1.fromBase58Check = fromBase58Check;
function fromBech32$2(n) {
  let c, u;
  try {
    c = bech32_1.bech32.decode(n);
  } catch {
  }
  if (c) {
    if (u = c.words[0], u !== 0) throw new TypeError(n + " uses wrong encoding");
  } else if (c = bech32_1.bech32m.decode(n), u = c.words[0], u === 0) throw new TypeError(n + " uses wrong encoding");
  const p = bech32_1.bech32.fromWords(c.words.slice(1));
  return {
    version: u,
    prefix: c.prefix,
    data: Buffer$f.from(p)
  };
}
address$1.fromBech32 = fromBech32$2;
function toBase58Check(n, c) {
  (0, types_1$8.typeforce)(
    (0, types_1$8.tuple)(types_1$8.Hash160bit, types_1$8.UInt8),
    arguments
  );
  const u = Buffer$f.allocUnsafe(21);
  return u.writeUInt8(c, 0), n.copy(u, 1), bs58check$h.encode(u);
}
address$1.toBase58Check = toBase58Check;
function toBech32$2(n, c, u) {
  const p = bech32_1.bech32.toWords(n);
  return p.unshift(c), c === 0 ? bech32_1.bech32.encode(u, p) : bech32_1.bech32m.encode(u, p);
}
address$1.toBech32 = toBech32$2;
function fromOutputScript(n, c) {
  c = c || networks$2.bitcoin;
  try {
    return payments$2.p2pkh({ output: n, network: c }).address;
  } catch {
  }
  try {
    return payments$2.p2sh({ output: n, network: c }).address;
  } catch {
  }
  try {
    return payments$2.p2wpkh({ output: n, network: c }).address;
  } catch {
  }
  try {
    return payments$2.p2wsh({ output: n, network: c }).address;
  } catch {
  }
  try {
    return payments$2.p2tr({ output: n, network: c }).address;
  } catch {
  }
  try {
    return _toFutureSegwitAddress(n, c);
  } catch {
  }
  throw new Error(bscript$3.toASM(n) + " has no matching Address");
}
address$1.fromOutputScript = fromOutputScript;
function toOutputScript(n, c) {
  c = c || networks$2.bitcoin;
  let u, p;
  try {
    u = fromBase58Check(n);
  } catch {
  }
  if (u) {
    if (u.version === c.pubKeyHash)
      return payments$2.p2pkh({ hash: u.hash }).output;
    if (u.version === c.scriptHash)
      return payments$2.p2sh({ hash: u.hash }).output;
  } else {
    try {
      p = fromBech32$2(n);
    } catch {
    }
    if (p) {
      if (p.prefix !== c.bech32)
        throw new Error(n + " has an invalid prefix");
      if (p.version === 0) {
        if (p.data.length === 20)
          return payments$2.p2wpkh({ hash: p.data }).output;
        if (p.data.length === 32)
          return payments$2.p2wsh({ hash: p.data }).output;
      } else if (p.version === 1) {
        if (p.data.length === 32)
          return payments$2.p2tr({ pubkey: p.data }).output;
      } else if (p.version >= FUTURE_SEGWIT_MIN_VERSION && p.version <= FUTURE_SEGWIT_MAX_VERSION && p.data.length >= FUTURE_SEGWIT_MIN_SIZE && p.data.length <= FUTURE_SEGWIT_MAX_SIZE)
        return console.warn(FUTURE_SEGWIT_VERSION_WARNING), bscript$3.compile([
          p.version + FUTURE_SEGWIT_VERSION_DIFF,
          p.data
        ]);
    }
  }
  throw new Error(n + " has no matching Script");
}
address$1.toOutputScript = toOutputScript;
var block = {}, merkle$2 = {};
Object.defineProperty(merkle$2, "__esModule", { value: !0 });
merkle$2.fastMerkleRoot = void 0;
function fastMerkleRoot(n, c) {
  if (!Array.isArray(n)) throw TypeError("Expected values Array");
  if (typeof c != "function")
    throw TypeError("Expected digest Function");
  let u = n.length;
  const p = n.concat();
  for (; u > 1; ) {
    let a = 0;
    for (let A = 0; A < u; A += 2, ++a) {
      const b = p[A], F = A + 1 === u ? b : p[A + 1], le = Buffer$f.concat([b, F]);
      p[a] = c(le);
    }
    u = a;
  }
  return p[0];
}
merkle$2.fastMerkleRoot = fastMerkleRoot;
var transaction = {};
Object.defineProperty(transaction, "__esModule", { value: !0 });
transaction.Transaction = void 0;
const bufferutils_1$2 = bufferutils, bcrypto$1 = crypto$9, bscript$2 = script$1, script_1 = script$1, types$l = types$p, { typeforce: typeforce$2 } = types$l;
function varSliceSize(n) {
  const c = n.length;
  return bufferutils_1$2.varuint.encodingLength(c) + c;
}
function vectorSize(n) {
  const c = n.length;
  return bufferutils_1$2.varuint.encodingLength(c) + n.reduce((u, p) => u + varSliceSize(p), 0);
}
const EMPTY_BUFFER = Buffer$f.allocUnsafe(0), EMPTY_WITNESS = [], ZERO$2 = Buffer$f.from(
  "0000000000000000000000000000000000000000000000000000000000000000",
  "hex"
), ONE$2 = Buffer$f.from(
  "0000000000000000000000000000000000000000000000000000000000000001",
  "hex"
), VALUE_UINT64_MAX = Buffer$f.from("ffffffffffffffff", "hex"), BLANK_OUTPUT = {
  script: EMPTY_BUFFER,
  valueBuffer: VALUE_UINT64_MAX
};
function isOutput(n) {
  return n.value !== void 0;
}
let Transaction$2 = class uf {
  constructor() {
    this.version = 1, this.locktime = 0, this.ins = [], this.outs = [];
  }
  static fromBuffer(c, u) {
    const p = new bufferutils_1$2.BufferReader(c), a = new uf();
    a.version = p.readInt32();
    const A = p.readUInt8(), b = p.readUInt8();
    let F = !1;
    A === uf.ADVANCED_TRANSACTION_MARKER && b === uf.ADVANCED_TRANSACTION_FLAG ? F = !0 : p.offset -= 2;
    const le = p.readVarInt();
    for (let pe = 0; pe < le; ++pe)
      a.ins.push({
        hash: p.readSlice(32),
        index: p.readUInt32(),
        script: p.readVarSlice(),
        sequence: p.readUInt32(),
        witness: EMPTY_WITNESS
      });
    const L = p.readVarInt();
    for (let pe = 0; pe < L; ++pe)
      a.outs.push({
        value: p.readUInt64(),
        script: p.readVarSlice()
      });
    if (F) {
      for (let pe = 0; pe < le; ++pe)
        a.ins[pe].witness = p.readVector();
      if (!a.hasWitnesses())
        throw new Error("Transaction has superfluous witness data");
    }
    if (a.locktime = p.readUInt32(), u) return a;
    if (p.offset !== c.length)
      throw new Error("Transaction has unexpected data");
    return a;
  }
  static fromHex(c) {
    return uf.fromBuffer(Buffer$f.from(c, "hex"), !1);
  }
  static isCoinbaseHash(c) {
    typeforce$2(types$l.Hash256bit, c);
    for (let u = 0; u < 32; ++u)
      if (c[u] !== 0) return !1;
    return !0;
  }
  isCoinbase() {
    return this.ins.length === 1 && uf.isCoinbaseHash(this.ins[0].hash);
  }
  addInput(c, u, p, a) {
    return typeforce$2(
      types$l.tuple(
        types$l.Hash256bit,
        types$l.UInt32,
        types$l.maybe(types$l.UInt32),
        types$l.maybe(types$l.Buffer)
      ),
      arguments
    ), types$l.Null(p) && (p = uf.DEFAULT_SEQUENCE), this.ins.push({
      hash: c,
      index: u,
      script: a || EMPTY_BUFFER,
      sequence: p,
      witness: EMPTY_WITNESS
    }) - 1;
  }
  addOutput(c, u) {
    return typeforce$2(types$l.tuple(types$l.Buffer, types$l.Satoshi), arguments), this.outs.push({
      script: c,
      value: u
    }) - 1;
  }
  hasWitnesses() {
    return this.ins.some((c) => c.witness.length !== 0);
  }
  weight() {
    const c = this.byteLength(!1), u = this.byteLength(!0);
    return c * 3 + u;
  }
  virtualSize() {
    return Math.ceil(this.weight() / 4);
  }
  byteLength(c = !0) {
    const u = c && this.hasWitnesses();
    return (u ? 10 : 8) + bufferutils_1$2.varuint.encodingLength(this.ins.length) + bufferutils_1$2.varuint.encodingLength(this.outs.length) + this.ins.reduce((p, a) => p + 40 + varSliceSize(a.script), 0) + this.outs.reduce((p, a) => p + 8 + varSliceSize(a.script), 0) + (u ? this.ins.reduce((p, a) => p + vectorSize(a.witness), 0) : 0);
  }
  clone() {
    const c = new uf();
    return c.version = this.version, c.locktime = this.locktime, c.ins = this.ins.map((u) => ({
      hash: u.hash,
      index: u.index,
      script: u.script,
      sequence: u.sequence,
      witness: u.witness
    })), c.outs = this.outs.map((u) => ({
      script: u.script,
      value: u.value
    })), c;
  }
  /**
   * Hash transaction for signing a specific input.
   *
   * Bitcoin uses a different hash for each signed transaction input.
   * This method copies the transaction, makes the necessary changes based on the
   * hashType, and then hashes the result.
   * This hash can then be used to sign the provided transaction input.
   */
  hashForSignature(c, u, p) {
    if (typeforce$2(
      types$l.tuple(
        types$l.UInt32,
        types$l.Buffer,
        /* types.UInt8 */
        types$l.Number
      ),
      arguments
    ), c >= this.ins.length) return ONE$2;
    const a = bscript$2.compile(
      bscript$2.decompile(u).filter((F) => F !== script_1.OPS.OP_CODESEPARATOR)
    ), A = this.clone();
    if ((p & 31) === uf.SIGHASH_NONE)
      A.outs = [], A.ins.forEach((F, le) => {
        le !== c && (F.sequence = 0);
      });
    else if ((p & 31) === uf.SIGHASH_SINGLE) {
      if (c >= this.outs.length) return ONE$2;
      A.outs.length = c + 1;
      for (let F = 0; F < c; F++)
        A.outs[F] = BLANK_OUTPUT;
      A.ins.forEach((F, le) => {
        le !== c && (F.sequence = 0);
      });
    }
    p & uf.SIGHASH_ANYONECANPAY ? (A.ins = [A.ins[c]], A.ins[0].script = a) : (A.ins.forEach((F) => {
      F.script = EMPTY_BUFFER;
    }), A.ins[c].script = a);
    const b = Buffer$f.allocUnsafe(A.byteLength(!1) + 4);
    return b.writeInt32LE(p, b.length - 4), A.__toBuffer(b, 0, !1), bcrypto$1.hash256(b);
  }
  hashForWitnessV1(c, u, p, a, A, b) {
    if (typeforce$2(
      types$l.tuple(
        types$l.UInt32,
        typeforce$2.arrayOf(types$l.Buffer),
        typeforce$2.arrayOf(types$l.Satoshi),
        types$l.UInt32
      ),
      arguments
    ), p.length !== this.ins.length || u.length !== this.ins.length)
      throw new Error("Must supply prevout script and value for all inputs");
    const F = a === uf.SIGHASH_DEFAULT ? uf.SIGHASH_ALL : a & uf.SIGHASH_OUTPUT_MASK, L = (a & uf.SIGHASH_INPUT_MASK) === uf.SIGHASH_ANYONECANPAY, pe = F === uf.SIGHASH_NONE, $ = F === uf.SIGHASH_SINGLE;
    let Ee = EMPTY_BUFFER, be = EMPTY_BUFFER, He = EMPTY_BUFFER, Pe = EMPTY_BUFFER, nr = EMPTY_BUFFER;
    if (!L) {
      let Ir = bufferutils_1$2.BufferWriter.withCapacity(
        36 * this.ins.length
      );
      this.ins.forEach((xr) => {
        Ir.writeSlice(xr.hash), Ir.writeUInt32(xr.index);
      }), Ee = bcrypto$1.sha256(Ir.end()), Ir = bufferutils_1$2.BufferWriter.withCapacity(
        8 * this.ins.length
      ), p.forEach((xr) => Ir.writeUInt64(xr)), be = bcrypto$1.sha256(Ir.end()), Ir = bufferutils_1$2.BufferWriter.withCapacity(
        u.map(varSliceSize).reduce((xr, kr) => xr + kr)
      ), u.forEach(
        (xr) => Ir.writeVarSlice(xr)
      ), He = bcrypto$1.sha256(Ir.end()), Ir = bufferutils_1$2.BufferWriter.withCapacity(
        4 * this.ins.length
      ), this.ins.forEach((xr) => Ir.writeUInt32(xr.sequence)), Pe = bcrypto$1.sha256(Ir.end());
    }
    if (pe || $) {
      if ($ && c < this.outs.length) {
        const Ir = this.outs[c], xr = bufferutils_1$2.BufferWriter.withCapacity(
          8 + varSliceSize(Ir.script)
        );
        xr.writeUInt64(Ir.value), xr.writeVarSlice(Ir.script), nr = bcrypto$1.sha256(xr.end());
      }
    } else {
      const Ir = this.outs.map((kr) => 8 + varSliceSize(kr.script)).reduce((kr, Ce) => kr + Ce), xr = bufferutils_1$2.BufferWriter.withCapacity(Ir);
      this.outs.forEach((kr) => {
        xr.writeUInt64(kr.value), xr.writeVarSlice(kr.script);
      }), nr = bcrypto$1.sha256(xr.end());
    }
    const ir = (A ? 2 : 0) + (b ? 1 : 0), or = 174 - (L ? 49 : 0) - (pe ? 32 : 0) + (b ? 32 : 0) + (A ? 37 : 0), lr = bufferutils_1$2.BufferWriter.withCapacity(or);
    if (lr.writeUInt8(a), lr.writeInt32(this.version), lr.writeUInt32(this.locktime), lr.writeSlice(Ee), lr.writeSlice(be), lr.writeSlice(He), lr.writeSlice(Pe), pe || $ || lr.writeSlice(nr), lr.writeUInt8(ir), L) {
      const Ir = this.ins[c];
      lr.writeSlice(Ir.hash), lr.writeUInt32(Ir.index), lr.writeUInt64(p[c]), lr.writeVarSlice(u[c]), lr.writeUInt32(Ir.sequence);
    } else
      lr.writeUInt32(c);
    if (b) {
      const Ir = bufferutils_1$2.BufferWriter.withCapacity(
        varSliceSize(b)
      );
      Ir.writeVarSlice(b), lr.writeSlice(bcrypto$1.sha256(Ir.end()));
    }
    return $ && lr.writeSlice(nr), A && (lr.writeSlice(A), lr.writeUInt8(0), lr.writeUInt32(4294967295)), bcrypto$1.taggedHash(
      "TapSighash",
      Buffer$f.concat([Buffer$f.from([0]), lr.end()])
    );
  }
  hashForWitnessV0(c, u, p, a) {
    typeforce$2(
      types$l.tuple(types$l.UInt32, types$l.Buffer, types$l.Satoshi, types$l.UInt32),
      arguments
    );
    let A = Buffer$f.from([]), b, F = ZERO$2, le = ZERO$2, L = ZERO$2;
    if (a & uf.SIGHASH_ANYONECANPAY || (A = Buffer$f.allocUnsafe(36 * this.ins.length), b = new bufferutils_1$2.BufferWriter(A, 0), this.ins.forEach(($) => {
      b.writeSlice($.hash), b.writeUInt32($.index);
    }), le = bcrypto$1.hash256(A)), !(a & uf.SIGHASH_ANYONECANPAY) && (a & 31) !== uf.SIGHASH_SINGLE && (a & 31) !== uf.SIGHASH_NONE && (A = Buffer$f.allocUnsafe(4 * this.ins.length), b = new bufferutils_1$2.BufferWriter(A, 0), this.ins.forEach(($) => {
      b.writeUInt32($.sequence);
    }), L = bcrypto$1.hash256(A)), (a & 31) !== uf.SIGHASH_SINGLE && (a & 31) !== uf.SIGHASH_NONE) {
      const $ = this.outs.reduce((Ee, be) => Ee + 8 + varSliceSize(be.script), 0);
      A = Buffer$f.allocUnsafe($), b = new bufferutils_1$2.BufferWriter(A, 0), this.outs.forEach((Ee) => {
        b.writeUInt64(Ee.value), b.writeVarSlice(Ee.script);
      }), F = bcrypto$1.hash256(A);
    } else if ((a & 31) === uf.SIGHASH_SINGLE && c < this.outs.length) {
      const $ = this.outs[c];
      A = Buffer$f.allocUnsafe(8 + varSliceSize($.script)), b = new bufferutils_1$2.BufferWriter(A, 0), b.writeUInt64($.value), b.writeVarSlice($.script), F = bcrypto$1.hash256(A);
    }
    A = Buffer$f.allocUnsafe(156 + varSliceSize(u)), b = new bufferutils_1$2.BufferWriter(A, 0);
    const pe = this.ins[c];
    return b.writeInt32(this.version), b.writeSlice(le), b.writeSlice(L), b.writeSlice(pe.hash), b.writeUInt32(pe.index), b.writeVarSlice(u), b.writeUInt64(p), b.writeUInt32(pe.sequence), b.writeSlice(F), b.writeUInt32(this.locktime), b.writeUInt32(a), bcrypto$1.hash256(A);
  }
  getHash(c) {
    return c && this.isCoinbase() ? Buffer$f.alloc(32, 0) : bcrypto$1.hash256(this.__toBuffer(void 0, void 0, c));
  }
  getId() {
    return (0, bufferutils_1$2.reverseBuffer)(this.getHash(!1)).toString(
      "hex"
    );
  }
  toBuffer(c, u) {
    return this.__toBuffer(c, u, !0);
  }
  toHex() {
    return this.toBuffer(void 0, void 0).toString("hex");
  }
  setInputScript(c, u) {
    typeforce$2(types$l.tuple(types$l.Number, types$l.Buffer), arguments), this.ins[c].script = u;
  }
  setWitness(c, u) {
    typeforce$2(types$l.tuple(types$l.Number, [types$l.Buffer]), arguments), this.ins[c].witness = u;
  }
  __toBuffer(c, u, p = !1) {
    c || (c = Buffer$f.allocUnsafe(this.byteLength(p)));
    const a = new bufferutils_1$2.BufferWriter(
      c,
      u || 0
    );
    a.writeInt32(this.version);
    const A = p && this.hasWitnesses();
    return A && (a.writeUInt8(uf.ADVANCED_TRANSACTION_MARKER), a.writeUInt8(uf.ADVANCED_TRANSACTION_FLAG)), a.writeVarInt(this.ins.length), this.ins.forEach((b) => {
      a.writeSlice(b.hash), a.writeUInt32(b.index), a.writeVarSlice(b.script), a.writeUInt32(b.sequence);
    }), a.writeVarInt(this.outs.length), this.outs.forEach((b) => {
      isOutput(b) ? a.writeUInt64(b.value) : a.writeSlice(b.valueBuffer), a.writeVarSlice(b.script);
    }), A && this.ins.forEach((b) => {
      a.writeVector(b.witness);
    }), a.writeUInt32(this.locktime), u !== void 0 ? c.slice(u, a.offset) : c;
  }
};
transaction.Transaction = Transaction$2;
Transaction$2.DEFAULT_SEQUENCE = 4294967295;
Transaction$2.SIGHASH_DEFAULT = 0;
Transaction$2.SIGHASH_ALL = 1;
Transaction$2.SIGHASH_NONE = 2;
Transaction$2.SIGHASH_SINGLE = 3;
Transaction$2.SIGHASH_ANYONECANPAY = 128;
Transaction$2.SIGHASH_OUTPUT_MASK = 3;
Transaction$2.SIGHASH_INPUT_MASK = 128;
Transaction$2.ADVANCED_TRANSACTION_MARKER = 0;
Transaction$2.ADVANCED_TRANSACTION_FLAG = 1;
Object.defineProperty(block, "__esModule", { value: !0 });
block.Block = void 0;
const bufferutils_1$1 = bufferutils, bcrypto = crypto$9, merkle_1$4 = merkle$2, transaction_1$3 = transaction, types$k = types$p, { typeforce: typeforce$1 } = types$k, errorMerkleNoTxes = new TypeError(
  "Cannot compute merkle root for zero transactions"
), errorWitnessNotSegwit = new TypeError(
  "Cannot compute witness commit for non-segwit block"
);
class Block {
  constructor() {
    this.version = 1, this.prevHash = void 0, this.merkleRoot = void 0, this.timestamp = 0, this.witnessCommit = void 0, this.bits = 0, this.nonce = 0, this.transactions = void 0;
  }
  static fromBuffer(c) {
    if (c.length < 80) throw new Error("Buffer too small (< 80 bytes)");
    const u = new bufferutils_1$1.BufferReader(c), p = new Block();
    if (p.version = u.readInt32(), p.prevHash = u.readSlice(32), p.merkleRoot = u.readSlice(32), p.timestamp = u.readUInt32(), p.bits = u.readUInt32(), p.nonce = u.readUInt32(), c.length === 80) return p;
    const a = () => {
      const F = transaction_1$3.Transaction.fromBuffer(
        u.buffer.slice(u.offset),
        !0
      );
      return u.offset += F.byteLength(), F;
    }, A = u.readVarInt();
    p.transactions = [];
    for (let F = 0; F < A; ++F) {
      const le = a();
      p.transactions.push(le);
    }
    const b = p.getWitnessCommit();
    return b && (p.witnessCommit = b), p;
  }
  static fromHex(c) {
    return Block.fromBuffer(Buffer$f.from(c, "hex"));
  }
  static calculateTarget(c) {
    const u = ((c & 4278190080) >> 24) - 3, p = c & 8388607, a = Buffer$f.alloc(32, 0);
    return a.writeUIntBE(p, 29 - u, 3), a;
  }
  static calculateMerkleRoot(c, u) {
    if (typeforce$1([{ getHash: types$k.Function }], c), c.length === 0) throw errorMerkleNoTxes;
    if (u && !txesHaveWitnessCommit(c))
      throw errorWitnessNotSegwit;
    const p = c.map(
      (A) => A.getHash(u)
    ), a = (0, merkle_1$4.fastMerkleRoot)(p, bcrypto.hash256);
    return u ? bcrypto.hash256(
      Buffer$f.concat([a, c[0].ins[0].witness[0]])
    ) : a;
  }
  getWitnessCommit() {
    if (!txesHaveWitnessCommit(this.transactions)) return null;
    const c = this.transactions[0].outs.filter(
      (p) => p.script.slice(0, 6).equals(Buffer$f.from("6a24aa21a9ed", "hex"))
    ).map((p) => p.script.slice(6, 38));
    if (c.length === 0) return null;
    const u = c[c.length - 1];
    return u instanceof Buffer$f && u.length === 32 ? u : null;
  }
  hasWitnessCommit() {
    return this.witnessCommit instanceof Buffer$f && this.witnessCommit.length === 32 || this.getWitnessCommit() !== null;
  }
  hasWitness() {
    return anyTxHasWitness(this.transactions);
  }
  weight() {
    const c = this.byteLength(!1, !1), u = this.byteLength(!1, !0);
    return c * 3 + u;
  }
  byteLength(c, u = !0) {
    return c || !this.transactions ? 80 : 80 + bufferutils_1$1.varuint.encodingLength(this.transactions.length) + this.transactions.reduce((p, a) => p + a.byteLength(u), 0);
  }
  getHash() {
    return bcrypto.hash256(this.toBuffer(!0));
  }
  getId() {
    return (0, bufferutils_1$1.reverseBuffer)(this.getHash()).toString("hex");
  }
  getUTCDate() {
    const c = /* @__PURE__ */ new Date(0);
    return c.setUTCSeconds(this.timestamp), c;
  }
  // TODO: buffer, offset compatibility
  toBuffer(c) {
    const u = Buffer$f.allocUnsafe(this.byteLength(c)), p = new bufferutils_1$1.BufferWriter(u);
    return p.writeInt32(this.version), p.writeSlice(this.prevHash), p.writeSlice(this.merkleRoot), p.writeUInt32(this.timestamp), p.writeUInt32(this.bits), p.writeUInt32(this.nonce), c || !this.transactions || (bufferutils_1$1.varuint.encode(
      this.transactions.length,
      u,
      p.offset
    ), p.offset += bufferutils_1$1.varuint.encode.bytes, this.transactions.forEach((a) => {
      const A = a.byteLength();
      a.toBuffer(u, p.offset), p.offset += A;
    })), u;
  }
  toHex(c) {
    return this.toBuffer(c).toString("hex");
  }
  checkTxRoots() {
    const c = this.hasWitnessCommit();
    return !c && this.hasWitness() ? !1 : this.__checkMerkleRoot() && (c ? this.__checkWitnessCommit() : !0);
  }
  checkProofOfWork() {
    const c = (0, bufferutils_1$1.reverseBuffer)(this.getHash()), u = Block.calculateTarget(this.bits);
    return c.compare(u) <= 0;
  }
  __checkMerkleRoot() {
    if (!this.transactions) throw errorMerkleNoTxes;
    const c = Block.calculateMerkleRoot(this.transactions);
    return this.merkleRoot.compare(c) === 0;
  }
  __checkWitnessCommit() {
    if (!this.transactions) throw errorMerkleNoTxes;
    if (!this.hasWitnessCommit()) throw errorWitnessNotSegwit;
    const c = Block.calculateMerkleRoot(
      this.transactions,
      !0
    );
    return this.witnessCommit.compare(c) === 0;
  }
}
block.Block = Block;
function txesHaveWitnessCommit(n) {
  return n instanceof Array && n[0] && n[0].ins && n[0].ins instanceof Array && n[0].ins[0] && n[0].ins[0].witness && n[0].ins[0].witness instanceof Array && n[0].ins[0].witness.length > 0;
}
function anyTxHasWitness(n) {
  return n instanceof Array && n.some(
    (c) => typeof c == "object" && c.ins instanceof Array && c.ins.some(
      (u) => typeof u == "object" && u.witness instanceof Array && u.witness.length > 0
    )
  );
}
var psbt$3 = {}, psbt$2 = {}, combiner = {}, parser = {}, fromBuffer = {}, converter = {}, typeFields = {};
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), function(c) {
    c[c.UNSIGNED_TX = 0] = "UNSIGNED_TX", c[c.GLOBAL_XPUB = 1] = "GLOBAL_XPUB";
  }(n.GlobalTypes || (n.GlobalTypes = {})), n.GLOBAL_TYPE_NAMES = ["unsignedTx", "globalXpub"], function(c) {
    c[c.NON_WITNESS_UTXO = 0] = "NON_WITNESS_UTXO", c[c.WITNESS_UTXO = 1] = "WITNESS_UTXO", c[c.PARTIAL_SIG = 2] = "PARTIAL_SIG", c[c.SIGHASH_TYPE = 3] = "SIGHASH_TYPE", c[c.REDEEM_SCRIPT = 4] = "REDEEM_SCRIPT", c[c.WITNESS_SCRIPT = 5] = "WITNESS_SCRIPT", c[c.BIP32_DERIVATION = 6] = "BIP32_DERIVATION", c[c.FINAL_SCRIPTSIG = 7] = "FINAL_SCRIPTSIG", c[c.FINAL_SCRIPTWITNESS = 8] = "FINAL_SCRIPTWITNESS", c[c.POR_COMMITMENT = 9] = "POR_COMMITMENT", c[c.TAP_KEY_SIG = 19] = "TAP_KEY_SIG", c[c.TAP_SCRIPT_SIG = 20] = "TAP_SCRIPT_SIG", c[c.TAP_LEAF_SCRIPT = 21] = "TAP_LEAF_SCRIPT", c[c.TAP_BIP32_DERIVATION = 22] = "TAP_BIP32_DERIVATION", c[c.TAP_INTERNAL_KEY = 23] = "TAP_INTERNAL_KEY", c[c.TAP_MERKLE_ROOT = 24] = "TAP_MERKLE_ROOT";
  }(n.InputTypes || (n.InputTypes = {})), n.INPUT_TYPE_NAMES = [
    "nonWitnessUtxo",
    "witnessUtxo",
    "partialSig",
    "sighashType",
    "redeemScript",
    "witnessScript",
    "bip32Derivation",
    "finalScriptSig",
    "finalScriptWitness",
    "porCommitment",
    "tapKeySig",
    "tapScriptSig",
    "tapLeafScript",
    "tapBip32Derivation",
    "tapInternalKey",
    "tapMerkleRoot"
  ], function(c) {
    c[c.REDEEM_SCRIPT = 0] = "REDEEM_SCRIPT", c[c.WITNESS_SCRIPT = 1] = "WITNESS_SCRIPT", c[c.BIP32_DERIVATION = 2] = "BIP32_DERIVATION", c[c.TAP_INTERNAL_KEY = 5] = "TAP_INTERNAL_KEY", c[c.TAP_TREE = 6] = "TAP_TREE", c[c.TAP_BIP32_DERIVATION = 7] = "TAP_BIP32_DERIVATION";
  }(n.OutputTypes || (n.OutputTypes = {})), n.OUTPUT_TYPE_NAMES = [
    "redeemScript",
    "witnessScript",
    "bip32Derivation",
    "tapInternalKey",
    "tapTree",
    "tapBip32Derivation"
  ];
})(typeFields);
var globalXpub$1 = {};
Object.defineProperty(globalXpub$1, "__esModule", { value: !0 });
const typeFields_1$g = typeFields, range$4 = (n) => [...Array(n).keys()];
function decode$q(n) {
  if (n.key[0] !== typeFields_1$g.GlobalTypes.GLOBAL_XPUB)
    throw new Error(
      "Decode Error: could not decode globalXpub with key 0x" + n.key.toString("hex")
    );
  if (n.key.length !== 79 || ![2, 3].includes(n.key[46]))
    throw new Error(
      "Decode Error: globalXpub has invalid extended pubkey in key 0x" + n.key.toString("hex")
    );
  if (n.value.length / 4 % 1 !== 0)
    throw new Error(
      "Decode Error: Global GLOBAL_XPUB value length should be multiple of 4"
    );
  const c = n.key.slice(1), u = {
    masterFingerprint: n.value.slice(0, 4),
    extendedPubkey: c,
    path: "m"
  };
  for (const p of range$4(n.value.length / 4 - 1)) {
    const a = n.value.readUInt32LE(p * 4 + 4), A = !!(a & 2147483648), b = a & 2147483647;
    u.path += "/" + b.toString(10) + (A ? "'" : "");
  }
  return u;
}
globalXpub$1.decode = decode$q;
function encode$q(n) {
  const c = Buffer$f.from([typeFields_1$g.GlobalTypes.GLOBAL_XPUB]), u = Buffer$f.concat([c, n.extendedPubkey]), p = n.path.split("/"), a = Buffer$f.allocUnsafe(p.length * 4);
  n.masterFingerprint.copy(a, 0);
  let A = 4;
  return p.slice(1).forEach((b) => {
    const F = b.slice(-1) === "'";
    let le = 2147483647 & parseInt(F ? b.slice(0, -1) : b, 10);
    F && (le += 2147483648), a.writeUInt32LE(le, A), A += 4;
  }), {
    key: u,
    value: a
  };
}
globalXpub$1.encode = encode$q;
globalXpub$1.expected = "{ masterFingerprint: Buffer; extendedPubkey: Buffer; path: string; }";
function check$h(n) {
  const c = n.extendedPubkey, u = n.masterFingerprint, p = n.path;
  return Buffer$f.isBuffer(c) && c.length === 78 && [2, 3].indexOf(c[45]) > -1 && Buffer$f.isBuffer(u) && u.length === 4 && typeof p == "string" && !!p.match(/^m(\/\d+'?)*$/);
}
globalXpub$1.check = check$h;
function canAddToArray$3(n, c, u) {
  const p = c.extendedPubkey.toString("hex");
  return u.has(p) ? !1 : (u.add(p), n.filter((a) => a.extendedPubkey.equals(c.extendedPubkey)).length === 0);
}
globalXpub$1.canAddToArray = canAddToArray$3;
var unsignedTx$1 = {};
Object.defineProperty(unsignedTx$1, "__esModule", { value: !0 });
const typeFields_1$f = typeFields;
function encode$p(n) {
  return {
    key: Buffer$f.from([typeFields_1$f.GlobalTypes.UNSIGNED_TX]),
    value: n.toBuffer()
  };
}
unsignedTx$1.encode = encode$p;
var finalScriptSig$1 = {};
Object.defineProperty(finalScriptSig$1, "__esModule", { value: !0 });
const typeFields_1$e = typeFields;
function decode$p(n) {
  if (n.key[0] !== typeFields_1$e.InputTypes.FINAL_SCRIPTSIG)
    throw new Error(
      "Decode Error: could not decode finalScriptSig with key 0x" + n.key.toString("hex")
    );
  return n.value;
}
finalScriptSig$1.decode = decode$p;
function encode$o(n) {
  return {
    key: Buffer$f.from([typeFields_1$e.InputTypes.FINAL_SCRIPTSIG]),
    value: n
  };
}
finalScriptSig$1.encode = encode$o;
finalScriptSig$1.expected = "Buffer";
function check$g(n) {
  return Buffer$f.isBuffer(n);
}
finalScriptSig$1.check = check$g;
function canAdd$8(n, c) {
  return !!n && !!c && n.finalScriptSig === void 0;
}
finalScriptSig$1.canAdd = canAdd$8;
var finalScriptWitness$1 = {};
Object.defineProperty(finalScriptWitness$1, "__esModule", { value: !0 });
const typeFields_1$d = typeFields;
function decode$o(n) {
  if (n.key[0] !== typeFields_1$d.InputTypes.FINAL_SCRIPTWITNESS)
    throw new Error(
      "Decode Error: could not decode finalScriptWitness with key 0x" + n.key.toString("hex")
    );
  return n.value;
}
finalScriptWitness$1.decode = decode$o;
function encode$n(n) {
  return {
    key: Buffer$f.from([typeFields_1$d.InputTypes.FINAL_SCRIPTWITNESS]),
    value: n
  };
}
finalScriptWitness$1.encode = encode$n;
finalScriptWitness$1.expected = "Buffer";
function check$f(n) {
  return Buffer$f.isBuffer(n);
}
finalScriptWitness$1.check = check$f;
function canAdd$7(n, c) {
  return !!n && !!c && n.finalScriptWitness === void 0;
}
finalScriptWitness$1.canAdd = canAdd$7;
var nonWitnessUtxo$1 = {};
Object.defineProperty(nonWitnessUtxo$1, "__esModule", { value: !0 });
const typeFields_1$c = typeFields;
function decode$n(n) {
  if (n.key[0] !== typeFields_1$c.InputTypes.NON_WITNESS_UTXO)
    throw new Error(
      "Decode Error: could not decode nonWitnessUtxo with key 0x" + n.key.toString("hex")
    );
  return n.value;
}
nonWitnessUtxo$1.decode = decode$n;
function encode$m(n) {
  return {
    key: Buffer$f.from([typeFields_1$c.InputTypes.NON_WITNESS_UTXO]),
    value: n
  };
}
nonWitnessUtxo$1.encode = encode$m;
nonWitnessUtxo$1.expected = "Buffer";
function check$e(n) {
  return Buffer$f.isBuffer(n);
}
nonWitnessUtxo$1.check = check$e;
function canAdd$6(n, c) {
  return !!n && !!c && n.nonWitnessUtxo === void 0;
}
nonWitnessUtxo$1.canAdd = canAdd$6;
var partialSig$1 = {};
Object.defineProperty(partialSig$1, "__esModule", { value: !0 });
const typeFields_1$b = typeFields;
function decode$m(n) {
  if (n.key[0] !== typeFields_1$b.InputTypes.PARTIAL_SIG)
    throw new Error(
      "Decode Error: could not decode partialSig with key 0x" + n.key.toString("hex")
    );
  if (!(n.key.length === 34 || n.key.length === 66) || ![2, 3, 4].includes(n.key[1]))
    throw new Error(
      "Decode Error: partialSig has invalid pubkey in key 0x" + n.key.toString("hex")
    );
  return {
    pubkey: n.key.slice(1),
    signature: n.value
  };
}
partialSig$1.decode = decode$m;
function encode$l(n) {
  const c = Buffer$f.from([typeFields_1$b.InputTypes.PARTIAL_SIG]);
  return {
    key: Buffer$f.concat([c, n.pubkey]),
    value: n.signature
  };
}
partialSig$1.encode = encode$l;
partialSig$1.expected = "{ pubkey: Buffer; signature: Buffer; }";
function check$d(n) {
  return Buffer$f.isBuffer(n.pubkey) && Buffer$f.isBuffer(n.signature) && [33, 65].includes(n.pubkey.length) && [2, 3, 4].includes(n.pubkey[0]) && isDerSigWithSighash(n.signature);
}
partialSig$1.check = check$d;
function isDerSigWithSighash(n) {
  if (!Buffer$f.isBuffer(n) || n.length < 9 || n[0] !== 48 || n.length !== n[1] + 3 || n[2] !== 2) return !1;
  const c = n[3];
  if (c > 33 || c < 1 || n[3 + c + 1] !== 2) return !1;
  const u = n[3 + c + 2];
  return !(u > 33 || u < 1 || n.length !== 3 + c + 2 + u + 2);
}
function canAddToArray$2(n, c, u) {
  const p = c.pubkey.toString("hex");
  return u.has(p) ? !1 : (u.add(p), n.filter((a) => a.pubkey.equals(c.pubkey)).length === 0);
}
partialSig$1.canAddToArray = canAddToArray$2;
var porCommitment$1 = {};
Object.defineProperty(porCommitment$1, "__esModule", { value: !0 });
const typeFields_1$a = typeFields;
function decode$l(n) {
  if (n.key[0] !== typeFields_1$a.InputTypes.POR_COMMITMENT)
    throw new Error(
      "Decode Error: could not decode porCommitment with key 0x" + n.key.toString("hex")
    );
  return n.value.toString("utf8");
}
porCommitment$1.decode = decode$l;
function encode$k(n) {
  return {
    key: Buffer$f.from([typeFields_1$a.InputTypes.POR_COMMITMENT]),
    value: Buffer$f.from(n, "utf8")
  };
}
porCommitment$1.encode = encode$k;
porCommitment$1.expected = "string";
function check$c(n) {
  return typeof n == "string";
}
porCommitment$1.check = check$c;
function canAdd$5(n, c) {
  return !!n && !!c && n.porCommitment === void 0;
}
porCommitment$1.canAdd = canAdd$5;
var sighashType$1 = {};
Object.defineProperty(sighashType$1, "__esModule", { value: !0 });
const typeFields_1$9 = typeFields;
function decode$k(n) {
  if (n.key[0] !== typeFields_1$9.InputTypes.SIGHASH_TYPE)
    throw new Error(
      "Decode Error: could not decode sighashType with key 0x" + n.key.toString("hex")
    );
  return n.value.readUInt32LE(0);
}
sighashType$1.decode = decode$k;
function encode$j(n) {
  const c = Buffer$f.from([typeFields_1$9.InputTypes.SIGHASH_TYPE]), u = Buffer$f.allocUnsafe(4);
  return u.writeUInt32LE(n, 0), {
    key: c,
    value: u
  };
}
sighashType$1.encode = encode$j;
sighashType$1.expected = "number";
function check$b(n) {
  return typeof n == "number";
}
sighashType$1.check = check$b;
function canAdd$4(n, c) {
  return !!n && !!c && n.sighashType === void 0;
}
sighashType$1.canAdd = canAdd$4;
var tapKeySig$1 = {};
Object.defineProperty(tapKeySig$1, "__esModule", { value: !0 });
const typeFields_1$8 = typeFields;
function decode$j(n) {
  if (n.key[0] !== typeFields_1$8.InputTypes.TAP_KEY_SIG || n.key.length !== 1)
    throw new Error(
      "Decode Error: could not decode tapKeySig with key 0x" + n.key.toString("hex")
    );
  if (!check$a(n.value))
    throw new Error(
      "Decode Error: tapKeySig not a valid 64-65-byte BIP340 signature"
    );
  return n.value;
}
tapKeySig$1.decode = decode$j;
function encode$i(n) {
  return { key: Buffer$f.from([typeFields_1$8.InputTypes.TAP_KEY_SIG]), value: n };
}
tapKeySig$1.encode = encode$i;
tapKeySig$1.expected = "Buffer";
function check$a(n) {
  return Buffer$f.isBuffer(n) && (n.length === 64 || n.length === 65);
}
tapKeySig$1.check = check$a;
function canAdd$3(n, c) {
  return !!n && !!c && n.tapKeySig === void 0;
}
tapKeySig$1.canAdd = canAdd$3;
var tapLeafScript$1 = {};
Object.defineProperty(tapLeafScript$1, "__esModule", { value: !0 });
const typeFields_1$7 = typeFields;
function decode$i(n) {
  if (n.key[0] !== typeFields_1$7.InputTypes.TAP_LEAF_SCRIPT)
    throw new Error(
      "Decode Error: could not decode tapLeafScript with key 0x" + n.key.toString("hex")
    );
  if ((n.key.length - 2) % 32 !== 0)
    throw new Error(
      "Decode Error: tapLeafScript has invalid control block in key 0x" + n.key.toString("hex")
    );
  const c = n.value[n.value.length - 1];
  if ((n.key[1] & 254) !== c)
    throw new Error(
      "Decode Error: tapLeafScript bad leaf version in key 0x" + n.key.toString("hex")
    );
  const u = n.value.slice(0, -1);
  return { controlBlock: n.key.slice(1), script: u, leafVersion: c };
}
tapLeafScript$1.decode = decode$i;
function encode$h(n) {
  const c = Buffer$f.from([typeFields_1$7.InputTypes.TAP_LEAF_SCRIPT]), u = Buffer$f.from([n.leafVersion]);
  return {
    key: Buffer$f.concat([c, n.controlBlock]),
    value: Buffer$f.concat([n.script, u])
  };
}
tapLeafScript$1.encode = encode$h;
tapLeafScript$1.expected = "{ controlBlock: Buffer; leafVersion: number, script: Buffer; }";
function check$9(n) {
  return Buffer$f.isBuffer(n.controlBlock) && (n.controlBlock.length - 1) % 32 === 0 && (n.controlBlock[0] & 254) === n.leafVersion && Buffer$f.isBuffer(n.script);
}
tapLeafScript$1.check = check$9;
function canAddToArray$1(n, c, u) {
  const p = c.controlBlock.toString("hex");
  return u.has(p) ? !1 : (u.add(p), n.filter((a) => a.controlBlock.equals(c.controlBlock)).length === 0);
}
tapLeafScript$1.canAddToArray = canAddToArray$1;
var tapMerkleRoot$1 = {};
Object.defineProperty(tapMerkleRoot$1, "__esModule", { value: !0 });
const typeFields_1$6 = typeFields;
function decode$h(n) {
  if (n.key[0] !== typeFields_1$6.InputTypes.TAP_MERKLE_ROOT || n.key.length !== 1)
    throw new Error(
      "Decode Error: could not decode tapMerkleRoot with key 0x" + n.key.toString("hex")
    );
  if (!check$8(n.value))
    throw new Error("Decode Error: tapMerkleRoot not a 32-byte hash");
  return n.value;
}
tapMerkleRoot$1.decode = decode$h;
function encode$g(n) {
  return { key: Buffer$f.from([typeFields_1$6.InputTypes.TAP_MERKLE_ROOT]), value: n };
}
tapMerkleRoot$1.encode = encode$g;
tapMerkleRoot$1.expected = "Buffer";
function check$8(n) {
  return Buffer$f.isBuffer(n) && n.length === 32;
}
tapMerkleRoot$1.check = check$8;
function canAdd$2(n, c) {
  return !!n && !!c && n.tapMerkleRoot === void 0;
}
tapMerkleRoot$1.canAdd = canAdd$2;
var tapScriptSig$1 = {};
Object.defineProperty(tapScriptSig$1, "__esModule", { value: !0 });
const typeFields_1$5 = typeFields;
function decode$g(n) {
  if (n.key[0] !== typeFields_1$5.InputTypes.TAP_SCRIPT_SIG)
    throw new Error(
      "Decode Error: could not decode tapScriptSig with key 0x" + n.key.toString("hex")
    );
  if (n.key.length !== 65)
    throw new Error(
      "Decode Error: tapScriptSig has invalid key 0x" + n.key.toString("hex")
    );
  if (n.value.length !== 64 && n.value.length !== 65)
    throw new Error(
      "Decode Error: tapScriptSig has invalid signature in key 0x" + n.key.toString("hex")
    );
  const c = n.key.slice(1, 33), u = n.key.slice(33);
  return {
    pubkey: c,
    leafHash: u,
    signature: n.value
  };
}
tapScriptSig$1.decode = decode$g;
function encode$f(n) {
  const c = Buffer$f.from([typeFields_1$5.InputTypes.TAP_SCRIPT_SIG]);
  return {
    key: Buffer$f.concat([c, n.pubkey, n.leafHash]),
    value: n.signature
  };
}
tapScriptSig$1.encode = encode$f;
tapScriptSig$1.expected = "{ pubkey: Buffer; leafHash: Buffer; signature: Buffer; }";
function check$7(n) {
  return Buffer$f.isBuffer(n.pubkey) && Buffer$f.isBuffer(n.leafHash) && Buffer$f.isBuffer(n.signature) && n.pubkey.length === 32 && n.leafHash.length === 32 && (n.signature.length === 64 || n.signature.length === 65);
}
tapScriptSig$1.check = check$7;
function canAddToArray(n, c, u) {
  const p = c.pubkey.toString("hex") + c.leafHash.toString("hex");
  return u.has(p) ? !1 : (u.add(p), n.filter(
    (a) => a.pubkey.equals(c.pubkey) && a.leafHash.equals(c.leafHash)
  ).length === 0);
}
tapScriptSig$1.canAddToArray = canAddToArray;
var witnessUtxo$1 = {}, tools = {}, varint$3 = {};
Object.defineProperty(varint$3, "__esModule", { value: !0 });
const MAX_SAFE_INTEGER$2 = 9007199254740991;
function checkUInt53(n) {
  if (n < 0 || n > MAX_SAFE_INTEGER$2 || n % 1 !== 0)
    throw new RangeError("value out of range");
}
function encode$e(n, c, u) {
  if (checkUInt53(n), c || (c = Buffer$f.allocUnsafe(encodingLength(n))), !Buffer$f.isBuffer(c))
    throw new TypeError("buffer must be a Buffer instance");
  return u || (u = 0), n < 253 ? (c.writeUInt8(n, u), Object.assign(encode$e, { bytes: 1 })) : n <= 65535 ? (c.writeUInt8(253, u), c.writeUInt16LE(n, u + 1), Object.assign(encode$e, { bytes: 3 })) : n <= 4294967295 ? (c.writeUInt8(254, u), c.writeUInt32LE(n, u + 1), Object.assign(encode$e, { bytes: 5 })) : (c.writeUInt8(255, u), c.writeUInt32LE(n >>> 0, u + 1), c.writeUInt32LE(n / 4294967296 | 0, u + 5), Object.assign(encode$e, { bytes: 9 })), c;
}
varint$3.encode = encode$e;
function decode$f(n, c) {
  if (!Buffer$f.isBuffer(n))
    throw new TypeError("buffer must be a Buffer instance");
  c || (c = 0);
  const u = n.readUInt8(c);
  if (u < 253)
    return Object.assign(decode$f, { bytes: 1 }), u;
  if (u === 253)
    return Object.assign(decode$f, { bytes: 3 }), n.readUInt16LE(c + 1);
  if (u === 254)
    return Object.assign(decode$f, { bytes: 5 }), n.readUInt32LE(c + 1);
  {
    Object.assign(decode$f, { bytes: 9 });
    const p = n.readUInt32LE(c + 1), A = n.readUInt32LE(c + 5) * 4294967296 + p;
    return checkUInt53(A), A;
  }
}
varint$3.decode = decode$f;
function encodingLength(n) {
  return checkUInt53(n), n < 253 ? 1 : n <= 65535 ? 3 : n <= 4294967295 ? 5 : 9;
}
varint$3.encodingLength = encodingLength;
Object.defineProperty(tools, "__esModule", { value: !0 });
const varuint$7 = varint$3;
tools.range = (n) => [...Array(n).keys()];
function reverseBuffer$1(n) {
  if (n.length < 1) return n;
  let c = n.length - 1, u = 0;
  for (let p = 0; p < n.length / 2; p++)
    u = n[p], n[p] = n[c], n[c] = u, c--;
  return n;
}
tools.reverseBuffer = reverseBuffer$1;
function keyValsToBuffer(n) {
  const c = n.map(keyValToBuffer);
  return c.push(Buffer$f.from([0])), Buffer$f.concat(c);
}
tools.keyValsToBuffer = keyValsToBuffer;
function keyValToBuffer(n) {
  const c = n.key.length, u = n.value.length, p = varuint$7.encodingLength(c), a = varuint$7.encodingLength(u), A = Buffer$f.allocUnsafe(
    p + c + a + u
  );
  return varuint$7.encode(c, A, 0), n.key.copy(A, p), varuint$7.encode(u, A, p + c), n.value.copy(A, p + c + a), A;
}
tools.keyValToBuffer = keyValToBuffer;
function verifuint(n, c) {
  if (typeof n != "number")
    throw new Error("cannot write a non-number as a number");
  if (n < 0)
    throw new Error("specified a negative value for writing an unsigned value");
  if (n > c) throw new Error("RangeError: value out of range");
  if (Math.floor(n) !== n)
    throw new Error("value has a fractional component");
}
function readUInt64LE(n, c) {
  const u = n.readUInt32LE(c);
  let p = n.readUInt32LE(c + 4);
  return p *= 4294967296, verifuint(p + u, 9007199254740991), p + u;
}
tools.readUInt64LE = readUInt64LE;
function writeUInt64LE(n, c, u) {
  return verifuint(c, 9007199254740991), n.writeInt32LE(c & -1, u), n.writeUInt32LE(Math.floor(c / 4294967296), u + 4), u + 8;
}
tools.writeUInt64LE = writeUInt64LE;
Object.defineProperty(witnessUtxo$1, "__esModule", { value: !0 });
const typeFields_1$4 = typeFields, tools_1$2 = tools, varuint$6 = varint$3;
function decode$e(n) {
  if (n.key[0] !== typeFields_1$4.InputTypes.WITNESS_UTXO)
    throw new Error(
      "Decode Error: could not decode witnessUtxo with key 0x" + n.key.toString("hex")
    );
  const c = tools_1$2.readUInt64LE(n.value, 0);
  let u = 8;
  const p = varuint$6.decode(n.value, u);
  u += varuint$6.encodingLength(p);
  const a = n.value.slice(u);
  if (a.length !== p)
    throw new Error("Decode Error: WITNESS_UTXO script is not proper length");
  return {
    script: a,
    value: c
  };
}
witnessUtxo$1.decode = decode$e;
function encode$d(n) {
  const { script: c, value: u } = n, p = varuint$6.encodingLength(c.length), a = Buffer$f.allocUnsafe(8 + p + c.length);
  return tools_1$2.writeUInt64LE(a, u, 0), varuint$6.encode(c.length, a, 8), c.copy(a, 8 + p), {
    key: Buffer$f.from([typeFields_1$4.InputTypes.WITNESS_UTXO]),
    value: a
  };
}
witnessUtxo$1.encode = encode$d;
witnessUtxo$1.expected = "{ script: Buffer; value: number; }";
function check$6(n) {
  return Buffer$f.isBuffer(n.script) && typeof n.value == "number";
}
witnessUtxo$1.check = check$6;
function canAdd$1(n, c) {
  return !!n && !!c && n.witnessUtxo === void 0;
}
witnessUtxo$1.canAdd = canAdd$1;
var tapTree$2 = {};
Object.defineProperty(tapTree$2, "__esModule", { value: !0 });
const typeFields_1$3 = typeFields, varuint$5 = varint$3;
function decode$d(n) {
  if (n.key[0] !== typeFields_1$3.OutputTypes.TAP_TREE || n.key.length !== 1)
    throw new Error(
      "Decode Error: could not decode tapTree with key 0x" + n.key.toString("hex")
    );
  let c = 0;
  const u = [];
  for (; c < n.value.length; ) {
    const p = n.value[c++], a = n.value[c++], A = varuint$5.decode(n.value, c);
    c += varuint$5.encodingLength(A), u.push({
      depth: p,
      leafVersion: a,
      script: n.value.slice(c, c + A)
    }), c += A;
  }
  return { leaves: u };
}
tapTree$2.decode = decode$d;
function encode$c(n) {
  const c = Buffer$f.from([typeFields_1$3.OutputTypes.TAP_TREE]), u = [].concat(
    ...n.leaves.map((p) => [
      Buffer$f.of(p.depth, p.leafVersion),
      varuint$5.encode(p.script.length),
      p.script
    ])
  );
  return {
    key: c,
    value: Buffer$f.concat(u)
  };
}
tapTree$2.encode = encode$c;
tapTree$2.expected = "{ leaves: [{ depth: number; leafVersion: number, script: Buffer; }] }";
function check$5(n) {
  return Array.isArray(n.leaves) && n.leaves.every(
    (c) => c.depth >= 0 && c.depth <= 128 && (c.leafVersion & 254) === c.leafVersion && Buffer$f.isBuffer(c.script)
  );
}
tapTree$2.check = check$5;
function canAdd(n, c) {
  return !!n && !!c && n.tapTree === void 0;
}
tapTree$2.canAdd = canAdd;
var bip32Derivation$2 = {};
Object.defineProperty(bip32Derivation$2, "__esModule", { value: !0 });
const range$3 = (n) => [...Array(n).keys()], isValidDERKey = (n) => n.length === 33 && [2, 3].includes(n[0]) || n.length === 65 && n[0] === 4;
function makeConverter$4(n, c = isValidDERKey) {
  function u(F) {
    if (F.key[0] !== n)
      throw new Error(
        "Decode Error: could not decode bip32Derivation with key 0x" + F.key.toString("hex")
      );
    const le = F.key.slice(1);
    if (!c(le))
      throw new Error(
        "Decode Error: bip32Derivation has invalid pubkey in key 0x" + F.key.toString("hex")
      );
    if (F.value.length / 4 % 1 !== 0)
      throw new Error(
        "Decode Error: Input BIP32_DERIVATION value length should be multiple of 4"
      );
    const L = {
      masterFingerprint: F.value.slice(0, 4),
      pubkey: le,
      path: "m"
    };
    for (const pe of range$3(F.value.length / 4 - 1)) {
      const $ = F.value.readUInt32LE(pe * 4 + 4), Ee = !!($ & 2147483648), be = $ & 2147483647;
      L.path += "/" + be.toString(10) + (Ee ? "'" : "");
    }
    return L;
  }
  function p(F) {
    const le = Buffer$f.from([n]), L = Buffer$f.concat([le, F.pubkey]), pe = F.path.split("/"), $ = Buffer$f.allocUnsafe(pe.length * 4);
    F.masterFingerprint.copy($, 0);
    let Ee = 4;
    return pe.slice(1).forEach((be) => {
      const He = be.slice(-1) === "'";
      let Pe = 2147483647 & parseInt(He ? be.slice(0, -1) : be, 10);
      He && (Pe += 2147483648), $.writeUInt32LE(Pe, Ee), Ee += 4;
    }), {
      key: L,
      value: $
    };
  }
  const a = "{ masterFingerprint: Buffer; pubkey: Buffer; path: string; }";
  function A(F) {
    return Buffer$f.isBuffer(F.pubkey) && Buffer$f.isBuffer(F.masterFingerprint) && typeof F.path == "string" && c(F.pubkey) && F.masterFingerprint.length === 4;
  }
  function b(F, le, L) {
    const pe = le.pubkey.toString("hex");
    return L.has(pe) ? !1 : (L.add(pe), F.filter(($) => $.pubkey.equals(le.pubkey)).length === 0);
  }
  return {
    decode: u,
    encode: p,
    check: A,
    expected: a,
    canAddToArray: b
  };
}
bip32Derivation$2.makeConverter = makeConverter$4;
var checkPubkey$1 = {};
Object.defineProperty(checkPubkey$1, "__esModule", { value: !0 });
function makeChecker(n) {
  return c;
  function c(u) {
    let p;
    if (n.includes(u.key[0]) && (p = u.key.slice(1), !(p.length === 33 || p.length === 65) || ![2, 3, 4].includes(p[0])))
      throw new Error(
        "Format Error: invalid pubkey in key 0x" + u.key.toString("hex")
      );
    return p;
  }
}
checkPubkey$1.makeChecker = makeChecker;
var redeemScript$1 = {};
Object.defineProperty(redeemScript$1, "__esModule", { value: !0 });
function makeConverter$3(n) {
  function c(b) {
    if (b.key[0] !== n)
      throw new Error(
        "Decode Error: could not decode redeemScript with key 0x" + b.key.toString("hex")
      );
    return b.value;
  }
  function u(b) {
    return {
      key: Buffer$f.from([n]),
      value: b
    };
  }
  const p = "Buffer";
  function a(b) {
    return Buffer$f.isBuffer(b);
  }
  function A(b, F) {
    return !!b && !!F && b.redeemScript === void 0;
  }
  return {
    decode: c,
    encode: u,
    check: a,
    expected: p,
    canAdd: A
  };
}
redeemScript$1.makeConverter = makeConverter$3;
var tapBip32Derivation$1 = {};
Object.defineProperty(tapBip32Derivation$1, "__esModule", { value: !0 });
const varuint$4 = varint$3, bip32Derivation$1 = bip32Derivation$2, isValidBIP340Key = (n) => n.length === 32;
function makeConverter$2(n) {
  const c = bip32Derivation$1.makeConverter(n, isValidBIP340Key);
  function u(b) {
    const F = varuint$4.decode(b.value), le = varuint$4.encodingLength(F), L = c.decode({
      key: b.key,
      value: b.value.slice(le + F * 32)
    }), pe = new Array(F);
    for (let $ = 0, Ee = le; $ < F; $++, Ee += 32)
      pe[$] = b.value.slice(Ee, Ee + 32);
    return Object.assign({}, L, { leafHashes: pe });
  }
  function p(b) {
    const F = c.encode(b), le = varuint$4.encodingLength(b.leafHashes.length), L = Buffer$f.allocUnsafe(le);
    varuint$4.encode(b.leafHashes.length, L);
    const pe = Buffer$f.concat([L, ...b.leafHashes, F.value]);
    return Object.assign({}, F, { value: pe });
  }
  const a = "{ masterFingerprint: Buffer; pubkey: Buffer; path: string; leafHashes: Buffer[]; }";
  function A(b) {
    return Array.isArray(b.leafHashes) && b.leafHashes.every(
      (F) => Buffer$f.isBuffer(F) && F.length === 32
    ) && c.check(b);
  }
  return {
    decode: u,
    encode: p,
    check: A,
    expected: a,
    canAddToArray: c.canAddToArray
  };
}
tapBip32Derivation$1.makeConverter = makeConverter$2;
var tapInternalKey$1 = {};
Object.defineProperty(tapInternalKey$1, "__esModule", { value: !0 });
function makeConverter$1(n) {
  function c(b) {
    if (b.key[0] !== n || b.key.length !== 1)
      throw new Error(
        "Decode Error: could not decode tapInternalKey with key 0x" + b.key.toString("hex")
      );
    if (b.value.length !== 32)
      throw new Error(
        "Decode Error: tapInternalKey not a 32-byte x-only pubkey"
      );
    return b.value;
  }
  function u(b) {
    return { key: Buffer$f.from([n]), value: b };
  }
  const p = "Buffer";
  function a(b) {
    return Buffer$f.isBuffer(b) && b.length === 32;
  }
  function A(b, F) {
    return !!b && !!F && b.tapInternalKey === void 0;
  }
  return {
    decode: c,
    encode: u,
    check: a,
    expected: p,
    canAdd: A
  };
}
tapInternalKey$1.makeConverter = makeConverter$1;
var witnessScript$1 = {};
Object.defineProperty(witnessScript$1, "__esModule", { value: !0 });
function makeConverter(n) {
  function c(b) {
    if (b.key[0] !== n)
      throw new Error(
        "Decode Error: could not decode witnessScript with key 0x" + b.key.toString("hex")
      );
    return b.value;
  }
  function u(b) {
    return {
      key: Buffer$f.from([n]),
      value: b
    };
  }
  const p = "Buffer";
  function a(b) {
    return Buffer$f.isBuffer(b);
  }
  function A(b, F) {
    return !!b && !!F && b.witnessScript === void 0;
  }
  return {
    decode: c,
    encode: u,
    check: a,
    expected: p,
    canAdd: A
  };
}
witnessScript$1.makeConverter = makeConverter;
Object.defineProperty(converter, "__esModule", { value: !0 });
const typeFields_1$2 = typeFields, globalXpub = globalXpub$1, unsignedTx = unsignedTx$1, finalScriptSig = finalScriptSig$1, finalScriptWitness = finalScriptWitness$1, nonWitnessUtxo = nonWitnessUtxo$1, partialSig = partialSig$1, porCommitment = porCommitment$1, sighashType = sighashType$1, tapKeySig = tapKeySig$1, tapLeafScript = tapLeafScript$1, tapMerkleRoot = tapMerkleRoot$1, tapScriptSig = tapScriptSig$1, witnessUtxo = witnessUtxo$1, tapTree$1 = tapTree$2, bip32Derivation = bip32Derivation$2, checkPubkey = checkPubkey$1, redeemScript = redeemScript$1, tapBip32Derivation = tapBip32Derivation$1, tapInternalKey = tapInternalKey$1, witnessScript = witnessScript$1, globals = {
  unsignedTx,
  globalXpub,
  // pass an Array of key bytes that require pubkey beside the key
  checkPubkey: checkPubkey.makeChecker([])
};
converter.globals = globals;
const inputs = {
  nonWitnessUtxo,
  partialSig,
  sighashType,
  finalScriptSig,
  finalScriptWitness,
  porCommitment,
  witnessUtxo,
  bip32Derivation: bip32Derivation.makeConverter(
    typeFields_1$2.InputTypes.BIP32_DERIVATION
  ),
  redeemScript: redeemScript.makeConverter(
    typeFields_1$2.InputTypes.REDEEM_SCRIPT
  ),
  witnessScript: witnessScript.makeConverter(
    typeFields_1$2.InputTypes.WITNESS_SCRIPT
  ),
  checkPubkey: checkPubkey.makeChecker([
    typeFields_1$2.InputTypes.PARTIAL_SIG,
    typeFields_1$2.InputTypes.BIP32_DERIVATION
  ]),
  tapKeySig,
  tapScriptSig,
  tapLeafScript,
  tapBip32Derivation: tapBip32Derivation.makeConverter(
    typeFields_1$2.InputTypes.TAP_BIP32_DERIVATION
  ),
  tapInternalKey: tapInternalKey.makeConverter(
    typeFields_1$2.InputTypes.TAP_INTERNAL_KEY
  ),
  tapMerkleRoot
};
converter.inputs = inputs;
const outputs = {
  bip32Derivation: bip32Derivation.makeConverter(
    typeFields_1$2.OutputTypes.BIP32_DERIVATION
  ),
  redeemScript: redeemScript.makeConverter(
    typeFields_1$2.OutputTypes.REDEEM_SCRIPT
  ),
  witnessScript: witnessScript.makeConverter(
    typeFields_1$2.OutputTypes.WITNESS_SCRIPT
  ),
  checkPubkey: checkPubkey.makeChecker([
    typeFields_1$2.OutputTypes.BIP32_DERIVATION
  ]),
  tapBip32Derivation: tapBip32Derivation.makeConverter(
    typeFields_1$2.OutputTypes.TAP_BIP32_DERIVATION
  ),
  tapTree: tapTree$1,
  tapInternalKey: tapInternalKey.makeConverter(
    typeFields_1$2.OutputTypes.TAP_INTERNAL_KEY
  )
};
converter.outputs = outputs;
Object.defineProperty(fromBuffer, "__esModule", { value: !0 });
const convert$2 = converter, tools_1$1 = tools, varuint$3 = varint$3, typeFields_1$1 = typeFields;
function psbtFromBuffer(n, c) {
  let u = 0;
  function p() {
    const nr = varuint$3.decode(n, u);
    u += varuint$3.encodingLength(nr);
    const ir = n.slice(u, u + nr);
    return u += nr, ir;
  }
  function a() {
    const nr = n.readUInt32BE(u);
    return u += 4, nr;
  }
  function A() {
    const nr = n.readUInt8(u);
    return u += 1, nr;
  }
  function b() {
    const nr = p(), ir = p();
    return {
      key: nr,
      value: ir
    };
  }
  function F() {
    if (u >= n.length)
      throw new Error("Format Error: Unexpected End of PSBT");
    const nr = n.readUInt8(u) === 0;
    return nr && u++, nr;
  }
  if (a() !== 1886610036)
    throw new Error("Format Error: Invalid Magic Number");
  if (A() !== 255)
    throw new Error(
      "Format Error: Magic Number must be followed by 0xff separator"
    );
  const le = [], L = {};
  for (; !F(); ) {
    const nr = b(), ir = nr.key.toString("hex");
    if (L[ir])
      throw new Error(
        "Format Error: Keys must be unique for global keymap: key " + ir
      );
    L[ir] = 1, le.push(nr);
  }
  const pe = le.filter(
    (nr) => nr.key[0] === typeFields_1$1.GlobalTypes.UNSIGNED_TX
  );
  if (pe.length !== 1)
    throw new Error("Format Error: Only one UNSIGNED_TX allowed");
  const $ = c(pe[0].value), { inputCount: Ee, outputCount: be } = $.getInputOutputCounts(), He = [], Pe = [];
  for (const nr of tools_1$1.range(Ee)) {
    const ir = {}, or = [];
    for (; !F(); ) {
      const lr = b(), Ir = lr.key.toString("hex");
      if (ir[Ir])
        throw new Error(
          "Format Error: Keys must be unique for each input: input index " + nr + " key " + Ir
        );
      ir[Ir] = 1, or.push(lr);
    }
    He.push(or);
  }
  for (const nr of tools_1$1.range(be)) {
    const ir = {}, or = [];
    for (; !F(); ) {
      const lr = b(), Ir = lr.key.toString("hex");
      if (ir[Ir])
        throw new Error(
          "Format Error: Keys must be unique for each output: output index " + nr + " key " + Ir
        );
      ir[Ir] = 1, or.push(lr);
    }
    Pe.push(or);
  }
  return psbtFromKeyVals($, {
    globalMapKeyVals: le,
    inputKeyVals: He,
    outputKeyVals: Pe
  });
}
fromBuffer.psbtFromBuffer = psbtFromBuffer;
function checkKeyBuffer(n, c, u) {
  if (!c.equals(Buffer$f.from([u])))
    throw new Error(
      `Format Error: Invalid ${n} key: ${c.toString("hex")}`
    );
}
fromBuffer.checkKeyBuffer = checkKeyBuffer;
function psbtFromKeyVals(n, { globalMapKeyVals: c, inputKeyVals: u, outputKeyVals: p }) {
  const a = {
    unsignedTx: n
  };
  let A = 0;
  for (const pe of c)
    switch (pe.key[0]) {
      case typeFields_1$1.GlobalTypes.UNSIGNED_TX:
        if (checkKeyBuffer(
          "global",
          pe.key,
          typeFields_1$1.GlobalTypes.UNSIGNED_TX
        ), A > 0)
          throw new Error("Format Error: GlobalMap has multiple UNSIGNED_TX");
        A++;
        break;
      case typeFields_1$1.GlobalTypes.GLOBAL_XPUB:
        a.globalXpub === void 0 && (a.globalXpub = []), a.globalXpub.push(convert$2.globals.globalXpub.decode(pe));
        break;
      default:
        a.unknownKeyVals || (a.unknownKeyVals = []), a.unknownKeyVals.push(pe);
    }
  const b = u.length, F = p.length, le = [], L = [];
  for (const pe of tools_1$1.range(b)) {
    const $ = {};
    for (const Ee of u[pe])
      switch (convert$2.inputs.checkPubkey(Ee), Ee.key[0]) {
        case typeFields_1$1.InputTypes.NON_WITNESS_UTXO:
          if (checkKeyBuffer(
            "input",
            Ee.key,
            typeFields_1$1.InputTypes.NON_WITNESS_UTXO
          ), $.nonWitnessUtxo !== void 0)
            throw new Error(
              "Format Error: Input has multiple NON_WITNESS_UTXO"
            );
          $.nonWitnessUtxo = convert$2.inputs.nonWitnessUtxo.decode(Ee);
          break;
        case typeFields_1$1.InputTypes.WITNESS_UTXO:
          if (checkKeyBuffer(
            "input",
            Ee.key,
            typeFields_1$1.InputTypes.WITNESS_UTXO
          ), $.witnessUtxo !== void 0)
            throw new Error("Format Error: Input has multiple WITNESS_UTXO");
          $.witnessUtxo = convert$2.inputs.witnessUtxo.decode(Ee);
          break;
        case typeFields_1$1.InputTypes.PARTIAL_SIG:
          $.partialSig === void 0 && ($.partialSig = []), $.partialSig.push(convert$2.inputs.partialSig.decode(Ee));
          break;
        case typeFields_1$1.InputTypes.SIGHASH_TYPE:
          if (checkKeyBuffer(
            "input",
            Ee.key,
            typeFields_1$1.InputTypes.SIGHASH_TYPE
          ), $.sighashType !== void 0)
            throw new Error("Format Error: Input has multiple SIGHASH_TYPE");
          $.sighashType = convert$2.inputs.sighashType.decode(Ee);
          break;
        case typeFields_1$1.InputTypes.REDEEM_SCRIPT:
          if (checkKeyBuffer(
            "input",
            Ee.key,
            typeFields_1$1.InputTypes.REDEEM_SCRIPT
          ), $.redeemScript !== void 0)
            throw new Error("Format Error: Input has multiple REDEEM_SCRIPT");
          $.redeemScript = convert$2.inputs.redeemScript.decode(Ee);
          break;
        case typeFields_1$1.InputTypes.WITNESS_SCRIPT:
          if (checkKeyBuffer(
            "input",
            Ee.key,
            typeFields_1$1.InputTypes.WITNESS_SCRIPT
          ), $.witnessScript !== void 0)
            throw new Error("Format Error: Input has multiple WITNESS_SCRIPT");
          $.witnessScript = convert$2.inputs.witnessScript.decode(Ee);
          break;
        case typeFields_1$1.InputTypes.BIP32_DERIVATION:
          $.bip32Derivation === void 0 && ($.bip32Derivation = []), $.bip32Derivation.push(
            convert$2.inputs.bip32Derivation.decode(Ee)
          );
          break;
        case typeFields_1$1.InputTypes.FINAL_SCRIPTSIG:
          checkKeyBuffer(
            "input",
            Ee.key,
            typeFields_1$1.InputTypes.FINAL_SCRIPTSIG
          ), $.finalScriptSig = convert$2.inputs.finalScriptSig.decode(Ee);
          break;
        case typeFields_1$1.InputTypes.FINAL_SCRIPTWITNESS:
          checkKeyBuffer(
            "input",
            Ee.key,
            typeFields_1$1.InputTypes.FINAL_SCRIPTWITNESS
          ), $.finalScriptWitness = convert$2.inputs.finalScriptWitness.decode(
            Ee
          );
          break;
        case typeFields_1$1.InputTypes.POR_COMMITMENT:
          checkKeyBuffer(
            "input",
            Ee.key,
            typeFields_1$1.InputTypes.POR_COMMITMENT
          ), $.porCommitment = convert$2.inputs.porCommitment.decode(Ee);
          break;
        case typeFields_1$1.InputTypes.TAP_KEY_SIG:
          checkKeyBuffer(
            "input",
            Ee.key,
            typeFields_1$1.InputTypes.TAP_KEY_SIG
          ), $.tapKeySig = convert$2.inputs.tapKeySig.decode(Ee);
          break;
        case typeFields_1$1.InputTypes.TAP_SCRIPT_SIG:
          $.tapScriptSig === void 0 && ($.tapScriptSig = []), $.tapScriptSig.push(convert$2.inputs.tapScriptSig.decode(Ee));
          break;
        case typeFields_1$1.InputTypes.TAP_LEAF_SCRIPT:
          $.tapLeafScript === void 0 && ($.tapLeafScript = []), $.tapLeafScript.push(convert$2.inputs.tapLeafScript.decode(Ee));
          break;
        case typeFields_1$1.InputTypes.TAP_BIP32_DERIVATION:
          $.tapBip32Derivation === void 0 && ($.tapBip32Derivation = []), $.tapBip32Derivation.push(
            convert$2.inputs.tapBip32Derivation.decode(Ee)
          );
          break;
        case typeFields_1$1.InputTypes.TAP_INTERNAL_KEY:
          checkKeyBuffer(
            "input",
            Ee.key,
            typeFields_1$1.InputTypes.TAP_INTERNAL_KEY
          ), $.tapInternalKey = convert$2.inputs.tapInternalKey.decode(Ee);
          break;
        case typeFields_1$1.InputTypes.TAP_MERKLE_ROOT:
          checkKeyBuffer(
            "input",
            Ee.key,
            typeFields_1$1.InputTypes.TAP_MERKLE_ROOT
          ), $.tapMerkleRoot = convert$2.inputs.tapMerkleRoot.decode(Ee);
          break;
        default:
          $.unknownKeyVals || ($.unknownKeyVals = []), $.unknownKeyVals.push(Ee);
      }
    le.push($);
  }
  for (const pe of tools_1$1.range(F)) {
    const $ = {};
    for (const Ee of p[pe])
      switch (convert$2.outputs.checkPubkey(Ee), Ee.key[0]) {
        case typeFields_1$1.OutputTypes.REDEEM_SCRIPT:
          if (checkKeyBuffer(
            "output",
            Ee.key,
            typeFields_1$1.OutputTypes.REDEEM_SCRIPT
          ), $.redeemScript !== void 0)
            throw new Error("Format Error: Output has multiple REDEEM_SCRIPT");
          $.redeemScript = convert$2.outputs.redeemScript.decode(Ee);
          break;
        case typeFields_1$1.OutputTypes.WITNESS_SCRIPT:
          if (checkKeyBuffer(
            "output",
            Ee.key,
            typeFields_1$1.OutputTypes.WITNESS_SCRIPT
          ), $.witnessScript !== void 0)
            throw new Error("Format Error: Output has multiple WITNESS_SCRIPT");
          $.witnessScript = convert$2.outputs.witnessScript.decode(Ee);
          break;
        case typeFields_1$1.OutputTypes.BIP32_DERIVATION:
          $.bip32Derivation === void 0 && ($.bip32Derivation = []), $.bip32Derivation.push(
            convert$2.outputs.bip32Derivation.decode(Ee)
          );
          break;
        case typeFields_1$1.OutputTypes.TAP_INTERNAL_KEY:
          checkKeyBuffer(
            "output",
            Ee.key,
            typeFields_1$1.OutputTypes.TAP_INTERNAL_KEY
          ), $.tapInternalKey = convert$2.outputs.tapInternalKey.decode(Ee);
          break;
        case typeFields_1$1.OutputTypes.TAP_TREE:
          checkKeyBuffer(
            "output",
            Ee.key,
            typeFields_1$1.OutputTypes.TAP_TREE
          ), $.tapTree = convert$2.outputs.tapTree.decode(Ee);
          break;
        case typeFields_1$1.OutputTypes.TAP_BIP32_DERIVATION:
          $.tapBip32Derivation === void 0 && ($.tapBip32Derivation = []), $.tapBip32Derivation.push(
            convert$2.outputs.tapBip32Derivation.decode(Ee)
          );
          break;
        default:
          $.unknownKeyVals || ($.unknownKeyVals = []), $.unknownKeyVals.push(Ee);
      }
    L.push($);
  }
  return { globalMap: a, inputs: le, outputs: L };
}
fromBuffer.psbtFromKeyVals = psbtFromKeyVals;
var toBuffer$2 = {};
Object.defineProperty(toBuffer$2, "__esModule", { value: !0 });
const convert$1 = converter, tools_1 = tools;
function psbtToBuffer({ globalMap: n, inputs: c, outputs: u }) {
  const { globalKeyVals: p, inputKeyVals: a, outputKeyVals: A } = psbtToKeyVals({
    globalMap: n,
    inputs: c,
    outputs: u
  }), b = tools_1.keyValsToBuffer(p), F = ($) => $.length === 0 ? [Buffer$f.from([0])] : $.map(tools_1.keyValsToBuffer), le = F(a), L = F(A), pe = Buffer$f.allocUnsafe(5);
  return pe.writeUIntBE(482972169471, 0, 5), Buffer$f.concat(
    [pe, b].concat(le, L)
  );
}
toBuffer$2.psbtToBuffer = psbtToBuffer;
const sortKeyVals = (n, c) => n.key.compare(c.key);
function keyValsFromMap(n, c) {
  const u = /* @__PURE__ */ new Set(), p = Object.entries(n).reduce((A, [b, F]) => {
    if (b === "unknownKeyVals") return A;
    const le = c[b];
    if (le === void 0) return A;
    const L = (Array.isArray(F) ? F : [F]).map(
      le.encode
    );
    return L.map(($) => $.key.toString("hex")).forEach(($) => {
      if (u.has($))
        throw new Error("Serialize Error: Duplicate key: " + $);
      u.add($);
    }), A.concat(L);
  }, []), a = n.unknownKeyVals ? n.unknownKeyVals.filter((A) => !u.has(A.key.toString("hex"))) : [];
  return p.concat(a).sort(sortKeyVals);
}
function psbtToKeyVals({ globalMap: n, inputs: c, outputs: u }) {
  return {
    globalKeyVals: keyValsFromMap(n, convert$1.globals),
    inputKeyVals: c.map((p) => keyValsFromMap(p, convert$1.inputs)),
    outputKeyVals: u.map((p) => keyValsFromMap(p, convert$1.outputs))
  };
}
toBuffer$2.psbtToKeyVals = psbtToKeyVals;
(function(n) {
  function c(u) {
    for (var p in u) n.hasOwnProperty(p) || (n[p] = u[p]);
  }
  Object.defineProperty(n, "__esModule", { value: !0 }), c(fromBuffer), c(toBuffer$2);
})(parser);
Object.defineProperty(combiner, "__esModule", { value: !0 });
const parser_1$1 = parser;
function combine$1(n) {
  const c = n[0], u = parser_1$1.psbtToKeyVals(c), p = n.slice(1);
  if (p.length === 0) throw new Error("Combine: Nothing to combine");
  const a = getTx(c);
  if (a === void 0)
    throw new Error("Combine: Self missing transaction");
  const A = getKeySet(u.globalKeyVals), b = u.inputKeyVals.map(getKeySet), F = u.outputKeyVals.map(getKeySet);
  for (const le of p) {
    const L = getTx(le);
    if (L === void 0 || !L.toBuffer().equals(a.toBuffer()))
      throw new Error(
        "Combine: One of the Psbts does not have the same transaction."
      );
    const pe = parser_1$1.psbtToKeyVals(le);
    getKeySet(pe.globalKeyVals).forEach(
      keyPusher(
        A,
        u.globalKeyVals,
        pe.globalKeyVals
      )
    ), pe.inputKeyVals.map(getKeySet).forEach(
      (He, Pe) => He.forEach(
        keyPusher(
          b[Pe],
          u.inputKeyVals[Pe],
          pe.inputKeyVals[Pe]
        )
      )
    ), pe.outputKeyVals.map(getKeySet).forEach(
      (He, Pe) => He.forEach(
        keyPusher(
          F[Pe],
          u.outputKeyVals[Pe],
          pe.outputKeyVals[Pe]
        )
      )
    );
  }
  return parser_1$1.psbtFromKeyVals(a, {
    globalMapKeyVals: u.globalKeyVals,
    inputKeyVals: u.inputKeyVals,
    outputKeyVals: u.outputKeyVals
  });
}
combiner.combine = combine$1;
function keyPusher(n, c, u) {
  return (p) => {
    if (n.has(p)) return;
    const a = u.filter((A) => A.key.toString("hex") === p)[0];
    c.push(a), n.add(p);
  };
}
function getTx(n) {
  return n.globalMap.unsignedTx;
}
function getKeySet(n) {
  const c = /* @__PURE__ */ new Set();
  return n.forEach((u) => {
    const p = u.key.toString("hex");
    if (c.has(p))
      throw new Error("Combine: KeyValue Map keys should be unique");
    c.add(p);
  }), c;
}
var utils$N = {};
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  const c = converter;
  function u(be, He) {
    const Pe = be[He];
    if (Pe === void 0) throw new Error(`No input #${He}`);
    return Pe;
  }
  n.checkForInput = u;
  function p(be, He) {
    const Pe = be[He];
    if (Pe === void 0) throw new Error(`No output #${He}`);
    return Pe;
  }
  n.checkForOutput = p;
  function a(be, He, Pe) {
    if (be.key[0] < Pe)
      throw new Error(
        "Use the method for your specific key instead of addUnknownKeyVal*"
      );
    if (He && He.filter((nr) => nr.key.equals(be.key)).length !== 0)
      throw new Error(`Duplicate Key: ${be.key.toString("hex")}`);
  }
  n.checkHasKey = a;
  function A(be) {
    let He = 0;
    return Object.keys(be).forEach((Pe) => {
      Number(isNaN(Number(Pe))) && He++;
    }), He;
  }
  n.getEnumLength = A;
  function b(be, He) {
    let Pe = !1;
    if (He.nonWitnessUtxo || He.witnessUtxo) {
      const nr = !!He.redeemScript, ir = !!He.witnessScript, or = !nr || !!He.finalScriptSig, lr = !ir || !!He.finalScriptWitness, Ir = !!He.finalScriptSig || !!He.finalScriptWitness;
      Pe = or && lr && Ir;
    }
    if (Pe === !1)
      throw new Error(
        `Input #${be} has too much or too little data to clean`
      );
  }
  n.inputCheckUncleanFinalized = b;
  function F(be, He, Pe, nr) {
    throw new Error(
      `Data for ${be} key ${He} is incorrect: Expected ${Pe} and got ${JSON.stringify(nr)}`
    );
  }
  function le(be) {
    return (He, Pe) => {
      for (const nr of Object.keys(He)) {
        const ir = He[nr], { canAdd: or, canAddToArray: lr, check: Ir, expected: xr } = (
          // @ts-ignore
          c[be + "s"][nr] || {}
        ), kr = !!lr;
        if (Ir)
          if (kr) {
            if (!Array.isArray(ir) || // @ts-ignore
            Pe[nr] && !Array.isArray(Pe[nr]))
              throw new Error(`Key type ${nr} must be an array`);
            ir.every(Ir) || F(be, nr, xr, ir);
            const Ce = Pe[nr] || [], tr = /* @__PURE__ */ new Set();
            if (!ir.every((Fe) => lr(Ce, Fe, tr)))
              throw new Error("Can not add duplicate data to array");
            Pe[nr] = Ce.concat(ir);
          } else {
            if (Ir(ir) || F(be, nr, xr, ir), !or(Pe, ir))
              throw new Error(`Can not add duplicate data to ${be}`);
            Pe[nr] = ir;
          }
      }
    };
  }
  n.updateGlobal = le("global"), n.updateInput = le("input"), n.updateOutput = le("output");
  function L(be, He) {
    const Pe = be.length - 1, nr = u(be, Pe);
    n.updateInput(He, nr);
  }
  n.addInputAttributes = L;
  function pe(be, He) {
    const Pe = be.length - 1, nr = p(be, Pe);
    n.updateOutput(He, nr);
  }
  n.addOutputAttributes = pe;
  function $(be, He) {
    if (!Buffer$f.isBuffer(He) || He.length < 4)
      throw new Error("Set Version: Invalid Transaction");
    return He.writeUInt32LE(be, 0), He;
  }
  n.defaultVersionSetter = $;
  function Ee(be, He) {
    if (!Buffer$f.isBuffer(He) || He.length < 4)
      throw new Error("Set Locktime: Invalid Transaction");
    return He.writeUInt32LE(be, He.length - 4), He;
  }
  n.defaultLocktimeSetter = Ee;
})(utils$N);
Object.defineProperty(psbt$2, "__esModule", { value: !0 });
const combiner_1 = combiner, parser_1 = parser, typeFields_1 = typeFields, utils_1$y = utils$N;
let Psbt$1 = class {
  constructor(c) {
    this.inputs = [], this.outputs = [], this.globalMap = {
      unsignedTx: c
    };
  }
  static fromBase64(c, u) {
    const p = Buffer$f.from(c, "base64");
    return this.fromBuffer(p, u);
  }
  static fromHex(c, u) {
    const p = Buffer$f.from(c, "hex");
    return this.fromBuffer(p, u);
  }
  static fromBuffer(c, u) {
    const p = parser_1.psbtFromBuffer(c, u), a = new this(p.globalMap.unsignedTx);
    return Object.assign(a, p), a;
  }
  toBase64() {
    return this.toBuffer().toString("base64");
  }
  toHex() {
    return this.toBuffer().toString("hex");
  }
  toBuffer() {
    return parser_1.psbtToBuffer(this);
  }
  updateGlobal(c) {
    return utils_1$y.updateGlobal(c, this.globalMap), this;
  }
  updateInput(c, u) {
    const p = utils_1$y.checkForInput(this.inputs, c);
    return utils_1$y.updateInput(u, p), this;
  }
  updateOutput(c, u) {
    const p = utils_1$y.checkForOutput(this.outputs, c);
    return utils_1$y.updateOutput(u, p), this;
  }
  addUnknownKeyValToGlobal(c) {
    return utils_1$y.checkHasKey(
      c,
      this.globalMap.unknownKeyVals,
      utils_1$y.getEnumLength(typeFields_1.GlobalTypes)
    ), this.globalMap.unknownKeyVals || (this.globalMap.unknownKeyVals = []), this.globalMap.unknownKeyVals.push(c), this;
  }
  addUnknownKeyValToInput(c, u) {
    const p = utils_1$y.checkForInput(this.inputs, c);
    return utils_1$y.checkHasKey(
      u,
      p.unknownKeyVals,
      utils_1$y.getEnumLength(typeFields_1.InputTypes)
    ), p.unknownKeyVals || (p.unknownKeyVals = []), p.unknownKeyVals.push(u), this;
  }
  addUnknownKeyValToOutput(c, u) {
    const p = utils_1$y.checkForOutput(this.outputs, c);
    return utils_1$y.checkHasKey(
      u,
      p.unknownKeyVals,
      utils_1$y.getEnumLength(typeFields_1.OutputTypes)
    ), p.unknownKeyVals || (p.unknownKeyVals = []), p.unknownKeyVals.push(u), this;
  }
  addInput(c) {
    this.globalMap.unsignedTx.addInput(c), this.inputs.push({
      unknownKeyVals: []
    });
    const u = c.unknownKeyVals || [], p = this.inputs.length - 1;
    if (!Array.isArray(u))
      throw new Error("unknownKeyVals must be an Array");
    return u.forEach(
      (a) => this.addUnknownKeyValToInput(p, a)
    ), utils_1$y.addInputAttributes(this.inputs, c), this;
  }
  addOutput(c) {
    this.globalMap.unsignedTx.addOutput(c), this.outputs.push({
      unknownKeyVals: []
    });
    const u = c.unknownKeyVals || [], p = this.outputs.length - 1;
    if (!Array.isArray(u))
      throw new Error("unknownKeyVals must be an Array");
    return u.forEach(
      (a) => this.addUnknownKeyValToOutput(p, a)
    ), utils_1$y.addOutputAttributes(this.outputs, c), this;
  }
  clearFinalizedInput(c) {
    const u = utils_1$y.checkForInput(this.inputs, c);
    utils_1$y.inputCheckUncleanFinalized(c, u);
    for (const p of Object.keys(u))
      [
        "witnessUtxo",
        "nonWitnessUtxo",
        "finalScriptSig",
        "finalScriptWitness",
        "unknownKeyVals"
      ].includes(p) || delete u[p];
    return this;
  }
  combine(...c) {
    const u = combiner_1.combine([this].concat(c));
    return Object.assign(this, u), this;
  }
  getTransaction() {
    return this.globalMap.unsignedTx.toBuffer();
  }
};
psbt$2.Psbt = Psbt$1;
var bip371 = {}, psbtutils = {};
Object.defineProperty(psbtutils, "__esModule", { value: !0 });
psbtutils.signatureBlocksAction = psbtutils.checkInputForSig = pubkeyInScript_1 = psbtutils.pubkeyInScript = psbtutils.pubkeyPositionInScript = psbtutils.witnessStackToScriptWitness = psbtutils.isP2TR = psbtutils.isP2SHScript = psbtutils.isP2WSHScript = psbtutils.isP2WPKH = psbtutils.isP2PKH = psbtutils.isP2PK = psbtutils.isP2MS = void 0;
const varuint$2 = varint$3, bscript$1 = script$1, transaction_1$2 = transaction, crypto_1 = crypto$9, payments$1 = payments$3;
function isPaymentFactory(n) {
  return (c) => {
    try {
      return n({ output: c }), !0;
    } catch {
      return !1;
    }
  };
}
psbtutils.isP2MS = isPaymentFactory(payments$1.p2ms);
psbtutils.isP2PK = isPaymentFactory(payments$1.p2pk);
psbtutils.isP2PKH = isPaymentFactory(payments$1.p2pkh);
psbtutils.isP2WPKH = isPaymentFactory(payments$1.p2wpkh);
psbtutils.isP2WSHScript = isPaymentFactory(payments$1.p2wsh);
psbtutils.isP2SHScript = isPaymentFactory(payments$1.p2sh);
psbtutils.isP2TR = isPaymentFactory(payments$1.p2tr);
function witnessStackToScriptWitness$1(n) {
  let c = Buffer$f.allocUnsafe(0);
  function u(b) {
    c = Buffer$f.concat([c, Buffer$f.from(b)]);
  }
  function p(b) {
    const F = c.length, le = varuint$2.encodingLength(b);
    c = Buffer$f.concat([c, Buffer$f.allocUnsafe(le)]), varuint$2.encode(b, c, F);
  }
  function a(b) {
    p(b.length), u(b);
  }
  function A(b) {
    p(b.length), b.forEach(a);
  }
  return A(n), c;
}
psbtutils.witnessStackToScriptWitness = witnessStackToScriptWitness$1;
function pubkeyPositionInScript(n, c) {
  const u = (0, crypto_1.hash160)(n), p = n.slice(1, 33), a = bscript$1.decompile(c);
  if (a === null) throw new Error("Unknown script error");
  return a.findIndex((A) => typeof A == "number" ? !1 : A.equals(n) || A.equals(u) || A.equals(p));
}
psbtutils.pubkeyPositionInScript = pubkeyPositionInScript;
function pubkeyInScript(n, c) {
  return pubkeyPositionInScript(n, c) !== -1;
}
var pubkeyInScript_1 = psbtutils.pubkeyInScript = pubkeyInScript;
function checkInputForSig(n, c) {
  return extractPartialSigs(n).some(
    (p) => signatureBlocksAction(p, bscript$1.signature.decode, c)
  );
}
psbtutils.checkInputForSig = checkInputForSig;
function signatureBlocksAction(n, c, u) {
  const { hashType: p } = c(n), a = [];
  switch (p & transaction_1$2.Transaction.SIGHASH_ANYONECANPAY && a.push("addInput"), p & 31) {
    case transaction_1$2.Transaction.SIGHASH_ALL:
      break;
    case transaction_1$2.Transaction.SIGHASH_SINGLE:
    case transaction_1$2.Transaction.SIGHASH_NONE:
      a.push("addOutput"), a.push("setInputSequence");
      break;
  }
  return a.indexOf(u) === -1;
}
psbtutils.signatureBlocksAction = signatureBlocksAction;
function extractPartialSigs(n) {
  let c = [];
  if ((n.partialSig || []).length === 0) {
    if (!n.finalScriptSig && !n.finalScriptWitness) return [];
    c = getPsigsFromInputFinalScripts(n);
  } else
    c = n.partialSig;
  return c.map((u) => u.signature);
}
function getPsigsFromInputFinalScripts(n) {
  const c = n.finalScriptSig ? bscript$1.decompile(n.finalScriptSig) || [] : [], u = n.finalScriptWitness ? bscript$1.decompile(n.finalScriptWitness) || [] : [];
  return c.concat(u).filter((p) => Buffer$f.isBuffer(p) && bscript$1.isCanonicalScriptSignature(p)).map((p) => ({ signature: p }));
}
Object.defineProperty(bip371, "__esModule", { value: !0 });
bip371.checkTaprootInputForSigs = bip371.tapTreeFromList = bip371.tapTreeToList = bip371.tweakInternalPubKey = bip371.checkTaprootOutputFields = bip371.checkTaprootInputFields = bip371.isTaprootOutput = bip371.isTaprootInput = bip371.serializeTaprootSignature = bip371.tapScriptFinalizer = toXOnly_1 = bip371.toXOnly = void 0;
const types_1$7 = types$p, transaction_1$1 = transaction, psbtutils_1$1 = psbtutils, bip341_1$1 = bip341, payments_1 = payments$3, psbtutils_2 = psbtutils, toXOnly$1 = (n) => n.length === 32 ? n : n.slice(1, 33);
var toXOnly_1 = bip371.toXOnly = toXOnly$1;
function tapScriptFinalizer(n, c, u) {
  const p = findTapLeafToFinalize(
    c,
    n,
    u
  );
  try {
    const A = sortSignatures(c, p).concat(p.script).concat(p.controlBlock);
    return {
      finalScriptWitness: (0, psbtutils_1$1.witnessStackToScriptWitness)(A)
    };
  } catch (a) {
    throw new Error(`Can not finalize taproot input #${n}: ${a}`);
  }
}
bip371.tapScriptFinalizer = tapScriptFinalizer;
function serializeTaprootSignature(n, c) {
  const u = c ? Buffer$f.from([c]) : Buffer$f.from([]);
  return Buffer$f.concat([n, u]);
}
bip371.serializeTaprootSignature = serializeTaprootSignature;
function isTaprootInput(n) {
  return n && !!(n.tapInternalKey || n.tapMerkleRoot || n.tapLeafScript && n.tapLeafScript.length || n.tapBip32Derivation && n.tapBip32Derivation.length || n.witnessUtxo && (0, psbtutils_1$1.isP2TR)(n.witnessUtxo.script));
}
bip371.isTaprootInput = isTaprootInput;
function isTaprootOutput(n, c) {
  return n && !!(n.tapInternalKey || n.tapTree || n.tapBip32Derivation && n.tapBip32Derivation.length || c && (0, psbtutils_1$1.isP2TR)(c));
}
bip371.isTaprootOutput = isTaprootOutput;
function checkTaprootInputFields(n, c, u) {
  checkMixedTaprootAndNonTaprootInputFields(n, c, u), checkIfTapLeafInTree(n, c, u);
}
bip371.checkTaprootInputFields = checkTaprootInputFields;
function checkTaprootOutputFields(n, c, u) {
  checkMixedTaprootAndNonTaprootOutputFields(n, c, u), checkTaprootScriptPubkey(n, c);
}
bip371.checkTaprootOutputFields = checkTaprootOutputFields;
function checkTaprootScriptPubkey(n, c) {
  if (!c.tapTree && !c.tapInternalKey) return;
  const u = c.tapInternalKey || n.tapInternalKey, p = c.tapTree || n.tapTree;
  if (u) {
    const { script: a } = n, A = getTaprootScripPubkey(u, p);
    if (a && !a.equals(A))
      throw new Error("Error adding output. Script or address missmatch.");
  }
}
function getTaprootScripPubkey(n, c) {
  const u = c && tapTreeFromList(c.leaves), { output: p } = (0, payments_1.p2tr)({
    internalPubkey: n,
    scriptTree: u
  });
  return p;
}
function tweakInternalPubKey(n, c) {
  const u = c.tapInternalKey, p = u && (0, bip341_1$1.tweakKey)(u, c.tapMerkleRoot);
  if (!p)
    throw new Error(
      `Cannot tweak tap internal key for input #${n}. Public key: ${u && u.toString("hex")}`
    );
  return p.x;
}
bip371.tweakInternalPubKey = tweakInternalPubKey;
function tapTreeToList(n) {
  if (!(0, types_1$7.isTaptree)(n))
    throw new Error(
      "Cannot convert taptree to tapleaf list. Expecting a tapree structure."
    );
  return _tapTreeToList(n);
}
bip371.tapTreeToList = tapTreeToList;
function tapTreeFromList(n = []) {
  return n.length === 1 && n[0].depth === 0 ? {
    output: n[0].script,
    version: n[0].leafVersion
  } : instertLeavesInTree(n);
}
bip371.tapTreeFromList = tapTreeFromList;
function checkTaprootInputForSigs(n, c) {
  return extractTaprootSigs(n).some(
    (p) => (0, psbtutils_2.signatureBlocksAction)(p, decodeSchnorrSignature, c)
  );
}
bip371.checkTaprootInputForSigs = checkTaprootInputForSigs;
function decodeSchnorrSignature(n) {
  return {
    signature: n.slice(0, 64),
    hashType: n.slice(64)[0] || transaction_1$1.Transaction.SIGHASH_DEFAULT
  };
}
function extractTaprootSigs(n) {
  const c = [];
  if (n.tapKeySig && c.push(n.tapKeySig), n.tapScriptSig && c.push(...n.tapScriptSig.map((u) => u.signature)), !c.length) {
    const u = getTapKeySigFromWithness(n.finalScriptWitness);
    u && c.push(u);
  }
  return c;
}
function getTapKeySigFromWithness(n) {
  if (!n) return;
  const c = n.slice(2);
  if (c.length === 64 || c.length === 65) return c;
}
function _tapTreeToList(n, c = [], u = 0) {
  if (u > bip341_1$1.MAX_TAPTREE_DEPTH)
    throw new Error("Max taptree depth exceeded.");
  return n ? (0, types_1$7.isTapleaf)(n) ? (c.push({
    depth: u,
    leafVersion: n.version || bip341_1$1.LEAF_VERSION_TAPSCRIPT,
    script: n.output
  }), c) : (n[0] && _tapTreeToList(n[0], c, u + 1), n[1] && _tapTreeToList(n[1], c, u + 1), c) : [];
}
function instertLeavesInTree(n) {
  let c;
  for (const u of n)
    if (c = instertLeafInTree(u, c), !c) throw new Error("No room left to insert tapleaf in tree");
  return c;
}
function instertLeafInTree(n, c, u = 0) {
  if (u > bip341_1$1.MAX_TAPTREE_DEPTH)
    throw new Error("Max taptree depth exceeded.");
  if (n.depth === u)
    return c ? void 0 : {
      output: n.script,
      version: n.leafVersion
    };
  if ((0, types_1$7.isTapleaf)(c)) return;
  const p = instertLeafInTree(n, c && c[0], u + 1);
  if (p) return [p, c && c[1]];
  const a = instertLeafInTree(n, c && c[1], u + 1);
  if (a) return [c && c[0], a];
}
function checkMixedTaprootAndNonTaprootInputFields(n, c, u) {
  const p = isTaprootInput(n) && hasNonTaprootFields(c), a = hasNonTaprootFields(n) && isTaprootInput(c), A = n === c && isTaprootInput(c) && hasNonTaprootFields(c);
  if (p || a || A)
    throw new Error(
      `Invalid arguments for Psbt.${u}. Cannot use both taproot and non-taproot fields.`
    );
}
function checkMixedTaprootAndNonTaprootOutputFields(n, c, u) {
  const p = isTaprootOutput(n) && hasNonTaprootFields(c), a = hasNonTaprootFields(n) && isTaprootOutput(c), A = n === c && isTaprootOutput(c) && hasNonTaprootFields(c);
  if (p || a || A)
    throw new Error(
      `Invalid arguments for Psbt.${u}. Cannot use both taproot and non-taproot fields.`
    );
}
function checkIfTapLeafInTree(n, c, u) {
  if (c.tapMerkleRoot) {
    const p = (c.tapLeafScript || []).every(
      (A) => isTapLeafInTree(A, c.tapMerkleRoot)
    ), a = (n.tapLeafScript || []).every(
      (A) => isTapLeafInTree(A, c.tapMerkleRoot)
    );
    if (!p || !a)
      throw new Error(
        `Invalid arguments for Psbt.${u}. Tapleaf not part of taptree.`
      );
  } else if (n.tapMerkleRoot && !(c.tapLeafScript || []).every(
    (a) => isTapLeafInTree(a, n.tapMerkleRoot)
  ))
    throw new Error(
      `Invalid arguments for Psbt.${u}. Tapleaf not part of taptree.`
    );
}
function isTapLeafInTree(n, c) {
  if (!c) return !0;
  const u = (0, bip341_1$1.tapleafHash)({
    output: n.script,
    version: n.leafVersion
  });
  return (0, bip341_1$1.rootHashFromPath)(
    n.controlBlock,
    u
  ).equals(c);
}
function sortSignatures(n, c) {
  const u = (0, bip341_1$1.tapleafHash)({
    output: c.script,
    version: c.leafVersion
  });
  return (n.tapScriptSig || []).filter((p) => p.leafHash.equals(u)).map((p) => addPubkeyPositionInScript(c.script, p)).sort((p, a) => a.positionInScript - p.positionInScript).map((p) => p.signature);
}
function addPubkeyPositionInScript(n, c) {
  return Object.assign(
    {
      positionInScript: (0, psbtutils_1$1.pubkeyPositionInScript)(
        c.pubkey,
        n
      )
    },
    c
  );
}
function findTapLeafToFinalize(n, c, u) {
  if (!n.tapScriptSig || !n.tapScriptSig.length)
    throw new Error(
      `Can not finalize taproot input #${c}. No tapleaf script signature provided.`
    );
  const p = (n.tapLeafScript || []).sort((a, A) => a.controlBlock.length - A.controlBlock.length).find(
    (a) => canFinalizeLeaf(a, n.tapScriptSig, u)
  );
  if (!p)
    throw new Error(
      `Can not finalize taproot input #${c}. Signature for tapleaf script not found.`
    );
  return p;
}
function canFinalizeLeaf(n, c, u) {
  const p = (0, bip341_1$1.tapleafHash)({
    output: n.script,
    version: n.leafVersion
  });
  return (!u || u.equals(p)) && c.find((A) => A.leafHash.equals(p)) !== void 0;
}
function hasNonTaprootFields(n) {
  return n && !!(n.redeemScript || n.witnessScript || n.bip32Derivation && n.bip32Derivation.length);
}
Object.defineProperty(psbt$3, "__esModule", { value: !0 });
psbt$3.Psbt = void 0;
const bip174_1 = psbt$2, varuint$1 = varint$3, utils_1$x = utils$N, address_1 = address$1, bufferutils_1 = bufferutils, networks_1 = networks$3, payments = payments$3, bip341_1 = bip341, bscript = script$1, transaction_1 = transaction, bip371_1 = bip371, psbtutils_1 = psbtutils, DEFAULT_OPTS = {
  /**
   * A bitcoinjs Network object. This is only used if you pass an `address`
   * parameter to addOutput. Otherwise it is not needed and can be left default.
   */
  network: networks_1.bitcoin,
  /**
   * When extractTransaction is called, the fee rate is checked.
   * THIS IS NOT TO BE RELIED ON.
   * It is only here as a last ditch effort to prevent sending a 500 BTC fee etc.
   */
  maximumFeeRate: 5e3
  // satoshi per byte
};
class Psbt {
  static fromBase64(c, u = {}) {
    const p = Buffer$f.from(c, "base64");
    return this.fromBuffer(p, u);
  }
  static fromHex(c, u = {}) {
    const p = Buffer$f.from(c, "hex");
    return this.fromBuffer(p, u);
  }
  static fromBuffer(c, u = {}) {
    const p = bip174_1.Psbt.fromBuffer(c, transactionFromBuffer), a = new Psbt(u, p);
    return checkTxForDupeIns(a.__CACHE.__TX, a.__CACHE), a;
  }
  constructor(c = {}, u = new bip174_1.Psbt(new PsbtTransaction())) {
    this.data = u, this.opts = Object.assign({}, DEFAULT_OPTS, c), this.__CACHE = {
      __NON_WITNESS_UTXO_TX_CACHE: [],
      __NON_WITNESS_UTXO_BUF_CACHE: [],
      __TX_IN_CACHE: {},
      __TX: this.data.globalMap.unsignedTx.tx,
      // Psbt's predecesor (TransactionBuilder - now removed) behavior
      // was to not confirm input values  before signing.
      // Even though we highly encourage people to get
      // the full parent transaction to verify values, the ability to
      // sign non-segwit inputs without the full transaction was often
      // requested. So the only way to activate is to use @ts-ignore.
      // We will disable exporting the Psbt when unsafe sign is active.
      // because it is not BIP174 compliant.
      __UNSAFE_SIGN_NONSEGWIT: !1
    }, this.data.inputs.length === 0 && this.setVersion(2);
    const p = (a, A, b, F) => Object.defineProperty(a, A, {
      enumerable: b,
      writable: F
    });
    p(this, "__CACHE", !1, !0), p(this, "opts", !1, !0);
  }
  get inputCount() {
    return this.data.inputs.length;
  }
  get version() {
    return this.__CACHE.__TX.version;
  }
  set version(c) {
    this.setVersion(c);
  }
  get locktime() {
    return this.__CACHE.__TX.locktime;
  }
  set locktime(c) {
    this.setLocktime(c);
  }
  get txInputs() {
    return this.__CACHE.__TX.ins.map((c) => ({
      hash: (0, bufferutils_1.cloneBuffer)(c.hash),
      index: c.index,
      sequence: c.sequence
    }));
  }
  get txOutputs() {
    return this.__CACHE.__TX.outs.map((c) => {
      let u;
      try {
        u = (0, address_1.fromOutputScript)(
          c.script,
          this.opts.network
        );
      } catch {
      }
      return {
        script: (0, bufferutils_1.cloneBuffer)(c.script),
        value: c.value,
        address: u
      };
    });
  }
  combine(...c) {
    return this.data.combine(...c.map((u) => u.data)), this;
  }
  clone() {
    const c = Psbt.fromBuffer(this.data.toBuffer());
    return c.opts = JSON.parse(JSON.stringify(this.opts)), c;
  }
  setMaximumFeeRate(c) {
    check32Bit(c), this.opts.maximumFeeRate = c;
  }
  setVersion(c) {
    check32Bit(c), checkInputsForPartialSig(this.data.inputs, "setVersion");
    const u = this.__CACHE;
    return u.__TX.version = c, u.__EXTRACTED_TX = void 0, this;
  }
  setLocktime(c) {
    check32Bit(c), checkInputsForPartialSig(this.data.inputs, "setLocktime");
    const u = this.__CACHE;
    return u.__TX.locktime = c, u.__EXTRACTED_TX = void 0, this;
  }
  setInputSequence(c, u) {
    check32Bit(u), checkInputsForPartialSig(this.data.inputs, "setInputSequence");
    const p = this.__CACHE;
    if (p.__TX.ins.length <= c)
      throw new Error("Input index too high");
    return p.__TX.ins[c].sequence = u, p.__EXTRACTED_TX = void 0, this;
  }
  addInputs(c) {
    return c.forEach((u) => this.addInput(u)), this;
  }
  addInput(c) {
    if (arguments.length > 1 || !c || c.hash === void 0 || c.index === void 0)
      throw new Error(
        "Invalid arguments for Psbt.addInput. Requires single object with at least [hash] and [index]"
      );
    (0, bip371_1.checkTaprootInputFields)(c, c, "addInput"), checkInputsForPartialSig(this.data.inputs, "addInput"), c.witnessScript && checkInvalidP2WSH(c.witnessScript);
    const u = this.__CACHE;
    this.data.addInput(c);
    const p = u.__TX.ins[u.__TX.ins.length - 1];
    checkTxInputCache(u, p);
    const a = this.data.inputs.length - 1, A = this.data.inputs[a];
    return A.nonWitnessUtxo && addNonWitnessTxCache(this.__CACHE, A, a), u.__FEE = void 0, u.__FEE_RATE = void 0, u.__EXTRACTED_TX = void 0, this;
  }
  addOutputs(c) {
    return c.forEach((u) => this.addOutput(u)), this;
  }
  addOutput(c) {
    if (arguments.length > 1 || !c || c.value === void 0 || c.address === void 0 && c.script === void 0)
      throw new Error(
        "Invalid arguments for Psbt.addOutput. Requires single object with at least [script or address] and [value]"
      );
    checkInputsForPartialSig(this.data.inputs, "addOutput");
    const { address: u } = c;
    if (typeof u == "string") {
      const { network: a } = this.opts, A = (0, address_1.toOutputScript)(u, a);
      c = Object.assign(c, { script: A });
    }
    (0, bip371_1.checkTaprootOutputFields)(c, c, "addOutput");
    const p = this.__CACHE;
    return this.data.addOutput(c), p.__FEE = void 0, p.__FEE_RATE = void 0, p.__EXTRACTED_TX = void 0, this;
  }
  extractTransaction(c) {
    if (!this.data.inputs.every(isFinalized)) throw new Error("Not finalized");
    const u = this.__CACHE;
    if (c || checkFees(this, u, this.opts), u.__EXTRACTED_TX) return u.__EXTRACTED_TX;
    const p = u.__TX.clone();
    return inputFinalizeGetAmts(this.data.inputs, p, u, !0), p;
  }
  getFeeRate() {
    return getTxCacheValue(
      "__FEE_RATE",
      "fee rate",
      this.data.inputs,
      this.__CACHE
    );
  }
  getFee() {
    return getTxCacheValue("__FEE", "fee", this.data.inputs, this.__CACHE);
  }
  finalizeAllInputs() {
    return (0, utils_1$x.checkForInput)(this.data.inputs, 0), range$2(this.data.inputs.length).forEach((c) => this.finalizeInput(c)), this;
  }
  finalizeInput(c, u) {
    const p = (0, utils_1$x.checkForInput)(this.data.inputs, c);
    return (0, bip371_1.isTaprootInput)(p) ? this._finalizeTaprootInput(
      c,
      p,
      void 0,
      u
    ) : this._finalizeInput(c, p, u);
  }
  finalizeTaprootInput(c, u, p = bip371_1.tapScriptFinalizer) {
    const a = (0, utils_1$x.checkForInput)(this.data.inputs, c);
    if ((0, bip371_1.isTaprootInput)(a))
      return this._finalizeTaprootInput(
        c,
        a,
        u,
        p
      );
    throw new Error(`Cannot finalize input #${c}. Not Taproot.`);
  }
  _finalizeInput(c, u, p = getFinalScripts) {
    const { script: a, isP2SH: A, isP2WSH: b, isSegwit: F } = getScriptFromInput(
      c,
      u,
      this.__CACHE
    );
    if (!a) throw new Error(`No script found for input #${c}`);
    checkPartialSigSighashes(u);
    const { finalScriptSig: le, finalScriptWitness: L } = p(
      c,
      u,
      a,
      F,
      A,
      b
    );
    if (le && this.data.updateInput(c, { finalScriptSig: le }), L && this.data.updateInput(c, { finalScriptWitness: L }), !le && !L)
      throw new Error(`Unknown error finalizing input #${c}`);
    return this.data.clearFinalizedInput(c), this;
  }
  _finalizeTaprootInput(c, u, p, a = bip371_1.tapScriptFinalizer) {
    if (!u.witnessUtxo)
      throw new Error(
        `Cannot finalize input #${c}. Missing withness utxo.`
      );
    if (u.tapKeySig) {
      const A = payments.p2tr({
        output: u.witnessUtxo.script,
        signature: u.tapKeySig
      }), b = (0, psbtutils_1.witnessStackToScriptWitness)(
        A.witness
      );
      this.data.updateInput(c, { finalScriptWitness: b });
    } else {
      const { finalScriptWitness: A } = a(
        c,
        u,
        p
      );
      this.data.updateInput(c, { finalScriptWitness: A });
    }
    return this.data.clearFinalizedInput(c), this;
  }
  getInputType(c) {
    const u = (0, utils_1$x.checkForInput)(this.data.inputs, c), p = getScriptFromUtxo(c, u, this.__CACHE), a = getMeaningfulScript(
      p,
      c,
      "input",
      u.redeemScript || redeemFromFinalScriptSig(u.finalScriptSig),
      u.witnessScript || redeemFromFinalWitnessScript(u.finalScriptWitness)
    ), A = a.type === "raw" ? "" : a.type + "-", b = classifyScript(a.meaningfulScript);
    return A + b;
  }
  inputHasPubkey(c, u) {
    const p = (0, utils_1$x.checkForInput)(this.data.inputs, c);
    return pubkeyInInput(u, p, c, this.__CACHE);
  }
  inputHasHDKey(c, u) {
    const p = (0, utils_1$x.checkForInput)(this.data.inputs, c), a = bip32DerivationIsMine(u);
    return !!p.bip32Derivation && p.bip32Derivation.some(a);
  }
  outputHasPubkey(c, u) {
    const p = (0, utils_1$x.checkForOutput)(this.data.outputs, c);
    return pubkeyInOutput(u, p, c, this.__CACHE);
  }
  outputHasHDKey(c, u) {
    const p = (0, utils_1$x.checkForOutput)(this.data.outputs, c), a = bip32DerivationIsMine(u);
    return !!p.bip32Derivation && p.bip32Derivation.some(a);
  }
  validateSignaturesOfAllInputs(c) {
    return (0, utils_1$x.checkForInput)(this.data.inputs, 0), range$2(this.data.inputs.length).map(
      (p) => this.validateSignaturesOfInput(p, c)
    ).reduce((p, a) => a === !0 && p, !0);
  }
  validateSignaturesOfInput(c, u, p) {
    const a = this.data.inputs[c];
    return (0, bip371_1.isTaprootInput)(a) ? this.validateSignaturesOfTaprootInput(
      c,
      u,
      p
    ) : this._validateSignaturesOfInput(c, u, p);
  }
  _validateSignaturesOfInput(c, u, p) {
    const a = this.data.inputs[c], A = (a || {}).partialSig;
    if (!a || !A || A.length < 1)
      throw new Error("No signatures to validate");
    if (typeof u != "function")
      throw new Error("Need validator function to validate signatures");
    const b = p ? A.filter(($) => $.pubkey.equals(p)) : A;
    if (b.length < 1) throw new Error("No signatures for this pubkey");
    const F = [];
    let le, L, pe;
    for (const $ of b) {
      const Ee = bscript.signature.decode($.signature), { hash: be, script: He } = pe !== Ee.hashType ? getHashForSig(
        c,
        Object.assign({}, a, { sighashType: Ee.hashType }),
        this.__CACHE,
        !0
      ) : { hash: le, script: L };
      pe = Ee.hashType, le = be, L = He, checkScriptForPubkey($.pubkey, He, "verify"), F.push(u($.pubkey, be, Ee.signature));
    }
    return F.every(($) => $ === !0);
  }
  validateSignaturesOfTaprootInput(c, u, p) {
    const a = this.data.inputs[c], A = (a || {}).tapKeySig, b = (a || {}).tapScriptSig;
    if (!a && !A && !(b && !b.length))
      throw new Error("No signatures to validate");
    if (typeof u != "function")
      throw new Error("Need validator function to validate signatures");
    p = p && (0, bip371_1.toXOnly)(p);
    const F = p ? getTaprootHashesForSig(
      c,
      a,
      this.data.inputs,
      p,
      this.__CACHE
    ) : getAllTaprootHashesForSig(
      c,
      a,
      this.data.inputs,
      this.__CACHE
    );
    if (!F.length) throw new Error("No signatures for this pubkey");
    const le = F.find((pe) => !pe.leafHash);
    let L = 0;
    if (A && le) {
      if (!u(
        le.pubkey,
        le.hash,
        trimTaprootSig(A)
      )) return !1;
      L++;
    }
    if (b)
      for (const pe of b) {
        const $ = F.find((Ee) => pe.pubkey.equals(Ee.pubkey));
        if ($) {
          if (!u(
            pe.pubkey,
            $.hash,
            trimTaprootSig(pe.signature)
          )) return !1;
          L++;
        }
      }
    return L > 0;
  }
  signAllInputsHD(c, u = [transaction_1.Transaction.SIGHASH_ALL]) {
    if (!c || !c.publicKey || !c.fingerprint)
      throw new Error("Need HDSigner to sign input");
    const p = [];
    for (const a of range$2(this.data.inputs.length))
      try {
        this.signInputHD(a, c, u), p.push(!0);
      } catch {
        p.push(!1);
      }
    if (p.every((a) => a === !1))
      throw new Error("No inputs were signed");
    return this;
  }
  signAllInputsHDAsync(c, u = [transaction_1.Transaction.SIGHASH_ALL]) {
    return new Promise((p, a) => {
      if (!c || !c.publicKey || !c.fingerprint)
        return a(new Error("Need HDSigner to sign input"));
      const A = [], b = [];
      for (const F of range$2(this.data.inputs.length))
        b.push(
          this.signInputHDAsync(F, c, u).then(
            () => {
              A.push(!0);
            },
            () => {
              A.push(!1);
            }
          )
        );
      return Promise.all(b).then(() => {
        if (A.every((F) => F === !1))
          return a(new Error("No inputs were signed"));
        p();
      });
    });
  }
  signInputHD(c, u, p = [transaction_1.Transaction.SIGHASH_ALL]) {
    if (!u || !u.publicKey || !u.fingerprint)
      throw new Error("Need HDSigner to sign input");
    return getSignersFromHD(c, this.data.inputs, u).forEach((A) => this.signInput(c, A, p)), this;
  }
  signInputHDAsync(c, u, p = [transaction_1.Transaction.SIGHASH_ALL]) {
    return new Promise((a, A) => {
      if (!u || !u.publicKey || !u.fingerprint)
        return A(new Error("Need HDSigner to sign input"));
      const F = getSignersFromHD(c, this.data.inputs, u).map(
        (le) => this.signInputAsync(c, le, p)
      );
      return Promise.all(F).then(() => {
        a();
      }).catch(A);
    });
  }
  signAllInputs(c, u) {
    if (!c || !c.publicKey)
      throw new Error("Need Signer to sign input");
    const p = [];
    for (const a of range$2(this.data.inputs.length))
      try {
        this.signInput(a, c, u), p.push(!0);
      } catch {
        p.push(!1);
      }
    if (p.every((a) => a === !1))
      throw new Error("No inputs were signed");
    return this;
  }
  signAllInputsAsync(c, u) {
    return new Promise((p, a) => {
      if (!c || !c.publicKey)
        return a(new Error("Need Signer to sign input"));
      const A = [], b = [];
      for (const [F] of this.data.inputs.entries())
        b.push(
          this.signInputAsync(F, c, u).then(
            () => {
              A.push(!0);
            },
            () => {
              A.push(!1);
            }
          )
        );
      return Promise.all(b).then(() => {
        if (A.every((F) => F === !1))
          return a(new Error("No inputs were signed"));
        p();
      });
    });
  }
  signInput(c, u, p) {
    if (!u || !u.publicKey)
      throw new Error("Need Signer to sign input");
    const a = (0, utils_1$x.checkForInput)(this.data.inputs, c);
    return (0, bip371_1.isTaprootInput)(a) ? this._signTaprootInput(
      c,
      a,
      u,
      void 0,
      p
    ) : this._signInput(c, u, p);
  }
  signTaprootInput(c, u, p, a) {
    if (!u || !u.publicKey)
      throw new Error("Need Signer to sign input");
    const A = (0, utils_1$x.checkForInput)(this.data.inputs, c);
    if ((0, bip371_1.isTaprootInput)(A))
      return this._signTaprootInput(
        c,
        A,
        u,
        p,
        a
      );
    throw new Error(`Input #${c} is not of type Taproot.`);
  }
  _signInput(c, u, p = [transaction_1.Transaction.SIGHASH_ALL]) {
    const { hash: a, sighashType: A } = getHashAndSighashType(
      this.data.inputs,
      c,
      u.publicKey,
      this.__CACHE,
      p
    ), b = [
      {
        pubkey: u.publicKey,
        signature: bscript.signature.encode(u.sign(a), A)
      }
    ];
    return this.data.updateInput(c, { partialSig: b }), this;
  }
  _signTaprootInput(c, u, p, a, A = [transaction_1.Transaction.SIGHASH_DEFAULT]) {
    const b = this.checkTaprootHashesForSig(
      c,
      u,
      p,
      a,
      A
    ), F = b.filter((L) => !L.leafHash).map(
      (L) => (0, bip371_1.serializeTaprootSignature)(
        p.signSchnorr(L.hash),
        u.sighashType
      )
    )[0], le = b.filter((L) => !!L.leafHash).map((L) => ({
      pubkey: (0, bip371_1.toXOnly)(p.publicKey),
      signature: (0, bip371_1.serializeTaprootSignature)(
        p.signSchnorr(L.hash),
        u.sighashType
      ),
      leafHash: L.leafHash
    }));
    return F && this.data.updateInput(c, { tapKeySig: F }), le.length && this.data.updateInput(c, { tapScriptSig: le }), this;
  }
  signInputAsync(c, u, p) {
    return Promise.resolve().then(() => {
      if (!u || !u.publicKey)
        throw new Error("Need Signer to sign input");
      const a = (0, utils_1$x.checkForInput)(this.data.inputs, c);
      return (0, bip371_1.isTaprootInput)(a) ? this._signTaprootInputAsync(
        c,
        a,
        u,
        void 0,
        p
      ) : this._signInputAsync(c, u, p);
    });
  }
  signTaprootInputAsync(c, u, p, a) {
    return Promise.resolve().then(() => {
      if (!u || !u.publicKey)
        throw new Error("Need Signer to sign input");
      const A = (0, utils_1$x.checkForInput)(this.data.inputs, c);
      if ((0, bip371_1.isTaprootInput)(A))
        return this._signTaprootInputAsync(
          c,
          A,
          u,
          p,
          a
        );
      throw new Error(`Input #${c} is not of type Taproot.`);
    });
  }
  _signInputAsync(c, u, p = [transaction_1.Transaction.SIGHASH_ALL]) {
    const { hash: a, sighashType: A } = getHashAndSighashType(
      this.data.inputs,
      c,
      u.publicKey,
      this.__CACHE,
      p
    );
    return Promise.resolve(u.sign(a)).then((b) => {
      const F = [
        {
          pubkey: u.publicKey,
          signature: bscript.signature.encode(b, A)
        }
      ];
      this.data.updateInput(c, { partialSig: F });
    });
  }
  async _signTaprootInputAsync(c, u, p, a, A = [transaction_1.Transaction.SIGHASH_DEFAULT]) {
    const b = this.checkTaprootHashesForSig(
      c,
      u,
      p,
      a,
      A
    ), F = [], le = b.filter((pe) => !pe.leafHash)[0];
    if (le) {
      const pe = Promise.resolve(
        p.signSchnorr(le.hash)
      ).then(($) => ({
        tapKeySig: (0, bip371_1.serializeTaprootSignature)(
          $,
          u.sighashType
        )
      }));
      F.push(pe);
    }
    const L = b.filter((pe) => !!pe.leafHash);
    if (L.length) {
      const pe = L.map(($) => Promise.resolve(p.signSchnorr($.hash)).then(
        (Ee) => ({ tapScriptSig: [
          {
            pubkey: (0, bip371_1.toXOnly)(p.publicKey),
            signature: (0, bip371_1.serializeTaprootSignature)(
              Ee,
              u.sighashType
            ),
            leafHash: $.leafHash
          }
        ] })
      ));
      F.push(...pe);
    }
    return Promise.all(F).then((pe) => {
      pe.forEach(($) => this.data.updateInput(c, $));
    });
  }
  checkTaprootHashesForSig(c, u, p, a, A) {
    if (typeof p.signSchnorr != "function")
      throw new Error(
        `Need Schnorr Signer to sign taproot input #${c}.`
      );
    const b = getTaprootHashesForSig(
      c,
      u,
      this.data.inputs,
      p.publicKey,
      this.__CACHE,
      a,
      A
    );
    if (!b || !b.length)
      throw new Error(
        `Can not sign for input #${c} with the key ${p.publicKey.toString(
          "hex"
        )}`
      );
    return b;
  }
  toBuffer() {
    return checkCache(this.__CACHE), this.data.toBuffer();
  }
  toHex() {
    return checkCache(this.__CACHE), this.data.toHex();
  }
  toBase64() {
    return checkCache(this.__CACHE), this.data.toBase64();
  }
  updateGlobal(c) {
    return this.data.updateGlobal(c), this;
  }
  updateInput(c, u) {
    return u.witnessScript && checkInvalidP2WSH(u.witnessScript), (0, bip371_1.checkTaprootInputFields)(
      this.data.inputs[c],
      u,
      "updateInput"
    ), this.data.updateInput(c, u), u.nonWitnessUtxo && addNonWitnessTxCache(
      this.__CACHE,
      this.data.inputs[c],
      c
    ), this;
  }
  updateOutput(c, u) {
    const p = this.data.outputs[c];
    return (0, bip371_1.checkTaprootOutputFields)(
      p,
      u,
      "updateOutput"
    ), this.data.updateOutput(c, u), this;
  }
  addUnknownKeyValToGlobal(c) {
    return this.data.addUnknownKeyValToGlobal(c), this;
  }
  addUnknownKeyValToInput(c, u) {
    return this.data.addUnknownKeyValToInput(c, u), this;
  }
  addUnknownKeyValToOutput(c, u) {
    return this.data.addUnknownKeyValToOutput(c, u), this;
  }
  clearFinalizedInput(c) {
    return this.data.clearFinalizedInput(c), this;
  }
}
psbt$3.Psbt = Psbt;
const transactionFromBuffer = (n) => new PsbtTransaction(n);
class PsbtTransaction {
  constructor(c = Buffer$f.from([2, 0, 0, 0, 0, 0, 0, 0, 0, 0])) {
    this.tx = transaction_1.Transaction.fromBuffer(c), checkTxEmpty(this.tx), Object.defineProperty(this, "tx", {
      enumerable: !1,
      writable: !0
    });
  }
  getInputOutputCounts() {
    return {
      inputCount: this.tx.ins.length,
      outputCount: this.tx.outs.length
    };
  }
  addInput(c) {
    if (c.hash === void 0 || c.index === void 0 || !Buffer$f.isBuffer(c.hash) && typeof c.hash != "string" || typeof c.index != "number")
      throw new Error("Error adding input.");
    const u = typeof c.hash == "string" ? (0, bufferutils_1.reverseBuffer)(Buffer$f.from(c.hash, "hex")) : c.hash;
    this.tx.addInput(u, c.index, c.sequence);
  }
  addOutput(c) {
    if (c.script === void 0 || c.value === void 0 || !Buffer$f.isBuffer(c.script) || typeof c.value != "number")
      throw new Error("Error adding output.");
    this.tx.addOutput(c.script, c.value);
  }
  toBuffer() {
    return this.tx.toBuffer();
  }
}
function canFinalize(n, c, u) {
  switch (u) {
    case "pubkey":
    case "pubkeyhash":
    case "witnesspubkeyhash":
      return hasSigs(1, n.partialSig);
    case "multisig":
      const p = payments.p2ms({ output: c });
      return hasSigs(p.m, n.partialSig, p.pubkeys);
    default:
      return !1;
  }
}
function checkCache(n) {
  if (n.__UNSAFE_SIGN_NONSEGWIT !== !1)
    throw new Error("Not BIP174 compliant, can not export");
}
function hasSigs(n, c, u) {
  if (!c) return !1;
  let p;
  if (u ? p = u.map((a) => {
    const A = compressPubkey(a);
    return c.find((b) => b.pubkey.equals(A));
  }).filter((a) => !!a) : p = c, p.length > n) throw new Error("Too many signatures");
  return p.length === n;
}
function isFinalized(n) {
  return !!n.finalScriptSig || !!n.finalScriptWitness;
}
function bip32DerivationIsMine(n) {
  return (c) => !(!c.masterFingerprint.equals(n.fingerprint) || !n.derivePath(c.path).publicKey.equals(c.pubkey));
}
function check32Bit(n) {
  if (typeof n != "number" || n !== Math.floor(n) || n > 4294967295 || n < 0)
    throw new Error("Invalid 32 bit integer");
}
function checkFees(n, c, u) {
  const p = c.__FEE_RATE || n.getFeeRate(), a = c.__EXTRACTED_TX.virtualSize(), A = p * a;
  if (p >= u.maximumFeeRate)
    throw new Error(
      `Warning: You are paying around ${(A / 1e8).toFixed(8)} in fees, which is ${p} satoshi per byte for a transaction with a VSize of ${a} bytes (segwit counted as 0.25 byte per byte). Use setMaximumFeeRate method to raise your threshold, or pass true to the first arg of extractTransaction.`
    );
}
function checkInputsForPartialSig(n, c) {
  n.forEach((u) => {
    if ((0, bip371_1.isTaprootInput)(u) ? (0, bip371_1.checkTaprootInputForSigs)(u, c) : (0, psbtutils_1.checkInputForSig)(u, c))
      throw new Error("Can not modify transaction, signatures exist.");
  });
}
function checkPartialSigSighashes(n) {
  if (!n.sighashType || !n.partialSig) return;
  const { partialSig: c, sighashType: u } = n;
  c.forEach((p) => {
    const { hashType: a } = bscript.signature.decode(p.signature);
    if (u !== a)
      throw new Error("Signature sighash does not match input sighash type");
  });
}
function checkScriptForPubkey(n, c, u) {
  if (!(0, psbtutils_1.pubkeyInScript)(n, c))
    throw new Error(
      `Can not ${u} for this input with the key ${n.toString("hex")}`
    );
}
function checkTxEmpty(n) {
  if (!n.ins.every(
    (u) => u.script && u.script.length === 0 && u.witness && u.witness.length === 0
  ))
    throw new Error("Format Error: Transaction ScriptSigs are not empty");
}
function checkTxForDupeIns(n, c) {
  n.ins.forEach((u) => {
    checkTxInputCache(c, u);
  });
}
function checkTxInputCache(n, c) {
  const u = (0, bufferutils_1.reverseBuffer)(Buffer$f.from(c.hash)).toString("hex") + ":" + c.index;
  if (n.__TX_IN_CACHE[u]) throw new Error("Duplicate input detected.");
  n.__TX_IN_CACHE[u] = 1;
}
function scriptCheckerFactory(n, c) {
  return (u, p, a, A) => {
    const b = n({
      redeem: { output: a }
    }).output;
    if (!p.equals(b))
      throw new Error(
        `${c} for ${A} #${u} doesn't match the scriptPubKey in the prevout`
      );
  };
}
const checkRedeemScript = scriptCheckerFactory(payments.p2sh, "Redeem script"), checkWitnessScript = scriptCheckerFactory(
  payments.p2wsh,
  "Witness script"
);
function getTxCacheValue(n, c, u, p) {
  if (!u.every(isFinalized))
    throw new Error(`PSBT must be finalized to calculate ${c}`);
  if (n === "__FEE_RATE" && p.__FEE_RATE) return p.__FEE_RATE;
  if (n === "__FEE" && p.__FEE) return p.__FEE;
  let a, A = !0;
  if (p.__EXTRACTED_TX ? (a = p.__EXTRACTED_TX, A = !1) : a = p.__TX.clone(), inputFinalizeGetAmts(u, a, p, A), n === "__FEE_RATE") return p.__FEE_RATE;
  if (n === "__FEE") return p.__FEE;
}
function getFinalScripts(n, c, u, p, a, A) {
  const b = classifyScript(u);
  if (!canFinalize(c, u, b))
    throw new Error(`Can not finalize input #${n}`);
  return prepareFinalScripts(
    u,
    b,
    c.partialSig,
    p,
    a,
    A
  );
}
function prepareFinalScripts(n, c, u, p, a, A) {
  let b, F;
  const le = getPayment(n, c, u), L = A ? payments.p2wsh({ redeem: le }) : null, pe = a ? payments.p2sh({ redeem: L || le }) : null;
  return p ? (L ? F = (0, psbtutils_1.witnessStackToScriptWitness)(
    L.witness
  ) : F = (0, psbtutils_1.witnessStackToScriptWitness)(
    le.witness
  ), pe && (b = pe.input)) : pe ? b = pe.input : b = le.input, {
    finalScriptSig: b,
    finalScriptWitness: F
  };
}
function getHashAndSighashType(n, c, u, p, a) {
  const A = (0, utils_1$x.checkForInput)(n, c), { hash: b, sighashType: F, script: le } = getHashForSig(
    c,
    A,
    p,
    !1,
    a
  );
  return checkScriptForPubkey(u, le, "sign"), {
    hash: b,
    sighashType: F
  };
}
function getHashForSig(n, c, u, p, a) {
  const A = u.__TX, b = c.sighashType || transaction_1.Transaction.SIGHASH_ALL;
  checkSighashTypeAllowed(b, a);
  let F, le;
  if (c.nonWitnessUtxo) {
    const $ = nonWitnessUtxoTxFromCache(
      u,
      c,
      n
    ), Ee = A.ins[n].hash, be = $.getHash();
    if (!Ee.equals(be))
      throw new Error(
        `Non-witness UTXO hash for input #${n} doesn't match the hash specified in the prevout`
      );
    const He = A.ins[n].index;
    le = $.outs[He];
  } else if (c.witnessUtxo)
    le = c.witnessUtxo;
  else
    throw new Error("Need a Utxo input item for signing");
  const { meaningfulScript: L, type: pe } = getMeaningfulScript(
    le.script,
    n,
    "input",
    c.redeemScript,
    c.witnessScript
  );
  if (["p2sh-p2wsh", "p2wsh"].indexOf(pe) >= 0)
    F = A.hashForWitnessV0(
      n,
      L,
      le.value,
      b
    );
  else if ((0, psbtutils_1.isP2WPKH)(L)) {
    const $ = payments.p2pkh({
      hash: L.slice(2)
    }).output;
    F = A.hashForWitnessV0(
      n,
      $,
      le.value,
      b
    );
  } else {
    if (c.nonWitnessUtxo === void 0 && u.__UNSAFE_SIGN_NONSEGWIT === !1)
      throw new Error(
        `Input #${n} has witnessUtxo but non-segwit script: ${L.toString("hex")}`
      );
    !p && u.__UNSAFE_SIGN_NONSEGWIT !== !1 && console.warn(
      `Warning: Signing non-segwit inputs without the full parent transaction means there is a chance that a miner could feed you incorrect information to trick you into paying large fees. This behavior is the same as Psbt's predecesor (TransactionBuilder - now removed) when signing non-segwit scripts. You are not able to export this Psbt with toBuffer|toBase64|toHex since it is not BIP174 compliant.
*********************
PROCEED WITH CAUTION!
*********************`
    ), F = A.hashForSignature(
      n,
      L,
      b
    );
  }
  return {
    script: L,
    sighashType: b,
    hash: F
  };
}
function getAllTaprootHashesForSig(n, c, u, p) {
  const a = [];
  if (c.tapInternalKey) {
    const b = getPrevoutTaprootKey(n, c, p);
    b && a.push(b);
  }
  if (c.tapScriptSig) {
    const b = c.tapScriptSig.map((F) => F.pubkey);
    a.push(...b);
  }
  return a.map(
    (b) => getTaprootHashesForSig(n, c, u, b, p)
  ).flat();
}
function getPrevoutTaprootKey(n, c, u) {
  const { script: p } = getScriptAndAmountFromUtxo(n, c, u);
  return (0, psbtutils_1.isP2TR)(p) ? p.subarray(2, 34) : null;
}
function trimTaprootSig(n) {
  return n.length === 64 ? n : n.subarray(0, 64);
}
function getTaprootHashesForSig(n, c, u, p, a, A, b) {
  const F = a.__TX, le = c.sighashType || transaction_1.Transaction.SIGHASH_DEFAULT;
  checkSighashTypeAllowed(le, b);
  const L = u.map(
    (He, Pe) => getScriptAndAmountFromUtxo(Pe, He, a)
  ), pe = L.map((He) => He.script), $ = L.map((He) => He.value), Ee = [];
  if (c.tapInternalKey && !A) {
    const He = getPrevoutTaprootKey(n, c, a) || Buffer$f.from([]);
    if ((0, bip371_1.toXOnly)(p).equals(He)) {
      const Pe = F.hashForWitnessV1(
        n,
        pe,
        $,
        le
      );
      Ee.push({ pubkey: p, hash: Pe });
    }
  }
  const be = (c.tapLeafScript || []).filter((He) => (0, psbtutils_1.pubkeyInScript)(p, He.script)).map((He) => {
    const Pe = (0, bip341_1.tapleafHash)({
      output: He.script,
      version: He.leafVersion
    });
    return Object.assign({ hash: Pe }, He);
  }).filter(
    (He) => !A || A.equals(He.hash)
  ).map((He) => {
    const Pe = F.hashForWitnessV1(
      n,
      pe,
      $,
      transaction_1.Transaction.SIGHASH_DEFAULT,
      He.hash
    );
    return {
      pubkey: p,
      hash: Pe,
      leafHash: He.hash
    };
  });
  return Ee.concat(be);
}
function checkSighashTypeAllowed(n, c) {
  if (c && c.indexOf(n) < 0) {
    const u = sighashTypeToString(n);
    throw new Error(
      `Sighash type is not allowed. Retry the sign method passing the sighashTypes array of whitelisted types. Sighash type: ${u}`
    );
  }
}
function getPayment(n, c, u) {
  let p;
  switch (c) {
    case "multisig":
      const a = getSortedSigs(n, u);
      p = payments.p2ms({
        output: n,
        signatures: a
      });
      break;
    case "pubkey":
      p = payments.p2pk({
        output: n,
        signature: u[0].signature
      });
      break;
    case "pubkeyhash":
      p = payments.p2pkh({
        output: n,
        pubkey: u[0].pubkey,
        signature: u[0].signature
      });
      break;
    case "witnesspubkeyhash":
      p = payments.p2wpkh({
        output: n,
        pubkey: u[0].pubkey,
        signature: u[0].signature
      });
      break;
  }
  return p;
}
function getScriptFromInput(n, c, u) {
  const p = u.__TX, a = {
    script: null,
    isSegwit: !1,
    isP2SH: !1,
    isP2WSH: !1
  };
  if (a.isP2SH = !!c.redeemScript, a.isP2WSH = !!c.witnessScript, c.witnessScript)
    a.script = c.witnessScript;
  else if (c.redeemScript)
    a.script = c.redeemScript;
  else if (c.nonWitnessUtxo) {
    const A = nonWitnessUtxoTxFromCache(
      u,
      c,
      n
    ), b = p.ins[n].index;
    a.script = A.outs[b].script;
  } else c.witnessUtxo && (a.script = c.witnessUtxo.script);
  return (c.witnessScript || (0, psbtutils_1.isP2WPKH)(a.script)) && (a.isSegwit = !0), a;
}
function getSignersFromHD(n, c, u) {
  const p = (0, utils_1$x.checkForInput)(c, n);
  if (!p.bip32Derivation || p.bip32Derivation.length === 0)
    throw new Error("Need bip32Derivation to sign with HD");
  const a = p.bip32Derivation.map((b) => {
    if (b.masterFingerprint.equals(u.fingerprint))
      return b;
  }).filter((b) => !!b);
  if (a.length === 0)
    throw new Error(
      "Need one bip32Derivation masterFingerprint to match the HDSigner fingerprint"
    );
  return a.map((b) => {
    const F = u.derivePath(b.path);
    if (!b.pubkey.equals(F.publicKey))
      throw new Error("pubkey did not match bip32Derivation");
    return F;
  });
}
function getSortedSigs(n, c) {
  return payments.p2ms({ output: n }).pubkeys.map((p) => (c.filter((a) => a.pubkey.equals(p))[0] || {}).signature).filter((p) => !!p);
}
function scriptWitnessToWitnessStack(n) {
  let c = 0;
  function u(b) {
    return c += b, n.slice(c - b, c);
  }
  function p() {
    const b = varuint$1.decode(n, c);
    return c += varuint$1.decode.bytes, b;
  }
  function a() {
    return u(p());
  }
  function A() {
    const b = p(), F = [];
    for (let le = 0; le < b; le++) F.push(a());
    return F;
  }
  return A();
}
function sighashTypeToString(n) {
  let c = n & transaction_1.Transaction.SIGHASH_ANYONECANPAY ? "SIGHASH_ANYONECANPAY | " : "";
  switch (n & 31) {
    case transaction_1.Transaction.SIGHASH_ALL:
      c += "SIGHASH_ALL";
      break;
    case transaction_1.Transaction.SIGHASH_SINGLE:
      c += "SIGHASH_SINGLE";
      break;
    case transaction_1.Transaction.SIGHASH_NONE:
      c += "SIGHASH_NONE";
      break;
  }
  return c;
}
function addNonWitnessTxCache(n, c, u) {
  n.__NON_WITNESS_UTXO_BUF_CACHE[u] = c.nonWitnessUtxo;
  const p = transaction_1.Transaction.fromBuffer(c.nonWitnessUtxo);
  n.__NON_WITNESS_UTXO_TX_CACHE[u] = p;
  const a = n, A = u;
  delete c.nonWitnessUtxo, Object.defineProperty(c, "nonWitnessUtxo", {
    enumerable: !0,
    get() {
      const b = a.__NON_WITNESS_UTXO_BUF_CACHE[A], F = a.__NON_WITNESS_UTXO_TX_CACHE[A];
      if (b !== void 0)
        return b;
      {
        const le = F.toBuffer();
        return a.__NON_WITNESS_UTXO_BUF_CACHE[A] = le, le;
      }
    },
    set(b) {
      a.__NON_WITNESS_UTXO_BUF_CACHE[A] = b;
    }
  });
}
function inputFinalizeGetAmts(n, c, u, p) {
  let a = 0;
  n.forEach((le, L) => {
    if (p && le.finalScriptSig && (c.ins[L].script = le.finalScriptSig), p && le.finalScriptWitness && (c.ins[L].witness = scriptWitnessToWitnessStack(
      le.finalScriptWitness
    )), le.witnessUtxo)
      a += le.witnessUtxo.value;
    else if (le.nonWitnessUtxo) {
      const pe = nonWitnessUtxoTxFromCache(u, le, L), $ = c.ins[L].index, Ee = pe.outs[$];
      a += Ee.value;
    }
  });
  const A = c.outs.reduce((le, L) => le + L.value, 0), b = a - A;
  if (b < 0)
    throw new Error("Outputs are spending more than Inputs");
  const F = c.virtualSize();
  u.__FEE = b, u.__EXTRACTED_TX = c, u.__FEE_RATE = Math.floor(b / F);
}
function nonWitnessUtxoTxFromCache(n, c, u) {
  const p = n.__NON_WITNESS_UTXO_TX_CACHE;
  return p[u] || addNonWitnessTxCache(n, c, u), p[u];
}
function getScriptFromUtxo(n, c, u) {
  const { script: p } = getScriptAndAmountFromUtxo(n, c, u);
  return p;
}
function getScriptAndAmountFromUtxo(n, c, u) {
  if (c.witnessUtxo !== void 0)
    return {
      script: c.witnessUtxo.script,
      value: c.witnessUtxo.value
    };
  if (c.nonWitnessUtxo !== void 0) {
    const a = nonWitnessUtxoTxFromCache(
      u,
      c,
      n
    ).outs[u.__TX.ins[n].index];
    return { script: a.script, value: a.value };
  } else
    throw new Error("Can't find pubkey in input without Utxo data");
}
function pubkeyInInput(n, c, u, p) {
  const a = getScriptFromUtxo(u, c, p), { meaningfulScript: A } = getMeaningfulScript(
    a,
    u,
    "input",
    c.redeemScript,
    c.witnessScript
  );
  return (0, psbtutils_1.pubkeyInScript)(n, A);
}
function pubkeyInOutput(n, c, u, p) {
  const a = p.__TX.outs[u].script, { meaningfulScript: A } = getMeaningfulScript(
    a,
    u,
    "output",
    c.redeemScript,
    c.witnessScript
  );
  return (0, psbtutils_1.pubkeyInScript)(n, A);
}
function redeemFromFinalScriptSig(n) {
  if (!n) return;
  const c = bscript.decompile(n);
  if (!c) return;
  const u = c[c.length - 1];
  if (!(!Buffer$f.isBuffer(u) || isPubkeyLike(u) || isSigLike(u) || !bscript.decompile(u)))
    return u;
}
function redeemFromFinalWitnessScript(n) {
  if (!n) return;
  const c = scriptWitnessToWitnessStack(n), u = c[c.length - 1];
  if (!(isPubkeyLike(u) || !bscript.decompile(u)))
    return u;
}
function compressPubkey(n) {
  if (n.length === 65) {
    const c = n[64] & 1, u = n.slice(0, 33);
    return u[0] = 2 | c, u;
  }
  return n.slice();
}
function isPubkeyLike(n) {
  return n.length === 33 && bscript.isCanonicalPubKey(n);
}
function isSigLike(n) {
  return bscript.isCanonicalScriptSignature(n);
}
function getMeaningfulScript(n, c, u, p, a) {
  const A = (0, psbtutils_1.isP2SHScript)(n), b = A && p && (0, psbtutils_1.isP2WSHScript)(p), F = (0, psbtutils_1.isP2WSHScript)(n);
  if (A && p === void 0)
    throw new Error("scriptPubkey is P2SH but redeemScript missing");
  if ((F || b) && a === void 0)
    throw new Error(
      "scriptPubkey or redeemScript is P2WSH but witnessScript missing"
    );
  let le;
  return b ? (le = a, checkRedeemScript(c, n, p, u), checkWitnessScript(c, p, a, u), checkInvalidP2WSH(le)) : F ? (le = a, checkWitnessScript(c, n, a, u), checkInvalidP2WSH(le)) : A ? (le = p, checkRedeemScript(c, n, p, u)) : le = n, {
    meaningfulScript: le,
    type: b ? "p2sh-p2wsh" : A ? "p2sh" : F ? "p2wsh" : "raw"
  };
}
function checkInvalidP2WSH(n) {
  if ((0, psbtutils_1.isP2WPKH)(n) || (0, psbtutils_1.isP2SHScript)(n))
    throw new Error("P2WPKH or P2SH can not be contained within P2WSH");
}
function classifyScript(n) {
  return (0, psbtutils_1.isP2WPKH)(n) ? "witnesspubkeyhash" : (0, psbtutils_1.isP2PKH)(n) ? "pubkeyhash" : (0, psbtutils_1.isP2MS)(n) ? "multisig" : (0, psbtutils_1.isP2PK)(n) ? "pubkey" : "nonstandard";
}
function range$2(n) {
  return [...Array(n).keys()];
}
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.initEccLib = n.Transaction = n.opcodes = n.Psbt = n.Block = n.script = n.payments = n.networks = n.crypto = n.address = void 0;
  const c = address$1;
  n.address = c;
  const u = crypto$9;
  n.crypto = u;
  const p = networks$3;
  n.networks = p;
  const a = payments$3;
  n.payments = a;
  const A = script$1;
  n.script = A;
  var b = block;
  Object.defineProperty(n, "Block", {
    enumerable: !0,
    get: function() {
      return b.Block;
    }
  });
  var F = psbt$3;
  Object.defineProperty(n, "Psbt", {
    enumerable: !0,
    get: function() {
      return F.Psbt;
    }
  });
  var le = ops;
  Object.defineProperty(n, "opcodes", {
    enumerable: !0,
    get: function() {
      return le.OPS;
    }
  });
  var L = transaction;
  Object.defineProperty(n, "Transaction", {
    enumerable: !0,
    get: function() {
      return L.Transaction;
    }
  });
  var pe = ecc_lib;
  Object.defineProperty(n, "initEccLib", {
    enumerable: !0,
    get: function() {
      return pe.initEccLib;
    }
  });
})(src$j);
var dist$x = {}, secp256k1$b = {}, _shortw_utils = {}, hmac$6 = {};
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.hmac = n.HMAC = void 0;
  const c = utils$O;
  class u extends c.Hash {
    constructor(A, b) {
      super(), this.finished = !1, this.destroyed = !1, (0, c.ahash)(A);
      const F = (0, c.toBytes)(b);
      if (this.iHash = A.create(), typeof this.iHash.update != "function")
        throw new Error("Expected instance of class which extends utils.Hash");
      this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
      const le = this.blockLen, L = new Uint8Array(le);
      L.set(F.length > le ? A.create().update(F).digest() : F);
      for (let pe = 0; pe < L.length; pe++)
        L[pe] ^= 54;
      this.iHash.update(L), this.oHash = A.create();
      for (let pe = 0; pe < L.length; pe++)
        L[pe] ^= 106;
      this.oHash.update(L), (0, c.clean)(L);
    }
    update(A) {
      return (0, c.aexists)(this), this.iHash.update(A), this;
    }
    digestInto(A) {
      (0, c.aexists)(this), (0, c.abytes)(A, this.outputLen), this.finished = !0, this.iHash.digestInto(A), this.oHash.update(A), this.oHash.digestInto(A), this.destroy();
    }
    digest() {
      const A = new Uint8Array(this.oHash.outputLen);
      return this.digestInto(A), A;
    }
    _cloneInto(A) {
      A || (A = Object.create(Object.getPrototypeOf(this), {}));
      const { oHash: b, iHash: F, finished: le, destroyed: L, blockLen: pe, outputLen: $ } = this;
      return A = A, A.finished = le, A.destroyed = L, A.blockLen = pe, A.outputLen = $, A.oHash = b._cloneInto(A.oHash), A.iHash = F._cloneInto(A.iHash), A;
    }
    clone() {
      return this._cloneInto();
    }
    destroy() {
      this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
    }
  }
  n.HMAC = u;
  const p = (a, A, b) => new u(a, A).update(b).digest();
  n.hmac = p, n.hmac.create = (a, A) => new u(a, A);
})(hmac$6);
var weierstrass$3 = {}, curve$2 = {}, modular = {}, utils$M = {};
Object.defineProperty(utils$M, "__esModule", { value: !0 });
utils$M.notImplemented = utils$M.bitMask = void 0;
utils$M.isBytes = isBytes$c;
utils$M.abytes = abytes$5;
utils$M.abool = abool$1;
utils$M.numberToHexUnpadded = numberToHexUnpadded$3;
utils$M.hexToNumber = hexToNumber$3;
utils$M.bytesToHex = bytesToHex$6;
utils$M.hexToBytes = hexToBytes$6;
utils$M.bytesToNumberBE = bytesToNumberBE$3;
utils$M.bytesToNumberLE = bytesToNumberLE$3;
utils$M.numberToBytesBE = numberToBytesBE$3;
utils$M.numberToBytesLE = numberToBytesLE$3;
utils$M.numberToVarBytesBE = numberToVarBytesBE$2;
utils$M.ensureBytes = ensureBytes$3;
utils$M.concatBytes = concatBytes$8;
utils$M.equalBytes = equalBytes$4;
utils$M.utf8ToBytes = utf8ToBytes$9;
utils$M.inRange = inRange$1;
utils$M.aInRange = aInRange$1;
utils$M.bitLen = bitLen$3;
utils$M.bitGet = bitGet$2;
utils$M.bitSet = bitSet$2;
utils$M.createHmacDrbg = createHmacDrbg$3;
utils$M.validateObject = validateObject$3;
utils$M.memoized = memoized$1;
const _0n$m = /* @__PURE__ */ BigInt(0), _1n$k = /* @__PURE__ */ BigInt(1);
function isBytes$c(n) {
  return n instanceof Uint8Array || ArrayBuffer.isView(n) && n.constructor.name === "Uint8Array";
}
function abytes$5(n) {
  if (!isBytes$c(n))
    throw new Error("Uint8Array expected");
}
function abool$1(n, c) {
  if (typeof c != "boolean")
    throw new Error(n + " boolean expected, got " + c);
}
function numberToHexUnpadded$3(n) {
  const c = n.toString(16);
  return c.length & 1 ? "0" + c : c;
}
function hexToNumber$3(n) {
  if (typeof n != "string")
    throw new Error("hex string expected, got " + typeof n);
  return n === "" ? _0n$m : BigInt("0x" + n);
}
const hasHexBuiltin$3 = (
  // @ts-ignore
  typeof Uint8Array.from([]).toHex == "function" && typeof Uint8Array.fromHex == "function"
), hexes$4 = /* @__PURE__ */ Array.from({ length: 256 }, (n, c) => c.toString(16).padStart(2, "0"));
function bytesToHex$6(n) {
  if (abytes$5(n), hasHexBuiltin$3)
    return n.toHex();
  let c = "";
  for (let u = 0; u < n.length; u++)
    c += hexes$4[n[u]];
  return c;
}
const asciis$3 = { _0: 48, _9: 57, A: 65, F: 70, a: 97, f: 102 };
function asciiToBase16$3(n) {
  if (n >= asciis$3._0 && n <= asciis$3._9)
    return n - asciis$3._0;
  if (n >= asciis$3.A && n <= asciis$3.F)
    return n - (asciis$3.A - 10);
  if (n >= asciis$3.a && n <= asciis$3.f)
    return n - (asciis$3.a - 10);
}
function hexToBytes$6(n) {
  if (typeof n != "string")
    throw new Error("hex string expected, got " + typeof n);
  if (hasHexBuiltin$3)
    return Uint8Array.fromHex(n);
  const c = n.length, u = c / 2;
  if (c % 2)
    throw new Error("hex string expected, got unpadded hex of length " + c);
  const p = new Uint8Array(u);
  for (let a = 0, A = 0; a < u; a++, A += 2) {
    const b = asciiToBase16$3(n.charCodeAt(A)), F = asciiToBase16$3(n.charCodeAt(A + 1));
    if (b === void 0 || F === void 0) {
      const le = n[A] + n[A + 1];
      throw new Error('hex string expected, got non-hex character "' + le + '" at index ' + A);
    }
    p[a] = b * 16 + F;
  }
  return p;
}
function bytesToNumberBE$3(n) {
  return hexToNumber$3(bytesToHex$6(n));
}
function bytesToNumberLE$3(n) {
  return abytes$5(n), hexToNumber$3(bytesToHex$6(Uint8Array.from(n).reverse()));
}
function numberToBytesBE$3(n, c) {
  return hexToBytes$6(n.toString(16).padStart(c * 2, "0"));
}
function numberToBytesLE$3(n, c) {
  return numberToBytesBE$3(n, c).reverse();
}
function numberToVarBytesBE$2(n) {
  return hexToBytes$6(numberToHexUnpadded$3(n));
}
function ensureBytes$3(n, c, u) {
  let p;
  if (typeof c == "string")
    try {
      p = hexToBytes$6(c);
    } catch (A) {
      throw new Error(n + " must be hex string or Uint8Array, cause: " + A);
    }
  else if (isBytes$c(c))
    p = Uint8Array.from(c);
  else
    throw new Error(n + " must be hex string or Uint8Array");
  const a = p.length;
  if (typeof u == "number" && a !== u)
    throw new Error(n + " of length " + u + " expected, got " + a);
  return p;
}
function concatBytes$8(...n) {
  let c = 0;
  for (let p = 0; p < n.length; p++) {
    const a = n[p];
    abytes$5(a), c += a.length;
  }
  const u = new Uint8Array(c);
  for (let p = 0, a = 0; p < n.length; p++) {
    const A = n[p];
    u.set(A, a), a += A.length;
  }
  return u;
}
function equalBytes$4(n, c) {
  if (n.length !== c.length)
    return !1;
  let u = 0;
  for (let p = 0; p < n.length; p++)
    u |= n[p] ^ c[p];
  return u === 0;
}
function utf8ToBytes$9(n) {
  if (typeof n != "string")
    throw new Error("string expected");
  return new Uint8Array(new TextEncoder().encode(n));
}
const isPosBig$1 = (n) => typeof n == "bigint" && _0n$m <= n;
function inRange$1(n, c, u) {
  return isPosBig$1(n) && isPosBig$1(c) && isPosBig$1(u) && c <= n && n < u;
}
function aInRange$1(n, c, u, p) {
  if (!inRange$1(c, u, p))
    throw new Error("expected valid " + n + ": " + u + " <= n < " + p + ", got " + c);
}
function bitLen$3(n) {
  let c;
  for (c = 0; n > _0n$m; n >>= _1n$k, c += 1)
    ;
  return c;
}
function bitGet$2(n, c) {
  return n >> BigInt(c) & _1n$k;
}
function bitSet$2(n, c, u) {
  return n | (u ? _1n$k : _0n$m) << BigInt(c);
}
const bitMask$3 = (n) => (_1n$k << BigInt(n)) - _1n$k;
utils$M.bitMask = bitMask$3;
const u8n$3 = (n) => new Uint8Array(n), u8fr$3 = (n) => Uint8Array.from(n);
function createHmacDrbg$3(n, c, u) {
  if (typeof n != "number" || n < 2)
    throw new Error("hashLen must be a number");
  if (typeof c != "number" || c < 2)
    throw new Error("qByteLen must be a number");
  if (typeof u != "function")
    throw new Error("hmacFn must be a function");
  let p = u8n$3(n), a = u8n$3(n), A = 0;
  const b = () => {
    p.fill(1), a.fill(0), A = 0;
  }, F = (...$) => u(a, p, ...$), le = ($ = u8n$3(0)) => {
    a = F(u8fr$3([0]), $), p = F(), $.length !== 0 && (a = F(u8fr$3([1]), $), p = F());
  }, L = () => {
    if (A++ >= 1e3)
      throw new Error("drbg: tried 1000 values");
    let $ = 0;
    const Ee = [];
    for (; $ < c; ) {
      p = F();
      const be = p.slice();
      Ee.push(be), $ += p.length;
    }
    return concatBytes$8(...Ee);
  };
  return ($, Ee) => {
    b(), le($);
    let be;
    for (; !(be = Ee(L())); )
      le();
    return b(), be;
  };
}
const validatorFns$3 = {
  bigint: (n) => typeof n == "bigint",
  function: (n) => typeof n == "function",
  boolean: (n) => typeof n == "boolean",
  string: (n) => typeof n == "string",
  stringOrUint8Array: (n) => typeof n == "string" || isBytes$c(n),
  isSafeInteger: (n) => Number.isSafeInteger(n),
  array: (n) => Array.isArray(n),
  field: (n, c) => c.Fp.isValid(n),
  hash: (n) => typeof n == "function" && Number.isSafeInteger(n.outputLen)
};
function validateObject$3(n, c, u = {}) {
  const p = (a, A, b) => {
    const F = validatorFns$3[A];
    if (typeof F != "function")
      throw new Error("invalid validator function");
    const le = n[a];
    if (!(b && le === void 0) && !F(le, n))
      throw new Error("param " + String(a) + " is invalid. Expected " + A + ", got " + le);
  };
  for (const [a, A] of Object.entries(c))
    p(a, A, !1);
  for (const [a, A] of Object.entries(u))
    p(a, A, !0);
  return n;
}
const notImplemented = () => {
  throw new Error("not implemented");
};
utils$M.notImplemented = notImplemented;
function memoized$1(n) {
  const c = /* @__PURE__ */ new WeakMap();
  return (u, ...p) => {
    const a = c.get(u);
    if (a !== void 0)
      return a;
    const A = n(u, ...p);
    return c.set(u, A), A;
  };
}
Object.defineProperty(modular, "__esModule", { value: !0 });
modular.isNegativeLE = void 0;
modular.mod = mod$4;
modular.pow = pow$4;
modular.pow2 = pow2$3;
modular.invert = invert$3;
modular.tonelliShanks = tonelliShanks$3;
modular.FpSqrt = FpSqrt$3;
modular.validateField = validateField$3;
modular.FpPow = FpPow$3;
modular.FpInvertBatch = FpInvertBatch$3;
modular.FpDiv = FpDiv;
modular.FpLegendre = FpLegendre$1;
modular.FpIsSquare = FpIsSquare;
modular.nLength = nLength$3;
modular.Field = Field$5;
modular.FpSqrtOdd = FpSqrtOdd;
modular.FpSqrtEven = FpSqrtEven;
modular.hashToPrivateScalar = hashToPrivateScalar$1;
modular.getFieldBytesLength = getFieldBytesLength$2;
modular.getMinHashLength = getMinHashLength$2;
modular.mapHashToField = mapHashToField$2;
const utils_1$w = utils$O, utils_ts_1$6 = utils$M, _0n$l = BigInt(0), _1n$j = BigInt(1), _2n$c = /* @__PURE__ */ BigInt(2), _3n$7 = /* @__PURE__ */ BigInt(3), _4n$7 = /* @__PURE__ */ BigInt(4), _5n$3 = /* @__PURE__ */ BigInt(5), _8n$3 = /* @__PURE__ */ BigInt(8);
function mod$4(n, c) {
  const u = n % c;
  return u >= _0n$l ? u : c + u;
}
function pow$4(n, c, u) {
  return FpPow$3(Field$5(u), n, c);
}
function pow2$3(n, c, u) {
  let p = n;
  for (; c-- > _0n$l; )
    p *= p, p %= u;
  return p;
}
function invert$3(n, c) {
  if (n === _0n$l)
    throw new Error("invert: expected non-zero number");
  if (c <= _0n$l)
    throw new Error("invert: expected positive modulus, got " + c);
  let u = mod$4(n, c), p = c, a = _0n$l, A = _1n$j;
  for (; u !== _0n$l; ) {
    const F = p / u, le = p % u, L = a - A * F;
    p = u, u = le, a = A, A = L;
  }
  if (p !== _1n$j)
    throw new Error("invert: does not exist");
  return mod$4(a, c);
}
function sqrt3mod4$1(n, c) {
  const u = (n.ORDER + _1n$j) / _4n$7, p = n.pow(c, u);
  if (!n.eql(n.sqr(p), c))
    throw new Error("Cannot find square root");
  return p;
}
function sqrt5mod8$1(n, c) {
  const u = (n.ORDER - _5n$3) / _8n$3, p = n.mul(c, _2n$c), a = n.pow(p, u), A = n.mul(c, a), b = n.mul(n.mul(A, _2n$c), a), F = n.mul(A, n.sub(b, n.ONE));
  if (!n.eql(n.sqr(F), c))
    throw new Error("Cannot find square root");
  return F;
}
function tonelliShanks$3(n) {
  if (n < BigInt(3))
    throw new Error("sqrt is not defined for small field");
  let c = n - _1n$j, u = 0;
  for (; c % _2n$c === _0n$l; )
    c /= _2n$c, u++;
  let p = _2n$c;
  const a = Field$5(n);
  for (; FpLegendre$1(a, p) === 1; )
    if (p++ > 1e3)
      throw new Error("Cannot find square root: probably non-prime P");
  if (u === 1)
    return sqrt3mod4$1;
  let A = a.pow(p, c);
  const b = (c + _1n$j) / _2n$c;
  return function(le, L) {
    if (le.is0(L))
      return L;
    if (FpLegendre$1(le, L) !== 1)
      throw new Error("Cannot find square root");
    let pe = u, $ = le.mul(le.ONE, A), Ee = le.pow(L, c), be = le.pow(L, b);
    for (; !le.eql(Ee, le.ONE); ) {
      if (le.is0(Ee))
        return le.ZERO;
      let He = 1, Pe = le.sqr(Ee);
      for (; !le.eql(Pe, le.ONE); )
        if (He++, Pe = le.sqr(Pe), He === pe)
          throw new Error("Cannot find square root");
      const nr = _1n$j << BigInt(pe - He - 1), ir = le.pow($, nr);
      pe = He, $ = le.sqr(ir), Ee = le.mul(Ee, $), be = le.mul(be, ir);
    }
    return be;
  };
}
function FpSqrt$3(n) {
  return n % _4n$7 === _3n$7 ? sqrt3mod4$1 : n % _8n$3 === _5n$3 ? sqrt5mod8$1 : tonelliShanks$3(n);
}
const isNegativeLE = (n, c) => (mod$4(n, c) & _1n$j) === _1n$j;
modular.isNegativeLE = isNegativeLE;
const FIELD_FIELDS$3 = [
  "create",
  "isValid",
  "is0",
  "neg",
  "inv",
  "sqrt",
  "sqr",
  "eql",
  "add",
  "sub",
  "mul",
  "pow",
  "div",
  "addN",
  "subN",
  "mulN",
  "sqrN"
];
function validateField$3(n) {
  const c = {
    ORDER: "bigint",
    MASK: "bigint",
    BYTES: "isSafeInteger",
    BITS: "isSafeInteger"
  }, u = FIELD_FIELDS$3.reduce((p, a) => (p[a] = "function", p), c);
  return (0, utils_ts_1$6.validateObject)(n, u);
}
function FpPow$3(n, c, u) {
  if (u < _0n$l)
    throw new Error("invalid exponent, negatives unsupported");
  if (u === _0n$l)
    return n.ONE;
  if (u === _1n$j)
    return c;
  let p = n.ONE, a = c;
  for (; u > _0n$l; )
    u & _1n$j && (p = n.mul(p, a)), a = n.sqr(a), u >>= _1n$j;
  return p;
}
function FpInvertBatch$3(n, c, u = !1) {
  const p = new Array(c.length).fill(u ? n.ZERO : void 0), a = c.reduce((b, F, le) => n.is0(F) ? b : (p[le] = b, n.mul(b, F)), n.ONE), A = n.inv(a);
  return c.reduceRight((b, F, le) => n.is0(F) ? b : (p[le] = n.mul(b, p[le]), n.mul(b, F)), A), p;
}
function FpDiv(n, c, u) {
  return n.mul(c, typeof u == "bigint" ? invert$3(u, n.ORDER) : n.inv(u));
}
function FpLegendre$1(n, c) {
  const u = (n.ORDER - _1n$j) / _2n$c, p = n.pow(c, u), a = n.eql(p, n.ONE), A = n.eql(p, n.ZERO), b = n.eql(p, n.neg(n.ONE));
  if (!a && !A && !b)
    throw new Error("invalid Legendre symbol result");
  return a ? 1 : A ? 0 : -1;
}
function FpIsSquare(n, c) {
  return FpLegendre$1(n, c) === 1;
}
function nLength$3(n, c) {
  c !== void 0 && (0, utils_1$w.anumber)(c);
  const u = c !== void 0 ? c : n.toString(2).length, p = Math.ceil(u / 8);
  return { nBitLength: u, nByteLength: p };
}
function Field$5(n, c, u = !1, p = {}) {
  if (n <= _0n$l)
    throw new Error("invalid field: expected ORDER > 0, got " + n);
  const { nBitLength: a, nByteLength: A } = nLength$3(n, c);
  if (A > 2048)
    throw new Error("invalid field: expected ORDER of <= 2048 bytes");
  let b;
  const F = Object.freeze({
    ORDER: n,
    isLE: u,
    BITS: a,
    BYTES: A,
    MASK: (0, utils_ts_1$6.bitMask)(a),
    ZERO: _0n$l,
    ONE: _1n$j,
    create: (le) => mod$4(le, n),
    isValid: (le) => {
      if (typeof le != "bigint")
        throw new Error("invalid field element: expected bigint, got " + typeof le);
      return _0n$l <= le && le < n;
    },
    is0: (le) => le === _0n$l,
    isOdd: (le) => (le & _1n$j) === _1n$j,
    neg: (le) => mod$4(-le, n),
    eql: (le, L) => le === L,
    sqr: (le) => mod$4(le * le, n),
    add: (le, L) => mod$4(le + L, n),
    sub: (le, L) => mod$4(le - L, n),
    mul: (le, L) => mod$4(le * L, n),
    pow: (le, L) => FpPow$3(F, le, L),
    div: (le, L) => mod$4(le * invert$3(L, n), n),
    // Same as above, but doesn't normalize
    sqrN: (le) => le * le,
    addN: (le, L) => le + L,
    subN: (le, L) => le - L,
    mulN: (le, L) => le * L,
    inv: (le) => invert$3(le, n),
    sqrt: p.sqrt || ((le) => (b || (b = FpSqrt$3(n)), b(F, le))),
    toBytes: (le) => u ? (0, utils_ts_1$6.numberToBytesLE)(le, A) : (0, utils_ts_1$6.numberToBytesBE)(le, A),
    fromBytes: (le) => {
      if (le.length !== A)
        throw new Error("Field.fromBytes: expected " + A + " bytes, got " + le.length);
      return u ? (0, utils_ts_1$6.bytesToNumberLE)(le) : (0, utils_ts_1$6.bytesToNumberBE)(le);
    },
    // TODO: we don't need it here, move out to separate fn
    invertBatch: (le) => FpInvertBatch$3(F, le),
    // We can't move this out because Fp6, Fp12 implement it
    // and it's unclear what to return in there.
    cmov: (le, L, pe) => pe ? L : le
  });
  return Object.freeze(F);
}
function FpSqrtOdd(n, c) {
  if (!n.isOdd)
    throw new Error("Field doesn't have isOdd");
  const u = n.sqrt(c);
  return n.isOdd(u) ? u : n.neg(u);
}
function FpSqrtEven(n, c) {
  if (!n.isOdd)
    throw new Error("Field doesn't have isOdd");
  const u = n.sqrt(c);
  return n.isOdd(u) ? n.neg(u) : u;
}
function hashToPrivateScalar$1(n, c, u = !1) {
  n = (0, utils_ts_1$6.ensureBytes)("privateHash", n);
  const p = n.length, a = nLength$3(c).nByteLength + 8;
  if (a < 24 || p < a || p > 1024)
    throw new Error("hashToPrivateScalar: expected " + a + "-1024 bytes of input, got " + p);
  const A = u ? (0, utils_ts_1$6.bytesToNumberLE)(n) : (0, utils_ts_1$6.bytesToNumberBE)(n);
  return mod$4(A, c - _1n$j) + _1n$j;
}
function getFieldBytesLength$2(n) {
  if (typeof n != "bigint")
    throw new Error("field order must be bigint");
  const c = n.toString(2).length;
  return Math.ceil(c / 8);
}
function getMinHashLength$2(n) {
  const c = getFieldBytesLength$2(n);
  return c + Math.ceil(c / 2);
}
function mapHashToField$2(n, c, u = !1) {
  const p = n.length, a = getFieldBytesLength$2(c), A = getMinHashLength$2(c);
  if (p < 16 || p < A || p > 1024)
    throw new Error("expected " + A + "-1024 bytes of input, got " + p);
  const b = u ? (0, utils_ts_1$6.bytesToNumberLE)(n) : (0, utils_ts_1$6.bytesToNumberBE)(n), F = mod$4(b, c - _1n$j) + _1n$j;
  return u ? (0, utils_ts_1$6.numberToBytesLE)(F, a) : (0, utils_ts_1$6.numberToBytesBE)(F, a);
}
Object.defineProperty(curve$2, "__esModule", { value: !0 });
curve$2.wNAF = wNAF$3;
curve$2.pippenger = pippenger$1;
curve$2.precomputeMSMUnsafe = precomputeMSMUnsafe;
curve$2.validateBasic = validateBasic$3;
const modular_ts_1$1 = modular, utils_ts_1$5 = utils$M, _0n$k = BigInt(0), _1n$i = BigInt(1);
function constTimeNegate$1(n, c) {
  const u = c.negate();
  return n ? u : c;
}
function validateW$1(n, c) {
  if (!Number.isSafeInteger(n) || n <= 0 || n > c)
    throw new Error("invalid window size, expected [1.." + c + "], got W=" + n);
}
function calcWOpts$1(n, c) {
  validateW$1(n, c);
  const u = Math.ceil(c / n) + 1, p = 2 ** (n - 1), a = 2 ** n, A = (0, utils_ts_1$5.bitMask)(n), b = BigInt(n);
  return { windows: u, windowSize: p, mask: A, maxNumber: a, shiftBy: b };
}
function calcOffsets$1(n, c, u) {
  const { windowSize: p, mask: a, maxNumber: A, shiftBy: b } = u;
  let F = Number(n & a), le = n >> b;
  F > p && (F -= A, le += _1n$i);
  const L = c * p, pe = L + Math.abs(F) - 1, $ = F === 0, Ee = F < 0, be = c % 2 !== 0;
  return { nextN: le, offset: pe, isZero: $, isNeg: Ee, isNegF: be, offsetF: L };
}
function validateMSMPoints$1(n, c) {
  if (!Array.isArray(n))
    throw new Error("array expected");
  n.forEach((u, p) => {
    if (!(u instanceof c))
      throw new Error("invalid point at index " + p);
  });
}
function validateMSMScalars$1(n, c) {
  if (!Array.isArray(n))
    throw new Error("array of scalars expected");
  n.forEach((u, p) => {
    if (!c.isValid(u))
      throw new Error("invalid scalar at index " + p);
  });
}
const pointPrecomputes$1 = /* @__PURE__ */ new WeakMap(), pointWindowSizes$1 = /* @__PURE__ */ new WeakMap();
function getW$1(n) {
  return pointWindowSizes$1.get(n) || 1;
}
function wNAF$3(n, c) {
  return {
    constTimeNegate: constTimeNegate$1,
    hasPrecomputes(u) {
      return getW$1(u) !== 1;
    },
    // non-const time multiplication ladder
    unsafeLadder(u, p, a = n.ZERO) {
      let A = u;
      for (; p > _0n$k; )
        p & _1n$i && (a = a.add(A)), A = A.double(), p >>= _1n$i;
      return a;
    },
    /**
     * Creates a wNAF precomputation window. Used for caching.
     * Default window size is set by `utils.precompute()` and is equal to 8.
     * Number of precomputed points depends on the curve size:
     * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
     * - 𝑊 is the window size
     * - 𝑛 is the bitlength of the curve order.
     * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
     * @param elm Point instance
     * @param W window size
     * @returns precomputed point tables flattened to a single array
     */
    precomputeWindow(u, p) {
      const { windows: a, windowSize: A } = calcWOpts$1(p, c), b = [];
      let F = u, le = F;
      for (let L = 0; L < a; L++) {
        le = F, b.push(le);
        for (let pe = 1; pe < A; pe++)
          le = le.add(F), b.push(le);
        F = le.double();
      }
      return b;
    },
    /**
     * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
     * @param W window size
     * @param precomputes precomputed tables
     * @param n scalar (we don't check here, but should be less than curve order)
     * @returns real and fake (for const-time) points
     */
    wNAF(u, p, a) {
      let A = n.ZERO, b = n.BASE;
      const F = calcWOpts$1(u, c);
      for (let le = 0; le < F.windows; le++) {
        const { nextN: L, offset: pe, isZero: $, isNeg: Ee, isNegF: be, offsetF: He } = calcOffsets$1(a, le, F);
        a = L, $ ? b = b.add(constTimeNegate$1(be, p[He])) : A = A.add(constTimeNegate$1(Ee, p[pe]));
      }
      return { p: A, f: b };
    },
    /**
     * Implements ec unsafe (non const-time) multiplication using precomputed tables and w-ary non-adjacent form.
     * @param W window size
     * @param precomputes precomputed tables
     * @param n scalar (we don't check here, but should be less than curve order)
     * @param acc accumulator point to add result of multiplication
     * @returns point
     */
    wNAFUnsafe(u, p, a, A = n.ZERO) {
      const b = calcWOpts$1(u, c);
      for (let F = 0; F < b.windows && a !== _0n$k; F++) {
        const { nextN: le, offset: L, isZero: pe, isNeg: $ } = calcOffsets$1(a, F, b);
        if (a = le, !pe) {
          const Ee = p[L];
          A = A.add($ ? Ee.negate() : Ee);
        }
      }
      return A;
    },
    getPrecomputes(u, p, a) {
      let A = pointPrecomputes$1.get(p);
      return A || (A = this.precomputeWindow(p, u), u !== 1 && pointPrecomputes$1.set(p, a(A))), A;
    },
    wNAFCached(u, p, a) {
      const A = getW$1(u);
      return this.wNAF(A, this.getPrecomputes(A, u, a), p);
    },
    wNAFCachedUnsafe(u, p, a, A) {
      const b = getW$1(u);
      return b === 1 ? this.unsafeLadder(u, p, A) : this.wNAFUnsafe(b, this.getPrecomputes(b, u, a), p, A);
    },
    // We calculate precomputes for elliptic curve point multiplication
    // using windowed method. This specifies window size and
    // stores precomputed values. Usually only base point would be precomputed.
    setWindowSize(u, p) {
      validateW$1(p, c), pointWindowSizes$1.set(u, p), pointPrecomputes$1.delete(u);
    }
  };
}
function pippenger$1(n, c, u, p) {
  validateMSMPoints$1(u, n), validateMSMScalars$1(p, c);
  const a = u.length, A = p.length;
  if (a !== A)
    throw new Error("arrays of points and scalars must have equal length");
  const b = n.ZERO, F = (0, utils_ts_1$5.bitLen)(BigInt(a));
  let le = 1;
  F > 12 ? le = F - 3 : F > 4 ? le = F - 2 : F > 0 && (le = 2);
  const L = (0, utils_ts_1$5.bitMask)(le), pe = new Array(Number(L) + 1).fill(b), $ = Math.floor((c.BITS - 1) / le) * le;
  let Ee = b;
  for (let be = $; be >= 0; be -= le) {
    pe.fill(b);
    for (let Pe = 0; Pe < A; Pe++) {
      const nr = p[Pe], ir = Number(nr >> BigInt(be) & L);
      pe[ir] = pe[ir].add(u[Pe]);
    }
    let He = b;
    for (let Pe = pe.length - 1, nr = b; Pe > 0; Pe--)
      nr = nr.add(pe[Pe]), He = He.add(nr);
    if (Ee = Ee.add(He), be !== 0)
      for (let Pe = 0; Pe < le; Pe++)
        Ee = Ee.double();
  }
  return Ee;
}
function precomputeMSMUnsafe(n, c, u, p) {
  validateW$1(p, c.BITS), validateMSMPoints$1(u, n);
  const a = n.ZERO, A = 2 ** p - 1, b = Math.ceil(c.BITS / p), F = (0, utils_ts_1$5.bitMask)(p), le = u.map((L) => {
    const pe = [];
    for (let $ = 0, Ee = L; $ < A; $++)
      pe.push(Ee), Ee = Ee.add(L);
    return pe;
  });
  return (L) => {
    if (validateMSMScalars$1(L, c), L.length > u.length)
      throw new Error("array of scalars must be smaller than array of points");
    let pe = a;
    for (let $ = 0; $ < b; $++) {
      if (pe !== a)
        for (let be = 0; be < p; be++)
          pe = pe.double();
      const Ee = BigInt(b * p - ($ + 1) * p);
      for (let be = 0; be < L.length; be++) {
        const He = L[be], Pe = Number(He >> Ee & F);
        Pe && (pe = pe.add(le[be][Pe - 1]));
      }
    }
    return pe;
  };
}
function validateBasic$3(n) {
  return (0, modular_ts_1$1.validateField)(n.Fp), (0, utils_ts_1$5.validateObject)(n, {
    n: "bigint",
    h: "bigint",
    Gx: "field",
    Gy: "field"
  }, {
    nBitLength: "isSafeInteger",
    nByteLength: "isSafeInteger"
  }), Object.freeze({
    ...(0, modular_ts_1$1.nLength)(n.n, n.nBitLength),
    ...n,
    p: n.Fp.ORDER
  });
}
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.DER = n.DERErr = void 0, n.weierstrassPoints = be, n.weierstrass = Pe, n.SWUFpSqrtRatio = nr, n.mapToCurveSimpleSWU = ir;
  const c = curve$2, u = modular, p = utils$M;
  function a(or) {
    or.lowS !== void 0 && (0, p.abool)("lowS", or.lowS), or.prehash !== void 0 && (0, p.abool)("prehash", or.prehash);
  }
  function A(or) {
    const lr = (0, c.validateBasic)(or);
    (0, p.validateObject)(lr, {
      a: "field",
      b: "field"
    }, {
      allowInfinityPoint: "boolean",
      allowedPrivateKeyLengths: "array",
      clearCofactor: "function",
      fromBytes: "function",
      isTorsionFree: "function",
      toBytes: "function",
      wrapPrivateKey: "boolean"
    });
    const { endo: Ir, Fp: xr, a: kr } = lr;
    if (Ir) {
      if (!xr.eql(kr, xr.ZERO))
        throw new Error("invalid endo: CURVE.a must be 0");
      if (typeof Ir != "object" || typeof Ir.beta != "bigint" || typeof Ir.splitScalar != "function")
        throw new Error('invalid endo: expected "beta": bigint and "splitScalar": function');
    }
    return Object.freeze({ ...lr });
  }
  class b extends Error {
    constructor(lr = "") {
      super(lr);
    }
  }
  n.DERErr = b, n.DER = {
    // asn.1 DER encoding utils
    Err: b,
    // Basic building block is TLV (Tag-Length-Value)
    _tlv: {
      encode: (or, lr) => {
        const { Err: Ir } = n.DER;
        if (or < 0 || or > 256)
          throw new Ir("tlv.encode: wrong tag");
        if (lr.length & 1)
          throw new Ir("tlv.encode: unpadded data");
        const xr = lr.length / 2, kr = (0, p.numberToHexUnpadded)(xr);
        if (kr.length / 2 & 128)
          throw new Ir("tlv.encode: long form length too big");
        const Ce = xr > 127 ? (0, p.numberToHexUnpadded)(kr.length / 2 | 128) : "";
        return (0, p.numberToHexUnpadded)(or) + Ce + kr + lr;
      },
      // v - value, l - left bytes (unparsed)
      decode(or, lr) {
        const { Err: Ir } = n.DER;
        let xr = 0;
        if (or < 0 || or > 256)
          throw new Ir("tlv.encode: wrong tag");
        if (lr.length < 2 || lr[xr++] !== or)
          throw new Ir("tlv.decode: wrong tlv");
        const kr = lr[xr++], Ce = !!(kr & 128);
        let tr = 0;
        if (!Ce)
          tr = kr;
        else {
          const Sr = kr & 127;
          if (!Sr)
            throw new Ir("tlv.decode(long): indefinite length not supported");
          if (Sr > 4)
            throw new Ir("tlv.decode(long): byte length is too big");
          const er = lr.subarray(xr, xr + Sr);
          if (er.length !== Sr)
            throw new Ir("tlv.decode: length bytes not complete");
          if (er[0] === 0)
            throw new Ir("tlv.decode(long): zero leftmost byte");
          for (const Ie of er)
            tr = tr << 8 | Ie;
          if (xr += Sr, tr < 128)
            throw new Ir("tlv.decode(long): not minimal encoding");
        }
        const Fe = lr.subarray(xr, xr + tr);
        if (Fe.length !== tr)
          throw new Ir("tlv.decode: wrong value length");
        return { v: Fe, l: lr.subarray(xr + tr) };
      }
    },
    // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
    // since we always use positive integers here. It must always be empty:
    // - add zero byte if exists
    // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
    _int: {
      encode(or) {
        const { Err: lr } = n.DER;
        if (or < le)
          throw new lr("integer: negative integers are not allowed");
        let Ir = (0, p.numberToHexUnpadded)(or);
        if (Number.parseInt(Ir[0], 16) & 8 && (Ir = "00" + Ir), Ir.length & 1)
          throw new lr("unexpected DER parsing assertion: unpadded hex");
        return Ir;
      },
      decode(or) {
        const { Err: lr } = n.DER;
        if (or[0] & 128)
          throw new lr("invalid signature integer: negative");
        if (or[0] === 0 && !(or[1] & 128))
          throw new lr("invalid signature integer: unnecessary leading zero");
        return (0, p.bytesToNumberBE)(or);
      }
    },
    toSig(or) {
      const { Err: lr, _int: Ir, _tlv: xr } = n.DER, kr = (0, p.ensureBytes)("signature", or), { v: Ce, l: tr } = xr.decode(48, kr);
      if (tr.length)
        throw new lr("invalid signature: left bytes after parsing");
      const { v: Fe, l: Sr } = xr.decode(2, Ce), { v: er, l: Ie } = xr.decode(2, Sr);
      if (Ie.length)
        throw new lr("invalid signature: left bytes after parsing");
      return { r: Ir.decode(Fe), s: Ir.decode(er) };
    },
    hexFromSig(or) {
      const { _tlv: lr, _int: Ir } = n.DER, xr = lr.encode(2, Ir.encode(or.r)), kr = lr.encode(2, Ir.encode(or.s)), Ce = xr + kr;
      return lr.encode(48, Ce);
    }
  };
  function F(or, lr) {
    return (0, p.bytesToHex)((0, p.numberToBytesBE)(or, lr));
  }
  const le = BigInt(0), L = BigInt(1), pe = BigInt(2), $ = BigInt(3), Ee = BigInt(4);
  function be(or) {
    const lr = A(or), { Fp: Ir } = lr, xr = (0, u.Field)(lr.n, lr.nBitLength), kr = lr.toBytes || ((Cr, Hr, si) => {
      const ui = Hr.toAffine();
      return (0, p.concatBytes)(Uint8Array.from([4]), Ir.toBytes(ui.x), Ir.toBytes(ui.y));
    }), Ce = lr.fromBytes || ((Cr) => {
      const Hr = Cr.subarray(1), si = Ir.fromBytes(Hr.subarray(0, Ir.BYTES)), ui = Ir.fromBytes(Hr.subarray(Ir.BYTES, 2 * Ir.BYTES));
      return { x: si, y: ui };
    });
    function tr(Cr) {
      const { a: Hr, b: si } = lr, ui = Ir.sqr(Cr), Li = Ir.mul(ui, Cr);
      return Ir.add(Ir.add(Li, Ir.mul(Cr, Hr)), si);
    }
    function Fe(Cr, Hr) {
      const si = Ir.sqr(Hr), ui = tr(Cr);
      return Ir.eql(si, ui);
    }
    if (!Fe(lr.Gx, lr.Gy))
      throw new Error("bad curve params: generator point");
    const Sr = Ir.mul(Ir.pow(lr.a, $), Ee), er = Ir.mul(Ir.sqr(lr.b), BigInt(27));
    if (Ir.is0(Ir.add(Sr, er)))
      throw new Error("bad curve params: a or b");
    function Ie(Cr) {
      return (0, p.inRange)(Cr, L, lr.n);
    }
    function xe(Cr) {
      const { allowedPrivateKeyLengths: Hr, nByteLength: si, wrapPrivateKey: ui, n: Li } = lr;
      if (Hr && typeof Cr != "bigint") {
        if ((0, p.isBytes)(Cr) && (Cr = (0, p.bytesToHex)(Cr)), typeof Cr != "string" || !Hr.includes(Cr.length))
          throw new Error("invalid private key");
        Cr = Cr.padStart(si * 2, "0");
      }
      let Qi;
      try {
        Qi = typeof Cr == "bigint" ? Cr : (0, p.bytesToNumberBE)((0, p.ensureBytes)("private key", Cr, si));
      } catch {
        throw new Error("invalid private key, expected hex or " + si + " bytes, got " + typeof Cr);
      }
      return ui && (Qi = (0, u.mod)(Qi, Li)), (0, p.aInRange)("private key", Qi, L, Li), Qi;
    }
    function rr(Cr) {
      if (!(Cr instanceof _r))
        throw new Error("ProjectivePoint expected");
    }
    const ar = (0, p.memoized)((Cr, Hr) => {
      const { px: si, py: ui, pz: Li } = Cr;
      if (Ir.eql(Li, Ir.ONE))
        return { x: si, y: ui };
      const Qi = Cr.is0();
      Hr == null && (Hr = Qi ? Ir.ONE : Ir.inv(Li));
      const wi = Ir.mul(si, Hr), Ji = Ir.mul(ui, Hr), mn = Ir.mul(Li, Hr);
      if (Qi)
        return { x: Ir.ZERO, y: Ir.ZERO };
      if (!Ir.eql(mn, Ir.ONE))
        throw new Error("invZ was invalid");
      return { x: wi, y: Ji };
    }), yr = (0, p.memoized)((Cr) => {
      if (Cr.is0()) {
        if (lr.allowInfinityPoint && !Ir.is0(Cr.py))
          return;
        throw new Error("bad point: ZERO");
      }
      const { x: Hr, y: si } = Cr.toAffine();
      if (!Ir.isValid(Hr) || !Ir.isValid(si))
        throw new Error("bad point: x or y not FE");
      if (!Fe(Hr, si))
        throw new Error("bad point: equation left != right");
      if (!Cr.isTorsionFree())
        throw new Error("bad point: not in prime-order subgroup");
      return !0;
    });
    class _r {
      constructor(Hr, si, ui) {
        if (Hr == null || !Ir.isValid(Hr))
          throw new Error("x required");
        if (si == null || !Ir.isValid(si) || Ir.is0(si))
          throw new Error("y required");
        if (ui == null || !Ir.isValid(ui))
          throw new Error("z required");
        this.px = Hr, this.py = si, this.pz = ui, Object.freeze(this);
      }
      // Does not validate if the point is on-curve.
      // Use fromHex instead, or call assertValidity() later.
      static fromAffine(Hr) {
        const { x: si, y: ui } = Hr || {};
        if (!Hr || !Ir.isValid(si) || !Ir.isValid(ui))
          throw new Error("invalid affine point");
        if (Hr instanceof _r)
          throw new Error("projective point not allowed");
        const Li = (Qi) => Ir.eql(Qi, Ir.ZERO);
        return Li(si) && Li(ui) ? _r.ZERO : new _r(si, ui, Ir.ONE);
      }
      get x() {
        return this.toAffine().x;
      }
      get y() {
        return this.toAffine().y;
      }
      /**
       * Takes a bunch of Projective Points but executes only one
       * inversion on all of them. Inversion is very slow operation,
       * so this improves performance massively.
       * Optimization: converts a list of projective points to a list of identical points with Z=1.
       */
      static normalizeZ(Hr) {
        const si = (0, u.FpInvertBatch)(Ir, Hr.map((ui) => ui.pz));
        return Hr.map((ui, Li) => ui.toAffine(si[Li])).map(_r.fromAffine);
      }
      /**
       * Converts hash string or Uint8Array to Point.
       * @param hex short/long ECDSA hex
       */
      static fromHex(Hr) {
        const si = _r.fromAffine(Ce((0, p.ensureBytes)("pointHex", Hr)));
        return si.assertValidity(), si;
      }
      // Multiplies generator point by privateKey.
      static fromPrivateKey(Hr) {
        return _r.BASE.multiply(xe(Hr));
      }
      // Multiscalar Multiplication
      static msm(Hr, si) {
        return (0, c.pippenger)(_r, xr, Hr, si);
      }
      // "Private method", don't use it directly
      _setWindowSize(Hr) {
        Te.setWindowSize(this, Hr);
      }
      // A point on curve is valid if it conforms to equation.
      assertValidity() {
        yr(this);
      }
      hasEvenY() {
        const { y: Hr } = this.toAffine();
        if (Ir.isOdd)
          return !Ir.isOdd(Hr);
        throw new Error("Field doesn't support isOdd");
      }
      /**
       * Compare one point to another.
       */
      equals(Hr) {
        rr(Hr);
        const { px: si, py: ui, pz: Li } = this, { px: Qi, py: wi, pz: Ji } = Hr, mn = Ir.eql(Ir.mul(si, Ji), Ir.mul(Qi, Li)), pi = Ir.eql(Ir.mul(ui, Ji), Ir.mul(wi, Li));
        return mn && pi;
      }
      /**
       * Flips point to one corresponding to (x, -y) in Affine coordinates.
       */
      negate() {
        return new _r(this.px, Ir.neg(this.py), this.pz);
      }
      // Renes-Costello-Batina exception-free doubling formula.
      // There is 30% faster Jacobian formula, but it is not complete.
      // https://eprint.iacr.org/2015/1060, algorithm 3
      // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
      double() {
        const { a: Hr, b: si } = lr, ui = Ir.mul(si, $), { px: Li, py: Qi, pz: wi } = this;
        let Ji = Ir.ZERO, mn = Ir.ZERO, pi = Ir.ZERO, ei = Ir.mul(Li, Li), Vr = Ir.mul(Qi, Qi), qr = Ir.mul(wi, wi), Zi = Ir.mul(Li, Qi);
        return Zi = Ir.add(Zi, Zi), pi = Ir.mul(Li, wi), pi = Ir.add(pi, pi), Ji = Ir.mul(Hr, pi), mn = Ir.mul(ui, qr), mn = Ir.add(Ji, mn), Ji = Ir.sub(Vr, mn), mn = Ir.add(Vr, mn), mn = Ir.mul(Ji, mn), Ji = Ir.mul(Zi, Ji), pi = Ir.mul(ui, pi), qr = Ir.mul(Hr, qr), Zi = Ir.sub(ei, qr), Zi = Ir.mul(Hr, Zi), Zi = Ir.add(Zi, pi), pi = Ir.add(ei, ei), ei = Ir.add(pi, ei), ei = Ir.add(ei, qr), ei = Ir.mul(ei, Zi), mn = Ir.add(mn, ei), qr = Ir.mul(Qi, wi), qr = Ir.add(qr, qr), ei = Ir.mul(qr, Zi), Ji = Ir.sub(Ji, ei), pi = Ir.mul(qr, Vr), pi = Ir.add(pi, pi), pi = Ir.add(pi, pi), new _r(Ji, mn, pi);
      }
      // Renes-Costello-Batina exception-free addition formula.
      // There is 30% faster Jacobian formula, but it is not complete.
      // https://eprint.iacr.org/2015/1060, algorithm 1
      // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
      add(Hr) {
        rr(Hr);
        const { px: si, py: ui, pz: Li } = this, { px: Qi, py: wi, pz: Ji } = Hr;
        let mn = Ir.ZERO, pi = Ir.ZERO, ei = Ir.ZERO;
        const Vr = lr.a, qr = Ir.mul(lr.b, $);
        let Zi = Ir.mul(si, Qi), Wr = Ir.mul(ui, wi), ri = Ir.mul(Li, Ji), _i = Ir.add(si, ui), Er = Ir.add(Qi, wi);
        _i = Ir.mul(_i, Er), Er = Ir.add(Zi, Wr), _i = Ir.sub(_i, Er), Er = Ir.add(si, Li);
        let Di = Ir.add(Qi, Ji);
        return Er = Ir.mul(Er, Di), Di = Ir.add(Zi, ri), Er = Ir.sub(Er, Di), Di = Ir.add(ui, Li), mn = Ir.add(wi, Ji), Di = Ir.mul(Di, mn), mn = Ir.add(Wr, ri), Di = Ir.sub(Di, mn), ei = Ir.mul(Vr, Er), mn = Ir.mul(qr, ri), ei = Ir.add(mn, ei), mn = Ir.sub(Wr, ei), ei = Ir.add(Wr, ei), pi = Ir.mul(mn, ei), Wr = Ir.add(Zi, Zi), Wr = Ir.add(Wr, Zi), ri = Ir.mul(Vr, ri), Er = Ir.mul(qr, Er), Wr = Ir.add(Wr, ri), ri = Ir.sub(Zi, ri), ri = Ir.mul(Vr, ri), Er = Ir.add(Er, ri), Zi = Ir.mul(Wr, Er), pi = Ir.add(pi, Zi), Zi = Ir.mul(Di, Er), mn = Ir.mul(_i, mn), mn = Ir.sub(mn, Zi), Zi = Ir.mul(_i, Wr), ei = Ir.mul(Di, ei), ei = Ir.add(ei, Zi), new _r(mn, pi, ei);
      }
      subtract(Hr) {
        return this.add(Hr.negate());
      }
      is0() {
        return this.equals(_r.ZERO);
      }
      wNAF(Hr) {
        return Te.wNAFCached(this, Hr, _r.normalizeZ);
      }
      /**
       * Non-constant-time multiplication. Uses double-and-add algorithm.
       * It's faster, but should only be used when you don't care about
       * an exposed private key e.g. sig verification, which works over *public* keys.
       */
      multiplyUnsafe(Hr) {
        const { endo: si, n: ui } = lr;
        (0, p.aInRange)("scalar", Hr, le, ui);
        const Li = _r.ZERO;
        if (Hr === le)
          return Li;
        if (this.is0() || Hr === L)
          return this;
        if (!si || Te.hasPrecomputes(this))
          return Te.wNAFCachedUnsafe(this, Hr, _r.normalizeZ);
        let { k1neg: Qi, k1: wi, k2neg: Ji, k2: mn } = si.splitScalar(Hr), pi = Li, ei = Li, Vr = this;
        for (; wi > le || mn > le; )
          wi & L && (pi = pi.add(Vr)), mn & L && (ei = ei.add(Vr)), Vr = Vr.double(), wi >>= L, mn >>= L;
        return Qi && (pi = pi.negate()), Ji && (ei = ei.negate()), ei = new _r(Ir.mul(ei.px, si.beta), ei.py, ei.pz), pi.add(ei);
      }
      /**
       * Constant time multiplication.
       * Uses wNAF method. Windowed method may be 10% faster,
       * but takes 2x longer to generate and consumes 2x memory.
       * Uses precomputes when available.
       * Uses endomorphism for Koblitz curves.
       * @param scalar by which the point would be multiplied
       * @returns New point
       */
      multiply(Hr) {
        const { endo: si, n: ui } = lr;
        (0, p.aInRange)("scalar", Hr, L, ui);
        let Li, Qi;
        if (si) {
          const { k1neg: wi, k1: Ji, k2neg: mn, k2: pi } = si.splitScalar(Hr);
          let { p: ei, f: Vr } = this.wNAF(Ji), { p: qr, f: Zi } = this.wNAF(pi);
          ei = Te.constTimeNegate(wi, ei), qr = Te.constTimeNegate(mn, qr), qr = new _r(Ir.mul(qr.px, si.beta), qr.py, qr.pz), Li = ei.add(qr), Qi = Vr.add(Zi);
        } else {
          const { p: wi, f: Ji } = this.wNAF(Hr);
          Li = wi, Qi = Ji;
        }
        return _r.normalizeZ([Li, Qi])[0];
      }
      /**
       * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
       * Not using Strauss-Shamir trick: precomputation tables are faster.
       * The trick could be useful if both P and Q are not G (not in our case).
       * @returns non-zero affine point
       */
      multiplyAndAddUnsafe(Hr, si, ui) {
        const Li = _r.BASE, Qi = (Ji, mn) => mn === le || mn === L || !Ji.equals(Li) ? Ji.multiplyUnsafe(mn) : Ji.multiply(mn), wi = Qi(this, si).add(Qi(Hr, ui));
        return wi.is0() ? void 0 : wi;
      }
      // Converts Projective point to affine (x, y) coordinates.
      // Can accept precomputed Z^-1 - for example, from invertBatch.
      // (x, y, z) ∋ (x=x/z, y=y/z)
      toAffine(Hr) {
        return ar(this, Hr);
      }
      isTorsionFree() {
        const { h: Hr, isTorsionFree: si } = lr;
        if (Hr === L)
          return !0;
        if (si)
          return si(_r, this);
        throw new Error("isTorsionFree() has not been declared for the elliptic curve");
      }
      clearCofactor() {
        const { h: Hr, clearCofactor: si } = lr;
        return Hr === L ? this : si ? si(_r, this) : this.multiplyUnsafe(lr.h);
      }
      toRawBytes(Hr = !0) {
        return (0, p.abool)("isCompressed", Hr), this.assertValidity(), kr(_r, this, Hr);
      }
      toHex(Hr = !0) {
        return (0, p.abool)("isCompressed", Hr), (0, p.bytesToHex)(this.toRawBytes(Hr));
      }
    }
    _r.BASE = new _r(lr.Gx, lr.Gy, Ir.ONE), _r.ZERO = new _r(Ir.ZERO, Ir.ONE, Ir.ZERO);
    const { endo: Or, nBitLength: vr } = lr, Te = (0, c.wNAF)(_r, Or ? Math.ceil(vr / 2) : vr);
    return {
      CURVE: lr,
      ProjectivePoint: _r,
      normPrivateKeyToScalar: xe,
      weierstrassEquation: tr,
      isWithinCurveOrder: Ie
    };
  }
  function He(or) {
    const lr = (0, c.validateBasic)(or);
    return (0, p.validateObject)(lr, {
      hash: "hash",
      hmac: "function",
      randomBytes: "function"
    }, {
      bits2int: "function",
      bits2int_modN: "function",
      lowS: "boolean"
    }), Object.freeze({ lowS: !0, ...lr });
  }
  function Pe(or) {
    const lr = He(or), { Fp: Ir, n: xr, nByteLength: kr, nBitLength: Ce } = lr, tr = Ir.BYTES + 1, Fe = 2 * Ir.BYTES + 1;
    function Sr(qr) {
      return (0, u.mod)(qr, xr);
    }
    function er(qr) {
      return (0, u.invert)(qr, xr);
    }
    const { ProjectivePoint: Ie, normPrivateKeyToScalar: xe, weierstrassEquation: rr, isWithinCurveOrder: ar } = be({
      ...lr,
      toBytes(qr, Zi, Wr) {
        const ri = Zi.toAffine(), _i = Ir.toBytes(ri.x), Er = p.concatBytes;
        return (0, p.abool)("isCompressed", Wr), Wr ? Er(Uint8Array.from([Zi.hasEvenY() ? 2 : 3]), _i) : Er(Uint8Array.from([4]), _i, Ir.toBytes(ri.y));
      },
      fromBytes(qr) {
        const Zi = qr.length, Wr = qr[0], ri = qr.subarray(1);
        if (Zi === tr && (Wr === 2 || Wr === 3)) {
          const _i = (0, p.bytesToNumberBE)(ri);
          if (!(0, p.inRange)(_i, L, Ir.ORDER))
            throw new Error("Point is not on curve");
          const Er = rr(_i);
          let Di;
          try {
            Di = Ir.sqrt(Er);
          } catch (so) {
            const Do = so instanceof Error ? ": " + so.message : "";
            throw new Error("Point is not on curve" + Do);
          }
          const _n = (Di & L) === L;
          return (Wr & 1) === 1 !== _n && (Di = Ir.neg(Di)), { x: _i, y: Di };
        } else if (Zi === Fe && Wr === 4) {
          const _i = Ir.fromBytes(ri.subarray(0, Ir.BYTES)), Er = Ir.fromBytes(ri.subarray(Ir.BYTES, 2 * Ir.BYTES));
          return { x: _i, y: Er };
        } else {
          const _i = tr, Er = Fe;
          throw new Error("invalid Point, expected length of " + _i + ", or uncompressed " + Er + ", got " + Zi);
        }
      }
    });
    function yr(qr) {
      const Zi = xr >> L;
      return qr > Zi;
    }
    function _r(qr) {
      return yr(qr) ? Sr(-qr) : qr;
    }
    const Or = (qr, Zi, Wr) => (0, p.bytesToNumberBE)(qr.slice(Zi, Wr));
    class vr {
      constructor(Zi, Wr, ri) {
        (0, p.aInRange)("r", Zi, L, xr), (0, p.aInRange)("s", Wr, L, xr), this.r = Zi, this.s = Wr, ri != null && (this.recovery = ri), Object.freeze(this);
      }
      // pair (bytes of r, bytes of s)
      static fromCompact(Zi) {
        const Wr = kr;
        return Zi = (0, p.ensureBytes)("compactSignature", Zi, Wr * 2), new vr(Or(Zi, 0, Wr), Or(Zi, Wr, 2 * Wr));
      }
      // DER encoded ECDSA signature
      // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
      static fromDER(Zi) {
        const { r: Wr, s: ri } = n.DER.toSig((0, p.ensureBytes)("DER", Zi));
        return new vr(Wr, ri);
      }
      /**
       * @todo remove
       * @deprecated
       */
      assertValidity() {
      }
      addRecoveryBit(Zi) {
        return new vr(this.r, this.s, Zi);
      }
      recoverPublicKey(Zi) {
        const { r: Wr, s: ri, recovery: _i } = this, Er = Li((0, p.ensureBytes)("msgHash", Zi));
        if (_i == null || ![0, 1, 2, 3].includes(_i))
          throw new Error("recovery id invalid");
        const Di = _i === 2 || _i === 3 ? Wr + lr.n : Wr;
        if (Di >= Ir.ORDER)
          throw new Error("recovery id 2 or 3 invalid");
        const _n = _i & 1 ? "03" : "02", On = Ie.fromHex(_n + F(Di, Ir.BYTES)), so = er(Di), Do = Sr(-Er * so), gn = Sr(ri * so), Gn = Ie.BASE.multiplyAndAddUnsafe(On, Do, gn);
        if (!Gn)
          throw new Error("point at infinify");
        return Gn.assertValidity(), Gn;
      }
      // Signatures should be low-s, to prevent malleability.
      hasHighS() {
        return yr(this.s);
      }
      normalizeS() {
        return this.hasHighS() ? new vr(this.r, Sr(-this.s), this.recovery) : this;
      }
      // DER-encoded
      toDERRawBytes() {
        return (0, p.hexToBytes)(this.toDERHex());
      }
      toDERHex() {
        return n.DER.hexFromSig(this);
      }
      // padded bytes of r, then padded bytes of s
      toCompactRawBytes() {
        return (0, p.hexToBytes)(this.toCompactHex());
      }
      toCompactHex() {
        const Zi = kr;
        return F(this.r, Zi) + F(this.s, Zi);
      }
    }
    const Te = {
      isValidPrivateKey(qr) {
        try {
          return xe(qr), !0;
        } catch {
          return !1;
        }
      },
      normPrivateKeyToScalar: xe,
      /**
       * Produces cryptographically secure private key from random of size
       * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
       */
      randomPrivateKey: () => {
        const qr = (0, u.getMinHashLength)(lr.n);
        return (0, u.mapHashToField)(lr.randomBytes(qr), lr.n);
      },
      /**
       * Creates precompute table for an arbitrary EC point. Makes point "cached".
       * Allows to massively speed-up `point.multiply(scalar)`.
       * @returns cached point
       * @example
       * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
       * fast.multiply(privKey); // much faster ECDH now
       */
      precompute(qr = 8, Zi = Ie.BASE) {
        return Zi._setWindowSize(qr), Zi.multiply(BigInt(3)), Zi;
      }
    };
    function Cr(qr, Zi = !0) {
      return Ie.fromPrivateKey(qr).toRawBytes(Zi);
    }
    function Hr(qr) {
      if (typeof qr == "bigint")
        return !1;
      if (qr instanceof Ie)
        return !0;
      const Wr = (0, p.ensureBytes)("key", qr).length, ri = Ir.BYTES, _i = ri + 1, Er = 2 * ri + 1;
      if (!(lr.allowedPrivateKeyLengths || kr === _i))
        return Wr === _i || Wr === Er;
    }
    function si(qr, Zi, Wr = !0) {
      if (Hr(qr) === !0)
        throw new Error("first arg must be private key");
      if (Hr(Zi) === !1)
        throw new Error("second arg must be public key");
      return Ie.fromHex(Zi).multiply(xe(qr)).toRawBytes(Wr);
    }
    const ui = lr.bits2int || function(qr) {
      if (qr.length > 8192)
        throw new Error("input is too large");
      const Zi = (0, p.bytesToNumberBE)(qr), Wr = qr.length * 8 - Ce;
      return Wr > 0 ? Zi >> BigInt(Wr) : Zi;
    }, Li = lr.bits2int_modN || function(qr) {
      return Sr(ui(qr));
    }, Qi = (0, p.bitMask)(Ce);
    function wi(qr) {
      return (0, p.aInRange)("num < 2^" + Ce, qr, le, Qi), (0, p.numberToBytesBE)(qr, kr);
    }
    function Ji(qr, Zi, Wr = mn) {
      if (["recovered", "canonical"].some((hn) => hn in Wr))
        throw new Error("sign() legacy options not supported");
      const { hash: ri, randomBytes: _i } = lr;
      let { lowS: Er, prehash: Di, extraEntropy: _n } = Wr;
      Er == null && (Er = !0), qr = (0, p.ensureBytes)("msgHash", qr), a(Wr), Di && (qr = (0, p.ensureBytes)("prehashed msgHash", ri(qr)));
      const On = Li(qr), so = xe(Zi), Do = [wi(so), wi(On)];
      if (_n != null && _n !== !1) {
        const hn = _n === !0 ? _i(Ir.BYTES) : _n;
        Do.push((0, p.ensureBytes)("extraEntropy", hn));
      }
      const gn = (0, p.concatBytes)(...Do), Gn = On;
      function pn(hn) {
        const Rn = ui(hn);
        if (!ar(Rn))
          return;
        const vo = er(Rn), Hi = Ie.BASE.multiply(Rn).toAffine(), di = Sr(Hi.x);
        if (di === le)
          return;
        const Ui = Sr(vo * Sr(Gn + di * so));
        if (Ui === le)
          return;
        let ln = (Hi.x === di ? 0 : 2) | Number(Hi.y & L), Un = Ui;
        return Er && yr(Ui) && (Un = _r(Ui), ln ^= 1), new vr(di, Un, ln);
      }
      return { seed: gn, k2sig: pn };
    }
    const mn = { lowS: lr.lowS, prehash: !1 }, pi = { lowS: lr.lowS, prehash: !1 };
    function ei(qr, Zi, Wr = mn) {
      const { seed: ri, k2sig: _i } = Ji(qr, Zi, Wr), Er = lr;
      return (0, p.createHmacDrbg)(Er.hash.outputLen, Er.nByteLength, Er.hmac)(ri, _i);
    }
    Ie.BASE._setWindowSize(8);
    function Vr(qr, Zi, Wr, ri = pi) {
      var ln;
      const _i = qr;
      Zi = (0, p.ensureBytes)("msgHash", Zi), Wr = (0, p.ensureBytes)("publicKey", Wr);
      const { lowS: Er, prehash: Di, format: _n } = ri;
      if (a(ri), "strict" in ri)
        throw new Error("options.strict was renamed to lowS");
      if (_n !== void 0 && _n !== "compact" && _n !== "der")
        throw new Error("format must be compact or der");
      const On = typeof _i == "string" || (0, p.isBytes)(_i), so = !On && !_n && typeof _i == "object" && _i !== null && typeof _i.r == "bigint" && typeof _i.s == "bigint";
      if (!On && !so)
        throw new Error("invalid signature, expected Uint8Array, hex string or Signature instance");
      let Do, gn;
      try {
        if (so && (Do = new vr(_i.r, _i.s)), On) {
          try {
            _n !== "compact" && (Do = vr.fromDER(_i));
          } catch (Un) {
            if (!(Un instanceof n.DER.Err))
              throw Un;
          }
          !Do && _n !== "der" && (Do = vr.fromCompact(_i));
        }
        gn = Ie.fromHex(Wr);
      } catch {
        return !1;
      }
      if (!Do || Er && Do.hasHighS())
        return !1;
      Di && (Zi = lr.hash(Zi));
      const { r: Gn, s: pn } = Do, hn = Li(Zi), Rn = er(pn), vo = Sr(hn * Rn), Hi = Sr(Gn * Rn), di = (ln = Ie.BASE.multiplyAndAddUnsafe(gn, vo, Hi)) == null ? void 0 : ln.toAffine();
      return di ? Sr(di.x) === Gn : !1;
    }
    return {
      CURVE: lr,
      getPublicKey: Cr,
      getSharedSecret: si,
      sign: ei,
      verify: Vr,
      ProjectivePoint: Ie,
      Signature: vr,
      utils: Te
    };
  }
  function nr(or, lr) {
    const Ir = or.ORDER;
    let xr = le;
    for (let yr = Ir - L; yr % pe === le; yr /= pe)
      xr += L;
    const kr = xr, Ce = pe << kr - L - L, tr = Ce * pe, Fe = (Ir - L) / tr, Sr = (Fe - L) / pe, er = tr - L, Ie = Ce, xe = or.pow(lr, Fe), rr = or.pow(lr, (Fe + L) / pe);
    let ar = (yr, _r) => {
      let Or = xe, vr = or.pow(_r, er), Te = or.sqr(vr);
      Te = or.mul(Te, _r);
      let Cr = or.mul(yr, Te);
      Cr = or.pow(Cr, Sr), Cr = or.mul(Cr, vr), vr = or.mul(Cr, _r), Te = or.mul(Cr, yr);
      let Hr = or.mul(Te, vr);
      Cr = or.pow(Hr, Ie);
      let si = or.eql(Cr, or.ONE);
      vr = or.mul(Te, rr), Cr = or.mul(Hr, Or), Te = or.cmov(vr, Te, si), Hr = or.cmov(Cr, Hr, si);
      for (let ui = kr; ui > L; ui--) {
        let Li = ui - pe;
        Li = pe << Li - L;
        let Qi = or.pow(Hr, Li);
        const wi = or.eql(Qi, or.ONE);
        vr = or.mul(Te, Or), Or = or.mul(Or, Or), Qi = or.mul(Hr, Or), Te = or.cmov(vr, Te, wi), Hr = or.cmov(Qi, Hr, wi);
      }
      return { isValid: si, value: Te };
    };
    if (or.ORDER % Ee === $) {
      const yr = (or.ORDER - $) / Ee, _r = or.sqrt(or.neg(lr));
      ar = (Or, vr) => {
        let Te = or.sqr(vr);
        const Cr = or.mul(Or, vr);
        Te = or.mul(Te, Cr);
        let Hr = or.pow(Te, yr);
        Hr = or.mul(Hr, Cr);
        const si = or.mul(Hr, _r), ui = or.mul(or.sqr(Hr), vr), Li = or.eql(ui, Or);
        let Qi = or.cmov(si, Hr, Li);
        return { isValid: Li, value: Qi };
      };
    }
    return ar;
  }
  function ir(or, lr) {
    if ((0, u.validateField)(or), !or.isValid(lr.A) || !or.isValid(lr.B) || !or.isValid(lr.Z))
      throw new Error("mapToCurveSimpleSWU: invalid opts");
    const Ir = nr(or, lr.Z);
    if (!or.isOdd)
      throw new Error("Fp.isOdd is not implemented!");
    return (xr) => {
      let kr, Ce, tr, Fe, Sr, er, Ie, xe;
      kr = or.sqr(xr), kr = or.mul(kr, lr.Z), Ce = or.sqr(kr), Ce = or.add(Ce, kr), tr = or.add(Ce, or.ONE), tr = or.mul(tr, lr.B), Fe = or.cmov(lr.Z, or.neg(Ce), !or.eql(Ce, or.ZERO)), Fe = or.mul(Fe, lr.A), Ce = or.sqr(tr), er = or.sqr(Fe), Sr = or.mul(er, lr.A), Ce = or.add(Ce, Sr), Ce = or.mul(Ce, tr), er = or.mul(er, Fe), Sr = or.mul(er, lr.B), Ce = or.add(Ce, Sr), Ie = or.mul(kr, tr);
      const { isValid: rr, value: ar } = Ir(Ce, er);
      xe = or.mul(kr, xr), xe = or.mul(xe, ar), Ie = or.cmov(Ie, tr, rr), xe = or.cmov(xe, ar, rr);
      const yr = or.isOdd(xr) === or.isOdd(xe);
      xe = or.cmov(or.neg(xe), xe, yr);
      const _r = (0, u.FpInvertBatch)(or, [Fe], !0)[0];
      return Ie = or.mul(Ie, _r), { x: Ie, y: xe };
    };
  }
})(weierstrass$3);
Object.defineProperty(_shortw_utils, "__esModule", { value: !0 });
_shortw_utils.getHash = getHash$3;
_shortw_utils.createCurve = createCurve$3;
const hmac_1$2 = hmac$6, utils_1$v = utils$O, weierstrass_ts_1 = weierstrass$3;
function getHash$3(n) {
  return {
    hash: n,
    hmac: (c, ...u) => (0, hmac_1$2.hmac)(n, c, (0, utils_1$v.concatBytes)(...u)),
    randomBytes: utils_1$v.randomBytes
  };
}
function createCurve$3(n, c) {
  const u = (p) => (0, weierstrass_ts_1.weierstrass)({ ...n, ...getHash$3(p) });
  return { ...u(c), create: u };
}
var hashToCurve$1 = {};
Object.defineProperty(hashToCurve$1, "__esModule", { value: !0 });
hashToCurve$1.expand_message_xmd = expand_message_xmd$2;
hashToCurve$1.expand_message_xof = expand_message_xof$2;
hashToCurve$1.hash_to_field = hash_to_field$2;
hashToCurve$1.isogenyMap = isogenyMap$2;
hashToCurve$1.createHasher = createHasher$3;
const modular_ts_1 = modular, utils_ts_1$4 = utils$M, os2ip$2 = utils_ts_1$4.bytesToNumberBE;
function i2osp$2(n, c) {
  if (anum$1(n), anum$1(c), n < 0 || n >= 1 << 8 * c)
    throw new Error("invalid I2OSP input: " + n);
  const u = Array.from({ length: c }).fill(0);
  for (let p = c - 1; p >= 0; p--)
    u[p] = n & 255, n >>>= 8;
  return new Uint8Array(u);
}
function strxor$2(n, c) {
  const u = new Uint8Array(n.length);
  for (let p = 0; p < n.length; p++)
    u[p] = n[p] ^ c[p];
  return u;
}
function anum$1(n) {
  if (!Number.isSafeInteger(n))
    throw new Error("number expected");
}
function expand_message_xmd$2(n, c, u, p) {
  (0, utils_ts_1$4.abytes)(n), (0, utils_ts_1$4.abytes)(c), anum$1(u), c.length > 255 && (c = p((0, utils_ts_1$4.concatBytes)((0, utils_ts_1$4.utf8ToBytes)("H2C-OVERSIZE-DST-"), c)));
  const { outputLen: a, blockLen: A } = p, b = Math.ceil(u / a);
  if (u > 65535 || b > 255)
    throw new Error("expand_message_xmd: invalid lenInBytes");
  const F = (0, utils_ts_1$4.concatBytes)(c, i2osp$2(c.length, 1)), le = i2osp$2(0, A), L = i2osp$2(u, 2), pe = new Array(b), $ = p((0, utils_ts_1$4.concatBytes)(le, n, L, i2osp$2(0, 1), F));
  pe[0] = p((0, utils_ts_1$4.concatBytes)($, i2osp$2(1, 1), F));
  for (let be = 1; be <= b; be++) {
    const He = [strxor$2($, pe[be - 1]), i2osp$2(be + 1, 1), F];
    pe[be] = p((0, utils_ts_1$4.concatBytes)(...He));
  }
  return (0, utils_ts_1$4.concatBytes)(...pe).slice(0, u);
}
function expand_message_xof$2(n, c, u, p, a) {
  if ((0, utils_ts_1$4.abytes)(n), (0, utils_ts_1$4.abytes)(c), anum$1(u), c.length > 255) {
    const A = Math.ceil(2 * p / 8);
    c = a.create({ dkLen: A }).update((0, utils_ts_1$4.utf8ToBytes)("H2C-OVERSIZE-DST-")).update(c).digest();
  }
  if (u > 65535 || c.length > 255)
    throw new Error("expand_message_xof: invalid lenInBytes");
  return a.create({ dkLen: u }).update(n).update(i2osp$2(u, 2)).update(c).update(i2osp$2(c.length, 1)).digest();
}
function hash_to_field$2(n, c, u) {
  (0, utils_ts_1$4.validateObject)(u, {
    DST: "stringOrUint8Array",
    p: "bigint",
    m: "isSafeInteger",
    k: "isSafeInteger",
    hash: "hash"
  });
  const { p, k: a, m: A, hash: b, expand: F, DST: le } = u;
  (0, utils_ts_1$4.abytes)(n), anum$1(c);
  const L = typeof le == "string" ? (0, utils_ts_1$4.utf8ToBytes)(le) : le, pe = p.toString(2).length, $ = Math.ceil((pe + a) / 8), Ee = c * A * $;
  let be;
  if (F === "xmd")
    be = expand_message_xmd$2(n, L, Ee, b);
  else if (F === "xof")
    be = expand_message_xof$2(n, L, Ee, a, b);
  else if (F === "_internal_pass")
    be = n;
  else
    throw new Error('expand must be "xmd" or "xof"');
  const He = new Array(c);
  for (let Pe = 0; Pe < c; Pe++) {
    const nr = new Array(A);
    for (let ir = 0; ir < A; ir++) {
      const or = $ * (ir + Pe * A), lr = be.subarray(or, or + $);
      nr[ir] = (0, modular_ts_1.mod)(os2ip$2(lr), p);
    }
    He[Pe] = nr;
  }
  return He;
}
function isogenyMap$2(n, c) {
  const u = c.map((p) => Array.from(p).reverse());
  return (p, a) => {
    const [A, b, F, le] = u.map(($) => $.reduce((Ee, be) => n.add(n.mul(Ee, p), be))), [L, pe] = (0, modular_ts_1.FpInvertBatch)(n, [b, le], !0);
    return p = n.mul(A, L), a = n.mul(a, n.mul(F, pe)), { x: p, y: a };
  };
}
function createHasher$3(n, c, u) {
  if (typeof c != "function")
    throw new Error("mapToCurve() must be defined");
  function p(A) {
    return n.fromAffine(c(A));
  }
  function a(A) {
    const b = A.clearCofactor();
    return b.equals(n.ZERO) ? n.ZERO : (b.assertValidity(), b);
  }
  return {
    defaults: u,
    // Encodes byte string to elliptic curve.
    // hash_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
    hashToCurve(A, b) {
      const F = hash_to_field$2(A, 2, { ...u, DST: u.DST, ...b }), le = p(F[0]), L = p(F[1]);
      return a(le.add(L));
    },
    // Encodes byte string to elliptic curve.
    // encode_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
    encodeToCurve(A, b) {
      const F = hash_to_field$2(A, 1, { ...u, DST: u.encodeDST, ...b });
      return a(p(F[0]));
    },
    // Same as encodeToCurve, but without hash
    mapToCurve(A) {
      if (!Array.isArray(A))
        throw new Error("expected array of bigints");
      for (const b of A)
        if (typeof b != "bigint")
          throw new Error("expected array of bigints");
      return a(p(A));
    }
  };
}
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.encodeToCurve = n.hashToCurve = n.secp256k1_hasher = n.schnorr = n.secp256k1 = void 0;
  const c = sha2, u = utils$O, p = _shortw_utils, a = hashToCurve$1, A = modular, b = utils$M, F = weierstrass$3, le = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"), L = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), pe = BigInt(0), $ = BigInt(1), Ee = BigInt(2), be = (_r, Or) => (_r + Or / Ee) / Or;
  function He(_r) {
    const Or = le, vr = BigInt(3), Te = BigInt(6), Cr = BigInt(11), Hr = BigInt(22), si = BigInt(23), ui = BigInt(44), Li = BigInt(88), Qi = _r * _r * _r % Or, wi = Qi * Qi * _r % Or, Ji = (0, A.pow2)(wi, vr, Or) * wi % Or, mn = (0, A.pow2)(Ji, vr, Or) * wi % Or, pi = (0, A.pow2)(mn, Ee, Or) * Qi % Or, ei = (0, A.pow2)(pi, Cr, Or) * pi % Or, Vr = (0, A.pow2)(ei, Hr, Or) * ei % Or, qr = (0, A.pow2)(Vr, ui, Or) * Vr % Or, Zi = (0, A.pow2)(qr, Li, Or) * qr % Or, Wr = (0, A.pow2)(Zi, ui, Or) * Vr % Or, ri = (0, A.pow2)(Wr, vr, Or) * wi % Or, _i = (0, A.pow2)(ri, si, Or) * ei % Or, Er = (0, A.pow2)(_i, Te, Or) * Qi % Or, Di = (0, A.pow2)(Er, Ee, Or);
    if (!Pe.eql(Pe.sqr(Di), _r))
      throw new Error("Cannot find square root");
    return Di;
  }
  const Pe = (0, A.Field)(le, void 0, void 0, { sqrt: He });
  n.secp256k1 = (0, p.createCurve)({
    a: pe,
    b: BigInt(7),
    Fp: Pe,
    n: L,
    Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
    Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
    h: BigInt(1),
    lowS: !0,
    // Allow only low-S signatures by default in sign() and verify()
    endo: {
      // Endomorphism, see above
      beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
      splitScalar: (_r) => {
        const Or = L, vr = BigInt("0x3086d221a7d46bcde86c90e49284eb15"), Te = -$ * BigInt("0xe4437ed6010e88286f547fa90abfe4c3"), Cr = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), Hr = vr, si = BigInt("0x100000000000000000000000000000000"), ui = be(Hr * _r, Or), Li = be(-Te * _r, Or);
        let Qi = (0, A.mod)(_r - ui * vr - Li * Cr, Or), wi = (0, A.mod)(-ui * Te - Li * Hr, Or);
        const Ji = Qi > si, mn = wi > si;
        if (Ji && (Qi = Or - Qi), mn && (wi = Or - wi), Qi > si || wi > si)
          throw new Error("splitScalar: Endomorphism failed, k=" + _r);
        return { k1neg: Ji, k1: Qi, k2neg: mn, k2: wi };
      }
    }
  }, c.sha256);
  const nr = {};
  function ir(_r, ...Or) {
    let vr = nr[_r];
    if (vr === void 0) {
      const Te = (0, c.sha256)(Uint8Array.from(_r, (Cr) => Cr.charCodeAt(0)));
      vr = (0, b.concatBytes)(Te, Te), nr[_r] = vr;
    }
    return (0, c.sha256)((0, b.concatBytes)(vr, ...Or));
  }
  const or = (_r) => _r.toRawBytes(!0).slice(1), lr = (_r) => (0, b.numberToBytesBE)(_r, 32), Ir = (_r) => (0, A.mod)(_r, le), xr = (_r) => (0, A.mod)(_r, L), kr = n.secp256k1.ProjectivePoint, Ce = (_r, Or, vr) => kr.BASE.multiplyAndAddUnsafe(_r, Or, vr);
  function tr(_r) {
    let Or = n.secp256k1.utils.normPrivateKeyToScalar(_r), vr = kr.fromPrivateKey(Or);
    return { scalar: vr.hasEvenY() ? Or : xr(-Or), bytes: or(vr) };
  }
  function Fe(_r) {
    (0, b.aInRange)("x", _r, $, le);
    const Or = Ir(_r * _r), vr = Ir(Or * _r + BigInt(7));
    let Te = He(vr);
    Te % Ee !== pe && (Te = Ir(-Te));
    const Cr = new kr(_r, Te, $);
    return Cr.assertValidity(), Cr;
  }
  const Sr = b.bytesToNumberBE;
  function er(..._r) {
    return xr(Sr(ir("BIP0340/challenge", ..._r)));
  }
  function Ie(_r) {
    return tr(_r).bytes;
  }
  function xe(_r, Or, vr = (0, u.randomBytes)(32)) {
    const Te = (0, b.ensureBytes)("message", _r), { bytes: Cr, scalar: Hr } = tr(Or), si = (0, b.ensureBytes)("auxRand", vr, 32), ui = lr(Hr ^ Sr(ir("BIP0340/aux", si))), Li = ir("BIP0340/nonce", ui, Cr, Te), Qi = xr(Sr(Li));
    if (Qi === pe)
      throw new Error("sign failed: k is zero");
    const { bytes: wi, scalar: Ji } = tr(Qi), mn = er(wi, Cr, Te), pi = new Uint8Array(64);
    if (pi.set(wi, 0), pi.set(lr(xr(Ji + mn * Hr)), 32), !rr(pi, Te, Cr))
      throw new Error("sign: Invalid signature produced");
    return pi;
  }
  function rr(_r, Or, vr) {
    const Te = (0, b.ensureBytes)("signature", _r, 64), Cr = (0, b.ensureBytes)("message", Or), Hr = (0, b.ensureBytes)("publicKey", vr, 32);
    try {
      const si = Fe(Sr(Hr)), ui = Sr(Te.subarray(0, 32));
      if (!(0, b.inRange)(ui, $, le))
        return !1;
      const Li = Sr(Te.subarray(32, 64));
      if (!(0, b.inRange)(Li, $, L))
        return !1;
      const Qi = er(lr(ui), or(si), Cr), wi = Ce(si, Li, xr(-Qi));
      return !(!wi || !wi.hasEvenY() || wi.toAffine().x !== ui);
    } catch {
      return !1;
    }
  }
  n.schnorr = {
    getPublicKey: Ie,
    sign: xe,
    verify: rr,
    utils: {
      randomPrivateKey: n.secp256k1.utils.randomPrivateKey,
      lift_x: Fe,
      pointToBytes: or,
      numberToBytesBE: b.numberToBytesBE,
      bytesToNumberBE: b.bytesToNumberBE,
      taggedHash: ir,
      mod: A.mod
    }
  };
  const ar = (0, a.isogenyMap)(Pe, [
    // xNum
    [
      "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
      "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
      "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
      "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
    ],
    // xDen
    [
      "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
      "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
      "0x0000000000000000000000000000000000000000000000000000000000000001"
      // LAST 1
    ],
    // yNum
    [
      "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
      "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
      "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
      "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
    ],
    // yDen
    [
      "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
      "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
      "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
      "0x0000000000000000000000000000000000000000000000000000000000000001"
      // LAST 1
    ]
  ].map((_r) => _r.map((Or) => BigInt(Or)))), yr = (0, F.mapToCurveSimpleSWU)(Pe, {
    A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
    B: BigInt("1771"),
    Z: Pe.create(BigInt("-11"))
  });
  n.secp256k1_hasher = (0, a.createHasher)(n.secp256k1.ProjectivePoint, (_r) => {
    const { x: Or, y: vr } = yr(Pe.create(_r[0]));
    return ar(Or, vr);
  }, {
    DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
    encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
    p: Pe.ORDER,
    m: 1,
    k: 128,
    expand: "xmd",
    hash: c.sha256
  }), n.hashToCurve = n.secp256k1_hasher.hashToCurve, n.encodeToCurve = n.secp256k1_hasher.encodeToCurve;
})(secp256k1$b);
var secp256k1$a = secp256k1$b, mod$3 = modular, utils$L = utils$M;
function _interopNamespaceDefault(n) {
  var c = /* @__PURE__ */ Object.create(null);
  return n && Object.keys(n).forEach(function(u) {
    if (u !== "default") {
      var p = Object.getOwnPropertyDescriptor(n, u);
      Object.defineProperty(c, u, p.get ? p : {
        enumerable: !0,
        get: function() {
          return n[u];
        }
      });
    }
  }), c.default = n, Object.freeze(c);
}
var mod__namespace = /* @__PURE__ */ _interopNamespaceDefault(mod$3), utils__namespace = /* @__PURE__ */ _interopNamespaceDefault(utils$L);
const Point$9 = secp256k1$a.secp256k1.ProjectivePoint, THROW_BAD_PRIVATE = "Expected Private", THROW_BAD_POINT = "Expected Point", THROW_BAD_TWEAK = "Expected Tweak", THROW_BAD_HASH = "Expected Hash", THROW_BAD_SIGNATURE = "Expected Signature", THROW_BAD_EXTRA_DATA = "Expected Extra Data (32 bytes)", THROW_BAD_SCALAR = "Expected Scalar", THROW_BAD_RECOVERY_ID = "Bad Recovery Id", HASH_SIZE$1 = 32, TWEAK_SIZE$1 = 32, BN32_N$1 = new Uint8Array([
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  254,
  186,
  174,
  220,
  230,
  175,
  72,
  160,
  59,
  191,
  210,
  94,
  140,
  208,
  54,
  65,
  65
]), EXTRA_DATA_SIZE$1 = 32, BN32_ZERO$1 = new Uint8Array(32), BN32_P_MINUS_N$1 = new Uint8Array([
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1,
  69,
  81,
  35,
  25,
  80,
  183,
  95,
  196,
  64,
  45,
  161,
  114,
  47,
  201,
  186,
  238
]), _1n$h = BigInt(1);
function isUint8Array$2(n) {
  return n instanceof Uint8Array;
}
function cmpBN32$1(n, c) {
  for (let u = 0; u < 32; ++u)
    if (n[u] !== c[u])
      return n[u] < c[u] ? -1 : 1;
  return 0;
}
function isZero$1(n) {
  return cmpBN32$1(n, BN32_ZERO$1) === 0;
}
function isTweak$1(n) {
  return !(!(n instanceof Uint8Array) || n.length !== TWEAK_SIZE$1 || cmpBN32$1(n, BN32_N$1) >= 0);
}
function isSignature$1(n) {
  return n instanceof Uint8Array && n.length === 64 && cmpBN32$1(n.subarray(0, 32), BN32_N$1) < 0 && cmpBN32$1(n.subarray(32, 64), BN32_N$1) < 0;
}
function isSigrLessThanPMinusN$1(n) {
  return isUint8Array$2(n) && n.length === 64 && cmpBN32$1(n.subarray(0, 32), BN32_P_MINUS_N$1) < 0;
}
function isSignatureNonzeroRS(n) {
  return !(isZero$1(n.subarray(0, 32)) || isZero$1(n.subarray(32, 64)));
}
function isHash$1(n) {
  return n instanceof Uint8Array && n.length === HASH_SIZE$1;
}
function isExtraData$1(n) {
  return n === void 0 || n instanceof Uint8Array && n.length === EXTRA_DATA_SIZE$1;
}
function normalizeScalar(n) {
  let c;
  if (typeof n == "bigint")
    c = n;
  else if (typeof n == "number" && Number.isSafeInteger(n) && n >= 0)
    c = BigInt(n);
  else if (typeof n == "string") {
    if (n.length !== 64)
      throw new Error("Expected 32 bytes of private scalar");
    c = utils__namespace.hexToNumber(n);
  } else if (n instanceof Uint8Array) {
    if (n.length !== 32)
      throw new Error("Expected 32 bytes of private scalar");
    c = utils__namespace.bytesToNumberBE(n);
  } else
    throw new TypeError("Expected valid private scalar");
  if (c < 0) throw new Error("Expected private scalar >= 0");
  return c;
}
function normalizePrivateKey(n) {
  return secp256k1$a.secp256k1.utils.normPrivateKeyToScalar(n);
}
function _privateAdd(n, c) {
  const u = normalizePrivateKey(n), p = normalizeScalar(c), a = utils__namespace.numberToBytesBE(mod__namespace.mod(u + p, secp256k1$a.secp256k1.CURVE.n), 32);
  return secp256k1$a.secp256k1.utils.isValidPrivateKey(a) ? a : null;
}
function _privateSub(n, c) {
  const u = normalizePrivateKey(n), p = normalizeScalar(c), a = utils__namespace.numberToBytesBE(mod__namespace.mod(u - p, secp256k1$a.secp256k1.CURVE.n), 32);
  return secp256k1$a.secp256k1.utils.isValidPrivateKey(a) ? a : null;
}
function _privateNegate(n) {
  const c = normalizePrivateKey(n), u = utils__namespace.numberToBytesBE(secp256k1$a.secp256k1.CURVE.n - c, 32);
  return secp256k1$a.secp256k1.utils.isValidPrivateKey(u) ? u : null;
}
function _pointAddScalar(n, c, u) {
  const p = fromHex$3(n), a = normalizeScalar(c), A = Point$9.BASE.multiplyAndAddUnsafe(p, a, _1n$h);
  if (!A) throw new Error("Tweaked point at infinity");
  return A.toRawBytes(u);
}
function _pointMultiply(n, c, u) {
  const p = fromHex$3(n), a = typeof c == "string" ? c : utils__namespace.bytesToHex(c), A = utils__namespace.hexToNumber(a);
  return p.multiply(A).toRawBytes(u);
}
function assumeCompression$1(n, c) {
  return n === void 0 ? c !== void 0 ? isPointCompressed$2(c) : !0 : !!n;
}
function throwToNull(n) {
  try {
    return n();
  } catch {
    return null;
  }
}
function fromXOnly(n) {
  return secp256k1$a.schnorr.utils.lift_x(utils__namespace.bytesToNumberBE(n));
}
function fromHex$3(n) {
  return n.length === 32 ? fromXOnly(n) : Point$9.fromHex(n);
}
function _isPoint$1(n, c) {
  if (n.length === 32 !== c) return !1;
  try {
    return c ? !!fromXOnly(n) : !!Point$9.fromHex(n);
  } catch {
    return !1;
  }
}
function isPoint$3(n) {
  return _isPoint$1(n, !1);
}
function isPointCompressed$2(n) {
  return _isPoint$1(n, !1) && n.length === 33;
}
function isPrivate$2(n) {
  return secp256k1$a.secp256k1.utils.isValidPrivateKey(n);
}
function isXOnlyPoint$2(n) {
  return _isPoint$1(n, !0);
}
function xOnlyPointAddTweak$2(n, c) {
  if (!isXOnlyPoint$2(n))
    throw new Error(THROW_BAD_POINT);
  if (!isTweak$1(c))
    throw new Error(THROW_BAD_TWEAK);
  return throwToNull(() => {
    const u = _pointAddScalar(n, c, !0);
    return { parity: u[0] % 2 === 1 ? 1 : 0, xOnlyPubkey: u.slice(1) };
  });
}
function xOnlyPointFromPoint$2(n) {
  if (!isPoint$3(n))
    throw new Error(THROW_BAD_POINT);
  return n.slice(1, 33);
}
function pointFromScalar$2(n, c) {
  if (!isPrivate$2(n))
    throw new Error(THROW_BAD_PRIVATE);
  return throwToNull(
    () => secp256k1$a.secp256k1.getPublicKey(n, assumeCompression$1(c))
  );
}
function xOnlyPointFromScalar$2(n) {
  if (!isPrivate$2(n))
    throw new Error(THROW_BAD_PRIVATE);
  return xOnlyPointFromPoint$2(pointFromScalar$2(n));
}
function pointCompress$2(n, c) {
  if (!isPoint$3(n))
    throw new Error(THROW_BAD_POINT);
  return fromHex$3(n).toRawBytes(assumeCompression$1(c, n));
}
function pointMultiply$2(n, c, u) {
  if (!isPoint$3(n))
    throw new Error(THROW_BAD_POINT);
  if (!isTweak$1(c))
    throw new Error(THROW_BAD_TWEAK);
  return throwToNull(
    () => _pointMultiply(n, c, assumeCompression$1(u, n))
  );
}
function pointAdd$2(n, c, u) {
  if (!isPoint$3(n) || !isPoint$3(c))
    throw new Error(THROW_BAD_POINT);
  return throwToNull(() => {
    const p = fromHex$3(n), a = fromHex$3(c);
    return p.equals(a.negate()) ? null : p.add(a).toRawBytes(assumeCompression$1(u, n));
  });
}
function pointAddScalar$2(n, c, u) {
  if (!isPoint$3(n))
    throw new Error(THROW_BAD_POINT);
  if (!isTweak$1(c))
    throw new Error(THROW_BAD_TWEAK);
  return throwToNull(
    () => _pointAddScalar(n, c, assumeCompression$1(u, n))
  );
}
function privateAdd$2(n, c) {
  if (!isPrivate$2(n))
    throw new Error(THROW_BAD_PRIVATE);
  if (!isTweak$1(c))
    throw new Error(THROW_BAD_TWEAK);
  return throwToNull(() => _privateAdd(n, c));
}
function privateSub$2(n, c) {
  if (!isPrivate$2(n))
    throw new Error(THROW_BAD_PRIVATE);
  if (!isTweak$1(c))
    throw new Error(THROW_BAD_TWEAK);
  return throwToNull(() => _privateSub(n, c));
}
function privateNegate$2(n) {
  if (!isPrivate$2(n))
    throw new Error(THROW_BAD_PRIVATE);
  return _privateNegate(n);
}
function sign$4(n, c, u) {
  if (!isPrivate$2(c))
    throw new Error(THROW_BAD_PRIVATE);
  if (!isHash$1(n))
    throw new Error(THROW_BAD_SCALAR);
  if (!isExtraData$1(u))
    throw new Error(THROW_BAD_EXTRA_DATA);
  return secp256k1$a.secp256k1.sign(n, c, { extraEntropy: u }).toCompactRawBytes();
}
function signRecoverable$2(n, c, u) {
  if (!isPrivate$2(c))
    throw new Error(THROW_BAD_PRIVATE);
  if (!isHash$1(n))
    throw new Error(THROW_BAD_SCALAR);
  if (!isExtraData$1(u))
    throw new Error(THROW_BAD_EXTRA_DATA);
  const p = secp256k1$a.secp256k1.sign(n, c, { extraEntropy: u });
  return {
    signature: p.toCompactRawBytes(),
    recoveryId: p.recovery
  };
}
function signSchnorr$3(n, c, u) {
  if (!isPrivate$2(c))
    throw new Error(THROW_BAD_PRIVATE);
  if (!isHash$1(n))
    throw new Error(THROW_BAD_SCALAR);
  if (!isExtraData$1(u))
    throw new Error(THROW_BAD_EXTRA_DATA);
  return secp256k1$a.schnorr.sign(n, c, u);
}
function recover$2(n, c, u, p) {
  if (!isHash$1(n))
    throw new Error(THROW_BAD_HASH);
  if (!isSignature$1(c) || !isSignatureNonzeroRS(c))
    throw new Error(THROW_BAD_SIGNATURE);
  if (u & 2 && !isSigrLessThanPMinusN$1(c))
    throw new Error(THROW_BAD_RECOVERY_ID);
  if (!isXOnlyPoint$2(c.subarray(0, 32)))
    throw new Error(THROW_BAD_SIGNATURE);
  const A = secp256k1$a.secp256k1.Signature.fromCompact(c).addRecoveryBit(u).recoverPublicKey(n);
  if (!A) throw new Error(THROW_BAD_SIGNATURE);
  return A.toRawBytes(assumeCompression$1(p));
}
function verify$3(n, c, u, p) {
  if (!isPoint$3(c))
    throw new Error(THROW_BAD_POINT);
  if (!isSignature$1(u))
    throw new Error(THROW_BAD_SIGNATURE);
  if (!isHash$1(n))
    throw new Error(THROW_BAD_SCALAR);
  return secp256k1$a.secp256k1.verify(u, n, c, { lowS: p });
}
function verifySchnorr$2(n, c, u) {
  if (!isXOnlyPoint$2(c))
    throw new Error(THROW_BAD_POINT);
  if (!isSignature$1(u))
    throw new Error(THROW_BAD_SIGNATURE);
  if (!isHash$1(n))
    throw new Error(THROW_BAD_SCALAR);
  return secp256k1$a.schnorr.verify(u, n, c);
}
dist$x.isPoint = isPoint$3;
dist$x.isPointCompressed = isPointCompressed$2;
dist$x.isPrivate = isPrivate$2;
dist$x.isXOnlyPoint = isXOnlyPoint$2;
dist$x.pointAdd = pointAdd$2;
dist$x.pointAddScalar = pointAddScalar$2;
dist$x.pointCompress = pointCompress$2;
dist$x.pointFromScalar = pointFromScalar$2;
dist$x.pointMultiply = pointMultiply$2;
dist$x.privateAdd = privateAdd$2;
dist$x.privateNegate = privateNegate$2;
dist$x.privateSub = privateSub$2;
dist$x.recover = recover$2;
dist$x.sign = sign$4;
dist$x.signRecoverable = signRecoverable$2;
dist$x.signSchnorr = signSchnorr$3;
dist$x.verify = verify$3;
dist$x.verifySchnorr = verifySchnorr$2;
dist$x.xOnlyPointAddTweak = xOnlyPointAddTweak$2;
dist$x.xOnlyPointFromPoint = xOnlyPointFromPoint$2;
dist$x.xOnlyPointFromScalar = xOnlyPointFromScalar$2;
var dist$w = {}, utils$K = {}, stringHelper = {}, commonjsBrowser$3 = {}, v1$d = {}, rng$e = {};
Object.defineProperty(rng$e, "__esModule", {
  value: !0
});
rng$e.default = rng$d;
let getRandomValues$c;
const rnds8$a = new Uint8Array(16);
function rng$d() {
  if (!getRandomValues$c && (getRandomValues$c = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !getRandomValues$c))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return getRandomValues$c(rnds8$a);
}
var stringify$d = {}, validate$e = {}, regex$3 = {};
Object.defineProperty(regex$3, "__esModule", {
  value: !0
});
regex$3.default = void 0;
var _default$c = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
regex$3.default = _default$c;
Object.defineProperty(validate$e, "__esModule", {
  value: !0
});
validate$e.default = void 0;
var _regex = _interopRequireDefault$8(regex$3);
function _interopRequireDefault$8(n) {
  return n && n.__esModule ? n : { default: n };
}
function validate$d(n) {
  return typeof n == "string" && _regex.default.test(n);
}
var _default$b = validate$d;
validate$e.default = _default$b;
Object.defineProperty(stringify$d, "__esModule", {
  value: !0
});
stringify$d.default = void 0;
stringify$d.unsafeStringify = unsafeStringify$1;
var _validate$2 = _interopRequireDefault$7(validate$e);
function _interopRequireDefault$7(n) {
  return n && n.__esModule ? n : { default: n };
}
const byteToHex$a = [];
for (let n = 0; n < 256; ++n)
  byteToHex$a.push((n + 256).toString(16).slice(1));
function unsafeStringify$1(n, c = 0) {
  return byteToHex$a[n[c + 0]] + byteToHex$a[n[c + 1]] + byteToHex$a[n[c + 2]] + byteToHex$a[n[c + 3]] + "-" + byteToHex$a[n[c + 4]] + byteToHex$a[n[c + 5]] + "-" + byteToHex$a[n[c + 6]] + byteToHex$a[n[c + 7]] + "-" + byteToHex$a[n[c + 8]] + byteToHex$a[n[c + 9]] + "-" + byteToHex$a[n[c + 10]] + byteToHex$a[n[c + 11]] + byteToHex$a[n[c + 12]] + byteToHex$a[n[c + 13]] + byteToHex$a[n[c + 14]] + byteToHex$a[n[c + 15]];
}
function stringify$c(n, c = 0) {
  const u = unsafeStringify$1(n, c);
  if (!(0, _validate$2.default)(u))
    throw TypeError("Stringified UUID is invalid");
  return u;
}
var _default$a = stringify$c;
stringify$d.default = _default$a;
Object.defineProperty(v1$d, "__esModule", {
  value: !0
});
v1$d.default = void 0;
var _rng$1 = _interopRequireDefault$6(rng$e), _stringify$2 = stringify$d;
function _interopRequireDefault$6(n) {
  return n && n.__esModule ? n : { default: n };
}
let _nodeId$9, _clockseq$9, _lastMSecs$9 = 0, _lastNSecs$9 = 0;
function v1$c(n, c, u) {
  let p = c && u || 0;
  const a = c || new Array(16);
  n = n || {};
  let A = n.node || _nodeId$9, b = n.clockseq !== void 0 ? n.clockseq : _clockseq$9;
  if (A == null || b == null) {
    const Ee = n.random || (n.rng || _rng$1.default)();
    A == null && (A = _nodeId$9 = [Ee[0] | 1, Ee[1], Ee[2], Ee[3], Ee[4], Ee[5]]), b == null && (b = _clockseq$9 = (Ee[6] << 8 | Ee[7]) & 16383);
  }
  let F = n.msecs !== void 0 ? n.msecs : Date.now(), le = n.nsecs !== void 0 ? n.nsecs : _lastNSecs$9 + 1;
  const L = F - _lastMSecs$9 + (le - _lastNSecs$9) / 1e4;
  if (L < 0 && n.clockseq === void 0 && (b = b + 1 & 16383), (L < 0 || F > _lastMSecs$9) && n.nsecs === void 0 && (le = 0), le >= 1e4)
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  _lastMSecs$9 = F, _lastNSecs$9 = le, _clockseq$9 = b, F += 122192928e5;
  const pe = ((F & 268435455) * 1e4 + le) % 4294967296;
  a[p++] = pe >>> 24 & 255, a[p++] = pe >>> 16 & 255, a[p++] = pe >>> 8 & 255, a[p++] = pe & 255;
  const $ = F / 4294967296 * 1e4 & 268435455;
  a[p++] = $ >>> 8 & 255, a[p++] = $ & 255, a[p++] = $ >>> 24 & 15 | 16, a[p++] = $ >>> 16 & 255, a[p++] = b >>> 8 | 128, a[p++] = b & 255;
  for (let Ee = 0; Ee < 6; ++Ee)
    a[p + Ee] = A[Ee];
  return c || (0, _stringify$2.unsafeStringify)(a);
}
var _default$9 = v1$c;
v1$d.default = _default$9;
var v3$d = {}, v35$d = {}, parse$k = {};
Object.defineProperty(parse$k, "__esModule", {
  value: !0
});
parse$k.default = void 0;
var _validate$1 = _interopRequireDefault$5(validate$e);
function _interopRequireDefault$5(n) {
  return n && n.__esModule ? n : { default: n };
}
function parse$j(n) {
  if (!(0, _validate$1.default)(n))
    throw TypeError("Invalid UUID");
  let c;
  const u = new Uint8Array(16);
  return u[0] = (c = parseInt(n.slice(0, 8), 16)) >>> 24, u[1] = c >>> 16 & 255, u[2] = c >>> 8 & 255, u[3] = c & 255, u[4] = (c = parseInt(n.slice(9, 13), 16)) >>> 8, u[5] = c & 255, u[6] = (c = parseInt(n.slice(14, 18), 16)) >>> 8, u[7] = c & 255, u[8] = (c = parseInt(n.slice(19, 23), 16)) >>> 8, u[9] = c & 255, u[10] = (c = parseInt(n.slice(24, 36), 16)) / 1099511627776 & 255, u[11] = c / 4294967296 & 255, u[12] = c >>> 24 & 255, u[13] = c >>> 16 & 255, u[14] = c >>> 8 & 255, u[15] = c & 255, u;
}
var _default$8 = parse$j;
parse$k.default = _default$8;
Object.defineProperty(v35$d, "__esModule", {
  value: !0
});
v35$d.URL = v35$d.DNS = void 0;
v35$d.default = v35$c;
var _stringify$1 = stringify$d, _parse = _interopRequireDefault$4(parse$k);
function _interopRequireDefault$4(n) {
  return n && n.__esModule ? n : { default: n };
}
function stringToBytes$a(n) {
  n = unescape(encodeURIComponent(n));
  const c = [];
  for (let u = 0; u < n.length; ++u)
    c.push(n.charCodeAt(u));
  return c;
}
const DNS$9 = "6ba7b810-9dad-11d1-80b4-00c04fd430c8";
v35$d.DNS = DNS$9;
const URL$a = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
v35$d.URL = URL$a;
function v35$c(n, c, u) {
  function p(a, A, b, F) {
    var le;
    if (typeof a == "string" && (a = stringToBytes$a(a)), typeof A == "string" && (A = (0, _parse.default)(A)), ((le = A) === null || le === void 0 ? void 0 : le.length) !== 16)
      throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    let L = new Uint8Array(16 + a.length);
    if (L.set(A), L.set(a, A.length), L = u(L), L[6] = L[6] & 15 | c, L[8] = L[8] & 63 | 128, b) {
      F = F || 0;
      for (let pe = 0; pe < 16; ++pe)
        b[F + pe] = L[pe];
      return b;
    }
    return (0, _stringify$1.unsafeStringify)(L);
  }
  try {
    p.name = n;
  } catch {
  }
  return p.DNS = DNS$9, p.URL = URL$a, p;
}
var md5$f = {};
Object.defineProperty(md5$f, "__esModule", {
  value: !0
});
md5$f.default = void 0;
function md5$e(n) {
  if (typeof n == "string") {
    const c = unescape(encodeURIComponent(n));
    n = new Uint8Array(c.length);
    for (let u = 0; u < c.length; ++u)
      n[u] = c.charCodeAt(u);
  }
  return md5ToHexEncodedArray$9(wordsToMd5$9(bytesToWords$9(n), n.length * 8));
}
function md5ToHexEncodedArray$9(n) {
  const c = [], u = n.length * 32, p = "0123456789abcdef";
  for (let a = 0; a < u; a += 8) {
    const A = n[a >> 5] >>> a % 32 & 255, b = parseInt(p.charAt(A >>> 4 & 15) + p.charAt(A & 15), 16);
    c.push(b);
  }
  return c;
}
function getOutputLength$9(n) {
  return (n + 64 >>> 9 << 4) + 14 + 1;
}
function wordsToMd5$9(n, c) {
  n[c >> 5] |= 128 << c % 32, n[getOutputLength$9(c) - 1] = c;
  let u = 1732584193, p = -271733879, a = -1732584194, A = 271733878;
  for (let b = 0; b < n.length; b += 16) {
    const F = u, le = p, L = a, pe = A;
    u = md5ff$9(u, p, a, A, n[b], 7, -680876936), A = md5ff$9(A, u, p, a, n[b + 1], 12, -389564586), a = md5ff$9(a, A, u, p, n[b + 2], 17, 606105819), p = md5ff$9(p, a, A, u, n[b + 3], 22, -1044525330), u = md5ff$9(u, p, a, A, n[b + 4], 7, -176418897), A = md5ff$9(A, u, p, a, n[b + 5], 12, 1200080426), a = md5ff$9(a, A, u, p, n[b + 6], 17, -1473231341), p = md5ff$9(p, a, A, u, n[b + 7], 22, -45705983), u = md5ff$9(u, p, a, A, n[b + 8], 7, 1770035416), A = md5ff$9(A, u, p, a, n[b + 9], 12, -1958414417), a = md5ff$9(a, A, u, p, n[b + 10], 17, -42063), p = md5ff$9(p, a, A, u, n[b + 11], 22, -1990404162), u = md5ff$9(u, p, a, A, n[b + 12], 7, 1804603682), A = md5ff$9(A, u, p, a, n[b + 13], 12, -40341101), a = md5ff$9(a, A, u, p, n[b + 14], 17, -1502002290), p = md5ff$9(p, a, A, u, n[b + 15], 22, 1236535329), u = md5gg$9(u, p, a, A, n[b + 1], 5, -165796510), A = md5gg$9(A, u, p, a, n[b + 6], 9, -1069501632), a = md5gg$9(a, A, u, p, n[b + 11], 14, 643717713), p = md5gg$9(p, a, A, u, n[b], 20, -373897302), u = md5gg$9(u, p, a, A, n[b + 5], 5, -701558691), A = md5gg$9(A, u, p, a, n[b + 10], 9, 38016083), a = md5gg$9(a, A, u, p, n[b + 15], 14, -660478335), p = md5gg$9(p, a, A, u, n[b + 4], 20, -405537848), u = md5gg$9(u, p, a, A, n[b + 9], 5, 568446438), A = md5gg$9(A, u, p, a, n[b + 14], 9, -1019803690), a = md5gg$9(a, A, u, p, n[b + 3], 14, -187363961), p = md5gg$9(p, a, A, u, n[b + 8], 20, 1163531501), u = md5gg$9(u, p, a, A, n[b + 13], 5, -1444681467), A = md5gg$9(A, u, p, a, n[b + 2], 9, -51403784), a = md5gg$9(a, A, u, p, n[b + 7], 14, 1735328473), p = md5gg$9(p, a, A, u, n[b + 12], 20, -1926607734), u = md5hh$9(u, p, a, A, n[b + 5], 4, -378558), A = md5hh$9(A, u, p, a, n[b + 8], 11, -2022574463), a = md5hh$9(a, A, u, p, n[b + 11], 16, 1839030562), p = md5hh$9(p, a, A, u, n[b + 14], 23, -35309556), u = md5hh$9(u, p, a, A, n[b + 1], 4, -1530992060), A = md5hh$9(A, u, p, a, n[b + 4], 11, 1272893353), a = md5hh$9(a, A, u, p, n[b + 7], 16, -155497632), p = md5hh$9(p, a, A, u, n[b + 10], 23, -1094730640), u = md5hh$9(u, p, a, A, n[b + 13], 4, 681279174), A = md5hh$9(A, u, p, a, n[b], 11, -358537222), a = md5hh$9(a, A, u, p, n[b + 3], 16, -722521979), p = md5hh$9(p, a, A, u, n[b + 6], 23, 76029189), u = md5hh$9(u, p, a, A, n[b + 9], 4, -640364487), A = md5hh$9(A, u, p, a, n[b + 12], 11, -421815835), a = md5hh$9(a, A, u, p, n[b + 15], 16, 530742520), p = md5hh$9(p, a, A, u, n[b + 2], 23, -995338651), u = md5ii$9(u, p, a, A, n[b], 6, -198630844), A = md5ii$9(A, u, p, a, n[b + 7], 10, 1126891415), a = md5ii$9(a, A, u, p, n[b + 14], 15, -1416354905), p = md5ii$9(p, a, A, u, n[b + 5], 21, -57434055), u = md5ii$9(u, p, a, A, n[b + 12], 6, 1700485571), A = md5ii$9(A, u, p, a, n[b + 3], 10, -1894986606), a = md5ii$9(a, A, u, p, n[b + 10], 15, -1051523), p = md5ii$9(p, a, A, u, n[b + 1], 21, -2054922799), u = md5ii$9(u, p, a, A, n[b + 8], 6, 1873313359), A = md5ii$9(A, u, p, a, n[b + 15], 10, -30611744), a = md5ii$9(a, A, u, p, n[b + 6], 15, -1560198380), p = md5ii$9(p, a, A, u, n[b + 13], 21, 1309151649), u = md5ii$9(u, p, a, A, n[b + 4], 6, -145523070), A = md5ii$9(A, u, p, a, n[b + 11], 10, -1120210379), a = md5ii$9(a, A, u, p, n[b + 2], 15, 718787259), p = md5ii$9(p, a, A, u, n[b + 9], 21, -343485551), u = safeAdd$9(u, F), p = safeAdd$9(p, le), a = safeAdd$9(a, L), A = safeAdd$9(A, pe);
  }
  return [u, p, a, A];
}
function bytesToWords$9(n) {
  if (n.length === 0)
    return [];
  const c = n.length * 8, u = new Uint32Array(getOutputLength$9(c));
  for (let p = 0; p < c; p += 8)
    u[p >> 5] |= (n[p / 8] & 255) << p % 32;
  return u;
}
function safeAdd$9(n, c) {
  const u = (n & 65535) + (c & 65535);
  return (n >> 16) + (c >> 16) + (u >> 16) << 16 | u & 65535;
}
function bitRotateLeft$9(n, c) {
  return n << c | n >>> 32 - c;
}
function md5cmn$9(n, c, u, p, a, A) {
  return safeAdd$9(bitRotateLeft$9(safeAdd$9(safeAdd$9(c, n), safeAdd$9(p, A)), a), u);
}
function md5ff$9(n, c, u, p, a, A, b) {
  return md5cmn$9(c & u | ~c & p, n, c, a, A, b);
}
function md5gg$9(n, c, u, p, a, A, b) {
  return md5cmn$9(c & p | u & ~p, n, c, a, A, b);
}
function md5hh$9(n, c, u, p, a, A, b) {
  return md5cmn$9(c ^ u ^ p, n, c, a, A, b);
}
function md5ii$9(n, c, u, p, a, A, b) {
  return md5cmn$9(u ^ (c | ~p), n, c, a, A, b);
}
var _default$7 = md5$e;
md5$f.default = _default$7;
Object.defineProperty(v3$d, "__esModule", {
  value: !0
});
v3$d.default = void 0;
var _v$1 = _interopRequireDefault$3(v35$d), _md$1 = _interopRequireDefault$3(md5$f);
function _interopRequireDefault$3(n) {
  return n && n.__esModule ? n : { default: n };
}
const v3$c = (0, _v$1.default)("v3", 48, _md$1.default);
var _default$6 = v3$c;
v3$d.default = _default$6;
var v4$e = {}, native$4 = {};
Object.defineProperty(native$4, "__esModule", {
  value: !0
});
native$4.default = void 0;
const randomUUID$1 = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var _default$5 = {
  randomUUID: randomUUID$1
};
native$4.default = _default$5;
Object.defineProperty(v4$e, "__esModule", {
  value: !0
});
v4$e.default = void 0;
var _native = _interopRequireDefault$2(native$4), _rng = _interopRequireDefault$2(rng$e), _stringify = stringify$d;
function _interopRequireDefault$2(n) {
  return n && n.__esModule ? n : { default: n };
}
function v4$d(n, c, u) {
  if (_native.default.randomUUID && !c && !n)
    return _native.default.randomUUID();
  n = n || {};
  const p = n.random || (n.rng || _rng.default)();
  if (p[6] = p[6] & 15 | 64, p[8] = p[8] & 63 | 128, c) {
    u = u || 0;
    for (let a = 0; a < 16; ++a)
      c[u + a] = p[a];
    return c;
  }
  return (0, _stringify.unsafeStringify)(p);
}
var _default$4 = v4$d;
v4$e.default = _default$4;
var v5$d = {}, sha1$e = {};
Object.defineProperty(sha1$e, "__esModule", {
  value: !0
});
sha1$e.default = void 0;
function f$c(n, c, u, p) {
  switch (n) {
    case 0:
      return c & u ^ ~c & p;
    case 1:
      return c ^ u ^ p;
    case 2:
      return c & u ^ c & p ^ u & p;
    case 3:
      return c ^ u ^ p;
  }
}
function ROTL$9(n, c) {
  return n << c | n >>> 32 - c;
}
function sha1$d(n) {
  const c = [1518500249, 1859775393, 2400959708, 3395469782], u = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
  if (typeof n == "string") {
    const b = unescape(encodeURIComponent(n));
    n = [];
    for (let F = 0; F < b.length; ++F)
      n.push(b.charCodeAt(F));
  } else Array.isArray(n) || (n = Array.prototype.slice.call(n));
  n.push(128);
  const p = n.length / 4 + 2, a = Math.ceil(p / 16), A = new Array(a);
  for (let b = 0; b < a; ++b) {
    const F = new Uint32Array(16);
    for (let le = 0; le < 16; ++le)
      F[le] = n[b * 64 + le * 4] << 24 | n[b * 64 + le * 4 + 1] << 16 | n[b * 64 + le * 4 + 2] << 8 | n[b * 64 + le * 4 + 3];
    A[b] = F;
  }
  A[a - 1][14] = (n.length - 1) * 8 / Math.pow(2, 32), A[a - 1][14] = Math.floor(A[a - 1][14]), A[a - 1][15] = (n.length - 1) * 8 & 4294967295;
  for (let b = 0; b < a; ++b) {
    const F = new Uint32Array(80);
    for (let be = 0; be < 16; ++be)
      F[be] = A[b][be];
    for (let be = 16; be < 80; ++be)
      F[be] = ROTL$9(F[be - 3] ^ F[be - 8] ^ F[be - 14] ^ F[be - 16], 1);
    let le = u[0], L = u[1], pe = u[2], $ = u[3], Ee = u[4];
    for (let be = 0; be < 80; ++be) {
      const He = Math.floor(be / 20), Pe = ROTL$9(le, 5) + f$c(He, L, pe, $) + Ee + c[He] + F[be] >>> 0;
      Ee = $, $ = pe, pe = ROTL$9(L, 30) >>> 0, L = le, le = Pe;
    }
    u[0] = u[0] + le >>> 0, u[1] = u[1] + L >>> 0, u[2] = u[2] + pe >>> 0, u[3] = u[3] + $ >>> 0, u[4] = u[4] + Ee >>> 0;
  }
  return [u[0] >> 24 & 255, u[0] >> 16 & 255, u[0] >> 8 & 255, u[0] & 255, u[1] >> 24 & 255, u[1] >> 16 & 255, u[1] >> 8 & 255, u[1] & 255, u[2] >> 24 & 255, u[2] >> 16 & 255, u[2] >> 8 & 255, u[2] & 255, u[3] >> 24 & 255, u[3] >> 16 & 255, u[3] >> 8 & 255, u[3] & 255, u[4] >> 24 & 255, u[4] >> 16 & 255, u[4] >> 8 & 255, u[4] & 255];
}
var _default$3 = sha1$d;
sha1$e.default = _default$3;
Object.defineProperty(v5$d, "__esModule", {
  value: !0
});
v5$d.default = void 0;
var _v = _interopRequireDefault$1(v35$d), _sha = _interopRequireDefault$1(sha1$e);
function _interopRequireDefault$1(n) {
  return n && n.__esModule ? n : { default: n };
}
const v5$c = (0, _v.default)("v5", 80, _sha.default);
var _default$2 = v5$c;
v5$d.default = _default$2;
var nil$c = {};
Object.defineProperty(nil$c, "__esModule", {
  value: !0
});
nil$c.default = void 0;
var _default$1 = "00000000-0000-0000-0000-000000000000";
nil$c.default = _default$1;
var version$f = {};
Object.defineProperty(version$f, "__esModule", {
  value: !0
});
version$f.default = void 0;
var _validate = _interopRequireDefault(validate$e);
function _interopRequireDefault(n) {
  return n && n.__esModule ? n : { default: n };
}
function version$e(n) {
  if (!(0, _validate.default)(n))
    throw TypeError("Invalid UUID");
  return parseInt(n.slice(14, 15), 16);
}
var _default = version$e;
version$f.default = _default;
(function(n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), Object.defineProperty(n, "NIL", {
    enumerable: !0,
    get: function() {
      return A.default;
    }
  }), Object.defineProperty(n, "parse", {
    enumerable: !0,
    get: function() {
      return L.default;
    }
  }), Object.defineProperty(n, "stringify", {
    enumerable: !0,
    get: function() {
      return le.default;
    }
  }), Object.defineProperty(n, "v1", {
    enumerable: !0,
    get: function() {
      return c.default;
    }
  }), Object.defineProperty(n, "v3", {
    enumerable: !0,
    get: function() {
      return u.default;
    }
  }), Object.defineProperty(n, "v4", {
    enumerable: !0,
    get: function() {
      return p.default;
    }
  }), Object.defineProperty(n, "v5", {
    enumerable: !0,
    get: function() {
      return a.default;
    }
  }), Object.defineProperty(n, "validate", {
    enumerable: !0,
    get: function() {
      return F.default;
    }
  }), Object.defineProperty(n, "version", {
    enumerable: !0,
    get: function() {
      return b.default;
    }
  });
  var c = pe(v1$d), u = pe(v3$d), p = pe(v4$e), a = pe(v5$d), A = pe(nil$c), b = pe(version$f), F = pe(validate$e), le = pe(stringify$d), L = pe(parse$k);
  function pe($) {
    return $ && $.__esModule ? $ : { default: $ };
  }
})(commonjsBrowser$3);
var coin$1 = {};
Object.defineProperty(coin$1, "__esModule", { value: !0 });
coin$1.getCoinSymbol = void 0;
function getCoinSymbol(n) {
  var c;
  return (c = {
    0: "BTC",
    2: "LTC",
    3: "DOGE",
    4: "RDD",
    5: "DASH",
    6: "PPC",
    7: "NMC",
    8: "FTC",
    9: "XCP",
    10: "BLK",
    11: "NSR",
    12: "NBT",
    13: "MZC",
    14: "VIA",
    15: "XCH",
    16: "RBY",
    17: "GRS",
    18: "DGC",
    19: "CCN",
    20: "DGB",
    22: "MONA",
    23: "CLAM",
    24: "XPM",
    25: "NEOS",
    26: "JBS",
    27: "ZRC",
    28: "VTC",
    29: "NXT",
    30: "BURST",
    31: "MUE",
    32: "ZOOM",
    33: "VASH",
    34: "CDN",
    35: "SDC",
    36: "PKB",
    37: "PND",
    38: "START",
    39: "MOIN",
    40: "EXP",
    41: "EMC2",
    42: "DCR",
    43: "XEM",
    44: "PART",
    45: "ARG",
    48: "SHR",
    49: "GCR",
    50: "NVC",
    51: "AC",
    52: "BTCD",
    53: "DOPE",
    54: "TPC",
    55: "AIB",
    56: "EDRC",
    57: "SYS",
    58: "SLR",
    59: "SMLY",
    60: "ETH",
    61: "ETC",
    62: "PSB",
    63: "LDCN",
    65: "XBC",
    66: "IOP",
    67: "NXS",
    68: "INSN",
    69: "OK",
    70: "BRIT",
    71: "CMP",
    72: "CRW",
    73: "BELA",
    74: "ICX",
    75: "FJC",
    76: "MIX",
    77: "XVG",
    78: "EFL",
    79: "CLUB",
    80: "RICHX",
    81: "POT",
    82: "QRK",
    83: "TRC",
    84: "GRC",
    85: "AUR",
    86: "IXC",
    87: "NLG",
    88: "BITB",
    89: "BTA",
    90: "XMY",
    91: "BSD",
    92: "UNO",
    93: "MTR",
    94: "GB",
    95: "SHM",
    96: "CRX",
    97: "BIQ",
    98: "EVO",
    99: "STO",
    100: "BIGUP",
    101: "GAME",
    102: "DLC",
    103: "ZYD",
    104: "DBIC",
    105: "STRAT",
    106: "SH",
    107: "MARS",
    108: "UBQ",
    109: "PTC",
    110: "NRO",
    111: "ARK",
    112: "USC",
    113: "THC",
    114: "LINX",
    115: "ECN",
    116: "DNR",
    117: "PINK",
    118: "ATOM",
    119: "PIVX",
    120: "FLASH",
    121: "ZEN",
    122: "PUT",
    123: "ZNY",
    124: "UNIFY",
    125: "XST",
    126: "BRK",
    127: "VC",
    128: "XMR",
    129: "VOX",
    130: "NAV",
    131: "FCT",
    132: "EC",
    133: "ZEC",
    134: "LSK",
    135: "STEEM",
    136: "XZC",
    137: "RBTC",
    139: "RPT",
    140: "LBC",
    141: "KMD",
    142: "BSQ",
    143: "RIC",
    144: "XRP",
    145: "BCH",
    146: "NEBL",
    147: "ZCL",
    148: "XLM",
    149: "NLC2",
    150: "WHL",
    151: "ERC",
    152: "DMD",
    153: "BTM",
    154: "BIO",
    155: "XWCC",
    156: "BTG",
    157: "BTC2X",
    158: "SSN",
    159: "TOA",
    160: "BTX",
    161: "ACC",
    162: "BCO",
    163: "ELLA",
    164: "PIRL",
    165: "XNO",
    166: "VIVO",
    167: "FRST",
    168: "HNC",
    169: "BUZZ",
    170: "MBRS",
    171: "HC",
    172: "HTML",
    173: "ODN",
    174: "ONX",
    175: "RVN",
    176: "GBX",
    177: "BTCZ",
    178: "POA",
    179: "NYC",
    180: "MXT",
    181: "WC",
    182: "MNX",
    183: "BTCP",
    184: "MUSIC",
    185: "BCA",
    186: "CRAVE",
    187: "STAK",
    188: "WBTC",
    189: "LCH",
    190: "EXCL",
    192: "LCC",
    193: "XFE",
    194: "EOS",
    195: "TRX",
    196: "KOBO",
    197: "HUSH",
    198: "BAN",
    199: "ETF",
    200: "OMNI",
    201: "BIFI",
    202: "UFO",
    203: "CNMC",
    204: "BCN",
    205: "RIN",
    206: "ATP",
    207: "EVT",
    208: "ATN",
    209: "BIS",
    210: "NEET",
    211: "BOPO",
    212: "OOT",
    213: "ALIAS",
    214: "MONK",
    215: "BOXY",
    216: "FLO",
    217: "MEC",
    218: "BTDX",
    219: "XAX",
    220: "ANON",
    221: "LTZ",
    222: "BITG",
    223: "ICP",
    224: "SMART",
    225: "XUEZ",
    226: "HLM",
    227: "WEB",
    228: "ACM",
    229: "NOS",
    230: "BITC",
    231: "HTH",
    232: "TZC",
    233: "VAR",
    234: "IOV",
    235: "FIO",
    236: "BSV",
    237: "DXN",
    238: "QRL",
    239: "PCX",
    240: "LOKI",
    242: "NIM",
    243: "SOV",
    244: "JCT",
    245: "SLP",
    246: "EWT",
    247: "UC",
    248: "EXOS",
    249: "ECA",
    250: "SOOM",
    251: "XRD",
    252: "FREE",
    253: "NPW",
    254: "BST",
    256: "NANO",
    257: "BTCC",
    259: "ZEST",
    260: "ABT",
    261: "PION",
    262: "DT3",
    263: "ZBUX",
    264: "KPL",
    265: "TPAY",
    266: "ZILLA",
    267: "ANK",
    268: "BCC",
    269: "HPB",
    270: "ONE",
    271: "SBC",
    272: "IPC",
    273: "DMTC",
    274: "OGC",
    275: "SHIT",
    276: "ANDES",
    277: "AREPA",
    278: "BOLI",
    279: "RIL",
    280: "HTR",
    281: "FCTID",
    282: "BRAVO",
    283: "ALGO",
    284: "BZX",
    285: "GXX",
    286: "HEAT",
    287: "XDN",
    288: "FSN",
    289: "CPC",
    290: "BOLD",
    291: "IOST",
    292: "TKEY",
    293: "USE",
    294: "BCZ",
    295: "IOC",
    296: "ASF",
    297: "MASS",
    298: "FAIR",
    299: "NUKO",
    300: "GNX",
    301: "DIVI",
    302: "CMT",
    303: "EUNO",
    304: "IOTX",
    305: "ONION",
    306: "8BIT",
    307: "ATC",
    308: "BTS",
    309: "CKB",
    310: "UGAS",
    311: "ADS",
    312: "ARA",
    313: "ZIL",
    314: "MOAC",
    315: "SWTC",
    316: "VNSC",
    317: "PLUG",
    318: "MAN",
    319: "ECC",
    320: "RPD",
    321: "RAP",
    322: "GARD",
    323: "ZER",
    324: "EBST",
    325: "SHARD",
    326: "MRX",
    327: "CMM",
    328: "BLOCK",
    329: "AUDAX",
    330: "LUNA",
    331: "ZPM",
    332: "KUVA",
    333: "MEM",
    334: "CS",
    335: "SWIFT",
    336: "FIX",
    337: "CPC",
    338: "VGO",
    339: "DVT",
    340: "N8V",
    341: "MTNS",
    342: "BLAST",
    343: "DCT",
    344: "AUX",
    345: "USDP",
    346: "HTDF",
    347: "YEC",
    348: "QLC",
    349: "TEA",
    350: "ARW",
    351: "MDM",
    352: "CYB",
    353: "LTO",
    354: "DOT",
    355: "AEON",
    356: "RES",
    357: "AYA",
    358: "DAPS",
    359: "CSC",
    360: "VSYS",
    361: "NOLLAR",
    362: "XNOS",
    363: "CPU",
    364: "LAMB",
    365: "VCT",
    366: "CZR",
    367: "ABBC",
    368: "HET",
    369: "XAS",
    370: "VDL",
    371: "MED",
    372: "ZVC",
    373: "VESTX",
    374: "DBT",
    375: "SEOS",
    376: "MXW",
    377: "ZNZ",
    378: "XCX",
    379: "SOX",
    380: "NYZO",
    381: "ULC",
    382: "RYO",
    383: "KAL",
    384: "XSN",
    385: "DOGEC",
    386: "BMV",
    387: "QBC",
    388: "IMG",
    389: "QOS",
    390: "PKT",
    391: "LHD",
    392: "CENNZ",
    393: "HSN",
    394: "CRO",
    395: "UMBRU",
    396: "EVER",
    397: "NEAR",
    398: "XPC",
    399: "ZOC",
    400: "NIX",
    401: "UC",
    402: "GALI",
    403: "OLT",
    404: "XBI",
    405: "DONU",
    406: "EARTHS",
    407: "HDD",
    408: "SUGAR",
    409: "AILE",
    410: "TENT",
    411: "TAN",
    412: "AIN",
    413: "MSR",
    414: "SUMO",
    415: "ETN",
    416: "BYTZ",
    417: "WOW",
    418: "XTNC",
    419: "LTHN",
    420: "NODE",
    421: "AGM",
    422: "CCX",
    423: "TNET",
    424: "TELOS",
    425: "AION",
    426: "BC",
    427: "KTV",
    428: "ZCR",
    429: "ERG",
    430: "PESO",
    431: "BTC2",
    432: "XRPHD",
    433: "WE",
    434: "KSM",
    435: "PCN",
    436: "NCH",
    437: "ICU",
    438: "LN",
    439: "DTP",
    440: "BTCR",
    441: "AERGO",
    442: "XTH",
    443: "LV",
    444: "PHR",
    445: "VITAE",
    446: "COCOS",
    447: "DIN",
    448: "SPL",
    449: "YCE",
    450: "XLR",
    451: "KTS",
    452: "DGLD",
    453: "XNS",
    454: "EM",
    455: "SHN",
    456: "SEELE",
    457: "AE",
    458: "ODX",
    459: "KAVA",
    460: "GLEEC",
    461: "FIL",
    462: "RUTA",
    463: "CSDT",
    464: "ETI",
    465: "ZSLP",
    466: "ERE",
    467: "DX",
    468: "CPS",
    469: "BTH",
    470: "MESG",
    471: "FIMK",
    472: "AR",
    473: "OGO",
    474: "ROSE",
    475: "BARE",
    476: "GLEEC",
    477: "CLR",
    478: "RNG",
    479: "OLO",
    480: "PEXA",
    481: "MOON",
    482: "OCEAN",
    483: "BNT",
    484: "AMO",
    485: "FCH",
    486: "LAT",
    487: "COIN",
    488: "VEO",
    489: "CCA",
    490: "GFN",
    491: "BIP",
    492: "KPG",
    493: "FIN",
    494: "BAND",
    495: "DROP",
    496: "BHT",
    497: "LYRA",
    498: "CS",
    499: "RUPX",
    500: "THETA",
    501: "SOL",
    502: "THT",
    503: "CFX",
    504: "KUMA",
    505: "HASH",
    506: "CSPR",
    507: "EARTH",
    508: "EGLD",
    509: "CHI",
    510: "KOTO",
    511: "OTC",
    512: "XRD",
    513: "SEELEN",
    514: "AETH",
    515: "DNA",
    516: "VEE",
    517: "SIERRA",
    518: "LET",
    519: "BSC",
    520: "BTCV",
    521: "ABA",
    522: "SCC",
    523: "EDG",
    524: "AMS",
    525: "GOSS",
    526: "BU",
    527: "GRAM",
    528: "YAP",
    529: "SCRT",
    530: "NOVO",
    531: "GHOST",
    532: "HST",
    533: "PRJ",
    534: "YOU",
    535: "XHV",
    536: "BYND",
    537: "JOYS",
    538: "VAL",
    539: "FLOW",
    540: "SMESH",
    541: "SCDO",
    542: "IQS",
    543: "BIND",
    544: "COINEVO",
    545: "SCRIBE",
    546: "HYN",
    547: "BHP",
    548: "BBC",
    549: "MKF",
    550: "XDC",
    551: "STR",
    552: "SUM",
    553: "HBC",
    555: "BCS",
    556: "KTS",
    557: "LKR",
    558: "TAO",
    559: "XWC",
    560: "DEAL",
    561: "NTY",
    562: "TOP",
    564: "AG",
    565: "CICO",
    566: "IRIS",
    567: "NCG",
    568: "LRG",
    569: "SERO",
    570: "BDX",
    571: "CCXX",
    572: "SLS",
    573: "SRM",
    575: "VIVT",
    576: "BPS",
    577: "NKN",
    578: "ICL",
    579: "BONO",
    580: "PLC",
    581: "DUN",
    582: "DMCH",
    583: "CTC",
    584: "KELP",
    585: "GBCR",
    586: "XDAG",
    587: "PRV",
    588: "SCAP",
    589: "TFUEL",
    590: "GTM",
    591: "RNL",
    592: "GRIN",
    593: "MWC",
    594: "DOCK",
    595: "POLYX",
    596: "DIVER",
    597: "XEP",
    598: "APN",
    599: "TFC",
    600: "UTE",
    601: "MTC",
    602: "NC",
    603: "XINY",
    604: "DYN",
    605: "BUFS",
    606: "STOS",
    607: "TON",
    608: "TAFT",
    609: "HYDRA",
    610: "NOR",
    613: "WCN",
    614: "OPT",
    615: "PSWAP",
    616: "VAL",
    617: "XOR",
    618: "SSP",
    619: "DEI",
    621: "ZERO",
    622: "ALPHA",
    623: "BDECO",
    624: "NOBL",
    625: "EAST",
    626: "KDA",
    627: "SOUL",
    628: "LORE",
    629: "FNR",
    630: "NEXUS",
    631: "QTZ",
    632: "XMA",
    633: "CALL",
    634: "VAL",
    635: "POKT",
    636: "EMIT",
    637: "APTOS",
    638: "ADON",
    639: "BTSG",
    640: "LFC",
    641: "KCS",
    642: "KCC",
    643: "AZERO",
    644: "TREE",
    645: "LX",
    646: "XLN",
    647: "CIC",
    648: "ZRB",
    650: "UCO",
    651: "SFX",
    652: "SFT",
    653: "WSFX",
    654: "USDG",
    655: "WMP",
    659: "KOIN",
    660: "PIRATE",
    663: "SFRX",
    666: "ACT",
    667: "PRKL",
    668: "SSC",
    669: "GC",
    670: "PLGR",
    671: "MPLGR",
    672: "KNOX",
    673: "ZED",
    674: "CNDL",
    675: "WLKR",
    676: "WLKRR",
    677: "YUNGE",
    678: "Voken",
    679: "APL",
    680: "Evrynet",
    681: "NENG",
    682: "CHTA",
    685: "OAS",
    686: "KAR",
    688: "CET",
    690: "KLV",
    694: "VTBC",
    698: "VEIL",
    699: "GTB",
    700: "XDAI",
    701: "COM",
    702: "CCC",
    707: "MCOIN",
    711: "CHC",
    712: "SERF",
    713: "XTL",
    714: "BNB",
    715: "SIN",
    716: "DLN",
    717: "BONTE",
    718: "PEER",
    725: "MCX",
    730: "HEALIOS",
    731: "BMK",
    734: "DENTX",
    737: "ATOP",
    747: "CFG",
    750: "XPRT",
    757: "HONEY",
    768: "BALLZ",
    770: "COSA",
    771: "BR",
    775: "PLSR",
    776: "KEY",
    777: "BTW",
    780: "PLCUC",
    781: "PLCUX",
    782: "PLCU",
    784: "SUI",
    786: "UIDD",
    787: "ACA",
    788: "BNC",
    789: "TAU",
    799: "PDEX",
    800: "BEET",
    801: "DST",
    804: "ZKS",
    808: "QVT",
    809: "SDN",
    810: "ASTR",
    813: "MEER",
    818: "VET",
    819: "REEF",
    820: "CLO",
    822: "BDB",
    827: "ACE",
    828: "CCN",
    831: "CRUZ",
    832: "SAPP",
    833: "777",
    834: "KYAN",
    835: "AZR",
    836: "CFL",
    837: "DASHD",
    838: "TRTT",
    839: "UCR",
    840: "PNY",
    841: "BECN",
    842: "MONK",
    843: "SAGA",
    844: "SUV",
    845: "ESK",
    846: "OWO",
    847: "PEPS",
    848: "BIR",
    849: "MOBIC",
    850: "FLS",
    852: "DSM",
    853: "PRCY",
    858: "HVH",
    866: "MOB",
    868: "IF",
    877: "NAM",
    880: "LUM",
    883: "ZBC",
    886: "ADF",
    888: "NEO",
    889: "TOMO",
    890: "XSEL",
    896: "LKSC",
    898: "AS",
    899: "XEC",
    900: "LMO",
    901: "NXT",
    904: "HNT",
    907: "FIS",
    909: "SGE",
    911: "GERT",
    916: "META",
    917: "FRA",
    919: "CCD",
    921: "AVN",
    925: "DIP",
    928: "GHM",
    931: "RUNE",
    945: "UNLOCK",
    955: "LTP",
    960: "VKAX",
    966: "MATIC",
    968: "UNW",
    970: "TWINS",
    977: "TLOS",
    981: "TAFECO",
    985: "AU",
    987: "VCG",
    988: "XAZAB",
    989: "AIOZ",
    990: "CORE",
    991: "PEC",
    992: "UNT",
    993: "XRB",
    994: "QUAI",
    995: "CAPS",
    996: "OKT",
    997: "SUM",
    998: "LBTC",
    999: "BCD",
    1e3: "BTN",
    1001: "TT",
    1002: "BKT",
    1003: "NODL",
    1004: "PCOIN",
    1005: "TAO",
    1006: "HSK",
    1007: "FTM",
    1008: "RPG",
    1010: "HT",
    1011: "ELV",
    1013: "BIC",
    1020: "EVC",
    1022: "XRD",
    1023: "ONE",
    1024: "ONT",
    1025: "CZZ",
    1026: "KEX",
    1027: "MCM",
    1032: "BTCR",
    1042: "MFID",
    1111: "BBC",
    1120: "RISE",
    1122: "CMT",
    1128: "ETSC",
    1129: "DFI",
    1130: "DFI",
    1137: "$DAG",
    1145: "CDY",
    1155: "EFI",
    1170: "HOO",
    1234: "ALPH",
    1284: "GLMR",
    1285: "MOVR",
    1298: "WPC",
    1308: "WEI",
    1337: "DFC",
    1397: "HYC",
    1410: "TENTSLP",
    1510: "XSC",
    1512: "AAC",
    1533: "BEAM",
    1555: "APC",
    1616: "ELF",
    1618: "AUDL",
    1620: "ATH",
    1627: "LUME",
    1642: "NEW",
    1657: "BTA",
    1668: "NEOX",
    1669: "MEWC",
    1688: "BCX",
    1729: "XTZ",
    1776: "LBTC",
    1777: "BBP",
    1784: "JPYS",
    1789: "VEGA",
    1815: "ADA",
    1818: "CUBE",
    1856: "TES",
    1888: "ZTX",
    1899: "XEC",
    1901: "CLC",
    1919: "VIPS",
    1926: "CITY",
    1955: "XX",
    1977: "XMX",
    1984: "TRTL",
    1985: "SLRT",
    1986: "QTH",
    1987: "EGEM",
    1988: "MIRA",
    1989: "HODL",
    1990: "PHL",
    1991: "SC",
    1996: "MYT",
    1997: "POLIS",
    1998: "XMCC",
    1999: "COLX",
    2e3: "GIN",
    2001: "MNP",
    2002: "MLN",
    2017: "KIN",
    2018: "EOSC",
    2019: "GBT",
    2020: "PKC",
    2021: "SKT",
    2022: "XHT",
    2048: "MCASH",
    2049: "TRUE",
    2086: "KILT",
    2109: "SAMA",
    2112: "IoTE",
    2137: "XRG",
    2182: "CHZ",
    2221: "ASK",
    2301: "QTUM",
    2302: "ETP",
    2303: "GXC",
    2304: "CRP",
    2305: "ELA",
    2338: "SNOW",
    2365: "XIN",
    2570: "AOA",
    2718: "NAS",
    2894: "REOSC",
    2941: "BND",
    3003: "LUX",
    3030: "HBAR",
    3077: "COS",
    3276: "CCC",
    3333: "SXP",
    3377: "ROI",
    3381: "DYN",
    3383: "SEQ",
    3552: "DEO",
    3564: "DST",
    3601: "CY",
    4040: "FC8",
    4096: "YEE",
    4218: "IOTA",
    4219: "SMR",
    4242: "AXE",
    4343: "XYM",
    4444: "C4E",
    4919: "XVM",
    5006: "SBC",
    5248: "FIC",
    5353: "HNS",
    5404: "ISK",
    5467: "ALTME",
    5555: "FUND",
    5757: "STX",
    5895: "VOW",
    5920: "SLU",
    6060: "GO",
    6174: "MOI",
    6599: "RSC",
    6666: "BPA",
    6688: "SAFE",
    6779: "COTI",
    6969: "ROGER",
    7091: "TOPL",
    7331: "KLY",
    7341: "SHFT",
    7777: "BTV",
    8e3: "SKY",
    8192: "PAC",
    8217: "KLAY",
    8339: "BTQ",
    8444: "XCH",
    8680: "PLMNT",
    8888: "SBTC",
    8964: "NULS",
    8997: "BBC",
    8998: "JGC",
    8999: "BTP",
    9e3: "AVAX",
    9001: "ARB1",
    9002: "BOBA",
    9003: "LOOP",
    9004: "STRK",
    9005: "AVAXC",
    9006: "BSC",
    9797: "NRG",
    9888: "BTF",
    9999: "GOD",
    1e4: "FO",
    10226: "RTM",
    10291: "XRC",
    10605: "XPI",
    11111: "ESS",
    12345: "IPOS",
    12586: "MINA",
    13107: "BTY",
    13108: "YCC",
    14001: "WAX",
    15845: "SDGO",
    16181: "XTX",
    16754: "ARDR",
    18e3: "MTR",
    19165: "SAFE",
    19167: "FLUX",
    19169: "RITO",
    20036: "XND",
    21004: "C4EI",
    21888: "PCT",
    22504: "PWR",
    25252: "BELL",
    25718: "CHX",
    29223: "NEXA",
    31102: "ESN",
    33416: "TEO",
    33878: "BTCS",
    34952: "BTT",
    37992: "FXTC",
    39321: "AMA",
    42069: "FACT",
    43028: "AXIV",
    49262: "EVE",
    49344: "STASH",
    52752: "CELO",
    61616: "TH",
    65536: "KETH",
    69420: "GRLC",
    70007: "GWL",
    77777: "ZYN",
    88888: "RYO",
    99999: "WICC",
    100500: "HOME",
    101010: "STC",
    105105: "STRAX",
    111111: "KAS",
    161803: "APTA",
    200625: "AKA",
    200665: "GENOM",
    246529: "ATS",
    261131: "ZAMA",
    314159: "PI",
    333332: "VALUE",
    333333: "3333",
    424242: "X42",
    534352: "SCR",
    666666: "VITE",
    888888: "SEA",
    1048576: "AMAX",
    1171337: "ILT",
    1313114: "ETHO",
    1313500: "XERO",
    1712144: "LAX",
    3924011: "EPK",
    4741444: "HYD",
    5249353: "BCO",
    5249354: "BHD",
    5264462: "PTN",
    5655640: "VLX",
    5718350: "WAN",
    5741564: "WAVES",
    5741565: "WEST",
    6382179: "ABC",
    6517357: "CRM",
    7562605: "SEM",
    7567736: "ION",
    7777777: "FCT",
    7825266: "WGR",
    7825267: "OBSR",
    8163271: "AFS",
    15118976: "XDS",
    61717561: "AQUA",
    88888888: "HATCH",
    91927009: "kUSD",
    99999996: "GENS",
    99999997: "EQ",
    99999998: "FLUID",
    99999999: "QKC",
    608589380: "FVDC"
  }[n]) !== null && c !== void 0 ? c : "";
}
coin$1.getCoinSymbol = getCoinSymbol;
(function(n) {
  var c = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function($, Ee, be, He) {
    He === void 0 && (He = be);
    var Pe = Object.getOwnPropertyDescriptor(Ee, be);
    (!Pe || ("get" in Pe ? !Ee.__esModule : Pe.writable || Pe.configurable)) && (Pe = { enumerable: !0, get: function() {
      return Ee[be];
    } }), Object.defineProperty($, He, Pe);
  } : function($, Ee, be, He) {
    He === void 0 && (He = be), $[He] = Ee[be];
  }), u = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function($, Ee) {
    Object.defineProperty($, "default", { enumerable: !0, value: Ee });
  } : function($, Ee) {
    $.default = Ee;
  }), p = commonjsGlobal && commonjsGlobal.__importStar || function($) {
    if ($ && $.__esModule) return $;
    var Ee = {};
    if ($ != null) for (var be in $) be !== "default" && Object.prototype.hasOwnProperty.call($, be) && c(Ee, $, be);
    return u(Ee, $), Ee;
  }, a = commonjsGlobal && commonjsGlobal.__exportStar || function($, Ee) {
    for (var be in $) be !== "default" && !Object.prototype.hasOwnProperty.call(Ee, be) && c(Ee, $, be);
  };
  Object.defineProperty(n, "__esModule", { value: !0 }), n.parsePath = n.uuidStringify = n.uuidParse = n.toBuffer = n.toHex = n.uuid = void 0;
  const A = p(commonjsBrowser$3);
  n.uuid = A, a(coin$1, n);
  function b($) {
    return $ === void 0 ? "" : Buffer$f.from($).toString("hex");
  }
  n.toHex = b;
  function F($) {
    return Buffer$f.from($ ?? "", "hex");
  }
  n.toBuffer = F;
  function le($) {
    return Buffer$f.from(A.parse($));
  }
  n.uuidParse = le;
  function L($) {
    return A.stringify($);
  }
  n.uuidStringify = L;
  function pe($) {
    return $.replace(/^m\//i, "").split("/").map((be) => {
      const He = be.endsWith("'");
      return {
        index: Number(He ? be.substring(0, be.length - 1) : be),
        hardened: He
      };
    });
  }
  n.parsePath = pe;
})(stringHelper);
var crypto$7 = {}, dist$v = {}, extendStatics = function(n, c) {
  return extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(u, p) {
    u.__proto__ = p;
  } || function(u, p) {
    for (var a in p) Object.prototype.hasOwnProperty.call(p, a) && (u[a] = p[a]);
  }, extendStatics(n, c);
};
function __extends(n, c) {
  if (typeof c != "function" && c !== null)
    throw new TypeError("Class extends value " + String(c) + " is not a constructor or null");
  extendStatics(n, c);
  function u() {
    this.constructor = n;
  }
  n.prototype = c === null ? Object.create(c) : (u.prototype = c.prototype, new u());
}
var __assign = function() {
  return __assign = Object.assign || function(c) {
    for (var u, p = 1, a = arguments.length; p < a; p++) {
      u = arguments[p];
      for (var A in u) Object.prototype.hasOwnProperty.call(u, A) && (c[A] = u[A]);
    }
    return c;
  }, __assign.apply(this, arguments);
};
function __rest(n, c) {
  var u = {};
  for (var p in n) Object.prototype.hasOwnProperty.call(n, p) && c.indexOf(p) < 0 && (u[p] = n[p]);
  if (n != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, p = Object.getOwnPropertySymbols(n); a < p.length; a++)
      c.indexOf(p[a]) < 0 && Object.prototype.propertyIsEnumerable.call(n, p[a]) && (u[p[a]] = n[p[a]]);
  return u;
}
function __decorate(n, c, u, p) {
  var a = arguments.length, A = a < 3 ? c : p === null ? p = Object.getOwnPropertyDescriptor(c, u) : p, b;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") A = Reflect.decorate(n, c, u, p);
  else for (var F = n.length - 1; F >= 0; F--) (b = n[F]) && (A = (a < 3 ? b(A) : a > 3 ? b(c, u, A) : b(c, u)) || A);
  return a > 3 && A && Object.defineProperty(c, u, A), A;
}
function __param(n, c) {
  return function(u, p) {
    c(u, p, n);
  };
}
function __esDecorate(n, c, u, p, a, A) {
  function b(ir) {
    if (ir !== void 0 && typeof ir != "function") throw new TypeError("Function expected");
    return ir;
  }
  for (var F = p.kind, le = F === "getter" ? "get" : F === "setter" ? "set" : "value", L = !c && n ? p.static ? n : n.prototype : null, pe = c || (L ? Object.getOwnPropertyDescriptor(L, p.name) : {}), $, Ee = !1, be = u.length - 1; be >= 0; be--) {
    var He = {};
    for (var Pe in p) He[Pe] = Pe === "access" ? {} : p[Pe];
    for (var Pe in p.access) He.access[Pe] = p.access[Pe];
    He.addInitializer = function(ir) {
      if (Ee) throw new TypeError("Cannot add initializers after decoration has completed");
      A.push(b(ir || null));
    };
    var nr = (0, u[be])(F === "accessor" ? { get: pe.get, set: pe.set } : pe[le], He);
    if (F === "accessor") {
      if (nr === void 0) continue;
      if (nr === null || typeof nr != "object") throw new TypeError("Object expected");
      ($ = b(nr.get)) && (pe.get = $), ($ = b(nr.set)) && (pe.set = $), ($ = b(nr.init)) && a.unshift($);
    } else ($ = b(nr)) && (F === "field" ? a.unshift($) : pe[le] = $);
  }
  L && Object.defineProperty(L, p.name, pe), Ee = !0;
}
function __runInitializers(n, c, u) {
  for (var p = arguments.length > 2, a = 0; a < c.length; a++)
    u = p ? c[a].call(n, u) : c[a].call(n);
  return p ? u : void 0;
}
function __propKey(n) {
  return typeof n == "symbol" ? n : "".concat(n);
}
function __setFunctionName(n, c, u) {
  return typeof c == "symbol" && (c = c.description ? "[".concat(c.description, "]") : ""), Object.defineProperty(n, "name", { configurable: !0, value: u ? "".concat(u, " ", c) : c });
}
function __metadata(n, c) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function") return Reflect.metadata(n, c);
}
function __awaiter$7(n, c, u, p) {
  function a(A) {
    return A instanceof u ? A : new u(function(b) {
      b(A);
    });
  }
  return new (u || (u = Promise))(function(A, b) {
    function F(pe) {
      try {
        L(p.next(pe));
      } catch ($) {
        b($);
      }
    }
    function le(pe) {
      try {
        L(p.throw(pe));
      } catch ($) {
        b($);
      }
    }
    function L(pe) {
      pe.done ? A(pe.value) : a(pe.value).then(F, le);
    }
    L((p = p.apply(n, c || [])).next());
  });
}
function __generator(n, c) {
  var u = { label: 0, sent: function() {
    if (A[0] & 1) throw A[1];
    return A[1];
  }, trys: [], ops: [] }, p, a, A, b = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return b.next = F(0), b.throw = F(1), b.return = F(2), typeof Symbol == "function" && (b[Symbol.iterator] = function() {
    return this;
  }), b;
  function F(L) {
    return function(pe) {
      return le([L, pe]);
    };
  }
  function le(L) {
    if (p) throw new TypeError("Generator is already executing.");
    for (; b && (b = 0, L[0] && (u = 0)), u; ) try {
      if (p = 1, a && (A = L[0] & 2 ? a.return : L[0] ? a.throw || ((A = a.return) && A.call(a), 0) : a.next) && !(A = A.call(a, L[1])).done) return A;
      switch (a = 0, A && (L = [L[0] & 2, A.value]), L[0]) {
        case 0:
        case 1:
          A = L;
          break;
        case 4:
          return u.label++, { value: L[1], done: !1 };
        case 5:
          u.label++, a = L[1], L = [0];
          continue;
        case 7:
          L = u.ops.pop(), u.trys.pop();
          continue;
        default:
          if (A = u.trys, !(A = A.length > 0 && A[A.length - 1]) && (L[0] === 6 || L[0] === 2)) {
            u = 0;
            continue;
          }
          if (L[0] === 3 && (!A || L[1] > A[0] && L[1] < A[3])) {
            u.label = L[1];
            break;
          }
          if (L[0] === 6 && u.label < A[1]) {
            u.label = A[1], A = L;
            break;
          }
          if (A && u.label < A[2]) {
            u.label = A[2], u.ops.push(L);
            break;
          }
          A[2] && u.ops.pop(), u.trys.pop();
          continue;
      }
      L = c.call(n, u);
    } catch (pe) {
      L = [6, pe], a = 0;
    } finally {
      p = A = 0;
    }
    if (L[0] & 5) throw L[1];
    return { value: L[0] ? L[1] : void 0, done: !0 };
  }
}
var __createBinding$f = Object.create ? function(n, c, u, p) {
  p === void 0 && (p = u);
  var a = Object.getOwnPropertyDescriptor(c, u);
  (!a || ("get" in a ? !c.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
    return c[u];
  } }), Object.defineProperty(n, p, a);
} : function(n, c, u, p) {
  p === void 0 && (p = u), n[p] = c[u];
};
function __exportStar(n, c) {
  for (var u in n) u !== "default" && !Object.prototype.hasOwnProperty.call(c, u) && __createBinding$f(c, n, u);
}
function __values$1(n) {
  var c = typeof Symbol == "function" && Symbol.iterator, u = c && n[c], p = 0;
  if (u) return u.call(n);
  if (n && typeof n.length == "number") return {
    next: function() {
      return n && p >= n.length && (n = void 0), { value: n && n[p++], done: !n };
    }
  };
  throw new TypeError(c ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(n, c) {
  var u = typeof Symbol == "function" && n[Symbol.iterator];
  if (!u) return n;
  var p = u.call(n), a, A = [], b;
  try {
    for (; (c === void 0 || c-- > 0) && !(a = p.next()).done; ) A.push(a.value);
  } catch (F) {
    b = { error: F };
  } finally {
    try {
      a && !a.done && (u = p.return) && u.call(p);
    } finally {
      if (b) throw b.error;
    }
  }
  return A;
}
function __spread() {
  for (var n = [], c = 0; c < arguments.length; c++)
    n = n.concat(__read(arguments[c]));
  return n;
}
function __spreadArrays() {
  for (var n = 0, c = 0, u = arguments.length; c < u; c++) n += arguments[c].length;
  for (var p = Array(n), a = 0, c = 0; c < u; c++)
    for (var A = arguments[c], b = 0, F = A.length; b < F; b++, a++)
      p[a] = A[b];
  return p;
}
function __spreadArray(n, c, u) {
  if (u || arguments.length === 2) for (var p = 0, a = c.length, A; p < a; p++)
    (A || !(p in c)) && (A || (A = Array.prototype.slice.call(c, 0, p)), A[p] = c[p]);
  return n.concat(A || Array.prototype.slice.call(c));
}
function __await(n) {
  return this instanceof __await ? (this.v = n, this) : new __await(n);
}
function __asyncGenerator(n, c, u) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var p = u.apply(n, c || []), a, A = [];
  return a = Object.create((typeof AsyncIterator == "function" ? AsyncIterator : Object).prototype), F("next"), F("throw"), F("return", b), a[Symbol.asyncIterator] = function() {
    return this;
  }, a;
  function b(be) {
    return function(He) {
      return Promise.resolve(He).then(be, $);
    };
  }
  function F(be, He) {
    p[be] && (a[be] = function(Pe) {
      return new Promise(function(nr, ir) {
        A.push([be, Pe, nr, ir]) > 1 || le(be, Pe);
      });
    }, He && (a[be] = He(a[be])));
  }
  function le(be, He) {
    try {
      L(p[be](He));
    } catch (Pe) {
      Ee(A[0][3], Pe);
    }
  }
  function L(be) {
    be.value instanceof __await ? Promise.resolve(be.value.v).then(pe, $) : Ee(A[0][2], be);
  }
  function pe(be) {
    le("next", be);
  }
  function $(be) {
    le("throw", be);
  }
  function Ee(be, He) {
    be(He), A.shift(), A.length && le(A[0][0], A[0][1]);
  }
}
function __asyncDelegator(n) {
  var c, u;
  return c = {}, p("next"), p("throw", function(a) {
    throw a;
  }), p("return"), c[Symbol.iterator] = function() {
    return this;
  }, c;
  function p(a, A) {
    c[a] = n[a] ? function(b) {
      return (u = !u) ? { value: __await(n[a](b)), done: !1 } : A ? A(b) : b;
    } : A;
  }
}
function __asyncValues(n) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var c = n[Symbol.asyncIterator], u;
  return c ? c.call(n) : (n = typeof __values$1 == "function" ? __values$1(n) : n[Symbol.iterator](), u = {}, p("next"), p("throw"), p("return"), u[Symbol.asyncIterator] = function() {
    return this;
  }, u);
  function p(A) {
    u[A] = n[A] && function(b) {
      return new Promise(function(F, le) {
        b = n[A](b), a(F, le, b.done, b.value);
      });
    };
  }
  function a(A, b, F, le) {
    Promise.resolve(le).then(function(L) {
      A({ value: L, done: F });
    }, b);
  }
}
function __makeTemplateObject(n, c) {
  return Object.defineProperty ? Object.defineProperty(n, "raw", { value: c }) : n.raw = c, n;
}
var __setModuleDefault$f = Object.create ? function(n, c) {
  Object.defineProperty(n, "default", { enumerable: !0, value: c });
} : function(n, c) {
  n.default = c;
}, ownKeys = function(n) {
  return ownKeys = Object.getOwnPropertyNames || function(c) {
    var u = [];
    for (var p in c) Object.prototype.hasOwnProperty.call(c, p) && (u[u.length] = p);
    return u;
  }, ownKeys(n);
};
function __importStar$f(n) {
  if (n && n.__esModule) return n;
  var c = {};
  if (n != null) for (var u = ownKeys(n), p = 0; p < u.length; p++) u[p] !== "default" && __createBinding$f(c, n, u[p]);
  return __setModuleDefault$f(c, n), c;
}
function __importDefault$j(n) {
  return n && n.__esModule ? n : { default: n };
}
function __classPrivateFieldGet$1(n, c, u, p) {
  if (u === "a" && !p) throw new TypeError("Private accessor was defined without a getter");
  if (typeof c == "function" ? n !== c || !p : !c.has(n)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return u === "m" ? p : u === "a" ? p.call(n) : p ? p.value : c.get(n);
}
function __classPrivateFieldSet$1(n, c, u, p, a) {
  if (p === "m") throw new TypeError("Private method is not writable");
  if (p === "a" && !a) throw new TypeError("Private accessor was defined without a setter");
  if (typeof c == "function" ? n !== c || !a : !c.has(n)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return p === "a" ? a.call(n, u) : a ? a.value = u : c.set(n, u), u;
}
function __classPrivateFieldIn(n, c) {
  if (c === null || typeof c != "object" && typeof c != "function") throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof n == "function" ? c === n : n.has(c);
}
function __addDisposableResource(n, c, u) {
  if (c != null) {
    if (typeof c != "object" && typeof c != "function") throw new TypeError("Object expected.");
    var p, a;
    if (u) {
      if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
      p = c[Symbol.asyncDispose];
    }
    if (p === void 0) {
      if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
      p = c[Symbol.dispose], u && (a = p);
    }
    if (typeof p != "function") throw new TypeError("Object not disposable.");
    a && (p = function() {
      try {
        a.call(this);
      } catch (A) {
        return Promise.reject(A);
      }
    }), n.stack.push({ value: c, dispose: p, async: u });
  } else u && n.stack.push({ async: !0 });
  return c;
}
var _SuppressedError = typeof SuppressedError == "function" ? SuppressedError : function(n, c, u) {
  var p = new Error(u);
  return p.name = "SuppressedError", p.error = n, p.suppressed = c, p;
};
function __disposeResources(n) {
  function c(A) {
    n.error = n.hasError ? new _SuppressedError(A, n.error, "An error was suppressed during disposal.") : A, n.hasError = !0;
  }
  var u, p = 0;
  function a() {
    for (; u = n.stack.pop(); )
      try {
        if (!u.async && p === 1) return p = 0, n.stack.push(u), Promise.resolve().then(a);
        if (u.dispose) {
          var A = u.dispose.call(u.value);
          if (u.async) return p |= 2, Promise.resolve(A).then(a, function(b) {
            return c(b), a();
          });
        } else p |= 1;
      } catch (b) {
        c(b);
      }
    if (p === 1) return n.hasError ? Promise.reject(n.error) : Promise.resolve();
    if (n.hasError) throw n.error;
  }
  return a();
}
function __rewriteRelativeImportExtension(n, c) {
  return typeof n == "string" && /^\.\.?\//.test(n) ? n.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(u, p, a, A, b) {
    return p ? c ? ".jsx" : ".js" : a && (!A || !b) ? u : a + A + "." + b.toLowerCase() + "js";
  }) : n;
}
const tslib_es6 = {
  __extends,
  __assign,
  __rest,
  __decorate,
  __param,
  __esDecorate,
  __runInitializers,
  __propKey,
  __setFunctionName,
  __metadata,
  __awaiter: __awaiter$7,
  __generator,
  __createBinding: __createBinding$f,
  __exportStar,
  __values: __values$1,
  __read,
  __spread,
  __spreadArrays,
  __spreadArray,
  __await,
  __asyncGenerator,
  __asyncDelegator,
  __asyncValues,
  __makeTemplateObject,
  __importStar: __importStar$f,
  __importDefault: __importDefault$j,
  __classPrivateFieldGet: __classPrivateFieldGet$1,
  __classPrivateFieldSet: __classPrivateFieldSet$1,
  __classPrivateFieldIn,
  __addDisposableResource,
  __disposeResources,
  __rewriteRelativeImportExtension
}, tslib_es6$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  __addDisposableResource,
  get __assign() {
    return __assign;
  },
  __asyncDelegator,
  __asyncGenerator,
  __asyncValues,
  __await,
  __awaiter: __awaiter$7,
  __classPrivateFieldGet: __classPrivateFieldGet$1,
  __classPrivateFieldIn,
  __classPrivateFieldSet: __classPrivateFieldSet$1,
  __createBinding: __createBinding$f,
  __decorate,
  __disposeResources,
  __esDecorate,
  __exportStar,
  __extends,
  __generator,
  __importDefault: __importDefault$j,
  __importStar: __importStar$f,
  __makeTemplateObject,
  __metadata,
  __param,
  __propKey,
  __read,
  __rest,
  __rewriteRelativeImportExtension,
  __runInitializers,
  __setFunctionName,
  __spread,
  __spreadArray,
  __spreadArrays,
  __values: __values$1,
  default: tslib_es6
}, Symbol.toStringTag, { value: "Module" })), require$$0$4 = /* @__PURE__ */ getAugmentedNamespace(tslib_es6$1);
var patchCBOR$c = {}, utils$J = {}, lib$f = {}, cborSync$c = { exports: {} }, DataItem$d = {};
Object.defineProperty(DataItem$d, "__esModule", { value: !0 });
DataItem$d.DataItem = void 0;
let DataItem$c = class {
  constructor(c, u) {
    this.setTag = (p) => {
      this.tag = p;
    }, this.clearTag = () => {
      this.tag = void 0;
    }, this.getTag = () => this.tag, this.getData = () => this.data, this.data = c, this.tag = u;
  }
};
DataItem$d.DataItem = DataItem$c;
(function(n) {
  (function(c, u) {
    n.exports ? n.exports = u() : c.CBOR = u();
  })(commonjsGlobal, function() {
    const { DataItem: c } = DataItem$d;
    var u = function() {
      function p(Ce) {
        this.$hex = Ce;
      }
      p.prototype = {
        length: function() {
          return this.$hex.length / 2;
        },
        toString: function(Ce) {
          if (!Ce || Ce === "hex" || Ce === 16)
            return this.$hex;
          if (Ce === "utf-8") {
            for (var tr = "", Fe = 0; Fe < this.$hex.length; Fe += 2)
              tr += "%" + this.$hex.substring(Fe, Fe + 2);
            return decodeURIComponent(tr);
          }
          if (Ce === "latin") {
            for (var tr = [], Fe = 0; Fe < this.$hex.length; Fe += 2)
              tr.push(parseInt(this.$hex.substring(Fe, Fe + 2), 16));
            return String.fromCharCode.apply(String, tr);
          }
          throw new Error("Unrecognised format: " + Ce);
        }
      }, p.fromLatinString = function(Ce) {
        for (var tr = "", Fe = 0; Fe < Ce.length; Fe++) {
          var Sr = Ce.charCodeAt(Fe).toString(16);
          Sr.length === 1 && (Sr = "0" + Sr), tr += Sr;
        }
        return new p(tr);
      }, p.fromUtf8String = function(Ce) {
        for (var tr = encodeURIComponent(Ce), Fe = "", Sr = 0; Sr < tr.length; Sr++)
          if (tr.charAt(Sr) === "%")
            Fe += tr.substring(Sr + 1, Sr + 3), Sr += 2;
          else {
            var er = tr.charCodeAt(Sr).toString(16);
            er.length < 2 && (er = "0" + er), Fe += er;
          }
        return new p(Fe);
      };
      var a = [], A = {}, b = function(Ce) {
        return function() {
          throw new Error(Ce + " not implemented");
        };
      };
      function F() {
      }
      F.prototype = {
        peekByte: b("peekByte"),
        readByte: b("readByte"),
        readChunk: b("readChunk"),
        readFloat16: function() {
          var Ce = this.readUint16(), tr = (Ce & 32767) >> 10, Fe = Ce & 1023, Sr = Ce & 32768;
          if (tr === 31)
            return Fe === 0 ? Sr ? -1 / 0 : 1 / 0 : NaN;
          var er = tr ? Math.pow(2, tr - 25) * (1024 + Fe) : Math.pow(2, -24) * Fe;
          return Sr ? -er : er;
        },
        readFloat32: function() {
          var Ce = this.readUint32(), tr = (Ce & 2147483647) >> 23, Fe = Ce & 8388607, Sr = Ce & 2147483648;
          if (tr === 255)
            return Fe === 0 ? Sr ? -1 / 0 : 1 / 0 : NaN;
          var er = tr ? Math.pow(2, tr - 23 - 127) * (8388608 + Fe) : Math.pow(2, -149) * Fe;
          return Sr ? -er : er;
        },
        readFloat64: function() {
          var Ce = this.readUint32(), tr = this.readUint32(), Fe = Ce >> 20 & 2047, Sr = (Ce & 1048575) * 4294967296 + tr, er = Ce & 2147483648;
          if (Fe === 2047)
            return Sr === 0 ? er ? -1 / 0 : 1 / 0 : NaN;
          var Ie = Fe ? Math.pow(2, Fe - 52 - 1023) * (4503599627370496 + Sr) : Math.pow(2, -1074) * Sr;
          return er ? -Ie : Ie;
        },
        readUint16: function() {
          return this.readByte() * 256 + this.readByte();
        },
        readUint32: function() {
          return this.readUint16() * 65536 + this.readUint16();
        },
        readUint64: function() {
          return this.readUint32() * 4294967296 + this.readUint32();
        }
      };
      function le() {
      }
      le.prototype = {
        writeByte: b("writeByte"),
        result: b("result"),
        writeFloat16: b("writeFloat16"),
        writeFloat32: b("writeFloat32"),
        writeFloat64: b("writeFloat64"),
        writeUint16: function(Ce) {
          this.writeByte(Ce >> 8 & 255), this.writeByte(Ce & 255);
        },
        writeUint32: function(Ce) {
          this.writeUint16(Ce >> 16 & 65535), this.writeUint16(Ce & 65535);
        },
        writeUint64: function(Ce) {
          if (Ce >= 9007199254740992 || Ce <= -9007199254740992)
            throw new Error("Cannot encode Uint64 of: " + Ce + " magnitude to big (floating point errors)");
          this.writeUint32(Math.floor(Ce / 4294967296)), this.writeUint32(Ce % 4294967296);
        },
        writeString: b("writeString"),
        canWriteBinary: function(Ce) {
          return !1;
        },
        writeBinary: b("writeChunk")
      };
      function L(Ce) {
        var tr = Ce.readByte(), Fe = tr >> 5, Sr = tr & 31;
        return { type: Fe, value: Sr };
      }
      function pe(Ce, tr) {
        var Fe = Ce.value;
        if (Fe < 24)
          return Fe;
        if (Fe == 24)
          return tr.readByte();
        if (Fe == 25)
          return tr.readUint16();
        if (Fe == 26)
          return tr.readUint32();
        if (Fe == 27)
          return tr.readUint64();
        if (Fe == 31)
          return null;
        b("Additional info: " + Fe)();
      }
      function $(Ce, tr, Fe) {
        Fe.writeByte(Ce << 5 | tr);
      }
      function Ee(Ce, tr, Fe) {
        var Sr = Ce << 5;
        tr < 24 ? Fe.writeByte(Sr | tr) : tr < 256 ? (Fe.writeByte(Sr | 24), Fe.writeByte(tr)) : tr < 65536 ? (Fe.writeByte(Sr | 25), Fe.writeUint16(tr)) : tr < 4294967296 ? (Fe.writeByte(Sr | 26), Fe.writeUint32(tr)) : (Fe.writeByte(Sr | 27), Fe.writeUint64(tr));
      }
      var be = new Error();
      function He(Ce) {
        var tr = L(Ce);
        switch (tr.type) {
          case 0:
            return pe(tr, Ce);
          case 1:
            return -1 - pe(tr, Ce);
          case 2:
            return Ce.readChunk(pe(tr, Ce));
          case 3:
            var Fe = Ce.readChunk(pe(tr, Ce));
            return Fe.toString("utf-8");
          case 4:
          case 5:
            var Sr = pe(tr, Ce), yr = [];
            if (Sr !== null) {
              tr.type === 5 && (Sr *= 2);
              for (var er = 0; er < Sr; er++)
                yr[er] = He(Ce);
            } else
              for (var Ie; (Ie = He(Ce)) !== be; )
                yr.push(Ie);
            if (tr.type === 5) {
              for (var xe = {}, er = 0; er < yr.length; er += 2)
                xe[yr[er]] = yr[er + 1];
              return xe;
            } else
              return yr;
          case 6:
            var rr = pe(tr, Ce), ar = A[rr], yr = He(Ce);
            return ar ? ar(yr) : yr;
          case 7:
            if (tr.value === 25)
              return Ce.readFloat16();
            if (tr.value === 26)
              return Ce.readFloat32();
            if (tr.value === 27)
              return Ce.readFloat64();
            switch (pe(tr, Ce)) {
              case 20:
                return !1;
              case 21:
                return !0;
              case 22:
                return null;
              case 23:
                return;
              case null:
                return be;
              default:
                throw new Error("Unknown fixed value: " + tr.value);
            }
          default:
            throw new Error("Unsupported header: " + JSON.stringify(tr));
        }
        throw new Error("not implemented yet");
      }
      function Pe(Ce, tr) {
        for (var Fe = 0; Fe < a.length; Fe++) {
          var Sr = a[Fe].fn(Ce);
          if (Sr !== void 0)
            return Ee(6, a[Fe].tag, tr), Pe(Sr, tr);
        }
        if (Ce && typeof Ce.toCBOR == "function" && (Ce = Ce.toCBOR()), Ce === !1)
          Ee(7, 20, tr);
        else if (Ce === !0)
          Ee(7, 21, tr);
        else if (Ce === null)
          Ee(7, 22, tr);
        else if (Ce === void 0)
          Ee(7, 23, tr);
        else if (typeof Ce == "number")
          Math.floor(Ce) === Ce && Ce < 9007199254740992 && Ce > -9007199254740992 ? Ce < 0 ? Ee(1, -1 - Ce, tr) : Ee(0, Ce, tr) : ($(7, 27, tr), tr.writeFloat64(Ce));
        else if (typeof Ce == "string")
          tr.writeString(Ce, function(Ie) {
            Ee(3, Ie, tr);
          });
        else if (tr.canWriteBinary(Ce))
          tr.writeBinary(Ce, function(Ie) {
            Ee(2, Ie, tr);
          });
        else if (typeof Ce == "object")
          if (or.config.useToJSON && typeof Ce.toJSON == "function" && (Ce = Ce.toJSON()), Array.isArray(Ce)) {
            Ee(4, Ce.length, tr);
            for (var Fe = 0; Fe < Ce.length; Fe++)
              Pe(Ce[Fe], tr);
          } else {
            var er = Object.keys(Ce);
            Ee(5, er.length, tr);
            for (var Fe = 0; Fe < er.length; Fe++) {
              const xe = parseInt(er[Fe]);
              isNaN(xe) ? (Pe(er[Fe], tr), Pe(Ce[er[Fe]], tr)) : (Pe(xe, tr), Pe(Ce[er[Fe]], tr));
            }
          }
        else
          throw new Error("CBOR encoding not supported: " + Ce);
      }
      var nr = [], ir = [], or = {
        config: {
          useToJSON: !0
        },
        addWriter: function(Ce, tr) {
          typeof Ce == "string" ? ir.push(function(Fe) {
            if (Ce === Fe)
              return tr(Fe);
          }) : ir.push(Ce);
        },
        addReader: function(Ce, tr) {
          typeof Ce == "string" ? nr.push(function(Fe, Sr) {
            if (Ce === Sr)
              return tr(Fe, Sr);
          }) : nr.push(Ce);
        },
        encode: function(Ce, tr) {
          for (var Fe = 0; Fe < ir.length; Fe++) {
            var Sr = ir[Fe], er = Sr(tr);
            if (er)
              return Pe(Ce, er), er.result();
          }
          throw new Error("Unsupported output format: " + tr);
        },
        encodeDataItem: function(Ce, tr) {
          for (var Fe = 0; Fe < ir.length; Fe++) {
            var Sr = ir[Fe], er = Sr(tr);
            if (er)
              return Ce.getTag() !== void 0 ? (Pe(Ce, er), er.result()) : (Pe(Ce.getData(), er), er.result());
          }
          throw new Error("Unsupported output format: " + tr);
        },
        decode: function(Ce, tr) {
          for (var Fe = 0; Fe < nr.length; Fe++) {
            var Sr = nr[Fe], er = Sr(Ce, tr);
            if (er)
              return He(er);
          }
          throw new Error("Unsupported input format: " + tr);
        },
        decodeToDataItem: function(Ce, tr) {
          for (var Fe = 0; Fe < nr.length; Fe++) {
            var Sr = nr[Fe], er = Sr(Ce, tr);
            if (er) {
              const Ie = He(er);
              return Ie instanceof c ? Ie : new c(Ie);
            }
          }
          throw new Error("Unsupported input format: " + tr);
        },
        addSemanticEncode: function(Ce, tr) {
          if (typeof Ce != "number" || Ce % 1 !== 0 || Ce < 0)
            throw new Error("Tag must be a positive integer");
          return a.push({ tag: Ce, fn: tr }), this;
        },
        addSemanticDecode: function(Ce, tr) {
          if (typeof Ce != "number" || Ce % 1 !== 0 || Ce < 0)
            throw new Error("Tag must be a positive integer");
          return A[Ce] = tr, this;
        }
      };
      function lr(Ce) {
        this.buffer = Ce, this.pos = 0;
      }
      lr.prototype = Object.create(F.prototype), lr.prototype.peekByte = function() {
        return this.buffer[this.pos];
      }, lr.prototype.readByte = function() {
        return this.buffer[this.pos++];
      }, lr.prototype.readUint16 = function() {
        var Ce = this.buffer.readUInt16BE(this.pos);
        return this.pos += 2, Ce;
      }, lr.prototype.readUint32 = function() {
        var Ce = this.buffer.readUInt32BE(this.pos);
        return this.pos += 4, Ce;
      }, lr.prototype.readFloat32 = function() {
        var Ce = this.buffer.readFloatBE(this.pos);
        return this.pos += 4, Ce;
      }, lr.prototype.readFloat64 = function() {
        var Ce = this.buffer.readDoubleBE(this.pos);
        return this.pos += 8, Ce;
      }, lr.prototype.readChunk = function(Ce) {
        var tr = Buffer$f.alloc(Ce);
        return this.buffer.copy(tr, 0, this.pos, this.pos += Ce), tr;
      };
      function Ir(Ce) {
        this.byteLength = 0, this.defaultBufferLength = 16384, this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0, this.completeBuffers = [], this.stringFormat = Ce;
      }
      Ir.prototype = Object.create(le.prototype), Ir.prototype.writeByte = function(Ce) {
        this.latestBuffer[this.latestBufferOffset++] = Ce, this.latestBufferOffset >= this.latestBuffer.length && (this.completeBuffers.push(this.latestBuffer), this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0), this.byteLength++;
      }, Ir.prototype.writeFloat32 = function(Ce) {
        var tr = Buffer$f.alloc(4);
        tr.writeFloatBE(Ce, 0), this.writeBuffer(tr);
      }, Ir.prototype.writeFloat64 = function(Ce) {
        var tr = Buffer$f.alloc(8);
        tr.writeDoubleBE(Ce, 0), this.writeBuffer(tr);
      }, Ir.prototype.writeString = function(Ce, tr) {
        var Fe = Buffer$f.from(Ce, "utf-8");
        tr(Fe.length), this.writeBuffer(Fe);
      }, Ir.prototype.canWriteBinary = function(Ce) {
        return Ce instanceof Buffer$f;
      }, Ir.prototype.writeBinary = function(Ce, tr) {
        tr(Ce.length), this.writeBuffer(Ce);
      }, Ir.prototype.writeBuffer = function(Ce) {
        if (!(Ce instanceof Buffer$f))
          throw new TypeError("BufferWriter only accepts Buffers");
        this.latestBufferOffset ? this.latestBuffer.length - this.latestBufferOffset >= Ce.length ? (Ce.copy(this.latestBuffer, this.latestBufferOffset), this.latestBufferOffset += Ce.length, this.latestBufferOffset >= this.latestBuffer.length && (this.completeBuffers.push(this.latestBuffer), this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0)) : (this.completeBuffers.push(this.latestBuffer.slice(0, this.latestBufferOffset)), this.completeBuffers.push(Ce), this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0) : this.completeBuffers.push(Ce), this.byteLength += Ce.length;
      }, Ir.prototype.result = function() {
        for (var Ce = Buffer$f.alloc(this.byteLength), tr = 0, Fe = 0; Fe < this.completeBuffers.length; Fe++) {
          var Sr = this.completeBuffers[Fe];
          Sr.copy(Ce, tr, 0, Sr.length), tr += Sr.length;
        }
        return this.latestBufferOffset && this.latestBuffer.copy(Ce, tr, 0, this.latestBufferOffset), this.stringFormat ? Ce.toString(this.stringFormat) : Ce;
      }, typeof Buffer$f == "function" && (or.addReader(function(Ce, tr) {
        if (Buffer$f.isBuffer(Ce))
          return new lr(Ce);
        if (tr === "hex" || tr === "base64") {
          var Fe = Buffer$f.from(Ce, tr);
          return new lr(Fe);
        }
      }), or.addWriter(function(Ce) {
        if (!Ce || Ce === "buffer")
          return new Ir();
        if (Ce === "hex" || Ce === "base64")
          return new Ir(Ce);
      }));
      function xr(Ce) {
        this.hex = Ce, this.pos = 0;
      }
      xr.prototype = Object.create(F.prototype), xr.prototype.peekByte = function() {
        var Ce = this.hex.substring(this.pos, 2);
        return parseInt(Ce, 16);
      }, xr.prototype.readByte = function() {
        var Ce = this.hex.substring(this.pos, this.pos + 2);
        return this.pos += 2, parseInt(Ce, 16);
      }, xr.prototype.readChunk = function(Ce) {
        var tr = this.hex.substring(this.pos, this.pos + Ce * 2);
        return this.pos += Ce * 2, typeof Buffer$f == "function" ? Buffer$f.from(tr, "hex") : new p(tr);
      };
      function kr(Ce) {
        this.$hex = "", this.finalFormat = Ce || "hex";
      }
      return kr.prototype = Object.create(le.prototype), kr.prototype.writeByte = function(Ce) {
        if (Ce < 0 || Ce > 255)
          throw new Error("Byte value out of range: " + Ce);
        var tr = Ce.toString(16);
        tr.length == 1 && (tr = "0" + tr), this.$hex += tr;
      }, kr.prototype.canWriteBinary = function(Ce) {
        return Ce instanceof p || typeof Buffer$f == "function" && Ce instanceof Buffer$f;
      }, kr.prototype.writeBinary = function(Ce, tr) {
        if (Ce instanceof p)
          tr(Ce.length()), this.$hex += Ce.$hex;
        else if (typeof Buffer$f == "function" && Ce instanceof Buffer$f)
          tr(Ce.length), this.$hex += Ce.toString("hex");
        else
          throw new TypeError("HexWriter only accepts BinaryHex or Buffers");
      }, kr.prototype.result = function() {
        return this.finalFormat === "buffer" && typeof Buffer$f == "function" ? Buffer$f.from(this.$hex, "hex") : new p(this.$hex).toString(this.finalFormat);
      }, kr.prototype.writeString = function(Ce, tr) {
        var Fe = p.fromUtf8String(Ce);
        tr(Fe.length()), this.$hex += Fe.$hex;
      }, or.addReader(function(Ce, tr) {
        if (Ce instanceof p || Ce.$hex)
          return new xr(Ce.$hex);
        if (tr === "hex")
          return new xr(Ce);
      }), or.addWriter(function(Ce) {
        if (Ce === "hex")
          return new kr();
      }), or;
    }();
    return u.addSemanticEncode(0, function(p) {
      if (p instanceof Date)
        return p.toISOString();
    }).addSemanticDecode(0, function(p) {
      return new Date(p);
    }).addSemanticDecode(1, function(p) {
      return new Date(p);
    }), u;
  });
})(cborSync$c);
var cborSyncExports = cborSync$c.exports;
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.DataItem = n.addWriter = n.addReader = n.addSemanticEncode = n.addSemanticDecode = n.decodeToDataItem = n.encodeDataItem = void 0;
  var c = cborSyncExports;
  Object.defineProperty(n, "encodeDataItem", { enumerable: !0, get: function() {
    return c.encodeDataItem;
  } }), Object.defineProperty(n, "decodeToDataItem", { enumerable: !0, get: function() {
    return c.decodeToDataItem;
  } }), Object.defineProperty(n, "addSemanticDecode", { enumerable: !0, get: function() {
    return c.addSemanticDecode;
  } }), Object.defineProperty(n, "addSemanticEncode", { enumerable: !0, get: function() {
    return c.addSemanticEncode;
  } }), Object.defineProperty(n, "addReader", { enumerable: !0, get: function() {
    return c.addReader;
  } }), Object.defineProperty(n, "addWriter", { enumerable: !0, get: function() {
    return c.addWriter;
  } });
  var u = DataItem$d;
  Object.defineProperty(n, "DataItem", { enumerable: !0, get: function() {
    return u.DataItem;
  } });
})(lib$f);
Object.defineProperty(utils$J, "__esModule", { value: !0 });
utils$J.patchTags = void 0;
const lib_1$9 = lib$f, alreadyPatchedTag = [], patchTags = (n) => {
  n.forEach((c) => {
    alreadyPatchedTag.find((u) => u === c) || ((0, lib_1$9.addSemanticEncode)(c, (u) => {
      if (u instanceof lib_1$9.DataItem && u.getTag() === c)
        return u.getData();
    }), (0, lib_1$9.addSemanticDecode)(c, (u) => new lib_1$9.DataItem(u, c)), alreadyPatchedTag.push(c));
  });
};
utils$J.patchTags = patchTags;
var RegistryType$d = {};
Object.defineProperty(RegistryType$d, "__esModule", { value: !0 });
RegistryType$d.RegistryTypes = RegistryType$d.RegistryType = void 0;
let RegistryType$c = class {
  constructor(c, u) {
    this.type = c, this.tag = u, this.getTag = () => this.tag, this.getType = () => this.type;
  }
};
RegistryType$d.RegistryType = RegistryType$c;
RegistryType$d.RegistryTypes = {
  UUID: new RegistryType$c("uuid", 37),
  BYTES: new RegistryType$c("bytes", void 0),
  CRYPTO_HDKEY: new RegistryType$c("crypto-hdkey", 303),
  CRYPTO_KEYPATH: new RegistryType$c("crypto-keypath", 304),
  CRYPTO_COIN_INFO: new RegistryType$c("crypto-coin-info", 305),
  CRYPTO_ECKEY: new RegistryType$c("crypto-eckey", 306),
  CRYPTO_OUTPUT: new RegistryType$c("crypto-output", 308),
  CRYPTO_PSBT: new RegistryType$c("crypto-psbt", 310),
  CRYPTO_ACCOUNT: new RegistryType$c("crypto-account", 311),
  CRYPTO_MULTI_ACCOUNTS: new RegistryType$c("crypto-multi-accounts", 1103),
  QR_HARDWARE_CALL: new RegistryType$c("qr-hardware-call", 1201),
  KEY_DERIVATION_CALL: new RegistryType$c("key-derivation-call", 1301),
  KEY_DERIVATION_SCHEMA: new RegistryType$c("key-derivation-schema", 1302)
};
var ScriptExpression$c = {};
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.ScriptExpressions = n.ScriptExpression = void 0;
  class c {
    constructor(p, a) {
      this.tag = p, this.expression = a, this.getTag = () => this.tag, this.getExpression = () => this.expression;
    }
  }
  n.ScriptExpression = c, c.fromTag = (u) => Object.values(n.ScriptExpressions).find((a) => a.getTag() === u), n.ScriptExpressions = {
    SCRIPT_HASH: new c(400, "sh"),
    WITNESS_SCRIPT_HASH: new c(401, "wsh"),
    PUBLIC_KEY: new c(402, "pk"),
    PUBLIC_KEY_HASH: new c(403, "pkh"),
    WITNESS_PUBLIC_KEY_HASH: new c(404, "wpkh"),
    COMBO: new c(405, "combo"),
    MULTISIG: new c(406, "multi"),
    SORTED_MULTISIG: new c(407, "sortedmulti"),
    ADDRESS: new c(307, "addr"),
    RAW_SCRIPT: new c(408, "raw")
  };
})(ScriptExpression$c);
Object.defineProperty(patchCBOR$c, "__esModule", { value: !0 });
const utils_1$u = utils$J, RegistryType_1$9 = RegistryType$d, ScriptExpression_1$1 = ScriptExpression$c, registryTags = Object.values(RegistryType_1$9.RegistryTypes).filter((n) => !!n.getTag()).map((n) => n.getTag()), scriptExpressionTags = Object.values(ScriptExpression_1$1.ScriptExpressions).map((n) => n.getTag());
(0, utils_1$u.patchTags)(registryTags.concat(scriptExpressionTags));
var dist$u = {};
(function(n) {
  Object.defineProperties(n, { __esModule: { value: !0 }, [Symbol.toStringTag]: { value: "Module" } });
  var c = {}, u = {};
  u.byteLength = pe, u.toByteArray = Ee, u.fromByteArray = Pe;
  for (var p = [], a = [], A = typeof Uint8Array < "u" ? Uint8Array : Array, b = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", F = 0, le = b.length; F < le; ++F)
    p[F] = b[F], a[b.charCodeAt(F)] = F;
  a[45] = 62, a[95] = 63;
  function L(or) {
    var lr = or.length;
    if (lr % 4 > 0)
      throw new Error("Invalid string. Length must be a multiple of 4");
    var Ir = or.indexOf("=");
    Ir === -1 && (Ir = lr);
    var xr = Ir === lr ? 0 : 4 - Ir % 4;
    return [Ir, xr];
  }
  function pe(or) {
    var lr = L(or), Ir = lr[0], xr = lr[1];
    return (Ir + xr) * 3 / 4 - xr;
  }
  function $(or, lr, Ir) {
    return (lr + Ir) * 3 / 4 - Ir;
  }
  function Ee(or) {
    var lr, Ir = L(or), xr = Ir[0], kr = Ir[1], Ce = new A($(or, xr, kr)), tr = 0, Fe = kr > 0 ? xr - 4 : xr, Sr;
    for (Sr = 0; Sr < Fe; Sr += 4)
      lr = a[or.charCodeAt(Sr)] << 18 | a[or.charCodeAt(Sr + 1)] << 12 | a[or.charCodeAt(Sr + 2)] << 6 | a[or.charCodeAt(Sr + 3)], Ce[tr++] = lr >> 16 & 255, Ce[tr++] = lr >> 8 & 255, Ce[tr++] = lr & 255;
    return kr === 2 && (lr = a[or.charCodeAt(Sr)] << 2 | a[or.charCodeAt(Sr + 1)] >> 4, Ce[tr++] = lr & 255), kr === 1 && (lr = a[or.charCodeAt(Sr)] << 10 | a[or.charCodeAt(Sr + 1)] << 4 | a[or.charCodeAt(Sr + 2)] >> 2, Ce[tr++] = lr >> 8 & 255, Ce[tr++] = lr & 255), Ce;
  }
  function be(or) {
    return p[or >> 18 & 63] + p[or >> 12 & 63] + p[or >> 6 & 63] + p[or & 63];
  }
  function He(or, lr, Ir) {
    for (var xr, kr = [], Ce = lr; Ce < Ir; Ce += 3)
      xr = (or[Ce] << 16 & 16711680) + (or[Ce + 1] << 8 & 65280) + (or[Ce + 2] & 255), kr.push(be(xr));
    return kr.join("");
  }
  function Pe(or) {
    for (var lr, Ir = or.length, xr = Ir % 3, kr = [], Ce = 16383, tr = 0, Fe = Ir - xr; tr < Fe; tr += Ce)
      kr.push(He(or, tr, tr + Ce > Fe ? Fe : tr + Ce));
    return xr === 1 ? (lr = or[Ir - 1], kr.push(
      p[lr >> 2] + p[lr << 4 & 63] + "=="
    )) : xr === 2 && (lr = (or[Ir - 2] << 8) + or[Ir - 1], kr.push(
      p[lr >> 10] + p[lr >> 4 & 63] + p[lr << 2 & 63] + "="
    )), kr.join("");
  }
  var nr = {};
  nr.read = function(or, lr, Ir, xr, kr) {
    var Ce, tr, Fe = kr * 8 - xr - 1, Sr = (1 << Fe) - 1, er = Sr >> 1, Ie = -7, xe = Ir ? kr - 1 : 0, rr = Ir ? -1 : 1, ar = or[lr + xe];
    for (xe += rr, Ce = ar & (1 << -Ie) - 1, ar >>= -Ie, Ie += Fe; Ie > 0; Ce = Ce * 256 + or[lr + xe], xe += rr, Ie -= 8)
      ;
    for (tr = Ce & (1 << -Ie) - 1, Ce >>= -Ie, Ie += xr; Ie > 0; tr = tr * 256 + or[lr + xe], xe += rr, Ie -= 8)
      ;
    if (Ce === 0)
      Ce = 1 - er;
    else {
      if (Ce === Sr)
        return tr ? NaN : (ar ? -1 : 1) * (1 / 0);
      tr = tr + Math.pow(2, xr), Ce = Ce - er;
    }
    return (ar ? -1 : 1) * tr * Math.pow(2, Ce - xr);
  }, nr.write = function(or, lr, Ir, xr, kr, Ce) {
    var tr, Fe, Sr, er = Ce * 8 - kr - 1, Ie = (1 << er) - 1, xe = Ie >> 1, rr = kr === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, ar = xr ? 0 : Ce - 1, yr = xr ? 1 : -1, _r = lr < 0 || lr === 0 && 1 / lr < 0 ? 1 : 0;
    for (lr = Math.abs(lr), isNaN(lr) || lr === 1 / 0 ? (Fe = isNaN(lr) ? 1 : 0, tr = Ie) : (tr = Math.floor(Math.log(lr) / Math.LN2), lr * (Sr = Math.pow(2, -tr)) < 1 && (tr--, Sr *= 2), tr + xe >= 1 ? lr += rr / Sr : lr += rr * Math.pow(2, 1 - xe), lr * Sr >= 2 && (tr++, Sr /= 2), tr + xe >= Ie ? (Fe = 0, tr = Ie) : tr + xe >= 1 ? (Fe = (lr * Sr - 1) * Math.pow(2, kr), tr = tr + xe) : (Fe = lr * Math.pow(2, xe - 1) * Math.pow(2, kr), tr = 0)); kr >= 8; or[Ir + ar] = Fe & 255, ar += yr, Fe /= 256, kr -= 8)
      ;
    for (tr = tr << kr | Fe, er += kr; er > 0; or[Ir + ar] = tr & 255, ar += yr, tr /= 256, er -= 8)
      ;
    or[Ir + ar - yr] |= _r * 128;
  };
  (function(or) {
    const lr = u, Ir = nr, xr = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
    or.Buffer = Ie, or.SlowBuffer = si, or.INSPECT_MAX_BYTES = 50;
    const kr = 2147483647;
    or.kMaxLength = kr;
    const { Uint8Array: Ce, ArrayBuffer: tr, SharedArrayBuffer: Fe } = globalThis;
    Ie.TYPED_ARRAY_SUPPORT = Sr(), !Ie.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
      "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
    );
    function Sr() {
      try {
        const Bn = new Ce(1), hi = { foo: function() {
          return 42;
        } };
        return Object.setPrototypeOf(hi, Ce.prototype), Object.setPrototypeOf(Bn, hi), Bn.foo() === 42;
      } catch {
        return !1;
      }
    }
    Object.defineProperty(Ie.prototype, "parent", {
      enumerable: !0,
      get: function() {
        if (Ie.isBuffer(this))
          return this.buffer;
      }
    }), Object.defineProperty(Ie.prototype, "offset", {
      enumerable: !0,
      get: function() {
        if (Ie.isBuffer(this))
          return this.byteOffset;
      }
    });
    function er(Bn) {
      if (Bn > kr)
        throw new RangeError('The value "' + Bn + '" is invalid for option "size"');
      const hi = new Ce(Bn);
      return Object.setPrototypeOf(hi, Ie.prototype), hi;
    }
    function Ie(Bn, hi, Ii) {
      if (typeof Bn == "number") {
        if (typeof hi == "string")
          throw new TypeError(
            'The "string" argument must be of type string. Received type number'
          );
        return yr(Bn);
      }
      return xe(Bn, hi, Ii);
    }
    Ie.poolSize = 8192;
    function xe(Bn, hi, Ii) {
      if (typeof Bn == "string")
        return _r(Bn, hi);
      if (tr.isView(Bn))
        return vr(Bn);
      if (Bn == null)
        throw new TypeError(
          "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof Bn
        );
      if (ls(Bn, tr) || Bn && ls(Bn.buffer, tr) || typeof Fe < "u" && (ls(Bn, Fe) || Bn && ls(Bn.buffer, Fe)))
        return Te(Bn, hi, Ii);
      if (typeof Bn == "number")
        throw new TypeError(
          'The "value" argument must not be of type number. Received type number'
        );
      const Gi = Bn.valueOf && Bn.valueOf();
      if (Gi != null && Gi !== Bn)
        return Ie.from(Gi, hi, Ii);
      const kn = Cr(Bn);
      if (kn) return kn;
      if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof Bn[Symbol.toPrimitive] == "function")
        return Ie.from(Bn[Symbol.toPrimitive]("string"), hi, Ii);
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof Bn
      );
    }
    Ie.from = function(Bn, hi, Ii) {
      return xe(Bn, hi, Ii);
    }, Object.setPrototypeOf(Ie.prototype, Ce.prototype), Object.setPrototypeOf(Ie, Ce);
    function rr(Bn) {
      if (typeof Bn != "number")
        throw new TypeError('"size" argument must be of type number');
      if (Bn < 0)
        throw new RangeError('The value "' + Bn + '" is invalid for option "size"');
    }
    function ar(Bn, hi, Ii) {
      return rr(Bn), Bn <= 0 ? er(Bn) : hi !== void 0 ? typeof Ii == "string" ? er(Bn).fill(hi, Ii) : er(Bn).fill(hi) : er(Bn);
    }
    Ie.alloc = function(Bn, hi, Ii) {
      return ar(Bn, hi, Ii);
    };
    function yr(Bn) {
      return rr(Bn), er(Bn < 0 ? 0 : Hr(Bn) | 0);
    }
    Ie.allocUnsafe = function(Bn) {
      return yr(Bn);
    }, Ie.allocUnsafeSlow = function(Bn) {
      return yr(Bn);
    };
    function _r(Bn, hi) {
      if ((typeof hi != "string" || hi === "") && (hi = "utf8"), !Ie.isEncoding(hi))
        throw new TypeError("Unknown encoding: " + hi);
      const Ii = ui(Bn, hi) | 0;
      let Gi = er(Ii);
      const kn = Gi.write(Bn, hi);
      return kn !== Ii && (Gi = Gi.slice(0, kn)), Gi;
    }
    function Or(Bn) {
      const hi = Bn.length < 0 ? 0 : Hr(Bn.length) | 0, Ii = er(hi);
      for (let Gi = 0; Gi < hi; Gi += 1)
        Ii[Gi] = Bn[Gi] & 255;
      return Ii;
    }
    function vr(Bn) {
      if (ls(Bn, Ce)) {
        const hi = new Ce(Bn);
        return Te(hi.buffer, hi.byteOffset, hi.byteLength);
      }
      return Or(Bn);
    }
    function Te(Bn, hi, Ii) {
      if (hi < 0 || Bn.byteLength < hi)
        throw new RangeError('"offset" is outside of buffer bounds');
      if (Bn.byteLength < hi + (Ii || 0))
        throw new RangeError('"length" is outside of buffer bounds');
      let Gi;
      return hi === void 0 && Ii === void 0 ? Gi = new Ce(Bn) : Ii === void 0 ? Gi = new Ce(Bn, hi) : Gi = new Ce(Bn, hi, Ii), Object.setPrototypeOf(Gi, Ie.prototype), Gi;
    }
    function Cr(Bn) {
      if (Ie.isBuffer(Bn)) {
        const hi = Hr(Bn.length) | 0, Ii = er(hi);
        return Ii.length === 0 || Bn.copy(Ii, 0, 0, hi), Ii;
      }
      if (Bn.length !== void 0)
        return typeof Bn.length != "number" || na(Bn.length) ? er(0) : Or(Bn);
      if (Bn.type === "Buffer" && Array.isArray(Bn.data))
        return Or(Bn.data);
    }
    function Hr(Bn) {
      if (Bn >= kr)
        throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + kr.toString(16) + " bytes");
      return Bn | 0;
    }
    function si(Bn) {
      return +Bn != Bn && (Bn = 0), Ie.alloc(+Bn);
    }
    Ie.isBuffer = function(hi) {
      return hi != null && hi._isBuffer === !0 && hi !== Ie.prototype;
    }, Ie.compare = function(hi, Ii) {
      if (ls(hi, Ce) && (hi = Ie.from(hi, hi.offset, hi.byteLength)), ls(Ii, Ce) && (Ii = Ie.from(Ii, Ii.offset, Ii.byteLength)), !Ie.isBuffer(hi) || !Ie.isBuffer(Ii))
        throw new TypeError(
          'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
        );
      if (hi === Ii) return 0;
      let Gi = hi.length, kn = Ii.length;
      for (let ho = 0, eo = Math.min(Gi, kn); ho < eo; ++ho)
        if (hi[ho] !== Ii[ho]) {
          Gi = hi[ho], kn = Ii[ho];
          break;
        }
      return Gi < kn ? -1 : kn < Gi ? 1 : 0;
    }, Ie.isEncoding = function(hi) {
      switch (String(hi).toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return !0;
        default:
          return !1;
      }
    }, Ie.concat = function(hi, Ii) {
      if (!Array.isArray(hi))
        throw new TypeError('"list" argument must be an Array of Buffers');
      if (hi.length === 0)
        return Ie.alloc(0);
      let Gi;
      if (Ii === void 0)
        for (Ii = 0, Gi = 0; Gi < hi.length; ++Gi)
          Ii += hi[Gi].length;
      const kn = Ie.allocUnsafe(Ii);
      let ho = 0;
      for (Gi = 0; Gi < hi.length; ++Gi) {
        let eo = hi[Gi];
        if (ls(eo, Ce))
          ho + eo.length > kn.length ? (Ie.isBuffer(eo) || (eo = Ie.from(eo)), eo.copy(kn, ho)) : Ce.prototype.set.call(
            kn,
            eo,
            ho
          );
        else if (Ie.isBuffer(eo))
          eo.copy(kn, ho);
        else
          throw new TypeError('"list" argument must be an Array of Buffers');
        ho += eo.length;
      }
      return kn;
    };
    function ui(Bn, hi) {
      if (Ie.isBuffer(Bn))
        return Bn.length;
      if (tr.isView(Bn) || ls(Bn, tr))
        return Bn.byteLength;
      if (typeof Bn != "string")
        throw new TypeError(
          'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof Bn
        );
      const Ii = Bn.length, Gi = arguments.length > 2 && arguments[2] === !0;
      if (!Gi && Ii === 0) return 0;
      let kn = !1;
      for (; ; )
        switch (hi) {
          case "ascii":
          case "latin1":
          case "binary":
            return Ii;
          case "utf8":
          case "utf-8":
            return xs(Bn).length;
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return Ii * 2;
          case "hex":
            return Ii >>> 1;
          case "base64":
            return $s(Bn).length;
          default:
            if (kn)
              return Gi ? -1 : xs(Bn).length;
            hi = ("" + hi).toLowerCase(), kn = !0;
        }
    }
    Ie.byteLength = ui;
    function Li(Bn, hi, Ii) {
      let Gi = !1;
      if ((hi === void 0 || hi < 0) && (hi = 0), hi > this.length || ((Ii === void 0 || Ii > this.length) && (Ii = this.length), Ii <= 0) || (Ii >>>= 0, hi >>>= 0, Ii <= hi))
        return "";
      for (Bn || (Bn = "utf8"); ; )
        switch (Bn) {
          case "hex":
            return _n(this, hi, Ii);
          case "utf8":
          case "utf-8":
            return Wr(this, hi, Ii);
          case "ascii":
            return Er(this, hi, Ii);
          case "latin1":
          case "binary":
            return Di(this, hi, Ii);
          case "base64":
            return Zi(this, hi, Ii);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return On(this, hi, Ii);
          default:
            if (Gi) throw new TypeError("Unknown encoding: " + Bn);
            Bn = (Bn + "").toLowerCase(), Gi = !0;
        }
    }
    Ie.prototype._isBuffer = !0;
    function Qi(Bn, hi, Ii) {
      const Gi = Bn[hi];
      Bn[hi] = Bn[Ii], Bn[Ii] = Gi;
    }
    Ie.prototype.swap16 = function() {
      const hi = this.length;
      if (hi % 2 !== 0)
        throw new RangeError("Buffer size must be a multiple of 16-bits");
      for (let Ii = 0; Ii < hi; Ii += 2)
        Qi(this, Ii, Ii + 1);
      return this;
    }, Ie.prototype.swap32 = function() {
      const hi = this.length;
      if (hi % 4 !== 0)
        throw new RangeError("Buffer size must be a multiple of 32-bits");
      for (let Ii = 0; Ii < hi; Ii += 4)
        Qi(this, Ii, Ii + 3), Qi(this, Ii + 1, Ii + 2);
      return this;
    }, Ie.prototype.swap64 = function() {
      const hi = this.length;
      if (hi % 8 !== 0)
        throw new RangeError("Buffer size must be a multiple of 64-bits");
      for (let Ii = 0; Ii < hi; Ii += 8)
        Qi(this, Ii, Ii + 7), Qi(this, Ii + 1, Ii + 6), Qi(this, Ii + 2, Ii + 5), Qi(this, Ii + 3, Ii + 4);
      return this;
    }, Ie.prototype.toString = function() {
      const hi = this.length;
      return hi === 0 ? "" : arguments.length === 0 ? Wr(this, 0, hi) : Li.apply(this, arguments);
    }, Ie.prototype.toLocaleString = Ie.prototype.toString, Ie.prototype.equals = function(hi) {
      if (!Ie.isBuffer(hi)) throw new TypeError("Argument must be a Buffer");
      return this === hi ? !0 : Ie.compare(this, hi) === 0;
    }, Ie.prototype.inspect = function() {
      let hi = "";
      const Ii = or.INSPECT_MAX_BYTES;
      return hi = this.toString("hex", 0, Ii).replace(/(.{2})/g, "$1 ").trim(), this.length > Ii && (hi += " ... "), "<Buffer " + hi + ">";
    }, xr && (Ie.prototype[xr] = Ie.prototype.inspect), Ie.prototype.compare = function(hi, Ii, Gi, kn, ho) {
      if (ls(hi, Ce) && (hi = Ie.from(hi, hi.offset, hi.byteLength)), !Ie.isBuffer(hi))
        throw new TypeError(
          'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof hi
        );
      if (Ii === void 0 && (Ii = 0), Gi === void 0 && (Gi = hi ? hi.length : 0), kn === void 0 && (kn = 0), ho === void 0 && (ho = this.length), Ii < 0 || Gi > hi.length || kn < 0 || ho > this.length)
        throw new RangeError("out of range index");
      if (kn >= ho && Ii >= Gi)
        return 0;
      if (kn >= ho)
        return -1;
      if (Ii >= Gi)
        return 1;
      if (Ii >>>= 0, Gi >>>= 0, kn >>>= 0, ho >>>= 0, this === hi) return 0;
      let eo = ho - kn, Ei = Gi - Ii;
      const vs = Math.min(eo, Ei), vi = this.slice(kn, ho), xi = hi.slice(Ii, Gi);
      for (let Lr = 0; Lr < vs; ++Lr)
        if (vi[Lr] !== xi[Lr]) {
          eo = vi[Lr], Ei = xi[Lr];
          break;
        }
      return eo < Ei ? -1 : Ei < eo ? 1 : 0;
    };
    function wi(Bn, hi, Ii, Gi, kn) {
      if (Bn.length === 0) return -1;
      if (typeof Ii == "string" ? (Gi = Ii, Ii = 0) : Ii > 2147483647 ? Ii = 2147483647 : Ii < -2147483648 && (Ii = -2147483648), Ii = +Ii, na(Ii) && (Ii = kn ? 0 : Bn.length - 1), Ii < 0 && (Ii = Bn.length + Ii), Ii >= Bn.length) {
        if (kn) return -1;
        Ii = Bn.length - 1;
      } else if (Ii < 0)
        if (kn) Ii = 0;
        else return -1;
      if (typeof hi == "string" && (hi = Ie.from(hi, Gi)), Ie.isBuffer(hi))
        return hi.length === 0 ? -1 : Ji(Bn, hi, Ii, Gi, kn);
      if (typeof hi == "number")
        return hi = hi & 255, typeof Ce.prototype.indexOf == "function" ? kn ? Ce.prototype.indexOf.call(Bn, hi, Ii) : Ce.prototype.lastIndexOf.call(Bn, hi, Ii) : Ji(Bn, [hi], Ii, Gi, kn);
      throw new TypeError("val must be string, number or Buffer");
    }
    function Ji(Bn, hi, Ii, Gi, kn) {
      let ho = 1, eo = Bn.length, Ei = hi.length;
      if (Gi !== void 0 && (Gi = String(Gi).toLowerCase(), Gi === "ucs2" || Gi === "ucs-2" || Gi === "utf16le" || Gi === "utf-16le")) {
        if (Bn.length < 2 || hi.length < 2)
          return -1;
        ho = 2, eo /= 2, Ei /= 2, Ii /= 2;
      }
      function vs(xi, Lr) {
        return ho === 1 ? xi[Lr] : xi.readUInt16BE(Lr * ho);
      }
      let vi;
      if (kn) {
        let xi = -1;
        for (vi = Ii; vi < eo; vi++)
          if (vs(Bn, vi) === vs(hi, xi === -1 ? 0 : vi - xi)) {
            if (xi === -1 && (xi = vi), vi - xi + 1 === Ei) return xi * ho;
          } else
            xi !== -1 && (vi -= vi - xi), xi = -1;
      } else
        for (Ii + Ei > eo && (Ii = eo - Ei), vi = Ii; vi >= 0; vi--) {
          let xi = !0;
          for (let Lr = 0; Lr < Ei; Lr++)
            if (vs(Bn, vi + Lr) !== vs(hi, Lr)) {
              xi = !1;
              break;
            }
          if (xi) return vi;
        }
      return -1;
    }
    Ie.prototype.includes = function(hi, Ii, Gi) {
      return this.indexOf(hi, Ii, Gi) !== -1;
    }, Ie.prototype.indexOf = function(hi, Ii, Gi) {
      return wi(this, hi, Ii, Gi, !0);
    }, Ie.prototype.lastIndexOf = function(hi, Ii, Gi) {
      return wi(this, hi, Ii, Gi, !1);
    };
    function mn(Bn, hi, Ii, Gi) {
      Ii = Number(Ii) || 0;
      const kn = Bn.length - Ii;
      Gi ? (Gi = Number(Gi), Gi > kn && (Gi = kn)) : Gi = kn;
      const ho = hi.length;
      Gi > ho / 2 && (Gi = ho / 2);
      let eo;
      for (eo = 0; eo < Gi; ++eo) {
        const Ei = parseInt(hi.substr(eo * 2, 2), 16);
        if (na(Ei)) return eo;
        Bn[Ii + eo] = Ei;
      }
      return eo;
    }
    function pi(Bn, hi, Ii, Gi) {
      return rs(xs(hi, Bn.length - Ii), Bn, Ii, Gi);
    }
    function ei(Bn, hi, Ii, Gi) {
      return rs(Fo(hi), Bn, Ii, Gi);
    }
    function Vr(Bn, hi, Ii, Gi) {
      return rs($s(hi), Bn, Ii, Gi);
    }
    function qr(Bn, hi, Ii, Gi) {
      return rs(Zo(hi, Bn.length - Ii), Bn, Ii, Gi);
    }
    Ie.prototype.write = function(hi, Ii, Gi, kn) {
      if (Ii === void 0)
        kn = "utf8", Gi = this.length, Ii = 0;
      else if (Gi === void 0 && typeof Ii == "string")
        kn = Ii, Gi = this.length, Ii = 0;
      else if (isFinite(Ii))
        Ii = Ii >>> 0, isFinite(Gi) ? (Gi = Gi >>> 0, kn === void 0 && (kn = "utf8")) : (kn = Gi, Gi = void 0);
      else
        throw new Error(
          "Buffer.write(string, encoding, offset[, length]) is no longer supported"
        );
      const ho = this.length - Ii;
      if ((Gi === void 0 || Gi > ho) && (Gi = ho), hi.length > 0 && (Gi < 0 || Ii < 0) || Ii > this.length)
        throw new RangeError("Attempt to write outside buffer bounds");
      kn || (kn = "utf8");
      let eo = !1;
      for (; ; )
        switch (kn) {
          case "hex":
            return mn(this, hi, Ii, Gi);
          case "utf8":
          case "utf-8":
            return pi(this, hi, Ii, Gi);
          case "ascii":
          case "latin1":
          case "binary":
            return ei(this, hi, Ii, Gi);
          case "base64":
            return Vr(this, hi, Ii, Gi);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return qr(this, hi, Ii, Gi);
          default:
            if (eo) throw new TypeError("Unknown encoding: " + kn);
            kn = ("" + kn).toLowerCase(), eo = !0;
        }
    }, Ie.prototype.toJSON = function() {
      return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
      };
    };
    function Zi(Bn, hi, Ii) {
      return hi === 0 && Ii === Bn.length ? lr.fromByteArray(Bn) : lr.fromByteArray(Bn.slice(hi, Ii));
    }
    function Wr(Bn, hi, Ii) {
      Ii = Math.min(Bn.length, Ii);
      const Gi = [];
      let kn = hi;
      for (; kn < Ii; ) {
        const ho = Bn[kn];
        let eo = null, Ei = ho > 239 ? 4 : ho > 223 ? 3 : ho > 191 ? 2 : 1;
        if (kn + Ei <= Ii) {
          let vs, vi, xi, Lr;
          switch (Ei) {
            case 1:
              ho < 128 && (eo = ho);
              break;
            case 2:
              vs = Bn[kn + 1], (vs & 192) === 128 && (Lr = (ho & 31) << 6 | vs & 63, Lr > 127 && (eo = Lr));
              break;
            case 3:
              vs = Bn[kn + 1], vi = Bn[kn + 2], (vs & 192) === 128 && (vi & 192) === 128 && (Lr = (ho & 15) << 12 | (vs & 63) << 6 | vi & 63, Lr > 2047 && (Lr < 55296 || Lr > 57343) && (eo = Lr));
              break;
            case 4:
              vs = Bn[kn + 1], vi = Bn[kn + 2], xi = Bn[kn + 3], (vs & 192) === 128 && (vi & 192) === 128 && (xi & 192) === 128 && (Lr = (ho & 15) << 18 | (vs & 63) << 12 | (vi & 63) << 6 | xi & 63, Lr > 65535 && Lr < 1114112 && (eo = Lr));
          }
        }
        eo === null ? (eo = 65533, Ei = 1) : eo > 65535 && (eo -= 65536, Gi.push(eo >>> 10 & 1023 | 55296), eo = 56320 | eo & 1023), Gi.push(eo), kn += Ei;
      }
      return _i(Gi);
    }
    const ri = 4096;
    function _i(Bn) {
      const hi = Bn.length;
      if (hi <= ri)
        return String.fromCharCode.apply(String, Bn);
      let Ii = "", Gi = 0;
      for (; Gi < hi; )
        Ii += String.fromCharCode.apply(
          String,
          Bn.slice(Gi, Gi += ri)
        );
      return Ii;
    }
    function Er(Bn, hi, Ii) {
      let Gi = "";
      Ii = Math.min(Bn.length, Ii);
      for (let kn = hi; kn < Ii; ++kn)
        Gi += String.fromCharCode(Bn[kn] & 127);
      return Gi;
    }
    function Di(Bn, hi, Ii) {
      let Gi = "";
      Ii = Math.min(Bn.length, Ii);
      for (let kn = hi; kn < Ii; ++kn)
        Gi += String.fromCharCode(Bn[kn]);
      return Gi;
    }
    function _n(Bn, hi, Ii) {
      const Gi = Bn.length;
      (!hi || hi < 0) && (hi = 0), (!Ii || Ii < 0 || Ii > Gi) && (Ii = Gi);
      let kn = "";
      for (let ho = hi; ho < Ii; ++ho)
        kn += os[Bn[ho]];
      return kn;
    }
    function On(Bn, hi, Ii) {
      const Gi = Bn.slice(hi, Ii);
      let kn = "";
      for (let ho = 0; ho < Gi.length - 1; ho += 2)
        kn += String.fromCharCode(Gi[ho] + Gi[ho + 1] * 256);
      return kn;
    }
    Ie.prototype.slice = function(hi, Ii) {
      const Gi = this.length;
      hi = ~~hi, Ii = Ii === void 0 ? Gi : ~~Ii, hi < 0 ? (hi += Gi, hi < 0 && (hi = 0)) : hi > Gi && (hi = Gi), Ii < 0 ? (Ii += Gi, Ii < 0 && (Ii = 0)) : Ii > Gi && (Ii = Gi), Ii < hi && (Ii = hi);
      const kn = this.subarray(hi, Ii);
      return Object.setPrototypeOf(kn, Ie.prototype), kn;
    };
    function so(Bn, hi, Ii) {
      if (Bn % 1 !== 0 || Bn < 0) throw new RangeError("offset is not uint");
      if (Bn + hi > Ii) throw new RangeError("Trying to access beyond buffer length");
    }
    Ie.prototype.readUintLE = Ie.prototype.readUIntLE = function(hi, Ii, Gi) {
      hi = hi >>> 0, Ii = Ii >>> 0, Gi || so(hi, Ii, this.length);
      let kn = this[hi], ho = 1, eo = 0;
      for (; ++eo < Ii && (ho *= 256); )
        kn += this[hi + eo] * ho;
      return kn;
    }, Ie.prototype.readUintBE = Ie.prototype.readUIntBE = function(hi, Ii, Gi) {
      hi = hi >>> 0, Ii = Ii >>> 0, Gi || so(hi, Ii, this.length);
      let kn = this[hi + --Ii], ho = 1;
      for (; Ii > 0 && (ho *= 256); )
        kn += this[hi + --Ii] * ho;
      return kn;
    }, Ie.prototype.readUint8 = Ie.prototype.readUInt8 = function(hi, Ii) {
      return hi = hi >>> 0, Ii || so(hi, 1, this.length), this[hi];
    }, Ie.prototype.readUint16LE = Ie.prototype.readUInt16LE = function(hi, Ii) {
      return hi = hi >>> 0, Ii || so(hi, 2, this.length), this[hi] | this[hi + 1] << 8;
    }, Ie.prototype.readUint16BE = Ie.prototype.readUInt16BE = function(hi, Ii) {
      return hi = hi >>> 0, Ii || so(hi, 2, this.length), this[hi] << 8 | this[hi + 1];
    }, Ie.prototype.readUint32LE = Ie.prototype.readUInt32LE = function(hi, Ii) {
      return hi = hi >>> 0, Ii || so(hi, 4, this.length), (this[hi] | this[hi + 1] << 8 | this[hi + 2] << 16) + this[hi + 3] * 16777216;
    }, Ie.prototype.readUint32BE = Ie.prototype.readUInt32BE = function(hi, Ii) {
      return hi = hi >>> 0, Ii || so(hi, 4, this.length), this[hi] * 16777216 + (this[hi + 1] << 16 | this[hi + 2] << 8 | this[hi + 3]);
    }, Ie.prototype.readBigUInt64LE = fs(function(hi) {
      hi = hi >>> 0, Un(hi, "offset");
      const Ii = this[hi], Gi = this[hi + 7];
      (Ii === void 0 || Gi === void 0) && Bo(hi, this.length - 8);
      const kn = Ii + this[++hi] * 2 ** 8 + this[++hi] * 2 ** 16 + this[++hi] * 2 ** 24, ho = this[++hi] + this[++hi] * 2 ** 8 + this[++hi] * 2 ** 16 + Gi * 2 ** 24;
      return BigInt(kn) + (BigInt(ho) << BigInt(32));
    }), Ie.prototype.readBigUInt64BE = fs(function(hi) {
      hi = hi >>> 0, Un(hi, "offset");
      const Ii = this[hi], Gi = this[hi + 7];
      (Ii === void 0 || Gi === void 0) && Bo(hi, this.length - 8);
      const kn = Ii * 2 ** 24 + this[++hi] * 2 ** 16 + this[++hi] * 2 ** 8 + this[++hi], ho = this[++hi] * 2 ** 24 + this[++hi] * 2 ** 16 + this[++hi] * 2 ** 8 + Gi;
      return (BigInt(kn) << BigInt(32)) + BigInt(ho);
    }), Ie.prototype.readIntLE = function(hi, Ii, Gi) {
      hi = hi >>> 0, Ii = Ii >>> 0, Gi || so(hi, Ii, this.length);
      let kn = this[hi], ho = 1, eo = 0;
      for (; ++eo < Ii && (ho *= 256); )
        kn += this[hi + eo] * ho;
      return ho *= 128, kn >= ho && (kn -= Math.pow(2, 8 * Ii)), kn;
    }, Ie.prototype.readIntBE = function(hi, Ii, Gi) {
      hi = hi >>> 0, Ii = Ii >>> 0, Gi || so(hi, Ii, this.length);
      let kn = Ii, ho = 1, eo = this[hi + --kn];
      for (; kn > 0 && (ho *= 256); )
        eo += this[hi + --kn] * ho;
      return ho *= 128, eo >= ho && (eo -= Math.pow(2, 8 * Ii)), eo;
    }, Ie.prototype.readInt8 = function(hi, Ii) {
      return hi = hi >>> 0, Ii || so(hi, 1, this.length), this[hi] & 128 ? (255 - this[hi] + 1) * -1 : this[hi];
    }, Ie.prototype.readInt16LE = function(hi, Ii) {
      hi = hi >>> 0, Ii || so(hi, 2, this.length);
      const Gi = this[hi] | this[hi + 1] << 8;
      return Gi & 32768 ? Gi | 4294901760 : Gi;
    }, Ie.prototype.readInt16BE = function(hi, Ii) {
      hi = hi >>> 0, Ii || so(hi, 2, this.length);
      const Gi = this[hi + 1] | this[hi] << 8;
      return Gi & 32768 ? Gi | 4294901760 : Gi;
    }, Ie.prototype.readInt32LE = function(hi, Ii) {
      return hi = hi >>> 0, Ii || so(hi, 4, this.length), this[hi] | this[hi + 1] << 8 | this[hi + 2] << 16 | this[hi + 3] << 24;
    }, Ie.prototype.readInt32BE = function(hi, Ii) {
      return hi = hi >>> 0, Ii || so(hi, 4, this.length), this[hi] << 24 | this[hi + 1] << 16 | this[hi + 2] << 8 | this[hi + 3];
    }, Ie.prototype.readBigInt64LE = fs(function(hi) {
      hi = hi >>> 0, Un(hi, "offset");
      const Ii = this[hi], Gi = this[hi + 7];
      (Ii === void 0 || Gi === void 0) && Bo(hi, this.length - 8);
      const kn = this[hi + 4] + this[hi + 5] * 2 ** 8 + this[hi + 6] * 2 ** 16 + (Gi << 24);
      return (BigInt(kn) << BigInt(32)) + BigInt(Ii + this[++hi] * 2 ** 8 + this[++hi] * 2 ** 16 + this[++hi] * 2 ** 24);
    }), Ie.prototype.readBigInt64BE = fs(function(hi) {
      hi = hi >>> 0, Un(hi, "offset");
      const Ii = this[hi], Gi = this[hi + 7];
      (Ii === void 0 || Gi === void 0) && Bo(hi, this.length - 8);
      const kn = (Ii << 24) + // Overflow
      this[++hi] * 2 ** 16 + this[++hi] * 2 ** 8 + this[++hi];
      return (BigInt(kn) << BigInt(32)) + BigInt(this[++hi] * 2 ** 24 + this[++hi] * 2 ** 16 + this[++hi] * 2 ** 8 + Gi);
    }), Ie.prototype.readFloatLE = function(hi, Ii) {
      return hi = hi >>> 0, Ii || so(hi, 4, this.length), Ir.read(this, hi, !0, 23, 4);
    }, Ie.prototype.readFloatBE = function(hi, Ii) {
      return hi = hi >>> 0, Ii || so(hi, 4, this.length), Ir.read(this, hi, !1, 23, 4);
    }, Ie.prototype.readDoubleLE = function(hi, Ii) {
      return hi = hi >>> 0, Ii || so(hi, 8, this.length), Ir.read(this, hi, !0, 52, 8);
    }, Ie.prototype.readDoubleBE = function(hi, Ii) {
      return hi = hi >>> 0, Ii || so(hi, 8, this.length), Ir.read(this, hi, !1, 52, 8);
    };
    function Do(Bn, hi, Ii, Gi, kn, ho) {
      if (!Ie.isBuffer(Bn)) throw new TypeError('"buffer" argument must be a Buffer instance');
      if (hi > kn || hi < ho) throw new RangeError('"value" argument is out of bounds');
      if (Ii + Gi > Bn.length) throw new RangeError("Index out of range");
    }
    Ie.prototype.writeUintLE = Ie.prototype.writeUIntLE = function(hi, Ii, Gi, kn) {
      if (hi = +hi, Ii = Ii >>> 0, Gi = Gi >>> 0, !kn) {
        const Ei = Math.pow(2, 8 * Gi) - 1;
        Do(this, hi, Ii, Gi, Ei, 0);
      }
      let ho = 1, eo = 0;
      for (this[Ii] = hi & 255; ++eo < Gi && (ho *= 256); )
        this[Ii + eo] = hi / ho & 255;
      return Ii + Gi;
    }, Ie.prototype.writeUintBE = Ie.prototype.writeUIntBE = function(hi, Ii, Gi, kn) {
      if (hi = +hi, Ii = Ii >>> 0, Gi = Gi >>> 0, !kn) {
        const Ei = Math.pow(2, 8 * Gi) - 1;
        Do(this, hi, Ii, Gi, Ei, 0);
      }
      let ho = Gi - 1, eo = 1;
      for (this[Ii + ho] = hi & 255; --ho >= 0 && (eo *= 256); )
        this[Ii + ho] = hi / eo & 255;
      return Ii + Gi;
    }, Ie.prototype.writeUint8 = Ie.prototype.writeUInt8 = function(hi, Ii, Gi) {
      return hi = +hi, Ii = Ii >>> 0, Gi || Do(this, hi, Ii, 1, 255, 0), this[Ii] = hi & 255, Ii + 1;
    }, Ie.prototype.writeUint16LE = Ie.prototype.writeUInt16LE = function(hi, Ii, Gi) {
      return hi = +hi, Ii = Ii >>> 0, Gi || Do(this, hi, Ii, 2, 65535, 0), this[Ii] = hi & 255, this[Ii + 1] = hi >>> 8, Ii + 2;
    }, Ie.prototype.writeUint16BE = Ie.prototype.writeUInt16BE = function(hi, Ii, Gi) {
      return hi = +hi, Ii = Ii >>> 0, Gi || Do(this, hi, Ii, 2, 65535, 0), this[Ii] = hi >>> 8, this[Ii + 1] = hi & 255, Ii + 2;
    }, Ie.prototype.writeUint32LE = Ie.prototype.writeUInt32LE = function(hi, Ii, Gi) {
      return hi = +hi, Ii = Ii >>> 0, Gi || Do(this, hi, Ii, 4, 4294967295, 0), this[Ii + 3] = hi >>> 24, this[Ii + 2] = hi >>> 16, this[Ii + 1] = hi >>> 8, this[Ii] = hi & 255, Ii + 4;
    }, Ie.prototype.writeUint32BE = Ie.prototype.writeUInt32BE = function(hi, Ii, Gi) {
      return hi = +hi, Ii = Ii >>> 0, Gi || Do(this, hi, Ii, 4, 4294967295, 0), this[Ii] = hi >>> 24, this[Ii + 1] = hi >>> 16, this[Ii + 2] = hi >>> 8, this[Ii + 3] = hi & 255, Ii + 4;
    };
    function gn(Bn, hi, Ii, Gi, kn) {
      ln(hi, Gi, kn, Bn, Ii, 7);
      let ho = Number(hi & BigInt(4294967295));
      Bn[Ii++] = ho, ho = ho >> 8, Bn[Ii++] = ho, ho = ho >> 8, Bn[Ii++] = ho, ho = ho >> 8, Bn[Ii++] = ho;
      let eo = Number(hi >> BigInt(32) & BigInt(4294967295));
      return Bn[Ii++] = eo, eo = eo >> 8, Bn[Ii++] = eo, eo = eo >> 8, Bn[Ii++] = eo, eo = eo >> 8, Bn[Ii++] = eo, Ii;
    }
    function Gn(Bn, hi, Ii, Gi, kn) {
      ln(hi, Gi, kn, Bn, Ii, 7);
      let ho = Number(hi & BigInt(4294967295));
      Bn[Ii + 7] = ho, ho = ho >> 8, Bn[Ii + 6] = ho, ho = ho >> 8, Bn[Ii + 5] = ho, ho = ho >> 8, Bn[Ii + 4] = ho;
      let eo = Number(hi >> BigInt(32) & BigInt(4294967295));
      return Bn[Ii + 3] = eo, eo = eo >> 8, Bn[Ii + 2] = eo, eo = eo >> 8, Bn[Ii + 1] = eo, eo = eo >> 8, Bn[Ii] = eo, Ii + 8;
    }
    Ie.prototype.writeBigUInt64LE = fs(function(hi, Ii = 0) {
      return gn(this, hi, Ii, BigInt(0), BigInt("0xffffffffffffffff"));
    }), Ie.prototype.writeBigUInt64BE = fs(function(hi, Ii = 0) {
      return Gn(this, hi, Ii, BigInt(0), BigInt("0xffffffffffffffff"));
    }), Ie.prototype.writeIntLE = function(hi, Ii, Gi, kn) {
      if (hi = +hi, Ii = Ii >>> 0, !kn) {
        const vs = Math.pow(2, 8 * Gi - 1);
        Do(this, hi, Ii, Gi, vs - 1, -vs);
      }
      let ho = 0, eo = 1, Ei = 0;
      for (this[Ii] = hi & 255; ++ho < Gi && (eo *= 256); )
        hi < 0 && Ei === 0 && this[Ii + ho - 1] !== 0 && (Ei = 1), this[Ii + ho] = (hi / eo >> 0) - Ei & 255;
      return Ii + Gi;
    }, Ie.prototype.writeIntBE = function(hi, Ii, Gi, kn) {
      if (hi = +hi, Ii = Ii >>> 0, !kn) {
        const vs = Math.pow(2, 8 * Gi - 1);
        Do(this, hi, Ii, Gi, vs - 1, -vs);
      }
      let ho = Gi - 1, eo = 1, Ei = 0;
      for (this[Ii + ho] = hi & 255; --ho >= 0 && (eo *= 256); )
        hi < 0 && Ei === 0 && this[Ii + ho + 1] !== 0 && (Ei = 1), this[Ii + ho] = (hi / eo >> 0) - Ei & 255;
      return Ii + Gi;
    }, Ie.prototype.writeInt8 = function(hi, Ii, Gi) {
      return hi = +hi, Ii = Ii >>> 0, Gi || Do(this, hi, Ii, 1, 127, -128), hi < 0 && (hi = 255 + hi + 1), this[Ii] = hi & 255, Ii + 1;
    }, Ie.prototype.writeInt16LE = function(hi, Ii, Gi) {
      return hi = +hi, Ii = Ii >>> 0, Gi || Do(this, hi, Ii, 2, 32767, -32768), this[Ii] = hi & 255, this[Ii + 1] = hi >>> 8, Ii + 2;
    }, Ie.prototype.writeInt16BE = function(hi, Ii, Gi) {
      return hi = +hi, Ii = Ii >>> 0, Gi || Do(this, hi, Ii, 2, 32767, -32768), this[Ii] = hi >>> 8, this[Ii + 1] = hi & 255, Ii + 2;
    }, Ie.prototype.writeInt32LE = function(hi, Ii, Gi) {
      return hi = +hi, Ii = Ii >>> 0, Gi || Do(this, hi, Ii, 4, 2147483647, -2147483648), this[Ii] = hi & 255, this[Ii + 1] = hi >>> 8, this[Ii + 2] = hi >>> 16, this[Ii + 3] = hi >>> 24, Ii + 4;
    }, Ie.prototype.writeInt32BE = function(hi, Ii, Gi) {
      return hi = +hi, Ii = Ii >>> 0, Gi || Do(this, hi, Ii, 4, 2147483647, -2147483648), hi < 0 && (hi = 4294967295 + hi + 1), this[Ii] = hi >>> 24, this[Ii + 1] = hi >>> 16, this[Ii + 2] = hi >>> 8, this[Ii + 3] = hi & 255, Ii + 4;
    }, Ie.prototype.writeBigInt64LE = fs(function(hi, Ii = 0) {
      return gn(this, hi, Ii, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
    }), Ie.prototype.writeBigInt64BE = fs(function(hi, Ii = 0) {
      return Gn(this, hi, Ii, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
    });
    function pn(Bn, hi, Ii, Gi, kn, ho) {
      if (Ii + Gi > Bn.length) throw new RangeError("Index out of range");
      if (Ii < 0) throw new RangeError("Index out of range");
    }
    function hn(Bn, hi, Ii, Gi, kn) {
      return hi = +hi, Ii = Ii >>> 0, kn || pn(Bn, hi, Ii, 4), Ir.write(Bn, hi, Ii, Gi, 23, 4), Ii + 4;
    }
    Ie.prototype.writeFloatLE = function(hi, Ii, Gi) {
      return hn(this, hi, Ii, !0, Gi);
    }, Ie.prototype.writeFloatBE = function(hi, Ii, Gi) {
      return hn(this, hi, Ii, !1, Gi);
    };
    function Rn(Bn, hi, Ii, Gi, kn) {
      return hi = +hi, Ii = Ii >>> 0, kn || pn(Bn, hi, Ii, 8), Ir.write(Bn, hi, Ii, Gi, 52, 8), Ii + 8;
    }
    Ie.prototype.writeDoubleLE = function(hi, Ii, Gi) {
      return Rn(this, hi, Ii, !0, Gi);
    }, Ie.prototype.writeDoubleBE = function(hi, Ii, Gi) {
      return Rn(this, hi, Ii, !1, Gi);
    }, Ie.prototype.copy = function(hi, Ii, Gi, kn) {
      if (!Ie.isBuffer(hi)) throw new TypeError("argument should be a Buffer");
      if (Gi || (Gi = 0), !kn && kn !== 0 && (kn = this.length), Ii >= hi.length && (Ii = hi.length), Ii || (Ii = 0), kn > 0 && kn < Gi && (kn = Gi), kn === Gi || hi.length === 0 || this.length === 0) return 0;
      if (Ii < 0)
        throw new RangeError("targetStart out of bounds");
      if (Gi < 0 || Gi >= this.length) throw new RangeError("Index out of range");
      if (kn < 0) throw new RangeError("sourceEnd out of bounds");
      kn > this.length && (kn = this.length), hi.length - Ii < kn - Gi && (kn = hi.length - Ii + Gi);
      const ho = kn - Gi;
      return this === hi && typeof Ce.prototype.copyWithin == "function" ? this.copyWithin(Ii, Gi, kn) : Ce.prototype.set.call(
        hi,
        this.subarray(Gi, kn),
        Ii
      ), ho;
    }, Ie.prototype.fill = function(hi, Ii, Gi, kn) {
      if (typeof hi == "string") {
        if (typeof Ii == "string" ? (kn = Ii, Ii = 0, Gi = this.length) : typeof Gi == "string" && (kn = Gi, Gi = this.length), kn !== void 0 && typeof kn != "string")
          throw new TypeError("encoding must be a string");
        if (typeof kn == "string" && !Ie.isEncoding(kn))
          throw new TypeError("Unknown encoding: " + kn);
        if (hi.length === 1) {
          const eo = hi.charCodeAt(0);
          (kn === "utf8" && eo < 128 || kn === "latin1") && (hi = eo);
        }
      } else typeof hi == "number" ? hi = hi & 255 : typeof hi == "boolean" && (hi = Number(hi));
      if (Ii < 0 || this.length < Ii || this.length < Gi)
        throw new RangeError("Out of range index");
      if (Gi <= Ii)
        return this;
      Ii = Ii >>> 0, Gi = Gi === void 0 ? this.length : Gi >>> 0, hi || (hi = 0);
      let ho;
      if (typeof hi == "number")
        for (ho = Ii; ho < Gi; ++ho)
          this[ho] = hi;
      else {
        const eo = Ie.isBuffer(hi) ? hi : Ie.from(hi, kn), Ei = eo.length;
        if (Ei === 0)
          throw new TypeError('The value "' + hi + '" is invalid for argument "value"');
        for (ho = 0; ho < Gi - Ii; ++ho)
          this[ho + Ii] = eo[ho % Ei];
      }
      return this;
    };
    const vo = {};
    function Hi(Bn, hi, Ii) {
      vo[Bn] = class extends Ii {
        constructor() {
          super(), Object.defineProperty(this, "message", {
            value: hi.apply(this, arguments),
            writable: !0,
            configurable: !0
          }), this.name = `${this.name} [${Bn}]`, this.stack, delete this.name;
        }
        get code() {
          return Bn;
        }
        set code(kn) {
          Object.defineProperty(this, "code", {
            configurable: !0,
            enumerable: !0,
            value: kn,
            writable: !0
          });
        }
        toString() {
          return `${this.name} [${Bn}]: ${this.message}`;
        }
      };
    }
    Hi(
      "ERR_BUFFER_OUT_OF_BOUNDS",
      function(Bn) {
        return Bn ? `${Bn} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
      },
      RangeError
    ), Hi(
      "ERR_INVALID_ARG_TYPE",
      function(Bn, hi) {
        return `The "${Bn}" argument must be of type number. Received type ${typeof hi}`;
      },
      TypeError
    ), Hi(
      "ERR_OUT_OF_RANGE",
      function(Bn, hi, Ii) {
        let Gi = `The value of "${Bn}" is out of range.`, kn = Ii;
        return Number.isInteger(Ii) && Math.abs(Ii) > 2 ** 32 ? kn = di(String(Ii)) : typeof Ii == "bigint" && (kn = String(Ii), (Ii > BigInt(2) ** BigInt(32) || Ii < -(BigInt(2) ** BigInt(32))) && (kn = di(kn)), kn += "n"), Gi += ` It must be ${hi}. Received ${kn}`, Gi;
      },
      RangeError
    );
    function di(Bn) {
      let hi = "", Ii = Bn.length;
      const Gi = Bn[0] === "-" ? 1 : 0;
      for (; Ii >= Gi + 4; Ii -= 3)
        hi = `_${Bn.slice(Ii - 3, Ii)}${hi}`;
      return `${Bn.slice(0, Ii)}${hi}`;
    }
    function Ui(Bn, hi, Ii) {
      Un(hi, "offset"), (Bn[hi] === void 0 || Bn[hi + Ii] === void 0) && Bo(hi, Bn.length - (Ii + 1));
    }
    function ln(Bn, hi, Ii, Gi, kn, ho) {
      if (Bn > Ii || Bn < hi) {
        const eo = typeof hi == "bigint" ? "n" : "";
        let Ei;
        throw hi === 0 || hi === BigInt(0) ? Ei = `>= 0${eo} and < 2${eo} ** ${(ho + 1) * 8}${eo}` : Ei = `>= -(2${eo} ** ${(ho + 1) * 8 - 1}${eo}) and < 2 ** ${(ho + 1) * 8 - 1}${eo}`, new vo.ERR_OUT_OF_RANGE("value", Ei, Bn);
      }
      Ui(Gi, kn, ho);
    }
    function Un(Bn, hi) {
      if (typeof Bn != "number")
        throw new vo.ERR_INVALID_ARG_TYPE(hi, "number", Bn);
    }
    function Bo(Bn, hi, Ii) {
      throw Math.floor(Bn) !== Bn ? (Un(Bn, Ii), new vo.ERR_OUT_OF_RANGE("offset", "an integer", Bn)) : hi < 0 ? new vo.ERR_BUFFER_OUT_OF_BOUNDS() : new vo.ERR_OUT_OF_RANGE(
        "offset",
        `>= 0 and <= ${hi}`,
        Bn
      );
    }
    const co = /[^+/0-9A-Za-z-_]/g;
    function To(Bn) {
      if (Bn = Bn.split("=")[0], Bn = Bn.trim().replace(co, ""), Bn.length < 2) return "";
      for (; Bn.length % 4 !== 0; )
        Bn = Bn + "=";
      return Bn;
    }
    function xs(Bn, hi) {
      hi = hi || 1 / 0;
      let Ii;
      const Gi = Bn.length;
      let kn = null;
      const ho = [];
      for (let eo = 0; eo < Gi; ++eo) {
        if (Ii = Bn.charCodeAt(eo), Ii > 55295 && Ii < 57344) {
          if (!kn) {
            if (Ii > 56319) {
              (hi -= 3) > -1 && ho.push(239, 191, 189);
              continue;
            } else if (eo + 1 === Gi) {
              (hi -= 3) > -1 && ho.push(239, 191, 189);
              continue;
            }
            kn = Ii;
            continue;
          }
          if (Ii < 56320) {
            (hi -= 3) > -1 && ho.push(239, 191, 189), kn = Ii;
            continue;
          }
          Ii = (kn - 55296 << 10 | Ii - 56320) + 65536;
        } else kn && (hi -= 3) > -1 && ho.push(239, 191, 189);
        if (kn = null, Ii < 128) {
          if ((hi -= 1) < 0) break;
          ho.push(Ii);
        } else if (Ii < 2048) {
          if ((hi -= 2) < 0) break;
          ho.push(
            Ii >> 6 | 192,
            Ii & 63 | 128
          );
        } else if (Ii < 65536) {
          if ((hi -= 3) < 0) break;
          ho.push(
            Ii >> 12 | 224,
            Ii >> 6 & 63 | 128,
            Ii & 63 | 128
          );
        } else if (Ii < 1114112) {
          if ((hi -= 4) < 0) break;
          ho.push(
            Ii >> 18 | 240,
            Ii >> 12 & 63 | 128,
            Ii >> 6 & 63 | 128,
            Ii & 63 | 128
          );
        } else
          throw new Error("Invalid code point");
      }
      return ho;
    }
    function Fo(Bn) {
      const hi = [];
      for (let Ii = 0; Ii < Bn.length; ++Ii)
        hi.push(Bn.charCodeAt(Ii) & 255);
      return hi;
    }
    function Zo(Bn, hi) {
      let Ii, Gi, kn;
      const ho = [];
      for (let eo = 0; eo < Bn.length && !((hi -= 2) < 0); ++eo)
        Ii = Bn.charCodeAt(eo), Gi = Ii >> 8, kn = Ii % 256, ho.push(kn), ho.push(Gi);
      return ho;
    }
    function $s(Bn) {
      return lr.toByteArray(To(Bn));
    }
    function rs(Bn, hi, Ii, Gi) {
      let kn;
      for (kn = 0; kn < Gi && !(kn + Ii >= hi.length || kn >= Bn.length); ++kn)
        hi[kn + Ii] = Bn[kn];
      return kn;
    }
    function ls(Bn, hi) {
      return Bn instanceof hi || Bn != null && Bn.constructor != null && Bn.constructor.name != null && Bn.constructor.name === hi.name;
    }
    function na(Bn) {
      return Bn !== Bn;
    }
    const os = function() {
      const Bn = "0123456789abcdef", hi = new Array(256);
      for (let Ii = 0; Ii < 16; ++Ii) {
        const Gi = Ii * 16;
        for (let kn = 0; kn < 16; ++kn)
          hi[Gi + kn] = Bn[Ii] + Bn[kn];
      }
      return hi;
    }();
    function fs(Bn) {
      return typeof BigInt > "u" ? da : Bn;
    }
    function da() {
      throw new Error("BigInt not supported");
    }
  })(c);
  const ir = c.Buffer;
  n.Blob = c.Blob, n.BlobOptions = c.BlobOptions, n.Buffer = c.Buffer, n.File = c.File, n.FileOptions = c.FileOptions, n.INSPECT_MAX_BYTES = c.INSPECT_MAX_BYTES, n.SlowBuffer = c.SlowBuffer, n.TranscodeEncoding = c.TranscodeEncoding, n.atob = c.atob, n.btoa = c.btoa, n.constants = c.constants, n.default = ir, n.isAscii = c.isAscii, n.isUtf8 = c.isUtf8, n.kMaxLength = c.kMaxLength, n.kStringMaxLength = c.kStringMaxLength, n.resolveObjectURL = c.resolveObjectURL, n.transcode = c.transcode;
})(dist$u);
var CryptoHDKey$d = {}, inherits_browser = { exports: {} };
typeof Object.create == "function" ? inherits_browser.exports = function(c, u) {
  u && (c.super_ = u, c.prototype = Object.create(u.prototype, {
    constructor: {
      value: c,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }));
} : inherits_browser.exports = function(c, u) {
  if (u) {
    c.super_ = u;
    var p = function() {
    };
    p.prototype = u.prototype, c.prototype = new p(), c.prototype.constructor = c;
  }
};
var inherits_browserExports = inherits_browser.exports, readableBrowser$1 = { exports: {} }, events = { exports: {} }, R$1 = typeof Reflect == "object" ? Reflect : null, ReflectApply = R$1 && typeof R$1.apply == "function" ? R$1.apply : function(c, u, p) {
  return Function.prototype.apply.call(c, u, p);
}, ReflectOwnKeys;
R$1 && typeof R$1.ownKeys == "function" ? ReflectOwnKeys = R$1.ownKeys : Object.getOwnPropertySymbols ? ReflectOwnKeys = function(c) {
  return Object.getOwnPropertyNames(c).concat(Object.getOwnPropertySymbols(c));
} : ReflectOwnKeys = function(c) {
  return Object.getOwnPropertyNames(c);
};
function ProcessEmitWarning(n) {
  console && console.warn && console.warn(n);
}
var NumberIsNaN = Number.isNaN || function(c) {
  return c !== c;
};
function EventEmitter$1() {
  EventEmitter$1.init.call(this);
}
events.exports = EventEmitter$1;
events.exports.once = once$2;
EventEmitter$1.EventEmitter = EventEmitter$1;
EventEmitter$1.prototype._events = void 0;
EventEmitter$1.prototype._eventsCount = 0;
EventEmitter$1.prototype._maxListeners = void 0;
var defaultMaxListeners = 10;
function checkListener(n) {
  if (typeof n != "function")
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof n);
}
Object.defineProperty(EventEmitter$1, "defaultMaxListeners", {
  enumerable: !0,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(n) {
    if (typeof n != "number" || n < 0 || NumberIsNaN(n))
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + n + ".");
    defaultMaxListeners = n;
  }
});
EventEmitter$1.init = function() {
  (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
EventEmitter$1.prototype.setMaxListeners = function(c) {
  if (typeof c != "number" || c < 0 || NumberIsNaN(c))
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + c + ".");
  return this._maxListeners = c, this;
};
function _getMaxListeners(n) {
  return n._maxListeners === void 0 ? EventEmitter$1.defaultMaxListeners : n._maxListeners;
}
EventEmitter$1.prototype.getMaxListeners = function() {
  return _getMaxListeners(this);
};
EventEmitter$1.prototype.emit = function(c) {
  for (var u = [], p = 1; p < arguments.length; p++) u.push(arguments[p]);
  var a = c === "error", A = this._events;
  if (A !== void 0)
    a = a && A.error === void 0;
  else if (!a)
    return !1;
  if (a) {
    var b;
    if (u.length > 0 && (b = u[0]), b instanceof Error)
      throw b;
    var F = new Error("Unhandled error." + (b ? " (" + b.message + ")" : ""));
    throw F.context = b, F;
  }
  var le = A[c];
  if (le === void 0)
    return !1;
  if (typeof le == "function")
    ReflectApply(le, this, u);
  else
    for (var L = le.length, pe = arrayClone(le, L), p = 0; p < L; ++p)
      ReflectApply(pe[p], this, u);
  return !0;
};
function _addListener(n, c, u, p) {
  var a, A, b;
  if (checkListener(u), A = n._events, A === void 0 ? (A = n._events = /* @__PURE__ */ Object.create(null), n._eventsCount = 0) : (A.newListener !== void 0 && (n.emit(
    "newListener",
    c,
    u.listener ? u.listener : u
  ), A = n._events), b = A[c]), b === void 0)
    b = A[c] = u, ++n._eventsCount;
  else if (typeof b == "function" ? b = A[c] = p ? [u, b] : [b, u] : p ? b.unshift(u) : b.push(u), a = _getMaxListeners(n), a > 0 && b.length > a && !b.warned) {
    b.warned = !0;
    var F = new Error("Possible EventEmitter memory leak detected. " + b.length + " " + String(c) + " listeners added. Use emitter.setMaxListeners() to increase limit");
    F.name = "MaxListenersExceededWarning", F.emitter = n, F.type = c, F.count = b.length, ProcessEmitWarning(F);
  }
  return n;
}
EventEmitter$1.prototype.addListener = function(c, u) {
  return _addListener(this, c, u, !1);
};
EventEmitter$1.prototype.on = EventEmitter$1.prototype.addListener;
EventEmitter$1.prototype.prependListener = function(c, u) {
  return _addListener(this, c, u, !0);
};
function onceWrapper() {
  if (!this.fired)
    return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function _onceWrap(n, c, u) {
  var p = { fired: !1, wrapFn: void 0, target: n, type: c, listener: u }, a = onceWrapper.bind(p);
  return a.listener = u, p.wrapFn = a, a;
}
EventEmitter$1.prototype.once = function(c, u) {
  return checkListener(u), this.on(c, _onceWrap(this, c, u)), this;
};
EventEmitter$1.prototype.prependOnceListener = function(c, u) {
  return checkListener(u), this.prependListener(c, _onceWrap(this, c, u)), this;
};
EventEmitter$1.prototype.removeListener = function(c, u) {
  var p, a, A, b, F;
  if (checkListener(u), a = this._events, a === void 0)
    return this;
  if (p = a[c], p === void 0)
    return this;
  if (p === u || p.listener === u)
    --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete a[c], a.removeListener && this.emit("removeListener", c, p.listener || u));
  else if (typeof p != "function") {
    for (A = -1, b = p.length - 1; b >= 0; b--)
      if (p[b] === u || p[b].listener === u) {
        F = p[b].listener, A = b;
        break;
      }
    if (A < 0)
      return this;
    A === 0 ? p.shift() : spliceOne(p, A), p.length === 1 && (a[c] = p[0]), a.removeListener !== void 0 && this.emit("removeListener", c, F || u);
  }
  return this;
};
EventEmitter$1.prototype.off = EventEmitter$1.prototype.removeListener;
EventEmitter$1.prototype.removeAllListeners = function(c) {
  var u, p, a;
  if (p = this._events, p === void 0)
    return this;
  if (p.removeListener === void 0)
    return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : p[c] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete p[c]), this;
  if (arguments.length === 0) {
    var A = Object.keys(p), b;
    for (a = 0; a < A.length; ++a)
      b = A[a], b !== "removeListener" && this.removeAllListeners(b);
    return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
  }
  if (u = p[c], typeof u == "function")
    this.removeListener(c, u);
  else if (u !== void 0)
    for (a = u.length - 1; a >= 0; a--)
      this.removeListener(c, u[a]);
  return this;
};
function _listeners(n, c, u) {
  var p = n._events;
  if (p === void 0)
    return [];
  var a = p[c];
  return a === void 0 ? [] : typeof a == "function" ? u ? [a.listener || a] : [a] : u ? unwrapListeners(a) : arrayClone(a, a.length);
}
EventEmitter$1.prototype.listeners = function(c) {
  return _listeners(this, c, !0);
};
EventEmitter$1.prototype.rawListeners = function(c) {
  return _listeners(this, c, !1);
};
EventEmitter$1.listenerCount = function(n, c) {
  return typeof n.listenerCount == "function" ? n.listenerCount(c) : listenerCount.call(n, c);
};
EventEmitter$1.prototype.listenerCount = listenerCount;
function listenerCount(n) {
  var c = this._events;
  if (c !== void 0) {
    var u = c[n];
    if (typeof u == "function")
      return 1;
    if (u !== void 0)
      return u.length;
  }
  return 0;
}
EventEmitter$1.prototype.eventNames = function() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};
function arrayClone(n, c) {
  for (var u = new Array(c), p = 0; p < c; ++p)
    u[p] = n[p];
  return u;
}
function spliceOne(n, c) {
  for (; c + 1 < n.length; c++)
    n[c] = n[c + 1];
  n.pop();
}
function unwrapListeners(n) {
  for (var c = new Array(n.length), u = 0; u < c.length; ++u)
    c[u] = n[u].listener || n[u];
  return c;
}
function once$2(n, c) {
  return new Promise(function(u, p) {
    function a(b) {
      n.removeListener(c, A), p(b);
    }
    function A() {
      typeof n.removeListener == "function" && n.removeListener("error", a), u([].slice.call(arguments));
    }
    eventTargetAgnosticAddListener(n, c, A, { once: !0 }), c !== "error" && addErrorHandlerIfEventEmitter(n, a, { once: !0 });
  });
}
function addErrorHandlerIfEventEmitter(n, c, u) {
  typeof n.on == "function" && eventTargetAgnosticAddListener(n, "error", c, u);
}
function eventTargetAgnosticAddListener(n, c, u, p) {
  if (typeof n.on == "function")
    p.once ? n.once(c, u) : n.on(c, u);
  else if (typeof n.addEventListener == "function")
    n.addEventListener(c, function a(A) {
      p.once && n.removeEventListener(c, a), u(A);
    });
  else
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof n);
}
var eventsExports = events.exports;
const EventEmitter$2 = /* @__PURE__ */ getDefaultExportFromCjs(eventsExports);
var streamBrowser$1 = eventsExports.EventEmitter, util$8 = {}, types$j = {}, shams$1 = function() {
  if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
    return !1;
  if (typeof Symbol.iterator == "symbol")
    return !0;
  var c = {}, u = Symbol("test"), p = Object(u);
  if (typeof u == "string" || Object.prototype.toString.call(u) !== "[object Symbol]" || Object.prototype.toString.call(p) !== "[object Symbol]")
    return !1;
  var a = 42;
  c[u] = a;
  for (var A in c)
    return !1;
  if (typeof Object.keys == "function" && Object.keys(c).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(c).length !== 0)
    return !1;
  var b = Object.getOwnPropertySymbols(c);
  if (b.length !== 1 || b[0] !== u || !Object.prototype.propertyIsEnumerable.call(c, u))
    return !1;
  if (typeof Object.getOwnPropertyDescriptor == "function") {
    var F = (
      /** @type {PropertyDescriptor} */
      Object.getOwnPropertyDescriptor(c, u)
    );
    if (F.value !== a || F.enumerable !== !0)
      return !1;
  }
  return !0;
}, hasSymbols$3 = shams$1, shams = function() {
  return hasSymbols$3() && !!Symbol.toStringTag;
}, esObjectAtoms = Object, esErrors = Error, _eval = EvalError, range$1 = RangeError, ref = ReferenceError, syntax = SyntaxError, type = TypeError, uri = URIError, abs$1 = Math.abs, floor$1 = Math.floor, max$1 = Math.max, min$1 = Math.min, pow$3 = Math.pow, gOPD$2 = Object.getOwnPropertyDescriptor, $gOPD$1 = gOPD$2;
if ($gOPD$1)
  try {
    $gOPD$1([], "length");
  } catch {
    $gOPD$1 = null;
  }
var gopd$1 = $gOPD$1, $defineProperty$3 = Object.defineProperty || !1;
if ($defineProperty$3)
  try {
    $defineProperty$3({}, "a", { value: 1 });
  } catch {
    $defineProperty$3 = !1;
  }
var esDefineProperty = $defineProperty$3, hasSymbols$2, hasRequiredHasSymbols;
function requireHasSymbols() {
  if (hasRequiredHasSymbols) return hasSymbols$2;
  hasRequiredHasSymbols = 1;
  var n = typeof Symbol < "u" && Symbol, c = shams$1;
  return hasSymbols$2 = function() {
    return typeof n != "function" || typeof Symbol != "function" || typeof n("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : c();
  }, hasSymbols$2;
}
var implementation$6, hasRequiredImplementation$2;
function requireImplementation$2() {
  if (hasRequiredImplementation$2) return implementation$6;
  hasRequiredImplementation$2 = 1;
  var n = "Function.prototype.bind called on incompatible ", c = Object.prototype.toString, u = Math.max, p = "[object Function]", a = function(le, L) {
    for (var pe = [], $ = 0; $ < le.length; $ += 1)
      pe[$] = le[$];
    for (var Ee = 0; Ee < L.length; Ee += 1)
      pe[Ee + le.length] = L[Ee];
    return pe;
  }, A = function(le, L) {
    for (var pe = [], $ = L, Ee = 0; $ < le.length; $ += 1, Ee += 1)
      pe[Ee] = le[$];
    return pe;
  }, b = function(F, le) {
    for (var L = "", pe = 0; pe < F.length; pe += 1)
      L += F[pe], pe + 1 < F.length && (L += le);
    return L;
  };
  return implementation$6 = function(le) {
    var L = this;
    if (typeof L != "function" || c.apply(L) !== p)
      throw new TypeError(n + L);
    for (var pe = A(arguments, 1), $, Ee = function() {
      if (this instanceof $) {
        var ir = L.apply(
          this,
          a(pe, arguments)
        );
        return Object(ir) === ir ? ir : this;
      }
      return L.apply(
        le,
        a(pe, arguments)
      );
    }, be = u(0, L.length - pe.length), He = [], Pe = 0; Pe < be; Pe++)
      He[Pe] = "$" + Pe;
    if ($ = Function("binder", "return function (" + b(He, ",") + "){ return binder.apply(this,arguments); }")(Ee), L.prototype) {
      var nr = function() {
      };
      nr.prototype = L.prototype, $.prototype = new nr(), nr.prototype = null;
    }
    return $;
  }, implementation$6;
}
var functionBind, hasRequiredFunctionBind;
function requireFunctionBind() {
  if (hasRequiredFunctionBind) return functionBind;
  hasRequiredFunctionBind = 1;
  var n = requireImplementation$2();
  return functionBind = Function.prototype.bind || n, functionBind;
}
var functionCall, hasRequiredFunctionCall;
function requireFunctionCall() {
  return hasRequiredFunctionCall || (hasRequiredFunctionCall = 1, functionCall = Function.prototype.call), functionCall;
}
var functionApply, hasRequiredFunctionApply;
function requireFunctionApply() {
  return hasRequiredFunctionApply || (hasRequiredFunctionApply = 1, functionApply = Function.prototype.apply), functionApply;
}
var reflectApply$1 = typeof Reflect < "u" && Reflect && Reflect.apply, bind$3 = requireFunctionBind(), $apply$2 = requireFunctionApply(), $call$2 = requireFunctionCall(), $reflectApply = reflectApply$1, actualApply$1 = $reflectApply || bind$3.call($call$2, $apply$2), bind$2 = requireFunctionBind(), $TypeError$3 = type, $call$1 = requireFunctionCall(), $actualApply = actualApply$1, callBindApplyHelpers = function(c) {
  if (c.length < 1 || typeof c[0] != "function")
    throw new $TypeError$3("a function is required");
  return $actualApply(bind$2, $call$1, c);
}, get, hasRequiredGet;
function requireGet() {
  if (hasRequiredGet) return get;
  hasRequiredGet = 1;
  var n = callBindApplyHelpers, c = gopd$1, u;
  try {
    u = /** @type {{ __proto__?: typeof Array.prototype }} */
    [].__proto__ === Array.prototype;
  } catch (b) {
    if (!b || typeof b != "object" || !("code" in b) || b.code !== "ERR_PROTO_ACCESS")
      throw b;
  }
  var p = !!u && c && c(
    Object.prototype,
    /** @type {keyof typeof Object.prototype} */
    "__proto__"
  ), a = Object, A = a.getPrototypeOf;
  return get = p && typeof p.get == "function" ? n([p.get]) : typeof A == "function" ? (
    /** @type {import('./get')} */
    function(F) {
      return A(F == null ? F : a(F));
    }
  ) : !1, get;
}
var hasown, hasRequiredHasown;
function requireHasown() {
  if (hasRequiredHasown) return hasown;
  hasRequiredHasown = 1;
  var n = Function.prototype.call, c = Object.prototype.hasOwnProperty, u = requireFunctionBind();
  return hasown = u.call(n, c), hasown;
}
var undefined$1, $Object$1 = esObjectAtoms, $Error = esErrors, $EvalError = _eval, $RangeError = range$1, $ReferenceError = ref, $SyntaxError$1 = syntax, $TypeError$2 = type, $URIError = uri, abs = abs$1, floor = floor$1, max = max$1, min = min$1, pow$2 = pow$3, $Function = Function, getEvalledConstructor = function(n) {
  try {
    return $Function('"use strict"; return (' + n + ").constructor;")();
  } catch {
  }
}, $gOPD = gopd$1, $defineProperty$2 = esDefineProperty, throwTypeError = function() {
  throw new $TypeError$2();
}, ThrowTypeError = $gOPD ? function() {
  try {
    return arguments.callee, throwTypeError;
  } catch {
    try {
      return $gOPD(arguments, "callee").get;
    } catch {
      return throwTypeError;
    }
  }
}() : throwTypeError, hasSymbols$1 = requireHasSymbols()(), getDunderProto = requireGet(), getProto$1 = typeof Reflect == "function" && Reflect.getPrototypeOf || $Object$1.getPrototypeOf || getDunderProto, $apply$1 = requireFunctionApply(), $call = requireFunctionCall(), needsEval = {}, TypedArray = typeof Uint8Array > "u" || !getProto$1 ? undefined$1 : getProto$1(Uint8Array), INTRINSICS = {
  __proto__: null,
  "%AggregateError%": typeof AggregateError > "u" ? undefined$1 : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer > "u" ? undefined$1 : ArrayBuffer,
  "%ArrayIteratorPrototype%": hasSymbols$1 && getProto$1 ? getProto$1([][Symbol.iterator]()) : undefined$1,
  "%AsyncFromSyncIteratorPrototype%": undefined$1,
  "%AsyncFunction%": needsEval,
  "%AsyncGenerator%": needsEval,
  "%AsyncGeneratorFunction%": needsEval,
  "%AsyncIteratorPrototype%": needsEval,
  "%Atomics%": typeof Atomics > "u" ? undefined$1 : Atomics,
  "%BigInt%": typeof BigInt > "u" ? undefined$1 : BigInt,
  "%BigInt64Array%": typeof BigInt64Array > "u" ? undefined$1 : BigInt64Array,
  "%BigUint64Array%": typeof BigUint64Array > "u" ? undefined$1 : BigUint64Array,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView > "u" ? undefined$1 : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": $Error,
  "%eval%": eval,
  // eslint-disable-line no-eval
  "%EvalError%": $EvalError,
  "%Float32Array%": typeof Float32Array > "u" ? undefined$1 : Float32Array,
  "%Float64Array%": typeof Float64Array > "u" ? undefined$1 : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? undefined$1 : FinalizationRegistry,
  "%Function%": $Function,
  "%GeneratorFunction%": needsEval,
  "%Int8Array%": typeof Int8Array > "u" ? undefined$1 : Int8Array,
  "%Int16Array%": typeof Int16Array > "u" ? undefined$1 : Int16Array,
  "%Int32Array%": typeof Int32Array > "u" ? undefined$1 : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": hasSymbols$1 && getProto$1 ? getProto$1(getProto$1([][Symbol.iterator]())) : undefined$1,
  "%JSON%": typeof JSON == "object" ? JSON : undefined$1,
  "%Map%": typeof Map > "u" ? undefined$1 : Map,
  "%MapIteratorPrototype%": typeof Map > "u" || !hasSymbols$1 || !getProto$1 ? undefined$1 : getProto$1((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": $Object$1,
  "%Object.getOwnPropertyDescriptor%": $gOPD,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise > "u" ? undefined$1 : Promise,
  "%Proxy%": typeof Proxy > "u" ? undefined$1 : Proxy,
  "%RangeError%": $RangeError,
  "%ReferenceError%": $ReferenceError,
  "%Reflect%": typeof Reflect > "u" ? undefined$1 : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set > "u" ? undefined$1 : Set,
  "%SetIteratorPrototype%": typeof Set > "u" || !hasSymbols$1 || !getProto$1 ? undefined$1 : getProto$1((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? undefined$1 : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": hasSymbols$1 && getProto$1 ? getProto$1(""[Symbol.iterator]()) : undefined$1,
  "%Symbol%": hasSymbols$1 ? Symbol : undefined$1,
  "%SyntaxError%": $SyntaxError$1,
  "%ThrowTypeError%": ThrowTypeError,
  "%TypedArray%": TypedArray,
  "%TypeError%": $TypeError$2,
  "%Uint8Array%": typeof Uint8Array > "u" ? undefined$1 : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? undefined$1 : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array > "u" ? undefined$1 : Uint16Array,
  "%Uint32Array%": typeof Uint32Array > "u" ? undefined$1 : Uint32Array,
  "%URIError%": $URIError,
  "%WeakMap%": typeof WeakMap > "u" ? undefined$1 : WeakMap,
  "%WeakRef%": typeof WeakRef > "u" ? undefined$1 : WeakRef,
  "%WeakSet%": typeof WeakSet > "u" ? undefined$1 : WeakSet,
  "%Function.prototype.call%": $call,
  "%Function.prototype.apply%": $apply$1,
  "%Object.defineProperty%": $defineProperty$2,
  "%Math.abs%": abs,
  "%Math.floor%": floor,
  "%Math.max%": max,
  "%Math.min%": min,
  "%Math.pow%": pow$2
};
if (getProto$1)
  try {
    null.error;
  } catch (n) {
    var errorProto = getProto$1(getProto$1(n));
    INTRINSICS["%Error.prototype%"] = errorProto;
  }
var doEval = function n(c) {
  var u;
  if (c === "%AsyncFunction%")
    u = getEvalledConstructor("async function () {}");
  else if (c === "%GeneratorFunction%")
    u = getEvalledConstructor("function* () {}");
  else if (c === "%AsyncGeneratorFunction%")
    u = getEvalledConstructor("async function* () {}");
  else if (c === "%AsyncGenerator%") {
    var p = n("%AsyncGeneratorFunction%");
    p && (u = p.prototype);
  } else if (c === "%AsyncIteratorPrototype%") {
    var a = n("%AsyncGenerator%");
    a && getProto$1 && (u = getProto$1(a.prototype));
  }
  return INTRINSICS[c] = u, u;
}, LEGACY_ALIASES = {
  __proto__: null,
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
}, bind$1 = requireFunctionBind(), hasOwn = requireHasown(), $concat = bind$1.call($call, Array.prototype.concat), $spliceApply = bind$1.call($apply$1, Array.prototype.splice), $replace = bind$1.call($call, String.prototype.replace), $strSlice = bind$1.call($call, String.prototype.slice), $exec = bind$1.call($call, RegExp.prototype.exec), rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, reEscapeChar = /\\(\\)?/g, stringToPath = function(c) {
  var u = $strSlice(c, 0, 1), p = $strSlice(c, -1);
  if (u === "%" && p !== "%")
    throw new $SyntaxError$1("invalid intrinsic syntax, expected closing `%`");
  if (p === "%" && u !== "%")
    throw new $SyntaxError$1("invalid intrinsic syntax, expected opening `%`");
  var a = [];
  return $replace(c, rePropName, function(A, b, F, le) {
    a[a.length] = F ? $replace(le, reEscapeChar, "$1") : b || A;
  }), a;
}, getBaseIntrinsic = function(c, u) {
  var p = c, a;
  if (hasOwn(LEGACY_ALIASES, p) && (a = LEGACY_ALIASES[p], p = "%" + a[0] + "%"), hasOwn(INTRINSICS, p)) {
    var A = INTRINSICS[p];
    if (A === needsEval && (A = doEval(p)), typeof A > "u" && !u)
      throw new $TypeError$2("intrinsic " + c + " exists, but is not available. Please file an issue!");
    return {
      alias: a,
      name: p,
      value: A
    };
  }
  throw new $SyntaxError$1("intrinsic " + c + " does not exist!");
}, getIntrinsic = function(c, u) {
  if (typeof c != "string" || c.length === 0)
    throw new $TypeError$2("intrinsic name must be a non-empty string");
  if (arguments.length > 1 && typeof u != "boolean")
    throw new $TypeError$2('"allowMissing" argument must be a boolean');
  if ($exec(/^%?[^%]*%?$/, c) === null)
    throw new $SyntaxError$1("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  var p = stringToPath(c), a = p.length > 0 ? p[0] : "", A = getBaseIntrinsic("%" + a + "%", u), b = A.name, F = A.value, le = !1, L = A.alias;
  L && (a = L[0], $spliceApply(p, $concat([0, 1], L)));
  for (var pe = 1, $ = !0; pe < p.length; pe += 1) {
    var Ee = p[pe], be = $strSlice(Ee, 0, 1), He = $strSlice(Ee, -1);
    if ((be === '"' || be === "'" || be === "`" || He === '"' || He === "'" || He === "`") && be !== He)
      throw new $SyntaxError$1("property names with quotes must have matching quotes");
    if ((Ee === "constructor" || !$) && (le = !0), a += "." + Ee, b = "%" + a + "%", hasOwn(INTRINSICS, b))
      F = INTRINSICS[b];
    else if (F != null) {
      if (!(Ee in F)) {
        if (!u)
          throw new $TypeError$2("base intrinsic for " + c + " exists, but the property is not available.");
        return;
      }
      if ($gOPD && pe + 1 >= p.length) {
        var Pe = $gOPD(F, Ee);
        $ = !!Pe, $ && "get" in Pe && !("originalValue" in Pe.get) ? F = Pe.get : F = F[Ee];
      } else
        $ = hasOwn(F, Ee), F = F[Ee];
      $ && !le && (INTRINSICS[b] = F);
    }
  }
  return F;
}, GetIntrinsic$2 = getIntrinsic, callBindBasic = callBindApplyHelpers, $indexOf$2 = callBindBasic([GetIntrinsic$2("%String.prototype.indexOf%")]), callBound$4 = function(c, u) {
  var p = (
    /** @type {Parameters<typeof callBindBasic>[0][0]} */
    GetIntrinsic$2(c, !!u)
  );
  return typeof p == "function" && $indexOf$2(c, ".prototype.") > -1 ? callBindBasic([p]) : p;
}, hasToStringTag$3 = shams(), callBound$3 = callBound$4, $toString$1 = callBound$3("Object.prototype.toString"), isStandardArguments = function(c) {
  return hasToStringTag$3 && c && typeof c == "object" && Symbol.toStringTag in c ? !1 : $toString$1(c) === "[object Arguments]";
}, isLegacyArguments = function(c) {
  return isStandardArguments(c) ? !0 : c !== null && typeof c == "object" && "length" in c && typeof c.length == "number" && c.length >= 0 && $toString$1(c) !== "[object Array]" && "callee" in c && $toString$1(c.callee) === "[object Function]";
}, supportsStandardArguments = function() {
  return isStandardArguments(arguments);
}();
isStandardArguments.isLegacyArguments = isLegacyArguments;
var isArguments$1 = supportsStandardArguments ? isStandardArguments : isLegacyArguments, toStr$3 = Object.prototype.toString, fnToStr$1 = Function.prototype.toString, isFnRegex = /^\s*(?:function)?\*/, hasToStringTag$2 = shams(), getProto = Object.getPrototypeOf, getGeneratorFunc = function() {
  if (!hasToStringTag$2)
    return !1;
  try {
    return Function("return function*() {}")();
  } catch {
  }
}, GeneratorFunction, isGeneratorFunction = function(c) {
  if (typeof c != "function")
    return !1;
  if (isFnRegex.test(fnToStr$1.call(c)))
    return !0;
  if (!hasToStringTag$2) {
    var u = toStr$3.call(c);
    return u === "[object GeneratorFunction]";
  }
  if (!getProto)
    return !1;
  if (typeof GeneratorFunction > "u") {
    var p = getGeneratorFunc();
    GeneratorFunction = p ? getProto(p) : !1;
  }
  return getProto(c) === GeneratorFunction;
}, fnToStr = Function.prototype.toString, reflectApply = typeof Reflect == "object" && Reflect !== null && Reflect.apply, badArrayLike, isCallableMarker;
if (typeof reflectApply == "function" && typeof Object.defineProperty == "function")
  try {
    badArrayLike = Object.defineProperty({}, "length", {
      get: function() {
        throw isCallableMarker;
      }
    }), isCallableMarker = {}, reflectApply(function() {
      throw 42;
    }, null, badArrayLike);
  } catch (n) {
    n !== isCallableMarker && (reflectApply = null);
  }
else
  reflectApply = null;
var constructorRegex = /^\s*class\b/, isES6ClassFn = function(c) {
  try {
    var u = fnToStr.call(c);
    return constructorRegex.test(u);
  } catch {
    return !1;
  }
}, tryFunctionObject = function(c) {
  try {
    return isES6ClassFn(c) ? !1 : (fnToStr.call(c), !0);
  } catch {
    return !1;
  }
}, toStr$2 = Object.prototype.toString, objectClass = "[object Object]", fnClass = "[object Function]", genClass = "[object GeneratorFunction]", ddaClass = "[object HTMLAllCollection]", ddaClass2 = "[object HTML document.all class]", ddaClass3 = "[object HTMLCollection]", hasToStringTag$1 = typeof Symbol == "function" && !!Symbol.toStringTag, isIE68 = !(0 in [,]), isDDA = function() {
  return !1;
};
if (typeof document == "object") {
  var all = document.all;
  toStr$2.call(all) === toStr$2.call(document.all) && (isDDA = function(c) {
    if ((isIE68 || !c) && (typeof c > "u" || typeof c == "object"))
      try {
        var u = toStr$2.call(c);
        return (u === ddaClass || u === ddaClass2 || u === ddaClass3 || u === objectClass) && c("") == null;
      } catch {
      }
    return !1;
  });
}
var isCallable$1 = reflectApply ? function(c) {
  if (isDDA(c))
    return !0;
  if (!c || typeof c != "function" && typeof c != "object")
    return !1;
  try {
    reflectApply(c, null, badArrayLike);
  } catch (u) {
    if (u !== isCallableMarker)
      return !1;
  }
  return !isES6ClassFn(c) && tryFunctionObject(c);
} : function(c) {
  if (isDDA(c))
    return !0;
  if (!c || typeof c != "function" && typeof c != "object")
    return !1;
  if (hasToStringTag$1)
    return tryFunctionObject(c);
  if (isES6ClassFn(c))
    return !1;
  var u = toStr$2.call(c);
  return u !== fnClass && u !== genClass && !/^\[object HTML/.test(u) ? !1 : tryFunctionObject(c);
}, isCallable = isCallable$1, toStr$1 = Object.prototype.toString, hasOwnProperty = Object.prototype.hasOwnProperty, forEachArray = function(c, u, p) {
  for (var a = 0, A = c.length; a < A; a++)
    hasOwnProperty.call(c, a) && (p == null ? u(c[a], a, c) : u.call(p, c[a], a, c));
}, forEachString = function(c, u, p) {
  for (var a = 0, A = c.length; a < A; a++)
    p == null ? u(c.charAt(a), a, c) : u.call(p, c.charAt(a), a, c);
}, forEachObject = function(c, u, p) {
  for (var a in c)
    hasOwnProperty.call(c, a) && (p == null ? u(c[a], a, c) : u.call(p, c[a], a, c));
}, forEach$1 = function(c, u, p) {
  if (!isCallable(u))
    throw new TypeError("iterator must be a function");
  var a;
  arguments.length >= 3 && (a = p), toStr$1.call(c) === "[object Array]" ? forEachArray(c, u, a) : typeof c == "string" ? forEachString(c, u, a) : forEachObject(c, u, a);
}, forEach_1 = forEach$1, possibleTypedArrayNames = [
  "Float32Array",
  "Float64Array",
  "Int8Array",
  "Int16Array",
  "Int32Array",
  "Uint8Array",
  "Uint8ClampedArray",
  "Uint16Array",
  "Uint32Array",
  "BigInt64Array",
  "BigUint64Array"
], possibleNames = possibleTypedArrayNames, g$1 = typeof globalThis > "u" ? commonjsGlobal : globalThis, availableTypedArrays$1 = function() {
  for (var c = [], u = 0; u < possibleNames.length; u++)
    typeof g$1[possibleNames[u]] == "function" && (c[c.length] = possibleNames[u]);
  return c;
}, callBind$2 = { exports: {} }, $defineProperty$1 = esDefineProperty, $SyntaxError = syntax, $TypeError$1 = type, gopd = gopd$1, defineDataProperty = function(c, u, p) {
  if (!c || typeof c != "object" && typeof c != "function")
    throw new $TypeError$1("`obj` must be an object or a function`");
  if (typeof u != "string" && typeof u != "symbol")
    throw new $TypeError$1("`property` must be a string or a symbol`");
  if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
    throw new $TypeError$1("`nonEnumerable`, if provided, must be a boolean or null");
  if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
    throw new $TypeError$1("`nonWritable`, if provided, must be a boolean or null");
  if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
    throw new $TypeError$1("`nonConfigurable`, if provided, must be a boolean or null");
  if (arguments.length > 6 && typeof arguments[6] != "boolean")
    throw new $TypeError$1("`loose`, if provided, must be a boolean");
  var a = arguments.length > 3 ? arguments[3] : null, A = arguments.length > 4 ? arguments[4] : null, b = arguments.length > 5 ? arguments[5] : null, F = arguments.length > 6 ? arguments[6] : !1, le = !!gopd && gopd(c, u);
  if ($defineProperty$1)
    $defineProperty$1(c, u, {
      configurable: b === null && le ? le.configurable : !b,
      enumerable: a === null && le ? le.enumerable : !a,
      value: p,
      writable: A === null && le ? le.writable : !A
    });
  else if (F || !a && !A && !b)
    c[u] = p;
  else
    throw new $SyntaxError("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
}, $defineProperty = esDefineProperty, hasPropertyDescriptors = function() {
  return !!$defineProperty;
};
hasPropertyDescriptors.hasArrayLengthDefineBug = function() {
  if (!$defineProperty)
    return null;
  try {
    return $defineProperty([], "length", { value: 1 }).length !== 1;
  } catch {
    return !0;
  }
};
var hasPropertyDescriptors_1 = hasPropertyDescriptors, GetIntrinsic$1 = getIntrinsic, define = defineDataProperty, hasDescriptors = hasPropertyDescriptors_1(), gOPD$1 = gopd$1, $TypeError = type, $floor = GetIntrinsic$1("%Math.floor%"), setFunctionLength = function(c, u) {
  if (typeof c != "function")
    throw new $TypeError("`fn` is not a function");
  if (typeof u != "number" || u < 0 || u > 4294967295 || $floor(u) !== u)
    throw new $TypeError("`length` must be a positive 32-bit integer");
  var p = arguments.length > 2 && !!arguments[2], a = !0, A = !0;
  if ("length" in c && gOPD$1) {
    var b = gOPD$1(c, "length");
    b && !b.configurable && (a = !1), b && !b.writable && (A = !1);
  }
  return (a || A || !p) && (hasDescriptors ? define(
    /** @type {Parameters<define>[0]} */
    c,
    "length",
    u,
    !0,
    !0
  ) : define(
    /** @type {Parameters<define>[0]} */
    c,
    "length",
    u
  )), c;
}, bind = requireFunctionBind(), $apply = requireFunctionApply(), actualApply = actualApply$1, applyBind = function() {
  return actualApply(bind, $apply, arguments);
};
(function(n) {
  var c = setFunctionLength, u = esDefineProperty, p = callBindApplyHelpers, a = applyBind;
  n.exports = function(b) {
    var F = p(arguments), le = b.length - (arguments.length - 1);
    return c(
      F,
      1 + (le > 0 ? le : 0),
      !0
    );
  }, u ? u(n.exports, "apply", { value: a }) : n.exports.apply = a;
})(callBind$2);
var callBindExports = callBind$2.exports, forEach = forEach_1, availableTypedArrays = availableTypedArrays$1, callBind$1 = callBindExports, callBound$2 = callBound$4, gOPD = gopd$1, $toString = callBound$2("Object.prototype.toString"), hasToStringTag = shams(), g = typeof globalThis > "u" ? commonjsGlobal : globalThis, typedArrays = availableTypedArrays(), $slice = callBound$2("String.prototype.slice"), getPrototypeOf = Object.getPrototypeOf, $indexOf$1 = callBound$2("Array.prototype.indexOf", !0) || function(c, u) {
  for (var p = 0; p < c.length; p += 1)
    if (c[p] === u)
      return p;
  return -1;
}, cache = { __proto__: null };
hasToStringTag && gOPD && getPrototypeOf ? forEach(typedArrays, function(n) {
  var c = new g[n]();
  if (Symbol.toStringTag in c) {
    var u = getPrototypeOf(c), p = gOPD(u, Symbol.toStringTag);
    if (!p) {
      var a = getPrototypeOf(u);
      p = gOPD(a, Symbol.toStringTag);
    }
    cache["$" + n] = callBind$1(p.get);
  }
}) : forEach(typedArrays, function(n) {
  var c = new g[n](), u = c.slice || c.set;
  u && (cache["$" + n] = callBind$1(u));
});
var tryTypedArrays = function(c) {
  var u = !1;
  return forEach(
    // eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */
    /** @type {any} */
    cache,
    /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */
    function(p, a) {
      if (!u)
        try {
          "$" + p(c) === a && (u = $slice(a, 1));
        } catch {
        }
    }
  ), u;
}, trySlices = function(c) {
  var u = !1;
  return forEach(
    // eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */
    /** @type {any} */
    cache,
    /** @type {(getter: typeof cache, name: `\$${import('.').TypedArrayName}`) => void} */
    function(p, a) {
      if (!u)
        try {
          p(c), u = $slice(a, 1);
        } catch {
        }
    }
  ), u;
}, whichTypedArray$1 = function(c) {
  if (!c || typeof c != "object")
    return !1;
  if (!hasToStringTag) {
    var u = $slice($toString(c), 8, -1);
    return $indexOf$1(typedArrays, u) > -1 ? u : u !== "Object" ? !1 : trySlices(c);
  }
  return gOPD ? tryTypedArrays(c) : null;
}, whichTypedArray = whichTypedArray$1, isTypedArray = function(c) {
  return !!whichTypedArray(c);
};
(function(n) {
  var c = isArguments$1, u = isGeneratorFunction, p = whichTypedArray$1, a = isTypedArray;
  function A(Di) {
    return Di.call.bind(Di);
  }
  var b = typeof BigInt < "u", F = typeof Symbol < "u", le = A(Object.prototype.toString), L = A(Number.prototype.valueOf), pe = A(String.prototype.valueOf), $ = A(Boolean.prototype.valueOf);
  if (b)
    var Ee = A(BigInt.prototype.valueOf);
  if (F)
    var be = A(Symbol.prototype.valueOf);
  function He(Di, _n) {
    if (typeof Di != "object")
      return !1;
    try {
      return _n(Di), !0;
    } catch {
      return !1;
    }
  }
  n.isArgumentsObject = c, n.isGeneratorFunction = u, n.isTypedArray = a;
  function Pe(Di) {
    return typeof Promise < "u" && Di instanceof Promise || Di !== null && typeof Di == "object" && typeof Di.then == "function" && typeof Di.catch == "function";
  }
  n.isPromise = Pe;
  function nr(Di) {
    return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(Di) : a(Di) || si(Di);
  }
  n.isArrayBufferView = nr;
  function ir(Di) {
    return p(Di) === "Uint8Array";
  }
  n.isUint8Array = ir;
  function or(Di) {
    return p(Di) === "Uint8ClampedArray";
  }
  n.isUint8ClampedArray = or;
  function lr(Di) {
    return p(Di) === "Uint16Array";
  }
  n.isUint16Array = lr;
  function Ir(Di) {
    return p(Di) === "Uint32Array";
  }
  n.isUint32Array = Ir;
  function xr(Di) {
    return p(Di) === "Int8Array";
  }
  n.isInt8Array = xr;
  function kr(Di) {
    return p(Di) === "Int16Array";
  }
  n.isInt16Array = kr;
  function Ce(Di) {
    return p(Di) === "Int32Array";
  }
  n.isInt32Array = Ce;
  function tr(Di) {
    return p(Di) === "Float32Array";
  }
  n.isFloat32Array = tr;
  function Fe(Di) {
    return p(Di) === "Float64Array";
  }
  n.isFloat64Array = Fe;
  function Sr(Di) {
    return p(Di) === "BigInt64Array";
  }
  n.isBigInt64Array = Sr;
  function er(Di) {
    return p(Di) === "BigUint64Array";
  }
  n.isBigUint64Array = er;
  function Ie(Di) {
    return le(Di) === "[object Map]";
  }
  Ie.working = typeof Map < "u" && Ie(/* @__PURE__ */ new Map());
  function xe(Di) {
    return typeof Map > "u" ? !1 : Ie.working ? Ie(Di) : Di instanceof Map;
  }
  n.isMap = xe;
  function rr(Di) {
    return le(Di) === "[object Set]";
  }
  rr.working = typeof Set < "u" && rr(/* @__PURE__ */ new Set());
  function ar(Di) {
    return typeof Set > "u" ? !1 : rr.working ? rr(Di) : Di instanceof Set;
  }
  n.isSet = ar;
  function yr(Di) {
    return le(Di) === "[object WeakMap]";
  }
  yr.working = typeof WeakMap < "u" && yr(/* @__PURE__ */ new WeakMap());
  function _r(Di) {
    return typeof WeakMap > "u" ? !1 : yr.working ? yr(Di) : Di instanceof WeakMap;
  }
  n.isWeakMap = _r;
  function Or(Di) {
    return le(Di) === "[object WeakSet]";
  }
  Or.working = typeof WeakSet < "u" && Or(/* @__PURE__ */ new WeakSet());
  function vr(Di) {
    return Or(Di);
  }
  n.isWeakSet = vr;
  function Te(Di) {
    return le(Di) === "[object ArrayBuffer]";
  }
  Te.working = typeof ArrayBuffer < "u" && Te(new ArrayBuffer());
  function Cr(Di) {
    return typeof ArrayBuffer > "u" ? !1 : Te.working ? Te(Di) : Di instanceof ArrayBuffer;
  }
  n.isArrayBuffer = Cr;
  function Hr(Di) {
    return le(Di) === "[object DataView]";
  }
  Hr.working = typeof ArrayBuffer < "u" && typeof DataView < "u" && Hr(new DataView(new ArrayBuffer(1), 0, 1));
  function si(Di) {
    return typeof DataView > "u" ? !1 : Hr.working ? Hr(Di) : Di instanceof DataView;
  }
  n.isDataView = si;
  var ui = typeof SharedArrayBuffer < "u" ? SharedArrayBuffer : void 0;
  function Li(Di) {
    return le(Di) === "[object SharedArrayBuffer]";
  }
  function Qi(Di) {
    return typeof ui > "u" ? !1 : (typeof Li.working > "u" && (Li.working = Li(new ui())), Li.working ? Li(Di) : Di instanceof ui);
  }
  n.isSharedArrayBuffer = Qi;
  function wi(Di) {
    return le(Di) === "[object AsyncFunction]";
  }
  n.isAsyncFunction = wi;
  function Ji(Di) {
    return le(Di) === "[object Map Iterator]";
  }
  n.isMapIterator = Ji;
  function mn(Di) {
    return le(Di) === "[object Set Iterator]";
  }
  n.isSetIterator = mn;
  function pi(Di) {
    return le(Di) === "[object Generator]";
  }
  n.isGeneratorObject = pi;
  function ei(Di) {
    return le(Di) === "[object WebAssembly.Module]";
  }
  n.isWebAssemblyCompiledModule = ei;
  function Vr(Di) {
    return He(Di, L);
  }
  n.isNumberObject = Vr;
  function qr(Di) {
    return He(Di, pe);
  }
  n.isStringObject = qr;
  function Zi(Di) {
    return He(Di, $);
  }
  n.isBooleanObject = Zi;
  function Wr(Di) {
    return b && He(Di, Ee);
  }
  n.isBigIntObject = Wr;
  function ri(Di) {
    return F && He(Di, be);
  }
  n.isSymbolObject = ri;
  function _i(Di) {
    return Vr(Di) || qr(Di) || Zi(Di) || Wr(Di) || ri(Di);
  }
  n.isBoxedPrimitive = _i;
  function Er(Di) {
    return typeof Uint8Array < "u" && (Cr(Di) || Qi(Di));
  }
  n.isAnyArrayBuffer = Er, ["isProxy", "isExternal", "isModuleNamespaceObject"].forEach(function(Di) {
    Object.defineProperty(n, Di, {
      enumerable: !1,
      value: function() {
        throw new Error(Di + " is not supported in userland");
      }
    });
  });
})(types$j);
var isBufferBrowser = function(c) {
  return c && typeof c == "object" && typeof c.copy == "function" && typeof c.fill == "function" && typeof c.readUInt8 == "function";
};
(function(n) {
  var c = Object.getOwnPropertyDescriptors || function(si) {
    for (var ui = Object.keys(si), Li = {}, Qi = 0; Qi < ui.length; Qi++)
      Li[ui[Qi]] = Object.getOwnPropertyDescriptor(si, ui[Qi]);
    return Li;
  }, u = /%[sdj%]/g;
  n.format = function(Hr) {
    if (!xr(Hr)) {
      for (var si = [], ui = 0; ui < arguments.length; ui++)
        si.push(b(arguments[ui]));
      return si.join(" ");
    }
    for (var ui = 1, Li = arguments, Qi = Li.length, wi = String(Hr).replace(u, function(mn) {
      if (mn === "%%") return "%";
      if (ui >= Qi) return mn;
      switch (mn) {
        case "%s":
          return String(Li[ui++]);
        case "%d":
          return Number(Li[ui++]);
        case "%j":
          try {
            return JSON.stringify(Li[ui++]);
          } catch {
            return "[Circular]";
          }
        default:
          return mn;
      }
    }), Ji = Li[ui]; ui < Qi; Ji = Li[++ui])
      or(Ji) || !Fe(Ji) ? wi += " " + Ji : wi += " " + b(Ji);
    return wi;
  }, n.deprecate = function(Hr, si) {
    if (typeof process$1 < "u" && process$1.noDeprecation === !0)
      return Hr;
    if (typeof process$1 > "u")
      return function() {
        return n.deprecate(Hr, si).apply(this, arguments);
      };
    var ui = !1;
    function Li() {
      if (!ui) {
        if (process$1.throwDeprecation)
          throw new Error(si);
        process$1.traceDeprecation ? console.trace(si) : console.error(si), ui = !0;
      }
      return Hr.apply(this, arguments);
    }
    return Li;
  };
  var p = {}, a = /^$/;
  if (process$1.env.NODE_DEBUG) {
    var A = process$1.env.NODE_DEBUG;
    A = A.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase(), a = new RegExp("^" + A + "$", "i");
  }
  n.debuglog = function(Hr) {
    if (Hr = Hr.toUpperCase(), !p[Hr])
      if (a.test(Hr)) {
        var si = process$1.pid;
        p[Hr] = function() {
          var ui = n.format.apply(n, arguments);
          console.error("%s %d: %s", Hr, si, ui);
        };
      } else
        p[Hr] = function() {
        };
    return p[Hr];
  };
  function b(Hr, si) {
    var ui = {
      seen: [],
      stylize: le
    };
    return arguments.length >= 3 && (ui.depth = arguments[2]), arguments.length >= 4 && (ui.colors = arguments[3]), ir(si) ? ui.showHidden = si : si && n._extend(ui, si), Ce(ui.showHidden) && (ui.showHidden = !1), Ce(ui.depth) && (ui.depth = 2), Ce(ui.colors) && (ui.colors = !1), Ce(ui.customInspect) && (ui.customInspect = !0), ui.colors && (ui.stylize = F), pe(ui, Hr, ui.depth);
  }
  n.inspect = b, b.colors = {
    bold: [1, 22],
    italic: [3, 23],
    underline: [4, 24],
    inverse: [7, 27],
    white: [37, 39],
    grey: [90, 39],
    black: [30, 39],
    blue: [34, 39],
    cyan: [36, 39],
    green: [32, 39],
    magenta: [35, 39],
    red: [31, 39],
    yellow: [33, 39]
  }, b.styles = {
    special: "cyan",
    number: "yellow",
    boolean: "yellow",
    undefined: "grey",
    null: "bold",
    string: "green",
    date: "magenta",
    // "name": intentionally not styling
    regexp: "red"
  };
  function F(Hr, si) {
    var ui = b.styles[si];
    return ui ? "\x1B[" + b.colors[ui][0] + "m" + Hr + "\x1B[" + b.colors[ui][1] + "m" : Hr;
  }
  function le(Hr, si) {
    return Hr;
  }
  function L(Hr) {
    var si = {};
    return Hr.forEach(function(ui, Li) {
      si[ui] = !0;
    }), si;
  }
  function pe(Hr, si, ui) {
    if (Hr.customInspect && si && Ie(si.inspect) && // Filter out the util module, it's inspect function is special
    si.inspect !== n.inspect && // Also filter out any prototype objects using the circular check.
    !(si.constructor && si.constructor.prototype === si)) {
      var Li = si.inspect(ui, Hr);
      return xr(Li) || (Li = pe(Hr, Li, ui)), Li;
    }
    var Qi = $(Hr, si);
    if (Qi)
      return Qi;
    var wi = Object.keys(si), Ji = L(wi);
    if (Hr.showHidden && (wi = Object.getOwnPropertyNames(si)), er(si) && (wi.indexOf("message") >= 0 || wi.indexOf("description") >= 0))
      return Ee(si);
    if (wi.length === 0) {
      if (Ie(si)) {
        var mn = si.name ? ": " + si.name : "";
        return Hr.stylize("[Function" + mn + "]", "special");
      }
      if (tr(si))
        return Hr.stylize(RegExp.prototype.toString.call(si), "regexp");
      if (Sr(si))
        return Hr.stylize(Date.prototype.toString.call(si), "date");
      if (er(si))
        return Ee(si);
    }
    var pi = "", ei = !1, Vr = ["{", "}"];
    if (nr(si) && (ei = !0, Vr = ["[", "]"]), Ie(si)) {
      var qr = si.name ? ": " + si.name : "";
      pi = " [Function" + qr + "]";
    }
    if (tr(si) && (pi = " " + RegExp.prototype.toString.call(si)), Sr(si) && (pi = " " + Date.prototype.toUTCString.call(si)), er(si) && (pi = " " + Ee(si)), wi.length === 0 && (!ei || si.length == 0))
      return Vr[0] + pi + Vr[1];
    if (ui < 0)
      return tr(si) ? Hr.stylize(RegExp.prototype.toString.call(si), "regexp") : Hr.stylize("[Object]", "special");
    Hr.seen.push(si);
    var Zi;
    return ei ? Zi = be(Hr, si, ui, Ji, wi) : Zi = wi.map(function(Wr) {
      return He(Hr, si, ui, Ji, Wr, ei);
    }), Hr.seen.pop(), Pe(Zi, pi, Vr);
  }
  function $(Hr, si) {
    if (Ce(si))
      return Hr.stylize("undefined", "undefined");
    if (xr(si)) {
      var ui = "'" + JSON.stringify(si).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
      return Hr.stylize(ui, "string");
    }
    if (Ir(si))
      return Hr.stylize("" + si, "number");
    if (ir(si))
      return Hr.stylize("" + si, "boolean");
    if (or(si))
      return Hr.stylize("null", "null");
  }
  function Ee(Hr) {
    return "[" + Error.prototype.toString.call(Hr) + "]";
  }
  function be(Hr, si, ui, Li, Qi) {
    for (var wi = [], Ji = 0, mn = si.length; Ji < mn; ++Ji)
      Or(si, String(Ji)) ? wi.push(He(
        Hr,
        si,
        ui,
        Li,
        String(Ji),
        !0
      )) : wi.push("");
    return Qi.forEach(function(pi) {
      pi.match(/^\d+$/) || wi.push(He(
        Hr,
        si,
        ui,
        Li,
        pi,
        !0
      ));
    }), wi;
  }
  function He(Hr, si, ui, Li, Qi, wi) {
    var Ji, mn, pi;
    if (pi = Object.getOwnPropertyDescriptor(si, Qi) || { value: si[Qi] }, pi.get ? pi.set ? mn = Hr.stylize("[Getter/Setter]", "special") : mn = Hr.stylize("[Getter]", "special") : pi.set && (mn = Hr.stylize("[Setter]", "special")), Or(Li, Qi) || (Ji = "[" + Qi + "]"), mn || (Hr.seen.indexOf(pi.value) < 0 ? (or(ui) ? mn = pe(Hr, pi.value, null) : mn = pe(Hr, pi.value, ui - 1), mn.indexOf(`
`) > -1 && (wi ? mn = mn.split(`
`).map(function(ei) {
      return "  " + ei;
    }).join(`
`).slice(2) : mn = `
` + mn.split(`
`).map(function(ei) {
      return "   " + ei;
    }).join(`
`))) : mn = Hr.stylize("[Circular]", "special")), Ce(Ji)) {
      if (wi && Qi.match(/^\d+$/))
        return mn;
      Ji = JSON.stringify("" + Qi), Ji.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (Ji = Ji.slice(1, -1), Ji = Hr.stylize(Ji, "name")) : (Ji = Ji.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), Ji = Hr.stylize(Ji, "string"));
    }
    return Ji + ": " + mn;
  }
  function Pe(Hr, si, ui) {
    var Li = Hr.reduce(function(Qi, wi) {
      return wi.indexOf(`
`) >= 0, Qi + wi.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0);
    return Li > 60 ? ui[0] + (si === "" ? "" : si + `
 `) + " " + Hr.join(`,
  `) + " " + ui[1] : ui[0] + si + " " + Hr.join(", ") + " " + ui[1];
  }
  n.types = types$j;
  function nr(Hr) {
    return Array.isArray(Hr);
  }
  n.isArray = nr;
  function ir(Hr) {
    return typeof Hr == "boolean";
  }
  n.isBoolean = ir;
  function or(Hr) {
    return Hr === null;
  }
  n.isNull = or;
  function lr(Hr) {
    return Hr == null;
  }
  n.isNullOrUndefined = lr;
  function Ir(Hr) {
    return typeof Hr == "number";
  }
  n.isNumber = Ir;
  function xr(Hr) {
    return typeof Hr == "string";
  }
  n.isString = xr;
  function kr(Hr) {
    return typeof Hr == "symbol";
  }
  n.isSymbol = kr;
  function Ce(Hr) {
    return Hr === void 0;
  }
  n.isUndefined = Ce;
  function tr(Hr) {
    return Fe(Hr) && rr(Hr) === "[object RegExp]";
  }
  n.isRegExp = tr, n.types.isRegExp = tr;
  function Fe(Hr) {
    return typeof Hr == "object" && Hr !== null;
  }
  n.isObject = Fe;
  function Sr(Hr) {
    return Fe(Hr) && rr(Hr) === "[object Date]";
  }
  n.isDate = Sr, n.types.isDate = Sr;
  function er(Hr) {
    return Fe(Hr) && (rr(Hr) === "[object Error]" || Hr instanceof Error);
  }
  n.isError = er, n.types.isNativeError = er;
  function Ie(Hr) {
    return typeof Hr == "function";
  }
  n.isFunction = Ie;
  function xe(Hr) {
    return Hr === null || typeof Hr == "boolean" || typeof Hr == "number" || typeof Hr == "string" || typeof Hr == "symbol" || // ES6 symbol
    typeof Hr > "u";
  }
  n.isPrimitive = xe, n.isBuffer = isBufferBrowser;
  function rr(Hr) {
    return Object.prototype.toString.call(Hr);
  }
  function ar(Hr) {
    return Hr < 10 ? "0" + Hr.toString(10) : Hr.toString(10);
  }
  var yr = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ];
  function _r() {
    var Hr = /* @__PURE__ */ new Date(), si = [
      ar(Hr.getHours()),
      ar(Hr.getMinutes()),
      ar(Hr.getSeconds())
    ].join(":");
    return [Hr.getDate(), yr[Hr.getMonth()], si].join(" ");
  }
  n.log = function() {
    console.log("%s - %s", _r(), n.format.apply(n, arguments));
  }, n.inherits = inherits_browserExports, n._extend = function(Hr, si) {
    if (!si || !Fe(si)) return Hr;
    for (var ui = Object.keys(si), Li = ui.length; Li--; )
      Hr[ui[Li]] = si[ui[Li]];
    return Hr;
  };
  function Or(Hr, si) {
    return Object.prototype.hasOwnProperty.call(Hr, si);
  }
  var vr = typeof Symbol < "u" ? Symbol("util.promisify.custom") : void 0;
  n.promisify = function(si) {
    if (typeof si != "function")
      throw new TypeError('The "original" argument must be of type Function');
    if (vr && si[vr]) {
      var ui = si[vr];
      if (typeof ui != "function")
        throw new TypeError('The "util.promisify.custom" argument must be of type Function');
      return Object.defineProperty(ui, vr, {
        value: ui,
        enumerable: !1,
        writable: !1,
        configurable: !0
      }), ui;
    }
    function ui() {
      for (var Li, Qi, wi = new Promise(function(pi, ei) {
        Li = pi, Qi = ei;
      }), Ji = [], mn = 0; mn < arguments.length; mn++)
        Ji.push(arguments[mn]);
      Ji.push(function(pi, ei) {
        pi ? Qi(pi) : Li(ei);
      });
      try {
        si.apply(this, Ji);
      } catch (pi) {
        Qi(pi);
      }
      return wi;
    }
    return Object.setPrototypeOf(ui, Object.getPrototypeOf(si)), vr && Object.defineProperty(ui, vr, {
      value: ui,
      enumerable: !1,
      writable: !1,
      configurable: !0
    }), Object.defineProperties(
      ui,
      c(si)
    );
  }, n.promisify.custom = vr;
  function Te(Hr, si) {
    if (!Hr) {
      var ui = new Error("Promise was rejected with a falsy value");
      ui.reason = Hr, Hr = ui;
    }
    return si(Hr);
  }
  function Cr(Hr) {
    if (typeof Hr != "function")
      throw new TypeError('The "original" argument must be of type Function');
    function si() {
      for (var ui = [], Li = 0; Li < arguments.length; Li++)
        ui.push(arguments[Li]);
      var Qi = ui.pop();
      if (typeof Qi != "function")
        throw new TypeError("The last argument must be of type Function");
      var wi = this, Ji = function() {
        return Qi.apply(wi, arguments);
      };
      Hr.apply(this, ui).then(
        function(mn) {
          process$1.nextTick(Ji.bind(null, null, mn));
        },
        function(mn) {
          process$1.nextTick(Te.bind(null, mn, Ji));
        }
      );
    }
    return Object.setPrototypeOf(si, Object.getPrototypeOf(Hr)), Object.defineProperties(
      si,
      c(Hr)
    ), si;
  }
  n.callbackify = Cr;
})(util$8);
var buffer_list, hasRequiredBuffer_list;
function requireBuffer_list() {
  if (hasRequiredBuffer_list) return buffer_list;
  hasRequiredBuffer_list = 1;
  function n(He, Pe) {
    var nr = Object.keys(He);
    if (Object.getOwnPropertySymbols) {
      var ir = Object.getOwnPropertySymbols(He);
      Pe && (ir = ir.filter(function(or) {
        return Object.getOwnPropertyDescriptor(He, or).enumerable;
      })), nr.push.apply(nr, ir);
    }
    return nr;
  }
  function c(He) {
    for (var Pe = 1; Pe < arguments.length; Pe++) {
      var nr = arguments[Pe] != null ? arguments[Pe] : {};
      Pe % 2 ? n(Object(nr), !0).forEach(function(ir) {
        u(He, ir, nr[ir]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(He, Object.getOwnPropertyDescriptors(nr)) : n(Object(nr)).forEach(function(ir) {
        Object.defineProperty(He, ir, Object.getOwnPropertyDescriptor(nr, ir));
      });
    }
    return He;
  }
  function u(He, Pe, nr) {
    return Pe = b(Pe), Pe in He ? Object.defineProperty(He, Pe, { value: nr, enumerable: !0, configurable: !0, writable: !0 }) : He[Pe] = nr, He;
  }
  function p(He, Pe) {
    if (!(He instanceof Pe))
      throw new TypeError("Cannot call a class as a function");
  }
  function a(He, Pe) {
    for (var nr = 0; nr < Pe.length; nr++) {
      var ir = Pe[nr];
      ir.enumerable = ir.enumerable || !1, ir.configurable = !0, "value" in ir && (ir.writable = !0), Object.defineProperty(He, b(ir.key), ir);
    }
  }
  function A(He, Pe, nr) {
    return Pe && a(He.prototype, Pe), Object.defineProperty(He, "prototype", { writable: !1 }), He;
  }
  function b(He) {
    var Pe = F(He, "string");
    return typeof Pe == "symbol" ? Pe : String(Pe);
  }
  function F(He, Pe) {
    if (typeof He != "object" || He === null) return He;
    var nr = He[Symbol.toPrimitive];
    if (nr !== void 0) {
      var ir = nr.call(He, Pe || "default");
      if (typeof ir != "object") return ir;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (Pe === "string" ? String : Number)(He);
  }
  var le = require$$0$5, L = le.Buffer, pe = util$8, $ = pe.inspect, Ee = $ && $.custom || "inspect";
  function be(He, Pe, nr) {
    L.prototype.copy.call(He, Pe, nr);
  }
  return buffer_list = /* @__PURE__ */ function() {
    function He() {
      p(this, He), this.head = null, this.tail = null, this.length = 0;
    }
    return A(He, [{
      key: "push",
      value: function(nr) {
        var ir = {
          data: nr,
          next: null
        };
        this.length > 0 ? this.tail.next = ir : this.head = ir, this.tail = ir, ++this.length;
      }
    }, {
      key: "unshift",
      value: function(nr) {
        var ir = {
          data: nr,
          next: this.head
        };
        this.length === 0 && (this.tail = ir), this.head = ir, ++this.length;
      }
    }, {
      key: "shift",
      value: function() {
        if (this.length !== 0) {
          var nr = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, nr;
        }
      }
    }, {
      key: "clear",
      value: function() {
        this.head = this.tail = null, this.length = 0;
      }
    }, {
      key: "join",
      value: function(nr) {
        if (this.length === 0) return "";
        for (var ir = this.head, or = "" + ir.data; ir = ir.next; ) or += nr + ir.data;
        return or;
      }
    }, {
      key: "concat",
      value: function(nr) {
        if (this.length === 0) return L.alloc(0);
        for (var ir = L.allocUnsafe(nr >>> 0), or = this.head, lr = 0; or; )
          be(or.data, ir, lr), lr += or.data.length, or = or.next;
        return ir;
      }
      // Consumes a specified amount of bytes or characters from the buffered data.
    }, {
      key: "consume",
      value: function(nr, ir) {
        var or;
        return nr < this.head.data.length ? (or = this.head.data.slice(0, nr), this.head.data = this.head.data.slice(nr)) : nr === this.head.data.length ? or = this.shift() : or = ir ? this._getString(nr) : this._getBuffer(nr), or;
      }
    }, {
      key: "first",
      value: function() {
        return this.head.data;
      }
      // Consumes a specified amount of characters from the buffered data.
    }, {
      key: "_getString",
      value: function(nr) {
        var ir = this.head, or = 1, lr = ir.data;
        for (nr -= lr.length; ir = ir.next; ) {
          var Ir = ir.data, xr = nr > Ir.length ? Ir.length : nr;
          if (xr === Ir.length ? lr += Ir : lr += Ir.slice(0, nr), nr -= xr, nr === 0) {
            xr === Ir.length ? (++or, ir.next ? this.head = ir.next : this.head = this.tail = null) : (this.head = ir, ir.data = Ir.slice(xr));
            break;
          }
          ++or;
        }
        return this.length -= or, lr;
      }
      // Consumes a specified amount of bytes from the buffered data.
    }, {
      key: "_getBuffer",
      value: function(nr) {
        var ir = L.allocUnsafe(nr), or = this.head, lr = 1;
        for (or.data.copy(ir), nr -= or.data.length; or = or.next; ) {
          var Ir = or.data, xr = nr > Ir.length ? Ir.length : nr;
          if (Ir.copy(ir, ir.length - nr, 0, xr), nr -= xr, nr === 0) {
            xr === Ir.length ? (++lr, or.next ? this.head = or.next : this.head = this.tail = null) : (this.head = or, or.data = Ir.slice(xr));
            break;
          }
          ++lr;
        }
        return this.length -= lr, ir;
      }
      // Make sure the linked list only shows the minimal necessary information.
    }, {
      key: Ee,
      value: function(nr, ir) {
        return $(this, c(c({}, ir), {}, {
          // Only inspect one level.
          depth: 0,
          // It should not recurse.
          customInspect: !1
        }));
      }
    }]), He;
  }(), buffer_list;
}
function destroy(n, c) {
  var u = this, p = this._readableState && this._readableState.destroyed, a = this._writableState && this._writableState.destroyed;
  return p || a ? (c ? c(n) : n && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, process$1.nextTick(emitErrorNT, this, n)) : process$1.nextTick(emitErrorNT, this, n)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(n || null, function(A) {
    !c && A ? u._writableState ? u._writableState.errorEmitted ? process$1.nextTick(emitCloseNT, u) : (u._writableState.errorEmitted = !0, process$1.nextTick(emitErrorAndCloseNT, u, A)) : process$1.nextTick(emitErrorAndCloseNT, u, A) : c ? (process$1.nextTick(emitCloseNT, u), c(A)) : process$1.nextTick(emitCloseNT, u);
  }), this);
}
function emitErrorAndCloseNT(n, c) {
  emitErrorNT(n, c), emitCloseNT(n);
}
function emitCloseNT(n) {
  n._writableState && !n._writableState.emitClose || n._readableState && !n._readableState.emitClose || n.emit("close");
}
function undestroy() {
  this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
}
function emitErrorNT(n, c) {
  n.emit("error", c);
}
function errorOrDestroy(n, c) {
  var u = n._readableState, p = n._writableState;
  u && u.autoDestroy || p && p.autoDestroy ? n.destroy(c) : n.emit("error", c);
}
var destroy_1$1 = {
  destroy,
  undestroy,
  errorOrDestroy
}, errorsBrowser = {};
function _inheritsLoose(n, c) {
  n.prototype = Object.create(c.prototype), n.prototype.constructor = n, n.__proto__ = c;
}
var codes = {};
function createErrorType(n, c, u) {
  u || (u = Error);
  function p(A, b, F) {
    return typeof c == "string" ? c : c(A, b, F);
  }
  var a = /* @__PURE__ */ function(A) {
    _inheritsLoose(b, A);
    function b(F, le, L) {
      return A.call(this, p(F, le, L)) || this;
    }
    return b;
  }(u);
  a.prototype.name = u.name, a.prototype.code = n, codes[n] = a;
}
function oneOf(n, c) {
  if (Array.isArray(n)) {
    var u = n.length;
    return n = n.map(function(p) {
      return String(p);
    }), u > 2 ? "one of ".concat(c, " ").concat(n.slice(0, u - 1).join(", "), ", or ") + n[u - 1] : u === 2 ? "one of ".concat(c, " ").concat(n[0], " or ").concat(n[1]) : "of ".concat(c, " ").concat(n[0]);
  } else
    return "of ".concat(c, " ").concat(String(n));
}
function startsWith(n, c, u) {
  return n.substr(0, c.length) === c;
}
function endsWith(n, c, u) {
  return (u === void 0 || u > n.length) && (u = n.length), n.substring(u - c.length, u) === c;
}
function includes(n, c, u) {
  return typeof u != "number" && (u = 0), u + c.length > n.length ? !1 : n.indexOf(c, u) !== -1;
}
createErrorType("ERR_INVALID_OPT_VALUE", function(n, c) {
  return 'The value "' + c + '" is invalid for option "' + n + '"';
}, TypeError);
createErrorType("ERR_INVALID_ARG_TYPE", function(n, c, u) {
  var p;
  typeof c == "string" && startsWith(c, "not ") ? (p = "must not be", c = c.replace(/^not /, "")) : p = "must be";
  var a;
  if (endsWith(n, " argument"))
    a = "The ".concat(n, " ").concat(p, " ").concat(oneOf(c, "type"));
  else {
    var A = includes(n, ".") ? "property" : "argument";
    a = 'The "'.concat(n, '" ').concat(A, " ").concat(p, " ").concat(oneOf(c, "type"));
  }
  return a += ". Received type ".concat(typeof u), a;
}, TypeError);
createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(n) {
  return "The " + n + " method is not implemented";
});
createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
createErrorType("ERR_STREAM_DESTROYED", function(n) {
  return "Cannot call " + n + " after a stream was destroyed";
});
createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
createErrorType("ERR_UNKNOWN_ENCODING", function(n) {
  return "Unknown encoding: " + n;
}, TypeError);
createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
errorsBrowser.codes = codes;
var ERR_INVALID_OPT_VALUE = errorsBrowser.codes.ERR_INVALID_OPT_VALUE;
function highWaterMarkFrom(n, c, u) {
  return n.highWaterMark != null ? n.highWaterMark : c ? n[u] : null;
}
function getHighWaterMark(n, c, u, p) {
  var a = highWaterMarkFrom(c, p, u);
  if (a != null) {
    if (!(isFinite(a) && Math.floor(a) === a) || a < 0) {
      var A = p ? u : "highWaterMark";
      throw new ERR_INVALID_OPT_VALUE(A, a);
    }
    return Math.floor(a);
  }
  return n.objectMode ? 16 : 16 * 1024;
}
var state = {
  getHighWaterMark
}, browser$b = deprecate;
function deprecate(n, c) {
  if (config$1("noDeprecation"))
    return n;
  var u = !1;
  function p() {
    if (!u) {
      if (config$1("throwDeprecation"))
        throw new Error(c);
      config$1("traceDeprecation") ? console.trace(c) : console.warn(c), u = !0;
    }
    return n.apply(this, arguments);
  }
  return p;
}
function config$1(n) {
  try {
    if (!commonjsGlobal.localStorage) return !1;
  } catch {
    return !1;
  }
  var c = commonjsGlobal.localStorage[n];
  return c == null ? !1 : String(c).toLowerCase() === "true";
}
var _stream_writable$1, hasRequired_stream_writable$1;
function require_stream_writable$1() {
  if (hasRequired_stream_writable$1) return _stream_writable$1;
  hasRequired_stream_writable$1 = 1, _stream_writable$1 = tr;
  function n(Qi) {
    var wi = this;
    this.next = null, this.entry = null, this.finish = function() {
      Li(wi, Qi);
    };
  }
  var c;
  tr.WritableState = kr;
  var u = {
    deprecate: browser$b
  }, p = streamBrowser$1, a = require$$0$5.Buffer, A = (typeof commonjsGlobal < "u" ? commonjsGlobal : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function b(Qi) {
    return a.from(Qi);
  }
  function F(Qi) {
    return a.isBuffer(Qi) || Qi instanceof A;
  }
  var le = destroy_1$1, L = state, pe = L.getHighWaterMark, $ = errorsBrowser.codes, Ee = $.ERR_INVALID_ARG_TYPE, be = $.ERR_METHOD_NOT_IMPLEMENTED, He = $.ERR_MULTIPLE_CALLBACK, Pe = $.ERR_STREAM_CANNOT_PIPE, nr = $.ERR_STREAM_DESTROYED, ir = $.ERR_STREAM_NULL_VALUES, or = $.ERR_STREAM_WRITE_AFTER_END, lr = $.ERR_UNKNOWN_ENCODING, Ir = le.errorOrDestroy;
  inherits_browserExports(tr, p);
  function xr() {
  }
  function kr(Qi, wi, Ji) {
    c = c || require_stream_duplex$1(), Qi = Qi || {}, typeof Ji != "boolean" && (Ji = wi instanceof c), this.objectMode = !!Qi.objectMode, Ji && (this.objectMode = this.objectMode || !!Qi.writableObjectMode), this.highWaterMark = pe(this, Qi, "writableHighWaterMark", Ji), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
    var mn = Qi.decodeStrings === !1;
    this.decodeStrings = !mn, this.defaultEncoding = Qi.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(pi) {
      yr(wi, pi);
    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = Qi.emitClose !== !1, this.autoDestroy = !!Qi.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new n(this);
  }
  kr.prototype.getBuffer = function() {
    for (var wi = this.bufferedRequest, Ji = []; wi; )
      Ji.push(wi), wi = wi.next;
    return Ji;
  }, function() {
    try {
      Object.defineProperty(kr.prototype, "buffer", {
        get: u.deprecate(function() {
          return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
      });
    } catch {
    }
  }();
  var Ce;
  typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (Ce = Function.prototype[Symbol.hasInstance], Object.defineProperty(tr, Symbol.hasInstance, {
    value: function(wi) {
      return Ce.call(this, wi) ? !0 : this !== tr ? !1 : wi && wi._writableState instanceof kr;
    }
  })) : Ce = function(wi) {
    return wi instanceof this;
  };
  function tr(Qi) {
    c = c || require_stream_duplex$1();
    var wi = this instanceof c;
    if (!wi && !Ce.call(tr, this)) return new tr(Qi);
    this._writableState = new kr(Qi, this, wi), this.writable = !0, Qi && (typeof Qi.write == "function" && (this._write = Qi.write), typeof Qi.writev == "function" && (this._writev = Qi.writev), typeof Qi.destroy == "function" && (this._destroy = Qi.destroy), typeof Qi.final == "function" && (this._final = Qi.final)), p.call(this);
  }
  tr.prototype.pipe = function() {
    Ir(this, new Pe());
  };
  function Fe(Qi, wi) {
    var Ji = new or();
    Ir(Qi, Ji), process$1.nextTick(wi, Ji);
  }
  function Sr(Qi, wi, Ji, mn) {
    var pi;
    return Ji === null ? pi = new ir() : typeof Ji != "string" && !wi.objectMode && (pi = new Ee("chunk", ["string", "Buffer"], Ji)), pi ? (Ir(Qi, pi), process$1.nextTick(mn, pi), !1) : !0;
  }
  tr.prototype.write = function(Qi, wi, Ji) {
    var mn = this._writableState, pi = !1, ei = !mn.objectMode && F(Qi);
    return ei && !a.isBuffer(Qi) && (Qi = b(Qi)), typeof wi == "function" && (Ji = wi, wi = null), ei ? wi = "buffer" : wi || (wi = mn.defaultEncoding), typeof Ji != "function" && (Ji = xr), mn.ending ? Fe(this, Ji) : (ei || Sr(this, mn, Qi, Ji)) && (mn.pendingcb++, pi = Ie(this, mn, ei, Qi, wi, Ji)), pi;
  }, tr.prototype.cork = function() {
    this._writableState.corked++;
  }, tr.prototype.uncork = function() {
    var Qi = this._writableState;
    Qi.corked && (Qi.corked--, !Qi.writing && !Qi.corked && !Qi.bufferProcessing && Qi.bufferedRequest && vr(this, Qi));
  }, tr.prototype.setDefaultEncoding = function(wi) {
    if (typeof wi == "string" && (wi = wi.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((wi + "").toLowerCase()) > -1)) throw new lr(wi);
    return this._writableState.defaultEncoding = wi, this;
  }, Object.defineProperty(tr.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  });
  function er(Qi, wi, Ji) {
    return !Qi.objectMode && Qi.decodeStrings !== !1 && typeof wi == "string" && (wi = a.from(wi, Ji)), wi;
  }
  Object.defineProperty(tr.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function Ie(Qi, wi, Ji, mn, pi, ei) {
    if (!Ji) {
      var Vr = er(wi, mn, pi);
      mn !== Vr && (Ji = !0, pi = "buffer", mn = Vr);
    }
    var qr = wi.objectMode ? 1 : mn.length;
    wi.length += qr;
    var Zi = wi.length < wi.highWaterMark;
    if (Zi || (wi.needDrain = !0), wi.writing || wi.corked) {
      var Wr = wi.lastBufferedRequest;
      wi.lastBufferedRequest = {
        chunk: mn,
        encoding: pi,
        isBuf: Ji,
        callback: ei,
        next: null
      }, Wr ? Wr.next = wi.lastBufferedRequest : wi.bufferedRequest = wi.lastBufferedRequest, wi.bufferedRequestCount += 1;
    } else
      xe(Qi, wi, !1, qr, mn, pi, ei);
    return Zi;
  }
  function xe(Qi, wi, Ji, mn, pi, ei, Vr) {
    wi.writelen = mn, wi.writecb = Vr, wi.writing = !0, wi.sync = !0, wi.destroyed ? wi.onwrite(new nr("write")) : Ji ? Qi._writev(pi, wi.onwrite) : Qi._write(pi, ei, wi.onwrite), wi.sync = !1;
  }
  function rr(Qi, wi, Ji, mn, pi) {
    --wi.pendingcb, Ji ? (process$1.nextTick(pi, mn), process$1.nextTick(si, Qi, wi), Qi._writableState.errorEmitted = !0, Ir(Qi, mn)) : (pi(mn), Qi._writableState.errorEmitted = !0, Ir(Qi, mn), si(Qi, wi));
  }
  function ar(Qi) {
    Qi.writing = !1, Qi.writecb = null, Qi.length -= Qi.writelen, Qi.writelen = 0;
  }
  function yr(Qi, wi) {
    var Ji = Qi._writableState, mn = Ji.sync, pi = Ji.writecb;
    if (typeof pi != "function") throw new He();
    if (ar(Ji), wi) rr(Qi, Ji, mn, wi, pi);
    else {
      var ei = Te(Ji) || Qi.destroyed;
      !ei && !Ji.corked && !Ji.bufferProcessing && Ji.bufferedRequest && vr(Qi, Ji), mn ? process$1.nextTick(_r, Qi, Ji, ei, pi) : _r(Qi, Ji, ei, pi);
    }
  }
  function _r(Qi, wi, Ji, mn) {
    Ji || Or(Qi, wi), wi.pendingcb--, mn(), si(Qi, wi);
  }
  function Or(Qi, wi) {
    wi.length === 0 && wi.needDrain && (wi.needDrain = !1, Qi.emit("drain"));
  }
  function vr(Qi, wi) {
    wi.bufferProcessing = !0;
    var Ji = wi.bufferedRequest;
    if (Qi._writev && Ji && Ji.next) {
      var mn = wi.bufferedRequestCount, pi = new Array(mn), ei = wi.corkedRequestsFree;
      ei.entry = Ji;
      for (var Vr = 0, qr = !0; Ji; )
        pi[Vr] = Ji, Ji.isBuf || (qr = !1), Ji = Ji.next, Vr += 1;
      pi.allBuffers = qr, xe(Qi, wi, !0, wi.length, pi, "", ei.finish), wi.pendingcb++, wi.lastBufferedRequest = null, ei.next ? (wi.corkedRequestsFree = ei.next, ei.next = null) : wi.corkedRequestsFree = new n(wi), wi.bufferedRequestCount = 0;
    } else {
      for (; Ji; ) {
        var Zi = Ji.chunk, Wr = Ji.encoding, ri = Ji.callback, _i = wi.objectMode ? 1 : Zi.length;
        if (xe(Qi, wi, !1, _i, Zi, Wr, ri), Ji = Ji.next, wi.bufferedRequestCount--, wi.writing)
          break;
      }
      Ji === null && (wi.lastBufferedRequest = null);
    }
    wi.bufferedRequest = Ji, wi.bufferProcessing = !1;
  }
  tr.prototype._write = function(Qi, wi, Ji) {
    Ji(new be("_write()"));
  }, tr.prototype._writev = null, tr.prototype.end = function(Qi, wi, Ji) {
    var mn = this._writableState;
    return typeof Qi == "function" ? (Ji = Qi, Qi = null, wi = null) : typeof wi == "function" && (Ji = wi, wi = null), Qi != null && this.write(Qi, wi), mn.corked && (mn.corked = 1, this.uncork()), mn.ending || ui(this, mn, Ji), this;
  }, Object.defineProperty(tr.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function Te(Qi) {
    return Qi.ending && Qi.length === 0 && Qi.bufferedRequest === null && !Qi.finished && !Qi.writing;
  }
  function Cr(Qi, wi) {
    Qi._final(function(Ji) {
      wi.pendingcb--, Ji && Ir(Qi, Ji), wi.prefinished = !0, Qi.emit("prefinish"), si(Qi, wi);
    });
  }
  function Hr(Qi, wi) {
    !wi.prefinished && !wi.finalCalled && (typeof Qi._final == "function" && !wi.destroyed ? (wi.pendingcb++, wi.finalCalled = !0, process$1.nextTick(Cr, Qi, wi)) : (wi.prefinished = !0, Qi.emit("prefinish")));
  }
  function si(Qi, wi) {
    var Ji = Te(wi);
    if (Ji && (Hr(Qi, wi), wi.pendingcb === 0 && (wi.finished = !0, Qi.emit("finish"), wi.autoDestroy))) {
      var mn = Qi._readableState;
      (!mn || mn.autoDestroy && mn.endEmitted) && Qi.destroy();
    }
    return Ji;
  }
  function ui(Qi, wi, Ji) {
    wi.ending = !0, si(Qi, wi), Ji && (wi.finished ? process$1.nextTick(Ji) : Qi.once("finish", Ji)), wi.ended = !0, Qi.writable = !1;
  }
  function Li(Qi, wi, Ji) {
    var mn = Qi.entry;
    for (Qi.entry = null; mn; ) {
      var pi = mn.callback;
      wi.pendingcb--, pi(Ji), mn = mn.next;
    }
    wi.corkedRequestsFree.next = Qi;
  }
  return Object.defineProperty(tr.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState === void 0 ? !1 : this._writableState.destroyed;
    },
    set: function(wi) {
      this._writableState && (this._writableState.destroyed = wi);
    }
  }), tr.prototype.destroy = le.destroy, tr.prototype._undestroy = le.undestroy, tr.prototype._destroy = function(Qi, wi) {
    wi(Qi);
  }, _stream_writable$1;
}
var _stream_duplex$1, hasRequired_stream_duplex$1;
function require_stream_duplex$1() {
  if (hasRequired_stream_duplex$1) return _stream_duplex$1;
  hasRequired_stream_duplex$1 = 1;
  var n = Object.keys || function(L) {
    var pe = [];
    for (var $ in L) pe.push($);
    return pe;
  };
  _stream_duplex$1 = b;
  var c = require_stream_readable$1(), u = require_stream_writable$1();
  inherits_browserExports(b, c);
  for (var p = n(u.prototype), a = 0; a < p.length; a++) {
    var A = p[a];
    b.prototype[A] || (b.prototype[A] = u.prototype[A]);
  }
  function b(L) {
    if (!(this instanceof b)) return new b(L);
    c.call(this, L), u.call(this, L), this.allowHalfOpen = !0, L && (L.readable === !1 && (this.readable = !1), L.writable === !1 && (this.writable = !1), L.allowHalfOpen === !1 && (this.allowHalfOpen = !1, this.once("end", F)));
  }
  Object.defineProperty(b.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  }), Object.defineProperty(b.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  }), Object.defineProperty(b.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function F() {
    this._writableState.ended || process$1.nextTick(le, this);
  }
  function le(L) {
    L.end();
  }
  return Object.defineProperty(b.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(pe) {
      this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = pe, this._writableState.destroyed = pe);
    }
  }), _stream_duplex$1;
}
var string_decoder = {}, Buffer$d = safeBufferExports.Buffer, isEncoding = Buffer$d.isEncoding || function(n) {
  switch (n = "" + n, n && n.toLowerCase()) {
    case "hex":
    case "utf8":
    case "utf-8":
    case "ascii":
    case "binary":
    case "base64":
    case "ucs2":
    case "ucs-2":
    case "utf16le":
    case "utf-16le":
    case "raw":
      return !0;
    default:
      return !1;
  }
};
function _normalizeEncoding(n) {
  if (!n) return "utf8";
  for (var c; ; )
    switch (n) {
      case "utf8":
      case "utf-8":
        return "utf8";
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return "utf16le";
      case "latin1":
      case "binary":
        return "latin1";
      case "base64":
      case "ascii":
      case "hex":
        return n;
      default:
        if (c) return;
        n = ("" + n).toLowerCase(), c = !0;
    }
}
function normalizeEncoding(n) {
  var c = _normalizeEncoding(n);
  if (typeof c != "string" && (Buffer$d.isEncoding === isEncoding || !isEncoding(n))) throw new Error("Unknown encoding: " + n);
  return c || n;
}
string_decoder.StringDecoder = StringDecoder$1;
function StringDecoder$1(n) {
  this.encoding = normalizeEncoding(n);
  var c;
  switch (this.encoding) {
    case "utf16le":
      this.text = utf16Text, this.end = utf16End, c = 4;
      break;
    case "utf8":
      this.fillLast = utf8FillLast, c = 4;
      break;
    case "base64":
      this.text = base64Text, this.end = base64End, c = 3;
      break;
    default:
      this.write = simpleWrite, this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0, this.lastTotal = 0, this.lastChar = Buffer$d.allocUnsafe(c);
}
StringDecoder$1.prototype.write = function(n) {
  if (n.length === 0) return "";
  var c, u;
  if (this.lastNeed) {
    if (c = this.fillLast(n), c === void 0) return "";
    u = this.lastNeed, this.lastNeed = 0;
  } else
    u = 0;
  return u < n.length ? c ? c + this.text(n, u) : this.text(n, u) : c || "";
};
StringDecoder$1.prototype.end = utf8End;
StringDecoder$1.prototype.text = utf8Text;
StringDecoder$1.prototype.fillLast = function(n) {
  if (this.lastNeed <= n.length)
    return n.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
  n.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, n.length), this.lastNeed -= n.length;
};
function utf8CheckByte(n) {
  return n <= 127 ? 0 : n >> 5 === 6 ? 2 : n >> 4 === 14 ? 3 : n >> 3 === 30 ? 4 : n >> 6 === 2 ? -1 : -2;
}
function utf8CheckIncomplete(n, c, u) {
  var p = c.length - 1;
  if (p < u) return 0;
  var a = utf8CheckByte(c[p]);
  return a >= 0 ? (a > 0 && (n.lastNeed = a - 1), a) : --p < u || a === -2 ? 0 : (a = utf8CheckByte(c[p]), a >= 0 ? (a > 0 && (n.lastNeed = a - 2), a) : --p < u || a === -2 ? 0 : (a = utf8CheckByte(c[p]), a >= 0 ? (a > 0 && (a === 2 ? a = 0 : n.lastNeed = a - 3), a) : 0));
}
function utf8CheckExtraBytes(n, c, u) {
  if ((c[0] & 192) !== 128)
    return n.lastNeed = 0, "�";
  if (n.lastNeed > 1 && c.length > 1) {
    if ((c[1] & 192) !== 128)
      return n.lastNeed = 1, "�";
    if (n.lastNeed > 2 && c.length > 2 && (c[2] & 192) !== 128)
      return n.lastNeed = 2, "�";
  }
}
function utf8FillLast(n) {
  var c = this.lastTotal - this.lastNeed, u = utf8CheckExtraBytes(this, n);
  if (u !== void 0) return u;
  if (this.lastNeed <= n.length)
    return n.copy(this.lastChar, c, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
  n.copy(this.lastChar, c, 0, n.length), this.lastNeed -= n.length;
}
function utf8Text(n, c) {
  var u = utf8CheckIncomplete(this, n, c);
  if (!this.lastNeed) return n.toString("utf8", c);
  this.lastTotal = u;
  var p = n.length - (u - this.lastNeed);
  return n.copy(this.lastChar, 0, p), n.toString("utf8", c, p);
}
function utf8End(n) {
  var c = n && n.length ? this.write(n) : "";
  return this.lastNeed ? c + "�" : c;
}
function utf16Text(n, c) {
  if ((n.length - c) % 2 === 0) {
    var u = n.toString("utf16le", c);
    if (u) {
      var p = u.charCodeAt(u.length - 1);
      if (p >= 55296 && p <= 56319)
        return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = n[n.length - 2], this.lastChar[1] = n[n.length - 1], u.slice(0, -1);
    }
    return u;
  }
  return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = n[n.length - 1], n.toString("utf16le", c, n.length - 1);
}
function utf16End(n) {
  var c = n && n.length ? this.write(n) : "";
  if (this.lastNeed) {
    var u = this.lastTotal - this.lastNeed;
    return c + this.lastChar.toString("utf16le", 0, u);
  }
  return c;
}
function base64Text(n, c) {
  var u = (n.length - c) % 3;
  return u === 0 ? n.toString("base64", c) : (this.lastNeed = 3 - u, this.lastTotal = 3, u === 1 ? this.lastChar[0] = n[n.length - 1] : (this.lastChar[0] = n[n.length - 2], this.lastChar[1] = n[n.length - 1]), n.toString("base64", c, n.length - u));
}
function base64End(n) {
  var c = n && n.length ? this.write(n) : "";
  return this.lastNeed ? c + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : c;
}
function simpleWrite(n) {
  return n.toString(this.encoding);
}
function simpleEnd(n) {
  return n && n.length ? this.write(n) : "";
}
var ERR_STREAM_PREMATURE_CLOSE = errorsBrowser.codes.ERR_STREAM_PREMATURE_CLOSE;
function once$1(n) {
  var c = !1;
  return function() {
    if (!c) {
      c = !0;
      for (var u = arguments.length, p = new Array(u), a = 0; a < u; a++)
        p[a] = arguments[a];
      n.apply(this, p);
    }
  };
}
function noop$2() {
}
function isRequest$1(n) {
  return n.setHeader && typeof n.abort == "function";
}
function eos$1(n, c, u) {
  if (typeof c == "function") return eos$1(n, null, c);
  c || (c = {}), u = once$1(u || noop$2);
  var p = c.readable || c.readable !== !1 && n.readable, a = c.writable || c.writable !== !1 && n.writable, A = function() {
    n.writable || F();
  }, b = n._writableState && n._writableState.finished, F = function() {
    a = !1, b = !0, p || u.call(n);
  }, le = n._readableState && n._readableState.endEmitted, L = function() {
    p = !1, le = !0, a || u.call(n);
  }, pe = function(He) {
    u.call(n, He);
  }, $ = function() {
    var He;
    if (p && !le)
      return (!n._readableState || !n._readableState.ended) && (He = new ERR_STREAM_PREMATURE_CLOSE()), u.call(n, He);
    if (a && !b)
      return (!n._writableState || !n._writableState.ended) && (He = new ERR_STREAM_PREMATURE_CLOSE()), u.call(n, He);
  }, Ee = function() {
    n.req.on("finish", F);
  };
  return isRequest$1(n) ? (n.on("complete", F), n.on("abort", $), n.req ? Ee() : n.on("request", Ee)) : a && !n._writableState && (n.on("end", A), n.on("close", A)), n.on("end", L), n.on("finish", F), c.error !== !1 && n.on("error", pe), n.on("close", $), function() {
    n.removeListener("complete", F), n.removeListener("abort", $), n.removeListener("request", Ee), n.req && n.req.removeListener("finish", F), n.removeListener("end", A), n.removeListener("close", A), n.removeListener("finish", F), n.removeListener("end", L), n.removeListener("error", pe), n.removeListener("close", $);
  };
}
var endOfStream = eos$1, async_iterator, hasRequiredAsync_iterator;
function requireAsync_iterator() {
  if (hasRequiredAsync_iterator) return async_iterator;
  hasRequiredAsync_iterator = 1;
  var n;
  function c(lr, Ir, xr) {
    return Ir = u(Ir), Ir in lr ? Object.defineProperty(lr, Ir, { value: xr, enumerable: !0, configurable: !0, writable: !0 }) : lr[Ir] = xr, lr;
  }
  function u(lr) {
    var Ir = p(lr, "string");
    return typeof Ir == "symbol" ? Ir : String(Ir);
  }
  function p(lr, Ir) {
    if (typeof lr != "object" || lr === null) return lr;
    var xr = lr[Symbol.toPrimitive];
    if (xr !== void 0) {
      var kr = xr.call(lr, Ir || "default");
      if (typeof kr != "object") return kr;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (Ir === "string" ? String : Number)(lr);
  }
  var a = endOfStream, A = Symbol("lastResolve"), b = Symbol("lastReject"), F = Symbol("error"), le = Symbol("ended"), L = Symbol("lastPromise"), pe = Symbol("handlePromise"), $ = Symbol("stream");
  function Ee(lr, Ir) {
    return {
      value: lr,
      done: Ir
    };
  }
  function be(lr) {
    var Ir = lr[A];
    if (Ir !== null) {
      var xr = lr[$].read();
      xr !== null && (lr[L] = null, lr[A] = null, lr[b] = null, Ir(Ee(xr, !1)));
    }
  }
  function He(lr) {
    process$1.nextTick(be, lr);
  }
  function Pe(lr, Ir) {
    return function(xr, kr) {
      lr.then(function() {
        if (Ir[le]) {
          xr(Ee(void 0, !0));
          return;
        }
        Ir[pe](xr, kr);
      }, kr);
    };
  }
  var nr = Object.getPrototypeOf(function() {
  }), ir = Object.setPrototypeOf((n = {
    get stream() {
      return this[$];
    },
    next: function() {
      var Ir = this, xr = this[F];
      if (xr !== null)
        return Promise.reject(xr);
      if (this[le])
        return Promise.resolve(Ee(void 0, !0));
      if (this[$].destroyed)
        return new Promise(function(Fe, Sr) {
          process$1.nextTick(function() {
            Ir[F] ? Sr(Ir[F]) : Fe(Ee(void 0, !0));
          });
        });
      var kr = this[L], Ce;
      if (kr)
        Ce = new Promise(Pe(kr, this));
      else {
        var tr = this[$].read();
        if (tr !== null)
          return Promise.resolve(Ee(tr, !1));
        Ce = new Promise(this[pe]);
      }
      return this[L] = Ce, Ce;
    }
  }, c(n, Symbol.asyncIterator, function() {
    return this;
  }), c(n, "return", function() {
    var Ir = this;
    return new Promise(function(xr, kr) {
      Ir[$].destroy(null, function(Ce) {
        if (Ce) {
          kr(Ce);
          return;
        }
        xr(Ee(void 0, !0));
      });
    });
  }), n), nr), or = function(Ir) {
    var xr, kr = Object.create(ir, (xr = {}, c(xr, $, {
      value: Ir,
      writable: !0
    }), c(xr, A, {
      value: null,
      writable: !0
    }), c(xr, b, {
      value: null,
      writable: !0
    }), c(xr, F, {
      value: null,
      writable: !0
    }), c(xr, le, {
      value: Ir._readableState.endEmitted,
      writable: !0
    }), c(xr, pe, {
      value: function(tr, Fe) {
        var Sr = kr[$].read();
        Sr ? (kr[L] = null, kr[A] = null, kr[b] = null, tr(Ee(Sr, !1))) : (kr[A] = tr, kr[b] = Fe);
      },
      writable: !0
    }), xr));
    return kr[L] = null, a(Ir, function(Ce) {
      if (Ce && Ce.code !== "ERR_STREAM_PREMATURE_CLOSE") {
        var tr = kr[b];
        tr !== null && (kr[L] = null, kr[A] = null, kr[b] = null, tr(Ce)), kr[F] = Ce;
        return;
      }
      var Fe = kr[A];
      Fe !== null && (kr[L] = null, kr[A] = null, kr[b] = null, Fe(Ee(void 0, !0))), kr[le] = !0;
    }), Ir.on("readable", He.bind(null, kr)), kr;
  };
  return async_iterator = or, async_iterator;
}
var fromBrowser, hasRequiredFromBrowser;
function requireFromBrowser() {
  return hasRequiredFromBrowser || (hasRequiredFromBrowser = 1, fromBrowser = function() {
    throw new Error("Readable.from is not available in the browser");
  }), fromBrowser;
}
var _stream_readable$1, hasRequired_stream_readable$1;
function require_stream_readable$1() {
  if (hasRequired_stream_readable$1) return _stream_readable$1;
  hasRequired_stream_readable$1 = 1, _stream_readable$1 = Fe;
  var n;
  Fe.ReadableState = tr, eventsExports.EventEmitter;
  var c = function(Vr, qr) {
    return Vr.listeners(qr).length;
  }, u = streamBrowser$1, p = require$$0$5.Buffer, a = (typeof commonjsGlobal < "u" ? commonjsGlobal : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function A(ei) {
    return p.from(ei);
  }
  function b(ei) {
    return p.isBuffer(ei) || ei instanceof a;
  }
  var F = util$8, le;
  F && F.debuglog ? le = F.debuglog("stream") : le = function() {
  };
  var L = requireBuffer_list(), pe = destroy_1$1, $ = state, Ee = $.getHighWaterMark, be = errorsBrowser.codes, He = be.ERR_INVALID_ARG_TYPE, Pe = be.ERR_STREAM_PUSH_AFTER_EOF, nr = be.ERR_METHOD_NOT_IMPLEMENTED, ir = be.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, or, lr, Ir;
  inherits_browserExports(Fe, u);
  var xr = pe.errorOrDestroy, kr = ["error", "close", "destroy", "pause", "resume"];
  function Ce(ei, Vr, qr) {
    if (typeof ei.prependListener == "function") return ei.prependListener(Vr, qr);
    !ei._events || !ei._events[Vr] ? ei.on(Vr, qr) : Array.isArray(ei._events[Vr]) ? ei._events[Vr].unshift(qr) : ei._events[Vr] = [qr, ei._events[Vr]];
  }
  function tr(ei, Vr, qr) {
    n = n || require_stream_duplex$1(), ei = ei || {}, typeof qr != "boolean" && (qr = Vr instanceof n), this.objectMode = !!ei.objectMode, qr && (this.objectMode = this.objectMode || !!ei.readableObjectMode), this.highWaterMark = Ee(this, ei, "readableHighWaterMark", qr), this.buffer = new L(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = ei.emitClose !== !1, this.autoDestroy = !!ei.autoDestroy, this.destroyed = !1, this.defaultEncoding = ei.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, ei.encoding && (or || (or = string_decoder.StringDecoder), this.decoder = new or(ei.encoding), this.encoding = ei.encoding);
  }
  function Fe(ei) {
    if (n = n || require_stream_duplex$1(), !(this instanceof Fe)) return new Fe(ei);
    var Vr = this instanceof n;
    this._readableState = new tr(ei, this, Vr), this.readable = !0, ei && (typeof ei.read == "function" && (this._read = ei.read), typeof ei.destroy == "function" && (this._destroy = ei.destroy)), u.call(this);
  }
  Object.defineProperty(Fe.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 ? !1 : this._readableState.destroyed;
    },
    set: function(Vr) {
      this._readableState && (this._readableState.destroyed = Vr);
    }
  }), Fe.prototype.destroy = pe.destroy, Fe.prototype._undestroy = pe.undestroy, Fe.prototype._destroy = function(ei, Vr) {
    Vr(ei);
  }, Fe.prototype.push = function(ei, Vr) {
    var qr = this._readableState, Zi;
    return qr.objectMode ? Zi = !0 : typeof ei == "string" && (Vr = Vr || qr.defaultEncoding, Vr !== qr.encoding && (ei = p.from(ei, Vr), Vr = ""), Zi = !0), Sr(this, ei, Vr, !1, Zi);
  }, Fe.prototype.unshift = function(ei) {
    return Sr(this, ei, null, !0, !1);
  };
  function Sr(ei, Vr, qr, Zi, Wr) {
    le("readableAddChunk", Vr);
    var ri = ei._readableState;
    if (Vr === null)
      ri.reading = !1, yr(ei, ri);
    else {
      var _i;
      if (Wr || (_i = Ie(ri, Vr)), _i)
        xr(ei, _i);
      else if (ri.objectMode || Vr && Vr.length > 0)
        if (typeof Vr != "string" && !ri.objectMode && Object.getPrototypeOf(Vr) !== p.prototype && (Vr = A(Vr)), Zi)
          ri.endEmitted ? xr(ei, new ir()) : er(ei, ri, Vr, !0);
        else if (ri.ended)
          xr(ei, new Pe());
        else {
          if (ri.destroyed)
            return !1;
          ri.reading = !1, ri.decoder && !qr ? (Vr = ri.decoder.write(Vr), ri.objectMode || Vr.length !== 0 ? er(ei, ri, Vr, !1) : vr(ei, ri)) : er(ei, ri, Vr, !1);
        }
      else Zi || (ri.reading = !1, vr(ei, ri));
    }
    return !ri.ended && (ri.length < ri.highWaterMark || ri.length === 0);
  }
  function er(ei, Vr, qr, Zi) {
    Vr.flowing && Vr.length === 0 && !Vr.sync ? (Vr.awaitDrain = 0, ei.emit("data", qr)) : (Vr.length += Vr.objectMode ? 1 : qr.length, Zi ? Vr.buffer.unshift(qr) : Vr.buffer.push(qr), Vr.needReadable && _r(ei)), vr(ei, Vr);
  }
  function Ie(ei, Vr) {
    var qr;
    return !b(Vr) && typeof Vr != "string" && Vr !== void 0 && !ei.objectMode && (qr = new He("chunk", ["string", "Buffer", "Uint8Array"], Vr)), qr;
  }
  Fe.prototype.isPaused = function() {
    return this._readableState.flowing === !1;
  }, Fe.prototype.setEncoding = function(ei) {
    or || (or = string_decoder.StringDecoder);
    var Vr = new or(ei);
    this._readableState.decoder = Vr, this._readableState.encoding = this._readableState.decoder.encoding;
    for (var qr = this._readableState.buffer.head, Zi = ""; qr !== null; )
      Zi += Vr.write(qr.data), qr = qr.next;
    return this._readableState.buffer.clear(), Zi !== "" && this._readableState.buffer.push(Zi), this._readableState.length = Zi.length, this;
  };
  var xe = 1073741824;
  function rr(ei) {
    return ei >= xe ? ei = xe : (ei--, ei |= ei >>> 1, ei |= ei >>> 2, ei |= ei >>> 4, ei |= ei >>> 8, ei |= ei >>> 16, ei++), ei;
  }
  function ar(ei, Vr) {
    return ei <= 0 || Vr.length === 0 && Vr.ended ? 0 : Vr.objectMode ? 1 : ei !== ei ? Vr.flowing && Vr.length ? Vr.buffer.head.data.length : Vr.length : (ei > Vr.highWaterMark && (Vr.highWaterMark = rr(ei)), ei <= Vr.length ? ei : Vr.ended ? Vr.length : (Vr.needReadable = !0, 0));
  }
  Fe.prototype.read = function(ei) {
    le("read", ei), ei = parseInt(ei, 10);
    var Vr = this._readableState, qr = ei;
    if (ei !== 0 && (Vr.emittedReadable = !1), ei === 0 && Vr.needReadable && ((Vr.highWaterMark !== 0 ? Vr.length >= Vr.highWaterMark : Vr.length > 0) || Vr.ended))
      return le("read: emitReadable", Vr.length, Vr.ended), Vr.length === 0 && Vr.ended ? Ji(this) : _r(this), null;
    if (ei = ar(ei, Vr), ei === 0 && Vr.ended)
      return Vr.length === 0 && Ji(this), null;
    var Zi = Vr.needReadable;
    le("need readable", Zi), (Vr.length === 0 || Vr.length - ei < Vr.highWaterMark) && (Zi = !0, le("length less than watermark", Zi)), Vr.ended || Vr.reading ? (Zi = !1, le("reading or ended", Zi)) : Zi && (le("do read"), Vr.reading = !0, Vr.sync = !0, Vr.length === 0 && (Vr.needReadable = !0), this._read(Vr.highWaterMark), Vr.sync = !1, Vr.reading || (ei = ar(qr, Vr)));
    var Wr;
    return ei > 0 ? Wr = wi(ei, Vr) : Wr = null, Wr === null ? (Vr.needReadable = Vr.length <= Vr.highWaterMark, ei = 0) : (Vr.length -= ei, Vr.awaitDrain = 0), Vr.length === 0 && (Vr.ended || (Vr.needReadable = !0), qr !== ei && Vr.ended && Ji(this)), Wr !== null && this.emit("data", Wr), Wr;
  };
  function yr(ei, Vr) {
    if (le("onEofChunk"), !Vr.ended) {
      if (Vr.decoder) {
        var qr = Vr.decoder.end();
        qr && qr.length && (Vr.buffer.push(qr), Vr.length += Vr.objectMode ? 1 : qr.length);
      }
      Vr.ended = !0, Vr.sync ? _r(ei) : (Vr.needReadable = !1, Vr.emittedReadable || (Vr.emittedReadable = !0, Or(ei)));
    }
  }
  function _r(ei) {
    var Vr = ei._readableState;
    le("emitReadable", Vr.needReadable, Vr.emittedReadable), Vr.needReadable = !1, Vr.emittedReadable || (le("emitReadable", Vr.flowing), Vr.emittedReadable = !0, process$1.nextTick(Or, ei));
  }
  function Or(ei) {
    var Vr = ei._readableState;
    le("emitReadable_", Vr.destroyed, Vr.length, Vr.ended), !Vr.destroyed && (Vr.length || Vr.ended) && (ei.emit("readable"), Vr.emittedReadable = !1), Vr.needReadable = !Vr.flowing && !Vr.ended && Vr.length <= Vr.highWaterMark, Qi(ei);
  }
  function vr(ei, Vr) {
    Vr.readingMore || (Vr.readingMore = !0, process$1.nextTick(Te, ei, Vr));
  }
  function Te(ei, Vr) {
    for (; !Vr.reading && !Vr.ended && (Vr.length < Vr.highWaterMark || Vr.flowing && Vr.length === 0); ) {
      var qr = Vr.length;
      if (le("maybeReadMore read 0"), ei.read(0), qr === Vr.length)
        break;
    }
    Vr.readingMore = !1;
  }
  Fe.prototype._read = function(ei) {
    xr(this, new nr("_read()"));
  }, Fe.prototype.pipe = function(ei, Vr) {
    var qr = this, Zi = this._readableState;
    switch (Zi.pipesCount) {
      case 0:
        Zi.pipes = ei;
        break;
      case 1:
        Zi.pipes = [Zi.pipes, ei];
        break;
      default:
        Zi.pipes.push(ei);
        break;
    }
    Zi.pipesCount += 1, le("pipe count=%d opts=%j", Zi.pipesCount, Vr);
    var Wr = (!Vr || Vr.end !== !1) && ei !== process$1.stdout && ei !== process$1.stderr, ri = Wr ? Er : pn;
    Zi.endEmitted ? process$1.nextTick(ri) : qr.once("end", ri), ei.on("unpipe", _i);
    function _i(hn, Rn) {
      le("onunpipe"), hn === qr && Rn && Rn.hasUnpiped === !1 && (Rn.hasUnpiped = !0, On());
    }
    function Er() {
      le("onend"), ei.end();
    }
    var Di = Cr(qr);
    ei.on("drain", Di);
    var _n = !1;
    function On() {
      le("cleanup"), ei.removeListener("close", gn), ei.removeListener("finish", Gn), ei.removeListener("drain", Di), ei.removeListener("error", Do), ei.removeListener("unpipe", _i), qr.removeListener("end", Er), qr.removeListener("end", pn), qr.removeListener("data", so), _n = !0, Zi.awaitDrain && (!ei._writableState || ei._writableState.needDrain) && Di();
    }
    qr.on("data", so);
    function so(hn) {
      le("ondata");
      var Rn = ei.write(hn);
      le("dest.write", Rn), Rn === !1 && ((Zi.pipesCount === 1 && Zi.pipes === ei || Zi.pipesCount > 1 && pi(Zi.pipes, ei) !== -1) && !_n && (le("false write response, pause", Zi.awaitDrain), Zi.awaitDrain++), qr.pause());
    }
    function Do(hn) {
      le("onerror", hn), pn(), ei.removeListener("error", Do), c(ei, "error") === 0 && xr(ei, hn);
    }
    Ce(ei, "error", Do);
    function gn() {
      ei.removeListener("finish", Gn), pn();
    }
    ei.once("close", gn);
    function Gn() {
      le("onfinish"), ei.removeListener("close", gn), pn();
    }
    ei.once("finish", Gn);
    function pn() {
      le("unpipe"), qr.unpipe(ei);
    }
    return ei.emit("pipe", qr), Zi.flowing || (le("pipe resume"), qr.resume()), ei;
  };
  function Cr(ei) {
    return function() {
      var qr = ei._readableState;
      le("pipeOnDrain", qr.awaitDrain), qr.awaitDrain && qr.awaitDrain--, qr.awaitDrain === 0 && c(ei, "data") && (qr.flowing = !0, Qi(ei));
    };
  }
  Fe.prototype.unpipe = function(ei) {
    var Vr = this._readableState, qr = {
      hasUnpiped: !1
    };
    if (Vr.pipesCount === 0) return this;
    if (Vr.pipesCount === 1)
      return ei && ei !== Vr.pipes ? this : (ei || (ei = Vr.pipes), Vr.pipes = null, Vr.pipesCount = 0, Vr.flowing = !1, ei && ei.emit("unpipe", this, qr), this);
    if (!ei) {
      var Zi = Vr.pipes, Wr = Vr.pipesCount;
      Vr.pipes = null, Vr.pipesCount = 0, Vr.flowing = !1;
      for (var ri = 0; ri < Wr; ri++) Zi[ri].emit("unpipe", this, {
        hasUnpiped: !1
      });
      return this;
    }
    var _i = pi(Vr.pipes, ei);
    return _i === -1 ? this : (Vr.pipes.splice(_i, 1), Vr.pipesCount -= 1, Vr.pipesCount === 1 && (Vr.pipes = Vr.pipes[0]), ei.emit("unpipe", this, qr), this);
  }, Fe.prototype.on = function(ei, Vr) {
    var qr = u.prototype.on.call(this, ei, Vr), Zi = this._readableState;
    return ei === "data" ? (Zi.readableListening = this.listenerCount("readable") > 0, Zi.flowing !== !1 && this.resume()) : ei === "readable" && !Zi.endEmitted && !Zi.readableListening && (Zi.readableListening = Zi.needReadable = !0, Zi.flowing = !1, Zi.emittedReadable = !1, le("on readable", Zi.length, Zi.reading), Zi.length ? _r(this) : Zi.reading || process$1.nextTick(si, this)), qr;
  }, Fe.prototype.addListener = Fe.prototype.on, Fe.prototype.removeListener = function(ei, Vr) {
    var qr = u.prototype.removeListener.call(this, ei, Vr);
    return ei === "readable" && process$1.nextTick(Hr, this), qr;
  }, Fe.prototype.removeAllListeners = function(ei) {
    var Vr = u.prototype.removeAllListeners.apply(this, arguments);
    return (ei === "readable" || ei === void 0) && process$1.nextTick(Hr, this), Vr;
  };
  function Hr(ei) {
    var Vr = ei._readableState;
    Vr.readableListening = ei.listenerCount("readable") > 0, Vr.resumeScheduled && !Vr.paused ? Vr.flowing = !0 : ei.listenerCount("data") > 0 && ei.resume();
  }
  function si(ei) {
    le("readable nexttick read 0"), ei.read(0);
  }
  Fe.prototype.resume = function() {
    var ei = this._readableState;
    return ei.flowing || (le("resume"), ei.flowing = !ei.readableListening, ui(this, ei)), ei.paused = !1, this;
  };
  function ui(ei, Vr) {
    Vr.resumeScheduled || (Vr.resumeScheduled = !0, process$1.nextTick(Li, ei, Vr));
  }
  function Li(ei, Vr) {
    le("resume", Vr.reading), Vr.reading || ei.read(0), Vr.resumeScheduled = !1, ei.emit("resume"), Qi(ei), Vr.flowing && !Vr.reading && ei.read(0);
  }
  Fe.prototype.pause = function() {
    return le("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (le("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
  };
  function Qi(ei) {
    var Vr = ei._readableState;
    for (le("flow", Vr.flowing); Vr.flowing && ei.read() !== null; ) ;
  }
  Fe.prototype.wrap = function(ei) {
    var Vr = this, qr = this._readableState, Zi = !1;
    ei.on("end", function() {
      if (le("wrapped end"), qr.decoder && !qr.ended) {
        var _i = qr.decoder.end();
        _i && _i.length && Vr.push(_i);
      }
      Vr.push(null);
    }), ei.on("data", function(_i) {
      if (le("wrapped data"), qr.decoder && (_i = qr.decoder.write(_i)), !(qr.objectMode && _i == null) && !(!qr.objectMode && (!_i || !_i.length))) {
        var Er = Vr.push(_i);
        Er || (Zi = !0, ei.pause());
      }
    });
    for (var Wr in ei)
      this[Wr] === void 0 && typeof ei[Wr] == "function" && (this[Wr] = /* @__PURE__ */ function(Er) {
        return function() {
          return ei[Er].apply(ei, arguments);
        };
      }(Wr));
    for (var ri = 0; ri < kr.length; ri++)
      ei.on(kr[ri], this.emit.bind(this, kr[ri]));
    return this._read = function(_i) {
      le("wrapped _read", _i), Zi && (Zi = !1, ei.resume());
    }, this;
  }, typeof Symbol == "function" && (Fe.prototype[Symbol.asyncIterator] = function() {
    return lr === void 0 && (lr = requireAsync_iterator()), lr(this);
  }), Object.defineProperty(Fe.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.highWaterMark;
    }
  }), Object.defineProperty(Fe.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState && this._readableState.buffer;
    }
  }), Object.defineProperty(Fe.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.flowing;
    },
    set: function(Vr) {
      this._readableState && (this._readableState.flowing = Vr);
    }
  }), Fe._fromList = wi, Object.defineProperty(Fe.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.length;
    }
  });
  function wi(ei, Vr) {
    if (Vr.length === 0) return null;
    var qr;
    return Vr.objectMode ? qr = Vr.buffer.shift() : !ei || ei >= Vr.length ? (Vr.decoder ? qr = Vr.buffer.join("") : Vr.buffer.length === 1 ? qr = Vr.buffer.first() : qr = Vr.buffer.concat(Vr.length), Vr.buffer.clear()) : qr = Vr.buffer.consume(ei, Vr.decoder), qr;
  }
  function Ji(ei) {
    var Vr = ei._readableState;
    le("endReadable", Vr.endEmitted), Vr.endEmitted || (Vr.ended = !0, process$1.nextTick(mn, Vr, ei));
  }
  function mn(ei, Vr) {
    if (le("endReadableNT", ei.endEmitted, ei.length), !ei.endEmitted && ei.length === 0 && (ei.endEmitted = !0, Vr.readable = !1, Vr.emit("end"), ei.autoDestroy)) {
      var qr = Vr._writableState;
      (!qr || qr.autoDestroy && qr.finished) && Vr.destroy();
    }
  }
  typeof Symbol == "function" && (Fe.from = function(ei, Vr) {
    return Ir === void 0 && (Ir = requireFromBrowser()), Ir(Fe, ei, Vr);
  });
  function pi(ei, Vr) {
    for (var qr = 0, Zi = ei.length; qr < Zi; qr++)
      if (ei[qr] === Vr) return qr;
    return -1;
  }
  return _stream_readable$1;
}
var _stream_transform$1 = Transform$3, _require$codes$1 = errorsBrowser.codes, ERR_METHOD_NOT_IMPLEMENTED = _require$codes$1.ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK = _require$codes$1.ERR_MULTIPLE_CALLBACK, ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes$1.ERR_TRANSFORM_ALREADY_TRANSFORMING, ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes$1.ERR_TRANSFORM_WITH_LENGTH_0, Duplex = require_stream_duplex$1();
inherits_browserExports(Transform$3, Duplex);
function afterTransform(n, c) {
  var u = this._transformState;
  u.transforming = !1;
  var p = u.writecb;
  if (p === null)
    return this.emit("error", new ERR_MULTIPLE_CALLBACK());
  u.writechunk = null, u.writecb = null, c != null && this.push(c), p(n);
  var a = this._readableState;
  a.reading = !1, (a.needReadable || a.length < a.highWaterMark) && this._read(a.highWaterMark);
}
function Transform$3(n) {
  if (!(this instanceof Transform$3)) return new Transform$3(n);
  Duplex.call(this, n), this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: !1,
    transforming: !1,
    writecb: null,
    writechunk: null,
    writeencoding: null
  }, this._readableState.needReadable = !0, this._readableState.sync = !1, n && (typeof n.transform == "function" && (this._transform = n.transform), typeof n.flush == "function" && (this._flush = n.flush)), this.on("prefinish", prefinish);
}
function prefinish() {
  var n = this;
  typeof this._flush == "function" && !this._readableState.destroyed ? this._flush(function(c, u) {
    done(n, c, u);
  }) : done(this, null, null);
}
Transform$3.prototype.push = function(n, c) {
  return this._transformState.needTransform = !1, Duplex.prototype.push.call(this, n, c);
};
Transform$3.prototype._transform = function(n, c, u) {
  u(new ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
};
Transform$3.prototype._write = function(n, c, u) {
  var p = this._transformState;
  if (p.writecb = u, p.writechunk = n, p.writeencoding = c, !p.transforming) {
    var a = this._readableState;
    (p.needTransform || a.needReadable || a.length < a.highWaterMark) && this._read(a.highWaterMark);
  }
};
Transform$3.prototype._read = function(n) {
  var c = this._transformState;
  c.writechunk !== null && !c.transforming ? (c.transforming = !0, this._transform(c.writechunk, c.writeencoding, c.afterTransform)) : c.needTransform = !0;
};
Transform$3.prototype._destroy = function(n, c) {
  Duplex.prototype._destroy.call(this, n, function(u) {
    c(u);
  });
};
function done(n, c, u) {
  if (c) return n.emit("error", c);
  if (u != null && n.push(u), n._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
  if (n._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
  return n.push(null);
}
var _stream_passthrough$1 = PassThrough, Transform$2 = _stream_transform$1;
inherits_browserExports(PassThrough, Transform$2);
function PassThrough(n) {
  if (!(this instanceof PassThrough)) return new PassThrough(n);
  Transform$2.call(this, n);
}
PassThrough.prototype._transform = function(n, c, u) {
  u(null, n);
};
var eos;
function once(n) {
  var c = !1;
  return function() {
    c || (c = !0, n.apply(void 0, arguments));
  };
}
var _require$codes = errorsBrowser.codes, ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS, ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;
function noop$1(n) {
  if (n) throw n;
}
function isRequest(n) {
  return n.setHeader && typeof n.abort == "function";
}
function destroyer(n, c, u, p) {
  p = once(p);
  var a = !1;
  n.on("close", function() {
    a = !0;
  }), eos === void 0 && (eos = endOfStream), eos(n, {
    readable: c,
    writable: u
  }, function(b) {
    if (b) return p(b);
    a = !0, p();
  });
  var A = !1;
  return function(b) {
    if (!a && !A) {
      if (A = !0, isRequest(n)) return n.abort();
      if (typeof n.destroy == "function") return n.destroy();
      p(b || new ERR_STREAM_DESTROYED("pipe"));
    }
  };
}
function call(n) {
  n();
}
function pipe(n, c) {
  return n.pipe(c);
}
function popCallback(n) {
  return !n.length || typeof n[n.length - 1] != "function" ? noop$1 : n.pop();
}
function pipeline() {
  for (var n = arguments.length, c = new Array(n), u = 0; u < n; u++)
    c[u] = arguments[u];
  var p = popCallback(c);
  if (Array.isArray(c[0]) && (c = c[0]), c.length < 2)
    throw new ERR_MISSING_ARGS("streams");
  var a, A = c.map(function(b, F) {
    var le = F < c.length - 1, L = F > 0;
    return destroyer(b, le, L, function(pe) {
      a || (a = pe), pe && A.forEach(call), !le && (A.forEach(call), p(a));
    });
  });
  return c.reduce(pipe);
}
var pipeline_1 = pipeline;
(function(n, c) {
  c = n.exports = require_stream_readable$1(), c.Stream = c, c.Readable = c, c.Writable = require_stream_writable$1(), c.Duplex = require_stream_duplex$1(), c.Transform = _stream_transform$1, c.PassThrough = _stream_passthrough$1, c.finished = endOfStream, c.pipeline = pipeline_1;
})(readableBrowser$1, readableBrowser$1.exports);
var readableBrowserExports = readableBrowser$1.exports, Buffer$c = safeBufferExports.Buffer, Transform$1 = readableBrowserExports.Transform, inherits$f = inherits_browserExports;
function throwIfNotStringOrBuffer(n, c) {
  if (!Buffer$c.isBuffer(n) && typeof n != "string")
    throw new TypeError(c + " must be a string or a buffer");
}
function HashBase$2(n) {
  Transform$1.call(this), this._block = Buffer$c.allocUnsafe(n), this._blockSize = n, this._blockOffset = 0, this._length = [0, 0, 0, 0], this._finalized = !1;
}
inherits$f(HashBase$2, Transform$1);
HashBase$2.prototype._transform = function(n, c, u) {
  var p = null;
  try {
    this.update(n, c);
  } catch (a) {
    p = a;
  }
  u(p);
};
HashBase$2.prototype._flush = function(n) {
  var c = null;
  try {
    this.push(this.digest());
  } catch (u) {
    c = u;
  }
  n(c);
};
HashBase$2.prototype.update = function(n, c) {
  if (throwIfNotStringOrBuffer(n, "Data"), this._finalized) throw new Error("Digest already called");
  Buffer$c.isBuffer(n) || (n = Buffer$c.from(n, c));
  for (var u = this._block, p = 0; this._blockOffset + n.length - p >= this._blockSize; ) {
    for (var a = this._blockOffset; a < this._blockSize; ) u[a++] = n[p++];
    this._update(), this._blockOffset = 0;
  }
  for (; p < n.length; ) u[this._blockOffset++] = n[p++];
  for (var A = 0, b = n.length * 8; b > 0; ++A)
    this._length[A] += b, b = this._length[A] / 4294967296 | 0, b > 0 && (this._length[A] -= 4294967296 * b);
  return this;
};
HashBase$2.prototype._update = function() {
  throw new Error("_update is not implemented");
};
HashBase$2.prototype.digest = function(n) {
  if (this._finalized) throw new Error("Digest already called");
  this._finalized = !0;
  var c = this._digest();
  n !== void 0 && (c = c.toString(n)), this._block.fill(0), this._blockOffset = 0;
  for (var u = 0; u < 4; ++u) this._length[u] = 0;
  return c;
};
HashBase$2.prototype._digest = function() {
  throw new Error("_digest is not implemented");
};
var hashBase$1 = HashBase$2, inherits$e = inherits_browserExports, HashBase$1 = hashBase$1, Buffer$b = safeBufferExports.Buffer, ARRAY16$1 = new Array(16);
function MD5$1() {
  HashBase$1.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878;
}
inherits$e(MD5$1, HashBase$1);
MD5$1.prototype._update = function() {
  for (var n = ARRAY16$1, c = 0; c < 16; ++c) n[c] = this._block.readInt32LE(c * 4);
  var u = this._a, p = this._b, a = this._c, A = this._d;
  u = fnF(u, p, a, A, n[0], 3614090360, 7), A = fnF(A, u, p, a, n[1], 3905402710, 12), a = fnF(a, A, u, p, n[2], 606105819, 17), p = fnF(p, a, A, u, n[3], 3250441966, 22), u = fnF(u, p, a, A, n[4], 4118548399, 7), A = fnF(A, u, p, a, n[5], 1200080426, 12), a = fnF(a, A, u, p, n[6], 2821735955, 17), p = fnF(p, a, A, u, n[7], 4249261313, 22), u = fnF(u, p, a, A, n[8], 1770035416, 7), A = fnF(A, u, p, a, n[9], 2336552879, 12), a = fnF(a, A, u, p, n[10], 4294925233, 17), p = fnF(p, a, A, u, n[11], 2304563134, 22), u = fnF(u, p, a, A, n[12], 1804603682, 7), A = fnF(A, u, p, a, n[13], 4254626195, 12), a = fnF(a, A, u, p, n[14], 2792965006, 17), p = fnF(p, a, A, u, n[15], 1236535329, 22), u = fnG(u, p, a, A, n[1], 4129170786, 5), A = fnG(A, u, p, a, n[6], 3225465664, 9), a = fnG(a, A, u, p, n[11], 643717713, 14), p = fnG(p, a, A, u, n[0], 3921069994, 20), u = fnG(u, p, a, A, n[5], 3593408605, 5), A = fnG(A, u, p, a, n[10], 38016083, 9), a = fnG(a, A, u, p, n[15], 3634488961, 14), p = fnG(p, a, A, u, n[4], 3889429448, 20), u = fnG(u, p, a, A, n[9], 568446438, 5), A = fnG(A, u, p, a, n[14], 3275163606, 9), a = fnG(a, A, u, p, n[3], 4107603335, 14), p = fnG(p, a, A, u, n[8], 1163531501, 20), u = fnG(u, p, a, A, n[13], 2850285829, 5), A = fnG(A, u, p, a, n[2], 4243563512, 9), a = fnG(a, A, u, p, n[7], 1735328473, 14), p = fnG(p, a, A, u, n[12], 2368359562, 20), u = fnH(u, p, a, A, n[5], 4294588738, 4), A = fnH(A, u, p, a, n[8], 2272392833, 11), a = fnH(a, A, u, p, n[11], 1839030562, 16), p = fnH(p, a, A, u, n[14], 4259657740, 23), u = fnH(u, p, a, A, n[1], 2763975236, 4), A = fnH(A, u, p, a, n[4], 1272893353, 11), a = fnH(a, A, u, p, n[7], 4139469664, 16), p = fnH(p, a, A, u, n[10], 3200236656, 23), u = fnH(u, p, a, A, n[13], 681279174, 4), A = fnH(A, u, p, a, n[0], 3936430074, 11), a = fnH(a, A, u, p, n[3], 3572445317, 16), p = fnH(p, a, A, u, n[6], 76029189, 23), u = fnH(u, p, a, A, n[9], 3654602809, 4), A = fnH(A, u, p, a, n[12], 3873151461, 11), a = fnH(a, A, u, p, n[15], 530742520, 16), p = fnH(p, a, A, u, n[2], 3299628645, 23), u = fnI(u, p, a, A, n[0], 4096336452, 6), A = fnI(A, u, p, a, n[7], 1126891415, 10), a = fnI(a, A, u, p, n[14], 2878612391, 15), p = fnI(p, a, A, u, n[5], 4237533241, 21), u = fnI(u, p, a, A, n[12], 1700485571, 6), A = fnI(A, u, p, a, n[3], 2399980690, 10), a = fnI(a, A, u, p, n[10], 4293915773, 15), p = fnI(p, a, A, u, n[1], 2240044497, 21), u = fnI(u, p, a, A, n[8], 1873313359, 6), A = fnI(A, u, p, a, n[15], 4264355552, 10), a = fnI(a, A, u, p, n[6], 2734768916, 15), p = fnI(p, a, A, u, n[13], 1309151649, 21), u = fnI(u, p, a, A, n[4], 4149444226, 6), A = fnI(A, u, p, a, n[11], 3174756917, 10), a = fnI(a, A, u, p, n[2], 718787259, 15), p = fnI(p, a, A, u, n[9], 3951481745, 21), this._a = this._a + u | 0, this._b = this._b + p | 0, this._c = this._c + a | 0, this._d = this._d + A | 0;
};
MD5$1.prototype._digest = function() {
  this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
  var n = Buffer$b.allocUnsafe(16);
  return n.writeInt32LE(this._a, 0), n.writeInt32LE(this._b, 4), n.writeInt32LE(this._c, 8), n.writeInt32LE(this._d, 12), n;
};
function rotl$5(n, c) {
  return n << c | n >>> 32 - c;
}
function fnF(n, c, u, p, a, A, b) {
  return rotl$5(n + (c & u | ~c & p) + a + A | 0, b) + c | 0;
}
function fnG(n, c, u, p, a, A, b) {
  return rotl$5(n + (c & p | u & ~p) + a + A | 0, b) + c | 0;
}
function fnH(n, c, u, p, a, A, b) {
  return rotl$5(n + (c ^ u ^ p) + a + A | 0, b) + c | 0;
}
function fnI(n, c, u, p, a, A, b) {
  return rotl$5(n + (u ^ (c | ~p)) + a + A | 0, b) + c | 0;
}
var md5_js = MD5$1, Buffer$a = require$$0$5.Buffer, inherits$d = inherits_browserExports, HashBase = hashBase$1, ARRAY16 = new Array(16), zl = [
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  7,
  4,
  13,
  1,
  10,
  6,
  15,
  3,
  12,
  0,
  9,
  5,
  2,
  14,
  11,
  8,
  3,
  10,
  14,
  4,
  9,
  15,
  8,
  1,
  2,
  7,
  0,
  6,
  13,
  11,
  5,
  12,
  1,
  9,
  11,
  10,
  0,
  8,
  12,
  4,
  13,
  3,
  7,
  15,
  14,
  5,
  6,
  2,
  4,
  0,
  5,
  9,
  7,
  12,
  2,
  10,
  14,
  1,
  3,
  8,
  11,
  6,
  15,
  13
], zr = [
  5,
  14,
  7,
  0,
  9,
  2,
  11,
  4,
  13,
  6,
  15,
  8,
  1,
  10,
  3,
  12,
  6,
  11,
  3,
  7,
  0,
  13,
  5,
  10,
  14,
  15,
  8,
  12,
  4,
  9,
  1,
  2,
  15,
  5,
  1,
  3,
  7,
  14,
  6,
  9,
  11,
  8,
  12,
  2,
  10,
  0,
  4,
  13,
  8,
  6,
  4,
  1,
  3,
  11,
  15,
  0,
  5,
  12,
  2,
  13,
  9,
  7,
  10,
  14,
  12,
  15,
  10,
  4,
  1,
  5,
  8,
  7,
  6,
  2,
  13,
  14,
  0,
  3,
  9,
  11
], sl = [
  11,
  14,
  15,
  12,
  5,
  8,
  7,
  9,
  11,
  13,
  14,
  15,
  6,
  7,
  9,
  8,
  7,
  6,
  8,
  13,
  11,
  9,
  7,
  15,
  7,
  12,
  15,
  9,
  11,
  7,
  13,
  12,
  11,
  13,
  6,
  7,
  14,
  9,
  13,
  15,
  14,
  8,
  13,
  6,
  5,
  12,
  7,
  5,
  11,
  12,
  14,
  15,
  14,
  15,
  9,
  8,
  9,
  14,
  5,
  6,
  8,
  6,
  5,
  12,
  9,
  15,
  5,
  11,
  6,
  8,
  13,
  12,
  5,
  12,
  13,
  14,
  11,
  8,
  5,
  6
], sr = [
  8,
  9,
  9,
  11,
  13,
  15,
  15,
  5,
  7,
  7,
  8,
  11,
  14,
  14,
  12,
  6,
  9,
  13,
  15,
  7,
  12,
  8,
  9,
  11,
  7,
  7,
  12,
  7,
  6,
  15,
  13,
  11,
  9,
  7,
  15,
  11,
  8,
  6,
  6,
  14,
  12,
  13,
  5,
  14,
  13,
  13,
  7,
  5,
  15,
  5,
  8,
  11,
  14,
  14,
  6,
  14,
  6,
  9,
  12,
  9,
  12,
  5,
  15,
  8,
  8,
  5,
  12,
  9,
  12,
  5,
  14,
  6,
  8,
  13,
  6,
  5,
  15,
  13,
  11,
  11
], hl = [0, 1518500249, 1859775393, 2400959708, 2840853838], hr = [1352829926, 1548603684, 1836072691, 2053994217, 0];
function RIPEMD160$5() {
  HashBase.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520;
}
inherits$d(RIPEMD160$5, HashBase);
RIPEMD160$5.prototype._update = function() {
  for (var n = ARRAY16, c = 0; c < 16; ++c) n[c] = this._block.readInt32LE(c * 4);
  for (var u = this._a | 0, p = this._b | 0, a = this._c | 0, A = this._d | 0, b = this._e | 0, F = this._a | 0, le = this._b | 0, L = this._c | 0, pe = this._d | 0, $ = this._e | 0, Ee = 0; Ee < 80; Ee += 1) {
    var be, He;
    Ee < 16 ? (be = fn1(u, p, a, A, b, n[zl[Ee]], hl[0], sl[Ee]), He = fn5(F, le, L, pe, $, n[zr[Ee]], hr[0], sr[Ee])) : Ee < 32 ? (be = fn2(u, p, a, A, b, n[zl[Ee]], hl[1], sl[Ee]), He = fn4(F, le, L, pe, $, n[zr[Ee]], hr[1], sr[Ee])) : Ee < 48 ? (be = fn3(u, p, a, A, b, n[zl[Ee]], hl[2], sl[Ee]), He = fn3(F, le, L, pe, $, n[zr[Ee]], hr[2], sr[Ee])) : Ee < 64 ? (be = fn4(u, p, a, A, b, n[zl[Ee]], hl[3], sl[Ee]), He = fn2(F, le, L, pe, $, n[zr[Ee]], hr[3], sr[Ee])) : (be = fn5(u, p, a, A, b, n[zl[Ee]], hl[4], sl[Ee]), He = fn1(F, le, L, pe, $, n[zr[Ee]], hr[4], sr[Ee])), u = b, b = A, A = rotl$4(a, 10), a = p, p = be, F = $, $ = pe, pe = rotl$4(L, 10), L = le, le = He;
  }
  var Pe = this._b + a + pe | 0;
  this._b = this._c + A + $ | 0, this._c = this._d + b + F | 0, this._d = this._e + u + le | 0, this._e = this._a + p + L | 0, this._a = Pe;
};
RIPEMD160$5.prototype._digest = function() {
  this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
  var n = Buffer$a.alloc ? Buffer$a.alloc(20) : new Buffer$a(20);
  return n.writeInt32LE(this._a, 0), n.writeInt32LE(this._b, 4), n.writeInt32LE(this._c, 8), n.writeInt32LE(this._d, 12), n.writeInt32LE(this._e, 16), n;
};
function rotl$4(n, c) {
  return n << c | n >>> 32 - c;
}
function fn1(n, c, u, p, a, A, b, F) {
  return rotl$4(n + (c ^ u ^ p) + A + b | 0, F) + a | 0;
}
function fn2(n, c, u, p, a, A, b, F) {
  return rotl$4(n + (c & u | ~c & p) + A + b | 0, F) + a | 0;
}
function fn3(n, c, u, p, a, A, b, F) {
  return rotl$4(n + ((c | ~u) ^ p) + A + b | 0, F) + a | 0;
}
function fn4(n, c, u, p, a, A, b, F) {
  return rotl$4(n + (c & p | u & ~p) + A + b | 0, F) + a | 0;
}
function fn5(n, c, u, p, a, A, b, F) {
  return rotl$4(n + (c ^ (u | ~p)) + A + b | 0, F) + a | 0;
}
var ripemd160$5 = RIPEMD160$5, sha_js = { exports: {} }, Buffer$9 = safeBufferExports.Buffer;
function Hash$f(n, c) {
  this._block = Buffer$9.alloc(n), this._finalSize = c, this._blockSize = n, this._len = 0;
}
Hash$f.prototype.update = function(n, c) {
  typeof n == "string" && (c = c || "utf8", n = Buffer$9.from(n, c));
  for (var u = this._block, p = this._blockSize, a = n.length, A = this._len, b = 0; b < a; ) {
    for (var F = A % p, le = Math.min(a - b, p - F), L = 0; L < le; L++)
      u[F + L] = n[b + L];
    A += le, b += le, A % p === 0 && this._update(u);
  }
  return this._len += a, this;
};
Hash$f.prototype.digest = function(n) {
  var c = this._len % this._blockSize;
  this._block[c] = 128, this._block.fill(0, c + 1), c >= this._finalSize && (this._update(this._block), this._block.fill(0));
  var u = this._len * 8;
  if (u <= 4294967295)
    this._block.writeUInt32BE(u, this._blockSize - 4);
  else {
    var p = (u & 4294967295) >>> 0, a = (u - p) / 4294967296;
    this._block.writeUInt32BE(a, this._blockSize - 8), this._block.writeUInt32BE(p, this._blockSize - 4);
  }
  this._update(this._block);
  var A = this._hash();
  return n ? A.toString(n) : A;
};
Hash$f.prototype._update = function() {
  throw new Error("_update must be implemented by subclass");
};
var hash$b = Hash$f, inherits$c = inherits_browserExports, Hash$e = hash$b, Buffer$8 = safeBufferExports.Buffer, K$5 = [
  1518500249,
  1859775393,
  -1894007588,
  -899497514
], W$6 = new Array(80);
function Sha() {
  this.init(), this._w = W$6, Hash$e.call(this, 64, 56);
}
inherits$c(Sha, Hash$e);
Sha.prototype.init = function() {
  return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
};
function rotl5$1(n) {
  return n << 5 | n >>> 27;
}
function rotl30$1(n) {
  return n << 30 | n >>> 2;
}
function ft$2(n, c, u, p) {
  return n === 0 ? c & u | ~c & p : n === 2 ? c & u | c & p | u & p : c ^ u ^ p;
}
Sha.prototype._update = function(n) {
  for (var c = this._w, u = this._a | 0, p = this._b | 0, a = this._c | 0, A = this._d | 0, b = this._e | 0, F = 0; F < 16; ++F) c[F] = n.readInt32BE(F * 4);
  for (; F < 80; ++F) c[F] = c[F - 3] ^ c[F - 8] ^ c[F - 14] ^ c[F - 16];
  for (var le = 0; le < 80; ++le) {
    var L = ~~(le / 20), pe = rotl5$1(u) + ft$2(L, p, a, A) + b + c[le] + K$5[L] | 0;
    b = A, A = a, a = rotl30$1(p), p = u, u = pe;
  }
  this._a = u + this._a | 0, this._b = p + this._b | 0, this._c = a + this._c | 0, this._d = A + this._d | 0, this._e = b + this._e | 0;
};
Sha.prototype._hash = function() {
  var n = Buffer$8.allocUnsafe(20);
  return n.writeInt32BE(this._a | 0, 0), n.writeInt32BE(this._b | 0, 4), n.writeInt32BE(this._c | 0, 8), n.writeInt32BE(this._d | 0, 12), n.writeInt32BE(this._e | 0, 16), n;
};
var sha$3 = Sha, inherits$b = inherits_browserExports, Hash$d = hash$b, Buffer$7 = safeBufferExports.Buffer, K$4 = [
  1518500249,
  1859775393,
  -1894007588,
  -899497514
], W$5 = new Array(80);
function Sha1() {
  this.init(), this._w = W$5, Hash$d.call(this, 64, 56);
}
inherits$b(Sha1, Hash$d);
Sha1.prototype.init = function() {
  return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
};
function rotl1(n) {
  return n << 1 | n >>> 31;
}
function rotl5(n) {
  return n << 5 | n >>> 27;
}
function rotl30(n) {
  return n << 30 | n >>> 2;
}
function ft$1(n, c, u, p) {
  return n === 0 ? c & u | ~c & p : n === 2 ? c & u | c & p | u & p : c ^ u ^ p;
}
Sha1.prototype._update = function(n) {
  for (var c = this._w, u = this._a | 0, p = this._b | 0, a = this._c | 0, A = this._d | 0, b = this._e | 0, F = 0; F < 16; ++F) c[F] = n.readInt32BE(F * 4);
  for (; F < 80; ++F) c[F] = rotl1(c[F - 3] ^ c[F - 8] ^ c[F - 14] ^ c[F - 16]);
  for (var le = 0; le < 80; ++le) {
    var L = ~~(le / 20), pe = rotl5(u) + ft$1(L, p, a, A) + b + c[le] + K$4[L] | 0;
    b = A, A = a, a = rotl30(p), p = u, u = pe;
  }
  this._a = u + this._a | 0, this._b = p + this._b | 0, this._c = a + this._c | 0, this._d = A + this._d | 0, this._e = b + this._e | 0;
};
Sha1.prototype._hash = function() {
  var n = Buffer$7.allocUnsafe(20);
  return n.writeInt32BE(this._a | 0, 0), n.writeInt32BE(this._b | 0, 4), n.writeInt32BE(this._c | 0, 8), n.writeInt32BE(this._d | 0, 12), n.writeInt32BE(this._e | 0, 16), n;
};
var sha1$c = Sha1, inherits$a = inherits_browserExports, Hash$c = hash$b, Buffer$6 = safeBufferExports.Buffer, K$3 = [
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
], W$4 = new Array(64);
function Sha256$2() {
  this.init(), this._w = W$4, Hash$c.call(this, 64, 56);
}
inherits$a(Sha256$2, Hash$c);
Sha256$2.prototype.init = function() {
  return this._a = 1779033703, this._b = 3144134277, this._c = 1013904242, this._d = 2773480762, this._e = 1359893119, this._f = 2600822924, this._g = 528734635, this._h = 1541459225, this;
};
function ch(n, c, u) {
  return u ^ n & (c ^ u);
}
function maj$1(n, c, u) {
  return n & c | u & (n | c);
}
function sigma0$1(n) {
  return (n >>> 2 | n << 30) ^ (n >>> 13 | n << 19) ^ (n >>> 22 | n << 10);
}
function sigma1$1(n) {
  return (n >>> 6 | n << 26) ^ (n >>> 11 | n << 21) ^ (n >>> 25 | n << 7);
}
function gamma0(n) {
  return (n >>> 7 | n << 25) ^ (n >>> 18 | n << 14) ^ n >>> 3;
}
function gamma1(n) {
  return (n >>> 17 | n << 15) ^ (n >>> 19 | n << 13) ^ n >>> 10;
}
Sha256$2.prototype._update = function(n) {
  for (var c = this._w, u = this._a | 0, p = this._b | 0, a = this._c | 0, A = this._d | 0, b = this._e | 0, F = this._f | 0, le = this._g | 0, L = this._h | 0, pe = 0; pe < 16; ++pe) c[pe] = n.readInt32BE(pe * 4);
  for (; pe < 64; ++pe) c[pe] = gamma1(c[pe - 2]) + c[pe - 7] + gamma0(c[pe - 15]) + c[pe - 16] | 0;
  for (var $ = 0; $ < 64; ++$) {
    var Ee = L + sigma1$1(b) + ch(b, F, le) + K$3[$] + c[$] | 0, be = sigma0$1(u) + maj$1(u, p, a) | 0;
    L = le, le = F, F = b, b = A + Ee | 0, A = a, a = p, p = u, u = Ee + be | 0;
  }
  this._a = u + this._a | 0, this._b = p + this._b | 0, this._c = a + this._c | 0, this._d = A + this._d | 0, this._e = b + this._e | 0, this._f = F + this._f | 0, this._g = le + this._g | 0, this._h = L + this._h | 0;
};
Sha256$2.prototype._hash = function() {
  var n = Buffer$6.allocUnsafe(32);
  return n.writeInt32BE(this._a, 0), n.writeInt32BE(this._b, 4), n.writeInt32BE(this._c, 8), n.writeInt32BE(this._d, 12), n.writeInt32BE(this._e, 16), n.writeInt32BE(this._f, 20), n.writeInt32BE(this._g, 24), n.writeInt32BE(this._h, 28), n;
};
var sha256$d = Sha256$2, inherits$9 = inherits_browserExports, Sha256$1 = sha256$d, Hash$b = hash$b, Buffer$5 = safeBufferExports.Buffer, W$3 = new Array(64);
function Sha224() {
  this.init(), this._w = W$3, Hash$b.call(this, 64, 56);
}
inherits$9(Sha224, Sha256$1);
Sha224.prototype.init = function() {
  return this._a = 3238371032, this._b = 914150663, this._c = 812702999, this._d = 4144912697, this._e = 4290775857, this._f = 1750603025, this._g = 1694076839, this._h = 3204075428, this;
};
Sha224.prototype._hash = function() {
  var n = Buffer$5.allocUnsafe(28);
  return n.writeInt32BE(this._a, 0), n.writeInt32BE(this._b, 4), n.writeInt32BE(this._c, 8), n.writeInt32BE(this._d, 12), n.writeInt32BE(this._e, 16), n.writeInt32BE(this._f, 20), n.writeInt32BE(this._g, 24), n;
};
var sha224$1 = Sha224, inherits$8 = inherits_browserExports, Hash$a = hash$b, Buffer$4 = safeBufferExports.Buffer, K$2 = [
  1116352408,
  3609767458,
  1899447441,
  602891725,
  3049323471,
  3964484399,
  3921009573,
  2173295548,
  961987163,
  4081628472,
  1508970993,
  3053834265,
  2453635748,
  2937671579,
  2870763221,
  3664609560,
  3624381080,
  2734883394,
  310598401,
  1164996542,
  607225278,
  1323610764,
  1426881987,
  3590304994,
  1925078388,
  4068182383,
  2162078206,
  991336113,
  2614888103,
  633803317,
  3248222580,
  3479774868,
  3835390401,
  2666613458,
  4022224774,
  944711139,
  264347078,
  2341262773,
  604807628,
  2007800933,
  770255983,
  1495990901,
  1249150122,
  1856431235,
  1555081692,
  3175218132,
  1996064986,
  2198950837,
  2554220882,
  3999719339,
  2821834349,
  766784016,
  2952996808,
  2566594879,
  3210313671,
  3203337956,
  3336571891,
  1034457026,
  3584528711,
  2466948901,
  113926993,
  3758326383,
  338241895,
  168717936,
  666307205,
  1188179964,
  773529912,
  1546045734,
  1294757372,
  1522805485,
  1396182291,
  2643833823,
  1695183700,
  2343527390,
  1986661051,
  1014477480,
  2177026350,
  1206759142,
  2456956037,
  344077627,
  2730485921,
  1290863460,
  2820302411,
  3158454273,
  3259730800,
  3505952657,
  3345764771,
  106217008,
  3516065817,
  3606008344,
  3600352804,
  1432725776,
  4094571909,
  1467031594,
  275423344,
  851169720,
  430227734,
  3100823752,
  506948616,
  1363258195,
  659060556,
  3750685593,
  883997877,
  3785050280,
  958139571,
  3318307427,
  1322822218,
  3812723403,
  1537002063,
  2003034995,
  1747873779,
  3602036899,
  1955562222,
  1575990012,
  2024104815,
  1125592928,
  2227730452,
  2716904306,
  2361852424,
  442776044,
  2428436474,
  593698344,
  2756734187,
  3733110249,
  3204031479,
  2999351573,
  3329325298,
  3815920427,
  3391569614,
  3928383900,
  3515267271,
  566280711,
  3940187606,
  3454069534,
  4118630271,
  4000239992,
  116418474,
  1914138554,
  174292421,
  2731055270,
  289380356,
  3203993006,
  460393269,
  320620315,
  685471733,
  587496836,
  852142971,
  1086792851,
  1017036298,
  365543100,
  1126000580,
  2618297676,
  1288033470,
  3409855158,
  1501505948,
  4234509866,
  1607167915,
  987167468,
  1816402316,
  1246189591
], W$2 = new Array(160);
function Sha512$1() {
  this.init(), this._w = W$2, Hash$a.call(this, 128, 112);
}
inherits$8(Sha512$1, Hash$a);
Sha512$1.prototype.init = function() {
  return this._ah = 1779033703, this._bh = 3144134277, this._ch = 1013904242, this._dh = 2773480762, this._eh = 1359893119, this._fh = 2600822924, this._gh = 528734635, this._hh = 1541459225, this._al = 4089235720, this._bl = 2227873595, this._cl = 4271175723, this._dl = 1595750129, this._el = 2917565137, this._fl = 725511199, this._gl = 4215389547, this._hl = 327033209, this;
};
function Ch(n, c, u) {
  return u ^ n & (c ^ u);
}
function maj(n, c, u) {
  return n & c | u & (n | c);
}
function sigma0(n, c) {
  return (n >>> 28 | c << 4) ^ (c >>> 2 | n << 30) ^ (c >>> 7 | n << 25);
}
function sigma1(n, c) {
  return (n >>> 14 | c << 18) ^ (n >>> 18 | c << 14) ^ (c >>> 9 | n << 23);
}
function Gamma0(n, c) {
  return (n >>> 1 | c << 31) ^ (n >>> 8 | c << 24) ^ n >>> 7;
}
function Gamma0l(n, c) {
  return (n >>> 1 | c << 31) ^ (n >>> 8 | c << 24) ^ (n >>> 7 | c << 25);
}
function Gamma1(n, c) {
  return (n >>> 19 | c << 13) ^ (c >>> 29 | n << 3) ^ n >>> 6;
}
function Gamma1l(n, c) {
  return (n >>> 19 | c << 13) ^ (c >>> 29 | n << 3) ^ (n >>> 6 | c << 26);
}
function getCarry(n, c) {
  return n >>> 0 < c >>> 0 ? 1 : 0;
}
Sha512$1.prototype._update = function(n) {
  for (var c = this._w, u = this._ah | 0, p = this._bh | 0, a = this._ch | 0, A = this._dh | 0, b = this._eh | 0, F = this._fh | 0, le = this._gh | 0, L = this._hh | 0, pe = this._al | 0, $ = this._bl | 0, Ee = this._cl | 0, be = this._dl | 0, He = this._el | 0, Pe = this._fl | 0, nr = this._gl | 0, ir = this._hl | 0, or = 0; or < 32; or += 2)
    c[or] = n.readInt32BE(or * 4), c[or + 1] = n.readInt32BE(or * 4 + 4);
  for (; or < 160; or += 2) {
    var lr = c[or - 30], Ir = c[or - 15 * 2 + 1], xr = Gamma0(lr, Ir), kr = Gamma0l(Ir, lr);
    lr = c[or - 2 * 2], Ir = c[or - 2 * 2 + 1];
    var Ce = Gamma1(lr, Ir), tr = Gamma1l(Ir, lr), Fe = c[or - 7 * 2], Sr = c[or - 7 * 2 + 1], er = c[or - 16 * 2], Ie = c[or - 16 * 2 + 1], xe = kr + Sr | 0, rr = xr + Fe + getCarry(xe, kr) | 0;
    xe = xe + tr | 0, rr = rr + Ce + getCarry(xe, tr) | 0, xe = xe + Ie | 0, rr = rr + er + getCarry(xe, Ie) | 0, c[or] = rr, c[or + 1] = xe;
  }
  for (var ar = 0; ar < 160; ar += 2) {
    rr = c[ar], xe = c[ar + 1];
    var yr = maj(u, p, a), _r = maj(pe, $, Ee), Or = sigma0(u, pe), vr = sigma0(pe, u), Te = sigma1(b, He), Cr = sigma1(He, b), Hr = K$2[ar], si = K$2[ar + 1], ui = Ch(b, F, le), Li = Ch(He, Pe, nr), Qi = ir + Cr | 0, wi = L + Te + getCarry(Qi, ir) | 0;
    Qi = Qi + Li | 0, wi = wi + ui + getCarry(Qi, Li) | 0, Qi = Qi + si | 0, wi = wi + Hr + getCarry(Qi, si) | 0, Qi = Qi + xe | 0, wi = wi + rr + getCarry(Qi, xe) | 0;
    var Ji = vr + _r | 0, mn = Or + yr + getCarry(Ji, vr) | 0;
    L = le, ir = nr, le = F, nr = Pe, F = b, Pe = He, He = be + Qi | 0, b = A + wi + getCarry(He, be) | 0, A = a, be = Ee, a = p, Ee = $, p = u, $ = pe, pe = Qi + Ji | 0, u = wi + mn + getCarry(pe, Qi) | 0;
  }
  this._al = this._al + pe | 0, this._bl = this._bl + $ | 0, this._cl = this._cl + Ee | 0, this._dl = this._dl + be | 0, this._el = this._el + He | 0, this._fl = this._fl + Pe | 0, this._gl = this._gl + nr | 0, this._hl = this._hl + ir | 0, this._ah = this._ah + u + getCarry(this._al, pe) | 0, this._bh = this._bh + p + getCarry(this._bl, $) | 0, this._ch = this._ch + a + getCarry(this._cl, Ee) | 0, this._dh = this._dh + A + getCarry(this._dl, be) | 0, this._eh = this._eh + b + getCarry(this._el, He) | 0, this._fh = this._fh + F + getCarry(this._fl, Pe) | 0, this._gh = this._gh + le + getCarry(this._gl, nr) | 0, this._hh = this._hh + L + getCarry(this._hl, ir) | 0;
};
Sha512$1.prototype._hash = function() {
  var n = Buffer$4.allocUnsafe(64);
  function c(u, p, a) {
    n.writeInt32BE(u, a), n.writeInt32BE(p, a + 4);
  }
  return c(this._ah, this._al, 0), c(this._bh, this._bl, 8), c(this._ch, this._cl, 16), c(this._dh, this._dl, 24), c(this._eh, this._el, 32), c(this._fh, this._fl, 40), c(this._gh, this._gl, 48), c(this._hh, this._hl, 56), n;
};
var sha512$5 = Sha512$1, inherits$7 = inherits_browserExports, SHA512$4 = sha512$5, Hash$9 = hash$b, Buffer$3 = safeBufferExports.Buffer, W$1 = new Array(160);
function Sha384() {
  this.init(), this._w = W$1, Hash$9.call(this, 128, 112);
}
inherits$7(Sha384, SHA512$4);
Sha384.prototype.init = function() {
  return this._ah = 3418070365, this._bh = 1654270250, this._ch = 2438529370, this._dh = 355462360, this._eh = 1731405415, this._fh = 2394180231, this._gh = 3675008525, this._hh = 1203062813, this._al = 3238371032, this._bl = 914150663, this._cl = 812702999, this._dl = 4144912697, this._el = 4290775857, this._fl = 1750603025, this._gl = 1694076839, this._hl = 3204075428, this;
};
Sha384.prototype._hash = function() {
  var n = Buffer$3.allocUnsafe(48);
  function c(u, p, a) {
    n.writeInt32BE(u, a), n.writeInt32BE(p, a + 4);
  }
  return c(this._ah, this._al, 0), c(this._bh, this._bl, 8), c(this._ch, this._cl, 16), c(this._dh, this._dl, 24), c(this._eh, this._el, 32), c(this._fh, this._fl, 40), n;
};
var sha384$1 = Sha384, exports = sha_js.exports = function(c) {
  c = c.toLowerCase();
  var u = exports[c];
  if (!u) throw new Error(c + " is not supported (we accept pull requests)");
  return new u();
};
exports.sha = sha$3;
exports.sha1 = sha1$c;
exports.sha224 = sha224$1;
exports.sha256 = sha256$d;
exports.sha384 = sha384$1;
exports.sha512 = sha512$5;
var sha_jsExports = sha_js.exports, streamBrowserify = Stream$2, EE = eventsExports.EventEmitter, inherits$6 = inherits_browserExports;
inherits$6(Stream$2, EE);
Stream$2.Readable = require_stream_readable$1();
Stream$2.Writable = require_stream_writable$1();
Stream$2.Duplex = require_stream_duplex$1();
Stream$2.Transform = _stream_transform$1;
Stream$2.PassThrough = _stream_passthrough$1;
Stream$2.finished = endOfStream;
Stream$2.pipeline = pipeline_1;
Stream$2.Stream = Stream$2;
function Stream$2() {
  EE.call(this);
}
Stream$2.prototype.pipe = function(n, c) {
  var u = this;
  function p(pe) {
    n.writable && n.write(pe) === !1 && u.pause && u.pause();
  }
  u.on("data", p);
  function a() {
    u.readable && u.resume && u.resume();
  }
  n.on("drain", a), !n._isStdio && (!c || c.end !== !1) && (u.on("end", b), u.on("close", F));
  var A = !1;
  function b() {
    A || (A = !0, n.end());
  }
  function F() {
    A || (A = !0, typeof n.destroy == "function" && n.destroy());
  }
  function le(pe) {
    if (L(), EE.listenerCount(this, "error") === 0)
      throw pe;
  }
  u.on("error", le), n.on("error", le);
  function L() {
    u.removeListener("data", p), n.removeListener("drain", a), u.removeListener("end", b), u.removeListener("close", F), u.removeListener("error", le), n.removeListener("error", le), u.removeListener("end", L), u.removeListener("close", L), n.removeListener("close", L);
  }
  return u.on("end", L), u.on("close", L), n.on("close", L), n.emit("pipe", u), n;
};
var Buffer$2 = safeBufferExports.Buffer, Transform = streamBrowserify.Transform, StringDecoder = string_decoder.StringDecoder, inherits$5 = inherits_browserExports;
function CipherBase(n) {
  Transform.call(this), this.hashMode = typeof n == "string", this.hashMode ? this[n] = this._finalOrDigest : this.final = this._finalOrDigest, this._final && (this.__final = this._final, this._final = null), this._decoder = null, this._encoding = null;
}
inherits$5(CipherBase, Transform);
var useUint8Array = typeof Uint8Array < "u", useArrayBuffer = typeof ArrayBuffer < "u" && typeof Uint8Array < "u" && ArrayBuffer.isView && (Buffer$2.prototype instanceof Uint8Array || Buffer$2.TYPED_ARRAY_SUPPORT);
function toBuffer$1(n, c) {
  if (n instanceof Buffer$2)
    return n;
  if (typeof n == "string")
    return Buffer$2.from(n, c);
  if (useArrayBuffer && ArrayBuffer.isView(n)) {
    if (n.byteLength === 0)
      return Buffer$2.alloc(0);
    var u = Buffer$2.from(n.buffer, n.byteOffset, n.byteLength);
    if (u.byteLength === n.byteLength)
      return u;
  }
  if (useUint8Array && n instanceof Uint8Array || Buffer$2.isBuffer(n) && n.constructor && typeof n.constructor.isBuffer == "function" && n.constructor.isBuffer(n))
    return Buffer$2.from(n);
  throw new TypeError('The "data" argument must be of type string or an instance of Buffer, TypedArray, or DataView.');
}
CipherBase.prototype.update = function(n, c, u) {
  var p = toBuffer$1(n, c), a = this._update(p);
  return this.hashMode ? this : (u && (a = this._toString(a, u)), a);
};
CipherBase.prototype.setAutoPadding = function() {
};
CipherBase.prototype.getAuthTag = function() {
  throw new Error("trying to get auth tag in unsupported state");
};
CipherBase.prototype.setAuthTag = function() {
  throw new Error("trying to set auth tag in unsupported state");
};
CipherBase.prototype.setAAD = function() {
  throw new Error("trying to set aad in unsupported state");
};
CipherBase.prototype._transform = function(n, c, u) {
  var p;
  try {
    this.hashMode ? this._update(n) : this.push(this._update(n));
  } catch (a) {
    p = a;
  } finally {
    u(p);
  }
};
CipherBase.prototype._flush = function(n) {
  var c;
  try {
    this.push(this.__final());
  } catch (u) {
    c = u;
  }
  n(c);
};
CipherBase.prototype._finalOrDigest = function(n) {
  var c = this.__final() || Buffer$2.alloc(0);
  return n && (c = this._toString(c, n, !0)), c;
};
CipherBase.prototype._toString = function(n, c, u) {
  if (this._decoder || (this._decoder = new StringDecoder(c), this._encoding = c), this._encoding !== c)
    throw new Error("can’t switch encodings");
  var p = this._decoder.write(n);
  return u && (p += this._decoder.end()), p;
};
var cipherBase = CipherBase, inherits$4 = inherits_browserExports, MD5 = md5_js, RIPEMD160$4 = ripemd160$5, sha$2 = sha_jsExports, Base$4 = cipherBase;
function Hash$8(n) {
  Base$4.call(this, "digest"), this._hash = n;
}
inherits$4(Hash$8, Base$4);
Hash$8.prototype._update = function(n) {
  this._hash.update(n);
};
Hash$8.prototype._final = function() {
  return this._hash.digest();
};
var browser$a = function(c) {
  return c = c.toLowerCase(), c === "md5" ? new MD5() : c === "rmd160" || c === "ripemd160" ? new RIPEMD160$4() : new Hash$8(sha$2(c));
}, _Buffer$2 = safeBufferExports.Buffer;
function base$j(n) {
  if (n.length >= 255)
    throw new TypeError("Alphabet too long");
  for (var c = new Uint8Array(256), u = 0; u < c.length; u++)
    c[u] = 255;
  for (var p = 0; p < n.length; p++) {
    var a = n.charAt(p), A = a.charCodeAt(0);
    if (c[A] !== 255)
      throw new TypeError(a + " is ambiguous");
    c[A] = p;
  }
  var b = n.length, F = n.charAt(0), le = Math.log(b) / Math.log(256), L = Math.log(256) / Math.log(b);
  function pe(be) {
    if ((Array.isArray(be) || be instanceof Uint8Array) && (be = _Buffer$2.from(be)), !_Buffer$2.isBuffer(be))
      throw new TypeError("Expected Buffer");
    if (be.length === 0)
      return "";
    for (var He = 0, Pe = 0, nr = 0, ir = be.length; nr !== ir && be[nr] === 0; )
      nr++, He++;
    for (var or = (ir - nr) * L + 1 >>> 0, lr = new Uint8Array(or); nr !== ir; ) {
      for (var Ir = be[nr], xr = 0, kr = or - 1; (Ir !== 0 || xr < Pe) && kr !== -1; kr--, xr++)
        Ir += 256 * lr[kr] >>> 0, lr[kr] = Ir % b >>> 0, Ir = Ir / b >>> 0;
      if (Ir !== 0)
        throw new Error("Non-zero carry");
      Pe = xr, nr++;
    }
    for (var Ce = or - Pe; Ce !== or && lr[Ce] === 0; )
      Ce++;
    for (var tr = F.repeat(He); Ce < or; ++Ce)
      tr += n.charAt(lr[Ce]);
    return tr;
  }
  function $(be) {
    if (typeof be != "string")
      throw new TypeError("Expected String");
    if (be.length === 0)
      return _Buffer$2.alloc(0);
    for (var He = 0, Pe = 0, nr = 0; be[He] === F; )
      Pe++, He++;
    for (var ir = (be.length - He) * le + 1 >>> 0, or = new Uint8Array(ir); He < be.length; ) {
      var lr = be.charCodeAt(He);
      if (lr > 255)
        return;
      var Ir = c[lr];
      if (Ir === 255)
        return;
      for (var xr = 0, kr = ir - 1; (Ir !== 0 || xr < nr) && kr !== -1; kr--, xr++)
        Ir += b * or[kr] >>> 0, or[kr] = Ir % 256 >>> 0, Ir = Ir / 256 >>> 0;
      if (Ir !== 0)
        throw new Error("Non-zero carry");
      nr = xr, He++;
    }
    for (var Ce = ir - nr; Ce !== ir && or[Ce] === 0; )
      Ce++;
    var tr = _Buffer$2.allocUnsafe(Pe + (ir - Ce));
    tr.fill(0, 0, Pe);
    for (var Fe = Pe; Ce !== ir; )
      tr[Fe++] = or[Ce++];
    return tr;
  }
  function Ee(be) {
    var He = $(be);
    if (He)
      return He;
    throw new Error("Non-base" + b + " character");
  }
  return {
    encode: pe,
    decodeUnsafe: $,
    decode: Ee
  };
}
var src$h = base$j, basex$1 = src$h, ALPHABET$2 = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz", bs58$e = basex$1(ALPHABET$2), base58$3 = bs58$e, Buffer$1 = safeBufferExports.Buffer, base$i = function(n) {
  function c(A) {
    var b = n(A);
    return base58$3.encode(Buffer$1.concat([
      A,
      b
    ], A.length + 4));
  }
  function u(A) {
    var b = A.slice(0, -4), F = A.slice(-4), le = n(b);
    if (!(F[0] ^ le[0] | F[1] ^ le[1] | F[2] ^ le[2] | F[3] ^ le[3]))
      return b;
  }
  function p(A) {
    var b = base58$3.decodeUnsafe(A);
    if (b)
      return u(b);
  }
  function a(A) {
    var b = base58$3.decode(A), F = u(b);
    if (!F) throw new Error("Invalid checksum");
    return F;
  }
  return {
    encode: c,
    decode: a,
    decodeUnsafe: p
  };
}, createHash$3 = browser$a, bs58checkBase$1 = base$i;
function sha256x2$2(n) {
  var c = createHash$3("sha256").update(n).digest();
  return createHash$3("sha256").update(c).digest();
}
var bs58check$g = bs58checkBase$1(sha256x2$2), CryptoCoinInfo$c = {}, RegistryItem$d = {}, dist$t = {}, ur$1 = {}, errors$f = {};
Object.defineProperty(errors$f, "__esModule", { value: !0 });
errors$f.InvalidChecksumError = errors$f.InvalidSequenceComponentError = errors$f.InvalidTypeError = errors$f.InvalidPathLengthError = errors$f.InvalidSchemeError = void 0;
class InvalidSchemeError extends Error {
  constructor() {
    super("Invalid Scheme"), this.name = "InvalidSchemeError";
  }
}
errors$f.InvalidSchemeError = InvalidSchemeError;
class InvalidPathLengthError extends Error {
  constructor() {
    super("Invalid Path"), this.name = "InvalidPathLengthError";
  }
}
errors$f.InvalidPathLengthError = InvalidPathLengthError;
class InvalidTypeError extends Error {
  constructor() {
    super("Invalid Type"), this.name = "InvalidTypeError";
  }
}
errors$f.InvalidTypeError = InvalidTypeError;
class InvalidSequenceComponentError extends Error {
  constructor() {
    super("Invalid Sequence Component"), this.name = "InvalidSequenceComponentError";
  }
}
errors$f.InvalidSequenceComponentError = InvalidSequenceComponentError;
class InvalidChecksumError extends Error {
  constructor() {
    super("Invalid Checksum"), this.name = "InvalidChecksumError";
  }
}
errors$f.InvalidChecksumError = InvalidChecksumError;
var utils$I = {};
const createBuffer = Buffer$1$1.from && Buffer$1$1.alloc && Buffer$1$1.allocUnsafe && Buffer$1$1.allocUnsafeSlow ? Buffer$1$1.from : (
  // support for Node < 5.10
  (n) => new Buffer$1$1(n)
);
function defineCrc(n, c) {
  const u = (p, a) => c(p, a) >>> 0;
  return u.signed = c, u.unsigned = u, u.model = n, u;
}
const crc1 = defineCrc("crc1", function(n, c) {
  Buffer$1$1.isBuffer(n) || (n = createBuffer(n));
  let u = ~~c, p = 0;
  for (let a = 0; a < n.length; a++) {
    const A = n[a];
    p += A;
  }
  return u += p % 256, u % 256;
});
let TABLE$9 = [
  0,
  7,
  14,
  9,
  28,
  27,
  18,
  21,
  56,
  63,
  54,
  49,
  36,
  35,
  42,
  45,
  112,
  119,
  126,
  121,
  108,
  107,
  98,
  101,
  72,
  79,
  70,
  65,
  84,
  83,
  90,
  93,
  224,
  231,
  238,
  233,
  252,
  251,
  242,
  245,
  216,
  223,
  214,
  209,
  196,
  195,
  202,
  205,
  144,
  151,
  158,
  153,
  140,
  139,
  130,
  133,
  168,
  175,
  166,
  161,
  180,
  179,
  186,
  189,
  199,
  192,
  201,
  206,
  219,
  220,
  213,
  210,
  255,
  248,
  241,
  246,
  227,
  228,
  237,
  234,
  183,
  176,
  185,
  190,
  171,
  172,
  165,
  162,
  143,
  136,
  129,
  134,
  147,
  148,
  157,
  154,
  39,
  32,
  41,
  46,
  59,
  60,
  53,
  50,
  31,
  24,
  17,
  22,
  3,
  4,
  13,
  10,
  87,
  80,
  89,
  94,
  75,
  76,
  69,
  66,
  111,
  104,
  97,
  102,
  115,
  116,
  125,
  122,
  137,
  142,
  135,
  128,
  149,
  146,
  155,
  156,
  177,
  182,
  191,
  184,
  173,
  170,
  163,
  164,
  249,
  254,
  247,
  240,
  229,
  226,
  235,
  236,
  193,
  198,
  207,
  200,
  221,
  218,
  211,
  212,
  105,
  110,
  103,
  96,
  117,
  114,
  123,
  124,
  81,
  86,
  95,
  88,
  77,
  74,
  67,
  68,
  25,
  30,
  23,
  16,
  5,
  2,
  11,
  12,
  33,
  38,
  47,
  40,
  61,
  58,
  51,
  52,
  78,
  73,
  64,
  71,
  82,
  85,
  92,
  91,
  118,
  113,
  120,
  127,
  106,
  109,
  100,
  99,
  62,
  57,
  48,
  55,
  34,
  37,
  44,
  43,
  6,
  1,
  8,
  15,
  26,
  29,
  20,
  19,
  174,
  169,
  160,
  167,
  178,
  181,
  188,
  187,
  150,
  145,
  152,
  159,
  138,
  141,
  132,
  131,
  222,
  217,
  208,
  215,
  194,
  197,
  204,
  203,
  230,
  225,
  232,
  239,
  250,
  253,
  244,
  243
];
typeof Int32Array < "u" && (TABLE$9 = new Int32Array(TABLE$9));
const crc8 = defineCrc("crc-8", function(n, c) {
  Buffer$1$1.isBuffer(n) || (n = createBuffer(n));
  let u = ~~c;
  for (let p = 0; p < n.length; p++) {
    const a = n[p];
    u = TABLE$9[(u ^ a) & 255] & 255;
  }
  return u;
});
let TABLE$8 = [
  0,
  94,
  188,
  226,
  97,
  63,
  221,
  131,
  194,
  156,
  126,
  32,
  163,
  253,
  31,
  65,
  157,
  195,
  33,
  127,
  252,
  162,
  64,
  30,
  95,
  1,
  227,
  189,
  62,
  96,
  130,
  220,
  35,
  125,
  159,
  193,
  66,
  28,
  254,
  160,
  225,
  191,
  93,
  3,
  128,
  222,
  60,
  98,
  190,
  224,
  2,
  92,
  223,
  129,
  99,
  61,
  124,
  34,
  192,
  158,
  29,
  67,
  161,
  255,
  70,
  24,
  250,
  164,
  39,
  121,
  155,
  197,
  132,
  218,
  56,
  102,
  229,
  187,
  89,
  7,
  219,
  133,
  103,
  57,
  186,
  228,
  6,
  88,
  25,
  71,
  165,
  251,
  120,
  38,
  196,
  154,
  101,
  59,
  217,
  135,
  4,
  90,
  184,
  230,
  167,
  249,
  27,
  69,
  198,
  152,
  122,
  36,
  248,
  166,
  68,
  26,
  153,
  199,
  37,
  123,
  58,
  100,
  134,
  216,
  91,
  5,
  231,
  185,
  140,
  210,
  48,
  110,
  237,
  179,
  81,
  15,
  78,
  16,
  242,
  172,
  47,
  113,
  147,
  205,
  17,
  79,
  173,
  243,
  112,
  46,
  204,
  146,
  211,
  141,
  111,
  49,
  178,
  236,
  14,
  80,
  175,
  241,
  19,
  77,
  206,
  144,
  114,
  44,
  109,
  51,
  209,
  143,
  12,
  82,
  176,
  238,
  50,
  108,
  142,
  208,
  83,
  13,
  239,
  177,
  240,
  174,
  76,
  18,
  145,
  207,
  45,
  115,
  202,
  148,
  118,
  40,
  171,
  245,
  23,
  73,
  8,
  86,
  180,
  234,
  105,
  55,
  213,
  139,
  87,
  9,
  235,
  181,
  54,
  104,
  138,
  212,
  149,
  203,
  41,
  119,
  244,
  170,
  72,
  22,
  233,
  183,
  85,
  11,
  136,
  214,
  52,
  106,
  43,
  117,
  151,
  201,
  74,
  20,
  246,
  168,
  116,
  42,
  200,
  150,
  21,
  75,
  169,
  247,
  182,
  232,
  10,
  84,
  215,
  137,
  107,
  53
];
typeof Int32Array < "u" && (TABLE$8 = new Int32Array(TABLE$8));
const crc81wire = defineCrc("dallas-1-wire", function(n, c) {
  Buffer$1$1.isBuffer(n) || (n = createBuffer(n));
  let u = ~~c;
  for (let p = 0; p < n.length; p++) {
    const a = n[p];
    u = TABLE$8[(u ^ a) & 255] & 255;
  }
  return u;
});
let TABLE$7 = [
  0,
  49345,
  49537,
  320,
  49921,
  960,
  640,
  49729,
  50689,
  1728,
  1920,
  51009,
  1280,
  50625,
  50305,
  1088,
  52225,
  3264,
  3456,
  52545,
  3840,
  53185,
  52865,
  3648,
  2560,
  51905,
  52097,
  2880,
  51457,
  2496,
  2176,
  51265,
  55297,
  6336,
  6528,
  55617,
  6912,
  56257,
  55937,
  6720,
  7680,
  57025,
  57217,
  8e3,
  56577,
  7616,
  7296,
  56385,
  5120,
  54465,
  54657,
  5440,
  55041,
  6080,
  5760,
  54849,
  53761,
  4800,
  4992,
  54081,
  4352,
  53697,
  53377,
  4160,
  61441,
  12480,
  12672,
  61761,
  13056,
  62401,
  62081,
  12864,
  13824,
  63169,
  63361,
  14144,
  62721,
  13760,
  13440,
  62529,
  15360,
  64705,
  64897,
  15680,
  65281,
  16320,
  16e3,
  65089,
  64001,
  15040,
  15232,
  64321,
  14592,
  63937,
  63617,
  14400,
  10240,
  59585,
  59777,
  10560,
  60161,
  11200,
  10880,
  59969,
  60929,
  11968,
  12160,
  61249,
  11520,
  60865,
  60545,
  11328,
  58369,
  9408,
  9600,
  58689,
  9984,
  59329,
  59009,
  9792,
  8704,
  58049,
  58241,
  9024,
  57601,
  8640,
  8320,
  57409,
  40961,
  24768,
  24960,
  41281,
  25344,
  41921,
  41601,
  25152,
  26112,
  42689,
  42881,
  26432,
  42241,
  26048,
  25728,
  42049,
  27648,
  44225,
  44417,
  27968,
  44801,
  28608,
  28288,
  44609,
  43521,
  27328,
  27520,
  43841,
  26880,
  43457,
  43137,
  26688,
  30720,
  47297,
  47489,
  31040,
  47873,
  31680,
  31360,
  47681,
  48641,
  32448,
  32640,
  48961,
  32e3,
  48577,
  48257,
  31808,
  46081,
  29888,
  30080,
  46401,
  30464,
  47041,
  46721,
  30272,
  29184,
  45761,
  45953,
  29504,
  45313,
  29120,
  28800,
  45121,
  20480,
  37057,
  37249,
  20800,
  37633,
  21440,
  21120,
  37441,
  38401,
  22208,
  22400,
  38721,
  21760,
  38337,
  38017,
  21568,
  39937,
  23744,
  23936,
  40257,
  24320,
  40897,
  40577,
  24128,
  23040,
  39617,
  39809,
  23360,
  39169,
  22976,
  22656,
  38977,
  34817,
  18624,
  18816,
  35137,
  19200,
  35777,
  35457,
  19008,
  19968,
  36545,
  36737,
  20288,
  36097,
  19904,
  19584,
  35905,
  17408,
  33985,
  34177,
  17728,
  34561,
  18368,
  18048,
  34369,
  33281,
  17088,
  17280,
  33601,
  16640,
  33217,
  32897,
  16448
];
typeof Int32Array < "u" && (TABLE$7 = new Int32Array(TABLE$7));
const crc16 = defineCrc("crc-16", function(n, c) {
  Buffer$1$1.isBuffer(n) || (n = createBuffer(n));
  let u = ~~c;
  for (let p = 0; p < n.length; p++) {
    const a = n[p];
    u = (TABLE$7[(u ^ a) & 255] ^ u >> 8) & 65535;
  }
  return u;
});
let TABLE$6 = [
  0,
  4129,
  8258,
  12387,
  16516,
  20645,
  24774,
  28903,
  33032,
  37161,
  41290,
  45419,
  49548,
  53677,
  57806,
  61935,
  4657,
  528,
  12915,
  8786,
  21173,
  17044,
  29431,
  25302,
  37689,
  33560,
  45947,
  41818,
  54205,
  50076,
  62463,
  58334,
  9314,
  13379,
  1056,
  5121,
  25830,
  29895,
  17572,
  21637,
  42346,
  46411,
  34088,
  38153,
  58862,
  62927,
  50604,
  54669,
  13907,
  9842,
  5649,
  1584,
  30423,
  26358,
  22165,
  18100,
  46939,
  42874,
  38681,
  34616,
  63455,
  59390,
  55197,
  51132,
  18628,
  22757,
  26758,
  30887,
  2112,
  6241,
  10242,
  14371,
  51660,
  55789,
  59790,
  63919,
  35144,
  39273,
  43274,
  47403,
  23285,
  19156,
  31415,
  27286,
  6769,
  2640,
  14899,
  10770,
  56317,
  52188,
  64447,
  60318,
  39801,
  35672,
  47931,
  43802,
  27814,
  31879,
  19684,
  23749,
  11298,
  15363,
  3168,
  7233,
  60846,
  64911,
  52716,
  56781,
  44330,
  48395,
  36200,
  40265,
  32407,
  28342,
  24277,
  20212,
  15891,
  11826,
  7761,
  3696,
  65439,
  61374,
  57309,
  53244,
  48923,
  44858,
  40793,
  36728,
  37256,
  33193,
  45514,
  41451,
  53516,
  49453,
  61774,
  57711,
  4224,
  161,
  12482,
  8419,
  20484,
  16421,
  28742,
  24679,
  33721,
  37784,
  41979,
  46042,
  49981,
  54044,
  58239,
  62302,
  689,
  4752,
  8947,
  13010,
  16949,
  21012,
  25207,
  29270,
  46570,
  42443,
  38312,
  34185,
  62830,
  58703,
  54572,
  50445,
  13538,
  9411,
  5280,
  1153,
  29798,
  25671,
  21540,
  17413,
  42971,
  47098,
  34713,
  38840,
  59231,
  63358,
  50973,
  55100,
  9939,
  14066,
  1681,
  5808,
  26199,
  30326,
  17941,
  22068,
  55628,
  51565,
  63758,
  59695,
  39368,
  35305,
  47498,
  43435,
  22596,
  18533,
  30726,
  26663,
  6336,
  2273,
  14466,
  10403,
  52093,
  56156,
  60223,
  64286,
  35833,
  39896,
  43963,
  48026,
  19061,
  23124,
  27191,
  31254,
  2801,
  6864,
  10931,
  14994,
  64814,
  60687,
  56684,
  52557,
  48554,
  44427,
  40424,
  36297,
  31782,
  27655,
  23652,
  19525,
  15522,
  11395,
  7392,
  3265,
  61215,
  65342,
  53085,
  57212,
  44955,
  49082,
  36825,
  40952,
  28183,
  32310,
  20053,
  24180,
  11923,
  16050,
  3793,
  7920
];
typeof Int32Array < "u" && (TABLE$6 = new Int32Array(TABLE$6));
const crc16ccitt = defineCrc("ccitt", function(n, c) {
  Buffer$1$1.isBuffer(n) || (n = createBuffer(n));
  let u = typeof c < "u" ? ~~c : 65535;
  for (let p = 0; p < n.length; p++) {
    const a = n[p];
    u = (TABLE$6[(u >> 8 ^ a) & 255] ^ u << 8) & 65535;
  }
  return u;
});
let TABLE$5 = [
  0,
  49345,
  49537,
  320,
  49921,
  960,
  640,
  49729,
  50689,
  1728,
  1920,
  51009,
  1280,
  50625,
  50305,
  1088,
  52225,
  3264,
  3456,
  52545,
  3840,
  53185,
  52865,
  3648,
  2560,
  51905,
  52097,
  2880,
  51457,
  2496,
  2176,
  51265,
  55297,
  6336,
  6528,
  55617,
  6912,
  56257,
  55937,
  6720,
  7680,
  57025,
  57217,
  8e3,
  56577,
  7616,
  7296,
  56385,
  5120,
  54465,
  54657,
  5440,
  55041,
  6080,
  5760,
  54849,
  53761,
  4800,
  4992,
  54081,
  4352,
  53697,
  53377,
  4160,
  61441,
  12480,
  12672,
  61761,
  13056,
  62401,
  62081,
  12864,
  13824,
  63169,
  63361,
  14144,
  62721,
  13760,
  13440,
  62529,
  15360,
  64705,
  64897,
  15680,
  65281,
  16320,
  16e3,
  65089,
  64001,
  15040,
  15232,
  64321,
  14592,
  63937,
  63617,
  14400,
  10240,
  59585,
  59777,
  10560,
  60161,
  11200,
  10880,
  59969,
  60929,
  11968,
  12160,
  61249,
  11520,
  60865,
  60545,
  11328,
  58369,
  9408,
  9600,
  58689,
  9984,
  59329,
  59009,
  9792,
  8704,
  58049,
  58241,
  9024,
  57601,
  8640,
  8320,
  57409,
  40961,
  24768,
  24960,
  41281,
  25344,
  41921,
  41601,
  25152,
  26112,
  42689,
  42881,
  26432,
  42241,
  26048,
  25728,
  42049,
  27648,
  44225,
  44417,
  27968,
  44801,
  28608,
  28288,
  44609,
  43521,
  27328,
  27520,
  43841,
  26880,
  43457,
  43137,
  26688,
  30720,
  47297,
  47489,
  31040,
  47873,
  31680,
  31360,
  47681,
  48641,
  32448,
  32640,
  48961,
  32e3,
  48577,
  48257,
  31808,
  46081,
  29888,
  30080,
  46401,
  30464,
  47041,
  46721,
  30272,
  29184,
  45761,
  45953,
  29504,
  45313,
  29120,
  28800,
  45121,
  20480,
  37057,
  37249,
  20800,
  37633,
  21440,
  21120,
  37441,
  38401,
  22208,
  22400,
  38721,
  21760,
  38337,
  38017,
  21568,
  39937,
  23744,
  23936,
  40257,
  24320,
  40897,
  40577,
  24128,
  23040,
  39617,
  39809,
  23360,
  39169,
  22976,
  22656,
  38977,
  34817,
  18624,
  18816,
  35137,
  19200,
  35777,
  35457,
  19008,
  19968,
  36545,
  36737,
  20288,
  36097,
  19904,
  19584,
  35905,
  17408,
  33985,
  34177,
  17728,
  34561,
  18368,
  18048,
  34369,
  33281,
  17088,
  17280,
  33601,
  16640,
  33217,
  32897,
  16448
];
typeof Int32Array < "u" && (TABLE$5 = new Int32Array(TABLE$5));
const crc16modbus = defineCrc("crc-16-modbus", function(n, c) {
  Buffer$1$1.isBuffer(n) || (n = createBuffer(n));
  let u = typeof c < "u" ? ~~c : 65535;
  for (let p = 0; p < n.length; p++) {
    const a = n[p];
    u = (TABLE$5[(u ^ a) & 255] ^ u >> 8) & 65535;
  }
  return u;
}), crc16xmodem = defineCrc("xmodem", function(n, c) {
  Buffer$1$1.isBuffer(n) || (n = createBuffer(n));
  let u = typeof c < "u" ? ~~c : 0;
  for (let p = 0; p < n.length; p++) {
    const a = n[p];
    let A = u >>> 8 & 255;
    A ^= a & 255, A ^= A >>> 4, u = u << 8 & 65535, u ^= A, A = A << 5 & 65535, u ^= A, A = A << 7 & 65535, u ^= A;
  }
  return u;
});
let TABLE$4 = [
  0,
  4489,
  8978,
  12955,
  17956,
  22445,
  25910,
  29887,
  35912,
  40385,
  44890,
  48851,
  51820,
  56293,
  59774,
  63735,
  4225,
  264,
  13203,
  8730,
  22181,
  18220,
  30135,
  25662,
  40137,
  36160,
  49115,
  44626,
  56045,
  52068,
  63999,
  59510,
  8450,
  12427,
  528,
  5017,
  26406,
  30383,
  17460,
  21949,
  44362,
  48323,
  36440,
  40913,
  60270,
  64231,
  51324,
  55797,
  12675,
  8202,
  4753,
  792,
  30631,
  26158,
  21685,
  17724,
  48587,
  44098,
  40665,
  36688,
  64495,
  60006,
  55549,
  51572,
  16900,
  21389,
  24854,
  28831,
  1056,
  5545,
  10034,
  14011,
  52812,
  57285,
  60766,
  64727,
  34920,
  39393,
  43898,
  47859,
  21125,
  17164,
  29079,
  24606,
  5281,
  1320,
  14259,
  9786,
  57037,
  53060,
  64991,
  60502,
  39145,
  35168,
  48123,
  43634,
  25350,
  29327,
  16404,
  20893,
  9506,
  13483,
  1584,
  6073,
  61262,
  65223,
  52316,
  56789,
  43370,
  47331,
  35448,
  39921,
  29575,
  25102,
  20629,
  16668,
  13731,
  9258,
  5809,
  1848,
  65487,
  60998,
  56541,
  52564,
  47595,
  43106,
  39673,
  35696,
  33800,
  38273,
  42778,
  46739,
  49708,
  54181,
  57662,
  61623,
  2112,
  6601,
  11090,
  15067,
  20068,
  24557,
  28022,
  31999,
  38025,
  34048,
  47003,
  42514,
  53933,
  49956,
  61887,
  57398,
  6337,
  2376,
  15315,
  10842,
  24293,
  20332,
  32247,
  27774,
  42250,
  46211,
  34328,
  38801,
  58158,
  62119,
  49212,
  53685,
  10562,
  14539,
  2640,
  7129,
  28518,
  32495,
  19572,
  24061,
  46475,
  41986,
  38553,
  34576,
  62383,
  57894,
  53437,
  49460,
  14787,
  10314,
  6865,
  2904,
  32743,
  28270,
  23797,
  19836,
  50700,
  55173,
  58654,
  62615,
  32808,
  37281,
  41786,
  45747,
  19012,
  23501,
  26966,
  30943,
  3168,
  7657,
  12146,
  16123,
  54925,
  50948,
  62879,
  58390,
  37033,
  33056,
  46011,
  41522,
  23237,
  19276,
  31191,
  26718,
  7393,
  3432,
  16371,
  11898,
  59150,
  63111,
  50204,
  54677,
  41258,
  45219,
  33336,
  37809,
  27462,
  31439,
  18516,
  23005,
  11618,
  15595,
  3696,
  8185,
  63375,
  58886,
  54429,
  50452,
  45483,
  40994,
  37561,
  33584,
  31687,
  27214,
  22741,
  18780,
  15843,
  11370,
  7921,
  3960
];
typeof Int32Array < "u" && (TABLE$4 = new Int32Array(TABLE$4));
const crc16kermit = defineCrc("kermit", function(n, c) {
  Buffer$1$1.isBuffer(n) || (n = createBuffer(n));
  let u = typeof c < "u" ? ~~c : 0;
  for (let p = 0; p < n.length; p++) {
    const a = n[p];
    u = (TABLE$4[(u ^ a) & 255] ^ u >> 8) & 65535;
  }
  return u;
});
let TABLE$3 = [
  0,
  8801531,
  9098509,
  825846,
  9692897,
  1419802,
  1651692,
  10452759,
  10584377,
  2608578,
  2839604,
  11344079,
  3303384,
  11807523,
  12104405,
  4128302,
  12930697,
  4391538,
  5217156,
  13227903,
  5679208,
  13690003,
  14450021,
  5910942,
  6606768,
  14844747,
  15604413,
  6837830,
  16197969,
  7431594,
  8256604,
  16494759,
  840169,
  9084178,
  8783076,
  18463,
  10434312,
  1670131,
  1434117,
  9678590,
  11358416,
  2825259,
  2590173,
  10602790,
  4109873,
  12122826,
  11821884,
  3289031,
  13213536,
  5231515,
  4409965,
  12912278,
  5929345,
  14431610,
  13675660,
  5693559,
  6823513,
  15618722,
  14863188,
  6588335,
  16513208,
  8238147,
  7417269,
  16212302,
  1680338,
  10481449,
  9664223,
  1391140,
  9061683,
  788936,
  36926,
  8838341,
  12067563,
  4091408,
  3340262,
  11844381,
  2868234,
  11372785,
  10555655,
  2579964,
  14478683,
  5939616,
  5650518,
  13661357,
  5180346,
  13190977,
  12967607,
  4428364,
  8219746,
  16457881,
  16234863,
  7468436,
  15633027,
  6866552,
  6578062,
  14816117,
  1405499,
  9649856,
  10463030,
  1698765,
  8819930,
  55329,
  803287,
  9047340,
  11858690,
  3325945,
  4072975,
  12086004,
  2561507,
  10574104,
  11387118,
  2853909,
  13647026,
  5664841,
  5958079,
  14460228,
  4446803,
  12949160,
  13176670,
  5194661,
  7454091,
  16249200,
  16476294,
  8201341,
  14834538,
  6559633,
  6852199,
  15647388,
  3360676,
  11864927,
  12161705,
  4185682,
  10527045,
  2551230,
  2782280,
  11286707,
  9619101,
  1346150,
  1577872,
  10379115,
  73852,
  8875143,
  9172337,
  899466,
  16124205,
  7357910,
  8182816,
  16421083,
  6680524,
  14918455,
  15678145,
  6911546,
  5736468,
  13747439,
  14507289,
  5968354,
  12873461,
  4334094,
  5159928,
  13170435,
  4167245,
  12180150,
  11879232,
  3346363,
  11301036,
  2767959,
  2532769,
  10545498,
  10360692,
  1596303,
  1360505,
  9604738,
  913813,
  9157998,
  8856728,
  92259,
  16439492,
  8164415,
  7343561,
  16138546,
  6897189,
  15692510,
  14936872,
  6662099,
  5986813,
  14488838,
  13733104,
  5750795,
  13156124,
  5174247,
  4352529,
  12855018,
  2810998,
  11315341,
  10498427,
  2522496,
  12124823,
  4148844,
  3397530,
  11901793,
  9135439,
  862644,
  110658,
  8912057,
  1606574,
  10407765,
  9590435,
  1317464,
  15706879,
  6940164,
  6651890,
  14889737,
  8145950,
  16384229,
  16161043,
  7394792,
  5123014,
  13133629,
  12910283,
  4370992,
  14535975,
  5997020,
  5707818,
  13718737,
  2504095,
  10516836,
  11329682,
  2796649,
  11916158,
  3383173,
  4130419,
  12143240,
  8893606,
  129117,
  876971,
  9121104,
  1331783,
  9576124,
  10389322,
  1625009,
  14908182,
  6633453,
  6925851,
  15721184,
  7380471,
  16175372,
  16402682,
  8127489,
  4389423,
  12891860,
  13119266,
  5137369,
  13704398,
  5722165,
  6015427,
  14517560
];
typeof Int32Array < "u" && (TABLE$3 = new Int32Array(TABLE$3));
const crc24 = defineCrc("crc-24", function(n, c) {
  Buffer$1$1.isBuffer(n) || (n = createBuffer(n));
  let u = typeof c < "u" ? ~~c : 11994318;
  for (let p = 0; p < n.length; p++) {
    const a = n[p];
    u = (TABLE$3[(u >> 16 ^ a) & 255] ^ u << 8) & 16777215;
  }
  return u;
});
let TABLE$2 = [
  0,
  1996959894,
  3993919788,
  2567524794,
  124634137,
  1886057615,
  3915621685,
  2657392035,
  249268274,
  2044508324,
  3772115230,
  2547177864,
  162941995,
  2125561021,
  3887607047,
  2428444049,
  498536548,
  1789927666,
  4089016648,
  2227061214,
  450548861,
  1843258603,
  4107580753,
  2211677639,
  325883990,
  1684777152,
  4251122042,
  2321926636,
  335633487,
  1661365465,
  4195302755,
  2366115317,
  997073096,
  1281953886,
  3579855332,
  2724688242,
  1006888145,
  1258607687,
  3524101629,
  2768942443,
  901097722,
  1119000684,
  3686517206,
  2898065728,
  853044451,
  1172266101,
  3705015759,
  2882616665,
  651767980,
  1373503546,
  3369554304,
  3218104598,
  565507253,
  1454621731,
  3485111705,
  3099436303,
  671266974,
  1594198024,
  3322730930,
  2970347812,
  795835527,
  1483230225,
  3244367275,
  3060149565,
  1994146192,
  31158534,
  2563907772,
  4023717930,
  1907459465,
  112637215,
  2680153253,
  3904427059,
  2013776290,
  251722036,
  2517215374,
  3775830040,
  2137656763,
  141376813,
  2439277719,
  3865271297,
  1802195444,
  476864866,
  2238001368,
  4066508878,
  1812370925,
  453092731,
  2181625025,
  4111451223,
  1706088902,
  314042704,
  2344532202,
  4240017532,
  1658658271,
  366619977,
  2362670323,
  4224994405,
  1303535960,
  984961486,
  2747007092,
  3569037538,
  1256170817,
  1037604311,
  2765210733,
  3554079995,
  1131014506,
  879679996,
  2909243462,
  3663771856,
  1141124467,
  855842277,
  2852801631,
  3708648649,
  1342533948,
  654459306,
  3188396048,
  3373015174,
  1466479909,
  544179635,
  3110523913,
  3462522015,
  1591671054,
  702138776,
  2966460450,
  3352799412,
  1504918807,
  783551873,
  3082640443,
  3233442989,
  3988292384,
  2596254646,
  62317068,
  1957810842,
  3939845945,
  2647816111,
  81470997,
  1943803523,
  3814918930,
  2489596804,
  225274430,
  2053790376,
  3826175755,
  2466906013,
  167816743,
  2097651377,
  4027552580,
  2265490386,
  503444072,
  1762050814,
  4150417245,
  2154129355,
  426522225,
  1852507879,
  4275313526,
  2312317920,
  282753626,
  1742555852,
  4189708143,
  2394877945,
  397917763,
  1622183637,
  3604390888,
  2714866558,
  953729732,
  1340076626,
  3518719985,
  2797360999,
  1068828381,
  1219638859,
  3624741850,
  2936675148,
  906185462,
  1090812512,
  3747672003,
  2825379669,
  829329135,
  1181335161,
  3412177804,
  3160834842,
  628085408,
  1382605366,
  3423369109,
  3138078467,
  570562233,
  1426400815,
  3317316542,
  2998733608,
  733239954,
  1555261956,
  3268935591,
  3050360625,
  752459403,
  1541320221,
  2607071920,
  3965973030,
  1969922972,
  40735498,
  2617837225,
  3943577151,
  1913087877,
  83908371,
  2512341634,
  3803740692,
  2075208622,
  213261112,
  2463272603,
  3855990285,
  2094854071,
  198958881,
  2262029012,
  4057260610,
  1759359992,
  534414190,
  2176718541,
  4139329115,
  1873836001,
  414664567,
  2282248934,
  4279200368,
  1711684554,
  285281116,
  2405801727,
  4167216745,
  1634467795,
  376229701,
  2685067896,
  3608007406,
  1308918612,
  956543938,
  2808555105,
  3495958263,
  1231636301,
  1047427035,
  2932959818,
  3654703836,
  1088359270,
  936918e3,
  2847714899,
  3736837829,
  1202900863,
  817233897,
  3183342108,
  3401237130,
  1404277552,
  615818150,
  3134207493,
  3453421203,
  1423857449,
  601450431,
  3009837614,
  3294710456,
  1567103746,
  711928724,
  3020668471,
  3272380065,
  1510334235,
  755167117
];
typeof Int32Array < "u" && (TABLE$2 = new Int32Array(TABLE$2));
const crc32$3 = defineCrc("crc-32", function(n, c) {
  Buffer$1$1.isBuffer(n) || (n = createBuffer(n));
  let u = c === 0 ? 0 : ~~c ^ -1;
  for (let p = 0; p < n.length; p++) {
    const a = n[p];
    u = TABLE$2[(u ^ a) & 255] ^ u >>> 8;
  }
  return u ^ -1;
});
let TABLE$1 = [
  0,
  1996959894,
  3993919788,
  2567524794,
  124634137,
  1886057615,
  3915621685,
  2657392035,
  249268274,
  2044508324,
  3772115230,
  2547177864,
  162941995,
  2125561021,
  3887607047,
  2428444049,
  498536548,
  1789927666,
  4089016648,
  2227061214,
  450548861,
  1843258603,
  4107580753,
  2211677639,
  325883990,
  1684777152,
  4251122042,
  2321926636,
  335633487,
  1661365465,
  4195302755,
  2366115317,
  997073096,
  1281953886,
  3579855332,
  2724688242,
  1006888145,
  1258607687,
  3524101629,
  2768942443,
  901097722,
  1119000684,
  3686517206,
  2898065728,
  853044451,
  1172266101,
  3705015759,
  2882616665,
  651767980,
  1373503546,
  3369554304,
  3218104598,
  565507253,
  1454621731,
  3485111705,
  3099436303,
  671266974,
  1594198024,
  3322730930,
  2970347812,
  795835527,
  1483230225,
  3244367275,
  3060149565,
  1994146192,
  31158534,
  2563907772,
  4023717930,
  1907459465,
  112637215,
  2680153253,
  3904427059,
  2013776290,
  251722036,
  2517215374,
  3775830040,
  2137656763,
  141376813,
  2439277719,
  3865271297,
  1802195444,
  476864866,
  2238001368,
  4066508878,
  1812370925,
  453092731,
  2181625025,
  4111451223,
  1706088902,
  314042704,
  2344532202,
  4240017532,
  1658658271,
  366619977,
  2362670323,
  4224994405,
  1303535960,
  984961486,
  2747007092,
  3569037538,
  1256170817,
  1037604311,
  2765210733,
  3554079995,
  1131014506,
  879679996,
  2909243462,
  3663771856,
  1141124467,
  855842277,
  2852801631,
  3708648649,
  1342533948,
  654459306,
  3188396048,
  3373015174,
  1466479909,
  544179635,
  3110523913,
  3462522015,
  1591671054,
  702138776,
  2966460450,
  3352799412,
  1504918807,
  783551873,
  3082640443,
  3233442989,
  3988292384,
  2596254646,
  62317068,
  1957810842,
  3939845945,
  2647816111,
  81470997,
  1943803523,
  3814918930,
  2489596804,
  225274430,
  2053790376,
  3826175755,
  2466906013,
  167816743,
  2097651377,
  4027552580,
  2265490386,
  503444072,
  1762050814,
  4150417245,
  2154129355,
  426522225,
  1852507879,
  4275313526,
  2312317920,
  282753626,
  1742555852,
  4189708143,
  2394877945,
  397917763,
  1622183637,
  3604390888,
  2714866558,
  953729732,
  1340076626,
  3518719985,
  2797360999,
  1068828381,
  1219638859,
  3624741850,
  2936675148,
  906185462,
  1090812512,
  3747672003,
  2825379669,
  829329135,
  1181335161,
  3412177804,
  3160834842,
  628085408,
  1382605366,
  3423369109,
  3138078467,
  570562233,
  1426400815,
  3317316542,
  2998733608,
  733239954,
  1555261956,
  3268935591,
  3050360625,
  752459403,
  1541320221,
  2607071920,
  3965973030,
  1969922972,
  40735498,
  2617837225,
  3943577151,
  1913087877,
  83908371,
  2512341634,
  3803740692,
  2075208622,
  213261112,
  2463272603,
  3855990285,
  2094854071,
  198958881,
  2262029012,
  4057260610,
  1759359992,
  534414190,
  2176718541,
  4139329115,
  1873836001,
  414664567,
  2282248934,
  4279200368,
  1711684554,
  285281116,
  2405801727,
  4167216745,
  1634467795,
  376229701,
  2685067896,
  3608007406,
  1308918612,
  956543938,
  2808555105,
  3495958263,
  1231636301,
  1047427035,
  2932959818,
  3654703836,
  1088359270,
  936918e3,
  2847714899,
  3736837829,
  1202900863,
  817233897,
  3183342108,
  3401237130,
  1404277552,
  615818150,
  3134207493,
  3453421203,
  1423857449,
  601450431,
  3009837614,
  3294710456,
  1567103746,
  711928724,
  3020668471,
  3272380065,
  1510334235,
  755167117
];
typeof Int32Array < "u" && (TABLE$1 = new Int32Array(TABLE$1));
const crcjam = defineCrc("jam", function(n, c = -1) {
  Buffer$1$1.isBuffer(n) || (n = createBuffer(n));
  let u = c === 0 ? 0 : ~~c;
  for (let p = 0; p < n.length; p++) {
    const a = n[p];
    u = TABLE$1[(u ^ a) & 255] ^ u >>> 8;
  }
  return u;
}), index = {
  crc1,
  crc8,
  crc81wire,
  crc16,
  crc16ccitt,
  crc16modbus,
  crc16xmodem,
  crc16kermit,
  crc24,
  crc32: crc32$3,
  crcjam
}, crc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  crc1,
  crc16,
  crc16ccitt,
  crc16kermit,
  crc16modbus,
  crc16xmodem,
  crc24,
  crc32: crc32$3,
  crc8,
  crc81wire,
  crcjam,
  default: index
}, Symbol.toStringTag, { value: "Module" })), require$$1$b = /* @__PURE__ */ getAugmentedNamespace(crc);
var __importDefault$i = commonjsGlobal && commonjsGlobal.__importDefault || function(n) {
  return n && n.__esModule ? n : { default: n };
};
Object.defineProperty(utils$I, "__esModule", { value: !0 });
utils$I.bufferXOR = utils$I.setDifference = utils$I.arrayContains = utils$I.arraysEqual = utils$I.hasPrefix = utils$I.isURType = utils$I.intToBytes = utils$I.toUint32 = utils$I.getCRCHex = utils$I.getCRC = utils$I.split = utils$I.partition = utils$I.sha256Hash = void 0;
const sha_js_1 = __importDefault$i(sha_jsExports), crc_1 = require$$1$b, sha256Hash = (n) => sha_js_1.default("sha256").update(n).digest();
utils$I.sha256Hash = sha256Hash;
const partition = (n, c) => n.match(new RegExp(".{1," + c + "}", "g")) || [n];
utils$I.partition = partition;
const split$2 = (n, c) => [n.slice(0, -c), n.slice(-c)];
utils$I.split = split$2;
const getCRC = (n) => crc_1.crc32(n);
utils$I.getCRC = getCRC;
const getCRCHex = (n) => crc_1.crc32(n).toString(16).padStart(8, "0");
utils$I.getCRCHex = getCRCHex;
const toUint32 = (n) => n >>> 0;
utils$I.toUint32 = toUint32;
const intToBytes = (n) => {
  const c = new ArrayBuffer(4);
  return new DataView(c).setUint32(0, n, !1), Buffer$f.from(c);
};
utils$I.intToBytes = intToBytes;
const isURType = (n) => n.split("").every((c, u) => {
  let p = n.charCodeAt(u);
  return 97 <= p && p <= 122 || 48 <= p && p <= 57 || p === 45;
});
utils$I.isURType = isURType;
const hasPrefix = (n, c) => n.indexOf(c) === 0;
utils$I.hasPrefix = hasPrefix;
const arraysEqual = (n, c) => n.length !== c.length ? !1 : n.every((u) => c.includes(u));
utils$I.arraysEqual = arraysEqual;
const arrayContains = (n, c) => c.every((u) => n.includes(u));
utils$I.arrayContains = arrayContains;
const setDifference = (n, c) => n.filter((u) => c.indexOf(u) < 0);
utils$I.setDifference = setDifference;
const bufferXOR = (n, c) => {
  const u = Math.max(n.length, c.length), p = Buffer$f.allocUnsafe(u);
  for (let a = 0; a < u; ++a)
    p[a] = n[a] ^ c[a];
  return p;
};
utils$I.bufferXOR = bufferXOR;
var cbor$1 = {}, main$4 = { exports: {} };
(function(n) {
  (function(c, u) {
    n.exports ? n.exports = u() : c.CBOR = u();
  })(commonjsGlobal, function() {
    var c = function() {
      function u(kr) {
        this.$hex = kr;
      }
      u.prototype = {
        length: function() {
          return this.$hex.length / 2;
        },
        toString: function(kr) {
          if (!kr || kr === "hex" || kr === 16) return this.$hex;
          if (kr === "utf-8") {
            for (var Ce = "", tr = 0; tr < this.$hex.length; tr += 2)
              Ce += "%" + this.$hex.substring(tr, tr + 2);
            return decodeURIComponent(Ce);
          }
          if (kr === "latin") {
            for (var Ce = [], tr = 0; tr < this.$hex.length; tr += 2)
              Ce.push(parseInt(this.$hex.substring(tr, tr + 2), 16));
            return String.fromCharCode.apply(String, Ce);
          }
          throw new Error("Unrecognised format: " + kr);
        }
      }, u.fromLatinString = function(kr) {
        for (var Ce = "", tr = 0; tr < kr.length; tr++) {
          var Fe = kr.charCodeAt(tr).toString(16);
          Fe.length === 1 && (Fe = "0" + Fe), Ce += Fe;
        }
        return new u(Ce);
      }, u.fromUtf8String = function(kr) {
        for (var Ce = encodeURIComponent(kr), tr = "", Fe = 0; Fe < Ce.length; Fe++)
          if (Ce.charAt(Fe) === "%")
            tr += Ce.substring(Fe + 1, Fe + 3), Fe += 2;
          else {
            var Sr = Ce.charCodeAt(Fe).toString(16);
            Sr.length < 2 && (Sr = "0" + Sr), tr += Sr;
          }
        return new u(tr);
      };
      var p = [], a = {}, A = function(kr) {
        return function() {
          throw new Error(kr + " not implemented");
        };
      };
      function b() {
      }
      b.prototype = {
        peekByte: A("peekByte"),
        readByte: A("readByte"),
        readChunk: A("readChunk"),
        readFloat16: function() {
          var kr = this.readUint16(), Ce = (kr & 32767) >> 10, tr = kr & 1023, Fe = kr & 32768;
          if (Ce === 31)
            return tr === 0 ? Fe ? -1 / 0 : 1 / 0 : NaN;
          var Sr = Ce ? Math.pow(2, Ce - 25) * (1024 + tr) : Math.pow(2, -24) * tr;
          return Fe ? -Sr : Sr;
        },
        readFloat32: function() {
          var kr = this.readUint32(), Ce = (kr & 2147483647) >> 23, tr = kr & 8388607, Fe = kr & 2147483648;
          if (Ce === 255)
            return tr === 0 ? Fe ? -1 / 0 : 1 / 0 : NaN;
          var Sr = Ce ? Math.pow(2, Ce - 23 - 127) * (8388608 + tr) : Math.pow(2, -149) * tr;
          return Fe ? -Sr : Sr;
        },
        readFloat64: function() {
          var kr = this.readUint32(), Ce = this.readUint32(), tr = kr >> 20 & 2047, Fe = (kr & 1048575) * 4294967296 + Ce, Sr = kr & 2147483648;
          if (tr === 2047)
            return Fe === 0 ? Sr ? -1 / 0 : 1 / 0 : NaN;
          var er = tr ? Math.pow(2, tr - 52 - 1023) * (4503599627370496 + Fe) : Math.pow(2, -1074) * Fe;
          return Sr ? -er : er;
        },
        readUint16: function() {
          return this.readByte() * 256 + this.readByte();
        },
        readUint32: function() {
          return this.readUint16() * 65536 + this.readUint16();
        },
        readUint64: function() {
          return this.readUint32() * 4294967296 + this.readUint32();
        }
      };
      function F() {
      }
      F.prototype = {
        writeByte: A("writeByte"),
        result: A("result"),
        writeFloat16: A("writeFloat16"),
        writeFloat32: A("writeFloat32"),
        writeFloat64: A("writeFloat64"),
        writeUint16: function(kr) {
          this.writeByte(kr >> 8 & 255), this.writeByte(kr & 255);
        },
        writeUint32: function(kr) {
          this.writeUint16(kr >> 16 & 65535), this.writeUint16(kr & 65535);
        },
        writeUint64: function(kr) {
          if (kr >= 9007199254740992 || kr <= -9007199254740992)
            throw new Error("Cannot encode Uint64 of: " + kr + " magnitude to big (floating point errors)");
          this.writeUint32(Math.floor(kr / 4294967296)), this.writeUint32(kr % 4294967296);
        },
        writeString: A("writeString"),
        canWriteBinary: function(kr) {
          return !1;
        },
        writeBinary: A("writeChunk")
      };
      function le(kr) {
        var Ce = kr.readByte(), tr = Ce >> 5, Fe = Ce & 31;
        return { type: tr, value: Fe };
      }
      function L(kr, Ce) {
        var tr = kr.value;
        if (tr < 24)
          return tr;
        if (tr == 24)
          return Ce.readByte();
        if (tr == 25)
          return Ce.readUint16();
        if (tr == 26)
          return Ce.readUint32();
        if (tr == 27)
          return Ce.readUint64();
        if (tr == 31)
          return null;
        A("Additional info: " + tr)();
      }
      function pe(kr, Ce, tr) {
        tr.writeByte(kr << 5 | Ce);
      }
      function $(kr, Ce, tr) {
        var Fe = kr << 5;
        Ce < 24 ? tr.writeByte(Fe | Ce) : Ce < 256 ? (tr.writeByte(Fe | 24), tr.writeByte(Ce)) : Ce < 65536 ? (tr.writeByte(Fe | 25), tr.writeUint16(Ce)) : Ce < 4294967296 ? (tr.writeByte(Fe | 26), tr.writeUint32(Ce)) : (tr.writeByte(Fe | 27), tr.writeUint64(Ce));
      }
      var Ee = new Error();
      function be(kr) {
        var Ce = le(kr);
        switch (Ce.type) {
          case 0:
            return L(Ce, kr);
          case 1:
            return -1 - L(Ce, kr);
          case 2:
            return kr.readChunk(L(Ce, kr));
          case 3:
            var tr = kr.readChunk(L(Ce, kr));
            return tr.toString("utf-8");
          case 4:
          case 5:
            var Fe = L(Ce, kr), ar = [];
            if (Fe !== null) {
              Ce.type === 5 && (Fe *= 2);
              for (var Sr = 0; Sr < Fe; Sr++)
                ar[Sr] = be(kr);
            } else
              for (var er; (er = be(kr)) !== Ee; )
                ar.push(er);
            if (Ce.type === 5) {
              for (var Ie = {}, Sr = 0; Sr < ar.length; Sr += 2)
                Ie[ar[Sr]] = ar[Sr + 1];
              return Ie;
            } else
              return ar;
          case 6:
            var xe = L(Ce, kr), rr = a[xe], ar = be(kr);
            return rr ? rr(ar) : ar;
          case 7:
            if (Ce.value === 25)
              return kr.readFloat16();
            if (Ce.value === 26)
              return kr.readFloat32();
            if (Ce.value === 27)
              return kr.readFloat64();
            switch (L(Ce, kr)) {
              case 20:
                return !1;
              case 21:
                return !0;
              case 22:
                return null;
              case 23:
                return;
              case null:
                return Ee;
              default:
                throw new Error("Unknown fixed value: " + Ce.value);
            }
          default:
            throw new Error("Unsupported header: " + JSON.stringify(Ce));
        }
        throw new Error("not implemented yet");
      }
      function He(kr, Ce) {
        for (var tr = 0; tr < p.length; tr++) {
          var Fe = p[tr].fn(kr);
          if (Fe !== void 0)
            return $(6, p[tr].tag, Ce), He(Fe, Ce);
        }
        if (kr && typeof kr.toCBOR == "function" && (kr = kr.toCBOR()), kr === !1)
          $(7, 20, Ce);
        else if (kr === !0)
          $(7, 21, Ce);
        else if (kr === null)
          $(7, 22, Ce);
        else if (kr === void 0)
          $(7, 23, Ce);
        else if (typeof kr == "number")
          Math.floor(kr) === kr && kr < 9007199254740992 && kr > -9007199254740992 ? kr < 0 ? $(1, -1 - kr, Ce) : $(0, kr, Ce) : (pe(7, 27, Ce), Ce.writeFloat64(kr));
        else if (typeof kr == "string")
          Ce.writeString(kr, function(er) {
            $(3, er, Ce);
          });
        else if (Ce.canWriteBinary(kr))
          Ce.writeBinary(kr, function(er) {
            $(2, er, Ce);
          });
        else if (typeof kr == "object")
          if (ir.config.useToJSON && typeof kr.toJSON == "function" && (kr = kr.toJSON()), Array.isArray(kr)) {
            $(4, kr.length, Ce);
            for (var tr = 0; tr < kr.length; tr++)
              He(kr[tr], Ce);
          } else {
            var Sr = Object.keys(kr);
            $(5, Sr.length, Ce);
            for (var tr = 0; tr < Sr.length; tr++)
              He(Sr[tr], Ce), He(kr[Sr[tr]], Ce);
          }
        else
          throw new Error("CBOR encoding not supported: " + kr);
      }
      var Pe = [], nr = [], ir = {
        config: {
          useToJSON: !0
        },
        addWriter: function(kr, Ce) {
          typeof kr == "string" ? nr.push(function(tr) {
            if (kr === tr) return Ce(tr);
          }) : nr.push(kr);
        },
        addReader: function(kr, Ce) {
          typeof kr == "string" ? Pe.push(function(tr, Fe) {
            if (kr === Fe) return Ce(tr, Fe);
          }) : Pe.push(kr);
        },
        encode: function(kr, Ce) {
          for (var tr = 0; tr < nr.length; tr++) {
            var Fe = nr[tr], Sr = Fe(Ce);
            if (Sr)
              return He(kr, Sr), Sr.result();
          }
          throw new Error("Unsupported output format: " + Ce);
        },
        decode: function(kr, Ce) {
          for (var tr = 0; tr < Pe.length; tr++) {
            var Fe = Pe[tr], Sr = Fe(kr, Ce);
            if (Sr)
              return be(Sr);
          }
          throw new Error("Unsupported input format: " + Ce);
        },
        addSemanticEncode: function(kr, Ce) {
          if (typeof kr != "number" || kr % 1 !== 0 || kr < 0)
            throw new Error("Tag must be a positive integer");
          return p.push({ tag: kr, fn: Ce }), this;
        },
        addSemanticDecode: function(kr, Ce) {
          if (typeof kr != "number" || kr % 1 !== 0 || kr < 0)
            throw new Error("Tag must be a positive integer");
          return a[kr] = Ce, this;
        },
        Reader: b,
        Writer: F
      };
      function or(kr) {
        this.buffer = kr, this.pos = 0;
      }
      or.prototype = Object.create(b.prototype), or.prototype.peekByte = function() {
        return this.buffer[this.pos];
      }, or.prototype.readByte = function() {
        return this.buffer[this.pos++];
      }, or.prototype.readUint16 = function() {
        var kr = this.buffer.readUInt16BE(this.pos);
        return this.pos += 2, kr;
      }, or.prototype.readUint32 = function() {
        var kr = this.buffer.readUInt32BE(this.pos);
        return this.pos += 4, kr;
      }, or.prototype.readFloat32 = function() {
        var kr = this.buffer.readFloatBE(this.pos);
        return this.pos += 4, kr;
      }, or.prototype.readFloat64 = function() {
        var kr = this.buffer.readDoubleBE(this.pos);
        return this.pos += 8, kr;
      }, or.prototype.readChunk = function(kr) {
        var Ce = Buffer$f.alloc(kr);
        return this.buffer.copy(Ce, 0, this.pos, this.pos += kr), Ce;
      };
      function lr(kr) {
        this.byteLength = 0, this.defaultBufferLength = 16384, this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0, this.completeBuffers = [], this.stringFormat = kr;
      }
      lr.prototype = Object.create(F.prototype), lr.prototype.writeByte = function(kr) {
        this.latestBuffer[this.latestBufferOffset++] = kr, this.latestBufferOffset >= this.latestBuffer.length && (this.completeBuffers.push(this.latestBuffer), this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0), this.byteLength++;
      }, lr.prototype.writeFloat32 = function(kr) {
        var Ce = Buffer$f.alloc(4);
        Ce.writeFloatBE(kr, 0), this.writeBuffer(Ce);
      }, lr.prototype.writeFloat64 = function(kr) {
        var Ce = Buffer$f.alloc(8);
        Ce.writeDoubleBE(kr, 0), this.writeBuffer(Ce);
      }, lr.prototype.writeString = function(kr, Ce) {
        var tr = Buffer$f.from(kr, "utf-8");
        Ce(tr.length), this.writeBuffer(tr);
      }, lr.prototype.canWriteBinary = function(kr) {
        return kr instanceof Buffer$f;
      }, lr.prototype.writeBinary = function(kr, Ce) {
        Ce(kr.length), this.writeBuffer(kr);
      }, lr.prototype.writeBuffer = function(kr) {
        if (!(kr instanceof Buffer$f)) throw new TypeError("BufferWriter only accepts Buffers");
        this.latestBufferOffset ? this.latestBuffer.length - this.latestBufferOffset >= kr.length ? (kr.copy(this.latestBuffer, this.latestBufferOffset), this.latestBufferOffset += kr.length, this.latestBufferOffset >= this.latestBuffer.length && (this.completeBuffers.push(this.latestBuffer), this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0)) : (this.completeBuffers.push(this.latestBuffer.slice(0, this.latestBufferOffset)), this.completeBuffers.push(kr), this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0) : this.completeBuffers.push(kr), this.byteLength += kr.length;
      }, lr.prototype.result = function() {
        for (var kr = Buffer$f.alloc(this.byteLength), Ce = 0, tr = 0; tr < this.completeBuffers.length; tr++) {
          var Fe = this.completeBuffers[tr];
          Fe.copy(kr, Ce, 0, Fe.length), Ce += Fe.length;
        }
        return this.latestBufferOffset && this.latestBuffer.copy(kr, Ce, 0, this.latestBufferOffset), this.stringFormat ? kr.toString(this.stringFormat) : kr;
      }, typeof Buffer$f == "function" && (ir.addReader(function(kr, Ce) {
        if (kr instanceof Buffer$f)
          return new or(kr);
        if (Ce === "hex" || Ce === "base64") {
          var tr = Buffer$f.from(kr, Ce);
          return new or(tr);
        }
      }), ir.addWriter(function(kr) {
        if (!kr || kr === "buffer")
          return new lr();
        if (kr === "hex" || kr === "base64")
          return new lr(kr);
      }));
      function Ir(kr) {
        this.hex = kr, this.pos = 0;
      }
      Ir.prototype = Object.create(b.prototype), Ir.prototype.peekByte = function() {
        var kr = this.hex.substring(this.pos, 2);
        return parseInt(kr, 16);
      }, Ir.prototype.readByte = function() {
        var kr = this.hex.substring(this.pos, this.pos + 2);
        return this.pos += 2, parseInt(kr, 16);
      }, Ir.prototype.readChunk = function(kr) {
        var Ce = this.hex.substring(this.pos, this.pos + kr * 2);
        return this.pos += kr * 2, typeof Buffer$f == "function" ? Buffer$f.from(Ce, "hex") : new u(Ce);
      };
      function xr(kr) {
        this.$hex = "", this.finalFormat = kr || "hex";
      }
      return xr.prototype = Object.create(F.prototype), xr.prototype.writeByte = function(kr) {
        if (kr < 0 || kr > 255) throw new Error("Byte value out of range: " + kr);
        var Ce = kr.toString(16);
        Ce.length == 1 && (Ce = "0" + Ce), this.$hex += Ce;
      }, xr.prototype.canWriteBinary = function(kr) {
        return kr instanceof u || typeof Buffer$f == "function" && kr instanceof Buffer$f;
      }, xr.prototype.writeBinary = function(kr, Ce) {
        if (kr instanceof u)
          Ce(kr.length()), this.$hex += kr.$hex;
        else if (typeof Buffer$f == "function" && kr instanceof Buffer$f)
          Ce(kr.length), this.$hex += kr.toString("hex");
        else
          throw new TypeError("HexWriter only accepts BinaryHex or Buffers");
      }, xr.prototype.result = function() {
        return this.finalFormat === "buffer" && typeof Buffer$f == "function" ? Buffer$f.from(this.$hex, "hex") : new u(this.$hex).toString(this.finalFormat);
      }, xr.prototype.writeString = function(kr, Ce) {
        var tr = u.fromUtf8String(kr);
        Ce(tr.length()), this.$hex += tr.$hex;
      }, ir.addReader(function(kr, Ce) {
        if (kr instanceof u || kr.$hex)
          return new Ir(kr.$hex);
        if (Ce === "hex")
          return new Ir(kr);
      }), ir.addWriter(function(kr) {
        if (kr === "hex")
          return new xr();
      }), ir;
    }();
    return c.addSemanticEncode(0, function(u) {
      if (u instanceof Date)
        return u.toISOString();
    }).addSemanticDecode(0, function(u) {
      return new Date(u);
    }).addSemanticDecode(1, function(u) {
      return new Date(u);
    }), c;
  });
})(main$4);
var mainExports$1 = main$4.exports;
Object.defineProperty(cbor$1, "__esModule", { value: !0 });
cbor$1.cborDecode = cbor$1.cborEncode = void 0;
const cbor = mainExports$1, cborEncode = (n) => cbor.encode(n);
cbor$1.cborEncode = cborEncode;
const cborDecode = (n) => cbor.decode(Buffer$f.isBuffer(n) ? n : Buffer$f.from(n, "hex"));
cbor$1.cborDecode = cborDecode;
Object.defineProperty(ur$1, "__esModule", { value: !0 });
const errors_1$5 = errors$f, utils_1$t = utils$I, cbor_1$1 = cbor$1;
class UR {
  constructor(c, u = "bytes") {
    if (this._cborPayload = c, this._type = u, !utils_1$t.isURType(this._type))
      throw new errors_1$5.InvalidTypeError();
  }
  static fromBuffer(c) {
    return new UR(cbor_1$1.cborEncode(c));
  }
  static from(c, u) {
    return UR.fromBuffer(Buffer$f.from(c, u));
  }
  decodeCBOR() {
    return cbor_1$1.cborDecode(this._cborPayload);
  }
  get type() {
    return this._type;
  }
  get cbor() {
    return this._cborPayload;
  }
  equals(c) {
    return this.type === c.type && this.cbor.equals(c.cbor);
  }
}
ur$1.default = UR;
var urEncoder = {}, fountainEncoder = {}, assert$t = { exports: {} }, errors$e = {}, hasRequiredErrors$c;
function requireErrors$c() {
  if (hasRequiredErrors$c) return errors$e;
  hasRequiredErrors$c = 1;
  function n(or) {
    "@babel/helpers - typeof";
    return n = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(lr) {
      return typeof lr;
    } : function(lr) {
      return lr && typeof Symbol == "function" && lr.constructor === Symbol && lr !== Symbol.prototype ? "symbol" : typeof lr;
    }, n(or);
  }
  function c(or, lr, Ir) {
    return Object.defineProperty(or, "prototype", { writable: !1 }), or;
  }
  function u(or, lr) {
    if (!(or instanceof lr))
      throw new TypeError("Cannot call a class as a function");
  }
  function p(or, lr) {
    if (typeof lr != "function" && lr !== null)
      throw new TypeError("Super expression must either be null or a function");
    or.prototype = Object.create(lr && lr.prototype, { constructor: { value: or, writable: !0, configurable: !0 } }), Object.defineProperty(or, "prototype", { writable: !1 }), lr && a(or, lr);
  }
  function a(or, lr) {
    return a = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(xr, kr) {
      return xr.__proto__ = kr, xr;
    }, a(or, lr);
  }
  function A(or) {
    var lr = le();
    return function() {
      var xr = L(or), kr;
      if (lr) {
        var Ce = L(this).constructor;
        kr = Reflect.construct(xr, arguments, Ce);
      } else
        kr = xr.apply(this, arguments);
      return b(this, kr);
    };
  }
  function b(or, lr) {
    if (lr && (n(lr) === "object" || typeof lr == "function"))
      return lr;
    if (lr !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return F(or);
  }
  function F(or) {
    if (or === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return or;
  }
  function le() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  function L(or) {
    return L = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(Ir) {
      return Ir.__proto__ || Object.getPrototypeOf(Ir);
    }, L(or);
  }
  var pe = {}, $, Ee;
  function be(or, lr, Ir) {
    Ir || (Ir = Error);
    function xr(Ce, tr, Fe) {
      return typeof lr == "string" ? lr : lr(Ce, tr, Fe);
    }
    var kr = /* @__PURE__ */ function(Ce) {
      p(Fe, Ce);
      var tr = A(Fe);
      function Fe(Sr, er, Ie) {
        var xe;
        return u(this, Fe), xe = tr.call(this, xr(Sr, er, Ie)), xe.code = or, xe;
      }
      return c(Fe);
    }(Ir);
    pe[or] = kr;
  }
  function He(or, lr) {
    if (Array.isArray(or)) {
      var Ir = or.length;
      return or = or.map(function(xr) {
        return String(xr);
      }), Ir > 2 ? "one of ".concat(lr, " ").concat(or.slice(0, Ir - 1).join(", "), ", or ") + or[Ir - 1] : Ir === 2 ? "one of ".concat(lr, " ").concat(or[0], " or ").concat(or[1]) : "of ".concat(lr, " ").concat(or[0]);
    } else
      return "of ".concat(lr, " ").concat(String(or));
  }
  function Pe(or, lr, Ir) {
    return or.substr(0, lr.length) === lr;
  }
  function nr(or, lr, Ir) {
    return (Ir === void 0 || Ir > or.length) && (Ir = or.length), or.substring(Ir - lr.length, Ir) === lr;
  }
  function ir(or, lr, Ir) {
    return typeof Ir != "number" && (Ir = 0), Ir + lr.length > or.length ? !1 : or.indexOf(lr, Ir) !== -1;
  }
  return be("ERR_AMBIGUOUS_ARGUMENT", 'The "%s" argument is ambiguous. %s', TypeError), be("ERR_INVALID_ARG_TYPE", function(or, lr, Ir) {
    $ === void 0 && ($ = requireAssert()), $(typeof or == "string", "'name' must be a string");
    var xr;
    typeof lr == "string" && Pe(lr, "not ") ? (xr = "must not be", lr = lr.replace(/^not /, "")) : xr = "must be";
    var kr;
    if (nr(or, " argument"))
      kr = "The ".concat(or, " ").concat(xr, " ").concat(He(lr, "type"));
    else {
      var Ce = ir(or, ".") ? "property" : "argument";
      kr = 'The "'.concat(or, '" ').concat(Ce, " ").concat(xr, " ").concat(He(lr, "type"));
    }
    return kr += ". Received type ".concat(n(Ir)), kr;
  }, TypeError), be("ERR_INVALID_ARG_VALUE", function(or, lr) {
    var Ir = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "is invalid";
    Ee === void 0 && (Ee = util$8);
    var xr = Ee.inspect(lr);
    return xr.length > 128 && (xr = "".concat(xr.slice(0, 128), "...")), "The argument '".concat(or, "' ").concat(Ir, ". Received ").concat(xr);
  }, TypeError), be("ERR_INVALID_RETURN_VALUE", function(or, lr, Ir) {
    var xr;
    return Ir && Ir.constructor && Ir.constructor.name ? xr = "instance of ".concat(Ir.constructor.name) : xr = "type ".concat(n(Ir)), "Expected ".concat(or, ' to be returned from the "').concat(lr, '"') + " function but got ".concat(xr, ".");
  }, TypeError), be("ERR_MISSING_ARGS", function() {
    for (var or = arguments.length, lr = new Array(or), Ir = 0; Ir < or; Ir++)
      lr[Ir] = arguments[Ir];
    $ === void 0 && ($ = requireAssert()), $(lr.length > 0, "At least one arg needs to be specified");
    var xr = "The ", kr = lr.length;
    switch (lr = lr.map(function(Ce) {
      return '"'.concat(Ce, '"');
    }), kr) {
      case 1:
        xr += "".concat(lr[0], " argument");
        break;
      case 2:
        xr += "".concat(lr[0], " and ").concat(lr[1], " arguments");
        break;
      default:
        xr += lr.slice(0, kr - 1).join(", "), xr += ", and ".concat(lr[kr - 1], " arguments");
        break;
    }
    return "".concat(xr, " must be specified");
  }, TypeError), errors$e.codes = pe, errors$e;
}
var assertion_error, hasRequiredAssertion_error;
function requireAssertion_error() {
  if (hasRequiredAssertion_error) return assertion_error;
  hasRequiredAssertion_error = 1;
  function n(vr, Te) {
    var Cr = Object.keys(vr);
    if (Object.getOwnPropertySymbols) {
      var Hr = Object.getOwnPropertySymbols(vr);
      Te && (Hr = Hr.filter(function(si) {
        return Object.getOwnPropertyDescriptor(vr, si).enumerable;
      })), Cr.push.apply(Cr, Hr);
    }
    return Cr;
  }
  function c(vr) {
    for (var Te = 1; Te < arguments.length; Te++) {
      var Cr = arguments[Te] != null ? arguments[Te] : {};
      Te % 2 ? n(Object(Cr), !0).forEach(function(Hr) {
        u(vr, Hr, Cr[Hr]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(vr, Object.getOwnPropertyDescriptors(Cr)) : n(Object(Cr)).forEach(function(Hr) {
        Object.defineProperty(vr, Hr, Object.getOwnPropertyDescriptor(Cr, Hr));
      });
    }
    return vr;
  }
  function u(vr, Te, Cr) {
    return Te = b(Te), Te in vr ? Object.defineProperty(vr, Te, { value: Cr, enumerable: !0, configurable: !0, writable: !0 }) : vr[Te] = Cr, vr;
  }
  function p(vr, Te) {
    if (!(vr instanceof Te))
      throw new TypeError("Cannot call a class as a function");
  }
  function a(vr, Te) {
    for (var Cr = 0; Cr < Te.length; Cr++) {
      var Hr = Te[Cr];
      Hr.enumerable = Hr.enumerable || !1, Hr.configurable = !0, "value" in Hr && (Hr.writable = !0), Object.defineProperty(vr, b(Hr.key), Hr);
    }
  }
  function A(vr, Te, Cr) {
    return Te && a(vr.prototype, Te), Object.defineProperty(vr, "prototype", { writable: !1 }), vr;
  }
  function b(vr) {
    var Te = F(vr, "string");
    return or(Te) === "symbol" ? Te : String(Te);
  }
  function F(vr, Te) {
    if (or(vr) !== "object" || vr === null) return vr;
    var Cr = vr[Symbol.toPrimitive];
    if (Cr !== void 0) {
      var Hr = Cr.call(vr, Te || "default");
      if (or(Hr) !== "object") return Hr;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (Te === "string" ? String : Number)(vr);
  }
  function le(vr, Te) {
    if (typeof Te != "function" && Te !== null)
      throw new TypeError("Super expression must either be null or a function");
    vr.prototype = Object.create(Te && Te.prototype, { constructor: { value: vr, writable: !0, configurable: !0 } }), Object.defineProperty(vr, "prototype", { writable: !1 }), Te && nr(vr, Te);
  }
  function L(vr) {
    var Te = He();
    return function() {
      var Hr = ir(vr), si;
      if (Te) {
        var ui = ir(this).constructor;
        si = Reflect.construct(Hr, arguments, ui);
      } else
        si = Hr.apply(this, arguments);
      return pe(this, si);
    };
  }
  function pe(vr, Te) {
    if (Te && (or(Te) === "object" || typeof Te == "function"))
      return Te;
    if (Te !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return $(vr);
  }
  function $(vr) {
    if (vr === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return vr;
  }
  function Ee(vr) {
    var Te = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
    return Ee = function(Hr) {
      if (Hr === null || !Pe(Hr)) return Hr;
      if (typeof Hr != "function")
        throw new TypeError("Super expression must either be null or a function");
      if (typeof Te < "u") {
        if (Te.has(Hr)) return Te.get(Hr);
        Te.set(Hr, si);
      }
      function si() {
        return be(Hr, arguments, ir(this).constructor);
      }
      return si.prototype = Object.create(Hr.prototype, { constructor: { value: si, enumerable: !1, writable: !0, configurable: !0 } }), nr(si, Hr);
    }, Ee(vr);
  }
  function be(vr, Te, Cr) {
    return He() ? be = Reflect.construct.bind() : be = function(si, ui, Li) {
      var Qi = [null];
      Qi.push.apply(Qi, ui);
      var wi = Function.bind.apply(si, Qi), Ji = new wi();
      return Li && nr(Ji, Li.prototype), Ji;
    }, be.apply(null, arguments);
  }
  function He() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  function Pe(vr) {
    return Function.toString.call(vr).indexOf("[native code]") !== -1;
  }
  function nr(vr, Te) {
    return nr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(Hr, si) {
      return Hr.__proto__ = si, Hr;
    }, nr(vr, Te);
  }
  function ir(vr) {
    return ir = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(Cr) {
      return Cr.__proto__ || Object.getPrototypeOf(Cr);
    }, ir(vr);
  }
  function or(vr) {
    "@babel/helpers - typeof";
    return or = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(Te) {
      return typeof Te;
    } : function(Te) {
      return Te && typeof Symbol == "function" && Te.constructor === Symbol && Te !== Symbol.prototype ? "symbol" : typeof Te;
    }, or(vr);
  }
  var lr = util$8, Ir = lr.inspect, xr = requireErrors$c(), kr = xr.codes.ERR_INVALID_ARG_TYPE;
  function Ce(vr, Te, Cr) {
    return (Cr === void 0 || Cr > vr.length) && (Cr = vr.length), vr.substring(Cr - Te.length, Cr) === Te;
  }
  function tr(vr, Te) {
    if (Te = Math.floor(Te), vr.length == 0 || Te == 0) return "";
    var Cr = vr.length * Te;
    for (Te = Math.floor(Math.log(Te) / Math.log(2)); Te; )
      vr += vr, Te--;
    return vr += vr.substring(0, Cr - vr.length), vr;
  }
  var Fe = "", Sr = "", er = "", Ie = "", xe = {
    deepStrictEqual: "Expected values to be strictly deep-equal:",
    strictEqual: "Expected values to be strictly equal:",
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: "Expected values to be loosely deep-equal:",
    equal: "Expected values to be loosely equal:",
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: "Values identical but not reference-equal:"
  }, rr = 10;
  function ar(vr) {
    var Te = Object.keys(vr), Cr = Object.create(Object.getPrototypeOf(vr));
    return Te.forEach(function(Hr) {
      Cr[Hr] = vr[Hr];
    }), Object.defineProperty(Cr, "message", {
      value: vr.message
    }), Cr;
  }
  function yr(vr) {
    return Ir(vr, {
      compact: !1,
      customInspect: !1,
      depth: 1e3,
      maxArrayLength: 1 / 0,
      // Assert compares only enumerable properties (with a few exceptions).
      showHidden: !1,
      // Having a long line as error is better than wrapping the line for
      // comparison for now.
      // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
      // have meta information about the inspected properties (i.e., know where
      // in what line the property starts and ends).
      breakLength: 1 / 0,
      // Assert does not detect proxies currently.
      showProxy: !1,
      sorted: !0,
      // Inspect getters as we also check them when comparing entries.
      getters: !0
    });
  }
  function _r(vr, Te, Cr) {
    var Hr = "", si = "", ui = 0, Li = "", Qi = !1, wi = yr(vr), Ji = wi.split(`
`), mn = yr(Te).split(`
`), pi = 0, ei = "";
    if (Cr === "strictEqual" && or(vr) === "object" && or(Te) === "object" && vr !== null && Te !== null && (Cr = "strictEqualObject"), Ji.length === 1 && mn.length === 1 && Ji[0] !== mn[0]) {
      var Vr = Ji[0].length + mn[0].length;
      if (Vr <= rr) {
        if ((or(vr) !== "object" || vr === null) && (or(Te) !== "object" || Te === null) && (vr !== 0 || Te !== 0))
          return "".concat(xe[Cr], `

`) + "".concat(Ji[0], " !== ").concat(mn[0], `
`);
      } else if (Cr !== "strictEqualObject") {
        var qr = process$1.stderr && process$1.stderr.isTTY ? process$1.stderr.columns : 80;
        if (Vr < qr) {
          for (; Ji[0][pi] === mn[0][pi]; )
            pi++;
          pi > 2 && (ei = `
  `.concat(tr(" ", pi), "^"), pi = 0);
        }
      }
    }
    for (var Zi = Ji[Ji.length - 1], Wr = mn[mn.length - 1]; Zi === Wr && (pi++ < 2 ? Li = `
  `.concat(Zi).concat(Li) : Hr = Zi, Ji.pop(), mn.pop(), !(Ji.length === 0 || mn.length === 0)); )
      Zi = Ji[Ji.length - 1], Wr = mn[mn.length - 1];
    var ri = Math.max(Ji.length, mn.length);
    if (ri === 0) {
      var _i = wi.split(`
`);
      if (_i.length > 30)
        for (_i[26] = "".concat(Fe, "...").concat(Ie); _i.length > 27; )
          _i.pop();
      return "".concat(xe.notIdentical, `

`).concat(_i.join(`
`), `
`);
    }
    pi > 3 && (Li = `
`.concat(Fe, "...").concat(Ie).concat(Li), Qi = !0), Hr !== "" && (Li = `
  `.concat(Hr).concat(Li), Hr = "");
    var Er = 0, Di = xe[Cr] + `
`.concat(Sr, "+ actual").concat(Ie, " ").concat(er, "- expected").concat(Ie), _n = " ".concat(Fe, "...").concat(Ie, " Lines skipped");
    for (pi = 0; pi < ri; pi++) {
      var On = pi - ui;
      if (Ji.length < pi + 1)
        On > 1 && pi > 2 && (On > 4 ? (si += `
`.concat(Fe, "...").concat(Ie), Qi = !0) : On > 3 && (si += `
  `.concat(mn[pi - 2]), Er++), si += `
  `.concat(mn[pi - 1]), Er++), ui = pi, Hr += `
`.concat(er, "-").concat(Ie, " ").concat(mn[pi]), Er++;
      else if (mn.length < pi + 1)
        On > 1 && pi > 2 && (On > 4 ? (si += `
`.concat(Fe, "...").concat(Ie), Qi = !0) : On > 3 && (si += `
  `.concat(Ji[pi - 2]), Er++), si += `
  `.concat(Ji[pi - 1]), Er++), ui = pi, si += `
`.concat(Sr, "+").concat(Ie, " ").concat(Ji[pi]), Er++;
      else {
        var so = mn[pi], Do = Ji[pi], gn = Do !== so && (!Ce(Do, ",") || Do.slice(0, -1) !== so);
        gn && Ce(so, ",") && so.slice(0, -1) === Do && (gn = !1, Do += ","), gn ? (On > 1 && pi > 2 && (On > 4 ? (si += `
`.concat(Fe, "...").concat(Ie), Qi = !0) : On > 3 && (si += `
  `.concat(Ji[pi - 2]), Er++), si += `
  `.concat(Ji[pi - 1]), Er++), ui = pi, si += `
`.concat(Sr, "+").concat(Ie, " ").concat(Do), Hr += `
`.concat(er, "-").concat(Ie, " ").concat(so), Er += 2) : (si += Hr, Hr = "", (On === 1 || pi === 0) && (si += `
  `.concat(Do), Er++));
      }
      if (Er > 20 && pi < ri - 2)
        return "".concat(Di).concat(_n, `
`).concat(si, `
`).concat(Fe, "...").concat(Ie).concat(Hr, `
`) + "".concat(Fe, "...").concat(Ie);
    }
    return "".concat(Di).concat(Qi ? _n : "", `
`).concat(si).concat(Hr).concat(Li).concat(ei);
  }
  var Or = /* @__PURE__ */ function(vr, Te) {
    le(Hr, vr);
    var Cr = L(Hr);
    function Hr(si) {
      var ui;
      if (p(this, Hr), or(si) !== "object" || si === null)
        throw new kr("options", "Object", si);
      var Li = si.message, Qi = si.operator, wi = si.stackStartFn, Ji = si.actual, mn = si.expected, pi = Error.stackTraceLimit;
      if (Error.stackTraceLimit = 0, Li != null)
        ui = Cr.call(this, String(Li));
      else if (process$1.stderr && process$1.stderr.isTTY && (process$1.stderr && process$1.stderr.getColorDepth && process$1.stderr.getColorDepth() !== 1 ? (Fe = "\x1B[34m", Sr = "\x1B[32m", Ie = "\x1B[39m", er = "\x1B[31m") : (Fe = "", Sr = "", Ie = "", er = "")), or(Ji) === "object" && Ji !== null && or(mn) === "object" && mn !== null && "stack" in Ji && Ji instanceof Error && "stack" in mn && mn instanceof Error && (Ji = ar(Ji), mn = ar(mn)), Qi === "deepStrictEqual" || Qi === "strictEqual")
        ui = Cr.call(this, _r(Ji, mn, Qi));
      else if (Qi === "notDeepStrictEqual" || Qi === "notStrictEqual") {
        var ei = xe[Qi], Vr = yr(Ji).split(`
`);
        if (Qi === "notStrictEqual" && or(Ji) === "object" && Ji !== null && (ei = xe.notStrictEqualObject), Vr.length > 30)
          for (Vr[26] = "".concat(Fe, "...").concat(Ie); Vr.length > 27; )
            Vr.pop();
        Vr.length === 1 ? ui = Cr.call(this, "".concat(ei, " ").concat(Vr[0])) : ui = Cr.call(this, "".concat(ei, `

`).concat(Vr.join(`
`), `
`));
      } else {
        var qr = yr(Ji), Zi = "", Wr = xe[Qi];
        Qi === "notDeepEqual" || Qi === "notEqual" ? (qr = "".concat(xe[Qi], `

`).concat(qr), qr.length > 1024 && (qr = "".concat(qr.slice(0, 1021), "..."))) : (Zi = "".concat(yr(mn)), qr.length > 512 && (qr = "".concat(qr.slice(0, 509), "...")), Zi.length > 512 && (Zi = "".concat(Zi.slice(0, 509), "...")), Qi === "deepEqual" || Qi === "equal" ? qr = "".concat(Wr, `

`).concat(qr, `

should equal

`) : Zi = " ".concat(Qi, " ").concat(Zi)), ui = Cr.call(this, "".concat(qr).concat(Zi));
      }
      return Error.stackTraceLimit = pi, ui.generatedMessage = !Li, Object.defineProperty($(ui), "name", {
        value: "AssertionError [ERR_ASSERTION]",
        enumerable: !1,
        writable: !0,
        configurable: !0
      }), ui.code = "ERR_ASSERTION", ui.actual = Ji, ui.expected = mn, ui.operator = Qi, Error.captureStackTrace && Error.captureStackTrace($(ui), wi), ui.stack, ui.name = "AssertionError", pe(ui);
    }
    return A(Hr, [{
      key: "toString",
      value: function() {
        return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
      }
    }, {
      key: Te,
      value: function(ui, Li) {
        return Ir(this, c(c({}, Li), {}, {
          customInspect: !1,
          depth: 0
        }));
      }
    }]), Hr;
  }(/* @__PURE__ */ Ee(Error), Ir.custom);
  return assertion_error = Or, assertion_error;
}
var toStr = Object.prototype.toString, isArguments = function(c) {
  var u = toStr.call(c), p = u === "[object Arguments]";
  return p || (p = u !== "[object Array]" && c !== null && typeof c == "object" && typeof c.length == "number" && c.length >= 0 && toStr.call(c.callee) === "[object Function]"), p;
}, implementation$5, hasRequiredImplementation$1;
function requireImplementation$1() {
  if (hasRequiredImplementation$1) return implementation$5;
  hasRequiredImplementation$1 = 1;
  var n;
  if (!Object.keys) {
    var c = Object.prototype.hasOwnProperty, u = Object.prototype.toString, p = isArguments, a = Object.prototype.propertyIsEnumerable, A = !a.call({ toString: null }, "toString"), b = a.call(function() {
    }, "prototype"), F = [
      "toString",
      "toLocaleString",
      "valueOf",
      "hasOwnProperty",
      "isPrototypeOf",
      "propertyIsEnumerable",
      "constructor"
    ], le = function(Ee) {
      var be = Ee.constructor;
      return be && be.prototype === Ee;
    }, L = {
      $applicationCache: !0,
      $console: !0,
      $external: !0,
      $frame: !0,
      $frameElement: !0,
      $frames: !0,
      $innerHeight: !0,
      $innerWidth: !0,
      $onmozfullscreenchange: !0,
      $onmozfullscreenerror: !0,
      $outerHeight: !0,
      $outerWidth: !0,
      $pageXOffset: !0,
      $pageYOffset: !0,
      $parent: !0,
      $scrollLeft: !0,
      $scrollTop: !0,
      $scrollX: !0,
      $scrollY: !0,
      $self: !0,
      $webkitIndexedDB: !0,
      $webkitStorageInfo: !0,
      $window: !0
    }, pe = function() {
      if (typeof window > "u")
        return !1;
      for (var Ee in window)
        try {
          if (!L["$" + Ee] && c.call(window, Ee) && window[Ee] !== null && typeof window[Ee] == "object")
            try {
              le(window[Ee]);
            } catch {
              return !0;
            }
        } catch {
          return !0;
        }
      return !1;
    }(), $ = function(Ee) {
      if (typeof window > "u" || !pe)
        return le(Ee);
      try {
        return le(Ee);
      } catch {
        return !1;
      }
    };
    n = function(be) {
      var He = be !== null && typeof be == "object", Pe = u.call(be) === "[object Function]", nr = p(be), ir = He && u.call(be) === "[object String]", or = [];
      if (!He && !Pe && !nr)
        throw new TypeError("Object.keys called on a non-object");
      var lr = b && Pe;
      if (ir && be.length > 0 && !c.call(be, 0))
        for (var Ir = 0; Ir < be.length; ++Ir)
          or.push(String(Ir));
      if (nr && be.length > 0)
        for (var xr = 0; xr < be.length; ++xr)
          or.push(String(xr));
      else
        for (var kr in be)
          !(lr && kr === "prototype") && c.call(be, kr) && or.push(String(kr));
      if (A)
        for (var Ce = $(be), tr = 0; tr < F.length; ++tr)
          !(Ce && F[tr] === "constructor") && c.call(be, F[tr]) && or.push(F[tr]);
      return or;
    };
  }
  return implementation$5 = n, implementation$5;
}
var slice = Array.prototype.slice, isArgs = isArguments, origKeys = Object.keys, keysShim = origKeys ? function(c) {
  return origKeys(c);
} : requireImplementation$1(), originalKeys = Object.keys;
keysShim.shim = function() {
  if (Object.keys) {
    var c = function() {
      var u = Object.keys(arguments);
      return u && u.length === arguments.length;
    }(1, 2);
    c || (Object.keys = function(p) {
      return isArgs(p) ? originalKeys(slice.call(p)) : originalKeys(p);
    });
  } else
    Object.keys = keysShim;
  return Object.keys || keysShim;
};
var objectKeys$1 = keysShim, objectKeys = objectKeys$1, hasSymbols = shams$1(), callBound$1 = callBound$4, $Object = esObjectAtoms, $push = callBound$1("Array.prototype.push"), $propIsEnumerable = callBound$1("Object.prototype.propertyIsEnumerable"), originalGetSymbols = hasSymbols ? $Object.getOwnPropertySymbols : null, implementation$4 = function(c, u) {
  if (c == null)
    throw new TypeError("target must be an object");
  var p = $Object(c);
  if (arguments.length === 1)
    return p;
  for (var a = 1; a < arguments.length; ++a) {
    var A = $Object(arguments[a]), b = objectKeys(A), F = hasSymbols && ($Object.getOwnPropertySymbols || originalGetSymbols);
    if (F)
      for (var le = F(A), L = 0; L < le.length; ++L) {
        var pe = le[L];
        $propIsEnumerable(A, pe) && $push(b, pe);
      }
    for (var $ = 0; $ < b.length; ++$) {
      var Ee = b[$];
      if ($propIsEnumerable(A, Ee)) {
        var be = A[Ee];
        p[Ee] = be;
      }
    }
  }
  return p;
}, implementation$3 = implementation$4, lacksProperEnumerationOrder = function() {
  if (!Object.assign)
    return !1;
  for (var n = "abcdefghijklmnopqrst", c = n.split(""), u = {}, p = 0; p < c.length; ++p)
    u[c[p]] = c[p];
  var a = Object.assign({}, u), A = "";
  for (var b in a)
    A += b;
  return n !== A;
}, assignHasPendingExceptions = function() {
  if (!Object.assign || !Object.preventExtensions)
    return !1;
  var n = Object.preventExtensions({ 1: 2 });
  try {
    Object.assign(n, "xy");
  } catch {
    return n[1] === "y";
  }
  return !1;
}, polyfill$2 = function() {
  return !Object.assign || lacksProperEnumerationOrder() || assignHasPendingExceptions() ? implementation$3 : Object.assign;
}, numberIsNaN = function(n) {
  return n !== n;
}, implementation$2 = function(c, u) {
  return c === 0 && u === 0 ? 1 / c === 1 / u : !!(c === u || numberIsNaN(c) && numberIsNaN(u));
}, implementation$1 = implementation$2, polyfill$1 = function() {
  return typeof Object.is == "function" ? Object.is : implementation$1;
}, GetIntrinsic = getIntrinsic, callBind = callBindExports, $indexOf = callBind(GetIntrinsic("String.prototype.indexOf")), callBound = function(c, u) {
  var p = GetIntrinsic(c, !!u);
  return typeof p == "function" && $indexOf(c, ".prototype.") > -1 ? callBind(p) : p;
}, defineProperties_1, hasRequiredDefineProperties;
function requireDefineProperties() {
  if (hasRequiredDefineProperties) return defineProperties_1;
  hasRequiredDefineProperties = 1;
  var n = objectKeys$1, c = typeof Symbol == "function" && typeof Symbol("foo") == "symbol", u = Object.prototype.toString, p = Array.prototype.concat, a = defineDataProperty, A = function(L) {
    return typeof L == "function" && u.call(L) === "[object Function]";
  }, b = hasPropertyDescriptors_1(), F = function(L, pe, $, Ee) {
    if (pe in L) {
      if (Ee === !0) {
        if (L[pe] === $)
          return;
      } else if (!A(Ee) || !Ee())
        return;
    }
    b ? a(L, pe, $, !0) : a(L, pe, $);
  }, le = function(L, pe) {
    var $ = arguments.length > 2 ? arguments[2] : {}, Ee = n(pe);
    c && (Ee = p.call(Ee, Object.getOwnPropertySymbols(pe)));
    for (var be = 0; be < Ee.length; be += 1)
      F(L, Ee[be], pe[Ee[be]], $[Ee[be]]);
  };
  return le.supportsDescriptors = !!b, defineProperties_1 = le, defineProperties_1;
}
var shim$1, hasRequiredShim$1;
function requireShim$1() {
  if (hasRequiredShim$1) return shim$1;
  hasRequiredShim$1 = 1;
  var n = polyfill$1, c = requireDefineProperties();
  return shim$1 = function() {
    var p = n();
    return c(Object, { is: p }, {
      is: function() {
        return Object.is !== p;
      }
    }), p;
  }, shim$1;
}
var objectIs, hasRequiredObjectIs;
function requireObjectIs() {
  if (hasRequiredObjectIs) return objectIs;
  hasRequiredObjectIs = 1;
  var n = requireDefineProperties(), c = callBindExports, u = implementation$2, p = polyfill$1, a = requireShim$1(), A = c(p(), Object);
  return n(A, {
    getPolyfill: p,
    implementation: u,
    shim: a
  }), objectIs = A, objectIs;
}
var implementation, hasRequiredImplementation;
function requireImplementation() {
  return hasRequiredImplementation || (hasRequiredImplementation = 1, implementation = function(c) {
    return c !== c;
  }), implementation;
}
var polyfill, hasRequiredPolyfill;
function requirePolyfill() {
  if (hasRequiredPolyfill) return polyfill;
  hasRequiredPolyfill = 1;
  var n = requireImplementation();
  return polyfill = function() {
    return Number.isNaN && Number.isNaN(NaN) && !Number.isNaN("a") ? Number.isNaN : n;
  }, polyfill;
}
var shim, hasRequiredShim;
function requireShim() {
  if (hasRequiredShim) return shim;
  hasRequiredShim = 1;
  var n = requireDefineProperties(), c = requirePolyfill();
  return shim = function() {
    var p = c();
    return n(Number, { isNaN: p }, {
      isNaN: function() {
        return Number.isNaN !== p;
      }
    }), p;
  }, shim;
}
var isNan, hasRequiredIsNan;
function requireIsNan() {
  if (hasRequiredIsNan) return isNan;
  hasRequiredIsNan = 1;
  var n = callBindExports, c = requireDefineProperties(), u = requireImplementation(), p = requirePolyfill(), a = requireShim(), A = n(p(), Number);
  return c(A, {
    getPolyfill: p,
    implementation: u,
    shim: a
  }), isNan = A, isNan;
}
var comparisons, hasRequiredComparisons;
function requireComparisons() {
  if (hasRequiredComparisons) return comparisons;
  hasRequiredComparisons = 1;
  function n(gn, Gn) {
    return A(gn) || a(gn, Gn) || u(gn, Gn) || c();
  }
  function c() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function u(gn, Gn) {
    if (gn) {
      if (typeof gn == "string") return p(gn, Gn);
      var pn = Object.prototype.toString.call(gn).slice(8, -1);
      if (pn === "Object" && gn.constructor && (pn = gn.constructor.name), pn === "Map" || pn === "Set") return Array.from(gn);
      if (pn === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(pn)) return p(gn, Gn);
    }
  }
  function p(gn, Gn) {
    (Gn == null || Gn > gn.length) && (Gn = gn.length);
    for (var pn = 0, hn = new Array(Gn); pn < Gn; pn++) hn[pn] = gn[pn];
    return hn;
  }
  function a(gn, Gn) {
    var pn = gn == null ? null : typeof Symbol < "u" && gn[Symbol.iterator] || gn["@@iterator"];
    if (pn != null) {
      var hn, Rn, vo, Hi, di = [], Ui = !0, ln = !1;
      try {
        if (vo = (pn = pn.call(gn)).next, Gn !== 0) for (; !(Ui = (hn = vo.call(pn)).done) && (di.push(hn.value), di.length !== Gn); Ui = !0) ;
      } catch (Un) {
        ln = !0, Rn = Un;
      } finally {
        try {
          if (!Ui && pn.return != null && (Hi = pn.return(), Object(Hi) !== Hi)) return;
        } finally {
          if (ln) throw Rn;
        }
      }
      return di;
    }
  }
  function A(gn) {
    if (Array.isArray(gn)) return gn;
  }
  function b(gn) {
    "@babel/helpers - typeof";
    return b = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(Gn) {
      return typeof Gn;
    } : function(Gn) {
      return Gn && typeof Symbol == "function" && Gn.constructor === Symbol && Gn !== Symbol.prototype ? "symbol" : typeof Gn;
    }, b(gn);
  }
  var F = /a/g.flags !== void 0, le = function(Gn) {
    var pn = [];
    return Gn.forEach(function(hn) {
      return pn.push(hn);
    }), pn;
  }, L = function(Gn) {
    var pn = [];
    return Gn.forEach(function(hn, Rn) {
      return pn.push([Rn, hn]);
    }), pn;
  }, pe = Object.is ? Object.is : requireObjectIs(), $ = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
  }, Ee = Number.isNaN ? Number.isNaN : requireIsNan();
  function be(gn) {
    return gn.call.bind(gn);
  }
  var He = be(Object.prototype.hasOwnProperty), Pe = be(Object.prototype.propertyIsEnumerable), nr = be(Object.prototype.toString), ir = util$8.types, or = ir.isAnyArrayBuffer, lr = ir.isArrayBufferView, Ir = ir.isDate, xr = ir.isMap, kr = ir.isRegExp, Ce = ir.isSet, tr = ir.isNativeError, Fe = ir.isBoxedPrimitive, Sr = ir.isNumberObject, er = ir.isStringObject, Ie = ir.isBooleanObject, xe = ir.isBigIntObject, rr = ir.isSymbolObject, ar = ir.isFloat32Array, yr = ir.isFloat64Array;
  function _r(gn) {
    if (gn.length === 0 || gn.length > 10) return !0;
    for (var Gn = 0; Gn < gn.length; Gn++) {
      var pn = gn.charCodeAt(Gn);
      if (pn < 48 || pn > 57) return !0;
    }
    return gn.length === 10 && gn >= Math.pow(2, 32);
  }
  function Or(gn) {
    return Object.keys(gn).filter(_r).concat($(gn).filter(Object.prototype.propertyIsEnumerable.bind(gn)));
  }
  function vr(gn, Gn) {
    if (gn === Gn)
      return 0;
    for (var pn = gn.length, hn = Gn.length, Rn = 0, vo = Math.min(pn, hn); Rn < vo; ++Rn)
      if (gn[Rn] !== Gn[Rn]) {
        pn = gn[Rn], hn = Gn[Rn];
        break;
      }
    return pn < hn ? -1 : hn < pn ? 1 : 0;
  }
  var Te = !0, Cr = !1, Hr = 0, si = 1, ui = 2, Li = 3;
  function Qi(gn, Gn) {
    return F ? gn.source === Gn.source && gn.flags === Gn.flags : RegExp.prototype.toString.call(gn) === RegExp.prototype.toString.call(Gn);
  }
  function wi(gn, Gn) {
    if (gn.byteLength !== Gn.byteLength)
      return !1;
    for (var pn = 0; pn < gn.byteLength; pn++)
      if (gn[pn] !== Gn[pn])
        return !1;
    return !0;
  }
  function Ji(gn, Gn) {
    return gn.byteLength !== Gn.byteLength ? !1 : vr(new Uint8Array(gn.buffer, gn.byteOffset, gn.byteLength), new Uint8Array(Gn.buffer, Gn.byteOffset, Gn.byteLength)) === 0;
  }
  function mn(gn, Gn) {
    return gn.byteLength === Gn.byteLength && vr(new Uint8Array(gn), new Uint8Array(Gn)) === 0;
  }
  function pi(gn, Gn) {
    return Sr(gn) ? Sr(Gn) && pe(Number.prototype.valueOf.call(gn), Number.prototype.valueOf.call(Gn)) : er(gn) ? er(Gn) && String.prototype.valueOf.call(gn) === String.prototype.valueOf.call(Gn) : Ie(gn) ? Ie(Gn) && Boolean.prototype.valueOf.call(gn) === Boolean.prototype.valueOf.call(Gn) : xe(gn) ? xe(Gn) && BigInt.prototype.valueOf.call(gn) === BigInt.prototype.valueOf.call(Gn) : rr(Gn) && Symbol.prototype.valueOf.call(gn) === Symbol.prototype.valueOf.call(Gn);
  }
  function ei(gn, Gn, pn, hn) {
    if (gn === Gn)
      return gn !== 0 ? !0 : pn ? pe(gn, Gn) : !0;
    if (pn) {
      if (b(gn) !== "object")
        return typeof gn == "number" && Ee(gn) && Ee(Gn);
      if (b(Gn) !== "object" || gn === null || Gn === null || Object.getPrototypeOf(gn) !== Object.getPrototypeOf(Gn))
        return !1;
    } else {
      if (gn === null || b(gn) !== "object")
        return Gn === null || b(Gn) !== "object" ? gn == Gn : !1;
      if (Gn === null || b(Gn) !== "object")
        return !1;
    }
    var Rn = nr(gn), vo = nr(Gn);
    if (Rn !== vo)
      return !1;
    if (Array.isArray(gn)) {
      if (gn.length !== Gn.length)
        return !1;
      var Hi = Or(gn), di = Or(Gn);
      return Hi.length !== di.length ? !1 : qr(gn, Gn, pn, hn, si, Hi);
    }
    if (Rn === "[object Object]" && (!xr(gn) && xr(Gn) || !Ce(gn) && Ce(Gn)))
      return !1;
    if (Ir(gn)) {
      if (!Ir(Gn) || Date.prototype.getTime.call(gn) !== Date.prototype.getTime.call(Gn))
        return !1;
    } else if (kr(gn)) {
      if (!kr(Gn) || !Qi(gn, Gn))
        return !1;
    } else if (tr(gn) || gn instanceof Error) {
      if (gn.message !== Gn.message || gn.name !== Gn.name)
        return !1;
    } else if (lr(gn)) {
      if (!pn && (ar(gn) || yr(gn))) {
        if (!wi(gn, Gn))
          return !1;
      } else if (!Ji(gn, Gn))
        return !1;
      var Ui = Or(gn), ln = Or(Gn);
      return Ui.length !== ln.length ? !1 : qr(gn, Gn, pn, hn, Hr, Ui);
    } else {
      if (Ce(gn))
        return !Ce(Gn) || gn.size !== Gn.size ? !1 : qr(gn, Gn, pn, hn, ui);
      if (xr(gn))
        return !xr(Gn) || gn.size !== Gn.size ? !1 : qr(gn, Gn, pn, hn, Li);
      if (or(gn)) {
        if (!mn(gn, Gn))
          return !1;
      } else if (Fe(gn) && !pi(gn, Gn))
        return !1;
    }
    return qr(gn, Gn, pn, hn, Hr);
  }
  function Vr(gn, Gn) {
    return Gn.filter(function(pn) {
      return Pe(gn, pn);
    });
  }
  function qr(gn, Gn, pn, hn, Rn, vo) {
    if (arguments.length === 5) {
      vo = Object.keys(gn);
      var Hi = Object.keys(Gn);
      if (vo.length !== Hi.length)
        return !1;
    }
    for (var di = 0; di < vo.length; di++)
      if (!He(Gn, vo[di]))
        return !1;
    if (pn && arguments.length === 5) {
      var Ui = $(gn);
      if (Ui.length !== 0) {
        var ln = 0;
        for (di = 0; di < Ui.length; di++) {
          var Un = Ui[di];
          if (Pe(gn, Un)) {
            if (!Pe(Gn, Un))
              return !1;
            vo.push(Un), ln++;
          } else if (Pe(Gn, Un))
            return !1;
        }
        var Bo = $(Gn);
        if (Ui.length !== Bo.length && Vr(Gn, Bo).length !== ln)
          return !1;
      } else {
        var co = $(Gn);
        if (co.length !== 0 && Vr(Gn, co).length !== 0)
          return !1;
      }
    }
    if (vo.length === 0 && (Rn === Hr || Rn === si && gn.length === 0 || gn.size === 0))
      return !0;
    if (hn === void 0)
      hn = {
        val1: /* @__PURE__ */ new Map(),
        val2: /* @__PURE__ */ new Map(),
        position: 0
      };
    else {
      var To = hn.val1.get(gn);
      if (To !== void 0) {
        var xs = hn.val2.get(Gn);
        if (xs !== void 0)
          return To === xs;
      }
      hn.position++;
    }
    hn.val1.set(gn, hn.position), hn.val2.set(Gn, hn.position);
    var Fo = On(gn, Gn, pn, vo, hn, Rn);
    return hn.val1.delete(gn), hn.val2.delete(Gn), Fo;
  }
  function Zi(gn, Gn, pn, hn) {
    for (var Rn = le(gn), vo = 0; vo < Rn.length; vo++) {
      var Hi = Rn[vo];
      if (ei(Gn, Hi, pn, hn))
        return gn.delete(Hi), !0;
    }
    return !1;
  }
  function Wr(gn) {
    switch (b(gn)) {
      case "undefined":
        return null;
      case "object":
        return;
      case "symbol":
        return !1;
      case "string":
        gn = +gn;
      case "number":
        if (Ee(gn))
          return !1;
    }
    return !0;
  }
  function ri(gn, Gn, pn) {
    var hn = Wr(pn);
    return hn ?? (Gn.has(hn) && !gn.has(hn));
  }
  function _i(gn, Gn, pn, hn, Rn) {
    var vo = Wr(pn);
    if (vo != null)
      return vo;
    var Hi = Gn.get(vo);
    return Hi === void 0 && !Gn.has(vo) || !ei(hn, Hi, !1, Rn) ? !1 : !gn.has(vo) && ei(hn, Hi, !1, Rn);
  }
  function Er(gn, Gn, pn, hn) {
    for (var Rn = null, vo = le(gn), Hi = 0; Hi < vo.length; Hi++) {
      var di = vo[Hi];
      if (b(di) === "object" && di !== null)
        Rn === null && (Rn = /* @__PURE__ */ new Set()), Rn.add(di);
      else if (!Gn.has(di)) {
        if (pn || !ri(gn, Gn, di))
          return !1;
        Rn === null && (Rn = /* @__PURE__ */ new Set()), Rn.add(di);
      }
    }
    if (Rn !== null) {
      for (var Ui = le(Gn), ln = 0; ln < Ui.length; ln++) {
        var Un = Ui[ln];
        if (b(Un) === "object" && Un !== null) {
          if (!Zi(Rn, Un, pn, hn)) return !1;
        } else if (!pn && !gn.has(Un) && !Zi(Rn, Un, pn, hn))
          return !1;
      }
      return Rn.size === 0;
    }
    return !0;
  }
  function Di(gn, Gn, pn, hn, Rn, vo) {
    for (var Hi = le(gn), di = 0; di < Hi.length; di++) {
      var Ui = Hi[di];
      if (ei(pn, Ui, Rn, vo) && ei(hn, Gn.get(Ui), Rn, vo))
        return gn.delete(Ui), !0;
    }
    return !1;
  }
  function _n(gn, Gn, pn, hn) {
    for (var Rn = null, vo = L(gn), Hi = 0; Hi < vo.length; Hi++) {
      var di = n(vo[Hi], 2), Ui = di[0], ln = di[1];
      if (b(Ui) === "object" && Ui !== null)
        Rn === null && (Rn = /* @__PURE__ */ new Set()), Rn.add(Ui);
      else {
        var Un = Gn.get(Ui);
        if (Un === void 0 && !Gn.has(Ui) || !ei(ln, Un, pn, hn)) {
          if (pn || !_i(gn, Gn, Ui, ln, hn)) return !1;
          Rn === null && (Rn = /* @__PURE__ */ new Set()), Rn.add(Ui);
        }
      }
    }
    if (Rn !== null) {
      for (var Bo = L(Gn), co = 0; co < Bo.length; co++) {
        var To = n(Bo[co], 2), xs = To[0], Fo = To[1];
        if (b(xs) === "object" && xs !== null) {
          if (!Di(Rn, gn, xs, Fo, pn, hn)) return !1;
        } else if (!pn && (!gn.has(xs) || !ei(gn.get(xs), Fo, !1, hn)) && !Di(Rn, gn, xs, Fo, !1, hn))
          return !1;
      }
      return Rn.size === 0;
    }
    return !0;
  }
  function On(gn, Gn, pn, hn, Rn, vo) {
    var Hi = 0;
    if (vo === ui) {
      if (!Er(gn, Gn, pn, Rn))
        return !1;
    } else if (vo === Li) {
      if (!_n(gn, Gn, pn, Rn))
        return !1;
    } else if (vo === si)
      for (; Hi < gn.length; Hi++)
        if (He(gn, Hi)) {
          if (!He(Gn, Hi) || !ei(gn[Hi], Gn[Hi], pn, Rn))
            return !1;
        } else {
          if (He(Gn, Hi))
            return !1;
          for (var di = Object.keys(gn); Hi < di.length; Hi++) {
            var Ui = di[Hi];
            if (!He(Gn, Ui) || !ei(gn[Ui], Gn[Ui], pn, Rn))
              return !1;
          }
          return di.length === Object.keys(Gn).length;
        }
    for (Hi = 0; Hi < hn.length; Hi++) {
      var ln = hn[Hi];
      if (!ei(gn[ln], Gn[ln], pn, Rn))
        return !1;
    }
    return !0;
  }
  function so(gn, Gn) {
    return ei(gn, Gn, Cr);
  }
  function Do(gn, Gn) {
    return ei(gn, Gn, Te);
  }
  return comparisons = {
    isDeepEqual: so,
    isDeepStrictEqual: Do
  }, comparisons;
}
var hasRequiredAssert;
function requireAssert() {
  if (hasRequiredAssert) return assert$t.exports;
  hasRequiredAssert = 1;
  function n(ui) {
    "@babel/helpers - typeof";
    return n = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(Li) {
      return typeof Li;
    } : function(Li) {
      return Li && typeof Symbol == "function" && Li.constructor === Symbol && Li !== Symbol.prototype ? "symbol" : typeof Li;
    }, n(ui);
  }
  function c(ui, Li, Qi) {
    return Object.defineProperty(ui, "prototype", { writable: !1 }), ui;
  }
  function u(ui, Li) {
    if (!(ui instanceof Li))
      throw new TypeError("Cannot call a class as a function");
  }
  var p = requireErrors$c(), a = p.codes, A = a.ERR_AMBIGUOUS_ARGUMENT, b = a.ERR_INVALID_ARG_TYPE, F = a.ERR_INVALID_ARG_VALUE, le = a.ERR_INVALID_RETURN_VALUE, L = a.ERR_MISSING_ARGS, pe = requireAssertion_error(), $ = util$8, Ee = $.inspect, be = util$8.types, He = be.isPromise, Pe = be.isRegExp, nr = polyfill$2(), ir = polyfill$1(), or = callBound("RegExp.prototype.test"), lr, Ir;
  function xr() {
    var ui = requireComparisons();
    lr = ui.isDeepEqual, Ir = ui.isDeepStrictEqual;
  }
  var kr = !1, Ce = assert$t.exports = Ie, tr = {};
  function Fe(ui) {
    throw ui.message instanceof Error ? ui.message : new pe(ui);
  }
  function Sr(ui, Li, Qi, wi, Ji) {
    var mn = arguments.length, pi;
    if (mn === 0)
      pi = "Failed";
    else if (mn === 1)
      Qi = ui, ui = void 0;
    else {
      if (kr === !1) {
        kr = !0;
        var ei = process$1.emitWarning ? process$1.emitWarning : console.warn.bind(console);
        ei("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", "DeprecationWarning", "DEP0094");
      }
      mn === 2 && (wi = "!=");
    }
    if (Qi instanceof Error) throw Qi;
    var Vr = {
      actual: ui,
      expected: Li,
      operator: wi === void 0 ? "fail" : wi,
      stackStartFn: Ji || Sr
    };
    Qi !== void 0 && (Vr.message = Qi);
    var qr = new pe(Vr);
    throw pi && (qr.message = pi, qr.generatedMessage = !0), qr;
  }
  Ce.fail = Sr, Ce.AssertionError = pe;
  function er(ui, Li, Qi, wi) {
    if (!Qi) {
      var Ji = !1;
      if (Li === 0)
        Ji = !0, wi = "No value argument passed to `assert.ok()`";
      else if (wi instanceof Error)
        throw wi;
      var mn = new pe({
        actual: Qi,
        expected: !0,
        message: wi,
        operator: "==",
        stackStartFn: ui
      });
      throw mn.generatedMessage = Ji, mn;
    }
  }
  function Ie() {
    for (var ui = arguments.length, Li = new Array(ui), Qi = 0; Qi < ui; Qi++)
      Li[Qi] = arguments[Qi];
    er.apply(void 0, [Ie, Li.length].concat(Li));
  }
  Ce.ok = Ie, Ce.equal = function ui(Li, Qi, wi) {
    if (arguments.length < 2)
      throw new L("actual", "expected");
    Li != Qi && Fe({
      actual: Li,
      expected: Qi,
      message: wi,
      operator: "==",
      stackStartFn: ui
    });
  }, Ce.notEqual = function ui(Li, Qi, wi) {
    if (arguments.length < 2)
      throw new L("actual", "expected");
    Li == Qi && Fe({
      actual: Li,
      expected: Qi,
      message: wi,
      operator: "!=",
      stackStartFn: ui
    });
  }, Ce.deepEqual = function ui(Li, Qi, wi) {
    if (arguments.length < 2)
      throw new L("actual", "expected");
    lr === void 0 && xr(), lr(Li, Qi) || Fe({
      actual: Li,
      expected: Qi,
      message: wi,
      operator: "deepEqual",
      stackStartFn: ui
    });
  }, Ce.notDeepEqual = function ui(Li, Qi, wi) {
    if (arguments.length < 2)
      throw new L("actual", "expected");
    lr === void 0 && xr(), lr(Li, Qi) && Fe({
      actual: Li,
      expected: Qi,
      message: wi,
      operator: "notDeepEqual",
      stackStartFn: ui
    });
  }, Ce.deepStrictEqual = function ui(Li, Qi, wi) {
    if (arguments.length < 2)
      throw new L("actual", "expected");
    lr === void 0 && xr(), Ir(Li, Qi) || Fe({
      actual: Li,
      expected: Qi,
      message: wi,
      operator: "deepStrictEqual",
      stackStartFn: ui
    });
  }, Ce.notDeepStrictEqual = xe;
  function xe(ui, Li, Qi) {
    if (arguments.length < 2)
      throw new L("actual", "expected");
    lr === void 0 && xr(), Ir(ui, Li) && Fe({
      actual: ui,
      expected: Li,
      message: Qi,
      operator: "notDeepStrictEqual",
      stackStartFn: xe
    });
  }
  Ce.strictEqual = function ui(Li, Qi, wi) {
    if (arguments.length < 2)
      throw new L("actual", "expected");
    ir(Li, Qi) || Fe({
      actual: Li,
      expected: Qi,
      message: wi,
      operator: "strictEqual",
      stackStartFn: ui
    });
  }, Ce.notStrictEqual = function ui(Li, Qi, wi) {
    if (arguments.length < 2)
      throw new L("actual", "expected");
    ir(Li, Qi) && Fe({
      actual: Li,
      expected: Qi,
      message: wi,
      operator: "notStrictEqual",
      stackStartFn: ui
    });
  };
  var rr = /* @__PURE__ */ c(function ui(Li, Qi, wi) {
    var Ji = this;
    u(this, ui), Qi.forEach(function(mn) {
      mn in Li && (wi !== void 0 && typeof wi[mn] == "string" && Pe(Li[mn]) && or(Li[mn], wi[mn]) ? Ji[mn] = wi[mn] : Ji[mn] = Li[mn]);
    });
  });
  function ar(ui, Li, Qi, wi, Ji, mn) {
    if (!(Qi in ui) || !Ir(ui[Qi], Li[Qi])) {
      if (!wi) {
        var pi = new rr(ui, Ji), ei = new rr(Li, Ji, ui), Vr = new pe({
          actual: pi,
          expected: ei,
          operator: "deepStrictEqual",
          stackStartFn: mn
        });
        throw Vr.actual = ui, Vr.expected = Li, Vr.operator = mn.name, Vr;
      }
      Fe({
        actual: ui,
        expected: Li,
        message: wi,
        operator: mn.name,
        stackStartFn: mn
      });
    }
  }
  function yr(ui, Li, Qi, wi) {
    if (typeof Li != "function") {
      if (Pe(Li)) return or(Li, ui);
      if (arguments.length === 2)
        throw new b("expected", ["Function", "RegExp"], Li);
      if (n(ui) !== "object" || ui === null) {
        var Ji = new pe({
          actual: ui,
          expected: Li,
          message: Qi,
          operator: "deepStrictEqual",
          stackStartFn: wi
        });
        throw Ji.operator = wi.name, Ji;
      }
      var mn = Object.keys(Li);
      if (Li instanceof Error)
        mn.push("name", "message");
      else if (mn.length === 0)
        throw new F("error", Li, "may not be an empty object");
      return lr === void 0 && xr(), mn.forEach(function(pi) {
        typeof ui[pi] == "string" && Pe(Li[pi]) && or(Li[pi], ui[pi]) || ar(ui, Li, pi, Qi, mn, wi);
      }), !0;
    }
    return Li.prototype !== void 0 && ui instanceof Li ? !0 : Error.isPrototypeOf(Li) ? !1 : Li.call({}, ui) === !0;
  }
  function _r(ui) {
    if (typeof ui != "function")
      throw new b("fn", "Function", ui);
    try {
      ui();
    } catch (Li) {
      return Li;
    }
    return tr;
  }
  function Or(ui) {
    return He(ui) || ui !== null && n(ui) === "object" && typeof ui.then == "function" && typeof ui.catch == "function";
  }
  function vr(ui) {
    return Promise.resolve().then(function() {
      var Li;
      if (typeof ui == "function") {
        if (Li = ui(), !Or(Li))
          throw new le("instance of Promise", "promiseFn", Li);
      } else if (Or(ui))
        Li = ui;
      else
        throw new b("promiseFn", ["Function", "Promise"], ui);
      return Promise.resolve().then(function() {
        return Li;
      }).then(function() {
        return tr;
      }).catch(function(Qi) {
        return Qi;
      });
    });
  }
  function Te(ui, Li, Qi, wi) {
    if (typeof Qi == "string") {
      if (arguments.length === 4)
        throw new b("error", ["Object", "Error", "Function", "RegExp"], Qi);
      if (n(Li) === "object" && Li !== null) {
        if (Li.message === Qi)
          throw new A("error/message", 'The error message "'.concat(Li.message, '" is identical to the message.'));
      } else if (Li === Qi)
        throw new A("error/message", 'The error "'.concat(Li, '" is identical to the message.'));
      wi = Qi, Qi = void 0;
    } else if (Qi != null && n(Qi) !== "object" && typeof Qi != "function")
      throw new b("error", ["Object", "Error", "Function", "RegExp"], Qi);
    if (Li === tr) {
      var Ji = "";
      Qi && Qi.name && (Ji += " (".concat(Qi.name, ")")), Ji += wi ? ": ".concat(wi) : ".";
      var mn = ui.name === "rejects" ? "rejection" : "exception";
      Fe({
        actual: void 0,
        expected: Qi,
        operator: ui.name,
        message: "Missing expected ".concat(mn).concat(Ji),
        stackStartFn: ui
      });
    }
    if (Qi && !yr(Li, Qi, wi, ui))
      throw Li;
  }
  function Cr(ui, Li, Qi, wi) {
    if (Li !== tr) {
      if (typeof Qi == "string" && (wi = Qi, Qi = void 0), !Qi || yr(Li, Qi)) {
        var Ji = wi ? ": ".concat(wi) : ".", mn = ui.name === "doesNotReject" ? "rejection" : "exception";
        Fe({
          actual: Li,
          expected: Qi,
          operator: ui.name,
          message: "Got unwanted ".concat(mn).concat(Ji, `
`) + 'Actual message: "'.concat(Li && Li.message, '"'),
          stackStartFn: ui
        });
      }
      throw Li;
    }
  }
  Ce.throws = function ui(Li) {
    for (var Qi = arguments.length, wi = new Array(Qi > 1 ? Qi - 1 : 0), Ji = 1; Ji < Qi; Ji++)
      wi[Ji - 1] = arguments[Ji];
    Te.apply(void 0, [ui, _r(Li)].concat(wi));
  }, Ce.rejects = function ui(Li) {
    for (var Qi = arguments.length, wi = new Array(Qi > 1 ? Qi - 1 : 0), Ji = 1; Ji < Qi; Ji++)
      wi[Ji - 1] = arguments[Ji];
    return vr(Li).then(function(mn) {
      return Te.apply(void 0, [ui, mn].concat(wi));
    });
  }, Ce.doesNotThrow = function ui(Li) {
    for (var Qi = arguments.length, wi = new Array(Qi > 1 ? Qi - 1 : 0), Ji = 1; Ji < Qi; Ji++)
      wi[Ji - 1] = arguments[Ji];
    Cr.apply(void 0, [ui, _r(Li)].concat(wi));
  }, Ce.doesNotReject = function ui(Li) {
    for (var Qi = arguments.length, wi = new Array(Qi > 1 ? Qi - 1 : 0), Ji = 1; Ji < Qi; Ji++)
      wi[Ji - 1] = arguments[Ji];
    return vr(Li).then(function(mn) {
      return Cr.apply(void 0, [ui, mn].concat(wi));
    });
  }, Ce.ifError = function ui(Li) {
    if (Li != null) {
      var Qi = "ifError got unwanted exception: ";
      n(Li) === "object" && typeof Li.message == "string" ? Li.message.length === 0 && Li.constructor ? Qi += Li.constructor.name : Qi += Li.message : Qi += Ee(Li);
      var wi = new pe({
        actual: Li,
        expected: null,
        operator: "ifError",
        message: Qi,
        stackStartFn: ui
      }), Ji = Li.stack;
      if (typeof Ji == "string") {
        var mn = Ji.split(`
`);
        mn.shift();
        for (var pi = wi.stack.split(`
`), ei = 0; ei < mn.length; ei++) {
          var Vr = pi.indexOf(mn[ei]);
          if (Vr !== -1) {
            pi = pi.slice(0, Vr);
            break;
          }
        }
        wi.stack = "".concat(pi.join(`
`), `
`).concat(mn.join(`
`));
      }
      throw wi;
    }
  };
  function Hr(ui, Li, Qi, wi, Ji) {
    if (!Pe(Li))
      throw new b("regexp", "RegExp", Li);
    var mn = Ji === "match";
    if (typeof ui != "string" || or(Li, ui) !== mn) {
      if (Qi instanceof Error)
        throw Qi;
      var pi = !Qi;
      Qi = Qi || (typeof ui != "string" ? 'The "string" argument must be of type string. Received type ' + "".concat(n(ui), " (").concat(Ee(ui), ")") : (mn ? "The input did not match the regular expression " : "The input was expected to not match the regular expression ") + "".concat(Ee(Li), `. Input:

`).concat(Ee(ui), `
`));
      var ei = new pe({
        actual: ui,
        expected: Li,
        message: Qi,
        operator: Ji,
        stackStartFn: wi
      });
      throw ei.generatedMessage = pi, ei;
    }
  }
  Ce.match = function ui(Li, Qi, wi) {
    Hr(Li, Qi, wi, ui, "match");
  }, Ce.doesNotMatch = function ui(Li, Qi, wi) {
    Hr(Li, Qi, wi, ui, "doesNotMatch");
  };
  function si() {
    for (var ui = arguments.length, Li = new Array(ui), Qi = 0; Qi < ui; Qi++)
      Li[Qi] = arguments[Qi];
    er.apply(void 0, [si, Li.length].concat(Li));
  }
  return Ce.strict = nr(si, Ce, {
    equal: Ce.strictEqual,
    deepEqual: Ce.deepStrictEqual,
    notEqual: Ce.notStrictEqual,
    notDeepEqual: Ce.notDeepStrictEqual
  }), Ce.strict.strict = Ce.strict, assert$t.exports;
}
var fountainUtils = {}, xoshiro = {}, bignumber = { exports: {} };
(function(n) {
  (function(c) {
    var u, p = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, a = Math.ceil, A = Math.floor, b = "[BigNumber Error] ", F = b + "Number primitive has more than 15 significant digits: ", le = 1e14, L = 14, pe = 9007199254740991, $ = [1, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9, 1e10, 1e11, 1e12, 1e13], Ee = 1e7, be = 1e9;
    function He(kr) {
      var Ce, tr, Fe, Sr = ui.prototype = { constructor: ui, toString: null, valueOf: null }, er = new ui(1), Ie = 20, xe = 4, rr = -7, ar = 21, yr = -1e7, _r = 1e7, Or = !1, vr = 1, Te = 0, Cr = {
        prefix: "",
        groupSize: 3,
        secondaryGroupSize: 0,
        groupSeparator: ",",
        decimalSeparator: ".",
        fractionGroupSize: 0,
        fractionGroupSeparator: " ",
        // non-breaking space
        suffix: ""
      }, Hr = "0123456789abcdefghijklmnopqrstuvwxyz", si = !0;
      function ui(pi, ei) {
        var Vr, qr, Zi, Wr, ri, _i, Er, Di, _n = this;
        if (!(_n instanceof ui)) return new ui(pi, ei);
        if (ei == null) {
          if (pi && pi._isBigNumber === !0) {
            _n.s = pi.s, !pi.c || pi.e > _r ? _n.c = _n.e = null : pi.e < yr ? _n.c = [_n.e = 0] : (_n.e = pi.e, _n.c = pi.c.slice());
            return;
          }
          if ((_i = typeof pi == "number") && pi * 0 == 0) {
            if (_n.s = 1 / pi < 0 ? (pi = -pi, -1) : 1, pi === ~~pi) {
              for (Wr = 0, ri = pi; ri >= 10; ri /= 10, Wr++) ;
              Wr > _r ? _n.c = _n.e = null : (_n.e = Wr, _n.c = [pi]);
              return;
            }
            Di = String(pi);
          } else {
            if (!p.test(Di = String(pi))) return Fe(_n, Di, _i);
            _n.s = Di.charCodeAt(0) == 45 ? (Di = Di.slice(1), -1) : 1;
          }
          (Wr = Di.indexOf(".")) > -1 && (Di = Di.replace(".", "")), (ri = Di.search(/e/i)) > 0 ? (Wr < 0 && (Wr = ri), Wr += +Di.slice(ri + 1), Di = Di.substring(0, ri)) : Wr < 0 && (Wr = Di.length);
        } else {
          if (or(ei, 2, Hr.length, "Base"), ei == 10 && si)
            return _n = new ui(pi), Ji(_n, Ie + _n.e + 1, xe);
          if (Di = String(pi), _i = typeof pi == "number") {
            if (pi * 0 != 0) return Fe(_n, Di, _i, ei);
            if (_n.s = 1 / pi < 0 ? (Di = Di.slice(1), -1) : 1, ui.DEBUG && Di.replace(/^0\.0*|\./, "").length > 15)
              throw Error(F + pi);
          } else
            _n.s = Di.charCodeAt(0) === 45 ? (Di = Di.slice(1), -1) : 1;
          for (Vr = Hr.slice(0, ei), Wr = ri = 0, Er = Di.length; ri < Er; ri++)
            if (Vr.indexOf(qr = Di.charAt(ri)) < 0) {
              if (qr == ".") {
                if (ri > Wr) {
                  Wr = Er;
                  continue;
                }
              } else if (!Zi && (Di == Di.toUpperCase() && (Di = Di.toLowerCase()) || Di == Di.toLowerCase() && (Di = Di.toUpperCase()))) {
                Zi = !0, ri = -1, Wr = 0;
                continue;
              }
              return Fe(_n, String(pi), _i, ei);
            }
          _i = !1, Di = tr(Di, ei, 10, _n.s), (Wr = Di.indexOf(".")) > -1 ? Di = Di.replace(".", "") : Wr = Di.length;
        }
        for (ri = 0; Di.charCodeAt(ri) === 48; ri++) ;
        for (Er = Di.length; Di.charCodeAt(--Er) === 48; ) ;
        if (Di = Di.slice(ri, ++Er)) {
          if (Er -= ri, _i && ui.DEBUG && Er > 15 && (pi > pe || pi !== A(pi)))
            throw Error(F + _n.s * pi);
          if ((Wr = Wr - ri - 1) > _r)
            _n.c = _n.e = null;
          else if (Wr < yr)
            _n.c = [_n.e = 0];
          else {
            if (_n.e = Wr, _n.c = [], ri = (Wr + 1) % L, Wr < 0 && (ri += L), ri < Er) {
              for (ri && _n.c.push(+Di.slice(0, ri)), Er -= L; ri < Er; )
                _n.c.push(+Di.slice(ri, ri += L));
              ri = L - (Di = Di.slice(ri)).length;
            } else
              ri -= Er;
            for (; ri--; Di += "0") ;
            _n.c.push(+Di);
          }
        } else
          _n.c = [_n.e = 0];
      }
      ui.clone = He, ui.ROUND_UP = 0, ui.ROUND_DOWN = 1, ui.ROUND_CEIL = 2, ui.ROUND_FLOOR = 3, ui.ROUND_HALF_UP = 4, ui.ROUND_HALF_DOWN = 5, ui.ROUND_HALF_EVEN = 6, ui.ROUND_HALF_CEIL = 7, ui.ROUND_HALF_FLOOR = 8, ui.EUCLID = 9, ui.config = ui.set = function(pi) {
        var ei, Vr;
        if (pi != null)
          if (typeof pi == "object") {
            if (pi.hasOwnProperty(ei = "DECIMAL_PLACES") && (Vr = pi[ei], or(Vr, 0, be, ei), Ie = Vr), pi.hasOwnProperty(ei = "ROUNDING_MODE") && (Vr = pi[ei], or(Vr, 0, 8, ei), xe = Vr), pi.hasOwnProperty(ei = "EXPONENTIAL_AT") && (Vr = pi[ei], Vr && Vr.pop ? (or(Vr[0], -be, 0, ei), or(Vr[1], 0, be, ei), rr = Vr[0], ar = Vr[1]) : (or(Vr, -be, be, ei), rr = -(ar = Vr < 0 ? -Vr : Vr))), pi.hasOwnProperty(ei = "RANGE"))
              if (Vr = pi[ei], Vr && Vr.pop)
                or(Vr[0], -be, -1, ei), or(Vr[1], 1, be, ei), yr = Vr[0], _r = Vr[1];
              else if (or(Vr, -be, be, ei), Vr)
                yr = -(_r = Vr < 0 ? -Vr : Vr);
              else
                throw Error(b + ei + " cannot be zero: " + Vr);
            if (pi.hasOwnProperty(ei = "CRYPTO"))
              if (Vr = pi[ei], Vr === !!Vr)
                if (Vr)
                  if (typeof crypto < "u" && crypto && (crypto.getRandomValues || crypto.randomBytes))
                    Or = Vr;
                  else
                    throw Or = !Vr, Error(b + "crypto unavailable");
                else
                  Or = Vr;
              else
                throw Error(b + ei + " not true or false: " + Vr);
            if (pi.hasOwnProperty(ei = "MODULO_MODE") && (Vr = pi[ei], or(Vr, 0, 9, ei), vr = Vr), pi.hasOwnProperty(ei = "POW_PRECISION") && (Vr = pi[ei], or(Vr, 0, be, ei), Te = Vr), pi.hasOwnProperty(ei = "FORMAT"))
              if (Vr = pi[ei], typeof Vr == "object") Cr = Vr;
              else throw Error(b + ei + " not an object: " + Vr);
            if (pi.hasOwnProperty(ei = "ALPHABET"))
              if (Vr = pi[ei], typeof Vr == "string" && !/^.?$|[+\-.\s]|(.).*\1/.test(Vr))
                si = Vr.slice(0, 10) == "0123456789", Hr = Vr;
              else
                throw Error(b + ei + " invalid: " + Vr);
          } else
            throw Error(b + "Object expected: " + pi);
        return {
          DECIMAL_PLACES: Ie,
          ROUNDING_MODE: xe,
          EXPONENTIAL_AT: [rr, ar],
          RANGE: [yr, _r],
          CRYPTO: Or,
          MODULO_MODE: vr,
          POW_PRECISION: Te,
          FORMAT: Cr,
          ALPHABET: Hr
        };
      }, ui.isBigNumber = function(pi) {
        if (!pi || pi._isBigNumber !== !0) return !1;
        if (!ui.DEBUG) return !0;
        var ei, Vr, qr = pi.c, Zi = pi.e, Wr = pi.s;
        e: if ({}.toString.call(qr) == "[object Array]") {
          if ((Wr === 1 || Wr === -1) && Zi >= -be && Zi <= be && Zi === A(Zi)) {
            if (qr[0] === 0) {
              if (Zi === 0 && qr.length === 1) return !0;
              break e;
            }
            if (ei = (Zi + 1) % L, ei < 1 && (ei += L), String(qr[0]).length == ei) {
              for (ei = 0; ei < qr.length; ei++)
                if (Vr = qr[ei], Vr < 0 || Vr >= le || Vr !== A(Vr)) break e;
              if (Vr !== 0) return !0;
            }
          }
        } else if (qr === null && Zi === null && (Wr === null || Wr === 1 || Wr === -1))
          return !0;
        throw Error(b + "Invalid BigNumber: " + pi);
      }, ui.maximum = ui.max = function() {
        return Qi(arguments, -1);
      }, ui.minimum = ui.min = function() {
        return Qi(arguments, 1);
      }, ui.random = function() {
        var pi = 9007199254740992, ei = Math.random() * pi & 2097151 ? function() {
          return A(Math.random() * pi);
        } : function() {
          return (Math.random() * 1073741824 | 0) * 8388608 + (Math.random() * 8388608 | 0);
        };
        return function(Vr) {
          var qr, Zi, Wr, ri, _i, Er = 0, Di = [], _n = new ui(er);
          if (Vr == null ? Vr = Ie : or(Vr, 0, be), ri = a(Vr / L), Or)
            if (crypto.getRandomValues) {
              for (qr = crypto.getRandomValues(new Uint32Array(ri *= 2)); Er < ri; )
                _i = qr[Er] * 131072 + (qr[Er + 1] >>> 11), _i >= 9e15 ? (Zi = crypto.getRandomValues(new Uint32Array(2)), qr[Er] = Zi[0], qr[Er + 1] = Zi[1]) : (Di.push(_i % 1e14), Er += 2);
              Er = ri / 2;
            } else if (crypto.randomBytes) {
              for (qr = crypto.randomBytes(ri *= 7); Er < ri; )
                _i = (qr[Er] & 31) * 281474976710656 + qr[Er + 1] * 1099511627776 + qr[Er + 2] * 4294967296 + qr[Er + 3] * 16777216 + (qr[Er + 4] << 16) + (qr[Er + 5] << 8) + qr[Er + 6], _i >= 9e15 ? crypto.randomBytes(7).copy(qr, Er) : (Di.push(_i % 1e14), Er += 7);
              Er = ri / 7;
            } else
              throw Or = !1, Error(b + "crypto unavailable");
          if (!Or)
            for (; Er < ri; )
              _i = ei(), _i < 9e15 && (Di[Er++] = _i % 1e14);
          for (ri = Di[--Er], Vr %= L, ri && Vr && (_i = $[L - Vr], Di[Er] = A(ri / _i) * _i); Di[Er] === 0; Di.pop(), Er--) ;
          if (Er < 0)
            Di = [Wr = 0];
          else {
            for (Wr = -1; Di[0] === 0; Di.splice(0, 1), Wr -= L) ;
            for (Er = 1, _i = Di[0]; _i >= 10; _i /= 10, Er++) ;
            Er < L && (Wr -= L - Er);
          }
          return _n.e = Wr, _n.c = Di, _n;
        };
      }(), ui.sum = function() {
        for (var pi = 1, ei = arguments, Vr = new ui(ei[0]); pi < ei.length; ) Vr = Vr.plus(ei[pi++]);
        return Vr;
      }, tr = /* @__PURE__ */ function() {
        var pi = "0123456789";
        function ei(Vr, qr, Zi, Wr) {
          for (var ri, _i = [0], Er, Di = 0, _n = Vr.length; Di < _n; ) {
            for (Er = _i.length; Er--; _i[Er] *= qr) ;
            for (_i[0] += Wr.indexOf(Vr.charAt(Di++)), ri = 0; ri < _i.length; ri++)
              _i[ri] > Zi - 1 && (_i[ri + 1] == null && (_i[ri + 1] = 0), _i[ri + 1] += _i[ri] / Zi | 0, _i[ri] %= Zi);
          }
          return _i.reverse();
        }
        return function(Vr, qr, Zi, Wr, ri) {
          var _i, Er, Di, _n, On, so, Do, gn, Gn = Vr.indexOf("."), pn = Ie, hn = xe;
          for (Gn >= 0 && (_n = Te, Te = 0, Vr = Vr.replace(".", ""), gn = new ui(qr), so = gn.pow(Vr.length - Gn), Te = _n, gn.c = ei(
            xr(nr(so.c), so.e, "0"),
            10,
            Zi,
            pi
          ), gn.e = gn.c.length), Do = ei(Vr, qr, Zi, ri ? (_i = Hr, pi) : (_i = pi, Hr)), Di = _n = Do.length; Do[--_n] == 0; Do.pop()) ;
          if (!Do[0]) return _i.charAt(0);
          if (Gn < 0 ? --Di : (so.c = Do, so.e = Di, so.s = Wr, so = Ce(so, gn, pn, hn, Zi), Do = so.c, On = so.r, Di = so.e), Er = Di + pn + 1, Gn = Do[Er], _n = Zi / 2, On = On || Er < 0 || Do[Er + 1] != null, On = hn < 4 ? (Gn != null || On) && (hn == 0 || hn == (so.s < 0 ? 3 : 2)) : Gn > _n || Gn == _n && (hn == 4 || On || hn == 6 && Do[Er - 1] & 1 || hn == (so.s < 0 ? 8 : 7)), Er < 1 || !Do[0])
            Vr = On ? xr(_i.charAt(1), -pn, _i.charAt(0)) : _i.charAt(0);
          else {
            if (Do.length = Er, On)
              for (--Zi; ++Do[--Er] > Zi; )
                Do[Er] = 0, Er || (++Di, Do = [1].concat(Do));
            for (_n = Do.length; !Do[--_n]; ) ;
            for (Gn = 0, Vr = ""; Gn <= _n; Vr += _i.charAt(Do[Gn++])) ;
            Vr = xr(Vr, Di, _i.charAt(0));
          }
          return Vr;
        };
      }(), Ce = /* @__PURE__ */ function() {
        function pi(qr, Zi, Wr) {
          var ri, _i, Er, Di, _n = 0, On = qr.length, so = Zi % Ee, Do = Zi / Ee | 0;
          for (qr = qr.slice(); On--; )
            Er = qr[On] % Ee, Di = qr[On] / Ee | 0, ri = Do * Er + Di * so, _i = so * Er + ri % Ee * Ee + _n, _n = (_i / Wr | 0) + (ri / Ee | 0) + Do * Di, qr[On] = _i % Wr;
          return _n && (qr = [_n].concat(qr)), qr;
        }
        function ei(qr, Zi, Wr, ri) {
          var _i, Er;
          if (Wr != ri)
            Er = Wr > ri ? 1 : -1;
          else
            for (_i = Er = 0; _i < Wr; _i++)
              if (qr[_i] != Zi[_i]) {
                Er = qr[_i] > Zi[_i] ? 1 : -1;
                break;
              }
          return Er;
        }
        function Vr(qr, Zi, Wr, ri) {
          for (var _i = 0; Wr--; )
            qr[Wr] -= _i, _i = qr[Wr] < Zi[Wr] ? 1 : 0, qr[Wr] = _i * ri + qr[Wr] - Zi[Wr];
          for (; !qr[0] && qr.length > 1; qr.splice(0, 1)) ;
        }
        return function(qr, Zi, Wr, ri, _i) {
          var Er, Di, _n, On, so, Do, gn, Gn, pn, hn, Rn, vo, Hi, di, Ui, ln, Un, Bo = qr.s == Zi.s ? 1 : -1, co = qr.c, To = Zi.c;
          if (!co || !co[0] || !To || !To[0])
            return new ui(
              // Return NaN if either NaN, or both Infinity or 0.
              !qr.s || !Zi.s || (co ? To && co[0] == To[0] : !To) ? NaN : (
                // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
                co && co[0] == 0 || !To ? Bo * 0 : Bo / 0
              )
            );
          for (Gn = new ui(Bo), pn = Gn.c = [], Di = qr.e - Zi.e, Bo = Wr + Di + 1, _i || (_i = le, Di = Pe(qr.e / L) - Pe(Zi.e / L), Bo = Bo / L | 0), _n = 0; To[_n] == (co[_n] || 0); _n++) ;
          if (To[_n] > (co[_n] || 0) && Di--, Bo < 0)
            pn.push(1), On = !0;
          else {
            for (di = co.length, ln = To.length, _n = 0, Bo += 2, so = A(_i / (To[0] + 1)), so > 1 && (To = pi(To, so, _i), co = pi(co, so, _i), ln = To.length, di = co.length), Hi = ln, hn = co.slice(0, ln), Rn = hn.length; Rn < ln; hn[Rn++] = 0) ;
            Un = To.slice(), Un = [0].concat(Un), Ui = To[0], To[1] >= _i / 2 && Ui++;
            do {
              if (so = 0, Er = ei(To, hn, ln, Rn), Er < 0) {
                if (vo = hn[0], ln != Rn && (vo = vo * _i + (hn[1] || 0)), so = A(vo / Ui), so > 1)
                  for (so >= _i && (so = _i - 1), Do = pi(To, so, _i), gn = Do.length, Rn = hn.length; ei(Do, hn, gn, Rn) == 1; )
                    so--, Vr(Do, ln < gn ? Un : To, gn, _i), gn = Do.length, Er = 1;
                else
                  so == 0 && (Er = so = 1), Do = To.slice(), gn = Do.length;
                if (gn < Rn && (Do = [0].concat(Do)), Vr(hn, Do, Rn, _i), Rn = hn.length, Er == -1)
                  for (; ei(To, hn, ln, Rn) < 1; )
                    so++, Vr(hn, ln < Rn ? Un : To, Rn, _i), Rn = hn.length;
              } else Er === 0 && (so++, hn = [0]);
              pn[_n++] = so, hn[0] ? hn[Rn++] = co[Hi] || 0 : (hn = [co[Hi]], Rn = 1);
            } while ((Hi++ < di || hn[0] != null) && Bo--);
            On = hn[0] != null, pn[0] || pn.splice(0, 1);
          }
          if (_i == le) {
            for (_n = 1, Bo = pn[0]; Bo >= 10; Bo /= 10, _n++) ;
            Ji(Gn, Wr + (Gn.e = _n + Di * L - 1) + 1, ri, On);
          } else
            Gn.e = Di, Gn.r = +On;
          return Gn;
        };
      }();
      function Li(pi, ei, Vr, qr) {
        var Zi, Wr, ri, _i, Er;
        if (Vr == null ? Vr = xe : or(Vr, 0, 8), !pi.c) return pi.toString();
        if (Zi = pi.c[0], ri = pi.e, ei == null)
          Er = nr(pi.c), Er = qr == 1 || qr == 2 && (ri <= rr || ri >= ar) ? Ir(Er, ri) : xr(Er, ri, "0");
        else if (pi = Ji(new ui(pi), ei, Vr), Wr = pi.e, Er = nr(pi.c), _i = Er.length, qr == 1 || qr == 2 && (ei <= Wr || Wr <= rr)) {
          for (; _i < ei; Er += "0", _i++) ;
          Er = Ir(Er, Wr);
        } else if (ei -= ri, Er = xr(Er, Wr, "0"), Wr + 1 > _i) {
          if (--ei > 0) for (Er += "."; ei--; Er += "0") ;
        } else if (ei += Wr - _i, ei > 0)
          for (Wr + 1 == _i && (Er += "."); ei--; Er += "0") ;
        return pi.s < 0 && Zi ? "-" + Er : Er;
      }
      function Qi(pi, ei) {
        for (var Vr, qr, Zi = 1, Wr = new ui(pi[0]); Zi < pi.length; Zi++)
          qr = new ui(pi[Zi]), (!qr.s || (Vr = ir(Wr, qr)) === ei || Vr === 0 && Wr.s === ei) && (Wr = qr);
        return Wr;
      }
      function wi(pi, ei, Vr) {
        for (var qr = 1, Zi = ei.length; !ei[--Zi]; ei.pop()) ;
        for (Zi = ei[0]; Zi >= 10; Zi /= 10, qr++) ;
        return (Vr = qr + Vr * L - 1) > _r ? pi.c = pi.e = null : Vr < yr ? pi.c = [pi.e = 0] : (pi.e = Vr, pi.c = ei), pi;
      }
      Fe = /* @__PURE__ */ function() {
        var pi = /^(-?)0([xbo])(?=\w[\w.]*$)/i, ei = /^([^.]+)\.$/, Vr = /^\.([^.]+)$/, qr = /^-?(Infinity|NaN)$/, Zi = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
        return function(Wr, ri, _i, Er) {
          var Di, _n = _i ? ri : ri.replace(Zi, "");
          if (qr.test(_n))
            Wr.s = isNaN(_n) ? null : _n < 0 ? -1 : 1;
          else {
            if (!_i && (_n = _n.replace(pi, function(On, so, Do) {
              return Di = (Do = Do.toLowerCase()) == "x" ? 16 : Do == "b" ? 2 : 8, !Er || Er == Di ? so : On;
            }), Er && (Di = Er, _n = _n.replace(ei, "$1").replace(Vr, "0.$1")), ri != _n))
              return new ui(_n, Di);
            if (ui.DEBUG)
              throw Error(b + "Not a" + (Er ? " base " + Er : "") + " number: " + ri);
            Wr.s = null;
          }
          Wr.c = Wr.e = null;
        };
      }();
      function Ji(pi, ei, Vr, qr) {
        var Zi, Wr, ri, _i, Er, Di, _n, On = pi.c, so = $;
        if (On) {
          e: {
            for (Zi = 1, _i = On[0]; _i >= 10; _i /= 10, Zi++) ;
            if (Wr = ei - Zi, Wr < 0)
              Wr += L, ri = ei, Er = On[Di = 0], _n = A(Er / so[Zi - ri - 1] % 10);
            else if (Di = a((Wr + 1) / L), Di >= On.length)
              if (qr) {
                for (; On.length <= Di; On.push(0)) ;
                Er = _n = 0, Zi = 1, Wr %= L, ri = Wr - L + 1;
              } else
                break e;
            else {
              for (Er = _i = On[Di], Zi = 1; _i >= 10; _i /= 10, Zi++) ;
              Wr %= L, ri = Wr - L + Zi, _n = ri < 0 ? 0 : A(Er / so[Zi - ri - 1] % 10);
            }
            if (qr = qr || ei < 0 || // Are there any non-zero digits after the rounding digit?
            // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
            // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
            On[Di + 1] != null || (ri < 0 ? Er : Er % so[Zi - ri - 1]), qr = Vr < 4 ? (_n || qr) && (Vr == 0 || Vr == (pi.s < 0 ? 3 : 2)) : _n > 5 || _n == 5 && (Vr == 4 || qr || Vr == 6 && // Check whether the digit to the left of the rounding digit is odd.
            (Wr > 0 ? ri > 0 ? Er / so[Zi - ri] : 0 : On[Di - 1]) % 10 & 1 || Vr == (pi.s < 0 ? 8 : 7)), ei < 1 || !On[0])
              return On.length = 0, qr ? (ei -= pi.e + 1, On[0] = so[(L - ei % L) % L], pi.e = -ei || 0) : On[0] = pi.e = 0, pi;
            if (Wr == 0 ? (On.length = Di, _i = 1, Di--) : (On.length = Di + 1, _i = so[L - Wr], On[Di] = ri > 0 ? A(Er / so[Zi - ri] % so[ri]) * _i : 0), qr)
              for (; ; )
                if (Di == 0) {
                  for (Wr = 1, ri = On[0]; ri >= 10; ri /= 10, Wr++) ;
                  for (ri = On[0] += _i, _i = 1; ri >= 10; ri /= 10, _i++) ;
                  Wr != _i && (pi.e++, On[0] == le && (On[0] = 1));
                  break;
                } else {
                  if (On[Di] += _i, On[Di] != le) break;
                  On[Di--] = 0, _i = 1;
                }
            for (Wr = On.length; On[--Wr] === 0; On.pop()) ;
          }
          pi.e > _r ? pi.c = pi.e = null : pi.e < yr && (pi.c = [pi.e = 0]);
        }
        return pi;
      }
      function mn(pi) {
        var ei, Vr = pi.e;
        return Vr === null ? pi.toString() : (ei = nr(pi.c), ei = Vr <= rr || Vr >= ar ? Ir(ei, Vr) : xr(ei, Vr, "0"), pi.s < 0 ? "-" + ei : ei);
      }
      return Sr.absoluteValue = Sr.abs = function() {
        var pi = new ui(this);
        return pi.s < 0 && (pi.s = 1), pi;
      }, Sr.comparedTo = function(pi, ei) {
        return ir(this, new ui(pi, ei));
      }, Sr.decimalPlaces = Sr.dp = function(pi, ei) {
        var Vr, qr, Zi, Wr = this;
        if (pi != null)
          return or(pi, 0, be), ei == null ? ei = xe : or(ei, 0, 8), Ji(new ui(Wr), pi + Wr.e + 1, ei);
        if (!(Vr = Wr.c)) return null;
        if (qr = ((Zi = Vr.length - 1) - Pe(this.e / L)) * L, Zi = Vr[Zi]) for (; Zi % 10 == 0; Zi /= 10, qr--) ;
        return qr < 0 && (qr = 0), qr;
      }, Sr.dividedBy = Sr.div = function(pi, ei) {
        return Ce(this, new ui(pi, ei), Ie, xe);
      }, Sr.dividedToIntegerBy = Sr.idiv = function(pi, ei) {
        return Ce(this, new ui(pi, ei), 0, 1);
      }, Sr.exponentiatedBy = Sr.pow = function(pi, ei) {
        var Vr, qr, Zi, Wr, ri, _i, Er, Di, _n, On = this;
        if (pi = new ui(pi), pi.c && !pi.isInteger())
          throw Error(b + "Exponent not an integer: " + mn(pi));
        if (ei != null && (ei = new ui(ei)), _i = pi.e > 14, !On.c || !On.c[0] || On.c[0] == 1 && !On.e && On.c.length == 1 || !pi.c || !pi.c[0])
          return _n = new ui(Math.pow(+mn(On), _i ? pi.s * (2 - lr(pi)) : +mn(pi))), ei ? _n.mod(ei) : _n;
        if (Er = pi.s < 0, ei) {
          if (ei.c ? !ei.c[0] : !ei.s) return new ui(NaN);
          qr = !Er && On.isInteger() && ei.isInteger(), qr && (On = On.mod(ei));
        } else {
          if (pi.e > 9 && (On.e > 0 || On.e < -1 || (On.e == 0 ? On.c[0] > 1 || _i && On.c[1] >= 24e7 : On.c[0] < 8e13 || _i && On.c[0] <= 9999975e7)))
            return Wr = On.s < 0 && lr(pi) ? -0 : 0, On.e > -1 && (Wr = 1 / Wr), new ui(Er ? 1 / Wr : Wr);
          Te && (Wr = a(Te / L + 2));
        }
        for (_i ? (Vr = new ui(0.5), Er && (pi.s = 1), Di = lr(pi)) : (Zi = Math.abs(+mn(pi)), Di = Zi % 2), _n = new ui(er); ; ) {
          if (Di) {
            if (_n = _n.times(On), !_n.c) break;
            Wr ? _n.c.length > Wr && (_n.c.length = Wr) : qr && (_n = _n.mod(ei));
          }
          if (Zi) {
            if (Zi = A(Zi / 2), Zi === 0) break;
            Di = Zi % 2;
          } else if (pi = pi.times(Vr), Ji(pi, pi.e + 1, 1), pi.e > 14)
            Di = lr(pi);
          else {
            if (Zi = +mn(pi), Zi === 0) break;
            Di = Zi % 2;
          }
          On = On.times(On), Wr ? On.c && On.c.length > Wr && (On.c.length = Wr) : qr && (On = On.mod(ei));
        }
        return qr ? _n : (Er && (_n = er.div(_n)), ei ? _n.mod(ei) : Wr ? Ji(_n, Te, xe, ri) : _n);
      }, Sr.integerValue = function(pi) {
        var ei = new ui(this);
        return pi == null ? pi = xe : or(pi, 0, 8), Ji(ei, ei.e + 1, pi);
      }, Sr.isEqualTo = Sr.eq = function(pi, ei) {
        return ir(this, new ui(pi, ei)) === 0;
      }, Sr.isFinite = function() {
        return !!this.c;
      }, Sr.isGreaterThan = Sr.gt = function(pi, ei) {
        return ir(this, new ui(pi, ei)) > 0;
      }, Sr.isGreaterThanOrEqualTo = Sr.gte = function(pi, ei) {
        return (ei = ir(this, new ui(pi, ei))) === 1 || ei === 0;
      }, Sr.isInteger = function() {
        return !!this.c && Pe(this.e / L) > this.c.length - 2;
      }, Sr.isLessThan = Sr.lt = function(pi, ei) {
        return ir(this, new ui(pi, ei)) < 0;
      }, Sr.isLessThanOrEqualTo = Sr.lte = function(pi, ei) {
        return (ei = ir(this, new ui(pi, ei))) === -1 || ei === 0;
      }, Sr.isNaN = function() {
        return !this.s;
      }, Sr.isNegative = function() {
        return this.s < 0;
      }, Sr.isPositive = function() {
        return this.s > 0;
      }, Sr.isZero = function() {
        return !!this.c && this.c[0] == 0;
      }, Sr.minus = function(pi, ei) {
        var Vr, qr, Zi, Wr, ri = this, _i = ri.s;
        if (pi = new ui(pi, ei), ei = pi.s, !_i || !ei) return new ui(NaN);
        if (_i != ei)
          return pi.s = -ei, ri.plus(pi);
        var Er = ri.e / L, Di = pi.e / L, _n = ri.c, On = pi.c;
        if (!Er || !Di) {
          if (!_n || !On) return _n ? (pi.s = -ei, pi) : new ui(On ? ri : NaN);
          if (!_n[0] || !On[0])
            return On[0] ? (pi.s = -ei, pi) : new ui(_n[0] ? ri : (
              // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
              xe == 3 ? -0 : 0
            ));
        }
        if (Er = Pe(Er), Di = Pe(Di), _n = _n.slice(), _i = Er - Di) {
          for ((Wr = _i < 0) ? (_i = -_i, Zi = _n) : (Di = Er, Zi = On), Zi.reverse(), ei = _i; ei--; Zi.push(0)) ;
          Zi.reverse();
        } else
          for (qr = (Wr = (_i = _n.length) < (ei = On.length)) ? _i : ei, _i = ei = 0; ei < qr; ei++)
            if (_n[ei] != On[ei]) {
              Wr = _n[ei] < On[ei];
              break;
            }
        if (Wr && (Zi = _n, _n = On, On = Zi, pi.s = -pi.s), ei = (qr = On.length) - (Vr = _n.length), ei > 0) for (; ei--; _n[Vr++] = 0) ;
        for (ei = le - 1; qr > _i; ) {
          if (_n[--qr] < On[qr]) {
            for (Vr = qr; Vr && !_n[--Vr]; _n[Vr] = ei) ;
            --_n[Vr], _n[qr] += le;
          }
          _n[qr] -= On[qr];
        }
        for (; _n[0] == 0; _n.splice(0, 1), --Di) ;
        return _n[0] ? wi(pi, _n, Di) : (pi.s = xe == 3 ? -1 : 1, pi.c = [pi.e = 0], pi);
      }, Sr.modulo = Sr.mod = function(pi, ei) {
        var Vr, qr, Zi = this;
        return pi = new ui(pi, ei), !Zi.c || !pi.s || pi.c && !pi.c[0] ? new ui(NaN) : !pi.c || Zi.c && !Zi.c[0] ? new ui(Zi) : (vr == 9 ? (qr = pi.s, pi.s = 1, Vr = Ce(Zi, pi, 0, 3), pi.s = qr, Vr.s *= qr) : Vr = Ce(Zi, pi, 0, vr), pi = Zi.minus(Vr.times(pi)), !pi.c[0] && vr == 1 && (pi.s = Zi.s), pi);
      }, Sr.multipliedBy = Sr.times = function(pi, ei) {
        var Vr, qr, Zi, Wr, ri, _i, Er, Di, _n, On, so, Do, gn, Gn, pn, hn = this, Rn = hn.c, vo = (pi = new ui(pi, ei)).c;
        if (!Rn || !vo || !Rn[0] || !vo[0])
          return !hn.s || !pi.s || Rn && !Rn[0] && !vo || vo && !vo[0] && !Rn ? pi.c = pi.e = pi.s = null : (pi.s *= hn.s, !Rn || !vo ? pi.c = pi.e = null : (pi.c = [0], pi.e = 0)), pi;
        for (qr = Pe(hn.e / L) + Pe(pi.e / L), pi.s *= hn.s, Er = Rn.length, On = vo.length, Er < On && (gn = Rn, Rn = vo, vo = gn, Zi = Er, Er = On, On = Zi), Zi = Er + On, gn = []; Zi--; gn.push(0)) ;
        for (Gn = le, pn = Ee, Zi = On; --Zi >= 0; ) {
          for (Vr = 0, so = vo[Zi] % pn, Do = vo[Zi] / pn | 0, ri = Er, Wr = Zi + ri; Wr > Zi; )
            Di = Rn[--ri] % pn, _n = Rn[ri] / pn | 0, _i = Do * Di + _n * so, Di = so * Di + _i % pn * pn + gn[Wr] + Vr, Vr = (Di / Gn | 0) + (_i / pn | 0) + Do * _n, gn[Wr--] = Di % Gn;
          gn[Wr] = Vr;
        }
        return Vr ? ++qr : gn.splice(0, 1), wi(pi, gn, qr);
      }, Sr.negated = function() {
        var pi = new ui(this);
        return pi.s = -pi.s || null, pi;
      }, Sr.plus = function(pi, ei) {
        var Vr, qr = this, Zi = qr.s;
        if (pi = new ui(pi, ei), ei = pi.s, !Zi || !ei) return new ui(NaN);
        if (Zi != ei)
          return pi.s = -ei, qr.minus(pi);
        var Wr = qr.e / L, ri = pi.e / L, _i = qr.c, Er = pi.c;
        if (!Wr || !ri) {
          if (!_i || !Er) return new ui(Zi / 0);
          if (!_i[0] || !Er[0]) return Er[0] ? pi : new ui(_i[0] ? qr : Zi * 0);
        }
        if (Wr = Pe(Wr), ri = Pe(ri), _i = _i.slice(), Zi = Wr - ri) {
          for (Zi > 0 ? (ri = Wr, Vr = Er) : (Zi = -Zi, Vr = _i), Vr.reverse(); Zi--; Vr.push(0)) ;
          Vr.reverse();
        }
        for (Zi = _i.length, ei = Er.length, Zi - ei < 0 && (Vr = Er, Er = _i, _i = Vr, ei = Zi), Zi = 0; ei; )
          Zi = (_i[--ei] = _i[ei] + Er[ei] + Zi) / le | 0, _i[ei] = le === _i[ei] ? 0 : _i[ei] % le;
        return Zi && (_i = [Zi].concat(_i), ++ri), wi(pi, _i, ri);
      }, Sr.precision = Sr.sd = function(pi, ei) {
        var Vr, qr, Zi, Wr = this;
        if (pi != null && pi !== !!pi)
          return or(pi, 1, be), ei == null ? ei = xe : or(ei, 0, 8), Ji(new ui(Wr), pi, ei);
        if (!(Vr = Wr.c)) return null;
        if (Zi = Vr.length - 1, qr = Zi * L + 1, Zi = Vr[Zi]) {
          for (; Zi % 10 == 0; Zi /= 10, qr--) ;
          for (Zi = Vr[0]; Zi >= 10; Zi /= 10, qr++) ;
        }
        return pi && Wr.e + 1 > qr && (qr = Wr.e + 1), qr;
      }, Sr.shiftedBy = function(pi) {
        return or(pi, -pe, pe), this.times("1e" + pi);
      }, Sr.squareRoot = Sr.sqrt = function() {
        var pi, ei, Vr, qr, Zi, Wr = this, ri = Wr.c, _i = Wr.s, Er = Wr.e, Di = Ie + 4, _n = new ui("0.5");
        if (_i !== 1 || !ri || !ri[0])
          return new ui(!_i || _i < 0 && (!ri || ri[0]) ? NaN : ri ? Wr : 1 / 0);
        if (_i = Math.sqrt(+mn(Wr)), _i == 0 || _i == 1 / 0 ? (ei = nr(ri), (ei.length + Er) % 2 == 0 && (ei += "0"), _i = Math.sqrt(+ei), Er = Pe((Er + 1) / 2) - (Er < 0 || Er % 2), _i == 1 / 0 ? ei = "5e" + Er : (ei = _i.toExponential(), ei = ei.slice(0, ei.indexOf("e") + 1) + Er), Vr = new ui(ei)) : Vr = new ui(_i + ""), Vr.c[0]) {
          for (Er = Vr.e, _i = Er + Di, _i < 3 && (_i = 0); ; )
            if (Zi = Vr, Vr = _n.times(Zi.plus(Ce(Wr, Zi, Di, 1))), nr(Zi.c).slice(0, _i) === (ei = nr(Vr.c)).slice(0, _i))
              if (Vr.e < Er && --_i, ei = ei.slice(_i - 3, _i + 1), ei == "9999" || !qr && ei == "4999") {
                if (!qr && (Ji(Zi, Zi.e + Ie + 2, 0), Zi.times(Zi).eq(Wr))) {
                  Vr = Zi;
                  break;
                }
                Di += 4, _i += 4, qr = 1;
              } else {
                (!+ei || !+ei.slice(1) && ei.charAt(0) == "5") && (Ji(Vr, Vr.e + Ie + 2, 1), pi = !Vr.times(Vr).eq(Wr));
                break;
              }
        }
        return Ji(Vr, Vr.e + Ie + 1, xe, pi);
      }, Sr.toExponential = function(pi, ei) {
        return pi != null && (or(pi, 0, be), pi++), Li(this, pi, ei, 1);
      }, Sr.toFixed = function(pi, ei) {
        return pi != null && (or(pi, 0, be), pi = pi + this.e + 1), Li(this, pi, ei);
      }, Sr.toFormat = function(pi, ei, Vr) {
        var qr, Zi = this;
        if (Vr == null)
          pi != null && ei && typeof ei == "object" ? (Vr = ei, ei = null) : pi && typeof pi == "object" ? (Vr = pi, pi = ei = null) : Vr = Cr;
        else if (typeof Vr != "object")
          throw Error(b + "Argument not an object: " + Vr);
        if (qr = Zi.toFixed(pi, ei), Zi.c) {
          var Wr, ri = qr.split("."), _i = +Vr.groupSize, Er = +Vr.secondaryGroupSize, Di = Vr.groupSeparator || "", _n = ri[0], On = ri[1], so = Zi.s < 0, Do = so ? _n.slice(1) : _n, gn = Do.length;
          if (Er && (Wr = _i, _i = Er, Er = Wr, gn -= Wr), _i > 0 && gn > 0) {
            for (Wr = gn % _i || _i, _n = Do.substr(0, Wr); Wr < gn; Wr += _i) _n += Di + Do.substr(Wr, _i);
            Er > 0 && (_n += Di + Do.slice(Wr)), so && (_n = "-" + _n);
          }
          qr = On ? _n + (Vr.decimalSeparator || "") + ((Er = +Vr.fractionGroupSize) ? On.replace(
            new RegExp("\\d{" + Er + "}\\B", "g"),
            "$&" + (Vr.fractionGroupSeparator || "")
          ) : On) : _n;
        }
        return (Vr.prefix || "") + qr + (Vr.suffix || "");
      }, Sr.toFraction = function(pi) {
        var ei, Vr, qr, Zi, Wr, ri, _i, Er, Di, _n, On, so, Do = this, gn = Do.c;
        if (pi != null && (_i = new ui(pi), !_i.isInteger() && (_i.c || _i.s !== 1) || _i.lt(er)))
          throw Error(b + "Argument " + (_i.isInteger() ? "out of range: " : "not an integer: ") + mn(_i));
        if (!gn) return new ui(Do);
        for (ei = new ui(er), Di = Vr = new ui(er), qr = Er = new ui(er), so = nr(gn), Wr = ei.e = so.length - Do.e - 1, ei.c[0] = $[(ri = Wr % L) < 0 ? L + ri : ri], pi = !pi || _i.comparedTo(ei) > 0 ? Wr > 0 ? ei : Di : _i, ri = _r, _r = 1 / 0, _i = new ui(so), Er.c[0] = 0; _n = Ce(_i, ei, 0, 1), Zi = Vr.plus(_n.times(qr)), Zi.comparedTo(pi) != 1; )
          Vr = qr, qr = Zi, Di = Er.plus(_n.times(Zi = Di)), Er = Zi, ei = _i.minus(_n.times(Zi = ei)), _i = Zi;
        return Zi = Ce(pi.minus(Vr), qr, 0, 1), Er = Er.plus(Zi.times(Di)), Vr = Vr.plus(Zi.times(qr)), Er.s = Di.s = Do.s, Wr = Wr * 2, On = Ce(Di, qr, Wr, xe).minus(Do).abs().comparedTo(
          Ce(Er, Vr, Wr, xe).minus(Do).abs()
        ) < 1 ? [Di, qr] : [Er, Vr], _r = ri, On;
      }, Sr.toNumber = function() {
        return +mn(this);
      }, Sr.toPrecision = function(pi, ei) {
        return pi != null && or(pi, 1, be), Li(this, pi, ei, 2);
      }, Sr.toString = function(pi) {
        var ei, Vr = this, qr = Vr.s, Zi = Vr.e;
        return Zi === null ? qr ? (ei = "Infinity", qr < 0 && (ei = "-" + ei)) : ei = "NaN" : (pi == null ? ei = Zi <= rr || Zi >= ar ? Ir(nr(Vr.c), Zi) : xr(nr(Vr.c), Zi, "0") : pi === 10 && si ? (Vr = Ji(new ui(Vr), Ie + Zi + 1, xe), ei = xr(nr(Vr.c), Vr.e, "0")) : (or(pi, 2, Hr.length, "Base"), ei = tr(xr(nr(Vr.c), Zi, "0"), 10, pi, qr, !0)), qr < 0 && Vr.c[0] && (ei = "-" + ei)), ei;
      }, Sr.valueOf = Sr.toJSON = function() {
        return mn(this);
      }, Sr._isBigNumber = !0, kr != null && ui.set(kr), ui;
    }
    function Pe(kr) {
      var Ce = kr | 0;
      return kr > 0 || kr === Ce ? Ce : Ce - 1;
    }
    function nr(kr) {
      for (var Ce, tr, Fe = 1, Sr = kr.length, er = kr[0] + ""; Fe < Sr; ) {
        for (Ce = kr[Fe++] + "", tr = L - Ce.length; tr--; Ce = "0" + Ce) ;
        er += Ce;
      }
      for (Sr = er.length; er.charCodeAt(--Sr) === 48; ) ;
      return er.slice(0, Sr + 1 || 1);
    }
    function ir(kr, Ce) {
      var tr, Fe, Sr = kr.c, er = Ce.c, Ie = kr.s, xe = Ce.s, rr = kr.e, ar = Ce.e;
      if (!Ie || !xe) return null;
      if (tr = Sr && !Sr[0], Fe = er && !er[0], tr || Fe) return tr ? Fe ? 0 : -xe : Ie;
      if (Ie != xe) return Ie;
      if (tr = Ie < 0, Fe = rr == ar, !Sr || !er) return Fe ? 0 : !Sr ^ tr ? 1 : -1;
      if (!Fe) return rr > ar ^ tr ? 1 : -1;
      for (xe = (rr = Sr.length) < (ar = er.length) ? rr : ar, Ie = 0; Ie < xe; Ie++) if (Sr[Ie] != er[Ie]) return Sr[Ie] > er[Ie] ^ tr ? 1 : -1;
      return rr == ar ? 0 : rr > ar ^ tr ? 1 : -1;
    }
    function or(kr, Ce, tr, Fe) {
      if (kr < Ce || kr > tr || kr !== A(kr))
        throw Error(b + (Fe || "Argument") + (typeof kr == "number" ? kr < Ce || kr > tr ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(kr));
    }
    function lr(kr) {
      var Ce = kr.c.length - 1;
      return Pe(kr.e / L) == Ce && kr.c[Ce] % 2 != 0;
    }
    function Ir(kr, Ce) {
      return (kr.length > 1 ? kr.charAt(0) + "." + kr.slice(1) : kr) + (Ce < 0 ? "e" : "e+") + Ce;
    }
    function xr(kr, Ce, tr) {
      var Fe, Sr;
      if (Ce < 0) {
        for (Sr = tr + "."; ++Ce; Sr += tr) ;
        kr = Sr + kr;
      } else if (Fe = kr.length, ++Ce > Fe) {
        for (Sr = tr, Ce -= Fe; --Ce; Sr += tr) ;
        kr += Sr;
      } else Ce < Fe && (kr = kr.slice(0, Ce) + "." + kr.slice(Ce));
      return kr;
    }
    u = He(), u.default = u.BigNumber = u, n.exports ? n.exports = u : (c || (c = typeof self < "u" && self ? self : window), c.BigNumber = u);
  })(commonjsGlobal);
})(bignumber);
var bignumberExports = bignumber.exports, jsbiUmd = { exports: {} };
(function(n, c) {
  (function(u, p) {
    n.exports = p();
  })(commonjsGlobal, function() {
    var u = Math.imul, p = Math.clz32, a = Math.abs, A = Math.max, b = Math.floor;
    class F extends Array {
      constructor(L, pe) {
        if (super(L), this.sign = pe, L > F.__kMaxLength) throw new RangeError("Maximum BigInt size exceeded");
      }
      static BigInt(L) {
        var pe = Number.isFinite;
        if (typeof L == "number") {
          if (L === 0) return F.__zero();
          if (F.__isOneDigitInt(L)) return 0 > L ? F.__oneDigit(-L, !0) : F.__oneDigit(L, !1);
          if (!pe(L) || b(L) !== L) throw new RangeError("The number " + L + " cannot be converted to BigInt because it is not an integer");
          return F.__fromDouble(L);
        }
        if (typeof L == "string") {
          const $ = F.__fromString(L);
          if ($ === null) throw new SyntaxError("Cannot convert " + L + " to a BigInt");
          return $;
        }
        if (typeof L == "boolean") return L === !0 ? F.__oneDigit(1, !1) : F.__zero();
        if (typeof L == "object") {
          if (L.constructor === F) return L;
          const $ = F.__toPrimitive(L);
          return F.BigInt($);
        }
        throw new TypeError("Cannot convert " + L + " to a BigInt");
      }
      toDebugString() {
        const L = ["BigInt["];
        for (const pe of this) L.push((pe && (pe >>> 0).toString(16)) + ", ");
        return L.push("]"), L.join("");
      }
      toString(L = 10) {
        if (2 > L || 36 < L) throw new RangeError("toString() radix argument must be between 2 and 36");
        return this.length === 0 ? "0" : L & L - 1 ? F.__toStringGeneric(this, L, !1) : F.__toStringBasePowerOfTwo(this, L);
      }
      static toNumber(L) {
        const pe = L.length;
        if (pe === 0) return 0;
        if (pe === 1) {
          const tr = L.__unsignedDigit(0);
          return L.sign ? -tr : tr;
        }
        const $ = L.__digit(pe - 1), Ee = F.__clz30($), be = 30 * pe - Ee;
        if (1024 < be) return L.sign ? -1 / 0 : 1 / 0;
        let He = be - 1, Pe = $, nr = pe - 1;
        const ir = Ee + 3;
        let or = ir === 32 ? 0 : Pe << ir;
        or >>>= 12;
        const lr = ir - 12;
        let Ir = 12 <= ir ? 0 : Pe << 20 + ir, xr = 20 + ir;
        for (0 < lr && 0 < nr && (nr--, Pe = L.__digit(nr), or |= Pe >>> 30 - lr, Ir = Pe << lr + 2, xr = lr + 2); 0 < xr && 0 < nr; ) nr--, Pe = L.__digit(nr), Ir |= 30 <= xr ? Pe << xr - 30 : Pe >>> 30 - xr, xr -= 30;
        const kr = F.__decideRounding(L, xr, nr, Pe);
        if ((kr === 1 || kr === 0 && (1 & Ir) == 1) && (Ir = Ir + 1 >>> 0, Ir === 0 && (or++, or >>> 20 != 0 && (or = 0, He++, 1023 < He)))) return L.sign ? -1 / 0 : 1 / 0;
        const Ce = L.sign ? -2147483648 : 0;
        return He = He + 1023 << 20, F.__kBitConversionInts[1] = Ce | He | or, F.__kBitConversionInts[0] = Ir, F.__kBitConversionDouble[0];
      }
      static unaryMinus(L) {
        if (L.length === 0) return L;
        const pe = L.__copy();
        return pe.sign = !L.sign, pe;
      }
      static bitwiseNot(L) {
        return L.sign ? F.__absoluteSubOne(L).__trim() : F.__absoluteAddOne(L, !0);
      }
      static exponentiate(L, pe) {
        if (pe.sign) throw new RangeError("Exponent must be positive");
        if (pe.length === 0) return F.__oneDigit(1, !1);
        if (L.length === 0) return L;
        if (L.length === 1 && L.__digit(0) === 1) return L.sign && !(1 & pe.__digit(0)) ? F.unaryMinus(L) : L;
        if (1 < pe.length) throw new RangeError("BigInt too big");
        let $ = pe.__unsignedDigit(0);
        if ($ === 1) return L;
        if ($ >= F.__kMaxLengthBits) throw new RangeError("BigInt too big");
        if (L.length === 1 && L.__digit(0) === 2) {
          const He = 1 + (0 | $ / 30), Pe = L.sign && (1 & $) != 0, nr = new F(He, Pe);
          nr.__initializeDigits();
          const ir = 1 << $ % 30;
          return nr.__setDigit(He - 1, ir), nr;
        }
        let Ee = null, be = L;
        for (1 & $ && (Ee = L), $ >>= 1; $ !== 0; $ >>= 1) be = F.multiply(be, be), 1 & $ && (Ee === null ? Ee = be : Ee = F.multiply(Ee, be));
        return Ee;
      }
      static multiply(L, pe) {
        if (L.length === 0) return L;
        if (pe.length === 0) return pe;
        let $ = L.length + pe.length;
        30 <= L.__clzmsd() + pe.__clzmsd() && $--;
        const Ee = new F($, L.sign !== pe.sign);
        Ee.__initializeDigits();
        for (let be = 0; be < L.length; be++) F.__multiplyAccumulate(pe, L.__digit(be), Ee, be);
        return Ee.__trim();
      }
      static divide(L, pe) {
        if (pe.length === 0) throw new RangeError("Division by zero");
        if (0 > F.__absoluteCompare(L, pe)) return F.__zero();
        const $ = L.sign !== pe.sign, Ee = pe.__unsignedDigit(0);
        let be;
        if (pe.length === 1 && 32767 >= Ee) {
          if (Ee === 1) return $ === L.sign ? L : F.unaryMinus(L);
          be = F.__absoluteDivSmall(L, Ee, null);
        } else be = F.__absoluteDivLarge(L, pe, !0, !1);
        return be.sign = $, be.__trim();
      }
      static remainder(L, pe) {
        if (pe.length === 0) throw new RangeError("Division by zero");
        if (0 > F.__absoluteCompare(L, pe)) return L;
        const $ = pe.__unsignedDigit(0);
        if (pe.length === 1 && 32767 >= $) {
          if ($ === 1) return F.__zero();
          const be = F.__absoluteModSmall(L, $);
          return be === 0 ? F.__zero() : F.__oneDigit(be, L.sign);
        }
        const Ee = F.__absoluteDivLarge(L, pe, !1, !0);
        return Ee.sign = L.sign, Ee.__trim();
      }
      static add(L, pe) {
        const $ = L.sign;
        return $ === pe.sign ? F.__absoluteAdd(L, pe, $) : 0 <= F.__absoluteCompare(L, pe) ? F.__absoluteSub(L, pe, $) : F.__absoluteSub(pe, L, !$);
      }
      static subtract(L, pe) {
        const $ = L.sign;
        return $ === pe.sign ? 0 <= F.__absoluteCompare(L, pe) ? F.__absoluteSub(L, pe, $) : F.__absoluteSub(pe, L, !$) : F.__absoluteAdd(L, pe, $);
      }
      static leftShift(L, pe) {
        return pe.length === 0 || L.length === 0 ? L : pe.sign ? F.__rightShiftByAbsolute(L, pe) : F.__leftShiftByAbsolute(L, pe);
      }
      static signedRightShift(L, pe) {
        return pe.length === 0 || L.length === 0 ? L : pe.sign ? F.__leftShiftByAbsolute(L, pe) : F.__rightShiftByAbsolute(L, pe);
      }
      static unsignedRightShift() {
        throw new TypeError("BigInts have no unsigned right shift; use >> instead");
      }
      static lessThan(L, pe) {
        return 0 > F.__compareToBigInt(L, pe);
      }
      static lessThanOrEqual(L, pe) {
        return 0 >= F.__compareToBigInt(L, pe);
      }
      static greaterThan(L, pe) {
        return 0 < F.__compareToBigInt(L, pe);
      }
      static greaterThanOrEqual(L, pe) {
        return 0 <= F.__compareToBigInt(L, pe);
      }
      static equal(L, pe) {
        if (L.sign !== pe.sign || L.length !== pe.length) return !1;
        for (let $ = 0; $ < L.length; $++) if (L.__digit($) !== pe.__digit($)) return !1;
        return !0;
      }
      static notEqual(L, pe) {
        return !F.equal(L, pe);
      }
      static bitwiseAnd(L, pe) {
        if (!L.sign && !pe.sign) return F.__absoluteAnd(L, pe).__trim();
        if (L.sign && pe.sign) {
          const $ = A(L.length, pe.length) + 1;
          let Ee = F.__absoluteSubOne(L, $);
          const be = F.__absoluteSubOne(pe);
          return Ee = F.__absoluteOr(Ee, be, Ee), F.__absoluteAddOne(Ee, !0, Ee).__trim();
        }
        return L.sign && ([L, pe] = [pe, L]), F.__absoluteAndNot(L, F.__absoluteSubOne(pe)).__trim();
      }
      static bitwiseXor(L, pe) {
        if (!L.sign && !pe.sign) return F.__absoluteXor(L, pe).__trim();
        if (L.sign && pe.sign) {
          const be = A(L.length, pe.length), He = F.__absoluteSubOne(L, be), Pe = F.__absoluteSubOne(pe);
          return F.__absoluteXor(He, Pe, He).__trim();
        }
        const $ = A(L.length, pe.length) + 1;
        L.sign && ([L, pe] = [pe, L]);
        let Ee = F.__absoluteSubOne(pe, $);
        return Ee = F.__absoluteXor(Ee, L, Ee), F.__absoluteAddOne(Ee, !0, Ee).__trim();
      }
      static bitwiseOr(L, pe) {
        const $ = A(L.length, pe.length);
        if (!L.sign && !pe.sign) return F.__absoluteOr(L, pe).__trim();
        if (L.sign && pe.sign) {
          let be = F.__absoluteSubOne(L, $);
          const He = F.__absoluteSubOne(pe);
          return be = F.__absoluteAnd(be, He, be), F.__absoluteAddOne(be, !0, be).__trim();
        }
        L.sign && ([L, pe] = [pe, L]);
        let Ee = F.__absoluteSubOne(pe, $);
        return Ee = F.__absoluteAndNot(Ee, L, Ee), F.__absoluteAddOne(Ee, !0, Ee).__trim();
      }
      static asIntN(L, pe) {
        if (pe.length === 0) return pe;
        if (L = b(L), 0 > L) throw new RangeError("Invalid value: not (convertible to) a safe integer");
        if (L === 0) return F.__zero();
        if (L >= F.__kMaxLengthBits) return pe;
        const $ = 0 | (L + 29) / 30;
        if (pe.length < $) return pe;
        const Ee = pe.__unsignedDigit($ - 1), be = 1 << (L - 1) % 30;
        if (pe.length === $ && Ee < be) return pe;
        if ((Ee & be) !== be) return F.__truncateToNBits(L, pe);
        if (!pe.sign) return F.__truncateAndSubFromPowerOfTwo(L, pe, !0);
        if (!(Ee & be - 1)) {
          for (let He = $ - 2; 0 <= He; He--) if (pe.__digit(He) !== 0) return F.__truncateAndSubFromPowerOfTwo(L, pe, !1);
          return pe.length === $ && Ee === be ? pe : F.__truncateToNBits(L, pe);
        }
        return F.__truncateAndSubFromPowerOfTwo(L, pe, !1);
      }
      static asUintN(L, pe) {
        if (pe.length === 0) return pe;
        if (L = b(L), 0 > L) throw new RangeError("Invalid value: not (convertible to) a safe integer");
        if (L === 0) return F.__zero();
        if (pe.sign) {
          if (L > F.__kMaxLengthBits) throw new RangeError("BigInt too big");
          return F.__truncateAndSubFromPowerOfTwo(L, pe, !1);
        }
        if (L >= F.__kMaxLengthBits) return pe;
        const $ = 0 | (L + 29) / 30;
        if (pe.length < $) return pe;
        const Ee = L % 30;
        return pe.length == $ && (Ee === 0 || !(pe.__digit($ - 1) >>> Ee)) ? pe : F.__truncateToNBits(L, pe);
      }
      static ADD(L, pe) {
        if (L = F.__toPrimitive(L), pe = F.__toPrimitive(pe), typeof L == "string") return typeof pe != "string" && (pe = pe.toString()), L + pe;
        if (typeof pe == "string") return L.toString() + pe;
        if (L = F.__toNumeric(L), pe = F.__toNumeric(pe), F.__isBigInt(L) && F.__isBigInt(pe)) return F.add(L, pe);
        if (typeof L == "number" && typeof pe == "number") return L + pe;
        throw new TypeError("Cannot mix BigInt and other types, use explicit conversions");
      }
      static LT(L, pe) {
        return F.__compare(L, pe, 0);
      }
      static LE(L, pe) {
        return F.__compare(L, pe, 1);
      }
      static GT(L, pe) {
        return F.__compare(L, pe, 2);
      }
      static GE(L, pe) {
        return F.__compare(L, pe, 3);
      }
      static EQ(L, pe) {
        for (; ; ) {
          if (F.__isBigInt(L)) return F.__isBigInt(pe) ? F.equal(L, pe) : F.EQ(pe, L);
          if (typeof L == "number") {
            if (F.__isBigInt(pe)) return F.__equalToNumber(pe, L);
            if (typeof pe != "object") return L == pe;
            pe = F.__toPrimitive(pe);
          } else if (typeof L == "string") {
            if (F.__isBigInt(pe)) return L = F.__fromString(L), L !== null && F.equal(L, pe);
            if (typeof pe != "object") return L == pe;
            pe = F.__toPrimitive(pe);
          } else if (typeof L == "boolean") {
            if (F.__isBigInt(pe)) return F.__equalToNumber(pe, +L);
            if (typeof pe != "object") return L == pe;
            pe = F.__toPrimitive(pe);
          } else if (typeof L == "symbol") {
            if (F.__isBigInt(pe)) return !1;
            if (typeof pe != "object") return L == pe;
            pe = F.__toPrimitive(pe);
          } else if (typeof L == "object") {
            if (typeof pe == "object" && pe.constructor !== F) return L == pe;
            L = F.__toPrimitive(L);
          } else return L == pe;
        }
      }
      static NE(L, pe) {
        return !F.EQ(L, pe);
      }
      static __zero() {
        return new F(0, !1);
      }
      static __oneDigit(L, pe) {
        const $ = new F(1, pe);
        return $.__setDigit(0, L), $;
      }
      __copy() {
        const L = new F(this.length, this.sign);
        for (let pe = 0; pe < this.length; pe++) L[pe] = this[pe];
        return L;
      }
      __trim() {
        let L = this.length, pe = this[L - 1];
        for (; pe === 0; ) L--, pe = this[L - 1], this.pop();
        return L === 0 && (this.sign = !1), this;
      }
      __initializeDigits() {
        for (let L = 0; L < this.length; L++) this[L] = 0;
      }
      static __decideRounding(L, pe, $, Ee) {
        if (0 < pe) return -1;
        let be;
        if (0 > pe) be = -pe - 1;
        else {
          if ($ === 0) return -1;
          $--, Ee = L.__digit($), be = 29;
        }
        let He = 1 << be;
        if (!(Ee & He)) return -1;
        if (He -= 1, (Ee & He) != 0) return 1;
        for (; 0 < $; ) if ($--, L.__digit($) !== 0) return 1;
        return 0;
      }
      static __fromDouble(L) {
        F.__kBitConversionDouble[0] = L;
        const pe = 2047 & F.__kBitConversionInts[1] >>> 20, $ = pe - 1023, Ee = (0 | $ / 30) + 1, be = new F(Ee, 0 > L);
        let He = 1048575 & F.__kBitConversionInts[1] | 1048576, Pe = F.__kBitConversionInts[0];
        const nr = 20, ir = $ % 30;
        let or, lr = 0;
        if (20 > ir) {
          const Ir = nr - ir;
          lr = Ir + 32, or = He >>> Ir, He = He << 32 - Ir | Pe >>> Ir, Pe <<= 32 - Ir;
        } else if (ir === 20) lr = 32, or = He, He = Pe, Pe = 0;
        else {
          const Ir = ir - nr;
          lr = 32 - Ir, or = He << Ir | Pe >>> 32 - Ir, He = Pe << Ir, Pe = 0;
        }
        be.__setDigit(Ee - 1, or);
        for (let Ir = Ee - 2; 0 <= Ir; Ir--) 0 < lr ? (lr -= 30, or = He >>> 2, He = He << 30 | Pe >>> 2, Pe <<= 30) : or = 0, be.__setDigit(Ir, or);
        return be.__trim();
      }
      static __isWhitespace(L) {
        return 13 >= L && 9 <= L || (159 >= L ? L == 32 : 131071 >= L ? L == 160 || L == 5760 : 196607 >= L ? (L &= 131071, 10 >= L || L == 40 || L == 41 || L == 47 || L == 95 || L == 4096) : L == 65279);
      }
      static __fromString(L, pe = 0) {
        let $ = 0;
        const Ee = L.length;
        let be = 0;
        if (be === Ee) return F.__zero();
        let He = L.charCodeAt(be);
        for (; F.__isWhitespace(He); ) {
          if (++be === Ee) return F.__zero();
          He = L.charCodeAt(be);
        }
        if (He === 43) {
          if (++be === Ee) return null;
          He = L.charCodeAt(be), $ = 1;
        } else if (He === 45) {
          if (++be === Ee) return null;
          He = L.charCodeAt(be), $ = -1;
        }
        if (pe === 0) {
          if (pe = 10, He === 48) {
            if (++be === Ee) return F.__zero();
            if (He = L.charCodeAt(be), He === 88 || He === 120) {
              if (pe = 16, ++be === Ee) return null;
              He = L.charCodeAt(be);
            } else if (He === 79 || He === 111) {
              if (pe = 8, ++be === Ee) return null;
              He = L.charCodeAt(be);
            } else if (He === 66 || He === 98) {
              if (pe = 2, ++be === Ee) return null;
              He = L.charCodeAt(be);
            }
          }
        } else if (pe === 16 && He === 48) {
          if (++be === Ee) return F.__zero();
          if (He = L.charCodeAt(be), He === 88 || He === 120) {
            if (++be === Ee) return null;
            He = L.charCodeAt(be);
          }
        }
        if ($ != 0 && pe !== 10) return null;
        for (; He === 48; ) {
          if (++be === Ee) return F.__zero();
          He = L.charCodeAt(be);
        }
        const Pe = Ee - be;
        let nr = F.__kMaxBitsPerChar[pe], ir = F.__kBitsPerCharTableMultiplier - 1;
        if (Pe > 1073741824 / nr) return null;
        const or = nr * Pe + ir >>> F.__kBitsPerCharTableShift, lr = new F(0 | (or + 29) / 30, !1), Ir = 10 > pe ? pe : 10, xr = 10 < pe ? pe - 10 : 0;
        if (pe & pe - 1) {
          lr.__initializeDigits();
          let kr = !1, Ce = 0;
          do {
            let tr = 0, Fe = 1;
            for (; ; ) {
              let er;
              if (He - 48 >>> 0 < Ir) er = He - 48;
              else if ((32 | He) - 97 >>> 0 < xr) er = (32 | He) - 87;
              else {
                kr = !0;
                break;
              }
              const Ie = Fe * pe;
              if (1073741823 < Ie) break;
              if (Fe = Ie, tr = tr * pe + er, Ce++, ++be === Ee) {
                kr = !0;
                break;
              }
              He = L.charCodeAt(be);
            }
            ir = 30 * F.__kBitsPerCharTableMultiplier - 1;
            const Sr = 0 | (nr * Ce + ir >>> F.__kBitsPerCharTableShift) / 30;
            lr.__inplaceMultiplyAdd(Fe, tr, Sr);
          } while (!kr);
        } else {
          nr >>= F.__kBitsPerCharTableShift;
          const kr = [], Ce = [];
          let tr = !1;
          do {
            let Fe = 0, Sr = 0;
            for (; ; ) {
              let er;
              if (He - 48 >>> 0 < Ir) er = He - 48;
              else if ((32 | He) - 97 >>> 0 < xr) er = (32 | He) - 87;
              else {
                tr = !0;
                break;
              }
              if (Sr += nr, Fe = Fe << nr | er, ++be === Ee) {
                tr = !0;
                break;
              }
              if (He = L.charCodeAt(be), 30 < Sr + nr) break;
            }
            kr.push(Fe), Ce.push(Sr);
          } while (!tr);
          F.__fillFromParts(lr, kr, Ce);
        }
        if (be !== Ee) {
          if (!F.__isWhitespace(He)) return null;
          for (be++; be < Ee; be++) if (He = L.charCodeAt(be), !F.__isWhitespace(He)) return null;
        }
        return lr.sign = $ == -1, lr.__trim();
      }
      static __fillFromParts(L, pe, $) {
        let Ee = 0, be = 0, He = 0;
        for (let Pe = pe.length - 1; 0 <= Pe; Pe--) {
          const nr = pe[Pe], ir = $[Pe];
          be |= nr << He, He += ir, He === 30 ? (L.__setDigit(Ee++, be), He = 0, be = 0) : 30 < He && (L.__setDigit(Ee++, 1073741823 & be), He -= 30, be = nr >>> ir - He);
        }
        if (be !== 0) {
          if (Ee >= L.length) throw new Error("implementation bug");
          L.__setDigit(Ee++, be);
        }
        for (; Ee < L.length; Ee++) L.__setDigit(Ee, 0);
      }
      static __toStringBasePowerOfTwo(L, pe) {
        const $ = L.length;
        let Ee = pe - 1;
        Ee = (85 & Ee >>> 1) + (85 & Ee), Ee = (51 & Ee >>> 2) + (51 & Ee), Ee = (15 & Ee >>> 4) + (15 & Ee);
        const be = Ee, He = pe - 1, Pe = L.__digit($ - 1), nr = F.__clz30(Pe);
        let ir = 0 | (30 * $ - nr + be - 1) / be;
        if (L.sign && ir++, 268435456 < ir) throw new Error("string too long");
        const or = Array(ir);
        let lr = ir - 1, Ir = 0, xr = 0;
        for (let Ce = 0; Ce < $ - 1; Ce++) {
          const tr = L.__digit(Ce), Fe = (Ir | tr << xr) & He;
          or[lr--] = F.__kConversionChars[Fe];
          const Sr = be - xr;
          for (Ir = tr >>> Sr, xr = 30 - Sr; xr >= be; ) or[lr--] = F.__kConversionChars[Ir & He], Ir >>>= be, xr -= be;
        }
        const kr = (Ir | Pe << xr) & He;
        for (or[lr--] = F.__kConversionChars[kr], Ir = Pe >>> be - xr; Ir !== 0; ) or[lr--] = F.__kConversionChars[Ir & He], Ir >>>= be;
        if (L.sign && (or[lr--] = "-"), lr != -1) throw new Error("implementation bug");
        return or.join("");
      }
      static __toStringGeneric(L, pe, $) {
        const Ee = L.length;
        if (Ee === 0) return "";
        if (Ee === 1) {
          let Ce = L.__unsignedDigit(0).toString(pe);
          return $ === !1 && L.sign && (Ce = "-" + Ce), Ce;
        }
        const be = 30 * Ee - F.__clz30(L.__digit(Ee - 1)), He = F.__kMaxBitsPerChar[pe], Pe = He - 1;
        let nr = be * F.__kBitsPerCharTableMultiplier;
        nr += Pe - 1, nr = 0 | nr / Pe;
        const ir = nr + 1 >> 1, or = F.exponentiate(F.__oneDigit(pe, !1), F.__oneDigit(ir, !1));
        let lr, Ir;
        const xr = or.__unsignedDigit(0);
        if (or.length === 1 && 32767 >= xr) {
          lr = new F(L.length, !1), lr.__initializeDigits();
          let Ce = 0;
          for (let tr = 2 * L.length - 1; 0 <= tr; tr--) {
            const Fe = Ce << 15 | L.__halfDigit(tr);
            lr.__setHalfDigit(tr, 0 | Fe / xr), Ce = 0 | Fe % xr;
          }
          Ir = Ce.toString(pe);
        } else {
          const Ce = F.__absoluteDivLarge(L, or, !0, !0);
          lr = Ce.quotient;
          const tr = Ce.remainder.__trim();
          Ir = F.__toStringGeneric(tr, pe, !0);
        }
        lr.__trim();
        let kr = F.__toStringGeneric(lr, pe, !0);
        for (; Ir.length < ir; ) Ir = "0" + Ir;
        return $ === !1 && L.sign && (kr = "-" + kr), kr + Ir;
      }
      static __unequalSign(L) {
        return L ? -1 : 1;
      }
      static __absoluteGreater(L) {
        return L ? -1 : 1;
      }
      static __absoluteLess(L) {
        return L ? 1 : -1;
      }
      static __compareToBigInt(L, pe) {
        const $ = L.sign;
        if ($ !== pe.sign) return F.__unequalSign($);
        const Ee = F.__absoluteCompare(L, pe);
        return 0 < Ee ? F.__absoluteGreater($) : 0 > Ee ? F.__absoluteLess($) : 0;
      }
      static __compareToNumber(L, pe) {
        if (F.__isOneDigitInt(pe)) {
          const $ = L.sign, Ee = 0 > pe;
          if ($ !== Ee) return F.__unequalSign($);
          if (L.length === 0) {
            if (Ee) throw new Error("implementation bug");
            return pe === 0 ? 0 : -1;
          }
          if (1 < L.length) return F.__absoluteGreater($);
          const be = a(pe), He = L.__unsignedDigit(0);
          return He > be ? F.__absoluteGreater($) : He < be ? F.__absoluteLess($) : 0;
        }
        return F.__compareToDouble(L, pe);
      }
      static __compareToDouble(L, pe) {
        if (pe !== pe) return pe;
        if (pe === 1 / 0) return -1;
        if (pe === -1 / 0) return 1;
        const $ = L.sign;
        if ($ !== 0 > pe) return F.__unequalSign($);
        if (pe === 0) throw new Error("implementation bug: should be handled elsewhere");
        if (L.length === 0) return -1;
        F.__kBitConversionDouble[0] = pe;
        const Ee = 2047 & F.__kBitConversionInts[1] >>> 20;
        if (Ee == 2047) throw new Error("implementation bug: handled elsewhere");
        const be = Ee - 1023;
        if (0 > be) return F.__absoluteGreater($);
        const He = L.length;
        let Pe = L.__digit(He - 1);
        const nr = F.__clz30(Pe), ir = 30 * He - nr, or = be + 1;
        if (ir < or) return F.__absoluteLess($);
        if (ir > or) return F.__absoluteGreater($);
        let lr = 1048576 | 1048575 & F.__kBitConversionInts[1], Ir = F.__kBitConversionInts[0];
        const xr = 20, kr = 29 - nr;
        if (kr !== (0 | (ir - 1) % 30)) throw new Error("implementation bug");
        let Ce, tr = 0;
        if (20 > kr) {
          const Fe = xr - kr;
          tr = Fe + 32, Ce = lr >>> Fe, lr = lr << 32 - Fe | Ir >>> Fe, Ir <<= 32 - Fe;
        } else if (kr === 20) tr = 32, Ce = lr, lr = Ir, Ir = 0;
        else {
          const Fe = kr - xr;
          tr = 32 - Fe, Ce = lr << Fe | Ir >>> 32 - Fe, lr = Ir << Fe, Ir = 0;
        }
        if (Pe >>>= 0, Ce >>>= 0, Pe > Ce) return F.__absoluteGreater($);
        if (Pe < Ce) return F.__absoluteLess($);
        for (let Fe = He - 2; 0 <= Fe; Fe--) {
          0 < tr ? (tr -= 30, Ce = lr >>> 2, lr = lr << 30 | Ir >>> 2, Ir <<= 30) : Ce = 0;
          const Sr = L.__unsignedDigit(Fe);
          if (Sr > Ce) return F.__absoluteGreater($);
          if (Sr < Ce) return F.__absoluteLess($);
        }
        if (lr !== 0 || Ir !== 0) {
          if (tr === 0) throw new Error("implementation bug");
          return F.__absoluteLess($);
        }
        return 0;
      }
      static __equalToNumber(L, pe) {
        return F.__isOneDigitInt(pe) ? pe === 0 ? L.length === 0 : L.length === 1 && L.sign === 0 > pe && L.__unsignedDigit(0) === a(pe) : F.__compareToDouble(L, pe) === 0;
      }
      static __comparisonResultToBool(L, pe) {
        return pe === 0 ? 0 > L : pe === 1 ? 0 >= L : pe === 2 ? 0 < L : pe === 3 ? 0 <= L : void 0;
      }
      static __compare(L, pe, $) {
        if (L = F.__toPrimitive(L), pe = F.__toPrimitive(pe), typeof L == "string" && typeof pe == "string") switch ($) {
          case 0:
            return L < pe;
          case 1:
            return L <= pe;
          case 2:
            return L > pe;
          case 3:
            return L >= pe;
        }
        if (F.__isBigInt(L) && typeof pe == "string") return pe = F.__fromString(pe), pe !== null && F.__comparisonResultToBool(F.__compareToBigInt(L, pe), $);
        if (typeof L == "string" && F.__isBigInt(pe)) return L = F.__fromString(L), L !== null && F.__comparisonResultToBool(F.__compareToBigInt(L, pe), $);
        if (L = F.__toNumeric(L), pe = F.__toNumeric(pe), F.__isBigInt(L)) {
          if (F.__isBigInt(pe)) return F.__comparisonResultToBool(F.__compareToBigInt(L, pe), $);
          if (typeof pe != "number") throw new Error("implementation bug");
          return F.__comparisonResultToBool(F.__compareToNumber(L, pe), $);
        }
        if (typeof L != "number") throw new Error("implementation bug");
        if (F.__isBigInt(pe)) return F.__comparisonResultToBool(F.__compareToNumber(pe, L), 2 ^ $);
        if (typeof pe != "number") throw new Error("implementation bug");
        return $ === 0 ? L < pe : $ === 1 ? L <= pe : $ === 2 ? L > pe : $ === 3 ? L >= pe : void 0;
      }
      __clzmsd() {
        return F.__clz30(this.__digit(this.length - 1));
      }
      static __absoluteAdd(L, pe, $) {
        if (L.length < pe.length) return F.__absoluteAdd(pe, L, $);
        if (L.length === 0) return L;
        if (pe.length === 0) return L.sign === $ ? L : F.unaryMinus(L);
        let Ee = L.length;
        (L.__clzmsd() === 0 || pe.length === L.length && pe.__clzmsd() === 0) && Ee++;
        const be = new F(Ee, $);
        let He = 0, Pe = 0;
        for (; Pe < pe.length; Pe++) {
          const nr = L.__digit(Pe) + pe.__digit(Pe) + He;
          He = nr >>> 30, be.__setDigit(Pe, 1073741823 & nr);
        }
        for (; Pe < L.length; Pe++) {
          const nr = L.__digit(Pe) + He;
          He = nr >>> 30, be.__setDigit(Pe, 1073741823 & nr);
        }
        return Pe < be.length && be.__setDigit(Pe, He), be.__trim();
      }
      static __absoluteSub(L, pe, $) {
        if (L.length === 0) return L;
        if (pe.length === 0) return L.sign === $ ? L : F.unaryMinus(L);
        const Ee = new F(L.length, $);
        let be = 0, He = 0;
        for (; He < pe.length; He++) {
          const Pe = L.__digit(He) - pe.__digit(He) - be;
          be = 1 & Pe >>> 30, Ee.__setDigit(He, 1073741823 & Pe);
        }
        for (; He < L.length; He++) {
          const Pe = L.__digit(He) - be;
          be = 1 & Pe >>> 30, Ee.__setDigit(He, 1073741823 & Pe);
        }
        return Ee.__trim();
      }
      static __absoluteAddOne(L, pe, $ = null) {
        const Ee = L.length;
        $ === null ? $ = new F(Ee, pe) : $.sign = pe;
        let be = 1;
        for (let He = 0; He < Ee; He++) {
          const Pe = L.__digit(He) + be;
          be = Pe >>> 30, $.__setDigit(He, 1073741823 & Pe);
        }
        return be != 0 && $.__setDigitGrow(Ee, 1), $;
      }
      static __absoluteSubOne(L, pe) {
        const $ = L.length;
        pe = pe || $;
        const Ee = new F(pe, !1);
        let be = 1;
        for (let He = 0; He < $; He++) {
          const Pe = L.__digit(He) - be;
          be = 1 & Pe >>> 30, Ee.__setDigit(He, 1073741823 & Pe);
        }
        if (be != 0) throw new Error("implementation bug");
        for (let He = $; He < pe; He++) Ee.__setDigit(He, 0);
        return Ee;
      }
      static __absoluteAnd(L, pe, $ = null) {
        let Ee = L.length, be = pe.length, He = be;
        if (Ee < be) {
          He = Ee;
          const ir = L, or = Ee;
          L = pe, Ee = be, pe = ir, be = or;
        }
        let Pe = He;
        $ === null ? $ = new F(Pe, !1) : Pe = $.length;
        let nr = 0;
        for (; nr < He; nr++) $.__setDigit(nr, L.__digit(nr) & pe.__digit(nr));
        for (; nr < Pe; nr++) $.__setDigit(nr, 0);
        return $;
      }
      static __absoluteAndNot(L, pe, $ = null) {
        const Ee = L.length, be = pe.length;
        let He = be;
        Ee < be && (He = Ee);
        let Pe = Ee;
        $ === null ? $ = new F(Pe, !1) : Pe = $.length;
        let nr = 0;
        for (; nr < He; nr++) $.__setDigit(nr, L.__digit(nr) & ~pe.__digit(nr));
        for (; nr < Ee; nr++) $.__setDigit(nr, L.__digit(nr));
        for (; nr < Pe; nr++) $.__setDigit(nr, 0);
        return $;
      }
      static __absoluteOr(L, pe, $ = null) {
        let Ee = L.length, be = pe.length, He = be;
        if (Ee < be) {
          He = Ee;
          const ir = L, or = Ee;
          L = pe, Ee = be, pe = ir, be = or;
        }
        let Pe = Ee;
        $ === null ? $ = new F(Pe, !1) : Pe = $.length;
        let nr = 0;
        for (; nr < He; nr++) $.__setDigit(nr, L.__digit(nr) | pe.__digit(nr));
        for (; nr < Ee; nr++) $.__setDigit(nr, L.__digit(nr));
        for (; nr < Pe; nr++) $.__setDigit(nr, 0);
        return $;
      }
      static __absoluteXor(L, pe, $ = null) {
        let Ee = L.length, be = pe.length, He = be;
        if (Ee < be) {
          He = Ee;
          const ir = L, or = Ee;
          L = pe, Ee = be, pe = ir, be = or;
        }
        let Pe = Ee;
        $ === null ? $ = new F(Pe, !1) : Pe = $.length;
        let nr = 0;
        for (; nr < He; nr++) $.__setDigit(nr, L.__digit(nr) ^ pe.__digit(nr));
        for (; nr < Ee; nr++) $.__setDigit(nr, L.__digit(nr));
        for (; nr < Pe; nr++) $.__setDigit(nr, 0);
        return $;
      }
      static __absoluteCompare(L, pe) {
        const $ = L.length - pe.length;
        if ($ != 0) return $;
        let Ee = L.length - 1;
        for (; 0 <= Ee && L.__digit(Ee) === pe.__digit(Ee); ) Ee--;
        return 0 > Ee ? 0 : L.__unsignedDigit(Ee) > pe.__unsignedDigit(Ee) ? 1 : -1;
      }
      static __multiplyAccumulate(L, pe, $, Ee) {
        if (pe === 0) return;
        const be = 32767 & pe, He = pe >>> 15;
        let Pe = 0, nr = 0;
        for (let ir, or = 0; or < L.length; or++, Ee++) {
          ir = $.__digit(Ee);
          const lr = L.__digit(or), Ir = 32767 & lr, xr = lr >>> 15, kr = F.__imul(Ir, be), Ce = F.__imul(Ir, He), tr = F.__imul(xr, be), Fe = F.__imul(xr, He);
          ir += nr + kr + Pe, Pe = ir >>> 30, ir &= 1073741823, ir += ((32767 & Ce) << 15) + ((32767 & tr) << 15), Pe += ir >>> 30, nr = Fe + (Ce >>> 15) + (tr >>> 15), $.__setDigit(Ee, 1073741823 & ir);
        }
        for (; Pe != 0 || nr !== 0; Ee++) {
          let ir = $.__digit(Ee);
          ir += Pe + nr, nr = 0, Pe = ir >>> 30, $.__setDigit(Ee, 1073741823 & ir);
        }
      }
      static __internalMultiplyAdd(L, pe, $, Ee, be) {
        let He = $, Pe = 0;
        for (let nr = 0; nr < Ee; nr++) {
          const ir = L.__digit(nr), or = F.__imul(32767 & ir, pe), lr = F.__imul(ir >>> 15, pe), Ir = or + ((32767 & lr) << 15) + Pe + He;
          He = Ir >>> 30, Pe = lr >>> 15, be.__setDigit(nr, 1073741823 & Ir);
        }
        if (be.length > Ee) for (be.__setDigit(Ee++, He + Pe); Ee < be.length; ) be.__setDigit(Ee++, 0);
        else if (He + Pe !== 0) throw new Error("implementation bug");
      }
      __inplaceMultiplyAdd(L, pe, $) {
        $ > this.length && ($ = this.length);
        const Ee = 32767 & L, be = L >>> 15;
        let He = 0, Pe = pe;
        for (let nr = 0; nr < $; nr++) {
          const ir = this.__digit(nr), or = 32767 & ir, lr = ir >>> 15, Ir = F.__imul(or, Ee), xr = F.__imul(or, be), kr = F.__imul(lr, Ee), Ce = F.__imul(lr, be);
          let tr = Pe + Ir + He;
          He = tr >>> 30, tr &= 1073741823, tr += ((32767 & xr) << 15) + ((32767 & kr) << 15), He += tr >>> 30, Pe = Ce + (xr >>> 15) + (kr >>> 15), this.__setDigit(nr, 1073741823 & tr);
        }
        if (He != 0 || Pe !== 0) throw new Error("implementation bug");
      }
      static __absoluteDivSmall(L, pe, $ = null) {
        $ === null && ($ = new F(L.length, !1));
        let Ee = 0;
        for (let be, He = 2 * L.length - 1; 0 <= He; He -= 2) {
          be = (Ee << 15 | L.__halfDigit(He)) >>> 0;
          const Pe = 0 | be / pe;
          Ee = 0 | be % pe, be = (Ee << 15 | L.__halfDigit(He - 1)) >>> 0;
          const nr = 0 | be / pe;
          Ee = 0 | be % pe, $.__setDigit(He >>> 1, Pe << 15 | nr);
        }
        return $;
      }
      static __absoluteModSmall(L, pe) {
        let $ = 0;
        for (let Ee = 2 * L.length - 1; 0 <= Ee; Ee--)
          $ = 0 | (($ << 15 | L.__halfDigit(Ee)) >>> 0) % pe;
        return $;
      }
      static __absoluteDivLarge(L, pe, $, Ee) {
        const be = pe.__halfDigitLength(), He = pe.length, Pe = L.__halfDigitLength() - be;
        let nr = null;
        $ && (nr = new F(Pe + 2 >>> 1, !1), nr.__initializeDigits());
        const ir = new F(be + 2 >>> 1, !1);
        ir.__initializeDigits();
        const or = F.__clz15(pe.__halfDigit(be - 1));
        0 < or && (pe = F.__specialLeftShift(pe, or, 0));
        const lr = F.__specialLeftShift(L, or, 1), Ir = pe.__halfDigit(be - 1);
        let xr = 0;
        for (let kr, Ce = Pe; 0 <= Ce; Ce--) {
          kr = 32767;
          const tr = lr.__halfDigit(Ce + be);
          if (tr !== Ir) {
            const Sr = (tr << 15 | lr.__halfDigit(Ce + be - 1)) >>> 0;
            kr = 0 | Sr / Ir;
            let er = 0 | Sr % Ir;
            const Ie = pe.__halfDigit(be - 2), xe = lr.__halfDigit(Ce + be - 2);
            for (; F.__imul(kr, Ie) >>> 0 > (er << 16 | xe) >>> 0 && (kr--, er += Ir, !(32767 < er)); ) ;
          }
          F.__internalMultiplyAdd(pe, kr, 0, He, ir);
          let Fe = lr.__inplaceSub(ir, Ce, be + 1);
          Fe !== 0 && (Fe = lr.__inplaceAdd(pe, Ce, be), lr.__setHalfDigit(Ce + be, 32767 & lr.__halfDigit(Ce + be) + Fe), kr--), $ && (1 & Ce ? xr = kr << 15 : nr.__setDigit(Ce >>> 1, xr | kr));
        }
        if (Ee) return lr.__inplaceRightShift(or), $ ? { quotient: nr, remainder: lr } : lr;
        if ($) return nr;
        throw new Error("unreachable");
      }
      static __clz15(L) {
        return F.__clz30(L) - 15;
      }
      __inplaceAdd(L, pe, $) {
        let Ee = 0;
        for (let be = 0; be < $; be++) {
          const He = this.__halfDigit(pe + be) + L.__halfDigit(be) + Ee;
          Ee = He >>> 15, this.__setHalfDigit(pe + be, 32767 & He);
        }
        return Ee;
      }
      __inplaceSub(L, pe, $) {
        let Ee = 0;
        if (1 & pe) {
          pe >>= 1;
          let be = this.__digit(pe), He = 32767 & be, Pe = 0;
          for (; Pe < $ - 1 >>> 1; Pe++) {
            const or = L.__digit(Pe), lr = (be >>> 15) - (32767 & or) - Ee;
            Ee = 1 & lr >>> 15, this.__setDigit(pe + Pe, (32767 & lr) << 15 | 32767 & He), be = this.__digit(pe + Pe + 1), He = (32767 & be) - (or >>> 15) - Ee, Ee = 1 & He >>> 15;
          }
          const nr = L.__digit(Pe), ir = (be >>> 15) - (32767 & nr) - Ee;
          if (Ee = 1 & ir >>> 15, this.__setDigit(pe + Pe, (32767 & ir) << 15 | 32767 & He), pe + Pe + 1 >= this.length) throw new RangeError("out of bounds");
          !(1 & $) && (be = this.__digit(pe + Pe + 1), He = (32767 & be) - (nr >>> 15) - Ee, Ee = 1 & He >>> 15, this.__setDigit(pe + L.length, 1073709056 & be | 32767 & He));
        } else {
          pe >>= 1;
          let be = 0;
          for (; be < L.length - 1; be++) {
            const or = this.__digit(pe + be), lr = L.__digit(be), Ir = (32767 & or) - (32767 & lr) - Ee;
            Ee = 1 & Ir >>> 15;
            const xr = (or >>> 15) - (lr >>> 15) - Ee;
            Ee = 1 & xr >>> 15, this.__setDigit(pe + be, (32767 & xr) << 15 | 32767 & Ir);
          }
          const He = this.__digit(pe + be), Pe = L.__digit(be), nr = (32767 & He) - (32767 & Pe) - Ee;
          Ee = 1 & nr >>> 15;
          let ir = 0;
          !(1 & $) && (ir = (He >>> 15) - (Pe >>> 15) - Ee, Ee = 1 & ir >>> 15), this.__setDigit(pe + be, (32767 & ir) << 15 | 32767 & nr);
        }
        return Ee;
      }
      __inplaceRightShift(L) {
        if (L === 0) return;
        let pe = this.__digit(0) >>> L;
        const $ = this.length - 1;
        for (let Ee = 0; Ee < $; Ee++) {
          const be = this.__digit(Ee + 1);
          this.__setDigit(Ee, 1073741823 & be << 30 - L | pe), pe = be >>> L;
        }
        this.__setDigit($, pe);
      }
      static __specialLeftShift(L, pe, $) {
        const Ee = L.length, be = new F(Ee + $, !1);
        if (pe === 0) {
          for (let Pe = 0; Pe < Ee; Pe++) be.__setDigit(Pe, L.__digit(Pe));
          return 0 < $ && be.__setDigit(Ee, 0), be;
        }
        let He = 0;
        for (let Pe = 0; Pe < Ee; Pe++) {
          const nr = L.__digit(Pe);
          be.__setDigit(Pe, 1073741823 & nr << pe | He), He = nr >>> 30 - pe;
        }
        return 0 < $ && be.__setDigit(Ee, He), be;
      }
      static __leftShiftByAbsolute(L, pe) {
        const $ = F.__toShiftAmount(pe);
        if (0 > $) throw new RangeError("BigInt too big");
        const Ee = 0 | $ / 30, be = $ % 30, He = L.length, Pe = be !== 0 && L.__digit(He - 1) >>> 30 - be != 0, nr = He + Ee + (Pe ? 1 : 0), ir = new F(nr, L.sign);
        if (be === 0) {
          let or = 0;
          for (; or < Ee; or++) ir.__setDigit(or, 0);
          for (; or < nr; or++) ir.__setDigit(or, L.__digit(or - Ee));
        } else {
          let or = 0;
          for (let lr = 0; lr < Ee; lr++) ir.__setDigit(lr, 0);
          for (let lr = 0; lr < He; lr++) {
            const Ir = L.__digit(lr);
            ir.__setDigit(lr + Ee, 1073741823 & Ir << be | or), or = Ir >>> 30 - be;
          }
          if (Pe) ir.__setDigit(He + Ee, or);
          else if (or !== 0) throw new Error("implementation bug");
        }
        return ir.__trim();
      }
      static __rightShiftByAbsolute(L, pe) {
        const $ = L.length, Ee = L.sign, be = F.__toShiftAmount(pe);
        if (0 > be) return F.__rightShiftByMaximum(Ee);
        const He = 0 | be / 30, Pe = be % 30;
        let nr = $ - He;
        if (0 >= nr) return F.__rightShiftByMaximum(Ee);
        let ir = !1;
        if (Ee) {
          if (L.__digit(He) & (1 << Pe) - 1) ir = !0;
          else for (let lr = 0; lr < He; lr++) if (L.__digit(lr) !== 0) {
            ir = !0;
            break;
          }
        }
        ir && Pe === 0 && !~L.__digit($ - 1) && nr++;
        let or = new F(nr, Ee);
        if (Pe === 0) {
          or.__setDigit(nr - 1, 0);
          for (let lr = He; lr < $; lr++) or.__setDigit(lr - He, L.__digit(lr));
        } else {
          let lr = L.__digit(He) >>> Pe;
          const Ir = $ - He - 1;
          for (let xr = 0; xr < Ir; xr++) {
            const kr = L.__digit(xr + He + 1);
            or.__setDigit(xr, 1073741823 & kr << 30 - Pe | lr), lr = kr >>> Pe;
          }
          or.__setDigit(Ir, lr);
        }
        return ir && (or = F.__absoluteAddOne(or, !0, or)), or.__trim();
      }
      static __rightShiftByMaximum(L) {
        return L ? F.__oneDigit(1, !0) : F.__zero();
      }
      static __toShiftAmount(L) {
        if (1 < L.length) return -1;
        const pe = L.__unsignedDigit(0);
        return pe > F.__kMaxLengthBits ? -1 : pe;
      }
      static __toPrimitive(L, pe = "default") {
        if (typeof L != "object" || L.constructor === F) return L;
        if (typeof Symbol < "u" && typeof Symbol.toPrimitive == "symbol") {
          const be = L[Symbol.toPrimitive];
          if (be) {
            const He = be(pe);
            if (typeof He != "object") return He;
            throw new TypeError("Cannot convert object to primitive value");
          }
        }
        const $ = L.valueOf;
        if ($) {
          const be = $.call(L);
          if (typeof be != "object") return be;
        }
        const Ee = L.toString;
        if (Ee) {
          const be = Ee.call(L);
          if (typeof be != "object") return be;
        }
        throw new TypeError("Cannot convert object to primitive value");
      }
      static __toNumeric(L) {
        return F.__isBigInt(L) ? L : +L;
      }
      static __isBigInt(L) {
        return typeof L == "object" && L !== null && L.constructor === F;
      }
      static __truncateToNBits(L, pe) {
        const $ = 0 | (L + 29) / 30, Ee = new F($, pe.sign), be = $ - 1;
        for (let Pe = 0; Pe < be; Pe++) Ee.__setDigit(Pe, pe.__digit(Pe));
        let He = pe.__digit(be);
        if (L % 30 != 0) {
          const Pe = 32 - L % 30;
          He = He << Pe >>> Pe;
        }
        return Ee.__setDigit(be, He), Ee.__trim();
      }
      static __truncateAndSubFromPowerOfTwo(L, pe, $) {
        var Ee = Math.min;
        const be = 0 | (L + 29) / 30, He = new F(be, $);
        let Pe = 0;
        const nr = be - 1;
        let ir = 0;
        for (const xr = Ee(nr, pe.length); Pe < xr; Pe++) {
          const kr = 0 - pe.__digit(Pe) - ir;
          ir = 1 & kr >>> 30, He.__setDigit(Pe, 1073741823 & kr);
        }
        for (; Pe < nr; Pe++) He.__setDigit(Pe, 0 | 1073741823 & -ir);
        let or = nr < pe.length ? pe.__digit(nr) : 0;
        const lr = L % 30;
        let Ir;
        if (lr == 0) Ir = 0 - or - ir, Ir &= 1073741823;
        else {
          const xr = 32 - lr;
          or = or << xr >>> xr;
          const kr = 1 << 32 - xr;
          Ir = kr - or - ir, Ir &= kr - 1;
        }
        return He.__setDigit(nr, Ir), He.__trim();
      }
      __digit(L) {
        return this[L];
      }
      __unsignedDigit(L) {
        return this[L] >>> 0;
      }
      __setDigit(L, pe) {
        this[L] = 0 | pe;
      }
      __setDigitGrow(L, pe) {
        this[L] = 0 | pe;
      }
      __halfDigitLength() {
        const L = this.length;
        return 32767 >= this.__unsignedDigit(L - 1) ? 2 * L - 1 : 2 * L;
      }
      __halfDigit(L) {
        return 32767 & this[L >>> 1] >>> 15 * (1 & L);
      }
      __setHalfDigit(L, pe) {
        const $ = L >>> 1, Ee = this.__digit($), be = 1 & L ? 32767 & Ee | pe << 15 : 1073709056 & Ee | 32767 & pe;
        this.__setDigit($, be);
      }
      static __digitPow(L, pe) {
        let $ = 1;
        for (; 0 < pe; ) 1 & pe && ($ *= L), pe >>>= 1, L *= L;
        return $;
      }
      static __isOneDigitInt(L) {
        return (1073741823 & L) === L;
      }
    }
    return F.__kMaxLength = 33554432, F.__kMaxLengthBits = F.__kMaxLength << 5, F.__kMaxBitsPerChar = [0, 0, 32, 51, 64, 75, 83, 90, 96, 102, 107, 111, 115, 119, 122, 126, 128, 131, 134, 136, 139, 141, 143, 145, 147, 149, 151, 153, 154, 156, 158, 159, 160, 162, 163, 165, 166], F.__kBitsPerCharTableShift = 5, F.__kBitsPerCharTableMultiplier = 1 << F.__kBitsPerCharTableShift, F.__kConversionChars = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"], F.__kBitConversionBuffer = new ArrayBuffer(8), F.__kBitConversionDouble = new Float64Array(F.__kBitConversionBuffer), F.__kBitConversionInts = new Int32Array(F.__kBitConversionBuffer), F.__clz30 = p ? function(le) {
      return p(le) - 2;
    } : function(le) {
      var L = Math.LN2, pe = Math.log;
      return le === 0 ? 30 : 0 | 29 - (0 | pe(le >>> 0) / L);
    }, F.__imul = u || function(le, L) {
      return 0 | le * L;
    }, F;
  });
})(jsbiUmd);
var jsbiUmdExports = jsbiUmd.exports, __importDefault$h = commonjsGlobal && commonjsGlobal.__importDefault || function(n) {
  return n && n.__esModule ? n : { default: n };
};
Object.defineProperty(xoshiro, "__esModule", { value: !0 });
const utils_1$s = utils$I, bignumber_js_1 = __importDefault$h(bignumberExports), jsbi_1 = __importDefault$h(jsbiUmdExports), MAX_UINT64 = 18446744073709552e3, rotl$3 = (n, c) => jsbi_1.default.bitwiseXor(jsbi_1.default.asUintN(64, jsbi_1.default.leftShift(n, jsbi_1.default.BigInt(c))), jsbi_1.default.BigInt(jsbi_1.default.asUintN(64, jsbi_1.default.signedRightShift(n, jsbi_1.default.subtract(jsbi_1.default.BigInt(64), jsbi_1.default.BigInt(c))))));
class Xoshiro {
  constructor(c) {
    this.next = () => new bignumber_js_1.default(this.roll().toString()), this.nextDouble = () => new bignumber_js_1.default(this.roll().toString()).div(MAX_UINT64 + 1), this.nextInt = (p, a) => Math.floor(this.nextDouble().toNumber() * (a - p + 1) + p), this.nextByte = () => this.nextInt(0, 255), this.nextData = (p) => [...new Array(p)].map(() => this.nextByte());
    const u = utils_1$s.sha256Hash(c);
    this.s = [jsbi_1.default.BigInt(0), jsbi_1.default.BigInt(0), jsbi_1.default.BigInt(0), jsbi_1.default.BigInt(0)], this.setS(u);
  }
  setS(c) {
    for (let u = 0; u < 4; u++) {
      let p = u * 8, a = jsbi_1.default.BigInt(0);
      for (let A = 0; A < 8; A++)
        a = jsbi_1.default.asUintN(64, jsbi_1.default.leftShift(a, jsbi_1.default.BigInt(8))), a = jsbi_1.default.asUintN(64, jsbi_1.default.bitwiseOr(a, jsbi_1.default.BigInt(c[p + A])));
      this.s[u] = jsbi_1.default.asUintN(64, a);
    }
  }
  roll() {
    const c = jsbi_1.default.asUintN(64, jsbi_1.default.multiply(rotl$3(jsbi_1.default.asUintN(64, jsbi_1.default.multiply(this.s[1], jsbi_1.default.BigInt(5))), 7), jsbi_1.default.BigInt(9))), u = jsbi_1.default.asUintN(64, jsbi_1.default.leftShift(this.s[1], jsbi_1.default.BigInt(17)));
    return this.s[2] = jsbi_1.default.asUintN(64, jsbi_1.default.bitwiseXor(this.s[2], jsbi_1.default.BigInt(this.s[0]))), this.s[3] = jsbi_1.default.asUintN(64, jsbi_1.default.bitwiseXor(this.s[3], jsbi_1.default.BigInt(this.s[1]))), this.s[1] = jsbi_1.default.asUintN(64, jsbi_1.default.bitwiseXor(this.s[1], jsbi_1.default.BigInt(this.s[2]))), this.s[0] = jsbi_1.default.asUintN(64, jsbi_1.default.bitwiseXor(this.s[0], jsbi_1.default.BigInt(this.s[3]))), this.s[2] = jsbi_1.default.asUintN(64, jsbi_1.default.bitwiseXor(this.s[2], jsbi_1.default.BigInt(u))), this.s[3] = jsbi_1.default.asUintN(64, rotl$3(this.s[3], 45)), c;
  }
}
xoshiro.default = Xoshiro;
var precomputeAlias = function(n, c) {
  var u = n.reduce(function(pe, $) {
    if ($ < 0)
      throw new Error("Probability must be a positive: p[" + n.indexOf($) + "]=" + $);
    return pe + $;
  }, 0);
  if (u === 0)
    throw new Error("Probability sum must be greater than zero.");
  for (var p = n.map(function(pe) {
    return pe * c / u;
  }), a = { prob: new Array(c), alias: new Array(c) }, A = [], b = [], F = c - 1; F >= 0; F--)
    p[F] < 1 ? A.push(F) : b.push(F);
  for (; A.length > 0 && b.length > 0; ) {
    var le = A.pop(), L = b.pop();
    a.prob[le] = p[le], a.alias[le] = L, p[L] = p[L] + p[le] - 1, p[L] < 1 ? A.push(L) : b.push(L);
  }
  for (; b.length > 0; )
    a.prob[b.pop()] = 1;
  for (; A.length > 0; )
    a.prob[A.pop()] = 1;
  return a;
}, draw = function(n, c, u) {
  var p = Math.floor(u() * n.prob.length);
  return c[u() < n.prob[p] ? p : n.alias[p]];
}, next = function(n, c, u, p) {
  if (p === void 0 && (p = 1), p === 1)
    return draw(n, c, u);
  for (var a = [], A = 0; A < p; A++)
    a.push(draw(n, c, u));
  return a;
}, sample = function(n, c, u) {
  if (u === void 0 && (u = Math.random), !Array.isArray(n))
    throw new Error("Probabilities must be an array.");
  if (n.length === 0)
    throw new Error("Probabilities array must not be empty.");
  var p = n.length, a = c ?? Array.from({ length: p }, function(b, F) {
    return F;
  }), A = precomputeAlias(n, p);
  return {
    next: function(b) {
      return b === void 0 && (b = 1), next(A, a, u, b);
    }
  };
};
const esm$2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sample
}, Symbol.toStringTag, { value: "Module" })), require$$2$1 = /* @__PURE__ */ getAugmentedNamespace(esm$2);
(function(n) {
  var c = commonjsGlobal && commonjsGlobal.__importDefault || function(le) {
    return le && le.__esModule ? le : { default: le };
  };
  Object.defineProperty(n, "__esModule", { value: !0 }), n.chooseFragments = n.shuffle = n.chooseDegree = void 0;
  const u = utils$I, p = c(xoshiro), a = c(require$$2$1), A = (le, L) => {
    const pe = [...new Array(le)].map((Ee, be) => 1 / (be + 1));
    return a.default(pe, void 0, L.nextDouble).next() + 1;
  };
  n.chooseDegree = A;
  const b = (le, L) => {
    let pe = [...le], $ = [];
    for (; pe.length > 0; ) {
      let Ee = L.nextInt(0, pe.length - 1), be = pe[Ee];
      pe.splice(Ee, 1), $.push(be);
    }
    return $;
  };
  n.shuffle = b;
  const F = (le, L, pe) => {
    if (le <= L)
      return [le - 1];
    {
      const $ = Buffer$f.concat([u.intToBytes(le), u.intToBytes(pe)]), Ee = new p.default($), be = n.chooseDegree(L, Ee), He = [...new Array(L)].map((nr, ir) => ir);
      return n.shuffle(He, Ee).slice(0, be);
    }
  };
  n.chooseFragments = F;
})(fountainUtils);
var __importDefault$g = commonjsGlobal && commonjsGlobal.__importDefault || function(n) {
  return n && n.__esModule ? n : { default: n };
};
Object.defineProperty(fountainEncoder, "__esModule", { value: !0 });
fountainEncoder.FountainEncoderPart = void 0;
const assert_1$3 = __importDefault$g(requireAssert()), utils_1$r = utils$I, fountainUtils_1$1 = fountainUtils, cbor_1 = cbor$1;
class FountainEncoderPart {
  constructor(c, u, p, a, A) {
    this._seqNum = c, this._seqLength = u, this._messageLength = p, this._checksum = a, this._fragment = A;
  }
  get messageLength() {
    return this._messageLength;
  }
  get fragment() {
    return this._fragment;
  }
  get seqNum() {
    return this._seqNum;
  }
  get seqLength() {
    return this._seqLength;
  }
  get checksum() {
    return this._checksum;
  }
  cbor() {
    const c = cbor_1.cborEncode([
      this._seqNum,
      this._seqLength,
      this._messageLength,
      this._checksum,
      this._fragment
    ]);
    return Buffer$f.from(c);
  }
  description() {
    return `seqNum:${this._seqNum}, seqLen:${this._seqLength}, messageLen:${this._messageLength}, checksum:${this._checksum}, data:${this._fragment.toString("hex")}`;
  }
  static fromCBOR(c) {
    const [u, p, a, A, b] = cbor_1.cborDecode(c);
    return assert_1$3.default(typeof u == "number"), assert_1$3.default(typeof p == "number"), assert_1$3.default(typeof a == "number"), assert_1$3.default(typeof A == "number"), assert_1$3.default(Buffer$f.isBuffer(b) && b.length > 0), new FountainEncoderPart(u, p, a, A, Buffer$f.from(b));
  }
}
fountainEncoder.FountainEncoderPart = FountainEncoderPart;
class FountainEncoder {
  constructor(c, u = 100, p = 0, a = 10) {
    const A = FountainEncoder.findNominalFragmentLength(c.length, a, u);
    this._messageLength = c.length, this._fragments = FountainEncoder.partitionMessage(c, A), this.fragmentLength = A, this.seqNum = utils_1$r.toUint32(p), this.checksum = utils_1$r.getCRC(c);
  }
  get fragmentsLength() {
    return this._fragments.length;
  }
  get fragments() {
    return this._fragments;
  }
  get messageLength() {
    return this._messageLength;
  }
  isComplete() {
    return this.seqNum >= this._fragments.length;
  }
  isSinglePart() {
    return this._fragments.length === 1;
  }
  seqLength() {
    return this._fragments.length;
  }
  mix(c) {
    return c.reduce((u, p) => utils_1$r.bufferXOR(this._fragments[p], u), Buffer$f.alloc(this.fragmentLength, 0));
  }
  nextPart() {
    this.seqNum = utils_1$r.toUint32(this.seqNum + 1);
    const c = fountainUtils_1$1.chooseFragments(this.seqNum, this._fragments.length, this.checksum), u = this.mix(c);
    return new FountainEncoderPart(this.seqNum, this._fragments.length, this._messageLength, this.checksum, u);
  }
  static findNominalFragmentLength(c, u, p) {
    assert_1$3.default(c > 0), assert_1$3.default(u > 0), assert_1$3.default(p >= u);
    const a = Math.ceil(c / u);
    let A = 0;
    for (let b = 1; b <= a && (A = Math.ceil(c / b), !(A <= p)); b++)
      ;
    return A;
  }
  static partitionMessage(c, u) {
    let p = Buffer$f.from(c), a, A = [];
    for (; p.length > 0; )
      [a, p] = utils_1$r.split(p, -u), a = Buffer$f.alloc(u, 0).fill(a, 0, a.length), A.push(a);
    return A;
  }
}
fountainEncoder.default = FountainEncoder;
var bytewords$1 = {}, __importDefault$f = commonjsGlobal && commonjsGlobal.__importDefault || function(n) {
  return n && n.__esModule ? n : { default: n };
};
Object.defineProperty(bytewords$1, "__esModule", { value: !0 });
const assert_1$2 = __importDefault$f(requireAssert()), utils_1$q = utils$I, bytewords = "ableacidalsoapexaquaarchatomauntawayaxisbackbaldbarnbeltbetabiasbluebodybragbrewbulbbuzzcalmcashcatschefcityclawcodecolacookcostcruxcurlcuspcyandarkdatadaysdelidicedietdoordowndrawdropdrumdulldutyeacheasyechoedgeepicevenexamexiteyesfactfairfernfigsfilmfishfizzflapflewfluxfoxyfreefrogfuelfundgalagamegeargemsgiftgirlglowgoodgraygrimgurugushgyrohalfhanghardhawkheathelphighhillholyhopehornhutsicedideaidleinchinkyintoirisironitemjadejazzjoinjoltjowljudojugsjumpjunkjurykeepkenokeptkeyskickkilnkingkitekiwiknoblamblavalazyleaflegsliarlimplionlistlogoloudloveluaulucklungmainmanymathmazememomenumeowmildmintmissmonknailnavyneednewsnextnoonnotenumbobeyoboeomitonyxopenovalowlspaidpartpeckplaypluspoempoolposepuffpumapurrquadquizraceramprealredorichroadrockroofrubyruinrunsrustsafesagascarsetssilkskewslotsoapsolosongstubsurfswantacotasktaxitenttiedtimetinytoiltombtoystriptunatwinuglyundouniturgeuservastveryvetovialvibeviewvisavoidvowswallwandwarmwaspwavewaxywebswhatwhenwhizwolfworkyankyawnyellyogayurtzapszerozestzinczonezoom";
let bytewordsLookUpTable = [];
const BYTEWORDS_NUM = 256, BYTEWORD_LENGTH = 4, MINIMAL_BYTEWORD_LENGTH = 2;
var STYLES;
(function(n) {
  n.STANDARD = "standard", n.URI = "uri", n.MINIMAL = "minimal";
})(STYLES || (STYLES = {}));
const getWord = (n) => bytewords.slice(n * BYTEWORD_LENGTH, n * BYTEWORD_LENGTH + BYTEWORD_LENGTH), getMinimalWord = (n) => {
  const c = getWord(n);
  return `${c[0]}${c[BYTEWORD_LENGTH - 1]}`;
}, addCRC = (n) => {
  const c = utils_1$q.getCRCHex(Buffer$f.from(n, "hex"));
  return `${n}${c}`;
}, encodeWithSeparator = (n, c) => {
  const u = addCRC(n);
  return Buffer$f.from(u, "hex").reduce((A, b) => [...A, getWord(b)], []).join(c);
}, encodeMinimal = (n) => {
  const c = addCRC(n);
  return Buffer$f.from(c, "hex").reduce((a, A) => a + getMinimalWord(A), "");
}, decodeWord = (n, c) => {
  assert_1$2.default(n.length === c, "Invalid Bytewords: word.length does not match wordLength provided");
  const u = 26;
  if (bytewordsLookUpTable.length === 0) {
    const F = u * u;
    bytewordsLookUpTable = [...new Array(F)].map(() => -1);
    for (let le = 0; le < BYTEWORDS_NUM; le++) {
      const L = getWord(le);
      let pe = L[0].charCodeAt(0) - 97, Ee = (L[3].charCodeAt(0) - 97) * u + pe;
      bytewordsLookUpTable[Ee] = le;
    }
  }
  let p = n[0].toLowerCase().charCodeAt(0) - 97, a = n[c == 4 ? 3 : 1].toLowerCase().charCodeAt(0) - 97;
  assert_1$2.default(0 <= p && p < u && 0 <= a && a < u, "Invalid Bytewords: invalid word");
  let A = a * u + p, b = bytewordsLookUpTable[A];
  if (assert_1$2.default(b !== -1, "Invalid Bytewords: value not in lookup table"), c == BYTEWORD_LENGTH) {
    const F = getWord(b);
    let le = n[1].toLowerCase(), L = n[2].toLowerCase();
    assert_1$2.default(le === F[1] && L === F[2], "Invalid Bytewords: invalid middle letters of word");
  }
  return Buffer$f.from([b]).toString("hex");
}, _decode = (n, c, u) => {
  const a = (u == BYTEWORD_LENGTH ? n.split(c) : utils_1$q.partition(n, 2)).map((le) => decodeWord(le, u)).join("");
  assert_1$2.default(a.length >= 5, "Invalid Bytewords: invalid decoded string length");
  const [A, b] = utils_1$q.split(Buffer$f.from(a, "hex"), 4), F = utils_1$q.getCRCHex(A);
  return assert_1$2.default(F === b.toString("hex"), "Invalid Checksum"), A.toString("hex");
}, decode$c = (n, c = STYLES.MINIMAL) => {
  switch (c) {
    case STYLES.STANDARD:
      return _decode(n, " ", BYTEWORD_LENGTH);
    case STYLES.URI:
      return _decode(n, "-", BYTEWORD_LENGTH);
    case STYLES.MINIMAL:
      return _decode(n, "", MINIMAL_BYTEWORD_LENGTH);
    default:
      throw new Error(`Invalid style ${c}`);
  }
}, encode$b = (n, c = STYLES.MINIMAL) => {
  switch (c) {
    case STYLES.STANDARD:
      return encodeWithSeparator(n, " ");
    case STYLES.URI:
      return encodeWithSeparator(n, "-");
    case STYLES.MINIMAL:
      return encodeMinimal(n);
    default:
      throw new Error(`Invalid style ${c}`);
  }
};
bytewords$1.default = {
  decode: decode$c,
  encode: encode$b,
  STYLES
};
var __importDefault$e = commonjsGlobal && commonjsGlobal.__importDefault || function(n) {
  return n && n.__esModule ? n : { default: n };
};
Object.defineProperty(urEncoder, "__esModule", { value: !0 });
const fountainEncoder_1$1 = __importDefault$e(fountainEncoder), bytewords_1$1 = __importDefault$e(bytewords$1);
class UREncoder {
  constructor(c, u, p, a) {
    this.ur = c, this.fountainEncoder = new fountainEncoder_1$1.default(c.cbor, u, p, a);
  }
  get fragmentsLength() {
    return this.fountainEncoder.fragmentsLength;
  }
  get fragments() {
    return this.fountainEncoder.fragments;
  }
  get messageLength() {
    return this.fountainEncoder.messageLength;
  }
  get cbor() {
    return this.ur.cbor;
  }
  encodeWhole() {
    return [...new Array(this.fragmentsLength)].map(() => this.nextPart());
  }
  nextPart() {
    const c = this.fountainEncoder.nextPart();
    return this.fountainEncoder.isSinglePart() ? UREncoder.encodeSinglePart(this.ur) : UREncoder.encodePart(this.ur.type, c);
  }
  static encodeUri(c, u) {
    const p = u.join("/");
    return [c, p].join(":");
  }
  static encodeUR(c) {
    return UREncoder.encodeUri("ur", c);
  }
  static encodePart(c, u) {
    const p = `${u.seqNum}-${u.seqLength}`, a = bytewords_1$1.default.encode(u.cbor().toString("hex"), bytewords_1$1.default.STYLES.MINIMAL);
    return UREncoder.encodeUR([c, p, a]);
  }
  static encodeSinglePart(c) {
    const u = bytewords_1$1.default.encode(c.cbor.toString("hex"), bytewords_1$1.default.STYLES.MINIMAL);
    return UREncoder.encodeUR([c.type, u]);
  }
}
urEncoder.default = UREncoder;
var urDecoder = {}, fountainDecoder = {};
Object.defineProperty(fountainDecoder, "__esModule", { value: !0 });
fountainDecoder.FountainDecoderPart = void 0;
const utils_1$p = utils$I, fountainUtils_1 = fountainUtils, errors_1$4 = errors$f;
class FountainDecoderPart {
  constructor(c, u) {
    this._indexes = c, this._fragment = u;
  }
  get indexes() {
    return this._indexes;
  }
  get fragment() {
    return this._fragment;
  }
  static fromEncoderPart(c) {
    const u = fountainUtils_1.chooseFragments(c.seqNum, c.seqLength, c.checksum), p = c.fragment;
    return new FountainDecoderPart(u, p);
  }
  isSimple() {
    return this.indexes.length === 1;
  }
}
fountainDecoder.FountainDecoderPart = FountainDecoderPart;
class FountainDecoder {
  constructor() {
    this.result = void 0, this.expectedMessageLength = 0, this.expectedChecksum = 0, this.expectedFragmentLength = 0, this.processedPartsCount = 0, this.expectedPartIndexes = [], this.lastPartIndexes = [], this.queuedParts = [], this.receivedPartIndexes = [], this.mixedParts = [], this.simpleParts = [];
  }
  validatePart(c) {
    if (this.expectedPartIndexes.length === 0)
      [...new Array(c.seqLength)].forEach((u, p) => this.expectedPartIndexes.push(p)), this.expectedMessageLength = c.messageLength, this.expectedChecksum = c.checksum, this.expectedFragmentLength = c.fragment.length;
    else if (this.expectedPartIndexes.length !== c.seqLength || this.expectedMessageLength !== c.messageLength || this.expectedChecksum !== c.checksum || this.expectedFragmentLength !== c.fragment.length)
      return !1;
    return !0;
  }
  reducePartByPart(c, u) {
    if (utils_1$p.arrayContains(c.indexes, u.indexes)) {
      const p = utils_1$p.setDifference(c.indexes, u.indexes), a = utils_1$p.bufferXOR(c.fragment, u.fragment);
      return new FountainDecoderPart(p, a);
    } else
      return c;
  }
  reduceMixedBy(c) {
    const u = [];
    this.mixedParts.map(({ value: p }) => this.reducePartByPart(p, c)).forEach((p) => {
      p.isSimple() ? this.queuedParts.push(p) : u.push({ key: p.indexes, value: p });
    }), this.mixedParts = u;
  }
  processSimplePart(c) {
    const u = c.indexes[0];
    if (!this.receivedPartIndexes.includes(u))
      if (this.simpleParts.push({ key: c.indexes, value: c }), this.receivedPartIndexes.push(u), utils_1$p.arraysEqual(this.receivedPartIndexes, this.expectedPartIndexes)) {
        const p = this.simpleParts.map(({ value: b }) => b).sort((b, F) => b.indexes[0] - F.indexes[0]), a = FountainDecoder.joinFragments(p.map((b) => b.fragment), this.expectedMessageLength);
        utils_1$p.getCRC(a) === this.expectedChecksum ? this.result = a : this.error = new errors_1$4.InvalidChecksumError();
      } else
        this.reduceMixedBy(c);
  }
  processMixedPart(c) {
    if (this.mixedParts.some(({ key: p }) => utils_1$p.arraysEqual(p, c.indexes)))
      return;
    let u = this.simpleParts.reduce((p, { value: a }) => this.reducePartByPart(p, a), c);
    u = this.mixedParts.reduce((p, { value: a }) => this.reducePartByPart(p, a), u), u.isSimple() ? this.queuedParts.push(u) : (this.reduceMixedBy(u), this.mixedParts.push({ key: u.indexes, value: u }));
  }
  processQueuedItem() {
    if (this.queuedParts.length === 0)
      return;
    const c = this.queuedParts.shift();
    c.isSimple() ? this.processSimplePart(c) : this.processMixedPart(c);
  }
  receivePart(c) {
    if (this.isComplete() || !this.validatePart(c))
      return !1;
    const u = FountainDecoderPart.fromEncoderPart(c);
    for (this.lastPartIndexes = u.indexes, this.queuedParts.push(u); !this.isComplete() && this.queuedParts.length > 0; )
      this.processQueuedItem();
    return this.processedPartsCount += 1, !0;
  }
  isComplete() {
    return this.result !== void 0 && this.result.length > 0;
  }
  isSuccess() {
    return !!(this.error === void 0 && this.isComplete());
  }
  resultMessage() {
    return this.isSuccess() ? this.result : Buffer$f.from([]);
  }
  isFailure() {
    return this.error !== void 0;
  }
  resultError() {
    return this.error ? this.error.message : "";
  }
  expectedPartCount() {
    return this.expectedPartIndexes.length;
  }
  getExpectedPartIndexes() {
    return [...this.expectedPartIndexes];
  }
  getReceivedPartIndexes() {
    return [...this.receivedPartIndexes];
  }
  getLastPartIndexes() {
    return [...this.lastPartIndexes];
  }
  estimatedPercentComplete() {
    if (this.isComplete())
      return 1;
    const c = this.expectedPartCount();
    return c === 0 ? 0 : Math.min(0.99, this.processedPartsCount / (c * 1.75));
  }
  getProgress() {
    if (this.isComplete())
      return 1;
    const c = this.expectedPartCount();
    return c === 0 ? 0 : this.receivedPartIndexes.length / c;
  }
}
fountainDecoder.default = FountainDecoder;
FountainDecoder.joinFragments = (n, c) => Buffer$f.concat(n).slice(0, c);
var __importDefault$d = commonjsGlobal && commonjsGlobal.__importDefault || function(n) {
  return n && n.__esModule ? n : { default: n };
};
Object.defineProperty(urDecoder, "__esModule", { value: !0 });
const fountainDecoder_1 = __importDefault$d(fountainDecoder), bytewords_1 = __importDefault$d(bytewords$1), assert_1$1 = __importDefault$d(requireAssert()), utils_1$o = utils$I, errors_1$3 = errors$f, ur_1$e = __importDefault$d(ur$1), fountainEncoder_1 = fountainEncoder;
class URDecoder {
  constructor(c = new fountainDecoder_1.default(), u = "bytes") {
    this.fountainDecoder = c, this.type = u, assert_1$1.default(utils_1$o.isURType(u), "Invalid UR type"), this.expected_type = "";
  }
  static decodeBody(c, u) {
    const p = bytewords_1.default.decode(u, bytewords_1.default.STYLES.MINIMAL);
    return new ur_1$e.default(Buffer$f.from(p, "hex"), c);
  }
  validatePart(c) {
    return this.expected_type ? this.expected_type === c : utils_1$o.isURType(c) ? (this.expected_type = c, !0) : !1;
  }
  static decode(c) {
    const [u, p] = this.parse(c);
    if (p.length === 0)
      throw new errors_1$3.InvalidPathLengthError();
    const a = p[0];
    return URDecoder.decodeBody(u, a);
  }
  static parse(c) {
    const u = c.toLowerCase();
    if (u.slice(0, 3) !== "ur:")
      throw new errors_1$3.InvalidSchemeError();
    const a = u.slice(3).split("/"), A = a[0];
    if (a.length < 2)
      throw new errors_1$3.InvalidPathLengthError();
    if (!utils_1$o.isURType(A))
      throw new errors_1$3.InvalidTypeError();
    return [A, a.slice(1)];
  }
  static parseSequenceComponent(c) {
    const u = c.split("-");
    if (u.length !== 2)
      throw new errors_1$3.InvalidSequenceComponentError();
    const p = utils_1$o.toUint32(Number(u[0])), a = Number(u[1]);
    if (p < 1 || a < 1)
      throw new errors_1$3.InvalidSequenceComponentError();
    return [p, a];
  }
  receivePart(c) {
    if (this.result !== void 0)
      return !1;
    const [u, p] = URDecoder.parse(c);
    if (!this.validatePart(u))
      return !1;
    if (p.length === 1)
      return this.result = URDecoder.decodeBody(u, p[0]), !0;
    if (p.length !== 2)
      throw new errors_1$3.InvalidPathLengthError();
    const [a, A] = p, [b, F] = URDecoder.parseSequenceComponent(a), le = bytewords_1.default.decode(A, bytewords_1.default.STYLES.MINIMAL), L = fountainEncoder_1.FountainEncoderPart.fromCBOR(le);
    return b !== L.seqNum || F !== L.seqLength || !this.fountainDecoder.receivePart(L) ? !1 : (this.fountainDecoder.isSuccess() ? this.result = new ur_1$e.default(this.fountainDecoder.resultMessage(), u) : this.fountainDecoder.isFailure() && (this.error = new errors_1$3.InvalidSchemeError()), !0);
  }
  resultUR() {
    return this.result ? this.result : new ur_1$e.default(Buffer$f.from([]));
  }
  isComplete() {
    return this.result && this.result.cbor.length > 0;
  }
  isSuccess() {
    return !this.error && this.isComplete();
  }
  isError() {
    return this.error !== void 0;
  }
  resultError() {
    return this.error ? this.error.message : "";
  }
  expectedPartCount() {
    return this.fountainDecoder.expectedPartCount();
  }
  expectedPartIndexes() {
    return this.fountainDecoder.getExpectedPartIndexes();
  }
  receivedPartIndexes() {
    return this.fountainDecoder.getReceivedPartIndexes();
  }
  lastPartIndexes() {
    return this.fountainDecoder.getLastPartIndexes();
  }
  estimatedPercentComplete() {
    return this.fountainDecoder.estimatedPercentComplete();
  }
  getProgress() {
    return this.fountainDecoder.getProgress();
  }
}
urDecoder.default = URDecoder;
var __importDefault$c = commonjsGlobal && commonjsGlobal.__importDefault || function(n) {
  return n && n.__esModule ? n : { default: n };
};
Object.defineProperty(dist$t, "__esModule", { value: !0 });
dist$t.URDecoder = dist$t.UREncoder = dist$t.UR = void 0;
const ur_1$d = __importDefault$c(ur$1);
dist$t.UR = ur_1$d.default;
const urEncoder_1 = __importDefault$c(urEncoder);
dist$t.UREncoder = urEncoder_1.default;
const urDecoder_1 = __importDefault$c(urDecoder);
dist$t.URDecoder = urDecoder_1.default;
Object.defineProperty(RegistryItem$d, "__esModule", { value: !0 });
RegistryItem$d.RegistryItem = void 0;
const bc_ur_1$1 = dist$t, lib_1$8 = lib$f;
let RegistryItem$c = class {
  constructor() {
    this.toCBOR = () => {
      if (this.toDataItem() === void 0)
        throw new Error(`#[ur-registry][RegistryItem][fn.toCBOR]: registry ${this.getRegistryType()}'s method toDataItem returns undefined`);
      return (0, lib_1$8.encodeDataItem)(this.toDataItem());
    }, this.toUR = () => new bc_ur_1$1.UR(this.toCBOR(), this.getRegistryType().getType()), this.toUREncoder = (c, u, p) => {
      const a = this.toUR();
      return new bc_ur_1$1.UREncoder(a, c, u, p);
    };
  }
};
RegistryItem$d.RegistryItem = RegistryItem$c;
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.CryptoCoinInfo = n.Network = n.Type = void 0;
  const c = lib$f, u = RegistryItem$d, p = RegistryType$d;
  var a;
  (function(le) {
    le.type = "1", le.network = "2";
  })(a || (a = {}));
  var A;
  (function(le) {
    le[le.bitcoin = 0] = "bitcoin";
  })(A = n.Type || (n.Type = {}));
  var b;
  (function(le) {
    le[le.mainnet = 0] = "mainnet", le[le.testnet = 1] = "testnet";
  })(b = n.Network || (n.Network = {}));
  class F extends u.RegistryItem {
    constructor(L, pe) {
      super(), this.type = L, this.network = pe, this.getRegistryType = () => p.RegistryTypes.CRYPTO_COIN_INFO, this.getType = () => this.type || A.bitcoin, this.getNetwork = () => this.network || b.mainnet, this.toDataItem = () => {
        const $ = {};
        return this.type && ($[a.type] = this.type), this.network && ($[a.network] = this.network), new c.DataItem($);
      };
    }
  }
  n.CryptoCoinInfo = F, F.fromDataItem = (le) => {
    const L = le.getData(), pe = L[a.type], $ = L[a.network];
    return new F(pe, $);
  }, F.fromCBOR = (le) => {
    const L = (0, c.decodeToDataItem)(le);
    return F.fromDataItem(L);
  };
})(CryptoCoinInfo$c);
var CryptoKeypath$d = {}, PathComponent$d = {};
Object.defineProperty(PathComponent$d, "__esModule", { value: !0 });
PathComponent$d.PathComponent = void 0;
let PathComponent$c = class Yp {
  constructor(c) {
    if (this.getIndex = () => this.index, this.isWildcard = () => this.wildcard, this.isHardened = () => this.hardened, this.index = c.index, this.hardened = c.hardened, this.index !== void 0 ? this.wildcard = !1 : this.wildcard = !0, this.index && this.index & Yp.HARDENED_BIT)
      throw new Error(`#[ur-registry][PathComponent][fn.constructor]: Invalid index ${this.index} - most significant bit cannot be set`);
  }
};
PathComponent$d.PathComponent = PathComponent$c;
PathComponent$c.HARDENED_BIT = 2147483648;
Object.defineProperty(CryptoKeypath$d, "__esModule", { value: !0 });
CryptoKeypath$d.CryptoKeypath = void 0;
const lib_1$7 = lib$f, PathComponent_1 = PathComponent$d, RegistryItem_1$8 = RegistryItem$d, RegistryType_1$8 = RegistryType$d;
var Keys$5;
(function(n) {
  n[n.components = 1] = "components", n[n.source_fingerprint = 2] = "source_fingerprint", n[n.depth = 3] = "depth";
})(Keys$5 || (Keys$5 = {}));
let CryptoKeypath$c = class extends RegistryItem_1$8.RegistryItem {
  constructor(c = [], u, p) {
    super(), this.components = c, this.sourceFingerprint = u, this.depth = p, this.getRegistryType = () => RegistryType_1$8.RegistryTypes.CRYPTO_KEYPATH, this.getPath = () => this.components.length === 0 ? void 0 : this.components.map((A) => `${A.isWildcard() ? "*" : A.getIndex()}${A.isHardened() ? "'" : ""}`).join("/"), this.getComponents = () => this.components, this.getSourceFingerprint = () => this.sourceFingerprint, this.getDepth = () => this.depth, this.toDataItem = () => {
      const a = {}, A = [];
      return this.components && this.components.forEach((b) => {
        b.isWildcard() ? A.push([]) : A.push(b.getIndex()), A.push(b.isHardened());
      }), a[Keys$5.components] = A, this.sourceFingerprint && (a[Keys$5.source_fingerprint] = this.sourceFingerprint.readUInt32BE(0)), this.depth !== void 0 && (a[Keys$5.depth] = this.depth), new lib_1$7.DataItem(a);
    };
  }
};
CryptoKeypath$d.CryptoKeypath = CryptoKeypath$c;
CryptoKeypath$c.fromDataItem = (n) => {
  const c = n.getData(), u = [], p = c[Keys$5.components];
  if (p)
    for (let F = 0; F < p.length; F += 2) {
      const le = p[F + 1], L = p[F];
      typeof L == "number" ? u.push(new PathComponent_1.PathComponent({ index: L, hardened: le })) : u.push(new PathComponent_1.PathComponent({ hardened: le }));
    }
  const a = c[Keys$5.source_fingerprint];
  let A;
  a && (A = Buffer$f.alloc(4), A.writeUInt32BE(a, 0));
  const b = c[Keys$5.depth];
  return new CryptoKeypath$c(u, A, b);
};
CryptoKeypath$c.fromCBOR = (n) => {
  const c = (0, lib_1$7.decodeToDataItem)(n);
  return CryptoKeypath$c.fromDataItem(c);
};
Object.defineProperty(CryptoHDKey$d, "__esModule", { value: !0 });
CryptoHDKey$d.CryptoHDKey = void 0;
const bs58check_1$2 = bs58check$g, CryptoCoinInfo_1 = CryptoCoinInfo$c, CryptoKeypath_1 = CryptoKeypath$d, lib_1$6 = lib$f, RegistryItem_1$7 = RegistryItem$d, RegistryType_1$7 = RegistryType$d;
var Keys$4;
(function(n) {
  n[n.is_master = 1] = "is_master", n[n.is_private = 2] = "is_private", n[n.key_data = 3] = "key_data", n[n.chain_code = 4] = "chain_code", n[n.use_info = 5] = "use_info", n[n.origin = 6] = "origin", n[n.children = 7] = "children", n[n.parent_fingerprint = 8] = "parent_fingerprint", n[n.name = 9] = "name", n[n.note = 10] = "note";
})(Keys$4 || (Keys$4 = {}));
let CryptoHDKey$c = class extends RegistryItem_1$7.RegistryItem {
  constructor(c) {
    super(), this.isECKey = () => !1, this.getKey = () => this.key, this.getChainCode = () => this.chainCode, this.isMaster = () => this.master, this.isPrivateKey = () => !!this.privateKey, this.getUseInfo = () => this.useInfo, this.getOrigin = () => this.origin, this.getChildren = () => this.children, this.getParentFingerprint = () => this.parentFingerprint, this.getName = () => this.name, this.getNote = () => this.note, this.getBip32Key = () => {
      var u, p, a;
      let A, b, F = 0, le = Buffer$f.alloc(4).fill(0);
      if (this.isMaster())
        A = Buffer$f.from("0488ADE4", "hex"), b = 0, F = 0;
      else {
        b = ((u = this.getOrigin()) === null || u === void 0 ? void 0 : u.getComponents().length) || ((p = this.getOrigin()) === null || p === void 0 ? void 0 : p.getDepth());
        const be = (a = this.getOrigin()) === null || a === void 0 ? void 0 : a.getComponents(), He = be[be.length - 1];
        He && (F = He.isHardened() ? He.getIndex() + 2147483648 : He.getIndex(), this.getParentFingerprint() && (le = this.getParentFingerprint())), this.isPrivateKey() ? A = Buffer$f.from("0488ADE4", "hex") : A = Buffer$f.from("0488B21E", "hex");
      }
      const L = Buffer$f.alloc(1);
      L.writeUInt8(b, 0);
      const pe = Buffer$f.alloc(4);
      pe.writeUInt32BE(F, 0);
      const $ = this.getChainCode(), Ee = this.getKey();
      return (0, bs58check_1$2.encode)(Buffer$f.concat([A, L, le, pe, $, Ee]));
    }, this.getRegistryType = () => RegistryType_1$7.RegistryTypes.CRYPTO_HDKEY, this.getOutputDescriptorContent = () => {
      var u, p, a, A, b, F, le;
      let L = "";
      return this.getOrigin() && !((u = this.getOrigin()) === null || u === void 0) && u.getSourceFingerprint() && !((p = this.getOrigin()) === null || p === void 0) && p.getPath() && (L += `${(A = (a = this.getOrigin()) === null || a === void 0 ? void 0 : a.getSourceFingerprint()) === null || A === void 0 ? void 0 : A.toString("hex")}/${(b = this.getOrigin()) === null || b === void 0 ? void 0 : b.getPath()}`), L += this.getBip32Key(), this.getChildren() && !((F = this.getChildren()) === null || F === void 0) && F.getPath() && (L += `/${(le = this.getChildren()) === null || le === void 0 ? void 0 : le.getPath()}`), L;
    }, this.setupMasterKey = (u) => {
      this.master = !0, this.key = u.key, this.chainCode = u.chainCode;
    }, this.setupDeriveKey = (u) => {
      this.master = !1, this.privateKey = u.isPrivateKey, this.key = u.key, this.chainCode = u.chainCode, this.useInfo = u.useInfo, this.origin = u.origin, this.children = u.children, this.parentFingerprint = u.parentFingerprint, this.name = u.name, this.note = u.note;
    }, this.toDataItem = () => {
      const u = {};
      if (this.master)
        u[Keys$4.is_master] = !0, u[Keys$4.key_data] = this.key, u[Keys$4.chain_code] = this.chainCode;
      else {
        if (this.privateKey !== void 0 && (u[Keys$4.is_private] = this.privateKey), u[Keys$4.key_data] = this.key, this.chainCode && (u[Keys$4.chain_code] = this.chainCode), this.useInfo) {
          const p = this.useInfo.toDataItem();
          p.setTag(this.useInfo.getRegistryType().getTag()), u[Keys$4.use_info] = p;
        }
        if (this.origin) {
          const p = this.origin.toDataItem();
          p.setTag(this.origin.getRegistryType().getTag()), u[Keys$4.origin] = p;
        }
        if (this.children) {
          const p = this.children.toDataItem();
          p.setTag(this.children.getRegistryType().getTag()), u[Keys$4.children] = p;
        }
        this.parentFingerprint && (u[Keys$4.parent_fingerprint] = this.parentFingerprint.readUInt32BE(0)), this.name !== void 0 && (u[Keys$4.name] = this.name), this.note !== void 0 && (u[Keys$4.note] = this.note);
      }
      return new lib_1$6.DataItem(u);
    }, c.isMaster ? this.setupMasterKey(c) : this.setupDeriveKey(c);
  }
};
CryptoHDKey$d.CryptoHDKey = CryptoHDKey$c;
CryptoHDKey$c.fromDataItem = (n) => {
  const c = n.getData(), u = !!c[Keys$4.is_master], p = c[Keys$4.is_private], a = c[Keys$4.key_data], A = c[Keys$4.chain_code], b = c[Keys$4.use_info] ? CryptoCoinInfo_1.CryptoCoinInfo.fromDataItem(c[Keys$4.use_info]) : void 0, F = c[Keys$4.origin] ? CryptoKeypath_1.CryptoKeypath.fromDataItem(c[Keys$4.origin]) : void 0, le = c[Keys$4.children] ? CryptoKeypath_1.CryptoKeypath.fromDataItem(c[Keys$4.children]) : void 0, L = c[Keys$4.parent_fingerprint];
  let pe;
  L && (pe = Buffer$f.alloc(4), pe.writeUInt32BE(L, 0));
  const $ = c[Keys$4.name], Ee = c[Keys$4.note];
  return new CryptoHDKey$c({
    isMaster: u,
    isPrivateKey: p,
    key: a,
    chainCode: A,
    useInfo: b,
    origin: F,
    children: le,
    parentFingerprint: pe,
    name: $,
    note: Ee
  });
};
CryptoHDKey$c.fromCBOR = (n) => {
  const c = (0, lib_1$6.decodeToDataItem)(n);
  return CryptoHDKey$c.fromDataItem(c);
};
var CryptoECKey$d = {};
Object.defineProperty(CryptoECKey$d, "__esModule", { value: !0 });
CryptoECKey$d.CryptoECKey = void 0;
const lib_1$5 = lib$f, RegistryItem_1$6 = RegistryItem$d, RegistryType_1$6 = RegistryType$d;
var Keys$3;
(function(n) {
  n[n.curve = 1] = "curve", n[n.private = 2] = "private", n[n.data = 3] = "data";
})(Keys$3 || (Keys$3 = {}));
let CryptoECKey$c = class extends RegistryItem_1$6.RegistryItem {
  constructor(c) {
    super(), this.isECKey = () => !0, this.getCurve = () => this.curve || 0, this.isPrivateKey = () => this.privateKey || !1, this.getData = () => this.data, this.getRegistryType = () => RegistryType_1$6.RegistryTypes.CRYPTO_ECKEY, this.toDataItem = () => {
      const u = {};
      return this.curve && (u[Keys$3.curve] = this.curve), this.privateKey !== void 0 && (u[Keys$3.private] = this.privateKey), u[Keys$3.data] = this.data, new lib_1$5.DataItem(u);
    }, this.getOutputDescriptorContent = () => this.data.toString("hex"), this.data = c.data, this.curve = c.curve, this.privateKey = c.privateKey || void 0;
  }
};
CryptoECKey$d.CryptoECKey = CryptoECKey$c;
CryptoECKey$c.fromDataItem = (n) => {
  const c = n.getData(), u = c[Keys$3.curve], p = c[Keys$3.private], a = c[Keys$3.data];
  if (!a)
    throw new Error(`#[ur-registry][CryptoECKey][fn.fromDataItem]: decoded [dataItem][#data.data] is undefined: ${n}`);
  return new CryptoECKey$c({ data: a, curve: u, privateKey: p });
};
CryptoECKey$c.fromCBOR = (n) => {
  const c = (0, lib_1$5.decodeToDataItem)(n);
  return CryptoECKey$c.fromDataItem(c);
};
var Bytes$e = {};
Object.defineProperty(Bytes$e, "__esModule", { value: !0 });
Bytes$e.Bytes = void 0;
const lib_1$4 = lib$f, RegistryItem_1$5 = RegistryItem$d, RegistryType_1$5 = RegistryType$d;
let Bytes$d = class extends RegistryItem_1$5.RegistryItem {
  constructor(c) {
    super(), this.bytes = c, this.getRegistryType = () => RegistryType_1$5.RegistryTypes.BYTES, this.getData = () => this.bytes, this.toDataItem = () => new lib_1$4.DataItem(this.bytes);
  }
};
Bytes$e.Bytes = Bytes$d;
Bytes$d.fromDataItem = (n) => {
  const c = n.getData();
  if (!c)
    throw new Error(`#[ur-registry][Bytes][fn.fromDataItem]: decoded [dataItem][#data] is undefined: ${n}`);
  return new Bytes$d(c);
};
Bytes$d.fromCBOR = (n) => {
  const c = (0, lib_1$4.decodeToDataItem)(n);
  return Bytes$d.fromDataItem(c);
};
var CryptoOutput$d = {}, MultiKey$d = {};
Object.defineProperty(MultiKey$d, "__esModule", { value: !0 });
MultiKey$d.MultiKey = void 0;
const CryptoECKey_1$1 = CryptoECKey$d, CryptoHDKey_1$2 = CryptoHDKey$d, DataItem_1 = DataItem$d, RegistryItem_1$4 = RegistryItem$d, RegistryType_1$4 = RegistryType$d;
var Keys$2;
(function(n) {
  n[n.threshold = 1] = "threshold", n[n.keys = 2] = "keys";
})(Keys$2 || (Keys$2 = {}));
let MultiKey$c = class extends RegistryItem_1$4.RegistryItem {
  constructor(c, u) {
    super(), this.threshold = c, this.keys = u, this.getThreshold = () => this.threshold, this.getKeys = () => this.keys, this.toDataItem = () => {
      const p = {};
      p[Keys$2.threshold] = this.threshold;
      const a = this.keys.map((A) => {
        const b = A.toDataItem();
        return b.setTag(A.getRegistryType().getTag()), b;
      });
      return p[Keys$2.keys] = a, new DataItem_1.DataItem(p);
    }, this.getOutputDescriptorContent = () => [
      this.getThreshold(),
      this.keys.map((p) => p.getOutputDescriptorContent()).join(",")
    ].join(",");
  }
};
MultiKey$d.MultiKey = MultiKey$c;
MultiKey$c.fromDataItem = (n) => {
  const c = n.getData(), u = c[Keys$2.threshold], p = c[Keys$2.keys], a = [];
  return p.forEach((A) => {
    A.getTag() === RegistryType_1$4.RegistryTypes.CRYPTO_HDKEY.getTag() ? a.push(CryptoHDKey_1$2.CryptoHDKey.fromDataItem(A)) : A.getTag() === RegistryType_1$4.RegistryTypes.CRYPTO_ECKEY.getTag() && a.push(CryptoECKey_1$1.CryptoECKey.fromDataItem(A));
  }), new MultiKey$c(u, a);
};
Object.defineProperty(CryptoOutput$d, "__esModule", { value: !0 });
CryptoOutput$d.CryptoOutput = void 0;
const CryptoECKey_1 = CryptoECKey$d, CryptoHDKey_1$1 = CryptoHDKey$d, lib_1$3 = lib$f, MultiKey_1 = MultiKey$d, RegistryItem_1$3 = RegistryItem$d, RegistryType_1$3 = RegistryType$d, ScriptExpression_1 = ScriptExpression$c;
let CryptoOutput$c = class extends RegistryItem_1$3.RegistryItem {
  constructor(c, u) {
    super(), this.scriptExpressions = c, this.cryptoKey = u, this.getRegistryType = () => RegistryType_1$3.RegistryTypes.CRYPTO_OUTPUT, this.getCryptoKey = () => this.cryptoKey, this.getHDKey = () => {
      if (this.cryptoKey instanceof CryptoHDKey_1$1.CryptoHDKey)
        return this.cryptoKey;
    }, this.getECKey = () => {
      if (this.cryptoKey instanceof CryptoECKey_1.CryptoECKey)
        return this.cryptoKey;
    }, this.getMultiKey = () => {
      if (this.cryptoKey instanceof MultiKey_1.MultiKey)
        return this.cryptoKey;
    }, this.getScriptExpressions = () => this.scriptExpressions, this._toOutputDescriptor = (p) => p >= this.scriptExpressions.length ? this.cryptoKey.getOutputDescriptorContent() : `${this.scriptExpressions[p].getExpression()}(${this._toOutputDescriptor(p + 1)})`, this.toString = () => this._toOutputDescriptor(0), this.toDataItem = () => {
      let p = this.cryptoKey.toDataItem();
      return (this.cryptoKey instanceof CryptoECKey_1.CryptoECKey || this.cryptoKey instanceof CryptoHDKey_1$1.CryptoHDKey) && p.setTag(this.cryptoKey.getRegistryType().getTag()), [...this.scriptExpressions].reverse().forEach((A) => {
        const b = A.getTag();
        p.getTag() === void 0 ? p.setTag(b) : p = new lib_1$3.DataItem(p, b);
      }), p;
    };
  }
};
CryptoOutput$d.CryptoOutput = CryptoOutput$c;
CryptoOutput$c.fromDataItem = (n) => {
  const c = [];
  let u = n;
  for (; ; ) {
    let A = u.getTag();
    const b = ScriptExpression_1.ScriptExpression.fromTag(A);
    if (b)
      if (c.push(b), u.getData() instanceof lib_1$3.DataItem)
        u = u.getData(), A = u.getTag();
      else
        break;
    else
      break;
  }
  const p = c.length;
  if (p > 0 && (c[p - 1].getExpression() === ScriptExpression_1.ScriptExpressions.MULTISIG.getExpression() || c[p - 1].getExpression() === ScriptExpression_1.ScriptExpressions.SORTED_MULTISIG.getExpression())) {
    const A = MultiKey_1.MultiKey.fromDataItem(u);
    return new CryptoOutput$c(c, A);
  }
  if (u.getTag() === RegistryType_1$3.RegistryTypes.CRYPTO_HDKEY.getTag()) {
    const A = CryptoHDKey_1$1.CryptoHDKey.fromDataItem(u);
    return new CryptoOutput$c(c, A);
  } else {
    const A = CryptoECKey_1.CryptoECKey.fromDataItem(u);
    return new CryptoOutput$c(c, A);
  }
};
CryptoOutput$c.fromCBOR = (n) => {
  const c = (0, lib_1$3.decodeToDataItem)(n);
  return CryptoOutput$c.fromDataItem(c);
};
var CryptoPSBT$d = {};
Object.defineProperty(CryptoPSBT$d, "__esModule", { value: !0 });
CryptoPSBT$d.CryptoPSBT = void 0;
const lib_1$2 = lib$f, RegistryItem_1$2 = RegistryItem$d, RegistryType_1$2 = RegistryType$d;
let CryptoPSBT$c = class extends RegistryItem_1$2.RegistryItem {
  constructor(c) {
    super(), this.psbt = c, this.getRegistryType = () => RegistryType_1$2.RegistryTypes.CRYPTO_PSBT, this.getPSBT = () => this.psbt, this.toDataItem = () => new lib_1$2.DataItem(this.psbt);
  }
};
CryptoPSBT$d.CryptoPSBT = CryptoPSBT$c;
CryptoPSBT$c.fromDataItem = (n) => {
  const c = n.getData();
  if (!c)
    throw new Error(`#[ur-registry][CryptoPSBT][fn.fromDataItem]: decoded [dataItem][#data] is undefined: ${n}`);
  return new CryptoPSBT$c(c);
};
CryptoPSBT$c.fromCBOR = (n) => {
  const c = (0, lib_1$2.decodeToDataItem)(n);
  return CryptoPSBT$c.fromDataItem(c);
};
var CryptoAccount$c = {}, hasRequiredCryptoAccount$c;
function requireCryptoAccount$c() {
  if (hasRequiredCryptoAccount$c) return CryptoAccount$c;
  hasRequiredCryptoAccount$c = 1, Object.defineProperty(CryptoAccount$c, "__esModule", { value: !0 }), CryptoAccount$c.CryptoAccount = void 0;
  const n = requireDist$c(), c = lib$f, u = RegistryItem$d, p = RegistryType$d;
  var a;
  (function(b) {
    b[b.masterFingerprint = 1] = "masterFingerprint", b[b.outputDescriptors = 2] = "outputDescriptors";
  })(a || (a = {}));
  class A extends u.RegistryItem {
    constructor(F, le) {
      super(), this.masterFingerprint = F, this.outputDescriptors = le, this.getRegistryType = () => p.RegistryTypes.CRYPTO_ACCOUNT, this.getMasterFingerprint = () => this.masterFingerprint, this.getOutputDescriptors = () => this.outputDescriptors, this.toDataItem = () => {
        const L = {};
        return this.masterFingerprint && (L[a.masterFingerprint] = this.masterFingerprint.readUInt32BE(0)), this.outputDescriptors && (L[a.outputDescriptors] = this.outputDescriptors.map((pe) => pe.toDataItem())), new c.DataItem(L);
      };
    }
  }
  return CryptoAccount$c.CryptoAccount = A, A.fromDataItem = (b) => {
    const F = b.getData(), le = Buffer$f.alloc(4), L = F[a.masterFingerprint];
    L && le.writeUInt32BE(L, 0);
    const $ = F[a.outputDescriptors].map((Ee) => n.CryptoOutput.fromDataItem(Ee));
    return new A(le, $);
  }, A.fromCBOR = (b) => {
    const F = (0, c.decodeToDataItem)(b);
    return A.fromDataItem(F);
  }, CryptoAccount$c;
}
var Decoder$c = {}, errors$d = {};
Object.defineProperty(errors$d, "__esModule", { value: !0 });
errors$d.UnknownURTypeError = void 0;
class UnknownURTypeError extends Error {
  constructor(c) {
    super(c);
  }
}
errors$d.UnknownURTypeError = UnknownURTypeError;
var hasRequiredDecoder$c;
function requireDecoder$c() {
  if (hasRequiredDecoder$c) return Decoder$c;
  hasRequiredDecoder$c = 1, Object.defineProperty(Decoder$c, "__esModule", { value: !0 }), Decoder$c.URRegistryDecoder = void 0;
  const n = dist$t, c = requireDist$c(), u = RegistryType$d, p = errors$d;
  class a extends n.URDecoder {
    constructor() {
      super(...arguments), this.resultRegistryType = () => {
        const b = this.resultUR();
        switch (b.type) {
          case u.RegistryTypes.BYTES.getType():
            return c.Bytes.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_HDKEY.getType():
            return c.CryptoHDKey.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_KEYPATH.getType():
            return c.CryptoKeypath.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_COIN_INFO.getType():
            return c.CryptoCoinInfo.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_ECKEY.getType():
            return c.CryptoECKey.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_OUTPUT.getType():
            return c.CryptoOutput.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_PSBT.getType():
            return c.CryptoPSBT.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_ACCOUNT.getType():
            return c.CryptoAccount.fromCBOR(b.cbor);
          default:
            throw new p.UnknownURTypeError(`#[ur-registry][Decoder][fn.resultRegistryType]: registry type ${b.type} is not supported now`);
        }
      };
    }
  }
  return Decoder$c.URRegistryDecoder = a, Decoder$c;
}
var CryptoMultiAccounts$d = {};
Object.defineProperty(CryptoMultiAccounts$d, "__esModule", { value: !0 });
CryptoMultiAccounts$d.CryptoMultiAccounts = void 0;
const RegistryType_1$1 = RegistryType$d, CryptoHDKey_1 = CryptoHDKey$d, RegistryItem_1$1 = RegistryItem$d, lib_1$1 = lib$f;
var Keys$1;
(function(n) {
  n[n.masterFingerprint = 1] = "masterFingerprint", n[n.keys = 2] = "keys", n[n.device = 3] = "device", n[n.deviceId = 4] = "deviceId", n[n.version = 5] = "version";
})(Keys$1 || (Keys$1 = {}));
let CryptoMultiAccounts$c = class extends RegistryItem_1$1.RegistryItem {
  constructor(c, u, p, a, A) {
    super(), this.masterFingerprint = c, this.keys = u, this.device = p, this.deviceId = a, this.version = A, this.getRegistryType = () => RegistryType_1$1.RegistryTypes.CRYPTO_MULTI_ACCOUNTS, this.getMasterFingerprint = () => this.masterFingerprint, this.getKeys = () => this.keys, this.getDevice = () => this.device, this.getDeviceId = () => this.deviceId, this.getVersion = () => this.version, this.toDataItem = () => {
      const b = {};
      return this.masterFingerprint && (b[Keys$1.masterFingerprint] = this.masterFingerprint.readUInt32BE(0)), this.keys && (b[Keys$1.keys] = this.keys.map((F) => {
        const le = F.toDataItem();
        return le.setTag(F.getRegistryType().getTag()), le;
      })), this.device && (b[Keys$1.device] = this.device), this.deviceId && (b[Keys$1.deviceId] = this.deviceId), this.version && (b[Keys$1.version] = this.version), new lib_1$1.DataItem(b);
    };
  }
};
CryptoMultiAccounts$d.CryptoMultiAccounts = CryptoMultiAccounts$c;
CryptoMultiAccounts$c.fromDataItem = (n) => {
  const c = n.getData(), u = Buffer$f.alloc(4), p = c[Keys$1.masterFingerprint];
  p && u.writeUInt32BE(p, 0);
  const A = c[Keys$1.keys].map((L) => CryptoHDKey_1.CryptoHDKey.fromDataItem(L)), b = c[Keys$1.device], F = c[Keys$1.deviceId], le = c[Keys$1.version];
  return new CryptoMultiAccounts$c(u, A, b, F, le);
};
CryptoMultiAccounts$c.fromCBOR = (n) => {
  const c = (0, lib_1$1.decodeToDataItem)(n);
  return CryptoMultiAccounts$c.fromDataItem(c);
};
var QRHardwareCall$c = {}, KeyDerivation$d = {}, DerivationSchema$c = {};
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.KeyDerivationSchema = n.DerivationAlgorithm = n.Curve = void 0;
  const c = RegistryType$d, u = RegistryItem$d, p = lib$f, a = CryptoKeypath$d;
  var A;
  (function(L) {
    L[L.keyPath = 1] = "keyPath", L[L.curve = 2] = "curve", L[L.algo = 3] = "algo", L[L.chainType = 4] = "chainType";
  })(A || (A = {}));
  var b;
  (function(L) {
    L[L.secp256k1 = 0] = "secp256k1", L[L.ed25519 = 1] = "ed25519";
  })(b = n.Curve || (n.Curve = {}));
  var F;
  (function(L) {
    L[L.slip10 = 0] = "slip10", L[L.bip32ed25519 = 1] = "bip32ed25519";
  })(F = n.DerivationAlgorithm || (n.DerivationAlgorithm = {}));
  class le extends u.RegistryItem {
    constructor(pe, $ = b.secp256k1, Ee = F.slip10, be) {
      super(), this.keypath = pe, this.curve = $, this.algo = Ee, this.chainType = be, this.getRegistryType = () => c.RegistryTypes.KEY_DERIVATION_SCHEMA, this.getKeypath = () => this.keypath, this.getCurve = () => this.curve, this.getAlgo = () => this.algo, this.getChainType = () => this.chainType, this.toDataItem = () => {
        const He = {}, Pe = this.getKeypath().toDataItem();
        return Pe.setTag(this.getKeypath().getRegistryType().getTag()), He[A.keyPath] = Pe, He[A.curve] = this.curve, He[A.algo] = this.algo, this.chainType && (He[A.chainType] = this.chainType), new p.DataItem(He);
      };
    }
  }
  n.KeyDerivationSchema = le, le.fromDataItem = (L) => {
    const pe = L.getData(), $ = a.CryptoKeypath.fromDataItem(pe[A.keyPath]), Ee = pe[A.curve], be = pe[A.algo], He = pe[A.chainType];
    return new le($, Ee, be, He);
  }, le.fromCBOR = (L) => {
    const pe = (0, p.decodeToDataItem)(L);
    return le.fromDataItem(pe);
  };
})(DerivationSchema$c);
Object.defineProperty(KeyDerivation$d, "__esModule", { value: !0 });
KeyDerivation$d.KeyDerivation = void 0;
const RegistryType_1 = RegistryType$d, RegistryItem_1 = RegistryItem$d, lib_1 = lib$f, DerivationSchema_1 = DerivationSchema$c;
var Keys;
(function(n) {
  n[n.schemas = 1] = "schemas";
})(Keys || (Keys = {}));
let KeyDerivation$c = class extends RegistryItem_1.RegistryItem {
  constructor(c) {
    super(), this.schemas = c, this.getRegistryType = () => RegistryType_1.RegistryTypes.KEY_DERIVATION_CALL, this.getSchemas = () => this.schemas, this.toDataItem = () => {
      const u = {};
      return u[Keys.schemas] = this.schemas.map((p) => {
        const a = p.toDataItem();
        return a.setTag(p.getRegistryType().getTag()), a;
      }), new lib_1.DataItem(u);
    };
  }
};
KeyDerivation$d.KeyDerivation = KeyDerivation$c;
KeyDerivation$c.fromDataItem = (n) => {
  const u = n.getData()[Keys.schemas].map((p) => DerivationSchema_1.KeyDerivationSchema.fromDataItem(p));
  return new KeyDerivation$c(u);
};
KeyDerivation$c.fromCBOR = (n) => {
  const c = (0, lib_1.decodeToDataItem)(n);
  return KeyDerivation$c.fromDataItem(c);
};
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.QRHardwareCall = n.QRHardwareCallVersion = n.QRHardwareCallType = void 0;
  const c = RegistryType$d, u = RegistryItem$d, p = lib$f, a = KeyDerivation$d;
  var A;
  (function(le) {
    le[le.type = 1] = "type", le[le.params = 2] = "params", le[le.origin = 3] = "origin", le[le.version = 4] = "version";
  })(A || (A = {}));
  var b;
  (function(le) {
    le[le.KeyDerivation = 0] = "KeyDerivation";
  })(b = n.QRHardwareCallType || (n.QRHardwareCallType = {})), function(le) {
    le[le.V0 = 0] = "V0", le[le.V1 = 1] = "V1";
  }(n.QRHardwareCallVersion || (n.QRHardwareCallVersion = {}));
  class F extends u.RegistryItem {
    constructor(L, pe, $, Ee) {
      super(), this.type = L, this.params = pe, this.origin = $, this.version = Ee, this.getRegistryType = () => c.RegistryTypes.QR_HARDWARE_CALL, this.getType = () => this.type, this.getParams = () => this.params, this.getOrigin = () => this.origin, this.getVersion = () => this.version, this.toDataItem = () => {
        const be = {};
        be[A.type] = this.type;
        const He = this.params.toDataItem();
        return He.setTag(this.params.getRegistryType().getTag()), be[A.params] = He, this.origin && (be[A.origin] = this.origin), this.version && (be[A.version] = this.version), new p.DataItem(be);
      };
    }
  }
  n.QRHardwareCall = F, F.fromDataItem = (le) => {
    const L = le.getData(), pe = L[A.type] || b.KeyDerivation;
    let $;
    switch (pe) {
      case b.KeyDerivation:
        $ = a.KeyDerivation.fromDataItem(L[A.params]);
    }
    const Ee = L[A.origin], be = L[A.version];
    return new F(pe, $, Ee, be);
  }, F.fromCBOR = (le) => {
    const L = (0, p.decodeToDataItem)(le);
    return F.fromDataItem(L);
  };
})(QRHardwareCall$c);
var types$i = {};
Object.defineProperty(types$i, "__esModule", { value: !0 });
var hasRequiredDist$c;
function requireDist$c() {
  return hasRequiredDist$c || (hasRequiredDist$c = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.Buffer = n.extend = n.PathComponent = n.ScriptExpressions = n.MultiKey = n.CryptoPSBT = n.CryptoOutput = n.CryptoECKey = n.CryptoCoinInfoNetwork = n.CryptoCoinInfoType = n.CryptoCoinInfo = n.CryptoKeypath = n.CryptoMultiAccounts = n.CryptoHDKey = n.CryptoAccount = n.Bytes = n.URRegistryDecoder = n.DataItem = void 0;
    const c = require$$0$4, u = dist$u;
    Object.defineProperty(n, "Buffer", { enumerable: !0, get: function() {
      return u.Buffer;
    } });
    const p = CryptoHDKey$d;
    Object.defineProperty(n, "CryptoHDKey", { enumerable: !0, get: function() {
      return p.CryptoHDKey;
    } });
    const a = CryptoKeypath$d;
    Object.defineProperty(n, "CryptoKeypath", { enumerable: !0, get: function() {
      return a.CryptoKeypath;
    } });
    const A = CryptoCoinInfo$c;
    Object.defineProperty(n, "CryptoCoinInfo", { enumerable: !0, get: function() {
      return A.CryptoCoinInfo;
    } }), Object.defineProperty(n, "CryptoCoinInfoType", { enumerable: !0, get: function() {
      return A.Type;
    } }), Object.defineProperty(n, "CryptoCoinInfoNetwork", { enumerable: !0, get: function() {
      return A.Network;
    } });
    const b = CryptoECKey$d;
    Object.defineProperty(n, "CryptoECKey", { enumerable: !0, get: function() {
      return b.CryptoECKey;
    } });
    const F = Bytes$e;
    Object.defineProperty(n, "Bytes", { enumerable: !0, get: function() {
      return F.Bytes;
    } });
    const le = CryptoOutput$d;
    Object.defineProperty(n, "CryptoOutput", { enumerable: !0, get: function() {
      return le.CryptoOutput;
    } });
    const L = CryptoPSBT$d;
    Object.defineProperty(n, "CryptoPSBT", { enumerable: !0, get: function() {
      return L.CryptoPSBT;
    } });
    const pe = requireCryptoAccount$c();
    Object.defineProperty(n, "CryptoAccount", { enumerable: !0, get: function() {
      return pe.CryptoAccount;
    } });
    const $ = requireDecoder$c();
    Object.defineProperty(n, "URRegistryDecoder", { enumerable: !0, get: function() {
      return $.URRegistryDecoder;
    } });
    const Ee = MultiKey$d;
    Object.defineProperty(n, "MultiKey", { enumerable: !0, get: function() {
      return Ee.MultiKey;
    } });
    const be = ScriptExpression$c;
    Object.defineProperty(n, "ScriptExpressions", { enumerable: !0, get: function() {
      return be.ScriptExpressions;
    } });
    const He = PathComponent$d;
    Object.defineProperty(n, "PathComponent", { enumerable: !0, get: function() {
      return He.PathComponent;
    } });
    const Pe = RegistryItem$d, nr = RegistryType$d, ir = lib$f;
    var or = lib$f;
    Object.defineProperty(n, "DataItem", { enumerable: !0, get: function() {
      return or.DataItem;
    } });
    const lr = utils$J, Ir = CryptoMultiAccounts$d;
    Object.defineProperty(n, "CryptoMultiAccounts", { enumerable: !0, get: function() {
      return Ir.CryptoMultiAccounts;
    } });
    const xr = {
      URRegistryDecoder: $.URRegistryDecoder,
      Bytes: F.Bytes,
      CryptoAccount: pe.CryptoAccount,
      CryptoHDKey: p.CryptoHDKey,
      CryptoMultiAccounts: Ir.CryptoMultiAccounts,
      CryptoKeypath: a.CryptoKeypath,
      CryptoCoinInfo: A.CryptoCoinInfo,
      CryptoCoinInfoType: A.Type,
      CryptoCoinInfoNetwork: A.Network,
      CryptoECKey: b.CryptoECKey,
      CryptoOutput: le.CryptoOutput,
      CryptoPSBT: L.CryptoPSBT,
      MultiKey: Ee.MultiKey,
      ScriptExpressions: be.ScriptExpressions,
      PathComponent: He.PathComponent
    }, kr = {
      addReader: ir.addReader,
      addSemanticDecode: ir.addSemanticDecode,
      addSemanticEncode: ir.addSemanticEncode,
      addWriter: ir.addWriter,
      patchTags: lr.patchTags
    }, Ce = {
      RegistryTypes: nr.RegistryTypes,
      RegistryItem: Pe.RegistryItem,
      RegistryType: nr.RegistryType,
      decodeToDataItem: ir.decodeToDataItem,
      encodeDataItem: ir.encodeDataItem,
      cbor: kr
    };
    n.extend = Ce, (0, c.__exportStar)(errors$d, n), (0, c.__exportStar)(requireDecoder$c(), n), (0, c.__exportStar)(lib$f, n), (0, c.__exportStar)(requireCryptoAccount$c(), n), (0, c.__exportStar)(CryptoPSBT$d, n), (0, c.__exportStar)(CryptoHDKey$d, n), (0, c.__exportStar)(CryptoMultiAccounts$d, n), (0, c.__exportStar)(QRHardwareCall$c, n), (0, c.__exportStar)(KeyDerivation$d, n), (0, c.__exportStar)(DerivationSchema$c, n), (0, c.__exportStar)(CryptoOutput$d, n), (0, c.__exportStar)(CryptoCoinInfo$c, n), (0, c.__exportStar)(CryptoECKey$d, n), (0, c.__exportStar)(MultiKey$d, n), (0, c.__exportStar)(CryptoKeypath$d, n), (0, c.__exportStar)(patchCBOR$c, n), (0, c.__exportStar)(PathComponent$d, n), (0, c.__exportStar)(RegistryItem$d, n), (0, c.__exportStar)(RegistryType$d, n), (0, c.__exportStar)(types$i, n), (0, c.__exportStar)(utils$J, n), n.default = xr;
  }(dist$v)), dist$v;
}
Object.defineProperty(crypto$7, "__esModule", { value: !0 });
crypto$7.pathToKeypath = void 0;
const bc_ur_registry_1$4 = requireDist$c(), pathToKeypath = (n) => {
  const u = n.replace(/[m|M]\//, "").split("/").map((p) => {
    const a = parseInt(p.replace("'", ""), 10), A = p.endsWith("'");
    return new bc_ur_registry_1$4.PathComponent({ index: a, hardened: A });
  });
  return new bc_ur_registry_1$4.CryptoKeypath(u);
};
crypto$7.pathToKeypath = pathToKeypath;
(function(n) {
  var c = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(p, a, A, b) {
    b === void 0 && (b = A);
    var F = Object.getOwnPropertyDescriptor(a, A);
    (!F || ("get" in F ? !a.__esModule : F.writable || F.configurable)) && (F = { enumerable: !0, get: function() {
      return a[A];
    } }), Object.defineProperty(p, b, F);
  } : function(p, a, A, b) {
    b === void 0 && (b = A), p[b] = a[A];
  }), u = commonjsGlobal && commonjsGlobal.__exportStar || function(p, a) {
    for (var A in p) A !== "default" && !Object.prototype.hasOwnProperty.call(a, A) && c(a, p, A);
  };
  Object.defineProperty(n, "__esModule", { value: !0 }), u(stringHelper, n), u(crypto$7, n), u(coin$1, n);
})(utils$K);
var sdk = {}, chains = {}, bitcoin$1 = {}, dist$s = { exports: {} }, bcUrRegistryBtc_cjs_production_min = {}, dist$r = {}, patchCBOR$b = {}, utils$H = {}, lib$e = {}, cborSync$b = { exports: {} }, DataItem$b = {}, hasRequiredDataItem$b;
function requireDataItem$b() {
  if (hasRequiredDataItem$b) return DataItem$b;
  hasRequiredDataItem$b = 1, Object.defineProperty(DataItem$b, "__esModule", { value: !0 }), DataItem$b.DataItem = void 0;
  class n {
    constructor(u, p) {
      this.setTag = (a) => {
        this.tag = a;
      }, this.clearTag = () => {
        this.tag = void 0;
      }, this.getTag = () => this.tag, this.getData = () => this.data, this.data = u, this.tag = p;
    }
  }
  return DataItem$b.DataItem = n, DataItem$b;
}
var hasRequiredCborSync$b;
function requireCborSync$b() {
  return hasRequiredCborSync$b || (hasRequiredCborSync$b = 1, function(n) {
    (function(c, u) {
      n.exports ? n.exports = u() : c.CBOR = u();
    })(commonjsGlobal, function() {
      const { DataItem: c } = requireDataItem$b();
      var u = function() {
        function p(Ce) {
          this.$hex = Ce;
        }
        p.prototype = {
          length: function() {
            return this.$hex.length / 2;
          },
          toString: function(Ce) {
            if (!Ce || Ce === "hex" || Ce === 16)
              return this.$hex;
            if (Ce === "utf-8") {
              for (var tr = "", Fe = 0; Fe < this.$hex.length; Fe += 2)
                tr += "%" + this.$hex.substring(Fe, Fe + 2);
              return decodeURIComponent(tr);
            }
            if (Ce === "latin") {
              for (var tr = [], Fe = 0; Fe < this.$hex.length; Fe += 2)
                tr.push(parseInt(this.$hex.substring(Fe, Fe + 2), 16));
              return String.fromCharCode.apply(String, tr);
            }
            throw new Error("Unrecognised format: " + Ce);
          }
        }, p.fromLatinString = function(Ce) {
          for (var tr = "", Fe = 0; Fe < Ce.length; Fe++) {
            var Sr = Ce.charCodeAt(Fe).toString(16);
            Sr.length === 1 && (Sr = "0" + Sr), tr += Sr;
          }
          return new p(tr);
        }, p.fromUtf8String = function(Ce) {
          for (var tr = encodeURIComponent(Ce), Fe = "", Sr = 0; Sr < tr.length; Sr++)
            if (tr.charAt(Sr) === "%")
              Fe += tr.substring(Sr + 1, Sr + 3), Sr += 2;
            else {
              var er = tr.charCodeAt(Sr).toString(16);
              er.length < 2 && (er = "0" + er), Fe += er;
            }
          return new p(Fe);
        };
        var a = [], A = {}, b = function(Ce) {
          return function() {
            throw new Error(Ce + " not implemented");
          };
        };
        function F() {
        }
        F.prototype = {
          peekByte: b("peekByte"),
          readByte: b("readByte"),
          readChunk: b("readChunk"),
          readFloat16: function() {
            var Ce = this.readUint16(), tr = (Ce & 32767) >> 10, Fe = Ce & 1023, Sr = Ce & 32768;
            if (tr === 31)
              return Fe === 0 ? Sr ? -1 / 0 : 1 / 0 : NaN;
            var er = tr ? Math.pow(2, tr - 25) * (1024 + Fe) : Math.pow(2, -24) * Fe;
            return Sr ? -er : er;
          },
          readFloat32: function() {
            var Ce = this.readUint32(), tr = (Ce & 2147483647) >> 23, Fe = Ce & 8388607, Sr = Ce & 2147483648;
            if (tr === 255)
              return Fe === 0 ? Sr ? -1 / 0 : 1 / 0 : NaN;
            var er = tr ? Math.pow(2, tr - 23 - 127) * (8388608 + Fe) : Math.pow(2, -149) * Fe;
            return Sr ? -er : er;
          },
          readFloat64: function() {
            var Ce = this.readUint32(), tr = this.readUint32(), Fe = Ce >> 20 & 2047, Sr = (Ce & 1048575) * 4294967296 + tr, er = Ce & 2147483648;
            if (Fe === 2047)
              return Sr === 0 ? er ? -1 / 0 : 1 / 0 : NaN;
            var Ie = Fe ? Math.pow(2, Fe - 52 - 1023) * (4503599627370496 + Sr) : Math.pow(2, -1074) * Sr;
            return er ? -Ie : Ie;
          },
          readUint16: function() {
            return this.readByte() * 256 + this.readByte();
          },
          readUint32: function() {
            return this.readUint16() * 65536 + this.readUint16();
          },
          readUint64: function() {
            return this.readUint32() * 4294967296 + this.readUint32();
          }
        };
        function le() {
        }
        le.prototype = {
          writeByte: b("writeByte"),
          result: b("result"),
          writeFloat16: b("writeFloat16"),
          writeFloat32: b("writeFloat32"),
          writeFloat64: b("writeFloat64"),
          writeUint16: function(Ce) {
            this.writeByte(Ce >> 8 & 255), this.writeByte(Ce & 255);
          },
          writeUint32: function(Ce) {
            this.writeUint16(Ce >> 16 & 65535), this.writeUint16(Ce & 65535);
          },
          writeUint64: function(Ce) {
            if (Ce >= 9007199254740992 || Ce <= -9007199254740992)
              throw new Error("Cannot encode Uint64 of: " + Ce + " magnitude to big (floating point errors)");
            this.writeUint32(Math.floor(Ce / 4294967296)), this.writeUint32(Ce % 4294967296);
          },
          writeString: b("writeString"),
          canWriteBinary: function(Ce) {
            return !1;
          },
          writeBinary: b("writeChunk")
        };
        function L(Ce) {
          var tr = Ce.readByte(), Fe = tr >> 5, Sr = tr & 31;
          return { type: Fe, value: Sr };
        }
        function pe(Ce, tr) {
          var Fe = Ce.value;
          if (Fe < 24)
            return Fe;
          if (Fe == 24)
            return tr.readByte();
          if (Fe == 25)
            return tr.readUint16();
          if (Fe == 26)
            return tr.readUint32();
          if (Fe == 27)
            return tr.readUint64();
          if (Fe == 31)
            return null;
          b("Additional info: " + Fe)();
        }
        function $(Ce, tr, Fe) {
          Fe.writeByte(Ce << 5 | tr);
        }
        function Ee(Ce, tr, Fe) {
          var Sr = Ce << 5;
          tr < 24 ? Fe.writeByte(Sr | tr) : tr < 256 ? (Fe.writeByte(Sr | 24), Fe.writeByte(tr)) : tr < 65536 ? (Fe.writeByte(Sr | 25), Fe.writeUint16(tr)) : tr < 4294967296 ? (Fe.writeByte(Sr | 26), Fe.writeUint32(tr)) : (Fe.writeByte(Sr | 27), Fe.writeUint64(tr));
        }
        var be = new Error();
        function He(Ce) {
          var tr = L(Ce);
          switch (tr.type) {
            case 0:
              return pe(tr, Ce);
            case 1:
              return -1 - pe(tr, Ce);
            case 2:
              return Ce.readChunk(pe(tr, Ce));
            case 3:
              var Fe = Ce.readChunk(pe(tr, Ce));
              return Fe.toString("utf-8");
            case 4:
            case 5:
              var Sr = pe(tr, Ce), yr = [];
              if (Sr !== null) {
                tr.type === 5 && (Sr *= 2);
                for (var er = 0; er < Sr; er++)
                  yr[er] = He(Ce);
              } else
                for (var Ie; (Ie = He(Ce)) !== be; )
                  yr.push(Ie);
              if (tr.type === 5) {
                for (var xe = {}, er = 0; er < yr.length; er += 2)
                  xe[yr[er]] = yr[er + 1];
                return xe;
              } else
                return yr;
            case 6:
              var rr = pe(tr, Ce), ar = A[rr], yr = He(Ce);
              return ar ? ar(yr) : yr;
            case 7:
              if (tr.value === 25)
                return Ce.readFloat16();
              if (tr.value === 26)
                return Ce.readFloat32();
              if (tr.value === 27)
                return Ce.readFloat64();
              switch (pe(tr, Ce)) {
                case 20:
                  return !1;
                case 21:
                  return !0;
                case 22:
                  return null;
                case 23:
                  return;
                case null:
                  return be;
                default:
                  throw new Error("Unknown fixed value: " + tr.value);
              }
            default:
              throw new Error("Unsupported header: " + JSON.stringify(tr));
          }
          throw new Error("not implemented yet");
        }
        function Pe(Ce, tr) {
          for (var Fe = 0; Fe < a.length; Fe++) {
            var Sr = a[Fe].fn(Ce);
            if (Sr !== void 0)
              return Ee(6, a[Fe].tag, tr), Pe(Sr, tr);
          }
          if (Ce && typeof Ce.toCBOR == "function" && (Ce = Ce.toCBOR()), Ce === !1)
            Ee(7, 20, tr);
          else if (Ce === !0)
            Ee(7, 21, tr);
          else if (Ce === null)
            Ee(7, 22, tr);
          else if (Ce === void 0)
            Ee(7, 23, tr);
          else if (typeof Ce == "number")
            Math.floor(Ce) === Ce && Ce < 9007199254740992 && Ce > -9007199254740992 ? Ce < 0 ? Ee(1, -1 - Ce, tr) : Ee(0, Ce, tr) : ($(7, 27, tr), tr.writeFloat64(Ce));
          else if (typeof Ce == "string")
            tr.writeString(Ce, function(Ie) {
              Ee(3, Ie, tr);
            });
          else if (tr.canWriteBinary(Ce))
            tr.writeBinary(Ce, function(Ie) {
              Ee(2, Ie, tr);
            });
          else if (typeof Ce == "object")
            if (or.config.useToJSON && typeof Ce.toJSON == "function" && (Ce = Ce.toJSON()), Array.isArray(Ce)) {
              Ee(4, Ce.length, tr);
              for (var Fe = 0; Fe < Ce.length; Fe++)
                Pe(Ce[Fe], tr);
            } else {
              var er = Object.keys(Ce);
              Ee(5, er.length, tr);
              for (var Fe = 0; Fe < er.length; Fe++) {
                const xe = parseInt(er[Fe]);
                isNaN(xe) ? (Pe(er[Fe], tr), Pe(Ce[er[Fe]], tr)) : (Pe(xe, tr), Pe(Ce[er[Fe]], tr));
              }
            }
          else
            throw new Error("CBOR encoding not supported: " + Ce);
        }
        var nr = [], ir = [], or = {
          config: {
            useToJSON: !0
          },
          addWriter: function(Ce, tr) {
            typeof Ce == "string" ? ir.push(function(Fe) {
              if (Ce === Fe)
                return tr(Fe);
            }) : ir.push(Ce);
          },
          addReader: function(Ce, tr) {
            typeof Ce == "string" ? nr.push(function(Fe, Sr) {
              if (Ce === Sr)
                return tr(Fe, Sr);
            }) : nr.push(Ce);
          },
          encode: function(Ce, tr) {
            for (var Fe = 0; Fe < ir.length; Fe++) {
              var Sr = ir[Fe], er = Sr(tr);
              if (er)
                return Pe(Ce, er), er.result();
            }
            throw new Error("Unsupported output format: " + tr);
          },
          encodeDataItem: function(Ce, tr) {
            for (var Fe = 0; Fe < ir.length; Fe++) {
              var Sr = ir[Fe], er = Sr(tr);
              if (er)
                return Ce.getTag() !== void 0 ? (Pe(Ce, er), er.result()) : (Pe(Ce.getData(), er), er.result());
            }
            throw new Error("Unsupported output format: " + tr);
          },
          decode: function(Ce, tr) {
            for (var Fe = 0; Fe < nr.length; Fe++) {
              var Sr = nr[Fe], er = Sr(Ce, tr);
              if (er)
                return He(er);
            }
            throw new Error("Unsupported input format: " + tr);
          },
          decodeToDataItem: function(Ce, tr) {
            for (var Fe = 0; Fe < nr.length; Fe++) {
              var Sr = nr[Fe], er = Sr(Ce, tr);
              if (er) {
                const Ie = He(er);
                return Ie instanceof c ? Ie : new c(Ie);
              }
            }
            throw new Error("Unsupported input format: " + tr);
          },
          addSemanticEncode: function(Ce, tr) {
            if (typeof Ce != "number" || Ce % 1 !== 0 || Ce < 0)
              throw new Error("Tag must be a positive integer");
            return a.push({ tag: Ce, fn: tr }), this;
          },
          addSemanticDecode: function(Ce, tr) {
            if (typeof Ce != "number" || Ce % 1 !== 0 || Ce < 0)
              throw new Error("Tag must be a positive integer");
            return A[Ce] = tr, this;
          }
        };
        function lr(Ce) {
          this.buffer = Ce, this.pos = 0;
        }
        lr.prototype = Object.create(F.prototype), lr.prototype.peekByte = function() {
          return this.buffer[this.pos];
        }, lr.prototype.readByte = function() {
          return this.buffer[this.pos++];
        }, lr.prototype.readUint16 = function() {
          var Ce = this.buffer.readUInt16BE(this.pos);
          return this.pos += 2, Ce;
        }, lr.prototype.readUint32 = function() {
          var Ce = this.buffer.readUInt32BE(this.pos);
          return this.pos += 4, Ce;
        }, lr.prototype.readFloat32 = function() {
          var Ce = this.buffer.readFloatBE(this.pos);
          return this.pos += 4, Ce;
        }, lr.prototype.readFloat64 = function() {
          var Ce = this.buffer.readDoubleBE(this.pos);
          return this.pos += 8, Ce;
        }, lr.prototype.readChunk = function(Ce) {
          var tr = Buffer$f.alloc(Ce);
          return this.buffer.copy(tr, 0, this.pos, this.pos += Ce), tr;
        };
        function Ir(Ce) {
          this.byteLength = 0, this.defaultBufferLength = 16384, this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0, this.completeBuffers = [], this.stringFormat = Ce;
        }
        Ir.prototype = Object.create(le.prototype), Ir.prototype.writeByte = function(Ce) {
          this.latestBuffer[this.latestBufferOffset++] = Ce, this.latestBufferOffset >= this.latestBuffer.length && (this.completeBuffers.push(this.latestBuffer), this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0), this.byteLength++;
        }, Ir.prototype.writeFloat32 = function(Ce) {
          var tr = Buffer$f.alloc(4);
          tr.writeFloatBE(Ce, 0), this.writeBuffer(tr);
        }, Ir.prototype.writeFloat64 = function(Ce) {
          var tr = Buffer$f.alloc(8);
          tr.writeDoubleBE(Ce, 0), this.writeBuffer(tr);
        }, Ir.prototype.writeString = function(Ce, tr) {
          var Fe = Buffer$f.from(Ce, "utf-8");
          tr(Fe.length), this.writeBuffer(Fe);
        }, Ir.prototype.canWriteBinary = function(Ce) {
          return Ce instanceof Buffer$f;
        }, Ir.prototype.writeBinary = function(Ce, tr) {
          tr(Ce.length), this.writeBuffer(Ce);
        }, Ir.prototype.writeBuffer = function(Ce) {
          if (!(Ce instanceof Buffer$f))
            throw new TypeError("BufferWriter only accepts Buffers");
          this.latestBufferOffset ? this.latestBuffer.length - this.latestBufferOffset >= Ce.length ? (Ce.copy(this.latestBuffer, this.latestBufferOffset), this.latestBufferOffset += Ce.length, this.latestBufferOffset >= this.latestBuffer.length && (this.completeBuffers.push(this.latestBuffer), this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0)) : (this.completeBuffers.push(this.latestBuffer.slice(0, this.latestBufferOffset)), this.completeBuffers.push(Ce), this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0) : this.completeBuffers.push(Ce), this.byteLength += Ce.length;
        }, Ir.prototype.result = function() {
          for (var Ce = Buffer$f.alloc(this.byteLength), tr = 0, Fe = 0; Fe < this.completeBuffers.length; Fe++) {
            var Sr = this.completeBuffers[Fe];
            Sr.copy(Ce, tr, 0, Sr.length), tr += Sr.length;
          }
          return this.latestBufferOffset && this.latestBuffer.copy(Ce, tr, 0, this.latestBufferOffset), this.stringFormat ? Ce.toString(this.stringFormat) : Ce;
        }, typeof Buffer$f == "function" && (or.addReader(function(Ce, tr) {
          if (Buffer$f.isBuffer(Ce))
            return new lr(Ce);
          if (tr === "hex" || tr === "base64") {
            var Fe = Buffer$f.from(Ce, tr);
            return new lr(Fe);
          }
        }), or.addWriter(function(Ce) {
          if (!Ce || Ce === "buffer")
            return new Ir();
          if (Ce === "hex" || Ce === "base64")
            return new Ir(Ce);
        }));
        function xr(Ce) {
          this.hex = Ce, this.pos = 0;
        }
        xr.prototype = Object.create(F.prototype), xr.prototype.peekByte = function() {
          var Ce = this.hex.substring(this.pos, 2);
          return parseInt(Ce, 16);
        }, xr.prototype.readByte = function() {
          var Ce = this.hex.substring(this.pos, this.pos + 2);
          return this.pos += 2, parseInt(Ce, 16);
        }, xr.prototype.readChunk = function(Ce) {
          var tr = this.hex.substring(this.pos, this.pos + Ce * 2);
          return this.pos += Ce * 2, typeof Buffer$f == "function" ? Buffer$f.from(tr, "hex") : new p(tr);
        };
        function kr(Ce) {
          this.$hex = "", this.finalFormat = Ce || "hex";
        }
        return kr.prototype = Object.create(le.prototype), kr.prototype.writeByte = function(Ce) {
          if (Ce < 0 || Ce > 255)
            throw new Error("Byte value out of range: " + Ce);
          var tr = Ce.toString(16);
          tr.length == 1 && (tr = "0" + tr), this.$hex += tr;
        }, kr.prototype.canWriteBinary = function(Ce) {
          return Ce instanceof p || typeof Buffer$f == "function" && Ce instanceof Buffer$f;
        }, kr.prototype.writeBinary = function(Ce, tr) {
          if (Ce instanceof p)
            tr(Ce.length()), this.$hex += Ce.$hex;
          else if (typeof Buffer$f == "function" && Ce instanceof Buffer$f)
            tr(Ce.length), this.$hex += Ce.toString("hex");
          else
            throw new TypeError("HexWriter only accepts BinaryHex or Buffers");
        }, kr.prototype.result = function() {
          return this.finalFormat === "buffer" && typeof Buffer$f == "function" ? Buffer$f.from(this.$hex, "hex") : new p(this.$hex).toString(this.finalFormat);
        }, kr.prototype.writeString = function(Ce, tr) {
          var Fe = p.fromUtf8String(Ce);
          tr(Fe.length()), this.$hex += Fe.$hex;
        }, or.addReader(function(Ce, tr) {
          if (Ce instanceof p || Ce.$hex)
            return new xr(Ce.$hex);
          if (tr === "hex")
            return new xr(Ce);
        }), or.addWriter(function(Ce) {
          if (Ce === "hex")
            return new kr();
        }), or;
      }();
      return u.addSemanticEncode(0, function(p) {
        if (p instanceof Date)
          return p.toISOString();
      }).addSemanticDecode(0, function(p) {
        return new Date(p);
      }).addSemanticDecode(1, function(p) {
        return new Date(p);
      }), u;
    });
  }(cborSync$b)), cborSync$b.exports;
}
var hasRequiredLib$c;
function requireLib$c() {
  return hasRequiredLib$c || (hasRequiredLib$c = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.DataItem = n.addWriter = n.addReader = n.addSemanticEncode = n.addSemanticDecode = n.decodeToDataItem = n.encodeDataItem = void 0;
    var c = requireCborSync$b();
    Object.defineProperty(n, "encodeDataItem", { enumerable: !0, get: function() {
      return c.encodeDataItem;
    } }), Object.defineProperty(n, "decodeToDataItem", { enumerable: !0, get: function() {
      return c.decodeToDataItem;
    } }), Object.defineProperty(n, "addSemanticDecode", { enumerable: !0, get: function() {
      return c.addSemanticDecode;
    } }), Object.defineProperty(n, "addSemanticEncode", { enumerable: !0, get: function() {
      return c.addSemanticEncode;
    } }), Object.defineProperty(n, "addReader", { enumerable: !0, get: function() {
      return c.addReader;
    } }), Object.defineProperty(n, "addWriter", { enumerable: !0, get: function() {
      return c.addWriter;
    } });
    var u = requireDataItem$b();
    Object.defineProperty(n, "DataItem", { enumerable: !0, get: function() {
      return u.DataItem;
    } });
  }(lib$e)), lib$e;
}
var hasRequiredUtils$e;
function requireUtils$e() {
  if (hasRequiredUtils$e) return utils$H;
  hasRequiredUtils$e = 1, Object.defineProperty(utils$H, "__esModule", { value: !0 }), utils$H.patchTags = void 0;
  const n = requireLib$c(), c = [], u = (p) => {
    p.forEach((a) => {
      c.find((A) => A === a) || ((0, n.addSemanticEncode)(a, (A) => {
        if (A instanceof n.DataItem && A.getTag() === a)
          return A.getData();
      }), (0, n.addSemanticDecode)(a, (A) => new n.DataItem(A, a)), c.push(a));
    });
  };
  return utils$H.patchTags = u, utils$H;
}
var RegistryType$b = {}, hasRequiredRegistryType$b;
function requireRegistryType$b() {
  if (hasRequiredRegistryType$b) return RegistryType$b;
  hasRequiredRegistryType$b = 1, Object.defineProperty(RegistryType$b, "__esModule", { value: !0 }), RegistryType$b.RegistryTypes = RegistryType$b.RegistryType = void 0;
  class n {
    constructor(u, p) {
      this.type = u, this.tag = p, this.getTag = () => this.tag, this.getType = () => this.type;
    }
  }
  return RegistryType$b.RegistryType = n, RegistryType$b.RegistryTypes = {
    UUID: new n("uuid", 37),
    BYTES: new n("bytes", void 0),
    CRYPTO_HDKEY: new n("crypto-hdkey", 303),
    CRYPTO_KEYPATH: new n("crypto-keypath", 304),
    CRYPTO_COIN_INFO: new n("crypto-coin-info", 305),
    CRYPTO_ECKEY: new n("crypto-eckey", 306),
    CRYPTO_OUTPUT: new n("crypto-output", 308),
    CRYPTO_PSBT: new n("crypto-psbt", 310),
    CRYPTO_ACCOUNT: new n("crypto-account", 311),
    CRYPTO_MULTI_ACCOUNTS: new n("crypto-multi-accounts", 1103),
    QR_HARDWARE_CALL: new n("qr-hardware-call", 1201),
    KEY_DERIVATION_CALL: new n("key-derivation-call", 1301),
    KEY_DERIVATION_SCHEMA: new n("key-derivation-schema", 1302)
  }, RegistryType$b;
}
var ScriptExpression$b = {}, hasRequiredScriptExpression$b;
function requireScriptExpression$b() {
  return hasRequiredScriptExpression$b || (hasRequiredScriptExpression$b = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.ScriptExpressions = n.ScriptExpression = void 0;
    class c {
      constructor(p, a) {
        this.tag = p, this.expression = a, this.getTag = () => this.tag, this.getExpression = () => this.expression;
      }
    }
    n.ScriptExpression = c, c.fromTag = (u) => Object.values(n.ScriptExpressions).find((a) => a.getTag() === u), n.ScriptExpressions = {
      SCRIPT_HASH: new c(400, "sh"),
      WITNESS_SCRIPT_HASH: new c(401, "wsh"),
      PUBLIC_KEY: new c(402, "pk"),
      PUBLIC_KEY_HASH: new c(403, "pkh"),
      WITNESS_PUBLIC_KEY_HASH: new c(404, "wpkh"),
      COMBO: new c(405, "combo"),
      MULTISIG: new c(406, "multi"),
      SORTED_MULTISIG: new c(407, "sortedmulti"),
      ADDRESS: new c(307, "addr"),
      RAW_SCRIPT: new c(408, "raw")
    };
  }(ScriptExpression$b)), ScriptExpression$b;
}
var hasRequiredPatchCBOR$b;
function requirePatchCBOR$b() {
  if (hasRequiredPatchCBOR$b) return patchCBOR$b;
  hasRequiredPatchCBOR$b = 1, Object.defineProperty(patchCBOR$b, "__esModule", { value: !0 });
  const n = requireUtils$e(), c = requireRegistryType$b(), u = requireScriptExpression$b(), p = Object.values(c.RegistryTypes).filter((A) => !!A.getTag()).map((A) => A.getTag()), a = Object.values(u.ScriptExpressions).map((A) => A.getTag());
  return (0, n.patchTags)(p.concat(a)), patchCBOR$b;
}
var CryptoHDKey$b = {}, src$g, hasRequiredSrc$c;
function requireSrc$c() {
  if (hasRequiredSrc$c) return src$g;
  hasRequiredSrc$c = 1;
  var n = safeBufferExports.Buffer;
  function c(u) {
    if (u.length >= 255)
      throw new TypeError("Alphabet too long");
    for (var p = new Uint8Array(256), a = 0; a < p.length; a++)
      p[a] = 255;
    for (var A = 0; A < u.length; A++) {
      var b = u.charAt(A), F = b.charCodeAt(0);
      if (p[F] !== 255)
        throw new TypeError(b + " is ambiguous");
      p[F] = A;
    }
    var le = u.length, L = u.charAt(0), pe = Math.log(le) / Math.log(256), $ = Math.log(256) / Math.log(le);
    function Ee(Pe) {
      if ((Array.isArray(Pe) || Pe instanceof Uint8Array) && (Pe = n.from(Pe)), !n.isBuffer(Pe))
        throw new TypeError("Expected Buffer");
      if (Pe.length === 0)
        return "";
      for (var nr = 0, ir = 0, or = 0, lr = Pe.length; or !== lr && Pe[or] === 0; )
        or++, nr++;
      for (var Ir = (lr - or) * $ + 1 >>> 0, xr = new Uint8Array(Ir); or !== lr; ) {
        for (var kr = Pe[or], Ce = 0, tr = Ir - 1; (kr !== 0 || Ce < ir) && tr !== -1; tr--, Ce++)
          kr += 256 * xr[tr] >>> 0, xr[tr] = kr % le >>> 0, kr = kr / le >>> 0;
        if (kr !== 0)
          throw new Error("Non-zero carry");
        ir = Ce, or++;
      }
      for (var Fe = Ir - ir; Fe !== Ir && xr[Fe] === 0; )
        Fe++;
      for (var Sr = L.repeat(nr); Fe < Ir; ++Fe)
        Sr += u.charAt(xr[Fe]);
      return Sr;
    }
    function be(Pe) {
      if (typeof Pe != "string")
        throw new TypeError("Expected String");
      if (Pe.length === 0)
        return n.alloc(0);
      for (var nr = 0, ir = 0, or = 0; Pe[nr] === L; )
        ir++, nr++;
      for (var lr = (Pe.length - nr) * pe + 1 >>> 0, Ir = new Uint8Array(lr); nr < Pe.length; ) {
        var xr = Pe.charCodeAt(nr);
        if (xr > 255)
          return;
        var kr = p[xr];
        if (kr === 255)
          return;
        for (var Ce = 0, tr = lr - 1; (kr !== 0 || Ce < or) && tr !== -1; tr--, Ce++)
          kr += le * Ir[tr] >>> 0, Ir[tr] = kr % 256 >>> 0, kr = kr / 256 >>> 0;
        if (kr !== 0)
          throw new Error("Non-zero carry");
        or = Ce, nr++;
      }
      for (var Fe = lr - or; Fe !== lr && Ir[Fe] === 0; )
        Fe++;
      var Sr = n.allocUnsafe(ir + (lr - Fe));
      Sr.fill(0, 0, ir);
      for (var er = ir; Fe !== lr; )
        Sr[er++] = Ir[Fe++];
      return Sr;
    }
    function He(Pe) {
      var nr = be(Pe);
      if (nr)
        return nr;
      throw new Error("Non-base" + le + " character");
    }
    return {
      encode: Ee,
      decodeUnsafe: be,
      decode: He
    };
  }
  return src$g = c, src$g;
}
var bs58$d, hasRequiredBs58$c;
function requireBs58$c() {
  if (hasRequiredBs58$c) return bs58$d;
  hasRequiredBs58$c = 1;
  var n = requireSrc$c(), c = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
  return bs58$d = n(c), bs58$d;
}
var base$h, hasRequiredBase$d;
function requireBase$d() {
  if (hasRequiredBase$d) return base$h;
  hasRequiredBase$d = 1;
  var n = requireBs58$c(), c = safeBufferExports.Buffer;
  return base$h = function(u) {
    function p(F) {
      var le = u(F);
      return n.encode(c.concat([
        F,
        le
      ], F.length + 4));
    }
    function a(F) {
      var le = F.slice(0, -4), L = F.slice(-4), pe = u(le);
      if (!(L[0] ^ pe[0] | L[1] ^ pe[1] | L[2] ^ pe[2] | L[3] ^ pe[3]))
        return le;
    }
    function A(F) {
      var le = n.decodeUnsafe(F);
      if (le)
        return a(le);
    }
    function b(F) {
      var le = n.decode(F), L = a(le);
      if (!L) throw new Error("Invalid checksum");
      return L;
    }
    return {
      encode: p,
      decode: b,
      decodeUnsafe: A
    };
  }, base$h;
}
var bs58check$f, hasRequiredBs58check$c;
function requireBs58check$c() {
  if (hasRequiredBs58check$c) return bs58check$f;
  hasRequiredBs58check$c = 1;
  var n = browser$a, c = requireBase$d();
  function u(p) {
    var a = n("sha256").update(p).digest();
    return n("sha256").update(a).digest();
  }
  return bs58check$f = c(u), bs58check$f;
}
var CryptoCoinInfo$b = {}, RegistryItem$b = {}, hasRequiredRegistryItem$b;
function requireRegistryItem$b() {
  if (hasRequiredRegistryItem$b) return RegistryItem$b;
  hasRequiredRegistryItem$b = 1, Object.defineProperty(RegistryItem$b, "__esModule", { value: !0 }), RegistryItem$b.RegistryItem = void 0;
  const n = dist$t, c = requireLib$c();
  class u {
    constructor() {
      this.toCBOR = () => {
        if (this.toDataItem() === void 0)
          throw new Error(`#[ur-registry][RegistryItem][fn.toCBOR]: registry ${this.getRegistryType()}'s method toDataItem returns undefined`);
        return (0, c.encodeDataItem)(this.toDataItem());
      }, this.toUR = () => new n.UR(this.toCBOR(), this.getRegistryType().getType()), this.toUREncoder = (a, A, b) => {
        const F = this.toUR();
        return new n.UREncoder(F, a, A, b);
      };
    }
  }
  return RegistryItem$b.RegistryItem = u, RegistryItem$b;
}
var hasRequiredCryptoCoinInfo$b;
function requireCryptoCoinInfo$b() {
  return hasRequiredCryptoCoinInfo$b || (hasRequiredCryptoCoinInfo$b = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.CryptoCoinInfo = n.Network = n.Type = void 0;
    const c = requireLib$c(), u = requireRegistryItem$b(), p = requireRegistryType$b();
    var a;
    (function(le) {
      le.type = "1", le.network = "2";
    })(a || (a = {}));
    var A;
    (function(le) {
      le[le.bitcoin = 0] = "bitcoin";
    })(A = n.Type || (n.Type = {}));
    var b;
    (function(le) {
      le[le.mainnet = 0] = "mainnet", le[le.testnet = 1] = "testnet";
    })(b = n.Network || (n.Network = {}));
    class F extends u.RegistryItem {
      constructor(L, pe) {
        super(), this.type = L, this.network = pe, this.getRegistryType = () => p.RegistryTypes.CRYPTO_COIN_INFO, this.getType = () => this.type || A.bitcoin, this.getNetwork = () => this.network || b.mainnet, this.toDataItem = () => {
          const $ = {};
          return this.type && ($[a.type] = this.type), this.network && ($[a.network] = this.network), new c.DataItem($);
        };
      }
    }
    n.CryptoCoinInfo = F, F.fromDataItem = (le) => {
      const L = le.getData(), pe = L[a.type], $ = L[a.network];
      return new F(pe, $);
    }, F.fromCBOR = (le) => {
      const L = (0, c.decodeToDataItem)(le);
      return F.fromDataItem(L);
    };
  }(CryptoCoinInfo$b)), CryptoCoinInfo$b;
}
var CryptoKeypath$b = {}, PathComponent$b = {}, hasRequiredPathComponent$b;
function requirePathComponent$b() {
  if (hasRequiredPathComponent$b) return PathComponent$b;
  hasRequiredPathComponent$b = 1, Object.defineProperty(PathComponent$b, "__esModule", { value: !0 }), PathComponent$b.PathComponent = void 0;
  class n {
    constructor(u) {
      if (this.getIndex = () => this.index, this.isWildcard = () => this.wildcard, this.isHardened = () => this.hardened, this.index = u.index, this.hardened = u.hardened, this.index !== void 0 ? this.wildcard = !1 : this.wildcard = !0, this.index && this.index & n.HARDENED_BIT)
        throw new Error(`#[ur-registry][PathComponent][fn.constructor]: Invalid index ${this.index} - most significant bit cannot be set`);
    }
  }
  return PathComponent$b.PathComponent = n, n.HARDENED_BIT = 2147483648, PathComponent$b;
}
var hasRequiredCryptoKeypath$b;
function requireCryptoKeypath$b() {
  if (hasRequiredCryptoKeypath$b) return CryptoKeypath$b;
  hasRequiredCryptoKeypath$b = 1, Object.defineProperty(CryptoKeypath$b, "__esModule", { value: !0 }), CryptoKeypath$b.CryptoKeypath = void 0;
  const n = requireLib$c(), c = requirePathComponent$b(), u = requireRegistryItem$b(), p = requireRegistryType$b();
  var a;
  (function(b) {
    b[b.components = 1] = "components", b[b.source_fingerprint = 2] = "source_fingerprint", b[b.depth = 3] = "depth";
  })(a || (a = {}));
  class A extends u.RegistryItem {
    constructor(F = [], le, L) {
      super(), this.components = F, this.sourceFingerprint = le, this.depth = L, this.getRegistryType = () => p.RegistryTypes.CRYPTO_KEYPATH, this.getPath = () => this.components.length === 0 ? void 0 : this.components.map(($) => `${$.isWildcard() ? "*" : $.getIndex()}${$.isHardened() ? "'" : ""}`).join("/"), this.getComponents = () => this.components, this.getSourceFingerprint = () => this.sourceFingerprint, this.getDepth = () => this.depth, this.toDataItem = () => {
        const pe = {}, $ = [];
        return this.components && this.components.forEach((Ee) => {
          Ee.isWildcard() ? $.push([]) : $.push(Ee.getIndex()), $.push(Ee.isHardened());
        }), pe[a.components] = $, this.sourceFingerprint && (pe[a.source_fingerprint] = this.sourceFingerprint.readUInt32BE(0)), this.depth !== void 0 && (pe[a.depth] = this.depth), new n.DataItem(pe);
      };
    }
  }
  return CryptoKeypath$b.CryptoKeypath = A, A.fromDataItem = (b) => {
    const F = b.getData(), le = [], L = F[a.components];
    if (L)
      for (let be = 0; be < L.length; be += 2) {
        const He = L[be + 1], Pe = L[be];
        typeof Pe == "number" ? le.push(new c.PathComponent({ index: Pe, hardened: He })) : le.push(new c.PathComponent({ hardened: He }));
      }
    const pe = F[a.source_fingerprint];
    let $;
    pe && ($ = Buffer$f.alloc(4), $.writeUInt32BE(pe, 0));
    const Ee = F[a.depth];
    return new A(le, $, Ee);
  }, A.fromCBOR = (b) => {
    const F = (0, n.decodeToDataItem)(b);
    return A.fromDataItem(F);
  }, CryptoKeypath$b;
}
var hasRequiredCryptoHDKey$b;
function requireCryptoHDKey$b() {
  if (hasRequiredCryptoHDKey$b) return CryptoHDKey$b;
  hasRequiredCryptoHDKey$b = 1, Object.defineProperty(CryptoHDKey$b, "__esModule", { value: !0 }), CryptoHDKey$b.CryptoHDKey = void 0;
  const n = requireBs58check$c(), c = requireCryptoCoinInfo$b(), u = requireCryptoKeypath$b(), p = requireLib$c(), a = requireRegistryItem$b(), A = requireRegistryType$b();
  var b;
  (function(le) {
    le[le.is_master = 1] = "is_master", le[le.is_private = 2] = "is_private", le[le.key_data = 3] = "key_data", le[le.chain_code = 4] = "chain_code", le[le.use_info = 5] = "use_info", le[le.origin = 6] = "origin", le[le.children = 7] = "children", le[le.parent_fingerprint = 8] = "parent_fingerprint", le[le.name = 9] = "name", le[le.note = 10] = "note";
  })(b || (b = {}));
  class F extends a.RegistryItem {
    constructor(L) {
      super(), this.isECKey = () => !1, this.getKey = () => this.key, this.getChainCode = () => this.chainCode, this.isMaster = () => this.master, this.isPrivateKey = () => !!this.privateKey, this.getUseInfo = () => this.useInfo, this.getOrigin = () => this.origin, this.getChildren = () => this.children, this.getParentFingerprint = () => this.parentFingerprint, this.getName = () => this.name, this.getNote = () => this.note, this.getBip32Key = () => {
        var pe, $, Ee;
        let be, He, Pe = 0, nr = Buffer$f.alloc(4).fill(0);
        if (this.isMaster())
          be = Buffer$f.from("0488ADE4", "hex"), He = 0, Pe = 0;
        else {
          He = ((pe = this.getOrigin()) === null || pe === void 0 ? void 0 : pe.getComponents().length) || (($ = this.getOrigin()) === null || $ === void 0 ? void 0 : $.getDepth());
          const xr = (Ee = this.getOrigin()) === null || Ee === void 0 ? void 0 : Ee.getComponents(), kr = xr[xr.length - 1];
          kr && (Pe = kr.isHardened() ? kr.getIndex() + 2147483648 : kr.getIndex(), this.getParentFingerprint() && (nr = this.getParentFingerprint())), this.isPrivateKey() ? be = Buffer$f.from("0488ADE4", "hex") : be = Buffer$f.from("0488B21E", "hex");
        }
        const ir = Buffer$f.alloc(1);
        ir.writeUInt8(He, 0);
        const or = Buffer$f.alloc(4);
        or.writeUInt32BE(Pe, 0);
        const lr = this.getChainCode(), Ir = this.getKey();
        return (0, n.encode)(Buffer$f.concat([be, ir, nr, or, lr, Ir]));
      }, this.getRegistryType = () => A.RegistryTypes.CRYPTO_HDKEY, this.getOutputDescriptorContent = () => {
        var pe, $, Ee, be, He, Pe, nr;
        let ir = "";
        return this.getOrigin() && !((pe = this.getOrigin()) === null || pe === void 0) && pe.getSourceFingerprint() && !(($ = this.getOrigin()) === null || $ === void 0) && $.getPath() && (ir += `${(be = (Ee = this.getOrigin()) === null || Ee === void 0 ? void 0 : Ee.getSourceFingerprint()) === null || be === void 0 ? void 0 : be.toString("hex")}/${(He = this.getOrigin()) === null || He === void 0 ? void 0 : He.getPath()}`), ir += this.getBip32Key(), this.getChildren() && !((Pe = this.getChildren()) === null || Pe === void 0) && Pe.getPath() && (ir += `/${(nr = this.getChildren()) === null || nr === void 0 ? void 0 : nr.getPath()}`), ir;
      }, this.setupMasterKey = (pe) => {
        this.master = !0, this.key = pe.key, this.chainCode = pe.chainCode;
      }, this.setupDeriveKey = (pe) => {
        this.master = !1, this.privateKey = pe.isPrivateKey, this.key = pe.key, this.chainCode = pe.chainCode, this.useInfo = pe.useInfo, this.origin = pe.origin, this.children = pe.children, this.parentFingerprint = pe.parentFingerprint, this.name = pe.name, this.note = pe.note;
      }, this.toDataItem = () => {
        const pe = {};
        if (this.master)
          pe[b.is_master] = !0, pe[b.key_data] = this.key, pe[b.chain_code] = this.chainCode;
        else {
          if (this.privateKey !== void 0 && (pe[b.is_private] = this.privateKey), pe[b.key_data] = this.key, this.chainCode && (pe[b.chain_code] = this.chainCode), this.useInfo) {
            const $ = this.useInfo.toDataItem();
            $.setTag(this.useInfo.getRegistryType().getTag()), pe[b.use_info] = $;
          }
          if (this.origin) {
            const $ = this.origin.toDataItem();
            $.setTag(this.origin.getRegistryType().getTag()), pe[b.origin] = $;
          }
          if (this.children) {
            const $ = this.children.toDataItem();
            $.setTag(this.children.getRegistryType().getTag()), pe[b.children] = $;
          }
          this.parentFingerprint && (pe[b.parent_fingerprint] = this.parentFingerprint.readUInt32BE(0)), this.name !== void 0 && (pe[b.name] = this.name), this.note !== void 0 && (pe[b.note] = this.note);
        }
        return new p.DataItem(pe);
      }, L.isMaster ? this.setupMasterKey(L) : this.setupDeriveKey(L);
    }
  }
  return CryptoHDKey$b.CryptoHDKey = F, F.fromDataItem = (le) => {
    const L = le.getData(), pe = !!L[b.is_master], $ = L[b.is_private], Ee = L[b.key_data], be = L[b.chain_code], He = L[b.use_info] ? c.CryptoCoinInfo.fromDataItem(L[b.use_info]) : void 0, Pe = L[b.origin] ? u.CryptoKeypath.fromDataItem(L[b.origin]) : void 0, nr = L[b.children] ? u.CryptoKeypath.fromDataItem(L[b.children]) : void 0, ir = L[b.parent_fingerprint];
    let or;
    ir && (or = Buffer$f.alloc(4), or.writeUInt32BE(ir, 0));
    const lr = L[b.name], Ir = L[b.note];
    return new F({
      isMaster: pe,
      isPrivateKey: $,
      key: Ee,
      chainCode: be,
      useInfo: He,
      origin: Pe,
      children: nr,
      parentFingerprint: or,
      name: lr,
      note: Ir
    });
  }, F.fromCBOR = (le) => {
    const L = (0, p.decodeToDataItem)(le);
    return F.fromDataItem(L);
  }, CryptoHDKey$b;
}
var CryptoECKey$b = {}, hasRequiredCryptoECKey$b;
function requireCryptoECKey$b() {
  if (hasRequiredCryptoECKey$b) return CryptoECKey$b;
  hasRequiredCryptoECKey$b = 1, Object.defineProperty(CryptoECKey$b, "__esModule", { value: !0 }), CryptoECKey$b.CryptoECKey = void 0;
  const n = requireLib$c(), c = requireRegistryItem$b(), u = requireRegistryType$b();
  var p;
  (function(A) {
    A[A.curve = 1] = "curve", A[A.private = 2] = "private", A[A.data = 3] = "data";
  })(p || (p = {}));
  class a extends c.RegistryItem {
    constructor(b) {
      super(), this.isECKey = () => !0, this.getCurve = () => this.curve || 0, this.isPrivateKey = () => this.privateKey || !1, this.getData = () => this.data, this.getRegistryType = () => u.RegistryTypes.CRYPTO_ECKEY, this.toDataItem = () => {
        const F = {};
        return this.curve && (F[p.curve] = this.curve), this.privateKey !== void 0 && (F[p.private] = this.privateKey), F[p.data] = this.data, new n.DataItem(F);
      }, this.getOutputDescriptorContent = () => this.data.toString("hex"), this.data = b.data, this.curve = b.curve, this.privateKey = b.privateKey || void 0;
    }
  }
  return CryptoECKey$b.CryptoECKey = a, a.fromDataItem = (A) => {
    const b = A.getData(), F = b[p.curve], le = b[p.private], L = b[p.data];
    if (!L)
      throw new Error(`#[ur-registry][CryptoECKey][fn.fromDataItem]: decoded [dataItem][#data.data] is undefined: ${A}`);
    return new a({ data: L, curve: F, privateKey: le });
  }, a.fromCBOR = (A) => {
    const b = (0, n.decodeToDataItem)(A);
    return a.fromDataItem(b);
  }, CryptoECKey$b;
}
var Bytes$c = {}, hasRequiredBytes$c;
function requireBytes$c() {
  if (hasRequiredBytes$c) return Bytes$c;
  hasRequiredBytes$c = 1, Object.defineProperty(Bytes$c, "__esModule", { value: !0 }), Bytes$c.Bytes = void 0;
  const n = requireLib$c(), c = requireRegistryItem$b(), u = requireRegistryType$b();
  class p extends c.RegistryItem {
    constructor(A) {
      super(), this.bytes = A, this.getRegistryType = () => u.RegistryTypes.BYTES, this.getData = () => this.bytes, this.toDataItem = () => new n.DataItem(this.bytes);
    }
  }
  return Bytes$c.Bytes = p, p.fromDataItem = (a) => {
    const A = a.getData();
    if (!A)
      throw new Error(`#[ur-registry][Bytes][fn.fromDataItem]: decoded [dataItem][#data] is undefined: ${a}`);
    return new p(A);
  }, p.fromCBOR = (a) => {
    const A = (0, n.decodeToDataItem)(a);
    return p.fromDataItem(A);
  }, Bytes$c;
}
var CryptoOutput$b = {}, MultiKey$b = {}, hasRequiredMultiKey$b;
function requireMultiKey$b() {
  if (hasRequiredMultiKey$b) return MultiKey$b;
  hasRequiredMultiKey$b = 1, Object.defineProperty(MultiKey$b, "__esModule", { value: !0 }), MultiKey$b.MultiKey = void 0;
  const n = requireCryptoECKey$b(), c = requireCryptoHDKey$b(), u = requireDataItem$b(), p = requireRegistryItem$b(), a = requireRegistryType$b();
  var A;
  (function(F) {
    F[F.threshold = 1] = "threshold", F[F.keys = 2] = "keys";
  })(A || (A = {}));
  class b extends p.RegistryItem {
    constructor(le, L) {
      super(), this.threshold = le, this.keys = L, this.getThreshold = () => this.threshold, this.getKeys = () => this.keys, this.toDataItem = () => {
        const pe = {};
        pe[A.threshold] = this.threshold;
        const $ = this.keys.map((Ee) => {
          const be = Ee.toDataItem();
          return be.setTag(Ee.getRegistryType().getTag()), be;
        });
        return pe[A.keys] = $, new u.DataItem(pe);
      }, this.getOutputDescriptorContent = () => [
        this.getThreshold(),
        this.keys.map((pe) => pe.getOutputDescriptorContent()).join(",")
      ].join(",");
    }
  }
  return MultiKey$b.MultiKey = b, b.fromDataItem = (F) => {
    const le = F.getData(), L = le[A.threshold], pe = le[A.keys], $ = [];
    return pe.forEach((Ee) => {
      Ee.getTag() === a.RegistryTypes.CRYPTO_HDKEY.getTag() ? $.push(c.CryptoHDKey.fromDataItem(Ee)) : Ee.getTag() === a.RegistryTypes.CRYPTO_ECKEY.getTag() && $.push(n.CryptoECKey.fromDataItem(Ee));
    }), new b(L, $);
  }, MultiKey$b;
}
var hasRequiredCryptoOutput$b;
function requireCryptoOutput$b() {
  if (hasRequiredCryptoOutput$b) return CryptoOutput$b;
  hasRequiredCryptoOutput$b = 1, Object.defineProperty(CryptoOutput$b, "__esModule", { value: !0 }), CryptoOutput$b.CryptoOutput = void 0;
  const n = requireCryptoECKey$b(), c = requireCryptoHDKey$b(), u = requireLib$c(), p = requireMultiKey$b(), a = requireRegistryItem$b(), A = requireRegistryType$b(), b = requireScriptExpression$b();
  class F extends a.RegistryItem {
    constructor(L, pe) {
      super(), this.scriptExpressions = L, this.cryptoKey = pe, this.getRegistryType = () => A.RegistryTypes.CRYPTO_OUTPUT, this.getCryptoKey = () => this.cryptoKey, this.getHDKey = () => {
        if (this.cryptoKey instanceof c.CryptoHDKey)
          return this.cryptoKey;
      }, this.getECKey = () => {
        if (this.cryptoKey instanceof n.CryptoECKey)
          return this.cryptoKey;
      }, this.getMultiKey = () => {
        if (this.cryptoKey instanceof p.MultiKey)
          return this.cryptoKey;
      }, this.getScriptExpressions = () => this.scriptExpressions, this._toOutputDescriptor = ($) => $ >= this.scriptExpressions.length ? this.cryptoKey.getOutputDescriptorContent() : `${this.scriptExpressions[$].getExpression()}(${this._toOutputDescriptor($ + 1)})`, this.toString = () => this._toOutputDescriptor(0), this.toDataItem = () => {
        let $ = this.cryptoKey.toDataItem();
        return (this.cryptoKey instanceof n.CryptoECKey || this.cryptoKey instanceof c.CryptoHDKey) && $.setTag(this.cryptoKey.getRegistryType().getTag()), [...this.scriptExpressions].reverse().forEach((be) => {
          const He = be.getTag();
          $.getTag() === void 0 ? $.setTag(He) : $ = new u.DataItem($, He);
        }), $;
      };
    }
  }
  return CryptoOutput$b.CryptoOutput = F, F.fromDataItem = (le) => {
    const L = [];
    let pe = le;
    for (; ; ) {
      let be = pe.getTag();
      const He = b.ScriptExpression.fromTag(be);
      if (He)
        if (L.push(He), pe.getData() instanceof u.DataItem)
          pe = pe.getData(), be = pe.getTag();
        else
          break;
      else
        break;
    }
    const $ = L.length;
    if ($ > 0 && (L[$ - 1].getExpression() === b.ScriptExpressions.MULTISIG.getExpression() || L[$ - 1].getExpression() === b.ScriptExpressions.SORTED_MULTISIG.getExpression())) {
      const be = p.MultiKey.fromDataItem(pe);
      return new F(L, be);
    }
    if (pe.getTag() === A.RegistryTypes.CRYPTO_HDKEY.getTag()) {
      const be = c.CryptoHDKey.fromDataItem(pe);
      return new F(L, be);
    } else {
      const be = n.CryptoECKey.fromDataItem(pe);
      return new F(L, be);
    }
  }, F.fromCBOR = (le) => {
    const L = (0, u.decodeToDataItem)(le);
    return F.fromDataItem(L);
  }, CryptoOutput$b;
}
var CryptoPSBT$b = {}, hasRequiredCryptoPSBT$b;
function requireCryptoPSBT$b() {
  if (hasRequiredCryptoPSBT$b) return CryptoPSBT$b;
  hasRequiredCryptoPSBT$b = 1, Object.defineProperty(CryptoPSBT$b, "__esModule", { value: !0 }), CryptoPSBT$b.CryptoPSBT = void 0;
  const n = requireLib$c(), c = requireRegistryItem$b(), u = requireRegistryType$b();
  class p extends c.RegistryItem {
    constructor(A) {
      super(), this.psbt = A, this.getRegistryType = () => u.RegistryTypes.CRYPTO_PSBT, this.getPSBT = () => this.psbt, this.toDataItem = () => new n.DataItem(this.psbt);
    }
  }
  return CryptoPSBT$b.CryptoPSBT = p, p.fromDataItem = (a) => {
    const A = a.getData();
    if (!A)
      throw new Error(`#[ur-registry][CryptoPSBT][fn.fromDataItem]: decoded [dataItem][#data] is undefined: ${a}`);
    return new p(A);
  }, p.fromCBOR = (a) => {
    const A = (0, n.decodeToDataItem)(a);
    return p.fromDataItem(A);
  }, CryptoPSBT$b;
}
var CryptoAccount$b = {}, hasRequiredCryptoAccount$b;
function requireCryptoAccount$b() {
  if (hasRequiredCryptoAccount$b) return CryptoAccount$b;
  hasRequiredCryptoAccount$b = 1, Object.defineProperty(CryptoAccount$b, "__esModule", { value: !0 }), CryptoAccount$b.CryptoAccount = void 0;
  const n = requireDist$b(), c = requireLib$c(), u = requireRegistryItem$b(), p = requireRegistryType$b();
  var a;
  (function(b) {
    b[b.masterFingerprint = 1] = "masterFingerprint", b[b.outputDescriptors = 2] = "outputDescriptors";
  })(a || (a = {}));
  class A extends u.RegistryItem {
    constructor(F, le) {
      super(), this.masterFingerprint = F, this.outputDescriptors = le, this.getRegistryType = () => p.RegistryTypes.CRYPTO_ACCOUNT, this.getMasterFingerprint = () => this.masterFingerprint, this.getOutputDescriptors = () => this.outputDescriptors, this.toDataItem = () => {
        const L = {};
        return this.masterFingerprint && (L[a.masterFingerprint] = this.masterFingerprint.readUInt32BE(0)), this.outputDescriptors && (L[a.outputDescriptors] = this.outputDescriptors.map((pe) => pe.toDataItem())), new c.DataItem(L);
      };
    }
  }
  return CryptoAccount$b.CryptoAccount = A, A.fromDataItem = (b) => {
    const F = b.getData(), le = Buffer$f.alloc(4), L = F[a.masterFingerprint];
    L && le.writeUInt32BE(L, 0);
    const $ = F[a.outputDescriptors].map((Ee) => n.CryptoOutput.fromDataItem(Ee));
    return new A(le, $);
  }, A.fromCBOR = (b) => {
    const F = (0, c.decodeToDataItem)(b);
    return A.fromDataItem(F);
  }, CryptoAccount$b;
}
var Decoder$b = {}, errors$c = {}, hasRequiredErrors$b;
function requireErrors$b() {
  if (hasRequiredErrors$b) return errors$c;
  hasRequiredErrors$b = 1, Object.defineProperty(errors$c, "__esModule", { value: !0 }), errors$c.UnknownURTypeError = void 0;
  class n extends Error {
    constructor(u) {
      super(u);
    }
  }
  return errors$c.UnknownURTypeError = n, errors$c;
}
var hasRequiredDecoder$b;
function requireDecoder$b() {
  if (hasRequiredDecoder$b) return Decoder$b;
  hasRequiredDecoder$b = 1, Object.defineProperty(Decoder$b, "__esModule", { value: !0 }), Decoder$b.URRegistryDecoder = void 0;
  const n = dist$t, c = requireDist$b(), u = requireRegistryType$b(), p = requireErrors$b();
  class a extends n.URDecoder {
    constructor() {
      super(...arguments), this.resultRegistryType = () => {
        const b = this.resultUR();
        switch (b.type) {
          case u.RegistryTypes.BYTES.getType():
            return c.Bytes.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_HDKEY.getType():
            return c.CryptoHDKey.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_KEYPATH.getType():
            return c.CryptoKeypath.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_COIN_INFO.getType():
            return c.CryptoCoinInfo.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_ECKEY.getType():
            return c.CryptoECKey.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_OUTPUT.getType():
            return c.CryptoOutput.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_PSBT.getType():
            return c.CryptoPSBT.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_ACCOUNT.getType():
            return c.CryptoAccount.fromCBOR(b.cbor);
          default:
            throw new p.UnknownURTypeError(`#[ur-registry][Decoder][fn.resultRegistryType]: registry type ${b.type} is not supported now`);
        }
      };
    }
  }
  return Decoder$b.URRegistryDecoder = a, Decoder$b;
}
var CryptoMultiAccounts$b = {}, hasRequiredCryptoMultiAccounts$b;
function requireCryptoMultiAccounts$b() {
  if (hasRequiredCryptoMultiAccounts$b) return CryptoMultiAccounts$b;
  hasRequiredCryptoMultiAccounts$b = 1, Object.defineProperty(CryptoMultiAccounts$b, "__esModule", { value: !0 }), CryptoMultiAccounts$b.CryptoMultiAccounts = void 0;
  const n = requireRegistryType$b(), c = requireCryptoHDKey$b(), u = requireRegistryItem$b(), p = requireLib$c();
  var a;
  (function(b) {
    b[b.masterFingerprint = 1] = "masterFingerprint", b[b.keys = 2] = "keys", b[b.device = 3] = "device", b[b.deviceId = 4] = "deviceId", b[b.version = 5] = "version";
  })(a || (a = {}));
  class A extends u.RegistryItem {
    constructor(F, le, L, pe, $) {
      super(), this.masterFingerprint = F, this.keys = le, this.device = L, this.deviceId = pe, this.version = $, this.getRegistryType = () => n.RegistryTypes.CRYPTO_MULTI_ACCOUNTS, this.getMasterFingerprint = () => this.masterFingerprint, this.getKeys = () => this.keys, this.getDevice = () => this.device, this.getDeviceId = () => this.deviceId, this.getVersion = () => this.version, this.toDataItem = () => {
        const Ee = {};
        return this.masterFingerprint && (Ee[a.masterFingerprint] = this.masterFingerprint.readUInt32BE(0)), this.keys && (Ee[a.keys] = this.keys.map((be) => {
          const He = be.toDataItem();
          return He.setTag(be.getRegistryType().getTag()), He;
        })), this.device && (Ee[a.device] = this.device), this.deviceId && (Ee[a.deviceId] = this.deviceId), this.version && (Ee[a.version] = this.version), new p.DataItem(Ee);
      };
    }
  }
  return CryptoMultiAccounts$b.CryptoMultiAccounts = A, A.fromDataItem = (b) => {
    const F = b.getData(), le = Buffer$f.alloc(4), L = F[a.masterFingerprint];
    L && le.writeUInt32BE(L, 0);
    const $ = F[a.keys].map((Pe) => c.CryptoHDKey.fromDataItem(Pe)), Ee = F[a.device], be = F[a.deviceId], He = F[a.version];
    return new A(le, $, Ee, be, He);
  }, A.fromCBOR = (b) => {
    const F = (0, p.decodeToDataItem)(b);
    return A.fromDataItem(F);
  }, CryptoMultiAccounts$b;
}
var QRHardwareCall$b = {}, KeyDerivation$b = {}, DerivationSchema$b = {}, hasRequiredDerivationSchema$b;
function requireDerivationSchema$b() {
  return hasRequiredDerivationSchema$b || (hasRequiredDerivationSchema$b = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.KeyDerivationSchema = n.DerivationAlgorithm = n.Curve = void 0;
    const c = requireRegistryType$b(), u = requireRegistryItem$b(), p = requireLib$c(), a = requireCryptoKeypath$b();
    var A;
    (function(L) {
      L[L.keyPath = 1] = "keyPath", L[L.curve = 2] = "curve", L[L.algo = 3] = "algo";
    })(A || (A = {}));
    var b;
    (function(L) {
      L[L.secp256k1 = 0] = "secp256k1", L[L.ed25519 = 1] = "ed25519";
    })(b = n.Curve || (n.Curve = {}));
    var F;
    (function(L) {
      L[L.slip10 = 0] = "slip10", L[L.bip32ed25519 = 1] = "bip32ed25519";
    })(F = n.DerivationAlgorithm || (n.DerivationAlgorithm = {}));
    class le extends u.RegistryItem {
      constructor(pe, $ = b.secp256k1, Ee = F.slip10) {
        super(), this.keypath = pe, this.curve = $, this.algo = Ee, this.getRegistryType = () => c.RegistryTypes.KEY_DERIVATION_SCHEMA, this.getKeypath = () => this.keypath, this.getCurve = () => this.curve, this.getAlgo = () => this.algo, this.toDataItem = () => {
          const be = {}, He = this.getKeypath().toDataItem();
          return He.setTag(this.getKeypath().getRegistryType().getTag()), be[A.keyPath] = He, be[A.curve] = this.curve, be[A.algo] = this.algo, new p.DataItem(be);
        };
      }
    }
    n.KeyDerivationSchema = le, le.fromDataItem = (L) => {
      const pe = L.getData(), $ = a.CryptoKeypath.fromDataItem(pe[A.keyPath]), Ee = pe[A.curve], be = pe[A.algo];
      return new le($, Ee, be);
    }, le.fromCBOR = (L) => {
      const pe = (0, p.decodeToDataItem)(L);
      return le.fromDataItem(pe);
    };
  }(DerivationSchema$b)), DerivationSchema$b;
}
var hasRequiredKeyDerivation$b;
function requireKeyDerivation$b() {
  if (hasRequiredKeyDerivation$b) return KeyDerivation$b;
  hasRequiredKeyDerivation$b = 1, Object.defineProperty(KeyDerivation$b, "__esModule", { value: !0 }), KeyDerivation$b.KeyDerivation = void 0;
  const n = requireRegistryType$b(), c = requireRegistryItem$b(), u = requireLib$c(), p = requireDerivationSchema$b();
  var a;
  (function(b) {
    b[b.schemas = 1] = "schemas";
  })(a || (a = {}));
  class A extends c.RegistryItem {
    constructor(F) {
      super(), this.schemas = F, this.getRegistryType = () => n.RegistryTypes.KEY_DERIVATION_CALL, this.getSchemas = () => this.schemas, this.toDataItem = () => {
        const le = {};
        return le[a.schemas] = this.schemas.map((L) => {
          const pe = L.toDataItem();
          return pe.setTag(L.getRegistryType().getTag()), pe;
        }), new u.DataItem(le);
      };
    }
  }
  return KeyDerivation$b.KeyDerivation = A, A.fromDataItem = (b) => {
    const le = b.getData()[a.schemas].map((L) => p.KeyDerivationSchema.fromDataItem(L));
    return new A(le);
  }, A.fromCBOR = (b) => {
    const F = (0, u.decodeToDataItem)(b);
    return A.fromDataItem(F);
  }, KeyDerivation$b;
}
var hasRequiredQRHardwareCall$b;
function requireQRHardwareCall$b() {
  return hasRequiredQRHardwareCall$b || (hasRequiredQRHardwareCall$b = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.QRHardwareCall = n.QRHardwareCallType = void 0;
    const c = requireRegistryType$b(), u = requireRegistryItem$b(), p = requireLib$c(), a = requireKeyDerivation$b();
    var A;
    (function(le) {
      le[le.type = 1] = "type", le[le.params = 2] = "params", le[le.origin = 3] = "origin";
    })(A || (A = {}));
    var b;
    (function(le) {
      le[le.KeyDerivation = 0] = "KeyDerivation";
    })(b = n.QRHardwareCallType || (n.QRHardwareCallType = {}));
    class F extends u.RegistryItem {
      constructor(L, pe, $) {
        super(), this.type = L, this.params = pe, this.origin = $, this.getRegistryType = () => c.RegistryTypes.QR_HARDWARE_CALL, this.getType = () => this.type, this.getParams = () => this.params, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const Ee = {};
          Ee[A.type] = this.type;
          const be = this.params.toDataItem();
          return be.setTag(this.params.getRegistryType().getTag()), Ee[A.params] = be, this.origin && (Ee[A.origin] = this.origin), new p.DataItem(Ee);
        };
      }
    }
    n.QRHardwareCall = F, F.fromDataItem = (le) => {
      const L = le.getData(), pe = L[A.type] || b.KeyDerivation;
      let $;
      switch (pe) {
        case b.KeyDerivation:
          $ = a.KeyDerivation.fromDataItem(L[A.params]);
      }
      const Ee = L[A.origin];
      return new F(pe, $, Ee);
    }, F.fromCBOR = (le) => {
      const L = (0, p.decodeToDataItem)(le);
      return F.fromDataItem(L);
    };
  }(QRHardwareCall$b)), QRHardwareCall$b;
}
var types$h = {}, hasRequiredTypes$c;
function requireTypes$c() {
  return hasRequiredTypes$c || (hasRequiredTypes$c = 1, Object.defineProperty(types$h, "__esModule", { value: !0 })), types$h;
}
var hasRequiredDist$b;
function requireDist$b() {
  return hasRequiredDist$b || (hasRequiredDist$b = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.Buffer = n.extend = n.PathComponent = n.ScriptExpressions = n.MultiKey = n.CryptoPSBT = n.CryptoOutput = n.CryptoECKey = n.CryptoCoinInfoNetwork = n.CryptoCoinInfoType = n.CryptoCoinInfo = n.CryptoKeypath = n.CryptoMultiAccounts = n.CryptoHDKey = n.CryptoAccount = n.Bytes = n.URRegistryDecoder = n.DataItem = void 0;
    const c = require$$0$4;
    requirePatchCBOR$b();
    const u = dist$u;
    Object.defineProperty(n, "Buffer", { enumerable: !0, get: function() {
      return u.Buffer;
    } });
    const p = requireCryptoHDKey$b();
    Object.defineProperty(n, "CryptoHDKey", { enumerable: !0, get: function() {
      return p.CryptoHDKey;
    } });
    const a = requireCryptoKeypath$b();
    Object.defineProperty(n, "CryptoKeypath", { enumerable: !0, get: function() {
      return a.CryptoKeypath;
    } });
    const A = requireCryptoCoinInfo$b();
    Object.defineProperty(n, "CryptoCoinInfo", { enumerable: !0, get: function() {
      return A.CryptoCoinInfo;
    } }), Object.defineProperty(n, "CryptoCoinInfoType", { enumerable: !0, get: function() {
      return A.Type;
    } }), Object.defineProperty(n, "CryptoCoinInfoNetwork", { enumerable: !0, get: function() {
      return A.Network;
    } });
    const b = requireCryptoECKey$b();
    Object.defineProperty(n, "CryptoECKey", { enumerable: !0, get: function() {
      return b.CryptoECKey;
    } });
    const F = requireBytes$c();
    Object.defineProperty(n, "Bytes", { enumerable: !0, get: function() {
      return F.Bytes;
    } });
    const le = requireCryptoOutput$b();
    Object.defineProperty(n, "CryptoOutput", { enumerable: !0, get: function() {
      return le.CryptoOutput;
    } });
    const L = requireCryptoPSBT$b();
    Object.defineProperty(n, "CryptoPSBT", { enumerable: !0, get: function() {
      return L.CryptoPSBT;
    } });
    const pe = requireCryptoAccount$b();
    Object.defineProperty(n, "CryptoAccount", { enumerable: !0, get: function() {
      return pe.CryptoAccount;
    } });
    const $ = requireDecoder$b();
    Object.defineProperty(n, "URRegistryDecoder", { enumerable: !0, get: function() {
      return $.URRegistryDecoder;
    } });
    const Ee = requireMultiKey$b();
    Object.defineProperty(n, "MultiKey", { enumerable: !0, get: function() {
      return Ee.MultiKey;
    } });
    const be = requireScriptExpression$b();
    Object.defineProperty(n, "ScriptExpressions", { enumerable: !0, get: function() {
      return be.ScriptExpressions;
    } });
    const He = requirePathComponent$b();
    Object.defineProperty(n, "PathComponent", { enumerable: !0, get: function() {
      return He.PathComponent;
    } });
    const Pe = requireRegistryItem$b(), nr = requireRegistryType$b(), ir = requireLib$c();
    var or = requireLib$c();
    Object.defineProperty(n, "DataItem", { enumerable: !0, get: function() {
      return or.DataItem;
    } });
    const lr = requireUtils$e(), Ir = requireCryptoMultiAccounts$b();
    Object.defineProperty(n, "CryptoMultiAccounts", { enumerable: !0, get: function() {
      return Ir.CryptoMultiAccounts;
    } });
    const xr = {
      URRegistryDecoder: $.URRegistryDecoder,
      Bytes: F.Bytes,
      CryptoAccount: pe.CryptoAccount,
      CryptoHDKey: p.CryptoHDKey,
      CryptoMultiAccounts: Ir.CryptoMultiAccounts,
      CryptoKeypath: a.CryptoKeypath,
      CryptoCoinInfo: A.CryptoCoinInfo,
      CryptoCoinInfoType: A.Type,
      CryptoCoinInfoNetwork: A.Network,
      CryptoECKey: b.CryptoECKey,
      CryptoOutput: le.CryptoOutput,
      CryptoPSBT: L.CryptoPSBT,
      MultiKey: Ee.MultiKey,
      ScriptExpressions: be.ScriptExpressions,
      PathComponent: He.PathComponent
    }, kr = {
      addReader: ir.addReader,
      addSemanticDecode: ir.addSemanticDecode,
      addSemanticEncode: ir.addSemanticEncode,
      addWriter: ir.addWriter,
      patchTags: lr.patchTags
    }, Ce = {
      RegistryTypes: nr.RegistryTypes,
      RegistryItem: Pe.RegistryItem,
      RegistryType: nr.RegistryType,
      decodeToDataItem: ir.decodeToDataItem,
      encodeDataItem: ir.encodeDataItem,
      cbor: kr
    };
    n.extend = Ce, (0, c.__exportStar)(requireErrors$b(), n), (0, c.__exportStar)(requireDecoder$b(), n), (0, c.__exportStar)(requireLib$c(), n), (0, c.__exportStar)(requireCryptoAccount$b(), n), (0, c.__exportStar)(requireCryptoPSBT$b(), n), (0, c.__exportStar)(requireCryptoHDKey$b(), n), (0, c.__exportStar)(requireCryptoMultiAccounts$b(), n), (0, c.__exportStar)(requireQRHardwareCall$b(), n), (0, c.__exportStar)(requireKeyDerivation$b(), n), (0, c.__exportStar)(requireDerivationSchema$b(), n), (0, c.__exportStar)(requireCryptoOutput$b(), n), (0, c.__exportStar)(requireCryptoCoinInfo$b(), n), (0, c.__exportStar)(requireCryptoECKey$b(), n), (0, c.__exportStar)(requireMultiKey$b(), n), (0, c.__exportStar)(requireCryptoKeypath$b(), n), (0, c.__exportStar)(requirePatchCBOR$b(), n), (0, c.__exportStar)(requirePathComponent$b(), n), (0, c.__exportStar)(requireRegistryItem$b(), n), (0, c.__exportStar)(requireRegistryType$b(), n), (0, c.__exportStar)(requireTypes$c(), n), (0, c.__exportStar)(requireUtils$e(), n), n.default = xr;
  }(dist$r)), dist$r;
}
var getRandomValues$b, rnds8$9 = new Uint8Array(16);
function rng$c() {
  if (!getRandomValues$b && (getRandomValues$b = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !getRandomValues$b))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return getRandomValues$b(rnds8$9);
}
const REGEX$8 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function validate$c(n) {
  return typeof n == "string" && REGEX$8.test(n);
}
var byteToHex$9 = [];
for (var i$a = 0; i$a < 256; ++i$a)
  byteToHex$9.push((i$a + 256).toString(16).substr(1));
function stringify$b(n) {
  var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, u = (byteToHex$9[n[c + 0]] + byteToHex$9[n[c + 1]] + byteToHex$9[n[c + 2]] + byteToHex$9[n[c + 3]] + "-" + byteToHex$9[n[c + 4]] + byteToHex$9[n[c + 5]] + "-" + byteToHex$9[n[c + 6]] + byteToHex$9[n[c + 7]] + "-" + byteToHex$9[n[c + 8]] + byteToHex$9[n[c + 9]] + "-" + byteToHex$9[n[c + 10]] + byteToHex$9[n[c + 11]] + byteToHex$9[n[c + 12]] + byteToHex$9[n[c + 13]] + byteToHex$9[n[c + 14]] + byteToHex$9[n[c + 15]]).toLowerCase();
  if (!validate$c(u))
    throw TypeError("Stringified UUID is invalid");
  return u;
}
var _nodeId$8, _clockseq$8, _lastMSecs$8 = 0, _lastNSecs$8 = 0;
function v1$b(n, c, u) {
  var p = c && u || 0, a = c || new Array(16);
  n = n || {};
  var A = n.node || _nodeId$8, b = n.clockseq !== void 0 ? n.clockseq : _clockseq$8;
  if (A == null || b == null) {
    var F = n.random || (n.rng || rng$c)();
    A == null && (A = _nodeId$8 = [F[0] | 1, F[1], F[2], F[3], F[4], F[5]]), b == null && (b = _clockseq$8 = (F[6] << 8 | F[7]) & 16383);
  }
  var le = n.msecs !== void 0 ? n.msecs : Date.now(), L = n.nsecs !== void 0 ? n.nsecs : _lastNSecs$8 + 1, pe = le - _lastMSecs$8 + (L - _lastNSecs$8) / 1e4;
  if (pe < 0 && n.clockseq === void 0 && (b = b + 1 & 16383), (pe < 0 || le > _lastMSecs$8) && n.nsecs === void 0 && (L = 0), L >= 1e4)
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  _lastMSecs$8 = le, _lastNSecs$8 = L, _clockseq$8 = b, le += 122192928e5;
  var $ = ((le & 268435455) * 1e4 + L) % 4294967296;
  a[p++] = $ >>> 24 & 255, a[p++] = $ >>> 16 & 255, a[p++] = $ >>> 8 & 255, a[p++] = $ & 255;
  var Ee = le / 4294967296 * 1e4 & 268435455;
  a[p++] = Ee >>> 8 & 255, a[p++] = Ee & 255, a[p++] = Ee >>> 24 & 15 | 16, a[p++] = Ee >>> 16 & 255, a[p++] = b >>> 8 | 128, a[p++] = b & 255;
  for (var be = 0; be < 6; ++be)
    a[p + be] = A[be];
  return c || stringify$b(a);
}
function parse$i(n) {
  if (!validate$c(n))
    throw TypeError("Invalid UUID");
  var c, u = new Uint8Array(16);
  return u[0] = (c = parseInt(n.slice(0, 8), 16)) >>> 24, u[1] = c >>> 16 & 255, u[2] = c >>> 8 & 255, u[3] = c & 255, u[4] = (c = parseInt(n.slice(9, 13), 16)) >>> 8, u[5] = c & 255, u[6] = (c = parseInt(n.slice(14, 18), 16)) >>> 8, u[7] = c & 255, u[8] = (c = parseInt(n.slice(19, 23), 16)) >>> 8, u[9] = c & 255, u[10] = (c = parseInt(n.slice(24, 36), 16)) / 1099511627776 & 255, u[11] = c / 4294967296 & 255, u[12] = c >>> 24 & 255, u[13] = c >>> 16 & 255, u[14] = c >>> 8 & 255, u[15] = c & 255, u;
}
function stringToBytes$9(n) {
  n = unescape(encodeURIComponent(n));
  for (var c = [], u = 0; u < n.length; ++u)
    c.push(n.charCodeAt(u));
  return c;
}
var DNS$8 = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", URL$9 = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
function v35$b(n, c, u) {
  function p(a, A, b, F) {
    if (typeof a == "string" && (a = stringToBytes$9(a)), typeof A == "string" && (A = parse$i(A)), A.length !== 16)
      throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    var le = new Uint8Array(16 + a.length);
    if (le.set(A), le.set(a, A.length), le = u(le), le[6] = le[6] & 15 | c, le[8] = le[8] & 63 | 128, b) {
      F = F || 0;
      for (var L = 0; L < 16; ++L)
        b[F + L] = le[L];
      return b;
    }
    return stringify$b(le);
  }
  try {
    p.name = n;
  } catch {
  }
  return p.DNS = DNS$8, p.URL = URL$9, p;
}
function md5$d(n) {
  if (typeof n == "string") {
    var c = unescape(encodeURIComponent(n));
    n = new Uint8Array(c.length);
    for (var u = 0; u < c.length; ++u)
      n[u] = c.charCodeAt(u);
  }
  return md5ToHexEncodedArray$8(wordsToMd5$8(bytesToWords$8(n), n.length * 8));
}
function md5ToHexEncodedArray$8(n) {
  for (var c = [], u = n.length * 32, p = "0123456789abcdef", a = 0; a < u; a += 8) {
    var A = n[a >> 5] >>> a % 32 & 255, b = parseInt(p.charAt(A >>> 4 & 15) + p.charAt(A & 15), 16);
    c.push(b);
  }
  return c;
}
function getOutputLength$8(n) {
  return (n + 64 >>> 9 << 4) + 14 + 1;
}
function wordsToMd5$8(n, c) {
  n[c >> 5] |= 128 << c % 32, n[getOutputLength$8(c) - 1] = c;
  for (var u = 1732584193, p = -271733879, a = -1732584194, A = 271733878, b = 0; b < n.length; b += 16) {
    var F = u, le = p, L = a, pe = A;
    u = md5ff$8(u, p, a, A, n[b], 7, -680876936), A = md5ff$8(A, u, p, a, n[b + 1], 12, -389564586), a = md5ff$8(a, A, u, p, n[b + 2], 17, 606105819), p = md5ff$8(p, a, A, u, n[b + 3], 22, -1044525330), u = md5ff$8(u, p, a, A, n[b + 4], 7, -176418897), A = md5ff$8(A, u, p, a, n[b + 5], 12, 1200080426), a = md5ff$8(a, A, u, p, n[b + 6], 17, -1473231341), p = md5ff$8(p, a, A, u, n[b + 7], 22, -45705983), u = md5ff$8(u, p, a, A, n[b + 8], 7, 1770035416), A = md5ff$8(A, u, p, a, n[b + 9], 12, -1958414417), a = md5ff$8(a, A, u, p, n[b + 10], 17, -42063), p = md5ff$8(p, a, A, u, n[b + 11], 22, -1990404162), u = md5ff$8(u, p, a, A, n[b + 12], 7, 1804603682), A = md5ff$8(A, u, p, a, n[b + 13], 12, -40341101), a = md5ff$8(a, A, u, p, n[b + 14], 17, -1502002290), p = md5ff$8(p, a, A, u, n[b + 15], 22, 1236535329), u = md5gg$8(u, p, a, A, n[b + 1], 5, -165796510), A = md5gg$8(A, u, p, a, n[b + 6], 9, -1069501632), a = md5gg$8(a, A, u, p, n[b + 11], 14, 643717713), p = md5gg$8(p, a, A, u, n[b], 20, -373897302), u = md5gg$8(u, p, a, A, n[b + 5], 5, -701558691), A = md5gg$8(A, u, p, a, n[b + 10], 9, 38016083), a = md5gg$8(a, A, u, p, n[b + 15], 14, -660478335), p = md5gg$8(p, a, A, u, n[b + 4], 20, -405537848), u = md5gg$8(u, p, a, A, n[b + 9], 5, 568446438), A = md5gg$8(A, u, p, a, n[b + 14], 9, -1019803690), a = md5gg$8(a, A, u, p, n[b + 3], 14, -187363961), p = md5gg$8(p, a, A, u, n[b + 8], 20, 1163531501), u = md5gg$8(u, p, a, A, n[b + 13], 5, -1444681467), A = md5gg$8(A, u, p, a, n[b + 2], 9, -51403784), a = md5gg$8(a, A, u, p, n[b + 7], 14, 1735328473), p = md5gg$8(p, a, A, u, n[b + 12], 20, -1926607734), u = md5hh$8(u, p, a, A, n[b + 5], 4, -378558), A = md5hh$8(A, u, p, a, n[b + 8], 11, -2022574463), a = md5hh$8(a, A, u, p, n[b + 11], 16, 1839030562), p = md5hh$8(p, a, A, u, n[b + 14], 23, -35309556), u = md5hh$8(u, p, a, A, n[b + 1], 4, -1530992060), A = md5hh$8(A, u, p, a, n[b + 4], 11, 1272893353), a = md5hh$8(a, A, u, p, n[b + 7], 16, -155497632), p = md5hh$8(p, a, A, u, n[b + 10], 23, -1094730640), u = md5hh$8(u, p, a, A, n[b + 13], 4, 681279174), A = md5hh$8(A, u, p, a, n[b], 11, -358537222), a = md5hh$8(a, A, u, p, n[b + 3], 16, -722521979), p = md5hh$8(p, a, A, u, n[b + 6], 23, 76029189), u = md5hh$8(u, p, a, A, n[b + 9], 4, -640364487), A = md5hh$8(A, u, p, a, n[b + 12], 11, -421815835), a = md5hh$8(a, A, u, p, n[b + 15], 16, 530742520), p = md5hh$8(p, a, A, u, n[b + 2], 23, -995338651), u = md5ii$8(u, p, a, A, n[b], 6, -198630844), A = md5ii$8(A, u, p, a, n[b + 7], 10, 1126891415), a = md5ii$8(a, A, u, p, n[b + 14], 15, -1416354905), p = md5ii$8(p, a, A, u, n[b + 5], 21, -57434055), u = md5ii$8(u, p, a, A, n[b + 12], 6, 1700485571), A = md5ii$8(A, u, p, a, n[b + 3], 10, -1894986606), a = md5ii$8(a, A, u, p, n[b + 10], 15, -1051523), p = md5ii$8(p, a, A, u, n[b + 1], 21, -2054922799), u = md5ii$8(u, p, a, A, n[b + 8], 6, 1873313359), A = md5ii$8(A, u, p, a, n[b + 15], 10, -30611744), a = md5ii$8(a, A, u, p, n[b + 6], 15, -1560198380), p = md5ii$8(p, a, A, u, n[b + 13], 21, 1309151649), u = md5ii$8(u, p, a, A, n[b + 4], 6, -145523070), A = md5ii$8(A, u, p, a, n[b + 11], 10, -1120210379), a = md5ii$8(a, A, u, p, n[b + 2], 15, 718787259), p = md5ii$8(p, a, A, u, n[b + 9], 21, -343485551), u = safeAdd$8(u, F), p = safeAdd$8(p, le), a = safeAdd$8(a, L), A = safeAdd$8(A, pe);
  }
  return [u, p, a, A];
}
function bytesToWords$8(n) {
  if (n.length === 0)
    return [];
  for (var c = n.length * 8, u = new Uint32Array(getOutputLength$8(c)), p = 0; p < c; p += 8)
    u[p >> 5] |= (n[p / 8] & 255) << p % 32;
  return u;
}
function safeAdd$8(n, c) {
  var u = (n & 65535) + (c & 65535), p = (n >> 16) + (c >> 16) + (u >> 16);
  return p << 16 | u & 65535;
}
function bitRotateLeft$8(n, c) {
  return n << c | n >>> 32 - c;
}
function md5cmn$8(n, c, u, p, a, A) {
  return safeAdd$8(bitRotateLeft$8(safeAdd$8(safeAdd$8(c, n), safeAdd$8(p, A)), a), u);
}
function md5ff$8(n, c, u, p, a, A, b) {
  return md5cmn$8(c & u | ~c & p, n, c, a, A, b);
}
function md5gg$8(n, c, u, p, a, A, b) {
  return md5cmn$8(c & p | u & ~p, n, c, a, A, b);
}
function md5hh$8(n, c, u, p, a, A, b) {
  return md5cmn$8(c ^ u ^ p, n, c, a, A, b);
}
function md5ii$8(n, c, u, p, a, A, b) {
  return md5cmn$8(u ^ (c | ~p), n, c, a, A, b);
}
var v3$b = v35$b("v3", 48, md5$d);
function v4$c(n, c, u) {
  n = n || {};
  var p = n.random || (n.rng || rng$c)();
  if (p[6] = p[6] & 15 | 64, p[8] = p[8] & 63 | 128, c) {
    u = u || 0;
    for (var a = 0; a < 16; ++a)
      c[u + a] = p[a];
    return c;
  }
  return stringify$b(p);
}
function f$b(n, c, u, p) {
  switch (n) {
    case 0:
      return c & u ^ ~c & p;
    case 1:
      return c ^ u ^ p;
    case 2:
      return c & u ^ c & p ^ u & p;
    case 3:
      return c ^ u ^ p;
  }
}
function ROTL$8(n, c) {
  return n << c | n >>> 32 - c;
}
function sha1$b(n) {
  var c = [1518500249, 1859775393, 2400959708, 3395469782], u = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
  if (typeof n == "string") {
    var p = unescape(encodeURIComponent(n));
    n = [];
    for (var a = 0; a < p.length; ++a)
      n.push(p.charCodeAt(a));
  } else Array.isArray(n) || (n = Array.prototype.slice.call(n));
  n.push(128);
  for (var A = n.length / 4 + 2, b = Math.ceil(A / 16), F = new Array(b), le = 0; le < b; ++le) {
    for (var L = new Uint32Array(16), pe = 0; pe < 16; ++pe)
      L[pe] = n[le * 64 + pe * 4] << 24 | n[le * 64 + pe * 4 + 1] << 16 | n[le * 64 + pe * 4 + 2] << 8 | n[le * 64 + pe * 4 + 3];
    F[le] = L;
  }
  F[b - 1][14] = (n.length - 1) * 8 / Math.pow(2, 32), F[b - 1][14] = Math.floor(F[b - 1][14]), F[b - 1][15] = (n.length - 1) * 8 & 4294967295;
  for (var $ = 0; $ < b; ++$) {
    for (var Ee = new Uint32Array(80), be = 0; be < 16; ++be)
      Ee[be] = F[$][be];
    for (var He = 16; He < 80; ++He)
      Ee[He] = ROTL$8(Ee[He - 3] ^ Ee[He - 8] ^ Ee[He - 14] ^ Ee[He - 16], 1);
    for (var Pe = u[0], nr = u[1], ir = u[2], or = u[3], lr = u[4], Ir = 0; Ir < 80; ++Ir) {
      var xr = Math.floor(Ir / 20), kr = ROTL$8(Pe, 5) + f$b(xr, nr, ir, or) + lr + c[xr] + Ee[Ir] >>> 0;
      lr = or, or = ir, ir = ROTL$8(nr, 30) >>> 0, nr = Pe, Pe = kr;
    }
    u[0] = u[0] + Pe >>> 0, u[1] = u[1] + nr >>> 0, u[2] = u[2] + ir >>> 0, u[3] = u[3] + or >>> 0, u[4] = u[4] + lr >>> 0;
  }
  return [u[0] >> 24 & 255, u[0] >> 16 & 255, u[0] >> 8 & 255, u[0] & 255, u[1] >> 24 & 255, u[1] >> 16 & 255, u[1] >> 8 & 255, u[1] & 255, u[2] >> 24 & 255, u[2] >> 16 & 255, u[2] >> 8 & 255, u[2] & 255, u[3] >> 24 & 255, u[3] >> 16 & 255, u[3] >> 8 & 255, u[3] & 255, u[4] >> 24 & 255, u[4] >> 16 & 255, u[4] >> 8 & 255, u[4] & 255];
}
var v5$b = v35$b("v5", 80, sha1$b);
const nil$b = "00000000-0000-0000-0000-000000000000";
function version$d(n) {
  if (!validate$c(n))
    throw TypeError("Invalid UUID");
  return parseInt(n.substr(14, 1), 16);
}
const esmBrowser$8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  NIL: nil$b,
  parse: parse$i,
  stringify: stringify$b,
  v1: v1$b,
  v3: v3$b,
  v4: v4$c,
  v5: v5$b,
  validate: validate$c,
  version: version$d
}, Symbol.toStringTag, { value: "Module" })), require$$1$a = /* @__PURE__ */ getAugmentedNamespace(esmBrowser$8);
var hasRequiredBcUrRegistryBtc_cjs_production_min;
function requireBcUrRegistryBtc_cjs_production_min() {
  return hasRequiredBcUrRegistryBtc_cjs_production_min || (hasRequiredBcUrRegistryBtc_cjs_production_min = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 });
    var c = requireDist$b(), u = require$$1$a;
    const p = { BTC_SIGN_REQUEST: new c.RegistryType("btc-sign-request", 8101), BTC_SIGNATURE: new c.RegistryType("btc-signature", 8102) }, { decodeToDataItem: a, RegistryTypes: A } = c.extend;
    var b, F;
    (b = n.DataType || (n.DataType = {}))[b.message = 1] = "message", function(be) {
      be[be.requestId = 1] = "requestId", be[be.signData = 2] = "signData", be[be.dataType = 3] = "dataType", be[be.derivationPaths = 4] = "derivationPaths", be[be.addresses = 5] = "addresses", be[be.origin = 6] = "origin";
    }(F || (F = {}));
    class le extends c.RegistryItem {
      constructor(He) {
        super(), this.getRegistryType = () => p.BTC_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDataype = () => this.dataType, this.getDerivationPaths = () => this.derivationPaths.map((Pe) => Pe.getPath()), this.getAddress = () => this.addresses, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const Pe = {};
          return Pe[F.requestId] = new c.DataItem(this.requestId, A.UUID.getTag()), Pe[F.signData] = this.signData, Pe[F.dataType] = this.dataType, Pe[F.derivationPaths] = this.derivationPaths.map((nr) => {
            const ir = nr.toDataItem();
            return ir.setTag(nr.getRegistryType().getTag()), ir;
          }), this.addresses && (Pe[F.addresses] = this.addresses), this.origin && (Pe[F.origin] = this.origin), new c.DataItem(Pe);
        }, this.requestId = He.requestId, this.signData = He.signData, this.dataType = He.dataType, this.derivationPaths = He.derivationPaths, this.addresses = He.addresses, this.origin = He.origin;
      }
      static constructBtcRequest(He, Pe, nr, ir, or, lr, Ir) {
        const xr = or.map((kr, Ce) => {
          const tr = kr.replace(/[m|M]\//, "").split("/").map((Fe) => {
            const Sr = parseInt(Fe.replace("'", ""));
            let er = !1;
            return Fe.endsWith("'") && (er = !0), new c.PathComponent({ index: Sr, hardened: er });
          });
          return new c.CryptoKeypath(tr, Buffer$f.from(Pe[Ce], "hex"));
        });
        return new le({ requestId: Buffer$f.from(u.parse(He)), signData: nr, dataType: ir || n.DataType.message, derivationPaths: xr, addresses: lr || void 0, origin: Ir || void 0 });
      }
    }
    le.fromDataItem = (be) => {
      const He = be.getData(), Pe = He[F.requestId] ? He[F.requestId].getData() : void 0, nr = He[F.signData], ir = He[F.dataType], or = He[F.derivationPaths].map((lr) => c.CryptoKeypath.fromDataItem(lr));
      return new le({ requestId: Pe, signData: nr, dataType: ir, derivationPaths: or, addresses: He[F.addresses] ? He[F.addresses] : void 0, origin: He[F.origin] ? He[F.origin] : void 0 });
    }, le.fromCBOR = (be) => {
      const He = a(be);
      return le.fromDataItem(He);
    };
    const { RegistryTypes: L, decodeToDataItem: pe } = c.extend;
    var $;
    (function(be) {
      be[be.requestId = 1] = "requestId", be[be.signature = 2] = "signature", be[be.publicKey = 3] = "publicKey";
    })($ || ($ = {}));
    class Ee extends c.RegistryItem {
      constructor(He, Pe, nr) {
        super(), this.getRegistryType = () => p.BTC_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.getPublicKey = () => this.publicKey, this.toDataItem = () => {
          const ir = {};
          return ir[$.requestId] = new c.DataItem(this.requestId, L.UUID.getTag()), ir[$.signature] = this.signature, ir[$.publicKey] = this.publicKey, new c.DataItem(ir);
        }, this.signature = He, this.requestId = Pe, this.publicKey = nr;
      }
    }
    Ee.fromDataItem = (be) => {
      const He = be.getData(), Pe = He[$.signature], nr = He[$.requestId].getData();
      return new Ee(Pe, nr, He[$.publicKey]);
    }, Ee.fromCBOR = (be) => {
      const He = pe(be);
      return Ee.fromDataItem(He);
    }, c.patchTags(Object.values(p).filter((be) => !!be.getTag()).map((be) => be.getTag())), Object.keys(c).forEach(function(be) {
      be !== "default" && Object.defineProperty(n, be, { enumerable: !0, get: function() {
        return c[be];
      } });
    }), n.BtcSignRequest = le, n.BtcSignature = Ee;
  }(bcUrRegistryBtc_cjs_production_min)), bcUrRegistryBtc_cjs_production_min;
}
var bcUrRegistryBtc_cjs_development = {}, hasRequiredBcUrRegistryBtc_cjs_development;
function requireBcUrRegistryBtc_cjs_development() {
  return hasRequiredBcUrRegistryBtc_cjs_development || (hasRequiredBcUrRegistryBtc_cjs_development = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 });
    var c = requireDist$b(), u = require$$1$a;
    const p = {
      BTC_SIGN_REQUEST: /* @__PURE__ */ new c.RegistryType("btc-sign-request", 8101),
      BTC_SIGNATURE: /* @__PURE__ */ new c.RegistryType("btc-signature", 8102)
    }, {
      decodeToDataItem: a,
      RegistryTypes: A
    } = c.extend;
    (function(Ee) {
      Ee[Ee.message = 1] = "message";
    })(n.DataType || (n.DataType = {}));
    var b;
    (function(Ee) {
      Ee[Ee.requestId = 1] = "requestId", Ee[Ee.signData = 2] = "signData", Ee[Ee.dataType = 3] = "dataType", Ee[Ee.derivationPaths = 4] = "derivationPaths", Ee[Ee.addresses = 5] = "addresses", Ee[Ee.origin = 6] = "origin";
    })(b || (b = {}));
    class F extends c.RegistryItem {
      constructor(be) {
        super(), this.getRegistryType = () => p.BTC_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDataype = () => this.dataType, this.getDerivationPaths = () => this.derivationPaths.map((He) => He.getPath()), this.getAddress = () => this.addresses, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const He = {};
          return He[b.requestId] = new c.DataItem(this.requestId, A.UUID.getTag()), He[b.signData] = this.signData, He[b.dataType] = this.dataType, He[b.derivationPaths] = this.derivationPaths.map((Pe) => {
            const nr = Pe.toDataItem();
            return nr.setTag(Pe.getRegistryType().getTag()), nr;
          }), this.addresses && (He[b.addresses] = this.addresses), this.origin && (He[b.origin] = this.origin), new c.DataItem(He);
        }, this.requestId = be.requestId, this.signData = be.signData, this.dataType = be.dataType, this.derivationPaths = be.derivationPaths, this.addresses = be.addresses, this.origin = be.origin;
      }
      static constructBtcRequest(be, He, Pe, nr, ir, or, lr) {
        const Ir = ir.map((xr, kr) => {
          const tr = xr.replace(/[m|M]\//, "").split("/").map((Fe) => {
            const Sr = parseInt(Fe.replace("'", ""));
            let er = !1;
            return Fe.endsWith("'") && (er = !0), new c.PathComponent({
              index: Sr,
              hardened: er
            });
          });
          return new c.CryptoKeypath(tr, Buffer$f.from(He[kr], "hex"));
        });
        return new F({
          requestId: Buffer$f.from(u.parse(be)),
          signData: Pe,
          dataType: nr || n.DataType.message,
          derivationPaths: Ir,
          addresses: or || void 0,
          origin: lr || void 0
        });
      }
    }
    F.fromDataItem = (Ee) => {
      const be = Ee.getData(), He = be[b.requestId] ? be[b.requestId].getData() : void 0, Pe = be[b.signData], nr = be[b.dataType], ir = be[b.derivationPaths].map((Ir) => c.CryptoKeypath.fromDataItem(Ir)), or = be[b.addresses] ? be[b.addresses] : void 0, lr = be[b.origin] ? be[b.origin] : void 0;
      return new F({
        requestId: He,
        signData: Pe,
        dataType: nr,
        derivationPaths: ir,
        addresses: or,
        origin: lr
      });
    }, F.fromCBOR = (Ee) => {
      const be = a(Ee);
      return F.fromDataItem(be);
    };
    const {
      RegistryTypes: le,
      decodeToDataItem: L
    } = c.extend;
    var pe;
    (function(Ee) {
      Ee[Ee.requestId = 1] = "requestId", Ee[Ee.signature = 2] = "signature", Ee[Ee.publicKey = 3] = "publicKey";
    })(pe || (pe = {}));
    class $ extends c.RegistryItem {
      constructor(be, He, Pe) {
        super(), this.getRegistryType = () => p.BTC_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.getPublicKey = () => this.publicKey, this.toDataItem = () => {
          const nr = {};
          return nr[pe.requestId] = new c.DataItem(this.requestId, le.UUID.getTag()), nr[pe.signature] = this.signature, nr[pe.publicKey] = this.publicKey, new c.DataItem(nr);
        }, this.signature = be, this.requestId = He, this.publicKey = Pe;
      }
    }
    $.fromDataItem = (Ee) => {
      const be = Ee.getData(), He = be[pe.signature], Pe = be[pe.requestId].getData(), nr = be[pe.publicKey];
      return new $(He, Pe, nr);
    }, $.fromCBOR = (Ee) => {
      const be = L(Ee);
      return $.fromDataItem(be);
    }, c.patchTags(Object.values(p).filter((Ee) => !!Ee.getTag()).map((Ee) => Ee.getTag())), Object.keys(c).forEach(function(Ee) {
      Ee !== "default" && Object.defineProperty(n, Ee, {
        enumerable: !0,
        get: function() {
          return c[Ee];
        }
      });
    }), n.BtcSignRequest = F, n.BtcSignature = $;
  }(bcUrRegistryBtc_cjs_development)), bcUrRegistryBtc_cjs_development;
}
process$1.env.NODE_ENV === "production" ? dist$s.exports = requireBcUrRegistryBtc_cjs_production_min() : dist$s.exports = requireBcUrRegistryBtc_cjs_development();
var distExports$c = dist$s.exports, ur = {};
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.URType = n.UR = void 0;
  var c = dist$t;
  Object.defineProperty(n, "UR", { enumerable: !0, get: function() {
    return c.UR;
  } }), function(u) {
    u.CryptoPSBT = "crypto-psbt", u.CryptoMultiAccounts = "crypto-multi-accounts", u.CryptoHDKey = "crypto-hdkey", u.CryptoAccount = "crypto-account", u.BtcSignature = "btc-signature", u.ArweaveCryptoAccount = "arweave-crypto-account", u.EthSignature = "eth-signature", u.SolSignature = "sol-signature", u.StellarSignature = "stellar-signature", u.CosmosSignature = "cosmos-signature", u.EvmSignature = "evm-signature", u.AptosSignature = "aptos-signature", u.CardanoSignature = "cardano-signature", u.CardanoSignDataSignature = "cardano-sign-data-signature", u.CardanoSignCip8DataSignature = "cardano-sign-cip8-data-signature", u.CardanoCatalystSignature = "cardano-catalyst-voting-registration-signature", u.TronSignature = "keystone-sign-result", u.KeystoneSignResult = "keystone-sign-result", u.NearSignature = "near-signature", u.ArweaveSignature = "arweave-signature", u.SuiSignature = "sui-signature", u.XrpAccount = "bytes", u.XrpSignRequest = "bytes", u.XrpSignature = "bytes", u.TonSignature = "ton-signature";
  }(n.URType || (n.URType = {}));
})(ur);
Object.defineProperty(bitcoin$1, "__esModule", { value: !0 });
bitcoin$1.KeystoneBitcoinSDK = void 0;
const bc_ur_registry_1$3 = requireDist$c(), bc_ur_registry_btc_1 = distExports$c, utils_1$n = utils$K, ur_1$c = ur;
class KeystoneBitcoinSDK {
  constructor(c) {
    this.config = c;
  }
  parsePSBT(c) {
    if (c.type !== ur_1$c.URType.CryptoPSBT)
      throw new Error("type not match");
    return (0, utils_1$n.toHex)(bc_ur_registry_1$3.CryptoPSBT.fromCBOR(c.cbor).getPSBT());
  }
  generatePSBT(c) {
    return new bc_ur_registry_1$3.CryptoPSBT(c).toUR();
  }
  generateSignRequest({ requestId: c, signData: u, dataType: p, accounts: a, origin: A }) {
    var b;
    const F = [], le = [];
    return a.forEach((L) => {
      var pe;
      F.push(new bc_ur_registry_btc_1.CryptoKeypath((0, utils_1$n.parsePath)(L.path).map(($) => new bc_ur_registry_btc_1.PathComponent($)), (0, utils_1$n.toBuffer)(L.xfp))), le.push((pe = L.address) !== null && pe !== void 0 ? pe : "");
    }), new bc_ur_registry_btc_1.BtcSignRequest({
      signData: (0, utils_1$n.toBuffer)(u),
      dataType: p,
      derivationPaths: F,
      requestId: (0, utils_1$n.uuidParse)(c),
      addresses: le,
      origin: A ?? ((b = this.config) === null || b === void 0 ? void 0 : b.origin)
    }).toUR();
  }
  parseSignature(c) {
    if (c.type !== ur_1$c.URType.BtcSignature)
      throw new Error("type not match");
    const u = bc_ur_registry_btc_1.BtcSignature.fromCBOR(c.cbor);
    return {
      requestId: (0, utils_1$n.uuidStringify)(u.getRequestId()),
      signature: (0, utils_1$n.toHex)(u.getSignature()),
      publicKey: (0, utils_1$n.toHex)(u.getPublicKey())
    };
  }
}
KeystoneBitcoinSDK.DataType = bc_ur_registry_btc_1.DataType;
bitcoin$1.KeystoneBitcoinSDK = KeystoneBitcoinSDK;
var cosmos = {}, dist$q = { exports: {} }, bcUrRegistryCosmos_cjs_production_min = {}, dist$p = {}, patchCBOR$a = {}, utils$G = {}, lib$d = {}, cborSync$a = { exports: {} }, DataItem$a = {}, hasRequiredDataItem$a;
function requireDataItem$a() {
  if (hasRequiredDataItem$a) return DataItem$a;
  hasRequiredDataItem$a = 1, Object.defineProperty(DataItem$a, "__esModule", { value: !0 }), DataItem$a.DataItem = void 0;
  class n {
    constructor(u, p) {
      this.setTag = (a) => {
        this.tag = a;
      }, this.clearTag = () => {
        this.tag = void 0;
      }, this.getTag = () => this.tag, this.getData = () => this.data, this.data = u, this.tag = p;
    }
  }
  return DataItem$a.DataItem = n, DataItem$a;
}
var hasRequiredCborSync$a;
function requireCborSync$a() {
  return hasRequiredCborSync$a || (hasRequiredCborSync$a = 1, function(n) {
    (function(c, u) {
      n.exports ? n.exports = u() : c.CBOR = u();
    })(commonjsGlobal, function() {
      const { DataItem: c } = requireDataItem$a();
      var u = function() {
        function p(Ce) {
          this.$hex = Ce;
        }
        p.prototype = {
          length: function() {
            return this.$hex.length / 2;
          },
          toString: function(Ce) {
            if (!Ce || Ce === "hex" || Ce === 16)
              return this.$hex;
            if (Ce === "utf-8") {
              for (var tr = "", Fe = 0; Fe < this.$hex.length; Fe += 2)
                tr += "%" + this.$hex.substring(Fe, Fe + 2);
              return decodeURIComponent(tr);
            }
            if (Ce === "latin") {
              for (var tr = [], Fe = 0; Fe < this.$hex.length; Fe += 2)
                tr.push(parseInt(this.$hex.substring(Fe, Fe + 2), 16));
              return String.fromCharCode.apply(String, tr);
            }
            throw new Error("Unrecognised format: " + Ce);
          }
        }, p.fromLatinString = function(Ce) {
          for (var tr = "", Fe = 0; Fe < Ce.length; Fe++) {
            var Sr = Ce.charCodeAt(Fe).toString(16);
            Sr.length === 1 && (Sr = "0" + Sr), tr += Sr;
          }
          return new p(tr);
        }, p.fromUtf8String = function(Ce) {
          for (var tr = encodeURIComponent(Ce), Fe = "", Sr = 0; Sr < tr.length; Sr++)
            if (tr.charAt(Sr) === "%")
              Fe += tr.substring(Sr + 1, Sr + 3), Sr += 2;
            else {
              var er = tr.charCodeAt(Sr).toString(16);
              er.length < 2 && (er = "0" + er), Fe += er;
            }
          return new p(Fe);
        };
        var a = [], A = {}, b = function(Ce) {
          return function() {
            throw new Error(Ce + " not implemented");
          };
        };
        function F() {
        }
        F.prototype = {
          peekByte: b("peekByte"),
          readByte: b("readByte"),
          readChunk: b("readChunk"),
          readFloat16: function() {
            var Ce = this.readUint16(), tr = (Ce & 32767) >> 10, Fe = Ce & 1023, Sr = Ce & 32768;
            if (tr === 31)
              return Fe === 0 ? Sr ? -1 / 0 : 1 / 0 : NaN;
            var er = tr ? Math.pow(2, tr - 25) * (1024 + Fe) : Math.pow(2, -24) * Fe;
            return Sr ? -er : er;
          },
          readFloat32: function() {
            var Ce = this.readUint32(), tr = (Ce & 2147483647) >> 23, Fe = Ce & 8388607, Sr = Ce & 2147483648;
            if (tr === 255)
              return Fe === 0 ? Sr ? -1 / 0 : 1 / 0 : NaN;
            var er = tr ? Math.pow(2, tr - 23 - 127) * (8388608 + Fe) : Math.pow(2, -149) * Fe;
            return Sr ? -er : er;
          },
          readFloat64: function() {
            var Ce = this.readUint32(), tr = this.readUint32(), Fe = Ce >> 20 & 2047, Sr = (Ce & 1048575) * 4294967296 + tr, er = Ce & 2147483648;
            if (Fe === 2047)
              return Sr === 0 ? er ? -1 / 0 : 1 / 0 : NaN;
            var Ie = Fe ? Math.pow(2, Fe - 52 - 1023) * (4503599627370496 + Sr) : Math.pow(2, -1074) * Sr;
            return er ? -Ie : Ie;
          },
          readUint16: function() {
            return this.readByte() * 256 + this.readByte();
          },
          readUint32: function() {
            return this.readUint16() * 65536 + this.readUint16();
          },
          readUint64: function() {
            return this.readUint32() * 4294967296 + this.readUint32();
          }
        };
        function le() {
        }
        le.prototype = {
          writeByte: b("writeByte"),
          result: b("result"),
          writeFloat16: b("writeFloat16"),
          writeFloat32: b("writeFloat32"),
          writeFloat64: b("writeFloat64"),
          writeUint16: function(Ce) {
            this.writeByte(Ce >> 8 & 255), this.writeByte(Ce & 255);
          },
          writeUint32: function(Ce) {
            this.writeUint16(Ce >> 16 & 65535), this.writeUint16(Ce & 65535);
          },
          writeUint64: function(Ce) {
            if (Ce >= 9007199254740992 || Ce <= -9007199254740992)
              throw new Error("Cannot encode Uint64 of: " + Ce + " magnitude to big (floating point errors)");
            this.writeUint32(Math.floor(Ce / 4294967296)), this.writeUint32(Ce % 4294967296);
          },
          writeString: b("writeString"),
          canWriteBinary: function(Ce) {
            return !1;
          },
          writeBinary: b("writeChunk")
        };
        function L(Ce) {
          var tr = Ce.readByte(), Fe = tr >> 5, Sr = tr & 31;
          return { type: Fe, value: Sr };
        }
        function pe(Ce, tr) {
          var Fe = Ce.value;
          if (Fe < 24)
            return Fe;
          if (Fe == 24)
            return tr.readByte();
          if (Fe == 25)
            return tr.readUint16();
          if (Fe == 26)
            return tr.readUint32();
          if (Fe == 27)
            return tr.readUint64();
          if (Fe == 31)
            return null;
          b("Additional info: " + Fe)();
        }
        function $(Ce, tr, Fe) {
          Fe.writeByte(Ce << 5 | tr);
        }
        function Ee(Ce, tr, Fe) {
          var Sr = Ce << 5;
          tr < 24 ? Fe.writeByte(Sr | tr) : tr < 256 ? (Fe.writeByte(Sr | 24), Fe.writeByte(tr)) : tr < 65536 ? (Fe.writeByte(Sr | 25), Fe.writeUint16(tr)) : tr < 4294967296 ? (Fe.writeByte(Sr | 26), Fe.writeUint32(tr)) : (Fe.writeByte(Sr | 27), Fe.writeUint64(tr));
        }
        var be = new Error();
        function He(Ce) {
          var tr = L(Ce);
          switch (tr.type) {
            case 0:
              return pe(tr, Ce);
            case 1:
              return -1 - pe(tr, Ce);
            case 2:
              return Ce.readChunk(pe(tr, Ce));
            case 3:
              var Fe = Ce.readChunk(pe(tr, Ce));
              return Fe.toString("utf-8");
            case 4:
            case 5:
              var Sr = pe(tr, Ce), yr = [];
              if (Sr !== null) {
                tr.type === 5 && (Sr *= 2);
                for (var er = 0; er < Sr; er++)
                  yr[er] = He(Ce);
              } else
                for (var Ie; (Ie = He(Ce)) !== be; )
                  yr.push(Ie);
              if (tr.type === 5) {
                for (var xe = {}, er = 0; er < yr.length; er += 2)
                  xe[yr[er]] = yr[er + 1];
                return xe;
              } else
                return yr;
            case 6:
              var rr = pe(tr, Ce), ar = A[rr], yr = He(Ce);
              return ar ? ar(yr) : yr;
            case 7:
              if (tr.value === 25)
                return Ce.readFloat16();
              if (tr.value === 26)
                return Ce.readFloat32();
              if (tr.value === 27)
                return Ce.readFloat64();
              switch (pe(tr, Ce)) {
                case 20:
                  return !1;
                case 21:
                  return !0;
                case 22:
                  return null;
                case 23:
                  return;
                case null:
                  return be;
                default:
                  throw new Error("Unknown fixed value: " + tr.value);
              }
            default:
              throw new Error("Unsupported header: " + JSON.stringify(tr));
          }
          throw new Error("not implemented yet");
        }
        function Pe(Ce, tr) {
          for (var Fe = 0; Fe < a.length; Fe++) {
            var Sr = a[Fe].fn(Ce);
            if (Sr !== void 0)
              return Ee(6, a[Fe].tag, tr), Pe(Sr, tr);
          }
          if (Ce && typeof Ce.toCBOR == "function" && (Ce = Ce.toCBOR()), Ce === !1)
            Ee(7, 20, tr);
          else if (Ce === !0)
            Ee(7, 21, tr);
          else if (Ce === null)
            Ee(7, 22, tr);
          else if (Ce === void 0)
            Ee(7, 23, tr);
          else if (typeof Ce == "number")
            Math.floor(Ce) === Ce && Ce < 9007199254740992 && Ce > -9007199254740992 ? Ce < 0 ? Ee(1, -1 - Ce, tr) : Ee(0, Ce, tr) : ($(7, 27, tr), tr.writeFloat64(Ce));
          else if (typeof Ce == "string")
            tr.writeString(Ce, function(Ie) {
              Ee(3, Ie, tr);
            });
          else if (tr.canWriteBinary(Ce))
            tr.writeBinary(Ce, function(Ie) {
              Ee(2, Ie, tr);
            });
          else if (typeof Ce == "object")
            if (or.config.useToJSON && typeof Ce.toJSON == "function" && (Ce = Ce.toJSON()), Array.isArray(Ce)) {
              Ee(4, Ce.length, tr);
              for (var Fe = 0; Fe < Ce.length; Fe++)
                Pe(Ce[Fe], tr);
            } else {
              var er = Object.keys(Ce);
              Ee(5, er.length, tr);
              for (var Fe = 0; Fe < er.length; Fe++) {
                const xe = parseInt(er[Fe]);
                isNaN(xe) ? (Pe(er[Fe], tr), Pe(Ce[er[Fe]], tr)) : (Pe(xe, tr), Pe(Ce[er[Fe]], tr));
              }
            }
          else
            throw new Error("CBOR encoding not supported: " + Ce);
        }
        var nr = [], ir = [], or = {
          config: {
            useToJSON: !0
          },
          addWriter: function(Ce, tr) {
            typeof Ce == "string" ? ir.push(function(Fe) {
              if (Ce === Fe)
                return tr(Fe);
            }) : ir.push(Ce);
          },
          addReader: function(Ce, tr) {
            typeof Ce == "string" ? nr.push(function(Fe, Sr) {
              if (Ce === Sr)
                return tr(Fe, Sr);
            }) : nr.push(Ce);
          },
          encode: function(Ce, tr) {
            for (var Fe = 0; Fe < ir.length; Fe++) {
              var Sr = ir[Fe], er = Sr(tr);
              if (er)
                return Pe(Ce, er), er.result();
            }
            throw new Error("Unsupported output format: " + tr);
          },
          encodeDataItem: function(Ce, tr) {
            for (var Fe = 0; Fe < ir.length; Fe++) {
              var Sr = ir[Fe], er = Sr(tr);
              if (er)
                return Ce.getTag() !== void 0 ? (Pe(Ce, er), er.result()) : (Pe(Ce.getData(), er), er.result());
            }
            throw new Error("Unsupported output format: " + tr);
          },
          decode: function(Ce, tr) {
            for (var Fe = 0; Fe < nr.length; Fe++) {
              var Sr = nr[Fe], er = Sr(Ce, tr);
              if (er)
                return He(er);
            }
            throw new Error("Unsupported input format: " + tr);
          },
          decodeToDataItem: function(Ce, tr) {
            for (var Fe = 0; Fe < nr.length; Fe++) {
              var Sr = nr[Fe], er = Sr(Ce, tr);
              if (er) {
                const Ie = He(er);
                return Ie instanceof c ? Ie : new c(Ie);
              }
            }
            throw new Error("Unsupported input format: " + tr);
          },
          addSemanticEncode: function(Ce, tr) {
            if (typeof Ce != "number" || Ce % 1 !== 0 || Ce < 0)
              throw new Error("Tag must be a positive integer");
            return a.push({ tag: Ce, fn: tr }), this;
          },
          addSemanticDecode: function(Ce, tr) {
            if (typeof Ce != "number" || Ce % 1 !== 0 || Ce < 0)
              throw new Error("Tag must be a positive integer");
            return A[Ce] = tr, this;
          }
        };
        function lr(Ce) {
          this.buffer = Ce, this.pos = 0;
        }
        lr.prototype = Object.create(F.prototype), lr.prototype.peekByte = function() {
          return this.buffer[this.pos];
        }, lr.prototype.readByte = function() {
          return this.buffer[this.pos++];
        }, lr.prototype.readUint16 = function() {
          var Ce = this.buffer.readUInt16BE(this.pos);
          return this.pos += 2, Ce;
        }, lr.prototype.readUint32 = function() {
          var Ce = this.buffer.readUInt32BE(this.pos);
          return this.pos += 4, Ce;
        }, lr.prototype.readFloat32 = function() {
          var Ce = this.buffer.readFloatBE(this.pos);
          return this.pos += 4, Ce;
        }, lr.prototype.readFloat64 = function() {
          var Ce = this.buffer.readDoubleBE(this.pos);
          return this.pos += 8, Ce;
        }, lr.prototype.readChunk = function(Ce) {
          var tr = Buffer$f.alloc(Ce);
          return this.buffer.copy(tr, 0, this.pos, this.pos += Ce), tr;
        };
        function Ir(Ce) {
          this.byteLength = 0, this.defaultBufferLength = 16384, this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0, this.completeBuffers = [], this.stringFormat = Ce;
        }
        Ir.prototype = Object.create(le.prototype), Ir.prototype.writeByte = function(Ce) {
          this.latestBuffer[this.latestBufferOffset++] = Ce, this.latestBufferOffset >= this.latestBuffer.length && (this.completeBuffers.push(this.latestBuffer), this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0), this.byteLength++;
        }, Ir.prototype.writeFloat32 = function(Ce) {
          var tr = Buffer$f.alloc(4);
          tr.writeFloatBE(Ce, 0), this.writeBuffer(tr);
        }, Ir.prototype.writeFloat64 = function(Ce) {
          var tr = Buffer$f.alloc(8);
          tr.writeDoubleBE(Ce, 0), this.writeBuffer(tr);
        }, Ir.prototype.writeString = function(Ce, tr) {
          var Fe = Buffer$f.from(Ce, "utf-8");
          tr(Fe.length), this.writeBuffer(Fe);
        }, Ir.prototype.canWriteBinary = function(Ce) {
          return Ce instanceof Buffer$f;
        }, Ir.prototype.writeBinary = function(Ce, tr) {
          tr(Ce.length), this.writeBuffer(Ce);
        }, Ir.prototype.writeBuffer = function(Ce) {
          if (!(Ce instanceof Buffer$f))
            throw new TypeError("BufferWriter only accepts Buffers");
          this.latestBufferOffset ? this.latestBuffer.length - this.latestBufferOffset >= Ce.length ? (Ce.copy(this.latestBuffer, this.latestBufferOffset), this.latestBufferOffset += Ce.length, this.latestBufferOffset >= this.latestBuffer.length && (this.completeBuffers.push(this.latestBuffer), this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0)) : (this.completeBuffers.push(this.latestBuffer.slice(0, this.latestBufferOffset)), this.completeBuffers.push(Ce), this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0) : this.completeBuffers.push(Ce), this.byteLength += Ce.length;
        }, Ir.prototype.result = function() {
          for (var Ce = Buffer$f.alloc(this.byteLength), tr = 0, Fe = 0; Fe < this.completeBuffers.length; Fe++) {
            var Sr = this.completeBuffers[Fe];
            Sr.copy(Ce, tr, 0, Sr.length), tr += Sr.length;
          }
          return this.latestBufferOffset && this.latestBuffer.copy(Ce, tr, 0, this.latestBufferOffset), this.stringFormat ? Ce.toString(this.stringFormat) : Ce;
        }, typeof Buffer$f == "function" && (or.addReader(function(Ce, tr) {
          if (Buffer$f.isBuffer(Ce))
            return new lr(Ce);
          if (tr === "hex" || tr === "base64") {
            var Fe = Buffer$f.from(Ce, tr);
            return new lr(Fe);
          }
        }), or.addWriter(function(Ce) {
          if (!Ce || Ce === "buffer")
            return new Ir();
          if (Ce === "hex" || Ce === "base64")
            return new Ir(Ce);
        }));
        function xr(Ce) {
          this.hex = Ce, this.pos = 0;
        }
        xr.prototype = Object.create(F.prototype), xr.prototype.peekByte = function() {
          var Ce = this.hex.substring(this.pos, 2);
          return parseInt(Ce, 16);
        }, xr.prototype.readByte = function() {
          var Ce = this.hex.substring(this.pos, this.pos + 2);
          return this.pos += 2, parseInt(Ce, 16);
        }, xr.prototype.readChunk = function(Ce) {
          var tr = this.hex.substring(this.pos, this.pos + Ce * 2);
          return this.pos += Ce * 2, typeof Buffer$f == "function" ? Buffer$f.from(tr, "hex") : new p(tr);
        };
        function kr(Ce) {
          this.$hex = "", this.finalFormat = Ce || "hex";
        }
        return kr.prototype = Object.create(le.prototype), kr.prototype.writeByte = function(Ce) {
          if (Ce < 0 || Ce > 255)
            throw new Error("Byte value out of range: " + Ce);
          var tr = Ce.toString(16);
          tr.length == 1 && (tr = "0" + tr), this.$hex += tr;
        }, kr.prototype.canWriteBinary = function(Ce) {
          return Ce instanceof p || typeof Buffer$f == "function" && Ce instanceof Buffer$f;
        }, kr.prototype.writeBinary = function(Ce, tr) {
          if (Ce instanceof p)
            tr(Ce.length()), this.$hex += Ce.$hex;
          else if (typeof Buffer$f == "function" && Ce instanceof Buffer$f)
            tr(Ce.length), this.$hex += Ce.toString("hex");
          else
            throw new TypeError("HexWriter only accepts BinaryHex or Buffers");
        }, kr.prototype.result = function() {
          return this.finalFormat === "buffer" && typeof Buffer$f == "function" ? Buffer$f.from(this.$hex, "hex") : new p(this.$hex).toString(this.finalFormat);
        }, kr.prototype.writeString = function(Ce, tr) {
          var Fe = p.fromUtf8String(Ce);
          tr(Fe.length()), this.$hex += Fe.$hex;
        }, or.addReader(function(Ce, tr) {
          if (Ce instanceof p || Ce.$hex)
            return new xr(Ce.$hex);
          if (tr === "hex")
            return new xr(Ce);
        }), or.addWriter(function(Ce) {
          if (Ce === "hex")
            return new kr();
        }), or;
      }();
      return u.addSemanticEncode(0, function(p) {
        if (p instanceof Date)
          return p.toISOString();
      }).addSemanticDecode(0, function(p) {
        return new Date(p);
      }).addSemanticDecode(1, function(p) {
        return new Date(p);
      }), u;
    });
  }(cborSync$a)), cborSync$a.exports;
}
var hasRequiredLib$b;
function requireLib$b() {
  return hasRequiredLib$b || (hasRequiredLib$b = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.DataItem = n.addWriter = n.addReader = n.addSemanticEncode = n.addSemanticDecode = n.decodeToDataItem = n.encodeDataItem = void 0;
    var c = requireCborSync$a();
    Object.defineProperty(n, "encodeDataItem", { enumerable: !0, get: function() {
      return c.encodeDataItem;
    } }), Object.defineProperty(n, "decodeToDataItem", { enumerable: !0, get: function() {
      return c.decodeToDataItem;
    } }), Object.defineProperty(n, "addSemanticDecode", { enumerable: !0, get: function() {
      return c.addSemanticDecode;
    } }), Object.defineProperty(n, "addSemanticEncode", { enumerable: !0, get: function() {
      return c.addSemanticEncode;
    } }), Object.defineProperty(n, "addReader", { enumerable: !0, get: function() {
      return c.addReader;
    } }), Object.defineProperty(n, "addWriter", { enumerable: !0, get: function() {
      return c.addWriter;
    } });
    var u = requireDataItem$a();
    Object.defineProperty(n, "DataItem", { enumerable: !0, get: function() {
      return u.DataItem;
    } });
  }(lib$d)), lib$d;
}
var hasRequiredUtils$d;
function requireUtils$d() {
  if (hasRequiredUtils$d) return utils$G;
  hasRequiredUtils$d = 1, Object.defineProperty(utils$G, "__esModule", { value: !0 }), utils$G.patchTags = void 0;
  const n = requireLib$b(), c = [], u = (p) => {
    p.forEach((a) => {
      c.find((A) => A === a) || ((0, n.addSemanticEncode)(a, (A) => {
        if (A instanceof n.DataItem && A.getTag() === a)
          return A.getData();
      }), (0, n.addSemanticDecode)(a, (A) => new n.DataItem(A, a)), c.push(a));
    });
  };
  return utils$G.patchTags = u, utils$G;
}
var RegistryType$a = {}, hasRequiredRegistryType$a;
function requireRegistryType$a() {
  if (hasRequiredRegistryType$a) return RegistryType$a;
  hasRequiredRegistryType$a = 1, Object.defineProperty(RegistryType$a, "__esModule", { value: !0 }), RegistryType$a.RegistryTypes = RegistryType$a.RegistryType = void 0;
  class n {
    constructor(u, p) {
      this.type = u, this.tag = p, this.getTag = () => this.tag, this.getType = () => this.type;
    }
  }
  return RegistryType$a.RegistryType = n, RegistryType$a.RegistryTypes = {
    UUID: new n("uuid", 37),
    BYTES: new n("bytes", void 0),
    CRYPTO_HDKEY: new n("crypto-hdkey", 303),
    CRYPTO_KEYPATH: new n("crypto-keypath", 304),
    CRYPTO_COIN_INFO: new n("crypto-coin-info", 305),
    CRYPTO_ECKEY: new n("crypto-eckey", 306),
    CRYPTO_OUTPUT: new n("crypto-output", 308),
    CRYPTO_PSBT: new n("crypto-psbt", 310),
    CRYPTO_ACCOUNT: new n("crypto-account", 311),
    CRYPTO_MULTI_ACCOUNTS: new n("crypto-multi-accounts", 1103),
    QR_HARDWARE_CALL: new n("qr-hardware-call", 1201),
    KEY_DERIVATION_CALL: new n("key-derivation-call", 1301),
    KEY_DERIVATION_SCHEMA: new n("key-derivation-schema", 1302)
  }, RegistryType$a;
}
var ScriptExpression$a = {}, hasRequiredScriptExpression$a;
function requireScriptExpression$a() {
  return hasRequiredScriptExpression$a || (hasRequiredScriptExpression$a = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.ScriptExpressions = n.ScriptExpression = void 0;
    class c {
      constructor(p, a) {
        this.tag = p, this.expression = a, this.getTag = () => this.tag, this.getExpression = () => this.expression;
      }
    }
    n.ScriptExpression = c, c.fromTag = (u) => Object.values(n.ScriptExpressions).find((a) => a.getTag() === u), n.ScriptExpressions = {
      SCRIPT_HASH: new c(400, "sh"),
      WITNESS_SCRIPT_HASH: new c(401, "wsh"),
      PUBLIC_KEY: new c(402, "pk"),
      PUBLIC_KEY_HASH: new c(403, "pkh"),
      WITNESS_PUBLIC_KEY_HASH: new c(404, "wpkh"),
      COMBO: new c(405, "combo"),
      MULTISIG: new c(406, "multi"),
      SORTED_MULTISIG: new c(407, "sortedmulti"),
      ADDRESS: new c(307, "addr"),
      RAW_SCRIPT: new c(408, "raw")
    };
  }(ScriptExpression$a)), ScriptExpression$a;
}
var hasRequiredPatchCBOR$a;
function requirePatchCBOR$a() {
  if (hasRequiredPatchCBOR$a) return patchCBOR$a;
  hasRequiredPatchCBOR$a = 1, Object.defineProperty(patchCBOR$a, "__esModule", { value: !0 });
  const n = requireUtils$d(), c = requireRegistryType$a(), u = requireScriptExpression$a(), p = Object.values(c.RegistryTypes).filter((A) => !!A.getTag()).map((A) => A.getTag()), a = Object.values(u.ScriptExpressions).map((A) => A.getTag());
  return (0, n.patchTags)(p.concat(a)), patchCBOR$a;
}
var CryptoHDKey$a = {}, src$f, hasRequiredSrc$b;
function requireSrc$b() {
  if (hasRequiredSrc$b) return src$f;
  hasRequiredSrc$b = 1;
  var n = safeBufferExports.Buffer;
  function c(u) {
    if (u.length >= 255)
      throw new TypeError("Alphabet too long");
    for (var p = new Uint8Array(256), a = 0; a < p.length; a++)
      p[a] = 255;
    for (var A = 0; A < u.length; A++) {
      var b = u.charAt(A), F = b.charCodeAt(0);
      if (p[F] !== 255)
        throw new TypeError(b + " is ambiguous");
      p[F] = A;
    }
    var le = u.length, L = u.charAt(0), pe = Math.log(le) / Math.log(256), $ = Math.log(256) / Math.log(le);
    function Ee(Pe) {
      if ((Array.isArray(Pe) || Pe instanceof Uint8Array) && (Pe = n.from(Pe)), !n.isBuffer(Pe))
        throw new TypeError("Expected Buffer");
      if (Pe.length === 0)
        return "";
      for (var nr = 0, ir = 0, or = 0, lr = Pe.length; or !== lr && Pe[or] === 0; )
        or++, nr++;
      for (var Ir = (lr - or) * $ + 1 >>> 0, xr = new Uint8Array(Ir); or !== lr; ) {
        for (var kr = Pe[or], Ce = 0, tr = Ir - 1; (kr !== 0 || Ce < ir) && tr !== -1; tr--, Ce++)
          kr += 256 * xr[tr] >>> 0, xr[tr] = kr % le >>> 0, kr = kr / le >>> 0;
        if (kr !== 0)
          throw new Error("Non-zero carry");
        ir = Ce, or++;
      }
      for (var Fe = Ir - ir; Fe !== Ir && xr[Fe] === 0; )
        Fe++;
      for (var Sr = L.repeat(nr); Fe < Ir; ++Fe)
        Sr += u.charAt(xr[Fe]);
      return Sr;
    }
    function be(Pe) {
      if (typeof Pe != "string")
        throw new TypeError("Expected String");
      if (Pe.length === 0)
        return n.alloc(0);
      for (var nr = 0, ir = 0, or = 0; Pe[nr] === L; )
        ir++, nr++;
      for (var lr = (Pe.length - nr) * pe + 1 >>> 0, Ir = new Uint8Array(lr); nr < Pe.length; ) {
        var xr = Pe.charCodeAt(nr);
        if (xr > 255)
          return;
        var kr = p[xr];
        if (kr === 255)
          return;
        for (var Ce = 0, tr = lr - 1; (kr !== 0 || Ce < or) && tr !== -1; tr--, Ce++)
          kr += le * Ir[tr] >>> 0, Ir[tr] = kr % 256 >>> 0, kr = kr / 256 >>> 0;
        if (kr !== 0)
          throw new Error("Non-zero carry");
        or = Ce, nr++;
      }
      for (var Fe = lr - or; Fe !== lr && Ir[Fe] === 0; )
        Fe++;
      var Sr = n.allocUnsafe(ir + (lr - Fe));
      Sr.fill(0, 0, ir);
      for (var er = ir; Fe !== lr; )
        Sr[er++] = Ir[Fe++];
      return Sr;
    }
    function He(Pe) {
      var nr = be(Pe);
      if (nr)
        return nr;
      throw new Error("Non-base" + le + " character");
    }
    return {
      encode: Ee,
      decodeUnsafe: be,
      decode: He
    };
  }
  return src$f = c, src$f;
}
var bs58$c, hasRequiredBs58$b;
function requireBs58$b() {
  if (hasRequiredBs58$b) return bs58$c;
  hasRequiredBs58$b = 1;
  var n = requireSrc$b(), c = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
  return bs58$c = n(c), bs58$c;
}
var base$g, hasRequiredBase$c;
function requireBase$c() {
  if (hasRequiredBase$c) return base$g;
  hasRequiredBase$c = 1;
  var n = requireBs58$b(), c = safeBufferExports.Buffer;
  return base$g = function(u) {
    function p(F) {
      var le = u(F);
      return n.encode(c.concat([
        F,
        le
      ], F.length + 4));
    }
    function a(F) {
      var le = F.slice(0, -4), L = F.slice(-4), pe = u(le);
      if (!(L[0] ^ pe[0] | L[1] ^ pe[1] | L[2] ^ pe[2] | L[3] ^ pe[3]))
        return le;
    }
    function A(F) {
      var le = n.decodeUnsafe(F);
      if (le)
        return a(le);
    }
    function b(F) {
      var le = n.decode(F), L = a(le);
      if (!L) throw new Error("Invalid checksum");
      return L;
    }
    return {
      encode: p,
      decode: b,
      decodeUnsafe: A
    };
  }, base$g;
}
var bs58check$e, hasRequiredBs58check$b;
function requireBs58check$b() {
  if (hasRequiredBs58check$b) return bs58check$e;
  hasRequiredBs58check$b = 1;
  var n = browser$a, c = requireBase$c();
  function u(p) {
    var a = n("sha256").update(p).digest();
    return n("sha256").update(a).digest();
  }
  return bs58check$e = c(u), bs58check$e;
}
var CryptoCoinInfo$a = {}, RegistryItem$a = {}, hasRequiredRegistryItem$a;
function requireRegistryItem$a() {
  if (hasRequiredRegistryItem$a) return RegistryItem$a;
  hasRequiredRegistryItem$a = 1, Object.defineProperty(RegistryItem$a, "__esModule", { value: !0 }), RegistryItem$a.RegistryItem = void 0;
  const n = dist$t, c = requireLib$b();
  class u {
    constructor() {
      this.toCBOR = () => {
        if (this.toDataItem() === void 0)
          throw new Error(`#[ur-registry][RegistryItem][fn.toCBOR]: registry ${this.getRegistryType()}'s method toDataItem returns undefined`);
        return (0, c.encodeDataItem)(this.toDataItem());
      }, this.toUR = () => new n.UR(this.toCBOR(), this.getRegistryType().getType()), this.toUREncoder = (a, A, b) => {
        const F = this.toUR();
        return new n.UREncoder(F, a, A, b);
      };
    }
  }
  return RegistryItem$a.RegistryItem = u, RegistryItem$a;
}
var hasRequiredCryptoCoinInfo$a;
function requireCryptoCoinInfo$a() {
  return hasRequiredCryptoCoinInfo$a || (hasRequiredCryptoCoinInfo$a = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.CryptoCoinInfo = n.Network = n.Type = void 0;
    const c = requireLib$b(), u = requireRegistryItem$a(), p = requireRegistryType$a();
    var a;
    (function(le) {
      le.type = "1", le.network = "2";
    })(a || (a = {}));
    var A;
    (function(le) {
      le[le.bitcoin = 0] = "bitcoin";
    })(A = n.Type || (n.Type = {}));
    var b;
    (function(le) {
      le[le.mainnet = 0] = "mainnet", le[le.testnet = 1] = "testnet";
    })(b = n.Network || (n.Network = {}));
    class F extends u.RegistryItem {
      constructor(L, pe) {
        super(), this.type = L, this.network = pe, this.getRegistryType = () => p.RegistryTypes.CRYPTO_COIN_INFO, this.getType = () => this.type || A.bitcoin, this.getNetwork = () => this.network || b.mainnet, this.toDataItem = () => {
          const $ = {};
          return this.type && ($[a.type] = this.type), this.network && ($[a.network] = this.network), new c.DataItem($);
        };
      }
    }
    n.CryptoCoinInfo = F, F.fromDataItem = (le) => {
      const L = le.getData(), pe = L[a.type], $ = L[a.network];
      return new F(pe, $);
    }, F.fromCBOR = (le) => {
      const L = (0, c.decodeToDataItem)(le);
      return F.fromDataItem(L);
    };
  }(CryptoCoinInfo$a)), CryptoCoinInfo$a;
}
var CryptoKeypath$a = {}, PathComponent$a = {}, hasRequiredPathComponent$a;
function requirePathComponent$a() {
  if (hasRequiredPathComponent$a) return PathComponent$a;
  hasRequiredPathComponent$a = 1, Object.defineProperty(PathComponent$a, "__esModule", { value: !0 }), PathComponent$a.PathComponent = void 0;
  class n {
    constructor(u) {
      if (this.getIndex = () => this.index, this.isWildcard = () => this.wildcard, this.isHardened = () => this.hardened, this.index = u.index, this.hardened = u.hardened, this.index !== void 0 ? this.wildcard = !1 : this.wildcard = !0, this.index && this.index & n.HARDENED_BIT)
        throw new Error(`#[ur-registry][PathComponent][fn.constructor]: Invalid index ${this.index} - most significant bit cannot be set`);
    }
  }
  return PathComponent$a.PathComponent = n, n.HARDENED_BIT = 2147483648, PathComponent$a;
}
var hasRequiredCryptoKeypath$a;
function requireCryptoKeypath$a() {
  if (hasRequiredCryptoKeypath$a) return CryptoKeypath$a;
  hasRequiredCryptoKeypath$a = 1, Object.defineProperty(CryptoKeypath$a, "__esModule", { value: !0 }), CryptoKeypath$a.CryptoKeypath = void 0;
  const n = requireLib$b(), c = requirePathComponent$a(), u = requireRegistryItem$a(), p = requireRegistryType$a();
  var a;
  (function(b) {
    b[b.components = 1] = "components", b[b.source_fingerprint = 2] = "source_fingerprint", b[b.depth = 3] = "depth";
  })(a || (a = {}));
  class A extends u.RegistryItem {
    constructor(F = [], le, L) {
      super(), this.components = F, this.sourceFingerprint = le, this.depth = L, this.getRegistryType = () => p.RegistryTypes.CRYPTO_KEYPATH, this.getPath = () => this.components.length === 0 ? void 0 : this.components.map(($) => `${$.isWildcard() ? "*" : $.getIndex()}${$.isHardened() ? "'" : ""}`).join("/"), this.getComponents = () => this.components, this.getSourceFingerprint = () => this.sourceFingerprint, this.getDepth = () => this.depth, this.toDataItem = () => {
        const pe = {}, $ = [];
        return this.components && this.components.forEach((Ee) => {
          Ee.isWildcard() ? $.push([]) : $.push(Ee.getIndex()), $.push(Ee.isHardened());
        }), pe[a.components] = $, this.sourceFingerprint && (pe[a.source_fingerprint] = this.sourceFingerprint.readUInt32BE(0)), this.depth !== void 0 && (pe[a.depth] = this.depth), new n.DataItem(pe);
      };
    }
  }
  return CryptoKeypath$a.CryptoKeypath = A, A.fromDataItem = (b) => {
    const F = b.getData(), le = [], L = F[a.components];
    if (L)
      for (let be = 0; be < L.length; be += 2) {
        const He = L[be + 1], Pe = L[be];
        typeof Pe == "number" ? le.push(new c.PathComponent({ index: Pe, hardened: He })) : le.push(new c.PathComponent({ hardened: He }));
      }
    const pe = F[a.source_fingerprint];
    let $;
    pe && ($ = Buffer$f.alloc(4), $.writeUInt32BE(pe, 0));
    const Ee = F[a.depth];
    return new A(le, $, Ee);
  }, A.fromCBOR = (b) => {
    const F = (0, n.decodeToDataItem)(b);
    return A.fromDataItem(F);
  }, CryptoKeypath$a;
}
var hasRequiredCryptoHDKey$a;
function requireCryptoHDKey$a() {
  if (hasRequiredCryptoHDKey$a) return CryptoHDKey$a;
  hasRequiredCryptoHDKey$a = 1, Object.defineProperty(CryptoHDKey$a, "__esModule", { value: !0 }), CryptoHDKey$a.CryptoHDKey = void 0;
  const n = requireBs58check$b(), c = requireCryptoCoinInfo$a(), u = requireCryptoKeypath$a(), p = requireLib$b(), a = requireRegistryItem$a(), A = requireRegistryType$a();
  var b;
  (function(le) {
    le[le.is_master = 1] = "is_master", le[le.is_private = 2] = "is_private", le[le.key_data = 3] = "key_data", le[le.chain_code = 4] = "chain_code", le[le.use_info = 5] = "use_info", le[le.origin = 6] = "origin", le[le.children = 7] = "children", le[le.parent_fingerprint = 8] = "parent_fingerprint", le[le.name = 9] = "name", le[le.note = 10] = "note";
  })(b || (b = {}));
  class F extends a.RegistryItem {
    constructor(L) {
      super(), this.isECKey = () => !1, this.getKey = () => this.key, this.getChainCode = () => this.chainCode, this.isMaster = () => this.master, this.isPrivateKey = () => !!this.privateKey, this.getUseInfo = () => this.useInfo, this.getOrigin = () => this.origin, this.getChildren = () => this.children, this.getParentFingerprint = () => this.parentFingerprint, this.getName = () => this.name, this.getNote = () => this.note, this.getBip32Key = () => {
        var pe, $, Ee;
        let be, He, Pe = 0, nr = Buffer$f.alloc(4).fill(0);
        if (this.isMaster())
          be = Buffer$f.from("0488ADE4", "hex"), He = 0, Pe = 0;
        else {
          He = ((pe = this.getOrigin()) === null || pe === void 0 ? void 0 : pe.getComponents().length) || (($ = this.getOrigin()) === null || $ === void 0 ? void 0 : $.getDepth());
          const xr = (Ee = this.getOrigin()) === null || Ee === void 0 ? void 0 : Ee.getComponents(), kr = xr[xr.length - 1];
          kr && (Pe = kr.isHardened() ? kr.getIndex() + 2147483648 : kr.getIndex(), this.getParentFingerprint() && (nr = this.getParentFingerprint())), this.isPrivateKey() ? be = Buffer$f.from("0488ADE4", "hex") : be = Buffer$f.from("0488B21E", "hex");
        }
        const ir = Buffer$f.alloc(1);
        ir.writeUInt8(He, 0);
        const or = Buffer$f.alloc(4);
        or.writeUInt32BE(Pe, 0);
        const lr = this.getChainCode(), Ir = this.getKey();
        return (0, n.encode)(Buffer$f.concat([be, ir, nr, or, lr, Ir]));
      }, this.getRegistryType = () => A.RegistryTypes.CRYPTO_HDKEY, this.getOutputDescriptorContent = () => {
        var pe, $, Ee, be, He, Pe, nr;
        let ir = "";
        return this.getOrigin() && !((pe = this.getOrigin()) === null || pe === void 0) && pe.getSourceFingerprint() && !(($ = this.getOrigin()) === null || $ === void 0) && $.getPath() && (ir += `${(be = (Ee = this.getOrigin()) === null || Ee === void 0 ? void 0 : Ee.getSourceFingerprint()) === null || be === void 0 ? void 0 : be.toString("hex")}/${(He = this.getOrigin()) === null || He === void 0 ? void 0 : He.getPath()}`), ir += this.getBip32Key(), this.getChildren() && !((Pe = this.getChildren()) === null || Pe === void 0) && Pe.getPath() && (ir += `/${(nr = this.getChildren()) === null || nr === void 0 ? void 0 : nr.getPath()}`), ir;
      }, this.setupMasterKey = (pe) => {
        this.master = !0, this.key = pe.key, this.chainCode = pe.chainCode;
      }, this.setupDeriveKey = (pe) => {
        this.master = !1, this.privateKey = pe.isPrivateKey, this.key = pe.key, this.chainCode = pe.chainCode, this.useInfo = pe.useInfo, this.origin = pe.origin, this.children = pe.children, this.parentFingerprint = pe.parentFingerprint, this.name = pe.name, this.note = pe.note;
      }, this.toDataItem = () => {
        const pe = {};
        if (this.master)
          pe[b.is_master] = !0, pe[b.key_data] = this.key, pe[b.chain_code] = this.chainCode;
        else {
          if (this.privateKey !== void 0 && (pe[b.is_private] = this.privateKey), pe[b.key_data] = this.key, this.chainCode && (pe[b.chain_code] = this.chainCode), this.useInfo) {
            const $ = this.useInfo.toDataItem();
            $.setTag(this.useInfo.getRegistryType().getTag()), pe[b.use_info] = $;
          }
          if (this.origin) {
            const $ = this.origin.toDataItem();
            $.setTag(this.origin.getRegistryType().getTag()), pe[b.origin] = $;
          }
          if (this.children) {
            const $ = this.children.toDataItem();
            $.setTag(this.children.getRegistryType().getTag()), pe[b.children] = $;
          }
          this.parentFingerprint && (pe[b.parent_fingerprint] = this.parentFingerprint.readUInt32BE(0)), this.name !== void 0 && (pe[b.name] = this.name), this.note !== void 0 && (pe[b.note] = this.note);
        }
        return new p.DataItem(pe);
      }, L.isMaster ? this.setupMasterKey(L) : this.setupDeriveKey(L);
    }
  }
  return CryptoHDKey$a.CryptoHDKey = F, F.fromDataItem = (le) => {
    const L = le.getData(), pe = !!L[b.is_master], $ = L[b.is_private], Ee = L[b.key_data], be = L[b.chain_code], He = L[b.use_info] ? c.CryptoCoinInfo.fromDataItem(L[b.use_info]) : void 0, Pe = L[b.origin] ? u.CryptoKeypath.fromDataItem(L[b.origin]) : void 0, nr = L[b.children] ? u.CryptoKeypath.fromDataItem(L[b.children]) : void 0, ir = L[b.parent_fingerprint];
    let or;
    ir && (or = Buffer$f.alloc(4), or.writeUInt32BE(ir, 0));
    const lr = L[b.name], Ir = L[b.note];
    return new F({
      isMaster: pe,
      isPrivateKey: $,
      key: Ee,
      chainCode: be,
      useInfo: He,
      origin: Pe,
      children: nr,
      parentFingerprint: or,
      name: lr,
      note: Ir
    });
  }, F.fromCBOR = (le) => {
    const L = (0, p.decodeToDataItem)(le);
    return F.fromDataItem(L);
  }, CryptoHDKey$a;
}
var CryptoECKey$a = {}, hasRequiredCryptoECKey$a;
function requireCryptoECKey$a() {
  if (hasRequiredCryptoECKey$a) return CryptoECKey$a;
  hasRequiredCryptoECKey$a = 1, Object.defineProperty(CryptoECKey$a, "__esModule", { value: !0 }), CryptoECKey$a.CryptoECKey = void 0;
  const n = requireLib$b(), c = requireRegistryItem$a(), u = requireRegistryType$a();
  var p;
  (function(A) {
    A[A.curve = 1] = "curve", A[A.private = 2] = "private", A[A.data = 3] = "data";
  })(p || (p = {}));
  class a extends c.RegistryItem {
    constructor(b) {
      super(), this.isECKey = () => !0, this.getCurve = () => this.curve || 0, this.isPrivateKey = () => this.privateKey || !1, this.getData = () => this.data, this.getRegistryType = () => u.RegistryTypes.CRYPTO_ECKEY, this.toDataItem = () => {
        const F = {};
        return this.curve && (F[p.curve] = this.curve), this.privateKey !== void 0 && (F[p.private] = this.privateKey), F[p.data] = this.data, new n.DataItem(F);
      }, this.getOutputDescriptorContent = () => this.data.toString("hex"), this.data = b.data, this.curve = b.curve, this.privateKey = b.privateKey || void 0;
    }
  }
  return CryptoECKey$a.CryptoECKey = a, a.fromDataItem = (A) => {
    const b = A.getData(), F = b[p.curve], le = b[p.private], L = b[p.data];
    if (!L)
      throw new Error(`#[ur-registry][CryptoECKey][fn.fromDataItem]: decoded [dataItem][#data.data] is undefined: ${A}`);
    return new a({ data: L, curve: F, privateKey: le });
  }, a.fromCBOR = (A) => {
    const b = (0, n.decodeToDataItem)(A);
    return a.fromDataItem(b);
  }, CryptoECKey$a;
}
var Bytes$b = {}, hasRequiredBytes$b;
function requireBytes$b() {
  if (hasRequiredBytes$b) return Bytes$b;
  hasRequiredBytes$b = 1, Object.defineProperty(Bytes$b, "__esModule", { value: !0 }), Bytes$b.Bytes = void 0;
  const n = requireLib$b(), c = requireRegistryItem$a(), u = requireRegistryType$a();
  class p extends c.RegistryItem {
    constructor(A) {
      super(), this.bytes = A, this.getRegistryType = () => u.RegistryTypes.BYTES, this.getData = () => this.bytes, this.toDataItem = () => new n.DataItem(this.bytes);
    }
  }
  return Bytes$b.Bytes = p, p.fromDataItem = (a) => {
    const A = a.getData();
    if (!A)
      throw new Error(`#[ur-registry][Bytes][fn.fromDataItem]: decoded [dataItem][#data] is undefined: ${a}`);
    return new p(A);
  }, p.fromCBOR = (a) => {
    const A = (0, n.decodeToDataItem)(a);
    return p.fromDataItem(A);
  }, Bytes$b;
}
var CryptoOutput$a = {}, MultiKey$a = {}, hasRequiredMultiKey$a;
function requireMultiKey$a() {
  if (hasRequiredMultiKey$a) return MultiKey$a;
  hasRequiredMultiKey$a = 1, Object.defineProperty(MultiKey$a, "__esModule", { value: !0 }), MultiKey$a.MultiKey = void 0;
  const n = requireCryptoECKey$a(), c = requireCryptoHDKey$a(), u = requireDataItem$a(), p = requireRegistryItem$a(), a = requireRegistryType$a();
  var A;
  (function(F) {
    F[F.threshold = 1] = "threshold", F[F.keys = 2] = "keys";
  })(A || (A = {}));
  class b extends p.RegistryItem {
    constructor(le, L) {
      super(), this.threshold = le, this.keys = L, this.getThreshold = () => this.threshold, this.getKeys = () => this.keys, this.toDataItem = () => {
        const pe = {};
        pe[A.threshold] = this.threshold;
        const $ = this.keys.map((Ee) => {
          const be = Ee.toDataItem();
          return be.setTag(Ee.getRegistryType().getTag()), be;
        });
        return pe[A.keys] = $, new u.DataItem(pe);
      }, this.getOutputDescriptorContent = () => [
        this.getThreshold(),
        this.keys.map((pe) => pe.getOutputDescriptorContent()).join(",")
      ].join(",");
    }
  }
  return MultiKey$a.MultiKey = b, b.fromDataItem = (F) => {
    const le = F.getData(), L = le[A.threshold], pe = le[A.keys], $ = [];
    return pe.forEach((Ee) => {
      Ee.getTag() === a.RegistryTypes.CRYPTO_HDKEY.getTag() ? $.push(c.CryptoHDKey.fromDataItem(Ee)) : Ee.getTag() === a.RegistryTypes.CRYPTO_ECKEY.getTag() && $.push(n.CryptoECKey.fromDataItem(Ee));
    }), new b(L, $);
  }, MultiKey$a;
}
var hasRequiredCryptoOutput$a;
function requireCryptoOutput$a() {
  if (hasRequiredCryptoOutput$a) return CryptoOutput$a;
  hasRequiredCryptoOutput$a = 1, Object.defineProperty(CryptoOutput$a, "__esModule", { value: !0 }), CryptoOutput$a.CryptoOutput = void 0;
  const n = requireCryptoECKey$a(), c = requireCryptoHDKey$a(), u = requireLib$b(), p = requireMultiKey$a(), a = requireRegistryItem$a(), A = requireRegistryType$a(), b = requireScriptExpression$a();
  class F extends a.RegistryItem {
    constructor(L, pe) {
      super(), this.scriptExpressions = L, this.cryptoKey = pe, this.getRegistryType = () => A.RegistryTypes.CRYPTO_OUTPUT, this.getCryptoKey = () => this.cryptoKey, this.getHDKey = () => {
        if (this.cryptoKey instanceof c.CryptoHDKey)
          return this.cryptoKey;
      }, this.getECKey = () => {
        if (this.cryptoKey instanceof n.CryptoECKey)
          return this.cryptoKey;
      }, this.getMultiKey = () => {
        if (this.cryptoKey instanceof p.MultiKey)
          return this.cryptoKey;
      }, this.getScriptExpressions = () => this.scriptExpressions, this._toOutputDescriptor = ($) => $ >= this.scriptExpressions.length ? this.cryptoKey.getOutputDescriptorContent() : `${this.scriptExpressions[$].getExpression()}(${this._toOutputDescriptor($ + 1)})`, this.toString = () => this._toOutputDescriptor(0), this.toDataItem = () => {
        let $ = this.cryptoKey.toDataItem();
        return (this.cryptoKey instanceof n.CryptoECKey || this.cryptoKey instanceof c.CryptoHDKey) && $.setTag(this.cryptoKey.getRegistryType().getTag()), [...this.scriptExpressions].reverse().forEach((be) => {
          const He = be.getTag();
          $.getTag() === void 0 ? $.setTag(He) : $ = new u.DataItem($, He);
        }), $;
      };
    }
  }
  return CryptoOutput$a.CryptoOutput = F, F.fromDataItem = (le) => {
    const L = [];
    let pe = le;
    for (; ; ) {
      let be = pe.getTag();
      const He = b.ScriptExpression.fromTag(be);
      if (He)
        if (L.push(He), pe.getData() instanceof u.DataItem)
          pe = pe.getData(), be = pe.getTag();
        else
          break;
      else
        break;
    }
    const $ = L.length;
    if ($ > 0 && (L[$ - 1].getExpression() === b.ScriptExpressions.MULTISIG.getExpression() || L[$ - 1].getExpression() === b.ScriptExpressions.SORTED_MULTISIG.getExpression())) {
      const be = p.MultiKey.fromDataItem(pe);
      return new F(L, be);
    }
    if (pe.getTag() === A.RegistryTypes.CRYPTO_HDKEY.getTag()) {
      const be = c.CryptoHDKey.fromDataItem(pe);
      return new F(L, be);
    } else {
      const be = n.CryptoECKey.fromDataItem(pe);
      return new F(L, be);
    }
  }, F.fromCBOR = (le) => {
    const L = (0, u.decodeToDataItem)(le);
    return F.fromDataItem(L);
  }, CryptoOutput$a;
}
var CryptoPSBT$a = {}, hasRequiredCryptoPSBT$a;
function requireCryptoPSBT$a() {
  if (hasRequiredCryptoPSBT$a) return CryptoPSBT$a;
  hasRequiredCryptoPSBT$a = 1, Object.defineProperty(CryptoPSBT$a, "__esModule", { value: !0 }), CryptoPSBT$a.CryptoPSBT = void 0;
  const n = requireLib$b(), c = requireRegistryItem$a(), u = requireRegistryType$a();
  class p extends c.RegistryItem {
    constructor(A) {
      super(), this.psbt = A, this.getRegistryType = () => u.RegistryTypes.CRYPTO_PSBT, this.getPSBT = () => this.psbt, this.toDataItem = () => new n.DataItem(this.psbt);
    }
  }
  return CryptoPSBT$a.CryptoPSBT = p, p.fromDataItem = (a) => {
    const A = a.getData();
    if (!A)
      throw new Error(`#[ur-registry][CryptoPSBT][fn.fromDataItem]: decoded [dataItem][#data] is undefined: ${a}`);
    return new p(A);
  }, p.fromCBOR = (a) => {
    const A = (0, n.decodeToDataItem)(a);
    return p.fromDataItem(A);
  }, CryptoPSBT$a;
}
var CryptoAccount$a = {}, hasRequiredCryptoAccount$a;
function requireCryptoAccount$a() {
  if (hasRequiredCryptoAccount$a) return CryptoAccount$a;
  hasRequiredCryptoAccount$a = 1, Object.defineProperty(CryptoAccount$a, "__esModule", { value: !0 }), CryptoAccount$a.CryptoAccount = void 0;
  const n = requireDist$a(), c = requireLib$b(), u = requireRegistryItem$a(), p = requireRegistryType$a();
  var a;
  (function(b) {
    b[b.masterFingerprint = 1] = "masterFingerprint", b[b.outputDescriptors = 2] = "outputDescriptors";
  })(a || (a = {}));
  class A extends u.RegistryItem {
    constructor(F, le) {
      super(), this.masterFingerprint = F, this.outputDescriptors = le, this.getRegistryType = () => p.RegistryTypes.CRYPTO_ACCOUNT, this.getMasterFingerprint = () => this.masterFingerprint, this.getOutputDescriptors = () => this.outputDescriptors, this.toDataItem = () => {
        const L = {};
        return this.masterFingerprint && (L[a.masterFingerprint] = this.masterFingerprint.readUInt32BE(0)), this.outputDescriptors && (L[a.outputDescriptors] = this.outputDescriptors.map((pe) => pe.toDataItem())), new c.DataItem(L);
      };
    }
  }
  return CryptoAccount$a.CryptoAccount = A, A.fromDataItem = (b) => {
    const F = b.getData(), le = Buffer$f.alloc(4), L = F[a.masterFingerprint];
    L && le.writeUInt32BE(L, 0);
    const $ = F[a.outputDescriptors].map((Ee) => n.CryptoOutput.fromDataItem(Ee));
    return new A(le, $);
  }, A.fromCBOR = (b) => {
    const F = (0, c.decodeToDataItem)(b);
    return A.fromDataItem(F);
  }, CryptoAccount$a;
}
var Decoder$a = {}, errors$b = {}, hasRequiredErrors$a;
function requireErrors$a() {
  if (hasRequiredErrors$a) return errors$b;
  hasRequiredErrors$a = 1, Object.defineProperty(errors$b, "__esModule", { value: !0 }), errors$b.UnknownURTypeError = void 0;
  class n extends Error {
    constructor(u) {
      super(u);
    }
  }
  return errors$b.UnknownURTypeError = n, errors$b;
}
var hasRequiredDecoder$a;
function requireDecoder$a() {
  if (hasRequiredDecoder$a) return Decoder$a;
  hasRequiredDecoder$a = 1, Object.defineProperty(Decoder$a, "__esModule", { value: !0 }), Decoder$a.URRegistryDecoder = void 0;
  const n = dist$t, c = requireDist$a(), u = requireRegistryType$a(), p = requireErrors$a();
  class a extends n.URDecoder {
    constructor() {
      super(...arguments), this.resultRegistryType = () => {
        const b = this.resultUR();
        switch (b.type) {
          case u.RegistryTypes.BYTES.getType():
            return c.Bytes.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_HDKEY.getType():
            return c.CryptoHDKey.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_KEYPATH.getType():
            return c.CryptoKeypath.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_COIN_INFO.getType():
            return c.CryptoCoinInfo.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_ECKEY.getType():
            return c.CryptoECKey.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_OUTPUT.getType():
            return c.CryptoOutput.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_PSBT.getType():
            return c.CryptoPSBT.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_ACCOUNT.getType():
            return c.CryptoAccount.fromCBOR(b.cbor);
          default:
            throw new p.UnknownURTypeError(`#[ur-registry][Decoder][fn.resultRegistryType]: registry type ${b.type} is not supported now`);
        }
      };
    }
  }
  return Decoder$a.URRegistryDecoder = a, Decoder$a;
}
var CryptoMultiAccounts$a = {}, hasRequiredCryptoMultiAccounts$a;
function requireCryptoMultiAccounts$a() {
  if (hasRequiredCryptoMultiAccounts$a) return CryptoMultiAccounts$a;
  hasRequiredCryptoMultiAccounts$a = 1, Object.defineProperty(CryptoMultiAccounts$a, "__esModule", { value: !0 }), CryptoMultiAccounts$a.CryptoMultiAccounts = void 0;
  const n = requireRegistryType$a(), c = requireCryptoHDKey$a(), u = requireRegistryItem$a(), p = requireLib$b();
  var a;
  (function(b) {
    b[b.masterFingerprint = 1] = "masterFingerprint", b[b.keys = 2] = "keys", b[b.device = 3] = "device", b[b.deviceId = 4] = "deviceId", b[b.version = 5] = "version";
  })(a || (a = {}));
  class A extends u.RegistryItem {
    constructor(F, le, L, pe, $) {
      super(), this.masterFingerprint = F, this.keys = le, this.device = L, this.deviceId = pe, this.version = $, this.getRegistryType = () => n.RegistryTypes.CRYPTO_MULTI_ACCOUNTS, this.getMasterFingerprint = () => this.masterFingerprint, this.getKeys = () => this.keys, this.getDevice = () => this.device, this.getDeviceId = () => this.deviceId, this.getVersion = () => this.version, this.toDataItem = () => {
        const Ee = {};
        return this.masterFingerprint && (Ee[a.masterFingerprint] = this.masterFingerprint.readUInt32BE(0)), this.keys && (Ee[a.keys] = this.keys.map((be) => {
          const He = be.toDataItem();
          return He.setTag(be.getRegistryType().getTag()), He;
        })), this.device && (Ee[a.device] = this.device), this.deviceId && (Ee[a.deviceId] = this.deviceId), this.version && (Ee[a.version] = this.version), new p.DataItem(Ee);
      };
    }
  }
  return CryptoMultiAccounts$a.CryptoMultiAccounts = A, A.fromDataItem = (b) => {
    const F = b.getData(), le = Buffer$f.alloc(4), L = F[a.masterFingerprint];
    L && le.writeUInt32BE(L, 0);
    const $ = F[a.keys].map((Pe) => c.CryptoHDKey.fromDataItem(Pe)), Ee = F[a.device], be = F[a.deviceId], He = F[a.version];
    return new A(le, $, Ee, be, He);
  }, A.fromCBOR = (b) => {
    const F = (0, p.decodeToDataItem)(b);
    return A.fromDataItem(F);
  }, CryptoMultiAccounts$a;
}
var QRHardwareCall$a = {}, KeyDerivation$a = {}, DerivationSchema$a = {}, hasRequiredDerivationSchema$a;
function requireDerivationSchema$a() {
  return hasRequiredDerivationSchema$a || (hasRequiredDerivationSchema$a = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.KeyDerivationSchema = n.DerivationAlgorithm = n.Curve = void 0;
    const c = requireRegistryType$a(), u = requireRegistryItem$a(), p = requireLib$b(), a = requireCryptoKeypath$a();
    var A;
    (function(L) {
      L[L.keyPath = 1] = "keyPath", L[L.curve = 2] = "curve", L[L.algo = 3] = "algo";
    })(A || (A = {}));
    var b;
    (function(L) {
      L[L.secp256k1 = 0] = "secp256k1", L[L.ed25519 = 1] = "ed25519";
    })(b = n.Curve || (n.Curve = {}));
    var F;
    (function(L) {
      L[L.slip10 = 0] = "slip10", L[L.bip32ed25519 = 1] = "bip32ed25519";
    })(F = n.DerivationAlgorithm || (n.DerivationAlgorithm = {}));
    class le extends u.RegistryItem {
      constructor(pe, $ = b.secp256k1, Ee = F.slip10) {
        super(), this.keypath = pe, this.curve = $, this.algo = Ee, this.getRegistryType = () => c.RegistryTypes.KEY_DERIVATION_SCHEMA, this.getKeypath = () => this.keypath, this.getCurve = () => this.curve, this.getAlgo = () => this.algo, this.toDataItem = () => {
          const be = {}, He = this.getKeypath().toDataItem();
          return He.setTag(this.getKeypath().getRegistryType().getTag()), be[A.keyPath] = He, be[A.curve] = this.curve, be[A.algo] = this.algo, new p.DataItem(be);
        };
      }
    }
    n.KeyDerivationSchema = le, le.fromDataItem = (L) => {
      const pe = L.getData(), $ = a.CryptoKeypath.fromDataItem(pe[A.keyPath]), Ee = pe[A.curve], be = pe[A.algo];
      return new le($, Ee, be);
    }, le.fromCBOR = (L) => {
      const pe = (0, p.decodeToDataItem)(L);
      return le.fromDataItem(pe);
    };
  }(DerivationSchema$a)), DerivationSchema$a;
}
var hasRequiredKeyDerivation$a;
function requireKeyDerivation$a() {
  if (hasRequiredKeyDerivation$a) return KeyDerivation$a;
  hasRequiredKeyDerivation$a = 1, Object.defineProperty(KeyDerivation$a, "__esModule", { value: !0 }), KeyDerivation$a.KeyDerivation = void 0;
  const n = requireRegistryType$a(), c = requireRegistryItem$a(), u = requireLib$b(), p = requireDerivationSchema$a();
  var a;
  (function(b) {
    b[b.schemas = 1] = "schemas";
  })(a || (a = {}));
  class A extends c.RegistryItem {
    constructor(F) {
      super(), this.schemas = F, this.getRegistryType = () => n.RegistryTypes.KEY_DERIVATION_CALL, this.getSchemas = () => this.schemas, this.toDataItem = () => {
        const le = {};
        return le[a.schemas] = this.schemas.map((L) => {
          const pe = L.toDataItem();
          return pe.setTag(L.getRegistryType().getTag()), pe;
        }), new u.DataItem(le);
      };
    }
  }
  return KeyDerivation$a.KeyDerivation = A, A.fromDataItem = (b) => {
    const le = b.getData()[a.schemas].map((L) => p.KeyDerivationSchema.fromDataItem(L));
    return new A(le);
  }, A.fromCBOR = (b) => {
    const F = (0, u.decodeToDataItem)(b);
    return A.fromDataItem(F);
  }, KeyDerivation$a;
}
var hasRequiredQRHardwareCall$a;
function requireQRHardwareCall$a() {
  return hasRequiredQRHardwareCall$a || (hasRequiredQRHardwareCall$a = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.QRHardwareCall = n.QRHardwareCallType = void 0;
    const c = requireRegistryType$a(), u = requireRegistryItem$a(), p = requireLib$b(), a = requireKeyDerivation$a();
    var A;
    (function(le) {
      le[le.type = 1] = "type", le[le.params = 2] = "params", le[le.origin = 3] = "origin";
    })(A || (A = {}));
    var b;
    (function(le) {
      le[le.KeyDerivation = 0] = "KeyDerivation";
    })(b = n.QRHardwareCallType || (n.QRHardwareCallType = {}));
    class F extends u.RegistryItem {
      constructor(L, pe, $) {
        super(), this.type = L, this.params = pe, this.origin = $, this.getRegistryType = () => c.RegistryTypes.QR_HARDWARE_CALL, this.getType = () => this.type, this.getParams = () => this.params, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const Ee = {};
          Ee[A.type] = this.type;
          const be = this.params.toDataItem();
          return be.setTag(this.params.getRegistryType().getTag()), Ee[A.params] = be, this.origin && (Ee[A.origin] = this.origin), new p.DataItem(Ee);
        };
      }
    }
    n.QRHardwareCall = F, F.fromDataItem = (le) => {
      const L = le.getData(), pe = L[A.type] || b.KeyDerivation;
      let $;
      switch (pe) {
        case b.KeyDerivation:
          $ = a.KeyDerivation.fromDataItem(L[A.params]);
      }
      const Ee = L[A.origin];
      return new F(pe, $, Ee);
    }, F.fromCBOR = (le) => {
      const L = (0, p.decodeToDataItem)(le);
      return F.fromDataItem(L);
    };
  }(QRHardwareCall$a)), QRHardwareCall$a;
}
var types$g = {}, hasRequiredTypes$b;
function requireTypes$b() {
  return hasRequiredTypes$b || (hasRequiredTypes$b = 1, Object.defineProperty(types$g, "__esModule", { value: !0 })), types$g;
}
var hasRequiredDist$a;
function requireDist$a() {
  return hasRequiredDist$a || (hasRequiredDist$a = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.Buffer = n.extend = n.PathComponent = n.ScriptExpressions = n.MultiKey = n.CryptoPSBT = n.CryptoOutput = n.CryptoECKey = n.CryptoCoinInfoNetwork = n.CryptoCoinInfoType = n.CryptoCoinInfo = n.CryptoKeypath = n.CryptoMultiAccounts = n.CryptoHDKey = n.CryptoAccount = n.Bytes = n.URRegistryDecoder = n.DataItem = void 0;
    const c = require$$0$4;
    requirePatchCBOR$a();
    const u = dist$u;
    Object.defineProperty(n, "Buffer", { enumerable: !0, get: function() {
      return u.Buffer;
    } });
    const p = requireCryptoHDKey$a();
    Object.defineProperty(n, "CryptoHDKey", { enumerable: !0, get: function() {
      return p.CryptoHDKey;
    } });
    const a = requireCryptoKeypath$a();
    Object.defineProperty(n, "CryptoKeypath", { enumerable: !0, get: function() {
      return a.CryptoKeypath;
    } });
    const A = requireCryptoCoinInfo$a();
    Object.defineProperty(n, "CryptoCoinInfo", { enumerable: !0, get: function() {
      return A.CryptoCoinInfo;
    } }), Object.defineProperty(n, "CryptoCoinInfoType", { enumerable: !0, get: function() {
      return A.Type;
    } }), Object.defineProperty(n, "CryptoCoinInfoNetwork", { enumerable: !0, get: function() {
      return A.Network;
    } });
    const b = requireCryptoECKey$a();
    Object.defineProperty(n, "CryptoECKey", { enumerable: !0, get: function() {
      return b.CryptoECKey;
    } });
    const F = requireBytes$b();
    Object.defineProperty(n, "Bytes", { enumerable: !0, get: function() {
      return F.Bytes;
    } });
    const le = requireCryptoOutput$a();
    Object.defineProperty(n, "CryptoOutput", { enumerable: !0, get: function() {
      return le.CryptoOutput;
    } });
    const L = requireCryptoPSBT$a();
    Object.defineProperty(n, "CryptoPSBT", { enumerable: !0, get: function() {
      return L.CryptoPSBT;
    } });
    const pe = requireCryptoAccount$a();
    Object.defineProperty(n, "CryptoAccount", { enumerable: !0, get: function() {
      return pe.CryptoAccount;
    } });
    const $ = requireDecoder$a();
    Object.defineProperty(n, "URRegistryDecoder", { enumerable: !0, get: function() {
      return $.URRegistryDecoder;
    } });
    const Ee = requireMultiKey$a();
    Object.defineProperty(n, "MultiKey", { enumerable: !0, get: function() {
      return Ee.MultiKey;
    } });
    const be = requireScriptExpression$a();
    Object.defineProperty(n, "ScriptExpressions", { enumerable: !0, get: function() {
      return be.ScriptExpressions;
    } });
    const He = requirePathComponent$a();
    Object.defineProperty(n, "PathComponent", { enumerable: !0, get: function() {
      return He.PathComponent;
    } });
    const Pe = requireRegistryItem$a(), nr = requireRegistryType$a(), ir = requireLib$b();
    var or = requireLib$b();
    Object.defineProperty(n, "DataItem", { enumerable: !0, get: function() {
      return or.DataItem;
    } });
    const lr = requireUtils$d(), Ir = requireCryptoMultiAccounts$a();
    Object.defineProperty(n, "CryptoMultiAccounts", { enumerable: !0, get: function() {
      return Ir.CryptoMultiAccounts;
    } });
    const xr = {
      URRegistryDecoder: $.URRegistryDecoder,
      Bytes: F.Bytes,
      CryptoAccount: pe.CryptoAccount,
      CryptoHDKey: p.CryptoHDKey,
      CryptoMultiAccounts: Ir.CryptoMultiAccounts,
      CryptoKeypath: a.CryptoKeypath,
      CryptoCoinInfo: A.CryptoCoinInfo,
      CryptoCoinInfoType: A.Type,
      CryptoCoinInfoNetwork: A.Network,
      CryptoECKey: b.CryptoECKey,
      CryptoOutput: le.CryptoOutput,
      CryptoPSBT: L.CryptoPSBT,
      MultiKey: Ee.MultiKey,
      ScriptExpressions: be.ScriptExpressions,
      PathComponent: He.PathComponent
    }, kr = {
      addReader: ir.addReader,
      addSemanticDecode: ir.addSemanticDecode,
      addSemanticEncode: ir.addSemanticEncode,
      addWriter: ir.addWriter,
      patchTags: lr.patchTags
    }, Ce = {
      RegistryTypes: nr.RegistryTypes,
      RegistryItem: Pe.RegistryItem,
      RegistryType: nr.RegistryType,
      decodeToDataItem: ir.decodeToDataItem,
      encodeDataItem: ir.encodeDataItem,
      cbor: kr
    };
    n.extend = Ce, (0, c.__exportStar)(requireErrors$a(), n), (0, c.__exportStar)(requireDecoder$a(), n), (0, c.__exportStar)(requireLib$b(), n), (0, c.__exportStar)(requireCryptoAccount$a(), n), (0, c.__exportStar)(requireCryptoPSBT$a(), n), (0, c.__exportStar)(requireCryptoHDKey$a(), n), (0, c.__exportStar)(requireCryptoMultiAccounts$a(), n), (0, c.__exportStar)(requireQRHardwareCall$a(), n), (0, c.__exportStar)(requireKeyDerivation$a(), n), (0, c.__exportStar)(requireDerivationSchema$a(), n), (0, c.__exportStar)(requireCryptoOutput$a(), n), (0, c.__exportStar)(requireCryptoCoinInfo$a(), n), (0, c.__exportStar)(requireCryptoECKey$a(), n), (0, c.__exportStar)(requireMultiKey$a(), n), (0, c.__exportStar)(requireCryptoKeypath$a(), n), (0, c.__exportStar)(requirePatchCBOR$a(), n), (0, c.__exportStar)(requirePathComponent$a(), n), (0, c.__exportStar)(requireRegistryItem$a(), n), (0, c.__exportStar)(requireRegistryType$a(), n), (0, c.__exportStar)(requireTypes$b(), n), (0, c.__exportStar)(requireUtils$d(), n), n.default = xr;
  }(dist$p)), dist$p;
}
var getRandomValues$a, rnds8$8 = new Uint8Array(16);
function rng$b() {
  if (!getRandomValues$a && (getRandomValues$a = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !getRandomValues$a))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return getRandomValues$a(rnds8$8);
}
const REGEX$7 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function validate$b(n) {
  return typeof n == "string" && REGEX$7.test(n);
}
var byteToHex$8 = [];
for (var i$9 = 0; i$9 < 256; ++i$9)
  byteToHex$8.push((i$9 + 256).toString(16).substr(1));
function stringify$a(n) {
  var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, u = (byteToHex$8[n[c + 0]] + byteToHex$8[n[c + 1]] + byteToHex$8[n[c + 2]] + byteToHex$8[n[c + 3]] + "-" + byteToHex$8[n[c + 4]] + byteToHex$8[n[c + 5]] + "-" + byteToHex$8[n[c + 6]] + byteToHex$8[n[c + 7]] + "-" + byteToHex$8[n[c + 8]] + byteToHex$8[n[c + 9]] + "-" + byteToHex$8[n[c + 10]] + byteToHex$8[n[c + 11]] + byteToHex$8[n[c + 12]] + byteToHex$8[n[c + 13]] + byteToHex$8[n[c + 14]] + byteToHex$8[n[c + 15]]).toLowerCase();
  if (!validate$b(u))
    throw TypeError("Stringified UUID is invalid");
  return u;
}
var _nodeId$7, _clockseq$7, _lastMSecs$7 = 0, _lastNSecs$7 = 0;
function v1$a(n, c, u) {
  var p = c && u || 0, a = c || new Array(16);
  n = n || {};
  var A = n.node || _nodeId$7, b = n.clockseq !== void 0 ? n.clockseq : _clockseq$7;
  if (A == null || b == null) {
    var F = n.random || (n.rng || rng$b)();
    A == null && (A = _nodeId$7 = [F[0] | 1, F[1], F[2], F[3], F[4], F[5]]), b == null && (b = _clockseq$7 = (F[6] << 8 | F[7]) & 16383);
  }
  var le = n.msecs !== void 0 ? n.msecs : Date.now(), L = n.nsecs !== void 0 ? n.nsecs : _lastNSecs$7 + 1, pe = le - _lastMSecs$7 + (L - _lastNSecs$7) / 1e4;
  if (pe < 0 && n.clockseq === void 0 && (b = b + 1 & 16383), (pe < 0 || le > _lastMSecs$7) && n.nsecs === void 0 && (L = 0), L >= 1e4)
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  _lastMSecs$7 = le, _lastNSecs$7 = L, _clockseq$7 = b, le += 122192928e5;
  var $ = ((le & 268435455) * 1e4 + L) % 4294967296;
  a[p++] = $ >>> 24 & 255, a[p++] = $ >>> 16 & 255, a[p++] = $ >>> 8 & 255, a[p++] = $ & 255;
  var Ee = le / 4294967296 * 1e4 & 268435455;
  a[p++] = Ee >>> 8 & 255, a[p++] = Ee & 255, a[p++] = Ee >>> 24 & 15 | 16, a[p++] = Ee >>> 16 & 255, a[p++] = b >>> 8 | 128, a[p++] = b & 255;
  for (var be = 0; be < 6; ++be)
    a[p + be] = A[be];
  return c || stringify$a(a);
}
function parse$h(n) {
  if (!validate$b(n))
    throw TypeError("Invalid UUID");
  var c, u = new Uint8Array(16);
  return u[0] = (c = parseInt(n.slice(0, 8), 16)) >>> 24, u[1] = c >>> 16 & 255, u[2] = c >>> 8 & 255, u[3] = c & 255, u[4] = (c = parseInt(n.slice(9, 13), 16)) >>> 8, u[5] = c & 255, u[6] = (c = parseInt(n.slice(14, 18), 16)) >>> 8, u[7] = c & 255, u[8] = (c = parseInt(n.slice(19, 23), 16)) >>> 8, u[9] = c & 255, u[10] = (c = parseInt(n.slice(24, 36), 16)) / 1099511627776 & 255, u[11] = c / 4294967296 & 255, u[12] = c >>> 24 & 255, u[13] = c >>> 16 & 255, u[14] = c >>> 8 & 255, u[15] = c & 255, u;
}
function stringToBytes$8(n) {
  n = unescape(encodeURIComponent(n));
  for (var c = [], u = 0; u < n.length; ++u)
    c.push(n.charCodeAt(u));
  return c;
}
var DNS$7 = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", URL$8 = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
function v35$a(n, c, u) {
  function p(a, A, b, F) {
    if (typeof a == "string" && (a = stringToBytes$8(a)), typeof A == "string" && (A = parse$h(A)), A.length !== 16)
      throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    var le = new Uint8Array(16 + a.length);
    if (le.set(A), le.set(a, A.length), le = u(le), le[6] = le[6] & 15 | c, le[8] = le[8] & 63 | 128, b) {
      F = F || 0;
      for (var L = 0; L < 16; ++L)
        b[F + L] = le[L];
      return b;
    }
    return stringify$a(le);
  }
  try {
    p.name = n;
  } catch {
  }
  return p.DNS = DNS$7, p.URL = URL$8, p;
}
function md5$c(n) {
  if (typeof n == "string") {
    var c = unescape(encodeURIComponent(n));
    n = new Uint8Array(c.length);
    for (var u = 0; u < c.length; ++u)
      n[u] = c.charCodeAt(u);
  }
  return md5ToHexEncodedArray$7(wordsToMd5$7(bytesToWords$7(n), n.length * 8));
}
function md5ToHexEncodedArray$7(n) {
  for (var c = [], u = n.length * 32, p = "0123456789abcdef", a = 0; a < u; a += 8) {
    var A = n[a >> 5] >>> a % 32 & 255, b = parseInt(p.charAt(A >>> 4 & 15) + p.charAt(A & 15), 16);
    c.push(b);
  }
  return c;
}
function getOutputLength$7(n) {
  return (n + 64 >>> 9 << 4) + 14 + 1;
}
function wordsToMd5$7(n, c) {
  n[c >> 5] |= 128 << c % 32, n[getOutputLength$7(c) - 1] = c;
  for (var u = 1732584193, p = -271733879, a = -1732584194, A = 271733878, b = 0; b < n.length; b += 16) {
    var F = u, le = p, L = a, pe = A;
    u = md5ff$7(u, p, a, A, n[b], 7, -680876936), A = md5ff$7(A, u, p, a, n[b + 1], 12, -389564586), a = md5ff$7(a, A, u, p, n[b + 2], 17, 606105819), p = md5ff$7(p, a, A, u, n[b + 3], 22, -1044525330), u = md5ff$7(u, p, a, A, n[b + 4], 7, -176418897), A = md5ff$7(A, u, p, a, n[b + 5], 12, 1200080426), a = md5ff$7(a, A, u, p, n[b + 6], 17, -1473231341), p = md5ff$7(p, a, A, u, n[b + 7], 22, -45705983), u = md5ff$7(u, p, a, A, n[b + 8], 7, 1770035416), A = md5ff$7(A, u, p, a, n[b + 9], 12, -1958414417), a = md5ff$7(a, A, u, p, n[b + 10], 17, -42063), p = md5ff$7(p, a, A, u, n[b + 11], 22, -1990404162), u = md5ff$7(u, p, a, A, n[b + 12], 7, 1804603682), A = md5ff$7(A, u, p, a, n[b + 13], 12, -40341101), a = md5ff$7(a, A, u, p, n[b + 14], 17, -1502002290), p = md5ff$7(p, a, A, u, n[b + 15], 22, 1236535329), u = md5gg$7(u, p, a, A, n[b + 1], 5, -165796510), A = md5gg$7(A, u, p, a, n[b + 6], 9, -1069501632), a = md5gg$7(a, A, u, p, n[b + 11], 14, 643717713), p = md5gg$7(p, a, A, u, n[b], 20, -373897302), u = md5gg$7(u, p, a, A, n[b + 5], 5, -701558691), A = md5gg$7(A, u, p, a, n[b + 10], 9, 38016083), a = md5gg$7(a, A, u, p, n[b + 15], 14, -660478335), p = md5gg$7(p, a, A, u, n[b + 4], 20, -405537848), u = md5gg$7(u, p, a, A, n[b + 9], 5, 568446438), A = md5gg$7(A, u, p, a, n[b + 14], 9, -1019803690), a = md5gg$7(a, A, u, p, n[b + 3], 14, -187363961), p = md5gg$7(p, a, A, u, n[b + 8], 20, 1163531501), u = md5gg$7(u, p, a, A, n[b + 13], 5, -1444681467), A = md5gg$7(A, u, p, a, n[b + 2], 9, -51403784), a = md5gg$7(a, A, u, p, n[b + 7], 14, 1735328473), p = md5gg$7(p, a, A, u, n[b + 12], 20, -1926607734), u = md5hh$7(u, p, a, A, n[b + 5], 4, -378558), A = md5hh$7(A, u, p, a, n[b + 8], 11, -2022574463), a = md5hh$7(a, A, u, p, n[b + 11], 16, 1839030562), p = md5hh$7(p, a, A, u, n[b + 14], 23, -35309556), u = md5hh$7(u, p, a, A, n[b + 1], 4, -1530992060), A = md5hh$7(A, u, p, a, n[b + 4], 11, 1272893353), a = md5hh$7(a, A, u, p, n[b + 7], 16, -155497632), p = md5hh$7(p, a, A, u, n[b + 10], 23, -1094730640), u = md5hh$7(u, p, a, A, n[b + 13], 4, 681279174), A = md5hh$7(A, u, p, a, n[b], 11, -358537222), a = md5hh$7(a, A, u, p, n[b + 3], 16, -722521979), p = md5hh$7(p, a, A, u, n[b + 6], 23, 76029189), u = md5hh$7(u, p, a, A, n[b + 9], 4, -640364487), A = md5hh$7(A, u, p, a, n[b + 12], 11, -421815835), a = md5hh$7(a, A, u, p, n[b + 15], 16, 530742520), p = md5hh$7(p, a, A, u, n[b + 2], 23, -995338651), u = md5ii$7(u, p, a, A, n[b], 6, -198630844), A = md5ii$7(A, u, p, a, n[b + 7], 10, 1126891415), a = md5ii$7(a, A, u, p, n[b + 14], 15, -1416354905), p = md5ii$7(p, a, A, u, n[b + 5], 21, -57434055), u = md5ii$7(u, p, a, A, n[b + 12], 6, 1700485571), A = md5ii$7(A, u, p, a, n[b + 3], 10, -1894986606), a = md5ii$7(a, A, u, p, n[b + 10], 15, -1051523), p = md5ii$7(p, a, A, u, n[b + 1], 21, -2054922799), u = md5ii$7(u, p, a, A, n[b + 8], 6, 1873313359), A = md5ii$7(A, u, p, a, n[b + 15], 10, -30611744), a = md5ii$7(a, A, u, p, n[b + 6], 15, -1560198380), p = md5ii$7(p, a, A, u, n[b + 13], 21, 1309151649), u = md5ii$7(u, p, a, A, n[b + 4], 6, -145523070), A = md5ii$7(A, u, p, a, n[b + 11], 10, -1120210379), a = md5ii$7(a, A, u, p, n[b + 2], 15, 718787259), p = md5ii$7(p, a, A, u, n[b + 9], 21, -343485551), u = safeAdd$7(u, F), p = safeAdd$7(p, le), a = safeAdd$7(a, L), A = safeAdd$7(A, pe);
  }
  return [u, p, a, A];
}
function bytesToWords$7(n) {
  if (n.length === 0)
    return [];
  for (var c = n.length * 8, u = new Uint32Array(getOutputLength$7(c)), p = 0; p < c; p += 8)
    u[p >> 5] |= (n[p / 8] & 255) << p % 32;
  return u;
}
function safeAdd$7(n, c) {
  var u = (n & 65535) + (c & 65535), p = (n >> 16) + (c >> 16) + (u >> 16);
  return p << 16 | u & 65535;
}
function bitRotateLeft$7(n, c) {
  return n << c | n >>> 32 - c;
}
function md5cmn$7(n, c, u, p, a, A) {
  return safeAdd$7(bitRotateLeft$7(safeAdd$7(safeAdd$7(c, n), safeAdd$7(p, A)), a), u);
}
function md5ff$7(n, c, u, p, a, A, b) {
  return md5cmn$7(c & u | ~c & p, n, c, a, A, b);
}
function md5gg$7(n, c, u, p, a, A, b) {
  return md5cmn$7(c & p | u & ~p, n, c, a, A, b);
}
function md5hh$7(n, c, u, p, a, A, b) {
  return md5cmn$7(c ^ u ^ p, n, c, a, A, b);
}
function md5ii$7(n, c, u, p, a, A, b) {
  return md5cmn$7(u ^ (c | ~p), n, c, a, A, b);
}
var v3$a = v35$a("v3", 48, md5$c);
function v4$b(n, c, u) {
  n = n || {};
  var p = n.random || (n.rng || rng$b)();
  if (p[6] = p[6] & 15 | 64, p[8] = p[8] & 63 | 128, c) {
    u = u || 0;
    for (var a = 0; a < 16; ++a)
      c[u + a] = p[a];
    return c;
  }
  return stringify$a(p);
}
function f$a(n, c, u, p) {
  switch (n) {
    case 0:
      return c & u ^ ~c & p;
    case 1:
      return c ^ u ^ p;
    case 2:
      return c & u ^ c & p ^ u & p;
    case 3:
      return c ^ u ^ p;
  }
}
function ROTL$7(n, c) {
  return n << c | n >>> 32 - c;
}
function sha1$a(n) {
  var c = [1518500249, 1859775393, 2400959708, 3395469782], u = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
  if (typeof n == "string") {
    var p = unescape(encodeURIComponent(n));
    n = [];
    for (var a = 0; a < p.length; ++a)
      n.push(p.charCodeAt(a));
  } else Array.isArray(n) || (n = Array.prototype.slice.call(n));
  n.push(128);
  for (var A = n.length / 4 + 2, b = Math.ceil(A / 16), F = new Array(b), le = 0; le < b; ++le) {
    for (var L = new Uint32Array(16), pe = 0; pe < 16; ++pe)
      L[pe] = n[le * 64 + pe * 4] << 24 | n[le * 64 + pe * 4 + 1] << 16 | n[le * 64 + pe * 4 + 2] << 8 | n[le * 64 + pe * 4 + 3];
    F[le] = L;
  }
  F[b - 1][14] = (n.length - 1) * 8 / Math.pow(2, 32), F[b - 1][14] = Math.floor(F[b - 1][14]), F[b - 1][15] = (n.length - 1) * 8 & 4294967295;
  for (var $ = 0; $ < b; ++$) {
    for (var Ee = new Uint32Array(80), be = 0; be < 16; ++be)
      Ee[be] = F[$][be];
    for (var He = 16; He < 80; ++He)
      Ee[He] = ROTL$7(Ee[He - 3] ^ Ee[He - 8] ^ Ee[He - 14] ^ Ee[He - 16], 1);
    for (var Pe = u[0], nr = u[1], ir = u[2], or = u[3], lr = u[4], Ir = 0; Ir < 80; ++Ir) {
      var xr = Math.floor(Ir / 20), kr = ROTL$7(Pe, 5) + f$a(xr, nr, ir, or) + lr + c[xr] + Ee[Ir] >>> 0;
      lr = or, or = ir, ir = ROTL$7(nr, 30) >>> 0, nr = Pe, Pe = kr;
    }
    u[0] = u[0] + Pe >>> 0, u[1] = u[1] + nr >>> 0, u[2] = u[2] + ir >>> 0, u[3] = u[3] + or >>> 0, u[4] = u[4] + lr >>> 0;
  }
  return [u[0] >> 24 & 255, u[0] >> 16 & 255, u[0] >> 8 & 255, u[0] & 255, u[1] >> 24 & 255, u[1] >> 16 & 255, u[1] >> 8 & 255, u[1] & 255, u[2] >> 24 & 255, u[2] >> 16 & 255, u[2] >> 8 & 255, u[2] & 255, u[3] >> 24 & 255, u[3] >> 16 & 255, u[3] >> 8 & 255, u[3] & 255, u[4] >> 24 & 255, u[4] >> 16 & 255, u[4] >> 8 & 255, u[4] & 255];
}
var v5$a = v35$a("v5", 80, sha1$a);
const nil$a = "00000000-0000-0000-0000-000000000000";
function version$c(n) {
  if (!validate$b(n))
    throw TypeError("Invalid UUID");
  return parseInt(n.substr(14, 1), 16);
}
const esmBrowser$7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  NIL: nil$a,
  parse: parse$h,
  stringify: stringify$a,
  v1: v1$a,
  v3: v3$a,
  v4: v4$b,
  v5: v5$a,
  validate: validate$b,
  version: version$c
}, Symbol.toStringTag, { value: "Module" })), require$$1$9 = /* @__PURE__ */ getAugmentedNamespace(esmBrowser$7);
var hasRequiredBcUrRegistryCosmos_cjs_production_min;
function requireBcUrRegistryCosmos_cjs_production_min() {
  return hasRequiredBcUrRegistryCosmos_cjs_production_min || (hasRequiredBcUrRegistryCosmos_cjs_production_min = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 });
    var c = requireDist$a(), u = require$$1$9;
    const p = { COSMOS_SIGN_REQUEST: new c.RegistryType("cosmos-sign-request", 4101), COSMOS_SIGNATURE: new c.RegistryType("cosmos-signature", 4102) }, { decodeToDataItem: a, RegistryTypes: A } = c.extend;
    var b, F;
    (b = n.SignDataType || (n.SignDataType = {}))[b.amino = 1] = "amino", b[b.direct = 2] = "direct", b[b.textual = 3] = "textual", b[b.message = 4] = "message", function(be) {
      be[be.requestId = 1] = "requestId", be[be.signData = 2] = "signData", be[be.dataType = 3] = "dataType", be[be.derivationPaths = 4] = "derivationPaths", be[be.addresses = 5] = "addresses", be[be.origin = 6] = "origin";
    }(F || (F = {}));
    class le extends c.RegistryItem {
      constructor(He) {
        super(), this.getRegistryType = () => p.COSMOS_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDataype = () => this.dataType, this.getDerivationPaths = () => this.derivationPaths.map((Pe) => Pe.getPath()), this.getAddress = () => this.addresses, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const Pe = {};
          return Pe[F.requestId] = new c.DataItem(this.requestId, A.UUID.getTag()), Pe[F.signData] = this.signData, Pe[F.dataType] = this.dataType, Pe[F.derivationPaths] = this.derivationPaths.map((nr) => {
            const ir = nr.toDataItem();
            return ir.setTag(nr.getRegistryType().getTag()), ir;
          }), this.addresses && (Pe[F.addresses] = this.addresses), this.origin && (Pe[F.origin] = this.origin), new c.DataItem(Pe);
        }, this.requestId = He.requestId, this.signData = He.signData, this.dataType = He.dataType, this.derivationPaths = He.derivationPaths, this.addresses = He.addresses, this.origin = He.origin;
      }
      static constructCosmosRequest(He, Pe, nr, ir, or, lr, Ir) {
        const xr = or.map((kr, Ce) => {
          const tr = kr.replace(/[m|M]\//, "").split("/").map((Fe) => {
            const Sr = parseInt(Fe.replace("'", ""));
            let er = !1;
            return Fe.endsWith("'") && (er = !0), new c.PathComponent({ index: Sr, hardened: er });
          });
          return new c.CryptoKeypath(tr, Buffer$f.from(Pe[Ce], "hex"));
        });
        return new le({ requestId: Buffer$f.from(u.parse(He)), signData: nr, dataType: ir || n.SignDataType.amino, derivationPaths: xr, addresses: lr || void 0, origin: Ir || void 0 });
      }
    }
    le.fromDataItem = (be) => {
      const He = be.getData(), Pe = He[F.requestId] ? He[F.requestId].getData() : void 0, nr = He[F.signData], ir = He[F.dataType], or = He[F.derivationPaths].map((lr) => c.CryptoKeypath.fromDataItem(lr));
      return new le({ requestId: Pe, signData: nr, dataType: ir, derivationPaths: or, addresses: He[F.addresses] ? He[F.addresses] : void 0, origin: He[F.origin] ? He[F.origin] : void 0 });
    }, le.fromCBOR = (be) => {
      const He = a(be);
      return le.fromDataItem(He);
    };
    const { RegistryTypes: L, decodeToDataItem: pe } = c.extend;
    var $;
    (function(be) {
      be[be.requestId = 1] = "requestId", be[be.signature = 2] = "signature", be[be.publicKey = 3] = "publicKey";
    })($ || ($ = {}));
    class Ee extends c.RegistryItem {
      constructor(He, Pe, nr) {
        super(), this.getRegistryType = () => p.COSMOS_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.getPublicKey = () => this.publicKey, this.toDataItem = () => {
          const ir = {};
          return ir[$.requestId] = new c.DataItem(this.requestId, L.UUID.getTag()), ir[$.signature] = this.signature, ir[$.publicKey] = this.publicKey, new c.DataItem(ir);
        }, this.signature = He, this.requestId = Pe, this.publicKey = nr;
      }
    }
    Ee.fromDataItem = (be) => {
      const He = be.getData(), Pe = He[$.signature], nr = He[$.requestId].getData();
      return new Ee(Pe, nr, He[$.publicKey]);
    }, Ee.fromCBOR = (be) => {
      const He = pe(be);
      return Ee.fromDataItem(He);
    }, c.patchTags(Object.values(p).filter((be) => !!be.getTag()).map((be) => be.getTag())), Object.keys(c).forEach(function(be) {
      be !== "default" && Object.defineProperty(n, be, { enumerable: !0, get: function() {
        return c[be];
      } });
    }), n.CosmosSignRequest = le, n.CosmosSignature = Ee;
  }(bcUrRegistryCosmos_cjs_production_min)), bcUrRegistryCosmos_cjs_production_min;
}
var bcUrRegistryCosmos_cjs_development = {}, hasRequiredBcUrRegistryCosmos_cjs_development;
function requireBcUrRegistryCosmos_cjs_development() {
  return hasRequiredBcUrRegistryCosmos_cjs_development || (hasRequiredBcUrRegistryCosmos_cjs_development = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 });
    var c = requireDist$a(), u = require$$1$9;
    const p = {
      COSMOS_SIGN_REQUEST: /* @__PURE__ */ new c.RegistryType("cosmos-sign-request", 4101),
      COSMOS_SIGNATURE: /* @__PURE__ */ new c.RegistryType("cosmos-signature", 4102)
    }, {
      decodeToDataItem: a,
      RegistryTypes: A
    } = c.extend;
    (function(Ee) {
      Ee[Ee.amino = 1] = "amino", Ee[Ee.direct = 2] = "direct", Ee[Ee.textual = 3] = "textual", Ee[Ee.message = 4] = "message";
    })(n.SignDataType || (n.SignDataType = {}));
    var b;
    (function(Ee) {
      Ee[Ee.requestId = 1] = "requestId", Ee[Ee.signData = 2] = "signData", Ee[Ee.dataType = 3] = "dataType", Ee[Ee.derivationPaths = 4] = "derivationPaths", Ee[Ee.addresses = 5] = "addresses", Ee[Ee.origin = 6] = "origin";
    })(b || (b = {}));
    class F extends c.RegistryItem {
      constructor(be) {
        super(), this.getRegistryType = () => p.COSMOS_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDataype = () => this.dataType, this.getDerivationPaths = () => this.derivationPaths.map((He) => He.getPath()), this.getAddress = () => this.addresses, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const He = {};
          return He[b.requestId] = new c.DataItem(this.requestId, A.UUID.getTag()), He[b.signData] = this.signData, He[b.dataType] = this.dataType, He[b.derivationPaths] = this.derivationPaths.map((Pe) => {
            const nr = Pe.toDataItem();
            return nr.setTag(Pe.getRegistryType().getTag()), nr;
          }), this.addresses && (He[b.addresses] = this.addresses), this.origin && (He[b.origin] = this.origin), new c.DataItem(He);
        }, this.requestId = be.requestId, this.signData = be.signData, this.dataType = be.dataType, this.derivationPaths = be.derivationPaths, this.addresses = be.addresses, this.origin = be.origin;
      }
      static constructCosmosRequest(be, He, Pe, nr, ir, or, lr) {
        const Ir = ir.map((xr, kr) => {
          const tr = xr.replace(/[m|M]\//, "").split("/").map((Fe) => {
            const Sr = parseInt(Fe.replace("'", ""));
            let er = !1;
            return Fe.endsWith("'") && (er = !0), new c.PathComponent({
              index: Sr,
              hardened: er
            });
          });
          return new c.CryptoKeypath(tr, Buffer$f.from(He[kr], "hex"));
        });
        return new F({
          requestId: Buffer$f.from(u.parse(be)),
          signData: Pe,
          dataType: nr || n.SignDataType.amino,
          derivationPaths: Ir,
          addresses: or || void 0,
          origin: lr || void 0
        });
      }
    }
    F.fromDataItem = (Ee) => {
      const be = Ee.getData(), He = be[b.requestId] ? be[b.requestId].getData() : void 0, Pe = be[b.signData], nr = be[b.dataType], ir = be[b.derivationPaths].map((Ir) => c.CryptoKeypath.fromDataItem(Ir)), or = be[b.addresses] ? be[b.addresses] : void 0, lr = be[b.origin] ? be[b.origin] : void 0;
      return new F({
        requestId: He,
        signData: Pe,
        dataType: nr,
        derivationPaths: ir,
        addresses: or,
        origin: lr
      });
    }, F.fromCBOR = (Ee) => {
      const be = a(Ee);
      return F.fromDataItem(be);
    };
    const {
      RegistryTypes: le,
      decodeToDataItem: L
    } = c.extend;
    var pe;
    (function(Ee) {
      Ee[Ee.requestId = 1] = "requestId", Ee[Ee.signature = 2] = "signature", Ee[Ee.publicKey = 3] = "publicKey";
    })(pe || (pe = {}));
    class $ extends c.RegistryItem {
      constructor(be, He, Pe) {
        super(), this.getRegistryType = () => p.COSMOS_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.getPublicKey = () => this.publicKey, this.toDataItem = () => {
          const nr = {};
          return nr[pe.requestId] = new c.DataItem(this.requestId, le.UUID.getTag()), nr[pe.signature] = this.signature, nr[pe.publicKey] = this.publicKey, new c.DataItem(nr);
        }, this.signature = be, this.requestId = He, this.publicKey = Pe;
      }
    }
    $.fromDataItem = (Ee) => {
      const be = Ee.getData(), He = be[pe.signature], Pe = be[pe.requestId].getData(), nr = be[pe.publicKey];
      return new $(He, Pe, nr);
    }, $.fromCBOR = (Ee) => {
      const be = L(Ee);
      return $.fromDataItem(be);
    }, c.patchTags(Object.values(p).filter((Ee) => !!Ee.getTag()).map((Ee) => Ee.getTag())), Object.keys(c).forEach(function(Ee) {
      Ee !== "default" && Object.defineProperty(n, Ee, {
        enumerable: !0,
        get: function() {
          return c[Ee];
        }
      });
    }), n.CosmosSignRequest = F, n.CosmosSignature = $;
  }(bcUrRegistryCosmos_cjs_development)), bcUrRegistryCosmos_cjs_development;
}
process$1.env.NODE_ENV === "production" ? dist$q.exports = requireBcUrRegistryCosmos_cjs_production_min() : dist$q.exports = requireBcUrRegistryCosmos_cjs_development();
var distExports$b = dist$q.exports;
Object.defineProperty(cosmos, "__esModule", { value: !0 });
cosmos.KeystoneCosmosSDK = void 0;
const utils_1$m = utils$K, ur_1$b = ur, bc_ur_registry_cosmos_1 = distExports$b;
class KeystoneCosmosSDK {
  constructor(c) {
    this.config = c;
  }
  parseSignature(c) {
    if (c.type !== ur_1$b.URType.CosmosSignature)
      throw new Error("type not match");
    const u = bc_ur_registry_cosmos_1.CosmosSignature.fromCBOR(c.cbor);
    return {
      requestId: (0, utils_1$m.uuidStringify)(u.getRequestId()),
      signature: (0, utils_1$m.toHex)(u.getSignature()),
      publicKey: (0, utils_1$m.toHex)(u.getPublicKey())
    };
  }
  generateSignRequest({ requestId: c, signData: u, dataType: p, accounts: a, origin: A }) {
    var b;
    const F = [], le = [];
    return a.forEach((L) => {
      F.push(new bc_ur_registry_cosmos_1.CryptoKeypath((0, utils_1$m.parsePath)(L.path).map((pe) => new bc_ur_registry_cosmos_1.PathComponent(pe)), (0, utils_1$m.toBuffer)(L.xfp))), le.push(L.address);
    }), new bc_ur_registry_cosmos_1.CosmosSignRequest({
      signData: (0, utils_1$m.toBuffer)(u),
      dataType: p,
      derivationPaths: F,
      requestId: (0, utils_1$m.uuidParse)(c),
      addresses: le,
      origin: A ?? ((b = this.config) === null || b === void 0 ? void 0 : b.origin)
    }).toUR();
  }
}
KeystoneCosmosSDK.DataType = bc_ur_registry_cosmos_1.SignDataType;
cosmos.KeystoneCosmosSDK = KeystoneCosmosSDK;
var evm = {}, dist$o = { exports: {} }, bcUrRegistryEvm_cjs_production_min = {}, dist$n = {}, patchCBOR$9 = {}, utils$F = {}, lib$c = {}, cborSync$9 = { exports: {} }, DataItem$9 = {}, hasRequiredDataItem$9;
function requireDataItem$9() {
  if (hasRequiredDataItem$9) return DataItem$9;
  hasRequiredDataItem$9 = 1, Object.defineProperty(DataItem$9, "__esModule", { value: !0 }), DataItem$9.DataItem = void 0;
  class n {
    constructor(u, p) {
      this.setTag = (a) => {
        this.tag = a;
      }, this.clearTag = () => {
        this.tag = void 0;
      }, this.getTag = () => this.tag, this.getData = () => this.data, this.data = u, this.tag = p;
    }
  }
  return DataItem$9.DataItem = n, DataItem$9;
}
var hasRequiredCborSync$9;
function requireCborSync$9() {
  return hasRequiredCborSync$9 || (hasRequiredCborSync$9 = 1, function(n) {
    (function(c, u) {
      n.exports ? n.exports = u() : c.CBOR = u();
    })(commonjsGlobal, function() {
      const { DataItem: c } = requireDataItem$9();
      var u = function() {
        function p(Ce) {
          this.$hex = Ce;
        }
        p.prototype = {
          length: function() {
            return this.$hex.length / 2;
          },
          toString: function(Ce) {
            if (!Ce || Ce === "hex" || Ce === 16)
              return this.$hex;
            if (Ce === "utf-8") {
              for (var tr = "", Fe = 0; Fe < this.$hex.length; Fe += 2)
                tr += "%" + this.$hex.substring(Fe, Fe + 2);
              return decodeURIComponent(tr);
            }
            if (Ce === "latin") {
              for (var tr = [], Fe = 0; Fe < this.$hex.length; Fe += 2)
                tr.push(parseInt(this.$hex.substring(Fe, Fe + 2), 16));
              return String.fromCharCode.apply(String, tr);
            }
            throw new Error("Unrecognised format: " + Ce);
          }
        }, p.fromLatinString = function(Ce) {
          for (var tr = "", Fe = 0; Fe < Ce.length; Fe++) {
            var Sr = Ce.charCodeAt(Fe).toString(16);
            Sr.length === 1 && (Sr = "0" + Sr), tr += Sr;
          }
          return new p(tr);
        }, p.fromUtf8String = function(Ce) {
          for (var tr = encodeURIComponent(Ce), Fe = "", Sr = 0; Sr < tr.length; Sr++)
            if (tr.charAt(Sr) === "%")
              Fe += tr.substring(Sr + 1, Sr + 3), Sr += 2;
            else {
              var er = tr.charCodeAt(Sr).toString(16);
              er.length < 2 && (er = "0" + er), Fe += er;
            }
          return new p(Fe);
        };
        var a = [], A = {}, b = function(Ce) {
          return function() {
            throw new Error(Ce + " not implemented");
          };
        };
        function F() {
        }
        F.prototype = {
          peekByte: b("peekByte"),
          readByte: b("readByte"),
          readChunk: b("readChunk"),
          readFloat16: function() {
            var Ce = this.readUint16(), tr = (Ce & 32767) >> 10, Fe = Ce & 1023, Sr = Ce & 32768;
            if (tr === 31)
              return Fe === 0 ? Sr ? -1 / 0 : 1 / 0 : NaN;
            var er = tr ? Math.pow(2, tr - 25) * (1024 + Fe) : Math.pow(2, -24) * Fe;
            return Sr ? -er : er;
          },
          readFloat32: function() {
            var Ce = this.readUint32(), tr = (Ce & 2147483647) >> 23, Fe = Ce & 8388607, Sr = Ce & 2147483648;
            if (tr === 255)
              return Fe === 0 ? Sr ? -1 / 0 : 1 / 0 : NaN;
            var er = tr ? Math.pow(2, tr - 23 - 127) * (8388608 + Fe) : Math.pow(2, -149) * Fe;
            return Sr ? -er : er;
          },
          readFloat64: function() {
            var Ce = this.readUint32(), tr = this.readUint32(), Fe = Ce >> 20 & 2047, Sr = (Ce & 1048575) * 4294967296 + tr, er = Ce & 2147483648;
            if (Fe === 2047)
              return Sr === 0 ? er ? -1 / 0 : 1 / 0 : NaN;
            var Ie = Fe ? Math.pow(2, Fe - 52 - 1023) * (4503599627370496 + Sr) : Math.pow(2, -1074) * Sr;
            return er ? -Ie : Ie;
          },
          readUint16: function() {
            return this.readByte() * 256 + this.readByte();
          },
          readUint32: function() {
            return this.readUint16() * 65536 + this.readUint16();
          },
          readUint64: function() {
            return this.readUint32() * 4294967296 + this.readUint32();
          }
        };
        function le() {
        }
        le.prototype = {
          writeByte: b("writeByte"),
          result: b("result"),
          writeFloat16: b("writeFloat16"),
          writeFloat32: b("writeFloat32"),
          writeFloat64: b("writeFloat64"),
          writeUint16: function(Ce) {
            this.writeByte(Ce >> 8 & 255), this.writeByte(Ce & 255);
          },
          writeUint32: function(Ce) {
            this.writeUint16(Ce >> 16 & 65535), this.writeUint16(Ce & 65535);
          },
          writeUint64: function(Ce) {
            if (Ce >= 9007199254740992 || Ce <= -9007199254740992)
              throw new Error("Cannot encode Uint64 of: " + Ce + " magnitude to big (floating point errors)");
            this.writeUint32(Math.floor(Ce / 4294967296)), this.writeUint32(Ce % 4294967296);
          },
          writeString: b("writeString"),
          canWriteBinary: function(Ce) {
            return !1;
          },
          writeBinary: b("writeChunk")
        };
        function L(Ce) {
          var tr = Ce.readByte(), Fe = tr >> 5, Sr = tr & 31;
          return { type: Fe, value: Sr };
        }
        function pe(Ce, tr) {
          var Fe = Ce.value;
          if (Fe < 24)
            return Fe;
          if (Fe == 24)
            return tr.readByte();
          if (Fe == 25)
            return tr.readUint16();
          if (Fe == 26)
            return tr.readUint32();
          if (Fe == 27)
            return tr.readUint64();
          if (Fe == 31)
            return null;
          b("Additional info: " + Fe)();
        }
        function $(Ce, tr, Fe) {
          Fe.writeByte(Ce << 5 | tr);
        }
        function Ee(Ce, tr, Fe) {
          var Sr = Ce << 5;
          tr < 24 ? Fe.writeByte(Sr | tr) : tr < 256 ? (Fe.writeByte(Sr | 24), Fe.writeByte(tr)) : tr < 65536 ? (Fe.writeByte(Sr | 25), Fe.writeUint16(tr)) : tr < 4294967296 ? (Fe.writeByte(Sr | 26), Fe.writeUint32(tr)) : (Fe.writeByte(Sr | 27), Fe.writeUint64(tr));
        }
        var be = new Error();
        function He(Ce) {
          var tr = L(Ce);
          switch (tr.type) {
            case 0:
              return pe(tr, Ce);
            case 1:
              return -1 - pe(tr, Ce);
            case 2:
              return Ce.readChunk(pe(tr, Ce));
            case 3:
              var Fe = Ce.readChunk(pe(tr, Ce));
              return Fe.toString("utf-8");
            case 4:
            case 5:
              var Sr = pe(tr, Ce), yr = [];
              if (Sr !== null) {
                tr.type === 5 && (Sr *= 2);
                for (var er = 0; er < Sr; er++)
                  yr[er] = He(Ce);
              } else
                for (var Ie; (Ie = He(Ce)) !== be; )
                  yr.push(Ie);
              if (tr.type === 5) {
                for (var xe = {}, er = 0; er < yr.length; er += 2)
                  xe[yr[er]] = yr[er + 1];
                return xe;
              } else
                return yr;
            case 6:
              var rr = pe(tr, Ce), ar = A[rr], yr = He(Ce);
              return ar ? ar(yr) : yr;
            case 7:
              if (tr.value === 25)
                return Ce.readFloat16();
              if (tr.value === 26)
                return Ce.readFloat32();
              if (tr.value === 27)
                return Ce.readFloat64();
              switch (pe(tr, Ce)) {
                case 20:
                  return !1;
                case 21:
                  return !0;
                case 22:
                  return null;
                case 23:
                  return;
                case null:
                  return be;
                default:
                  throw new Error("Unknown fixed value: " + tr.value);
              }
            default:
              throw new Error("Unsupported header: " + JSON.stringify(tr));
          }
          throw new Error("not implemented yet");
        }
        function Pe(Ce, tr) {
          for (var Fe = 0; Fe < a.length; Fe++) {
            var Sr = a[Fe].fn(Ce);
            if (Sr !== void 0)
              return Ee(6, a[Fe].tag, tr), Pe(Sr, tr);
          }
          if (Ce && typeof Ce.toCBOR == "function" && (Ce = Ce.toCBOR()), Ce === !1)
            Ee(7, 20, tr);
          else if (Ce === !0)
            Ee(7, 21, tr);
          else if (Ce === null)
            Ee(7, 22, tr);
          else if (Ce === void 0)
            Ee(7, 23, tr);
          else if (typeof Ce == "number")
            Math.floor(Ce) === Ce && Ce < 9007199254740992 && Ce > -9007199254740992 ? Ce < 0 ? Ee(1, -1 - Ce, tr) : Ee(0, Ce, tr) : ($(7, 27, tr), tr.writeFloat64(Ce));
          else if (typeof Ce == "string")
            tr.writeString(Ce, function(Ie) {
              Ee(3, Ie, tr);
            });
          else if (tr.canWriteBinary(Ce))
            tr.writeBinary(Ce, function(Ie) {
              Ee(2, Ie, tr);
            });
          else if (typeof Ce == "object")
            if (or.config.useToJSON && typeof Ce.toJSON == "function" && (Ce = Ce.toJSON()), Array.isArray(Ce)) {
              Ee(4, Ce.length, tr);
              for (var Fe = 0; Fe < Ce.length; Fe++)
                Pe(Ce[Fe], tr);
            } else {
              var er = Object.keys(Ce);
              Ee(5, er.length, tr);
              for (var Fe = 0; Fe < er.length; Fe++) {
                const xe = parseInt(er[Fe]);
                isNaN(xe) ? (Pe(er[Fe], tr), Pe(Ce[er[Fe]], tr)) : (Pe(xe, tr), Pe(Ce[er[Fe]], tr));
              }
            }
          else
            throw new Error("CBOR encoding not supported: " + Ce);
        }
        var nr = [], ir = [], or = {
          config: {
            useToJSON: !0
          },
          addWriter: function(Ce, tr) {
            typeof Ce == "string" ? ir.push(function(Fe) {
              if (Ce === Fe)
                return tr(Fe);
            }) : ir.push(Ce);
          },
          addReader: function(Ce, tr) {
            typeof Ce == "string" ? nr.push(function(Fe, Sr) {
              if (Ce === Sr)
                return tr(Fe, Sr);
            }) : nr.push(Ce);
          },
          encode: function(Ce, tr) {
            for (var Fe = 0; Fe < ir.length; Fe++) {
              var Sr = ir[Fe], er = Sr(tr);
              if (er)
                return Pe(Ce, er), er.result();
            }
            throw new Error("Unsupported output format: " + tr);
          },
          encodeDataItem: function(Ce, tr) {
            for (var Fe = 0; Fe < ir.length; Fe++) {
              var Sr = ir[Fe], er = Sr(tr);
              if (er)
                return Ce.getTag() !== void 0 ? (Pe(Ce, er), er.result()) : (Pe(Ce.getData(), er), er.result());
            }
            throw new Error("Unsupported output format: " + tr);
          },
          decode: function(Ce, tr) {
            for (var Fe = 0; Fe < nr.length; Fe++) {
              var Sr = nr[Fe], er = Sr(Ce, tr);
              if (er)
                return He(er);
            }
            throw new Error("Unsupported input format: " + tr);
          },
          decodeToDataItem: function(Ce, tr) {
            for (var Fe = 0; Fe < nr.length; Fe++) {
              var Sr = nr[Fe], er = Sr(Ce, tr);
              if (er) {
                const Ie = He(er);
                return Ie instanceof c ? Ie : new c(Ie);
              }
            }
            throw new Error("Unsupported input format: " + tr);
          },
          addSemanticEncode: function(Ce, tr) {
            if (typeof Ce != "number" || Ce % 1 !== 0 || Ce < 0)
              throw new Error("Tag must be a positive integer");
            return a.push({ tag: Ce, fn: tr }), this;
          },
          addSemanticDecode: function(Ce, tr) {
            if (typeof Ce != "number" || Ce % 1 !== 0 || Ce < 0)
              throw new Error("Tag must be a positive integer");
            return A[Ce] = tr, this;
          }
        };
        function lr(Ce) {
          this.buffer = Ce, this.pos = 0;
        }
        lr.prototype = Object.create(F.prototype), lr.prototype.peekByte = function() {
          return this.buffer[this.pos];
        }, lr.prototype.readByte = function() {
          return this.buffer[this.pos++];
        }, lr.prototype.readUint16 = function() {
          var Ce = this.buffer.readUInt16BE(this.pos);
          return this.pos += 2, Ce;
        }, lr.prototype.readUint32 = function() {
          var Ce = this.buffer.readUInt32BE(this.pos);
          return this.pos += 4, Ce;
        }, lr.prototype.readFloat32 = function() {
          var Ce = this.buffer.readFloatBE(this.pos);
          return this.pos += 4, Ce;
        }, lr.prototype.readFloat64 = function() {
          var Ce = this.buffer.readDoubleBE(this.pos);
          return this.pos += 8, Ce;
        }, lr.prototype.readChunk = function(Ce) {
          var tr = Buffer$f.alloc(Ce);
          return this.buffer.copy(tr, 0, this.pos, this.pos += Ce), tr;
        };
        function Ir(Ce) {
          this.byteLength = 0, this.defaultBufferLength = 16384, this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0, this.completeBuffers = [], this.stringFormat = Ce;
        }
        Ir.prototype = Object.create(le.prototype), Ir.prototype.writeByte = function(Ce) {
          this.latestBuffer[this.latestBufferOffset++] = Ce, this.latestBufferOffset >= this.latestBuffer.length && (this.completeBuffers.push(this.latestBuffer), this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0), this.byteLength++;
        }, Ir.prototype.writeFloat32 = function(Ce) {
          var tr = Buffer$f.alloc(4);
          tr.writeFloatBE(Ce, 0), this.writeBuffer(tr);
        }, Ir.prototype.writeFloat64 = function(Ce) {
          var tr = Buffer$f.alloc(8);
          tr.writeDoubleBE(Ce, 0), this.writeBuffer(tr);
        }, Ir.prototype.writeString = function(Ce, tr) {
          var Fe = Buffer$f.from(Ce, "utf-8");
          tr(Fe.length), this.writeBuffer(Fe);
        }, Ir.prototype.canWriteBinary = function(Ce) {
          return Ce instanceof Buffer$f;
        }, Ir.prototype.writeBinary = function(Ce, tr) {
          tr(Ce.length), this.writeBuffer(Ce);
        }, Ir.prototype.writeBuffer = function(Ce) {
          if (!(Ce instanceof Buffer$f))
            throw new TypeError("BufferWriter only accepts Buffers");
          this.latestBufferOffset ? this.latestBuffer.length - this.latestBufferOffset >= Ce.length ? (Ce.copy(this.latestBuffer, this.latestBufferOffset), this.latestBufferOffset += Ce.length, this.latestBufferOffset >= this.latestBuffer.length && (this.completeBuffers.push(this.latestBuffer), this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0)) : (this.completeBuffers.push(this.latestBuffer.slice(0, this.latestBufferOffset)), this.completeBuffers.push(Ce), this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0) : this.completeBuffers.push(Ce), this.byteLength += Ce.length;
        }, Ir.prototype.result = function() {
          for (var Ce = Buffer$f.alloc(this.byteLength), tr = 0, Fe = 0; Fe < this.completeBuffers.length; Fe++) {
            var Sr = this.completeBuffers[Fe];
            Sr.copy(Ce, tr, 0, Sr.length), tr += Sr.length;
          }
          return this.latestBufferOffset && this.latestBuffer.copy(Ce, tr, 0, this.latestBufferOffset), this.stringFormat ? Ce.toString(this.stringFormat) : Ce;
        }, typeof Buffer$f == "function" && (or.addReader(function(Ce, tr) {
          if (Buffer$f.isBuffer(Ce))
            return new lr(Ce);
          if (tr === "hex" || tr === "base64") {
            var Fe = Buffer$f.from(Ce, tr);
            return new lr(Fe);
          }
        }), or.addWriter(function(Ce) {
          if (!Ce || Ce === "buffer")
            return new Ir();
          if (Ce === "hex" || Ce === "base64")
            return new Ir(Ce);
        }));
        function xr(Ce) {
          this.hex = Ce, this.pos = 0;
        }
        xr.prototype = Object.create(F.prototype), xr.prototype.peekByte = function() {
          var Ce = this.hex.substring(this.pos, 2);
          return parseInt(Ce, 16);
        }, xr.prototype.readByte = function() {
          var Ce = this.hex.substring(this.pos, this.pos + 2);
          return this.pos += 2, parseInt(Ce, 16);
        }, xr.prototype.readChunk = function(Ce) {
          var tr = this.hex.substring(this.pos, this.pos + Ce * 2);
          return this.pos += Ce * 2, typeof Buffer$f == "function" ? Buffer$f.from(tr, "hex") : new p(tr);
        };
        function kr(Ce) {
          this.$hex = "", this.finalFormat = Ce || "hex";
        }
        return kr.prototype = Object.create(le.prototype), kr.prototype.writeByte = function(Ce) {
          if (Ce < 0 || Ce > 255)
            throw new Error("Byte value out of range: " + Ce);
          var tr = Ce.toString(16);
          tr.length == 1 && (tr = "0" + tr), this.$hex += tr;
        }, kr.prototype.canWriteBinary = function(Ce) {
          return Ce instanceof p || typeof Buffer$f == "function" && Ce instanceof Buffer$f;
        }, kr.prototype.writeBinary = function(Ce, tr) {
          if (Ce instanceof p)
            tr(Ce.length()), this.$hex += Ce.$hex;
          else if (typeof Buffer$f == "function" && Ce instanceof Buffer$f)
            tr(Ce.length), this.$hex += Ce.toString("hex");
          else
            throw new TypeError("HexWriter only accepts BinaryHex or Buffers");
        }, kr.prototype.result = function() {
          return this.finalFormat === "buffer" && typeof Buffer$f == "function" ? Buffer$f.from(this.$hex, "hex") : new p(this.$hex).toString(this.finalFormat);
        }, kr.prototype.writeString = function(Ce, tr) {
          var Fe = p.fromUtf8String(Ce);
          tr(Fe.length()), this.$hex += Fe.$hex;
        }, or.addReader(function(Ce, tr) {
          if (Ce instanceof p || Ce.$hex)
            return new xr(Ce.$hex);
          if (tr === "hex")
            return new xr(Ce);
        }), or.addWriter(function(Ce) {
          if (Ce === "hex")
            return new kr();
        }), or;
      }();
      return u.addSemanticEncode(0, function(p) {
        if (p instanceof Date)
          return p.toISOString();
      }).addSemanticDecode(0, function(p) {
        return new Date(p);
      }).addSemanticDecode(1, function(p) {
        return new Date(p);
      }), u;
    });
  }(cborSync$9)), cborSync$9.exports;
}
var hasRequiredLib$a;
function requireLib$a() {
  return hasRequiredLib$a || (hasRequiredLib$a = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.DataItem = n.addWriter = n.addReader = n.addSemanticEncode = n.addSemanticDecode = n.decodeToDataItem = n.encodeDataItem = void 0;
    var c = requireCborSync$9();
    Object.defineProperty(n, "encodeDataItem", { enumerable: !0, get: function() {
      return c.encodeDataItem;
    } }), Object.defineProperty(n, "decodeToDataItem", { enumerable: !0, get: function() {
      return c.decodeToDataItem;
    } }), Object.defineProperty(n, "addSemanticDecode", { enumerable: !0, get: function() {
      return c.addSemanticDecode;
    } }), Object.defineProperty(n, "addSemanticEncode", { enumerable: !0, get: function() {
      return c.addSemanticEncode;
    } }), Object.defineProperty(n, "addReader", { enumerable: !0, get: function() {
      return c.addReader;
    } }), Object.defineProperty(n, "addWriter", { enumerable: !0, get: function() {
      return c.addWriter;
    } });
    var u = requireDataItem$9();
    Object.defineProperty(n, "DataItem", { enumerable: !0, get: function() {
      return u.DataItem;
    } });
  }(lib$c)), lib$c;
}
var hasRequiredUtils$c;
function requireUtils$c() {
  if (hasRequiredUtils$c) return utils$F;
  hasRequiredUtils$c = 1, Object.defineProperty(utils$F, "__esModule", { value: !0 }), utils$F.patchTags = void 0;
  const n = requireLib$a(), c = [], u = (p) => {
    p.forEach((a) => {
      c.find((A) => A === a) || ((0, n.addSemanticEncode)(a, (A) => {
        if (A instanceof n.DataItem && A.getTag() === a)
          return A.getData();
      }), (0, n.addSemanticDecode)(a, (A) => new n.DataItem(A, a)), c.push(a));
    });
  };
  return utils$F.patchTags = u, utils$F;
}
var RegistryType$9 = {}, hasRequiredRegistryType$9;
function requireRegistryType$9() {
  if (hasRequiredRegistryType$9) return RegistryType$9;
  hasRequiredRegistryType$9 = 1, Object.defineProperty(RegistryType$9, "__esModule", { value: !0 }), RegistryType$9.RegistryTypes = RegistryType$9.RegistryType = void 0;
  class n {
    constructor(u, p) {
      this.type = u, this.tag = p, this.getTag = () => this.tag, this.getType = () => this.type;
    }
  }
  return RegistryType$9.RegistryType = n, RegistryType$9.RegistryTypes = {
    UUID: new n("uuid", 37),
    BYTES: new n("bytes", void 0),
    CRYPTO_HDKEY: new n("crypto-hdkey", 303),
    CRYPTO_KEYPATH: new n("crypto-keypath", 304),
    CRYPTO_COIN_INFO: new n("crypto-coin-info", 305),
    CRYPTO_ECKEY: new n("crypto-eckey", 306),
    CRYPTO_OUTPUT: new n("crypto-output", 308),
    CRYPTO_PSBT: new n("crypto-psbt", 310),
    CRYPTO_ACCOUNT: new n("crypto-account", 311),
    CRYPTO_MULTI_ACCOUNTS: new n("crypto-multi-accounts", 1103),
    QR_HARDWARE_CALL: new n("qr-hardware-call", 1201),
    KEY_DERIVATION_CALL: new n("key-derivation-call", 1301),
    KEY_DERIVATION_SCHEMA: new n("key-derivation-schema", 1302)
  }, RegistryType$9;
}
var ScriptExpression$9 = {}, hasRequiredScriptExpression$9;
function requireScriptExpression$9() {
  return hasRequiredScriptExpression$9 || (hasRequiredScriptExpression$9 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.ScriptExpressions = n.ScriptExpression = void 0;
    class c {
      constructor(p, a) {
        this.tag = p, this.expression = a, this.getTag = () => this.tag, this.getExpression = () => this.expression;
      }
    }
    n.ScriptExpression = c, c.fromTag = (u) => Object.values(n.ScriptExpressions).find((a) => a.getTag() === u), n.ScriptExpressions = {
      SCRIPT_HASH: new c(400, "sh"),
      WITNESS_SCRIPT_HASH: new c(401, "wsh"),
      PUBLIC_KEY: new c(402, "pk"),
      PUBLIC_KEY_HASH: new c(403, "pkh"),
      WITNESS_PUBLIC_KEY_HASH: new c(404, "wpkh"),
      COMBO: new c(405, "combo"),
      MULTISIG: new c(406, "multi"),
      SORTED_MULTISIG: new c(407, "sortedmulti"),
      ADDRESS: new c(307, "addr"),
      RAW_SCRIPT: new c(408, "raw")
    };
  }(ScriptExpression$9)), ScriptExpression$9;
}
var hasRequiredPatchCBOR$9;
function requirePatchCBOR$9() {
  if (hasRequiredPatchCBOR$9) return patchCBOR$9;
  hasRequiredPatchCBOR$9 = 1, Object.defineProperty(patchCBOR$9, "__esModule", { value: !0 });
  const n = requireUtils$c(), c = requireRegistryType$9(), u = requireScriptExpression$9(), p = Object.values(c.RegistryTypes).filter((A) => !!A.getTag()).map((A) => A.getTag()), a = Object.values(u.ScriptExpressions).map((A) => A.getTag());
  return (0, n.patchTags)(p.concat(a)), patchCBOR$9;
}
var CryptoHDKey$9 = {}, src$e, hasRequiredSrc$a;
function requireSrc$a() {
  if (hasRequiredSrc$a) return src$e;
  hasRequiredSrc$a = 1;
  var n = safeBufferExports.Buffer;
  function c(u) {
    if (u.length >= 255)
      throw new TypeError("Alphabet too long");
    for (var p = new Uint8Array(256), a = 0; a < p.length; a++)
      p[a] = 255;
    for (var A = 0; A < u.length; A++) {
      var b = u.charAt(A), F = b.charCodeAt(0);
      if (p[F] !== 255)
        throw new TypeError(b + " is ambiguous");
      p[F] = A;
    }
    var le = u.length, L = u.charAt(0), pe = Math.log(le) / Math.log(256), $ = Math.log(256) / Math.log(le);
    function Ee(Pe) {
      if ((Array.isArray(Pe) || Pe instanceof Uint8Array) && (Pe = n.from(Pe)), !n.isBuffer(Pe))
        throw new TypeError("Expected Buffer");
      if (Pe.length === 0)
        return "";
      for (var nr = 0, ir = 0, or = 0, lr = Pe.length; or !== lr && Pe[or] === 0; )
        or++, nr++;
      for (var Ir = (lr - or) * $ + 1 >>> 0, xr = new Uint8Array(Ir); or !== lr; ) {
        for (var kr = Pe[or], Ce = 0, tr = Ir - 1; (kr !== 0 || Ce < ir) && tr !== -1; tr--, Ce++)
          kr += 256 * xr[tr] >>> 0, xr[tr] = kr % le >>> 0, kr = kr / le >>> 0;
        if (kr !== 0)
          throw new Error("Non-zero carry");
        ir = Ce, or++;
      }
      for (var Fe = Ir - ir; Fe !== Ir && xr[Fe] === 0; )
        Fe++;
      for (var Sr = L.repeat(nr); Fe < Ir; ++Fe)
        Sr += u.charAt(xr[Fe]);
      return Sr;
    }
    function be(Pe) {
      if (typeof Pe != "string")
        throw new TypeError("Expected String");
      if (Pe.length === 0)
        return n.alloc(0);
      for (var nr = 0, ir = 0, or = 0; Pe[nr] === L; )
        ir++, nr++;
      for (var lr = (Pe.length - nr) * pe + 1 >>> 0, Ir = new Uint8Array(lr); nr < Pe.length; ) {
        var xr = Pe.charCodeAt(nr);
        if (xr > 255)
          return;
        var kr = p[xr];
        if (kr === 255)
          return;
        for (var Ce = 0, tr = lr - 1; (kr !== 0 || Ce < or) && tr !== -1; tr--, Ce++)
          kr += le * Ir[tr] >>> 0, Ir[tr] = kr % 256 >>> 0, kr = kr / 256 >>> 0;
        if (kr !== 0)
          throw new Error("Non-zero carry");
        or = Ce, nr++;
      }
      for (var Fe = lr - or; Fe !== lr && Ir[Fe] === 0; )
        Fe++;
      var Sr = n.allocUnsafe(ir + (lr - Fe));
      Sr.fill(0, 0, ir);
      for (var er = ir; Fe !== lr; )
        Sr[er++] = Ir[Fe++];
      return Sr;
    }
    function He(Pe) {
      var nr = be(Pe);
      if (nr)
        return nr;
      throw new Error("Non-base" + le + " character");
    }
    return {
      encode: Ee,
      decodeUnsafe: be,
      decode: He
    };
  }
  return src$e = c, src$e;
}
var bs58$b, hasRequiredBs58$a;
function requireBs58$a() {
  if (hasRequiredBs58$a) return bs58$b;
  hasRequiredBs58$a = 1;
  var n = requireSrc$a(), c = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
  return bs58$b = n(c), bs58$b;
}
var base$f, hasRequiredBase$b;
function requireBase$b() {
  if (hasRequiredBase$b) return base$f;
  hasRequiredBase$b = 1;
  var n = requireBs58$a(), c = safeBufferExports.Buffer;
  return base$f = function(u) {
    function p(F) {
      var le = u(F);
      return n.encode(c.concat([
        F,
        le
      ], F.length + 4));
    }
    function a(F) {
      var le = F.slice(0, -4), L = F.slice(-4), pe = u(le);
      if (!(L[0] ^ pe[0] | L[1] ^ pe[1] | L[2] ^ pe[2] | L[3] ^ pe[3]))
        return le;
    }
    function A(F) {
      var le = n.decodeUnsafe(F);
      if (le)
        return a(le);
    }
    function b(F) {
      var le = n.decode(F), L = a(le);
      if (!L) throw new Error("Invalid checksum");
      return L;
    }
    return {
      encode: p,
      decode: b,
      decodeUnsafe: A
    };
  }, base$f;
}
var bs58check$d, hasRequiredBs58check$a;
function requireBs58check$a() {
  if (hasRequiredBs58check$a) return bs58check$d;
  hasRequiredBs58check$a = 1;
  var n = browser$a, c = requireBase$b();
  function u(p) {
    var a = n("sha256").update(p).digest();
    return n("sha256").update(a).digest();
  }
  return bs58check$d = c(u), bs58check$d;
}
var CryptoCoinInfo$9 = {}, RegistryItem$9 = {}, hasRequiredRegistryItem$9;
function requireRegistryItem$9() {
  if (hasRequiredRegistryItem$9) return RegistryItem$9;
  hasRequiredRegistryItem$9 = 1, Object.defineProperty(RegistryItem$9, "__esModule", { value: !0 }), RegistryItem$9.RegistryItem = void 0;
  const n = dist$t, c = requireLib$a();
  class u {
    constructor() {
      this.toCBOR = () => {
        if (this.toDataItem() === void 0)
          throw new Error(`#[ur-registry][RegistryItem][fn.toCBOR]: registry ${this.getRegistryType()}'s method toDataItem returns undefined`);
        return (0, c.encodeDataItem)(this.toDataItem());
      }, this.toUR = () => new n.UR(this.toCBOR(), this.getRegistryType().getType()), this.toUREncoder = (a, A, b) => {
        const F = this.toUR();
        return new n.UREncoder(F, a, A, b);
      };
    }
  }
  return RegistryItem$9.RegistryItem = u, RegistryItem$9;
}
var hasRequiredCryptoCoinInfo$9;
function requireCryptoCoinInfo$9() {
  return hasRequiredCryptoCoinInfo$9 || (hasRequiredCryptoCoinInfo$9 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.CryptoCoinInfo = n.Network = n.Type = void 0;
    const c = requireLib$a(), u = requireRegistryItem$9(), p = requireRegistryType$9();
    var a;
    (function(le) {
      le.type = "1", le.network = "2";
    })(a || (a = {}));
    var A;
    (function(le) {
      le[le.bitcoin = 0] = "bitcoin";
    })(A = n.Type || (n.Type = {}));
    var b;
    (function(le) {
      le[le.mainnet = 0] = "mainnet", le[le.testnet = 1] = "testnet";
    })(b = n.Network || (n.Network = {}));
    class F extends u.RegistryItem {
      constructor(L, pe) {
        super(), this.type = L, this.network = pe, this.getRegistryType = () => p.RegistryTypes.CRYPTO_COIN_INFO, this.getType = () => this.type || A.bitcoin, this.getNetwork = () => this.network || b.mainnet, this.toDataItem = () => {
          const $ = {};
          return this.type && ($[a.type] = this.type), this.network && ($[a.network] = this.network), new c.DataItem($);
        };
      }
    }
    n.CryptoCoinInfo = F, F.fromDataItem = (le) => {
      const L = le.getData(), pe = L[a.type], $ = L[a.network];
      return new F(pe, $);
    }, F.fromCBOR = (le) => {
      const L = (0, c.decodeToDataItem)(le);
      return F.fromDataItem(L);
    };
  }(CryptoCoinInfo$9)), CryptoCoinInfo$9;
}
var CryptoKeypath$9 = {}, PathComponent$9 = {}, hasRequiredPathComponent$9;
function requirePathComponent$9() {
  if (hasRequiredPathComponent$9) return PathComponent$9;
  hasRequiredPathComponent$9 = 1, Object.defineProperty(PathComponent$9, "__esModule", { value: !0 }), PathComponent$9.PathComponent = void 0;
  class n {
    constructor(u) {
      if (this.getIndex = () => this.index, this.isWildcard = () => this.wildcard, this.isHardened = () => this.hardened, this.index = u.index, this.hardened = u.hardened, this.index !== void 0 ? this.wildcard = !1 : this.wildcard = !0, this.index && this.index & n.HARDENED_BIT)
        throw new Error(`#[ur-registry][PathComponent][fn.constructor]: Invalid index ${this.index} - most significant bit cannot be set`);
    }
  }
  return PathComponent$9.PathComponent = n, n.HARDENED_BIT = 2147483648, PathComponent$9;
}
var hasRequiredCryptoKeypath$9;
function requireCryptoKeypath$9() {
  if (hasRequiredCryptoKeypath$9) return CryptoKeypath$9;
  hasRequiredCryptoKeypath$9 = 1, Object.defineProperty(CryptoKeypath$9, "__esModule", { value: !0 }), CryptoKeypath$9.CryptoKeypath = void 0;
  const n = requireLib$a(), c = requirePathComponent$9(), u = requireRegistryItem$9(), p = requireRegistryType$9();
  var a;
  (function(b) {
    b[b.components = 1] = "components", b[b.source_fingerprint = 2] = "source_fingerprint", b[b.depth = 3] = "depth";
  })(a || (a = {}));
  class A extends u.RegistryItem {
    constructor(F = [], le, L) {
      super(), this.components = F, this.sourceFingerprint = le, this.depth = L, this.getRegistryType = () => p.RegistryTypes.CRYPTO_KEYPATH, this.getPath = () => this.components.length === 0 ? void 0 : this.components.map(($) => `${$.isWildcard() ? "*" : $.getIndex()}${$.isHardened() ? "'" : ""}`).join("/"), this.getComponents = () => this.components, this.getSourceFingerprint = () => this.sourceFingerprint, this.getDepth = () => this.depth, this.toDataItem = () => {
        const pe = {}, $ = [];
        return this.components && this.components.forEach((Ee) => {
          Ee.isWildcard() ? $.push([]) : $.push(Ee.getIndex()), $.push(Ee.isHardened());
        }), pe[a.components] = $, this.sourceFingerprint && (pe[a.source_fingerprint] = this.sourceFingerprint.readUInt32BE(0)), this.depth !== void 0 && (pe[a.depth] = this.depth), new n.DataItem(pe);
      };
    }
  }
  return CryptoKeypath$9.CryptoKeypath = A, A.fromDataItem = (b) => {
    const F = b.getData(), le = [], L = F[a.components];
    if (L)
      for (let be = 0; be < L.length; be += 2) {
        const He = L[be + 1], Pe = L[be];
        typeof Pe == "number" ? le.push(new c.PathComponent({ index: Pe, hardened: He })) : le.push(new c.PathComponent({ hardened: He }));
      }
    const pe = F[a.source_fingerprint];
    let $;
    pe && ($ = Buffer$f.alloc(4), $.writeUInt32BE(pe, 0));
    const Ee = F[a.depth];
    return new A(le, $, Ee);
  }, A.fromCBOR = (b) => {
    const F = (0, n.decodeToDataItem)(b);
    return A.fromDataItem(F);
  }, CryptoKeypath$9;
}
var hasRequiredCryptoHDKey$9;
function requireCryptoHDKey$9() {
  if (hasRequiredCryptoHDKey$9) return CryptoHDKey$9;
  hasRequiredCryptoHDKey$9 = 1, Object.defineProperty(CryptoHDKey$9, "__esModule", { value: !0 }), CryptoHDKey$9.CryptoHDKey = void 0;
  const n = requireBs58check$a(), c = requireCryptoCoinInfo$9(), u = requireCryptoKeypath$9(), p = requireLib$a(), a = requireRegistryItem$9(), A = requireRegistryType$9();
  var b;
  (function(le) {
    le[le.is_master = 1] = "is_master", le[le.is_private = 2] = "is_private", le[le.key_data = 3] = "key_data", le[le.chain_code = 4] = "chain_code", le[le.use_info = 5] = "use_info", le[le.origin = 6] = "origin", le[le.children = 7] = "children", le[le.parent_fingerprint = 8] = "parent_fingerprint", le[le.name = 9] = "name", le[le.note = 10] = "note";
  })(b || (b = {}));
  class F extends a.RegistryItem {
    constructor(L) {
      super(), this.isECKey = () => !1, this.getKey = () => this.key, this.getChainCode = () => this.chainCode, this.isMaster = () => this.master, this.isPrivateKey = () => !!this.privateKey, this.getUseInfo = () => this.useInfo, this.getOrigin = () => this.origin, this.getChildren = () => this.children, this.getParentFingerprint = () => this.parentFingerprint, this.getName = () => this.name, this.getNote = () => this.note, this.getBip32Key = () => {
        var pe, $, Ee;
        let be, He, Pe = 0, nr = Buffer$f.alloc(4).fill(0);
        if (this.isMaster())
          be = Buffer$f.from("0488ADE4", "hex"), He = 0, Pe = 0;
        else {
          He = ((pe = this.getOrigin()) === null || pe === void 0 ? void 0 : pe.getComponents().length) || (($ = this.getOrigin()) === null || $ === void 0 ? void 0 : $.getDepth());
          const xr = (Ee = this.getOrigin()) === null || Ee === void 0 ? void 0 : Ee.getComponents(), kr = xr[xr.length - 1];
          kr && (Pe = kr.isHardened() ? kr.getIndex() + 2147483648 : kr.getIndex(), this.getParentFingerprint() && (nr = this.getParentFingerprint())), this.isPrivateKey() ? be = Buffer$f.from("0488ADE4", "hex") : be = Buffer$f.from("0488B21E", "hex");
        }
        const ir = Buffer$f.alloc(1);
        ir.writeUInt8(He, 0);
        const or = Buffer$f.alloc(4);
        or.writeUInt32BE(Pe, 0);
        const lr = this.getChainCode(), Ir = this.getKey();
        return (0, n.encode)(Buffer$f.concat([be, ir, nr, or, lr, Ir]));
      }, this.getRegistryType = () => A.RegistryTypes.CRYPTO_HDKEY, this.getOutputDescriptorContent = () => {
        var pe, $, Ee, be, He, Pe, nr;
        let ir = "";
        return this.getOrigin() && !((pe = this.getOrigin()) === null || pe === void 0) && pe.getSourceFingerprint() && !(($ = this.getOrigin()) === null || $ === void 0) && $.getPath() && (ir += `${(be = (Ee = this.getOrigin()) === null || Ee === void 0 ? void 0 : Ee.getSourceFingerprint()) === null || be === void 0 ? void 0 : be.toString("hex")}/${(He = this.getOrigin()) === null || He === void 0 ? void 0 : He.getPath()}`), ir += this.getBip32Key(), this.getChildren() && !((Pe = this.getChildren()) === null || Pe === void 0) && Pe.getPath() && (ir += `/${(nr = this.getChildren()) === null || nr === void 0 ? void 0 : nr.getPath()}`), ir;
      }, this.setupMasterKey = (pe) => {
        this.master = !0, this.key = pe.key, this.chainCode = pe.chainCode;
      }, this.setupDeriveKey = (pe) => {
        this.master = !1, this.privateKey = pe.isPrivateKey, this.key = pe.key, this.chainCode = pe.chainCode, this.useInfo = pe.useInfo, this.origin = pe.origin, this.children = pe.children, this.parentFingerprint = pe.parentFingerprint, this.name = pe.name, this.note = pe.note;
      }, this.toDataItem = () => {
        const pe = {};
        if (this.master)
          pe[b.is_master] = !0, pe[b.key_data] = this.key, pe[b.chain_code] = this.chainCode;
        else {
          if (this.privateKey !== void 0 && (pe[b.is_private] = this.privateKey), pe[b.key_data] = this.key, this.chainCode && (pe[b.chain_code] = this.chainCode), this.useInfo) {
            const $ = this.useInfo.toDataItem();
            $.setTag(this.useInfo.getRegistryType().getTag()), pe[b.use_info] = $;
          }
          if (this.origin) {
            const $ = this.origin.toDataItem();
            $.setTag(this.origin.getRegistryType().getTag()), pe[b.origin] = $;
          }
          if (this.children) {
            const $ = this.children.toDataItem();
            $.setTag(this.children.getRegistryType().getTag()), pe[b.children] = $;
          }
          this.parentFingerprint && (pe[b.parent_fingerprint] = this.parentFingerprint.readUInt32BE(0)), this.name !== void 0 && (pe[b.name] = this.name), this.note !== void 0 && (pe[b.note] = this.note);
        }
        return new p.DataItem(pe);
      }, L.isMaster ? this.setupMasterKey(L) : this.setupDeriveKey(L);
    }
  }
  return CryptoHDKey$9.CryptoHDKey = F, F.fromDataItem = (le) => {
    const L = le.getData(), pe = !!L[b.is_master], $ = L[b.is_private], Ee = L[b.key_data], be = L[b.chain_code], He = L[b.use_info] ? c.CryptoCoinInfo.fromDataItem(L[b.use_info]) : void 0, Pe = L[b.origin] ? u.CryptoKeypath.fromDataItem(L[b.origin]) : void 0, nr = L[b.children] ? u.CryptoKeypath.fromDataItem(L[b.children]) : void 0, ir = L[b.parent_fingerprint];
    let or;
    ir && (or = Buffer$f.alloc(4), or.writeUInt32BE(ir, 0));
    const lr = L[b.name], Ir = L[b.note];
    return new F({
      isMaster: pe,
      isPrivateKey: $,
      key: Ee,
      chainCode: be,
      useInfo: He,
      origin: Pe,
      children: nr,
      parentFingerprint: or,
      name: lr,
      note: Ir
    });
  }, F.fromCBOR = (le) => {
    const L = (0, p.decodeToDataItem)(le);
    return F.fromDataItem(L);
  }, CryptoHDKey$9;
}
var CryptoECKey$9 = {}, hasRequiredCryptoECKey$9;
function requireCryptoECKey$9() {
  if (hasRequiredCryptoECKey$9) return CryptoECKey$9;
  hasRequiredCryptoECKey$9 = 1, Object.defineProperty(CryptoECKey$9, "__esModule", { value: !0 }), CryptoECKey$9.CryptoECKey = void 0;
  const n = requireLib$a(), c = requireRegistryItem$9(), u = requireRegistryType$9();
  var p;
  (function(A) {
    A[A.curve = 1] = "curve", A[A.private = 2] = "private", A[A.data = 3] = "data";
  })(p || (p = {}));
  class a extends c.RegistryItem {
    constructor(b) {
      super(), this.isECKey = () => !0, this.getCurve = () => this.curve || 0, this.isPrivateKey = () => this.privateKey || !1, this.getData = () => this.data, this.getRegistryType = () => u.RegistryTypes.CRYPTO_ECKEY, this.toDataItem = () => {
        const F = {};
        return this.curve && (F[p.curve] = this.curve), this.privateKey !== void 0 && (F[p.private] = this.privateKey), F[p.data] = this.data, new n.DataItem(F);
      }, this.getOutputDescriptorContent = () => this.data.toString("hex"), this.data = b.data, this.curve = b.curve, this.privateKey = b.privateKey || void 0;
    }
  }
  return CryptoECKey$9.CryptoECKey = a, a.fromDataItem = (A) => {
    const b = A.getData(), F = b[p.curve], le = b[p.private], L = b[p.data];
    if (!L)
      throw new Error(`#[ur-registry][CryptoECKey][fn.fromDataItem]: decoded [dataItem][#data.data] is undefined: ${A}`);
    return new a({ data: L, curve: F, privateKey: le });
  }, a.fromCBOR = (A) => {
    const b = (0, n.decodeToDataItem)(A);
    return a.fromDataItem(b);
  }, CryptoECKey$9;
}
var Bytes$a = {}, hasRequiredBytes$a;
function requireBytes$a() {
  if (hasRequiredBytes$a) return Bytes$a;
  hasRequiredBytes$a = 1, Object.defineProperty(Bytes$a, "__esModule", { value: !0 }), Bytes$a.Bytes = void 0;
  const n = requireLib$a(), c = requireRegistryItem$9(), u = requireRegistryType$9();
  class p extends c.RegistryItem {
    constructor(A) {
      super(), this.bytes = A, this.getRegistryType = () => u.RegistryTypes.BYTES, this.getData = () => this.bytes, this.toDataItem = () => new n.DataItem(this.bytes);
    }
  }
  return Bytes$a.Bytes = p, p.fromDataItem = (a) => {
    const A = a.getData();
    if (!A)
      throw new Error(`#[ur-registry][Bytes][fn.fromDataItem]: decoded [dataItem][#data] is undefined: ${a}`);
    return new p(A);
  }, p.fromCBOR = (a) => {
    const A = (0, n.decodeToDataItem)(a);
    return p.fromDataItem(A);
  }, Bytes$a;
}
var CryptoOutput$9 = {}, MultiKey$9 = {}, hasRequiredMultiKey$9;
function requireMultiKey$9() {
  if (hasRequiredMultiKey$9) return MultiKey$9;
  hasRequiredMultiKey$9 = 1, Object.defineProperty(MultiKey$9, "__esModule", { value: !0 }), MultiKey$9.MultiKey = void 0;
  const n = requireCryptoECKey$9(), c = requireCryptoHDKey$9(), u = requireDataItem$9(), p = requireRegistryItem$9(), a = requireRegistryType$9();
  var A;
  (function(F) {
    F[F.threshold = 1] = "threshold", F[F.keys = 2] = "keys";
  })(A || (A = {}));
  class b extends p.RegistryItem {
    constructor(le, L) {
      super(), this.threshold = le, this.keys = L, this.getThreshold = () => this.threshold, this.getKeys = () => this.keys, this.toDataItem = () => {
        const pe = {};
        pe[A.threshold] = this.threshold;
        const $ = this.keys.map((Ee) => {
          const be = Ee.toDataItem();
          return be.setTag(Ee.getRegistryType().getTag()), be;
        });
        return pe[A.keys] = $, new u.DataItem(pe);
      }, this.getOutputDescriptorContent = () => [
        this.getThreshold(),
        this.keys.map((pe) => pe.getOutputDescriptorContent()).join(",")
      ].join(",");
    }
  }
  return MultiKey$9.MultiKey = b, b.fromDataItem = (F) => {
    const le = F.getData(), L = le[A.threshold], pe = le[A.keys], $ = [];
    return pe.forEach((Ee) => {
      Ee.getTag() === a.RegistryTypes.CRYPTO_HDKEY.getTag() ? $.push(c.CryptoHDKey.fromDataItem(Ee)) : Ee.getTag() === a.RegistryTypes.CRYPTO_ECKEY.getTag() && $.push(n.CryptoECKey.fromDataItem(Ee));
    }), new b(L, $);
  }, MultiKey$9;
}
var hasRequiredCryptoOutput$9;
function requireCryptoOutput$9() {
  if (hasRequiredCryptoOutput$9) return CryptoOutput$9;
  hasRequiredCryptoOutput$9 = 1, Object.defineProperty(CryptoOutput$9, "__esModule", { value: !0 }), CryptoOutput$9.CryptoOutput = void 0;
  const n = requireCryptoECKey$9(), c = requireCryptoHDKey$9(), u = requireLib$a(), p = requireMultiKey$9(), a = requireRegistryItem$9(), A = requireRegistryType$9(), b = requireScriptExpression$9();
  class F extends a.RegistryItem {
    constructor(L, pe) {
      super(), this.scriptExpressions = L, this.cryptoKey = pe, this.getRegistryType = () => A.RegistryTypes.CRYPTO_OUTPUT, this.getCryptoKey = () => this.cryptoKey, this.getHDKey = () => {
        if (this.cryptoKey instanceof c.CryptoHDKey)
          return this.cryptoKey;
      }, this.getECKey = () => {
        if (this.cryptoKey instanceof n.CryptoECKey)
          return this.cryptoKey;
      }, this.getMultiKey = () => {
        if (this.cryptoKey instanceof p.MultiKey)
          return this.cryptoKey;
      }, this.getScriptExpressions = () => this.scriptExpressions, this._toOutputDescriptor = ($) => $ >= this.scriptExpressions.length ? this.cryptoKey.getOutputDescriptorContent() : `${this.scriptExpressions[$].getExpression()}(${this._toOutputDescriptor($ + 1)})`, this.toString = () => this._toOutputDescriptor(0), this.toDataItem = () => {
        let $ = this.cryptoKey.toDataItem();
        return (this.cryptoKey instanceof n.CryptoECKey || this.cryptoKey instanceof c.CryptoHDKey) && $.setTag(this.cryptoKey.getRegistryType().getTag()), [...this.scriptExpressions].reverse().forEach((be) => {
          const He = be.getTag();
          $.getTag() === void 0 ? $.setTag(He) : $ = new u.DataItem($, He);
        }), $;
      };
    }
  }
  return CryptoOutput$9.CryptoOutput = F, F.fromDataItem = (le) => {
    const L = [];
    let pe = le;
    for (; ; ) {
      let be = pe.getTag();
      const He = b.ScriptExpression.fromTag(be);
      if (He)
        if (L.push(He), pe.getData() instanceof u.DataItem)
          pe = pe.getData(), be = pe.getTag();
        else
          break;
      else
        break;
    }
    const $ = L.length;
    if ($ > 0 && (L[$ - 1].getExpression() === b.ScriptExpressions.MULTISIG.getExpression() || L[$ - 1].getExpression() === b.ScriptExpressions.SORTED_MULTISIG.getExpression())) {
      const be = p.MultiKey.fromDataItem(pe);
      return new F(L, be);
    }
    if (pe.getTag() === A.RegistryTypes.CRYPTO_HDKEY.getTag()) {
      const be = c.CryptoHDKey.fromDataItem(pe);
      return new F(L, be);
    } else {
      const be = n.CryptoECKey.fromDataItem(pe);
      return new F(L, be);
    }
  }, F.fromCBOR = (le) => {
    const L = (0, u.decodeToDataItem)(le);
    return F.fromDataItem(L);
  }, CryptoOutput$9;
}
var CryptoPSBT$9 = {}, hasRequiredCryptoPSBT$9;
function requireCryptoPSBT$9() {
  if (hasRequiredCryptoPSBT$9) return CryptoPSBT$9;
  hasRequiredCryptoPSBT$9 = 1, Object.defineProperty(CryptoPSBT$9, "__esModule", { value: !0 }), CryptoPSBT$9.CryptoPSBT = void 0;
  const n = requireLib$a(), c = requireRegistryItem$9(), u = requireRegistryType$9();
  class p extends c.RegistryItem {
    constructor(A) {
      super(), this.psbt = A, this.getRegistryType = () => u.RegistryTypes.CRYPTO_PSBT, this.getPSBT = () => this.psbt, this.toDataItem = () => new n.DataItem(this.psbt);
    }
  }
  return CryptoPSBT$9.CryptoPSBT = p, p.fromDataItem = (a) => {
    const A = a.getData();
    if (!A)
      throw new Error(`#[ur-registry][CryptoPSBT][fn.fromDataItem]: decoded [dataItem][#data] is undefined: ${a}`);
    return new p(A);
  }, p.fromCBOR = (a) => {
    const A = (0, n.decodeToDataItem)(a);
    return p.fromDataItem(A);
  }, CryptoPSBT$9;
}
var CryptoAccount$9 = {}, hasRequiredCryptoAccount$9;
function requireCryptoAccount$9() {
  if (hasRequiredCryptoAccount$9) return CryptoAccount$9;
  hasRequiredCryptoAccount$9 = 1, Object.defineProperty(CryptoAccount$9, "__esModule", { value: !0 }), CryptoAccount$9.CryptoAccount = void 0;
  const n = requireDist$9(), c = requireLib$a(), u = requireRegistryItem$9(), p = requireRegistryType$9();
  var a;
  (function(b) {
    b[b.masterFingerprint = 1] = "masterFingerprint", b[b.outputDescriptors = 2] = "outputDescriptors";
  })(a || (a = {}));
  class A extends u.RegistryItem {
    constructor(F, le) {
      super(), this.masterFingerprint = F, this.outputDescriptors = le, this.getRegistryType = () => p.RegistryTypes.CRYPTO_ACCOUNT, this.getMasterFingerprint = () => this.masterFingerprint, this.getOutputDescriptors = () => this.outputDescriptors, this.toDataItem = () => {
        const L = {};
        return this.masterFingerprint && (L[a.masterFingerprint] = this.masterFingerprint.readUInt32BE(0)), this.outputDescriptors && (L[a.outputDescriptors] = this.outputDescriptors.map((pe) => pe.toDataItem())), new c.DataItem(L);
      };
    }
  }
  return CryptoAccount$9.CryptoAccount = A, A.fromDataItem = (b) => {
    const F = b.getData(), le = Buffer$f.alloc(4), L = F[a.masterFingerprint];
    L && le.writeUInt32BE(L, 0);
    const $ = F[a.outputDescriptors].map((Ee) => n.CryptoOutput.fromDataItem(Ee));
    return new A(le, $);
  }, A.fromCBOR = (b) => {
    const F = (0, c.decodeToDataItem)(b);
    return A.fromDataItem(F);
  }, CryptoAccount$9;
}
var Decoder$9 = {}, errors$a = {}, hasRequiredErrors$9;
function requireErrors$9() {
  if (hasRequiredErrors$9) return errors$a;
  hasRequiredErrors$9 = 1, Object.defineProperty(errors$a, "__esModule", { value: !0 }), errors$a.UnknownURTypeError = void 0;
  class n extends Error {
    constructor(u) {
      super(u);
    }
  }
  return errors$a.UnknownURTypeError = n, errors$a;
}
var hasRequiredDecoder$9;
function requireDecoder$9() {
  if (hasRequiredDecoder$9) return Decoder$9;
  hasRequiredDecoder$9 = 1, Object.defineProperty(Decoder$9, "__esModule", { value: !0 }), Decoder$9.URRegistryDecoder = void 0;
  const n = dist$t, c = requireDist$9(), u = requireRegistryType$9(), p = requireErrors$9();
  class a extends n.URDecoder {
    constructor() {
      super(...arguments), this.resultRegistryType = () => {
        const b = this.resultUR();
        switch (b.type) {
          case u.RegistryTypes.BYTES.getType():
            return c.Bytes.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_HDKEY.getType():
            return c.CryptoHDKey.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_KEYPATH.getType():
            return c.CryptoKeypath.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_COIN_INFO.getType():
            return c.CryptoCoinInfo.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_ECKEY.getType():
            return c.CryptoECKey.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_OUTPUT.getType():
            return c.CryptoOutput.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_PSBT.getType():
            return c.CryptoPSBT.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_ACCOUNT.getType():
            return c.CryptoAccount.fromCBOR(b.cbor);
          default:
            throw new p.UnknownURTypeError(`#[ur-registry][Decoder][fn.resultRegistryType]: registry type ${b.type} is not supported now`);
        }
      };
    }
  }
  return Decoder$9.URRegistryDecoder = a, Decoder$9;
}
var CryptoMultiAccounts$9 = {}, hasRequiredCryptoMultiAccounts$9;
function requireCryptoMultiAccounts$9() {
  if (hasRequiredCryptoMultiAccounts$9) return CryptoMultiAccounts$9;
  hasRequiredCryptoMultiAccounts$9 = 1, Object.defineProperty(CryptoMultiAccounts$9, "__esModule", { value: !0 }), CryptoMultiAccounts$9.CryptoMultiAccounts = void 0;
  const n = requireRegistryType$9(), c = requireCryptoHDKey$9(), u = requireRegistryItem$9(), p = requireLib$a();
  var a;
  (function(b) {
    b[b.masterFingerprint = 1] = "masterFingerprint", b[b.keys = 2] = "keys", b[b.device = 3] = "device", b[b.deviceId = 4] = "deviceId", b[b.version = 5] = "version";
  })(a || (a = {}));
  class A extends u.RegistryItem {
    constructor(F, le, L, pe, $) {
      super(), this.masterFingerprint = F, this.keys = le, this.device = L, this.deviceId = pe, this.version = $, this.getRegistryType = () => n.RegistryTypes.CRYPTO_MULTI_ACCOUNTS, this.getMasterFingerprint = () => this.masterFingerprint, this.getKeys = () => this.keys, this.getDevice = () => this.device, this.getDeviceId = () => this.deviceId, this.getVersion = () => this.version, this.toDataItem = () => {
        const Ee = {};
        return this.masterFingerprint && (Ee[a.masterFingerprint] = this.masterFingerprint.readUInt32BE(0)), this.keys && (Ee[a.keys] = this.keys.map((be) => {
          const He = be.toDataItem();
          return He.setTag(be.getRegistryType().getTag()), He;
        })), this.device && (Ee[a.device] = this.device), this.deviceId && (Ee[a.deviceId] = this.deviceId), this.version && (Ee[a.version] = this.version), new p.DataItem(Ee);
      };
    }
  }
  return CryptoMultiAccounts$9.CryptoMultiAccounts = A, A.fromDataItem = (b) => {
    const F = b.getData(), le = Buffer$f.alloc(4), L = F[a.masterFingerprint];
    L && le.writeUInt32BE(L, 0);
    const $ = F[a.keys].map((Pe) => c.CryptoHDKey.fromDataItem(Pe)), Ee = F[a.device], be = F[a.deviceId], He = F[a.version];
    return new A(le, $, Ee, be, He);
  }, A.fromCBOR = (b) => {
    const F = (0, p.decodeToDataItem)(b);
    return A.fromDataItem(F);
  }, CryptoMultiAccounts$9;
}
var QRHardwareCall$9 = {}, KeyDerivation$9 = {}, DerivationSchema$9 = {}, hasRequiredDerivationSchema$9;
function requireDerivationSchema$9() {
  return hasRequiredDerivationSchema$9 || (hasRequiredDerivationSchema$9 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.KeyDerivationSchema = n.DerivationAlgorithm = n.Curve = void 0;
    const c = requireRegistryType$9(), u = requireRegistryItem$9(), p = requireLib$a(), a = requireCryptoKeypath$9();
    var A;
    (function(L) {
      L[L.keyPath = 1] = "keyPath", L[L.curve = 2] = "curve", L[L.algo = 3] = "algo";
    })(A || (A = {}));
    var b;
    (function(L) {
      L[L.secp256k1 = 0] = "secp256k1", L[L.ed25519 = 1] = "ed25519";
    })(b = n.Curve || (n.Curve = {}));
    var F;
    (function(L) {
      L[L.slip10 = 0] = "slip10", L[L.bip32ed25519 = 1] = "bip32ed25519";
    })(F = n.DerivationAlgorithm || (n.DerivationAlgorithm = {}));
    class le extends u.RegistryItem {
      constructor(pe, $ = b.secp256k1, Ee = F.slip10) {
        super(), this.keypath = pe, this.curve = $, this.algo = Ee, this.getRegistryType = () => c.RegistryTypes.KEY_DERIVATION_SCHEMA, this.getKeypath = () => this.keypath, this.getCurve = () => this.curve, this.getAlgo = () => this.algo, this.toDataItem = () => {
          const be = {}, He = this.getKeypath().toDataItem();
          return He.setTag(this.getKeypath().getRegistryType().getTag()), be[A.keyPath] = He, be[A.curve] = this.curve, be[A.algo] = this.algo, new p.DataItem(be);
        };
      }
    }
    n.KeyDerivationSchema = le, le.fromDataItem = (L) => {
      const pe = L.getData(), $ = a.CryptoKeypath.fromDataItem(pe[A.keyPath]), Ee = pe[A.curve], be = pe[A.algo];
      return new le($, Ee, be);
    }, le.fromCBOR = (L) => {
      const pe = (0, p.decodeToDataItem)(L);
      return le.fromDataItem(pe);
    };
  }(DerivationSchema$9)), DerivationSchema$9;
}
var hasRequiredKeyDerivation$9;
function requireKeyDerivation$9() {
  if (hasRequiredKeyDerivation$9) return KeyDerivation$9;
  hasRequiredKeyDerivation$9 = 1, Object.defineProperty(KeyDerivation$9, "__esModule", { value: !0 }), KeyDerivation$9.KeyDerivation = void 0;
  const n = requireRegistryType$9(), c = requireRegistryItem$9(), u = requireLib$a(), p = requireDerivationSchema$9();
  var a;
  (function(b) {
    b[b.schemas = 1] = "schemas";
  })(a || (a = {}));
  class A extends c.RegistryItem {
    constructor(F) {
      super(), this.schemas = F, this.getRegistryType = () => n.RegistryTypes.KEY_DERIVATION_CALL, this.getSchemas = () => this.schemas, this.toDataItem = () => {
        const le = {};
        return le[a.schemas] = this.schemas.map((L) => {
          const pe = L.toDataItem();
          return pe.setTag(L.getRegistryType().getTag()), pe;
        }), new u.DataItem(le);
      };
    }
  }
  return KeyDerivation$9.KeyDerivation = A, A.fromDataItem = (b) => {
    const le = b.getData()[a.schemas].map((L) => p.KeyDerivationSchema.fromDataItem(L));
    return new A(le);
  }, A.fromCBOR = (b) => {
    const F = (0, u.decodeToDataItem)(b);
    return A.fromDataItem(F);
  }, KeyDerivation$9;
}
var hasRequiredQRHardwareCall$9;
function requireQRHardwareCall$9() {
  return hasRequiredQRHardwareCall$9 || (hasRequiredQRHardwareCall$9 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.QRHardwareCall = n.QRHardwareCallType = void 0;
    const c = requireRegistryType$9(), u = requireRegistryItem$9(), p = requireLib$a(), a = requireKeyDerivation$9();
    var A;
    (function(le) {
      le[le.type = 1] = "type", le[le.params = 2] = "params", le[le.origin = 3] = "origin";
    })(A || (A = {}));
    var b;
    (function(le) {
      le[le.KeyDerivation = 0] = "KeyDerivation";
    })(b = n.QRHardwareCallType || (n.QRHardwareCallType = {}));
    class F extends u.RegistryItem {
      constructor(L, pe, $) {
        super(), this.type = L, this.params = pe, this.origin = $, this.getRegistryType = () => c.RegistryTypes.QR_HARDWARE_CALL, this.getType = () => this.type, this.getParams = () => this.params, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const Ee = {};
          Ee[A.type] = this.type;
          const be = this.params.toDataItem();
          return be.setTag(this.params.getRegistryType().getTag()), Ee[A.params] = be, this.origin && (Ee[A.origin] = this.origin), new p.DataItem(Ee);
        };
      }
    }
    n.QRHardwareCall = F, F.fromDataItem = (le) => {
      const L = le.getData(), pe = L[A.type] || b.KeyDerivation;
      let $;
      switch (pe) {
        case b.KeyDerivation:
          $ = a.KeyDerivation.fromDataItem(L[A.params]);
      }
      const Ee = L[A.origin];
      return new F(pe, $, Ee);
    }, F.fromCBOR = (le) => {
      const L = (0, p.decodeToDataItem)(le);
      return F.fromDataItem(L);
    };
  }(QRHardwareCall$9)), QRHardwareCall$9;
}
var types$f = {}, hasRequiredTypes$a;
function requireTypes$a() {
  return hasRequiredTypes$a || (hasRequiredTypes$a = 1, Object.defineProperty(types$f, "__esModule", { value: !0 })), types$f;
}
var hasRequiredDist$9;
function requireDist$9() {
  return hasRequiredDist$9 || (hasRequiredDist$9 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.Buffer = n.extend = n.PathComponent = n.ScriptExpressions = n.MultiKey = n.CryptoPSBT = n.CryptoOutput = n.CryptoECKey = n.CryptoCoinInfoNetwork = n.CryptoCoinInfoType = n.CryptoCoinInfo = n.CryptoKeypath = n.CryptoMultiAccounts = n.CryptoHDKey = n.CryptoAccount = n.Bytes = n.URRegistryDecoder = n.DataItem = void 0;
    const c = require$$0$4;
    requirePatchCBOR$9();
    const u = dist$u;
    Object.defineProperty(n, "Buffer", { enumerable: !0, get: function() {
      return u.Buffer;
    } });
    const p = requireCryptoHDKey$9();
    Object.defineProperty(n, "CryptoHDKey", { enumerable: !0, get: function() {
      return p.CryptoHDKey;
    } });
    const a = requireCryptoKeypath$9();
    Object.defineProperty(n, "CryptoKeypath", { enumerable: !0, get: function() {
      return a.CryptoKeypath;
    } });
    const A = requireCryptoCoinInfo$9();
    Object.defineProperty(n, "CryptoCoinInfo", { enumerable: !0, get: function() {
      return A.CryptoCoinInfo;
    } }), Object.defineProperty(n, "CryptoCoinInfoType", { enumerable: !0, get: function() {
      return A.Type;
    } }), Object.defineProperty(n, "CryptoCoinInfoNetwork", { enumerable: !0, get: function() {
      return A.Network;
    } });
    const b = requireCryptoECKey$9();
    Object.defineProperty(n, "CryptoECKey", { enumerable: !0, get: function() {
      return b.CryptoECKey;
    } });
    const F = requireBytes$a();
    Object.defineProperty(n, "Bytes", { enumerable: !0, get: function() {
      return F.Bytes;
    } });
    const le = requireCryptoOutput$9();
    Object.defineProperty(n, "CryptoOutput", { enumerable: !0, get: function() {
      return le.CryptoOutput;
    } });
    const L = requireCryptoPSBT$9();
    Object.defineProperty(n, "CryptoPSBT", { enumerable: !0, get: function() {
      return L.CryptoPSBT;
    } });
    const pe = requireCryptoAccount$9();
    Object.defineProperty(n, "CryptoAccount", { enumerable: !0, get: function() {
      return pe.CryptoAccount;
    } });
    const $ = requireDecoder$9();
    Object.defineProperty(n, "URRegistryDecoder", { enumerable: !0, get: function() {
      return $.URRegistryDecoder;
    } });
    const Ee = requireMultiKey$9();
    Object.defineProperty(n, "MultiKey", { enumerable: !0, get: function() {
      return Ee.MultiKey;
    } });
    const be = requireScriptExpression$9();
    Object.defineProperty(n, "ScriptExpressions", { enumerable: !0, get: function() {
      return be.ScriptExpressions;
    } });
    const He = requirePathComponent$9();
    Object.defineProperty(n, "PathComponent", { enumerable: !0, get: function() {
      return He.PathComponent;
    } });
    const Pe = requireRegistryItem$9(), nr = requireRegistryType$9(), ir = requireLib$a();
    var or = requireLib$a();
    Object.defineProperty(n, "DataItem", { enumerable: !0, get: function() {
      return or.DataItem;
    } });
    const lr = requireUtils$c(), Ir = requireCryptoMultiAccounts$9();
    Object.defineProperty(n, "CryptoMultiAccounts", { enumerable: !0, get: function() {
      return Ir.CryptoMultiAccounts;
    } });
    const xr = {
      URRegistryDecoder: $.URRegistryDecoder,
      Bytes: F.Bytes,
      CryptoAccount: pe.CryptoAccount,
      CryptoHDKey: p.CryptoHDKey,
      CryptoMultiAccounts: Ir.CryptoMultiAccounts,
      CryptoKeypath: a.CryptoKeypath,
      CryptoCoinInfo: A.CryptoCoinInfo,
      CryptoCoinInfoType: A.Type,
      CryptoCoinInfoNetwork: A.Network,
      CryptoECKey: b.CryptoECKey,
      CryptoOutput: le.CryptoOutput,
      CryptoPSBT: L.CryptoPSBT,
      MultiKey: Ee.MultiKey,
      ScriptExpressions: be.ScriptExpressions,
      PathComponent: He.PathComponent
    }, kr = {
      addReader: ir.addReader,
      addSemanticDecode: ir.addSemanticDecode,
      addSemanticEncode: ir.addSemanticEncode,
      addWriter: ir.addWriter,
      patchTags: lr.patchTags
    }, Ce = {
      RegistryTypes: nr.RegistryTypes,
      RegistryItem: Pe.RegistryItem,
      RegistryType: nr.RegistryType,
      decodeToDataItem: ir.decodeToDataItem,
      encodeDataItem: ir.encodeDataItem,
      cbor: kr
    };
    n.extend = Ce, (0, c.__exportStar)(requireErrors$9(), n), (0, c.__exportStar)(requireDecoder$9(), n), (0, c.__exportStar)(requireLib$a(), n), (0, c.__exportStar)(requireCryptoAccount$9(), n), (0, c.__exportStar)(requireCryptoPSBT$9(), n), (0, c.__exportStar)(requireCryptoHDKey$9(), n), (0, c.__exportStar)(requireCryptoMultiAccounts$9(), n), (0, c.__exportStar)(requireQRHardwareCall$9(), n), (0, c.__exportStar)(requireKeyDerivation$9(), n), (0, c.__exportStar)(requireDerivationSchema$9(), n), (0, c.__exportStar)(requireCryptoOutput$9(), n), (0, c.__exportStar)(requireCryptoCoinInfo$9(), n), (0, c.__exportStar)(requireCryptoECKey$9(), n), (0, c.__exportStar)(requireMultiKey$9(), n), (0, c.__exportStar)(requireCryptoKeypath$9(), n), (0, c.__exportStar)(requirePatchCBOR$9(), n), (0, c.__exportStar)(requirePathComponent$9(), n), (0, c.__exportStar)(requireRegistryItem$9(), n), (0, c.__exportStar)(requireRegistryType$9(), n), (0, c.__exportStar)(requireTypes$a(), n), (0, c.__exportStar)(requireUtils$c(), n), n.default = xr;
  }(dist$n)), dist$n;
}
var commonjsBrowser$2 = {}, v1$9 = {}, rng$a = {}, hasRequiredRng$2;
function requireRng$2() {
  if (hasRequiredRng$2) return rng$a;
  hasRequiredRng$2 = 1, Object.defineProperty(rng$a, "__esModule", {
    value: !0
  }), rng$a.default = u;
  let n;
  const c = new Uint8Array(16);
  function u() {
    if (!n && (n = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !n))
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    return n(c);
  }
  return rng$a;
}
var stringify$9 = {}, validate$a = {}, regex$2 = {}, hasRequiredRegex$2;
function requireRegex$2() {
  if (hasRequiredRegex$2) return regex$2;
  hasRequiredRegex$2 = 1, Object.defineProperty(regex$2, "__esModule", {
    value: !0
  }), regex$2.default = void 0;
  var n = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
  return regex$2.default = n, regex$2;
}
var hasRequiredValidate$2;
function requireValidate$2() {
  if (hasRequiredValidate$2) return validate$a;
  hasRequiredValidate$2 = 1, Object.defineProperty(validate$a, "__esModule", {
    value: !0
  }), validate$a.default = void 0;
  var n = c(requireRegex$2());
  function c(a) {
    return a && a.__esModule ? a : { default: a };
  }
  function u(a) {
    return typeof a == "string" && n.default.test(a);
  }
  var p = u;
  return validate$a.default = p, validate$a;
}
var hasRequiredStringify$2;
function requireStringify$2() {
  if (hasRequiredStringify$2) return stringify$9;
  hasRequiredStringify$2 = 1, Object.defineProperty(stringify$9, "__esModule", {
    value: !0
  }), stringify$9.default = void 0, stringify$9.unsafeStringify = p;
  var n = c(requireValidate$2());
  function c(b) {
    return b && b.__esModule ? b : { default: b };
  }
  const u = [];
  for (let b = 0; b < 256; ++b)
    u.push((b + 256).toString(16).slice(1));
  function p(b, F = 0) {
    return u[b[F + 0]] + u[b[F + 1]] + u[b[F + 2]] + u[b[F + 3]] + "-" + u[b[F + 4]] + u[b[F + 5]] + "-" + u[b[F + 6]] + u[b[F + 7]] + "-" + u[b[F + 8]] + u[b[F + 9]] + "-" + u[b[F + 10]] + u[b[F + 11]] + u[b[F + 12]] + u[b[F + 13]] + u[b[F + 14]] + u[b[F + 15]];
  }
  function a(b, F = 0) {
    const le = p(b, F);
    if (!(0, n.default)(le))
      throw TypeError("Stringified UUID is invalid");
    return le;
  }
  var A = a;
  return stringify$9.default = A, stringify$9;
}
var hasRequiredV1$2;
function requireV1$2() {
  if (hasRequiredV1$2) return v1$9;
  hasRequiredV1$2 = 1, Object.defineProperty(v1$9, "__esModule", {
    value: !0
  }), v1$9.default = void 0;
  var n = u(requireRng$2()), c = requireStringify$2();
  function u(L) {
    return L && L.__esModule ? L : { default: L };
  }
  let p, a, A = 0, b = 0;
  function F(L, pe, $) {
    let Ee = pe && $ || 0;
    const be = pe || new Array(16);
    L = L || {};
    let He = L.node || p, Pe = L.clockseq !== void 0 ? L.clockseq : a;
    if (He == null || Pe == null) {
      const xr = L.random || (L.rng || n.default)();
      He == null && (He = p = [xr[0] | 1, xr[1], xr[2], xr[3], xr[4], xr[5]]), Pe == null && (Pe = a = (xr[6] << 8 | xr[7]) & 16383);
    }
    let nr = L.msecs !== void 0 ? L.msecs : Date.now(), ir = L.nsecs !== void 0 ? L.nsecs : b + 1;
    const or = nr - A + (ir - b) / 1e4;
    if (or < 0 && L.clockseq === void 0 && (Pe = Pe + 1 & 16383), (or < 0 || nr > A) && L.nsecs === void 0 && (ir = 0), ir >= 1e4)
      throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    A = nr, b = ir, a = Pe, nr += 122192928e5;
    const lr = ((nr & 268435455) * 1e4 + ir) % 4294967296;
    be[Ee++] = lr >>> 24 & 255, be[Ee++] = lr >>> 16 & 255, be[Ee++] = lr >>> 8 & 255, be[Ee++] = lr & 255;
    const Ir = nr / 4294967296 * 1e4 & 268435455;
    be[Ee++] = Ir >>> 8 & 255, be[Ee++] = Ir & 255, be[Ee++] = Ir >>> 24 & 15 | 16, be[Ee++] = Ir >>> 16 & 255, be[Ee++] = Pe >>> 8 | 128, be[Ee++] = Pe & 255;
    for (let xr = 0; xr < 6; ++xr)
      be[Ee + xr] = He[xr];
    return pe || (0, c.unsafeStringify)(be);
  }
  var le = F;
  return v1$9.default = le, v1$9;
}
var v3$9 = {}, v35$9 = {}, parse$g = {}, hasRequiredParse$2;
function requireParse$2() {
  if (hasRequiredParse$2) return parse$g;
  hasRequiredParse$2 = 1, Object.defineProperty(parse$g, "__esModule", {
    value: !0
  }), parse$g.default = void 0;
  var n = c(requireValidate$2());
  function c(a) {
    return a && a.__esModule ? a : { default: a };
  }
  function u(a) {
    if (!(0, n.default)(a))
      throw TypeError("Invalid UUID");
    let A;
    const b = new Uint8Array(16);
    return b[0] = (A = parseInt(a.slice(0, 8), 16)) >>> 24, b[1] = A >>> 16 & 255, b[2] = A >>> 8 & 255, b[3] = A & 255, b[4] = (A = parseInt(a.slice(9, 13), 16)) >>> 8, b[5] = A & 255, b[6] = (A = parseInt(a.slice(14, 18), 16)) >>> 8, b[7] = A & 255, b[8] = (A = parseInt(a.slice(19, 23), 16)) >>> 8, b[9] = A & 255, b[10] = (A = parseInt(a.slice(24, 36), 16)) / 1099511627776 & 255, b[11] = A / 4294967296 & 255, b[12] = A >>> 24 & 255, b[13] = A >>> 16 & 255, b[14] = A >>> 8 & 255, b[15] = A & 255, b;
  }
  var p = u;
  return parse$g.default = p, parse$g;
}
var hasRequiredV35$2;
function requireV35$2() {
  if (hasRequiredV35$2) return v35$9;
  hasRequiredV35$2 = 1, Object.defineProperty(v35$9, "__esModule", {
    value: !0
  }), v35$9.URL = v35$9.DNS = void 0, v35$9.default = b;
  var n = requireStringify$2(), c = u(requireParse$2());
  function u(F) {
    return F && F.__esModule ? F : { default: F };
  }
  function p(F) {
    F = unescape(encodeURIComponent(F));
    const le = [];
    for (let L = 0; L < F.length; ++L)
      le.push(F.charCodeAt(L));
    return le;
  }
  const a = "6ba7b810-9dad-11d1-80b4-00c04fd430c8";
  v35$9.DNS = a;
  const A = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
  v35$9.URL = A;
  function b(F, le, L) {
    function pe($, Ee, be, He) {
      var Pe;
      if (typeof $ == "string" && ($ = p($)), typeof Ee == "string" && (Ee = (0, c.default)(Ee)), ((Pe = Ee) === null || Pe === void 0 ? void 0 : Pe.length) !== 16)
        throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
      let nr = new Uint8Array(16 + $.length);
      if (nr.set(Ee), nr.set($, Ee.length), nr = L(nr), nr[6] = nr[6] & 15 | le, nr[8] = nr[8] & 63 | 128, be) {
        He = He || 0;
        for (let ir = 0; ir < 16; ++ir)
          be[He + ir] = nr[ir];
        return be;
      }
      return (0, n.unsafeStringify)(nr);
    }
    try {
      pe.name = F;
    } catch {
    }
    return pe.DNS = a, pe.URL = A, pe;
  }
  return v35$9;
}
var md5$b = {}, hasRequiredMd5$4;
function requireMd5$4() {
  if (hasRequiredMd5$4) return md5$b;
  hasRequiredMd5$4 = 1, Object.defineProperty(md5$b, "__esModule", {
    value: !0
  }), md5$b.default = void 0;
  function n(be) {
    if (typeof be == "string") {
      const He = unescape(encodeURIComponent(be));
      be = new Uint8Array(He.length);
      for (let Pe = 0; Pe < He.length; ++Pe)
        be[Pe] = He.charCodeAt(Pe);
    }
    return c(p(a(be), be.length * 8));
  }
  function c(be) {
    const He = [], Pe = be.length * 32, nr = "0123456789abcdef";
    for (let ir = 0; ir < Pe; ir += 8) {
      const or = be[ir >> 5] >>> ir % 32 & 255, lr = parseInt(nr.charAt(or >>> 4 & 15) + nr.charAt(or & 15), 16);
      He.push(lr);
    }
    return He;
  }
  function u(be) {
    return (be + 64 >>> 9 << 4) + 14 + 1;
  }
  function p(be, He) {
    be[He >> 5] |= 128 << He % 32, be[u(He) - 1] = He;
    let Pe = 1732584193, nr = -271733879, ir = -1732584194, or = 271733878;
    for (let lr = 0; lr < be.length; lr += 16) {
      const Ir = Pe, xr = nr, kr = ir, Ce = or;
      Pe = le(Pe, nr, ir, or, be[lr], 7, -680876936), or = le(or, Pe, nr, ir, be[lr + 1], 12, -389564586), ir = le(ir, or, Pe, nr, be[lr + 2], 17, 606105819), nr = le(nr, ir, or, Pe, be[lr + 3], 22, -1044525330), Pe = le(Pe, nr, ir, or, be[lr + 4], 7, -176418897), or = le(or, Pe, nr, ir, be[lr + 5], 12, 1200080426), ir = le(ir, or, Pe, nr, be[lr + 6], 17, -1473231341), nr = le(nr, ir, or, Pe, be[lr + 7], 22, -45705983), Pe = le(Pe, nr, ir, or, be[lr + 8], 7, 1770035416), or = le(or, Pe, nr, ir, be[lr + 9], 12, -1958414417), ir = le(ir, or, Pe, nr, be[lr + 10], 17, -42063), nr = le(nr, ir, or, Pe, be[lr + 11], 22, -1990404162), Pe = le(Pe, nr, ir, or, be[lr + 12], 7, 1804603682), or = le(or, Pe, nr, ir, be[lr + 13], 12, -40341101), ir = le(ir, or, Pe, nr, be[lr + 14], 17, -1502002290), nr = le(nr, ir, or, Pe, be[lr + 15], 22, 1236535329), Pe = L(Pe, nr, ir, or, be[lr + 1], 5, -165796510), or = L(or, Pe, nr, ir, be[lr + 6], 9, -1069501632), ir = L(ir, or, Pe, nr, be[lr + 11], 14, 643717713), nr = L(nr, ir, or, Pe, be[lr], 20, -373897302), Pe = L(Pe, nr, ir, or, be[lr + 5], 5, -701558691), or = L(or, Pe, nr, ir, be[lr + 10], 9, 38016083), ir = L(ir, or, Pe, nr, be[lr + 15], 14, -660478335), nr = L(nr, ir, or, Pe, be[lr + 4], 20, -405537848), Pe = L(Pe, nr, ir, or, be[lr + 9], 5, 568446438), or = L(or, Pe, nr, ir, be[lr + 14], 9, -1019803690), ir = L(ir, or, Pe, nr, be[lr + 3], 14, -187363961), nr = L(nr, ir, or, Pe, be[lr + 8], 20, 1163531501), Pe = L(Pe, nr, ir, or, be[lr + 13], 5, -1444681467), or = L(or, Pe, nr, ir, be[lr + 2], 9, -51403784), ir = L(ir, or, Pe, nr, be[lr + 7], 14, 1735328473), nr = L(nr, ir, or, Pe, be[lr + 12], 20, -1926607734), Pe = pe(Pe, nr, ir, or, be[lr + 5], 4, -378558), or = pe(or, Pe, nr, ir, be[lr + 8], 11, -2022574463), ir = pe(ir, or, Pe, nr, be[lr + 11], 16, 1839030562), nr = pe(nr, ir, or, Pe, be[lr + 14], 23, -35309556), Pe = pe(Pe, nr, ir, or, be[lr + 1], 4, -1530992060), or = pe(or, Pe, nr, ir, be[lr + 4], 11, 1272893353), ir = pe(ir, or, Pe, nr, be[lr + 7], 16, -155497632), nr = pe(nr, ir, or, Pe, be[lr + 10], 23, -1094730640), Pe = pe(Pe, nr, ir, or, be[lr + 13], 4, 681279174), or = pe(or, Pe, nr, ir, be[lr], 11, -358537222), ir = pe(ir, or, Pe, nr, be[lr + 3], 16, -722521979), nr = pe(nr, ir, or, Pe, be[lr + 6], 23, 76029189), Pe = pe(Pe, nr, ir, or, be[lr + 9], 4, -640364487), or = pe(or, Pe, nr, ir, be[lr + 12], 11, -421815835), ir = pe(ir, or, Pe, nr, be[lr + 15], 16, 530742520), nr = pe(nr, ir, or, Pe, be[lr + 2], 23, -995338651), Pe = $(Pe, nr, ir, or, be[lr], 6, -198630844), or = $(or, Pe, nr, ir, be[lr + 7], 10, 1126891415), ir = $(ir, or, Pe, nr, be[lr + 14], 15, -1416354905), nr = $(nr, ir, or, Pe, be[lr + 5], 21, -57434055), Pe = $(Pe, nr, ir, or, be[lr + 12], 6, 1700485571), or = $(or, Pe, nr, ir, be[lr + 3], 10, -1894986606), ir = $(ir, or, Pe, nr, be[lr + 10], 15, -1051523), nr = $(nr, ir, or, Pe, be[lr + 1], 21, -2054922799), Pe = $(Pe, nr, ir, or, be[lr + 8], 6, 1873313359), or = $(or, Pe, nr, ir, be[lr + 15], 10, -30611744), ir = $(ir, or, Pe, nr, be[lr + 6], 15, -1560198380), nr = $(nr, ir, or, Pe, be[lr + 13], 21, 1309151649), Pe = $(Pe, nr, ir, or, be[lr + 4], 6, -145523070), or = $(or, Pe, nr, ir, be[lr + 11], 10, -1120210379), ir = $(ir, or, Pe, nr, be[lr + 2], 15, 718787259), nr = $(nr, ir, or, Pe, be[lr + 9], 21, -343485551), Pe = A(Pe, Ir), nr = A(nr, xr), ir = A(ir, kr), or = A(or, Ce);
    }
    return [Pe, nr, ir, or];
  }
  function a(be) {
    if (be.length === 0)
      return [];
    const He = be.length * 8, Pe = new Uint32Array(u(He));
    for (let nr = 0; nr < He; nr += 8)
      Pe[nr >> 5] |= (be[nr / 8] & 255) << nr % 32;
    return Pe;
  }
  function A(be, He) {
    const Pe = (be & 65535) + (He & 65535);
    return (be >> 16) + (He >> 16) + (Pe >> 16) << 16 | Pe & 65535;
  }
  function b(be, He) {
    return be << He | be >>> 32 - He;
  }
  function F(be, He, Pe, nr, ir, or) {
    return A(b(A(A(He, be), A(nr, or)), ir), Pe);
  }
  function le(be, He, Pe, nr, ir, or, lr) {
    return F(He & Pe | ~He & nr, be, He, ir, or, lr);
  }
  function L(be, He, Pe, nr, ir, or, lr) {
    return F(He & nr | Pe & ~nr, be, He, ir, or, lr);
  }
  function pe(be, He, Pe, nr, ir, or, lr) {
    return F(He ^ Pe ^ nr, be, He, ir, or, lr);
  }
  function $(be, He, Pe, nr, ir, or, lr) {
    return F(Pe ^ (He | ~nr), be, He, ir, or, lr);
  }
  var Ee = n;
  return md5$b.default = Ee, md5$b;
}
var hasRequiredV3$2;
function requireV3$2() {
  if (hasRequiredV3$2) return v3$9;
  hasRequiredV3$2 = 1, Object.defineProperty(v3$9, "__esModule", {
    value: !0
  }), v3$9.default = void 0;
  var n = u(requireV35$2()), c = u(requireMd5$4());
  function u(A) {
    return A && A.__esModule ? A : { default: A };
  }
  var a = (0, n.default)("v3", 48, c.default);
  return v3$9.default = a, v3$9;
}
var v4$a = {}, native$3 = {}, hasRequiredNative$2;
function requireNative$2() {
  if (hasRequiredNative$2) return native$3;
  hasRequiredNative$2 = 1, Object.defineProperty(native$3, "__esModule", {
    value: !0
  }), native$3.default = void 0;
  var c = {
    randomUUID: typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto)
  };
  return native$3.default = c, native$3;
}
var hasRequiredV4$2;
function requireV4$2() {
  if (hasRequiredV4$2) return v4$a;
  hasRequiredV4$2 = 1, Object.defineProperty(v4$a, "__esModule", {
    value: !0
  }), v4$a.default = void 0;
  var n = p(requireNative$2()), c = p(requireRng$2()), u = requireStringify$2();
  function p(b) {
    return b && b.__esModule ? b : { default: b };
  }
  function a(b, F, le) {
    if (n.default.randomUUID && !F && !b)
      return n.default.randomUUID();
    b = b || {};
    const L = b.random || (b.rng || c.default)();
    if (L[6] = L[6] & 15 | 64, L[8] = L[8] & 63 | 128, F) {
      le = le || 0;
      for (let pe = 0; pe < 16; ++pe)
        F[le + pe] = L[pe];
      return F;
    }
    return (0, u.unsafeStringify)(L);
  }
  var A = a;
  return v4$a.default = A, v4$a;
}
var v5$9 = {}, sha1$9 = {}, hasRequiredSha1$2;
function requireSha1$2() {
  if (hasRequiredSha1$2) return sha1$9;
  hasRequiredSha1$2 = 1, Object.defineProperty(sha1$9, "__esModule", {
    value: !0
  }), sha1$9.default = void 0;
  function n(a, A, b, F) {
    switch (a) {
      case 0:
        return A & b ^ ~A & F;
      case 1:
        return A ^ b ^ F;
      case 2:
        return A & b ^ A & F ^ b & F;
      case 3:
        return A ^ b ^ F;
    }
  }
  function c(a, A) {
    return a << A | a >>> 32 - A;
  }
  function u(a) {
    const A = [1518500249, 1859775393, 2400959708, 3395469782], b = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
    if (typeof a == "string") {
      const pe = unescape(encodeURIComponent(a));
      a = [];
      for (let $ = 0; $ < pe.length; ++$)
        a.push(pe.charCodeAt($));
    } else Array.isArray(a) || (a = Array.prototype.slice.call(a));
    a.push(128);
    const F = a.length / 4 + 2, le = Math.ceil(F / 16), L = new Array(le);
    for (let pe = 0; pe < le; ++pe) {
      const $ = new Uint32Array(16);
      for (let Ee = 0; Ee < 16; ++Ee)
        $[Ee] = a[pe * 64 + Ee * 4] << 24 | a[pe * 64 + Ee * 4 + 1] << 16 | a[pe * 64 + Ee * 4 + 2] << 8 | a[pe * 64 + Ee * 4 + 3];
      L[pe] = $;
    }
    L[le - 1][14] = (a.length - 1) * 8 / Math.pow(2, 32), L[le - 1][14] = Math.floor(L[le - 1][14]), L[le - 1][15] = (a.length - 1) * 8 & 4294967295;
    for (let pe = 0; pe < le; ++pe) {
      const $ = new Uint32Array(80);
      for (let ir = 0; ir < 16; ++ir)
        $[ir] = L[pe][ir];
      for (let ir = 16; ir < 80; ++ir)
        $[ir] = c($[ir - 3] ^ $[ir - 8] ^ $[ir - 14] ^ $[ir - 16], 1);
      let Ee = b[0], be = b[1], He = b[2], Pe = b[3], nr = b[4];
      for (let ir = 0; ir < 80; ++ir) {
        const or = Math.floor(ir / 20), lr = c(Ee, 5) + n(or, be, He, Pe) + nr + A[or] + $[ir] >>> 0;
        nr = Pe, Pe = He, He = c(be, 30) >>> 0, be = Ee, Ee = lr;
      }
      b[0] = b[0] + Ee >>> 0, b[1] = b[1] + be >>> 0, b[2] = b[2] + He >>> 0, b[3] = b[3] + Pe >>> 0, b[4] = b[4] + nr >>> 0;
    }
    return [b[0] >> 24 & 255, b[0] >> 16 & 255, b[0] >> 8 & 255, b[0] & 255, b[1] >> 24 & 255, b[1] >> 16 & 255, b[1] >> 8 & 255, b[1] & 255, b[2] >> 24 & 255, b[2] >> 16 & 255, b[2] >> 8 & 255, b[2] & 255, b[3] >> 24 & 255, b[3] >> 16 & 255, b[3] >> 8 & 255, b[3] & 255, b[4] >> 24 & 255, b[4] >> 16 & 255, b[4] >> 8 & 255, b[4] & 255];
  }
  var p = u;
  return sha1$9.default = p, sha1$9;
}
var hasRequiredV5$2;
function requireV5$2() {
  if (hasRequiredV5$2) return v5$9;
  hasRequiredV5$2 = 1, Object.defineProperty(v5$9, "__esModule", {
    value: !0
  }), v5$9.default = void 0;
  var n = u(requireV35$2()), c = u(requireSha1$2());
  function u(A) {
    return A && A.__esModule ? A : { default: A };
  }
  var a = (0, n.default)("v5", 80, c.default);
  return v5$9.default = a, v5$9;
}
var nil$9 = {}, hasRequiredNil$2;
function requireNil$2() {
  if (hasRequiredNil$2) return nil$9;
  hasRequiredNil$2 = 1, Object.defineProperty(nil$9, "__esModule", {
    value: !0
  }), nil$9.default = void 0;
  var n = "00000000-0000-0000-0000-000000000000";
  return nil$9.default = n, nil$9;
}
var version$b = {}, hasRequiredVersion$2;
function requireVersion$2() {
  if (hasRequiredVersion$2) return version$b;
  hasRequiredVersion$2 = 1, Object.defineProperty(version$b, "__esModule", {
    value: !0
  }), version$b.default = void 0;
  var n = c(requireValidate$2());
  function c(a) {
    return a && a.__esModule ? a : { default: a };
  }
  function u(a) {
    if (!(0, n.default)(a))
      throw TypeError("Invalid UUID");
    return parseInt(a.slice(14, 15), 16);
  }
  var p = u;
  return version$b.default = p, version$b;
}
var hasRequiredCommonjsBrowser$2;
function requireCommonjsBrowser$2() {
  return hasRequiredCommonjsBrowser$2 || (hasRequiredCommonjsBrowser$2 = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "NIL", {
      enumerable: !0,
      get: function() {
        return A.default;
      }
    }), Object.defineProperty(n, "parse", {
      enumerable: !0,
      get: function() {
        return L.default;
      }
    }), Object.defineProperty(n, "stringify", {
      enumerable: !0,
      get: function() {
        return le.default;
      }
    }), Object.defineProperty(n, "v1", {
      enumerable: !0,
      get: function() {
        return c.default;
      }
    }), Object.defineProperty(n, "v3", {
      enumerable: !0,
      get: function() {
        return u.default;
      }
    }), Object.defineProperty(n, "v4", {
      enumerable: !0,
      get: function() {
        return p.default;
      }
    }), Object.defineProperty(n, "v5", {
      enumerable: !0,
      get: function() {
        return a.default;
      }
    }), Object.defineProperty(n, "validate", {
      enumerable: !0,
      get: function() {
        return F.default;
      }
    }), Object.defineProperty(n, "version", {
      enumerable: !0,
      get: function() {
        return b.default;
      }
    });
    var c = pe(requireV1$2()), u = pe(requireV3$2()), p = pe(requireV4$2()), a = pe(requireV5$2()), A = pe(requireNil$2()), b = pe(requireVersion$2()), F = pe(requireValidate$2()), le = pe(requireStringify$2()), L = pe(requireParse$2());
    function pe($) {
      return $ && $.__esModule ? $ : { default: $ };
    }
  }(commonjsBrowser$2)), commonjsBrowser$2;
}
var hasRequiredBcUrRegistryEvm_cjs_production_min;
function requireBcUrRegistryEvm_cjs_production_min() {
  return hasRequiredBcUrRegistryEvm_cjs_production_min || (hasRequiredBcUrRegistryEvm_cjs_production_min = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 });
    var c = requireDist$9(), u = requireCommonjsBrowser$2();
    const p = { EVM_SIGN_REQUEST: new c.RegistryType("evm-sign-request", 4101), EVM_SIGNATURE: new c.RegistryType("evm-signature", 4102) }, { decodeToDataItem: a, RegistryTypes: A } = c.extend;
    var b, F;
    (b = n.SignDataType || (n.SignDataType = {}))[b.arbitrary = 1] = "arbitrary", b[b.cosmosAmino = 2] = "cosmosAmino", b[b.cosmosDirect = 3] = "cosmosDirect", function(be) {
      be[be.requestId = 1] = "requestId", be[be.signData = 2] = "signData", be[be.dataType = 3] = "dataType", be[be.customChainIdentifier = 4] = "customChainIdentifier", be[be.derivationPath = 5] = "derivationPath", be[be.address = 6] = "address", be[be.origin = 7] = "origin";
    }(F || (F = {}));
    class le extends c.RegistryItem {
      constructor(He) {
        super(), this.getRegistryType = () => p.EVM_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDataype = () => this.dataType, this.getCustomChainIdentifier = () => this.customChainIdentifier, this.getDerivationPath = () => this.derivationPath.getPath(), this.getAddress = () => this.address, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const Pe = {};
          Pe[F.requestId] = new c.DataItem(this.requestId, A.UUID.getTag()), Pe[F.signData] = this.signData, Pe[F.dataType] = this.dataType, Pe[F.customChainIdentifier] = this.customChainIdentifier;
          const nr = this.derivationPath.toDataItem();
          return nr.setTag(this.derivationPath.getRegistryType().getTag()), Pe[F.derivationPath] = nr, this.address && (Pe[F.address] = this.address), this.origin && (Pe[F.origin] = this.origin), new c.DataItem(Pe);
        }, this.requestId = He.requestId, this.signData = He.signData, this.dataType = He.dataType, this.customChainIdentifier = He.customChainIdentifier, this.derivationPath = He.derivationPath, this.address = He.address, this.origin = He.origin;
      }
      static parsePath(He, Pe) {
        const nr = He.replace(/[m|M]\//, "").split("/").map((ir) => {
          const or = parseInt(ir.replace("'", ""));
          let lr = !1;
          return ir.endsWith("'") && (lr = !0), new c.PathComponent({ index: or, hardened: lr });
        });
        return new c.CryptoKeypath(nr, Buffer$f.from(Pe, "hex"));
      }
      static constructEvmRequest(He, Pe, nr, ir, or, lr, Ir, xr) {
        return new le({ requestId: Buffer$f.from(u.parse(He)), signData: nr, dataType: ir || n.SignDataType.arbitrary, customChainIdentifier: or, derivationPath: le.parsePath(lr, Pe), address: Ir, origin: xr });
      }
    }
    le.fromDataItem = (be) => {
      const He = be.getData(), Pe = He[F.requestId] ? He[F.requestId].getData() : void 0;
      return new le({ requestId: Pe, signData: He[F.signData], dataType: He[F.dataType], customChainIdentifier: He[F.customChainIdentifier], derivationPath: c.CryptoKeypath.fromDataItem(He[F.derivationPath]), address: He[F.address], origin: He[F.origin] });
    }, le.fromCBOR = (be) => {
      const He = a(be);
      return le.fromDataItem(He);
    };
    const { RegistryTypes: L, decodeToDataItem: pe } = c.extend;
    var $;
    (function(be) {
      be[be.requestId = 1] = "requestId", be[be.signature = 2] = "signature";
    })($ || ($ = {}));
    class Ee extends c.RegistryItem {
      constructor(He, Pe) {
        super(), this.getRegistryType = () => p.EVM_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.toDataItem = () => {
          const nr = {};
          return nr[$.requestId] = new c.DataItem(this.requestId, L.UUID.getTag()), nr[$.signature] = this.signature, new c.DataItem(nr);
        }, this.signature = He, this.requestId = Pe;
      }
    }
    Ee.fromDataItem = (be) => {
      const He = be.getData(), Pe = He[$.signature], nr = He[$.requestId].getData();
      return new Ee(Pe, nr);
    }, Ee.fromCBOR = (be) => {
      const He = pe(be);
      return Ee.fromDataItem(He);
    }, c.patchTags(Object.values(p).filter((be) => !!be.getTag()).map((be) => be.getTag())), Object.keys(c).forEach(function(be) {
      be !== "default" && Object.defineProperty(n, be, { enumerable: !0, get: function() {
        return c[be];
      } });
    }), n.EvmSignRequest = le, n.EvmSignature = Ee;
  }(bcUrRegistryEvm_cjs_production_min)), bcUrRegistryEvm_cjs_production_min;
}
var bcUrRegistryEvm_cjs_development = {}, hasRequiredBcUrRegistryEvm_cjs_development;
function requireBcUrRegistryEvm_cjs_development() {
  return hasRequiredBcUrRegistryEvm_cjs_development || (hasRequiredBcUrRegistryEvm_cjs_development = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 });
    var c = requireDist$9(), u = requireCommonjsBrowser$2();
    const p = {
      EVM_SIGN_REQUEST: /* @__PURE__ */ new c.RegistryType("evm-sign-request", 4101),
      EVM_SIGNATURE: /* @__PURE__ */ new c.RegistryType("evm-signature", 4102)
    }, {
      decodeToDataItem: a,
      RegistryTypes: A
    } = c.extend;
    (function(Ee) {
      Ee[Ee.arbitrary = 1] = "arbitrary", Ee[Ee.cosmosAmino = 2] = "cosmosAmino", Ee[Ee.cosmosDirect = 3] = "cosmosDirect";
    })(n.SignDataType || (n.SignDataType = {}));
    var b;
    (function(Ee) {
      Ee[Ee.requestId = 1] = "requestId", Ee[Ee.signData = 2] = "signData", Ee[Ee.dataType = 3] = "dataType", Ee[Ee.customChainIdentifier = 4] = "customChainIdentifier", Ee[Ee.derivationPath = 5] = "derivationPath", Ee[Ee.address = 6] = "address", Ee[Ee.origin = 7] = "origin";
    })(b || (b = {}));
    class F extends c.RegistryItem {
      constructor(be) {
        super(), this.getRegistryType = () => p.EVM_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDataype = () => this.dataType, this.getCustomChainIdentifier = () => this.customChainIdentifier, this.getDerivationPath = () => this.derivationPath.getPath(), this.getAddress = () => this.address, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const He = {};
          He[b.requestId] = new c.DataItem(this.requestId, A.UUID.getTag()), He[b.signData] = this.signData, He[b.dataType] = this.dataType, He[b.customChainIdentifier] = this.customChainIdentifier;
          const Pe = this.derivationPath.toDataItem();
          return Pe.setTag(this.derivationPath.getRegistryType().getTag()), He[b.derivationPath] = Pe, this.address && (He[b.address] = this.address), this.origin && (He[b.origin] = this.origin), new c.DataItem(He);
        }, this.requestId = be.requestId, this.signData = be.signData, this.dataType = be.dataType, this.customChainIdentifier = be.customChainIdentifier, this.derivationPath = be.derivationPath, this.address = be.address, this.origin = be.origin;
      }
      static parsePath(be, He) {
        const nr = be.replace(/[m|M]\//, "").split("/").map((ir) => {
          const or = parseInt(ir.replace("'", ""));
          let lr = !1;
          return ir.endsWith("'") && (lr = !0), new c.PathComponent({
            index: or,
            hardened: lr
          });
        });
        return new c.CryptoKeypath(nr, Buffer$f.from(He, "hex"));
      }
      static constructEvmRequest(be, He, Pe, nr, ir, or, lr, Ir) {
        return new F({
          requestId: Buffer$f.from(u.parse(be)),
          signData: Pe,
          dataType: nr || n.SignDataType.arbitrary,
          customChainIdentifier: ir,
          derivationPath: F.parsePath(or, He),
          address: lr,
          origin: Ir
        });
      }
    }
    F.fromDataItem = (Ee) => {
      const be = Ee.getData(), He = be[b.requestId] ? be[b.requestId].getData() : void 0;
      return new F({
        requestId: He,
        signData: be[b.signData],
        dataType: be[b.dataType],
        customChainIdentifier: be[b.customChainIdentifier],
        derivationPath: c.CryptoKeypath.fromDataItem(be[b.derivationPath]),
        address: be[b.address],
        origin: be[b.origin]
      });
    }, F.fromCBOR = (Ee) => {
      const be = a(Ee);
      return F.fromDataItem(be);
    };
    const {
      RegistryTypes: le,
      decodeToDataItem: L
    } = c.extend;
    var pe;
    (function(Ee) {
      Ee[Ee.requestId = 1] = "requestId", Ee[Ee.signature = 2] = "signature";
    })(pe || (pe = {}));
    class $ extends c.RegistryItem {
      constructor(be, He) {
        super(), this.getRegistryType = () => p.EVM_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.toDataItem = () => {
          const Pe = {};
          return Pe[pe.requestId] = new c.DataItem(this.requestId, le.UUID.getTag()), Pe[pe.signature] = this.signature, new c.DataItem(Pe);
        }, this.signature = be, this.requestId = He;
      }
    }
    $.fromDataItem = (Ee) => {
      const be = Ee.getData(), He = be[pe.signature], Pe = be[pe.requestId].getData();
      return new $(He, Pe);
    }, $.fromCBOR = (Ee) => {
      const be = L(Ee);
      return $.fromDataItem(be);
    }, c.patchTags(Object.values(p).filter((Ee) => !!Ee.getTag()).map((Ee) => Ee.getTag())), Object.keys(c).forEach(function(Ee) {
      Ee !== "default" && Object.defineProperty(n, Ee, {
        enumerable: !0,
        get: function() {
          return c[Ee];
        }
      });
    }), n.EvmSignRequest = F, n.EvmSignature = $;
  }(bcUrRegistryEvm_cjs_development)), bcUrRegistryEvm_cjs_development;
}
process$1.env.NODE_ENV === "production" ? dist$o.exports = requireBcUrRegistryEvm_cjs_production_min() : dist$o.exports = requireBcUrRegistryEvm_cjs_development();
var distExports$a = dist$o.exports;
Object.defineProperty(evm, "__esModule", { value: !0 });
evm.KeystoneEvmSDK = void 0;
const utils_1$l = utils$K, ur_1$a = ur, bc_ur_registry_evm_1 = distExports$a;
class KeystoneEvmSDK {
  constructor(c) {
    this.config = c;
  }
  parseSignature(c) {
    if (c.type !== ur_1$a.URType.EvmSignature)
      throw new Error("type not match");
    const u = bc_ur_registry_evm_1.EvmSignature.fromCBOR(c.cbor);
    return {
      requestId: (0, utils_1$l.uuidStringify)(u.getRequestId()),
      signature: (0, utils_1$l.toHex)(u.getSignature())
    };
  }
  generateSignRequest({ requestId: c, signData: u, dataType: p, customChainIdentifier: a, account: A, origin: b }) {
    var F;
    const le = new bc_ur_registry_evm_1.CryptoKeypath((0, utils_1$l.parsePath)(A.path).map((L) => new bc_ur_registry_evm_1.PathComponent(L)), (0, utils_1$l.toBuffer)(A.xfp));
    return new bc_ur_registry_evm_1.EvmSignRequest({
      signData: (0, utils_1$l.toBuffer)(u),
      dataType: p,
      customChainIdentifier: a,
      derivationPath: le,
      requestId: (0, utils_1$l.uuidParse)(c),
      address: A.address !== void 0 ? (0, utils_1$l.toBuffer)(A.address.substring(A.address.startsWith("0x") ? 2 : 0)) : void 0,
      origin: b ?? ((F = this.config) === null || F === void 0 ? void 0 : F.origin)
    }).toUR();
  }
}
KeystoneEvmSDK.DataType = bc_ur_registry_evm_1.SignDataType;
evm.KeystoneEvmSDK = KeystoneEvmSDK;
var ethereum$2 = {}, dist$m = { exports: {} }, bcUrRegistryEth_cjs_production_min = {}, dist$l = {}, patchCBOR$8 = {}, utils$E = {}, lib$b = {}, cborSync$8 = { exports: {} }, DataItem$8 = {}, hasRequiredDataItem$8;
function requireDataItem$8() {
  if (hasRequiredDataItem$8) return DataItem$8;
  hasRequiredDataItem$8 = 1, Object.defineProperty(DataItem$8, "__esModule", { value: !0 }), DataItem$8.DataItem = void 0;
  class n {
    constructor(u, p) {
      this.setTag = (a) => {
        this.tag = a;
      }, this.clearTag = () => {
        this.tag = void 0;
      }, this.getTag = () => this.tag, this.getData = () => this.data, this.data = u, this.tag = p;
    }
  }
  return DataItem$8.DataItem = n, DataItem$8;
}
var hasRequiredCborSync$8;
function requireCborSync$8() {
  return hasRequiredCborSync$8 || (hasRequiredCborSync$8 = 1, function(n) {
    (function(c, u) {
      n.exports ? n.exports = u() : c.CBOR = u();
    })(commonjsGlobal, function() {
      const { DataItem: c } = requireDataItem$8();
      var u = function() {
        function p(Ce) {
          this.$hex = Ce;
        }
        p.prototype = {
          length: function() {
            return this.$hex.length / 2;
          },
          toString: function(Ce) {
            if (!Ce || Ce === "hex" || Ce === 16)
              return this.$hex;
            if (Ce === "utf-8") {
              for (var tr = "", Fe = 0; Fe < this.$hex.length; Fe += 2)
                tr += "%" + this.$hex.substring(Fe, Fe + 2);
              return decodeURIComponent(tr);
            }
            if (Ce === "latin") {
              for (var tr = [], Fe = 0; Fe < this.$hex.length; Fe += 2)
                tr.push(parseInt(this.$hex.substring(Fe, Fe + 2), 16));
              return String.fromCharCode.apply(String, tr);
            }
            throw new Error("Unrecognised format: " + Ce);
          }
        }, p.fromLatinString = function(Ce) {
          for (var tr = "", Fe = 0; Fe < Ce.length; Fe++) {
            var Sr = Ce.charCodeAt(Fe).toString(16);
            Sr.length === 1 && (Sr = "0" + Sr), tr += Sr;
          }
          return new p(tr);
        }, p.fromUtf8String = function(Ce) {
          for (var tr = encodeURIComponent(Ce), Fe = "", Sr = 0; Sr < tr.length; Sr++)
            if (tr.charAt(Sr) === "%")
              Fe += tr.substring(Sr + 1, Sr + 3), Sr += 2;
            else {
              var er = tr.charCodeAt(Sr).toString(16);
              er.length < 2 && (er = "0" + er), Fe += er;
            }
          return new p(Fe);
        };
        var a = [], A = {}, b = function(Ce) {
          return function() {
            throw new Error(Ce + " not implemented");
          };
        };
        function F() {
        }
        F.prototype = {
          peekByte: b("peekByte"),
          readByte: b("readByte"),
          readChunk: b("readChunk"),
          readFloat16: function() {
            var Ce = this.readUint16(), tr = (Ce & 32767) >> 10, Fe = Ce & 1023, Sr = Ce & 32768;
            if (tr === 31)
              return Fe === 0 ? Sr ? -1 / 0 : 1 / 0 : NaN;
            var er = tr ? Math.pow(2, tr - 25) * (1024 + Fe) : Math.pow(2, -24) * Fe;
            return Sr ? -er : er;
          },
          readFloat32: function() {
            var Ce = this.readUint32(), tr = (Ce & 2147483647) >> 23, Fe = Ce & 8388607, Sr = Ce & 2147483648;
            if (tr === 255)
              return Fe === 0 ? Sr ? -1 / 0 : 1 / 0 : NaN;
            var er = tr ? Math.pow(2, tr - 23 - 127) * (8388608 + Fe) : Math.pow(2, -149) * Fe;
            return Sr ? -er : er;
          },
          readFloat64: function() {
            var Ce = this.readUint32(), tr = this.readUint32(), Fe = Ce >> 20 & 2047, Sr = (Ce & 1048575) * 4294967296 + tr, er = Ce & 2147483648;
            if (Fe === 2047)
              return Sr === 0 ? er ? -1 / 0 : 1 / 0 : NaN;
            var Ie = Fe ? Math.pow(2, Fe - 52 - 1023) * (4503599627370496 + Sr) : Math.pow(2, -1074) * Sr;
            return er ? -Ie : Ie;
          },
          readUint16: function() {
            return this.readByte() * 256 + this.readByte();
          },
          readUint32: function() {
            return this.readUint16() * 65536 + this.readUint16();
          },
          readUint64: function() {
            return this.readUint32() * 4294967296 + this.readUint32();
          }
        };
        function le() {
        }
        le.prototype = {
          writeByte: b("writeByte"),
          result: b("result"),
          writeFloat16: b("writeFloat16"),
          writeFloat32: b("writeFloat32"),
          writeFloat64: b("writeFloat64"),
          writeUint16: function(Ce) {
            this.writeByte(Ce >> 8 & 255), this.writeByte(Ce & 255);
          },
          writeUint32: function(Ce) {
            this.writeUint16(Ce >> 16 & 65535), this.writeUint16(Ce & 65535);
          },
          writeUint64: function(Ce) {
            if (Ce >= 9007199254740992 || Ce <= -9007199254740992)
              throw new Error("Cannot encode Uint64 of: " + Ce + " magnitude to big (floating point errors)");
            this.writeUint32(Math.floor(Ce / 4294967296)), this.writeUint32(Ce % 4294967296);
          },
          writeString: b("writeString"),
          canWriteBinary: function(Ce) {
            return !1;
          },
          writeBinary: b("writeChunk")
        };
        function L(Ce) {
          var tr = Ce.readByte(), Fe = tr >> 5, Sr = tr & 31;
          return { type: Fe, value: Sr };
        }
        function pe(Ce, tr) {
          var Fe = Ce.value;
          if (Fe < 24)
            return Fe;
          if (Fe == 24)
            return tr.readByte();
          if (Fe == 25)
            return tr.readUint16();
          if (Fe == 26)
            return tr.readUint32();
          if (Fe == 27)
            return tr.readUint64();
          if (Fe == 31)
            return null;
          b("Additional info: " + Fe)();
        }
        function $(Ce, tr, Fe) {
          Fe.writeByte(Ce << 5 | tr);
        }
        function Ee(Ce, tr, Fe) {
          var Sr = Ce << 5;
          tr < 24 ? Fe.writeByte(Sr | tr) : tr < 256 ? (Fe.writeByte(Sr | 24), Fe.writeByte(tr)) : tr < 65536 ? (Fe.writeByte(Sr | 25), Fe.writeUint16(tr)) : tr < 4294967296 ? (Fe.writeByte(Sr | 26), Fe.writeUint32(tr)) : (Fe.writeByte(Sr | 27), Fe.writeUint64(tr));
        }
        var be = new Error();
        function He(Ce) {
          var tr = L(Ce);
          switch (tr.type) {
            case 0:
              return pe(tr, Ce);
            case 1:
              return -1 - pe(tr, Ce);
            case 2:
              return Ce.readChunk(pe(tr, Ce));
            case 3:
              var Fe = Ce.readChunk(pe(tr, Ce));
              return Fe.toString("utf-8");
            case 4:
            case 5:
              var Sr = pe(tr, Ce), yr = [];
              if (Sr !== null) {
                tr.type === 5 && (Sr *= 2);
                for (var er = 0; er < Sr; er++)
                  yr[er] = He(Ce);
              } else
                for (var Ie; (Ie = He(Ce)) !== be; )
                  yr.push(Ie);
              if (tr.type === 5) {
                for (var xe = {}, er = 0; er < yr.length; er += 2)
                  xe[yr[er]] = yr[er + 1];
                return xe;
              } else
                return yr;
            case 6:
              var rr = pe(tr, Ce), ar = A[rr], yr = He(Ce);
              return ar ? ar(yr) : yr;
            case 7:
              if (tr.value === 25)
                return Ce.readFloat16();
              if (tr.value === 26)
                return Ce.readFloat32();
              if (tr.value === 27)
                return Ce.readFloat64();
              switch (pe(tr, Ce)) {
                case 20:
                  return !1;
                case 21:
                  return !0;
                case 22:
                  return null;
                case 23:
                  return;
                case null:
                  return be;
                default:
                  throw new Error("Unknown fixed value: " + tr.value);
              }
            default:
              throw new Error("Unsupported header: " + JSON.stringify(tr));
          }
          throw new Error("not implemented yet");
        }
        function Pe(Ce, tr) {
          for (var Fe = 0; Fe < a.length; Fe++) {
            var Sr = a[Fe].fn(Ce);
            if (Sr !== void 0)
              return Ee(6, a[Fe].tag, tr), Pe(Sr, tr);
          }
          if (Ce && typeof Ce.toCBOR == "function" && (Ce = Ce.toCBOR()), Ce === !1)
            Ee(7, 20, tr);
          else if (Ce === !0)
            Ee(7, 21, tr);
          else if (Ce === null)
            Ee(7, 22, tr);
          else if (Ce === void 0)
            Ee(7, 23, tr);
          else if (typeof Ce == "number")
            Math.floor(Ce) === Ce && Ce < 9007199254740992 && Ce > -9007199254740992 ? Ce < 0 ? Ee(1, -1 - Ce, tr) : Ee(0, Ce, tr) : ($(7, 27, tr), tr.writeFloat64(Ce));
          else if (typeof Ce == "string")
            tr.writeString(Ce, function(Ie) {
              Ee(3, Ie, tr);
            });
          else if (tr.canWriteBinary(Ce))
            tr.writeBinary(Ce, function(Ie) {
              Ee(2, Ie, tr);
            });
          else if (typeof Ce == "object")
            if (or.config.useToJSON && typeof Ce.toJSON == "function" && (Ce = Ce.toJSON()), Array.isArray(Ce)) {
              Ee(4, Ce.length, tr);
              for (var Fe = 0; Fe < Ce.length; Fe++)
                Pe(Ce[Fe], tr);
            } else {
              var er = Object.keys(Ce);
              Ee(5, er.length, tr);
              for (var Fe = 0; Fe < er.length; Fe++) {
                const xe = parseInt(er[Fe]);
                isNaN(xe) ? (Pe(er[Fe], tr), Pe(Ce[er[Fe]], tr)) : (Pe(xe, tr), Pe(Ce[er[Fe]], tr));
              }
            }
          else
            throw new Error("CBOR encoding not supported: " + Ce);
        }
        var nr = [], ir = [], or = {
          config: {
            useToJSON: !0
          },
          addWriter: function(Ce, tr) {
            typeof Ce == "string" ? ir.push(function(Fe) {
              if (Ce === Fe)
                return tr(Fe);
            }) : ir.push(Ce);
          },
          addReader: function(Ce, tr) {
            typeof Ce == "string" ? nr.push(function(Fe, Sr) {
              if (Ce === Sr)
                return tr(Fe, Sr);
            }) : nr.push(Ce);
          },
          encode: function(Ce, tr) {
            for (var Fe = 0; Fe < ir.length; Fe++) {
              var Sr = ir[Fe], er = Sr(tr);
              if (er)
                return Pe(Ce, er), er.result();
            }
            throw new Error("Unsupported output format: " + tr);
          },
          encodeDataItem: function(Ce, tr) {
            for (var Fe = 0; Fe < ir.length; Fe++) {
              var Sr = ir[Fe], er = Sr(tr);
              if (er)
                return Ce.getTag() !== void 0 ? (Pe(Ce, er), er.result()) : (Pe(Ce.getData(), er), er.result());
            }
            throw new Error("Unsupported output format: " + tr);
          },
          decode: function(Ce, tr) {
            for (var Fe = 0; Fe < nr.length; Fe++) {
              var Sr = nr[Fe], er = Sr(Ce, tr);
              if (er)
                return He(er);
            }
            throw new Error("Unsupported input format: " + tr);
          },
          decodeToDataItem: function(Ce, tr) {
            for (var Fe = 0; Fe < nr.length; Fe++) {
              var Sr = nr[Fe], er = Sr(Ce, tr);
              if (er) {
                const Ie = He(er);
                return Ie instanceof c ? Ie : new c(Ie);
              }
            }
            throw new Error("Unsupported input format: " + tr);
          },
          addSemanticEncode: function(Ce, tr) {
            if (typeof Ce != "number" || Ce % 1 !== 0 || Ce < 0)
              throw new Error("Tag must be a positive integer");
            return a.push({ tag: Ce, fn: tr }), this;
          },
          addSemanticDecode: function(Ce, tr) {
            if (typeof Ce != "number" || Ce % 1 !== 0 || Ce < 0)
              throw new Error("Tag must be a positive integer");
            return A[Ce] = tr, this;
          }
        };
        function lr(Ce) {
          this.buffer = Ce, this.pos = 0;
        }
        lr.prototype = Object.create(F.prototype), lr.prototype.peekByte = function() {
          return this.buffer[this.pos];
        }, lr.prototype.readByte = function() {
          return this.buffer[this.pos++];
        }, lr.prototype.readUint16 = function() {
          var Ce = this.buffer.readUInt16BE(this.pos);
          return this.pos += 2, Ce;
        }, lr.prototype.readUint32 = function() {
          var Ce = this.buffer.readUInt32BE(this.pos);
          return this.pos += 4, Ce;
        }, lr.prototype.readFloat32 = function() {
          var Ce = this.buffer.readFloatBE(this.pos);
          return this.pos += 4, Ce;
        }, lr.prototype.readFloat64 = function() {
          var Ce = this.buffer.readDoubleBE(this.pos);
          return this.pos += 8, Ce;
        }, lr.prototype.readChunk = function(Ce) {
          var tr = Buffer$f.alloc(Ce);
          return this.buffer.copy(tr, 0, this.pos, this.pos += Ce), tr;
        };
        function Ir(Ce) {
          this.byteLength = 0, this.defaultBufferLength = 16384, this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0, this.completeBuffers = [], this.stringFormat = Ce;
        }
        Ir.prototype = Object.create(le.prototype), Ir.prototype.writeByte = function(Ce) {
          this.latestBuffer[this.latestBufferOffset++] = Ce, this.latestBufferOffset >= this.latestBuffer.length && (this.completeBuffers.push(this.latestBuffer), this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0), this.byteLength++;
        }, Ir.prototype.writeFloat32 = function(Ce) {
          var tr = Buffer$f.alloc(4);
          tr.writeFloatBE(Ce, 0), this.writeBuffer(tr);
        }, Ir.prototype.writeFloat64 = function(Ce) {
          var tr = Buffer$f.alloc(8);
          tr.writeDoubleBE(Ce, 0), this.writeBuffer(tr);
        }, Ir.prototype.writeString = function(Ce, tr) {
          var Fe = Buffer$f.from(Ce, "utf-8");
          tr(Fe.length), this.writeBuffer(Fe);
        }, Ir.prototype.canWriteBinary = function(Ce) {
          return Ce instanceof Buffer$f;
        }, Ir.prototype.writeBinary = function(Ce, tr) {
          tr(Ce.length), this.writeBuffer(Ce);
        }, Ir.prototype.writeBuffer = function(Ce) {
          if (!(Ce instanceof Buffer$f))
            throw new TypeError("BufferWriter only accepts Buffers");
          this.latestBufferOffset ? this.latestBuffer.length - this.latestBufferOffset >= Ce.length ? (Ce.copy(this.latestBuffer, this.latestBufferOffset), this.latestBufferOffset += Ce.length, this.latestBufferOffset >= this.latestBuffer.length && (this.completeBuffers.push(this.latestBuffer), this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0)) : (this.completeBuffers.push(this.latestBuffer.slice(0, this.latestBufferOffset)), this.completeBuffers.push(Ce), this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0) : this.completeBuffers.push(Ce), this.byteLength += Ce.length;
        }, Ir.prototype.result = function() {
          for (var Ce = Buffer$f.alloc(this.byteLength), tr = 0, Fe = 0; Fe < this.completeBuffers.length; Fe++) {
            var Sr = this.completeBuffers[Fe];
            Sr.copy(Ce, tr, 0, Sr.length), tr += Sr.length;
          }
          return this.latestBufferOffset && this.latestBuffer.copy(Ce, tr, 0, this.latestBufferOffset), this.stringFormat ? Ce.toString(this.stringFormat) : Ce;
        }, typeof Buffer$f == "function" && (or.addReader(function(Ce, tr) {
          if (Buffer$f.isBuffer(Ce))
            return new lr(Ce);
          if (tr === "hex" || tr === "base64") {
            var Fe = Buffer$f.from(Ce, tr);
            return new lr(Fe);
          }
        }), or.addWriter(function(Ce) {
          if (!Ce || Ce === "buffer")
            return new Ir();
          if (Ce === "hex" || Ce === "base64")
            return new Ir(Ce);
        }));
        function xr(Ce) {
          this.hex = Ce, this.pos = 0;
        }
        xr.prototype = Object.create(F.prototype), xr.prototype.peekByte = function() {
          var Ce = this.hex.substring(this.pos, 2);
          return parseInt(Ce, 16);
        }, xr.prototype.readByte = function() {
          var Ce = this.hex.substring(this.pos, this.pos + 2);
          return this.pos += 2, parseInt(Ce, 16);
        }, xr.prototype.readChunk = function(Ce) {
          var tr = this.hex.substring(this.pos, this.pos + Ce * 2);
          return this.pos += Ce * 2, typeof Buffer$f == "function" ? Buffer$f.from(tr, "hex") : new p(tr);
        };
        function kr(Ce) {
          this.$hex = "", this.finalFormat = Ce || "hex";
        }
        return kr.prototype = Object.create(le.prototype), kr.prototype.writeByte = function(Ce) {
          if (Ce < 0 || Ce > 255)
            throw new Error("Byte value out of range: " + Ce);
          var tr = Ce.toString(16);
          tr.length == 1 && (tr = "0" + tr), this.$hex += tr;
        }, kr.prototype.canWriteBinary = function(Ce) {
          return Ce instanceof p || typeof Buffer$f == "function" && Ce instanceof Buffer$f;
        }, kr.prototype.writeBinary = function(Ce, tr) {
          if (Ce instanceof p)
            tr(Ce.length()), this.$hex += Ce.$hex;
          else if (typeof Buffer$f == "function" && Ce instanceof Buffer$f)
            tr(Ce.length), this.$hex += Ce.toString("hex");
          else
            throw new TypeError("HexWriter only accepts BinaryHex or Buffers");
        }, kr.prototype.result = function() {
          return this.finalFormat === "buffer" && typeof Buffer$f == "function" ? Buffer$f.from(this.$hex, "hex") : new p(this.$hex).toString(this.finalFormat);
        }, kr.prototype.writeString = function(Ce, tr) {
          var Fe = p.fromUtf8String(Ce);
          tr(Fe.length()), this.$hex += Fe.$hex;
        }, or.addReader(function(Ce, tr) {
          if (Ce instanceof p || Ce.$hex)
            return new xr(Ce.$hex);
          if (tr === "hex")
            return new xr(Ce);
        }), or.addWriter(function(Ce) {
          if (Ce === "hex")
            return new kr();
        }), or;
      }();
      return u.addSemanticEncode(0, function(p) {
        if (p instanceof Date)
          return p.toISOString();
      }).addSemanticDecode(0, function(p) {
        return new Date(p);
      }).addSemanticDecode(1, function(p) {
        return new Date(p);
      }), u;
    });
  }(cborSync$8)), cborSync$8.exports;
}
var hasRequiredLib$9;
function requireLib$9() {
  return hasRequiredLib$9 || (hasRequiredLib$9 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.DataItem = n.addWriter = n.addReader = n.addSemanticEncode = n.addSemanticDecode = n.decodeToDataItem = n.encodeDataItem = void 0;
    var c = requireCborSync$8();
    Object.defineProperty(n, "encodeDataItem", { enumerable: !0, get: function() {
      return c.encodeDataItem;
    } }), Object.defineProperty(n, "decodeToDataItem", { enumerable: !0, get: function() {
      return c.decodeToDataItem;
    } }), Object.defineProperty(n, "addSemanticDecode", { enumerable: !0, get: function() {
      return c.addSemanticDecode;
    } }), Object.defineProperty(n, "addSemanticEncode", { enumerable: !0, get: function() {
      return c.addSemanticEncode;
    } }), Object.defineProperty(n, "addReader", { enumerable: !0, get: function() {
      return c.addReader;
    } }), Object.defineProperty(n, "addWriter", { enumerable: !0, get: function() {
      return c.addWriter;
    } });
    var u = requireDataItem$8();
    Object.defineProperty(n, "DataItem", { enumerable: !0, get: function() {
      return u.DataItem;
    } });
  }(lib$b)), lib$b;
}
var hasRequiredUtils$b;
function requireUtils$b() {
  if (hasRequiredUtils$b) return utils$E;
  hasRequiredUtils$b = 1, Object.defineProperty(utils$E, "__esModule", { value: !0 }), utils$E.patchTags = void 0;
  const n = requireLib$9(), c = [], u = (p) => {
    p.forEach((a) => {
      c.find((A) => A === a) || ((0, n.addSemanticEncode)(a, (A) => {
        if (A instanceof n.DataItem && A.getTag() === a)
          return A.getData();
      }), (0, n.addSemanticDecode)(a, (A) => new n.DataItem(A, a)), c.push(a));
    });
  };
  return utils$E.patchTags = u, utils$E;
}
var RegistryType$8 = {}, hasRequiredRegistryType$8;
function requireRegistryType$8() {
  if (hasRequiredRegistryType$8) return RegistryType$8;
  hasRequiredRegistryType$8 = 1, Object.defineProperty(RegistryType$8, "__esModule", { value: !0 }), RegistryType$8.RegistryTypes = RegistryType$8.RegistryType = void 0;
  class n {
    constructor(u, p) {
      this.type = u, this.tag = p, this.getTag = () => this.tag, this.getType = () => this.type;
    }
  }
  return RegistryType$8.RegistryType = n, RegistryType$8.RegistryTypes = {
    UUID: new n("uuid", 37),
    BYTES: new n("bytes", void 0),
    CRYPTO_HDKEY: new n("crypto-hdkey", 303),
    CRYPTO_KEYPATH: new n("crypto-keypath", 304),
    CRYPTO_COIN_INFO: new n("crypto-coin-info", 305),
    CRYPTO_ECKEY: new n("crypto-eckey", 306),
    CRYPTO_OUTPUT: new n("crypto-output", 308),
    CRYPTO_PSBT: new n("crypto-psbt", 310),
    CRYPTO_ACCOUNT: new n("crypto-account", 311),
    CRYPTO_MULTI_ACCOUNTS: new n("crypto-multi-accounts", 1103),
    QR_HARDWARE_CALL: new n("qr-hardware-call", 1201),
    KEY_DERIVATION_CALL: new n("key-derivation-call", 1301),
    KEY_DERIVATION_SCHEMA: new n("key-derivation-schema", 1302)
  }, RegistryType$8;
}
var ScriptExpression$8 = {}, hasRequiredScriptExpression$8;
function requireScriptExpression$8() {
  return hasRequiredScriptExpression$8 || (hasRequiredScriptExpression$8 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.ScriptExpressions = n.ScriptExpression = void 0;
    class c {
      constructor(p, a) {
        this.tag = p, this.expression = a, this.getTag = () => this.tag, this.getExpression = () => this.expression;
      }
    }
    n.ScriptExpression = c, c.fromTag = (u) => Object.values(n.ScriptExpressions).find((a) => a.getTag() === u), n.ScriptExpressions = {
      SCRIPT_HASH: new c(400, "sh"),
      WITNESS_SCRIPT_HASH: new c(401, "wsh"),
      PUBLIC_KEY: new c(402, "pk"),
      PUBLIC_KEY_HASH: new c(403, "pkh"),
      WITNESS_PUBLIC_KEY_HASH: new c(404, "wpkh"),
      COMBO: new c(405, "combo"),
      MULTISIG: new c(406, "multi"),
      SORTED_MULTISIG: new c(407, "sortedmulti"),
      ADDRESS: new c(307, "addr"),
      RAW_SCRIPT: new c(408, "raw")
    };
  }(ScriptExpression$8)), ScriptExpression$8;
}
var hasRequiredPatchCBOR$8;
function requirePatchCBOR$8() {
  if (hasRequiredPatchCBOR$8) return patchCBOR$8;
  hasRequiredPatchCBOR$8 = 1, Object.defineProperty(patchCBOR$8, "__esModule", { value: !0 });
  const n = requireUtils$b(), c = requireRegistryType$8(), u = requireScriptExpression$8(), p = Object.values(c.RegistryTypes).filter((A) => !!A.getTag()).map((A) => A.getTag()), a = Object.values(u.ScriptExpressions).map((A) => A.getTag());
  return (0, n.patchTags)(p.concat(a)), patchCBOR$8;
}
var CryptoHDKey$8 = {}, src$d, hasRequiredSrc$9;
function requireSrc$9() {
  if (hasRequiredSrc$9) return src$d;
  hasRequiredSrc$9 = 1;
  var n = safeBufferExports.Buffer;
  function c(u) {
    if (u.length >= 255)
      throw new TypeError("Alphabet too long");
    for (var p = new Uint8Array(256), a = 0; a < p.length; a++)
      p[a] = 255;
    for (var A = 0; A < u.length; A++) {
      var b = u.charAt(A), F = b.charCodeAt(0);
      if (p[F] !== 255)
        throw new TypeError(b + " is ambiguous");
      p[F] = A;
    }
    var le = u.length, L = u.charAt(0), pe = Math.log(le) / Math.log(256), $ = Math.log(256) / Math.log(le);
    function Ee(Pe) {
      if ((Array.isArray(Pe) || Pe instanceof Uint8Array) && (Pe = n.from(Pe)), !n.isBuffer(Pe))
        throw new TypeError("Expected Buffer");
      if (Pe.length === 0)
        return "";
      for (var nr = 0, ir = 0, or = 0, lr = Pe.length; or !== lr && Pe[or] === 0; )
        or++, nr++;
      for (var Ir = (lr - or) * $ + 1 >>> 0, xr = new Uint8Array(Ir); or !== lr; ) {
        for (var kr = Pe[or], Ce = 0, tr = Ir - 1; (kr !== 0 || Ce < ir) && tr !== -1; tr--, Ce++)
          kr += 256 * xr[tr] >>> 0, xr[tr] = kr % le >>> 0, kr = kr / le >>> 0;
        if (kr !== 0)
          throw new Error("Non-zero carry");
        ir = Ce, or++;
      }
      for (var Fe = Ir - ir; Fe !== Ir && xr[Fe] === 0; )
        Fe++;
      for (var Sr = L.repeat(nr); Fe < Ir; ++Fe)
        Sr += u.charAt(xr[Fe]);
      return Sr;
    }
    function be(Pe) {
      if (typeof Pe != "string")
        throw new TypeError("Expected String");
      if (Pe.length === 0)
        return n.alloc(0);
      for (var nr = 0, ir = 0, or = 0; Pe[nr] === L; )
        ir++, nr++;
      for (var lr = (Pe.length - nr) * pe + 1 >>> 0, Ir = new Uint8Array(lr); nr < Pe.length; ) {
        var xr = Pe.charCodeAt(nr);
        if (xr > 255)
          return;
        var kr = p[xr];
        if (kr === 255)
          return;
        for (var Ce = 0, tr = lr - 1; (kr !== 0 || Ce < or) && tr !== -1; tr--, Ce++)
          kr += le * Ir[tr] >>> 0, Ir[tr] = kr % 256 >>> 0, kr = kr / 256 >>> 0;
        if (kr !== 0)
          throw new Error("Non-zero carry");
        or = Ce, nr++;
      }
      for (var Fe = lr - or; Fe !== lr && Ir[Fe] === 0; )
        Fe++;
      var Sr = n.allocUnsafe(ir + (lr - Fe));
      Sr.fill(0, 0, ir);
      for (var er = ir; Fe !== lr; )
        Sr[er++] = Ir[Fe++];
      return Sr;
    }
    function He(Pe) {
      var nr = be(Pe);
      if (nr)
        return nr;
      throw new Error("Non-base" + le + " character");
    }
    return {
      encode: Ee,
      decodeUnsafe: be,
      decode: He
    };
  }
  return src$d = c, src$d;
}
var bs58$a, hasRequiredBs58$9;
function requireBs58$9() {
  if (hasRequiredBs58$9) return bs58$a;
  hasRequiredBs58$9 = 1;
  var n = requireSrc$9(), c = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
  return bs58$a = n(c), bs58$a;
}
var base$e, hasRequiredBase$a;
function requireBase$a() {
  if (hasRequiredBase$a) return base$e;
  hasRequiredBase$a = 1;
  var n = requireBs58$9(), c = safeBufferExports.Buffer;
  return base$e = function(u) {
    function p(F) {
      var le = u(F);
      return n.encode(c.concat([
        F,
        le
      ], F.length + 4));
    }
    function a(F) {
      var le = F.slice(0, -4), L = F.slice(-4), pe = u(le);
      if (!(L[0] ^ pe[0] | L[1] ^ pe[1] | L[2] ^ pe[2] | L[3] ^ pe[3]))
        return le;
    }
    function A(F) {
      var le = n.decodeUnsafe(F);
      if (le)
        return a(le);
    }
    function b(F) {
      var le = n.decode(F), L = a(le);
      if (!L) throw new Error("Invalid checksum");
      return L;
    }
    return {
      encode: p,
      decode: b,
      decodeUnsafe: A
    };
  }, base$e;
}
var bs58check$c, hasRequiredBs58check$9;
function requireBs58check$9() {
  if (hasRequiredBs58check$9) return bs58check$c;
  hasRequiredBs58check$9 = 1;
  var n = browser$a, c = requireBase$a();
  function u(p) {
    var a = n("sha256").update(p).digest();
    return n("sha256").update(a).digest();
  }
  return bs58check$c = c(u), bs58check$c;
}
var CryptoCoinInfo$8 = {}, RegistryItem$8 = {}, hasRequiredRegistryItem$8;
function requireRegistryItem$8() {
  if (hasRequiredRegistryItem$8) return RegistryItem$8;
  hasRequiredRegistryItem$8 = 1, Object.defineProperty(RegistryItem$8, "__esModule", { value: !0 }), RegistryItem$8.RegistryItem = void 0;
  const n = dist$t, c = requireLib$9();
  class u {
    constructor() {
      this.toCBOR = () => {
        if (this.toDataItem() === void 0)
          throw new Error(`#[ur-registry][RegistryItem][fn.toCBOR]: registry ${this.getRegistryType()}'s method toDataItem returns undefined`);
        return (0, c.encodeDataItem)(this.toDataItem());
      }, this.toUR = () => new n.UR(this.toCBOR(), this.getRegistryType().getType()), this.toUREncoder = (a, A, b) => {
        const F = this.toUR();
        return new n.UREncoder(F, a, A, b);
      };
    }
  }
  return RegistryItem$8.RegistryItem = u, RegistryItem$8;
}
var hasRequiredCryptoCoinInfo$8;
function requireCryptoCoinInfo$8() {
  return hasRequiredCryptoCoinInfo$8 || (hasRequiredCryptoCoinInfo$8 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.CryptoCoinInfo = n.Network = n.Type = void 0;
    const c = requireLib$9(), u = requireRegistryItem$8(), p = requireRegistryType$8();
    var a;
    (function(le) {
      le.type = "1", le.network = "2";
    })(a || (a = {}));
    var A;
    (function(le) {
      le[le.bitcoin = 0] = "bitcoin";
    })(A = n.Type || (n.Type = {}));
    var b;
    (function(le) {
      le[le.mainnet = 0] = "mainnet", le[le.testnet = 1] = "testnet";
    })(b = n.Network || (n.Network = {}));
    class F extends u.RegistryItem {
      constructor(L, pe) {
        super(), this.type = L, this.network = pe, this.getRegistryType = () => p.RegistryTypes.CRYPTO_COIN_INFO, this.getType = () => this.type || A.bitcoin, this.getNetwork = () => this.network || b.mainnet, this.toDataItem = () => {
          const $ = {};
          return this.type && ($[a.type] = this.type), this.network && ($[a.network] = this.network), new c.DataItem($);
        };
      }
    }
    n.CryptoCoinInfo = F, F.fromDataItem = (le) => {
      const L = le.getData(), pe = L[a.type], $ = L[a.network];
      return new F(pe, $);
    }, F.fromCBOR = (le) => {
      const L = (0, c.decodeToDataItem)(le);
      return F.fromDataItem(L);
    };
  }(CryptoCoinInfo$8)), CryptoCoinInfo$8;
}
var CryptoKeypath$8 = {}, PathComponent$8 = {}, hasRequiredPathComponent$8;
function requirePathComponent$8() {
  if (hasRequiredPathComponent$8) return PathComponent$8;
  hasRequiredPathComponent$8 = 1, Object.defineProperty(PathComponent$8, "__esModule", { value: !0 }), PathComponent$8.PathComponent = void 0;
  class n {
    constructor(u) {
      if (this.getIndex = () => this.index, this.isWildcard = () => this.wildcard, this.isHardened = () => this.hardened, this.index = u.index, this.hardened = u.hardened, this.index !== void 0 ? this.wildcard = !1 : this.wildcard = !0, this.index && this.index & n.HARDENED_BIT)
        throw new Error(`#[ur-registry][PathComponent][fn.constructor]: Invalid index ${this.index} - most significant bit cannot be set`);
    }
  }
  return PathComponent$8.PathComponent = n, n.HARDENED_BIT = 2147483648, PathComponent$8;
}
var hasRequiredCryptoKeypath$8;
function requireCryptoKeypath$8() {
  if (hasRequiredCryptoKeypath$8) return CryptoKeypath$8;
  hasRequiredCryptoKeypath$8 = 1, Object.defineProperty(CryptoKeypath$8, "__esModule", { value: !0 }), CryptoKeypath$8.CryptoKeypath = void 0;
  const n = requireLib$9(), c = requirePathComponent$8(), u = requireRegistryItem$8(), p = requireRegistryType$8();
  var a;
  (function(b) {
    b[b.components = 1] = "components", b[b.source_fingerprint = 2] = "source_fingerprint", b[b.depth = 3] = "depth";
  })(a || (a = {}));
  class A extends u.RegistryItem {
    constructor(F = [], le, L) {
      super(), this.components = F, this.sourceFingerprint = le, this.depth = L, this.getRegistryType = () => p.RegistryTypes.CRYPTO_KEYPATH, this.getPath = () => this.components.length === 0 ? void 0 : this.components.map(($) => `${$.isWildcard() ? "*" : $.getIndex()}${$.isHardened() ? "'" : ""}`).join("/"), this.getComponents = () => this.components, this.getSourceFingerprint = () => this.sourceFingerprint, this.getDepth = () => this.depth, this.toDataItem = () => {
        const pe = {}, $ = [];
        return this.components && this.components.forEach((Ee) => {
          Ee.isWildcard() ? $.push([]) : $.push(Ee.getIndex()), $.push(Ee.isHardened());
        }), pe[a.components] = $, this.sourceFingerprint && (pe[a.source_fingerprint] = this.sourceFingerprint.readUInt32BE(0)), this.depth !== void 0 && (pe[a.depth] = this.depth), new n.DataItem(pe);
      };
    }
  }
  return CryptoKeypath$8.CryptoKeypath = A, A.fromDataItem = (b) => {
    const F = b.getData(), le = [], L = F[a.components];
    if (L)
      for (let be = 0; be < L.length; be += 2) {
        const He = L[be + 1], Pe = L[be];
        typeof Pe == "number" ? le.push(new c.PathComponent({ index: Pe, hardened: He })) : le.push(new c.PathComponent({ hardened: He }));
      }
    const pe = F[a.source_fingerprint];
    let $;
    pe && ($ = Buffer$f.alloc(4), $.writeUInt32BE(pe, 0));
    const Ee = F[a.depth];
    return new A(le, $, Ee);
  }, A.fromCBOR = (b) => {
    const F = (0, n.decodeToDataItem)(b);
    return A.fromDataItem(F);
  }, CryptoKeypath$8;
}
var hasRequiredCryptoHDKey$8;
function requireCryptoHDKey$8() {
  if (hasRequiredCryptoHDKey$8) return CryptoHDKey$8;
  hasRequiredCryptoHDKey$8 = 1, Object.defineProperty(CryptoHDKey$8, "__esModule", { value: !0 }), CryptoHDKey$8.CryptoHDKey = void 0;
  const n = requireBs58check$9(), c = requireCryptoCoinInfo$8(), u = requireCryptoKeypath$8(), p = requireLib$9(), a = requireRegistryItem$8(), A = requireRegistryType$8();
  var b;
  (function(le) {
    le[le.is_master = 1] = "is_master", le[le.is_private = 2] = "is_private", le[le.key_data = 3] = "key_data", le[le.chain_code = 4] = "chain_code", le[le.use_info = 5] = "use_info", le[le.origin = 6] = "origin", le[le.children = 7] = "children", le[le.parent_fingerprint = 8] = "parent_fingerprint", le[le.name = 9] = "name", le[le.note = 10] = "note";
  })(b || (b = {}));
  class F extends a.RegistryItem {
    constructor(L) {
      super(), this.isECKey = () => !1, this.getKey = () => this.key, this.getChainCode = () => this.chainCode, this.isMaster = () => this.master, this.isPrivateKey = () => !!this.privateKey, this.getUseInfo = () => this.useInfo, this.getOrigin = () => this.origin, this.getChildren = () => this.children, this.getParentFingerprint = () => this.parentFingerprint, this.getName = () => this.name, this.getNote = () => this.note, this.getBip32Key = () => {
        var pe, $, Ee;
        let be, He, Pe = 0, nr = Buffer$f.alloc(4).fill(0);
        if (this.isMaster())
          be = Buffer$f.from("0488ADE4", "hex"), He = 0, Pe = 0;
        else {
          He = ((pe = this.getOrigin()) === null || pe === void 0 ? void 0 : pe.getComponents().length) || (($ = this.getOrigin()) === null || $ === void 0 ? void 0 : $.getDepth());
          const xr = (Ee = this.getOrigin()) === null || Ee === void 0 ? void 0 : Ee.getComponents(), kr = xr[xr.length - 1];
          kr && (Pe = kr.isHardened() ? kr.getIndex() + 2147483648 : kr.getIndex(), this.getParentFingerprint() && (nr = this.getParentFingerprint())), this.isPrivateKey() ? be = Buffer$f.from("0488ADE4", "hex") : be = Buffer$f.from("0488B21E", "hex");
        }
        const ir = Buffer$f.alloc(1);
        ir.writeUInt8(He, 0);
        const or = Buffer$f.alloc(4);
        or.writeUInt32BE(Pe, 0);
        const lr = this.getChainCode(), Ir = this.getKey();
        return (0, n.encode)(Buffer$f.concat([be, ir, nr, or, lr, Ir]));
      }, this.getRegistryType = () => A.RegistryTypes.CRYPTO_HDKEY, this.getOutputDescriptorContent = () => {
        var pe, $, Ee, be, He, Pe, nr;
        let ir = "";
        return this.getOrigin() && !((pe = this.getOrigin()) === null || pe === void 0) && pe.getSourceFingerprint() && !(($ = this.getOrigin()) === null || $ === void 0) && $.getPath() && (ir += `${(be = (Ee = this.getOrigin()) === null || Ee === void 0 ? void 0 : Ee.getSourceFingerprint()) === null || be === void 0 ? void 0 : be.toString("hex")}/${(He = this.getOrigin()) === null || He === void 0 ? void 0 : He.getPath()}`), ir += this.getBip32Key(), this.getChildren() && !((Pe = this.getChildren()) === null || Pe === void 0) && Pe.getPath() && (ir += `/${(nr = this.getChildren()) === null || nr === void 0 ? void 0 : nr.getPath()}`), ir;
      }, this.setupMasterKey = (pe) => {
        this.master = !0, this.key = pe.key, this.chainCode = pe.chainCode;
      }, this.setupDeriveKey = (pe) => {
        this.master = !1, this.privateKey = pe.isPrivateKey, this.key = pe.key, this.chainCode = pe.chainCode, this.useInfo = pe.useInfo, this.origin = pe.origin, this.children = pe.children, this.parentFingerprint = pe.parentFingerprint, this.name = pe.name, this.note = pe.note;
      }, this.toDataItem = () => {
        const pe = {};
        if (this.master)
          pe[b.is_master] = !0, pe[b.key_data] = this.key, pe[b.chain_code] = this.chainCode;
        else {
          if (this.privateKey !== void 0 && (pe[b.is_private] = this.privateKey), pe[b.key_data] = this.key, this.chainCode && (pe[b.chain_code] = this.chainCode), this.useInfo) {
            const $ = this.useInfo.toDataItem();
            $.setTag(this.useInfo.getRegistryType().getTag()), pe[b.use_info] = $;
          }
          if (this.origin) {
            const $ = this.origin.toDataItem();
            $.setTag(this.origin.getRegistryType().getTag()), pe[b.origin] = $;
          }
          if (this.children) {
            const $ = this.children.toDataItem();
            $.setTag(this.children.getRegistryType().getTag()), pe[b.children] = $;
          }
          this.parentFingerprint && (pe[b.parent_fingerprint] = this.parentFingerprint.readUInt32BE(0)), this.name !== void 0 && (pe[b.name] = this.name), this.note !== void 0 && (pe[b.note] = this.note);
        }
        return new p.DataItem(pe);
      }, L.isMaster ? this.setupMasterKey(L) : this.setupDeriveKey(L);
    }
  }
  return CryptoHDKey$8.CryptoHDKey = F, F.fromDataItem = (le) => {
    const L = le.getData(), pe = !!L[b.is_master], $ = L[b.is_private], Ee = L[b.key_data], be = L[b.chain_code], He = L[b.use_info] ? c.CryptoCoinInfo.fromDataItem(L[b.use_info]) : void 0, Pe = L[b.origin] ? u.CryptoKeypath.fromDataItem(L[b.origin]) : void 0, nr = L[b.children] ? u.CryptoKeypath.fromDataItem(L[b.children]) : void 0, ir = L[b.parent_fingerprint];
    let or;
    ir && (or = Buffer$f.alloc(4), or.writeUInt32BE(ir, 0));
    const lr = L[b.name], Ir = L[b.note];
    return new F({
      isMaster: pe,
      isPrivateKey: $,
      key: Ee,
      chainCode: be,
      useInfo: He,
      origin: Pe,
      children: nr,
      parentFingerprint: or,
      name: lr,
      note: Ir
    });
  }, F.fromCBOR = (le) => {
    const L = (0, p.decodeToDataItem)(le);
    return F.fromDataItem(L);
  }, CryptoHDKey$8;
}
var CryptoECKey$8 = {}, hasRequiredCryptoECKey$8;
function requireCryptoECKey$8() {
  if (hasRequiredCryptoECKey$8) return CryptoECKey$8;
  hasRequiredCryptoECKey$8 = 1, Object.defineProperty(CryptoECKey$8, "__esModule", { value: !0 }), CryptoECKey$8.CryptoECKey = void 0;
  const n = requireLib$9(), c = requireRegistryItem$8(), u = requireRegistryType$8();
  var p;
  (function(A) {
    A[A.curve = 1] = "curve", A[A.private = 2] = "private", A[A.data = 3] = "data";
  })(p || (p = {}));
  class a extends c.RegistryItem {
    constructor(b) {
      super(), this.isECKey = () => !0, this.getCurve = () => this.curve || 0, this.isPrivateKey = () => this.privateKey || !1, this.getData = () => this.data, this.getRegistryType = () => u.RegistryTypes.CRYPTO_ECKEY, this.toDataItem = () => {
        const F = {};
        return this.curve && (F[p.curve] = this.curve), this.privateKey !== void 0 && (F[p.private] = this.privateKey), F[p.data] = this.data, new n.DataItem(F);
      }, this.getOutputDescriptorContent = () => this.data.toString("hex"), this.data = b.data, this.curve = b.curve, this.privateKey = b.privateKey || void 0;
    }
  }
  return CryptoECKey$8.CryptoECKey = a, a.fromDataItem = (A) => {
    const b = A.getData(), F = b[p.curve], le = b[p.private], L = b[p.data];
    if (!L)
      throw new Error(`#[ur-registry][CryptoECKey][fn.fromDataItem]: decoded [dataItem][#data.data] is undefined: ${A}`);
    return new a({ data: L, curve: F, privateKey: le });
  }, a.fromCBOR = (A) => {
    const b = (0, n.decodeToDataItem)(A);
    return a.fromDataItem(b);
  }, CryptoECKey$8;
}
var Bytes$9 = {}, hasRequiredBytes$9;
function requireBytes$9() {
  if (hasRequiredBytes$9) return Bytes$9;
  hasRequiredBytes$9 = 1, Object.defineProperty(Bytes$9, "__esModule", { value: !0 }), Bytes$9.Bytes = void 0;
  const n = requireLib$9(), c = requireRegistryItem$8(), u = requireRegistryType$8();
  class p extends c.RegistryItem {
    constructor(A) {
      super(), this.bytes = A, this.getRegistryType = () => u.RegistryTypes.BYTES, this.getData = () => this.bytes, this.toDataItem = () => new n.DataItem(this.bytes);
    }
  }
  return Bytes$9.Bytes = p, p.fromDataItem = (a) => {
    const A = a.getData();
    if (!A)
      throw new Error(`#[ur-registry][Bytes][fn.fromDataItem]: decoded [dataItem][#data] is undefined: ${a}`);
    return new p(A);
  }, p.fromCBOR = (a) => {
    const A = (0, n.decodeToDataItem)(a);
    return p.fromDataItem(A);
  }, Bytes$9;
}
var CryptoOutput$8 = {}, MultiKey$8 = {}, hasRequiredMultiKey$8;
function requireMultiKey$8() {
  if (hasRequiredMultiKey$8) return MultiKey$8;
  hasRequiredMultiKey$8 = 1, Object.defineProperty(MultiKey$8, "__esModule", { value: !0 }), MultiKey$8.MultiKey = void 0;
  const n = requireCryptoECKey$8(), c = requireCryptoHDKey$8(), u = requireDataItem$8(), p = requireRegistryItem$8(), a = requireRegistryType$8();
  var A;
  (function(F) {
    F[F.threshold = 1] = "threshold", F[F.keys = 2] = "keys";
  })(A || (A = {}));
  class b extends p.RegistryItem {
    constructor(le, L) {
      super(), this.threshold = le, this.keys = L, this.getThreshold = () => this.threshold, this.getKeys = () => this.keys, this.toDataItem = () => {
        const pe = {};
        pe[A.threshold] = this.threshold;
        const $ = this.keys.map((Ee) => {
          const be = Ee.toDataItem();
          return be.setTag(Ee.getRegistryType().getTag()), be;
        });
        return pe[A.keys] = $, new u.DataItem(pe);
      }, this.getOutputDescriptorContent = () => [
        this.getThreshold(),
        this.keys.map((pe) => pe.getOutputDescriptorContent()).join(",")
      ].join(",");
    }
  }
  return MultiKey$8.MultiKey = b, b.fromDataItem = (F) => {
    const le = F.getData(), L = le[A.threshold], pe = le[A.keys], $ = [];
    return pe.forEach((Ee) => {
      Ee.getTag() === a.RegistryTypes.CRYPTO_HDKEY.getTag() ? $.push(c.CryptoHDKey.fromDataItem(Ee)) : Ee.getTag() === a.RegistryTypes.CRYPTO_ECKEY.getTag() && $.push(n.CryptoECKey.fromDataItem(Ee));
    }), new b(L, $);
  }, MultiKey$8;
}
var hasRequiredCryptoOutput$8;
function requireCryptoOutput$8() {
  if (hasRequiredCryptoOutput$8) return CryptoOutput$8;
  hasRequiredCryptoOutput$8 = 1, Object.defineProperty(CryptoOutput$8, "__esModule", { value: !0 }), CryptoOutput$8.CryptoOutput = void 0;
  const n = requireCryptoECKey$8(), c = requireCryptoHDKey$8(), u = requireLib$9(), p = requireMultiKey$8(), a = requireRegistryItem$8(), A = requireRegistryType$8(), b = requireScriptExpression$8();
  class F extends a.RegistryItem {
    constructor(L, pe) {
      super(), this.scriptExpressions = L, this.cryptoKey = pe, this.getRegistryType = () => A.RegistryTypes.CRYPTO_OUTPUT, this.getCryptoKey = () => this.cryptoKey, this.getHDKey = () => {
        if (this.cryptoKey instanceof c.CryptoHDKey)
          return this.cryptoKey;
      }, this.getECKey = () => {
        if (this.cryptoKey instanceof n.CryptoECKey)
          return this.cryptoKey;
      }, this.getMultiKey = () => {
        if (this.cryptoKey instanceof p.MultiKey)
          return this.cryptoKey;
      }, this.getScriptExpressions = () => this.scriptExpressions, this._toOutputDescriptor = ($) => $ >= this.scriptExpressions.length ? this.cryptoKey.getOutputDescriptorContent() : `${this.scriptExpressions[$].getExpression()}(${this._toOutputDescriptor($ + 1)})`, this.toString = () => this._toOutputDescriptor(0), this.toDataItem = () => {
        let $ = this.cryptoKey.toDataItem();
        return (this.cryptoKey instanceof n.CryptoECKey || this.cryptoKey instanceof c.CryptoHDKey) && $.setTag(this.cryptoKey.getRegistryType().getTag()), [...this.scriptExpressions].reverse().forEach((be) => {
          const He = be.getTag();
          $.getTag() === void 0 ? $.setTag(He) : $ = new u.DataItem($, He);
        }), $;
      };
    }
  }
  return CryptoOutput$8.CryptoOutput = F, F.fromDataItem = (le) => {
    const L = [];
    let pe = le;
    for (; ; ) {
      let be = pe.getTag();
      const He = b.ScriptExpression.fromTag(be);
      if (He)
        if (L.push(He), pe.getData() instanceof u.DataItem)
          pe = pe.getData(), be = pe.getTag();
        else
          break;
      else
        break;
    }
    const $ = L.length;
    if ($ > 0 && (L[$ - 1].getExpression() === b.ScriptExpressions.MULTISIG.getExpression() || L[$ - 1].getExpression() === b.ScriptExpressions.SORTED_MULTISIG.getExpression())) {
      const be = p.MultiKey.fromDataItem(pe);
      return new F(L, be);
    }
    if (pe.getTag() === A.RegistryTypes.CRYPTO_HDKEY.getTag()) {
      const be = c.CryptoHDKey.fromDataItem(pe);
      return new F(L, be);
    } else {
      const be = n.CryptoECKey.fromDataItem(pe);
      return new F(L, be);
    }
  }, F.fromCBOR = (le) => {
    const L = (0, u.decodeToDataItem)(le);
    return F.fromDataItem(L);
  }, CryptoOutput$8;
}
var CryptoPSBT$8 = {}, hasRequiredCryptoPSBT$8;
function requireCryptoPSBT$8() {
  if (hasRequiredCryptoPSBT$8) return CryptoPSBT$8;
  hasRequiredCryptoPSBT$8 = 1, Object.defineProperty(CryptoPSBT$8, "__esModule", { value: !0 }), CryptoPSBT$8.CryptoPSBT = void 0;
  const n = requireLib$9(), c = requireRegistryItem$8(), u = requireRegistryType$8();
  class p extends c.RegistryItem {
    constructor(A) {
      super(), this.psbt = A, this.getRegistryType = () => u.RegistryTypes.CRYPTO_PSBT, this.getPSBT = () => this.psbt, this.toDataItem = () => new n.DataItem(this.psbt);
    }
  }
  return CryptoPSBT$8.CryptoPSBT = p, p.fromDataItem = (a) => {
    const A = a.getData();
    if (!A)
      throw new Error(`#[ur-registry][CryptoPSBT][fn.fromDataItem]: decoded [dataItem][#data] is undefined: ${a}`);
    return new p(A);
  }, p.fromCBOR = (a) => {
    const A = (0, n.decodeToDataItem)(a);
    return p.fromDataItem(A);
  }, CryptoPSBT$8;
}
var CryptoAccount$8 = {}, hasRequiredCryptoAccount$8;
function requireCryptoAccount$8() {
  if (hasRequiredCryptoAccount$8) return CryptoAccount$8;
  hasRequiredCryptoAccount$8 = 1, Object.defineProperty(CryptoAccount$8, "__esModule", { value: !0 }), CryptoAccount$8.CryptoAccount = void 0;
  const n = requireDist$8(), c = requireLib$9(), u = requireRegistryItem$8(), p = requireRegistryType$8();
  var a;
  (function(b) {
    b[b.masterFingerprint = 1] = "masterFingerprint", b[b.outputDescriptors = 2] = "outputDescriptors";
  })(a || (a = {}));
  class A extends u.RegistryItem {
    constructor(F, le) {
      super(), this.masterFingerprint = F, this.outputDescriptors = le, this.getRegistryType = () => p.RegistryTypes.CRYPTO_ACCOUNT, this.getMasterFingerprint = () => this.masterFingerprint, this.getOutputDescriptors = () => this.outputDescriptors, this.toDataItem = () => {
        const L = {};
        return this.masterFingerprint && (L[a.masterFingerprint] = this.masterFingerprint.readUInt32BE(0)), this.outputDescriptors && (L[a.outputDescriptors] = this.outputDescriptors.map((pe) => pe.toDataItem())), new c.DataItem(L);
      };
    }
  }
  return CryptoAccount$8.CryptoAccount = A, A.fromDataItem = (b) => {
    const F = b.getData(), le = Buffer$f.alloc(4), L = F[a.masterFingerprint];
    L && le.writeUInt32BE(L, 0);
    const $ = F[a.outputDescriptors].map((Ee) => n.CryptoOutput.fromDataItem(Ee));
    return new A(le, $);
  }, A.fromCBOR = (b) => {
    const F = (0, c.decodeToDataItem)(b);
    return A.fromDataItem(F);
  }, CryptoAccount$8;
}
var Decoder$8 = {}, errors$9 = {}, hasRequiredErrors$8;
function requireErrors$8() {
  if (hasRequiredErrors$8) return errors$9;
  hasRequiredErrors$8 = 1, Object.defineProperty(errors$9, "__esModule", { value: !0 }), errors$9.UnknownURTypeError = void 0;
  class n extends Error {
    constructor(u) {
      super(u);
    }
  }
  return errors$9.UnknownURTypeError = n, errors$9;
}
var hasRequiredDecoder$8;
function requireDecoder$8() {
  if (hasRequiredDecoder$8) return Decoder$8;
  hasRequiredDecoder$8 = 1, Object.defineProperty(Decoder$8, "__esModule", { value: !0 }), Decoder$8.URRegistryDecoder = void 0;
  const n = dist$t, c = requireDist$8(), u = requireRegistryType$8(), p = requireErrors$8();
  class a extends n.URDecoder {
    constructor() {
      super(...arguments), this.resultRegistryType = () => {
        const b = this.resultUR();
        switch (b.type) {
          case u.RegistryTypes.BYTES.getType():
            return c.Bytes.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_HDKEY.getType():
            return c.CryptoHDKey.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_KEYPATH.getType():
            return c.CryptoKeypath.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_COIN_INFO.getType():
            return c.CryptoCoinInfo.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_ECKEY.getType():
            return c.CryptoECKey.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_OUTPUT.getType():
            return c.CryptoOutput.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_PSBT.getType():
            return c.CryptoPSBT.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_ACCOUNT.getType():
            return c.CryptoAccount.fromCBOR(b.cbor);
          default:
            throw new p.UnknownURTypeError(`#[ur-registry][Decoder][fn.resultRegistryType]: registry type ${b.type} is not supported now`);
        }
      };
    }
  }
  return Decoder$8.URRegistryDecoder = a, Decoder$8;
}
var CryptoMultiAccounts$8 = {}, hasRequiredCryptoMultiAccounts$8;
function requireCryptoMultiAccounts$8() {
  if (hasRequiredCryptoMultiAccounts$8) return CryptoMultiAccounts$8;
  hasRequiredCryptoMultiAccounts$8 = 1, Object.defineProperty(CryptoMultiAccounts$8, "__esModule", { value: !0 }), CryptoMultiAccounts$8.CryptoMultiAccounts = void 0;
  const n = requireRegistryType$8(), c = requireCryptoHDKey$8(), u = requireRegistryItem$8(), p = requireLib$9();
  var a;
  (function(b) {
    b[b.masterFingerprint = 1] = "masterFingerprint", b[b.keys = 2] = "keys", b[b.device = 3] = "device", b[b.deviceId = 4] = "deviceId", b[b.version = 5] = "version";
  })(a || (a = {}));
  class A extends u.RegistryItem {
    constructor(F, le, L, pe, $) {
      super(), this.masterFingerprint = F, this.keys = le, this.device = L, this.deviceId = pe, this.version = $, this.getRegistryType = () => n.RegistryTypes.CRYPTO_MULTI_ACCOUNTS, this.getMasterFingerprint = () => this.masterFingerprint, this.getKeys = () => this.keys, this.getDevice = () => this.device, this.getDeviceId = () => this.deviceId, this.getVersion = () => this.version, this.toDataItem = () => {
        const Ee = {};
        return this.masterFingerprint && (Ee[a.masterFingerprint] = this.masterFingerprint.readUInt32BE(0)), this.keys && (Ee[a.keys] = this.keys.map((be) => {
          const He = be.toDataItem();
          return He.setTag(be.getRegistryType().getTag()), He;
        })), this.device && (Ee[a.device] = this.device), this.deviceId && (Ee[a.deviceId] = this.deviceId), this.version && (Ee[a.version] = this.version), new p.DataItem(Ee);
      };
    }
  }
  return CryptoMultiAccounts$8.CryptoMultiAccounts = A, A.fromDataItem = (b) => {
    const F = b.getData(), le = Buffer$f.alloc(4), L = F[a.masterFingerprint];
    L && le.writeUInt32BE(L, 0);
    const $ = F[a.keys].map((Pe) => c.CryptoHDKey.fromDataItem(Pe)), Ee = F[a.device], be = F[a.deviceId], He = F[a.version];
    return new A(le, $, Ee, be, He);
  }, A.fromCBOR = (b) => {
    const F = (0, p.decodeToDataItem)(b);
    return A.fromDataItem(F);
  }, CryptoMultiAccounts$8;
}
var QRHardwareCall$8 = {}, KeyDerivation$8 = {}, DerivationSchema$8 = {}, hasRequiredDerivationSchema$8;
function requireDerivationSchema$8() {
  return hasRequiredDerivationSchema$8 || (hasRequiredDerivationSchema$8 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.KeyDerivationSchema = n.DerivationAlgorithm = n.Curve = void 0;
    const c = requireRegistryType$8(), u = requireRegistryItem$8(), p = requireLib$9(), a = requireCryptoKeypath$8();
    var A;
    (function(L) {
      L[L.keyPath = 1] = "keyPath", L[L.curve = 2] = "curve", L[L.algo = 3] = "algo";
    })(A || (A = {}));
    var b;
    (function(L) {
      L[L.secp256k1 = 0] = "secp256k1", L[L.ed25519 = 1] = "ed25519";
    })(b = n.Curve || (n.Curve = {}));
    var F;
    (function(L) {
      L[L.slip10 = 0] = "slip10", L[L.bip32ed25519 = 1] = "bip32ed25519";
    })(F = n.DerivationAlgorithm || (n.DerivationAlgorithm = {}));
    class le extends u.RegistryItem {
      constructor(pe, $ = b.secp256k1, Ee = F.slip10) {
        super(), this.keypath = pe, this.curve = $, this.algo = Ee, this.getRegistryType = () => c.RegistryTypes.KEY_DERIVATION_SCHEMA, this.getKeypath = () => this.keypath, this.getCurve = () => this.curve, this.getAlgo = () => this.algo, this.toDataItem = () => {
          const be = {}, He = this.getKeypath().toDataItem();
          return He.setTag(this.getKeypath().getRegistryType().getTag()), be[A.keyPath] = He, be[A.curve] = this.curve, be[A.algo] = this.algo, new p.DataItem(be);
        };
      }
    }
    n.KeyDerivationSchema = le, le.fromDataItem = (L) => {
      const pe = L.getData(), $ = a.CryptoKeypath.fromDataItem(pe[A.keyPath]), Ee = pe[A.curve], be = pe[A.algo];
      return new le($, Ee, be);
    }, le.fromCBOR = (L) => {
      const pe = (0, p.decodeToDataItem)(L);
      return le.fromDataItem(pe);
    };
  }(DerivationSchema$8)), DerivationSchema$8;
}
var hasRequiredKeyDerivation$8;
function requireKeyDerivation$8() {
  if (hasRequiredKeyDerivation$8) return KeyDerivation$8;
  hasRequiredKeyDerivation$8 = 1, Object.defineProperty(KeyDerivation$8, "__esModule", { value: !0 }), KeyDerivation$8.KeyDerivation = void 0;
  const n = requireRegistryType$8(), c = requireRegistryItem$8(), u = requireLib$9(), p = requireDerivationSchema$8();
  var a;
  (function(b) {
    b[b.schemas = 1] = "schemas";
  })(a || (a = {}));
  class A extends c.RegistryItem {
    constructor(F) {
      super(), this.schemas = F, this.getRegistryType = () => n.RegistryTypes.KEY_DERIVATION_CALL, this.getSchemas = () => this.schemas, this.toDataItem = () => {
        const le = {};
        return le[a.schemas] = this.schemas.map((L) => {
          const pe = L.toDataItem();
          return pe.setTag(L.getRegistryType().getTag()), pe;
        }), new u.DataItem(le);
      };
    }
  }
  return KeyDerivation$8.KeyDerivation = A, A.fromDataItem = (b) => {
    const le = b.getData()[a.schemas].map((L) => p.KeyDerivationSchema.fromDataItem(L));
    return new A(le);
  }, A.fromCBOR = (b) => {
    const F = (0, u.decodeToDataItem)(b);
    return A.fromDataItem(F);
  }, KeyDerivation$8;
}
var hasRequiredQRHardwareCall$8;
function requireQRHardwareCall$8() {
  return hasRequiredQRHardwareCall$8 || (hasRequiredQRHardwareCall$8 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.QRHardwareCall = n.QRHardwareCallType = void 0;
    const c = requireRegistryType$8(), u = requireRegistryItem$8(), p = requireLib$9(), a = requireKeyDerivation$8();
    var A;
    (function(le) {
      le[le.type = 1] = "type", le[le.params = 2] = "params", le[le.origin = 3] = "origin";
    })(A || (A = {}));
    var b;
    (function(le) {
      le[le.KeyDerivation = 0] = "KeyDerivation";
    })(b = n.QRHardwareCallType || (n.QRHardwareCallType = {}));
    class F extends u.RegistryItem {
      constructor(L, pe, $) {
        super(), this.type = L, this.params = pe, this.origin = $, this.getRegistryType = () => c.RegistryTypes.QR_HARDWARE_CALL, this.getType = () => this.type, this.getParams = () => this.params, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const Ee = {};
          Ee[A.type] = this.type;
          const be = this.params.toDataItem();
          return be.setTag(this.params.getRegistryType().getTag()), Ee[A.params] = be, this.origin && (Ee[A.origin] = this.origin), new p.DataItem(Ee);
        };
      }
    }
    n.QRHardwareCall = F, F.fromDataItem = (le) => {
      const L = le.getData(), pe = L[A.type] || b.KeyDerivation;
      let $;
      switch (pe) {
        case b.KeyDerivation:
          $ = a.KeyDerivation.fromDataItem(L[A.params]);
      }
      const Ee = L[A.origin];
      return new F(pe, $, Ee);
    }, F.fromCBOR = (le) => {
      const L = (0, p.decodeToDataItem)(le);
      return F.fromDataItem(L);
    };
  }(QRHardwareCall$8)), QRHardwareCall$8;
}
var types$e = {}, hasRequiredTypes$9;
function requireTypes$9() {
  return hasRequiredTypes$9 || (hasRequiredTypes$9 = 1, Object.defineProperty(types$e, "__esModule", { value: !0 })), types$e;
}
var hasRequiredDist$8;
function requireDist$8() {
  return hasRequiredDist$8 || (hasRequiredDist$8 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.Buffer = n.extend = n.PathComponent = n.ScriptExpressions = n.MultiKey = n.CryptoPSBT = n.CryptoOutput = n.CryptoECKey = n.CryptoCoinInfoNetwork = n.CryptoCoinInfoType = n.CryptoCoinInfo = n.CryptoKeypath = n.CryptoMultiAccounts = n.CryptoHDKey = n.CryptoAccount = n.Bytes = n.URRegistryDecoder = n.DataItem = void 0;
    const c = require$$0$4;
    requirePatchCBOR$8();
    const u = dist$u;
    Object.defineProperty(n, "Buffer", { enumerable: !0, get: function() {
      return u.Buffer;
    } });
    const p = requireCryptoHDKey$8();
    Object.defineProperty(n, "CryptoHDKey", { enumerable: !0, get: function() {
      return p.CryptoHDKey;
    } });
    const a = requireCryptoKeypath$8();
    Object.defineProperty(n, "CryptoKeypath", { enumerable: !0, get: function() {
      return a.CryptoKeypath;
    } });
    const A = requireCryptoCoinInfo$8();
    Object.defineProperty(n, "CryptoCoinInfo", { enumerable: !0, get: function() {
      return A.CryptoCoinInfo;
    } }), Object.defineProperty(n, "CryptoCoinInfoType", { enumerable: !0, get: function() {
      return A.Type;
    } }), Object.defineProperty(n, "CryptoCoinInfoNetwork", { enumerable: !0, get: function() {
      return A.Network;
    } });
    const b = requireCryptoECKey$8();
    Object.defineProperty(n, "CryptoECKey", { enumerable: !0, get: function() {
      return b.CryptoECKey;
    } });
    const F = requireBytes$9();
    Object.defineProperty(n, "Bytes", { enumerable: !0, get: function() {
      return F.Bytes;
    } });
    const le = requireCryptoOutput$8();
    Object.defineProperty(n, "CryptoOutput", { enumerable: !0, get: function() {
      return le.CryptoOutput;
    } });
    const L = requireCryptoPSBT$8();
    Object.defineProperty(n, "CryptoPSBT", { enumerable: !0, get: function() {
      return L.CryptoPSBT;
    } });
    const pe = requireCryptoAccount$8();
    Object.defineProperty(n, "CryptoAccount", { enumerable: !0, get: function() {
      return pe.CryptoAccount;
    } });
    const $ = requireDecoder$8();
    Object.defineProperty(n, "URRegistryDecoder", { enumerable: !0, get: function() {
      return $.URRegistryDecoder;
    } });
    const Ee = requireMultiKey$8();
    Object.defineProperty(n, "MultiKey", { enumerable: !0, get: function() {
      return Ee.MultiKey;
    } });
    const be = requireScriptExpression$8();
    Object.defineProperty(n, "ScriptExpressions", { enumerable: !0, get: function() {
      return be.ScriptExpressions;
    } });
    const He = requirePathComponent$8();
    Object.defineProperty(n, "PathComponent", { enumerable: !0, get: function() {
      return He.PathComponent;
    } });
    const Pe = requireRegistryItem$8(), nr = requireRegistryType$8(), ir = requireLib$9();
    var or = requireLib$9();
    Object.defineProperty(n, "DataItem", { enumerable: !0, get: function() {
      return or.DataItem;
    } });
    const lr = requireUtils$b(), Ir = requireCryptoMultiAccounts$8();
    Object.defineProperty(n, "CryptoMultiAccounts", { enumerable: !0, get: function() {
      return Ir.CryptoMultiAccounts;
    } });
    const xr = {
      URRegistryDecoder: $.URRegistryDecoder,
      Bytes: F.Bytes,
      CryptoAccount: pe.CryptoAccount,
      CryptoHDKey: p.CryptoHDKey,
      CryptoMultiAccounts: Ir.CryptoMultiAccounts,
      CryptoKeypath: a.CryptoKeypath,
      CryptoCoinInfo: A.CryptoCoinInfo,
      CryptoCoinInfoType: A.Type,
      CryptoCoinInfoNetwork: A.Network,
      CryptoECKey: b.CryptoECKey,
      CryptoOutput: le.CryptoOutput,
      CryptoPSBT: L.CryptoPSBT,
      MultiKey: Ee.MultiKey,
      ScriptExpressions: be.ScriptExpressions,
      PathComponent: He.PathComponent
    }, kr = {
      addReader: ir.addReader,
      addSemanticDecode: ir.addSemanticDecode,
      addSemanticEncode: ir.addSemanticEncode,
      addWriter: ir.addWriter,
      patchTags: lr.patchTags
    }, Ce = {
      RegistryTypes: nr.RegistryTypes,
      RegistryItem: Pe.RegistryItem,
      RegistryType: nr.RegistryType,
      decodeToDataItem: ir.decodeToDataItem,
      encodeDataItem: ir.encodeDataItem,
      cbor: kr
    };
    n.extend = Ce, (0, c.__exportStar)(requireErrors$8(), n), (0, c.__exportStar)(requireDecoder$8(), n), (0, c.__exportStar)(requireLib$9(), n), (0, c.__exportStar)(requireCryptoAccount$8(), n), (0, c.__exportStar)(requireCryptoPSBT$8(), n), (0, c.__exportStar)(requireCryptoHDKey$8(), n), (0, c.__exportStar)(requireCryptoMultiAccounts$8(), n), (0, c.__exportStar)(requireQRHardwareCall$8(), n), (0, c.__exportStar)(requireKeyDerivation$8(), n), (0, c.__exportStar)(requireDerivationSchema$8(), n), (0, c.__exportStar)(requireCryptoOutput$8(), n), (0, c.__exportStar)(requireCryptoCoinInfo$8(), n), (0, c.__exportStar)(requireCryptoECKey$8(), n), (0, c.__exportStar)(requireMultiKey$8(), n), (0, c.__exportStar)(requireCryptoKeypath$8(), n), (0, c.__exportStar)(requirePatchCBOR$8(), n), (0, c.__exportStar)(requirePathComponent$8(), n), (0, c.__exportStar)(requireRegistryItem$8(), n), (0, c.__exportStar)(requireRegistryType$8(), n), (0, c.__exportStar)(requireTypes$9(), n), (0, c.__exportStar)(requireUtils$b(), n), n.default = xr;
  }(dist$l)), dist$l;
}
var getRandomValues$9, rnds8$7 = new Uint8Array(16);
function rng$9() {
  if (!getRandomValues$9 && (getRandomValues$9 = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !getRandomValues$9))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return getRandomValues$9(rnds8$7);
}
const REGEX$6 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function validate$9(n) {
  return typeof n == "string" && REGEX$6.test(n);
}
var byteToHex$7 = [];
for (var i$8 = 0; i$8 < 256; ++i$8)
  byteToHex$7.push((i$8 + 256).toString(16).substr(1));
function stringify$8(n) {
  var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, u = (byteToHex$7[n[c + 0]] + byteToHex$7[n[c + 1]] + byteToHex$7[n[c + 2]] + byteToHex$7[n[c + 3]] + "-" + byteToHex$7[n[c + 4]] + byteToHex$7[n[c + 5]] + "-" + byteToHex$7[n[c + 6]] + byteToHex$7[n[c + 7]] + "-" + byteToHex$7[n[c + 8]] + byteToHex$7[n[c + 9]] + "-" + byteToHex$7[n[c + 10]] + byteToHex$7[n[c + 11]] + byteToHex$7[n[c + 12]] + byteToHex$7[n[c + 13]] + byteToHex$7[n[c + 14]] + byteToHex$7[n[c + 15]]).toLowerCase();
  if (!validate$9(u))
    throw TypeError("Stringified UUID is invalid");
  return u;
}
var _nodeId$6, _clockseq$6, _lastMSecs$6 = 0, _lastNSecs$6 = 0;
function v1$8(n, c, u) {
  var p = c && u || 0, a = c || new Array(16);
  n = n || {};
  var A = n.node || _nodeId$6, b = n.clockseq !== void 0 ? n.clockseq : _clockseq$6;
  if (A == null || b == null) {
    var F = n.random || (n.rng || rng$9)();
    A == null && (A = _nodeId$6 = [F[0] | 1, F[1], F[2], F[3], F[4], F[5]]), b == null && (b = _clockseq$6 = (F[6] << 8 | F[7]) & 16383);
  }
  var le = n.msecs !== void 0 ? n.msecs : Date.now(), L = n.nsecs !== void 0 ? n.nsecs : _lastNSecs$6 + 1, pe = le - _lastMSecs$6 + (L - _lastNSecs$6) / 1e4;
  if (pe < 0 && n.clockseq === void 0 && (b = b + 1 & 16383), (pe < 0 || le > _lastMSecs$6) && n.nsecs === void 0 && (L = 0), L >= 1e4)
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  _lastMSecs$6 = le, _lastNSecs$6 = L, _clockseq$6 = b, le += 122192928e5;
  var $ = ((le & 268435455) * 1e4 + L) % 4294967296;
  a[p++] = $ >>> 24 & 255, a[p++] = $ >>> 16 & 255, a[p++] = $ >>> 8 & 255, a[p++] = $ & 255;
  var Ee = le / 4294967296 * 1e4 & 268435455;
  a[p++] = Ee >>> 8 & 255, a[p++] = Ee & 255, a[p++] = Ee >>> 24 & 15 | 16, a[p++] = Ee >>> 16 & 255, a[p++] = b >>> 8 | 128, a[p++] = b & 255;
  for (var be = 0; be < 6; ++be)
    a[p + be] = A[be];
  return c || stringify$8(a);
}
function parse$f(n) {
  if (!validate$9(n))
    throw TypeError("Invalid UUID");
  var c, u = new Uint8Array(16);
  return u[0] = (c = parseInt(n.slice(0, 8), 16)) >>> 24, u[1] = c >>> 16 & 255, u[2] = c >>> 8 & 255, u[3] = c & 255, u[4] = (c = parseInt(n.slice(9, 13), 16)) >>> 8, u[5] = c & 255, u[6] = (c = parseInt(n.slice(14, 18), 16)) >>> 8, u[7] = c & 255, u[8] = (c = parseInt(n.slice(19, 23), 16)) >>> 8, u[9] = c & 255, u[10] = (c = parseInt(n.slice(24, 36), 16)) / 1099511627776 & 255, u[11] = c / 4294967296 & 255, u[12] = c >>> 24 & 255, u[13] = c >>> 16 & 255, u[14] = c >>> 8 & 255, u[15] = c & 255, u;
}
function stringToBytes$7(n) {
  n = unescape(encodeURIComponent(n));
  for (var c = [], u = 0; u < n.length; ++u)
    c.push(n.charCodeAt(u));
  return c;
}
var DNS$6 = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", URL$7 = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
function v35$8(n, c, u) {
  function p(a, A, b, F) {
    if (typeof a == "string" && (a = stringToBytes$7(a)), typeof A == "string" && (A = parse$f(A)), A.length !== 16)
      throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    var le = new Uint8Array(16 + a.length);
    if (le.set(A), le.set(a, A.length), le = u(le), le[6] = le[6] & 15 | c, le[8] = le[8] & 63 | 128, b) {
      F = F || 0;
      for (var L = 0; L < 16; ++L)
        b[F + L] = le[L];
      return b;
    }
    return stringify$8(le);
  }
  try {
    p.name = n;
  } catch {
  }
  return p.DNS = DNS$6, p.URL = URL$7, p;
}
function md5$a(n) {
  if (typeof n == "string") {
    var c = unescape(encodeURIComponent(n));
    n = new Uint8Array(c.length);
    for (var u = 0; u < c.length; ++u)
      n[u] = c.charCodeAt(u);
  }
  return md5ToHexEncodedArray$6(wordsToMd5$6(bytesToWords$6(n), n.length * 8));
}
function md5ToHexEncodedArray$6(n) {
  for (var c = [], u = n.length * 32, p = "0123456789abcdef", a = 0; a < u; a += 8) {
    var A = n[a >> 5] >>> a % 32 & 255, b = parseInt(p.charAt(A >>> 4 & 15) + p.charAt(A & 15), 16);
    c.push(b);
  }
  return c;
}
function getOutputLength$6(n) {
  return (n + 64 >>> 9 << 4) + 14 + 1;
}
function wordsToMd5$6(n, c) {
  n[c >> 5] |= 128 << c % 32, n[getOutputLength$6(c) - 1] = c;
  for (var u = 1732584193, p = -271733879, a = -1732584194, A = 271733878, b = 0; b < n.length; b += 16) {
    var F = u, le = p, L = a, pe = A;
    u = md5ff$6(u, p, a, A, n[b], 7, -680876936), A = md5ff$6(A, u, p, a, n[b + 1], 12, -389564586), a = md5ff$6(a, A, u, p, n[b + 2], 17, 606105819), p = md5ff$6(p, a, A, u, n[b + 3], 22, -1044525330), u = md5ff$6(u, p, a, A, n[b + 4], 7, -176418897), A = md5ff$6(A, u, p, a, n[b + 5], 12, 1200080426), a = md5ff$6(a, A, u, p, n[b + 6], 17, -1473231341), p = md5ff$6(p, a, A, u, n[b + 7], 22, -45705983), u = md5ff$6(u, p, a, A, n[b + 8], 7, 1770035416), A = md5ff$6(A, u, p, a, n[b + 9], 12, -1958414417), a = md5ff$6(a, A, u, p, n[b + 10], 17, -42063), p = md5ff$6(p, a, A, u, n[b + 11], 22, -1990404162), u = md5ff$6(u, p, a, A, n[b + 12], 7, 1804603682), A = md5ff$6(A, u, p, a, n[b + 13], 12, -40341101), a = md5ff$6(a, A, u, p, n[b + 14], 17, -1502002290), p = md5ff$6(p, a, A, u, n[b + 15], 22, 1236535329), u = md5gg$6(u, p, a, A, n[b + 1], 5, -165796510), A = md5gg$6(A, u, p, a, n[b + 6], 9, -1069501632), a = md5gg$6(a, A, u, p, n[b + 11], 14, 643717713), p = md5gg$6(p, a, A, u, n[b], 20, -373897302), u = md5gg$6(u, p, a, A, n[b + 5], 5, -701558691), A = md5gg$6(A, u, p, a, n[b + 10], 9, 38016083), a = md5gg$6(a, A, u, p, n[b + 15], 14, -660478335), p = md5gg$6(p, a, A, u, n[b + 4], 20, -405537848), u = md5gg$6(u, p, a, A, n[b + 9], 5, 568446438), A = md5gg$6(A, u, p, a, n[b + 14], 9, -1019803690), a = md5gg$6(a, A, u, p, n[b + 3], 14, -187363961), p = md5gg$6(p, a, A, u, n[b + 8], 20, 1163531501), u = md5gg$6(u, p, a, A, n[b + 13], 5, -1444681467), A = md5gg$6(A, u, p, a, n[b + 2], 9, -51403784), a = md5gg$6(a, A, u, p, n[b + 7], 14, 1735328473), p = md5gg$6(p, a, A, u, n[b + 12], 20, -1926607734), u = md5hh$6(u, p, a, A, n[b + 5], 4, -378558), A = md5hh$6(A, u, p, a, n[b + 8], 11, -2022574463), a = md5hh$6(a, A, u, p, n[b + 11], 16, 1839030562), p = md5hh$6(p, a, A, u, n[b + 14], 23, -35309556), u = md5hh$6(u, p, a, A, n[b + 1], 4, -1530992060), A = md5hh$6(A, u, p, a, n[b + 4], 11, 1272893353), a = md5hh$6(a, A, u, p, n[b + 7], 16, -155497632), p = md5hh$6(p, a, A, u, n[b + 10], 23, -1094730640), u = md5hh$6(u, p, a, A, n[b + 13], 4, 681279174), A = md5hh$6(A, u, p, a, n[b], 11, -358537222), a = md5hh$6(a, A, u, p, n[b + 3], 16, -722521979), p = md5hh$6(p, a, A, u, n[b + 6], 23, 76029189), u = md5hh$6(u, p, a, A, n[b + 9], 4, -640364487), A = md5hh$6(A, u, p, a, n[b + 12], 11, -421815835), a = md5hh$6(a, A, u, p, n[b + 15], 16, 530742520), p = md5hh$6(p, a, A, u, n[b + 2], 23, -995338651), u = md5ii$6(u, p, a, A, n[b], 6, -198630844), A = md5ii$6(A, u, p, a, n[b + 7], 10, 1126891415), a = md5ii$6(a, A, u, p, n[b + 14], 15, -1416354905), p = md5ii$6(p, a, A, u, n[b + 5], 21, -57434055), u = md5ii$6(u, p, a, A, n[b + 12], 6, 1700485571), A = md5ii$6(A, u, p, a, n[b + 3], 10, -1894986606), a = md5ii$6(a, A, u, p, n[b + 10], 15, -1051523), p = md5ii$6(p, a, A, u, n[b + 1], 21, -2054922799), u = md5ii$6(u, p, a, A, n[b + 8], 6, 1873313359), A = md5ii$6(A, u, p, a, n[b + 15], 10, -30611744), a = md5ii$6(a, A, u, p, n[b + 6], 15, -1560198380), p = md5ii$6(p, a, A, u, n[b + 13], 21, 1309151649), u = md5ii$6(u, p, a, A, n[b + 4], 6, -145523070), A = md5ii$6(A, u, p, a, n[b + 11], 10, -1120210379), a = md5ii$6(a, A, u, p, n[b + 2], 15, 718787259), p = md5ii$6(p, a, A, u, n[b + 9], 21, -343485551), u = safeAdd$6(u, F), p = safeAdd$6(p, le), a = safeAdd$6(a, L), A = safeAdd$6(A, pe);
  }
  return [u, p, a, A];
}
function bytesToWords$6(n) {
  if (n.length === 0)
    return [];
  for (var c = n.length * 8, u = new Uint32Array(getOutputLength$6(c)), p = 0; p < c; p += 8)
    u[p >> 5] |= (n[p / 8] & 255) << p % 32;
  return u;
}
function safeAdd$6(n, c) {
  var u = (n & 65535) + (c & 65535), p = (n >> 16) + (c >> 16) + (u >> 16);
  return p << 16 | u & 65535;
}
function bitRotateLeft$6(n, c) {
  return n << c | n >>> 32 - c;
}
function md5cmn$6(n, c, u, p, a, A) {
  return safeAdd$6(bitRotateLeft$6(safeAdd$6(safeAdd$6(c, n), safeAdd$6(p, A)), a), u);
}
function md5ff$6(n, c, u, p, a, A, b) {
  return md5cmn$6(c & u | ~c & p, n, c, a, A, b);
}
function md5gg$6(n, c, u, p, a, A, b) {
  return md5cmn$6(c & p | u & ~p, n, c, a, A, b);
}
function md5hh$6(n, c, u, p, a, A, b) {
  return md5cmn$6(c ^ u ^ p, n, c, a, A, b);
}
function md5ii$6(n, c, u, p, a, A, b) {
  return md5cmn$6(u ^ (c | ~p), n, c, a, A, b);
}
var v3$8 = v35$8("v3", 48, md5$a);
function v4$9(n, c, u) {
  n = n || {};
  var p = n.random || (n.rng || rng$9)();
  if (p[6] = p[6] & 15 | 64, p[8] = p[8] & 63 | 128, c) {
    u = u || 0;
    for (var a = 0; a < 16; ++a)
      c[u + a] = p[a];
    return c;
  }
  return stringify$8(p);
}
function f$9(n, c, u, p) {
  switch (n) {
    case 0:
      return c & u ^ ~c & p;
    case 1:
      return c ^ u ^ p;
    case 2:
      return c & u ^ c & p ^ u & p;
    case 3:
      return c ^ u ^ p;
  }
}
function ROTL$6(n, c) {
  return n << c | n >>> 32 - c;
}
function sha1$8(n) {
  var c = [1518500249, 1859775393, 2400959708, 3395469782], u = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
  if (typeof n == "string") {
    var p = unescape(encodeURIComponent(n));
    n = [];
    for (var a = 0; a < p.length; ++a)
      n.push(p.charCodeAt(a));
  } else Array.isArray(n) || (n = Array.prototype.slice.call(n));
  n.push(128);
  for (var A = n.length / 4 + 2, b = Math.ceil(A / 16), F = new Array(b), le = 0; le < b; ++le) {
    for (var L = new Uint32Array(16), pe = 0; pe < 16; ++pe)
      L[pe] = n[le * 64 + pe * 4] << 24 | n[le * 64 + pe * 4 + 1] << 16 | n[le * 64 + pe * 4 + 2] << 8 | n[le * 64 + pe * 4 + 3];
    F[le] = L;
  }
  F[b - 1][14] = (n.length - 1) * 8 / Math.pow(2, 32), F[b - 1][14] = Math.floor(F[b - 1][14]), F[b - 1][15] = (n.length - 1) * 8 & 4294967295;
  for (var $ = 0; $ < b; ++$) {
    for (var Ee = new Uint32Array(80), be = 0; be < 16; ++be)
      Ee[be] = F[$][be];
    for (var He = 16; He < 80; ++He)
      Ee[He] = ROTL$6(Ee[He - 3] ^ Ee[He - 8] ^ Ee[He - 14] ^ Ee[He - 16], 1);
    for (var Pe = u[0], nr = u[1], ir = u[2], or = u[3], lr = u[4], Ir = 0; Ir < 80; ++Ir) {
      var xr = Math.floor(Ir / 20), kr = ROTL$6(Pe, 5) + f$9(xr, nr, ir, or) + lr + c[xr] + Ee[Ir] >>> 0;
      lr = or, or = ir, ir = ROTL$6(nr, 30) >>> 0, nr = Pe, Pe = kr;
    }
    u[0] = u[0] + Pe >>> 0, u[1] = u[1] + nr >>> 0, u[2] = u[2] + ir >>> 0, u[3] = u[3] + or >>> 0, u[4] = u[4] + lr >>> 0;
  }
  return [u[0] >> 24 & 255, u[0] >> 16 & 255, u[0] >> 8 & 255, u[0] & 255, u[1] >> 24 & 255, u[1] >> 16 & 255, u[1] >> 8 & 255, u[1] & 255, u[2] >> 24 & 255, u[2] >> 16 & 255, u[2] >> 8 & 255, u[2] & 255, u[3] >> 24 & 255, u[3] >> 16 & 255, u[3] >> 8 & 255, u[3] & 255, u[4] >> 24 & 255, u[4] >> 16 & 255, u[4] >> 8 & 255, u[4] & 255];
}
var v5$8 = v35$8("v5", 80, sha1$8);
const nil$8 = "00000000-0000-0000-0000-000000000000";
function version$a(n) {
  if (!validate$9(n))
    throw TypeError("Invalid UUID");
  return parseInt(n.substr(14, 1), 16);
}
const esmBrowser$6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  NIL: nil$8,
  parse: parse$f,
  stringify: stringify$8,
  v1: v1$8,
  v3: v3$8,
  v4: v4$9,
  v5: v5$8,
  validate: validate$9,
  version: version$a
}, Symbol.toStringTag, { value: "Module" })), require$$1$8 = /* @__PURE__ */ getAugmentedNamespace(esmBrowser$6);
var cryptoBrowserify = {}, browser$9 = { exports: {} }, hasRequiredBrowser$9;
function requireBrowser$9() {
  if (hasRequiredBrowser$9) return browser$9.exports;
  hasRequiredBrowser$9 = 1;
  var n = 65536, c = 4294967295;
  function u() {
    throw new Error(`Secure random number generation is not supported by this browser.
Use Chrome, Firefox or Internet Explorer 11`);
  }
  var p = safeBufferExports.Buffer, a = commonjsGlobal.crypto || commonjsGlobal.msCrypto;
  a && a.getRandomValues ? browser$9.exports = A : browser$9.exports = u;
  function A(b, F) {
    if (b > c) throw new RangeError("requested too many random bytes");
    var le = p.allocUnsafe(b);
    if (b > 0)
      if (b > n)
        for (var L = 0; L < b; L += n)
          a.getRandomValues(le.slice(L, L + n));
      else
        a.getRandomValues(le);
    return typeof F == "function" ? process$1.nextTick(function() {
      F(null, le);
    }) : le;
  }
  return browser$9.exports;
}
var legacy, hasRequiredLegacy;
function requireLegacy() {
  if (hasRequiredLegacy) return legacy;
  hasRequiredLegacy = 1;
  var n = inherits_browserExports, c = safeBufferExports.Buffer, u = cipherBase, p = c.alloc(128), a = 64;
  function A(b, F) {
    u.call(this, "digest"), typeof F == "string" && (F = c.from(F)), this._alg = b, this._key = F, F.length > a ? F = b(F) : F.length < a && (F = c.concat([F, p], a));
    for (var le = this._ipad = c.allocUnsafe(a), L = this._opad = c.allocUnsafe(a), pe = 0; pe < a; pe++)
      le[pe] = F[pe] ^ 54, L[pe] = F[pe] ^ 92;
    this._hash = [le];
  }
  return n(A, u), A.prototype._update = function(b) {
    this._hash.push(b);
  }, A.prototype._final = function() {
    var b = this._alg(c.concat(this._hash));
    return this._alg(c.concat([this._opad, b]));
  }, legacy = A, legacy;
}
var md5$9, hasRequiredMd5$3;
function requireMd5$3() {
  if (hasRequiredMd5$3) return md5$9;
  hasRequiredMd5$3 = 1;
  var n = md5_js;
  return md5$9 = function(c) {
    return new n().update(c).digest();
  }, md5$9;
}
var browser$8, hasRequiredBrowser$8;
function requireBrowser$8() {
  if (hasRequiredBrowser$8) return browser$8;
  hasRequiredBrowser$8 = 1;
  var n = inherits_browserExports, c = requireLegacy(), u = cipherBase, p = safeBufferExports.Buffer, a = requireMd5$3(), A = ripemd160$5, b = sha_jsExports, F = p.alloc(128);
  function le(L, pe) {
    u.call(this, "digest"), typeof pe == "string" && (pe = p.from(pe));
    var $ = L === "sha512" || L === "sha384" ? 128 : 64;
    if (this._alg = L, this._key = pe, pe.length > $) {
      var Ee = L === "rmd160" ? new A() : b(L);
      pe = Ee.update(pe).digest();
    } else pe.length < $ && (pe = p.concat([pe, F], $));
    for (var be = this._ipad = p.allocUnsafe($), He = this._opad = p.allocUnsafe($), Pe = 0; Pe < $; Pe++)
      be[Pe] = pe[Pe] ^ 54, He[Pe] = pe[Pe] ^ 92;
    this._hash = L === "rmd160" ? new A() : b(L), this._hash.update(be);
  }
  return n(le, u), le.prototype._update = function(L) {
    this._hash.update(L);
  }, le.prototype._final = function() {
    var L = this._hash.digest(), pe = this._alg === "rmd160" ? new A() : b(this._alg);
    return pe.update(this._opad).update(L).digest();
  }, browser$8 = function(pe, $) {
    return pe = pe.toLowerCase(), pe === "rmd160" || pe === "ripemd160" ? new le("rmd160", $) : pe === "md5" ? new c(a, $) : new le(pe, $);
  }, browser$8;
}
const sha224WithRSAEncryption = {
  sign: "rsa",
  hash: "sha224",
  id: "302d300d06096086480165030402040500041c"
}, sha256WithRSAEncryption = {
  sign: "rsa",
  hash: "sha256",
  id: "3031300d060960864801650304020105000420"
}, sha384WithRSAEncryption = {
  sign: "rsa",
  hash: "sha384",
  id: "3041300d060960864801650304020205000430"
}, sha512WithRSAEncryption = {
  sign: "rsa",
  hash: "sha512",
  id: "3051300d060960864801650304020305000440"
}, sha256$c = {
  sign: "ecdsa",
  hash: "sha256",
  id: ""
}, sha224 = {
  sign: "ecdsa",
  hash: "sha224",
  id: ""
}, sha384 = {
  sign: "ecdsa",
  hash: "sha384",
  id: ""
}, sha512$4 = {
  sign: "ecdsa",
  hash: "sha512",
  id: ""
}, DSA = {
  sign: "dsa",
  hash: "sha1",
  id: ""
}, ripemd160WithRSA = {
  sign: "rsa",
  hash: "rmd160",
  id: "3021300906052b2403020105000414"
}, md5WithRSAEncryption = {
  sign: "rsa",
  hash: "md5",
  id: "3020300c06082a864886f70d020505000410"
}, require$$6 = {
  sha224WithRSAEncryption,
  "RSA-SHA224": {
    sign: "ecdsa/rsa",
    hash: "sha224",
    id: "302d300d06096086480165030402040500041c"
  },
  sha256WithRSAEncryption,
  "RSA-SHA256": {
    sign: "ecdsa/rsa",
    hash: "sha256",
    id: "3031300d060960864801650304020105000420"
  },
  sha384WithRSAEncryption,
  "RSA-SHA384": {
    sign: "ecdsa/rsa",
    hash: "sha384",
    id: "3041300d060960864801650304020205000430"
  },
  sha512WithRSAEncryption,
  "RSA-SHA512": {
    sign: "ecdsa/rsa",
    hash: "sha512",
    id: "3051300d060960864801650304020305000440"
  },
  "RSA-SHA1": {
    sign: "rsa",
    hash: "sha1",
    id: "3021300906052b0e03021a05000414"
  },
  "ecdsa-with-SHA1": {
    sign: "ecdsa",
    hash: "sha1",
    id: ""
  },
  sha256: sha256$c,
  sha224,
  sha384,
  sha512: sha512$4,
  "DSA-SHA": {
    sign: "dsa",
    hash: "sha1",
    id: ""
  },
  "DSA-SHA1": {
    sign: "dsa",
    hash: "sha1",
    id: ""
  },
  DSA,
  "DSA-WITH-SHA224": {
    sign: "dsa",
    hash: "sha224",
    id: ""
  },
  "DSA-SHA224": {
    sign: "dsa",
    hash: "sha224",
    id: ""
  },
  "DSA-WITH-SHA256": {
    sign: "dsa",
    hash: "sha256",
    id: ""
  },
  "DSA-SHA256": {
    sign: "dsa",
    hash: "sha256",
    id: ""
  },
  "DSA-WITH-SHA384": {
    sign: "dsa",
    hash: "sha384",
    id: ""
  },
  "DSA-SHA384": {
    sign: "dsa",
    hash: "sha384",
    id: ""
  },
  "DSA-WITH-SHA512": {
    sign: "dsa",
    hash: "sha512",
    id: ""
  },
  "DSA-SHA512": {
    sign: "dsa",
    hash: "sha512",
    id: ""
  },
  "DSA-RIPEMD160": {
    sign: "dsa",
    hash: "rmd160",
    id: ""
  },
  ripemd160WithRSA,
  "RSA-RIPEMD160": {
    sign: "rsa",
    hash: "rmd160",
    id: "3021300906052b2403020105000414"
  },
  md5WithRSAEncryption,
  "RSA-MD5": {
    sign: "rsa",
    hash: "md5",
    id: "3020300c06082a864886f70d020505000410"
  }
};
var algos, hasRequiredAlgos;
function requireAlgos() {
  return hasRequiredAlgos || (hasRequiredAlgos = 1, algos = require$$6), algos;
}
var browser$7 = {}, precondition, hasRequiredPrecondition;
function requirePrecondition() {
  if (hasRequiredPrecondition) return precondition;
  hasRequiredPrecondition = 1;
  var n = Math.pow(2, 30) - 1;
  return precondition = function(c, u) {
    if (typeof c != "number")
      throw new TypeError("Iterations not a number");
    if (c < 0)
      throw new TypeError("Bad iterations");
    if (typeof u != "number")
      throw new TypeError("Key length not a number");
    if (u < 0 || u > n || u !== u)
      throw new TypeError("Bad key length");
  }, precondition;
}
var defaultEncoding_1, hasRequiredDefaultEncoding;
function requireDefaultEncoding() {
  if (hasRequiredDefaultEncoding) return defaultEncoding_1;
  hasRequiredDefaultEncoding = 1;
  var n;
  if (commonjsGlobal.process && commonjsGlobal.process.browser)
    n = "utf-8";
  else if (commonjsGlobal.process && commonjsGlobal.process.version) {
    var c = parseInt(process$1.version.split(".")[0].slice(1), 10);
    n = c >= 6 ? "utf-8" : "binary";
  } else
    n = "utf-8";
  return defaultEncoding_1 = n, defaultEncoding_1;
}
var makeHash, hasRequiredMakeHash;
function requireMakeHash() {
  if (hasRequiredMakeHash) return makeHash;
  hasRequiredMakeHash = 1;
  var n = 4, c = new Buffer$f(n);
  c.fill(0);
  var u = 8, p = 16;
  function a(A) {
    if (A.length % n !== 0) {
      var b = A.length + (n - A.length % n);
      A = Buffer$f.concat([A, c], b);
    }
    for (var F = new Array(A.length >>> 2), le = 0, L = 0; le < A.length; le += n, L++)
      F[L] = A.readInt32LE(le);
    return F;
  }
  return makeHash = function(b, F) {
    var le = F(a(b), b.length * u);
    b = new Buffer$f(p);
    for (var L = 0; L < le.length; L++)
      b.writeInt32LE(le[L], L << 2, !0);
    return b;
  }, makeHash;
}
var md5$8, hasRequiredMd5$2;
function requireMd5$2() {
  if (hasRequiredMd5$2) return md5$8;
  hasRequiredMd5$2 = 1;
  var n = requireMakeHash();
  function c(L, pe) {
    L[pe >> 5] |= 128 << pe % 32, L[(pe + 64 >>> 9 << 4) + 14] = pe;
    for (var $ = 1732584193, Ee = -271733879, be = -1732584194, He = 271733878, Pe = 0; Pe < L.length; Pe += 16) {
      var nr = $, ir = Ee, or = be, lr = He;
      $ = p($, Ee, be, He, L[Pe + 0], 7, -680876936), He = p(He, $, Ee, be, L[Pe + 1], 12, -389564586), be = p(be, He, $, Ee, L[Pe + 2], 17, 606105819), Ee = p(Ee, be, He, $, L[Pe + 3], 22, -1044525330), $ = p($, Ee, be, He, L[Pe + 4], 7, -176418897), He = p(He, $, Ee, be, L[Pe + 5], 12, 1200080426), be = p(be, He, $, Ee, L[Pe + 6], 17, -1473231341), Ee = p(Ee, be, He, $, L[Pe + 7], 22, -45705983), $ = p($, Ee, be, He, L[Pe + 8], 7, 1770035416), He = p(He, $, Ee, be, L[Pe + 9], 12, -1958414417), be = p(be, He, $, Ee, L[Pe + 10], 17, -42063), Ee = p(Ee, be, He, $, L[Pe + 11], 22, -1990404162), $ = p($, Ee, be, He, L[Pe + 12], 7, 1804603682), He = p(He, $, Ee, be, L[Pe + 13], 12, -40341101), be = p(be, He, $, Ee, L[Pe + 14], 17, -1502002290), Ee = p(Ee, be, He, $, L[Pe + 15], 22, 1236535329), $ = a($, Ee, be, He, L[Pe + 1], 5, -165796510), He = a(He, $, Ee, be, L[Pe + 6], 9, -1069501632), be = a(be, He, $, Ee, L[Pe + 11], 14, 643717713), Ee = a(Ee, be, He, $, L[Pe + 0], 20, -373897302), $ = a($, Ee, be, He, L[Pe + 5], 5, -701558691), He = a(He, $, Ee, be, L[Pe + 10], 9, 38016083), be = a(be, He, $, Ee, L[Pe + 15], 14, -660478335), Ee = a(Ee, be, He, $, L[Pe + 4], 20, -405537848), $ = a($, Ee, be, He, L[Pe + 9], 5, 568446438), He = a(He, $, Ee, be, L[Pe + 14], 9, -1019803690), be = a(be, He, $, Ee, L[Pe + 3], 14, -187363961), Ee = a(Ee, be, He, $, L[Pe + 8], 20, 1163531501), $ = a($, Ee, be, He, L[Pe + 13], 5, -1444681467), He = a(He, $, Ee, be, L[Pe + 2], 9, -51403784), be = a(be, He, $, Ee, L[Pe + 7], 14, 1735328473), Ee = a(Ee, be, He, $, L[Pe + 12], 20, -1926607734), $ = A($, Ee, be, He, L[Pe + 5], 4, -378558), He = A(He, $, Ee, be, L[Pe + 8], 11, -2022574463), be = A(be, He, $, Ee, L[Pe + 11], 16, 1839030562), Ee = A(Ee, be, He, $, L[Pe + 14], 23, -35309556), $ = A($, Ee, be, He, L[Pe + 1], 4, -1530992060), He = A(He, $, Ee, be, L[Pe + 4], 11, 1272893353), be = A(be, He, $, Ee, L[Pe + 7], 16, -155497632), Ee = A(Ee, be, He, $, L[Pe + 10], 23, -1094730640), $ = A($, Ee, be, He, L[Pe + 13], 4, 681279174), He = A(He, $, Ee, be, L[Pe + 0], 11, -358537222), be = A(be, He, $, Ee, L[Pe + 3], 16, -722521979), Ee = A(Ee, be, He, $, L[Pe + 6], 23, 76029189), $ = A($, Ee, be, He, L[Pe + 9], 4, -640364487), He = A(He, $, Ee, be, L[Pe + 12], 11, -421815835), be = A(be, He, $, Ee, L[Pe + 15], 16, 530742520), Ee = A(Ee, be, He, $, L[Pe + 2], 23, -995338651), $ = b($, Ee, be, He, L[Pe + 0], 6, -198630844), He = b(He, $, Ee, be, L[Pe + 7], 10, 1126891415), be = b(be, He, $, Ee, L[Pe + 14], 15, -1416354905), Ee = b(Ee, be, He, $, L[Pe + 5], 21, -57434055), $ = b($, Ee, be, He, L[Pe + 12], 6, 1700485571), He = b(He, $, Ee, be, L[Pe + 3], 10, -1894986606), be = b(be, He, $, Ee, L[Pe + 10], 15, -1051523), Ee = b(Ee, be, He, $, L[Pe + 1], 21, -2054922799), $ = b($, Ee, be, He, L[Pe + 8], 6, 1873313359), He = b(He, $, Ee, be, L[Pe + 15], 10, -30611744), be = b(be, He, $, Ee, L[Pe + 6], 15, -1560198380), Ee = b(Ee, be, He, $, L[Pe + 13], 21, 1309151649), $ = b($, Ee, be, He, L[Pe + 4], 6, -145523070), He = b(He, $, Ee, be, L[Pe + 11], 10, -1120210379), be = b(be, He, $, Ee, L[Pe + 2], 15, 718787259), Ee = b(Ee, be, He, $, L[Pe + 9], 21, -343485551), $ = F($, nr), Ee = F(Ee, ir), be = F(be, or), He = F(He, lr);
    }
    return [$, Ee, be, He];
  }
  function u(L, pe, $, Ee, be, He) {
    return F(le(F(F(pe, L), F(Ee, He)), be), $);
  }
  function p(L, pe, $, Ee, be, He, Pe) {
    return u(pe & $ | ~pe & Ee, L, pe, be, He, Pe);
  }
  function a(L, pe, $, Ee, be, He, Pe) {
    return u(pe & Ee | $ & ~Ee, L, pe, be, He, Pe);
  }
  function A(L, pe, $, Ee, be, He, Pe) {
    return u(pe ^ $ ^ Ee, L, pe, be, He, Pe);
  }
  function b(L, pe, $, Ee, be, He, Pe) {
    return u($ ^ (pe | ~Ee), L, pe, be, He, Pe);
  }
  function F(L, pe) {
    var $ = (L & 65535) + (pe & 65535), Ee = (L >> 16) + (pe >> 16) + ($ >> 16);
    return Ee << 16 | $ & 65535;
  }
  function le(L, pe) {
    return L << pe | L >>> 32 - pe;
  }
  return md5$8 = function(pe) {
    return n(pe, c);
  }, md5$8;
}
var hashBase, hasRequiredHashBase;
function requireHashBase() {
  if (hasRequiredHashBase) return hashBase;
  hasRequiredHashBase = 1;
  var n = streamBrowserify.Transform, c = inherits_browserExports;
  function u(p) {
    n.call(this), this._block = new Buffer$f(p), this._blockSize = p, this._blockOffset = 0, this._length = [0, 0, 0, 0], this._finalized = !1;
  }
  return c(u, n), u.prototype._transform = function(p, a, A) {
    var b = null;
    try {
      a !== "buffer" && (p = new Buffer$f(p, a)), this.update(p);
    } catch (F) {
      b = F;
    }
    A(b);
  }, u.prototype._flush = function(p) {
    var a = null;
    try {
      this.push(this._digest());
    } catch (A) {
      a = A;
    }
    p(a);
  }, u.prototype.update = function(p, a) {
    if (!Buffer$f.isBuffer(p) && typeof p != "string") throw new TypeError("Data must be a string or a buffer");
    if (this._finalized) throw new Error("Digest already called");
    Buffer$f.isBuffer(p) || (p = new Buffer$f(p, a || "binary"));
    for (var A = this._block, b = 0; this._blockOffset + p.length - b >= this._blockSize; ) {
      for (var F = this._blockOffset; F < this._blockSize; ) A[F++] = p[b++];
      this._update(), this._blockOffset = 0;
    }
    for (; b < p.length; ) A[this._blockOffset++] = p[b++];
    for (var le = 0, L = p.length * 8; L > 0; ++le)
      this._length[le] += L, L = this._length[le] / 4294967296 | 0, L > 0 && (this._length[le] -= 4294967296 * L);
    return this;
  }, u.prototype._update = function(p) {
    throw new Error("_update is not implemented");
  }, u.prototype.digest = function(p) {
    if (this._finalized) throw new Error("Digest already called");
    this._finalized = !0;
    var a = this._digest();
    return p !== void 0 && (a = a.toString(p)), a;
  }, u.prototype._digest = function() {
    throw new Error("_digest is not implemented");
  }, hashBase = u, hashBase;
}
var ripemd160$4, hasRequiredRipemd160;
function requireRipemd160() {
  if (hasRequiredRipemd160) return ripemd160$4;
  hasRequiredRipemd160 = 1;
  var n = inherits_browserExports, c = requireHashBase();
  function u() {
    c.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520;
  }
  n(u, c), u.prototype._update = function() {
    for (var L = new Array(16), pe = 0; pe < 16; ++pe) L[pe] = this._block.readInt32LE(pe * 4);
    var $ = this._a, Ee = this._b, be = this._c, He = this._d, Pe = this._e;
    $ = a($, Ee, be, He, Pe, L[0], 0, 11), be = p(be, 10), Pe = a(Pe, $, Ee, be, He, L[1], 0, 14), Ee = p(Ee, 10), He = a(He, Pe, $, Ee, be, L[2], 0, 15), $ = p($, 10), be = a(be, He, Pe, $, Ee, L[3], 0, 12), Pe = p(Pe, 10), Ee = a(Ee, be, He, Pe, $, L[4], 0, 5), He = p(He, 10), $ = a($, Ee, be, He, Pe, L[5], 0, 8), be = p(be, 10), Pe = a(Pe, $, Ee, be, He, L[6], 0, 7), Ee = p(Ee, 10), He = a(He, Pe, $, Ee, be, L[7], 0, 9), $ = p($, 10), be = a(be, He, Pe, $, Ee, L[8], 0, 11), Pe = p(Pe, 10), Ee = a(Ee, be, He, Pe, $, L[9], 0, 13), He = p(He, 10), $ = a($, Ee, be, He, Pe, L[10], 0, 14), be = p(be, 10), Pe = a(Pe, $, Ee, be, He, L[11], 0, 15), Ee = p(Ee, 10), He = a(He, Pe, $, Ee, be, L[12], 0, 6), $ = p($, 10), be = a(be, He, Pe, $, Ee, L[13], 0, 7), Pe = p(Pe, 10), Ee = a(Ee, be, He, Pe, $, L[14], 0, 9), He = p(He, 10), $ = a($, Ee, be, He, Pe, L[15], 0, 8), be = p(be, 10), Pe = A(Pe, $, Ee, be, He, L[7], 1518500249, 7), Ee = p(Ee, 10), He = A(He, Pe, $, Ee, be, L[4], 1518500249, 6), $ = p($, 10), be = A(be, He, Pe, $, Ee, L[13], 1518500249, 8), Pe = p(Pe, 10), Ee = A(Ee, be, He, Pe, $, L[1], 1518500249, 13), He = p(He, 10), $ = A($, Ee, be, He, Pe, L[10], 1518500249, 11), be = p(be, 10), Pe = A(Pe, $, Ee, be, He, L[6], 1518500249, 9), Ee = p(Ee, 10), He = A(He, Pe, $, Ee, be, L[15], 1518500249, 7), $ = p($, 10), be = A(be, He, Pe, $, Ee, L[3], 1518500249, 15), Pe = p(Pe, 10), Ee = A(Ee, be, He, Pe, $, L[12], 1518500249, 7), He = p(He, 10), $ = A($, Ee, be, He, Pe, L[0], 1518500249, 12), be = p(be, 10), Pe = A(Pe, $, Ee, be, He, L[9], 1518500249, 15), Ee = p(Ee, 10), He = A(He, Pe, $, Ee, be, L[5], 1518500249, 9), $ = p($, 10), be = A(be, He, Pe, $, Ee, L[2], 1518500249, 11), Pe = p(Pe, 10), Ee = A(Ee, be, He, Pe, $, L[14], 1518500249, 7), He = p(He, 10), $ = A($, Ee, be, He, Pe, L[11], 1518500249, 13), be = p(be, 10), Pe = A(Pe, $, Ee, be, He, L[8], 1518500249, 12), Ee = p(Ee, 10), He = b(He, Pe, $, Ee, be, L[3], 1859775393, 11), $ = p($, 10), be = b(be, He, Pe, $, Ee, L[10], 1859775393, 13), Pe = p(Pe, 10), Ee = b(Ee, be, He, Pe, $, L[14], 1859775393, 6), He = p(He, 10), $ = b($, Ee, be, He, Pe, L[4], 1859775393, 7), be = p(be, 10), Pe = b(Pe, $, Ee, be, He, L[9], 1859775393, 14), Ee = p(Ee, 10), He = b(He, Pe, $, Ee, be, L[15], 1859775393, 9), $ = p($, 10), be = b(be, He, Pe, $, Ee, L[8], 1859775393, 13), Pe = p(Pe, 10), Ee = b(Ee, be, He, Pe, $, L[1], 1859775393, 15), He = p(He, 10), $ = b($, Ee, be, He, Pe, L[2], 1859775393, 14), be = p(be, 10), Pe = b(Pe, $, Ee, be, He, L[7], 1859775393, 8), Ee = p(Ee, 10), He = b(He, Pe, $, Ee, be, L[0], 1859775393, 13), $ = p($, 10), be = b(be, He, Pe, $, Ee, L[6], 1859775393, 6), Pe = p(Pe, 10), Ee = b(Ee, be, He, Pe, $, L[13], 1859775393, 5), He = p(He, 10), $ = b($, Ee, be, He, Pe, L[11], 1859775393, 12), be = p(be, 10), Pe = b(Pe, $, Ee, be, He, L[5], 1859775393, 7), Ee = p(Ee, 10), He = b(He, Pe, $, Ee, be, L[12], 1859775393, 5), $ = p($, 10), be = F(be, He, Pe, $, Ee, L[1], 2400959708, 11), Pe = p(Pe, 10), Ee = F(Ee, be, He, Pe, $, L[9], 2400959708, 12), He = p(He, 10), $ = F($, Ee, be, He, Pe, L[11], 2400959708, 14), be = p(be, 10), Pe = F(Pe, $, Ee, be, He, L[10], 2400959708, 15), Ee = p(Ee, 10), He = F(He, Pe, $, Ee, be, L[0], 2400959708, 14), $ = p($, 10), be = F(be, He, Pe, $, Ee, L[8], 2400959708, 15), Pe = p(Pe, 10), Ee = F(Ee, be, He, Pe, $, L[12], 2400959708, 9), He = p(He, 10), $ = F($, Ee, be, He, Pe, L[4], 2400959708, 8), be = p(be, 10), Pe = F(Pe, $, Ee, be, He, L[13], 2400959708, 9), Ee = p(Ee, 10), He = F(He, Pe, $, Ee, be, L[3], 2400959708, 14), $ = p($, 10), be = F(be, He, Pe, $, Ee, L[7], 2400959708, 5), Pe = p(Pe, 10), Ee = F(Ee, be, He, Pe, $, L[15], 2400959708, 6), He = p(He, 10), $ = F($, Ee, be, He, Pe, L[14], 2400959708, 8), be = p(be, 10), Pe = F(Pe, $, Ee, be, He, L[5], 2400959708, 6), Ee = p(Ee, 10), He = F(He, Pe, $, Ee, be, L[6], 2400959708, 5), $ = p($, 10), be = F(be, He, Pe, $, Ee, L[2], 2400959708, 12), Pe = p(Pe, 10), Ee = le(Ee, be, He, Pe, $, L[4], 2840853838, 9), He = p(He, 10), $ = le($, Ee, be, He, Pe, L[0], 2840853838, 15), be = p(be, 10), Pe = le(Pe, $, Ee, be, He, L[5], 2840853838, 5), Ee = p(Ee, 10), He = le(He, Pe, $, Ee, be, L[9], 2840853838, 11), $ = p($, 10), be = le(be, He, Pe, $, Ee, L[7], 2840853838, 6), Pe = p(Pe, 10), Ee = le(Ee, be, He, Pe, $, L[12], 2840853838, 8), He = p(He, 10), $ = le($, Ee, be, He, Pe, L[2], 2840853838, 13), be = p(be, 10), Pe = le(Pe, $, Ee, be, He, L[10], 2840853838, 12), Ee = p(Ee, 10), He = le(He, Pe, $, Ee, be, L[14], 2840853838, 5), $ = p($, 10), be = le(be, He, Pe, $, Ee, L[1], 2840853838, 12), Pe = p(Pe, 10), Ee = le(Ee, be, He, Pe, $, L[3], 2840853838, 13), He = p(He, 10), $ = le($, Ee, be, He, Pe, L[8], 2840853838, 14), be = p(be, 10), Pe = le(Pe, $, Ee, be, He, L[11], 2840853838, 11), Ee = p(Ee, 10), He = le(He, Pe, $, Ee, be, L[6], 2840853838, 8), $ = p($, 10), be = le(be, He, Pe, $, Ee, L[15], 2840853838, 5), Pe = p(Pe, 10), Ee = le(Ee, be, He, Pe, $, L[13], 2840853838, 6), He = p(He, 10);
    var nr = this._a, ir = this._b, or = this._c, lr = this._d, Ir = this._e;
    nr = le(nr, ir, or, lr, Ir, L[5], 1352829926, 8), or = p(or, 10), Ir = le(Ir, nr, ir, or, lr, L[14], 1352829926, 9), ir = p(ir, 10), lr = le(lr, Ir, nr, ir, or, L[7], 1352829926, 9), nr = p(nr, 10), or = le(or, lr, Ir, nr, ir, L[0], 1352829926, 11), Ir = p(Ir, 10), ir = le(ir, or, lr, Ir, nr, L[9], 1352829926, 13), lr = p(lr, 10), nr = le(nr, ir, or, lr, Ir, L[2], 1352829926, 15), or = p(or, 10), Ir = le(Ir, nr, ir, or, lr, L[11], 1352829926, 15), ir = p(ir, 10), lr = le(lr, Ir, nr, ir, or, L[4], 1352829926, 5), nr = p(nr, 10), or = le(or, lr, Ir, nr, ir, L[13], 1352829926, 7), Ir = p(Ir, 10), ir = le(ir, or, lr, Ir, nr, L[6], 1352829926, 7), lr = p(lr, 10), nr = le(nr, ir, or, lr, Ir, L[15], 1352829926, 8), or = p(or, 10), Ir = le(Ir, nr, ir, or, lr, L[8], 1352829926, 11), ir = p(ir, 10), lr = le(lr, Ir, nr, ir, or, L[1], 1352829926, 14), nr = p(nr, 10), or = le(or, lr, Ir, nr, ir, L[10], 1352829926, 14), Ir = p(Ir, 10), ir = le(ir, or, lr, Ir, nr, L[3], 1352829926, 12), lr = p(lr, 10), nr = le(nr, ir, or, lr, Ir, L[12], 1352829926, 6), or = p(or, 10), Ir = F(Ir, nr, ir, or, lr, L[6], 1548603684, 9), ir = p(ir, 10), lr = F(lr, Ir, nr, ir, or, L[11], 1548603684, 13), nr = p(nr, 10), or = F(or, lr, Ir, nr, ir, L[3], 1548603684, 15), Ir = p(Ir, 10), ir = F(ir, or, lr, Ir, nr, L[7], 1548603684, 7), lr = p(lr, 10), nr = F(nr, ir, or, lr, Ir, L[0], 1548603684, 12), or = p(or, 10), Ir = F(Ir, nr, ir, or, lr, L[13], 1548603684, 8), ir = p(ir, 10), lr = F(lr, Ir, nr, ir, or, L[5], 1548603684, 9), nr = p(nr, 10), or = F(or, lr, Ir, nr, ir, L[10], 1548603684, 11), Ir = p(Ir, 10), ir = F(ir, or, lr, Ir, nr, L[14], 1548603684, 7), lr = p(lr, 10), nr = F(nr, ir, or, lr, Ir, L[15], 1548603684, 7), or = p(or, 10), Ir = F(Ir, nr, ir, or, lr, L[8], 1548603684, 12), ir = p(ir, 10), lr = F(lr, Ir, nr, ir, or, L[12], 1548603684, 7), nr = p(nr, 10), or = F(or, lr, Ir, nr, ir, L[4], 1548603684, 6), Ir = p(Ir, 10), ir = F(ir, or, lr, Ir, nr, L[9], 1548603684, 15), lr = p(lr, 10), nr = F(nr, ir, or, lr, Ir, L[1], 1548603684, 13), or = p(or, 10), Ir = F(Ir, nr, ir, or, lr, L[2], 1548603684, 11), ir = p(ir, 10), lr = b(lr, Ir, nr, ir, or, L[15], 1836072691, 9), nr = p(nr, 10), or = b(or, lr, Ir, nr, ir, L[5], 1836072691, 7), Ir = p(Ir, 10), ir = b(ir, or, lr, Ir, nr, L[1], 1836072691, 15), lr = p(lr, 10), nr = b(nr, ir, or, lr, Ir, L[3], 1836072691, 11), or = p(or, 10), Ir = b(Ir, nr, ir, or, lr, L[7], 1836072691, 8), ir = p(ir, 10), lr = b(lr, Ir, nr, ir, or, L[14], 1836072691, 6), nr = p(nr, 10), or = b(or, lr, Ir, nr, ir, L[6], 1836072691, 6), Ir = p(Ir, 10), ir = b(ir, or, lr, Ir, nr, L[9], 1836072691, 14), lr = p(lr, 10), nr = b(nr, ir, or, lr, Ir, L[11], 1836072691, 12), or = p(or, 10), Ir = b(Ir, nr, ir, or, lr, L[8], 1836072691, 13), ir = p(ir, 10), lr = b(lr, Ir, nr, ir, or, L[12], 1836072691, 5), nr = p(nr, 10), or = b(or, lr, Ir, nr, ir, L[2], 1836072691, 14), Ir = p(Ir, 10), ir = b(ir, or, lr, Ir, nr, L[10], 1836072691, 13), lr = p(lr, 10), nr = b(nr, ir, or, lr, Ir, L[0], 1836072691, 13), or = p(or, 10), Ir = b(Ir, nr, ir, or, lr, L[4], 1836072691, 7), ir = p(ir, 10), lr = b(lr, Ir, nr, ir, or, L[13], 1836072691, 5), nr = p(nr, 10), or = A(or, lr, Ir, nr, ir, L[8], 2053994217, 15), Ir = p(Ir, 10), ir = A(ir, or, lr, Ir, nr, L[6], 2053994217, 5), lr = p(lr, 10), nr = A(nr, ir, or, lr, Ir, L[4], 2053994217, 8), or = p(or, 10), Ir = A(Ir, nr, ir, or, lr, L[1], 2053994217, 11), ir = p(ir, 10), lr = A(lr, Ir, nr, ir, or, L[3], 2053994217, 14), nr = p(nr, 10), or = A(or, lr, Ir, nr, ir, L[11], 2053994217, 14), Ir = p(Ir, 10), ir = A(ir, or, lr, Ir, nr, L[15], 2053994217, 6), lr = p(lr, 10), nr = A(nr, ir, or, lr, Ir, L[0], 2053994217, 14), or = p(or, 10), Ir = A(Ir, nr, ir, or, lr, L[5], 2053994217, 6), ir = p(ir, 10), lr = A(lr, Ir, nr, ir, or, L[12], 2053994217, 9), nr = p(nr, 10), or = A(or, lr, Ir, nr, ir, L[2], 2053994217, 12), Ir = p(Ir, 10), ir = A(ir, or, lr, Ir, nr, L[13], 2053994217, 9), lr = p(lr, 10), nr = A(nr, ir, or, lr, Ir, L[9], 2053994217, 12), or = p(or, 10), Ir = A(Ir, nr, ir, or, lr, L[7], 2053994217, 5), ir = p(ir, 10), lr = A(lr, Ir, nr, ir, or, L[10], 2053994217, 15), nr = p(nr, 10), or = A(or, lr, Ir, nr, ir, L[14], 2053994217, 8), Ir = p(Ir, 10), ir = a(ir, or, lr, Ir, nr, L[12], 0, 8), lr = p(lr, 10), nr = a(nr, ir, or, lr, Ir, L[15], 0, 5), or = p(or, 10), Ir = a(Ir, nr, ir, or, lr, L[10], 0, 12), ir = p(ir, 10), lr = a(lr, Ir, nr, ir, or, L[4], 0, 9), nr = p(nr, 10), or = a(or, lr, Ir, nr, ir, L[1], 0, 12), Ir = p(Ir, 10), ir = a(ir, or, lr, Ir, nr, L[5], 0, 5), lr = p(lr, 10), nr = a(nr, ir, or, lr, Ir, L[8], 0, 14), or = p(or, 10), Ir = a(Ir, nr, ir, or, lr, L[7], 0, 6), ir = p(ir, 10), lr = a(lr, Ir, nr, ir, or, L[6], 0, 8), nr = p(nr, 10), or = a(or, lr, Ir, nr, ir, L[2], 0, 13), Ir = p(Ir, 10), ir = a(ir, or, lr, Ir, nr, L[13], 0, 6), lr = p(lr, 10), nr = a(nr, ir, or, lr, Ir, L[14], 0, 5), or = p(or, 10), Ir = a(Ir, nr, ir, or, lr, L[0], 0, 15), ir = p(ir, 10), lr = a(lr, Ir, nr, ir, or, L[3], 0, 13), nr = p(nr, 10), or = a(or, lr, Ir, nr, ir, L[9], 0, 11), Ir = p(Ir, 10), ir = a(ir, or, lr, Ir, nr, L[11], 0, 11), lr = p(lr, 10);
    var xr = this._b + be + lr | 0;
    this._b = this._c + He + Ir | 0, this._c = this._d + Pe + nr | 0, this._d = this._e + $ + ir | 0, this._e = this._a + Ee + or | 0, this._a = xr;
  }, u.prototype._digest = function() {
    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
    var L = new Buffer$f(20);
    return L.writeInt32LE(this._a, 0), L.writeInt32LE(this._b, 4), L.writeInt32LE(this._c, 8), L.writeInt32LE(this._d, 12), L.writeInt32LE(this._e, 16), L;
  };
  function p(L, pe) {
    return L << pe | L >>> 32 - pe;
  }
  function a(L, pe, $, Ee, be, He, Pe, nr) {
    return p(L + (pe ^ $ ^ Ee) + He + Pe | 0, nr) + be | 0;
  }
  function A(L, pe, $, Ee, be, He, Pe, nr) {
    return p(L + (pe & $ | ~pe & Ee) + He + Pe | 0, nr) + be | 0;
  }
  function b(L, pe, $, Ee, be, He, Pe, nr) {
    return p(L + ((pe | ~$) ^ Ee) + He + Pe | 0, nr) + be | 0;
  }
  function F(L, pe, $, Ee, be, He, Pe, nr) {
    return p(L + (pe & Ee | $ & ~Ee) + He + Pe | 0, nr) + be | 0;
  }
  function le(L, pe, $, Ee, be, He, Pe, nr) {
    return p(L + (pe ^ ($ | ~Ee)) + He + Pe | 0, nr) + be | 0;
  }
  return ripemd160$4 = u, ripemd160$4;
}
var isarray$1, hasRequiredIsarray$1;
function requireIsarray$1() {
  if (hasRequiredIsarray$1) return isarray$1;
  hasRequiredIsarray$1 = 1;
  var n = {}.toString;
  return isarray$1 = Array.isArray || function(c) {
    return n.call(c) == "[object Array]";
  }, isarray$1;
}
var typedArrayBuffer, hasRequiredTypedArrayBuffer;
function requireTypedArrayBuffer() {
  if (hasRequiredTypedArrayBuffer) return typedArrayBuffer;
  hasRequiredTypedArrayBuffer = 1;
  var n = type, c = callBound$4, u = c("TypedArray.prototype.buffer", !0), p = isTypedArray;
  return typedArrayBuffer = u || function(A) {
    if (!p(A))
      throw new n("Not a Typed Array");
    return A.buffer;
  }, typedArrayBuffer;
}
var toBuffer, hasRequiredToBuffer$1;
function requireToBuffer$1() {
  if (hasRequiredToBuffer$1) return toBuffer;
  hasRequiredToBuffer$1 = 1;
  var n = safeBufferExports.Buffer, c = requireIsarray$1(), u = requireTypedArrayBuffer(), p = ArrayBuffer.isView || function(le) {
    try {
      return u(le), !0;
    } catch {
      return !1;
    }
  }, a = typeof Uint8Array < "u", A = typeof ArrayBuffer < "u" && typeof Uint8Array < "u", b = A && (n.prototype instanceof Uint8Array || n.TYPED_ARRAY_SUPPORT);
  return toBuffer = function(le, L) {
    if (le instanceof n)
      return le;
    if (typeof le == "string")
      return n.from(le, L);
    if (A && p(le)) {
      if (le.byteLength === 0)
        return n.alloc(0);
      if (b) {
        var pe = n.from(le.buffer, le.byteOffset, le.byteLength);
        if (pe.byteLength === le.byteLength)
          return pe;
      }
      var $ = le instanceof Uint8Array ? le : new Uint8Array(le.buffer, le.byteOffset, le.byteLength), Ee = n.from($);
      if (Ee.length === le.byteLength)
        return Ee;
    }
    if (a && le instanceof Uint8Array)
      return n.from(le);
    var be = c(le);
    if (be)
      for (var He = 0; He < le.length; He += 1) {
        var Pe = le[He];
        if (typeof Pe != "number" || Pe < 0 || Pe > 255 || ~~Pe !== Pe)
          throw new RangeError("Array items must be numbers in the range 0-255.");
      }
    if (be || n.isBuffer(le) && le.constructor && typeof le.constructor.isBuffer == "function" && le.constructor.isBuffer(le))
      return n.from(le);
    throw new TypeError('The "data" argument must be a string, an Array, a Buffer, a Uint8Array, or a DataView.');
  }, toBuffer;
}
var toBuffer_1, hasRequiredToBuffer;
function requireToBuffer() {
  if (hasRequiredToBuffer) return toBuffer_1;
  hasRequiredToBuffer = 1;
  var n = safeBufferExports.Buffer, c = requireToBuffer$1(), u = typeof Uint8Array < "u", p = u && typeof ArrayBuffer < "u", a = p && ArrayBuffer.isView;
  return toBuffer_1 = function(A, b, F) {
    if (typeof A == "string" || n.isBuffer(A) || u && A instanceof Uint8Array || a && a(A))
      return c(A, b);
    throw new TypeError(F + " must be a string, a Buffer, a Uint8Array, or a DataView");
  }, toBuffer_1;
}
var syncBrowser, hasRequiredSyncBrowser;
function requireSyncBrowser() {
  if (hasRequiredSyncBrowser) return syncBrowser;
  hasRequiredSyncBrowser = 1;
  var n = requireMd5$2(), c = requireRipemd160(), u = sha_jsExports, p = safeBufferExports.Buffer, a = requirePrecondition(), A = requireDefaultEncoding(), b = requireToBuffer(), F = p.alloc(128), le = {
    __proto__: null,
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    "sha512-256": 32,
    ripemd160: 20,
    rmd160: 20
  }, L = {
    __proto__: null,
    "sha-1": "sha1",
    "sha-224": "sha224",
    "sha-256": "sha256",
    "sha-384": "sha384",
    "sha-512": "sha512",
    "ripemd-160": "ripemd160"
  };
  function pe(He) {
    return new c().update(He).digest();
  }
  function $(He) {
    function Pe(nr) {
      return u(He).update(nr).digest();
    }
    return He === "rmd160" || He === "ripemd160" ? pe : He === "md5" ? n : Pe;
  }
  function Ee(He, Pe, nr) {
    var ir = $(He), or = He === "sha512" || He === "sha384" ? 128 : 64;
    Pe.length > or ? Pe = ir(Pe) : Pe.length < or && (Pe = p.concat([Pe, F], or));
    for (var lr = p.allocUnsafe(or + le[He]), Ir = p.allocUnsafe(or + le[He]), xr = 0; xr < or; xr++)
      lr[xr] = Pe[xr] ^ 54, Ir[xr] = Pe[xr] ^ 92;
    var kr = p.allocUnsafe(or + nr + 4);
    lr.copy(kr, 0, 0, or), this.ipad1 = kr, this.ipad2 = lr, this.opad = Ir, this.alg = He, this.blocksize = or, this.hash = ir, this.size = le[He];
  }
  Ee.prototype.run = function(He, Pe) {
    He.copy(Pe, this.blocksize);
    var nr = this.hash(Pe);
    return nr.copy(this.opad, this.blocksize), this.hash(this.opad);
  };
  function be(He, Pe, nr, ir, or) {
    a(nr, ir), He = b(He, A, "Password"), Pe = b(Pe, A, "Salt");
    var lr = (or || "sha1").toLowerCase(), Ir = L[lr] || lr, xr = le[Ir];
    if (typeof xr != "number" || !xr)
      throw new TypeError("Digest algorithm not supported: " + or);
    var kr = new Ee(Ir, He, Pe.length), Ce = p.allocUnsafe(ir), tr = p.allocUnsafe(Pe.length + 4);
    Pe.copy(tr, 0, 0, Pe.length);
    for (var Fe = 0, Sr = xr, er = Math.ceil(ir / Sr), Ie = 1; Ie <= er; Ie++) {
      tr.writeUInt32BE(Ie, Pe.length);
      for (var xe = kr.run(tr, kr.ipad1), rr = xe, ar = 1; ar < nr; ar++) {
        rr = kr.run(rr, kr.ipad2);
        for (var yr = 0; yr < Sr; yr++)
          xe[yr] ^= rr[yr];
      }
      xe.copy(Ce, Fe), Fe += Sr;
    }
    return Ce;
  }
  return syncBrowser = be, syncBrowser;
}
var async, hasRequiredAsync;
function requireAsync() {
  if (hasRequiredAsync) return async;
  hasRequiredAsync = 1;
  var n = safeBufferExports.Buffer, c = requirePrecondition(), u = requireDefaultEncoding(), p = requireSyncBrowser(), a = requireToBuffer(), A, b = commonjsGlobal.crypto && commonjsGlobal.crypto.subtle, F = {
    sha: "SHA-1",
    "sha-1": "SHA-1",
    sha1: "SHA-1",
    sha256: "SHA-256",
    "sha-256": "SHA-256",
    sha384: "SHA-384",
    "sha-384": "SHA-384",
    "sha-512": "SHA-512",
    sha512: "SHA-512"
  }, le = [], L;
  function pe() {
    return L || (commonjsGlobal.process && commonjsGlobal.process.nextTick ? L = commonjsGlobal.process.nextTick : commonjsGlobal.queueMicrotask ? L = commonjsGlobal.queueMicrotask : commonjsGlobal.setImmediate ? L = commonjsGlobal.setImmediate : L = commonjsGlobal.setTimeout, L);
  }
  function $(He, Pe, nr, ir, or) {
    return b.importKey("raw", He, { name: "PBKDF2" }, !1, ["deriveBits"]).then(function(lr) {
      return b.deriveBits({
        name: "PBKDF2",
        salt: Pe,
        iterations: nr,
        hash: {
          name: or
        }
      }, lr, ir << 3);
    }).then(function(lr) {
      return n.from(lr);
    });
  }
  function Ee(He) {
    if (commonjsGlobal.process && !commonjsGlobal.process.browser || !b || !b.importKey || !b.deriveBits)
      return Promise.resolve(!1);
    if (le[He] !== void 0)
      return le[He];
    A = A || n.alloc(8);
    var Pe = $(A, A, 10, 128, He).then(
      function() {
        return !0;
      },
      function() {
        return !1;
      }
    );
    return le[He] = Pe, Pe;
  }
  function be(He, Pe) {
    He.then(function(nr) {
      pe()(function() {
        Pe(null, nr);
      });
    }, function(nr) {
      pe()(function() {
        Pe(nr);
      });
    });
  }
  return async = function(He, Pe, nr, ir, or, lr) {
    typeof or == "function" && (lr = or, or = void 0), or = or || "sha1";
    var Ir = F[or.toLowerCase()];
    if (!Ir || typeof commonjsGlobal.Promise != "function") {
      pe()(function() {
        var xr;
        try {
          xr = p(He, Pe, nr, ir, or);
        } catch (kr) {
          lr(kr);
          return;
        }
        lr(null, xr);
      });
      return;
    }
    if (c(nr, ir), He = a(He, u, "Password"), Pe = a(Pe, u, "Salt"), typeof lr != "function")
      throw new Error("No callback provided to pbkdf2");
    be(Ee(Ir).then(function(xr) {
      return xr ? $(He, Pe, nr, ir, Ir) : p(He, Pe, nr, ir, or);
    }), lr);
  }, async;
}
var hasRequiredBrowser$7;
function requireBrowser$7() {
  return hasRequiredBrowser$7 || (hasRequiredBrowser$7 = 1, browser$7.pbkdf2 = requireAsync(), browser$7.pbkdf2Sync = requireSyncBrowser()), browser$7;
}
var browser$6 = {}, des$1 = {}, utils$D = {}, hasRequiredUtils$a;
function requireUtils$a() {
  if (hasRequiredUtils$a) return utils$D;
  hasRequiredUtils$a = 1, utils$D.readUInt32BE = function(a, A) {
    var b = a[0 + A] << 24 | a[1 + A] << 16 | a[2 + A] << 8 | a[3 + A];
    return b >>> 0;
  }, utils$D.writeUInt32BE = function(a, A, b) {
    a[0 + b] = A >>> 24, a[1 + b] = A >>> 16 & 255, a[2 + b] = A >>> 8 & 255, a[3 + b] = A & 255;
  }, utils$D.ip = function(a, A, b, F) {
    for (var le = 0, L = 0, pe = 6; pe >= 0; pe -= 2) {
      for (var $ = 0; $ <= 24; $ += 8)
        le <<= 1, le |= A >>> $ + pe & 1;
      for (var $ = 0; $ <= 24; $ += 8)
        le <<= 1, le |= a >>> $ + pe & 1;
    }
    for (var pe = 6; pe >= 0; pe -= 2) {
      for (var $ = 1; $ <= 25; $ += 8)
        L <<= 1, L |= A >>> $ + pe & 1;
      for (var $ = 1; $ <= 25; $ += 8)
        L <<= 1, L |= a >>> $ + pe & 1;
    }
    b[F + 0] = le >>> 0, b[F + 1] = L >>> 0;
  }, utils$D.rip = function(a, A, b, F) {
    for (var le = 0, L = 0, pe = 0; pe < 4; pe++)
      for (var $ = 24; $ >= 0; $ -= 8)
        le <<= 1, le |= A >>> $ + pe & 1, le <<= 1, le |= a >>> $ + pe & 1;
    for (var pe = 4; pe < 8; pe++)
      for (var $ = 24; $ >= 0; $ -= 8)
        L <<= 1, L |= A >>> $ + pe & 1, L <<= 1, L |= a >>> $ + pe & 1;
    b[F + 0] = le >>> 0, b[F + 1] = L >>> 0;
  }, utils$D.pc1 = function(a, A, b, F) {
    for (var le = 0, L = 0, pe = 7; pe >= 5; pe--) {
      for (var $ = 0; $ <= 24; $ += 8)
        le <<= 1, le |= A >> $ + pe & 1;
      for (var $ = 0; $ <= 24; $ += 8)
        le <<= 1, le |= a >> $ + pe & 1;
    }
    for (var $ = 0; $ <= 24; $ += 8)
      le <<= 1, le |= A >> $ + pe & 1;
    for (var pe = 1; pe <= 3; pe++) {
      for (var $ = 0; $ <= 24; $ += 8)
        L <<= 1, L |= A >> $ + pe & 1;
      for (var $ = 0; $ <= 24; $ += 8)
        L <<= 1, L |= a >> $ + pe & 1;
    }
    for (var $ = 0; $ <= 24; $ += 8)
      L <<= 1, L |= a >> $ + pe & 1;
    b[F + 0] = le >>> 0, b[F + 1] = L >>> 0;
  }, utils$D.r28shl = function(a, A) {
    return a << A & 268435455 | a >>> 28 - A;
  };
  var n = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
  ];
  utils$D.pc2 = function(a, A, b, F) {
    for (var le = 0, L = 0, pe = n.length >>> 1, $ = 0; $ < pe; $++)
      le <<= 1, le |= a >>> n[$] & 1;
    for (var $ = pe; $ < n.length; $++)
      L <<= 1, L |= A >>> n[$] & 1;
    b[F + 0] = le >>> 0, b[F + 1] = L >>> 0;
  }, utils$D.expand = function(a, A, b) {
    var F = 0, le = 0;
    F = (a & 1) << 5 | a >>> 27;
    for (var L = 23; L >= 15; L -= 4)
      F <<= 6, F |= a >>> L & 63;
    for (var L = 11; L >= 3; L -= 4)
      le |= a >>> L & 63, le <<= 6;
    le |= (a & 31) << 1 | a >>> 31, A[b + 0] = F >>> 0, A[b + 1] = le >>> 0;
  };
  var c = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
  ];
  utils$D.substitute = function(a, A) {
    for (var b = 0, F = 0; F < 4; F++) {
      var le = a >>> 18 - F * 6 & 63, L = c[F * 64 + le];
      b <<= 4, b |= L;
    }
    for (var F = 0; F < 4; F++) {
      var le = A >>> 18 - F * 6 & 63, L = c[4 * 64 + F * 64 + le];
      b <<= 4, b |= L;
    }
    return b >>> 0;
  };
  var u = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
  ];
  return utils$D.permute = function(a) {
    for (var A = 0, b = 0; b < u.length; b++)
      A <<= 1, A |= a >>> u[b] & 1;
    return A >>> 0;
  }, utils$D.padSplit = function(a, A, b) {
    for (var F = a.toString(2); F.length < A; )
      F = "0" + F;
    for (var le = [], L = 0; L < A; L += b)
      le.push(F.slice(L, L + b));
    return le.join(" ");
  }, utils$D;
}
var minimalisticAssert = assert$s;
function assert$s(n, c) {
  if (!n)
    throw new Error(c || "Assertion failed");
}
assert$s.equal = function(c, u, p) {
  if (c != u)
    throw new Error(p || "Assertion failed: " + c + " != " + u);
};
var cipher, hasRequiredCipher;
function requireCipher() {
  if (hasRequiredCipher) return cipher;
  hasRequiredCipher = 1;
  var n = minimalisticAssert;
  function c(u) {
    this.options = u, this.type = this.options.type, this.blockSize = 8, this._init(), this.buffer = new Array(this.blockSize), this.bufferOff = 0, this.padding = u.padding !== !1;
  }
  return cipher = c, c.prototype._init = function() {
  }, c.prototype.update = function(p) {
    return p.length === 0 ? [] : this.type === "decrypt" ? this._updateDecrypt(p) : this._updateEncrypt(p);
  }, c.prototype._buffer = function(p, a) {
    for (var A = Math.min(this.buffer.length - this.bufferOff, p.length - a), b = 0; b < A; b++)
      this.buffer[this.bufferOff + b] = p[a + b];
    return this.bufferOff += A, A;
  }, c.prototype._flushBuffer = function(p, a) {
    return this._update(this.buffer, 0, p, a), this.bufferOff = 0, this.blockSize;
  }, c.prototype._updateEncrypt = function(p) {
    var a = 0, A = 0, b = (this.bufferOff + p.length) / this.blockSize | 0, F = new Array(b * this.blockSize);
    this.bufferOff !== 0 && (a += this._buffer(p, a), this.bufferOff === this.buffer.length && (A += this._flushBuffer(F, A)));
    for (var le = p.length - (p.length - a) % this.blockSize; a < le; a += this.blockSize)
      this._update(p, a, F, A), A += this.blockSize;
    for (; a < p.length; a++, this.bufferOff++)
      this.buffer[this.bufferOff] = p[a];
    return F;
  }, c.prototype._updateDecrypt = function(p) {
    for (var a = 0, A = 0, b = Math.ceil((this.bufferOff + p.length) / this.blockSize) - 1, F = new Array(b * this.blockSize); b > 0; b--)
      a += this._buffer(p, a), A += this._flushBuffer(F, A);
    return a += this._buffer(p, a), F;
  }, c.prototype.final = function(p) {
    var a;
    p && (a = this.update(p));
    var A;
    return this.type === "encrypt" ? A = this._finalEncrypt() : A = this._finalDecrypt(), a ? a.concat(A) : A;
  }, c.prototype._pad = function(p, a) {
    if (a === 0)
      return !1;
    for (; a < p.length; )
      p[a++] = 0;
    return !0;
  }, c.prototype._finalEncrypt = function() {
    if (!this._pad(this.buffer, this.bufferOff))
      return [];
    var p = new Array(this.blockSize);
    return this._update(this.buffer, 0, p, 0), p;
  }, c.prototype._unpad = function(p) {
    return p;
  }, c.prototype._finalDecrypt = function() {
    n.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
    var p = new Array(this.blockSize);
    return this._flushBuffer(p, 0), this._unpad(p);
  }, cipher;
}
var des, hasRequiredDes$1;
function requireDes$1() {
  if (hasRequiredDes$1) return des;
  hasRequiredDes$1 = 1;
  var n = minimalisticAssert, c = inherits_browserExports, u = requireUtils$a(), p = requireCipher();
  function a() {
    this.tmp = new Array(2), this.keys = null;
  }
  function A(F) {
    p.call(this, F);
    var le = new a();
    this._desState = le, this.deriveKeys(le, F.key);
  }
  c(A, p), des = A, A.create = function(le) {
    return new A(le);
  };
  var b = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
  ];
  return A.prototype.deriveKeys = function(le, L) {
    le.keys = new Array(16 * 2), n.equal(L.length, this.blockSize, "Invalid key length");
    var pe = u.readUInt32BE(L, 0), $ = u.readUInt32BE(L, 4);
    u.pc1(pe, $, le.tmp, 0), pe = le.tmp[0], $ = le.tmp[1];
    for (var Ee = 0; Ee < le.keys.length; Ee += 2) {
      var be = b[Ee >>> 1];
      pe = u.r28shl(pe, be), $ = u.r28shl($, be), u.pc2(pe, $, le.keys, Ee);
    }
  }, A.prototype._update = function(le, L, pe, $) {
    var Ee = this._desState, be = u.readUInt32BE(le, L), He = u.readUInt32BE(le, L + 4);
    u.ip(be, He, Ee.tmp, 0), be = Ee.tmp[0], He = Ee.tmp[1], this.type === "encrypt" ? this._encrypt(Ee, be, He, Ee.tmp, 0) : this._decrypt(Ee, be, He, Ee.tmp, 0), be = Ee.tmp[0], He = Ee.tmp[1], u.writeUInt32BE(pe, be, $), u.writeUInt32BE(pe, He, $ + 4);
  }, A.prototype._pad = function(le, L) {
    if (this.padding === !1)
      return !1;
    for (var pe = le.length - L, $ = L; $ < le.length; $++)
      le[$] = pe;
    return !0;
  }, A.prototype._unpad = function(le) {
    if (this.padding === !1)
      return le;
    for (var L = le[le.length - 1], pe = le.length - L; pe < le.length; pe++)
      n.equal(le[pe], L);
    return le.slice(0, le.length - L);
  }, A.prototype._encrypt = function(le, L, pe, $, Ee) {
    for (var be = L, He = pe, Pe = 0; Pe < le.keys.length; Pe += 2) {
      var nr = le.keys[Pe], ir = le.keys[Pe + 1];
      u.expand(He, le.tmp, 0), nr ^= le.tmp[0], ir ^= le.tmp[1];
      var or = u.substitute(nr, ir), lr = u.permute(or), Ir = He;
      He = (be ^ lr) >>> 0, be = Ir;
    }
    u.rip(He, be, $, Ee);
  }, A.prototype._decrypt = function(le, L, pe, $, Ee) {
    for (var be = pe, He = L, Pe = le.keys.length - 2; Pe >= 0; Pe -= 2) {
      var nr = le.keys[Pe], ir = le.keys[Pe + 1];
      u.expand(be, le.tmp, 0), nr ^= le.tmp[0], ir ^= le.tmp[1];
      var or = u.substitute(nr, ir), lr = u.permute(or), Ir = be;
      be = (He ^ lr) >>> 0, He = Ir;
    }
    u.rip(be, He, $, Ee);
  }, des;
}
var cbc$1 = {}, hasRequiredCbc$1;
function requireCbc$1() {
  if (hasRequiredCbc$1) return cbc$1;
  hasRequiredCbc$1 = 1;
  var n = minimalisticAssert, c = inherits_browserExports, u = {};
  function p(A) {
    n.equal(A.length, 8, "Invalid IV length"), this.iv = new Array(8);
    for (var b = 0; b < this.iv.length; b++)
      this.iv[b] = A[b];
  }
  function a(A) {
    function b(pe) {
      A.call(this, pe), this._cbcInit();
    }
    c(b, A);
    for (var F = Object.keys(u), le = 0; le < F.length; le++) {
      var L = F[le];
      b.prototype[L] = u[L];
    }
    return b.create = function($) {
      return new b($);
    }, b;
  }
  return cbc$1.instantiate = a, u._cbcInit = function() {
    var b = new p(this.options.iv);
    this._cbcState = b;
  }, u._update = function(b, F, le, L) {
    var pe = this._cbcState, $ = this.constructor.super_.prototype, Ee = pe.iv;
    if (this.type === "encrypt") {
      for (var be = 0; be < this.blockSize; be++)
        Ee[be] ^= b[F + be];
      $._update.call(this, Ee, 0, le, L);
      for (var be = 0; be < this.blockSize; be++)
        Ee[be] = le[L + be];
    } else {
      $._update.call(this, b, F, le, L);
      for (var be = 0; be < this.blockSize; be++)
        le[L + be] ^= Ee[be];
      for (var be = 0; be < this.blockSize; be++)
        Ee[be] = b[F + be];
    }
  }, cbc$1;
}
var ede, hasRequiredEde;
function requireEde() {
  if (hasRequiredEde) return ede;
  hasRequiredEde = 1;
  var n = minimalisticAssert, c = inherits_browserExports, u = requireCipher(), p = requireDes$1();
  function a(b, F) {
    n.equal(F.length, 24, "Invalid key length");
    var le = F.slice(0, 8), L = F.slice(8, 16), pe = F.slice(16, 24);
    b === "encrypt" ? this.ciphers = [
      p.create({ type: "encrypt", key: le }),
      p.create({ type: "decrypt", key: L }),
      p.create({ type: "encrypt", key: pe })
    ] : this.ciphers = [
      p.create({ type: "decrypt", key: pe }),
      p.create({ type: "encrypt", key: L }),
      p.create({ type: "decrypt", key: le })
    ];
  }
  function A(b) {
    u.call(this, b);
    var F = new a(this.type, this.options.key);
    this._edeState = F;
  }
  return c(A, u), ede = A, A.create = function(F) {
    return new A(F);
  }, A.prototype._update = function(F, le, L, pe) {
    var $ = this._edeState;
    $.ciphers[0]._update(F, le, L, pe), $.ciphers[1]._update(L, pe, L, pe), $.ciphers[2]._update(L, pe, L, pe);
  }, A.prototype._pad = p.prototype._pad, A.prototype._unpad = p.prototype._unpad, ede;
}
var hasRequiredDes;
function requireDes() {
  return hasRequiredDes || (hasRequiredDes = 1, des$1.utils = requireUtils$a(), des$1.Cipher = requireCipher(), des$1.DES = requireDes$1(), des$1.CBC = requireCbc$1(), des$1.EDE = requireEde()), des$1;
}
var browserifyDes, hasRequiredBrowserifyDes;
function requireBrowserifyDes() {
  if (hasRequiredBrowserifyDes) return browserifyDes;
  hasRequiredBrowserifyDes = 1;
  var n = cipherBase, c = requireDes(), u = inherits_browserExports, p = safeBufferExports.Buffer, a = {
    "des-ede3-cbc": c.CBC.instantiate(c.EDE),
    "des-ede3": c.EDE,
    "des-ede-cbc": c.CBC.instantiate(c.EDE),
    "des-ede": c.EDE,
    "des-cbc": c.CBC.instantiate(c.DES),
    "des-ecb": c.DES
  };
  a.des = a["des-cbc"], a.des3 = a["des-ede3-cbc"], browserifyDes = A, u(A, n);
  function A(b) {
    n.call(this);
    var F = b.mode.toLowerCase(), le = a[F], L;
    b.decrypt ? L = "decrypt" : L = "encrypt";
    var pe = b.key;
    p.isBuffer(pe) || (pe = p.from(pe)), (F === "des-ede" || F === "des-ede-cbc") && (pe = p.concat([pe, pe.slice(0, 8)]));
    var $ = b.iv;
    p.isBuffer($) || ($ = p.from($)), this._des = le.create({
      key: pe,
      iv: $,
      type: L
    });
  }
  return A.prototype._update = function(b) {
    return p.from(this._des.update(b));
  }, A.prototype._final = function() {
    return p.from(this._des.final());
  }, browserifyDes;
}
var browser$5 = {}, encrypter = {}, ecb = {}, hasRequiredEcb;
function requireEcb() {
  return hasRequiredEcb || (hasRequiredEcb = 1, ecb.encrypt = function(n, c) {
    return n._cipher.encryptBlock(c);
  }, ecb.decrypt = function(n, c) {
    return n._cipher.decryptBlock(c);
  }), ecb;
}
var cbc = {}, bufferXor, hasRequiredBufferXor;
function requireBufferXor() {
  return hasRequiredBufferXor || (hasRequiredBufferXor = 1, bufferXor = function(c, u) {
    for (var p = Math.min(c.length, u.length), a = new Buffer$f(p), A = 0; A < p; ++A)
      a[A] = c[A] ^ u[A];
    return a;
  }), bufferXor;
}
var hasRequiredCbc;
function requireCbc() {
  if (hasRequiredCbc) return cbc;
  hasRequiredCbc = 1;
  var n = requireBufferXor();
  return cbc.encrypt = function(c, u) {
    var p = n(u, c._prev);
    return c._prev = c._cipher.encryptBlock(p), c._prev;
  }, cbc.decrypt = function(c, u) {
    var p = c._prev;
    c._prev = u;
    var a = c._cipher.decryptBlock(u);
    return n(a, p);
  }, cbc;
}
var cfb = {}, hasRequiredCfb;
function requireCfb() {
  if (hasRequiredCfb) return cfb;
  hasRequiredCfb = 1;
  var n = safeBufferExports.Buffer, c = requireBufferXor();
  function u(p, a, A) {
    var b = a.length, F = c(a, p._cache);
    return p._cache = p._cache.slice(b), p._prev = n.concat([p._prev, A ? a : F]), F;
  }
  return cfb.encrypt = function(p, a, A) {
    for (var b = n.allocUnsafe(0), F; a.length; )
      if (p._cache.length === 0 && (p._cache = p._cipher.encryptBlock(p._prev), p._prev = n.allocUnsafe(0)), p._cache.length <= a.length)
        F = p._cache.length, b = n.concat([b, u(p, a.slice(0, F), A)]), a = a.slice(F);
      else {
        b = n.concat([b, u(p, a, A)]);
        break;
      }
    return b;
  }, cfb;
}
var cfb8 = {}, hasRequiredCfb8;
function requireCfb8() {
  if (hasRequiredCfb8) return cfb8;
  hasRequiredCfb8 = 1;
  var n = safeBufferExports.Buffer;
  function c(u, p, a) {
    var A = u._cipher.encryptBlock(u._prev), b = A[0] ^ p;
    return u._prev = n.concat([
      u._prev.slice(1),
      n.from([a ? p : b])
    ]), b;
  }
  return cfb8.encrypt = function(u, p, a) {
    for (var A = p.length, b = n.allocUnsafe(A), F = -1; ++F < A; )
      b[F] = c(u, p[F], a);
    return b;
  }, cfb8;
}
var cfb1 = {}, hasRequiredCfb1;
function requireCfb1() {
  if (hasRequiredCfb1) return cfb1;
  hasRequiredCfb1 = 1;
  var n = safeBufferExports.Buffer;
  function c(p, a, A) {
    for (var b, F = -1, le = 8, L = 0, pe, $; ++F < le; )
      b = p._cipher.encryptBlock(p._prev), pe = a & 1 << 7 - F ? 128 : 0, $ = b[0] ^ pe, L += ($ & 128) >> F % 8, p._prev = u(p._prev, A ? pe : $);
    return L;
  }
  function u(p, a) {
    var A = p.length, b = -1, F = n.allocUnsafe(p.length);
    for (p = n.concat([p, n.from([a])]); ++b < A; )
      F[b] = p[b] << 1 | p[b + 1] >> 7;
    return F;
  }
  return cfb1.encrypt = function(p, a, A) {
    for (var b = a.length, F = n.allocUnsafe(b), le = -1; ++le < b; )
      F[le] = c(p, a[le], A);
    return F;
  }, cfb1;
}
var ofb = {}, hasRequiredOfb;
function requireOfb() {
  if (hasRequiredOfb) return ofb;
  hasRequiredOfb = 1;
  var n = requireBufferXor();
  function c(u) {
    return u._prev = u._cipher.encryptBlock(u._prev), u._prev;
  }
  return ofb.encrypt = function(u, p) {
    for (; u._cache.length < p.length; )
      u._cache = Buffer$f.concat([u._cache, c(u)]);
    var a = u._cache.slice(0, p.length);
    return u._cache = u._cache.slice(p.length), n(p, a);
  }, ofb;
}
var ctr = {}, incr32_1, hasRequiredIncr32;
function requireIncr32() {
  if (hasRequiredIncr32) return incr32_1;
  hasRequiredIncr32 = 1;
  function n(c) {
    for (var u = c.length, p; u--; )
      if (p = c.readUInt8(u), p === 255)
        c.writeUInt8(0, u);
      else {
        p++, c.writeUInt8(p, u);
        break;
      }
  }
  return incr32_1 = n, incr32_1;
}
var hasRequiredCtr;
function requireCtr() {
  if (hasRequiredCtr) return ctr;
  hasRequiredCtr = 1;
  var n = requireBufferXor(), c = safeBufferExports.Buffer, u = requireIncr32();
  function p(A) {
    var b = A._cipher.encryptBlockRaw(A._prev);
    return u(A._prev), b;
  }
  var a = 16;
  return ctr.encrypt = function(A, b) {
    var F = Math.ceil(b.length / a), le = A._cache.length;
    A._cache = c.concat([
      A._cache,
      c.allocUnsafe(F * a)
    ]);
    for (var L = 0; L < F; L++) {
      var pe = p(A), $ = le + L * a;
      A._cache.writeUInt32BE(pe[0], $ + 0), A._cache.writeUInt32BE(pe[1], $ + 4), A._cache.writeUInt32BE(pe[2], $ + 8), A._cache.writeUInt32BE(pe[3], $ + 12);
    }
    var Ee = A._cache.slice(0, b.length);
    return A._cache = A._cache.slice(b.length), n(b, Ee);
  }, ctr;
}
const aes128 = {
  cipher: "AES",
  key: 128,
  iv: 16,
  mode: "CBC",
  type: "block"
}, aes192 = {
  cipher: "AES",
  key: 192,
  iv: 16,
  mode: "CBC",
  type: "block"
}, aes256 = {
  cipher: "AES",
  key: 256,
  iv: 16,
  mode: "CBC",
  type: "block"
}, require$$2 = {
  "aes-128-ecb": {
    cipher: "AES",
    key: 128,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-192-ecb": {
    cipher: "AES",
    key: 192,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-256-ecb": {
    cipher: "AES",
    key: 256,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-128-cbc": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  "aes-192-cbc": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  "aes-256-cbc": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  aes128,
  aes192,
  aes256,
  "aes-128-cfb": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-192-cfb": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-256-cfb": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-128-cfb8": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-192-cfb8": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-256-cfb8": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-128-cfb1": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-192-cfb1": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-256-cfb1": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-128-ofb": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-192-ofb": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-256-ofb": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-128-ctr": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-192-ctr": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-256-ctr": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-128-gcm": {
    cipher: "AES",
    key: 128,
    iv: 12,
    mode: "GCM",
    type: "auth"
  },
  "aes-192-gcm": {
    cipher: "AES",
    key: 192,
    iv: 12,
    mode: "GCM",
    type: "auth"
  },
  "aes-256-gcm": {
    cipher: "AES",
    key: 256,
    iv: 12,
    mode: "GCM",
    type: "auth"
  }
};
var modes_1, hasRequiredModes$1;
function requireModes$1() {
  if (hasRequiredModes$1) return modes_1;
  hasRequiredModes$1 = 1;
  var n = {
    ECB: requireEcb(),
    CBC: requireCbc(),
    CFB: requireCfb(),
    CFB8: requireCfb8(),
    CFB1: requireCfb1(),
    OFB: requireOfb(),
    CTR: requireCtr(),
    GCM: requireCtr()
  }, c = require$$2;
  for (var u in c)
    c[u].module = n[c[u].mode];
  return modes_1 = c, modes_1;
}
var aes = {}, hasRequiredAes;
function requireAes() {
  if (hasRequiredAes) return aes;
  hasRequiredAes = 1;
  var n = safeBufferExports.Buffer;
  function c(F) {
    n.isBuffer(F) || (F = n.from(F));
    for (var le = F.length / 4 | 0, L = new Array(le), pe = 0; pe < le; pe++)
      L[pe] = F.readUInt32BE(pe * 4);
    return L;
  }
  function u(F) {
    for (var le = 0; le < F.length; F++)
      F[le] = 0;
  }
  function p(F, le, L, pe, $) {
    for (var Ee = L[0], be = L[1], He = L[2], Pe = L[3], nr = F[0] ^ le[0], ir = F[1] ^ le[1], or = F[2] ^ le[2], lr = F[3] ^ le[3], Ir, xr, kr, Ce, tr = 4, Fe = 1; Fe < $; Fe++)
      Ir = Ee[nr >>> 24] ^ be[ir >>> 16 & 255] ^ He[or >>> 8 & 255] ^ Pe[lr & 255] ^ le[tr++], xr = Ee[ir >>> 24] ^ be[or >>> 16 & 255] ^ He[lr >>> 8 & 255] ^ Pe[nr & 255] ^ le[tr++], kr = Ee[or >>> 24] ^ be[lr >>> 16 & 255] ^ He[nr >>> 8 & 255] ^ Pe[ir & 255] ^ le[tr++], Ce = Ee[lr >>> 24] ^ be[nr >>> 16 & 255] ^ He[ir >>> 8 & 255] ^ Pe[or & 255] ^ le[tr++], nr = Ir, ir = xr, or = kr, lr = Ce;
    return Ir = (pe[nr >>> 24] << 24 | pe[ir >>> 16 & 255] << 16 | pe[or >>> 8 & 255] << 8 | pe[lr & 255]) ^ le[tr++], xr = (pe[ir >>> 24] << 24 | pe[or >>> 16 & 255] << 16 | pe[lr >>> 8 & 255] << 8 | pe[nr & 255]) ^ le[tr++], kr = (pe[or >>> 24] << 24 | pe[lr >>> 16 & 255] << 16 | pe[nr >>> 8 & 255] << 8 | pe[ir & 255]) ^ le[tr++], Ce = (pe[lr >>> 24] << 24 | pe[nr >>> 16 & 255] << 16 | pe[ir >>> 8 & 255] << 8 | pe[or & 255]) ^ le[tr++], Ir = Ir >>> 0, xr = xr >>> 0, kr = kr >>> 0, Ce = Ce >>> 0, [Ir, xr, kr, Ce];
  }
  var a = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], A = function() {
    for (var F = new Array(256), le = 0; le < 256; le++)
      le < 128 ? F[le] = le << 1 : F[le] = le << 1 ^ 283;
    for (var L = [], pe = [], $ = [[], [], [], []], Ee = [[], [], [], []], be = 0, He = 0, Pe = 0; Pe < 256; ++Pe) {
      var nr = He ^ He << 1 ^ He << 2 ^ He << 3 ^ He << 4;
      nr = nr >>> 8 ^ nr & 255 ^ 99, L[be] = nr, pe[nr] = be;
      var ir = F[be], or = F[ir], lr = F[or], Ir = F[nr] * 257 ^ nr * 16843008;
      $[0][be] = Ir << 24 | Ir >>> 8, $[1][be] = Ir << 16 | Ir >>> 16, $[2][be] = Ir << 8 | Ir >>> 24, $[3][be] = Ir, Ir = lr * 16843009 ^ or * 65537 ^ ir * 257 ^ be * 16843008, Ee[0][nr] = Ir << 24 | Ir >>> 8, Ee[1][nr] = Ir << 16 | Ir >>> 16, Ee[2][nr] = Ir << 8 | Ir >>> 24, Ee[3][nr] = Ir, be === 0 ? be = He = 1 : (be = ir ^ F[F[F[lr ^ ir]]], He ^= F[F[He]]);
    }
    return {
      SBOX: L,
      INV_SBOX: pe,
      SUB_MIX: $,
      INV_SUB_MIX: Ee
    };
  }();
  function b(F) {
    this._key = c(F), this._reset();
  }
  return b.blockSize = 4 * 4, b.keySize = 256 / 8, b.prototype.blockSize = b.blockSize, b.prototype.keySize = b.keySize, b.prototype._reset = function() {
    for (var F = this._key, le = F.length, L = le + 6, pe = (L + 1) * 4, $ = [], Ee = 0; Ee < le; Ee++)
      $[Ee] = F[Ee];
    for (Ee = le; Ee < pe; Ee++) {
      var be = $[Ee - 1];
      Ee % le === 0 ? (be = be << 8 | be >>> 24, be = A.SBOX[be >>> 24] << 24 | A.SBOX[be >>> 16 & 255] << 16 | A.SBOX[be >>> 8 & 255] << 8 | A.SBOX[be & 255], be ^= a[Ee / le | 0] << 24) : le > 6 && Ee % le === 4 && (be = A.SBOX[be >>> 24] << 24 | A.SBOX[be >>> 16 & 255] << 16 | A.SBOX[be >>> 8 & 255] << 8 | A.SBOX[be & 255]), $[Ee] = $[Ee - le] ^ be;
    }
    for (var He = [], Pe = 0; Pe < pe; Pe++) {
      var nr = pe - Pe, ir = $[nr - (Pe % 4 ? 0 : 4)];
      Pe < 4 || nr <= 4 ? He[Pe] = ir : He[Pe] = A.INV_SUB_MIX[0][A.SBOX[ir >>> 24]] ^ A.INV_SUB_MIX[1][A.SBOX[ir >>> 16 & 255]] ^ A.INV_SUB_MIX[2][A.SBOX[ir >>> 8 & 255]] ^ A.INV_SUB_MIX[3][A.SBOX[ir & 255]];
    }
    this._nRounds = L, this._keySchedule = $, this._invKeySchedule = He;
  }, b.prototype.encryptBlockRaw = function(F) {
    return F = c(F), p(F, this._keySchedule, A.SUB_MIX, A.SBOX, this._nRounds);
  }, b.prototype.encryptBlock = function(F) {
    var le = this.encryptBlockRaw(F), L = n.allocUnsafe(16);
    return L.writeUInt32BE(le[0], 0), L.writeUInt32BE(le[1], 4), L.writeUInt32BE(le[2], 8), L.writeUInt32BE(le[3], 12), L;
  }, b.prototype.decryptBlock = function(F) {
    F = c(F);
    var le = F[1];
    F[1] = F[3], F[3] = le;
    var L = p(F, this._invKeySchedule, A.INV_SUB_MIX, A.INV_SBOX, this._nRounds), pe = n.allocUnsafe(16);
    return pe.writeUInt32BE(L[0], 0), pe.writeUInt32BE(L[3], 4), pe.writeUInt32BE(L[2], 8), pe.writeUInt32BE(L[1], 12), pe;
  }, b.prototype.scrub = function() {
    u(this._keySchedule), u(this._invKeySchedule), u(this._key);
  }, aes.AES = b, aes;
}
var ghash, hasRequiredGhash;
function requireGhash() {
  if (hasRequiredGhash) return ghash;
  hasRequiredGhash = 1;
  var n = safeBufferExports.Buffer, c = n.alloc(16, 0);
  function u(A) {
    return [
      A.readUInt32BE(0),
      A.readUInt32BE(4),
      A.readUInt32BE(8),
      A.readUInt32BE(12)
    ];
  }
  function p(A) {
    var b = n.allocUnsafe(16);
    return b.writeUInt32BE(A[0] >>> 0, 0), b.writeUInt32BE(A[1] >>> 0, 4), b.writeUInt32BE(A[2] >>> 0, 8), b.writeUInt32BE(A[3] >>> 0, 12), b;
  }
  function a(A) {
    this.h = A, this.state = n.alloc(16, 0), this.cache = n.allocUnsafe(0);
  }
  return a.prototype.ghash = function(A) {
    for (var b = -1; ++b < A.length; )
      this.state[b] ^= A[b];
    this._multiply();
  }, a.prototype._multiply = function() {
    for (var A = u(this.h), b = [0, 0, 0, 0], F, le, L, pe = -1; ++pe < 128; ) {
      for (le = (this.state[~~(pe / 8)] & 1 << 7 - pe % 8) !== 0, le && (b[0] ^= A[0], b[1] ^= A[1], b[2] ^= A[2], b[3] ^= A[3]), L = (A[3] & 1) !== 0, F = 3; F > 0; F--)
        A[F] = A[F] >>> 1 | (A[F - 1] & 1) << 31;
      A[0] = A[0] >>> 1, L && (A[0] = A[0] ^ 225 << 24);
    }
    this.state = p(b);
  }, a.prototype.update = function(A) {
    this.cache = n.concat([this.cache, A]);
    for (var b; this.cache.length >= 16; )
      b = this.cache.slice(0, 16), this.cache = this.cache.slice(16), this.ghash(b);
  }, a.prototype.final = function(A, b) {
    return this.cache.length && this.ghash(n.concat([this.cache, c], 16)), this.ghash(p([0, A, 0, b])), this.state;
  }, ghash = a, ghash;
}
var authCipher, hasRequiredAuthCipher;
function requireAuthCipher() {
  if (hasRequiredAuthCipher) return authCipher;
  hasRequiredAuthCipher = 1;
  var n = requireAes(), c = safeBufferExports.Buffer, u = cipherBase, p = inherits_browserExports, a = requireGhash(), A = requireBufferXor(), b = requireIncr32();
  function F(pe, $) {
    var Ee = 0;
    pe.length !== $.length && Ee++;
    for (var be = Math.min(pe.length, $.length), He = 0; He < be; ++He)
      Ee += pe[He] ^ $[He];
    return Ee;
  }
  function le(pe, $, Ee) {
    if ($.length === 12)
      return pe._finID = c.concat([$, c.from([0, 0, 0, 1])]), c.concat([$, c.from([0, 0, 0, 2])]);
    var be = new a(Ee), He = $.length, Pe = He % 16;
    be.update($), Pe && (Pe = 16 - Pe, be.update(c.alloc(Pe, 0))), be.update(c.alloc(8, 0));
    var nr = He * 8, ir = c.alloc(8);
    ir.writeUIntBE(nr, 0, 8), be.update(ir), pe._finID = be.state;
    var or = c.from(pe._finID);
    return b(or), or;
  }
  function L(pe, $, Ee, be) {
    u.call(this);
    var He = c.alloc(4, 0);
    this._cipher = new n.AES($);
    var Pe = this._cipher.encryptBlock(He);
    this._ghash = new a(Pe), Ee = le(this, Ee, Pe), this._prev = c.from(Ee), this._cache = c.allocUnsafe(0), this._secCache = c.allocUnsafe(0), this._decrypt = be, this._alen = 0, this._len = 0, this._mode = pe, this._authTag = null, this._called = !1;
  }
  return p(L, u), L.prototype._update = function(pe) {
    if (!this._called && this._alen) {
      var $ = 16 - this._alen % 16;
      $ < 16 && ($ = c.alloc($, 0), this._ghash.update($));
    }
    this._called = !0;
    var Ee = this._mode.encrypt(this, pe);
    return this._decrypt ? this._ghash.update(pe) : this._ghash.update(Ee), this._len += pe.length, Ee;
  }, L.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error("Unsupported state or unable to authenticate data");
    var pe = A(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && F(pe, this._authTag)) throw new Error("Unsupported state or unable to authenticate data");
    this._authTag = pe, this._cipher.scrub();
  }, L.prototype.getAuthTag = function() {
    if (this._decrypt || !c.isBuffer(this._authTag)) throw new Error("Attempting to get auth tag in unsupported state");
    return this._authTag;
  }, L.prototype.setAuthTag = function($) {
    if (!this._decrypt) throw new Error("Attempting to set auth tag in unsupported state");
    this._authTag = $;
  }, L.prototype.setAAD = function($) {
    if (this._called) throw new Error("Attempting to set AAD in unsupported state");
    this._ghash.update($), this._alen += $.length;
  }, authCipher = L, authCipher;
}
var streamCipher, hasRequiredStreamCipher;
function requireStreamCipher() {
  if (hasRequiredStreamCipher) return streamCipher;
  hasRequiredStreamCipher = 1;
  var n = requireAes(), c = safeBufferExports.Buffer, u = cipherBase, p = inherits_browserExports;
  function a(A, b, F, le) {
    u.call(this), this._cipher = new n.AES(b), this._prev = c.from(F), this._cache = c.allocUnsafe(0), this._secCache = c.allocUnsafe(0), this._decrypt = le, this._mode = A;
  }
  return p(a, u), a.prototype._update = function(A) {
    return this._mode.encrypt(this, A, this._decrypt);
  }, a.prototype._final = function() {
    this._cipher.scrub();
  }, streamCipher = a, streamCipher;
}
var evp_bytestokey, hasRequiredEvp_bytestokey;
function requireEvp_bytestokey() {
  if (hasRequiredEvp_bytestokey) return evp_bytestokey;
  hasRequiredEvp_bytestokey = 1;
  var n = safeBufferExports.Buffer, c = md5_js;
  function u(p, a, A, b) {
    if (n.isBuffer(p) || (p = n.from(p, "binary")), a && (n.isBuffer(a) || (a = n.from(a, "binary")), a.length !== 8))
      throw new RangeError("salt should be Buffer with 8 byte length");
    for (var F = A / 8, le = n.alloc(F), L = n.alloc(b || 0), pe = n.alloc(0); F > 0 || b > 0; ) {
      var $ = new c();
      $.update(pe), $.update(p), a && $.update(a), pe = $.digest();
      var Ee = 0;
      if (F > 0) {
        var be = le.length - F;
        Ee = Math.min(F, pe.length), pe.copy(le, be, 0, Ee), F -= Ee;
      }
      if (Ee < pe.length && b > 0) {
        var He = L.length - b, Pe = Math.min(b, pe.length - Ee);
        pe.copy(L, He, Ee, Ee + Pe), b -= Pe;
      }
    }
    return pe.fill(0), { key: le, iv: L };
  }
  return evp_bytestokey = u, evp_bytestokey;
}
var hasRequiredEncrypter;
function requireEncrypter() {
  if (hasRequiredEncrypter) return encrypter;
  hasRequiredEncrypter = 1;
  var n = requireModes$1(), c = requireAuthCipher(), u = safeBufferExports.Buffer, p = requireStreamCipher(), a = cipherBase, A = requireAes(), b = requireEvp_bytestokey(), F = inherits_browserExports;
  function le(be, He, Pe) {
    a.call(this), this._cache = new pe(), this._cipher = new A.AES(He), this._prev = u.from(Pe), this._mode = be, this._autopadding = !0;
  }
  F(le, a), le.prototype._update = function(be) {
    this._cache.add(be);
    for (var He, Pe, nr = []; He = this._cache.get(); )
      Pe = this._mode.encrypt(this, He), nr.push(Pe);
    return u.concat(nr);
  };
  var L = u.alloc(16, 16);
  le.prototype._final = function() {
    var be = this._cache.flush();
    if (this._autopadding)
      return be = this._mode.encrypt(this, be), this._cipher.scrub(), be;
    if (!be.equals(L))
      throw this._cipher.scrub(), new Error("data not multiple of block length");
  }, le.prototype.setAutoPadding = function(be) {
    return this._autopadding = !!be, this;
  };
  function pe() {
    this.cache = u.allocUnsafe(0);
  }
  pe.prototype.add = function(be) {
    this.cache = u.concat([this.cache, be]);
  }, pe.prototype.get = function() {
    if (this.cache.length > 15) {
      var be = this.cache.slice(0, 16);
      return this.cache = this.cache.slice(16), be;
    }
    return null;
  }, pe.prototype.flush = function() {
    for (var be = 16 - this.cache.length, He = u.allocUnsafe(be), Pe = -1; ++Pe < be; )
      He.writeUInt8(be, Pe);
    return u.concat([this.cache, He]);
  };
  function $(be, He, Pe) {
    var nr = n[be.toLowerCase()];
    if (!nr) throw new TypeError("invalid suite type");
    if (typeof He == "string" && (He = u.from(He)), He.length !== nr.key / 8) throw new TypeError("invalid key length " + He.length);
    if (typeof Pe == "string" && (Pe = u.from(Pe)), nr.mode !== "GCM" && Pe.length !== nr.iv) throw new TypeError("invalid iv length " + Pe.length);
    return nr.type === "stream" ? new p(nr.module, He, Pe) : nr.type === "auth" ? new c(nr.module, He, Pe) : new le(nr.module, He, Pe);
  }
  function Ee(be, He) {
    var Pe = n[be.toLowerCase()];
    if (!Pe) throw new TypeError("invalid suite type");
    var nr = b(He, !1, Pe.key, Pe.iv);
    return $(be, nr.key, nr.iv);
  }
  return encrypter.createCipheriv = $, encrypter.createCipher = Ee, encrypter;
}
var decrypter = {}, hasRequiredDecrypter;
function requireDecrypter() {
  if (hasRequiredDecrypter) return decrypter;
  hasRequiredDecrypter = 1;
  var n = requireAuthCipher(), c = safeBufferExports.Buffer, u = requireModes$1(), p = requireStreamCipher(), a = cipherBase, A = requireAes(), b = requireEvp_bytestokey(), F = inherits_browserExports;
  function le(be, He, Pe) {
    a.call(this), this._cache = new L(), this._last = void 0, this._cipher = new A.AES(He), this._prev = c.from(Pe), this._mode = be, this._autopadding = !0;
  }
  F(le, a), le.prototype._update = function(be) {
    this._cache.add(be);
    for (var He, Pe, nr = []; He = this._cache.get(this._autopadding); )
      Pe = this._mode.decrypt(this, He), nr.push(Pe);
    return c.concat(nr);
  }, le.prototype._final = function() {
    var be = this._cache.flush();
    if (this._autopadding)
      return pe(this._mode.decrypt(this, be));
    if (be)
      throw new Error("data not multiple of block length");
  }, le.prototype.setAutoPadding = function(be) {
    return this._autopadding = !!be, this;
  };
  function L() {
    this.cache = c.allocUnsafe(0);
  }
  L.prototype.add = function(be) {
    this.cache = c.concat([this.cache, be]);
  }, L.prototype.get = function(be) {
    var He;
    if (be) {
      if (this.cache.length > 16)
        return He = this.cache.slice(0, 16), this.cache = this.cache.slice(16), He;
    } else if (this.cache.length >= 16)
      return He = this.cache.slice(0, 16), this.cache = this.cache.slice(16), He;
    return null;
  }, L.prototype.flush = function() {
    if (this.cache.length) return this.cache;
  };
  function pe(be) {
    var He = be[15];
    if (He < 1 || He > 16)
      throw new Error("unable to decrypt data");
    for (var Pe = -1; ++Pe < He; )
      if (be[Pe + (16 - He)] !== He)
        throw new Error("unable to decrypt data");
    if (He !== 16)
      return be.slice(0, 16 - He);
  }
  function $(be, He, Pe) {
    var nr = u[be.toLowerCase()];
    if (!nr) throw new TypeError("invalid suite type");
    if (typeof Pe == "string" && (Pe = c.from(Pe)), nr.mode !== "GCM" && Pe.length !== nr.iv) throw new TypeError("invalid iv length " + Pe.length);
    if (typeof He == "string" && (He = c.from(He)), He.length !== nr.key / 8) throw new TypeError("invalid key length " + He.length);
    return nr.type === "stream" ? new p(nr.module, He, Pe, !0) : nr.type === "auth" ? new n(nr.module, He, Pe, !0) : new le(nr.module, He, Pe);
  }
  function Ee(be, He) {
    var Pe = u[be.toLowerCase()];
    if (!Pe) throw new TypeError("invalid suite type");
    var nr = b(He, !1, Pe.key, Pe.iv);
    return $(be, nr.key, nr.iv);
  }
  return decrypter.createDecipher = Ee, decrypter.createDecipheriv = $, decrypter;
}
var hasRequiredBrowser$6;
function requireBrowser$6() {
  if (hasRequiredBrowser$6) return browser$5;
  hasRequiredBrowser$6 = 1;
  var n = requireEncrypter(), c = requireDecrypter(), u = require$$2;
  function p() {
    return Object.keys(u);
  }
  return browser$5.createCipher = browser$5.Cipher = n.createCipher, browser$5.createCipheriv = browser$5.Cipheriv = n.createCipheriv, browser$5.createDecipher = browser$5.Decipher = c.createDecipher, browser$5.createDecipheriv = browser$5.Decipheriv = c.createDecipheriv, browser$5.listCiphers = browser$5.getCiphers = p, browser$5;
}
var modes = {}, hasRequiredModes;
function requireModes() {
  return hasRequiredModes || (hasRequiredModes = 1, function(n) {
    n["des-ecb"] = {
      key: 8,
      iv: 0
    }, n["des-cbc"] = n.des = {
      key: 8,
      iv: 8
    }, n["des-ede3-cbc"] = n.des3 = {
      key: 24,
      iv: 8
    }, n["des-ede3"] = {
      key: 24,
      iv: 0
    }, n["des-ede-cbc"] = {
      key: 16,
      iv: 8
    }, n["des-ede"] = {
      key: 16,
      iv: 0
    };
  }(modes)), modes;
}
var hasRequiredBrowser$5;
function requireBrowser$5() {
  if (hasRequiredBrowser$5) return browser$6;
  hasRequiredBrowser$5 = 1;
  var n = requireBrowserifyDes(), c = requireBrowser$6(), u = requireModes$1(), p = requireModes(), a = requireEvp_bytestokey();
  function A(pe, $) {
    pe = pe.toLowerCase();
    var Ee, be;
    if (u[pe])
      Ee = u[pe].key, be = u[pe].iv;
    else if (p[pe])
      Ee = p[pe].key * 8, be = p[pe].iv;
    else
      throw new TypeError("invalid suite type");
    var He = a($, !1, Ee, be);
    return F(pe, He.key, He.iv);
  }
  function b(pe, $) {
    pe = pe.toLowerCase();
    var Ee, be;
    if (u[pe])
      Ee = u[pe].key, be = u[pe].iv;
    else if (p[pe])
      Ee = p[pe].key * 8, be = p[pe].iv;
    else
      throw new TypeError("invalid suite type");
    var He = a($, !1, Ee, be);
    return le(pe, He.key, He.iv);
  }
  function F(pe, $, Ee) {
    if (pe = pe.toLowerCase(), u[pe]) return c.createCipheriv(pe, $, Ee);
    if (p[pe]) return new n({ key: $, iv: Ee, mode: pe });
    throw new TypeError("invalid suite type");
  }
  function le(pe, $, Ee) {
    if (pe = pe.toLowerCase(), u[pe]) return c.createDecipheriv(pe, $, Ee);
    if (p[pe]) return new n({ key: $, iv: Ee, mode: pe, decrypt: !0 });
    throw new TypeError("invalid suite type");
  }
  function L() {
    return Object.keys(p).concat(c.getCiphers());
  }
  return browser$6.createCipher = browser$6.Cipher = A, browser$6.createCipheriv = browser$6.Cipheriv = F, browser$6.createDecipher = browser$6.Decipher = b, browser$6.createDecipheriv = browser$6.Decipheriv = le, browser$6.listCiphers = browser$6.getCiphers = L, browser$6;
}
var browser$4 = {}, bn$6 = { exports: {} };
bn$6.exports;
var hasRequiredBn$4;
function requireBn$4() {
  return hasRequiredBn$4 || (hasRequiredBn$4 = 1, function(n) {
    (function(c, u) {
      function p(er, Ie) {
        if (!er) throw new Error(Ie || "Assertion failed");
      }
      function a(er, Ie) {
        er.super_ = Ie;
        var xe = function() {
        };
        xe.prototype = Ie.prototype, er.prototype = new xe(), er.prototype.constructor = er;
      }
      function A(er, Ie, xe) {
        if (A.isBN(er))
          return er;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, er !== null && ((Ie === "le" || Ie === "be") && (xe = Ie, Ie = 10), this._init(er || 0, Ie || 10, xe || "be"));
      }
      typeof c == "object" ? c.exports = A : u.BN = A, A.BN = A, A.wordSize = 26;
      var b;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? b = window.Buffer : b = require$$0$5.Buffer;
      } catch {
      }
      A.isBN = function(Ie) {
        return Ie instanceof A ? !0 : Ie !== null && typeof Ie == "object" && Ie.constructor.wordSize === A.wordSize && Array.isArray(Ie.words);
      }, A.max = function(Ie, xe) {
        return Ie.cmp(xe) > 0 ? Ie : xe;
      }, A.min = function(Ie, xe) {
        return Ie.cmp(xe) < 0 ? Ie : xe;
      }, A.prototype._init = function(Ie, xe, rr) {
        if (typeof Ie == "number")
          return this._initNumber(Ie, xe, rr);
        if (typeof Ie == "object")
          return this._initArray(Ie, xe, rr);
        xe === "hex" && (xe = 16), p(xe === (xe | 0) && xe >= 2 && xe <= 36), Ie = Ie.toString().replace(/\s+/g, "");
        var ar = 0;
        Ie[0] === "-" && (ar++, this.negative = 1), ar < Ie.length && (xe === 16 ? this._parseHex(Ie, ar, rr) : (this._parseBase(Ie, xe, ar), rr === "le" && this._initArray(this.toArray(), xe, rr)));
      }, A.prototype._initNumber = function(Ie, xe, rr) {
        Ie < 0 && (this.negative = 1, Ie = -Ie), Ie < 67108864 ? (this.words = [Ie & 67108863], this.length = 1) : Ie < 4503599627370496 ? (this.words = [
          Ie & 67108863,
          Ie / 67108864 & 67108863
        ], this.length = 2) : (p(Ie < 9007199254740992), this.words = [
          Ie & 67108863,
          Ie / 67108864 & 67108863,
          1
        ], this.length = 3), rr === "le" && this._initArray(this.toArray(), xe, rr);
      }, A.prototype._initArray = function(Ie, xe, rr) {
        if (p(typeof Ie.length == "number"), Ie.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(Ie.length / 3), this.words = new Array(this.length);
        for (var ar = 0; ar < this.length; ar++)
          this.words[ar] = 0;
        var yr, _r, Or = 0;
        if (rr === "be")
          for (ar = Ie.length - 1, yr = 0; ar >= 0; ar -= 3)
            _r = Ie[ar] | Ie[ar - 1] << 8 | Ie[ar - 2] << 16, this.words[yr] |= _r << Or & 67108863, this.words[yr + 1] = _r >>> 26 - Or & 67108863, Or += 24, Or >= 26 && (Or -= 26, yr++);
        else if (rr === "le")
          for (ar = 0, yr = 0; ar < Ie.length; ar += 3)
            _r = Ie[ar] | Ie[ar + 1] << 8 | Ie[ar + 2] << 16, this.words[yr] |= _r << Or & 67108863, this.words[yr + 1] = _r >>> 26 - Or & 67108863, Or += 24, Or >= 26 && (Or -= 26, yr++);
        return this.strip();
      };
      function F(er, Ie) {
        var xe = er.charCodeAt(Ie);
        return xe >= 65 && xe <= 70 ? xe - 55 : xe >= 97 && xe <= 102 ? xe - 87 : xe - 48 & 15;
      }
      function le(er, Ie, xe) {
        var rr = F(er, xe);
        return xe - 1 >= Ie && (rr |= F(er, xe - 1) << 4), rr;
      }
      A.prototype._parseHex = function(Ie, xe, rr) {
        this.length = Math.ceil((Ie.length - xe) / 6), this.words = new Array(this.length);
        for (var ar = 0; ar < this.length; ar++)
          this.words[ar] = 0;
        var yr = 0, _r = 0, Or;
        if (rr === "be")
          for (ar = Ie.length - 1; ar >= xe; ar -= 2)
            Or = le(Ie, xe, ar) << yr, this.words[_r] |= Or & 67108863, yr >= 18 ? (yr -= 18, _r += 1, this.words[_r] |= Or >>> 26) : yr += 8;
        else {
          var vr = Ie.length - xe;
          for (ar = vr % 2 === 0 ? xe + 1 : xe; ar < Ie.length; ar += 2)
            Or = le(Ie, xe, ar) << yr, this.words[_r] |= Or & 67108863, yr >= 18 ? (yr -= 18, _r += 1, this.words[_r] |= Or >>> 26) : yr += 8;
        }
        this.strip();
      };
      function L(er, Ie, xe, rr) {
        for (var ar = 0, yr = Math.min(er.length, xe), _r = Ie; _r < yr; _r++) {
          var Or = er.charCodeAt(_r) - 48;
          ar *= rr, Or >= 49 ? ar += Or - 49 + 10 : Or >= 17 ? ar += Or - 17 + 10 : ar += Or;
        }
        return ar;
      }
      A.prototype._parseBase = function(Ie, xe, rr) {
        this.words = [0], this.length = 1;
        for (var ar = 0, yr = 1; yr <= 67108863; yr *= xe)
          ar++;
        ar--, yr = yr / xe | 0;
        for (var _r = Ie.length - rr, Or = _r % ar, vr = Math.min(_r, _r - Or) + rr, Te = 0, Cr = rr; Cr < vr; Cr += ar)
          Te = L(Ie, Cr, Cr + ar, xe), this.imuln(yr), this.words[0] + Te < 67108864 ? this.words[0] += Te : this._iaddn(Te);
        if (Or !== 0) {
          var Hr = 1;
          for (Te = L(Ie, Cr, Ie.length, xe), Cr = 0; Cr < Or; Cr++)
            Hr *= xe;
          this.imuln(Hr), this.words[0] + Te < 67108864 ? this.words[0] += Te : this._iaddn(Te);
        }
        this.strip();
      }, A.prototype.copy = function(Ie) {
        Ie.words = new Array(this.length);
        for (var xe = 0; xe < this.length; xe++)
          Ie.words[xe] = this.words[xe];
        Ie.length = this.length, Ie.negative = this.negative, Ie.red = this.red;
      }, A.prototype.clone = function() {
        var Ie = new A(null);
        return this.copy(Ie), Ie;
      }, A.prototype._expand = function(Ie) {
        for (; this.length < Ie; )
          this.words[this.length++] = 0;
        return this;
      }, A.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, A.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, A.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var pe = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], $ = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], Ee = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      A.prototype.toString = function(Ie, xe) {
        Ie = Ie || 10, xe = xe | 0 || 1;
        var rr;
        if (Ie === 16 || Ie === "hex") {
          rr = "";
          for (var ar = 0, yr = 0, _r = 0; _r < this.length; _r++) {
            var Or = this.words[_r], vr = ((Or << ar | yr) & 16777215).toString(16);
            yr = Or >>> 24 - ar & 16777215, ar += 2, ar >= 26 && (ar -= 26, _r--), yr !== 0 || _r !== this.length - 1 ? rr = pe[6 - vr.length] + vr + rr : rr = vr + rr;
          }
          for (yr !== 0 && (rr = yr.toString(16) + rr); rr.length % xe !== 0; )
            rr = "0" + rr;
          return this.negative !== 0 && (rr = "-" + rr), rr;
        }
        if (Ie === (Ie | 0) && Ie >= 2 && Ie <= 36) {
          var Te = $[Ie], Cr = Ee[Ie];
          rr = "";
          var Hr = this.clone();
          for (Hr.negative = 0; !Hr.isZero(); ) {
            var si = Hr.modn(Cr).toString(Ie);
            Hr = Hr.idivn(Cr), Hr.isZero() ? rr = si + rr : rr = pe[Te - si.length] + si + rr;
          }
          for (this.isZero() && (rr = "0" + rr); rr.length % xe !== 0; )
            rr = "0" + rr;
          return this.negative !== 0 && (rr = "-" + rr), rr;
        }
        p(!1, "Base should be between 2 and 36");
      }, A.prototype.toNumber = function() {
        var Ie = this.words[0];
        return this.length === 2 ? Ie += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? Ie += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && p(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -Ie : Ie;
      }, A.prototype.toJSON = function() {
        return this.toString(16);
      }, A.prototype.toBuffer = function(Ie, xe) {
        return p(typeof b < "u"), this.toArrayLike(b, Ie, xe);
      }, A.prototype.toArray = function(Ie, xe) {
        return this.toArrayLike(Array, Ie, xe);
      }, A.prototype.toArrayLike = function(Ie, xe, rr) {
        var ar = this.byteLength(), yr = rr || Math.max(1, ar);
        p(ar <= yr, "byte array longer than desired length"), p(yr > 0, "Requested array length <= 0"), this.strip();
        var _r = xe === "le", Or = new Ie(yr), vr, Te, Cr = this.clone();
        if (_r) {
          for (Te = 0; !Cr.isZero(); Te++)
            vr = Cr.andln(255), Cr.iushrn(8), Or[Te] = vr;
          for (; Te < yr; Te++)
            Or[Te] = 0;
        } else {
          for (Te = 0; Te < yr - ar; Te++)
            Or[Te] = 0;
          for (Te = 0; !Cr.isZero(); Te++)
            vr = Cr.andln(255), Cr.iushrn(8), Or[yr - Te - 1] = vr;
        }
        return Or;
      }, Math.clz32 ? A.prototype._countBits = function(Ie) {
        return 32 - Math.clz32(Ie);
      } : A.prototype._countBits = function(Ie) {
        var xe = Ie, rr = 0;
        return xe >= 4096 && (rr += 13, xe >>>= 13), xe >= 64 && (rr += 7, xe >>>= 7), xe >= 8 && (rr += 4, xe >>>= 4), xe >= 2 && (rr += 2, xe >>>= 2), rr + xe;
      }, A.prototype._zeroBits = function(Ie) {
        if (Ie === 0) return 26;
        var xe = Ie, rr = 0;
        return xe & 8191 || (rr += 13, xe >>>= 13), xe & 127 || (rr += 7, xe >>>= 7), xe & 15 || (rr += 4, xe >>>= 4), xe & 3 || (rr += 2, xe >>>= 2), xe & 1 || rr++, rr;
      }, A.prototype.bitLength = function() {
        var Ie = this.words[this.length - 1], xe = this._countBits(Ie);
        return (this.length - 1) * 26 + xe;
      };
      function be(er) {
        for (var Ie = new Array(er.bitLength()), xe = 0; xe < Ie.length; xe++) {
          var rr = xe / 26 | 0, ar = xe % 26;
          Ie[xe] = (er.words[rr] & 1 << ar) >>> ar;
        }
        return Ie;
      }
      A.prototype.zeroBits = function() {
        if (this.isZero()) return 0;
        for (var Ie = 0, xe = 0; xe < this.length; xe++) {
          var rr = this._zeroBits(this.words[xe]);
          if (Ie += rr, rr !== 26) break;
        }
        return Ie;
      }, A.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, A.prototype.toTwos = function(Ie) {
        return this.negative !== 0 ? this.abs().inotn(Ie).iaddn(1) : this.clone();
      }, A.prototype.fromTwos = function(Ie) {
        return this.testn(Ie - 1) ? this.notn(Ie).iaddn(1).ineg() : this.clone();
      }, A.prototype.isNeg = function() {
        return this.negative !== 0;
      }, A.prototype.neg = function() {
        return this.clone().ineg();
      }, A.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, A.prototype.iuor = function(Ie) {
        for (; this.length < Ie.length; )
          this.words[this.length++] = 0;
        for (var xe = 0; xe < Ie.length; xe++)
          this.words[xe] = this.words[xe] | Ie.words[xe];
        return this.strip();
      }, A.prototype.ior = function(Ie) {
        return p((this.negative | Ie.negative) === 0), this.iuor(Ie);
      }, A.prototype.or = function(Ie) {
        return this.length > Ie.length ? this.clone().ior(Ie) : Ie.clone().ior(this);
      }, A.prototype.uor = function(Ie) {
        return this.length > Ie.length ? this.clone().iuor(Ie) : Ie.clone().iuor(this);
      }, A.prototype.iuand = function(Ie) {
        var xe;
        this.length > Ie.length ? xe = Ie : xe = this;
        for (var rr = 0; rr < xe.length; rr++)
          this.words[rr] = this.words[rr] & Ie.words[rr];
        return this.length = xe.length, this.strip();
      }, A.prototype.iand = function(Ie) {
        return p((this.negative | Ie.negative) === 0), this.iuand(Ie);
      }, A.prototype.and = function(Ie) {
        return this.length > Ie.length ? this.clone().iand(Ie) : Ie.clone().iand(this);
      }, A.prototype.uand = function(Ie) {
        return this.length > Ie.length ? this.clone().iuand(Ie) : Ie.clone().iuand(this);
      }, A.prototype.iuxor = function(Ie) {
        var xe, rr;
        this.length > Ie.length ? (xe = this, rr = Ie) : (xe = Ie, rr = this);
        for (var ar = 0; ar < rr.length; ar++)
          this.words[ar] = xe.words[ar] ^ rr.words[ar];
        if (this !== xe)
          for (; ar < xe.length; ar++)
            this.words[ar] = xe.words[ar];
        return this.length = xe.length, this.strip();
      }, A.prototype.ixor = function(Ie) {
        return p((this.negative | Ie.negative) === 0), this.iuxor(Ie);
      }, A.prototype.xor = function(Ie) {
        return this.length > Ie.length ? this.clone().ixor(Ie) : Ie.clone().ixor(this);
      }, A.prototype.uxor = function(Ie) {
        return this.length > Ie.length ? this.clone().iuxor(Ie) : Ie.clone().iuxor(this);
      }, A.prototype.inotn = function(Ie) {
        p(typeof Ie == "number" && Ie >= 0);
        var xe = Math.ceil(Ie / 26) | 0, rr = Ie % 26;
        this._expand(xe), rr > 0 && xe--;
        for (var ar = 0; ar < xe; ar++)
          this.words[ar] = ~this.words[ar] & 67108863;
        return rr > 0 && (this.words[ar] = ~this.words[ar] & 67108863 >> 26 - rr), this.strip();
      }, A.prototype.notn = function(Ie) {
        return this.clone().inotn(Ie);
      }, A.prototype.setn = function(Ie, xe) {
        p(typeof Ie == "number" && Ie >= 0);
        var rr = Ie / 26 | 0, ar = Ie % 26;
        return this._expand(rr + 1), xe ? this.words[rr] = this.words[rr] | 1 << ar : this.words[rr] = this.words[rr] & ~(1 << ar), this.strip();
      }, A.prototype.iadd = function(Ie) {
        var xe;
        if (this.negative !== 0 && Ie.negative === 0)
          return this.negative = 0, xe = this.isub(Ie), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && Ie.negative !== 0)
          return Ie.negative = 0, xe = this.isub(Ie), Ie.negative = 1, xe._normSign();
        var rr, ar;
        this.length > Ie.length ? (rr = this, ar = Ie) : (rr = Ie, ar = this);
        for (var yr = 0, _r = 0; _r < ar.length; _r++)
          xe = (rr.words[_r] | 0) + (ar.words[_r] | 0) + yr, this.words[_r] = xe & 67108863, yr = xe >>> 26;
        for (; yr !== 0 && _r < rr.length; _r++)
          xe = (rr.words[_r] | 0) + yr, this.words[_r] = xe & 67108863, yr = xe >>> 26;
        if (this.length = rr.length, yr !== 0)
          this.words[this.length] = yr, this.length++;
        else if (rr !== this)
          for (; _r < rr.length; _r++)
            this.words[_r] = rr.words[_r];
        return this;
      }, A.prototype.add = function(Ie) {
        var xe;
        return Ie.negative !== 0 && this.negative === 0 ? (Ie.negative = 0, xe = this.sub(Ie), Ie.negative ^= 1, xe) : Ie.negative === 0 && this.negative !== 0 ? (this.negative = 0, xe = Ie.sub(this), this.negative = 1, xe) : this.length > Ie.length ? this.clone().iadd(Ie) : Ie.clone().iadd(this);
      }, A.prototype.isub = function(Ie) {
        if (Ie.negative !== 0) {
          Ie.negative = 0;
          var xe = this.iadd(Ie);
          return Ie.negative = 1, xe._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(Ie), this.negative = 1, this._normSign();
        var rr = this.cmp(Ie);
        if (rr === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var ar, yr;
        rr > 0 ? (ar = this, yr = Ie) : (ar = Ie, yr = this);
        for (var _r = 0, Or = 0; Or < yr.length; Or++)
          xe = (ar.words[Or] | 0) - (yr.words[Or] | 0) + _r, _r = xe >> 26, this.words[Or] = xe & 67108863;
        for (; _r !== 0 && Or < ar.length; Or++)
          xe = (ar.words[Or] | 0) + _r, _r = xe >> 26, this.words[Or] = xe & 67108863;
        if (_r === 0 && Or < ar.length && ar !== this)
          for (; Or < ar.length; Or++)
            this.words[Or] = ar.words[Or];
        return this.length = Math.max(this.length, Or), ar !== this && (this.negative = 1), this.strip();
      }, A.prototype.sub = function(Ie) {
        return this.clone().isub(Ie);
      };
      function He(er, Ie, xe) {
        xe.negative = Ie.negative ^ er.negative;
        var rr = er.length + Ie.length | 0;
        xe.length = rr, rr = rr - 1 | 0;
        var ar = er.words[0] | 0, yr = Ie.words[0] | 0, _r = ar * yr, Or = _r & 67108863, vr = _r / 67108864 | 0;
        xe.words[0] = Or;
        for (var Te = 1; Te < rr; Te++) {
          for (var Cr = vr >>> 26, Hr = vr & 67108863, si = Math.min(Te, Ie.length - 1), ui = Math.max(0, Te - er.length + 1); ui <= si; ui++) {
            var Li = Te - ui | 0;
            ar = er.words[Li] | 0, yr = Ie.words[ui] | 0, _r = ar * yr + Hr, Cr += _r / 67108864 | 0, Hr = _r & 67108863;
          }
          xe.words[Te] = Hr | 0, vr = Cr | 0;
        }
        return vr !== 0 ? xe.words[Te] = vr | 0 : xe.length--, xe.strip();
      }
      var Pe = function(Ie, xe, rr) {
        var ar = Ie.words, yr = xe.words, _r = rr.words, Or = 0, vr, Te, Cr, Hr = ar[0] | 0, si = Hr & 8191, ui = Hr >>> 13, Li = ar[1] | 0, Qi = Li & 8191, wi = Li >>> 13, Ji = ar[2] | 0, mn = Ji & 8191, pi = Ji >>> 13, ei = ar[3] | 0, Vr = ei & 8191, qr = ei >>> 13, Zi = ar[4] | 0, Wr = Zi & 8191, ri = Zi >>> 13, _i = ar[5] | 0, Er = _i & 8191, Di = _i >>> 13, _n = ar[6] | 0, On = _n & 8191, so = _n >>> 13, Do = ar[7] | 0, gn = Do & 8191, Gn = Do >>> 13, pn = ar[8] | 0, hn = pn & 8191, Rn = pn >>> 13, vo = ar[9] | 0, Hi = vo & 8191, di = vo >>> 13, Ui = yr[0] | 0, ln = Ui & 8191, Un = Ui >>> 13, Bo = yr[1] | 0, co = Bo & 8191, To = Bo >>> 13, xs = yr[2] | 0, Fo = xs & 8191, Zo = xs >>> 13, $s = yr[3] | 0, rs = $s & 8191, ls = $s >>> 13, na = yr[4] | 0, os = na & 8191, fs = na >>> 13, da = yr[5] | 0, Bn = da & 8191, hi = da >>> 13, Ii = yr[6] | 0, Gi = Ii & 8191, kn = Ii >>> 13, ho = yr[7] | 0, eo = ho & 8191, Ei = ho >>> 13, vs = yr[8] | 0, vi = vs & 8191, xi = vs >>> 13, Lr = yr[9] | 0, dn = Lr & 8191, xn = Lr >>> 13;
        rr.negative = Ie.negative ^ xe.negative, rr.length = 19, vr = Math.imul(si, ln), Te = Math.imul(si, Un), Te = Te + Math.imul(ui, ln) | 0, Cr = Math.imul(ui, Un);
        var oi = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (oi >>> 26) | 0, oi &= 67108863, vr = Math.imul(Qi, ln), Te = Math.imul(Qi, Un), Te = Te + Math.imul(wi, ln) | 0, Cr = Math.imul(wi, Un), vr = vr + Math.imul(si, co) | 0, Te = Te + Math.imul(si, To) | 0, Te = Te + Math.imul(ui, co) | 0, Cr = Cr + Math.imul(ui, To) | 0;
        var Yr = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (Yr >>> 26) | 0, Yr &= 67108863, vr = Math.imul(mn, ln), Te = Math.imul(mn, Un), Te = Te + Math.imul(pi, ln) | 0, Cr = Math.imul(pi, Un), vr = vr + Math.imul(Qi, co) | 0, Te = Te + Math.imul(Qi, To) | 0, Te = Te + Math.imul(wi, co) | 0, Cr = Cr + Math.imul(wi, To) | 0, vr = vr + Math.imul(si, Fo) | 0, Te = Te + Math.imul(si, Zo) | 0, Te = Te + Math.imul(ui, Fo) | 0, Cr = Cr + Math.imul(ui, Zo) | 0;
        var ji = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (ji >>> 26) | 0, ji &= 67108863, vr = Math.imul(Vr, ln), Te = Math.imul(Vr, Un), Te = Te + Math.imul(qr, ln) | 0, Cr = Math.imul(qr, Un), vr = vr + Math.imul(mn, co) | 0, Te = Te + Math.imul(mn, To) | 0, Te = Te + Math.imul(pi, co) | 0, Cr = Cr + Math.imul(pi, To) | 0, vr = vr + Math.imul(Qi, Fo) | 0, Te = Te + Math.imul(Qi, Zo) | 0, Te = Te + Math.imul(wi, Fo) | 0, Cr = Cr + Math.imul(wi, Zo) | 0, vr = vr + Math.imul(si, rs) | 0, Te = Te + Math.imul(si, ls) | 0, Te = Te + Math.imul(ui, rs) | 0, Cr = Cr + Math.imul(ui, ls) | 0;
        var Cn = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (Cn >>> 26) | 0, Cn &= 67108863, vr = Math.imul(Wr, ln), Te = Math.imul(Wr, Un), Te = Te + Math.imul(ri, ln) | 0, Cr = Math.imul(ri, Un), vr = vr + Math.imul(Vr, co) | 0, Te = Te + Math.imul(Vr, To) | 0, Te = Te + Math.imul(qr, co) | 0, Cr = Cr + Math.imul(qr, To) | 0, vr = vr + Math.imul(mn, Fo) | 0, Te = Te + Math.imul(mn, Zo) | 0, Te = Te + Math.imul(pi, Fo) | 0, Cr = Cr + Math.imul(pi, Zo) | 0, vr = vr + Math.imul(Qi, rs) | 0, Te = Te + Math.imul(Qi, ls) | 0, Te = Te + Math.imul(wi, rs) | 0, Cr = Cr + Math.imul(wi, ls) | 0, vr = vr + Math.imul(si, os) | 0, Te = Te + Math.imul(si, fs) | 0, Te = Te + Math.imul(ui, os) | 0, Cr = Cr + Math.imul(ui, fs) | 0;
        var Mn = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (Mn >>> 26) | 0, Mn &= 67108863, vr = Math.imul(Er, ln), Te = Math.imul(Er, Un), Te = Te + Math.imul(Di, ln) | 0, Cr = Math.imul(Di, Un), vr = vr + Math.imul(Wr, co) | 0, Te = Te + Math.imul(Wr, To) | 0, Te = Te + Math.imul(ri, co) | 0, Cr = Cr + Math.imul(ri, To) | 0, vr = vr + Math.imul(Vr, Fo) | 0, Te = Te + Math.imul(Vr, Zo) | 0, Te = Te + Math.imul(qr, Fo) | 0, Cr = Cr + Math.imul(qr, Zo) | 0, vr = vr + Math.imul(mn, rs) | 0, Te = Te + Math.imul(mn, ls) | 0, Te = Te + Math.imul(pi, rs) | 0, Cr = Cr + Math.imul(pi, ls) | 0, vr = vr + Math.imul(Qi, os) | 0, Te = Te + Math.imul(Qi, fs) | 0, Te = Te + Math.imul(wi, os) | 0, Cr = Cr + Math.imul(wi, fs) | 0, vr = vr + Math.imul(si, Bn) | 0, Te = Te + Math.imul(si, hi) | 0, Te = Te + Math.imul(ui, Bn) | 0, Cr = Cr + Math.imul(ui, hi) | 0;
        var B = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (B >>> 26) | 0, B &= 67108863, vr = Math.imul(On, ln), Te = Math.imul(On, Un), Te = Te + Math.imul(so, ln) | 0, Cr = Math.imul(so, Un), vr = vr + Math.imul(Er, co) | 0, Te = Te + Math.imul(Er, To) | 0, Te = Te + Math.imul(Di, co) | 0, Cr = Cr + Math.imul(Di, To) | 0, vr = vr + Math.imul(Wr, Fo) | 0, Te = Te + Math.imul(Wr, Zo) | 0, Te = Te + Math.imul(ri, Fo) | 0, Cr = Cr + Math.imul(ri, Zo) | 0, vr = vr + Math.imul(Vr, rs) | 0, Te = Te + Math.imul(Vr, ls) | 0, Te = Te + Math.imul(qr, rs) | 0, Cr = Cr + Math.imul(qr, ls) | 0, vr = vr + Math.imul(mn, os) | 0, Te = Te + Math.imul(mn, fs) | 0, Te = Te + Math.imul(pi, os) | 0, Cr = Cr + Math.imul(pi, fs) | 0, vr = vr + Math.imul(Qi, Bn) | 0, Te = Te + Math.imul(Qi, hi) | 0, Te = Te + Math.imul(wi, Bn) | 0, Cr = Cr + Math.imul(wi, hi) | 0, vr = vr + Math.imul(si, Gi) | 0, Te = Te + Math.imul(si, kn) | 0, Te = Te + Math.imul(ui, Gi) | 0, Cr = Cr + Math.imul(ui, kn) | 0;
        var o = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (o >>> 26) | 0, o &= 67108863, vr = Math.imul(gn, ln), Te = Math.imul(gn, Un), Te = Te + Math.imul(Gn, ln) | 0, Cr = Math.imul(Gn, Un), vr = vr + Math.imul(On, co) | 0, Te = Te + Math.imul(On, To) | 0, Te = Te + Math.imul(so, co) | 0, Cr = Cr + Math.imul(so, To) | 0, vr = vr + Math.imul(Er, Fo) | 0, Te = Te + Math.imul(Er, Zo) | 0, Te = Te + Math.imul(Di, Fo) | 0, Cr = Cr + Math.imul(Di, Zo) | 0, vr = vr + Math.imul(Wr, rs) | 0, Te = Te + Math.imul(Wr, ls) | 0, Te = Te + Math.imul(ri, rs) | 0, Cr = Cr + Math.imul(ri, ls) | 0, vr = vr + Math.imul(Vr, os) | 0, Te = Te + Math.imul(Vr, fs) | 0, Te = Te + Math.imul(qr, os) | 0, Cr = Cr + Math.imul(qr, fs) | 0, vr = vr + Math.imul(mn, Bn) | 0, Te = Te + Math.imul(mn, hi) | 0, Te = Te + Math.imul(pi, Bn) | 0, Cr = Cr + Math.imul(pi, hi) | 0, vr = vr + Math.imul(Qi, Gi) | 0, Te = Te + Math.imul(Qi, kn) | 0, Te = Te + Math.imul(wi, Gi) | 0, Cr = Cr + Math.imul(wi, kn) | 0, vr = vr + Math.imul(si, eo) | 0, Te = Te + Math.imul(si, Ei) | 0, Te = Te + Math.imul(ui, eo) | 0, Cr = Cr + Math.imul(ui, Ei) | 0;
        var m = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (m >>> 26) | 0, m &= 67108863, vr = Math.imul(hn, ln), Te = Math.imul(hn, Un), Te = Te + Math.imul(Rn, ln) | 0, Cr = Math.imul(Rn, Un), vr = vr + Math.imul(gn, co) | 0, Te = Te + Math.imul(gn, To) | 0, Te = Te + Math.imul(Gn, co) | 0, Cr = Cr + Math.imul(Gn, To) | 0, vr = vr + Math.imul(On, Fo) | 0, Te = Te + Math.imul(On, Zo) | 0, Te = Te + Math.imul(so, Fo) | 0, Cr = Cr + Math.imul(so, Zo) | 0, vr = vr + Math.imul(Er, rs) | 0, Te = Te + Math.imul(Er, ls) | 0, Te = Te + Math.imul(Di, rs) | 0, Cr = Cr + Math.imul(Di, ls) | 0, vr = vr + Math.imul(Wr, os) | 0, Te = Te + Math.imul(Wr, fs) | 0, Te = Te + Math.imul(ri, os) | 0, Cr = Cr + Math.imul(ri, fs) | 0, vr = vr + Math.imul(Vr, Bn) | 0, Te = Te + Math.imul(Vr, hi) | 0, Te = Te + Math.imul(qr, Bn) | 0, Cr = Cr + Math.imul(qr, hi) | 0, vr = vr + Math.imul(mn, Gi) | 0, Te = Te + Math.imul(mn, kn) | 0, Te = Te + Math.imul(pi, Gi) | 0, Cr = Cr + Math.imul(pi, kn) | 0, vr = vr + Math.imul(Qi, eo) | 0, Te = Te + Math.imul(Qi, Ei) | 0, Te = Te + Math.imul(wi, eo) | 0, Cr = Cr + Math.imul(wi, Ei) | 0, vr = vr + Math.imul(si, vi) | 0, Te = Te + Math.imul(si, xi) | 0, Te = Te + Math.imul(ui, vi) | 0, Cr = Cr + Math.imul(ui, xi) | 0;
        var d = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (d >>> 26) | 0, d &= 67108863, vr = Math.imul(Hi, ln), Te = Math.imul(Hi, Un), Te = Te + Math.imul(di, ln) | 0, Cr = Math.imul(di, Un), vr = vr + Math.imul(hn, co) | 0, Te = Te + Math.imul(hn, To) | 0, Te = Te + Math.imul(Rn, co) | 0, Cr = Cr + Math.imul(Rn, To) | 0, vr = vr + Math.imul(gn, Fo) | 0, Te = Te + Math.imul(gn, Zo) | 0, Te = Te + Math.imul(Gn, Fo) | 0, Cr = Cr + Math.imul(Gn, Zo) | 0, vr = vr + Math.imul(On, rs) | 0, Te = Te + Math.imul(On, ls) | 0, Te = Te + Math.imul(so, rs) | 0, Cr = Cr + Math.imul(so, ls) | 0, vr = vr + Math.imul(Er, os) | 0, Te = Te + Math.imul(Er, fs) | 0, Te = Te + Math.imul(Di, os) | 0, Cr = Cr + Math.imul(Di, fs) | 0, vr = vr + Math.imul(Wr, Bn) | 0, Te = Te + Math.imul(Wr, hi) | 0, Te = Te + Math.imul(ri, Bn) | 0, Cr = Cr + Math.imul(ri, hi) | 0, vr = vr + Math.imul(Vr, Gi) | 0, Te = Te + Math.imul(Vr, kn) | 0, Te = Te + Math.imul(qr, Gi) | 0, Cr = Cr + Math.imul(qr, kn) | 0, vr = vr + Math.imul(mn, eo) | 0, Te = Te + Math.imul(mn, Ei) | 0, Te = Te + Math.imul(pi, eo) | 0, Cr = Cr + Math.imul(pi, Ei) | 0, vr = vr + Math.imul(Qi, vi) | 0, Te = Te + Math.imul(Qi, xi) | 0, Te = Te + Math.imul(wi, vi) | 0, Cr = Cr + Math.imul(wi, xi) | 0, vr = vr + Math.imul(si, dn) | 0, Te = Te + Math.imul(si, xn) | 0, Te = Te + Math.imul(ui, dn) | 0, Cr = Cr + Math.imul(ui, xn) | 0;
        var v = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (v >>> 26) | 0, v &= 67108863, vr = Math.imul(Hi, co), Te = Math.imul(Hi, To), Te = Te + Math.imul(di, co) | 0, Cr = Math.imul(di, To), vr = vr + Math.imul(hn, Fo) | 0, Te = Te + Math.imul(hn, Zo) | 0, Te = Te + Math.imul(Rn, Fo) | 0, Cr = Cr + Math.imul(Rn, Zo) | 0, vr = vr + Math.imul(gn, rs) | 0, Te = Te + Math.imul(gn, ls) | 0, Te = Te + Math.imul(Gn, rs) | 0, Cr = Cr + Math.imul(Gn, ls) | 0, vr = vr + Math.imul(On, os) | 0, Te = Te + Math.imul(On, fs) | 0, Te = Te + Math.imul(so, os) | 0, Cr = Cr + Math.imul(so, fs) | 0, vr = vr + Math.imul(Er, Bn) | 0, Te = Te + Math.imul(Er, hi) | 0, Te = Te + Math.imul(Di, Bn) | 0, Cr = Cr + Math.imul(Di, hi) | 0, vr = vr + Math.imul(Wr, Gi) | 0, Te = Te + Math.imul(Wr, kn) | 0, Te = Te + Math.imul(ri, Gi) | 0, Cr = Cr + Math.imul(ri, kn) | 0, vr = vr + Math.imul(Vr, eo) | 0, Te = Te + Math.imul(Vr, Ei) | 0, Te = Te + Math.imul(qr, eo) | 0, Cr = Cr + Math.imul(qr, Ei) | 0, vr = vr + Math.imul(mn, vi) | 0, Te = Te + Math.imul(mn, xi) | 0, Te = Te + Math.imul(pi, vi) | 0, Cr = Cr + Math.imul(pi, xi) | 0, vr = vr + Math.imul(Qi, dn) | 0, Te = Te + Math.imul(Qi, xn) | 0, Te = Te + Math.imul(wi, dn) | 0, Cr = Cr + Math.imul(wi, xn) | 0;
        var he = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (he >>> 26) | 0, he &= 67108863, vr = Math.imul(Hi, Fo), Te = Math.imul(Hi, Zo), Te = Te + Math.imul(di, Fo) | 0, Cr = Math.imul(di, Zo), vr = vr + Math.imul(hn, rs) | 0, Te = Te + Math.imul(hn, ls) | 0, Te = Te + Math.imul(Rn, rs) | 0, Cr = Cr + Math.imul(Rn, ls) | 0, vr = vr + Math.imul(gn, os) | 0, Te = Te + Math.imul(gn, fs) | 0, Te = Te + Math.imul(Gn, os) | 0, Cr = Cr + Math.imul(Gn, fs) | 0, vr = vr + Math.imul(On, Bn) | 0, Te = Te + Math.imul(On, hi) | 0, Te = Te + Math.imul(so, Bn) | 0, Cr = Cr + Math.imul(so, hi) | 0, vr = vr + Math.imul(Er, Gi) | 0, Te = Te + Math.imul(Er, kn) | 0, Te = Te + Math.imul(Di, Gi) | 0, Cr = Cr + Math.imul(Di, kn) | 0, vr = vr + Math.imul(Wr, eo) | 0, Te = Te + Math.imul(Wr, Ei) | 0, Te = Te + Math.imul(ri, eo) | 0, Cr = Cr + Math.imul(ri, Ei) | 0, vr = vr + Math.imul(Vr, vi) | 0, Te = Te + Math.imul(Vr, xi) | 0, Te = Te + Math.imul(qr, vi) | 0, Cr = Cr + Math.imul(qr, xi) | 0, vr = vr + Math.imul(mn, dn) | 0, Te = Te + Math.imul(mn, xn) | 0, Te = Te + Math.imul(pi, dn) | 0, Cr = Cr + Math.imul(pi, xn) | 0;
        var we = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (we >>> 26) | 0, we &= 67108863, vr = Math.imul(Hi, rs), Te = Math.imul(Hi, ls), Te = Te + Math.imul(di, rs) | 0, Cr = Math.imul(di, ls), vr = vr + Math.imul(hn, os) | 0, Te = Te + Math.imul(hn, fs) | 0, Te = Te + Math.imul(Rn, os) | 0, Cr = Cr + Math.imul(Rn, fs) | 0, vr = vr + Math.imul(gn, Bn) | 0, Te = Te + Math.imul(gn, hi) | 0, Te = Te + Math.imul(Gn, Bn) | 0, Cr = Cr + Math.imul(Gn, hi) | 0, vr = vr + Math.imul(On, Gi) | 0, Te = Te + Math.imul(On, kn) | 0, Te = Te + Math.imul(so, Gi) | 0, Cr = Cr + Math.imul(so, kn) | 0, vr = vr + Math.imul(Er, eo) | 0, Te = Te + Math.imul(Er, Ei) | 0, Te = Te + Math.imul(Di, eo) | 0, Cr = Cr + Math.imul(Di, Ei) | 0, vr = vr + Math.imul(Wr, vi) | 0, Te = Te + Math.imul(Wr, xi) | 0, Te = Te + Math.imul(ri, vi) | 0, Cr = Cr + Math.imul(ri, xi) | 0, vr = vr + Math.imul(Vr, dn) | 0, Te = Te + Math.imul(Vr, xn) | 0, Te = Te + Math.imul(qr, dn) | 0, Cr = Cr + Math.imul(qr, xn) | 0;
        var Be = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (Be >>> 26) | 0, Be &= 67108863, vr = Math.imul(Hi, os), Te = Math.imul(Hi, fs), Te = Te + Math.imul(di, os) | 0, Cr = Math.imul(di, fs), vr = vr + Math.imul(hn, Bn) | 0, Te = Te + Math.imul(hn, hi) | 0, Te = Te + Math.imul(Rn, Bn) | 0, Cr = Cr + Math.imul(Rn, hi) | 0, vr = vr + Math.imul(gn, Gi) | 0, Te = Te + Math.imul(gn, kn) | 0, Te = Te + Math.imul(Gn, Gi) | 0, Cr = Cr + Math.imul(Gn, kn) | 0, vr = vr + Math.imul(On, eo) | 0, Te = Te + Math.imul(On, Ei) | 0, Te = Te + Math.imul(so, eo) | 0, Cr = Cr + Math.imul(so, Ei) | 0, vr = vr + Math.imul(Er, vi) | 0, Te = Te + Math.imul(Er, xi) | 0, Te = Te + Math.imul(Di, vi) | 0, Cr = Cr + Math.imul(Di, xi) | 0, vr = vr + Math.imul(Wr, dn) | 0, Te = Te + Math.imul(Wr, xn) | 0, Te = Te + Math.imul(ri, dn) | 0, Cr = Cr + Math.imul(ri, xn) | 0;
        var Me = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (Me >>> 26) | 0, Me &= 67108863, vr = Math.imul(Hi, Bn), Te = Math.imul(Hi, hi), Te = Te + Math.imul(di, Bn) | 0, Cr = Math.imul(di, hi), vr = vr + Math.imul(hn, Gi) | 0, Te = Te + Math.imul(hn, kn) | 0, Te = Te + Math.imul(Rn, Gi) | 0, Cr = Cr + Math.imul(Rn, kn) | 0, vr = vr + Math.imul(gn, eo) | 0, Te = Te + Math.imul(gn, Ei) | 0, Te = Te + Math.imul(Gn, eo) | 0, Cr = Cr + Math.imul(Gn, Ei) | 0, vr = vr + Math.imul(On, vi) | 0, Te = Te + Math.imul(On, xi) | 0, Te = Te + Math.imul(so, vi) | 0, Cr = Cr + Math.imul(so, xi) | 0, vr = vr + Math.imul(Er, dn) | 0, Te = Te + Math.imul(Er, xn) | 0, Te = Te + Math.imul(Di, dn) | 0, Cr = Cr + Math.imul(Di, xn) | 0;
        var fr = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (fr >>> 26) | 0, fr &= 67108863, vr = Math.imul(Hi, Gi), Te = Math.imul(Hi, kn), Te = Te + Math.imul(di, Gi) | 0, Cr = Math.imul(di, kn), vr = vr + Math.imul(hn, eo) | 0, Te = Te + Math.imul(hn, Ei) | 0, Te = Te + Math.imul(Rn, eo) | 0, Cr = Cr + Math.imul(Rn, Ei) | 0, vr = vr + Math.imul(gn, vi) | 0, Te = Te + Math.imul(gn, xi) | 0, Te = Te + Math.imul(Gn, vi) | 0, Cr = Cr + Math.imul(Gn, xi) | 0, vr = vr + Math.imul(On, dn) | 0, Te = Te + Math.imul(On, xn) | 0, Te = Te + Math.imul(so, dn) | 0, Cr = Cr + Math.imul(so, xn) | 0;
        var wr = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (wr >>> 26) | 0, wr &= 67108863, vr = Math.imul(Hi, eo), Te = Math.imul(Hi, Ei), Te = Te + Math.imul(di, eo) | 0, Cr = Math.imul(di, Ei), vr = vr + Math.imul(hn, vi) | 0, Te = Te + Math.imul(hn, xi) | 0, Te = Te + Math.imul(Rn, vi) | 0, Cr = Cr + Math.imul(Rn, xi) | 0, vr = vr + Math.imul(gn, dn) | 0, Te = Te + Math.imul(gn, xn) | 0, Te = Te + Math.imul(Gn, dn) | 0, Cr = Cr + Math.imul(Gn, xn) | 0;
        var dr = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (dr >>> 26) | 0, dr &= 67108863, vr = Math.imul(Hi, vi), Te = Math.imul(Hi, xi), Te = Te + Math.imul(di, vi) | 0, Cr = Math.imul(di, xi), vr = vr + Math.imul(hn, dn) | 0, Te = Te + Math.imul(hn, xn) | 0, Te = Te + Math.imul(Rn, dn) | 0, Cr = Cr + Math.imul(Rn, xn) | 0;
        var Dr = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (Dr >>> 26) | 0, Dr &= 67108863, vr = Math.imul(Hi, dn), Te = Math.imul(Hi, xn), Te = Te + Math.imul(di, dn) | 0, Cr = Math.imul(di, xn);
        var Rr = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        return Or = (Cr + (Te >>> 13) | 0) + (Rr >>> 26) | 0, Rr &= 67108863, _r[0] = oi, _r[1] = Yr, _r[2] = ji, _r[3] = Cn, _r[4] = Mn, _r[5] = B, _r[6] = o, _r[7] = m, _r[8] = d, _r[9] = v, _r[10] = he, _r[11] = we, _r[12] = Be, _r[13] = Me, _r[14] = fr, _r[15] = wr, _r[16] = dr, _r[17] = Dr, _r[18] = Rr, Or !== 0 && (_r[19] = Or, rr.length++), rr;
      };
      Math.imul || (Pe = He);
      function nr(er, Ie, xe) {
        xe.negative = Ie.negative ^ er.negative, xe.length = er.length + Ie.length;
        for (var rr = 0, ar = 0, yr = 0; yr < xe.length - 1; yr++) {
          var _r = ar;
          ar = 0;
          for (var Or = rr & 67108863, vr = Math.min(yr, Ie.length - 1), Te = Math.max(0, yr - er.length + 1); Te <= vr; Te++) {
            var Cr = yr - Te, Hr = er.words[Cr] | 0, si = Ie.words[Te] | 0, ui = Hr * si, Li = ui & 67108863;
            _r = _r + (ui / 67108864 | 0) | 0, Li = Li + Or | 0, Or = Li & 67108863, _r = _r + (Li >>> 26) | 0, ar += _r >>> 26, _r &= 67108863;
          }
          xe.words[yr] = Or, rr = _r, _r = ar;
        }
        return rr !== 0 ? xe.words[yr] = rr : xe.length--, xe.strip();
      }
      function ir(er, Ie, xe) {
        var rr = new or();
        return rr.mulp(er, Ie, xe);
      }
      A.prototype.mulTo = function(Ie, xe) {
        var rr, ar = this.length + Ie.length;
        return this.length === 10 && Ie.length === 10 ? rr = Pe(this, Ie, xe) : ar < 63 ? rr = He(this, Ie, xe) : ar < 1024 ? rr = nr(this, Ie, xe) : rr = ir(this, Ie, xe), rr;
      };
      function or(er, Ie) {
        this.x = er, this.y = Ie;
      }
      or.prototype.makeRBT = function(Ie) {
        for (var xe = new Array(Ie), rr = A.prototype._countBits(Ie) - 1, ar = 0; ar < Ie; ar++)
          xe[ar] = this.revBin(ar, rr, Ie);
        return xe;
      }, or.prototype.revBin = function(Ie, xe, rr) {
        if (Ie === 0 || Ie === rr - 1) return Ie;
        for (var ar = 0, yr = 0; yr < xe; yr++)
          ar |= (Ie & 1) << xe - yr - 1, Ie >>= 1;
        return ar;
      }, or.prototype.permute = function(Ie, xe, rr, ar, yr, _r) {
        for (var Or = 0; Or < _r; Or++)
          ar[Or] = xe[Ie[Or]], yr[Or] = rr[Ie[Or]];
      }, or.prototype.transform = function(Ie, xe, rr, ar, yr, _r) {
        this.permute(_r, Ie, xe, rr, ar, yr);
        for (var Or = 1; Or < yr; Or <<= 1)
          for (var vr = Or << 1, Te = Math.cos(2 * Math.PI / vr), Cr = Math.sin(2 * Math.PI / vr), Hr = 0; Hr < yr; Hr += vr)
            for (var si = Te, ui = Cr, Li = 0; Li < Or; Li++) {
              var Qi = rr[Hr + Li], wi = ar[Hr + Li], Ji = rr[Hr + Li + Or], mn = ar[Hr + Li + Or], pi = si * Ji - ui * mn;
              mn = si * mn + ui * Ji, Ji = pi, rr[Hr + Li] = Qi + Ji, ar[Hr + Li] = wi + mn, rr[Hr + Li + Or] = Qi - Ji, ar[Hr + Li + Or] = wi - mn, Li !== vr && (pi = Te * si - Cr * ui, ui = Te * ui + Cr * si, si = pi);
            }
      }, or.prototype.guessLen13b = function(Ie, xe) {
        var rr = Math.max(xe, Ie) | 1, ar = rr & 1, yr = 0;
        for (rr = rr / 2 | 0; rr; rr = rr >>> 1)
          yr++;
        return 1 << yr + 1 + ar;
      }, or.prototype.conjugate = function(Ie, xe, rr) {
        if (!(rr <= 1))
          for (var ar = 0; ar < rr / 2; ar++) {
            var yr = Ie[ar];
            Ie[ar] = Ie[rr - ar - 1], Ie[rr - ar - 1] = yr, yr = xe[ar], xe[ar] = -xe[rr - ar - 1], xe[rr - ar - 1] = -yr;
          }
      }, or.prototype.normalize13b = function(Ie, xe) {
        for (var rr = 0, ar = 0; ar < xe / 2; ar++) {
          var yr = Math.round(Ie[2 * ar + 1] / xe) * 8192 + Math.round(Ie[2 * ar] / xe) + rr;
          Ie[ar] = yr & 67108863, yr < 67108864 ? rr = 0 : rr = yr / 67108864 | 0;
        }
        return Ie;
      }, or.prototype.convert13b = function(Ie, xe, rr, ar) {
        for (var yr = 0, _r = 0; _r < xe; _r++)
          yr = yr + (Ie[_r] | 0), rr[2 * _r] = yr & 8191, yr = yr >>> 13, rr[2 * _r + 1] = yr & 8191, yr = yr >>> 13;
        for (_r = 2 * xe; _r < ar; ++_r)
          rr[_r] = 0;
        p(yr === 0), p((yr & -8192) === 0);
      }, or.prototype.stub = function(Ie) {
        for (var xe = new Array(Ie), rr = 0; rr < Ie; rr++)
          xe[rr] = 0;
        return xe;
      }, or.prototype.mulp = function(Ie, xe, rr) {
        var ar = 2 * this.guessLen13b(Ie.length, xe.length), yr = this.makeRBT(ar), _r = this.stub(ar), Or = new Array(ar), vr = new Array(ar), Te = new Array(ar), Cr = new Array(ar), Hr = new Array(ar), si = new Array(ar), ui = rr.words;
        ui.length = ar, this.convert13b(Ie.words, Ie.length, Or, ar), this.convert13b(xe.words, xe.length, Cr, ar), this.transform(Or, _r, vr, Te, ar, yr), this.transform(Cr, _r, Hr, si, ar, yr);
        for (var Li = 0; Li < ar; Li++) {
          var Qi = vr[Li] * Hr[Li] - Te[Li] * si[Li];
          Te[Li] = vr[Li] * si[Li] + Te[Li] * Hr[Li], vr[Li] = Qi;
        }
        return this.conjugate(vr, Te, ar), this.transform(vr, Te, ui, _r, ar, yr), this.conjugate(ui, _r, ar), this.normalize13b(ui, ar), rr.negative = Ie.negative ^ xe.negative, rr.length = Ie.length + xe.length, rr.strip();
      }, A.prototype.mul = function(Ie) {
        var xe = new A(null);
        return xe.words = new Array(this.length + Ie.length), this.mulTo(Ie, xe);
      }, A.prototype.mulf = function(Ie) {
        var xe = new A(null);
        return xe.words = new Array(this.length + Ie.length), ir(this, Ie, xe);
      }, A.prototype.imul = function(Ie) {
        return this.clone().mulTo(Ie, this);
      }, A.prototype.imuln = function(Ie) {
        p(typeof Ie == "number"), p(Ie < 67108864);
        for (var xe = 0, rr = 0; rr < this.length; rr++) {
          var ar = (this.words[rr] | 0) * Ie, yr = (ar & 67108863) + (xe & 67108863);
          xe >>= 26, xe += ar / 67108864 | 0, xe += yr >>> 26, this.words[rr] = yr & 67108863;
        }
        return xe !== 0 && (this.words[rr] = xe, this.length++), this;
      }, A.prototype.muln = function(Ie) {
        return this.clone().imuln(Ie);
      }, A.prototype.sqr = function() {
        return this.mul(this);
      }, A.prototype.isqr = function() {
        return this.imul(this.clone());
      }, A.prototype.pow = function(Ie) {
        var xe = be(Ie);
        if (xe.length === 0) return new A(1);
        for (var rr = this, ar = 0; ar < xe.length && xe[ar] === 0; ar++, rr = rr.sqr())
          ;
        if (++ar < xe.length)
          for (var yr = rr.sqr(); ar < xe.length; ar++, yr = yr.sqr())
            xe[ar] !== 0 && (rr = rr.mul(yr));
        return rr;
      }, A.prototype.iushln = function(Ie) {
        p(typeof Ie == "number" && Ie >= 0);
        var xe = Ie % 26, rr = (Ie - xe) / 26, ar = 67108863 >>> 26 - xe << 26 - xe, yr;
        if (xe !== 0) {
          var _r = 0;
          for (yr = 0; yr < this.length; yr++) {
            var Or = this.words[yr] & ar, vr = (this.words[yr] | 0) - Or << xe;
            this.words[yr] = vr | _r, _r = Or >>> 26 - xe;
          }
          _r && (this.words[yr] = _r, this.length++);
        }
        if (rr !== 0) {
          for (yr = this.length - 1; yr >= 0; yr--)
            this.words[yr + rr] = this.words[yr];
          for (yr = 0; yr < rr; yr++)
            this.words[yr] = 0;
          this.length += rr;
        }
        return this.strip();
      }, A.prototype.ishln = function(Ie) {
        return p(this.negative === 0), this.iushln(Ie);
      }, A.prototype.iushrn = function(Ie, xe, rr) {
        p(typeof Ie == "number" && Ie >= 0);
        var ar;
        xe ? ar = (xe - xe % 26) / 26 : ar = 0;
        var yr = Ie % 26, _r = Math.min((Ie - yr) / 26, this.length), Or = 67108863 ^ 67108863 >>> yr << yr, vr = rr;
        if (ar -= _r, ar = Math.max(0, ar), vr) {
          for (var Te = 0; Te < _r; Te++)
            vr.words[Te] = this.words[Te];
          vr.length = _r;
        }
        if (_r !== 0) if (this.length > _r)
          for (this.length -= _r, Te = 0; Te < this.length; Te++)
            this.words[Te] = this.words[Te + _r];
        else
          this.words[0] = 0, this.length = 1;
        var Cr = 0;
        for (Te = this.length - 1; Te >= 0 && (Cr !== 0 || Te >= ar); Te--) {
          var Hr = this.words[Te] | 0;
          this.words[Te] = Cr << 26 - yr | Hr >>> yr, Cr = Hr & Or;
        }
        return vr && Cr !== 0 && (vr.words[vr.length++] = Cr), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, A.prototype.ishrn = function(Ie, xe, rr) {
        return p(this.negative === 0), this.iushrn(Ie, xe, rr);
      }, A.prototype.shln = function(Ie) {
        return this.clone().ishln(Ie);
      }, A.prototype.ushln = function(Ie) {
        return this.clone().iushln(Ie);
      }, A.prototype.shrn = function(Ie) {
        return this.clone().ishrn(Ie);
      }, A.prototype.ushrn = function(Ie) {
        return this.clone().iushrn(Ie);
      }, A.prototype.testn = function(Ie) {
        p(typeof Ie == "number" && Ie >= 0);
        var xe = Ie % 26, rr = (Ie - xe) / 26, ar = 1 << xe;
        if (this.length <= rr) return !1;
        var yr = this.words[rr];
        return !!(yr & ar);
      }, A.prototype.imaskn = function(Ie) {
        p(typeof Ie == "number" && Ie >= 0);
        var xe = Ie % 26, rr = (Ie - xe) / 26;
        if (p(this.negative === 0, "imaskn works only with positive numbers"), this.length <= rr)
          return this;
        if (xe !== 0 && rr++, this.length = Math.min(rr, this.length), xe !== 0) {
          var ar = 67108863 ^ 67108863 >>> xe << xe;
          this.words[this.length - 1] &= ar;
        }
        return this.strip();
      }, A.prototype.maskn = function(Ie) {
        return this.clone().imaskn(Ie);
      }, A.prototype.iaddn = function(Ie) {
        return p(typeof Ie == "number"), p(Ie < 67108864), Ie < 0 ? this.isubn(-Ie) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < Ie ? (this.words[0] = Ie - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(Ie), this.negative = 1, this) : this._iaddn(Ie);
      }, A.prototype._iaddn = function(Ie) {
        this.words[0] += Ie;
        for (var xe = 0; xe < this.length && this.words[xe] >= 67108864; xe++)
          this.words[xe] -= 67108864, xe === this.length - 1 ? this.words[xe + 1] = 1 : this.words[xe + 1]++;
        return this.length = Math.max(this.length, xe + 1), this;
      }, A.prototype.isubn = function(Ie) {
        if (p(typeof Ie == "number"), p(Ie < 67108864), Ie < 0) return this.iaddn(-Ie);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(Ie), this.negative = 1, this;
        if (this.words[0] -= Ie, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var xe = 0; xe < this.length && this.words[xe] < 0; xe++)
            this.words[xe] += 67108864, this.words[xe + 1] -= 1;
        return this.strip();
      }, A.prototype.addn = function(Ie) {
        return this.clone().iaddn(Ie);
      }, A.prototype.subn = function(Ie) {
        return this.clone().isubn(Ie);
      }, A.prototype.iabs = function() {
        return this.negative = 0, this;
      }, A.prototype.abs = function() {
        return this.clone().iabs();
      }, A.prototype._ishlnsubmul = function(Ie, xe, rr) {
        var ar = Ie.length + rr, yr;
        this._expand(ar);
        var _r, Or = 0;
        for (yr = 0; yr < Ie.length; yr++) {
          _r = (this.words[yr + rr] | 0) + Or;
          var vr = (Ie.words[yr] | 0) * xe;
          _r -= vr & 67108863, Or = (_r >> 26) - (vr / 67108864 | 0), this.words[yr + rr] = _r & 67108863;
        }
        for (; yr < this.length - rr; yr++)
          _r = (this.words[yr + rr] | 0) + Or, Or = _r >> 26, this.words[yr + rr] = _r & 67108863;
        if (Or === 0) return this.strip();
        for (p(Or === -1), Or = 0, yr = 0; yr < this.length; yr++)
          _r = -(this.words[yr] | 0) + Or, Or = _r >> 26, this.words[yr] = _r & 67108863;
        return this.negative = 1, this.strip();
      }, A.prototype._wordDiv = function(Ie, xe) {
        var rr = this.length - Ie.length, ar = this.clone(), yr = Ie, _r = yr.words[yr.length - 1] | 0, Or = this._countBits(_r);
        rr = 26 - Or, rr !== 0 && (yr = yr.ushln(rr), ar.iushln(rr), _r = yr.words[yr.length - 1] | 0);
        var vr = ar.length - yr.length, Te;
        if (xe !== "mod") {
          Te = new A(null), Te.length = vr + 1, Te.words = new Array(Te.length);
          for (var Cr = 0; Cr < Te.length; Cr++)
            Te.words[Cr] = 0;
        }
        var Hr = ar.clone()._ishlnsubmul(yr, 1, vr);
        Hr.negative === 0 && (ar = Hr, Te && (Te.words[vr] = 1));
        for (var si = vr - 1; si >= 0; si--) {
          var ui = (ar.words[yr.length + si] | 0) * 67108864 + (ar.words[yr.length + si - 1] | 0);
          for (ui = Math.min(ui / _r | 0, 67108863), ar._ishlnsubmul(yr, ui, si); ar.negative !== 0; )
            ui--, ar.negative = 0, ar._ishlnsubmul(yr, 1, si), ar.isZero() || (ar.negative ^= 1);
          Te && (Te.words[si] = ui);
        }
        return Te && Te.strip(), ar.strip(), xe !== "div" && rr !== 0 && ar.iushrn(rr), {
          div: Te || null,
          mod: ar
        };
      }, A.prototype.divmod = function(Ie, xe, rr) {
        if (p(!Ie.isZero()), this.isZero())
          return {
            div: new A(0),
            mod: new A(0)
          };
        var ar, yr, _r;
        return this.negative !== 0 && Ie.negative === 0 ? (_r = this.neg().divmod(Ie, xe), xe !== "mod" && (ar = _r.div.neg()), xe !== "div" && (yr = _r.mod.neg(), rr && yr.negative !== 0 && yr.iadd(Ie)), {
          div: ar,
          mod: yr
        }) : this.negative === 0 && Ie.negative !== 0 ? (_r = this.divmod(Ie.neg(), xe), xe !== "mod" && (ar = _r.div.neg()), {
          div: ar,
          mod: _r.mod
        }) : this.negative & Ie.negative ? (_r = this.neg().divmod(Ie.neg(), xe), xe !== "div" && (yr = _r.mod.neg(), rr && yr.negative !== 0 && yr.isub(Ie)), {
          div: _r.div,
          mod: yr
        }) : Ie.length > this.length || this.cmp(Ie) < 0 ? {
          div: new A(0),
          mod: this
        } : Ie.length === 1 ? xe === "div" ? {
          div: this.divn(Ie.words[0]),
          mod: null
        } : xe === "mod" ? {
          div: null,
          mod: new A(this.modn(Ie.words[0]))
        } : {
          div: this.divn(Ie.words[0]),
          mod: new A(this.modn(Ie.words[0]))
        } : this._wordDiv(Ie, xe);
      }, A.prototype.div = function(Ie) {
        return this.divmod(Ie, "div", !1).div;
      }, A.prototype.mod = function(Ie) {
        return this.divmod(Ie, "mod", !1).mod;
      }, A.prototype.umod = function(Ie) {
        return this.divmod(Ie, "mod", !0).mod;
      }, A.prototype.divRound = function(Ie) {
        var xe = this.divmod(Ie);
        if (xe.mod.isZero()) return xe.div;
        var rr = xe.div.negative !== 0 ? xe.mod.isub(Ie) : xe.mod, ar = Ie.ushrn(1), yr = Ie.andln(1), _r = rr.cmp(ar);
        return _r < 0 || yr === 1 && _r === 0 ? xe.div : xe.div.negative !== 0 ? xe.div.isubn(1) : xe.div.iaddn(1);
      }, A.prototype.modn = function(Ie) {
        p(Ie <= 67108863);
        for (var xe = (1 << 26) % Ie, rr = 0, ar = this.length - 1; ar >= 0; ar--)
          rr = (xe * rr + (this.words[ar] | 0)) % Ie;
        return rr;
      }, A.prototype.idivn = function(Ie) {
        p(Ie <= 67108863);
        for (var xe = 0, rr = this.length - 1; rr >= 0; rr--) {
          var ar = (this.words[rr] | 0) + xe * 67108864;
          this.words[rr] = ar / Ie | 0, xe = ar % Ie;
        }
        return this.strip();
      }, A.prototype.divn = function(Ie) {
        return this.clone().idivn(Ie);
      }, A.prototype.egcd = function(Ie) {
        p(Ie.negative === 0), p(!Ie.isZero());
        var xe = this, rr = Ie.clone();
        xe.negative !== 0 ? xe = xe.umod(Ie) : xe = xe.clone();
        for (var ar = new A(1), yr = new A(0), _r = new A(0), Or = new A(1), vr = 0; xe.isEven() && rr.isEven(); )
          xe.iushrn(1), rr.iushrn(1), ++vr;
        for (var Te = rr.clone(), Cr = xe.clone(); !xe.isZero(); ) {
          for (var Hr = 0, si = 1; !(xe.words[0] & si) && Hr < 26; ++Hr, si <<= 1) ;
          if (Hr > 0)
            for (xe.iushrn(Hr); Hr-- > 0; )
              (ar.isOdd() || yr.isOdd()) && (ar.iadd(Te), yr.isub(Cr)), ar.iushrn(1), yr.iushrn(1);
          for (var ui = 0, Li = 1; !(rr.words[0] & Li) && ui < 26; ++ui, Li <<= 1) ;
          if (ui > 0)
            for (rr.iushrn(ui); ui-- > 0; )
              (_r.isOdd() || Or.isOdd()) && (_r.iadd(Te), Or.isub(Cr)), _r.iushrn(1), Or.iushrn(1);
          xe.cmp(rr) >= 0 ? (xe.isub(rr), ar.isub(_r), yr.isub(Or)) : (rr.isub(xe), _r.isub(ar), Or.isub(yr));
        }
        return {
          a: _r,
          b: Or,
          gcd: rr.iushln(vr)
        };
      }, A.prototype._invmp = function(Ie) {
        p(Ie.negative === 0), p(!Ie.isZero());
        var xe = this, rr = Ie.clone();
        xe.negative !== 0 ? xe = xe.umod(Ie) : xe = xe.clone();
        for (var ar = new A(1), yr = new A(0), _r = rr.clone(); xe.cmpn(1) > 0 && rr.cmpn(1) > 0; ) {
          for (var Or = 0, vr = 1; !(xe.words[0] & vr) && Or < 26; ++Or, vr <<= 1) ;
          if (Or > 0)
            for (xe.iushrn(Or); Or-- > 0; )
              ar.isOdd() && ar.iadd(_r), ar.iushrn(1);
          for (var Te = 0, Cr = 1; !(rr.words[0] & Cr) && Te < 26; ++Te, Cr <<= 1) ;
          if (Te > 0)
            for (rr.iushrn(Te); Te-- > 0; )
              yr.isOdd() && yr.iadd(_r), yr.iushrn(1);
          xe.cmp(rr) >= 0 ? (xe.isub(rr), ar.isub(yr)) : (rr.isub(xe), yr.isub(ar));
        }
        var Hr;
        return xe.cmpn(1) === 0 ? Hr = ar : Hr = yr, Hr.cmpn(0) < 0 && Hr.iadd(Ie), Hr;
      }, A.prototype.gcd = function(Ie) {
        if (this.isZero()) return Ie.abs();
        if (Ie.isZero()) return this.abs();
        var xe = this.clone(), rr = Ie.clone();
        xe.negative = 0, rr.negative = 0;
        for (var ar = 0; xe.isEven() && rr.isEven(); ar++)
          xe.iushrn(1), rr.iushrn(1);
        do {
          for (; xe.isEven(); )
            xe.iushrn(1);
          for (; rr.isEven(); )
            rr.iushrn(1);
          var yr = xe.cmp(rr);
          if (yr < 0) {
            var _r = xe;
            xe = rr, rr = _r;
          } else if (yr === 0 || rr.cmpn(1) === 0)
            break;
          xe.isub(rr);
        } while (!0);
        return rr.iushln(ar);
      }, A.prototype.invm = function(Ie) {
        return this.egcd(Ie).a.umod(Ie);
      }, A.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, A.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, A.prototype.andln = function(Ie) {
        return this.words[0] & Ie;
      }, A.prototype.bincn = function(Ie) {
        p(typeof Ie == "number");
        var xe = Ie % 26, rr = (Ie - xe) / 26, ar = 1 << xe;
        if (this.length <= rr)
          return this._expand(rr + 1), this.words[rr] |= ar, this;
        for (var yr = ar, _r = rr; yr !== 0 && _r < this.length; _r++) {
          var Or = this.words[_r] | 0;
          Or += yr, yr = Or >>> 26, Or &= 67108863, this.words[_r] = Or;
        }
        return yr !== 0 && (this.words[_r] = yr, this.length++), this;
      }, A.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, A.prototype.cmpn = function(Ie) {
        var xe = Ie < 0;
        if (this.negative !== 0 && !xe) return -1;
        if (this.negative === 0 && xe) return 1;
        this.strip();
        var rr;
        if (this.length > 1)
          rr = 1;
        else {
          xe && (Ie = -Ie), p(Ie <= 67108863, "Number is too big");
          var ar = this.words[0] | 0;
          rr = ar === Ie ? 0 : ar < Ie ? -1 : 1;
        }
        return this.negative !== 0 ? -rr | 0 : rr;
      }, A.prototype.cmp = function(Ie) {
        if (this.negative !== 0 && Ie.negative === 0) return -1;
        if (this.negative === 0 && Ie.negative !== 0) return 1;
        var xe = this.ucmp(Ie);
        return this.negative !== 0 ? -xe | 0 : xe;
      }, A.prototype.ucmp = function(Ie) {
        if (this.length > Ie.length) return 1;
        if (this.length < Ie.length) return -1;
        for (var xe = 0, rr = this.length - 1; rr >= 0; rr--) {
          var ar = this.words[rr] | 0, yr = Ie.words[rr] | 0;
          if (ar !== yr) {
            ar < yr ? xe = -1 : ar > yr && (xe = 1);
            break;
          }
        }
        return xe;
      }, A.prototype.gtn = function(Ie) {
        return this.cmpn(Ie) === 1;
      }, A.prototype.gt = function(Ie) {
        return this.cmp(Ie) === 1;
      }, A.prototype.gten = function(Ie) {
        return this.cmpn(Ie) >= 0;
      }, A.prototype.gte = function(Ie) {
        return this.cmp(Ie) >= 0;
      }, A.prototype.ltn = function(Ie) {
        return this.cmpn(Ie) === -1;
      }, A.prototype.lt = function(Ie) {
        return this.cmp(Ie) === -1;
      }, A.prototype.lten = function(Ie) {
        return this.cmpn(Ie) <= 0;
      }, A.prototype.lte = function(Ie) {
        return this.cmp(Ie) <= 0;
      }, A.prototype.eqn = function(Ie) {
        return this.cmpn(Ie) === 0;
      }, A.prototype.eq = function(Ie) {
        return this.cmp(Ie) === 0;
      }, A.red = function(Ie) {
        return new Fe(Ie);
      }, A.prototype.toRed = function(Ie) {
        return p(!this.red, "Already a number in reduction context"), p(this.negative === 0, "red works only with positives"), Ie.convertTo(this)._forceRed(Ie);
      }, A.prototype.fromRed = function() {
        return p(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, A.prototype._forceRed = function(Ie) {
        return this.red = Ie, this;
      }, A.prototype.forceRed = function(Ie) {
        return p(!this.red, "Already a number in reduction context"), this._forceRed(Ie);
      }, A.prototype.redAdd = function(Ie) {
        return p(this.red, "redAdd works only with red numbers"), this.red.add(this, Ie);
      }, A.prototype.redIAdd = function(Ie) {
        return p(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, Ie);
      }, A.prototype.redSub = function(Ie) {
        return p(this.red, "redSub works only with red numbers"), this.red.sub(this, Ie);
      }, A.prototype.redISub = function(Ie) {
        return p(this.red, "redISub works only with red numbers"), this.red.isub(this, Ie);
      }, A.prototype.redShl = function(Ie) {
        return p(this.red, "redShl works only with red numbers"), this.red.shl(this, Ie);
      }, A.prototype.redMul = function(Ie) {
        return p(this.red, "redMul works only with red numbers"), this.red._verify2(this, Ie), this.red.mul(this, Ie);
      }, A.prototype.redIMul = function(Ie) {
        return p(this.red, "redMul works only with red numbers"), this.red._verify2(this, Ie), this.red.imul(this, Ie);
      }, A.prototype.redSqr = function() {
        return p(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, A.prototype.redISqr = function() {
        return p(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, A.prototype.redSqrt = function() {
        return p(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, A.prototype.redInvm = function() {
        return p(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, A.prototype.redNeg = function() {
        return p(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, A.prototype.redPow = function(Ie) {
        return p(this.red && !Ie.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, Ie);
      };
      var lr = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function Ir(er, Ie) {
        this.name = er, this.p = new A(Ie, 16), this.n = this.p.bitLength(), this.k = new A(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      Ir.prototype._tmp = function() {
        var Ie = new A(null);
        return Ie.words = new Array(Math.ceil(this.n / 13)), Ie;
      }, Ir.prototype.ireduce = function(Ie) {
        var xe = Ie, rr;
        do
          this.split(xe, this.tmp), xe = this.imulK(xe), xe = xe.iadd(this.tmp), rr = xe.bitLength();
        while (rr > this.n);
        var ar = rr < this.n ? -1 : xe.ucmp(this.p);
        return ar === 0 ? (xe.words[0] = 0, xe.length = 1) : ar > 0 ? xe.isub(this.p) : xe.strip !== void 0 ? xe.strip() : xe._strip(), xe;
      }, Ir.prototype.split = function(Ie, xe) {
        Ie.iushrn(this.n, 0, xe);
      }, Ir.prototype.imulK = function(Ie) {
        return Ie.imul(this.k);
      };
      function xr() {
        Ir.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      a(xr, Ir), xr.prototype.split = function(Ie, xe) {
        for (var rr = 4194303, ar = Math.min(Ie.length, 9), yr = 0; yr < ar; yr++)
          xe.words[yr] = Ie.words[yr];
        if (xe.length = ar, Ie.length <= 9) {
          Ie.words[0] = 0, Ie.length = 1;
          return;
        }
        var _r = Ie.words[9];
        for (xe.words[xe.length++] = _r & rr, yr = 10; yr < Ie.length; yr++) {
          var Or = Ie.words[yr] | 0;
          Ie.words[yr - 10] = (Or & rr) << 4 | _r >>> 22, _r = Or;
        }
        _r >>>= 22, Ie.words[yr - 10] = _r, _r === 0 && Ie.length > 10 ? Ie.length -= 10 : Ie.length -= 9;
      }, xr.prototype.imulK = function(Ie) {
        Ie.words[Ie.length] = 0, Ie.words[Ie.length + 1] = 0, Ie.length += 2;
        for (var xe = 0, rr = 0; rr < Ie.length; rr++) {
          var ar = Ie.words[rr] | 0;
          xe += ar * 977, Ie.words[rr] = xe & 67108863, xe = ar * 64 + (xe / 67108864 | 0);
        }
        return Ie.words[Ie.length - 1] === 0 && (Ie.length--, Ie.words[Ie.length - 1] === 0 && Ie.length--), Ie;
      };
      function kr() {
        Ir.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      a(kr, Ir);
      function Ce() {
        Ir.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      a(Ce, Ir);
      function tr() {
        Ir.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      a(tr, Ir), tr.prototype.imulK = function(Ie) {
        for (var xe = 0, rr = 0; rr < Ie.length; rr++) {
          var ar = (Ie.words[rr] | 0) * 19 + xe, yr = ar & 67108863;
          ar >>>= 26, Ie.words[rr] = yr, xe = ar;
        }
        return xe !== 0 && (Ie.words[Ie.length++] = xe), Ie;
      }, A._prime = function(Ie) {
        if (lr[Ie]) return lr[Ie];
        var xe;
        if (Ie === "k256")
          xe = new xr();
        else if (Ie === "p224")
          xe = new kr();
        else if (Ie === "p192")
          xe = new Ce();
        else if (Ie === "p25519")
          xe = new tr();
        else
          throw new Error("Unknown prime " + Ie);
        return lr[Ie] = xe, xe;
      };
      function Fe(er) {
        if (typeof er == "string") {
          var Ie = A._prime(er);
          this.m = Ie.p, this.prime = Ie;
        } else
          p(er.gtn(1), "modulus must be greater than 1"), this.m = er, this.prime = null;
      }
      Fe.prototype._verify1 = function(Ie) {
        p(Ie.negative === 0, "red works only with positives"), p(Ie.red, "red works only with red numbers");
      }, Fe.prototype._verify2 = function(Ie, xe) {
        p((Ie.negative | xe.negative) === 0, "red works only with positives"), p(
          Ie.red && Ie.red === xe.red,
          "red works only with red numbers"
        );
      }, Fe.prototype.imod = function(Ie) {
        return this.prime ? this.prime.ireduce(Ie)._forceRed(this) : Ie.umod(this.m)._forceRed(this);
      }, Fe.prototype.neg = function(Ie) {
        return Ie.isZero() ? Ie.clone() : this.m.sub(Ie)._forceRed(this);
      }, Fe.prototype.add = function(Ie, xe) {
        this._verify2(Ie, xe);
        var rr = Ie.add(xe);
        return rr.cmp(this.m) >= 0 && rr.isub(this.m), rr._forceRed(this);
      }, Fe.prototype.iadd = function(Ie, xe) {
        this._verify2(Ie, xe);
        var rr = Ie.iadd(xe);
        return rr.cmp(this.m) >= 0 && rr.isub(this.m), rr;
      }, Fe.prototype.sub = function(Ie, xe) {
        this._verify2(Ie, xe);
        var rr = Ie.sub(xe);
        return rr.cmpn(0) < 0 && rr.iadd(this.m), rr._forceRed(this);
      }, Fe.prototype.isub = function(Ie, xe) {
        this._verify2(Ie, xe);
        var rr = Ie.isub(xe);
        return rr.cmpn(0) < 0 && rr.iadd(this.m), rr;
      }, Fe.prototype.shl = function(Ie, xe) {
        return this._verify1(Ie), this.imod(Ie.ushln(xe));
      }, Fe.prototype.imul = function(Ie, xe) {
        return this._verify2(Ie, xe), this.imod(Ie.imul(xe));
      }, Fe.prototype.mul = function(Ie, xe) {
        return this._verify2(Ie, xe), this.imod(Ie.mul(xe));
      }, Fe.prototype.isqr = function(Ie) {
        return this.imul(Ie, Ie.clone());
      }, Fe.prototype.sqr = function(Ie) {
        return this.mul(Ie, Ie);
      }, Fe.prototype.sqrt = function(Ie) {
        if (Ie.isZero()) return Ie.clone();
        var xe = this.m.andln(3);
        if (p(xe % 2 === 1), xe === 3) {
          var rr = this.m.add(new A(1)).iushrn(2);
          return this.pow(Ie, rr);
        }
        for (var ar = this.m.subn(1), yr = 0; !ar.isZero() && ar.andln(1) === 0; )
          yr++, ar.iushrn(1);
        p(!ar.isZero());
        var _r = new A(1).toRed(this), Or = _r.redNeg(), vr = this.m.subn(1).iushrn(1), Te = this.m.bitLength();
        for (Te = new A(2 * Te * Te).toRed(this); this.pow(Te, vr).cmp(Or) !== 0; )
          Te.redIAdd(Or);
        for (var Cr = this.pow(Te, ar), Hr = this.pow(Ie, ar.addn(1).iushrn(1)), si = this.pow(Ie, ar), ui = yr; si.cmp(_r) !== 0; ) {
          for (var Li = si, Qi = 0; Li.cmp(_r) !== 0; Qi++)
            Li = Li.redSqr();
          p(Qi < ui);
          var wi = this.pow(Cr, new A(1).iushln(ui - Qi - 1));
          Hr = Hr.redMul(wi), Cr = wi.redSqr(), si = si.redMul(Cr), ui = Qi;
        }
        return Hr;
      }, Fe.prototype.invm = function(Ie) {
        var xe = Ie._invmp(this.m);
        return xe.negative !== 0 ? (xe.negative = 0, this.imod(xe).redNeg()) : this.imod(xe);
      }, Fe.prototype.pow = function(Ie, xe) {
        if (xe.isZero()) return new A(1).toRed(this);
        if (xe.cmpn(1) === 0) return Ie.clone();
        var rr = 4, ar = new Array(1 << rr);
        ar[0] = new A(1).toRed(this), ar[1] = Ie;
        for (var yr = 2; yr < ar.length; yr++)
          ar[yr] = this.mul(ar[yr - 1], Ie);
        var _r = ar[0], Or = 0, vr = 0, Te = xe.bitLength() % 26;
        for (Te === 0 && (Te = 26), yr = xe.length - 1; yr >= 0; yr--) {
          for (var Cr = xe.words[yr], Hr = Te - 1; Hr >= 0; Hr--) {
            var si = Cr >> Hr & 1;
            if (_r !== ar[0] && (_r = this.sqr(_r)), si === 0 && Or === 0) {
              vr = 0;
              continue;
            }
            Or <<= 1, Or |= si, vr++, !(vr !== rr && (yr !== 0 || Hr !== 0)) && (_r = this.mul(_r, ar[Or]), vr = 0, Or = 0);
          }
          Te = 26;
        }
        return _r;
      }, Fe.prototype.convertTo = function(Ie) {
        var xe = Ie.umod(this.m);
        return xe === Ie ? xe.clone() : xe;
      }, Fe.prototype.convertFrom = function(Ie) {
        var xe = Ie.clone();
        return xe.red = null, xe;
      }, A.mont = function(Ie) {
        return new Sr(Ie);
      };
      function Sr(er) {
        Fe.call(this, er), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new A(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      a(Sr, Fe), Sr.prototype.convertTo = function(Ie) {
        return this.imod(Ie.ushln(this.shift));
      }, Sr.prototype.convertFrom = function(Ie) {
        var xe = this.imod(Ie.mul(this.rinv));
        return xe.red = null, xe;
      }, Sr.prototype.imul = function(Ie, xe) {
        if (Ie.isZero() || xe.isZero())
          return Ie.words[0] = 0, Ie.length = 1, Ie;
        var rr = Ie.imul(xe), ar = rr.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), yr = rr.isub(ar).iushrn(this.shift), _r = yr;
        return yr.cmp(this.m) >= 0 ? _r = yr.isub(this.m) : yr.cmpn(0) < 0 && (_r = yr.iadd(this.m)), _r._forceRed(this);
      }, Sr.prototype.mul = function(Ie, xe) {
        if (Ie.isZero() || xe.isZero()) return new A(0)._forceRed(this);
        var rr = Ie.mul(xe), ar = rr.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), yr = rr.isub(ar).iushrn(this.shift), _r = yr;
        return yr.cmp(this.m) >= 0 ? _r = yr.isub(this.m) : yr.cmpn(0) < 0 && (_r = yr.iadd(this.m)), _r._forceRed(this);
      }, Sr.prototype.invm = function(Ie) {
        var xe = this.imod(Ie._invmp(this.m).mul(this.r2));
        return xe._forceRed(this);
      };
    })(n, commonjsGlobal);
  }(bn$6)), bn$6.exports;
}
var bn$5 = { exports: {} };
bn$5.exports;
var hasRequiredBn$3;
function requireBn$3() {
  return hasRequiredBn$3 || (hasRequiredBn$3 = 1, function(n) {
    (function(c, u) {
      function p(er, Ie) {
        if (!er) throw new Error(Ie || "Assertion failed");
      }
      function a(er, Ie) {
        er.super_ = Ie;
        var xe = function() {
        };
        xe.prototype = Ie.prototype, er.prototype = new xe(), er.prototype.constructor = er;
      }
      function A(er, Ie, xe) {
        if (A.isBN(er))
          return er;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, er !== null && ((Ie === "le" || Ie === "be") && (xe = Ie, Ie = 10), this._init(er || 0, Ie || 10, xe || "be"));
      }
      typeof c == "object" ? c.exports = A : u.BN = A, A.BN = A, A.wordSize = 26;
      var b;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? b = window.Buffer : b = require$$0$5.Buffer;
      } catch {
      }
      A.isBN = function(Ie) {
        return Ie instanceof A ? !0 : Ie !== null && typeof Ie == "object" && Ie.constructor.wordSize === A.wordSize && Array.isArray(Ie.words);
      }, A.max = function(Ie, xe) {
        return Ie.cmp(xe) > 0 ? Ie : xe;
      }, A.min = function(Ie, xe) {
        return Ie.cmp(xe) < 0 ? Ie : xe;
      }, A.prototype._init = function(Ie, xe, rr) {
        if (typeof Ie == "number")
          return this._initNumber(Ie, xe, rr);
        if (typeof Ie == "object")
          return this._initArray(Ie, xe, rr);
        xe === "hex" && (xe = 16), p(xe === (xe | 0) && xe >= 2 && xe <= 36), Ie = Ie.toString().replace(/\s+/g, "");
        var ar = 0;
        Ie[0] === "-" && (ar++, this.negative = 1), ar < Ie.length && (xe === 16 ? this._parseHex(Ie, ar, rr) : (this._parseBase(Ie, xe, ar), rr === "le" && this._initArray(this.toArray(), xe, rr)));
      }, A.prototype._initNumber = function(Ie, xe, rr) {
        Ie < 0 && (this.negative = 1, Ie = -Ie), Ie < 67108864 ? (this.words = [Ie & 67108863], this.length = 1) : Ie < 4503599627370496 ? (this.words = [
          Ie & 67108863,
          Ie / 67108864 & 67108863
        ], this.length = 2) : (p(Ie < 9007199254740992), this.words = [
          Ie & 67108863,
          Ie / 67108864 & 67108863,
          1
        ], this.length = 3), rr === "le" && this._initArray(this.toArray(), xe, rr);
      }, A.prototype._initArray = function(Ie, xe, rr) {
        if (p(typeof Ie.length == "number"), Ie.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(Ie.length / 3), this.words = new Array(this.length);
        for (var ar = 0; ar < this.length; ar++)
          this.words[ar] = 0;
        var yr, _r, Or = 0;
        if (rr === "be")
          for (ar = Ie.length - 1, yr = 0; ar >= 0; ar -= 3)
            _r = Ie[ar] | Ie[ar - 1] << 8 | Ie[ar - 2] << 16, this.words[yr] |= _r << Or & 67108863, this.words[yr + 1] = _r >>> 26 - Or & 67108863, Or += 24, Or >= 26 && (Or -= 26, yr++);
        else if (rr === "le")
          for (ar = 0, yr = 0; ar < Ie.length; ar += 3)
            _r = Ie[ar] | Ie[ar + 1] << 8 | Ie[ar + 2] << 16, this.words[yr] |= _r << Or & 67108863, this.words[yr + 1] = _r >>> 26 - Or & 67108863, Or += 24, Or >= 26 && (Or -= 26, yr++);
        return this.strip();
      };
      function F(er, Ie) {
        var xe = er.charCodeAt(Ie);
        return xe >= 65 && xe <= 70 ? xe - 55 : xe >= 97 && xe <= 102 ? xe - 87 : xe - 48 & 15;
      }
      function le(er, Ie, xe) {
        var rr = F(er, xe);
        return xe - 1 >= Ie && (rr |= F(er, xe - 1) << 4), rr;
      }
      A.prototype._parseHex = function(Ie, xe, rr) {
        this.length = Math.ceil((Ie.length - xe) / 6), this.words = new Array(this.length);
        for (var ar = 0; ar < this.length; ar++)
          this.words[ar] = 0;
        var yr = 0, _r = 0, Or;
        if (rr === "be")
          for (ar = Ie.length - 1; ar >= xe; ar -= 2)
            Or = le(Ie, xe, ar) << yr, this.words[_r] |= Or & 67108863, yr >= 18 ? (yr -= 18, _r += 1, this.words[_r] |= Or >>> 26) : yr += 8;
        else {
          var vr = Ie.length - xe;
          for (ar = vr % 2 === 0 ? xe + 1 : xe; ar < Ie.length; ar += 2)
            Or = le(Ie, xe, ar) << yr, this.words[_r] |= Or & 67108863, yr >= 18 ? (yr -= 18, _r += 1, this.words[_r] |= Or >>> 26) : yr += 8;
        }
        this.strip();
      };
      function L(er, Ie, xe, rr) {
        for (var ar = 0, yr = Math.min(er.length, xe), _r = Ie; _r < yr; _r++) {
          var Or = er.charCodeAt(_r) - 48;
          ar *= rr, Or >= 49 ? ar += Or - 49 + 10 : Or >= 17 ? ar += Or - 17 + 10 : ar += Or;
        }
        return ar;
      }
      A.prototype._parseBase = function(Ie, xe, rr) {
        this.words = [0], this.length = 1;
        for (var ar = 0, yr = 1; yr <= 67108863; yr *= xe)
          ar++;
        ar--, yr = yr / xe | 0;
        for (var _r = Ie.length - rr, Or = _r % ar, vr = Math.min(_r, _r - Or) + rr, Te = 0, Cr = rr; Cr < vr; Cr += ar)
          Te = L(Ie, Cr, Cr + ar, xe), this.imuln(yr), this.words[0] + Te < 67108864 ? this.words[0] += Te : this._iaddn(Te);
        if (Or !== 0) {
          var Hr = 1;
          for (Te = L(Ie, Cr, Ie.length, xe), Cr = 0; Cr < Or; Cr++)
            Hr *= xe;
          this.imuln(Hr), this.words[0] + Te < 67108864 ? this.words[0] += Te : this._iaddn(Te);
        }
        this.strip();
      }, A.prototype.copy = function(Ie) {
        Ie.words = new Array(this.length);
        for (var xe = 0; xe < this.length; xe++)
          Ie.words[xe] = this.words[xe];
        Ie.length = this.length, Ie.negative = this.negative, Ie.red = this.red;
      }, A.prototype.clone = function() {
        var Ie = new A(null);
        return this.copy(Ie), Ie;
      }, A.prototype._expand = function(Ie) {
        for (; this.length < Ie; )
          this.words[this.length++] = 0;
        return this;
      }, A.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, A.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, A.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var pe = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], $ = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], Ee = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      A.prototype.toString = function(Ie, xe) {
        Ie = Ie || 10, xe = xe | 0 || 1;
        var rr;
        if (Ie === 16 || Ie === "hex") {
          rr = "";
          for (var ar = 0, yr = 0, _r = 0; _r < this.length; _r++) {
            var Or = this.words[_r], vr = ((Or << ar | yr) & 16777215).toString(16);
            yr = Or >>> 24 - ar & 16777215, ar += 2, ar >= 26 && (ar -= 26, _r--), yr !== 0 || _r !== this.length - 1 ? rr = pe[6 - vr.length] + vr + rr : rr = vr + rr;
          }
          for (yr !== 0 && (rr = yr.toString(16) + rr); rr.length % xe !== 0; )
            rr = "0" + rr;
          return this.negative !== 0 && (rr = "-" + rr), rr;
        }
        if (Ie === (Ie | 0) && Ie >= 2 && Ie <= 36) {
          var Te = $[Ie], Cr = Ee[Ie];
          rr = "";
          var Hr = this.clone();
          for (Hr.negative = 0; !Hr.isZero(); ) {
            var si = Hr.modn(Cr).toString(Ie);
            Hr = Hr.idivn(Cr), Hr.isZero() ? rr = si + rr : rr = pe[Te - si.length] + si + rr;
          }
          for (this.isZero() && (rr = "0" + rr); rr.length % xe !== 0; )
            rr = "0" + rr;
          return this.negative !== 0 && (rr = "-" + rr), rr;
        }
        p(!1, "Base should be between 2 and 36");
      }, A.prototype.toNumber = function() {
        var Ie = this.words[0];
        return this.length === 2 ? Ie += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? Ie += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && p(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -Ie : Ie;
      }, A.prototype.toJSON = function() {
        return this.toString(16);
      }, A.prototype.toBuffer = function(Ie, xe) {
        return p(typeof b < "u"), this.toArrayLike(b, Ie, xe);
      }, A.prototype.toArray = function(Ie, xe) {
        return this.toArrayLike(Array, Ie, xe);
      }, A.prototype.toArrayLike = function(Ie, xe, rr) {
        var ar = this.byteLength(), yr = rr || Math.max(1, ar);
        p(ar <= yr, "byte array longer than desired length"), p(yr > 0, "Requested array length <= 0"), this.strip();
        var _r = xe === "le", Or = new Ie(yr), vr, Te, Cr = this.clone();
        if (_r) {
          for (Te = 0; !Cr.isZero(); Te++)
            vr = Cr.andln(255), Cr.iushrn(8), Or[Te] = vr;
          for (; Te < yr; Te++)
            Or[Te] = 0;
        } else {
          for (Te = 0; Te < yr - ar; Te++)
            Or[Te] = 0;
          for (Te = 0; !Cr.isZero(); Te++)
            vr = Cr.andln(255), Cr.iushrn(8), Or[yr - Te - 1] = vr;
        }
        return Or;
      }, Math.clz32 ? A.prototype._countBits = function(Ie) {
        return 32 - Math.clz32(Ie);
      } : A.prototype._countBits = function(Ie) {
        var xe = Ie, rr = 0;
        return xe >= 4096 && (rr += 13, xe >>>= 13), xe >= 64 && (rr += 7, xe >>>= 7), xe >= 8 && (rr += 4, xe >>>= 4), xe >= 2 && (rr += 2, xe >>>= 2), rr + xe;
      }, A.prototype._zeroBits = function(Ie) {
        if (Ie === 0) return 26;
        var xe = Ie, rr = 0;
        return xe & 8191 || (rr += 13, xe >>>= 13), xe & 127 || (rr += 7, xe >>>= 7), xe & 15 || (rr += 4, xe >>>= 4), xe & 3 || (rr += 2, xe >>>= 2), xe & 1 || rr++, rr;
      }, A.prototype.bitLength = function() {
        var Ie = this.words[this.length - 1], xe = this._countBits(Ie);
        return (this.length - 1) * 26 + xe;
      };
      function be(er) {
        for (var Ie = new Array(er.bitLength()), xe = 0; xe < Ie.length; xe++) {
          var rr = xe / 26 | 0, ar = xe % 26;
          Ie[xe] = (er.words[rr] & 1 << ar) >>> ar;
        }
        return Ie;
      }
      A.prototype.zeroBits = function() {
        if (this.isZero()) return 0;
        for (var Ie = 0, xe = 0; xe < this.length; xe++) {
          var rr = this._zeroBits(this.words[xe]);
          if (Ie += rr, rr !== 26) break;
        }
        return Ie;
      }, A.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, A.prototype.toTwos = function(Ie) {
        return this.negative !== 0 ? this.abs().inotn(Ie).iaddn(1) : this.clone();
      }, A.prototype.fromTwos = function(Ie) {
        return this.testn(Ie - 1) ? this.notn(Ie).iaddn(1).ineg() : this.clone();
      }, A.prototype.isNeg = function() {
        return this.negative !== 0;
      }, A.prototype.neg = function() {
        return this.clone().ineg();
      }, A.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, A.prototype.iuor = function(Ie) {
        for (; this.length < Ie.length; )
          this.words[this.length++] = 0;
        for (var xe = 0; xe < Ie.length; xe++)
          this.words[xe] = this.words[xe] | Ie.words[xe];
        return this.strip();
      }, A.prototype.ior = function(Ie) {
        return p((this.negative | Ie.negative) === 0), this.iuor(Ie);
      }, A.prototype.or = function(Ie) {
        return this.length > Ie.length ? this.clone().ior(Ie) : Ie.clone().ior(this);
      }, A.prototype.uor = function(Ie) {
        return this.length > Ie.length ? this.clone().iuor(Ie) : Ie.clone().iuor(this);
      }, A.prototype.iuand = function(Ie) {
        var xe;
        this.length > Ie.length ? xe = Ie : xe = this;
        for (var rr = 0; rr < xe.length; rr++)
          this.words[rr] = this.words[rr] & Ie.words[rr];
        return this.length = xe.length, this.strip();
      }, A.prototype.iand = function(Ie) {
        return p((this.negative | Ie.negative) === 0), this.iuand(Ie);
      }, A.prototype.and = function(Ie) {
        return this.length > Ie.length ? this.clone().iand(Ie) : Ie.clone().iand(this);
      }, A.prototype.uand = function(Ie) {
        return this.length > Ie.length ? this.clone().iuand(Ie) : Ie.clone().iuand(this);
      }, A.prototype.iuxor = function(Ie) {
        var xe, rr;
        this.length > Ie.length ? (xe = this, rr = Ie) : (xe = Ie, rr = this);
        for (var ar = 0; ar < rr.length; ar++)
          this.words[ar] = xe.words[ar] ^ rr.words[ar];
        if (this !== xe)
          for (; ar < xe.length; ar++)
            this.words[ar] = xe.words[ar];
        return this.length = xe.length, this.strip();
      }, A.prototype.ixor = function(Ie) {
        return p((this.negative | Ie.negative) === 0), this.iuxor(Ie);
      }, A.prototype.xor = function(Ie) {
        return this.length > Ie.length ? this.clone().ixor(Ie) : Ie.clone().ixor(this);
      }, A.prototype.uxor = function(Ie) {
        return this.length > Ie.length ? this.clone().iuxor(Ie) : Ie.clone().iuxor(this);
      }, A.prototype.inotn = function(Ie) {
        p(typeof Ie == "number" && Ie >= 0);
        var xe = Math.ceil(Ie / 26) | 0, rr = Ie % 26;
        this._expand(xe), rr > 0 && xe--;
        for (var ar = 0; ar < xe; ar++)
          this.words[ar] = ~this.words[ar] & 67108863;
        return rr > 0 && (this.words[ar] = ~this.words[ar] & 67108863 >> 26 - rr), this.strip();
      }, A.prototype.notn = function(Ie) {
        return this.clone().inotn(Ie);
      }, A.prototype.setn = function(Ie, xe) {
        p(typeof Ie == "number" && Ie >= 0);
        var rr = Ie / 26 | 0, ar = Ie % 26;
        return this._expand(rr + 1), xe ? this.words[rr] = this.words[rr] | 1 << ar : this.words[rr] = this.words[rr] & ~(1 << ar), this.strip();
      }, A.prototype.iadd = function(Ie) {
        var xe;
        if (this.negative !== 0 && Ie.negative === 0)
          return this.negative = 0, xe = this.isub(Ie), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && Ie.negative !== 0)
          return Ie.negative = 0, xe = this.isub(Ie), Ie.negative = 1, xe._normSign();
        var rr, ar;
        this.length > Ie.length ? (rr = this, ar = Ie) : (rr = Ie, ar = this);
        for (var yr = 0, _r = 0; _r < ar.length; _r++)
          xe = (rr.words[_r] | 0) + (ar.words[_r] | 0) + yr, this.words[_r] = xe & 67108863, yr = xe >>> 26;
        for (; yr !== 0 && _r < rr.length; _r++)
          xe = (rr.words[_r] | 0) + yr, this.words[_r] = xe & 67108863, yr = xe >>> 26;
        if (this.length = rr.length, yr !== 0)
          this.words[this.length] = yr, this.length++;
        else if (rr !== this)
          for (; _r < rr.length; _r++)
            this.words[_r] = rr.words[_r];
        return this;
      }, A.prototype.add = function(Ie) {
        var xe;
        return Ie.negative !== 0 && this.negative === 0 ? (Ie.negative = 0, xe = this.sub(Ie), Ie.negative ^= 1, xe) : Ie.negative === 0 && this.negative !== 0 ? (this.negative = 0, xe = Ie.sub(this), this.negative = 1, xe) : this.length > Ie.length ? this.clone().iadd(Ie) : Ie.clone().iadd(this);
      }, A.prototype.isub = function(Ie) {
        if (Ie.negative !== 0) {
          Ie.negative = 0;
          var xe = this.iadd(Ie);
          return Ie.negative = 1, xe._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(Ie), this.negative = 1, this._normSign();
        var rr = this.cmp(Ie);
        if (rr === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var ar, yr;
        rr > 0 ? (ar = this, yr = Ie) : (ar = Ie, yr = this);
        for (var _r = 0, Or = 0; Or < yr.length; Or++)
          xe = (ar.words[Or] | 0) - (yr.words[Or] | 0) + _r, _r = xe >> 26, this.words[Or] = xe & 67108863;
        for (; _r !== 0 && Or < ar.length; Or++)
          xe = (ar.words[Or] | 0) + _r, _r = xe >> 26, this.words[Or] = xe & 67108863;
        if (_r === 0 && Or < ar.length && ar !== this)
          for (; Or < ar.length; Or++)
            this.words[Or] = ar.words[Or];
        return this.length = Math.max(this.length, Or), ar !== this && (this.negative = 1), this.strip();
      }, A.prototype.sub = function(Ie) {
        return this.clone().isub(Ie);
      };
      function He(er, Ie, xe) {
        xe.negative = Ie.negative ^ er.negative;
        var rr = er.length + Ie.length | 0;
        xe.length = rr, rr = rr - 1 | 0;
        var ar = er.words[0] | 0, yr = Ie.words[0] | 0, _r = ar * yr, Or = _r & 67108863, vr = _r / 67108864 | 0;
        xe.words[0] = Or;
        for (var Te = 1; Te < rr; Te++) {
          for (var Cr = vr >>> 26, Hr = vr & 67108863, si = Math.min(Te, Ie.length - 1), ui = Math.max(0, Te - er.length + 1); ui <= si; ui++) {
            var Li = Te - ui | 0;
            ar = er.words[Li] | 0, yr = Ie.words[ui] | 0, _r = ar * yr + Hr, Cr += _r / 67108864 | 0, Hr = _r & 67108863;
          }
          xe.words[Te] = Hr | 0, vr = Cr | 0;
        }
        return vr !== 0 ? xe.words[Te] = vr | 0 : xe.length--, xe.strip();
      }
      var Pe = function(Ie, xe, rr) {
        var ar = Ie.words, yr = xe.words, _r = rr.words, Or = 0, vr, Te, Cr, Hr = ar[0] | 0, si = Hr & 8191, ui = Hr >>> 13, Li = ar[1] | 0, Qi = Li & 8191, wi = Li >>> 13, Ji = ar[2] | 0, mn = Ji & 8191, pi = Ji >>> 13, ei = ar[3] | 0, Vr = ei & 8191, qr = ei >>> 13, Zi = ar[4] | 0, Wr = Zi & 8191, ri = Zi >>> 13, _i = ar[5] | 0, Er = _i & 8191, Di = _i >>> 13, _n = ar[6] | 0, On = _n & 8191, so = _n >>> 13, Do = ar[7] | 0, gn = Do & 8191, Gn = Do >>> 13, pn = ar[8] | 0, hn = pn & 8191, Rn = pn >>> 13, vo = ar[9] | 0, Hi = vo & 8191, di = vo >>> 13, Ui = yr[0] | 0, ln = Ui & 8191, Un = Ui >>> 13, Bo = yr[1] | 0, co = Bo & 8191, To = Bo >>> 13, xs = yr[2] | 0, Fo = xs & 8191, Zo = xs >>> 13, $s = yr[3] | 0, rs = $s & 8191, ls = $s >>> 13, na = yr[4] | 0, os = na & 8191, fs = na >>> 13, da = yr[5] | 0, Bn = da & 8191, hi = da >>> 13, Ii = yr[6] | 0, Gi = Ii & 8191, kn = Ii >>> 13, ho = yr[7] | 0, eo = ho & 8191, Ei = ho >>> 13, vs = yr[8] | 0, vi = vs & 8191, xi = vs >>> 13, Lr = yr[9] | 0, dn = Lr & 8191, xn = Lr >>> 13;
        rr.negative = Ie.negative ^ xe.negative, rr.length = 19, vr = Math.imul(si, ln), Te = Math.imul(si, Un), Te = Te + Math.imul(ui, ln) | 0, Cr = Math.imul(ui, Un);
        var oi = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (oi >>> 26) | 0, oi &= 67108863, vr = Math.imul(Qi, ln), Te = Math.imul(Qi, Un), Te = Te + Math.imul(wi, ln) | 0, Cr = Math.imul(wi, Un), vr = vr + Math.imul(si, co) | 0, Te = Te + Math.imul(si, To) | 0, Te = Te + Math.imul(ui, co) | 0, Cr = Cr + Math.imul(ui, To) | 0;
        var Yr = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (Yr >>> 26) | 0, Yr &= 67108863, vr = Math.imul(mn, ln), Te = Math.imul(mn, Un), Te = Te + Math.imul(pi, ln) | 0, Cr = Math.imul(pi, Un), vr = vr + Math.imul(Qi, co) | 0, Te = Te + Math.imul(Qi, To) | 0, Te = Te + Math.imul(wi, co) | 0, Cr = Cr + Math.imul(wi, To) | 0, vr = vr + Math.imul(si, Fo) | 0, Te = Te + Math.imul(si, Zo) | 0, Te = Te + Math.imul(ui, Fo) | 0, Cr = Cr + Math.imul(ui, Zo) | 0;
        var ji = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (ji >>> 26) | 0, ji &= 67108863, vr = Math.imul(Vr, ln), Te = Math.imul(Vr, Un), Te = Te + Math.imul(qr, ln) | 0, Cr = Math.imul(qr, Un), vr = vr + Math.imul(mn, co) | 0, Te = Te + Math.imul(mn, To) | 0, Te = Te + Math.imul(pi, co) | 0, Cr = Cr + Math.imul(pi, To) | 0, vr = vr + Math.imul(Qi, Fo) | 0, Te = Te + Math.imul(Qi, Zo) | 0, Te = Te + Math.imul(wi, Fo) | 0, Cr = Cr + Math.imul(wi, Zo) | 0, vr = vr + Math.imul(si, rs) | 0, Te = Te + Math.imul(si, ls) | 0, Te = Te + Math.imul(ui, rs) | 0, Cr = Cr + Math.imul(ui, ls) | 0;
        var Cn = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (Cn >>> 26) | 0, Cn &= 67108863, vr = Math.imul(Wr, ln), Te = Math.imul(Wr, Un), Te = Te + Math.imul(ri, ln) | 0, Cr = Math.imul(ri, Un), vr = vr + Math.imul(Vr, co) | 0, Te = Te + Math.imul(Vr, To) | 0, Te = Te + Math.imul(qr, co) | 0, Cr = Cr + Math.imul(qr, To) | 0, vr = vr + Math.imul(mn, Fo) | 0, Te = Te + Math.imul(mn, Zo) | 0, Te = Te + Math.imul(pi, Fo) | 0, Cr = Cr + Math.imul(pi, Zo) | 0, vr = vr + Math.imul(Qi, rs) | 0, Te = Te + Math.imul(Qi, ls) | 0, Te = Te + Math.imul(wi, rs) | 0, Cr = Cr + Math.imul(wi, ls) | 0, vr = vr + Math.imul(si, os) | 0, Te = Te + Math.imul(si, fs) | 0, Te = Te + Math.imul(ui, os) | 0, Cr = Cr + Math.imul(ui, fs) | 0;
        var Mn = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (Mn >>> 26) | 0, Mn &= 67108863, vr = Math.imul(Er, ln), Te = Math.imul(Er, Un), Te = Te + Math.imul(Di, ln) | 0, Cr = Math.imul(Di, Un), vr = vr + Math.imul(Wr, co) | 0, Te = Te + Math.imul(Wr, To) | 0, Te = Te + Math.imul(ri, co) | 0, Cr = Cr + Math.imul(ri, To) | 0, vr = vr + Math.imul(Vr, Fo) | 0, Te = Te + Math.imul(Vr, Zo) | 0, Te = Te + Math.imul(qr, Fo) | 0, Cr = Cr + Math.imul(qr, Zo) | 0, vr = vr + Math.imul(mn, rs) | 0, Te = Te + Math.imul(mn, ls) | 0, Te = Te + Math.imul(pi, rs) | 0, Cr = Cr + Math.imul(pi, ls) | 0, vr = vr + Math.imul(Qi, os) | 0, Te = Te + Math.imul(Qi, fs) | 0, Te = Te + Math.imul(wi, os) | 0, Cr = Cr + Math.imul(wi, fs) | 0, vr = vr + Math.imul(si, Bn) | 0, Te = Te + Math.imul(si, hi) | 0, Te = Te + Math.imul(ui, Bn) | 0, Cr = Cr + Math.imul(ui, hi) | 0;
        var B = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (B >>> 26) | 0, B &= 67108863, vr = Math.imul(On, ln), Te = Math.imul(On, Un), Te = Te + Math.imul(so, ln) | 0, Cr = Math.imul(so, Un), vr = vr + Math.imul(Er, co) | 0, Te = Te + Math.imul(Er, To) | 0, Te = Te + Math.imul(Di, co) | 0, Cr = Cr + Math.imul(Di, To) | 0, vr = vr + Math.imul(Wr, Fo) | 0, Te = Te + Math.imul(Wr, Zo) | 0, Te = Te + Math.imul(ri, Fo) | 0, Cr = Cr + Math.imul(ri, Zo) | 0, vr = vr + Math.imul(Vr, rs) | 0, Te = Te + Math.imul(Vr, ls) | 0, Te = Te + Math.imul(qr, rs) | 0, Cr = Cr + Math.imul(qr, ls) | 0, vr = vr + Math.imul(mn, os) | 0, Te = Te + Math.imul(mn, fs) | 0, Te = Te + Math.imul(pi, os) | 0, Cr = Cr + Math.imul(pi, fs) | 0, vr = vr + Math.imul(Qi, Bn) | 0, Te = Te + Math.imul(Qi, hi) | 0, Te = Te + Math.imul(wi, Bn) | 0, Cr = Cr + Math.imul(wi, hi) | 0, vr = vr + Math.imul(si, Gi) | 0, Te = Te + Math.imul(si, kn) | 0, Te = Te + Math.imul(ui, Gi) | 0, Cr = Cr + Math.imul(ui, kn) | 0;
        var o = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (o >>> 26) | 0, o &= 67108863, vr = Math.imul(gn, ln), Te = Math.imul(gn, Un), Te = Te + Math.imul(Gn, ln) | 0, Cr = Math.imul(Gn, Un), vr = vr + Math.imul(On, co) | 0, Te = Te + Math.imul(On, To) | 0, Te = Te + Math.imul(so, co) | 0, Cr = Cr + Math.imul(so, To) | 0, vr = vr + Math.imul(Er, Fo) | 0, Te = Te + Math.imul(Er, Zo) | 0, Te = Te + Math.imul(Di, Fo) | 0, Cr = Cr + Math.imul(Di, Zo) | 0, vr = vr + Math.imul(Wr, rs) | 0, Te = Te + Math.imul(Wr, ls) | 0, Te = Te + Math.imul(ri, rs) | 0, Cr = Cr + Math.imul(ri, ls) | 0, vr = vr + Math.imul(Vr, os) | 0, Te = Te + Math.imul(Vr, fs) | 0, Te = Te + Math.imul(qr, os) | 0, Cr = Cr + Math.imul(qr, fs) | 0, vr = vr + Math.imul(mn, Bn) | 0, Te = Te + Math.imul(mn, hi) | 0, Te = Te + Math.imul(pi, Bn) | 0, Cr = Cr + Math.imul(pi, hi) | 0, vr = vr + Math.imul(Qi, Gi) | 0, Te = Te + Math.imul(Qi, kn) | 0, Te = Te + Math.imul(wi, Gi) | 0, Cr = Cr + Math.imul(wi, kn) | 0, vr = vr + Math.imul(si, eo) | 0, Te = Te + Math.imul(si, Ei) | 0, Te = Te + Math.imul(ui, eo) | 0, Cr = Cr + Math.imul(ui, Ei) | 0;
        var m = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (m >>> 26) | 0, m &= 67108863, vr = Math.imul(hn, ln), Te = Math.imul(hn, Un), Te = Te + Math.imul(Rn, ln) | 0, Cr = Math.imul(Rn, Un), vr = vr + Math.imul(gn, co) | 0, Te = Te + Math.imul(gn, To) | 0, Te = Te + Math.imul(Gn, co) | 0, Cr = Cr + Math.imul(Gn, To) | 0, vr = vr + Math.imul(On, Fo) | 0, Te = Te + Math.imul(On, Zo) | 0, Te = Te + Math.imul(so, Fo) | 0, Cr = Cr + Math.imul(so, Zo) | 0, vr = vr + Math.imul(Er, rs) | 0, Te = Te + Math.imul(Er, ls) | 0, Te = Te + Math.imul(Di, rs) | 0, Cr = Cr + Math.imul(Di, ls) | 0, vr = vr + Math.imul(Wr, os) | 0, Te = Te + Math.imul(Wr, fs) | 0, Te = Te + Math.imul(ri, os) | 0, Cr = Cr + Math.imul(ri, fs) | 0, vr = vr + Math.imul(Vr, Bn) | 0, Te = Te + Math.imul(Vr, hi) | 0, Te = Te + Math.imul(qr, Bn) | 0, Cr = Cr + Math.imul(qr, hi) | 0, vr = vr + Math.imul(mn, Gi) | 0, Te = Te + Math.imul(mn, kn) | 0, Te = Te + Math.imul(pi, Gi) | 0, Cr = Cr + Math.imul(pi, kn) | 0, vr = vr + Math.imul(Qi, eo) | 0, Te = Te + Math.imul(Qi, Ei) | 0, Te = Te + Math.imul(wi, eo) | 0, Cr = Cr + Math.imul(wi, Ei) | 0, vr = vr + Math.imul(si, vi) | 0, Te = Te + Math.imul(si, xi) | 0, Te = Te + Math.imul(ui, vi) | 0, Cr = Cr + Math.imul(ui, xi) | 0;
        var d = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (d >>> 26) | 0, d &= 67108863, vr = Math.imul(Hi, ln), Te = Math.imul(Hi, Un), Te = Te + Math.imul(di, ln) | 0, Cr = Math.imul(di, Un), vr = vr + Math.imul(hn, co) | 0, Te = Te + Math.imul(hn, To) | 0, Te = Te + Math.imul(Rn, co) | 0, Cr = Cr + Math.imul(Rn, To) | 0, vr = vr + Math.imul(gn, Fo) | 0, Te = Te + Math.imul(gn, Zo) | 0, Te = Te + Math.imul(Gn, Fo) | 0, Cr = Cr + Math.imul(Gn, Zo) | 0, vr = vr + Math.imul(On, rs) | 0, Te = Te + Math.imul(On, ls) | 0, Te = Te + Math.imul(so, rs) | 0, Cr = Cr + Math.imul(so, ls) | 0, vr = vr + Math.imul(Er, os) | 0, Te = Te + Math.imul(Er, fs) | 0, Te = Te + Math.imul(Di, os) | 0, Cr = Cr + Math.imul(Di, fs) | 0, vr = vr + Math.imul(Wr, Bn) | 0, Te = Te + Math.imul(Wr, hi) | 0, Te = Te + Math.imul(ri, Bn) | 0, Cr = Cr + Math.imul(ri, hi) | 0, vr = vr + Math.imul(Vr, Gi) | 0, Te = Te + Math.imul(Vr, kn) | 0, Te = Te + Math.imul(qr, Gi) | 0, Cr = Cr + Math.imul(qr, kn) | 0, vr = vr + Math.imul(mn, eo) | 0, Te = Te + Math.imul(mn, Ei) | 0, Te = Te + Math.imul(pi, eo) | 0, Cr = Cr + Math.imul(pi, Ei) | 0, vr = vr + Math.imul(Qi, vi) | 0, Te = Te + Math.imul(Qi, xi) | 0, Te = Te + Math.imul(wi, vi) | 0, Cr = Cr + Math.imul(wi, xi) | 0, vr = vr + Math.imul(si, dn) | 0, Te = Te + Math.imul(si, xn) | 0, Te = Te + Math.imul(ui, dn) | 0, Cr = Cr + Math.imul(ui, xn) | 0;
        var v = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (v >>> 26) | 0, v &= 67108863, vr = Math.imul(Hi, co), Te = Math.imul(Hi, To), Te = Te + Math.imul(di, co) | 0, Cr = Math.imul(di, To), vr = vr + Math.imul(hn, Fo) | 0, Te = Te + Math.imul(hn, Zo) | 0, Te = Te + Math.imul(Rn, Fo) | 0, Cr = Cr + Math.imul(Rn, Zo) | 0, vr = vr + Math.imul(gn, rs) | 0, Te = Te + Math.imul(gn, ls) | 0, Te = Te + Math.imul(Gn, rs) | 0, Cr = Cr + Math.imul(Gn, ls) | 0, vr = vr + Math.imul(On, os) | 0, Te = Te + Math.imul(On, fs) | 0, Te = Te + Math.imul(so, os) | 0, Cr = Cr + Math.imul(so, fs) | 0, vr = vr + Math.imul(Er, Bn) | 0, Te = Te + Math.imul(Er, hi) | 0, Te = Te + Math.imul(Di, Bn) | 0, Cr = Cr + Math.imul(Di, hi) | 0, vr = vr + Math.imul(Wr, Gi) | 0, Te = Te + Math.imul(Wr, kn) | 0, Te = Te + Math.imul(ri, Gi) | 0, Cr = Cr + Math.imul(ri, kn) | 0, vr = vr + Math.imul(Vr, eo) | 0, Te = Te + Math.imul(Vr, Ei) | 0, Te = Te + Math.imul(qr, eo) | 0, Cr = Cr + Math.imul(qr, Ei) | 0, vr = vr + Math.imul(mn, vi) | 0, Te = Te + Math.imul(mn, xi) | 0, Te = Te + Math.imul(pi, vi) | 0, Cr = Cr + Math.imul(pi, xi) | 0, vr = vr + Math.imul(Qi, dn) | 0, Te = Te + Math.imul(Qi, xn) | 0, Te = Te + Math.imul(wi, dn) | 0, Cr = Cr + Math.imul(wi, xn) | 0;
        var he = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (he >>> 26) | 0, he &= 67108863, vr = Math.imul(Hi, Fo), Te = Math.imul(Hi, Zo), Te = Te + Math.imul(di, Fo) | 0, Cr = Math.imul(di, Zo), vr = vr + Math.imul(hn, rs) | 0, Te = Te + Math.imul(hn, ls) | 0, Te = Te + Math.imul(Rn, rs) | 0, Cr = Cr + Math.imul(Rn, ls) | 0, vr = vr + Math.imul(gn, os) | 0, Te = Te + Math.imul(gn, fs) | 0, Te = Te + Math.imul(Gn, os) | 0, Cr = Cr + Math.imul(Gn, fs) | 0, vr = vr + Math.imul(On, Bn) | 0, Te = Te + Math.imul(On, hi) | 0, Te = Te + Math.imul(so, Bn) | 0, Cr = Cr + Math.imul(so, hi) | 0, vr = vr + Math.imul(Er, Gi) | 0, Te = Te + Math.imul(Er, kn) | 0, Te = Te + Math.imul(Di, Gi) | 0, Cr = Cr + Math.imul(Di, kn) | 0, vr = vr + Math.imul(Wr, eo) | 0, Te = Te + Math.imul(Wr, Ei) | 0, Te = Te + Math.imul(ri, eo) | 0, Cr = Cr + Math.imul(ri, Ei) | 0, vr = vr + Math.imul(Vr, vi) | 0, Te = Te + Math.imul(Vr, xi) | 0, Te = Te + Math.imul(qr, vi) | 0, Cr = Cr + Math.imul(qr, xi) | 0, vr = vr + Math.imul(mn, dn) | 0, Te = Te + Math.imul(mn, xn) | 0, Te = Te + Math.imul(pi, dn) | 0, Cr = Cr + Math.imul(pi, xn) | 0;
        var we = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (we >>> 26) | 0, we &= 67108863, vr = Math.imul(Hi, rs), Te = Math.imul(Hi, ls), Te = Te + Math.imul(di, rs) | 0, Cr = Math.imul(di, ls), vr = vr + Math.imul(hn, os) | 0, Te = Te + Math.imul(hn, fs) | 0, Te = Te + Math.imul(Rn, os) | 0, Cr = Cr + Math.imul(Rn, fs) | 0, vr = vr + Math.imul(gn, Bn) | 0, Te = Te + Math.imul(gn, hi) | 0, Te = Te + Math.imul(Gn, Bn) | 0, Cr = Cr + Math.imul(Gn, hi) | 0, vr = vr + Math.imul(On, Gi) | 0, Te = Te + Math.imul(On, kn) | 0, Te = Te + Math.imul(so, Gi) | 0, Cr = Cr + Math.imul(so, kn) | 0, vr = vr + Math.imul(Er, eo) | 0, Te = Te + Math.imul(Er, Ei) | 0, Te = Te + Math.imul(Di, eo) | 0, Cr = Cr + Math.imul(Di, Ei) | 0, vr = vr + Math.imul(Wr, vi) | 0, Te = Te + Math.imul(Wr, xi) | 0, Te = Te + Math.imul(ri, vi) | 0, Cr = Cr + Math.imul(ri, xi) | 0, vr = vr + Math.imul(Vr, dn) | 0, Te = Te + Math.imul(Vr, xn) | 0, Te = Te + Math.imul(qr, dn) | 0, Cr = Cr + Math.imul(qr, xn) | 0;
        var Be = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (Be >>> 26) | 0, Be &= 67108863, vr = Math.imul(Hi, os), Te = Math.imul(Hi, fs), Te = Te + Math.imul(di, os) | 0, Cr = Math.imul(di, fs), vr = vr + Math.imul(hn, Bn) | 0, Te = Te + Math.imul(hn, hi) | 0, Te = Te + Math.imul(Rn, Bn) | 0, Cr = Cr + Math.imul(Rn, hi) | 0, vr = vr + Math.imul(gn, Gi) | 0, Te = Te + Math.imul(gn, kn) | 0, Te = Te + Math.imul(Gn, Gi) | 0, Cr = Cr + Math.imul(Gn, kn) | 0, vr = vr + Math.imul(On, eo) | 0, Te = Te + Math.imul(On, Ei) | 0, Te = Te + Math.imul(so, eo) | 0, Cr = Cr + Math.imul(so, Ei) | 0, vr = vr + Math.imul(Er, vi) | 0, Te = Te + Math.imul(Er, xi) | 0, Te = Te + Math.imul(Di, vi) | 0, Cr = Cr + Math.imul(Di, xi) | 0, vr = vr + Math.imul(Wr, dn) | 0, Te = Te + Math.imul(Wr, xn) | 0, Te = Te + Math.imul(ri, dn) | 0, Cr = Cr + Math.imul(ri, xn) | 0;
        var Me = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (Me >>> 26) | 0, Me &= 67108863, vr = Math.imul(Hi, Bn), Te = Math.imul(Hi, hi), Te = Te + Math.imul(di, Bn) | 0, Cr = Math.imul(di, hi), vr = vr + Math.imul(hn, Gi) | 0, Te = Te + Math.imul(hn, kn) | 0, Te = Te + Math.imul(Rn, Gi) | 0, Cr = Cr + Math.imul(Rn, kn) | 0, vr = vr + Math.imul(gn, eo) | 0, Te = Te + Math.imul(gn, Ei) | 0, Te = Te + Math.imul(Gn, eo) | 0, Cr = Cr + Math.imul(Gn, Ei) | 0, vr = vr + Math.imul(On, vi) | 0, Te = Te + Math.imul(On, xi) | 0, Te = Te + Math.imul(so, vi) | 0, Cr = Cr + Math.imul(so, xi) | 0, vr = vr + Math.imul(Er, dn) | 0, Te = Te + Math.imul(Er, xn) | 0, Te = Te + Math.imul(Di, dn) | 0, Cr = Cr + Math.imul(Di, xn) | 0;
        var fr = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (fr >>> 26) | 0, fr &= 67108863, vr = Math.imul(Hi, Gi), Te = Math.imul(Hi, kn), Te = Te + Math.imul(di, Gi) | 0, Cr = Math.imul(di, kn), vr = vr + Math.imul(hn, eo) | 0, Te = Te + Math.imul(hn, Ei) | 0, Te = Te + Math.imul(Rn, eo) | 0, Cr = Cr + Math.imul(Rn, Ei) | 0, vr = vr + Math.imul(gn, vi) | 0, Te = Te + Math.imul(gn, xi) | 0, Te = Te + Math.imul(Gn, vi) | 0, Cr = Cr + Math.imul(Gn, xi) | 0, vr = vr + Math.imul(On, dn) | 0, Te = Te + Math.imul(On, xn) | 0, Te = Te + Math.imul(so, dn) | 0, Cr = Cr + Math.imul(so, xn) | 0;
        var wr = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (wr >>> 26) | 0, wr &= 67108863, vr = Math.imul(Hi, eo), Te = Math.imul(Hi, Ei), Te = Te + Math.imul(di, eo) | 0, Cr = Math.imul(di, Ei), vr = vr + Math.imul(hn, vi) | 0, Te = Te + Math.imul(hn, xi) | 0, Te = Te + Math.imul(Rn, vi) | 0, Cr = Cr + Math.imul(Rn, xi) | 0, vr = vr + Math.imul(gn, dn) | 0, Te = Te + Math.imul(gn, xn) | 0, Te = Te + Math.imul(Gn, dn) | 0, Cr = Cr + Math.imul(Gn, xn) | 0;
        var dr = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (dr >>> 26) | 0, dr &= 67108863, vr = Math.imul(Hi, vi), Te = Math.imul(Hi, xi), Te = Te + Math.imul(di, vi) | 0, Cr = Math.imul(di, xi), vr = vr + Math.imul(hn, dn) | 0, Te = Te + Math.imul(hn, xn) | 0, Te = Te + Math.imul(Rn, dn) | 0, Cr = Cr + Math.imul(Rn, xn) | 0;
        var Dr = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (Dr >>> 26) | 0, Dr &= 67108863, vr = Math.imul(Hi, dn), Te = Math.imul(Hi, xn), Te = Te + Math.imul(di, dn) | 0, Cr = Math.imul(di, xn);
        var Rr = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        return Or = (Cr + (Te >>> 13) | 0) + (Rr >>> 26) | 0, Rr &= 67108863, _r[0] = oi, _r[1] = Yr, _r[2] = ji, _r[3] = Cn, _r[4] = Mn, _r[5] = B, _r[6] = o, _r[7] = m, _r[8] = d, _r[9] = v, _r[10] = he, _r[11] = we, _r[12] = Be, _r[13] = Me, _r[14] = fr, _r[15] = wr, _r[16] = dr, _r[17] = Dr, _r[18] = Rr, Or !== 0 && (_r[19] = Or, rr.length++), rr;
      };
      Math.imul || (Pe = He);
      function nr(er, Ie, xe) {
        xe.negative = Ie.negative ^ er.negative, xe.length = er.length + Ie.length;
        for (var rr = 0, ar = 0, yr = 0; yr < xe.length - 1; yr++) {
          var _r = ar;
          ar = 0;
          for (var Or = rr & 67108863, vr = Math.min(yr, Ie.length - 1), Te = Math.max(0, yr - er.length + 1); Te <= vr; Te++) {
            var Cr = yr - Te, Hr = er.words[Cr] | 0, si = Ie.words[Te] | 0, ui = Hr * si, Li = ui & 67108863;
            _r = _r + (ui / 67108864 | 0) | 0, Li = Li + Or | 0, Or = Li & 67108863, _r = _r + (Li >>> 26) | 0, ar += _r >>> 26, _r &= 67108863;
          }
          xe.words[yr] = Or, rr = _r, _r = ar;
        }
        return rr !== 0 ? xe.words[yr] = rr : xe.length--, xe.strip();
      }
      function ir(er, Ie, xe) {
        var rr = new or();
        return rr.mulp(er, Ie, xe);
      }
      A.prototype.mulTo = function(Ie, xe) {
        var rr, ar = this.length + Ie.length;
        return this.length === 10 && Ie.length === 10 ? rr = Pe(this, Ie, xe) : ar < 63 ? rr = He(this, Ie, xe) : ar < 1024 ? rr = nr(this, Ie, xe) : rr = ir(this, Ie, xe), rr;
      };
      function or(er, Ie) {
        this.x = er, this.y = Ie;
      }
      or.prototype.makeRBT = function(Ie) {
        for (var xe = new Array(Ie), rr = A.prototype._countBits(Ie) - 1, ar = 0; ar < Ie; ar++)
          xe[ar] = this.revBin(ar, rr, Ie);
        return xe;
      }, or.prototype.revBin = function(Ie, xe, rr) {
        if (Ie === 0 || Ie === rr - 1) return Ie;
        for (var ar = 0, yr = 0; yr < xe; yr++)
          ar |= (Ie & 1) << xe - yr - 1, Ie >>= 1;
        return ar;
      }, or.prototype.permute = function(Ie, xe, rr, ar, yr, _r) {
        for (var Or = 0; Or < _r; Or++)
          ar[Or] = xe[Ie[Or]], yr[Or] = rr[Ie[Or]];
      }, or.prototype.transform = function(Ie, xe, rr, ar, yr, _r) {
        this.permute(_r, Ie, xe, rr, ar, yr);
        for (var Or = 1; Or < yr; Or <<= 1)
          for (var vr = Or << 1, Te = Math.cos(2 * Math.PI / vr), Cr = Math.sin(2 * Math.PI / vr), Hr = 0; Hr < yr; Hr += vr)
            for (var si = Te, ui = Cr, Li = 0; Li < Or; Li++) {
              var Qi = rr[Hr + Li], wi = ar[Hr + Li], Ji = rr[Hr + Li + Or], mn = ar[Hr + Li + Or], pi = si * Ji - ui * mn;
              mn = si * mn + ui * Ji, Ji = pi, rr[Hr + Li] = Qi + Ji, ar[Hr + Li] = wi + mn, rr[Hr + Li + Or] = Qi - Ji, ar[Hr + Li + Or] = wi - mn, Li !== vr && (pi = Te * si - Cr * ui, ui = Te * ui + Cr * si, si = pi);
            }
      }, or.prototype.guessLen13b = function(Ie, xe) {
        var rr = Math.max(xe, Ie) | 1, ar = rr & 1, yr = 0;
        for (rr = rr / 2 | 0; rr; rr = rr >>> 1)
          yr++;
        return 1 << yr + 1 + ar;
      }, or.prototype.conjugate = function(Ie, xe, rr) {
        if (!(rr <= 1))
          for (var ar = 0; ar < rr / 2; ar++) {
            var yr = Ie[ar];
            Ie[ar] = Ie[rr - ar - 1], Ie[rr - ar - 1] = yr, yr = xe[ar], xe[ar] = -xe[rr - ar - 1], xe[rr - ar - 1] = -yr;
          }
      }, or.prototype.normalize13b = function(Ie, xe) {
        for (var rr = 0, ar = 0; ar < xe / 2; ar++) {
          var yr = Math.round(Ie[2 * ar + 1] / xe) * 8192 + Math.round(Ie[2 * ar] / xe) + rr;
          Ie[ar] = yr & 67108863, yr < 67108864 ? rr = 0 : rr = yr / 67108864 | 0;
        }
        return Ie;
      }, or.prototype.convert13b = function(Ie, xe, rr, ar) {
        for (var yr = 0, _r = 0; _r < xe; _r++)
          yr = yr + (Ie[_r] | 0), rr[2 * _r] = yr & 8191, yr = yr >>> 13, rr[2 * _r + 1] = yr & 8191, yr = yr >>> 13;
        for (_r = 2 * xe; _r < ar; ++_r)
          rr[_r] = 0;
        p(yr === 0), p((yr & -8192) === 0);
      }, or.prototype.stub = function(Ie) {
        for (var xe = new Array(Ie), rr = 0; rr < Ie; rr++)
          xe[rr] = 0;
        return xe;
      }, or.prototype.mulp = function(Ie, xe, rr) {
        var ar = 2 * this.guessLen13b(Ie.length, xe.length), yr = this.makeRBT(ar), _r = this.stub(ar), Or = new Array(ar), vr = new Array(ar), Te = new Array(ar), Cr = new Array(ar), Hr = new Array(ar), si = new Array(ar), ui = rr.words;
        ui.length = ar, this.convert13b(Ie.words, Ie.length, Or, ar), this.convert13b(xe.words, xe.length, Cr, ar), this.transform(Or, _r, vr, Te, ar, yr), this.transform(Cr, _r, Hr, si, ar, yr);
        for (var Li = 0; Li < ar; Li++) {
          var Qi = vr[Li] * Hr[Li] - Te[Li] * si[Li];
          Te[Li] = vr[Li] * si[Li] + Te[Li] * Hr[Li], vr[Li] = Qi;
        }
        return this.conjugate(vr, Te, ar), this.transform(vr, Te, ui, _r, ar, yr), this.conjugate(ui, _r, ar), this.normalize13b(ui, ar), rr.negative = Ie.negative ^ xe.negative, rr.length = Ie.length + xe.length, rr.strip();
      }, A.prototype.mul = function(Ie) {
        var xe = new A(null);
        return xe.words = new Array(this.length + Ie.length), this.mulTo(Ie, xe);
      }, A.prototype.mulf = function(Ie) {
        var xe = new A(null);
        return xe.words = new Array(this.length + Ie.length), ir(this, Ie, xe);
      }, A.prototype.imul = function(Ie) {
        return this.clone().mulTo(Ie, this);
      }, A.prototype.imuln = function(Ie) {
        p(typeof Ie == "number"), p(Ie < 67108864);
        for (var xe = 0, rr = 0; rr < this.length; rr++) {
          var ar = (this.words[rr] | 0) * Ie, yr = (ar & 67108863) + (xe & 67108863);
          xe >>= 26, xe += ar / 67108864 | 0, xe += yr >>> 26, this.words[rr] = yr & 67108863;
        }
        return xe !== 0 && (this.words[rr] = xe, this.length++), this;
      }, A.prototype.muln = function(Ie) {
        return this.clone().imuln(Ie);
      }, A.prototype.sqr = function() {
        return this.mul(this);
      }, A.prototype.isqr = function() {
        return this.imul(this.clone());
      }, A.prototype.pow = function(Ie) {
        var xe = be(Ie);
        if (xe.length === 0) return new A(1);
        for (var rr = this, ar = 0; ar < xe.length && xe[ar] === 0; ar++, rr = rr.sqr())
          ;
        if (++ar < xe.length)
          for (var yr = rr.sqr(); ar < xe.length; ar++, yr = yr.sqr())
            xe[ar] !== 0 && (rr = rr.mul(yr));
        return rr;
      }, A.prototype.iushln = function(Ie) {
        p(typeof Ie == "number" && Ie >= 0);
        var xe = Ie % 26, rr = (Ie - xe) / 26, ar = 67108863 >>> 26 - xe << 26 - xe, yr;
        if (xe !== 0) {
          var _r = 0;
          for (yr = 0; yr < this.length; yr++) {
            var Or = this.words[yr] & ar, vr = (this.words[yr] | 0) - Or << xe;
            this.words[yr] = vr | _r, _r = Or >>> 26 - xe;
          }
          _r && (this.words[yr] = _r, this.length++);
        }
        if (rr !== 0) {
          for (yr = this.length - 1; yr >= 0; yr--)
            this.words[yr + rr] = this.words[yr];
          for (yr = 0; yr < rr; yr++)
            this.words[yr] = 0;
          this.length += rr;
        }
        return this.strip();
      }, A.prototype.ishln = function(Ie) {
        return p(this.negative === 0), this.iushln(Ie);
      }, A.prototype.iushrn = function(Ie, xe, rr) {
        p(typeof Ie == "number" && Ie >= 0);
        var ar;
        xe ? ar = (xe - xe % 26) / 26 : ar = 0;
        var yr = Ie % 26, _r = Math.min((Ie - yr) / 26, this.length), Or = 67108863 ^ 67108863 >>> yr << yr, vr = rr;
        if (ar -= _r, ar = Math.max(0, ar), vr) {
          for (var Te = 0; Te < _r; Te++)
            vr.words[Te] = this.words[Te];
          vr.length = _r;
        }
        if (_r !== 0) if (this.length > _r)
          for (this.length -= _r, Te = 0; Te < this.length; Te++)
            this.words[Te] = this.words[Te + _r];
        else
          this.words[0] = 0, this.length = 1;
        var Cr = 0;
        for (Te = this.length - 1; Te >= 0 && (Cr !== 0 || Te >= ar); Te--) {
          var Hr = this.words[Te] | 0;
          this.words[Te] = Cr << 26 - yr | Hr >>> yr, Cr = Hr & Or;
        }
        return vr && Cr !== 0 && (vr.words[vr.length++] = Cr), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, A.prototype.ishrn = function(Ie, xe, rr) {
        return p(this.negative === 0), this.iushrn(Ie, xe, rr);
      }, A.prototype.shln = function(Ie) {
        return this.clone().ishln(Ie);
      }, A.prototype.ushln = function(Ie) {
        return this.clone().iushln(Ie);
      }, A.prototype.shrn = function(Ie) {
        return this.clone().ishrn(Ie);
      }, A.prototype.ushrn = function(Ie) {
        return this.clone().iushrn(Ie);
      }, A.prototype.testn = function(Ie) {
        p(typeof Ie == "number" && Ie >= 0);
        var xe = Ie % 26, rr = (Ie - xe) / 26, ar = 1 << xe;
        if (this.length <= rr) return !1;
        var yr = this.words[rr];
        return !!(yr & ar);
      }, A.prototype.imaskn = function(Ie) {
        p(typeof Ie == "number" && Ie >= 0);
        var xe = Ie % 26, rr = (Ie - xe) / 26;
        if (p(this.negative === 0, "imaskn works only with positive numbers"), this.length <= rr)
          return this;
        if (xe !== 0 && rr++, this.length = Math.min(rr, this.length), xe !== 0) {
          var ar = 67108863 ^ 67108863 >>> xe << xe;
          this.words[this.length - 1] &= ar;
        }
        return this.strip();
      }, A.prototype.maskn = function(Ie) {
        return this.clone().imaskn(Ie);
      }, A.prototype.iaddn = function(Ie) {
        return p(typeof Ie == "number"), p(Ie < 67108864), Ie < 0 ? this.isubn(-Ie) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < Ie ? (this.words[0] = Ie - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(Ie), this.negative = 1, this) : this._iaddn(Ie);
      }, A.prototype._iaddn = function(Ie) {
        this.words[0] += Ie;
        for (var xe = 0; xe < this.length && this.words[xe] >= 67108864; xe++)
          this.words[xe] -= 67108864, xe === this.length - 1 ? this.words[xe + 1] = 1 : this.words[xe + 1]++;
        return this.length = Math.max(this.length, xe + 1), this;
      }, A.prototype.isubn = function(Ie) {
        if (p(typeof Ie == "number"), p(Ie < 67108864), Ie < 0) return this.iaddn(-Ie);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(Ie), this.negative = 1, this;
        if (this.words[0] -= Ie, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var xe = 0; xe < this.length && this.words[xe] < 0; xe++)
            this.words[xe] += 67108864, this.words[xe + 1] -= 1;
        return this.strip();
      }, A.prototype.addn = function(Ie) {
        return this.clone().iaddn(Ie);
      }, A.prototype.subn = function(Ie) {
        return this.clone().isubn(Ie);
      }, A.prototype.iabs = function() {
        return this.negative = 0, this;
      }, A.prototype.abs = function() {
        return this.clone().iabs();
      }, A.prototype._ishlnsubmul = function(Ie, xe, rr) {
        var ar = Ie.length + rr, yr;
        this._expand(ar);
        var _r, Or = 0;
        for (yr = 0; yr < Ie.length; yr++) {
          _r = (this.words[yr + rr] | 0) + Or;
          var vr = (Ie.words[yr] | 0) * xe;
          _r -= vr & 67108863, Or = (_r >> 26) - (vr / 67108864 | 0), this.words[yr + rr] = _r & 67108863;
        }
        for (; yr < this.length - rr; yr++)
          _r = (this.words[yr + rr] | 0) + Or, Or = _r >> 26, this.words[yr + rr] = _r & 67108863;
        if (Or === 0) return this.strip();
        for (p(Or === -1), Or = 0, yr = 0; yr < this.length; yr++)
          _r = -(this.words[yr] | 0) + Or, Or = _r >> 26, this.words[yr] = _r & 67108863;
        return this.negative = 1, this.strip();
      }, A.prototype._wordDiv = function(Ie, xe) {
        var rr = this.length - Ie.length, ar = this.clone(), yr = Ie, _r = yr.words[yr.length - 1] | 0, Or = this._countBits(_r);
        rr = 26 - Or, rr !== 0 && (yr = yr.ushln(rr), ar.iushln(rr), _r = yr.words[yr.length - 1] | 0);
        var vr = ar.length - yr.length, Te;
        if (xe !== "mod") {
          Te = new A(null), Te.length = vr + 1, Te.words = new Array(Te.length);
          for (var Cr = 0; Cr < Te.length; Cr++)
            Te.words[Cr] = 0;
        }
        var Hr = ar.clone()._ishlnsubmul(yr, 1, vr);
        Hr.negative === 0 && (ar = Hr, Te && (Te.words[vr] = 1));
        for (var si = vr - 1; si >= 0; si--) {
          var ui = (ar.words[yr.length + si] | 0) * 67108864 + (ar.words[yr.length + si - 1] | 0);
          for (ui = Math.min(ui / _r | 0, 67108863), ar._ishlnsubmul(yr, ui, si); ar.negative !== 0; )
            ui--, ar.negative = 0, ar._ishlnsubmul(yr, 1, si), ar.isZero() || (ar.negative ^= 1);
          Te && (Te.words[si] = ui);
        }
        return Te && Te.strip(), ar.strip(), xe !== "div" && rr !== 0 && ar.iushrn(rr), {
          div: Te || null,
          mod: ar
        };
      }, A.prototype.divmod = function(Ie, xe, rr) {
        if (p(!Ie.isZero()), this.isZero())
          return {
            div: new A(0),
            mod: new A(0)
          };
        var ar, yr, _r;
        return this.negative !== 0 && Ie.negative === 0 ? (_r = this.neg().divmod(Ie, xe), xe !== "mod" && (ar = _r.div.neg()), xe !== "div" && (yr = _r.mod.neg(), rr && yr.negative !== 0 && yr.iadd(Ie)), {
          div: ar,
          mod: yr
        }) : this.negative === 0 && Ie.negative !== 0 ? (_r = this.divmod(Ie.neg(), xe), xe !== "mod" && (ar = _r.div.neg()), {
          div: ar,
          mod: _r.mod
        }) : this.negative & Ie.negative ? (_r = this.neg().divmod(Ie.neg(), xe), xe !== "div" && (yr = _r.mod.neg(), rr && yr.negative !== 0 && yr.isub(Ie)), {
          div: _r.div,
          mod: yr
        }) : Ie.length > this.length || this.cmp(Ie) < 0 ? {
          div: new A(0),
          mod: this
        } : Ie.length === 1 ? xe === "div" ? {
          div: this.divn(Ie.words[0]),
          mod: null
        } : xe === "mod" ? {
          div: null,
          mod: new A(this.modn(Ie.words[0]))
        } : {
          div: this.divn(Ie.words[0]),
          mod: new A(this.modn(Ie.words[0]))
        } : this._wordDiv(Ie, xe);
      }, A.prototype.div = function(Ie) {
        return this.divmod(Ie, "div", !1).div;
      }, A.prototype.mod = function(Ie) {
        return this.divmod(Ie, "mod", !1).mod;
      }, A.prototype.umod = function(Ie) {
        return this.divmod(Ie, "mod", !0).mod;
      }, A.prototype.divRound = function(Ie) {
        var xe = this.divmod(Ie);
        if (xe.mod.isZero()) return xe.div;
        var rr = xe.div.negative !== 0 ? xe.mod.isub(Ie) : xe.mod, ar = Ie.ushrn(1), yr = Ie.andln(1), _r = rr.cmp(ar);
        return _r < 0 || yr === 1 && _r === 0 ? xe.div : xe.div.negative !== 0 ? xe.div.isubn(1) : xe.div.iaddn(1);
      }, A.prototype.modn = function(Ie) {
        p(Ie <= 67108863);
        for (var xe = (1 << 26) % Ie, rr = 0, ar = this.length - 1; ar >= 0; ar--)
          rr = (xe * rr + (this.words[ar] | 0)) % Ie;
        return rr;
      }, A.prototype.idivn = function(Ie) {
        p(Ie <= 67108863);
        for (var xe = 0, rr = this.length - 1; rr >= 0; rr--) {
          var ar = (this.words[rr] | 0) + xe * 67108864;
          this.words[rr] = ar / Ie | 0, xe = ar % Ie;
        }
        return this.strip();
      }, A.prototype.divn = function(Ie) {
        return this.clone().idivn(Ie);
      }, A.prototype.egcd = function(Ie) {
        p(Ie.negative === 0), p(!Ie.isZero());
        var xe = this, rr = Ie.clone();
        xe.negative !== 0 ? xe = xe.umod(Ie) : xe = xe.clone();
        for (var ar = new A(1), yr = new A(0), _r = new A(0), Or = new A(1), vr = 0; xe.isEven() && rr.isEven(); )
          xe.iushrn(1), rr.iushrn(1), ++vr;
        for (var Te = rr.clone(), Cr = xe.clone(); !xe.isZero(); ) {
          for (var Hr = 0, si = 1; !(xe.words[0] & si) && Hr < 26; ++Hr, si <<= 1) ;
          if (Hr > 0)
            for (xe.iushrn(Hr); Hr-- > 0; )
              (ar.isOdd() || yr.isOdd()) && (ar.iadd(Te), yr.isub(Cr)), ar.iushrn(1), yr.iushrn(1);
          for (var ui = 0, Li = 1; !(rr.words[0] & Li) && ui < 26; ++ui, Li <<= 1) ;
          if (ui > 0)
            for (rr.iushrn(ui); ui-- > 0; )
              (_r.isOdd() || Or.isOdd()) && (_r.iadd(Te), Or.isub(Cr)), _r.iushrn(1), Or.iushrn(1);
          xe.cmp(rr) >= 0 ? (xe.isub(rr), ar.isub(_r), yr.isub(Or)) : (rr.isub(xe), _r.isub(ar), Or.isub(yr));
        }
        return {
          a: _r,
          b: Or,
          gcd: rr.iushln(vr)
        };
      }, A.prototype._invmp = function(Ie) {
        p(Ie.negative === 0), p(!Ie.isZero());
        var xe = this, rr = Ie.clone();
        xe.negative !== 0 ? xe = xe.umod(Ie) : xe = xe.clone();
        for (var ar = new A(1), yr = new A(0), _r = rr.clone(); xe.cmpn(1) > 0 && rr.cmpn(1) > 0; ) {
          for (var Or = 0, vr = 1; !(xe.words[0] & vr) && Or < 26; ++Or, vr <<= 1) ;
          if (Or > 0)
            for (xe.iushrn(Or); Or-- > 0; )
              ar.isOdd() && ar.iadd(_r), ar.iushrn(1);
          for (var Te = 0, Cr = 1; !(rr.words[0] & Cr) && Te < 26; ++Te, Cr <<= 1) ;
          if (Te > 0)
            for (rr.iushrn(Te); Te-- > 0; )
              yr.isOdd() && yr.iadd(_r), yr.iushrn(1);
          xe.cmp(rr) >= 0 ? (xe.isub(rr), ar.isub(yr)) : (rr.isub(xe), yr.isub(ar));
        }
        var Hr;
        return xe.cmpn(1) === 0 ? Hr = ar : Hr = yr, Hr.cmpn(0) < 0 && Hr.iadd(Ie), Hr;
      }, A.prototype.gcd = function(Ie) {
        if (this.isZero()) return Ie.abs();
        if (Ie.isZero()) return this.abs();
        var xe = this.clone(), rr = Ie.clone();
        xe.negative = 0, rr.negative = 0;
        for (var ar = 0; xe.isEven() && rr.isEven(); ar++)
          xe.iushrn(1), rr.iushrn(1);
        do {
          for (; xe.isEven(); )
            xe.iushrn(1);
          for (; rr.isEven(); )
            rr.iushrn(1);
          var yr = xe.cmp(rr);
          if (yr < 0) {
            var _r = xe;
            xe = rr, rr = _r;
          } else if (yr === 0 || rr.cmpn(1) === 0)
            break;
          xe.isub(rr);
        } while (!0);
        return rr.iushln(ar);
      }, A.prototype.invm = function(Ie) {
        return this.egcd(Ie).a.umod(Ie);
      }, A.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, A.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, A.prototype.andln = function(Ie) {
        return this.words[0] & Ie;
      }, A.prototype.bincn = function(Ie) {
        p(typeof Ie == "number");
        var xe = Ie % 26, rr = (Ie - xe) / 26, ar = 1 << xe;
        if (this.length <= rr)
          return this._expand(rr + 1), this.words[rr] |= ar, this;
        for (var yr = ar, _r = rr; yr !== 0 && _r < this.length; _r++) {
          var Or = this.words[_r] | 0;
          Or += yr, yr = Or >>> 26, Or &= 67108863, this.words[_r] = Or;
        }
        return yr !== 0 && (this.words[_r] = yr, this.length++), this;
      }, A.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, A.prototype.cmpn = function(Ie) {
        var xe = Ie < 0;
        if (this.negative !== 0 && !xe) return -1;
        if (this.negative === 0 && xe) return 1;
        this.strip();
        var rr;
        if (this.length > 1)
          rr = 1;
        else {
          xe && (Ie = -Ie), p(Ie <= 67108863, "Number is too big");
          var ar = this.words[0] | 0;
          rr = ar === Ie ? 0 : ar < Ie ? -1 : 1;
        }
        return this.negative !== 0 ? -rr | 0 : rr;
      }, A.prototype.cmp = function(Ie) {
        if (this.negative !== 0 && Ie.negative === 0) return -1;
        if (this.negative === 0 && Ie.negative !== 0) return 1;
        var xe = this.ucmp(Ie);
        return this.negative !== 0 ? -xe | 0 : xe;
      }, A.prototype.ucmp = function(Ie) {
        if (this.length > Ie.length) return 1;
        if (this.length < Ie.length) return -1;
        for (var xe = 0, rr = this.length - 1; rr >= 0; rr--) {
          var ar = this.words[rr] | 0, yr = Ie.words[rr] | 0;
          if (ar !== yr) {
            ar < yr ? xe = -1 : ar > yr && (xe = 1);
            break;
          }
        }
        return xe;
      }, A.prototype.gtn = function(Ie) {
        return this.cmpn(Ie) === 1;
      }, A.prototype.gt = function(Ie) {
        return this.cmp(Ie) === 1;
      }, A.prototype.gten = function(Ie) {
        return this.cmpn(Ie) >= 0;
      }, A.prototype.gte = function(Ie) {
        return this.cmp(Ie) >= 0;
      }, A.prototype.ltn = function(Ie) {
        return this.cmpn(Ie) === -1;
      }, A.prototype.lt = function(Ie) {
        return this.cmp(Ie) === -1;
      }, A.prototype.lten = function(Ie) {
        return this.cmpn(Ie) <= 0;
      }, A.prototype.lte = function(Ie) {
        return this.cmp(Ie) <= 0;
      }, A.prototype.eqn = function(Ie) {
        return this.cmpn(Ie) === 0;
      }, A.prototype.eq = function(Ie) {
        return this.cmp(Ie) === 0;
      }, A.red = function(Ie) {
        return new Fe(Ie);
      }, A.prototype.toRed = function(Ie) {
        return p(!this.red, "Already a number in reduction context"), p(this.negative === 0, "red works only with positives"), Ie.convertTo(this)._forceRed(Ie);
      }, A.prototype.fromRed = function() {
        return p(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, A.prototype._forceRed = function(Ie) {
        return this.red = Ie, this;
      }, A.prototype.forceRed = function(Ie) {
        return p(!this.red, "Already a number in reduction context"), this._forceRed(Ie);
      }, A.prototype.redAdd = function(Ie) {
        return p(this.red, "redAdd works only with red numbers"), this.red.add(this, Ie);
      }, A.prototype.redIAdd = function(Ie) {
        return p(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, Ie);
      }, A.prototype.redSub = function(Ie) {
        return p(this.red, "redSub works only with red numbers"), this.red.sub(this, Ie);
      }, A.prototype.redISub = function(Ie) {
        return p(this.red, "redISub works only with red numbers"), this.red.isub(this, Ie);
      }, A.prototype.redShl = function(Ie) {
        return p(this.red, "redShl works only with red numbers"), this.red.shl(this, Ie);
      }, A.prototype.redMul = function(Ie) {
        return p(this.red, "redMul works only with red numbers"), this.red._verify2(this, Ie), this.red.mul(this, Ie);
      }, A.prototype.redIMul = function(Ie) {
        return p(this.red, "redMul works only with red numbers"), this.red._verify2(this, Ie), this.red.imul(this, Ie);
      }, A.prototype.redSqr = function() {
        return p(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, A.prototype.redISqr = function() {
        return p(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, A.prototype.redSqrt = function() {
        return p(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, A.prototype.redInvm = function() {
        return p(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, A.prototype.redNeg = function() {
        return p(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, A.prototype.redPow = function(Ie) {
        return p(this.red && !Ie.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, Ie);
      };
      var lr = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function Ir(er, Ie) {
        this.name = er, this.p = new A(Ie, 16), this.n = this.p.bitLength(), this.k = new A(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      Ir.prototype._tmp = function() {
        var Ie = new A(null);
        return Ie.words = new Array(Math.ceil(this.n / 13)), Ie;
      }, Ir.prototype.ireduce = function(Ie) {
        var xe = Ie, rr;
        do
          this.split(xe, this.tmp), xe = this.imulK(xe), xe = xe.iadd(this.tmp), rr = xe.bitLength();
        while (rr > this.n);
        var ar = rr < this.n ? -1 : xe.ucmp(this.p);
        return ar === 0 ? (xe.words[0] = 0, xe.length = 1) : ar > 0 ? xe.isub(this.p) : xe.strip !== void 0 ? xe.strip() : xe._strip(), xe;
      }, Ir.prototype.split = function(Ie, xe) {
        Ie.iushrn(this.n, 0, xe);
      }, Ir.prototype.imulK = function(Ie) {
        return Ie.imul(this.k);
      };
      function xr() {
        Ir.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      a(xr, Ir), xr.prototype.split = function(Ie, xe) {
        for (var rr = 4194303, ar = Math.min(Ie.length, 9), yr = 0; yr < ar; yr++)
          xe.words[yr] = Ie.words[yr];
        if (xe.length = ar, Ie.length <= 9) {
          Ie.words[0] = 0, Ie.length = 1;
          return;
        }
        var _r = Ie.words[9];
        for (xe.words[xe.length++] = _r & rr, yr = 10; yr < Ie.length; yr++) {
          var Or = Ie.words[yr] | 0;
          Ie.words[yr - 10] = (Or & rr) << 4 | _r >>> 22, _r = Or;
        }
        _r >>>= 22, Ie.words[yr - 10] = _r, _r === 0 && Ie.length > 10 ? Ie.length -= 10 : Ie.length -= 9;
      }, xr.prototype.imulK = function(Ie) {
        Ie.words[Ie.length] = 0, Ie.words[Ie.length + 1] = 0, Ie.length += 2;
        for (var xe = 0, rr = 0; rr < Ie.length; rr++) {
          var ar = Ie.words[rr] | 0;
          xe += ar * 977, Ie.words[rr] = xe & 67108863, xe = ar * 64 + (xe / 67108864 | 0);
        }
        return Ie.words[Ie.length - 1] === 0 && (Ie.length--, Ie.words[Ie.length - 1] === 0 && Ie.length--), Ie;
      };
      function kr() {
        Ir.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      a(kr, Ir);
      function Ce() {
        Ir.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      a(Ce, Ir);
      function tr() {
        Ir.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      a(tr, Ir), tr.prototype.imulK = function(Ie) {
        for (var xe = 0, rr = 0; rr < Ie.length; rr++) {
          var ar = (Ie.words[rr] | 0) * 19 + xe, yr = ar & 67108863;
          ar >>>= 26, Ie.words[rr] = yr, xe = ar;
        }
        return xe !== 0 && (Ie.words[Ie.length++] = xe), Ie;
      }, A._prime = function(Ie) {
        if (lr[Ie]) return lr[Ie];
        var xe;
        if (Ie === "k256")
          xe = new xr();
        else if (Ie === "p224")
          xe = new kr();
        else if (Ie === "p192")
          xe = new Ce();
        else if (Ie === "p25519")
          xe = new tr();
        else
          throw new Error("Unknown prime " + Ie);
        return lr[Ie] = xe, xe;
      };
      function Fe(er) {
        if (typeof er == "string") {
          var Ie = A._prime(er);
          this.m = Ie.p, this.prime = Ie;
        } else
          p(er.gtn(1), "modulus must be greater than 1"), this.m = er, this.prime = null;
      }
      Fe.prototype._verify1 = function(Ie) {
        p(Ie.negative === 0, "red works only with positives"), p(Ie.red, "red works only with red numbers");
      }, Fe.prototype._verify2 = function(Ie, xe) {
        p((Ie.negative | xe.negative) === 0, "red works only with positives"), p(
          Ie.red && Ie.red === xe.red,
          "red works only with red numbers"
        );
      }, Fe.prototype.imod = function(Ie) {
        return this.prime ? this.prime.ireduce(Ie)._forceRed(this) : Ie.umod(this.m)._forceRed(this);
      }, Fe.prototype.neg = function(Ie) {
        return Ie.isZero() ? Ie.clone() : this.m.sub(Ie)._forceRed(this);
      }, Fe.prototype.add = function(Ie, xe) {
        this._verify2(Ie, xe);
        var rr = Ie.add(xe);
        return rr.cmp(this.m) >= 0 && rr.isub(this.m), rr._forceRed(this);
      }, Fe.prototype.iadd = function(Ie, xe) {
        this._verify2(Ie, xe);
        var rr = Ie.iadd(xe);
        return rr.cmp(this.m) >= 0 && rr.isub(this.m), rr;
      }, Fe.prototype.sub = function(Ie, xe) {
        this._verify2(Ie, xe);
        var rr = Ie.sub(xe);
        return rr.cmpn(0) < 0 && rr.iadd(this.m), rr._forceRed(this);
      }, Fe.prototype.isub = function(Ie, xe) {
        this._verify2(Ie, xe);
        var rr = Ie.isub(xe);
        return rr.cmpn(0) < 0 && rr.iadd(this.m), rr;
      }, Fe.prototype.shl = function(Ie, xe) {
        return this._verify1(Ie), this.imod(Ie.ushln(xe));
      }, Fe.prototype.imul = function(Ie, xe) {
        return this._verify2(Ie, xe), this.imod(Ie.imul(xe));
      }, Fe.prototype.mul = function(Ie, xe) {
        return this._verify2(Ie, xe), this.imod(Ie.mul(xe));
      }, Fe.prototype.isqr = function(Ie) {
        return this.imul(Ie, Ie.clone());
      }, Fe.prototype.sqr = function(Ie) {
        return this.mul(Ie, Ie);
      }, Fe.prototype.sqrt = function(Ie) {
        if (Ie.isZero()) return Ie.clone();
        var xe = this.m.andln(3);
        if (p(xe % 2 === 1), xe === 3) {
          var rr = this.m.add(new A(1)).iushrn(2);
          return this.pow(Ie, rr);
        }
        for (var ar = this.m.subn(1), yr = 0; !ar.isZero() && ar.andln(1) === 0; )
          yr++, ar.iushrn(1);
        p(!ar.isZero());
        var _r = new A(1).toRed(this), Or = _r.redNeg(), vr = this.m.subn(1).iushrn(1), Te = this.m.bitLength();
        for (Te = new A(2 * Te * Te).toRed(this); this.pow(Te, vr).cmp(Or) !== 0; )
          Te.redIAdd(Or);
        for (var Cr = this.pow(Te, ar), Hr = this.pow(Ie, ar.addn(1).iushrn(1)), si = this.pow(Ie, ar), ui = yr; si.cmp(_r) !== 0; ) {
          for (var Li = si, Qi = 0; Li.cmp(_r) !== 0; Qi++)
            Li = Li.redSqr();
          p(Qi < ui);
          var wi = this.pow(Cr, new A(1).iushln(ui - Qi - 1));
          Hr = Hr.redMul(wi), Cr = wi.redSqr(), si = si.redMul(Cr), ui = Qi;
        }
        return Hr;
      }, Fe.prototype.invm = function(Ie) {
        var xe = Ie._invmp(this.m);
        return xe.negative !== 0 ? (xe.negative = 0, this.imod(xe).redNeg()) : this.imod(xe);
      }, Fe.prototype.pow = function(Ie, xe) {
        if (xe.isZero()) return new A(1).toRed(this);
        if (xe.cmpn(1) === 0) return Ie.clone();
        var rr = 4, ar = new Array(1 << rr);
        ar[0] = new A(1).toRed(this), ar[1] = Ie;
        for (var yr = 2; yr < ar.length; yr++)
          ar[yr] = this.mul(ar[yr - 1], Ie);
        var _r = ar[0], Or = 0, vr = 0, Te = xe.bitLength() % 26;
        for (Te === 0 && (Te = 26), yr = xe.length - 1; yr >= 0; yr--) {
          for (var Cr = xe.words[yr], Hr = Te - 1; Hr >= 0; Hr--) {
            var si = Cr >> Hr & 1;
            if (_r !== ar[0] && (_r = this.sqr(_r)), si === 0 && Or === 0) {
              vr = 0;
              continue;
            }
            Or <<= 1, Or |= si, vr++, !(vr !== rr && (yr !== 0 || Hr !== 0)) && (_r = this.mul(_r, ar[Or]), vr = 0, Or = 0);
          }
          Te = 26;
        }
        return _r;
      }, Fe.prototype.convertTo = function(Ie) {
        var xe = Ie.umod(this.m);
        return xe === Ie ? xe.clone() : xe;
      }, Fe.prototype.convertFrom = function(Ie) {
        var xe = Ie.clone();
        return xe.red = null, xe;
      }, A.mont = function(Ie) {
        return new Sr(Ie);
      };
      function Sr(er) {
        Fe.call(this, er), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new A(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      a(Sr, Fe), Sr.prototype.convertTo = function(Ie) {
        return this.imod(Ie.ushln(this.shift));
      }, Sr.prototype.convertFrom = function(Ie) {
        var xe = this.imod(Ie.mul(this.rinv));
        return xe.red = null, xe;
      }, Sr.prototype.imul = function(Ie, xe) {
        if (Ie.isZero() || xe.isZero())
          return Ie.words[0] = 0, Ie.length = 1, Ie;
        var rr = Ie.imul(xe), ar = rr.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), yr = rr.isub(ar).iushrn(this.shift), _r = yr;
        return yr.cmp(this.m) >= 0 ? _r = yr.isub(this.m) : yr.cmpn(0) < 0 && (_r = yr.iadd(this.m)), _r._forceRed(this);
      }, Sr.prototype.mul = function(Ie, xe) {
        if (Ie.isZero() || xe.isZero()) return new A(0)._forceRed(this);
        var rr = Ie.mul(xe), ar = rr.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), yr = rr.isub(ar).iushrn(this.shift), _r = yr;
        return yr.cmp(this.m) >= 0 ? _r = yr.isub(this.m) : yr.cmpn(0) < 0 && (_r = yr.iadd(this.m)), _r._forceRed(this);
      }, Sr.prototype.invm = function(Ie) {
        var xe = this.imod(Ie._invmp(this.m).mul(this.r2));
        return xe._forceRed(this);
      };
    })(n, commonjsGlobal);
  }(bn$5)), bn$5.exports;
}
var brorand = { exports: {} }, hasRequiredBrorand;
function requireBrorand() {
  if (hasRequiredBrorand) return brorand.exports;
  hasRequiredBrorand = 1;
  var n;
  brorand.exports = function(a) {
    return n || (n = new c(null)), n.generate(a);
  };
  function c(p) {
    this.rand = p;
  }
  if (brorand.exports.Rand = c, c.prototype.generate = function(a) {
    return this._rand(a);
  }, c.prototype._rand = function(a) {
    if (this.rand.getBytes)
      return this.rand.getBytes(a);
    for (var A = new Uint8Array(a), b = 0; b < A.length; b++)
      A[b] = this.rand.getByte();
    return A;
  }, typeof self == "object")
    self.crypto && self.crypto.getRandomValues ? c.prototype._rand = function(a) {
      var A = new Uint8Array(a);
      return self.crypto.getRandomValues(A), A;
    } : self.msCrypto && self.msCrypto.getRandomValues ? c.prototype._rand = function(a) {
      var A = new Uint8Array(a);
      return self.msCrypto.getRandomValues(A), A;
    } : typeof window == "object" && (c.prototype._rand = function() {
      throw new Error("Not implemented yet");
    });
  else
    try {
      var u = requireCryptoBrowserify();
      if (typeof u.randomBytes != "function")
        throw new Error("Not supported");
      c.prototype._rand = function(a) {
        return u.randomBytes(a);
      };
    } catch {
    }
  return brorand.exports;
}
var mr, hasRequiredMr;
function requireMr() {
  if (hasRequiredMr) return mr;
  hasRequiredMr = 1;
  var n = requireBn$3(), c = requireBrorand();
  function u(p) {
    this.rand = p || new c.Rand();
  }
  return mr = u, u.create = function(a) {
    return new u(a);
  }, u.prototype._randbelow = function(a) {
    var A = a.bitLength(), b = Math.ceil(A / 8);
    do
      var F = new n(this.rand.generate(b));
    while (F.cmp(a) >= 0);
    return F;
  }, u.prototype._randrange = function(a, A) {
    var b = A.sub(a);
    return a.add(this._randbelow(b));
  }, u.prototype.test = function(a, A, b) {
    var F = a.bitLength(), le = n.mont(a), L = new n(1).toRed(le);
    A || (A = Math.max(1, F / 48 | 0));
    for (var pe = a.subn(1), $ = 0; !pe.testn($); $++)
      ;
    for (var Ee = a.shrn($), be = pe.toRed(le), He = !0; A > 0; A--) {
      var Pe = this._randrange(new n(2), pe);
      b && b(Pe);
      var nr = Pe.toRed(le).redPow(Ee);
      if (!(nr.cmp(L) === 0 || nr.cmp(be) === 0)) {
        for (var ir = 1; ir < $; ir++) {
          if (nr = nr.redSqr(), nr.cmp(L) === 0)
            return !1;
          if (nr.cmp(be) === 0)
            break;
        }
        if (ir === $)
          return !1;
      }
    }
    return He;
  }, u.prototype.getDivisor = function(a, A) {
    var b = a.bitLength(), F = n.mont(a), le = new n(1).toRed(F);
    A || (A = Math.max(1, b / 48 | 0));
    for (var L = a.subn(1), pe = 0; !L.testn(pe); pe++)
      ;
    for (var $ = a.shrn(pe), Ee = L.toRed(F); A > 0; A--) {
      var be = this._randrange(new n(2), L), He = a.gcd(be);
      if (He.cmpn(1) !== 0)
        return He;
      var Pe = be.toRed(F).redPow($);
      if (!(Pe.cmp(le) === 0 || Pe.cmp(Ee) === 0)) {
        for (var nr = 1; nr < pe; nr++) {
          if (Pe = Pe.redSqr(), Pe.cmp(le) === 0)
            return Pe.fromRed().subn(1).gcd(a);
          if (Pe.cmp(Ee) === 0)
            break;
        }
        if (nr === pe)
          return Pe = Pe.redSqr(), Pe.fromRed().subn(1).gcd(a);
      }
    }
    return !1;
  }, mr;
}
var generatePrime, hasRequiredGeneratePrime;
function requireGeneratePrime() {
  if (hasRequiredGeneratePrime) return generatePrime;
  hasRequiredGeneratePrime = 1;
  var n = requireBrowser$9();
  generatePrime = nr, nr.simpleSieve = He, nr.fermatTest = Pe;
  var c = requireBn$4(), u = new c(24), p = requireMr(), a = new p(), A = new c(1), b = new c(2), F = new c(5);
  new c(16), new c(8);
  var le = new c(10), L = new c(3);
  new c(7);
  var pe = new c(11), $ = new c(4);
  new c(12);
  var Ee = null;
  function be() {
    if (Ee !== null)
      return Ee;
    var ir = 1048576, or = [];
    or[0] = 2;
    for (var lr = 1, Ir = 3; Ir < ir; Ir += 2) {
      for (var xr = Math.ceil(Math.sqrt(Ir)), kr = 0; kr < lr && or[kr] <= xr && Ir % or[kr] !== 0; kr++)
        ;
      lr !== kr && or[kr] <= xr || (or[lr++] = Ir);
    }
    return Ee = or, or;
  }
  function He(ir) {
    for (var or = be(), lr = 0; lr < or.length; lr++)
      if (ir.modn(or[lr]) === 0)
        return ir.cmpn(or[lr]) === 0;
    return !0;
  }
  function Pe(ir) {
    var or = c.mont(ir);
    return b.toRed(or).redPow(ir.subn(1)).fromRed().cmpn(1) === 0;
  }
  function nr(ir, or) {
    if (ir < 16)
      return or === 2 || or === 5 ? new c([140, 123]) : new c([140, 39]);
    or = new c(or);
    for (var lr, Ir; ; ) {
      for (lr = new c(n(Math.ceil(ir / 8))); lr.bitLength() > ir; )
        lr.ishrn(1);
      if (lr.isEven() && lr.iadd(A), lr.testn(1) || lr.iadd(b), or.cmp(b)) {
        if (!or.cmp(F))
          for (; lr.mod(le).cmp(L); )
            lr.iadd($);
      } else for (; lr.mod(u).cmp(pe); )
        lr.iadd($);
      if (Ir = lr.shrn(1), He(Ir) && He(lr) && Pe(Ir) && Pe(lr) && a.test(Ir) && a.test(lr))
        return lr;
    }
  }
  return generatePrime;
}
const modp1 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"
}, modp2 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"
}, modp5 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"
}, modp14 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"
}, modp15 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"
}, modp16 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"
}, modp17 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"
}, modp18 = {
  gen: "02",
  prime: "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"
}, require$$1$7 = {
  modp1,
  modp2,
  modp5,
  modp14,
  modp15,
  modp16,
  modp17,
  modp18
};
var dh, hasRequiredDh;
function requireDh() {
  if (hasRequiredDh) return dh;
  hasRequiredDh = 1;
  var n = requireBn$4(), c = requireMr(), u = new c(), p = new n(24), a = new n(11), A = new n(10), b = new n(3), F = new n(7), le = requireGeneratePrime(), L = requireBrowser$9();
  dh = He;
  function pe(nr, ir) {
    return ir = ir || "utf8", Buffer$f.isBuffer(nr) || (nr = new Buffer$f(nr, ir)), this._pub = new n(nr), this;
  }
  function $(nr, ir) {
    return ir = ir || "utf8", Buffer$f.isBuffer(nr) || (nr = new Buffer$f(nr, ir)), this._priv = new n(nr), this;
  }
  var Ee = {};
  function be(nr, ir) {
    var or = ir.toString("hex"), lr = [or, nr.toString(16)].join("_");
    if (lr in Ee)
      return Ee[lr];
    var Ir = 0;
    if (nr.isEven() || !le.simpleSieve || !le.fermatTest(nr) || !u.test(nr))
      return Ir += 1, or === "02" || or === "05" ? Ir += 8 : Ir += 4, Ee[lr] = Ir, Ir;
    u.test(nr.shrn(1)) || (Ir += 2);
    var xr;
    switch (or) {
      case "02":
        nr.mod(p).cmp(a) && (Ir += 8);
        break;
      case "05":
        xr = nr.mod(A), xr.cmp(b) && xr.cmp(F) && (Ir += 8);
        break;
      default:
        Ir += 4;
    }
    return Ee[lr] = Ir, Ir;
  }
  function He(nr, ir, or) {
    this.setGenerator(ir), this.__prime = new n(nr), this._prime = n.mont(this.__prime), this._primeLen = nr.length, this._pub = void 0, this._priv = void 0, this._primeCode = void 0, or ? (this.setPublicKey = pe, this.setPrivateKey = $) : this._primeCode = 8;
  }
  Object.defineProperty(He.prototype, "verifyError", {
    enumerable: !0,
    get: function() {
      return typeof this._primeCode != "number" && (this._primeCode = be(this.__prime, this.__gen)), this._primeCode;
    }
  }), He.prototype.generateKeys = function() {
    return this._priv || (this._priv = new n(L(this._primeLen))), this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed(), this.getPublicKey();
  }, He.prototype.computeSecret = function(nr) {
    nr = new n(nr), nr = nr.toRed(this._prime);
    var ir = nr.redPow(this._priv).fromRed(), or = new Buffer$f(ir.toArray()), lr = this.getPrime();
    if (or.length < lr.length) {
      var Ir = new Buffer$f(lr.length - or.length);
      Ir.fill(0), or = Buffer$f.concat([Ir, or]);
    }
    return or;
  }, He.prototype.getPublicKey = function(ir) {
    return Pe(this._pub, ir);
  }, He.prototype.getPrivateKey = function(ir) {
    return Pe(this._priv, ir);
  }, He.prototype.getPrime = function(nr) {
    return Pe(this.__prime, nr);
  }, He.prototype.getGenerator = function(nr) {
    return Pe(this._gen, nr);
  }, He.prototype.setGenerator = function(nr, ir) {
    return ir = ir || "utf8", Buffer$f.isBuffer(nr) || (nr = new Buffer$f(nr, ir)), this.__gen = nr, this._gen = new n(nr), this;
  };
  function Pe(nr, ir) {
    var or = new Buffer$f(nr.toArray());
    return ir ? or.toString(ir) : or;
  }
  return dh;
}
var hasRequiredBrowser$4;
function requireBrowser$4() {
  if (hasRequiredBrowser$4) return browser$4;
  hasRequiredBrowser$4 = 1;
  var n = requireGeneratePrime(), c = require$$1$7, u = requireDh();
  function p(b) {
    var F = new Buffer$f(c[b].prime, "hex"), le = new Buffer$f(c[b].gen, "hex");
    return new u(F, le);
  }
  var a = {
    binary: !0,
    hex: !0,
    base64: !0
  };
  function A(b, F, le, L) {
    return Buffer$f.isBuffer(F) || a[F] === void 0 ? A(b, "binary", F, le) : (F = F || "binary", L = L || "binary", le = le || new Buffer$f([2]), Buffer$f.isBuffer(le) || (le = new Buffer$f(le, L)), typeof b == "number" ? new u(n(b, le), le, !0) : (Buffer$f.isBuffer(b) || (b = new Buffer$f(b, F)), new u(b, le, !0)));
  }
  return browser$4.DiffieHellmanGroup = browser$4.createDiffieHellmanGroup = browser$4.getDiffieHellman = p, browser$4.createDiffieHellman = browser$4.DiffieHellman = A, browser$4;
}
var readableBrowser = { exports: {} }, processNextickArgs = { exports: {} }, hasRequiredProcessNextickArgs;
function requireProcessNextickArgs() {
  if (hasRequiredProcessNextickArgs) return processNextickArgs.exports;
  hasRequiredProcessNextickArgs = 1, typeof process$1 > "u" || !process$1.version || process$1.version.indexOf("v0.") === 0 || process$1.version.indexOf("v1.") === 0 && process$1.version.indexOf("v1.8.") !== 0 ? processNextickArgs.exports = { nextTick: n } : processNextickArgs.exports = process$1;
  function n(c, u, p, a) {
    if (typeof c != "function")
      throw new TypeError('"callback" argument must be a function');
    var A = arguments.length, b, F;
    switch (A) {
      case 0:
      case 1:
        return process$1.nextTick(c);
      case 2:
        return process$1.nextTick(function() {
          c.call(null, u);
        });
      case 3:
        return process$1.nextTick(function() {
          c.call(null, u, p);
        });
      case 4:
        return process$1.nextTick(function() {
          c.call(null, u, p, a);
        });
      default:
        for (b = new Array(A - 1), F = 0; F < b.length; )
          b[F++] = arguments[F];
        return process$1.nextTick(function() {
          c.apply(null, b);
        });
    }
  }
  return processNextickArgs.exports;
}
var isarray, hasRequiredIsarray;
function requireIsarray() {
  if (hasRequiredIsarray) return isarray;
  hasRequiredIsarray = 1;
  var n = {}.toString;
  return isarray = Array.isArray || function(c) {
    return n.call(c) == "[object Array]";
  }, isarray;
}
var streamBrowser, hasRequiredStreamBrowser;
function requireStreamBrowser() {
  return hasRequiredStreamBrowser || (hasRequiredStreamBrowser = 1, streamBrowser = eventsExports.EventEmitter), streamBrowser;
}
var safeBuffer = { exports: {} }, hasRequiredSafeBuffer;
function requireSafeBuffer() {
  return hasRequiredSafeBuffer || (hasRequiredSafeBuffer = 1, function(n, c) {
    var u = require$$0$5, p = u.Buffer;
    function a(b, F) {
      for (var le in b)
        F[le] = b[le];
    }
    p.from && p.alloc && p.allocUnsafe && p.allocUnsafeSlow ? n.exports = u : (a(u, c), c.Buffer = A);
    function A(b, F, le) {
      return p(b, F, le);
    }
    a(p, A), A.from = function(b, F, le) {
      if (typeof b == "number")
        throw new TypeError("Argument must not be a number");
      return p(b, F, le);
    }, A.alloc = function(b, F, le) {
      if (typeof b != "number")
        throw new TypeError("Argument must be a number");
      var L = p(b);
      return F !== void 0 ? typeof le == "string" ? L.fill(F, le) : L.fill(F) : L.fill(0), L;
    }, A.allocUnsafe = function(b) {
      if (typeof b != "number")
        throw new TypeError("Argument must be a number");
      return p(b);
    }, A.allocUnsafeSlow = function(b) {
      if (typeof b != "number")
        throw new TypeError("Argument must be a number");
      return u.SlowBuffer(b);
    };
  }(safeBuffer, safeBuffer.exports)), safeBuffer.exports;
}
var util$7 = {}, hasRequiredUtil;
function requireUtil() {
  if (hasRequiredUtil) return util$7;
  hasRequiredUtil = 1;
  function n(Pe) {
    return Array.isArray ? Array.isArray(Pe) : He(Pe) === "[object Array]";
  }
  util$7.isArray = n;
  function c(Pe) {
    return typeof Pe == "boolean";
  }
  util$7.isBoolean = c;
  function u(Pe) {
    return Pe === null;
  }
  util$7.isNull = u;
  function p(Pe) {
    return Pe == null;
  }
  util$7.isNullOrUndefined = p;
  function a(Pe) {
    return typeof Pe == "number";
  }
  util$7.isNumber = a;
  function A(Pe) {
    return typeof Pe == "string";
  }
  util$7.isString = A;
  function b(Pe) {
    return typeof Pe == "symbol";
  }
  util$7.isSymbol = b;
  function F(Pe) {
    return Pe === void 0;
  }
  util$7.isUndefined = F;
  function le(Pe) {
    return He(Pe) === "[object RegExp]";
  }
  util$7.isRegExp = le;
  function L(Pe) {
    return typeof Pe == "object" && Pe !== null;
  }
  util$7.isObject = L;
  function pe(Pe) {
    return He(Pe) === "[object Date]";
  }
  util$7.isDate = pe;
  function $(Pe) {
    return He(Pe) === "[object Error]" || Pe instanceof Error;
  }
  util$7.isError = $;
  function Ee(Pe) {
    return typeof Pe == "function";
  }
  util$7.isFunction = Ee;
  function be(Pe) {
    return Pe === null || typeof Pe == "boolean" || typeof Pe == "number" || typeof Pe == "string" || typeof Pe == "symbol" || // ES6 symbol
    typeof Pe > "u";
  }
  util$7.isPrimitive = be, util$7.isBuffer = require$$0$5.Buffer.isBuffer;
  function He(Pe) {
    return Object.prototype.toString.call(Pe);
  }
  return util$7;
}
var BufferList = { exports: {} }, hasRequiredBufferList;
function requireBufferList() {
  return hasRequiredBufferList || (hasRequiredBufferList = 1, function(n) {
    function c(A, b) {
      if (!(A instanceof b))
        throw new TypeError("Cannot call a class as a function");
    }
    var u = requireSafeBuffer().Buffer, p = util$8;
    function a(A, b, F) {
      A.copy(b, F);
    }
    n.exports = function() {
      function A() {
        c(this, A), this.head = null, this.tail = null, this.length = 0;
      }
      return A.prototype.push = function(F) {
        var le = { data: F, next: null };
        this.length > 0 ? this.tail.next = le : this.head = le, this.tail = le, ++this.length;
      }, A.prototype.unshift = function(F) {
        var le = { data: F, next: this.head };
        this.length === 0 && (this.tail = le), this.head = le, ++this.length;
      }, A.prototype.shift = function() {
        if (this.length !== 0) {
          var F = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, F;
        }
      }, A.prototype.clear = function() {
        this.head = this.tail = null, this.length = 0;
      }, A.prototype.join = function(F) {
        if (this.length === 0) return "";
        for (var le = this.head, L = "" + le.data; le = le.next; )
          L += F + le.data;
        return L;
      }, A.prototype.concat = function(F) {
        if (this.length === 0) return u.alloc(0);
        for (var le = u.allocUnsafe(F >>> 0), L = this.head, pe = 0; L; )
          a(L.data, le, pe), pe += L.data.length, L = L.next;
        return le;
      }, A;
    }(), p && p.inspect && p.inspect.custom && (n.exports.prototype[p.inspect.custom] = function() {
      var A = p.inspect({ length: this.length });
      return this.constructor.name + " " + A;
    });
  }(BufferList)), BufferList.exports;
}
var destroy_1, hasRequiredDestroy;
function requireDestroy() {
  if (hasRequiredDestroy) return destroy_1;
  hasRequiredDestroy = 1;
  var n = requireProcessNextickArgs();
  function c(a, A) {
    var b = this, F = this._readableState && this._readableState.destroyed, le = this._writableState && this._writableState.destroyed;
    return F || le ? (A ? A(a) : a && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, n.nextTick(p, this, a)) : n.nextTick(p, this, a)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(a || null, function(L) {
      !A && L ? b._writableState ? b._writableState.errorEmitted || (b._writableState.errorEmitted = !0, n.nextTick(p, b, L)) : n.nextTick(p, b, L) : A && A(L);
    }), this);
  }
  function u() {
    this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
  }
  function p(a, A) {
    a.emit("error", A);
  }
  return destroy_1 = {
    destroy: c,
    undestroy: u
  }, destroy_1;
}
var _stream_writable, hasRequired_stream_writable;
function require_stream_writable() {
  if (hasRequired_stream_writable) return _stream_writable;
  hasRequired_stream_writable = 1;
  var n = requireProcessNextickArgs();
  _stream_writable = Pe;
  function c(_r) {
    var Or = this;
    this.next = null, this.entry = null, this.finish = function() {
      yr(Or, _r);
    };
  }
  var u = !process$1.browser && ["v0.10", "v0.9."].indexOf(process$1.version.slice(0, 5)) > -1 ? setImmediate : n.nextTick, p;
  Pe.WritableState = be;
  var a = Object.create(requireUtil());
  a.inherits = inherits_browserExports;
  var A = {
    deprecate: browser$b
  }, b = requireStreamBrowser(), F = requireSafeBuffer().Buffer, le = (typeof commonjsGlobal < "u" ? commonjsGlobal : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function L(_r) {
    return F.from(_r);
  }
  function pe(_r) {
    return F.isBuffer(_r) || _r instanceof le;
  }
  var $ = requireDestroy();
  a.inherits(Pe, b);
  function Ee() {
  }
  function be(_r, Or) {
    p = p || require_stream_duplex(), _r = _r || {};
    var vr = Or instanceof p;
    this.objectMode = !!_r.objectMode, vr && (this.objectMode = this.objectMode || !!_r.writableObjectMode);
    var Te = _r.highWaterMark, Cr = _r.writableHighWaterMark, Hr = this.objectMode ? 16 : 16 * 1024;
    Te || Te === 0 ? this.highWaterMark = Te : vr && (Cr || Cr === 0) ? this.highWaterMark = Cr : this.highWaterMark = Hr, this.highWaterMark = Math.floor(this.highWaterMark), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
    var si = _r.decodeStrings === !1;
    this.decodeStrings = !si, this.defaultEncoding = _r.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(ui) {
      Ce(Or, ui);
    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new c(this);
  }
  be.prototype.getBuffer = function() {
    for (var Or = this.bufferedRequest, vr = []; Or; )
      vr.push(Or), Or = Or.next;
    return vr;
  }, function() {
    try {
      Object.defineProperty(be.prototype, "buffer", {
        get: A.deprecate(function() {
          return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
      });
    } catch {
    }
  }();
  var He;
  typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (He = Function.prototype[Symbol.hasInstance], Object.defineProperty(Pe, Symbol.hasInstance, {
    value: function(_r) {
      return He.call(this, _r) ? !0 : this !== Pe ? !1 : _r && _r._writableState instanceof be;
    }
  })) : He = function(_r) {
    return _r instanceof this;
  };
  function Pe(_r) {
    if (p = p || require_stream_duplex(), !He.call(Pe, this) && !(this instanceof p))
      return new Pe(_r);
    this._writableState = new be(_r, this), this.writable = !0, _r && (typeof _r.write == "function" && (this._write = _r.write), typeof _r.writev == "function" && (this._writev = _r.writev), typeof _r.destroy == "function" && (this._destroy = _r.destroy), typeof _r.final == "function" && (this._final = _r.final)), b.call(this);
  }
  Pe.prototype.pipe = function() {
    this.emit("error", new Error("Cannot pipe, not readable"));
  };
  function nr(_r, Or) {
    var vr = new Error("write after end");
    _r.emit("error", vr), n.nextTick(Or, vr);
  }
  function ir(_r, Or, vr, Te) {
    var Cr = !0, Hr = !1;
    return vr === null ? Hr = new TypeError("May not write null values to stream") : typeof vr != "string" && vr !== void 0 && !Or.objectMode && (Hr = new TypeError("Invalid non-string/buffer chunk")), Hr && (_r.emit("error", Hr), n.nextTick(Te, Hr), Cr = !1), Cr;
  }
  Pe.prototype.write = function(_r, Or, vr) {
    var Te = this._writableState, Cr = !1, Hr = !Te.objectMode && pe(_r);
    return Hr && !F.isBuffer(_r) && (_r = L(_r)), typeof Or == "function" && (vr = Or, Or = null), Hr ? Or = "buffer" : Or || (Or = Te.defaultEncoding), typeof vr != "function" && (vr = Ee), Te.ended ? nr(this, vr) : (Hr || ir(this, Te, _r, vr)) && (Te.pendingcb++, Cr = lr(this, Te, Hr, _r, Or, vr)), Cr;
  }, Pe.prototype.cork = function() {
    var _r = this._writableState;
    _r.corked++;
  }, Pe.prototype.uncork = function() {
    var _r = this._writableState;
    _r.corked && (_r.corked--, !_r.writing && !_r.corked && !_r.bufferProcessing && _r.bufferedRequest && Sr(this, _r));
  }, Pe.prototype.setDefaultEncoding = function(Or) {
    if (typeof Or == "string" && (Or = Or.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((Or + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + Or);
    return this._writableState.defaultEncoding = Or, this;
  };
  function or(_r, Or, vr) {
    return !_r.objectMode && _r.decodeStrings !== !1 && typeof Or == "string" && (Or = F.from(Or, vr)), Or;
  }
  Object.defineProperty(Pe.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function lr(_r, Or, vr, Te, Cr, Hr) {
    if (!vr) {
      var si = or(Or, Te, Cr);
      Te !== si && (vr = !0, Cr = "buffer", Te = si);
    }
    var ui = Or.objectMode ? 1 : Te.length;
    Or.length += ui;
    var Li = Or.length < Or.highWaterMark;
    if (Li || (Or.needDrain = !0), Or.writing || Or.corked) {
      var Qi = Or.lastBufferedRequest;
      Or.lastBufferedRequest = {
        chunk: Te,
        encoding: Cr,
        isBuf: vr,
        callback: Hr,
        next: null
      }, Qi ? Qi.next = Or.lastBufferedRequest : Or.bufferedRequest = Or.lastBufferedRequest, Or.bufferedRequestCount += 1;
    } else
      Ir(_r, Or, !1, ui, Te, Cr, Hr);
    return Li;
  }
  function Ir(_r, Or, vr, Te, Cr, Hr, si) {
    Or.writelen = Te, Or.writecb = si, Or.writing = !0, Or.sync = !0, vr ? _r._writev(Cr, Or.onwrite) : _r._write(Cr, Hr, Or.onwrite), Or.sync = !1;
  }
  function xr(_r, Or, vr, Te, Cr) {
    --Or.pendingcb, vr ? (n.nextTick(Cr, Te), n.nextTick(rr, _r, Or), _r._writableState.errorEmitted = !0, _r.emit("error", Te)) : (Cr(Te), _r._writableState.errorEmitted = !0, _r.emit("error", Te), rr(_r, Or));
  }
  function kr(_r) {
    _r.writing = !1, _r.writecb = null, _r.length -= _r.writelen, _r.writelen = 0;
  }
  function Ce(_r, Or) {
    var vr = _r._writableState, Te = vr.sync, Cr = vr.writecb;
    if (kr(vr), Or) xr(_r, vr, Te, Or, Cr);
    else {
      var Hr = er(vr);
      !Hr && !vr.corked && !vr.bufferProcessing && vr.bufferedRequest && Sr(_r, vr), Te ? u(tr, _r, vr, Hr, Cr) : tr(_r, vr, Hr, Cr);
    }
  }
  function tr(_r, Or, vr, Te) {
    vr || Fe(_r, Or), Or.pendingcb--, Te(), rr(_r, Or);
  }
  function Fe(_r, Or) {
    Or.length === 0 && Or.needDrain && (Or.needDrain = !1, _r.emit("drain"));
  }
  function Sr(_r, Or) {
    Or.bufferProcessing = !0;
    var vr = Or.bufferedRequest;
    if (_r._writev && vr && vr.next) {
      var Te = Or.bufferedRequestCount, Cr = new Array(Te), Hr = Or.corkedRequestsFree;
      Hr.entry = vr;
      for (var si = 0, ui = !0; vr; )
        Cr[si] = vr, vr.isBuf || (ui = !1), vr = vr.next, si += 1;
      Cr.allBuffers = ui, Ir(_r, Or, !0, Or.length, Cr, "", Hr.finish), Or.pendingcb++, Or.lastBufferedRequest = null, Hr.next ? (Or.corkedRequestsFree = Hr.next, Hr.next = null) : Or.corkedRequestsFree = new c(Or), Or.bufferedRequestCount = 0;
    } else {
      for (; vr; ) {
        var Li = vr.chunk, Qi = vr.encoding, wi = vr.callback, Ji = Or.objectMode ? 1 : Li.length;
        if (Ir(_r, Or, !1, Ji, Li, Qi, wi), vr = vr.next, Or.bufferedRequestCount--, Or.writing)
          break;
      }
      vr === null && (Or.lastBufferedRequest = null);
    }
    Or.bufferedRequest = vr, Or.bufferProcessing = !1;
  }
  Pe.prototype._write = function(_r, Or, vr) {
    vr(new Error("_write() is not implemented"));
  }, Pe.prototype._writev = null, Pe.prototype.end = function(_r, Or, vr) {
    var Te = this._writableState;
    typeof _r == "function" ? (vr = _r, _r = null, Or = null) : typeof Or == "function" && (vr = Or, Or = null), _r != null && this.write(_r, Or), Te.corked && (Te.corked = 1, this.uncork()), Te.ending || ar(this, Te, vr);
  };
  function er(_r) {
    return _r.ending && _r.length === 0 && _r.bufferedRequest === null && !_r.finished && !_r.writing;
  }
  function Ie(_r, Or) {
    _r._final(function(vr) {
      Or.pendingcb--, vr && _r.emit("error", vr), Or.prefinished = !0, _r.emit("prefinish"), rr(_r, Or);
    });
  }
  function xe(_r, Or) {
    !Or.prefinished && !Or.finalCalled && (typeof _r._final == "function" ? (Or.pendingcb++, Or.finalCalled = !0, n.nextTick(Ie, _r, Or)) : (Or.prefinished = !0, _r.emit("prefinish")));
  }
  function rr(_r, Or) {
    var vr = er(Or);
    return vr && (xe(_r, Or), Or.pendingcb === 0 && (Or.finished = !0, _r.emit("finish"))), vr;
  }
  function ar(_r, Or, vr) {
    Or.ending = !0, rr(_r, Or), vr && (Or.finished ? n.nextTick(vr) : _r.once("finish", vr)), Or.ended = !0, _r.writable = !1;
  }
  function yr(_r, Or, vr) {
    var Te = _r.entry;
    for (_r.entry = null; Te; ) {
      var Cr = Te.callback;
      Or.pendingcb--, Cr(vr), Te = Te.next;
    }
    Or.corkedRequestsFree.next = _r;
  }
  return Object.defineProperty(Pe.prototype, "destroyed", {
    get: function() {
      return this._writableState === void 0 ? !1 : this._writableState.destroyed;
    },
    set: function(_r) {
      this._writableState && (this._writableState.destroyed = _r);
    }
  }), Pe.prototype.destroy = $.destroy, Pe.prototype._undestroy = $.undestroy, Pe.prototype._destroy = function(_r, Or) {
    this.end(), Or(_r);
  }, _stream_writable;
}
var _stream_duplex, hasRequired_stream_duplex;
function require_stream_duplex() {
  if (hasRequired_stream_duplex) return _stream_duplex;
  hasRequired_stream_duplex = 1;
  var n = requireProcessNextickArgs(), c = Object.keys || function($) {
    var Ee = [];
    for (var be in $)
      Ee.push(be);
    return Ee;
  };
  _stream_duplex = le;
  var u = Object.create(requireUtil());
  u.inherits = inherits_browserExports;
  var p = require_stream_readable(), a = require_stream_writable();
  u.inherits(le, p);
  for (var A = c(a.prototype), b = 0; b < A.length; b++) {
    var F = A[b];
    le.prototype[F] || (le.prototype[F] = a.prototype[F]);
  }
  function le($) {
    if (!(this instanceof le)) return new le($);
    p.call(this, $), a.call(this, $), $ && $.readable === !1 && (this.readable = !1), $ && $.writable === !1 && (this.writable = !1), this.allowHalfOpen = !0, $ && $.allowHalfOpen === !1 && (this.allowHalfOpen = !1), this.once("end", L);
  }
  Object.defineProperty(le.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function L() {
    this.allowHalfOpen || this._writableState.ended || n.nextTick(pe, this);
  }
  function pe($) {
    $.end();
  }
  return Object.defineProperty(le.prototype, "destroyed", {
    get: function() {
      return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function($) {
      this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = $, this._writableState.destroyed = $);
    }
  }), le.prototype._destroy = function($, Ee) {
    this.push(null), this.end(), n.nextTick(Ee, $);
  }, _stream_duplex;
}
var _stream_readable, hasRequired_stream_readable;
function require_stream_readable() {
  if (hasRequired_stream_readable) return _stream_readable;
  hasRequired_stream_readable = 1;
  var n = requireProcessNextickArgs();
  _stream_readable = or;
  var c = requireIsarray(), u;
  or.ReadableState = ir, eventsExports.EventEmitter;
  var p = function(wi, Ji) {
    return wi.listeners(Ji).length;
  }, a = requireStreamBrowser(), A = requireSafeBuffer().Buffer, b = (typeof commonjsGlobal < "u" ? commonjsGlobal : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function F(wi) {
    return A.from(wi);
  }
  function le(wi) {
    return A.isBuffer(wi) || wi instanceof b;
  }
  var L = Object.create(requireUtil());
  L.inherits = inherits_browserExports;
  var pe = util$8, $ = void 0;
  pe && pe.debuglog ? $ = pe.debuglog("stream") : $ = function() {
  };
  var Ee = requireBufferList(), be = requireDestroy(), He;
  L.inherits(or, a);
  var Pe = ["error", "close", "destroy", "pause", "resume"];
  function nr(wi, Ji, mn) {
    if (typeof wi.prependListener == "function") return wi.prependListener(Ji, mn);
    !wi._events || !wi._events[Ji] ? wi.on(Ji, mn) : c(wi._events[Ji]) ? wi._events[Ji].unshift(mn) : wi._events[Ji] = [mn, wi._events[Ji]];
  }
  function ir(wi, Ji) {
    u = u || require_stream_duplex(), wi = wi || {};
    var mn = Ji instanceof u;
    this.objectMode = !!wi.objectMode, mn && (this.objectMode = this.objectMode || !!wi.readableObjectMode);
    var pi = wi.highWaterMark, ei = wi.readableHighWaterMark, Vr = this.objectMode ? 16 : 16 * 1024;
    pi || pi === 0 ? this.highWaterMark = pi : mn && (ei || ei === 0) ? this.highWaterMark = ei : this.highWaterMark = Vr, this.highWaterMark = Math.floor(this.highWaterMark), this.buffer = new Ee(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.destroyed = !1, this.defaultEncoding = wi.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, wi.encoding && (He || (He = string_decoder.StringDecoder), this.decoder = new He(wi.encoding), this.encoding = wi.encoding);
  }
  function or(wi) {
    if (u = u || require_stream_duplex(), !(this instanceof or)) return new or(wi);
    this._readableState = new ir(wi, this), this.readable = !0, wi && (typeof wi.read == "function" && (this._read = wi.read), typeof wi.destroy == "function" && (this._destroy = wi.destroy)), a.call(this);
  }
  Object.defineProperty(or.prototype, "destroyed", {
    get: function() {
      return this._readableState === void 0 ? !1 : this._readableState.destroyed;
    },
    set: function(wi) {
      this._readableState && (this._readableState.destroyed = wi);
    }
  }), or.prototype.destroy = be.destroy, or.prototype._undestroy = be.undestroy, or.prototype._destroy = function(wi, Ji) {
    this.push(null), Ji(wi);
  }, or.prototype.push = function(wi, Ji) {
    var mn = this._readableState, pi;
    return mn.objectMode ? pi = !0 : typeof wi == "string" && (Ji = Ji || mn.defaultEncoding, Ji !== mn.encoding && (wi = A.from(wi, Ji), Ji = ""), pi = !0), lr(this, wi, Ji, !1, pi);
  }, or.prototype.unshift = function(wi) {
    return lr(this, wi, null, !0, !1);
  };
  function lr(wi, Ji, mn, pi, ei) {
    var Vr = wi._readableState;
    if (Ji === null)
      Vr.reading = !1, Sr(wi, Vr);
    else {
      var qr;
      ei || (qr = xr(Vr, Ji)), qr ? wi.emit("error", qr) : Vr.objectMode || Ji && Ji.length > 0 ? (typeof Ji != "string" && !Vr.objectMode && Object.getPrototypeOf(Ji) !== A.prototype && (Ji = F(Ji)), pi ? Vr.endEmitted ? wi.emit("error", new Error("stream.unshift() after end event")) : Ir(wi, Vr, Ji, !0) : Vr.ended ? wi.emit("error", new Error("stream.push() after EOF")) : (Vr.reading = !1, Vr.decoder && !mn ? (Ji = Vr.decoder.write(Ji), Vr.objectMode || Ji.length !== 0 ? Ir(wi, Vr, Ji, !1) : xe(wi, Vr)) : Ir(wi, Vr, Ji, !1))) : pi || (Vr.reading = !1);
    }
    return kr(Vr);
  }
  function Ir(wi, Ji, mn, pi) {
    Ji.flowing && Ji.length === 0 && !Ji.sync ? (wi.emit("data", mn), wi.read(0)) : (Ji.length += Ji.objectMode ? 1 : mn.length, pi ? Ji.buffer.unshift(mn) : Ji.buffer.push(mn), Ji.needReadable && er(wi)), xe(wi, Ji);
  }
  function xr(wi, Ji) {
    var mn;
    return !le(Ji) && typeof Ji != "string" && Ji !== void 0 && !wi.objectMode && (mn = new TypeError("Invalid non-string/buffer chunk")), mn;
  }
  function kr(wi) {
    return !wi.ended && (wi.needReadable || wi.length < wi.highWaterMark || wi.length === 0);
  }
  or.prototype.isPaused = function() {
    return this._readableState.flowing === !1;
  }, or.prototype.setEncoding = function(wi) {
    return He || (He = string_decoder.StringDecoder), this._readableState.decoder = new He(wi), this._readableState.encoding = wi, this;
  };
  var Ce = 8388608;
  function tr(wi) {
    return wi >= Ce ? wi = Ce : (wi--, wi |= wi >>> 1, wi |= wi >>> 2, wi |= wi >>> 4, wi |= wi >>> 8, wi |= wi >>> 16, wi++), wi;
  }
  function Fe(wi, Ji) {
    return wi <= 0 || Ji.length === 0 && Ji.ended ? 0 : Ji.objectMode ? 1 : wi !== wi ? Ji.flowing && Ji.length ? Ji.buffer.head.data.length : Ji.length : (wi > Ji.highWaterMark && (Ji.highWaterMark = tr(wi)), wi <= Ji.length ? wi : Ji.ended ? Ji.length : (Ji.needReadable = !0, 0));
  }
  or.prototype.read = function(wi) {
    $("read", wi), wi = parseInt(wi, 10);
    var Ji = this._readableState, mn = wi;
    if (wi !== 0 && (Ji.emittedReadable = !1), wi === 0 && Ji.needReadable && (Ji.length >= Ji.highWaterMark || Ji.ended))
      return $("read: emitReadable", Ji.length, Ji.ended), Ji.length === 0 && Ji.ended ? ui(this) : er(this), null;
    if (wi = Fe(wi, Ji), wi === 0 && Ji.ended)
      return Ji.length === 0 && ui(this), null;
    var pi = Ji.needReadable;
    $("need readable", pi), (Ji.length === 0 || Ji.length - wi < Ji.highWaterMark) && (pi = !0, $("length less than watermark", pi)), Ji.ended || Ji.reading ? (pi = !1, $("reading or ended", pi)) : pi && ($("do read"), Ji.reading = !0, Ji.sync = !0, Ji.length === 0 && (Ji.needReadable = !0), this._read(Ji.highWaterMark), Ji.sync = !1, Ji.reading || (wi = Fe(mn, Ji)));
    var ei;
    return wi > 0 ? ei = Te(wi, Ji) : ei = null, ei === null ? (Ji.needReadable = !0, wi = 0) : Ji.length -= wi, Ji.length === 0 && (Ji.ended || (Ji.needReadable = !0), mn !== wi && Ji.ended && ui(this)), ei !== null && this.emit("data", ei), ei;
  };
  function Sr(wi, Ji) {
    if (!Ji.ended) {
      if (Ji.decoder) {
        var mn = Ji.decoder.end();
        mn && mn.length && (Ji.buffer.push(mn), Ji.length += Ji.objectMode ? 1 : mn.length);
      }
      Ji.ended = !0, er(wi);
    }
  }
  function er(wi) {
    var Ji = wi._readableState;
    Ji.needReadable = !1, Ji.emittedReadable || ($("emitReadable", Ji.flowing), Ji.emittedReadable = !0, Ji.sync ? n.nextTick(Ie, wi) : Ie(wi));
  }
  function Ie(wi) {
    $("emit readable"), wi.emit("readable"), vr(wi);
  }
  function xe(wi, Ji) {
    Ji.readingMore || (Ji.readingMore = !0, n.nextTick(rr, wi, Ji));
  }
  function rr(wi, Ji) {
    for (var mn = Ji.length; !Ji.reading && !Ji.flowing && !Ji.ended && Ji.length < Ji.highWaterMark && ($("maybeReadMore read 0"), wi.read(0), mn !== Ji.length); )
      mn = Ji.length;
    Ji.readingMore = !1;
  }
  or.prototype._read = function(wi) {
    this.emit("error", new Error("_read() is not implemented"));
  }, or.prototype.pipe = function(wi, Ji) {
    var mn = this, pi = this._readableState;
    switch (pi.pipesCount) {
      case 0:
        pi.pipes = wi;
        break;
      case 1:
        pi.pipes = [pi.pipes, wi];
        break;
      default:
        pi.pipes.push(wi);
        break;
    }
    pi.pipesCount += 1, $("pipe count=%d opts=%j", pi.pipesCount, Ji);
    var ei = (!Ji || Ji.end !== !1) && wi !== process$1.stdout && wi !== process$1.stderr, Vr = ei ? Zi : Do;
    pi.endEmitted ? n.nextTick(Vr) : mn.once("end", Vr), wi.on("unpipe", qr);
    function qr(gn, Gn) {
      $("onunpipe"), gn === mn && Gn && Gn.hasUnpiped === !1 && (Gn.hasUnpiped = !0, _i());
    }
    function Zi() {
      $("onend"), wi.end();
    }
    var Wr = ar(mn);
    wi.on("drain", Wr);
    var ri = !1;
    function _i() {
      $("cleanup"), wi.removeListener("close", On), wi.removeListener("finish", so), wi.removeListener("drain", Wr), wi.removeListener("error", _n), wi.removeListener("unpipe", qr), mn.removeListener("end", Zi), mn.removeListener("end", Do), mn.removeListener("data", Di), ri = !0, pi.awaitDrain && (!wi._writableState || wi._writableState.needDrain) && Wr();
    }
    var Er = !1;
    mn.on("data", Di);
    function Di(gn) {
      $("ondata"), Er = !1;
      var Gn = wi.write(gn);
      Gn === !1 && !Er && ((pi.pipesCount === 1 && pi.pipes === wi || pi.pipesCount > 1 && Qi(pi.pipes, wi) !== -1) && !ri && ($("false write response, pause", pi.awaitDrain), pi.awaitDrain++, Er = !0), mn.pause());
    }
    function _n(gn) {
      $("onerror", gn), Do(), wi.removeListener("error", _n), p(wi, "error") === 0 && wi.emit("error", gn);
    }
    nr(wi, "error", _n);
    function On() {
      wi.removeListener("finish", so), Do();
    }
    wi.once("close", On);
    function so() {
      $("onfinish"), wi.removeListener("close", On), Do();
    }
    wi.once("finish", so);
    function Do() {
      $("unpipe"), mn.unpipe(wi);
    }
    return wi.emit("pipe", mn), pi.flowing || ($("pipe resume"), mn.resume()), wi;
  };
  function ar(wi) {
    return function() {
      var Ji = wi._readableState;
      $("pipeOnDrain", Ji.awaitDrain), Ji.awaitDrain && Ji.awaitDrain--, Ji.awaitDrain === 0 && p(wi, "data") && (Ji.flowing = !0, vr(wi));
    };
  }
  or.prototype.unpipe = function(wi) {
    var Ji = this._readableState, mn = { hasUnpiped: !1 };
    if (Ji.pipesCount === 0) return this;
    if (Ji.pipesCount === 1)
      return wi && wi !== Ji.pipes ? this : (wi || (wi = Ji.pipes), Ji.pipes = null, Ji.pipesCount = 0, Ji.flowing = !1, wi && wi.emit("unpipe", this, mn), this);
    if (!wi) {
      var pi = Ji.pipes, ei = Ji.pipesCount;
      Ji.pipes = null, Ji.pipesCount = 0, Ji.flowing = !1;
      for (var Vr = 0; Vr < ei; Vr++)
        pi[Vr].emit("unpipe", this, { hasUnpiped: !1 });
      return this;
    }
    var qr = Qi(Ji.pipes, wi);
    return qr === -1 ? this : (Ji.pipes.splice(qr, 1), Ji.pipesCount -= 1, Ji.pipesCount === 1 && (Ji.pipes = Ji.pipes[0]), wi.emit("unpipe", this, mn), this);
  }, or.prototype.on = function(wi, Ji) {
    var mn = a.prototype.on.call(this, wi, Ji);
    if (wi === "data")
      this._readableState.flowing !== !1 && this.resume();
    else if (wi === "readable") {
      var pi = this._readableState;
      !pi.endEmitted && !pi.readableListening && (pi.readableListening = pi.needReadable = !0, pi.emittedReadable = !1, pi.reading ? pi.length && er(this) : n.nextTick(yr, this));
    }
    return mn;
  }, or.prototype.addListener = or.prototype.on;
  function yr(wi) {
    $("readable nexttick read 0"), wi.read(0);
  }
  or.prototype.resume = function() {
    var wi = this._readableState;
    return wi.flowing || ($("resume"), wi.flowing = !0, _r(this, wi)), this;
  };
  function _r(wi, Ji) {
    Ji.resumeScheduled || (Ji.resumeScheduled = !0, n.nextTick(Or, wi, Ji));
  }
  function Or(wi, Ji) {
    Ji.reading || ($("resume read 0"), wi.read(0)), Ji.resumeScheduled = !1, Ji.awaitDrain = 0, wi.emit("resume"), vr(wi), Ji.flowing && !Ji.reading && wi.read(0);
  }
  or.prototype.pause = function() {
    return $("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && ($("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
  };
  function vr(wi) {
    var Ji = wi._readableState;
    for ($("flow", Ji.flowing); Ji.flowing && wi.read() !== null; )
      ;
  }
  or.prototype.wrap = function(wi) {
    var Ji = this, mn = this._readableState, pi = !1;
    wi.on("end", function() {
      if ($("wrapped end"), mn.decoder && !mn.ended) {
        var qr = mn.decoder.end();
        qr && qr.length && Ji.push(qr);
      }
      Ji.push(null);
    }), wi.on("data", function(qr) {
      if ($("wrapped data"), mn.decoder && (qr = mn.decoder.write(qr)), !(mn.objectMode && qr == null) && !(!mn.objectMode && (!qr || !qr.length))) {
        var Zi = Ji.push(qr);
        Zi || (pi = !0, wi.pause());
      }
    });
    for (var ei in wi)
      this[ei] === void 0 && typeof wi[ei] == "function" && (this[ei] = /* @__PURE__ */ function(qr) {
        return function() {
          return wi[qr].apply(wi, arguments);
        };
      }(ei));
    for (var Vr = 0; Vr < Pe.length; Vr++)
      wi.on(Pe[Vr], this.emit.bind(this, Pe[Vr]));
    return this._read = function(qr) {
      $("wrapped _read", qr), pi && (pi = !1, wi.resume());
    }, this;
  }, Object.defineProperty(or.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.highWaterMark;
    }
  }), or._fromList = Te;
  function Te(wi, Ji) {
    if (Ji.length === 0) return null;
    var mn;
    return Ji.objectMode ? mn = Ji.buffer.shift() : !wi || wi >= Ji.length ? (Ji.decoder ? mn = Ji.buffer.join("") : Ji.buffer.length === 1 ? mn = Ji.buffer.head.data : mn = Ji.buffer.concat(Ji.length), Ji.buffer.clear()) : mn = Cr(wi, Ji.buffer, Ji.decoder), mn;
  }
  function Cr(wi, Ji, mn) {
    var pi;
    return wi < Ji.head.data.length ? (pi = Ji.head.data.slice(0, wi), Ji.head.data = Ji.head.data.slice(wi)) : wi === Ji.head.data.length ? pi = Ji.shift() : pi = mn ? Hr(wi, Ji) : si(wi, Ji), pi;
  }
  function Hr(wi, Ji) {
    var mn = Ji.head, pi = 1, ei = mn.data;
    for (wi -= ei.length; mn = mn.next; ) {
      var Vr = mn.data, qr = wi > Vr.length ? Vr.length : wi;
      if (qr === Vr.length ? ei += Vr : ei += Vr.slice(0, wi), wi -= qr, wi === 0) {
        qr === Vr.length ? (++pi, mn.next ? Ji.head = mn.next : Ji.head = Ji.tail = null) : (Ji.head = mn, mn.data = Vr.slice(qr));
        break;
      }
      ++pi;
    }
    return Ji.length -= pi, ei;
  }
  function si(wi, Ji) {
    var mn = A.allocUnsafe(wi), pi = Ji.head, ei = 1;
    for (pi.data.copy(mn), wi -= pi.data.length; pi = pi.next; ) {
      var Vr = pi.data, qr = wi > Vr.length ? Vr.length : wi;
      if (Vr.copy(mn, mn.length - wi, 0, qr), wi -= qr, wi === 0) {
        qr === Vr.length ? (++ei, pi.next ? Ji.head = pi.next : Ji.head = Ji.tail = null) : (Ji.head = pi, pi.data = Vr.slice(qr));
        break;
      }
      ++ei;
    }
    return Ji.length -= ei, mn;
  }
  function ui(wi) {
    var Ji = wi._readableState;
    if (Ji.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    Ji.endEmitted || (Ji.ended = !0, n.nextTick(Li, Ji, wi));
  }
  function Li(wi, Ji) {
    !wi.endEmitted && wi.length === 0 && (wi.endEmitted = !0, Ji.readable = !1, Ji.emit("end"));
  }
  function Qi(wi, Ji) {
    for (var mn = 0, pi = wi.length; mn < pi; mn++)
      if (wi[mn] === Ji) return mn;
    return -1;
  }
  return _stream_readable;
}
var _stream_transform, hasRequired_stream_transform;
function require_stream_transform() {
  if (hasRequired_stream_transform) return _stream_transform;
  hasRequired_stream_transform = 1, _stream_transform = p;
  var n = require_stream_duplex(), c = Object.create(requireUtil());
  c.inherits = inherits_browserExports, c.inherits(p, n);
  function u(b, F) {
    var le = this._transformState;
    le.transforming = !1;
    var L = le.writecb;
    if (!L)
      return this.emit("error", new Error("write callback called multiple times"));
    le.writechunk = null, le.writecb = null, F != null && this.push(F), L(b);
    var pe = this._readableState;
    pe.reading = !1, (pe.needReadable || pe.length < pe.highWaterMark) && this._read(pe.highWaterMark);
  }
  function p(b) {
    if (!(this instanceof p)) return new p(b);
    n.call(this, b), this._transformState = {
      afterTransform: u.bind(this),
      needTransform: !1,
      transforming: !1,
      writecb: null,
      writechunk: null,
      writeencoding: null
    }, this._readableState.needReadable = !0, this._readableState.sync = !1, b && (typeof b.transform == "function" && (this._transform = b.transform), typeof b.flush == "function" && (this._flush = b.flush)), this.on("prefinish", a);
  }
  function a() {
    var b = this;
    typeof this._flush == "function" ? this._flush(function(F, le) {
      A(b, F, le);
    }) : A(this, null, null);
  }
  p.prototype.push = function(b, F) {
    return this._transformState.needTransform = !1, n.prototype.push.call(this, b, F);
  }, p.prototype._transform = function(b, F, le) {
    throw new Error("_transform() is not implemented");
  }, p.prototype._write = function(b, F, le) {
    var L = this._transformState;
    if (L.writecb = le, L.writechunk = b, L.writeencoding = F, !L.transforming) {
      var pe = this._readableState;
      (L.needTransform || pe.needReadable || pe.length < pe.highWaterMark) && this._read(pe.highWaterMark);
    }
  }, p.prototype._read = function(b) {
    var F = this._transformState;
    F.writechunk !== null && F.writecb && !F.transforming ? (F.transforming = !0, this._transform(F.writechunk, F.writeencoding, F.afterTransform)) : F.needTransform = !0;
  }, p.prototype._destroy = function(b, F) {
    var le = this;
    n.prototype._destroy.call(this, b, function(L) {
      F(L), le.emit("close");
    });
  };
  function A(b, F, le) {
    if (F) return b.emit("error", F);
    if (le != null && b.push(le), b._writableState.length) throw new Error("Calling transform done when ws.length != 0");
    if (b._transformState.transforming) throw new Error("Calling transform done when still transforming");
    return b.push(null);
  }
  return _stream_transform;
}
var _stream_passthrough, hasRequired_stream_passthrough;
function require_stream_passthrough() {
  if (hasRequired_stream_passthrough) return _stream_passthrough;
  hasRequired_stream_passthrough = 1, _stream_passthrough = u;
  var n = require_stream_transform(), c = Object.create(requireUtil());
  c.inherits = inherits_browserExports, c.inherits(u, n);
  function u(p) {
    if (!(this instanceof u)) return new u(p);
    n.call(this, p);
  }
  return u.prototype._transform = function(p, a, A) {
    A(null, p);
  }, _stream_passthrough;
}
var hasRequiredReadableBrowser;
function requireReadableBrowser() {
  return hasRequiredReadableBrowser || (hasRequiredReadableBrowser = 1, function(n, c) {
    c = n.exports = require_stream_readable(), c.Stream = c, c.Readable = c, c.Writable = require_stream_writable(), c.Duplex = require_stream_duplex(), c.Transform = require_stream_transform(), c.PassThrough = require_stream_passthrough();
  }(readableBrowser, readableBrowser.exports)), readableBrowser.exports;
}
var sign$3 = { exports: {} }, bn$4 = { exports: {} };
bn$4.exports;
(function(n) {
  (function(c, u) {
    function p(xe, rr) {
      if (!xe) throw new Error(rr || "Assertion failed");
    }
    function a(xe, rr) {
      xe.super_ = rr;
      var ar = function() {
      };
      ar.prototype = rr.prototype, xe.prototype = new ar(), xe.prototype.constructor = xe;
    }
    function A(xe, rr, ar) {
      if (A.isBN(xe))
        return xe;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, xe !== null && ((rr === "le" || rr === "be") && (ar = rr, rr = 10), this._init(xe || 0, rr || 10, ar || "be"));
    }
    typeof c == "object" ? c.exports = A : u.BN = A, A.BN = A, A.wordSize = 26;
    var b;
    try {
      typeof window < "u" && typeof window.Buffer < "u" ? b = window.Buffer : b = require$$0$5.Buffer;
    } catch {
    }
    A.isBN = function(rr) {
      return rr instanceof A ? !0 : rr !== null && typeof rr == "object" && rr.constructor.wordSize === A.wordSize && Array.isArray(rr.words);
    }, A.max = function(rr, ar) {
      return rr.cmp(ar) > 0 ? rr : ar;
    }, A.min = function(rr, ar) {
      return rr.cmp(ar) < 0 ? rr : ar;
    }, A.prototype._init = function(rr, ar, yr) {
      if (typeof rr == "number")
        return this._initNumber(rr, ar, yr);
      if (typeof rr == "object")
        return this._initArray(rr, ar, yr);
      ar === "hex" && (ar = 16), p(ar === (ar | 0) && ar >= 2 && ar <= 36), rr = rr.toString().replace(/\s+/g, "");
      var _r = 0;
      rr[0] === "-" && (_r++, this.negative = 1), _r < rr.length && (ar === 16 ? this._parseHex(rr, _r, yr) : (this._parseBase(rr, ar, _r), yr === "le" && this._initArray(this.toArray(), ar, yr)));
    }, A.prototype._initNumber = function(rr, ar, yr) {
      rr < 0 && (this.negative = 1, rr = -rr), rr < 67108864 ? (this.words = [rr & 67108863], this.length = 1) : rr < 4503599627370496 ? (this.words = [
        rr & 67108863,
        rr / 67108864 & 67108863
      ], this.length = 2) : (p(rr < 9007199254740992), this.words = [
        rr & 67108863,
        rr / 67108864 & 67108863,
        1
      ], this.length = 3), yr === "le" && this._initArray(this.toArray(), ar, yr);
    }, A.prototype._initArray = function(rr, ar, yr) {
      if (p(typeof rr.length == "number"), rr.length <= 0)
        return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(rr.length / 3), this.words = new Array(this.length);
      for (var _r = 0; _r < this.length; _r++)
        this.words[_r] = 0;
      var Or, vr, Te = 0;
      if (yr === "be")
        for (_r = rr.length - 1, Or = 0; _r >= 0; _r -= 3)
          vr = rr[_r] | rr[_r - 1] << 8 | rr[_r - 2] << 16, this.words[Or] |= vr << Te & 67108863, this.words[Or + 1] = vr >>> 26 - Te & 67108863, Te += 24, Te >= 26 && (Te -= 26, Or++);
      else if (yr === "le")
        for (_r = 0, Or = 0; _r < rr.length; _r += 3)
          vr = rr[_r] | rr[_r + 1] << 8 | rr[_r + 2] << 16, this.words[Or] |= vr << Te & 67108863, this.words[Or + 1] = vr >>> 26 - Te & 67108863, Te += 24, Te >= 26 && (Te -= 26, Or++);
      return this._strip();
    };
    function F(xe, rr) {
      var ar = xe.charCodeAt(rr);
      if (ar >= 48 && ar <= 57)
        return ar - 48;
      if (ar >= 65 && ar <= 70)
        return ar - 55;
      if (ar >= 97 && ar <= 102)
        return ar - 87;
      p(!1, "Invalid character in " + xe);
    }
    function le(xe, rr, ar) {
      var yr = F(xe, ar);
      return ar - 1 >= rr && (yr |= F(xe, ar - 1) << 4), yr;
    }
    A.prototype._parseHex = function(rr, ar, yr) {
      this.length = Math.ceil((rr.length - ar) / 6), this.words = new Array(this.length);
      for (var _r = 0; _r < this.length; _r++)
        this.words[_r] = 0;
      var Or = 0, vr = 0, Te;
      if (yr === "be")
        for (_r = rr.length - 1; _r >= ar; _r -= 2)
          Te = le(rr, ar, _r) << Or, this.words[vr] |= Te & 67108863, Or >= 18 ? (Or -= 18, vr += 1, this.words[vr] |= Te >>> 26) : Or += 8;
      else {
        var Cr = rr.length - ar;
        for (_r = Cr % 2 === 0 ? ar + 1 : ar; _r < rr.length; _r += 2)
          Te = le(rr, ar, _r) << Or, this.words[vr] |= Te & 67108863, Or >= 18 ? (Or -= 18, vr += 1, this.words[vr] |= Te >>> 26) : Or += 8;
      }
      this._strip();
    };
    function L(xe, rr, ar, yr) {
      for (var _r = 0, Or = 0, vr = Math.min(xe.length, ar), Te = rr; Te < vr; Te++) {
        var Cr = xe.charCodeAt(Te) - 48;
        _r *= yr, Cr >= 49 ? Or = Cr - 49 + 10 : Cr >= 17 ? Or = Cr - 17 + 10 : Or = Cr, p(Cr >= 0 && Or < yr, "Invalid character"), _r += Or;
      }
      return _r;
    }
    A.prototype._parseBase = function(rr, ar, yr) {
      this.words = [0], this.length = 1;
      for (var _r = 0, Or = 1; Or <= 67108863; Or *= ar)
        _r++;
      _r--, Or = Or / ar | 0;
      for (var vr = rr.length - yr, Te = vr % _r, Cr = Math.min(vr, vr - Te) + yr, Hr = 0, si = yr; si < Cr; si += _r)
        Hr = L(rr, si, si + _r, ar), this.imuln(Or), this.words[0] + Hr < 67108864 ? this.words[0] += Hr : this._iaddn(Hr);
      if (Te !== 0) {
        var ui = 1;
        for (Hr = L(rr, si, rr.length, ar), si = 0; si < Te; si++)
          ui *= ar;
        this.imuln(ui), this.words[0] + Hr < 67108864 ? this.words[0] += Hr : this._iaddn(Hr);
      }
      this._strip();
    }, A.prototype.copy = function(rr) {
      rr.words = new Array(this.length);
      for (var ar = 0; ar < this.length; ar++)
        rr.words[ar] = this.words[ar];
      rr.length = this.length, rr.negative = this.negative, rr.red = this.red;
    };
    function pe(xe, rr) {
      xe.words = rr.words, xe.length = rr.length, xe.negative = rr.negative, xe.red = rr.red;
    }
    if (A.prototype._move = function(rr) {
      pe(rr, this);
    }, A.prototype.clone = function() {
      var rr = new A(null);
      return this.copy(rr), rr;
    }, A.prototype._expand = function(rr) {
      for (; this.length < rr; )
        this.words[this.length++] = 0;
      return this;
    }, A.prototype._strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; )
        this.length--;
      return this._normSign();
    }, A.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, typeof Symbol < "u" && typeof Symbol.for == "function")
      try {
        A.prototype[Symbol.for("nodejs.util.inspect.custom")] = $;
      } catch {
        A.prototype.inspect = $;
      }
    else
      A.prototype.inspect = $;
    function $() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    var Ee = [
      "",
      "0",
      "00",
      "000",
      "0000",
      "00000",
      "000000",
      "0000000",
      "00000000",
      "000000000",
      "0000000000",
      "00000000000",
      "000000000000",
      "0000000000000",
      "00000000000000",
      "000000000000000",
      "0000000000000000",
      "00000000000000000",
      "000000000000000000",
      "0000000000000000000",
      "00000000000000000000",
      "000000000000000000000",
      "0000000000000000000000",
      "00000000000000000000000",
      "000000000000000000000000",
      "0000000000000000000000000"
    ], be = [
      0,
      0,
      25,
      16,
      12,
      11,
      10,
      9,
      8,
      8,
      7,
      7,
      7,
      7,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5
    ], He = [
      0,
      0,
      33554432,
      43046721,
      16777216,
      48828125,
      60466176,
      40353607,
      16777216,
      43046721,
      1e7,
      19487171,
      35831808,
      62748517,
      7529536,
      11390625,
      16777216,
      24137569,
      34012224,
      47045881,
      64e6,
      4084101,
      5153632,
      6436343,
      7962624,
      9765625,
      11881376,
      14348907,
      17210368,
      20511149,
      243e5,
      28629151,
      33554432,
      39135393,
      45435424,
      52521875,
      60466176
    ];
    A.prototype.toString = function(rr, ar) {
      rr = rr || 10, ar = ar | 0 || 1;
      var yr;
      if (rr === 16 || rr === "hex") {
        yr = "";
        for (var _r = 0, Or = 0, vr = 0; vr < this.length; vr++) {
          var Te = this.words[vr], Cr = ((Te << _r | Or) & 16777215).toString(16);
          Or = Te >>> 24 - _r & 16777215, _r += 2, _r >= 26 && (_r -= 26, vr--), Or !== 0 || vr !== this.length - 1 ? yr = Ee[6 - Cr.length] + Cr + yr : yr = Cr + yr;
        }
        for (Or !== 0 && (yr = Or.toString(16) + yr); yr.length % ar !== 0; )
          yr = "0" + yr;
        return this.negative !== 0 && (yr = "-" + yr), yr;
      }
      if (rr === (rr | 0) && rr >= 2 && rr <= 36) {
        var Hr = be[rr], si = He[rr];
        yr = "";
        var ui = this.clone();
        for (ui.negative = 0; !ui.isZero(); ) {
          var Li = ui.modrn(si).toString(rr);
          ui = ui.idivn(si), ui.isZero() ? yr = Li + yr : yr = Ee[Hr - Li.length] + Li + yr;
        }
        for (this.isZero() && (yr = "0" + yr); yr.length % ar !== 0; )
          yr = "0" + yr;
        return this.negative !== 0 && (yr = "-" + yr), yr;
      }
      p(!1, "Base should be between 2 and 36");
    }, A.prototype.toNumber = function() {
      var rr = this.words[0];
      return this.length === 2 ? rr += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? rr += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && p(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -rr : rr;
    }, A.prototype.toJSON = function() {
      return this.toString(16, 2);
    }, b && (A.prototype.toBuffer = function(rr, ar) {
      return this.toArrayLike(b, rr, ar);
    }), A.prototype.toArray = function(rr, ar) {
      return this.toArrayLike(Array, rr, ar);
    };
    var Pe = function(rr, ar) {
      return rr.allocUnsafe ? rr.allocUnsafe(ar) : new rr(ar);
    };
    A.prototype.toArrayLike = function(rr, ar, yr) {
      this._strip();
      var _r = this.byteLength(), Or = yr || Math.max(1, _r);
      p(_r <= Or, "byte array longer than desired length"), p(Or > 0, "Requested array length <= 0");
      var vr = Pe(rr, Or), Te = ar === "le" ? "LE" : "BE";
      return this["_toArrayLike" + Te](vr, _r), vr;
    }, A.prototype._toArrayLikeLE = function(rr, ar) {
      for (var yr = 0, _r = 0, Or = 0, vr = 0; Or < this.length; Or++) {
        var Te = this.words[Or] << vr | _r;
        rr[yr++] = Te & 255, yr < rr.length && (rr[yr++] = Te >> 8 & 255), yr < rr.length && (rr[yr++] = Te >> 16 & 255), vr === 6 ? (yr < rr.length && (rr[yr++] = Te >> 24 & 255), _r = 0, vr = 0) : (_r = Te >>> 24, vr += 2);
      }
      if (yr < rr.length)
        for (rr[yr++] = _r; yr < rr.length; )
          rr[yr++] = 0;
    }, A.prototype._toArrayLikeBE = function(rr, ar) {
      for (var yr = rr.length - 1, _r = 0, Or = 0, vr = 0; Or < this.length; Or++) {
        var Te = this.words[Or] << vr | _r;
        rr[yr--] = Te & 255, yr >= 0 && (rr[yr--] = Te >> 8 & 255), yr >= 0 && (rr[yr--] = Te >> 16 & 255), vr === 6 ? (yr >= 0 && (rr[yr--] = Te >> 24 & 255), _r = 0, vr = 0) : (_r = Te >>> 24, vr += 2);
      }
      if (yr >= 0)
        for (rr[yr--] = _r; yr >= 0; )
          rr[yr--] = 0;
    }, Math.clz32 ? A.prototype._countBits = function(rr) {
      return 32 - Math.clz32(rr);
    } : A.prototype._countBits = function(rr) {
      var ar = rr, yr = 0;
      return ar >= 4096 && (yr += 13, ar >>>= 13), ar >= 64 && (yr += 7, ar >>>= 7), ar >= 8 && (yr += 4, ar >>>= 4), ar >= 2 && (yr += 2, ar >>>= 2), yr + ar;
    }, A.prototype._zeroBits = function(rr) {
      if (rr === 0) return 26;
      var ar = rr, yr = 0;
      return ar & 8191 || (yr += 13, ar >>>= 13), ar & 127 || (yr += 7, ar >>>= 7), ar & 15 || (yr += 4, ar >>>= 4), ar & 3 || (yr += 2, ar >>>= 2), ar & 1 || yr++, yr;
    }, A.prototype.bitLength = function() {
      var rr = this.words[this.length - 1], ar = this._countBits(rr);
      return (this.length - 1) * 26 + ar;
    };
    function nr(xe) {
      for (var rr = new Array(xe.bitLength()), ar = 0; ar < rr.length; ar++) {
        var yr = ar / 26 | 0, _r = ar % 26;
        rr[ar] = xe.words[yr] >>> _r & 1;
      }
      return rr;
    }
    A.prototype.zeroBits = function() {
      if (this.isZero()) return 0;
      for (var rr = 0, ar = 0; ar < this.length; ar++) {
        var yr = this._zeroBits(this.words[ar]);
        if (rr += yr, yr !== 26) break;
      }
      return rr;
    }, A.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, A.prototype.toTwos = function(rr) {
      return this.negative !== 0 ? this.abs().inotn(rr).iaddn(1) : this.clone();
    }, A.prototype.fromTwos = function(rr) {
      return this.testn(rr - 1) ? this.notn(rr).iaddn(1).ineg() : this.clone();
    }, A.prototype.isNeg = function() {
      return this.negative !== 0;
    }, A.prototype.neg = function() {
      return this.clone().ineg();
    }, A.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, A.prototype.iuor = function(rr) {
      for (; this.length < rr.length; )
        this.words[this.length++] = 0;
      for (var ar = 0; ar < rr.length; ar++)
        this.words[ar] = this.words[ar] | rr.words[ar];
      return this._strip();
    }, A.prototype.ior = function(rr) {
      return p((this.negative | rr.negative) === 0), this.iuor(rr);
    }, A.prototype.or = function(rr) {
      return this.length > rr.length ? this.clone().ior(rr) : rr.clone().ior(this);
    }, A.prototype.uor = function(rr) {
      return this.length > rr.length ? this.clone().iuor(rr) : rr.clone().iuor(this);
    }, A.prototype.iuand = function(rr) {
      var ar;
      this.length > rr.length ? ar = rr : ar = this;
      for (var yr = 0; yr < ar.length; yr++)
        this.words[yr] = this.words[yr] & rr.words[yr];
      return this.length = ar.length, this._strip();
    }, A.prototype.iand = function(rr) {
      return p((this.negative | rr.negative) === 0), this.iuand(rr);
    }, A.prototype.and = function(rr) {
      return this.length > rr.length ? this.clone().iand(rr) : rr.clone().iand(this);
    }, A.prototype.uand = function(rr) {
      return this.length > rr.length ? this.clone().iuand(rr) : rr.clone().iuand(this);
    }, A.prototype.iuxor = function(rr) {
      var ar, yr;
      this.length > rr.length ? (ar = this, yr = rr) : (ar = rr, yr = this);
      for (var _r = 0; _r < yr.length; _r++)
        this.words[_r] = ar.words[_r] ^ yr.words[_r];
      if (this !== ar)
        for (; _r < ar.length; _r++)
          this.words[_r] = ar.words[_r];
      return this.length = ar.length, this._strip();
    }, A.prototype.ixor = function(rr) {
      return p((this.negative | rr.negative) === 0), this.iuxor(rr);
    }, A.prototype.xor = function(rr) {
      return this.length > rr.length ? this.clone().ixor(rr) : rr.clone().ixor(this);
    }, A.prototype.uxor = function(rr) {
      return this.length > rr.length ? this.clone().iuxor(rr) : rr.clone().iuxor(this);
    }, A.prototype.inotn = function(rr) {
      p(typeof rr == "number" && rr >= 0);
      var ar = Math.ceil(rr / 26) | 0, yr = rr % 26;
      this._expand(ar), yr > 0 && ar--;
      for (var _r = 0; _r < ar; _r++)
        this.words[_r] = ~this.words[_r] & 67108863;
      return yr > 0 && (this.words[_r] = ~this.words[_r] & 67108863 >> 26 - yr), this._strip();
    }, A.prototype.notn = function(rr) {
      return this.clone().inotn(rr);
    }, A.prototype.setn = function(rr, ar) {
      p(typeof rr == "number" && rr >= 0);
      var yr = rr / 26 | 0, _r = rr % 26;
      return this._expand(yr + 1), ar ? this.words[yr] = this.words[yr] | 1 << _r : this.words[yr] = this.words[yr] & ~(1 << _r), this._strip();
    }, A.prototype.iadd = function(rr) {
      var ar;
      if (this.negative !== 0 && rr.negative === 0)
        return this.negative = 0, ar = this.isub(rr), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && rr.negative !== 0)
        return rr.negative = 0, ar = this.isub(rr), rr.negative = 1, ar._normSign();
      var yr, _r;
      this.length > rr.length ? (yr = this, _r = rr) : (yr = rr, _r = this);
      for (var Or = 0, vr = 0; vr < _r.length; vr++)
        ar = (yr.words[vr] | 0) + (_r.words[vr] | 0) + Or, this.words[vr] = ar & 67108863, Or = ar >>> 26;
      for (; Or !== 0 && vr < yr.length; vr++)
        ar = (yr.words[vr] | 0) + Or, this.words[vr] = ar & 67108863, Or = ar >>> 26;
      if (this.length = yr.length, Or !== 0)
        this.words[this.length] = Or, this.length++;
      else if (yr !== this)
        for (; vr < yr.length; vr++)
          this.words[vr] = yr.words[vr];
      return this;
    }, A.prototype.add = function(rr) {
      var ar;
      return rr.negative !== 0 && this.negative === 0 ? (rr.negative = 0, ar = this.sub(rr), rr.negative ^= 1, ar) : rr.negative === 0 && this.negative !== 0 ? (this.negative = 0, ar = rr.sub(this), this.negative = 1, ar) : this.length > rr.length ? this.clone().iadd(rr) : rr.clone().iadd(this);
    }, A.prototype.isub = function(rr) {
      if (rr.negative !== 0) {
        rr.negative = 0;
        var ar = this.iadd(rr);
        return rr.negative = 1, ar._normSign();
      } else if (this.negative !== 0)
        return this.negative = 0, this.iadd(rr), this.negative = 1, this._normSign();
      var yr = this.cmp(rr);
      if (yr === 0)
        return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var _r, Or;
      yr > 0 ? (_r = this, Or = rr) : (_r = rr, Or = this);
      for (var vr = 0, Te = 0; Te < Or.length; Te++)
        ar = (_r.words[Te] | 0) - (Or.words[Te] | 0) + vr, vr = ar >> 26, this.words[Te] = ar & 67108863;
      for (; vr !== 0 && Te < _r.length; Te++)
        ar = (_r.words[Te] | 0) + vr, vr = ar >> 26, this.words[Te] = ar & 67108863;
      if (vr === 0 && Te < _r.length && _r !== this)
        for (; Te < _r.length; Te++)
          this.words[Te] = _r.words[Te];
      return this.length = Math.max(this.length, Te), _r !== this && (this.negative = 1), this._strip();
    }, A.prototype.sub = function(rr) {
      return this.clone().isub(rr);
    };
    function ir(xe, rr, ar) {
      ar.negative = rr.negative ^ xe.negative;
      var yr = xe.length + rr.length | 0;
      ar.length = yr, yr = yr - 1 | 0;
      var _r = xe.words[0] | 0, Or = rr.words[0] | 0, vr = _r * Or, Te = vr & 67108863, Cr = vr / 67108864 | 0;
      ar.words[0] = Te;
      for (var Hr = 1; Hr < yr; Hr++) {
        for (var si = Cr >>> 26, ui = Cr & 67108863, Li = Math.min(Hr, rr.length - 1), Qi = Math.max(0, Hr - xe.length + 1); Qi <= Li; Qi++) {
          var wi = Hr - Qi | 0;
          _r = xe.words[wi] | 0, Or = rr.words[Qi] | 0, vr = _r * Or + ui, si += vr / 67108864 | 0, ui = vr & 67108863;
        }
        ar.words[Hr] = ui | 0, Cr = si | 0;
      }
      return Cr !== 0 ? ar.words[Hr] = Cr | 0 : ar.length--, ar._strip();
    }
    var or = function(rr, ar, yr) {
      var _r = rr.words, Or = ar.words, vr = yr.words, Te = 0, Cr, Hr, si, ui = _r[0] | 0, Li = ui & 8191, Qi = ui >>> 13, wi = _r[1] | 0, Ji = wi & 8191, mn = wi >>> 13, pi = _r[2] | 0, ei = pi & 8191, Vr = pi >>> 13, qr = _r[3] | 0, Zi = qr & 8191, Wr = qr >>> 13, ri = _r[4] | 0, _i = ri & 8191, Er = ri >>> 13, Di = _r[5] | 0, _n = Di & 8191, On = Di >>> 13, so = _r[6] | 0, Do = so & 8191, gn = so >>> 13, Gn = _r[7] | 0, pn = Gn & 8191, hn = Gn >>> 13, Rn = _r[8] | 0, vo = Rn & 8191, Hi = Rn >>> 13, di = _r[9] | 0, Ui = di & 8191, ln = di >>> 13, Un = Or[0] | 0, Bo = Un & 8191, co = Un >>> 13, To = Or[1] | 0, xs = To & 8191, Fo = To >>> 13, Zo = Or[2] | 0, $s = Zo & 8191, rs = Zo >>> 13, ls = Or[3] | 0, na = ls & 8191, os = ls >>> 13, fs = Or[4] | 0, da = fs & 8191, Bn = fs >>> 13, hi = Or[5] | 0, Ii = hi & 8191, Gi = hi >>> 13, kn = Or[6] | 0, ho = kn & 8191, eo = kn >>> 13, Ei = Or[7] | 0, vs = Ei & 8191, vi = Ei >>> 13, xi = Or[8] | 0, Lr = xi & 8191, dn = xi >>> 13, xn = Or[9] | 0, oi = xn & 8191, Yr = xn >>> 13;
      yr.negative = rr.negative ^ ar.negative, yr.length = 19, Cr = Math.imul(Li, Bo), Hr = Math.imul(Li, co), Hr = Hr + Math.imul(Qi, Bo) | 0, si = Math.imul(Qi, co);
      var ji = (Te + Cr | 0) + ((Hr & 8191) << 13) | 0;
      Te = (si + (Hr >>> 13) | 0) + (ji >>> 26) | 0, ji &= 67108863, Cr = Math.imul(Ji, Bo), Hr = Math.imul(Ji, co), Hr = Hr + Math.imul(mn, Bo) | 0, si = Math.imul(mn, co), Cr = Cr + Math.imul(Li, xs) | 0, Hr = Hr + Math.imul(Li, Fo) | 0, Hr = Hr + Math.imul(Qi, xs) | 0, si = si + Math.imul(Qi, Fo) | 0;
      var Cn = (Te + Cr | 0) + ((Hr & 8191) << 13) | 0;
      Te = (si + (Hr >>> 13) | 0) + (Cn >>> 26) | 0, Cn &= 67108863, Cr = Math.imul(ei, Bo), Hr = Math.imul(ei, co), Hr = Hr + Math.imul(Vr, Bo) | 0, si = Math.imul(Vr, co), Cr = Cr + Math.imul(Ji, xs) | 0, Hr = Hr + Math.imul(Ji, Fo) | 0, Hr = Hr + Math.imul(mn, xs) | 0, si = si + Math.imul(mn, Fo) | 0, Cr = Cr + Math.imul(Li, $s) | 0, Hr = Hr + Math.imul(Li, rs) | 0, Hr = Hr + Math.imul(Qi, $s) | 0, si = si + Math.imul(Qi, rs) | 0;
      var Mn = (Te + Cr | 0) + ((Hr & 8191) << 13) | 0;
      Te = (si + (Hr >>> 13) | 0) + (Mn >>> 26) | 0, Mn &= 67108863, Cr = Math.imul(Zi, Bo), Hr = Math.imul(Zi, co), Hr = Hr + Math.imul(Wr, Bo) | 0, si = Math.imul(Wr, co), Cr = Cr + Math.imul(ei, xs) | 0, Hr = Hr + Math.imul(ei, Fo) | 0, Hr = Hr + Math.imul(Vr, xs) | 0, si = si + Math.imul(Vr, Fo) | 0, Cr = Cr + Math.imul(Ji, $s) | 0, Hr = Hr + Math.imul(Ji, rs) | 0, Hr = Hr + Math.imul(mn, $s) | 0, si = si + Math.imul(mn, rs) | 0, Cr = Cr + Math.imul(Li, na) | 0, Hr = Hr + Math.imul(Li, os) | 0, Hr = Hr + Math.imul(Qi, na) | 0, si = si + Math.imul(Qi, os) | 0;
      var B = (Te + Cr | 0) + ((Hr & 8191) << 13) | 0;
      Te = (si + (Hr >>> 13) | 0) + (B >>> 26) | 0, B &= 67108863, Cr = Math.imul(_i, Bo), Hr = Math.imul(_i, co), Hr = Hr + Math.imul(Er, Bo) | 0, si = Math.imul(Er, co), Cr = Cr + Math.imul(Zi, xs) | 0, Hr = Hr + Math.imul(Zi, Fo) | 0, Hr = Hr + Math.imul(Wr, xs) | 0, si = si + Math.imul(Wr, Fo) | 0, Cr = Cr + Math.imul(ei, $s) | 0, Hr = Hr + Math.imul(ei, rs) | 0, Hr = Hr + Math.imul(Vr, $s) | 0, si = si + Math.imul(Vr, rs) | 0, Cr = Cr + Math.imul(Ji, na) | 0, Hr = Hr + Math.imul(Ji, os) | 0, Hr = Hr + Math.imul(mn, na) | 0, si = si + Math.imul(mn, os) | 0, Cr = Cr + Math.imul(Li, da) | 0, Hr = Hr + Math.imul(Li, Bn) | 0, Hr = Hr + Math.imul(Qi, da) | 0, si = si + Math.imul(Qi, Bn) | 0;
      var o = (Te + Cr | 0) + ((Hr & 8191) << 13) | 0;
      Te = (si + (Hr >>> 13) | 0) + (o >>> 26) | 0, o &= 67108863, Cr = Math.imul(_n, Bo), Hr = Math.imul(_n, co), Hr = Hr + Math.imul(On, Bo) | 0, si = Math.imul(On, co), Cr = Cr + Math.imul(_i, xs) | 0, Hr = Hr + Math.imul(_i, Fo) | 0, Hr = Hr + Math.imul(Er, xs) | 0, si = si + Math.imul(Er, Fo) | 0, Cr = Cr + Math.imul(Zi, $s) | 0, Hr = Hr + Math.imul(Zi, rs) | 0, Hr = Hr + Math.imul(Wr, $s) | 0, si = si + Math.imul(Wr, rs) | 0, Cr = Cr + Math.imul(ei, na) | 0, Hr = Hr + Math.imul(ei, os) | 0, Hr = Hr + Math.imul(Vr, na) | 0, si = si + Math.imul(Vr, os) | 0, Cr = Cr + Math.imul(Ji, da) | 0, Hr = Hr + Math.imul(Ji, Bn) | 0, Hr = Hr + Math.imul(mn, da) | 0, si = si + Math.imul(mn, Bn) | 0, Cr = Cr + Math.imul(Li, Ii) | 0, Hr = Hr + Math.imul(Li, Gi) | 0, Hr = Hr + Math.imul(Qi, Ii) | 0, si = si + Math.imul(Qi, Gi) | 0;
      var m = (Te + Cr | 0) + ((Hr & 8191) << 13) | 0;
      Te = (si + (Hr >>> 13) | 0) + (m >>> 26) | 0, m &= 67108863, Cr = Math.imul(Do, Bo), Hr = Math.imul(Do, co), Hr = Hr + Math.imul(gn, Bo) | 0, si = Math.imul(gn, co), Cr = Cr + Math.imul(_n, xs) | 0, Hr = Hr + Math.imul(_n, Fo) | 0, Hr = Hr + Math.imul(On, xs) | 0, si = si + Math.imul(On, Fo) | 0, Cr = Cr + Math.imul(_i, $s) | 0, Hr = Hr + Math.imul(_i, rs) | 0, Hr = Hr + Math.imul(Er, $s) | 0, si = si + Math.imul(Er, rs) | 0, Cr = Cr + Math.imul(Zi, na) | 0, Hr = Hr + Math.imul(Zi, os) | 0, Hr = Hr + Math.imul(Wr, na) | 0, si = si + Math.imul(Wr, os) | 0, Cr = Cr + Math.imul(ei, da) | 0, Hr = Hr + Math.imul(ei, Bn) | 0, Hr = Hr + Math.imul(Vr, da) | 0, si = si + Math.imul(Vr, Bn) | 0, Cr = Cr + Math.imul(Ji, Ii) | 0, Hr = Hr + Math.imul(Ji, Gi) | 0, Hr = Hr + Math.imul(mn, Ii) | 0, si = si + Math.imul(mn, Gi) | 0, Cr = Cr + Math.imul(Li, ho) | 0, Hr = Hr + Math.imul(Li, eo) | 0, Hr = Hr + Math.imul(Qi, ho) | 0, si = si + Math.imul(Qi, eo) | 0;
      var d = (Te + Cr | 0) + ((Hr & 8191) << 13) | 0;
      Te = (si + (Hr >>> 13) | 0) + (d >>> 26) | 0, d &= 67108863, Cr = Math.imul(pn, Bo), Hr = Math.imul(pn, co), Hr = Hr + Math.imul(hn, Bo) | 0, si = Math.imul(hn, co), Cr = Cr + Math.imul(Do, xs) | 0, Hr = Hr + Math.imul(Do, Fo) | 0, Hr = Hr + Math.imul(gn, xs) | 0, si = si + Math.imul(gn, Fo) | 0, Cr = Cr + Math.imul(_n, $s) | 0, Hr = Hr + Math.imul(_n, rs) | 0, Hr = Hr + Math.imul(On, $s) | 0, si = si + Math.imul(On, rs) | 0, Cr = Cr + Math.imul(_i, na) | 0, Hr = Hr + Math.imul(_i, os) | 0, Hr = Hr + Math.imul(Er, na) | 0, si = si + Math.imul(Er, os) | 0, Cr = Cr + Math.imul(Zi, da) | 0, Hr = Hr + Math.imul(Zi, Bn) | 0, Hr = Hr + Math.imul(Wr, da) | 0, si = si + Math.imul(Wr, Bn) | 0, Cr = Cr + Math.imul(ei, Ii) | 0, Hr = Hr + Math.imul(ei, Gi) | 0, Hr = Hr + Math.imul(Vr, Ii) | 0, si = si + Math.imul(Vr, Gi) | 0, Cr = Cr + Math.imul(Ji, ho) | 0, Hr = Hr + Math.imul(Ji, eo) | 0, Hr = Hr + Math.imul(mn, ho) | 0, si = si + Math.imul(mn, eo) | 0, Cr = Cr + Math.imul(Li, vs) | 0, Hr = Hr + Math.imul(Li, vi) | 0, Hr = Hr + Math.imul(Qi, vs) | 0, si = si + Math.imul(Qi, vi) | 0;
      var v = (Te + Cr | 0) + ((Hr & 8191) << 13) | 0;
      Te = (si + (Hr >>> 13) | 0) + (v >>> 26) | 0, v &= 67108863, Cr = Math.imul(vo, Bo), Hr = Math.imul(vo, co), Hr = Hr + Math.imul(Hi, Bo) | 0, si = Math.imul(Hi, co), Cr = Cr + Math.imul(pn, xs) | 0, Hr = Hr + Math.imul(pn, Fo) | 0, Hr = Hr + Math.imul(hn, xs) | 0, si = si + Math.imul(hn, Fo) | 0, Cr = Cr + Math.imul(Do, $s) | 0, Hr = Hr + Math.imul(Do, rs) | 0, Hr = Hr + Math.imul(gn, $s) | 0, si = si + Math.imul(gn, rs) | 0, Cr = Cr + Math.imul(_n, na) | 0, Hr = Hr + Math.imul(_n, os) | 0, Hr = Hr + Math.imul(On, na) | 0, si = si + Math.imul(On, os) | 0, Cr = Cr + Math.imul(_i, da) | 0, Hr = Hr + Math.imul(_i, Bn) | 0, Hr = Hr + Math.imul(Er, da) | 0, si = si + Math.imul(Er, Bn) | 0, Cr = Cr + Math.imul(Zi, Ii) | 0, Hr = Hr + Math.imul(Zi, Gi) | 0, Hr = Hr + Math.imul(Wr, Ii) | 0, si = si + Math.imul(Wr, Gi) | 0, Cr = Cr + Math.imul(ei, ho) | 0, Hr = Hr + Math.imul(ei, eo) | 0, Hr = Hr + Math.imul(Vr, ho) | 0, si = si + Math.imul(Vr, eo) | 0, Cr = Cr + Math.imul(Ji, vs) | 0, Hr = Hr + Math.imul(Ji, vi) | 0, Hr = Hr + Math.imul(mn, vs) | 0, si = si + Math.imul(mn, vi) | 0, Cr = Cr + Math.imul(Li, Lr) | 0, Hr = Hr + Math.imul(Li, dn) | 0, Hr = Hr + Math.imul(Qi, Lr) | 0, si = si + Math.imul(Qi, dn) | 0;
      var he = (Te + Cr | 0) + ((Hr & 8191) << 13) | 0;
      Te = (si + (Hr >>> 13) | 0) + (he >>> 26) | 0, he &= 67108863, Cr = Math.imul(Ui, Bo), Hr = Math.imul(Ui, co), Hr = Hr + Math.imul(ln, Bo) | 0, si = Math.imul(ln, co), Cr = Cr + Math.imul(vo, xs) | 0, Hr = Hr + Math.imul(vo, Fo) | 0, Hr = Hr + Math.imul(Hi, xs) | 0, si = si + Math.imul(Hi, Fo) | 0, Cr = Cr + Math.imul(pn, $s) | 0, Hr = Hr + Math.imul(pn, rs) | 0, Hr = Hr + Math.imul(hn, $s) | 0, si = si + Math.imul(hn, rs) | 0, Cr = Cr + Math.imul(Do, na) | 0, Hr = Hr + Math.imul(Do, os) | 0, Hr = Hr + Math.imul(gn, na) | 0, si = si + Math.imul(gn, os) | 0, Cr = Cr + Math.imul(_n, da) | 0, Hr = Hr + Math.imul(_n, Bn) | 0, Hr = Hr + Math.imul(On, da) | 0, si = si + Math.imul(On, Bn) | 0, Cr = Cr + Math.imul(_i, Ii) | 0, Hr = Hr + Math.imul(_i, Gi) | 0, Hr = Hr + Math.imul(Er, Ii) | 0, si = si + Math.imul(Er, Gi) | 0, Cr = Cr + Math.imul(Zi, ho) | 0, Hr = Hr + Math.imul(Zi, eo) | 0, Hr = Hr + Math.imul(Wr, ho) | 0, si = si + Math.imul(Wr, eo) | 0, Cr = Cr + Math.imul(ei, vs) | 0, Hr = Hr + Math.imul(ei, vi) | 0, Hr = Hr + Math.imul(Vr, vs) | 0, si = si + Math.imul(Vr, vi) | 0, Cr = Cr + Math.imul(Ji, Lr) | 0, Hr = Hr + Math.imul(Ji, dn) | 0, Hr = Hr + Math.imul(mn, Lr) | 0, si = si + Math.imul(mn, dn) | 0, Cr = Cr + Math.imul(Li, oi) | 0, Hr = Hr + Math.imul(Li, Yr) | 0, Hr = Hr + Math.imul(Qi, oi) | 0, si = si + Math.imul(Qi, Yr) | 0;
      var we = (Te + Cr | 0) + ((Hr & 8191) << 13) | 0;
      Te = (si + (Hr >>> 13) | 0) + (we >>> 26) | 0, we &= 67108863, Cr = Math.imul(Ui, xs), Hr = Math.imul(Ui, Fo), Hr = Hr + Math.imul(ln, xs) | 0, si = Math.imul(ln, Fo), Cr = Cr + Math.imul(vo, $s) | 0, Hr = Hr + Math.imul(vo, rs) | 0, Hr = Hr + Math.imul(Hi, $s) | 0, si = si + Math.imul(Hi, rs) | 0, Cr = Cr + Math.imul(pn, na) | 0, Hr = Hr + Math.imul(pn, os) | 0, Hr = Hr + Math.imul(hn, na) | 0, si = si + Math.imul(hn, os) | 0, Cr = Cr + Math.imul(Do, da) | 0, Hr = Hr + Math.imul(Do, Bn) | 0, Hr = Hr + Math.imul(gn, da) | 0, si = si + Math.imul(gn, Bn) | 0, Cr = Cr + Math.imul(_n, Ii) | 0, Hr = Hr + Math.imul(_n, Gi) | 0, Hr = Hr + Math.imul(On, Ii) | 0, si = si + Math.imul(On, Gi) | 0, Cr = Cr + Math.imul(_i, ho) | 0, Hr = Hr + Math.imul(_i, eo) | 0, Hr = Hr + Math.imul(Er, ho) | 0, si = si + Math.imul(Er, eo) | 0, Cr = Cr + Math.imul(Zi, vs) | 0, Hr = Hr + Math.imul(Zi, vi) | 0, Hr = Hr + Math.imul(Wr, vs) | 0, si = si + Math.imul(Wr, vi) | 0, Cr = Cr + Math.imul(ei, Lr) | 0, Hr = Hr + Math.imul(ei, dn) | 0, Hr = Hr + Math.imul(Vr, Lr) | 0, si = si + Math.imul(Vr, dn) | 0, Cr = Cr + Math.imul(Ji, oi) | 0, Hr = Hr + Math.imul(Ji, Yr) | 0, Hr = Hr + Math.imul(mn, oi) | 0, si = si + Math.imul(mn, Yr) | 0;
      var Be = (Te + Cr | 0) + ((Hr & 8191) << 13) | 0;
      Te = (si + (Hr >>> 13) | 0) + (Be >>> 26) | 0, Be &= 67108863, Cr = Math.imul(Ui, $s), Hr = Math.imul(Ui, rs), Hr = Hr + Math.imul(ln, $s) | 0, si = Math.imul(ln, rs), Cr = Cr + Math.imul(vo, na) | 0, Hr = Hr + Math.imul(vo, os) | 0, Hr = Hr + Math.imul(Hi, na) | 0, si = si + Math.imul(Hi, os) | 0, Cr = Cr + Math.imul(pn, da) | 0, Hr = Hr + Math.imul(pn, Bn) | 0, Hr = Hr + Math.imul(hn, da) | 0, si = si + Math.imul(hn, Bn) | 0, Cr = Cr + Math.imul(Do, Ii) | 0, Hr = Hr + Math.imul(Do, Gi) | 0, Hr = Hr + Math.imul(gn, Ii) | 0, si = si + Math.imul(gn, Gi) | 0, Cr = Cr + Math.imul(_n, ho) | 0, Hr = Hr + Math.imul(_n, eo) | 0, Hr = Hr + Math.imul(On, ho) | 0, si = si + Math.imul(On, eo) | 0, Cr = Cr + Math.imul(_i, vs) | 0, Hr = Hr + Math.imul(_i, vi) | 0, Hr = Hr + Math.imul(Er, vs) | 0, si = si + Math.imul(Er, vi) | 0, Cr = Cr + Math.imul(Zi, Lr) | 0, Hr = Hr + Math.imul(Zi, dn) | 0, Hr = Hr + Math.imul(Wr, Lr) | 0, si = si + Math.imul(Wr, dn) | 0, Cr = Cr + Math.imul(ei, oi) | 0, Hr = Hr + Math.imul(ei, Yr) | 0, Hr = Hr + Math.imul(Vr, oi) | 0, si = si + Math.imul(Vr, Yr) | 0;
      var Me = (Te + Cr | 0) + ((Hr & 8191) << 13) | 0;
      Te = (si + (Hr >>> 13) | 0) + (Me >>> 26) | 0, Me &= 67108863, Cr = Math.imul(Ui, na), Hr = Math.imul(Ui, os), Hr = Hr + Math.imul(ln, na) | 0, si = Math.imul(ln, os), Cr = Cr + Math.imul(vo, da) | 0, Hr = Hr + Math.imul(vo, Bn) | 0, Hr = Hr + Math.imul(Hi, da) | 0, si = si + Math.imul(Hi, Bn) | 0, Cr = Cr + Math.imul(pn, Ii) | 0, Hr = Hr + Math.imul(pn, Gi) | 0, Hr = Hr + Math.imul(hn, Ii) | 0, si = si + Math.imul(hn, Gi) | 0, Cr = Cr + Math.imul(Do, ho) | 0, Hr = Hr + Math.imul(Do, eo) | 0, Hr = Hr + Math.imul(gn, ho) | 0, si = si + Math.imul(gn, eo) | 0, Cr = Cr + Math.imul(_n, vs) | 0, Hr = Hr + Math.imul(_n, vi) | 0, Hr = Hr + Math.imul(On, vs) | 0, si = si + Math.imul(On, vi) | 0, Cr = Cr + Math.imul(_i, Lr) | 0, Hr = Hr + Math.imul(_i, dn) | 0, Hr = Hr + Math.imul(Er, Lr) | 0, si = si + Math.imul(Er, dn) | 0, Cr = Cr + Math.imul(Zi, oi) | 0, Hr = Hr + Math.imul(Zi, Yr) | 0, Hr = Hr + Math.imul(Wr, oi) | 0, si = si + Math.imul(Wr, Yr) | 0;
      var fr = (Te + Cr | 0) + ((Hr & 8191) << 13) | 0;
      Te = (si + (Hr >>> 13) | 0) + (fr >>> 26) | 0, fr &= 67108863, Cr = Math.imul(Ui, da), Hr = Math.imul(Ui, Bn), Hr = Hr + Math.imul(ln, da) | 0, si = Math.imul(ln, Bn), Cr = Cr + Math.imul(vo, Ii) | 0, Hr = Hr + Math.imul(vo, Gi) | 0, Hr = Hr + Math.imul(Hi, Ii) | 0, si = si + Math.imul(Hi, Gi) | 0, Cr = Cr + Math.imul(pn, ho) | 0, Hr = Hr + Math.imul(pn, eo) | 0, Hr = Hr + Math.imul(hn, ho) | 0, si = si + Math.imul(hn, eo) | 0, Cr = Cr + Math.imul(Do, vs) | 0, Hr = Hr + Math.imul(Do, vi) | 0, Hr = Hr + Math.imul(gn, vs) | 0, si = si + Math.imul(gn, vi) | 0, Cr = Cr + Math.imul(_n, Lr) | 0, Hr = Hr + Math.imul(_n, dn) | 0, Hr = Hr + Math.imul(On, Lr) | 0, si = si + Math.imul(On, dn) | 0, Cr = Cr + Math.imul(_i, oi) | 0, Hr = Hr + Math.imul(_i, Yr) | 0, Hr = Hr + Math.imul(Er, oi) | 0, si = si + Math.imul(Er, Yr) | 0;
      var wr = (Te + Cr | 0) + ((Hr & 8191) << 13) | 0;
      Te = (si + (Hr >>> 13) | 0) + (wr >>> 26) | 0, wr &= 67108863, Cr = Math.imul(Ui, Ii), Hr = Math.imul(Ui, Gi), Hr = Hr + Math.imul(ln, Ii) | 0, si = Math.imul(ln, Gi), Cr = Cr + Math.imul(vo, ho) | 0, Hr = Hr + Math.imul(vo, eo) | 0, Hr = Hr + Math.imul(Hi, ho) | 0, si = si + Math.imul(Hi, eo) | 0, Cr = Cr + Math.imul(pn, vs) | 0, Hr = Hr + Math.imul(pn, vi) | 0, Hr = Hr + Math.imul(hn, vs) | 0, si = si + Math.imul(hn, vi) | 0, Cr = Cr + Math.imul(Do, Lr) | 0, Hr = Hr + Math.imul(Do, dn) | 0, Hr = Hr + Math.imul(gn, Lr) | 0, si = si + Math.imul(gn, dn) | 0, Cr = Cr + Math.imul(_n, oi) | 0, Hr = Hr + Math.imul(_n, Yr) | 0, Hr = Hr + Math.imul(On, oi) | 0, si = si + Math.imul(On, Yr) | 0;
      var dr = (Te + Cr | 0) + ((Hr & 8191) << 13) | 0;
      Te = (si + (Hr >>> 13) | 0) + (dr >>> 26) | 0, dr &= 67108863, Cr = Math.imul(Ui, ho), Hr = Math.imul(Ui, eo), Hr = Hr + Math.imul(ln, ho) | 0, si = Math.imul(ln, eo), Cr = Cr + Math.imul(vo, vs) | 0, Hr = Hr + Math.imul(vo, vi) | 0, Hr = Hr + Math.imul(Hi, vs) | 0, si = si + Math.imul(Hi, vi) | 0, Cr = Cr + Math.imul(pn, Lr) | 0, Hr = Hr + Math.imul(pn, dn) | 0, Hr = Hr + Math.imul(hn, Lr) | 0, si = si + Math.imul(hn, dn) | 0, Cr = Cr + Math.imul(Do, oi) | 0, Hr = Hr + Math.imul(Do, Yr) | 0, Hr = Hr + Math.imul(gn, oi) | 0, si = si + Math.imul(gn, Yr) | 0;
      var Dr = (Te + Cr | 0) + ((Hr & 8191) << 13) | 0;
      Te = (si + (Hr >>> 13) | 0) + (Dr >>> 26) | 0, Dr &= 67108863, Cr = Math.imul(Ui, vs), Hr = Math.imul(Ui, vi), Hr = Hr + Math.imul(ln, vs) | 0, si = Math.imul(ln, vi), Cr = Cr + Math.imul(vo, Lr) | 0, Hr = Hr + Math.imul(vo, dn) | 0, Hr = Hr + Math.imul(Hi, Lr) | 0, si = si + Math.imul(Hi, dn) | 0, Cr = Cr + Math.imul(pn, oi) | 0, Hr = Hr + Math.imul(pn, Yr) | 0, Hr = Hr + Math.imul(hn, oi) | 0, si = si + Math.imul(hn, Yr) | 0;
      var Rr = (Te + Cr | 0) + ((Hr & 8191) << 13) | 0;
      Te = (si + (Hr >>> 13) | 0) + (Rr >>> 26) | 0, Rr &= 67108863, Cr = Math.imul(Ui, Lr), Hr = Math.imul(Ui, dn), Hr = Hr + Math.imul(ln, Lr) | 0, si = Math.imul(ln, dn), Cr = Cr + Math.imul(vo, oi) | 0, Hr = Hr + Math.imul(vo, Yr) | 0, Hr = Hr + Math.imul(Hi, oi) | 0, si = si + Math.imul(Hi, Yr) | 0;
      var Qe = (Te + Cr | 0) + ((Hr & 8191) << 13) | 0;
      Te = (si + (Hr >>> 13) | 0) + (Qe >>> 26) | 0, Qe &= 67108863, Cr = Math.imul(Ui, oi), Hr = Math.imul(Ui, Yr), Hr = Hr + Math.imul(ln, oi) | 0, si = Math.imul(ln, Yr);
      var Fr = (Te + Cr | 0) + ((Hr & 8191) << 13) | 0;
      return Te = (si + (Hr >>> 13) | 0) + (Fr >>> 26) | 0, Fr &= 67108863, vr[0] = ji, vr[1] = Cn, vr[2] = Mn, vr[3] = B, vr[4] = o, vr[5] = m, vr[6] = d, vr[7] = v, vr[8] = he, vr[9] = we, vr[10] = Be, vr[11] = Me, vr[12] = fr, vr[13] = wr, vr[14] = dr, vr[15] = Dr, vr[16] = Rr, vr[17] = Qe, vr[18] = Fr, Te !== 0 && (vr[19] = Te, yr.length++), yr;
    };
    Math.imul || (or = ir);
    function lr(xe, rr, ar) {
      ar.negative = rr.negative ^ xe.negative, ar.length = xe.length + rr.length;
      for (var yr = 0, _r = 0, Or = 0; Or < ar.length - 1; Or++) {
        var vr = _r;
        _r = 0;
        for (var Te = yr & 67108863, Cr = Math.min(Or, rr.length - 1), Hr = Math.max(0, Or - xe.length + 1); Hr <= Cr; Hr++) {
          var si = Or - Hr, ui = xe.words[si] | 0, Li = rr.words[Hr] | 0, Qi = ui * Li, wi = Qi & 67108863;
          vr = vr + (Qi / 67108864 | 0) | 0, wi = wi + Te | 0, Te = wi & 67108863, vr = vr + (wi >>> 26) | 0, _r += vr >>> 26, vr &= 67108863;
        }
        ar.words[Or] = Te, yr = vr, vr = _r;
      }
      return yr !== 0 ? ar.words[Or] = yr : ar.length--, ar._strip();
    }
    function Ir(xe, rr, ar) {
      return lr(xe, rr, ar);
    }
    A.prototype.mulTo = function(rr, ar) {
      var yr, _r = this.length + rr.length;
      return this.length === 10 && rr.length === 10 ? yr = or(this, rr, ar) : _r < 63 ? yr = ir(this, rr, ar) : _r < 1024 ? yr = lr(this, rr, ar) : yr = Ir(this, rr, ar), yr;
    }, A.prototype.mul = function(rr) {
      var ar = new A(null);
      return ar.words = new Array(this.length + rr.length), this.mulTo(rr, ar);
    }, A.prototype.mulf = function(rr) {
      var ar = new A(null);
      return ar.words = new Array(this.length + rr.length), Ir(this, rr, ar);
    }, A.prototype.imul = function(rr) {
      return this.clone().mulTo(rr, this);
    }, A.prototype.imuln = function(rr) {
      var ar = rr < 0;
      ar && (rr = -rr), p(typeof rr == "number"), p(rr < 67108864);
      for (var yr = 0, _r = 0; _r < this.length; _r++) {
        var Or = (this.words[_r] | 0) * rr, vr = (Or & 67108863) + (yr & 67108863);
        yr >>= 26, yr += Or / 67108864 | 0, yr += vr >>> 26, this.words[_r] = vr & 67108863;
      }
      return yr !== 0 && (this.words[_r] = yr, this.length++), ar ? this.ineg() : this;
    }, A.prototype.muln = function(rr) {
      return this.clone().imuln(rr);
    }, A.prototype.sqr = function() {
      return this.mul(this);
    }, A.prototype.isqr = function() {
      return this.imul(this.clone());
    }, A.prototype.pow = function(rr) {
      var ar = nr(rr);
      if (ar.length === 0) return new A(1);
      for (var yr = this, _r = 0; _r < ar.length && ar[_r] === 0; _r++, yr = yr.sqr())
        ;
      if (++_r < ar.length)
        for (var Or = yr.sqr(); _r < ar.length; _r++, Or = Or.sqr())
          ar[_r] !== 0 && (yr = yr.mul(Or));
      return yr;
    }, A.prototype.iushln = function(rr) {
      p(typeof rr == "number" && rr >= 0);
      var ar = rr % 26, yr = (rr - ar) / 26, _r = 67108863 >>> 26 - ar << 26 - ar, Or;
      if (ar !== 0) {
        var vr = 0;
        for (Or = 0; Or < this.length; Or++) {
          var Te = this.words[Or] & _r, Cr = (this.words[Or] | 0) - Te << ar;
          this.words[Or] = Cr | vr, vr = Te >>> 26 - ar;
        }
        vr && (this.words[Or] = vr, this.length++);
      }
      if (yr !== 0) {
        for (Or = this.length - 1; Or >= 0; Or--)
          this.words[Or + yr] = this.words[Or];
        for (Or = 0; Or < yr; Or++)
          this.words[Or] = 0;
        this.length += yr;
      }
      return this._strip();
    }, A.prototype.ishln = function(rr) {
      return p(this.negative === 0), this.iushln(rr);
    }, A.prototype.iushrn = function(rr, ar, yr) {
      p(typeof rr == "number" && rr >= 0);
      var _r;
      ar ? _r = (ar - ar % 26) / 26 : _r = 0;
      var Or = rr % 26, vr = Math.min((rr - Or) / 26, this.length), Te = 67108863 ^ 67108863 >>> Or << Or, Cr = yr;
      if (_r -= vr, _r = Math.max(0, _r), Cr) {
        for (var Hr = 0; Hr < vr; Hr++)
          Cr.words[Hr] = this.words[Hr];
        Cr.length = vr;
      }
      if (vr !== 0) if (this.length > vr)
        for (this.length -= vr, Hr = 0; Hr < this.length; Hr++)
          this.words[Hr] = this.words[Hr + vr];
      else
        this.words[0] = 0, this.length = 1;
      var si = 0;
      for (Hr = this.length - 1; Hr >= 0 && (si !== 0 || Hr >= _r); Hr--) {
        var ui = this.words[Hr] | 0;
        this.words[Hr] = si << 26 - Or | ui >>> Or, si = ui & Te;
      }
      return Cr && si !== 0 && (Cr.words[Cr.length++] = si), this.length === 0 && (this.words[0] = 0, this.length = 1), this._strip();
    }, A.prototype.ishrn = function(rr, ar, yr) {
      return p(this.negative === 0), this.iushrn(rr, ar, yr);
    }, A.prototype.shln = function(rr) {
      return this.clone().ishln(rr);
    }, A.prototype.ushln = function(rr) {
      return this.clone().iushln(rr);
    }, A.prototype.shrn = function(rr) {
      return this.clone().ishrn(rr);
    }, A.prototype.ushrn = function(rr) {
      return this.clone().iushrn(rr);
    }, A.prototype.testn = function(rr) {
      p(typeof rr == "number" && rr >= 0);
      var ar = rr % 26, yr = (rr - ar) / 26, _r = 1 << ar;
      if (this.length <= yr) return !1;
      var Or = this.words[yr];
      return !!(Or & _r);
    }, A.prototype.imaskn = function(rr) {
      p(typeof rr == "number" && rr >= 0);
      var ar = rr % 26, yr = (rr - ar) / 26;
      if (p(this.negative === 0, "imaskn works only with positive numbers"), this.length <= yr)
        return this;
      if (ar !== 0 && yr++, this.length = Math.min(yr, this.length), ar !== 0) {
        var _r = 67108863 ^ 67108863 >>> ar << ar;
        this.words[this.length - 1] &= _r;
      }
      return this._strip();
    }, A.prototype.maskn = function(rr) {
      return this.clone().imaskn(rr);
    }, A.prototype.iaddn = function(rr) {
      return p(typeof rr == "number"), p(rr < 67108864), rr < 0 ? this.isubn(-rr) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) <= rr ? (this.words[0] = rr - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(rr), this.negative = 1, this) : this._iaddn(rr);
    }, A.prototype._iaddn = function(rr) {
      this.words[0] += rr;
      for (var ar = 0; ar < this.length && this.words[ar] >= 67108864; ar++)
        this.words[ar] -= 67108864, ar === this.length - 1 ? this.words[ar + 1] = 1 : this.words[ar + 1]++;
      return this.length = Math.max(this.length, ar + 1), this;
    }, A.prototype.isubn = function(rr) {
      if (p(typeof rr == "number"), p(rr < 67108864), rr < 0) return this.iaddn(-rr);
      if (this.negative !== 0)
        return this.negative = 0, this.iaddn(rr), this.negative = 1, this;
      if (this.words[0] -= rr, this.length === 1 && this.words[0] < 0)
        this.words[0] = -this.words[0], this.negative = 1;
      else
        for (var ar = 0; ar < this.length && this.words[ar] < 0; ar++)
          this.words[ar] += 67108864, this.words[ar + 1] -= 1;
      return this._strip();
    }, A.prototype.addn = function(rr) {
      return this.clone().iaddn(rr);
    }, A.prototype.subn = function(rr) {
      return this.clone().isubn(rr);
    }, A.prototype.iabs = function() {
      return this.negative = 0, this;
    }, A.prototype.abs = function() {
      return this.clone().iabs();
    }, A.prototype._ishlnsubmul = function(rr, ar, yr) {
      var _r = rr.length + yr, Or;
      this._expand(_r);
      var vr, Te = 0;
      for (Or = 0; Or < rr.length; Or++) {
        vr = (this.words[Or + yr] | 0) + Te;
        var Cr = (rr.words[Or] | 0) * ar;
        vr -= Cr & 67108863, Te = (vr >> 26) - (Cr / 67108864 | 0), this.words[Or + yr] = vr & 67108863;
      }
      for (; Or < this.length - yr; Or++)
        vr = (this.words[Or + yr] | 0) + Te, Te = vr >> 26, this.words[Or + yr] = vr & 67108863;
      if (Te === 0) return this._strip();
      for (p(Te === -1), Te = 0, Or = 0; Or < this.length; Or++)
        vr = -(this.words[Or] | 0) + Te, Te = vr >> 26, this.words[Or] = vr & 67108863;
      return this.negative = 1, this._strip();
    }, A.prototype._wordDiv = function(rr, ar) {
      var yr = this.length - rr.length, _r = this.clone(), Or = rr, vr = Or.words[Or.length - 1] | 0, Te = this._countBits(vr);
      yr = 26 - Te, yr !== 0 && (Or = Or.ushln(yr), _r.iushln(yr), vr = Or.words[Or.length - 1] | 0);
      var Cr = _r.length - Or.length, Hr;
      if (ar !== "mod") {
        Hr = new A(null), Hr.length = Cr + 1, Hr.words = new Array(Hr.length);
        for (var si = 0; si < Hr.length; si++)
          Hr.words[si] = 0;
      }
      var ui = _r.clone()._ishlnsubmul(Or, 1, Cr);
      ui.negative === 0 && (_r = ui, Hr && (Hr.words[Cr] = 1));
      for (var Li = Cr - 1; Li >= 0; Li--) {
        var Qi = (_r.words[Or.length + Li] | 0) * 67108864 + (_r.words[Or.length + Li - 1] | 0);
        for (Qi = Math.min(Qi / vr | 0, 67108863), _r._ishlnsubmul(Or, Qi, Li); _r.negative !== 0; )
          Qi--, _r.negative = 0, _r._ishlnsubmul(Or, 1, Li), _r.isZero() || (_r.negative ^= 1);
        Hr && (Hr.words[Li] = Qi);
      }
      return Hr && Hr._strip(), _r._strip(), ar !== "div" && yr !== 0 && _r.iushrn(yr), {
        div: Hr || null,
        mod: _r
      };
    }, A.prototype.divmod = function(rr, ar, yr) {
      if (p(!rr.isZero()), this.isZero())
        return {
          div: new A(0),
          mod: new A(0)
        };
      var _r, Or, vr;
      return this.negative !== 0 && rr.negative === 0 ? (vr = this.neg().divmod(rr, ar), ar !== "mod" && (_r = vr.div.neg()), ar !== "div" && (Or = vr.mod.neg(), yr && Or.negative !== 0 && Or.iadd(rr)), {
        div: _r,
        mod: Or
      }) : this.negative === 0 && rr.negative !== 0 ? (vr = this.divmod(rr.neg(), ar), ar !== "mod" && (_r = vr.div.neg()), {
        div: _r,
        mod: vr.mod
      }) : this.negative & rr.negative ? (vr = this.neg().divmod(rr.neg(), ar), ar !== "div" && (Or = vr.mod.neg(), yr && Or.negative !== 0 && Or.isub(rr)), {
        div: vr.div,
        mod: Or
      }) : rr.length > this.length || this.cmp(rr) < 0 ? {
        div: new A(0),
        mod: this
      } : rr.length === 1 ? ar === "div" ? {
        div: this.divn(rr.words[0]),
        mod: null
      } : ar === "mod" ? {
        div: null,
        mod: new A(this.modrn(rr.words[0]))
      } : {
        div: this.divn(rr.words[0]),
        mod: new A(this.modrn(rr.words[0]))
      } : this._wordDiv(rr, ar);
    }, A.prototype.div = function(rr) {
      return this.divmod(rr, "div", !1).div;
    }, A.prototype.mod = function(rr) {
      return this.divmod(rr, "mod", !1).mod;
    }, A.prototype.umod = function(rr) {
      return this.divmod(rr, "mod", !0).mod;
    }, A.prototype.divRound = function(rr) {
      var ar = this.divmod(rr);
      if (ar.mod.isZero()) return ar.div;
      var yr = ar.div.negative !== 0 ? ar.mod.isub(rr) : ar.mod, _r = rr.ushrn(1), Or = rr.andln(1), vr = yr.cmp(_r);
      return vr < 0 || Or === 1 && vr === 0 ? ar.div : ar.div.negative !== 0 ? ar.div.isubn(1) : ar.div.iaddn(1);
    }, A.prototype.modrn = function(rr) {
      var ar = rr < 0;
      ar && (rr = -rr), p(rr <= 67108863);
      for (var yr = (1 << 26) % rr, _r = 0, Or = this.length - 1; Or >= 0; Or--)
        _r = (yr * _r + (this.words[Or] | 0)) % rr;
      return ar ? -_r : _r;
    }, A.prototype.modn = function(rr) {
      return this.modrn(rr);
    }, A.prototype.idivn = function(rr) {
      var ar = rr < 0;
      ar && (rr = -rr), p(rr <= 67108863);
      for (var yr = 0, _r = this.length - 1; _r >= 0; _r--) {
        var Or = (this.words[_r] | 0) + yr * 67108864;
        this.words[_r] = Or / rr | 0, yr = Or % rr;
      }
      return this._strip(), ar ? this.ineg() : this;
    }, A.prototype.divn = function(rr) {
      return this.clone().idivn(rr);
    }, A.prototype.egcd = function(rr) {
      p(rr.negative === 0), p(!rr.isZero());
      var ar = this, yr = rr.clone();
      ar.negative !== 0 ? ar = ar.umod(rr) : ar = ar.clone();
      for (var _r = new A(1), Or = new A(0), vr = new A(0), Te = new A(1), Cr = 0; ar.isEven() && yr.isEven(); )
        ar.iushrn(1), yr.iushrn(1), ++Cr;
      for (var Hr = yr.clone(), si = ar.clone(); !ar.isZero(); ) {
        for (var ui = 0, Li = 1; !(ar.words[0] & Li) && ui < 26; ++ui, Li <<= 1) ;
        if (ui > 0)
          for (ar.iushrn(ui); ui-- > 0; )
            (_r.isOdd() || Or.isOdd()) && (_r.iadd(Hr), Or.isub(si)), _r.iushrn(1), Or.iushrn(1);
        for (var Qi = 0, wi = 1; !(yr.words[0] & wi) && Qi < 26; ++Qi, wi <<= 1) ;
        if (Qi > 0)
          for (yr.iushrn(Qi); Qi-- > 0; )
            (vr.isOdd() || Te.isOdd()) && (vr.iadd(Hr), Te.isub(si)), vr.iushrn(1), Te.iushrn(1);
        ar.cmp(yr) >= 0 ? (ar.isub(yr), _r.isub(vr), Or.isub(Te)) : (yr.isub(ar), vr.isub(_r), Te.isub(Or));
      }
      return {
        a: vr,
        b: Te,
        gcd: yr.iushln(Cr)
      };
    }, A.prototype._invmp = function(rr) {
      p(rr.negative === 0), p(!rr.isZero());
      var ar = this, yr = rr.clone();
      ar.negative !== 0 ? ar = ar.umod(rr) : ar = ar.clone();
      for (var _r = new A(1), Or = new A(0), vr = yr.clone(); ar.cmpn(1) > 0 && yr.cmpn(1) > 0; ) {
        for (var Te = 0, Cr = 1; !(ar.words[0] & Cr) && Te < 26; ++Te, Cr <<= 1) ;
        if (Te > 0)
          for (ar.iushrn(Te); Te-- > 0; )
            _r.isOdd() && _r.iadd(vr), _r.iushrn(1);
        for (var Hr = 0, si = 1; !(yr.words[0] & si) && Hr < 26; ++Hr, si <<= 1) ;
        if (Hr > 0)
          for (yr.iushrn(Hr); Hr-- > 0; )
            Or.isOdd() && Or.iadd(vr), Or.iushrn(1);
        ar.cmp(yr) >= 0 ? (ar.isub(yr), _r.isub(Or)) : (yr.isub(ar), Or.isub(_r));
      }
      var ui;
      return ar.cmpn(1) === 0 ? ui = _r : ui = Or, ui.cmpn(0) < 0 && ui.iadd(rr), ui;
    }, A.prototype.gcd = function(rr) {
      if (this.isZero()) return rr.abs();
      if (rr.isZero()) return this.abs();
      var ar = this.clone(), yr = rr.clone();
      ar.negative = 0, yr.negative = 0;
      for (var _r = 0; ar.isEven() && yr.isEven(); _r++)
        ar.iushrn(1), yr.iushrn(1);
      do {
        for (; ar.isEven(); )
          ar.iushrn(1);
        for (; yr.isEven(); )
          yr.iushrn(1);
        var Or = ar.cmp(yr);
        if (Or < 0) {
          var vr = ar;
          ar = yr, yr = vr;
        } else if (Or === 0 || yr.cmpn(1) === 0)
          break;
        ar.isub(yr);
      } while (!0);
      return yr.iushln(_r);
    }, A.prototype.invm = function(rr) {
      return this.egcd(rr).a.umod(rr);
    }, A.prototype.isEven = function() {
      return (this.words[0] & 1) === 0;
    }, A.prototype.isOdd = function() {
      return (this.words[0] & 1) === 1;
    }, A.prototype.andln = function(rr) {
      return this.words[0] & rr;
    }, A.prototype.bincn = function(rr) {
      p(typeof rr == "number");
      var ar = rr % 26, yr = (rr - ar) / 26, _r = 1 << ar;
      if (this.length <= yr)
        return this._expand(yr + 1), this.words[yr] |= _r, this;
      for (var Or = _r, vr = yr; Or !== 0 && vr < this.length; vr++) {
        var Te = this.words[vr] | 0;
        Te += Or, Or = Te >>> 26, Te &= 67108863, this.words[vr] = Te;
      }
      return Or !== 0 && (this.words[vr] = Or, this.length++), this;
    }, A.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, A.prototype.cmpn = function(rr) {
      var ar = rr < 0;
      if (this.negative !== 0 && !ar) return -1;
      if (this.negative === 0 && ar) return 1;
      this._strip();
      var yr;
      if (this.length > 1)
        yr = 1;
      else {
        ar && (rr = -rr), p(rr <= 67108863, "Number is too big");
        var _r = this.words[0] | 0;
        yr = _r === rr ? 0 : _r < rr ? -1 : 1;
      }
      return this.negative !== 0 ? -yr | 0 : yr;
    }, A.prototype.cmp = function(rr) {
      if (this.negative !== 0 && rr.negative === 0) return -1;
      if (this.negative === 0 && rr.negative !== 0) return 1;
      var ar = this.ucmp(rr);
      return this.negative !== 0 ? -ar | 0 : ar;
    }, A.prototype.ucmp = function(rr) {
      if (this.length > rr.length) return 1;
      if (this.length < rr.length) return -1;
      for (var ar = 0, yr = this.length - 1; yr >= 0; yr--) {
        var _r = this.words[yr] | 0, Or = rr.words[yr] | 0;
        if (_r !== Or) {
          _r < Or ? ar = -1 : _r > Or && (ar = 1);
          break;
        }
      }
      return ar;
    }, A.prototype.gtn = function(rr) {
      return this.cmpn(rr) === 1;
    }, A.prototype.gt = function(rr) {
      return this.cmp(rr) === 1;
    }, A.prototype.gten = function(rr) {
      return this.cmpn(rr) >= 0;
    }, A.prototype.gte = function(rr) {
      return this.cmp(rr) >= 0;
    }, A.prototype.ltn = function(rr) {
      return this.cmpn(rr) === -1;
    }, A.prototype.lt = function(rr) {
      return this.cmp(rr) === -1;
    }, A.prototype.lten = function(rr) {
      return this.cmpn(rr) <= 0;
    }, A.prototype.lte = function(rr) {
      return this.cmp(rr) <= 0;
    }, A.prototype.eqn = function(rr) {
      return this.cmpn(rr) === 0;
    }, A.prototype.eq = function(rr) {
      return this.cmp(rr) === 0;
    }, A.red = function(rr) {
      return new er(rr);
    }, A.prototype.toRed = function(rr) {
      return p(!this.red, "Already a number in reduction context"), p(this.negative === 0, "red works only with positives"), rr.convertTo(this)._forceRed(rr);
    }, A.prototype.fromRed = function() {
      return p(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, A.prototype._forceRed = function(rr) {
      return this.red = rr, this;
    }, A.prototype.forceRed = function(rr) {
      return p(!this.red, "Already a number in reduction context"), this._forceRed(rr);
    }, A.prototype.redAdd = function(rr) {
      return p(this.red, "redAdd works only with red numbers"), this.red.add(this, rr);
    }, A.prototype.redIAdd = function(rr) {
      return p(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, rr);
    }, A.prototype.redSub = function(rr) {
      return p(this.red, "redSub works only with red numbers"), this.red.sub(this, rr);
    }, A.prototype.redISub = function(rr) {
      return p(this.red, "redISub works only with red numbers"), this.red.isub(this, rr);
    }, A.prototype.redShl = function(rr) {
      return p(this.red, "redShl works only with red numbers"), this.red.shl(this, rr);
    }, A.prototype.redMul = function(rr) {
      return p(this.red, "redMul works only with red numbers"), this.red._verify2(this, rr), this.red.mul(this, rr);
    }, A.prototype.redIMul = function(rr) {
      return p(this.red, "redMul works only with red numbers"), this.red._verify2(this, rr), this.red.imul(this, rr);
    }, A.prototype.redSqr = function() {
      return p(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, A.prototype.redISqr = function() {
      return p(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, A.prototype.redSqrt = function() {
      return p(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, A.prototype.redInvm = function() {
      return p(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, A.prototype.redNeg = function() {
      return p(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, A.prototype.redPow = function(rr) {
      return p(this.red && !rr.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, rr);
    };
    var xr = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };
    function kr(xe, rr) {
      this.name = xe, this.p = new A(rr, 16), this.n = this.p.bitLength(), this.k = new A(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    kr.prototype._tmp = function() {
      var rr = new A(null);
      return rr.words = new Array(Math.ceil(this.n / 13)), rr;
    }, kr.prototype.ireduce = function(rr) {
      var ar = rr, yr;
      do
        this.split(ar, this.tmp), ar = this.imulK(ar), ar = ar.iadd(this.tmp), yr = ar.bitLength();
      while (yr > this.n);
      var _r = yr < this.n ? -1 : ar.ucmp(this.p);
      return _r === 0 ? (ar.words[0] = 0, ar.length = 1) : _r > 0 ? ar.isub(this.p) : ar.strip !== void 0 ? ar.strip() : ar._strip(), ar;
    }, kr.prototype.split = function(rr, ar) {
      rr.iushrn(this.n, 0, ar);
    }, kr.prototype.imulK = function(rr) {
      return rr.imul(this.k);
    };
    function Ce() {
      kr.call(
        this,
        "k256",
        "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
      );
    }
    a(Ce, kr), Ce.prototype.split = function(rr, ar) {
      for (var yr = 4194303, _r = Math.min(rr.length, 9), Or = 0; Or < _r; Or++)
        ar.words[Or] = rr.words[Or];
      if (ar.length = _r, rr.length <= 9) {
        rr.words[0] = 0, rr.length = 1;
        return;
      }
      var vr = rr.words[9];
      for (ar.words[ar.length++] = vr & yr, Or = 10; Or < rr.length; Or++) {
        var Te = rr.words[Or] | 0;
        rr.words[Or - 10] = (Te & yr) << 4 | vr >>> 22, vr = Te;
      }
      vr >>>= 22, rr.words[Or - 10] = vr, vr === 0 && rr.length > 10 ? rr.length -= 10 : rr.length -= 9;
    }, Ce.prototype.imulK = function(rr) {
      rr.words[rr.length] = 0, rr.words[rr.length + 1] = 0, rr.length += 2;
      for (var ar = 0, yr = 0; yr < rr.length; yr++) {
        var _r = rr.words[yr] | 0;
        ar += _r * 977, rr.words[yr] = ar & 67108863, ar = _r * 64 + (ar / 67108864 | 0);
      }
      return rr.words[rr.length - 1] === 0 && (rr.length--, rr.words[rr.length - 1] === 0 && rr.length--), rr;
    };
    function tr() {
      kr.call(
        this,
        "p224",
        "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
      );
    }
    a(tr, kr);
    function Fe() {
      kr.call(
        this,
        "p192",
        "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
      );
    }
    a(Fe, kr);
    function Sr() {
      kr.call(
        this,
        "25519",
        "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
      );
    }
    a(Sr, kr), Sr.prototype.imulK = function(rr) {
      for (var ar = 0, yr = 0; yr < rr.length; yr++) {
        var _r = (rr.words[yr] | 0) * 19 + ar, Or = _r & 67108863;
        _r >>>= 26, rr.words[yr] = Or, ar = _r;
      }
      return ar !== 0 && (rr.words[rr.length++] = ar), rr;
    }, A._prime = function(rr) {
      if (xr[rr]) return xr[rr];
      var ar;
      if (rr === "k256")
        ar = new Ce();
      else if (rr === "p224")
        ar = new tr();
      else if (rr === "p192")
        ar = new Fe();
      else if (rr === "p25519")
        ar = new Sr();
      else
        throw new Error("Unknown prime " + rr);
      return xr[rr] = ar, ar;
    };
    function er(xe) {
      if (typeof xe == "string") {
        var rr = A._prime(xe);
        this.m = rr.p, this.prime = rr;
      } else
        p(xe.gtn(1), "modulus must be greater than 1"), this.m = xe, this.prime = null;
    }
    er.prototype._verify1 = function(rr) {
      p(rr.negative === 0, "red works only with positives"), p(rr.red, "red works only with red numbers");
    }, er.prototype._verify2 = function(rr, ar) {
      p((rr.negative | ar.negative) === 0, "red works only with positives"), p(
        rr.red && rr.red === ar.red,
        "red works only with red numbers"
      );
    }, er.prototype.imod = function(rr) {
      return this.prime ? this.prime.ireduce(rr)._forceRed(this) : (pe(rr, rr.umod(this.m)._forceRed(this)), rr);
    }, er.prototype.neg = function(rr) {
      return rr.isZero() ? rr.clone() : this.m.sub(rr)._forceRed(this);
    }, er.prototype.add = function(rr, ar) {
      this._verify2(rr, ar);
      var yr = rr.add(ar);
      return yr.cmp(this.m) >= 0 && yr.isub(this.m), yr._forceRed(this);
    }, er.prototype.iadd = function(rr, ar) {
      this._verify2(rr, ar);
      var yr = rr.iadd(ar);
      return yr.cmp(this.m) >= 0 && yr.isub(this.m), yr;
    }, er.prototype.sub = function(rr, ar) {
      this._verify2(rr, ar);
      var yr = rr.sub(ar);
      return yr.cmpn(0) < 0 && yr.iadd(this.m), yr._forceRed(this);
    }, er.prototype.isub = function(rr, ar) {
      this._verify2(rr, ar);
      var yr = rr.isub(ar);
      return yr.cmpn(0) < 0 && yr.iadd(this.m), yr;
    }, er.prototype.shl = function(rr, ar) {
      return this._verify1(rr), this.imod(rr.ushln(ar));
    }, er.prototype.imul = function(rr, ar) {
      return this._verify2(rr, ar), this.imod(rr.imul(ar));
    }, er.prototype.mul = function(rr, ar) {
      return this._verify2(rr, ar), this.imod(rr.mul(ar));
    }, er.prototype.isqr = function(rr) {
      return this.imul(rr, rr.clone());
    }, er.prototype.sqr = function(rr) {
      return this.mul(rr, rr);
    }, er.prototype.sqrt = function(rr) {
      if (rr.isZero()) return rr.clone();
      var ar = this.m.andln(3);
      if (p(ar % 2 === 1), ar === 3) {
        var yr = this.m.add(new A(1)).iushrn(2);
        return this.pow(rr, yr);
      }
      for (var _r = this.m.subn(1), Or = 0; !_r.isZero() && _r.andln(1) === 0; )
        Or++, _r.iushrn(1);
      p(!_r.isZero());
      var vr = new A(1).toRed(this), Te = vr.redNeg(), Cr = this.m.subn(1).iushrn(1), Hr = this.m.bitLength();
      for (Hr = new A(2 * Hr * Hr).toRed(this); this.pow(Hr, Cr).cmp(Te) !== 0; )
        Hr.redIAdd(Te);
      for (var si = this.pow(Hr, _r), ui = this.pow(rr, _r.addn(1).iushrn(1)), Li = this.pow(rr, _r), Qi = Or; Li.cmp(vr) !== 0; ) {
        for (var wi = Li, Ji = 0; wi.cmp(vr) !== 0; Ji++)
          wi = wi.redSqr();
        p(Ji < Qi);
        var mn = this.pow(si, new A(1).iushln(Qi - Ji - 1));
        ui = ui.redMul(mn), si = mn.redSqr(), Li = Li.redMul(si), Qi = Ji;
      }
      return ui;
    }, er.prototype.invm = function(rr) {
      var ar = rr._invmp(this.m);
      return ar.negative !== 0 ? (ar.negative = 0, this.imod(ar).redNeg()) : this.imod(ar);
    }, er.prototype.pow = function(rr, ar) {
      if (ar.isZero()) return new A(1).toRed(this);
      if (ar.cmpn(1) === 0) return rr.clone();
      var yr = 4, _r = new Array(1 << yr);
      _r[0] = new A(1).toRed(this), _r[1] = rr;
      for (var Or = 2; Or < _r.length; Or++)
        _r[Or] = this.mul(_r[Or - 1], rr);
      var vr = _r[0], Te = 0, Cr = 0, Hr = ar.bitLength() % 26;
      for (Hr === 0 && (Hr = 26), Or = ar.length - 1; Or >= 0; Or--) {
        for (var si = ar.words[Or], ui = Hr - 1; ui >= 0; ui--) {
          var Li = si >> ui & 1;
          if (vr !== _r[0] && (vr = this.sqr(vr)), Li === 0 && Te === 0) {
            Cr = 0;
            continue;
          }
          Te <<= 1, Te |= Li, Cr++, !(Cr !== yr && (Or !== 0 || ui !== 0)) && (vr = this.mul(vr, _r[Te]), Cr = 0, Te = 0);
        }
        Hr = 26;
      }
      return vr;
    }, er.prototype.convertTo = function(rr) {
      var ar = rr.umod(this.m);
      return ar === rr ? ar.clone() : ar;
    }, er.prototype.convertFrom = function(rr) {
      var ar = rr.clone();
      return ar.red = null, ar;
    }, A.mont = function(rr) {
      return new Ie(rr);
    };
    function Ie(xe) {
      er.call(this, xe), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new A(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    a(Ie, er), Ie.prototype.convertTo = function(rr) {
      return this.imod(rr.ushln(this.shift));
    }, Ie.prototype.convertFrom = function(rr) {
      var ar = this.imod(rr.mul(this.rinv));
      return ar.red = null, ar;
    }, Ie.prototype.imul = function(rr, ar) {
      if (rr.isZero() || ar.isZero())
        return rr.words[0] = 0, rr.length = 1, rr;
      var yr = rr.imul(ar), _r = yr.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), Or = yr.isub(_r).iushrn(this.shift), vr = Or;
      return Or.cmp(this.m) >= 0 ? vr = Or.isub(this.m) : Or.cmpn(0) < 0 && (vr = Or.iadd(this.m)), vr._forceRed(this);
    }, Ie.prototype.mul = function(rr, ar) {
      if (rr.isZero() || ar.isZero()) return new A(0)._forceRed(this);
      var yr = rr.mul(ar), _r = yr.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), Or = yr.isub(_r).iushrn(this.shift), vr = Or;
      return Or.cmp(this.m) >= 0 ? vr = Or.isub(this.m) : Or.cmpn(0) < 0 && (vr = Or.iadd(this.m)), vr._forceRed(this);
    }, Ie.prototype.invm = function(rr) {
      var ar = this.imod(rr._invmp(this.m).mul(this.r2));
      return ar._forceRed(this);
    };
  })(n, commonjsGlobal);
})(bn$4);
var bnExports$1 = bn$4.exports, browserifyRsa, hasRequiredBrowserifyRsa;
function requireBrowserifyRsa() {
  if (hasRequiredBrowserifyRsa) return browserifyRsa;
  hasRequiredBrowserifyRsa = 1;
  var n = bnExports$1, c = requireBrowser$9(), u = safeBufferExports.Buffer;
  function p(b) {
    var F = b.modulus.byteLength(), le;
    do
      le = new n(c(F));
    while (le.cmp(b.modulus) >= 0 || !le.umod(b.prime1) || !le.umod(b.prime2));
    return le;
  }
  function a(b) {
    var F = p(b), le = F.toRed(n.mont(b.modulus)).redPow(new n(b.publicExponent)).fromRed();
    return { blinder: le, unblinder: F.invm(b.modulus) };
  }
  function A(b, F) {
    var le = a(F), L = F.modulus.byteLength(), pe = new n(b).mul(le.blinder).umod(F.modulus), $ = pe.toRed(n.mont(F.prime1)), Ee = pe.toRed(n.mont(F.prime2)), be = F.coefficient, He = F.prime1, Pe = F.prime2, nr = $.redPow(F.exponent1).fromRed(), ir = Ee.redPow(F.exponent2).fromRed(), or = nr.isub(ir).imul(be).umod(He).imul(Pe);
    return ir.iadd(or).imul(le.unblinder).umod(F.modulus).toArrayLike(u, "be", L);
  }
  return A.getr = p, browserifyRsa = A, browserifyRsa;
}
var elliptic$2 = {};
const name = "elliptic", version$9 = "6.6.1", description = "EC cryptography", main$3 = "lib/elliptic.js", files = [
  "lib"
], scripts = {
  lint: "eslint lib test",
  "lint:fix": "npm run lint -- --fix",
  unit: "istanbul test _mocha --reporter=spec test/index.js",
  test: "npm run lint && npm run unit",
  version: "grunt dist && git add dist/"
}, repository = {
  type: "git",
  url: "git@github.com:indutny/elliptic"
}, keywords = [
  "EC",
  "Elliptic",
  "curve",
  "Cryptography"
], author = "Fedor Indutny <fedor@indutny.com>", license = "MIT", bugs = {
  url: "https://github.com/indutny/elliptic/issues"
}, homepage = "https://github.com/indutny/elliptic", devDependencies = {
  brfs: "^2.0.2",
  coveralls: "^3.1.0",
  eslint: "^7.6.0",
  grunt: "^1.2.1",
  "grunt-browserify": "^5.3.0",
  "grunt-cli": "^1.3.2",
  "grunt-contrib-connect": "^3.0.0",
  "grunt-contrib-copy": "^1.0.0",
  "grunt-contrib-uglify": "^5.0.0",
  "grunt-mocha-istanbul": "^5.0.2",
  "grunt-saucelabs": "^9.0.1",
  istanbul: "^0.4.5",
  mocha: "^8.0.1"
}, dependencies = {
  "bn.js": "^4.11.9",
  brorand: "^1.1.0",
  "hash.js": "^1.0.0",
  "hmac-drbg": "^1.0.1",
  inherits: "^2.0.4",
  "minimalistic-assert": "^1.0.1",
  "minimalistic-crypto-utils": "^1.0.1"
}, require$$0$3 = {
  name,
  version: version$9,
  description,
  main: main$3,
  files,
  scripts,
  repository,
  keywords,
  author,
  license,
  bugs,
  homepage,
  devDependencies,
  dependencies
};
var utils$C = {}, bn$3 = { exports: {} };
bn$3.exports;
(function(n) {
  (function(c, u) {
    function p(er, Ie) {
      if (!er) throw new Error(Ie || "Assertion failed");
    }
    function a(er, Ie) {
      er.super_ = Ie;
      var xe = function() {
      };
      xe.prototype = Ie.prototype, er.prototype = new xe(), er.prototype.constructor = er;
    }
    function A(er, Ie, xe) {
      if (A.isBN(er))
        return er;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, er !== null && ((Ie === "le" || Ie === "be") && (xe = Ie, Ie = 10), this._init(er || 0, Ie || 10, xe || "be"));
    }
    typeof c == "object" ? c.exports = A : u.BN = A, A.BN = A, A.wordSize = 26;
    var b;
    try {
      typeof window < "u" && typeof window.Buffer < "u" ? b = window.Buffer : b = require$$0$5.Buffer;
    } catch {
    }
    A.isBN = function(Ie) {
      return Ie instanceof A ? !0 : Ie !== null && typeof Ie == "object" && Ie.constructor.wordSize === A.wordSize && Array.isArray(Ie.words);
    }, A.max = function(Ie, xe) {
      return Ie.cmp(xe) > 0 ? Ie : xe;
    }, A.min = function(Ie, xe) {
      return Ie.cmp(xe) < 0 ? Ie : xe;
    }, A.prototype._init = function(Ie, xe, rr) {
      if (typeof Ie == "number")
        return this._initNumber(Ie, xe, rr);
      if (typeof Ie == "object")
        return this._initArray(Ie, xe, rr);
      xe === "hex" && (xe = 16), p(xe === (xe | 0) && xe >= 2 && xe <= 36), Ie = Ie.toString().replace(/\s+/g, "");
      var ar = 0;
      Ie[0] === "-" && (ar++, this.negative = 1), ar < Ie.length && (xe === 16 ? this._parseHex(Ie, ar, rr) : (this._parseBase(Ie, xe, ar), rr === "le" && this._initArray(this.toArray(), xe, rr)));
    }, A.prototype._initNumber = function(Ie, xe, rr) {
      Ie < 0 && (this.negative = 1, Ie = -Ie), Ie < 67108864 ? (this.words = [Ie & 67108863], this.length = 1) : Ie < 4503599627370496 ? (this.words = [
        Ie & 67108863,
        Ie / 67108864 & 67108863
      ], this.length = 2) : (p(Ie < 9007199254740992), this.words = [
        Ie & 67108863,
        Ie / 67108864 & 67108863,
        1
      ], this.length = 3), rr === "le" && this._initArray(this.toArray(), xe, rr);
    }, A.prototype._initArray = function(Ie, xe, rr) {
      if (p(typeof Ie.length == "number"), Ie.length <= 0)
        return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(Ie.length / 3), this.words = new Array(this.length);
      for (var ar = 0; ar < this.length; ar++)
        this.words[ar] = 0;
      var yr, _r, Or = 0;
      if (rr === "be")
        for (ar = Ie.length - 1, yr = 0; ar >= 0; ar -= 3)
          _r = Ie[ar] | Ie[ar - 1] << 8 | Ie[ar - 2] << 16, this.words[yr] |= _r << Or & 67108863, this.words[yr + 1] = _r >>> 26 - Or & 67108863, Or += 24, Or >= 26 && (Or -= 26, yr++);
      else if (rr === "le")
        for (ar = 0, yr = 0; ar < Ie.length; ar += 3)
          _r = Ie[ar] | Ie[ar + 1] << 8 | Ie[ar + 2] << 16, this.words[yr] |= _r << Or & 67108863, this.words[yr + 1] = _r >>> 26 - Or & 67108863, Or += 24, Or >= 26 && (Or -= 26, yr++);
      return this.strip();
    };
    function F(er, Ie) {
      var xe = er.charCodeAt(Ie);
      return xe >= 65 && xe <= 70 ? xe - 55 : xe >= 97 && xe <= 102 ? xe - 87 : xe - 48 & 15;
    }
    function le(er, Ie, xe) {
      var rr = F(er, xe);
      return xe - 1 >= Ie && (rr |= F(er, xe - 1) << 4), rr;
    }
    A.prototype._parseHex = function(Ie, xe, rr) {
      this.length = Math.ceil((Ie.length - xe) / 6), this.words = new Array(this.length);
      for (var ar = 0; ar < this.length; ar++)
        this.words[ar] = 0;
      var yr = 0, _r = 0, Or;
      if (rr === "be")
        for (ar = Ie.length - 1; ar >= xe; ar -= 2)
          Or = le(Ie, xe, ar) << yr, this.words[_r] |= Or & 67108863, yr >= 18 ? (yr -= 18, _r += 1, this.words[_r] |= Or >>> 26) : yr += 8;
      else {
        var vr = Ie.length - xe;
        for (ar = vr % 2 === 0 ? xe + 1 : xe; ar < Ie.length; ar += 2)
          Or = le(Ie, xe, ar) << yr, this.words[_r] |= Or & 67108863, yr >= 18 ? (yr -= 18, _r += 1, this.words[_r] |= Or >>> 26) : yr += 8;
      }
      this.strip();
    };
    function L(er, Ie, xe, rr) {
      for (var ar = 0, yr = Math.min(er.length, xe), _r = Ie; _r < yr; _r++) {
        var Or = er.charCodeAt(_r) - 48;
        ar *= rr, Or >= 49 ? ar += Or - 49 + 10 : Or >= 17 ? ar += Or - 17 + 10 : ar += Or;
      }
      return ar;
    }
    A.prototype._parseBase = function(Ie, xe, rr) {
      this.words = [0], this.length = 1;
      for (var ar = 0, yr = 1; yr <= 67108863; yr *= xe)
        ar++;
      ar--, yr = yr / xe | 0;
      for (var _r = Ie.length - rr, Or = _r % ar, vr = Math.min(_r, _r - Or) + rr, Te = 0, Cr = rr; Cr < vr; Cr += ar)
        Te = L(Ie, Cr, Cr + ar, xe), this.imuln(yr), this.words[0] + Te < 67108864 ? this.words[0] += Te : this._iaddn(Te);
      if (Or !== 0) {
        var Hr = 1;
        for (Te = L(Ie, Cr, Ie.length, xe), Cr = 0; Cr < Or; Cr++)
          Hr *= xe;
        this.imuln(Hr), this.words[0] + Te < 67108864 ? this.words[0] += Te : this._iaddn(Te);
      }
      this.strip();
    }, A.prototype.copy = function(Ie) {
      Ie.words = new Array(this.length);
      for (var xe = 0; xe < this.length; xe++)
        Ie.words[xe] = this.words[xe];
      Ie.length = this.length, Ie.negative = this.negative, Ie.red = this.red;
    }, A.prototype.clone = function() {
      var Ie = new A(null);
      return this.copy(Ie), Ie;
    }, A.prototype._expand = function(Ie) {
      for (; this.length < Ie; )
        this.words[this.length++] = 0;
      return this;
    }, A.prototype.strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; )
        this.length--;
      return this._normSign();
    }, A.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, A.prototype.inspect = function() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    var pe = [
      "",
      "0",
      "00",
      "000",
      "0000",
      "00000",
      "000000",
      "0000000",
      "00000000",
      "000000000",
      "0000000000",
      "00000000000",
      "000000000000",
      "0000000000000",
      "00000000000000",
      "000000000000000",
      "0000000000000000",
      "00000000000000000",
      "000000000000000000",
      "0000000000000000000",
      "00000000000000000000",
      "000000000000000000000",
      "0000000000000000000000",
      "00000000000000000000000",
      "000000000000000000000000",
      "0000000000000000000000000"
    ], $ = [
      0,
      0,
      25,
      16,
      12,
      11,
      10,
      9,
      8,
      8,
      7,
      7,
      7,
      7,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5
    ], Ee = [
      0,
      0,
      33554432,
      43046721,
      16777216,
      48828125,
      60466176,
      40353607,
      16777216,
      43046721,
      1e7,
      19487171,
      35831808,
      62748517,
      7529536,
      11390625,
      16777216,
      24137569,
      34012224,
      47045881,
      64e6,
      4084101,
      5153632,
      6436343,
      7962624,
      9765625,
      11881376,
      14348907,
      17210368,
      20511149,
      243e5,
      28629151,
      33554432,
      39135393,
      45435424,
      52521875,
      60466176
    ];
    A.prototype.toString = function(Ie, xe) {
      Ie = Ie || 10, xe = xe | 0 || 1;
      var rr;
      if (Ie === 16 || Ie === "hex") {
        rr = "";
        for (var ar = 0, yr = 0, _r = 0; _r < this.length; _r++) {
          var Or = this.words[_r], vr = ((Or << ar | yr) & 16777215).toString(16);
          yr = Or >>> 24 - ar & 16777215, ar += 2, ar >= 26 && (ar -= 26, _r--), yr !== 0 || _r !== this.length - 1 ? rr = pe[6 - vr.length] + vr + rr : rr = vr + rr;
        }
        for (yr !== 0 && (rr = yr.toString(16) + rr); rr.length % xe !== 0; )
          rr = "0" + rr;
        return this.negative !== 0 && (rr = "-" + rr), rr;
      }
      if (Ie === (Ie | 0) && Ie >= 2 && Ie <= 36) {
        var Te = $[Ie], Cr = Ee[Ie];
        rr = "";
        var Hr = this.clone();
        for (Hr.negative = 0; !Hr.isZero(); ) {
          var si = Hr.modn(Cr).toString(Ie);
          Hr = Hr.idivn(Cr), Hr.isZero() ? rr = si + rr : rr = pe[Te - si.length] + si + rr;
        }
        for (this.isZero() && (rr = "0" + rr); rr.length % xe !== 0; )
          rr = "0" + rr;
        return this.negative !== 0 && (rr = "-" + rr), rr;
      }
      p(!1, "Base should be between 2 and 36");
    }, A.prototype.toNumber = function() {
      var Ie = this.words[0];
      return this.length === 2 ? Ie += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? Ie += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && p(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -Ie : Ie;
    }, A.prototype.toJSON = function() {
      return this.toString(16);
    }, A.prototype.toBuffer = function(Ie, xe) {
      return p(typeof b < "u"), this.toArrayLike(b, Ie, xe);
    }, A.prototype.toArray = function(Ie, xe) {
      return this.toArrayLike(Array, Ie, xe);
    }, A.prototype.toArrayLike = function(Ie, xe, rr) {
      var ar = this.byteLength(), yr = rr || Math.max(1, ar);
      p(ar <= yr, "byte array longer than desired length"), p(yr > 0, "Requested array length <= 0"), this.strip();
      var _r = xe === "le", Or = new Ie(yr), vr, Te, Cr = this.clone();
      if (_r) {
        for (Te = 0; !Cr.isZero(); Te++)
          vr = Cr.andln(255), Cr.iushrn(8), Or[Te] = vr;
        for (; Te < yr; Te++)
          Or[Te] = 0;
      } else {
        for (Te = 0; Te < yr - ar; Te++)
          Or[Te] = 0;
        for (Te = 0; !Cr.isZero(); Te++)
          vr = Cr.andln(255), Cr.iushrn(8), Or[yr - Te - 1] = vr;
      }
      return Or;
    }, Math.clz32 ? A.prototype._countBits = function(Ie) {
      return 32 - Math.clz32(Ie);
    } : A.prototype._countBits = function(Ie) {
      var xe = Ie, rr = 0;
      return xe >= 4096 && (rr += 13, xe >>>= 13), xe >= 64 && (rr += 7, xe >>>= 7), xe >= 8 && (rr += 4, xe >>>= 4), xe >= 2 && (rr += 2, xe >>>= 2), rr + xe;
    }, A.prototype._zeroBits = function(Ie) {
      if (Ie === 0) return 26;
      var xe = Ie, rr = 0;
      return xe & 8191 || (rr += 13, xe >>>= 13), xe & 127 || (rr += 7, xe >>>= 7), xe & 15 || (rr += 4, xe >>>= 4), xe & 3 || (rr += 2, xe >>>= 2), xe & 1 || rr++, rr;
    }, A.prototype.bitLength = function() {
      var Ie = this.words[this.length - 1], xe = this._countBits(Ie);
      return (this.length - 1) * 26 + xe;
    };
    function be(er) {
      for (var Ie = new Array(er.bitLength()), xe = 0; xe < Ie.length; xe++) {
        var rr = xe / 26 | 0, ar = xe % 26;
        Ie[xe] = (er.words[rr] & 1 << ar) >>> ar;
      }
      return Ie;
    }
    A.prototype.zeroBits = function() {
      if (this.isZero()) return 0;
      for (var Ie = 0, xe = 0; xe < this.length; xe++) {
        var rr = this._zeroBits(this.words[xe]);
        if (Ie += rr, rr !== 26) break;
      }
      return Ie;
    }, A.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, A.prototype.toTwos = function(Ie) {
      return this.negative !== 0 ? this.abs().inotn(Ie).iaddn(1) : this.clone();
    }, A.prototype.fromTwos = function(Ie) {
      return this.testn(Ie - 1) ? this.notn(Ie).iaddn(1).ineg() : this.clone();
    }, A.prototype.isNeg = function() {
      return this.negative !== 0;
    }, A.prototype.neg = function() {
      return this.clone().ineg();
    }, A.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, A.prototype.iuor = function(Ie) {
      for (; this.length < Ie.length; )
        this.words[this.length++] = 0;
      for (var xe = 0; xe < Ie.length; xe++)
        this.words[xe] = this.words[xe] | Ie.words[xe];
      return this.strip();
    }, A.prototype.ior = function(Ie) {
      return p((this.negative | Ie.negative) === 0), this.iuor(Ie);
    }, A.prototype.or = function(Ie) {
      return this.length > Ie.length ? this.clone().ior(Ie) : Ie.clone().ior(this);
    }, A.prototype.uor = function(Ie) {
      return this.length > Ie.length ? this.clone().iuor(Ie) : Ie.clone().iuor(this);
    }, A.prototype.iuand = function(Ie) {
      var xe;
      this.length > Ie.length ? xe = Ie : xe = this;
      for (var rr = 0; rr < xe.length; rr++)
        this.words[rr] = this.words[rr] & Ie.words[rr];
      return this.length = xe.length, this.strip();
    }, A.prototype.iand = function(Ie) {
      return p((this.negative | Ie.negative) === 0), this.iuand(Ie);
    }, A.prototype.and = function(Ie) {
      return this.length > Ie.length ? this.clone().iand(Ie) : Ie.clone().iand(this);
    }, A.prototype.uand = function(Ie) {
      return this.length > Ie.length ? this.clone().iuand(Ie) : Ie.clone().iuand(this);
    }, A.prototype.iuxor = function(Ie) {
      var xe, rr;
      this.length > Ie.length ? (xe = this, rr = Ie) : (xe = Ie, rr = this);
      for (var ar = 0; ar < rr.length; ar++)
        this.words[ar] = xe.words[ar] ^ rr.words[ar];
      if (this !== xe)
        for (; ar < xe.length; ar++)
          this.words[ar] = xe.words[ar];
      return this.length = xe.length, this.strip();
    }, A.prototype.ixor = function(Ie) {
      return p((this.negative | Ie.negative) === 0), this.iuxor(Ie);
    }, A.prototype.xor = function(Ie) {
      return this.length > Ie.length ? this.clone().ixor(Ie) : Ie.clone().ixor(this);
    }, A.prototype.uxor = function(Ie) {
      return this.length > Ie.length ? this.clone().iuxor(Ie) : Ie.clone().iuxor(this);
    }, A.prototype.inotn = function(Ie) {
      p(typeof Ie == "number" && Ie >= 0);
      var xe = Math.ceil(Ie / 26) | 0, rr = Ie % 26;
      this._expand(xe), rr > 0 && xe--;
      for (var ar = 0; ar < xe; ar++)
        this.words[ar] = ~this.words[ar] & 67108863;
      return rr > 0 && (this.words[ar] = ~this.words[ar] & 67108863 >> 26 - rr), this.strip();
    }, A.prototype.notn = function(Ie) {
      return this.clone().inotn(Ie);
    }, A.prototype.setn = function(Ie, xe) {
      p(typeof Ie == "number" && Ie >= 0);
      var rr = Ie / 26 | 0, ar = Ie % 26;
      return this._expand(rr + 1), xe ? this.words[rr] = this.words[rr] | 1 << ar : this.words[rr] = this.words[rr] & ~(1 << ar), this.strip();
    }, A.prototype.iadd = function(Ie) {
      var xe;
      if (this.negative !== 0 && Ie.negative === 0)
        return this.negative = 0, xe = this.isub(Ie), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && Ie.negative !== 0)
        return Ie.negative = 0, xe = this.isub(Ie), Ie.negative = 1, xe._normSign();
      var rr, ar;
      this.length > Ie.length ? (rr = this, ar = Ie) : (rr = Ie, ar = this);
      for (var yr = 0, _r = 0; _r < ar.length; _r++)
        xe = (rr.words[_r] | 0) + (ar.words[_r] | 0) + yr, this.words[_r] = xe & 67108863, yr = xe >>> 26;
      for (; yr !== 0 && _r < rr.length; _r++)
        xe = (rr.words[_r] | 0) + yr, this.words[_r] = xe & 67108863, yr = xe >>> 26;
      if (this.length = rr.length, yr !== 0)
        this.words[this.length] = yr, this.length++;
      else if (rr !== this)
        for (; _r < rr.length; _r++)
          this.words[_r] = rr.words[_r];
      return this;
    }, A.prototype.add = function(Ie) {
      var xe;
      return Ie.negative !== 0 && this.negative === 0 ? (Ie.negative = 0, xe = this.sub(Ie), Ie.negative ^= 1, xe) : Ie.negative === 0 && this.negative !== 0 ? (this.negative = 0, xe = Ie.sub(this), this.negative = 1, xe) : this.length > Ie.length ? this.clone().iadd(Ie) : Ie.clone().iadd(this);
    }, A.prototype.isub = function(Ie) {
      if (Ie.negative !== 0) {
        Ie.negative = 0;
        var xe = this.iadd(Ie);
        return Ie.negative = 1, xe._normSign();
      } else if (this.negative !== 0)
        return this.negative = 0, this.iadd(Ie), this.negative = 1, this._normSign();
      var rr = this.cmp(Ie);
      if (rr === 0)
        return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var ar, yr;
      rr > 0 ? (ar = this, yr = Ie) : (ar = Ie, yr = this);
      for (var _r = 0, Or = 0; Or < yr.length; Or++)
        xe = (ar.words[Or] | 0) - (yr.words[Or] | 0) + _r, _r = xe >> 26, this.words[Or] = xe & 67108863;
      for (; _r !== 0 && Or < ar.length; Or++)
        xe = (ar.words[Or] | 0) + _r, _r = xe >> 26, this.words[Or] = xe & 67108863;
      if (_r === 0 && Or < ar.length && ar !== this)
        for (; Or < ar.length; Or++)
          this.words[Or] = ar.words[Or];
      return this.length = Math.max(this.length, Or), ar !== this && (this.negative = 1), this.strip();
    }, A.prototype.sub = function(Ie) {
      return this.clone().isub(Ie);
    };
    function He(er, Ie, xe) {
      xe.negative = Ie.negative ^ er.negative;
      var rr = er.length + Ie.length | 0;
      xe.length = rr, rr = rr - 1 | 0;
      var ar = er.words[0] | 0, yr = Ie.words[0] | 0, _r = ar * yr, Or = _r & 67108863, vr = _r / 67108864 | 0;
      xe.words[0] = Or;
      for (var Te = 1; Te < rr; Te++) {
        for (var Cr = vr >>> 26, Hr = vr & 67108863, si = Math.min(Te, Ie.length - 1), ui = Math.max(0, Te - er.length + 1); ui <= si; ui++) {
          var Li = Te - ui | 0;
          ar = er.words[Li] | 0, yr = Ie.words[ui] | 0, _r = ar * yr + Hr, Cr += _r / 67108864 | 0, Hr = _r & 67108863;
        }
        xe.words[Te] = Hr | 0, vr = Cr | 0;
      }
      return vr !== 0 ? xe.words[Te] = vr | 0 : xe.length--, xe.strip();
    }
    var Pe = function(Ie, xe, rr) {
      var ar = Ie.words, yr = xe.words, _r = rr.words, Or = 0, vr, Te, Cr, Hr = ar[0] | 0, si = Hr & 8191, ui = Hr >>> 13, Li = ar[1] | 0, Qi = Li & 8191, wi = Li >>> 13, Ji = ar[2] | 0, mn = Ji & 8191, pi = Ji >>> 13, ei = ar[3] | 0, Vr = ei & 8191, qr = ei >>> 13, Zi = ar[4] | 0, Wr = Zi & 8191, ri = Zi >>> 13, _i = ar[5] | 0, Er = _i & 8191, Di = _i >>> 13, _n = ar[6] | 0, On = _n & 8191, so = _n >>> 13, Do = ar[7] | 0, gn = Do & 8191, Gn = Do >>> 13, pn = ar[8] | 0, hn = pn & 8191, Rn = pn >>> 13, vo = ar[9] | 0, Hi = vo & 8191, di = vo >>> 13, Ui = yr[0] | 0, ln = Ui & 8191, Un = Ui >>> 13, Bo = yr[1] | 0, co = Bo & 8191, To = Bo >>> 13, xs = yr[2] | 0, Fo = xs & 8191, Zo = xs >>> 13, $s = yr[3] | 0, rs = $s & 8191, ls = $s >>> 13, na = yr[4] | 0, os = na & 8191, fs = na >>> 13, da = yr[5] | 0, Bn = da & 8191, hi = da >>> 13, Ii = yr[6] | 0, Gi = Ii & 8191, kn = Ii >>> 13, ho = yr[7] | 0, eo = ho & 8191, Ei = ho >>> 13, vs = yr[8] | 0, vi = vs & 8191, xi = vs >>> 13, Lr = yr[9] | 0, dn = Lr & 8191, xn = Lr >>> 13;
      rr.negative = Ie.negative ^ xe.negative, rr.length = 19, vr = Math.imul(si, ln), Te = Math.imul(si, Un), Te = Te + Math.imul(ui, ln) | 0, Cr = Math.imul(ui, Un);
      var oi = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
      Or = (Cr + (Te >>> 13) | 0) + (oi >>> 26) | 0, oi &= 67108863, vr = Math.imul(Qi, ln), Te = Math.imul(Qi, Un), Te = Te + Math.imul(wi, ln) | 0, Cr = Math.imul(wi, Un), vr = vr + Math.imul(si, co) | 0, Te = Te + Math.imul(si, To) | 0, Te = Te + Math.imul(ui, co) | 0, Cr = Cr + Math.imul(ui, To) | 0;
      var Yr = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
      Or = (Cr + (Te >>> 13) | 0) + (Yr >>> 26) | 0, Yr &= 67108863, vr = Math.imul(mn, ln), Te = Math.imul(mn, Un), Te = Te + Math.imul(pi, ln) | 0, Cr = Math.imul(pi, Un), vr = vr + Math.imul(Qi, co) | 0, Te = Te + Math.imul(Qi, To) | 0, Te = Te + Math.imul(wi, co) | 0, Cr = Cr + Math.imul(wi, To) | 0, vr = vr + Math.imul(si, Fo) | 0, Te = Te + Math.imul(si, Zo) | 0, Te = Te + Math.imul(ui, Fo) | 0, Cr = Cr + Math.imul(ui, Zo) | 0;
      var ji = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
      Or = (Cr + (Te >>> 13) | 0) + (ji >>> 26) | 0, ji &= 67108863, vr = Math.imul(Vr, ln), Te = Math.imul(Vr, Un), Te = Te + Math.imul(qr, ln) | 0, Cr = Math.imul(qr, Un), vr = vr + Math.imul(mn, co) | 0, Te = Te + Math.imul(mn, To) | 0, Te = Te + Math.imul(pi, co) | 0, Cr = Cr + Math.imul(pi, To) | 0, vr = vr + Math.imul(Qi, Fo) | 0, Te = Te + Math.imul(Qi, Zo) | 0, Te = Te + Math.imul(wi, Fo) | 0, Cr = Cr + Math.imul(wi, Zo) | 0, vr = vr + Math.imul(si, rs) | 0, Te = Te + Math.imul(si, ls) | 0, Te = Te + Math.imul(ui, rs) | 0, Cr = Cr + Math.imul(ui, ls) | 0;
      var Cn = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
      Or = (Cr + (Te >>> 13) | 0) + (Cn >>> 26) | 0, Cn &= 67108863, vr = Math.imul(Wr, ln), Te = Math.imul(Wr, Un), Te = Te + Math.imul(ri, ln) | 0, Cr = Math.imul(ri, Un), vr = vr + Math.imul(Vr, co) | 0, Te = Te + Math.imul(Vr, To) | 0, Te = Te + Math.imul(qr, co) | 0, Cr = Cr + Math.imul(qr, To) | 0, vr = vr + Math.imul(mn, Fo) | 0, Te = Te + Math.imul(mn, Zo) | 0, Te = Te + Math.imul(pi, Fo) | 0, Cr = Cr + Math.imul(pi, Zo) | 0, vr = vr + Math.imul(Qi, rs) | 0, Te = Te + Math.imul(Qi, ls) | 0, Te = Te + Math.imul(wi, rs) | 0, Cr = Cr + Math.imul(wi, ls) | 0, vr = vr + Math.imul(si, os) | 0, Te = Te + Math.imul(si, fs) | 0, Te = Te + Math.imul(ui, os) | 0, Cr = Cr + Math.imul(ui, fs) | 0;
      var Mn = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
      Or = (Cr + (Te >>> 13) | 0) + (Mn >>> 26) | 0, Mn &= 67108863, vr = Math.imul(Er, ln), Te = Math.imul(Er, Un), Te = Te + Math.imul(Di, ln) | 0, Cr = Math.imul(Di, Un), vr = vr + Math.imul(Wr, co) | 0, Te = Te + Math.imul(Wr, To) | 0, Te = Te + Math.imul(ri, co) | 0, Cr = Cr + Math.imul(ri, To) | 0, vr = vr + Math.imul(Vr, Fo) | 0, Te = Te + Math.imul(Vr, Zo) | 0, Te = Te + Math.imul(qr, Fo) | 0, Cr = Cr + Math.imul(qr, Zo) | 0, vr = vr + Math.imul(mn, rs) | 0, Te = Te + Math.imul(mn, ls) | 0, Te = Te + Math.imul(pi, rs) | 0, Cr = Cr + Math.imul(pi, ls) | 0, vr = vr + Math.imul(Qi, os) | 0, Te = Te + Math.imul(Qi, fs) | 0, Te = Te + Math.imul(wi, os) | 0, Cr = Cr + Math.imul(wi, fs) | 0, vr = vr + Math.imul(si, Bn) | 0, Te = Te + Math.imul(si, hi) | 0, Te = Te + Math.imul(ui, Bn) | 0, Cr = Cr + Math.imul(ui, hi) | 0;
      var B = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
      Or = (Cr + (Te >>> 13) | 0) + (B >>> 26) | 0, B &= 67108863, vr = Math.imul(On, ln), Te = Math.imul(On, Un), Te = Te + Math.imul(so, ln) | 0, Cr = Math.imul(so, Un), vr = vr + Math.imul(Er, co) | 0, Te = Te + Math.imul(Er, To) | 0, Te = Te + Math.imul(Di, co) | 0, Cr = Cr + Math.imul(Di, To) | 0, vr = vr + Math.imul(Wr, Fo) | 0, Te = Te + Math.imul(Wr, Zo) | 0, Te = Te + Math.imul(ri, Fo) | 0, Cr = Cr + Math.imul(ri, Zo) | 0, vr = vr + Math.imul(Vr, rs) | 0, Te = Te + Math.imul(Vr, ls) | 0, Te = Te + Math.imul(qr, rs) | 0, Cr = Cr + Math.imul(qr, ls) | 0, vr = vr + Math.imul(mn, os) | 0, Te = Te + Math.imul(mn, fs) | 0, Te = Te + Math.imul(pi, os) | 0, Cr = Cr + Math.imul(pi, fs) | 0, vr = vr + Math.imul(Qi, Bn) | 0, Te = Te + Math.imul(Qi, hi) | 0, Te = Te + Math.imul(wi, Bn) | 0, Cr = Cr + Math.imul(wi, hi) | 0, vr = vr + Math.imul(si, Gi) | 0, Te = Te + Math.imul(si, kn) | 0, Te = Te + Math.imul(ui, Gi) | 0, Cr = Cr + Math.imul(ui, kn) | 0;
      var o = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
      Or = (Cr + (Te >>> 13) | 0) + (o >>> 26) | 0, o &= 67108863, vr = Math.imul(gn, ln), Te = Math.imul(gn, Un), Te = Te + Math.imul(Gn, ln) | 0, Cr = Math.imul(Gn, Un), vr = vr + Math.imul(On, co) | 0, Te = Te + Math.imul(On, To) | 0, Te = Te + Math.imul(so, co) | 0, Cr = Cr + Math.imul(so, To) | 0, vr = vr + Math.imul(Er, Fo) | 0, Te = Te + Math.imul(Er, Zo) | 0, Te = Te + Math.imul(Di, Fo) | 0, Cr = Cr + Math.imul(Di, Zo) | 0, vr = vr + Math.imul(Wr, rs) | 0, Te = Te + Math.imul(Wr, ls) | 0, Te = Te + Math.imul(ri, rs) | 0, Cr = Cr + Math.imul(ri, ls) | 0, vr = vr + Math.imul(Vr, os) | 0, Te = Te + Math.imul(Vr, fs) | 0, Te = Te + Math.imul(qr, os) | 0, Cr = Cr + Math.imul(qr, fs) | 0, vr = vr + Math.imul(mn, Bn) | 0, Te = Te + Math.imul(mn, hi) | 0, Te = Te + Math.imul(pi, Bn) | 0, Cr = Cr + Math.imul(pi, hi) | 0, vr = vr + Math.imul(Qi, Gi) | 0, Te = Te + Math.imul(Qi, kn) | 0, Te = Te + Math.imul(wi, Gi) | 0, Cr = Cr + Math.imul(wi, kn) | 0, vr = vr + Math.imul(si, eo) | 0, Te = Te + Math.imul(si, Ei) | 0, Te = Te + Math.imul(ui, eo) | 0, Cr = Cr + Math.imul(ui, Ei) | 0;
      var m = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
      Or = (Cr + (Te >>> 13) | 0) + (m >>> 26) | 0, m &= 67108863, vr = Math.imul(hn, ln), Te = Math.imul(hn, Un), Te = Te + Math.imul(Rn, ln) | 0, Cr = Math.imul(Rn, Un), vr = vr + Math.imul(gn, co) | 0, Te = Te + Math.imul(gn, To) | 0, Te = Te + Math.imul(Gn, co) | 0, Cr = Cr + Math.imul(Gn, To) | 0, vr = vr + Math.imul(On, Fo) | 0, Te = Te + Math.imul(On, Zo) | 0, Te = Te + Math.imul(so, Fo) | 0, Cr = Cr + Math.imul(so, Zo) | 0, vr = vr + Math.imul(Er, rs) | 0, Te = Te + Math.imul(Er, ls) | 0, Te = Te + Math.imul(Di, rs) | 0, Cr = Cr + Math.imul(Di, ls) | 0, vr = vr + Math.imul(Wr, os) | 0, Te = Te + Math.imul(Wr, fs) | 0, Te = Te + Math.imul(ri, os) | 0, Cr = Cr + Math.imul(ri, fs) | 0, vr = vr + Math.imul(Vr, Bn) | 0, Te = Te + Math.imul(Vr, hi) | 0, Te = Te + Math.imul(qr, Bn) | 0, Cr = Cr + Math.imul(qr, hi) | 0, vr = vr + Math.imul(mn, Gi) | 0, Te = Te + Math.imul(mn, kn) | 0, Te = Te + Math.imul(pi, Gi) | 0, Cr = Cr + Math.imul(pi, kn) | 0, vr = vr + Math.imul(Qi, eo) | 0, Te = Te + Math.imul(Qi, Ei) | 0, Te = Te + Math.imul(wi, eo) | 0, Cr = Cr + Math.imul(wi, Ei) | 0, vr = vr + Math.imul(si, vi) | 0, Te = Te + Math.imul(si, xi) | 0, Te = Te + Math.imul(ui, vi) | 0, Cr = Cr + Math.imul(ui, xi) | 0;
      var d = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
      Or = (Cr + (Te >>> 13) | 0) + (d >>> 26) | 0, d &= 67108863, vr = Math.imul(Hi, ln), Te = Math.imul(Hi, Un), Te = Te + Math.imul(di, ln) | 0, Cr = Math.imul(di, Un), vr = vr + Math.imul(hn, co) | 0, Te = Te + Math.imul(hn, To) | 0, Te = Te + Math.imul(Rn, co) | 0, Cr = Cr + Math.imul(Rn, To) | 0, vr = vr + Math.imul(gn, Fo) | 0, Te = Te + Math.imul(gn, Zo) | 0, Te = Te + Math.imul(Gn, Fo) | 0, Cr = Cr + Math.imul(Gn, Zo) | 0, vr = vr + Math.imul(On, rs) | 0, Te = Te + Math.imul(On, ls) | 0, Te = Te + Math.imul(so, rs) | 0, Cr = Cr + Math.imul(so, ls) | 0, vr = vr + Math.imul(Er, os) | 0, Te = Te + Math.imul(Er, fs) | 0, Te = Te + Math.imul(Di, os) | 0, Cr = Cr + Math.imul(Di, fs) | 0, vr = vr + Math.imul(Wr, Bn) | 0, Te = Te + Math.imul(Wr, hi) | 0, Te = Te + Math.imul(ri, Bn) | 0, Cr = Cr + Math.imul(ri, hi) | 0, vr = vr + Math.imul(Vr, Gi) | 0, Te = Te + Math.imul(Vr, kn) | 0, Te = Te + Math.imul(qr, Gi) | 0, Cr = Cr + Math.imul(qr, kn) | 0, vr = vr + Math.imul(mn, eo) | 0, Te = Te + Math.imul(mn, Ei) | 0, Te = Te + Math.imul(pi, eo) | 0, Cr = Cr + Math.imul(pi, Ei) | 0, vr = vr + Math.imul(Qi, vi) | 0, Te = Te + Math.imul(Qi, xi) | 0, Te = Te + Math.imul(wi, vi) | 0, Cr = Cr + Math.imul(wi, xi) | 0, vr = vr + Math.imul(si, dn) | 0, Te = Te + Math.imul(si, xn) | 0, Te = Te + Math.imul(ui, dn) | 0, Cr = Cr + Math.imul(ui, xn) | 0;
      var v = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
      Or = (Cr + (Te >>> 13) | 0) + (v >>> 26) | 0, v &= 67108863, vr = Math.imul(Hi, co), Te = Math.imul(Hi, To), Te = Te + Math.imul(di, co) | 0, Cr = Math.imul(di, To), vr = vr + Math.imul(hn, Fo) | 0, Te = Te + Math.imul(hn, Zo) | 0, Te = Te + Math.imul(Rn, Fo) | 0, Cr = Cr + Math.imul(Rn, Zo) | 0, vr = vr + Math.imul(gn, rs) | 0, Te = Te + Math.imul(gn, ls) | 0, Te = Te + Math.imul(Gn, rs) | 0, Cr = Cr + Math.imul(Gn, ls) | 0, vr = vr + Math.imul(On, os) | 0, Te = Te + Math.imul(On, fs) | 0, Te = Te + Math.imul(so, os) | 0, Cr = Cr + Math.imul(so, fs) | 0, vr = vr + Math.imul(Er, Bn) | 0, Te = Te + Math.imul(Er, hi) | 0, Te = Te + Math.imul(Di, Bn) | 0, Cr = Cr + Math.imul(Di, hi) | 0, vr = vr + Math.imul(Wr, Gi) | 0, Te = Te + Math.imul(Wr, kn) | 0, Te = Te + Math.imul(ri, Gi) | 0, Cr = Cr + Math.imul(ri, kn) | 0, vr = vr + Math.imul(Vr, eo) | 0, Te = Te + Math.imul(Vr, Ei) | 0, Te = Te + Math.imul(qr, eo) | 0, Cr = Cr + Math.imul(qr, Ei) | 0, vr = vr + Math.imul(mn, vi) | 0, Te = Te + Math.imul(mn, xi) | 0, Te = Te + Math.imul(pi, vi) | 0, Cr = Cr + Math.imul(pi, xi) | 0, vr = vr + Math.imul(Qi, dn) | 0, Te = Te + Math.imul(Qi, xn) | 0, Te = Te + Math.imul(wi, dn) | 0, Cr = Cr + Math.imul(wi, xn) | 0;
      var he = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
      Or = (Cr + (Te >>> 13) | 0) + (he >>> 26) | 0, he &= 67108863, vr = Math.imul(Hi, Fo), Te = Math.imul(Hi, Zo), Te = Te + Math.imul(di, Fo) | 0, Cr = Math.imul(di, Zo), vr = vr + Math.imul(hn, rs) | 0, Te = Te + Math.imul(hn, ls) | 0, Te = Te + Math.imul(Rn, rs) | 0, Cr = Cr + Math.imul(Rn, ls) | 0, vr = vr + Math.imul(gn, os) | 0, Te = Te + Math.imul(gn, fs) | 0, Te = Te + Math.imul(Gn, os) | 0, Cr = Cr + Math.imul(Gn, fs) | 0, vr = vr + Math.imul(On, Bn) | 0, Te = Te + Math.imul(On, hi) | 0, Te = Te + Math.imul(so, Bn) | 0, Cr = Cr + Math.imul(so, hi) | 0, vr = vr + Math.imul(Er, Gi) | 0, Te = Te + Math.imul(Er, kn) | 0, Te = Te + Math.imul(Di, Gi) | 0, Cr = Cr + Math.imul(Di, kn) | 0, vr = vr + Math.imul(Wr, eo) | 0, Te = Te + Math.imul(Wr, Ei) | 0, Te = Te + Math.imul(ri, eo) | 0, Cr = Cr + Math.imul(ri, Ei) | 0, vr = vr + Math.imul(Vr, vi) | 0, Te = Te + Math.imul(Vr, xi) | 0, Te = Te + Math.imul(qr, vi) | 0, Cr = Cr + Math.imul(qr, xi) | 0, vr = vr + Math.imul(mn, dn) | 0, Te = Te + Math.imul(mn, xn) | 0, Te = Te + Math.imul(pi, dn) | 0, Cr = Cr + Math.imul(pi, xn) | 0;
      var we = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
      Or = (Cr + (Te >>> 13) | 0) + (we >>> 26) | 0, we &= 67108863, vr = Math.imul(Hi, rs), Te = Math.imul(Hi, ls), Te = Te + Math.imul(di, rs) | 0, Cr = Math.imul(di, ls), vr = vr + Math.imul(hn, os) | 0, Te = Te + Math.imul(hn, fs) | 0, Te = Te + Math.imul(Rn, os) | 0, Cr = Cr + Math.imul(Rn, fs) | 0, vr = vr + Math.imul(gn, Bn) | 0, Te = Te + Math.imul(gn, hi) | 0, Te = Te + Math.imul(Gn, Bn) | 0, Cr = Cr + Math.imul(Gn, hi) | 0, vr = vr + Math.imul(On, Gi) | 0, Te = Te + Math.imul(On, kn) | 0, Te = Te + Math.imul(so, Gi) | 0, Cr = Cr + Math.imul(so, kn) | 0, vr = vr + Math.imul(Er, eo) | 0, Te = Te + Math.imul(Er, Ei) | 0, Te = Te + Math.imul(Di, eo) | 0, Cr = Cr + Math.imul(Di, Ei) | 0, vr = vr + Math.imul(Wr, vi) | 0, Te = Te + Math.imul(Wr, xi) | 0, Te = Te + Math.imul(ri, vi) | 0, Cr = Cr + Math.imul(ri, xi) | 0, vr = vr + Math.imul(Vr, dn) | 0, Te = Te + Math.imul(Vr, xn) | 0, Te = Te + Math.imul(qr, dn) | 0, Cr = Cr + Math.imul(qr, xn) | 0;
      var Be = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
      Or = (Cr + (Te >>> 13) | 0) + (Be >>> 26) | 0, Be &= 67108863, vr = Math.imul(Hi, os), Te = Math.imul(Hi, fs), Te = Te + Math.imul(di, os) | 0, Cr = Math.imul(di, fs), vr = vr + Math.imul(hn, Bn) | 0, Te = Te + Math.imul(hn, hi) | 0, Te = Te + Math.imul(Rn, Bn) | 0, Cr = Cr + Math.imul(Rn, hi) | 0, vr = vr + Math.imul(gn, Gi) | 0, Te = Te + Math.imul(gn, kn) | 0, Te = Te + Math.imul(Gn, Gi) | 0, Cr = Cr + Math.imul(Gn, kn) | 0, vr = vr + Math.imul(On, eo) | 0, Te = Te + Math.imul(On, Ei) | 0, Te = Te + Math.imul(so, eo) | 0, Cr = Cr + Math.imul(so, Ei) | 0, vr = vr + Math.imul(Er, vi) | 0, Te = Te + Math.imul(Er, xi) | 0, Te = Te + Math.imul(Di, vi) | 0, Cr = Cr + Math.imul(Di, xi) | 0, vr = vr + Math.imul(Wr, dn) | 0, Te = Te + Math.imul(Wr, xn) | 0, Te = Te + Math.imul(ri, dn) | 0, Cr = Cr + Math.imul(ri, xn) | 0;
      var Me = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
      Or = (Cr + (Te >>> 13) | 0) + (Me >>> 26) | 0, Me &= 67108863, vr = Math.imul(Hi, Bn), Te = Math.imul(Hi, hi), Te = Te + Math.imul(di, Bn) | 0, Cr = Math.imul(di, hi), vr = vr + Math.imul(hn, Gi) | 0, Te = Te + Math.imul(hn, kn) | 0, Te = Te + Math.imul(Rn, Gi) | 0, Cr = Cr + Math.imul(Rn, kn) | 0, vr = vr + Math.imul(gn, eo) | 0, Te = Te + Math.imul(gn, Ei) | 0, Te = Te + Math.imul(Gn, eo) | 0, Cr = Cr + Math.imul(Gn, Ei) | 0, vr = vr + Math.imul(On, vi) | 0, Te = Te + Math.imul(On, xi) | 0, Te = Te + Math.imul(so, vi) | 0, Cr = Cr + Math.imul(so, xi) | 0, vr = vr + Math.imul(Er, dn) | 0, Te = Te + Math.imul(Er, xn) | 0, Te = Te + Math.imul(Di, dn) | 0, Cr = Cr + Math.imul(Di, xn) | 0;
      var fr = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
      Or = (Cr + (Te >>> 13) | 0) + (fr >>> 26) | 0, fr &= 67108863, vr = Math.imul(Hi, Gi), Te = Math.imul(Hi, kn), Te = Te + Math.imul(di, Gi) | 0, Cr = Math.imul(di, kn), vr = vr + Math.imul(hn, eo) | 0, Te = Te + Math.imul(hn, Ei) | 0, Te = Te + Math.imul(Rn, eo) | 0, Cr = Cr + Math.imul(Rn, Ei) | 0, vr = vr + Math.imul(gn, vi) | 0, Te = Te + Math.imul(gn, xi) | 0, Te = Te + Math.imul(Gn, vi) | 0, Cr = Cr + Math.imul(Gn, xi) | 0, vr = vr + Math.imul(On, dn) | 0, Te = Te + Math.imul(On, xn) | 0, Te = Te + Math.imul(so, dn) | 0, Cr = Cr + Math.imul(so, xn) | 0;
      var wr = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
      Or = (Cr + (Te >>> 13) | 0) + (wr >>> 26) | 0, wr &= 67108863, vr = Math.imul(Hi, eo), Te = Math.imul(Hi, Ei), Te = Te + Math.imul(di, eo) | 0, Cr = Math.imul(di, Ei), vr = vr + Math.imul(hn, vi) | 0, Te = Te + Math.imul(hn, xi) | 0, Te = Te + Math.imul(Rn, vi) | 0, Cr = Cr + Math.imul(Rn, xi) | 0, vr = vr + Math.imul(gn, dn) | 0, Te = Te + Math.imul(gn, xn) | 0, Te = Te + Math.imul(Gn, dn) | 0, Cr = Cr + Math.imul(Gn, xn) | 0;
      var dr = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
      Or = (Cr + (Te >>> 13) | 0) + (dr >>> 26) | 0, dr &= 67108863, vr = Math.imul(Hi, vi), Te = Math.imul(Hi, xi), Te = Te + Math.imul(di, vi) | 0, Cr = Math.imul(di, xi), vr = vr + Math.imul(hn, dn) | 0, Te = Te + Math.imul(hn, xn) | 0, Te = Te + Math.imul(Rn, dn) | 0, Cr = Cr + Math.imul(Rn, xn) | 0;
      var Dr = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
      Or = (Cr + (Te >>> 13) | 0) + (Dr >>> 26) | 0, Dr &= 67108863, vr = Math.imul(Hi, dn), Te = Math.imul(Hi, xn), Te = Te + Math.imul(di, dn) | 0, Cr = Math.imul(di, xn);
      var Rr = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
      return Or = (Cr + (Te >>> 13) | 0) + (Rr >>> 26) | 0, Rr &= 67108863, _r[0] = oi, _r[1] = Yr, _r[2] = ji, _r[3] = Cn, _r[4] = Mn, _r[5] = B, _r[6] = o, _r[7] = m, _r[8] = d, _r[9] = v, _r[10] = he, _r[11] = we, _r[12] = Be, _r[13] = Me, _r[14] = fr, _r[15] = wr, _r[16] = dr, _r[17] = Dr, _r[18] = Rr, Or !== 0 && (_r[19] = Or, rr.length++), rr;
    };
    Math.imul || (Pe = He);
    function nr(er, Ie, xe) {
      xe.negative = Ie.negative ^ er.negative, xe.length = er.length + Ie.length;
      for (var rr = 0, ar = 0, yr = 0; yr < xe.length - 1; yr++) {
        var _r = ar;
        ar = 0;
        for (var Or = rr & 67108863, vr = Math.min(yr, Ie.length - 1), Te = Math.max(0, yr - er.length + 1); Te <= vr; Te++) {
          var Cr = yr - Te, Hr = er.words[Cr] | 0, si = Ie.words[Te] | 0, ui = Hr * si, Li = ui & 67108863;
          _r = _r + (ui / 67108864 | 0) | 0, Li = Li + Or | 0, Or = Li & 67108863, _r = _r + (Li >>> 26) | 0, ar += _r >>> 26, _r &= 67108863;
        }
        xe.words[yr] = Or, rr = _r, _r = ar;
      }
      return rr !== 0 ? xe.words[yr] = rr : xe.length--, xe.strip();
    }
    function ir(er, Ie, xe) {
      var rr = new or();
      return rr.mulp(er, Ie, xe);
    }
    A.prototype.mulTo = function(Ie, xe) {
      var rr, ar = this.length + Ie.length;
      return this.length === 10 && Ie.length === 10 ? rr = Pe(this, Ie, xe) : ar < 63 ? rr = He(this, Ie, xe) : ar < 1024 ? rr = nr(this, Ie, xe) : rr = ir(this, Ie, xe), rr;
    };
    function or(er, Ie) {
      this.x = er, this.y = Ie;
    }
    or.prototype.makeRBT = function(Ie) {
      for (var xe = new Array(Ie), rr = A.prototype._countBits(Ie) - 1, ar = 0; ar < Ie; ar++)
        xe[ar] = this.revBin(ar, rr, Ie);
      return xe;
    }, or.prototype.revBin = function(Ie, xe, rr) {
      if (Ie === 0 || Ie === rr - 1) return Ie;
      for (var ar = 0, yr = 0; yr < xe; yr++)
        ar |= (Ie & 1) << xe - yr - 1, Ie >>= 1;
      return ar;
    }, or.prototype.permute = function(Ie, xe, rr, ar, yr, _r) {
      for (var Or = 0; Or < _r; Or++)
        ar[Or] = xe[Ie[Or]], yr[Or] = rr[Ie[Or]];
    }, or.prototype.transform = function(Ie, xe, rr, ar, yr, _r) {
      this.permute(_r, Ie, xe, rr, ar, yr);
      for (var Or = 1; Or < yr; Or <<= 1)
        for (var vr = Or << 1, Te = Math.cos(2 * Math.PI / vr), Cr = Math.sin(2 * Math.PI / vr), Hr = 0; Hr < yr; Hr += vr)
          for (var si = Te, ui = Cr, Li = 0; Li < Or; Li++) {
            var Qi = rr[Hr + Li], wi = ar[Hr + Li], Ji = rr[Hr + Li + Or], mn = ar[Hr + Li + Or], pi = si * Ji - ui * mn;
            mn = si * mn + ui * Ji, Ji = pi, rr[Hr + Li] = Qi + Ji, ar[Hr + Li] = wi + mn, rr[Hr + Li + Or] = Qi - Ji, ar[Hr + Li + Or] = wi - mn, Li !== vr && (pi = Te * si - Cr * ui, ui = Te * ui + Cr * si, si = pi);
          }
    }, or.prototype.guessLen13b = function(Ie, xe) {
      var rr = Math.max(xe, Ie) | 1, ar = rr & 1, yr = 0;
      for (rr = rr / 2 | 0; rr; rr = rr >>> 1)
        yr++;
      return 1 << yr + 1 + ar;
    }, or.prototype.conjugate = function(Ie, xe, rr) {
      if (!(rr <= 1))
        for (var ar = 0; ar < rr / 2; ar++) {
          var yr = Ie[ar];
          Ie[ar] = Ie[rr - ar - 1], Ie[rr - ar - 1] = yr, yr = xe[ar], xe[ar] = -xe[rr - ar - 1], xe[rr - ar - 1] = -yr;
        }
    }, or.prototype.normalize13b = function(Ie, xe) {
      for (var rr = 0, ar = 0; ar < xe / 2; ar++) {
        var yr = Math.round(Ie[2 * ar + 1] / xe) * 8192 + Math.round(Ie[2 * ar] / xe) + rr;
        Ie[ar] = yr & 67108863, yr < 67108864 ? rr = 0 : rr = yr / 67108864 | 0;
      }
      return Ie;
    }, or.prototype.convert13b = function(Ie, xe, rr, ar) {
      for (var yr = 0, _r = 0; _r < xe; _r++)
        yr = yr + (Ie[_r] | 0), rr[2 * _r] = yr & 8191, yr = yr >>> 13, rr[2 * _r + 1] = yr & 8191, yr = yr >>> 13;
      for (_r = 2 * xe; _r < ar; ++_r)
        rr[_r] = 0;
      p(yr === 0), p((yr & -8192) === 0);
    }, or.prototype.stub = function(Ie) {
      for (var xe = new Array(Ie), rr = 0; rr < Ie; rr++)
        xe[rr] = 0;
      return xe;
    }, or.prototype.mulp = function(Ie, xe, rr) {
      var ar = 2 * this.guessLen13b(Ie.length, xe.length), yr = this.makeRBT(ar), _r = this.stub(ar), Or = new Array(ar), vr = new Array(ar), Te = new Array(ar), Cr = new Array(ar), Hr = new Array(ar), si = new Array(ar), ui = rr.words;
      ui.length = ar, this.convert13b(Ie.words, Ie.length, Or, ar), this.convert13b(xe.words, xe.length, Cr, ar), this.transform(Or, _r, vr, Te, ar, yr), this.transform(Cr, _r, Hr, si, ar, yr);
      for (var Li = 0; Li < ar; Li++) {
        var Qi = vr[Li] * Hr[Li] - Te[Li] * si[Li];
        Te[Li] = vr[Li] * si[Li] + Te[Li] * Hr[Li], vr[Li] = Qi;
      }
      return this.conjugate(vr, Te, ar), this.transform(vr, Te, ui, _r, ar, yr), this.conjugate(ui, _r, ar), this.normalize13b(ui, ar), rr.negative = Ie.negative ^ xe.negative, rr.length = Ie.length + xe.length, rr.strip();
    }, A.prototype.mul = function(Ie) {
      var xe = new A(null);
      return xe.words = new Array(this.length + Ie.length), this.mulTo(Ie, xe);
    }, A.prototype.mulf = function(Ie) {
      var xe = new A(null);
      return xe.words = new Array(this.length + Ie.length), ir(this, Ie, xe);
    }, A.prototype.imul = function(Ie) {
      return this.clone().mulTo(Ie, this);
    }, A.prototype.imuln = function(Ie) {
      p(typeof Ie == "number"), p(Ie < 67108864);
      for (var xe = 0, rr = 0; rr < this.length; rr++) {
        var ar = (this.words[rr] | 0) * Ie, yr = (ar & 67108863) + (xe & 67108863);
        xe >>= 26, xe += ar / 67108864 | 0, xe += yr >>> 26, this.words[rr] = yr & 67108863;
      }
      return xe !== 0 && (this.words[rr] = xe, this.length++), this;
    }, A.prototype.muln = function(Ie) {
      return this.clone().imuln(Ie);
    }, A.prototype.sqr = function() {
      return this.mul(this);
    }, A.prototype.isqr = function() {
      return this.imul(this.clone());
    }, A.prototype.pow = function(Ie) {
      var xe = be(Ie);
      if (xe.length === 0) return new A(1);
      for (var rr = this, ar = 0; ar < xe.length && xe[ar] === 0; ar++, rr = rr.sqr())
        ;
      if (++ar < xe.length)
        for (var yr = rr.sqr(); ar < xe.length; ar++, yr = yr.sqr())
          xe[ar] !== 0 && (rr = rr.mul(yr));
      return rr;
    }, A.prototype.iushln = function(Ie) {
      p(typeof Ie == "number" && Ie >= 0);
      var xe = Ie % 26, rr = (Ie - xe) / 26, ar = 67108863 >>> 26 - xe << 26 - xe, yr;
      if (xe !== 0) {
        var _r = 0;
        for (yr = 0; yr < this.length; yr++) {
          var Or = this.words[yr] & ar, vr = (this.words[yr] | 0) - Or << xe;
          this.words[yr] = vr | _r, _r = Or >>> 26 - xe;
        }
        _r && (this.words[yr] = _r, this.length++);
      }
      if (rr !== 0) {
        for (yr = this.length - 1; yr >= 0; yr--)
          this.words[yr + rr] = this.words[yr];
        for (yr = 0; yr < rr; yr++)
          this.words[yr] = 0;
        this.length += rr;
      }
      return this.strip();
    }, A.prototype.ishln = function(Ie) {
      return p(this.negative === 0), this.iushln(Ie);
    }, A.prototype.iushrn = function(Ie, xe, rr) {
      p(typeof Ie == "number" && Ie >= 0);
      var ar;
      xe ? ar = (xe - xe % 26) / 26 : ar = 0;
      var yr = Ie % 26, _r = Math.min((Ie - yr) / 26, this.length), Or = 67108863 ^ 67108863 >>> yr << yr, vr = rr;
      if (ar -= _r, ar = Math.max(0, ar), vr) {
        for (var Te = 0; Te < _r; Te++)
          vr.words[Te] = this.words[Te];
        vr.length = _r;
      }
      if (_r !== 0) if (this.length > _r)
        for (this.length -= _r, Te = 0; Te < this.length; Te++)
          this.words[Te] = this.words[Te + _r];
      else
        this.words[0] = 0, this.length = 1;
      var Cr = 0;
      for (Te = this.length - 1; Te >= 0 && (Cr !== 0 || Te >= ar); Te--) {
        var Hr = this.words[Te] | 0;
        this.words[Te] = Cr << 26 - yr | Hr >>> yr, Cr = Hr & Or;
      }
      return vr && Cr !== 0 && (vr.words[vr.length++] = Cr), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
    }, A.prototype.ishrn = function(Ie, xe, rr) {
      return p(this.negative === 0), this.iushrn(Ie, xe, rr);
    }, A.prototype.shln = function(Ie) {
      return this.clone().ishln(Ie);
    }, A.prototype.ushln = function(Ie) {
      return this.clone().iushln(Ie);
    }, A.prototype.shrn = function(Ie) {
      return this.clone().ishrn(Ie);
    }, A.prototype.ushrn = function(Ie) {
      return this.clone().iushrn(Ie);
    }, A.prototype.testn = function(Ie) {
      p(typeof Ie == "number" && Ie >= 0);
      var xe = Ie % 26, rr = (Ie - xe) / 26, ar = 1 << xe;
      if (this.length <= rr) return !1;
      var yr = this.words[rr];
      return !!(yr & ar);
    }, A.prototype.imaskn = function(Ie) {
      p(typeof Ie == "number" && Ie >= 0);
      var xe = Ie % 26, rr = (Ie - xe) / 26;
      if (p(this.negative === 0, "imaskn works only with positive numbers"), this.length <= rr)
        return this;
      if (xe !== 0 && rr++, this.length = Math.min(rr, this.length), xe !== 0) {
        var ar = 67108863 ^ 67108863 >>> xe << xe;
        this.words[this.length - 1] &= ar;
      }
      return this.strip();
    }, A.prototype.maskn = function(Ie) {
      return this.clone().imaskn(Ie);
    }, A.prototype.iaddn = function(Ie) {
      return p(typeof Ie == "number"), p(Ie < 67108864), Ie < 0 ? this.isubn(-Ie) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < Ie ? (this.words[0] = Ie - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(Ie), this.negative = 1, this) : this._iaddn(Ie);
    }, A.prototype._iaddn = function(Ie) {
      this.words[0] += Ie;
      for (var xe = 0; xe < this.length && this.words[xe] >= 67108864; xe++)
        this.words[xe] -= 67108864, xe === this.length - 1 ? this.words[xe + 1] = 1 : this.words[xe + 1]++;
      return this.length = Math.max(this.length, xe + 1), this;
    }, A.prototype.isubn = function(Ie) {
      if (p(typeof Ie == "number"), p(Ie < 67108864), Ie < 0) return this.iaddn(-Ie);
      if (this.negative !== 0)
        return this.negative = 0, this.iaddn(Ie), this.negative = 1, this;
      if (this.words[0] -= Ie, this.length === 1 && this.words[0] < 0)
        this.words[0] = -this.words[0], this.negative = 1;
      else
        for (var xe = 0; xe < this.length && this.words[xe] < 0; xe++)
          this.words[xe] += 67108864, this.words[xe + 1] -= 1;
      return this.strip();
    }, A.prototype.addn = function(Ie) {
      return this.clone().iaddn(Ie);
    }, A.prototype.subn = function(Ie) {
      return this.clone().isubn(Ie);
    }, A.prototype.iabs = function() {
      return this.negative = 0, this;
    }, A.prototype.abs = function() {
      return this.clone().iabs();
    }, A.prototype._ishlnsubmul = function(Ie, xe, rr) {
      var ar = Ie.length + rr, yr;
      this._expand(ar);
      var _r, Or = 0;
      for (yr = 0; yr < Ie.length; yr++) {
        _r = (this.words[yr + rr] | 0) + Or;
        var vr = (Ie.words[yr] | 0) * xe;
        _r -= vr & 67108863, Or = (_r >> 26) - (vr / 67108864 | 0), this.words[yr + rr] = _r & 67108863;
      }
      for (; yr < this.length - rr; yr++)
        _r = (this.words[yr + rr] | 0) + Or, Or = _r >> 26, this.words[yr + rr] = _r & 67108863;
      if (Or === 0) return this.strip();
      for (p(Or === -1), Or = 0, yr = 0; yr < this.length; yr++)
        _r = -(this.words[yr] | 0) + Or, Or = _r >> 26, this.words[yr] = _r & 67108863;
      return this.negative = 1, this.strip();
    }, A.prototype._wordDiv = function(Ie, xe) {
      var rr = this.length - Ie.length, ar = this.clone(), yr = Ie, _r = yr.words[yr.length - 1] | 0, Or = this._countBits(_r);
      rr = 26 - Or, rr !== 0 && (yr = yr.ushln(rr), ar.iushln(rr), _r = yr.words[yr.length - 1] | 0);
      var vr = ar.length - yr.length, Te;
      if (xe !== "mod") {
        Te = new A(null), Te.length = vr + 1, Te.words = new Array(Te.length);
        for (var Cr = 0; Cr < Te.length; Cr++)
          Te.words[Cr] = 0;
      }
      var Hr = ar.clone()._ishlnsubmul(yr, 1, vr);
      Hr.negative === 0 && (ar = Hr, Te && (Te.words[vr] = 1));
      for (var si = vr - 1; si >= 0; si--) {
        var ui = (ar.words[yr.length + si] | 0) * 67108864 + (ar.words[yr.length + si - 1] | 0);
        for (ui = Math.min(ui / _r | 0, 67108863), ar._ishlnsubmul(yr, ui, si); ar.negative !== 0; )
          ui--, ar.negative = 0, ar._ishlnsubmul(yr, 1, si), ar.isZero() || (ar.negative ^= 1);
        Te && (Te.words[si] = ui);
      }
      return Te && Te.strip(), ar.strip(), xe !== "div" && rr !== 0 && ar.iushrn(rr), {
        div: Te || null,
        mod: ar
      };
    }, A.prototype.divmod = function(Ie, xe, rr) {
      if (p(!Ie.isZero()), this.isZero())
        return {
          div: new A(0),
          mod: new A(0)
        };
      var ar, yr, _r;
      return this.negative !== 0 && Ie.negative === 0 ? (_r = this.neg().divmod(Ie, xe), xe !== "mod" && (ar = _r.div.neg()), xe !== "div" && (yr = _r.mod.neg(), rr && yr.negative !== 0 && yr.iadd(Ie)), {
        div: ar,
        mod: yr
      }) : this.negative === 0 && Ie.negative !== 0 ? (_r = this.divmod(Ie.neg(), xe), xe !== "mod" && (ar = _r.div.neg()), {
        div: ar,
        mod: _r.mod
      }) : this.negative & Ie.negative ? (_r = this.neg().divmod(Ie.neg(), xe), xe !== "div" && (yr = _r.mod.neg(), rr && yr.negative !== 0 && yr.isub(Ie)), {
        div: _r.div,
        mod: yr
      }) : Ie.length > this.length || this.cmp(Ie) < 0 ? {
        div: new A(0),
        mod: this
      } : Ie.length === 1 ? xe === "div" ? {
        div: this.divn(Ie.words[0]),
        mod: null
      } : xe === "mod" ? {
        div: null,
        mod: new A(this.modn(Ie.words[0]))
      } : {
        div: this.divn(Ie.words[0]),
        mod: new A(this.modn(Ie.words[0]))
      } : this._wordDiv(Ie, xe);
    }, A.prototype.div = function(Ie) {
      return this.divmod(Ie, "div", !1).div;
    }, A.prototype.mod = function(Ie) {
      return this.divmod(Ie, "mod", !1).mod;
    }, A.prototype.umod = function(Ie) {
      return this.divmod(Ie, "mod", !0).mod;
    }, A.prototype.divRound = function(Ie) {
      var xe = this.divmod(Ie);
      if (xe.mod.isZero()) return xe.div;
      var rr = xe.div.negative !== 0 ? xe.mod.isub(Ie) : xe.mod, ar = Ie.ushrn(1), yr = Ie.andln(1), _r = rr.cmp(ar);
      return _r < 0 || yr === 1 && _r === 0 ? xe.div : xe.div.negative !== 0 ? xe.div.isubn(1) : xe.div.iaddn(1);
    }, A.prototype.modn = function(Ie) {
      p(Ie <= 67108863);
      for (var xe = (1 << 26) % Ie, rr = 0, ar = this.length - 1; ar >= 0; ar--)
        rr = (xe * rr + (this.words[ar] | 0)) % Ie;
      return rr;
    }, A.prototype.idivn = function(Ie) {
      p(Ie <= 67108863);
      for (var xe = 0, rr = this.length - 1; rr >= 0; rr--) {
        var ar = (this.words[rr] | 0) + xe * 67108864;
        this.words[rr] = ar / Ie | 0, xe = ar % Ie;
      }
      return this.strip();
    }, A.prototype.divn = function(Ie) {
      return this.clone().idivn(Ie);
    }, A.prototype.egcd = function(Ie) {
      p(Ie.negative === 0), p(!Ie.isZero());
      var xe = this, rr = Ie.clone();
      xe.negative !== 0 ? xe = xe.umod(Ie) : xe = xe.clone();
      for (var ar = new A(1), yr = new A(0), _r = new A(0), Or = new A(1), vr = 0; xe.isEven() && rr.isEven(); )
        xe.iushrn(1), rr.iushrn(1), ++vr;
      for (var Te = rr.clone(), Cr = xe.clone(); !xe.isZero(); ) {
        for (var Hr = 0, si = 1; !(xe.words[0] & si) && Hr < 26; ++Hr, si <<= 1) ;
        if (Hr > 0)
          for (xe.iushrn(Hr); Hr-- > 0; )
            (ar.isOdd() || yr.isOdd()) && (ar.iadd(Te), yr.isub(Cr)), ar.iushrn(1), yr.iushrn(1);
        for (var ui = 0, Li = 1; !(rr.words[0] & Li) && ui < 26; ++ui, Li <<= 1) ;
        if (ui > 0)
          for (rr.iushrn(ui); ui-- > 0; )
            (_r.isOdd() || Or.isOdd()) && (_r.iadd(Te), Or.isub(Cr)), _r.iushrn(1), Or.iushrn(1);
        xe.cmp(rr) >= 0 ? (xe.isub(rr), ar.isub(_r), yr.isub(Or)) : (rr.isub(xe), _r.isub(ar), Or.isub(yr));
      }
      return {
        a: _r,
        b: Or,
        gcd: rr.iushln(vr)
      };
    }, A.prototype._invmp = function(Ie) {
      p(Ie.negative === 0), p(!Ie.isZero());
      var xe = this, rr = Ie.clone();
      xe.negative !== 0 ? xe = xe.umod(Ie) : xe = xe.clone();
      for (var ar = new A(1), yr = new A(0), _r = rr.clone(); xe.cmpn(1) > 0 && rr.cmpn(1) > 0; ) {
        for (var Or = 0, vr = 1; !(xe.words[0] & vr) && Or < 26; ++Or, vr <<= 1) ;
        if (Or > 0)
          for (xe.iushrn(Or); Or-- > 0; )
            ar.isOdd() && ar.iadd(_r), ar.iushrn(1);
        for (var Te = 0, Cr = 1; !(rr.words[0] & Cr) && Te < 26; ++Te, Cr <<= 1) ;
        if (Te > 0)
          for (rr.iushrn(Te); Te-- > 0; )
            yr.isOdd() && yr.iadd(_r), yr.iushrn(1);
        xe.cmp(rr) >= 0 ? (xe.isub(rr), ar.isub(yr)) : (rr.isub(xe), yr.isub(ar));
      }
      var Hr;
      return xe.cmpn(1) === 0 ? Hr = ar : Hr = yr, Hr.cmpn(0) < 0 && Hr.iadd(Ie), Hr;
    }, A.prototype.gcd = function(Ie) {
      if (this.isZero()) return Ie.abs();
      if (Ie.isZero()) return this.abs();
      var xe = this.clone(), rr = Ie.clone();
      xe.negative = 0, rr.negative = 0;
      for (var ar = 0; xe.isEven() && rr.isEven(); ar++)
        xe.iushrn(1), rr.iushrn(1);
      do {
        for (; xe.isEven(); )
          xe.iushrn(1);
        for (; rr.isEven(); )
          rr.iushrn(1);
        var yr = xe.cmp(rr);
        if (yr < 0) {
          var _r = xe;
          xe = rr, rr = _r;
        } else if (yr === 0 || rr.cmpn(1) === 0)
          break;
        xe.isub(rr);
      } while (!0);
      return rr.iushln(ar);
    }, A.prototype.invm = function(Ie) {
      return this.egcd(Ie).a.umod(Ie);
    }, A.prototype.isEven = function() {
      return (this.words[0] & 1) === 0;
    }, A.prototype.isOdd = function() {
      return (this.words[0] & 1) === 1;
    }, A.prototype.andln = function(Ie) {
      return this.words[0] & Ie;
    }, A.prototype.bincn = function(Ie) {
      p(typeof Ie == "number");
      var xe = Ie % 26, rr = (Ie - xe) / 26, ar = 1 << xe;
      if (this.length <= rr)
        return this._expand(rr + 1), this.words[rr] |= ar, this;
      for (var yr = ar, _r = rr; yr !== 0 && _r < this.length; _r++) {
        var Or = this.words[_r] | 0;
        Or += yr, yr = Or >>> 26, Or &= 67108863, this.words[_r] = Or;
      }
      return yr !== 0 && (this.words[_r] = yr, this.length++), this;
    }, A.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, A.prototype.cmpn = function(Ie) {
      var xe = Ie < 0;
      if (this.negative !== 0 && !xe) return -1;
      if (this.negative === 0 && xe) return 1;
      this.strip();
      var rr;
      if (this.length > 1)
        rr = 1;
      else {
        xe && (Ie = -Ie), p(Ie <= 67108863, "Number is too big");
        var ar = this.words[0] | 0;
        rr = ar === Ie ? 0 : ar < Ie ? -1 : 1;
      }
      return this.negative !== 0 ? -rr | 0 : rr;
    }, A.prototype.cmp = function(Ie) {
      if (this.negative !== 0 && Ie.negative === 0) return -1;
      if (this.negative === 0 && Ie.negative !== 0) return 1;
      var xe = this.ucmp(Ie);
      return this.negative !== 0 ? -xe | 0 : xe;
    }, A.prototype.ucmp = function(Ie) {
      if (this.length > Ie.length) return 1;
      if (this.length < Ie.length) return -1;
      for (var xe = 0, rr = this.length - 1; rr >= 0; rr--) {
        var ar = this.words[rr] | 0, yr = Ie.words[rr] | 0;
        if (ar !== yr) {
          ar < yr ? xe = -1 : ar > yr && (xe = 1);
          break;
        }
      }
      return xe;
    }, A.prototype.gtn = function(Ie) {
      return this.cmpn(Ie) === 1;
    }, A.prototype.gt = function(Ie) {
      return this.cmp(Ie) === 1;
    }, A.prototype.gten = function(Ie) {
      return this.cmpn(Ie) >= 0;
    }, A.prototype.gte = function(Ie) {
      return this.cmp(Ie) >= 0;
    }, A.prototype.ltn = function(Ie) {
      return this.cmpn(Ie) === -1;
    }, A.prototype.lt = function(Ie) {
      return this.cmp(Ie) === -1;
    }, A.prototype.lten = function(Ie) {
      return this.cmpn(Ie) <= 0;
    }, A.prototype.lte = function(Ie) {
      return this.cmp(Ie) <= 0;
    }, A.prototype.eqn = function(Ie) {
      return this.cmpn(Ie) === 0;
    }, A.prototype.eq = function(Ie) {
      return this.cmp(Ie) === 0;
    }, A.red = function(Ie) {
      return new Fe(Ie);
    }, A.prototype.toRed = function(Ie) {
      return p(!this.red, "Already a number in reduction context"), p(this.negative === 0, "red works only with positives"), Ie.convertTo(this)._forceRed(Ie);
    }, A.prototype.fromRed = function() {
      return p(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, A.prototype._forceRed = function(Ie) {
      return this.red = Ie, this;
    }, A.prototype.forceRed = function(Ie) {
      return p(!this.red, "Already a number in reduction context"), this._forceRed(Ie);
    }, A.prototype.redAdd = function(Ie) {
      return p(this.red, "redAdd works only with red numbers"), this.red.add(this, Ie);
    }, A.prototype.redIAdd = function(Ie) {
      return p(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, Ie);
    }, A.prototype.redSub = function(Ie) {
      return p(this.red, "redSub works only with red numbers"), this.red.sub(this, Ie);
    }, A.prototype.redISub = function(Ie) {
      return p(this.red, "redISub works only with red numbers"), this.red.isub(this, Ie);
    }, A.prototype.redShl = function(Ie) {
      return p(this.red, "redShl works only with red numbers"), this.red.shl(this, Ie);
    }, A.prototype.redMul = function(Ie) {
      return p(this.red, "redMul works only with red numbers"), this.red._verify2(this, Ie), this.red.mul(this, Ie);
    }, A.prototype.redIMul = function(Ie) {
      return p(this.red, "redMul works only with red numbers"), this.red._verify2(this, Ie), this.red.imul(this, Ie);
    }, A.prototype.redSqr = function() {
      return p(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, A.prototype.redISqr = function() {
      return p(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, A.prototype.redSqrt = function() {
      return p(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, A.prototype.redInvm = function() {
      return p(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, A.prototype.redNeg = function() {
      return p(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, A.prototype.redPow = function(Ie) {
      return p(this.red && !Ie.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, Ie);
    };
    var lr = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };
    function Ir(er, Ie) {
      this.name = er, this.p = new A(Ie, 16), this.n = this.p.bitLength(), this.k = new A(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    Ir.prototype._tmp = function() {
      var Ie = new A(null);
      return Ie.words = new Array(Math.ceil(this.n / 13)), Ie;
    }, Ir.prototype.ireduce = function(Ie) {
      var xe = Ie, rr;
      do
        this.split(xe, this.tmp), xe = this.imulK(xe), xe = xe.iadd(this.tmp), rr = xe.bitLength();
      while (rr > this.n);
      var ar = rr < this.n ? -1 : xe.ucmp(this.p);
      return ar === 0 ? (xe.words[0] = 0, xe.length = 1) : ar > 0 ? xe.isub(this.p) : xe.strip !== void 0 ? xe.strip() : xe._strip(), xe;
    }, Ir.prototype.split = function(Ie, xe) {
      Ie.iushrn(this.n, 0, xe);
    }, Ir.prototype.imulK = function(Ie) {
      return Ie.imul(this.k);
    };
    function xr() {
      Ir.call(
        this,
        "k256",
        "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
      );
    }
    a(xr, Ir), xr.prototype.split = function(Ie, xe) {
      for (var rr = 4194303, ar = Math.min(Ie.length, 9), yr = 0; yr < ar; yr++)
        xe.words[yr] = Ie.words[yr];
      if (xe.length = ar, Ie.length <= 9) {
        Ie.words[0] = 0, Ie.length = 1;
        return;
      }
      var _r = Ie.words[9];
      for (xe.words[xe.length++] = _r & rr, yr = 10; yr < Ie.length; yr++) {
        var Or = Ie.words[yr] | 0;
        Ie.words[yr - 10] = (Or & rr) << 4 | _r >>> 22, _r = Or;
      }
      _r >>>= 22, Ie.words[yr - 10] = _r, _r === 0 && Ie.length > 10 ? Ie.length -= 10 : Ie.length -= 9;
    }, xr.prototype.imulK = function(Ie) {
      Ie.words[Ie.length] = 0, Ie.words[Ie.length + 1] = 0, Ie.length += 2;
      for (var xe = 0, rr = 0; rr < Ie.length; rr++) {
        var ar = Ie.words[rr] | 0;
        xe += ar * 977, Ie.words[rr] = xe & 67108863, xe = ar * 64 + (xe / 67108864 | 0);
      }
      return Ie.words[Ie.length - 1] === 0 && (Ie.length--, Ie.words[Ie.length - 1] === 0 && Ie.length--), Ie;
    };
    function kr() {
      Ir.call(
        this,
        "p224",
        "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
      );
    }
    a(kr, Ir);
    function Ce() {
      Ir.call(
        this,
        "p192",
        "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
      );
    }
    a(Ce, Ir);
    function tr() {
      Ir.call(
        this,
        "25519",
        "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
      );
    }
    a(tr, Ir), tr.prototype.imulK = function(Ie) {
      for (var xe = 0, rr = 0; rr < Ie.length; rr++) {
        var ar = (Ie.words[rr] | 0) * 19 + xe, yr = ar & 67108863;
        ar >>>= 26, Ie.words[rr] = yr, xe = ar;
      }
      return xe !== 0 && (Ie.words[Ie.length++] = xe), Ie;
    }, A._prime = function(Ie) {
      if (lr[Ie]) return lr[Ie];
      var xe;
      if (Ie === "k256")
        xe = new xr();
      else if (Ie === "p224")
        xe = new kr();
      else if (Ie === "p192")
        xe = new Ce();
      else if (Ie === "p25519")
        xe = new tr();
      else
        throw new Error("Unknown prime " + Ie);
      return lr[Ie] = xe, xe;
    };
    function Fe(er) {
      if (typeof er == "string") {
        var Ie = A._prime(er);
        this.m = Ie.p, this.prime = Ie;
      } else
        p(er.gtn(1), "modulus must be greater than 1"), this.m = er, this.prime = null;
    }
    Fe.prototype._verify1 = function(Ie) {
      p(Ie.negative === 0, "red works only with positives"), p(Ie.red, "red works only with red numbers");
    }, Fe.prototype._verify2 = function(Ie, xe) {
      p((Ie.negative | xe.negative) === 0, "red works only with positives"), p(
        Ie.red && Ie.red === xe.red,
        "red works only with red numbers"
      );
    }, Fe.prototype.imod = function(Ie) {
      return this.prime ? this.prime.ireduce(Ie)._forceRed(this) : Ie.umod(this.m)._forceRed(this);
    }, Fe.prototype.neg = function(Ie) {
      return Ie.isZero() ? Ie.clone() : this.m.sub(Ie)._forceRed(this);
    }, Fe.prototype.add = function(Ie, xe) {
      this._verify2(Ie, xe);
      var rr = Ie.add(xe);
      return rr.cmp(this.m) >= 0 && rr.isub(this.m), rr._forceRed(this);
    }, Fe.prototype.iadd = function(Ie, xe) {
      this._verify2(Ie, xe);
      var rr = Ie.iadd(xe);
      return rr.cmp(this.m) >= 0 && rr.isub(this.m), rr;
    }, Fe.prototype.sub = function(Ie, xe) {
      this._verify2(Ie, xe);
      var rr = Ie.sub(xe);
      return rr.cmpn(0) < 0 && rr.iadd(this.m), rr._forceRed(this);
    }, Fe.prototype.isub = function(Ie, xe) {
      this._verify2(Ie, xe);
      var rr = Ie.isub(xe);
      return rr.cmpn(0) < 0 && rr.iadd(this.m), rr;
    }, Fe.prototype.shl = function(Ie, xe) {
      return this._verify1(Ie), this.imod(Ie.ushln(xe));
    }, Fe.prototype.imul = function(Ie, xe) {
      return this._verify2(Ie, xe), this.imod(Ie.imul(xe));
    }, Fe.prototype.mul = function(Ie, xe) {
      return this._verify2(Ie, xe), this.imod(Ie.mul(xe));
    }, Fe.prototype.isqr = function(Ie) {
      return this.imul(Ie, Ie.clone());
    }, Fe.prototype.sqr = function(Ie) {
      return this.mul(Ie, Ie);
    }, Fe.prototype.sqrt = function(Ie) {
      if (Ie.isZero()) return Ie.clone();
      var xe = this.m.andln(3);
      if (p(xe % 2 === 1), xe === 3) {
        var rr = this.m.add(new A(1)).iushrn(2);
        return this.pow(Ie, rr);
      }
      for (var ar = this.m.subn(1), yr = 0; !ar.isZero() && ar.andln(1) === 0; )
        yr++, ar.iushrn(1);
      p(!ar.isZero());
      var _r = new A(1).toRed(this), Or = _r.redNeg(), vr = this.m.subn(1).iushrn(1), Te = this.m.bitLength();
      for (Te = new A(2 * Te * Te).toRed(this); this.pow(Te, vr).cmp(Or) !== 0; )
        Te.redIAdd(Or);
      for (var Cr = this.pow(Te, ar), Hr = this.pow(Ie, ar.addn(1).iushrn(1)), si = this.pow(Ie, ar), ui = yr; si.cmp(_r) !== 0; ) {
        for (var Li = si, Qi = 0; Li.cmp(_r) !== 0; Qi++)
          Li = Li.redSqr();
        p(Qi < ui);
        var wi = this.pow(Cr, new A(1).iushln(ui - Qi - 1));
        Hr = Hr.redMul(wi), Cr = wi.redSqr(), si = si.redMul(Cr), ui = Qi;
      }
      return Hr;
    }, Fe.prototype.invm = function(Ie) {
      var xe = Ie._invmp(this.m);
      return xe.negative !== 0 ? (xe.negative = 0, this.imod(xe).redNeg()) : this.imod(xe);
    }, Fe.prototype.pow = function(Ie, xe) {
      if (xe.isZero()) return new A(1).toRed(this);
      if (xe.cmpn(1) === 0) return Ie.clone();
      var rr = 4, ar = new Array(1 << rr);
      ar[0] = new A(1).toRed(this), ar[1] = Ie;
      for (var yr = 2; yr < ar.length; yr++)
        ar[yr] = this.mul(ar[yr - 1], Ie);
      var _r = ar[0], Or = 0, vr = 0, Te = xe.bitLength() % 26;
      for (Te === 0 && (Te = 26), yr = xe.length - 1; yr >= 0; yr--) {
        for (var Cr = xe.words[yr], Hr = Te - 1; Hr >= 0; Hr--) {
          var si = Cr >> Hr & 1;
          if (_r !== ar[0] && (_r = this.sqr(_r)), si === 0 && Or === 0) {
            vr = 0;
            continue;
          }
          Or <<= 1, Or |= si, vr++, !(vr !== rr && (yr !== 0 || Hr !== 0)) && (_r = this.mul(_r, ar[Or]), vr = 0, Or = 0);
        }
        Te = 26;
      }
      return _r;
    }, Fe.prototype.convertTo = function(Ie) {
      var xe = Ie.umod(this.m);
      return xe === Ie ? xe.clone() : xe;
    }, Fe.prototype.convertFrom = function(Ie) {
      var xe = Ie.clone();
      return xe.red = null, xe;
    }, A.mont = function(Ie) {
      return new Sr(Ie);
    };
    function Sr(er) {
      Fe.call(this, er), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new A(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    a(Sr, Fe), Sr.prototype.convertTo = function(Ie) {
      return this.imod(Ie.ushln(this.shift));
    }, Sr.prototype.convertFrom = function(Ie) {
      var xe = this.imod(Ie.mul(this.rinv));
      return xe.red = null, xe;
    }, Sr.prototype.imul = function(Ie, xe) {
      if (Ie.isZero() || xe.isZero())
        return Ie.words[0] = 0, Ie.length = 1, Ie;
      var rr = Ie.imul(xe), ar = rr.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), yr = rr.isub(ar).iushrn(this.shift), _r = yr;
      return yr.cmp(this.m) >= 0 ? _r = yr.isub(this.m) : yr.cmpn(0) < 0 && (_r = yr.iadd(this.m)), _r._forceRed(this);
    }, Sr.prototype.mul = function(Ie, xe) {
      if (Ie.isZero() || xe.isZero()) return new A(0)._forceRed(this);
      var rr = Ie.mul(xe), ar = rr.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), yr = rr.isub(ar).iushrn(this.shift), _r = yr;
      return yr.cmp(this.m) >= 0 ? _r = yr.isub(this.m) : yr.cmpn(0) < 0 && (_r = yr.iadd(this.m)), _r._forceRed(this);
    }, Sr.prototype.invm = function(Ie) {
      var xe = this.imod(Ie._invmp(this.m).mul(this.r2));
      return xe._forceRed(this);
    };
  })(n, commonjsGlobal);
})(bn$3);
var bnExports = bn$3.exports, utils$B = {};
(function(n) {
  var c = n;
  function u(A, b) {
    if (Array.isArray(A))
      return A.slice();
    if (!A)
      return [];
    var F = [];
    if (typeof A != "string") {
      for (var le = 0; le < A.length; le++)
        F[le] = A[le] | 0;
      return F;
    }
    if (b === "hex") {
      A = A.replace(/[^a-z0-9]+/ig, ""), A.length % 2 !== 0 && (A = "0" + A);
      for (var le = 0; le < A.length; le += 2)
        F.push(parseInt(A[le] + A[le + 1], 16));
    } else
      for (var le = 0; le < A.length; le++) {
        var L = A.charCodeAt(le), pe = L >> 8, $ = L & 255;
        pe ? F.push(pe, $) : F.push($);
      }
    return F;
  }
  c.toArray = u;
  function p(A) {
    return A.length === 1 ? "0" + A : A;
  }
  c.zero2 = p;
  function a(A) {
    for (var b = "", F = 0; F < A.length; F++)
      b += p(A[F].toString(16));
    return b;
  }
  c.toHex = a, c.encode = function(b, F) {
    return F === "hex" ? a(b) : b;
  };
})(utils$B);
(function(n) {
  var c = n, u = bnExports, p = minimalisticAssert, a = utils$B;
  c.assert = p, c.toArray = a.toArray, c.zero2 = a.zero2, c.toHex = a.toHex, c.encode = a.encode;
  function A(pe, $, Ee) {
    var be = new Array(Math.max(pe.bitLength(), Ee) + 1), He;
    for (He = 0; He < be.length; He += 1)
      be[He] = 0;
    var Pe = 1 << $ + 1, nr = pe.clone();
    for (He = 0; He < be.length; He++) {
      var ir, or = nr.andln(Pe - 1);
      nr.isOdd() ? (or > (Pe >> 1) - 1 ? ir = (Pe >> 1) - or : ir = or, nr.isubn(ir)) : ir = 0, be[He] = ir, nr.iushrn(1);
    }
    return be;
  }
  c.getNAF = A;
  function b(pe, $) {
    var Ee = [
      [],
      []
    ];
    pe = pe.clone(), $ = $.clone();
    for (var be = 0, He = 0, Pe; pe.cmpn(-be) > 0 || $.cmpn(-He) > 0; ) {
      var nr = pe.andln(3) + be & 3, ir = $.andln(3) + He & 3;
      nr === 3 && (nr = -1), ir === 3 && (ir = -1);
      var or;
      nr & 1 ? (Pe = pe.andln(7) + be & 7, (Pe === 3 || Pe === 5) && ir === 2 ? or = -nr : or = nr) : or = 0, Ee[0].push(or);
      var lr;
      ir & 1 ? (Pe = $.andln(7) + He & 7, (Pe === 3 || Pe === 5) && nr === 2 ? lr = -ir : lr = ir) : lr = 0, Ee[1].push(lr), 2 * be === or + 1 && (be = 1 - be), 2 * He === lr + 1 && (He = 1 - He), pe.iushrn(1), $.iushrn(1);
    }
    return Ee;
  }
  c.getJSF = b;
  function F(pe, $, Ee) {
    var be = "_" + $;
    pe.prototype[$] = function() {
      return this[be] !== void 0 ? this[be] : this[be] = Ee.call(this);
    };
  }
  c.cachedProperty = F;
  function le(pe) {
    return typeof pe == "string" ? c.toArray(pe, "hex") : pe;
  }
  c.parseBytes = le;
  function L(pe) {
    return new u(pe, "hex", "le");
  }
  c.intFromLE = L;
})(utils$C);
var curve$1 = {}, BN$6 = bnExports, utils$A = utils$C, getNAF = utils$A.getNAF, getJSF = utils$A.getJSF, assert$r = utils$A.assert;
function BaseCurve(n, c) {
  this.type = n, this.p = new BN$6(c.p, 16), this.red = c.prime ? BN$6.red(c.prime) : BN$6.mont(this.p), this.zero = new BN$6(0).toRed(this.red), this.one = new BN$6(1).toRed(this.red), this.two = new BN$6(2).toRed(this.red), this.n = c.n && new BN$6(c.n, 16), this.g = c.g && this.pointFromJSON(c.g, c.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
  var u = this.n && this.p.div(this.n);
  !u || u.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
}
var base$d = BaseCurve;
BaseCurve.prototype.point = function() {
  throw new Error("Not implemented");
};
BaseCurve.prototype.validate = function() {
  throw new Error("Not implemented");
};
BaseCurve.prototype._fixedNafMul = function(c, u) {
  assert$r(c.precomputed);
  var p = c._getDoubles(), a = getNAF(u, 1, this._bitLength), A = (1 << p.step + 1) - (p.step % 2 === 0 ? 2 : 1);
  A /= 3;
  var b = [], F, le;
  for (F = 0; F < a.length; F += p.step) {
    le = 0;
    for (var L = F + p.step - 1; L >= F; L--)
      le = (le << 1) + a[L];
    b.push(le);
  }
  for (var pe = this.jpoint(null, null, null), $ = this.jpoint(null, null, null), Ee = A; Ee > 0; Ee--) {
    for (F = 0; F < b.length; F++)
      le = b[F], le === Ee ? $ = $.mixedAdd(p.points[F]) : le === -Ee && ($ = $.mixedAdd(p.points[F].neg()));
    pe = pe.add($);
  }
  return pe.toP();
};
BaseCurve.prototype._wnafMul = function(c, u) {
  var p = 4, a = c._getNAFPoints(p);
  p = a.wnd;
  for (var A = a.points, b = getNAF(u, p, this._bitLength), F = this.jpoint(null, null, null), le = b.length - 1; le >= 0; le--) {
    for (var L = 0; le >= 0 && b[le] === 0; le--)
      L++;
    if (le >= 0 && L++, F = F.dblp(L), le < 0)
      break;
    var pe = b[le];
    assert$r(pe !== 0), c.type === "affine" ? pe > 0 ? F = F.mixedAdd(A[pe - 1 >> 1]) : F = F.mixedAdd(A[-pe - 1 >> 1].neg()) : pe > 0 ? F = F.add(A[pe - 1 >> 1]) : F = F.add(A[-pe - 1 >> 1].neg());
  }
  return c.type === "affine" ? F.toP() : F;
};
BaseCurve.prototype._wnafMulAdd = function(c, u, p, a, A) {
  var b = this._wnafT1, F = this._wnafT2, le = this._wnafT3, L = 0, pe, $, Ee;
  for (pe = 0; pe < a; pe++) {
    Ee = u[pe];
    var be = Ee._getNAFPoints(c);
    b[pe] = be.wnd, F[pe] = be.points;
  }
  for (pe = a - 1; pe >= 1; pe -= 2) {
    var He = pe - 1, Pe = pe;
    if (b[He] !== 1 || b[Pe] !== 1) {
      le[He] = getNAF(p[He], b[He], this._bitLength), le[Pe] = getNAF(p[Pe], b[Pe], this._bitLength), L = Math.max(le[He].length, L), L = Math.max(le[Pe].length, L);
      continue;
    }
    var nr = [
      u[He],
      /* 1 */
      null,
      /* 3 */
      null,
      /* 5 */
      u[Pe]
      /* 7 */
    ];
    u[He].y.cmp(u[Pe].y) === 0 ? (nr[1] = u[He].add(u[Pe]), nr[2] = u[He].toJ().mixedAdd(u[Pe].neg())) : u[He].y.cmp(u[Pe].y.redNeg()) === 0 ? (nr[1] = u[He].toJ().mixedAdd(u[Pe]), nr[2] = u[He].add(u[Pe].neg())) : (nr[1] = u[He].toJ().mixedAdd(u[Pe]), nr[2] = u[He].toJ().mixedAdd(u[Pe].neg()));
    var ir = [
      -3,
      /* -1 -1 */
      -1,
      /* -1 0 */
      -5,
      /* -1 1 */
      -7,
      /* 0 -1 */
      0,
      /* 0 0 */
      7,
      /* 0 1 */
      5,
      /* 1 -1 */
      1,
      /* 1 0 */
      3
      /* 1 1 */
    ], or = getJSF(p[He], p[Pe]);
    for (L = Math.max(or[0].length, L), le[He] = new Array(L), le[Pe] = new Array(L), $ = 0; $ < L; $++) {
      var lr = or[0][$] | 0, Ir = or[1][$] | 0;
      le[He][$] = ir[(lr + 1) * 3 + (Ir + 1)], le[Pe][$] = 0, F[He] = nr;
    }
  }
  var xr = this.jpoint(null, null, null), kr = this._wnafT4;
  for (pe = L; pe >= 0; pe--) {
    for (var Ce = 0; pe >= 0; ) {
      var tr = !0;
      for ($ = 0; $ < a; $++)
        kr[$] = le[$][pe] | 0, kr[$] !== 0 && (tr = !1);
      if (!tr)
        break;
      Ce++, pe--;
    }
    if (pe >= 0 && Ce++, xr = xr.dblp(Ce), pe < 0)
      break;
    for ($ = 0; $ < a; $++) {
      var Fe = kr[$];
      Fe !== 0 && (Fe > 0 ? Ee = F[$][Fe - 1 >> 1] : Fe < 0 && (Ee = F[$][-Fe - 1 >> 1].neg()), Ee.type === "affine" ? xr = xr.mixedAdd(Ee) : xr = xr.add(Ee));
    }
  }
  for (pe = 0; pe < a; pe++)
    F[pe] = null;
  return A ? xr : xr.toP();
};
function BasePoint(n, c) {
  this.curve = n, this.type = c, this.precomputed = null;
}
BaseCurve.BasePoint = BasePoint;
BasePoint.prototype.eq = function() {
  throw new Error("Not implemented");
};
BasePoint.prototype.validate = function() {
  return this.curve.validate(this);
};
BaseCurve.prototype.decodePoint = function(c, u) {
  c = utils$A.toArray(c, u);
  var p = this.p.byteLength();
  if ((c[0] === 4 || c[0] === 6 || c[0] === 7) && c.length - 1 === 2 * p) {
    c[0] === 6 ? assert$r(c[c.length - 1] % 2 === 0) : c[0] === 7 && assert$r(c[c.length - 1] % 2 === 1);
    var a = this.point(
      c.slice(1, 1 + p),
      c.slice(1 + p, 1 + 2 * p)
    );
    return a;
  } else if ((c[0] === 2 || c[0] === 3) && c.length - 1 === p)
    return this.pointFromX(c.slice(1, 1 + p), c[0] === 3);
  throw new Error("Unknown point format");
};
BasePoint.prototype.encodeCompressed = function(c) {
  return this.encode(c, !0);
};
BasePoint.prototype._encode = function(c) {
  var u = this.curve.p.byteLength(), p = this.getX().toArray("be", u);
  return c ? [this.getY().isEven() ? 2 : 3].concat(p) : [4].concat(p, this.getY().toArray("be", u));
};
BasePoint.prototype.encode = function(c, u) {
  return utils$A.encode(this._encode(u), c);
};
BasePoint.prototype.precompute = function(c) {
  if (this.precomputed)
    return this;
  var u = {
    doubles: null,
    naf: null,
    beta: null
  };
  return u.naf = this._getNAFPoints(8), u.doubles = this._getDoubles(4, c), u.beta = this._getBeta(), this.precomputed = u, this;
};
BasePoint.prototype._hasDoubles = function(c) {
  if (!this.precomputed)
    return !1;
  var u = this.precomputed.doubles;
  return u ? u.points.length >= Math.ceil((c.bitLength() + 1) / u.step) : !1;
};
BasePoint.prototype._getDoubles = function(c, u) {
  if (this.precomputed && this.precomputed.doubles)
    return this.precomputed.doubles;
  for (var p = [this], a = this, A = 0; A < u; A += c) {
    for (var b = 0; b < c; b++)
      a = a.dbl();
    p.push(a);
  }
  return {
    step: c,
    points: p
  };
};
BasePoint.prototype._getNAFPoints = function(c) {
  if (this.precomputed && this.precomputed.naf)
    return this.precomputed.naf;
  for (var u = [this], p = (1 << c) - 1, a = p === 1 ? null : this.dbl(), A = 1; A < p; A++)
    u[A] = u[A - 1].add(a);
  return {
    wnd: c,
    points: u
  };
};
BasePoint.prototype._getBeta = function() {
  return null;
};
BasePoint.prototype.dblp = function(c) {
  for (var u = this, p = 0; p < c; p++)
    u = u.dbl();
  return u;
};
var utils$z = utils$C, BN$5 = bnExports, inherits$3 = inherits_browserExports, Base$3 = base$d, assert$q = utils$z.assert;
function ShortCurve(n) {
  Base$3.call(this, "short", n), this.a = new BN$5(n.a, 16).toRed(this.red), this.b = new BN$5(n.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = this.a.fromRed().cmpn(0) === 0, this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0, this.endo = this._getEndomorphism(n), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
}
inherits$3(ShortCurve, Base$3);
var short = ShortCurve;
ShortCurve.prototype._getEndomorphism = function(c) {
  if (!(!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)) {
    var u, p;
    if (c.beta)
      u = new BN$5(c.beta, 16).toRed(this.red);
    else {
      var a = this._getEndoRoots(this.p);
      u = a[0].cmp(a[1]) < 0 ? a[0] : a[1], u = u.toRed(this.red);
    }
    if (c.lambda)
      p = new BN$5(c.lambda, 16);
    else {
      var A = this._getEndoRoots(this.n);
      this.g.mul(A[0]).x.cmp(this.g.x.redMul(u)) === 0 ? p = A[0] : (p = A[1], assert$q(this.g.mul(p).x.cmp(this.g.x.redMul(u)) === 0));
    }
    var b;
    return c.basis ? b = c.basis.map(function(F) {
      return {
        a: new BN$5(F.a, 16),
        b: new BN$5(F.b, 16)
      };
    }) : b = this._getEndoBasis(p), {
      beta: u,
      lambda: p,
      basis: b
    };
  }
};
ShortCurve.prototype._getEndoRoots = function(c) {
  var u = c === this.p ? this.red : BN$5.mont(c), p = new BN$5(2).toRed(u).redInvm(), a = p.redNeg(), A = new BN$5(3).toRed(u).redNeg().redSqrt().redMul(p), b = a.redAdd(A).fromRed(), F = a.redSub(A).fromRed();
  return [b, F];
};
ShortCurve.prototype._getEndoBasis = function(c) {
  for (var u = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), p = c, a = this.n.clone(), A = new BN$5(1), b = new BN$5(0), F = new BN$5(0), le = new BN$5(1), L, pe, $, Ee, be, He, Pe, nr = 0, ir, or; p.cmpn(0) !== 0; ) {
    var lr = a.div(p);
    ir = a.sub(lr.mul(p)), or = F.sub(lr.mul(A));
    var Ir = le.sub(lr.mul(b));
    if (!$ && ir.cmp(u) < 0)
      L = Pe.neg(), pe = A, $ = ir.neg(), Ee = or;
    else if ($ && ++nr === 2)
      break;
    Pe = ir, a = p, p = ir, F = A, A = or, le = b, b = Ir;
  }
  be = ir.neg(), He = or;
  var xr = $.sqr().add(Ee.sqr()), kr = be.sqr().add(He.sqr());
  return kr.cmp(xr) >= 0 && (be = L, He = pe), $.negative && ($ = $.neg(), Ee = Ee.neg()), be.negative && (be = be.neg(), He = He.neg()), [
    { a: $, b: Ee },
    { a: be, b: He }
  ];
};
ShortCurve.prototype._endoSplit = function(c) {
  var u = this.endo.basis, p = u[0], a = u[1], A = a.b.mul(c).divRound(this.n), b = p.b.neg().mul(c).divRound(this.n), F = A.mul(p.a), le = b.mul(a.a), L = A.mul(p.b), pe = b.mul(a.b), $ = c.sub(F).sub(le), Ee = L.add(pe).neg();
  return { k1: $, k2: Ee };
};
ShortCurve.prototype.pointFromX = function(c, u) {
  c = new BN$5(c, 16), c.red || (c = c.toRed(this.red));
  var p = c.redSqr().redMul(c).redIAdd(c.redMul(this.a)).redIAdd(this.b), a = p.redSqrt();
  if (a.redSqr().redSub(p).cmp(this.zero) !== 0)
    throw new Error("invalid point");
  var A = a.fromRed().isOdd();
  return (u && !A || !u && A) && (a = a.redNeg()), this.point(c, a);
};
ShortCurve.prototype.validate = function(c) {
  if (c.inf)
    return !0;
  var u = c.x, p = c.y, a = this.a.redMul(u), A = u.redSqr().redMul(u).redIAdd(a).redIAdd(this.b);
  return p.redSqr().redISub(A).cmpn(0) === 0;
};
ShortCurve.prototype._endoWnafMulAdd = function(c, u, p) {
  for (var a = this._endoWnafT1, A = this._endoWnafT2, b = 0; b < c.length; b++) {
    var F = this._endoSplit(u[b]), le = c[b], L = le._getBeta();
    F.k1.negative && (F.k1.ineg(), le = le.neg(!0)), F.k2.negative && (F.k2.ineg(), L = L.neg(!0)), a[b * 2] = le, a[b * 2 + 1] = L, A[b * 2] = F.k1, A[b * 2 + 1] = F.k2;
  }
  for (var pe = this._wnafMulAdd(1, a, A, b * 2, p), $ = 0; $ < b * 2; $++)
    a[$] = null, A[$] = null;
  return pe;
};
function Point$8(n, c, u, p) {
  Base$3.BasePoint.call(this, n, "affine"), c === null && u === null ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new BN$5(c, 16), this.y = new BN$5(u, 16), p && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
}
inherits$3(Point$8, Base$3.BasePoint);
ShortCurve.prototype.point = function(c, u, p) {
  return new Point$8(this, c, u, p);
};
ShortCurve.prototype.pointFromJSON = function(c, u) {
  return Point$8.fromJSON(this, c, u);
};
Point$8.prototype._getBeta = function() {
  if (this.curve.endo) {
    var c = this.precomputed;
    if (c && c.beta)
      return c.beta;
    var u = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (c) {
      var p = this.curve, a = function(A) {
        return p.point(A.x.redMul(p.endo.beta), A.y);
      };
      c.beta = u, u.precomputed = {
        beta: null,
        naf: c.naf && {
          wnd: c.naf.wnd,
          points: c.naf.points.map(a)
        },
        doubles: c.doubles && {
          step: c.doubles.step,
          points: c.doubles.points.map(a)
        }
      };
    }
    return u;
  }
};
Point$8.prototype.toJSON = function() {
  return this.precomputed ? [this.x, this.y, this.precomputed && {
    doubles: this.precomputed.doubles && {
      step: this.precomputed.doubles.step,
      points: this.precomputed.doubles.points.slice(1)
    },
    naf: this.precomputed.naf && {
      wnd: this.precomputed.naf.wnd,
      points: this.precomputed.naf.points.slice(1)
    }
  }] : [this.x, this.y];
};
Point$8.fromJSON = function(c, u, p) {
  typeof u == "string" && (u = JSON.parse(u));
  var a = c.point(u[0], u[1], p);
  if (!u[2])
    return a;
  function A(F) {
    return c.point(F[0], F[1], p);
  }
  var b = u[2];
  return a.precomputed = {
    beta: null,
    doubles: b.doubles && {
      step: b.doubles.step,
      points: [a].concat(b.doubles.points.map(A))
    },
    naf: b.naf && {
      wnd: b.naf.wnd,
      points: [a].concat(b.naf.points.map(A))
    }
  }, a;
};
Point$8.prototype.inspect = function() {
  return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
Point$8.prototype.isInfinity = function() {
  return this.inf;
};
Point$8.prototype.add = function(c) {
  if (this.inf)
    return c;
  if (c.inf)
    return this;
  if (this.eq(c))
    return this.dbl();
  if (this.neg().eq(c))
    return this.curve.point(null, null);
  if (this.x.cmp(c.x) === 0)
    return this.curve.point(null, null);
  var u = this.y.redSub(c.y);
  u.cmpn(0) !== 0 && (u = u.redMul(this.x.redSub(c.x).redInvm()));
  var p = u.redSqr().redISub(this.x).redISub(c.x), a = u.redMul(this.x.redSub(p)).redISub(this.y);
  return this.curve.point(p, a);
};
Point$8.prototype.dbl = function() {
  if (this.inf)
    return this;
  var c = this.y.redAdd(this.y);
  if (c.cmpn(0) === 0)
    return this.curve.point(null, null);
  var u = this.curve.a, p = this.x.redSqr(), a = c.redInvm(), A = p.redAdd(p).redIAdd(p).redIAdd(u).redMul(a), b = A.redSqr().redISub(this.x.redAdd(this.x)), F = A.redMul(this.x.redSub(b)).redISub(this.y);
  return this.curve.point(b, F);
};
Point$8.prototype.getX = function() {
  return this.x.fromRed();
};
Point$8.prototype.getY = function() {
  return this.y.fromRed();
};
Point$8.prototype.mul = function(c) {
  return c = new BN$5(c, 16), this.isInfinity() ? this : this._hasDoubles(c) ? this.curve._fixedNafMul(this, c) : this.curve.endo ? this.curve._endoWnafMulAdd([this], [c]) : this.curve._wnafMul(this, c);
};
Point$8.prototype.mulAdd = function(c, u, p) {
  var a = [this, u], A = [c, p];
  return this.curve.endo ? this.curve._endoWnafMulAdd(a, A) : this.curve._wnafMulAdd(1, a, A, 2);
};
Point$8.prototype.jmulAdd = function(c, u, p) {
  var a = [this, u], A = [c, p];
  return this.curve.endo ? this.curve._endoWnafMulAdd(a, A, !0) : this.curve._wnafMulAdd(1, a, A, 2, !0);
};
Point$8.prototype.eq = function(c) {
  return this === c || this.inf === c.inf && (this.inf || this.x.cmp(c.x) === 0 && this.y.cmp(c.y) === 0);
};
Point$8.prototype.neg = function(c) {
  if (this.inf)
    return this;
  var u = this.curve.point(this.x, this.y.redNeg());
  if (c && this.precomputed) {
    var p = this.precomputed, a = function(A) {
      return A.neg();
    };
    u.precomputed = {
      naf: p.naf && {
        wnd: p.naf.wnd,
        points: p.naf.points.map(a)
      },
      doubles: p.doubles && {
        step: p.doubles.step,
        points: p.doubles.points.map(a)
      }
    };
  }
  return u;
};
Point$8.prototype.toJ = function() {
  if (this.inf)
    return this.curve.jpoint(null, null, null);
  var c = this.curve.jpoint(this.x, this.y, this.curve.one);
  return c;
};
function JPoint(n, c, u, p) {
  Base$3.BasePoint.call(this, n, "jacobian"), c === null && u === null && p === null ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new BN$5(0)) : (this.x = new BN$5(c, 16), this.y = new BN$5(u, 16), this.z = new BN$5(p, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
}
inherits$3(JPoint, Base$3.BasePoint);
ShortCurve.prototype.jpoint = function(c, u, p) {
  return new JPoint(this, c, u, p);
};
JPoint.prototype.toP = function() {
  if (this.isInfinity())
    return this.curve.point(null, null);
  var c = this.z.redInvm(), u = c.redSqr(), p = this.x.redMul(u), a = this.y.redMul(u).redMul(c);
  return this.curve.point(p, a);
};
JPoint.prototype.neg = function() {
  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
JPoint.prototype.add = function(c) {
  if (this.isInfinity())
    return c;
  if (c.isInfinity())
    return this;
  var u = c.z.redSqr(), p = this.z.redSqr(), a = this.x.redMul(u), A = c.x.redMul(p), b = this.y.redMul(u.redMul(c.z)), F = c.y.redMul(p.redMul(this.z)), le = a.redSub(A), L = b.redSub(F);
  if (le.cmpn(0) === 0)
    return L.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
  var pe = le.redSqr(), $ = pe.redMul(le), Ee = a.redMul(pe), be = L.redSqr().redIAdd($).redISub(Ee).redISub(Ee), He = L.redMul(Ee.redISub(be)).redISub(b.redMul($)), Pe = this.z.redMul(c.z).redMul(le);
  return this.curve.jpoint(be, He, Pe);
};
JPoint.prototype.mixedAdd = function(c) {
  if (this.isInfinity())
    return c.toJ();
  if (c.isInfinity())
    return this;
  var u = this.z.redSqr(), p = this.x, a = c.x.redMul(u), A = this.y, b = c.y.redMul(u).redMul(this.z), F = p.redSub(a), le = A.redSub(b);
  if (F.cmpn(0) === 0)
    return le.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
  var L = F.redSqr(), pe = L.redMul(F), $ = p.redMul(L), Ee = le.redSqr().redIAdd(pe).redISub($).redISub($), be = le.redMul($.redISub(Ee)).redISub(A.redMul(pe)), He = this.z.redMul(F);
  return this.curve.jpoint(Ee, be, He);
};
JPoint.prototype.dblp = function(c) {
  if (c === 0)
    return this;
  if (this.isInfinity())
    return this;
  if (!c)
    return this.dbl();
  var u;
  if (this.curve.zeroA || this.curve.threeA) {
    var p = this;
    for (u = 0; u < c; u++)
      p = p.dbl();
    return p;
  }
  var a = this.curve.a, A = this.curve.tinv, b = this.x, F = this.y, le = this.z, L = le.redSqr().redSqr(), pe = F.redAdd(F);
  for (u = 0; u < c; u++) {
    var $ = b.redSqr(), Ee = pe.redSqr(), be = Ee.redSqr(), He = $.redAdd($).redIAdd($).redIAdd(a.redMul(L)), Pe = b.redMul(Ee), nr = He.redSqr().redISub(Pe.redAdd(Pe)), ir = Pe.redISub(nr), or = He.redMul(ir);
    or = or.redIAdd(or).redISub(be);
    var lr = pe.redMul(le);
    u + 1 < c && (L = L.redMul(be)), b = nr, le = lr, pe = or;
  }
  return this.curve.jpoint(b, pe.redMul(A), le);
};
JPoint.prototype.dbl = function() {
  return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
};
JPoint.prototype._zeroDbl = function() {
  var c, u, p;
  if (this.zOne) {
    var a = this.x.redSqr(), A = this.y.redSqr(), b = A.redSqr(), F = this.x.redAdd(A).redSqr().redISub(a).redISub(b);
    F = F.redIAdd(F);
    var le = a.redAdd(a).redIAdd(a), L = le.redSqr().redISub(F).redISub(F), pe = b.redIAdd(b);
    pe = pe.redIAdd(pe), pe = pe.redIAdd(pe), c = L, u = le.redMul(F.redISub(L)).redISub(pe), p = this.y.redAdd(this.y);
  } else {
    var $ = this.x.redSqr(), Ee = this.y.redSqr(), be = Ee.redSqr(), He = this.x.redAdd(Ee).redSqr().redISub($).redISub(be);
    He = He.redIAdd(He);
    var Pe = $.redAdd($).redIAdd($), nr = Pe.redSqr(), ir = be.redIAdd(be);
    ir = ir.redIAdd(ir), ir = ir.redIAdd(ir), c = nr.redISub(He).redISub(He), u = Pe.redMul(He.redISub(c)).redISub(ir), p = this.y.redMul(this.z), p = p.redIAdd(p);
  }
  return this.curve.jpoint(c, u, p);
};
JPoint.prototype._threeDbl = function() {
  var c, u, p;
  if (this.zOne) {
    var a = this.x.redSqr(), A = this.y.redSqr(), b = A.redSqr(), F = this.x.redAdd(A).redSqr().redISub(a).redISub(b);
    F = F.redIAdd(F);
    var le = a.redAdd(a).redIAdd(a).redIAdd(this.curve.a), L = le.redSqr().redISub(F).redISub(F);
    c = L;
    var pe = b.redIAdd(b);
    pe = pe.redIAdd(pe), pe = pe.redIAdd(pe), u = le.redMul(F.redISub(L)).redISub(pe), p = this.y.redAdd(this.y);
  } else {
    var $ = this.z.redSqr(), Ee = this.y.redSqr(), be = this.x.redMul(Ee), He = this.x.redSub($).redMul(this.x.redAdd($));
    He = He.redAdd(He).redIAdd(He);
    var Pe = be.redIAdd(be);
    Pe = Pe.redIAdd(Pe);
    var nr = Pe.redAdd(Pe);
    c = He.redSqr().redISub(nr), p = this.y.redAdd(this.z).redSqr().redISub(Ee).redISub($);
    var ir = Ee.redSqr();
    ir = ir.redIAdd(ir), ir = ir.redIAdd(ir), ir = ir.redIAdd(ir), u = He.redMul(Pe.redISub(c)).redISub(ir);
  }
  return this.curve.jpoint(c, u, p);
};
JPoint.prototype._dbl = function() {
  var c = this.curve.a, u = this.x, p = this.y, a = this.z, A = a.redSqr().redSqr(), b = u.redSqr(), F = p.redSqr(), le = b.redAdd(b).redIAdd(b).redIAdd(c.redMul(A)), L = u.redAdd(u);
  L = L.redIAdd(L);
  var pe = L.redMul(F), $ = le.redSqr().redISub(pe.redAdd(pe)), Ee = pe.redISub($), be = F.redSqr();
  be = be.redIAdd(be), be = be.redIAdd(be), be = be.redIAdd(be);
  var He = le.redMul(Ee).redISub(be), Pe = p.redAdd(p).redMul(a);
  return this.curve.jpoint($, He, Pe);
};
JPoint.prototype.trpl = function() {
  if (!this.curve.zeroA)
    return this.dbl().add(this);
  var c = this.x.redSqr(), u = this.y.redSqr(), p = this.z.redSqr(), a = u.redSqr(), A = c.redAdd(c).redIAdd(c), b = A.redSqr(), F = this.x.redAdd(u).redSqr().redISub(c).redISub(a);
  F = F.redIAdd(F), F = F.redAdd(F).redIAdd(F), F = F.redISub(b);
  var le = F.redSqr(), L = a.redIAdd(a);
  L = L.redIAdd(L), L = L.redIAdd(L), L = L.redIAdd(L);
  var pe = A.redIAdd(F).redSqr().redISub(b).redISub(le).redISub(L), $ = u.redMul(pe);
  $ = $.redIAdd($), $ = $.redIAdd($);
  var Ee = this.x.redMul(le).redISub($);
  Ee = Ee.redIAdd(Ee), Ee = Ee.redIAdd(Ee);
  var be = this.y.redMul(pe.redMul(L.redISub(pe)).redISub(F.redMul(le)));
  be = be.redIAdd(be), be = be.redIAdd(be), be = be.redIAdd(be);
  var He = this.z.redAdd(F).redSqr().redISub(p).redISub(le);
  return this.curve.jpoint(Ee, be, He);
};
JPoint.prototype.mul = function(c, u) {
  return c = new BN$5(c, u), this.curve._wnafMul(this, c);
};
JPoint.prototype.eq = function(c) {
  if (c.type === "affine")
    return this.eq(c.toJ());
  if (this === c)
    return !0;
  var u = this.z.redSqr(), p = c.z.redSqr();
  if (this.x.redMul(p).redISub(c.x.redMul(u)).cmpn(0) !== 0)
    return !1;
  var a = u.redMul(this.z), A = p.redMul(c.z);
  return this.y.redMul(A).redISub(c.y.redMul(a)).cmpn(0) === 0;
};
JPoint.prototype.eqXToP = function(c) {
  var u = this.z.redSqr(), p = c.toRed(this.curve.red).redMul(u);
  if (this.x.cmp(p) === 0)
    return !0;
  for (var a = c.clone(), A = this.curve.redN.redMul(u); ; ) {
    if (a.iadd(this.curve.n), a.cmp(this.curve.p) >= 0)
      return !1;
    if (p.redIAdd(A), this.x.cmp(p) === 0)
      return !0;
  }
};
JPoint.prototype.inspect = function() {
  return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
JPoint.prototype.isInfinity = function() {
  return this.z.cmpn(0) === 0;
};
var BN$4 = bnExports, inherits$2 = inherits_browserExports, Base$2 = base$d, utils$y = utils$C;
function MontCurve(n) {
  Base$2.call(this, "mont", n), this.a = new BN$4(n.a, 16).toRed(this.red), this.b = new BN$4(n.b, 16).toRed(this.red), this.i4 = new BN$4(4).toRed(this.red).redInvm(), this.two = new BN$4(2).toRed(this.red), this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
inherits$2(MontCurve, Base$2);
var mont = MontCurve;
MontCurve.prototype.validate = function(c) {
  var u = c.normalize().x, p = u.redSqr(), a = p.redMul(u).redAdd(p.redMul(this.a)).redAdd(u), A = a.redSqrt();
  return A.redSqr().cmp(a) === 0;
};
function Point$7(n, c, u) {
  Base$2.BasePoint.call(this, n, "projective"), c === null && u === null ? (this.x = this.curve.one, this.z = this.curve.zero) : (this.x = new BN$4(c, 16), this.z = new BN$4(u, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)));
}
inherits$2(Point$7, Base$2.BasePoint);
MontCurve.prototype.decodePoint = function(c, u) {
  return this.point(utils$y.toArray(c, u), 1);
};
MontCurve.prototype.point = function(c, u) {
  return new Point$7(this, c, u);
};
MontCurve.prototype.pointFromJSON = function(c) {
  return Point$7.fromJSON(this, c);
};
Point$7.prototype.precompute = function() {
};
Point$7.prototype._encode = function() {
  return this.getX().toArray("be", this.curve.p.byteLength());
};
Point$7.fromJSON = function(c, u) {
  return new Point$7(c, u[0], u[1] || c.one);
};
Point$7.prototype.inspect = function() {
  return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
Point$7.prototype.isInfinity = function() {
  return this.z.cmpn(0) === 0;
};
Point$7.prototype.dbl = function() {
  var c = this.x.redAdd(this.z), u = c.redSqr(), p = this.x.redSub(this.z), a = p.redSqr(), A = u.redSub(a), b = u.redMul(a), F = A.redMul(a.redAdd(this.curve.a24.redMul(A)));
  return this.curve.point(b, F);
};
Point$7.prototype.add = function() {
  throw new Error("Not supported on Montgomery curve");
};
Point$7.prototype.diffAdd = function(c, u) {
  var p = this.x.redAdd(this.z), a = this.x.redSub(this.z), A = c.x.redAdd(c.z), b = c.x.redSub(c.z), F = b.redMul(p), le = A.redMul(a), L = u.z.redMul(F.redAdd(le).redSqr()), pe = u.x.redMul(F.redISub(le).redSqr());
  return this.curve.point(L, pe);
};
Point$7.prototype.mul = function(c) {
  for (var u = c.clone(), p = this, a = this.curve.point(null, null), A = this, b = []; u.cmpn(0) !== 0; u.iushrn(1))
    b.push(u.andln(1));
  for (var F = b.length - 1; F >= 0; F--)
    b[F] === 0 ? (p = p.diffAdd(a, A), a = a.dbl()) : (a = p.diffAdd(a, A), p = p.dbl());
  return a;
};
Point$7.prototype.mulAdd = function() {
  throw new Error("Not supported on Montgomery curve");
};
Point$7.prototype.jumlAdd = function() {
  throw new Error("Not supported on Montgomery curve");
};
Point$7.prototype.eq = function(c) {
  return this.getX().cmp(c.getX()) === 0;
};
Point$7.prototype.normalize = function() {
  return this.x = this.x.redMul(this.z.redInvm()), this.z = this.curve.one, this;
};
Point$7.prototype.getX = function() {
  return this.normalize(), this.x.fromRed();
};
var utils$x = utils$C, BN$3 = bnExports, inherits$1 = inherits_browserExports, Base$1 = base$d, assert$p = utils$x.assert;
function EdwardsCurve(n) {
  this.twisted = (n.a | 0) !== 1, this.mOneA = this.twisted && (n.a | 0) === -1, this.extended = this.mOneA, Base$1.call(this, "edwards", n), this.a = new BN$3(n.a, 16).umod(this.red.m), this.a = this.a.toRed(this.red), this.c = new BN$3(n.c, 16).toRed(this.red), this.c2 = this.c.redSqr(), this.d = new BN$3(n.d, 16).toRed(this.red), this.dd = this.d.redAdd(this.d), assert$p(!this.twisted || this.c.fromRed().cmpn(1) === 0), this.oneC = (n.c | 0) === 1;
}
inherits$1(EdwardsCurve, Base$1);
var edwards = EdwardsCurve;
EdwardsCurve.prototype._mulA = function(c) {
  return this.mOneA ? c.redNeg() : this.a.redMul(c);
};
EdwardsCurve.prototype._mulC = function(c) {
  return this.oneC ? c : this.c.redMul(c);
};
EdwardsCurve.prototype.jpoint = function(c, u, p, a) {
  return this.point(c, u, p, a);
};
EdwardsCurve.prototype.pointFromX = function(c, u) {
  c = new BN$3(c, 16), c.red || (c = c.toRed(this.red));
  var p = c.redSqr(), a = this.c2.redSub(this.a.redMul(p)), A = this.one.redSub(this.c2.redMul(this.d).redMul(p)), b = a.redMul(A.redInvm()), F = b.redSqrt();
  if (F.redSqr().redSub(b).cmp(this.zero) !== 0)
    throw new Error("invalid point");
  var le = F.fromRed().isOdd();
  return (u && !le || !u && le) && (F = F.redNeg()), this.point(c, F);
};
EdwardsCurve.prototype.pointFromY = function(c, u) {
  c = new BN$3(c, 16), c.red || (c = c.toRed(this.red));
  var p = c.redSqr(), a = p.redSub(this.c2), A = p.redMul(this.d).redMul(this.c2).redSub(this.a), b = a.redMul(A.redInvm());
  if (b.cmp(this.zero) === 0) {
    if (u)
      throw new Error("invalid point");
    return this.point(this.zero, c);
  }
  var F = b.redSqrt();
  if (F.redSqr().redSub(b).cmp(this.zero) !== 0)
    throw new Error("invalid point");
  return F.fromRed().isOdd() !== u && (F = F.redNeg()), this.point(F, c);
};
EdwardsCurve.prototype.validate = function(c) {
  if (c.isInfinity())
    return !0;
  c.normalize();
  var u = c.x.redSqr(), p = c.y.redSqr(), a = u.redMul(this.a).redAdd(p), A = this.c2.redMul(this.one.redAdd(this.d.redMul(u).redMul(p)));
  return a.cmp(A) === 0;
};
function Point$6(n, c, u, p, a) {
  Base$1.BasePoint.call(this, n, "projective"), c === null && u === null && p === null ? (this.x = this.curve.zero, this.y = this.curve.one, this.z = this.curve.one, this.t = this.curve.zero, this.zOne = !0) : (this.x = new BN$3(c, 16), this.y = new BN$3(u, 16), this.z = p ? new BN$3(p, 16) : this.curve.one, this.t = a && new BN$3(a, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.t && !this.t.red && (this.t = this.t.toRed(this.curve.red)), this.zOne = this.z === this.curve.one, this.curve.extended && !this.t && (this.t = this.x.redMul(this.y), this.zOne || (this.t = this.t.redMul(this.z.redInvm()))));
}
inherits$1(Point$6, Base$1.BasePoint);
EdwardsCurve.prototype.pointFromJSON = function(c) {
  return Point$6.fromJSON(this, c);
};
EdwardsCurve.prototype.point = function(c, u, p, a) {
  return new Point$6(this, c, u, p, a);
};
Point$6.fromJSON = function(c, u) {
  return new Point$6(c, u[0], u[1], u[2]);
};
Point$6.prototype.inspect = function() {
  return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
Point$6.prototype.isInfinity = function() {
  return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
Point$6.prototype._extDbl = function() {
  var c = this.x.redSqr(), u = this.y.redSqr(), p = this.z.redSqr();
  p = p.redIAdd(p);
  var a = this.curve._mulA(c), A = this.x.redAdd(this.y).redSqr().redISub(c).redISub(u), b = a.redAdd(u), F = b.redSub(p), le = a.redSub(u), L = A.redMul(F), pe = b.redMul(le), $ = A.redMul(le), Ee = F.redMul(b);
  return this.curve.point(L, pe, Ee, $);
};
Point$6.prototype._projDbl = function() {
  var c = this.x.redAdd(this.y).redSqr(), u = this.x.redSqr(), p = this.y.redSqr(), a, A, b, F, le, L;
  if (this.curve.twisted) {
    F = this.curve._mulA(u);
    var pe = F.redAdd(p);
    this.zOne ? (a = c.redSub(u).redSub(p).redMul(pe.redSub(this.curve.two)), A = pe.redMul(F.redSub(p)), b = pe.redSqr().redSub(pe).redSub(pe)) : (le = this.z.redSqr(), L = pe.redSub(le).redISub(le), a = c.redSub(u).redISub(p).redMul(L), A = pe.redMul(F.redSub(p)), b = pe.redMul(L));
  } else
    F = u.redAdd(p), le = this.curve._mulC(this.z).redSqr(), L = F.redSub(le).redSub(le), a = this.curve._mulC(c.redISub(F)).redMul(L), A = this.curve._mulC(F).redMul(u.redISub(p)), b = F.redMul(L);
  return this.curve.point(a, A, b);
};
Point$6.prototype.dbl = function() {
  return this.isInfinity() ? this : this.curve.extended ? this._extDbl() : this._projDbl();
};
Point$6.prototype._extAdd = function(c) {
  var u = this.y.redSub(this.x).redMul(c.y.redSub(c.x)), p = this.y.redAdd(this.x).redMul(c.y.redAdd(c.x)), a = this.t.redMul(this.curve.dd).redMul(c.t), A = this.z.redMul(c.z.redAdd(c.z)), b = p.redSub(u), F = A.redSub(a), le = A.redAdd(a), L = p.redAdd(u), pe = b.redMul(F), $ = le.redMul(L), Ee = b.redMul(L), be = F.redMul(le);
  return this.curve.point(pe, $, be, Ee);
};
Point$6.prototype._projAdd = function(c) {
  var u = this.z.redMul(c.z), p = u.redSqr(), a = this.x.redMul(c.x), A = this.y.redMul(c.y), b = this.curve.d.redMul(a).redMul(A), F = p.redSub(b), le = p.redAdd(b), L = this.x.redAdd(this.y).redMul(c.x.redAdd(c.y)).redISub(a).redISub(A), pe = u.redMul(F).redMul(L), $, Ee;
  return this.curve.twisted ? ($ = u.redMul(le).redMul(A.redSub(this.curve._mulA(a))), Ee = F.redMul(le)) : ($ = u.redMul(le).redMul(A.redSub(a)), Ee = this.curve._mulC(F).redMul(le)), this.curve.point(pe, $, Ee);
};
Point$6.prototype.add = function(c) {
  return this.isInfinity() ? c : c.isInfinity() ? this : this.curve.extended ? this._extAdd(c) : this._projAdd(c);
};
Point$6.prototype.mul = function(c) {
  return this._hasDoubles(c) ? this.curve._fixedNafMul(this, c) : this.curve._wnafMul(this, c);
};
Point$6.prototype.mulAdd = function(c, u, p) {
  return this.curve._wnafMulAdd(1, [this, u], [c, p], 2, !1);
};
Point$6.prototype.jmulAdd = function(c, u, p) {
  return this.curve._wnafMulAdd(1, [this, u], [c, p], 2, !0);
};
Point$6.prototype.normalize = function() {
  if (this.zOne)
    return this;
  var c = this.z.redInvm();
  return this.x = this.x.redMul(c), this.y = this.y.redMul(c), this.t && (this.t = this.t.redMul(c)), this.z = this.curve.one, this.zOne = !0, this;
};
Point$6.prototype.neg = function() {
  return this.curve.point(
    this.x.redNeg(),
    this.y,
    this.z,
    this.t && this.t.redNeg()
  );
};
Point$6.prototype.getX = function() {
  return this.normalize(), this.x.fromRed();
};
Point$6.prototype.getY = function() {
  return this.normalize(), this.y.fromRed();
};
Point$6.prototype.eq = function(c) {
  return this === c || this.getX().cmp(c.getX()) === 0 && this.getY().cmp(c.getY()) === 0;
};
Point$6.prototype.eqXToP = function(c) {
  var u = c.toRed(this.curve.red).redMul(this.z);
  if (this.x.cmp(u) === 0)
    return !0;
  for (var p = c.clone(), a = this.curve.redN.redMul(this.z); ; ) {
    if (p.iadd(this.curve.n), p.cmp(this.curve.p) >= 0)
      return !1;
    if (u.redIAdd(a), this.x.cmp(u) === 0)
      return !0;
  }
};
Point$6.prototype.toP = Point$6.prototype.normalize;
Point$6.prototype.mixedAdd = Point$6.prototype.add;
(function(n) {
  var c = n;
  c.base = base$d, c.short = short, c.mont = mont, c.edwards = edwards;
})(curve$1);
var curves$1 = {}, hash$a = {}, utils$w = {}, assert$o = minimalisticAssert, inherits = inherits_browserExports;
utils$w.inherits = inherits;
function isSurrogatePair(n, c) {
  return (n.charCodeAt(c) & 64512) !== 55296 || c < 0 || c + 1 >= n.length ? !1 : (n.charCodeAt(c + 1) & 64512) === 56320;
}
function toArray(n, c) {
  if (Array.isArray(n))
    return n.slice();
  if (!n)
    return [];
  var u = [];
  if (typeof n == "string")
    if (c) {
      if (c === "hex")
        for (n = n.replace(/[^a-z0-9]+/ig, ""), n.length % 2 !== 0 && (n = "0" + n), a = 0; a < n.length; a += 2)
          u.push(parseInt(n[a] + n[a + 1], 16));
    } else for (var p = 0, a = 0; a < n.length; a++) {
      var A = n.charCodeAt(a);
      A < 128 ? u[p++] = A : A < 2048 ? (u[p++] = A >> 6 | 192, u[p++] = A & 63 | 128) : isSurrogatePair(n, a) ? (A = 65536 + ((A & 1023) << 10) + (n.charCodeAt(++a) & 1023), u[p++] = A >> 18 | 240, u[p++] = A >> 12 & 63 | 128, u[p++] = A >> 6 & 63 | 128, u[p++] = A & 63 | 128) : (u[p++] = A >> 12 | 224, u[p++] = A >> 6 & 63 | 128, u[p++] = A & 63 | 128);
    }
  else
    for (a = 0; a < n.length; a++)
      u[a] = n[a] | 0;
  return u;
}
utils$w.toArray = toArray;
function toHex$3(n) {
  for (var c = "", u = 0; u < n.length; u++)
    c += zero2(n[u].toString(16));
  return c;
}
utils$w.toHex = toHex$3;
function htonl(n) {
  var c = n >>> 24 | n >>> 8 & 65280 | n << 8 & 16711680 | (n & 255) << 24;
  return c >>> 0;
}
utils$w.htonl = htonl;
function toHex32(n, c) {
  for (var u = "", p = 0; p < n.length; p++) {
    var a = n[p];
    c === "little" && (a = htonl(a)), u += zero8(a.toString(16));
  }
  return u;
}
utils$w.toHex32 = toHex32;
function zero2(n) {
  return n.length === 1 ? "0" + n : n;
}
utils$w.zero2 = zero2;
function zero8(n) {
  return n.length === 7 ? "0" + n : n.length === 6 ? "00" + n : n.length === 5 ? "000" + n : n.length === 4 ? "0000" + n : n.length === 3 ? "00000" + n : n.length === 2 ? "000000" + n : n.length === 1 ? "0000000" + n : n;
}
utils$w.zero8 = zero8;
function join32(n, c, u, p) {
  var a = u - c;
  assert$o(a % 4 === 0);
  for (var A = new Array(a / 4), b = 0, F = c; b < A.length; b++, F += 4) {
    var le;
    p === "big" ? le = n[F] << 24 | n[F + 1] << 16 | n[F + 2] << 8 | n[F + 3] : le = n[F + 3] << 24 | n[F + 2] << 16 | n[F + 1] << 8 | n[F], A[b] = le >>> 0;
  }
  return A;
}
utils$w.join32 = join32;
function split32(n, c) {
  for (var u = new Array(n.length * 4), p = 0, a = 0; p < n.length; p++, a += 4) {
    var A = n[p];
    c === "big" ? (u[a] = A >>> 24, u[a + 1] = A >>> 16 & 255, u[a + 2] = A >>> 8 & 255, u[a + 3] = A & 255) : (u[a + 3] = A >>> 24, u[a + 2] = A >>> 16 & 255, u[a + 1] = A >>> 8 & 255, u[a] = A & 255);
  }
  return u;
}
utils$w.split32 = split32;
function rotr32$1(n, c) {
  return n >>> c | n << 32 - c;
}
utils$w.rotr32 = rotr32$1;
function rotl32$2(n, c) {
  return n << c | n >>> 32 - c;
}
utils$w.rotl32 = rotl32$2;
function sum32$3(n, c) {
  return n + c >>> 0;
}
utils$w.sum32 = sum32$3;
function sum32_3$1(n, c, u) {
  return n + c + u >>> 0;
}
utils$w.sum32_3 = sum32_3$1;
function sum32_4$2(n, c, u, p) {
  return n + c + u + p >>> 0;
}
utils$w.sum32_4 = sum32_4$2;
function sum32_5$2(n, c, u, p, a) {
  return n + c + u + p + a >>> 0;
}
utils$w.sum32_5 = sum32_5$2;
function sum64$1(n, c, u, p) {
  var a = n[c], A = n[c + 1], b = p + A >>> 0, F = (b < p ? 1 : 0) + u + a;
  n[c] = F >>> 0, n[c + 1] = b;
}
utils$w.sum64 = sum64$1;
function sum64_hi$1(n, c, u, p) {
  var a = c + p >>> 0, A = (a < c ? 1 : 0) + n + u;
  return A >>> 0;
}
utils$w.sum64_hi = sum64_hi$1;
function sum64_lo$1(n, c, u, p) {
  var a = c + p;
  return a >>> 0;
}
utils$w.sum64_lo = sum64_lo$1;
function sum64_4_hi$1(n, c, u, p, a, A, b, F) {
  var le = 0, L = c;
  L = L + p >>> 0, le += L < c ? 1 : 0, L = L + A >>> 0, le += L < A ? 1 : 0, L = L + F >>> 0, le += L < F ? 1 : 0;
  var pe = n + u + a + b + le;
  return pe >>> 0;
}
utils$w.sum64_4_hi = sum64_4_hi$1;
function sum64_4_lo$1(n, c, u, p, a, A, b, F) {
  var le = c + p + A + F;
  return le >>> 0;
}
utils$w.sum64_4_lo = sum64_4_lo$1;
function sum64_5_hi$1(n, c, u, p, a, A, b, F, le, L) {
  var pe = 0, $ = c;
  $ = $ + p >>> 0, pe += $ < c ? 1 : 0, $ = $ + A >>> 0, pe += $ < A ? 1 : 0, $ = $ + F >>> 0, pe += $ < F ? 1 : 0, $ = $ + L >>> 0, pe += $ < L ? 1 : 0;
  var Ee = n + u + a + b + le + pe;
  return Ee >>> 0;
}
utils$w.sum64_5_hi = sum64_5_hi$1;
function sum64_5_lo$1(n, c, u, p, a, A, b, F, le, L) {
  var pe = c + p + A + F + L;
  return pe >>> 0;
}
utils$w.sum64_5_lo = sum64_5_lo$1;
function rotr64_hi$1(n, c, u) {
  var p = c << 32 - u | n >>> u;
  return p >>> 0;
}
utils$w.rotr64_hi = rotr64_hi$1;
function rotr64_lo$1(n, c, u) {
  var p = n << 32 - u | c >>> u;
  return p >>> 0;
}
utils$w.rotr64_lo = rotr64_lo$1;
function shr64_hi$1(n, c, u) {
  return n >>> u;
}
utils$w.shr64_hi = shr64_hi$1;
function shr64_lo$1(n, c, u) {
  var p = n << 32 - u | c >>> u;
  return p >>> 0;
}
utils$w.shr64_lo = shr64_lo$1;
var common$6 = {}, utils$v = utils$w, assert$n = minimalisticAssert;
function BlockHash$4() {
  this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
}
common$6.BlockHash = BlockHash$4;
BlockHash$4.prototype.update = function(c, u) {
  if (c = utils$v.toArray(c, u), this.pending ? this.pending = this.pending.concat(c) : this.pending = c, this.pendingTotal += c.length, this.pending.length >= this._delta8) {
    c = this.pending;
    var p = c.length % this._delta8;
    this.pending = c.slice(c.length - p, c.length), this.pending.length === 0 && (this.pending = null), c = utils$v.join32(c, 0, c.length - p, this.endian);
    for (var a = 0; a < c.length; a += this._delta32)
      this._update(c, a, a + this._delta32);
  }
  return this;
};
BlockHash$4.prototype.digest = function(c) {
  return this.update(this._pad()), assert$n(this.pending === null), this._digest(c);
};
BlockHash$4.prototype._pad = function() {
  var c = this.pendingTotal, u = this._delta8, p = u - (c + this.padLength) % u, a = new Array(p + this.padLength);
  a[0] = 128;
  for (var A = 1; A < p; A++)
    a[A] = 0;
  if (c <<= 3, this.endian === "big") {
    for (var b = 8; b < this.padLength; b++)
      a[A++] = 0;
    a[A++] = 0, a[A++] = 0, a[A++] = 0, a[A++] = 0, a[A++] = c >>> 24 & 255, a[A++] = c >>> 16 & 255, a[A++] = c >>> 8 & 255, a[A++] = c & 255;
  } else
    for (a[A++] = c & 255, a[A++] = c >>> 8 & 255, a[A++] = c >>> 16 & 255, a[A++] = c >>> 24 & 255, a[A++] = 0, a[A++] = 0, a[A++] = 0, a[A++] = 0, b = 8; b < this.padLength; b++)
      a[A++] = 0;
  return a;
};
var sha$1 = {}, common$5 = {}, utils$u = utils$w, rotr32 = utils$u.rotr32;
function ft_1$1(n, c, u, p) {
  if (n === 0)
    return ch32$1(c, u, p);
  if (n === 1 || n === 3)
    return p32(c, u, p);
  if (n === 2)
    return maj32$1(c, u, p);
}
common$5.ft_1 = ft_1$1;
function ch32$1(n, c, u) {
  return n & c ^ ~n & u;
}
common$5.ch32 = ch32$1;
function maj32$1(n, c, u) {
  return n & c ^ n & u ^ c & u;
}
common$5.maj32 = maj32$1;
function p32(n, c, u) {
  return n ^ c ^ u;
}
common$5.p32 = p32;
function s0_256$1(n) {
  return rotr32(n, 2) ^ rotr32(n, 13) ^ rotr32(n, 22);
}
common$5.s0_256 = s0_256$1;
function s1_256$1(n) {
  return rotr32(n, 6) ^ rotr32(n, 11) ^ rotr32(n, 25);
}
common$5.s1_256 = s1_256$1;
function g0_256$1(n) {
  return rotr32(n, 7) ^ rotr32(n, 18) ^ n >>> 3;
}
common$5.g0_256 = g0_256$1;
function g1_256$1(n) {
  return rotr32(n, 17) ^ rotr32(n, 19) ^ n >>> 10;
}
common$5.g1_256 = g1_256$1;
var utils$t = utils$w, common$4 = common$6, shaCommon$1 = common$5, rotl32$1 = utils$t.rotl32, sum32$2 = utils$t.sum32, sum32_5$1 = utils$t.sum32_5, ft_1 = shaCommon$1.ft_1, BlockHash$3 = common$4.BlockHash, sha1_K = [
  1518500249,
  1859775393,
  2400959708,
  3395469782
];
function SHA1() {
  if (!(this instanceof SHA1))
    return new SHA1();
  BlockHash$3.call(this), this.h = [
    1732584193,
    4023233417,
    2562383102,
    271733878,
    3285377520
  ], this.W = new Array(80);
}
utils$t.inherits(SHA1, BlockHash$3);
var _1 = SHA1;
SHA1.blockSize = 512;
SHA1.outSize = 160;
SHA1.hmacStrength = 80;
SHA1.padLength = 64;
SHA1.prototype._update = function(c, u) {
  for (var p = this.W, a = 0; a < 16; a++)
    p[a] = c[u + a];
  for (; a < p.length; a++)
    p[a] = rotl32$1(p[a - 3] ^ p[a - 8] ^ p[a - 14] ^ p[a - 16], 1);
  var A = this.h[0], b = this.h[1], F = this.h[2], le = this.h[3], L = this.h[4];
  for (a = 0; a < p.length; a++) {
    var pe = ~~(a / 20), $ = sum32_5$1(rotl32$1(A, 5), ft_1(pe, b, F, le), L, p[a], sha1_K[pe]);
    L = le, le = F, F = rotl32$1(b, 30), b = A, A = $;
  }
  this.h[0] = sum32$2(this.h[0], A), this.h[1] = sum32$2(this.h[1], b), this.h[2] = sum32$2(this.h[2], F), this.h[3] = sum32$2(this.h[3], le), this.h[4] = sum32$2(this.h[4], L);
};
SHA1.prototype._digest = function(c) {
  return c === "hex" ? utils$t.toHex32(this.h, "big") : utils$t.split32(this.h, "big");
};
var utils$s = utils$w, common$3 = common$6, shaCommon = common$5, assert$m = minimalisticAssert, sum32$1 = utils$s.sum32, sum32_4$1 = utils$s.sum32_4, sum32_5 = utils$s.sum32_5, ch32 = shaCommon.ch32, maj32 = shaCommon.maj32, s0_256 = shaCommon.s0_256, s1_256 = shaCommon.s1_256, g0_256 = shaCommon.g0_256, g1_256 = shaCommon.g1_256, BlockHash$2 = common$3.BlockHash, sha256_K = [
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
];
function SHA256$8() {
  if (!(this instanceof SHA256$8))
    return new SHA256$8();
  BlockHash$2.call(this), this.h = [
    1779033703,
    3144134277,
    1013904242,
    2773480762,
    1359893119,
    2600822924,
    528734635,
    1541459225
  ], this.k = sha256_K, this.W = new Array(64);
}
utils$s.inherits(SHA256$8, BlockHash$2);
var _256 = SHA256$8;
SHA256$8.blockSize = 512;
SHA256$8.outSize = 256;
SHA256$8.hmacStrength = 192;
SHA256$8.padLength = 64;
SHA256$8.prototype._update = function(c, u) {
  for (var p = this.W, a = 0; a < 16; a++)
    p[a] = c[u + a];
  for (; a < p.length; a++)
    p[a] = sum32_4$1(g1_256(p[a - 2]), p[a - 7], g0_256(p[a - 15]), p[a - 16]);
  var A = this.h[0], b = this.h[1], F = this.h[2], le = this.h[3], L = this.h[4], pe = this.h[5], $ = this.h[6], Ee = this.h[7];
  for (assert$m(this.k.length === p.length), a = 0; a < p.length; a++) {
    var be = sum32_5(Ee, s1_256(L), ch32(L, pe, $), this.k[a], p[a]), He = sum32$1(s0_256(A), maj32(A, b, F));
    Ee = $, $ = pe, pe = L, L = sum32$1(le, be), le = F, F = b, b = A, A = sum32$1(be, He);
  }
  this.h[0] = sum32$1(this.h[0], A), this.h[1] = sum32$1(this.h[1], b), this.h[2] = sum32$1(this.h[2], F), this.h[3] = sum32$1(this.h[3], le), this.h[4] = sum32$1(this.h[4], L), this.h[5] = sum32$1(this.h[5], pe), this.h[6] = sum32$1(this.h[6], $), this.h[7] = sum32$1(this.h[7], Ee);
};
SHA256$8.prototype._digest = function(c) {
  return c === "hex" ? utils$s.toHex32(this.h, "big") : utils$s.split32(this.h, "big");
};
var utils$r = utils$w, SHA256$7 = _256;
function SHA224$4() {
  if (!(this instanceof SHA224$4))
    return new SHA224$4();
  SHA256$7.call(this), this.h = [
    3238371032,
    914150663,
    812702999,
    4144912697,
    4290775857,
    1750603025,
    1694076839,
    3204075428
  ];
}
utils$r.inherits(SHA224$4, SHA256$7);
var _224 = SHA224$4;
SHA224$4.blockSize = 512;
SHA224$4.outSize = 224;
SHA224$4.hmacStrength = 192;
SHA224$4.padLength = 64;
SHA224$4.prototype._digest = function(c) {
  return c === "hex" ? utils$r.toHex32(this.h.slice(0, 7), "big") : utils$r.split32(this.h.slice(0, 7), "big");
};
var utils$q = utils$w, common$2 = common$6, assert$l = minimalisticAssert, rotr64_hi = utils$q.rotr64_hi, rotr64_lo = utils$q.rotr64_lo, shr64_hi = utils$q.shr64_hi, shr64_lo = utils$q.shr64_lo, sum64 = utils$q.sum64, sum64_hi = utils$q.sum64_hi, sum64_lo = utils$q.sum64_lo, sum64_4_hi = utils$q.sum64_4_hi, sum64_4_lo = utils$q.sum64_4_lo, sum64_5_hi = utils$q.sum64_5_hi, sum64_5_lo = utils$q.sum64_5_lo, BlockHash$1 = common$2.BlockHash, sha512_K = [
  1116352408,
  3609767458,
  1899447441,
  602891725,
  3049323471,
  3964484399,
  3921009573,
  2173295548,
  961987163,
  4081628472,
  1508970993,
  3053834265,
  2453635748,
  2937671579,
  2870763221,
  3664609560,
  3624381080,
  2734883394,
  310598401,
  1164996542,
  607225278,
  1323610764,
  1426881987,
  3590304994,
  1925078388,
  4068182383,
  2162078206,
  991336113,
  2614888103,
  633803317,
  3248222580,
  3479774868,
  3835390401,
  2666613458,
  4022224774,
  944711139,
  264347078,
  2341262773,
  604807628,
  2007800933,
  770255983,
  1495990901,
  1249150122,
  1856431235,
  1555081692,
  3175218132,
  1996064986,
  2198950837,
  2554220882,
  3999719339,
  2821834349,
  766784016,
  2952996808,
  2566594879,
  3210313671,
  3203337956,
  3336571891,
  1034457026,
  3584528711,
  2466948901,
  113926993,
  3758326383,
  338241895,
  168717936,
  666307205,
  1188179964,
  773529912,
  1546045734,
  1294757372,
  1522805485,
  1396182291,
  2643833823,
  1695183700,
  2343527390,
  1986661051,
  1014477480,
  2177026350,
  1206759142,
  2456956037,
  344077627,
  2730485921,
  1290863460,
  2820302411,
  3158454273,
  3259730800,
  3505952657,
  3345764771,
  106217008,
  3516065817,
  3606008344,
  3600352804,
  1432725776,
  4094571909,
  1467031594,
  275423344,
  851169720,
  430227734,
  3100823752,
  506948616,
  1363258195,
  659060556,
  3750685593,
  883997877,
  3785050280,
  958139571,
  3318307427,
  1322822218,
  3812723403,
  1537002063,
  2003034995,
  1747873779,
  3602036899,
  1955562222,
  1575990012,
  2024104815,
  1125592928,
  2227730452,
  2716904306,
  2361852424,
  442776044,
  2428436474,
  593698344,
  2756734187,
  3733110249,
  3204031479,
  2999351573,
  3329325298,
  3815920427,
  3391569614,
  3928383900,
  3515267271,
  566280711,
  3940187606,
  3454069534,
  4118630271,
  4000239992,
  116418474,
  1914138554,
  174292421,
  2731055270,
  289380356,
  3203993006,
  460393269,
  320620315,
  685471733,
  587496836,
  852142971,
  1086792851,
  1017036298,
  365543100,
  1126000580,
  2618297676,
  1288033470,
  3409855158,
  1501505948,
  4234509866,
  1607167915,
  987167468,
  1816402316,
  1246189591
];
function SHA512$3() {
  if (!(this instanceof SHA512$3))
    return new SHA512$3();
  BlockHash$1.call(this), this.h = [
    1779033703,
    4089235720,
    3144134277,
    2227873595,
    1013904242,
    4271175723,
    2773480762,
    1595750129,
    1359893119,
    2917565137,
    2600822924,
    725511199,
    528734635,
    4215389547,
    1541459225,
    327033209
  ], this.k = sha512_K, this.W = new Array(160);
}
utils$q.inherits(SHA512$3, BlockHash$1);
var _512 = SHA512$3;
SHA512$3.blockSize = 1024;
SHA512$3.outSize = 512;
SHA512$3.hmacStrength = 192;
SHA512$3.padLength = 128;
SHA512$3.prototype._prepareBlock = function(c, u) {
  for (var p = this.W, a = 0; a < 32; a++)
    p[a] = c[u + a];
  for (; a < p.length; a += 2) {
    var A = g1_512_hi(p[a - 4], p[a - 3]), b = g1_512_lo(p[a - 4], p[a - 3]), F = p[a - 14], le = p[a - 13], L = g0_512_hi(p[a - 30], p[a - 29]), pe = g0_512_lo(p[a - 30], p[a - 29]), $ = p[a - 32], Ee = p[a - 31];
    p[a] = sum64_4_hi(
      A,
      b,
      F,
      le,
      L,
      pe,
      $,
      Ee
    ), p[a + 1] = sum64_4_lo(
      A,
      b,
      F,
      le,
      L,
      pe,
      $,
      Ee
    );
  }
};
SHA512$3.prototype._update = function(c, u) {
  this._prepareBlock(c, u);
  var p = this.W, a = this.h[0], A = this.h[1], b = this.h[2], F = this.h[3], le = this.h[4], L = this.h[5], pe = this.h[6], $ = this.h[7], Ee = this.h[8], be = this.h[9], He = this.h[10], Pe = this.h[11], nr = this.h[12], ir = this.h[13], or = this.h[14], lr = this.h[15];
  assert$l(this.k.length === p.length);
  for (var Ir = 0; Ir < p.length; Ir += 2) {
    var xr = or, kr = lr, Ce = s1_512_hi(Ee, be), tr = s1_512_lo(Ee, be), Fe = ch64_hi(Ee, be, He, Pe, nr), Sr = ch64_lo(Ee, be, He, Pe, nr, ir), er = this.k[Ir], Ie = this.k[Ir + 1], xe = p[Ir], rr = p[Ir + 1], ar = sum64_5_hi(
      xr,
      kr,
      Ce,
      tr,
      Fe,
      Sr,
      er,
      Ie,
      xe,
      rr
    ), yr = sum64_5_lo(
      xr,
      kr,
      Ce,
      tr,
      Fe,
      Sr,
      er,
      Ie,
      xe,
      rr
    );
    xr = s0_512_hi(a, A), kr = s0_512_lo(a, A), Ce = maj64_hi(a, A, b, F, le), tr = maj64_lo(a, A, b, F, le, L);
    var _r = sum64_hi(xr, kr, Ce, tr), Or = sum64_lo(xr, kr, Ce, tr);
    or = nr, lr = ir, nr = He, ir = Pe, He = Ee, Pe = be, Ee = sum64_hi(pe, $, ar, yr), be = sum64_lo($, $, ar, yr), pe = le, $ = L, le = b, L = F, b = a, F = A, a = sum64_hi(ar, yr, _r, Or), A = sum64_lo(ar, yr, _r, Or);
  }
  sum64(this.h, 0, a, A), sum64(this.h, 2, b, F), sum64(this.h, 4, le, L), sum64(this.h, 6, pe, $), sum64(this.h, 8, Ee, be), sum64(this.h, 10, He, Pe), sum64(this.h, 12, nr, ir), sum64(this.h, 14, or, lr);
};
SHA512$3.prototype._digest = function(c) {
  return c === "hex" ? utils$q.toHex32(this.h, "big") : utils$q.split32(this.h, "big");
};
function ch64_hi(n, c, u, p, a) {
  var A = n & u ^ ~n & a;
  return A < 0 && (A += 4294967296), A;
}
function ch64_lo(n, c, u, p, a, A) {
  var b = c & p ^ ~c & A;
  return b < 0 && (b += 4294967296), b;
}
function maj64_hi(n, c, u, p, a) {
  var A = n & u ^ n & a ^ u & a;
  return A < 0 && (A += 4294967296), A;
}
function maj64_lo(n, c, u, p, a, A) {
  var b = c & p ^ c & A ^ p & A;
  return b < 0 && (b += 4294967296), b;
}
function s0_512_hi(n, c) {
  var u = rotr64_hi(n, c, 28), p = rotr64_hi(c, n, 2), a = rotr64_hi(c, n, 7), A = u ^ p ^ a;
  return A < 0 && (A += 4294967296), A;
}
function s0_512_lo(n, c) {
  var u = rotr64_lo(n, c, 28), p = rotr64_lo(c, n, 2), a = rotr64_lo(c, n, 7), A = u ^ p ^ a;
  return A < 0 && (A += 4294967296), A;
}
function s1_512_hi(n, c) {
  var u = rotr64_hi(n, c, 14), p = rotr64_hi(n, c, 18), a = rotr64_hi(c, n, 9), A = u ^ p ^ a;
  return A < 0 && (A += 4294967296), A;
}
function s1_512_lo(n, c) {
  var u = rotr64_lo(n, c, 14), p = rotr64_lo(n, c, 18), a = rotr64_lo(c, n, 9), A = u ^ p ^ a;
  return A < 0 && (A += 4294967296), A;
}
function g0_512_hi(n, c) {
  var u = rotr64_hi(n, c, 1), p = rotr64_hi(n, c, 8), a = shr64_hi(n, c, 7), A = u ^ p ^ a;
  return A < 0 && (A += 4294967296), A;
}
function g0_512_lo(n, c) {
  var u = rotr64_lo(n, c, 1), p = rotr64_lo(n, c, 8), a = shr64_lo(n, c, 7), A = u ^ p ^ a;
  return A < 0 && (A += 4294967296), A;
}
function g1_512_hi(n, c) {
  var u = rotr64_hi(n, c, 19), p = rotr64_hi(c, n, 29), a = shr64_hi(n, c, 6), A = u ^ p ^ a;
  return A < 0 && (A += 4294967296), A;
}
function g1_512_lo(n, c) {
  var u = rotr64_lo(n, c, 19), p = rotr64_lo(c, n, 29), a = shr64_lo(n, c, 6), A = u ^ p ^ a;
  return A < 0 && (A += 4294967296), A;
}
var utils$p = utils$w, SHA512$2 = _512;
function SHA384$1() {
  if (!(this instanceof SHA384$1))
    return new SHA384$1();
  SHA512$2.call(this), this.h = [
    3418070365,
    3238371032,
    1654270250,
    914150663,
    2438529370,
    812702999,
    355462360,
    4144912697,
    1731405415,
    4290775857,
    2394180231,
    1750603025,
    3675008525,
    1694076839,
    1203062813,
    3204075428
  ];
}
utils$p.inherits(SHA384$1, SHA512$2);
var _384 = SHA384$1;
SHA384$1.blockSize = 1024;
SHA384$1.outSize = 384;
SHA384$1.hmacStrength = 192;
SHA384$1.padLength = 128;
SHA384$1.prototype._digest = function(c) {
  return c === "hex" ? utils$p.toHex32(this.h.slice(0, 12), "big") : utils$p.split32(this.h.slice(0, 12), "big");
};
sha$1.sha1 = _1;
sha$1.sha224 = _224;
sha$1.sha256 = _256;
sha$1.sha384 = _384;
sha$1.sha512 = _512;
var ripemd$1 = {}, utils$o = utils$w, common$1 = common$6, rotl32 = utils$o.rotl32, sum32 = utils$o.sum32, sum32_3 = utils$o.sum32_3, sum32_4 = utils$o.sum32_4, BlockHash = common$1.BlockHash;
function RIPEMD160$3() {
  if (!(this instanceof RIPEMD160$3))
    return new RIPEMD160$3();
  BlockHash.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.endian = "little";
}
utils$o.inherits(RIPEMD160$3, BlockHash);
ripemd$1.ripemd160 = RIPEMD160$3;
RIPEMD160$3.blockSize = 512;
RIPEMD160$3.outSize = 160;
RIPEMD160$3.hmacStrength = 192;
RIPEMD160$3.padLength = 64;
RIPEMD160$3.prototype._update = function(c, u) {
  for (var p = this.h[0], a = this.h[1], A = this.h[2], b = this.h[3], F = this.h[4], le = p, L = a, pe = A, $ = b, Ee = F, be = 0; be < 80; be++) {
    var He = sum32(
      rotl32(
        sum32_4(p, f$8(be, a, A, b), c[r[be] + u], K$1(be)),
        s[be]
      ),
      F
    );
    p = F, F = b, b = rotl32(A, 10), A = a, a = He, He = sum32(
      rotl32(
        sum32_4(le, f$8(79 - be, L, pe, $), c[rh[be] + u], Kh(be)),
        sh[be]
      ),
      Ee
    ), le = Ee, Ee = $, $ = rotl32(pe, 10), pe = L, L = He;
  }
  He = sum32_3(this.h[1], A, $), this.h[1] = sum32_3(this.h[2], b, Ee), this.h[2] = sum32_3(this.h[3], F, le), this.h[3] = sum32_3(this.h[4], p, L), this.h[4] = sum32_3(this.h[0], a, pe), this.h[0] = He;
};
RIPEMD160$3.prototype._digest = function(c) {
  return c === "hex" ? utils$o.toHex32(this.h, "little") : utils$o.split32(this.h, "little");
};
function f$8(n, c, u, p) {
  return n <= 15 ? c ^ u ^ p : n <= 31 ? c & u | ~c & p : n <= 47 ? (c | ~u) ^ p : n <= 63 ? c & p | u & ~p : c ^ (u | ~p);
}
function K$1(n) {
  return n <= 15 ? 0 : n <= 31 ? 1518500249 : n <= 47 ? 1859775393 : n <= 63 ? 2400959708 : 2840853838;
}
function Kh(n) {
  return n <= 15 ? 1352829926 : n <= 31 ? 1548603684 : n <= 47 ? 1836072691 : n <= 63 ? 2053994217 : 0;
}
var r = [
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  7,
  4,
  13,
  1,
  10,
  6,
  15,
  3,
  12,
  0,
  9,
  5,
  2,
  14,
  11,
  8,
  3,
  10,
  14,
  4,
  9,
  15,
  8,
  1,
  2,
  7,
  0,
  6,
  13,
  11,
  5,
  12,
  1,
  9,
  11,
  10,
  0,
  8,
  12,
  4,
  13,
  3,
  7,
  15,
  14,
  5,
  6,
  2,
  4,
  0,
  5,
  9,
  7,
  12,
  2,
  10,
  14,
  1,
  3,
  8,
  11,
  6,
  15,
  13
], rh = [
  5,
  14,
  7,
  0,
  9,
  2,
  11,
  4,
  13,
  6,
  15,
  8,
  1,
  10,
  3,
  12,
  6,
  11,
  3,
  7,
  0,
  13,
  5,
  10,
  14,
  15,
  8,
  12,
  4,
  9,
  1,
  2,
  15,
  5,
  1,
  3,
  7,
  14,
  6,
  9,
  11,
  8,
  12,
  2,
  10,
  0,
  4,
  13,
  8,
  6,
  4,
  1,
  3,
  11,
  15,
  0,
  5,
  12,
  2,
  13,
  9,
  7,
  10,
  14,
  12,
  15,
  10,
  4,
  1,
  5,
  8,
  7,
  6,
  2,
  13,
  14,
  0,
  3,
  9,
  11
], s = [
  11,
  14,
  15,
  12,
  5,
  8,
  7,
  9,
  11,
  13,
  14,
  15,
  6,
  7,
  9,
  8,
  7,
  6,
  8,
  13,
  11,
  9,
  7,
  15,
  7,
  12,
  15,
  9,
  11,
  7,
  13,
  12,
  11,
  13,
  6,
  7,
  14,
  9,
  13,
  15,
  14,
  8,
  13,
  6,
  5,
  12,
  7,
  5,
  11,
  12,
  14,
  15,
  14,
  15,
  9,
  8,
  9,
  14,
  5,
  6,
  8,
  6,
  5,
  12,
  9,
  15,
  5,
  11,
  6,
  8,
  13,
  12,
  5,
  12,
  13,
  14,
  11,
  8,
  5,
  6
], sh = [
  8,
  9,
  9,
  11,
  13,
  15,
  15,
  5,
  7,
  7,
  8,
  11,
  14,
  14,
  12,
  6,
  9,
  13,
  15,
  7,
  12,
  8,
  9,
  11,
  7,
  7,
  12,
  7,
  6,
  15,
  13,
  11,
  9,
  7,
  15,
  11,
  8,
  6,
  6,
  14,
  12,
  13,
  5,
  14,
  13,
  13,
  7,
  5,
  15,
  5,
  8,
  11,
  14,
  14,
  6,
  14,
  6,
  9,
  12,
  9,
  12,
  5,
  15,
  8,
  8,
  5,
  12,
  9,
  12,
  5,
  14,
  6,
  8,
  13,
  6,
  5,
  15,
  13,
  11,
  11
], utils$n = utils$w, assert$k = minimalisticAssert;
function Hmac$1(n, c, u) {
  if (!(this instanceof Hmac$1))
    return new Hmac$1(n, c, u);
  this.Hash = n, this.blockSize = n.blockSize / 8, this.outSize = n.outSize / 8, this.inner = null, this.outer = null, this._init(utils$n.toArray(c, u));
}
var hmac$5 = Hmac$1;
Hmac$1.prototype._init = function(c) {
  c.length > this.blockSize && (c = new this.Hash().update(c).digest()), assert$k(c.length <= this.blockSize);
  for (var u = c.length; u < this.blockSize; u++)
    c.push(0);
  for (u = 0; u < c.length; u++)
    c[u] ^= 54;
  for (this.inner = new this.Hash().update(c), u = 0; u < c.length; u++)
    c[u] ^= 106;
  this.outer = new this.Hash().update(c);
};
Hmac$1.prototype.update = function(c, u) {
  return this.inner.update(c, u), this;
};
Hmac$1.prototype.digest = function(c) {
  return this.outer.update(this.inner.digest()), this.outer.digest(c);
};
(function(n) {
  var c = n;
  c.utils = utils$w, c.common = common$6, c.sha = sha$1, c.ripemd = ripemd$1, c.hmac = hmac$5, c.sha1 = c.sha.sha1, c.sha256 = c.sha.sha256, c.sha224 = c.sha.sha224, c.sha384 = c.sha.sha384, c.sha512 = c.sha.sha512, c.ripemd160 = c.ripemd.ripemd160;
})(hash$a);
var secp256k1$9, hasRequiredSecp256k1$1;
function requireSecp256k1$1() {
  return hasRequiredSecp256k1$1 || (hasRequiredSecp256k1$1 = 1, secp256k1$9 = {
    doubles: {
      step: 4,
      points: [
        [
          "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
          "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
        ],
        [
          "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
          "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
        ],
        [
          "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
          "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
        ],
        [
          "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
          "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
        ],
        [
          "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
          "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
        ],
        [
          "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
          "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
        ],
        [
          "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
          "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
        ],
        [
          "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
          "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
        ],
        [
          "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
          "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
        ],
        [
          "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
          "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
        ],
        [
          "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
          "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
        ],
        [
          "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
          "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
        ],
        [
          "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
          "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
        ],
        [
          "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
          "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
        ],
        [
          "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
          "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
        ],
        [
          "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
          "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
        ],
        [
          "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
          "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
        ],
        [
          "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
          "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
        ],
        [
          "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
          "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
        ],
        [
          "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
          "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
        ],
        [
          "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
          "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
        ],
        [
          "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
          "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
        ],
        [
          "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
          "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
        ],
        [
          "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
          "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
        ],
        [
          "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
          "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
        ],
        [
          "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
          "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
        ],
        [
          "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
          "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
        ],
        [
          "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
          "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
        ],
        [
          "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
          "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
        ],
        [
          "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
          "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
        ],
        [
          "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
          "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
        ],
        [
          "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
          "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
        ],
        [
          "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
          "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
        ],
        [
          "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
          "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
        ],
        [
          "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
          "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
        ],
        [
          "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
          "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
        ],
        [
          "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
          "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
        ],
        [
          "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
          "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
        ],
        [
          "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
          "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
        ],
        [
          "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
          "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
        ],
        [
          "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
          "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
        ],
        [
          "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
          "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
        ],
        [
          "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
          "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
        ],
        [
          "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
          "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
        ],
        [
          "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
          "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
        ],
        [
          "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
          "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
        ],
        [
          "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
          "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
        ],
        [
          "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
          "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
        ],
        [
          "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
          "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
        ],
        [
          "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
          "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
        ],
        [
          "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
          "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
        ],
        [
          "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
          "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
        ],
        [
          "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
          "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
        ],
        [
          "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
          "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
        ],
        [
          "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
          "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
        ],
        [
          "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
          "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
        ],
        [
          "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
          "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
        ],
        [
          "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
          "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
        ],
        [
          "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
          "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
        ],
        [
          "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
          "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
        ],
        [
          "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
          "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
        ],
        [
          "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
          "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
        ],
        [
          "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
          "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
        ],
        [
          "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
          "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
        ],
        [
          "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
          "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
        ]
      ]
    },
    naf: {
      wnd: 7,
      points: [
        [
          "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
          "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
        ],
        [
          "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
          "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
        ],
        [
          "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
          "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
        ],
        [
          "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
          "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
        ],
        [
          "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
          "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
        ],
        [
          "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
          "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
        ],
        [
          "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
          "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
        ],
        [
          "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
          "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
        ],
        [
          "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
          "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
        ],
        [
          "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
          "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
        ],
        [
          "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
          "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
        ],
        [
          "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
          "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
        ],
        [
          "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
          "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
        ],
        [
          "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
          "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
        ],
        [
          "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
          "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
        ],
        [
          "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
          "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
        ],
        [
          "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
          "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
        ],
        [
          "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
          "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
        ],
        [
          "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
          "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
        ],
        [
          "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
          "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
        ],
        [
          "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
          "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
        ],
        [
          "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
          "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
        ],
        [
          "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
          "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
        ],
        [
          "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
          "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
        ],
        [
          "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
          "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
        ],
        [
          "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
          "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
        ],
        [
          "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
          "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
        ],
        [
          "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
          "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
        ],
        [
          "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
          "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
        ],
        [
          "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
          "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
        ],
        [
          "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
          "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
        ],
        [
          "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
          "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
        ],
        [
          "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
          "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
        ],
        [
          "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
          "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
        ],
        [
          "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
          "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
        ],
        [
          "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
          "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
        ],
        [
          "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
          "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
        ],
        [
          "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
          "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
        ],
        [
          "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
          "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
        ],
        [
          "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
          "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
        ],
        [
          "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
          "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
        ],
        [
          "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
          "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
        ],
        [
          "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
          "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
        ],
        [
          "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
          "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
        ],
        [
          "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
          "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
        ],
        [
          "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
          "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
        ],
        [
          "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
          "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
        ],
        [
          "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
          "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
        ],
        [
          "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
          "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
        ],
        [
          "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
          "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
        ],
        [
          "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
          "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
        ],
        [
          "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
          "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
        ],
        [
          "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
          "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
        ],
        [
          "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
          "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
        ],
        [
          "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
          "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
        ],
        [
          "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
          "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
        ],
        [
          "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
          "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
        ],
        [
          "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
          "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
        ],
        [
          "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
          "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
        ],
        [
          "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
          "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
        ],
        [
          "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
          "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
        ],
        [
          "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
          "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
        ],
        [
          "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
          "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
        ],
        [
          "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
          "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
        ],
        [
          "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
          "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
        ],
        [
          "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
          "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
        ],
        [
          "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
          "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
        ],
        [
          "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
          "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
        ],
        [
          "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
          "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
        ],
        [
          "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
          "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
        ],
        [
          "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
          "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
        ],
        [
          "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
          "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
        ],
        [
          "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
          "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
        ],
        [
          "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
          "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
        ],
        [
          "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
          "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
        ],
        [
          "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
          "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
        ],
        [
          "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
          "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
        ],
        [
          "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
          "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
        ],
        [
          "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
          "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
        ],
        [
          "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
          "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
        ],
        [
          "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
          "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
        ],
        [
          "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
          "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
        ],
        [
          "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
          "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
        ],
        [
          "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
          "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
        ],
        [
          "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
          "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
        ],
        [
          "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
          "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
        ],
        [
          "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
          "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
        ],
        [
          "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
          "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
        ],
        [
          "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
          "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
        ],
        [
          "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
          "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
        ],
        [
          "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
          "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
        ],
        [
          "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
          "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
        ],
        [
          "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
          "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
        ],
        [
          "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
          "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
        ],
        [
          "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
          "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
        ],
        [
          "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
          "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
        ],
        [
          "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
          "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
        ],
        [
          "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
          "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
        ],
        [
          "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
          "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
        ],
        [
          "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
          "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
        ],
        [
          "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
          "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
        ],
        [
          "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
          "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
        ],
        [
          "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
          "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
        ],
        [
          "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
          "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
        ],
        [
          "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
          "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
        ],
        [
          "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
          "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
        ],
        [
          "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
          "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
        ],
        [
          "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
          "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
        ],
        [
          "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
          "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
        ],
        [
          "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
          "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
        ],
        [
          "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
          "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
        ],
        [
          "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
          "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
        ],
        [
          "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
          "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
        ],
        [
          "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
          "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
        ],
        [
          "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
          "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
        ],
        [
          "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
          "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
        ],
        [
          "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
          "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
        ],
        [
          "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
          "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
        ],
        [
          "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
          "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
        ],
        [
          "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
          "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
        ],
        [
          "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
          "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
        ],
        [
          "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
          "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
        ],
        [
          "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
          "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
        ],
        [
          "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
          "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
        ],
        [
          "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
          "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
        ],
        [
          "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
          "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
        ],
        [
          "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
          "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
        ]
      ]
    }
  }), secp256k1$9;
}
(function(n) {
  var c = n, u = hash$a, p = curve$1, a = utils$C, A = a.assert;
  function b(L) {
    L.type === "short" ? this.curve = new p.short(L) : L.type === "edwards" ? this.curve = new p.edwards(L) : this.curve = new p.mont(L), this.g = this.curve.g, this.n = this.curve.n, this.hash = L.hash, A(this.g.validate(), "Invalid curve"), A(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
  }
  c.PresetCurve = b;
  function F(L, pe) {
    Object.defineProperty(c, L, {
      configurable: !0,
      enumerable: !0,
      get: function() {
        var $ = new b(pe);
        return Object.defineProperty(c, L, {
          configurable: !0,
          enumerable: !0,
          value: $
        }), $;
      }
    });
  }
  F("p192", {
    type: "short",
    prime: "p192",
    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
    hash: u.sha256,
    gRed: !1,
    g: [
      "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
      "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
    ]
  }), F("p224", {
    type: "short",
    prime: "p224",
    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
    hash: u.sha256,
    gRed: !1,
    g: [
      "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
      "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
    ]
  }), F("p256", {
    type: "short",
    prime: null,
    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
    hash: u.sha256,
    gRed: !1,
    g: [
      "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
      "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
    ]
  }), F("p384", {
    type: "short",
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: u.sha384,
    gRed: !1,
    g: [
      "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
      "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
  }), F("p521", {
    type: "short",
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: u.sha512,
    gRed: !1,
    g: [
      "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
      "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
  }), F("curve25519", {
    type: "mont",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "76d06",
    b: "1",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: u.sha256,
    gRed: !1,
    g: [
      "9"
    ]
  }), F("ed25519", {
    type: "edwards",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "-1",
    c: "1",
    // -121665 * (121666^(-1)) (mod P)
    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: u.sha256,
    gRed: !1,
    g: [
      "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
      // 4/5
      "6666666666666666666666666666666666666666666666666666666666666658"
    ]
  });
  var le;
  try {
    le = requireSecp256k1$1();
  } catch {
    le = void 0;
  }
  F("secp256k1", {
    type: "short",
    prime: "k256",
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
    a: "0",
    b: "7",
    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
    h: "1",
    hash: u.sha256,
    // Precomputed endomorphism
    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
    basis: [
      {
        a: "3086d221a7d46bcde86c90e49284eb15",
        b: "-e4437ed6010e88286f547fa90abfe4c3"
      },
      {
        a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
        b: "3086d221a7d46bcde86c90e49284eb15"
      }
    ],
    gRed: !1,
    g: [
      "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
      "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
      le
    ]
  });
})(curves$1);
var hash$9 = hash$a, utils$m = utils$B, assert$j = minimalisticAssert;
function HmacDRBG(n) {
  if (!(this instanceof HmacDRBG))
    return new HmacDRBG(n);
  this.hash = n.hash, this.predResist = !!n.predResist, this.outLen = this.hash.outSize, this.minEntropy = n.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
  var c = utils$m.toArray(n.entropy, n.entropyEnc || "hex"), u = utils$m.toArray(n.nonce, n.nonceEnc || "hex"), p = utils$m.toArray(n.pers, n.persEnc || "hex");
  assert$j(
    c.length >= this.minEntropy / 8,
    "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
  ), this._init(c, u, p);
}
var hmacDrbg = HmacDRBG;
HmacDRBG.prototype._init = function(c, u, p) {
  var a = c.concat(u).concat(p);
  this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);
  for (var A = 0; A < this.V.length; A++)
    this.K[A] = 0, this.V[A] = 1;
  this._update(a), this._reseed = 1, this.reseedInterval = 281474976710656;
};
HmacDRBG.prototype._hmac = function() {
  return new hash$9.hmac(this.hash, this.K);
};
HmacDRBG.prototype._update = function(c) {
  var u = this._hmac().update(this.V).update([0]);
  c && (u = u.update(c)), this.K = u.digest(), this.V = this._hmac().update(this.V).digest(), c && (this.K = this._hmac().update(this.V).update([1]).update(c).digest(), this.V = this._hmac().update(this.V).digest());
};
HmacDRBG.prototype.reseed = function(c, u, p, a) {
  typeof u != "string" && (a = p, p = u, u = null), c = utils$m.toArray(c, u), p = utils$m.toArray(p, a), assert$j(
    c.length >= this.minEntropy / 8,
    "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
  ), this._update(c.concat(p || [])), this._reseed = 1;
};
HmacDRBG.prototype.generate = function(c, u, p, a) {
  if (this._reseed > this.reseedInterval)
    throw new Error("Reseed is required");
  typeof u != "string" && (a = p, p = u, u = null), p && (p = utils$m.toArray(p, a || "hex"), this._update(p));
  for (var A = []; A.length < c; )
    this.V = this._hmac().update(this.V).digest(), A = A.concat(this.V);
  var b = A.slice(0, c);
  return this._update(p), this._reseed++, utils$m.encode(b, u);
};
var BN$2 = bnExports, utils$l = utils$C, assert$i = utils$l.assert;
function KeyPair$2(n, c) {
  this.ec = n, this.priv = null, this.pub = null, c.priv && this._importPrivate(c.priv, c.privEnc), c.pub && this._importPublic(c.pub, c.pubEnc);
}
var key$2 = KeyPair$2;
KeyPair$2.fromPublic = function(c, u, p) {
  return u instanceof KeyPair$2 ? u : new KeyPair$2(c, {
    pub: u,
    pubEnc: p
  });
};
KeyPair$2.fromPrivate = function(c, u, p) {
  return u instanceof KeyPair$2 ? u : new KeyPair$2(c, {
    priv: u,
    privEnc: p
  });
};
KeyPair$2.prototype.validate = function() {
  var c = this.getPublic();
  return c.isInfinity() ? { result: !1, reason: "Invalid public key" } : c.validate() ? c.mul(this.ec.curve.n).isInfinity() ? { result: !0, reason: null } : { result: !1, reason: "Public key * N != O" } : { result: !1, reason: "Public key is not a point" };
};
KeyPair$2.prototype.getPublic = function(c, u) {
  return typeof c == "string" && (u = c, c = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), u ? this.pub.encode(u, c) : this.pub;
};
KeyPair$2.prototype.getPrivate = function(c) {
  return c === "hex" ? this.priv.toString(16, 2) : this.priv;
};
KeyPair$2.prototype._importPrivate = function(c, u) {
  this.priv = new BN$2(c, u || 16), this.priv = this.priv.umod(this.ec.curve.n);
};
KeyPair$2.prototype._importPublic = function(c, u) {
  if (c.x || c.y) {
    this.ec.curve.type === "mont" ? assert$i(c.x, "Need x coordinate") : (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") && assert$i(c.x && c.y, "Need both x and y coordinate"), this.pub = this.ec.curve.point(c.x, c.y);
    return;
  }
  this.pub = this.ec.curve.decodePoint(c, u);
};
KeyPair$2.prototype.derive = function(c) {
  return c.validate() || assert$i(c.validate(), "public point not validated"), c.mul(this.priv).getX();
};
KeyPair$2.prototype.sign = function(c, u, p) {
  return this.ec.sign(c, this, u, p);
};
KeyPair$2.prototype.verify = function(c, u, p) {
  return this.ec.verify(c, u, this, void 0, p);
};
KeyPair$2.prototype.inspect = function() {
  return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};
var BN$1 = bnExports, utils$k = utils$C, assert$h = utils$k.assert;
function Signature$2(n, c) {
  if (n instanceof Signature$2)
    return n;
  this._importDER(n, c) || (assert$h(n.r && n.s, "Signature without r or s"), this.r = new BN$1(n.r, 16), this.s = new BN$1(n.s, 16), n.recoveryParam === void 0 ? this.recoveryParam = null : this.recoveryParam = n.recoveryParam);
}
var signature$3 = Signature$2;
function Position() {
  this.place = 0;
}
function getLength(n, c) {
  var u = n[c.place++];
  if (!(u & 128))
    return u;
  var p = u & 15;
  if (p === 0 || p > 4 || n[c.place] === 0)
    return !1;
  for (var a = 0, A = 0, b = c.place; A < p; A++, b++)
    a <<= 8, a |= n[b], a >>>= 0;
  return a <= 127 ? !1 : (c.place = b, a);
}
function rmPadding(n) {
  for (var c = 0, u = n.length - 1; !n[c] && !(n[c + 1] & 128) && c < u; )
    c++;
  return c === 0 ? n : n.slice(c);
}
Signature$2.prototype._importDER = function(c, u) {
  c = utils$k.toArray(c, u);
  var p = new Position();
  if (c[p.place++] !== 48)
    return !1;
  var a = getLength(c, p);
  if (a === !1 || a + p.place !== c.length || c[p.place++] !== 2)
    return !1;
  var A = getLength(c, p);
  if (A === !1 || c[p.place] & 128)
    return !1;
  var b = c.slice(p.place, A + p.place);
  if (p.place += A, c[p.place++] !== 2)
    return !1;
  var F = getLength(c, p);
  if (F === !1 || c.length !== F + p.place || c[p.place] & 128)
    return !1;
  var le = c.slice(p.place, F + p.place);
  if (b[0] === 0)
    if (b[1] & 128)
      b = b.slice(1);
    else
      return !1;
  if (le[0] === 0)
    if (le[1] & 128)
      le = le.slice(1);
    else
      return !1;
  return this.r = new BN$1(b), this.s = new BN$1(le), this.recoveryParam = null, !0;
};
function constructLength(n, c) {
  if (c < 128) {
    n.push(c);
    return;
  }
  var u = 1 + (Math.log(c) / Math.LN2 >>> 3);
  for (n.push(u | 128); --u; )
    n.push(c >>> (u << 3) & 255);
  n.push(c);
}
Signature$2.prototype.toDER = function(c) {
  var u = this.r.toArray(), p = this.s.toArray();
  for (u[0] & 128 && (u = [0].concat(u)), p[0] & 128 && (p = [0].concat(p)), u = rmPadding(u), p = rmPadding(p); !p[0] && !(p[1] & 128); )
    p = p.slice(1);
  var a = [2];
  constructLength(a, u.length), a = a.concat(u), a.push(2), constructLength(a, p.length);
  var A = a.concat(p), b = [48];
  return constructLength(b, A.length), b = b.concat(A), utils$k.encode(b, c);
};
var ec$4, hasRequiredEc;
function requireEc() {
  if (hasRequiredEc) return ec$4;
  hasRequiredEc = 1;
  var n = bnExports, c = hmacDrbg, u = utils$C, p = curves$1, a = requireBrorand(), A = u.assert, b = key$2, F = signature$3;
  function le(L) {
    if (!(this instanceof le))
      return new le(L);
    typeof L == "string" && (A(
      Object.prototype.hasOwnProperty.call(p, L),
      "Unknown curve " + L
    ), L = p[L]), L instanceof p.PresetCurve && (L = { curve: L }), this.curve = L.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = L.curve.g, this.g.precompute(L.curve.n.bitLength() + 1), this.hash = L.hash || L.curve.hash;
  }
  return ec$4 = le, le.prototype.keyPair = function(pe) {
    return new b(this, pe);
  }, le.prototype.keyFromPrivate = function(pe, $) {
    return b.fromPrivate(this, pe, $);
  }, le.prototype.keyFromPublic = function(pe, $) {
    return b.fromPublic(this, pe, $);
  }, le.prototype.genKeyPair = function(pe) {
    pe || (pe = {});
    for (var $ = new c({
      hash: this.hash,
      pers: pe.pers,
      persEnc: pe.persEnc || "utf8",
      entropy: pe.entropy || a(this.hash.hmacStrength),
      entropyEnc: pe.entropy && pe.entropyEnc || "utf8",
      nonce: this.n.toArray()
    }), Ee = this.n.byteLength(), be = this.n.sub(new n(2)); ; ) {
      var He = new n($.generate(Ee));
      if (!(He.cmp(be) > 0))
        return He.iaddn(1), this.keyFromPrivate(He);
    }
  }, le.prototype._truncateToN = function(pe, $, Ee) {
    var be;
    if (n.isBN(pe) || typeof pe == "number")
      pe = new n(pe, 16), be = pe.byteLength();
    else if (typeof pe == "object")
      be = pe.length, pe = new n(pe, 16);
    else {
      var He = pe.toString();
      be = He.length + 1 >>> 1, pe = new n(He, 16);
    }
    typeof Ee != "number" && (Ee = be * 8);
    var Pe = Ee - this.n.bitLength();
    return Pe > 0 && (pe = pe.ushrn(Pe)), !$ && pe.cmp(this.n) >= 0 ? pe.sub(this.n) : pe;
  }, le.prototype.sign = function(pe, $, Ee, be) {
    if (typeof Ee == "object" && (be = Ee, Ee = null), be || (be = {}), typeof pe != "string" && typeof pe != "number" && !n.isBN(pe)) {
      A(
        typeof pe == "object" && pe && typeof pe.length == "number",
        "Expected message to be an array-like, a hex string, or a BN instance"
      ), A(pe.length >>> 0 === pe.length);
      for (var He = 0; He < pe.length; He++) A((pe[He] & 255) === pe[He]);
    }
    $ = this.keyFromPrivate($, Ee), pe = this._truncateToN(pe, !1, be.msgBitLength), A(!pe.isNeg(), "Can not sign a negative message");
    var Pe = this.n.byteLength(), nr = $.getPrivate().toArray("be", Pe), ir = pe.toArray("be", Pe);
    A(new n(ir).eq(pe), "Can not sign message");
    for (var or = new c({
      hash: this.hash,
      entropy: nr,
      nonce: ir,
      pers: be.pers,
      persEnc: be.persEnc || "utf8"
    }), lr = this.n.sub(new n(1)), Ir = 0; ; Ir++) {
      var xr = be.k ? be.k(Ir) : new n(or.generate(this.n.byteLength()));
      if (xr = this._truncateToN(xr, !0), !(xr.cmpn(1) <= 0 || xr.cmp(lr) >= 0)) {
        var kr = this.g.mul(xr);
        if (!kr.isInfinity()) {
          var Ce = kr.getX(), tr = Ce.umod(this.n);
          if (tr.cmpn(0) !== 0) {
            var Fe = xr.invm(this.n).mul(tr.mul($.getPrivate()).iadd(pe));
            if (Fe = Fe.umod(this.n), Fe.cmpn(0) !== 0) {
              var Sr = (kr.getY().isOdd() ? 1 : 0) | (Ce.cmp(tr) !== 0 ? 2 : 0);
              return be.canonical && Fe.cmp(this.nh) > 0 && (Fe = this.n.sub(Fe), Sr ^= 1), new F({ r: tr, s: Fe, recoveryParam: Sr });
            }
          }
        }
      }
    }
  }, le.prototype.verify = function(pe, $, Ee, be, He) {
    He || (He = {}), pe = this._truncateToN(pe, !1, He.msgBitLength), Ee = this.keyFromPublic(Ee, be), $ = new F($, "hex");
    var Pe = $.r, nr = $.s;
    if (Pe.cmpn(1) < 0 || Pe.cmp(this.n) >= 0 || nr.cmpn(1) < 0 || nr.cmp(this.n) >= 0)
      return !1;
    var ir = nr.invm(this.n), or = ir.mul(pe).umod(this.n), lr = ir.mul(Pe).umod(this.n), Ir;
    return this.curve._maxwellTrick ? (Ir = this.g.jmulAdd(or, Ee.getPublic(), lr), Ir.isInfinity() ? !1 : Ir.eqXToP(Pe)) : (Ir = this.g.mulAdd(or, Ee.getPublic(), lr), Ir.isInfinity() ? !1 : Ir.getX().umod(this.n).cmp(Pe) === 0);
  }, le.prototype.recoverPubKey = function(L, pe, $, Ee) {
    A((3 & $) === $, "The recovery param is more than two bits"), pe = new F(pe, Ee);
    var be = this.n, He = new n(L), Pe = pe.r, nr = pe.s, ir = $ & 1, or = $ >> 1;
    if (Pe.cmp(this.curve.p.umod(this.curve.n)) >= 0 && or)
      throw new Error("Unable to find sencond key candinate");
    or ? Pe = this.curve.pointFromX(Pe.add(this.curve.n), ir) : Pe = this.curve.pointFromX(Pe, ir);
    var lr = pe.r.invm(be), Ir = be.sub(He).mul(lr).umod(be), xr = nr.mul(lr).umod(be);
    return this.g.mulAdd(Ir, Pe, xr);
  }, le.prototype.getKeyRecoveryParam = function(L, pe, $, Ee) {
    if (pe = new F(pe, Ee), pe.recoveryParam !== null)
      return pe.recoveryParam;
    for (var be = 0; be < 4; be++) {
      var He;
      try {
        He = this.recoverPubKey(L, pe, be);
      } catch {
        continue;
      }
      if (He.eq($))
        return be;
    }
    throw new Error("Unable to find valid recovery factor");
  }, ec$4;
}
var utils$j = utils$C, assert$g = utils$j.assert, parseBytes$2 = utils$j.parseBytes, cachedProperty$1 = utils$j.cachedProperty;
function KeyPair$1(n, c) {
  this.eddsa = n, this._secret = parseBytes$2(c.secret), n.isPoint(c.pub) ? this._pub = c.pub : this._pubBytes = parseBytes$2(c.pub);
}
KeyPair$1.fromPublic = function(c, u) {
  return u instanceof KeyPair$1 ? u : new KeyPair$1(c, { pub: u });
};
KeyPair$1.fromSecret = function(c, u) {
  return u instanceof KeyPair$1 ? u : new KeyPair$1(c, { secret: u });
};
KeyPair$1.prototype.secret = function() {
  return this._secret;
};
cachedProperty$1(KeyPair$1, "pubBytes", function() {
  return this.eddsa.encodePoint(this.pub());
});
cachedProperty$1(KeyPair$1, "pub", function() {
  return this._pubBytes ? this.eddsa.decodePoint(this._pubBytes) : this.eddsa.g.mul(this.priv());
});
cachedProperty$1(KeyPair$1, "privBytes", function() {
  var c = this.eddsa, u = this.hash(), p = c.encodingLength - 1, a = u.slice(0, c.encodingLength);
  return a[0] &= 248, a[p] &= 127, a[p] |= 64, a;
});
cachedProperty$1(KeyPair$1, "priv", function() {
  return this.eddsa.decodeInt(this.privBytes());
});
cachedProperty$1(KeyPair$1, "hash", function() {
  return this.eddsa.hash().update(this.secret()).digest();
});
cachedProperty$1(KeyPair$1, "messagePrefix", function() {
  return this.hash().slice(this.eddsa.encodingLength);
});
KeyPair$1.prototype.sign = function(c) {
  return assert$g(this._secret, "KeyPair can only verify"), this.eddsa.sign(c, this);
};
KeyPair$1.prototype.verify = function(c, u) {
  return this.eddsa.verify(c, u, this);
};
KeyPair$1.prototype.getSecret = function(c) {
  return assert$g(this._secret, "KeyPair is public only"), utils$j.encode(this.secret(), c);
};
KeyPair$1.prototype.getPublic = function(c) {
  return utils$j.encode(this.pubBytes(), c);
};
var key$1 = KeyPair$1, BN = bnExports, utils$i = utils$C, assert$f = utils$i.assert, cachedProperty = utils$i.cachedProperty, parseBytes$1 = utils$i.parseBytes;
function Signature$1(n, c) {
  this.eddsa = n, typeof c != "object" && (c = parseBytes$1(c)), Array.isArray(c) && (assert$f(c.length === n.encodingLength * 2, "Signature has invalid size"), c = {
    R: c.slice(0, n.encodingLength),
    S: c.slice(n.encodingLength)
  }), assert$f(c.R && c.S, "Signature without R or S"), n.isPoint(c.R) && (this._R = c.R), c.S instanceof BN && (this._S = c.S), this._Rencoded = Array.isArray(c.R) ? c.R : c.Rencoded, this._Sencoded = Array.isArray(c.S) ? c.S : c.Sencoded;
}
cachedProperty(Signature$1, "S", function() {
  return this.eddsa.decodeInt(this.Sencoded());
});
cachedProperty(Signature$1, "R", function() {
  return this.eddsa.decodePoint(this.Rencoded());
});
cachedProperty(Signature$1, "Rencoded", function() {
  return this.eddsa.encodePoint(this.R());
});
cachedProperty(Signature$1, "Sencoded", function() {
  return this.eddsa.encodeInt(this.S());
});
Signature$1.prototype.toBytes = function() {
  return this.Rencoded().concat(this.Sencoded());
};
Signature$1.prototype.toHex = function() {
  return utils$i.encode(this.toBytes(), "hex").toUpperCase();
};
var signature$2 = Signature$1, hash$8 = hash$a, curves = curves$1, utils$h = utils$C, assert$e = utils$h.assert, parseBytes = utils$h.parseBytes, KeyPair = key$1, Signature = signature$2;
function EDDSA(n) {
  if (assert$e(n === "ed25519", "only tested with ed25519 so far"), !(this instanceof EDDSA))
    return new EDDSA(n);
  n = curves[n].curve, this.curve = n, this.g = n.g, this.g.precompute(n.n.bitLength() + 1), this.pointClass = n.point().constructor, this.encodingLength = Math.ceil(n.n.bitLength() / 8), this.hash = hash$8.sha512;
}
var eddsa = EDDSA;
EDDSA.prototype.sign = function(c, u) {
  c = parseBytes(c);
  var p = this.keyFromSecret(u), a = this.hashInt(p.messagePrefix(), c), A = this.g.mul(a), b = this.encodePoint(A), F = this.hashInt(b, p.pubBytes(), c).mul(p.priv()), le = a.add(F).umod(this.curve.n);
  return this.makeSignature({ R: A, S: le, Rencoded: b });
};
EDDSA.prototype.verify = function(c, u, p) {
  if (c = parseBytes(c), u = this.makeSignature(u), u.S().gte(u.eddsa.curve.n) || u.S().isNeg())
    return !1;
  var a = this.keyFromPublic(p), A = this.hashInt(u.Rencoded(), a.pubBytes(), c), b = this.g.mul(u.S()), F = u.R().add(a.pub().mul(A));
  return F.eq(b);
};
EDDSA.prototype.hashInt = function() {
  for (var c = this.hash(), u = 0; u < arguments.length; u++)
    c.update(arguments[u]);
  return utils$h.intFromLE(c.digest()).umod(this.curve.n);
};
EDDSA.prototype.keyFromPublic = function(c) {
  return KeyPair.fromPublic(this, c);
};
EDDSA.prototype.keyFromSecret = function(c) {
  return KeyPair.fromSecret(this, c);
};
EDDSA.prototype.makeSignature = function(c) {
  return c instanceof Signature ? c : new Signature(this, c);
};
EDDSA.prototype.encodePoint = function(c) {
  var u = c.getY().toArray("le", this.encodingLength);
  return u[this.encodingLength - 1] |= c.getX().isOdd() ? 128 : 0, u;
};
EDDSA.prototype.decodePoint = function(c) {
  c = utils$h.parseBytes(c);
  var u = c.length - 1, p = c.slice(0, u).concat(c[u] & -129), a = (c[u] & 128) !== 0, A = utils$h.intFromLE(p);
  return this.curve.pointFromY(A, a);
};
EDDSA.prototype.encodeInt = function(c) {
  return c.toArray("le", this.encodingLength);
};
EDDSA.prototype.decodeInt = function(c) {
  return utils$h.intFromLE(c);
};
EDDSA.prototype.isPoint = function(c) {
  return c instanceof this.pointClass;
};
var hasRequiredElliptic$2;
function requireElliptic$2() {
  return hasRequiredElliptic$2 || (hasRequiredElliptic$2 = 1, function(n) {
    var c = n;
    c.version = require$$0$3.version, c.utils = utils$C, c.rand = requireBrorand(), c.curve = curve$1, c.curves = curves$1, c.ec = requireEc(), c.eddsa = eddsa;
  }(elliptic$2)), elliptic$2;
}
var asn1$1 = {}, asn1 = {}, bn$2 = { exports: {} };
bn$2.exports;
var hasRequiredBn$2;
function requireBn$2() {
  return hasRequiredBn$2 || (hasRequiredBn$2 = 1, function(n) {
    (function(c, u) {
      function p(er, Ie) {
        if (!er) throw new Error(Ie || "Assertion failed");
      }
      function a(er, Ie) {
        er.super_ = Ie;
        var xe = function() {
        };
        xe.prototype = Ie.prototype, er.prototype = new xe(), er.prototype.constructor = er;
      }
      function A(er, Ie, xe) {
        if (A.isBN(er))
          return er;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, er !== null && ((Ie === "le" || Ie === "be") && (xe = Ie, Ie = 10), this._init(er || 0, Ie || 10, xe || "be"));
      }
      typeof c == "object" ? c.exports = A : u.BN = A, A.BN = A, A.wordSize = 26;
      var b;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? b = window.Buffer : b = require$$0$5.Buffer;
      } catch {
      }
      A.isBN = function(Ie) {
        return Ie instanceof A ? !0 : Ie !== null && typeof Ie == "object" && Ie.constructor.wordSize === A.wordSize && Array.isArray(Ie.words);
      }, A.max = function(Ie, xe) {
        return Ie.cmp(xe) > 0 ? Ie : xe;
      }, A.min = function(Ie, xe) {
        return Ie.cmp(xe) < 0 ? Ie : xe;
      }, A.prototype._init = function(Ie, xe, rr) {
        if (typeof Ie == "number")
          return this._initNumber(Ie, xe, rr);
        if (typeof Ie == "object")
          return this._initArray(Ie, xe, rr);
        xe === "hex" && (xe = 16), p(xe === (xe | 0) && xe >= 2 && xe <= 36), Ie = Ie.toString().replace(/\s+/g, "");
        var ar = 0;
        Ie[0] === "-" && (ar++, this.negative = 1), ar < Ie.length && (xe === 16 ? this._parseHex(Ie, ar, rr) : (this._parseBase(Ie, xe, ar), rr === "le" && this._initArray(this.toArray(), xe, rr)));
      }, A.prototype._initNumber = function(Ie, xe, rr) {
        Ie < 0 && (this.negative = 1, Ie = -Ie), Ie < 67108864 ? (this.words = [Ie & 67108863], this.length = 1) : Ie < 4503599627370496 ? (this.words = [
          Ie & 67108863,
          Ie / 67108864 & 67108863
        ], this.length = 2) : (p(Ie < 9007199254740992), this.words = [
          Ie & 67108863,
          Ie / 67108864 & 67108863,
          1
        ], this.length = 3), rr === "le" && this._initArray(this.toArray(), xe, rr);
      }, A.prototype._initArray = function(Ie, xe, rr) {
        if (p(typeof Ie.length == "number"), Ie.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(Ie.length / 3), this.words = new Array(this.length);
        for (var ar = 0; ar < this.length; ar++)
          this.words[ar] = 0;
        var yr, _r, Or = 0;
        if (rr === "be")
          for (ar = Ie.length - 1, yr = 0; ar >= 0; ar -= 3)
            _r = Ie[ar] | Ie[ar - 1] << 8 | Ie[ar - 2] << 16, this.words[yr] |= _r << Or & 67108863, this.words[yr + 1] = _r >>> 26 - Or & 67108863, Or += 24, Or >= 26 && (Or -= 26, yr++);
        else if (rr === "le")
          for (ar = 0, yr = 0; ar < Ie.length; ar += 3)
            _r = Ie[ar] | Ie[ar + 1] << 8 | Ie[ar + 2] << 16, this.words[yr] |= _r << Or & 67108863, this.words[yr + 1] = _r >>> 26 - Or & 67108863, Or += 24, Or >= 26 && (Or -= 26, yr++);
        return this.strip();
      };
      function F(er, Ie) {
        var xe = er.charCodeAt(Ie);
        return xe >= 65 && xe <= 70 ? xe - 55 : xe >= 97 && xe <= 102 ? xe - 87 : xe - 48 & 15;
      }
      function le(er, Ie, xe) {
        var rr = F(er, xe);
        return xe - 1 >= Ie && (rr |= F(er, xe - 1) << 4), rr;
      }
      A.prototype._parseHex = function(Ie, xe, rr) {
        this.length = Math.ceil((Ie.length - xe) / 6), this.words = new Array(this.length);
        for (var ar = 0; ar < this.length; ar++)
          this.words[ar] = 0;
        var yr = 0, _r = 0, Or;
        if (rr === "be")
          for (ar = Ie.length - 1; ar >= xe; ar -= 2)
            Or = le(Ie, xe, ar) << yr, this.words[_r] |= Or & 67108863, yr >= 18 ? (yr -= 18, _r += 1, this.words[_r] |= Or >>> 26) : yr += 8;
        else {
          var vr = Ie.length - xe;
          for (ar = vr % 2 === 0 ? xe + 1 : xe; ar < Ie.length; ar += 2)
            Or = le(Ie, xe, ar) << yr, this.words[_r] |= Or & 67108863, yr >= 18 ? (yr -= 18, _r += 1, this.words[_r] |= Or >>> 26) : yr += 8;
        }
        this.strip();
      };
      function L(er, Ie, xe, rr) {
        for (var ar = 0, yr = Math.min(er.length, xe), _r = Ie; _r < yr; _r++) {
          var Or = er.charCodeAt(_r) - 48;
          ar *= rr, Or >= 49 ? ar += Or - 49 + 10 : Or >= 17 ? ar += Or - 17 + 10 : ar += Or;
        }
        return ar;
      }
      A.prototype._parseBase = function(Ie, xe, rr) {
        this.words = [0], this.length = 1;
        for (var ar = 0, yr = 1; yr <= 67108863; yr *= xe)
          ar++;
        ar--, yr = yr / xe | 0;
        for (var _r = Ie.length - rr, Or = _r % ar, vr = Math.min(_r, _r - Or) + rr, Te = 0, Cr = rr; Cr < vr; Cr += ar)
          Te = L(Ie, Cr, Cr + ar, xe), this.imuln(yr), this.words[0] + Te < 67108864 ? this.words[0] += Te : this._iaddn(Te);
        if (Or !== 0) {
          var Hr = 1;
          for (Te = L(Ie, Cr, Ie.length, xe), Cr = 0; Cr < Or; Cr++)
            Hr *= xe;
          this.imuln(Hr), this.words[0] + Te < 67108864 ? this.words[0] += Te : this._iaddn(Te);
        }
        this.strip();
      }, A.prototype.copy = function(Ie) {
        Ie.words = new Array(this.length);
        for (var xe = 0; xe < this.length; xe++)
          Ie.words[xe] = this.words[xe];
        Ie.length = this.length, Ie.negative = this.negative, Ie.red = this.red;
      }, A.prototype.clone = function() {
        var Ie = new A(null);
        return this.copy(Ie), Ie;
      }, A.prototype._expand = function(Ie) {
        for (; this.length < Ie; )
          this.words[this.length++] = 0;
        return this;
      }, A.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, A.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, A.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var pe = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], $ = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], Ee = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      A.prototype.toString = function(Ie, xe) {
        Ie = Ie || 10, xe = xe | 0 || 1;
        var rr;
        if (Ie === 16 || Ie === "hex") {
          rr = "";
          for (var ar = 0, yr = 0, _r = 0; _r < this.length; _r++) {
            var Or = this.words[_r], vr = ((Or << ar | yr) & 16777215).toString(16);
            yr = Or >>> 24 - ar & 16777215, ar += 2, ar >= 26 && (ar -= 26, _r--), yr !== 0 || _r !== this.length - 1 ? rr = pe[6 - vr.length] + vr + rr : rr = vr + rr;
          }
          for (yr !== 0 && (rr = yr.toString(16) + rr); rr.length % xe !== 0; )
            rr = "0" + rr;
          return this.negative !== 0 && (rr = "-" + rr), rr;
        }
        if (Ie === (Ie | 0) && Ie >= 2 && Ie <= 36) {
          var Te = $[Ie], Cr = Ee[Ie];
          rr = "";
          var Hr = this.clone();
          for (Hr.negative = 0; !Hr.isZero(); ) {
            var si = Hr.modn(Cr).toString(Ie);
            Hr = Hr.idivn(Cr), Hr.isZero() ? rr = si + rr : rr = pe[Te - si.length] + si + rr;
          }
          for (this.isZero() && (rr = "0" + rr); rr.length % xe !== 0; )
            rr = "0" + rr;
          return this.negative !== 0 && (rr = "-" + rr), rr;
        }
        p(!1, "Base should be between 2 and 36");
      }, A.prototype.toNumber = function() {
        var Ie = this.words[0];
        return this.length === 2 ? Ie += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? Ie += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && p(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -Ie : Ie;
      }, A.prototype.toJSON = function() {
        return this.toString(16);
      }, A.prototype.toBuffer = function(Ie, xe) {
        return p(typeof b < "u"), this.toArrayLike(b, Ie, xe);
      }, A.prototype.toArray = function(Ie, xe) {
        return this.toArrayLike(Array, Ie, xe);
      }, A.prototype.toArrayLike = function(Ie, xe, rr) {
        var ar = this.byteLength(), yr = rr || Math.max(1, ar);
        p(ar <= yr, "byte array longer than desired length"), p(yr > 0, "Requested array length <= 0"), this.strip();
        var _r = xe === "le", Or = new Ie(yr), vr, Te, Cr = this.clone();
        if (_r) {
          for (Te = 0; !Cr.isZero(); Te++)
            vr = Cr.andln(255), Cr.iushrn(8), Or[Te] = vr;
          for (; Te < yr; Te++)
            Or[Te] = 0;
        } else {
          for (Te = 0; Te < yr - ar; Te++)
            Or[Te] = 0;
          for (Te = 0; !Cr.isZero(); Te++)
            vr = Cr.andln(255), Cr.iushrn(8), Or[yr - Te - 1] = vr;
        }
        return Or;
      }, Math.clz32 ? A.prototype._countBits = function(Ie) {
        return 32 - Math.clz32(Ie);
      } : A.prototype._countBits = function(Ie) {
        var xe = Ie, rr = 0;
        return xe >= 4096 && (rr += 13, xe >>>= 13), xe >= 64 && (rr += 7, xe >>>= 7), xe >= 8 && (rr += 4, xe >>>= 4), xe >= 2 && (rr += 2, xe >>>= 2), rr + xe;
      }, A.prototype._zeroBits = function(Ie) {
        if (Ie === 0) return 26;
        var xe = Ie, rr = 0;
        return xe & 8191 || (rr += 13, xe >>>= 13), xe & 127 || (rr += 7, xe >>>= 7), xe & 15 || (rr += 4, xe >>>= 4), xe & 3 || (rr += 2, xe >>>= 2), xe & 1 || rr++, rr;
      }, A.prototype.bitLength = function() {
        var Ie = this.words[this.length - 1], xe = this._countBits(Ie);
        return (this.length - 1) * 26 + xe;
      };
      function be(er) {
        for (var Ie = new Array(er.bitLength()), xe = 0; xe < Ie.length; xe++) {
          var rr = xe / 26 | 0, ar = xe % 26;
          Ie[xe] = (er.words[rr] & 1 << ar) >>> ar;
        }
        return Ie;
      }
      A.prototype.zeroBits = function() {
        if (this.isZero()) return 0;
        for (var Ie = 0, xe = 0; xe < this.length; xe++) {
          var rr = this._zeroBits(this.words[xe]);
          if (Ie += rr, rr !== 26) break;
        }
        return Ie;
      }, A.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, A.prototype.toTwos = function(Ie) {
        return this.negative !== 0 ? this.abs().inotn(Ie).iaddn(1) : this.clone();
      }, A.prototype.fromTwos = function(Ie) {
        return this.testn(Ie - 1) ? this.notn(Ie).iaddn(1).ineg() : this.clone();
      }, A.prototype.isNeg = function() {
        return this.negative !== 0;
      }, A.prototype.neg = function() {
        return this.clone().ineg();
      }, A.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, A.prototype.iuor = function(Ie) {
        for (; this.length < Ie.length; )
          this.words[this.length++] = 0;
        for (var xe = 0; xe < Ie.length; xe++)
          this.words[xe] = this.words[xe] | Ie.words[xe];
        return this.strip();
      }, A.prototype.ior = function(Ie) {
        return p((this.negative | Ie.negative) === 0), this.iuor(Ie);
      }, A.prototype.or = function(Ie) {
        return this.length > Ie.length ? this.clone().ior(Ie) : Ie.clone().ior(this);
      }, A.prototype.uor = function(Ie) {
        return this.length > Ie.length ? this.clone().iuor(Ie) : Ie.clone().iuor(this);
      }, A.prototype.iuand = function(Ie) {
        var xe;
        this.length > Ie.length ? xe = Ie : xe = this;
        for (var rr = 0; rr < xe.length; rr++)
          this.words[rr] = this.words[rr] & Ie.words[rr];
        return this.length = xe.length, this.strip();
      }, A.prototype.iand = function(Ie) {
        return p((this.negative | Ie.negative) === 0), this.iuand(Ie);
      }, A.prototype.and = function(Ie) {
        return this.length > Ie.length ? this.clone().iand(Ie) : Ie.clone().iand(this);
      }, A.prototype.uand = function(Ie) {
        return this.length > Ie.length ? this.clone().iuand(Ie) : Ie.clone().iuand(this);
      }, A.prototype.iuxor = function(Ie) {
        var xe, rr;
        this.length > Ie.length ? (xe = this, rr = Ie) : (xe = Ie, rr = this);
        for (var ar = 0; ar < rr.length; ar++)
          this.words[ar] = xe.words[ar] ^ rr.words[ar];
        if (this !== xe)
          for (; ar < xe.length; ar++)
            this.words[ar] = xe.words[ar];
        return this.length = xe.length, this.strip();
      }, A.prototype.ixor = function(Ie) {
        return p((this.negative | Ie.negative) === 0), this.iuxor(Ie);
      }, A.prototype.xor = function(Ie) {
        return this.length > Ie.length ? this.clone().ixor(Ie) : Ie.clone().ixor(this);
      }, A.prototype.uxor = function(Ie) {
        return this.length > Ie.length ? this.clone().iuxor(Ie) : Ie.clone().iuxor(this);
      }, A.prototype.inotn = function(Ie) {
        p(typeof Ie == "number" && Ie >= 0);
        var xe = Math.ceil(Ie / 26) | 0, rr = Ie % 26;
        this._expand(xe), rr > 0 && xe--;
        for (var ar = 0; ar < xe; ar++)
          this.words[ar] = ~this.words[ar] & 67108863;
        return rr > 0 && (this.words[ar] = ~this.words[ar] & 67108863 >> 26 - rr), this.strip();
      }, A.prototype.notn = function(Ie) {
        return this.clone().inotn(Ie);
      }, A.prototype.setn = function(Ie, xe) {
        p(typeof Ie == "number" && Ie >= 0);
        var rr = Ie / 26 | 0, ar = Ie % 26;
        return this._expand(rr + 1), xe ? this.words[rr] = this.words[rr] | 1 << ar : this.words[rr] = this.words[rr] & ~(1 << ar), this.strip();
      }, A.prototype.iadd = function(Ie) {
        var xe;
        if (this.negative !== 0 && Ie.negative === 0)
          return this.negative = 0, xe = this.isub(Ie), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && Ie.negative !== 0)
          return Ie.negative = 0, xe = this.isub(Ie), Ie.negative = 1, xe._normSign();
        var rr, ar;
        this.length > Ie.length ? (rr = this, ar = Ie) : (rr = Ie, ar = this);
        for (var yr = 0, _r = 0; _r < ar.length; _r++)
          xe = (rr.words[_r] | 0) + (ar.words[_r] | 0) + yr, this.words[_r] = xe & 67108863, yr = xe >>> 26;
        for (; yr !== 0 && _r < rr.length; _r++)
          xe = (rr.words[_r] | 0) + yr, this.words[_r] = xe & 67108863, yr = xe >>> 26;
        if (this.length = rr.length, yr !== 0)
          this.words[this.length] = yr, this.length++;
        else if (rr !== this)
          for (; _r < rr.length; _r++)
            this.words[_r] = rr.words[_r];
        return this;
      }, A.prototype.add = function(Ie) {
        var xe;
        return Ie.negative !== 0 && this.negative === 0 ? (Ie.negative = 0, xe = this.sub(Ie), Ie.negative ^= 1, xe) : Ie.negative === 0 && this.negative !== 0 ? (this.negative = 0, xe = Ie.sub(this), this.negative = 1, xe) : this.length > Ie.length ? this.clone().iadd(Ie) : Ie.clone().iadd(this);
      }, A.prototype.isub = function(Ie) {
        if (Ie.negative !== 0) {
          Ie.negative = 0;
          var xe = this.iadd(Ie);
          return Ie.negative = 1, xe._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(Ie), this.negative = 1, this._normSign();
        var rr = this.cmp(Ie);
        if (rr === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var ar, yr;
        rr > 0 ? (ar = this, yr = Ie) : (ar = Ie, yr = this);
        for (var _r = 0, Or = 0; Or < yr.length; Or++)
          xe = (ar.words[Or] | 0) - (yr.words[Or] | 0) + _r, _r = xe >> 26, this.words[Or] = xe & 67108863;
        for (; _r !== 0 && Or < ar.length; Or++)
          xe = (ar.words[Or] | 0) + _r, _r = xe >> 26, this.words[Or] = xe & 67108863;
        if (_r === 0 && Or < ar.length && ar !== this)
          for (; Or < ar.length; Or++)
            this.words[Or] = ar.words[Or];
        return this.length = Math.max(this.length, Or), ar !== this && (this.negative = 1), this.strip();
      }, A.prototype.sub = function(Ie) {
        return this.clone().isub(Ie);
      };
      function He(er, Ie, xe) {
        xe.negative = Ie.negative ^ er.negative;
        var rr = er.length + Ie.length | 0;
        xe.length = rr, rr = rr - 1 | 0;
        var ar = er.words[0] | 0, yr = Ie.words[0] | 0, _r = ar * yr, Or = _r & 67108863, vr = _r / 67108864 | 0;
        xe.words[0] = Or;
        for (var Te = 1; Te < rr; Te++) {
          for (var Cr = vr >>> 26, Hr = vr & 67108863, si = Math.min(Te, Ie.length - 1), ui = Math.max(0, Te - er.length + 1); ui <= si; ui++) {
            var Li = Te - ui | 0;
            ar = er.words[Li] | 0, yr = Ie.words[ui] | 0, _r = ar * yr + Hr, Cr += _r / 67108864 | 0, Hr = _r & 67108863;
          }
          xe.words[Te] = Hr | 0, vr = Cr | 0;
        }
        return vr !== 0 ? xe.words[Te] = vr | 0 : xe.length--, xe.strip();
      }
      var Pe = function(Ie, xe, rr) {
        var ar = Ie.words, yr = xe.words, _r = rr.words, Or = 0, vr, Te, Cr, Hr = ar[0] | 0, si = Hr & 8191, ui = Hr >>> 13, Li = ar[1] | 0, Qi = Li & 8191, wi = Li >>> 13, Ji = ar[2] | 0, mn = Ji & 8191, pi = Ji >>> 13, ei = ar[3] | 0, Vr = ei & 8191, qr = ei >>> 13, Zi = ar[4] | 0, Wr = Zi & 8191, ri = Zi >>> 13, _i = ar[5] | 0, Er = _i & 8191, Di = _i >>> 13, _n = ar[6] | 0, On = _n & 8191, so = _n >>> 13, Do = ar[7] | 0, gn = Do & 8191, Gn = Do >>> 13, pn = ar[8] | 0, hn = pn & 8191, Rn = pn >>> 13, vo = ar[9] | 0, Hi = vo & 8191, di = vo >>> 13, Ui = yr[0] | 0, ln = Ui & 8191, Un = Ui >>> 13, Bo = yr[1] | 0, co = Bo & 8191, To = Bo >>> 13, xs = yr[2] | 0, Fo = xs & 8191, Zo = xs >>> 13, $s = yr[3] | 0, rs = $s & 8191, ls = $s >>> 13, na = yr[4] | 0, os = na & 8191, fs = na >>> 13, da = yr[5] | 0, Bn = da & 8191, hi = da >>> 13, Ii = yr[6] | 0, Gi = Ii & 8191, kn = Ii >>> 13, ho = yr[7] | 0, eo = ho & 8191, Ei = ho >>> 13, vs = yr[8] | 0, vi = vs & 8191, xi = vs >>> 13, Lr = yr[9] | 0, dn = Lr & 8191, xn = Lr >>> 13;
        rr.negative = Ie.negative ^ xe.negative, rr.length = 19, vr = Math.imul(si, ln), Te = Math.imul(si, Un), Te = Te + Math.imul(ui, ln) | 0, Cr = Math.imul(ui, Un);
        var oi = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (oi >>> 26) | 0, oi &= 67108863, vr = Math.imul(Qi, ln), Te = Math.imul(Qi, Un), Te = Te + Math.imul(wi, ln) | 0, Cr = Math.imul(wi, Un), vr = vr + Math.imul(si, co) | 0, Te = Te + Math.imul(si, To) | 0, Te = Te + Math.imul(ui, co) | 0, Cr = Cr + Math.imul(ui, To) | 0;
        var Yr = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (Yr >>> 26) | 0, Yr &= 67108863, vr = Math.imul(mn, ln), Te = Math.imul(mn, Un), Te = Te + Math.imul(pi, ln) | 0, Cr = Math.imul(pi, Un), vr = vr + Math.imul(Qi, co) | 0, Te = Te + Math.imul(Qi, To) | 0, Te = Te + Math.imul(wi, co) | 0, Cr = Cr + Math.imul(wi, To) | 0, vr = vr + Math.imul(si, Fo) | 0, Te = Te + Math.imul(si, Zo) | 0, Te = Te + Math.imul(ui, Fo) | 0, Cr = Cr + Math.imul(ui, Zo) | 0;
        var ji = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (ji >>> 26) | 0, ji &= 67108863, vr = Math.imul(Vr, ln), Te = Math.imul(Vr, Un), Te = Te + Math.imul(qr, ln) | 0, Cr = Math.imul(qr, Un), vr = vr + Math.imul(mn, co) | 0, Te = Te + Math.imul(mn, To) | 0, Te = Te + Math.imul(pi, co) | 0, Cr = Cr + Math.imul(pi, To) | 0, vr = vr + Math.imul(Qi, Fo) | 0, Te = Te + Math.imul(Qi, Zo) | 0, Te = Te + Math.imul(wi, Fo) | 0, Cr = Cr + Math.imul(wi, Zo) | 0, vr = vr + Math.imul(si, rs) | 0, Te = Te + Math.imul(si, ls) | 0, Te = Te + Math.imul(ui, rs) | 0, Cr = Cr + Math.imul(ui, ls) | 0;
        var Cn = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (Cn >>> 26) | 0, Cn &= 67108863, vr = Math.imul(Wr, ln), Te = Math.imul(Wr, Un), Te = Te + Math.imul(ri, ln) | 0, Cr = Math.imul(ri, Un), vr = vr + Math.imul(Vr, co) | 0, Te = Te + Math.imul(Vr, To) | 0, Te = Te + Math.imul(qr, co) | 0, Cr = Cr + Math.imul(qr, To) | 0, vr = vr + Math.imul(mn, Fo) | 0, Te = Te + Math.imul(mn, Zo) | 0, Te = Te + Math.imul(pi, Fo) | 0, Cr = Cr + Math.imul(pi, Zo) | 0, vr = vr + Math.imul(Qi, rs) | 0, Te = Te + Math.imul(Qi, ls) | 0, Te = Te + Math.imul(wi, rs) | 0, Cr = Cr + Math.imul(wi, ls) | 0, vr = vr + Math.imul(si, os) | 0, Te = Te + Math.imul(si, fs) | 0, Te = Te + Math.imul(ui, os) | 0, Cr = Cr + Math.imul(ui, fs) | 0;
        var Mn = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (Mn >>> 26) | 0, Mn &= 67108863, vr = Math.imul(Er, ln), Te = Math.imul(Er, Un), Te = Te + Math.imul(Di, ln) | 0, Cr = Math.imul(Di, Un), vr = vr + Math.imul(Wr, co) | 0, Te = Te + Math.imul(Wr, To) | 0, Te = Te + Math.imul(ri, co) | 0, Cr = Cr + Math.imul(ri, To) | 0, vr = vr + Math.imul(Vr, Fo) | 0, Te = Te + Math.imul(Vr, Zo) | 0, Te = Te + Math.imul(qr, Fo) | 0, Cr = Cr + Math.imul(qr, Zo) | 0, vr = vr + Math.imul(mn, rs) | 0, Te = Te + Math.imul(mn, ls) | 0, Te = Te + Math.imul(pi, rs) | 0, Cr = Cr + Math.imul(pi, ls) | 0, vr = vr + Math.imul(Qi, os) | 0, Te = Te + Math.imul(Qi, fs) | 0, Te = Te + Math.imul(wi, os) | 0, Cr = Cr + Math.imul(wi, fs) | 0, vr = vr + Math.imul(si, Bn) | 0, Te = Te + Math.imul(si, hi) | 0, Te = Te + Math.imul(ui, Bn) | 0, Cr = Cr + Math.imul(ui, hi) | 0;
        var B = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (B >>> 26) | 0, B &= 67108863, vr = Math.imul(On, ln), Te = Math.imul(On, Un), Te = Te + Math.imul(so, ln) | 0, Cr = Math.imul(so, Un), vr = vr + Math.imul(Er, co) | 0, Te = Te + Math.imul(Er, To) | 0, Te = Te + Math.imul(Di, co) | 0, Cr = Cr + Math.imul(Di, To) | 0, vr = vr + Math.imul(Wr, Fo) | 0, Te = Te + Math.imul(Wr, Zo) | 0, Te = Te + Math.imul(ri, Fo) | 0, Cr = Cr + Math.imul(ri, Zo) | 0, vr = vr + Math.imul(Vr, rs) | 0, Te = Te + Math.imul(Vr, ls) | 0, Te = Te + Math.imul(qr, rs) | 0, Cr = Cr + Math.imul(qr, ls) | 0, vr = vr + Math.imul(mn, os) | 0, Te = Te + Math.imul(mn, fs) | 0, Te = Te + Math.imul(pi, os) | 0, Cr = Cr + Math.imul(pi, fs) | 0, vr = vr + Math.imul(Qi, Bn) | 0, Te = Te + Math.imul(Qi, hi) | 0, Te = Te + Math.imul(wi, Bn) | 0, Cr = Cr + Math.imul(wi, hi) | 0, vr = vr + Math.imul(si, Gi) | 0, Te = Te + Math.imul(si, kn) | 0, Te = Te + Math.imul(ui, Gi) | 0, Cr = Cr + Math.imul(ui, kn) | 0;
        var o = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (o >>> 26) | 0, o &= 67108863, vr = Math.imul(gn, ln), Te = Math.imul(gn, Un), Te = Te + Math.imul(Gn, ln) | 0, Cr = Math.imul(Gn, Un), vr = vr + Math.imul(On, co) | 0, Te = Te + Math.imul(On, To) | 0, Te = Te + Math.imul(so, co) | 0, Cr = Cr + Math.imul(so, To) | 0, vr = vr + Math.imul(Er, Fo) | 0, Te = Te + Math.imul(Er, Zo) | 0, Te = Te + Math.imul(Di, Fo) | 0, Cr = Cr + Math.imul(Di, Zo) | 0, vr = vr + Math.imul(Wr, rs) | 0, Te = Te + Math.imul(Wr, ls) | 0, Te = Te + Math.imul(ri, rs) | 0, Cr = Cr + Math.imul(ri, ls) | 0, vr = vr + Math.imul(Vr, os) | 0, Te = Te + Math.imul(Vr, fs) | 0, Te = Te + Math.imul(qr, os) | 0, Cr = Cr + Math.imul(qr, fs) | 0, vr = vr + Math.imul(mn, Bn) | 0, Te = Te + Math.imul(mn, hi) | 0, Te = Te + Math.imul(pi, Bn) | 0, Cr = Cr + Math.imul(pi, hi) | 0, vr = vr + Math.imul(Qi, Gi) | 0, Te = Te + Math.imul(Qi, kn) | 0, Te = Te + Math.imul(wi, Gi) | 0, Cr = Cr + Math.imul(wi, kn) | 0, vr = vr + Math.imul(si, eo) | 0, Te = Te + Math.imul(si, Ei) | 0, Te = Te + Math.imul(ui, eo) | 0, Cr = Cr + Math.imul(ui, Ei) | 0;
        var m = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (m >>> 26) | 0, m &= 67108863, vr = Math.imul(hn, ln), Te = Math.imul(hn, Un), Te = Te + Math.imul(Rn, ln) | 0, Cr = Math.imul(Rn, Un), vr = vr + Math.imul(gn, co) | 0, Te = Te + Math.imul(gn, To) | 0, Te = Te + Math.imul(Gn, co) | 0, Cr = Cr + Math.imul(Gn, To) | 0, vr = vr + Math.imul(On, Fo) | 0, Te = Te + Math.imul(On, Zo) | 0, Te = Te + Math.imul(so, Fo) | 0, Cr = Cr + Math.imul(so, Zo) | 0, vr = vr + Math.imul(Er, rs) | 0, Te = Te + Math.imul(Er, ls) | 0, Te = Te + Math.imul(Di, rs) | 0, Cr = Cr + Math.imul(Di, ls) | 0, vr = vr + Math.imul(Wr, os) | 0, Te = Te + Math.imul(Wr, fs) | 0, Te = Te + Math.imul(ri, os) | 0, Cr = Cr + Math.imul(ri, fs) | 0, vr = vr + Math.imul(Vr, Bn) | 0, Te = Te + Math.imul(Vr, hi) | 0, Te = Te + Math.imul(qr, Bn) | 0, Cr = Cr + Math.imul(qr, hi) | 0, vr = vr + Math.imul(mn, Gi) | 0, Te = Te + Math.imul(mn, kn) | 0, Te = Te + Math.imul(pi, Gi) | 0, Cr = Cr + Math.imul(pi, kn) | 0, vr = vr + Math.imul(Qi, eo) | 0, Te = Te + Math.imul(Qi, Ei) | 0, Te = Te + Math.imul(wi, eo) | 0, Cr = Cr + Math.imul(wi, Ei) | 0, vr = vr + Math.imul(si, vi) | 0, Te = Te + Math.imul(si, xi) | 0, Te = Te + Math.imul(ui, vi) | 0, Cr = Cr + Math.imul(ui, xi) | 0;
        var d = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (d >>> 26) | 0, d &= 67108863, vr = Math.imul(Hi, ln), Te = Math.imul(Hi, Un), Te = Te + Math.imul(di, ln) | 0, Cr = Math.imul(di, Un), vr = vr + Math.imul(hn, co) | 0, Te = Te + Math.imul(hn, To) | 0, Te = Te + Math.imul(Rn, co) | 0, Cr = Cr + Math.imul(Rn, To) | 0, vr = vr + Math.imul(gn, Fo) | 0, Te = Te + Math.imul(gn, Zo) | 0, Te = Te + Math.imul(Gn, Fo) | 0, Cr = Cr + Math.imul(Gn, Zo) | 0, vr = vr + Math.imul(On, rs) | 0, Te = Te + Math.imul(On, ls) | 0, Te = Te + Math.imul(so, rs) | 0, Cr = Cr + Math.imul(so, ls) | 0, vr = vr + Math.imul(Er, os) | 0, Te = Te + Math.imul(Er, fs) | 0, Te = Te + Math.imul(Di, os) | 0, Cr = Cr + Math.imul(Di, fs) | 0, vr = vr + Math.imul(Wr, Bn) | 0, Te = Te + Math.imul(Wr, hi) | 0, Te = Te + Math.imul(ri, Bn) | 0, Cr = Cr + Math.imul(ri, hi) | 0, vr = vr + Math.imul(Vr, Gi) | 0, Te = Te + Math.imul(Vr, kn) | 0, Te = Te + Math.imul(qr, Gi) | 0, Cr = Cr + Math.imul(qr, kn) | 0, vr = vr + Math.imul(mn, eo) | 0, Te = Te + Math.imul(mn, Ei) | 0, Te = Te + Math.imul(pi, eo) | 0, Cr = Cr + Math.imul(pi, Ei) | 0, vr = vr + Math.imul(Qi, vi) | 0, Te = Te + Math.imul(Qi, xi) | 0, Te = Te + Math.imul(wi, vi) | 0, Cr = Cr + Math.imul(wi, xi) | 0, vr = vr + Math.imul(si, dn) | 0, Te = Te + Math.imul(si, xn) | 0, Te = Te + Math.imul(ui, dn) | 0, Cr = Cr + Math.imul(ui, xn) | 0;
        var v = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (v >>> 26) | 0, v &= 67108863, vr = Math.imul(Hi, co), Te = Math.imul(Hi, To), Te = Te + Math.imul(di, co) | 0, Cr = Math.imul(di, To), vr = vr + Math.imul(hn, Fo) | 0, Te = Te + Math.imul(hn, Zo) | 0, Te = Te + Math.imul(Rn, Fo) | 0, Cr = Cr + Math.imul(Rn, Zo) | 0, vr = vr + Math.imul(gn, rs) | 0, Te = Te + Math.imul(gn, ls) | 0, Te = Te + Math.imul(Gn, rs) | 0, Cr = Cr + Math.imul(Gn, ls) | 0, vr = vr + Math.imul(On, os) | 0, Te = Te + Math.imul(On, fs) | 0, Te = Te + Math.imul(so, os) | 0, Cr = Cr + Math.imul(so, fs) | 0, vr = vr + Math.imul(Er, Bn) | 0, Te = Te + Math.imul(Er, hi) | 0, Te = Te + Math.imul(Di, Bn) | 0, Cr = Cr + Math.imul(Di, hi) | 0, vr = vr + Math.imul(Wr, Gi) | 0, Te = Te + Math.imul(Wr, kn) | 0, Te = Te + Math.imul(ri, Gi) | 0, Cr = Cr + Math.imul(ri, kn) | 0, vr = vr + Math.imul(Vr, eo) | 0, Te = Te + Math.imul(Vr, Ei) | 0, Te = Te + Math.imul(qr, eo) | 0, Cr = Cr + Math.imul(qr, Ei) | 0, vr = vr + Math.imul(mn, vi) | 0, Te = Te + Math.imul(mn, xi) | 0, Te = Te + Math.imul(pi, vi) | 0, Cr = Cr + Math.imul(pi, xi) | 0, vr = vr + Math.imul(Qi, dn) | 0, Te = Te + Math.imul(Qi, xn) | 0, Te = Te + Math.imul(wi, dn) | 0, Cr = Cr + Math.imul(wi, xn) | 0;
        var he = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (he >>> 26) | 0, he &= 67108863, vr = Math.imul(Hi, Fo), Te = Math.imul(Hi, Zo), Te = Te + Math.imul(di, Fo) | 0, Cr = Math.imul(di, Zo), vr = vr + Math.imul(hn, rs) | 0, Te = Te + Math.imul(hn, ls) | 0, Te = Te + Math.imul(Rn, rs) | 0, Cr = Cr + Math.imul(Rn, ls) | 0, vr = vr + Math.imul(gn, os) | 0, Te = Te + Math.imul(gn, fs) | 0, Te = Te + Math.imul(Gn, os) | 0, Cr = Cr + Math.imul(Gn, fs) | 0, vr = vr + Math.imul(On, Bn) | 0, Te = Te + Math.imul(On, hi) | 0, Te = Te + Math.imul(so, Bn) | 0, Cr = Cr + Math.imul(so, hi) | 0, vr = vr + Math.imul(Er, Gi) | 0, Te = Te + Math.imul(Er, kn) | 0, Te = Te + Math.imul(Di, Gi) | 0, Cr = Cr + Math.imul(Di, kn) | 0, vr = vr + Math.imul(Wr, eo) | 0, Te = Te + Math.imul(Wr, Ei) | 0, Te = Te + Math.imul(ri, eo) | 0, Cr = Cr + Math.imul(ri, Ei) | 0, vr = vr + Math.imul(Vr, vi) | 0, Te = Te + Math.imul(Vr, xi) | 0, Te = Te + Math.imul(qr, vi) | 0, Cr = Cr + Math.imul(qr, xi) | 0, vr = vr + Math.imul(mn, dn) | 0, Te = Te + Math.imul(mn, xn) | 0, Te = Te + Math.imul(pi, dn) | 0, Cr = Cr + Math.imul(pi, xn) | 0;
        var we = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (we >>> 26) | 0, we &= 67108863, vr = Math.imul(Hi, rs), Te = Math.imul(Hi, ls), Te = Te + Math.imul(di, rs) | 0, Cr = Math.imul(di, ls), vr = vr + Math.imul(hn, os) | 0, Te = Te + Math.imul(hn, fs) | 0, Te = Te + Math.imul(Rn, os) | 0, Cr = Cr + Math.imul(Rn, fs) | 0, vr = vr + Math.imul(gn, Bn) | 0, Te = Te + Math.imul(gn, hi) | 0, Te = Te + Math.imul(Gn, Bn) | 0, Cr = Cr + Math.imul(Gn, hi) | 0, vr = vr + Math.imul(On, Gi) | 0, Te = Te + Math.imul(On, kn) | 0, Te = Te + Math.imul(so, Gi) | 0, Cr = Cr + Math.imul(so, kn) | 0, vr = vr + Math.imul(Er, eo) | 0, Te = Te + Math.imul(Er, Ei) | 0, Te = Te + Math.imul(Di, eo) | 0, Cr = Cr + Math.imul(Di, Ei) | 0, vr = vr + Math.imul(Wr, vi) | 0, Te = Te + Math.imul(Wr, xi) | 0, Te = Te + Math.imul(ri, vi) | 0, Cr = Cr + Math.imul(ri, xi) | 0, vr = vr + Math.imul(Vr, dn) | 0, Te = Te + Math.imul(Vr, xn) | 0, Te = Te + Math.imul(qr, dn) | 0, Cr = Cr + Math.imul(qr, xn) | 0;
        var Be = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (Be >>> 26) | 0, Be &= 67108863, vr = Math.imul(Hi, os), Te = Math.imul(Hi, fs), Te = Te + Math.imul(di, os) | 0, Cr = Math.imul(di, fs), vr = vr + Math.imul(hn, Bn) | 0, Te = Te + Math.imul(hn, hi) | 0, Te = Te + Math.imul(Rn, Bn) | 0, Cr = Cr + Math.imul(Rn, hi) | 0, vr = vr + Math.imul(gn, Gi) | 0, Te = Te + Math.imul(gn, kn) | 0, Te = Te + Math.imul(Gn, Gi) | 0, Cr = Cr + Math.imul(Gn, kn) | 0, vr = vr + Math.imul(On, eo) | 0, Te = Te + Math.imul(On, Ei) | 0, Te = Te + Math.imul(so, eo) | 0, Cr = Cr + Math.imul(so, Ei) | 0, vr = vr + Math.imul(Er, vi) | 0, Te = Te + Math.imul(Er, xi) | 0, Te = Te + Math.imul(Di, vi) | 0, Cr = Cr + Math.imul(Di, xi) | 0, vr = vr + Math.imul(Wr, dn) | 0, Te = Te + Math.imul(Wr, xn) | 0, Te = Te + Math.imul(ri, dn) | 0, Cr = Cr + Math.imul(ri, xn) | 0;
        var Me = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (Me >>> 26) | 0, Me &= 67108863, vr = Math.imul(Hi, Bn), Te = Math.imul(Hi, hi), Te = Te + Math.imul(di, Bn) | 0, Cr = Math.imul(di, hi), vr = vr + Math.imul(hn, Gi) | 0, Te = Te + Math.imul(hn, kn) | 0, Te = Te + Math.imul(Rn, Gi) | 0, Cr = Cr + Math.imul(Rn, kn) | 0, vr = vr + Math.imul(gn, eo) | 0, Te = Te + Math.imul(gn, Ei) | 0, Te = Te + Math.imul(Gn, eo) | 0, Cr = Cr + Math.imul(Gn, Ei) | 0, vr = vr + Math.imul(On, vi) | 0, Te = Te + Math.imul(On, xi) | 0, Te = Te + Math.imul(so, vi) | 0, Cr = Cr + Math.imul(so, xi) | 0, vr = vr + Math.imul(Er, dn) | 0, Te = Te + Math.imul(Er, xn) | 0, Te = Te + Math.imul(Di, dn) | 0, Cr = Cr + Math.imul(Di, xn) | 0;
        var fr = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (fr >>> 26) | 0, fr &= 67108863, vr = Math.imul(Hi, Gi), Te = Math.imul(Hi, kn), Te = Te + Math.imul(di, Gi) | 0, Cr = Math.imul(di, kn), vr = vr + Math.imul(hn, eo) | 0, Te = Te + Math.imul(hn, Ei) | 0, Te = Te + Math.imul(Rn, eo) | 0, Cr = Cr + Math.imul(Rn, Ei) | 0, vr = vr + Math.imul(gn, vi) | 0, Te = Te + Math.imul(gn, xi) | 0, Te = Te + Math.imul(Gn, vi) | 0, Cr = Cr + Math.imul(Gn, xi) | 0, vr = vr + Math.imul(On, dn) | 0, Te = Te + Math.imul(On, xn) | 0, Te = Te + Math.imul(so, dn) | 0, Cr = Cr + Math.imul(so, xn) | 0;
        var wr = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (wr >>> 26) | 0, wr &= 67108863, vr = Math.imul(Hi, eo), Te = Math.imul(Hi, Ei), Te = Te + Math.imul(di, eo) | 0, Cr = Math.imul(di, Ei), vr = vr + Math.imul(hn, vi) | 0, Te = Te + Math.imul(hn, xi) | 0, Te = Te + Math.imul(Rn, vi) | 0, Cr = Cr + Math.imul(Rn, xi) | 0, vr = vr + Math.imul(gn, dn) | 0, Te = Te + Math.imul(gn, xn) | 0, Te = Te + Math.imul(Gn, dn) | 0, Cr = Cr + Math.imul(Gn, xn) | 0;
        var dr = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (dr >>> 26) | 0, dr &= 67108863, vr = Math.imul(Hi, vi), Te = Math.imul(Hi, xi), Te = Te + Math.imul(di, vi) | 0, Cr = Math.imul(di, xi), vr = vr + Math.imul(hn, dn) | 0, Te = Te + Math.imul(hn, xn) | 0, Te = Te + Math.imul(Rn, dn) | 0, Cr = Cr + Math.imul(Rn, xn) | 0;
        var Dr = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (Dr >>> 26) | 0, Dr &= 67108863, vr = Math.imul(Hi, dn), Te = Math.imul(Hi, xn), Te = Te + Math.imul(di, dn) | 0, Cr = Math.imul(di, xn);
        var Rr = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        return Or = (Cr + (Te >>> 13) | 0) + (Rr >>> 26) | 0, Rr &= 67108863, _r[0] = oi, _r[1] = Yr, _r[2] = ji, _r[3] = Cn, _r[4] = Mn, _r[5] = B, _r[6] = o, _r[7] = m, _r[8] = d, _r[9] = v, _r[10] = he, _r[11] = we, _r[12] = Be, _r[13] = Me, _r[14] = fr, _r[15] = wr, _r[16] = dr, _r[17] = Dr, _r[18] = Rr, Or !== 0 && (_r[19] = Or, rr.length++), rr;
      };
      Math.imul || (Pe = He);
      function nr(er, Ie, xe) {
        xe.negative = Ie.negative ^ er.negative, xe.length = er.length + Ie.length;
        for (var rr = 0, ar = 0, yr = 0; yr < xe.length - 1; yr++) {
          var _r = ar;
          ar = 0;
          for (var Or = rr & 67108863, vr = Math.min(yr, Ie.length - 1), Te = Math.max(0, yr - er.length + 1); Te <= vr; Te++) {
            var Cr = yr - Te, Hr = er.words[Cr] | 0, si = Ie.words[Te] | 0, ui = Hr * si, Li = ui & 67108863;
            _r = _r + (ui / 67108864 | 0) | 0, Li = Li + Or | 0, Or = Li & 67108863, _r = _r + (Li >>> 26) | 0, ar += _r >>> 26, _r &= 67108863;
          }
          xe.words[yr] = Or, rr = _r, _r = ar;
        }
        return rr !== 0 ? xe.words[yr] = rr : xe.length--, xe.strip();
      }
      function ir(er, Ie, xe) {
        var rr = new or();
        return rr.mulp(er, Ie, xe);
      }
      A.prototype.mulTo = function(Ie, xe) {
        var rr, ar = this.length + Ie.length;
        return this.length === 10 && Ie.length === 10 ? rr = Pe(this, Ie, xe) : ar < 63 ? rr = He(this, Ie, xe) : ar < 1024 ? rr = nr(this, Ie, xe) : rr = ir(this, Ie, xe), rr;
      };
      function or(er, Ie) {
        this.x = er, this.y = Ie;
      }
      or.prototype.makeRBT = function(Ie) {
        for (var xe = new Array(Ie), rr = A.prototype._countBits(Ie) - 1, ar = 0; ar < Ie; ar++)
          xe[ar] = this.revBin(ar, rr, Ie);
        return xe;
      }, or.prototype.revBin = function(Ie, xe, rr) {
        if (Ie === 0 || Ie === rr - 1) return Ie;
        for (var ar = 0, yr = 0; yr < xe; yr++)
          ar |= (Ie & 1) << xe - yr - 1, Ie >>= 1;
        return ar;
      }, or.prototype.permute = function(Ie, xe, rr, ar, yr, _r) {
        for (var Or = 0; Or < _r; Or++)
          ar[Or] = xe[Ie[Or]], yr[Or] = rr[Ie[Or]];
      }, or.prototype.transform = function(Ie, xe, rr, ar, yr, _r) {
        this.permute(_r, Ie, xe, rr, ar, yr);
        for (var Or = 1; Or < yr; Or <<= 1)
          for (var vr = Or << 1, Te = Math.cos(2 * Math.PI / vr), Cr = Math.sin(2 * Math.PI / vr), Hr = 0; Hr < yr; Hr += vr)
            for (var si = Te, ui = Cr, Li = 0; Li < Or; Li++) {
              var Qi = rr[Hr + Li], wi = ar[Hr + Li], Ji = rr[Hr + Li + Or], mn = ar[Hr + Li + Or], pi = si * Ji - ui * mn;
              mn = si * mn + ui * Ji, Ji = pi, rr[Hr + Li] = Qi + Ji, ar[Hr + Li] = wi + mn, rr[Hr + Li + Or] = Qi - Ji, ar[Hr + Li + Or] = wi - mn, Li !== vr && (pi = Te * si - Cr * ui, ui = Te * ui + Cr * si, si = pi);
            }
      }, or.prototype.guessLen13b = function(Ie, xe) {
        var rr = Math.max(xe, Ie) | 1, ar = rr & 1, yr = 0;
        for (rr = rr / 2 | 0; rr; rr = rr >>> 1)
          yr++;
        return 1 << yr + 1 + ar;
      }, or.prototype.conjugate = function(Ie, xe, rr) {
        if (!(rr <= 1))
          for (var ar = 0; ar < rr / 2; ar++) {
            var yr = Ie[ar];
            Ie[ar] = Ie[rr - ar - 1], Ie[rr - ar - 1] = yr, yr = xe[ar], xe[ar] = -xe[rr - ar - 1], xe[rr - ar - 1] = -yr;
          }
      }, or.prototype.normalize13b = function(Ie, xe) {
        for (var rr = 0, ar = 0; ar < xe / 2; ar++) {
          var yr = Math.round(Ie[2 * ar + 1] / xe) * 8192 + Math.round(Ie[2 * ar] / xe) + rr;
          Ie[ar] = yr & 67108863, yr < 67108864 ? rr = 0 : rr = yr / 67108864 | 0;
        }
        return Ie;
      }, or.prototype.convert13b = function(Ie, xe, rr, ar) {
        for (var yr = 0, _r = 0; _r < xe; _r++)
          yr = yr + (Ie[_r] | 0), rr[2 * _r] = yr & 8191, yr = yr >>> 13, rr[2 * _r + 1] = yr & 8191, yr = yr >>> 13;
        for (_r = 2 * xe; _r < ar; ++_r)
          rr[_r] = 0;
        p(yr === 0), p((yr & -8192) === 0);
      }, or.prototype.stub = function(Ie) {
        for (var xe = new Array(Ie), rr = 0; rr < Ie; rr++)
          xe[rr] = 0;
        return xe;
      }, or.prototype.mulp = function(Ie, xe, rr) {
        var ar = 2 * this.guessLen13b(Ie.length, xe.length), yr = this.makeRBT(ar), _r = this.stub(ar), Or = new Array(ar), vr = new Array(ar), Te = new Array(ar), Cr = new Array(ar), Hr = new Array(ar), si = new Array(ar), ui = rr.words;
        ui.length = ar, this.convert13b(Ie.words, Ie.length, Or, ar), this.convert13b(xe.words, xe.length, Cr, ar), this.transform(Or, _r, vr, Te, ar, yr), this.transform(Cr, _r, Hr, si, ar, yr);
        for (var Li = 0; Li < ar; Li++) {
          var Qi = vr[Li] * Hr[Li] - Te[Li] * si[Li];
          Te[Li] = vr[Li] * si[Li] + Te[Li] * Hr[Li], vr[Li] = Qi;
        }
        return this.conjugate(vr, Te, ar), this.transform(vr, Te, ui, _r, ar, yr), this.conjugate(ui, _r, ar), this.normalize13b(ui, ar), rr.negative = Ie.negative ^ xe.negative, rr.length = Ie.length + xe.length, rr.strip();
      }, A.prototype.mul = function(Ie) {
        var xe = new A(null);
        return xe.words = new Array(this.length + Ie.length), this.mulTo(Ie, xe);
      }, A.prototype.mulf = function(Ie) {
        var xe = new A(null);
        return xe.words = new Array(this.length + Ie.length), ir(this, Ie, xe);
      }, A.prototype.imul = function(Ie) {
        return this.clone().mulTo(Ie, this);
      }, A.prototype.imuln = function(Ie) {
        p(typeof Ie == "number"), p(Ie < 67108864);
        for (var xe = 0, rr = 0; rr < this.length; rr++) {
          var ar = (this.words[rr] | 0) * Ie, yr = (ar & 67108863) + (xe & 67108863);
          xe >>= 26, xe += ar / 67108864 | 0, xe += yr >>> 26, this.words[rr] = yr & 67108863;
        }
        return xe !== 0 && (this.words[rr] = xe, this.length++), this;
      }, A.prototype.muln = function(Ie) {
        return this.clone().imuln(Ie);
      }, A.prototype.sqr = function() {
        return this.mul(this);
      }, A.prototype.isqr = function() {
        return this.imul(this.clone());
      }, A.prototype.pow = function(Ie) {
        var xe = be(Ie);
        if (xe.length === 0) return new A(1);
        for (var rr = this, ar = 0; ar < xe.length && xe[ar] === 0; ar++, rr = rr.sqr())
          ;
        if (++ar < xe.length)
          for (var yr = rr.sqr(); ar < xe.length; ar++, yr = yr.sqr())
            xe[ar] !== 0 && (rr = rr.mul(yr));
        return rr;
      }, A.prototype.iushln = function(Ie) {
        p(typeof Ie == "number" && Ie >= 0);
        var xe = Ie % 26, rr = (Ie - xe) / 26, ar = 67108863 >>> 26 - xe << 26 - xe, yr;
        if (xe !== 0) {
          var _r = 0;
          for (yr = 0; yr < this.length; yr++) {
            var Or = this.words[yr] & ar, vr = (this.words[yr] | 0) - Or << xe;
            this.words[yr] = vr | _r, _r = Or >>> 26 - xe;
          }
          _r && (this.words[yr] = _r, this.length++);
        }
        if (rr !== 0) {
          for (yr = this.length - 1; yr >= 0; yr--)
            this.words[yr + rr] = this.words[yr];
          for (yr = 0; yr < rr; yr++)
            this.words[yr] = 0;
          this.length += rr;
        }
        return this.strip();
      }, A.prototype.ishln = function(Ie) {
        return p(this.negative === 0), this.iushln(Ie);
      }, A.prototype.iushrn = function(Ie, xe, rr) {
        p(typeof Ie == "number" && Ie >= 0);
        var ar;
        xe ? ar = (xe - xe % 26) / 26 : ar = 0;
        var yr = Ie % 26, _r = Math.min((Ie - yr) / 26, this.length), Or = 67108863 ^ 67108863 >>> yr << yr, vr = rr;
        if (ar -= _r, ar = Math.max(0, ar), vr) {
          for (var Te = 0; Te < _r; Te++)
            vr.words[Te] = this.words[Te];
          vr.length = _r;
        }
        if (_r !== 0) if (this.length > _r)
          for (this.length -= _r, Te = 0; Te < this.length; Te++)
            this.words[Te] = this.words[Te + _r];
        else
          this.words[0] = 0, this.length = 1;
        var Cr = 0;
        for (Te = this.length - 1; Te >= 0 && (Cr !== 0 || Te >= ar); Te--) {
          var Hr = this.words[Te] | 0;
          this.words[Te] = Cr << 26 - yr | Hr >>> yr, Cr = Hr & Or;
        }
        return vr && Cr !== 0 && (vr.words[vr.length++] = Cr), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, A.prototype.ishrn = function(Ie, xe, rr) {
        return p(this.negative === 0), this.iushrn(Ie, xe, rr);
      }, A.prototype.shln = function(Ie) {
        return this.clone().ishln(Ie);
      }, A.prototype.ushln = function(Ie) {
        return this.clone().iushln(Ie);
      }, A.prototype.shrn = function(Ie) {
        return this.clone().ishrn(Ie);
      }, A.prototype.ushrn = function(Ie) {
        return this.clone().iushrn(Ie);
      }, A.prototype.testn = function(Ie) {
        p(typeof Ie == "number" && Ie >= 0);
        var xe = Ie % 26, rr = (Ie - xe) / 26, ar = 1 << xe;
        if (this.length <= rr) return !1;
        var yr = this.words[rr];
        return !!(yr & ar);
      }, A.prototype.imaskn = function(Ie) {
        p(typeof Ie == "number" && Ie >= 0);
        var xe = Ie % 26, rr = (Ie - xe) / 26;
        if (p(this.negative === 0, "imaskn works only with positive numbers"), this.length <= rr)
          return this;
        if (xe !== 0 && rr++, this.length = Math.min(rr, this.length), xe !== 0) {
          var ar = 67108863 ^ 67108863 >>> xe << xe;
          this.words[this.length - 1] &= ar;
        }
        return this.strip();
      }, A.prototype.maskn = function(Ie) {
        return this.clone().imaskn(Ie);
      }, A.prototype.iaddn = function(Ie) {
        return p(typeof Ie == "number"), p(Ie < 67108864), Ie < 0 ? this.isubn(-Ie) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < Ie ? (this.words[0] = Ie - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(Ie), this.negative = 1, this) : this._iaddn(Ie);
      }, A.prototype._iaddn = function(Ie) {
        this.words[0] += Ie;
        for (var xe = 0; xe < this.length && this.words[xe] >= 67108864; xe++)
          this.words[xe] -= 67108864, xe === this.length - 1 ? this.words[xe + 1] = 1 : this.words[xe + 1]++;
        return this.length = Math.max(this.length, xe + 1), this;
      }, A.prototype.isubn = function(Ie) {
        if (p(typeof Ie == "number"), p(Ie < 67108864), Ie < 0) return this.iaddn(-Ie);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(Ie), this.negative = 1, this;
        if (this.words[0] -= Ie, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var xe = 0; xe < this.length && this.words[xe] < 0; xe++)
            this.words[xe] += 67108864, this.words[xe + 1] -= 1;
        return this.strip();
      }, A.prototype.addn = function(Ie) {
        return this.clone().iaddn(Ie);
      }, A.prototype.subn = function(Ie) {
        return this.clone().isubn(Ie);
      }, A.prototype.iabs = function() {
        return this.negative = 0, this;
      }, A.prototype.abs = function() {
        return this.clone().iabs();
      }, A.prototype._ishlnsubmul = function(Ie, xe, rr) {
        var ar = Ie.length + rr, yr;
        this._expand(ar);
        var _r, Or = 0;
        for (yr = 0; yr < Ie.length; yr++) {
          _r = (this.words[yr + rr] | 0) + Or;
          var vr = (Ie.words[yr] | 0) * xe;
          _r -= vr & 67108863, Or = (_r >> 26) - (vr / 67108864 | 0), this.words[yr + rr] = _r & 67108863;
        }
        for (; yr < this.length - rr; yr++)
          _r = (this.words[yr + rr] | 0) + Or, Or = _r >> 26, this.words[yr + rr] = _r & 67108863;
        if (Or === 0) return this.strip();
        for (p(Or === -1), Or = 0, yr = 0; yr < this.length; yr++)
          _r = -(this.words[yr] | 0) + Or, Or = _r >> 26, this.words[yr] = _r & 67108863;
        return this.negative = 1, this.strip();
      }, A.prototype._wordDiv = function(Ie, xe) {
        var rr = this.length - Ie.length, ar = this.clone(), yr = Ie, _r = yr.words[yr.length - 1] | 0, Or = this._countBits(_r);
        rr = 26 - Or, rr !== 0 && (yr = yr.ushln(rr), ar.iushln(rr), _r = yr.words[yr.length - 1] | 0);
        var vr = ar.length - yr.length, Te;
        if (xe !== "mod") {
          Te = new A(null), Te.length = vr + 1, Te.words = new Array(Te.length);
          for (var Cr = 0; Cr < Te.length; Cr++)
            Te.words[Cr] = 0;
        }
        var Hr = ar.clone()._ishlnsubmul(yr, 1, vr);
        Hr.negative === 0 && (ar = Hr, Te && (Te.words[vr] = 1));
        for (var si = vr - 1; si >= 0; si--) {
          var ui = (ar.words[yr.length + si] | 0) * 67108864 + (ar.words[yr.length + si - 1] | 0);
          for (ui = Math.min(ui / _r | 0, 67108863), ar._ishlnsubmul(yr, ui, si); ar.negative !== 0; )
            ui--, ar.negative = 0, ar._ishlnsubmul(yr, 1, si), ar.isZero() || (ar.negative ^= 1);
          Te && (Te.words[si] = ui);
        }
        return Te && Te.strip(), ar.strip(), xe !== "div" && rr !== 0 && ar.iushrn(rr), {
          div: Te || null,
          mod: ar
        };
      }, A.prototype.divmod = function(Ie, xe, rr) {
        if (p(!Ie.isZero()), this.isZero())
          return {
            div: new A(0),
            mod: new A(0)
          };
        var ar, yr, _r;
        return this.negative !== 0 && Ie.negative === 0 ? (_r = this.neg().divmod(Ie, xe), xe !== "mod" && (ar = _r.div.neg()), xe !== "div" && (yr = _r.mod.neg(), rr && yr.negative !== 0 && yr.iadd(Ie)), {
          div: ar,
          mod: yr
        }) : this.negative === 0 && Ie.negative !== 0 ? (_r = this.divmod(Ie.neg(), xe), xe !== "mod" && (ar = _r.div.neg()), {
          div: ar,
          mod: _r.mod
        }) : this.negative & Ie.negative ? (_r = this.neg().divmod(Ie.neg(), xe), xe !== "div" && (yr = _r.mod.neg(), rr && yr.negative !== 0 && yr.isub(Ie)), {
          div: _r.div,
          mod: yr
        }) : Ie.length > this.length || this.cmp(Ie) < 0 ? {
          div: new A(0),
          mod: this
        } : Ie.length === 1 ? xe === "div" ? {
          div: this.divn(Ie.words[0]),
          mod: null
        } : xe === "mod" ? {
          div: null,
          mod: new A(this.modn(Ie.words[0]))
        } : {
          div: this.divn(Ie.words[0]),
          mod: new A(this.modn(Ie.words[0]))
        } : this._wordDiv(Ie, xe);
      }, A.prototype.div = function(Ie) {
        return this.divmod(Ie, "div", !1).div;
      }, A.prototype.mod = function(Ie) {
        return this.divmod(Ie, "mod", !1).mod;
      }, A.prototype.umod = function(Ie) {
        return this.divmod(Ie, "mod", !0).mod;
      }, A.prototype.divRound = function(Ie) {
        var xe = this.divmod(Ie);
        if (xe.mod.isZero()) return xe.div;
        var rr = xe.div.negative !== 0 ? xe.mod.isub(Ie) : xe.mod, ar = Ie.ushrn(1), yr = Ie.andln(1), _r = rr.cmp(ar);
        return _r < 0 || yr === 1 && _r === 0 ? xe.div : xe.div.negative !== 0 ? xe.div.isubn(1) : xe.div.iaddn(1);
      }, A.prototype.modn = function(Ie) {
        p(Ie <= 67108863);
        for (var xe = (1 << 26) % Ie, rr = 0, ar = this.length - 1; ar >= 0; ar--)
          rr = (xe * rr + (this.words[ar] | 0)) % Ie;
        return rr;
      }, A.prototype.idivn = function(Ie) {
        p(Ie <= 67108863);
        for (var xe = 0, rr = this.length - 1; rr >= 0; rr--) {
          var ar = (this.words[rr] | 0) + xe * 67108864;
          this.words[rr] = ar / Ie | 0, xe = ar % Ie;
        }
        return this.strip();
      }, A.prototype.divn = function(Ie) {
        return this.clone().idivn(Ie);
      }, A.prototype.egcd = function(Ie) {
        p(Ie.negative === 0), p(!Ie.isZero());
        var xe = this, rr = Ie.clone();
        xe.negative !== 0 ? xe = xe.umod(Ie) : xe = xe.clone();
        for (var ar = new A(1), yr = new A(0), _r = new A(0), Or = new A(1), vr = 0; xe.isEven() && rr.isEven(); )
          xe.iushrn(1), rr.iushrn(1), ++vr;
        for (var Te = rr.clone(), Cr = xe.clone(); !xe.isZero(); ) {
          for (var Hr = 0, si = 1; !(xe.words[0] & si) && Hr < 26; ++Hr, si <<= 1) ;
          if (Hr > 0)
            for (xe.iushrn(Hr); Hr-- > 0; )
              (ar.isOdd() || yr.isOdd()) && (ar.iadd(Te), yr.isub(Cr)), ar.iushrn(1), yr.iushrn(1);
          for (var ui = 0, Li = 1; !(rr.words[0] & Li) && ui < 26; ++ui, Li <<= 1) ;
          if (ui > 0)
            for (rr.iushrn(ui); ui-- > 0; )
              (_r.isOdd() || Or.isOdd()) && (_r.iadd(Te), Or.isub(Cr)), _r.iushrn(1), Or.iushrn(1);
          xe.cmp(rr) >= 0 ? (xe.isub(rr), ar.isub(_r), yr.isub(Or)) : (rr.isub(xe), _r.isub(ar), Or.isub(yr));
        }
        return {
          a: _r,
          b: Or,
          gcd: rr.iushln(vr)
        };
      }, A.prototype._invmp = function(Ie) {
        p(Ie.negative === 0), p(!Ie.isZero());
        var xe = this, rr = Ie.clone();
        xe.negative !== 0 ? xe = xe.umod(Ie) : xe = xe.clone();
        for (var ar = new A(1), yr = new A(0), _r = rr.clone(); xe.cmpn(1) > 0 && rr.cmpn(1) > 0; ) {
          for (var Or = 0, vr = 1; !(xe.words[0] & vr) && Or < 26; ++Or, vr <<= 1) ;
          if (Or > 0)
            for (xe.iushrn(Or); Or-- > 0; )
              ar.isOdd() && ar.iadd(_r), ar.iushrn(1);
          for (var Te = 0, Cr = 1; !(rr.words[0] & Cr) && Te < 26; ++Te, Cr <<= 1) ;
          if (Te > 0)
            for (rr.iushrn(Te); Te-- > 0; )
              yr.isOdd() && yr.iadd(_r), yr.iushrn(1);
          xe.cmp(rr) >= 0 ? (xe.isub(rr), ar.isub(yr)) : (rr.isub(xe), yr.isub(ar));
        }
        var Hr;
        return xe.cmpn(1) === 0 ? Hr = ar : Hr = yr, Hr.cmpn(0) < 0 && Hr.iadd(Ie), Hr;
      }, A.prototype.gcd = function(Ie) {
        if (this.isZero()) return Ie.abs();
        if (Ie.isZero()) return this.abs();
        var xe = this.clone(), rr = Ie.clone();
        xe.negative = 0, rr.negative = 0;
        for (var ar = 0; xe.isEven() && rr.isEven(); ar++)
          xe.iushrn(1), rr.iushrn(1);
        do {
          for (; xe.isEven(); )
            xe.iushrn(1);
          for (; rr.isEven(); )
            rr.iushrn(1);
          var yr = xe.cmp(rr);
          if (yr < 0) {
            var _r = xe;
            xe = rr, rr = _r;
          } else if (yr === 0 || rr.cmpn(1) === 0)
            break;
          xe.isub(rr);
        } while (!0);
        return rr.iushln(ar);
      }, A.prototype.invm = function(Ie) {
        return this.egcd(Ie).a.umod(Ie);
      }, A.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, A.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, A.prototype.andln = function(Ie) {
        return this.words[0] & Ie;
      }, A.prototype.bincn = function(Ie) {
        p(typeof Ie == "number");
        var xe = Ie % 26, rr = (Ie - xe) / 26, ar = 1 << xe;
        if (this.length <= rr)
          return this._expand(rr + 1), this.words[rr] |= ar, this;
        for (var yr = ar, _r = rr; yr !== 0 && _r < this.length; _r++) {
          var Or = this.words[_r] | 0;
          Or += yr, yr = Or >>> 26, Or &= 67108863, this.words[_r] = Or;
        }
        return yr !== 0 && (this.words[_r] = yr, this.length++), this;
      }, A.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, A.prototype.cmpn = function(Ie) {
        var xe = Ie < 0;
        if (this.negative !== 0 && !xe) return -1;
        if (this.negative === 0 && xe) return 1;
        this.strip();
        var rr;
        if (this.length > 1)
          rr = 1;
        else {
          xe && (Ie = -Ie), p(Ie <= 67108863, "Number is too big");
          var ar = this.words[0] | 0;
          rr = ar === Ie ? 0 : ar < Ie ? -1 : 1;
        }
        return this.negative !== 0 ? -rr | 0 : rr;
      }, A.prototype.cmp = function(Ie) {
        if (this.negative !== 0 && Ie.negative === 0) return -1;
        if (this.negative === 0 && Ie.negative !== 0) return 1;
        var xe = this.ucmp(Ie);
        return this.negative !== 0 ? -xe | 0 : xe;
      }, A.prototype.ucmp = function(Ie) {
        if (this.length > Ie.length) return 1;
        if (this.length < Ie.length) return -1;
        for (var xe = 0, rr = this.length - 1; rr >= 0; rr--) {
          var ar = this.words[rr] | 0, yr = Ie.words[rr] | 0;
          if (ar !== yr) {
            ar < yr ? xe = -1 : ar > yr && (xe = 1);
            break;
          }
        }
        return xe;
      }, A.prototype.gtn = function(Ie) {
        return this.cmpn(Ie) === 1;
      }, A.prototype.gt = function(Ie) {
        return this.cmp(Ie) === 1;
      }, A.prototype.gten = function(Ie) {
        return this.cmpn(Ie) >= 0;
      }, A.prototype.gte = function(Ie) {
        return this.cmp(Ie) >= 0;
      }, A.prototype.ltn = function(Ie) {
        return this.cmpn(Ie) === -1;
      }, A.prototype.lt = function(Ie) {
        return this.cmp(Ie) === -1;
      }, A.prototype.lten = function(Ie) {
        return this.cmpn(Ie) <= 0;
      }, A.prototype.lte = function(Ie) {
        return this.cmp(Ie) <= 0;
      }, A.prototype.eqn = function(Ie) {
        return this.cmpn(Ie) === 0;
      }, A.prototype.eq = function(Ie) {
        return this.cmp(Ie) === 0;
      }, A.red = function(Ie) {
        return new Fe(Ie);
      }, A.prototype.toRed = function(Ie) {
        return p(!this.red, "Already a number in reduction context"), p(this.negative === 0, "red works only with positives"), Ie.convertTo(this)._forceRed(Ie);
      }, A.prototype.fromRed = function() {
        return p(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, A.prototype._forceRed = function(Ie) {
        return this.red = Ie, this;
      }, A.prototype.forceRed = function(Ie) {
        return p(!this.red, "Already a number in reduction context"), this._forceRed(Ie);
      }, A.prototype.redAdd = function(Ie) {
        return p(this.red, "redAdd works only with red numbers"), this.red.add(this, Ie);
      }, A.prototype.redIAdd = function(Ie) {
        return p(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, Ie);
      }, A.prototype.redSub = function(Ie) {
        return p(this.red, "redSub works only with red numbers"), this.red.sub(this, Ie);
      }, A.prototype.redISub = function(Ie) {
        return p(this.red, "redISub works only with red numbers"), this.red.isub(this, Ie);
      }, A.prototype.redShl = function(Ie) {
        return p(this.red, "redShl works only with red numbers"), this.red.shl(this, Ie);
      }, A.prototype.redMul = function(Ie) {
        return p(this.red, "redMul works only with red numbers"), this.red._verify2(this, Ie), this.red.mul(this, Ie);
      }, A.prototype.redIMul = function(Ie) {
        return p(this.red, "redMul works only with red numbers"), this.red._verify2(this, Ie), this.red.imul(this, Ie);
      }, A.prototype.redSqr = function() {
        return p(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, A.prototype.redISqr = function() {
        return p(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, A.prototype.redSqrt = function() {
        return p(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, A.prototype.redInvm = function() {
        return p(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, A.prototype.redNeg = function() {
        return p(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, A.prototype.redPow = function(Ie) {
        return p(this.red && !Ie.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, Ie);
      };
      var lr = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function Ir(er, Ie) {
        this.name = er, this.p = new A(Ie, 16), this.n = this.p.bitLength(), this.k = new A(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      Ir.prototype._tmp = function() {
        var Ie = new A(null);
        return Ie.words = new Array(Math.ceil(this.n / 13)), Ie;
      }, Ir.prototype.ireduce = function(Ie) {
        var xe = Ie, rr;
        do
          this.split(xe, this.tmp), xe = this.imulK(xe), xe = xe.iadd(this.tmp), rr = xe.bitLength();
        while (rr > this.n);
        var ar = rr < this.n ? -1 : xe.ucmp(this.p);
        return ar === 0 ? (xe.words[0] = 0, xe.length = 1) : ar > 0 ? xe.isub(this.p) : xe.strip !== void 0 ? xe.strip() : xe._strip(), xe;
      }, Ir.prototype.split = function(Ie, xe) {
        Ie.iushrn(this.n, 0, xe);
      }, Ir.prototype.imulK = function(Ie) {
        return Ie.imul(this.k);
      };
      function xr() {
        Ir.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      a(xr, Ir), xr.prototype.split = function(Ie, xe) {
        for (var rr = 4194303, ar = Math.min(Ie.length, 9), yr = 0; yr < ar; yr++)
          xe.words[yr] = Ie.words[yr];
        if (xe.length = ar, Ie.length <= 9) {
          Ie.words[0] = 0, Ie.length = 1;
          return;
        }
        var _r = Ie.words[9];
        for (xe.words[xe.length++] = _r & rr, yr = 10; yr < Ie.length; yr++) {
          var Or = Ie.words[yr] | 0;
          Ie.words[yr - 10] = (Or & rr) << 4 | _r >>> 22, _r = Or;
        }
        _r >>>= 22, Ie.words[yr - 10] = _r, _r === 0 && Ie.length > 10 ? Ie.length -= 10 : Ie.length -= 9;
      }, xr.prototype.imulK = function(Ie) {
        Ie.words[Ie.length] = 0, Ie.words[Ie.length + 1] = 0, Ie.length += 2;
        for (var xe = 0, rr = 0; rr < Ie.length; rr++) {
          var ar = Ie.words[rr] | 0;
          xe += ar * 977, Ie.words[rr] = xe & 67108863, xe = ar * 64 + (xe / 67108864 | 0);
        }
        return Ie.words[Ie.length - 1] === 0 && (Ie.length--, Ie.words[Ie.length - 1] === 0 && Ie.length--), Ie;
      };
      function kr() {
        Ir.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      a(kr, Ir);
      function Ce() {
        Ir.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      a(Ce, Ir);
      function tr() {
        Ir.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      a(tr, Ir), tr.prototype.imulK = function(Ie) {
        for (var xe = 0, rr = 0; rr < Ie.length; rr++) {
          var ar = (Ie.words[rr] | 0) * 19 + xe, yr = ar & 67108863;
          ar >>>= 26, Ie.words[rr] = yr, xe = ar;
        }
        return xe !== 0 && (Ie.words[Ie.length++] = xe), Ie;
      }, A._prime = function(Ie) {
        if (lr[Ie]) return lr[Ie];
        var xe;
        if (Ie === "k256")
          xe = new xr();
        else if (Ie === "p224")
          xe = new kr();
        else if (Ie === "p192")
          xe = new Ce();
        else if (Ie === "p25519")
          xe = new tr();
        else
          throw new Error("Unknown prime " + Ie);
        return lr[Ie] = xe, xe;
      };
      function Fe(er) {
        if (typeof er == "string") {
          var Ie = A._prime(er);
          this.m = Ie.p, this.prime = Ie;
        } else
          p(er.gtn(1), "modulus must be greater than 1"), this.m = er, this.prime = null;
      }
      Fe.prototype._verify1 = function(Ie) {
        p(Ie.negative === 0, "red works only with positives"), p(Ie.red, "red works only with red numbers");
      }, Fe.prototype._verify2 = function(Ie, xe) {
        p((Ie.negative | xe.negative) === 0, "red works only with positives"), p(
          Ie.red && Ie.red === xe.red,
          "red works only with red numbers"
        );
      }, Fe.prototype.imod = function(Ie) {
        return this.prime ? this.prime.ireduce(Ie)._forceRed(this) : Ie.umod(this.m)._forceRed(this);
      }, Fe.prototype.neg = function(Ie) {
        return Ie.isZero() ? Ie.clone() : this.m.sub(Ie)._forceRed(this);
      }, Fe.prototype.add = function(Ie, xe) {
        this._verify2(Ie, xe);
        var rr = Ie.add(xe);
        return rr.cmp(this.m) >= 0 && rr.isub(this.m), rr._forceRed(this);
      }, Fe.prototype.iadd = function(Ie, xe) {
        this._verify2(Ie, xe);
        var rr = Ie.iadd(xe);
        return rr.cmp(this.m) >= 0 && rr.isub(this.m), rr;
      }, Fe.prototype.sub = function(Ie, xe) {
        this._verify2(Ie, xe);
        var rr = Ie.sub(xe);
        return rr.cmpn(0) < 0 && rr.iadd(this.m), rr._forceRed(this);
      }, Fe.prototype.isub = function(Ie, xe) {
        this._verify2(Ie, xe);
        var rr = Ie.isub(xe);
        return rr.cmpn(0) < 0 && rr.iadd(this.m), rr;
      }, Fe.prototype.shl = function(Ie, xe) {
        return this._verify1(Ie), this.imod(Ie.ushln(xe));
      }, Fe.prototype.imul = function(Ie, xe) {
        return this._verify2(Ie, xe), this.imod(Ie.imul(xe));
      }, Fe.prototype.mul = function(Ie, xe) {
        return this._verify2(Ie, xe), this.imod(Ie.mul(xe));
      }, Fe.prototype.isqr = function(Ie) {
        return this.imul(Ie, Ie.clone());
      }, Fe.prototype.sqr = function(Ie) {
        return this.mul(Ie, Ie);
      }, Fe.prototype.sqrt = function(Ie) {
        if (Ie.isZero()) return Ie.clone();
        var xe = this.m.andln(3);
        if (p(xe % 2 === 1), xe === 3) {
          var rr = this.m.add(new A(1)).iushrn(2);
          return this.pow(Ie, rr);
        }
        for (var ar = this.m.subn(1), yr = 0; !ar.isZero() && ar.andln(1) === 0; )
          yr++, ar.iushrn(1);
        p(!ar.isZero());
        var _r = new A(1).toRed(this), Or = _r.redNeg(), vr = this.m.subn(1).iushrn(1), Te = this.m.bitLength();
        for (Te = new A(2 * Te * Te).toRed(this); this.pow(Te, vr).cmp(Or) !== 0; )
          Te.redIAdd(Or);
        for (var Cr = this.pow(Te, ar), Hr = this.pow(Ie, ar.addn(1).iushrn(1)), si = this.pow(Ie, ar), ui = yr; si.cmp(_r) !== 0; ) {
          for (var Li = si, Qi = 0; Li.cmp(_r) !== 0; Qi++)
            Li = Li.redSqr();
          p(Qi < ui);
          var wi = this.pow(Cr, new A(1).iushln(ui - Qi - 1));
          Hr = Hr.redMul(wi), Cr = wi.redSqr(), si = si.redMul(Cr), ui = Qi;
        }
        return Hr;
      }, Fe.prototype.invm = function(Ie) {
        var xe = Ie._invmp(this.m);
        return xe.negative !== 0 ? (xe.negative = 0, this.imod(xe).redNeg()) : this.imod(xe);
      }, Fe.prototype.pow = function(Ie, xe) {
        if (xe.isZero()) return new A(1).toRed(this);
        if (xe.cmpn(1) === 0) return Ie.clone();
        var rr = 4, ar = new Array(1 << rr);
        ar[0] = new A(1).toRed(this), ar[1] = Ie;
        for (var yr = 2; yr < ar.length; yr++)
          ar[yr] = this.mul(ar[yr - 1], Ie);
        var _r = ar[0], Or = 0, vr = 0, Te = xe.bitLength() % 26;
        for (Te === 0 && (Te = 26), yr = xe.length - 1; yr >= 0; yr--) {
          for (var Cr = xe.words[yr], Hr = Te - 1; Hr >= 0; Hr--) {
            var si = Cr >> Hr & 1;
            if (_r !== ar[0] && (_r = this.sqr(_r)), si === 0 && Or === 0) {
              vr = 0;
              continue;
            }
            Or <<= 1, Or |= si, vr++, !(vr !== rr && (yr !== 0 || Hr !== 0)) && (_r = this.mul(_r, ar[Or]), vr = 0, Or = 0);
          }
          Te = 26;
        }
        return _r;
      }, Fe.prototype.convertTo = function(Ie) {
        var xe = Ie.umod(this.m);
        return xe === Ie ? xe.clone() : xe;
      }, Fe.prototype.convertFrom = function(Ie) {
        var xe = Ie.clone();
        return xe.red = null, xe;
      }, A.mont = function(Ie) {
        return new Sr(Ie);
      };
      function Sr(er) {
        Fe.call(this, er), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new A(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      a(Sr, Fe), Sr.prototype.convertTo = function(Ie) {
        return this.imod(Ie.ushln(this.shift));
      }, Sr.prototype.convertFrom = function(Ie) {
        var xe = this.imod(Ie.mul(this.rinv));
        return xe.red = null, xe;
      }, Sr.prototype.imul = function(Ie, xe) {
        if (Ie.isZero() || xe.isZero())
          return Ie.words[0] = 0, Ie.length = 1, Ie;
        var rr = Ie.imul(xe), ar = rr.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), yr = rr.isub(ar).iushrn(this.shift), _r = yr;
        return yr.cmp(this.m) >= 0 ? _r = yr.isub(this.m) : yr.cmpn(0) < 0 && (_r = yr.iadd(this.m)), _r._forceRed(this);
      }, Sr.prototype.mul = function(Ie, xe) {
        if (Ie.isZero() || xe.isZero()) return new A(0)._forceRed(this);
        var rr = Ie.mul(xe), ar = rr.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), yr = rr.isub(ar).iushrn(this.shift), _r = yr;
        return yr.cmp(this.m) >= 0 ? _r = yr.isub(this.m) : yr.cmpn(0) < 0 && (_r = yr.iadd(this.m)), _r._forceRed(this);
      }, Sr.prototype.invm = function(Ie) {
        var xe = this.imod(Ie._invmp(this.m).mul(this.r2));
        return xe._forceRed(this);
      };
    })(n, commonjsGlobal);
  }(bn$2)), bn$2.exports;
}
var api = {}, vmBrowserify = {}, hasRequiredVmBrowserify;
function requireVmBrowserify() {
  return hasRequiredVmBrowserify || (hasRequiredVmBrowserify = 1, function(exports) {
    var indexOf = function(n, c) {
      if (n.indexOf) return n.indexOf(c);
      for (var u = 0; u < n.length; u++)
        if (n[u] === c) return u;
      return -1;
    }, Object_keys = function(n) {
      if (Object.keys) return Object.keys(n);
      var c = [];
      for (var u in n) c.push(u);
      return c;
    }, forEach = function(n, c) {
      if (n.forEach) return n.forEach(c);
      for (var u = 0; u < n.length; u++)
        c(n[u], u, n);
    }, defineProp = function() {
      try {
        return Object.defineProperty({}, "_", {}), function(n, c, u) {
          Object.defineProperty(n, c, {
            writable: !0,
            enumerable: !1,
            configurable: !0,
            value: u
          });
        };
      } catch {
        return function(c, u, p) {
          c[u] = p;
        };
      }
    }(), globals = [
      "Array",
      "Boolean",
      "Date",
      "Error",
      "EvalError",
      "Function",
      "Infinity",
      "JSON",
      "Math",
      "NaN",
      "Number",
      "Object",
      "RangeError",
      "ReferenceError",
      "RegExp",
      "String",
      "SyntaxError",
      "TypeError",
      "URIError",
      "decodeURI",
      "decodeURIComponent",
      "encodeURI",
      "encodeURIComponent",
      "escape",
      "eval",
      "isFinite",
      "isNaN",
      "parseFloat",
      "parseInt",
      "undefined",
      "unescape"
    ];
    function Context() {
    }
    Context.prototype = {};
    var Script = exports.Script = function(c) {
      if (!(this instanceof Script)) return new Script(c);
      this.code = c;
    };
    Script.prototype.runInContext = function(n) {
      if (!(n instanceof Context))
        throw new TypeError("needs a 'context' argument.");
      var c = document.createElement("iframe");
      c.style || (c.style = {}), c.style.display = "none", document.body.appendChild(c);
      var u = c.contentWindow, p = u.eval, a = u.execScript;
      !p && a && (a.call(u, "null"), p = u.eval), forEach(Object_keys(n), function(F) {
        u[F] = n[F];
      }), forEach(globals, function(F) {
        n[F] && (u[F] = n[F]);
      });
      var A = Object_keys(u), b = p.call(u, this.code);
      return forEach(Object_keys(u), function(F) {
        (F in n || indexOf(A, F) === -1) && (n[F] = u[F]);
      }), forEach(globals, function(F) {
        F in n || defineProp(n, F, u[F]);
      }), document.body.removeChild(c), b;
    }, Script.prototype.runInThisContext = function() {
      return eval(this.code);
    }, Script.prototype.runInNewContext = function(n) {
      var c = Script.createContext(n), u = this.runInContext(c);
      return n && forEach(Object_keys(c), function(p) {
        n[p] = c[p];
      }), u;
    }, forEach(Object_keys(Script.prototype), function(n) {
      exports[n] = Script[n] = function(c) {
        var u = Script(c);
        return u[n].apply(u, [].slice.call(arguments, 1));
      };
    }), exports.isContext = function(n) {
      return n instanceof Context;
    }, exports.createScript = function(n) {
      return exports.Script(n);
    }, exports.createContext = Script.createContext = function(n) {
      var c = new Context();
      return typeof n == "object" && forEach(Object_keys(n), function(u) {
        c[u] = n[u];
      }), c;
    };
  }(vmBrowserify)), vmBrowserify;
}
var hasRequiredApi;
function requireApi() {
  return hasRequiredApi || (hasRequiredApi = 1, function(n) {
    var c = requireAsn1$1(), u = inherits_browserExports, p = n;
    p.define = function(b, F) {
      return new a(b, F);
    };
    function a(A, b) {
      this.name = A, this.body = b, this.decoders = {}, this.encoders = {};
    }
    a.prototype._createNamed = function(b) {
      var F;
      try {
        F = requireVmBrowserify().runInThisContext(
          "(function " + this.name + `(entity) {
  this._initNamed(entity);
})`
        );
      } catch {
        F = function(L) {
          this._initNamed(L);
        };
      }
      return u(F, b), F.prototype._initNamed = function(L) {
        b.call(this, L);
      }, new F(this);
    }, a.prototype._getDecoder = function(b) {
      return b = b || "der", this.decoders.hasOwnProperty(b) || (this.decoders[b] = this._createNamed(c.decoders[b])), this.decoders[b];
    }, a.prototype.decode = function(b, F, le) {
      return this._getDecoder(F).decode(b, le);
    }, a.prototype._getEncoder = function(b) {
      return b = b || "der", this.encoders.hasOwnProperty(b) || (this.encoders[b] = this._createNamed(c.encoders[b])), this.encoders[b];
    }, a.prototype.encode = function(b, F, le) {
      return this._getEncoder(F).encode(b, le);
    };
  }(api)), api;
}
var base$c = {}, reporter = {}, hasRequiredReporter;
function requireReporter() {
  if (hasRequiredReporter) return reporter;
  hasRequiredReporter = 1;
  var n = inherits_browserExports;
  function c(p) {
    this._reporterState = {
      obj: null,
      path: [],
      options: p || {},
      errors: []
    };
  }
  reporter.Reporter = c, c.prototype.isError = function(a) {
    return a instanceof u;
  }, c.prototype.save = function() {
    var a = this._reporterState;
    return { obj: a.obj, pathLen: a.path.length };
  }, c.prototype.restore = function(a) {
    var A = this._reporterState;
    A.obj = a.obj, A.path = A.path.slice(0, a.pathLen);
  }, c.prototype.enterKey = function(a) {
    return this._reporterState.path.push(a);
  }, c.prototype.exitKey = function(a) {
    var A = this._reporterState;
    A.path = A.path.slice(0, a - 1);
  }, c.prototype.leaveKey = function(a, A, b) {
    var F = this._reporterState;
    this.exitKey(a), F.obj !== null && (F.obj[A] = b);
  }, c.prototype.path = function() {
    return this._reporterState.path.join("/");
  }, c.prototype.enterObject = function() {
    var a = this._reporterState, A = a.obj;
    return a.obj = {}, A;
  }, c.prototype.leaveObject = function(a) {
    var A = this._reporterState, b = A.obj;
    return A.obj = a, b;
  }, c.prototype.error = function(a) {
    var A, b = this._reporterState, F = a instanceof u;
    if (F ? A = a : A = new u(b.path.map(function(le) {
      return "[" + JSON.stringify(le) + "]";
    }).join(""), a.message || a, a.stack), !b.options.partial)
      throw A;
    return F || b.errors.push(A), A;
  }, c.prototype.wrapResult = function(a) {
    var A = this._reporterState;
    return A.options.partial ? {
      result: this.isError(a) ? null : a,
      errors: A.errors
    } : a;
  };
  function u(p, a) {
    this.path = p, this.rethrow(a);
  }
  return n(u, Error), u.prototype.rethrow = function(a) {
    if (this.message = a + " at: " + (this.path || "(shallow)"), Error.captureStackTrace && Error.captureStackTrace(this, u), !this.stack)
      try {
        throw new Error(this.message);
      } catch (A) {
        this.stack = A.stack;
      }
    return this;
  }, reporter;
}
var buffer$2 = {}, hasRequiredBuffer;
function requireBuffer() {
  if (hasRequiredBuffer) return buffer$2;
  hasRequiredBuffer = 1;
  var n = inherits_browserExports, c = requireBase$9().Reporter, u = require$$0$5.Buffer;
  function p(A, b) {
    if (c.call(this, b), !u.isBuffer(A)) {
      this.error("Input not Buffer");
      return;
    }
    this.base = A, this.offset = 0, this.length = A.length;
  }
  n(p, c), buffer$2.DecoderBuffer = p, p.prototype.save = function() {
    return { offset: this.offset, reporter: c.prototype.save.call(this) };
  }, p.prototype.restore = function(b) {
    var F = new p(this.base);
    return F.offset = b.offset, F.length = this.offset, this.offset = b.offset, c.prototype.restore.call(this, b.reporter), F;
  }, p.prototype.isEmpty = function() {
    return this.offset === this.length;
  }, p.prototype.readUInt8 = function(b) {
    return this.offset + 1 <= this.length ? this.base.readUInt8(this.offset++, !0) : this.error(b || "DecoderBuffer overrun");
  }, p.prototype.skip = function(b, F) {
    if (!(this.offset + b <= this.length))
      return this.error(F || "DecoderBuffer overrun");
    var le = new p(this.base);
    return le._reporterState = this._reporterState, le.offset = this.offset, le.length = this.offset + b, this.offset += b, le;
  }, p.prototype.raw = function(b) {
    return this.base.slice(b ? b.offset : this.offset, this.length);
  };
  function a(A, b) {
    if (Array.isArray(A))
      this.length = 0, this.value = A.map(function(F) {
        return F instanceof a || (F = new a(F, b)), this.length += F.length, F;
      }, this);
    else if (typeof A == "number") {
      if (!(0 <= A && A <= 255))
        return b.error("non-byte EncoderBuffer value");
      this.value = A, this.length = 1;
    } else if (typeof A == "string")
      this.value = A, this.length = u.byteLength(A);
    else if (u.isBuffer(A))
      this.value = A, this.length = A.length;
    else
      return b.error("Unsupported type: " + typeof A);
  }
  return buffer$2.EncoderBuffer = a, a.prototype.join = function(b, F) {
    return b || (b = new u(this.length)), F || (F = 0), this.length === 0 || (Array.isArray(this.value) ? this.value.forEach(function(le) {
      le.join(b, F), F += le.length;
    }) : (typeof this.value == "number" ? b[F] = this.value : typeof this.value == "string" ? b.write(this.value, F) : u.isBuffer(this.value) && this.value.copy(b, F), F += this.length)), b;
  }, buffer$2;
}
var node, hasRequiredNode;
function requireNode() {
  if (hasRequiredNode) return node;
  hasRequiredNode = 1;
  var n = requireBase$9().Reporter, c = requireBase$9().EncoderBuffer, u = requireBase$9().DecoderBuffer, p = minimalisticAssert, a = [
    "seq",
    "seqof",
    "set",
    "setof",
    "objid",
    "bool",
    "gentime",
    "utctime",
    "null_",
    "enum",
    "int",
    "objDesc",
    "bitstr",
    "bmpstr",
    "charstr",
    "genstr",
    "graphstr",
    "ia5str",
    "iso646str",
    "numstr",
    "octstr",
    "printstr",
    "t61str",
    "unistr",
    "utf8str",
    "videostr"
  ], A = [
    "key",
    "obj",
    "use",
    "optional",
    "explicit",
    "implicit",
    "def",
    "choice",
    "any",
    "contains"
  ].concat(a), b = [
    "_peekTag",
    "_decodeTag",
    "_use",
    "_decodeStr",
    "_decodeObjid",
    "_decodeTime",
    "_decodeNull",
    "_decodeInt",
    "_decodeBool",
    "_decodeList",
    "_encodeComposite",
    "_encodeStr",
    "_encodeObjid",
    "_encodeTime",
    "_encodeNull",
    "_encodeInt",
    "_encodeBool"
  ];
  function F(L, pe) {
    var $ = {};
    this._baseState = $, $.enc = L, $.parent = pe || null, $.children = null, $.tag = null, $.args = null, $.reverseArgs = null, $.choice = null, $.optional = !1, $.any = !1, $.obj = !1, $.use = null, $.useDecoder = null, $.key = null, $.default = null, $.explicit = null, $.implicit = null, $.contains = null, $.parent || ($.children = [], this._wrap());
  }
  node = F;
  var le = [
    "enc",
    "parent",
    "children",
    "tag",
    "args",
    "reverseArgs",
    "choice",
    "optional",
    "any",
    "obj",
    "use",
    "alteredUse",
    "key",
    "default",
    "explicit",
    "implicit",
    "contains"
  ];
  return F.prototype.clone = function() {
    var pe = this._baseState, $ = {};
    le.forEach(function(be) {
      $[be] = pe[be];
    });
    var Ee = new this.constructor($.parent);
    return Ee._baseState = $, Ee;
  }, F.prototype._wrap = function() {
    var pe = this._baseState;
    A.forEach(function($) {
      this[$] = function() {
        var be = new this.constructor(this);
        return pe.children.push(be), be[$].apply(be, arguments);
      };
    }, this);
  }, F.prototype._init = function(pe) {
    var $ = this._baseState;
    p($.parent === null), pe.call(this), $.children = $.children.filter(function(Ee) {
      return Ee._baseState.parent === this;
    }, this), p.equal($.children.length, 1, "Root node can have only one child");
  }, F.prototype._useArgs = function(pe) {
    var $ = this._baseState, Ee = pe.filter(function(be) {
      return be instanceof this.constructor;
    }, this);
    pe = pe.filter(function(be) {
      return !(be instanceof this.constructor);
    }, this), Ee.length !== 0 && (p($.children === null), $.children = Ee, Ee.forEach(function(be) {
      be._baseState.parent = this;
    }, this)), pe.length !== 0 && (p($.args === null), $.args = pe, $.reverseArgs = pe.map(function(be) {
      if (typeof be != "object" || be.constructor !== Object)
        return be;
      var He = {};
      return Object.keys(be).forEach(function(Pe) {
        Pe == (Pe | 0) && (Pe |= 0);
        var nr = be[Pe];
        He[nr] = Pe;
      }), He;
    }));
  }, b.forEach(function(L) {
    F.prototype[L] = function() {
      var $ = this._baseState;
      throw new Error(L + " not implemented for encoding: " + $.enc);
    };
  }), a.forEach(function(L) {
    F.prototype[L] = function() {
      var $ = this._baseState, Ee = Array.prototype.slice.call(arguments);
      return p($.tag === null), $.tag = L, this._useArgs(Ee), this;
    };
  }), F.prototype.use = function(pe) {
    p(pe);
    var $ = this._baseState;
    return p($.use === null), $.use = pe, this;
  }, F.prototype.optional = function() {
    var pe = this._baseState;
    return pe.optional = !0, this;
  }, F.prototype.def = function(pe) {
    var $ = this._baseState;
    return p($.default === null), $.default = pe, $.optional = !0, this;
  }, F.prototype.explicit = function(pe) {
    var $ = this._baseState;
    return p($.explicit === null && $.implicit === null), $.explicit = pe, this;
  }, F.prototype.implicit = function(pe) {
    var $ = this._baseState;
    return p($.explicit === null && $.implicit === null), $.implicit = pe, this;
  }, F.prototype.obj = function() {
    var pe = this._baseState, $ = Array.prototype.slice.call(arguments);
    return pe.obj = !0, $.length !== 0 && this._useArgs($), this;
  }, F.prototype.key = function(pe) {
    var $ = this._baseState;
    return p($.key === null), $.key = pe, this;
  }, F.prototype.any = function() {
    var pe = this._baseState;
    return pe.any = !0, this;
  }, F.prototype.choice = function(pe) {
    var $ = this._baseState;
    return p($.choice === null), $.choice = pe, this._useArgs(Object.keys(pe).map(function(Ee) {
      return pe[Ee];
    })), this;
  }, F.prototype.contains = function(pe) {
    var $ = this._baseState;
    return p($.use === null), $.contains = pe, this;
  }, F.prototype._decode = function(pe, $) {
    var Ee = this._baseState;
    if (Ee.parent === null)
      return pe.wrapResult(Ee.children[0]._decode(pe, $));
    var be = Ee.default, He = !0, Pe = null;
    if (Ee.key !== null && (Pe = pe.enterKey(Ee.key)), Ee.optional) {
      var nr = null;
      if (Ee.explicit !== null ? nr = Ee.explicit : Ee.implicit !== null ? nr = Ee.implicit : Ee.tag !== null && (nr = Ee.tag), nr === null && !Ee.any) {
        var ir = pe.save();
        try {
          Ee.choice === null ? this._decodeGeneric(Ee.tag, pe, $) : this._decodeChoice(pe, $), He = !0;
        } catch {
          He = !1;
        }
        pe.restore(ir);
      } else if (He = this._peekTag(pe, nr, Ee.any), pe.isError(He))
        return He;
    }
    var or;
    if (Ee.obj && He && (or = pe.enterObject()), He) {
      if (Ee.explicit !== null) {
        var lr = this._decodeTag(pe, Ee.explicit);
        if (pe.isError(lr))
          return lr;
        pe = lr;
      }
      var Ir = pe.offset;
      if (Ee.use === null && Ee.choice === null) {
        if (Ee.any)
          var ir = pe.save();
        var xr = this._decodeTag(
          pe,
          Ee.implicit !== null ? Ee.implicit : Ee.tag,
          Ee.any
        );
        if (pe.isError(xr))
          return xr;
        Ee.any ? be = pe.raw(ir) : pe = xr;
      }
      if ($ && $.track && Ee.tag !== null && $.track(pe.path(), Ir, pe.length, "tagged"), $ && $.track && Ee.tag !== null && $.track(pe.path(), pe.offset, pe.length, "content"), Ee.any ? be = be : Ee.choice === null ? be = this._decodeGeneric(Ee.tag, pe, $) : be = this._decodeChoice(pe, $), pe.isError(be))
        return be;
      if (!Ee.any && Ee.choice === null && Ee.children !== null && Ee.children.forEach(function(tr) {
        tr._decode(pe, $);
      }), Ee.contains && (Ee.tag === "octstr" || Ee.tag === "bitstr")) {
        var kr = new u(be);
        be = this._getUse(Ee.contains, pe._reporterState.obj)._decode(kr, $);
      }
    }
    return Ee.obj && He && (be = pe.leaveObject(or)), Ee.key !== null && (be !== null || He === !0) ? pe.leaveKey(Pe, Ee.key, be) : Pe !== null && pe.exitKey(Pe), be;
  }, F.prototype._decodeGeneric = function(pe, $, Ee) {
    var be = this._baseState;
    return pe === "seq" || pe === "set" ? null : pe === "seqof" || pe === "setof" ? this._decodeList($, pe, be.args[0], Ee) : /str$/.test(pe) ? this._decodeStr($, pe, Ee) : pe === "objid" && be.args ? this._decodeObjid($, be.args[0], be.args[1], Ee) : pe === "objid" ? this._decodeObjid($, null, null, Ee) : pe === "gentime" || pe === "utctime" ? this._decodeTime($, pe, Ee) : pe === "null_" ? this._decodeNull($, Ee) : pe === "bool" ? this._decodeBool($, Ee) : pe === "objDesc" ? this._decodeStr($, pe, Ee) : pe === "int" || pe === "enum" ? this._decodeInt($, be.args && be.args[0], Ee) : be.use !== null ? this._getUse(be.use, $._reporterState.obj)._decode($, Ee) : $.error("unknown tag: " + pe);
  }, F.prototype._getUse = function(pe, $) {
    var Ee = this._baseState;
    return Ee.useDecoder = this._use(pe, $), p(Ee.useDecoder._baseState.parent === null), Ee.useDecoder = Ee.useDecoder._baseState.children[0], Ee.implicit !== Ee.useDecoder._baseState.implicit && (Ee.useDecoder = Ee.useDecoder.clone(), Ee.useDecoder._baseState.implicit = Ee.implicit), Ee.useDecoder;
  }, F.prototype._decodeChoice = function(pe, $) {
    var Ee = this._baseState, be = null, He = !1;
    return Object.keys(Ee.choice).some(function(Pe) {
      var nr = pe.save(), ir = Ee.choice[Pe];
      try {
        var or = ir._decode(pe, $);
        if (pe.isError(or))
          return !1;
        be = { type: Pe, value: or }, He = !0;
      } catch {
        return pe.restore(nr), !1;
      }
      return !0;
    }, this), He ? be : pe.error("Choice not matched");
  }, F.prototype._createEncoderBuffer = function(pe) {
    return new c(pe, this.reporter);
  }, F.prototype._encode = function(pe, $, Ee) {
    var be = this._baseState;
    if (!(be.default !== null && be.default === pe)) {
      var He = this._encodeValue(pe, $, Ee);
      if (He !== void 0 && !this._skipDefault(He, $, Ee))
        return He;
    }
  }, F.prototype._encodeValue = function(pe, $, Ee) {
    var be = this._baseState;
    if (be.parent === null)
      return be.children[0]._encode(pe, $ || new n());
    var ir = null;
    if (this.reporter = $, be.optional && pe === void 0)
      if (be.default !== null)
        pe = be.default;
      else
        return;
    var He = null, Pe = !1;
    if (be.any)
      ir = this._createEncoderBuffer(pe);
    else if (be.choice)
      ir = this._encodeChoice(pe, $);
    else if (be.contains)
      He = this._getUse(be.contains, Ee)._encode(pe, $), Pe = !0;
    else if (be.children)
      He = be.children.map(function(Ir) {
        if (Ir._baseState.tag === "null_")
          return Ir._encode(null, $, pe);
        if (Ir._baseState.key === null)
          return $.error("Child should have a key");
        var xr = $.enterKey(Ir._baseState.key);
        if (typeof pe != "object")
          return $.error("Child expected, but input is not object");
        var kr = Ir._encode(pe[Ir._baseState.key], $, pe);
        return $.leaveKey(xr), kr;
      }, this).filter(function(Ir) {
        return Ir;
      }), He = this._createEncoderBuffer(He);
    else if (be.tag === "seqof" || be.tag === "setof") {
      if (!(be.args && be.args.length === 1))
        return $.error("Too many args for : " + be.tag);
      if (!Array.isArray(pe))
        return $.error("seqof/setof, but data is not Array");
      var nr = this.clone();
      nr._baseState.implicit = null, He = this._createEncoderBuffer(pe.map(function(Ir) {
        var xr = this._baseState;
        return this._getUse(xr.args[0], pe)._encode(Ir, $);
      }, nr));
    } else be.use !== null ? ir = this._getUse(be.use, Ee)._encode(pe, $) : (He = this._encodePrimitive(be.tag, pe), Pe = !0);
    var ir;
    if (!be.any && be.choice === null) {
      var or = be.implicit !== null ? be.implicit : be.tag, lr = be.implicit === null ? "universal" : "context";
      or === null ? be.use === null && $.error("Tag could be omitted only for .use()") : be.use === null && (ir = this._encodeComposite(or, Pe, lr, He));
    }
    return be.explicit !== null && (ir = this._encodeComposite(be.explicit, !1, "context", ir)), ir;
  }, F.prototype._encodeChoice = function(pe, $) {
    var Ee = this._baseState, be = Ee.choice[pe.type];
    return be || p(
      !1,
      pe.type + " not found in " + JSON.stringify(Object.keys(Ee.choice))
    ), be._encode(pe.value, $);
  }, F.prototype._encodePrimitive = function(pe, $) {
    var Ee = this._baseState;
    if (/str$/.test(pe))
      return this._encodeStr($, pe);
    if (pe === "objid" && Ee.args)
      return this._encodeObjid($, Ee.reverseArgs[0], Ee.args[1]);
    if (pe === "objid")
      return this._encodeObjid($, null, null);
    if (pe === "gentime" || pe === "utctime")
      return this._encodeTime($, pe);
    if (pe === "null_")
      return this._encodeNull();
    if (pe === "int" || pe === "enum")
      return this._encodeInt($, Ee.args && Ee.reverseArgs[0]);
    if (pe === "bool")
      return this._encodeBool($);
    if (pe === "objDesc")
      return this._encodeStr($, pe);
    throw new Error("Unsupported tag: " + pe);
  }, F.prototype._isNumstr = function(pe) {
    return /^[0-9 ]*$/.test(pe);
  }, F.prototype._isPrintstr = function(pe) {
    return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(pe);
  }, node;
}
var hasRequiredBase$9;
function requireBase$9() {
  return hasRequiredBase$9 || (hasRequiredBase$9 = 1, function(n) {
    var c = n;
    c.Reporter = requireReporter().Reporter, c.DecoderBuffer = requireBuffer().DecoderBuffer, c.EncoderBuffer = requireBuffer().EncoderBuffer, c.Node = requireNode();
  }(base$c)), base$c;
}
var constants$7 = {}, der = {}, hasRequiredDer$2;
function requireDer$2() {
  return hasRequiredDer$2 || (hasRequiredDer$2 = 1, function(n) {
    var c = requireConstants$1();
    n.tagClass = {
      0: "universal",
      1: "application",
      2: "context",
      3: "private"
    }, n.tagClassByName = c._reverse(n.tagClass), n.tag = {
      0: "end",
      1: "bool",
      2: "int",
      3: "bitstr",
      4: "octstr",
      5: "null_",
      6: "objid",
      7: "objDesc",
      8: "external",
      9: "real",
      10: "enum",
      11: "embed",
      12: "utf8str",
      13: "relativeOid",
      16: "seq",
      17: "set",
      18: "numstr",
      19: "printstr",
      20: "t61str",
      21: "videostr",
      22: "ia5str",
      23: "utctime",
      24: "gentime",
      25: "graphstr",
      26: "iso646str",
      27: "genstr",
      28: "unistr",
      29: "charstr",
      30: "bmpstr"
    }, n.tagByName = c._reverse(n.tag);
  }(der)), der;
}
var hasRequiredConstants$1;
function requireConstants$1() {
  return hasRequiredConstants$1 || (hasRequiredConstants$1 = 1, function(n) {
    var c = n;
    c._reverse = function(p) {
      var a = {};
      return Object.keys(p).forEach(function(A) {
        (A | 0) == A && (A = A | 0);
        var b = p[A];
        a[b] = A;
      }), a;
    }, c.der = requireDer$2();
  }(constants$7)), constants$7;
}
var decoders = {}, der_1$1, hasRequiredDer$1;
function requireDer$1() {
  if (hasRequiredDer$1) return der_1$1;
  hasRequiredDer$1 = 1;
  var n = inherits_browserExports, c = requireAsn1$1(), u = c.base, p = c.bignum, a = c.constants.der;
  function A(L) {
    this.enc = "der", this.name = L.name, this.entity = L, this.tree = new b(), this.tree._init(L.body);
  }
  der_1$1 = A, A.prototype.decode = function(pe, $) {
    return pe instanceof u.DecoderBuffer || (pe = new u.DecoderBuffer(pe, $)), this.tree._decode(pe, $);
  };
  function b(L) {
    u.Node.call(this, "der", L);
  }
  n(b, u.Node), b.prototype._peekTag = function(pe, $, Ee) {
    if (pe.isEmpty())
      return !1;
    var be = pe.save(), He = F(pe, 'Failed to peek tag: "' + $ + '"');
    return pe.isError(He) ? He : (pe.restore(be), He.tag === $ || He.tagStr === $ || He.tagStr + "of" === $ || Ee);
  }, b.prototype._decodeTag = function(pe, $, Ee) {
    var be = F(
      pe,
      'Failed to decode tag of "' + $ + '"'
    );
    if (pe.isError(be))
      return be;
    var He = le(
      pe,
      be.primitive,
      'Failed to get length of "' + $ + '"'
    );
    if (pe.isError(He))
      return He;
    if (!Ee && be.tag !== $ && be.tagStr !== $ && be.tagStr + "of" !== $)
      return pe.error('Failed to match tag: "' + $ + '"');
    if (be.primitive || He !== null)
      return pe.skip(He, 'Failed to match body of: "' + $ + '"');
    var Pe = pe.save(), nr = this._skipUntilEnd(
      pe,
      'Failed to skip indefinite length body: "' + this.tag + '"'
    );
    return pe.isError(nr) ? nr : (He = pe.offset - Pe.offset, pe.restore(Pe), pe.skip(He, 'Failed to match body of: "' + $ + '"'));
  }, b.prototype._skipUntilEnd = function(pe, $) {
    for (; ; ) {
      var Ee = F(pe, $);
      if (pe.isError(Ee))
        return Ee;
      var be = le(pe, Ee.primitive, $);
      if (pe.isError(be))
        return be;
      var He;
      if (Ee.primitive || be !== null ? He = pe.skip(be) : He = this._skipUntilEnd(pe, $), pe.isError(He))
        return He;
      if (Ee.tagStr === "end")
        break;
    }
  }, b.prototype._decodeList = function(pe, $, Ee, be) {
    for (var He = []; !pe.isEmpty(); ) {
      var Pe = this._peekTag(pe, "end");
      if (pe.isError(Pe))
        return Pe;
      var nr = Ee.decode(pe, "der", be);
      if (pe.isError(nr) && Pe)
        break;
      He.push(nr);
    }
    return He;
  }, b.prototype._decodeStr = function(pe, $) {
    if ($ === "bitstr") {
      var Ee = pe.readUInt8();
      return pe.isError(Ee) ? Ee : { unused: Ee, data: pe.raw() };
    } else if ($ === "bmpstr") {
      var be = pe.raw();
      if (be.length % 2 === 1)
        return pe.error("Decoding of string type: bmpstr length mismatch");
      for (var He = "", Pe = 0; Pe < be.length / 2; Pe++)
        He += String.fromCharCode(be.readUInt16BE(Pe * 2));
      return He;
    } else if ($ === "numstr") {
      var nr = pe.raw().toString("ascii");
      return this._isNumstr(nr) ? nr : pe.error("Decoding of string type: numstr unsupported characters");
    } else {
      if ($ === "octstr")
        return pe.raw();
      if ($ === "objDesc")
        return pe.raw();
      if ($ === "printstr") {
        var ir = pe.raw().toString("ascii");
        return this._isPrintstr(ir) ? ir : pe.error("Decoding of string type: printstr unsupported characters");
      } else return /str$/.test($) ? pe.raw().toString() : pe.error("Decoding of string type: " + $ + " unsupported");
    }
  }, b.prototype._decodeObjid = function(pe, $, Ee) {
    for (var be, He = [], Pe = 0; !pe.isEmpty(); ) {
      var nr = pe.readUInt8();
      Pe <<= 7, Pe |= nr & 127, nr & 128 || (He.push(Pe), Pe = 0);
    }
    nr & 128 && He.push(Pe);
    var ir = He[0] / 40 | 0, or = He[0] % 40;
    if (Ee ? be = He : be = [ir, or].concat(He.slice(1)), $) {
      var lr = $[be.join(" ")];
      lr === void 0 && (lr = $[be.join(".")]), lr !== void 0 && (be = lr);
    }
    return be;
  }, b.prototype._decodeTime = function(pe, $) {
    var Ee = pe.raw().toString();
    if ($ === "gentime")
      var be = Ee.slice(0, 4) | 0, He = Ee.slice(4, 6) | 0, Pe = Ee.slice(6, 8) | 0, nr = Ee.slice(8, 10) | 0, ir = Ee.slice(10, 12) | 0, or = Ee.slice(12, 14) | 0;
    else if ($ === "utctime") {
      var be = Ee.slice(0, 2) | 0, He = Ee.slice(2, 4) | 0, Pe = Ee.slice(4, 6) | 0, nr = Ee.slice(6, 8) | 0, ir = Ee.slice(8, 10) | 0, or = Ee.slice(10, 12) | 0;
      be < 70 ? be = 2e3 + be : be = 1900 + be;
    } else
      return pe.error("Decoding " + $ + " time is not supported yet");
    return Date.UTC(be, He - 1, Pe, nr, ir, or, 0);
  }, b.prototype._decodeNull = function(pe) {
    return null;
  }, b.prototype._decodeBool = function(pe) {
    var $ = pe.readUInt8();
    return pe.isError($) ? $ : $ !== 0;
  }, b.prototype._decodeInt = function(pe, $) {
    var Ee = pe.raw(), be = new p(Ee);
    return $ && (be = $[be.toString(10)] || be), be;
  }, b.prototype._use = function(pe, $) {
    return typeof pe == "function" && (pe = pe($)), pe._getDecoder("der").tree;
  };
  function F(L, pe) {
    var $ = L.readUInt8(pe);
    if (L.isError($))
      return $;
    var Ee = a.tagClass[$ >> 6], be = ($ & 32) === 0;
    if (($ & 31) === 31) {
      var He = $;
      for ($ = 0; (He & 128) === 128; ) {
        if (He = L.readUInt8(pe), L.isError(He))
          return He;
        $ <<= 7, $ |= He & 127;
      }
    } else
      $ &= 31;
    var Pe = a.tag[$];
    return {
      cls: Ee,
      primitive: be,
      tag: $,
      tagStr: Pe
    };
  }
  function le(L, pe, $) {
    var Ee = L.readUInt8($);
    if (L.isError(Ee))
      return Ee;
    if (!pe && Ee === 128)
      return null;
    if (!(Ee & 128))
      return Ee;
    var be = Ee & 127;
    if (be > 4)
      return L.error("length octect is too long");
    Ee = 0;
    for (var He = 0; He < be; He++) {
      Ee <<= 8;
      var Pe = L.readUInt8($);
      if (L.isError(Pe))
        return Pe;
      Ee |= Pe;
    }
    return Ee;
  }
  return der_1$1;
}
var pem$1, hasRequiredPem$1;
function requirePem$1() {
  if (hasRequiredPem$1) return pem$1;
  hasRequiredPem$1 = 1;
  var n = inherits_browserExports, c = require$$0$5.Buffer, u = requireDer$1();
  function p(a) {
    u.call(this, a), this.enc = "pem";
  }
  return n(p, u), pem$1 = p, p.prototype.decode = function(A, b) {
    for (var F = A.toString().split(/[\r\n]+/g), le = b.label.toUpperCase(), L = /^-----(BEGIN|END) ([^-]+)-----$/, pe = -1, $ = -1, Ee = 0; Ee < F.length; Ee++) {
      var be = F[Ee].match(L);
      if (be !== null && be[2] === le)
        if (pe === -1) {
          if (be[1] !== "BEGIN")
            break;
          pe = Ee;
        } else {
          if (be[1] !== "END")
            break;
          $ = Ee;
          break;
        }
    }
    if (pe === -1 || $ === -1)
      throw new Error("PEM section not found for: " + le);
    var He = F.slice(pe + 1, $).join("");
    He.replace(/[^a-z0-9\+\/=]+/gi, "");
    var Pe = new c(He, "base64");
    return u.prototype.decode.call(this, Pe, b);
  }, pem$1;
}
var hasRequiredDecoders;
function requireDecoders() {
  return hasRequiredDecoders || (hasRequiredDecoders = 1, function(n) {
    var c = n;
    c.der = requireDer$1(), c.pem = requirePem$1();
  }(decoders)), decoders;
}
var encoders = {}, der_1, hasRequiredDer;
function requireDer() {
  if (hasRequiredDer) return der_1;
  hasRequiredDer = 1;
  var n = inherits_browserExports, c = require$$0$5.Buffer, u = requireAsn1$1(), p = u.base, a = u.constants.der;
  function A(L) {
    this.enc = "der", this.name = L.name, this.entity = L, this.tree = new b(), this.tree._init(L.body);
  }
  der_1 = A, A.prototype.encode = function(pe, $) {
    return this.tree._encode(pe, $).join();
  };
  function b(L) {
    p.Node.call(this, "der", L);
  }
  n(b, p.Node), b.prototype._encodeComposite = function(pe, $, Ee, be) {
    var He = le(pe, $, Ee, this.reporter);
    if (be.length < 128) {
      var ir = new c(2);
      return ir[0] = He, ir[1] = be.length, this._createEncoderBuffer([ir, be]);
    }
    for (var Pe = 1, nr = be.length; nr >= 256; nr >>= 8)
      Pe++;
    var ir = new c(2 + Pe);
    ir[0] = He, ir[1] = 128 | Pe;
    for (var nr = 1 + Pe, or = be.length; or > 0; nr--, or >>= 8)
      ir[nr] = or & 255;
    return this._createEncoderBuffer([ir, be]);
  }, b.prototype._encodeStr = function(pe, $) {
    if ($ === "bitstr")
      return this._createEncoderBuffer([pe.unused | 0, pe.data]);
    if ($ === "bmpstr") {
      for (var Ee = new c(pe.length * 2), be = 0; be < pe.length; be++)
        Ee.writeUInt16BE(pe.charCodeAt(be), be * 2);
      return this._createEncoderBuffer(Ee);
    } else return $ === "numstr" ? this._isNumstr(pe) ? this._createEncoderBuffer(pe) : this.reporter.error("Encoding of string type: numstr supports only digits and space") : $ === "printstr" ? this._isPrintstr(pe) ? this._createEncoderBuffer(pe) : this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark") : /str$/.test($) ? this._createEncoderBuffer(pe) : $ === "objDesc" ? this._createEncoderBuffer(pe) : this.reporter.error("Encoding of string type: " + $ + " unsupported");
  }, b.prototype._encodeObjid = function(pe, $, Ee) {
    if (typeof pe == "string") {
      if (!$)
        return this.reporter.error("string objid given, but no values map found");
      if (!$.hasOwnProperty(pe))
        return this.reporter.error("objid not found in values map");
      pe = $[pe].split(/[\s\.]+/g);
      for (var be = 0; be < pe.length; be++)
        pe[be] |= 0;
    } else if (Array.isArray(pe)) {
      pe = pe.slice();
      for (var be = 0; be < pe.length; be++)
        pe[be] |= 0;
    }
    if (!Array.isArray(pe))
      return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(pe));
    if (!Ee) {
      if (pe[1] >= 40)
        return this.reporter.error("Second objid identifier OOB");
      pe.splice(0, 2, pe[0] * 40 + pe[1]);
    }
    for (var He = 0, be = 0; be < pe.length; be++) {
      var Pe = pe[be];
      for (He++; Pe >= 128; Pe >>= 7)
        He++;
    }
    for (var nr = new c(He), ir = nr.length - 1, be = pe.length - 1; be >= 0; be--) {
      var Pe = pe[be];
      for (nr[ir--] = Pe & 127; (Pe >>= 7) > 0; )
        nr[ir--] = 128 | Pe & 127;
    }
    return this._createEncoderBuffer(nr);
  };
  function F(L) {
    return L < 10 ? "0" + L : L;
  }
  b.prototype._encodeTime = function(pe, $) {
    var Ee, be = new Date(pe);
    return $ === "gentime" ? Ee = [
      F(be.getFullYear()),
      F(be.getUTCMonth() + 1),
      F(be.getUTCDate()),
      F(be.getUTCHours()),
      F(be.getUTCMinutes()),
      F(be.getUTCSeconds()),
      "Z"
    ].join("") : $ === "utctime" ? Ee = [
      F(be.getFullYear() % 100),
      F(be.getUTCMonth() + 1),
      F(be.getUTCDate()),
      F(be.getUTCHours()),
      F(be.getUTCMinutes()),
      F(be.getUTCSeconds()),
      "Z"
    ].join("") : this.reporter.error("Encoding " + $ + " time is not supported yet"), this._encodeStr(Ee, "octstr");
  }, b.prototype._encodeNull = function() {
    return this._createEncoderBuffer("");
  }, b.prototype._encodeInt = function(pe, $) {
    if (typeof pe == "string") {
      if (!$)
        return this.reporter.error("String int or enum given, but no values map");
      if (!$.hasOwnProperty(pe))
        return this.reporter.error("Values map doesn't contain: " + JSON.stringify(pe));
      pe = $[pe];
    }
    if (typeof pe != "number" && !c.isBuffer(pe)) {
      var Ee = pe.toArray();
      !pe.sign && Ee[0] & 128 && Ee.unshift(0), pe = new c(Ee);
    }
    if (c.isBuffer(pe)) {
      var be = pe.length;
      pe.length === 0 && be++;
      var Pe = new c(be);
      return pe.copy(Pe), pe.length === 0 && (Pe[0] = 0), this._createEncoderBuffer(Pe);
    }
    if (pe < 128)
      return this._createEncoderBuffer(pe);
    if (pe < 256)
      return this._createEncoderBuffer([0, pe]);
    for (var be = 1, He = pe; He >= 256; He >>= 8)
      be++;
    for (var Pe = new Array(be), He = Pe.length - 1; He >= 0; He--)
      Pe[He] = pe & 255, pe >>= 8;
    return Pe[0] & 128 && Pe.unshift(0), this._createEncoderBuffer(new c(Pe));
  }, b.prototype._encodeBool = function(pe) {
    return this._createEncoderBuffer(pe ? 255 : 0);
  }, b.prototype._use = function(pe, $) {
    return typeof pe == "function" && (pe = pe($)), pe._getEncoder("der").tree;
  }, b.prototype._skipDefault = function(pe, $, Ee) {
    var be = this._baseState, He;
    if (be.default === null)
      return !1;
    var Pe = pe.join();
    if (be.defaultBuffer === void 0 && (be.defaultBuffer = this._encodeValue(be.default, $, Ee).join()), Pe.length !== be.defaultBuffer.length)
      return !1;
    for (He = 0; He < Pe.length; He++)
      if (Pe[He] !== be.defaultBuffer[He])
        return !1;
    return !0;
  };
  function le(L, pe, $, Ee) {
    var be;
    if (L === "seqof" ? L = "seq" : L === "setof" && (L = "set"), a.tagByName.hasOwnProperty(L))
      be = a.tagByName[L];
    else if (typeof L == "number" && (L | 0) === L)
      be = L;
    else
      return Ee.error("Unknown tag: " + L);
    return be >= 31 ? Ee.error("Multi-octet tag encoding unsupported") : (pe || (be |= 32), be |= a.tagClassByName[$ || "universal"] << 6, be);
  }
  return der_1;
}
var pem, hasRequiredPem;
function requirePem() {
  if (hasRequiredPem) return pem;
  hasRequiredPem = 1;
  var n = inherits_browserExports, c = requireDer();
  function u(p) {
    c.call(this, p), this.enc = "pem";
  }
  return n(u, c), pem = u, u.prototype.encode = function(a, A) {
    for (var b = c.prototype.encode.call(this, a), F = b.toString("base64"), le = ["-----BEGIN " + A.label + "-----"], L = 0; L < F.length; L += 64)
      le.push(F.slice(L, L + 64));
    return le.push("-----END " + A.label + "-----"), le.join(`
`);
  }, pem;
}
var hasRequiredEncoders;
function requireEncoders() {
  return hasRequiredEncoders || (hasRequiredEncoders = 1, function(n) {
    var c = n;
    c.der = requireDer(), c.pem = requirePem();
  }(encoders)), encoders;
}
var hasRequiredAsn1$1;
function requireAsn1$1() {
  return hasRequiredAsn1$1 || (hasRequiredAsn1$1 = 1, function(n) {
    var c = n;
    c.bignum = requireBn$2(), c.define = requireApi().define, c.base = requireBase$9(), c.constants = requireConstants$1(), c.decoders = requireDecoders(), c.encoders = requireEncoders();
  }(asn1)), asn1;
}
var certificate, hasRequiredCertificate;
function requireCertificate() {
  if (hasRequiredCertificate) return certificate;
  hasRequiredCertificate = 1;
  var n = requireAsn1$1(), c = n.define("Time", function() {
    this.choice({
      utcTime: this.utctime(),
      generalTime: this.gentime()
    });
  }), u = n.define("AttributeTypeValue", function() {
    this.seq().obj(
      this.key("type").objid(),
      this.key("value").any()
    );
  }), p = n.define("AlgorithmIdentifier", function() {
    this.seq().obj(
      this.key("algorithm").objid(),
      this.key("parameters").optional(),
      this.key("curve").objid().optional()
    );
  }), a = n.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").use(p),
      this.key("subjectPublicKey").bitstr()
    );
  }), A = n.define("RelativeDistinguishedName", function() {
    this.setof(u);
  }), b = n.define("RDNSequence", function() {
    this.seqof(A);
  }), F = n.define("Name", function() {
    this.choice({
      rdnSequence: this.use(b)
    });
  }), le = n.define("Validity", function() {
    this.seq().obj(
      this.key("notBefore").use(c),
      this.key("notAfter").use(c)
    );
  }), L = n.define("Extension", function() {
    this.seq().obj(
      this.key("extnID").objid(),
      this.key("critical").bool().def(!1),
      this.key("extnValue").octstr()
    );
  }), pe = n.define("TBSCertificate", function() {
    this.seq().obj(
      this.key("version").explicit(0).int().optional(),
      this.key("serialNumber").int(),
      this.key("signature").use(p),
      this.key("issuer").use(F),
      this.key("validity").use(le),
      this.key("subject").use(F),
      this.key("subjectPublicKeyInfo").use(a),
      this.key("issuerUniqueID").implicit(1).bitstr().optional(),
      this.key("subjectUniqueID").implicit(2).bitstr().optional(),
      this.key("extensions").explicit(3).seqof(L).optional()
    );
  }), $ = n.define("X509Certificate", function() {
    this.seq().obj(
      this.key("tbsCertificate").use(pe),
      this.key("signatureAlgorithm").use(p),
      this.key("signatureValue").bitstr()
    );
  });
  return certificate = $, certificate;
}
var hasRequiredAsn1;
function requireAsn1() {
  if (hasRequiredAsn1) return asn1$1;
  hasRequiredAsn1 = 1;
  var n = requireAsn1$1();
  asn1$1.certificate = requireCertificate();
  var c = n.define("RSAPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("modulus").int(),
      this.key("publicExponent").int(),
      this.key("privateExponent").int(),
      this.key("prime1").int(),
      this.key("prime2").int(),
      this.key("exponent1").int(),
      this.key("exponent2").int(),
      this.key("coefficient").int()
    );
  });
  asn1$1.RSAPrivateKey = c;
  var u = n.define("RSAPublicKey", function() {
    this.seq().obj(
      this.key("modulus").int(),
      this.key("publicExponent").int()
    );
  });
  asn1$1.RSAPublicKey = u;
  var p = n.define("AlgorithmIdentifier", function() {
    this.seq().obj(
      this.key("algorithm").objid(),
      this.key("none").null_().optional(),
      this.key("curve").objid().optional(),
      this.key("params").seq().obj(
        this.key("p").int(),
        this.key("q").int(),
        this.key("g").int()
      ).optional()
    );
  }), a = n.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").use(p),
      this.key("subjectPublicKey").bitstr()
    );
  });
  asn1$1.PublicKey = a;
  var A = n.define("PrivateKeyInfo", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("algorithm").use(p),
      this.key("subjectPrivateKey").octstr()
    );
  });
  asn1$1.PrivateKey = A;
  var b = n.define("EncryptedPrivateKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").seq().obj(
        this.key("id").objid(),
        this.key("decrypt").seq().obj(
          this.key("kde").seq().obj(
            this.key("id").objid(),
            this.key("kdeparams").seq().obj(
              this.key("salt").octstr(),
              this.key("iters").int()
            )
          ),
          this.key("cipher").seq().obj(
            this.key("algo").objid(),
            this.key("iv").octstr()
          )
        )
      ),
      this.key("subjectPrivateKey").octstr()
    );
  });
  asn1$1.EncryptedPrivateKey = b;
  var F = n.define("DSAPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("p").int(),
      this.key("q").int(),
      this.key("g").int(),
      this.key("pub_key").int(),
      this.key("priv_key").int()
    );
  });
  asn1$1.DSAPrivateKey = F, asn1$1.DSAparam = n.define("DSAparam", function() {
    this.int();
  });
  var le = n.define("ECParameters", function() {
    this.choice({
      namedCurve: this.objid()
    });
  }), L = n.define("ECPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("privateKey").octstr(),
      this.key("parameters").optional().explicit(0).use(le),
      this.key("publicKey").optional().explicit(1).bitstr()
    );
  });
  return asn1$1.ECPrivateKey = L, asn1$1.signature = n.define("signature", function() {
    this.seq().obj(
      this.key("r").int(),
      this.key("s").int()
    );
  }), asn1$1;
}
const require$$1$6 = {
  "2.16.840.1.101.3.4.1.1": "aes-128-ecb",
  "2.16.840.1.101.3.4.1.2": "aes-128-cbc",
  "2.16.840.1.101.3.4.1.3": "aes-128-ofb",
  "2.16.840.1.101.3.4.1.4": "aes-128-cfb",
  "2.16.840.1.101.3.4.1.21": "aes-192-ecb",
  "2.16.840.1.101.3.4.1.22": "aes-192-cbc",
  "2.16.840.1.101.3.4.1.23": "aes-192-ofb",
  "2.16.840.1.101.3.4.1.24": "aes-192-cfb",
  "2.16.840.1.101.3.4.1.41": "aes-256-ecb",
  "2.16.840.1.101.3.4.1.42": "aes-256-cbc",
  "2.16.840.1.101.3.4.1.43": "aes-256-ofb",
  "2.16.840.1.101.3.4.1.44": "aes-256-cfb"
};
var fixProc, hasRequiredFixProc;
function requireFixProc() {
  if (hasRequiredFixProc) return fixProc;
  hasRequiredFixProc = 1;
  var n = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m, c = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m, u = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m, p = requireEvp_bytestokey(), a = requireBrowser$6(), A = safeBufferExports.Buffer;
  return fixProc = function(b, F) {
    var le = b.toString(), L = le.match(n), pe;
    if (L) {
      var Ee = "aes" + L[1], be = A.from(L[2], "hex"), He = A.from(L[3].replace(/[\r\n]/g, ""), "base64"), Pe = p(F, be.slice(0, 8), parseInt(L[1], 10)).key, nr = [], ir = a.createDecipheriv(Ee, Pe, be);
      nr.push(ir.update(He)), nr.push(ir.final()), pe = A.concat(nr);
    } else {
      var $ = le.match(u);
      pe = A.from($[2].replace(/[\r\n]/g, ""), "base64");
    }
    var or = le.match(c)[1];
    return {
      tag: or,
      data: pe
    };
  }, fixProc;
}
var parseAsn1, hasRequiredParseAsn1;
function requireParseAsn1() {
  if (hasRequiredParseAsn1) return parseAsn1;
  hasRequiredParseAsn1 = 1;
  var n = requireAsn1(), c = require$$1$6, u = requireFixProc(), p = requireBrowser$6(), a = requireBrowser$7(), A = safeBufferExports.Buffer;
  function b(le, L) {
    var pe = le.algorithm.decrypt.kde.kdeparams.salt, $ = parseInt(le.algorithm.decrypt.kde.kdeparams.iters.toString(), 10), Ee = c[le.algorithm.decrypt.cipher.algo.join(".")], be = le.algorithm.decrypt.cipher.iv, He = le.subjectPrivateKey, Pe = parseInt(Ee.split("-")[1], 10) / 8, nr = a.pbkdf2Sync(L, pe, $, Pe, "sha1"), ir = p.createDecipheriv(Ee, nr, be), or = [];
    return or.push(ir.update(He)), or.push(ir.final()), A.concat(or);
  }
  function F(le) {
    var L;
    typeof le == "object" && !A.isBuffer(le) && (L = le.passphrase, le = le.key), typeof le == "string" && (le = A.from(le));
    var pe = u(le, L), $ = pe.tag, Ee = pe.data, be, He;
    switch ($) {
      case "CERTIFICATE":
        He = n.certificate.decode(Ee, "der").tbsCertificate.subjectPublicKeyInfo;
      case "PUBLIC KEY":
        switch (He || (He = n.PublicKey.decode(Ee, "der")), be = He.algorithm.algorithm.join("."), be) {
          case "1.2.840.113549.1.1.1":
            return n.RSAPublicKey.decode(He.subjectPublicKey.data, "der");
          case "1.2.840.10045.2.1":
            return He.subjectPrivateKey = He.subjectPublicKey, {
              type: "ec",
              data: He
            };
          case "1.2.840.10040.4.1":
            return He.algorithm.params.pub_key = n.DSAparam.decode(He.subjectPublicKey.data, "der"), {
              type: "dsa",
              data: He.algorithm.params
            };
          default:
            throw new Error("unknown key id " + be);
        }
      case "ENCRYPTED PRIVATE KEY":
        Ee = n.EncryptedPrivateKey.decode(Ee, "der"), Ee = b(Ee, L);
      case "PRIVATE KEY":
        switch (He = n.PrivateKey.decode(Ee, "der"), be = He.algorithm.algorithm.join("."), be) {
          case "1.2.840.113549.1.1.1":
            return n.RSAPrivateKey.decode(He.subjectPrivateKey, "der");
          case "1.2.840.10045.2.1":
            return {
              curve: He.algorithm.curve,
              privateKey: n.ECPrivateKey.decode(He.subjectPrivateKey, "der").privateKey
            };
          case "1.2.840.10040.4.1":
            return He.algorithm.params.priv_key = n.DSAparam.decode(He.subjectPrivateKey, "der"), {
              type: "dsa",
              params: He.algorithm.params
            };
          default:
            throw new Error("unknown key id " + be);
        }
      case "RSA PUBLIC KEY":
        return n.RSAPublicKey.decode(Ee, "der");
      case "RSA PRIVATE KEY":
        return n.RSAPrivateKey.decode(Ee, "der");
      case "DSA PRIVATE KEY":
        return {
          type: "dsa",
          params: n.DSAPrivateKey.decode(Ee, "der")
        };
      case "EC PRIVATE KEY":
        return Ee = n.ECPrivateKey.decode(Ee, "der"), {
          curve: Ee.parameters.value,
          privateKey: Ee.privateKey
        };
      default:
        throw new Error("unknown key type " + $);
    }
  }
  return F.signature = n.signature, parseAsn1 = F, parseAsn1;
}
const require$$4$1 = {
  "1.3.132.0.10": "secp256k1",
  "1.3.132.0.33": "p224",
  "1.2.840.10045.3.1.1": "p192",
  "1.2.840.10045.3.1.7": "p256",
  "1.3.132.0.34": "p384",
  "1.3.132.0.35": "p521"
};
var hasRequiredSign;
function requireSign() {
  if (hasRequiredSign) return sign$3.exports;
  hasRequiredSign = 1;
  var n = safeBufferExports.Buffer, c = requireBrowser$8(), u = requireBrowserifyRsa(), p = requireElliptic$2().ec, a = bnExports$1, A = requireParseAsn1(), b = require$$4$1, F = 1;
  function le(ir, or, lr, Ir, xr) {
    var kr = A(or);
    if (kr.curve) {
      if (Ir !== "ecdsa" && Ir !== "ecdsa/rsa")
        throw new Error("wrong private key type");
      return L(ir, kr);
    } else if (kr.type === "dsa") {
      if (Ir !== "dsa")
        throw new Error("wrong private key type");
      return pe(ir, kr, lr);
    }
    if (Ir !== "rsa" && Ir !== "ecdsa/rsa")
      throw new Error("wrong private key type");
    if (or.padding !== void 0 && or.padding !== F)
      throw new Error("illegal or unsupported padding mode");
    ir = n.concat([xr, ir]);
    for (var Ce = kr.modulus.byteLength(), tr = [0, 1]; ir.length + tr.length + 1 < Ce; )
      tr.push(255);
    tr.push(0);
    for (var Fe = -1; ++Fe < ir.length; )
      tr.push(ir[Fe]);
    var Sr = u(tr, kr);
    return Sr;
  }
  function L(ir, or) {
    var lr = b[or.curve.join(".")];
    if (!lr)
      throw new Error("unknown curve " + or.curve.join("."));
    var Ir = new p(lr), xr = Ir.keyFromPrivate(or.privateKey), kr = xr.sign(ir);
    return n.from(kr.toDER());
  }
  function pe(ir, or, lr) {
    for (var Ir = or.params.priv_key, xr = or.params.p, kr = or.params.q, Ce = or.params.g, tr = new a(0), Fe, Sr = be(ir, kr).mod(kr), er = !1, Ie = Ee(Ir, kr, ir, lr); er === !1; )
      Fe = Pe(kr, Ie, lr), tr = nr(Ce, Fe, xr, kr), er = Fe.invm(kr).imul(Sr.add(Ir.mul(tr))).mod(kr), er.cmpn(0) === 0 && (er = !1, tr = new a(0));
    return $(tr, er);
  }
  function $(ir, or) {
    ir = ir.toArray(), or = or.toArray(), ir[0] & 128 && (ir = [0].concat(ir)), or[0] & 128 && (or = [0].concat(or));
    var lr = ir.length + or.length + 4, Ir = [
      48,
      lr,
      2,
      ir.length
    ];
    return Ir = Ir.concat(ir, [2, or.length], or), n.from(Ir);
  }
  function Ee(ir, or, lr, Ir) {
    if (ir = n.from(ir.toArray()), ir.length < or.byteLength()) {
      var xr = n.alloc(or.byteLength() - ir.length);
      ir = n.concat([xr, ir]);
    }
    var kr = lr.length, Ce = He(lr, or), tr = n.alloc(kr);
    tr.fill(1);
    var Fe = n.alloc(kr);
    return Fe = c(Ir, Fe).update(tr).update(n.from([0])).update(ir).update(Ce).digest(), tr = c(Ir, Fe).update(tr).digest(), Fe = c(Ir, Fe).update(tr).update(n.from([1])).update(ir).update(Ce).digest(), tr = c(Ir, Fe).update(tr).digest(), { k: Fe, v: tr };
  }
  function be(ir, or) {
    var lr = new a(ir), Ir = (ir.length << 3) - or.bitLength();
    return Ir > 0 && lr.ishrn(Ir), lr;
  }
  function He(ir, or) {
    ir = be(ir, or), ir = ir.mod(or);
    var lr = n.from(ir.toArray());
    if (lr.length < or.byteLength()) {
      var Ir = n.alloc(or.byteLength() - lr.length);
      lr = n.concat([Ir, lr]);
    }
    return lr;
  }
  function Pe(ir, or, lr) {
    var Ir, xr;
    do {
      for (Ir = n.alloc(0); Ir.length * 8 < ir.bitLength(); )
        or.v = c(lr, or.k).update(or.v).digest(), Ir = n.concat([Ir, or.v]);
      xr = be(Ir, ir), or.k = c(lr, or.k).update(or.v).update(n.from([0])).digest(), or.v = c(lr, or.k).update(or.v).digest();
    } while (xr.cmp(ir) !== -1);
    return xr;
  }
  function nr(ir, or, lr, Ir) {
    return ir.toRed(a.mont(lr)).redPow(or).fromRed().mod(Ir);
  }
  return sign$3.exports = le, sign$3.exports.getKey = Ee, sign$3.exports.makeKey = Pe, sign$3.exports;
}
var verify_1, hasRequiredVerify;
function requireVerify() {
  if (hasRequiredVerify) return verify_1;
  hasRequiredVerify = 1;
  var n = safeBufferExports.Buffer, c = bnExports$1, u = requireElliptic$2().ec, p = requireParseAsn1(), a = require$$4$1;
  function A(L, pe, $, Ee, be) {
    var He = p($);
    if (He.type === "ec") {
      if (Ee !== "ecdsa" && Ee !== "ecdsa/rsa")
        throw new Error("wrong public key type");
      return b(L, pe, He);
    } else if (He.type === "dsa") {
      if (Ee !== "dsa")
        throw new Error("wrong public key type");
      return F(L, pe, He);
    }
    if (Ee !== "rsa" && Ee !== "ecdsa/rsa")
      throw new Error("wrong public key type");
    pe = n.concat([be, pe]);
    for (var Pe = He.modulus.byteLength(), nr = [1], ir = 0; pe.length + nr.length + 2 < Pe; )
      nr.push(255), ir += 1;
    nr.push(0);
    for (var or = -1; ++or < pe.length; )
      nr.push(pe[or]);
    nr = n.from(nr);
    var lr = c.mont(He.modulus);
    L = new c(L).toRed(lr), L = L.redPow(new c(He.publicExponent)), L = n.from(L.fromRed().toArray());
    var Ir = ir < 8 ? 1 : 0;
    for (Pe = Math.min(L.length, nr.length), L.length !== nr.length && (Ir = 1), or = -1; ++or < Pe; )
      Ir |= L[or] ^ nr[or];
    return Ir === 0;
  }
  function b(L, pe, $) {
    var Ee = a[$.data.algorithm.curve.join(".")];
    if (!Ee)
      throw new Error("unknown curve " + $.data.algorithm.curve.join("."));
    var be = new u(Ee), He = $.data.subjectPrivateKey.data;
    return be.verify(pe, L, He);
  }
  function F(L, pe, $) {
    var Ee = $.data.p, be = $.data.q, He = $.data.g, Pe = $.data.pub_key, nr = p.signature.decode(L, "der"), ir = nr.s, or = nr.r;
    le(ir, be), le(or, be);
    var lr = c.mont(Ee), Ir = ir.invm(be), xr = He.toRed(lr).redPow(new c(pe).mul(Ir).mod(be)).fromRed().mul(Pe.toRed(lr).redPow(or.mul(Ir).mod(be)).fromRed()).mod(Ee).mod(be);
    return xr.cmp(or) === 0;
  }
  function le(L, pe) {
    if (L.cmpn(0) <= 0)
      throw new Error("invalid sig");
    if (L.cmp(pe) >= 0)
      throw new Error("invalid sig");
  }
  return verify_1 = A, verify_1;
}
var browser$3, hasRequiredBrowser$3;
function requireBrowser$3() {
  if (hasRequiredBrowser$3) return browser$3;
  hasRequiredBrowser$3 = 1;
  var n = safeBufferExports.Buffer, c = browser$a, u = requireReadableBrowser(), p = inherits_browserExports, a = requireSign(), A = requireVerify(), b = require$$6;
  Object.keys(b).forEach(function($) {
    b[$].id = n.from(b[$].id, "hex"), b[$.toLowerCase()] = b[$];
  });
  function F($) {
    u.Writable.call(this);
    var Ee = b[$];
    if (!Ee)
      throw new Error("Unknown message digest");
    this._hashType = Ee.hash, this._hash = c(Ee.hash), this._tag = Ee.id, this._signType = Ee.sign;
  }
  p(F, u.Writable), F.prototype._write = function(Ee, be, He) {
    this._hash.update(Ee), He();
  }, F.prototype.update = function(Ee, be) {
    return this._hash.update(typeof Ee == "string" ? n.from(Ee, be) : Ee), this;
  }, F.prototype.sign = function(Ee, be) {
    this.end();
    var He = this._hash.digest(), Pe = a(He, Ee, this._hashType, this._signType, this._tag);
    return be ? Pe.toString(be) : Pe;
  };
  function le($) {
    u.Writable.call(this);
    var Ee = b[$];
    if (!Ee)
      throw new Error("Unknown message digest");
    this._hash = c(Ee.hash), this._tag = Ee.id, this._signType = Ee.sign;
  }
  p(le, u.Writable), le.prototype._write = function(Ee, be, He) {
    this._hash.update(Ee), He();
  }, le.prototype.update = function(Ee, be) {
    return this._hash.update(typeof Ee == "string" ? n.from(Ee, be) : Ee), this;
  }, le.prototype.verify = function(Ee, be, He) {
    var Pe = typeof be == "string" ? n.from(be, He) : be;
    this.end();
    var nr = this._hash.digest();
    return A(Pe, nr, Ee, this._signType, this._tag);
  };
  function L($) {
    return new F($);
  }
  function pe($) {
    return new le($);
  }
  return browser$3 = {
    Sign: L,
    Verify: pe,
    createSign: L,
    createVerify: pe
  }, browser$3;
}
var bn$1 = { exports: {} };
bn$1.exports;
var hasRequiredBn$1;
function requireBn$1() {
  return hasRequiredBn$1 || (hasRequiredBn$1 = 1, function(n) {
    (function(c, u) {
      function p(er, Ie) {
        if (!er) throw new Error(Ie || "Assertion failed");
      }
      function a(er, Ie) {
        er.super_ = Ie;
        var xe = function() {
        };
        xe.prototype = Ie.prototype, er.prototype = new xe(), er.prototype.constructor = er;
      }
      function A(er, Ie, xe) {
        if (A.isBN(er))
          return er;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, er !== null && ((Ie === "le" || Ie === "be") && (xe = Ie, Ie = 10), this._init(er || 0, Ie || 10, xe || "be"));
      }
      typeof c == "object" ? c.exports = A : u.BN = A, A.BN = A, A.wordSize = 26;
      var b;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? b = window.Buffer : b = require$$0$5.Buffer;
      } catch {
      }
      A.isBN = function(Ie) {
        return Ie instanceof A ? !0 : Ie !== null && typeof Ie == "object" && Ie.constructor.wordSize === A.wordSize && Array.isArray(Ie.words);
      }, A.max = function(Ie, xe) {
        return Ie.cmp(xe) > 0 ? Ie : xe;
      }, A.min = function(Ie, xe) {
        return Ie.cmp(xe) < 0 ? Ie : xe;
      }, A.prototype._init = function(Ie, xe, rr) {
        if (typeof Ie == "number")
          return this._initNumber(Ie, xe, rr);
        if (typeof Ie == "object")
          return this._initArray(Ie, xe, rr);
        xe === "hex" && (xe = 16), p(xe === (xe | 0) && xe >= 2 && xe <= 36), Ie = Ie.toString().replace(/\s+/g, "");
        var ar = 0;
        Ie[0] === "-" && (ar++, this.negative = 1), ar < Ie.length && (xe === 16 ? this._parseHex(Ie, ar, rr) : (this._parseBase(Ie, xe, ar), rr === "le" && this._initArray(this.toArray(), xe, rr)));
      }, A.prototype._initNumber = function(Ie, xe, rr) {
        Ie < 0 && (this.negative = 1, Ie = -Ie), Ie < 67108864 ? (this.words = [Ie & 67108863], this.length = 1) : Ie < 4503599627370496 ? (this.words = [
          Ie & 67108863,
          Ie / 67108864 & 67108863
        ], this.length = 2) : (p(Ie < 9007199254740992), this.words = [
          Ie & 67108863,
          Ie / 67108864 & 67108863,
          1
        ], this.length = 3), rr === "le" && this._initArray(this.toArray(), xe, rr);
      }, A.prototype._initArray = function(Ie, xe, rr) {
        if (p(typeof Ie.length == "number"), Ie.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(Ie.length / 3), this.words = new Array(this.length);
        for (var ar = 0; ar < this.length; ar++)
          this.words[ar] = 0;
        var yr, _r, Or = 0;
        if (rr === "be")
          for (ar = Ie.length - 1, yr = 0; ar >= 0; ar -= 3)
            _r = Ie[ar] | Ie[ar - 1] << 8 | Ie[ar - 2] << 16, this.words[yr] |= _r << Or & 67108863, this.words[yr + 1] = _r >>> 26 - Or & 67108863, Or += 24, Or >= 26 && (Or -= 26, yr++);
        else if (rr === "le")
          for (ar = 0, yr = 0; ar < Ie.length; ar += 3)
            _r = Ie[ar] | Ie[ar + 1] << 8 | Ie[ar + 2] << 16, this.words[yr] |= _r << Or & 67108863, this.words[yr + 1] = _r >>> 26 - Or & 67108863, Or += 24, Or >= 26 && (Or -= 26, yr++);
        return this.strip();
      };
      function F(er, Ie) {
        var xe = er.charCodeAt(Ie);
        return xe >= 65 && xe <= 70 ? xe - 55 : xe >= 97 && xe <= 102 ? xe - 87 : xe - 48 & 15;
      }
      function le(er, Ie, xe) {
        var rr = F(er, xe);
        return xe - 1 >= Ie && (rr |= F(er, xe - 1) << 4), rr;
      }
      A.prototype._parseHex = function(Ie, xe, rr) {
        this.length = Math.ceil((Ie.length - xe) / 6), this.words = new Array(this.length);
        for (var ar = 0; ar < this.length; ar++)
          this.words[ar] = 0;
        var yr = 0, _r = 0, Or;
        if (rr === "be")
          for (ar = Ie.length - 1; ar >= xe; ar -= 2)
            Or = le(Ie, xe, ar) << yr, this.words[_r] |= Or & 67108863, yr >= 18 ? (yr -= 18, _r += 1, this.words[_r] |= Or >>> 26) : yr += 8;
        else {
          var vr = Ie.length - xe;
          for (ar = vr % 2 === 0 ? xe + 1 : xe; ar < Ie.length; ar += 2)
            Or = le(Ie, xe, ar) << yr, this.words[_r] |= Or & 67108863, yr >= 18 ? (yr -= 18, _r += 1, this.words[_r] |= Or >>> 26) : yr += 8;
        }
        this.strip();
      };
      function L(er, Ie, xe, rr) {
        for (var ar = 0, yr = Math.min(er.length, xe), _r = Ie; _r < yr; _r++) {
          var Or = er.charCodeAt(_r) - 48;
          ar *= rr, Or >= 49 ? ar += Or - 49 + 10 : Or >= 17 ? ar += Or - 17 + 10 : ar += Or;
        }
        return ar;
      }
      A.prototype._parseBase = function(Ie, xe, rr) {
        this.words = [0], this.length = 1;
        for (var ar = 0, yr = 1; yr <= 67108863; yr *= xe)
          ar++;
        ar--, yr = yr / xe | 0;
        for (var _r = Ie.length - rr, Or = _r % ar, vr = Math.min(_r, _r - Or) + rr, Te = 0, Cr = rr; Cr < vr; Cr += ar)
          Te = L(Ie, Cr, Cr + ar, xe), this.imuln(yr), this.words[0] + Te < 67108864 ? this.words[0] += Te : this._iaddn(Te);
        if (Or !== 0) {
          var Hr = 1;
          for (Te = L(Ie, Cr, Ie.length, xe), Cr = 0; Cr < Or; Cr++)
            Hr *= xe;
          this.imuln(Hr), this.words[0] + Te < 67108864 ? this.words[0] += Te : this._iaddn(Te);
        }
        this.strip();
      }, A.prototype.copy = function(Ie) {
        Ie.words = new Array(this.length);
        for (var xe = 0; xe < this.length; xe++)
          Ie.words[xe] = this.words[xe];
        Ie.length = this.length, Ie.negative = this.negative, Ie.red = this.red;
      }, A.prototype.clone = function() {
        var Ie = new A(null);
        return this.copy(Ie), Ie;
      }, A.prototype._expand = function(Ie) {
        for (; this.length < Ie; )
          this.words[this.length++] = 0;
        return this;
      }, A.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, A.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, A.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var pe = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], $ = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], Ee = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      A.prototype.toString = function(Ie, xe) {
        Ie = Ie || 10, xe = xe | 0 || 1;
        var rr;
        if (Ie === 16 || Ie === "hex") {
          rr = "";
          for (var ar = 0, yr = 0, _r = 0; _r < this.length; _r++) {
            var Or = this.words[_r], vr = ((Or << ar | yr) & 16777215).toString(16);
            yr = Or >>> 24 - ar & 16777215, ar += 2, ar >= 26 && (ar -= 26, _r--), yr !== 0 || _r !== this.length - 1 ? rr = pe[6 - vr.length] + vr + rr : rr = vr + rr;
          }
          for (yr !== 0 && (rr = yr.toString(16) + rr); rr.length % xe !== 0; )
            rr = "0" + rr;
          return this.negative !== 0 && (rr = "-" + rr), rr;
        }
        if (Ie === (Ie | 0) && Ie >= 2 && Ie <= 36) {
          var Te = $[Ie], Cr = Ee[Ie];
          rr = "";
          var Hr = this.clone();
          for (Hr.negative = 0; !Hr.isZero(); ) {
            var si = Hr.modn(Cr).toString(Ie);
            Hr = Hr.idivn(Cr), Hr.isZero() ? rr = si + rr : rr = pe[Te - si.length] + si + rr;
          }
          for (this.isZero() && (rr = "0" + rr); rr.length % xe !== 0; )
            rr = "0" + rr;
          return this.negative !== 0 && (rr = "-" + rr), rr;
        }
        p(!1, "Base should be between 2 and 36");
      }, A.prototype.toNumber = function() {
        var Ie = this.words[0];
        return this.length === 2 ? Ie += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? Ie += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && p(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -Ie : Ie;
      }, A.prototype.toJSON = function() {
        return this.toString(16);
      }, A.prototype.toBuffer = function(Ie, xe) {
        return p(typeof b < "u"), this.toArrayLike(b, Ie, xe);
      }, A.prototype.toArray = function(Ie, xe) {
        return this.toArrayLike(Array, Ie, xe);
      }, A.prototype.toArrayLike = function(Ie, xe, rr) {
        var ar = this.byteLength(), yr = rr || Math.max(1, ar);
        p(ar <= yr, "byte array longer than desired length"), p(yr > 0, "Requested array length <= 0"), this.strip();
        var _r = xe === "le", Or = new Ie(yr), vr, Te, Cr = this.clone();
        if (_r) {
          for (Te = 0; !Cr.isZero(); Te++)
            vr = Cr.andln(255), Cr.iushrn(8), Or[Te] = vr;
          for (; Te < yr; Te++)
            Or[Te] = 0;
        } else {
          for (Te = 0; Te < yr - ar; Te++)
            Or[Te] = 0;
          for (Te = 0; !Cr.isZero(); Te++)
            vr = Cr.andln(255), Cr.iushrn(8), Or[yr - Te - 1] = vr;
        }
        return Or;
      }, Math.clz32 ? A.prototype._countBits = function(Ie) {
        return 32 - Math.clz32(Ie);
      } : A.prototype._countBits = function(Ie) {
        var xe = Ie, rr = 0;
        return xe >= 4096 && (rr += 13, xe >>>= 13), xe >= 64 && (rr += 7, xe >>>= 7), xe >= 8 && (rr += 4, xe >>>= 4), xe >= 2 && (rr += 2, xe >>>= 2), rr + xe;
      }, A.prototype._zeroBits = function(Ie) {
        if (Ie === 0) return 26;
        var xe = Ie, rr = 0;
        return xe & 8191 || (rr += 13, xe >>>= 13), xe & 127 || (rr += 7, xe >>>= 7), xe & 15 || (rr += 4, xe >>>= 4), xe & 3 || (rr += 2, xe >>>= 2), xe & 1 || rr++, rr;
      }, A.prototype.bitLength = function() {
        var Ie = this.words[this.length - 1], xe = this._countBits(Ie);
        return (this.length - 1) * 26 + xe;
      };
      function be(er) {
        for (var Ie = new Array(er.bitLength()), xe = 0; xe < Ie.length; xe++) {
          var rr = xe / 26 | 0, ar = xe % 26;
          Ie[xe] = (er.words[rr] & 1 << ar) >>> ar;
        }
        return Ie;
      }
      A.prototype.zeroBits = function() {
        if (this.isZero()) return 0;
        for (var Ie = 0, xe = 0; xe < this.length; xe++) {
          var rr = this._zeroBits(this.words[xe]);
          if (Ie += rr, rr !== 26) break;
        }
        return Ie;
      }, A.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, A.prototype.toTwos = function(Ie) {
        return this.negative !== 0 ? this.abs().inotn(Ie).iaddn(1) : this.clone();
      }, A.prototype.fromTwos = function(Ie) {
        return this.testn(Ie - 1) ? this.notn(Ie).iaddn(1).ineg() : this.clone();
      }, A.prototype.isNeg = function() {
        return this.negative !== 0;
      }, A.prototype.neg = function() {
        return this.clone().ineg();
      }, A.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, A.prototype.iuor = function(Ie) {
        for (; this.length < Ie.length; )
          this.words[this.length++] = 0;
        for (var xe = 0; xe < Ie.length; xe++)
          this.words[xe] = this.words[xe] | Ie.words[xe];
        return this.strip();
      }, A.prototype.ior = function(Ie) {
        return p((this.negative | Ie.negative) === 0), this.iuor(Ie);
      }, A.prototype.or = function(Ie) {
        return this.length > Ie.length ? this.clone().ior(Ie) : Ie.clone().ior(this);
      }, A.prototype.uor = function(Ie) {
        return this.length > Ie.length ? this.clone().iuor(Ie) : Ie.clone().iuor(this);
      }, A.prototype.iuand = function(Ie) {
        var xe;
        this.length > Ie.length ? xe = Ie : xe = this;
        for (var rr = 0; rr < xe.length; rr++)
          this.words[rr] = this.words[rr] & Ie.words[rr];
        return this.length = xe.length, this.strip();
      }, A.prototype.iand = function(Ie) {
        return p((this.negative | Ie.negative) === 0), this.iuand(Ie);
      }, A.prototype.and = function(Ie) {
        return this.length > Ie.length ? this.clone().iand(Ie) : Ie.clone().iand(this);
      }, A.prototype.uand = function(Ie) {
        return this.length > Ie.length ? this.clone().iuand(Ie) : Ie.clone().iuand(this);
      }, A.prototype.iuxor = function(Ie) {
        var xe, rr;
        this.length > Ie.length ? (xe = this, rr = Ie) : (xe = Ie, rr = this);
        for (var ar = 0; ar < rr.length; ar++)
          this.words[ar] = xe.words[ar] ^ rr.words[ar];
        if (this !== xe)
          for (; ar < xe.length; ar++)
            this.words[ar] = xe.words[ar];
        return this.length = xe.length, this.strip();
      }, A.prototype.ixor = function(Ie) {
        return p((this.negative | Ie.negative) === 0), this.iuxor(Ie);
      }, A.prototype.xor = function(Ie) {
        return this.length > Ie.length ? this.clone().ixor(Ie) : Ie.clone().ixor(this);
      }, A.prototype.uxor = function(Ie) {
        return this.length > Ie.length ? this.clone().iuxor(Ie) : Ie.clone().iuxor(this);
      }, A.prototype.inotn = function(Ie) {
        p(typeof Ie == "number" && Ie >= 0);
        var xe = Math.ceil(Ie / 26) | 0, rr = Ie % 26;
        this._expand(xe), rr > 0 && xe--;
        for (var ar = 0; ar < xe; ar++)
          this.words[ar] = ~this.words[ar] & 67108863;
        return rr > 0 && (this.words[ar] = ~this.words[ar] & 67108863 >> 26 - rr), this.strip();
      }, A.prototype.notn = function(Ie) {
        return this.clone().inotn(Ie);
      }, A.prototype.setn = function(Ie, xe) {
        p(typeof Ie == "number" && Ie >= 0);
        var rr = Ie / 26 | 0, ar = Ie % 26;
        return this._expand(rr + 1), xe ? this.words[rr] = this.words[rr] | 1 << ar : this.words[rr] = this.words[rr] & ~(1 << ar), this.strip();
      }, A.prototype.iadd = function(Ie) {
        var xe;
        if (this.negative !== 0 && Ie.negative === 0)
          return this.negative = 0, xe = this.isub(Ie), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && Ie.negative !== 0)
          return Ie.negative = 0, xe = this.isub(Ie), Ie.negative = 1, xe._normSign();
        var rr, ar;
        this.length > Ie.length ? (rr = this, ar = Ie) : (rr = Ie, ar = this);
        for (var yr = 0, _r = 0; _r < ar.length; _r++)
          xe = (rr.words[_r] | 0) + (ar.words[_r] | 0) + yr, this.words[_r] = xe & 67108863, yr = xe >>> 26;
        for (; yr !== 0 && _r < rr.length; _r++)
          xe = (rr.words[_r] | 0) + yr, this.words[_r] = xe & 67108863, yr = xe >>> 26;
        if (this.length = rr.length, yr !== 0)
          this.words[this.length] = yr, this.length++;
        else if (rr !== this)
          for (; _r < rr.length; _r++)
            this.words[_r] = rr.words[_r];
        return this;
      }, A.prototype.add = function(Ie) {
        var xe;
        return Ie.negative !== 0 && this.negative === 0 ? (Ie.negative = 0, xe = this.sub(Ie), Ie.negative ^= 1, xe) : Ie.negative === 0 && this.negative !== 0 ? (this.negative = 0, xe = Ie.sub(this), this.negative = 1, xe) : this.length > Ie.length ? this.clone().iadd(Ie) : Ie.clone().iadd(this);
      }, A.prototype.isub = function(Ie) {
        if (Ie.negative !== 0) {
          Ie.negative = 0;
          var xe = this.iadd(Ie);
          return Ie.negative = 1, xe._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(Ie), this.negative = 1, this._normSign();
        var rr = this.cmp(Ie);
        if (rr === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var ar, yr;
        rr > 0 ? (ar = this, yr = Ie) : (ar = Ie, yr = this);
        for (var _r = 0, Or = 0; Or < yr.length; Or++)
          xe = (ar.words[Or] | 0) - (yr.words[Or] | 0) + _r, _r = xe >> 26, this.words[Or] = xe & 67108863;
        for (; _r !== 0 && Or < ar.length; Or++)
          xe = (ar.words[Or] | 0) + _r, _r = xe >> 26, this.words[Or] = xe & 67108863;
        if (_r === 0 && Or < ar.length && ar !== this)
          for (; Or < ar.length; Or++)
            this.words[Or] = ar.words[Or];
        return this.length = Math.max(this.length, Or), ar !== this && (this.negative = 1), this.strip();
      }, A.prototype.sub = function(Ie) {
        return this.clone().isub(Ie);
      };
      function He(er, Ie, xe) {
        xe.negative = Ie.negative ^ er.negative;
        var rr = er.length + Ie.length | 0;
        xe.length = rr, rr = rr - 1 | 0;
        var ar = er.words[0] | 0, yr = Ie.words[0] | 0, _r = ar * yr, Or = _r & 67108863, vr = _r / 67108864 | 0;
        xe.words[0] = Or;
        for (var Te = 1; Te < rr; Te++) {
          for (var Cr = vr >>> 26, Hr = vr & 67108863, si = Math.min(Te, Ie.length - 1), ui = Math.max(0, Te - er.length + 1); ui <= si; ui++) {
            var Li = Te - ui | 0;
            ar = er.words[Li] | 0, yr = Ie.words[ui] | 0, _r = ar * yr + Hr, Cr += _r / 67108864 | 0, Hr = _r & 67108863;
          }
          xe.words[Te] = Hr | 0, vr = Cr | 0;
        }
        return vr !== 0 ? xe.words[Te] = vr | 0 : xe.length--, xe.strip();
      }
      var Pe = function(Ie, xe, rr) {
        var ar = Ie.words, yr = xe.words, _r = rr.words, Or = 0, vr, Te, Cr, Hr = ar[0] | 0, si = Hr & 8191, ui = Hr >>> 13, Li = ar[1] | 0, Qi = Li & 8191, wi = Li >>> 13, Ji = ar[2] | 0, mn = Ji & 8191, pi = Ji >>> 13, ei = ar[3] | 0, Vr = ei & 8191, qr = ei >>> 13, Zi = ar[4] | 0, Wr = Zi & 8191, ri = Zi >>> 13, _i = ar[5] | 0, Er = _i & 8191, Di = _i >>> 13, _n = ar[6] | 0, On = _n & 8191, so = _n >>> 13, Do = ar[7] | 0, gn = Do & 8191, Gn = Do >>> 13, pn = ar[8] | 0, hn = pn & 8191, Rn = pn >>> 13, vo = ar[9] | 0, Hi = vo & 8191, di = vo >>> 13, Ui = yr[0] | 0, ln = Ui & 8191, Un = Ui >>> 13, Bo = yr[1] | 0, co = Bo & 8191, To = Bo >>> 13, xs = yr[2] | 0, Fo = xs & 8191, Zo = xs >>> 13, $s = yr[3] | 0, rs = $s & 8191, ls = $s >>> 13, na = yr[4] | 0, os = na & 8191, fs = na >>> 13, da = yr[5] | 0, Bn = da & 8191, hi = da >>> 13, Ii = yr[6] | 0, Gi = Ii & 8191, kn = Ii >>> 13, ho = yr[7] | 0, eo = ho & 8191, Ei = ho >>> 13, vs = yr[8] | 0, vi = vs & 8191, xi = vs >>> 13, Lr = yr[9] | 0, dn = Lr & 8191, xn = Lr >>> 13;
        rr.negative = Ie.negative ^ xe.negative, rr.length = 19, vr = Math.imul(si, ln), Te = Math.imul(si, Un), Te = Te + Math.imul(ui, ln) | 0, Cr = Math.imul(ui, Un);
        var oi = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (oi >>> 26) | 0, oi &= 67108863, vr = Math.imul(Qi, ln), Te = Math.imul(Qi, Un), Te = Te + Math.imul(wi, ln) | 0, Cr = Math.imul(wi, Un), vr = vr + Math.imul(si, co) | 0, Te = Te + Math.imul(si, To) | 0, Te = Te + Math.imul(ui, co) | 0, Cr = Cr + Math.imul(ui, To) | 0;
        var Yr = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (Yr >>> 26) | 0, Yr &= 67108863, vr = Math.imul(mn, ln), Te = Math.imul(mn, Un), Te = Te + Math.imul(pi, ln) | 0, Cr = Math.imul(pi, Un), vr = vr + Math.imul(Qi, co) | 0, Te = Te + Math.imul(Qi, To) | 0, Te = Te + Math.imul(wi, co) | 0, Cr = Cr + Math.imul(wi, To) | 0, vr = vr + Math.imul(si, Fo) | 0, Te = Te + Math.imul(si, Zo) | 0, Te = Te + Math.imul(ui, Fo) | 0, Cr = Cr + Math.imul(ui, Zo) | 0;
        var ji = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (ji >>> 26) | 0, ji &= 67108863, vr = Math.imul(Vr, ln), Te = Math.imul(Vr, Un), Te = Te + Math.imul(qr, ln) | 0, Cr = Math.imul(qr, Un), vr = vr + Math.imul(mn, co) | 0, Te = Te + Math.imul(mn, To) | 0, Te = Te + Math.imul(pi, co) | 0, Cr = Cr + Math.imul(pi, To) | 0, vr = vr + Math.imul(Qi, Fo) | 0, Te = Te + Math.imul(Qi, Zo) | 0, Te = Te + Math.imul(wi, Fo) | 0, Cr = Cr + Math.imul(wi, Zo) | 0, vr = vr + Math.imul(si, rs) | 0, Te = Te + Math.imul(si, ls) | 0, Te = Te + Math.imul(ui, rs) | 0, Cr = Cr + Math.imul(ui, ls) | 0;
        var Cn = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (Cn >>> 26) | 0, Cn &= 67108863, vr = Math.imul(Wr, ln), Te = Math.imul(Wr, Un), Te = Te + Math.imul(ri, ln) | 0, Cr = Math.imul(ri, Un), vr = vr + Math.imul(Vr, co) | 0, Te = Te + Math.imul(Vr, To) | 0, Te = Te + Math.imul(qr, co) | 0, Cr = Cr + Math.imul(qr, To) | 0, vr = vr + Math.imul(mn, Fo) | 0, Te = Te + Math.imul(mn, Zo) | 0, Te = Te + Math.imul(pi, Fo) | 0, Cr = Cr + Math.imul(pi, Zo) | 0, vr = vr + Math.imul(Qi, rs) | 0, Te = Te + Math.imul(Qi, ls) | 0, Te = Te + Math.imul(wi, rs) | 0, Cr = Cr + Math.imul(wi, ls) | 0, vr = vr + Math.imul(si, os) | 0, Te = Te + Math.imul(si, fs) | 0, Te = Te + Math.imul(ui, os) | 0, Cr = Cr + Math.imul(ui, fs) | 0;
        var Mn = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (Mn >>> 26) | 0, Mn &= 67108863, vr = Math.imul(Er, ln), Te = Math.imul(Er, Un), Te = Te + Math.imul(Di, ln) | 0, Cr = Math.imul(Di, Un), vr = vr + Math.imul(Wr, co) | 0, Te = Te + Math.imul(Wr, To) | 0, Te = Te + Math.imul(ri, co) | 0, Cr = Cr + Math.imul(ri, To) | 0, vr = vr + Math.imul(Vr, Fo) | 0, Te = Te + Math.imul(Vr, Zo) | 0, Te = Te + Math.imul(qr, Fo) | 0, Cr = Cr + Math.imul(qr, Zo) | 0, vr = vr + Math.imul(mn, rs) | 0, Te = Te + Math.imul(mn, ls) | 0, Te = Te + Math.imul(pi, rs) | 0, Cr = Cr + Math.imul(pi, ls) | 0, vr = vr + Math.imul(Qi, os) | 0, Te = Te + Math.imul(Qi, fs) | 0, Te = Te + Math.imul(wi, os) | 0, Cr = Cr + Math.imul(wi, fs) | 0, vr = vr + Math.imul(si, Bn) | 0, Te = Te + Math.imul(si, hi) | 0, Te = Te + Math.imul(ui, Bn) | 0, Cr = Cr + Math.imul(ui, hi) | 0;
        var B = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (B >>> 26) | 0, B &= 67108863, vr = Math.imul(On, ln), Te = Math.imul(On, Un), Te = Te + Math.imul(so, ln) | 0, Cr = Math.imul(so, Un), vr = vr + Math.imul(Er, co) | 0, Te = Te + Math.imul(Er, To) | 0, Te = Te + Math.imul(Di, co) | 0, Cr = Cr + Math.imul(Di, To) | 0, vr = vr + Math.imul(Wr, Fo) | 0, Te = Te + Math.imul(Wr, Zo) | 0, Te = Te + Math.imul(ri, Fo) | 0, Cr = Cr + Math.imul(ri, Zo) | 0, vr = vr + Math.imul(Vr, rs) | 0, Te = Te + Math.imul(Vr, ls) | 0, Te = Te + Math.imul(qr, rs) | 0, Cr = Cr + Math.imul(qr, ls) | 0, vr = vr + Math.imul(mn, os) | 0, Te = Te + Math.imul(mn, fs) | 0, Te = Te + Math.imul(pi, os) | 0, Cr = Cr + Math.imul(pi, fs) | 0, vr = vr + Math.imul(Qi, Bn) | 0, Te = Te + Math.imul(Qi, hi) | 0, Te = Te + Math.imul(wi, Bn) | 0, Cr = Cr + Math.imul(wi, hi) | 0, vr = vr + Math.imul(si, Gi) | 0, Te = Te + Math.imul(si, kn) | 0, Te = Te + Math.imul(ui, Gi) | 0, Cr = Cr + Math.imul(ui, kn) | 0;
        var o = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (o >>> 26) | 0, o &= 67108863, vr = Math.imul(gn, ln), Te = Math.imul(gn, Un), Te = Te + Math.imul(Gn, ln) | 0, Cr = Math.imul(Gn, Un), vr = vr + Math.imul(On, co) | 0, Te = Te + Math.imul(On, To) | 0, Te = Te + Math.imul(so, co) | 0, Cr = Cr + Math.imul(so, To) | 0, vr = vr + Math.imul(Er, Fo) | 0, Te = Te + Math.imul(Er, Zo) | 0, Te = Te + Math.imul(Di, Fo) | 0, Cr = Cr + Math.imul(Di, Zo) | 0, vr = vr + Math.imul(Wr, rs) | 0, Te = Te + Math.imul(Wr, ls) | 0, Te = Te + Math.imul(ri, rs) | 0, Cr = Cr + Math.imul(ri, ls) | 0, vr = vr + Math.imul(Vr, os) | 0, Te = Te + Math.imul(Vr, fs) | 0, Te = Te + Math.imul(qr, os) | 0, Cr = Cr + Math.imul(qr, fs) | 0, vr = vr + Math.imul(mn, Bn) | 0, Te = Te + Math.imul(mn, hi) | 0, Te = Te + Math.imul(pi, Bn) | 0, Cr = Cr + Math.imul(pi, hi) | 0, vr = vr + Math.imul(Qi, Gi) | 0, Te = Te + Math.imul(Qi, kn) | 0, Te = Te + Math.imul(wi, Gi) | 0, Cr = Cr + Math.imul(wi, kn) | 0, vr = vr + Math.imul(si, eo) | 0, Te = Te + Math.imul(si, Ei) | 0, Te = Te + Math.imul(ui, eo) | 0, Cr = Cr + Math.imul(ui, Ei) | 0;
        var m = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (m >>> 26) | 0, m &= 67108863, vr = Math.imul(hn, ln), Te = Math.imul(hn, Un), Te = Te + Math.imul(Rn, ln) | 0, Cr = Math.imul(Rn, Un), vr = vr + Math.imul(gn, co) | 0, Te = Te + Math.imul(gn, To) | 0, Te = Te + Math.imul(Gn, co) | 0, Cr = Cr + Math.imul(Gn, To) | 0, vr = vr + Math.imul(On, Fo) | 0, Te = Te + Math.imul(On, Zo) | 0, Te = Te + Math.imul(so, Fo) | 0, Cr = Cr + Math.imul(so, Zo) | 0, vr = vr + Math.imul(Er, rs) | 0, Te = Te + Math.imul(Er, ls) | 0, Te = Te + Math.imul(Di, rs) | 0, Cr = Cr + Math.imul(Di, ls) | 0, vr = vr + Math.imul(Wr, os) | 0, Te = Te + Math.imul(Wr, fs) | 0, Te = Te + Math.imul(ri, os) | 0, Cr = Cr + Math.imul(ri, fs) | 0, vr = vr + Math.imul(Vr, Bn) | 0, Te = Te + Math.imul(Vr, hi) | 0, Te = Te + Math.imul(qr, Bn) | 0, Cr = Cr + Math.imul(qr, hi) | 0, vr = vr + Math.imul(mn, Gi) | 0, Te = Te + Math.imul(mn, kn) | 0, Te = Te + Math.imul(pi, Gi) | 0, Cr = Cr + Math.imul(pi, kn) | 0, vr = vr + Math.imul(Qi, eo) | 0, Te = Te + Math.imul(Qi, Ei) | 0, Te = Te + Math.imul(wi, eo) | 0, Cr = Cr + Math.imul(wi, Ei) | 0, vr = vr + Math.imul(si, vi) | 0, Te = Te + Math.imul(si, xi) | 0, Te = Te + Math.imul(ui, vi) | 0, Cr = Cr + Math.imul(ui, xi) | 0;
        var d = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (d >>> 26) | 0, d &= 67108863, vr = Math.imul(Hi, ln), Te = Math.imul(Hi, Un), Te = Te + Math.imul(di, ln) | 0, Cr = Math.imul(di, Un), vr = vr + Math.imul(hn, co) | 0, Te = Te + Math.imul(hn, To) | 0, Te = Te + Math.imul(Rn, co) | 0, Cr = Cr + Math.imul(Rn, To) | 0, vr = vr + Math.imul(gn, Fo) | 0, Te = Te + Math.imul(gn, Zo) | 0, Te = Te + Math.imul(Gn, Fo) | 0, Cr = Cr + Math.imul(Gn, Zo) | 0, vr = vr + Math.imul(On, rs) | 0, Te = Te + Math.imul(On, ls) | 0, Te = Te + Math.imul(so, rs) | 0, Cr = Cr + Math.imul(so, ls) | 0, vr = vr + Math.imul(Er, os) | 0, Te = Te + Math.imul(Er, fs) | 0, Te = Te + Math.imul(Di, os) | 0, Cr = Cr + Math.imul(Di, fs) | 0, vr = vr + Math.imul(Wr, Bn) | 0, Te = Te + Math.imul(Wr, hi) | 0, Te = Te + Math.imul(ri, Bn) | 0, Cr = Cr + Math.imul(ri, hi) | 0, vr = vr + Math.imul(Vr, Gi) | 0, Te = Te + Math.imul(Vr, kn) | 0, Te = Te + Math.imul(qr, Gi) | 0, Cr = Cr + Math.imul(qr, kn) | 0, vr = vr + Math.imul(mn, eo) | 0, Te = Te + Math.imul(mn, Ei) | 0, Te = Te + Math.imul(pi, eo) | 0, Cr = Cr + Math.imul(pi, Ei) | 0, vr = vr + Math.imul(Qi, vi) | 0, Te = Te + Math.imul(Qi, xi) | 0, Te = Te + Math.imul(wi, vi) | 0, Cr = Cr + Math.imul(wi, xi) | 0, vr = vr + Math.imul(si, dn) | 0, Te = Te + Math.imul(si, xn) | 0, Te = Te + Math.imul(ui, dn) | 0, Cr = Cr + Math.imul(ui, xn) | 0;
        var v = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (v >>> 26) | 0, v &= 67108863, vr = Math.imul(Hi, co), Te = Math.imul(Hi, To), Te = Te + Math.imul(di, co) | 0, Cr = Math.imul(di, To), vr = vr + Math.imul(hn, Fo) | 0, Te = Te + Math.imul(hn, Zo) | 0, Te = Te + Math.imul(Rn, Fo) | 0, Cr = Cr + Math.imul(Rn, Zo) | 0, vr = vr + Math.imul(gn, rs) | 0, Te = Te + Math.imul(gn, ls) | 0, Te = Te + Math.imul(Gn, rs) | 0, Cr = Cr + Math.imul(Gn, ls) | 0, vr = vr + Math.imul(On, os) | 0, Te = Te + Math.imul(On, fs) | 0, Te = Te + Math.imul(so, os) | 0, Cr = Cr + Math.imul(so, fs) | 0, vr = vr + Math.imul(Er, Bn) | 0, Te = Te + Math.imul(Er, hi) | 0, Te = Te + Math.imul(Di, Bn) | 0, Cr = Cr + Math.imul(Di, hi) | 0, vr = vr + Math.imul(Wr, Gi) | 0, Te = Te + Math.imul(Wr, kn) | 0, Te = Te + Math.imul(ri, Gi) | 0, Cr = Cr + Math.imul(ri, kn) | 0, vr = vr + Math.imul(Vr, eo) | 0, Te = Te + Math.imul(Vr, Ei) | 0, Te = Te + Math.imul(qr, eo) | 0, Cr = Cr + Math.imul(qr, Ei) | 0, vr = vr + Math.imul(mn, vi) | 0, Te = Te + Math.imul(mn, xi) | 0, Te = Te + Math.imul(pi, vi) | 0, Cr = Cr + Math.imul(pi, xi) | 0, vr = vr + Math.imul(Qi, dn) | 0, Te = Te + Math.imul(Qi, xn) | 0, Te = Te + Math.imul(wi, dn) | 0, Cr = Cr + Math.imul(wi, xn) | 0;
        var he = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (he >>> 26) | 0, he &= 67108863, vr = Math.imul(Hi, Fo), Te = Math.imul(Hi, Zo), Te = Te + Math.imul(di, Fo) | 0, Cr = Math.imul(di, Zo), vr = vr + Math.imul(hn, rs) | 0, Te = Te + Math.imul(hn, ls) | 0, Te = Te + Math.imul(Rn, rs) | 0, Cr = Cr + Math.imul(Rn, ls) | 0, vr = vr + Math.imul(gn, os) | 0, Te = Te + Math.imul(gn, fs) | 0, Te = Te + Math.imul(Gn, os) | 0, Cr = Cr + Math.imul(Gn, fs) | 0, vr = vr + Math.imul(On, Bn) | 0, Te = Te + Math.imul(On, hi) | 0, Te = Te + Math.imul(so, Bn) | 0, Cr = Cr + Math.imul(so, hi) | 0, vr = vr + Math.imul(Er, Gi) | 0, Te = Te + Math.imul(Er, kn) | 0, Te = Te + Math.imul(Di, Gi) | 0, Cr = Cr + Math.imul(Di, kn) | 0, vr = vr + Math.imul(Wr, eo) | 0, Te = Te + Math.imul(Wr, Ei) | 0, Te = Te + Math.imul(ri, eo) | 0, Cr = Cr + Math.imul(ri, Ei) | 0, vr = vr + Math.imul(Vr, vi) | 0, Te = Te + Math.imul(Vr, xi) | 0, Te = Te + Math.imul(qr, vi) | 0, Cr = Cr + Math.imul(qr, xi) | 0, vr = vr + Math.imul(mn, dn) | 0, Te = Te + Math.imul(mn, xn) | 0, Te = Te + Math.imul(pi, dn) | 0, Cr = Cr + Math.imul(pi, xn) | 0;
        var we = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (we >>> 26) | 0, we &= 67108863, vr = Math.imul(Hi, rs), Te = Math.imul(Hi, ls), Te = Te + Math.imul(di, rs) | 0, Cr = Math.imul(di, ls), vr = vr + Math.imul(hn, os) | 0, Te = Te + Math.imul(hn, fs) | 0, Te = Te + Math.imul(Rn, os) | 0, Cr = Cr + Math.imul(Rn, fs) | 0, vr = vr + Math.imul(gn, Bn) | 0, Te = Te + Math.imul(gn, hi) | 0, Te = Te + Math.imul(Gn, Bn) | 0, Cr = Cr + Math.imul(Gn, hi) | 0, vr = vr + Math.imul(On, Gi) | 0, Te = Te + Math.imul(On, kn) | 0, Te = Te + Math.imul(so, Gi) | 0, Cr = Cr + Math.imul(so, kn) | 0, vr = vr + Math.imul(Er, eo) | 0, Te = Te + Math.imul(Er, Ei) | 0, Te = Te + Math.imul(Di, eo) | 0, Cr = Cr + Math.imul(Di, Ei) | 0, vr = vr + Math.imul(Wr, vi) | 0, Te = Te + Math.imul(Wr, xi) | 0, Te = Te + Math.imul(ri, vi) | 0, Cr = Cr + Math.imul(ri, xi) | 0, vr = vr + Math.imul(Vr, dn) | 0, Te = Te + Math.imul(Vr, xn) | 0, Te = Te + Math.imul(qr, dn) | 0, Cr = Cr + Math.imul(qr, xn) | 0;
        var Be = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (Be >>> 26) | 0, Be &= 67108863, vr = Math.imul(Hi, os), Te = Math.imul(Hi, fs), Te = Te + Math.imul(di, os) | 0, Cr = Math.imul(di, fs), vr = vr + Math.imul(hn, Bn) | 0, Te = Te + Math.imul(hn, hi) | 0, Te = Te + Math.imul(Rn, Bn) | 0, Cr = Cr + Math.imul(Rn, hi) | 0, vr = vr + Math.imul(gn, Gi) | 0, Te = Te + Math.imul(gn, kn) | 0, Te = Te + Math.imul(Gn, Gi) | 0, Cr = Cr + Math.imul(Gn, kn) | 0, vr = vr + Math.imul(On, eo) | 0, Te = Te + Math.imul(On, Ei) | 0, Te = Te + Math.imul(so, eo) | 0, Cr = Cr + Math.imul(so, Ei) | 0, vr = vr + Math.imul(Er, vi) | 0, Te = Te + Math.imul(Er, xi) | 0, Te = Te + Math.imul(Di, vi) | 0, Cr = Cr + Math.imul(Di, xi) | 0, vr = vr + Math.imul(Wr, dn) | 0, Te = Te + Math.imul(Wr, xn) | 0, Te = Te + Math.imul(ri, dn) | 0, Cr = Cr + Math.imul(ri, xn) | 0;
        var Me = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (Me >>> 26) | 0, Me &= 67108863, vr = Math.imul(Hi, Bn), Te = Math.imul(Hi, hi), Te = Te + Math.imul(di, Bn) | 0, Cr = Math.imul(di, hi), vr = vr + Math.imul(hn, Gi) | 0, Te = Te + Math.imul(hn, kn) | 0, Te = Te + Math.imul(Rn, Gi) | 0, Cr = Cr + Math.imul(Rn, kn) | 0, vr = vr + Math.imul(gn, eo) | 0, Te = Te + Math.imul(gn, Ei) | 0, Te = Te + Math.imul(Gn, eo) | 0, Cr = Cr + Math.imul(Gn, Ei) | 0, vr = vr + Math.imul(On, vi) | 0, Te = Te + Math.imul(On, xi) | 0, Te = Te + Math.imul(so, vi) | 0, Cr = Cr + Math.imul(so, xi) | 0, vr = vr + Math.imul(Er, dn) | 0, Te = Te + Math.imul(Er, xn) | 0, Te = Te + Math.imul(Di, dn) | 0, Cr = Cr + Math.imul(Di, xn) | 0;
        var fr = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (fr >>> 26) | 0, fr &= 67108863, vr = Math.imul(Hi, Gi), Te = Math.imul(Hi, kn), Te = Te + Math.imul(di, Gi) | 0, Cr = Math.imul(di, kn), vr = vr + Math.imul(hn, eo) | 0, Te = Te + Math.imul(hn, Ei) | 0, Te = Te + Math.imul(Rn, eo) | 0, Cr = Cr + Math.imul(Rn, Ei) | 0, vr = vr + Math.imul(gn, vi) | 0, Te = Te + Math.imul(gn, xi) | 0, Te = Te + Math.imul(Gn, vi) | 0, Cr = Cr + Math.imul(Gn, xi) | 0, vr = vr + Math.imul(On, dn) | 0, Te = Te + Math.imul(On, xn) | 0, Te = Te + Math.imul(so, dn) | 0, Cr = Cr + Math.imul(so, xn) | 0;
        var wr = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (wr >>> 26) | 0, wr &= 67108863, vr = Math.imul(Hi, eo), Te = Math.imul(Hi, Ei), Te = Te + Math.imul(di, eo) | 0, Cr = Math.imul(di, Ei), vr = vr + Math.imul(hn, vi) | 0, Te = Te + Math.imul(hn, xi) | 0, Te = Te + Math.imul(Rn, vi) | 0, Cr = Cr + Math.imul(Rn, xi) | 0, vr = vr + Math.imul(gn, dn) | 0, Te = Te + Math.imul(gn, xn) | 0, Te = Te + Math.imul(Gn, dn) | 0, Cr = Cr + Math.imul(Gn, xn) | 0;
        var dr = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (dr >>> 26) | 0, dr &= 67108863, vr = Math.imul(Hi, vi), Te = Math.imul(Hi, xi), Te = Te + Math.imul(di, vi) | 0, Cr = Math.imul(di, xi), vr = vr + Math.imul(hn, dn) | 0, Te = Te + Math.imul(hn, xn) | 0, Te = Te + Math.imul(Rn, dn) | 0, Cr = Cr + Math.imul(Rn, xn) | 0;
        var Dr = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (Dr >>> 26) | 0, Dr &= 67108863, vr = Math.imul(Hi, dn), Te = Math.imul(Hi, xn), Te = Te + Math.imul(di, dn) | 0, Cr = Math.imul(di, xn);
        var Rr = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        return Or = (Cr + (Te >>> 13) | 0) + (Rr >>> 26) | 0, Rr &= 67108863, _r[0] = oi, _r[1] = Yr, _r[2] = ji, _r[3] = Cn, _r[4] = Mn, _r[5] = B, _r[6] = o, _r[7] = m, _r[8] = d, _r[9] = v, _r[10] = he, _r[11] = we, _r[12] = Be, _r[13] = Me, _r[14] = fr, _r[15] = wr, _r[16] = dr, _r[17] = Dr, _r[18] = Rr, Or !== 0 && (_r[19] = Or, rr.length++), rr;
      };
      Math.imul || (Pe = He);
      function nr(er, Ie, xe) {
        xe.negative = Ie.negative ^ er.negative, xe.length = er.length + Ie.length;
        for (var rr = 0, ar = 0, yr = 0; yr < xe.length - 1; yr++) {
          var _r = ar;
          ar = 0;
          for (var Or = rr & 67108863, vr = Math.min(yr, Ie.length - 1), Te = Math.max(0, yr - er.length + 1); Te <= vr; Te++) {
            var Cr = yr - Te, Hr = er.words[Cr] | 0, si = Ie.words[Te] | 0, ui = Hr * si, Li = ui & 67108863;
            _r = _r + (ui / 67108864 | 0) | 0, Li = Li + Or | 0, Or = Li & 67108863, _r = _r + (Li >>> 26) | 0, ar += _r >>> 26, _r &= 67108863;
          }
          xe.words[yr] = Or, rr = _r, _r = ar;
        }
        return rr !== 0 ? xe.words[yr] = rr : xe.length--, xe.strip();
      }
      function ir(er, Ie, xe) {
        var rr = new or();
        return rr.mulp(er, Ie, xe);
      }
      A.prototype.mulTo = function(Ie, xe) {
        var rr, ar = this.length + Ie.length;
        return this.length === 10 && Ie.length === 10 ? rr = Pe(this, Ie, xe) : ar < 63 ? rr = He(this, Ie, xe) : ar < 1024 ? rr = nr(this, Ie, xe) : rr = ir(this, Ie, xe), rr;
      };
      function or(er, Ie) {
        this.x = er, this.y = Ie;
      }
      or.prototype.makeRBT = function(Ie) {
        for (var xe = new Array(Ie), rr = A.prototype._countBits(Ie) - 1, ar = 0; ar < Ie; ar++)
          xe[ar] = this.revBin(ar, rr, Ie);
        return xe;
      }, or.prototype.revBin = function(Ie, xe, rr) {
        if (Ie === 0 || Ie === rr - 1) return Ie;
        for (var ar = 0, yr = 0; yr < xe; yr++)
          ar |= (Ie & 1) << xe - yr - 1, Ie >>= 1;
        return ar;
      }, or.prototype.permute = function(Ie, xe, rr, ar, yr, _r) {
        for (var Or = 0; Or < _r; Or++)
          ar[Or] = xe[Ie[Or]], yr[Or] = rr[Ie[Or]];
      }, or.prototype.transform = function(Ie, xe, rr, ar, yr, _r) {
        this.permute(_r, Ie, xe, rr, ar, yr);
        for (var Or = 1; Or < yr; Or <<= 1)
          for (var vr = Or << 1, Te = Math.cos(2 * Math.PI / vr), Cr = Math.sin(2 * Math.PI / vr), Hr = 0; Hr < yr; Hr += vr)
            for (var si = Te, ui = Cr, Li = 0; Li < Or; Li++) {
              var Qi = rr[Hr + Li], wi = ar[Hr + Li], Ji = rr[Hr + Li + Or], mn = ar[Hr + Li + Or], pi = si * Ji - ui * mn;
              mn = si * mn + ui * Ji, Ji = pi, rr[Hr + Li] = Qi + Ji, ar[Hr + Li] = wi + mn, rr[Hr + Li + Or] = Qi - Ji, ar[Hr + Li + Or] = wi - mn, Li !== vr && (pi = Te * si - Cr * ui, ui = Te * ui + Cr * si, si = pi);
            }
      }, or.prototype.guessLen13b = function(Ie, xe) {
        var rr = Math.max(xe, Ie) | 1, ar = rr & 1, yr = 0;
        for (rr = rr / 2 | 0; rr; rr = rr >>> 1)
          yr++;
        return 1 << yr + 1 + ar;
      }, or.prototype.conjugate = function(Ie, xe, rr) {
        if (!(rr <= 1))
          for (var ar = 0; ar < rr / 2; ar++) {
            var yr = Ie[ar];
            Ie[ar] = Ie[rr - ar - 1], Ie[rr - ar - 1] = yr, yr = xe[ar], xe[ar] = -xe[rr - ar - 1], xe[rr - ar - 1] = -yr;
          }
      }, or.prototype.normalize13b = function(Ie, xe) {
        for (var rr = 0, ar = 0; ar < xe / 2; ar++) {
          var yr = Math.round(Ie[2 * ar + 1] / xe) * 8192 + Math.round(Ie[2 * ar] / xe) + rr;
          Ie[ar] = yr & 67108863, yr < 67108864 ? rr = 0 : rr = yr / 67108864 | 0;
        }
        return Ie;
      }, or.prototype.convert13b = function(Ie, xe, rr, ar) {
        for (var yr = 0, _r = 0; _r < xe; _r++)
          yr = yr + (Ie[_r] | 0), rr[2 * _r] = yr & 8191, yr = yr >>> 13, rr[2 * _r + 1] = yr & 8191, yr = yr >>> 13;
        for (_r = 2 * xe; _r < ar; ++_r)
          rr[_r] = 0;
        p(yr === 0), p((yr & -8192) === 0);
      }, or.prototype.stub = function(Ie) {
        for (var xe = new Array(Ie), rr = 0; rr < Ie; rr++)
          xe[rr] = 0;
        return xe;
      }, or.prototype.mulp = function(Ie, xe, rr) {
        var ar = 2 * this.guessLen13b(Ie.length, xe.length), yr = this.makeRBT(ar), _r = this.stub(ar), Or = new Array(ar), vr = new Array(ar), Te = new Array(ar), Cr = new Array(ar), Hr = new Array(ar), si = new Array(ar), ui = rr.words;
        ui.length = ar, this.convert13b(Ie.words, Ie.length, Or, ar), this.convert13b(xe.words, xe.length, Cr, ar), this.transform(Or, _r, vr, Te, ar, yr), this.transform(Cr, _r, Hr, si, ar, yr);
        for (var Li = 0; Li < ar; Li++) {
          var Qi = vr[Li] * Hr[Li] - Te[Li] * si[Li];
          Te[Li] = vr[Li] * si[Li] + Te[Li] * Hr[Li], vr[Li] = Qi;
        }
        return this.conjugate(vr, Te, ar), this.transform(vr, Te, ui, _r, ar, yr), this.conjugate(ui, _r, ar), this.normalize13b(ui, ar), rr.negative = Ie.negative ^ xe.negative, rr.length = Ie.length + xe.length, rr.strip();
      }, A.prototype.mul = function(Ie) {
        var xe = new A(null);
        return xe.words = new Array(this.length + Ie.length), this.mulTo(Ie, xe);
      }, A.prototype.mulf = function(Ie) {
        var xe = new A(null);
        return xe.words = new Array(this.length + Ie.length), ir(this, Ie, xe);
      }, A.prototype.imul = function(Ie) {
        return this.clone().mulTo(Ie, this);
      }, A.prototype.imuln = function(Ie) {
        p(typeof Ie == "number"), p(Ie < 67108864);
        for (var xe = 0, rr = 0; rr < this.length; rr++) {
          var ar = (this.words[rr] | 0) * Ie, yr = (ar & 67108863) + (xe & 67108863);
          xe >>= 26, xe += ar / 67108864 | 0, xe += yr >>> 26, this.words[rr] = yr & 67108863;
        }
        return xe !== 0 && (this.words[rr] = xe, this.length++), this;
      }, A.prototype.muln = function(Ie) {
        return this.clone().imuln(Ie);
      }, A.prototype.sqr = function() {
        return this.mul(this);
      }, A.prototype.isqr = function() {
        return this.imul(this.clone());
      }, A.prototype.pow = function(Ie) {
        var xe = be(Ie);
        if (xe.length === 0) return new A(1);
        for (var rr = this, ar = 0; ar < xe.length && xe[ar] === 0; ar++, rr = rr.sqr())
          ;
        if (++ar < xe.length)
          for (var yr = rr.sqr(); ar < xe.length; ar++, yr = yr.sqr())
            xe[ar] !== 0 && (rr = rr.mul(yr));
        return rr;
      }, A.prototype.iushln = function(Ie) {
        p(typeof Ie == "number" && Ie >= 0);
        var xe = Ie % 26, rr = (Ie - xe) / 26, ar = 67108863 >>> 26 - xe << 26 - xe, yr;
        if (xe !== 0) {
          var _r = 0;
          for (yr = 0; yr < this.length; yr++) {
            var Or = this.words[yr] & ar, vr = (this.words[yr] | 0) - Or << xe;
            this.words[yr] = vr | _r, _r = Or >>> 26 - xe;
          }
          _r && (this.words[yr] = _r, this.length++);
        }
        if (rr !== 0) {
          for (yr = this.length - 1; yr >= 0; yr--)
            this.words[yr + rr] = this.words[yr];
          for (yr = 0; yr < rr; yr++)
            this.words[yr] = 0;
          this.length += rr;
        }
        return this.strip();
      }, A.prototype.ishln = function(Ie) {
        return p(this.negative === 0), this.iushln(Ie);
      }, A.prototype.iushrn = function(Ie, xe, rr) {
        p(typeof Ie == "number" && Ie >= 0);
        var ar;
        xe ? ar = (xe - xe % 26) / 26 : ar = 0;
        var yr = Ie % 26, _r = Math.min((Ie - yr) / 26, this.length), Or = 67108863 ^ 67108863 >>> yr << yr, vr = rr;
        if (ar -= _r, ar = Math.max(0, ar), vr) {
          for (var Te = 0; Te < _r; Te++)
            vr.words[Te] = this.words[Te];
          vr.length = _r;
        }
        if (_r !== 0) if (this.length > _r)
          for (this.length -= _r, Te = 0; Te < this.length; Te++)
            this.words[Te] = this.words[Te + _r];
        else
          this.words[0] = 0, this.length = 1;
        var Cr = 0;
        for (Te = this.length - 1; Te >= 0 && (Cr !== 0 || Te >= ar); Te--) {
          var Hr = this.words[Te] | 0;
          this.words[Te] = Cr << 26 - yr | Hr >>> yr, Cr = Hr & Or;
        }
        return vr && Cr !== 0 && (vr.words[vr.length++] = Cr), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, A.prototype.ishrn = function(Ie, xe, rr) {
        return p(this.negative === 0), this.iushrn(Ie, xe, rr);
      }, A.prototype.shln = function(Ie) {
        return this.clone().ishln(Ie);
      }, A.prototype.ushln = function(Ie) {
        return this.clone().iushln(Ie);
      }, A.prototype.shrn = function(Ie) {
        return this.clone().ishrn(Ie);
      }, A.prototype.ushrn = function(Ie) {
        return this.clone().iushrn(Ie);
      }, A.prototype.testn = function(Ie) {
        p(typeof Ie == "number" && Ie >= 0);
        var xe = Ie % 26, rr = (Ie - xe) / 26, ar = 1 << xe;
        if (this.length <= rr) return !1;
        var yr = this.words[rr];
        return !!(yr & ar);
      }, A.prototype.imaskn = function(Ie) {
        p(typeof Ie == "number" && Ie >= 0);
        var xe = Ie % 26, rr = (Ie - xe) / 26;
        if (p(this.negative === 0, "imaskn works only with positive numbers"), this.length <= rr)
          return this;
        if (xe !== 0 && rr++, this.length = Math.min(rr, this.length), xe !== 0) {
          var ar = 67108863 ^ 67108863 >>> xe << xe;
          this.words[this.length - 1] &= ar;
        }
        return this.strip();
      }, A.prototype.maskn = function(Ie) {
        return this.clone().imaskn(Ie);
      }, A.prototype.iaddn = function(Ie) {
        return p(typeof Ie == "number"), p(Ie < 67108864), Ie < 0 ? this.isubn(-Ie) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < Ie ? (this.words[0] = Ie - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(Ie), this.negative = 1, this) : this._iaddn(Ie);
      }, A.prototype._iaddn = function(Ie) {
        this.words[0] += Ie;
        for (var xe = 0; xe < this.length && this.words[xe] >= 67108864; xe++)
          this.words[xe] -= 67108864, xe === this.length - 1 ? this.words[xe + 1] = 1 : this.words[xe + 1]++;
        return this.length = Math.max(this.length, xe + 1), this;
      }, A.prototype.isubn = function(Ie) {
        if (p(typeof Ie == "number"), p(Ie < 67108864), Ie < 0) return this.iaddn(-Ie);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(Ie), this.negative = 1, this;
        if (this.words[0] -= Ie, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var xe = 0; xe < this.length && this.words[xe] < 0; xe++)
            this.words[xe] += 67108864, this.words[xe + 1] -= 1;
        return this.strip();
      }, A.prototype.addn = function(Ie) {
        return this.clone().iaddn(Ie);
      }, A.prototype.subn = function(Ie) {
        return this.clone().isubn(Ie);
      }, A.prototype.iabs = function() {
        return this.negative = 0, this;
      }, A.prototype.abs = function() {
        return this.clone().iabs();
      }, A.prototype._ishlnsubmul = function(Ie, xe, rr) {
        var ar = Ie.length + rr, yr;
        this._expand(ar);
        var _r, Or = 0;
        for (yr = 0; yr < Ie.length; yr++) {
          _r = (this.words[yr + rr] | 0) + Or;
          var vr = (Ie.words[yr] | 0) * xe;
          _r -= vr & 67108863, Or = (_r >> 26) - (vr / 67108864 | 0), this.words[yr + rr] = _r & 67108863;
        }
        for (; yr < this.length - rr; yr++)
          _r = (this.words[yr + rr] | 0) + Or, Or = _r >> 26, this.words[yr + rr] = _r & 67108863;
        if (Or === 0) return this.strip();
        for (p(Or === -1), Or = 0, yr = 0; yr < this.length; yr++)
          _r = -(this.words[yr] | 0) + Or, Or = _r >> 26, this.words[yr] = _r & 67108863;
        return this.negative = 1, this.strip();
      }, A.prototype._wordDiv = function(Ie, xe) {
        var rr = this.length - Ie.length, ar = this.clone(), yr = Ie, _r = yr.words[yr.length - 1] | 0, Or = this._countBits(_r);
        rr = 26 - Or, rr !== 0 && (yr = yr.ushln(rr), ar.iushln(rr), _r = yr.words[yr.length - 1] | 0);
        var vr = ar.length - yr.length, Te;
        if (xe !== "mod") {
          Te = new A(null), Te.length = vr + 1, Te.words = new Array(Te.length);
          for (var Cr = 0; Cr < Te.length; Cr++)
            Te.words[Cr] = 0;
        }
        var Hr = ar.clone()._ishlnsubmul(yr, 1, vr);
        Hr.negative === 0 && (ar = Hr, Te && (Te.words[vr] = 1));
        for (var si = vr - 1; si >= 0; si--) {
          var ui = (ar.words[yr.length + si] | 0) * 67108864 + (ar.words[yr.length + si - 1] | 0);
          for (ui = Math.min(ui / _r | 0, 67108863), ar._ishlnsubmul(yr, ui, si); ar.negative !== 0; )
            ui--, ar.negative = 0, ar._ishlnsubmul(yr, 1, si), ar.isZero() || (ar.negative ^= 1);
          Te && (Te.words[si] = ui);
        }
        return Te && Te.strip(), ar.strip(), xe !== "div" && rr !== 0 && ar.iushrn(rr), {
          div: Te || null,
          mod: ar
        };
      }, A.prototype.divmod = function(Ie, xe, rr) {
        if (p(!Ie.isZero()), this.isZero())
          return {
            div: new A(0),
            mod: new A(0)
          };
        var ar, yr, _r;
        return this.negative !== 0 && Ie.negative === 0 ? (_r = this.neg().divmod(Ie, xe), xe !== "mod" && (ar = _r.div.neg()), xe !== "div" && (yr = _r.mod.neg(), rr && yr.negative !== 0 && yr.iadd(Ie)), {
          div: ar,
          mod: yr
        }) : this.negative === 0 && Ie.negative !== 0 ? (_r = this.divmod(Ie.neg(), xe), xe !== "mod" && (ar = _r.div.neg()), {
          div: ar,
          mod: _r.mod
        }) : this.negative & Ie.negative ? (_r = this.neg().divmod(Ie.neg(), xe), xe !== "div" && (yr = _r.mod.neg(), rr && yr.negative !== 0 && yr.isub(Ie)), {
          div: _r.div,
          mod: yr
        }) : Ie.length > this.length || this.cmp(Ie) < 0 ? {
          div: new A(0),
          mod: this
        } : Ie.length === 1 ? xe === "div" ? {
          div: this.divn(Ie.words[0]),
          mod: null
        } : xe === "mod" ? {
          div: null,
          mod: new A(this.modn(Ie.words[0]))
        } : {
          div: this.divn(Ie.words[0]),
          mod: new A(this.modn(Ie.words[0]))
        } : this._wordDiv(Ie, xe);
      }, A.prototype.div = function(Ie) {
        return this.divmod(Ie, "div", !1).div;
      }, A.prototype.mod = function(Ie) {
        return this.divmod(Ie, "mod", !1).mod;
      }, A.prototype.umod = function(Ie) {
        return this.divmod(Ie, "mod", !0).mod;
      }, A.prototype.divRound = function(Ie) {
        var xe = this.divmod(Ie);
        if (xe.mod.isZero()) return xe.div;
        var rr = xe.div.negative !== 0 ? xe.mod.isub(Ie) : xe.mod, ar = Ie.ushrn(1), yr = Ie.andln(1), _r = rr.cmp(ar);
        return _r < 0 || yr === 1 && _r === 0 ? xe.div : xe.div.negative !== 0 ? xe.div.isubn(1) : xe.div.iaddn(1);
      }, A.prototype.modn = function(Ie) {
        p(Ie <= 67108863);
        for (var xe = (1 << 26) % Ie, rr = 0, ar = this.length - 1; ar >= 0; ar--)
          rr = (xe * rr + (this.words[ar] | 0)) % Ie;
        return rr;
      }, A.prototype.idivn = function(Ie) {
        p(Ie <= 67108863);
        for (var xe = 0, rr = this.length - 1; rr >= 0; rr--) {
          var ar = (this.words[rr] | 0) + xe * 67108864;
          this.words[rr] = ar / Ie | 0, xe = ar % Ie;
        }
        return this.strip();
      }, A.prototype.divn = function(Ie) {
        return this.clone().idivn(Ie);
      }, A.prototype.egcd = function(Ie) {
        p(Ie.negative === 0), p(!Ie.isZero());
        var xe = this, rr = Ie.clone();
        xe.negative !== 0 ? xe = xe.umod(Ie) : xe = xe.clone();
        for (var ar = new A(1), yr = new A(0), _r = new A(0), Or = new A(1), vr = 0; xe.isEven() && rr.isEven(); )
          xe.iushrn(1), rr.iushrn(1), ++vr;
        for (var Te = rr.clone(), Cr = xe.clone(); !xe.isZero(); ) {
          for (var Hr = 0, si = 1; !(xe.words[0] & si) && Hr < 26; ++Hr, si <<= 1) ;
          if (Hr > 0)
            for (xe.iushrn(Hr); Hr-- > 0; )
              (ar.isOdd() || yr.isOdd()) && (ar.iadd(Te), yr.isub(Cr)), ar.iushrn(1), yr.iushrn(1);
          for (var ui = 0, Li = 1; !(rr.words[0] & Li) && ui < 26; ++ui, Li <<= 1) ;
          if (ui > 0)
            for (rr.iushrn(ui); ui-- > 0; )
              (_r.isOdd() || Or.isOdd()) && (_r.iadd(Te), Or.isub(Cr)), _r.iushrn(1), Or.iushrn(1);
          xe.cmp(rr) >= 0 ? (xe.isub(rr), ar.isub(_r), yr.isub(Or)) : (rr.isub(xe), _r.isub(ar), Or.isub(yr));
        }
        return {
          a: _r,
          b: Or,
          gcd: rr.iushln(vr)
        };
      }, A.prototype._invmp = function(Ie) {
        p(Ie.negative === 0), p(!Ie.isZero());
        var xe = this, rr = Ie.clone();
        xe.negative !== 0 ? xe = xe.umod(Ie) : xe = xe.clone();
        for (var ar = new A(1), yr = new A(0), _r = rr.clone(); xe.cmpn(1) > 0 && rr.cmpn(1) > 0; ) {
          for (var Or = 0, vr = 1; !(xe.words[0] & vr) && Or < 26; ++Or, vr <<= 1) ;
          if (Or > 0)
            for (xe.iushrn(Or); Or-- > 0; )
              ar.isOdd() && ar.iadd(_r), ar.iushrn(1);
          for (var Te = 0, Cr = 1; !(rr.words[0] & Cr) && Te < 26; ++Te, Cr <<= 1) ;
          if (Te > 0)
            for (rr.iushrn(Te); Te-- > 0; )
              yr.isOdd() && yr.iadd(_r), yr.iushrn(1);
          xe.cmp(rr) >= 0 ? (xe.isub(rr), ar.isub(yr)) : (rr.isub(xe), yr.isub(ar));
        }
        var Hr;
        return xe.cmpn(1) === 0 ? Hr = ar : Hr = yr, Hr.cmpn(0) < 0 && Hr.iadd(Ie), Hr;
      }, A.prototype.gcd = function(Ie) {
        if (this.isZero()) return Ie.abs();
        if (Ie.isZero()) return this.abs();
        var xe = this.clone(), rr = Ie.clone();
        xe.negative = 0, rr.negative = 0;
        for (var ar = 0; xe.isEven() && rr.isEven(); ar++)
          xe.iushrn(1), rr.iushrn(1);
        do {
          for (; xe.isEven(); )
            xe.iushrn(1);
          for (; rr.isEven(); )
            rr.iushrn(1);
          var yr = xe.cmp(rr);
          if (yr < 0) {
            var _r = xe;
            xe = rr, rr = _r;
          } else if (yr === 0 || rr.cmpn(1) === 0)
            break;
          xe.isub(rr);
        } while (!0);
        return rr.iushln(ar);
      }, A.prototype.invm = function(Ie) {
        return this.egcd(Ie).a.umod(Ie);
      }, A.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, A.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, A.prototype.andln = function(Ie) {
        return this.words[0] & Ie;
      }, A.prototype.bincn = function(Ie) {
        p(typeof Ie == "number");
        var xe = Ie % 26, rr = (Ie - xe) / 26, ar = 1 << xe;
        if (this.length <= rr)
          return this._expand(rr + 1), this.words[rr] |= ar, this;
        for (var yr = ar, _r = rr; yr !== 0 && _r < this.length; _r++) {
          var Or = this.words[_r] | 0;
          Or += yr, yr = Or >>> 26, Or &= 67108863, this.words[_r] = Or;
        }
        return yr !== 0 && (this.words[_r] = yr, this.length++), this;
      }, A.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, A.prototype.cmpn = function(Ie) {
        var xe = Ie < 0;
        if (this.negative !== 0 && !xe) return -1;
        if (this.negative === 0 && xe) return 1;
        this.strip();
        var rr;
        if (this.length > 1)
          rr = 1;
        else {
          xe && (Ie = -Ie), p(Ie <= 67108863, "Number is too big");
          var ar = this.words[0] | 0;
          rr = ar === Ie ? 0 : ar < Ie ? -1 : 1;
        }
        return this.negative !== 0 ? -rr | 0 : rr;
      }, A.prototype.cmp = function(Ie) {
        if (this.negative !== 0 && Ie.negative === 0) return -1;
        if (this.negative === 0 && Ie.negative !== 0) return 1;
        var xe = this.ucmp(Ie);
        return this.negative !== 0 ? -xe | 0 : xe;
      }, A.prototype.ucmp = function(Ie) {
        if (this.length > Ie.length) return 1;
        if (this.length < Ie.length) return -1;
        for (var xe = 0, rr = this.length - 1; rr >= 0; rr--) {
          var ar = this.words[rr] | 0, yr = Ie.words[rr] | 0;
          if (ar !== yr) {
            ar < yr ? xe = -1 : ar > yr && (xe = 1);
            break;
          }
        }
        return xe;
      }, A.prototype.gtn = function(Ie) {
        return this.cmpn(Ie) === 1;
      }, A.prototype.gt = function(Ie) {
        return this.cmp(Ie) === 1;
      }, A.prototype.gten = function(Ie) {
        return this.cmpn(Ie) >= 0;
      }, A.prototype.gte = function(Ie) {
        return this.cmp(Ie) >= 0;
      }, A.prototype.ltn = function(Ie) {
        return this.cmpn(Ie) === -1;
      }, A.prototype.lt = function(Ie) {
        return this.cmp(Ie) === -1;
      }, A.prototype.lten = function(Ie) {
        return this.cmpn(Ie) <= 0;
      }, A.prototype.lte = function(Ie) {
        return this.cmp(Ie) <= 0;
      }, A.prototype.eqn = function(Ie) {
        return this.cmpn(Ie) === 0;
      }, A.prototype.eq = function(Ie) {
        return this.cmp(Ie) === 0;
      }, A.red = function(Ie) {
        return new Fe(Ie);
      }, A.prototype.toRed = function(Ie) {
        return p(!this.red, "Already a number in reduction context"), p(this.negative === 0, "red works only with positives"), Ie.convertTo(this)._forceRed(Ie);
      }, A.prototype.fromRed = function() {
        return p(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, A.prototype._forceRed = function(Ie) {
        return this.red = Ie, this;
      }, A.prototype.forceRed = function(Ie) {
        return p(!this.red, "Already a number in reduction context"), this._forceRed(Ie);
      }, A.prototype.redAdd = function(Ie) {
        return p(this.red, "redAdd works only with red numbers"), this.red.add(this, Ie);
      }, A.prototype.redIAdd = function(Ie) {
        return p(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, Ie);
      }, A.prototype.redSub = function(Ie) {
        return p(this.red, "redSub works only with red numbers"), this.red.sub(this, Ie);
      }, A.prototype.redISub = function(Ie) {
        return p(this.red, "redISub works only with red numbers"), this.red.isub(this, Ie);
      }, A.prototype.redShl = function(Ie) {
        return p(this.red, "redShl works only with red numbers"), this.red.shl(this, Ie);
      }, A.prototype.redMul = function(Ie) {
        return p(this.red, "redMul works only with red numbers"), this.red._verify2(this, Ie), this.red.mul(this, Ie);
      }, A.prototype.redIMul = function(Ie) {
        return p(this.red, "redMul works only with red numbers"), this.red._verify2(this, Ie), this.red.imul(this, Ie);
      }, A.prototype.redSqr = function() {
        return p(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, A.prototype.redISqr = function() {
        return p(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, A.prototype.redSqrt = function() {
        return p(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, A.prototype.redInvm = function() {
        return p(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, A.prototype.redNeg = function() {
        return p(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, A.prototype.redPow = function(Ie) {
        return p(this.red && !Ie.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, Ie);
      };
      var lr = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function Ir(er, Ie) {
        this.name = er, this.p = new A(Ie, 16), this.n = this.p.bitLength(), this.k = new A(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      Ir.prototype._tmp = function() {
        var Ie = new A(null);
        return Ie.words = new Array(Math.ceil(this.n / 13)), Ie;
      }, Ir.prototype.ireduce = function(Ie) {
        var xe = Ie, rr;
        do
          this.split(xe, this.tmp), xe = this.imulK(xe), xe = xe.iadd(this.tmp), rr = xe.bitLength();
        while (rr > this.n);
        var ar = rr < this.n ? -1 : xe.ucmp(this.p);
        return ar === 0 ? (xe.words[0] = 0, xe.length = 1) : ar > 0 ? xe.isub(this.p) : xe.strip !== void 0 ? xe.strip() : xe._strip(), xe;
      }, Ir.prototype.split = function(Ie, xe) {
        Ie.iushrn(this.n, 0, xe);
      }, Ir.prototype.imulK = function(Ie) {
        return Ie.imul(this.k);
      };
      function xr() {
        Ir.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      a(xr, Ir), xr.prototype.split = function(Ie, xe) {
        for (var rr = 4194303, ar = Math.min(Ie.length, 9), yr = 0; yr < ar; yr++)
          xe.words[yr] = Ie.words[yr];
        if (xe.length = ar, Ie.length <= 9) {
          Ie.words[0] = 0, Ie.length = 1;
          return;
        }
        var _r = Ie.words[9];
        for (xe.words[xe.length++] = _r & rr, yr = 10; yr < Ie.length; yr++) {
          var Or = Ie.words[yr] | 0;
          Ie.words[yr - 10] = (Or & rr) << 4 | _r >>> 22, _r = Or;
        }
        _r >>>= 22, Ie.words[yr - 10] = _r, _r === 0 && Ie.length > 10 ? Ie.length -= 10 : Ie.length -= 9;
      }, xr.prototype.imulK = function(Ie) {
        Ie.words[Ie.length] = 0, Ie.words[Ie.length + 1] = 0, Ie.length += 2;
        for (var xe = 0, rr = 0; rr < Ie.length; rr++) {
          var ar = Ie.words[rr] | 0;
          xe += ar * 977, Ie.words[rr] = xe & 67108863, xe = ar * 64 + (xe / 67108864 | 0);
        }
        return Ie.words[Ie.length - 1] === 0 && (Ie.length--, Ie.words[Ie.length - 1] === 0 && Ie.length--), Ie;
      };
      function kr() {
        Ir.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      a(kr, Ir);
      function Ce() {
        Ir.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      a(Ce, Ir);
      function tr() {
        Ir.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      a(tr, Ir), tr.prototype.imulK = function(Ie) {
        for (var xe = 0, rr = 0; rr < Ie.length; rr++) {
          var ar = (Ie.words[rr] | 0) * 19 + xe, yr = ar & 67108863;
          ar >>>= 26, Ie.words[rr] = yr, xe = ar;
        }
        return xe !== 0 && (Ie.words[Ie.length++] = xe), Ie;
      }, A._prime = function(Ie) {
        if (lr[Ie]) return lr[Ie];
        var xe;
        if (Ie === "k256")
          xe = new xr();
        else if (Ie === "p224")
          xe = new kr();
        else if (Ie === "p192")
          xe = new Ce();
        else if (Ie === "p25519")
          xe = new tr();
        else
          throw new Error("Unknown prime " + Ie);
        return lr[Ie] = xe, xe;
      };
      function Fe(er) {
        if (typeof er == "string") {
          var Ie = A._prime(er);
          this.m = Ie.p, this.prime = Ie;
        } else
          p(er.gtn(1), "modulus must be greater than 1"), this.m = er, this.prime = null;
      }
      Fe.prototype._verify1 = function(Ie) {
        p(Ie.negative === 0, "red works only with positives"), p(Ie.red, "red works only with red numbers");
      }, Fe.prototype._verify2 = function(Ie, xe) {
        p((Ie.negative | xe.negative) === 0, "red works only with positives"), p(
          Ie.red && Ie.red === xe.red,
          "red works only with red numbers"
        );
      }, Fe.prototype.imod = function(Ie) {
        return this.prime ? this.prime.ireduce(Ie)._forceRed(this) : Ie.umod(this.m)._forceRed(this);
      }, Fe.prototype.neg = function(Ie) {
        return Ie.isZero() ? Ie.clone() : this.m.sub(Ie)._forceRed(this);
      }, Fe.prototype.add = function(Ie, xe) {
        this._verify2(Ie, xe);
        var rr = Ie.add(xe);
        return rr.cmp(this.m) >= 0 && rr.isub(this.m), rr._forceRed(this);
      }, Fe.prototype.iadd = function(Ie, xe) {
        this._verify2(Ie, xe);
        var rr = Ie.iadd(xe);
        return rr.cmp(this.m) >= 0 && rr.isub(this.m), rr;
      }, Fe.prototype.sub = function(Ie, xe) {
        this._verify2(Ie, xe);
        var rr = Ie.sub(xe);
        return rr.cmpn(0) < 0 && rr.iadd(this.m), rr._forceRed(this);
      }, Fe.prototype.isub = function(Ie, xe) {
        this._verify2(Ie, xe);
        var rr = Ie.isub(xe);
        return rr.cmpn(0) < 0 && rr.iadd(this.m), rr;
      }, Fe.prototype.shl = function(Ie, xe) {
        return this._verify1(Ie), this.imod(Ie.ushln(xe));
      }, Fe.prototype.imul = function(Ie, xe) {
        return this._verify2(Ie, xe), this.imod(Ie.imul(xe));
      }, Fe.prototype.mul = function(Ie, xe) {
        return this._verify2(Ie, xe), this.imod(Ie.mul(xe));
      }, Fe.prototype.isqr = function(Ie) {
        return this.imul(Ie, Ie.clone());
      }, Fe.prototype.sqr = function(Ie) {
        return this.mul(Ie, Ie);
      }, Fe.prototype.sqrt = function(Ie) {
        if (Ie.isZero()) return Ie.clone();
        var xe = this.m.andln(3);
        if (p(xe % 2 === 1), xe === 3) {
          var rr = this.m.add(new A(1)).iushrn(2);
          return this.pow(Ie, rr);
        }
        for (var ar = this.m.subn(1), yr = 0; !ar.isZero() && ar.andln(1) === 0; )
          yr++, ar.iushrn(1);
        p(!ar.isZero());
        var _r = new A(1).toRed(this), Or = _r.redNeg(), vr = this.m.subn(1).iushrn(1), Te = this.m.bitLength();
        for (Te = new A(2 * Te * Te).toRed(this); this.pow(Te, vr).cmp(Or) !== 0; )
          Te.redIAdd(Or);
        for (var Cr = this.pow(Te, ar), Hr = this.pow(Ie, ar.addn(1).iushrn(1)), si = this.pow(Ie, ar), ui = yr; si.cmp(_r) !== 0; ) {
          for (var Li = si, Qi = 0; Li.cmp(_r) !== 0; Qi++)
            Li = Li.redSqr();
          p(Qi < ui);
          var wi = this.pow(Cr, new A(1).iushln(ui - Qi - 1));
          Hr = Hr.redMul(wi), Cr = wi.redSqr(), si = si.redMul(Cr), ui = Qi;
        }
        return Hr;
      }, Fe.prototype.invm = function(Ie) {
        var xe = Ie._invmp(this.m);
        return xe.negative !== 0 ? (xe.negative = 0, this.imod(xe).redNeg()) : this.imod(xe);
      }, Fe.prototype.pow = function(Ie, xe) {
        if (xe.isZero()) return new A(1).toRed(this);
        if (xe.cmpn(1) === 0) return Ie.clone();
        var rr = 4, ar = new Array(1 << rr);
        ar[0] = new A(1).toRed(this), ar[1] = Ie;
        for (var yr = 2; yr < ar.length; yr++)
          ar[yr] = this.mul(ar[yr - 1], Ie);
        var _r = ar[0], Or = 0, vr = 0, Te = xe.bitLength() % 26;
        for (Te === 0 && (Te = 26), yr = xe.length - 1; yr >= 0; yr--) {
          for (var Cr = xe.words[yr], Hr = Te - 1; Hr >= 0; Hr--) {
            var si = Cr >> Hr & 1;
            if (_r !== ar[0] && (_r = this.sqr(_r)), si === 0 && Or === 0) {
              vr = 0;
              continue;
            }
            Or <<= 1, Or |= si, vr++, !(vr !== rr && (yr !== 0 || Hr !== 0)) && (_r = this.mul(_r, ar[Or]), vr = 0, Or = 0);
          }
          Te = 26;
        }
        return _r;
      }, Fe.prototype.convertTo = function(Ie) {
        var xe = Ie.umod(this.m);
        return xe === Ie ? xe.clone() : xe;
      }, Fe.prototype.convertFrom = function(Ie) {
        var xe = Ie.clone();
        return xe.red = null, xe;
      }, A.mont = function(Ie) {
        return new Sr(Ie);
      };
      function Sr(er) {
        Fe.call(this, er), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new A(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      a(Sr, Fe), Sr.prototype.convertTo = function(Ie) {
        return this.imod(Ie.ushln(this.shift));
      }, Sr.prototype.convertFrom = function(Ie) {
        var xe = this.imod(Ie.mul(this.rinv));
        return xe.red = null, xe;
      }, Sr.prototype.imul = function(Ie, xe) {
        if (Ie.isZero() || xe.isZero())
          return Ie.words[0] = 0, Ie.length = 1, Ie;
        var rr = Ie.imul(xe), ar = rr.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), yr = rr.isub(ar).iushrn(this.shift), _r = yr;
        return yr.cmp(this.m) >= 0 ? _r = yr.isub(this.m) : yr.cmpn(0) < 0 && (_r = yr.iadd(this.m)), _r._forceRed(this);
      }, Sr.prototype.mul = function(Ie, xe) {
        if (Ie.isZero() || xe.isZero()) return new A(0)._forceRed(this);
        var rr = Ie.mul(xe), ar = rr.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), yr = rr.isub(ar).iushrn(this.shift), _r = yr;
        return yr.cmp(this.m) >= 0 ? _r = yr.isub(this.m) : yr.cmpn(0) < 0 && (_r = yr.iadd(this.m)), _r._forceRed(this);
      }, Sr.prototype.invm = function(Ie) {
        var xe = this.imod(Ie._invmp(this.m).mul(this.r2));
        return xe._forceRed(this);
      };
    })(n, commonjsGlobal);
  }(bn$1)), bn$1.exports;
}
var browser$2, hasRequiredBrowser$2;
function requireBrowser$2() {
  if (hasRequiredBrowser$2) return browser$2;
  hasRequiredBrowser$2 = 1;
  var n = requireElliptic$2(), c = requireBn$1();
  browser$2 = function(b) {
    return new p(b);
  };
  var u = {
    secp256k1: {
      name: "secp256k1",
      byteLength: 32
    },
    secp224r1: {
      name: "p224",
      byteLength: 28
    },
    prime256v1: {
      name: "p256",
      byteLength: 32
    },
    prime192v1: {
      name: "p192",
      byteLength: 24
    },
    ed25519: {
      name: "ed25519",
      byteLength: 32
    },
    secp384r1: {
      name: "p384",
      byteLength: 48
    },
    secp521r1: {
      name: "p521",
      byteLength: 66
    }
  };
  u.p224 = u.secp224r1, u.p256 = u.secp256r1 = u.prime256v1, u.p192 = u.secp192r1 = u.prime192v1, u.p384 = u.secp384r1, u.p521 = u.secp521r1;
  function p(A) {
    this.curveType = u[A], this.curveType || (this.curveType = {
      name: A
    }), this.curve = new n.ec(this.curveType.name), this.keys = void 0;
  }
  p.prototype.generateKeys = function(A, b) {
    return this.keys = this.curve.genKeyPair(), this.getPublicKey(A, b);
  }, p.prototype.computeSecret = function(A, b, F) {
    b = b || "utf8", Buffer$f.isBuffer(A) || (A = new Buffer$f(A, b));
    var le = this.curve.keyFromPublic(A).getPublic(), L = le.mul(this.keys.getPrivate()).getX();
    return a(L, F, this.curveType.byteLength);
  }, p.prototype.getPublicKey = function(A, b) {
    var F = this.keys.getPublic(b === "compressed", !0);
    return b === "hybrid" && (F[F.length - 1] % 2 ? F[0] = 7 : F[0] = 6), a(F, A);
  }, p.prototype.getPrivateKey = function(A) {
    return a(this.keys.getPrivate(), A);
  }, p.prototype.setPublicKey = function(A, b) {
    return b = b || "utf8", Buffer$f.isBuffer(A) || (A = new Buffer$f(A, b)), this.keys._importPublic(A), this;
  }, p.prototype.setPrivateKey = function(A, b) {
    b = b || "utf8", Buffer$f.isBuffer(A) || (A = new Buffer$f(A, b));
    var F = new c(A);
    return F = F.toString(16), this.keys = this.curve.genKeyPair(), this.keys._importPrivate(F), this;
  };
  function a(A, b, F) {
    Array.isArray(A) || (A = A.toArray());
    var le = new Buffer$f(A);
    if (F && le.length < F) {
      var L = new Buffer$f(F - le.length);
      L.fill(0), le = Buffer$f.concat([L, le]);
    }
    return b ? le.toString(b) : le;
  }
  return browser$2;
}
var browser$1 = {}, mgf, hasRequiredMgf;
function requireMgf() {
  if (hasRequiredMgf) return mgf;
  hasRequiredMgf = 1;
  var n = browser$a, c = safeBufferExports.Buffer;
  mgf = function(p, a) {
    for (var A = c.alloc(0), b = 0, F; A.length < a; )
      F = u(b++), A = c.concat([A, n("sha1").update(p).update(F).digest()]);
    return A.slice(0, a);
  };
  function u(p) {
    var a = c.allocUnsafe(4);
    return a.writeUInt32BE(p, 0), a;
  }
  return mgf;
}
var xor, hasRequiredXor;
function requireXor() {
  return hasRequiredXor || (hasRequiredXor = 1, xor = function(c, u) {
    for (var p = c.length, a = -1; ++a < p; )
      c[a] ^= u[a];
    return c;
  }), xor;
}
var bn = { exports: {} };
bn.exports;
var hasRequiredBn;
function requireBn() {
  return hasRequiredBn || (hasRequiredBn = 1, function(n) {
    (function(c, u) {
      function p(er, Ie) {
        if (!er) throw new Error(Ie || "Assertion failed");
      }
      function a(er, Ie) {
        er.super_ = Ie;
        var xe = function() {
        };
        xe.prototype = Ie.prototype, er.prototype = new xe(), er.prototype.constructor = er;
      }
      function A(er, Ie, xe) {
        if (A.isBN(er))
          return er;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, er !== null && ((Ie === "le" || Ie === "be") && (xe = Ie, Ie = 10), this._init(er || 0, Ie || 10, xe || "be"));
      }
      typeof c == "object" ? c.exports = A : u.BN = A, A.BN = A, A.wordSize = 26;
      var b;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? b = window.Buffer : b = require$$0$5.Buffer;
      } catch {
      }
      A.isBN = function(Ie) {
        return Ie instanceof A ? !0 : Ie !== null && typeof Ie == "object" && Ie.constructor.wordSize === A.wordSize && Array.isArray(Ie.words);
      }, A.max = function(Ie, xe) {
        return Ie.cmp(xe) > 0 ? Ie : xe;
      }, A.min = function(Ie, xe) {
        return Ie.cmp(xe) < 0 ? Ie : xe;
      }, A.prototype._init = function(Ie, xe, rr) {
        if (typeof Ie == "number")
          return this._initNumber(Ie, xe, rr);
        if (typeof Ie == "object")
          return this._initArray(Ie, xe, rr);
        xe === "hex" && (xe = 16), p(xe === (xe | 0) && xe >= 2 && xe <= 36), Ie = Ie.toString().replace(/\s+/g, "");
        var ar = 0;
        Ie[0] === "-" && (ar++, this.negative = 1), ar < Ie.length && (xe === 16 ? this._parseHex(Ie, ar, rr) : (this._parseBase(Ie, xe, ar), rr === "le" && this._initArray(this.toArray(), xe, rr)));
      }, A.prototype._initNumber = function(Ie, xe, rr) {
        Ie < 0 && (this.negative = 1, Ie = -Ie), Ie < 67108864 ? (this.words = [Ie & 67108863], this.length = 1) : Ie < 4503599627370496 ? (this.words = [
          Ie & 67108863,
          Ie / 67108864 & 67108863
        ], this.length = 2) : (p(Ie < 9007199254740992), this.words = [
          Ie & 67108863,
          Ie / 67108864 & 67108863,
          1
        ], this.length = 3), rr === "le" && this._initArray(this.toArray(), xe, rr);
      }, A.prototype._initArray = function(Ie, xe, rr) {
        if (p(typeof Ie.length == "number"), Ie.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(Ie.length / 3), this.words = new Array(this.length);
        for (var ar = 0; ar < this.length; ar++)
          this.words[ar] = 0;
        var yr, _r, Or = 0;
        if (rr === "be")
          for (ar = Ie.length - 1, yr = 0; ar >= 0; ar -= 3)
            _r = Ie[ar] | Ie[ar - 1] << 8 | Ie[ar - 2] << 16, this.words[yr] |= _r << Or & 67108863, this.words[yr + 1] = _r >>> 26 - Or & 67108863, Or += 24, Or >= 26 && (Or -= 26, yr++);
        else if (rr === "le")
          for (ar = 0, yr = 0; ar < Ie.length; ar += 3)
            _r = Ie[ar] | Ie[ar + 1] << 8 | Ie[ar + 2] << 16, this.words[yr] |= _r << Or & 67108863, this.words[yr + 1] = _r >>> 26 - Or & 67108863, Or += 24, Or >= 26 && (Or -= 26, yr++);
        return this.strip();
      };
      function F(er, Ie) {
        var xe = er.charCodeAt(Ie);
        return xe >= 65 && xe <= 70 ? xe - 55 : xe >= 97 && xe <= 102 ? xe - 87 : xe - 48 & 15;
      }
      function le(er, Ie, xe) {
        var rr = F(er, xe);
        return xe - 1 >= Ie && (rr |= F(er, xe - 1) << 4), rr;
      }
      A.prototype._parseHex = function(Ie, xe, rr) {
        this.length = Math.ceil((Ie.length - xe) / 6), this.words = new Array(this.length);
        for (var ar = 0; ar < this.length; ar++)
          this.words[ar] = 0;
        var yr = 0, _r = 0, Or;
        if (rr === "be")
          for (ar = Ie.length - 1; ar >= xe; ar -= 2)
            Or = le(Ie, xe, ar) << yr, this.words[_r] |= Or & 67108863, yr >= 18 ? (yr -= 18, _r += 1, this.words[_r] |= Or >>> 26) : yr += 8;
        else {
          var vr = Ie.length - xe;
          for (ar = vr % 2 === 0 ? xe + 1 : xe; ar < Ie.length; ar += 2)
            Or = le(Ie, xe, ar) << yr, this.words[_r] |= Or & 67108863, yr >= 18 ? (yr -= 18, _r += 1, this.words[_r] |= Or >>> 26) : yr += 8;
        }
        this.strip();
      };
      function L(er, Ie, xe, rr) {
        for (var ar = 0, yr = Math.min(er.length, xe), _r = Ie; _r < yr; _r++) {
          var Or = er.charCodeAt(_r) - 48;
          ar *= rr, Or >= 49 ? ar += Or - 49 + 10 : Or >= 17 ? ar += Or - 17 + 10 : ar += Or;
        }
        return ar;
      }
      A.prototype._parseBase = function(Ie, xe, rr) {
        this.words = [0], this.length = 1;
        for (var ar = 0, yr = 1; yr <= 67108863; yr *= xe)
          ar++;
        ar--, yr = yr / xe | 0;
        for (var _r = Ie.length - rr, Or = _r % ar, vr = Math.min(_r, _r - Or) + rr, Te = 0, Cr = rr; Cr < vr; Cr += ar)
          Te = L(Ie, Cr, Cr + ar, xe), this.imuln(yr), this.words[0] + Te < 67108864 ? this.words[0] += Te : this._iaddn(Te);
        if (Or !== 0) {
          var Hr = 1;
          for (Te = L(Ie, Cr, Ie.length, xe), Cr = 0; Cr < Or; Cr++)
            Hr *= xe;
          this.imuln(Hr), this.words[0] + Te < 67108864 ? this.words[0] += Te : this._iaddn(Te);
        }
        this.strip();
      }, A.prototype.copy = function(Ie) {
        Ie.words = new Array(this.length);
        for (var xe = 0; xe < this.length; xe++)
          Ie.words[xe] = this.words[xe];
        Ie.length = this.length, Ie.negative = this.negative, Ie.red = this.red;
      }, A.prototype.clone = function() {
        var Ie = new A(null);
        return this.copy(Ie), Ie;
      }, A.prototype._expand = function(Ie) {
        for (; this.length < Ie; )
          this.words[this.length++] = 0;
        return this;
      }, A.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, A.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, A.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var pe = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], $ = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], Ee = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      A.prototype.toString = function(Ie, xe) {
        Ie = Ie || 10, xe = xe | 0 || 1;
        var rr;
        if (Ie === 16 || Ie === "hex") {
          rr = "";
          for (var ar = 0, yr = 0, _r = 0; _r < this.length; _r++) {
            var Or = this.words[_r], vr = ((Or << ar | yr) & 16777215).toString(16);
            yr = Or >>> 24 - ar & 16777215, ar += 2, ar >= 26 && (ar -= 26, _r--), yr !== 0 || _r !== this.length - 1 ? rr = pe[6 - vr.length] + vr + rr : rr = vr + rr;
          }
          for (yr !== 0 && (rr = yr.toString(16) + rr); rr.length % xe !== 0; )
            rr = "0" + rr;
          return this.negative !== 0 && (rr = "-" + rr), rr;
        }
        if (Ie === (Ie | 0) && Ie >= 2 && Ie <= 36) {
          var Te = $[Ie], Cr = Ee[Ie];
          rr = "";
          var Hr = this.clone();
          for (Hr.negative = 0; !Hr.isZero(); ) {
            var si = Hr.modn(Cr).toString(Ie);
            Hr = Hr.idivn(Cr), Hr.isZero() ? rr = si + rr : rr = pe[Te - si.length] + si + rr;
          }
          for (this.isZero() && (rr = "0" + rr); rr.length % xe !== 0; )
            rr = "0" + rr;
          return this.negative !== 0 && (rr = "-" + rr), rr;
        }
        p(!1, "Base should be between 2 and 36");
      }, A.prototype.toNumber = function() {
        var Ie = this.words[0];
        return this.length === 2 ? Ie += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? Ie += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && p(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -Ie : Ie;
      }, A.prototype.toJSON = function() {
        return this.toString(16);
      }, A.prototype.toBuffer = function(Ie, xe) {
        return p(typeof b < "u"), this.toArrayLike(b, Ie, xe);
      }, A.prototype.toArray = function(Ie, xe) {
        return this.toArrayLike(Array, Ie, xe);
      }, A.prototype.toArrayLike = function(Ie, xe, rr) {
        var ar = this.byteLength(), yr = rr || Math.max(1, ar);
        p(ar <= yr, "byte array longer than desired length"), p(yr > 0, "Requested array length <= 0"), this.strip();
        var _r = xe === "le", Or = new Ie(yr), vr, Te, Cr = this.clone();
        if (_r) {
          for (Te = 0; !Cr.isZero(); Te++)
            vr = Cr.andln(255), Cr.iushrn(8), Or[Te] = vr;
          for (; Te < yr; Te++)
            Or[Te] = 0;
        } else {
          for (Te = 0; Te < yr - ar; Te++)
            Or[Te] = 0;
          for (Te = 0; !Cr.isZero(); Te++)
            vr = Cr.andln(255), Cr.iushrn(8), Or[yr - Te - 1] = vr;
        }
        return Or;
      }, Math.clz32 ? A.prototype._countBits = function(Ie) {
        return 32 - Math.clz32(Ie);
      } : A.prototype._countBits = function(Ie) {
        var xe = Ie, rr = 0;
        return xe >= 4096 && (rr += 13, xe >>>= 13), xe >= 64 && (rr += 7, xe >>>= 7), xe >= 8 && (rr += 4, xe >>>= 4), xe >= 2 && (rr += 2, xe >>>= 2), rr + xe;
      }, A.prototype._zeroBits = function(Ie) {
        if (Ie === 0) return 26;
        var xe = Ie, rr = 0;
        return xe & 8191 || (rr += 13, xe >>>= 13), xe & 127 || (rr += 7, xe >>>= 7), xe & 15 || (rr += 4, xe >>>= 4), xe & 3 || (rr += 2, xe >>>= 2), xe & 1 || rr++, rr;
      }, A.prototype.bitLength = function() {
        var Ie = this.words[this.length - 1], xe = this._countBits(Ie);
        return (this.length - 1) * 26 + xe;
      };
      function be(er) {
        for (var Ie = new Array(er.bitLength()), xe = 0; xe < Ie.length; xe++) {
          var rr = xe / 26 | 0, ar = xe % 26;
          Ie[xe] = (er.words[rr] & 1 << ar) >>> ar;
        }
        return Ie;
      }
      A.prototype.zeroBits = function() {
        if (this.isZero()) return 0;
        for (var Ie = 0, xe = 0; xe < this.length; xe++) {
          var rr = this._zeroBits(this.words[xe]);
          if (Ie += rr, rr !== 26) break;
        }
        return Ie;
      }, A.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, A.prototype.toTwos = function(Ie) {
        return this.negative !== 0 ? this.abs().inotn(Ie).iaddn(1) : this.clone();
      }, A.prototype.fromTwos = function(Ie) {
        return this.testn(Ie - 1) ? this.notn(Ie).iaddn(1).ineg() : this.clone();
      }, A.prototype.isNeg = function() {
        return this.negative !== 0;
      }, A.prototype.neg = function() {
        return this.clone().ineg();
      }, A.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, A.prototype.iuor = function(Ie) {
        for (; this.length < Ie.length; )
          this.words[this.length++] = 0;
        for (var xe = 0; xe < Ie.length; xe++)
          this.words[xe] = this.words[xe] | Ie.words[xe];
        return this.strip();
      }, A.prototype.ior = function(Ie) {
        return p((this.negative | Ie.negative) === 0), this.iuor(Ie);
      }, A.prototype.or = function(Ie) {
        return this.length > Ie.length ? this.clone().ior(Ie) : Ie.clone().ior(this);
      }, A.prototype.uor = function(Ie) {
        return this.length > Ie.length ? this.clone().iuor(Ie) : Ie.clone().iuor(this);
      }, A.prototype.iuand = function(Ie) {
        var xe;
        this.length > Ie.length ? xe = Ie : xe = this;
        for (var rr = 0; rr < xe.length; rr++)
          this.words[rr] = this.words[rr] & Ie.words[rr];
        return this.length = xe.length, this.strip();
      }, A.prototype.iand = function(Ie) {
        return p((this.negative | Ie.negative) === 0), this.iuand(Ie);
      }, A.prototype.and = function(Ie) {
        return this.length > Ie.length ? this.clone().iand(Ie) : Ie.clone().iand(this);
      }, A.prototype.uand = function(Ie) {
        return this.length > Ie.length ? this.clone().iuand(Ie) : Ie.clone().iuand(this);
      }, A.prototype.iuxor = function(Ie) {
        var xe, rr;
        this.length > Ie.length ? (xe = this, rr = Ie) : (xe = Ie, rr = this);
        for (var ar = 0; ar < rr.length; ar++)
          this.words[ar] = xe.words[ar] ^ rr.words[ar];
        if (this !== xe)
          for (; ar < xe.length; ar++)
            this.words[ar] = xe.words[ar];
        return this.length = xe.length, this.strip();
      }, A.prototype.ixor = function(Ie) {
        return p((this.negative | Ie.negative) === 0), this.iuxor(Ie);
      }, A.prototype.xor = function(Ie) {
        return this.length > Ie.length ? this.clone().ixor(Ie) : Ie.clone().ixor(this);
      }, A.prototype.uxor = function(Ie) {
        return this.length > Ie.length ? this.clone().iuxor(Ie) : Ie.clone().iuxor(this);
      }, A.prototype.inotn = function(Ie) {
        p(typeof Ie == "number" && Ie >= 0);
        var xe = Math.ceil(Ie / 26) | 0, rr = Ie % 26;
        this._expand(xe), rr > 0 && xe--;
        for (var ar = 0; ar < xe; ar++)
          this.words[ar] = ~this.words[ar] & 67108863;
        return rr > 0 && (this.words[ar] = ~this.words[ar] & 67108863 >> 26 - rr), this.strip();
      }, A.prototype.notn = function(Ie) {
        return this.clone().inotn(Ie);
      }, A.prototype.setn = function(Ie, xe) {
        p(typeof Ie == "number" && Ie >= 0);
        var rr = Ie / 26 | 0, ar = Ie % 26;
        return this._expand(rr + 1), xe ? this.words[rr] = this.words[rr] | 1 << ar : this.words[rr] = this.words[rr] & ~(1 << ar), this.strip();
      }, A.prototype.iadd = function(Ie) {
        var xe;
        if (this.negative !== 0 && Ie.negative === 0)
          return this.negative = 0, xe = this.isub(Ie), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && Ie.negative !== 0)
          return Ie.negative = 0, xe = this.isub(Ie), Ie.negative = 1, xe._normSign();
        var rr, ar;
        this.length > Ie.length ? (rr = this, ar = Ie) : (rr = Ie, ar = this);
        for (var yr = 0, _r = 0; _r < ar.length; _r++)
          xe = (rr.words[_r] | 0) + (ar.words[_r] | 0) + yr, this.words[_r] = xe & 67108863, yr = xe >>> 26;
        for (; yr !== 0 && _r < rr.length; _r++)
          xe = (rr.words[_r] | 0) + yr, this.words[_r] = xe & 67108863, yr = xe >>> 26;
        if (this.length = rr.length, yr !== 0)
          this.words[this.length] = yr, this.length++;
        else if (rr !== this)
          for (; _r < rr.length; _r++)
            this.words[_r] = rr.words[_r];
        return this;
      }, A.prototype.add = function(Ie) {
        var xe;
        return Ie.negative !== 0 && this.negative === 0 ? (Ie.negative = 0, xe = this.sub(Ie), Ie.negative ^= 1, xe) : Ie.negative === 0 && this.negative !== 0 ? (this.negative = 0, xe = Ie.sub(this), this.negative = 1, xe) : this.length > Ie.length ? this.clone().iadd(Ie) : Ie.clone().iadd(this);
      }, A.prototype.isub = function(Ie) {
        if (Ie.negative !== 0) {
          Ie.negative = 0;
          var xe = this.iadd(Ie);
          return Ie.negative = 1, xe._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(Ie), this.negative = 1, this._normSign();
        var rr = this.cmp(Ie);
        if (rr === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var ar, yr;
        rr > 0 ? (ar = this, yr = Ie) : (ar = Ie, yr = this);
        for (var _r = 0, Or = 0; Or < yr.length; Or++)
          xe = (ar.words[Or] | 0) - (yr.words[Or] | 0) + _r, _r = xe >> 26, this.words[Or] = xe & 67108863;
        for (; _r !== 0 && Or < ar.length; Or++)
          xe = (ar.words[Or] | 0) + _r, _r = xe >> 26, this.words[Or] = xe & 67108863;
        if (_r === 0 && Or < ar.length && ar !== this)
          for (; Or < ar.length; Or++)
            this.words[Or] = ar.words[Or];
        return this.length = Math.max(this.length, Or), ar !== this && (this.negative = 1), this.strip();
      }, A.prototype.sub = function(Ie) {
        return this.clone().isub(Ie);
      };
      function He(er, Ie, xe) {
        xe.negative = Ie.negative ^ er.negative;
        var rr = er.length + Ie.length | 0;
        xe.length = rr, rr = rr - 1 | 0;
        var ar = er.words[0] | 0, yr = Ie.words[0] | 0, _r = ar * yr, Or = _r & 67108863, vr = _r / 67108864 | 0;
        xe.words[0] = Or;
        for (var Te = 1; Te < rr; Te++) {
          for (var Cr = vr >>> 26, Hr = vr & 67108863, si = Math.min(Te, Ie.length - 1), ui = Math.max(0, Te - er.length + 1); ui <= si; ui++) {
            var Li = Te - ui | 0;
            ar = er.words[Li] | 0, yr = Ie.words[ui] | 0, _r = ar * yr + Hr, Cr += _r / 67108864 | 0, Hr = _r & 67108863;
          }
          xe.words[Te] = Hr | 0, vr = Cr | 0;
        }
        return vr !== 0 ? xe.words[Te] = vr | 0 : xe.length--, xe.strip();
      }
      var Pe = function(Ie, xe, rr) {
        var ar = Ie.words, yr = xe.words, _r = rr.words, Or = 0, vr, Te, Cr, Hr = ar[0] | 0, si = Hr & 8191, ui = Hr >>> 13, Li = ar[1] | 0, Qi = Li & 8191, wi = Li >>> 13, Ji = ar[2] | 0, mn = Ji & 8191, pi = Ji >>> 13, ei = ar[3] | 0, Vr = ei & 8191, qr = ei >>> 13, Zi = ar[4] | 0, Wr = Zi & 8191, ri = Zi >>> 13, _i = ar[5] | 0, Er = _i & 8191, Di = _i >>> 13, _n = ar[6] | 0, On = _n & 8191, so = _n >>> 13, Do = ar[7] | 0, gn = Do & 8191, Gn = Do >>> 13, pn = ar[8] | 0, hn = pn & 8191, Rn = pn >>> 13, vo = ar[9] | 0, Hi = vo & 8191, di = vo >>> 13, Ui = yr[0] | 0, ln = Ui & 8191, Un = Ui >>> 13, Bo = yr[1] | 0, co = Bo & 8191, To = Bo >>> 13, xs = yr[2] | 0, Fo = xs & 8191, Zo = xs >>> 13, $s = yr[3] | 0, rs = $s & 8191, ls = $s >>> 13, na = yr[4] | 0, os = na & 8191, fs = na >>> 13, da = yr[5] | 0, Bn = da & 8191, hi = da >>> 13, Ii = yr[6] | 0, Gi = Ii & 8191, kn = Ii >>> 13, ho = yr[7] | 0, eo = ho & 8191, Ei = ho >>> 13, vs = yr[8] | 0, vi = vs & 8191, xi = vs >>> 13, Lr = yr[9] | 0, dn = Lr & 8191, xn = Lr >>> 13;
        rr.negative = Ie.negative ^ xe.negative, rr.length = 19, vr = Math.imul(si, ln), Te = Math.imul(si, Un), Te = Te + Math.imul(ui, ln) | 0, Cr = Math.imul(ui, Un);
        var oi = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (oi >>> 26) | 0, oi &= 67108863, vr = Math.imul(Qi, ln), Te = Math.imul(Qi, Un), Te = Te + Math.imul(wi, ln) | 0, Cr = Math.imul(wi, Un), vr = vr + Math.imul(si, co) | 0, Te = Te + Math.imul(si, To) | 0, Te = Te + Math.imul(ui, co) | 0, Cr = Cr + Math.imul(ui, To) | 0;
        var Yr = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (Yr >>> 26) | 0, Yr &= 67108863, vr = Math.imul(mn, ln), Te = Math.imul(mn, Un), Te = Te + Math.imul(pi, ln) | 0, Cr = Math.imul(pi, Un), vr = vr + Math.imul(Qi, co) | 0, Te = Te + Math.imul(Qi, To) | 0, Te = Te + Math.imul(wi, co) | 0, Cr = Cr + Math.imul(wi, To) | 0, vr = vr + Math.imul(si, Fo) | 0, Te = Te + Math.imul(si, Zo) | 0, Te = Te + Math.imul(ui, Fo) | 0, Cr = Cr + Math.imul(ui, Zo) | 0;
        var ji = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (ji >>> 26) | 0, ji &= 67108863, vr = Math.imul(Vr, ln), Te = Math.imul(Vr, Un), Te = Te + Math.imul(qr, ln) | 0, Cr = Math.imul(qr, Un), vr = vr + Math.imul(mn, co) | 0, Te = Te + Math.imul(mn, To) | 0, Te = Te + Math.imul(pi, co) | 0, Cr = Cr + Math.imul(pi, To) | 0, vr = vr + Math.imul(Qi, Fo) | 0, Te = Te + Math.imul(Qi, Zo) | 0, Te = Te + Math.imul(wi, Fo) | 0, Cr = Cr + Math.imul(wi, Zo) | 0, vr = vr + Math.imul(si, rs) | 0, Te = Te + Math.imul(si, ls) | 0, Te = Te + Math.imul(ui, rs) | 0, Cr = Cr + Math.imul(ui, ls) | 0;
        var Cn = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (Cn >>> 26) | 0, Cn &= 67108863, vr = Math.imul(Wr, ln), Te = Math.imul(Wr, Un), Te = Te + Math.imul(ri, ln) | 0, Cr = Math.imul(ri, Un), vr = vr + Math.imul(Vr, co) | 0, Te = Te + Math.imul(Vr, To) | 0, Te = Te + Math.imul(qr, co) | 0, Cr = Cr + Math.imul(qr, To) | 0, vr = vr + Math.imul(mn, Fo) | 0, Te = Te + Math.imul(mn, Zo) | 0, Te = Te + Math.imul(pi, Fo) | 0, Cr = Cr + Math.imul(pi, Zo) | 0, vr = vr + Math.imul(Qi, rs) | 0, Te = Te + Math.imul(Qi, ls) | 0, Te = Te + Math.imul(wi, rs) | 0, Cr = Cr + Math.imul(wi, ls) | 0, vr = vr + Math.imul(si, os) | 0, Te = Te + Math.imul(si, fs) | 0, Te = Te + Math.imul(ui, os) | 0, Cr = Cr + Math.imul(ui, fs) | 0;
        var Mn = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (Mn >>> 26) | 0, Mn &= 67108863, vr = Math.imul(Er, ln), Te = Math.imul(Er, Un), Te = Te + Math.imul(Di, ln) | 0, Cr = Math.imul(Di, Un), vr = vr + Math.imul(Wr, co) | 0, Te = Te + Math.imul(Wr, To) | 0, Te = Te + Math.imul(ri, co) | 0, Cr = Cr + Math.imul(ri, To) | 0, vr = vr + Math.imul(Vr, Fo) | 0, Te = Te + Math.imul(Vr, Zo) | 0, Te = Te + Math.imul(qr, Fo) | 0, Cr = Cr + Math.imul(qr, Zo) | 0, vr = vr + Math.imul(mn, rs) | 0, Te = Te + Math.imul(mn, ls) | 0, Te = Te + Math.imul(pi, rs) | 0, Cr = Cr + Math.imul(pi, ls) | 0, vr = vr + Math.imul(Qi, os) | 0, Te = Te + Math.imul(Qi, fs) | 0, Te = Te + Math.imul(wi, os) | 0, Cr = Cr + Math.imul(wi, fs) | 0, vr = vr + Math.imul(si, Bn) | 0, Te = Te + Math.imul(si, hi) | 0, Te = Te + Math.imul(ui, Bn) | 0, Cr = Cr + Math.imul(ui, hi) | 0;
        var B = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (B >>> 26) | 0, B &= 67108863, vr = Math.imul(On, ln), Te = Math.imul(On, Un), Te = Te + Math.imul(so, ln) | 0, Cr = Math.imul(so, Un), vr = vr + Math.imul(Er, co) | 0, Te = Te + Math.imul(Er, To) | 0, Te = Te + Math.imul(Di, co) | 0, Cr = Cr + Math.imul(Di, To) | 0, vr = vr + Math.imul(Wr, Fo) | 0, Te = Te + Math.imul(Wr, Zo) | 0, Te = Te + Math.imul(ri, Fo) | 0, Cr = Cr + Math.imul(ri, Zo) | 0, vr = vr + Math.imul(Vr, rs) | 0, Te = Te + Math.imul(Vr, ls) | 0, Te = Te + Math.imul(qr, rs) | 0, Cr = Cr + Math.imul(qr, ls) | 0, vr = vr + Math.imul(mn, os) | 0, Te = Te + Math.imul(mn, fs) | 0, Te = Te + Math.imul(pi, os) | 0, Cr = Cr + Math.imul(pi, fs) | 0, vr = vr + Math.imul(Qi, Bn) | 0, Te = Te + Math.imul(Qi, hi) | 0, Te = Te + Math.imul(wi, Bn) | 0, Cr = Cr + Math.imul(wi, hi) | 0, vr = vr + Math.imul(si, Gi) | 0, Te = Te + Math.imul(si, kn) | 0, Te = Te + Math.imul(ui, Gi) | 0, Cr = Cr + Math.imul(ui, kn) | 0;
        var o = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (o >>> 26) | 0, o &= 67108863, vr = Math.imul(gn, ln), Te = Math.imul(gn, Un), Te = Te + Math.imul(Gn, ln) | 0, Cr = Math.imul(Gn, Un), vr = vr + Math.imul(On, co) | 0, Te = Te + Math.imul(On, To) | 0, Te = Te + Math.imul(so, co) | 0, Cr = Cr + Math.imul(so, To) | 0, vr = vr + Math.imul(Er, Fo) | 0, Te = Te + Math.imul(Er, Zo) | 0, Te = Te + Math.imul(Di, Fo) | 0, Cr = Cr + Math.imul(Di, Zo) | 0, vr = vr + Math.imul(Wr, rs) | 0, Te = Te + Math.imul(Wr, ls) | 0, Te = Te + Math.imul(ri, rs) | 0, Cr = Cr + Math.imul(ri, ls) | 0, vr = vr + Math.imul(Vr, os) | 0, Te = Te + Math.imul(Vr, fs) | 0, Te = Te + Math.imul(qr, os) | 0, Cr = Cr + Math.imul(qr, fs) | 0, vr = vr + Math.imul(mn, Bn) | 0, Te = Te + Math.imul(mn, hi) | 0, Te = Te + Math.imul(pi, Bn) | 0, Cr = Cr + Math.imul(pi, hi) | 0, vr = vr + Math.imul(Qi, Gi) | 0, Te = Te + Math.imul(Qi, kn) | 0, Te = Te + Math.imul(wi, Gi) | 0, Cr = Cr + Math.imul(wi, kn) | 0, vr = vr + Math.imul(si, eo) | 0, Te = Te + Math.imul(si, Ei) | 0, Te = Te + Math.imul(ui, eo) | 0, Cr = Cr + Math.imul(ui, Ei) | 0;
        var m = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (m >>> 26) | 0, m &= 67108863, vr = Math.imul(hn, ln), Te = Math.imul(hn, Un), Te = Te + Math.imul(Rn, ln) | 0, Cr = Math.imul(Rn, Un), vr = vr + Math.imul(gn, co) | 0, Te = Te + Math.imul(gn, To) | 0, Te = Te + Math.imul(Gn, co) | 0, Cr = Cr + Math.imul(Gn, To) | 0, vr = vr + Math.imul(On, Fo) | 0, Te = Te + Math.imul(On, Zo) | 0, Te = Te + Math.imul(so, Fo) | 0, Cr = Cr + Math.imul(so, Zo) | 0, vr = vr + Math.imul(Er, rs) | 0, Te = Te + Math.imul(Er, ls) | 0, Te = Te + Math.imul(Di, rs) | 0, Cr = Cr + Math.imul(Di, ls) | 0, vr = vr + Math.imul(Wr, os) | 0, Te = Te + Math.imul(Wr, fs) | 0, Te = Te + Math.imul(ri, os) | 0, Cr = Cr + Math.imul(ri, fs) | 0, vr = vr + Math.imul(Vr, Bn) | 0, Te = Te + Math.imul(Vr, hi) | 0, Te = Te + Math.imul(qr, Bn) | 0, Cr = Cr + Math.imul(qr, hi) | 0, vr = vr + Math.imul(mn, Gi) | 0, Te = Te + Math.imul(mn, kn) | 0, Te = Te + Math.imul(pi, Gi) | 0, Cr = Cr + Math.imul(pi, kn) | 0, vr = vr + Math.imul(Qi, eo) | 0, Te = Te + Math.imul(Qi, Ei) | 0, Te = Te + Math.imul(wi, eo) | 0, Cr = Cr + Math.imul(wi, Ei) | 0, vr = vr + Math.imul(si, vi) | 0, Te = Te + Math.imul(si, xi) | 0, Te = Te + Math.imul(ui, vi) | 0, Cr = Cr + Math.imul(ui, xi) | 0;
        var d = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (d >>> 26) | 0, d &= 67108863, vr = Math.imul(Hi, ln), Te = Math.imul(Hi, Un), Te = Te + Math.imul(di, ln) | 0, Cr = Math.imul(di, Un), vr = vr + Math.imul(hn, co) | 0, Te = Te + Math.imul(hn, To) | 0, Te = Te + Math.imul(Rn, co) | 0, Cr = Cr + Math.imul(Rn, To) | 0, vr = vr + Math.imul(gn, Fo) | 0, Te = Te + Math.imul(gn, Zo) | 0, Te = Te + Math.imul(Gn, Fo) | 0, Cr = Cr + Math.imul(Gn, Zo) | 0, vr = vr + Math.imul(On, rs) | 0, Te = Te + Math.imul(On, ls) | 0, Te = Te + Math.imul(so, rs) | 0, Cr = Cr + Math.imul(so, ls) | 0, vr = vr + Math.imul(Er, os) | 0, Te = Te + Math.imul(Er, fs) | 0, Te = Te + Math.imul(Di, os) | 0, Cr = Cr + Math.imul(Di, fs) | 0, vr = vr + Math.imul(Wr, Bn) | 0, Te = Te + Math.imul(Wr, hi) | 0, Te = Te + Math.imul(ri, Bn) | 0, Cr = Cr + Math.imul(ri, hi) | 0, vr = vr + Math.imul(Vr, Gi) | 0, Te = Te + Math.imul(Vr, kn) | 0, Te = Te + Math.imul(qr, Gi) | 0, Cr = Cr + Math.imul(qr, kn) | 0, vr = vr + Math.imul(mn, eo) | 0, Te = Te + Math.imul(mn, Ei) | 0, Te = Te + Math.imul(pi, eo) | 0, Cr = Cr + Math.imul(pi, Ei) | 0, vr = vr + Math.imul(Qi, vi) | 0, Te = Te + Math.imul(Qi, xi) | 0, Te = Te + Math.imul(wi, vi) | 0, Cr = Cr + Math.imul(wi, xi) | 0, vr = vr + Math.imul(si, dn) | 0, Te = Te + Math.imul(si, xn) | 0, Te = Te + Math.imul(ui, dn) | 0, Cr = Cr + Math.imul(ui, xn) | 0;
        var v = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (v >>> 26) | 0, v &= 67108863, vr = Math.imul(Hi, co), Te = Math.imul(Hi, To), Te = Te + Math.imul(di, co) | 0, Cr = Math.imul(di, To), vr = vr + Math.imul(hn, Fo) | 0, Te = Te + Math.imul(hn, Zo) | 0, Te = Te + Math.imul(Rn, Fo) | 0, Cr = Cr + Math.imul(Rn, Zo) | 0, vr = vr + Math.imul(gn, rs) | 0, Te = Te + Math.imul(gn, ls) | 0, Te = Te + Math.imul(Gn, rs) | 0, Cr = Cr + Math.imul(Gn, ls) | 0, vr = vr + Math.imul(On, os) | 0, Te = Te + Math.imul(On, fs) | 0, Te = Te + Math.imul(so, os) | 0, Cr = Cr + Math.imul(so, fs) | 0, vr = vr + Math.imul(Er, Bn) | 0, Te = Te + Math.imul(Er, hi) | 0, Te = Te + Math.imul(Di, Bn) | 0, Cr = Cr + Math.imul(Di, hi) | 0, vr = vr + Math.imul(Wr, Gi) | 0, Te = Te + Math.imul(Wr, kn) | 0, Te = Te + Math.imul(ri, Gi) | 0, Cr = Cr + Math.imul(ri, kn) | 0, vr = vr + Math.imul(Vr, eo) | 0, Te = Te + Math.imul(Vr, Ei) | 0, Te = Te + Math.imul(qr, eo) | 0, Cr = Cr + Math.imul(qr, Ei) | 0, vr = vr + Math.imul(mn, vi) | 0, Te = Te + Math.imul(mn, xi) | 0, Te = Te + Math.imul(pi, vi) | 0, Cr = Cr + Math.imul(pi, xi) | 0, vr = vr + Math.imul(Qi, dn) | 0, Te = Te + Math.imul(Qi, xn) | 0, Te = Te + Math.imul(wi, dn) | 0, Cr = Cr + Math.imul(wi, xn) | 0;
        var he = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (he >>> 26) | 0, he &= 67108863, vr = Math.imul(Hi, Fo), Te = Math.imul(Hi, Zo), Te = Te + Math.imul(di, Fo) | 0, Cr = Math.imul(di, Zo), vr = vr + Math.imul(hn, rs) | 0, Te = Te + Math.imul(hn, ls) | 0, Te = Te + Math.imul(Rn, rs) | 0, Cr = Cr + Math.imul(Rn, ls) | 0, vr = vr + Math.imul(gn, os) | 0, Te = Te + Math.imul(gn, fs) | 0, Te = Te + Math.imul(Gn, os) | 0, Cr = Cr + Math.imul(Gn, fs) | 0, vr = vr + Math.imul(On, Bn) | 0, Te = Te + Math.imul(On, hi) | 0, Te = Te + Math.imul(so, Bn) | 0, Cr = Cr + Math.imul(so, hi) | 0, vr = vr + Math.imul(Er, Gi) | 0, Te = Te + Math.imul(Er, kn) | 0, Te = Te + Math.imul(Di, Gi) | 0, Cr = Cr + Math.imul(Di, kn) | 0, vr = vr + Math.imul(Wr, eo) | 0, Te = Te + Math.imul(Wr, Ei) | 0, Te = Te + Math.imul(ri, eo) | 0, Cr = Cr + Math.imul(ri, Ei) | 0, vr = vr + Math.imul(Vr, vi) | 0, Te = Te + Math.imul(Vr, xi) | 0, Te = Te + Math.imul(qr, vi) | 0, Cr = Cr + Math.imul(qr, xi) | 0, vr = vr + Math.imul(mn, dn) | 0, Te = Te + Math.imul(mn, xn) | 0, Te = Te + Math.imul(pi, dn) | 0, Cr = Cr + Math.imul(pi, xn) | 0;
        var we = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (we >>> 26) | 0, we &= 67108863, vr = Math.imul(Hi, rs), Te = Math.imul(Hi, ls), Te = Te + Math.imul(di, rs) | 0, Cr = Math.imul(di, ls), vr = vr + Math.imul(hn, os) | 0, Te = Te + Math.imul(hn, fs) | 0, Te = Te + Math.imul(Rn, os) | 0, Cr = Cr + Math.imul(Rn, fs) | 0, vr = vr + Math.imul(gn, Bn) | 0, Te = Te + Math.imul(gn, hi) | 0, Te = Te + Math.imul(Gn, Bn) | 0, Cr = Cr + Math.imul(Gn, hi) | 0, vr = vr + Math.imul(On, Gi) | 0, Te = Te + Math.imul(On, kn) | 0, Te = Te + Math.imul(so, Gi) | 0, Cr = Cr + Math.imul(so, kn) | 0, vr = vr + Math.imul(Er, eo) | 0, Te = Te + Math.imul(Er, Ei) | 0, Te = Te + Math.imul(Di, eo) | 0, Cr = Cr + Math.imul(Di, Ei) | 0, vr = vr + Math.imul(Wr, vi) | 0, Te = Te + Math.imul(Wr, xi) | 0, Te = Te + Math.imul(ri, vi) | 0, Cr = Cr + Math.imul(ri, xi) | 0, vr = vr + Math.imul(Vr, dn) | 0, Te = Te + Math.imul(Vr, xn) | 0, Te = Te + Math.imul(qr, dn) | 0, Cr = Cr + Math.imul(qr, xn) | 0;
        var Be = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (Be >>> 26) | 0, Be &= 67108863, vr = Math.imul(Hi, os), Te = Math.imul(Hi, fs), Te = Te + Math.imul(di, os) | 0, Cr = Math.imul(di, fs), vr = vr + Math.imul(hn, Bn) | 0, Te = Te + Math.imul(hn, hi) | 0, Te = Te + Math.imul(Rn, Bn) | 0, Cr = Cr + Math.imul(Rn, hi) | 0, vr = vr + Math.imul(gn, Gi) | 0, Te = Te + Math.imul(gn, kn) | 0, Te = Te + Math.imul(Gn, Gi) | 0, Cr = Cr + Math.imul(Gn, kn) | 0, vr = vr + Math.imul(On, eo) | 0, Te = Te + Math.imul(On, Ei) | 0, Te = Te + Math.imul(so, eo) | 0, Cr = Cr + Math.imul(so, Ei) | 0, vr = vr + Math.imul(Er, vi) | 0, Te = Te + Math.imul(Er, xi) | 0, Te = Te + Math.imul(Di, vi) | 0, Cr = Cr + Math.imul(Di, xi) | 0, vr = vr + Math.imul(Wr, dn) | 0, Te = Te + Math.imul(Wr, xn) | 0, Te = Te + Math.imul(ri, dn) | 0, Cr = Cr + Math.imul(ri, xn) | 0;
        var Me = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (Me >>> 26) | 0, Me &= 67108863, vr = Math.imul(Hi, Bn), Te = Math.imul(Hi, hi), Te = Te + Math.imul(di, Bn) | 0, Cr = Math.imul(di, hi), vr = vr + Math.imul(hn, Gi) | 0, Te = Te + Math.imul(hn, kn) | 0, Te = Te + Math.imul(Rn, Gi) | 0, Cr = Cr + Math.imul(Rn, kn) | 0, vr = vr + Math.imul(gn, eo) | 0, Te = Te + Math.imul(gn, Ei) | 0, Te = Te + Math.imul(Gn, eo) | 0, Cr = Cr + Math.imul(Gn, Ei) | 0, vr = vr + Math.imul(On, vi) | 0, Te = Te + Math.imul(On, xi) | 0, Te = Te + Math.imul(so, vi) | 0, Cr = Cr + Math.imul(so, xi) | 0, vr = vr + Math.imul(Er, dn) | 0, Te = Te + Math.imul(Er, xn) | 0, Te = Te + Math.imul(Di, dn) | 0, Cr = Cr + Math.imul(Di, xn) | 0;
        var fr = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (fr >>> 26) | 0, fr &= 67108863, vr = Math.imul(Hi, Gi), Te = Math.imul(Hi, kn), Te = Te + Math.imul(di, Gi) | 0, Cr = Math.imul(di, kn), vr = vr + Math.imul(hn, eo) | 0, Te = Te + Math.imul(hn, Ei) | 0, Te = Te + Math.imul(Rn, eo) | 0, Cr = Cr + Math.imul(Rn, Ei) | 0, vr = vr + Math.imul(gn, vi) | 0, Te = Te + Math.imul(gn, xi) | 0, Te = Te + Math.imul(Gn, vi) | 0, Cr = Cr + Math.imul(Gn, xi) | 0, vr = vr + Math.imul(On, dn) | 0, Te = Te + Math.imul(On, xn) | 0, Te = Te + Math.imul(so, dn) | 0, Cr = Cr + Math.imul(so, xn) | 0;
        var wr = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (wr >>> 26) | 0, wr &= 67108863, vr = Math.imul(Hi, eo), Te = Math.imul(Hi, Ei), Te = Te + Math.imul(di, eo) | 0, Cr = Math.imul(di, Ei), vr = vr + Math.imul(hn, vi) | 0, Te = Te + Math.imul(hn, xi) | 0, Te = Te + Math.imul(Rn, vi) | 0, Cr = Cr + Math.imul(Rn, xi) | 0, vr = vr + Math.imul(gn, dn) | 0, Te = Te + Math.imul(gn, xn) | 0, Te = Te + Math.imul(Gn, dn) | 0, Cr = Cr + Math.imul(Gn, xn) | 0;
        var dr = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (dr >>> 26) | 0, dr &= 67108863, vr = Math.imul(Hi, vi), Te = Math.imul(Hi, xi), Te = Te + Math.imul(di, vi) | 0, Cr = Math.imul(di, xi), vr = vr + Math.imul(hn, dn) | 0, Te = Te + Math.imul(hn, xn) | 0, Te = Te + Math.imul(Rn, dn) | 0, Cr = Cr + Math.imul(Rn, xn) | 0;
        var Dr = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        Or = (Cr + (Te >>> 13) | 0) + (Dr >>> 26) | 0, Dr &= 67108863, vr = Math.imul(Hi, dn), Te = Math.imul(Hi, xn), Te = Te + Math.imul(di, dn) | 0, Cr = Math.imul(di, xn);
        var Rr = (Or + vr | 0) + ((Te & 8191) << 13) | 0;
        return Or = (Cr + (Te >>> 13) | 0) + (Rr >>> 26) | 0, Rr &= 67108863, _r[0] = oi, _r[1] = Yr, _r[2] = ji, _r[3] = Cn, _r[4] = Mn, _r[5] = B, _r[6] = o, _r[7] = m, _r[8] = d, _r[9] = v, _r[10] = he, _r[11] = we, _r[12] = Be, _r[13] = Me, _r[14] = fr, _r[15] = wr, _r[16] = dr, _r[17] = Dr, _r[18] = Rr, Or !== 0 && (_r[19] = Or, rr.length++), rr;
      };
      Math.imul || (Pe = He);
      function nr(er, Ie, xe) {
        xe.negative = Ie.negative ^ er.negative, xe.length = er.length + Ie.length;
        for (var rr = 0, ar = 0, yr = 0; yr < xe.length - 1; yr++) {
          var _r = ar;
          ar = 0;
          for (var Or = rr & 67108863, vr = Math.min(yr, Ie.length - 1), Te = Math.max(0, yr - er.length + 1); Te <= vr; Te++) {
            var Cr = yr - Te, Hr = er.words[Cr] | 0, si = Ie.words[Te] | 0, ui = Hr * si, Li = ui & 67108863;
            _r = _r + (ui / 67108864 | 0) | 0, Li = Li + Or | 0, Or = Li & 67108863, _r = _r + (Li >>> 26) | 0, ar += _r >>> 26, _r &= 67108863;
          }
          xe.words[yr] = Or, rr = _r, _r = ar;
        }
        return rr !== 0 ? xe.words[yr] = rr : xe.length--, xe.strip();
      }
      function ir(er, Ie, xe) {
        var rr = new or();
        return rr.mulp(er, Ie, xe);
      }
      A.prototype.mulTo = function(Ie, xe) {
        var rr, ar = this.length + Ie.length;
        return this.length === 10 && Ie.length === 10 ? rr = Pe(this, Ie, xe) : ar < 63 ? rr = He(this, Ie, xe) : ar < 1024 ? rr = nr(this, Ie, xe) : rr = ir(this, Ie, xe), rr;
      };
      function or(er, Ie) {
        this.x = er, this.y = Ie;
      }
      or.prototype.makeRBT = function(Ie) {
        for (var xe = new Array(Ie), rr = A.prototype._countBits(Ie) - 1, ar = 0; ar < Ie; ar++)
          xe[ar] = this.revBin(ar, rr, Ie);
        return xe;
      }, or.prototype.revBin = function(Ie, xe, rr) {
        if (Ie === 0 || Ie === rr - 1) return Ie;
        for (var ar = 0, yr = 0; yr < xe; yr++)
          ar |= (Ie & 1) << xe - yr - 1, Ie >>= 1;
        return ar;
      }, or.prototype.permute = function(Ie, xe, rr, ar, yr, _r) {
        for (var Or = 0; Or < _r; Or++)
          ar[Or] = xe[Ie[Or]], yr[Or] = rr[Ie[Or]];
      }, or.prototype.transform = function(Ie, xe, rr, ar, yr, _r) {
        this.permute(_r, Ie, xe, rr, ar, yr);
        for (var Or = 1; Or < yr; Or <<= 1)
          for (var vr = Or << 1, Te = Math.cos(2 * Math.PI / vr), Cr = Math.sin(2 * Math.PI / vr), Hr = 0; Hr < yr; Hr += vr)
            for (var si = Te, ui = Cr, Li = 0; Li < Or; Li++) {
              var Qi = rr[Hr + Li], wi = ar[Hr + Li], Ji = rr[Hr + Li + Or], mn = ar[Hr + Li + Or], pi = si * Ji - ui * mn;
              mn = si * mn + ui * Ji, Ji = pi, rr[Hr + Li] = Qi + Ji, ar[Hr + Li] = wi + mn, rr[Hr + Li + Or] = Qi - Ji, ar[Hr + Li + Or] = wi - mn, Li !== vr && (pi = Te * si - Cr * ui, ui = Te * ui + Cr * si, si = pi);
            }
      }, or.prototype.guessLen13b = function(Ie, xe) {
        var rr = Math.max(xe, Ie) | 1, ar = rr & 1, yr = 0;
        for (rr = rr / 2 | 0; rr; rr = rr >>> 1)
          yr++;
        return 1 << yr + 1 + ar;
      }, or.prototype.conjugate = function(Ie, xe, rr) {
        if (!(rr <= 1))
          for (var ar = 0; ar < rr / 2; ar++) {
            var yr = Ie[ar];
            Ie[ar] = Ie[rr - ar - 1], Ie[rr - ar - 1] = yr, yr = xe[ar], xe[ar] = -xe[rr - ar - 1], xe[rr - ar - 1] = -yr;
          }
      }, or.prototype.normalize13b = function(Ie, xe) {
        for (var rr = 0, ar = 0; ar < xe / 2; ar++) {
          var yr = Math.round(Ie[2 * ar + 1] / xe) * 8192 + Math.round(Ie[2 * ar] / xe) + rr;
          Ie[ar] = yr & 67108863, yr < 67108864 ? rr = 0 : rr = yr / 67108864 | 0;
        }
        return Ie;
      }, or.prototype.convert13b = function(Ie, xe, rr, ar) {
        for (var yr = 0, _r = 0; _r < xe; _r++)
          yr = yr + (Ie[_r] | 0), rr[2 * _r] = yr & 8191, yr = yr >>> 13, rr[2 * _r + 1] = yr & 8191, yr = yr >>> 13;
        for (_r = 2 * xe; _r < ar; ++_r)
          rr[_r] = 0;
        p(yr === 0), p((yr & -8192) === 0);
      }, or.prototype.stub = function(Ie) {
        for (var xe = new Array(Ie), rr = 0; rr < Ie; rr++)
          xe[rr] = 0;
        return xe;
      }, or.prototype.mulp = function(Ie, xe, rr) {
        var ar = 2 * this.guessLen13b(Ie.length, xe.length), yr = this.makeRBT(ar), _r = this.stub(ar), Or = new Array(ar), vr = new Array(ar), Te = new Array(ar), Cr = new Array(ar), Hr = new Array(ar), si = new Array(ar), ui = rr.words;
        ui.length = ar, this.convert13b(Ie.words, Ie.length, Or, ar), this.convert13b(xe.words, xe.length, Cr, ar), this.transform(Or, _r, vr, Te, ar, yr), this.transform(Cr, _r, Hr, si, ar, yr);
        for (var Li = 0; Li < ar; Li++) {
          var Qi = vr[Li] * Hr[Li] - Te[Li] * si[Li];
          Te[Li] = vr[Li] * si[Li] + Te[Li] * Hr[Li], vr[Li] = Qi;
        }
        return this.conjugate(vr, Te, ar), this.transform(vr, Te, ui, _r, ar, yr), this.conjugate(ui, _r, ar), this.normalize13b(ui, ar), rr.negative = Ie.negative ^ xe.negative, rr.length = Ie.length + xe.length, rr.strip();
      }, A.prototype.mul = function(Ie) {
        var xe = new A(null);
        return xe.words = new Array(this.length + Ie.length), this.mulTo(Ie, xe);
      }, A.prototype.mulf = function(Ie) {
        var xe = new A(null);
        return xe.words = new Array(this.length + Ie.length), ir(this, Ie, xe);
      }, A.prototype.imul = function(Ie) {
        return this.clone().mulTo(Ie, this);
      }, A.prototype.imuln = function(Ie) {
        p(typeof Ie == "number"), p(Ie < 67108864);
        for (var xe = 0, rr = 0; rr < this.length; rr++) {
          var ar = (this.words[rr] | 0) * Ie, yr = (ar & 67108863) + (xe & 67108863);
          xe >>= 26, xe += ar / 67108864 | 0, xe += yr >>> 26, this.words[rr] = yr & 67108863;
        }
        return xe !== 0 && (this.words[rr] = xe, this.length++), this;
      }, A.prototype.muln = function(Ie) {
        return this.clone().imuln(Ie);
      }, A.prototype.sqr = function() {
        return this.mul(this);
      }, A.prototype.isqr = function() {
        return this.imul(this.clone());
      }, A.prototype.pow = function(Ie) {
        var xe = be(Ie);
        if (xe.length === 0) return new A(1);
        for (var rr = this, ar = 0; ar < xe.length && xe[ar] === 0; ar++, rr = rr.sqr())
          ;
        if (++ar < xe.length)
          for (var yr = rr.sqr(); ar < xe.length; ar++, yr = yr.sqr())
            xe[ar] !== 0 && (rr = rr.mul(yr));
        return rr;
      }, A.prototype.iushln = function(Ie) {
        p(typeof Ie == "number" && Ie >= 0);
        var xe = Ie % 26, rr = (Ie - xe) / 26, ar = 67108863 >>> 26 - xe << 26 - xe, yr;
        if (xe !== 0) {
          var _r = 0;
          for (yr = 0; yr < this.length; yr++) {
            var Or = this.words[yr] & ar, vr = (this.words[yr] | 0) - Or << xe;
            this.words[yr] = vr | _r, _r = Or >>> 26 - xe;
          }
          _r && (this.words[yr] = _r, this.length++);
        }
        if (rr !== 0) {
          for (yr = this.length - 1; yr >= 0; yr--)
            this.words[yr + rr] = this.words[yr];
          for (yr = 0; yr < rr; yr++)
            this.words[yr] = 0;
          this.length += rr;
        }
        return this.strip();
      }, A.prototype.ishln = function(Ie) {
        return p(this.negative === 0), this.iushln(Ie);
      }, A.prototype.iushrn = function(Ie, xe, rr) {
        p(typeof Ie == "number" && Ie >= 0);
        var ar;
        xe ? ar = (xe - xe % 26) / 26 : ar = 0;
        var yr = Ie % 26, _r = Math.min((Ie - yr) / 26, this.length), Or = 67108863 ^ 67108863 >>> yr << yr, vr = rr;
        if (ar -= _r, ar = Math.max(0, ar), vr) {
          for (var Te = 0; Te < _r; Te++)
            vr.words[Te] = this.words[Te];
          vr.length = _r;
        }
        if (_r !== 0) if (this.length > _r)
          for (this.length -= _r, Te = 0; Te < this.length; Te++)
            this.words[Te] = this.words[Te + _r];
        else
          this.words[0] = 0, this.length = 1;
        var Cr = 0;
        for (Te = this.length - 1; Te >= 0 && (Cr !== 0 || Te >= ar); Te--) {
          var Hr = this.words[Te] | 0;
          this.words[Te] = Cr << 26 - yr | Hr >>> yr, Cr = Hr & Or;
        }
        return vr && Cr !== 0 && (vr.words[vr.length++] = Cr), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, A.prototype.ishrn = function(Ie, xe, rr) {
        return p(this.negative === 0), this.iushrn(Ie, xe, rr);
      }, A.prototype.shln = function(Ie) {
        return this.clone().ishln(Ie);
      }, A.prototype.ushln = function(Ie) {
        return this.clone().iushln(Ie);
      }, A.prototype.shrn = function(Ie) {
        return this.clone().ishrn(Ie);
      }, A.prototype.ushrn = function(Ie) {
        return this.clone().iushrn(Ie);
      }, A.prototype.testn = function(Ie) {
        p(typeof Ie == "number" && Ie >= 0);
        var xe = Ie % 26, rr = (Ie - xe) / 26, ar = 1 << xe;
        if (this.length <= rr) return !1;
        var yr = this.words[rr];
        return !!(yr & ar);
      }, A.prototype.imaskn = function(Ie) {
        p(typeof Ie == "number" && Ie >= 0);
        var xe = Ie % 26, rr = (Ie - xe) / 26;
        if (p(this.negative === 0, "imaskn works only with positive numbers"), this.length <= rr)
          return this;
        if (xe !== 0 && rr++, this.length = Math.min(rr, this.length), xe !== 0) {
          var ar = 67108863 ^ 67108863 >>> xe << xe;
          this.words[this.length - 1] &= ar;
        }
        return this.strip();
      }, A.prototype.maskn = function(Ie) {
        return this.clone().imaskn(Ie);
      }, A.prototype.iaddn = function(Ie) {
        return p(typeof Ie == "number"), p(Ie < 67108864), Ie < 0 ? this.isubn(-Ie) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < Ie ? (this.words[0] = Ie - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(Ie), this.negative = 1, this) : this._iaddn(Ie);
      }, A.prototype._iaddn = function(Ie) {
        this.words[0] += Ie;
        for (var xe = 0; xe < this.length && this.words[xe] >= 67108864; xe++)
          this.words[xe] -= 67108864, xe === this.length - 1 ? this.words[xe + 1] = 1 : this.words[xe + 1]++;
        return this.length = Math.max(this.length, xe + 1), this;
      }, A.prototype.isubn = function(Ie) {
        if (p(typeof Ie == "number"), p(Ie < 67108864), Ie < 0) return this.iaddn(-Ie);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(Ie), this.negative = 1, this;
        if (this.words[0] -= Ie, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var xe = 0; xe < this.length && this.words[xe] < 0; xe++)
            this.words[xe] += 67108864, this.words[xe + 1] -= 1;
        return this.strip();
      }, A.prototype.addn = function(Ie) {
        return this.clone().iaddn(Ie);
      }, A.prototype.subn = function(Ie) {
        return this.clone().isubn(Ie);
      }, A.prototype.iabs = function() {
        return this.negative = 0, this;
      }, A.prototype.abs = function() {
        return this.clone().iabs();
      }, A.prototype._ishlnsubmul = function(Ie, xe, rr) {
        var ar = Ie.length + rr, yr;
        this._expand(ar);
        var _r, Or = 0;
        for (yr = 0; yr < Ie.length; yr++) {
          _r = (this.words[yr + rr] | 0) + Or;
          var vr = (Ie.words[yr] | 0) * xe;
          _r -= vr & 67108863, Or = (_r >> 26) - (vr / 67108864 | 0), this.words[yr + rr] = _r & 67108863;
        }
        for (; yr < this.length - rr; yr++)
          _r = (this.words[yr + rr] | 0) + Or, Or = _r >> 26, this.words[yr + rr] = _r & 67108863;
        if (Or === 0) return this.strip();
        for (p(Or === -1), Or = 0, yr = 0; yr < this.length; yr++)
          _r = -(this.words[yr] | 0) + Or, Or = _r >> 26, this.words[yr] = _r & 67108863;
        return this.negative = 1, this.strip();
      }, A.prototype._wordDiv = function(Ie, xe) {
        var rr = this.length - Ie.length, ar = this.clone(), yr = Ie, _r = yr.words[yr.length - 1] | 0, Or = this._countBits(_r);
        rr = 26 - Or, rr !== 0 && (yr = yr.ushln(rr), ar.iushln(rr), _r = yr.words[yr.length - 1] | 0);
        var vr = ar.length - yr.length, Te;
        if (xe !== "mod") {
          Te = new A(null), Te.length = vr + 1, Te.words = new Array(Te.length);
          for (var Cr = 0; Cr < Te.length; Cr++)
            Te.words[Cr] = 0;
        }
        var Hr = ar.clone()._ishlnsubmul(yr, 1, vr);
        Hr.negative === 0 && (ar = Hr, Te && (Te.words[vr] = 1));
        for (var si = vr - 1; si >= 0; si--) {
          var ui = (ar.words[yr.length + si] | 0) * 67108864 + (ar.words[yr.length + si - 1] | 0);
          for (ui = Math.min(ui / _r | 0, 67108863), ar._ishlnsubmul(yr, ui, si); ar.negative !== 0; )
            ui--, ar.negative = 0, ar._ishlnsubmul(yr, 1, si), ar.isZero() || (ar.negative ^= 1);
          Te && (Te.words[si] = ui);
        }
        return Te && Te.strip(), ar.strip(), xe !== "div" && rr !== 0 && ar.iushrn(rr), {
          div: Te || null,
          mod: ar
        };
      }, A.prototype.divmod = function(Ie, xe, rr) {
        if (p(!Ie.isZero()), this.isZero())
          return {
            div: new A(0),
            mod: new A(0)
          };
        var ar, yr, _r;
        return this.negative !== 0 && Ie.negative === 0 ? (_r = this.neg().divmod(Ie, xe), xe !== "mod" && (ar = _r.div.neg()), xe !== "div" && (yr = _r.mod.neg(), rr && yr.negative !== 0 && yr.iadd(Ie)), {
          div: ar,
          mod: yr
        }) : this.negative === 0 && Ie.negative !== 0 ? (_r = this.divmod(Ie.neg(), xe), xe !== "mod" && (ar = _r.div.neg()), {
          div: ar,
          mod: _r.mod
        }) : this.negative & Ie.negative ? (_r = this.neg().divmod(Ie.neg(), xe), xe !== "div" && (yr = _r.mod.neg(), rr && yr.negative !== 0 && yr.isub(Ie)), {
          div: _r.div,
          mod: yr
        }) : Ie.length > this.length || this.cmp(Ie) < 0 ? {
          div: new A(0),
          mod: this
        } : Ie.length === 1 ? xe === "div" ? {
          div: this.divn(Ie.words[0]),
          mod: null
        } : xe === "mod" ? {
          div: null,
          mod: new A(this.modn(Ie.words[0]))
        } : {
          div: this.divn(Ie.words[0]),
          mod: new A(this.modn(Ie.words[0]))
        } : this._wordDiv(Ie, xe);
      }, A.prototype.div = function(Ie) {
        return this.divmod(Ie, "div", !1).div;
      }, A.prototype.mod = function(Ie) {
        return this.divmod(Ie, "mod", !1).mod;
      }, A.prototype.umod = function(Ie) {
        return this.divmod(Ie, "mod", !0).mod;
      }, A.prototype.divRound = function(Ie) {
        var xe = this.divmod(Ie);
        if (xe.mod.isZero()) return xe.div;
        var rr = xe.div.negative !== 0 ? xe.mod.isub(Ie) : xe.mod, ar = Ie.ushrn(1), yr = Ie.andln(1), _r = rr.cmp(ar);
        return _r < 0 || yr === 1 && _r === 0 ? xe.div : xe.div.negative !== 0 ? xe.div.isubn(1) : xe.div.iaddn(1);
      }, A.prototype.modn = function(Ie) {
        p(Ie <= 67108863);
        for (var xe = (1 << 26) % Ie, rr = 0, ar = this.length - 1; ar >= 0; ar--)
          rr = (xe * rr + (this.words[ar] | 0)) % Ie;
        return rr;
      }, A.prototype.idivn = function(Ie) {
        p(Ie <= 67108863);
        for (var xe = 0, rr = this.length - 1; rr >= 0; rr--) {
          var ar = (this.words[rr] | 0) + xe * 67108864;
          this.words[rr] = ar / Ie | 0, xe = ar % Ie;
        }
        return this.strip();
      }, A.prototype.divn = function(Ie) {
        return this.clone().idivn(Ie);
      }, A.prototype.egcd = function(Ie) {
        p(Ie.negative === 0), p(!Ie.isZero());
        var xe = this, rr = Ie.clone();
        xe.negative !== 0 ? xe = xe.umod(Ie) : xe = xe.clone();
        for (var ar = new A(1), yr = new A(0), _r = new A(0), Or = new A(1), vr = 0; xe.isEven() && rr.isEven(); )
          xe.iushrn(1), rr.iushrn(1), ++vr;
        for (var Te = rr.clone(), Cr = xe.clone(); !xe.isZero(); ) {
          for (var Hr = 0, si = 1; !(xe.words[0] & si) && Hr < 26; ++Hr, si <<= 1) ;
          if (Hr > 0)
            for (xe.iushrn(Hr); Hr-- > 0; )
              (ar.isOdd() || yr.isOdd()) && (ar.iadd(Te), yr.isub(Cr)), ar.iushrn(1), yr.iushrn(1);
          for (var ui = 0, Li = 1; !(rr.words[0] & Li) && ui < 26; ++ui, Li <<= 1) ;
          if (ui > 0)
            for (rr.iushrn(ui); ui-- > 0; )
              (_r.isOdd() || Or.isOdd()) && (_r.iadd(Te), Or.isub(Cr)), _r.iushrn(1), Or.iushrn(1);
          xe.cmp(rr) >= 0 ? (xe.isub(rr), ar.isub(_r), yr.isub(Or)) : (rr.isub(xe), _r.isub(ar), Or.isub(yr));
        }
        return {
          a: _r,
          b: Or,
          gcd: rr.iushln(vr)
        };
      }, A.prototype._invmp = function(Ie) {
        p(Ie.negative === 0), p(!Ie.isZero());
        var xe = this, rr = Ie.clone();
        xe.negative !== 0 ? xe = xe.umod(Ie) : xe = xe.clone();
        for (var ar = new A(1), yr = new A(0), _r = rr.clone(); xe.cmpn(1) > 0 && rr.cmpn(1) > 0; ) {
          for (var Or = 0, vr = 1; !(xe.words[0] & vr) && Or < 26; ++Or, vr <<= 1) ;
          if (Or > 0)
            for (xe.iushrn(Or); Or-- > 0; )
              ar.isOdd() && ar.iadd(_r), ar.iushrn(1);
          for (var Te = 0, Cr = 1; !(rr.words[0] & Cr) && Te < 26; ++Te, Cr <<= 1) ;
          if (Te > 0)
            for (rr.iushrn(Te); Te-- > 0; )
              yr.isOdd() && yr.iadd(_r), yr.iushrn(1);
          xe.cmp(rr) >= 0 ? (xe.isub(rr), ar.isub(yr)) : (rr.isub(xe), yr.isub(ar));
        }
        var Hr;
        return xe.cmpn(1) === 0 ? Hr = ar : Hr = yr, Hr.cmpn(0) < 0 && Hr.iadd(Ie), Hr;
      }, A.prototype.gcd = function(Ie) {
        if (this.isZero()) return Ie.abs();
        if (Ie.isZero()) return this.abs();
        var xe = this.clone(), rr = Ie.clone();
        xe.negative = 0, rr.negative = 0;
        for (var ar = 0; xe.isEven() && rr.isEven(); ar++)
          xe.iushrn(1), rr.iushrn(1);
        do {
          for (; xe.isEven(); )
            xe.iushrn(1);
          for (; rr.isEven(); )
            rr.iushrn(1);
          var yr = xe.cmp(rr);
          if (yr < 0) {
            var _r = xe;
            xe = rr, rr = _r;
          } else if (yr === 0 || rr.cmpn(1) === 0)
            break;
          xe.isub(rr);
        } while (!0);
        return rr.iushln(ar);
      }, A.prototype.invm = function(Ie) {
        return this.egcd(Ie).a.umod(Ie);
      }, A.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, A.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, A.prototype.andln = function(Ie) {
        return this.words[0] & Ie;
      }, A.prototype.bincn = function(Ie) {
        p(typeof Ie == "number");
        var xe = Ie % 26, rr = (Ie - xe) / 26, ar = 1 << xe;
        if (this.length <= rr)
          return this._expand(rr + 1), this.words[rr] |= ar, this;
        for (var yr = ar, _r = rr; yr !== 0 && _r < this.length; _r++) {
          var Or = this.words[_r] | 0;
          Or += yr, yr = Or >>> 26, Or &= 67108863, this.words[_r] = Or;
        }
        return yr !== 0 && (this.words[_r] = yr, this.length++), this;
      }, A.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, A.prototype.cmpn = function(Ie) {
        var xe = Ie < 0;
        if (this.negative !== 0 && !xe) return -1;
        if (this.negative === 0 && xe) return 1;
        this.strip();
        var rr;
        if (this.length > 1)
          rr = 1;
        else {
          xe && (Ie = -Ie), p(Ie <= 67108863, "Number is too big");
          var ar = this.words[0] | 0;
          rr = ar === Ie ? 0 : ar < Ie ? -1 : 1;
        }
        return this.negative !== 0 ? -rr | 0 : rr;
      }, A.prototype.cmp = function(Ie) {
        if (this.negative !== 0 && Ie.negative === 0) return -1;
        if (this.negative === 0 && Ie.negative !== 0) return 1;
        var xe = this.ucmp(Ie);
        return this.negative !== 0 ? -xe | 0 : xe;
      }, A.prototype.ucmp = function(Ie) {
        if (this.length > Ie.length) return 1;
        if (this.length < Ie.length) return -1;
        for (var xe = 0, rr = this.length - 1; rr >= 0; rr--) {
          var ar = this.words[rr] | 0, yr = Ie.words[rr] | 0;
          if (ar !== yr) {
            ar < yr ? xe = -1 : ar > yr && (xe = 1);
            break;
          }
        }
        return xe;
      }, A.prototype.gtn = function(Ie) {
        return this.cmpn(Ie) === 1;
      }, A.prototype.gt = function(Ie) {
        return this.cmp(Ie) === 1;
      }, A.prototype.gten = function(Ie) {
        return this.cmpn(Ie) >= 0;
      }, A.prototype.gte = function(Ie) {
        return this.cmp(Ie) >= 0;
      }, A.prototype.ltn = function(Ie) {
        return this.cmpn(Ie) === -1;
      }, A.prototype.lt = function(Ie) {
        return this.cmp(Ie) === -1;
      }, A.prototype.lten = function(Ie) {
        return this.cmpn(Ie) <= 0;
      }, A.prototype.lte = function(Ie) {
        return this.cmp(Ie) <= 0;
      }, A.prototype.eqn = function(Ie) {
        return this.cmpn(Ie) === 0;
      }, A.prototype.eq = function(Ie) {
        return this.cmp(Ie) === 0;
      }, A.red = function(Ie) {
        return new Fe(Ie);
      }, A.prototype.toRed = function(Ie) {
        return p(!this.red, "Already a number in reduction context"), p(this.negative === 0, "red works only with positives"), Ie.convertTo(this)._forceRed(Ie);
      }, A.prototype.fromRed = function() {
        return p(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, A.prototype._forceRed = function(Ie) {
        return this.red = Ie, this;
      }, A.prototype.forceRed = function(Ie) {
        return p(!this.red, "Already a number in reduction context"), this._forceRed(Ie);
      }, A.prototype.redAdd = function(Ie) {
        return p(this.red, "redAdd works only with red numbers"), this.red.add(this, Ie);
      }, A.prototype.redIAdd = function(Ie) {
        return p(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, Ie);
      }, A.prototype.redSub = function(Ie) {
        return p(this.red, "redSub works only with red numbers"), this.red.sub(this, Ie);
      }, A.prototype.redISub = function(Ie) {
        return p(this.red, "redISub works only with red numbers"), this.red.isub(this, Ie);
      }, A.prototype.redShl = function(Ie) {
        return p(this.red, "redShl works only with red numbers"), this.red.shl(this, Ie);
      }, A.prototype.redMul = function(Ie) {
        return p(this.red, "redMul works only with red numbers"), this.red._verify2(this, Ie), this.red.mul(this, Ie);
      }, A.prototype.redIMul = function(Ie) {
        return p(this.red, "redMul works only with red numbers"), this.red._verify2(this, Ie), this.red.imul(this, Ie);
      }, A.prototype.redSqr = function() {
        return p(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, A.prototype.redISqr = function() {
        return p(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, A.prototype.redSqrt = function() {
        return p(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, A.prototype.redInvm = function() {
        return p(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, A.prototype.redNeg = function() {
        return p(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, A.prototype.redPow = function(Ie) {
        return p(this.red && !Ie.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, Ie);
      };
      var lr = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function Ir(er, Ie) {
        this.name = er, this.p = new A(Ie, 16), this.n = this.p.bitLength(), this.k = new A(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      Ir.prototype._tmp = function() {
        var Ie = new A(null);
        return Ie.words = new Array(Math.ceil(this.n / 13)), Ie;
      }, Ir.prototype.ireduce = function(Ie) {
        var xe = Ie, rr;
        do
          this.split(xe, this.tmp), xe = this.imulK(xe), xe = xe.iadd(this.tmp), rr = xe.bitLength();
        while (rr > this.n);
        var ar = rr < this.n ? -1 : xe.ucmp(this.p);
        return ar === 0 ? (xe.words[0] = 0, xe.length = 1) : ar > 0 ? xe.isub(this.p) : xe.strip !== void 0 ? xe.strip() : xe._strip(), xe;
      }, Ir.prototype.split = function(Ie, xe) {
        Ie.iushrn(this.n, 0, xe);
      }, Ir.prototype.imulK = function(Ie) {
        return Ie.imul(this.k);
      };
      function xr() {
        Ir.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      a(xr, Ir), xr.prototype.split = function(Ie, xe) {
        for (var rr = 4194303, ar = Math.min(Ie.length, 9), yr = 0; yr < ar; yr++)
          xe.words[yr] = Ie.words[yr];
        if (xe.length = ar, Ie.length <= 9) {
          Ie.words[0] = 0, Ie.length = 1;
          return;
        }
        var _r = Ie.words[9];
        for (xe.words[xe.length++] = _r & rr, yr = 10; yr < Ie.length; yr++) {
          var Or = Ie.words[yr] | 0;
          Ie.words[yr - 10] = (Or & rr) << 4 | _r >>> 22, _r = Or;
        }
        _r >>>= 22, Ie.words[yr - 10] = _r, _r === 0 && Ie.length > 10 ? Ie.length -= 10 : Ie.length -= 9;
      }, xr.prototype.imulK = function(Ie) {
        Ie.words[Ie.length] = 0, Ie.words[Ie.length + 1] = 0, Ie.length += 2;
        for (var xe = 0, rr = 0; rr < Ie.length; rr++) {
          var ar = Ie.words[rr] | 0;
          xe += ar * 977, Ie.words[rr] = xe & 67108863, xe = ar * 64 + (xe / 67108864 | 0);
        }
        return Ie.words[Ie.length - 1] === 0 && (Ie.length--, Ie.words[Ie.length - 1] === 0 && Ie.length--), Ie;
      };
      function kr() {
        Ir.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      a(kr, Ir);
      function Ce() {
        Ir.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      a(Ce, Ir);
      function tr() {
        Ir.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      a(tr, Ir), tr.prototype.imulK = function(Ie) {
        for (var xe = 0, rr = 0; rr < Ie.length; rr++) {
          var ar = (Ie.words[rr] | 0) * 19 + xe, yr = ar & 67108863;
          ar >>>= 26, Ie.words[rr] = yr, xe = ar;
        }
        return xe !== 0 && (Ie.words[Ie.length++] = xe), Ie;
      }, A._prime = function(Ie) {
        if (lr[Ie]) return lr[Ie];
        var xe;
        if (Ie === "k256")
          xe = new xr();
        else if (Ie === "p224")
          xe = new kr();
        else if (Ie === "p192")
          xe = new Ce();
        else if (Ie === "p25519")
          xe = new tr();
        else
          throw new Error("Unknown prime " + Ie);
        return lr[Ie] = xe, xe;
      };
      function Fe(er) {
        if (typeof er == "string") {
          var Ie = A._prime(er);
          this.m = Ie.p, this.prime = Ie;
        } else
          p(er.gtn(1), "modulus must be greater than 1"), this.m = er, this.prime = null;
      }
      Fe.prototype._verify1 = function(Ie) {
        p(Ie.negative === 0, "red works only with positives"), p(Ie.red, "red works only with red numbers");
      }, Fe.prototype._verify2 = function(Ie, xe) {
        p((Ie.negative | xe.negative) === 0, "red works only with positives"), p(
          Ie.red && Ie.red === xe.red,
          "red works only with red numbers"
        );
      }, Fe.prototype.imod = function(Ie) {
        return this.prime ? this.prime.ireduce(Ie)._forceRed(this) : Ie.umod(this.m)._forceRed(this);
      }, Fe.prototype.neg = function(Ie) {
        return Ie.isZero() ? Ie.clone() : this.m.sub(Ie)._forceRed(this);
      }, Fe.prototype.add = function(Ie, xe) {
        this._verify2(Ie, xe);
        var rr = Ie.add(xe);
        return rr.cmp(this.m) >= 0 && rr.isub(this.m), rr._forceRed(this);
      }, Fe.prototype.iadd = function(Ie, xe) {
        this._verify2(Ie, xe);
        var rr = Ie.iadd(xe);
        return rr.cmp(this.m) >= 0 && rr.isub(this.m), rr;
      }, Fe.prototype.sub = function(Ie, xe) {
        this._verify2(Ie, xe);
        var rr = Ie.sub(xe);
        return rr.cmpn(0) < 0 && rr.iadd(this.m), rr._forceRed(this);
      }, Fe.prototype.isub = function(Ie, xe) {
        this._verify2(Ie, xe);
        var rr = Ie.isub(xe);
        return rr.cmpn(0) < 0 && rr.iadd(this.m), rr;
      }, Fe.prototype.shl = function(Ie, xe) {
        return this._verify1(Ie), this.imod(Ie.ushln(xe));
      }, Fe.prototype.imul = function(Ie, xe) {
        return this._verify2(Ie, xe), this.imod(Ie.imul(xe));
      }, Fe.prototype.mul = function(Ie, xe) {
        return this._verify2(Ie, xe), this.imod(Ie.mul(xe));
      }, Fe.prototype.isqr = function(Ie) {
        return this.imul(Ie, Ie.clone());
      }, Fe.prototype.sqr = function(Ie) {
        return this.mul(Ie, Ie);
      }, Fe.prototype.sqrt = function(Ie) {
        if (Ie.isZero()) return Ie.clone();
        var xe = this.m.andln(3);
        if (p(xe % 2 === 1), xe === 3) {
          var rr = this.m.add(new A(1)).iushrn(2);
          return this.pow(Ie, rr);
        }
        for (var ar = this.m.subn(1), yr = 0; !ar.isZero() && ar.andln(1) === 0; )
          yr++, ar.iushrn(1);
        p(!ar.isZero());
        var _r = new A(1).toRed(this), Or = _r.redNeg(), vr = this.m.subn(1).iushrn(1), Te = this.m.bitLength();
        for (Te = new A(2 * Te * Te).toRed(this); this.pow(Te, vr).cmp(Or) !== 0; )
          Te.redIAdd(Or);
        for (var Cr = this.pow(Te, ar), Hr = this.pow(Ie, ar.addn(1).iushrn(1)), si = this.pow(Ie, ar), ui = yr; si.cmp(_r) !== 0; ) {
          for (var Li = si, Qi = 0; Li.cmp(_r) !== 0; Qi++)
            Li = Li.redSqr();
          p(Qi < ui);
          var wi = this.pow(Cr, new A(1).iushln(ui - Qi - 1));
          Hr = Hr.redMul(wi), Cr = wi.redSqr(), si = si.redMul(Cr), ui = Qi;
        }
        return Hr;
      }, Fe.prototype.invm = function(Ie) {
        var xe = Ie._invmp(this.m);
        return xe.negative !== 0 ? (xe.negative = 0, this.imod(xe).redNeg()) : this.imod(xe);
      }, Fe.prototype.pow = function(Ie, xe) {
        if (xe.isZero()) return new A(1).toRed(this);
        if (xe.cmpn(1) === 0) return Ie.clone();
        var rr = 4, ar = new Array(1 << rr);
        ar[0] = new A(1).toRed(this), ar[1] = Ie;
        for (var yr = 2; yr < ar.length; yr++)
          ar[yr] = this.mul(ar[yr - 1], Ie);
        var _r = ar[0], Or = 0, vr = 0, Te = xe.bitLength() % 26;
        for (Te === 0 && (Te = 26), yr = xe.length - 1; yr >= 0; yr--) {
          for (var Cr = xe.words[yr], Hr = Te - 1; Hr >= 0; Hr--) {
            var si = Cr >> Hr & 1;
            if (_r !== ar[0] && (_r = this.sqr(_r)), si === 0 && Or === 0) {
              vr = 0;
              continue;
            }
            Or <<= 1, Or |= si, vr++, !(vr !== rr && (yr !== 0 || Hr !== 0)) && (_r = this.mul(_r, ar[Or]), vr = 0, Or = 0);
          }
          Te = 26;
        }
        return _r;
      }, Fe.prototype.convertTo = function(Ie) {
        var xe = Ie.umod(this.m);
        return xe === Ie ? xe.clone() : xe;
      }, Fe.prototype.convertFrom = function(Ie) {
        var xe = Ie.clone();
        return xe.red = null, xe;
      }, A.mont = function(Ie) {
        return new Sr(Ie);
      };
      function Sr(er) {
        Fe.call(this, er), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new A(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      a(Sr, Fe), Sr.prototype.convertTo = function(Ie) {
        return this.imod(Ie.ushln(this.shift));
      }, Sr.prototype.convertFrom = function(Ie) {
        var xe = this.imod(Ie.mul(this.rinv));
        return xe.red = null, xe;
      }, Sr.prototype.imul = function(Ie, xe) {
        if (Ie.isZero() || xe.isZero())
          return Ie.words[0] = 0, Ie.length = 1, Ie;
        var rr = Ie.imul(xe), ar = rr.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), yr = rr.isub(ar).iushrn(this.shift), _r = yr;
        return yr.cmp(this.m) >= 0 ? _r = yr.isub(this.m) : yr.cmpn(0) < 0 && (_r = yr.iadd(this.m)), _r._forceRed(this);
      }, Sr.prototype.mul = function(Ie, xe) {
        if (Ie.isZero() || xe.isZero()) return new A(0)._forceRed(this);
        var rr = Ie.mul(xe), ar = rr.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), yr = rr.isub(ar).iushrn(this.shift), _r = yr;
        return yr.cmp(this.m) >= 0 ? _r = yr.isub(this.m) : yr.cmpn(0) < 0 && (_r = yr.iadd(this.m)), _r._forceRed(this);
      }, Sr.prototype.invm = function(Ie) {
        var xe = this.imod(Ie._invmp(this.m).mul(this.r2));
        return xe._forceRed(this);
      };
    })(n, commonjsGlobal);
  }(bn)), bn.exports;
}
var withPublic_1, hasRequiredWithPublic;
function requireWithPublic() {
  if (hasRequiredWithPublic) return withPublic_1;
  hasRequiredWithPublic = 1;
  var n = requireBn(), c = safeBufferExports.Buffer;
  function u(p, a) {
    return c.from(p.toRed(n.mont(a.modulus)).redPow(new n(a.publicExponent)).fromRed().toArray());
  }
  return withPublic_1 = u, withPublic_1;
}
var publicEncrypt, hasRequiredPublicEncrypt;
function requirePublicEncrypt() {
  if (hasRequiredPublicEncrypt) return publicEncrypt;
  hasRequiredPublicEncrypt = 1;
  var n = requireParseAsn1(), c = requireBrowser$9(), u = browser$a, p = requireMgf(), a = requireXor(), A = requireBn(), b = requireWithPublic(), F = requireBrowserifyRsa(), le = safeBufferExports.Buffer;
  publicEncrypt = function(be, He, Pe) {
    var nr;
    be.padding ? nr = be.padding : Pe ? nr = 1 : nr = 4;
    var ir = n(be), or;
    if (nr === 4)
      or = L(ir, He);
    else if (nr === 1)
      or = pe(ir, He, Pe);
    else if (nr === 3) {
      if (or = new A(He), or.cmp(ir.modulus) >= 0)
        throw new Error("data too long for modulus");
    } else
      throw new Error("unknown padding");
    return Pe ? F(or, ir) : b(or, ir);
  };
  function L(Ee, be) {
    var He = Ee.modulus.byteLength(), Pe = be.length, nr = u("sha1").update(le.alloc(0)).digest(), ir = nr.length, or = 2 * ir;
    if (Pe > He - or - 2)
      throw new Error("message too long");
    var lr = le.alloc(He - Pe - or - 2), Ir = He - ir - 1, xr = c(ir), kr = a(le.concat([nr, lr, le.alloc(1, 1), be], Ir), p(xr, Ir)), Ce = a(xr, p(kr, ir));
    return new A(le.concat([le.alloc(1), Ce, kr], He));
  }
  function pe(Ee, be, He) {
    var Pe = be.length, nr = Ee.modulus.byteLength();
    if (Pe > nr - 11)
      throw new Error("message too long");
    var ir;
    return He ? ir = le.alloc(nr - Pe - 3, 255) : ir = $(nr - Pe - 3), new A(le.concat([le.from([0, He ? 1 : 2]), ir, le.alloc(1), be], nr));
  }
  function $(Ee) {
    for (var be = le.allocUnsafe(Ee), He = 0, Pe = c(Ee * 2), nr = 0, ir; He < Ee; )
      nr === Pe.length && (Pe = c(Ee * 2), nr = 0), ir = Pe[nr++], ir && (be[He++] = ir);
    return be;
  }
  return publicEncrypt;
}
var privateDecrypt, hasRequiredPrivateDecrypt;
function requirePrivateDecrypt() {
  if (hasRequiredPrivateDecrypt) return privateDecrypt;
  hasRequiredPrivateDecrypt = 1;
  var n = requireParseAsn1(), c = requireMgf(), u = requireXor(), p = requireBn(), a = requireBrowserifyRsa(), A = browser$a, b = requireWithPublic(), F = safeBufferExports.Buffer;
  privateDecrypt = function(Ee, be, He) {
    var Pe;
    Ee.padding ? Pe = Ee.padding : He ? Pe = 1 : Pe = 4;
    var nr = n(Ee), ir = nr.modulus.byteLength();
    if (be.length > ir || new p(be).cmp(nr.modulus) >= 0)
      throw new Error("decryption error");
    var or;
    He ? or = b(new p(be), nr) : or = a(be, nr);
    var lr = F.alloc(ir - or.length);
    if (or = F.concat([lr, or], ir), Pe === 4)
      return le(nr, or);
    if (Pe === 1)
      return L(nr, or, He);
    if (Pe === 3)
      return or;
    throw new Error("unknown padding");
  };
  function le($, Ee) {
    var be = $.modulus.byteLength(), He = A("sha1").update(F.alloc(0)).digest(), Pe = He.length;
    if (Ee[0] !== 0)
      throw new Error("decryption error");
    var nr = Ee.slice(1, Pe + 1), ir = Ee.slice(Pe + 1), or = u(nr, c(ir, Pe)), lr = u(ir, c(or, be - Pe - 1));
    if (pe(He, lr.slice(0, Pe)))
      throw new Error("decryption error");
    for (var Ir = Pe; lr[Ir] === 0; )
      Ir++;
    if (lr[Ir++] !== 1)
      throw new Error("decryption error");
    return lr.slice(Ir);
  }
  function L($, Ee, be) {
    for (var He = Ee.slice(0, 2), Pe = 2, nr = 0; Ee[Pe++] !== 0; )
      if (Pe >= Ee.length) {
        nr++;
        break;
      }
    var ir = Ee.slice(2, Pe - 1);
    if ((He.toString("hex") !== "0002" && !be || He.toString("hex") !== "0001" && be) && nr++, ir.length < 8 && nr++, nr)
      throw new Error("decryption error");
    return Ee.slice(Pe);
  }
  function pe($, Ee) {
    $ = F.from($), Ee = F.from(Ee);
    var be = 0, He = $.length;
    $.length !== Ee.length && (be++, He = Math.min($.length, Ee.length));
    for (var Pe = -1; ++Pe < He; )
      be += $[Pe] ^ Ee[Pe];
    return be;
  }
  return privateDecrypt;
}
var hasRequiredBrowser$1;
function requireBrowser$1() {
  return hasRequiredBrowser$1 || (hasRequiredBrowser$1 = 1, function(n) {
    n.publicEncrypt = requirePublicEncrypt(), n.privateDecrypt = requirePrivateDecrypt(), n.privateEncrypt = function(u, p) {
      return n.publicEncrypt(u, p, !0);
    }, n.publicDecrypt = function(u, p) {
      return n.privateDecrypt(u, p, !0);
    };
  }(browser$1)), browser$1;
}
var browser = {}, hasRequiredBrowser;
function requireBrowser() {
  if (hasRequiredBrowser) return browser;
  hasRequiredBrowser = 1;
  function n() {
    throw new Error(`secure random number generation not supported by this browser
use chrome, FireFox or Internet Explorer 11`);
  }
  var c = safeBufferExports, u = requireBrowser$9(), p = c.Buffer, a = c.kMaxLength, A = commonjsGlobal.crypto || commonjsGlobal.msCrypto, b = Math.pow(2, 32) - 1;
  function F(Ee, be) {
    if (typeof Ee != "number" || Ee !== Ee)
      throw new TypeError("offset must be a number");
    if (Ee > b || Ee < 0)
      throw new TypeError("offset must be a uint32");
    if (Ee > a || Ee > be)
      throw new RangeError("offset out of range");
  }
  function le(Ee, be, He) {
    if (typeof Ee != "number" || Ee !== Ee)
      throw new TypeError("size must be a number");
    if (Ee > b || Ee < 0)
      throw new TypeError("size must be a uint32");
    if (Ee + be > He || Ee > a)
      throw new RangeError("buffer too small");
  }
  A && A.getRandomValues || !process$1.browser ? (browser.randomFill = L, browser.randomFillSync = $) : (browser.randomFill = n, browser.randomFillSync = n);
  function L(Ee, be, He, Pe) {
    if (!p.isBuffer(Ee) && !(Ee instanceof commonjsGlobal.Uint8Array))
      throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof be == "function")
      Pe = be, be = 0, He = Ee.length;
    else if (typeof He == "function")
      Pe = He, He = Ee.length - be;
    else if (typeof Pe != "function")
      throw new TypeError('"cb" argument must be a function');
    return F(be, Ee.length), le(He, be, Ee.length), pe(Ee, be, He, Pe);
  }
  function pe(Ee, be, He, Pe) {
    if (process$1.browser) {
      var nr = Ee.buffer, ir = new Uint8Array(nr, be, He);
      if (A.getRandomValues(ir), Pe) {
        process$1.nextTick(function() {
          Pe(null, Ee);
        });
        return;
      }
      return Ee;
    }
    if (Pe) {
      u(He, function(lr, Ir) {
        if (lr)
          return Pe(lr);
        Ir.copy(Ee, be), Pe(null, Ee);
      });
      return;
    }
    var or = u(He);
    return or.copy(Ee, be), Ee;
  }
  function $(Ee, be, He) {
    if (typeof be > "u" && (be = 0), !p.isBuffer(Ee) && !(Ee instanceof commonjsGlobal.Uint8Array))
      throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    return F(be, Ee.length), He === void 0 && (He = Ee.length - be), le(He, be, Ee.length), pe(Ee, be, He);
  }
  return browser;
}
var hasRequiredCryptoBrowserify;
function requireCryptoBrowserify() {
  if (hasRequiredCryptoBrowserify) return cryptoBrowserify;
  hasRequiredCryptoBrowserify = 1, cryptoBrowserify.randomBytes = cryptoBrowserify.rng = cryptoBrowserify.pseudoRandomBytes = cryptoBrowserify.prng = requireBrowser$9(), cryptoBrowserify.createHash = cryptoBrowserify.Hash = browser$a, cryptoBrowserify.createHmac = cryptoBrowserify.Hmac = requireBrowser$8();
  var n = requireAlgos(), c = Object.keys(n), u = [
    "sha1",
    "sha224",
    "sha256",
    "sha384",
    "sha512",
    "md5",
    "rmd160"
  ].concat(c);
  cryptoBrowserify.getHashes = function() {
    return u;
  };
  var p = requireBrowser$7();
  cryptoBrowserify.pbkdf2 = p.pbkdf2, cryptoBrowserify.pbkdf2Sync = p.pbkdf2Sync;
  var a = requireBrowser$5();
  cryptoBrowserify.Cipher = a.Cipher, cryptoBrowserify.createCipher = a.createCipher, cryptoBrowserify.Cipheriv = a.Cipheriv, cryptoBrowserify.createCipheriv = a.createCipheriv, cryptoBrowserify.Decipher = a.Decipher, cryptoBrowserify.createDecipher = a.createDecipher, cryptoBrowserify.Decipheriv = a.Decipheriv, cryptoBrowserify.createDecipheriv = a.createDecipheriv, cryptoBrowserify.getCiphers = a.getCiphers, cryptoBrowserify.listCiphers = a.listCiphers;
  var A = requireBrowser$4();
  cryptoBrowserify.DiffieHellmanGroup = A.DiffieHellmanGroup, cryptoBrowserify.createDiffieHellmanGroup = A.createDiffieHellmanGroup, cryptoBrowserify.getDiffieHellman = A.getDiffieHellman, cryptoBrowserify.createDiffieHellman = A.createDiffieHellman, cryptoBrowserify.DiffieHellman = A.DiffieHellman;
  var b = requireBrowser$3();
  cryptoBrowserify.createSign = b.createSign, cryptoBrowserify.Sign = b.Sign, cryptoBrowserify.createVerify = b.createVerify, cryptoBrowserify.Verify = b.Verify, cryptoBrowserify.createECDH = requireBrowser$2();
  var F = requireBrowser$1();
  cryptoBrowserify.publicEncrypt = F.publicEncrypt, cryptoBrowserify.privateEncrypt = F.privateEncrypt, cryptoBrowserify.publicDecrypt = F.publicDecrypt, cryptoBrowserify.privateDecrypt = F.privateDecrypt;
  var le = requireBrowser();
  return cryptoBrowserify.randomFill = le.randomFill, cryptoBrowserify.randomFillSync = le.randomFillSync, cryptoBrowserify.createCredentials = function() {
    throw new Error(`sorry, createCredentials is not implemented yet
we accept pull requests
https://github.com/browserify/crypto-browserify`);
  }, cryptoBrowserify.constants = {
    DH_CHECK_P_NOT_SAFE_PRIME: 2,
    DH_CHECK_P_NOT_PRIME: 1,
    DH_UNABLE_TO_CHECK_GENERATOR: 4,
    DH_NOT_SUITABLE_GENERATOR: 8,
    NPN_ENABLED: 1,
    ALPN_ENABLED: 1,
    RSA_PKCS1_PADDING: 1,
    RSA_SSLV23_PADDING: 2,
    RSA_NO_PADDING: 3,
    RSA_PKCS1_OAEP_PADDING: 4,
    RSA_X931_PADDING: 5,
    RSA_PKCS1_PSS_PADDING: 6,
    POINT_CONVERSION_COMPRESSED: 2,
    POINT_CONVERSION_UNCOMPRESSED: 4,
    POINT_CONVERSION_HYBRID: 6
  }, cryptoBrowserify;
}
var src$c, hasRequiredSrc$8;
function requireSrc$8() {
  if (hasRequiredSrc$8) return src$c;
  hasRequiredSrc$8 = 1;
  var n = safeBufferExports.Buffer;
  function c(u) {
    if (u.length >= 255)
      throw new TypeError("Alphabet too long");
    for (var p = new Uint8Array(256), a = 0; a < p.length; a++)
      p[a] = 255;
    for (var A = 0; A < u.length; A++) {
      var b = u.charAt(A), F = b.charCodeAt(0);
      if (p[F] !== 255)
        throw new TypeError(b + " is ambiguous");
      p[F] = A;
    }
    var le = u.length, L = u.charAt(0), pe = Math.log(le) / Math.log(256), $ = Math.log(256) / Math.log(le);
    function Ee(Pe) {
      if ((Array.isArray(Pe) || Pe instanceof Uint8Array) && (Pe = n.from(Pe)), !n.isBuffer(Pe))
        throw new TypeError("Expected Buffer");
      if (Pe.length === 0)
        return "";
      for (var nr = 0, ir = 0, or = 0, lr = Pe.length; or !== lr && Pe[or] === 0; )
        or++, nr++;
      for (var Ir = (lr - or) * $ + 1 >>> 0, xr = new Uint8Array(Ir); or !== lr; ) {
        for (var kr = Pe[or], Ce = 0, tr = Ir - 1; (kr !== 0 || Ce < ir) && tr !== -1; tr--, Ce++)
          kr += 256 * xr[tr] >>> 0, xr[tr] = kr % le >>> 0, kr = kr / le >>> 0;
        if (kr !== 0)
          throw new Error("Non-zero carry");
        ir = Ce, or++;
      }
      for (var Fe = Ir - ir; Fe !== Ir && xr[Fe] === 0; )
        Fe++;
      for (var Sr = L.repeat(nr); Fe < Ir; ++Fe)
        Sr += u.charAt(xr[Fe]);
      return Sr;
    }
    function be(Pe) {
      if (typeof Pe != "string")
        throw new TypeError("Expected String");
      if (Pe.length === 0)
        return n.alloc(0);
      for (var nr = 0, ir = 0, or = 0; Pe[nr] === L; )
        ir++, nr++;
      for (var lr = (Pe.length - nr) * pe + 1 >>> 0, Ir = new Uint8Array(lr); nr < Pe.length; ) {
        var xr = Pe.charCodeAt(nr);
        if (xr > 255)
          return;
        var kr = p[xr];
        if (kr === 255)
          return;
        for (var Ce = 0, tr = lr - 1; (kr !== 0 || Ce < or) && tr !== -1; tr--, Ce++)
          kr += le * Ir[tr] >>> 0, Ir[tr] = kr % 256 >>> 0, kr = kr / 256 >>> 0;
        if (kr !== 0)
          throw new Error("Non-zero carry");
        or = Ce, nr++;
      }
      for (var Fe = lr - or; Fe !== lr && Ir[Fe] === 0; )
        Fe++;
      var Sr = n.allocUnsafe(ir + (lr - Fe));
      Sr.fill(0, 0, ir);
      for (var er = ir; Fe !== lr; )
        Sr[er++] = Ir[Fe++];
      return Sr;
    }
    function He(Pe) {
      var nr = be(Pe);
      if (nr)
        return nr;
      throw new Error("Non-base" + le + " character");
    }
    return {
      encode: Ee,
      decodeUnsafe: be,
      decode: He
    };
  }
  return src$c = c, src$c;
}
var bs58$9, hasRequiredBs58$8;
function requireBs58$8() {
  if (hasRequiredBs58$8) return bs58$9;
  hasRequiredBs58$8 = 1;
  var n = requireSrc$8(), c = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
  return bs58$9 = n(c), bs58$9;
}
var base$b, hasRequiredBase$8;
function requireBase$8() {
  if (hasRequiredBase$8) return base$b;
  hasRequiredBase$8 = 1;
  var n = requireBs58$8(), c = safeBufferExports.Buffer;
  return base$b = function(u) {
    function p(F) {
      var le = u(F);
      return n.encode(c.concat([
        F,
        le
      ], F.length + 4));
    }
    function a(F) {
      var le = F.slice(0, -4), L = F.slice(-4), pe = u(le);
      if (!(L[0] ^ pe[0] | L[1] ^ pe[1] | L[2] ^ pe[2] | L[3] ^ pe[3]))
        return le;
    }
    function A(F) {
      var le = n.decodeUnsafe(F);
      if (le)
        return a(le);
    }
    function b(F) {
      var le = n.decode(F), L = a(le);
      if (!L) throw new Error("Invalid checksum");
      return L;
    }
    return {
      encode: p,
      decode: b,
      decodeUnsafe: A
    };
  }, base$b;
}
var bs58check$b, hasRequiredBs58check$8;
function requireBs58check$8() {
  if (hasRequiredBs58check$8) return bs58check$b;
  hasRequiredBs58check$8 = 1;
  var n = browser$a, c = requireBase$8();
  function u(p) {
    var a = n("sha256").update(p).digest();
    return n("sha256").update(a).digest();
  }
  return bs58check$b = c(u), bs58check$b;
}
var lib$a, hasRequiredLib$8;
function requireLib$8() {
  if (hasRequiredLib$8) return lib$a;
  hasRequiredLib$8 = 1;
  const n = {
    IMPOSSIBLE_CASE: "Impossible case. Please create issue.",
    TWEAK_ADD: "The tweak was out of range or the resulted private key is invalid",
    TWEAK_MUL: "The tweak was out of range or equal to zero",
    CONTEXT_RANDOMIZE_UNKNOW: "Unknow error on context randomization",
    SECKEY_INVALID: "Private Key is invalid",
    PUBKEY_PARSE: "Public Key could not be parsed",
    PUBKEY_SERIALIZE: "Public Key serialization error",
    PUBKEY_COMBINE: "The sum of the public keys is not valid",
    SIG_PARSE: "Signature could not be parsed",
    SIGN: "The nonce generation function failed, or the private key was invalid",
    RECOVER: "Public key could not be recover",
    ECDH: "Scalar was invalid (zero or overflow)"
  };
  function c(b, F) {
    if (!b) throw new Error(F);
  }
  function u(b, F, le) {
    if (c(F instanceof Uint8Array, `Expected ${b} to be an Uint8Array`), le !== void 0)
      if (Array.isArray(le)) {
        const L = le.join(", "), pe = `Expected ${b} to be an Uint8Array with length [${L}]`;
        c(le.includes(F.length), pe);
      } else {
        const L = `Expected ${b} to be an Uint8Array with length ${le}`;
        c(F.length === le, L);
      }
  }
  function p(b) {
    c(A(b) === "Boolean", "Expected compressed to be a Boolean");
  }
  function a(b = (le) => new Uint8Array(le), F) {
    return typeof b == "function" && (b = b(F)), u("output", b, F), b;
  }
  function A(b) {
    return Object.prototype.toString.call(b).slice(8, -1);
  }
  return lib$a = (b) => ({
    contextRandomize(F) {
      switch (c(
        F === null || F instanceof Uint8Array,
        "Expected seed to be an Uint8Array or null"
      ), F !== null && u("seed", F, 32), b.contextRandomize(F)) {
        case 1:
          throw new Error(n.CONTEXT_RANDOMIZE_UNKNOW);
      }
    },
    privateKeyVerify(F) {
      return u("private key", F, 32), b.privateKeyVerify(F) === 0;
    },
    privateKeyNegate(F) {
      switch (u("private key", F, 32), b.privateKeyNegate(F)) {
        case 0:
          return F;
        case 1:
          throw new Error(n.IMPOSSIBLE_CASE);
      }
    },
    privateKeyTweakAdd(F, le) {
      switch (u("private key", F, 32), u("tweak", le, 32), b.privateKeyTweakAdd(F, le)) {
        case 0:
          return F;
        case 1:
          throw new Error(n.TWEAK_ADD);
      }
    },
    privateKeyTweakMul(F, le) {
      switch (u("private key", F, 32), u("tweak", le, 32), b.privateKeyTweakMul(F, le)) {
        case 0:
          return F;
        case 1:
          throw new Error(n.TWEAK_MUL);
      }
    },
    publicKeyVerify(F) {
      return u("public key", F, [33, 65]), b.publicKeyVerify(F) === 0;
    },
    publicKeyCreate(F, le = !0, L) {
      switch (u("private key", F, 32), p(le), L = a(L, le ? 33 : 65), b.publicKeyCreate(L, F)) {
        case 0:
          return L;
        case 1:
          throw new Error(n.SECKEY_INVALID);
        case 2:
          throw new Error(n.PUBKEY_SERIALIZE);
      }
    },
    publicKeyConvert(F, le = !0, L) {
      switch (u("public key", F, [33, 65]), p(le), L = a(L, le ? 33 : 65), b.publicKeyConvert(L, F)) {
        case 0:
          return L;
        case 1:
          throw new Error(n.PUBKEY_PARSE);
        case 2:
          throw new Error(n.PUBKEY_SERIALIZE);
      }
    },
    publicKeyNegate(F, le = !0, L) {
      switch (u("public key", F, [33, 65]), p(le), L = a(L, le ? 33 : 65), b.publicKeyNegate(L, F)) {
        case 0:
          return L;
        case 1:
          throw new Error(n.PUBKEY_PARSE);
        case 2:
          throw new Error(n.IMPOSSIBLE_CASE);
        case 3:
          throw new Error(n.PUBKEY_SERIALIZE);
      }
    },
    publicKeyCombine(F, le = !0, L) {
      c(Array.isArray(F), "Expected public keys to be an Array"), c(F.length > 0, "Expected public keys array will have more than zero items");
      for (const pe of F)
        u("public key", pe, [33, 65]);
      switch (p(le), L = a(L, le ? 33 : 65), b.publicKeyCombine(L, F)) {
        case 0:
          return L;
        case 1:
          throw new Error(n.PUBKEY_PARSE);
        case 2:
          throw new Error(n.PUBKEY_COMBINE);
        case 3:
          throw new Error(n.PUBKEY_SERIALIZE);
      }
    },
    publicKeyTweakAdd(F, le, L = !0, pe) {
      switch (u("public key", F, [33, 65]), u("tweak", le, 32), p(L), pe = a(pe, L ? 33 : 65), b.publicKeyTweakAdd(pe, F, le)) {
        case 0:
          return pe;
        case 1:
          throw new Error(n.PUBKEY_PARSE);
        case 2:
          throw new Error(n.TWEAK_ADD);
      }
    },
    publicKeyTweakMul(F, le, L = !0, pe) {
      switch (u("public key", F, [33, 65]), u("tweak", le, 32), p(L), pe = a(pe, L ? 33 : 65), b.publicKeyTweakMul(pe, F, le)) {
        case 0:
          return pe;
        case 1:
          throw new Error(n.PUBKEY_PARSE);
        case 2:
          throw new Error(n.TWEAK_MUL);
      }
    },
    signatureNormalize(F) {
      switch (u("signature", F, 64), b.signatureNormalize(F)) {
        case 0:
          return F;
        case 1:
          throw new Error(n.SIG_PARSE);
      }
    },
    signatureExport(F, le) {
      u("signature", F, 64), le = a(le, 72);
      const L = { output: le, outputlen: 72 };
      switch (b.signatureExport(L, F)) {
        case 0:
          return le.slice(0, L.outputlen);
        case 1:
          throw new Error(n.SIG_PARSE);
        case 2:
          throw new Error(n.IMPOSSIBLE_CASE);
      }
    },
    signatureImport(F, le) {
      switch (u("signature", F), le = a(le, 64), b.signatureImport(le, F)) {
        case 0:
          return le;
        case 1:
          throw new Error(n.SIG_PARSE);
        case 2:
          throw new Error(n.IMPOSSIBLE_CASE);
      }
    },
    ecdsaSign(F, le, L = {}, pe) {
      u("message", F, 32), u("private key", le, 32), c(A(L) === "Object", "Expected options to be an Object"), L.data !== void 0 && u("options.data", L.data), L.noncefn !== void 0 && c(A(L.noncefn) === "Function", "Expected options.noncefn to be a Function"), pe = a(pe, 64);
      const $ = { signature: pe, recid: null };
      switch (b.ecdsaSign($, F, le, L.data, L.noncefn)) {
        case 0:
          return $;
        case 1:
          throw new Error(n.SIGN);
        case 2:
          throw new Error(n.IMPOSSIBLE_CASE);
      }
    },
    ecdsaVerify(F, le, L) {
      switch (u("signature", F, 64), u("message", le, 32), u("public key", L, [33, 65]), b.ecdsaVerify(F, le, L)) {
        case 0:
          return !0;
        case 3:
          return !1;
        case 1:
          throw new Error(n.SIG_PARSE);
        case 2:
          throw new Error(n.PUBKEY_PARSE);
      }
    },
    ecdsaRecover(F, le, L, pe = !0, $) {
      switch (u("signature", F, 64), c(
        A(le) === "Number" && le >= 0 && le <= 3,
        "Expected recovery id to be a Number within interval [0, 3]"
      ), u("message", L, 32), p(pe), $ = a($, pe ? 33 : 65), b.ecdsaRecover($, F, le, L)) {
        case 0:
          return $;
        case 1:
          throw new Error(n.SIG_PARSE);
        case 2:
          throw new Error(n.RECOVER);
        case 3:
          throw new Error(n.IMPOSSIBLE_CASE);
      }
    },
    ecdh(F, le, L = {}, pe) {
      switch (u("public key", F, [33, 65]), u("private key", le, 32), c(A(L) === "Object", "Expected options to be an Object"), L.data !== void 0 && u("options.data", L.data), L.hashfn !== void 0 ? (c(A(L.hashfn) === "Function", "Expected options.hashfn to be a Function"), L.xbuf !== void 0 && u("options.xbuf", L.xbuf, 32), L.ybuf !== void 0 && u("options.ybuf", L.ybuf, 32), u("output", pe)) : pe = a(pe, 32), b.ecdh(pe, F, le, L.data, L.hashfn, L.xbuf, L.ybuf)) {
        case 0:
          return pe;
        case 1:
          throw new Error(n.PUBKEY_PARSE);
        case 2:
          throw new Error(n.ECDH);
      }
    }
  }), lib$a;
}
var elliptic$1, hasRequiredElliptic$1;
function requireElliptic$1() {
  if (hasRequiredElliptic$1) return elliptic$1;
  hasRequiredElliptic$1 = 1;
  const n = requireElliptic$2().ec, c = new n("secp256k1"), u = c.curve, p = u.n.constructor;
  function a(le, L) {
    let pe = new p(L);
    if (pe.cmp(u.p) >= 0) return null;
    pe = pe.toRed(u.red);
    let $ = pe.redSqr().redIMul(pe).redIAdd(u.b).redSqrt();
    le === 3 !== $.isOdd() && ($ = $.redNeg());
    const Ee = pe.redSqr().redIMul(pe);
    return $.redSqr().redISub(Ee.redIAdd(u.b)).isZero() ? c.keyPair({ pub: { x: pe, y: $ } }) : null;
  }
  function A(le, L, pe) {
    let $ = new p(L), Ee = new p(pe);
    if ($.cmp(u.p) >= 0 || Ee.cmp(u.p) >= 0 || ($ = $.toRed(u.red), Ee = Ee.toRed(u.red), (le === 6 || le === 7) && Ee.isOdd() !== (le === 7))) return null;
    const be = $.redSqr().redIMul($);
    return Ee.redSqr().redISub(be.redIAdd(u.b)).isZero() ? c.keyPair({ pub: { x: $, y: Ee } }) : null;
  }
  function b(le) {
    const L = le[0];
    switch (L) {
      case 2:
      case 3:
        return le.length !== 33 ? null : a(L, le.subarray(1, 33));
      case 4:
      case 6:
      case 7:
        return le.length !== 65 ? null : A(L, le.subarray(1, 33), le.subarray(33, 65));
      default:
        return null;
    }
  }
  function F(le, L) {
    const pe = L.encode(null, le.length === 33);
    for (let $ = 0; $ < le.length; ++$) le[$] = pe[$];
  }
  return elliptic$1 = {
    contextRandomize() {
      return 0;
    },
    privateKeyVerify(le) {
      const L = new p(le);
      return L.cmp(u.n) < 0 && !L.isZero() ? 0 : 1;
    },
    privateKeyNegate(le) {
      const L = new p(le), pe = u.n.sub(L).umod(u.n).toArrayLike(Uint8Array, "be", 32);
      return le.set(pe), 0;
    },
    privateKeyTweakAdd(le, L) {
      const pe = new p(L);
      if (pe.cmp(u.n) >= 0 || (pe.iadd(new p(le)), pe.cmp(u.n) >= 0 && pe.isub(u.n), pe.isZero())) return 1;
      const $ = pe.toArrayLike(Uint8Array, "be", 32);
      return le.set($), 0;
    },
    privateKeyTweakMul(le, L) {
      let pe = new p(L);
      if (pe.cmp(u.n) >= 0 || pe.isZero()) return 1;
      pe.imul(new p(le)), pe.cmp(u.n) >= 0 && (pe = pe.umod(u.n));
      const $ = pe.toArrayLike(Uint8Array, "be", 32);
      return le.set($), 0;
    },
    publicKeyVerify(le) {
      return b(le) === null ? 1 : 0;
    },
    publicKeyCreate(le, L) {
      const pe = new p(L);
      if (pe.cmp(u.n) >= 0 || pe.isZero()) return 1;
      const $ = c.keyFromPrivate(L).getPublic();
      return F(le, $), 0;
    },
    publicKeyConvert(le, L) {
      const pe = b(L);
      if (pe === null) return 1;
      const $ = pe.getPublic();
      return F(le, $), 0;
    },
    publicKeyNegate(le, L) {
      const pe = b(L);
      if (pe === null) return 1;
      const $ = pe.getPublic();
      return $.y = $.y.redNeg(), F(le, $), 0;
    },
    publicKeyCombine(le, L) {
      const pe = new Array(L.length);
      for (let Ee = 0; Ee < L.length; ++Ee)
        if (pe[Ee] = b(L[Ee]), pe[Ee] === null) return 1;
      let $ = pe[0].getPublic();
      for (let Ee = 1; Ee < pe.length; ++Ee) $ = $.add(pe[Ee].pub);
      return $.isInfinity() ? 2 : (F(le, $), 0);
    },
    publicKeyTweakAdd(le, L, pe) {
      const $ = b(L);
      if ($ === null) return 1;
      if (pe = new p(pe), pe.cmp(u.n) >= 0) return 2;
      const Ee = $.getPublic().add(u.g.mul(pe));
      return Ee.isInfinity() ? 2 : (F(le, Ee), 0);
    },
    publicKeyTweakMul(le, L, pe) {
      const $ = b(L);
      if ($ === null) return 1;
      if (pe = new p(pe), pe.cmp(u.n) >= 0 || pe.isZero()) return 2;
      const Ee = $.getPublic().mul(pe);
      return F(le, Ee), 0;
    },
    signatureNormalize(le) {
      const L = new p(le.subarray(0, 32)), pe = new p(le.subarray(32, 64));
      return L.cmp(u.n) >= 0 || pe.cmp(u.n) >= 0 ? 1 : (pe.cmp(c.nh) === 1 && le.set(u.n.sub(pe).toArrayLike(Uint8Array, "be", 32), 32), 0);
    },
    // Copied 1-to-1 from https://github.com/bitcoinjs/bip66/blob/master/index.js
    // Adapted for Uint8Array instead Buffer
    signatureExport(le, L) {
      const pe = L.subarray(0, 32), $ = L.subarray(32, 64);
      if (new p(pe).cmp(u.n) >= 0 || new p($).cmp(u.n) >= 0) return 1;
      const { output: Ee } = le;
      let be = Ee.subarray(4, 37);
      be[0] = 0, be.set(pe, 1);
      let He = 33, Pe = 0;
      for (; He > 1 && be[Pe] === 0 && !(be[Pe + 1] & 128); --He, ++Pe) ;
      if (be = be.subarray(Pe), be[0] & 128 || He > 1 && be[0] === 0 && !(be[1] & 128)) return 1;
      let nr = Ee.subarray(39, 72);
      nr[0] = 0, nr.set($, 1);
      let ir = 33, or = 0;
      for (; ir > 1 && nr[or] === 0 && !(nr[or + 1] & 128); --ir, ++or) ;
      return nr = nr.subarray(or), nr[0] & 128 || ir > 1 && nr[0] === 0 && !(nr[1] & 128) ? 1 : (le.outputlen = 6 + He + ir, Ee[0] = 48, Ee[1] = le.outputlen - 2, Ee[2] = 2, Ee[3] = be.length, Ee.set(be, 4), Ee[4 + He] = 2, Ee[5 + He] = nr.length, Ee.set(nr, 6 + He), 0);
    },
    // Copied 1-to-1 from https://github.com/bitcoinjs/bip66/blob/master/index.js
    // Adapted for Uint8Array instead Buffer
    signatureImport(le, L) {
      if (L.length < 8 || L.length > 72 || L[0] !== 48 || L[1] !== L.length - 2 || L[2] !== 2) return 1;
      const pe = L[3];
      if (pe === 0 || 5 + pe >= L.length || L[4 + pe] !== 2) return 1;
      const $ = L[5 + pe];
      if ($ === 0 || 6 + pe + $ !== L.length || L[4] & 128 || pe > 1 && L[4] === 0 && !(L[5] & 128) || L[pe + 6] & 128 || $ > 1 && L[pe + 6] === 0 && !(L[pe + 7] & 128)) return 1;
      let Ee = L.subarray(4, 4 + pe);
      if (Ee.length === 33 && Ee[0] === 0 && (Ee = Ee.subarray(1)), Ee.length > 32) return 1;
      let be = L.subarray(6 + pe);
      if (be.length === 33 && be[0] === 0 && (be = be.slice(1)), be.length > 32) throw new Error("S length is too long");
      let He = new p(Ee);
      He.cmp(u.n) >= 0 && (He = new p(0));
      let Pe = new p(L.subarray(6 + pe));
      return Pe.cmp(u.n) >= 0 && (Pe = new p(0)), le.set(He.toArrayLike(Uint8Array, "be", 32), 0), le.set(Pe.toArrayLike(Uint8Array, "be", 32), 32), 0;
    },
    ecdsaSign(le, L, pe, $, Ee) {
      if (Ee) {
        const Pe = Ee;
        Ee = (nr) => {
          const ir = Pe(L, pe, null, $, nr);
          if (!(ir instanceof Uint8Array && ir.length === 32)) throw new Error("This is the way");
          return new p(ir);
        };
      }
      const be = new p(pe);
      if (be.cmp(u.n) >= 0 || be.isZero()) return 1;
      let He;
      try {
        He = c.sign(L, pe, { canonical: !0, k: Ee, pers: $ });
      } catch {
        return 1;
      }
      return le.signature.set(He.r.toArrayLike(Uint8Array, "be", 32), 0), le.signature.set(He.s.toArrayLike(Uint8Array, "be", 32), 32), le.recid = He.recoveryParam, 0;
    },
    ecdsaVerify(le, L, pe) {
      const $ = { r: le.subarray(0, 32), s: le.subarray(32, 64) }, Ee = new p($.r), be = new p($.s);
      if (Ee.cmp(u.n) >= 0 || be.cmp(u.n) >= 0) return 1;
      if (be.cmp(c.nh) === 1 || Ee.isZero() || be.isZero()) return 3;
      const He = b(pe);
      if (He === null) return 2;
      const Pe = He.getPublic();
      return c.verify(L, $, Pe) ? 0 : 3;
    },
    ecdsaRecover(le, L, pe, $) {
      const Ee = { r: L.slice(0, 32), s: L.slice(32, 64) }, be = new p(Ee.r), He = new p(Ee.s);
      if (be.cmp(u.n) >= 0 || He.cmp(u.n) >= 0) return 1;
      if (be.isZero() || He.isZero()) return 2;
      let Pe;
      try {
        Pe = c.recoverPubKey($, Ee, pe);
      } catch {
        return 2;
      }
      return F(le, Pe), 0;
    },
    ecdh(le, L, pe, $, Ee, be, He) {
      const Pe = b(L);
      if (Pe === null) return 1;
      const nr = new p(pe);
      if (nr.cmp(u.n) >= 0 || nr.isZero()) return 2;
      const ir = Pe.getPublic().mul(nr);
      if (Ee === void 0) {
        const or = ir.encode(null, !0), lr = c.hash().update(or).digest();
        for (let Ir = 0; Ir < 32; ++Ir) le[Ir] = lr[Ir];
      } else {
        be || (be = new Uint8Array(32));
        const or = ir.getX().toArray("be", 32);
        for (let kr = 0; kr < 32; ++kr) be[kr] = or[kr];
        He || (He = new Uint8Array(32));
        const lr = ir.getY().toArray("be", 32);
        for (let kr = 0; kr < 32; ++kr) He[kr] = lr[kr];
        const Ir = Ee(be, He, $);
        if (!(Ir instanceof Uint8Array && Ir.length === le.length)) return 2;
        le.set(Ir);
      }
      return 0;
    }
  }, elliptic$1;
}
var elliptic, hasRequiredElliptic;
function requireElliptic() {
  return hasRequiredElliptic || (hasRequiredElliptic = 1, elliptic = requireLib$8()(requireElliptic$1())), elliptic;
}
var hdkey, hasRequiredHdkey;
function requireHdkey() {
  if (hasRequiredHdkey) return hdkey;
  hasRequiredHdkey = 1;
  var n = requireAssert(), c = safeBufferExports.Buffer, u = requireCryptoBrowserify(), p = requireBs58check$8(), a = ripemd160$5, A = requireElliptic(), b = c.from("Bitcoin seed", "utf8"), F = 2147483648, le = 78, L = { private: 76066276, public: 76067358 };
  function pe(He) {
    this.versions = He || L, this.depth = 0, this.index = 0, this._privateKey = null, this._publicKey = null, this.chainCode = null, this._fingerprint = 0, this.parentFingerprint = 0;
  }
  Object.defineProperty(pe.prototype, "fingerprint", { get: function() {
    return this._fingerprint;
  } }), Object.defineProperty(pe.prototype, "identifier", { get: function() {
    return this._identifier;
  } }), Object.defineProperty(pe.prototype, "pubKeyHash", { get: function() {
    return this.identifier;
  } }), Object.defineProperty(pe.prototype, "privateKey", {
    get: function() {
      return this._privateKey;
    },
    set: function(He) {
      n.equal(He.length, 32, "Private key must be 32 bytes."), n(A.privateKeyVerify(He) === !0, "Invalid private key"), this._privateKey = He, this._publicKey = c.from(A.publicKeyCreate(He, !0)), this._identifier = be(this.publicKey), this._fingerprint = this._identifier.slice(0, 4).readUInt32BE(0);
    }
  });
  function $(He, Pe) {
    He._publicKey = c.from(Pe), He._identifier = be(Pe), He._fingerprint = He._identifier.slice(0, 4).readUInt32BE(0), He._privateKey = null;
  }
  Object.defineProperty(pe.prototype, "publicKey", {
    get: function() {
      return this._publicKey;
    },
    set: function(He) {
      n(He.length === 33 || He.length === 65, "Public key must be 33 or 65 bytes."), n(A.publicKeyVerify(He) === !0, "Invalid public key");
      const Pe = He.length === 65 ? A.publicKeyConvert(He, !0) : He;
      $(this, Pe);
    }
  }), Object.defineProperty(pe.prototype, "privateExtendedKey", {
    get: function() {
      return this._privateKey ? p.encode(Ee(this, this.versions.private, c.concat([c.alloc(1, 0), this.privateKey]))) : null;
    }
  }), Object.defineProperty(pe.prototype, "publicExtendedKey", {
    get: function() {
      return p.encode(Ee(this, this.versions.public, this.publicKey));
    }
  }), pe.prototype.derive = function(He) {
    if (He === "m" || He === "M" || He === "m'" || He === "M'")
      return this;
    var Pe = He.split("/"), nr = this;
    return Pe.forEach(function(ir, or) {
      if (or === 0) {
        n(/^[mM]{1}/.test(ir), 'Path must start with "m" or "M"');
        return;
      }
      var lr = ir.length > 1 && ir[ir.length - 1] === "'", Ir = parseInt(ir, 10);
      n(Ir < F, "Invalid index"), lr && (Ir += F), nr = nr.deriveChild(Ir);
    }), nr;
  }, pe.prototype.deriveChild = function(He) {
    var Pe = He >= F, nr = c.allocUnsafe(4);
    nr.writeUInt32BE(He, 0);
    var ir;
    if (Pe) {
      n(this.privateKey, "Could not derive hardened child key");
      var or = this.privateKey, lr = c.alloc(1, 0);
      or = c.concat([lr, or]), ir = c.concat([or, nr]);
    } else
      ir = c.concat([this.publicKey, nr]);
    var Ir = u.createHmac("sha512", this.chainCode).update(ir).digest(), xr = Ir.slice(0, 32), kr = Ir.slice(32), Ce = new pe(this.versions);
    if (this.privateKey)
      try {
        Ce.privateKey = c.from(A.privateKeyTweakAdd(c.from(this.privateKey), xr));
      } catch {
        return this.deriveChild(He + 1);
      }
    else
      try {
        Ce.publicKey = c.from(A.publicKeyTweakAdd(c.from(this.publicKey), xr, !0));
      } catch {
        return this.deriveChild(He + 1);
      }
    return Ce.chainCode = kr, Ce.depth = this.depth + 1, Ce.parentFingerprint = this.fingerprint, Ce.index = He, Ce;
  }, pe.prototype.sign = function(He) {
    return c.from(A.ecdsaSign(Uint8Array.from(He), Uint8Array.from(this.privateKey)).signature);
  }, pe.prototype.verify = function(He, Pe) {
    return A.ecdsaVerify(
      Uint8Array.from(Pe),
      Uint8Array.from(He),
      Uint8Array.from(this.publicKey)
    );
  }, pe.prototype.wipePrivateData = function() {
    return this._privateKey && u.randomBytes(this._privateKey.length).copy(this._privateKey), this._privateKey = null, this;
  }, pe.prototype.toJSON = function() {
    return {
      xpriv: this.privateExtendedKey,
      xpub: this.publicExtendedKey
    };
  }, pe.fromMasterSeed = function(He, Pe) {
    var nr = u.createHmac("sha512", b).update(He).digest(), ir = nr.slice(0, 32), or = nr.slice(32), lr = new pe(Pe);
    return lr.chainCode = or, lr.privateKey = ir, lr;
  }, pe.fromExtendedKey = function(He, Pe, nr) {
    Pe = Pe || L, nr = nr || !1;
    var ir = new pe(Pe), or = p.decode(He), lr = or.readUInt32BE(0);
    n(lr === Pe.private || lr === Pe.public, "Version mismatch: does not match private or public"), ir.depth = or.readUInt8(4), ir.parentFingerprint = or.readUInt32BE(5), ir.index = or.readUInt32BE(9), ir.chainCode = or.slice(13, 45);
    var Ir = or.slice(45);
    return Ir.readUInt8(0) === 0 ? (n(lr === Pe.private, "Version mismatch: version does not match private"), ir.privateKey = Ir.slice(1)) : (n(lr === Pe.public, "Version mismatch: version does not match public"), nr ? $(ir, Ir) : ir.publicKey = Ir), ir;
  }, pe.fromJSON = function(He) {
    return pe.fromExtendedKey(He.xpriv);
  };
  function Ee(He, Pe, nr) {
    var ir = c.allocUnsafe(le);
    ir.writeUInt32BE(Pe, 0), ir.writeUInt8(He.depth, 4);
    var or = He.depth ? He.parentFingerprint : 0;
    return ir.writeUInt32BE(or, 5), ir.writeUInt32BE(He.index, 9), He.chainCode.copy(ir, 13), nr.copy(ir, 45), ir;
  }
  function be(He) {
    var Pe = u.createHash("sha256").update(He).digest();
    return new a().update(Pe).digest();
  }
  return pe.HARDENED_OFFSET = F, hdkey = pe, hdkey;
}
var cjs$3 = {}, constants$6 = {}, secp256k1$8 = {};
function number$5(n) {
  if (!Number.isSafeInteger(n) || n < 0)
    throw new Error(`positive integer expected, not ${n}`);
}
function isBytes$b(n) {
  return n instanceof Uint8Array || n != null && typeof n == "object" && n.constructor.name === "Uint8Array";
}
function bytes$9(n, ...c) {
  if (!isBytes$b(n))
    throw new Error("Uint8Array expected");
  if (c.length > 0 && !c.includes(n.length))
    throw new Error(`Uint8Array expected of length ${c}, not of length=${n.length}`);
}
function hash$7(n) {
  if (typeof n != "function" || typeof n.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  number$5(n.outputLen), number$5(n.blockLen);
}
function exists$5(n, c = !0) {
  if (n.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (c && n.finished)
    throw new Error("Hash#digest() has already been called");
}
function output$5(n, c) {
  bytes$9(n);
  const u = c.outputLen;
  if (n.length < u)
    throw new Error(`digestInto() expects output buffer of length at least ${u}`);
}
const crypto$6 = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0;
const createView$7 = (n) => new DataView(n.buffer, n.byteOffset, n.byteLength), rotr$6 = (n, c) => n << 32 - c | n >>> c;
new Uint8Array(new Uint32Array([287454020]).buffer)[0];
function utf8ToBytes$8(n) {
  if (typeof n != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof n}`);
  return new Uint8Array(new TextEncoder().encode(n));
}
function toBytes$8(n) {
  return typeof n == "string" && (n = utf8ToBytes$8(n)), bytes$9(n), n;
}
function concatBytes$7(...n) {
  let c = 0;
  for (let p = 0; p < n.length; p++) {
    const a = n[p];
    bytes$9(a), c += a.length;
  }
  const u = new Uint8Array(c);
  for (let p = 0, a = 0; p < n.length; p++) {
    const A = n[p];
    u.set(A, a), a += A.length;
  }
  return u;
}
let Hash$7 = class {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
};
function wrapConstructor$5(n) {
  const c = (p) => n().update(toBytes$8(p)).digest(), u = n();
  return c.outputLen = u.outputLen, c.blockLen = u.blockLen, c.create = () => n(), c;
}
function randomBytes$2(n = 32) {
  if (crypto$6 && typeof crypto$6.getRandomValues == "function")
    return crypto$6.getRandomValues(new Uint8Array(n));
  throw new Error("crypto.getRandomValues must be defined");
}
function setBigUint64$6(n, c, u, p) {
  if (typeof n.setBigUint64 == "function")
    return n.setBigUint64(c, u, p);
  const a = BigInt(32), A = BigInt(4294967295), b = Number(u >> a & A), F = Number(u & A), le = p ? 4 : 0, L = p ? 0 : 4;
  n.setUint32(c + le, b, p), n.setUint32(c + L, F, p);
}
const Chi$6 = (n, c, u) => n & c ^ ~n & u, Maj$6 = (n, c, u) => n & c ^ n & u ^ c & u;
let HashMD$2 = class extends Hash$7 {
  constructor(c, u, p, a) {
    super(), this.blockLen = c, this.outputLen = u, this.padOffset = p, this.isLE = a, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(c), this.view = createView$7(this.buffer);
  }
  update(c) {
    exists$5(this);
    const { view: u, buffer: p, blockLen: a } = this;
    c = toBytes$8(c);
    const A = c.length;
    for (let b = 0; b < A; ) {
      const F = Math.min(a - this.pos, A - b);
      if (F === a) {
        const le = createView$7(c);
        for (; a <= A - b; b += a)
          this.process(le, b);
        continue;
      }
      p.set(c.subarray(b, b + F), this.pos), this.pos += F, b += F, this.pos === a && (this.process(u, 0), this.pos = 0);
    }
    return this.length += c.length, this.roundClean(), this;
  }
  digestInto(c) {
    exists$5(this), output$5(c, this), this.finished = !0;
    const { buffer: u, view: p, blockLen: a, isLE: A } = this;
    let { pos: b } = this;
    u[b++] = 128, this.buffer.subarray(b).fill(0), this.padOffset > a - b && (this.process(p, 0), b = 0);
    for (let $ = b; $ < a; $++)
      u[$] = 0;
    setBigUint64$6(p, a - 8, BigInt(this.length * 8), A), this.process(p, 0);
    const F = createView$7(c), le = this.outputLen;
    if (le % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const L = le / 4, pe = this.get();
    if (L > pe.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let $ = 0; $ < L; $++)
      F.setUint32(4 * $, pe[$], A);
  }
  digest() {
    const { buffer: c, outputLen: u } = this;
    this.digestInto(c);
    const p = c.slice(0, u);
    return this.destroy(), p;
  }
  _cloneInto(c) {
    c || (c = new this.constructor()), c.set(...this.get());
    const { blockLen: u, buffer: p, length: a, finished: A, destroyed: b, pos: F } = this;
    return c.length = a, c.pos = F, c.finished = A, c.destroyed = b, a % u && c.buffer.set(p), c;
  }
};
const SHA256_K$6 = /* @__PURE__ */ new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), SHA256_IV$2 = /* @__PURE__ */ new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), SHA256_W$6 = /* @__PURE__ */ new Uint32Array(64);
let SHA256$6 = class extends HashMD$2 {
  constructor() {
    super(64, 32, 8, !1), this.A = SHA256_IV$2[0] | 0, this.B = SHA256_IV$2[1] | 0, this.C = SHA256_IV$2[2] | 0, this.D = SHA256_IV$2[3] | 0, this.E = SHA256_IV$2[4] | 0, this.F = SHA256_IV$2[5] | 0, this.G = SHA256_IV$2[6] | 0, this.H = SHA256_IV$2[7] | 0;
  }
  get() {
    const { A: c, B: u, C: p, D: a, E: A, F: b, G: F, H: le } = this;
    return [c, u, p, a, A, b, F, le];
  }
  // prettier-ignore
  set(c, u, p, a, A, b, F, le) {
    this.A = c | 0, this.B = u | 0, this.C = p | 0, this.D = a | 0, this.E = A | 0, this.F = b | 0, this.G = F | 0, this.H = le | 0;
  }
  process(c, u) {
    for (let $ = 0; $ < 16; $++, u += 4)
      SHA256_W$6[$] = c.getUint32(u, !1);
    for (let $ = 16; $ < 64; $++) {
      const Ee = SHA256_W$6[$ - 15], be = SHA256_W$6[$ - 2], He = rotr$6(Ee, 7) ^ rotr$6(Ee, 18) ^ Ee >>> 3, Pe = rotr$6(be, 17) ^ rotr$6(be, 19) ^ be >>> 10;
      SHA256_W$6[$] = Pe + SHA256_W$6[$ - 7] + He + SHA256_W$6[$ - 16] | 0;
    }
    let { A: p, B: a, C: A, D: b, E: F, F: le, G: L, H: pe } = this;
    for (let $ = 0; $ < 64; $++) {
      const Ee = rotr$6(F, 6) ^ rotr$6(F, 11) ^ rotr$6(F, 25), be = pe + Ee + Chi$6(F, le, L) + SHA256_K$6[$] + SHA256_W$6[$] | 0, Pe = (rotr$6(p, 2) ^ rotr$6(p, 13) ^ rotr$6(p, 22)) + Maj$6(p, a, A) | 0;
      pe = L, L = le, le = F, F = b + be | 0, b = A, A = a, a = p, p = be + Pe | 0;
    }
    p = p + this.A | 0, a = a + this.B | 0, A = A + this.C | 0, b = b + this.D | 0, F = F + this.E | 0, le = le + this.F | 0, L = L + this.G | 0, pe = pe + this.H | 0, this.set(p, a, A, b, F, le, L, pe);
  }
  roundClean() {
    SHA256_W$6.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
};
const sha256$b = /* @__PURE__ */ wrapConstructor$5(() => new SHA256$6());
let HMAC$3 = class extends Hash$7 {
  constructor(c, u) {
    super(), this.finished = !1, this.destroyed = !1, hash$7(c);
    const p = toBytes$8(u);
    if (this.iHash = c.create(), typeof this.iHash.update != "function")
      throw new Error("Expected instance of class which extends utils.Hash");
    this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
    const a = this.blockLen, A = new Uint8Array(a);
    A.set(p.length > a ? c.create().update(p).digest() : p);
    for (let b = 0; b < A.length; b++)
      A[b] ^= 54;
    this.iHash.update(A), this.oHash = c.create();
    for (let b = 0; b < A.length; b++)
      A[b] ^= 106;
    this.oHash.update(A), A.fill(0);
  }
  update(c) {
    return exists$5(this), this.iHash.update(c), this;
  }
  digestInto(c) {
    exists$5(this), bytes$9(c, this.outputLen), this.finished = !0, this.iHash.digestInto(c), this.oHash.update(c), this.oHash.digestInto(c), this.destroy();
  }
  digest() {
    const c = new Uint8Array(this.oHash.outputLen);
    return this.digestInto(c), c;
  }
  _cloneInto(c) {
    c || (c = Object.create(Object.getPrototypeOf(this), {}));
    const { oHash: u, iHash: p, finished: a, destroyed: A, blockLen: b, outputLen: F } = this;
    return c = c, c.finished = a, c.destroyed = A, c.blockLen = b, c.outputLen = F, c.oHash = u._cloneInto(c.oHash), c.iHash = p._cloneInto(c.iHash), c;
  }
  destroy() {
    this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
  }
};
const hmac$4 = (n, c, u) => new HMAC$3(n, c).update(u).digest();
hmac$4.create = (n, c) => new HMAC$3(n, c);
const _0n$j = /* @__PURE__ */ BigInt(0), _1n$g = /* @__PURE__ */ BigInt(1), _2n$b = /* @__PURE__ */ BigInt(2);
function isBytes$a(n) {
  return n instanceof Uint8Array || n != null && typeof n == "object" && n.constructor.name === "Uint8Array";
}
function abytes$4(n) {
  if (!isBytes$a(n))
    throw new Error("Uint8Array expected");
}
const hexes$3 = /* @__PURE__ */ Array.from({ length: 256 }, (n, c) => c.toString(16).padStart(2, "0"));
function bytesToHex$5(n) {
  abytes$4(n);
  let c = "";
  for (let u = 0; u < n.length; u++)
    c += hexes$3[n[u]];
  return c;
}
function numberToHexUnpadded$2(n) {
  const c = n.toString(16);
  return c.length & 1 ? `0${c}` : c;
}
function hexToNumber$2(n) {
  if (typeof n != "string")
    throw new Error("hex string expected, got " + typeof n);
  return BigInt(n === "" ? "0" : `0x${n}`);
}
const asciis$2 = { _0: 48, _9: 57, _A: 65, _F: 70, _a: 97, _f: 102 };
function asciiToBase16$2(n) {
  if (n >= asciis$2._0 && n <= asciis$2._9)
    return n - asciis$2._0;
  if (n >= asciis$2._A && n <= asciis$2._F)
    return n - (asciis$2._A - 10);
  if (n >= asciis$2._a && n <= asciis$2._f)
    return n - (asciis$2._a - 10);
}
function hexToBytes$5(n) {
  if (typeof n != "string")
    throw new Error("hex string expected, got " + typeof n);
  const c = n.length, u = c / 2;
  if (c % 2)
    throw new Error("padded hex string expected, got unpadded hex of length " + c);
  const p = new Uint8Array(u);
  for (let a = 0, A = 0; a < u; a++, A += 2) {
    const b = asciiToBase16$2(n.charCodeAt(A)), F = asciiToBase16$2(n.charCodeAt(A + 1));
    if (b === void 0 || F === void 0) {
      const le = n[A] + n[A + 1];
      throw new Error('hex string expected, got non-hex character "' + le + '" at index ' + A);
    }
    p[a] = b * 16 + F;
  }
  return p;
}
function bytesToNumberBE$2(n) {
  return hexToNumber$2(bytesToHex$5(n));
}
function bytesToNumberLE$2(n) {
  return abytes$4(n), hexToNumber$2(bytesToHex$5(Uint8Array.from(n).reverse()));
}
function numberToBytesBE$2(n, c) {
  return hexToBytes$5(n.toString(16).padStart(c * 2, "0"));
}
function numberToBytesLE$2(n, c) {
  return numberToBytesBE$2(n, c).reverse();
}
function numberToVarBytesBE$1(n) {
  return hexToBytes$5(numberToHexUnpadded$2(n));
}
function ensureBytes$2(n, c, u) {
  let p;
  if (typeof c == "string")
    try {
      p = hexToBytes$5(c);
    } catch (A) {
      throw new Error(`${n} must be valid hex string, got "${c}". Cause: ${A}`);
    }
  else if (isBytes$a(c))
    p = Uint8Array.from(c);
  else
    throw new Error(`${n} must be hex string or Uint8Array`);
  const a = p.length;
  if (typeof u == "number" && a !== u)
    throw new Error(`${n} expected ${u} bytes, got ${a}`);
  return p;
}
function concatBytes$6(...n) {
  let c = 0;
  for (let p = 0; p < n.length; p++) {
    const a = n[p];
    abytes$4(a), c += a.length;
  }
  const u = new Uint8Array(c);
  for (let p = 0, a = 0; p < n.length; p++) {
    const A = n[p];
    u.set(A, a), a += A.length;
  }
  return u;
}
function equalBytes$3(n, c) {
  if (n.length !== c.length)
    return !1;
  let u = 0;
  for (let p = 0; p < n.length; p++)
    u |= n[p] ^ c[p];
  return u === 0;
}
function utf8ToBytes$7(n) {
  if (typeof n != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof n}`);
  return new Uint8Array(new TextEncoder().encode(n));
}
function bitLen$2(n) {
  let c;
  for (c = 0; n > _0n$j; n >>= _1n$g, c += 1)
    ;
  return c;
}
function bitGet$1(n, c) {
  return n >> BigInt(c) & _1n$g;
}
function bitSet$1(n, c, u) {
  return n | (u ? _1n$g : _0n$j) << BigInt(c);
}
const bitMask$2 = (n) => (_2n$b << BigInt(n - 1)) - _1n$g, u8n$2 = (n) => new Uint8Array(n), u8fr$2 = (n) => Uint8Array.from(n);
function createHmacDrbg$2(n, c, u) {
  if (typeof n != "number" || n < 2)
    throw new Error("hashLen must be a number");
  if (typeof c != "number" || c < 2)
    throw new Error("qByteLen must be a number");
  if (typeof u != "function")
    throw new Error("hmacFn must be a function");
  let p = u8n$2(n), a = u8n$2(n), A = 0;
  const b = () => {
    p.fill(1), a.fill(0), A = 0;
  }, F = (...$) => u(a, p, ...$), le = ($ = u8n$2()) => {
    a = F(u8fr$2([0]), $), p = F(), $.length !== 0 && (a = F(u8fr$2([1]), $), p = F());
  }, L = () => {
    if (A++ >= 1e3)
      throw new Error("drbg: tried 1000 values");
    let $ = 0;
    const Ee = [];
    for (; $ < c; ) {
      p = F();
      const be = p.slice();
      Ee.push(be), $ += p.length;
    }
    return concatBytes$6(...Ee);
  };
  return ($, Ee) => {
    b(), le($);
    let be;
    for (; !(be = Ee(L())); )
      le();
    return b(), be;
  };
}
const validatorFns$2 = {
  bigint: (n) => typeof n == "bigint",
  function: (n) => typeof n == "function",
  boolean: (n) => typeof n == "boolean",
  string: (n) => typeof n == "string",
  stringOrUint8Array: (n) => typeof n == "string" || isBytes$a(n),
  isSafeInteger: (n) => Number.isSafeInteger(n),
  array: (n) => Array.isArray(n),
  field: (n, c) => c.Fp.isValid(n),
  hash: (n) => typeof n == "function" && Number.isSafeInteger(n.outputLen)
};
function validateObject$2(n, c, u = {}) {
  const p = (a, A, b) => {
    const F = validatorFns$2[A];
    if (typeof F != "function")
      throw new Error(`Invalid validator "${A}", expected function`);
    const le = n[a];
    if (!(b && le === void 0) && !F(le, n))
      throw new Error(`Invalid param ${String(a)}=${le} (${typeof le}), expected ${A}`);
  };
  for (const [a, A] of Object.entries(c))
    p(a, A, !1);
  for (const [a, A] of Object.entries(u))
    p(a, A, !0);
  return n;
}
const ut$2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  abytes: abytes$4,
  bitGet: bitGet$1,
  bitLen: bitLen$2,
  bitMask: bitMask$2,
  bitSet: bitSet$1,
  bytesToHex: bytesToHex$5,
  bytesToNumberBE: bytesToNumberBE$2,
  bytesToNumberLE: bytesToNumberLE$2,
  concatBytes: concatBytes$6,
  createHmacDrbg: createHmacDrbg$2,
  ensureBytes: ensureBytes$2,
  equalBytes: equalBytes$3,
  hexToBytes: hexToBytes$5,
  hexToNumber: hexToNumber$2,
  isBytes: isBytes$a,
  numberToBytesBE: numberToBytesBE$2,
  numberToBytesLE: numberToBytesLE$2,
  numberToHexUnpadded: numberToHexUnpadded$2,
  numberToVarBytesBE: numberToVarBytesBE$1,
  utf8ToBytes: utf8ToBytes$7,
  validateObject: validateObject$2
}, Symbol.toStringTag, { value: "Module" }));
const _0n$i = BigInt(0), _1n$f = BigInt(1), _2n$a = BigInt(2), _3n$6 = BigInt(3), _4n$6 = BigInt(4), _5n$2 = BigInt(5), _8n$2 = BigInt(8);
BigInt(9);
BigInt(16);
function mod$2(n, c) {
  const u = n % c;
  return u >= _0n$i ? u : c + u;
}
function pow$1(n, c, u) {
  if (u <= _0n$i || c < _0n$i)
    throw new Error("Expected power/modulo > 0");
  if (u === _1n$f)
    return _0n$i;
  let p = _1n$f;
  for (; c > _0n$i; )
    c & _1n$f && (p = p * n % u), n = n * n % u, c >>= _1n$f;
  return p;
}
function pow2$2(n, c, u) {
  let p = n;
  for (; c-- > _0n$i; )
    p *= p, p %= u;
  return p;
}
function invert$2(n, c) {
  if (n === _0n$i || c <= _0n$i)
    throw new Error(`invert: expected positive integers, got n=${n} mod=${c}`);
  let u = mod$2(n, c), p = c, a = _0n$i, A = _1n$f;
  for (; u !== _0n$i; ) {
    const F = p / u, le = p % u, L = a - A * F;
    p = u, u = le, a = A, A = L;
  }
  if (p !== _1n$f)
    throw new Error("invert: does not exist");
  return mod$2(a, c);
}
function tonelliShanks$2(n) {
  const c = (n - _1n$f) / _2n$a;
  let u, p, a;
  for (u = n - _1n$f, p = 0; u % _2n$a === _0n$i; u /= _2n$a, p++)
    ;
  for (a = _2n$a; a < n && pow$1(a, c, n) !== n - _1n$f; a++)
    ;
  if (p === 1) {
    const b = (n + _1n$f) / _4n$6;
    return function(le, L) {
      const pe = le.pow(L, b);
      if (!le.eql(le.sqr(pe), L))
        throw new Error("Cannot find square root");
      return pe;
    };
  }
  const A = (u + _1n$f) / _2n$a;
  return function(F, le) {
    if (F.pow(le, c) === F.neg(F.ONE))
      throw new Error("Cannot find square root");
    let L = p, pe = F.pow(F.mul(F.ONE, a), u), $ = F.pow(le, A), Ee = F.pow(le, u);
    for (; !F.eql(Ee, F.ONE); ) {
      if (F.eql(Ee, F.ZERO))
        return F.ZERO;
      let be = 1;
      for (let Pe = F.sqr(Ee); be < L && !F.eql(Pe, F.ONE); be++)
        Pe = F.sqr(Pe);
      const He = F.pow(pe, _1n$f << BigInt(L - be - 1));
      pe = F.sqr(He), $ = F.mul($, He), Ee = F.mul(Ee, pe), L = be;
    }
    return $;
  };
}
function FpSqrt$2(n) {
  if (n % _4n$6 === _3n$6) {
    const c = (n + _1n$f) / _4n$6;
    return function(p, a) {
      const A = p.pow(a, c);
      if (!p.eql(p.sqr(A), a))
        throw new Error("Cannot find square root");
      return A;
    };
  }
  if (n % _8n$2 === _5n$2) {
    const c = (n - _5n$2) / _8n$2;
    return function(p, a) {
      const A = p.mul(a, _2n$a), b = p.pow(A, c), F = p.mul(a, b), le = p.mul(p.mul(F, _2n$a), b), L = p.mul(F, p.sub(le, p.ONE));
      if (!p.eql(p.sqr(L), a))
        throw new Error("Cannot find square root");
      return L;
    };
  }
  return tonelliShanks$2(n);
}
const FIELD_FIELDS$2 = [
  "create",
  "isValid",
  "is0",
  "neg",
  "inv",
  "sqrt",
  "sqr",
  "eql",
  "add",
  "sub",
  "mul",
  "pow",
  "div",
  "addN",
  "subN",
  "mulN",
  "sqrN"
];
function validateField$2(n) {
  const c = {
    ORDER: "bigint",
    MASK: "bigint",
    BYTES: "isSafeInteger",
    BITS: "isSafeInteger"
  }, u = FIELD_FIELDS$2.reduce((p, a) => (p[a] = "function", p), c);
  return validateObject$2(n, u);
}
function FpPow$2(n, c, u) {
  if (u < _0n$i)
    throw new Error("Expected power > 0");
  if (u === _0n$i)
    return n.ONE;
  if (u === _1n$f)
    return c;
  let p = n.ONE, a = c;
  for (; u > _0n$i; )
    u & _1n$f && (p = n.mul(p, a)), a = n.sqr(a), u >>= _1n$f;
  return p;
}
function FpInvertBatch$2(n, c) {
  const u = new Array(c.length), p = c.reduce((A, b, F) => n.is0(b) ? A : (u[F] = A, n.mul(A, b)), n.ONE), a = n.inv(p);
  return c.reduceRight((A, b, F) => n.is0(b) ? A : (u[F] = n.mul(A, u[F]), n.mul(A, b)), a), u;
}
function nLength$2(n, c) {
  const u = c !== void 0 ? c : n.toString(2).length, p = Math.ceil(u / 8);
  return { nBitLength: u, nByteLength: p };
}
function Field$4(n, c, u = !1, p = {}) {
  if (n <= _0n$i)
    throw new Error(`Expected Field ORDER > 0, got ${n}`);
  const { nBitLength: a, nByteLength: A } = nLength$2(n, c);
  if (A > 2048)
    throw new Error("Field lengths over 2048 bytes are not supported");
  const b = FpSqrt$2(n), F = Object.freeze({
    ORDER: n,
    BITS: a,
    BYTES: A,
    MASK: bitMask$2(a),
    ZERO: _0n$i,
    ONE: _1n$f,
    create: (le) => mod$2(le, n),
    isValid: (le) => {
      if (typeof le != "bigint")
        throw new Error(`Invalid field element: expected bigint, got ${typeof le}`);
      return _0n$i <= le && le < n;
    },
    is0: (le) => le === _0n$i,
    isOdd: (le) => (le & _1n$f) === _1n$f,
    neg: (le) => mod$2(-le, n),
    eql: (le, L) => le === L,
    sqr: (le) => mod$2(le * le, n),
    add: (le, L) => mod$2(le + L, n),
    sub: (le, L) => mod$2(le - L, n),
    mul: (le, L) => mod$2(le * L, n),
    pow: (le, L) => FpPow$2(F, le, L),
    div: (le, L) => mod$2(le * invert$2(L, n), n),
    // Same as above, but doesn't normalize
    sqrN: (le) => le * le,
    addN: (le, L) => le + L,
    subN: (le, L) => le - L,
    mulN: (le, L) => le * L,
    inv: (le) => invert$2(le, n),
    sqrt: p.sqrt || ((le) => b(F, le)),
    invertBatch: (le) => FpInvertBatch$2(F, le),
    // TODO: do we really need constant cmov?
    // We don't have const-time bigints anyway, so probably will be not very useful
    cmov: (le, L, pe) => pe ? L : le,
    toBytes: (le) => u ? numberToBytesLE$2(le, A) : numberToBytesBE$2(le, A),
    fromBytes: (le) => {
      if (le.length !== A)
        throw new Error(`Fp.fromBytes: expected ${A}, got ${le.length}`);
      return u ? bytesToNumberLE$2(le) : bytesToNumberBE$2(le);
    }
  });
  return Object.freeze(F);
}
function getFieldBytesLength$1(n) {
  if (typeof n != "bigint")
    throw new Error("field order must be bigint");
  const c = n.toString(2).length;
  return Math.ceil(c / 8);
}
function getMinHashLength$1(n) {
  const c = getFieldBytesLength$1(n);
  return c + Math.ceil(c / 2);
}
function mapHashToField$1(n, c, u = !1) {
  const p = n.length, a = getFieldBytesLength$1(c), A = getMinHashLength$1(c);
  if (p < 16 || p < A || p > 1024)
    throw new Error(`expected ${A}-1024 bytes of input, got ${p}`);
  const b = u ? bytesToNumberBE$2(n) : bytesToNumberLE$2(n), F = mod$2(b, c - _1n$f) + _1n$f;
  return u ? numberToBytesLE$2(F, a) : numberToBytesBE$2(F, a);
}
const _0n$h = BigInt(0), _1n$e = BigInt(1);
function wNAF$2(n, c) {
  const u = (a, A) => {
    const b = A.negate();
    return a ? b : A;
  }, p = (a) => {
    const A = Math.ceil(c / a) + 1, b = 2 ** (a - 1);
    return { windows: A, windowSize: b };
  };
  return {
    constTimeNegate: u,
    // non-const time multiplication ladder
    unsafeLadder(a, A) {
      let b = n.ZERO, F = a;
      for (; A > _0n$h; )
        A & _1n$e && (b = b.add(F)), F = F.double(), A >>= _1n$e;
      return b;
    },
    /**
     * Creates a wNAF precomputation window. Used for caching.
     * Default window size is set by `utils.precompute()` and is equal to 8.
     * Number of precomputed points depends on the curve size:
     * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
     * - 𝑊 is the window size
     * - 𝑛 is the bitlength of the curve order.
     * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
     * @returns precomputed point tables flattened to a single array
     */
    precomputeWindow(a, A) {
      const { windows: b, windowSize: F } = p(A), le = [];
      let L = a, pe = L;
      for (let $ = 0; $ < b; $++) {
        pe = L, le.push(pe);
        for (let Ee = 1; Ee < F; Ee++)
          pe = pe.add(L), le.push(pe);
        L = pe.double();
      }
      return le;
    },
    /**
     * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
     * @param W window size
     * @param precomputes precomputed tables
     * @param n scalar (we don't check here, but should be less than curve order)
     * @returns real and fake (for const-time) points
     */
    wNAF(a, A, b) {
      const { windows: F, windowSize: le } = p(a);
      let L = n.ZERO, pe = n.BASE;
      const $ = BigInt(2 ** a - 1), Ee = 2 ** a, be = BigInt(a);
      for (let He = 0; He < F; He++) {
        const Pe = He * le;
        let nr = Number(b & $);
        b >>= be, nr > le && (nr -= Ee, b += _1n$e);
        const ir = Pe, or = Pe + Math.abs(nr) - 1, lr = He % 2 !== 0, Ir = nr < 0;
        nr === 0 ? pe = pe.add(u(lr, A[ir])) : L = L.add(u(Ir, A[or]));
      }
      return { p: L, f: pe };
    },
    wNAFCached(a, A, b, F) {
      const le = a._WINDOW_SIZE || 1;
      let L = A.get(a);
      return L || (L = this.precomputeWindow(a, le), le !== 1 && A.set(a, F(L))), this.wNAF(le, L, b);
    }
  };
}
function validateBasic$2(n) {
  return validateField$2(n.Fp), validateObject$2(n, {
    n: "bigint",
    h: "bigint",
    Gx: "field",
    Gy: "field"
  }, {
    nBitLength: "isSafeInteger",
    nByteLength: "isSafeInteger"
  }), Object.freeze({
    ...nLength$2(n.n, n.nBitLength),
    ...n,
    p: n.Fp.ORDER
  });
}
function validatePointOpts$2(n) {
  const c = validateBasic$2(n);
  validateObject$2(c, {
    a: "field",
    b: "field"
  }, {
    allowedPrivateKeyLengths: "array",
    wrapPrivateKey: "boolean",
    isTorsionFree: "function",
    clearCofactor: "function",
    allowInfinityPoint: "boolean",
    fromBytes: "function",
    toBytes: "function"
  });
  const { endo: u, Fp: p, a } = c;
  if (u) {
    if (!p.eql(a, p.ZERO))
      throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
    if (typeof u != "object" || typeof u.beta != "bigint" || typeof u.splitScalar != "function")
      throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
  }
  return Object.freeze({ ...c });
}
const { bytesToNumberBE: b2n$1, hexToBytes: h2b$1 } = ut$2, DER$2 = {
  // asn.1 DER encoding utils
  Err: class extends Error {
    constructor(c = "") {
      super(c);
    }
  },
  _parseInt(n) {
    const { Err: c } = DER$2;
    if (n.length < 2 || n[0] !== 2)
      throw new c("Invalid signature integer tag");
    const u = n[1], p = n.subarray(2, u + 2);
    if (!u || p.length !== u)
      throw new c("Invalid signature integer: wrong length");
    if (p[0] & 128)
      throw new c("Invalid signature integer: negative");
    if (p[0] === 0 && !(p[1] & 128))
      throw new c("Invalid signature integer: unnecessary leading zero");
    return { d: b2n$1(p), l: n.subarray(u + 2) };
  },
  toSig(n) {
    const { Err: c } = DER$2, u = typeof n == "string" ? h2b$1(n) : n;
    abytes$4(u);
    let p = u.length;
    if (p < 2 || u[0] != 48)
      throw new c("Invalid signature tag");
    if (u[1] !== p - 2)
      throw new c("Invalid signature: incorrect length");
    const { d: a, l: A } = DER$2._parseInt(u.subarray(2)), { d: b, l: F } = DER$2._parseInt(A);
    if (F.length)
      throw new c("Invalid signature: left bytes after parsing");
    return { r: a, s: b };
  },
  hexFromSig(n) {
    const c = (L) => Number.parseInt(L[0], 16) & 8 ? "00" + L : L, u = (L) => {
      const pe = L.toString(16);
      return pe.length & 1 ? `0${pe}` : pe;
    }, p = c(u(n.s)), a = c(u(n.r)), A = p.length / 2, b = a.length / 2, F = u(A), le = u(b);
    return `30${u(b + A + 4)}02${le}${a}02${F}${p}`;
  }
}, _0n$g = BigInt(0), _1n$d = BigInt(1), _2n$9 = BigInt(2), _3n$5 = BigInt(3), _4n$5 = BigInt(4);
function weierstrassPoints$2(n) {
  const c = validatePointOpts$2(n), { Fp: u } = c, p = c.toBytes || ((He, Pe, nr) => {
    const ir = Pe.toAffine();
    return concatBytes$6(Uint8Array.from([4]), u.toBytes(ir.x), u.toBytes(ir.y));
  }), a = c.fromBytes || ((He) => {
    const Pe = He.subarray(1), nr = u.fromBytes(Pe.subarray(0, u.BYTES)), ir = u.fromBytes(Pe.subarray(u.BYTES, 2 * u.BYTES));
    return { x: nr, y: ir };
  });
  function A(He) {
    const { a: Pe, b: nr } = c, ir = u.sqr(He), or = u.mul(ir, He);
    return u.add(u.add(or, u.mul(He, Pe)), nr);
  }
  if (!u.eql(u.sqr(c.Gy), A(c.Gx)))
    throw new Error("bad generator point: equation left != right");
  function b(He) {
    return typeof He == "bigint" && _0n$g < He && He < c.n;
  }
  function F(He) {
    if (!b(He))
      throw new Error("Expected valid bigint: 0 < bigint < curve.n");
  }
  function le(He) {
    const { allowedPrivateKeyLengths: Pe, nByteLength: nr, wrapPrivateKey: ir, n: or } = c;
    if (Pe && typeof He != "bigint") {
      if (isBytes$a(He) && (He = bytesToHex$5(He)), typeof He != "string" || !Pe.includes(He.length))
        throw new Error("Invalid key");
      He = He.padStart(nr * 2, "0");
    }
    let lr;
    try {
      lr = typeof He == "bigint" ? He : bytesToNumberBE$2(ensureBytes$2("private key", He, nr));
    } catch {
      throw new Error(`private key must be ${nr} bytes, hex or bigint, not ${typeof He}`);
    }
    return ir && (lr = mod$2(lr, or)), F(lr), lr;
  }
  const L = /* @__PURE__ */ new Map();
  function pe(He) {
    if (!(He instanceof $))
      throw new Error("ProjectivePoint expected");
  }
  class $ {
    constructor(Pe, nr, ir) {
      if (this.px = Pe, this.py = nr, this.pz = ir, Pe == null || !u.isValid(Pe))
        throw new Error("x required");
      if (nr == null || !u.isValid(nr))
        throw new Error("y required");
      if (ir == null || !u.isValid(ir))
        throw new Error("z required");
    }
    // Does not validate if the point is on-curve.
    // Use fromHex instead, or call assertValidity() later.
    static fromAffine(Pe) {
      const { x: nr, y: ir } = Pe || {};
      if (!Pe || !u.isValid(nr) || !u.isValid(ir))
        throw new Error("invalid affine point");
      if (Pe instanceof $)
        throw new Error("projective point not allowed");
      const or = (lr) => u.eql(lr, u.ZERO);
      return or(nr) && or(ir) ? $.ZERO : new $(nr, ir, u.ONE);
    }
    get x() {
      return this.toAffine().x;
    }
    get y() {
      return this.toAffine().y;
    }
    /**
     * Takes a bunch of Projective Points but executes only one
     * inversion on all of them. Inversion is very slow operation,
     * so this improves performance massively.
     * Optimization: converts a list of projective points to a list of identical points with Z=1.
     */
    static normalizeZ(Pe) {
      const nr = u.invertBatch(Pe.map((ir) => ir.pz));
      return Pe.map((ir, or) => ir.toAffine(nr[or])).map($.fromAffine);
    }
    /**
     * Converts hash string or Uint8Array to Point.
     * @param hex short/long ECDSA hex
     */
    static fromHex(Pe) {
      const nr = $.fromAffine(a(ensureBytes$2("pointHex", Pe)));
      return nr.assertValidity(), nr;
    }
    // Multiplies generator point by privateKey.
    static fromPrivateKey(Pe) {
      return $.BASE.multiply(le(Pe));
    }
    // "Private method", don't use it directly
    _setWindowSize(Pe) {
      this._WINDOW_SIZE = Pe, L.delete(this);
    }
    // A point on curve is valid if it conforms to equation.
    assertValidity() {
      if (this.is0()) {
        if (c.allowInfinityPoint && !u.is0(this.py))
          return;
        throw new Error("bad point: ZERO");
      }
      const { x: Pe, y: nr } = this.toAffine();
      if (!u.isValid(Pe) || !u.isValid(nr))
        throw new Error("bad point: x or y not FE");
      const ir = u.sqr(nr), or = A(Pe);
      if (!u.eql(ir, or))
        throw new Error("bad point: equation left != right");
      if (!this.isTorsionFree())
        throw new Error("bad point: not in prime-order subgroup");
    }
    hasEvenY() {
      const { y: Pe } = this.toAffine();
      if (u.isOdd)
        return !u.isOdd(Pe);
      throw new Error("Field doesn't support isOdd");
    }
    /**
     * Compare one point to another.
     */
    equals(Pe) {
      pe(Pe);
      const { px: nr, py: ir, pz: or } = this, { px: lr, py: Ir, pz: xr } = Pe, kr = u.eql(u.mul(nr, xr), u.mul(lr, or)), Ce = u.eql(u.mul(ir, xr), u.mul(Ir, or));
      return kr && Ce;
    }
    /**
     * Flips point to one corresponding to (x, -y) in Affine coordinates.
     */
    negate() {
      return new $(this.px, u.neg(this.py), this.pz);
    }
    // Renes-Costello-Batina exception-free doubling formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 3
    // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
    double() {
      const { a: Pe, b: nr } = c, ir = u.mul(nr, _3n$5), { px: or, py: lr, pz: Ir } = this;
      let xr = u.ZERO, kr = u.ZERO, Ce = u.ZERO, tr = u.mul(or, or), Fe = u.mul(lr, lr), Sr = u.mul(Ir, Ir), er = u.mul(or, lr);
      return er = u.add(er, er), Ce = u.mul(or, Ir), Ce = u.add(Ce, Ce), xr = u.mul(Pe, Ce), kr = u.mul(ir, Sr), kr = u.add(xr, kr), xr = u.sub(Fe, kr), kr = u.add(Fe, kr), kr = u.mul(xr, kr), xr = u.mul(er, xr), Ce = u.mul(ir, Ce), Sr = u.mul(Pe, Sr), er = u.sub(tr, Sr), er = u.mul(Pe, er), er = u.add(er, Ce), Ce = u.add(tr, tr), tr = u.add(Ce, tr), tr = u.add(tr, Sr), tr = u.mul(tr, er), kr = u.add(kr, tr), Sr = u.mul(lr, Ir), Sr = u.add(Sr, Sr), tr = u.mul(Sr, er), xr = u.sub(xr, tr), Ce = u.mul(Sr, Fe), Ce = u.add(Ce, Ce), Ce = u.add(Ce, Ce), new $(xr, kr, Ce);
    }
    // Renes-Costello-Batina exception-free addition formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 1
    // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
    add(Pe) {
      pe(Pe);
      const { px: nr, py: ir, pz: or } = this, { px: lr, py: Ir, pz: xr } = Pe;
      let kr = u.ZERO, Ce = u.ZERO, tr = u.ZERO;
      const Fe = c.a, Sr = u.mul(c.b, _3n$5);
      let er = u.mul(nr, lr), Ie = u.mul(ir, Ir), xe = u.mul(or, xr), rr = u.add(nr, ir), ar = u.add(lr, Ir);
      rr = u.mul(rr, ar), ar = u.add(er, Ie), rr = u.sub(rr, ar), ar = u.add(nr, or);
      let yr = u.add(lr, xr);
      return ar = u.mul(ar, yr), yr = u.add(er, xe), ar = u.sub(ar, yr), yr = u.add(ir, or), kr = u.add(Ir, xr), yr = u.mul(yr, kr), kr = u.add(Ie, xe), yr = u.sub(yr, kr), tr = u.mul(Fe, ar), kr = u.mul(Sr, xe), tr = u.add(kr, tr), kr = u.sub(Ie, tr), tr = u.add(Ie, tr), Ce = u.mul(kr, tr), Ie = u.add(er, er), Ie = u.add(Ie, er), xe = u.mul(Fe, xe), ar = u.mul(Sr, ar), Ie = u.add(Ie, xe), xe = u.sub(er, xe), xe = u.mul(Fe, xe), ar = u.add(ar, xe), er = u.mul(Ie, ar), Ce = u.add(Ce, er), er = u.mul(yr, ar), kr = u.mul(rr, kr), kr = u.sub(kr, er), er = u.mul(rr, Ie), tr = u.mul(yr, tr), tr = u.add(tr, er), new $(kr, Ce, tr);
    }
    subtract(Pe) {
      return this.add(Pe.negate());
    }
    is0() {
      return this.equals($.ZERO);
    }
    wNAF(Pe) {
      return be.wNAFCached(this, L, Pe, (nr) => {
        const ir = u.invertBatch(nr.map((or) => or.pz));
        return nr.map((or, lr) => or.toAffine(ir[lr])).map($.fromAffine);
      });
    }
    /**
     * Non-constant-time multiplication. Uses double-and-add algorithm.
     * It's faster, but should only be used when you don't care about
     * an exposed private key e.g. sig verification, which works over *public* keys.
     */
    multiplyUnsafe(Pe) {
      const nr = $.ZERO;
      if (Pe === _0n$g)
        return nr;
      if (F(Pe), Pe === _1n$d)
        return this;
      const { endo: ir } = c;
      if (!ir)
        return be.unsafeLadder(this, Pe);
      let { k1neg: or, k1: lr, k2neg: Ir, k2: xr } = ir.splitScalar(Pe), kr = nr, Ce = nr, tr = this;
      for (; lr > _0n$g || xr > _0n$g; )
        lr & _1n$d && (kr = kr.add(tr)), xr & _1n$d && (Ce = Ce.add(tr)), tr = tr.double(), lr >>= _1n$d, xr >>= _1n$d;
      return or && (kr = kr.negate()), Ir && (Ce = Ce.negate()), Ce = new $(u.mul(Ce.px, ir.beta), Ce.py, Ce.pz), kr.add(Ce);
    }
    /**
     * Constant time multiplication.
     * Uses wNAF method. Windowed method may be 10% faster,
     * but takes 2x longer to generate and consumes 2x memory.
     * Uses precomputes when available.
     * Uses endomorphism for Koblitz curves.
     * @param scalar by which the point would be multiplied
     * @returns New point
     */
    multiply(Pe) {
      F(Pe);
      let nr = Pe, ir, or;
      const { endo: lr } = c;
      if (lr) {
        const { k1neg: Ir, k1: xr, k2neg: kr, k2: Ce } = lr.splitScalar(nr);
        let { p: tr, f: Fe } = this.wNAF(xr), { p: Sr, f: er } = this.wNAF(Ce);
        tr = be.constTimeNegate(Ir, tr), Sr = be.constTimeNegate(kr, Sr), Sr = new $(u.mul(Sr.px, lr.beta), Sr.py, Sr.pz), ir = tr.add(Sr), or = Fe.add(er);
      } else {
        const { p: Ir, f: xr } = this.wNAF(nr);
        ir = Ir, or = xr;
      }
      return $.normalizeZ([ir, or])[0];
    }
    /**
     * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
     * Not using Strauss-Shamir trick: precomputation tables are faster.
     * The trick could be useful if both P and Q are not G (not in our case).
     * @returns non-zero affine point
     */
    multiplyAndAddUnsafe(Pe, nr, ir) {
      const or = $.BASE, lr = (xr, kr) => kr === _0n$g || kr === _1n$d || !xr.equals(or) ? xr.multiplyUnsafe(kr) : xr.multiply(kr), Ir = lr(this, nr).add(lr(Pe, ir));
      return Ir.is0() ? void 0 : Ir;
    }
    // Converts Projective point to affine (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    // (x, y, z) ∋ (x=x/z, y=y/z)
    toAffine(Pe) {
      const { px: nr, py: ir, pz: or } = this, lr = this.is0();
      Pe == null && (Pe = lr ? u.ONE : u.inv(or));
      const Ir = u.mul(nr, Pe), xr = u.mul(ir, Pe), kr = u.mul(or, Pe);
      if (lr)
        return { x: u.ZERO, y: u.ZERO };
      if (!u.eql(kr, u.ONE))
        throw new Error("invZ was invalid");
      return { x: Ir, y: xr };
    }
    isTorsionFree() {
      const { h: Pe, isTorsionFree: nr } = c;
      if (Pe === _1n$d)
        return !0;
      if (nr)
        return nr($, this);
      throw new Error("isTorsionFree() has not been declared for the elliptic curve");
    }
    clearCofactor() {
      const { h: Pe, clearCofactor: nr } = c;
      return Pe === _1n$d ? this : nr ? nr($, this) : this.multiplyUnsafe(c.h);
    }
    toRawBytes(Pe = !0) {
      return this.assertValidity(), p($, this, Pe);
    }
    toHex(Pe = !0) {
      return bytesToHex$5(this.toRawBytes(Pe));
    }
  }
  $.BASE = new $(c.Gx, c.Gy, u.ONE), $.ZERO = new $(u.ZERO, u.ONE, u.ZERO);
  const Ee = c.nBitLength, be = wNAF$2($, c.endo ? Math.ceil(Ee / 2) : Ee);
  return {
    CURVE: c,
    ProjectivePoint: $,
    normPrivateKeyToScalar: le,
    weierstrassEquation: A,
    isWithinCurveOrder: b
  };
}
function validateOpts$3(n) {
  const c = validateBasic$2(n);
  return validateObject$2(c, {
    hash: "hash",
    hmac: "function",
    randomBytes: "function"
  }, {
    bits2int: "function",
    bits2int_modN: "function",
    lowS: "boolean"
  }), Object.freeze({ lowS: !0, ...c });
}
function weierstrass$2(n) {
  const c = validateOpts$3(n), { Fp: u, n: p } = c, a = u.BYTES + 1, A = 2 * u.BYTES + 1;
  function b(ar) {
    return _0n$g < ar && ar < u.ORDER;
  }
  function F(ar) {
    return mod$2(ar, p);
  }
  function le(ar) {
    return invert$2(ar, p);
  }
  const { ProjectivePoint: L, normPrivateKeyToScalar: pe, weierstrassEquation: $, isWithinCurveOrder: Ee } = weierstrassPoints$2({
    ...c,
    toBytes(ar, yr, _r) {
      const Or = yr.toAffine(), vr = u.toBytes(Or.x), Te = concatBytes$6;
      return _r ? Te(Uint8Array.from([yr.hasEvenY() ? 2 : 3]), vr) : Te(Uint8Array.from([4]), vr, u.toBytes(Or.y));
    },
    fromBytes(ar) {
      const yr = ar.length, _r = ar[0], Or = ar.subarray(1);
      if (yr === a && (_r === 2 || _r === 3)) {
        const vr = bytesToNumberBE$2(Or);
        if (!b(vr))
          throw new Error("Point is not on curve");
        const Te = $(vr);
        let Cr;
        try {
          Cr = u.sqrt(Te);
        } catch (ui) {
          const Li = ui instanceof Error ? ": " + ui.message : "";
          throw new Error("Point is not on curve" + Li);
        }
        const Hr = (Cr & _1n$d) === _1n$d;
        return (_r & 1) === 1 !== Hr && (Cr = u.neg(Cr)), { x: vr, y: Cr };
      } else if (yr === A && _r === 4) {
        const vr = u.fromBytes(Or.subarray(0, u.BYTES)), Te = u.fromBytes(Or.subarray(u.BYTES, 2 * u.BYTES));
        return { x: vr, y: Te };
      } else
        throw new Error(`Point of length ${yr} was invalid. Expected ${a} compressed bytes or ${A} uncompressed bytes`);
    }
  }), be = (ar) => bytesToHex$5(numberToBytesBE$2(ar, c.nByteLength));
  function He(ar) {
    const yr = p >> _1n$d;
    return ar > yr;
  }
  function Pe(ar) {
    return He(ar) ? F(-ar) : ar;
  }
  const nr = (ar, yr, _r) => bytesToNumberBE$2(ar.slice(yr, _r));
  class ir {
    constructor(yr, _r, Or) {
      this.r = yr, this.s = _r, this.recovery = Or, this.assertValidity();
    }
    // pair (bytes of r, bytes of s)
    static fromCompact(yr) {
      const _r = c.nByteLength;
      return yr = ensureBytes$2("compactSignature", yr, _r * 2), new ir(nr(yr, 0, _r), nr(yr, _r, 2 * _r));
    }
    // DER encoded ECDSA signature
    // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
    static fromDER(yr) {
      const { r: _r, s: Or } = DER$2.toSig(ensureBytes$2("DER", yr));
      return new ir(_r, Or);
    }
    assertValidity() {
      if (!Ee(this.r))
        throw new Error("r must be 0 < r < CURVE.n");
      if (!Ee(this.s))
        throw new Error("s must be 0 < s < CURVE.n");
    }
    addRecoveryBit(yr) {
      return new ir(this.r, this.s, yr);
    }
    recoverPublicKey(yr) {
      const { r: _r, s: Or, recovery: vr } = this, Te = Ce(ensureBytes$2("msgHash", yr));
      if (vr == null || ![0, 1, 2, 3].includes(vr))
        throw new Error("recovery id invalid");
      const Cr = vr === 2 || vr === 3 ? _r + c.n : _r;
      if (Cr >= u.ORDER)
        throw new Error("recovery id 2 or 3 invalid");
      const Hr = vr & 1 ? "03" : "02", si = L.fromHex(Hr + be(Cr)), ui = le(Cr), Li = F(-Te * ui), Qi = F(Or * ui), wi = L.BASE.multiplyAndAddUnsafe(si, Li, Qi);
      if (!wi)
        throw new Error("point at infinify");
      return wi.assertValidity(), wi;
    }
    // Signatures should be low-s, to prevent malleability.
    hasHighS() {
      return He(this.s);
    }
    normalizeS() {
      return this.hasHighS() ? new ir(this.r, F(-this.s), this.recovery) : this;
    }
    // DER-encoded
    toDERRawBytes() {
      return hexToBytes$5(this.toDERHex());
    }
    toDERHex() {
      return DER$2.hexFromSig({ r: this.r, s: this.s });
    }
    // padded bytes of r, then padded bytes of s
    toCompactRawBytes() {
      return hexToBytes$5(this.toCompactHex());
    }
    toCompactHex() {
      return be(this.r) + be(this.s);
    }
  }
  const or = {
    isValidPrivateKey(ar) {
      try {
        return pe(ar), !0;
      } catch {
        return !1;
      }
    },
    normPrivateKeyToScalar: pe,
    /**
     * Produces cryptographically secure private key from random of size
     * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
     */
    randomPrivateKey: () => {
      const ar = getMinHashLength$1(c.n);
      return mapHashToField$1(c.randomBytes(ar), c.n);
    },
    /**
     * Creates precompute table for an arbitrary EC point. Makes point "cached".
     * Allows to massively speed-up `point.multiply(scalar)`.
     * @returns cached point
     * @example
     * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
     * fast.multiply(privKey); // much faster ECDH now
     */
    precompute(ar = 8, yr = L.BASE) {
      return yr._setWindowSize(ar), yr.multiply(BigInt(3)), yr;
    }
  };
  function lr(ar, yr = !0) {
    return L.fromPrivateKey(ar).toRawBytes(yr);
  }
  function Ir(ar) {
    const yr = isBytes$a(ar), _r = typeof ar == "string", Or = (yr || _r) && ar.length;
    return yr ? Or === a || Or === A : _r ? Or === 2 * a || Or === 2 * A : ar instanceof L;
  }
  function xr(ar, yr, _r = !0) {
    if (Ir(ar))
      throw new Error("first arg must be private key");
    if (!Ir(yr))
      throw new Error("second arg must be public key");
    return L.fromHex(yr).multiply(pe(ar)).toRawBytes(_r);
  }
  const kr = c.bits2int || function(ar) {
    const yr = bytesToNumberBE$2(ar), _r = ar.length * 8 - c.nBitLength;
    return _r > 0 ? yr >> BigInt(_r) : yr;
  }, Ce = c.bits2int_modN || function(ar) {
    return F(kr(ar));
  }, tr = bitMask$2(c.nBitLength);
  function Fe(ar) {
    if (typeof ar != "bigint")
      throw new Error("bigint expected");
    if (!(_0n$g <= ar && ar < tr))
      throw new Error(`bigint expected < 2^${c.nBitLength}`);
    return numberToBytesBE$2(ar, c.nByteLength);
  }
  function Sr(ar, yr, _r = er) {
    if (["recovered", "canonical"].some((mn) => mn in _r))
      throw new Error("sign() legacy options not supported");
    const { hash: Or, randomBytes: vr } = c;
    let { lowS: Te, prehash: Cr, extraEntropy: Hr } = _r;
    Te == null && (Te = !0), ar = ensureBytes$2("msgHash", ar), Cr && (ar = ensureBytes$2("prehashed msgHash", Or(ar)));
    const si = Ce(ar), ui = pe(yr), Li = [Fe(ui), Fe(si)];
    if (Hr != null && Hr !== !1) {
      const mn = Hr === !0 ? vr(u.BYTES) : Hr;
      Li.push(ensureBytes$2("extraEntropy", mn));
    }
    const Qi = concatBytes$6(...Li), wi = si;
    function Ji(mn) {
      const pi = kr(mn);
      if (!Ee(pi))
        return;
      const ei = le(pi), Vr = L.BASE.multiply(pi).toAffine(), qr = F(Vr.x);
      if (qr === _0n$g)
        return;
      const Zi = F(ei * F(wi + qr * ui));
      if (Zi === _0n$g)
        return;
      let Wr = (Vr.x === qr ? 0 : 2) | Number(Vr.y & _1n$d), ri = Zi;
      return Te && He(Zi) && (ri = Pe(Zi), Wr ^= 1), new ir(qr, ri, Wr);
    }
    return { seed: Qi, k2sig: Ji };
  }
  const er = { lowS: c.lowS, prehash: !1 }, Ie = { lowS: c.lowS, prehash: !1 };
  function xe(ar, yr, _r = er) {
    const { seed: Or, k2sig: vr } = Sr(ar, yr, _r), Te = c;
    return createHmacDrbg$2(Te.hash.outputLen, Te.nByteLength, Te.hmac)(Or, vr);
  }
  L.BASE._setWindowSize(8);
  function rr(ar, yr, _r, Or = Ie) {
    var Vr;
    const vr = ar;
    if (yr = ensureBytes$2("msgHash", yr), _r = ensureBytes$2("publicKey", _r), "strict" in Or)
      throw new Error("options.strict was renamed to lowS");
    const { lowS: Te, prehash: Cr } = Or;
    let Hr, si;
    try {
      if (typeof vr == "string" || isBytes$a(vr))
        try {
          Hr = ir.fromDER(vr);
        } catch (qr) {
          if (!(qr instanceof DER$2.Err))
            throw qr;
          Hr = ir.fromCompact(vr);
        }
      else if (typeof vr == "object" && typeof vr.r == "bigint" && typeof vr.s == "bigint") {
        const { r: qr, s: Zi } = vr;
        Hr = new ir(qr, Zi);
      } else
        throw new Error("PARSE");
      si = L.fromHex(_r);
    } catch (qr) {
      if (qr.message === "PARSE")
        throw new Error("signature must be Signature instance, Uint8Array or hex string");
      return !1;
    }
    if (Te && Hr.hasHighS())
      return !1;
    Cr && (yr = c.hash(yr));
    const { r: ui, s: Li } = Hr, Qi = Ce(yr), wi = le(Li), Ji = F(Qi * wi), mn = F(ui * wi), pi = (Vr = L.BASE.multiplyAndAddUnsafe(si, Ji, mn)) == null ? void 0 : Vr.toAffine();
    return pi ? F(pi.x) === ui : !1;
  }
  return {
    CURVE: c,
    getPublicKey: lr,
    getSharedSecret: xr,
    sign: xe,
    verify: rr,
    ProjectivePoint: L,
    Signature: ir,
    utils: or
  };
}
function SWUFpSqrtRatio$1(n, c) {
  const u = n.ORDER;
  let p = _0n$g;
  for (let He = u - _1n$d; He % _2n$9 === _0n$g; He /= _2n$9)
    p += _1n$d;
  const a = p, A = _2n$9 << a - _1n$d - _1n$d, b = A * _2n$9, F = (u - _1n$d) / b, le = (F - _1n$d) / _2n$9, L = b - _1n$d, pe = A, $ = n.pow(c, F), Ee = n.pow(c, (F + _1n$d) / _2n$9);
  let be = (He, Pe) => {
    let nr = $, ir = n.pow(Pe, L), or = n.sqr(ir);
    or = n.mul(or, Pe);
    let lr = n.mul(He, or);
    lr = n.pow(lr, le), lr = n.mul(lr, ir), ir = n.mul(lr, Pe), or = n.mul(lr, He);
    let Ir = n.mul(or, ir);
    lr = n.pow(Ir, pe);
    let xr = n.eql(lr, n.ONE);
    ir = n.mul(or, Ee), lr = n.mul(Ir, nr), or = n.cmov(ir, or, xr), Ir = n.cmov(lr, Ir, xr);
    for (let kr = a; kr > _1n$d; kr--) {
      let Ce = kr - _2n$9;
      Ce = _2n$9 << Ce - _1n$d;
      let tr = n.pow(Ir, Ce);
      const Fe = n.eql(tr, n.ONE);
      ir = n.mul(or, nr), nr = n.mul(nr, nr), tr = n.mul(Ir, nr), or = n.cmov(ir, or, Fe), Ir = n.cmov(tr, Ir, Fe);
    }
    return { isValid: xr, value: or };
  };
  if (n.ORDER % _4n$5 === _3n$5) {
    const He = (n.ORDER - _3n$5) / _4n$5, Pe = n.sqrt(n.neg(c));
    be = (nr, ir) => {
      let or = n.sqr(ir);
      const lr = n.mul(nr, ir);
      or = n.mul(or, lr);
      let Ir = n.pow(or, He);
      Ir = n.mul(Ir, lr);
      const xr = n.mul(Ir, Pe), kr = n.mul(n.sqr(Ir), ir), Ce = n.eql(kr, nr);
      let tr = n.cmov(xr, Ir, Ce);
      return { isValid: Ce, value: tr };
    };
  }
  return be;
}
function mapToCurveSimpleSWU$1(n, c) {
  if (validateField$2(n), !n.isValid(c.A) || !n.isValid(c.B) || !n.isValid(c.Z))
    throw new Error("mapToCurveSimpleSWU: invalid opts");
  const u = SWUFpSqrtRatio$1(n, c.Z);
  if (!n.isOdd)
    throw new Error("Fp.isOdd is not implemented!");
  return (p) => {
    let a, A, b, F, le, L, pe, $;
    a = n.sqr(p), a = n.mul(a, c.Z), A = n.sqr(a), A = n.add(A, a), b = n.add(A, n.ONE), b = n.mul(b, c.B), F = n.cmov(c.Z, n.neg(A), !n.eql(A, n.ZERO)), F = n.mul(F, c.A), A = n.sqr(b), L = n.sqr(F), le = n.mul(L, c.A), A = n.add(A, le), A = n.mul(A, b), L = n.mul(L, F), le = n.mul(L, c.B), A = n.add(A, le), pe = n.mul(a, b);
    const { isValid: Ee, value: be } = u(A, L);
    $ = n.mul(a, p), $ = n.mul($, be), pe = n.cmov(pe, b, Ee), $ = n.cmov($, be, Ee);
    const He = n.isOdd(p) === n.isOdd($);
    return $ = n.cmov(n.neg($), $, He), pe = n.div(pe, F), { x: pe, y: $ };
  };
}
function getHash$2(n) {
  return {
    hash: n,
    hmac: (c, ...u) => hmac$4(n, c, concatBytes$7(...u)),
    randomBytes: randomBytes$2
  };
}
function createCurve$2(n, c) {
  const u = (p) => weierstrass$2({ ...n, ...getHash$2(p) });
  return Object.freeze({ ...u(c), create: u });
}
const os2ip$1 = bytesToNumberBE$2;
function i2osp$1(n, c) {
  if (n < 0 || n >= 1 << 8 * c)
    throw new Error(`bad I2OSP call: value=${n} length=${c}`);
  const u = Array.from({ length: c }).fill(0);
  for (let p = c - 1; p >= 0; p--)
    u[p] = n & 255, n >>>= 8;
  return new Uint8Array(u);
}
function strxor$1(n, c) {
  const u = new Uint8Array(n.length);
  for (let p = 0; p < n.length; p++)
    u[p] = n[p] ^ c[p];
  return u;
}
function anum(n) {
  if (!Number.isSafeInteger(n))
    throw new Error("number expected");
}
function expand_message_xmd$1(n, c, u, p) {
  abytes$4(n), abytes$4(c), anum(u), c.length > 255 && (c = p(concatBytes$6(utf8ToBytes$7("H2C-OVERSIZE-DST-"), c)));
  const { outputLen: a, blockLen: A } = p, b = Math.ceil(u / a);
  if (b > 255)
    throw new Error("Invalid xmd length");
  const F = concatBytes$6(c, i2osp$1(c.length, 1)), le = i2osp$1(0, A), L = i2osp$1(u, 2), pe = new Array(b), $ = p(concatBytes$6(le, n, L, i2osp$1(0, 1), F));
  pe[0] = p(concatBytes$6($, i2osp$1(1, 1), F));
  for (let be = 1; be <= b; be++) {
    const He = [strxor$1($, pe[be - 1]), i2osp$1(be + 1, 1), F];
    pe[be] = p(concatBytes$6(...He));
  }
  return concatBytes$6(...pe).slice(0, u);
}
function expand_message_xof$1(n, c, u, p, a) {
  if (abytes$4(n), abytes$4(c), anum(u), c.length > 255) {
    const A = Math.ceil(2 * p / 8);
    c = a.create({ dkLen: A }).update(utf8ToBytes$7("H2C-OVERSIZE-DST-")).update(c).digest();
  }
  if (u > 65535 || c.length > 255)
    throw new Error("expand_message_xof: invalid lenInBytes");
  return a.create({ dkLen: u }).update(n).update(i2osp$1(u, 2)).update(c).update(i2osp$1(c.length, 1)).digest();
}
function hash_to_field$1(n, c, u) {
  validateObject$2(u, {
    DST: "stringOrUint8Array",
    p: "bigint",
    m: "isSafeInteger",
    k: "isSafeInteger",
    hash: "hash"
  });
  const { p, k: a, m: A, hash: b, expand: F, DST: le } = u;
  abytes$4(n), anum(c);
  const L = typeof le == "string" ? utf8ToBytes$7(le) : le, pe = p.toString(2).length, $ = Math.ceil((pe + a) / 8), Ee = c * A * $;
  let be;
  if (F === "xmd")
    be = expand_message_xmd$1(n, L, Ee, b);
  else if (F === "xof")
    be = expand_message_xof$1(n, L, Ee, a, b);
  else if (F === "_internal_pass")
    be = n;
  else
    throw new Error('expand must be "xmd" or "xof"');
  const He = new Array(c);
  for (let Pe = 0; Pe < c; Pe++) {
    const nr = new Array(A);
    for (let ir = 0; ir < A; ir++) {
      const or = $ * (ir + Pe * A), lr = be.subarray(or, or + $);
      nr[ir] = mod$2(os2ip$1(lr), p);
    }
    He[Pe] = nr;
  }
  return He;
}
function isogenyMap$1(n, c) {
  const u = c.map((p) => Array.from(p).reverse());
  return (p, a) => {
    const [A, b, F, le] = u.map((L) => L.reduce((pe, $) => n.add(n.mul(pe, p), $)));
    return p = n.div(A, b), a = n.mul(a, n.div(F, le)), { x: p, y: a };
  };
}
function createHasher$2(n, c, u) {
  if (typeof c != "function")
    throw new Error("mapToCurve() must be defined");
  return {
    // Encodes byte string to elliptic curve.
    // hash_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
    hashToCurve(p, a) {
      const A = hash_to_field$1(p, 2, { ...u, DST: u.DST, ...a }), b = n.fromAffine(c(A[0])), F = n.fromAffine(c(A[1])), le = b.add(F).clearCofactor();
      return le.assertValidity(), le;
    },
    // Encodes byte string to elliptic curve.
    // encode_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
    encodeToCurve(p, a) {
      const A = hash_to_field$1(p, 1, { ...u, DST: u.encodeDST, ...a }), b = n.fromAffine(c(A[0])).clearCofactor();
      return b.assertValidity(), b;
    },
    // Same as encodeToCurve, but without hash
    mapToCurve(p) {
      if (!Array.isArray(p))
        throw new Error("mapToCurve: expected array of bigints");
      for (const A of p)
        if (typeof A != "bigint")
          throw new Error(`mapToCurve: expected array of bigints, got ${A} in array`);
      const a = n.fromAffine(c(p)).clearCofactor();
      return a.assertValidity(), a;
    }
  };
}
const secp256k1P$2 = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"), secp256k1N$3 = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), _1n$c = BigInt(1), _2n$8 = BigInt(2), divNearest$2 = (n, c) => (n + c / _2n$8) / c;
function sqrtMod$2(n) {
  const c = secp256k1P$2, u = BigInt(3), p = BigInt(6), a = BigInt(11), A = BigInt(22), b = BigInt(23), F = BigInt(44), le = BigInt(88), L = n * n * n % c, pe = L * L * n % c, $ = pow2$2(pe, u, c) * pe % c, Ee = pow2$2($, u, c) * pe % c, be = pow2$2(Ee, _2n$8, c) * L % c, He = pow2$2(be, a, c) * be % c, Pe = pow2$2(He, A, c) * He % c, nr = pow2$2(Pe, F, c) * Pe % c, ir = pow2$2(nr, le, c) * nr % c, or = pow2$2(ir, F, c) * Pe % c, lr = pow2$2(or, u, c) * pe % c, Ir = pow2$2(lr, b, c) * He % c, xr = pow2$2(Ir, p, c) * L % c, kr = pow2$2(xr, _2n$8, c);
  if (!Fp$1.eql(Fp$1.sqr(kr), n))
    throw new Error("Cannot find square root");
  return kr;
}
const Fp$1 = Field$4(secp256k1P$2, void 0, void 0, { sqrt: sqrtMod$2 }), secp256k1$6 = createCurve$2({
  a: BigInt(0),
  // equation params: a, b
  b: BigInt(7),
  // Seem to be rigid: bitcointalk.org/index.php?topic=289795.msg3183975#msg3183975
  Fp: Fp$1,
  // Field's prime: 2n**256n - 2n**32n - 2n**9n - 2n**8n - 2n**7n - 2n**6n - 2n**4n - 1n
  n: secp256k1N$3,
  // Curve order, total count of valid points in the field
  // Base point (x, y) aka generator point
  Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
  Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
  h: BigInt(1),
  // Cofactor
  lowS: !0,
  // Allow only low-S signatures by default in sign() and verify()
  /**
   * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
   * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
   * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
   * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
   */
  endo: {
    beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
    splitScalar: (n) => {
      const c = secp256k1N$3, u = BigInt("0x3086d221a7d46bcde86c90e49284eb15"), p = -_1n$c * BigInt("0xe4437ed6010e88286f547fa90abfe4c3"), a = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), A = u, b = BigInt("0x100000000000000000000000000000000"), F = divNearest$2(A * n, c), le = divNearest$2(-p * n, c);
      let L = mod$2(n - F * u - le * a, c), pe = mod$2(-F * p - le * A, c);
      const $ = L > b, Ee = pe > b;
      if ($ && (L = c - L), Ee && (pe = c - pe), L > b || pe > b)
        throw new Error("splitScalar: Endomorphism failed, k=" + n);
      return { k1neg: $, k1: L, k2neg: Ee, k2: pe };
    }
  }
}, sha256$b), _0n$f = BigInt(0), fe$2 = (n) => typeof n == "bigint" && _0n$f < n && n < secp256k1P$2, ge$1 = (n) => typeof n == "bigint" && _0n$f < n && n < secp256k1N$3, TAGGED_HASH_PREFIXES$2 = {};
function taggedHash$3(n, ...c) {
  let u = TAGGED_HASH_PREFIXES$2[n];
  if (u === void 0) {
    const p = sha256$b(Uint8Array.from(n, (a) => a.charCodeAt(0)));
    u = concatBytes$6(p, p), TAGGED_HASH_PREFIXES$2[n] = u;
  }
  return sha256$b(concatBytes$6(u, ...c));
}
const pointToBytes$2 = (n) => n.toRawBytes(!0).slice(1), numTo32b$2 = (n) => numberToBytesBE$2(n, 32), modP$2 = (n) => mod$2(n, secp256k1P$2), modN$3 = (n) => mod$2(n, secp256k1N$3), Point$5 = secp256k1$6.ProjectivePoint, GmulAdd$2 = (n, c, u) => Point$5.BASE.multiplyAndAddUnsafe(n, c, u);
function schnorrGetExtPubKey$2(n) {
  let c = secp256k1$6.utils.normPrivateKeyToScalar(n), u = Point$5.fromPrivateKey(c);
  return { scalar: u.hasEvenY() ? c : modN$3(-c), bytes: pointToBytes$2(u) };
}
function lift_x$2(n) {
  if (!fe$2(n))
    throw new Error("bad x: need 0 < x < p");
  const c = modP$2(n * n), u = modP$2(c * n + BigInt(7));
  let p = sqrtMod$2(u);
  p % _2n$8 !== _0n$f && (p = modP$2(-p));
  const a = new Point$5(n, p, _1n$c);
  return a.assertValidity(), a;
}
function challenge$2(...n) {
  return modN$3(bytesToNumberBE$2(taggedHash$3("BIP0340/challenge", ...n)));
}
function schnorrGetPublicKey$2(n) {
  return schnorrGetExtPubKey$2(n).bytes;
}
function schnorrSign$2(n, c, u = randomBytes$2(32)) {
  const p = ensureBytes$2("message", n), { bytes: a, scalar: A } = schnorrGetExtPubKey$2(c), b = ensureBytes$2("auxRand", u, 32), F = numTo32b$2(A ^ bytesToNumberBE$2(taggedHash$3("BIP0340/aux", b))), le = taggedHash$3("BIP0340/nonce", F, a, p), L = modN$3(bytesToNumberBE$2(le));
  if (L === _0n$f)
    throw new Error("sign failed: k is zero");
  const { bytes: pe, scalar: $ } = schnorrGetExtPubKey$2(L), Ee = challenge$2(pe, a, p), be = new Uint8Array(64);
  if (be.set(pe, 0), be.set(numTo32b$2(modN$3($ + Ee * A)), 32), !schnorrVerify$2(be, p, a))
    throw new Error("sign: Invalid signature produced");
  return be;
}
function schnorrVerify$2(n, c, u) {
  const p = ensureBytes$2("signature", n, 64), a = ensureBytes$2("message", c), A = ensureBytes$2("publicKey", u, 32);
  try {
    const b = lift_x$2(bytesToNumberBE$2(A)), F = bytesToNumberBE$2(p.subarray(0, 32));
    if (!fe$2(F))
      return !1;
    const le = bytesToNumberBE$2(p.subarray(32, 64));
    if (!ge$1(le))
      return !1;
    const L = challenge$2(numTo32b$2(F), pointToBytes$2(b), a), pe = GmulAdd$2(b, le, modN$3(-L));
    return !(!pe || !pe.hasEvenY() || pe.toAffine().x !== F);
  } catch {
    return !1;
  }
}
const schnorr$2 = {
  getPublicKey: schnorrGetPublicKey$2,
  sign: schnorrSign$2,
  verify: schnorrVerify$2,
  utils: {
    randomPrivateKey: secp256k1$6.utils.randomPrivateKey,
    lift_x: lift_x$2,
    pointToBytes: pointToBytes$2,
    numberToBytesBE: numberToBytesBE$2,
    bytesToNumberBE: bytesToNumberBE$2,
    taggedHash: taggedHash$3,
    mod: mod$2
  }
}, isoMap$1 = isogenyMap$1(Fp$1, [
  // xNum
  [
    "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
    "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
    "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
    "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
  ],
  // xDen
  [
    "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
    "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
    "0x0000000000000000000000000000000000000000000000000000000000000001"
    // LAST 1
  ],
  // yNum
  [
    "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
    "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
    "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
    "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
  ],
  // yDen
  [
    "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
    "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
    "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
    "0x0000000000000000000000000000000000000000000000000000000000000001"
    // LAST 1
  ]
].map((n) => n.map((c) => BigInt(c)))), mapSWU$1 = mapToCurveSimpleSWU$1(Fp$1, {
  A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
  B: BigInt("1771"),
  Z: Fp$1.create(BigInt("-11"))
}), htf = createHasher$2(secp256k1$6.ProjectivePoint, (n) => {
  const { x: c, y: u } = mapSWU$1(Fp$1.create(n[0]));
  return isoMap$1(c, u);
}, {
  DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
  encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
  p: Fp$1.ORDER,
  m: 1,
  k: 128,
  expand: "xmd",
  hash: sha256$b
}), hashToCurve = htf.hashToCurve, encodeToCurve = htf.encodeToCurve, secp256k1$7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  encodeToCurve,
  hashToCurve,
  schnorr: schnorr$2,
  secp256k1: secp256k1$6
}, Symbol.toStringTag, { value: "Module" })), require$$0$2 = /* @__PURE__ */ getAugmentedNamespace(secp256k1$7);
var hasRequiredSecp256k1;
function requireSecp256k1() {
  return hasRequiredSecp256k1 || (hasRequiredSecp256k1 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.secp256k1 = void 0;
    var c = require$$0$2;
    Object.defineProperty(n, "secp256k1", { enumerable: !0, get: function() {
      return c.secp256k1;
    } });
  }(secp256k1$8)), secp256k1$8;
}
var bytes$8 = {}, random$4 = {}, utils$g = {}, crypto$5 = {}, hasRequiredCrypto;
function requireCrypto() {
  return hasRequiredCrypto || (hasRequiredCrypto = 1, Object.defineProperty(crypto$5, "__esModule", { value: !0 }), crypto$5.crypto = void 0, crypto$5.crypto = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0), crypto$5;
}
var _assert = {}, hasRequired_assert;
function require_assert() {
  if (hasRequired_assert) return _assert;
  hasRequired_assert = 1, Object.defineProperty(_assert, "__esModule", { value: !0 }), _assert.output = _assert.exists = _assert.hash = _assert.bytes = _assert.bool = _assert.number = _assert.isBytes = void 0;
  function n(le) {
    if (!Number.isSafeInteger(le) || le < 0)
      throw new Error(`positive integer expected, not ${le}`);
  }
  _assert.number = n;
  function c(le) {
    if (typeof le != "boolean")
      throw new Error(`boolean expected, not ${le}`);
  }
  _assert.bool = c;
  function u(le) {
    return le instanceof Uint8Array || le != null && typeof le == "object" && le.constructor.name === "Uint8Array";
  }
  _assert.isBytes = u;
  function p(le, ...L) {
    if (!u(le))
      throw new Error("Uint8Array expected");
    if (L.length > 0 && !L.includes(le.length))
      throw new Error(`Uint8Array expected of length ${L}, not of length=${le.length}`);
  }
  _assert.bytes = p;
  function a(le) {
    if (typeof le != "function" || typeof le.create != "function")
      throw new Error("Hash should be wrapped by utils.wrapConstructor");
    n(le.outputLen), n(le.blockLen);
  }
  _assert.hash = a;
  function A(le, L = !0) {
    if (le.destroyed)
      throw new Error("Hash instance has been destroyed");
    if (L && le.finished)
      throw new Error("Hash#digest() has already been called");
  }
  _assert.exists = A;
  function b(le, L) {
    p(le);
    const pe = L.outputLen;
    if (le.length < pe)
      throw new Error(`digestInto() expects output buffer of length at least ${pe}`);
  }
  _assert.output = b;
  const F = { number: n, bool: c, bytes: p, hash: a, exists: A, output: b };
  return _assert.default = F, _assert;
}
var hasRequiredUtils$9;
function requireUtils$9() {
  return hasRequiredUtils$9 || (hasRequiredUtils$9 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.randomBytes = n.wrapXOFConstructorWithOpts = n.wrapConstructorWithOpts = n.wrapConstructor = n.checkOpts = n.Hash = n.concatBytes = n.toBytes = n.utf8ToBytes = n.asyncLoop = n.nextTick = n.hexToBytes = n.bytesToHex = n.byteSwap32 = n.byteSwapIfBE = n.byteSwap = n.isLE = n.rotl = n.rotr = n.createView = n.u32 = n.u8 = n.isBytes = void 0;
    const c = requireCrypto(), u = require_assert();
    function p(Ie) {
      return Ie instanceof Uint8Array || Ie != null && typeof Ie == "object" && Ie.constructor.name === "Uint8Array";
    }
    n.isBytes = p;
    const a = (Ie) => new Uint8Array(Ie.buffer, Ie.byteOffset, Ie.byteLength);
    n.u8 = a;
    const A = (Ie) => new Uint32Array(Ie.buffer, Ie.byteOffset, Math.floor(Ie.byteLength / 4));
    n.u32 = A;
    const b = (Ie) => new DataView(Ie.buffer, Ie.byteOffset, Ie.byteLength);
    n.createView = b;
    const F = (Ie, xe) => Ie << 32 - xe | Ie >>> xe;
    n.rotr = F;
    const le = (Ie, xe) => Ie << xe | Ie >>> 32 - xe >>> 0;
    n.rotl = le, n.isLE = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
    const L = (Ie) => Ie << 24 & 4278190080 | Ie << 8 & 16711680 | Ie >>> 8 & 65280 | Ie >>> 24 & 255;
    n.byteSwap = L, n.byteSwapIfBE = n.isLE ? (Ie) => Ie : (Ie) => (0, n.byteSwap)(Ie);
    function pe(Ie) {
      for (let xe = 0; xe < Ie.length; xe++)
        Ie[xe] = (0, n.byteSwap)(Ie[xe]);
    }
    n.byteSwap32 = pe;
    const $ = /* @__PURE__ */ Array.from({ length: 256 }, (Ie, xe) => xe.toString(16).padStart(2, "0"));
    function Ee(Ie) {
      (0, u.bytes)(Ie);
      let xe = "";
      for (let rr = 0; rr < Ie.length; rr++)
        xe += $[Ie[rr]];
      return xe;
    }
    n.bytesToHex = Ee;
    const be = { _0: 48, _9: 57, _A: 65, _F: 70, _a: 97, _f: 102 };
    function He(Ie) {
      if (Ie >= be._0 && Ie <= be._9)
        return Ie - be._0;
      if (Ie >= be._A && Ie <= be._F)
        return Ie - (be._A - 10);
      if (Ie >= be._a && Ie <= be._f)
        return Ie - (be._a - 10);
    }
    function Pe(Ie) {
      if (typeof Ie != "string")
        throw new Error("hex string expected, got " + typeof Ie);
      const xe = Ie.length, rr = xe / 2;
      if (xe % 2)
        throw new Error("padded hex string expected, got unpadded hex of length " + xe);
      const ar = new Uint8Array(rr);
      for (let yr = 0, _r = 0; yr < rr; yr++, _r += 2) {
        const Or = He(Ie.charCodeAt(_r)), vr = He(Ie.charCodeAt(_r + 1));
        if (Or === void 0 || vr === void 0) {
          const Te = Ie[_r] + Ie[_r + 1];
          throw new Error('hex string expected, got non-hex character "' + Te + '" at index ' + _r);
        }
        ar[yr] = Or * 16 + vr;
      }
      return ar;
    }
    n.hexToBytes = Pe;
    const nr = async () => {
    };
    n.nextTick = nr;
    async function ir(Ie, xe, rr) {
      let ar = Date.now();
      for (let yr = 0; yr < Ie; yr++) {
        rr(yr);
        const _r = Date.now() - ar;
        _r >= 0 && _r < xe || (await (0, n.nextTick)(), ar += _r);
      }
    }
    n.asyncLoop = ir;
    function or(Ie) {
      if (typeof Ie != "string")
        throw new Error(`utf8ToBytes expected string, got ${typeof Ie}`);
      return new Uint8Array(new TextEncoder().encode(Ie));
    }
    n.utf8ToBytes = or;
    function lr(Ie) {
      return typeof Ie == "string" && (Ie = or(Ie)), (0, u.bytes)(Ie), Ie;
    }
    n.toBytes = lr;
    function Ir(...Ie) {
      let xe = 0;
      for (let ar = 0; ar < Ie.length; ar++) {
        const yr = Ie[ar];
        (0, u.bytes)(yr), xe += yr.length;
      }
      const rr = new Uint8Array(xe);
      for (let ar = 0, yr = 0; ar < Ie.length; ar++) {
        const _r = Ie[ar];
        rr.set(_r, yr), yr += _r.length;
      }
      return rr;
    }
    n.concatBytes = Ir;
    class xr {
      // Safe version that clones internal state
      clone() {
        return this._cloneInto();
      }
    }
    n.Hash = xr;
    const kr = {}.toString;
    function Ce(Ie, xe) {
      if (xe !== void 0 && kr.call(xe) !== "[object Object]")
        throw new Error("Options should be object or undefined");
      return Object.assign(Ie, xe);
    }
    n.checkOpts = Ce;
    function tr(Ie) {
      const xe = (ar) => Ie().update(lr(ar)).digest(), rr = Ie();
      return xe.outputLen = rr.outputLen, xe.blockLen = rr.blockLen, xe.create = () => Ie(), xe;
    }
    n.wrapConstructor = tr;
    function Fe(Ie) {
      const xe = (ar, yr) => Ie(yr).update(lr(ar)).digest(), rr = Ie({});
      return xe.outputLen = rr.outputLen, xe.blockLen = rr.blockLen, xe.create = (ar) => Ie(ar), xe;
    }
    n.wrapConstructorWithOpts = Fe;
    function Sr(Ie) {
      const xe = (ar, yr) => Ie(yr).update(lr(ar)).digest(), rr = Ie({});
      return xe.outputLen = rr.outputLen, xe.blockLen = rr.blockLen, xe.create = (ar) => Ie(ar), xe;
    }
    n.wrapXOFConstructorWithOpts = Sr;
    function er(Ie = 32) {
      if (c.crypto && typeof c.crypto.getRandomValues == "function")
        return c.crypto.getRandomValues(new Uint8Array(Ie));
      throw new Error("crypto.getRandomValues must be defined");
    }
    n.randomBytes = er;
  }(utils$g)), utils$g;
}
var hasRequiredRandom;
function requireRandom() {
  if (hasRequiredRandom) return random$4;
  hasRequiredRandom = 1, Object.defineProperty(random$4, "__esModule", { value: !0 }), random$4.getRandomBytesSync = c, random$4.getRandomBytes = u;
  const n = requireUtils$9();
  function c(p) {
    return (0, n.randomBytes)(p);
  }
  async function u(p) {
    return (0, n.randomBytes)(p);
  }
  return random$4;
}
function commonjsRequire(n) {
  throw new Error('Could not dynamically require "' + n + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var utils$f = { exports: {} };
utils$f.exports;
var hasRequiredUtils$8;
function requireUtils$8() {
  return hasRequiredUtils$8 || (hasRequiredUtils$8 = 1, function(n, c) {
    var u = commonjsGlobal && commonjsGlobal.__importDefault || function(Ee) {
      return Ee && Ee.__esModule ? Ee : { default: Ee };
    };
    Object.defineProperty(c, "__esModule", { value: !0 }), c.crypto = c.utf8ToBytes = c.createView = c.concatBytes = c.toHex = c.bytesToHex = c.assertBytes = c.assertBool = void 0, c.bytesToUtf8 = le, c.hexToBytes = L, c.equalsBytes = pe, c.wrapHash = $;
    const p = u(require_assert()), a = requireUtils$9(), A = p.default.bool;
    c.assertBool = A;
    const b = p.default.bytes;
    c.assertBytes = b;
    var F = requireUtils$9();
    Object.defineProperty(c, "bytesToHex", { enumerable: !0, get: function() {
      return F.bytesToHex;
    } }), Object.defineProperty(c, "toHex", { enumerable: !0, get: function() {
      return F.bytesToHex;
    } }), Object.defineProperty(c, "concatBytes", { enumerable: !0, get: function() {
      return F.concatBytes;
    } }), Object.defineProperty(c, "createView", { enumerable: !0, get: function() {
      return F.createView;
    } }), Object.defineProperty(c, "utf8ToBytes", { enumerable: !0, get: function() {
      return F.utf8ToBytes;
    } });
    function le(Ee) {
      if (!(Ee instanceof Uint8Array))
        throw new TypeError(`bytesToUtf8 expected Uint8Array, got ${typeof Ee}`);
      return new TextDecoder().decode(Ee);
    }
    function L(Ee) {
      const be = Ee.startsWith("0x") ? Ee.substring(2) : Ee;
      return (0, a.hexToBytes)(be);
    }
    function pe(Ee, be) {
      if (Ee.length !== be.length)
        return !1;
      for (let He = 0; He < Ee.length; He++)
        if (Ee[He] !== be[He])
          return !1;
      return !0;
    }
    function $(Ee) {
      return (be) => (p.default.bytes(be), Ee(be));
    }
    c.crypto = (() => {
      const Ee = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0, be = typeof commonjsRequire == "function" && commonjsRequire.bind(n);
      return {
        node: be && !Ee ? be("crypto") : void 0,
        web: Ee
      };
    })();
  }(utils$f, utils$f.exports)), utils$f.exports;
}
var helpers = {}, internal = {}, hasRequiredInternal;
function requireInternal() {
  if (hasRequiredInternal) return internal;
  hasRequiredInternal = 1, Object.defineProperty(internal, "__esModule", { value: !0 }), internal.getKeys = internal.fromAscii = internal.fromUtf8 = internal.toAscii = internal.arrayContainsArray = internal.getBinarySize = internal.padToEven = internal.stripHexPrefix = internal.isHexString = void 0;
  const n = requireBytes$8();
  function c(pe, $) {
    return !(typeof pe != "string" || !pe.match(/^0x[0-9A-Fa-f]*$/) || typeof $ < "u" && $ > 0 && pe.length !== 2 + 2 * $);
  }
  internal.isHexString = c;
  const u = (pe) => {
    if (typeof pe != "string")
      throw new Error(`[stripHexPrefix] input must be type 'string', received ${typeof pe}`);
    return c(pe) ? pe.slice(2) : pe;
  };
  internal.stripHexPrefix = u;
  function p(pe) {
    let $ = pe;
    if (typeof $ != "string")
      throw new Error(`[padToEven] value must be type 'string', received ${typeof $}`);
    return $.length % 2 && ($ = `0${$}`), $;
  }
  internal.padToEven = p;
  function a(pe) {
    if (typeof pe != "string")
      throw new Error(`[getBinarySize] method requires input type 'string', received ${typeof pe}`);
    return (0, n.utf8ToBytes)(pe).byteLength;
  }
  internal.getBinarySize = a;
  function A(pe, $, Ee) {
    if (Array.isArray(pe) !== !0)
      throw new Error(`[arrayContainsArray] method requires input 'superset' to be an array, got type '${typeof pe}'`);
    if (Array.isArray($) !== !0)
      throw new Error(`[arrayContainsArray] method requires input 'subset' to be an array, got type '${typeof $}'`);
    return $[Ee === !0 ? "some" : "every"]((be) => pe.indexOf(be) >= 0);
  }
  internal.arrayContainsArray = A;
  function b(pe) {
    let $ = "", Ee = 0;
    const be = pe.length;
    for (pe.substring(0, 2) === "0x" && (Ee = 2); Ee < be; Ee += 2) {
      const He = parseInt(pe.substr(Ee, 2), 16);
      $ += String.fromCharCode(He);
    }
    return $;
  }
  internal.toAscii = b;
  function F(pe) {
    const $ = (0, n.utf8ToBytes)(pe);
    return `0x${p((0, n.bytesToUnprefixedHex)($)).replace(/^0+|0+$/g, "")}`;
  }
  internal.fromUtf8 = F;
  function le(pe) {
    let $ = "";
    for (let Ee = 0; Ee < pe.length; Ee++) {
      const He = pe.charCodeAt(Ee).toString(16);
      $ += He.length < 2 ? `0${He}` : He;
    }
    return `0x${$}`;
  }
  internal.fromAscii = le;
  function L(pe, $, Ee) {
    if (!Array.isArray(pe))
      throw new Error(`[getKeys] method expects input 'params' to be an array, got ${typeof pe}`);
    if (typeof $ != "string")
      throw new Error(`[getKeys] method expects input 'key' to be type 'string', got ${typeof pe}`);
    const be = [];
    for (let He = 0; He < pe.length; He++) {
      let Pe = pe[He][$];
      if (Ee === !0 && !Pe)
        Pe = "";
      else if (typeof Pe != "string")
        throw new Error(`invalid abi - expected type 'string', received ${typeof Pe}`);
      be.push(Pe);
    }
    return be;
  }
  return internal.getKeys = L, internal;
}
var hasRequiredHelpers;
function requireHelpers() {
  if (hasRequiredHelpers) return helpers;
  hasRequiredHelpers = 1, Object.defineProperty(helpers, "__esModule", { value: !0 }), helpers.assertIsString = helpers.assertIsArray = helpers.assertIsBytes = helpers.assertIsHexString = void 0;
  const n = requireInternal(), c = function(A) {
    if (!(0, n.isHexString)(A)) {
      const b = `This method only supports 0x-prefixed hex strings but input was: ${A}`;
      throw new Error(b);
    }
  };
  helpers.assertIsHexString = c;
  const u = function(A) {
    if (!(A instanceof Uint8Array)) {
      const b = `This method only supports Uint8Array but input was: ${A}`;
      throw new Error(b);
    }
  };
  helpers.assertIsBytes = u;
  const p = function(A) {
    if (!Array.isArray(A)) {
      const b = `This method only supports number arrays but input was: ${A}`;
      throw new Error(b);
    }
  };
  helpers.assertIsArray = p;
  const a = function(A) {
    if (typeof A != "string") {
      const b = `This method only supports strings but input was: ${A}`;
      throw new Error(b);
    }
  };
  return helpers.assertIsString = a, helpers;
}
var hasRequiredBytes$8;
function requireBytes$8() {
  return hasRequiredBytes$8 || (hasRequiredBytes$8 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.hexToBigInt = n.utf8ToBytes = n.equalsBytes = n.bytesToUtf8 = n.bigInt64ToBytes = n.int32ToBytes = n.bytesToBigInt64 = n.bytesToInt32 = n.concatBytes = n.randomBytes = n.compareBytes = n.intToUnpaddedBytes = n.bigIntToAddressBytes = n.bigIntToUnpaddedBytes = n.bigIntMin = n.bigIntMax = n.bigIntToHex = n.validateNoLeadingZeroes = n.short = n.addHexPrefix = n.toUnsigned = n.fromSigned = n.toBytes = n.unpadHex = n.unpadArray = n.unpadBytes = n.setLengthRight = n.setLengthLeft = n.zeros = n.bigIntToBytes = n.intToBytes = n.intToHex = n.hexToBytes = n.bytesToInt = n.bytesToBigInt = n.bytesToHex = n.unprefixedHexToBytes = n.bytesToUnprefixedHex = void 0;
    const c = requireRandom(), u = requireUtils$8(), p = requireHelpers(), a = requireInternal(), A = BigInt(0);
    n.bytesToUnprefixedHex = u.bytesToHex;
    const b = {}, F = {};
    for (let Vr = 0; Vr < 16; Vr++) {
      const qr = Vr, Zi = Vr * 16, Wr = Vr.toString(16).toLowerCase();
      F[Wr] = qr, F[Wr.toUpperCase()] = qr, b[Wr] = Zi, b[Wr.toUpperCase()] = Zi;
    }
    function le(Vr) {
      const qr = Vr.length, Zi = new Uint8Array(qr / 2);
      for (let Wr = 0; Wr < qr; Wr += 2)
        Zi[Wr / 2] = b[Vr[Wr]] + F[Vr[Wr + 1]];
      return Zi;
    }
    const L = (Vr) => {
      if (Vr.slice(0, 2) === "0x")
        throw new Error("hex string is prefixed with 0x, should be unprefixed");
      return le((0, a.padToEven)(Vr));
    };
    n.unprefixedHexToBytes = L;
    const pe = Array.from({ length: 256 }, (Vr, qr) => qr.toString(16).padStart(2, "0")), $ = (Vr) => {
      let qr = "0x";
      if (Vr === void 0 || Vr.length === 0)
        return qr;
      for (const Zi of Vr)
        qr = `${qr}${pe[Zi]}`;
      return qr;
    };
    n.bytesToHex = $;
    const Ee = [];
    for (let Vr = 0; Vr <= 256 * 256 - 1; Vr++)
      Ee[Vr] = BigInt(Vr);
    const be = (Vr, qr = !1) => {
      qr && Vr.reverse();
      const Zi = (0, n.bytesToHex)(Vr);
      return Zi === "0x" ? A : Zi.length === 4 ? Ee[Vr[0]] : Zi.length === 6 ? Ee[Vr[0] * 256 + Vr[1]] : BigInt(Zi);
    };
    n.bytesToBigInt = be;
    const He = (Vr) => {
      const qr = Number((0, n.bytesToBigInt)(Vr));
      if (!Number.isSafeInteger(qr))
        throw new Error("Number exceeds 53 bits");
      return qr;
    };
    n.bytesToInt = He;
    const Pe = (Vr) => {
      if (typeof Vr != "string")
        throw new Error(`hex argument type ${typeof Vr} must be of type string`);
      if (!/^0x[0-9a-fA-F]*$/.test(Vr))
        throw new Error(`Input must be a 0x-prefixed hexadecimal string, got ${Vr}`);
      const qr = Vr.slice(2);
      return le(qr.length % 2 === 0 ? qr : (0, a.padToEven)(qr));
    };
    n.hexToBytes = Pe;
    const nr = (Vr) => {
      if (!Number.isSafeInteger(Vr) || Vr < 0)
        throw new Error(`Received an invalid integer type: ${Vr}`);
      return `0x${Vr.toString(16)}`;
    };
    n.intToHex = nr;
    const ir = (Vr) => {
      const qr = (0, n.intToHex)(Vr);
      return (0, n.hexToBytes)(qr);
    };
    n.intToBytes = ir;
    const or = (Vr, qr = !1) => {
      const Zi = (0, n.toBytes)(`0x${(0, a.padToEven)(Vr.toString(16))}`);
      return qr ? Zi.reverse() : Zi;
    };
    n.bigIntToBytes = or;
    const lr = (Vr) => new Uint8Array(Vr);
    n.zeros = lr;
    const Ir = (Vr, qr, Zi) => Zi ? Vr.length < qr ? new Uint8Array([...Vr, ...(0, n.zeros)(qr - Vr.length)]) : Vr.subarray(0, qr) : Vr.length < qr ? new Uint8Array([...(0, n.zeros)(qr - Vr.length), ...Vr]) : Vr.subarray(-qr), xr = (Vr, qr) => ((0, p.assertIsBytes)(Vr), Ir(Vr, qr, !1));
    n.setLengthLeft = xr;
    const kr = (Vr, qr) => ((0, p.assertIsBytes)(Vr), Ir(Vr, qr, !0));
    n.setLengthRight = kr;
    const Ce = (Vr) => {
      let qr = Vr[0];
      for (; Vr.length > 0 && qr.toString() === "0"; )
        Vr = Vr.slice(1), qr = Vr[0];
      return Vr;
    }, tr = (Vr) => ((0, p.assertIsBytes)(Vr), Ce(Vr));
    n.unpadBytes = tr;
    const Fe = (Vr) => ((0, p.assertIsArray)(Vr), Ce(Vr));
    n.unpadArray = Fe;
    const Sr = (Vr) => ((0, p.assertIsHexString)(Vr), `0x${Ce((0, a.stripHexPrefix)(Vr))}`);
    n.unpadHex = Sr;
    const er = (Vr) => {
      if (Vr == null)
        return new Uint8Array();
      if (Array.isArray(Vr) || Vr instanceof Uint8Array)
        return Uint8Array.from(Vr);
      if (typeof Vr == "string") {
        if (!(0, a.isHexString)(Vr))
          throw new Error(`Cannot convert string to Uint8Array. toBytes only supports 0x-prefixed hex strings and this string was given: ${Vr}`);
        return (0, n.hexToBytes)(Vr);
      }
      if (typeof Vr == "number")
        return (0, n.intToBytes)(Vr);
      if (typeof Vr == "bigint") {
        if (Vr < A)
          throw new Error(`Cannot convert negative bigint to Uint8Array. Given: ${Vr}`);
        let qr = Vr.toString(16);
        return qr.length % 2 && (qr = "0" + qr), (0, n.unprefixedHexToBytes)(qr);
      }
      if (Vr.toBytes !== void 0)
        return Vr.toBytes();
      throw new Error("invalid type");
    };
    n.toBytes = er;
    const Ie = (Vr) => BigInt.asIntN(256, (0, n.bytesToBigInt)(Vr));
    n.fromSigned = Ie;
    const xe = (Vr) => (0, n.bigIntToBytes)(BigInt.asUintN(256, Vr));
    n.toUnsigned = xe;
    const rr = (Vr) => typeof Vr != "string" || (0, a.isHexString)(Vr) ? Vr : `0x${Vr}`;
    n.addHexPrefix = rr;
    const ar = (Vr, qr = 50) => {
      const Zi = Vr instanceof Uint8Array ? (0, n.bytesToHex)(Vr) : Vr, Wr = Zi.slice(0, 2) === "0x" ? qr + 2 : qr;
      return Zi.length <= Wr ? Zi : Zi.slice(0, Wr) + "…";
    };
    n.short = ar;
    const yr = (Vr) => {
      for (const [qr, Zi] of Object.entries(Vr))
        if (Zi !== void 0 && Zi.length > 0 && Zi[0] === 0)
          throw new Error(`${qr} cannot have leading zeroes, received: ${(0, n.bytesToHex)(Zi)}`);
    };
    n.validateNoLeadingZeroes = yr;
    const _r = (Vr) => `0x${Vr.toString(16)}`;
    n.bigIntToHex = _r;
    const Or = (...Vr) => Vr.reduce((qr, Zi) => Zi > qr ? Zi : qr);
    n.bigIntMax = Or;
    const vr = (...Vr) => Vr.reduce((qr, Zi) => Zi < qr ? Zi : qr);
    n.bigIntMin = vr;
    const Te = (Vr) => (0, n.unpadBytes)((0, n.bigIntToBytes)(Vr));
    n.bigIntToUnpaddedBytes = Te;
    const Cr = (Vr, qr = !0) => {
      const Zi = (0, n.bigIntToBytes)(Vr);
      if (qr && Zi.length > 20)
        throw Error(`Invalid address bytes length=${Zi.length} strict=${qr}`);
      return (0, n.setLengthLeft)(Zi, 20);
    };
    n.bigIntToAddressBytes = Cr;
    const Hr = (Vr) => (0, n.unpadBytes)((0, n.intToBytes)(Vr));
    n.intToUnpaddedBytes = Hr;
    const si = (Vr, qr) => {
      const Zi = (0, n.bytesToBigInt)(Vr), Wr = (0, n.bytesToBigInt)(qr);
      return Zi > Wr ? 1 : Zi < Wr ? -1 : 0;
    };
    n.compareBytes = si;
    const ui = (Vr) => (0, c.getRandomBytesSync)(Vr);
    n.randomBytes = ui;
    const Li = (...Vr) => {
      if (Vr.length === 1)
        return Vr[0];
      const qr = Vr.reduce((Wr, ri) => Wr + ri.length, 0), Zi = new Uint8Array(qr);
      for (let Wr = 0, ri = 0; Wr < Vr.length; Wr++) {
        const _i = Vr[Wr];
        Zi.set(_i, ri), ri += _i.length;
      }
      return Zi;
    };
    n.concatBytes = Li;
    function Qi(Vr, qr = !1) {
      return Vr.length < 4 && (Vr = Ir(Vr, 4, qr)), new DataView(Vr.buffer, Vr.byteOffset, Vr.byteLength).getUint32(0, qr);
    }
    n.bytesToInt32 = Qi;
    function wi(Vr, qr = !1) {
      return Vr.length < 8 && (Vr = Ir(Vr, 8, qr)), new DataView(Vr.buffer, Vr.byteOffset, Vr.byteLength).getBigUint64(0, qr);
    }
    n.bytesToBigInt64 = wi;
    function Ji(Vr, qr = !1) {
      const Zi = new ArrayBuffer(4);
      return new DataView(Zi).setUint32(0, Vr, qr), new Uint8Array(Zi);
    }
    n.int32ToBytes = Ji;
    function mn(Vr, qr = !1) {
      const Zi = new ArrayBuffer(8);
      return new DataView(Zi).setBigUint64(0, Vr, qr), new Uint8Array(Zi);
    }
    n.bigInt64ToBytes = mn;
    var pi = requireUtils$8();
    Object.defineProperty(n, "bytesToUtf8", { enumerable: !0, get: function() {
      return pi.bytesToUtf8;
    } }), Object.defineProperty(n, "equalsBytes", { enumerable: !0, get: function() {
      return pi.equalsBytes;
    } }), Object.defineProperty(n, "utf8ToBytes", { enumerable: !0, get: function() {
      return pi.utf8ToBytes;
    } });
    function ei(Vr) {
      return (0, n.bytesToBigInt)((0, n.hexToBytes)((0, a.isHexString)(Vr) ? Vr : `0x${Vr}`));
    }
    n.hexToBigInt = ei;
  }(bytes$8)), bytes$8;
}
var hasRequiredConstants;
function requireConstants() {
  return hasRequiredConstants || (hasRequiredConstants = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.BIGINT_2EXP256 = n.BIGINT_2EXP224 = n.BIGINT_2EXP160 = n.BIGINT_2EXP96 = n.BIGINT_224 = n.BIGINT_160 = n.BIGINT_100 = n.BIGINT_96 = n.BIGINT_256 = n.BIGINT_255 = n.BIGINT_128 = n.BIGINT_64 = n.BIGINT_32 = n.BIGINT_31 = n.BIGINT_28 = n.BIGINT_27 = n.BIGINT_8 = n.BIGINT_7 = n.BIGINT_3 = n.BIGINT_2 = n.BIGINT_1 = n.BIGINT_0 = n.BIGINT_NEG1 = n.RIPEMD160_ADDRESS_STRING = n.MAX_WITHDRAWALS_PER_PAYLOAD = n.RLP_EMPTY_STRING = n.KECCAK256_RLP = n.KECCAK256_RLP_S = n.KECCAK256_RLP_ARRAY = n.KECCAK256_RLP_ARRAY_S = n.KECCAK256_NULL = n.KECCAK256_NULL_S = n.TWO_POW256 = n.SECP256K1_ORDER_DIV_2 = n.SECP256K1_ORDER = n.MAX_INTEGER_BIGINT = n.MAX_INTEGER = n.MAX_UINT64 = void 0;
    const c = requireSecp256k1(), u = requireBytes$8();
    n.MAX_UINT64 = BigInt("0xffffffffffffffff"), n.MAX_INTEGER = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"), n.MAX_INTEGER_BIGINT = BigInt("115792089237316195423570985008687907853269984665640564039457584007913129639935"), n.SECP256K1_ORDER = c.secp256k1.CURVE.n, n.SECP256K1_ORDER_DIV_2 = c.secp256k1.CURVE.n / BigInt(2), n.TWO_POW256 = BigInt("0x10000000000000000000000000000000000000000000000000000000000000000"), n.KECCAK256_NULL_S = "0xc5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470", n.KECCAK256_NULL = (0, u.hexToBytes)(n.KECCAK256_NULL_S), n.KECCAK256_RLP_ARRAY_S = "0x1dcc4de8dec75d7aab85b567b6ccd41ad312451b948a7413f0a142fd40d49347", n.KECCAK256_RLP_ARRAY = (0, u.hexToBytes)(n.KECCAK256_RLP_ARRAY_S), n.KECCAK256_RLP_S = "0x56e81f171bcc55a6ff8345e692c0f86e5b48e01b996cadc001622fb5e363b421", n.KECCAK256_RLP = (0, u.hexToBytes)(n.KECCAK256_RLP_S), n.RLP_EMPTY_STRING = Uint8Array.from([128]), n.MAX_WITHDRAWALS_PER_PAYLOAD = 16, n.RIPEMD160_ADDRESS_STRING = "0000000000000000000000000000000000000003", n.BIGINT_NEG1 = BigInt(-1), n.BIGINT_0 = BigInt(0), n.BIGINT_1 = BigInt(1), n.BIGINT_2 = BigInt(2), n.BIGINT_3 = BigInt(3), n.BIGINT_7 = BigInt(7), n.BIGINT_8 = BigInt(8), n.BIGINT_27 = BigInt(27), n.BIGINT_28 = BigInt(28), n.BIGINT_31 = BigInt(31), n.BIGINT_32 = BigInt(32), n.BIGINT_64 = BigInt(64), n.BIGINT_128 = BigInt(128), n.BIGINT_255 = BigInt(255), n.BIGINT_256 = BigInt(256), n.BIGINT_96 = BigInt(96), n.BIGINT_100 = BigInt(100), n.BIGINT_160 = BigInt(160), n.BIGINT_224 = BigInt(224), n.BIGINT_2EXP96 = BigInt(7922816251426434e13), n.BIGINT_2EXP160 = BigInt(1461501637330903e33), n.BIGINT_2EXP224 = BigInt(2695994666715064e52), n.BIGINT_2EXP256 = n.BIGINT_2 ** n.BIGINT_256;
  }(constants$6)), constants$6;
}
var units = {}, hasRequiredUnits;
function requireUnits() {
  if (hasRequiredUnits) return units;
  hasRequiredUnits = 1, Object.defineProperty(units, "__esModule", { value: !0 }), units.formatBigDecimal = units.GWEI_TO_WEI = void 0;
  const n = requireConstants();
  units.GWEI_TO_WEI = BigInt(1e9);
  function c(u, p, a) {
    p === n.BIGINT_0 && (p = n.BIGINT_1);
    const A = u / p, b = (u - A * p) * a / p, F = String(a).length - 1 - String(b).length;
    return `${A}.${"0".repeat(F)}${b}`;
  }
  return units.formatBigDecimal = c, units;
}
var account$2 = {}, cjs$2 = {}, hasRequiredCjs$1;
function requireCjs$1() {
  if (hasRequiredCjs$1) return cjs$2;
  hasRequiredCjs$1 = 1, Object.defineProperty(cjs$2, "__esModule", { value: !0 }), cjs$2.RLP = cjs$2.utils = cjs$2.decode = cjs$2.encode = void 0;
  function n(ir) {
    if (Array.isArray(ir)) {
      const lr = [];
      let Ir = 0;
      for (let xr = 0; xr < ir.length; xr++) {
        const kr = n(ir[xr]);
        lr.push(kr), Ir += kr.length;
      }
      return pe(p(Ir, 192), ...lr);
    }
    const or = nr(ir);
    return or.length === 1 && or[0] < 128 ? or : pe(p(or.length, 128), or);
  }
  cjs$2.encode = n;
  function c(ir, or, lr) {
    if (lr > ir.length)
      throw new Error("invalid RLP (safeSlice): end slice of Uint8Array out-of-bounds");
    return ir.slice(or, lr);
  }
  function u(ir) {
    if (ir[0] === 0)
      throw new Error("invalid RLP: extra zeros");
    return le(F(ir));
  }
  function p(ir, or) {
    if (ir < 56)
      return Uint8Array.from([ir + or]);
    const lr = Ee(ir), Ir = lr.length / 2, xr = Ee(or + 55 + Ir);
    return Uint8Array.from(L(xr + lr));
  }
  function a(ir, or = !1) {
    if (typeof ir > "u" || ir === null || ir.length === 0)
      return Uint8Array.from([]);
    const lr = nr(ir), Ir = A(lr);
    if (or)
      return {
        data: Ir.data,
        remainder: Ir.remainder.slice()
      };
    if (Ir.remainder.length !== 0)
      throw new Error("invalid RLP: remainder must be zero");
    return Ir.data;
  }
  cjs$2.decode = a;
  function A(ir) {
    let or, lr, Ir, xr, kr;
    const Ce = [], tr = ir[0];
    if (tr <= 127)
      return {
        data: ir.slice(0, 1),
        remainder: ir.subarray(1)
      };
    if (tr <= 183) {
      if (or = tr - 127, tr === 128 ? Ir = Uint8Array.from([]) : Ir = c(ir, 1, or), or === 2 && Ir[0] < 128)
        throw new Error("invalid RLP encoding: invalid prefix, single byte < 0x80 are not prefixed");
      return {
        data: Ir,
        remainder: ir.subarray(or)
      };
    } else if (tr <= 191) {
      if (lr = tr - 182, ir.length - 1 < lr)
        throw new Error("invalid RLP: not enough bytes for string length");
      if (or = u(c(ir, 1, lr)), or <= 55)
        throw new Error("invalid RLP: expected string length to be greater than 55");
      return Ir = c(ir, lr, or + lr), {
        data: Ir,
        remainder: ir.subarray(or + lr)
      };
    } else if (tr <= 247) {
      for (or = tr - 191, xr = c(ir, 1, or); xr.length; )
        kr = A(xr), Ce.push(kr.data), xr = kr.remainder;
      return {
        data: Ce,
        remainder: ir.subarray(or)
      };
    } else {
      if (lr = tr - 246, or = u(c(ir, 1, lr)), or < 56)
        throw new Error("invalid RLP: encoded list too short");
      const Fe = lr + or;
      if (Fe > ir.length)
        throw new Error("invalid RLP: total length is larger than the data");
      for (xr = c(ir, lr, Fe); xr.length; )
        kr = A(xr), Ce.push(kr.data), xr = kr.remainder;
      return {
        data: Ce,
        remainder: ir.subarray(Fe)
      };
    }
  }
  const b = Array.from({ length: 256 }, (ir, or) => or.toString(16).padStart(2, "0"));
  function F(ir) {
    let or = "";
    for (let lr = 0; lr < ir.length; lr++)
      or += b[ir[lr]];
    return or;
  }
  function le(ir) {
    const or = Number.parseInt(ir, 16);
    if (Number.isNaN(or))
      throw new Error("Invalid byte sequence");
    return or;
  }
  function L(ir) {
    if (typeof ir != "string")
      throw new TypeError("hexToBytes: expected string, got " + typeof ir);
    if (ir.length % 2)
      throw new Error("hexToBytes: received invalid unpadded hex");
    const or = new Uint8Array(ir.length / 2);
    for (let lr = 0; lr < or.length; lr++) {
      const Ir = lr * 2;
      or[lr] = le(ir.slice(Ir, Ir + 2));
    }
    return or;
  }
  function pe(...ir) {
    if (ir.length === 1)
      return ir[0];
    const or = ir.reduce((Ir, xr) => Ir + xr.length, 0), lr = new Uint8Array(or);
    for (let Ir = 0, xr = 0; Ir < ir.length; Ir++) {
      const kr = ir[Ir];
      lr.set(kr, xr), xr += kr.length;
    }
    return lr;
  }
  function $(ir) {
    return new TextEncoder().encode(ir);
  }
  function Ee(ir) {
    if (ir < 0)
      throw new Error("Invalid integer as argument, must be unsigned!");
    const or = ir.toString(16);
    return or.length % 2 ? `0${or}` : or;
  }
  function be(ir) {
    return ir.length % 2 ? `0${ir}` : ir;
  }
  function He(ir) {
    return ir.length >= 2 && ir[0] === "0" && ir[1] === "x";
  }
  function Pe(ir) {
    return typeof ir != "string" ? ir : He(ir) ? ir.slice(2) : ir;
  }
  function nr(ir) {
    if (ir instanceof Uint8Array)
      return ir;
    if (typeof ir == "string")
      return He(ir) ? L(be(Pe(ir))) : $(ir);
    if (typeof ir == "number" || typeof ir == "bigint")
      return ir ? L(Ee(ir)) : Uint8Array.from([]);
    if (ir == null)
      return Uint8Array.from([]);
    throw new Error("toBytes: received unsupported type " + typeof ir);
  }
  return cjs$2.utils = {
    bytesToHex: F,
    concatBytes: pe,
    hexToBytes: L,
    utf8ToBytes: $
  }, cjs$2.RLP = { encode: n, decode: a }, cjs$2;
}
var keccak$1 = {}, sha3$1 = {}, _u64 = {}, hasRequired_u64;
function require_u64() {
  if (hasRequired_u64) return _u64;
  hasRequired_u64 = 1, Object.defineProperty(_u64, "__esModule", { value: !0 }), _u64.add5L = _u64.add5H = _u64.add4H = _u64.add4L = _u64.add3H = _u64.add3L = _u64.add = _u64.rotlBL = _u64.rotlBH = _u64.rotlSL = _u64.rotlSH = _u64.rotr32L = _u64.rotr32H = _u64.rotrBL = _u64.rotrBH = _u64.rotrSL = _u64.rotrSH = _u64.shrSL = _u64.shrSH = _u64.toBig = _u64.split = _u64.fromBig = void 0;
  const n = /* @__PURE__ */ BigInt(2 ** 32 - 1), c = /* @__PURE__ */ BigInt(32);
  function u(Fe, Sr = !1) {
    return Sr ? { h: Number(Fe & n), l: Number(Fe >> c & n) } : { h: Number(Fe >> c & n) | 0, l: Number(Fe & n) | 0 };
  }
  _u64.fromBig = u;
  function p(Fe, Sr = !1) {
    let er = new Uint32Array(Fe.length), Ie = new Uint32Array(Fe.length);
    for (let xe = 0; xe < Fe.length; xe++) {
      const { h: rr, l: ar } = u(Fe[xe], Sr);
      [er[xe], Ie[xe]] = [rr, ar];
    }
    return [er, Ie];
  }
  _u64.split = p;
  const a = (Fe, Sr) => BigInt(Fe >>> 0) << c | BigInt(Sr >>> 0);
  _u64.toBig = a;
  const A = (Fe, Sr, er) => Fe >>> er;
  _u64.shrSH = A;
  const b = (Fe, Sr, er) => Fe << 32 - er | Sr >>> er;
  _u64.shrSL = b;
  const F = (Fe, Sr, er) => Fe >>> er | Sr << 32 - er;
  _u64.rotrSH = F;
  const le = (Fe, Sr, er) => Fe << 32 - er | Sr >>> er;
  _u64.rotrSL = le;
  const L = (Fe, Sr, er) => Fe << 64 - er | Sr >>> er - 32;
  _u64.rotrBH = L;
  const pe = (Fe, Sr, er) => Fe >>> er - 32 | Sr << 64 - er;
  _u64.rotrBL = pe;
  const $ = (Fe, Sr) => Sr;
  _u64.rotr32H = $;
  const Ee = (Fe, Sr) => Fe;
  _u64.rotr32L = Ee;
  const be = (Fe, Sr, er) => Fe << er | Sr >>> 32 - er;
  _u64.rotlSH = be;
  const He = (Fe, Sr, er) => Sr << er | Fe >>> 32 - er;
  _u64.rotlSL = He;
  const Pe = (Fe, Sr, er) => Sr << er - 32 | Fe >>> 64 - er;
  _u64.rotlBH = Pe;
  const nr = (Fe, Sr, er) => Fe << er - 32 | Sr >>> 64 - er;
  _u64.rotlBL = nr;
  function ir(Fe, Sr, er, Ie) {
    const xe = (Sr >>> 0) + (Ie >>> 0);
    return { h: Fe + er + (xe / 2 ** 32 | 0) | 0, l: xe | 0 };
  }
  _u64.add = ir;
  const or = (Fe, Sr, er) => (Fe >>> 0) + (Sr >>> 0) + (er >>> 0);
  _u64.add3L = or;
  const lr = (Fe, Sr, er, Ie) => Sr + er + Ie + (Fe / 2 ** 32 | 0) | 0;
  _u64.add3H = lr;
  const Ir = (Fe, Sr, er, Ie) => (Fe >>> 0) + (Sr >>> 0) + (er >>> 0) + (Ie >>> 0);
  _u64.add4L = Ir;
  const xr = (Fe, Sr, er, Ie, xe) => Sr + er + Ie + xe + (Fe / 2 ** 32 | 0) | 0;
  _u64.add4H = xr;
  const kr = (Fe, Sr, er, Ie, xe) => (Fe >>> 0) + (Sr >>> 0) + (er >>> 0) + (Ie >>> 0) + (xe >>> 0);
  _u64.add5L = kr;
  const Ce = (Fe, Sr, er, Ie, xe, rr) => Sr + er + Ie + xe + rr + (Fe / 2 ** 32 | 0) | 0;
  _u64.add5H = Ce;
  const tr = {
    fromBig: u,
    split: p,
    toBig: a,
    shrSH: A,
    shrSL: b,
    rotrSH: F,
    rotrSL: le,
    rotrBH: L,
    rotrBL: pe,
    rotr32H: $,
    rotr32L: Ee,
    rotlSH: be,
    rotlSL: He,
    rotlBH: Pe,
    rotlBL: nr,
    add: ir,
    add3L: or,
    add3H: lr,
    add4L: Ir,
    add4H: xr,
    add5H: Ce,
    add5L: kr
  };
  return _u64.default = tr, _u64;
}
var hasRequiredSha3;
function requireSha3() {
  if (hasRequiredSha3) return sha3$1;
  hasRequiredSha3 = 1, Object.defineProperty(sha3$1, "__esModule", { value: !0 }), sha3$1.shake256 = sha3$1.shake128 = sha3$1.keccak_512 = sha3$1.keccak_384 = sha3$1.keccak_256 = sha3$1.keccak_224 = sha3$1.sha3_512 = sha3$1.sha3_384 = sha3$1.sha3_256 = sha3$1.sha3_224 = sha3$1.Keccak = sha3$1.keccakP = void 0;
  const n = require_assert(), c = require_u64(), u = requireUtils$9(), p = [], a = [], A = [], b = /* @__PURE__ */ BigInt(0), F = /* @__PURE__ */ BigInt(1), le = /* @__PURE__ */ BigInt(2), L = /* @__PURE__ */ BigInt(7), pe = /* @__PURE__ */ BigInt(256), $ = /* @__PURE__ */ BigInt(113);
  for (let Ir = 0, xr = F, kr = 1, Ce = 0; Ir < 24; Ir++) {
    [kr, Ce] = [Ce, (2 * kr + 3 * Ce) % 5], p.push(2 * (5 * Ce + kr)), a.push((Ir + 1) * (Ir + 2) / 2 % 64);
    let tr = b;
    for (let Fe = 0; Fe < 7; Fe++)
      xr = (xr << F ^ (xr >> L) * $) % pe, xr & le && (tr ^= F << (F << /* @__PURE__ */ BigInt(Fe)) - F);
    A.push(tr);
  }
  const [Ee, be] = /* @__PURE__ */ (0, c.split)(A, !0), He = (Ir, xr, kr) => kr > 32 ? (0, c.rotlBH)(Ir, xr, kr) : (0, c.rotlSH)(Ir, xr, kr), Pe = (Ir, xr, kr) => kr > 32 ? (0, c.rotlBL)(Ir, xr, kr) : (0, c.rotlSL)(Ir, xr, kr);
  function nr(Ir, xr = 24) {
    const kr = new Uint32Array(10);
    for (let Ce = 24 - xr; Ce < 24; Ce++) {
      for (let Sr = 0; Sr < 10; Sr++)
        kr[Sr] = Ir[Sr] ^ Ir[Sr + 10] ^ Ir[Sr + 20] ^ Ir[Sr + 30] ^ Ir[Sr + 40];
      for (let Sr = 0; Sr < 10; Sr += 2) {
        const er = (Sr + 8) % 10, Ie = (Sr + 2) % 10, xe = kr[Ie], rr = kr[Ie + 1], ar = He(xe, rr, 1) ^ kr[er], yr = Pe(xe, rr, 1) ^ kr[er + 1];
        for (let _r = 0; _r < 50; _r += 10)
          Ir[Sr + _r] ^= ar, Ir[Sr + _r + 1] ^= yr;
      }
      let tr = Ir[2], Fe = Ir[3];
      for (let Sr = 0; Sr < 24; Sr++) {
        const er = a[Sr], Ie = He(tr, Fe, er), xe = Pe(tr, Fe, er), rr = p[Sr];
        tr = Ir[rr], Fe = Ir[rr + 1], Ir[rr] = Ie, Ir[rr + 1] = xe;
      }
      for (let Sr = 0; Sr < 50; Sr += 10) {
        for (let er = 0; er < 10; er++)
          kr[er] = Ir[Sr + er];
        for (let er = 0; er < 10; er++)
          Ir[Sr + er] ^= ~kr[(er + 2) % 10] & kr[(er + 4) % 10];
      }
      Ir[0] ^= Ee[Ce], Ir[1] ^= be[Ce];
    }
    kr.fill(0);
  }
  sha3$1.keccakP = nr;
  class ir extends u.Hash {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(xr, kr, Ce, tr = !1, Fe = 24) {
      if (super(), this.blockLen = xr, this.suffix = kr, this.outputLen = Ce, this.enableXOF = tr, this.rounds = Fe, this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, (0, n.number)(Ce), 0 >= this.blockLen || this.blockLen >= 200)
        throw new Error("Sha3 supports only keccak-f1600 function");
      this.state = new Uint8Array(200), this.state32 = (0, u.u32)(this.state);
    }
    keccak() {
      u.isLE || (0, u.byteSwap32)(this.state32), nr(this.state32, this.rounds), u.isLE || (0, u.byteSwap32)(this.state32), this.posOut = 0, this.pos = 0;
    }
    update(xr) {
      (0, n.exists)(this);
      const { blockLen: kr, state: Ce } = this;
      xr = (0, u.toBytes)(xr);
      const tr = xr.length;
      for (let Fe = 0; Fe < tr; ) {
        const Sr = Math.min(kr - this.pos, tr - Fe);
        for (let er = 0; er < Sr; er++)
          Ce[this.pos++] ^= xr[Fe++];
        this.pos === kr && this.keccak();
      }
      return this;
    }
    finish() {
      if (this.finished)
        return;
      this.finished = !0;
      const { state: xr, suffix: kr, pos: Ce, blockLen: tr } = this;
      xr[Ce] ^= kr, kr & 128 && Ce === tr - 1 && this.keccak(), xr[tr - 1] ^= 128, this.keccak();
    }
    writeInto(xr) {
      (0, n.exists)(this, !1), (0, n.bytes)(xr), this.finish();
      const kr = this.state, { blockLen: Ce } = this;
      for (let tr = 0, Fe = xr.length; tr < Fe; ) {
        this.posOut >= Ce && this.keccak();
        const Sr = Math.min(Ce - this.posOut, Fe - tr);
        xr.set(kr.subarray(this.posOut, this.posOut + Sr), tr), this.posOut += Sr, tr += Sr;
      }
      return xr;
    }
    xofInto(xr) {
      if (!this.enableXOF)
        throw new Error("XOF is not possible for this instance");
      return this.writeInto(xr);
    }
    xof(xr) {
      return (0, n.number)(xr), this.xofInto(new Uint8Array(xr));
    }
    digestInto(xr) {
      if ((0, n.output)(xr, this), this.finished)
        throw new Error("digest() was already called");
      return this.writeInto(xr), this.destroy(), xr;
    }
    digest() {
      return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
      this.destroyed = !0, this.state.fill(0);
    }
    _cloneInto(xr) {
      const { blockLen: kr, suffix: Ce, outputLen: tr, rounds: Fe, enableXOF: Sr } = this;
      return xr || (xr = new ir(kr, Ce, tr, Sr, Fe)), xr.state32.set(this.state32), xr.pos = this.pos, xr.posOut = this.posOut, xr.finished = this.finished, xr.rounds = Fe, xr.suffix = Ce, xr.outputLen = tr, xr.enableXOF = Sr, xr.destroyed = this.destroyed, xr;
    }
  }
  sha3$1.Keccak = ir;
  const or = (Ir, xr, kr) => (0, u.wrapConstructor)(() => new ir(xr, Ir, kr));
  sha3$1.sha3_224 = or(6, 144, 224 / 8), sha3$1.sha3_256 = or(6, 136, 256 / 8), sha3$1.sha3_384 = or(6, 104, 384 / 8), sha3$1.sha3_512 = or(6, 72, 512 / 8), sha3$1.keccak_224 = or(1, 144, 224 / 8), sha3$1.keccak_256 = or(1, 136, 256 / 8), sha3$1.keccak_384 = or(1, 104, 384 / 8), sha3$1.keccak_512 = or(1, 72, 512 / 8);
  const lr = (Ir, xr, kr) => (0, u.wrapXOFConstructorWithOpts)((Ce = {}) => new ir(xr, Ir, Ce.dkLen === void 0 ? kr : Ce.dkLen, !0));
  return sha3$1.shake128 = lr(31, 168, 128 / 8), sha3$1.shake256 = lr(31, 136, 256 / 8), sha3$1;
}
var hasRequiredKeccak;
function requireKeccak() {
  if (hasRequiredKeccak) return keccak$1;
  hasRequiredKeccak = 1, Object.defineProperty(keccak$1, "__esModule", { value: !0 }), keccak$1.keccak512 = keccak$1.keccak384 = keccak$1.keccak256 = keccak$1.keccak224 = void 0;
  const n = requireSha3(), c = requireUtils$8();
  return keccak$1.keccak224 = (0, c.wrapHash)(n.keccak_224), keccak$1.keccak256 = (() => {
    const u = (0, c.wrapHash)(n.keccak_256);
    return u.create = n.keccak_256.create, u;
  })(), keccak$1.keccak384 = (0, c.wrapHash)(n.keccak_384), keccak$1.keccak512 = (0, c.wrapHash)(n.keccak_512), keccak$1;
}
var hasRequiredAccount;
function requireAccount() {
  return hasRequiredAccount || (hasRequiredAccount = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.accountBodyToRLP = n.accountBodyToSlim = n.accountBodyFromSlim = n.isZeroAddress = n.zeroAddress = n.importPublic = n.privateToAddress = n.privateToPublic = n.publicToAddress = n.pubToAddress = n.isValidPublic = n.isValidPrivate = n.generateAddress2 = n.generateAddress = n.isValidChecksumAddress = n.toChecksumAddress = n.isValidAddress = n.Account = void 0;
    const c = requireCjs$1(), u = requireKeccak(), p = requireSecp256k1(), a = requireBytes$8(), A = requireConstants(), b = requireHelpers(), F = requireInternal();
    class le {
      /**
       * This constructor assigns and validates the values.
       * Use the static factory methods to assist in creating an Account from varying data types.
       * undefined get assigned with the defaults present, but null args are retained as is
       */
      constructor(er = A.BIGINT_0, Ie = A.BIGINT_0, xe = A.KECCAK256_RLP, rr = A.KECCAK256_NULL, ar = null, yr = 0) {
        this._nonce = null, this._balance = null, this._storageRoot = null, this._codeHash = null, this._codeSize = null, this._version = null, this._nonce = er, this._balance = Ie, this._storageRoot = xe, this._codeHash = rr, ar === null && rr !== null && !this.isContract() && (ar = 0), this._codeSize = ar, this._version = yr, this._validate();
      }
      get version() {
        if (this._version !== null)
          return this._version;
        throw Error(`version=${this._version} not loaded`);
      }
      set version(er) {
        this._version = er;
      }
      get nonce() {
        if (this._nonce !== null)
          return this._nonce;
        throw Error(`nonce=${this._nonce} not loaded`);
      }
      set nonce(er) {
        this._nonce = er;
      }
      get balance() {
        if (this._balance !== null)
          return this._balance;
        throw Error(`balance=${this._balance} not loaded`);
      }
      set balance(er) {
        this._balance = er;
      }
      get storageRoot() {
        if (this._storageRoot !== null)
          return this._storageRoot;
        throw Error(`storageRoot=${this._storageRoot} not loaded`);
      }
      set storageRoot(er) {
        this._storageRoot = er;
      }
      get codeHash() {
        if (this._codeHash !== null)
          return this._codeHash;
        throw Error(`codeHash=${this._codeHash} not loaded`);
      }
      set codeHash(er) {
        this._codeHash = er;
      }
      get codeSize() {
        if (this._codeSize !== null)
          return this._codeSize;
        throw Error(`codeHash=${this._codeSize} not loaded`);
      }
      set codeSize(er) {
        this._codeSize = er;
      }
      static fromAccountData(er) {
        const { nonce: Ie, balance: xe, storageRoot: rr, codeHash: ar } = er;
        if (Ie === null || xe === null || rr === null || ar === null)
          throw Error("Partial fields not supported in fromAccountData");
        return new le(Ie !== void 0 ? (0, a.bytesToBigInt)((0, a.toBytes)(Ie)) : void 0, xe !== void 0 ? (0, a.bytesToBigInt)((0, a.toBytes)(xe)) : void 0, rr !== void 0 ? (0, a.toBytes)(rr) : void 0, ar !== void 0 ? (0, a.toBytes)(ar) : void 0);
      }
      static fromPartialAccountData(er) {
        const { nonce: Ie, balance: xe, storageRoot: rr, codeHash: ar, codeSize: yr, version: _r } = er;
        if (Ie === null && xe === null && rr === null && ar === null && yr === null && _r === null)
          throw Error("All partial fields null");
        return new le(Ie != null ? (0, a.bytesToBigInt)((0, a.toBytes)(Ie)) : Ie, xe != null ? (0, a.bytesToBigInt)((0, a.toBytes)(xe)) : xe, rr != null ? (0, a.toBytes)(rr) : rr, ar != null ? (0, a.toBytes)(ar) : ar, yr != null ? (0, a.bytesToInt)((0, a.toBytes)(yr)) : yr, _r != null ? (0, a.bytesToInt)((0, a.toBytes)(_r)) : _r);
      }
      static fromRlpSerializedAccount(er) {
        const Ie = c.RLP.decode(er);
        if (!Array.isArray(Ie))
          throw new Error("Invalid serialized account input. Must be array");
        return this.fromValuesArray(Ie);
      }
      static fromRlpSerializedPartialAccount(er) {
        const Ie = c.RLP.decode(er);
        if (!Array.isArray(Ie))
          throw new Error("Invalid serialized account input. Must be array");
        let xe = null;
        if (Array.isArray(Ie[0])) {
          const vr = (0, a.bytesToInt)(Ie[0][0]);
          if (vr !== 0 && vr !== 1)
            throw new Error(`Invalid isNullIndicator=${vr} for nonce`);
          vr === 1 && (xe = (0, a.bytesToBigInt)(Ie[0][1]));
        } else
          throw new Error("Invalid partial nonce encoding. Must be array");
        let rr = null;
        if (Array.isArray(Ie[1])) {
          const vr = (0, a.bytesToInt)(Ie[1][0]);
          if (vr !== 0 && vr !== 1)
            throw new Error(`Invalid isNullIndicator=${vr} for balance`);
          vr === 1 && (rr = (0, a.bytesToBigInt)(Ie[1][1]));
        } else
          throw new Error("Invalid partial balance encoding. Must be array");
        let ar = null;
        if (Array.isArray(Ie[2])) {
          const vr = (0, a.bytesToInt)(Ie[2][0]);
          if (vr !== 0 && vr !== 1)
            throw new Error(`Invalid isNullIndicator=${vr} for storageRoot`);
          vr === 1 && (ar = Ie[2][1]);
        } else
          throw new Error("Invalid partial storageRoot encoding. Must be array");
        let yr = null;
        if (Array.isArray(Ie[3])) {
          const vr = (0, a.bytesToInt)(Ie[3][0]);
          if (vr !== 0 && vr !== 1)
            throw new Error(`Invalid isNullIndicator=${vr} for codeHash`);
          vr === 1 && (yr = Ie[3][1]);
        } else
          throw new Error("Invalid partial codeHash encoding. Must be array");
        let _r = null;
        if (Array.isArray(Ie[4])) {
          const vr = (0, a.bytesToInt)(Ie[4][0]);
          if (vr !== 0 && vr !== 1)
            throw new Error(`Invalid isNullIndicator=${vr} for codeSize`);
          vr === 1 && (_r = (0, a.bytesToInt)(Ie[4][1]));
        } else
          throw new Error("Invalid partial codeSize encoding. Must be array");
        let Or = null;
        if (Array.isArray(Ie[5])) {
          const vr = (0, a.bytesToInt)(Ie[5][0]);
          if (vr !== 0 && vr !== 1)
            throw new Error(`Invalid isNullIndicator=${vr} for version`);
          vr === 1 && (Or = (0, a.bytesToInt)(Ie[5][1]));
        } else
          throw new Error("Invalid partial version encoding. Must be array");
        return this.fromPartialAccountData({ balance: rr, nonce: xe, storageRoot: ar, codeHash: yr, codeSize: _r, version: Or });
      }
      static fromValuesArray(er) {
        const [Ie, xe, rr, ar] = er;
        return new le((0, a.bytesToBigInt)(Ie), (0, a.bytesToBigInt)(xe), rr, ar);
      }
      _validate() {
        if (this._nonce !== null && this._nonce < A.BIGINT_0)
          throw new Error("nonce must be greater than zero");
        if (this._balance !== null && this._balance < A.BIGINT_0)
          throw new Error("balance must be greater than zero");
        if (this._storageRoot !== null && this._storageRoot.length !== 32)
          throw new Error("storageRoot must have a length of 32");
        if (this._codeHash !== null && this._codeHash.length !== 32)
          throw new Error("codeHash must have a length of 32");
        if (this._codeSize !== null && this._codeSize < A.BIGINT_0)
          throw new Error("codeSize must be greater than zero");
      }
      /**
       * Returns an array of Uint8Arrays of the raw bytes for the account, in order.
       */
      raw() {
        return [
          (0, a.bigIntToUnpaddedBytes)(this.nonce),
          (0, a.bigIntToUnpaddedBytes)(this.balance),
          this.storageRoot,
          this.codeHash
        ];
      }
      /**
       * Returns the RLP serialization of the account as a `Uint8Array`.
       */
      serialize() {
        return c.RLP.encode(this.raw());
      }
      serializeWithPartialInfo() {
        const er = [], Ie = (0, a.intToUnpaddedBytes)(0), xe = (0, a.intToUnpaddedBytes)(1);
        return this._nonce !== null ? er.push([xe, (0, a.bigIntToUnpaddedBytes)(this._nonce)]) : er.push([Ie]), this._balance !== null ? er.push([xe, (0, a.bigIntToUnpaddedBytes)(this._balance)]) : er.push([Ie]), this._storageRoot !== null ? er.push([xe, this._storageRoot]) : er.push([Ie]), this._codeHash !== null ? er.push([xe, this._codeHash]) : er.push([Ie]), this._codeSize !== null ? er.push([xe, (0, a.intToUnpaddedBytes)(this._codeSize)]) : er.push([Ie]), this._version !== null ? er.push([xe, (0, a.intToUnpaddedBytes)(this._version)]) : er.push([Ie]), c.RLP.encode(er);
      }
      /**
       * Returns a `Boolean` determining if the account is a contract.
       */
      isContract() {
        if (this._codeHash === null && this._codeSize === null)
          throw Error("Insufficient data as codeHash=null and codeSize=null");
        return this._codeHash !== null && !(0, a.equalsBytes)(this._codeHash, A.KECCAK256_NULL) || this._codeSize !== null && this._codeSize !== 0;
      }
      /**
       * Returns a `Boolean` determining if the account is empty complying to the definition of
       * account emptiness in [EIP-161](https://eips.ethereum.org/EIPS/eip-161):
       * "An account is considered empty when it has no code and zero nonce and zero balance."
       */
      isEmpty() {
        return this._balance !== null && this.balance !== A.BIGINT_0 || this._nonce === null && this.nonce !== A.BIGINT_0 || this._codeHash !== null && !(0, a.equalsBytes)(this.codeHash, A.KECCAK256_NULL) ? !1 : this.balance === A.BIGINT_0 && this.nonce === A.BIGINT_0 && (0, a.equalsBytes)(this.codeHash, A.KECCAK256_NULL);
      }
    }
    n.Account = le;
    const L = function(Sr) {
      try {
        (0, b.assertIsString)(Sr);
      } catch {
        return !1;
      }
      return /^0x[0-9a-fA-F]{40}$/.test(Sr);
    };
    n.isValidAddress = L;
    const pe = function(Sr, er) {
      (0, b.assertIsHexString)(Sr);
      const Ie = (0, F.stripHexPrefix)(Sr).toLowerCase();
      let xe = "";
      er !== void 0 && (xe = (0, a.bytesToBigInt)((0, a.toBytes)(er)).toString() + "0x");
      const rr = (0, a.utf8ToBytes)(xe + Ie), ar = (0, a.bytesToHex)((0, u.keccak256)(rr)).slice(2);
      let yr = "";
      for (let _r = 0; _r < Ie.length; _r++)
        parseInt(ar[_r], 16) >= 8 ? yr += Ie[_r].toUpperCase() : yr += Ie[_r];
      return `0x${yr}`;
    };
    n.toChecksumAddress = pe;
    const $ = function(Sr, er) {
      return (0, n.isValidAddress)(Sr) && (0, n.toChecksumAddress)(Sr, er) === Sr;
    };
    n.isValidChecksumAddress = $;
    const Ee = function(Sr, er) {
      return (0, b.assertIsBytes)(Sr), (0, b.assertIsBytes)(er), (0, a.bytesToBigInt)(er) === A.BIGINT_0 ? (0, u.keccak256)(c.RLP.encode([Sr, Uint8Array.from([])])).subarray(-20) : (0, u.keccak256)(c.RLP.encode([Sr, er])).subarray(-20);
    };
    n.generateAddress = Ee;
    const be = function(Sr, er, Ie) {
      if ((0, b.assertIsBytes)(Sr), (0, b.assertIsBytes)(er), (0, b.assertIsBytes)(Ie), Sr.length !== 20)
        throw new Error("Expected from to be of length 20");
      if (er.length !== 32)
        throw new Error("Expected salt to be of length 32");
      return (0, u.keccak256)((0, a.concatBytes)((0, a.hexToBytes)("0xff"), Sr, er, (0, u.keccak256)(Ie))).subarray(-20);
    };
    n.generateAddress2 = be;
    const He = function(Sr) {
      return p.secp256k1.utils.isValidPrivateKey(Sr);
    };
    n.isValidPrivate = He;
    const Pe = function(Sr, er = !1) {
      if ((0, b.assertIsBytes)(Sr), Sr.length === 64)
        try {
          return p.secp256k1.ProjectivePoint.fromHex((0, a.concatBytes)(Uint8Array.from([4]), Sr)), !0;
        } catch {
          return !1;
        }
      if (!er)
        return !1;
      try {
        return p.secp256k1.ProjectivePoint.fromHex(Sr), !0;
      } catch {
        return !1;
      }
    };
    n.isValidPublic = Pe;
    const nr = function(Sr, er = !1) {
      if ((0, b.assertIsBytes)(Sr), er && Sr.length !== 64 && (Sr = p.secp256k1.ProjectivePoint.fromHex(Sr).toRawBytes(!1).slice(1)), Sr.length !== 64)
        throw new Error("Expected pubKey to be of length 64");
      return (0, u.keccak256)(Sr).subarray(-20);
    };
    n.pubToAddress = nr, n.publicToAddress = n.pubToAddress;
    const ir = function(Sr) {
      return (0, b.assertIsBytes)(Sr), p.secp256k1.ProjectivePoint.fromPrivateKey(Sr).toRawBytes(!1).slice(1);
    };
    n.privateToPublic = ir;
    const or = function(Sr) {
      return (0, n.publicToAddress)((0, n.privateToPublic)(Sr));
    };
    n.privateToAddress = or;
    const lr = function(Sr) {
      return (0, b.assertIsBytes)(Sr), Sr.length !== 64 && (Sr = p.secp256k1.ProjectivePoint.fromHex(Sr).toRawBytes(!1).slice(1)), Sr;
    };
    n.importPublic = lr;
    const Ir = function() {
      const er = (0, a.zeros)(20);
      return (0, a.bytesToHex)(er);
    };
    n.zeroAddress = Ir;
    const xr = function(Sr) {
      try {
        (0, b.assertIsString)(Sr);
      } catch {
        return !1;
      }
      return (0, n.zeroAddress)() === Sr;
    };
    n.isZeroAddress = xr;
    function kr(Sr) {
      const [er, Ie, xe, rr] = Sr;
      return [
        er,
        Ie,
        xe.length === 0 ? A.KECCAK256_RLP : xe,
        rr.length === 0 ? A.KECCAK256_NULL : rr
      ];
    }
    n.accountBodyFromSlim = kr;
    const Ce = new Uint8Array(0);
    function tr(Sr) {
      const [er, Ie, xe, rr] = Sr;
      return [
        er,
        Ie,
        (0, a.equalsBytes)(xe, A.KECCAK256_RLP) ? Ce : xe,
        (0, a.equalsBytes)(rr, A.KECCAK256_NULL) ? Ce : rr
      ];
    }
    n.accountBodyToSlim = tr;
    function Fe(Sr, er = !0) {
      const Ie = er ? kr(Sr) : Sr;
      return c.RLP.encode(Ie);
    }
    n.accountBodyToRLP = Fe;
  }(account$2)), account$2;
}
var address = {}, hasRequiredAddress;
function requireAddress() {
  if (hasRequiredAddress) return address;
  hasRequiredAddress = 1, Object.defineProperty(address, "__esModule", { value: !0 }), address.Address = void 0;
  const n = requireAccount(), c = requireBytes$8(), u = requireConstants();
  class p {
    constructor(A) {
      if (A.length !== 20)
        throw new Error("Invalid address length");
      this.bytes = A;
    }
    /**
     * Returns the zero address.
     */
    static zero() {
      return new p((0, c.zeros)(20));
    }
    /**
     * Returns an Address object from a hex-encoded string.
     * @param str - Hex-encoded address
     */
    static fromString(A) {
      if (!(0, n.isValidAddress)(A))
        throw new Error(`Invalid address input=${A}`);
      return new p((0, c.hexToBytes)(A));
    }
    /**
     * Returns an address for a given public key.
     * @param pubKey The two points of an uncompressed key
     */
    static fromPublicKey(A) {
      if (!(A instanceof Uint8Array))
        throw new Error("Public key should be Uint8Array");
      const b = (0, n.pubToAddress)(A);
      return new p(b);
    }
    /**
     * Returns an address for a given private key.
     * @param privateKey A private key must be 256 bits wide
     */
    static fromPrivateKey(A) {
      if (!(A instanceof Uint8Array))
        throw new Error("Private key should be Uint8Array");
      const b = (0, n.privateToAddress)(A);
      return new p(b);
    }
    /**
     * Generates an address for a newly created contract.
     * @param from The address which is creating this new address
     * @param nonce The nonce of the from account
     */
    static generate(A, b) {
      if (typeof b != "bigint")
        throw new Error("Expected nonce to be a bigint");
      return new p((0, n.generateAddress)(A.bytes, (0, c.bigIntToBytes)(b)));
    }
    /**
     * Generates an address for a contract created using CREATE2.
     * @param from The address which is creating this new address
     * @param salt A salt
     * @param initCode The init code of the contract being created
     */
    static generate2(A, b, F) {
      if (!(b instanceof Uint8Array))
        throw new Error("Expected salt to be a Uint8Array");
      if (!(F instanceof Uint8Array))
        throw new Error("Expected initCode to be a Uint8Array");
      return new p((0, n.generateAddress2)(A.bytes, b, F));
    }
    /**
     * Is address equal to another.
     */
    equals(A) {
      return (0, c.equalsBytes)(this.bytes, A.bytes);
    }
    /**
     * Is address zero.
     */
    isZero() {
      return this.equals(p.zero());
    }
    /**
     * True if address is in the address range defined
     * by EIP-1352
     */
    isPrecompileOrSystemAddress() {
      const A = (0, c.bytesToBigInt)(this.bytes), b = u.BIGINT_0, F = BigInt("0xffff");
      return A >= b && A <= F;
    }
    /**
     * Returns hex encoding of address.
     */
    toString() {
      return (0, c.bytesToHex)(this.bytes);
    }
    /**
     * Returns a new Uint8Array representation of address.
     */
    toBytes() {
      return new Uint8Array(this.bytes);
    }
  }
  return address.Address = p, address;
}
var db = {}, hasRequiredDb;
function requireDb() {
  return hasRequiredDb || (hasRequiredDb = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.ValueEncoding = n.KeyEncoding = void 0, function(c) {
      c.String = "string", c.Bytes = "view", c.Number = "number";
    }(n.KeyEncoding || (n.KeyEncoding = {})), function(c) {
      c.String = "string", c.Bytes = "view", c.JSON = "json";
    }(n.ValueEncoding || (n.ValueEncoding = {}));
  }(db)), db;
}
var withdrawal = {}, types$d = {}, hasRequiredTypes$8;
function requireTypes$8() {
  return hasRequiredTypes$8 || (hasRequiredTypes$8 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.toType = n.TypeOutput = n.isNestedUint8Array = void 0;
    const c = requireBytes$8(), u = requireInternal();
    function p(b) {
      if (!Array.isArray(b))
        return !1;
      for (const F of b)
        if (Array.isArray(F)) {
          if (!p(F))
            return !1;
        } else if (!(F instanceof Uint8Array))
          return !1;
      return !0;
    }
    n.isNestedUint8Array = p;
    var a;
    (function(b) {
      b[b.Number = 0] = "Number", b[b.BigInt = 1] = "BigInt", b[b.Uint8Array = 2] = "Uint8Array", b[b.PrefixedHexString = 3] = "PrefixedHexString";
    })(a = n.TypeOutput || (n.TypeOutput = {}));
    function A(b, F) {
      if (b === null)
        return null;
      if (b === void 0)
        return;
      if (typeof b == "string" && !(0, u.isHexString)(b))
        throw new Error(`A string must be provided with a 0x-prefix, given: ${b}`);
      if (typeof b == "number" && !Number.isSafeInteger(b))
        throw new Error("The provided number is greater than MAX_SAFE_INTEGER (please use an alternative input type)");
      const le = (0, c.toBytes)(b);
      switch (F) {
        case a.Uint8Array:
          return le;
        case a.BigInt:
          return (0, c.bytesToBigInt)(le);
        case a.Number: {
          const L = (0, c.bytesToBigInt)(le);
          if (L > BigInt(Number.MAX_SAFE_INTEGER))
            throw new Error("The provided number is greater than MAX_SAFE_INTEGER (please use an alternative output type)");
          return Number(L);
        }
        case a.PrefixedHexString:
          return (0, c.bytesToHex)(le);
        default:
          throw new Error("unknown outputType");
      }
    }
    n.toType = A;
  }(types$d)), types$d;
}
var hasRequiredWithdrawal;
function requireWithdrawal() {
  if (hasRequiredWithdrawal) return withdrawal;
  hasRequiredWithdrawal = 1, Object.defineProperty(withdrawal, "__esModule", { value: !0 }), withdrawal.Withdrawal = void 0;
  const n = requireAddress(), c = requireBytes$8(), u = requireConstants(), p = requireTypes$8();
  class a {
    /**
     * This constructor assigns and validates the values.
     * Use the static factory methods to assist in creating a Withdrawal object from varying data types.
     * Its amount is in Gwei to match CL representation and for eventual ssz withdrawalsRoot
     */
    constructor(b, F, le, L) {
      this.index = b, this.validatorIndex = F, this.address = le, this.amount = L;
    }
    static fromWithdrawalData(b) {
      const { index: F, validatorIndex: le, address: L, amount: pe } = b, $ = (0, p.toType)(F, p.TypeOutput.BigInt), Ee = (0, p.toType)(le, p.TypeOutput.BigInt), be = L instanceof n.Address ? L : new n.Address((0, c.toBytes)(L)), He = (0, p.toType)(pe, p.TypeOutput.BigInt);
      return new a($, Ee, be, He);
    }
    static fromValuesArray(b) {
      if (b.length !== 4)
        throw Error(`Invalid withdrawalArray length expected=4 actual=${b.length}`);
      const [F, le, L, pe] = b;
      return a.fromWithdrawalData({ index: F, validatorIndex: le, address: L, amount: pe });
    }
    /**
     * Convert a withdrawal to a buffer array
     * @param withdrawal the withdrawal to convert
     * @returns buffer array of the withdrawal
     */
    static toBytesArray(b) {
      const { index: F, validatorIndex: le, address: L, amount: pe } = b, $ = (0, p.toType)(F, p.TypeOutput.BigInt) === u.BIGINT_0 ? new Uint8Array() : (0, p.toType)(F, p.TypeOutput.Uint8Array), Ee = (0, p.toType)(le, p.TypeOutput.BigInt) === u.BIGINT_0 ? new Uint8Array() : (0, p.toType)(le, p.TypeOutput.Uint8Array), be = L instanceof n.Address ? L.bytes : (0, p.toType)(L, p.TypeOutput.Uint8Array), He = (0, p.toType)(pe, p.TypeOutput.BigInt) === u.BIGINT_0 ? new Uint8Array() : (0, p.toType)(pe, p.TypeOutput.Uint8Array);
      return [$, Ee, be, He];
    }
    raw() {
      return a.toBytesArray(this);
    }
    toValue() {
      return {
        index: this.index,
        validatorIndex: this.validatorIndex,
        address: this.address.bytes,
        amount: this.amount
      };
    }
    toJSON() {
      return {
        index: (0, c.bigIntToHex)(this.index),
        validatorIndex: (0, c.bigIntToHex)(this.validatorIndex),
        address: (0, c.bytesToHex)(this.address.bytes),
        amount: (0, c.bigIntToHex)(this.amount)
      };
    }
  }
  return withdrawal.Withdrawal = a, withdrawal;
}
var signature$1 = {}, hasRequiredSignature;
function requireSignature() {
  if (hasRequiredSignature) return signature$1;
  hasRequiredSignature = 1, Object.defineProperty(signature$1, "__esModule", { value: !0 }), signature$1.hashPersonalMessage = signature$1.isValidSignature = signature$1.fromRpcSig = signature$1.toCompactSig = signature$1.toRpcSig = signature$1.ecrecover = signature$1.calculateSigRecovery = signature$1.ecsign = void 0;
  const n = requireKeccak(), c = requireSecp256k1(), u = requireBytes$8(), p = requireConstants(), a = requireHelpers();
  function A(He, Pe, nr) {
    const ir = c.secp256k1.sign(He, Pe), or = ir.toCompactRawBytes(), lr = or.slice(0, 32), Ir = or.slice(32, 64), xr = nr === void 0 ? BigInt(ir.recovery + 27) : BigInt(ir.recovery + 35) + BigInt(nr) * p.BIGINT_2;
    return { r: lr, s: Ir, v: xr };
  }
  signature$1.ecsign = A;
  function b(He, Pe) {
    return He === p.BIGINT_0 || He === p.BIGINT_1 ? He : Pe === void 0 ? He - p.BIGINT_27 : He - (Pe * p.BIGINT_2 + BigInt(35));
  }
  signature$1.calculateSigRecovery = b;
  function F(He) {
    return He === p.BIGINT_0 || He === p.BIGINT_1;
  }
  const le = function(He, Pe, nr, ir, or) {
    const lr = (0, u.concatBytes)((0, u.setLengthLeft)(nr, 32), (0, u.setLengthLeft)(ir, 32)), Ir = b(Pe, or);
    if (!F(Ir))
      throw new Error("Invalid signature v value");
    return c.secp256k1.Signature.fromCompact(lr).addRecoveryBit(Number(Ir)).recoverPublicKey(He).toRawBytes(!1).slice(1);
  };
  signature$1.ecrecover = le;
  const L = function(He, Pe, nr, ir) {
    const or = b(He, ir);
    if (!F(or))
      throw new Error("Invalid signature v value");
    return (0, u.bytesToHex)((0, u.concatBytes)((0, u.setLengthLeft)(Pe, 32), (0, u.setLengthLeft)(nr, 32), (0, u.toBytes)(He)));
  };
  signature$1.toRpcSig = L;
  const pe = function(He, Pe, nr, ir) {
    const or = b(He, ir);
    if (!F(or))
      throw new Error("Invalid signature v value");
    const lr = Uint8Array.from([...nr]);
    return (He > BigInt(28) && He % p.BIGINT_2 === p.BIGINT_1 || He === p.BIGINT_1 || He === BigInt(28)) && (lr[0] |= 128), (0, u.bytesToHex)((0, u.concatBytes)((0, u.setLengthLeft)(Pe, 32), (0, u.setLengthLeft)(lr, 32)));
  };
  signature$1.toCompactSig = pe;
  const $ = function(He) {
    const Pe = (0, u.toBytes)(He);
    let nr, ir, or;
    if (Pe.length >= 65)
      nr = Pe.subarray(0, 32), ir = Pe.subarray(32, 64), or = (0, u.bytesToBigInt)(Pe.subarray(64));
    else if (Pe.length === 64)
      nr = Pe.subarray(0, 32), ir = Pe.subarray(32, 64), or = BigInt((0, u.bytesToInt)(Pe.subarray(32, 33)) >> 7), ir[0] &= 127;
    else
      throw new Error("Invalid signature length");
    return or < 27 && (or = or + p.BIGINT_27), {
      v: or,
      r: nr,
      s: ir
    };
  };
  signature$1.fromRpcSig = $;
  const Ee = function(He, Pe, nr, ir = !0, or) {
    if (Pe.length !== 32 || nr.length !== 32 || !F(b(He, or)))
      return !1;
    const lr = (0, u.bytesToBigInt)(Pe), Ir = (0, u.bytesToBigInt)(nr);
    return !(lr === p.BIGINT_0 || lr >= p.SECP256K1_ORDER || Ir === p.BIGINT_0 || Ir >= p.SECP256K1_ORDER || ir && Ir >= p.SECP256K1_ORDER_DIV_2);
  };
  signature$1.isValidSignature = Ee;
  const be = function(He) {
    (0, a.assertIsBytes)(He);
    const Pe = (0, u.utf8ToBytes)(`Ethereum Signed Message:
${He.length}`);
    return (0, n.keccak256)((0, u.concatBytes)(Pe, He));
  };
  return signature$1.hashPersonalMessage = be, signature$1;
}
var asyncEventEmitter = {}, hasRequiredAsyncEventEmitter;
function requireAsyncEventEmitter() {
  if (hasRequiredAsyncEventEmitter) return asyncEventEmitter;
  hasRequiredAsyncEventEmitter = 1, Object.defineProperty(asyncEventEmitter, "__esModule", { value: !0 }), asyncEventEmitter.AsyncEventEmitter = void 0;
  const n = eventsExports;
  async function c(p, a, A) {
    let b;
    for await (const F of a)
      try {
        F.length < 2 ? F.call(p, A) : await new Promise((le, L) => {
          F.call(p, A, (pe) => {
            pe ? L(pe) : le();
          });
        });
      } catch (le) {
        b = le;
      }
    if (b)
      throw b;
  }
  class u extends n.EventEmitter {
    emit(a, ...A) {
      let [b, F] = A;
      const le = this;
      let L = le._events[a] ?? [];
      return F === void 0 && typeof b == "function" && (F = b, b = void 0), (a === "newListener" || a === "removeListener") && (b = {
        event: b,
        fn: F
      }, F = void 0), L = Array.isArray(L) ? L : [L], c(le, L.slice(), b).then(F).catch(F), le.listenerCount(a) > 0;
    }
    once(a, A) {
      const b = this;
      let F;
      if (typeof A != "function")
        throw new TypeError("listener must be a function");
      return A.length >= 2 ? F = function(le, L) {
        b.removeListener(a, F), A(le, L);
      } : F = function(le) {
        b.removeListener(a, F), A(le, F);
      }, b.on(a, F), b;
    }
    first(a, A) {
      let b = this._events[a] ?? [];
      if (typeof A != "function")
        throw new TypeError("listener must be a function");
      return Array.isArray(b) || (this._events[a] = b = [b]), b.unshift(A), this;
    }
    before(a, A, b) {
      return this.beforeOrAfter(a, A, b);
    }
    after(a, A, b) {
      return this.beforeOrAfter(a, A, b, "after");
    }
    beforeOrAfter(a, A, b, F) {
      let le = this._events[a] ?? [], L, pe;
      const $ = F === "after" ? 1 : 0;
      if (typeof b != "function")
        throw new TypeError("listener must be a function");
      if (typeof A != "function")
        throw new TypeError("target must be a function");
      for (Array.isArray(le) || (this._events[a] = le = [le]), pe = le.length, L = le.length; L--; )
        if (le[L] === A) {
          pe = L + $;
          break;
        }
      return le.splice(pe, 0, b), this;
    }
    on(a, A) {
      return super.on(a, A);
    }
    addListener(a, A) {
      return super.addListener(a, A);
    }
    prependListener(a, A) {
      return super.prependListener(a, A);
    }
    prependOnceListener(a, A) {
      return super.prependOnceListener(a, A);
    }
    removeAllListeners(a) {
      return super.removeAllListeners(a);
    }
    removeListener(a, A) {
      return super.removeListener(a, A);
    }
    eventNames() {
      return super.eventNames();
    }
    listeners(a) {
      return super.listeners(a);
    }
    listenerCount(a) {
      return super.listenerCount(a);
    }
    getMaxListeners() {
      return super.getMaxListeners();
    }
    setMaxListeners(a) {
      return super.setMaxListeners(a);
    }
  }
  return asyncEventEmitter.AsyncEventEmitter = u, asyncEventEmitter;
}
var blobs = {}, sha256$a = {}, sha256$9 = {}, _md = {}, hasRequired_md;
function require_md() {
  if (hasRequired_md) return _md;
  hasRequired_md = 1, Object.defineProperty(_md, "__esModule", { value: !0 }), _md.HashMD = _md.Maj = _md.Chi = void 0;
  const n = require_assert(), c = requireUtils$9();
  function u(b, F, le, L) {
    if (typeof b.setBigUint64 == "function")
      return b.setBigUint64(F, le, L);
    const pe = BigInt(32), $ = BigInt(4294967295), Ee = Number(le >> pe & $), be = Number(le & $), He = L ? 4 : 0, Pe = L ? 0 : 4;
    b.setUint32(F + He, Ee, L), b.setUint32(F + Pe, be, L);
  }
  const p = (b, F, le) => b & F ^ ~b & le;
  _md.Chi = p;
  const a = (b, F, le) => b & F ^ b & le ^ F & le;
  _md.Maj = a;
  class A extends c.Hash {
    constructor(F, le, L, pe) {
      super(), this.blockLen = F, this.outputLen = le, this.padOffset = L, this.isLE = pe, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(F), this.view = (0, c.createView)(this.buffer);
    }
    update(F) {
      (0, n.exists)(this);
      const { view: le, buffer: L, blockLen: pe } = this;
      F = (0, c.toBytes)(F);
      const $ = F.length;
      for (let Ee = 0; Ee < $; ) {
        const be = Math.min(pe - this.pos, $ - Ee);
        if (be === pe) {
          const He = (0, c.createView)(F);
          for (; pe <= $ - Ee; Ee += pe)
            this.process(He, Ee);
          continue;
        }
        L.set(F.subarray(Ee, Ee + be), this.pos), this.pos += be, Ee += be, this.pos === pe && (this.process(le, 0), this.pos = 0);
      }
      return this.length += F.length, this.roundClean(), this;
    }
    digestInto(F) {
      (0, n.exists)(this), (0, n.output)(F, this), this.finished = !0;
      const { buffer: le, view: L, blockLen: pe, isLE: $ } = this;
      let { pos: Ee } = this;
      le[Ee++] = 128, this.buffer.subarray(Ee).fill(0), this.padOffset > pe - Ee && (this.process(L, 0), Ee = 0);
      for (let ir = Ee; ir < pe; ir++)
        le[ir] = 0;
      u(L, pe - 8, BigInt(this.length * 8), $), this.process(L, 0);
      const be = (0, c.createView)(F), He = this.outputLen;
      if (He % 4)
        throw new Error("_sha2: outputLen should be aligned to 32bit");
      const Pe = He / 4, nr = this.get();
      if (Pe > nr.length)
        throw new Error("_sha2: outputLen bigger than state");
      for (let ir = 0; ir < Pe; ir++)
        be.setUint32(4 * ir, nr[ir], $);
    }
    digest() {
      const { buffer: F, outputLen: le } = this;
      this.digestInto(F);
      const L = F.slice(0, le);
      return this.destroy(), L;
    }
    _cloneInto(F) {
      F || (F = new this.constructor()), F.set(...this.get());
      const { blockLen: le, buffer: L, length: pe, finished: $, destroyed: Ee, pos: be } = this;
      return F.length = pe, F.pos = be, F.finished = $, F.destroyed = Ee, pe % le && F.buffer.set(L), F;
    }
  }
  return _md.HashMD = A, _md;
}
var hasRequiredSha256$1;
function requireSha256$1() {
  if (hasRequiredSha256$1) return sha256$9;
  hasRequiredSha256$1 = 1, Object.defineProperty(sha256$9, "__esModule", { value: !0 }), sha256$9.sha224 = sha256$9.sha256 = void 0;
  const n = require_md(), c = requireUtils$9(), u = /* @__PURE__ */ new Uint32Array([
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ]), p = /* @__PURE__ */ new Uint32Array([
    1779033703,
    3144134277,
    1013904242,
    2773480762,
    1359893119,
    2600822924,
    528734635,
    1541459225
  ]), a = /* @__PURE__ */ new Uint32Array(64);
  class A extends n.HashMD {
    constructor() {
      super(64, 32, 8, !1), this.A = p[0] | 0, this.B = p[1] | 0, this.C = p[2] | 0, this.D = p[3] | 0, this.E = p[4] | 0, this.F = p[5] | 0, this.G = p[6] | 0, this.H = p[7] | 0;
    }
    get() {
      const { A: le, B: L, C: pe, D: $, E: Ee, F: be, G: He, H: Pe } = this;
      return [le, L, pe, $, Ee, be, He, Pe];
    }
    // prettier-ignore
    set(le, L, pe, $, Ee, be, He, Pe) {
      this.A = le | 0, this.B = L | 0, this.C = pe | 0, this.D = $ | 0, this.E = Ee | 0, this.F = be | 0, this.G = He | 0, this.H = Pe | 0;
    }
    process(le, L) {
      for (let or = 0; or < 16; or++, L += 4)
        a[or] = le.getUint32(L, !1);
      for (let or = 16; or < 64; or++) {
        const lr = a[or - 15], Ir = a[or - 2], xr = (0, c.rotr)(lr, 7) ^ (0, c.rotr)(lr, 18) ^ lr >>> 3, kr = (0, c.rotr)(Ir, 17) ^ (0, c.rotr)(Ir, 19) ^ Ir >>> 10;
        a[or] = kr + a[or - 7] + xr + a[or - 16] | 0;
      }
      let { A: pe, B: $, C: Ee, D: be, E: He, F: Pe, G: nr, H: ir } = this;
      for (let or = 0; or < 64; or++) {
        const lr = (0, c.rotr)(He, 6) ^ (0, c.rotr)(He, 11) ^ (0, c.rotr)(He, 25), Ir = ir + lr + (0, n.Chi)(He, Pe, nr) + u[or] + a[or] | 0, kr = ((0, c.rotr)(pe, 2) ^ (0, c.rotr)(pe, 13) ^ (0, c.rotr)(pe, 22)) + (0, n.Maj)(pe, $, Ee) | 0;
        ir = nr, nr = Pe, Pe = He, He = be + Ir | 0, be = Ee, Ee = $, $ = pe, pe = Ir + kr | 0;
      }
      pe = pe + this.A | 0, $ = $ + this.B | 0, Ee = Ee + this.C | 0, be = be + this.D | 0, He = He + this.E | 0, Pe = Pe + this.F | 0, nr = nr + this.G | 0, ir = ir + this.H | 0, this.set(pe, $, Ee, be, He, Pe, nr, ir);
    }
    roundClean() {
      a.fill(0);
    }
    destroy() {
      this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
    }
  }
  class b extends A {
    constructor() {
      super(), this.A = -1056596264, this.B = 914150663, this.C = 812702999, this.D = -150054599, this.E = -4191439, this.F = 1750603025, this.G = 1694076839, this.H = -1090891868, this.outputLen = 28;
    }
  }
  return sha256$9.sha256 = (0, c.wrapConstructor)(() => new A()), sha256$9.sha224 = (0, c.wrapConstructor)(() => new b()), sha256$9;
}
var hasRequiredSha256;
function requireSha256() {
  if (hasRequiredSha256) return sha256$a;
  hasRequiredSha256 = 1, Object.defineProperty(sha256$a, "__esModule", { value: !0 }), sha256$a.sha256 = void 0;
  const n = requireSha256$1(), c = requireUtils$8();
  return sha256$a.sha256 = (0, c.wrapHash)(n.sha256), sha256$a;
}
var hasRequiredBlobs;
function requireBlobs() {
  return hasRequiredBlobs || (hasRequiredBlobs = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.commitmentsToVersionedHashes = n.computeVersionedHash = n.blobsToProofs = n.blobsToCommitments = n.getBlobs = void 0;
    const c = requireSha256(), u = requireBytes$8(), p = 32, a = 4096, A = 32 * a, F = A * 2 - 1, le = p * a;
    function L(nr, ir) {
      const or = new Uint8Array(ir * A).fill(0);
      return or.set(nr), or[nr.byteLength] = 128, or;
    }
    function pe(nr) {
      const ir = new Uint8Array(le);
      for (let or = 0; or < a; or++) {
        const lr = new Uint8Array(32);
        lr.set(nr.subarray(or * 31, (or + 1) * 31), 0), ir.set(lr, or * 32);
      }
      return ir;
    }
    const $ = (nr) => {
      const ir = (0, u.utf8ToBytes)(nr), or = ir.byteLength;
      if (or === 0)
        throw Error("invalid blob data");
      if (or > F)
        throw Error("blob data is too large");
      const lr = Math.ceil(or / A), Ir = L(ir, lr), xr = [];
      for (let kr = 0; kr < lr; kr++) {
        const Ce = Ir.subarray(kr * A, (kr + 1) * A), tr = pe(Ce);
        xr.push(tr);
      }
      return xr;
    };
    n.getBlobs = $;
    const Ee = (nr, ir) => {
      const or = [];
      for (const lr of ir)
        or.push(nr.blobToKzgCommitment(lr));
      return or;
    };
    n.blobsToCommitments = Ee;
    const be = (nr, ir, or) => ir.map((Ir, xr) => nr.computeBlobKzgProof(Ir, or[xr]));
    n.blobsToProofs = be;
    const He = (nr, ir) => {
      const or = new Uint8Array(32);
      return or.set([ir], 0), or.set((0, c.sha256)(nr).subarray(1), 1), or;
    };
    n.computeVersionedHash = He;
    const Pe = (nr) => {
      const ir = [];
      for (const or of nr)
        ir.push((0, n.computeVersionedHash)(or, 1));
      return ir;
    };
    n.commitmentsToVersionedHashes = Pe;
  }(blobs)), blobs;
}
var genesis = {}, hasRequiredGenesis;
function requireGenesis() {
  if (hasRequiredGenesis) return genesis;
  hasRequiredGenesis = 1, Object.defineProperty(genesis, "__esModule", { value: !0 }), genesis.parseGethGenesisState = void 0;
  const n = requireBytes$8(), c = requireInternal();
  function u(p) {
    const a = {};
    for (const A of Object.keys(p.alloc)) {
      let { balance: b, code: F, storage: le, nonce: L } = p.alloc[A];
      const pe = (0, n.addHexPrefix)(A.toLowerCase());
      b = (0, c.isHexString)(b) ? b : (0, n.bigIntToHex)(BigInt(b)), F = F !== void 0 ? (0, n.addHexPrefix)(F) : void 0, le = le !== void 0 ? Object.entries(le) : void 0, L = L !== void 0 ? (0, n.addHexPrefix)(L) : void 0, a[pe] = [b, F, le, L];
    }
    return a;
  }
  return genesis.parseGethGenesisState = u, genesis;
}
var kzg = {}, hasRequiredKzg;
function requireKzg() {
  if (hasRequiredKzg) return kzg;
  hasRequiredKzg = 1, Object.defineProperty(kzg, "__esModule", { value: !0 }), kzg.initKZG = void 0;
  function n(c, u) {
    c.loadTrustedSetup();
  }
  return kzg.initKZG = n, kzg;
}
var lock = {}, hasRequiredLock;
function requireLock() {
  if (hasRequiredLock) return lock;
  hasRequiredLock = 1, Object.defineProperty(lock, "__esModule", { value: !0 }), lock.Lock = void 0;
  class n {
    constructor() {
      this.permits = 1, this.promiseResolverQueue = [];
    }
    /**
     * Returns a promise used to wait for a permit to become available. This method should be awaited on.
     * @returns  A promise that gets resolved when execution is allowed to proceed.
     */
    async acquire() {
      return this.permits > 0 ? (this.permits -= 1, Promise.resolve(!0)) : new Promise((u) => this.promiseResolverQueue.push(u));
    }
    /**
     * Increases the number of permits by one. If there are other functions waiting, one of them will
     * continue to execute in a future iteration of the event loop.
     */
    release() {
      if (this.permits += 1, this.permits > 1 && this.promiseResolverQueue.length > 0)
        console.warn("Lock.permits should never be > 0 when there is someone waiting.");
      else if (this.permits === 1 && this.promiseResolverQueue.length > 0) {
        this.permits -= 1;
        const u = this.promiseResolverQueue.shift();
        u && u(!0);
      }
    }
  }
  return lock.Lock = n, lock;
}
var mapDB = {}, hasRequiredMapDB;
function requireMapDB() {
  if (hasRequiredMapDB) return mapDB;
  hasRequiredMapDB = 1, Object.defineProperty(mapDB, "__esModule", { value: !0 }), mapDB.MapDB = void 0;
  const n = requireBytes$8();
  class c {
    constructor(p) {
      this._database = p ?? /* @__PURE__ */ new Map();
    }
    async get(p) {
      const a = p instanceof Uint8Array ? (0, n.bytesToUnprefixedHex)(p) : p.toString();
      return this._database.get(a);
    }
    async put(p, a) {
      const A = p instanceof Uint8Array ? (0, n.bytesToUnprefixedHex)(p) : p.toString();
      this._database.set(A, a);
    }
    async del(p) {
      const a = p instanceof Uint8Array ? (0, n.bytesToUnprefixedHex)(p) : p.toString();
      this._database.delete(a);
    }
    async batch(p) {
      for (const a of p)
        a.type === "del" && await this.del(a.key), a.type === "put" && await this.put(a.key, a.value);
    }
    /**
     * Note that the returned shallow copy will share the underlying database with the original
     *
     * @returns DB
     */
    shallowCopy() {
      return new c(this._database);
    }
    open() {
      return Promise.resolve();
    }
  }
  return mapDB.MapDB = c, mapDB;
}
var provider = {}, hasRequiredProvider;
function requireProvider() {
  if (hasRequiredProvider) return provider;
  hasRequiredProvider = 1, Object.defineProperty(provider, "__esModule", { value: !0 }), provider.getProvider = provider.fetchFromProvider = void 0;
  const n = async (u, p) => {
    const a = JSON.stringify({
      method: p.method,
      params: p.params,
      jsonrpc: "2.0",
      id: 1
    }), A = await fetch(u, {
      headers: {
        "content-type": "application/json"
      },
      method: "POST",
      body: a
    });
    if (!A.ok)
      throw new Error(`JSONRpcError: ${JSON.stringify({
        method: p.method,
        status: A.status,
        message: await A.text().catch(() => "Could not parse error message likely because of a network error")
      }, null, 2)}`);
    return (await A.json()).result;
  };
  provider.fetchFromProvider = n;
  const c = (u) => {
    if (typeof u == "string")
      return u;
    if (typeof u == "object" && u._getConnection !== void 0)
      return u._getConnection().url;
    throw new Error("Must provide valid provider URL or Web3Provider");
  };
  return provider.getProvider = c, provider;
}
var requests = {}, hasRequiredRequests;
function requireRequests() {
  return hasRequiredRequests || (hasRequiredRequests = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.CLRequestFactory = n.ConsolidationRequest = n.WithdrawalRequest = n.DepositRequest = n.CLRequest = n.CLRequestType = void 0;
    const c = requireCjs$1(), u = requireUtils$8(), p = requireBytes$8(), a = requireConstants();
    var A;
    (function($) {
      $[$.Deposit = 0] = "Deposit", $[$.Withdrawal = 1] = "Withdrawal", $[$.Consolidation = 2] = "Consolidation";
    })(A = n.CLRequestType || (n.CLRequestType = {}));
    class b {
      constructor(Ee) {
        this.type = Ee;
      }
    }
    n.CLRequest = b;
    class F extends b {
      constructor(Ee, be, He, Pe, nr) {
        super(A.Deposit), this.pubkey = Ee, this.withdrawalCredentials = be, this.amount = He, this.signature = Pe, this.index = nr;
      }
      static fromRequestData(Ee) {
        const { pubkey: be, withdrawalCredentials: He, amount: Pe, signature: nr, index: ir } = Ee;
        return new F(be, He, Pe, nr, ir);
      }
      static fromJSON(Ee) {
        const { pubkey: be, withdrawalCredentials: He, amount: Pe, signature: nr, index: ir } = Ee;
        return this.fromRequestData({
          pubkey: (0, p.hexToBytes)(be),
          withdrawalCredentials: (0, p.hexToBytes)(He),
          amount: (0, p.hexToBigInt)(Pe),
          signature: (0, p.hexToBytes)(nr),
          index: (0, p.hexToBigInt)(ir)
        });
      }
      serialize() {
        const Ee = this.index === a.BIGINT_0 ? new Uint8Array() : (0, p.bigIntToBytes)(this.index), be = this.amount === a.BIGINT_0 ? new Uint8Array() : (0, p.bigIntToBytes)(this.amount);
        return (0, u.concatBytes)(Uint8Array.from([this.type]), c.RLP.encode([this.pubkey, this.withdrawalCredentials, be, this.signature, Ee]));
      }
      toJSON() {
        return {
          pubkey: (0, p.bytesToHex)(this.pubkey),
          withdrawalCredentials: (0, p.bytesToHex)(this.withdrawalCredentials),
          amount: (0, p.bigIntToHex)(this.amount),
          signature: (0, p.bytesToHex)(this.signature),
          index: (0, p.bigIntToHex)(this.index)
        };
      }
      static deserialize(Ee) {
        const [be, He, Pe, nr, ir] = c.RLP.decode(Ee.slice(1));
        return this.fromRequestData({
          pubkey: be,
          withdrawalCredentials: He,
          amount: (0, p.bytesToBigInt)(Pe),
          signature: nr,
          index: (0, p.bytesToBigInt)(ir)
        });
      }
    }
    n.DepositRequest = F;
    class le extends b {
      constructor(Ee, be, He) {
        super(A.Withdrawal), this.sourceAddress = Ee, this.validatorPubkey = be, this.amount = He;
      }
      static fromRequestData(Ee) {
        const { sourceAddress: be, validatorPubkey: He, amount: Pe } = Ee;
        return new le(be, He, Pe);
      }
      static fromJSON(Ee) {
        const { sourceAddress: be, validatorPubkey: He, amount: Pe } = Ee;
        return this.fromRequestData({
          sourceAddress: (0, p.hexToBytes)(be),
          validatorPubkey: (0, p.hexToBytes)(He),
          amount: (0, p.hexToBigInt)(Pe)
        });
      }
      serialize() {
        const Ee = this.amount === a.BIGINT_0 ? new Uint8Array() : (0, p.bigIntToBytes)(this.amount);
        return (0, u.concatBytes)(Uint8Array.from([this.type]), c.RLP.encode([this.sourceAddress, this.validatorPubkey, Ee]));
      }
      toJSON() {
        return {
          sourceAddress: (0, p.bytesToHex)(this.sourceAddress),
          validatorPubkey: (0, p.bytesToHex)(this.validatorPubkey),
          amount: (0, p.bigIntToHex)(this.amount)
        };
      }
      static deserialize(Ee) {
        const [be, He, Pe] = c.RLP.decode(Ee.slice(1));
        return this.fromRequestData({
          sourceAddress: be,
          validatorPubkey: He,
          amount: (0, p.bytesToBigInt)(Pe)
        });
      }
    }
    n.WithdrawalRequest = le;
    class L extends b {
      constructor(Ee, be, He) {
        super(A.Consolidation), this.sourceAddress = Ee, this.sourcePubkey = be, this.targetPubkey = He;
      }
      static fromRequestData(Ee) {
        const { sourceAddress: be, sourcePubkey: He, targetPubkey: Pe } = Ee;
        return new L(be, He, Pe);
      }
      static fromJSON(Ee) {
        const { sourceAddress: be, sourcePubkey: He, targetPubkey: Pe } = Ee;
        return this.fromRequestData({
          sourceAddress: (0, p.hexToBytes)(be),
          sourcePubkey: (0, p.hexToBytes)(He),
          targetPubkey: (0, p.hexToBytes)(Pe)
        });
      }
      serialize() {
        return (0, u.concatBytes)(Uint8Array.from([this.type]), c.RLP.encode([this.sourceAddress, this.sourcePubkey, this.targetPubkey]));
      }
      toJSON() {
        return {
          sourceAddress: (0, p.bytesToHex)(this.sourceAddress),
          sourcePubkey: (0, p.bytesToHex)(this.sourcePubkey),
          targetPubkey: (0, p.bytesToHex)(this.targetPubkey)
        };
      }
      static deserialize(Ee) {
        const [be, He, Pe] = c.RLP.decode(Ee.slice(1));
        return this.fromRequestData({
          sourceAddress: be,
          sourcePubkey: He,
          targetPubkey: Pe
        });
      }
    }
    n.ConsolidationRequest = L;
    class pe {
      static fromSerializedRequest(Ee) {
        switch (Ee[0]) {
          case A.Deposit:
            return F.deserialize(Ee);
          case A.Withdrawal:
            return le.deserialize(Ee);
          case A.Consolidation:
            return L.deserialize(Ee);
          default:
            throw Error(`Invalid request type=${Ee[0]}`);
        }
      }
    }
    n.CLRequestFactory = pe;
  }(requests)), requests;
}
var verkle = {}, hasRequiredVerkle;
function requireVerkle() {
  return hasRequiredVerkle || (hasRequiredVerkle = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.getVerkleTreeKeyForStorageSlot = n.chunkifyCode = n.getVerkleTreeKeyForCodeChunk = n.getVerkleTreeIndicesForCodeChunk = n.getVerkleTreeIndexesForStorageSlot = n.getVerkleKey = n.VERKLE_MAIN_STORAGE_OFFSET = n.VERKLE_NODE_WIDTH = n.VERKLE_CODE_OFFSET = n.VERKLE_HEADER_STORAGE_OFFSET = n.VERKLE_CODE_SIZE_LEAF_KEY = n.VERKLE_CODE_HASH_LEAF_KEY = n.VERKLE_NONCE_LEAF_KEY = n.VERKLE_BALANCE_LEAF_KEY = n.VERKLE_VERSION_LEAF_KEY = n.VerkleLeafType = n.verifyVerkleProof = n.getVerkleStem = void 0;
    const c = requireBytes$8();
    function u($, Ee, be = 0) {
      const He = (0, c.setLengthLeft)(Ee.toBytes(), 32);
      let Pe;
      return typeof be == "number" ? Pe = (0, c.setLengthRight)((0, c.int32ToBytes)(Number(be), !0), 32) : Pe = (0, c.setLengthRight)((0, c.bigIntToBytes)(BigInt(be), !0).slice(0, 32), 32), $.getTreeKey(He, Pe, 0).slice(0, 31);
    }
    n.getVerkleStem = u;
    function p($, Ee, be) {
      return $.verifyExecutionWitnessPreState((0, c.bytesToHex)(Ee), JSON.stringify(be));
    }
    n.verifyVerkleProof = p;
    var a;
    (function($) {
      $[$.Version = 0] = "Version", $[$.Balance = 1] = "Balance", $[$.Nonce = 2] = "Nonce", $[$.CodeHash = 3] = "CodeHash", $[$.CodeSize = 4] = "CodeSize";
    })(a = n.VerkleLeafType || (n.VerkleLeafType = {})), n.VERKLE_VERSION_LEAF_KEY = (0, c.intToBytes)(a.Version), n.VERKLE_BALANCE_LEAF_KEY = (0, c.intToBytes)(a.Balance), n.VERKLE_NONCE_LEAF_KEY = (0, c.intToBytes)(a.Nonce), n.VERKLE_CODE_HASH_LEAF_KEY = (0, c.intToBytes)(a.CodeHash), n.VERKLE_CODE_SIZE_LEAF_KEY = (0, c.intToBytes)(a.CodeSize), n.VERKLE_HEADER_STORAGE_OFFSET = 64, n.VERKLE_CODE_OFFSET = 128, n.VERKLE_NODE_WIDTH = 256, n.VERKLE_MAIN_STORAGE_OFFSET = BigInt(256) ** BigInt(31);
    const A = ($, Ee) => {
      switch (Ee) {
        case a.Version:
          return (0, c.concatBytes)($, n.VERKLE_VERSION_LEAF_KEY);
        case a.Balance:
          return (0, c.concatBytes)($, n.VERKLE_BALANCE_LEAF_KEY);
        case a.Nonce:
          return (0, c.concatBytes)($, n.VERKLE_NONCE_LEAF_KEY);
        case a.CodeHash:
          return (0, c.concatBytes)($, n.VERKLE_CODE_HASH_LEAF_KEY);
        case a.CodeSize:
          return (0, c.concatBytes)($, n.VERKLE_CODE_SIZE_LEAF_KEY);
        default:
          return (0, c.concatBytes)($, Ee);
      }
    };
    n.getVerkleKey = A;
    function b($) {
      let Ee;
      $ < n.VERKLE_CODE_OFFSET - n.VERKLE_HEADER_STORAGE_OFFSET ? Ee = BigInt(n.VERKLE_HEADER_STORAGE_OFFSET) + $ : Ee = n.VERKLE_MAIN_STORAGE_OFFSET + $;
      const be = Ee / BigInt(n.VERKLE_NODE_WIDTH), He = Number(Ee % BigInt(n.VERKLE_NODE_WIDTH));
      return { treeIndex: be, subIndex: He };
    }
    n.getVerkleTreeIndexesForStorageSlot = b;
    function F($) {
      const Ee = Math.floor((n.VERKLE_CODE_OFFSET + $) / n.VERKLE_NODE_WIDTH), be = (n.VERKLE_CODE_OFFSET + $) % n.VERKLE_NODE_WIDTH;
      return { treeIndex: Ee, subIndex: be };
    }
    n.getVerkleTreeIndicesForCodeChunk = F;
    const le = async ($, Ee, be) => {
      const { treeIndex: He, subIndex: Pe } = F(Ee);
      return (0, c.concatBytes)(u(be, $, He), (0, c.toBytes)(Pe));
    };
    n.getVerkleTreeKeyForCodeChunk = le;
    const L = ($) => {
      if ($.length % 31 !== 0) {
        const Ee = 31 - $.length % 31;
        $ = (0, c.setLengthRight)($, $.length + Ee);
      }
      throw new Error("Not implemented");
    };
    n.chunkifyCode = L;
    const pe = async ($, Ee, be) => {
      const { treeIndex: He, subIndex: Pe } = b(Ee);
      return (0, c.concatBytes)(u(be, $, He), (0, c.toBytes)(Pe));
    };
    n.getVerkleTreeKeyForStorageSlot = pe;
  }(verkle)), verkle;
}
var hasRequiredCjs;
function requireCjs() {
  return hasRequiredCjs || (hasRequiredCjs = 1, function(n) {
    var c = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(a, A, b, F) {
      F === void 0 && (F = b);
      var le = Object.getOwnPropertyDescriptor(A, b);
      (!le || ("get" in le ? !A.__esModule : le.writable || le.configurable)) && (le = { enumerable: !0, get: function() {
        return A[b];
      } }), Object.defineProperty(a, F, le);
    } : function(a, A, b, F) {
      F === void 0 && (F = b), a[F] = A[b];
    }), u = commonjsGlobal && commonjsGlobal.__exportStar || function(a, A) {
      for (var b in a) b !== "default" && !Object.prototype.hasOwnProperty.call(A, b) && c(A, a, b);
    };
    Object.defineProperty(n, "__esModule", { value: !0 }), n.toAscii = n.stripHexPrefix = n.padToEven = n.isHexString = n.getKeys = n.getBinarySize = n.fromUtf8 = n.fromAscii = n.arrayContainsArray = void 0, u(requireConstants(), n), u(requireUnits(), n), u(requireAccount(), n), u(requireAddress(), n), u(requireDb(), n), u(requireWithdrawal(), n), u(requireSignature(), n), u(requireBytes$8(), n), u(requireTypes$8(), n), u(requireAsyncEventEmitter(), n), u(requireBlobs(), n), u(requireGenesis(), n);
    var p = requireInternal();
    Object.defineProperty(n, "arrayContainsArray", { enumerable: !0, get: function() {
      return p.arrayContainsArray;
    } }), Object.defineProperty(n, "fromAscii", { enumerable: !0, get: function() {
      return p.fromAscii;
    } }), Object.defineProperty(n, "fromUtf8", { enumerable: !0, get: function() {
      return p.fromUtf8;
    } }), Object.defineProperty(n, "getBinarySize", { enumerable: !0, get: function() {
      return p.getBinarySize;
    } }), Object.defineProperty(n, "getKeys", { enumerable: !0, get: function() {
      return p.getKeys;
    } }), Object.defineProperty(n, "isHexString", { enumerable: !0, get: function() {
      return p.isHexString;
    } }), Object.defineProperty(n, "padToEven", { enumerable: !0, get: function() {
      return p.padToEven;
    } }), Object.defineProperty(n, "stripHexPrefix", { enumerable: !0, get: function() {
      return p.stripHexPrefix;
    } }), Object.defineProperty(n, "toAscii", { enumerable: !0, get: function() {
      return p.toAscii;
    } }), u(requireKzg(), n), u(requireLock(), n), u(requireMapDB(), n), u(requireProvider(), n), u(requireRequests(), n), u(requireVerkle(), n);
  }(cjs$3)), cjs$3;
}
var hasRequiredBcUrRegistryEth_cjs_production_min;
function requireBcUrRegistryEth_cjs_production_min() {
  return hasRequiredBcUrRegistryEth_cjs_production_min || (hasRequiredBcUrRegistryEth_cjs_production_min = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 });
    var c, u = requireDist$8(), p = require$$1$8, a = (c = requireHdkey()) && typeof c == "object" && "default" in c ? c.default : c, A = requireCjs();
    const b = { ETH_SIGN_REQUEST: new u.RegistryType("eth-sign-request", 401), ETH_SIGNATURE: new u.RegistryType("eth-signature", 402), ETH_NFT_ITEM: new u.RegistryType("eth-nft-item", 403) }, { decodeToDataItem: F, RegistryTypes: le } = u.extend;
    var L, pe;
    (function(Ir) {
      Ir[Ir.requestId = 1] = "requestId", Ir[Ir.signData = 2] = "signData", Ir[Ir.dataType = 3] = "dataType", Ir[Ir.chainId = 4] = "chainId", Ir[Ir.derivationPath = 5] = "derivationPath", Ir[Ir.address = 6] = "address", Ir[Ir.origin = 7] = "origin";
    })(L || (L = {})), (pe = n.DataType || (n.DataType = {}))[pe.transaction = 1] = "transaction", pe[pe.typedData = 2] = "typedData", pe[pe.personalMessage = 3] = "personalMessage", pe[pe.typedTransaction = 4] = "typedTransaction";
    class $ extends u.RegistryItem {
      constructor(xr) {
        super(), this.getRegistryType = () => b.ETH_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDataType = () => this.dataType, this.getChainId = () => this.chainId, this.getDerivationPath = () => this.derivationPath.getPath(), this.getSourceFingerprint = () => this.derivationPath.getSourceFingerprint(), this.getSignRequestAddress = () => this.address, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const kr = {};
          this.requestId && (kr[L.requestId] = new u.DataItem(this.requestId, le.UUID.getTag())), this.address && (kr[L.address] = this.address), this.chainId && (kr[L.chainId] = Number(this.chainId)), this.origin && (kr[L.origin] = this.origin), kr[L.signData] = this.signData, kr[L.dataType] = this.dataType;
          const Ce = this.derivationPath.toDataItem();
          return Ce.setTag(this.derivationPath.getRegistryType().getTag()), kr[L.derivationPath] = Ce, new u.DataItem(kr);
        }, this.requestId = xr.requestId, this.signData = xr.signData, this.dataType = xr.dataType, this.chainId = xr.chainId, this.derivationPath = xr.derivationPath, this.address = xr.address, this.origin = xr.origin;
      }
      static constructETHRequest(xr, kr, Ce, tr, Fe, Sr, er, Ie) {
        const xe = Ce.replace(/[m|M]\//, "").split("/"), rr = new u.CryptoKeypath(xe.map((ar) => {
          const yr = parseInt(ar.replace("'", ""));
          let _r = !1;
          return ar.endsWith("'") && (_r = !0), new u.PathComponent({ index: yr, hardened: _r });
        }), Buffer$f.from(tr, "hex"));
        return new $({ requestId: Fe ? Buffer$f.from(p.parse(Fe)) : void 0, signData: xr, dataType: kr, derivationPath: rr, chainId: Sr, address: er ? Buffer$f.from(er.replace("0x", ""), "hex") : void 0, origin: Ie || void 0 });
      }
    }
    $.fromDataItem = (Ir) => {
      const xr = Ir.getData(), kr = xr[L.signData], Ce = xr[L.dataType], tr = u.CryptoKeypath.fromDataItem(xr[L.derivationPath]), Fe = xr[L.chainId] ? xr[L.chainId] : void 0, Sr = xr[L.address] ? xr[L.address] : void 0, er = xr[L.requestId] ? xr[L.requestId].getData() : void 0;
      return new $({ requestId: er, signData: kr, dataType: Ce, chainId: Fe, derivationPath: tr, address: Sr, origin: xr[L.origin] ? xr[L.origin] : void 0 });
    }, $.fromCBOR = (Ir) => {
      const xr = F(Ir);
      return $.fromDataItem(xr);
    };
    const { RegistryTypes: Ee, decodeToDataItem: be } = u.extend;
    var He;
    (function(Ir) {
      Ir[Ir.requestId = 1] = "requestId", Ir[Ir.signature = 2] = "signature", Ir[Ir.origin = 3] = "origin";
    })(He || (He = {}));
    class Pe extends u.RegistryItem {
      constructor(xr, kr, Ce) {
        super(), this.getRegistryType = () => b.ETH_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const tr = {};
          return this.requestId && (tr[He.requestId] = new u.DataItem(this.requestId, Ee.UUID.getTag())), this.origin && (tr[He.origin] = this.origin), tr[He.signature] = this.signature, new u.DataItem(tr);
        }, this.signature = xr, this.requestId = kr, this.origin = Ce;
      }
    }
    Pe.fromDataItem = (Ir) => {
      const xr = Ir.getData(), kr = xr[He.signature], Ce = xr[He.requestId] ? xr[He.requestId].getData() : void 0;
      return new Pe(kr, Ce, xr[He.origin]);
    }, Pe.fromCBOR = (Ir) => {
      const xr = be(Ir);
      return Pe.fromDataItem(xr);
    };
    const { decodeToDataItem: nr } = u.extend;
    var ir;
    (function(Ir) {
      Ir[Ir.chainId = 1] = "chainId", Ir[Ir.contractAddress = 2] = "contractAddress", Ir[Ir.contractName = 3] = "contractName", Ir[Ir.name = 4] = "name", Ir[Ir.mediaData = 5] = "mediaData";
    })(ir || (ir = {}));
    class or extends u.RegistryItem {
      constructor(xr) {
        super(), this.getRegistryType = () => b.ETH_NFT_ITEM, this.getChainId = () => this.chainId, this.getName = () => this.name, this.getmediaData = () => this.mediaData, this.getContractAddress = () => this.contractAddress, this.getContractName = () => this.contractName, this.toDataItem = () => {
          const kr = {};
          return kr[ir.chainId] = this.chainId, kr[ir.name] = this.name, kr[ir.contractAddress] = this.contractAddress, kr[ir.contractName] = this.contractName, kr[ir.mediaData] = this.mediaData, new u.DataItem(kr);
        }, this.chainId = xr.chainId, this.name = xr.name, this.contractAddress = xr.contractAddress, this.contractName = xr.contractName, this.mediaData = xr.mediaData;
      }
      static constructETHNFTItem(xr, kr, Ce, tr, Fe) {
        return new or({ chainId: xr, contractAddress: kr, contractName: Ce, mediaData: Fe, name: tr });
      }
    }
    or.fromDataItem = (Ir) => {
      const xr = Ir.getData();
      return new or({ chainId: xr[ir.chainId], name: xr[ir.name], contractAddress: xr[ir.contractAddress], contractName: xr[ir.contractName], mediaData: xr[ir.mediaData] });
    }, or.fromCBOR = (Ir) => {
      const xr = nr(Ir);
      return or.fromDataItem(xr);
    };
    const lr = (Ir, xr) => {
      const kr = a.fromExtendedKey(Ir).derive(xr), Ce = "0x" + Buffer$f.from(A.publicToAddress(kr.publicKey, !0)).toString("hex");
      return A.toChecksumAddress(Ce);
    };
    u.patchTags(Object.values(b).filter((Ir) => !!Ir.getTag()).map((Ir) => Ir.getTag())), Object.keys(u).forEach(function(Ir) {
      Ir !== "default" && Object.defineProperty(n, Ir, { enumerable: !0, get: function() {
        return u[Ir];
      } });
    }), n.ETHNFTItem = or, n.ETHSignature = Pe, n.EthSignRequest = $, n.findHDPathFromAddress = (Ir, xr, kr, Ce) => {
      for (let tr = 0; tr < kr; tr++) {
        const Fe = lr(xr, "M/0/" + tr);
        if (Ir.toLowerCase() == Fe.toLowerCase()) return `${Ce}/0/${tr}`;
      }
      return null;
    }, n.generateAddressFromXpub = lr;
  }(bcUrRegistryEth_cjs_production_min)), bcUrRegistryEth_cjs_production_min;
}
var bcUrRegistryEth_cjs_development = {}, hasRequiredBcUrRegistryEth_cjs_development;
function requireBcUrRegistryEth_cjs_development() {
  return hasRequiredBcUrRegistryEth_cjs_development || (hasRequiredBcUrRegistryEth_cjs_development = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 });
    function c(Ir) {
      return Ir && typeof Ir == "object" && "default" in Ir ? Ir.default : Ir;
    }
    var u = requireDist$8(), p = require$$1$8, a = c(requireHdkey()), A = requireCjs();
    const b = {
      ETH_SIGN_REQUEST: /* @__PURE__ */ new u.RegistryType("eth-sign-request", 401),
      ETH_SIGNATURE: /* @__PURE__ */ new u.RegistryType("eth-signature", 402),
      ETH_NFT_ITEM: /* @__PURE__ */ new u.RegistryType("eth-nft-item", 403)
    }, {
      decodeToDataItem: F,
      RegistryTypes: le
    } = u.extend;
    var L;
    (function(Ir) {
      Ir[Ir.requestId = 1] = "requestId", Ir[Ir.signData = 2] = "signData", Ir[Ir.dataType = 3] = "dataType", Ir[Ir.chainId = 4] = "chainId", Ir[Ir.derivationPath = 5] = "derivationPath", Ir[Ir.address = 6] = "address", Ir[Ir.origin = 7] = "origin";
    })(L || (L = {})), function(Ir) {
      Ir[Ir.transaction = 1] = "transaction", Ir[Ir.typedData = 2] = "typedData", Ir[Ir.personalMessage = 3] = "personalMessage", Ir[Ir.typedTransaction = 4] = "typedTransaction";
    }(n.DataType || (n.DataType = {}));
    class pe extends u.RegistryItem {
      constructor(xr) {
        super(), this.getRegistryType = () => b.ETH_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDataType = () => this.dataType, this.getChainId = () => this.chainId, this.getDerivationPath = () => this.derivationPath.getPath(), this.getSourceFingerprint = () => this.derivationPath.getSourceFingerprint(), this.getSignRequestAddress = () => this.address, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const kr = {};
          this.requestId && (kr[L.requestId] = new u.DataItem(this.requestId, le.UUID.getTag())), this.address && (kr[L.address] = this.address), this.chainId && (kr[L.chainId] = Number(this.chainId)), this.origin && (kr[L.origin] = this.origin), kr[L.signData] = this.signData, kr[L.dataType] = this.dataType;
          const Ce = this.derivationPath.toDataItem();
          return Ce.setTag(this.derivationPath.getRegistryType().getTag()), kr[L.derivationPath] = Ce, new u.DataItem(kr);
        }, this.requestId = xr.requestId, this.signData = xr.signData, this.dataType = xr.dataType, this.chainId = xr.chainId, this.derivationPath = xr.derivationPath, this.address = xr.address, this.origin = xr.origin;
      }
      static constructETHRequest(xr, kr, Ce, tr, Fe, Sr, er, Ie) {
        const xe = Ce.replace(/[m|M]\//, "").split("/"), rr = new u.CryptoKeypath(xe.map((ar) => {
          const yr = parseInt(ar.replace("'", ""));
          let _r = !1;
          return ar.endsWith("'") && (_r = !0), new u.PathComponent({
            index: yr,
            hardened: _r
          });
        }), Buffer$f.from(tr, "hex"));
        return new pe({
          requestId: Fe ? Buffer$f.from(p.parse(Fe)) : void 0,
          signData: xr,
          dataType: kr,
          derivationPath: rr,
          chainId: Sr,
          address: er ? Buffer$f.from(er.replace("0x", ""), "hex") : void 0,
          origin: Ie || void 0
        });
      }
    }
    pe.fromDataItem = (Ir) => {
      const xr = Ir.getData(), kr = xr[L.signData], Ce = xr[L.dataType], tr = u.CryptoKeypath.fromDataItem(xr[L.derivationPath]), Fe = xr[L.chainId] ? xr[L.chainId] : void 0, Sr = xr[L.address] ? xr[L.address] : void 0, er = xr[L.requestId] ? xr[L.requestId].getData() : void 0, Ie = xr[L.origin] ? xr[L.origin] : void 0;
      return new pe({
        requestId: er,
        signData: kr,
        dataType: Ce,
        chainId: Fe,
        derivationPath: tr,
        address: Sr,
        origin: Ie
      });
    }, pe.fromCBOR = (Ir) => {
      const xr = F(Ir);
      return pe.fromDataItem(xr);
    };
    const {
      RegistryTypes: $,
      decodeToDataItem: Ee
    } = u.extend;
    var be;
    (function(Ir) {
      Ir[Ir.requestId = 1] = "requestId", Ir[Ir.signature = 2] = "signature", Ir[Ir.origin = 3] = "origin";
    })(be || (be = {}));
    class He extends u.RegistryItem {
      constructor(xr, kr, Ce) {
        super(), this.getRegistryType = () => b.ETH_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const tr = {};
          return this.requestId && (tr[be.requestId] = new u.DataItem(this.requestId, $.UUID.getTag())), this.origin && (tr[be.origin] = this.origin), tr[be.signature] = this.signature, new u.DataItem(tr);
        }, this.signature = xr, this.requestId = kr, this.origin = Ce;
      }
    }
    He.fromDataItem = (Ir) => {
      const xr = Ir.getData(), kr = xr[be.signature], Ce = xr[be.requestId] ? xr[be.requestId].getData() : void 0;
      return new He(kr, Ce, xr[be.origin]);
    }, He.fromCBOR = (Ir) => {
      const xr = Ee(Ir);
      return He.fromDataItem(xr);
    };
    const {
      decodeToDataItem: Pe
    } = u.extend;
    var nr;
    (function(Ir) {
      Ir[Ir.chainId = 1] = "chainId", Ir[Ir.contractAddress = 2] = "contractAddress", Ir[Ir.contractName = 3] = "contractName", Ir[Ir.name = 4] = "name", Ir[Ir.mediaData = 5] = "mediaData";
    })(nr || (nr = {}));
    class ir extends u.RegistryItem {
      constructor(xr) {
        super(), this.getRegistryType = () => b.ETH_NFT_ITEM, this.getChainId = () => this.chainId, this.getName = () => this.name, this.getmediaData = () => this.mediaData, this.getContractAddress = () => this.contractAddress, this.getContractName = () => this.contractName, this.toDataItem = () => {
          const kr = {};
          return kr[nr.chainId] = this.chainId, kr[nr.name] = this.name, kr[nr.contractAddress] = this.contractAddress, kr[nr.contractName] = this.contractName, kr[nr.mediaData] = this.mediaData, new u.DataItem(kr);
        }, this.chainId = xr.chainId, this.name = xr.name, this.contractAddress = xr.contractAddress, this.contractName = xr.contractName, this.mediaData = xr.mediaData;
      }
      static constructETHNFTItem(xr, kr, Ce, tr, Fe) {
        return new ir({
          chainId: xr,
          contractAddress: kr,
          contractName: Ce,
          mediaData: Fe,
          name: tr
        });
      }
    }
    ir.fromDataItem = (Ir) => {
      const xr = Ir.getData(), kr = xr[nr.chainId], Ce = xr[nr.name], tr = xr[nr.mediaData], Fe = xr[nr.contractAddress], Sr = xr[nr.contractName];
      return new ir({
        chainId: kr,
        name: Ce,
        contractAddress: Fe,
        contractName: Sr,
        mediaData: tr
      });
    }, ir.fromCBOR = (Ir) => {
      const xr = Pe(Ir);
      return ir.fromDataItem(xr);
    };
    const or = (Ir, xr) => {
      const Ce = a.fromExtendedKey(Ir).derive(xr), tr = "0x" + Buffer$f.from(A.publicToAddress(Ce.publicKey, !0)).toString("hex");
      return A.toChecksumAddress(tr);
    }, lr = (Ir, xr, kr, Ce) => {
      for (let tr = 0; tr < kr; tr++) {
        const Fe = `M/0/${tr}`, Sr = or(xr, Fe);
        if (Ir.toLowerCase() == Sr.toLowerCase())
          return `${Ce}/0/${tr}`;
      }
      return null;
    };
    u.patchTags(Object.values(b).filter((Ir) => !!Ir.getTag()).map((Ir) => Ir.getTag())), Object.keys(u).forEach(function(Ir) {
      Ir !== "default" && Object.defineProperty(n, Ir, {
        enumerable: !0,
        get: function() {
          return u[Ir];
        }
      });
    }), n.ETHNFTItem = ir, n.ETHSignature = He, n.EthSignRequest = pe, n.findHDPathFromAddress = lr, n.generateAddressFromXpub = or;
  }(bcUrRegistryEth_cjs_development)), bcUrRegistryEth_cjs_development;
}
process$1.env.NODE_ENV === "production" ? dist$m.exports = requireBcUrRegistryEth_cjs_production_min() : dist$m.exports = requireBcUrRegistryEth_cjs_development();
var distExports$9 = dist$m.exports;
Object.defineProperty(ethereum$2, "__esModule", { value: !0 });
ethereum$2.KeystoneEthereumSDK = void 0;
const bc_ur_registry_eth_1 = distExports$9, utils_1$k = utils$K, ur_1$9 = ur;
class KeystoneEthereumSDK {
  constructor(c) {
    this.config = c;
  }
  parseSignature(c) {
    if (c.type !== ur_1$9.URType.EthSignature)
      throw new Error("type not match");
    const u = bc_ur_registry_eth_1.ETHSignature.fromCBOR(c.cbor), p = u.getRequestId();
    return {
      requestId: p === void 0 ? void 0 : (0, utils_1$k.uuidStringify)(p),
      signature: (0, utils_1$k.toHex)(u.getSignature()),
      origin: u.getOrigin()
    };
  }
  generateSignRequest({ requestId: c, signData: u, dataType: p, path: a, xfp: A, chainId: b, address: F, origin: le }) {
    var L;
    return new bc_ur_registry_eth_1.EthSignRequest({
      requestId: (0, utils_1$k.uuidParse)(c),
      signData: (0, utils_1$k.toBuffer)(u),
      dataType: p,
      derivationPath: new bc_ur_registry_eth_1.CryptoKeypath((0, utils_1$k.parsePath)(a).map((pe) => new bc_ur_registry_eth_1.PathComponent(pe)), (0, utils_1$k.toBuffer)(A)),
      chainId: b,
      address: F !== void 0 ? (0, utils_1$k.toBuffer)(F) : void 0,
      origin: le ?? ((L = this.config) === null || L === void 0 ? void 0 : L.origin)
    }).toUR();
  }
}
KeystoneEthereumSDK.DataType = bc_ur_registry_eth_1.DataType;
ethereum$2.KeystoneEthereumSDK = KeystoneEthereumSDK;
var solana = {}, dist$k = { exports: {} }, bcUrRegistrySol_cjs_production_min = {}, getRandomValues$8, rnds8$6 = new Uint8Array(16);
function rng$8() {
  if (!getRandomValues$8 && (getRandomValues$8 = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !getRandomValues$8))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return getRandomValues$8(rnds8$6);
}
const REGEX$5 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function validate$8(n) {
  return typeof n == "string" && REGEX$5.test(n);
}
var byteToHex$6 = [];
for (var i$7 = 0; i$7 < 256; ++i$7)
  byteToHex$6.push((i$7 + 256).toString(16).substr(1));
function stringify$7(n) {
  var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, u = (byteToHex$6[n[c + 0]] + byteToHex$6[n[c + 1]] + byteToHex$6[n[c + 2]] + byteToHex$6[n[c + 3]] + "-" + byteToHex$6[n[c + 4]] + byteToHex$6[n[c + 5]] + "-" + byteToHex$6[n[c + 6]] + byteToHex$6[n[c + 7]] + "-" + byteToHex$6[n[c + 8]] + byteToHex$6[n[c + 9]] + "-" + byteToHex$6[n[c + 10]] + byteToHex$6[n[c + 11]] + byteToHex$6[n[c + 12]] + byteToHex$6[n[c + 13]] + byteToHex$6[n[c + 14]] + byteToHex$6[n[c + 15]]).toLowerCase();
  if (!validate$8(u))
    throw TypeError("Stringified UUID is invalid");
  return u;
}
var _nodeId$5, _clockseq$5, _lastMSecs$5 = 0, _lastNSecs$5 = 0;
function v1$7(n, c, u) {
  var p = c && u || 0, a = c || new Array(16);
  n = n || {};
  var A = n.node || _nodeId$5, b = n.clockseq !== void 0 ? n.clockseq : _clockseq$5;
  if (A == null || b == null) {
    var F = n.random || (n.rng || rng$8)();
    A == null && (A = _nodeId$5 = [F[0] | 1, F[1], F[2], F[3], F[4], F[5]]), b == null && (b = _clockseq$5 = (F[6] << 8 | F[7]) & 16383);
  }
  var le = n.msecs !== void 0 ? n.msecs : Date.now(), L = n.nsecs !== void 0 ? n.nsecs : _lastNSecs$5 + 1, pe = le - _lastMSecs$5 + (L - _lastNSecs$5) / 1e4;
  if (pe < 0 && n.clockseq === void 0 && (b = b + 1 & 16383), (pe < 0 || le > _lastMSecs$5) && n.nsecs === void 0 && (L = 0), L >= 1e4)
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  _lastMSecs$5 = le, _lastNSecs$5 = L, _clockseq$5 = b, le += 122192928e5;
  var $ = ((le & 268435455) * 1e4 + L) % 4294967296;
  a[p++] = $ >>> 24 & 255, a[p++] = $ >>> 16 & 255, a[p++] = $ >>> 8 & 255, a[p++] = $ & 255;
  var Ee = le / 4294967296 * 1e4 & 268435455;
  a[p++] = Ee >>> 8 & 255, a[p++] = Ee & 255, a[p++] = Ee >>> 24 & 15 | 16, a[p++] = Ee >>> 16 & 255, a[p++] = b >>> 8 | 128, a[p++] = b & 255;
  for (var be = 0; be < 6; ++be)
    a[p + be] = A[be];
  return c || stringify$7(a);
}
function parse$e(n) {
  if (!validate$8(n))
    throw TypeError("Invalid UUID");
  var c, u = new Uint8Array(16);
  return u[0] = (c = parseInt(n.slice(0, 8), 16)) >>> 24, u[1] = c >>> 16 & 255, u[2] = c >>> 8 & 255, u[3] = c & 255, u[4] = (c = parseInt(n.slice(9, 13), 16)) >>> 8, u[5] = c & 255, u[6] = (c = parseInt(n.slice(14, 18), 16)) >>> 8, u[7] = c & 255, u[8] = (c = parseInt(n.slice(19, 23), 16)) >>> 8, u[9] = c & 255, u[10] = (c = parseInt(n.slice(24, 36), 16)) / 1099511627776 & 255, u[11] = c / 4294967296 & 255, u[12] = c >>> 24 & 255, u[13] = c >>> 16 & 255, u[14] = c >>> 8 & 255, u[15] = c & 255, u;
}
function stringToBytes$6(n) {
  n = unescape(encodeURIComponent(n));
  for (var c = [], u = 0; u < n.length; ++u)
    c.push(n.charCodeAt(u));
  return c;
}
var DNS$5 = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", URL$6 = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
function v35$7(n, c, u) {
  function p(a, A, b, F) {
    if (typeof a == "string" && (a = stringToBytes$6(a)), typeof A == "string" && (A = parse$e(A)), A.length !== 16)
      throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    var le = new Uint8Array(16 + a.length);
    if (le.set(A), le.set(a, A.length), le = u(le), le[6] = le[6] & 15 | c, le[8] = le[8] & 63 | 128, b) {
      F = F || 0;
      for (var L = 0; L < 16; ++L)
        b[F + L] = le[L];
      return b;
    }
    return stringify$7(le);
  }
  try {
    p.name = n;
  } catch {
  }
  return p.DNS = DNS$5, p.URL = URL$6, p;
}
function md5$7(n) {
  if (typeof n == "string") {
    var c = unescape(encodeURIComponent(n));
    n = new Uint8Array(c.length);
    for (var u = 0; u < c.length; ++u)
      n[u] = c.charCodeAt(u);
  }
  return md5ToHexEncodedArray$5(wordsToMd5$5(bytesToWords$5(n), n.length * 8));
}
function md5ToHexEncodedArray$5(n) {
  for (var c = [], u = n.length * 32, p = "0123456789abcdef", a = 0; a < u; a += 8) {
    var A = n[a >> 5] >>> a % 32 & 255, b = parseInt(p.charAt(A >>> 4 & 15) + p.charAt(A & 15), 16);
    c.push(b);
  }
  return c;
}
function getOutputLength$5(n) {
  return (n + 64 >>> 9 << 4) + 14 + 1;
}
function wordsToMd5$5(n, c) {
  n[c >> 5] |= 128 << c % 32, n[getOutputLength$5(c) - 1] = c;
  for (var u = 1732584193, p = -271733879, a = -1732584194, A = 271733878, b = 0; b < n.length; b += 16) {
    var F = u, le = p, L = a, pe = A;
    u = md5ff$5(u, p, a, A, n[b], 7, -680876936), A = md5ff$5(A, u, p, a, n[b + 1], 12, -389564586), a = md5ff$5(a, A, u, p, n[b + 2], 17, 606105819), p = md5ff$5(p, a, A, u, n[b + 3], 22, -1044525330), u = md5ff$5(u, p, a, A, n[b + 4], 7, -176418897), A = md5ff$5(A, u, p, a, n[b + 5], 12, 1200080426), a = md5ff$5(a, A, u, p, n[b + 6], 17, -1473231341), p = md5ff$5(p, a, A, u, n[b + 7], 22, -45705983), u = md5ff$5(u, p, a, A, n[b + 8], 7, 1770035416), A = md5ff$5(A, u, p, a, n[b + 9], 12, -1958414417), a = md5ff$5(a, A, u, p, n[b + 10], 17, -42063), p = md5ff$5(p, a, A, u, n[b + 11], 22, -1990404162), u = md5ff$5(u, p, a, A, n[b + 12], 7, 1804603682), A = md5ff$5(A, u, p, a, n[b + 13], 12, -40341101), a = md5ff$5(a, A, u, p, n[b + 14], 17, -1502002290), p = md5ff$5(p, a, A, u, n[b + 15], 22, 1236535329), u = md5gg$5(u, p, a, A, n[b + 1], 5, -165796510), A = md5gg$5(A, u, p, a, n[b + 6], 9, -1069501632), a = md5gg$5(a, A, u, p, n[b + 11], 14, 643717713), p = md5gg$5(p, a, A, u, n[b], 20, -373897302), u = md5gg$5(u, p, a, A, n[b + 5], 5, -701558691), A = md5gg$5(A, u, p, a, n[b + 10], 9, 38016083), a = md5gg$5(a, A, u, p, n[b + 15], 14, -660478335), p = md5gg$5(p, a, A, u, n[b + 4], 20, -405537848), u = md5gg$5(u, p, a, A, n[b + 9], 5, 568446438), A = md5gg$5(A, u, p, a, n[b + 14], 9, -1019803690), a = md5gg$5(a, A, u, p, n[b + 3], 14, -187363961), p = md5gg$5(p, a, A, u, n[b + 8], 20, 1163531501), u = md5gg$5(u, p, a, A, n[b + 13], 5, -1444681467), A = md5gg$5(A, u, p, a, n[b + 2], 9, -51403784), a = md5gg$5(a, A, u, p, n[b + 7], 14, 1735328473), p = md5gg$5(p, a, A, u, n[b + 12], 20, -1926607734), u = md5hh$5(u, p, a, A, n[b + 5], 4, -378558), A = md5hh$5(A, u, p, a, n[b + 8], 11, -2022574463), a = md5hh$5(a, A, u, p, n[b + 11], 16, 1839030562), p = md5hh$5(p, a, A, u, n[b + 14], 23, -35309556), u = md5hh$5(u, p, a, A, n[b + 1], 4, -1530992060), A = md5hh$5(A, u, p, a, n[b + 4], 11, 1272893353), a = md5hh$5(a, A, u, p, n[b + 7], 16, -155497632), p = md5hh$5(p, a, A, u, n[b + 10], 23, -1094730640), u = md5hh$5(u, p, a, A, n[b + 13], 4, 681279174), A = md5hh$5(A, u, p, a, n[b], 11, -358537222), a = md5hh$5(a, A, u, p, n[b + 3], 16, -722521979), p = md5hh$5(p, a, A, u, n[b + 6], 23, 76029189), u = md5hh$5(u, p, a, A, n[b + 9], 4, -640364487), A = md5hh$5(A, u, p, a, n[b + 12], 11, -421815835), a = md5hh$5(a, A, u, p, n[b + 15], 16, 530742520), p = md5hh$5(p, a, A, u, n[b + 2], 23, -995338651), u = md5ii$5(u, p, a, A, n[b], 6, -198630844), A = md5ii$5(A, u, p, a, n[b + 7], 10, 1126891415), a = md5ii$5(a, A, u, p, n[b + 14], 15, -1416354905), p = md5ii$5(p, a, A, u, n[b + 5], 21, -57434055), u = md5ii$5(u, p, a, A, n[b + 12], 6, 1700485571), A = md5ii$5(A, u, p, a, n[b + 3], 10, -1894986606), a = md5ii$5(a, A, u, p, n[b + 10], 15, -1051523), p = md5ii$5(p, a, A, u, n[b + 1], 21, -2054922799), u = md5ii$5(u, p, a, A, n[b + 8], 6, 1873313359), A = md5ii$5(A, u, p, a, n[b + 15], 10, -30611744), a = md5ii$5(a, A, u, p, n[b + 6], 15, -1560198380), p = md5ii$5(p, a, A, u, n[b + 13], 21, 1309151649), u = md5ii$5(u, p, a, A, n[b + 4], 6, -145523070), A = md5ii$5(A, u, p, a, n[b + 11], 10, -1120210379), a = md5ii$5(a, A, u, p, n[b + 2], 15, 718787259), p = md5ii$5(p, a, A, u, n[b + 9], 21, -343485551), u = safeAdd$5(u, F), p = safeAdd$5(p, le), a = safeAdd$5(a, L), A = safeAdd$5(A, pe);
  }
  return [u, p, a, A];
}
function bytesToWords$5(n) {
  if (n.length === 0)
    return [];
  for (var c = n.length * 8, u = new Uint32Array(getOutputLength$5(c)), p = 0; p < c; p += 8)
    u[p >> 5] |= (n[p / 8] & 255) << p % 32;
  return u;
}
function safeAdd$5(n, c) {
  var u = (n & 65535) + (c & 65535), p = (n >> 16) + (c >> 16) + (u >> 16);
  return p << 16 | u & 65535;
}
function bitRotateLeft$5(n, c) {
  return n << c | n >>> 32 - c;
}
function md5cmn$5(n, c, u, p, a, A) {
  return safeAdd$5(bitRotateLeft$5(safeAdd$5(safeAdd$5(c, n), safeAdd$5(p, A)), a), u);
}
function md5ff$5(n, c, u, p, a, A, b) {
  return md5cmn$5(c & u | ~c & p, n, c, a, A, b);
}
function md5gg$5(n, c, u, p, a, A, b) {
  return md5cmn$5(c & p | u & ~p, n, c, a, A, b);
}
function md5hh$5(n, c, u, p, a, A, b) {
  return md5cmn$5(c ^ u ^ p, n, c, a, A, b);
}
function md5ii$5(n, c, u, p, a, A, b) {
  return md5cmn$5(u ^ (c | ~p), n, c, a, A, b);
}
var v3$7 = v35$7("v3", 48, md5$7);
function v4$8(n, c, u) {
  n = n || {};
  var p = n.random || (n.rng || rng$8)();
  if (p[6] = p[6] & 15 | 64, p[8] = p[8] & 63 | 128, c) {
    u = u || 0;
    for (var a = 0; a < 16; ++a)
      c[u + a] = p[a];
    return c;
  }
  return stringify$7(p);
}
function f$7(n, c, u, p) {
  switch (n) {
    case 0:
      return c & u ^ ~c & p;
    case 1:
      return c ^ u ^ p;
    case 2:
      return c & u ^ c & p ^ u & p;
    case 3:
      return c ^ u ^ p;
  }
}
function ROTL$5(n, c) {
  return n << c | n >>> 32 - c;
}
function sha1$7(n) {
  var c = [1518500249, 1859775393, 2400959708, 3395469782], u = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
  if (typeof n == "string") {
    var p = unescape(encodeURIComponent(n));
    n = [];
    for (var a = 0; a < p.length; ++a)
      n.push(p.charCodeAt(a));
  } else Array.isArray(n) || (n = Array.prototype.slice.call(n));
  n.push(128);
  for (var A = n.length / 4 + 2, b = Math.ceil(A / 16), F = new Array(b), le = 0; le < b; ++le) {
    for (var L = new Uint32Array(16), pe = 0; pe < 16; ++pe)
      L[pe] = n[le * 64 + pe * 4] << 24 | n[le * 64 + pe * 4 + 1] << 16 | n[le * 64 + pe * 4 + 2] << 8 | n[le * 64 + pe * 4 + 3];
    F[le] = L;
  }
  F[b - 1][14] = (n.length - 1) * 8 / Math.pow(2, 32), F[b - 1][14] = Math.floor(F[b - 1][14]), F[b - 1][15] = (n.length - 1) * 8 & 4294967295;
  for (var $ = 0; $ < b; ++$) {
    for (var Ee = new Uint32Array(80), be = 0; be < 16; ++be)
      Ee[be] = F[$][be];
    for (var He = 16; He < 80; ++He)
      Ee[He] = ROTL$5(Ee[He - 3] ^ Ee[He - 8] ^ Ee[He - 14] ^ Ee[He - 16], 1);
    for (var Pe = u[0], nr = u[1], ir = u[2], or = u[3], lr = u[4], Ir = 0; Ir < 80; ++Ir) {
      var xr = Math.floor(Ir / 20), kr = ROTL$5(Pe, 5) + f$7(xr, nr, ir, or) + lr + c[xr] + Ee[Ir] >>> 0;
      lr = or, or = ir, ir = ROTL$5(nr, 30) >>> 0, nr = Pe, Pe = kr;
    }
    u[0] = u[0] + Pe >>> 0, u[1] = u[1] + nr >>> 0, u[2] = u[2] + ir >>> 0, u[3] = u[3] + or >>> 0, u[4] = u[4] + lr >>> 0;
  }
  return [u[0] >> 24 & 255, u[0] >> 16 & 255, u[0] >> 8 & 255, u[0] & 255, u[1] >> 24 & 255, u[1] >> 16 & 255, u[1] >> 8 & 255, u[1] & 255, u[2] >> 24 & 255, u[2] >> 16 & 255, u[2] >> 8 & 255, u[2] & 255, u[3] >> 24 & 255, u[3] >> 16 & 255, u[3] >> 8 & 255, u[3] & 255, u[4] >> 24 & 255, u[4] >> 16 & 255, u[4] >> 8 & 255, u[4] & 255];
}
var v5$7 = v35$7("v5", 80, sha1$7);
const nil$7 = "00000000-0000-0000-0000-000000000000";
function version$8(n) {
  if (!validate$8(n))
    throw TypeError("Invalid UUID");
  return parseInt(n.substr(14, 1), 16);
}
const esmBrowser$5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  NIL: nil$7,
  parse: parse$e,
  stringify: stringify$7,
  v1: v1$7,
  v3: v3$7,
  v4: v4$8,
  v5: v5$7,
  validate: validate$8,
  version: version$8
}, Symbol.toStringTag, { value: "Module" })), require$$1$5 = /* @__PURE__ */ getAugmentedNamespace(esmBrowser$5);
var hasRequiredBcUrRegistrySol_cjs_production_min;
function requireBcUrRegistrySol_cjs_production_min() {
  return hasRequiredBcUrRegistrySol_cjs_production_min || (hasRequiredBcUrRegistrySol_cjs_production_min = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 });
    var c = requireDist$c(), u = require$$1$5;
    const p = { SOL_SIGN_REQUEST: new c.RegistryType("sol-sign-request", 1101), SOL_SIGNATURE: new c.RegistryType("sol-signature", 1102), SOL_NFT_ITEM: new c.RegistryType("sol-nft-item", 1104) }, { decodeToDataItem: a, RegistryTypes: A } = c.extend;
    var b, F;
    (b = n.SignType || (n.SignType = {}))[b.Transaction = 1] = "Transaction", b[b.Message = 2] = "Message", function(nr) {
      nr[nr.requestId = 1] = "requestId", nr[nr.signData = 2] = "signData", nr[nr.derivationPath = 3] = "derivationPath", nr[nr.address = 4] = "address", nr[nr.origin = 5] = "origin", nr[nr.signType = 6] = "signType";
    }(F || (F = {}));
    class le extends c.RegistryItem {
      constructor(ir) {
        super(), this.getRegistryType = () => p.SOL_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDerivationPath = () => this.derivationPath.getPath(), this.getSignRequestAddress = () => this.address, this.getOrigin = () => this.origin, this.getSignType = () => this.signType, this.toDataItem = () => {
          const or = {};
          this.requestId && (or[F.requestId] = new c.DataItem(this.requestId, A.UUID.getTag())), this.address && (or[F.address] = this.address), this.origin && (or[F.origin] = this.origin), or[F.signData] = this.signData, or[F.signType] = this.signType;
          const lr = this.derivationPath.toDataItem();
          return lr.setTag(this.derivationPath.getRegistryType().getTag()), or[F.derivationPath] = lr, new c.DataItem(or);
        }, this.requestId = ir.requestId, this.signData = ir.signData, this.derivationPath = ir.derivationPath, this.address = ir.address, this.origin = ir.origin, this.signType = ir.signType;
      }
      static constructSOLRequest(ir, or, lr, Ir, xr, kr, Ce) {
        const tr = or.replace(/[m|M]\//, "").split("/"), Fe = new c.CryptoKeypath(tr.map((Sr) => {
          const er = parseInt(Sr.replace("'", ""));
          let Ie = !1;
          return Sr.endsWith("'") && (Ie = !0), new c.PathComponent({ index: er, hardened: Ie });
        }), Buffer$f.from(lr, "hex"));
        return new le({ requestId: xr ? Buffer$f.from(u.parse(xr)) : void 0, signData: ir, derivationPath: Fe, address: kr ? Buffer$f.from(kr.replace("0x", ""), "hex") : void 0, origin: Ce || void 0, signType: Ir });
      }
    }
    le.fromDataItem = (nr) => {
      const ir = nr.getData(), or = ir[F.signData], lr = c.CryptoKeypath.fromDataItem(ir[F.derivationPath]), Ir = ir[F.address] ? ir[F.address] : void 0, xr = ir[F.requestId] ? ir[F.requestId].getData() : void 0;
      return new le({ requestId: xr, signData: or, derivationPath: lr, address: Ir, origin: ir[F.origin] ? ir[F.origin] : void 0, signType: ir[F.signType] });
    }, le.fromCBOR = (nr) => {
      const ir = a(nr);
      return le.fromDataItem(ir);
    };
    const { RegistryTypes: L, decodeToDataItem: pe } = c.extend;
    var $;
    (function(nr) {
      nr[nr.requestId = 1] = "requestId", nr[nr.signature = 2] = "signature";
    })($ || ($ = {}));
    class Ee extends c.RegistryItem {
      constructor(ir, or) {
        super(), this.getRegistryType = () => p.SOL_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.toDataItem = () => {
          const lr = {};
          return this.requestId && (lr[$.requestId] = new c.DataItem(this.requestId, L.UUID.getTag())), lr[$.signature] = this.signature, new c.DataItem(lr);
        }, this.signature = ir, this.requestId = or;
      }
    }
    Ee.fromDataItem = (nr) => {
      const ir = nr.getData(), or = ir[$.signature], lr = ir[$.requestId] ? ir[$.requestId].getData() : void 0;
      return new Ee(or, lr);
    }, Ee.fromCBOR = (nr) => {
      const ir = pe(nr);
      return Ee.fromDataItem(ir);
    };
    const { decodeToDataItem: be } = c.extend;
    var He;
    (function(nr) {
      nr[nr.mintAddress = 1] = "mintAddress", nr[nr.collectionName = 2] = "collectionName", nr[nr.name = 3] = "name", nr[nr.mediaData = 4] = "mediaData";
    })(He || (He = {}));
    class Pe extends c.RegistryItem {
      constructor(ir) {
        super(), this.getRegistryType = () => p.SOL_NFT_ITEM, this.getName = () => this.name, this.getMediaData = () => this.mediaData, this.getMintAddress = () => this.mintAddress, this.getCollectionName = () => this.collectionName, this.toDataItem = () => {
          const or = {};
          return or[He.name] = this.name, or[He.mintAddress] = this.mintAddress, or[He.collectionName] = this.collectionName, or[He.mediaData] = this.mediaData, new c.DataItem(or);
        }, this.name = ir.name, this.mintAddress = ir.mintAddress, this.collectionName = ir.collectionName, this.mediaData = ir.mediaData;
      }
      static constructETHNFTItem(ir, or, lr, Ir) {
        return new Pe({ mintAddress: ir, collectionName: or, mediaData: Ir, name: lr });
      }
    }
    Pe.fromDataItem = (nr) => {
      const ir = nr.getData();
      return new Pe({ name: ir[He.name], mintAddress: ir[He.mintAddress], collectionName: ir[He.collectionName], mediaData: ir[He.mediaData] });
    }, Pe.fromCBOR = (nr) => {
      const ir = be(nr);
      return Pe.fromDataItem(ir);
    }, c.patchTags(Object.values(p).filter((nr) => !!nr.getTag()).map((nr) => nr.getTag())), Object.keys(c).forEach(function(nr) {
      nr !== "default" && Object.defineProperty(n, nr, { enumerable: !0, get: function() {
        return c[nr];
      } });
    }), n.SOLNFTItem = Pe, n.SolSignRequest = le, n.SolSignature = Ee;
  }(bcUrRegistrySol_cjs_production_min)), bcUrRegistrySol_cjs_production_min;
}
var bcUrRegistrySol_cjs_development = {}, hasRequiredBcUrRegistrySol_cjs_development;
function requireBcUrRegistrySol_cjs_development() {
  return hasRequiredBcUrRegistrySol_cjs_development || (hasRequiredBcUrRegistrySol_cjs_development = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 });
    var c = requireDist$c(), u = require$$1$5;
    const p = {
      SOL_SIGN_REQUEST: /* @__PURE__ */ new c.RegistryType("sol-sign-request", 1101),
      SOL_SIGNATURE: /* @__PURE__ */ new c.RegistryType("sol-signature", 1102),
      SOL_NFT_ITEM: /* @__PURE__ */ new c.RegistryType("sol-nft-item", 1104)
    }, {
      decodeToDataItem: a,
      RegistryTypes: A
    } = c.extend;
    (function(Pe) {
      Pe[Pe.Transaction = 1] = "Transaction", Pe[Pe.Message = 2] = "Message";
    })(n.SignType || (n.SignType = {}));
    var b;
    (function(Pe) {
      Pe[Pe.requestId = 1] = "requestId", Pe[Pe.signData = 2] = "signData", Pe[Pe.derivationPath = 3] = "derivationPath", Pe[Pe.address = 4] = "address", Pe[Pe.origin = 5] = "origin", Pe[Pe.signType = 6] = "signType";
    })(b || (b = {}));
    class F extends c.RegistryItem {
      constructor(nr) {
        super(), this.getRegistryType = () => p.SOL_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDerivationPath = () => this.derivationPath.getPath(), this.getSignRequestAddress = () => this.address, this.getOrigin = () => this.origin, this.getSignType = () => this.signType, this.toDataItem = () => {
          const ir = {};
          this.requestId && (ir[b.requestId] = new c.DataItem(this.requestId, A.UUID.getTag())), this.address && (ir[b.address] = this.address), this.origin && (ir[b.origin] = this.origin), ir[b.signData] = this.signData, ir[b.signType] = this.signType;
          const or = this.derivationPath.toDataItem();
          return or.setTag(this.derivationPath.getRegistryType().getTag()), ir[b.derivationPath] = or, new c.DataItem(ir);
        }, this.requestId = nr.requestId, this.signData = nr.signData, this.derivationPath = nr.derivationPath, this.address = nr.address, this.origin = nr.origin, this.signType = nr.signType;
      }
      static constructSOLRequest(nr, ir, or, lr, Ir, xr, kr) {
        const Ce = ir.replace(/[m|M]\//, "").split("/"), tr = new c.CryptoKeypath(Ce.map((Fe) => {
          const Sr = parseInt(Fe.replace("'", ""));
          let er = !1;
          return Fe.endsWith("'") && (er = !0), new c.PathComponent({
            index: Sr,
            hardened: er
          });
        }), Buffer$f.from(or, "hex"));
        return new F({
          requestId: Ir ? Buffer$f.from(u.parse(Ir)) : void 0,
          signData: nr,
          derivationPath: tr,
          address: xr ? Buffer$f.from(xr.replace("0x", ""), "hex") : void 0,
          origin: kr || void 0,
          signType: lr
        });
      }
    }
    F.fromDataItem = (Pe) => {
      const nr = Pe.getData(), ir = nr[b.signData], or = c.CryptoKeypath.fromDataItem(nr[b.derivationPath]), lr = nr[b.address] ? nr[b.address] : void 0, Ir = nr[b.requestId] ? nr[b.requestId].getData() : void 0, xr = nr[b.origin] ? nr[b.origin] : void 0, kr = nr[b.signType];
      return new F({
        requestId: Ir,
        signData: ir,
        derivationPath: or,
        address: lr,
        origin: xr,
        signType: kr
      });
    }, F.fromCBOR = (Pe) => {
      const nr = a(Pe);
      return F.fromDataItem(nr);
    };
    const {
      RegistryTypes: le,
      decodeToDataItem: L
    } = c.extend;
    var pe;
    (function(Pe) {
      Pe[Pe.requestId = 1] = "requestId", Pe[Pe.signature = 2] = "signature";
    })(pe || (pe = {}));
    class $ extends c.RegistryItem {
      constructor(nr, ir) {
        super(), this.getRegistryType = () => p.SOL_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.toDataItem = () => {
          const or = {};
          return this.requestId && (or[pe.requestId] = new c.DataItem(this.requestId, le.UUID.getTag())), or[pe.signature] = this.signature, new c.DataItem(or);
        }, this.signature = nr, this.requestId = ir;
      }
    }
    $.fromDataItem = (Pe) => {
      const nr = Pe.getData(), ir = nr[pe.signature], or = nr[pe.requestId] ? nr[pe.requestId].getData() : void 0;
      return new $(ir, or);
    }, $.fromCBOR = (Pe) => {
      const nr = L(Pe);
      return $.fromDataItem(nr);
    };
    const {
      decodeToDataItem: Ee
    } = c.extend;
    var be;
    (function(Pe) {
      Pe[Pe.mintAddress = 1] = "mintAddress", Pe[Pe.collectionName = 2] = "collectionName", Pe[Pe.name = 3] = "name", Pe[Pe.mediaData = 4] = "mediaData";
    })(be || (be = {}));
    class He extends c.RegistryItem {
      constructor(nr) {
        super(), this.getRegistryType = () => p.SOL_NFT_ITEM, this.getName = () => this.name, this.getMediaData = () => this.mediaData, this.getMintAddress = () => this.mintAddress, this.getCollectionName = () => this.collectionName, this.toDataItem = () => {
          const ir = {};
          return ir[be.name] = this.name, ir[be.mintAddress] = this.mintAddress, ir[be.collectionName] = this.collectionName, ir[be.mediaData] = this.mediaData, new c.DataItem(ir);
        }, this.name = nr.name, this.mintAddress = nr.mintAddress, this.collectionName = nr.collectionName, this.mediaData = nr.mediaData;
      }
      static constructETHNFTItem(nr, ir, or, lr) {
        return new He({
          mintAddress: nr,
          collectionName: ir,
          mediaData: lr,
          name: or
        });
      }
    }
    He.fromDataItem = (Pe) => {
      const nr = Pe.getData(), ir = nr[be.name], or = nr[be.mediaData], lr = nr[be.mintAddress], Ir = nr[be.collectionName];
      return new He({
        name: ir,
        mintAddress: lr,
        collectionName: Ir,
        mediaData: or
      });
    }, He.fromCBOR = (Pe) => {
      const nr = Ee(Pe);
      return He.fromDataItem(nr);
    }, c.patchTags(Object.values(p).filter((Pe) => !!Pe.getTag()).map((Pe) => Pe.getTag())), Object.keys(c).forEach(function(Pe) {
      Pe !== "default" && Object.defineProperty(n, Pe, {
        enumerable: !0,
        get: function() {
          return c[Pe];
        }
      });
    }), n.SOLNFTItem = He, n.SolSignRequest = F, n.SolSignature = $;
  }(bcUrRegistrySol_cjs_development)), bcUrRegistrySol_cjs_development;
}
process$1.env.NODE_ENV === "production" ? dist$k.exports = requireBcUrRegistrySol_cjs_production_min() : dist$k.exports = requireBcUrRegistrySol_cjs_development();
var distExports$8 = dist$k.exports;
Object.defineProperty(solana, "__esModule", { value: !0 });
solana.KeystoneSolanaSDK = void 0;
const bc_ur_registry_sol_1 = distExports$8, utils_1$j = utils$K, ur_1$8 = ur;
class KeystoneSolanaSDK {
  parseSignature(c) {
    if (c.type !== ur_1$8.URType.SolSignature)
      throw new Error("type not match");
    const u = bc_ur_registry_sol_1.SolSignature.fromCBOR(c.cbor), p = u.getRequestId();
    return {
      requestId: p === void 0 ? void 0 : (0, utils_1$j.uuidStringify)(p),
      signature: (0, utils_1$j.toHex)(u.getSignature())
    };
  }
  generateSignRequest({ requestId: c, signData: u, dataType: p, path: a, xfp: A, address: b, origin: F }) {
    return new bc_ur_registry_sol_1.SolSignRequest({
      requestId: (0, utils_1$j.uuidParse)(c),
      signData: (0, utils_1$j.toBuffer)(u),
      signType: p,
      derivationPath: new bc_ur_registry_sol_1.CryptoKeypath((0, utils_1$j.parsePath)(a).map((le) => new bc_ur_registry_sol_1.PathComponent(le)), (0, utils_1$j.toBuffer)(A)),
      address: b !== void 0 ? (0, utils_1$j.toBuffer)(b) : void 0,
      origin: F
    }).toUR();
  }
}
KeystoneSolanaSDK.DataType = bc_ur_registry_sol_1.SignType;
solana.KeystoneSolanaSDK = KeystoneSolanaSDK;
var tron = {}, transfer = {}, contract_pb = {}, cjs$1 = {}, proto3 = {}, protoRuntime = {}, _enum = {}, assert$d = {};
Object.defineProperty(assert$d, "__esModule", { value: !0 });
assert$d.assertFloat32 = assert$d.assertUInt32 = assert$d.assertInt32 = assert$d.assert = void 0;
function assert$c(n, c) {
  if (!n)
    throw new Error(c);
}
assert$d.assert = assert$c;
const FLOAT32_MAX = 34028234663852886e22, FLOAT32_MIN = -34028234663852886e22, UINT32_MAX = 4294967295, INT32_MAX = 2147483647, INT32_MIN = -2147483648;
function assertInt32(n) {
  if (typeof n != "number")
    throw new Error("invalid int 32: " + typeof n);
  if (!Number.isInteger(n) || n > INT32_MAX || n < INT32_MIN)
    throw new Error("invalid int 32: " + n);
}
assert$d.assertInt32 = assertInt32;
function assertUInt32(n) {
  if (typeof n != "number")
    throw new Error("invalid uint 32: " + typeof n);
  if (!Number.isInteger(n) || n > UINT32_MAX || n < 0)
    throw new Error("invalid uint 32: " + n);
}
assert$d.assertUInt32 = assertUInt32;
function assertFloat32(n) {
  if (typeof n != "number")
    throw new Error("invalid float 32: " + typeof n);
  if (Number.isFinite(n) && (n > FLOAT32_MAX || n < FLOAT32_MIN))
    throw new Error("invalid float 32: " + n);
}
assert$d.assertFloat32 = assertFloat32;
Object.defineProperty(_enum, "__esModule", { value: !0 });
_enum.makeEnum = _enum.makeEnumType = _enum.setEnumType = _enum.getEnumType = void 0;
const assert_js_1$9 = assert$d, enumTypeSymbol = Symbol("@bufbuild/protobuf/enum-type");
function getEnumType(n) {
  const c = n[enumTypeSymbol];
  return (0, assert_js_1$9.assert)(c, "missing enum type on enum object"), c;
}
_enum.getEnumType = getEnumType;
function setEnumType(n, c, u, p) {
  n[enumTypeSymbol] = makeEnumType(c, u.map((a) => ({
    no: a.no,
    name: a.name,
    localName: n[a.no]
  })));
}
_enum.setEnumType = setEnumType;
function makeEnumType(n, c, u) {
  const p = /* @__PURE__ */ Object.create(null), a = /* @__PURE__ */ Object.create(null), A = [];
  for (const b of c) {
    const F = normalizeEnumValue(b);
    A.push(F), p[b.name] = F, a[b.no] = F;
  }
  return {
    typeName: n,
    values: A,
    // We do not surface options at this time
    // options: opt?.options ?? Object.create(null),
    findName(b) {
      return p[b];
    },
    findNumber(b) {
      return a[b];
    }
  };
}
_enum.makeEnumType = makeEnumType;
function makeEnum(n, c, u) {
  const p = {};
  for (const a of c) {
    const A = normalizeEnumValue(a);
    p[A.localName] = A.no, p[A.no] = A.localName;
  }
  return setEnumType(p, n, c), p;
}
_enum.makeEnum = makeEnum;
function normalizeEnumValue(n) {
  return "localName" in n ? n : Object.assign(Object.assign({}, n), { localName: n.name });
}
var messageType = {}, message = {};
Object.defineProperty(message, "__esModule", { value: !0 });
message.Message = void 0;
class Message {
  /**
   * Compare with a message of the same type.
   * Note that this function disregards extensions and unknown fields.
   */
  equals(c) {
    return this.getType().runtime.util.equals(this.getType(), this, c);
  }
  /**
   * Create a deep copy.
   */
  clone() {
    return this.getType().runtime.util.clone(this);
  }
  /**
   * Parse from binary data, merging fields.
   *
   * Repeated fields are appended. Map entries are added, overwriting
   * existing keys.
   *
   * If a message field is already present, it will be merged with the
   * new data.
   */
  fromBinary(c, u) {
    const p = this.getType(), a = p.runtime.bin, A = a.makeReadOptions(u);
    return a.readMessage(this, A.readerFactory(c), c.byteLength, A), this;
  }
  /**
   * Parse a message from a JSON value.
   */
  fromJson(c, u) {
    const p = this.getType(), a = p.runtime.json, A = a.makeReadOptions(u);
    return a.readMessage(p, c, A, this), this;
  }
  /**
   * Parse a message from a JSON string.
   */
  fromJsonString(c, u) {
    let p;
    try {
      p = JSON.parse(c);
    } catch (a) {
      throw new Error(`cannot decode ${this.getType().typeName} from JSON: ${a instanceof Error ? a.message : String(a)}`);
    }
    return this.fromJson(p, u);
  }
  /**
   * Serialize the message to binary data.
   */
  toBinary(c) {
    const u = this.getType(), p = u.runtime.bin, a = p.makeWriteOptions(c), A = a.writerFactory();
    return p.writeMessage(this, A, a), A.finish();
  }
  /**
   * Serialize the message to a JSON value, a JavaScript value that can be
   * passed to JSON.stringify().
   */
  toJson(c) {
    const u = this.getType(), p = u.runtime.json, a = p.makeWriteOptions(c);
    return p.writeMessage(this, a);
  }
  /**
   * Serialize the message to a JSON string.
   */
  toJsonString(c) {
    var u;
    const p = this.toJson(c);
    return JSON.stringify(p, null, (u = c == null ? void 0 : c.prettySpaces) !== null && u !== void 0 ? u : 0);
  }
  /**
   * Override for serialization behavior. This will be invoked when calling
   * JSON.stringify on this message (i.e. JSON.stringify(msg)).
   *
   * Note that this will not serialize google.protobuf.Any with a packed
   * message because the protobuf JSON format specifies that it needs to be
   * unpacked, and this is only possible with a type registry to look up the
   * message type.  As a result, attempting to serialize a message with this
   * type will throw an Error.
   *
   * This method is protected because you should not need to invoke it
   * directly -- instead use JSON.stringify or toJsonString for
   * stringified JSON.  Alternatively, if actual JSON is desired, you should
   * use toJson.
   */
  toJSON() {
    return this.toJson({
      emitDefaultValues: !0
    });
  }
  /**
   * Retrieve the MessageType of this message - a singleton that represents
   * the protobuf message declaration and provides metadata for reflection-
   * based operations.
   */
  getType() {
    return Object.getPrototypeOf(this).constructor;
  }
}
message.Message = Message;
Object.defineProperty(messageType, "__esModule", { value: !0 });
messageType.makeMessageType = void 0;
const message_js_1$d = message;
function makeMessageType(n, c, u, p) {
  var a;
  const A = (a = p == null ? void 0 : p.localName) !== null && a !== void 0 ? a : c.substring(c.lastIndexOf(".") + 1), b = {
    [A]: function(F) {
      n.util.initFields(this), n.util.initPartial(F, this);
    }
  }[A];
  return Object.setPrototypeOf(b.prototype, new message_js_1$d.Message()), Object.assign(b, {
    runtime: n,
    typeName: c,
    fields: n.util.newFieldList(u),
    fromBinary(F, le) {
      return new b().fromBinary(F, le);
    },
    fromJson(F, le) {
      return new b().fromJson(F, le);
    },
    fromJsonString(F, le) {
      return new b().fromJsonString(F, le);
    },
    equals(F, le) {
      return n.util.equals(b, F, le);
    }
  }), b;
}
messageType.makeMessageType = makeMessageType;
var extensions = {}, scalars = {}, protoInt64 = {}, varint$2 = {};
Object.defineProperty(varint$2, "__esModule", { value: !0 });
varint$2.varint32read = varint$2.varint32write = varint$2.uInt64ToString = varint$2.int64ToString = varint$2.int64FromString = varint$2.varint64write = varint$2.varint64read = void 0;
function varint64read() {
  let n = 0, c = 0;
  for (let p = 0; p < 28; p += 7) {
    let a = this.buf[this.pos++];
    if (n |= (a & 127) << p, !(a & 128))
      return this.assertBounds(), [n, c];
  }
  let u = this.buf[this.pos++];
  if (n |= (u & 15) << 28, c = (u & 112) >> 4, !(u & 128))
    return this.assertBounds(), [n, c];
  for (let p = 3; p <= 31; p += 7) {
    let a = this.buf[this.pos++];
    if (c |= (a & 127) << p, !(a & 128))
      return this.assertBounds(), [n, c];
  }
  throw new Error("invalid varint");
}
varint$2.varint64read = varint64read;
function varint64write(n, c, u) {
  for (let A = 0; A < 28; A = A + 7) {
    const b = n >>> A, F = !(!(b >>> 7) && c == 0), le = (F ? b | 128 : b) & 255;
    if (u.push(le), !F)
      return;
  }
  const p = n >>> 28 & 15 | (c & 7) << 4, a = !!(c >> 3);
  if (u.push((a ? p | 128 : p) & 255), !!a) {
    for (let A = 3; A < 31; A = A + 7) {
      const b = c >>> A, F = !!(b >>> 7), le = (F ? b | 128 : b) & 255;
      if (u.push(le), !F)
        return;
    }
    u.push(c >>> 31 & 1);
  }
}
varint$2.varint64write = varint64write;
const TWO_PWR_32_DBL$2 = 4294967296;
function int64FromString(n) {
  const c = n[0] === "-";
  c && (n = n.slice(1));
  const u = 1e6;
  let p = 0, a = 0;
  function A(b, F) {
    const le = Number(n.slice(b, F));
    a *= u, p = p * u + le, p >= TWO_PWR_32_DBL$2 && (a = a + (p / TWO_PWR_32_DBL$2 | 0), p = p % TWO_PWR_32_DBL$2);
  }
  return A(-24, -18), A(-18, -12), A(-12, -6), A(-6), c ? negate(p, a) : newBits(p, a);
}
varint$2.int64FromString = int64FromString;
function int64ToString(n, c) {
  let u = newBits(n, c);
  const p = u.hi & 2147483648;
  p && (u = negate(u.lo, u.hi));
  const a = uInt64ToString(u.lo, u.hi);
  return p ? "-" + a : a;
}
varint$2.int64ToString = int64ToString;
function uInt64ToString(n, c) {
  if ({ lo: n, hi: c } = toUnsigned(n, c), c <= 2097151)
    return String(TWO_PWR_32_DBL$2 * c + n);
  const u = n & 16777215, p = (n >>> 24 | c << 8) & 16777215, a = c >> 16 & 65535;
  let A = u + p * 6777216 + a * 6710656, b = p + a * 8147497, F = a * 2;
  const le = 1e7;
  return A >= le && (b += Math.floor(A / le), A %= le), b >= le && (F += Math.floor(b / le), b %= le), F.toString() + decimalFrom1e7WithLeadingZeros(b) + decimalFrom1e7WithLeadingZeros(A);
}
varint$2.uInt64ToString = uInt64ToString;
function toUnsigned(n, c) {
  return { lo: n >>> 0, hi: c >>> 0 };
}
function newBits(n, c) {
  return { lo: n | 0, hi: c | 0 };
}
function negate(n, c) {
  return c = ~c, n ? n = ~n + 1 : c += 1, newBits(n, c);
}
const decimalFrom1e7WithLeadingZeros = (n) => {
  const c = String(n);
  return "0000000".slice(c.length) + c;
};
function varint32write(n, c) {
  if (n >= 0) {
    for (; n > 127; )
      c.push(n & 127 | 128), n = n >>> 7;
    c.push(n);
  } else {
    for (let u = 0; u < 9; u++)
      c.push(n & 127 | 128), n = n >> 7;
    c.push(1);
  }
}
varint$2.varint32write = varint32write;
function varint32read() {
  let n = this.buf[this.pos++], c = n & 127;
  if (!(n & 128))
    return this.assertBounds(), c;
  if (n = this.buf[this.pos++], c |= (n & 127) << 7, !(n & 128))
    return this.assertBounds(), c;
  if (n = this.buf[this.pos++], c |= (n & 127) << 14, !(n & 128))
    return this.assertBounds(), c;
  if (n = this.buf[this.pos++], c |= (n & 127) << 21, !(n & 128))
    return this.assertBounds(), c;
  n = this.buf[this.pos++], c |= (n & 15) << 28;
  for (let u = 5; n & 128 && u < 10; u++)
    n = this.buf[this.pos++];
  if (n & 128)
    throw new Error("invalid varint");
  return this.assertBounds(), c >>> 0;
}
varint$2.varint32read = varint32read;
Object.defineProperty(protoInt64, "__esModule", { value: !0 });
protoInt64.protoInt64 = void 0;
const assert_js_1$8 = assert$d, varint_js_1$1 = varint$2;
function makeInt64Support() {
  const n = new DataView(new ArrayBuffer(8));
  if (typeof BigInt == "function" && typeof n.getBigInt64 == "function" && typeof n.getBigUint64 == "function" && typeof n.setBigInt64 == "function" && typeof n.setBigUint64 == "function" && (typeof process$1 != "object" || typeof process$1.env != "object" || process$1.env.BUF_BIGINT_DISABLE !== "1")) {
    const a = BigInt("-9223372036854775808"), A = BigInt("9223372036854775807"), b = BigInt("0"), F = BigInt("18446744073709551615");
    return {
      zero: BigInt(0),
      supported: !0,
      parse(le) {
        const L = typeof le == "bigint" ? le : BigInt(le);
        if (L > A || L < a)
          throw new Error(`int64 invalid: ${le}`);
        return L;
      },
      uParse(le) {
        const L = typeof le == "bigint" ? le : BigInt(le);
        if (L > F || L < b)
          throw new Error(`uint64 invalid: ${le}`);
        return L;
      },
      enc(le) {
        return n.setBigInt64(0, this.parse(le), !0), {
          lo: n.getInt32(0, !0),
          hi: n.getInt32(4, !0)
        };
      },
      uEnc(le) {
        return n.setBigInt64(0, this.uParse(le), !0), {
          lo: n.getInt32(0, !0),
          hi: n.getInt32(4, !0)
        };
      },
      dec(le, L) {
        return n.setInt32(0, le, !0), n.setInt32(4, L, !0), n.getBigInt64(0, !0);
      },
      uDec(le, L) {
        return n.setInt32(0, le, !0), n.setInt32(4, L, !0), n.getBigUint64(0, !0);
      }
    };
  }
  const u = (a) => (0, assert_js_1$8.assert)(/^-?[0-9]+$/.test(a), `int64 invalid: ${a}`), p = (a) => (0, assert_js_1$8.assert)(/^[0-9]+$/.test(a), `uint64 invalid: ${a}`);
  return {
    zero: "0",
    supported: !1,
    parse(a) {
      return typeof a != "string" && (a = a.toString()), u(a), a;
    },
    uParse(a) {
      return typeof a != "string" && (a = a.toString()), p(a), a;
    },
    enc(a) {
      return typeof a != "string" && (a = a.toString()), u(a), (0, varint_js_1$1.int64FromString)(a);
    },
    uEnc(a) {
      return typeof a != "string" && (a = a.toString()), p(a), (0, varint_js_1$1.int64FromString)(a);
    },
    dec(a, A) {
      return (0, varint_js_1$1.int64ToString)(a, A);
    },
    uDec(a, A) {
      return (0, varint_js_1$1.uInt64ToString)(a, A);
    }
  };
}
protoInt64.protoInt64 = makeInt64Support();
var scalar = {};
Object.defineProperty(scalar, "__esModule", { value: !0 });
scalar.LongType = scalar.ScalarType = void 0;
var ScalarType;
(function(n) {
  n[n.DOUBLE = 1] = "DOUBLE", n[n.FLOAT = 2] = "FLOAT", n[n.INT64 = 3] = "INT64", n[n.UINT64 = 4] = "UINT64", n[n.INT32 = 5] = "INT32", n[n.FIXED64 = 6] = "FIXED64", n[n.FIXED32 = 7] = "FIXED32", n[n.BOOL = 8] = "BOOL", n[n.STRING = 9] = "STRING", n[n.BYTES = 12] = "BYTES", n[n.UINT32 = 13] = "UINT32", n[n.SFIXED32 = 15] = "SFIXED32", n[n.SFIXED64 = 16] = "SFIXED64", n[n.SINT32 = 17] = "SINT32", n[n.SINT64 = 18] = "SINT64";
})(ScalarType || (scalar.ScalarType = ScalarType = {}));
var LongType;
(function(n) {
  n[n.BIGINT = 0] = "BIGINT", n[n.STRING = 1] = "STRING";
})(LongType || (scalar.LongType = LongType = {}));
Object.defineProperty(scalars, "__esModule", { value: !0 });
scalars.isScalarZeroValue = scalars.scalarZeroValue = scalars.scalarEquals = void 0;
const proto_int64_js_1$6 = protoInt64, scalar_js_1$9 = scalar;
function scalarEquals(n, c, u) {
  if (c === u)
    return !0;
  if (n == scalar_js_1$9.ScalarType.BYTES) {
    if (!(c instanceof Uint8Array) || !(u instanceof Uint8Array) || c.length !== u.length)
      return !1;
    for (let p = 0; p < c.length; p++)
      if (c[p] !== u[p])
        return !1;
    return !0;
  }
  switch (n) {
    case scalar_js_1$9.ScalarType.UINT64:
    case scalar_js_1$9.ScalarType.FIXED64:
    case scalar_js_1$9.ScalarType.INT64:
    case scalar_js_1$9.ScalarType.SFIXED64:
    case scalar_js_1$9.ScalarType.SINT64:
      return c == u;
  }
  return !1;
}
scalars.scalarEquals = scalarEquals;
function scalarZeroValue(n, c) {
  switch (n) {
    case scalar_js_1$9.ScalarType.BOOL:
      return !1;
    case scalar_js_1$9.ScalarType.UINT64:
    case scalar_js_1$9.ScalarType.FIXED64:
    case scalar_js_1$9.ScalarType.INT64:
    case scalar_js_1$9.ScalarType.SFIXED64:
    case scalar_js_1$9.ScalarType.SINT64:
      return c == 0 ? proto_int64_js_1$6.protoInt64.zero : "0";
    case scalar_js_1$9.ScalarType.DOUBLE:
    case scalar_js_1$9.ScalarType.FLOAT:
      return 0;
    case scalar_js_1$9.ScalarType.BYTES:
      return new Uint8Array(0);
    case scalar_js_1$9.ScalarType.STRING:
      return "";
    default:
      return 0;
  }
}
scalars.scalarZeroValue = scalarZeroValue;
function isScalarZeroValue(n, c) {
  switch (n) {
    case scalar_js_1$9.ScalarType.BOOL:
      return c === !1;
    case scalar_js_1$9.ScalarType.STRING:
      return c === "";
    case scalar_js_1$9.ScalarType.BYTES:
      return c instanceof Uint8Array && !c.byteLength;
    default:
      return c == 0;
  }
}
scalars.isScalarZeroValue = isScalarZeroValue;
Object.defineProperty(extensions, "__esModule", { value: !0 });
extensions.filterUnknownFields = extensions.createExtensionContainer = extensions.makeExtension = void 0;
const scalars_js_1$6 = scalars;
function makeExtension(n, c, u, p) {
  let a;
  return {
    typeName: c,
    extendee: u,
    get field() {
      if (!a) {
        const A = typeof p == "function" ? p() : p;
        A.name = c.split(".").pop(), A.jsonName = `[${c}]`, a = n.util.newFieldList([A]).list()[0];
      }
      return a;
    },
    runtime: n
  };
}
extensions.makeExtension = makeExtension;
function createExtensionContainer(n) {
  const c = n.field.localName, u = /* @__PURE__ */ Object.create(null);
  return u[c] = initExtensionField(n), [u, () => u[c]];
}
extensions.createExtensionContainer = createExtensionContainer;
function initExtensionField(n) {
  const c = n.field;
  if (c.repeated)
    return [];
  if (c.default !== void 0)
    return c.default;
  switch (c.kind) {
    case "enum":
      return c.T.values[0].no;
    case "scalar":
      return (0, scalars_js_1$6.scalarZeroValue)(c.T, c.L);
    case "message":
      const u = c.T, p = new u();
      return u.fieldWrapper ? u.fieldWrapper.unwrapField(p) : p;
    case "map":
      throw "map fields are not allowed to be extensions";
  }
}
function filterUnknownFields(n, c) {
  if (!c.repeated && (c.kind == "enum" || c.kind == "scalar")) {
    for (let u = n.length - 1; u >= 0; --u)
      if (n[u].no == c.no)
        return [n[u]];
    return [];
  }
  return n.filter((u) => u.no === c.no);
}
extensions.filterUnknownFields = filterUnknownFields;
var jsonFormat = {}, protoBase64 = {};
Object.defineProperty(protoBase64, "__esModule", { value: !0 });
protoBase64.protoBase64 = void 0;
let encTable = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".split(""), decTable = [];
for (let n = 0; n < encTable.length; n++)
  decTable[encTable[n].charCodeAt(0)] = n;
decTable[45] = encTable.indexOf("+");
decTable[95] = encTable.indexOf("/");
protoBase64.protoBase64 = {
  /**
   * Decodes a base64 string to a byte array.
   *
   * - ignores white-space, including line breaks and tabs
   * - allows inner padding (can decode concatenated base64 strings)
   * - does not require padding
   * - understands base64url encoding:
   *   "-" instead of "+",
   *   "_" instead of "/",
   *   no padding
   */
  dec(n) {
    let c = n.length * 3 / 4;
    n[n.length - 2] == "=" ? c -= 2 : n[n.length - 1] == "=" && (c -= 1);
    let u = new Uint8Array(c), p = 0, a = 0, A, b = 0;
    for (let F = 0; F < n.length; F++) {
      if (A = decTable[n.charCodeAt(F)], A === void 0)
        switch (n[F]) {
          case "=":
            a = 0;
          case `
`:
          case "\r":
          case "	":
          case " ":
            continue;
          default:
            throw Error("invalid base64 string.");
        }
      switch (a) {
        case 0:
          b = A, a = 1;
          break;
        case 1:
          u[p++] = b << 2 | (A & 48) >> 4, b = A, a = 2;
          break;
        case 2:
          u[p++] = (b & 15) << 4 | (A & 60) >> 2, b = A, a = 3;
          break;
        case 3:
          u[p++] = (b & 3) << 6 | A, a = 0;
          break;
      }
    }
    if (a == 1)
      throw Error("invalid base64 string.");
    return u.subarray(0, p);
  },
  /**
   * Encode a byte array to a base64 string.
   */
  enc(n) {
    let c = "", u = 0, p, a = 0;
    for (let A = 0; A < n.length; A++)
      switch (p = n[A], u) {
        case 0:
          c += encTable[p >> 2], a = (p & 3) << 4, u = 1;
          break;
        case 1:
          c += encTable[a | p >> 4], a = (p & 15) << 2, u = 2;
          break;
        case 2:
          c += encTable[a | p >> 6], c += encTable[p & 63], u = 0;
          break;
      }
    return u && (c += encTable[a], c += "=", u == 1 && (c += "=")), c;
  }
};
var extensionAccessor = {};
Object.defineProperty(extensionAccessor, "__esModule", { value: !0 });
extensionAccessor.hasExtension = extensionAccessor.clearExtension = extensionAccessor.setExtension = extensionAccessor.getExtension = void 0;
const assert_js_1$7 = assert$d, extensions_js_1$2 = extensions;
function getExtension(n, c, u) {
  assertExtendee(c, n);
  const p = c.runtime.bin.makeReadOptions(u), a = (0, extensions_js_1$2.filterUnknownFields)(n.getType().runtime.bin.listUnknownFields(n), c.field), [A, b] = (0, extensions_js_1$2.createExtensionContainer)(c);
  for (const F of a)
    c.runtime.bin.readField(A, p.readerFactory(F.data), c.field, F.wireType, p);
  return b();
}
extensionAccessor.getExtension = getExtension;
function setExtension(n, c, u, p) {
  assertExtendee(c, n);
  const a = c.runtime.bin.makeReadOptions(p), A = c.runtime.bin.makeWriteOptions(p);
  if (hasExtension(n, c)) {
    const L = n.getType().runtime.bin.listUnknownFields(n).filter((pe) => pe.no != c.field.no);
    n.getType().runtime.bin.discardUnknownFields(n);
    for (const pe of L)
      n.getType().runtime.bin.onUnknownField(n, pe.no, pe.wireType, pe.data);
  }
  const b = A.writerFactory();
  let F = c.field;
  !F.opt && !F.repeated && (F.kind == "enum" || F.kind == "scalar") && (F = Object.assign(Object.assign({}, c.field), { opt: !0 })), c.runtime.bin.writeField(F, u, b, A);
  const le = a.readerFactory(b.finish());
  for (; le.pos < le.len; ) {
    const [L, pe] = le.tag(), $ = le.skip(pe, L);
    n.getType().runtime.bin.onUnknownField(n, L, pe, $);
  }
}
extensionAccessor.setExtension = setExtension;
function clearExtension(n, c) {
  if (assertExtendee(c, n), hasExtension(n, c)) {
    const u = n.getType().runtime.bin, p = u.listUnknownFields(n).filter((a) => a.no != c.field.no);
    u.discardUnknownFields(n);
    for (const a of p)
      u.onUnknownField(n, a.no, a.wireType, a.data);
  }
}
extensionAccessor.clearExtension = clearExtension;
function hasExtension(n, c) {
  const u = n.getType();
  return c.extendee.typeName === u.typeName && !!u.runtime.bin.listUnknownFields(n).find((p) => p.no == c.field.no);
}
extensionAccessor.hasExtension = hasExtension;
function assertExtendee(n, c) {
  (0, assert_js_1$7.assert)(n.extendee.typeName == c.getType().typeName, `extension ${n.typeName} can only be applied to message ${n.extendee.typeName}`);
}
var reflect = {};
Object.defineProperty(reflect, "__esModule", { value: !0 });
reflect.clearField = reflect.isFieldSet = void 0;
const scalars_js_1$5 = scalars;
function isFieldSet(n, c) {
  const u = n.localName;
  if (n.repeated)
    return c[u].length > 0;
  if (n.oneof)
    return c[n.oneof.localName].case === u;
  switch (n.kind) {
    case "enum":
    case "scalar":
      return n.opt || n.req ? c[u] !== void 0 : n.kind == "enum" ? c[u] !== n.T.values[0].no : !(0, scalars_js_1$5.isScalarZeroValue)(n.T, c[u]);
    case "message":
      return c[u] !== void 0;
    case "map":
      return Object.keys(c[u]).length > 0;
  }
}
reflect.isFieldSet = isFieldSet;
function clearField(n, c) {
  const u = n.localName, p = !n.opt && !n.req;
  if (n.repeated)
    c[u] = [];
  else if (n.oneof)
    c[n.oneof.localName] = { case: void 0 };
  else
    switch (n.kind) {
      case "map":
        c[u] = {};
        break;
      case "enum":
        c[u] = p ? n.T.values[0].no : void 0;
        break;
      case "scalar":
        c[u] = p ? (0, scalars_js_1$5.scalarZeroValue)(n.T, n.L) : void 0;
        break;
      case "message":
        c[u] = void 0;
        break;
    }
}
reflect.clearField = clearField;
var fieldWrapper = {}, isMessage$1 = {};
Object.defineProperty(isMessage$1, "__esModule", { value: !0 });
isMessage$1.isMessage = void 0;
const message_js_1$c = message;
function isMessage(n, c) {
  if (n === null || typeof n != "object" || !Object.getOwnPropertyNames(message_js_1$c.Message.prototype).every((p) => p in n && typeof n[p] == "function"))
    return !1;
  const u = n.getType();
  return u === null || typeof u != "function" || !("typeName" in u) || typeof u.typeName != "string" ? !1 : c === void 0 ? !0 : u.typeName == c.typeName;
}
isMessage$1.isMessage = isMessage;
Object.defineProperty(fieldWrapper, "__esModule", { value: !0 });
fieldWrapper.getUnwrappedFieldType = fieldWrapper.wrapField = void 0;
const scalar_js_1$8 = scalar, is_message_js_1$6 = isMessage$1;
function wrapField(n, c) {
  return (0, is_message_js_1$6.isMessage)(c) || !n.fieldWrapper ? c : n.fieldWrapper.wrapField(c);
}
fieldWrapper.wrapField = wrapField;
function getUnwrappedFieldType(n) {
  if (n.fieldKind === "message" && !n.repeated && n.oneof == null)
    return wktWrapperToScalarType[n.message.typeName];
}
fieldWrapper.getUnwrappedFieldType = getUnwrappedFieldType;
const wktWrapperToScalarType = {
  "google.protobuf.DoubleValue": scalar_js_1$8.ScalarType.DOUBLE,
  "google.protobuf.FloatValue": scalar_js_1$8.ScalarType.FLOAT,
  "google.protobuf.Int64Value": scalar_js_1$8.ScalarType.INT64,
  "google.protobuf.UInt64Value": scalar_js_1$8.ScalarType.UINT64,
  "google.protobuf.Int32Value": scalar_js_1$8.ScalarType.INT32,
  "google.protobuf.UInt32Value": scalar_js_1$8.ScalarType.UINT32,
  "google.protobuf.BoolValue": scalar_js_1$8.ScalarType.BOOL,
  "google.protobuf.StringValue": scalar_js_1$8.ScalarType.STRING,
  "google.protobuf.BytesValue": scalar_js_1$8.ScalarType.BYTES
};
Object.defineProperty(jsonFormat, "__esModule", { value: !0 });
jsonFormat.makeJsonFormat = void 0;
const assert_js_1$6 = assert$d, proto_int64_js_1$5 = protoInt64, proto_base64_js_1$1 = protoBase64, extensions_js_1$1 = extensions, extension_accessor_js_1 = extensionAccessor, reflect_js_1$1 = reflect, field_wrapper_js_1$2 = fieldWrapper, scalars_js_1$4 = scalars, scalars_js_2 = scalars, scalar_js_1$7 = scalar, is_message_js_1$5 = isMessage$1, jsonReadDefaults = {
  ignoreUnknownFields: !1
}, jsonWriteDefaults = {
  emitDefaultValues: !1,
  enumAsInteger: !1,
  useProtoFieldName: !1,
  prettySpaces: 0
};
function makeReadOptions$1(n) {
  return n ? Object.assign(Object.assign({}, jsonReadDefaults), n) : jsonReadDefaults;
}
function makeWriteOptions$1(n) {
  return n ? Object.assign(Object.assign({}, jsonWriteDefaults), n) : jsonWriteDefaults;
}
const tokenNull = Symbol(), tokenIgnoredUnknownEnum = Symbol();
function makeJsonFormat() {
  return {
    makeReadOptions: makeReadOptions$1,
    makeWriteOptions: makeWriteOptions$1,
    readMessage(n, c, u, p) {
      if (c == null || Array.isArray(c) || typeof c != "object")
        throw new Error(`cannot decode message ${n.typeName} from JSON: ${debugJsonValue(c)}`);
      p = p ?? new n();
      const a = /* @__PURE__ */ new Map(), A = u.typeRegistry;
      for (const [b, F] of Object.entries(c)) {
        const le = n.fields.findJsonName(b);
        if (le) {
          if (le.oneof) {
            if (F === null && le.kind == "scalar")
              continue;
            const L = a.get(le.oneof);
            if (L !== void 0)
              throw new Error(`cannot decode message ${n.typeName} from JSON: multiple keys for oneof "${le.oneof.name}" present: "${L}", "${b}"`);
            a.set(le.oneof, b);
          }
          readField$1(p, F, le, u, n);
        } else {
          let L = !1;
          if (A != null && A.findExtension && b.startsWith("[") && b.endsWith("]")) {
            const pe = A.findExtension(b.substring(1, b.length - 1));
            if (pe && pe.extendee.typeName == n.typeName) {
              L = !0;
              const [$, Ee] = (0, extensions_js_1$1.createExtensionContainer)(pe);
              readField$1($, F, pe.field, u, pe), (0, extension_accessor_js_1.setExtension)(p, pe, Ee(), u);
            }
          }
          if (!L && !u.ignoreUnknownFields)
            throw new Error(`cannot decode message ${n.typeName} from JSON: key "${b}" is unknown`);
        }
      }
      return p;
    },
    writeMessage(n, c) {
      const u = n.getType(), p = {};
      let a;
      try {
        for (a of u.fields.byNumber()) {
          if (!(0, reflect_js_1$1.isFieldSet)(a, n)) {
            if (a.req)
              throw "required field not set";
            if (!c.emitDefaultValues || !canEmitFieldDefaultValue(a))
              continue;
          }
          const b = a.oneof ? n[a.oneof.localName].value : n[a.localName], F = writeField$1(a, b, c);
          F !== void 0 && (p[c.useProtoFieldName ? a.name : a.jsonName] = F);
        }
        const A = c.typeRegistry;
        if (A != null && A.findExtensionFor)
          for (const b of u.runtime.bin.listUnknownFields(n)) {
            const F = A.findExtensionFor(u.typeName, b.no);
            if (F && (0, extension_accessor_js_1.hasExtension)(n, F)) {
              const le = (0, extension_accessor_js_1.getExtension)(n, F, c), L = writeField$1(F.field, le, c);
              L !== void 0 && (p[F.field.jsonName] = L);
            }
          }
      } catch (A) {
        const b = a ? `cannot encode field ${u.typeName}.${a.name} to JSON` : `cannot encode message ${u.typeName} to JSON`, F = A instanceof Error ? A.message : String(A);
        throw new Error(b + (F.length > 0 ? `: ${F}` : ""));
      }
      return p;
    },
    readScalar(n, c, u) {
      return readScalar$1(n, c, u ?? scalar_js_1$7.LongType.BIGINT, !0);
    },
    writeScalar(n, c, u) {
      if (c !== void 0 && (u || (0, scalars_js_2.isScalarZeroValue)(n, c)))
        return writeScalar$1(n, c);
    },
    debug: debugJsonValue
  };
}
jsonFormat.makeJsonFormat = makeJsonFormat;
function debugJsonValue(n) {
  if (n === null)
    return "null";
  switch (typeof n) {
    case "object":
      return Array.isArray(n) ? "array" : "object";
    case "string":
      return n.length > 100 ? "string" : `"${n.split('"').join('\\"')}"`;
    default:
      return String(n);
  }
}
function readField$1(n, c, u, p, a) {
  let A = u.localName;
  if (u.repeated) {
    if ((0, assert_js_1$6.assert)(u.kind != "map"), c === null)
      return;
    if (!Array.isArray(c))
      throw new Error(`cannot decode field ${a.typeName}.${u.name} from JSON: ${debugJsonValue(c)}`);
    const b = n[A];
    for (const F of c) {
      if (F === null)
        throw new Error(`cannot decode field ${a.typeName}.${u.name} from JSON: ${debugJsonValue(F)}`);
      switch (u.kind) {
        case "message":
          b.push(u.T.fromJson(F, p));
          break;
        case "enum":
          const le = readEnum(u.T, F, p.ignoreUnknownFields, !0);
          le !== tokenIgnoredUnknownEnum && b.push(le);
          break;
        case "scalar":
          try {
            b.push(readScalar$1(u.T, F, u.L, !0));
          } catch (L) {
            let pe = `cannot decode field ${a.typeName}.${u.name} from JSON: ${debugJsonValue(F)}`;
            throw L instanceof Error && L.message.length > 0 && (pe += `: ${L.message}`), new Error(pe);
          }
          break;
      }
    }
  } else if (u.kind == "map") {
    if (c === null)
      return;
    if (typeof c != "object" || Array.isArray(c))
      throw new Error(`cannot decode field ${a.typeName}.${u.name} from JSON: ${debugJsonValue(c)}`);
    const b = n[A];
    for (const [F, le] of Object.entries(c)) {
      if (le === null)
        throw new Error(`cannot decode field ${a.typeName}.${u.name} from JSON: map value null`);
      let L;
      try {
        L = readMapKey(u.K, F);
      } catch (pe) {
        let $ = `cannot decode map key for field ${a.typeName}.${u.name} from JSON: ${debugJsonValue(c)}`;
        throw pe instanceof Error && pe.message.length > 0 && ($ += `: ${pe.message}`), new Error($);
      }
      switch (u.V.kind) {
        case "message":
          b[L] = u.V.T.fromJson(le, p);
          break;
        case "enum":
          const pe = readEnum(u.V.T, le, p.ignoreUnknownFields, !0);
          pe !== tokenIgnoredUnknownEnum && (b[L] = pe);
          break;
        case "scalar":
          try {
            b[L] = readScalar$1(u.V.T, le, scalar_js_1$7.LongType.BIGINT, !0);
          } catch ($) {
            let Ee = `cannot decode map value for field ${a.typeName}.${u.name} from JSON: ${debugJsonValue(c)}`;
            throw $ instanceof Error && $.message.length > 0 && (Ee += `: ${$.message}`), new Error(Ee);
          }
          break;
      }
    }
  } else
    switch (u.oneof && (n = n[u.oneof.localName] = { case: A }, A = "value"), u.kind) {
      case "message":
        const b = u.T;
        if (c === null && b.typeName != "google.protobuf.Value")
          return;
        let F = n[A];
        (0, is_message_js_1$5.isMessage)(F) ? F.fromJson(c, p) : (n[A] = F = b.fromJson(c, p), b.fieldWrapper && !u.oneof && (n[A] = b.fieldWrapper.unwrapField(F)));
        break;
      case "enum":
        const le = readEnum(u.T, c, p.ignoreUnknownFields, !1);
        switch (le) {
          case tokenNull:
            (0, reflect_js_1$1.clearField)(u, n);
            break;
          case tokenIgnoredUnknownEnum:
            break;
          default:
            n[A] = le;
            break;
        }
        break;
      case "scalar":
        try {
          const L = readScalar$1(u.T, c, u.L, !1);
          switch (L) {
            case tokenNull:
              (0, reflect_js_1$1.clearField)(u, n);
              break;
            default:
              n[A] = L;
              break;
          }
        } catch (L) {
          let pe = `cannot decode field ${a.typeName}.${u.name} from JSON: ${debugJsonValue(c)}`;
          throw L instanceof Error && L.message.length > 0 && (pe += `: ${L.message}`), new Error(pe);
        }
        break;
    }
}
function readMapKey(n, c) {
  if (n === scalar_js_1$7.ScalarType.BOOL)
    switch (c) {
      case "true":
        c = !0;
        break;
      case "false":
        c = !1;
        break;
    }
  return readScalar$1(n, c, scalar_js_1$7.LongType.BIGINT, !0).toString();
}
function readScalar$1(n, c, u, p) {
  if (c === null)
    return p ? (0, scalars_js_1$4.scalarZeroValue)(n, u) : tokenNull;
  switch (n) {
    case scalar_js_1$7.ScalarType.DOUBLE:
    case scalar_js_1$7.ScalarType.FLOAT:
      if (c === "NaN")
        return Number.NaN;
      if (c === "Infinity")
        return Number.POSITIVE_INFINITY;
      if (c === "-Infinity")
        return Number.NEGATIVE_INFINITY;
      if (c === "" || typeof c == "string" && c.trim().length !== c.length || typeof c != "string" && typeof c != "number")
        break;
      const a = Number(c);
      if (Number.isNaN(a) || !Number.isFinite(a))
        break;
      return n == scalar_js_1$7.ScalarType.FLOAT && (0, assert_js_1$6.assertFloat32)(a), a;
    case scalar_js_1$7.ScalarType.INT32:
    case scalar_js_1$7.ScalarType.FIXED32:
    case scalar_js_1$7.ScalarType.SFIXED32:
    case scalar_js_1$7.ScalarType.SINT32:
    case scalar_js_1$7.ScalarType.UINT32:
      let A;
      if (typeof c == "number" ? A = c : typeof c == "string" && c.length > 0 && c.trim().length === c.length && (A = Number(c)), A === void 0)
        break;
      return n == scalar_js_1$7.ScalarType.UINT32 || n == scalar_js_1$7.ScalarType.FIXED32 ? (0, assert_js_1$6.assertUInt32)(A) : (0, assert_js_1$6.assertInt32)(A), A;
    case scalar_js_1$7.ScalarType.INT64:
    case scalar_js_1$7.ScalarType.SFIXED64:
    case scalar_js_1$7.ScalarType.SINT64:
      if (typeof c != "number" && typeof c != "string")
        break;
      const b = proto_int64_js_1$5.protoInt64.parse(c);
      return u ? b.toString() : b;
    case scalar_js_1$7.ScalarType.FIXED64:
    case scalar_js_1$7.ScalarType.UINT64:
      if (typeof c != "number" && typeof c != "string")
        break;
      const F = proto_int64_js_1$5.protoInt64.uParse(c);
      return u ? F.toString() : F;
    case scalar_js_1$7.ScalarType.BOOL:
      if (typeof c != "boolean")
        break;
      return c;
    case scalar_js_1$7.ScalarType.STRING:
      if (typeof c != "string")
        break;
      try {
        encodeURIComponent(c);
      } catch {
        throw new Error("invalid UTF8");
      }
      return c;
    case scalar_js_1$7.ScalarType.BYTES:
      if (c === "")
        return new Uint8Array(0);
      if (typeof c != "string")
        break;
      return proto_base64_js_1$1.protoBase64.dec(c);
  }
  throw new Error();
}
function readEnum(n, c, u, p) {
  if (c === null)
    return n.typeName == "google.protobuf.NullValue" ? 0 : p ? n.values[0].no : tokenNull;
  switch (typeof c) {
    case "number":
      if (Number.isInteger(c))
        return c;
      break;
    case "string":
      const a = n.findName(c);
      if (a !== void 0)
        return a.no;
      if (u)
        return tokenIgnoredUnknownEnum;
      break;
  }
  throw new Error(`cannot decode enum ${n.typeName} from JSON: ${debugJsonValue(c)}`);
}
function canEmitFieldDefaultValue(n) {
  return n.repeated || n.kind == "map" ? !0 : !(n.oneof || n.kind == "message" || n.opt || n.req);
}
function writeField$1(n, c, u) {
  if (n.kind == "map") {
    (0, assert_js_1$6.assert)(typeof c == "object" && c != null);
    const p = {}, a = Object.entries(c);
    switch (n.V.kind) {
      case "scalar":
        for (const [b, F] of a)
          p[b.toString()] = writeScalar$1(n.V.T, F);
        break;
      case "message":
        for (const [b, F] of a)
          p[b.toString()] = F.toJson(u);
        break;
      case "enum":
        const A = n.V.T;
        for (const [b, F] of a)
          p[b.toString()] = writeEnum(A, F, u.enumAsInteger);
        break;
    }
    return u.emitDefaultValues || a.length > 0 ? p : void 0;
  }
  if (n.repeated) {
    (0, assert_js_1$6.assert)(Array.isArray(c));
    const p = [];
    switch (n.kind) {
      case "scalar":
        for (let a = 0; a < c.length; a++)
          p.push(writeScalar$1(n.T, c[a]));
        break;
      case "enum":
        for (let a = 0; a < c.length; a++)
          p.push(writeEnum(n.T, c[a], u.enumAsInteger));
        break;
      case "message":
        for (let a = 0; a < c.length; a++)
          p.push(c[a].toJson(u));
        break;
    }
    return u.emitDefaultValues || p.length > 0 ? p : void 0;
  }
  switch (n.kind) {
    case "scalar":
      return writeScalar$1(n.T, c);
    case "enum":
      return writeEnum(n.T, c, u.enumAsInteger);
    case "message":
      return (0, field_wrapper_js_1$2.wrapField)(n.T, c).toJson(u);
  }
}
function writeEnum(n, c, u) {
  var p;
  if ((0, assert_js_1$6.assert)(typeof c == "number"), n.typeName == "google.protobuf.NullValue")
    return null;
  if (u)
    return c;
  const a = n.findNumber(c);
  return (p = a == null ? void 0 : a.name) !== null && p !== void 0 ? p : c;
}
function writeScalar$1(n, c) {
  switch (n) {
    case scalar_js_1$7.ScalarType.INT32:
    case scalar_js_1$7.ScalarType.SFIXED32:
    case scalar_js_1$7.ScalarType.SINT32:
    case scalar_js_1$7.ScalarType.FIXED32:
    case scalar_js_1$7.ScalarType.UINT32:
      return (0, assert_js_1$6.assert)(typeof c == "number"), c;
    case scalar_js_1$7.ScalarType.FLOAT:
    case scalar_js_1$7.ScalarType.DOUBLE:
      return (0, assert_js_1$6.assert)(typeof c == "number"), Number.isNaN(c) ? "NaN" : c === Number.POSITIVE_INFINITY ? "Infinity" : c === Number.NEGATIVE_INFINITY ? "-Infinity" : c;
    case scalar_js_1$7.ScalarType.STRING:
      return (0, assert_js_1$6.assert)(typeof c == "string"), c;
    case scalar_js_1$7.ScalarType.BOOL:
      return (0, assert_js_1$6.assert)(typeof c == "boolean"), c;
    case scalar_js_1$7.ScalarType.UINT64:
    case scalar_js_1$7.ScalarType.FIXED64:
    case scalar_js_1$7.ScalarType.INT64:
    case scalar_js_1$7.ScalarType.SFIXED64:
    case scalar_js_1$7.ScalarType.SINT64:
      return (0, assert_js_1$6.assert)(typeof c == "bigint" || typeof c == "string" || typeof c == "number"), c.toString();
    case scalar_js_1$7.ScalarType.BYTES:
      return (0, assert_js_1$6.assert)(c instanceof Uint8Array), proto_base64_js_1$1.protoBase64.enc(c);
  }
}
var binaryFormat = {}, binaryEncoding = {};
Object.defineProperty(binaryEncoding, "__esModule", { value: !0 });
binaryEncoding.BinaryReader = binaryEncoding.BinaryWriter = binaryEncoding.WireType = void 0;
const varint_js_1 = varint$2, assert_js_1$5 = assert$d, proto_int64_js_1$4 = protoInt64;
var WireType;
(function(n) {
  n[n.Varint = 0] = "Varint", n[n.Bit64 = 1] = "Bit64", n[n.LengthDelimited = 2] = "LengthDelimited", n[n.StartGroup = 3] = "StartGroup", n[n.EndGroup = 4] = "EndGroup", n[n.Bit32 = 5] = "Bit32";
})(WireType || (binaryEncoding.WireType = WireType = {}));
class BinaryWriter {
  constructor(c) {
    this.stack = [], this.textEncoder = c ?? new TextEncoder(), this.chunks = [], this.buf = [];
  }
  /**
   * Return all bytes written and reset this writer.
   */
  finish() {
    this.chunks.push(new Uint8Array(this.buf));
    let c = 0;
    for (let a = 0; a < this.chunks.length; a++)
      c += this.chunks[a].length;
    let u = new Uint8Array(c), p = 0;
    for (let a = 0; a < this.chunks.length; a++)
      u.set(this.chunks[a], p), p += this.chunks[a].length;
    return this.chunks = [], u;
  }
  /**
   * Start a new fork for length-delimited data like a message
   * or a packed repeated field.
   *
   * Must be joined later with `join()`.
   */
  fork() {
    return this.stack.push({ chunks: this.chunks, buf: this.buf }), this.chunks = [], this.buf = [], this;
  }
  /**
   * Join the last fork. Write its length and bytes, then
   * return to the previous state.
   */
  join() {
    let c = this.finish(), u = this.stack.pop();
    if (!u)
      throw new Error("invalid state, fork stack empty");
    return this.chunks = u.chunks, this.buf = u.buf, this.uint32(c.byteLength), this.raw(c);
  }
  /**
   * Writes a tag (field number and wire type).
   *
   * Equivalent to `uint32( (fieldNo << 3 | type) >>> 0 )`.
   *
   * Generated code should compute the tag ahead of time and call `uint32()`.
   */
  tag(c, u) {
    return this.uint32((c << 3 | u) >>> 0);
  }
  /**
   * Write a chunk of raw bytes.
   */
  raw(c) {
    return this.buf.length && (this.chunks.push(new Uint8Array(this.buf)), this.buf = []), this.chunks.push(c), this;
  }
  /**
   * Write a `uint32` value, an unsigned 32 bit varint.
   */
  uint32(c) {
    for ((0, assert_js_1$5.assertUInt32)(c); c > 127; )
      this.buf.push(c & 127 | 128), c = c >>> 7;
    return this.buf.push(c), this;
  }
  /**
   * Write a `int32` value, a signed 32 bit varint.
   */
  int32(c) {
    return (0, assert_js_1$5.assertInt32)(c), (0, varint_js_1.varint32write)(c, this.buf), this;
  }
  /**
   * Write a `bool` value, a variant.
   */
  bool(c) {
    return this.buf.push(c ? 1 : 0), this;
  }
  /**
   * Write a `bytes` value, length-delimited arbitrary data.
   */
  bytes(c) {
    return this.uint32(c.byteLength), this.raw(c);
  }
  /**
   * Write a `string` value, length-delimited data converted to UTF-8 text.
   */
  string(c) {
    let u = this.textEncoder.encode(c);
    return this.uint32(u.byteLength), this.raw(u);
  }
  /**
   * Write a `float` value, 32-bit floating point number.
   */
  float(c) {
    (0, assert_js_1$5.assertFloat32)(c);
    let u = new Uint8Array(4);
    return new DataView(u.buffer).setFloat32(0, c, !0), this.raw(u);
  }
  /**
   * Write a `double` value, a 64-bit floating point number.
   */
  double(c) {
    let u = new Uint8Array(8);
    return new DataView(u.buffer).setFloat64(0, c, !0), this.raw(u);
  }
  /**
   * Write a `fixed32` value, an unsigned, fixed-length 32-bit integer.
   */
  fixed32(c) {
    (0, assert_js_1$5.assertUInt32)(c);
    let u = new Uint8Array(4);
    return new DataView(u.buffer).setUint32(0, c, !0), this.raw(u);
  }
  /**
   * Write a `sfixed32` value, a signed, fixed-length 32-bit integer.
   */
  sfixed32(c) {
    (0, assert_js_1$5.assertInt32)(c);
    let u = new Uint8Array(4);
    return new DataView(u.buffer).setInt32(0, c, !0), this.raw(u);
  }
  /**
   * Write a `sint32` value, a signed, zigzag-encoded 32-bit varint.
   */
  sint32(c) {
    return (0, assert_js_1$5.assertInt32)(c), c = (c << 1 ^ c >> 31) >>> 0, (0, varint_js_1.varint32write)(c, this.buf), this;
  }
  /**
   * Write a `fixed64` value, a signed, fixed-length 64-bit integer.
   */
  sfixed64(c) {
    let u = new Uint8Array(8), p = new DataView(u.buffer), a = proto_int64_js_1$4.protoInt64.enc(c);
    return p.setInt32(0, a.lo, !0), p.setInt32(4, a.hi, !0), this.raw(u);
  }
  /**
   * Write a `fixed64` value, an unsigned, fixed-length 64 bit integer.
   */
  fixed64(c) {
    let u = new Uint8Array(8), p = new DataView(u.buffer), a = proto_int64_js_1$4.protoInt64.uEnc(c);
    return p.setInt32(0, a.lo, !0), p.setInt32(4, a.hi, !0), this.raw(u);
  }
  /**
   * Write a `int64` value, a signed 64-bit varint.
   */
  int64(c) {
    let u = proto_int64_js_1$4.protoInt64.enc(c);
    return (0, varint_js_1.varint64write)(u.lo, u.hi, this.buf), this;
  }
  /**
   * Write a `sint64` value, a signed, zig-zag-encoded 64-bit varint.
   */
  sint64(c) {
    let u = proto_int64_js_1$4.protoInt64.enc(c), p = u.hi >> 31, a = u.lo << 1 ^ p, A = (u.hi << 1 | u.lo >>> 31) ^ p;
    return (0, varint_js_1.varint64write)(a, A, this.buf), this;
  }
  /**
   * Write a `uint64` value, an unsigned 64-bit varint.
   */
  uint64(c) {
    let u = proto_int64_js_1$4.protoInt64.uEnc(c);
    return (0, varint_js_1.varint64write)(u.lo, u.hi, this.buf), this;
  }
}
binaryEncoding.BinaryWriter = BinaryWriter;
class BinaryReader {
  constructor(c, u) {
    this.varint64 = varint_js_1.varint64read, this.uint32 = varint_js_1.varint32read, this.buf = c, this.len = c.length, this.pos = 0, this.view = new DataView(c.buffer, c.byteOffset, c.byteLength), this.textDecoder = u ?? new TextDecoder();
  }
  /**
   * Reads a tag - field number and wire type.
   */
  tag() {
    let c = this.uint32(), u = c >>> 3, p = c & 7;
    if (u <= 0 || p < 0 || p > 5)
      throw new Error("illegal tag: field no " + u + " wire type " + p);
    return [u, p];
  }
  /**
   * Skip one element and return the skipped data.
   *
   * When skipping StartGroup, provide the tags field number to check for
   * matching field number in the EndGroup tag.
   */
  skip(c, u) {
    let p = this.pos;
    switch (c) {
      case WireType.Varint:
        for (; this.buf[this.pos++] & 128; )
          ;
        break;
      case WireType.Bit64:
        this.pos += 4;
      case WireType.Bit32:
        this.pos += 4;
        break;
      case WireType.LengthDelimited:
        let a = this.uint32();
        this.pos += a;
        break;
      case WireType.StartGroup:
        for (; ; ) {
          const [A, b] = this.tag();
          if (b === WireType.EndGroup) {
            if (u !== void 0 && A !== u)
              throw new Error("invalid end group tag");
            break;
          }
          this.skip(b, A);
        }
        break;
      default:
        throw new Error("cant skip wire type " + c);
    }
    return this.assertBounds(), this.buf.subarray(p, this.pos);
  }
  /**
   * Throws error if position in byte array is out of range.
   */
  assertBounds() {
    if (this.pos > this.len)
      throw new RangeError("premature EOF");
  }
  /**
   * Read a `int32` field, a signed 32 bit varint.
   */
  int32() {
    return this.uint32() | 0;
  }
  /**
   * Read a `sint32` field, a signed, zigzag-encoded 32-bit varint.
   */
  sint32() {
    let c = this.uint32();
    return c >>> 1 ^ -(c & 1);
  }
  /**
   * Read a `int64` field, a signed 64-bit varint.
   */
  int64() {
    return proto_int64_js_1$4.protoInt64.dec(...this.varint64());
  }
  /**
   * Read a `uint64` field, an unsigned 64-bit varint.
   */
  uint64() {
    return proto_int64_js_1$4.protoInt64.uDec(...this.varint64());
  }
  /**
   * Read a `sint64` field, a signed, zig-zag-encoded 64-bit varint.
   */
  sint64() {
    let [c, u] = this.varint64(), p = -(c & 1);
    return c = (c >>> 1 | (u & 1) << 31) ^ p, u = u >>> 1 ^ p, proto_int64_js_1$4.protoInt64.dec(c, u);
  }
  /**
   * Read a `bool` field, a variant.
   */
  bool() {
    let [c, u] = this.varint64();
    return c !== 0 || u !== 0;
  }
  /**
   * Read a `fixed32` field, an unsigned, fixed-length 32-bit integer.
   */
  fixed32() {
    return this.view.getUint32((this.pos += 4) - 4, !0);
  }
  /**
   * Read a `sfixed32` field, a signed, fixed-length 32-bit integer.
   */
  sfixed32() {
    return this.view.getInt32((this.pos += 4) - 4, !0);
  }
  /**
   * Read a `fixed64` field, an unsigned, fixed-length 64 bit integer.
   */
  fixed64() {
    return proto_int64_js_1$4.protoInt64.uDec(this.sfixed32(), this.sfixed32());
  }
  /**
   * Read a `fixed64` field, a signed, fixed-length 64-bit integer.
   */
  sfixed64() {
    return proto_int64_js_1$4.protoInt64.dec(this.sfixed32(), this.sfixed32());
  }
  /**
   * Read a `float` field, 32-bit floating point number.
   */
  float() {
    return this.view.getFloat32((this.pos += 4) - 4, !0);
  }
  /**
   * Read a `double` field, a 64-bit floating point number.
   */
  double() {
    return this.view.getFloat64((this.pos += 8) - 8, !0);
  }
  /**
   * Read a `bytes` field, length-delimited arbitrary data.
   */
  bytes() {
    let c = this.uint32(), u = this.pos;
    return this.pos += c, this.assertBounds(), this.buf.subarray(u, u + c);
  }
  /**
   * Read a `string` field, length-delimited data converted to UTF-8 text.
   */
  string() {
    return this.textDecoder.decode(this.bytes());
  }
}
binaryEncoding.BinaryReader = BinaryReader;
Object.defineProperty(binaryFormat, "__esModule", { value: !0 });
binaryFormat.writeMapEntry = binaryFormat.makeBinaryFormat = void 0;
const binary_encoding_js_1 = binaryEncoding, field_wrapper_js_1$1 = fieldWrapper, scalars_js_1$3 = scalars, assert_js_1$4 = assert$d, reflect_js_1 = reflect, scalar_js_1$6 = scalar, is_message_js_1$4 = isMessage$1, unknownFieldsSymbol = Symbol("@bufbuild/protobuf/unknown-fields"), readDefaults = {
  readUnknownFields: !0,
  readerFactory: (n) => new binary_encoding_js_1.BinaryReader(n)
}, writeDefaults = {
  writeUnknownFields: !0,
  writerFactory: () => new binary_encoding_js_1.BinaryWriter()
};
function makeReadOptions(n) {
  return n ? Object.assign(Object.assign({}, readDefaults), n) : readDefaults;
}
function makeWriteOptions(n) {
  return n ? Object.assign(Object.assign({}, writeDefaults), n) : writeDefaults;
}
function makeBinaryFormat() {
  return {
    makeReadOptions,
    makeWriteOptions,
    listUnknownFields(n) {
      var c;
      return (c = n[unknownFieldsSymbol]) !== null && c !== void 0 ? c : [];
    },
    discardUnknownFields(n) {
      delete n[unknownFieldsSymbol];
    },
    writeUnknownFields(n, c) {
      const p = n[unknownFieldsSymbol];
      if (p)
        for (const a of p)
          c.tag(a.no, a.wireType).raw(a.data);
    },
    onUnknownField(n, c, u, p) {
      const a = n;
      Array.isArray(a[unknownFieldsSymbol]) || (a[unknownFieldsSymbol] = []), a[unknownFieldsSymbol].push({ no: c, wireType: u, data: p });
    },
    readMessage(n, c, u, p, a) {
      const A = n.getType(), b = a ? c.len : c.pos + u;
      let F, le;
      for (; c.pos < b && ([F, le] = c.tag(), !(a === !0 && le == binary_encoding_js_1.WireType.EndGroup)); ) {
        const L = A.fields.find(F);
        if (!L) {
          const pe = c.skip(le, F);
          p.readUnknownFields && this.onUnknownField(n, F, le, pe);
          continue;
        }
        readField(n, c, L, le, p);
      }
      if (a && // eslint-disable-line @typescript-eslint/strict-boolean-expressions
      (le != binary_encoding_js_1.WireType.EndGroup || F !== u))
        throw new Error("invalid end group tag");
    },
    readField,
    writeMessage(n, c, u) {
      const p = n.getType();
      for (const a of p.fields.byNumber()) {
        if (!(0, reflect_js_1.isFieldSet)(a, n)) {
          if (a.req)
            throw new Error(`cannot encode field ${p.typeName}.${a.name} to binary: required field not set`);
          continue;
        }
        const A = a.oneof ? n[a.oneof.localName].value : n[a.localName];
        writeField(a, A, c, u);
      }
      return u.writeUnknownFields && this.writeUnknownFields(n, c), c;
    },
    writeField(n, c, u, p) {
      c !== void 0 && writeField(n, c, u, p);
    }
  };
}
binaryFormat.makeBinaryFormat = makeBinaryFormat;
function readField(n, c, u, p, a) {
  let { repeated: A, localName: b } = u;
  switch (u.oneof && (n = n[u.oneof.localName], n.case != b && delete n.value, n.case = b, b = "value"), u.kind) {
    case "scalar":
    case "enum":
      const F = u.kind == "enum" ? scalar_js_1$6.ScalarType.INT32 : u.T;
      let le = readScalar;
      if (u.kind == "scalar" && u.L > 0 && (le = readScalarLTString), A) {
        let Ee = n[b];
        if (p == binary_encoding_js_1.WireType.LengthDelimited && F != scalar_js_1$6.ScalarType.STRING && F != scalar_js_1$6.ScalarType.BYTES) {
          let He = c.uint32() + c.pos;
          for (; c.pos < He; )
            Ee.push(le(c, F));
        } else
          Ee.push(le(c, F));
      } else
        n[b] = le(c, F);
      break;
    case "message":
      const L = u.T;
      A ? n[b].push(readMessageField(c, new L(), a, u)) : (0, is_message_js_1$4.isMessage)(n[b]) ? readMessageField(c, n[b], a, u) : (n[b] = readMessageField(c, new L(), a, u), L.fieldWrapper && !u.oneof && !u.repeated && (n[b] = L.fieldWrapper.unwrapField(n[b])));
      break;
    case "map":
      let [pe, $] = readMapEntry(u, c, a);
      n[b][pe] = $;
      break;
  }
}
function readMessageField(n, c, u, p) {
  const a = c.getType().runtime.bin, A = p == null ? void 0 : p.delimited;
  return a.readMessage(
    c,
    n,
    A ? p.no : n.uint32(),
    // eslint-disable-line @typescript-eslint/strict-boolean-expressions
    u,
    A
  ), c;
}
function readMapEntry(n, c, u) {
  const p = c.uint32(), a = c.pos + p;
  let A, b;
  for (; c.pos < a; ) {
    const [F] = c.tag();
    switch (F) {
      case 1:
        A = readScalar(c, n.K);
        break;
      case 2:
        switch (n.V.kind) {
          case "scalar":
            b = readScalar(c, n.V.T);
            break;
          case "enum":
            b = c.int32();
            break;
          case "message":
            b = readMessageField(c, new n.V.T(), u, void 0);
            break;
        }
        break;
    }
  }
  if (A === void 0 && (A = (0, scalars_js_1$3.scalarZeroValue)(n.K, scalar_js_1$6.LongType.BIGINT)), typeof A != "string" && typeof A != "number" && (A = A.toString()), b === void 0)
    switch (n.V.kind) {
      case "scalar":
        b = (0, scalars_js_1$3.scalarZeroValue)(n.V.T, scalar_js_1$6.LongType.BIGINT);
        break;
      case "enum":
        b = n.V.T.values[0].no;
        break;
      case "message":
        b = new n.V.T();
        break;
    }
  return [A, b];
}
function readScalarLTString(n, c) {
  const u = readScalar(n, c);
  return typeof u == "bigint" ? u.toString() : u;
}
function readScalar(n, c) {
  switch (c) {
    case scalar_js_1$6.ScalarType.STRING:
      return n.string();
    case scalar_js_1$6.ScalarType.BOOL:
      return n.bool();
    case scalar_js_1$6.ScalarType.DOUBLE:
      return n.double();
    case scalar_js_1$6.ScalarType.FLOAT:
      return n.float();
    case scalar_js_1$6.ScalarType.INT32:
      return n.int32();
    case scalar_js_1$6.ScalarType.INT64:
      return n.int64();
    case scalar_js_1$6.ScalarType.UINT64:
      return n.uint64();
    case scalar_js_1$6.ScalarType.FIXED64:
      return n.fixed64();
    case scalar_js_1$6.ScalarType.BYTES:
      return n.bytes();
    case scalar_js_1$6.ScalarType.FIXED32:
      return n.fixed32();
    case scalar_js_1$6.ScalarType.SFIXED32:
      return n.sfixed32();
    case scalar_js_1$6.ScalarType.SFIXED64:
      return n.sfixed64();
    case scalar_js_1$6.ScalarType.SINT64:
      return n.sint64();
    case scalar_js_1$6.ScalarType.UINT32:
      return n.uint32();
    case scalar_js_1$6.ScalarType.SINT32:
      return n.sint32();
  }
}
function writeField(n, c, u, p) {
  (0, assert_js_1$4.assert)(c !== void 0);
  const a = n.repeated;
  switch (n.kind) {
    case "scalar":
    case "enum":
      let A = n.kind == "enum" ? scalar_js_1$6.ScalarType.INT32 : n.T;
      if (a)
        if ((0, assert_js_1$4.assert)(Array.isArray(c)), n.packed)
          writePacked(u, A, n.no, c);
        else
          for (const b of c)
            writeScalar(u, A, n.no, b);
      else
        writeScalar(u, A, n.no, c);
      break;
    case "message":
      if (a) {
        (0, assert_js_1$4.assert)(Array.isArray(c));
        for (const b of c)
          writeMessageField(u, p, n, b);
      } else
        writeMessageField(u, p, n, c);
      break;
    case "map":
      (0, assert_js_1$4.assert)(typeof c == "object" && c != null);
      for (const [b, F] of Object.entries(c))
        writeMapEntry(u, p, n, b, F);
      break;
  }
}
function writeMapEntry(n, c, u, p, a) {
  n.tag(u.no, binary_encoding_js_1.WireType.LengthDelimited), n.fork();
  let A = p;
  switch (u.K) {
    case scalar_js_1$6.ScalarType.INT32:
    case scalar_js_1$6.ScalarType.FIXED32:
    case scalar_js_1$6.ScalarType.UINT32:
    case scalar_js_1$6.ScalarType.SFIXED32:
    case scalar_js_1$6.ScalarType.SINT32:
      A = Number.parseInt(p);
      break;
    case scalar_js_1$6.ScalarType.BOOL:
      (0, assert_js_1$4.assert)(p == "true" || p == "false"), A = p == "true";
      break;
  }
  switch (writeScalar(n, u.K, 1, A), u.V.kind) {
    case "scalar":
      writeScalar(n, u.V.T, 2, a);
      break;
    case "enum":
      writeScalar(n, scalar_js_1$6.ScalarType.INT32, 2, a);
      break;
    case "message":
      (0, assert_js_1$4.assert)(a !== void 0), n.tag(2, binary_encoding_js_1.WireType.LengthDelimited).bytes(a.toBinary(c));
      break;
  }
  n.join();
}
binaryFormat.writeMapEntry = writeMapEntry;
function writeMessageField(n, c, u, p) {
  const a = (0, field_wrapper_js_1$1.wrapField)(u.T, p);
  u.delimited ? n.tag(u.no, binary_encoding_js_1.WireType.StartGroup).raw(a.toBinary(c)).tag(u.no, binary_encoding_js_1.WireType.EndGroup) : n.tag(u.no, binary_encoding_js_1.WireType.LengthDelimited).bytes(a.toBinary(c));
}
function writeScalar(n, c, u, p) {
  (0, assert_js_1$4.assert)(p !== void 0);
  let [a, A] = scalarTypeInfo(c);
  n.tag(u, a)[A](p);
}
function writePacked(n, c, u, p) {
  if (!p.length)
    return;
  n.tag(u, binary_encoding_js_1.WireType.LengthDelimited).fork();
  let [, a] = scalarTypeInfo(c);
  for (let A = 0; A < p.length; A++)
    n[a](p[A]);
  n.join();
}
function scalarTypeInfo(n) {
  let c = binary_encoding_js_1.WireType.Varint;
  switch (n) {
    case scalar_js_1$6.ScalarType.BYTES:
    case scalar_js_1$6.ScalarType.STRING:
      c = binary_encoding_js_1.WireType.LengthDelimited;
      break;
    case scalar_js_1$6.ScalarType.DOUBLE:
    case scalar_js_1$6.ScalarType.FIXED64:
    case scalar_js_1$6.ScalarType.SFIXED64:
      c = binary_encoding_js_1.WireType.Bit64;
      break;
    case scalar_js_1$6.ScalarType.FIXED32:
    case scalar_js_1$6.ScalarType.SFIXED32:
    case scalar_js_1$6.ScalarType.FLOAT:
      c = binary_encoding_js_1.WireType.Bit32;
      break;
  }
  const u = scalar_js_1$6.ScalarType[n].toLowerCase();
  return [c, u];
}
var utilCommon = {};
Object.defineProperty(utilCommon, "__esModule", { value: !0 });
utilCommon.makeUtilCommon = void 0;
const enum_js_1$2 = _enum, scalars_js_1$2 = scalars, scalar_js_1$5 = scalar, is_message_js_1$3 = isMessage$1;
function makeUtilCommon() {
  return {
    setEnumType: enum_js_1$2.setEnumType,
    initPartial(n, c) {
      if (n === void 0)
        return;
      const u = c.getType();
      for (const p of u.fields.byMember()) {
        const a = p.localName, A = c, b = n;
        if (b[a] != null)
          switch (p.kind) {
            case "oneof":
              const F = b[a].case;
              if (F === void 0)
                continue;
              const le = p.findField(F);
              let L = b[a].value;
              le && le.kind == "message" && !(0, is_message_js_1$3.isMessage)(L, le.T) ? L = new le.T(L) : le && le.kind === "scalar" && le.T === scalar_js_1$5.ScalarType.BYTES && (L = toU8Arr(L)), A[a] = { case: F, value: L };
              break;
            case "scalar":
            case "enum":
              let pe = b[a];
              p.T === scalar_js_1$5.ScalarType.BYTES && (pe = p.repeated ? pe.map(toU8Arr) : toU8Arr(pe)), A[a] = pe;
              break;
            case "map":
              switch (p.V.kind) {
                case "scalar":
                case "enum":
                  if (p.V.T === scalar_js_1$5.ScalarType.BYTES)
                    for (const [be, He] of Object.entries(b[a]))
                      A[a][be] = toU8Arr(He);
                  else
                    Object.assign(A[a], b[a]);
                  break;
                case "message":
                  const Ee = p.V.T;
                  for (const be of Object.keys(b[a])) {
                    let He = b[a][be];
                    Ee.fieldWrapper || (He = new Ee(He)), A[a][be] = He;
                  }
                  break;
              }
              break;
            case "message":
              const $ = p.T;
              if (p.repeated)
                A[a] = b[a].map((Ee) => (0, is_message_js_1$3.isMessage)(Ee, $) ? Ee : new $(Ee));
              else {
                const Ee = b[a];
                $.fieldWrapper ? /* We can't use BytesValue.typeName as that will create a circular import */ $.typeName === "google.protobuf.BytesValue" ? A[a] = toU8Arr(Ee) : A[a] = Ee : A[a] = (0, is_message_js_1$3.isMessage)(Ee, $) ? Ee : new $(Ee);
              }
              break;
          }
      }
    },
    // TODO use isFieldSet() here to support future field presence
    equals(n, c, u) {
      return c === u ? !0 : !c || !u ? !1 : n.fields.byMember().every((p) => {
        const a = c[p.localName], A = u[p.localName];
        if (p.repeated) {
          if (a.length !== A.length)
            return !1;
          switch (p.kind) {
            case "message":
              return a.every((b, F) => p.T.equals(b, A[F]));
            case "scalar":
              return a.every((b, F) => (0, scalars_js_1$2.scalarEquals)(p.T, b, A[F]));
            case "enum":
              return a.every((b, F) => (0, scalars_js_1$2.scalarEquals)(scalar_js_1$5.ScalarType.INT32, b, A[F]));
          }
          throw new Error(`repeated cannot contain ${p.kind}`);
        }
        switch (p.kind) {
          case "message":
            return p.T.equals(a, A);
          case "enum":
            return (0, scalars_js_1$2.scalarEquals)(scalar_js_1$5.ScalarType.INT32, a, A);
          case "scalar":
            return (0, scalars_js_1$2.scalarEquals)(p.T, a, A);
          case "oneof":
            if (a.case !== A.case)
              return !1;
            const b = p.findField(a.case);
            if (b === void 0)
              return !0;
            switch (b.kind) {
              case "message":
                return b.T.equals(a.value, A.value);
              case "enum":
                return (0, scalars_js_1$2.scalarEquals)(scalar_js_1$5.ScalarType.INT32, a.value, A.value);
              case "scalar":
                return (0, scalars_js_1$2.scalarEquals)(b.T, a.value, A.value);
            }
            throw new Error(`oneof cannot contain ${b.kind}`);
          case "map":
            const F = Object.keys(a).concat(Object.keys(A));
            switch (p.V.kind) {
              case "message":
                const le = p.V.T;
                return F.every((pe) => le.equals(a[pe], A[pe]));
              case "enum":
                return F.every((pe) => (0, scalars_js_1$2.scalarEquals)(scalar_js_1$5.ScalarType.INT32, a[pe], A[pe]));
              case "scalar":
                const L = p.V.T;
                return F.every((pe) => (0, scalars_js_1$2.scalarEquals)(L, a[pe], A[pe]));
            }
            break;
        }
      });
    },
    // TODO use isFieldSet() here to support future field presence
    clone(n) {
      const c = n.getType(), u = new c(), p = u;
      for (const a of c.fields.byMember()) {
        const A = n[a.localName];
        let b;
        if (a.repeated)
          b = A.map(cloneSingularField);
        else if (a.kind == "map") {
          b = p[a.localName];
          for (const [F, le] of Object.entries(A))
            b[F] = cloneSingularField(le);
        } else a.kind == "oneof" ? b = a.findField(A.case) ? { case: A.case, value: cloneSingularField(A.value) } : { case: void 0 } : b = cloneSingularField(A);
        p[a.localName] = b;
      }
      for (const a of c.runtime.bin.listUnknownFields(n))
        c.runtime.bin.onUnknownField(p, a.no, a.wireType, a.data);
      return u;
    }
  };
}
utilCommon.makeUtilCommon = makeUtilCommon;
function cloneSingularField(n) {
  if (n === void 0)
    return n;
  if ((0, is_message_js_1$3.isMessage)(n))
    return n.clone();
  if (n instanceof Uint8Array) {
    const c = new Uint8Array(n.byteLength);
    return c.set(n), c;
  }
  return n;
}
function toU8Arr(n) {
  return n instanceof Uint8Array ? n : new Uint8Array(n);
}
Object.defineProperty(protoRuntime, "__esModule", { value: !0 });
protoRuntime.makeProtoRuntime = void 0;
const enum_js_1$1 = _enum, message_type_js_1 = messageType, extensions_js_1 = extensions, json_format_js_1 = jsonFormat, binary_format_js_1 = binaryFormat, util_common_js_1 = utilCommon;
function makeProtoRuntime(n, c, u) {
  return {
    syntax: n,
    json: (0, json_format_js_1.makeJsonFormat)(),
    bin: (0, binary_format_js_1.makeBinaryFormat)(),
    util: Object.assign(Object.assign({}, (0, util_common_js_1.makeUtilCommon)()), {
      newFieldList: c,
      initFields: u
    }),
    makeMessageType(p, a, A) {
      return (0, message_type_js_1.makeMessageType)(this, p, a, A);
    },
    makeEnum: enum_js_1$1.makeEnum,
    makeEnumType: enum_js_1$1.makeEnumType,
    getEnumType: enum_js_1$1.getEnumType,
    makeExtension(p, a, A) {
      return (0, extensions_js_1.makeExtension)(this, p, a, A);
    }
  };
}
protoRuntime.makeProtoRuntime = makeProtoRuntime;
var fieldList = {};
Object.defineProperty(fieldList, "__esModule", { value: !0 });
fieldList.InternalFieldList = void 0;
class InternalFieldList {
  constructor(c, u) {
    this._fields = c, this._normalizer = u;
  }
  findJsonName(c) {
    if (!this.jsonNames) {
      const u = {};
      for (const p of this.list())
        u[p.jsonName] = u[p.name] = p;
      this.jsonNames = u;
    }
    return this.jsonNames[c];
  }
  find(c) {
    if (!this.numbers) {
      const u = {};
      for (const p of this.list())
        u[p.no] = p;
      this.numbers = u;
    }
    return this.numbers[c];
  }
  list() {
    return this.all || (this.all = this._normalizer(this._fields)), this.all;
  }
  byNumber() {
    return this.numbersAsc || (this.numbersAsc = this.list().concat().sort((c, u) => c.no - u.no)), this.numbersAsc;
  }
  byMember() {
    if (!this.members) {
      this.members = [];
      const c = this.members;
      let u;
      for (const p of this.list())
        p.oneof ? p.oneof !== u && (u = p.oneof, c.push(u)) : c.push(p);
    }
    return this.members;
  }
}
fieldList.InternalFieldList = InternalFieldList;
var fieldNormalize = {}, field$1 = {}, names = {};
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.safeIdentifier = n.safeObjectProperty = n.findEnumSharedPrefix = n.fieldJsonName = n.localOneofName = n.localFieldName = n.localName = void 0;
  function c(He) {
    switch (He.kind) {
      case "field":
        return u(He.name, He.oneof !== void 0);
      case "oneof":
        return p(He.name);
      case "enum":
      case "message":
      case "service":
      case "extension": {
        const Pe = He.file.proto.package, nr = Pe === void 0 ? 0 : Pe.length + 1, ir = He.typeName.substring(nr).replace(/\./g, "_");
        return (0, n.safeObjectProperty)((0, n.safeIdentifier)(ir));
      }
      case "enum_value": {
        let Pe = He.name;
        const nr = He.parent.sharedPrefix;
        return nr !== void 0 && (Pe = Pe.substring(nr.length)), (0, n.safeObjectProperty)(Pe);
      }
      case "rpc": {
        let Pe = He.name;
        return Pe.length == 0 ? Pe : (Pe = Pe[0].toLowerCase() + Pe.substring(1), (0, n.safeObjectProperty)(Pe));
      }
    }
  }
  n.localName = c;
  function u(He, Pe) {
    const nr = b(He);
    return Pe ? nr : (0, n.safeObjectProperty)($(nr));
  }
  n.localFieldName = u;
  function p(He) {
    return u(He, !1);
  }
  n.localOneofName = p, n.fieldJsonName = b;
  function a(He, Pe) {
    const nr = A(He) + "_";
    for (const ir of Pe) {
      if (!ir.toLowerCase().startsWith(nr))
        return;
      const or = ir.substring(nr.length);
      if (or.length == 0 || /^\d/.test(or))
        return;
    }
    return nr;
  }
  n.findEnumSharedPrefix = a;
  function A(He) {
    return (He.substring(0, 1) + He.substring(1).replace(/[A-Z]/g, (Pe) => "_" + Pe)).toLowerCase();
  }
  function b(He) {
    let Pe = !1;
    const nr = [];
    for (let ir = 0; ir < He.length; ir++) {
      let or = He.charAt(ir);
      switch (or) {
        case "_":
          Pe = !0;
          break;
        case "0":
        case "1":
        case "2":
        case "3":
        case "4":
        case "5":
        case "6":
        case "7":
        case "8":
        case "9":
          nr.push(or), Pe = !1;
          break;
        default:
          Pe && (Pe = !1, or = or.toUpperCase()), nr.push(or);
          break;
      }
    }
    return nr.join("");
  }
  const F = /* @__PURE__ */ new Set([
    // ECMAScript 2015 keywords
    "break",
    "case",
    "catch",
    "class",
    "const",
    "continue",
    "debugger",
    "default",
    "delete",
    "do",
    "else",
    "export",
    "extends",
    "false",
    "finally",
    "for",
    "function",
    "if",
    "import",
    "in",
    "instanceof",
    "new",
    "null",
    "return",
    "super",
    "switch",
    "this",
    "throw",
    "true",
    "try",
    "typeof",
    "var",
    "void",
    "while",
    "with",
    "yield",
    // ECMAScript 2015 future reserved keywords
    "enum",
    "implements",
    "interface",
    "let",
    "package",
    "private",
    "protected",
    "public",
    "static",
    // Class name cannot be 'Object' when targeting ES5 with module CommonJS
    "Object",
    // TypeScript keywords that cannot be used for types (as opposed to variables)
    "bigint",
    "number",
    "boolean",
    "string",
    "object",
    // Identifiers reserved for the runtime, so we can generate legible code
    "globalThis",
    "Uint8Array",
    "Partial"
  ]), le = /* @__PURE__ */ new Set([
    // names reserved by JavaScript
    "constructor",
    "toString",
    "toJSON",
    "valueOf"
  ]), L = /* @__PURE__ */ new Set([
    // names reserved by the runtime
    "getType",
    "clone",
    "equals",
    "fromBinary",
    "fromJson",
    "fromJsonString",
    "toBinary",
    "toJson",
    "toJsonString",
    // names reserved by the runtime for the future
    "toObject"
  ]), pe = (He) => `${He}$`, $ = (He) => L.has(He) ? pe(He) : He, Ee = (He) => le.has(He) ? pe(He) : He;
  n.safeObjectProperty = Ee;
  const be = (He) => F.has(He) ? pe(He) : He;
  n.safeIdentifier = be;
})(names);
Object.defineProperty(field$1, "__esModule", { value: !0 });
field$1.InternalOneofInfo = void 0;
const names_js_1$4 = names, assert_js_1$3 = assert$d;
class InternalOneofInfo {
  constructor(c) {
    this.kind = "oneof", this.repeated = !1, this.packed = !1, this.opt = !1, this.req = !1, this.default = void 0, this.fields = [], this.name = c, this.localName = (0, names_js_1$4.localOneofName)(c);
  }
  addField(c) {
    (0, assert_js_1$3.assert)(c.oneof === this, `field ${c.name} not one of ${this.name}`), this.fields.push(c);
  }
  findField(c) {
    if (!this._lookup) {
      this._lookup = /* @__PURE__ */ Object.create(null);
      for (let u = 0; u < this.fields.length; u++)
        this._lookup[this.fields[u].localName] = this.fields[u];
    }
    return this._lookup[c];
  }
}
field$1.InternalOneofInfo = InternalOneofInfo;
Object.defineProperty(fieldNormalize, "__esModule", { value: !0 });
fieldNormalize.normalizeFieldInfos = void 0;
const field_js_1 = field$1, names_js_1$3 = names, scalar_js_1$4 = scalar;
function normalizeFieldInfos(n, c) {
  var u, p, a, A, b, F;
  const le = [];
  let L;
  for (const pe of typeof n == "function" ? n() : n) {
    const $ = pe;
    if ($.localName = (0, names_js_1$3.localFieldName)(pe.name, pe.oneof !== void 0), $.jsonName = (u = pe.jsonName) !== null && u !== void 0 ? u : (0, names_js_1$3.fieldJsonName)(pe.name), $.repeated = (p = pe.repeated) !== null && p !== void 0 ? p : !1, pe.kind == "scalar" && ($.L = (a = pe.L) !== null && a !== void 0 ? a : scalar_js_1$4.LongType.BIGINT), $.delimited = (A = pe.delimited) !== null && A !== void 0 ? A : !1, $.req = (b = pe.req) !== null && b !== void 0 ? b : !1, $.opt = (F = pe.opt) !== null && F !== void 0 ? F : !1, pe.packed === void 0 && (c ? $.packed = pe.kind == "enum" || pe.kind == "scalar" && pe.T != scalar_js_1$4.ScalarType.BYTES && pe.T != scalar_js_1$4.ScalarType.STRING : $.packed = !1), pe.oneof !== void 0) {
      const Ee = typeof pe.oneof == "string" ? pe.oneof : pe.oneof.name;
      (!L || L.name != Ee) && (L = new field_js_1.InternalOneofInfo(Ee)), $.oneof = L, L.addField($);
    }
    le.push($);
  }
  return le;
}
fieldNormalize.normalizeFieldInfos = normalizeFieldInfos;
Object.defineProperty(proto3, "__esModule", { value: !0 });
proto3.proto3 = void 0;
const proto_runtime_js_1$1 = protoRuntime, field_list_js_1$1 = fieldList, scalars_js_1$1 = scalars, field_normalize_js_1$1 = fieldNormalize;
proto3.proto3 = (0, proto_runtime_js_1$1.makeProtoRuntime)(
  "proto3",
  (n) => new field_list_js_1$1.InternalFieldList(n, (c) => (0, field_normalize_js_1$1.normalizeFieldInfos)(c, !0)),
  // TODO merge with proto2 and initExtensionField, also see initPartial, equals, clone
  (n) => {
    for (const c of n.getType().fields.byMember()) {
      if (c.opt)
        continue;
      const u = c.localName, p = n;
      if (c.repeated) {
        p[u] = [];
        continue;
      }
      switch (c.kind) {
        case "oneof":
          p[u] = { case: void 0 };
          break;
        case "enum":
          p[u] = 0;
          break;
        case "map":
          p[u] = {};
          break;
        case "scalar":
          p[u] = (0, scalars_js_1$1.scalarZeroValue)(c.T, c.L);
          break;
      }
    }
  }
);
var proto2 = {};
Object.defineProperty(proto2, "__esModule", { value: !0 });
proto2.proto2 = void 0;
const proto_runtime_js_1 = protoRuntime, field_list_js_1 = fieldList, field_normalize_js_1 = fieldNormalize;
proto2.proto2 = (0, proto_runtime_js_1.makeProtoRuntime)(
  "proto2",
  (n) => new field_list_js_1.InternalFieldList(n, (c) => (0, field_normalize_js_1.normalizeFieldInfos)(c, !1)),
  // TODO merge with proto3 and initExtensionField, also see initPartial, equals, clone
  (n) => {
    for (const c of n.getType().fields.byMember()) {
      const u = c.localName, p = n;
      if (c.repeated) {
        p[u] = [];
        continue;
      }
      switch (c.kind) {
        case "oneof":
          p[u] = { case: void 0 };
          break;
        case "map":
          p[u] = {};
          break;
      }
    }
  }
);
var protoDouble = {};
Object.defineProperty(protoDouble, "__esModule", { value: !0 });
protoDouble.protoDouble = void 0;
protoDouble.protoDouble = {
  NaN: Number.NaN,
  POSITIVE_INFINITY: Number.POSITIVE_INFINITY,
  NEGATIVE_INFINITY: Number.NEGATIVE_INFINITY
};
var protoDelimited = {};
(function(n) {
  var c = commonjsGlobal && commonjsGlobal.__asyncValues || function(A) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var b = A[Symbol.asyncIterator], F;
    return b ? b.call(A) : (A = typeof __values == "function" ? __values(A) : A[Symbol.iterator](), F = {}, le("next"), le("throw"), le("return"), F[Symbol.asyncIterator] = function() {
      return this;
    }, F);
    function le(pe) {
      F[pe] = A[pe] && function($) {
        return new Promise(function(Ee, be) {
          $ = A[pe]($), L(Ee, be, $.done, $.value);
        });
      };
    }
    function L(pe, $, Ee, be) {
      Promise.resolve(be).then(function(He) {
        pe({ value: He, done: Ee });
      }, $);
    }
  }, u = commonjsGlobal && commonjsGlobal.__await || function(A) {
    return this instanceof u ? (this.v = A, this) : new u(A);
  }, p = commonjsGlobal && commonjsGlobal.__asyncGenerator || function(A, b, F) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var le = F.apply(A, b || []), L, pe = [];
    return L = {}, Ee("next"), Ee("throw"), Ee("return", $), L[Symbol.asyncIterator] = function() {
      return this;
    }, L;
    function $(or) {
      return function(lr) {
        return Promise.resolve(lr).then(or, nr);
      };
    }
    function Ee(or, lr) {
      le[or] && (L[or] = function(Ir) {
        return new Promise(function(xr, kr) {
          pe.push([or, Ir, xr, kr]) > 1 || be(or, Ir);
        });
      }, lr && (L[or] = lr(L[or])));
    }
    function be(or, lr) {
      try {
        He(le[or](lr));
      } catch (Ir) {
        ir(pe[0][3], Ir);
      }
    }
    function He(or) {
      or.value instanceof u ? Promise.resolve(or.value.v).then(Pe, nr) : ir(pe[0][2], or);
    }
    function Pe(or) {
      be("next", or);
    }
    function nr(or) {
      be("throw", or);
    }
    function ir(or, lr) {
      or(lr), pe.shift(), pe.length && be(pe[0][0], pe[0][1]);
    }
  };
  Object.defineProperty(n, "__esModule", { value: !0 }), n.protoDelimited = void 0;
  const a = binaryEncoding;
  n.protoDelimited = {
    /**
     * Serialize a message, prefixing it with its size.
     */
    enc(A, b) {
      const F = A.getType().runtime.bin.makeWriteOptions(b);
      return F.writerFactory().bytes(A.toBinary(F)).finish();
    },
    /**
     * Parse a size-delimited message, ignoring extra bytes.
     */
    dec(A, b, F) {
      const le = A.runtime.bin.makeReadOptions(F);
      return A.fromBinary(le.readerFactory(b).bytes(), le);
    },
    /**
     * Parse a stream of size-delimited messages.
     */
    decStream(A, b) {
      return p(this, arguments, function* () {
        var le, L, pe, $;
        function Ee(ir, or) {
          const lr = new Uint8Array(ir.byteLength + or.byteLength);
          return lr.set(ir), lr.set(or, ir.length), lr;
        }
        let be = new Uint8Array(0);
        try {
          for (var He = !0, Pe = c(b), nr; nr = yield u(Pe.next()), le = nr.done, !le; He = !0)
            for ($ = nr.value, He = !1, be = Ee(be, $); ; ) {
              const or = n.protoDelimited.peekSize(be);
              if (or.eof || or.offset + or.size > be.byteLength)
                break;
              yield yield u(n.protoDelimited.dec(A, be)), be = be.subarray(or.offset + or.size);
            }
        } catch (ir) {
          L = { error: ir };
        } finally {
          try {
            !He && !le && (pe = Pe.return) && (yield u(pe.call(Pe)));
          } finally {
            if (L) throw L.error;
          }
        }
        if (be.byteLength > 0)
          throw new Error("incomplete data");
      });
    },
    /**
     * Decodes the size from the given size-delimited message, which may be
     * incomplete.
     *
     * Returns an object with the following properties:
     * - size: The size of the delimited message in bytes
     * - offset: The offset in the given byte array where the message starts
     * - eof: true
     *
     * If the size-delimited data does not include all bytes of the varint size,
     * the following object is returned:
     * - size: null
     * - offset: null
     * - eof: false
     *
     * This function can be used to implement parsing of size-delimited messages
     * from a stream.
     */
    peekSize(A) {
      const b = { eof: !0, size: null, offset: null };
      for (let F = 0; F < 10; F++) {
        if (F > A.byteLength)
          return b;
        if (!(A[F] & 128)) {
          const le = new a.BinaryReader(A);
          let L;
          try {
            L = le.uint32();
          } catch (pe) {
            if (pe instanceof RangeError)
              return b;
            throw pe;
          }
          return {
            eof: !1,
            size: L,
            offset: le.pos
          };
        }
      }
      throw new Error("invalid varint");
    }
  };
})(protoDelimited);
var codegenInfo = {}, reifyWkt$1 = {};
Object.defineProperty(reifyWkt$1, "__esModule", { value: !0 });
reifyWkt$1.reifyWkt = void 0;
const scalar_js_1$3 = scalar;
function reifyWkt(n) {
  switch (n.typeName) {
    case "google.protobuf.Any": {
      const c = n.fields.find((p) => p.number == 1 && p.fieldKind == "scalar" && p.scalar === scalar_js_1$3.ScalarType.STRING), u = n.fields.find((p) => p.number == 2 && p.fieldKind == "scalar" && p.scalar === scalar_js_1$3.ScalarType.BYTES);
      if (c && u)
        return {
          typeName: n.typeName,
          typeUrl: c,
          value: u
        };
      break;
    }
    case "google.protobuf.Timestamp": {
      const c = n.fields.find((p) => p.number == 1 && p.fieldKind == "scalar" && p.scalar === scalar_js_1$3.ScalarType.INT64), u = n.fields.find((p) => p.number == 2 && p.fieldKind == "scalar" && p.scalar === scalar_js_1$3.ScalarType.INT32);
      if (c && u)
        return {
          typeName: n.typeName,
          seconds: c,
          nanos: u
        };
      break;
    }
    case "google.protobuf.Duration": {
      const c = n.fields.find((p) => p.number == 1 && p.fieldKind == "scalar" && p.scalar === scalar_js_1$3.ScalarType.INT64), u = n.fields.find((p) => p.number == 2 && p.fieldKind == "scalar" && p.scalar === scalar_js_1$3.ScalarType.INT32);
      if (c && u)
        return {
          typeName: n.typeName,
          seconds: c,
          nanos: u
        };
      break;
    }
    case "google.protobuf.Struct": {
      const c = n.fields.find((u) => u.number == 1 && !u.repeated);
      if ((c == null ? void 0 : c.fieldKind) !== "map" || c.mapValue.kind !== "message" || c.mapValue.message.typeName !== "google.protobuf.Value")
        break;
      return { typeName: n.typeName, fields: c };
    }
    case "google.protobuf.Value": {
      const c = n.oneofs.find((le) => le.name === "kind"), u = n.fields.find((le) => le.number == 1 && le.oneof === c);
      if ((u == null ? void 0 : u.fieldKind) !== "enum" || u.enum.typeName !== "google.protobuf.NullValue")
        return;
      const p = n.fields.find((le) => le.number == 2 && le.fieldKind == "scalar" && le.scalar === scalar_js_1$3.ScalarType.DOUBLE && le.oneof === c), a = n.fields.find((le) => le.number == 3 && le.fieldKind == "scalar" && le.scalar === scalar_js_1$3.ScalarType.STRING && le.oneof === c), A = n.fields.find((le) => le.number == 4 && le.fieldKind == "scalar" && le.scalar === scalar_js_1$3.ScalarType.BOOL && le.oneof === c), b = n.fields.find((le) => le.number == 5 && le.oneof === c);
      if ((b == null ? void 0 : b.fieldKind) !== "message" || b.message.typeName !== "google.protobuf.Struct")
        return;
      const F = n.fields.find((le) => le.number == 6 && le.oneof === c);
      if ((F == null ? void 0 : F.fieldKind) !== "message" || F.message.typeName !== "google.protobuf.ListValue")
        return;
      if (c && p && a && A)
        return {
          typeName: n.typeName,
          kind: c,
          nullValue: u,
          numberValue: p,
          stringValue: a,
          boolValue: A,
          structValue: b,
          listValue: F
        };
      break;
    }
    case "google.protobuf.ListValue": {
      const c = n.fields.find((u) => u.number == 1 && u.repeated);
      if ((c == null ? void 0 : c.fieldKind) != "message" || c.message.typeName !== "google.protobuf.Value")
        break;
      return { typeName: n.typeName, values: c };
    }
    case "google.protobuf.FieldMask": {
      const c = n.fields.find((u) => u.number == 1 && u.fieldKind == "scalar" && u.scalar === scalar_js_1$3.ScalarType.STRING && u.repeated);
      if (c)
        return { typeName: n.typeName, paths: c };
      break;
    }
    case "google.protobuf.DoubleValue":
    case "google.protobuf.FloatValue":
    case "google.protobuf.Int64Value":
    case "google.protobuf.UInt64Value":
    case "google.protobuf.Int32Value":
    case "google.protobuf.UInt32Value":
    case "google.protobuf.BoolValue":
    case "google.protobuf.StringValue":
    case "google.protobuf.BytesValue": {
      const c = n.fields.find((u) => u.number == 1 && u.name == "value");
      if (!c || c.fieldKind !== "scalar")
        break;
      return { typeName: n.typeName, value: c };
    }
  }
}
reifyWkt$1.reifyWkt = reifyWkt;
Object.defineProperty(codegenInfo, "__esModule", { value: !0 });
codegenInfo.codegenInfo = void 0;
const names_js_1$2 = names, field_wrapper_js_1 = fieldWrapper, scalars_js_1 = scalars, reify_wkt_js_1 = reifyWkt$1, packageName = "@bufbuild/protobuf";
codegenInfo.codegenInfo = {
  packageName: "@bufbuild/protobuf",
  localName: names_js_1$2.localName,
  reifyWkt: reify_wkt_js_1.reifyWkt,
  getUnwrappedFieldType: field_wrapper_js_1.getUnwrappedFieldType,
  scalarDefaultValue: scalars_js_1.scalarZeroValue,
  scalarZeroValue: scalars_js_1.scalarZeroValue,
  safeIdentifier: names_js_1$2.safeIdentifier,
  safeObjectProperty: names_js_1$2.safeObjectProperty,
  // prettier-ignore
  symbols: {
    proto2: { typeOnly: !1, privateImportPath: "./proto2.js", publicImportPath: packageName },
    proto3: { typeOnly: !1, privateImportPath: "./proto3.js", publicImportPath: packageName },
    Message: { typeOnly: !1, privateImportPath: "./message.js", publicImportPath: packageName },
    PartialMessage: { typeOnly: !0, privateImportPath: "./message.js", publicImportPath: packageName },
    PlainMessage: { typeOnly: !0, privateImportPath: "./message.js", publicImportPath: packageName },
    FieldList: { typeOnly: !0, privateImportPath: "./field-list.js", publicImportPath: packageName },
    MessageType: { typeOnly: !0, privateImportPath: "./message-type.js", publicImportPath: packageName },
    Extension: { typeOnly: !0, privateImportPath: "./extension.js", publicImportPath: packageName },
    BinaryReadOptions: { typeOnly: !0, privateImportPath: "./binary-format.js", publicImportPath: packageName },
    BinaryWriteOptions: { typeOnly: !0, privateImportPath: "./binary-format.js", publicImportPath: packageName },
    JsonReadOptions: { typeOnly: !0, privateImportPath: "./json-format.js", publicImportPath: packageName },
    JsonWriteOptions: { typeOnly: !0, privateImportPath: "./json-format.js", publicImportPath: packageName },
    JsonValue: { typeOnly: !0, privateImportPath: "./json-format.js", publicImportPath: packageName },
    JsonObject: { typeOnly: !0, privateImportPath: "./json-format.js", publicImportPath: packageName },
    protoDouble: { typeOnly: !1, privateImportPath: "./proto-double.js", publicImportPath: packageName },
    protoInt64: { typeOnly: !1, privateImportPath: "./proto-int64.js", publicImportPath: packageName },
    ScalarType: { typeOnly: !1, privateImportPath: "./scalar.js", publicImportPath: packageName },
    LongType: { typeOnly: !1, privateImportPath: "./scalar.js", publicImportPath: packageName },
    MethodKind: { typeOnly: !1, privateImportPath: "./service-type.js", publicImportPath: packageName },
    MethodIdempotency: { typeOnly: !1, privateImportPath: "./service-type.js", publicImportPath: packageName },
    IMessageTypeRegistry: { typeOnly: !0, privateImportPath: "./type-registry.js", publicImportPath: packageName }
  },
  wktSourceFiles: [
    "google/protobuf/compiler/plugin.proto",
    "google/protobuf/any.proto",
    "google/protobuf/api.proto",
    "google/protobuf/descriptor.proto",
    "google/protobuf/duration.proto",
    "google/protobuf/empty.proto",
    "google/protobuf/field_mask.proto",
    "google/protobuf/source_context.proto",
    "google/protobuf/struct.proto",
    "google/protobuf/timestamp.proto",
    "google/protobuf/type.proto",
    "google/protobuf/wrappers.proto"
  ]
};
var serviceType = {};
Object.defineProperty(serviceType, "__esModule", { value: !0 });
serviceType.MethodIdempotency = serviceType.MethodKind = void 0;
var MethodKind;
(function(n) {
  n[n.Unary = 0] = "Unary", n[n.ServerStreaming = 1] = "ServerStreaming", n[n.ClientStreaming = 2] = "ClientStreaming", n[n.BiDiStreaming = 3] = "BiDiStreaming";
})(MethodKind || (serviceType.MethodKind = MethodKind = {}));
var MethodIdempotency;
(function(n) {
  n[n.NoSideEffects = 1] = "NoSideEffects", n[n.Idempotent = 2] = "Idempotent";
})(MethodIdempotency || (serviceType.MethodIdempotency = MethodIdempotency = {}));
var createDescriptorSet$1 = {}, descriptor_pb = {};
Object.defineProperty(descriptor_pb, "__esModule", { value: !0 });
descriptor_pb.GeneratedCodeInfo_Annotation_Semantic = descriptor_pb.GeneratedCodeInfo_Annotation = descriptor_pb.GeneratedCodeInfo = descriptor_pb.SourceCodeInfo_Location = descriptor_pb.SourceCodeInfo = descriptor_pb.FeatureSetDefaults_FeatureSetEditionDefault = descriptor_pb.FeatureSetDefaults = descriptor_pb.FeatureSet_JsonFormat = descriptor_pb.FeatureSet_MessageEncoding = descriptor_pb.FeatureSet_Utf8Validation = descriptor_pb.FeatureSet_RepeatedFieldEncoding = descriptor_pb.FeatureSet_EnumType = descriptor_pb.FeatureSet_FieldPresence = descriptor_pb.FeatureSet = descriptor_pb.UninterpretedOption_NamePart = descriptor_pb.UninterpretedOption = descriptor_pb.MethodOptions_IdempotencyLevel = descriptor_pb.MethodOptions = descriptor_pb.ServiceOptions = descriptor_pb.EnumValueOptions = descriptor_pb.EnumOptions = descriptor_pb.OneofOptions = descriptor_pb.FieldOptions_FeatureSupport = descriptor_pb.FieldOptions_EditionDefault = descriptor_pb.FieldOptions_OptionTargetType = descriptor_pb.FieldOptions_OptionRetention = descriptor_pb.FieldOptions_JSType = descriptor_pb.FieldOptions_CType = descriptor_pb.FieldOptions = descriptor_pb.MessageOptions = descriptor_pb.FileOptions_OptimizeMode = descriptor_pb.FileOptions = descriptor_pb.MethodDescriptorProto = descriptor_pb.ServiceDescriptorProto = descriptor_pb.EnumValueDescriptorProto = descriptor_pb.EnumDescriptorProto_EnumReservedRange = descriptor_pb.EnumDescriptorProto = descriptor_pb.OneofDescriptorProto = descriptor_pb.FieldDescriptorProto_Label = descriptor_pb.FieldDescriptorProto_Type = descriptor_pb.FieldDescriptorProto = descriptor_pb.ExtensionRangeOptions_Declaration = descriptor_pb.ExtensionRangeOptions_VerificationState = descriptor_pb.ExtensionRangeOptions = descriptor_pb.DescriptorProto_ReservedRange = descriptor_pb.DescriptorProto_ExtensionRange = descriptor_pb.DescriptorProto = descriptor_pb.FileDescriptorProto = descriptor_pb.FileDescriptorSet = descriptor_pb.Edition = void 0;
const proto2_js_1$2 = proto2, message_js_1$b = message;
var Edition;
(function(n) {
  n[n.EDITION_UNKNOWN = 0] = "EDITION_UNKNOWN", n[n.EDITION_LEGACY = 900] = "EDITION_LEGACY", n[n.EDITION_PROTO2 = 998] = "EDITION_PROTO2", n[n.EDITION_PROTO3 = 999] = "EDITION_PROTO3", n[n.EDITION_2023 = 1e3] = "EDITION_2023", n[n.EDITION_2024 = 1001] = "EDITION_2024", n[n.EDITION_1_TEST_ONLY = 1] = "EDITION_1_TEST_ONLY", n[n.EDITION_2_TEST_ONLY = 2] = "EDITION_2_TEST_ONLY", n[n.EDITION_99997_TEST_ONLY = 99997] = "EDITION_99997_TEST_ONLY", n[n.EDITION_99998_TEST_ONLY = 99998] = "EDITION_99998_TEST_ONLY", n[n.EDITION_99999_TEST_ONLY = 99999] = "EDITION_99999_TEST_ONLY", n[n.EDITION_MAX = 2147483647] = "EDITION_MAX";
})(Edition || (descriptor_pb.Edition = Edition = {}));
proto2_js_1$2.proto2.util.setEnumType(Edition, "google.protobuf.Edition", [
  { no: 0, name: "EDITION_UNKNOWN" },
  { no: 900, name: "EDITION_LEGACY" },
  { no: 998, name: "EDITION_PROTO2" },
  { no: 999, name: "EDITION_PROTO3" },
  { no: 1e3, name: "EDITION_2023" },
  { no: 1001, name: "EDITION_2024" },
  { no: 1, name: "EDITION_1_TEST_ONLY" },
  { no: 2, name: "EDITION_2_TEST_ONLY" },
  { no: 99997, name: "EDITION_99997_TEST_ONLY" },
  { no: 99998, name: "EDITION_99998_TEST_ONLY" },
  { no: 99999, name: "EDITION_99999_TEST_ONLY" },
  { no: 2147483647, name: "EDITION_MAX" }
]);
class FileDescriptorSet extends message_js_1$b.Message {
  constructor(c) {
    super(), this.file = [], proto2_js_1$2.proto2.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new FileDescriptorSet().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new FileDescriptorSet().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new FileDescriptorSet().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto2_js_1$2.proto2.util.equals(FileDescriptorSet, c, u);
  }
}
descriptor_pb.FileDescriptorSet = FileDescriptorSet;
FileDescriptorSet.runtime = proto2_js_1$2.proto2;
FileDescriptorSet.typeName = "google.protobuf.FileDescriptorSet";
FileDescriptorSet.fields = proto2_js_1$2.proto2.util.newFieldList(() => [
  { no: 1, name: "file", kind: "message", T: FileDescriptorProto, repeated: !0 }
]);
class FileDescriptorProto extends message_js_1$b.Message {
  constructor(c) {
    super(), this.dependency = [], this.publicDependency = [], this.weakDependency = [], this.messageType = [], this.enumType = [], this.service = [], this.extension = [], proto2_js_1$2.proto2.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new FileDescriptorProto().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new FileDescriptorProto().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new FileDescriptorProto().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto2_js_1$2.proto2.util.equals(FileDescriptorProto, c, u);
  }
}
descriptor_pb.FileDescriptorProto = FileDescriptorProto;
FileDescriptorProto.runtime = proto2_js_1$2.proto2;
FileDescriptorProto.typeName = "google.protobuf.FileDescriptorProto";
FileDescriptorProto.fields = proto2_js_1$2.proto2.util.newFieldList(() => [
  { no: 1, name: "name", kind: "scalar", T: 9, opt: !0 },
  { no: 2, name: "package", kind: "scalar", T: 9, opt: !0 },
  { no: 3, name: "dependency", kind: "scalar", T: 9, repeated: !0 },
  { no: 10, name: "public_dependency", kind: "scalar", T: 5, repeated: !0 },
  { no: 11, name: "weak_dependency", kind: "scalar", T: 5, repeated: !0 },
  { no: 4, name: "message_type", kind: "message", T: DescriptorProto, repeated: !0 },
  { no: 5, name: "enum_type", kind: "message", T: EnumDescriptorProto, repeated: !0 },
  { no: 6, name: "service", kind: "message", T: ServiceDescriptorProto, repeated: !0 },
  { no: 7, name: "extension", kind: "message", T: FieldDescriptorProto, repeated: !0 },
  { no: 8, name: "options", kind: "message", T: FileOptions, opt: !0 },
  { no: 9, name: "source_code_info", kind: "message", T: SourceCodeInfo, opt: !0 },
  { no: 12, name: "syntax", kind: "scalar", T: 9, opt: !0 },
  { no: 14, name: "edition", kind: "enum", T: proto2_js_1$2.proto2.getEnumType(Edition), opt: !0 }
]);
class DescriptorProto extends message_js_1$b.Message {
  constructor(c) {
    super(), this.field = [], this.extension = [], this.nestedType = [], this.enumType = [], this.extensionRange = [], this.oneofDecl = [], this.reservedRange = [], this.reservedName = [], proto2_js_1$2.proto2.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new DescriptorProto().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new DescriptorProto().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new DescriptorProto().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto2_js_1$2.proto2.util.equals(DescriptorProto, c, u);
  }
}
descriptor_pb.DescriptorProto = DescriptorProto;
DescriptorProto.runtime = proto2_js_1$2.proto2;
DescriptorProto.typeName = "google.protobuf.DescriptorProto";
DescriptorProto.fields = proto2_js_1$2.proto2.util.newFieldList(() => [
  { no: 1, name: "name", kind: "scalar", T: 9, opt: !0 },
  { no: 2, name: "field", kind: "message", T: FieldDescriptorProto, repeated: !0 },
  { no: 6, name: "extension", kind: "message", T: FieldDescriptorProto, repeated: !0 },
  { no: 3, name: "nested_type", kind: "message", T: DescriptorProto, repeated: !0 },
  { no: 4, name: "enum_type", kind: "message", T: EnumDescriptorProto, repeated: !0 },
  { no: 5, name: "extension_range", kind: "message", T: DescriptorProto_ExtensionRange, repeated: !0 },
  { no: 8, name: "oneof_decl", kind: "message", T: OneofDescriptorProto, repeated: !0 },
  { no: 7, name: "options", kind: "message", T: MessageOptions, opt: !0 },
  { no: 9, name: "reserved_range", kind: "message", T: DescriptorProto_ReservedRange, repeated: !0 },
  { no: 10, name: "reserved_name", kind: "scalar", T: 9, repeated: !0 }
]);
class DescriptorProto_ExtensionRange extends message_js_1$b.Message {
  constructor(c) {
    super(), proto2_js_1$2.proto2.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new DescriptorProto_ExtensionRange().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new DescriptorProto_ExtensionRange().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new DescriptorProto_ExtensionRange().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto2_js_1$2.proto2.util.equals(DescriptorProto_ExtensionRange, c, u);
  }
}
descriptor_pb.DescriptorProto_ExtensionRange = DescriptorProto_ExtensionRange;
DescriptorProto_ExtensionRange.runtime = proto2_js_1$2.proto2;
DescriptorProto_ExtensionRange.typeName = "google.protobuf.DescriptorProto.ExtensionRange";
DescriptorProto_ExtensionRange.fields = proto2_js_1$2.proto2.util.newFieldList(() => [
  { no: 1, name: "start", kind: "scalar", T: 5, opt: !0 },
  { no: 2, name: "end", kind: "scalar", T: 5, opt: !0 },
  { no: 3, name: "options", kind: "message", T: ExtensionRangeOptions, opt: !0 }
]);
class DescriptorProto_ReservedRange extends message_js_1$b.Message {
  constructor(c) {
    super(), proto2_js_1$2.proto2.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new DescriptorProto_ReservedRange().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new DescriptorProto_ReservedRange().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new DescriptorProto_ReservedRange().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto2_js_1$2.proto2.util.equals(DescriptorProto_ReservedRange, c, u);
  }
}
descriptor_pb.DescriptorProto_ReservedRange = DescriptorProto_ReservedRange;
DescriptorProto_ReservedRange.runtime = proto2_js_1$2.proto2;
DescriptorProto_ReservedRange.typeName = "google.protobuf.DescriptorProto.ReservedRange";
DescriptorProto_ReservedRange.fields = proto2_js_1$2.proto2.util.newFieldList(() => [
  { no: 1, name: "start", kind: "scalar", T: 5, opt: !0 },
  { no: 2, name: "end", kind: "scalar", T: 5, opt: !0 }
]);
class ExtensionRangeOptions extends message_js_1$b.Message {
  constructor(c) {
    super(), this.uninterpretedOption = [], this.declaration = [], proto2_js_1$2.proto2.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new ExtensionRangeOptions().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new ExtensionRangeOptions().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new ExtensionRangeOptions().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto2_js_1$2.proto2.util.equals(ExtensionRangeOptions, c, u);
  }
}
descriptor_pb.ExtensionRangeOptions = ExtensionRangeOptions;
ExtensionRangeOptions.runtime = proto2_js_1$2.proto2;
ExtensionRangeOptions.typeName = "google.protobuf.ExtensionRangeOptions";
ExtensionRangeOptions.fields = proto2_js_1$2.proto2.util.newFieldList(() => [
  { no: 999, name: "uninterpreted_option", kind: "message", T: UninterpretedOption, repeated: !0 },
  { no: 2, name: "declaration", kind: "message", T: ExtensionRangeOptions_Declaration, repeated: !0 },
  { no: 50, name: "features", kind: "message", T: FeatureSet, opt: !0 },
  { no: 3, name: "verification", kind: "enum", T: proto2_js_1$2.proto2.getEnumType(ExtensionRangeOptions_VerificationState), opt: !0, default: ExtensionRangeOptions_VerificationState.UNVERIFIED }
]);
var ExtensionRangeOptions_VerificationState;
(function(n) {
  n[n.DECLARATION = 0] = "DECLARATION", n[n.UNVERIFIED = 1] = "UNVERIFIED";
})(ExtensionRangeOptions_VerificationState || (descriptor_pb.ExtensionRangeOptions_VerificationState = ExtensionRangeOptions_VerificationState = {}));
proto2_js_1$2.proto2.util.setEnumType(ExtensionRangeOptions_VerificationState, "google.protobuf.ExtensionRangeOptions.VerificationState", [
  { no: 0, name: "DECLARATION" },
  { no: 1, name: "UNVERIFIED" }
]);
class ExtensionRangeOptions_Declaration extends message_js_1$b.Message {
  constructor(c) {
    super(), proto2_js_1$2.proto2.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new ExtensionRangeOptions_Declaration().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new ExtensionRangeOptions_Declaration().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new ExtensionRangeOptions_Declaration().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto2_js_1$2.proto2.util.equals(ExtensionRangeOptions_Declaration, c, u);
  }
}
descriptor_pb.ExtensionRangeOptions_Declaration = ExtensionRangeOptions_Declaration;
ExtensionRangeOptions_Declaration.runtime = proto2_js_1$2.proto2;
ExtensionRangeOptions_Declaration.typeName = "google.protobuf.ExtensionRangeOptions.Declaration";
ExtensionRangeOptions_Declaration.fields = proto2_js_1$2.proto2.util.newFieldList(() => [
  { no: 1, name: "number", kind: "scalar", T: 5, opt: !0 },
  { no: 2, name: "full_name", kind: "scalar", T: 9, opt: !0 },
  { no: 3, name: "type", kind: "scalar", T: 9, opt: !0 },
  { no: 5, name: "reserved", kind: "scalar", T: 8, opt: !0 },
  { no: 6, name: "repeated", kind: "scalar", T: 8, opt: !0 }
]);
class FieldDescriptorProto extends message_js_1$b.Message {
  constructor(c) {
    super(), proto2_js_1$2.proto2.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new FieldDescriptorProto().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new FieldDescriptorProto().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new FieldDescriptorProto().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto2_js_1$2.proto2.util.equals(FieldDescriptorProto, c, u);
  }
}
descriptor_pb.FieldDescriptorProto = FieldDescriptorProto;
FieldDescriptorProto.runtime = proto2_js_1$2.proto2;
FieldDescriptorProto.typeName = "google.protobuf.FieldDescriptorProto";
FieldDescriptorProto.fields = proto2_js_1$2.proto2.util.newFieldList(() => [
  { no: 1, name: "name", kind: "scalar", T: 9, opt: !0 },
  { no: 3, name: "number", kind: "scalar", T: 5, opt: !0 },
  { no: 4, name: "label", kind: "enum", T: proto2_js_1$2.proto2.getEnumType(FieldDescriptorProto_Label), opt: !0 },
  { no: 5, name: "type", kind: "enum", T: proto2_js_1$2.proto2.getEnumType(FieldDescriptorProto_Type), opt: !0 },
  { no: 6, name: "type_name", kind: "scalar", T: 9, opt: !0 },
  { no: 2, name: "extendee", kind: "scalar", T: 9, opt: !0 },
  { no: 7, name: "default_value", kind: "scalar", T: 9, opt: !0 },
  { no: 9, name: "oneof_index", kind: "scalar", T: 5, opt: !0 },
  { no: 10, name: "json_name", kind: "scalar", T: 9, opt: !0 },
  { no: 8, name: "options", kind: "message", T: FieldOptions, opt: !0 },
  { no: 17, name: "proto3_optional", kind: "scalar", T: 8, opt: !0 }
]);
var FieldDescriptorProto_Type;
(function(n) {
  n[n.DOUBLE = 1] = "DOUBLE", n[n.FLOAT = 2] = "FLOAT", n[n.INT64 = 3] = "INT64", n[n.UINT64 = 4] = "UINT64", n[n.INT32 = 5] = "INT32", n[n.FIXED64 = 6] = "FIXED64", n[n.FIXED32 = 7] = "FIXED32", n[n.BOOL = 8] = "BOOL", n[n.STRING = 9] = "STRING", n[n.GROUP = 10] = "GROUP", n[n.MESSAGE = 11] = "MESSAGE", n[n.BYTES = 12] = "BYTES", n[n.UINT32 = 13] = "UINT32", n[n.ENUM = 14] = "ENUM", n[n.SFIXED32 = 15] = "SFIXED32", n[n.SFIXED64 = 16] = "SFIXED64", n[n.SINT32 = 17] = "SINT32", n[n.SINT64 = 18] = "SINT64";
})(FieldDescriptorProto_Type || (descriptor_pb.FieldDescriptorProto_Type = FieldDescriptorProto_Type = {}));
proto2_js_1$2.proto2.util.setEnumType(FieldDescriptorProto_Type, "google.protobuf.FieldDescriptorProto.Type", [
  { no: 1, name: "TYPE_DOUBLE" },
  { no: 2, name: "TYPE_FLOAT" },
  { no: 3, name: "TYPE_INT64" },
  { no: 4, name: "TYPE_UINT64" },
  { no: 5, name: "TYPE_INT32" },
  { no: 6, name: "TYPE_FIXED64" },
  { no: 7, name: "TYPE_FIXED32" },
  { no: 8, name: "TYPE_BOOL" },
  { no: 9, name: "TYPE_STRING" },
  { no: 10, name: "TYPE_GROUP" },
  { no: 11, name: "TYPE_MESSAGE" },
  { no: 12, name: "TYPE_BYTES" },
  { no: 13, name: "TYPE_UINT32" },
  { no: 14, name: "TYPE_ENUM" },
  { no: 15, name: "TYPE_SFIXED32" },
  { no: 16, name: "TYPE_SFIXED64" },
  { no: 17, name: "TYPE_SINT32" },
  { no: 18, name: "TYPE_SINT64" }
]);
var FieldDescriptorProto_Label;
(function(n) {
  n[n.OPTIONAL = 1] = "OPTIONAL", n[n.REPEATED = 3] = "REPEATED", n[n.REQUIRED = 2] = "REQUIRED";
})(FieldDescriptorProto_Label || (descriptor_pb.FieldDescriptorProto_Label = FieldDescriptorProto_Label = {}));
proto2_js_1$2.proto2.util.setEnumType(FieldDescriptorProto_Label, "google.protobuf.FieldDescriptorProto.Label", [
  { no: 1, name: "LABEL_OPTIONAL" },
  { no: 3, name: "LABEL_REPEATED" },
  { no: 2, name: "LABEL_REQUIRED" }
]);
class OneofDescriptorProto extends message_js_1$b.Message {
  constructor(c) {
    super(), proto2_js_1$2.proto2.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new OneofDescriptorProto().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new OneofDescriptorProto().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new OneofDescriptorProto().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto2_js_1$2.proto2.util.equals(OneofDescriptorProto, c, u);
  }
}
descriptor_pb.OneofDescriptorProto = OneofDescriptorProto;
OneofDescriptorProto.runtime = proto2_js_1$2.proto2;
OneofDescriptorProto.typeName = "google.protobuf.OneofDescriptorProto";
OneofDescriptorProto.fields = proto2_js_1$2.proto2.util.newFieldList(() => [
  { no: 1, name: "name", kind: "scalar", T: 9, opt: !0 },
  { no: 2, name: "options", kind: "message", T: OneofOptions, opt: !0 }
]);
class EnumDescriptorProto extends message_js_1$b.Message {
  constructor(c) {
    super(), this.value = [], this.reservedRange = [], this.reservedName = [], proto2_js_1$2.proto2.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new EnumDescriptorProto().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new EnumDescriptorProto().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new EnumDescriptorProto().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto2_js_1$2.proto2.util.equals(EnumDescriptorProto, c, u);
  }
}
descriptor_pb.EnumDescriptorProto = EnumDescriptorProto;
EnumDescriptorProto.runtime = proto2_js_1$2.proto2;
EnumDescriptorProto.typeName = "google.protobuf.EnumDescriptorProto";
EnumDescriptorProto.fields = proto2_js_1$2.proto2.util.newFieldList(() => [
  { no: 1, name: "name", kind: "scalar", T: 9, opt: !0 },
  { no: 2, name: "value", kind: "message", T: EnumValueDescriptorProto, repeated: !0 },
  { no: 3, name: "options", kind: "message", T: EnumOptions, opt: !0 },
  { no: 4, name: "reserved_range", kind: "message", T: EnumDescriptorProto_EnumReservedRange, repeated: !0 },
  { no: 5, name: "reserved_name", kind: "scalar", T: 9, repeated: !0 }
]);
class EnumDescriptorProto_EnumReservedRange extends message_js_1$b.Message {
  constructor(c) {
    super(), proto2_js_1$2.proto2.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new EnumDescriptorProto_EnumReservedRange().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new EnumDescriptorProto_EnumReservedRange().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new EnumDescriptorProto_EnumReservedRange().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto2_js_1$2.proto2.util.equals(EnumDescriptorProto_EnumReservedRange, c, u);
  }
}
descriptor_pb.EnumDescriptorProto_EnumReservedRange = EnumDescriptorProto_EnumReservedRange;
EnumDescriptorProto_EnumReservedRange.runtime = proto2_js_1$2.proto2;
EnumDescriptorProto_EnumReservedRange.typeName = "google.protobuf.EnumDescriptorProto.EnumReservedRange";
EnumDescriptorProto_EnumReservedRange.fields = proto2_js_1$2.proto2.util.newFieldList(() => [
  { no: 1, name: "start", kind: "scalar", T: 5, opt: !0 },
  { no: 2, name: "end", kind: "scalar", T: 5, opt: !0 }
]);
class EnumValueDescriptorProto extends message_js_1$b.Message {
  constructor(c) {
    super(), proto2_js_1$2.proto2.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new EnumValueDescriptorProto().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new EnumValueDescriptorProto().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new EnumValueDescriptorProto().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto2_js_1$2.proto2.util.equals(EnumValueDescriptorProto, c, u);
  }
}
descriptor_pb.EnumValueDescriptorProto = EnumValueDescriptorProto;
EnumValueDescriptorProto.runtime = proto2_js_1$2.proto2;
EnumValueDescriptorProto.typeName = "google.protobuf.EnumValueDescriptorProto";
EnumValueDescriptorProto.fields = proto2_js_1$2.proto2.util.newFieldList(() => [
  { no: 1, name: "name", kind: "scalar", T: 9, opt: !0 },
  { no: 2, name: "number", kind: "scalar", T: 5, opt: !0 },
  { no: 3, name: "options", kind: "message", T: EnumValueOptions, opt: !0 }
]);
class ServiceDescriptorProto extends message_js_1$b.Message {
  constructor(c) {
    super(), this.method = [], proto2_js_1$2.proto2.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new ServiceDescriptorProto().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new ServiceDescriptorProto().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new ServiceDescriptorProto().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto2_js_1$2.proto2.util.equals(ServiceDescriptorProto, c, u);
  }
}
descriptor_pb.ServiceDescriptorProto = ServiceDescriptorProto;
ServiceDescriptorProto.runtime = proto2_js_1$2.proto2;
ServiceDescriptorProto.typeName = "google.protobuf.ServiceDescriptorProto";
ServiceDescriptorProto.fields = proto2_js_1$2.proto2.util.newFieldList(() => [
  { no: 1, name: "name", kind: "scalar", T: 9, opt: !0 },
  { no: 2, name: "method", kind: "message", T: MethodDescriptorProto, repeated: !0 },
  { no: 3, name: "options", kind: "message", T: ServiceOptions, opt: !0 }
]);
class MethodDescriptorProto extends message_js_1$b.Message {
  constructor(c) {
    super(), proto2_js_1$2.proto2.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new MethodDescriptorProto().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new MethodDescriptorProto().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new MethodDescriptorProto().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto2_js_1$2.proto2.util.equals(MethodDescriptorProto, c, u);
  }
}
descriptor_pb.MethodDescriptorProto = MethodDescriptorProto;
MethodDescriptorProto.runtime = proto2_js_1$2.proto2;
MethodDescriptorProto.typeName = "google.protobuf.MethodDescriptorProto";
MethodDescriptorProto.fields = proto2_js_1$2.proto2.util.newFieldList(() => [
  { no: 1, name: "name", kind: "scalar", T: 9, opt: !0 },
  { no: 2, name: "input_type", kind: "scalar", T: 9, opt: !0 },
  { no: 3, name: "output_type", kind: "scalar", T: 9, opt: !0 },
  { no: 4, name: "options", kind: "message", T: MethodOptions, opt: !0 },
  { no: 5, name: "client_streaming", kind: "scalar", T: 8, opt: !0, default: !1 },
  { no: 6, name: "server_streaming", kind: "scalar", T: 8, opt: !0, default: !1 }
]);
class FileOptions extends message_js_1$b.Message {
  constructor(c) {
    super(), this.uninterpretedOption = [], proto2_js_1$2.proto2.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new FileOptions().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new FileOptions().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new FileOptions().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto2_js_1$2.proto2.util.equals(FileOptions, c, u);
  }
}
descriptor_pb.FileOptions = FileOptions;
FileOptions.runtime = proto2_js_1$2.proto2;
FileOptions.typeName = "google.protobuf.FileOptions";
FileOptions.fields = proto2_js_1$2.proto2.util.newFieldList(() => [
  { no: 1, name: "java_package", kind: "scalar", T: 9, opt: !0 },
  { no: 8, name: "java_outer_classname", kind: "scalar", T: 9, opt: !0 },
  { no: 10, name: "java_multiple_files", kind: "scalar", T: 8, opt: !0, default: !1 },
  { no: 20, name: "java_generate_equals_and_hash", kind: "scalar", T: 8, opt: !0 },
  { no: 27, name: "java_string_check_utf8", kind: "scalar", T: 8, opt: !0, default: !1 },
  { no: 9, name: "optimize_for", kind: "enum", T: proto2_js_1$2.proto2.getEnumType(FileOptions_OptimizeMode), opt: !0, default: FileOptions_OptimizeMode.SPEED },
  { no: 11, name: "go_package", kind: "scalar", T: 9, opt: !0 },
  { no: 16, name: "cc_generic_services", kind: "scalar", T: 8, opt: !0, default: !1 },
  { no: 17, name: "java_generic_services", kind: "scalar", T: 8, opt: !0, default: !1 },
  { no: 18, name: "py_generic_services", kind: "scalar", T: 8, opt: !0, default: !1 },
  { no: 23, name: "deprecated", kind: "scalar", T: 8, opt: !0, default: !1 },
  { no: 31, name: "cc_enable_arenas", kind: "scalar", T: 8, opt: !0, default: !0 },
  { no: 36, name: "objc_class_prefix", kind: "scalar", T: 9, opt: !0 },
  { no: 37, name: "csharp_namespace", kind: "scalar", T: 9, opt: !0 },
  { no: 39, name: "swift_prefix", kind: "scalar", T: 9, opt: !0 },
  { no: 40, name: "php_class_prefix", kind: "scalar", T: 9, opt: !0 },
  { no: 41, name: "php_namespace", kind: "scalar", T: 9, opt: !0 },
  { no: 44, name: "php_metadata_namespace", kind: "scalar", T: 9, opt: !0 },
  { no: 45, name: "ruby_package", kind: "scalar", T: 9, opt: !0 },
  { no: 50, name: "features", kind: "message", T: FeatureSet, opt: !0 },
  { no: 999, name: "uninterpreted_option", kind: "message", T: UninterpretedOption, repeated: !0 }
]);
var FileOptions_OptimizeMode;
(function(n) {
  n[n.SPEED = 1] = "SPEED", n[n.CODE_SIZE = 2] = "CODE_SIZE", n[n.LITE_RUNTIME = 3] = "LITE_RUNTIME";
})(FileOptions_OptimizeMode || (descriptor_pb.FileOptions_OptimizeMode = FileOptions_OptimizeMode = {}));
proto2_js_1$2.proto2.util.setEnumType(FileOptions_OptimizeMode, "google.protobuf.FileOptions.OptimizeMode", [
  { no: 1, name: "SPEED" },
  { no: 2, name: "CODE_SIZE" },
  { no: 3, name: "LITE_RUNTIME" }
]);
class MessageOptions extends message_js_1$b.Message {
  constructor(c) {
    super(), this.uninterpretedOption = [], proto2_js_1$2.proto2.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new MessageOptions().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new MessageOptions().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new MessageOptions().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto2_js_1$2.proto2.util.equals(MessageOptions, c, u);
  }
}
descriptor_pb.MessageOptions = MessageOptions;
MessageOptions.runtime = proto2_js_1$2.proto2;
MessageOptions.typeName = "google.protobuf.MessageOptions";
MessageOptions.fields = proto2_js_1$2.proto2.util.newFieldList(() => [
  { no: 1, name: "message_set_wire_format", kind: "scalar", T: 8, opt: !0, default: !1 },
  { no: 2, name: "no_standard_descriptor_accessor", kind: "scalar", T: 8, opt: !0, default: !1 },
  { no: 3, name: "deprecated", kind: "scalar", T: 8, opt: !0, default: !1 },
  { no: 7, name: "map_entry", kind: "scalar", T: 8, opt: !0 },
  { no: 11, name: "deprecated_legacy_json_field_conflicts", kind: "scalar", T: 8, opt: !0 },
  { no: 12, name: "features", kind: "message", T: FeatureSet, opt: !0 },
  { no: 999, name: "uninterpreted_option", kind: "message", T: UninterpretedOption, repeated: !0 }
]);
class FieldOptions extends message_js_1$b.Message {
  constructor(c) {
    super(), this.targets = [], this.editionDefaults = [], this.uninterpretedOption = [], proto2_js_1$2.proto2.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new FieldOptions().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new FieldOptions().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new FieldOptions().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto2_js_1$2.proto2.util.equals(FieldOptions, c, u);
  }
}
descriptor_pb.FieldOptions = FieldOptions;
FieldOptions.runtime = proto2_js_1$2.proto2;
FieldOptions.typeName = "google.protobuf.FieldOptions";
FieldOptions.fields = proto2_js_1$2.proto2.util.newFieldList(() => [
  { no: 1, name: "ctype", kind: "enum", T: proto2_js_1$2.proto2.getEnumType(FieldOptions_CType), opt: !0, default: FieldOptions_CType.STRING },
  { no: 2, name: "packed", kind: "scalar", T: 8, opt: !0 },
  { no: 6, name: "jstype", kind: "enum", T: proto2_js_1$2.proto2.getEnumType(FieldOptions_JSType), opt: !0, default: FieldOptions_JSType.JS_NORMAL },
  { no: 5, name: "lazy", kind: "scalar", T: 8, opt: !0, default: !1 },
  { no: 15, name: "unverified_lazy", kind: "scalar", T: 8, opt: !0, default: !1 },
  { no: 3, name: "deprecated", kind: "scalar", T: 8, opt: !0, default: !1 },
  { no: 10, name: "weak", kind: "scalar", T: 8, opt: !0, default: !1 },
  { no: 16, name: "debug_redact", kind: "scalar", T: 8, opt: !0, default: !1 },
  { no: 17, name: "retention", kind: "enum", T: proto2_js_1$2.proto2.getEnumType(FieldOptions_OptionRetention), opt: !0 },
  { no: 19, name: "targets", kind: "enum", T: proto2_js_1$2.proto2.getEnumType(FieldOptions_OptionTargetType), repeated: !0 },
  { no: 20, name: "edition_defaults", kind: "message", T: FieldOptions_EditionDefault, repeated: !0 },
  { no: 21, name: "features", kind: "message", T: FeatureSet, opt: !0 },
  { no: 22, name: "feature_support", kind: "message", T: FieldOptions_FeatureSupport, opt: !0 },
  { no: 999, name: "uninterpreted_option", kind: "message", T: UninterpretedOption, repeated: !0 }
]);
var FieldOptions_CType;
(function(n) {
  n[n.STRING = 0] = "STRING", n[n.CORD = 1] = "CORD", n[n.STRING_PIECE = 2] = "STRING_PIECE";
})(FieldOptions_CType || (descriptor_pb.FieldOptions_CType = FieldOptions_CType = {}));
proto2_js_1$2.proto2.util.setEnumType(FieldOptions_CType, "google.protobuf.FieldOptions.CType", [
  { no: 0, name: "STRING" },
  { no: 1, name: "CORD" },
  { no: 2, name: "STRING_PIECE" }
]);
var FieldOptions_JSType;
(function(n) {
  n[n.JS_NORMAL = 0] = "JS_NORMAL", n[n.JS_STRING = 1] = "JS_STRING", n[n.JS_NUMBER = 2] = "JS_NUMBER";
})(FieldOptions_JSType || (descriptor_pb.FieldOptions_JSType = FieldOptions_JSType = {}));
proto2_js_1$2.proto2.util.setEnumType(FieldOptions_JSType, "google.protobuf.FieldOptions.JSType", [
  { no: 0, name: "JS_NORMAL" },
  { no: 1, name: "JS_STRING" },
  { no: 2, name: "JS_NUMBER" }
]);
var FieldOptions_OptionRetention;
(function(n) {
  n[n.RETENTION_UNKNOWN = 0] = "RETENTION_UNKNOWN", n[n.RETENTION_RUNTIME = 1] = "RETENTION_RUNTIME", n[n.RETENTION_SOURCE = 2] = "RETENTION_SOURCE";
})(FieldOptions_OptionRetention || (descriptor_pb.FieldOptions_OptionRetention = FieldOptions_OptionRetention = {}));
proto2_js_1$2.proto2.util.setEnumType(FieldOptions_OptionRetention, "google.protobuf.FieldOptions.OptionRetention", [
  { no: 0, name: "RETENTION_UNKNOWN" },
  { no: 1, name: "RETENTION_RUNTIME" },
  { no: 2, name: "RETENTION_SOURCE" }
]);
var FieldOptions_OptionTargetType;
(function(n) {
  n[n.TARGET_TYPE_UNKNOWN = 0] = "TARGET_TYPE_UNKNOWN", n[n.TARGET_TYPE_FILE = 1] = "TARGET_TYPE_FILE", n[n.TARGET_TYPE_EXTENSION_RANGE = 2] = "TARGET_TYPE_EXTENSION_RANGE", n[n.TARGET_TYPE_MESSAGE = 3] = "TARGET_TYPE_MESSAGE", n[n.TARGET_TYPE_FIELD = 4] = "TARGET_TYPE_FIELD", n[n.TARGET_TYPE_ONEOF = 5] = "TARGET_TYPE_ONEOF", n[n.TARGET_TYPE_ENUM = 6] = "TARGET_TYPE_ENUM", n[n.TARGET_TYPE_ENUM_ENTRY = 7] = "TARGET_TYPE_ENUM_ENTRY", n[n.TARGET_TYPE_SERVICE = 8] = "TARGET_TYPE_SERVICE", n[n.TARGET_TYPE_METHOD = 9] = "TARGET_TYPE_METHOD";
})(FieldOptions_OptionTargetType || (descriptor_pb.FieldOptions_OptionTargetType = FieldOptions_OptionTargetType = {}));
proto2_js_1$2.proto2.util.setEnumType(FieldOptions_OptionTargetType, "google.protobuf.FieldOptions.OptionTargetType", [
  { no: 0, name: "TARGET_TYPE_UNKNOWN" },
  { no: 1, name: "TARGET_TYPE_FILE" },
  { no: 2, name: "TARGET_TYPE_EXTENSION_RANGE" },
  { no: 3, name: "TARGET_TYPE_MESSAGE" },
  { no: 4, name: "TARGET_TYPE_FIELD" },
  { no: 5, name: "TARGET_TYPE_ONEOF" },
  { no: 6, name: "TARGET_TYPE_ENUM" },
  { no: 7, name: "TARGET_TYPE_ENUM_ENTRY" },
  { no: 8, name: "TARGET_TYPE_SERVICE" },
  { no: 9, name: "TARGET_TYPE_METHOD" }
]);
class FieldOptions_EditionDefault extends message_js_1$b.Message {
  constructor(c) {
    super(), proto2_js_1$2.proto2.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new FieldOptions_EditionDefault().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new FieldOptions_EditionDefault().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new FieldOptions_EditionDefault().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto2_js_1$2.proto2.util.equals(FieldOptions_EditionDefault, c, u);
  }
}
descriptor_pb.FieldOptions_EditionDefault = FieldOptions_EditionDefault;
FieldOptions_EditionDefault.runtime = proto2_js_1$2.proto2;
FieldOptions_EditionDefault.typeName = "google.protobuf.FieldOptions.EditionDefault";
FieldOptions_EditionDefault.fields = proto2_js_1$2.proto2.util.newFieldList(() => [
  { no: 3, name: "edition", kind: "enum", T: proto2_js_1$2.proto2.getEnumType(Edition), opt: !0 },
  { no: 2, name: "value", kind: "scalar", T: 9, opt: !0 }
]);
class FieldOptions_FeatureSupport extends message_js_1$b.Message {
  constructor(c) {
    super(), proto2_js_1$2.proto2.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new FieldOptions_FeatureSupport().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new FieldOptions_FeatureSupport().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new FieldOptions_FeatureSupport().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto2_js_1$2.proto2.util.equals(FieldOptions_FeatureSupport, c, u);
  }
}
descriptor_pb.FieldOptions_FeatureSupport = FieldOptions_FeatureSupport;
FieldOptions_FeatureSupport.runtime = proto2_js_1$2.proto2;
FieldOptions_FeatureSupport.typeName = "google.protobuf.FieldOptions.FeatureSupport";
FieldOptions_FeatureSupport.fields = proto2_js_1$2.proto2.util.newFieldList(() => [
  { no: 1, name: "edition_introduced", kind: "enum", T: proto2_js_1$2.proto2.getEnumType(Edition), opt: !0 },
  { no: 2, name: "edition_deprecated", kind: "enum", T: proto2_js_1$2.proto2.getEnumType(Edition), opt: !0 },
  { no: 3, name: "deprecation_warning", kind: "scalar", T: 9, opt: !0 },
  { no: 4, name: "edition_removed", kind: "enum", T: proto2_js_1$2.proto2.getEnumType(Edition), opt: !0 }
]);
class OneofOptions extends message_js_1$b.Message {
  constructor(c) {
    super(), this.uninterpretedOption = [], proto2_js_1$2.proto2.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new OneofOptions().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new OneofOptions().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new OneofOptions().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto2_js_1$2.proto2.util.equals(OneofOptions, c, u);
  }
}
descriptor_pb.OneofOptions = OneofOptions;
OneofOptions.runtime = proto2_js_1$2.proto2;
OneofOptions.typeName = "google.protobuf.OneofOptions";
OneofOptions.fields = proto2_js_1$2.proto2.util.newFieldList(() => [
  { no: 1, name: "features", kind: "message", T: FeatureSet, opt: !0 },
  { no: 999, name: "uninterpreted_option", kind: "message", T: UninterpretedOption, repeated: !0 }
]);
class EnumOptions extends message_js_1$b.Message {
  constructor(c) {
    super(), this.uninterpretedOption = [], proto2_js_1$2.proto2.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new EnumOptions().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new EnumOptions().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new EnumOptions().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto2_js_1$2.proto2.util.equals(EnumOptions, c, u);
  }
}
descriptor_pb.EnumOptions = EnumOptions;
EnumOptions.runtime = proto2_js_1$2.proto2;
EnumOptions.typeName = "google.protobuf.EnumOptions";
EnumOptions.fields = proto2_js_1$2.proto2.util.newFieldList(() => [
  { no: 2, name: "allow_alias", kind: "scalar", T: 8, opt: !0 },
  { no: 3, name: "deprecated", kind: "scalar", T: 8, opt: !0, default: !1 },
  { no: 6, name: "deprecated_legacy_json_field_conflicts", kind: "scalar", T: 8, opt: !0 },
  { no: 7, name: "features", kind: "message", T: FeatureSet, opt: !0 },
  { no: 999, name: "uninterpreted_option", kind: "message", T: UninterpretedOption, repeated: !0 }
]);
class EnumValueOptions extends message_js_1$b.Message {
  constructor(c) {
    super(), this.uninterpretedOption = [], proto2_js_1$2.proto2.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new EnumValueOptions().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new EnumValueOptions().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new EnumValueOptions().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto2_js_1$2.proto2.util.equals(EnumValueOptions, c, u);
  }
}
descriptor_pb.EnumValueOptions = EnumValueOptions;
EnumValueOptions.runtime = proto2_js_1$2.proto2;
EnumValueOptions.typeName = "google.protobuf.EnumValueOptions";
EnumValueOptions.fields = proto2_js_1$2.proto2.util.newFieldList(() => [
  { no: 1, name: "deprecated", kind: "scalar", T: 8, opt: !0, default: !1 },
  { no: 2, name: "features", kind: "message", T: FeatureSet, opt: !0 },
  { no: 3, name: "debug_redact", kind: "scalar", T: 8, opt: !0, default: !1 },
  { no: 4, name: "feature_support", kind: "message", T: FieldOptions_FeatureSupport, opt: !0 },
  { no: 999, name: "uninterpreted_option", kind: "message", T: UninterpretedOption, repeated: !0 }
]);
class ServiceOptions extends message_js_1$b.Message {
  constructor(c) {
    super(), this.uninterpretedOption = [], proto2_js_1$2.proto2.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new ServiceOptions().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new ServiceOptions().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new ServiceOptions().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto2_js_1$2.proto2.util.equals(ServiceOptions, c, u);
  }
}
descriptor_pb.ServiceOptions = ServiceOptions;
ServiceOptions.runtime = proto2_js_1$2.proto2;
ServiceOptions.typeName = "google.protobuf.ServiceOptions";
ServiceOptions.fields = proto2_js_1$2.proto2.util.newFieldList(() => [
  { no: 34, name: "features", kind: "message", T: FeatureSet, opt: !0 },
  { no: 33, name: "deprecated", kind: "scalar", T: 8, opt: !0, default: !1 },
  { no: 999, name: "uninterpreted_option", kind: "message", T: UninterpretedOption, repeated: !0 }
]);
class MethodOptions extends message_js_1$b.Message {
  constructor(c) {
    super(), this.uninterpretedOption = [], proto2_js_1$2.proto2.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new MethodOptions().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new MethodOptions().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new MethodOptions().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto2_js_1$2.proto2.util.equals(MethodOptions, c, u);
  }
}
descriptor_pb.MethodOptions = MethodOptions;
MethodOptions.runtime = proto2_js_1$2.proto2;
MethodOptions.typeName = "google.protobuf.MethodOptions";
MethodOptions.fields = proto2_js_1$2.proto2.util.newFieldList(() => [
  { no: 33, name: "deprecated", kind: "scalar", T: 8, opt: !0, default: !1 },
  { no: 34, name: "idempotency_level", kind: "enum", T: proto2_js_1$2.proto2.getEnumType(MethodOptions_IdempotencyLevel), opt: !0, default: MethodOptions_IdempotencyLevel.IDEMPOTENCY_UNKNOWN },
  { no: 35, name: "features", kind: "message", T: FeatureSet, opt: !0 },
  { no: 999, name: "uninterpreted_option", kind: "message", T: UninterpretedOption, repeated: !0 }
]);
var MethodOptions_IdempotencyLevel;
(function(n) {
  n[n.IDEMPOTENCY_UNKNOWN = 0] = "IDEMPOTENCY_UNKNOWN", n[n.NO_SIDE_EFFECTS = 1] = "NO_SIDE_EFFECTS", n[n.IDEMPOTENT = 2] = "IDEMPOTENT";
})(MethodOptions_IdempotencyLevel || (descriptor_pb.MethodOptions_IdempotencyLevel = MethodOptions_IdempotencyLevel = {}));
proto2_js_1$2.proto2.util.setEnumType(MethodOptions_IdempotencyLevel, "google.protobuf.MethodOptions.IdempotencyLevel", [
  { no: 0, name: "IDEMPOTENCY_UNKNOWN" },
  { no: 1, name: "NO_SIDE_EFFECTS" },
  { no: 2, name: "IDEMPOTENT" }
]);
class UninterpretedOption extends message_js_1$b.Message {
  constructor(c) {
    super(), this.name = [], proto2_js_1$2.proto2.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new UninterpretedOption().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new UninterpretedOption().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new UninterpretedOption().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto2_js_1$2.proto2.util.equals(UninterpretedOption, c, u);
  }
}
descriptor_pb.UninterpretedOption = UninterpretedOption;
UninterpretedOption.runtime = proto2_js_1$2.proto2;
UninterpretedOption.typeName = "google.protobuf.UninterpretedOption";
UninterpretedOption.fields = proto2_js_1$2.proto2.util.newFieldList(() => [
  { no: 2, name: "name", kind: "message", T: UninterpretedOption_NamePart, repeated: !0 },
  { no: 3, name: "identifier_value", kind: "scalar", T: 9, opt: !0 },
  { no: 4, name: "positive_int_value", kind: "scalar", T: 4, opt: !0 },
  { no: 5, name: "negative_int_value", kind: "scalar", T: 3, opt: !0 },
  { no: 6, name: "double_value", kind: "scalar", T: 1, opt: !0 },
  { no: 7, name: "string_value", kind: "scalar", T: 12, opt: !0 },
  { no: 8, name: "aggregate_value", kind: "scalar", T: 9, opt: !0 }
]);
class UninterpretedOption_NamePart extends message_js_1$b.Message {
  constructor(c) {
    super(), proto2_js_1$2.proto2.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new UninterpretedOption_NamePart().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new UninterpretedOption_NamePart().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new UninterpretedOption_NamePart().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto2_js_1$2.proto2.util.equals(UninterpretedOption_NamePart, c, u);
  }
}
descriptor_pb.UninterpretedOption_NamePart = UninterpretedOption_NamePart;
UninterpretedOption_NamePart.runtime = proto2_js_1$2.proto2;
UninterpretedOption_NamePart.typeName = "google.protobuf.UninterpretedOption.NamePart";
UninterpretedOption_NamePart.fields = proto2_js_1$2.proto2.util.newFieldList(() => [
  { no: 1, name: "name_part", kind: "scalar", T: 9, req: !0 },
  { no: 2, name: "is_extension", kind: "scalar", T: 8, req: !0 }
]);
class FeatureSet extends message_js_1$b.Message {
  constructor(c) {
    super(), proto2_js_1$2.proto2.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new FeatureSet().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new FeatureSet().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new FeatureSet().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto2_js_1$2.proto2.util.equals(FeatureSet, c, u);
  }
}
descriptor_pb.FeatureSet = FeatureSet;
FeatureSet.runtime = proto2_js_1$2.proto2;
FeatureSet.typeName = "google.protobuf.FeatureSet";
FeatureSet.fields = proto2_js_1$2.proto2.util.newFieldList(() => [
  { no: 1, name: "field_presence", kind: "enum", T: proto2_js_1$2.proto2.getEnumType(FeatureSet_FieldPresence), opt: !0 },
  { no: 2, name: "enum_type", kind: "enum", T: proto2_js_1$2.proto2.getEnumType(FeatureSet_EnumType), opt: !0 },
  { no: 3, name: "repeated_field_encoding", kind: "enum", T: proto2_js_1$2.proto2.getEnumType(FeatureSet_RepeatedFieldEncoding), opt: !0 },
  { no: 4, name: "utf8_validation", kind: "enum", T: proto2_js_1$2.proto2.getEnumType(FeatureSet_Utf8Validation), opt: !0 },
  { no: 5, name: "message_encoding", kind: "enum", T: proto2_js_1$2.proto2.getEnumType(FeatureSet_MessageEncoding), opt: !0 },
  { no: 6, name: "json_format", kind: "enum", T: proto2_js_1$2.proto2.getEnumType(FeatureSet_JsonFormat), opt: !0 }
]);
var FeatureSet_FieldPresence;
(function(n) {
  n[n.FIELD_PRESENCE_UNKNOWN = 0] = "FIELD_PRESENCE_UNKNOWN", n[n.EXPLICIT = 1] = "EXPLICIT", n[n.IMPLICIT = 2] = "IMPLICIT", n[n.LEGACY_REQUIRED = 3] = "LEGACY_REQUIRED";
})(FeatureSet_FieldPresence || (descriptor_pb.FeatureSet_FieldPresence = FeatureSet_FieldPresence = {}));
proto2_js_1$2.proto2.util.setEnumType(FeatureSet_FieldPresence, "google.protobuf.FeatureSet.FieldPresence", [
  { no: 0, name: "FIELD_PRESENCE_UNKNOWN" },
  { no: 1, name: "EXPLICIT" },
  { no: 2, name: "IMPLICIT" },
  { no: 3, name: "LEGACY_REQUIRED" }
]);
var FeatureSet_EnumType;
(function(n) {
  n[n.ENUM_TYPE_UNKNOWN = 0] = "ENUM_TYPE_UNKNOWN", n[n.OPEN = 1] = "OPEN", n[n.CLOSED = 2] = "CLOSED";
})(FeatureSet_EnumType || (descriptor_pb.FeatureSet_EnumType = FeatureSet_EnumType = {}));
proto2_js_1$2.proto2.util.setEnumType(FeatureSet_EnumType, "google.protobuf.FeatureSet.EnumType", [
  { no: 0, name: "ENUM_TYPE_UNKNOWN" },
  { no: 1, name: "OPEN" },
  { no: 2, name: "CLOSED" }
]);
var FeatureSet_RepeatedFieldEncoding;
(function(n) {
  n[n.REPEATED_FIELD_ENCODING_UNKNOWN = 0] = "REPEATED_FIELD_ENCODING_UNKNOWN", n[n.PACKED = 1] = "PACKED", n[n.EXPANDED = 2] = "EXPANDED";
})(FeatureSet_RepeatedFieldEncoding || (descriptor_pb.FeatureSet_RepeatedFieldEncoding = FeatureSet_RepeatedFieldEncoding = {}));
proto2_js_1$2.proto2.util.setEnumType(FeatureSet_RepeatedFieldEncoding, "google.protobuf.FeatureSet.RepeatedFieldEncoding", [
  { no: 0, name: "REPEATED_FIELD_ENCODING_UNKNOWN" },
  { no: 1, name: "PACKED" },
  { no: 2, name: "EXPANDED" }
]);
var FeatureSet_Utf8Validation;
(function(n) {
  n[n.UTF8_VALIDATION_UNKNOWN = 0] = "UTF8_VALIDATION_UNKNOWN", n[n.VERIFY = 2] = "VERIFY", n[n.NONE = 3] = "NONE";
})(FeatureSet_Utf8Validation || (descriptor_pb.FeatureSet_Utf8Validation = FeatureSet_Utf8Validation = {}));
proto2_js_1$2.proto2.util.setEnumType(FeatureSet_Utf8Validation, "google.protobuf.FeatureSet.Utf8Validation", [
  { no: 0, name: "UTF8_VALIDATION_UNKNOWN" },
  { no: 2, name: "VERIFY" },
  { no: 3, name: "NONE" }
]);
var FeatureSet_MessageEncoding;
(function(n) {
  n[n.MESSAGE_ENCODING_UNKNOWN = 0] = "MESSAGE_ENCODING_UNKNOWN", n[n.LENGTH_PREFIXED = 1] = "LENGTH_PREFIXED", n[n.DELIMITED = 2] = "DELIMITED";
})(FeatureSet_MessageEncoding || (descriptor_pb.FeatureSet_MessageEncoding = FeatureSet_MessageEncoding = {}));
proto2_js_1$2.proto2.util.setEnumType(FeatureSet_MessageEncoding, "google.protobuf.FeatureSet.MessageEncoding", [
  { no: 0, name: "MESSAGE_ENCODING_UNKNOWN" },
  { no: 1, name: "LENGTH_PREFIXED" },
  { no: 2, name: "DELIMITED" }
]);
var FeatureSet_JsonFormat;
(function(n) {
  n[n.JSON_FORMAT_UNKNOWN = 0] = "JSON_FORMAT_UNKNOWN", n[n.ALLOW = 1] = "ALLOW", n[n.LEGACY_BEST_EFFORT = 2] = "LEGACY_BEST_EFFORT";
})(FeatureSet_JsonFormat || (descriptor_pb.FeatureSet_JsonFormat = FeatureSet_JsonFormat = {}));
proto2_js_1$2.proto2.util.setEnumType(FeatureSet_JsonFormat, "google.protobuf.FeatureSet.JsonFormat", [
  { no: 0, name: "JSON_FORMAT_UNKNOWN" },
  { no: 1, name: "ALLOW" },
  { no: 2, name: "LEGACY_BEST_EFFORT" }
]);
class FeatureSetDefaults extends message_js_1$b.Message {
  constructor(c) {
    super(), this.defaults = [], proto2_js_1$2.proto2.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new FeatureSetDefaults().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new FeatureSetDefaults().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new FeatureSetDefaults().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto2_js_1$2.proto2.util.equals(FeatureSetDefaults, c, u);
  }
}
descriptor_pb.FeatureSetDefaults = FeatureSetDefaults;
FeatureSetDefaults.runtime = proto2_js_1$2.proto2;
FeatureSetDefaults.typeName = "google.protobuf.FeatureSetDefaults";
FeatureSetDefaults.fields = proto2_js_1$2.proto2.util.newFieldList(() => [
  { no: 1, name: "defaults", kind: "message", T: FeatureSetDefaults_FeatureSetEditionDefault, repeated: !0 },
  { no: 4, name: "minimum_edition", kind: "enum", T: proto2_js_1$2.proto2.getEnumType(Edition), opt: !0 },
  { no: 5, name: "maximum_edition", kind: "enum", T: proto2_js_1$2.proto2.getEnumType(Edition), opt: !0 }
]);
class FeatureSetDefaults_FeatureSetEditionDefault extends message_js_1$b.Message {
  constructor(c) {
    super(), proto2_js_1$2.proto2.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new FeatureSetDefaults_FeatureSetEditionDefault().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new FeatureSetDefaults_FeatureSetEditionDefault().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new FeatureSetDefaults_FeatureSetEditionDefault().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto2_js_1$2.proto2.util.equals(FeatureSetDefaults_FeatureSetEditionDefault, c, u);
  }
}
descriptor_pb.FeatureSetDefaults_FeatureSetEditionDefault = FeatureSetDefaults_FeatureSetEditionDefault;
FeatureSetDefaults_FeatureSetEditionDefault.runtime = proto2_js_1$2.proto2;
FeatureSetDefaults_FeatureSetEditionDefault.typeName = "google.protobuf.FeatureSetDefaults.FeatureSetEditionDefault";
FeatureSetDefaults_FeatureSetEditionDefault.fields = proto2_js_1$2.proto2.util.newFieldList(() => [
  { no: 3, name: "edition", kind: "enum", T: proto2_js_1$2.proto2.getEnumType(Edition), opt: !0 },
  { no: 4, name: "overridable_features", kind: "message", T: FeatureSet, opt: !0 },
  { no: 5, name: "fixed_features", kind: "message", T: FeatureSet, opt: !0 }
]);
class SourceCodeInfo extends message_js_1$b.Message {
  constructor(c) {
    super(), this.location = [], proto2_js_1$2.proto2.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new SourceCodeInfo().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new SourceCodeInfo().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new SourceCodeInfo().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto2_js_1$2.proto2.util.equals(SourceCodeInfo, c, u);
  }
}
descriptor_pb.SourceCodeInfo = SourceCodeInfo;
SourceCodeInfo.runtime = proto2_js_1$2.proto2;
SourceCodeInfo.typeName = "google.protobuf.SourceCodeInfo";
SourceCodeInfo.fields = proto2_js_1$2.proto2.util.newFieldList(() => [
  { no: 1, name: "location", kind: "message", T: SourceCodeInfo_Location, repeated: !0 }
]);
class SourceCodeInfo_Location extends message_js_1$b.Message {
  constructor(c) {
    super(), this.path = [], this.span = [], this.leadingDetachedComments = [], proto2_js_1$2.proto2.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new SourceCodeInfo_Location().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new SourceCodeInfo_Location().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new SourceCodeInfo_Location().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto2_js_1$2.proto2.util.equals(SourceCodeInfo_Location, c, u);
  }
}
descriptor_pb.SourceCodeInfo_Location = SourceCodeInfo_Location;
SourceCodeInfo_Location.runtime = proto2_js_1$2.proto2;
SourceCodeInfo_Location.typeName = "google.protobuf.SourceCodeInfo.Location";
SourceCodeInfo_Location.fields = proto2_js_1$2.proto2.util.newFieldList(() => [
  { no: 1, name: "path", kind: "scalar", T: 5, repeated: !0, packed: !0 },
  { no: 2, name: "span", kind: "scalar", T: 5, repeated: !0, packed: !0 },
  { no: 3, name: "leading_comments", kind: "scalar", T: 9, opt: !0 },
  { no: 4, name: "trailing_comments", kind: "scalar", T: 9, opt: !0 },
  { no: 6, name: "leading_detached_comments", kind: "scalar", T: 9, repeated: !0 }
]);
class GeneratedCodeInfo extends message_js_1$b.Message {
  constructor(c) {
    super(), this.annotation = [], proto2_js_1$2.proto2.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new GeneratedCodeInfo().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new GeneratedCodeInfo().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new GeneratedCodeInfo().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto2_js_1$2.proto2.util.equals(GeneratedCodeInfo, c, u);
  }
}
descriptor_pb.GeneratedCodeInfo = GeneratedCodeInfo;
GeneratedCodeInfo.runtime = proto2_js_1$2.proto2;
GeneratedCodeInfo.typeName = "google.protobuf.GeneratedCodeInfo";
GeneratedCodeInfo.fields = proto2_js_1$2.proto2.util.newFieldList(() => [
  { no: 1, name: "annotation", kind: "message", T: GeneratedCodeInfo_Annotation, repeated: !0 }
]);
class GeneratedCodeInfo_Annotation extends message_js_1$b.Message {
  constructor(c) {
    super(), this.path = [], proto2_js_1$2.proto2.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new GeneratedCodeInfo_Annotation().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new GeneratedCodeInfo_Annotation().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new GeneratedCodeInfo_Annotation().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto2_js_1$2.proto2.util.equals(GeneratedCodeInfo_Annotation, c, u);
  }
}
descriptor_pb.GeneratedCodeInfo_Annotation = GeneratedCodeInfo_Annotation;
GeneratedCodeInfo_Annotation.runtime = proto2_js_1$2.proto2;
GeneratedCodeInfo_Annotation.typeName = "google.protobuf.GeneratedCodeInfo.Annotation";
GeneratedCodeInfo_Annotation.fields = proto2_js_1$2.proto2.util.newFieldList(() => [
  { no: 1, name: "path", kind: "scalar", T: 5, repeated: !0, packed: !0 },
  { no: 2, name: "source_file", kind: "scalar", T: 9, opt: !0 },
  { no: 3, name: "begin", kind: "scalar", T: 5, opt: !0 },
  { no: 4, name: "end", kind: "scalar", T: 5, opt: !0 },
  { no: 5, name: "semantic", kind: "enum", T: proto2_js_1$2.proto2.getEnumType(GeneratedCodeInfo_Annotation_Semantic), opt: !0 }
]);
var GeneratedCodeInfo_Annotation_Semantic;
(function(n) {
  n[n.NONE = 0] = "NONE", n[n.SET = 1] = "SET", n[n.ALIAS = 2] = "ALIAS";
})(GeneratedCodeInfo_Annotation_Semantic || (descriptor_pb.GeneratedCodeInfo_Annotation_Semantic = GeneratedCodeInfo_Annotation_Semantic = {}));
proto2_js_1$2.proto2.util.setEnumType(GeneratedCodeInfo_Annotation_Semantic, "google.protobuf.GeneratedCodeInfo.Annotation.Semantic", [
  { no: 0, name: "NONE" },
  { no: 1, name: "SET" },
  { no: 2, name: "ALIAS" }
]);
var textFormat = {};
Object.defineProperty(textFormat, "__esModule", { value: !0 });
textFormat.parseTextFormatScalarValue = textFormat.parseTextFormatEnumValue = void 0;
const assert_js_1$2 = assert$d, proto_int64_js_1$3 = protoInt64, scalar_js_1$2 = scalar;
function parseTextFormatEnumValue(n, c) {
  const u = n.values.find((p) => p.name === c);
  return (0, assert_js_1$2.assert)(u, `cannot parse ${n.name} default value: ${c}`), u.number;
}
textFormat.parseTextFormatEnumValue = parseTextFormatEnumValue;
function parseTextFormatScalarValue(n, c) {
  switch (n) {
    case scalar_js_1$2.ScalarType.STRING:
      return c;
    case scalar_js_1$2.ScalarType.BYTES: {
      const u = unescapeBytesDefaultValue(c);
      if (u === !1)
        throw new Error(`cannot parse ${scalar_js_1$2.ScalarType[n]} default value: ${c}`);
      return u;
    }
    case scalar_js_1$2.ScalarType.INT64:
    case scalar_js_1$2.ScalarType.SFIXED64:
    case scalar_js_1$2.ScalarType.SINT64:
      return proto_int64_js_1$3.protoInt64.parse(c);
    case scalar_js_1$2.ScalarType.UINT64:
    case scalar_js_1$2.ScalarType.FIXED64:
      return proto_int64_js_1$3.protoInt64.uParse(c);
    case scalar_js_1$2.ScalarType.DOUBLE:
    case scalar_js_1$2.ScalarType.FLOAT:
      switch (c) {
        case "inf":
          return Number.POSITIVE_INFINITY;
        case "-inf":
          return Number.NEGATIVE_INFINITY;
        case "nan":
          return Number.NaN;
        default:
          return parseFloat(c);
      }
    case scalar_js_1$2.ScalarType.BOOL:
      return c === "true";
    case scalar_js_1$2.ScalarType.INT32:
    case scalar_js_1$2.ScalarType.UINT32:
    case scalar_js_1$2.ScalarType.SINT32:
    case scalar_js_1$2.ScalarType.FIXED32:
    case scalar_js_1$2.ScalarType.SFIXED32:
      return parseInt(c, 10);
  }
}
textFormat.parseTextFormatScalarValue = parseTextFormatScalarValue;
function unescapeBytesDefaultValue(n) {
  const c = [], u = {
    tail: n,
    c: "",
    next() {
      return this.tail.length == 0 ? !1 : (this.c = this.tail[0], this.tail = this.tail.substring(1), !0);
    },
    take(p) {
      if (this.tail.length >= p) {
        const a = this.tail.substring(0, p);
        return this.tail = this.tail.substring(p), a;
      }
      return !1;
    }
  };
  for (; u.next(); )
    switch (u.c) {
      case "\\":
        if (u.next())
          switch (u.c) {
            case "\\":
              c.push(u.c.charCodeAt(0));
              break;
            case "b":
              c.push(8);
              break;
            case "f":
              c.push(12);
              break;
            case "n":
              c.push(10);
              break;
            case "r":
              c.push(13);
              break;
            case "t":
              c.push(9);
              break;
            case "v":
              c.push(11);
              break;
            case "0":
            case "1":
            case "2":
            case "3":
            case "4":
            case "5":
            case "6":
            case "7": {
              const p = u.c, a = u.take(2);
              if (a === !1)
                return !1;
              const A = parseInt(p + a, 8);
              if (isNaN(A))
                return !1;
              c.push(A);
              break;
            }
            case "x": {
              const p = u.c, a = u.take(2);
              if (a === !1)
                return !1;
              const A = parseInt(p + a, 16);
              if (isNaN(A))
                return !1;
              c.push(A);
              break;
            }
            case "u": {
              const p = u.c, a = u.take(4);
              if (a === !1)
                return !1;
              const A = parseInt(p + a, 16);
              if (isNaN(A))
                return !1;
              const b = new Uint8Array(4);
              new DataView(b.buffer).setInt32(0, A, !0), c.push(b[0], b[1], b[2], b[3]);
              break;
            }
            case "U": {
              const p = u.c, a = u.take(8);
              if (a === !1)
                return !1;
              const A = proto_int64_js_1$3.protoInt64.uEnc(p + a), b = new Uint8Array(8), F = new DataView(b.buffer);
              F.setInt32(0, A.lo, !0), F.setInt32(4, A.hi, !0), c.push(b[0], b[1], b[2], b[3], b[4], b[5], b[6], b[7]);
              break;
            }
          }
        break;
      default:
        c.push(u.c.charCodeAt(0));
    }
  return new Uint8Array(c);
}
var featureSet = {};
Object.defineProperty(featureSet, "__esModule", { value: !0 });
featureSet.createFeatureResolver = void 0;
const descriptor_pb_js_1$3 = descriptor_pb, proto_base64_js_1 = protoBase64;
function getFeatureSetDefaults(n) {
  return descriptor_pb_js_1$3.FeatureSetDefaults.fromBinary(proto_base64_js_1.protoBase64.dec(
    /*upstream-inject-feature-defaults-start*/
    "ChMY5gciACoMCAEQAhgCIAMoATACChMY5wciACoMCAIQARgBIAIoATABChMY6AciDAgBEAEYASACKAEwASoAIOYHKOgH"
    /*upstream-inject-feature-defaults-end*/
  ), n);
}
function createFeatureResolver(n, c, u) {
  var p;
  const a = c ?? getFeatureSetDefaults(u), A = a.minimumEdition, b = a.maximumEdition;
  if (A === void 0 || b === void 0 || a.defaults.some((L) => L.edition === void 0))
    throw new Error("Invalid FeatureSetDefaults");
  if (n < A)
    throw new Error(`Edition ${descriptor_pb_js_1$3.Edition[n]} is earlier than the minimum supported edition ${descriptor_pb_js_1$3.Edition[A]}`);
  if (b < n)
    throw new Error(`Edition ${descriptor_pb_js_1$3.Edition[n]} is later than the maximum supported edition ${descriptor_pb_js_1$3.Edition[b]}`);
  let F;
  for (const L of a.defaults) {
    const pe = (p = L.edition) !== null && p !== void 0 ? p : 0;
    if (pe > n || F !== void 0 && F.e > pe)
      continue;
    let $;
    L.fixedFeatures && L.overridableFeatures ? ($ = L.fixedFeatures, $.fromBinary(L.overridableFeatures.toBinary())) : L.fixedFeatures ? $ = L.fixedFeatures : L.overridableFeatures ? $ = L.overridableFeatures : $ = new descriptor_pb_js_1$3.FeatureSet(), F = {
      e: pe,
      f: $
    };
  }
  if (F === void 0)
    throw new Error(`No valid default found for edition ${descriptor_pb_js_1$3.Edition[n]}`);
  const le = F.f.toBinary(u);
  return (...L) => {
    const pe = descriptor_pb_js_1$3.FeatureSet.fromBinary(le, u);
    for (const $ of L)
      $ !== void 0 && pe.fromBinary($.toBinary(u), u);
    if (!validateMergedFeatures(pe))
      throw new Error(`Invalid FeatureSet for edition ${descriptor_pb_js_1$3.Edition[n]}`);
    return pe;
  };
}
featureSet.createFeatureResolver = createFeatureResolver;
function validateMergedFeatures(n) {
  for (const c of descriptor_pb_js_1$3.FeatureSet.fields.list()) {
    const u = n[c.localName];
    if (u === void 0 || c.kind == "enum" && u === 0)
      return !1;
  }
  return !0;
}
Object.defineProperty(createDescriptorSet$1, "__esModule", { value: !0 });
createDescriptorSet$1.createDescriptorSet = void 0;
const descriptor_pb_js_1$2 = descriptor_pb, assert_js_1$1 = assert$d, service_type_js_1 = serviceType, names_js_1$1 = names, text_format_js_1 = textFormat, feature_set_js_1 = featureSet, scalar_js_1$1 = scalar, is_message_js_1$2 = isMessage$1;
function createDescriptorSet(n, c) {
  var u;
  const p = {
    files: [],
    enums: /* @__PURE__ */ new Map(),
    messages: /* @__PURE__ */ new Map(),
    services: /* @__PURE__ */ new Map(),
    extensions: /* @__PURE__ */ new Map(),
    mapEntries: /* @__PURE__ */ new Map()
  }, a = (0, is_message_js_1$2.isMessage)(n, descriptor_pb_js_1$2.FileDescriptorSet) ? n.file : n instanceof Uint8Array ? descriptor_pb_js_1$2.FileDescriptorSet.fromBinary(n).file : n, A = /* @__PURE__ */ new Map();
  for (const b of a) {
    const F = (u = b.edition) !== null && u !== void 0 ? u : parseFileSyntax(b.syntax, b.edition).edition;
    let le = A.get(F);
    le === void 0 && (le = (0, feature_set_js_1.createFeatureResolver)(F, c == null ? void 0 : c.featureSetDefaults, c == null ? void 0 : c.serializationOptions), A.set(F, le)), addFile(b, p, le);
  }
  return p;
}
createDescriptorSet$1.createDescriptorSet = createDescriptorSet;
function addFile(n, c, u) {
  var p, a;
  (0, assert_js_1$1.assert)(n.name, "invalid FileDescriptorProto: missing name");
  const A = Object.assign(Object.assign({ kind: "file", proto: n, deprecated: (a = (p = n.options) === null || p === void 0 ? void 0 : p.deprecated) !== null && a !== void 0 ? a : !1 }, parseFileSyntax(n.syntax, n.edition)), {
    name: n.name.replace(/\.proto/, ""),
    dependencies: findFileDependencies(n, c),
    enums: [],
    messages: [],
    extensions: [],
    services: [],
    toString() {
      return `file ${this.proto.name}`;
    },
    getSyntaxComments() {
      return findComments(this.proto.sourceCodeInfo, [
        FieldNumber.FileDescriptorProto_Syntax
      ]);
    },
    getPackageComments() {
      return findComments(this.proto.sourceCodeInfo, [
        FieldNumber.FileDescriptorProto_Package
      ]);
    },
    getFeatures() {
      var b;
      return u((b = n.options) === null || b === void 0 ? void 0 : b.features);
    }
  });
  c.mapEntries.clear();
  for (const b of n.enumType)
    addEnum(b, A, void 0, c, u);
  for (const b of n.messageType)
    addMessage(b, A, void 0, c, u);
  for (const b of n.service)
    addService(b, A, c, u);
  addExtensions(A, c, u);
  for (const b of c.mapEntries.values())
    addFields(b, c, u);
  for (const b of A.messages)
    addFields(b, c, u), addExtensions(b, c, u);
  c.mapEntries.clear(), c.files.push(A);
}
function addExtensions(n, c, u) {
  switch (n.kind) {
    case "file":
      for (const p of n.proto.extension) {
        const a = newExtension(p, n, void 0, c, u);
        n.extensions.push(a), c.extensions.set(a.typeName, a);
      }
      break;
    case "message":
      for (const p of n.proto.extension) {
        const a = newExtension(p, n.file, n, c, u);
        n.nestedExtensions.push(a), c.extensions.set(a.typeName, a);
      }
      for (const p of n.nestedMessages)
        addExtensions(p, c, u);
      break;
  }
}
function addFields(n, c, u) {
  const p = n.proto.oneofDecl.map((A) => newOneof(A, n, u)), a = /* @__PURE__ */ new Set();
  for (const A of n.proto.field) {
    const b = findOneof(A, p), F = newField(A, n.file, n, b, c, u);
    n.fields.push(F), b === void 0 ? n.members.push(F) : (b.fields.push(F), a.has(b) || (a.add(b), n.members.push(b)));
  }
  for (const A of p.filter((b) => a.has(b)))
    n.oneofs.push(A);
  for (const A of n.nestedMessages)
    addFields(A, c, u);
}
function addEnum(n, c, u, p, a) {
  var A, b, F;
  (0, assert_js_1$1.assert)(n.name, "invalid EnumDescriptorProto: missing name");
  const le = {
    kind: "enum",
    proto: n,
    deprecated: (b = (A = n.options) === null || A === void 0 ? void 0 : A.deprecated) !== null && b !== void 0 ? b : !1,
    file: c,
    parent: u,
    name: n.name,
    typeName: makeTypeName(n, u, c),
    values: [],
    sharedPrefix: (0, names_js_1$1.findEnumSharedPrefix)(n.name, n.value.map((L) => {
      var pe;
      return (pe = L.name) !== null && pe !== void 0 ? pe : "";
    })),
    toString() {
      return `enum ${this.typeName}`;
    },
    getComments() {
      const L = this.parent ? [
        ...this.parent.getComments().sourcePath,
        FieldNumber.DescriptorProto_EnumType,
        this.parent.proto.enumType.indexOf(this.proto)
      ] : [
        FieldNumber.FileDescriptorProto_EnumType,
        this.file.proto.enumType.indexOf(this.proto)
      ];
      return findComments(c.proto.sourceCodeInfo, L);
    },
    getFeatures() {
      var L, pe;
      return a((L = u == null ? void 0 : u.getFeatures()) !== null && L !== void 0 ? L : c.getFeatures(), (pe = n.options) === null || pe === void 0 ? void 0 : pe.features);
    }
  };
  p.enums.set(le.typeName, le), n.value.forEach((L) => {
    var pe, $;
    (0, assert_js_1$1.assert)(L.name, "invalid EnumValueDescriptorProto: missing name"), (0, assert_js_1$1.assert)(L.number !== void 0, "invalid EnumValueDescriptorProto: missing number"), le.values.push({
      kind: "enum_value",
      proto: L,
      deprecated: ($ = (pe = L.options) === null || pe === void 0 ? void 0 : pe.deprecated) !== null && $ !== void 0 ? $ : !1,
      parent: le,
      name: L.name,
      number: L.number,
      toString() {
        return `enum value ${le.typeName}.${this.name}`;
      },
      declarationString() {
        var Ee;
        let be = `${this.name} = ${this.number}`;
        return ((Ee = this.proto.options) === null || Ee === void 0 ? void 0 : Ee.deprecated) === !0 && (be += " [deprecated = true]"), be;
      },
      getComments() {
        const Ee = [
          ...this.parent.getComments().sourcePath,
          FieldNumber.EnumDescriptorProto_Value,
          this.parent.proto.value.indexOf(this.proto)
        ];
        return findComments(c.proto.sourceCodeInfo, Ee);
      },
      getFeatures() {
        var Ee;
        return a(le.getFeatures(), (Ee = L.options) === null || Ee === void 0 ? void 0 : Ee.features);
      }
    });
  }), ((F = u == null ? void 0 : u.nestedEnums) !== null && F !== void 0 ? F : c.enums).push(le);
}
function addMessage(n, c, u, p, a) {
  var A, b, F, le;
  (0, assert_js_1$1.assert)(n.name, "invalid DescriptorProto: missing name");
  const L = {
    kind: "message",
    proto: n,
    deprecated: (b = (A = n.options) === null || A === void 0 ? void 0 : A.deprecated) !== null && b !== void 0 ? b : !1,
    file: c,
    parent: u,
    name: n.name,
    typeName: makeTypeName(n, u, c),
    fields: [],
    oneofs: [],
    members: [],
    nestedEnums: [],
    nestedMessages: [],
    nestedExtensions: [],
    toString() {
      return `message ${this.typeName}`;
    },
    getComments() {
      const pe = this.parent ? [
        ...this.parent.getComments().sourcePath,
        FieldNumber.DescriptorProto_NestedType,
        this.parent.proto.nestedType.indexOf(this.proto)
      ] : [
        FieldNumber.FileDescriptorProto_MessageType,
        this.file.proto.messageType.indexOf(this.proto)
      ];
      return findComments(c.proto.sourceCodeInfo, pe);
    },
    getFeatures() {
      var pe, $;
      return a((pe = u == null ? void 0 : u.getFeatures()) !== null && pe !== void 0 ? pe : c.getFeatures(), ($ = n.options) === null || $ === void 0 ? void 0 : $.features);
    }
  };
  ((F = n.options) === null || F === void 0 ? void 0 : F.mapEntry) === !0 ? p.mapEntries.set(L.typeName, L) : (((le = u == null ? void 0 : u.nestedMessages) !== null && le !== void 0 ? le : c.messages).push(L), p.messages.set(L.typeName, L));
  for (const pe of n.enumType)
    addEnum(pe, c, L, p, a);
  for (const pe of n.nestedType)
    addMessage(pe, c, L, p, a);
}
function addService(n, c, u, p) {
  var a, A;
  (0, assert_js_1$1.assert)(n.name, "invalid ServiceDescriptorProto: missing name");
  const b = {
    kind: "service",
    proto: n,
    deprecated: (A = (a = n.options) === null || a === void 0 ? void 0 : a.deprecated) !== null && A !== void 0 ? A : !1,
    file: c,
    name: n.name,
    typeName: makeTypeName(n, void 0, c),
    methods: [],
    toString() {
      return `service ${this.typeName}`;
    },
    getComments() {
      const F = [
        FieldNumber.FileDescriptorProto_Service,
        this.file.proto.service.indexOf(this.proto)
      ];
      return findComments(c.proto.sourceCodeInfo, F);
    },
    getFeatures() {
      var F;
      return p(c.getFeatures(), (F = n.options) === null || F === void 0 ? void 0 : F.features);
    }
  };
  c.services.push(b), u.services.set(b.typeName, b);
  for (const F of n.method)
    b.methods.push(newMethod(F, b, u, p));
}
function newMethod(n, c, u, p) {
  var a, A, b;
  (0, assert_js_1$1.assert)(n.name, "invalid MethodDescriptorProto: missing name"), (0, assert_js_1$1.assert)(n.inputType, "invalid MethodDescriptorProto: missing input_type"), (0, assert_js_1$1.assert)(n.outputType, "invalid MethodDescriptorProto: missing output_type");
  let F;
  n.clientStreaming === !0 && n.serverStreaming === !0 ? F = service_type_js_1.MethodKind.BiDiStreaming : n.clientStreaming === !0 ? F = service_type_js_1.MethodKind.ClientStreaming : n.serverStreaming === !0 ? F = service_type_js_1.MethodKind.ServerStreaming : F = service_type_js_1.MethodKind.Unary;
  let le;
  switch ((a = n.options) === null || a === void 0 ? void 0 : a.idempotencyLevel) {
    case descriptor_pb_js_1$2.MethodOptions_IdempotencyLevel.IDEMPOTENT:
      le = service_type_js_1.MethodIdempotency.Idempotent;
      break;
    case descriptor_pb_js_1$2.MethodOptions_IdempotencyLevel.NO_SIDE_EFFECTS:
      le = service_type_js_1.MethodIdempotency.NoSideEffects;
      break;
    case descriptor_pb_js_1$2.MethodOptions_IdempotencyLevel.IDEMPOTENCY_UNKNOWN:
    case void 0:
      le = void 0;
      break;
  }
  const L = u.messages.get(trimLeadingDot(n.inputType)), pe = u.messages.get(trimLeadingDot(n.outputType));
  (0, assert_js_1$1.assert)(L, `invalid MethodDescriptorProto: input_type ${n.inputType} not found`), (0, assert_js_1$1.assert)(pe, `invalid MethodDescriptorProto: output_type ${n.inputType} not found`);
  const $ = n.name;
  return {
    kind: "rpc",
    proto: n,
    deprecated: (b = (A = n.options) === null || A === void 0 ? void 0 : A.deprecated) !== null && b !== void 0 ? b : !1,
    parent: c,
    name: $,
    methodKind: F,
    input: L,
    output: pe,
    idempotency: le,
    toString() {
      return `rpc ${c.typeName}.${$}`;
    },
    getComments() {
      const Ee = [
        ...this.parent.getComments().sourcePath,
        FieldNumber.ServiceDescriptorProto_Method,
        this.parent.proto.method.indexOf(this.proto)
      ];
      return findComments(c.file.proto.sourceCodeInfo, Ee);
    },
    getFeatures() {
      var Ee;
      return p(c.getFeatures(), (Ee = n.options) === null || Ee === void 0 ? void 0 : Ee.features);
    }
  };
}
function newOneof(n, c, u) {
  return (0, assert_js_1$1.assert)(n.name, "invalid OneofDescriptorProto: missing name"), {
    kind: "oneof",
    proto: n,
    deprecated: !1,
    parent: c,
    fields: [],
    name: n.name,
    toString() {
      return `oneof ${c.typeName}.${this.name}`;
    },
    getComments() {
      const p = [
        ...this.parent.getComments().sourcePath,
        FieldNumber.DescriptorProto_OneofDecl,
        this.parent.proto.oneofDecl.indexOf(this.proto)
      ];
      return findComments(c.file.proto.sourceCodeInfo, p);
    },
    getFeatures() {
      var p;
      return u(c.getFeatures(), (p = n.options) === null || p === void 0 ? void 0 : p.features);
    }
  };
}
function newField(n, c, u, p, a, A) {
  var b, F, le;
  (0, assert_js_1$1.assert)(n.name, "invalid FieldDescriptorProto: missing name"), (0, assert_js_1$1.assert)(n.number, "invalid FieldDescriptorProto: missing number"), (0, assert_js_1$1.assert)(n.type, "invalid FieldDescriptorProto: missing type");
  const L = {
    proto: n,
    deprecated: (F = (b = n.options) === null || b === void 0 ? void 0 : b.deprecated) !== null && F !== void 0 ? F : !1,
    name: n.name,
    number: n.number,
    parent: u,
    oneof: p,
    optional: isOptionalField(n, c.syntax),
    packedByDefault: isPackedFieldByDefault(n, A),
    packed: isPackedField(c, u, n, A),
    jsonName: n.jsonName === (0, names_js_1$1.fieldJsonName)(n.name) ? void 0 : n.jsonName,
    scalar: void 0,
    longType: void 0,
    message: void 0,
    enum: void 0,
    mapKey: void 0,
    mapValue: void 0,
    declarationString,
    // toString, getComments, getFeatures are overridden in newExtension
    toString() {
      return `field ${this.parent.typeName}.${this.name}`;
    },
    getComments() {
      const $ = [
        ...this.parent.getComments().sourcePath,
        FieldNumber.DescriptorProto_Field,
        this.parent.proto.field.indexOf(this.proto)
      ];
      return findComments(c.proto.sourceCodeInfo, $);
    },
    getFeatures() {
      var $;
      return A(u.getFeatures(), ($ = n.options) === null || $ === void 0 ? void 0 : $.features);
    }
  }, pe = n.label === descriptor_pb_js_1$2.FieldDescriptorProto_Label.REPEATED;
  switch (n.type) {
    case descriptor_pb_js_1$2.FieldDescriptorProto_Type.MESSAGE:
    case descriptor_pb_js_1$2.FieldDescriptorProto_Type.GROUP: {
      (0, assert_js_1$1.assert)(n.typeName, "invalid FieldDescriptorProto: missing type_name");
      const $ = a.mapEntries.get(trimLeadingDot(n.typeName));
      if ($ !== void 0)
        return (0, assert_js_1$1.assert)(pe, "invalid FieldDescriptorProto: expected map entry to be repeated"), Object.assign(Object.assign(Object.assign({}, L), { kind: "field", fieldKind: "map", repeated: !1 }), getMapFieldTypes($));
      const Ee = a.messages.get(trimLeadingDot(n.typeName));
      return (0, assert_js_1$1.assert)(Ee !== void 0, `invalid FieldDescriptorProto: type_name ${n.typeName} not found`), Object.assign(Object.assign({}, L), {
        kind: "field",
        fieldKind: "message",
        repeated: pe,
        message: Ee
      });
    }
    case descriptor_pb_js_1$2.FieldDescriptorProto_Type.ENUM: {
      (0, assert_js_1$1.assert)(n.typeName, "invalid FieldDescriptorProto: missing type_name");
      const $ = a.enums.get(trimLeadingDot(n.typeName));
      return (0, assert_js_1$1.assert)($ !== void 0, `invalid FieldDescriptorProto: type_name ${n.typeName} not found`), Object.assign(Object.assign({}, L), {
        kind: "field",
        fieldKind: "enum",
        getDefaultValue,
        repeated: pe,
        enum: $
      });
    }
    default: {
      const $ = fieldTypeToScalarType[n.type];
      return (0, assert_js_1$1.assert)($, `invalid FieldDescriptorProto: unknown type ${n.type}`), Object.assign(Object.assign({}, L), {
        kind: "field",
        fieldKind: "scalar",
        getDefaultValue,
        repeated: pe,
        scalar: $,
        longType: ((le = n.options) === null || le === void 0 ? void 0 : le.jstype) == descriptor_pb_js_1$2.FieldOptions_JSType.JS_STRING ? scalar_js_1$1.LongType.STRING : scalar_js_1$1.LongType.BIGINT
      });
    }
  }
}
function newExtension(n, c, u, p, a) {
  (0, assert_js_1$1.assert)(n.extendee, "invalid FieldDescriptorProto: missing extendee");
  const A = newField(
    n,
    c,
    null,
    // to safe us many lines of duplicated code, we trick the type system
    void 0,
    p,
    a
  ), b = p.messages.get(trimLeadingDot(n.extendee));
  return (0, assert_js_1$1.assert)(b, `invalid FieldDescriptorProto: extendee ${n.extendee} not found`), Object.assign(Object.assign({}, A), {
    kind: "extension",
    typeName: makeTypeName(n, u, c),
    parent: u,
    file: c,
    extendee: b,
    // Must override toString, getComments, getFeatures from newField, because we
    // call newField with parent undefined.
    toString() {
      return `extension ${this.typeName}`;
    },
    getComments() {
      const F = this.parent ? [
        ...this.parent.getComments().sourcePath,
        FieldNumber.DescriptorProto_Extension,
        this.parent.proto.extension.indexOf(n)
      ] : [
        FieldNumber.FileDescriptorProto_Extension,
        this.file.proto.extension.indexOf(n)
      ];
      return findComments(c.proto.sourceCodeInfo, F);
    },
    getFeatures() {
      var F;
      return a((u ?? c).getFeatures(), (F = n.options) === null || F === void 0 ? void 0 : F.features);
    }
  });
}
function parseFileSyntax(n, c) {
  let u, p;
  switch (n) {
    case void 0:
    case "proto2":
      p = "proto2", u = descriptor_pb_js_1$2.Edition.EDITION_PROTO2;
      break;
    case "proto3":
      p = "proto3", u = descriptor_pb_js_1$2.Edition.EDITION_PROTO3;
      break;
    case "editions":
      switch (p = "editions", c) {
        case void 0:
        case descriptor_pb_js_1$2.Edition.EDITION_1_TEST_ONLY:
        case descriptor_pb_js_1$2.Edition.EDITION_2_TEST_ONLY:
        case descriptor_pb_js_1$2.Edition.EDITION_99997_TEST_ONLY:
        case descriptor_pb_js_1$2.Edition.EDITION_99998_TEST_ONLY:
        case descriptor_pb_js_1$2.Edition.EDITION_99999_TEST_ONLY:
        case descriptor_pb_js_1$2.Edition.EDITION_UNKNOWN:
          u = descriptor_pb_js_1$2.Edition.EDITION_UNKNOWN;
          break;
        default:
          u = c;
          break;
      }
      break;
    default:
      throw new Error(`invalid FileDescriptorProto: unsupported syntax: ${n}`);
  }
  if (n === "editions" && c === descriptor_pb_js_1$2.Edition.EDITION_UNKNOWN)
    throw new Error(`invalid FileDescriptorProto: syntax ${n} cannot have edition ${String(c)}`);
  return {
    syntax: p,
    edition: u
  };
}
function findFileDependencies(n, c) {
  return n.dependency.map((u) => {
    const p = c.files.find((a) => a.proto.name === u);
    return (0, assert_js_1$1.assert)(p), p;
  });
}
function makeTypeName(n, c, u) {
  (0, assert_js_1$1.assert)(n.name, `invalid ${n.getType().typeName}: missing name`);
  let p;
  return c ? p = `${c.typeName}.${n.name}` : u.proto.package !== void 0 ? p = `${u.proto.package}.${n.name}` : p = `${n.name}`, p;
}
function trimLeadingDot(n) {
  return n.startsWith(".") ? n.substring(1) : n;
}
function getMapFieldTypes(n) {
  var c, u;
  (0, assert_js_1$1.assert)((c = n.proto.options) === null || c === void 0 ? void 0 : c.mapEntry, `invalid DescriptorProto: expected ${n.toString()} to be a map entry`), (0, assert_js_1$1.assert)(n.fields.length === 2, `invalid DescriptorProto: map entry ${n.toString()} has ${n.fields.length} fields`);
  const p = n.fields.find((b) => b.proto.number === 1);
  (0, assert_js_1$1.assert)(p, `invalid DescriptorProto: map entry ${n.toString()} is missing key field`);
  const a = p.scalar;
  (0, assert_js_1$1.assert)(a !== void 0 && a !== scalar_js_1$1.ScalarType.BYTES && a !== scalar_js_1$1.ScalarType.FLOAT && a !== scalar_js_1$1.ScalarType.DOUBLE, `invalid DescriptorProto: map entry ${n.toString()} has unexpected key type ${(u = p.proto.type) !== null && u !== void 0 ? u : -1}`);
  const A = n.fields.find((b) => b.proto.number === 2);
  switch ((0, assert_js_1$1.assert)(A, `invalid DescriptorProto: map entry ${n.toString()} is missing value field`), A.fieldKind) {
    case "scalar":
      return {
        mapKey: a,
        mapValue: Object.assign(Object.assign({}, A), { kind: "scalar" })
      };
    case "message":
      return {
        mapKey: a,
        mapValue: Object.assign(Object.assign({}, A), { kind: "message" })
      };
    case "enum":
      return {
        mapKey: a,
        mapValue: Object.assign(Object.assign({}, A), { kind: "enum" })
      };
    default:
      throw new Error("invalid DescriptorProto: unsupported map entry value field");
  }
}
function findOneof(n, c) {
  var u;
  const p = n.oneofIndex;
  if (p === void 0)
    return;
  let a;
  return n.proto3Optional !== !0 && (a = c[p], (0, assert_js_1$1.assert)(a, `invalid FieldDescriptorProto: oneof #${p} for field #${(u = n.number) !== null && u !== void 0 ? u : -1} not found`)), a;
}
function isOptionalField(n, c) {
  switch (c) {
    case "proto2":
      return n.oneofIndex === void 0 && n.label === descriptor_pb_js_1$2.FieldDescriptorProto_Label.OPTIONAL;
    case "proto3":
      return n.proto3Optional === !0;
    case "editions":
      return !1;
  }
}
function isPackedFieldByDefault(n, c) {
  const { repeatedFieldEncoding: u } = c();
  if (u != descriptor_pb_js_1$2.FeatureSet_RepeatedFieldEncoding.PACKED)
    return !1;
  switch (n.type) {
    case descriptor_pb_js_1$2.FieldDescriptorProto_Type.STRING:
    case descriptor_pb_js_1$2.FieldDescriptorProto_Type.BYTES:
    case descriptor_pb_js_1$2.FieldDescriptorProto_Type.GROUP:
    case descriptor_pb_js_1$2.FieldDescriptorProto_Type.MESSAGE:
      return !1;
    default:
      return !0;
  }
}
function isPackedField(n, c, u, p) {
  var a, A, b, F, le, L;
  switch (u.type) {
    case descriptor_pb_js_1$2.FieldDescriptorProto_Type.STRING:
    case descriptor_pb_js_1$2.FieldDescriptorProto_Type.BYTES:
    case descriptor_pb_js_1$2.FieldDescriptorProto_Type.GROUP:
    case descriptor_pb_js_1$2.FieldDescriptorProto_Type.MESSAGE:
      return !1;
    default:
      switch (n.edition) {
        case descriptor_pb_js_1$2.Edition.EDITION_PROTO2:
          return (A = (a = u.options) === null || a === void 0 ? void 0 : a.packed) !== null && A !== void 0 ? A : !1;
        case descriptor_pb_js_1$2.Edition.EDITION_PROTO3:
          return (F = (b = u.options) === null || b === void 0 ? void 0 : b.packed) !== null && F !== void 0 ? F : !0;
        default: {
          const { repeatedFieldEncoding: pe } = p((le = c == null ? void 0 : c.getFeatures()) !== null && le !== void 0 ? le : n.getFeatures(), (L = u.options) === null || L === void 0 ? void 0 : L.features);
          return pe == descriptor_pb_js_1$2.FeatureSet_RepeatedFieldEncoding.PACKED;
        }
      }
  }
}
const fieldTypeToScalarType = {
  [descriptor_pb_js_1$2.FieldDescriptorProto_Type.DOUBLE]: scalar_js_1$1.ScalarType.DOUBLE,
  [descriptor_pb_js_1$2.FieldDescriptorProto_Type.FLOAT]: scalar_js_1$1.ScalarType.FLOAT,
  [descriptor_pb_js_1$2.FieldDescriptorProto_Type.INT64]: scalar_js_1$1.ScalarType.INT64,
  [descriptor_pb_js_1$2.FieldDescriptorProto_Type.UINT64]: scalar_js_1$1.ScalarType.UINT64,
  [descriptor_pb_js_1$2.FieldDescriptorProto_Type.INT32]: scalar_js_1$1.ScalarType.INT32,
  [descriptor_pb_js_1$2.FieldDescriptorProto_Type.FIXED64]: scalar_js_1$1.ScalarType.FIXED64,
  [descriptor_pb_js_1$2.FieldDescriptorProto_Type.FIXED32]: scalar_js_1$1.ScalarType.FIXED32,
  [descriptor_pb_js_1$2.FieldDescriptorProto_Type.BOOL]: scalar_js_1$1.ScalarType.BOOL,
  [descriptor_pb_js_1$2.FieldDescriptorProto_Type.STRING]: scalar_js_1$1.ScalarType.STRING,
  [descriptor_pb_js_1$2.FieldDescriptorProto_Type.GROUP]: void 0,
  [descriptor_pb_js_1$2.FieldDescriptorProto_Type.MESSAGE]: void 0,
  [descriptor_pb_js_1$2.FieldDescriptorProto_Type.BYTES]: scalar_js_1$1.ScalarType.BYTES,
  [descriptor_pb_js_1$2.FieldDescriptorProto_Type.UINT32]: scalar_js_1$1.ScalarType.UINT32,
  [descriptor_pb_js_1$2.FieldDescriptorProto_Type.ENUM]: void 0,
  [descriptor_pb_js_1$2.FieldDescriptorProto_Type.SFIXED32]: scalar_js_1$1.ScalarType.SFIXED32,
  [descriptor_pb_js_1$2.FieldDescriptorProto_Type.SFIXED64]: scalar_js_1$1.ScalarType.SFIXED64,
  [descriptor_pb_js_1$2.FieldDescriptorProto_Type.SINT32]: scalar_js_1$1.ScalarType.SINT32,
  [descriptor_pb_js_1$2.FieldDescriptorProto_Type.SINT64]: scalar_js_1$1.ScalarType.SINT64
};
function findComments(n, c) {
  if (!n)
    return {
      leadingDetached: [],
      sourcePath: c
    };
  for (const u of n.location)
    if (u.path.length === c.length && !u.path.some((p, a) => c[a] !== p))
      return {
        leadingDetached: u.leadingDetachedComments,
        leading: u.leadingComments,
        trailing: u.trailingComments,
        sourcePath: c
      };
  return {
    leadingDetached: [],
    sourcePath: c
  };
}
var FieldNumber;
(function(n) {
  n[n.FileDescriptorProto_Package = 2] = "FileDescriptorProto_Package", n[n.FileDescriptorProto_MessageType = 4] = "FileDescriptorProto_MessageType", n[n.FileDescriptorProto_EnumType = 5] = "FileDescriptorProto_EnumType", n[n.FileDescriptorProto_Service = 6] = "FileDescriptorProto_Service", n[n.FileDescriptorProto_Extension = 7] = "FileDescriptorProto_Extension", n[n.FileDescriptorProto_Syntax = 12] = "FileDescriptorProto_Syntax", n[n.DescriptorProto_Field = 2] = "DescriptorProto_Field", n[n.DescriptorProto_NestedType = 3] = "DescriptorProto_NestedType", n[n.DescriptorProto_EnumType = 4] = "DescriptorProto_EnumType", n[n.DescriptorProto_Extension = 6] = "DescriptorProto_Extension", n[n.DescriptorProto_OneofDecl = 8] = "DescriptorProto_OneofDecl", n[n.EnumDescriptorProto_Value = 2] = "EnumDescriptorProto_Value", n[n.ServiceDescriptorProto_Method = 2] = "ServiceDescriptorProto_Method";
})(FieldNumber || (FieldNumber = {}));
function declarationString() {
  var n, c, u;
  const p = [];
  this.repeated && p.push("repeated"), this.optional && p.push("optional"), (this.kind === "extension" ? this.file : this.parent.file).syntax == "proto2" && this.proto.label === descriptor_pb_js_1$2.FieldDescriptorProto_Label.REQUIRED && p.push("required");
  let A;
  switch (this.fieldKind) {
    case "scalar":
      A = scalar_js_1$1.ScalarType[this.scalar].toLowerCase();
      break;
    case "enum":
      A = this.enum.typeName;
      break;
    case "message":
      A = this.message.typeName;
      break;
    case "map": {
      const le = scalar_js_1$1.ScalarType[this.mapKey].toLowerCase();
      let L;
      switch (this.mapValue.kind) {
        case "scalar":
          L = scalar_js_1$1.ScalarType[this.mapValue.scalar].toLowerCase();
          break;
        case "enum":
          L = this.mapValue.enum.typeName;
          break;
        case "message":
          L = this.mapValue.message.typeName;
          break;
      }
      A = `map<${le}, ${L}>`;
      break;
    }
  }
  p.push(`${A} ${this.name} = ${this.number}`);
  const b = [];
  ((n = this.proto.options) === null || n === void 0 ? void 0 : n.packed) !== void 0 && b.push(`packed = ${this.proto.options.packed.toString()}`);
  let F = this.proto.defaultValue;
  return F !== void 0 && ((this.proto.type == descriptor_pb_js_1$2.FieldDescriptorProto_Type.BYTES || this.proto.type == descriptor_pb_js_1$2.FieldDescriptorProto_Type.STRING) && (F = '"' + F.replace('"', '\\"') + '"'), b.push(`default = ${F}`)), this.jsonName !== void 0 && b.push(`json_name = "${this.jsonName}"`), ((c = this.proto.options) === null || c === void 0 ? void 0 : c.jstype) !== void 0 && b.push(`jstype = ${descriptor_pb_js_1$2.FieldOptions_JSType[this.proto.options.jstype]}`), ((u = this.proto.options) === null || u === void 0 ? void 0 : u.deprecated) === !0 && b.push("deprecated = true"), b.length > 0 && p.push("[" + b.join(", ") + "]"), p.join(" ");
}
function getDefaultValue() {
  const n = this.proto.defaultValue;
  if (n !== void 0)
    switch (this.fieldKind) {
      case "enum":
        return (0, text_format_js_1.parseTextFormatEnumValue)(this.enum, n);
      case "scalar":
        return (0, text_format_js_1.parseTextFormatScalarValue)(this.scalar, n);
      default:
        return;
    }
}
var createRegistry$1 = {};
Object.defineProperty(createRegistry$1, "__esModule", { value: !0 });
createRegistry$1.createRegistry = void 0;
function createRegistry(...n) {
  const c = {}, u = {}, p = {}, a = /* @__PURE__ */ new Map(), A = /* @__PURE__ */ new Map(), b = {
    findMessage(L) {
      return c[L];
    },
    findEnum(L) {
      return u[L];
    },
    findService(L) {
      return p[L];
    },
    findExtensionFor(L, pe) {
      var $, Ee;
      return (Ee = ($ = A.get(L)) === null || $ === void 0 ? void 0 : $.get(pe)) !== null && Ee !== void 0 ? Ee : void 0;
    },
    findExtension(L) {
      var pe;
      return (pe = a.get(L)) !== null && pe !== void 0 ? pe : void 0;
    }
  };
  function F(L) {
    var pe;
    if ("fields" in L)
      b.findMessage(L.typeName) || (c[L.typeName] = L, L.fields.list().forEach(le));
    else if ("methods" in L) {
      if (!b.findService(L.typeName)) {
        p[L.typeName] = L;
        for (const $ of Object.values(L.methods))
          F($.I), F($.O);
      }
    } else if ("extendee" in L) {
      if (!a.has(L.typeName)) {
        a.set(L.typeName, L);
        const $ = L.extendee.typeName;
        A.has($) || A.set($, /* @__PURE__ */ new Map()), (pe = A.get($)) === null || pe === void 0 || pe.set(L.field.no, L), F(L.extendee), le(L.field);
      }
    } else
      u[L.typeName] = L;
  }
  function le(L) {
    L.kind == "message" ? F(L.T) : L.kind == "map" && L.V.kind == "message" ? F(L.V.T) : L.kind == "enum" && F(L.T);
  }
  for (const L of n)
    F(L);
  return b;
}
createRegistry$1.createRegistry = createRegistry;
var createRegistryFromDesc = {}, timestamp_pb = {};
Object.defineProperty(timestamp_pb, "__esModule", { value: !0 });
timestamp_pb.Timestamp = void 0;
const message_js_1$a = message, proto_int64_js_1$2 = protoInt64, proto3_js_1$a = proto3;
class Timestamp extends message_js_1$a.Message {
  constructor(c) {
    super(), this.seconds = proto_int64_js_1$2.protoInt64.zero, this.nanos = 0, proto3_js_1$a.proto3.util.initPartial(c, this);
  }
  fromJson(c, u) {
    if (typeof c != "string")
      throw new Error(`cannot decode google.protobuf.Timestamp from JSON: ${proto3_js_1$a.proto3.json.debug(c)}`);
    const p = c.match(/^([0-9]{4})-([0-9]{2})-([0-9]{2})T([0-9]{2}):([0-9]{2}):([0-9]{2})(?:Z|\.([0-9]{3,9})Z|([+-][0-9][0-9]:[0-9][0-9]))$/);
    if (!p)
      throw new Error("cannot decode google.protobuf.Timestamp from JSON: invalid RFC 3339 string");
    const a = Date.parse(p[1] + "-" + p[2] + "-" + p[3] + "T" + p[4] + ":" + p[5] + ":" + p[6] + (p[8] ? p[8] : "Z"));
    if (Number.isNaN(a))
      throw new Error("cannot decode google.protobuf.Timestamp from JSON: invalid RFC 3339 string");
    if (a < Date.parse("0001-01-01T00:00:00Z") || a > Date.parse("9999-12-31T23:59:59Z"))
      throw new Error("cannot decode message google.protobuf.Timestamp from JSON: must be from 0001-01-01T00:00:00Z to 9999-12-31T23:59:59Z inclusive");
    return this.seconds = proto_int64_js_1$2.protoInt64.parse(a / 1e3), this.nanos = 0, p[7] && (this.nanos = parseInt("1" + p[7] + "0".repeat(9 - p[7].length)) - 1e9), this;
  }
  toJson(c) {
    const u = Number(this.seconds) * 1e3;
    if (u < Date.parse("0001-01-01T00:00:00Z") || u > Date.parse("9999-12-31T23:59:59Z"))
      throw new Error("cannot encode google.protobuf.Timestamp to JSON: must be from 0001-01-01T00:00:00Z to 9999-12-31T23:59:59Z inclusive");
    if (this.nanos < 0)
      throw new Error("cannot encode google.protobuf.Timestamp to JSON: nanos must not be negative");
    let p = "Z";
    if (this.nanos > 0) {
      const a = (this.nanos + 1e9).toString().substring(1);
      a.substring(3) === "000000" ? p = "." + a.substring(0, 3) + "Z" : a.substring(6) === "000" ? p = "." + a.substring(0, 6) + "Z" : p = "." + a + "Z";
    }
    return new Date(u).toISOString().replace(".000Z", p);
  }
  toDate() {
    return new Date(Number(this.seconds) * 1e3 + Math.ceil(this.nanos / 1e6));
  }
  static now() {
    return Timestamp.fromDate(/* @__PURE__ */ new Date());
  }
  static fromDate(c) {
    const u = c.getTime();
    return new Timestamp({
      seconds: proto_int64_js_1$2.protoInt64.parse(Math.floor(u / 1e3)),
      nanos: u % 1e3 * 1e6
    });
  }
  static fromBinary(c, u) {
    return new Timestamp().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new Timestamp().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new Timestamp().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto3_js_1$a.proto3.util.equals(Timestamp, c, u);
  }
}
timestamp_pb.Timestamp = Timestamp;
Timestamp.runtime = proto3_js_1$a.proto3;
Timestamp.typeName = "google.protobuf.Timestamp";
Timestamp.fields = proto3_js_1$a.proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "seconds",
    kind: "scalar",
    T: 3
    /* ScalarType.INT64 */
  },
  {
    no: 2,
    name: "nanos",
    kind: "scalar",
    T: 5
    /* ScalarType.INT32 */
  }
]);
var duration_pb = {};
Object.defineProperty(duration_pb, "__esModule", { value: !0 });
duration_pb.Duration = void 0;
const message_js_1$9 = message, proto_int64_js_1$1 = protoInt64, proto3_js_1$9 = proto3;
class Duration extends message_js_1$9.Message {
  constructor(c) {
    super(), this.seconds = proto_int64_js_1$1.protoInt64.zero, this.nanos = 0, proto3_js_1$9.proto3.util.initPartial(c, this);
  }
  fromJson(c, u) {
    if (typeof c != "string")
      throw new Error(`cannot decode google.protobuf.Duration from JSON: ${proto3_js_1$9.proto3.json.debug(c)}`);
    const p = c.match(/^(-?[0-9]+)(?:\.([0-9]+))?s/);
    if (p === null)
      throw new Error(`cannot decode google.protobuf.Duration from JSON: ${proto3_js_1$9.proto3.json.debug(c)}`);
    const a = Number(p[1]);
    if (a > 315576e6 || a < -315576e6)
      throw new Error(`cannot decode google.protobuf.Duration from JSON: ${proto3_js_1$9.proto3.json.debug(c)}`);
    if (this.seconds = proto_int64_js_1$1.protoInt64.parse(a), typeof p[2] == "string") {
      const A = p[2] + "0".repeat(9 - p[2].length);
      this.nanos = parseInt(A), (a < 0 || Object.is(a, -0)) && (this.nanos = -this.nanos);
    }
    return this;
  }
  toJson(c) {
    if (Number(this.seconds) > 315576e6 || Number(this.seconds) < -315576e6)
      throw new Error("cannot encode google.protobuf.Duration to JSON: value out of range");
    let u = this.seconds.toString();
    if (this.nanos !== 0) {
      let p = Math.abs(this.nanos).toString();
      p = "0".repeat(9 - p.length) + p, p.substring(3) === "000000" ? p = p.substring(0, 3) : p.substring(6) === "000" && (p = p.substring(0, 6)), u += "." + p, this.nanos < 0 && Number(this.seconds) == 0 && (u = "-" + u);
    }
    return u + "s";
  }
  static fromBinary(c, u) {
    return new Duration().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new Duration().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new Duration().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto3_js_1$9.proto3.util.equals(Duration, c, u);
  }
}
duration_pb.Duration = Duration;
Duration.runtime = proto3_js_1$9.proto3;
Duration.typeName = "google.protobuf.Duration";
Duration.fields = proto3_js_1$9.proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "seconds",
    kind: "scalar",
    T: 3
    /* ScalarType.INT64 */
  },
  {
    no: 2,
    name: "nanos",
    kind: "scalar",
    T: 5
    /* ScalarType.INT32 */
  }
]);
var any_pb = {};
Object.defineProperty(any_pb, "__esModule", { value: !0 });
any_pb.Any = void 0;
const message_js_1$8 = message, proto3_js_1$8 = proto3;
class Any extends message_js_1$8.Message {
  constructor(c) {
    super(), this.typeUrl = "", this.value = new Uint8Array(0), proto3_js_1$8.proto3.util.initPartial(c, this);
  }
  toJson(c) {
    var u;
    if (this.typeUrl === "")
      return {};
    const p = this.typeUrlToName(this.typeUrl), a = (u = c == null ? void 0 : c.typeRegistry) === null || u === void 0 ? void 0 : u.findMessage(p);
    if (!a)
      throw new Error(`cannot encode message google.protobuf.Any to JSON: "${this.typeUrl}" is not in the type registry`);
    let b = a.fromBinary(this.value).toJson(c);
    return (p.startsWith("google.protobuf.") || b === null || Array.isArray(b) || typeof b != "object") && (b = { value: b }), b["@type"] = this.typeUrl, b;
  }
  fromJson(c, u) {
    var p;
    if (c === null || Array.isArray(c) || typeof c != "object")
      throw new Error(`cannot decode message google.protobuf.Any from JSON: expected object but got ${c === null ? "null" : Array.isArray(c) ? "array" : typeof c}`);
    if (Object.keys(c).length == 0)
      return this;
    const a = c["@type"];
    if (typeof a != "string" || a == "")
      throw new Error('cannot decode message google.protobuf.Any from JSON: "@type" is empty');
    const A = this.typeUrlToName(a), b = (p = u == null ? void 0 : u.typeRegistry) === null || p === void 0 ? void 0 : p.findMessage(A);
    if (!b)
      throw new Error(`cannot decode message google.protobuf.Any from JSON: ${a} is not in the type registry`);
    let F;
    if (A.startsWith("google.protobuf.") && Object.prototype.hasOwnProperty.call(c, "value"))
      F = b.fromJson(c.value, u);
    else {
      const le = Object.assign({}, c);
      delete le["@type"], F = b.fromJson(le, u);
    }
    return this.packFrom(F), this;
  }
  packFrom(c) {
    this.value = c.toBinary(), this.typeUrl = this.typeNameToUrl(c.getType().typeName);
  }
  unpackTo(c) {
    return this.is(c.getType()) ? (c.fromBinary(this.value), !0) : !1;
  }
  unpack(c) {
    if (this.typeUrl === "")
      return;
    const u = c.findMessage(this.typeUrlToName(this.typeUrl));
    if (u)
      return u.fromBinary(this.value);
  }
  is(c) {
    if (this.typeUrl === "")
      return !1;
    const u = this.typeUrlToName(this.typeUrl);
    let p = "";
    return typeof c == "string" ? p = c : p = c.typeName, u === p;
  }
  typeNameToUrl(c) {
    return `type.googleapis.com/${c}`;
  }
  typeUrlToName(c) {
    if (!c.length)
      throw new Error(`invalid type url: ${c}`);
    const u = c.lastIndexOf("/"), p = u >= 0 ? c.substring(u + 1) : c;
    if (!p.length)
      throw new Error(`invalid type url: ${c}`);
    return p;
  }
  static pack(c) {
    const u = new Any();
    return u.packFrom(c), u;
  }
  static fromBinary(c, u) {
    return new Any().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new Any().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new Any().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto3_js_1$8.proto3.util.equals(Any, c, u);
  }
}
any_pb.Any = Any;
Any.runtime = proto3_js_1$8.proto3;
Any.typeName = "google.protobuf.Any";
Any.fields = proto3_js_1$8.proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "type_url",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 2,
    name: "value",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  }
]);
var empty_pb = {};
Object.defineProperty(empty_pb, "__esModule", { value: !0 });
empty_pb.Empty = void 0;
const message_js_1$7 = message, proto3_js_1$7 = proto3;
class Empty extends message_js_1$7.Message {
  constructor(c) {
    super(), proto3_js_1$7.proto3.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new Empty().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new Empty().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new Empty().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto3_js_1$7.proto3.util.equals(Empty, c, u);
  }
}
empty_pb.Empty = Empty;
Empty.runtime = proto3_js_1$7.proto3;
Empty.typeName = "google.protobuf.Empty";
Empty.fields = proto3_js_1$7.proto3.util.newFieldList(() => []);
var field_mask_pb = {};
Object.defineProperty(field_mask_pb, "__esModule", { value: !0 });
field_mask_pb.FieldMask = void 0;
const message_js_1$6 = message, proto3_js_1$6 = proto3;
class FieldMask extends message_js_1$6.Message {
  constructor(c) {
    super(), this.paths = [], proto3_js_1$6.proto3.util.initPartial(c, this);
  }
  toJson(c) {
    function u(p) {
      let a = !1;
      const A = [];
      for (let b = 0; b < p.length; b++) {
        let F = p.charAt(b);
        switch (F) {
          case "_":
            a = !0;
            break;
          case "0":
          case "1":
          case "2":
          case "3":
          case "4":
          case "5":
          case "6":
          case "7":
          case "8":
          case "9":
            A.push(F), a = !1;
            break;
          default:
            a && (a = !1, F = F.toUpperCase()), A.push(F);
            break;
        }
      }
      return A.join("");
    }
    return this.paths.map((p) => {
      if (p.match(/_[0-9]?_/g) || p.match(/[A-Z]/g))
        throw new Error('cannot encode google.protobuf.FieldMask to JSON: lowerCamelCase of path name "' + p + '" is irreversible');
      return u(p);
    }).join(",");
  }
  fromJson(c, u) {
    if (typeof c != "string")
      throw new Error("cannot decode google.protobuf.FieldMask from JSON: " + proto3_js_1$6.proto3.json.debug(c));
    if (c === "")
      return this;
    function p(a) {
      if (a.includes("_"))
        throw new Error("cannot decode google.protobuf.FieldMask from JSON: path names must be lowerCamelCase");
      const A = a.replace(/[A-Z]/g, (b) => "_" + b.toLowerCase());
      return A[0] === "_" ? A.substring(1) : A;
    }
    return this.paths = c.split(",").map(p), this;
  }
  static fromBinary(c, u) {
    return new FieldMask().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new FieldMask().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new FieldMask().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto3_js_1$6.proto3.util.equals(FieldMask, c, u);
  }
}
field_mask_pb.FieldMask = FieldMask;
FieldMask.runtime = proto3_js_1$6.proto3;
FieldMask.typeName = "google.protobuf.FieldMask";
FieldMask.fields = proto3_js_1$6.proto3.util.newFieldList(() => [
  { no: 1, name: "paths", kind: "scalar", T: 9, repeated: !0 }
]);
var struct_pb = {};
Object.defineProperty(struct_pb, "__esModule", { value: !0 });
struct_pb.ListValue = struct_pb.Value = struct_pb.Struct = struct_pb.NullValue = void 0;
const proto3_js_1$5 = proto3, message_js_1$5 = message;
var NullValue;
(function(n) {
  n[n.NULL_VALUE = 0] = "NULL_VALUE";
})(NullValue || (struct_pb.NullValue = NullValue = {}));
proto3_js_1$5.proto3.util.setEnumType(NullValue, "google.protobuf.NullValue", [
  { no: 0, name: "NULL_VALUE" }
]);
class Struct extends message_js_1$5.Message {
  constructor(c) {
    super(), this.fields = {}, proto3_js_1$5.proto3.util.initPartial(c, this);
  }
  toJson(c) {
    const u = {};
    for (const [p, a] of Object.entries(this.fields))
      u[p] = a.toJson(c);
    return u;
  }
  fromJson(c, u) {
    if (typeof c != "object" || c == null || Array.isArray(c))
      throw new Error("cannot decode google.protobuf.Struct from JSON " + proto3_js_1$5.proto3.json.debug(c));
    for (const [p, a] of Object.entries(c))
      this.fields[p] = Value.fromJson(a);
    return this;
  }
  static fromBinary(c, u) {
    return new Struct().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new Struct().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new Struct().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto3_js_1$5.proto3.util.equals(Struct, c, u);
  }
}
struct_pb.Struct = Struct;
Struct.runtime = proto3_js_1$5.proto3;
Struct.typeName = "google.protobuf.Struct";
Struct.fields = proto3_js_1$5.proto3.util.newFieldList(() => [
  { no: 1, name: "fields", kind: "map", K: 9, V: { kind: "message", T: Value } }
]);
class Value extends message_js_1$5.Message {
  constructor(c) {
    super(), this.kind = { case: void 0 }, proto3_js_1$5.proto3.util.initPartial(c, this);
  }
  toJson(c) {
    switch (this.kind.case) {
      case "nullValue":
        return null;
      case "numberValue":
        if (!Number.isFinite(this.kind.value))
          throw new Error("google.protobuf.Value cannot be NaN or Infinity");
        return this.kind.value;
      case "boolValue":
        return this.kind.value;
      case "stringValue":
        return this.kind.value;
      case "structValue":
      case "listValue":
        return this.kind.value.toJson(Object.assign(Object.assign({}, c), { emitDefaultValues: !0 }));
    }
    throw new Error("google.protobuf.Value must have a value");
  }
  fromJson(c, u) {
    switch (typeof c) {
      case "number":
        this.kind = { case: "numberValue", value: c };
        break;
      case "string":
        this.kind = { case: "stringValue", value: c };
        break;
      case "boolean":
        this.kind = { case: "boolValue", value: c };
        break;
      case "object":
        c === null ? this.kind = { case: "nullValue", value: NullValue.NULL_VALUE } : Array.isArray(c) ? this.kind = { case: "listValue", value: ListValue.fromJson(c) } : this.kind = { case: "structValue", value: Struct.fromJson(c) };
        break;
      default:
        throw new Error("cannot decode google.protobuf.Value from JSON " + proto3_js_1$5.proto3.json.debug(c));
    }
    return this;
  }
  static fromBinary(c, u) {
    return new Value().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new Value().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new Value().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto3_js_1$5.proto3.util.equals(Value, c, u);
  }
}
struct_pb.Value = Value;
Value.runtime = proto3_js_1$5.proto3;
Value.typeName = "google.protobuf.Value";
Value.fields = proto3_js_1$5.proto3.util.newFieldList(() => [
  { no: 1, name: "null_value", kind: "enum", T: proto3_js_1$5.proto3.getEnumType(NullValue), oneof: "kind" },
  { no: 2, name: "number_value", kind: "scalar", T: 1, oneof: "kind" },
  { no: 3, name: "string_value", kind: "scalar", T: 9, oneof: "kind" },
  { no: 4, name: "bool_value", kind: "scalar", T: 8, oneof: "kind" },
  { no: 5, name: "struct_value", kind: "message", T: Struct, oneof: "kind" },
  { no: 6, name: "list_value", kind: "message", T: ListValue, oneof: "kind" }
]);
class ListValue extends message_js_1$5.Message {
  constructor(c) {
    super(), this.values = [], proto3_js_1$5.proto3.util.initPartial(c, this);
  }
  toJson(c) {
    return this.values.map((u) => u.toJson());
  }
  fromJson(c, u) {
    if (!Array.isArray(c))
      throw new Error("cannot decode google.protobuf.ListValue from JSON " + proto3_js_1$5.proto3.json.debug(c));
    for (let p of c)
      this.values.push(Value.fromJson(p));
    return this;
  }
  static fromBinary(c, u) {
    return new ListValue().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new ListValue().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new ListValue().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto3_js_1$5.proto3.util.equals(ListValue, c, u);
  }
}
struct_pb.ListValue = ListValue;
ListValue.runtime = proto3_js_1$5.proto3;
ListValue.typeName = "google.protobuf.ListValue";
ListValue.fields = proto3_js_1$5.proto3.util.newFieldList(() => [
  { no: 1, name: "values", kind: "message", T: Value, repeated: !0 }
]);
var wrappers_pb = {};
Object.defineProperty(wrappers_pb, "__esModule", { value: !0 });
wrappers_pb.BytesValue = wrappers_pb.StringValue = wrappers_pb.BoolValue = wrappers_pb.UInt32Value = wrappers_pb.Int32Value = wrappers_pb.UInt64Value = wrappers_pb.Int64Value = wrappers_pb.FloatValue = wrappers_pb.DoubleValue = void 0;
const message_js_1$4 = message, proto3_js_1$4 = proto3, scalar_js_1 = scalar, proto_int64_js_1 = protoInt64;
class DoubleValue extends message_js_1$4.Message {
  constructor(c) {
    super(), this.value = 0, proto3_js_1$4.proto3.util.initPartial(c, this);
  }
  toJson(c) {
    return proto3_js_1$4.proto3.json.writeScalar(scalar_js_1.ScalarType.DOUBLE, this.value, !0);
  }
  fromJson(c, u) {
    try {
      this.value = proto3_js_1$4.proto3.json.readScalar(scalar_js_1.ScalarType.DOUBLE, c);
    } catch (p) {
      let a = 'cannot decode message google.protobuf.DoubleValue from JSON"';
      throw p instanceof Error && p.message.length > 0 && (a += `: ${p.message}`), new Error(a);
    }
    return this;
  }
  static fromBinary(c, u) {
    return new DoubleValue().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new DoubleValue().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new DoubleValue().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto3_js_1$4.proto3.util.equals(DoubleValue, c, u);
  }
}
wrappers_pb.DoubleValue = DoubleValue;
DoubleValue.runtime = proto3_js_1$4.proto3;
DoubleValue.typeName = "google.protobuf.DoubleValue";
DoubleValue.fields = proto3_js_1$4.proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "value",
    kind: "scalar",
    T: 1
    /* ScalarType.DOUBLE */
  }
]);
DoubleValue.fieldWrapper = {
  wrapField(n) {
    return new DoubleValue({ value: n });
  },
  unwrapField(n) {
    return n.value;
  }
};
class FloatValue extends message_js_1$4.Message {
  constructor(c) {
    super(), this.value = 0, proto3_js_1$4.proto3.util.initPartial(c, this);
  }
  toJson(c) {
    return proto3_js_1$4.proto3.json.writeScalar(scalar_js_1.ScalarType.FLOAT, this.value, !0);
  }
  fromJson(c, u) {
    try {
      this.value = proto3_js_1$4.proto3.json.readScalar(scalar_js_1.ScalarType.FLOAT, c);
    } catch (p) {
      let a = 'cannot decode message google.protobuf.FloatValue from JSON"';
      throw p instanceof Error && p.message.length > 0 && (a += `: ${p.message}`), new Error(a);
    }
    return this;
  }
  static fromBinary(c, u) {
    return new FloatValue().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new FloatValue().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new FloatValue().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto3_js_1$4.proto3.util.equals(FloatValue, c, u);
  }
}
wrappers_pb.FloatValue = FloatValue;
FloatValue.runtime = proto3_js_1$4.proto3;
FloatValue.typeName = "google.protobuf.FloatValue";
FloatValue.fields = proto3_js_1$4.proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "value",
    kind: "scalar",
    T: 2
    /* ScalarType.FLOAT */
  }
]);
FloatValue.fieldWrapper = {
  wrapField(n) {
    return new FloatValue({ value: n });
  },
  unwrapField(n) {
    return n.value;
  }
};
class Int64Value extends message_js_1$4.Message {
  constructor(c) {
    super(), this.value = proto_int64_js_1.protoInt64.zero, proto3_js_1$4.proto3.util.initPartial(c, this);
  }
  toJson(c) {
    return proto3_js_1$4.proto3.json.writeScalar(scalar_js_1.ScalarType.INT64, this.value, !0);
  }
  fromJson(c, u) {
    try {
      this.value = proto3_js_1$4.proto3.json.readScalar(scalar_js_1.ScalarType.INT64, c);
    } catch (p) {
      let a = 'cannot decode message google.protobuf.Int64Value from JSON"';
      throw p instanceof Error && p.message.length > 0 && (a += `: ${p.message}`), new Error(a);
    }
    return this;
  }
  static fromBinary(c, u) {
    return new Int64Value().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new Int64Value().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new Int64Value().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto3_js_1$4.proto3.util.equals(Int64Value, c, u);
  }
}
wrappers_pb.Int64Value = Int64Value;
Int64Value.runtime = proto3_js_1$4.proto3;
Int64Value.typeName = "google.protobuf.Int64Value";
Int64Value.fields = proto3_js_1$4.proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "value",
    kind: "scalar",
    T: 3
    /* ScalarType.INT64 */
  }
]);
Int64Value.fieldWrapper = {
  wrapField(n) {
    return new Int64Value({ value: n });
  },
  unwrapField(n) {
    return n.value;
  }
};
class UInt64Value extends message_js_1$4.Message {
  constructor(c) {
    super(), this.value = proto_int64_js_1.protoInt64.zero, proto3_js_1$4.proto3.util.initPartial(c, this);
  }
  toJson(c) {
    return proto3_js_1$4.proto3.json.writeScalar(scalar_js_1.ScalarType.UINT64, this.value, !0);
  }
  fromJson(c, u) {
    try {
      this.value = proto3_js_1$4.proto3.json.readScalar(scalar_js_1.ScalarType.UINT64, c);
    } catch (p) {
      let a = 'cannot decode message google.protobuf.UInt64Value from JSON"';
      throw p instanceof Error && p.message.length > 0 && (a += `: ${p.message}`), new Error(a);
    }
    return this;
  }
  static fromBinary(c, u) {
    return new UInt64Value().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new UInt64Value().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new UInt64Value().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto3_js_1$4.proto3.util.equals(UInt64Value, c, u);
  }
}
wrappers_pb.UInt64Value = UInt64Value;
UInt64Value.runtime = proto3_js_1$4.proto3;
UInt64Value.typeName = "google.protobuf.UInt64Value";
UInt64Value.fields = proto3_js_1$4.proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "value",
    kind: "scalar",
    T: 4
    /* ScalarType.UINT64 */
  }
]);
UInt64Value.fieldWrapper = {
  wrapField(n) {
    return new UInt64Value({ value: n });
  },
  unwrapField(n) {
    return n.value;
  }
};
class Int32Value extends message_js_1$4.Message {
  constructor(c) {
    super(), this.value = 0, proto3_js_1$4.proto3.util.initPartial(c, this);
  }
  toJson(c) {
    return proto3_js_1$4.proto3.json.writeScalar(scalar_js_1.ScalarType.INT32, this.value, !0);
  }
  fromJson(c, u) {
    try {
      this.value = proto3_js_1$4.proto3.json.readScalar(scalar_js_1.ScalarType.INT32, c);
    } catch (p) {
      let a = 'cannot decode message google.protobuf.Int32Value from JSON"';
      throw p instanceof Error && p.message.length > 0 && (a += `: ${p.message}`), new Error(a);
    }
    return this;
  }
  static fromBinary(c, u) {
    return new Int32Value().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new Int32Value().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new Int32Value().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto3_js_1$4.proto3.util.equals(Int32Value, c, u);
  }
}
wrappers_pb.Int32Value = Int32Value;
Int32Value.runtime = proto3_js_1$4.proto3;
Int32Value.typeName = "google.protobuf.Int32Value";
Int32Value.fields = proto3_js_1$4.proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "value",
    kind: "scalar",
    T: 5
    /* ScalarType.INT32 */
  }
]);
Int32Value.fieldWrapper = {
  wrapField(n) {
    return new Int32Value({ value: n });
  },
  unwrapField(n) {
    return n.value;
  }
};
class UInt32Value extends message_js_1$4.Message {
  constructor(c) {
    super(), this.value = 0, proto3_js_1$4.proto3.util.initPartial(c, this);
  }
  toJson(c) {
    return proto3_js_1$4.proto3.json.writeScalar(scalar_js_1.ScalarType.UINT32, this.value, !0);
  }
  fromJson(c, u) {
    try {
      this.value = proto3_js_1$4.proto3.json.readScalar(scalar_js_1.ScalarType.UINT32, c);
    } catch (p) {
      let a = 'cannot decode message google.protobuf.UInt32Value from JSON"';
      throw p instanceof Error && p.message.length > 0 && (a += `: ${p.message}`), new Error(a);
    }
    return this;
  }
  static fromBinary(c, u) {
    return new UInt32Value().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new UInt32Value().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new UInt32Value().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto3_js_1$4.proto3.util.equals(UInt32Value, c, u);
  }
}
wrappers_pb.UInt32Value = UInt32Value;
UInt32Value.runtime = proto3_js_1$4.proto3;
UInt32Value.typeName = "google.protobuf.UInt32Value";
UInt32Value.fields = proto3_js_1$4.proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "value",
    kind: "scalar",
    T: 13
    /* ScalarType.UINT32 */
  }
]);
UInt32Value.fieldWrapper = {
  wrapField(n) {
    return new UInt32Value({ value: n });
  },
  unwrapField(n) {
    return n.value;
  }
};
class BoolValue extends message_js_1$4.Message {
  constructor(c) {
    super(), this.value = !1, proto3_js_1$4.proto3.util.initPartial(c, this);
  }
  toJson(c) {
    return proto3_js_1$4.proto3.json.writeScalar(scalar_js_1.ScalarType.BOOL, this.value, !0);
  }
  fromJson(c, u) {
    try {
      this.value = proto3_js_1$4.proto3.json.readScalar(scalar_js_1.ScalarType.BOOL, c);
    } catch (p) {
      let a = 'cannot decode message google.protobuf.BoolValue from JSON"';
      throw p instanceof Error && p.message.length > 0 && (a += `: ${p.message}`), new Error(a);
    }
    return this;
  }
  static fromBinary(c, u) {
    return new BoolValue().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new BoolValue().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new BoolValue().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto3_js_1$4.proto3.util.equals(BoolValue, c, u);
  }
}
wrappers_pb.BoolValue = BoolValue;
BoolValue.runtime = proto3_js_1$4.proto3;
BoolValue.typeName = "google.protobuf.BoolValue";
BoolValue.fields = proto3_js_1$4.proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "value",
    kind: "scalar",
    T: 8
    /* ScalarType.BOOL */
  }
]);
BoolValue.fieldWrapper = {
  wrapField(n) {
    return new BoolValue({ value: n });
  },
  unwrapField(n) {
    return n.value;
  }
};
class StringValue extends message_js_1$4.Message {
  constructor(c) {
    super(), this.value = "", proto3_js_1$4.proto3.util.initPartial(c, this);
  }
  toJson(c) {
    return proto3_js_1$4.proto3.json.writeScalar(scalar_js_1.ScalarType.STRING, this.value, !0);
  }
  fromJson(c, u) {
    try {
      this.value = proto3_js_1$4.proto3.json.readScalar(scalar_js_1.ScalarType.STRING, c);
    } catch (p) {
      let a = 'cannot decode message google.protobuf.StringValue from JSON"';
      throw p instanceof Error && p.message.length > 0 && (a += `: ${p.message}`), new Error(a);
    }
    return this;
  }
  static fromBinary(c, u) {
    return new StringValue().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new StringValue().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new StringValue().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto3_js_1$4.proto3.util.equals(StringValue, c, u);
  }
}
wrappers_pb.StringValue = StringValue;
StringValue.runtime = proto3_js_1$4.proto3;
StringValue.typeName = "google.protobuf.StringValue";
StringValue.fields = proto3_js_1$4.proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "value",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  }
]);
StringValue.fieldWrapper = {
  wrapField(n) {
    return new StringValue({ value: n });
  },
  unwrapField(n) {
    return n.value;
  }
};
class BytesValue extends message_js_1$4.Message {
  constructor(c) {
    super(), this.value = new Uint8Array(0), proto3_js_1$4.proto3.util.initPartial(c, this);
  }
  toJson(c) {
    return proto3_js_1$4.proto3.json.writeScalar(scalar_js_1.ScalarType.BYTES, this.value, !0);
  }
  fromJson(c, u) {
    try {
      this.value = proto3_js_1$4.proto3.json.readScalar(scalar_js_1.ScalarType.BYTES, c);
    } catch (p) {
      let a = 'cannot decode message google.protobuf.BytesValue from JSON"';
      throw p instanceof Error && p.message.length > 0 && (a += `: ${p.message}`), new Error(a);
    }
    return this;
  }
  static fromBinary(c, u) {
    return new BytesValue().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new BytesValue().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new BytesValue().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto3_js_1$4.proto3.util.equals(BytesValue, c, u);
  }
}
wrappers_pb.BytesValue = BytesValue;
BytesValue.runtime = proto3_js_1$4.proto3;
BytesValue.typeName = "google.protobuf.BytesValue";
BytesValue.fields = proto3_js_1$4.proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "value",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  }
]);
BytesValue.fieldWrapper = {
  wrapField(n) {
    return new BytesValue({ value: n });
  },
  unwrapField(n) {
    return n.value;
  }
};
Object.defineProperty(createRegistryFromDesc, "__esModule", { value: !0 });
createRegistryFromDesc.createRegistryFromDescriptors = void 0;
const assert_js_1 = assert$d, proto3_js_1$3 = proto3, proto2_js_1$1 = proto2, names_js_1 = names, timestamp_pb_js_1 = timestamp_pb, duration_pb_js_1 = duration_pb, any_pb_js_1$1 = any_pb, empty_pb_js_1 = empty_pb, field_mask_pb_js_1 = field_mask_pb, struct_pb_js_1 = struct_pb, enum_js_1 = _enum, wrappers_pb_js_1 = wrappers_pb, descriptor_pb_js_1$1 = descriptor_pb, create_descriptor_set_js_1 = createDescriptorSet$1, is_message_js_1$1 = isMessage$1, wkMessages = [
  any_pb_js_1$1.Any,
  duration_pb_js_1.Duration,
  empty_pb_js_1.Empty,
  field_mask_pb_js_1.FieldMask,
  struct_pb_js_1.Struct,
  struct_pb_js_1.Value,
  struct_pb_js_1.ListValue,
  timestamp_pb_js_1.Timestamp,
  duration_pb_js_1.Duration,
  wrappers_pb_js_1.DoubleValue,
  wrappers_pb_js_1.FloatValue,
  wrappers_pb_js_1.Int64Value,
  wrappers_pb_js_1.Int32Value,
  wrappers_pb_js_1.UInt32Value,
  wrappers_pb_js_1.UInt64Value,
  wrappers_pb_js_1.BoolValue,
  wrappers_pb_js_1.StringValue,
  wrappers_pb_js_1.BytesValue
], wkEnums = [(0, enum_js_1.getEnumType)(struct_pb_js_1.NullValue)];
function createRegistryFromDescriptors(n, c = !0) {
  const u = n instanceof Uint8Array || (0, is_message_js_1$1.isMessage)(n, descriptor_pb_js_1$1.FileDescriptorSet) ? (0, create_descriptor_set_js_1.createDescriptorSet)(n) : n, p = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), A = /* @__PURE__ */ new Map(), b = /* @__PURE__ */ new Map(), F = {};
  if (c) {
    for (const le of wkMessages)
      a.set(le.typeName, le);
    for (const le of wkEnums)
      p.set(le.typeName, le);
  }
  return {
    /**
     * May raise an error on invalid descriptors.
     */
    findEnum(le) {
      const L = p.get(le);
      if (L)
        return L;
      const pe = u.enums.get(le);
      if (!pe)
        return;
      const Ee = (pe.file.syntax == "proto3" ? proto3_js_1$3.proto3 : proto2_js_1$1.proto2).makeEnumType(le, pe.values.map((be) => ({
        no: be.number,
        name: be.name,
        localName: (0, names_js_1.localName)(be)
      })), {});
      return p.set(le, Ee), Ee;
    },
    /**
     * May raise an error on invalid descriptors.
     */
    findMessage(le) {
      const L = a.get(le);
      if (L)
        return L;
      const pe = u.messages.get(le);
      if (!pe)
        return;
      const $ = pe.file.syntax == "proto3" ? proto3_js_1$3.proto3 : proto2_js_1$1.proto2, Ee = [], be = $.makeMessageType(le, () => Ee, {
        localName: (0, names_js_1.localName)(pe)
      });
      a.set(le, be);
      for (const He of pe.fields)
        Ee.push(makeFieldInfo(He, this));
      return be;
    },
    /**
     * May raise an error on invalid descriptors.
     */
    findService(le) {
      const L = F[le];
      if (L)
        return L;
      const pe = u.services.get(le);
      if (!pe)
        return;
      const $ = {};
      for (const Ee of pe.methods) {
        const be = resolve(Ee.input, this, Ee), He = resolve(Ee.output, this, Ee);
        $[(0, names_js_1.localName)(Ee)] = {
          name: Ee.name,
          I: be,
          O: He,
          kind: Ee.methodKind,
          idempotency: Ee.idempotency
          // We do not surface options at this time
          // options: {},
        };
      }
      return F[le] = {
        typeName: pe.typeName,
        methods: $
      };
    },
    /**
     * May raise an error on invalid descriptors.
     */
    findExtensionFor(le, L) {
      var pe;
      if (!u.messages.has(le))
        return;
      let $ = b.get(le);
      if (!$) {
        $ = /* @__PURE__ */ new Map(), b.set(le, $);
        for (const be of u.extensions.values())
          be.extendee.typeName == le && $.set(be.number, be);
      }
      const Ee = (pe = b.get(le)) === null || pe === void 0 ? void 0 : pe.get(L);
      return Ee ? this.findExtension(Ee.typeName) : void 0;
    },
    /**
     * May raise an error on invalid descriptors.
     */
    findExtension(le) {
      const L = A.get(le);
      if (L)
        return L;
      const pe = u.extensions.get(le);
      if (!pe)
        return;
      const $ = resolve(pe.extendee, this, pe), be = (pe.file.syntax == "proto3" ? proto3_js_1$3.proto3 : proto2_js_1$1.proto2).makeExtension(le, $, makeFieldInfo(pe, this));
      return A.set(le, be), be;
    }
  };
}
createRegistryFromDesc.createRegistryFromDescriptors = createRegistryFromDescriptors;
function makeFieldInfo(n, c) {
  var u;
  const p = {
    kind: n.fieldKind,
    no: n.number,
    name: n.name,
    jsonName: n.jsonName,
    delimited: n.proto.type == descriptor_pb_js_1$1.FieldDescriptorProto_Type.GROUP,
    repeated: n.repeated,
    packed: n.packed,
    oneof: (u = n.oneof) === null || u === void 0 ? void 0 : u.name,
    opt: n.optional,
    req: n.proto.label === descriptor_pb_js_1$1.FieldDescriptorProto_Label.REQUIRED
  };
  switch (n.fieldKind) {
    case "map": {
      (0, assert_js_1.assert)(n.kind == "field");
      let a;
      switch (n.mapValue.kind) {
        case "scalar":
          a = n.mapValue.scalar;
          break;
        case "enum": {
          a = resolve(n.mapValue.enum, c, n);
          break;
        }
        case "message": {
          a = resolve(n.mapValue.message, c, n);
          break;
        }
      }
      p.K = n.mapKey, p.V = {
        kind: n.mapValue.kind,
        T: a
      };
      break;
    }
    case "message": {
      p.T = resolve(n.message, c, n);
      break;
    }
    case "enum": {
      p.T = resolve(n.enum, c, n), p.default = n.getDefaultValue();
      break;
    }
    case "scalar": {
      p.L = n.longType, p.T = n.scalar, p.default = n.getDefaultValue();
      break;
    }
  }
  return p;
}
function resolve(n, c, u) {
  const p = n.kind == "message" ? c.findMessage(n.typeName) : c.findEnum(n.typeName);
  return (0, assert_js_1.assert)(p, `${n.toString()}" for ${u.toString()} not found`), p;
}
var toPlainMessage$1 = {};
Object.defineProperty(toPlainMessage$1, "__esModule", { value: !0 });
toPlainMessage$1.toPlainMessage = void 0;
const is_message_js_1 = isMessage$1;
function toPlainMessage(n) {
  if (!(0, is_message_js_1.isMessage)(n))
    return n;
  const c = n.getType(), u = {};
  for (const p of c.fields.byMember()) {
    const a = n[p.localName];
    let A;
    if (p.repeated)
      A = a.map((b) => toPlainValue(b));
    else if (p.kind == "map") {
      A = {};
      for (const [b, F] of Object.entries(a))
        A[b] = toPlainValue(F);
    } else p.kind == "oneof" ? A = p.findField(a.case) ? { case: a.case, value: toPlainValue(a.value) } : { case: void 0 } : A = toPlainValue(a);
    u[p.localName] = A;
  }
  return u;
}
toPlainMessage$1.toPlainMessage = toPlainMessage;
function toPlainValue(n) {
  if (n === void 0)
    return n;
  if ((0, is_message_js_1.isMessage)(n))
    return toPlainMessage(n);
  if (n instanceof Uint8Array) {
    const c = new Uint8Array(n.byteLength);
    return c.set(n), c;
  }
  return n;
}
var plugin_pb = {};
Object.defineProperty(plugin_pb, "__esModule", { value: !0 });
plugin_pb.CodeGeneratorResponse_File = plugin_pb.CodeGeneratorResponse_Feature = plugin_pb.CodeGeneratorResponse = plugin_pb.CodeGeneratorRequest = plugin_pb.Version = void 0;
const message_js_1$3 = message, proto2_js_1 = proto2, descriptor_pb_js_1 = descriptor_pb;
class Version extends message_js_1$3.Message {
  constructor(c) {
    super(), proto2_js_1.proto2.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new Version().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new Version().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new Version().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto2_js_1.proto2.util.equals(Version, c, u);
  }
}
plugin_pb.Version = Version;
Version.runtime = proto2_js_1.proto2;
Version.typeName = "google.protobuf.compiler.Version";
Version.fields = proto2_js_1.proto2.util.newFieldList(() => [
  { no: 1, name: "major", kind: "scalar", T: 5, opt: !0 },
  { no: 2, name: "minor", kind: "scalar", T: 5, opt: !0 },
  { no: 3, name: "patch", kind: "scalar", T: 5, opt: !0 },
  { no: 4, name: "suffix", kind: "scalar", T: 9, opt: !0 }
]);
class CodeGeneratorRequest extends message_js_1$3.Message {
  constructor(c) {
    super(), this.fileToGenerate = [], this.protoFile = [], this.sourceFileDescriptors = [], proto2_js_1.proto2.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new CodeGeneratorRequest().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new CodeGeneratorRequest().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new CodeGeneratorRequest().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto2_js_1.proto2.util.equals(CodeGeneratorRequest, c, u);
  }
}
plugin_pb.CodeGeneratorRequest = CodeGeneratorRequest;
CodeGeneratorRequest.runtime = proto2_js_1.proto2;
CodeGeneratorRequest.typeName = "google.protobuf.compiler.CodeGeneratorRequest";
CodeGeneratorRequest.fields = proto2_js_1.proto2.util.newFieldList(() => [
  { no: 1, name: "file_to_generate", kind: "scalar", T: 9, repeated: !0 },
  { no: 2, name: "parameter", kind: "scalar", T: 9, opt: !0 },
  { no: 15, name: "proto_file", kind: "message", T: descriptor_pb_js_1.FileDescriptorProto, repeated: !0 },
  { no: 17, name: "source_file_descriptors", kind: "message", T: descriptor_pb_js_1.FileDescriptorProto, repeated: !0 },
  { no: 3, name: "compiler_version", kind: "message", T: Version, opt: !0 }
]);
class CodeGeneratorResponse extends message_js_1$3.Message {
  constructor(c) {
    super(), this.file = [], proto2_js_1.proto2.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new CodeGeneratorResponse().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new CodeGeneratorResponse().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new CodeGeneratorResponse().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto2_js_1.proto2.util.equals(CodeGeneratorResponse, c, u);
  }
}
plugin_pb.CodeGeneratorResponse = CodeGeneratorResponse;
CodeGeneratorResponse.runtime = proto2_js_1.proto2;
CodeGeneratorResponse.typeName = "google.protobuf.compiler.CodeGeneratorResponse";
CodeGeneratorResponse.fields = proto2_js_1.proto2.util.newFieldList(() => [
  { no: 1, name: "error", kind: "scalar", T: 9, opt: !0 },
  { no: 2, name: "supported_features", kind: "scalar", T: 4, opt: !0 },
  { no: 3, name: "minimum_edition", kind: "scalar", T: 5, opt: !0 },
  { no: 4, name: "maximum_edition", kind: "scalar", T: 5, opt: !0 },
  { no: 15, name: "file", kind: "message", T: CodeGeneratorResponse_File, repeated: !0 }
]);
var CodeGeneratorResponse_Feature;
(function(n) {
  n[n.NONE = 0] = "NONE", n[n.PROTO3_OPTIONAL = 1] = "PROTO3_OPTIONAL", n[n.SUPPORTS_EDITIONS = 2] = "SUPPORTS_EDITIONS";
})(CodeGeneratorResponse_Feature || (plugin_pb.CodeGeneratorResponse_Feature = CodeGeneratorResponse_Feature = {}));
proto2_js_1.proto2.util.setEnumType(CodeGeneratorResponse_Feature, "google.protobuf.compiler.CodeGeneratorResponse.Feature", [
  { no: 0, name: "FEATURE_NONE" },
  { no: 1, name: "FEATURE_PROTO3_OPTIONAL" },
  { no: 2, name: "FEATURE_SUPPORTS_EDITIONS" }
]);
class CodeGeneratorResponse_File extends message_js_1$3.Message {
  constructor(c) {
    super(), proto2_js_1.proto2.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new CodeGeneratorResponse_File().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new CodeGeneratorResponse_File().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new CodeGeneratorResponse_File().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto2_js_1.proto2.util.equals(CodeGeneratorResponse_File, c, u);
  }
}
plugin_pb.CodeGeneratorResponse_File = CodeGeneratorResponse_File;
CodeGeneratorResponse_File.runtime = proto2_js_1.proto2;
CodeGeneratorResponse_File.typeName = "google.protobuf.compiler.CodeGeneratorResponse.File";
CodeGeneratorResponse_File.fields = proto2_js_1.proto2.util.newFieldList(() => [
  { no: 1, name: "name", kind: "scalar", T: 9, opt: !0 },
  { no: 2, name: "insertion_point", kind: "scalar", T: 9, opt: !0 },
  { no: 15, name: "content", kind: "scalar", T: 9, opt: !0 },
  { no: 16, name: "generated_code_info", kind: "message", T: descriptor_pb_js_1.GeneratedCodeInfo, opt: !0 }
]);
var api_pb = {}, type_pb = {}, source_context_pb = {};
Object.defineProperty(source_context_pb, "__esModule", { value: !0 });
source_context_pb.SourceContext = void 0;
const message_js_1$2 = message, proto3_js_1$2 = proto3;
class SourceContext extends message_js_1$2.Message {
  constructor(c) {
    super(), this.fileName = "", proto3_js_1$2.proto3.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new SourceContext().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new SourceContext().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new SourceContext().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto3_js_1$2.proto3.util.equals(SourceContext, c, u);
  }
}
source_context_pb.SourceContext = SourceContext;
SourceContext.runtime = proto3_js_1$2.proto3;
SourceContext.typeName = "google.protobuf.SourceContext";
SourceContext.fields = proto3_js_1$2.proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "file_name",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  }
]);
Object.defineProperty(type_pb, "__esModule", { value: !0 });
type_pb.Option = type_pb.EnumValue = type_pb.Enum = type_pb.Field_Cardinality = type_pb.Field_Kind = type_pb.Field = type_pb.Type = type_pb.Syntax = void 0;
const proto3_js_1$1 = proto3, message_js_1$1 = message, source_context_pb_js_1$1 = source_context_pb, any_pb_js_1 = any_pb;
var Syntax;
(function(n) {
  n[n.PROTO2 = 0] = "PROTO2", n[n.PROTO3 = 1] = "PROTO3", n[n.EDITIONS = 2] = "EDITIONS";
})(Syntax || (type_pb.Syntax = Syntax = {}));
proto3_js_1$1.proto3.util.setEnumType(Syntax, "google.protobuf.Syntax", [
  { no: 0, name: "SYNTAX_PROTO2" },
  { no: 1, name: "SYNTAX_PROTO3" },
  { no: 2, name: "SYNTAX_EDITIONS" }
]);
class Type extends message_js_1$1.Message {
  constructor(c) {
    super(), this.name = "", this.fields = [], this.oneofs = [], this.options = [], this.syntax = Syntax.PROTO2, this.edition = "", proto3_js_1$1.proto3.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new Type().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new Type().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new Type().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto3_js_1$1.proto3.util.equals(Type, c, u);
  }
}
type_pb.Type = Type;
Type.runtime = proto3_js_1$1.proto3;
Type.typeName = "google.protobuf.Type";
Type.fields = proto3_js_1$1.proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "name",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  { no: 2, name: "fields", kind: "message", T: Field$3, repeated: !0 },
  { no: 3, name: "oneofs", kind: "scalar", T: 9, repeated: !0 },
  { no: 4, name: "options", kind: "message", T: Option, repeated: !0 },
  { no: 5, name: "source_context", kind: "message", T: source_context_pb_js_1$1.SourceContext },
  { no: 6, name: "syntax", kind: "enum", T: proto3_js_1$1.proto3.getEnumType(Syntax) },
  {
    no: 7,
    name: "edition",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  }
]);
let Field$3 = class Vh extends message_js_1$1.Message {
  constructor(c) {
    super(), this.kind = Field_Kind.TYPE_UNKNOWN, this.cardinality = Field_Cardinality.UNKNOWN, this.number = 0, this.name = "", this.typeUrl = "", this.oneofIndex = 0, this.packed = !1, this.options = [], this.jsonName = "", this.defaultValue = "", proto3_js_1$1.proto3.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new Vh().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new Vh().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new Vh().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto3_js_1$1.proto3.util.equals(Vh, c, u);
  }
};
type_pb.Field = Field$3;
Field$3.runtime = proto3_js_1$1.proto3;
Field$3.typeName = "google.protobuf.Field";
Field$3.fields = proto3_js_1$1.proto3.util.newFieldList(() => [
  { no: 1, name: "kind", kind: "enum", T: proto3_js_1$1.proto3.getEnumType(Field_Kind) },
  { no: 2, name: "cardinality", kind: "enum", T: proto3_js_1$1.proto3.getEnumType(Field_Cardinality) },
  {
    no: 3,
    name: "number",
    kind: "scalar",
    T: 5
    /* ScalarType.INT32 */
  },
  {
    no: 4,
    name: "name",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 6,
    name: "type_url",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 7,
    name: "oneof_index",
    kind: "scalar",
    T: 5
    /* ScalarType.INT32 */
  },
  {
    no: 8,
    name: "packed",
    kind: "scalar",
    T: 8
    /* ScalarType.BOOL */
  },
  { no: 9, name: "options", kind: "message", T: Option, repeated: !0 },
  {
    no: 10,
    name: "json_name",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 11,
    name: "default_value",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  }
]);
var Field_Kind;
(function(n) {
  n[n.TYPE_UNKNOWN = 0] = "TYPE_UNKNOWN", n[n.TYPE_DOUBLE = 1] = "TYPE_DOUBLE", n[n.TYPE_FLOAT = 2] = "TYPE_FLOAT", n[n.TYPE_INT64 = 3] = "TYPE_INT64", n[n.TYPE_UINT64 = 4] = "TYPE_UINT64", n[n.TYPE_INT32 = 5] = "TYPE_INT32", n[n.TYPE_FIXED64 = 6] = "TYPE_FIXED64", n[n.TYPE_FIXED32 = 7] = "TYPE_FIXED32", n[n.TYPE_BOOL = 8] = "TYPE_BOOL", n[n.TYPE_STRING = 9] = "TYPE_STRING", n[n.TYPE_GROUP = 10] = "TYPE_GROUP", n[n.TYPE_MESSAGE = 11] = "TYPE_MESSAGE", n[n.TYPE_BYTES = 12] = "TYPE_BYTES", n[n.TYPE_UINT32 = 13] = "TYPE_UINT32", n[n.TYPE_ENUM = 14] = "TYPE_ENUM", n[n.TYPE_SFIXED32 = 15] = "TYPE_SFIXED32", n[n.TYPE_SFIXED64 = 16] = "TYPE_SFIXED64", n[n.TYPE_SINT32 = 17] = "TYPE_SINT32", n[n.TYPE_SINT64 = 18] = "TYPE_SINT64";
})(Field_Kind || (type_pb.Field_Kind = Field_Kind = {}));
proto3_js_1$1.proto3.util.setEnumType(Field_Kind, "google.protobuf.Field.Kind", [
  { no: 0, name: "TYPE_UNKNOWN" },
  { no: 1, name: "TYPE_DOUBLE" },
  { no: 2, name: "TYPE_FLOAT" },
  { no: 3, name: "TYPE_INT64" },
  { no: 4, name: "TYPE_UINT64" },
  { no: 5, name: "TYPE_INT32" },
  { no: 6, name: "TYPE_FIXED64" },
  { no: 7, name: "TYPE_FIXED32" },
  { no: 8, name: "TYPE_BOOL" },
  { no: 9, name: "TYPE_STRING" },
  { no: 10, name: "TYPE_GROUP" },
  { no: 11, name: "TYPE_MESSAGE" },
  { no: 12, name: "TYPE_BYTES" },
  { no: 13, name: "TYPE_UINT32" },
  { no: 14, name: "TYPE_ENUM" },
  { no: 15, name: "TYPE_SFIXED32" },
  { no: 16, name: "TYPE_SFIXED64" },
  { no: 17, name: "TYPE_SINT32" },
  { no: 18, name: "TYPE_SINT64" }
]);
var Field_Cardinality;
(function(n) {
  n[n.UNKNOWN = 0] = "UNKNOWN", n[n.OPTIONAL = 1] = "OPTIONAL", n[n.REQUIRED = 2] = "REQUIRED", n[n.REPEATED = 3] = "REPEATED";
})(Field_Cardinality || (type_pb.Field_Cardinality = Field_Cardinality = {}));
proto3_js_1$1.proto3.util.setEnumType(Field_Cardinality, "google.protobuf.Field.Cardinality", [
  { no: 0, name: "CARDINALITY_UNKNOWN" },
  { no: 1, name: "CARDINALITY_OPTIONAL" },
  { no: 2, name: "CARDINALITY_REQUIRED" },
  { no: 3, name: "CARDINALITY_REPEATED" }
]);
class Enum extends message_js_1$1.Message {
  constructor(c) {
    super(), this.name = "", this.enumvalue = [], this.options = [], this.syntax = Syntax.PROTO2, this.edition = "", proto3_js_1$1.proto3.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new Enum().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new Enum().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new Enum().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto3_js_1$1.proto3.util.equals(Enum, c, u);
  }
}
type_pb.Enum = Enum;
Enum.runtime = proto3_js_1$1.proto3;
Enum.typeName = "google.protobuf.Enum";
Enum.fields = proto3_js_1$1.proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "name",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  { no: 2, name: "enumvalue", kind: "message", T: EnumValue, repeated: !0 },
  { no: 3, name: "options", kind: "message", T: Option, repeated: !0 },
  { no: 4, name: "source_context", kind: "message", T: source_context_pb_js_1$1.SourceContext },
  { no: 5, name: "syntax", kind: "enum", T: proto3_js_1$1.proto3.getEnumType(Syntax) },
  {
    no: 6,
    name: "edition",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  }
]);
class EnumValue extends message_js_1$1.Message {
  constructor(c) {
    super(), this.name = "", this.number = 0, this.options = [], proto3_js_1$1.proto3.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new EnumValue().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new EnumValue().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new EnumValue().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto3_js_1$1.proto3.util.equals(EnumValue, c, u);
  }
}
type_pb.EnumValue = EnumValue;
EnumValue.runtime = proto3_js_1$1.proto3;
EnumValue.typeName = "google.protobuf.EnumValue";
EnumValue.fields = proto3_js_1$1.proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "name",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 2,
    name: "number",
    kind: "scalar",
    T: 5
    /* ScalarType.INT32 */
  },
  { no: 3, name: "options", kind: "message", T: Option, repeated: !0 }
]);
class Option extends message_js_1$1.Message {
  constructor(c) {
    super(), this.name = "", proto3_js_1$1.proto3.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new Option().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new Option().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new Option().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto3_js_1$1.proto3.util.equals(Option, c, u);
  }
}
type_pb.Option = Option;
Option.runtime = proto3_js_1$1.proto3;
Option.typeName = "google.protobuf.Option";
Option.fields = proto3_js_1$1.proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "name",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  { no: 2, name: "value", kind: "message", T: any_pb_js_1.Any }
]);
Object.defineProperty(api_pb, "__esModule", { value: !0 });
api_pb.Mixin = api_pb.Method = api_pb.Api = void 0;
const message_js_1 = message, type_pb_js_1 = type_pb, source_context_pb_js_1 = source_context_pb, proto3_js_1 = proto3;
class Api extends message_js_1.Message {
  constructor(c) {
    super(), this.name = "", this.methods = [], this.options = [], this.version = "", this.mixins = [], this.syntax = type_pb_js_1.Syntax.PROTO2, proto3_js_1.proto3.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new Api().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new Api().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new Api().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto3_js_1.proto3.util.equals(Api, c, u);
  }
}
api_pb.Api = Api;
Api.runtime = proto3_js_1.proto3;
Api.typeName = "google.protobuf.Api";
Api.fields = proto3_js_1.proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "name",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  { no: 2, name: "methods", kind: "message", T: Method, repeated: !0 },
  { no: 3, name: "options", kind: "message", T: type_pb_js_1.Option, repeated: !0 },
  {
    no: 4,
    name: "version",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  { no: 5, name: "source_context", kind: "message", T: source_context_pb_js_1.SourceContext },
  { no: 6, name: "mixins", kind: "message", T: Mixin, repeated: !0 },
  { no: 7, name: "syntax", kind: "enum", T: proto3_js_1.proto3.getEnumType(type_pb_js_1.Syntax) }
]);
class Method extends message_js_1.Message {
  constructor(c) {
    super(), this.name = "", this.requestTypeUrl = "", this.requestStreaming = !1, this.responseTypeUrl = "", this.responseStreaming = !1, this.options = [], this.syntax = type_pb_js_1.Syntax.PROTO2, proto3_js_1.proto3.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new Method().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new Method().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new Method().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto3_js_1.proto3.util.equals(Method, c, u);
  }
}
api_pb.Method = Method;
Method.runtime = proto3_js_1.proto3;
Method.typeName = "google.protobuf.Method";
Method.fields = proto3_js_1.proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "name",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 2,
    name: "request_type_url",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 3,
    name: "request_streaming",
    kind: "scalar",
    T: 8
    /* ScalarType.BOOL */
  },
  {
    no: 4,
    name: "response_type_url",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 5,
    name: "response_streaming",
    kind: "scalar",
    T: 8
    /* ScalarType.BOOL */
  },
  { no: 6, name: "options", kind: "message", T: type_pb_js_1.Option, repeated: !0 },
  { no: 7, name: "syntax", kind: "enum", T: proto3_js_1.proto3.getEnumType(type_pb_js_1.Syntax) }
]);
class Mixin extends message_js_1.Message {
  constructor(c) {
    super(), this.name = "", this.root = "", proto3_js_1.proto3.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new Mixin().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new Mixin().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new Mixin().fromJsonString(c, u);
  }
  static equals(c, u) {
    return proto3_js_1.proto3.util.equals(Mixin, c, u);
  }
}
api_pb.Mixin = Mixin;
Mixin.runtime = proto3_js_1.proto3;
Mixin.typeName = "google.protobuf.Mixin";
Mixin.fields = proto3_js_1.proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "name",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 2,
    name: "root",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  }
]);
(function(n) {
  var c = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(Ir, xr, kr, Ce) {
    Ce === void 0 && (Ce = kr);
    var tr = Object.getOwnPropertyDescriptor(xr, kr);
    (!tr || ("get" in tr ? !xr.__esModule : tr.writable || tr.configurable)) && (tr = { enumerable: !0, get: function() {
      return xr[kr];
    } }), Object.defineProperty(Ir, Ce, tr);
  } : function(Ir, xr, kr, Ce) {
    Ce === void 0 && (Ce = kr), Ir[Ce] = xr[kr];
  }), u = commonjsGlobal && commonjsGlobal.__exportStar || function(Ir, xr) {
    for (var kr in Ir) kr !== "default" && !Object.prototype.hasOwnProperty.call(xr, kr) && c(xr, Ir, kr);
  };
  Object.defineProperty(n, "__esModule", { value: !0 }), n.toPlainMessage = n.createRegistryFromDescriptors = n.createRegistry = n.createDescriptorSet = n.BinaryReader = n.BinaryWriter = n.WireType = n.MethodIdempotency = n.MethodKind = n.clearExtension = n.hasExtension = n.setExtension = n.getExtension = n.ScalarType = n.LongType = n.isMessage = n.Message = n.codegenInfo = n.protoDelimited = n.protoBase64 = n.protoInt64 = n.protoDouble = n.proto2 = n.proto3 = void 0;
  var p = proto3;
  Object.defineProperty(n, "proto3", { enumerable: !0, get: function() {
    return p.proto3;
  } });
  var a = proto2;
  Object.defineProperty(n, "proto2", { enumerable: !0, get: function() {
    return a.proto2;
  } });
  var A = protoDouble;
  Object.defineProperty(n, "protoDouble", { enumerable: !0, get: function() {
    return A.protoDouble;
  } });
  var b = protoInt64;
  Object.defineProperty(n, "protoInt64", { enumerable: !0, get: function() {
    return b.protoInt64;
  } });
  var F = protoBase64;
  Object.defineProperty(n, "protoBase64", { enumerable: !0, get: function() {
    return F.protoBase64;
  } });
  var le = protoDelimited;
  Object.defineProperty(n, "protoDelimited", { enumerable: !0, get: function() {
    return le.protoDelimited;
  } });
  var L = codegenInfo;
  Object.defineProperty(n, "codegenInfo", { enumerable: !0, get: function() {
    return L.codegenInfo;
  } });
  var pe = message;
  Object.defineProperty(n, "Message", { enumerable: !0, get: function() {
    return pe.Message;
  } });
  var $ = isMessage$1;
  Object.defineProperty(n, "isMessage", { enumerable: !0, get: function() {
    return $.isMessage;
  } });
  var Ee = scalar;
  Object.defineProperty(n, "LongType", { enumerable: !0, get: function() {
    return Ee.LongType;
  } }), Object.defineProperty(n, "ScalarType", { enumerable: !0, get: function() {
    return Ee.ScalarType;
  } });
  var be = extensionAccessor;
  Object.defineProperty(n, "getExtension", { enumerable: !0, get: function() {
    return be.getExtension;
  } }), Object.defineProperty(n, "setExtension", { enumerable: !0, get: function() {
    return be.setExtension;
  } }), Object.defineProperty(n, "hasExtension", { enumerable: !0, get: function() {
    return be.hasExtension;
  } }), Object.defineProperty(n, "clearExtension", { enumerable: !0, get: function() {
    return be.clearExtension;
  } });
  var He = serviceType;
  Object.defineProperty(n, "MethodKind", { enumerable: !0, get: function() {
    return He.MethodKind;
  } }), Object.defineProperty(n, "MethodIdempotency", { enumerable: !0, get: function() {
    return He.MethodIdempotency;
  } });
  var Pe = binaryEncoding;
  Object.defineProperty(n, "WireType", { enumerable: !0, get: function() {
    return Pe.WireType;
  } }), Object.defineProperty(n, "BinaryWriter", { enumerable: !0, get: function() {
    return Pe.BinaryWriter;
  } }), Object.defineProperty(n, "BinaryReader", { enumerable: !0, get: function() {
    return Pe.BinaryReader;
  } });
  var nr = createDescriptorSet$1;
  Object.defineProperty(n, "createDescriptorSet", { enumerable: !0, get: function() {
    return nr.createDescriptorSet;
  } });
  var ir = createRegistry$1;
  Object.defineProperty(n, "createRegistry", { enumerable: !0, get: function() {
    return ir.createRegistry;
  } });
  var or = createRegistryFromDesc;
  Object.defineProperty(n, "createRegistryFromDescriptors", { enumerable: !0, get: function() {
    return or.createRegistryFromDescriptors;
  } });
  var lr = toPlainMessage$1;
  Object.defineProperty(n, "toPlainMessage", { enumerable: !0, get: function() {
    return lr.toPlainMessage;
  } }), u(plugin_pb, n), u(api_pb, n), u(any_pb, n), u(descriptor_pb, n), u(duration_pb, n), u(empty_pb, n), u(field_mask_pb, n), u(source_context_pb, n), u(struct_pb, n), u(timestamp_pb, n), u(type_pb, n), u(wrappers_pb, n);
})(cjs$1);
Object.defineProperty(contract_pb, "__esModule", { value: !0 });
contract_pb.TriggerSmartContract = contract_pb.TransferAssetContract = contract_pb.TransferContract = void 0;
const protobuf_1$8 = cjs$1;
class TransferContract extends protobuf_1$8.Message {
  constructor(c) {
    super(), this.ownerAddress = new Uint8Array(0), this.toAddress = new Uint8Array(0), this.amount = protobuf_1$8.protoInt64.zero, protobuf_1$8.proto3.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new TransferContract().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new TransferContract().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new TransferContract().fromJsonString(c, u);
  }
  static equals(c, u) {
    return protobuf_1$8.proto3.util.equals(TransferContract, c, u);
  }
}
TransferContract.runtime = protobuf_1$8.proto3;
TransferContract.typeName = "protocol.TransferContract";
TransferContract.fields = protobuf_1$8.proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "owner_address",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  },
  {
    no: 2,
    name: "to_address",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  },
  {
    no: 3,
    name: "amount",
    kind: "scalar",
    T: 3
    /* ScalarType.INT64 */
  }
]);
contract_pb.TransferContract = TransferContract;
class TransferAssetContract extends protobuf_1$8.Message {
  constructor(c) {
    super(), this.assetName = new Uint8Array(0), this.ownerAddress = new Uint8Array(0), this.toAddress = new Uint8Array(0), this.amount = protobuf_1$8.protoInt64.zero, protobuf_1$8.proto3.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new TransferAssetContract().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new TransferAssetContract().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new TransferAssetContract().fromJsonString(c, u);
  }
  static equals(c, u) {
    return protobuf_1$8.proto3.util.equals(TransferAssetContract, c, u);
  }
}
TransferAssetContract.runtime = protobuf_1$8.proto3;
TransferAssetContract.typeName = "protocol.TransferAssetContract";
TransferAssetContract.fields = protobuf_1$8.proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "asset_name",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  },
  {
    no: 2,
    name: "owner_address",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  },
  {
    no: 3,
    name: "to_address",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  },
  {
    no: 4,
    name: "amount",
    kind: "scalar",
    T: 3
    /* ScalarType.INT64 */
  }
]);
contract_pb.TransferAssetContract = TransferAssetContract;
class TriggerSmartContract extends protobuf_1$8.Message {
  constructor(c) {
    super(), this.ownerAddress = new Uint8Array(0), this.contractAddress = new Uint8Array(0), this.callValue = protobuf_1$8.protoInt64.zero, this.data = new Uint8Array(0), this.callTokenValue = protobuf_1$8.protoInt64.zero, this.tokenId = protobuf_1$8.protoInt64.zero, protobuf_1$8.proto3.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new TriggerSmartContract().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new TriggerSmartContract().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new TriggerSmartContract().fromJsonString(c, u);
  }
  static equals(c, u) {
    return protobuf_1$8.proto3.util.equals(TriggerSmartContract, c, u);
  }
}
TriggerSmartContract.runtime = protobuf_1$8.proto3;
TriggerSmartContract.typeName = "protocol.TriggerSmartContract";
TriggerSmartContract.fields = protobuf_1$8.proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "owner_address",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  },
  {
    no: 2,
    name: "contract_address",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  },
  {
    no: 3,
    name: "call_value",
    kind: "scalar",
    T: 3
    /* ScalarType.INT64 */
  },
  {
    no: 4,
    name: "data",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  },
  {
    no: 5,
    name: "call_token_value",
    kind: "scalar",
    T: 3
    /* ScalarType.INT64 */
  },
  {
    no: 6,
    name: "token_id",
    kind: "scalar",
    T: 3
    /* ScalarType.INT64 */
  }
]);
contract_pb.TriggerSmartContract = TriggerSmartContract;
var tron_pb = {};
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.Transaction_raw = n.Transaction_Contract_ContractType = n.Transaction_Contract = n.Transaction = n.authority = n.AccountId = void 0;
  const c = cjs$1;
  class u extends c.Message {
    constructor(L) {
      super(), this.name = new Uint8Array(0), this.address = new Uint8Array(0), c.proto3.util.initPartial(L, this);
    }
    static fromBinary(L, pe) {
      return new u().fromBinary(L, pe);
    }
    static fromJson(L, pe) {
      return new u().fromJson(L, pe);
    }
    static fromJsonString(L, pe) {
      return new u().fromJsonString(L, pe);
    }
    static equals(L, pe) {
      return c.proto3.util.equals(u, L, pe);
    }
  }
  u.runtime = c.proto3, u.typeName = "protocol.AccountId", u.fields = c.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    },
    {
      no: 2,
      name: "address",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    }
  ]), n.AccountId = u;
  class p extends c.Message {
    constructor(L) {
      super(), this.permissionName = new Uint8Array(0), c.proto3.util.initPartial(L, this);
    }
    static fromBinary(L, pe) {
      return new p().fromBinary(L, pe);
    }
    static fromJson(L, pe) {
      return new p().fromJson(L, pe);
    }
    static fromJsonString(L, pe) {
      return new p().fromJsonString(L, pe);
    }
    static equals(L, pe) {
      return c.proto3.util.equals(p, L, pe);
    }
  }
  p.runtime = c.proto3, p.typeName = "protocol.authority", p.fields = c.proto3.util.newFieldList(() => [
    { no: 1, name: "account", kind: "message", T: u },
    {
      no: 2,
      name: "permission_name",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    }
  ]), n.authority = p;
  class a extends c.Message {
    constructor(L) {
      super(), this.signature = [], c.proto3.util.initPartial(L, this);
    }
    static fromBinary(L, pe) {
      return new a().fromBinary(L, pe);
    }
    static fromJson(L, pe) {
      return new a().fromJson(L, pe);
    }
    static fromJsonString(L, pe) {
      return new a().fromJsonString(L, pe);
    }
    static equals(L, pe) {
      return c.proto3.util.equals(a, L, pe);
    }
  }
  a.runtime = c.proto3, a.typeName = "protocol.Transaction", a.fields = c.proto3.util.newFieldList(() => [
    { no: 1, name: "raw_data", kind: "message", T: F },
    { no: 2, name: "signature", kind: "scalar", T: 12, repeated: !0 }
  ]), n.Transaction = a;
  class A extends c.Message {
    constructor(L) {
      super(), this.type = b.AccountCreateContract, this.provider = new Uint8Array(0), this.ContractName = new Uint8Array(0), this.PermissionId = 0, c.proto3.util.initPartial(L, this);
    }
    static fromBinary(L, pe) {
      return new A().fromBinary(L, pe);
    }
    static fromJson(L, pe) {
      return new A().fromJson(L, pe);
    }
    static fromJsonString(L, pe) {
      return new A().fromJsonString(L, pe);
    }
    static equals(L, pe) {
      return c.proto3.util.equals(A, L, pe);
    }
  }
  A.runtime = c.proto3, A.typeName = "protocol.Transaction.Contract", A.fields = c.proto3.util.newFieldList(() => [
    { no: 1, name: "type", kind: "enum", T: c.proto3.getEnumType(b) },
    { no: 2, name: "parameter", kind: "message", T: c.Any },
    {
      no: 3,
      name: "provider",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    },
    {
      no: 4,
      name: "ContractName",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    },
    {
      no: 5,
      name: "Permission_id",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    }
  ]), n.Transaction_Contract = A;
  var b;
  (function(le) {
    le[le.AccountCreateContract = 0] = "AccountCreateContract", le[le.TransferContract = 1] = "TransferContract", le[le.TransferAssetContract = 2] = "TransferAssetContract", le[le.TriggerSmartContract = 31] = "TriggerSmartContract";
  })(b = n.Transaction_Contract_ContractType || (n.Transaction_Contract_ContractType = {})), c.proto3.util.setEnumType(b, "protocol.Transaction.Contract.ContractType", [
    { no: 0, name: "AccountCreateContract" },
    { no: 1, name: "TransferContract" },
    { no: 2, name: "TransferAssetContract" },
    { no: 31, name: "TriggerSmartContract" }
  ]);
  class F extends c.Message {
    constructor(L) {
      super(), this.refBlockBytes = new Uint8Array(0), this.refBlockNum = c.protoInt64.zero, this.refBlockHash = new Uint8Array(0), this.expiration = c.protoInt64.zero, this.auths = [], this.data = new Uint8Array(0), this.contract = [], this.scripts = new Uint8Array(0), this.timestamp = c.protoInt64.zero, this.feeLimit = c.protoInt64.zero, c.proto3.util.initPartial(L, this);
    }
    static fromBinary(L, pe) {
      return new F().fromBinary(L, pe);
    }
    static fromJson(L, pe) {
      return new F().fromJson(L, pe);
    }
    static fromJsonString(L, pe) {
      return new F().fromJsonString(L, pe);
    }
    static equals(L, pe) {
      return c.proto3.util.equals(F, L, pe);
    }
  }
  F.runtime = c.proto3, F.typeName = "protocol.Transaction.raw", F.fields = c.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "ref_block_bytes",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    },
    {
      no: 3,
      name: "ref_block_num",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    },
    {
      no: 4,
      name: "ref_block_hash",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    },
    {
      no: 8,
      name: "expiration",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    },
    { no: 9, name: "auths", kind: "message", T: p, repeated: !0 },
    {
      no: 10,
      name: "data",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    },
    { no: 11, name: "contract", kind: "message", T: A, repeated: !0 },
    {
      no: 12,
      name: "scripts",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    },
    {
      no: 14,
      name: "timestamp",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    },
    {
      no: 18,
      name: "fee_limit",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    }
  ]), n.Transaction_raw = F;
})(tron_pb);
var tron_transaction_pb = {};
Object.defineProperty(tron_transaction_pb, "__esModule", { value: !0 });
tron_transaction_pb.TronTx = tron_transaction_pb.Override = tron_transaction_pb.LatestBlock = void 0;
const protobuf_1$7 = cjs$1;
class LatestBlock extends protobuf_1$7.Message {
  constructor(c) {
    super(), this.hash = "", this.number = 0, this.timestamp = protobuf_1$7.protoInt64.zero, protobuf_1$7.proto3.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new LatestBlock().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new LatestBlock().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new LatestBlock().fromJsonString(c, u);
  }
  static equals(c, u) {
    return protobuf_1$7.proto3.util.equals(LatestBlock, c, u);
  }
}
LatestBlock.runtime = protobuf_1$7.proto3;
LatestBlock.typeName = "protoc.LatestBlock";
LatestBlock.fields = protobuf_1$7.proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "hash",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 2,
    name: "number",
    kind: "scalar",
    T: 5
    /* ScalarType.INT32 */
  },
  {
    no: 3,
    name: "timestamp",
    kind: "scalar",
    T: 3
    /* ScalarType.INT64 */
  }
]);
tron_transaction_pb.LatestBlock = LatestBlock;
class Override extends protobuf_1$7.Message {
  constructor(c) {
    super(), this.tokenShortName = "", this.tokenFullName = "", this.decimals = 0, protobuf_1$7.proto3.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new Override().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new Override().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new Override().fromJsonString(c, u);
  }
  static equals(c, u) {
    return protobuf_1$7.proto3.util.equals(Override, c, u);
  }
}
Override.runtime = protobuf_1$7.proto3;
Override.typeName = "protoc.Override";
Override.fields = protobuf_1$7.proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "tokenShortName",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 2,
    name: "tokenFullName",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 3,
    name: "decimals",
    kind: "scalar",
    T: 5
    /* ScalarType.INT32 */
  }
]);
tron_transaction_pb.Override = Override;
class TronTx extends protobuf_1$7.Message {
  constructor(c) {
    super(), this.token = "", this.contractAddress = "", this.from = "", this.to = "", this.memo = "", this.value = "", this.fee = 0, protobuf_1$7.proto3.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new TronTx().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new TronTx().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new TronTx().fromJsonString(c, u);
  }
  static equals(c, u) {
    return protobuf_1$7.proto3.util.equals(TronTx, c, u);
  }
}
TronTx.runtime = protobuf_1$7.proto3;
TronTx.typeName = "protoc.TronTx";
TronTx.fields = protobuf_1$7.proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "token",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 2,
    name: "contractAddress",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 3,
    name: "from",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 4,
    name: "to",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 5,
    name: "memo",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 6,
    name: "value",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  { no: 7, name: "latestBlock", kind: "message", T: LatestBlock },
  { no: 8, name: "override", kind: "message", T: Override },
  {
    no: 9,
    name: "fee",
    kind: "scalar",
    T: 5
    /* ScalarType.INT32 */
  }
]);
tron_transaction_pb.TronTx = TronTx;
var __importDefault$b = commonjsGlobal && commonjsGlobal.__importDefault || function(n) {
  return n && n.__esModule ? n : { default: n };
};
Object.defineProperty(transfer, "__esModule", { value: !0 });
transfer.raw2tx = void 0;
const bs58check_1$1 = __importDefault$b(bs58check$k), contract_pb_1 = contract_pb, tron_pb_1 = tron_pb, utils_1$i = utils$K, tron_transaction_pb_1$1 = tron_transaction_pb;
function formatAddress$1(n) {
  return bs58check_1$1.default.encode(n);
}
function raw2tx(n, c) {
  let u;
  try {
    u = tron_pb_1.Transaction_raw.fromBinary(n);
  } catch {
    throw new Error("Sign data is invalid");
  }
  const p = c !== void 0 ? {
    decimals: c.decimals,
    tokenFullName: c.name,
    tokenShortName: c.symbol
  } : null, a = Buffer$f.from([...new Uint8Array(8).fill(0), ...u.refBlockHash, ...new Uint8Array(16).fill(0)]), A = new tron_transaction_pb_1$1.LatestBlock({
    hash: (0, utils_1$i.toHex)(a),
    number: +`0x${(0, utils_1$i.toHex)(u.refBlockBytes.slice(0, 2))}`,
    timestamp: BigInt(Number(u.expiration) - 600 * 5 * 1e3)
  }), b = u.contract[0];
  if (b.parameter === void 0)
    throw new Error("contract is invalid");
  let F;
  switch (b.type) {
    case tron_pb_1.Transaction_Contract_ContractType.TransferContract:
      try {
        F = contract_pb_1.TransferContract.fromBinary(b.parameter.value);
      } catch {
        throw new Error("sign data is invalid");
      }
      return new tron_transaction_pb_1$1.TronTx({
        fee: Number(u.feeLimit),
        from: formatAddress$1(F.ownerAddress),
        latestBlock: A,
        to: formatAddress$1(F.toAddress),
        token: "TRX",
        value: F.amount.toString()
      });
    case tron_pb_1.Transaction_Contract_ContractType.TransferAssetContract:
      try {
        F = contract_pb_1.TransferAssetContract.fromBinary(b.parameter.value);
      } catch {
        throw new Error("sign data is invalid");
      }
      if (p == null)
        throw new Error("token info is invalid");
      return new tron_transaction_pb_1$1.TronTx({
        fee: Number(u.feeLimit),
        from: formatAddress$1(F.ownerAddress),
        latestBlock: A,
        override: p,
        to: formatAddress$1(F.toAddress),
        token: Buffer$f.from(F.assetName).toString(),
        value: F.amount.toString()
      });
    case tron_pb_1.Transaction_Contract_ContractType.TriggerSmartContract:
      try {
        F = contract_pb_1.TriggerSmartContract.fromBinary(b.parameter.value);
      } catch {
        throw new Error("sign data is invalid");
      }
      if (p == null)
        throw new Error("token info is invalid");
      return new tron_transaction_pb_1$1.TronTx({
        contractAddress: formatAddress$1(F.contractAddress),
        fee: Number(u.feeLimit),
        from: formatAddress$1(F.ownerAddress),
        latestBlock: A,
        override: p,
        to: formatAddress$1(Buffer$f.from([65, ...F.data.slice(16, 36)])),
        value: BigInt(`0x${Buffer$f.from(F.data.slice(36, 68)).toString("hex")}`).toString()
      });
    default:
      throw new Error("contract is not supported");
  }
}
transfer.raw2tx = raw2tx;
var pako = {}, deflate$4 = {}, deflate$3 = {}, trees = {};
const Z_FIXED$1 = 4, Z_BINARY = 0, Z_TEXT = 1, Z_UNKNOWN$1 = 2;
function zero$1(n) {
  let c = n.length;
  for (; --c >= 0; )
    n[c] = 0;
}
const STORED_BLOCK = 0, STATIC_TREES = 1, DYN_TREES = 2, MIN_MATCH$1 = 3, MAX_MATCH$1 = 258, LENGTH_CODES$1 = 29, LITERALS$1 = 256, L_CODES$1 = LITERALS$1 + 1 + LENGTH_CODES$1, D_CODES$1 = 30, BL_CODES$1 = 19, HEAP_SIZE$1 = 2 * L_CODES$1 + 1, MAX_BITS$1 = 15, Buf_size = 16, MAX_BL_BITS = 7, END_BLOCK = 256, REP_3_6 = 16, REPZ_3_10 = 17, REPZ_11_138 = 18, extra_lbits = (
  /* extra bits for each length code */
  new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0])
), extra_dbits = (
  /* extra bits for each distance code */
  new Uint8Array([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13])
), extra_blbits = (
  /* extra bits for each bit length code */
  new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7])
), bl_order = new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), DIST_CODE_LEN = 512, static_ltree = new Array((L_CODES$1 + 2) * 2);
zero$1(static_ltree);
const static_dtree = new Array(D_CODES$1 * 2);
zero$1(static_dtree);
const _dist_code = new Array(DIST_CODE_LEN);
zero$1(_dist_code);
const _length_code = new Array(MAX_MATCH$1 - MIN_MATCH$1 + 1);
zero$1(_length_code);
const base_length = new Array(LENGTH_CODES$1);
zero$1(base_length);
const base_dist = new Array(D_CODES$1);
zero$1(base_dist);
function StaticTreeDesc(n, c, u, p, a) {
  this.static_tree = n, this.extra_bits = c, this.extra_base = u, this.elems = p, this.max_length = a, this.has_stree = n && n.length;
}
let static_l_desc, static_d_desc, static_bl_desc;
function TreeDesc(n, c) {
  this.dyn_tree = n, this.max_code = 0, this.stat_desc = c;
}
const d_code = (n) => n < 256 ? _dist_code[n] : _dist_code[256 + (n >>> 7)], put_short = (n, c) => {
  n.pending_buf[n.pending++] = c & 255, n.pending_buf[n.pending++] = c >>> 8 & 255;
}, send_bits = (n, c, u) => {
  n.bi_valid > Buf_size - u ? (n.bi_buf |= c << n.bi_valid & 65535, put_short(n, n.bi_buf), n.bi_buf = c >> Buf_size - n.bi_valid, n.bi_valid += u - Buf_size) : (n.bi_buf |= c << n.bi_valid & 65535, n.bi_valid += u);
}, send_code = (n, c, u) => {
  send_bits(
    n,
    u[c * 2],
    u[c * 2 + 1]
    /*.Len*/
  );
}, bi_reverse = (n, c) => {
  let u = 0;
  do
    u |= n & 1, n >>>= 1, u <<= 1;
  while (--c > 0);
  return u >>> 1;
}, bi_flush = (n) => {
  n.bi_valid === 16 ? (put_short(n, n.bi_buf), n.bi_buf = 0, n.bi_valid = 0) : n.bi_valid >= 8 && (n.pending_buf[n.pending++] = n.bi_buf & 255, n.bi_buf >>= 8, n.bi_valid -= 8);
}, gen_bitlen = (n, c) => {
  const u = c.dyn_tree, p = c.max_code, a = c.stat_desc.static_tree, A = c.stat_desc.has_stree, b = c.stat_desc.extra_bits, F = c.stat_desc.extra_base, le = c.stat_desc.max_length;
  let L, pe, $, Ee, be, He, Pe = 0;
  for (Ee = 0; Ee <= MAX_BITS$1; Ee++)
    n.bl_count[Ee] = 0;
  for (u[n.heap[n.heap_max] * 2 + 1] = 0, L = n.heap_max + 1; L < HEAP_SIZE$1; L++)
    pe = n.heap[L], Ee = u[u[pe * 2 + 1] * 2 + 1] + 1, Ee > le && (Ee = le, Pe++), u[pe * 2 + 1] = Ee, !(pe > p) && (n.bl_count[Ee]++, be = 0, pe >= F && (be = b[pe - F]), He = u[pe * 2], n.opt_len += He * (Ee + be), A && (n.static_len += He * (a[pe * 2 + 1] + be)));
  if (Pe !== 0) {
    do {
      for (Ee = le - 1; n.bl_count[Ee] === 0; )
        Ee--;
      n.bl_count[Ee]--, n.bl_count[Ee + 1] += 2, n.bl_count[le]--, Pe -= 2;
    } while (Pe > 0);
    for (Ee = le; Ee !== 0; Ee--)
      for (pe = n.bl_count[Ee]; pe !== 0; )
        $ = n.heap[--L], !($ > p) && (u[$ * 2 + 1] !== Ee && (n.opt_len += (Ee - u[$ * 2 + 1]) * u[$ * 2], u[$ * 2 + 1] = Ee), pe--);
  }
}, gen_codes = (n, c, u) => {
  const p = new Array(MAX_BITS$1 + 1);
  let a = 0, A, b;
  for (A = 1; A <= MAX_BITS$1; A++)
    a = a + u[A - 1] << 1, p[A] = a;
  for (b = 0; b <= c; b++) {
    let F = n[b * 2 + 1];
    F !== 0 && (n[b * 2] = bi_reverse(p[F]++, F));
  }
}, tr_static_init = () => {
  let n, c, u, p, a;
  const A = new Array(MAX_BITS$1 + 1);
  for (u = 0, p = 0; p < LENGTH_CODES$1 - 1; p++)
    for (base_length[p] = u, n = 0; n < 1 << extra_lbits[p]; n++)
      _length_code[u++] = p;
  for (_length_code[u - 1] = p, a = 0, p = 0; p < 16; p++)
    for (base_dist[p] = a, n = 0; n < 1 << extra_dbits[p]; n++)
      _dist_code[a++] = p;
  for (a >>= 7; p < D_CODES$1; p++)
    for (base_dist[p] = a << 7, n = 0; n < 1 << extra_dbits[p] - 7; n++)
      _dist_code[256 + a++] = p;
  for (c = 0; c <= MAX_BITS$1; c++)
    A[c] = 0;
  for (n = 0; n <= 143; )
    static_ltree[n * 2 + 1] = 8, n++, A[8]++;
  for (; n <= 255; )
    static_ltree[n * 2 + 1] = 9, n++, A[9]++;
  for (; n <= 279; )
    static_ltree[n * 2 + 1] = 7, n++, A[7]++;
  for (; n <= 287; )
    static_ltree[n * 2 + 1] = 8, n++, A[8]++;
  for (gen_codes(static_ltree, L_CODES$1 + 1, A), n = 0; n < D_CODES$1; n++)
    static_dtree[n * 2 + 1] = 5, static_dtree[n * 2] = bi_reverse(n, 5);
  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS$1 + 1, L_CODES$1, MAX_BITS$1), static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0, D_CODES$1, MAX_BITS$1), static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0, BL_CODES$1, MAX_BL_BITS);
}, init_block = (n) => {
  let c;
  for (c = 0; c < L_CODES$1; c++)
    n.dyn_ltree[c * 2] = 0;
  for (c = 0; c < D_CODES$1; c++)
    n.dyn_dtree[c * 2] = 0;
  for (c = 0; c < BL_CODES$1; c++)
    n.bl_tree[c * 2] = 0;
  n.dyn_ltree[END_BLOCK * 2] = 1, n.opt_len = n.static_len = 0, n.sym_next = n.matches = 0;
}, bi_windup = (n) => {
  n.bi_valid > 8 ? put_short(n, n.bi_buf) : n.bi_valid > 0 && (n.pending_buf[n.pending++] = n.bi_buf), n.bi_buf = 0, n.bi_valid = 0;
}, smaller = (n, c, u, p) => {
  const a = c * 2, A = u * 2;
  return n[a] < n[A] || n[a] === n[A] && p[c] <= p[u];
}, pqdownheap = (n, c, u) => {
  const p = n.heap[u];
  let a = u << 1;
  for (; a <= n.heap_len && (a < n.heap_len && smaller(c, n.heap[a + 1], n.heap[a], n.depth) && a++, !smaller(c, p, n.heap[a], n.depth)); )
    n.heap[u] = n.heap[a], u = a, a <<= 1;
  n.heap[u] = p;
}, compress_block = (n, c, u) => {
  let p, a, A = 0, b, F;
  if (n.sym_next !== 0)
    do
      p = n.pending_buf[n.sym_buf + A++] & 255, p += (n.pending_buf[n.sym_buf + A++] & 255) << 8, a = n.pending_buf[n.sym_buf + A++], p === 0 ? send_code(n, a, c) : (b = _length_code[a], send_code(n, b + LITERALS$1 + 1, c), F = extra_lbits[b], F !== 0 && (a -= base_length[b], send_bits(n, a, F)), p--, b = d_code(p), send_code(n, b, u), F = extra_dbits[b], F !== 0 && (p -= base_dist[b], send_bits(n, p, F)));
    while (A < n.sym_next);
  send_code(n, END_BLOCK, c);
}, build_tree = (n, c) => {
  const u = c.dyn_tree, p = c.stat_desc.static_tree, a = c.stat_desc.has_stree, A = c.stat_desc.elems;
  let b, F, le = -1, L;
  for (n.heap_len = 0, n.heap_max = HEAP_SIZE$1, b = 0; b < A; b++)
    u[b * 2] !== 0 ? (n.heap[++n.heap_len] = le = b, n.depth[b] = 0) : u[b * 2 + 1] = 0;
  for (; n.heap_len < 2; )
    L = n.heap[++n.heap_len] = le < 2 ? ++le : 0, u[L * 2] = 1, n.depth[L] = 0, n.opt_len--, a && (n.static_len -= p[L * 2 + 1]);
  for (c.max_code = le, b = n.heap_len >> 1; b >= 1; b--)
    pqdownheap(n, u, b);
  L = A;
  do
    b = n.heap[
      1
      /*SMALLEST*/
    ], n.heap[
      1
      /*SMALLEST*/
    ] = n.heap[n.heap_len--], pqdownheap(
      n,
      u,
      1
      /*SMALLEST*/
    ), F = n.heap[
      1
      /*SMALLEST*/
    ], n.heap[--n.heap_max] = b, n.heap[--n.heap_max] = F, u[L * 2] = u[b * 2] + u[F * 2], n.depth[L] = (n.depth[b] >= n.depth[F] ? n.depth[b] : n.depth[F]) + 1, u[b * 2 + 1] = u[F * 2 + 1] = L, n.heap[
      1
      /*SMALLEST*/
    ] = L++, pqdownheap(
      n,
      u,
      1
      /*SMALLEST*/
    );
  while (n.heap_len >= 2);
  n.heap[--n.heap_max] = n.heap[
    1
    /*SMALLEST*/
  ], gen_bitlen(n, c), gen_codes(u, le, n.bl_count);
}, scan_tree = (n, c, u) => {
  let p, a = -1, A, b = c[0 * 2 + 1], F = 0, le = 7, L = 4;
  for (b === 0 && (le = 138, L = 3), c[(u + 1) * 2 + 1] = 65535, p = 0; p <= u; p++)
    A = b, b = c[(p + 1) * 2 + 1], !(++F < le && A === b) && (F < L ? n.bl_tree[A * 2] += F : A !== 0 ? (A !== a && n.bl_tree[A * 2]++, n.bl_tree[REP_3_6 * 2]++) : F <= 10 ? n.bl_tree[REPZ_3_10 * 2]++ : n.bl_tree[REPZ_11_138 * 2]++, F = 0, a = A, b === 0 ? (le = 138, L = 3) : A === b ? (le = 6, L = 3) : (le = 7, L = 4));
}, send_tree = (n, c, u) => {
  let p, a = -1, A, b = c[0 * 2 + 1], F = 0, le = 7, L = 4;
  for (b === 0 && (le = 138, L = 3), p = 0; p <= u; p++)
    if (A = b, b = c[(p + 1) * 2 + 1], !(++F < le && A === b)) {
      if (F < L)
        do
          send_code(n, A, n.bl_tree);
        while (--F !== 0);
      else A !== 0 ? (A !== a && (send_code(n, A, n.bl_tree), F--), send_code(n, REP_3_6, n.bl_tree), send_bits(n, F - 3, 2)) : F <= 10 ? (send_code(n, REPZ_3_10, n.bl_tree), send_bits(n, F - 3, 3)) : (send_code(n, REPZ_11_138, n.bl_tree), send_bits(n, F - 11, 7));
      F = 0, a = A, b === 0 ? (le = 138, L = 3) : A === b ? (le = 6, L = 3) : (le = 7, L = 4);
    }
}, build_bl_tree = (n) => {
  let c;
  for (scan_tree(n, n.dyn_ltree, n.l_desc.max_code), scan_tree(n, n.dyn_dtree, n.d_desc.max_code), build_tree(n, n.bl_desc), c = BL_CODES$1 - 1; c >= 3 && n.bl_tree[bl_order[c] * 2 + 1] === 0; c--)
    ;
  return n.opt_len += 3 * (c + 1) + 5 + 5 + 4, c;
}, send_all_trees = (n, c, u, p) => {
  let a;
  for (send_bits(n, c - 257, 5), send_bits(n, u - 1, 5), send_bits(n, p - 4, 4), a = 0; a < p; a++)
    send_bits(n, n.bl_tree[bl_order[a] * 2 + 1], 3);
  send_tree(n, n.dyn_ltree, c - 1), send_tree(n, n.dyn_dtree, u - 1);
}, detect_data_type = (n) => {
  let c = 4093624447, u;
  for (u = 0; u <= 31; u++, c >>>= 1)
    if (c & 1 && n.dyn_ltree[u * 2] !== 0)
      return Z_BINARY;
  if (n.dyn_ltree[9 * 2] !== 0 || n.dyn_ltree[10 * 2] !== 0 || n.dyn_ltree[13 * 2] !== 0)
    return Z_TEXT;
  for (u = 32; u < LITERALS$1; u++)
    if (n.dyn_ltree[u * 2] !== 0)
      return Z_TEXT;
  return Z_BINARY;
};
let static_init_done = !1;
const _tr_init$1 = (n) => {
  static_init_done || (tr_static_init(), static_init_done = !0), n.l_desc = new TreeDesc(n.dyn_ltree, static_l_desc), n.d_desc = new TreeDesc(n.dyn_dtree, static_d_desc), n.bl_desc = new TreeDesc(n.bl_tree, static_bl_desc), n.bi_buf = 0, n.bi_valid = 0, init_block(n);
}, _tr_stored_block$1 = (n, c, u, p) => {
  send_bits(n, (STORED_BLOCK << 1) + (p ? 1 : 0), 3), bi_windup(n), put_short(n, u), put_short(n, ~u), u && n.pending_buf.set(n.window.subarray(c, c + u), n.pending), n.pending += u;
}, _tr_align$1 = (n) => {
  send_bits(n, STATIC_TREES << 1, 3), send_code(n, END_BLOCK, static_ltree), bi_flush(n);
}, _tr_flush_block$1 = (n, c, u, p) => {
  let a, A, b = 0;
  n.level > 0 ? (n.strm.data_type === Z_UNKNOWN$1 && (n.strm.data_type = detect_data_type(n)), build_tree(n, n.l_desc), build_tree(n, n.d_desc), b = build_bl_tree(n), a = n.opt_len + 3 + 7 >>> 3, A = n.static_len + 3 + 7 >>> 3, A <= a && (a = A)) : a = A = u + 5, u + 4 <= a && c !== -1 ? _tr_stored_block$1(n, c, u, p) : n.strategy === Z_FIXED$1 || A === a ? (send_bits(n, (STATIC_TREES << 1) + (p ? 1 : 0), 3), compress_block(n, static_ltree, static_dtree)) : (send_bits(n, (DYN_TREES << 1) + (p ? 1 : 0), 3), send_all_trees(n, n.l_desc.max_code + 1, n.d_desc.max_code + 1, b + 1), compress_block(n, n.dyn_ltree, n.dyn_dtree)), init_block(n), p && bi_windup(n);
}, _tr_tally$1 = (n, c, u) => (n.pending_buf[n.sym_buf + n.sym_next++] = c, n.pending_buf[n.sym_buf + n.sym_next++] = c >> 8, n.pending_buf[n.sym_buf + n.sym_next++] = u, c === 0 ? n.dyn_ltree[u * 2]++ : (n.matches++, c--, n.dyn_ltree[(_length_code[u] + LITERALS$1 + 1) * 2]++, n.dyn_dtree[d_code(c) * 2]++), n.sym_next === n.sym_end);
trees._tr_init = _tr_init$1;
trees._tr_stored_block = _tr_stored_block$1;
trees._tr_flush_block = _tr_flush_block$1;
trees._tr_tally = _tr_tally$1;
trees._tr_align = _tr_align$1;
const adler32$2 = (n, c, u, p) => {
  let a = n & 65535 | 0, A = n >>> 16 & 65535 | 0, b = 0;
  for (; u !== 0; ) {
    b = u > 2e3 ? 2e3 : u, u -= b;
    do
      a = a + c[p++] | 0, A = A + a | 0;
    while (--b);
    a %= 65521, A %= 65521;
  }
  return a | A << 16 | 0;
};
var adler32_1 = adler32$2;
const makeTable = () => {
  let n, c = [];
  for (var u = 0; u < 256; u++) {
    n = u;
    for (var p = 0; p < 8; p++)
      n = n & 1 ? 3988292384 ^ n >>> 1 : n >>> 1;
    c[u] = n;
  }
  return c;
}, crcTable = new Uint32Array(makeTable()), crc32$2 = (n, c, u, p) => {
  const a = crcTable, A = p + u;
  n ^= -1;
  for (let b = p; b < A; b++)
    n = n >>> 8 ^ a[(n ^ c[b]) & 255];
  return n ^ -1;
};
var crc32_1 = crc32$2, messages = {
  2: "need dictionary",
  /* Z_NEED_DICT       2  */
  1: "stream end",
  /* Z_STREAM_END      1  */
  0: "",
  /* Z_OK              0  */
  "-1": "file error",
  /* Z_ERRNO         (-1) */
  "-2": "stream error",
  /* Z_STREAM_ERROR  (-2) */
  "-3": "data error",
  /* Z_DATA_ERROR    (-3) */
  "-4": "insufficient memory",
  /* Z_MEM_ERROR     (-4) */
  "-5": "buffer error",
  /* Z_BUF_ERROR     (-5) */
  "-6": "incompatible version"
  /* Z_VERSION_ERROR (-6) */
}, constants$5 = {
  /* Allowed flush values; see deflate() and inflate() below for details */
  Z_NO_FLUSH: 0,
  Z_PARTIAL_FLUSH: 1,
  Z_SYNC_FLUSH: 2,
  Z_FULL_FLUSH: 3,
  Z_FINISH: 4,
  Z_BLOCK: 5,
  Z_TREES: 6,
  /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */
  Z_OK: 0,
  Z_STREAM_END: 1,
  Z_NEED_DICT: 2,
  Z_ERRNO: -1,
  Z_STREAM_ERROR: -2,
  Z_DATA_ERROR: -3,
  Z_MEM_ERROR: -4,
  Z_BUF_ERROR: -5,
  //Z_VERSION_ERROR: -6,
  /* compression levels */
  Z_NO_COMPRESSION: 0,
  Z_BEST_SPEED: 1,
  Z_BEST_COMPRESSION: 9,
  Z_DEFAULT_COMPRESSION: -1,
  Z_FILTERED: 1,
  Z_HUFFMAN_ONLY: 2,
  Z_RLE: 3,
  Z_FIXED: 4,
  Z_DEFAULT_STRATEGY: 0,
  /* Possible values of the data_type field (though see inflate()) */
  Z_BINARY: 0,
  Z_TEXT: 1,
  //Z_ASCII:                1, // = Z_TEXT (deprecated)
  Z_UNKNOWN: 2,
  /* The deflate compression method */
  Z_DEFLATED: 8
  //Z_NULL:                 null // Use -1 or null inline, depending on var type
};
const { _tr_init, _tr_stored_block, _tr_flush_block, _tr_tally, _tr_align } = trees, adler32$1 = adler32_1, crc32$1 = crc32_1, msg$2 = messages, {
  Z_NO_FLUSH: Z_NO_FLUSH$2,
  Z_PARTIAL_FLUSH,
  Z_FULL_FLUSH: Z_FULL_FLUSH$1,
  Z_FINISH: Z_FINISH$3,
  Z_BLOCK: Z_BLOCK$1,
  Z_OK: Z_OK$3,
  Z_STREAM_END: Z_STREAM_END$3,
  Z_STREAM_ERROR: Z_STREAM_ERROR$2,
  Z_DATA_ERROR: Z_DATA_ERROR$2,
  Z_BUF_ERROR: Z_BUF_ERROR$1,
  Z_DEFAULT_COMPRESSION: Z_DEFAULT_COMPRESSION$1,
  Z_FILTERED,
  Z_HUFFMAN_ONLY,
  Z_RLE,
  Z_FIXED,
  Z_DEFAULT_STRATEGY: Z_DEFAULT_STRATEGY$1,
  Z_UNKNOWN,
  Z_DEFLATED: Z_DEFLATED$2
} = constants$5, MAX_MEM_LEVEL = 9, MAX_WBITS$1 = 15, DEF_MEM_LEVEL = 8, LENGTH_CODES = 29, LITERALS = 256, L_CODES = LITERALS + 1 + LENGTH_CODES, D_CODES = 30, BL_CODES = 19, HEAP_SIZE = 2 * L_CODES + 1, MAX_BITS = 15, MIN_MATCH = 3, MAX_MATCH = 258, MIN_LOOKAHEAD = MAX_MATCH + MIN_MATCH + 1, PRESET_DICT = 32, INIT_STATE = 42, GZIP_STATE = 57, EXTRA_STATE = 69, NAME_STATE = 73, COMMENT_STATE = 91, HCRC_STATE = 103, BUSY_STATE = 113, FINISH_STATE = 666, BS_NEED_MORE = 1, BS_BLOCK_DONE = 2, BS_FINISH_STARTED = 3, BS_FINISH_DONE = 4, OS_CODE = 3, err = (n, c) => (n.msg = msg$2[c], c), rank = (n) => n * 2 - (n > 4 ? 9 : 0), zero = (n) => {
  let c = n.length;
  for (; --c >= 0; )
    n[c] = 0;
}, slide_hash = (n) => {
  let c, u, p, a = n.w_size;
  c = n.hash_size, p = c;
  do
    u = n.head[--p], n.head[p] = u >= a ? u - a : 0;
  while (--c);
  c = a, p = c;
  do
    u = n.prev[--p], n.prev[p] = u >= a ? u - a : 0;
  while (--c);
};
let HASH_ZLIB = (n, c, u) => (c << n.hash_shift ^ u) & n.hash_mask, HASH = HASH_ZLIB;
const flush_pending = (n) => {
  const c = n.state;
  let u = c.pending;
  u > n.avail_out && (u = n.avail_out), u !== 0 && (n.output.set(c.pending_buf.subarray(c.pending_out, c.pending_out + u), n.next_out), n.next_out += u, c.pending_out += u, n.total_out += u, n.avail_out -= u, c.pending -= u, c.pending === 0 && (c.pending_out = 0));
}, flush_block_only = (n, c) => {
  _tr_flush_block(n, n.block_start >= 0 ? n.block_start : -1, n.strstart - n.block_start, c), n.block_start = n.strstart, flush_pending(n.strm);
}, put_byte = (n, c) => {
  n.pending_buf[n.pending++] = c;
}, putShortMSB = (n, c) => {
  n.pending_buf[n.pending++] = c >>> 8 & 255, n.pending_buf[n.pending++] = c & 255;
}, read_buf = (n, c, u, p) => {
  let a = n.avail_in;
  return a > p && (a = p), a === 0 ? 0 : (n.avail_in -= a, c.set(n.input.subarray(n.next_in, n.next_in + a), u), n.state.wrap === 1 ? n.adler = adler32$1(n.adler, c, a, u) : n.state.wrap === 2 && (n.adler = crc32$1(n.adler, c, a, u)), n.next_in += a, n.total_in += a, a);
}, longest_match = (n, c) => {
  let u = n.max_chain_length, p = n.strstart, a, A, b = n.prev_length, F = n.nice_match;
  const le = n.strstart > n.w_size - MIN_LOOKAHEAD ? n.strstart - (n.w_size - MIN_LOOKAHEAD) : 0, L = n.window, pe = n.w_mask, $ = n.prev, Ee = n.strstart + MAX_MATCH;
  let be = L[p + b - 1], He = L[p + b];
  n.prev_length >= n.good_match && (u >>= 2), F > n.lookahead && (F = n.lookahead);
  do
    if (a = c, !(L[a + b] !== He || L[a + b - 1] !== be || L[a] !== L[p] || L[++a] !== L[p + 1])) {
      p += 2, a++;
      do
        ;
      while (L[++p] === L[++a] && L[++p] === L[++a] && L[++p] === L[++a] && L[++p] === L[++a] && L[++p] === L[++a] && L[++p] === L[++a] && L[++p] === L[++a] && L[++p] === L[++a] && p < Ee);
      if (A = MAX_MATCH - (Ee - p), p = Ee - MAX_MATCH, A > b) {
        if (n.match_start = c, b = A, A >= F)
          break;
        be = L[p + b - 1], He = L[p + b];
      }
    }
  while ((c = $[c & pe]) > le && --u !== 0);
  return b <= n.lookahead ? b : n.lookahead;
}, fill_window = (n) => {
  const c = n.w_size;
  let u, p, a;
  do {
    if (p = n.window_size - n.lookahead - n.strstart, n.strstart >= c + (c - MIN_LOOKAHEAD) && (n.window.set(n.window.subarray(c, c + c - p), 0), n.match_start -= c, n.strstart -= c, n.block_start -= c, n.insert > n.strstart && (n.insert = n.strstart), slide_hash(n), p += c), n.strm.avail_in === 0)
      break;
    if (u = read_buf(n.strm, n.window, n.strstart + n.lookahead, p), n.lookahead += u, n.lookahead + n.insert >= MIN_MATCH)
      for (a = n.strstart - n.insert, n.ins_h = n.window[a], n.ins_h = HASH(n, n.ins_h, n.window[a + 1]); n.insert && (n.ins_h = HASH(n, n.ins_h, n.window[a + MIN_MATCH - 1]), n.prev[a & n.w_mask] = n.head[n.ins_h], n.head[n.ins_h] = a, a++, n.insert--, !(n.lookahead + n.insert < MIN_MATCH)); )
        ;
  } while (n.lookahead < MIN_LOOKAHEAD && n.strm.avail_in !== 0);
}, deflate_stored = (n, c) => {
  let u = n.pending_buf_size - 5 > n.w_size ? n.w_size : n.pending_buf_size - 5, p, a, A, b = 0, F = n.strm.avail_in;
  do {
    if (p = 65535, A = n.bi_valid + 42 >> 3, n.strm.avail_out < A || (A = n.strm.avail_out - A, a = n.strstart - n.block_start, p > a + n.strm.avail_in && (p = a + n.strm.avail_in), p > A && (p = A), p < u && (p === 0 && c !== Z_FINISH$3 || c === Z_NO_FLUSH$2 || p !== a + n.strm.avail_in)))
      break;
    b = c === Z_FINISH$3 && p === a + n.strm.avail_in ? 1 : 0, _tr_stored_block(n, 0, 0, b), n.pending_buf[n.pending - 4] = p, n.pending_buf[n.pending - 3] = p >> 8, n.pending_buf[n.pending - 2] = ~p, n.pending_buf[n.pending - 1] = ~p >> 8, flush_pending(n.strm), a && (a > p && (a = p), n.strm.output.set(n.window.subarray(n.block_start, n.block_start + a), n.strm.next_out), n.strm.next_out += a, n.strm.avail_out -= a, n.strm.total_out += a, n.block_start += a, p -= a), p && (read_buf(n.strm, n.strm.output, n.strm.next_out, p), n.strm.next_out += p, n.strm.avail_out -= p, n.strm.total_out += p);
  } while (b === 0);
  return F -= n.strm.avail_in, F && (F >= n.w_size ? (n.matches = 2, n.window.set(n.strm.input.subarray(n.strm.next_in - n.w_size, n.strm.next_in), 0), n.strstart = n.w_size, n.insert = n.strstart) : (n.window_size - n.strstart <= F && (n.strstart -= n.w_size, n.window.set(n.window.subarray(n.w_size, n.w_size + n.strstart), 0), n.matches < 2 && n.matches++, n.insert > n.strstart && (n.insert = n.strstart)), n.window.set(n.strm.input.subarray(n.strm.next_in - F, n.strm.next_in), n.strstart), n.strstart += F, n.insert += F > n.w_size - n.insert ? n.w_size - n.insert : F), n.block_start = n.strstart), n.high_water < n.strstart && (n.high_water = n.strstart), b ? BS_FINISH_DONE : c !== Z_NO_FLUSH$2 && c !== Z_FINISH$3 && n.strm.avail_in === 0 && n.strstart === n.block_start ? BS_BLOCK_DONE : (A = n.window_size - n.strstart, n.strm.avail_in > A && n.block_start >= n.w_size && (n.block_start -= n.w_size, n.strstart -= n.w_size, n.window.set(n.window.subarray(n.w_size, n.w_size + n.strstart), 0), n.matches < 2 && n.matches++, A += n.w_size, n.insert > n.strstart && (n.insert = n.strstart)), A > n.strm.avail_in && (A = n.strm.avail_in), A && (read_buf(n.strm, n.window, n.strstart, A), n.strstart += A, n.insert += A > n.w_size - n.insert ? n.w_size - n.insert : A), n.high_water < n.strstart && (n.high_water = n.strstart), A = n.bi_valid + 42 >> 3, A = n.pending_buf_size - A > 65535 ? 65535 : n.pending_buf_size - A, u = A > n.w_size ? n.w_size : A, a = n.strstart - n.block_start, (a >= u || (a || c === Z_FINISH$3) && c !== Z_NO_FLUSH$2 && n.strm.avail_in === 0 && a <= A) && (p = a > A ? A : a, b = c === Z_FINISH$3 && n.strm.avail_in === 0 && p === a ? 1 : 0, _tr_stored_block(n, n.block_start, p, b), n.block_start += p, flush_pending(n.strm)), b ? BS_FINISH_STARTED : BS_NEED_MORE);
}, deflate_fast = (n, c) => {
  let u, p;
  for (; ; ) {
    if (n.lookahead < MIN_LOOKAHEAD) {
      if (fill_window(n), n.lookahead < MIN_LOOKAHEAD && c === Z_NO_FLUSH$2)
        return BS_NEED_MORE;
      if (n.lookahead === 0)
        break;
    }
    if (u = 0, n.lookahead >= MIN_MATCH && (n.ins_h = HASH(n, n.ins_h, n.window[n.strstart + MIN_MATCH - 1]), u = n.prev[n.strstart & n.w_mask] = n.head[n.ins_h], n.head[n.ins_h] = n.strstart), u !== 0 && n.strstart - u <= n.w_size - MIN_LOOKAHEAD && (n.match_length = longest_match(n, u)), n.match_length >= MIN_MATCH)
      if (p = _tr_tally(n, n.strstart - n.match_start, n.match_length - MIN_MATCH), n.lookahead -= n.match_length, n.match_length <= n.max_lazy_match && n.lookahead >= MIN_MATCH) {
        n.match_length--;
        do
          n.strstart++, n.ins_h = HASH(n, n.ins_h, n.window[n.strstart + MIN_MATCH - 1]), u = n.prev[n.strstart & n.w_mask] = n.head[n.ins_h], n.head[n.ins_h] = n.strstart;
        while (--n.match_length !== 0);
        n.strstart++;
      } else
        n.strstart += n.match_length, n.match_length = 0, n.ins_h = n.window[n.strstart], n.ins_h = HASH(n, n.ins_h, n.window[n.strstart + 1]);
    else
      p = _tr_tally(n, 0, n.window[n.strstart]), n.lookahead--, n.strstart++;
    if (p && (flush_block_only(n, !1), n.strm.avail_out === 0))
      return BS_NEED_MORE;
  }
  return n.insert = n.strstart < MIN_MATCH - 1 ? n.strstart : MIN_MATCH - 1, c === Z_FINISH$3 ? (flush_block_only(n, !0), n.strm.avail_out === 0 ? BS_FINISH_STARTED : BS_FINISH_DONE) : n.sym_next && (flush_block_only(n, !1), n.strm.avail_out === 0) ? BS_NEED_MORE : BS_BLOCK_DONE;
}, deflate_slow = (n, c) => {
  let u, p, a;
  for (; ; ) {
    if (n.lookahead < MIN_LOOKAHEAD) {
      if (fill_window(n), n.lookahead < MIN_LOOKAHEAD && c === Z_NO_FLUSH$2)
        return BS_NEED_MORE;
      if (n.lookahead === 0)
        break;
    }
    if (u = 0, n.lookahead >= MIN_MATCH && (n.ins_h = HASH(n, n.ins_h, n.window[n.strstart + MIN_MATCH - 1]), u = n.prev[n.strstart & n.w_mask] = n.head[n.ins_h], n.head[n.ins_h] = n.strstart), n.prev_length = n.match_length, n.prev_match = n.match_start, n.match_length = MIN_MATCH - 1, u !== 0 && n.prev_length < n.max_lazy_match && n.strstart - u <= n.w_size - MIN_LOOKAHEAD && (n.match_length = longest_match(n, u), n.match_length <= 5 && (n.strategy === Z_FILTERED || n.match_length === MIN_MATCH && n.strstart - n.match_start > 4096) && (n.match_length = MIN_MATCH - 1)), n.prev_length >= MIN_MATCH && n.match_length <= n.prev_length) {
      a = n.strstart + n.lookahead - MIN_MATCH, p = _tr_tally(n, n.strstart - 1 - n.prev_match, n.prev_length - MIN_MATCH), n.lookahead -= n.prev_length - 1, n.prev_length -= 2;
      do
        ++n.strstart <= a && (n.ins_h = HASH(n, n.ins_h, n.window[n.strstart + MIN_MATCH - 1]), u = n.prev[n.strstart & n.w_mask] = n.head[n.ins_h], n.head[n.ins_h] = n.strstart);
      while (--n.prev_length !== 0);
      if (n.match_available = 0, n.match_length = MIN_MATCH - 1, n.strstart++, p && (flush_block_only(n, !1), n.strm.avail_out === 0))
        return BS_NEED_MORE;
    } else if (n.match_available) {
      if (p = _tr_tally(n, 0, n.window[n.strstart - 1]), p && flush_block_only(n, !1), n.strstart++, n.lookahead--, n.strm.avail_out === 0)
        return BS_NEED_MORE;
    } else
      n.match_available = 1, n.strstart++, n.lookahead--;
  }
  return n.match_available && (p = _tr_tally(n, 0, n.window[n.strstart - 1]), n.match_available = 0), n.insert = n.strstart < MIN_MATCH - 1 ? n.strstart : MIN_MATCH - 1, c === Z_FINISH$3 ? (flush_block_only(n, !0), n.strm.avail_out === 0 ? BS_FINISH_STARTED : BS_FINISH_DONE) : n.sym_next && (flush_block_only(n, !1), n.strm.avail_out === 0) ? BS_NEED_MORE : BS_BLOCK_DONE;
}, deflate_rle = (n, c) => {
  let u, p, a, A;
  const b = n.window;
  for (; ; ) {
    if (n.lookahead <= MAX_MATCH) {
      if (fill_window(n), n.lookahead <= MAX_MATCH && c === Z_NO_FLUSH$2)
        return BS_NEED_MORE;
      if (n.lookahead === 0)
        break;
    }
    if (n.match_length = 0, n.lookahead >= MIN_MATCH && n.strstart > 0 && (a = n.strstart - 1, p = b[a], p === b[++a] && p === b[++a] && p === b[++a])) {
      A = n.strstart + MAX_MATCH;
      do
        ;
      while (p === b[++a] && p === b[++a] && p === b[++a] && p === b[++a] && p === b[++a] && p === b[++a] && p === b[++a] && p === b[++a] && a < A);
      n.match_length = MAX_MATCH - (A - a), n.match_length > n.lookahead && (n.match_length = n.lookahead);
    }
    if (n.match_length >= MIN_MATCH ? (u = _tr_tally(n, 1, n.match_length - MIN_MATCH), n.lookahead -= n.match_length, n.strstart += n.match_length, n.match_length = 0) : (u = _tr_tally(n, 0, n.window[n.strstart]), n.lookahead--, n.strstart++), u && (flush_block_only(n, !1), n.strm.avail_out === 0))
      return BS_NEED_MORE;
  }
  return n.insert = 0, c === Z_FINISH$3 ? (flush_block_only(n, !0), n.strm.avail_out === 0 ? BS_FINISH_STARTED : BS_FINISH_DONE) : n.sym_next && (flush_block_only(n, !1), n.strm.avail_out === 0) ? BS_NEED_MORE : BS_BLOCK_DONE;
}, deflate_huff = (n, c) => {
  let u;
  for (; ; ) {
    if (n.lookahead === 0 && (fill_window(n), n.lookahead === 0)) {
      if (c === Z_NO_FLUSH$2)
        return BS_NEED_MORE;
      break;
    }
    if (n.match_length = 0, u = _tr_tally(n, 0, n.window[n.strstart]), n.lookahead--, n.strstart++, u && (flush_block_only(n, !1), n.strm.avail_out === 0))
      return BS_NEED_MORE;
  }
  return n.insert = 0, c === Z_FINISH$3 ? (flush_block_only(n, !0), n.strm.avail_out === 0 ? BS_FINISH_STARTED : BS_FINISH_DONE) : n.sym_next && (flush_block_only(n, !1), n.strm.avail_out === 0) ? BS_NEED_MORE : BS_BLOCK_DONE;
};
function Config(n, c, u, p, a) {
  this.good_length = n, this.max_lazy = c, this.nice_length = u, this.max_chain = p, this.func = a;
}
const configuration_table = [
  /*      good lazy nice chain */
  new Config(0, 0, 0, 0, deflate_stored),
  /* 0 store only */
  new Config(4, 4, 8, 4, deflate_fast),
  /* 1 max speed, no lazy matches */
  new Config(4, 5, 16, 8, deflate_fast),
  /* 2 */
  new Config(4, 6, 32, 32, deflate_fast),
  /* 3 */
  new Config(4, 4, 16, 16, deflate_slow),
  /* 4 lazy matches */
  new Config(8, 16, 32, 32, deflate_slow),
  /* 5 */
  new Config(8, 16, 128, 128, deflate_slow),
  /* 6 */
  new Config(8, 32, 128, 256, deflate_slow),
  /* 7 */
  new Config(32, 128, 258, 1024, deflate_slow),
  /* 8 */
  new Config(32, 258, 258, 4096, deflate_slow)
  /* 9 max compression */
], lm_init = (n) => {
  n.window_size = 2 * n.w_size, zero(n.head), n.max_lazy_match = configuration_table[n.level].max_lazy, n.good_match = configuration_table[n.level].good_length, n.nice_match = configuration_table[n.level].nice_length, n.max_chain_length = configuration_table[n.level].max_chain, n.strstart = 0, n.block_start = 0, n.lookahead = 0, n.insert = 0, n.match_length = n.prev_length = MIN_MATCH - 1, n.match_available = 0, n.ins_h = 0;
};
function DeflateState() {
  this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = Z_DEFLATED$2, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new Uint16Array(HEAP_SIZE * 2), this.dyn_dtree = new Uint16Array((2 * D_CODES + 1) * 2), this.bl_tree = new Uint16Array((2 * BL_CODES + 1) * 2), zero(this.dyn_ltree), zero(this.dyn_dtree), zero(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new Uint16Array(MAX_BITS + 1), this.heap = new Uint16Array(2 * L_CODES + 1), zero(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new Uint16Array(2 * L_CODES + 1), zero(this.depth), this.sym_buf = 0, this.lit_bufsize = 0, this.sym_next = 0, this.sym_end = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
}
const deflateStateCheck = (n) => {
  if (!n)
    return 1;
  const c = n.state;
  return !c || c.strm !== n || c.status !== INIT_STATE && //#ifdef GZIP
  c.status !== GZIP_STATE && //#endif
  c.status !== EXTRA_STATE && c.status !== NAME_STATE && c.status !== COMMENT_STATE && c.status !== HCRC_STATE && c.status !== BUSY_STATE && c.status !== FINISH_STATE ? 1 : 0;
}, deflateResetKeep = (n) => {
  if (deflateStateCheck(n))
    return err(n, Z_STREAM_ERROR$2);
  n.total_in = n.total_out = 0, n.data_type = Z_UNKNOWN;
  const c = n.state;
  return c.pending = 0, c.pending_out = 0, c.wrap < 0 && (c.wrap = -c.wrap), c.status = //#ifdef GZIP
  c.wrap === 2 ? GZIP_STATE : (
    //#endif
    c.wrap ? INIT_STATE : BUSY_STATE
  ), n.adler = c.wrap === 2 ? 0 : 1, c.last_flush = -2, _tr_init(c), Z_OK$3;
}, deflateReset = (n) => {
  const c = deflateResetKeep(n);
  return c === Z_OK$3 && lm_init(n.state), c;
}, deflateSetHeader = (n, c) => deflateStateCheck(n) || n.state.wrap !== 2 ? Z_STREAM_ERROR$2 : (n.state.gzhead = c, Z_OK$3), deflateInit2 = (n, c, u, p, a, A) => {
  if (!n)
    return Z_STREAM_ERROR$2;
  let b = 1;
  if (c === Z_DEFAULT_COMPRESSION$1 && (c = 6), p < 0 ? (b = 0, p = -p) : p > 15 && (b = 2, p -= 16), a < 1 || a > MAX_MEM_LEVEL || u !== Z_DEFLATED$2 || p < 8 || p > 15 || c < 0 || c > 9 || A < 0 || A > Z_FIXED || p === 8 && b !== 1)
    return err(n, Z_STREAM_ERROR$2);
  p === 8 && (p = 9);
  const F = new DeflateState();
  return n.state = F, F.strm = n, F.status = INIT_STATE, F.wrap = b, F.gzhead = null, F.w_bits = p, F.w_size = 1 << F.w_bits, F.w_mask = F.w_size - 1, F.hash_bits = a + 7, F.hash_size = 1 << F.hash_bits, F.hash_mask = F.hash_size - 1, F.hash_shift = ~~((F.hash_bits + MIN_MATCH - 1) / MIN_MATCH), F.window = new Uint8Array(F.w_size * 2), F.head = new Uint16Array(F.hash_size), F.prev = new Uint16Array(F.w_size), F.lit_bufsize = 1 << a + 6, F.pending_buf_size = F.lit_bufsize * 4, F.pending_buf = new Uint8Array(F.pending_buf_size), F.sym_buf = F.lit_bufsize, F.sym_end = (F.lit_bufsize - 1) * 3, F.level = c, F.strategy = A, F.method = u, deflateReset(n);
}, deflateInit = (n, c) => deflateInit2(n, c, Z_DEFLATED$2, MAX_WBITS$1, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY$1), deflate$2 = (n, c) => {
  if (deflateStateCheck(n) || c > Z_BLOCK$1 || c < 0)
    return n ? err(n, Z_STREAM_ERROR$2) : Z_STREAM_ERROR$2;
  const u = n.state;
  if (!n.output || n.avail_in !== 0 && !n.input || u.status === FINISH_STATE && c !== Z_FINISH$3)
    return err(n, n.avail_out === 0 ? Z_BUF_ERROR$1 : Z_STREAM_ERROR$2);
  const p = u.last_flush;
  if (u.last_flush = c, u.pending !== 0) {
    if (flush_pending(n), n.avail_out === 0)
      return u.last_flush = -1, Z_OK$3;
  } else if (n.avail_in === 0 && rank(c) <= rank(p) && c !== Z_FINISH$3)
    return err(n, Z_BUF_ERROR$1);
  if (u.status === FINISH_STATE && n.avail_in !== 0)
    return err(n, Z_BUF_ERROR$1);
  if (u.status === INIT_STATE && u.wrap === 0 && (u.status = BUSY_STATE), u.status === INIT_STATE) {
    let a = Z_DEFLATED$2 + (u.w_bits - 8 << 4) << 8, A = -1;
    if (u.strategy >= Z_HUFFMAN_ONLY || u.level < 2 ? A = 0 : u.level < 6 ? A = 1 : u.level === 6 ? A = 2 : A = 3, a |= A << 6, u.strstart !== 0 && (a |= PRESET_DICT), a += 31 - a % 31, putShortMSB(u, a), u.strstart !== 0 && (putShortMSB(u, n.adler >>> 16), putShortMSB(u, n.adler & 65535)), n.adler = 1, u.status = BUSY_STATE, flush_pending(n), u.pending !== 0)
      return u.last_flush = -1, Z_OK$3;
  }
  if (u.status === GZIP_STATE) {
    if (n.adler = 0, put_byte(u, 31), put_byte(u, 139), put_byte(u, 8), u.gzhead)
      put_byte(
        u,
        (u.gzhead.text ? 1 : 0) + (u.gzhead.hcrc ? 2 : 0) + (u.gzhead.extra ? 4 : 0) + (u.gzhead.name ? 8 : 0) + (u.gzhead.comment ? 16 : 0)
      ), put_byte(u, u.gzhead.time & 255), put_byte(u, u.gzhead.time >> 8 & 255), put_byte(u, u.gzhead.time >> 16 & 255), put_byte(u, u.gzhead.time >> 24 & 255), put_byte(u, u.level === 9 ? 2 : u.strategy >= Z_HUFFMAN_ONLY || u.level < 2 ? 4 : 0), put_byte(u, u.gzhead.os & 255), u.gzhead.extra && u.gzhead.extra.length && (put_byte(u, u.gzhead.extra.length & 255), put_byte(u, u.gzhead.extra.length >> 8 & 255)), u.gzhead.hcrc && (n.adler = crc32$1(n.adler, u.pending_buf, u.pending, 0)), u.gzindex = 0, u.status = EXTRA_STATE;
    else if (put_byte(u, 0), put_byte(u, 0), put_byte(u, 0), put_byte(u, 0), put_byte(u, 0), put_byte(u, u.level === 9 ? 2 : u.strategy >= Z_HUFFMAN_ONLY || u.level < 2 ? 4 : 0), put_byte(u, OS_CODE), u.status = BUSY_STATE, flush_pending(n), u.pending !== 0)
      return u.last_flush = -1, Z_OK$3;
  }
  if (u.status === EXTRA_STATE) {
    if (u.gzhead.extra) {
      let a = u.pending, A = (u.gzhead.extra.length & 65535) - u.gzindex;
      for (; u.pending + A > u.pending_buf_size; ) {
        let F = u.pending_buf_size - u.pending;
        if (u.pending_buf.set(u.gzhead.extra.subarray(u.gzindex, u.gzindex + F), u.pending), u.pending = u.pending_buf_size, u.gzhead.hcrc && u.pending > a && (n.adler = crc32$1(n.adler, u.pending_buf, u.pending - a, a)), u.gzindex += F, flush_pending(n), u.pending !== 0)
          return u.last_flush = -1, Z_OK$3;
        a = 0, A -= F;
      }
      let b = new Uint8Array(u.gzhead.extra);
      u.pending_buf.set(b.subarray(u.gzindex, u.gzindex + A), u.pending), u.pending += A, u.gzhead.hcrc && u.pending > a && (n.adler = crc32$1(n.adler, u.pending_buf, u.pending - a, a)), u.gzindex = 0;
    }
    u.status = NAME_STATE;
  }
  if (u.status === NAME_STATE) {
    if (u.gzhead.name) {
      let a = u.pending, A;
      do {
        if (u.pending === u.pending_buf_size) {
          if (u.gzhead.hcrc && u.pending > a && (n.adler = crc32$1(n.adler, u.pending_buf, u.pending - a, a)), flush_pending(n), u.pending !== 0)
            return u.last_flush = -1, Z_OK$3;
          a = 0;
        }
        u.gzindex < u.gzhead.name.length ? A = u.gzhead.name.charCodeAt(u.gzindex++) & 255 : A = 0, put_byte(u, A);
      } while (A !== 0);
      u.gzhead.hcrc && u.pending > a && (n.adler = crc32$1(n.adler, u.pending_buf, u.pending - a, a)), u.gzindex = 0;
    }
    u.status = COMMENT_STATE;
  }
  if (u.status === COMMENT_STATE) {
    if (u.gzhead.comment) {
      let a = u.pending, A;
      do {
        if (u.pending === u.pending_buf_size) {
          if (u.gzhead.hcrc && u.pending > a && (n.adler = crc32$1(n.adler, u.pending_buf, u.pending - a, a)), flush_pending(n), u.pending !== 0)
            return u.last_flush = -1, Z_OK$3;
          a = 0;
        }
        u.gzindex < u.gzhead.comment.length ? A = u.gzhead.comment.charCodeAt(u.gzindex++) & 255 : A = 0, put_byte(u, A);
      } while (A !== 0);
      u.gzhead.hcrc && u.pending > a && (n.adler = crc32$1(n.adler, u.pending_buf, u.pending - a, a));
    }
    u.status = HCRC_STATE;
  }
  if (u.status === HCRC_STATE) {
    if (u.gzhead.hcrc) {
      if (u.pending + 2 > u.pending_buf_size && (flush_pending(n), u.pending !== 0))
        return u.last_flush = -1, Z_OK$3;
      put_byte(u, n.adler & 255), put_byte(u, n.adler >> 8 & 255), n.adler = 0;
    }
    if (u.status = BUSY_STATE, flush_pending(n), u.pending !== 0)
      return u.last_flush = -1, Z_OK$3;
  }
  if (n.avail_in !== 0 || u.lookahead !== 0 || c !== Z_NO_FLUSH$2 && u.status !== FINISH_STATE) {
    let a = u.level === 0 ? deflate_stored(u, c) : u.strategy === Z_HUFFMAN_ONLY ? deflate_huff(u, c) : u.strategy === Z_RLE ? deflate_rle(u, c) : configuration_table[u.level].func(u, c);
    if ((a === BS_FINISH_STARTED || a === BS_FINISH_DONE) && (u.status = FINISH_STATE), a === BS_NEED_MORE || a === BS_FINISH_STARTED)
      return n.avail_out === 0 && (u.last_flush = -1), Z_OK$3;
    if (a === BS_BLOCK_DONE && (c === Z_PARTIAL_FLUSH ? _tr_align(u) : c !== Z_BLOCK$1 && (_tr_stored_block(u, 0, 0, !1), c === Z_FULL_FLUSH$1 && (zero(u.head), u.lookahead === 0 && (u.strstart = 0, u.block_start = 0, u.insert = 0))), flush_pending(n), n.avail_out === 0))
      return u.last_flush = -1, Z_OK$3;
  }
  return c !== Z_FINISH$3 ? Z_OK$3 : u.wrap <= 0 ? Z_STREAM_END$3 : (u.wrap === 2 ? (put_byte(u, n.adler & 255), put_byte(u, n.adler >> 8 & 255), put_byte(u, n.adler >> 16 & 255), put_byte(u, n.adler >> 24 & 255), put_byte(u, n.total_in & 255), put_byte(u, n.total_in >> 8 & 255), put_byte(u, n.total_in >> 16 & 255), put_byte(u, n.total_in >> 24 & 255)) : (putShortMSB(u, n.adler >>> 16), putShortMSB(u, n.adler & 65535)), flush_pending(n), u.wrap > 0 && (u.wrap = -u.wrap), u.pending !== 0 ? Z_OK$3 : Z_STREAM_END$3);
}, deflateEnd = (n) => {
  if (deflateStateCheck(n))
    return Z_STREAM_ERROR$2;
  const c = n.state.status;
  return n.state = null, c === BUSY_STATE ? err(n, Z_DATA_ERROR$2) : Z_OK$3;
}, deflateSetDictionary = (n, c) => {
  let u = c.length;
  if (deflateStateCheck(n))
    return Z_STREAM_ERROR$2;
  const p = n.state, a = p.wrap;
  if (a === 2 || a === 1 && p.status !== INIT_STATE || p.lookahead)
    return Z_STREAM_ERROR$2;
  if (a === 1 && (n.adler = adler32$1(n.adler, c, u, 0)), p.wrap = 0, u >= p.w_size) {
    a === 0 && (zero(p.head), p.strstart = 0, p.block_start = 0, p.insert = 0);
    let le = new Uint8Array(p.w_size);
    le.set(c.subarray(u - p.w_size, u), 0), c = le, u = p.w_size;
  }
  const A = n.avail_in, b = n.next_in, F = n.input;
  for (n.avail_in = u, n.next_in = 0, n.input = c, fill_window(p); p.lookahead >= MIN_MATCH; ) {
    let le = p.strstart, L = p.lookahead - (MIN_MATCH - 1);
    do
      p.ins_h = HASH(p, p.ins_h, p.window[le + MIN_MATCH - 1]), p.prev[le & p.w_mask] = p.head[p.ins_h], p.head[p.ins_h] = le, le++;
    while (--L);
    p.strstart = le, p.lookahead = MIN_MATCH - 1, fill_window(p);
  }
  return p.strstart += p.lookahead, p.block_start = p.strstart, p.insert = p.lookahead, p.lookahead = 0, p.match_length = p.prev_length = MIN_MATCH - 1, p.match_available = 0, n.next_in = b, n.input = F, n.avail_in = A, p.wrap = a, Z_OK$3;
};
deflate$3.deflateInit = deflateInit;
deflate$3.deflateInit2 = deflateInit2;
deflate$3.deflateReset = deflateReset;
deflate$3.deflateResetKeep = deflateResetKeep;
deflate$3.deflateSetHeader = deflateSetHeader;
deflate$3.deflate = deflate$2;
deflate$3.deflateEnd = deflateEnd;
deflate$3.deflateSetDictionary = deflateSetDictionary;
deflate$3.deflateInfo = "pako deflate (from Nodeca project)";
var common = {};
const _has = (n, c) => Object.prototype.hasOwnProperty.call(n, c);
common.assign = function(n) {
  const c = Array.prototype.slice.call(arguments, 1);
  for (; c.length; ) {
    const u = c.shift();
    if (u) {
      if (typeof u != "object")
        throw new TypeError(u + "must be non-object");
      for (const p in u)
        _has(u, p) && (n[p] = u[p]);
    }
  }
  return n;
};
common.flattenChunks = (n) => {
  let c = 0;
  for (let p = 0, a = n.length; p < a; p++)
    c += n[p].length;
  const u = new Uint8Array(c);
  for (let p = 0, a = 0, A = n.length; p < A; p++) {
    let b = n[p];
    u.set(b, a), a += b.length;
  }
  return u;
};
var strings$2 = {};
let STR_APPLY_UIA_OK = !0;
try {
  String.fromCharCode.apply(null, new Uint8Array(1));
} catch (n) {
  STR_APPLY_UIA_OK = !1;
}
const _utf8len = new Uint8Array(256);
for (let n = 0; n < 256; n++)
  _utf8len[n] = n >= 252 ? 6 : n >= 248 ? 5 : n >= 240 ? 4 : n >= 224 ? 3 : n >= 192 ? 2 : 1;
_utf8len[254] = _utf8len[254] = 1;
strings$2.string2buf = (n) => {
  if (typeof TextEncoder == "function" && TextEncoder.prototype.encode)
    return new TextEncoder().encode(n);
  let c, u, p, a, A, b = n.length, F = 0;
  for (a = 0; a < b; a++)
    u = n.charCodeAt(a), (u & 64512) === 55296 && a + 1 < b && (p = n.charCodeAt(a + 1), (p & 64512) === 56320 && (u = 65536 + (u - 55296 << 10) + (p - 56320), a++)), F += u < 128 ? 1 : u < 2048 ? 2 : u < 65536 ? 3 : 4;
  for (c = new Uint8Array(F), A = 0, a = 0; A < F; a++)
    u = n.charCodeAt(a), (u & 64512) === 55296 && a + 1 < b && (p = n.charCodeAt(a + 1), (p & 64512) === 56320 && (u = 65536 + (u - 55296 << 10) + (p - 56320), a++)), u < 128 ? c[A++] = u : u < 2048 ? (c[A++] = 192 | u >>> 6, c[A++] = 128 | u & 63) : u < 65536 ? (c[A++] = 224 | u >>> 12, c[A++] = 128 | u >>> 6 & 63, c[A++] = 128 | u & 63) : (c[A++] = 240 | u >>> 18, c[A++] = 128 | u >>> 12 & 63, c[A++] = 128 | u >>> 6 & 63, c[A++] = 128 | u & 63);
  return c;
};
const buf2binstring = (n, c) => {
  if (c < 65534 && n.subarray && STR_APPLY_UIA_OK)
    return String.fromCharCode.apply(null, n.length === c ? n : n.subarray(0, c));
  let u = "";
  for (let p = 0; p < c; p++)
    u += String.fromCharCode(n[p]);
  return u;
};
strings$2.buf2string = (n, c) => {
  const u = c || n.length;
  if (typeof TextDecoder == "function" && TextDecoder.prototype.decode)
    return new TextDecoder().decode(n.subarray(0, c));
  let p, a;
  const A = new Array(u * 2);
  for (a = 0, p = 0; p < u; ) {
    let b = n[p++];
    if (b < 128) {
      A[a++] = b;
      continue;
    }
    let F = _utf8len[b];
    if (F > 4) {
      A[a++] = 65533, p += F - 1;
      continue;
    }
    for (b &= F === 2 ? 31 : F === 3 ? 15 : 7; F > 1 && p < u; )
      b = b << 6 | n[p++] & 63, F--;
    if (F > 1) {
      A[a++] = 65533;
      continue;
    }
    b < 65536 ? A[a++] = b : (b -= 65536, A[a++] = 55296 | b >> 10 & 1023, A[a++] = 56320 | b & 1023);
  }
  return buf2binstring(A, a);
};
strings$2.utf8border = (n, c) => {
  c = c || n.length, c > n.length && (c = n.length);
  let u = c - 1;
  for (; u >= 0 && (n[u] & 192) === 128; )
    u--;
  return u < 0 || u === 0 ? c : u + _utf8len[n[u]] > c ? u : c;
};
function ZStream$2() {
  this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
}
var zstream = ZStream$2;
const zlib_deflate = deflate$3, utils$e = common, strings$1 = strings$2, msg$1 = messages, ZStream$1 = zstream, toString$1 = Object.prototype.toString, {
  Z_NO_FLUSH: Z_NO_FLUSH$1,
  Z_SYNC_FLUSH,
  Z_FULL_FLUSH,
  Z_FINISH: Z_FINISH$2,
  Z_OK: Z_OK$2,
  Z_STREAM_END: Z_STREAM_END$2,
  Z_DEFAULT_COMPRESSION,
  Z_DEFAULT_STRATEGY,
  Z_DEFLATED: Z_DEFLATED$1
} = constants$5;
function Deflate$1(n) {
  this.options = utils$e.assign({
    level: Z_DEFAULT_COMPRESSION,
    method: Z_DEFLATED$1,
    chunkSize: 16384,
    windowBits: 15,
    memLevel: 8,
    strategy: Z_DEFAULT_STRATEGY
  }, n || {});
  let c = this.options;
  c.raw && c.windowBits > 0 ? c.windowBits = -c.windowBits : c.gzip && c.windowBits > 0 && c.windowBits < 16 && (c.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new ZStream$1(), this.strm.avail_out = 0;
  let u = zlib_deflate.deflateInit2(
    this.strm,
    c.level,
    c.method,
    c.windowBits,
    c.memLevel,
    c.strategy
  );
  if (u !== Z_OK$2)
    throw new Error(msg$1[u]);
  if (c.header && zlib_deflate.deflateSetHeader(this.strm, c.header), c.dictionary) {
    let p;
    if (typeof c.dictionary == "string" ? p = strings$1.string2buf(c.dictionary) : toString$1.call(c.dictionary) === "[object ArrayBuffer]" ? p = new Uint8Array(c.dictionary) : p = c.dictionary, u = zlib_deflate.deflateSetDictionary(this.strm, p), u !== Z_OK$2)
      throw new Error(msg$1[u]);
    this._dict_set = !0;
  }
}
Deflate$1.prototype.push = function(n, c) {
  const u = this.strm, p = this.options.chunkSize;
  let a, A;
  if (this.ended)
    return !1;
  for (c === ~~c ? A = c : A = c === !0 ? Z_FINISH$2 : Z_NO_FLUSH$1, typeof n == "string" ? u.input = strings$1.string2buf(n) : toString$1.call(n) === "[object ArrayBuffer]" ? u.input = new Uint8Array(n) : u.input = n, u.next_in = 0, u.avail_in = u.input.length; ; ) {
    if (u.avail_out === 0 && (u.output = new Uint8Array(p), u.next_out = 0, u.avail_out = p), (A === Z_SYNC_FLUSH || A === Z_FULL_FLUSH) && u.avail_out <= 6) {
      this.onData(u.output.subarray(0, u.next_out)), u.avail_out = 0;
      continue;
    }
    if (a = zlib_deflate.deflate(u, A), a === Z_STREAM_END$2)
      return u.next_out > 0 && this.onData(u.output.subarray(0, u.next_out)), a = zlib_deflate.deflateEnd(this.strm), this.onEnd(a), this.ended = !0, a === Z_OK$2;
    if (u.avail_out === 0) {
      this.onData(u.output);
      continue;
    }
    if (A > 0 && u.next_out > 0) {
      this.onData(u.output.subarray(0, u.next_out)), u.avail_out = 0;
      continue;
    }
    if (u.avail_in === 0) break;
  }
  return !0;
};
Deflate$1.prototype.onData = function(n) {
  this.chunks.push(n);
};
Deflate$1.prototype.onEnd = function(n) {
  n === Z_OK$2 && (this.result = utils$e.flattenChunks(this.chunks)), this.chunks = [], this.err = n, this.msg = this.strm.msg;
};
function deflate$1(n, c) {
  const u = new Deflate$1(c);
  if (u.push(n, !0), u.err)
    throw u.msg || msg$1[u.err];
  return u.result;
}
function deflateRaw$1(n, c) {
  return c = c || {}, c.raw = !0, deflate$1(n, c);
}
function gzip$1(n, c) {
  return c = c || {}, c.gzip = !0, deflate$1(n, c);
}
deflate$4.Deflate = Deflate$1;
deflate$4.deflate = deflate$1;
deflate$4.deflateRaw = deflateRaw$1;
deflate$4.gzip = gzip$1;
deflate$4.constants = constants$5;
var inflate$4 = {}, inflate$3 = {};
const BAD$1 = 16209, TYPE$1 = 16191;
var inffast = function n(c, u) {
  let p, a, A, b, F, le, L, pe, $, Ee, be, He, Pe, nr, ir, or, lr, Ir, xr, kr, Ce, tr, Fe, Sr;
  const er = c.state;
  p = c.next_in, Fe = c.input, a = p + (c.avail_in - 5), A = c.next_out, Sr = c.output, b = A - (u - c.avail_out), F = A + (c.avail_out - 257), le = er.dmax, L = er.wsize, pe = er.whave, $ = er.wnext, Ee = er.window, be = er.hold, He = er.bits, Pe = er.lencode, nr = er.distcode, ir = (1 << er.lenbits) - 1, or = (1 << er.distbits) - 1;
  e:
    do {
      He < 15 && (be += Fe[p++] << He, He += 8, be += Fe[p++] << He, He += 8), lr = Pe[be & ir];
      t:
        for (; ; ) {
          if (Ir = lr >>> 24, be >>>= Ir, He -= Ir, Ir = lr >>> 16 & 255, Ir === 0)
            Sr[A++] = lr & 65535;
          else if (Ir & 16) {
            xr = lr & 65535, Ir &= 15, Ir && (He < Ir && (be += Fe[p++] << He, He += 8), xr += be & (1 << Ir) - 1, be >>>= Ir, He -= Ir), He < 15 && (be += Fe[p++] << He, He += 8, be += Fe[p++] << He, He += 8), lr = nr[be & or];
            r:
              for (; ; ) {
                if (Ir = lr >>> 24, be >>>= Ir, He -= Ir, Ir = lr >>> 16 & 255, Ir & 16) {
                  if (kr = lr & 65535, Ir &= 15, He < Ir && (be += Fe[p++] << He, He += 8, He < Ir && (be += Fe[p++] << He, He += 8)), kr += be & (1 << Ir) - 1, kr > le) {
                    c.msg = "invalid distance too far back", er.mode = BAD$1;
                    break e;
                  }
                  if (be >>>= Ir, He -= Ir, Ir = A - b, kr > Ir) {
                    if (Ir = kr - Ir, Ir > pe && er.sane) {
                      c.msg = "invalid distance too far back", er.mode = BAD$1;
                      break e;
                    }
                    if (Ce = 0, tr = Ee, $ === 0) {
                      if (Ce += L - Ir, Ir < xr) {
                        xr -= Ir;
                        do
                          Sr[A++] = Ee[Ce++];
                        while (--Ir);
                        Ce = A - kr, tr = Sr;
                      }
                    } else if ($ < Ir) {
                      if (Ce += L + $ - Ir, Ir -= $, Ir < xr) {
                        xr -= Ir;
                        do
                          Sr[A++] = Ee[Ce++];
                        while (--Ir);
                        if (Ce = 0, $ < xr) {
                          Ir = $, xr -= Ir;
                          do
                            Sr[A++] = Ee[Ce++];
                          while (--Ir);
                          Ce = A - kr, tr = Sr;
                        }
                      }
                    } else if (Ce += $ - Ir, Ir < xr) {
                      xr -= Ir;
                      do
                        Sr[A++] = Ee[Ce++];
                      while (--Ir);
                      Ce = A - kr, tr = Sr;
                    }
                    for (; xr > 2; )
                      Sr[A++] = tr[Ce++], Sr[A++] = tr[Ce++], Sr[A++] = tr[Ce++], xr -= 3;
                    xr && (Sr[A++] = tr[Ce++], xr > 1 && (Sr[A++] = tr[Ce++]));
                  } else {
                    Ce = A - kr;
                    do
                      Sr[A++] = Sr[Ce++], Sr[A++] = Sr[Ce++], Sr[A++] = Sr[Ce++], xr -= 3;
                    while (xr > 2);
                    xr && (Sr[A++] = Sr[Ce++], xr > 1 && (Sr[A++] = Sr[Ce++]));
                  }
                } else if (Ir & 64) {
                  c.msg = "invalid distance code", er.mode = BAD$1;
                  break e;
                } else {
                  lr = nr[(lr & 65535) + (be & (1 << Ir) - 1)];
                  continue r;
                }
                break;
              }
          } else if (Ir & 64)
            if (Ir & 32) {
              er.mode = TYPE$1;
              break e;
            } else {
              c.msg = "invalid literal/length code", er.mode = BAD$1;
              break e;
            }
          else {
            lr = Pe[(lr & 65535) + (be & (1 << Ir) - 1)];
            continue t;
          }
          break;
        }
    } while (p < a && A < F);
  xr = He >> 3, p -= xr, He -= xr << 3, be &= (1 << He) - 1, c.next_in = p, c.next_out = A, c.avail_in = p < a ? 5 + (a - p) : 5 - (p - a), c.avail_out = A < F ? 257 + (F - A) : 257 - (A - F), er.hold = be, er.bits = He;
};
const MAXBITS = 15, ENOUGH_LENS$1 = 852, ENOUGH_DISTS$1 = 592, CODES$1 = 0, LENS$1 = 1, DISTS$1 = 2, lbase = new Uint16Array([
  /* Length codes 257..285 base */
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  13,
  15,
  17,
  19,
  23,
  27,
  31,
  35,
  43,
  51,
  59,
  67,
  83,
  99,
  115,
  131,
  163,
  195,
  227,
  258,
  0,
  0
]), lext = new Uint8Array([
  /* Length codes 257..285 extra */
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  17,
  17,
  17,
  17,
  18,
  18,
  18,
  18,
  19,
  19,
  19,
  19,
  20,
  20,
  20,
  20,
  21,
  21,
  21,
  21,
  16,
  72,
  78
]), dbase = new Uint16Array([
  /* Distance codes 0..29 base */
  1,
  2,
  3,
  4,
  5,
  7,
  9,
  13,
  17,
  25,
  33,
  49,
  65,
  97,
  129,
  193,
  257,
  385,
  513,
  769,
  1025,
  1537,
  2049,
  3073,
  4097,
  6145,
  8193,
  12289,
  16385,
  24577,
  0,
  0
]), dext = new Uint8Array([
  /* Distance codes 0..29 extra */
  16,
  16,
  16,
  16,
  17,
  17,
  18,
  18,
  19,
  19,
  20,
  20,
  21,
  21,
  22,
  22,
  23,
  23,
  24,
  24,
  25,
  25,
  26,
  26,
  27,
  27,
  28,
  28,
  29,
  29,
  64,
  64
]), inflate_table$1 = (n, c, u, p, a, A, b, F) => {
  const le = F.bits;
  let L = 0, pe = 0, $ = 0, Ee = 0, be = 0, He = 0, Pe = 0, nr = 0, ir = 0, or = 0, lr, Ir, xr, kr, Ce, tr = null, Fe;
  const Sr = new Uint16Array(MAXBITS + 1), er = new Uint16Array(MAXBITS + 1);
  let Ie = null, xe, rr, ar;
  for (L = 0; L <= MAXBITS; L++)
    Sr[L] = 0;
  for (pe = 0; pe < p; pe++)
    Sr[c[u + pe]]++;
  for (be = le, Ee = MAXBITS; Ee >= 1 && Sr[Ee] === 0; Ee--)
    ;
  if (be > Ee && (be = Ee), Ee === 0)
    return a[A++] = 1 << 24 | 64 << 16 | 0, a[A++] = 1 << 24 | 64 << 16 | 0, F.bits = 1, 0;
  for ($ = 1; $ < Ee && Sr[$] === 0; $++)
    ;
  for (be < $ && (be = $), nr = 1, L = 1; L <= MAXBITS; L++)
    if (nr <<= 1, nr -= Sr[L], nr < 0)
      return -1;
  if (nr > 0 && (n === CODES$1 || Ee !== 1))
    return -1;
  for (er[1] = 0, L = 1; L < MAXBITS; L++)
    er[L + 1] = er[L] + Sr[L];
  for (pe = 0; pe < p; pe++)
    c[u + pe] !== 0 && (b[er[c[u + pe]]++] = pe);
  if (n === CODES$1 ? (tr = Ie = b, Fe = 20) : n === LENS$1 ? (tr = lbase, Ie = lext, Fe = 257) : (tr = dbase, Ie = dext, Fe = 0), or = 0, pe = 0, L = $, Ce = A, He = be, Pe = 0, xr = -1, ir = 1 << be, kr = ir - 1, n === LENS$1 && ir > ENOUGH_LENS$1 || n === DISTS$1 && ir > ENOUGH_DISTS$1)
    return 1;
  for (; ; ) {
    xe = L - Pe, b[pe] + 1 < Fe ? (rr = 0, ar = b[pe]) : b[pe] >= Fe ? (rr = Ie[b[pe] - Fe], ar = tr[b[pe] - Fe]) : (rr = 96, ar = 0), lr = 1 << L - Pe, Ir = 1 << He, $ = Ir;
    do
      Ir -= lr, a[Ce + (or >> Pe) + Ir] = xe << 24 | rr << 16 | ar | 0;
    while (Ir !== 0);
    for (lr = 1 << L - 1; or & lr; )
      lr >>= 1;
    if (lr !== 0 ? (or &= lr - 1, or += lr) : or = 0, pe++, --Sr[L] === 0) {
      if (L === Ee)
        break;
      L = c[u + b[pe]];
    }
    if (L > be && (or & kr) !== xr) {
      for (Pe === 0 && (Pe = be), Ce += $, He = L - Pe, nr = 1 << He; He + Pe < Ee && (nr -= Sr[He + Pe], !(nr <= 0)); )
        He++, nr <<= 1;
      if (ir += 1 << He, n === LENS$1 && ir > ENOUGH_LENS$1 || n === DISTS$1 && ir > ENOUGH_DISTS$1)
        return 1;
      xr = or & kr, a[xr] = be << 24 | He << 16 | Ce - A | 0;
    }
  }
  return or !== 0 && (a[Ce + or] = L - Pe << 24 | 64 << 16 | 0), F.bits = be, 0;
};
var inftrees = inflate_table$1;
const adler32 = adler32_1, crc32 = crc32_1, inflate_fast = inffast, inflate_table = inftrees, CODES = 0, LENS = 1, DISTS = 2, {
  Z_FINISH: Z_FINISH$1,
  Z_BLOCK,
  Z_TREES,
  Z_OK: Z_OK$1,
  Z_STREAM_END: Z_STREAM_END$1,
  Z_NEED_DICT: Z_NEED_DICT$1,
  Z_STREAM_ERROR: Z_STREAM_ERROR$1,
  Z_DATA_ERROR: Z_DATA_ERROR$1,
  Z_MEM_ERROR: Z_MEM_ERROR$1,
  Z_BUF_ERROR,
  Z_DEFLATED
} = constants$5, HEAD = 16180, FLAGS = 16181, TIME = 16182, OS = 16183, EXLEN = 16184, EXTRA = 16185, NAME = 16186, COMMENT = 16187, HCRC = 16188, DICTID = 16189, DICT = 16190, TYPE = 16191, TYPEDO = 16192, STORED = 16193, COPY_ = 16194, COPY = 16195, TABLE = 16196, LENLENS = 16197, CODELENS = 16198, LEN_ = 16199, LEN = 16200, LENEXT = 16201, DIST = 16202, DISTEXT = 16203, MATCH = 16204, LIT = 16205, CHECK = 16206, LENGTH = 16207, DONE = 16208, BAD = 16209, MEM = 16210, SYNC = 16211, ENOUGH_LENS = 852, ENOUGH_DISTS = 592, MAX_WBITS = 15, DEF_WBITS = MAX_WBITS, zswap32 = (n) => (n >>> 24 & 255) + (n >>> 8 & 65280) + ((n & 65280) << 8) + ((n & 255) << 24);
function InflateState() {
  this.strm = null, this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new Uint16Array(320), this.work = new Uint16Array(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
}
const inflateStateCheck = (n) => {
  if (!n)
    return 1;
  const c = n.state;
  return !c || c.strm !== n || c.mode < HEAD || c.mode > SYNC ? 1 : 0;
}, inflateResetKeep = (n) => {
  if (inflateStateCheck(n))
    return Z_STREAM_ERROR$1;
  const c = n.state;
  return n.total_in = n.total_out = c.total = 0, n.msg = "", c.wrap && (n.adler = c.wrap & 1), c.mode = HEAD, c.last = 0, c.havedict = 0, c.flags = -1, c.dmax = 32768, c.head = null, c.hold = 0, c.bits = 0, c.lencode = c.lendyn = new Int32Array(ENOUGH_LENS), c.distcode = c.distdyn = new Int32Array(ENOUGH_DISTS), c.sane = 1, c.back = -1, Z_OK$1;
}, inflateReset = (n) => {
  if (inflateStateCheck(n))
    return Z_STREAM_ERROR$1;
  const c = n.state;
  return c.wsize = 0, c.whave = 0, c.wnext = 0, inflateResetKeep(n);
}, inflateReset2 = (n, c) => {
  let u;
  if (inflateStateCheck(n))
    return Z_STREAM_ERROR$1;
  const p = n.state;
  return c < 0 ? (u = 0, c = -c) : (u = (c >> 4) + 5, c < 48 && (c &= 15)), c && (c < 8 || c > 15) ? Z_STREAM_ERROR$1 : (p.window !== null && p.wbits !== c && (p.window = null), p.wrap = u, p.wbits = c, inflateReset(n));
}, inflateInit2 = (n, c) => {
  if (!n)
    return Z_STREAM_ERROR$1;
  const u = new InflateState();
  n.state = u, u.strm = n, u.window = null, u.mode = HEAD;
  const p = inflateReset2(n, c);
  return p !== Z_OK$1 && (n.state = null), p;
}, inflateInit = (n) => inflateInit2(n, DEF_WBITS);
let virgin = !0, lenfix, distfix;
const fixedtables = (n) => {
  if (virgin) {
    lenfix = new Int32Array(512), distfix = new Int32Array(32);
    let c = 0;
    for (; c < 144; )
      n.lens[c++] = 8;
    for (; c < 256; )
      n.lens[c++] = 9;
    for (; c < 280; )
      n.lens[c++] = 7;
    for (; c < 288; )
      n.lens[c++] = 8;
    for (inflate_table(LENS, n.lens, 0, 288, lenfix, 0, n.work, { bits: 9 }), c = 0; c < 32; )
      n.lens[c++] = 5;
    inflate_table(DISTS, n.lens, 0, 32, distfix, 0, n.work, { bits: 5 }), virgin = !1;
  }
  n.lencode = lenfix, n.lenbits = 9, n.distcode = distfix, n.distbits = 5;
}, updatewindow = (n, c, u, p) => {
  let a;
  const A = n.state;
  return A.window === null && (A.wsize = 1 << A.wbits, A.wnext = 0, A.whave = 0, A.window = new Uint8Array(A.wsize)), p >= A.wsize ? (A.window.set(c.subarray(u - A.wsize, u), 0), A.wnext = 0, A.whave = A.wsize) : (a = A.wsize - A.wnext, a > p && (a = p), A.window.set(c.subarray(u - p, u - p + a), A.wnext), p -= a, p ? (A.window.set(c.subarray(u - p, u), 0), A.wnext = p, A.whave = A.wsize) : (A.wnext += a, A.wnext === A.wsize && (A.wnext = 0), A.whave < A.wsize && (A.whave += a))), 0;
}, inflate$2 = (n, c) => {
  let u, p, a, A, b, F, le, L, pe, $, Ee, be, He, Pe, nr = 0, ir, or, lr, Ir, xr, kr, Ce, tr;
  const Fe = new Uint8Array(4);
  let Sr, er;
  const Ie = (
    /* permutation of code lengths */
    new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15])
  );
  if (inflateStateCheck(n) || !n.output || !n.input && n.avail_in !== 0)
    return Z_STREAM_ERROR$1;
  u = n.state, u.mode === TYPE && (u.mode = TYPEDO), b = n.next_out, a = n.output, le = n.avail_out, A = n.next_in, p = n.input, F = n.avail_in, L = u.hold, pe = u.bits, $ = F, Ee = le, tr = Z_OK$1;
  e:
    for (; ; )
      switch (u.mode) {
        case HEAD:
          if (u.wrap === 0) {
            u.mode = TYPEDO;
            break;
          }
          for (; pe < 16; ) {
            if (F === 0)
              break e;
            F--, L += p[A++] << pe, pe += 8;
          }
          if (u.wrap & 2 && L === 35615) {
            u.wbits === 0 && (u.wbits = 15), u.check = 0, Fe[0] = L & 255, Fe[1] = L >>> 8 & 255, u.check = crc32(u.check, Fe, 2, 0), L = 0, pe = 0, u.mode = FLAGS;
            break;
          }
          if (u.head && (u.head.done = !1), !(u.wrap & 1) || /* check if zlib header allowed */
          (((L & 255) << 8) + (L >> 8)) % 31) {
            n.msg = "incorrect header check", u.mode = BAD;
            break;
          }
          if ((L & 15) !== Z_DEFLATED) {
            n.msg = "unknown compression method", u.mode = BAD;
            break;
          }
          if (L >>>= 4, pe -= 4, Ce = (L & 15) + 8, u.wbits === 0 && (u.wbits = Ce), Ce > 15 || Ce > u.wbits) {
            n.msg = "invalid window size", u.mode = BAD;
            break;
          }
          u.dmax = 1 << u.wbits, u.flags = 0, n.adler = u.check = 1, u.mode = L & 512 ? DICTID : TYPE, L = 0, pe = 0;
          break;
        case FLAGS:
          for (; pe < 16; ) {
            if (F === 0)
              break e;
            F--, L += p[A++] << pe, pe += 8;
          }
          if (u.flags = L, (u.flags & 255) !== Z_DEFLATED) {
            n.msg = "unknown compression method", u.mode = BAD;
            break;
          }
          if (u.flags & 57344) {
            n.msg = "unknown header flags set", u.mode = BAD;
            break;
          }
          u.head && (u.head.text = L >> 8 & 1), u.flags & 512 && u.wrap & 4 && (Fe[0] = L & 255, Fe[1] = L >>> 8 & 255, u.check = crc32(u.check, Fe, 2, 0)), L = 0, pe = 0, u.mode = TIME;
        case TIME:
          for (; pe < 32; ) {
            if (F === 0)
              break e;
            F--, L += p[A++] << pe, pe += 8;
          }
          u.head && (u.head.time = L), u.flags & 512 && u.wrap & 4 && (Fe[0] = L & 255, Fe[1] = L >>> 8 & 255, Fe[2] = L >>> 16 & 255, Fe[3] = L >>> 24 & 255, u.check = crc32(u.check, Fe, 4, 0)), L = 0, pe = 0, u.mode = OS;
        case OS:
          for (; pe < 16; ) {
            if (F === 0)
              break e;
            F--, L += p[A++] << pe, pe += 8;
          }
          u.head && (u.head.xflags = L & 255, u.head.os = L >> 8), u.flags & 512 && u.wrap & 4 && (Fe[0] = L & 255, Fe[1] = L >>> 8 & 255, u.check = crc32(u.check, Fe, 2, 0)), L = 0, pe = 0, u.mode = EXLEN;
        case EXLEN:
          if (u.flags & 1024) {
            for (; pe < 16; ) {
              if (F === 0)
                break e;
              F--, L += p[A++] << pe, pe += 8;
            }
            u.length = L, u.head && (u.head.extra_len = L), u.flags & 512 && u.wrap & 4 && (Fe[0] = L & 255, Fe[1] = L >>> 8 & 255, u.check = crc32(u.check, Fe, 2, 0)), L = 0, pe = 0;
          } else u.head && (u.head.extra = null);
          u.mode = EXTRA;
        case EXTRA:
          if (u.flags & 1024 && (be = u.length, be > F && (be = F), be && (u.head && (Ce = u.head.extra_len - u.length, u.head.extra || (u.head.extra = new Uint8Array(u.head.extra_len)), u.head.extra.set(
            p.subarray(
              A,
              // extra field is limited to 65536 bytes
              // - no need for additional size check
              A + be
            ),
            /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
            Ce
          )), u.flags & 512 && u.wrap & 4 && (u.check = crc32(u.check, p, be, A)), F -= be, A += be, u.length -= be), u.length))
            break e;
          u.length = 0, u.mode = NAME;
        case NAME:
          if (u.flags & 2048) {
            if (F === 0)
              break e;
            be = 0;
            do
              Ce = p[A + be++], u.head && Ce && u.length < 65536 && (u.head.name += String.fromCharCode(Ce));
            while (Ce && be < F);
            if (u.flags & 512 && u.wrap & 4 && (u.check = crc32(u.check, p, be, A)), F -= be, A += be, Ce)
              break e;
          } else u.head && (u.head.name = null);
          u.length = 0, u.mode = COMMENT;
        case COMMENT:
          if (u.flags & 4096) {
            if (F === 0)
              break e;
            be = 0;
            do
              Ce = p[A + be++], u.head && Ce && u.length < 65536 && (u.head.comment += String.fromCharCode(Ce));
            while (Ce && be < F);
            if (u.flags & 512 && u.wrap & 4 && (u.check = crc32(u.check, p, be, A)), F -= be, A += be, Ce)
              break e;
          } else u.head && (u.head.comment = null);
          u.mode = HCRC;
        case HCRC:
          if (u.flags & 512) {
            for (; pe < 16; ) {
              if (F === 0)
                break e;
              F--, L += p[A++] << pe, pe += 8;
            }
            if (u.wrap & 4 && L !== (u.check & 65535)) {
              n.msg = "header crc mismatch", u.mode = BAD;
              break;
            }
            L = 0, pe = 0;
          }
          u.head && (u.head.hcrc = u.flags >> 9 & 1, u.head.done = !0), n.adler = u.check = 0, u.mode = TYPE;
          break;
        case DICTID:
          for (; pe < 32; ) {
            if (F === 0)
              break e;
            F--, L += p[A++] << pe, pe += 8;
          }
          n.adler = u.check = zswap32(L), L = 0, pe = 0, u.mode = DICT;
        case DICT:
          if (u.havedict === 0)
            return n.next_out = b, n.avail_out = le, n.next_in = A, n.avail_in = F, u.hold = L, u.bits = pe, Z_NEED_DICT$1;
          n.adler = u.check = 1, u.mode = TYPE;
        case TYPE:
          if (c === Z_BLOCK || c === Z_TREES)
            break e;
        case TYPEDO:
          if (u.last) {
            L >>>= pe & 7, pe -= pe & 7, u.mode = CHECK;
            break;
          }
          for (; pe < 3; ) {
            if (F === 0)
              break e;
            F--, L += p[A++] << pe, pe += 8;
          }
          switch (u.last = L & 1, L >>>= 1, pe -= 1, L & 3) {
            case 0:
              u.mode = STORED;
              break;
            case 1:
              if (fixedtables(u), u.mode = LEN_, c === Z_TREES) {
                L >>>= 2, pe -= 2;
                break e;
              }
              break;
            case 2:
              u.mode = TABLE;
              break;
            case 3:
              n.msg = "invalid block type", u.mode = BAD;
          }
          L >>>= 2, pe -= 2;
          break;
        case STORED:
          for (L >>>= pe & 7, pe -= pe & 7; pe < 32; ) {
            if (F === 0)
              break e;
            F--, L += p[A++] << pe, pe += 8;
          }
          if ((L & 65535) !== (L >>> 16 ^ 65535)) {
            n.msg = "invalid stored block lengths", u.mode = BAD;
            break;
          }
          if (u.length = L & 65535, L = 0, pe = 0, u.mode = COPY_, c === Z_TREES)
            break e;
        case COPY_:
          u.mode = COPY;
        case COPY:
          if (be = u.length, be) {
            if (be > F && (be = F), be > le && (be = le), be === 0)
              break e;
            a.set(p.subarray(A, A + be), b), F -= be, A += be, le -= be, b += be, u.length -= be;
            break;
          }
          u.mode = TYPE;
          break;
        case TABLE:
          for (; pe < 14; ) {
            if (F === 0)
              break e;
            F--, L += p[A++] << pe, pe += 8;
          }
          if (u.nlen = (L & 31) + 257, L >>>= 5, pe -= 5, u.ndist = (L & 31) + 1, L >>>= 5, pe -= 5, u.ncode = (L & 15) + 4, L >>>= 4, pe -= 4, u.nlen > 286 || u.ndist > 30) {
            n.msg = "too many length or distance symbols", u.mode = BAD;
            break;
          }
          u.have = 0, u.mode = LENLENS;
        case LENLENS:
          for (; u.have < u.ncode; ) {
            for (; pe < 3; ) {
              if (F === 0)
                break e;
              F--, L += p[A++] << pe, pe += 8;
            }
            u.lens[Ie[u.have++]] = L & 7, L >>>= 3, pe -= 3;
          }
          for (; u.have < 19; )
            u.lens[Ie[u.have++]] = 0;
          if (u.lencode = u.lendyn, u.lenbits = 7, Sr = { bits: u.lenbits }, tr = inflate_table(CODES, u.lens, 0, 19, u.lencode, 0, u.work, Sr), u.lenbits = Sr.bits, tr) {
            n.msg = "invalid code lengths set", u.mode = BAD;
            break;
          }
          u.have = 0, u.mode = CODELENS;
        case CODELENS:
          for (; u.have < u.nlen + u.ndist; ) {
            for (; nr = u.lencode[L & (1 << u.lenbits) - 1], ir = nr >>> 24, or = nr >>> 16 & 255, lr = nr & 65535, !(ir <= pe); ) {
              if (F === 0)
                break e;
              F--, L += p[A++] << pe, pe += 8;
            }
            if (lr < 16)
              L >>>= ir, pe -= ir, u.lens[u.have++] = lr;
            else {
              if (lr === 16) {
                for (er = ir + 2; pe < er; ) {
                  if (F === 0)
                    break e;
                  F--, L += p[A++] << pe, pe += 8;
                }
                if (L >>>= ir, pe -= ir, u.have === 0) {
                  n.msg = "invalid bit length repeat", u.mode = BAD;
                  break;
                }
                Ce = u.lens[u.have - 1], be = 3 + (L & 3), L >>>= 2, pe -= 2;
              } else if (lr === 17) {
                for (er = ir + 3; pe < er; ) {
                  if (F === 0)
                    break e;
                  F--, L += p[A++] << pe, pe += 8;
                }
                L >>>= ir, pe -= ir, Ce = 0, be = 3 + (L & 7), L >>>= 3, pe -= 3;
              } else {
                for (er = ir + 7; pe < er; ) {
                  if (F === 0)
                    break e;
                  F--, L += p[A++] << pe, pe += 8;
                }
                L >>>= ir, pe -= ir, Ce = 0, be = 11 + (L & 127), L >>>= 7, pe -= 7;
              }
              if (u.have + be > u.nlen + u.ndist) {
                n.msg = "invalid bit length repeat", u.mode = BAD;
                break;
              }
              for (; be--; )
                u.lens[u.have++] = Ce;
            }
          }
          if (u.mode === BAD)
            break;
          if (u.lens[256] === 0) {
            n.msg = "invalid code -- missing end-of-block", u.mode = BAD;
            break;
          }
          if (u.lenbits = 9, Sr = { bits: u.lenbits }, tr = inflate_table(LENS, u.lens, 0, u.nlen, u.lencode, 0, u.work, Sr), u.lenbits = Sr.bits, tr) {
            n.msg = "invalid literal/lengths set", u.mode = BAD;
            break;
          }
          if (u.distbits = 6, u.distcode = u.distdyn, Sr = { bits: u.distbits }, tr = inflate_table(DISTS, u.lens, u.nlen, u.ndist, u.distcode, 0, u.work, Sr), u.distbits = Sr.bits, tr) {
            n.msg = "invalid distances set", u.mode = BAD;
            break;
          }
          if (u.mode = LEN_, c === Z_TREES)
            break e;
        case LEN_:
          u.mode = LEN;
        case LEN:
          if (F >= 6 && le >= 258) {
            n.next_out = b, n.avail_out = le, n.next_in = A, n.avail_in = F, u.hold = L, u.bits = pe, inflate_fast(n, Ee), b = n.next_out, a = n.output, le = n.avail_out, A = n.next_in, p = n.input, F = n.avail_in, L = u.hold, pe = u.bits, u.mode === TYPE && (u.back = -1);
            break;
          }
          for (u.back = 0; nr = u.lencode[L & (1 << u.lenbits) - 1], ir = nr >>> 24, or = nr >>> 16 & 255, lr = nr & 65535, !(ir <= pe); ) {
            if (F === 0)
              break e;
            F--, L += p[A++] << pe, pe += 8;
          }
          if (or && !(or & 240)) {
            for (Ir = ir, xr = or, kr = lr; nr = u.lencode[kr + ((L & (1 << Ir + xr) - 1) >> Ir)], ir = nr >>> 24, or = nr >>> 16 & 255, lr = nr & 65535, !(Ir + ir <= pe); ) {
              if (F === 0)
                break e;
              F--, L += p[A++] << pe, pe += 8;
            }
            L >>>= Ir, pe -= Ir, u.back += Ir;
          }
          if (L >>>= ir, pe -= ir, u.back += ir, u.length = lr, or === 0) {
            u.mode = LIT;
            break;
          }
          if (or & 32) {
            u.back = -1, u.mode = TYPE;
            break;
          }
          if (or & 64) {
            n.msg = "invalid literal/length code", u.mode = BAD;
            break;
          }
          u.extra = or & 15, u.mode = LENEXT;
        case LENEXT:
          if (u.extra) {
            for (er = u.extra; pe < er; ) {
              if (F === 0)
                break e;
              F--, L += p[A++] << pe, pe += 8;
            }
            u.length += L & (1 << u.extra) - 1, L >>>= u.extra, pe -= u.extra, u.back += u.extra;
          }
          u.was = u.length, u.mode = DIST;
        case DIST:
          for (; nr = u.distcode[L & (1 << u.distbits) - 1], ir = nr >>> 24, or = nr >>> 16 & 255, lr = nr & 65535, !(ir <= pe); ) {
            if (F === 0)
              break e;
            F--, L += p[A++] << pe, pe += 8;
          }
          if (!(or & 240)) {
            for (Ir = ir, xr = or, kr = lr; nr = u.distcode[kr + ((L & (1 << Ir + xr) - 1) >> Ir)], ir = nr >>> 24, or = nr >>> 16 & 255, lr = nr & 65535, !(Ir + ir <= pe); ) {
              if (F === 0)
                break e;
              F--, L += p[A++] << pe, pe += 8;
            }
            L >>>= Ir, pe -= Ir, u.back += Ir;
          }
          if (L >>>= ir, pe -= ir, u.back += ir, or & 64) {
            n.msg = "invalid distance code", u.mode = BAD;
            break;
          }
          u.offset = lr, u.extra = or & 15, u.mode = DISTEXT;
        case DISTEXT:
          if (u.extra) {
            for (er = u.extra; pe < er; ) {
              if (F === 0)
                break e;
              F--, L += p[A++] << pe, pe += 8;
            }
            u.offset += L & (1 << u.extra) - 1, L >>>= u.extra, pe -= u.extra, u.back += u.extra;
          }
          if (u.offset > u.dmax) {
            n.msg = "invalid distance too far back", u.mode = BAD;
            break;
          }
          u.mode = MATCH;
        case MATCH:
          if (le === 0)
            break e;
          if (be = Ee - le, u.offset > be) {
            if (be = u.offset - be, be > u.whave && u.sane) {
              n.msg = "invalid distance too far back", u.mode = BAD;
              break;
            }
            be > u.wnext ? (be -= u.wnext, He = u.wsize - be) : He = u.wnext - be, be > u.length && (be = u.length), Pe = u.window;
          } else
            Pe = a, He = b - u.offset, be = u.length;
          be > le && (be = le), le -= be, u.length -= be;
          do
            a[b++] = Pe[He++];
          while (--be);
          u.length === 0 && (u.mode = LEN);
          break;
        case LIT:
          if (le === 0)
            break e;
          a[b++] = u.length, le--, u.mode = LEN;
          break;
        case CHECK:
          if (u.wrap) {
            for (; pe < 32; ) {
              if (F === 0)
                break e;
              F--, L |= p[A++] << pe, pe += 8;
            }
            if (Ee -= le, n.total_out += Ee, u.total += Ee, u.wrap & 4 && Ee && (n.adler = u.check = /*UPDATE_CHECK(state.check, put - _out, _out);*/
            u.flags ? crc32(u.check, a, Ee, b - Ee) : adler32(u.check, a, Ee, b - Ee)), Ee = le, u.wrap & 4 && (u.flags ? L : zswap32(L)) !== u.check) {
              n.msg = "incorrect data check", u.mode = BAD;
              break;
            }
            L = 0, pe = 0;
          }
          u.mode = LENGTH;
        case LENGTH:
          if (u.wrap && u.flags) {
            for (; pe < 32; ) {
              if (F === 0)
                break e;
              F--, L += p[A++] << pe, pe += 8;
            }
            if (u.wrap & 4 && L !== (u.total & 4294967295)) {
              n.msg = "incorrect length check", u.mode = BAD;
              break;
            }
            L = 0, pe = 0;
          }
          u.mode = DONE;
        case DONE:
          tr = Z_STREAM_END$1;
          break e;
        case BAD:
          tr = Z_DATA_ERROR$1;
          break e;
        case MEM:
          return Z_MEM_ERROR$1;
        case SYNC:
        default:
          return Z_STREAM_ERROR$1;
      }
  return n.next_out = b, n.avail_out = le, n.next_in = A, n.avail_in = F, u.hold = L, u.bits = pe, (u.wsize || Ee !== n.avail_out && u.mode < BAD && (u.mode < CHECK || c !== Z_FINISH$1)) && updatewindow(n, n.output, n.next_out, Ee - n.avail_out), $ -= n.avail_in, Ee -= n.avail_out, n.total_in += $, n.total_out += Ee, u.total += Ee, u.wrap & 4 && Ee && (n.adler = u.check = /*UPDATE_CHECK(state.check, strm.next_out - _out, _out);*/
  u.flags ? crc32(u.check, a, Ee, n.next_out - Ee) : adler32(u.check, a, Ee, n.next_out - Ee)), n.data_type = u.bits + (u.last ? 64 : 0) + (u.mode === TYPE ? 128 : 0) + (u.mode === LEN_ || u.mode === COPY_ ? 256 : 0), ($ === 0 && Ee === 0 || c === Z_FINISH$1) && tr === Z_OK$1 && (tr = Z_BUF_ERROR), tr;
}, inflateEnd = (n) => {
  if (inflateStateCheck(n))
    return Z_STREAM_ERROR$1;
  let c = n.state;
  return c.window && (c.window = null), n.state = null, Z_OK$1;
}, inflateGetHeader = (n, c) => {
  if (inflateStateCheck(n))
    return Z_STREAM_ERROR$1;
  const u = n.state;
  return u.wrap & 2 ? (u.head = c, c.done = !1, Z_OK$1) : Z_STREAM_ERROR$1;
}, inflateSetDictionary = (n, c) => {
  const u = c.length;
  let p, a, A;
  return inflateStateCheck(n) || (p = n.state, p.wrap !== 0 && p.mode !== DICT) ? Z_STREAM_ERROR$1 : p.mode === DICT && (a = 1, a = adler32(a, c, u, 0), a !== p.check) ? Z_DATA_ERROR$1 : (A = updatewindow(n, c, u, u), A ? (p.mode = MEM, Z_MEM_ERROR$1) : (p.havedict = 1, Z_OK$1));
};
inflate$3.inflateReset = inflateReset;
inflate$3.inflateReset2 = inflateReset2;
inflate$3.inflateResetKeep = inflateResetKeep;
inflate$3.inflateInit = inflateInit;
inflate$3.inflateInit2 = inflateInit2;
inflate$3.inflate = inflate$2;
inflate$3.inflateEnd = inflateEnd;
inflate$3.inflateGetHeader = inflateGetHeader;
inflate$3.inflateSetDictionary = inflateSetDictionary;
inflate$3.inflateInfo = "pako inflate (from Nodeca project)";
function GZheader$1() {
  this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
}
var gzheader = GZheader$1;
const zlib_inflate = inflate$3, utils$d = common, strings = strings$2, msg = messages, ZStream = zstream, GZheader = gzheader, toString = Object.prototype.toString, {
  Z_NO_FLUSH,
  Z_FINISH,
  Z_OK,
  Z_STREAM_END,
  Z_NEED_DICT,
  Z_STREAM_ERROR,
  Z_DATA_ERROR,
  Z_MEM_ERROR
} = constants$5;
function Inflate$1(n) {
  this.options = utils$d.assign({
    chunkSize: 1024 * 64,
    windowBits: 15,
    to: ""
  }, n || {});
  const c = this.options;
  c.raw && c.windowBits >= 0 && c.windowBits < 16 && (c.windowBits = -c.windowBits, c.windowBits === 0 && (c.windowBits = -15)), c.windowBits >= 0 && c.windowBits < 16 && !(n && n.windowBits) && (c.windowBits += 32), c.windowBits > 15 && c.windowBits < 48 && (c.windowBits & 15 || (c.windowBits |= 15)), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new ZStream(), this.strm.avail_out = 0;
  let u = zlib_inflate.inflateInit2(
    this.strm,
    c.windowBits
  );
  if (u !== Z_OK)
    throw new Error(msg[u]);
  if (this.header = new GZheader(), zlib_inflate.inflateGetHeader(this.strm, this.header), c.dictionary && (typeof c.dictionary == "string" ? c.dictionary = strings.string2buf(c.dictionary) : toString.call(c.dictionary) === "[object ArrayBuffer]" && (c.dictionary = new Uint8Array(c.dictionary)), c.raw && (u = zlib_inflate.inflateSetDictionary(this.strm, c.dictionary), u !== Z_OK)))
    throw new Error(msg[u]);
}
Inflate$1.prototype.push = function(n, c) {
  const u = this.strm, p = this.options.chunkSize, a = this.options.dictionary;
  let A, b, F;
  if (this.ended) return !1;
  for (c === ~~c ? b = c : b = c === !0 ? Z_FINISH : Z_NO_FLUSH, toString.call(n) === "[object ArrayBuffer]" ? u.input = new Uint8Array(n) : u.input = n, u.next_in = 0, u.avail_in = u.input.length; ; ) {
    for (u.avail_out === 0 && (u.output = new Uint8Array(p), u.next_out = 0, u.avail_out = p), A = zlib_inflate.inflate(u, b), A === Z_NEED_DICT && a && (A = zlib_inflate.inflateSetDictionary(u, a), A === Z_OK ? A = zlib_inflate.inflate(u, b) : A === Z_DATA_ERROR && (A = Z_NEED_DICT)); u.avail_in > 0 && A === Z_STREAM_END && u.state.wrap > 0 && n[u.next_in] !== 0; )
      zlib_inflate.inflateReset(u), A = zlib_inflate.inflate(u, b);
    switch (A) {
      case Z_STREAM_ERROR:
      case Z_DATA_ERROR:
      case Z_NEED_DICT:
      case Z_MEM_ERROR:
        return this.onEnd(A), this.ended = !0, !1;
    }
    if (F = u.avail_out, u.next_out && (u.avail_out === 0 || A === Z_STREAM_END))
      if (this.options.to === "string") {
        let le = strings.utf8border(u.output, u.next_out), L = u.next_out - le, pe = strings.buf2string(u.output, le);
        u.next_out = L, u.avail_out = p - L, L && u.output.set(u.output.subarray(le, le + L), 0), this.onData(pe);
      } else
        this.onData(u.output.length === u.next_out ? u.output : u.output.subarray(0, u.next_out));
    if (!(A === Z_OK && F === 0)) {
      if (A === Z_STREAM_END)
        return A = zlib_inflate.inflateEnd(this.strm), this.onEnd(A), this.ended = !0, !0;
      if (u.avail_in === 0) break;
    }
  }
  return !0;
};
Inflate$1.prototype.onData = function(n) {
  this.chunks.push(n);
};
Inflate$1.prototype.onEnd = function(n) {
  n === Z_OK && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = utils$d.flattenChunks(this.chunks)), this.chunks = [], this.err = n, this.msg = this.strm.msg;
};
function inflate$1(n, c) {
  const u = new Inflate$1(c);
  if (u.push(n), u.err) throw u.msg || msg[u.err];
  return u.result;
}
function inflateRaw$1(n, c) {
  return c = c || {}, c.raw = !0, inflate$1(n, c);
}
inflate$4.Inflate = Inflate$1;
inflate$4.inflate = inflate$1;
inflate$4.inflateRaw = inflateRaw$1;
inflate$4.ungzip = inflate$1;
inflate$4.constants = constants$5;
const { Deflate, deflate, deflateRaw, gzip } = deflate$4, { Inflate, inflate, inflateRaw, ungzip } = inflate$4, constants$4 = constants$5;
pako.Deflate = Deflate;
pako.deflate = deflate;
pako.deflateRaw = deflateRaw;
pako.gzip = gzip;
pako.Inflate = Inflate;
pako.inflate = inflate;
pako.inflateRaw = inflateRaw;
pako.ungzip = ungzip;
pako.constants = constants$4;
var base_pb = {}, payload_pb = {}, transaction_pb = {}, bch_transaction_pb = {}, btc_transaction_pb = {};
Object.defineProperty(btc_transaction_pb, "__esModule", { value: !0 });
btc_transaction_pb.Output = btc_transaction_pb.utxo = btc_transaction_pb.Input = btc_transaction_pb.Omni = btc_transaction_pb.BtcTx = void 0;
const protobuf_1$6 = cjs$1;
class BtcTx extends protobuf_1$6.Message {
  constructor(c) {
    super(), this.fee = protobuf_1$6.protoInt64.zero, this.dustThreshold = 0, this.memo = "", this.inputs = [], this.outputs = [], protobuf_1$6.proto3.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new BtcTx().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new BtcTx().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new BtcTx().fromJsonString(c, u);
  }
  static equals(c, u) {
    return protobuf_1$6.proto3.util.equals(BtcTx, c, u);
  }
}
BtcTx.runtime = protobuf_1$6.proto3;
BtcTx.typeName = "protoc.BtcTx";
BtcTx.fields = protobuf_1$6.proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "fee",
    kind: "scalar",
    T: 3
    /* ScalarType.INT64 */
  },
  {
    no: 2,
    name: "dustThreshold",
    kind: "scalar",
    T: 5
    /* ScalarType.INT32 */
  },
  {
    no: 3,
    name: "memo",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  { no: 4, name: "inputs", kind: "message", T: Input, repeated: !0 },
  { no: 5, name: "outputs", kind: "message", T: Output, repeated: !0 },
  { no: 6, name: "omni", kind: "message", T: Omni }
]);
btc_transaction_pb.BtcTx = BtcTx;
class Omni extends protobuf_1$6.Message {
  constructor(c) {
    super(), this.to = "", this.changeAddress = "", this.omniAmount = protobuf_1$6.protoInt64.zero, this.propertyId = 0, protobuf_1$6.proto3.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new Omni().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new Omni().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new Omni().fromJsonString(c, u);
  }
  static equals(c, u) {
    return protobuf_1$6.proto3.util.equals(Omni, c, u);
  }
}
Omni.runtime = protobuf_1$6.proto3;
Omni.typeName = "protoc.Omni";
Omni.fields = protobuf_1$6.proto3.util.newFieldList(() => [
  {
    no: 5,
    name: "to",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 6,
    name: "changeAddress",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 7,
    name: "omniAmount",
    kind: "scalar",
    T: 3
    /* ScalarType.INT64 */
  },
  {
    no: 8,
    name: "propertyId",
    kind: "scalar",
    T: 5
    /* ScalarType.INT32 */
  }
]);
btc_transaction_pb.Omni = Omni;
class Input extends protobuf_1$6.Message {
  constructor(c) {
    super(), this.hash = "", this.index = 0, this.ownerKeyPath = "", protobuf_1$6.proto3.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new Input().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new Input().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new Input().fromJsonString(c, u);
  }
  static equals(c, u) {
    return protobuf_1$6.proto3.util.equals(Input, c, u);
  }
}
Input.runtime = protobuf_1$6.proto3;
Input.typeName = "protoc.Input";
Input.fields = protobuf_1$6.proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "hash",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 2,
    name: "index",
    kind: "scalar",
    T: 5
    /* ScalarType.INT32 */
  },
  { no: 3, name: "utxo", kind: "message", T: utxo },
  {
    no: 4,
    name: "ownerKeyPath",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  }
]);
btc_transaction_pb.Input = Input;
class utxo extends protobuf_1$6.Message {
  constructor(c) {
    super(), this.publicKey = "", this.script = "", this.value = protobuf_1$6.protoInt64.zero, protobuf_1$6.proto3.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new utxo().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new utxo().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new utxo().fromJsonString(c, u);
  }
  static equals(c, u) {
    return protobuf_1$6.proto3.util.equals(utxo, c, u);
  }
}
utxo.runtime = protobuf_1$6.proto3;
utxo.typeName = "protoc.utxo";
utxo.fields = protobuf_1$6.proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "publicKey",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 2,
    name: "script",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 3,
    name: "value",
    kind: "scalar",
    T: 3
    /* ScalarType.INT64 */
  }
]);
btc_transaction_pb.utxo = utxo;
class Output extends protobuf_1$6.Message {
  constructor(c) {
    super(), this.address = "", this.value = protobuf_1$6.protoInt64.zero, this.isChange = !1, this.changeAddressPath = "", protobuf_1$6.proto3.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new Output().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new Output().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new Output().fromJsonString(c, u);
  }
  static equals(c, u) {
    return protobuf_1$6.proto3.util.equals(Output, c, u);
  }
}
Output.runtime = protobuf_1$6.proto3;
Output.typeName = "protoc.Output";
Output.fields = protobuf_1$6.proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "address",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 2,
    name: "value",
    kind: "scalar",
    T: 3
    /* ScalarType.INT64 */
  },
  {
    no: 3,
    name: "isChange",
    kind: "scalar",
    T: 8
    /* ScalarType.BOOL */
  },
  {
    no: 4,
    name: "changeAddressPath",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  }
]);
btc_transaction_pb.Output = Output;
Object.defineProperty(bch_transaction_pb, "__esModule", { value: !0 });
bch_transaction_pb.BchTx_Input = bch_transaction_pb.BchTx = void 0;
const protobuf_1$5 = cjs$1, btc_transaction_pb_1$2 = btc_transaction_pb;
class BchTx extends protobuf_1$5.Message {
  constructor(c) {
    super(), this.fee = protobuf_1$5.protoInt64.zero, this.dustThreshold = 0, this.memo = "", this.inputs = [], this.outputs = [], protobuf_1$5.proto3.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new BchTx().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new BchTx().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new BchTx().fromJsonString(c, u);
  }
  static equals(c, u) {
    return protobuf_1$5.proto3.util.equals(BchTx, c, u);
  }
}
BchTx.runtime = protobuf_1$5.proto3;
BchTx.typeName = "protoc.BchTx";
BchTx.fields = protobuf_1$5.proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "fee",
    kind: "scalar",
    T: 3
    /* ScalarType.INT64 */
  },
  {
    no: 2,
    name: "dustThreshold",
    kind: "scalar",
    T: 5
    /* ScalarType.INT32 */
  },
  {
    no: 3,
    name: "memo",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  { no: 4, name: "inputs", kind: "message", T: BchTx_Input, repeated: !0 },
  { no: 5, name: "outputs", kind: "message", T: btc_transaction_pb_1$2.Output, repeated: !0 }
]);
bch_transaction_pb.BchTx = BchTx;
class BchTx_Input extends protobuf_1$5.Message {
  constructor(c) {
    super(), this.hash = "", this.index = 0, this.value = protobuf_1$5.protoInt64.zero, this.pubkey = "", this.ownerKeyPath = "", protobuf_1$5.proto3.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new BchTx_Input().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new BchTx_Input().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new BchTx_Input().fromJsonString(c, u);
  }
  static equals(c, u) {
    return protobuf_1$5.proto3.util.equals(BchTx_Input, c, u);
  }
}
BchTx_Input.runtime = protobuf_1$5.proto3;
BchTx_Input.typeName = "protoc.BchTx.Input";
BchTx_Input.fields = protobuf_1$5.proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "hash",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 2,
    name: "index",
    kind: "scalar",
    T: 5
    /* ScalarType.INT32 */
  },
  {
    no: 3,
    name: "value",
    kind: "scalar",
    T: 3
    /* ScalarType.INT64 */
  },
  {
    no: 4,
    name: "pubkey",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 5,
    name: "ownerKeyPath",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  }
]);
bch_transaction_pb.BchTx_Input = BchTx_Input;
var dash_transaction_pb = {};
Object.defineProperty(dash_transaction_pb, "__esModule", { value: !0 });
dash_transaction_pb.DashTx_Input = dash_transaction_pb.DashTx = void 0;
const protobuf_1$4 = cjs$1, btc_transaction_pb_1$1 = btc_transaction_pb;
class DashTx extends protobuf_1$4.Message {
  constructor(c) {
    super(), this.fee = protobuf_1$4.protoInt64.zero, this.dustThreshold = 0, this.memo = "", this.inputs = [], this.outputs = [], protobuf_1$4.proto3.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new DashTx().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new DashTx().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new DashTx().fromJsonString(c, u);
  }
  static equals(c, u) {
    return protobuf_1$4.proto3.util.equals(DashTx, c, u);
  }
}
DashTx.runtime = protobuf_1$4.proto3;
DashTx.typeName = "protoc.DashTx";
DashTx.fields = protobuf_1$4.proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "fee",
    kind: "scalar",
    T: 3
    /* ScalarType.INT64 */
  },
  {
    no: 2,
    name: "dustThreshold",
    kind: "scalar",
    T: 5
    /* ScalarType.INT32 */
  },
  {
    no: 3,
    name: "memo",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  { no: 4, name: "inputs", kind: "message", T: DashTx_Input, repeated: !0 },
  { no: 5, name: "outputs", kind: "message", T: btc_transaction_pb_1$1.Output, repeated: !0 }
]);
dash_transaction_pb.DashTx = DashTx;
class DashTx_Input extends protobuf_1$4.Message {
  constructor(c) {
    super(), this.hash = "", this.index = 0, this.value = protobuf_1$4.protoInt64.zero, this.pubkey = "", this.ownerKeyPath = "", protobuf_1$4.proto3.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new DashTx_Input().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new DashTx_Input().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new DashTx_Input().fromJsonString(c, u);
  }
  static equals(c, u) {
    return protobuf_1$4.proto3.util.equals(DashTx_Input, c, u);
  }
}
DashTx_Input.runtime = protobuf_1$4.proto3;
DashTx_Input.typeName = "protoc.DashTx.Input";
DashTx_Input.fields = protobuf_1$4.proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "hash",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 2,
    name: "index",
    kind: "scalar",
    T: 5
    /* ScalarType.INT32 */
  },
  {
    no: 3,
    name: "value",
    kind: "scalar",
    T: 3
    /* ScalarType.INT64 */
  },
  {
    no: 4,
    name: "pubkey",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 5,
    name: "ownerKeyPath",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  }
]);
dash_transaction_pb.DashTx_Input = DashTx_Input;
var ltc_transaction_pb = {};
Object.defineProperty(ltc_transaction_pb, "__esModule", { value: !0 });
ltc_transaction_pb.LtcTx = void 0;
const protobuf_1$3 = cjs$1, btc_transaction_pb_1 = btc_transaction_pb;
class LtcTx extends protobuf_1$3.Message {
  constructor(c) {
    super(), this.fee = protobuf_1$3.protoInt64.zero, this.dustThreshold = 0, this.memo = "", this.inputs = [], this.outputs = [], protobuf_1$3.proto3.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new LtcTx().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new LtcTx().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new LtcTx().fromJsonString(c, u);
  }
  static equals(c, u) {
    return protobuf_1$3.proto3.util.equals(LtcTx, c, u);
  }
}
LtcTx.runtime = protobuf_1$3.proto3;
LtcTx.typeName = "protoc.LtcTx";
LtcTx.fields = protobuf_1$3.proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "fee",
    kind: "scalar",
    T: 3
    /* ScalarType.INT64 */
  },
  {
    no: 2,
    name: "dustThreshold",
    kind: "scalar",
    T: 5
    /* ScalarType.INT32 */
  },
  {
    no: 3,
    name: "memo",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  { no: 4, name: "inputs", kind: "message", T: btc_transaction_pb_1.Input, repeated: !0 },
  { no: 5, name: "outputs", kind: "message", T: btc_transaction_pb_1.Output, repeated: !0 }
]);
ltc_transaction_pb.LtcTx = LtcTx;
Object.defineProperty(transaction_pb, "__esModule", { value: !0 });
transaction_pb.SignTransaction = void 0;
const protobuf_1$2 = cjs$1, tron_transaction_pb_1 = tron_transaction_pb, bch_transaction_pb_1 = bch_transaction_pb, dash_transaction_pb_1 = dash_transaction_pb, ltc_transaction_pb_1 = ltc_transaction_pb;
class SignTransaction extends protobuf_1$2.Message {
  constructor(c) {
    super(), this.coinCode = "", this.signId = "", this.hdPath = "", this.timestamp = protobuf_1$2.protoInt64.zero, this.decimal = 0, this.Transaction = { case: void 0 }, protobuf_1$2.proto3.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new SignTransaction().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new SignTransaction().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new SignTransaction().fromJsonString(c, u);
  }
  static equals(c, u) {
    return protobuf_1$2.proto3.util.equals(SignTransaction, c, u);
  }
}
SignTransaction.runtime = protobuf_1$2.proto3;
SignTransaction.typeName = "protoc.SignTransaction";
SignTransaction.fields = protobuf_1$2.proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "coinCode",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 2,
    name: "signId",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 3,
    name: "hdPath",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 4,
    name: "timestamp",
    kind: "scalar",
    T: 3
    /* ScalarType.INT64 */
  },
  {
    no: 5,
    name: "decimal",
    kind: "scalar",
    T: 5
    /* ScalarType.INT32 */
  },
  { no: 8, name: "tronTx", kind: "message", T: tron_transaction_pb_1.TronTx, oneof: "Transaction" },
  { no: 10, name: "bchTx", kind: "message", T: bch_transaction_pb_1.BchTx, oneof: "Transaction" },
  { no: 11, name: "dashTx", kind: "message", T: dash_transaction_pb_1.DashTx, oneof: "Transaction" },
  { no: 12, name: "ltcTx", kind: "message", T: ltc_transaction_pb_1.LtcTx, oneof: "Transaction" }
]);
transaction_pb.SignTransaction = SignTransaction;
var sign_transaction_result_pb = {};
Object.defineProperty(sign_transaction_result_pb, "__esModule", { value: !0 });
sign_transaction_result_pb.SignTransactionResult = void 0;
const protobuf_1$1 = cjs$1;
class SignTransactionResult extends protobuf_1$1.Message {
  constructor(c) {
    super(), this.signId = "", this.txId = "", this.rawTx = "", protobuf_1$1.proto3.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new SignTransactionResult().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new SignTransactionResult().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new SignTransactionResult().fromJsonString(c, u);
  }
  static equals(c, u) {
    return protobuf_1$1.proto3.util.equals(SignTransactionResult, c, u);
  }
}
SignTransactionResult.runtime = protobuf_1$1.proto3;
SignTransactionResult.typeName = "protoc.SignTransactionResult";
SignTransactionResult.fields = protobuf_1$1.proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "signId",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 2,
    name: "txId",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 3,
    name: "rawTx",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  }
]);
sign_transaction_result_pb.SignTransactionResult = SignTransactionResult;
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.Payload_Type = n.Payload = void 0;
  const c = cjs$1, u = transaction_pb, p = sign_transaction_result_pb;
  class a extends c.Message {
    constructor(F) {
      super(), this.type = A.RESERVE, this.xfp = "", this.Content = { case: void 0 }, c.proto3.util.initPartial(F, this);
    }
    static fromBinary(F, le) {
      return new a().fromBinary(F, le);
    }
    static fromJson(F, le) {
      return new a().fromJson(F, le);
    }
    static fromJsonString(F, le) {
      return new a().fromJsonString(F, le);
    }
    static equals(F, le) {
      return c.proto3.util.equals(a, F, le);
    }
  }
  a.runtime = c.proto3, a.typeName = "protoc.Payload", a.fields = c.proto3.util.newFieldList(() => [
    { no: 1, name: "type", kind: "enum", T: c.proto3.getEnumType(A) },
    {
      no: 2,
      name: "xfp",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 4, name: "signTx", kind: "message", T: u.SignTransaction, oneof: "Content" },
    { no: 7, name: "signTxResult", kind: "message", T: p.SignTransactionResult, oneof: "Content" }
  ]), n.Payload = a;
  var A;
  (function(b) {
    b[b.RESERVE = 0] = "RESERVE", b[b.SYNC = 1] = "SYNC", b[b.SIGN_TX = 2] = "SIGN_TX", b[b.SIGN_MSG = 3] = "SIGN_MSG", b[b.SIGN_MULTI_SIG = 4] = "SIGN_MULTI_SIG", b[b.SYNC_MULTI_SIG_MSG = 5] = "SYNC_MULTI_SIG_MSG", b[b.SIGN_ETH_MULTI_SIG_MSG = 6] = "SIGN_ETH_MULTI_SIG_MSG", b[b.VERIFY_ADDRESS = 7] = "VERIFY_ADDRESS", b[b.STAKING = 8] = "STAKING", b[b.SIGN_TX_RESULT = 9] = "SIGN_TX_RESULT";
  })(A = n.Payload_Type || (n.Payload_Type = {})), c.proto3.util.setEnumType(A, "protoc.Payload.Type", [
    { no: 0, name: "TYPE_RESERVE" },
    { no: 1, name: "TYPE_SYNC" },
    { no: 2, name: "TYPE_SIGN_TX" },
    { no: 3, name: "TYPE_SIGN_MSG" },
    { no: 4, name: "TYPE_SIGN_MULTI_SIG" },
    { no: 5, name: "TYPE_SYNC_MULTI_SIG_MSG" },
    { no: 6, name: "TYPE_SIGN_ETH_MULTI_SIG_MSG" },
    { no: 7, name: "TYPE_VERIFY_ADDRESS" },
    { no: 8, name: "TYPE_STAKING" },
    { no: 9, name: "TYPE_SIGN_TX_RESULT" }
  ]);
})(payload_pb);
Object.defineProperty(base_pb, "__esModule", { value: !0 });
base_pb.Base = void 0;
const protobuf_1 = cjs$1, payload_pb_1$1 = payload_pb;
class Base extends protobuf_1.Message {
  constructor(c) {
    super(), this.version = 0, this.description = "", this.Content = { case: void 0 }, this.deviceType = "", protobuf_1.proto3.util.initPartial(c, this);
  }
  static fromBinary(c, u) {
    return new Base().fromBinary(c, u);
  }
  static fromJson(c, u) {
    return new Base().fromJson(c, u);
  }
  static fromJsonString(c, u) {
    return new Base().fromJsonString(c, u);
  }
  static equals(c, u) {
    return protobuf_1.proto3.util.equals(Base, c, u);
  }
}
Base.runtime = protobuf_1.proto3;
Base.typeName = "protoc.Base";
Base.fields = protobuf_1.proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "version",
    kind: "scalar",
    T: 5
    /* ScalarType.INT32 */
  },
  {
    no: 2,
    name: "description",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  { no: 3, name: "data", kind: "message", T: payload_pb_1$1.Payload },
  { no: 4, name: "hotVersion", kind: "scalar", T: 5, oneof: "Content" },
  { no: 5, name: "coldVersion", kind: "scalar", T: 5, oneof: "Content" },
  {
    no: 6,
    name: "deviceType",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  }
]);
base_pb.Base = Base;
var dist$j = { exports: {} }, bcUrRegistryKeystone_cjs_production_min = {}, dist$i = {}, patchCBOR$7 = {}, utils$c = {}, lib$9 = {}, cborSync$7 = { exports: {} }, DataItem$7 = {}, hasRequiredDataItem$7;
function requireDataItem$7() {
  if (hasRequiredDataItem$7) return DataItem$7;
  hasRequiredDataItem$7 = 1, Object.defineProperty(DataItem$7, "__esModule", { value: !0 }), DataItem$7.DataItem = void 0;
  class n {
    constructor(u, p) {
      this.setTag = (a) => {
        this.tag = a;
      }, this.clearTag = () => {
        this.tag = void 0;
      }, this.getTag = () => this.tag, this.getData = () => this.data, this.data = u, this.tag = p;
    }
  }
  return DataItem$7.DataItem = n, DataItem$7;
}
var hasRequiredCborSync$7;
function requireCborSync$7() {
  return hasRequiredCborSync$7 || (hasRequiredCborSync$7 = 1, function(n) {
    (function(c, u) {
      n.exports ? n.exports = u() : c.CBOR = u();
    })(commonjsGlobal, function() {
      const { DataItem: c } = requireDataItem$7();
      var u = function() {
        function p(Ce) {
          this.$hex = Ce;
        }
        p.prototype = {
          length: function() {
            return this.$hex.length / 2;
          },
          toString: function(Ce) {
            if (!Ce || Ce === "hex" || Ce === 16)
              return this.$hex;
            if (Ce === "utf-8") {
              for (var tr = "", Fe = 0; Fe < this.$hex.length; Fe += 2)
                tr += "%" + this.$hex.substring(Fe, Fe + 2);
              return decodeURIComponent(tr);
            }
            if (Ce === "latin") {
              for (var tr = [], Fe = 0; Fe < this.$hex.length; Fe += 2)
                tr.push(parseInt(this.$hex.substring(Fe, Fe + 2), 16));
              return String.fromCharCode.apply(String, tr);
            }
            throw new Error("Unrecognised format: " + Ce);
          }
        }, p.fromLatinString = function(Ce) {
          for (var tr = "", Fe = 0; Fe < Ce.length; Fe++) {
            var Sr = Ce.charCodeAt(Fe).toString(16);
            Sr.length === 1 && (Sr = "0" + Sr), tr += Sr;
          }
          return new p(tr);
        }, p.fromUtf8String = function(Ce) {
          for (var tr = encodeURIComponent(Ce), Fe = "", Sr = 0; Sr < tr.length; Sr++)
            if (tr.charAt(Sr) === "%")
              Fe += tr.substring(Sr + 1, Sr + 3), Sr += 2;
            else {
              var er = tr.charCodeAt(Sr).toString(16);
              er.length < 2 && (er = "0" + er), Fe += er;
            }
          return new p(Fe);
        };
        var a = [], A = {}, b = function(Ce) {
          return function() {
            throw new Error(Ce + " not implemented");
          };
        };
        function F() {
        }
        F.prototype = {
          peekByte: b("peekByte"),
          readByte: b("readByte"),
          readChunk: b("readChunk"),
          readFloat16: function() {
            var Ce = this.readUint16(), tr = (Ce & 32767) >> 10, Fe = Ce & 1023, Sr = Ce & 32768;
            if (tr === 31)
              return Fe === 0 ? Sr ? -1 / 0 : 1 / 0 : NaN;
            var er = tr ? Math.pow(2, tr - 25) * (1024 + Fe) : Math.pow(2, -24) * Fe;
            return Sr ? -er : er;
          },
          readFloat32: function() {
            var Ce = this.readUint32(), tr = (Ce & 2147483647) >> 23, Fe = Ce & 8388607, Sr = Ce & 2147483648;
            if (tr === 255)
              return Fe === 0 ? Sr ? -1 / 0 : 1 / 0 : NaN;
            var er = tr ? Math.pow(2, tr - 23 - 127) * (8388608 + Fe) : Math.pow(2, -149) * Fe;
            return Sr ? -er : er;
          },
          readFloat64: function() {
            var Ce = this.readUint32(), tr = this.readUint32(), Fe = Ce >> 20 & 2047, Sr = (Ce & 1048575) * 4294967296 + tr, er = Ce & 2147483648;
            if (Fe === 2047)
              return Sr === 0 ? er ? -1 / 0 : 1 / 0 : NaN;
            var Ie = Fe ? Math.pow(2, Fe - 52 - 1023) * (4503599627370496 + Sr) : Math.pow(2, -1074) * Sr;
            return er ? -Ie : Ie;
          },
          readUint16: function() {
            return this.readByte() * 256 + this.readByte();
          },
          readUint32: function() {
            return this.readUint16() * 65536 + this.readUint16();
          },
          readUint64: function() {
            return this.readUint32() * 4294967296 + this.readUint32();
          }
        };
        function le() {
        }
        le.prototype = {
          writeByte: b("writeByte"),
          result: b("result"),
          writeFloat16: b("writeFloat16"),
          writeFloat32: b("writeFloat32"),
          writeFloat64: b("writeFloat64"),
          writeUint16: function(Ce) {
            this.writeByte(Ce >> 8 & 255), this.writeByte(Ce & 255);
          },
          writeUint32: function(Ce) {
            this.writeUint16(Ce >> 16 & 65535), this.writeUint16(Ce & 65535);
          },
          writeUint64: function(Ce) {
            if (Ce >= 9007199254740992 || Ce <= -9007199254740992)
              throw new Error("Cannot encode Uint64 of: " + Ce + " magnitude to big (floating point errors)");
            this.writeUint32(Math.floor(Ce / 4294967296)), this.writeUint32(Ce % 4294967296);
          },
          writeString: b("writeString"),
          canWriteBinary: function(Ce) {
            return !1;
          },
          writeBinary: b("writeChunk")
        };
        function L(Ce) {
          var tr = Ce.readByte(), Fe = tr >> 5, Sr = tr & 31;
          return { type: Fe, value: Sr };
        }
        function pe(Ce, tr) {
          var Fe = Ce.value;
          if (Fe < 24)
            return Fe;
          if (Fe == 24)
            return tr.readByte();
          if (Fe == 25)
            return tr.readUint16();
          if (Fe == 26)
            return tr.readUint32();
          if (Fe == 27)
            return tr.readUint64();
          if (Fe == 31)
            return null;
          b("Additional info: " + Fe)();
        }
        function $(Ce, tr, Fe) {
          Fe.writeByte(Ce << 5 | tr);
        }
        function Ee(Ce, tr, Fe) {
          var Sr = Ce << 5;
          tr < 24 ? Fe.writeByte(Sr | tr) : tr < 256 ? (Fe.writeByte(Sr | 24), Fe.writeByte(tr)) : tr < 65536 ? (Fe.writeByte(Sr | 25), Fe.writeUint16(tr)) : tr < 4294967296 ? (Fe.writeByte(Sr | 26), Fe.writeUint32(tr)) : (Fe.writeByte(Sr | 27), Fe.writeUint64(tr));
        }
        var be = new Error();
        function He(Ce) {
          var tr = L(Ce);
          switch (tr.type) {
            case 0:
              return pe(tr, Ce);
            case 1:
              return -1 - pe(tr, Ce);
            case 2:
              return Ce.readChunk(pe(tr, Ce));
            case 3:
              var Fe = Ce.readChunk(pe(tr, Ce));
              return Fe.toString("utf-8");
            case 4:
            case 5:
              var Sr = pe(tr, Ce), yr = [];
              if (Sr !== null) {
                tr.type === 5 && (Sr *= 2);
                for (var er = 0; er < Sr; er++)
                  yr[er] = He(Ce);
              } else
                for (var Ie; (Ie = He(Ce)) !== be; )
                  yr.push(Ie);
              if (tr.type === 5) {
                for (var xe = {}, er = 0; er < yr.length; er += 2)
                  xe[yr[er]] = yr[er + 1];
                return xe;
              } else
                return yr;
            case 6:
              var rr = pe(tr, Ce), ar = A[rr], yr = He(Ce);
              return ar ? ar(yr) : yr;
            case 7:
              if (tr.value === 25)
                return Ce.readFloat16();
              if (tr.value === 26)
                return Ce.readFloat32();
              if (tr.value === 27)
                return Ce.readFloat64();
              switch (pe(tr, Ce)) {
                case 20:
                  return !1;
                case 21:
                  return !0;
                case 22:
                  return null;
                case 23:
                  return;
                case null:
                  return be;
                default:
                  throw new Error("Unknown fixed value: " + tr.value);
              }
            default:
              throw new Error("Unsupported header: " + JSON.stringify(tr));
          }
          throw new Error("not implemented yet");
        }
        function Pe(Ce, tr) {
          for (var Fe = 0; Fe < a.length; Fe++) {
            var Sr = a[Fe].fn(Ce);
            if (Sr !== void 0)
              return Ee(6, a[Fe].tag, tr), Pe(Sr, tr);
          }
          if (Ce && typeof Ce.toCBOR == "function" && (Ce = Ce.toCBOR()), Ce === !1)
            Ee(7, 20, tr);
          else if (Ce === !0)
            Ee(7, 21, tr);
          else if (Ce === null)
            Ee(7, 22, tr);
          else if (Ce === void 0)
            Ee(7, 23, tr);
          else if (typeof Ce == "number")
            Math.floor(Ce) === Ce && Ce < 9007199254740992 && Ce > -9007199254740992 ? Ce < 0 ? Ee(1, -1 - Ce, tr) : Ee(0, Ce, tr) : ($(7, 27, tr), tr.writeFloat64(Ce));
          else if (typeof Ce == "string")
            tr.writeString(Ce, function(Ie) {
              Ee(3, Ie, tr);
            });
          else if (tr.canWriteBinary(Ce))
            tr.writeBinary(Ce, function(Ie) {
              Ee(2, Ie, tr);
            });
          else if (typeof Ce == "object")
            if (or.config.useToJSON && typeof Ce.toJSON == "function" && (Ce = Ce.toJSON()), Array.isArray(Ce)) {
              Ee(4, Ce.length, tr);
              for (var Fe = 0; Fe < Ce.length; Fe++)
                Pe(Ce[Fe], tr);
            } else {
              var er = Object.keys(Ce);
              Ee(5, er.length, tr);
              for (var Fe = 0; Fe < er.length; Fe++) {
                const xe = parseInt(er[Fe]);
                isNaN(xe) ? (Pe(er[Fe], tr), Pe(Ce[er[Fe]], tr)) : (Pe(xe, tr), Pe(Ce[er[Fe]], tr));
              }
            }
          else
            throw new Error("CBOR encoding not supported: " + Ce);
        }
        var nr = [], ir = [], or = {
          config: {
            useToJSON: !0
          },
          addWriter: function(Ce, tr) {
            typeof Ce == "string" ? ir.push(function(Fe) {
              if (Ce === Fe)
                return tr(Fe);
            }) : ir.push(Ce);
          },
          addReader: function(Ce, tr) {
            typeof Ce == "string" ? nr.push(function(Fe, Sr) {
              if (Ce === Sr)
                return tr(Fe, Sr);
            }) : nr.push(Ce);
          },
          encode: function(Ce, tr) {
            for (var Fe = 0; Fe < ir.length; Fe++) {
              var Sr = ir[Fe], er = Sr(tr);
              if (er)
                return Pe(Ce, er), er.result();
            }
            throw new Error("Unsupported output format: " + tr);
          },
          encodeDataItem: function(Ce, tr) {
            for (var Fe = 0; Fe < ir.length; Fe++) {
              var Sr = ir[Fe], er = Sr(tr);
              if (er)
                return Ce.getTag() !== void 0 ? (Pe(Ce, er), er.result()) : (Pe(Ce.getData(), er), er.result());
            }
            throw new Error("Unsupported output format: " + tr);
          },
          decode: function(Ce, tr) {
            for (var Fe = 0; Fe < nr.length; Fe++) {
              var Sr = nr[Fe], er = Sr(Ce, tr);
              if (er)
                return He(er);
            }
            throw new Error("Unsupported input format: " + tr);
          },
          decodeToDataItem: function(Ce, tr) {
            for (var Fe = 0; Fe < nr.length; Fe++) {
              var Sr = nr[Fe], er = Sr(Ce, tr);
              if (er) {
                const Ie = He(er);
                return Ie instanceof c ? Ie : new c(Ie);
              }
            }
            throw new Error("Unsupported input format: " + tr);
          },
          addSemanticEncode: function(Ce, tr) {
            if (typeof Ce != "number" || Ce % 1 !== 0 || Ce < 0)
              throw new Error("Tag must be a positive integer");
            return a.push({ tag: Ce, fn: tr }), this;
          },
          addSemanticDecode: function(Ce, tr) {
            if (typeof Ce != "number" || Ce % 1 !== 0 || Ce < 0)
              throw new Error("Tag must be a positive integer");
            return A[Ce] = tr, this;
          }
        };
        function lr(Ce) {
          this.buffer = Ce, this.pos = 0;
        }
        lr.prototype = Object.create(F.prototype), lr.prototype.peekByte = function() {
          return this.buffer[this.pos];
        }, lr.prototype.readByte = function() {
          return this.buffer[this.pos++];
        }, lr.prototype.readUint16 = function() {
          var Ce = this.buffer.readUInt16BE(this.pos);
          return this.pos += 2, Ce;
        }, lr.prototype.readUint32 = function() {
          var Ce = this.buffer.readUInt32BE(this.pos);
          return this.pos += 4, Ce;
        }, lr.prototype.readFloat32 = function() {
          var Ce = this.buffer.readFloatBE(this.pos);
          return this.pos += 4, Ce;
        }, lr.prototype.readFloat64 = function() {
          var Ce = this.buffer.readDoubleBE(this.pos);
          return this.pos += 8, Ce;
        }, lr.prototype.readChunk = function(Ce) {
          var tr = Buffer$f.alloc(Ce);
          return this.buffer.copy(tr, 0, this.pos, this.pos += Ce), tr;
        };
        function Ir(Ce) {
          this.byteLength = 0, this.defaultBufferLength = 16384, this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0, this.completeBuffers = [], this.stringFormat = Ce;
        }
        Ir.prototype = Object.create(le.prototype), Ir.prototype.writeByte = function(Ce) {
          this.latestBuffer[this.latestBufferOffset++] = Ce, this.latestBufferOffset >= this.latestBuffer.length && (this.completeBuffers.push(this.latestBuffer), this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0), this.byteLength++;
        }, Ir.prototype.writeFloat32 = function(Ce) {
          var tr = Buffer$f.alloc(4);
          tr.writeFloatBE(Ce, 0), this.writeBuffer(tr);
        }, Ir.prototype.writeFloat64 = function(Ce) {
          var tr = Buffer$f.alloc(8);
          tr.writeDoubleBE(Ce, 0), this.writeBuffer(tr);
        }, Ir.prototype.writeString = function(Ce, tr) {
          var Fe = Buffer$f.from(Ce, "utf-8");
          tr(Fe.length), this.writeBuffer(Fe);
        }, Ir.prototype.canWriteBinary = function(Ce) {
          return Ce instanceof Buffer$f;
        }, Ir.prototype.writeBinary = function(Ce, tr) {
          tr(Ce.length), this.writeBuffer(Ce);
        }, Ir.prototype.writeBuffer = function(Ce) {
          if (!(Ce instanceof Buffer$f))
            throw new TypeError("BufferWriter only accepts Buffers");
          this.latestBufferOffset ? this.latestBuffer.length - this.latestBufferOffset >= Ce.length ? (Ce.copy(this.latestBuffer, this.latestBufferOffset), this.latestBufferOffset += Ce.length, this.latestBufferOffset >= this.latestBuffer.length && (this.completeBuffers.push(this.latestBuffer), this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0)) : (this.completeBuffers.push(this.latestBuffer.slice(0, this.latestBufferOffset)), this.completeBuffers.push(Ce), this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0) : this.completeBuffers.push(Ce), this.byteLength += Ce.length;
        }, Ir.prototype.result = function() {
          for (var Ce = Buffer$f.alloc(this.byteLength), tr = 0, Fe = 0; Fe < this.completeBuffers.length; Fe++) {
            var Sr = this.completeBuffers[Fe];
            Sr.copy(Ce, tr, 0, Sr.length), tr += Sr.length;
          }
          return this.latestBufferOffset && this.latestBuffer.copy(Ce, tr, 0, this.latestBufferOffset), this.stringFormat ? Ce.toString(this.stringFormat) : Ce;
        }, typeof Buffer$f == "function" && (or.addReader(function(Ce, tr) {
          if (Buffer$f.isBuffer(Ce))
            return new lr(Ce);
          if (tr === "hex" || tr === "base64") {
            var Fe = Buffer$f.from(Ce, tr);
            return new lr(Fe);
          }
        }), or.addWriter(function(Ce) {
          if (!Ce || Ce === "buffer")
            return new Ir();
          if (Ce === "hex" || Ce === "base64")
            return new Ir(Ce);
        }));
        function xr(Ce) {
          this.hex = Ce, this.pos = 0;
        }
        xr.prototype = Object.create(F.prototype), xr.prototype.peekByte = function() {
          var Ce = this.hex.substring(this.pos, 2);
          return parseInt(Ce, 16);
        }, xr.prototype.readByte = function() {
          var Ce = this.hex.substring(this.pos, this.pos + 2);
          return this.pos += 2, parseInt(Ce, 16);
        }, xr.prototype.readChunk = function(Ce) {
          var tr = this.hex.substring(this.pos, this.pos + Ce * 2);
          return this.pos += Ce * 2, typeof Buffer$f == "function" ? Buffer$f.from(tr, "hex") : new p(tr);
        };
        function kr(Ce) {
          this.$hex = "", this.finalFormat = Ce || "hex";
        }
        return kr.prototype = Object.create(le.prototype), kr.prototype.writeByte = function(Ce) {
          if (Ce < 0 || Ce > 255)
            throw new Error("Byte value out of range: " + Ce);
          var tr = Ce.toString(16);
          tr.length == 1 && (tr = "0" + tr), this.$hex += tr;
        }, kr.prototype.canWriteBinary = function(Ce) {
          return Ce instanceof p || typeof Buffer$f == "function" && Ce instanceof Buffer$f;
        }, kr.prototype.writeBinary = function(Ce, tr) {
          if (Ce instanceof p)
            tr(Ce.length()), this.$hex += Ce.$hex;
          else if (typeof Buffer$f == "function" && Ce instanceof Buffer$f)
            tr(Ce.length), this.$hex += Ce.toString("hex");
          else
            throw new TypeError("HexWriter only accepts BinaryHex or Buffers");
        }, kr.prototype.result = function() {
          return this.finalFormat === "buffer" && typeof Buffer$f == "function" ? Buffer$f.from(this.$hex, "hex") : new p(this.$hex).toString(this.finalFormat);
        }, kr.prototype.writeString = function(Ce, tr) {
          var Fe = p.fromUtf8String(Ce);
          tr(Fe.length()), this.$hex += Fe.$hex;
        }, or.addReader(function(Ce, tr) {
          if (Ce instanceof p || Ce.$hex)
            return new xr(Ce.$hex);
          if (tr === "hex")
            return new xr(Ce);
        }), or.addWriter(function(Ce) {
          if (Ce === "hex")
            return new kr();
        }), or;
      }();
      return u.addSemanticEncode(0, function(p) {
        if (p instanceof Date)
          return p.toISOString();
      }).addSemanticDecode(0, function(p) {
        return new Date(p);
      }).addSemanticDecode(1, function(p) {
        return new Date(p);
      }), u;
    });
  }(cborSync$7)), cborSync$7.exports;
}
var hasRequiredLib$7;
function requireLib$7() {
  return hasRequiredLib$7 || (hasRequiredLib$7 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.DataItem = n.addWriter = n.addReader = n.addSemanticEncode = n.addSemanticDecode = n.decodeToDataItem = n.encodeDataItem = void 0;
    var c = requireCborSync$7();
    Object.defineProperty(n, "encodeDataItem", { enumerable: !0, get: function() {
      return c.encodeDataItem;
    } }), Object.defineProperty(n, "decodeToDataItem", { enumerable: !0, get: function() {
      return c.decodeToDataItem;
    } }), Object.defineProperty(n, "addSemanticDecode", { enumerable: !0, get: function() {
      return c.addSemanticDecode;
    } }), Object.defineProperty(n, "addSemanticEncode", { enumerable: !0, get: function() {
      return c.addSemanticEncode;
    } }), Object.defineProperty(n, "addReader", { enumerable: !0, get: function() {
      return c.addReader;
    } }), Object.defineProperty(n, "addWriter", { enumerable: !0, get: function() {
      return c.addWriter;
    } });
    var u = requireDataItem$7();
    Object.defineProperty(n, "DataItem", { enumerable: !0, get: function() {
      return u.DataItem;
    } });
  }(lib$9)), lib$9;
}
var hasRequiredUtils$7;
function requireUtils$7() {
  if (hasRequiredUtils$7) return utils$c;
  hasRequiredUtils$7 = 1, Object.defineProperty(utils$c, "__esModule", { value: !0 }), utils$c.patchTags = void 0;
  const n = requireLib$7(), c = [], u = (p) => {
    p.forEach((a) => {
      c.find((A) => A === a) || ((0, n.addSemanticEncode)(a, (A) => {
        if (A instanceof n.DataItem && A.getTag() === a)
          return A.getData();
      }), (0, n.addSemanticDecode)(a, (A) => new n.DataItem(A, a)), c.push(a));
    });
  };
  return utils$c.patchTags = u, utils$c;
}
var RegistryType$7 = {}, hasRequiredRegistryType$7;
function requireRegistryType$7() {
  if (hasRequiredRegistryType$7) return RegistryType$7;
  hasRequiredRegistryType$7 = 1, Object.defineProperty(RegistryType$7, "__esModule", { value: !0 }), RegistryType$7.RegistryTypes = RegistryType$7.RegistryType = void 0;
  class n {
    constructor(u, p) {
      this.type = u, this.tag = p, this.getTag = () => this.tag, this.getType = () => this.type;
    }
  }
  return RegistryType$7.RegistryType = n, RegistryType$7.RegistryTypes = {
    UUID: new n("uuid", 37),
    BYTES: new n("bytes", void 0),
    CRYPTO_HDKEY: new n("crypto-hdkey", 303),
    CRYPTO_KEYPATH: new n("crypto-keypath", 304),
    CRYPTO_COIN_INFO: new n("crypto-coin-info", 305),
    CRYPTO_ECKEY: new n("crypto-eckey", 306),
    CRYPTO_OUTPUT: new n("crypto-output", 308),
    CRYPTO_PSBT: new n("crypto-psbt", 310),
    CRYPTO_ACCOUNT: new n("crypto-account", 311),
    CRYPTO_MULTI_ACCOUNTS: new n("crypto-multi-accounts", 1103),
    QR_HARDWARE_CALL: new n("qr-hardware-call", 1201),
    KEY_DERIVATION_CALL: new n("key-derivation-call", 1301),
    KEY_DERIVATION_SCHEMA: new n("key-derivation-schema", 1302)
  }, RegistryType$7;
}
var ScriptExpression$7 = {}, hasRequiredScriptExpression$7;
function requireScriptExpression$7() {
  return hasRequiredScriptExpression$7 || (hasRequiredScriptExpression$7 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.ScriptExpressions = n.ScriptExpression = void 0;
    class c {
      constructor(p, a) {
        this.tag = p, this.expression = a, this.getTag = () => this.tag, this.getExpression = () => this.expression;
      }
    }
    n.ScriptExpression = c, c.fromTag = (u) => Object.values(n.ScriptExpressions).find((a) => a.getTag() === u), n.ScriptExpressions = {
      SCRIPT_HASH: new c(400, "sh"),
      WITNESS_SCRIPT_HASH: new c(401, "wsh"),
      PUBLIC_KEY: new c(402, "pk"),
      PUBLIC_KEY_HASH: new c(403, "pkh"),
      WITNESS_PUBLIC_KEY_HASH: new c(404, "wpkh"),
      COMBO: new c(405, "combo"),
      MULTISIG: new c(406, "multi"),
      SORTED_MULTISIG: new c(407, "sortedmulti"),
      ADDRESS: new c(307, "addr"),
      RAW_SCRIPT: new c(408, "raw")
    };
  }(ScriptExpression$7)), ScriptExpression$7;
}
var hasRequiredPatchCBOR$7;
function requirePatchCBOR$7() {
  if (hasRequiredPatchCBOR$7) return patchCBOR$7;
  hasRequiredPatchCBOR$7 = 1, Object.defineProperty(patchCBOR$7, "__esModule", { value: !0 });
  const n = requireUtils$7(), c = requireRegistryType$7(), u = requireScriptExpression$7(), p = Object.values(c.RegistryTypes).filter((A) => !!A.getTag()).map((A) => A.getTag()), a = Object.values(u.ScriptExpressions).map((A) => A.getTag());
  return (0, n.patchTags)(p.concat(a)), patchCBOR$7;
}
var CryptoHDKey$7 = {}, src$b, hasRequiredSrc$7;
function requireSrc$7() {
  if (hasRequiredSrc$7) return src$b;
  hasRequiredSrc$7 = 1;
  var n = safeBufferExports.Buffer;
  function c(u) {
    if (u.length >= 255)
      throw new TypeError("Alphabet too long");
    for (var p = new Uint8Array(256), a = 0; a < p.length; a++)
      p[a] = 255;
    for (var A = 0; A < u.length; A++) {
      var b = u.charAt(A), F = b.charCodeAt(0);
      if (p[F] !== 255)
        throw new TypeError(b + " is ambiguous");
      p[F] = A;
    }
    var le = u.length, L = u.charAt(0), pe = Math.log(le) / Math.log(256), $ = Math.log(256) / Math.log(le);
    function Ee(Pe) {
      if ((Array.isArray(Pe) || Pe instanceof Uint8Array) && (Pe = n.from(Pe)), !n.isBuffer(Pe))
        throw new TypeError("Expected Buffer");
      if (Pe.length === 0)
        return "";
      for (var nr = 0, ir = 0, or = 0, lr = Pe.length; or !== lr && Pe[or] === 0; )
        or++, nr++;
      for (var Ir = (lr - or) * $ + 1 >>> 0, xr = new Uint8Array(Ir); or !== lr; ) {
        for (var kr = Pe[or], Ce = 0, tr = Ir - 1; (kr !== 0 || Ce < ir) && tr !== -1; tr--, Ce++)
          kr += 256 * xr[tr] >>> 0, xr[tr] = kr % le >>> 0, kr = kr / le >>> 0;
        if (kr !== 0)
          throw new Error("Non-zero carry");
        ir = Ce, or++;
      }
      for (var Fe = Ir - ir; Fe !== Ir && xr[Fe] === 0; )
        Fe++;
      for (var Sr = L.repeat(nr); Fe < Ir; ++Fe)
        Sr += u.charAt(xr[Fe]);
      return Sr;
    }
    function be(Pe) {
      if (typeof Pe != "string")
        throw new TypeError("Expected String");
      if (Pe.length === 0)
        return n.alloc(0);
      for (var nr = 0, ir = 0, or = 0; Pe[nr] === L; )
        ir++, nr++;
      for (var lr = (Pe.length - nr) * pe + 1 >>> 0, Ir = new Uint8Array(lr); nr < Pe.length; ) {
        var xr = Pe.charCodeAt(nr);
        if (xr > 255)
          return;
        var kr = p[xr];
        if (kr === 255)
          return;
        for (var Ce = 0, tr = lr - 1; (kr !== 0 || Ce < or) && tr !== -1; tr--, Ce++)
          kr += le * Ir[tr] >>> 0, Ir[tr] = kr % 256 >>> 0, kr = kr / 256 >>> 0;
        if (kr !== 0)
          throw new Error("Non-zero carry");
        or = Ce, nr++;
      }
      for (var Fe = lr - or; Fe !== lr && Ir[Fe] === 0; )
        Fe++;
      var Sr = n.allocUnsafe(ir + (lr - Fe));
      Sr.fill(0, 0, ir);
      for (var er = ir; Fe !== lr; )
        Sr[er++] = Ir[Fe++];
      return Sr;
    }
    function He(Pe) {
      var nr = be(Pe);
      if (nr)
        return nr;
      throw new Error("Non-base" + le + " character");
    }
    return {
      encode: Ee,
      decodeUnsafe: be,
      decode: He
    };
  }
  return src$b = c, src$b;
}
var bs58$8, hasRequiredBs58$7;
function requireBs58$7() {
  if (hasRequiredBs58$7) return bs58$8;
  hasRequiredBs58$7 = 1;
  var n = requireSrc$7(), c = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
  return bs58$8 = n(c), bs58$8;
}
var base$a, hasRequiredBase$7;
function requireBase$7() {
  if (hasRequiredBase$7) return base$a;
  hasRequiredBase$7 = 1;
  var n = requireBs58$7(), c = safeBufferExports.Buffer;
  return base$a = function(u) {
    function p(F) {
      var le = u(F);
      return n.encode(c.concat([
        F,
        le
      ], F.length + 4));
    }
    function a(F) {
      var le = F.slice(0, -4), L = F.slice(-4), pe = u(le);
      if (!(L[0] ^ pe[0] | L[1] ^ pe[1] | L[2] ^ pe[2] | L[3] ^ pe[3]))
        return le;
    }
    function A(F) {
      var le = n.decodeUnsafe(F);
      if (le)
        return a(le);
    }
    function b(F) {
      var le = n.decode(F), L = a(le);
      if (!L) throw new Error("Invalid checksum");
      return L;
    }
    return {
      encode: p,
      decode: b,
      decodeUnsafe: A
    };
  }, base$a;
}
var bs58check$a, hasRequiredBs58check$7;
function requireBs58check$7() {
  if (hasRequiredBs58check$7) return bs58check$a;
  hasRequiredBs58check$7 = 1;
  var n = browser$a, c = requireBase$7();
  function u(p) {
    var a = n("sha256").update(p).digest();
    return n("sha256").update(a).digest();
  }
  return bs58check$a = c(u), bs58check$a;
}
var CryptoCoinInfo$7 = {}, RegistryItem$7 = {}, hasRequiredRegistryItem$7;
function requireRegistryItem$7() {
  if (hasRequiredRegistryItem$7) return RegistryItem$7;
  hasRequiredRegistryItem$7 = 1, Object.defineProperty(RegistryItem$7, "__esModule", { value: !0 }), RegistryItem$7.RegistryItem = void 0;
  const n = dist$t, c = requireLib$7();
  class u {
    constructor() {
      this.toCBOR = () => {
        if (this.toDataItem() === void 0)
          throw new Error(`#[ur-registry][RegistryItem][fn.toCBOR]: registry ${this.getRegistryType()}'s method toDataItem returns undefined`);
        return (0, c.encodeDataItem)(this.toDataItem());
      }, this.toUR = () => new n.UR(this.toCBOR(), this.getRegistryType().getType()), this.toUREncoder = (a, A, b) => {
        const F = this.toUR();
        return new n.UREncoder(F, a, A, b);
      };
    }
  }
  return RegistryItem$7.RegistryItem = u, RegistryItem$7;
}
var hasRequiredCryptoCoinInfo$7;
function requireCryptoCoinInfo$7() {
  return hasRequiredCryptoCoinInfo$7 || (hasRequiredCryptoCoinInfo$7 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.CryptoCoinInfo = n.Network = n.Type = void 0;
    const c = requireLib$7(), u = requireRegistryItem$7(), p = requireRegistryType$7();
    var a;
    (function(le) {
      le.type = "1", le.network = "2";
    })(a || (a = {}));
    var A;
    (function(le) {
      le[le.bitcoin = 0] = "bitcoin";
    })(A = n.Type || (n.Type = {}));
    var b;
    (function(le) {
      le[le.mainnet = 0] = "mainnet", le[le.testnet = 1] = "testnet";
    })(b = n.Network || (n.Network = {}));
    class F extends u.RegistryItem {
      constructor(L, pe) {
        super(), this.type = L, this.network = pe, this.getRegistryType = () => p.RegistryTypes.CRYPTO_COIN_INFO, this.getType = () => this.type || A.bitcoin, this.getNetwork = () => this.network || b.mainnet, this.toDataItem = () => {
          const $ = {};
          return this.type && ($[a.type] = this.type), this.network && ($[a.network] = this.network), new c.DataItem($);
        };
      }
    }
    n.CryptoCoinInfo = F, F.fromDataItem = (le) => {
      const L = le.getData(), pe = L[a.type], $ = L[a.network];
      return new F(pe, $);
    }, F.fromCBOR = (le) => {
      const L = (0, c.decodeToDataItem)(le);
      return F.fromDataItem(L);
    };
  }(CryptoCoinInfo$7)), CryptoCoinInfo$7;
}
var CryptoKeypath$7 = {}, PathComponent$7 = {}, hasRequiredPathComponent$7;
function requirePathComponent$7() {
  if (hasRequiredPathComponent$7) return PathComponent$7;
  hasRequiredPathComponent$7 = 1, Object.defineProperty(PathComponent$7, "__esModule", { value: !0 }), PathComponent$7.PathComponent = void 0;
  class n {
    constructor(u) {
      if (this.getIndex = () => this.index, this.isWildcard = () => this.wildcard, this.isHardened = () => this.hardened, this.index = u.index, this.hardened = u.hardened, this.index !== void 0 ? this.wildcard = !1 : this.wildcard = !0, this.index && this.index & n.HARDENED_BIT)
        throw new Error(`#[ur-registry][PathComponent][fn.constructor]: Invalid index ${this.index} - most significant bit cannot be set`);
    }
  }
  return PathComponent$7.PathComponent = n, n.HARDENED_BIT = 2147483648, PathComponent$7;
}
var hasRequiredCryptoKeypath$7;
function requireCryptoKeypath$7() {
  if (hasRequiredCryptoKeypath$7) return CryptoKeypath$7;
  hasRequiredCryptoKeypath$7 = 1, Object.defineProperty(CryptoKeypath$7, "__esModule", { value: !0 }), CryptoKeypath$7.CryptoKeypath = void 0;
  const n = requireLib$7(), c = requirePathComponent$7(), u = requireRegistryItem$7(), p = requireRegistryType$7();
  var a;
  (function(b) {
    b[b.components = 1] = "components", b[b.source_fingerprint = 2] = "source_fingerprint", b[b.depth = 3] = "depth";
  })(a || (a = {}));
  class A extends u.RegistryItem {
    constructor(F = [], le, L) {
      super(), this.components = F, this.sourceFingerprint = le, this.depth = L, this.getRegistryType = () => p.RegistryTypes.CRYPTO_KEYPATH, this.getPath = () => this.components.length === 0 ? void 0 : this.components.map(($) => `${$.isWildcard() ? "*" : $.getIndex()}${$.isHardened() ? "'" : ""}`).join("/"), this.getComponents = () => this.components, this.getSourceFingerprint = () => this.sourceFingerprint, this.getDepth = () => this.depth, this.toDataItem = () => {
        const pe = {}, $ = [];
        return this.components && this.components.forEach((Ee) => {
          Ee.isWildcard() ? $.push([]) : $.push(Ee.getIndex()), $.push(Ee.isHardened());
        }), pe[a.components] = $, this.sourceFingerprint && (pe[a.source_fingerprint] = this.sourceFingerprint.readUInt32BE(0)), this.depth !== void 0 && (pe[a.depth] = this.depth), new n.DataItem(pe);
      };
    }
  }
  return CryptoKeypath$7.CryptoKeypath = A, A.fromDataItem = (b) => {
    const F = b.getData(), le = [], L = F[a.components];
    if (L)
      for (let be = 0; be < L.length; be += 2) {
        const He = L[be + 1], Pe = L[be];
        typeof Pe == "number" ? le.push(new c.PathComponent({ index: Pe, hardened: He })) : le.push(new c.PathComponent({ hardened: He }));
      }
    const pe = F[a.source_fingerprint];
    let $;
    pe && ($ = Buffer$f.alloc(4), $.writeUInt32BE(pe, 0));
    const Ee = F[a.depth];
    return new A(le, $, Ee);
  }, A.fromCBOR = (b) => {
    const F = (0, n.decodeToDataItem)(b);
    return A.fromDataItem(F);
  }, CryptoKeypath$7;
}
var hasRequiredCryptoHDKey$7;
function requireCryptoHDKey$7() {
  if (hasRequiredCryptoHDKey$7) return CryptoHDKey$7;
  hasRequiredCryptoHDKey$7 = 1, Object.defineProperty(CryptoHDKey$7, "__esModule", { value: !0 }), CryptoHDKey$7.CryptoHDKey = void 0;
  const n = requireBs58check$7(), c = requireCryptoCoinInfo$7(), u = requireCryptoKeypath$7(), p = requireLib$7(), a = requireRegistryItem$7(), A = requireRegistryType$7();
  var b;
  (function(le) {
    le[le.is_master = 1] = "is_master", le[le.is_private = 2] = "is_private", le[le.key_data = 3] = "key_data", le[le.chain_code = 4] = "chain_code", le[le.use_info = 5] = "use_info", le[le.origin = 6] = "origin", le[le.children = 7] = "children", le[le.parent_fingerprint = 8] = "parent_fingerprint", le[le.name = 9] = "name", le[le.note = 10] = "note";
  })(b || (b = {}));
  class F extends a.RegistryItem {
    constructor(L) {
      super(), this.isECKey = () => !1, this.getKey = () => this.key, this.getChainCode = () => this.chainCode, this.isMaster = () => this.master, this.isPrivateKey = () => !!this.privateKey, this.getUseInfo = () => this.useInfo, this.getOrigin = () => this.origin, this.getChildren = () => this.children, this.getParentFingerprint = () => this.parentFingerprint, this.getName = () => this.name, this.getNote = () => this.note, this.getBip32Key = () => {
        var pe, $, Ee;
        let be, He, Pe = 0, nr = Buffer$f.alloc(4).fill(0);
        if (this.isMaster())
          be = Buffer$f.from("0488ADE4", "hex"), He = 0, Pe = 0;
        else {
          He = ((pe = this.getOrigin()) === null || pe === void 0 ? void 0 : pe.getComponents().length) || (($ = this.getOrigin()) === null || $ === void 0 ? void 0 : $.getDepth());
          const xr = (Ee = this.getOrigin()) === null || Ee === void 0 ? void 0 : Ee.getComponents(), kr = xr[xr.length - 1];
          kr && (Pe = kr.isHardened() ? kr.getIndex() + 2147483648 : kr.getIndex(), this.getParentFingerprint() && (nr = this.getParentFingerprint())), this.isPrivateKey() ? be = Buffer$f.from("0488ADE4", "hex") : be = Buffer$f.from("0488B21E", "hex");
        }
        const ir = Buffer$f.alloc(1);
        ir.writeUInt8(He, 0);
        const or = Buffer$f.alloc(4);
        or.writeUInt32BE(Pe, 0);
        const lr = this.getChainCode(), Ir = this.getKey();
        return (0, n.encode)(Buffer$f.concat([be, ir, nr, or, lr, Ir]));
      }, this.getRegistryType = () => A.RegistryTypes.CRYPTO_HDKEY, this.getOutputDescriptorContent = () => {
        var pe, $, Ee, be, He, Pe, nr;
        let ir = "";
        return this.getOrigin() && !((pe = this.getOrigin()) === null || pe === void 0) && pe.getSourceFingerprint() && !(($ = this.getOrigin()) === null || $ === void 0) && $.getPath() && (ir += `${(be = (Ee = this.getOrigin()) === null || Ee === void 0 ? void 0 : Ee.getSourceFingerprint()) === null || be === void 0 ? void 0 : be.toString("hex")}/${(He = this.getOrigin()) === null || He === void 0 ? void 0 : He.getPath()}`), ir += this.getBip32Key(), this.getChildren() && !((Pe = this.getChildren()) === null || Pe === void 0) && Pe.getPath() && (ir += `/${(nr = this.getChildren()) === null || nr === void 0 ? void 0 : nr.getPath()}`), ir;
      }, this.setupMasterKey = (pe) => {
        this.master = !0, this.key = pe.key, this.chainCode = pe.chainCode;
      }, this.setupDeriveKey = (pe) => {
        this.master = !1, this.privateKey = pe.isPrivateKey, this.key = pe.key, this.chainCode = pe.chainCode, this.useInfo = pe.useInfo, this.origin = pe.origin, this.children = pe.children, this.parentFingerprint = pe.parentFingerprint, this.name = pe.name, this.note = pe.note;
      }, this.toDataItem = () => {
        const pe = {};
        if (this.master)
          pe[b.is_master] = !0, pe[b.key_data] = this.key, pe[b.chain_code] = this.chainCode;
        else {
          if (this.privateKey !== void 0 && (pe[b.is_private] = this.privateKey), pe[b.key_data] = this.key, this.chainCode && (pe[b.chain_code] = this.chainCode), this.useInfo) {
            const $ = this.useInfo.toDataItem();
            $.setTag(this.useInfo.getRegistryType().getTag()), pe[b.use_info] = $;
          }
          if (this.origin) {
            const $ = this.origin.toDataItem();
            $.setTag(this.origin.getRegistryType().getTag()), pe[b.origin] = $;
          }
          if (this.children) {
            const $ = this.children.toDataItem();
            $.setTag(this.children.getRegistryType().getTag()), pe[b.children] = $;
          }
          this.parentFingerprint && (pe[b.parent_fingerprint] = this.parentFingerprint.readUInt32BE(0)), this.name !== void 0 && (pe[b.name] = this.name), this.note !== void 0 && (pe[b.note] = this.note);
        }
        return new p.DataItem(pe);
      }, L.isMaster ? this.setupMasterKey(L) : this.setupDeriveKey(L);
    }
  }
  return CryptoHDKey$7.CryptoHDKey = F, F.fromDataItem = (le) => {
    const L = le.getData(), pe = !!L[b.is_master], $ = L[b.is_private], Ee = L[b.key_data], be = L[b.chain_code], He = L[b.use_info] ? c.CryptoCoinInfo.fromDataItem(L[b.use_info]) : void 0, Pe = L[b.origin] ? u.CryptoKeypath.fromDataItem(L[b.origin]) : void 0, nr = L[b.children] ? u.CryptoKeypath.fromDataItem(L[b.children]) : void 0, ir = L[b.parent_fingerprint];
    let or;
    ir && (or = Buffer$f.alloc(4), or.writeUInt32BE(ir, 0));
    const lr = L[b.name], Ir = L[b.note];
    return new F({
      isMaster: pe,
      isPrivateKey: $,
      key: Ee,
      chainCode: be,
      useInfo: He,
      origin: Pe,
      children: nr,
      parentFingerprint: or,
      name: lr,
      note: Ir
    });
  }, F.fromCBOR = (le) => {
    const L = (0, p.decodeToDataItem)(le);
    return F.fromDataItem(L);
  }, CryptoHDKey$7;
}
var CryptoECKey$7 = {}, hasRequiredCryptoECKey$7;
function requireCryptoECKey$7() {
  if (hasRequiredCryptoECKey$7) return CryptoECKey$7;
  hasRequiredCryptoECKey$7 = 1, Object.defineProperty(CryptoECKey$7, "__esModule", { value: !0 }), CryptoECKey$7.CryptoECKey = void 0;
  const n = requireLib$7(), c = requireRegistryItem$7(), u = requireRegistryType$7();
  var p;
  (function(A) {
    A[A.curve = 1] = "curve", A[A.private = 2] = "private", A[A.data = 3] = "data";
  })(p || (p = {}));
  class a extends c.RegistryItem {
    constructor(b) {
      super(), this.isECKey = () => !0, this.getCurve = () => this.curve || 0, this.isPrivateKey = () => this.privateKey || !1, this.getData = () => this.data, this.getRegistryType = () => u.RegistryTypes.CRYPTO_ECKEY, this.toDataItem = () => {
        const F = {};
        return this.curve && (F[p.curve] = this.curve), this.privateKey !== void 0 && (F[p.private] = this.privateKey), F[p.data] = this.data, new n.DataItem(F);
      }, this.getOutputDescriptorContent = () => this.data.toString("hex"), this.data = b.data, this.curve = b.curve, this.privateKey = b.privateKey || void 0;
    }
  }
  return CryptoECKey$7.CryptoECKey = a, a.fromDataItem = (A) => {
    const b = A.getData(), F = b[p.curve], le = b[p.private], L = b[p.data];
    if (!L)
      throw new Error(`#[ur-registry][CryptoECKey][fn.fromDataItem]: decoded [dataItem][#data.data] is undefined: ${A}`);
    return new a({ data: L, curve: F, privateKey: le });
  }, a.fromCBOR = (A) => {
    const b = (0, n.decodeToDataItem)(A);
    return a.fromDataItem(b);
  }, CryptoECKey$7;
}
var Bytes$8 = {}, hasRequiredBytes$7;
function requireBytes$7() {
  if (hasRequiredBytes$7) return Bytes$8;
  hasRequiredBytes$7 = 1, Object.defineProperty(Bytes$8, "__esModule", { value: !0 }), Bytes$8.Bytes = void 0;
  const n = requireLib$7(), c = requireRegistryItem$7(), u = requireRegistryType$7();
  class p extends c.RegistryItem {
    constructor(A) {
      super(), this.bytes = A, this.getRegistryType = () => u.RegistryTypes.BYTES, this.getData = () => this.bytes, this.toDataItem = () => new n.DataItem(this.bytes);
    }
  }
  return Bytes$8.Bytes = p, p.fromDataItem = (a) => {
    const A = a.getData();
    if (!A)
      throw new Error(`#[ur-registry][Bytes][fn.fromDataItem]: decoded [dataItem][#data] is undefined: ${a}`);
    return new p(A);
  }, p.fromCBOR = (a) => {
    const A = (0, n.decodeToDataItem)(a);
    return p.fromDataItem(A);
  }, Bytes$8;
}
var CryptoOutput$7 = {}, MultiKey$7 = {}, hasRequiredMultiKey$7;
function requireMultiKey$7() {
  if (hasRequiredMultiKey$7) return MultiKey$7;
  hasRequiredMultiKey$7 = 1, Object.defineProperty(MultiKey$7, "__esModule", { value: !0 }), MultiKey$7.MultiKey = void 0;
  const n = requireCryptoECKey$7(), c = requireCryptoHDKey$7(), u = requireDataItem$7(), p = requireRegistryItem$7(), a = requireRegistryType$7();
  var A;
  (function(F) {
    F[F.threshold = 1] = "threshold", F[F.keys = 2] = "keys";
  })(A || (A = {}));
  class b extends p.RegistryItem {
    constructor(le, L) {
      super(), this.threshold = le, this.keys = L, this.getThreshold = () => this.threshold, this.getKeys = () => this.keys, this.toDataItem = () => {
        const pe = {};
        pe[A.threshold] = this.threshold;
        const $ = this.keys.map((Ee) => {
          const be = Ee.toDataItem();
          return be.setTag(Ee.getRegistryType().getTag()), be;
        });
        return pe[A.keys] = $, new u.DataItem(pe);
      }, this.getOutputDescriptorContent = () => [
        this.getThreshold(),
        this.keys.map((pe) => pe.getOutputDescriptorContent()).join(",")
      ].join(",");
    }
  }
  return MultiKey$7.MultiKey = b, b.fromDataItem = (F) => {
    const le = F.getData(), L = le[A.threshold], pe = le[A.keys], $ = [];
    return pe.forEach((Ee) => {
      Ee.getTag() === a.RegistryTypes.CRYPTO_HDKEY.getTag() ? $.push(c.CryptoHDKey.fromDataItem(Ee)) : Ee.getTag() === a.RegistryTypes.CRYPTO_ECKEY.getTag() && $.push(n.CryptoECKey.fromDataItem(Ee));
    }), new b(L, $);
  }, MultiKey$7;
}
var hasRequiredCryptoOutput$7;
function requireCryptoOutput$7() {
  if (hasRequiredCryptoOutput$7) return CryptoOutput$7;
  hasRequiredCryptoOutput$7 = 1, Object.defineProperty(CryptoOutput$7, "__esModule", { value: !0 }), CryptoOutput$7.CryptoOutput = void 0;
  const n = requireCryptoECKey$7(), c = requireCryptoHDKey$7(), u = requireLib$7(), p = requireMultiKey$7(), a = requireRegistryItem$7(), A = requireRegistryType$7(), b = requireScriptExpression$7();
  class F extends a.RegistryItem {
    constructor(L, pe) {
      super(), this.scriptExpressions = L, this.cryptoKey = pe, this.getRegistryType = () => A.RegistryTypes.CRYPTO_OUTPUT, this.getCryptoKey = () => this.cryptoKey, this.getHDKey = () => {
        if (this.cryptoKey instanceof c.CryptoHDKey)
          return this.cryptoKey;
      }, this.getECKey = () => {
        if (this.cryptoKey instanceof n.CryptoECKey)
          return this.cryptoKey;
      }, this.getMultiKey = () => {
        if (this.cryptoKey instanceof p.MultiKey)
          return this.cryptoKey;
      }, this.getScriptExpressions = () => this.scriptExpressions, this._toOutputDescriptor = ($) => $ >= this.scriptExpressions.length ? this.cryptoKey.getOutputDescriptorContent() : `${this.scriptExpressions[$].getExpression()}(${this._toOutputDescriptor($ + 1)})`, this.toString = () => this._toOutputDescriptor(0), this.toDataItem = () => {
        let $ = this.cryptoKey.toDataItem();
        return (this.cryptoKey instanceof n.CryptoECKey || this.cryptoKey instanceof c.CryptoHDKey) && $.setTag(this.cryptoKey.getRegistryType().getTag()), [...this.scriptExpressions].reverse().forEach((be) => {
          const He = be.getTag();
          $.getTag() === void 0 ? $.setTag(He) : $ = new u.DataItem($, He);
        }), $;
      };
    }
  }
  return CryptoOutput$7.CryptoOutput = F, F.fromDataItem = (le) => {
    const L = [];
    let pe = le;
    for (; ; ) {
      let be = pe.getTag();
      const He = b.ScriptExpression.fromTag(be);
      if (He)
        if (L.push(He), pe.getData() instanceof u.DataItem)
          pe = pe.getData(), be = pe.getTag();
        else
          break;
      else
        break;
    }
    const $ = L.length;
    if ($ > 0 && (L[$ - 1].getExpression() === b.ScriptExpressions.MULTISIG.getExpression() || L[$ - 1].getExpression() === b.ScriptExpressions.SORTED_MULTISIG.getExpression())) {
      const be = p.MultiKey.fromDataItem(pe);
      return new F(L, be);
    }
    if (pe.getTag() === A.RegistryTypes.CRYPTO_HDKEY.getTag()) {
      const be = c.CryptoHDKey.fromDataItem(pe);
      return new F(L, be);
    } else {
      const be = n.CryptoECKey.fromDataItem(pe);
      return new F(L, be);
    }
  }, F.fromCBOR = (le) => {
    const L = (0, u.decodeToDataItem)(le);
    return F.fromDataItem(L);
  }, CryptoOutput$7;
}
var CryptoPSBT$7 = {}, hasRequiredCryptoPSBT$7;
function requireCryptoPSBT$7() {
  if (hasRequiredCryptoPSBT$7) return CryptoPSBT$7;
  hasRequiredCryptoPSBT$7 = 1, Object.defineProperty(CryptoPSBT$7, "__esModule", { value: !0 }), CryptoPSBT$7.CryptoPSBT = void 0;
  const n = requireLib$7(), c = requireRegistryItem$7(), u = requireRegistryType$7();
  class p extends c.RegistryItem {
    constructor(A) {
      super(), this.psbt = A, this.getRegistryType = () => u.RegistryTypes.CRYPTO_PSBT, this.getPSBT = () => this.psbt, this.toDataItem = () => new n.DataItem(this.psbt);
    }
  }
  return CryptoPSBT$7.CryptoPSBT = p, p.fromDataItem = (a) => {
    const A = a.getData();
    if (!A)
      throw new Error(`#[ur-registry][CryptoPSBT][fn.fromDataItem]: decoded [dataItem][#data] is undefined: ${a}`);
    return new p(A);
  }, p.fromCBOR = (a) => {
    const A = (0, n.decodeToDataItem)(a);
    return p.fromDataItem(A);
  }, CryptoPSBT$7;
}
var CryptoAccount$7 = {}, hasRequiredCryptoAccount$7;
function requireCryptoAccount$7() {
  if (hasRequiredCryptoAccount$7) return CryptoAccount$7;
  hasRequiredCryptoAccount$7 = 1, Object.defineProperty(CryptoAccount$7, "__esModule", { value: !0 }), CryptoAccount$7.CryptoAccount = void 0;
  const n = requireDist$7(), c = requireLib$7(), u = requireRegistryItem$7(), p = requireRegistryType$7();
  var a;
  (function(b) {
    b[b.masterFingerprint = 1] = "masterFingerprint", b[b.outputDescriptors = 2] = "outputDescriptors";
  })(a || (a = {}));
  class A extends u.RegistryItem {
    constructor(F, le) {
      super(), this.masterFingerprint = F, this.outputDescriptors = le, this.getRegistryType = () => p.RegistryTypes.CRYPTO_ACCOUNT, this.getMasterFingerprint = () => this.masterFingerprint, this.getOutputDescriptors = () => this.outputDescriptors, this.toDataItem = () => {
        const L = {};
        return this.masterFingerprint && (L[a.masterFingerprint] = this.masterFingerprint.readUInt32BE(0)), this.outputDescriptors && (L[a.outputDescriptors] = this.outputDescriptors.map((pe) => pe.toDataItem())), new c.DataItem(L);
      };
    }
  }
  return CryptoAccount$7.CryptoAccount = A, A.fromDataItem = (b) => {
    const F = b.getData(), le = Buffer$f.alloc(4), L = F[a.masterFingerprint];
    L && le.writeUInt32BE(L, 0);
    const $ = F[a.outputDescriptors].map((Ee) => n.CryptoOutput.fromDataItem(Ee));
    return new A(le, $);
  }, A.fromCBOR = (b) => {
    const F = (0, c.decodeToDataItem)(b);
    return A.fromDataItem(F);
  }, CryptoAccount$7;
}
var Decoder$7 = {}, errors$8 = {}, hasRequiredErrors$7;
function requireErrors$7() {
  if (hasRequiredErrors$7) return errors$8;
  hasRequiredErrors$7 = 1, Object.defineProperty(errors$8, "__esModule", { value: !0 }), errors$8.UnknownURTypeError = void 0;
  class n extends Error {
    constructor(u) {
      super(u);
    }
  }
  return errors$8.UnknownURTypeError = n, errors$8;
}
var hasRequiredDecoder$7;
function requireDecoder$7() {
  if (hasRequiredDecoder$7) return Decoder$7;
  hasRequiredDecoder$7 = 1, Object.defineProperty(Decoder$7, "__esModule", { value: !0 }), Decoder$7.URRegistryDecoder = void 0;
  const n = dist$t, c = requireDist$7(), u = requireRegistryType$7(), p = requireErrors$7();
  class a extends n.URDecoder {
    constructor() {
      super(...arguments), this.resultRegistryType = () => {
        const b = this.resultUR();
        switch (b.type) {
          case u.RegistryTypes.BYTES.getType():
            return c.Bytes.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_HDKEY.getType():
            return c.CryptoHDKey.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_KEYPATH.getType():
            return c.CryptoKeypath.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_COIN_INFO.getType():
            return c.CryptoCoinInfo.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_ECKEY.getType():
            return c.CryptoECKey.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_OUTPUT.getType():
            return c.CryptoOutput.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_PSBT.getType():
            return c.CryptoPSBT.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_ACCOUNT.getType():
            return c.CryptoAccount.fromCBOR(b.cbor);
          default:
            throw new p.UnknownURTypeError(`#[ur-registry][Decoder][fn.resultRegistryType]: registry type ${b.type} is not supported now`);
        }
      };
    }
  }
  return Decoder$7.URRegistryDecoder = a, Decoder$7;
}
var CryptoMultiAccounts$7 = {}, hasRequiredCryptoMultiAccounts$7;
function requireCryptoMultiAccounts$7() {
  if (hasRequiredCryptoMultiAccounts$7) return CryptoMultiAccounts$7;
  hasRequiredCryptoMultiAccounts$7 = 1, Object.defineProperty(CryptoMultiAccounts$7, "__esModule", { value: !0 }), CryptoMultiAccounts$7.CryptoMultiAccounts = void 0;
  const n = requireRegistryType$7(), c = requireCryptoHDKey$7(), u = requireRegistryItem$7(), p = requireLib$7();
  var a;
  (function(b) {
    b[b.masterFingerprint = 1] = "masterFingerprint", b[b.keys = 2] = "keys", b[b.device = 3] = "device", b[b.deviceId = 4] = "deviceId", b[b.version = 5] = "version";
  })(a || (a = {}));
  class A extends u.RegistryItem {
    constructor(F, le, L, pe, $) {
      super(), this.masterFingerprint = F, this.keys = le, this.device = L, this.deviceId = pe, this.version = $, this.getRegistryType = () => n.RegistryTypes.CRYPTO_MULTI_ACCOUNTS, this.getMasterFingerprint = () => this.masterFingerprint, this.getKeys = () => this.keys, this.getDevice = () => this.device, this.getDeviceId = () => this.deviceId, this.getVersion = () => this.version, this.toDataItem = () => {
        const Ee = {};
        return this.masterFingerprint && (Ee[a.masterFingerprint] = this.masterFingerprint.readUInt32BE(0)), this.keys && (Ee[a.keys] = this.keys.map((be) => {
          const He = be.toDataItem();
          return He.setTag(be.getRegistryType().getTag()), He;
        })), this.device && (Ee[a.device] = this.device), this.deviceId && (Ee[a.deviceId] = this.deviceId), this.version && (Ee[a.version] = this.version), new p.DataItem(Ee);
      };
    }
  }
  return CryptoMultiAccounts$7.CryptoMultiAccounts = A, A.fromDataItem = (b) => {
    const F = b.getData(), le = Buffer$f.alloc(4), L = F[a.masterFingerprint];
    L && le.writeUInt32BE(L, 0);
    const $ = F[a.keys].map((Pe) => c.CryptoHDKey.fromDataItem(Pe)), Ee = F[a.device], be = F[a.deviceId], He = F[a.version];
    return new A(le, $, Ee, be, He);
  }, A.fromCBOR = (b) => {
    const F = (0, p.decodeToDataItem)(b);
    return A.fromDataItem(F);
  }, CryptoMultiAccounts$7;
}
var QRHardwareCall$7 = {}, KeyDerivation$7 = {}, DerivationSchema$7 = {}, hasRequiredDerivationSchema$7;
function requireDerivationSchema$7() {
  return hasRequiredDerivationSchema$7 || (hasRequiredDerivationSchema$7 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.KeyDerivationSchema = n.DerivationAlgorithm = n.Curve = void 0;
    const c = requireRegistryType$7(), u = requireRegistryItem$7(), p = requireLib$7(), a = requireCryptoKeypath$7();
    var A;
    (function(L) {
      L[L.keyPath = 1] = "keyPath", L[L.curve = 2] = "curve", L[L.algo = 3] = "algo";
    })(A || (A = {}));
    var b;
    (function(L) {
      L[L.secp256k1 = 0] = "secp256k1", L[L.ed25519 = 1] = "ed25519";
    })(b = n.Curve || (n.Curve = {}));
    var F;
    (function(L) {
      L[L.slip10 = 0] = "slip10", L[L.bip32ed25519 = 1] = "bip32ed25519";
    })(F = n.DerivationAlgorithm || (n.DerivationAlgorithm = {}));
    class le extends u.RegistryItem {
      constructor(pe, $ = b.secp256k1, Ee = F.slip10) {
        super(), this.keypath = pe, this.curve = $, this.algo = Ee, this.getRegistryType = () => c.RegistryTypes.KEY_DERIVATION_SCHEMA, this.getKeypath = () => this.keypath, this.getCurve = () => this.curve, this.getAlgo = () => this.algo, this.toDataItem = () => {
          const be = {}, He = this.getKeypath().toDataItem();
          return He.setTag(this.getKeypath().getRegistryType().getTag()), be[A.keyPath] = He, be[A.curve] = this.curve, be[A.algo] = this.algo, new p.DataItem(be);
        };
      }
    }
    n.KeyDerivationSchema = le, le.fromDataItem = (L) => {
      const pe = L.getData(), $ = a.CryptoKeypath.fromDataItem(pe[A.keyPath]), Ee = pe[A.curve], be = pe[A.algo];
      return new le($, Ee, be);
    }, le.fromCBOR = (L) => {
      const pe = (0, p.decodeToDataItem)(L);
      return le.fromDataItem(pe);
    };
  }(DerivationSchema$7)), DerivationSchema$7;
}
var hasRequiredKeyDerivation$7;
function requireKeyDerivation$7() {
  if (hasRequiredKeyDerivation$7) return KeyDerivation$7;
  hasRequiredKeyDerivation$7 = 1, Object.defineProperty(KeyDerivation$7, "__esModule", { value: !0 }), KeyDerivation$7.KeyDerivation = void 0;
  const n = requireRegistryType$7(), c = requireRegistryItem$7(), u = requireLib$7(), p = requireDerivationSchema$7();
  var a;
  (function(b) {
    b[b.schemas = 1] = "schemas";
  })(a || (a = {}));
  class A extends c.RegistryItem {
    constructor(F) {
      super(), this.schemas = F, this.getRegistryType = () => n.RegistryTypes.KEY_DERIVATION_CALL, this.getSchemas = () => this.schemas, this.toDataItem = () => {
        const le = {};
        return le[a.schemas] = this.schemas.map((L) => {
          const pe = L.toDataItem();
          return pe.setTag(L.getRegistryType().getTag()), pe;
        }), new u.DataItem(le);
      };
    }
  }
  return KeyDerivation$7.KeyDerivation = A, A.fromDataItem = (b) => {
    const le = b.getData()[a.schemas].map((L) => p.KeyDerivationSchema.fromDataItem(L));
    return new A(le);
  }, A.fromCBOR = (b) => {
    const F = (0, u.decodeToDataItem)(b);
    return A.fromDataItem(F);
  }, KeyDerivation$7;
}
var hasRequiredQRHardwareCall$7;
function requireQRHardwareCall$7() {
  return hasRequiredQRHardwareCall$7 || (hasRequiredQRHardwareCall$7 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.QRHardwareCall = n.QRHardwareCallType = void 0;
    const c = requireRegistryType$7(), u = requireRegistryItem$7(), p = requireLib$7(), a = requireKeyDerivation$7();
    var A;
    (function(le) {
      le[le.type = 1] = "type", le[le.params = 2] = "params", le[le.origin = 3] = "origin";
    })(A || (A = {}));
    var b;
    (function(le) {
      le[le.KeyDerivation = 0] = "KeyDerivation";
    })(b = n.QRHardwareCallType || (n.QRHardwareCallType = {}));
    class F extends u.RegistryItem {
      constructor(L, pe, $) {
        super(), this.type = L, this.params = pe, this.origin = $, this.getRegistryType = () => c.RegistryTypes.QR_HARDWARE_CALL, this.getType = () => this.type, this.getParams = () => this.params, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const Ee = {};
          Ee[A.type] = this.type;
          const be = this.params.toDataItem();
          return be.setTag(this.params.getRegistryType().getTag()), Ee[A.params] = be, this.origin && (Ee[A.origin] = this.origin), new p.DataItem(Ee);
        };
      }
    }
    n.QRHardwareCall = F, F.fromDataItem = (le) => {
      const L = le.getData(), pe = L[A.type] || b.KeyDerivation;
      let $;
      switch (pe) {
        case b.KeyDerivation:
          $ = a.KeyDerivation.fromDataItem(L[A.params]);
      }
      const Ee = L[A.origin];
      return new F(pe, $, Ee);
    }, F.fromCBOR = (le) => {
      const L = (0, p.decodeToDataItem)(le);
      return F.fromDataItem(L);
    };
  }(QRHardwareCall$7)), QRHardwareCall$7;
}
var types$c = {}, hasRequiredTypes$7;
function requireTypes$7() {
  return hasRequiredTypes$7 || (hasRequiredTypes$7 = 1, Object.defineProperty(types$c, "__esModule", { value: !0 })), types$c;
}
var hasRequiredDist$7;
function requireDist$7() {
  return hasRequiredDist$7 || (hasRequiredDist$7 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.Buffer = n.extend = n.PathComponent = n.ScriptExpressions = n.MultiKey = n.CryptoPSBT = n.CryptoOutput = n.CryptoECKey = n.CryptoCoinInfoNetwork = n.CryptoCoinInfoType = n.CryptoCoinInfo = n.CryptoKeypath = n.CryptoMultiAccounts = n.CryptoHDKey = n.CryptoAccount = n.Bytes = n.URRegistryDecoder = n.DataItem = void 0;
    const c = require$$0$4;
    requirePatchCBOR$7();
    const u = dist$u;
    Object.defineProperty(n, "Buffer", { enumerable: !0, get: function() {
      return u.Buffer;
    } });
    const p = requireCryptoHDKey$7();
    Object.defineProperty(n, "CryptoHDKey", { enumerable: !0, get: function() {
      return p.CryptoHDKey;
    } });
    const a = requireCryptoKeypath$7();
    Object.defineProperty(n, "CryptoKeypath", { enumerable: !0, get: function() {
      return a.CryptoKeypath;
    } });
    const A = requireCryptoCoinInfo$7();
    Object.defineProperty(n, "CryptoCoinInfo", { enumerable: !0, get: function() {
      return A.CryptoCoinInfo;
    } }), Object.defineProperty(n, "CryptoCoinInfoType", { enumerable: !0, get: function() {
      return A.Type;
    } }), Object.defineProperty(n, "CryptoCoinInfoNetwork", { enumerable: !0, get: function() {
      return A.Network;
    } });
    const b = requireCryptoECKey$7();
    Object.defineProperty(n, "CryptoECKey", { enumerable: !0, get: function() {
      return b.CryptoECKey;
    } });
    const F = requireBytes$7();
    Object.defineProperty(n, "Bytes", { enumerable: !0, get: function() {
      return F.Bytes;
    } });
    const le = requireCryptoOutput$7();
    Object.defineProperty(n, "CryptoOutput", { enumerable: !0, get: function() {
      return le.CryptoOutput;
    } });
    const L = requireCryptoPSBT$7();
    Object.defineProperty(n, "CryptoPSBT", { enumerable: !0, get: function() {
      return L.CryptoPSBT;
    } });
    const pe = requireCryptoAccount$7();
    Object.defineProperty(n, "CryptoAccount", { enumerable: !0, get: function() {
      return pe.CryptoAccount;
    } });
    const $ = requireDecoder$7();
    Object.defineProperty(n, "URRegistryDecoder", { enumerable: !0, get: function() {
      return $.URRegistryDecoder;
    } });
    const Ee = requireMultiKey$7();
    Object.defineProperty(n, "MultiKey", { enumerable: !0, get: function() {
      return Ee.MultiKey;
    } });
    const be = requireScriptExpression$7();
    Object.defineProperty(n, "ScriptExpressions", { enumerable: !0, get: function() {
      return be.ScriptExpressions;
    } });
    const He = requirePathComponent$7();
    Object.defineProperty(n, "PathComponent", { enumerable: !0, get: function() {
      return He.PathComponent;
    } });
    const Pe = requireRegistryItem$7(), nr = requireRegistryType$7(), ir = requireLib$7();
    var or = requireLib$7();
    Object.defineProperty(n, "DataItem", { enumerable: !0, get: function() {
      return or.DataItem;
    } });
    const lr = requireUtils$7(), Ir = requireCryptoMultiAccounts$7();
    Object.defineProperty(n, "CryptoMultiAccounts", { enumerable: !0, get: function() {
      return Ir.CryptoMultiAccounts;
    } });
    const xr = {
      URRegistryDecoder: $.URRegistryDecoder,
      Bytes: F.Bytes,
      CryptoAccount: pe.CryptoAccount,
      CryptoHDKey: p.CryptoHDKey,
      CryptoMultiAccounts: Ir.CryptoMultiAccounts,
      CryptoKeypath: a.CryptoKeypath,
      CryptoCoinInfo: A.CryptoCoinInfo,
      CryptoCoinInfoType: A.Type,
      CryptoCoinInfoNetwork: A.Network,
      CryptoECKey: b.CryptoECKey,
      CryptoOutput: le.CryptoOutput,
      CryptoPSBT: L.CryptoPSBT,
      MultiKey: Ee.MultiKey,
      ScriptExpressions: be.ScriptExpressions,
      PathComponent: He.PathComponent
    }, kr = {
      addReader: ir.addReader,
      addSemanticDecode: ir.addSemanticDecode,
      addSemanticEncode: ir.addSemanticEncode,
      addWriter: ir.addWriter,
      patchTags: lr.patchTags
    }, Ce = {
      RegistryTypes: nr.RegistryTypes,
      RegistryItem: Pe.RegistryItem,
      RegistryType: nr.RegistryType,
      decodeToDataItem: ir.decodeToDataItem,
      encodeDataItem: ir.encodeDataItem,
      cbor: kr
    };
    n.extend = Ce, (0, c.__exportStar)(requireErrors$7(), n), (0, c.__exportStar)(requireDecoder$7(), n), (0, c.__exportStar)(requireLib$7(), n), (0, c.__exportStar)(requireCryptoAccount$7(), n), (0, c.__exportStar)(requireCryptoPSBT$7(), n), (0, c.__exportStar)(requireCryptoHDKey$7(), n), (0, c.__exportStar)(requireCryptoMultiAccounts$7(), n), (0, c.__exportStar)(requireQRHardwareCall$7(), n), (0, c.__exportStar)(requireKeyDerivation$7(), n), (0, c.__exportStar)(requireDerivationSchema$7(), n), (0, c.__exportStar)(requireCryptoOutput$7(), n), (0, c.__exportStar)(requireCryptoCoinInfo$7(), n), (0, c.__exportStar)(requireCryptoECKey$7(), n), (0, c.__exportStar)(requireMultiKey$7(), n), (0, c.__exportStar)(requireCryptoKeypath$7(), n), (0, c.__exportStar)(requirePatchCBOR$7(), n), (0, c.__exportStar)(requirePathComponent$7(), n), (0, c.__exportStar)(requireRegistryItem$7(), n), (0, c.__exportStar)(requireRegistryType$7(), n), (0, c.__exportStar)(requireTypes$7(), n), (0, c.__exportStar)(requireUtils$7(), n), n.default = xr;
  }(dist$i)), dist$i;
}
var hasRequiredBcUrRegistryKeystone_cjs_production_min;
function requireBcUrRegistryKeystone_cjs_production_min() {
  return hasRequiredBcUrRegistryKeystone_cjs_production_min || (hasRequiredBcUrRegistryKeystone_cjs_production_min = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 });
    var c = requireDist$7();
    const u = { KEYSTONE_SIGN_REQUEST: new c.RegistryType("keystone-sign-request", 6101), KEYSTONE_SIGN_RESULT: new c.RegistryType("keystone-sign-result", 6102) }, { decodeToDataItem: p } = c.extend;
    var a;
    (function(L) {
      L[L.signData = 1] = "signData", L[L.origin = 2] = "origin";
    })(a || (a = {}));
    class A extends c.RegistryItem {
      constructor(pe) {
        super(), this.getRegistryType = () => u.KEYSTONE_SIGN_REQUEST, this.getSignData = () => this.signData, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const $ = {};
          return $[a.signData] = this.signData, this.origin && ($[a.origin] = this.origin), new c.DataItem($);
        }, this.signData = pe.signData, this.origin = pe.origin;
      }
      static constructKeystoneRequest(pe, $) {
        return new A({ signData: pe, origin: $ });
      }
    }
    A.fromDataItem = (L) => {
      const pe = L.getData();
      return new A({ signData: pe[a.signData], origin: pe[a.origin] });
    }, A.fromCBOR = (L) => {
      const pe = p(L);
      return A.fromDataItem(pe);
    };
    const { decodeToDataItem: b } = c.extend;
    var F;
    (function(L) {
      L[L.signResult = 1] = "signResult";
    })(F || (F = {}));
    class le extends c.RegistryItem {
      constructor(pe) {
        super(), this.getRegistryType = () => u.KEYSTONE_SIGN_RESULT, this.getSignResult = () => this.signResult, this.toDataItem = () => {
          const $ = {};
          return $[F.signResult] = this.signResult, new c.DataItem($);
        }, this.signResult = pe;
      }
    }
    le.fromDataItem = (L) => {
      const pe = L.getData();
      return new le(pe[F.signResult]);
    }, le.fromCBOR = (L) => {
      const pe = b(L);
      return le.fromDataItem(pe);
    }, c.patchTags(Object.values(u).filter((L) => !!L.getTag()).map((L) => L.getTag())), Object.keys(c).forEach(function(L) {
      L !== "default" && Object.defineProperty(n, L, { enumerable: !0, get: function() {
        return c[L];
      } });
    }), n.KeystoneSignRequest = A, n.KeystoneSignResult = le;
  }(bcUrRegistryKeystone_cjs_production_min)), bcUrRegistryKeystone_cjs_production_min;
}
var bcUrRegistryKeystone_cjs_development = {}, hasRequiredBcUrRegistryKeystone_cjs_development;
function requireBcUrRegistryKeystone_cjs_development() {
  return hasRequiredBcUrRegistryKeystone_cjs_development || (hasRequiredBcUrRegistryKeystone_cjs_development = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 });
    var c = requireDist$7();
    const u = {
      KEYSTONE_SIGN_REQUEST: /* @__PURE__ */ new c.RegistryType("keystone-sign-request", 6101),
      KEYSTONE_SIGN_RESULT: /* @__PURE__ */ new c.RegistryType("keystone-sign-result", 6102)
    }, {
      decodeToDataItem: p
    } = c.extend;
    var a;
    (function(L) {
      L[L.signData = 1] = "signData", L[L.origin = 2] = "origin";
    })(a || (a = {}));
    class A extends c.RegistryItem {
      constructor(pe) {
        super(), this.getRegistryType = () => u.KEYSTONE_SIGN_REQUEST, this.getSignData = () => this.signData, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const $ = {};
          return $[a.signData] = this.signData, this.origin && ($[a.origin] = this.origin), new c.DataItem($);
        }, this.signData = pe.signData, this.origin = pe.origin;
      }
      static constructKeystoneRequest(pe, $) {
        return new A({
          signData: pe,
          origin: $
        });
      }
    }
    A.fromDataItem = (L) => {
      const pe = L.getData();
      return new A({
        signData: pe[a.signData],
        origin: pe[a.origin]
      });
    }, A.fromCBOR = (L) => {
      const pe = p(L);
      return A.fromDataItem(pe);
    };
    const {
      decodeToDataItem: b
    } = c.extend;
    var F;
    (function(L) {
      L[L.signResult = 1] = "signResult";
    })(F || (F = {}));
    class le extends c.RegistryItem {
      constructor(pe) {
        super(), this.getRegistryType = () => u.KEYSTONE_SIGN_RESULT, this.getSignResult = () => this.signResult, this.toDataItem = () => {
          const $ = {};
          return $[F.signResult] = this.signResult, new c.DataItem($);
        }, this.signResult = pe;
      }
    }
    le.fromDataItem = (L) => {
      const $ = L.getData()[F.signResult];
      return new le($);
    }, le.fromCBOR = (L) => {
      const pe = b(L);
      return le.fromDataItem(pe);
    }, c.patchTags(Object.values(u).filter((L) => !!L.getTag()).map((L) => L.getTag())), Object.keys(c).forEach(function(L) {
      L !== "default" && Object.defineProperty(n, L, {
        enumerable: !0,
        get: function() {
          return c[L];
        }
      });
    }), n.KeystoneSignRequest = A, n.KeystoneSignResult = le;
  }(bcUrRegistryKeystone_cjs_development)), bcUrRegistryKeystone_cjs_development;
}
process$1.env.NODE_ENV === "production" ? dist$j.exports = requireBcUrRegistryKeystone_cjs_production_min() : dist$j.exports = requireBcUrRegistryKeystone_cjs_development();
var distExports$7 = dist$j.exports, __importDefault$a = commonjsGlobal && commonjsGlobal.__importDefault || function(n) {
  return n && n.__esModule ? n : { default: n };
};
Object.defineProperty(tron, "__esModule", { value: !0 });
tron.KeystoneTronSDK = void 0;
const utils_1$h = utils$K, ur_1$7 = ur, transfer_1 = transfer, pako_1 = __importDefault$a(pako), base_pb_1 = base_pb, payload_pb_1 = payload_pb, transaction_pb_1 = transaction_pb, bc_ur_registry_keystone_1 = distExports$7;
class KeystoneTronSDK {
  parseSignature(c) {
    var u, p, a, A;
    if (c.type !== ur_1$7.URType.KeystoneSignResult)
      throw new Error("type not match");
    const b = bc_ur_registry_keystone_1.KeystoneSignResult.fromCBOR(c.cbor), F = base_pb_1.Base.fromBinary(pako_1.default.ungzip(b.getSignResult()));
    if (((u = F.data) === null || u === void 0 ? void 0 : u.Content.case) !== "signTxResult")
      throw new Error("invalid sign result");
    const { signId: le, rawTx: L } = (A = (a = (p = F.data) === null || p === void 0 ? void 0 : p.Content) === null || a === void 0 ? void 0 : a.value) !== null && A !== void 0 ? A : {};
    return {
      requestId: le,
      raw: L
    };
  }
  generateSignRequest({ requestId: c, signData: u, path: p, xfp: a, tokenInfo: A, origin: b }) {
    const F = (0, transfer_1.raw2tx)((0, utils_1$h.toBuffer)(u), A), le = pako_1.default.gzip(new base_pb_1.Base({
      version: 2,
      description: "QrCode Protocol",
      deviceType: "",
      data: new payload_pb_1.Payload({
        xfp: a,
        type: payload_pb_1.Payload_Type.SIGN_TX,
        Content: {
          case: "signTx",
          value: new transaction_pb_1.SignTransaction({
            coinCode: "TRON",
            hdPath: p,
            signId: c,
            timestamp: BigInt(Date.now()),
            decimal: 6,
            Transaction: {
              case: "tronTx",
              value: F
            }
          })
        }
      })
    }).toBinary());
    return new bc_ur_registry_keystone_1.KeystoneSignRequest({
      signData: Buffer$f.from(le),
      origin: b
    }).toUR();
  }
}
tron.KeystoneTronSDK = KeystoneTronSDK;
var aptos = {}, dist$h = { exports: {} }, bcUrRegistryAptos_cjs_production_min = {}, dist$g = {}, patchCBOR$6 = {}, utils$b = {}, lib$8 = {}, cborSync$6 = { exports: {} }, DataItem$6 = {}, hasRequiredDataItem$6;
function requireDataItem$6() {
  if (hasRequiredDataItem$6) return DataItem$6;
  hasRequiredDataItem$6 = 1, Object.defineProperty(DataItem$6, "__esModule", { value: !0 }), DataItem$6.DataItem = void 0;
  class n {
    constructor(u, p) {
      this.setTag = (a) => {
        this.tag = a;
      }, this.clearTag = () => {
        this.tag = void 0;
      }, this.getTag = () => this.tag, this.getData = () => this.data, this.data = u, this.tag = p;
    }
  }
  return DataItem$6.DataItem = n, DataItem$6;
}
var hasRequiredCborSync$6;
function requireCborSync$6() {
  return hasRequiredCborSync$6 || (hasRequiredCborSync$6 = 1, function(n) {
    (function(c, u) {
      n.exports ? n.exports = u() : c.CBOR = u();
    })(commonjsGlobal, function() {
      const { DataItem: c } = requireDataItem$6();
      var u = function() {
        function p(Ce) {
          this.$hex = Ce;
        }
        p.prototype = {
          length: function() {
            return this.$hex.length / 2;
          },
          toString: function(Ce) {
            if (!Ce || Ce === "hex" || Ce === 16)
              return this.$hex;
            if (Ce === "utf-8") {
              for (var tr = "", Fe = 0; Fe < this.$hex.length; Fe += 2)
                tr += "%" + this.$hex.substring(Fe, Fe + 2);
              return decodeURIComponent(tr);
            }
            if (Ce === "latin") {
              for (var tr = [], Fe = 0; Fe < this.$hex.length; Fe += 2)
                tr.push(parseInt(this.$hex.substring(Fe, Fe + 2), 16));
              return String.fromCharCode.apply(String, tr);
            }
            throw new Error("Unrecognised format: " + Ce);
          }
        }, p.fromLatinString = function(Ce) {
          for (var tr = "", Fe = 0; Fe < Ce.length; Fe++) {
            var Sr = Ce.charCodeAt(Fe).toString(16);
            Sr.length === 1 && (Sr = "0" + Sr), tr += Sr;
          }
          return new p(tr);
        }, p.fromUtf8String = function(Ce) {
          for (var tr = encodeURIComponent(Ce), Fe = "", Sr = 0; Sr < tr.length; Sr++)
            if (tr.charAt(Sr) === "%")
              Fe += tr.substring(Sr + 1, Sr + 3), Sr += 2;
            else {
              var er = tr.charCodeAt(Sr).toString(16);
              er.length < 2 && (er = "0" + er), Fe += er;
            }
          return new p(Fe);
        };
        var a = [], A = {}, b = function(Ce) {
          return function() {
            throw new Error(Ce + " not implemented");
          };
        };
        function F() {
        }
        F.prototype = {
          peekByte: b("peekByte"),
          readByte: b("readByte"),
          readChunk: b("readChunk"),
          readFloat16: function() {
            var Ce = this.readUint16(), tr = (Ce & 32767) >> 10, Fe = Ce & 1023, Sr = Ce & 32768;
            if (tr === 31)
              return Fe === 0 ? Sr ? -1 / 0 : 1 / 0 : NaN;
            var er = tr ? Math.pow(2, tr - 25) * (1024 + Fe) : Math.pow(2, -24) * Fe;
            return Sr ? -er : er;
          },
          readFloat32: function() {
            var Ce = this.readUint32(), tr = (Ce & 2147483647) >> 23, Fe = Ce & 8388607, Sr = Ce & 2147483648;
            if (tr === 255)
              return Fe === 0 ? Sr ? -1 / 0 : 1 / 0 : NaN;
            var er = tr ? Math.pow(2, tr - 23 - 127) * (8388608 + Fe) : Math.pow(2, -149) * Fe;
            return Sr ? -er : er;
          },
          readFloat64: function() {
            var Ce = this.readUint32(), tr = this.readUint32(), Fe = Ce >> 20 & 2047, Sr = (Ce & 1048575) * 4294967296 + tr, er = Ce & 2147483648;
            if (Fe === 2047)
              return Sr === 0 ? er ? -1 / 0 : 1 / 0 : NaN;
            var Ie = Fe ? Math.pow(2, Fe - 52 - 1023) * (4503599627370496 + Sr) : Math.pow(2, -1074) * Sr;
            return er ? -Ie : Ie;
          },
          readUint16: function() {
            return this.readByte() * 256 + this.readByte();
          },
          readUint32: function() {
            return this.readUint16() * 65536 + this.readUint16();
          },
          readUint64: function() {
            return this.readUint32() * 4294967296 + this.readUint32();
          }
        };
        function le() {
        }
        le.prototype = {
          writeByte: b("writeByte"),
          result: b("result"),
          writeFloat16: b("writeFloat16"),
          writeFloat32: b("writeFloat32"),
          writeFloat64: b("writeFloat64"),
          writeUint16: function(Ce) {
            this.writeByte(Ce >> 8 & 255), this.writeByte(Ce & 255);
          },
          writeUint32: function(Ce) {
            this.writeUint16(Ce >> 16 & 65535), this.writeUint16(Ce & 65535);
          },
          writeUint64: function(Ce) {
            if (Ce >= 9007199254740992 || Ce <= -9007199254740992)
              throw new Error("Cannot encode Uint64 of: " + Ce + " magnitude to big (floating point errors)");
            this.writeUint32(Math.floor(Ce / 4294967296)), this.writeUint32(Ce % 4294967296);
          },
          writeString: b("writeString"),
          canWriteBinary: function(Ce) {
            return !1;
          },
          writeBinary: b("writeChunk")
        };
        function L(Ce) {
          var tr = Ce.readByte(), Fe = tr >> 5, Sr = tr & 31;
          return { type: Fe, value: Sr };
        }
        function pe(Ce, tr) {
          var Fe = Ce.value;
          if (Fe < 24)
            return Fe;
          if (Fe == 24)
            return tr.readByte();
          if (Fe == 25)
            return tr.readUint16();
          if (Fe == 26)
            return tr.readUint32();
          if (Fe == 27)
            return tr.readUint64();
          if (Fe == 31)
            return null;
          b("Additional info: " + Fe)();
        }
        function $(Ce, tr, Fe) {
          Fe.writeByte(Ce << 5 | tr);
        }
        function Ee(Ce, tr, Fe) {
          var Sr = Ce << 5;
          tr < 24 ? Fe.writeByte(Sr | tr) : tr < 256 ? (Fe.writeByte(Sr | 24), Fe.writeByte(tr)) : tr < 65536 ? (Fe.writeByte(Sr | 25), Fe.writeUint16(tr)) : tr < 4294967296 ? (Fe.writeByte(Sr | 26), Fe.writeUint32(tr)) : (Fe.writeByte(Sr | 27), Fe.writeUint64(tr));
        }
        var be = new Error();
        function He(Ce) {
          var tr = L(Ce);
          switch (tr.type) {
            case 0:
              return pe(tr, Ce);
            case 1:
              return -1 - pe(tr, Ce);
            case 2:
              return Ce.readChunk(pe(tr, Ce));
            case 3:
              var Fe = Ce.readChunk(pe(tr, Ce));
              return Fe.toString("utf-8");
            case 4:
            case 5:
              var Sr = pe(tr, Ce), yr = [];
              if (Sr !== null) {
                tr.type === 5 && (Sr *= 2);
                for (var er = 0; er < Sr; er++)
                  yr[er] = He(Ce);
              } else
                for (var Ie; (Ie = He(Ce)) !== be; )
                  yr.push(Ie);
              if (tr.type === 5) {
                for (var xe = {}, er = 0; er < yr.length; er += 2)
                  xe[yr[er]] = yr[er + 1];
                return xe;
              } else
                return yr;
            case 6:
              var rr = pe(tr, Ce), ar = A[rr], yr = He(Ce);
              return ar ? ar(yr) : yr;
            case 7:
              if (tr.value === 25)
                return Ce.readFloat16();
              if (tr.value === 26)
                return Ce.readFloat32();
              if (tr.value === 27)
                return Ce.readFloat64();
              switch (pe(tr, Ce)) {
                case 20:
                  return !1;
                case 21:
                  return !0;
                case 22:
                  return null;
                case 23:
                  return;
                case null:
                  return be;
                default:
                  throw new Error("Unknown fixed value: " + tr.value);
              }
            default:
              throw new Error("Unsupported header: " + JSON.stringify(tr));
          }
          throw new Error("not implemented yet");
        }
        function Pe(Ce, tr) {
          for (var Fe = 0; Fe < a.length; Fe++) {
            var Sr = a[Fe].fn(Ce);
            if (Sr !== void 0)
              return Ee(6, a[Fe].tag, tr), Pe(Sr, tr);
          }
          if (Ce && typeof Ce.toCBOR == "function" && (Ce = Ce.toCBOR()), Ce === !1)
            Ee(7, 20, tr);
          else if (Ce === !0)
            Ee(7, 21, tr);
          else if (Ce === null)
            Ee(7, 22, tr);
          else if (Ce === void 0)
            Ee(7, 23, tr);
          else if (typeof Ce == "number")
            Math.floor(Ce) === Ce && Ce < 9007199254740992 && Ce > -9007199254740992 ? Ce < 0 ? Ee(1, -1 - Ce, tr) : Ee(0, Ce, tr) : ($(7, 27, tr), tr.writeFloat64(Ce));
          else if (typeof Ce == "string")
            tr.writeString(Ce, function(Ie) {
              Ee(3, Ie, tr);
            });
          else if (tr.canWriteBinary(Ce))
            tr.writeBinary(Ce, function(Ie) {
              Ee(2, Ie, tr);
            });
          else if (typeof Ce == "object")
            if (or.config.useToJSON && typeof Ce.toJSON == "function" && (Ce = Ce.toJSON()), Array.isArray(Ce)) {
              Ee(4, Ce.length, tr);
              for (var Fe = 0; Fe < Ce.length; Fe++)
                Pe(Ce[Fe], tr);
            } else {
              var er = Object.keys(Ce);
              Ee(5, er.length, tr);
              for (var Fe = 0; Fe < er.length; Fe++) {
                const xe = parseInt(er[Fe]);
                isNaN(xe) ? (Pe(er[Fe], tr), Pe(Ce[er[Fe]], tr)) : (Pe(xe, tr), Pe(Ce[er[Fe]], tr));
              }
            }
          else
            throw new Error("CBOR encoding not supported: " + Ce);
        }
        var nr = [], ir = [], or = {
          config: {
            useToJSON: !0
          },
          addWriter: function(Ce, tr) {
            typeof Ce == "string" ? ir.push(function(Fe) {
              if (Ce === Fe)
                return tr(Fe);
            }) : ir.push(Ce);
          },
          addReader: function(Ce, tr) {
            typeof Ce == "string" ? nr.push(function(Fe, Sr) {
              if (Ce === Sr)
                return tr(Fe, Sr);
            }) : nr.push(Ce);
          },
          encode: function(Ce, tr) {
            for (var Fe = 0; Fe < ir.length; Fe++) {
              var Sr = ir[Fe], er = Sr(tr);
              if (er)
                return Pe(Ce, er), er.result();
            }
            throw new Error("Unsupported output format: " + tr);
          },
          encodeDataItem: function(Ce, tr) {
            for (var Fe = 0; Fe < ir.length; Fe++) {
              var Sr = ir[Fe], er = Sr(tr);
              if (er)
                return Ce.getTag() !== void 0 ? (Pe(Ce, er), er.result()) : (Pe(Ce.getData(), er), er.result());
            }
            throw new Error("Unsupported output format: " + tr);
          },
          decode: function(Ce, tr) {
            for (var Fe = 0; Fe < nr.length; Fe++) {
              var Sr = nr[Fe], er = Sr(Ce, tr);
              if (er)
                return He(er);
            }
            throw new Error("Unsupported input format: " + tr);
          },
          decodeToDataItem: function(Ce, tr) {
            for (var Fe = 0; Fe < nr.length; Fe++) {
              var Sr = nr[Fe], er = Sr(Ce, tr);
              if (er) {
                const Ie = He(er);
                return Ie instanceof c ? Ie : new c(Ie);
              }
            }
            throw new Error("Unsupported input format: " + tr);
          },
          addSemanticEncode: function(Ce, tr) {
            if (typeof Ce != "number" || Ce % 1 !== 0 || Ce < 0)
              throw new Error("Tag must be a positive integer");
            return a.push({ tag: Ce, fn: tr }), this;
          },
          addSemanticDecode: function(Ce, tr) {
            if (typeof Ce != "number" || Ce % 1 !== 0 || Ce < 0)
              throw new Error("Tag must be a positive integer");
            return A[Ce] = tr, this;
          }
        };
        function lr(Ce) {
          this.buffer = Ce, this.pos = 0;
        }
        lr.prototype = Object.create(F.prototype), lr.prototype.peekByte = function() {
          return this.buffer[this.pos];
        }, lr.prototype.readByte = function() {
          return this.buffer[this.pos++];
        }, lr.prototype.readUint16 = function() {
          var Ce = this.buffer.readUInt16BE(this.pos);
          return this.pos += 2, Ce;
        }, lr.prototype.readUint32 = function() {
          var Ce = this.buffer.readUInt32BE(this.pos);
          return this.pos += 4, Ce;
        }, lr.prototype.readFloat32 = function() {
          var Ce = this.buffer.readFloatBE(this.pos);
          return this.pos += 4, Ce;
        }, lr.prototype.readFloat64 = function() {
          var Ce = this.buffer.readDoubleBE(this.pos);
          return this.pos += 8, Ce;
        }, lr.prototype.readChunk = function(Ce) {
          var tr = Buffer$f.alloc(Ce);
          return this.buffer.copy(tr, 0, this.pos, this.pos += Ce), tr;
        };
        function Ir(Ce) {
          this.byteLength = 0, this.defaultBufferLength = 16384, this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0, this.completeBuffers = [], this.stringFormat = Ce;
        }
        Ir.prototype = Object.create(le.prototype), Ir.prototype.writeByte = function(Ce) {
          this.latestBuffer[this.latestBufferOffset++] = Ce, this.latestBufferOffset >= this.latestBuffer.length && (this.completeBuffers.push(this.latestBuffer), this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0), this.byteLength++;
        }, Ir.prototype.writeFloat32 = function(Ce) {
          var tr = Buffer$f.alloc(4);
          tr.writeFloatBE(Ce, 0), this.writeBuffer(tr);
        }, Ir.prototype.writeFloat64 = function(Ce) {
          var tr = Buffer$f.alloc(8);
          tr.writeDoubleBE(Ce, 0), this.writeBuffer(tr);
        }, Ir.prototype.writeString = function(Ce, tr) {
          var Fe = Buffer$f.from(Ce, "utf-8");
          tr(Fe.length), this.writeBuffer(Fe);
        }, Ir.prototype.canWriteBinary = function(Ce) {
          return Ce instanceof Buffer$f;
        }, Ir.prototype.writeBinary = function(Ce, tr) {
          tr(Ce.length), this.writeBuffer(Ce);
        }, Ir.prototype.writeBuffer = function(Ce) {
          if (!(Ce instanceof Buffer$f))
            throw new TypeError("BufferWriter only accepts Buffers");
          this.latestBufferOffset ? this.latestBuffer.length - this.latestBufferOffset >= Ce.length ? (Ce.copy(this.latestBuffer, this.latestBufferOffset), this.latestBufferOffset += Ce.length, this.latestBufferOffset >= this.latestBuffer.length && (this.completeBuffers.push(this.latestBuffer), this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0)) : (this.completeBuffers.push(this.latestBuffer.slice(0, this.latestBufferOffset)), this.completeBuffers.push(Ce), this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0) : this.completeBuffers.push(Ce), this.byteLength += Ce.length;
        }, Ir.prototype.result = function() {
          for (var Ce = Buffer$f.alloc(this.byteLength), tr = 0, Fe = 0; Fe < this.completeBuffers.length; Fe++) {
            var Sr = this.completeBuffers[Fe];
            Sr.copy(Ce, tr, 0, Sr.length), tr += Sr.length;
          }
          return this.latestBufferOffset && this.latestBuffer.copy(Ce, tr, 0, this.latestBufferOffset), this.stringFormat ? Ce.toString(this.stringFormat) : Ce;
        }, typeof Buffer$f == "function" && (or.addReader(function(Ce, tr) {
          if (Buffer$f.isBuffer(Ce))
            return new lr(Ce);
          if (tr === "hex" || tr === "base64") {
            var Fe = Buffer$f.from(Ce, tr);
            return new lr(Fe);
          }
        }), or.addWriter(function(Ce) {
          if (!Ce || Ce === "buffer")
            return new Ir();
          if (Ce === "hex" || Ce === "base64")
            return new Ir(Ce);
        }));
        function xr(Ce) {
          this.hex = Ce, this.pos = 0;
        }
        xr.prototype = Object.create(F.prototype), xr.prototype.peekByte = function() {
          var Ce = this.hex.substring(this.pos, 2);
          return parseInt(Ce, 16);
        }, xr.prototype.readByte = function() {
          var Ce = this.hex.substring(this.pos, this.pos + 2);
          return this.pos += 2, parseInt(Ce, 16);
        }, xr.prototype.readChunk = function(Ce) {
          var tr = this.hex.substring(this.pos, this.pos + Ce * 2);
          return this.pos += Ce * 2, typeof Buffer$f == "function" ? Buffer$f.from(tr, "hex") : new p(tr);
        };
        function kr(Ce) {
          this.$hex = "", this.finalFormat = Ce || "hex";
        }
        return kr.prototype = Object.create(le.prototype), kr.prototype.writeByte = function(Ce) {
          if (Ce < 0 || Ce > 255)
            throw new Error("Byte value out of range: " + Ce);
          var tr = Ce.toString(16);
          tr.length == 1 && (tr = "0" + tr), this.$hex += tr;
        }, kr.prototype.canWriteBinary = function(Ce) {
          return Ce instanceof p || typeof Buffer$f == "function" && Ce instanceof Buffer$f;
        }, kr.prototype.writeBinary = function(Ce, tr) {
          if (Ce instanceof p)
            tr(Ce.length()), this.$hex += Ce.$hex;
          else if (typeof Buffer$f == "function" && Ce instanceof Buffer$f)
            tr(Ce.length), this.$hex += Ce.toString("hex");
          else
            throw new TypeError("HexWriter only accepts BinaryHex or Buffers");
        }, kr.prototype.result = function() {
          return this.finalFormat === "buffer" && typeof Buffer$f == "function" ? Buffer$f.from(this.$hex, "hex") : new p(this.$hex).toString(this.finalFormat);
        }, kr.prototype.writeString = function(Ce, tr) {
          var Fe = p.fromUtf8String(Ce);
          tr(Fe.length()), this.$hex += Fe.$hex;
        }, or.addReader(function(Ce, tr) {
          if (Ce instanceof p || Ce.$hex)
            return new xr(Ce.$hex);
          if (tr === "hex")
            return new xr(Ce);
        }), or.addWriter(function(Ce) {
          if (Ce === "hex")
            return new kr();
        }), or;
      }();
      return u.addSemanticEncode(0, function(p) {
        if (p instanceof Date)
          return p.toISOString();
      }).addSemanticDecode(0, function(p) {
        return new Date(p);
      }).addSemanticDecode(1, function(p) {
        return new Date(p);
      }), u;
    });
  }(cborSync$6)), cborSync$6.exports;
}
var hasRequiredLib$6;
function requireLib$6() {
  return hasRequiredLib$6 || (hasRequiredLib$6 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.DataItem = n.addWriter = n.addReader = n.addSemanticEncode = n.addSemanticDecode = n.decodeToDataItem = n.encodeDataItem = void 0;
    var c = requireCborSync$6();
    Object.defineProperty(n, "encodeDataItem", { enumerable: !0, get: function() {
      return c.encodeDataItem;
    } }), Object.defineProperty(n, "decodeToDataItem", { enumerable: !0, get: function() {
      return c.decodeToDataItem;
    } }), Object.defineProperty(n, "addSemanticDecode", { enumerable: !0, get: function() {
      return c.addSemanticDecode;
    } }), Object.defineProperty(n, "addSemanticEncode", { enumerable: !0, get: function() {
      return c.addSemanticEncode;
    } }), Object.defineProperty(n, "addReader", { enumerable: !0, get: function() {
      return c.addReader;
    } }), Object.defineProperty(n, "addWriter", { enumerable: !0, get: function() {
      return c.addWriter;
    } });
    var u = requireDataItem$6();
    Object.defineProperty(n, "DataItem", { enumerable: !0, get: function() {
      return u.DataItem;
    } });
  }(lib$8)), lib$8;
}
var hasRequiredUtils$6;
function requireUtils$6() {
  if (hasRequiredUtils$6) return utils$b;
  hasRequiredUtils$6 = 1, Object.defineProperty(utils$b, "__esModule", { value: !0 }), utils$b.patchTags = void 0;
  const n = requireLib$6(), c = [], u = (p) => {
    p.forEach((a) => {
      c.find((A) => A === a) || ((0, n.addSemanticEncode)(a, (A) => {
        if (A instanceof n.DataItem && A.getTag() === a)
          return A.getData();
      }), (0, n.addSemanticDecode)(a, (A) => new n.DataItem(A, a)), c.push(a));
    });
  };
  return utils$b.patchTags = u, utils$b;
}
var RegistryType$6 = {}, hasRequiredRegistryType$6;
function requireRegistryType$6() {
  if (hasRequiredRegistryType$6) return RegistryType$6;
  hasRequiredRegistryType$6 = 1, Object.defineProperty(RegistryType$6, "__esModule", { value: !0 }), RegistryType$6.RegistryTypes = RegistryType$6.RegistryType = void 0;
  class n {
    constructor(u, p) {
      this.type = u, this.tag = p, this.getTag = () => this.tag, this.getType = () => this.type;
    }
  }
  return RegistryType$6.RegistryType = n, RegistryType$6.RegistryTypes = {
    UUID: new n("uuid", 37),
    BYTES: new n("bytes", void 0),
    CRYPTO_HDKEY: new n("crypto-hdkey", 303),
    CRYPTO_KEYPATH: new n("crypto-keypath", 304),
    CRYPTO_COIN_INFO: new n("crypto-coin-info", 305),
    CRYPTO_ECKEY: new n("crypto-eckey", 306),
    CRYPTO_OUTPUT: new n("crypto-output", 308),
    CRYPTO_PSBT: new n("crypto-psbt", 310),
    CRYPTO_ACCOUNT: new n("crypto-account", 311),
    CRYPTO_MULTI_ACCOUNTS: new n("crypto-multi-accounts", 1103),
    QR_HARDWARE_CALL: new n("qr-hardware-call", 1201),
    KEY_DERIVATION_CALL: new n("key-derivation-call", 1301),
    KEY_DERIVATION_SCHEMA: new n("key-derivation-schema", 1302)
  }, RegistryType$6;
}
var ScriptExpression$6 = {}, hasRequiredScriptExpression$6;
function requireScriptExpression$6() {
  return hasRequiredScriptExpression$6 || (hasRequiredScriptExpression$6 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.ScriptExpressions = n.ScriptExpression = void 0;
    class c {
      constructor(p, a) {
        this.tag = p, this.expression = a, this.getTag = () => this.tag, this.getExpression = () => this.expression;
      }
    }
    n.ScriptExpression = c, c.fromTag = (u) => Object.values(n.ScriptExpressions).find((a) => a.getTag() === u), n.ScriptExpressions = {
      SCRIPT_HASH: new c(400, "sh"),
      WITNESS_SCRIPT_HASH: new c(401, "wsh"),
      PUBLIC_KEY: new c(402, "pk"),
      PUBLIC_KEY_HASH: new c(403, "pkh"),
      WITNESS_PUBLIC_KEY_HASH: new c(404, "wpkh"),
      COMBO: new c(405, "combo"),
      MULTISIG: new c(406, "multi"),
      SORTED_MULTISIG: new c(407, "sortedmulti"),
      ADDRESS: new c(307, "addr"),
      RAW_SCRIPT: new c(408, "raw")
    };
  }(ScriptExpression$6)), ScriptExpression$6;
}
var hasRequiredPatchCBOR$6;
function requirePatchCBOR$6() {
  if (hasRequiredPatchCBOR$6) return patchCBOR$6;
  hasRequiredPatchCBOR$6 = 1, Object.defineProperty(patchCBOR$6, "__esModule", { value: !0 });
  const n = requireUtils$6(), c = requireRegistryType$6(), u = requireScriptExpression$6(), p = Object.values(c.RegistryTypes).filter((A) => !!A.getTag()).map((A) => A.getTag()), a = Object.values(u.ScriptExpressions).map((A) => A.getTag());
  return (0, n.patchTags)(p.concat(a)), patchCBOR$6;
}
var CryptoHDKey$6 = {}, src$a, hasRequiredSrc$6;
function requireSrc$6() {
  if (hasRequiredSrc$6) return src$a;
  hasRequiredSrc$6 = 1;
  var n = safeBufferExports.Buffer;
  function c(u) {
    if (u.length >= 255)
      throw new TypeError("Alphabet too long");
    for (var p = new Uint8Array(256), a = 0; a < p.length; a++)
      p[a] = 255;
    for (var A = 0; A < u.length; A++) {
      var b = u.charAt(A), F = b.charCodeAt(0);
      if (p[F] !== 255)
        throw new TypeError(b + " is ambiguous");
      p[F] = A;
    }
    var le = u.length, L = u.charAt(0), pe = Math.log(le) / Math.log(256), $ = Math.log(256) / Math.log(le);
    function Ee(Pe) {
      if ((Array.isArray(Pe) || Pe instanceof Uint8Array) && (Pe = n.from(Pe)), !n.isBuffer(Pe))
        throw new TypeError("Expected Buffer");
      if (Pe.length === 0)
        return "";
      for (var nr = 0, ir = 0, or = 0, lr = Pe.length; or !== lr && Pe[or] === 0; )
        or++, nr++;
      for (var Ir = (lr - or) * $ + 1 >>> 0, xr = new Uint8Array(Ir); or !== lr; ) {
        for (var kr = Pe[or], Ce = 0, tr = Ir - 1; (kr !== 0 || Ce < ir) && tr !== -1; tr--, Ce++)
          kr += 256 * xr[tr] >>> 0, xr[tr] = kr % le >>> 0, kr = kr / le >>> 0;
        if (kr !== 0)
          throw new Error("Non-zero carry");
        ir = Ce, or++;
      }
      for (var Fe = Ir - ir; Fe !== Ir && xr[Fe] === 0; )
        Fe++;
      for (var Sr = L.repeat(nr); Fe < Ir; ++Fe)
        Sr += u.charAt(xr[Fe]);
      return Sr;
    }
    function be(Pe) {
      if (typeof Pe != "string")
        throw new TypeError("Expected String");
      if (Pe.length === 0)
        return n.alloc(0);
      for (var nr = 0, ir = 0, or = 0; Pe[nr] === L; )
        ir++, nr++;
      for (var lr = (Pe.length - nr) * pe + 1 >>> 0, Ir = new Uint8Array(lr); nr < Pe.length; ) {
        var xr = Pe.charCodeAt(nr);
        if (xr > 255)
          return;
        var kr = p[xr];
        if (kr === 255)
          return;
        for (var Ce = 0, tr = lr - 1; (kr !== 0 || Ce < or) && tr !== -1; tr--, Ce++)
          kr += le * Ir[tr] >>> 0, Ir[tr] = kr % 256 >>> 0, kr = kr / 256 >>> 0;
        if (kr !== 0)
          throw new Error("Non-zero carry");
        or = Ce, nr++;
      }
      for (var Fe = lr - or; Fe !== lr && Ir[Fe] === 0; )
        Fe++;
      var Sr = n.allocUnsafe(ir + (lr - Fe));
      Sr.fill(0, 0, ir);
      for (var er = ir; Fe !== lr; )
        Sr[er++] = Ir[Fe++];
      return Sr;
    }
    function He(Pe) {
      var nr = be(Pe);
      if (nr)
        return nr;
      throw new Error("Non-base" + le + " character");
    }
    return {
      encode: Ee,
      decodeUnsafe: be,
      decode: He
    };
  }
  return src$a = c, src$a;
}
var bs58$7, hasRequiredBs58$6;
function requireBs58$6() {
  if (hasRequiredBs58$6) return bs58$7;
  hasRequiredBs58$6 = 1;
  var n = requireSrc$6(), c = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
  return bs58$7 = n(c), bs58$7;
}
var base$9, hasRequiredBase$6;
function requireBase$6() {
  if (hasRequiredBase$6) return base$9;
  hasRequiredBase$6 = 1;
  var n = requireBs58$6(), c = safeBufferExports.Buffer;
  return base$9 = function(u) {
    function p(F) {
      var le = u(F);
      return n.encode(c.concat([
        F,
        le
      ], F.length + 4));
    }
    function a(F) {
      var le = F.slice(0, -4), L = F.slice(-4), pe = u(le);
      if (!(L[0] ^ pe[0] | L[1] ^ pe[1] | L[2] ^ pe[2] | L[3] ^ pe[3]))
        return le;
    }
    function A(F) {
      var le = n.decodeUnsafe(F);
      if (le)
        return a(le);
    }
    function b(F) {
      var le = n.decode(F), L = a(le);
      if (!L) throw new Error("Invalid checksum");
      return L;
    }
    return {
      encode: p,
      decode: b,
      decodeUnsafe: A
    };
  }, base$9;
}
var bs58check$9, hasRequiredBs58check$6;
function requireBs58check$6() {
  if (hasRequiredBs58check$6) return bs58check$9;
  hasRequiredBs58check$6 = 1;
  var n = browser$a, c = requireBase$6();
  function u(p) {
    var a = n("sha256").update(p).digest();
    return n("sha256").update(a).digest();
  }
  return bs58check$9 = c(u), bs58check$9;
}
var CryptoCoinInfo$6 = {}, RegistryItem$6 = {}, hasRequiredRegistryItem$6;
function requireRegistryItem$6() {
  if (hasRequiredRegistryItem$6) return RegistryItem$6;
  hasRequiredRegistryItem$6 = 1, Object.defineProperty(RegistryItem$6, "__esModule", { value: !0 }), RegistryItem$6.RegistryItem = void 0;
  const n = dist$t, c = requireLib$6();
  class u {
    constructor() {
      this.toCBOR = () => {
        if (this.toDataItem() === void 0)
          throw new Error(`#[ur-registry][RegistryItem][fn.toCBOR]: registry ${this.getRegistryType()}'s method toDataItem returns undefined`);
        return (0, c.encodeDataItem)(this.toDataItem());
      }, this.toUR = () => new n.UR(this.toCBOR(), this.getRegistryType().getType()), this.toUREncoder = (a, A, b) => {
        const F = this.toUR();
        return new n.UREncoder(F, a, A, b);
      };
    }
  }
  return RegistryItem$6.RegistryItem = u, RegistryItem$6;
}
var hasRequiredCryptoCoinInfo$6;
function requireCryptoCoinInfo$6() {
  return hasRequiredCryptoCoinInfo$6 || (hasRequiredCryptoCoinInfo$6 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.CryptoCoinInfo = n.Network = n.Type = void 0;
    const c = requireLib$6(), u = requireRegistryItem$6(), p = requireRegistryType$6();
    var a;
    (function(le) {
      le.type = "1", le.network = "2";
    })(a || (a = {}));
    var A;
    (function(le) {
      le[le.bitcoin = 0] = "bitcoin";
    })(A = n.Type || (n.Type = {}));
    var b;
    (function(le) {
      le[le.mainnet = 0] = "mainnet", le[le.testnet = 1] = "testnet";
    })(b = n.Network || (n.Network = {}));
    class F extends u.RegistryItem {
      constructor(L, pe) {
        super(), this.type = L, this.network = pe, this.getRegistryType = () => p.RegistryTypes.CRYPTO_COIN_INFO, this.getType = () => this.type || A.bitcoin, this.getNetwork = () => this.network || b.mainnet, this.toDataItem = () => {
          const $ = {};
          return this.type && ($[a.type] = this.type), this.network && ($[a.network] = this.network), new c.DataItem($);
        };
      }
    }
    n.CryptoCoinInfo = F, F.fromDataItem = (le) => {
      const L = le.getData(), pe = L[a.type], $ = L[a.network];
      return new F(pe, $);
    }, F.fromCBOR = (le) => {
      const L = (0, c.decodeToDataItem)(le);
      return F.fromDataItem(L);
    };
  }(CryptoCoinInfo$6)), CryptoCoinInfo$6;
}
var CryptoKeypath$6 = {}, PathComponent$6 = {}, hasRequiredPathComponent$6;
function requirePathComponent$6() {
  if (hasRequiredPathComponent$6) return PathComponent$6;
  hasRequiredPathComponent$6 = 1, Object.defineProperty(PathComponent$6, "__esModule", { value: !0 }), PathComponent$6.PathComponent = void 0;
  class n {
    constructor(u) {
      if (this.getIndex = () => this.index, this.isWildcard = () => this.wildcard, this.isHardened = () => this.hardened, this.index = u.index, this.hardened = u.hardened, this.index !== void 0 ? this.wildcard = !1 : this.wildcard = !0, this.index && this.index & n.HARDENED_BIT)
        throw new Error(`#[ur-registry][PathComponent][fn.constructor]: Invalid index ${this.index} - most significant bit cannot be set`);
    }
  }
  return PathComponent$6.PathComponent = n, n.HARDENED_BIT = 2147483648, PathComponent$6;
}
var hasRequiredCryptoKeypath$6;
function requireCryptoKeypath$6() {
  if (hasRequiredCryptoKeypath$6) return CryptoKeypath$6;
  hasRequiredCryptoKeypath$6 = 1, Object.defineProperty(CryptoKeypath$6, "__esModule", { value: !0 }), CryptoKeypath$6.CryptoKeypath = void 0;
  const n = requireLib$6(), c = requirePathComponent$6(), u = requireRegistryItem$6(), p = requireRegistryType$6();
  var a;
  (function(b) {
    b[b.components = 1] = "components", b[b.source_fingerprint = 2] = "source_fingerprint", b[b.depth = 3] = "depth";
  })(a || (a = {}));
  class A extends u.RegistryItem {
    constructor(F = [], le, L) {
      super(), this.components = F, this.sourceFingerprint = le, this.depth = L, this.getRegistryType = () => p.RegistryTypes.CRYPTO_KEYPATH, this.getPath = () => this.components.length === 0 ? void 0 : this.components.map(($) => `${$.isWildcard() ? "*" : $.getIndex()}${$.isHardened() ? "'" : ""}`).join("/"), this.getComponents = () => this.components, this.getSourceFingerprint = () => this.sourceFingerprint, this.getDepth = () => this.depth, this.toDataItem = () => {
        const pe = {}, $ = [];
        return this.components && this.components.forEach((Ee) => {
          Ee.isWildcard() ? $.push([]) : $.push(Ee.getIndex()), $.push(Ee.isHardened());
        }), pe[a.components] = $, this.sourceFingerprint && (pe[a.source_fingerprint] = this.sourceFingerprint.readUInt32BE(0)), this.depth !== void 0 && (pe[a.depth] = this.depth), new n.DataItem(pe);
      };
    }
  }
  return CryptoKeypath$6.CryptoKeypath = A, A.fromDataItem = (b) => {
    const F = b.getData(), le = [], L = F[a.components];
    if (L)
      for (let be = 0; be < L.length; be += 2) {
        const He = L[be + 1], Pe = L[be];
        typeof Pe == "number" ? le.push(new c.PathComponent({ index: Pe, hardened: He })) : le.push(new c.PathComponent({ hardened: He }));
      }
    const pe = F[a.source_fingerprint];
    let $;
    pe && ($ = Buffer$f.alloc(4), $.writeUInt32BE(pe, 0));
    const Ee = F[a.depth];
    return new A(le, $, Ee);
  }, A.fromCBOR = (b) => {
    const F = (0, n.decodeToDataItem)(b);
    return A.fromDataItem(F);
  }, CryptoKeypath$6;
}
var hasRequiredCryptoHDKey$6;
function requireCryptoHDKey$6() {
  if (hasRequiredCryptoHDKey$6) return CryptoHDKey$6;
  hasRequiredCryptoHDKey$6 = 1, Object.defineProperty(CryptoHDKey$6, "__esModule", { value: !0 }), CryptoHDKey$6.CryptoHDKey = void 0;
  const n = requireBs58check$6(), c = requireCryptoCoinInfo$6(), u = requireCryptoKeypath$6(), p = requireLib$6(), a = requireRegistryItem$6(), A = requireRegistryType$6();
  var b;
  (function(le) {
    le[le.is_master = 1] = "is_master", le[le.is_private = 2] = "is_private", le[le.key_data = 3] = "key_data", le[le.chain_code = 4] = "chain_code", le[le.use_info = 5] = "use_info", le[le.origin = 6] = "origin", le[le.children = 7] = "children", le[le.parent_fingerprint = 8] = "parent_fingerprint", le[le.name = 9] = "name", le[le.note = 10] = "note";
  })(b || (b = {}));
  class F extends a.RegistryItem {
    constructor(L) {
      super(), this.isECKey = () => !1, this.getKey = () => this.key, this.getChainCode = () => this.chainCode, this.isMaster = () => this.master, this.isPrivateKey = () => !!this.privateKey, this.getUseInfo = () => this.useInfo, this.getOrigin = () => this.origin, this.getChildren = () => this.children, this.getParentFingerprint = () => this.parentFingerprint, this.getName = () => this.name, this.getNote = () => this.note, this.getBip32Key = () => {
        var pe, $, Ee;
        let be, He, Pe = 0, nr = Buffer$f.alloc(4).fill(0);
        if (this.isMaster())
          be = Buffer$f.from("0488ADE4", "hex"), He = 0, Pe = 0;
        else {
          He = ((pe = this.getOrigin()) === null || pe === void 0 ? void 0 : pe.getComponents().length) || (($ = this.getOrigin()) === null || $ === void 0 ? void 0 : $.getDepth());
          const xr = (Ee = this.getOrigin()) === null || Ee === void 0 ? void 0 : Ee.getComponents(), kr = xr[xr.length - 1];
          kr && (Pe = kr.isHardened() ? kr.getIndex() + 2147483648 : kr.getIndex(), this.getParentFingerprint() && (nr = this.getParentFingerprint())), this.isPrivateKey() ? be = Buffer$f.from("0488ADE4", "hex") : be = Buffer$f.from("0488B21E", "hex");
        }
        const ir = Buffer$f.alloc(1);
        ir.writeUInt8(He, 0);
        const or = Buffer$f.alloc(4);
        or.writeUInt32BE(Pe, 0);
        const lr = this.getChainCode(), Ir = this.getKey();
        return (0, n.encode)(Buffer$f.concat([be, ir, nr, or, lr, Ir]));
      }, this.getRegistryType = () => A.RegistryTypes.CRYPTO_HDKEY, this.getOutputDescriptorContent = () => {
        var pe, $, Ee, be, He, Pe, nr;
        let ir = "";
        return this.getOrigin() && !((pe = this.getOrigin()) === null || pe === void 0) && pe.getSourceFingerprint() && !(($ = this.getOrigin()) === null || $ === void 0) && $.getPath() && (ir += `${(be = (Ee = this.getOrigin()) === null || Ee === void 0 ? void 0 : Ee.getSourceFingerprint()) === null || be === void 0 ? void 0 : be.toString("hex")}/${(He = this.getOrigin()) === null || He === void 0 ? void 0 : He.getPath()}`), ir += this.getBip32Key(), this.getChildren() && !((Pe = this.getChildren()) === null || Pe === void 0) && Pe.getPath() && (ir += `/${(nr = this.getChildren()) === null || nr === void 0 ? void 0 : nr.getPath()}`), ir;
      }, this.setupMasterKey = (pe) => {
        this.master = !0, this.key = pe.key, this.chainCode = pe.chainCode;
      }, this.setupDeriveKey = (pe) => {
        this.master = !1, this.privateKey = pe.isPrivateKey, this.key = pe.key, this.chainCode = pe.chainCode, this.useInfo = pe.useInfo, this.origin = pe.origin, this.children = pe.children, this.parentFingerprint = pe.parentFingerprint, this.name = pe.name, this.note = pe.note;
      }, this.toDataItem = () => {
        const pe = {};
        if (this.master)
          pe[b.is_master] = !0, pe[b.key_data] = this.key, pe[b.chain_code] = this.chainCode;
        else {
          if (this.privateKey !== void 0 && (pe[b.is_private] = this.privateKey), pe[b.key_data] = this.key, this.chainCode && (pe[b.chain_code] = this.chainCode), this.useInfo) {
            const $ = this.useInfo.toDataItem();
            $.setTag(this.useInfo.getRegistryType().getTag()), pe[b.use_info] = $;
          }
          if (this.origin) {
            const $ = this.origin.toDataItem();
            $.setTag(this.origin.getRegistryType().getTag()), pe[b.origin] = $;
          }
          if (this.children) {
            const $ = this.children.toDataItem();
            $.setTag(this.children.getRegistryType().getTag()), pe[b.children] = $;
          }
          this.parentFingerprint && (pe[b.parent_fingerprint] = this.parentFingerprint.readUInt32BE(0)), this.name !== void 0 && (pe[b.name] = this.name), this.note !== void 0 && (pe[b.note] = this.note);
        }
        return new p.DataItem(pe);
      }, L.isMaster ? this.setupMasterKey(L) : this.setupDeriveKey(L);
    }
  }
  return CryptoHDKey$6.CryptoHDKey = F, F.fromDataItem = (le) => {
    const L = le.getData(), pe = !!L[b.is_master], $ = L[b.is_private], Ee = L[b.key_data], be = L[b.chain_code], He = L[b.use_info] ? c.CryptoCoinInfo.fromDataItem(L[b.use_info]) : void 0, Pe = L[b.origin] ? u.CryptoKeypath.fromDataItem(L[b.origin]) : void 0, nr = L[b.children] ? u.CryptoKeypath.fromDataItem(L[b.children]) : void 0, ir = L[b.parent_fingerprint];
    let or;
    ir && (or = Buffer$f.alloc(4), or.writeUInt32BE(ir, 0));
    const lr = L[b.name], Ir = L[b.note];
    return new F({
      isMaster: pe,
      isPrivateKey: $,
      key: Ee,
      chainCode: be,
      useInfo: He,
      origin: Pe,
      children: nr,
      parentFingerprint: or,
      name: lr,
      note: Ir
    });
  }, F.fromCBOR = (le) => {
    const L = (0, p.decodeToDataItem)(le);
    return F.fromDataItem(L);
  }, CryptoHDKey$6;
}
var CryptoECKey$6 = {}, hasRequiredCryptoECKey$6;
function requireCryptoECKey$6() {
  if (hasRequiredCryptoECKey$6) return CryptoECKey$6;
  hasRequiredCryptoECKey$6 = 1, Object.defineProperty(CryptoECKey$6, "__esModule", { value: !0 }), CryptoECKey$6.CryptoECKey = void 0;
  const n = requireLib$6(), c = requireRegistryItem$6(), u = requireRegistryType$6();
  var p;
  (function(A) {
    A[A.curve = 1] = "curve", A[A.private = 2] = "private", A[A.data = 3] = "data";
  })(p || (p = {}));
  class a extends c.RegistryItem {
    constructor(b) {
      super(), this.isECKey = () => !0, this.getCurve = () => this.curve || 0, this.isPrivateKey = () => this.privateKey || !1, this.getData = () => this.data, this.getRegistryType = () => u.RegistryTypes.CRYPTO_ECKEY, this.toDataItem = () => {
        const F = {};
        return this.curve && (F[p.curve] = this.curve), this.privateKey !== void 0 && (F[p.private] = this.privateKey), F[p.data] = this.data, new n.DataItem(F);
      }, this.getOutputDescriptorContent = () => this.data.toString("hex"), this.data = b.data, this.curve = b.curve, this.privateKey = b.privateKey || void 0;
    }
  }
  return CryptoECKey$6.CryptoECKey = a, a.fromDataItem = (A) => {
    const b = A.getData(), F = b[p.curve], le = b[p.private], L = b[p.data];
    if (!L)
      throw new Error(`#[ur-registry][CryptoECKey][fn.fromDataItem]: decoded [dataItem][#data.data] is undefined: ${A}`);
    return new a({ data: L, curve: F, privateKey: le });
  }, a.fromCBOR = (A) => {
    const b = (0, n.decodeToDataItem)(A);
    return a.fromDataItem(b);
  }, CryptoECKey$6;
}
var Bytes$7 = {}, hasRequiredBytes$6;
function requireBytes$6() {
  if (hasRequiredBytes$6) return Bytes$7;
  hasRequiredBytes$6 = 1, Object.defineProperty(Bytes$7, "__esModule", { value: !0 }), Bytes$7.Bytes = void 0;
  const n = requireLib$6(), c = requireRegistryItem$6(), u = requireRegistryType$6();
  class p extends c.RegistryItem {
    constructor(A) {
      super(), this.bytes = A, this.getRegistryType = () => u.RegistryTypes.BYTES, this.getData = () => this.bytes, this.toDataItem = () => new n.DataItem(this.bytes);
    }
  }
  return Bytes$7.Bytes = p, p.fromDataItem = (a) => {
    const A = a.getData();
    if (!A)
      throw new Error(`#[ur-registry][Bytes][fn.fromDataItem]: decoded [dataItem][#data] is undefined: ${a}`);
    return new p(A);
  }, p.fromCBOR = (a) => {
    const A = (0, n.decodeToDataItem)(a);
    return p.fromDataItem(A);
  }, Bytes$7;
}
var CryptoOutput$6 = {}, MultiKey$6 = {}, hasRequiredMultiKey$6;
function requireMultiKey$6() {
  if (hasRequiredMultiKey$6) return MultiKey$6;
  hasRequiredMultiKey$6 = 1, Object.defineProperty(MultiKey$6, "__esModule", { value: !0 }), MultiKey$6.MultiKey = void 0;
  const n = requireCryptoECKey$6(), c = requireCryptoHDKey$6(), u = requireDataItem$6(), p = requireRegistryItem$6(), a = requireRegistryType$6();
  var A;
  (function(F) {
    F[F.threshold = 1] = "threshold", F[F.keys = 2] = "keys";
  })(A || (A = {}));
  class b extends p.RegistryItem {
    constructor(le, L) {
      super(), this.threshold = le, this.keys = L, this.getThreshold = () => this.threshold, this.getKeys = () => this.keys, this.toDataItem = () => {
        const pe = {};
        pe[A.threshold] = this.threshold;
        const $ = this.keys.map((Ee) => {
          const be = Ee.toDataItem();
          return be.setTag(Ee.getRegistryType().getTag()), be;
        });
        return pe[A.keys] = $, new u.DataItem(pe);
      }, this.getOutputDescriptorContent = () => [
        this.getThreshold(),
        this.keys.map((pe) => pe.getOutputDescriptorContent()).join(",")
      ].join(",");
    }
  }
  return MultiKey$6.MultiKey = b, b.fromDataItem = (F) => {
    const le = F.getData(), L = le[A.threshold], pe = le[A.keys], $ = [];
    return pe.forEach((Ee) => {
      Ee.getTag() === a.RegistryTypes.CRYPTO_HDKEY.getTag() ? $.push(c.CryptoHDKey.fromDataItem(Ee)) : Ee.getTag() === a.RegistryTypes.CRYPTO_ECKEY.getTag() && $.push(n.CryptoECKey.fromDataItem(Ee));
    }), new b(L, $);
  }, MultiKey$6;
}
var hasRequiredCryptoOutput$6;
function requireCryptoOutput$6() {
  if (hasRequiredCryptoOutput$6) return CryptoOutput$6;
  hasRequiredCryptoOutput$6 = 1, Object.defineProperty(CryptoOutput$6, "__esModule", { value: !0 }), CryptoOutput$6.CryptoOutput = void 0;
  const n = requireCryptoECKey$6(), c = requireCryptoHDKey$6(), u = requireLib$6(), p = requireMultiKey$6(), a = requireRegistryItem$6(), A = requireRegistryType$6(), b = requireScriptExpression$6();
  class F extends a.RegistryItem {
    constructor(L, pe) {
      super(), this.scriptExpressions = L, this.cryptoKey = pe, this.getRegistryType = () => A.RegistryTypes.CRYPTO_OUTPUT, this.getCryptoKey = () => this.cryptoKey, this.getHDKey = () => {
        if (this.cryptoKey instanceof c.CryptoHDKey)
          return this.cryptoKey;
      }, this.getECKey = () => {
        if (this.cryptoKey instanceof n.CryptoECKey)
          return this.cryptoKey;
      }, this.getMultiKey = () => {
        if (this.cryptoKey instanceof p.MultiKey)
          return this.cryptoKey;
      }, this.getScriptExpressions = () => this.scriptExpressions, this._toOutputDescriptor = ($) => $ >= this.scriptExpressions.length ? this.cryptoKey.getOutputDescriptorContent() : `${this.scriptExpressions[$].getExpression()}(${this._toOutputDescriptor($ + 1)})`, this.toString = () => this._toOutputDescriptor(0), this.toDataItem = () => {
        let $ = this.cryptoKey.toDataItem();
        return (this.cryptoKey instanceof n.CryptoECKey || this.cryptoKey instanceof c.CryptoHDKey) && $.setTag(this.cryptoKey.getRegistryType().getTag()), [...this.scriptExpressions].reverse().forEach((be) => {
          const He = be.getTag();
          $.getTag() === void 0 ? $.setTag(He) : $ = new u.DataItem($, He);
        }), $;
      };
    }
  }
  return CryptoOutput$6.CryptoOutput = F, F.fromDataItem = (le) => {
    const L = [];
    let pe = le;
    for (; ; ) {
      let be = pe.getTag();
      const He = b.ScriptExpression.fromTag(be);
      if (He)
        if (L.push(He), pe.getData() instanceof u.DataItem)
          pe = pe.getData(), be = pe.getTag();
        else
          break;
      else
        break;
    }
    const $ = L.length;
    if ($ > 0 && (L[$ - 1].getExpression() === b.ScriptExpressions.MULTISIG.getExpression() || L[$ - 1].getExpression() === b.ScriptExpressions.SORTED_MULTISIG.getExpression())) {
      const be = p.MultiKey.fromDataItem(pe);
      return new F(L, be);
    }
    if (pe.getTag() === A.RegistryTypes.CRYPTO_HDKEY.getTag()) {
      const be = c.CryptoHDKey.fromDataItem(pe);
      return new F(L, be);
    } else {
      const be = n.CryptoECKey.fromDataItem(pe);
      return new F(L, be);
    }
  }, F.fromCBOR = (le) => {
    const L = (0, u.decodeToDataItem)(le);
    return F.fromDataItem(L);
  }, CryptoOutput$6;
}
var CryptoPSBT$6 = {}, hasRequiredCryptoPSBT$6;
function requireCryptoPSBT$6() {
  if (hasRequiredCryptoPSBT$6) return CryptoPSBT$6;
  hasRequiredCryptoPSBT$6 = 1, Object.defineProperty(CryptoPSBT$6, "__esModule", { value: !0 }), CryptoPSBT$6.CryptoPSBT = void 0;
  const n = requireLib$6(), c = requireRegistryItem$6(), u = requireRegistryType$6();
  class p extends c.RegistryItem {
    constructor(A) {
      super(), this.psbt = A, this.getRegistryType = () => u.RegistryTypes.CRYPTO_PSBT, this.getPSBT = () => this.psbt, this.toDataItem = () => new n.DataItem(this.psbt);
    }
  }
  return CryptoPSBT$6.CryptoPSBT = p, p.fromDataItem = (a) => {
    const A = a.getData();
    if (!A)
      throw new Error(`#[ur-registry][CryptoPSBT][fn.fromDataItem]: decoded [dataItem][#data] is undefined: ${a}`);
    return new p(A);
  }, p.fromCBOR = (a) => {
    const A = (0, n.decodeToDataItem)(a);
    return p.fromDataItem(A);
  }, CryptoPSBT$6;
}
var CryptoAccount$6 = {}, hasRequiredCryptoAccount$6;
function requireCryptoAccount$6() {
  if (hasRequiredCryptoAccount$6) return CryptoAccount$6;
  hasRequiredCryptoAccount$6 = 1, Object.defineProperty(CryptoAccount$6, "__esModule", { value: !0 }), CryptoAccount$6.CryptoAccount = void 0;
  const n = requireDist$6(), c = requireLib$6(), u = requireRegistryItem$6(), p = requireRegistryType$6();
  var a;
  (function(b) {
    b[b.masterFingerprint = 1] = "masterFingerprint", b[b.outputDescriptors = 2] = "outputDescriptors";
  })(a || (a = {}));
  class A extends u.RegistryItem {
    constructor(F, le) {
      super(), this.masterFingerprint = F, this.outputDescriptors = le, this.getRegistryType = () => p.RegistryTypes.CRYPTO_ACCOUNT, this.getMasterFingerprint = () => this.masterFingerprint, this.getOutputDescriptors = () => this.outputDescriptors, this.toDataItem = () => {
        const L = {};
        return this.masterFingerprint && (L[a.masterFingerprint] = this.masterFingerprint.readUInt32BE(0)), this.outputDescriptors && (L[a.outputDescriptors] = this.outputDescriptors.map((pe) => pe.toDataItem())), new c.DataItem(L);
      };
    }
  }
  return CryptoAccount$6.CryptoAccount = A, A.fromDataItem = (b) => {
    const F = b.getData(), le = Buffer$f.alloc(4), L = F[a.masterFingerprint];
    L && le.writeUInt32BE(L, 0);
    const $ = F[a.outputDescriptors].map((Ee) => n.CryptoOutput.fromDataItem(Ee));
    return new A(le, $);
  }, A.fromCBOR = (b) => {
    const F = (0, c.decodeToDataItem)(b);
    return A.fromDataItem(F);
  }, CryptoAccount$6;
}
var Decoder$6 = {}, errors$7 = {}, hasRequiredErrors$6;
function requireErrors$6() {
  if (hasRequiredErrors$6) return errors$7;
  hasRequiredErrors$6 = 1, Object.defineProperty(errors$7, "__esModule", { value: !0 }), errors$7.UnknownURTypeError = void 0;
  class n extends Error {
    constructor(u) {
      super(u);
    }
  }
  return errors$7.UnknownURTypeError = n, errors$7;
}
var hasRequiredDecoder$6;
function requireDecoder$6() {
  if (hasRequiredDecoder$6) return Decoder$6;
  hasRequiredDecoder$6 = 1, Object.defineProperty(Decoder$6, "__esModule", { value: !0 }), Decoder$6.URRegistryDecoder = void 0;
  const n = dist$t, c = requireDist$6(), u = requireRegistryType$6(), p = requireErrors$6();
  class a extends n.URDecoder {
    constructor() {
      super(...arguments), this.resultRegistryType = () => {
        const b = this.resultUR();
        switch (b.type) {
          case u.RegistryTypes.BYTES.getType():
            return c.Bytes.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_HDKEY.getType():
            return c.CryptoHDKey.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_KEYPATH.getType():
            return c.CryptoKeypath.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_COIN_INFO.getType():
            return c.CryptoCoinInfo.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_ECKEY.getType():
            return c.CryptoECKey.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_OUTPUT.getType():
            return c.CryptoOutput.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_PSBT.getType():
            return c.CryptoPSBT.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_ACCOUNT.getType():
            return c.CryptoAccount.fromCBOR(b.cbor);
          default:
            throw new p.UnknownURTypeError(`#[ur-registry][Decoder][fn.resultRegistryType]: registry type ${b.type} is not supported now`);
        }
      };
    }
  }
  return Decoder$6.URRegistryDecoder = a, Decoder$6;
}
var CryptoMultiAccounts$6 = {}, hasRequiredCryptoMultiAccounts$6;
function requireCryptoMultiAccounts$6() {
  if (hasRequiredCryptoMultiAccounts$6) return CryptoMultiAccounts$6;
  hasRequiredCryptoMultiAccounts$6 = 1, Object.defineProperty(CryptoMultiAccounts$6, "__esModule", { value: !0 }), CryptoMultiAccounts$6.CryptoMultiAccounts = void 0;
  const n = requireRegistryType$6(), c = requireCryptoHDKey$6(), u = requireRegistryItem$6(), p = requireLib$6();
  var a;
  (function(b) {
    b[b.masterFingerprint = 1] = "masterFingerprint", b[b.keys = 2] = "keys", b[b.device = 3] = "device", b[b.deviceId = 4] = "deviceId", b[b.version = 5] = "version";
  })(a || (a = {}));
  class A extends u.RegistryItem {
    constructor(F, le, L, pe, $) {
      super(), this.masterFingerprint = F, this.keys = le, this.device = L, this.deviceId = pe, this.version = $, this.getRegistryType = () => n.RegistryTypes.CRYPTO_MULTI_ACCOUNTS, this.getMasterFingerprint = () => this.masterFingerprint, this.getKeys = () => this.keys, this.getDevice = () => this.device, this.getDeviceId = () => this.deviceId, this.getVersion = () => this.version, this.toDataItem = () => {
        const Ee = {};
        return this.masterFingerprint && (Ee[a.masterFingerprint] = this.masterFingerprint.readUInt32BE(0)), this.keys && (Ee[a.keys] = this.keys.map((be) => {
          const He = be.toDataItem();
          return He.setTag(be.getRegistryType().getTag()), He;
        })), this.device && (Ee[a.device] = this.device), this.deviceId && (Ee[a.deviceId] = this.deviceId), this.version && (Ee[a.version] = this.version), new p.DataItem(Ee);
      };
    }
  }
  return CryptoMultiAccounts$6.CryptoMultiAccounts = A, A.fromDataItem = (b) => {
    const F = b.getData(), le = Buffer$f.alloc(4), L = F[a.masterFingerprint];
    L && le.writeUInt32BE(L, 0);
    const $ = F[a.keys].map((Pe) => c.CryptoHDKey.fromDataItem(Pe)), Ee = F[a.device], be = F[a.deviceId], He = F[a.version];
    return new A(le, $, Ee, be, He);
  }, A.fromCBOR = (b) => {
    const F = (0, p.decodeToDataItem)(b);
    return A.fromDataItem(F);
  }, CryptoMultiAccounts$6;
}
var QRHardwareCall$6 = {}, KeyDerivation$6 = {}, DerivationSchema$6 = {}, hasRequiredDerivationSchema$6;
function requireDerivationSchema$6() {
  return hasRequiredDerivationSchema$6 || (hasRequiredDerivationSchema$6 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.KeyDerivationSchema = n.DerivationAlgorithm = n.Curve = void 0;
    const c = requireRegistryType$6(), u = requireRegistryItem$6(), p = requireLib$6(), a = requireCryptoKeypath$6();
    var A;
    (function(L) {
      L[L.keyPath = 1] = "keyPath", L[L.curve = 2] = "curve", L[L.algo = 3] = "algo";
    })(A || (A = {}));
    var b;
    (function(L) {
      L[L.secp256k1 = 0] = "secp256k1", L[L.ed25519 = 1] = "ed25519";
    })(b = n.Curve || (n.Curve = {}));
    var F;
    (function(L) {
      L[L.slip10 = 0] = "slip10", L[L.bip32ed25519 = 1] = "bip32ed25519";
    })(F = n.DerivationAlgorithm || (n.DerivationAlgorithm = {}));
    class le extends u.RegistryItem {
      constructor(pe, $ = b.secp256k1, Ee = F.slip10) {
        super(), this.keypath = pe, this.curve = $, this.algo = Ee, this.getRegistryType = () => c.RegistryTypes.KEY_DERIVATION_SCHEMA, this.getKeypath = () => this.keypath, this.getCurve = () => this.curve, this.getAlgo = () => this.algo, this.toDataItem = () => {
          const be = {}, He = this.getKeypath().toDataItem();
          return He.setTag(this.getKeypath().getRegistryType().getTag()), be[A.keyPath] = He, be[A.curve] = this.curve, be[A.algo] = this.algo, new p.DataItem(be);
        };
      }
    }
    n.KeyDerivationSchema = le, le.fromDataItem = (L) => {
      const pe = L.getData(), $ = a.CryptoKeypath.fromDataItem(pe[A.keyPath]), Ee = pe[A.curve], be = pe[A.algo];
      return new le($, Ee, be);
    }, le.fromCBOR = (L) => {
      const pe = (0, p.decodeToDataItem)(L);
      return le.fromDataItem(pe);
    };
  }(DerivationSchema$6)), DerivationSchema$6;
}
var hasRequiredKeyDerivation$6;
function requireKeyDerivation$6() {
  if (hasRequiredKeyDerivation$6) return KeyDerivation$6;
  hasRequiredKeyDerivation$6 = 1, Object.defineProperty(KeyDerivation$6, "__esModule", { value: !0 }), KeyDerivation$6.KeyDerivation = void 0;
  const n = requireRegistryType$6(), c = requireRegistryItem$6(), u = requireLib$6(), p = requireDerivationSchema$6();
  var a;
  (function(b) {
    b[b.schemas = 1] = "schemas";
  })(a || (a = {}));
  class A extends c.RegistryItem {
    constructor(F) {
      super(), this.schemas = F, this.getRegistryType = () => n.RegistryTypes.KEY_DERIVATION_CALL, this.getSchemas = () => this.schemas, this.toDataItem = () => {
        const le = {};
        return le[a.schemas] = this.schemas.map((L) => {
          const pe = L.toDataItem();
          return pe.setTag(L.getRegistryType().getTag()), pe;
        }), new u.DataItem(le);
      };
    }
  }
  return KeyDerivation$6.KeyDerivation = A, A.fromDataItem = (b) => {
    const le = b.getData()[a.schemas].map((L) => p.KeyDerivationSchema.fromDataItem(L));
    return new A(le);
  }, A.fromCBOR = (b) => {
    const F = (0, u.decodeToDataItem)(b);
    return A.fromDataItem(F);
  }, KeyDerivation$6;
}
var hasRequiredQRHardwareCall$6;
function requireQRHardwareCall$6() {
  return hasRequiredQRHardwareCall$6 || (hasRequiredQRHardwareCall$6 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.QRHardwareCall = n.QRHardwareCallType = void 0;
    const c = requireRegistryType$6(), u = requireRegistryItem$6(), p = requireLib$6(), a = requireKeyDerivation$6();
    var A;
    (function(le) {
      le[le.type = 1] = "type", le[le.params = 2] = "params", le[le.origin = 3] = "origin";
    })(A || (A = {}));
    var b;
    (function(le) {
      le[le.KeyDerivation = 0] = "KeyDerivation";
    })(b = n.QRHardwareCallType || (n.QRHardwareCallType = {}));
    class F extends u.RegistryItem {
      constructor(L, pe, $) {
        super(), this.type = L, this.params = pe, this.origin = $, this.getRegistryType = () => c.RegistryTypes.QR_HARDWARE_CALL, this.getType = () => this.type, this.getParams = () => this.params, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const Ee = {};
          Ee[A.type] = this.type;
          const be = this.params.toDataItem();
          return be.setTag(this.params.getRegistryType().getTag()), Ee[A.params] = be, this.origin && (Ee[A.origin] = this.origin), new p.DataItem(Ee);
        };
      }
    }
    n.QRHardwareCall = F, F.fromDataItem = (le) => {
      const L = le.getData(), pe = L[A.type] || b.KeyDerivation;
      let $;
      switch (pe) {
        case b.KeyDerivation:
          $ = a.KeyDerivation.fromDataItem(L[A.params]);
      }
      const Ee = L[A.origin];
      return new F(pe, $, Ee);
    }, F.fromCBOR = (le) => {
      const L = (0, p.decodeToDataItem)(le);
      return F.fromDataItem(L);
    };
  }(QRHardwareCall$6)), QRHardwareCall$6;
}
var types$b = {}, hasRequiredTypes$6;
function requireTypes$6() {
  return hasRequiredTypes$6 || (hasRequiredTypes$6 = 1, Object.defineProperty(types$b, "__esModule", { value: !0 })), types$b;
}
var hasRequiredDist$6;
function requireDist$6() {
  return hasRequiredDist$6 || (hasRequiredDist$6 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.Buffer = n.extend = n.PathComponent = n.ScriptExpressions = n.MultiKey = n.CryptoPSBT = n.CryptoOutput = n.CryptoECKey = n.CryptoCoinInfoNetwork = n.CryptoCoinInfoType = n.CryptoCoinInfo = n.CryptoKeypath = n.CryptoMultiAccounts = n.CryptoHDKey = n.CryptoAccount = n.Bytes = n.URRegistryDecoder = n.DataItem = void 0;
    const c = require$$0$4;
    requirePatchCBOR$6();
    const u = dist$u;
    Object.defineProperty(n, "Buffer", { enumerable: !0, get: function() {
      return u.Buffer;
    } });
    const p = requireCryptoHDKey$6();
    Object.defineProperty(n, "CryptoHDKey", { enumerable: !0, get: function() {
      return p.CryptoHDKey;
    } });
    const a = requireCryptoKeypath$6();
    Object.defineProperty(n, "CryptoKeypath", { enumerable: !0, get: function() {
      return a.CryptoKeypath;
    } });
    const A = requireCryptoCoinInfo$6();
    Object.defineProperty(n, "CryptoCoinInfo", { enumerable: !0, get: function() {
      return A.CryptoCoinInfo;
    } }), Object.defineProperty(n, "CryptoCoinInfoType", { enumerable: !0, get: function() {
      return A.Type;
    } }), Object.defineProperty(n, "CryptoCoinInfoNetwork", { enumerable: !0, get: function() {
      return A.Network;
    } });
    const b = requireCryptoECKey$6();
    Object.defineProperty(n, "CryptoECKey", { enumerable: !0, get: function() {
      return b.CryptoECKey;
    } });
    const F = requireBytes$6();
    Object.defineProperty(n, "Bytes", { enumerable: !0, get: function() {
      return F.Bytes;
    } });
    const le = requireCryptoOutput$6();
    Object.defineProperty(n, "CryptoOutput", { enumerable: !0, get: function() {
      return le.CryptoOutput;
    } });
    const L = requireCryptoPSBT$6();
    Object.defineProperty(n, "CryptoPSBT", { enumerable: !0, get: function() {
      return L.CryptoPSBT;
    } });
    const pe = requireCryptoAccount$6();
    Object.defineProperty(n, "CryptoAccount", { enumerable: !0, get: function() {
      return pe.CryptoAccount;
    } });
    const $ = requireDecoder$6();
    Object.defineProperty(n, "URRegistryDecoder", { enumerable: !0, get: function() {
      return $.URRegistryDecoder;
    } });
    const Ee = requireMultiKey$6();
    Object.defineProperty(n, "MultiKey", { enumerable: !0, get: function() {
      return Ee.MultiKey;
    } });
    const be = requireScriptExpression$6();
    Object.defineProperty(n, "ScriptExpressions", { enumerable: !0, get: function() {
      return be.ScriptExpressions;
    } });
    const He = requirePathComponent$6();
    Object.defineProperty(n, "PathComponent", { enumerable: !0, get: function() {
      return He.PathComponent;
    } });
    const Pe = requireRegistryItem$6(), nr = requireRegistryType$6(), ir = requireLib$6();
    var or = requireLib$6();
    Object.defineProperty(n, "DataItem", { enumerable: !0, get: function() {
      return or.DataItem;
    } });
    const lr = requireUtils$6(), Ir = requireCryptoMultiAccounts$6();
    Object.defineProperty(n, "CryptoMultiAccounts", { enumerable: !0, get: function() {
      return Ir.CryptoMultiAccounts;
    } });
    const xr = {
      URRegistryDecoder: $.URRegistryDecoder,
      Bytes: F.Bytes,
      CryptoAccount: pe.CryptoAccount,
      CryptoHDKey: p.CryptoHDKey,
      CryptoMultiAccounts: Ir.CryptoMultiAccounts,
      CryptoKeypath: a.CryptoKeypath,
      CryptoCoinInfo: A.CryptoCoinInfo,
      CryptoCoinInfoType: A.Type,
      CryptoCoinInfoNetwork: A.Network,
      CryptoECKey: b.CryptoECKey,
      CryptoOutput: le.CryptoOutput,
      CryptoPSBT: L.CryptoPSBT,
      MultiKey: Ee.MultiKey,
      ScriptExpressions: be.ScriptExpressions,
      PathComponent: He.PathComponent
    }, kr = {
      addReader: ir.addReader,
      addSemanticDecode: ir.addSemanticDecode,
      addSemanticEncode: ir.addSemanticEncode,
      addWriter: ir.addWriter,
      patchTags: lr.patchTags
    }, Ce = {
      RegistryTypes: nr.RegistryTypes,
      RegistryItem: Pe.RegistryItem,
      RegistryType: nr.RegistryType,
      decodeToDataItem: ir.decodeToDataItem,
      encodeDataItem: ir.encodeDataItem,
      cbor: kr
    };
    n.extend = Ce, (0, c.__exportStar)(requireErrors$6(), n), (0, c.__exportStar)(requireDecoder$6(), n), (0, c.__exportStar)(requireLib$6(), n), (0, c.__exportStar)(requireCryptoAccount$6(), n), (0, c.__exportStar)(requireCryptoPSBT$6(), n), (0, c.__exportStar)(requireCryptoHDKey$6(), n), (0, c.__exportStar)(requireCryptoMultiAccounts$6(), n), (0, c.__exportStar)(requireQRHardwareCall$6(), n), (0, c.__exportStar)(requireKeyDerivation$6(), n), (0, c.__exportStar)(requireDerivationSchema$6(), n), (0, c.__exportStar)(requireCryptoOutput$6(), n), (0, c.__exportStar)(requireCryptoCoinInfo$6(), n), (0, c.__exportStar)(requireCryptoECKey$6(), n), (0, c.__exportStar)(requireMultiKey$6(), n), (0, c.__exportStar)(requireCryptoKeypath$6(), n), (0, c.__exportStar)(requirePatchCBOR$6(), n), (0, c.__exportStar)(requirePathComponent$6(), n), (0, c.__exportStar)(requireRegistryItem$6(), n), (0, c.__exportStar)(requireRegistryType$6(), n), (0, c.__exportStar)(requireTypes$6(), n), (0, c.__exportStar)(requireUtils$6(), n), n.default = xr;
  }(dist$g)), dist$g;
}
var getRandomValues$7, rnds8$5 = new Uint8Array(16);
function rng$7() {
  if (!getRandomValues$7 && (getRandomValues$7 = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !getRandomValues$7))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return getRandomValues$7(rnds8$5);
}
const REGEX$4 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function validate$7(n) {
  return typeof n == "string" && REGEX$4.test(n);
}
var byteToHex$5 = [];
for (var i$6 = 0; i$6 < 256; ++i$6)
  byteToHex$5.push((i$6 + 256).toString(16).substr(1));
function stringify$6(n) {
  var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, u = (byteToHex$5[n[c + 0]] + byteToHex$5[n[c + 1]] + byteToHex$5[n[c + 2]] + byteToHex$5[n[c + 3]] + "-" + byteToHex$5[n[c + 4]] + byteToHex$5[n[c + 5]] + "-" + byteToHex$5[n[c + 6]] + byteToHex$5[n[c + 7]] + "-" + byteToHex$5[n[c + 8]] + byteToHex$5[n[c + 9]] + "-" + byteToHex$5[n[c + 10]] + byteToHex$5[n[c + 11]] + byteToHex$5[n[c + 12]] + byteToHex$5[n[c + 13]] + byteToHex$5[n[c + 14]] + byteToHex$5[n[c + 15]]).toLowerCase();
  if (!validate$7(u))
    throw TypeError("Stringified UUID is invalid");
  return u;
}
var _nodeId$4, _clockseq$4, _lastMSecs$4 = 0, _lastNSecs$4 = 0;
function v1$6(n, c, u) {
  var p = c && u || 0, a = c || new Array(16);
  n = n || {};
  var A = n.node || _nodeId$4, b = n.clockseq !== void 0 ? n.clockseq : _clockseq$4;
  if (A == null || b == null) {
    var F = n.random || (n.rng || rng$7)();
    A == null && (A = _nodeId$4 = [F[0] | 1, F[1], F[2], F[3], F[4], F[5]]), b == null && (b = _clockseq$4 = (F[6] << 8 | F[7]) & 16383);
  }
  var le = n.msecs !== void 0 ? n.msecs : Date.now(), L = n.nsecs !== void 0 ? n.nsecs : _lastNSecs$4 + 1, pe = le - _lastMSecs$4 + (L - _lastNSecs$4) / 1e4;
  if (pe < 0 && n.clockseq === void 0 && (b = b + 1 & 16383), (pe < 0 || le > _lastMSecs$4) && n.nsecs === void 0 && (L = 0), L >= 1e4)
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  _lastMSecs$4 = le, _lastNSecs$4 = L, _clockseq$4 = b, le += 122192928e5;
  var $ = ((le & 268435455) * 1e4 + L) % 4294967296;
  a[p++] = $ >>> 24 & 255, a[p++] = $ >>> 16 & 255, a[p++] = $ >>> 8 & 255, a[p++] = $ & 255;
  var Ee = le / 4294967296 * 1e4 & 268435455;
  a[p++] = Ee >>> 8 & 255, a[p++] = Ee & 255, a[p++] = Ee >>> 24 & 15 | 16, a[p++] = Ee >>> 16 & 255, a[p++] = b >>> 8 | 128, a[p++] = b & 255;
  for (var be = 0; be < 6; ++be)
    a[p + be] = A[be];
  return c || stringify$6(a);
}
function parse$d(n) {
  if (!validate$7(n))
    throw TypeError("Invalid UUID");
  var c, u = new Uint8Array(16);
  return u[0] = (c = parseInt(n.slice(0, 8), 16)) >>> 24, u[1] = c >>> 16 & 255, u[2] = c >>> 8 & 255, u[3] = c & 255, u[4] = (c = parseInt(n.slice(9, 13), 16)) >>> 8, u[5] = c & 255, u[6] = (c = parseInt(n.slice(14, 18), 16)) >>> 8, u[7] = c & 255, u[8] = (c = parseInt(n.slice(19, 23), 16)) >>> 8, u[9] = c & 255, u[10] = (c = parseInt(n.slice(24, 36), 16)) / 1099511627776 & 255, u[11] = c / 4294967296 & 255, u[12] = c >>> 24 & 255, u[13] = c >>> 16 & 255, u[14] = c >>> 8 & 255, u[15] = c & 255, u;
}
function stringToBytes$5(n) {
  n = unescape(encodeURIComponent(n));
  for (var c = [], u = 0; u < n.length; ++u)
    c.push(n.charCodeAt(u));
  return c;
}
var DNS$4 = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", URL$5 = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
function v35$6(n, c, u) {
  function p(a, A, b, F) {
    if (typeof a == "string" && (a = stringToBytes$5(a)), typeof A == "string" && (A = parse$d(A)), A.length !== 16)
      throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    var le = new Uint8Array(16 + a.length);
    if (le.set(A), le.set(a, A.length), le = u(le), le[6] = le[6] & 15 | c, le[8] = le[8] & 63 | 128, b) {
      F = F || 0;
      for (var L = 0; L < 16; ++L)
        b[F + L] = le[L];
      return b;
    }
    return stringify$6(le);
  }
  try {
    p.name = n;
  } catch {
  }
  return p.DNS = DNS$4, p.URL = URL$5, p;
}
function md5$6(n) {
  if (typeof n == "string") {
    var c = unescape(encodeURIComponent(n));
    n = new Uint8Array(c.length);
    for (var u = 0; u < c.length; ++u)
      n[u] = c.charCodeAt(u);
  }
  return md5ToHexEncodedArray$4(wordsToMd5$4(bytesToWords$4(n), n.length * 8));
}
function md5ToHexEncodedArray$4(n) {
  for (var c = [], u = n.length * 32, p = "0123456789abcdef", a = 0; a < u; a += 8) {
    var A = n[a >> 5] >>> a % 32 & 255, b = parseInt(p.charAt(A >>> 4 & 15) + p.charAt(A & 15), 16);
    c.push(b);
  }
  return c;
}
function getOutputLength$4(n) {
  return (n + 64 >>> 9 << 4) + 14 + 1;
}
function wordsToMd5$4(n, c) {
  n[c >> 5] |= 128 << c % 32, n[getOutputLength$4(c) - 1] = c;
  for (var u = 1732584193, p = -271733879, a = -1732584194, A = 271733878, b = 0; b < n.length; b += 16) {
    var F = u, le = p, L = a, pe = A;
    u = md5ff$4(u, p, a, A, n[b], 7, -680876936), A = md5ff$4(A, u, p, a, n[b + 1], 12, -389564586), a = md5ff$4(a, A, u, p, n[b + 2], 17, 606105819), p = md5ff$4(p, a, A, u, n[b + 3], 22, -1044525330), u = md5ff$4(u, p, a, A, n[b + 4], 7, -176418897), A = md5ff$4(A, u, p, a, n[b + 5], 12, 1200080426), a = md5ff$4(a, A, u, p, n[b + 6], 17, -1473231341), p = md5ff$4(p, a, A, u, n[b + 7], 22, -45705983), u = md5ff$4(u, p, a, A, n[b + 8], 7, 1770035416), A = md5ff$4(A, u, p, a, n[b + 9], 12, -1958414417), a = md5ff$4(a, A, u, p, n[b + 10], 17, -42063), p = md5ff$4(p, a, A, u, n[b + 11], 22, -1990404162), u = md5ff$4(u, p, a, A, n[b + 12], 7, 1804603682), A = md5ff$4(A, u, p, a, n[b + 13], 12, -40341101), a = md5ff$4(a, A, u, p, n[b + 14], 17, -1502002290), p = md5ff$4(p, a, A, u, n[b + 15], 22, 1236535329), u = md5gg$4(u, p, a, A, n[b + 1], 5, -165796510), A = md5gg$4(A, u, p, a, n[b + 6], 9, -1069501632), a = md5gg$4(a, A, u, p, n[b + 11], 14, 643717713), p = md5gg$4(p, a, A, u, n[b], 20, -373897302), u = md5gg$4(u, p, a, A, n[b + 5], 5, -701558691), A = md5gg$4(A, u, p, a, n[b + 10], 9, 38016083), a = md5gg$4(a, A, u, p, n[b + 15], 14, -660478335), p = md5gg$4(p, a, A, u, n[b + 4], 20, -405537848), u = md5gg$4(u, p, a, A, n[b + 9], 5, 568446438), A = md5gg$4(A, u, p, a, n[b + 14], 9, -1019803690), a = md5gg$4(a, A, u, p, n[b + 3], 14, -187363961), p = md5gg$4(p, a, A, u, n[b + 8], 20, 1163531501), u = md5gg$4(u, p, a, A, n[b + 13], 5, -1444681467), A = md5gg$4(A, u, p, a, n[b + 2], 9, -51403784), a = md5gg$4(a, A, u, p, n[b + 7], 14, 1735328473), p = md5gg$4(p, a, A, u, n[b + 12], 20, -1926607734), u = md5hh$4(u, p, a, A, n[b + 5], 4, -378558), A = md5hh$4(A, u, p, a, n[b + 8], 11, -2022574463), a = md5hh$4(a, A, u, p, n[b + 11], 16, 1839030562), p = md5hh$4(p, a, A, u, n[b + 14], 23, -35309556), u = md5hh$4(u, p, a, A, n[b + 1], 4, -1530992060), A = md5hh$4(A, u, p, a, n[b + 4], 11, 1272893353), a = md5hh$4(a, A, u, p, n[b + 7], 16, -155497632), p = md5hh$4(p, a, A, u, n[b + 10], 23, -1094730640), u = md5hh$4(u, p, a, A, n[b + 13], 4, 681279174), A = md5hh$4(A, u, p, a, n[b], 11, -358537222), a = md5hh$4(a, A, u, p, n[b + 3], 16, -722521979), p = md5hh$4(p, a, A, u, n[b + 6], 23, 76029189), u = md5hh$4(u, p, a, A, n[b + 9], 4, -640364487), A = md5hh$4(A, u, p, a, n[b + 12], 11, -421815835), a = md5hh$4(a, A, u, p, n[b + 15], 16, 530742520), p = md5hh$4(p, a, A, u, n[b + 2], 23, -995338651), u = md5ii$4(u, p, a, A, n[b], 6, -198630844), A = md5ii$4(A, u, p, a, n[b + 7], 10, 1126891415), a = md5ii$4(a, A, u, p, n[b + 14], 15, -1416354905), p = md5ii$4(p, a, A, u, n[b + 5], 21, -57434055), u = md5ii$4(u, p, a, A, n[b + 12], 6, 1700485571), A = md5ii$4(A, u, p, a, n[b + 3], 10, -1894986606), a = md5ii$4(a, A, u, p, n[b + 10], 15, -1051523), p = md5ii$4(p, a, A, u, n[b + 1], 21, -2054922799), u = md5ii$4(u, p, a, A, n[b + 8], 6, 1873313359), A = md5ii$4(A, u, p, a, n[b + 15], 10, -30611744), a = md5ii$4(a, A, u, p, n[b + 6], 15, -1560198380), p = md5ii$4(p, a, A, u, n[b + 13], 21, 1309151649), u = md5ii$4(u, p, a, A, n[b + 4], 6, -145523070), A = md5ii$4(A, u, p, a, n[b + 11], 10, -1120210379), a = md5ii$4(a, A, u, p, n[b + 2], 15, 718787259), p = md5ii$4(p, a, A, u, n[b + 9], 21, -343485551), u = safeAdd$4(u, F), p = safeAdd$4(p, le), a = safeAdd$4(a, L), A = safeAdd$4(A, pe);
  }
  return [u, p, a, A];
}
function bytesToWords$4(n) {
  if (n.length === 0)
    return [];
  for (var c = n.length * 8, u = new Uint32Array(getOutputLength$4(c)), p = 0; p < c; p += 8)
    u[p >> 5] |= (n[p / 8] & 255) << p % 32;
  return u;
}
function safeAdd$4(n, c) {
  var u = (n & 65535) + (c & 65535), p = (n >> 16) + (c >> 16) + (u >> 16);
  return p << 16 | u & 65535;
}
function bitRotateLeft$4(n, c) {
  return n << c | n >>> 32 - c;
}
function md5cmn$4(n, c, u, p, a, A) {
  return safeAdd$4(bitRotateLeft$4(safeAdd$4(safeAdd$4(c, n), safeAdd$4(p, A)), a), u);
}
function md5ff$4(n, c, u, p, a, A, b) {
  return md5cmn$4(c & u | ~c & p, n, c, a, A, b);
}
function md5gg$4(n, c, u, p, a, A, b) {
  return md5cmn$4(c & p | u & ~p, n, c, a, A, b);
}
function md5hh$4(n, c, u, p, a, A, b) {
  return md5cmn$4(c ^ u ^ p, n, c, a, A, b);
}
function md5ii$4(n, c, u, p, a, A, b) {
  return md5cmn$4(u ^ (c | ~p), n, c, a, A, b);
}
var v3$6 = v35$6("v3", 48, md5$6);
function v4$7(n, c, u) {
  n = n || {};
  var p = n.random || (n.rng || rng$7)();
  if (p[6] = p[6] & 15 | 64, p[8] = p[8] & 63 | 128, c) {
    u = u || 0;
    for (var a = 0; a < 16; ++a)
      c[u + a] = p[a];
    return c;
  }
  return stringify$6(p);
}
function f$6(n, c, u, p) {
  switch (n) {
    case 0:
      return c & u ^ ~c & p;
    case 1:
      return c ^ u ^ p;
    case 2:
      return c & u ^ c & p ^ u & p;
    case 3:
      return c ^ u ^ p;
  }
}
function ROTL$4(n, c) {
  return n << c | n >>> 32 - c;
}
function sha1$6(n) {
  var c = [1518500249, 1859775393, 2400959708, 3395469782], u = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
  if (typeof n == "string") {
    var p = unescape(encodeURIComponent(n));
    n = [];
    for (var a = 0; a < p.length; ++a)
      n.push(p.charCodeAt(a));
  } else Array.isArray(n) || (n = Array.prototype.slice.call(n));
  n.push(128);
  for (var A = n.length / 4 + 2, b = Math.ceil(A / 16), F = new Array(b), le = 0; le < b; ++le) {
    for (var L = new Uint32Array(16), pe = 0; pe < 16; ++pe)
      L[pe] = n[le * 64 + pe * 4] << 24 | n[le * 64 + pe * 4 + 1] << 16 | n[le * 64 + pe * 4 + 2] << 8 | n[le * 64 + pe * 4 + 3];
    F[le] = L;
  }
  F[b - 1][14] = (n.length - 1) * 8 / Math.pow(2, 32), F[b - 1][14] = Math.floor(F[b - 1][14]), F[b - 1][15] = (n.length - 1) * 8 & 4294967295;
  for (var $ = 0; $ < b; ++$) {
    for (var Ee = new Uint32Array(80), be = 0; be < 16; ++be)
      Ee[be] = F[$][be];
    for (var He = 16; He < 80; ++He)
      Ee[He] = ROTL$4(Ee[He - 3] ^ Ee[He - 8] ^ Ee[He - 14] ^ Ee[He - 16], 1);
    for (var Pe = u[0], nr = u[1], ir = u[2], or = u[3], lr = u[4], Ir = 0; Ir < 80; ++Ir) {
      var xr = Math.floor(Ir / 20), kr = ROTL$4(Pe, 5) + f$6(xr, nr, ir, or) + lr + c[xr] + Ee[Ir] >>> 0;
      lr = or, or = ir, ir = ROTL$4(nr, 30) >>> 0, nr = Pe, Pe = kr;
    }
    u[0] = u[0] + Pe >>> 0, u[1] = u[1] + nr >>> 0, u[2] = u[2] + ir >>> 0, u[3] = u[3] + or >>> 0, u[4] = u[4] + lr >>> 0;
  }
  return [u[0] >> 24 & 255, u[0] >> 16 & 255, u[0] >> 8 & 255, u[0] & 255, u[1] >> 24 & 255, u[1] >> 16 & 255, u[1] >> 8 & 255, u[1] & 255, u[2] >> 24 & 255, u[2] >> 16 & 255, u[2] >> 8 & 255, u[2] & 255, u[3] >> 24 & 255, u[3] >> 16 & 255, u[3] >> 8 & 255, u[3] & 255, u[4] >> 24 & 255, u[4] >> 16 & 255, u[4] >> 8 & 255, u[4] & 255];
}
var v5$6 = v35$6("v5", 80, sha1$6);
const nil$6 = "00000000-0000-0000-0000-000000000000";
function version$7(n) {
  if (!validate$7(n))
    throw TypeError("Invalid UUID");
  return parseInt(n.substr(14, 1), 16);
}
const esmBrowser$4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  NIL: nil$6,
  parse: parse$d,
  stringify: stringify$6,
  v1: v1$6,
  v3: v3$6,
  v4: v4$7,
  v5: v5$6,
  validate: validate$7,
  version: version$7
}, Symbol.toStringTag, { value: "Module" })), require$$1$4 = /* @__PURE__ */ getAugmentedNamespace(esmBrowser$4);
var hasRequiredBcUrRegistryAptos_cjs_production_min;
function requireBcUrRegistryAptos_cjs_production_min() {
  return hasRequiredBcUrRegistryAptos_cjs_production_min || (hasRequiredBcUrRegistryAptos_cjs_production_min = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 });
    var c = requireDist$6(), u = require$$1$4;
    const p = { APTOS_SIGN_REQUEST: new c.RegistryType("aptos-sign-request", 3101), APTOS_SIGNATURE: new c.RegistryType("aptos-signature", 3102) }, { decodeToDataItem: a, RegistryTypes: A } = c.extend;
    var b, F;
    (b = n.SignType || (n.SignType = {}))[b.SingleSign = 1] = "SingleSign", b[b.MultiSign = 2] = "MultiSign", b[b.SignMessage = 3] = "SignMessage", function(be) {
      be[be.requestId = 1] = "requestId", be[be.signData = 2] = "signData", be[be.authenticationKeyDerivationPaths = 3] = "authenticationKeyDerivationPaths", be[be.accounts = 4] = "accounts", be[be.origin = 5] = "origin", be[be.signType = 6] = "signType";
    }(F || (F = {}));
    class le extends c.RegistryItem {
      constructor(He) {
        super(), this.getRegistryType = () => p.APTOS_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getAuthenticationKeyDerivationPaths = () => this.authenticationKeyDerivationPaths.map((Pe) => Pe.getPath()), this.getSignRequestAccounts = () => this.accounts, this.getOrigin = () => this.origin, this.getSignType = () => this.signType, this.toDataItem = () => {
          const Pe = {};
          return Pe[F.requestId] = new c.DataItem(this.requestId, A.UUID.getTag()), this.accounts && (Pe[F.accounts] = this.accounts), this.origin && (Pe[F.origin] = this.origin), Pe[F.signData] = this.signData, Pe[F.signType] = this.signType, Pe[F.authenticationKeyDerivationPaths] = this.authenticationKeyDerivationPaths.map((nr) => {
            const ir = nr.toDataItem();
            return ir.setTag(nr.getRegistryType().getTag()), ir;
          }), new c.DataItem(Pe);
        }, this.requestId = He.requestId, this.signData = He.signData, this.authenticationKeyDerivationPaths = He.authenticationKeyDerivationPaths, this.accounts = He.accounts, this.origin = He.origin, this.signType = He.signType;
      }
      static constructAptosRequest(He, Pe, nr, ir, or, lr, Ir) {
        const xr = Pe.map((kr, Ce) => {
          const tr = kr.replace(/[m|M]\//, "").split("/").map((Fe) => {
            const Sr = parseInt(Fe.replace("'", ""));
            let er = !1;
            return Fe.endsWith("'") && (er = !0), new c.PathComponent({ index: Sr, hardened: er });
          });
          return new c.CryptoKeypath(tr, Buffer$f.from(nr[Ce], "hex"));
        });
        return new le({ requestId: Buffer$f.from(u.parse(or)), signData: He, authenticationKeyDerivationPaths: xr, accounts: lr || void 0, origin: Ir || void 0, signType: ir || n.SignType.SingleSign });
      }
    }
    le.fromDataItem = (be) => {
      const He = be.getData(), Pe = He[F.signData], nr = He[F.signType], ir = He[F.authenticationKeyDerivationPaths].map((Ir) => c.CryptoKeypath.fromDataItem(Ir)), or = He[F.accounts] ? He[F.accounts] : void 0, lr = He[F.requestId] ? He[F.requestId].getData() : void 0;
      return new le({ requestId: lr, signData: Pe, authenticationKeyDerivationPaths: ir, accounts: or, origin: He[F.origin] ? He[F.origin] : void 0, signType: nr });
    }, le.fromCBOR = (be) => {
      const He = a(be);
      return le.fromDataItem(He);
    };
    const { RegistryTypes: L, decodeToDataItem: pe } = c.extend;
    var $;
    (function(be) {
      be[be.requestId = 1] = "requestId", be[be.signature = 2] = "signature", be[be.authenticationPublicKey = 3] = "authenticationPublicKey";
    })($ || ($ = {}));
    class Ee extends c.RegistryItem {
      constructor(He, Pe, nr) {
        super(), this.getRegistryType = () => p.APTOS_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.getAuthenticationPublicKey = () => this.authenticationPublicKey, this.toDataItem = () => {
          const ir = {};
          return ir[$.requestId] = new c.DataItem(this.requestId, L.UUID.getTag()), ir[$.signature] = this.signature, ir[$.authenticationPublicKey] = this.authenticationPublicKey, new c.DataItem(ir);
        }, this.signature = He, this.requestId = Pe, this.authenticationPublicKey = nr;
      }
    }
    Ee.fromDataItem = (be) => {
      const He = be.getData(), Pe = He[$.signature], nr = He[$.requestId].getData();
      return new Ee(Pe, nr, He[$.authenticationPublicKey]);
    }, Ee.fromCBOR = (be) => {
      const He = pe(be);
      return Ee.fromDataItem(He);
    }, c.patchTags(Object.values(p).filter((be) => !!be.getTag()).map((be) => be.getTag())), Object.keys(c).forEach(function(be) {
      be !== "default" && Object.defineProperty(n, be, { enumerable: !0, get: function() {
        return c[be];
      } });
    }), n.AptosSignRequest = le, n.AptosSignature = Ee;
  }(bcUrRegistryAptos_cjs_production_min)), bcUrRegistryAptos_cjs_production_min;
}
var bcUrRegistryAptos_cjs_development = {}, hasRequiredBcUrRegistryAptos_cjs_development;
function requireBcUrRegistryAptos_cjs_development() {
  return hasRequiredBcUrRegistryAptos_cjs_development || (hasRequiredBcUrRegistryAptos_cjs_development = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 });
    var c = requireDist$6(), u = require$$1$4;
    const p = {
      APTOS_SIGN_REQUEST: /* @__PURE__ */ new c.RegistryType("aptos-sign-request", 3101),
      APTOS_SIGNATURE: /* @__PURE__ */ new c.RegistryType("aptos-signature", 3102)
    }, {
      decodeToDataItem: a,
      RegistryTypes: A
    } = c.extend;
    (function(Ee) {
      Ee[Ee.SingleSign = 1] = "SingleSign", Ee[Ee.MultiSign = 2] = "MultiSign", Ee[Ee.SignMessage = 3] = "SignMessage";
    })(n.SignType || (n.SignType = {}));
    var b;
    (function(Ee) {
      Ee[Ee.requestId = 1] = "requestId", Ee[Ee.signData = 2] = "signData", Ee[Ee.authenticationKeyDerivationPaths = 3] = "authenticationKeyDerivationPaths", Ee[Ee.accounts = 4] = "accounts", Ee[Ee.origin = 5] = "origin", Ee[Ee.signType = 6] = "signType";
    })(b || (b = {}));
    class F extends c.RegistryItem {
      constructor(be) {
        super(), this.getRegistryType = () => p.APTOS_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getAuthenticationKeyDerivationPaths = () => this.authenticationKeyDerivationPaths.map((He) => He.getPath()), this.getSignRequestAccounts = () => this.accounts, this.getOrigin = () => this.origin, this.getSignType = () => this.signType, this.toDataItem = () => {
          const He = {};
          return He[b.requestId] = new c.DataItem(this.requestId, A.UUID.getTag()), this.accounts && (He[b.accounts] = this.accounts), this.origin && (He[b.origin] = this.origin), He[b.signData] = this.signData, He[b.signType] = this.signType, He[b.authenticationKeyDerivationPaths] = this.authenticationKeyDerivationPaths.map((Pe) => {
            const nr = Pe.toDataItem();
            return nr.setTag(Pe.getRegistryType().getTag()), nr;
          }), new c.DataItem(He);
        }, this.requestId = be.requestId, this.signData = be.signData, this.authenticationKeyDerivationPaths = be.authenticationKeyDerivationPaths, this.accounts = be.accounts, this.origin = be.origin, this.signType = be.signType;
      }
      static constructAptosRequest(be, He, Pe, nr, ir, or, lr) {
        const Ir = He.map((xr, kr) => {
          const tr = xr.replace(/[m|M]\//, "").split("/").map((Fe) => {
            const Sr = parseInt(Fe.replace("'", ""));
            let er = !1;
            return Fe.endsWith("'") && (er = !0), new c.PathComponent({
              index: Sr,
              hardened: er
            });
          });
          return new c.CryptoKeypath(tr, Buffer$f.from(Pe[kr], "hex"));
        });
        return new F({
          requestId: Buffer$f.from(u.parse(ir)),
          signData: be,
          authenticationKeyDerivationPaths: Ir,
          accounts: or || void 0,
          origin: lr || void 0,
          signType: nr || n.SignType.SingleSign
        });
      }
    }
    F.fromDataItem = (Ee) => {
      const be = Ee.getData(), He = be[b.signData], Pe = be[b.signType], nr = be[b.authenticationKeyDerivationPaths].map((Ir) => c.CryptoKeypath.fromDataItem(Ir)), ir = be[b.accounts] ? be[b.accounts] : void 0, or = be[b.requestId] ? be[b.requestId].getData() : void 0, lr = be[b.origin] ? be[b.origin] : void 0;
      return new F({
        requestId: or,
        signData: He,
        authenticationKeyDerivationPaths: nr,
        accounts: ir,
        origin: lr,
        signType: Pe
      });
    }, F.fromCBOR = (Ee) => {
      const be = a(Ee);
      return F.fromDataItem(be);
    };
    const {
      RegistryTypes: le,
      decodeToDataItem: L
    } = c.extend;
    var pe;
    (function(Ee) {
      Ee[Ee.requestId = 1] = "requestId", Ee[Ee.signature = 2] = "signature", Ee[Ee.authenticationPublicKey = 3] = "authenticationPublicKey";
    })(pe || (pe = {}));
    class $ extends c.RegistryItem {
      constructor(be, He, Pe) {
        super(), this.getRegistryType = () => p.APTOS_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.getAuthenticationPublicKey = () => this.authenticationPublicKey, this.toDataItem = () => {
          const nr = {};
          return nr[pe.requestId] = new c.DataItem(this.requestId, le.UUID.getTag()), nr[pe.signature] = this.signature, nr[pe.authenticationPublicKey] = this.authenticationPublicKey, new c.DataItem(nr);
        }, this.signature = be, this.requestId = He, this.authenticationPublicKey = Pe;
      }
    }
    $.fromDataItem = (Ee) => {
      const be = Ee.getData(), He = be[pe.signature], Pe = be[pe.requestId].getData(), nr = be[pe.authenticationPublicKey];
      return new $(He, Pe, nr);
    }, $.fromCBOR = (Ee) => {
      const be = L(Ee);
      return $.fromDataItem(be);
    }, c.patchTags(Object.values(p).filter((Ee) => !!Ee.getTag()).map((Ee) => Ee.getTag())), Object.keys(c).forEach(function(Ee) {
      Ee !== "default" && Object.defineProperty(n, Ee, {
        enumerable: !0,
        get: function() {
          return c[Ee];
        }
      });
    }), n.AptosSignRequest = F, n.AptosSignature = $;
  }(bcUrRegistryAptos_cjs_development)), bcUrRegistryAptos_cjs_development;
}
process$1.env.NODE_ENV === "production" ? dist$h.exports = requireBcUrRegistryAptos_cjs_production_min() : dist$h.exports = requireBcUrRegistryAptos_cjs_development();
var distExports$6 = dist$h.exports;
Object.defineProperty(aptos, "__esModule", { value: !0 });
aptos.KeystoneAptosSDK = void 0;
const bc_ur_registry_aptos_1 = distExports$6, utils_1$g = utils$K, ur_1$6 = ur;
class KeystoneAptosSDK {
  parseSignature(c) {
    if (c.type !== ur_1$6.URType.AptosSignature)
      throw new Error("type not match");
    const u = bc_ur_registry_aptos_1.AptosSignature.fromCBOR(c.cbor);
    return {
      requestId: (0, utils_1$g.uuidStringify)(u.getRequestId()),
      signature: (0, utils_1$g.toHex)(u.getSignature()),
      authenticationPublicKey: (0, utils_1$g.toHex)(u.getAuthenticationPublicKey())
    };
  }
  generateSignRequest({ requestId: c, signData: u, signType: p, accounts: a, origin: A }) {
    const b = [], F = [];
    if (a.forEach((le) => {
      b.push(new bc_ur_registry_aptos_1.CryptoKeypath((0, utils_1$g.parsePath)(le.path).map((L) => new bc_ur_registry_aptos_1.PathComponent(L)), (0, utils_1$g.toBuffer)(le.xfp))), le.key !== void 0 && F.push((0, utils_1$g.toBuffer)(le.key));
    }), F.length > 0 && F.length !== b.length)
      throw new Error("account and path count must match");
    return new bc_ur_registry_aptos_1.AptosSignRequest({
      requestId: (0, utils_1$g.uuidParse)(c),
      signData: (0, utils_1$g.toBuffer)(u),
      signType: p,
      authenticationKeyDerivationPaths: b,
      accounts: F,
      origin: A
    }).toUR();
  }
}
KeystoneAptosSDK.SignType = bc_ur_registry_aptos_1.SignType;
aptos.KeystoneAptosSDK = KeystoneAptosSDK;
var bitcoin_cash = {}, keystone = {};
(function(n) {
  var c = commonjsGlobal && commonjsGlobal.__importDefault || function(He) {
    return He && He.__esModule ? He : { default: He };
  };
  Object.defineProperty(n, "__esModule", { value: !0 }), n.Keystone = n.TXCase = n.Chain = void 0;
  const u = c(pako), p = ur, a = distExports$7, A = base_pb, b = payload_pb, F = transaction_pb, le = ltc_transaction_pb, L = bch_transaction_pb, pe = dash_transaction_pb;
  var $;
  (function(He) {
    He.LTC = "LTC", He.BCH = "BCH", He.DASH = "DASH";
  })($ = n.Chain || (n.Chain = {}));
  var Ee;
  (function(He) {
    He.LTC = "ltcTx", He.BCH = "bchTx", He.DASH = "dashTx";
  })(Ee = n.TXCase || (n.TXCase = {}));
  class be {
    generateSignData({ chain: Pe, requestId: nr, signData: ir, xfp: or }) {
      let lr, Ir, xr;
      switch (Pe) {
        case $.LTC:
          lr = new le.LtcTx(Object.assign(Object.assign({}, ir), { fee: BigInt(ir.fee), dustThreshold: 5460 })), xr = $.LTC, Ir = Ee.LTC;
          break;
        case $.BCH:
          lr = new L.BchTx(Object.assign(Object.assign({}, ir), { fee: BigInt(ir.fee), dustThreshold: 546 })), xr = $.BCH, Ir = Ee.BCH;
          break;
        case $.DASH:
          lr = new pe.DashTx(Object.assign(Object.assign({}, ir), { fee: BigInt(ir.fee), dustThreshold: 546 })), xr = $.DASH, Ir = Ee.DASH;
          break;
        default:
          throw new Error("chain not support");
      }
      return u.default.gzip(new A.Base({
        version: 2,
        description: "QrCode Protocol",
        deviceType: "",
        data: new b.Payload({
          xfp: or,
          type: b.Payload_Type.SIGN_TX,
          Content: {
            case: "signTx",
            value: new F.SignTransaction({
              coinCode: xr,
              hdPath: "",
              signId: nr,
              timestamp: BigInt(Date.now()),
              decimal: 8,
              Transaction: {
                case: Ir,
                value: lr
              }
            })
          }
        })
      }).toBinary());
    }
    generateSignRequest(Pe) {
      const nr = Buffer$f.from(this.generateSignData(Pe));
      return new a.KeystoneSignRequest({
        signData: nr,
        origin: Pe.origin
      }).toUR();
    }
    parseSignResult(Pe) {
      var nr, ir;
      if (Pe.type !== p.URType.KeystoneSignResult)
        throw new Error("type not match");
      const or = a.KeystoneSignResult.fromCBOR(Pe.cbor), lr = A.Base.fromBinary(u.default.ungzip(or.getSignResult()));
      if (((nr = lr.data) === null || nr === void 0 ? void 0 : nr.Content.case) !== "signTxResult")
        throw new Error("invalid sign result");
      const Ir = (ir = lr.data) === null || ir === void 0 ? void 0 : ir.Content.value;
      return {
        requestId: Ir.signId,
        rawData: Ir.rawTx
      };
    }
  }
  n.Keystone = be;
})(keystone);
Object.defineProperty(bitcoin_cash, "__esModule", { value: !0 });
bitcoin_cash.KeystoneBitcoinCashSDK = void 0;
const keystone_1$2 = keystone;
class KeystoneBitcoinCashSDK extends keystone_1$2.Keystone {
  generateSignRequest(c) {
    return super.generateSignRequest(Object.assign({ chain: keystone_1$2.Chain.BCH }, c));
  }
}
bitcoin_cash.KeystoneBitcoinCashSDK = KeystoneBitcoinCashSDK;
var dash = {};
Object.defineProperty(dash, "__esModule", { value: !0 });
dash.KeystoneDashSDK = void 0;
const keystone_1$1 = keystone;
class KeystoneDashSDK extends keystone_1$1.Keystone {
  generateSignRequest(c) {
    return super.generateSignRequest(Object.assign({ chain: keystone_1$1.Chain.DASH }, c));
  }
}
dash.KeystoneDashSDK = KeystoneDashSDK;
var litecoin = {};
Object.defineProperty(litecoin, "__esModule", { value: !0 });
litecoin.KeystoneLitecoinSDK = void 0;
const keystone_1 = keystone;
class KeystoneLitecoinSDK extends keystone_1.Keystone {
  generateSignRequest(c) {
    return super.generateSignRequest(Object.assign({ chain: keystone_1.Chain.LTC }, c));
  }
}
litecoin.KeystoneLitecoinSDK = KeystoneLitecoinSDK;
var near = {}, dist$f = { exports: {} }, bcUrRegistryNear_cjs_production_min = {}, dist$e = {}, patchCBOR$5 = {}, utils$a = {}, lib$7 = {}, cborSync$5 = { exports: {} }, DataItem$5 = {}, hasRequiredDataItem$5;
function requireDataItem$5() {
  if (hasRequiredDataItem$5) return DataItem$5;
  hasRequiredDataItem$5 = 1, Object.defineProperty(DataItem$5, "__esModule", { value: !0 }), DataItem$5.DataItem = void 0;
  class n {
    constructor(u, p) {
      this.setTag = (a) => {
        this.tag = a;
      }, this.clearTag = () => {
        this.tag = void 0;
      }, this.getTag = () => this.tag, this.getData = () => this.data, this.data = u, this.tag = p;
    }
  }
  return DataItem$5.DataItem = n, DataItem$5;
}
var hasRequiredCborSync$5;
function requireCborSync$5() {
  return hasRequiredCborSync$5 || (hasRequiredCborSync$5 = 1, function(n) {
    (function(c, u) {
      n.exports ? n.exports = u() : c.CBOR = u();
    })(commonjsGlobal, function() {
      const { DataItem: c } = requireDataItem$5();
      var u = function() {
        function p(Ce) {
          this.$hex = Ce;
        }
        p.prototype = {
          length: function() {
            return this.$hex.length / 2;
          },
          toString: function(Ce) {
            if (!Ce || Ce === "hex" || Ce === 16)
              return this.$hex;
            if (Ce === "utf-8") {
              for (var tr = "", Fe = 0; Fe < this.$hex.length; Fe += 2)
                tr += "%" + this.$hex.substring(Fe, Fe + 2);
              return decodeURIComponent(tr);
            }
            if (Ce === "latin") {
              for (var tr = [], Fe = 0; Fe < this.$hex.length; Fe += 2)
                tr.push(parseInt(this.$hex.substring(Fe, Fe + 2), 16));
              return String.fromCharCode.apply(String, tr);
            }
            throw new Error("Unrecognised format: " + Ce);
          }
        }, p.fromLatinString = function(Ce) {
          for (var tr = "", Fe = 0; Fe < Ce.length; Fe++) {
            var Sr = Ce.charCodeAt(Fe).toString(16);
            Sr.length === 1 && (Sr = "0" + Sr), tr += Sr;
          }
          return new p(tr);
        }, p.fromUtf8String = function(Ce) {
          for (var tr = encodeURIComponent(Ce), Fe = "", Sr = 0; Sr < tr.length; Sr++)
            if (tr.charAt(Sr) === "%")
              Fe += tr.substring(Sr + 1, Sr + 3), Sr += 2;
            else {
              var er = tr.charCodeAt(Sr).toString(16);
              er.length < 2 && (er = "0" + er), Fe += er;
            }
          return new p(Fe);
        };
        var a = [], A = {}, b = function(Ce) {
          return function() {
            throw new Error(Ce + " not implemented");
          };
        };
        function F() {
        }
        F.prototype = {
          peekByte: b("peekByte"),
          readByte: b("readByte"),
          readChunk: b("readChunk"),
          readFloat16: function() {
            var Ce = this.readUint16(), tr = (Ce & 32767) >> 10, Fe = Ce & 1023, Sr = Ce & 32768;
            if (tr === 31)
              return Fe === 0 ? Sr ? -1 / 0 : 1 / 0 : NaN;
            var er = tr ? Math.pow(2, tr - 25) * (1024 + Fe) : Math.pow(2, -24) * Fe;
            return Sr ? -er : er;
          },
          readFloat32: function() {
            var Ce = this.readUint32(), tr = (Ce & 2147483647) >> 23, Fe = Ce & 8388607, Sr = Ce & 2147483648;
            if (tr === 255)
              return Fe === 0 ? Sr ? -1 / 0 : 1 / 0 : NaN;
            var er = tr ? Math.pow(2, tr - 23 - 127) * (8388608 + Fe) : Math.pow(2, -149) * Fe;
            return Sr ? -er : er;
          },
          readFloat64: function() {
            var Ce = this.readUint32(), tr = this.readUint32(), Fe = Ce >> 20 & 2047, Sr = (Ce & 1048575) * 4294967296 + tr, er = Ce & 2147483648;
            if (Fe === 2047)
              return Sr === 0 ? er ? -1 / 0 : 1 / 0 : NaN;
            var Ie = Fe ? Math.pow(2, Fe - 52 - 1023) * (4503599627370496 + Sr) : Math.pow(2, -1074) * Sr;
            return er ? -Ie : Ie;
          },
          readUint16: function() {
            return this.readByte() * 256 + this.readByte();
          },
          readUint32: function() {
            return this.readUint16() * 65536 + this.readUint16();
          },
          readUint64: function() {
            return this.readUint32() * 4294967296 + this.readUint32();
          }
        };
        function le() {
        }
        le.prototype = {
          writeByte: b("writeByte"),
          result: b("result"),
          writeFloat16: b("writeFloat16"),
          writeFloat32: b("writeFloat32"),
          writeFloat64: b("writeFloat64"),
          writeUint16: function(Ce) {
            this.writeByte(Ce >> 8 & 255), this.writeByte(Ce & 255);
          },
          writeUint32: function(Ce) {
            this.writeUint16(Ce >> 16 & 65535), this.writeUint16(Ce & 65535);
          },
          writeUint64: function(Ce) {
            if (Ce >= 9007199254740992 || Ce <= -9007199254740992)
              throw new Error("Cannot encode Uint64 of: " + Ce + " magnitude to big (floating point errors)");
            this.writeUint32(Math.floor(Ce / 4294967296)), this.writeUint32(Ce % 4294967296);
          },
          writeString: b("writeString"),
          canWriteBinary: function(Ce) {
            return !1;
          },
          writeBinary: b("writeChunk")
        };
        function L(Ce) {
          var tr = Ce.readByte(), Fe = tr >> 5, Sr = tr & 31;
          return { type: Fe, value: Sr };
        }
        function pe(Ce, tr) {
          var Fe = Ce.value;
          if (Fe < 24)
            return Fe;
          if (Fe == 24)
            return tr.readByte();
          if (Fe == 25)
            return tr.readUint16();
          if (Fe == 26)
            return tr.readUint32();
          if (Fe == 27)
            return tr.readUint64();
          if (Fe == 31)
            return null;
          b("Additional info: " + Fe)();
        }
        function $(Ce, tr, Fe) {
          Fe.writeByte(Ce << 5 | tr);
        }
        function Ee(Ce, tr, Fe) {
          var Sr = Ce << 5;
          tr < 24 ? Fe.writeByte(Sr | tr) : tr < 256 ? (Fe.writeByte(Sr | 24), Fe.writeByte(tr)) : tr < 65536 ? (Fe.writeByte(Sr | 25), Fe.writeUint16(tr)) : tr < 4294967296 ? (Fe.writeByte(Sr | 26), Fe.writeUint32(tr)) : (Fe.writeByte(Sr | 27), Fe.writeUint64(tr));
        }
        var be = new Error();
        function He(Ce) {
          var tr = L(Ce);
          switch (tr.type) {
            case 0:
              return pe(tr, Ce);
            case 1:
              return -1 - pe(tr, Ce);
            case 2:
              return Ce.readChunk(pe(tr, Ce));
            case 3:
              var Fe = Ce.readChunk(pe(tr, Ce));
              return Fe.toString("utf-8");
            case 4:
            case 5:
              var Sr = pe(tr, Ce), yr = [];
              if (Sr !== null) {
                tr.type === 5 && (Sr *= 2);
                for (var er = 0; er < Sr; er++)
                  yr[er] = He(Ce);
              } else
                for (var Ie; (Ie = He(Ce)) !== be; )
                  yr.push(Ie);
              if (tr.type === 5) {
                for (var xe = {}, er = 0; er < yr.length; er += 2)
                  xe[yr[er]] = yr[er + 1];
                return xe;
              } else
                return yr;
            case 6:
              var rr = pe(tr, Ce), ar = A[rr], yr = He(Ce);
              return ar ? ar(yr) : yr;
            case 7:
              if (tr.value === 25)
                return Ce.readFloat16();
              if (tr.value === 26)
                return Ce.readFloat32();
              if (tr.value === 27)
                return Ce.readFloat64();
              switch (pe(tr, Ce)) {
                case 20:
                  return !1;
                case 21:
                  return !0;
                case 22:
                  return null;
                case 23:
                  return;
                case null:
                  return be;
                default:
                  throw new Error("Unknown fixed value: " + tr.value);
              }
            default:
              throw new Error("Unsupported header: " + JSON.stringify(tr));
          }
          throw new Error("not implemented yet");
        }
        function Pe(Ce, tr) {
          for (var Fe = 0; Fe < a.length; Fe++) {
            var Sr = a[Fe].fn(Ce);
            if (Sr !== void 0)
              return Ee(6, a[Fe].tag, tr), Pe(Sr, tr);
          }
          if (Ce && typeof Ce.toCBOR == "function" && (Ce = Ce.toCBOR()), Ce === !1)
            Ee(7, 20, tr);
          else if (Ce === !0)
            Ee(7, 21, tr);
          else if (Ce === null)
            Ee(7, 22, tr);
          else if (Ce === void 0)
            Ee(7, 23, tr);
          else if (typeof Ce == "number")
            Math.floor(Ce) === Ce && Ce < 9007199254740992 && Ce > -9007199254740992 ? Ce < 0 ? Ee(1, -1 - Ce, tr) : Ee(0, Ce, tr) : ($(7, 27, tr), tr.writeFloat64(Ce));
          else if (typeof Ce == "string")
            tr.writeString(Ce, function(Ie) {
              Ee(3, Ie, tr);
            });
          else if (tr.canWriteBinary(Ce))
            tr.writeBinary(Ce, function(Ie) {
              Ee(2, Ie, tr);
            });
          else if (typeof Ce == "object")
            if (or.config.useToJSON && typeof Ce.toJSON == "function" && (Ce = Ce.toJSON()), Array.isArray(Ce)) {
              Ee(4, Ce.length, tr);
              for (var Fe = 0; Fe < Ce.length; Fe++)
                Pe(Ce[Fe], tr);
            } else {
              var er = Object.keys(Ce);
              Ee(5, er.length, tr);
              for (var Fe = 0; Fe < er.length; Fe++) {
                const xe = parseInt(er[Fe]);
                isNaN(xe) ? (Pe(er[Fe], tr), Pe(Ce[er[Fe]], tr)) : (Pe(xe, tr), Pe(Ce[er[Fe]], tr));
              }
            }
          else
            throw new Error("CBOR encoding not supported: " + Ce);
        }
        var nr = [], ir = [], or = {
          config: {
            useToJSON: !0
          },
          addWriter: function(Ce, tr) {
            typeof Ce == "string" ? ir.push(function(Fe) {
              if (Ce === Fe)
                return tr(Fe);
            }) : ir.push(Ce);
          },
          addReader: function(Ce, tr) {
            typeof Ce == "string" ? nr.push(function(Fe, Sr) {
              if (Ce === Sr)
                return tr(Fe, Sr);
            }) : nr.push(Ce);
          },
          encode: function(Ce, tr) {
            for (var Fe = 0; Fe < ir.length; Fe++) {
              var Sr = ir[Fe], er = Sr(tr);
              if (er)
                return Pe(Ce, er), er.result();
            }
            throw new Error("Unsupported output format: " + tr);
          },
          encodeDataItem: function(Ce, tr) {
            for (var Fe = 0; Fe < ir.length; Fe++) {
              var Sr = ir[Fe], er = Sr(tr);
              if (er)
                return Ce.getTag() !== void 0 ? (Pe(Ce, er), er.result()) : (Pe(Ce.getData(), er), er.result());
            }
            throw new Error("Unsupported output format: " + tr);
          },
          decode: function(Ce, tr) {
            for (var Fe = 0; Fe < nr.length; Fe++) {
              var Sr = nr[Fe], er = Sr(Ce, tr);
              if (er)
                return He(er);
            }
            throw new Error("Unsupported input format: " + tr);
          },
          decodeToDataItem: function(Ce, tr) {
            for (var Fe = 0; Fe < nr.length; Fe++) {
              var Sr = nr[Fe], er = Sr(Ce, tr);
              if (er) {
                const Ie = He(er);
                return Ie instanceof c ? Ie : new c(Ie);
              }
            }
            throw new Error("Unsupported input format: " + tr);
          },
          addSemanticEncode: function(Ce, tr) {
            if (typeof Ce != "number" || Ce % 1 !== 0 || Ce < 0)
              throw new Error("Tag must be a positive integer");
            return a.push({ tag: Ce, fn: tr }), this;
          },
          addSemanticDecode: function(Ce, tr) {
            if (typeof Ce != "number" || Ce % 1 !== 0 || Ce < 0)
              throw new Error("Tag must be a positive integer");
            return A[Ce] = tr, this;
          }
        };
        function lr(Ce) {
          this.buffer = Ce, this.pos = 0;
        }
        lr.prototype = Object.create(F.prototype), lr.prototype.peekByte = function() {
          return this.buffer[this.pos];
        }, lr.prototype.readByte = function() {
          return this.buffer[this.pos++];
        }, lr.prototype.readUint16 = function() {
          var Ce = this.buffer.readUInt16BE(this.pos);
          return this.pos += 2, Ce;
        }, lr.prototype.readUint32 = function() {
          var Ce = this.buffer.readUInt32BE(this.pos);
          return this.pos += 4, Ce;
        }, lr.prototype.readFloat32 = function() {
          var Ce = this.buffer.readFloatBE(this.pos);
          return this.pos += 4, Ce;
        }, lr.prototype.readFloat64 = function() {
          var Ce = this.buffer.readDoubleBE(this.pos);
          return this.pos += 8, Ce;
        }, lr.prototype.readChunk = function(Ce) {
          var tr = Buffer$f.alloc(Ce);
          return this.buffer.copy(tr, 0, this.pos, this.pos += Ce), tr;
        };
        function Ir(Ce) {
          this.byteLength = 0, this.defaultBufferLength = 16384, this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0, this.completeBuffers = [], this.stringFormat = Ce;
        }
        Ir.prototype = Object.create(le.prototype), Ir.prototype.writeByte = function(Ce) {
          this.latestBuffer[this.latestBufferOffset++] = Ce, this.latestBufferOffset >= this.latestBuffer.length && (this.completeBuffers.push(this.latestBuffer), this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0), this.byteLength++;
        }, Ir.prototype.writeFloat32 = function(Ce) {
          var tr = Buffer$f.alloc(4);
          tr.writeFloatBE(Ce, 0), this.writeBuffer(tr);
        }, Ir.prototype.writeFloat64 = function(Ce) {
          var tr = Buffer$f.alloc(8);
          tr.writeDoubleBE(Ce, 0), this.writeBuffer(tr);
        }, Ir.prototype.writeString = function(Ce, tr) {
          var Fe = Buffer$f.from(Ce, "utf-8");
          tr(Fe.length), this.writeBuffer(Fe);
        }, Ir.prototype.canWriteBinary = function(Ce) {
          return Ce instanceof Buffer$f;
        }, Ir.prototype.writeBinary = function(Ce, tr) {
          tr(Ce.length), this.writeBuffer(Ce);
        }, Ir.prototype.writeBuffer = function(Ce) {
          if (!(Ce instanceof Buffer$f))
            throw new TypeError("BufferWriter only accepts Buffers");
          this.latestBufferOffset ? this.latestBuffer.length - this.latestBufferOffset >= Ce.length ? (Ce.copy(this.latestBuffer, this.latestBufferOffset), this.latestBufferOffset += Ce.length, this.latestBufferOffset >= this.latestBuffer.length && (this.completeBuffers.push(this.latestBuffer), this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0)) : (this.completeBuffers.push(this.latestBuffer.slice(0, this.latestBufferOffset)), this.completeBuffers.push(Ce), this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0) : this.completeBuffers.push(Ce), this.byteLength += Ce.length;
        }, Ir.prototype.result = function() {
          for (var Ce = Buffer$f.alloc(this.byteLength), tr = 0, Fe = 0; Fe < this.completeBuffers.length; Fe++) {
            var Sr = this.completeBuffers[Fe];
            Sr.copy(Ce, tr, 0, Sr.length), tr += Sr.length;
          }
          return this.latestBufferOffset && this.latestBuffer.copy(Ce, tr, 0, this.latestBufferOffset), this.stringFormat ? Ce.toString(this.stringFormat) : Ce;
        }, typeof Buffer$f == "function" && (or.addReader(function(Ce, tr) {
          if (Buffer$f.isBuffer(Ce))
            return new lr(Ce);
          if (tr === "hex" || tr === "base64") {
            var Fe = Buffer$f.from(Ce, tr);
            return new lr(Fe);
          }
        }), or.addWriter(function(Ce) {
          if (!Ce || Ce === "buffer")
            return new Ir();
          if (Ce === "hex" || Ce === "base64")
            return new Ir(Ce);
        }));
        function xr(Ce) {
          this.hex = Ce, this.pos = 0;
        }
        xr.prototype = Object.create(F.prototype), xr.prototype.peekByte = function() {
          var Ce = this.hex.substring(this.pos, 2);
          return parseInt(Ce, 16);
        }, xr.prototype.readByte = function() {
          var Ce = this.hex.substring(this.pos, this.pos + 2);
          return this.pos += 2, parseInt(Ce, 16);
        }, xr.prototype.readChunk = function(Ce) {
          var tr = this.hex.substring(this.pos, this.pos + Ce * 2);
          return this.pos += Ce * 2, typeof Buffer$f == "function" ? Buffer$f.from(tr, "hex") : new p(tr);
        };
        function kr(Ce) {
          this.$hex = "", this.finalFormat = Ce || "hex";
        }
        return kr.prototype = Object.create(le.prototype), kr.prototype.writeByte = function(Ce) {
          if (Ce < 0 || Ce > 255)
            throw new Error("Byte value out of range: " + Ce);
          var tr = Ce.toString(16);
          tr.length == 1 && (tr = "0" + tr), this.$hex += tr;
        }, kr.prototype.canWriteBinary = function(Ce) {
          return Ce instanceof p || typeof Buffer$f == "function" && Ce instanceof Buffer$f;
        }, kr.prototype.writeBinary = function(Ce, tr) {
          if (Ce instanceof p)
            tr(Ce.length()), this.$hex += Ce.$hex;
          else if (typeof Buffer$f == "function" && Ce instanceof Buffer$f)
            tr(Ce.length), this.$hex += Ce.toString("hex");
          else
            throw new TypeError("HexWriter only accepts BinaryHex or Buffers");
        }, kr.prototype.result = function() {
          return this.finalFormat === "buffer" && typeof Buffer$f == "function" ? Buffer$f.from(this.$hex, "hex") : new p(this.$hex).toString(this.finalFormat);
        }, kr.prototype.writeString = function(Ce, tr) {
          var Fe = p.fromUtf8String(Ce);
          tr(Fe.length()), this.$hex += Fe.$hex;
        }, or.addReader(function(Ce, tr) {
          if (Ce instanceof p || Ce.$hex)
            return new xr(Ce.$hex);
          if (tr === "hex")
            return new xr(Ce);
        }), or.addWriter(function(Ce) {
          if (Ce === "hex")
            return new kr();
        }), or;
      }();
      return u.addSemanticEncode(0, function(p) {
        if (p instanceof Date)
          return p.toISOString();
      }).addSemanticDecode(0, function(p) {
        return new Date(p);
      }).addSemanticDecode(1, function(p) {
        return new Date(p);
      }), u;
    });
  }(cborSync$5)), cborSync$5.exports;
}
var hasRequiredLib$5;
function requireLib$5() {
  return hasRequiredLib$5 || (hasRequiredLib$5 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.DataItem = n.addWriter = n.addReader = n.addSemanticEncode = n.addSemanticDecode = n.decodeToDataItem = n.encodeDataItem = void 0;
    var c = requireCborSync$5();
    Object.defineProperty(n, "encodeDataItem", { enumerable: !0, get: function() {
      return c.encodeDataItem;
    } }), Object.defineProperty(n, "decodeToDataItem", { enumerable: !0, get: function() {
      return c.decodeToDataItem;
    } }), Object.defineProperty(n, "addSemanticDecode", { enumerable: !0, get: function() {
      return c.addSemanticDecode;
    } }), Object.defineProperty(n, "addSemanticEncode", { enumerable: !0, get: function() {
      return c.addSemanticEncode;
    } }), Object.defineProperty(n, "addReader", { enumerable: !0, get: function() {
      return c.addReader;
    } }), Object.defineProperty(n, "addWriter", { enumerable: !0, get: function() {
      return c.addWriter;
    } });
    var u = requireDataItem$5();
    Object.defineProperty(n, "DataItem", { enumerable: !0, get: function() {
      return u.DataItem;
    } });
  }(lib$7)), lib$7;
}
var hasRequiredUtils$5;
function requireUtils$5() {
  if (hasRequiredUtils$5) return utils$a;
  hasRequiredUtils$5 = 1, Object.defineProperty(utils$a, "__esModule", { value: !0 }), utils$a.patchTags = void 0;
  const n = requireLib$5(), c = [], u = (p) => {
    p.forEach((a) => {
      c.find((A) => A === a) || ((0, n.addSemanticEncode)(a, (A) => {
        if (A instanceof n.DataItem && A.getTag() === a)
          return A.getData();
      }), (0, n.addSemanticDecode)(a, (A) => new n.DataItem(A, a)), c.push(a));
    });
  };
  return utils$a.patchTags = u, utils$a;
}
var RegistryType$5 = {}, hasRequiredRegistryType$5;
function requireRegistryType$5() {
  if (hasRequiredRegistryType$5) return RegistryType$5;
  hasRequiredRegistryType$5 = 1, Object.defineProperty(RegistryType$5, "__esModule", { value: !0 }), RegistryType$5.RegistryTypes = RegistryType$5.RegistryType = void 0;
  class n {
    constructor(u, p) {
      this.type = u, this.tag = p, this.getTag = () => this.tag, this.getType = () => this.type;
    }
  }
  return RegistryType$5.RegistryType = n, RegistryType$5.RegistryTypes = {
    UUID: new n("uuid", 37),
    BYTES: new n("bytes", void 0),
    CRYPTO_HDKEY: new n("crypto-hdkey", 303),
    CRYPTO_KEYPATH: new n("crypto-keypath", 304),
    CRYPTO_COIN_INFO: new n("crypto-coin-info", 305),
    CRYPTO_ECKEY: new n("crypto-eckey", 306),
    CRYPTO_OUTPUT: new n("crypto-output", 308),
    CRYPTO_PSBT: new n("crypto-psbt", 310),
    CRYPTO_ACCOUNT: new n("crypto-account", 311),
    CRYPTO_MULTI_ACCOUNTS: new n("crypto-multi-accounts", 1103),
    QR_HARDWARE_CALL: new n("qr-hardware-call", 1201),
    KEY_DERIVATION_CALL: new n("key-derivation-call", 1301),
    KEY_DERIVATION_SCHEMA: new n("key-derivation-schema", 1302)
  }, RegistryType$5;
}
var ScriptExpression$5 = {}, hasRequiredScriptExpression$5;
function requireScriptExpression$5() {
  return hasRequiredScriptExpression$5 || (hasRequiredScriptExpression$5 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.ScriptExpressions = n.ScriptExpression = void 0;
    class c {
      constructor(p, a) {
        this.tag = p, this.expression = a, this.getTag = () => this.tag, this.getExpression = () => this.expression;
      }
    }
    n.ScriptExpression = c, c.fromTag = (u) => Object.values(n.ScriptExpressions).find((a) => a.getTag() === u), n.ScriptExpressions = {
      SCRIPT_HASH: new c(400, "sh"),
      WITNESS_SCRIPT_HASH: new c(401, "wsh"),
      PUBLIC_KEY: new c(402, "pk"),
      PUBLIC_KEY_HASH: new c(403, "pkh"),
      WITNESS_PUBLIC_KEY_HASH: new c(404, "wpkh"),
      COMBO: new c(405, "combo"),
      MULTISIG: new c(406, "multi"),
      SORTED_MULTISIG: new c(407, "sortedmulti"),
      ADDRESS: new c(307, "addr"),
      RAW_SCRIPT: new c(408, "raw")
    };
  }(ScriptExpression$5)), ScriptExpression$5;
}
var hasRequiredPatchCBOR$5;
function requirePatchCBOR$5() {
  if (hasRequiredPatchCBOR$5) return patchCBOR$5;
  hasRequiredPatchCBOR$5 = 1, Object.defineProperty(patchCBOR$5, "__esModule", { value: !0 });
  const n = requireUtils$5(), c = requireRegistryType$5(), u = requireScriptExpression$5(), p = Object.values(c.RegistryTypes).filter((A) => !!A.getTag()).map((A) => A.getTag()), a = Object.values(u.ScriptExpressions).map((A) => A.getTag());
  return (0, n.patchTags)(p.concat(a)), patchCBOR$5;
}
var CryptoHDKey$5 = {}, src$9, hasRequiredSrc$5;
function requireSrc$5() {
  if (hasRequiredSrc$5) return src$9;
  hasRequiredSrc$5 = 1;
  var n = safeBufferExports.Buffer;
  function c(u) {
    if (u.length >= 255)
      throw new TypeError("Alphabet too long");
    for (var p = new Uint8Array(256), a = 0; a < p.length; a++)
      p[a] = 255;
    for (var A = 0; A < u.length; A++) {
      var b = u.charAt(A), F = b.charCodeAt(0);
      if (p[F] !== 255)
        throw new TypeError(b + " is ambiguous");
      p[F] = A;
    }
    var le = u.length, L = u.charAt(0), pe = Math.log(le) / Math.log(256), $ = Math.log(256) / Math.log(le);
    function Ee(Pe) {
      if ((Array.isArray(Pe) || Pe instanceof Uint8Array) && (Pe = n.from(Pe)), !n.isBuffer(Pe))
        throw new TypeError("Expected Buffer");
      if (Pe.length === 0)
        return "";
      for (var nr = 0, ir = 0, or = 0, lr = Pe.length; or !== lr && Pe[or] === 0; )
        or++, nr++;
      for (var Ir = (lr - or) * $ + 1 >>> 0, xr = new Uint8Array(Ir); or !== lr; ) {
        for (var kr = Pe[or], Ce = 0, tr = Ir - 1; (kr !== 0 || Ce < ir) && tr !== -1; tr--, Ce++)
          kr += 256 * xr[tr] >>> 0, xr[tr] = kr % le >>> 0, kr = kr / le >>> 0;
        if (kr !== 0)
          throw new Error("Non-zero carry");
        ir = Ce, or++;
      }
      for (var Fe = Ir - ir; Fe !== Ir && xr[Fe] === 0; )
        Fe++;
      for (var Sr = L.repeat(nr); Fe < Ir; ++Fe)
        Sr += u.charAt(xr[Fe]);
      return Sr;
    }
    function be(Pe) {
      if (typeof Pe != "string")
        throw new TypeError("Expected String");
      if (Pe.length === 0)
        return n.alloc(0);
      for (var nr = 0, ir = 0, or = 0; Pe[nr] === L; )
        ir++, nr++;
      for (var lr = (Pe.length - nr) * pe + 1 >>> 0, Ir = new Uint8Array(lr); nr < Pe.length; ) {
        var xr = Pe.charCodeAt(nr);
        if (xr > 255)
          return;
        var kr = p[xr];
        if (kr === 255)
          return;
        for (var Ce = 0, tr = lr - 1; (kr !== 0 || Ce < or) && tr !== -1; tr--, Ce++)
          kr += le * Ir[tr] >>> 0, Ir[tr] = kr % 256 >>> 0, kr = kr / 256 >>> 0;
        if (kr !== 0)
          throw new Error("Non-zero carry");
        or = Ce, nr++;
      }
      for (var Fe = lr - or; Fe !== lr && Ir[Fe] === 0; )
        Fe++;
      var Sr = n.allocUnsafe(ir + (lr - Fe));
      Sr.fill(0, 0, ir);
      for (var er = ir; Fe !== lr; )
        Sr[er++] = Ir[Fe++];
      return Sr;
    }
    function He(Pe) {
      var nr = be(Pe);
      if (nr)
        return nr;
      throw new Error("Non-base" + le + " character");
    }
    return {
      encode: Ee,
      decodeUnsafe: be,
      decode: He
    };
  }
  return src$9 = c, src$9;
}
var bs58$6, hasRequiredBs58$5;
function requireBs58$5() {
  if (hasRequiredBs58$5) return bs58$6;
  hasRequiredBs58$5 = 1;
  var n = requireSrc$5(), c = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
  return bs58$6 = n(c), bs58$6;
}
var base$8, hasRequiredBase$5;
function requireBase$5() {
  if (hasRequiredBase$5) return base$8;
  hasRequiredBase$5 = 1;
  var n = requireBs58$5(), c = safeBufferExports.Buffer;
  return base$8 = function(u) {
    function p(F) {
      var le = u(F);
      return n.encode(c.concat([
        F,
        le
      ], F.length + 4));
    }
    function a(F) {
      var le = F.slice(0, -4), L = F.slice(-4), pe = u(le);
      if (!(L[0] ^ pe[0] | L[1] ^ pe[1] | L[2] ^ pe[2] | L[3] ^ pe[3]))
        return le;
    }
    function A(F) {
      var le = n.decodeUnsafe(F);
      if (le)
        return a(le);
    }
    function b(F) {
      var le = n.decode(F), L = a(le);
      if (!L) throw new Error("Invalid checksum");
      return L;
    }
    return {
      encode: p,
      decode: b,
      decodeUnsafe: A
    };
  }, base$8;
}
var bs58check$8, hasRequiredBs58check$5;
function requireBs58check$5() {
  if (hasRequiredBs58check$5) return bs58check$8;
  hasRequiredBs58check$5 = 1;
  var n = browser$a, c = requireBase$5();
  function u(p) {
    var a = n("sha256").update(p).digest();
    return n("sha256").update(a).digest();
  }
  return bs58check$8 = c(u), bs58check$8;
}
var CryptoCoinInfo$5 = {}, RegistryItem$5 = {}, hasRequiredRegistryItem$5;
function requireRegistryItem$5() {
  if (hasRequiredRegistryItem$5) return RegistryItem$5;
  hasRequiredRegistryItem$5 = 1, Object.defineProperty(RegistryItem$5, "__esModule", { value: !0 }), RegistryItem$5.RegistryItem = void 0;
  const n = dist$t, c = requireLib$5();
  class u {
    constructor() {
      this.toCBOR = () => {
        if (this.toDataItem() === void 0)
          throw new Error(`#[ur-registry][RegistryItem][fn.toCBOR]: registry ${this.getRegistryType()}'s method toDataItem returns undefined`);
        return (0, c.encodeDataItem)(this.toDataItem());
      }, this.toUR = () => new n.UR(this.toCBOR(), this.getRegistryType().getType()), this.toUREncoder = (a, A, b) => {
        const F = this.toUR();
        return new n.UREncoder(F, a, A, b);
      };
    }
  }
  return RegistryItem$5.RegistryItem = u, RegistryItem$5;
}
var hasRequiredCryptoCoinInfo$5;
function requireCryptoCoinInfo$5() {
  return hasRequiredCryptoCoinInfo$5 || (hasRequiredCryptoCoinInfo$5 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.CryptoCoinInfo = n.Network = n.Type = void 0;
    const c = requireLib$5(), u = requireRegistryItem$5(), p = requireRegistryType$5();
    var a;
    (function(le) {
      le.type = "1", le.network = "2";
    })(a || (a = {}));
    var A;
    (function(le) {
      le[le.bitcoin = 0] = "bitcoin";
    })(A = n.Type || (n.Type = {}));
    var b;
    (function(le) {
      le[le.mainnet = 0] = "mainnet", le[le.testnet = 1] = "testnet";
    })(b = n.Network || (n.Network = {}));
    class F extends u.RegistryItem {
      constructor(L, pe) {
        super(), this.type = L, this.network = pe, this.getRegistryType = () => p.RegistryTypes.CRYPTO_COIN_INFO, this.getType = () => this.type || A.bitcoin, this.getNetwork = () => this.network || b.mainnet, this.toDataItem = () => {
          const $ = {};
          return this.type && ($[a.type] = this.type), this.network && ($[a.network] = this.network), new c.DataItem($);
        };
      }
    }
    n.CryptoCoinInfo = F, F.fromDataItem = (le) => {
      const L = le.getData(), pe = L[a.type], $ = L[a.network];
      return new F(pe, $);
    }, F.fromCBOR = (le) => {
      const L = (0, c.decodeToDataItem)(le);
      return F.fromDataItem(L);
    };
  }(CryptoCoinInfo$5)), CryptoCoinInfo$5;
}
var CryptoKeypath$5 = {}, PathComponent$5 = {}, hasRequiredPathComponent$5;
function requirePathComponent$5() {
  if (hasRequiredPathComponent$5) return PathComponent$5;
  hasRequiredPathComponent$5 = 1, Object.defineProperty(PathComponent$5, "__esModule", { value: !0 }), PathComponent$5.PathComponent = void 0;
  class n {
    constructor(u) {
      if (this.getIndex = () => this.index, this.isWildcard = () => this.wildcard, this.isHardened = () => this.hardened, this.index = u.index, this.hardened = u.hardened, this.index !== void 0 ? this.wildcard = !1 : this.wildcard = !0, this.index && this.index & n.HARDENED_BIT)
        throw new Error(`#[ur-registry][PathComponent][fn.constructor]: Invalid index ${this.index} - most significant bit cannot be set`);
    }
  }
  return PathComponent$5.PathComponent = n, n.HARDENED_BIT = 2147483648, PathComponent$5;
}
var hasRequiredCryptoKeypath$5;
function requireCryptoKeypath$5() {
  if (hasRequiredCryptoKeypath$5) return CryptoKeypath$5;
  hasRequiredCryptoKeypath$5 = 1, Object.defineProperty(CryptoKeypath$5, "__esModule", { value: !0 }), CryptoKeypath$5.CryptoKeypath = void 0;
  const n = requireLib$5(), c = requirePathComponent$5(), u = requireRegistryItem$5(), p = requireRegistryType$5();
  var a;
  (function(b) {
    b[b.components = 1] = "components", b[b.source_fingerprint = 2] = "source_fingerprint", b[b.depth = 3] = "depth";
  })(a || (a = {}));
  class A extends u.RegistryItem {
    constructor(F = [], le, L) {
      super(), this.components = F, this.sourceFingerprint = le, this.depth = L, this.getRegistryType = () => p.RegistryTypes.CRYPTO_KEYPATH, this.getPath = () => this.components.length === 0 ? void 0 : this.components.map(($) => `${$.isWildcard() ? "*" : $.getIndex()}${$.isHardened() ? "'" : ""}`).join("/"), this.getComponents = () => this.components, this.getSourceFingerprint = () => this.sourceFingerprint, this.getDepth = () => this.depth, this.toDataItem = () => {
        const pe = {}, $ = [];
        return this.components && this.components.forEach((Ee) => {
          Ee.isWildcard() ? $.push([]) : $.push(Ee.getIndex()), $.push(Ee.isHardened());
        }), pe[a.components] = $, this.sourceFingerprint && (pe[a.source_fingerprint] = this.sourceFingerprint.readUInt32BE(0)), this.depth !== void 0 && (pe[a.depth] = this.depth), new n.DataItem(pe);
      };
    }
  }
  return CryptoKeypath$5.CryptoKeypath = A, A.fromDataItem = (b) => {
    const F = b.getData(), le = [], L = F[a.components];
    if (L)
      for (let be = 0; be < L.length; be += 2) {
        const He = L[be + 1], Pe = L[be];
        typeof Pe == "number" ? le.push(new c.PathComponent({ index: Pe, hardened: He })) : le.push(new c.PathComponent({ hardened: He }));
      }
    const pe = F[a.source_fingerprint];
    let $;
    pe && ($ = Buffer$f.alloc(4), $.writeUInt32BE(pe, 0));
    const Ee = F[a.depth];
    return new A(le, $, Ee);
  }, A.fromCBOR = (b) => {
    const F = (0, n.decodeToDataItem)(b);
    return A.fromDataItem(F);
  }, CryptoKeypath$5;
}
var hasRequiredCryptoHDKey$5;
function requireCryptoHDKey$5() {
  if (hasRequiredCryptoHDKey$5) return CryptoHDKey$5;
  hasRequiredCryptoHDKey$5 = 1, Object.defineProperty(CryptoHDKey$5, "__esModule", { value: !0 }), CryptoHDKey$5.CryptoHDKey = void 0;
  const n = requireBs58check$5(), c = requireCryptoCoinInfo$5(), u = requireCryptoKeypath$5(), p = requireLib$5(), a = requireRegistryItem$5(), A = requireRegistryType$5();
  var b;
  (function(le) {
    le[le.is_master = 1] = "is_master", le[le.is_private = 2] = "is_private", le[le.key_data = 3] = "key_data", le[le.chain_code = 4] = "chain_code", le[le.use_info = 5] = "use_info", le[le.origin = 6] = "origin", le[le.children = 7] = "children", le[le.parent_fingerprint = 8] = "parent_fingerprint", le[le.name = 9] = "name", le[le.note = 10] = "note";
  })(b || (b = {}));
  class F extends a.RegistryItem {
    constructor(L) {
      super(), this.isECKey = () => !1, this.getKey = () => this.key, this.getChainCode = () => this.chainCode, this.isMaster = () => this.master, this.isPrivateKey = () => !!this.privateKey, this.getUseInfo = () => this.useInfo, this.getOrigin = () => this.origin, this.getChildren = () => this.children, this.getParentFingerprint = () => this.parentFingerprint, this.getName = () => this.name, this.getNote = () => this.note, this.getBip32Key = () => {
        var pe, $, Ee;
        let be, He, Pe = 0, nr = Buffer$f.alloc(4).fill(0);
        if (this.isMaster())
          be = Buffer$f.from("0488ADE4", "hex"), He = 0, Pe = 0;
        else {
          He = ((pe = this.getOrigin()) === null || pe === void 0 ? void 0 : pe.getComponents().length) || (($ = this.getOrigin()) === null || $ === void 0 ? void 0 : $.getDepth());
          const xr = (Ee = this.getOrigin()) === null || Ee === void 0 ? void 0 : Ee.getComponents(), kr = xr[xr.length - 1];
          kr && (Pe = kr.isHardened() ? kr.getIndex() + 2147483648 : kr.getIndex(), this.getParentFingerprint() && (nr = this.getParentFingerprint())), this.isPrivateKey() ? be = Buffer$f.from("0488ADE4", "hex") : be = Buffer$f.from("0488B21E", "hex");
        }
        const ir = Buffer$f.alloc(1);
        ir.writeUInt8(He, 0);
        const or = Buffer$f.alloc(4);
        or.writeUInt32BE(Pe, 0);
        const lr = this.getChainCode(), Ir = this.getKey();
        return (0, n.encode)(Buffer$f.concat([be, ir, nr, or, lr, Ir]));
      }, this.getRegistryType = () => A.RegistryTypes.CRYPTO_HDKEY, this.getOutputDescriptorContent = () => {
        var pe, $, Ee, be, He, Pe, nr;
        let ir = "";
        return this.getOrigin() && !((pe = this.getOrigin()) === null || pe === void 0) && pe.getSourceFingerprint() && !(($ = this.getOrigin()) === null || $ === void 0) && $.getPath() && (ir += `${(be = (Ee = this.getOrigin()) === null || Ee === void 0 ? void 0 : Ee.getSourceFingerprint()) === null || be === void 0 ? void 0 : be.toString("hex")}/${(He = this.getOrigin()) === null || He === void 0 ? void 0 : He.getPath()}`), ir += this.getBip32Key(), this.getChildren() && !((Pe = this.getChildren()) === null || Pe === void 0) && Pe.getPath() && (ir += `/${(nr = this.getChildren()) === null || nr === void 0 ? void 0 : nr.getPath()}`), ir;
      }, this.setupMasterKey = (pe) => {
        this.master = !0, this.key = pe.key, this.chainCode = pe.chainCode;
      }, this.setupDeriveKey = (pe) => {
        this.master = !1, this.privateKey = pe.isPrivateKey, this.key = pe.key, this.chainCode = pe.chainCode, this.useInfo = pe.useInfo, this.origin = pe.origin, this.children = pe.children, this.parentFingerprint = pe.parentFingerprint, this.name = pe.name, this.note = pe.note;
      }, this.toDataItem = () => {
        const pe = {};
        if (this.master)
          pe[b.is_master] = !0, pe[b.key_data] = this.key, pe[b.chain_code] = this.chainCode;
        else {
          if (this.privateKey !== void 0 && (pe[b.is_private] = this.privateKey), pe[b.key_data] = this.key, this.chainCode && (pe[b.chain_code] = this.chainCode), this.useInfo) {
            const $ = this.useInfo.toDataItem();
            $.setTag(this.useInfo.getRegistryType().getTag()), pe[b.use_info] = $;
          }
          if (this.origin) {
            const $ = this.origin.toDataItem();
            $.setTag(this.origin.getRegistryType().getTag()), pe[b.origin] = $;
          }
          if (this.children) {
            const $ = this.children.toDataItem();
            $.setTag(this.children.getRegistryType().getTag()), pe[b.children] = $;
          }
          this.parentFingerprint && (pe[b.parent_fingerprint] = this.parentFingerprint.readUInt32BE(0)), this.name !== void 0 && (pe[b.name] = this.name), this.note !== void 0 && (pe[b.note] = this.note);
        }
        return new p.DataItem(pe);
      }, L.isMaster ? this.setupMasterKey(L) : this.setupDeriveKey(L);
    }
  }
  return CryptoHDKey$5.CryptoHDKey = F, F.fromDataItem = (le) => {
    const L = le.getData(), pe = !!L[b.is_master], $ = L[b.is_private], Ee = L[b.key_data], be = L[b.chain_code], He = L[b.use_info] ? c.CryptoCoinInfo.fromDataItem(L[b.use_info]) : void 0, Pe = L[b.origin] ? u.CryptoKeypath.fromDataItem(L[b.origin]) : void 0, nr = L[b.children] ? u.CryptoKeypath.fromDataItem(L[b.children]) : void 0, ir = L[b.parent_fingerprint];
    let or;
    ir && (or = Buffer$f.alloc(4), or.writeUInt32BE(ir, 0));
    const lr = L[b.name], Ir = L[b.note];
    return new F({
      isMaster: pe,
      isPrivateKey: $,
      key: Ee,
      chainCode: be,
      useInfo: He,
      origin: Pe,
      children: nr,
      parentFingerprint: or,
      name: lr,
      note: Ir
    });
  }, F.fromCBOR = (le) => {
    const L = (0, p.decodeToDataItem)(le);
    return F.fromDataItem(L);
  }, CryptoHDKey$5;
}
var CryptoECKey$5 = {}, hasRequiredCryptoECKey$5;
function requireCryptoECKey$5() {
  if (hasRequiredCryptoECKey$5) return CryptoECKey$5;
  hasRequiredCryptoECKey$5 = 1, Object.defineProperty(CryptoECKey$5, "__esModule", { value: !0 }), CryptoECKey$5.CryptoECKey = void 0;
  const n = requireLib$5(), c = requireRegistryItem$5(), u = requireRegistryType$5();
  var p;
  (function(A) {
    A[A.curve = 1] = "curve", A[A.private = 2] = "private", A[A.data = 3] = "data";
  })(p || (p = {}));
  class a extends c.RegistryItem {
    constructor(b) {
      super(), this.isECKey = () => !0, this.getCurve = () => this.curve || 0, this.isPrivateKey = () => this.privateKey || !1, this.getData = () => this.data, this.getRegistryType = () => u.RegistryTypes.CRYPTO_ECKEY, this.toDataItem = () => {
        const F = {};
        return this.curve && (F[p.curve] = this.curve), this.privateKey !== void 0 && (F[p.private] = this.privateKey), F[p.data] = this.data, new n.DataItem(F);
      }, this.getOutputDescriptorContent = () => this.data.toString("hex"), this.data = b.data, this.curve = b.curve, this.privateKey = b.privateKey || void 0;
    }
  }
  return CryptoECKey$5.CryptoECKey = a, a.fromDataItem = (A) => {
    const b = A.getData(), F = b[p.curve], le = b[p.private], L = b[p.data];
    if (!L)
      throw new Error(`#[ur-registry][CryptoECKey][fn.fromDataItem]: decoded [dataItem][#data.data] is undefined: ${A}`);
    return new a({ data: L, curve: F, privateKey: le });
  }, a.fromCBOR = (A) => {
    const b = (0, n.decodeToDataItem)(A);
    return a.fromDataItem(b);
  }, CryptoECKey$5;
}
var Bytes$6 = {}, hasRequiredBytes$5;
function requireBytes$5() {
  if (hasRequiredBytes$5) return Bytes$6;
  hasRequiredBytes$5 = 1, Object.defineProperty(Bytes$6, "__esModule", { value: !0 }), Bytes$6.Bytes = void 0;
  const n = requireLib$5(), c = requireRegistryItem$5(), u = requireRegistryType$5();
  class p extends c.RegistryItem {
    constructor(A) {
      super(), this.bytes = A, this.getRegistryType = () => u.RegistryTypes.BYTES, this.getData = () => this.bytes, this.toDataItem = () => new n.DataItem(this.bytes);
    }
  }
  return Bytes$6.Bytes = p, p.fromDataItem = (a) => {
    const A = a.getData();
    if (!A)
      throw new Error(`#[ur-registry][Bytes][fn.fromDataItem]: decoded [dataItem][#data] is undefined: ${a}`);
    return new p(A);
  }, p.fromCBOR = (a) => {
    const A = (0, n.decodeToDataItem)(a);
    return p.fromDataItem(A);
  }, Bytes$6;
}
var CryptoOutput$5 = {}, MultiKey$5 = {}, hasRequiredMultiKey$5;
function requireMultiKey$5() {
  if (hasRequiredMultiKey$5) return MultiKey$5;
  hasRequiredMultiKey$5 = 1, Object.defineProperty(MultiKey$5, "__esModule", { value: !0 }), MultiKey$5.MultiKey = void 0;
  const n = requireCryptoECKey$5(), c = requireCryptoHDKey$5(), u = requireDataItem$5(), p = requireRegistryItem$5(), a = requireRegistryType$5();
  var A;
  (function(F) {
    F[F.threshold = 1] = "threshold", F[F.keys = 2] = "keys";
  })(A || (A = {}));
  class b extends p.RegistryItem {
    constructor(le, L) {
      super(), this.threshold = le, this.keys = L, this.getThreshold = () => this.threshold, this.getKeys = () => this.keys, this.toDataItem = () => {
        const pe = {};
        pe[A.threshold] = this.threshold;
        const $ = this.keys.map((Ee) => {
          const be = Ee.toDataItem();
          return be.setTag(Ee.getRegistryType().getTag()), be;
        });
        return pe[A.keys] = $, new u.DataItem(pe);
      }, this.getOutputDescriptorContent = () => [
        this.getThreshold(),
        this.keys.map((pe) => pe.getOutputDescriptorContent()).join(",")
      ].join(",");
    }
  }
  return MultiKey$5.MultiKey = b, b.fromDataItem = (F) => {
    const le = F.getData(), L = le[A.threshold], pe = le[A.keys], $ = [];
    return pe.forEach((Ee) => {
      Ee.getTag() === a.RegistryTypes.CRYPTO_HDKEY.getTag() ? $.push(c.CryptoHDKey.fromDataItem(Ee)) : Ee.getTag() === a.RegistryTypes.CRYPTO_ECKEY.getTag() && $.push(n.CryptoECKey.fromDataItem(Ee));
    }), new b(L, $);
  }, MultiKey$5;
}
var hasRequiredCryptoOutput$5;
function requireCryptoOutput$5() {
  if (hasRequiredCryptoOutput$5) return CryptoOutput$5;
  hasRequiredCryptoOutput$5 = 1, Object.defineProperty(CryptoOutput$5, "__esModule", { value: !0 }), CryptoOutput$5.CryptoOutput = void 0;
  const n = requireCryptoECKey$5(), c = requireCryptoHDKey$5(), u = requireLib$5(), p = requireMultiKey$5(), a = requireRegistryItem$5(), A = requireRegistryType$5(), b = requireScriptExpression$5();
  class F extends a.RegistryItem {
    constructor(L, pe) {
      super(), this.scriptExpressions = L, this.cryptoKey = pe, this.getRegistryType = () => A.RegistryTypes.CRYPTO_OUTPUT, this.getCryptoKey = () => this.cryptoKey, this.getHDKey = () => {
        if (this.cryptoKey instanceof c.CryptoHDKey)
          return this.cryptoKey;
      }, this.getECKey = () => {
        if (this.cryptoKey instanceof n.CryptoECKey)
          return this.cryptoKey;
      }, this.getMultiKey = () => {
        if (this.cryptoKey instanceof p.MultiKey)
          return this.cryptoKey;
      }, this.getScriptExpressions = () => this.scriptExpressions, this._toOutputDescriptor = ($) => $ >= this.scriptExpressions.length ? this.cryptoKey.getOutputDescriptorContent() : `${this.scriptExpressions[$].getExpression()}(${this._toOutputDescriptor($ + 1)})`, this.toString = () => this._toOutputDescriptor(0), this.toDataItem = () => {
        let $ = this.cryptoKey.toDataItem();
        return (this.cryptoKey instanceof n.CryptoECKey || this.cryptoKey instanceof c.CryptoHDKey) && $.setTag(this.cryptoKey.getRegistryType().getTag()), [...this.scriptExpressions].reverse().forEach((be) => {
          const He = be.getTag();
          $.getTag() === void 0 ? $.setTag(He) : $ = new u.DataItem($, He);
        }), $;
      };
    }
  }
  return CryptoOutput$5.CryptoOutput = F, F.fromDataItem = (le) => {
    const L = [];
    let pe = le;
    for (; ; ) {
      let be = pe.getTag();
      const He = b.ScriptExpression.fromTag(be);
      if (He)
        if (L.push(He), pe.getData() instanceof u.DataItem)
          pe = pe.getData(), be = pe.getTag();
        else
          break;
      else
        break;
    }
    const $ = L.length;
    if ($ > 0 && (L[$ - 1].getExpression() === b.ScriptExpressions.MULTISIG.getExpression() || L[$ - 1].getExpression() === b.ScriptExpressions.SORTED_MULTISIG.getExpression())) {
      const be = p.MultiKey.fromDataItem(pe);
      return new F(L, be);
    }
    if (pe.getTag() === A.RegistryTypes.CRYPTO_HDKEY.getTag()) {
      const be = c.CryptoHDKey.fromDataItem(pe);
      return new F(L, be);
    } else {
      const be = n.CryptoECKey.fromDataItem(pe);
      return new F(L, be);
    }
  }, F.fromCBOR = (le) => {
    const L = (0, u.decodeToDataItem)(le);
    return F.fromDataItem(L);
  }, CryptoOutput$5;
}
var CryptoPSBT$5 = {}, hasRequiredCryptoPSBT$5;
function requireCryptoPSBT$5() {
  if (hasRequiredCryptoPSBT$5) return CryptoPSBT$5;
  hasRequiredCryptoPSBT$5 = 1, Object.defineProperty(CryptoPSBT$5, "__esModule", { value: !0 }), CryptoPSBT$5.CryptoPSBT = void 0;
  const n = requireLib$5(), c = requireRegistryItem$5(), u = requireRegistryType$5();
  class p extends c.RegistryItem {
    constructor(A) {
      super(), this.psbt = A, this.getRegistryType = () => u.RegistryTypes.CRYPTO_PSBT, this.getPSBT = () => this.psbt, this.toDataItem = () => new n.DataItem(this.psbt);
    }
  }
  return CryptoPSBT$5.CryptoPSBT = p, p.fromDataItem = (a) => {
    const A = a.getData();
    if (!A)
      throw new Error(`#[ur-registry][CryptoPSBT][fn.fromDataItem]: decoded [dataItem][#data] is undefined: ${a}`);
    return new p(A);
  }, p.fromCBOR = (a) => {
    const A = (0, n.decodeToDataItem)(a);
    return p.fromDataItem(A);
  }, CryptoPSBT$5;
}
var CryptoAccount$5 = {}, hasRequiredCryptoAccount$5;
function requireCryptoAccount$5() {
  if (hasRequiredCryptoAccount$5) return CryptoAccount$5;
  hasRequiredCryptoAccount$5 = 1, Object.defineProperty(CryptoAccount$5, "__esModule", { value: !0 }), CryptoAccount$5.CryptoAccount = void 0;
  const n = requireDist$5(), c = requireLib$5(), u = requireRegistryItem$5(), p = requireRegistryType$5();
  var a;
  (function(b) {
    b[b.masterFingerprint = 1] = "masterFingerprint", b[b.outputDescriptors = 2] = "outputDescriptors";
  })(a || (a = {}));
  class A extends u.RegistryItem {
    constructor(F, le) {
      super(), this.masterFingerprint = F, this.outputDescriptors = le, this.getRegistryType = () => p.RegistryTypes.CRYPTO_ACCOUNT, this.getMasterFingerprint = () => this.masterFingerprint, this.getOutputDescriptors = () => this.outputDescriptors, this.toDataItem = () => {
        const L = {};
        return this.masterFingerprint && (L[a.masterFingerprint] = this.masterFingerprint.readUInt32BE(0)), this.outputDescriptors && (L[a.outputDescriptors] = this.outputDescriptors.map((pe) => pe.toDataItem())), new c.DataItem(L);
      };
    }
  }
  return CryptoAccount$5.CryptoAccount = A, A.fromDataItem = (b) => {
    const F = b.getData(), le = Buffer$f.alloc(4), L = F[a.masterFingerprint];
    L && le.writeUInt32BE(L, 0);
    const $ = F[a.outputDescriptors].map((Ee) => n.CryptoOutput.fromDataItem(Ee));
    return new A(le, $);
  }, A.fromCBOR = (b) => {
    const F = (0, c.decodeToDataItem)(b);
    return A.fromDataItem(F);
  }, CryptoAccount$5;
}
var Decoder$5 = {}, errors$6 = {}, hasRequiredErrors$5;
function requireErrors$5() {
  if (hasRequiredErrors$5) return errors$6;
  hasRequiredErrors$5 = 1, Object.defineProperty(errors$6, "__esModule", { value: !0 }), errors$6.UnknownURTypeError = void 0;
  class n extends Error {
    constructor(u) {
      super(u);
    }
  }
  return errors$6.UnknownURTypeError = n, errors$6;
}
var hasRequiredDecoder$5;
function requireDecoder$5() {
  if (hasRequiredDecoder$5) return Decoder$5;
  hasRequiredDecoder$5 = 1, Object.defineProperty(Decoder$5, "__esModule", { value: !0 }), Decoder$5.URRegistryDecoder = void 0;
  const n = dist$t, c = requireDist$5(), u = requireRegistryType$5(), p = requireErrors$5();
  class a extends n.URDecoder {
    constructor() {
      super(...arguments), this.resultRegistryType = () => {
        const b = this.resultUR();
        switch (b.type) {
          case u.RegistryTypes.BYTES.getType():
            return c.Bytes.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_HDKEY.getType():
            return c.CryptoHDKey.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_KEYPATH.getType():
            return c.CryptoKeypath.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_COIN_INFO.getType():
            return c.CryptoCoinInfo.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_ECKEY.getType():
            return c.CryptoECKey.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_OUTPUT.getType():
            return c.CryptoOutput.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_PSBT.getType():
            return c.CryptoPSBT.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_ACCOUNT.getType():
            return c.CryptoAccount.fromCBOR(b.cbor);
          default:
            throw new p.UnknownURTypeError(`#[ur-registry][Decoder][fn.resultRegistryType]: registry type ${b.type} is not supported now`);
        }
      };
    }
  }
  return Decoder$5.URRegistryDecoder = a, Decoder$5;
}
var CryptoMultiAccounts$5 = {}, hasRequiredCryptoMultiAccounts$5;
function requireCryptoMultiAccounts$5() {
  if (hasRequiredCryptoMultiAccounts$5) return CryptoMultiAccounts$5;
  hasRequiredCryptoMultiAccounts$5 = 1, Object.defineProperty(CryptoMultiAccounts$5, "__esModule", { value: !0 }), CryptoMultiAccounts$5.CryptoMultiAccounts = void 0;
  const n = requireRegistryType$5(), c = requireCryptoHDKey$5(), u = requireRegistryItem$5(), p = requireLib$5();
  var a;
  (function(b) {
    b[b.masterFingerprint = 1] = "masterFingerprint", b[b.keys = 2] = "keys", b[b.device = 3] = "device", b[b.deviceId = 4] = "deviceId", b[b.version = 5] = "version";
  })(a || (a = {}));
  class A extends u.RegistryItem {
    constructor(F, le, L, pe, $) {
      super(), this.masterFingerprint = F, this.keys = le, this.device = L, this.deviceId = pe, this.version = $, this.getRegistryType = () => n.RegistryTypes.CRYPTO_MULTI_ACCOUNTS, this.getMasterFingerprint = () => this.masterFingerprint, this.getKeys = () => this.keys, this.getDevice = () => this.device, this.getDeviceId = () => this.deviceId, this.getVersion = () => this.version, this.toDataItem = () => {
        const Ee = {};
        return this.masterFingerprint && (Ee[a.masterFingerprint] = this.masterFingerprint.readUInt32BE(0)), this.keys && (Ee[a.keys] = this.keys.map((be) => {
          const He = be.toDataItem();
          return He.setTag(be.getRegistryType().getTag()), He;
        })), this.device && (Ee[a.device] = this.device), this.deviceId && (Ee[a.deviceId] = this.deviceId), this.version && (Ee[a.version] = this.version), new p.DataItem(Ee);
      };
    }
  }
  return CryptoMultiAccounts$5.CryptoMultiAccounts = A, A.fromDataItem = (b) => {
    const F = b.getData(), le = Buffer$f.alloc(4), L = F[a.masterFingerprint];
    L && le.writeUInt32BE(L, 0);
    const $ = F[a.keys].map((Pe) => c.CryptoHDKey.fromDataItem(Pe)), Ee = F[a.device], be = F[a.deviceId], He = F[a.version];
    return new A(le, $, Ee, be, He);
  }, A.fromCBOR = (b) => {
    const F = (0, p.decodeToDataItem)(b);
    return A.fromDataItem(F);
  }, CryptoMultiAccounts$5;
}
var QRHardwareCall$5 = {}, KeyDerivation$5 = {}, DerivationSchema$5 = {}, hasRequiredDerivationSchema$5;
function requireDerivationSchema$5() {
  return hasRequiredDerivationSchema$5 || (hasRequiredDerivationSchema$5 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.KeyDerivationSchema = n.DerivationAlgorithm = n.Curve = void 0;
    const c = requireRegistryType$5(), u = requireRegistryItem$5(), p = requireLib$5(), a = requireCryptoKeypath$5();
    var A;
    (function(L) {
      L[L.keyPath = 1] = "keyPath", L[L.curve = 2] = "curve", L[L.algo = 3] = "algo";
    })(A || (A = {}));
    var b;
    (function(L) {
      L[L.secp256k1 = 0] = "secp256k1", L[L.ed25519 = 1] = "ed25519";
    })(b = n.Curve || (n.Curve = {}));
    var F;
    (function(L) {
      L[L.slip10 = 0] = "slip10", L[L.bip32ed25519 = 1] = "bip32ed25519";
    })(F = n.DerivationAlgorithm || (n.DerivationAlgorithm = {}));
    class le extends u.RegistryItem {
      constructor(pe, $ = b.secp256k1, Ee = F.slip10) {
        super(), this.keypath = pe, this.curve = $, this.algo = Ee, this.getRegistryType = () => c.RegistryTypes.KEY_DERIVATION_SCHEMA, this.getKeypath = () => this.keypath, this.getCurve = () => this.curve, this.getAlgo = () => this.algo, this.toDataItem = () => {
          const be = {}, He = this.getKeypath().toDataItem();
          return He.setTag(this.getKeypath().getRegistryType().getTag()), be[A.keyPath] = He, be[A.curve] = this.curve, be[A.algo] = this.algo, new p.DataItem(be);
        };
      }
    }
    n.KeyDerivationSchema = le, le.fromDataItem = (L) => {
      const pe = L.getData(), $ = a.CryptoKeypath.fromDataItem(pe[A.keyPath]), Ee = pe[A.curve], be = pe[A.algo];
      return new le($, Ee, be);
    }, le.fromCBOR = (L) => {
      const pe = (0, p.decodeToDataItem)(L);
      return le.fromDataItem(pe);
    };
  }(DerivationSchema$5)), DerivationSchema$5;
}
var hasRequiredKeyDerivation$5;
function requireKeyDerivation$5() {
  if (hasRequiredKeyDerivation$5) return KeyDerivation$5;
  hasRequiredKeyDerivation$5 = 1, Object.defineProperty(KeyDerivation$5, "__esModule", { value: !0 }), KeyDerivation$5.KeyDerivation = void 0;
  const n = requireRegistryType$5(), c = requireRegistryItem$5(), u = requireLib$5(), p = requireDerivationSchema$5();
  var a;
  (function(b) {
    b[b.schemas = 1] = "schemas";
  })(a || (a = {}));
  class A extends c.RegistryItem {
    constructor(F) {
      super(), this.schemas = F, this.getRegistryType = () => n.RegistryTypes.KEY_DERIVATION_CALL, this.getSchemas = () => this.schemas, this.toDataItem = () => {
        const le = {};
        return le[a.schemas] = this.schemas.map((L) => {
          const pe = L.toDataItem();
          return pe.setTag(L.getRegistryType().getTag()), pe;
        }), new u.DataItem(le);
      };
    }
  }
  return KeyDerivation$5.KeyDerivation = A, A.fromDataItem = (b) => {
    const le = b.getData()[a.schemas].map((L) => p.KeyDerivationSchema.fromDataItem(L));
    return new A(le);
  }, A.fromCBOR = (b) => {
    const F = (0, u.decodeToDataItem)(b);
    return A.fromDataItem(F);
  }, KeyDerivation$5;
}
var hasRequiredQRHardwareCall$5;
function requireQRHardwareCall$5() {
  return hasRequiredQRHardwareCall$5 || (hasRequiredQRHardwareCall$5 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.QRHardwareCall = n.QRHardwareCallType = void 0;
    const c = requireRegistryType$5(), u = requireRegistryItem$5(), p = requireLib$5(), a = requireKeyDerivation$5();
    var A;
    (function(le) {
      le[le.type = 1] = "type", le[le.params = 2] = "params", le[le.origin = 3] = "origin";
    })(A || (A = {}));
    var b;
    (function(le) {
      le[le.KeyDerivation = 0] = "KeyDerivation";
    })(b = n.QRHardwareCallType || (n.QRHardwareCallType = {}));
    class F extends u.RegistryItem {
      constructor(L, pe, $) {
        super(), this.type = L, this.params = pe, this.origin = $, this.getRegistryType = () => c.RegistryTypes.QR_HARDWARE_CALL, this.getType = () => this.type, this.getParams = () => this.params, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const Ee = {};
          Ee[A.type] = this.type;
          const be = this.params.toDataItem();
          return be.setTag(this.params.getRegistryType().getTag()), Ee[A.params] = be, this.origin && (Ee[A.origin] = this.origin), new p.DataItem(Ee);
        };
      }
    }
    n.QRHardwareCall = F, F.fromDataItem = (le) => {
      const L = le.getData(), pe = L[A.type] || b.KeyDerivation;
      let $;
      switch (pe) {
        case b.KeyDerivation:
          $ = a.KeyDerivation.fromDataItem(L[A.params]);
      }
      const Ee = L[A.origin];
      return new F(pe, $, Ee);
    }, F.fromCBOR = (le) => {
      const L = (0, p.decodeToDataItem)(le);
      return F.fromDataItem(L);
    };
  }(QRHardwareCall$5)), QRHardwareCall$5;
}
var types$a = {}, hasRequiredTypes$5;
function requireTypes$5() {
  return hasRequiredTypes$5 || (hasRequiredTypes$5 = 1, Object.defineProperty(types$a, "__esModule", { value: !0 })), types$a;
}
var hasRequiredDist$5;
function requireDist$5() {
  return hasRequiredDist$5 || (hasRequiredDist$5 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.Buffer = n.extend = n.PathComponent = n.ScriptExpressions = n.MultiKey = n.CryptoPSBT = n.CryptoOutput = n.CryptoECKey = n.CryptoCoinInfoNetwork = n.CryptoCoinInfoType = n.CryptoCoinInfo = n.CryptoKeypath = n.CryptoMultiAccounts = n.CryptoHDKey = n.CryptoAccount = n.Bytes = n.URRegistryDecoder = n.DataItem = void 0;
    const c = require$$0$4;
    requirePatchCBOR$5();
    const u = dist$u;
    Object.defineProperty(n, "Buffer", { enumerable: !0, get: function() {
      return u.Buffer;
    } });
    const p = requireCryptoHDKey$5();
    Object.defineProperty(n, "CryptoHDKey", { enumerable: !0, get: function() {
      return p.CryptoHDKey;
    } });
    const a = requireCryptoKeypath$5();
    Object.defineProperty(n, "CryptoKeypath", { enumerable: !0, get: function() {
      return a.CryptoKeypath;
    } });
    const A = requireCryptoCoinInfo$5();
    Object.defineProperty(n, "CryptoCoinInfo", { enumerable: !0, get: function() {
      return A.CryptoCoinInfo;
    } }), Object.defineProperty(n, "CryptoCoinInfoType", { enumerable: !0, get: function() {
      return A.Type;
    } }), Object.defineProperty(n, "CryptoCoinInfoNetwork", { enumerable: !0, get: function() {
      return A.Network;
    } });
    const b = requireCryptoECKey$5();
    Object.defineProperty(n, "CryptoECKey", { enumerable: !0, get: function() {
      return b.CryptoECKey;
    } });
    const F = requireBytes$5();
    Object.defineProperty(n, "Bytes", { enumerable: !0, get: function() {
      return F.Bytes;
    } });
    const le = requireCryptoOutput$5();
    Object.defineProperty(n, "CryptoOutput", { enumerable: !0, get: function() {
      return le.CryptoOutput;
    } });
    const L = requireCryptoPSBT$5();
    Object.defineProperty(n, "CryptoPSBT", { enumerable: !0, get: function() {
      return L.CryptoPSBT;
    } });
    const pe = requireCryptoAccount$5();
    Object.defineProperty(n, "CryptoAccount", { enumerable: !0, get: function() {
      return pe.CryptoAccount;
    } });
    const $ = requireDecoder$5();
    Object.defineProperty(n, "URRegistryDecoder", { enumerable: !0, get: function() {
      return $.URRegistryDecoder;
    } });
    const Ee = requireMultiKey$5();
    Object.defineProperty(n, "MultiKey", { enumerable: !0, get: function() {
      return Ee.MultiKey;
    } });
    const be = requireScriptExpression$5();
    Object.defineProperty(n, "ScriptExpressions", { enumerable: !0, get: function() {
      return be.ScriptExpressions;
    } });
    const He = requirePathComponent$5();
    Object.defineProperty(n, "PathComponent", { enumerable: !0, get: function() {
      return He.PathComponent;
    } });
    const Pe = requireRegistryItem$5(), nr = requireRegistryType$5(), ir = requireLib$5();
    var or = requireLib$5();
    Object.defineProperty(n, "DataItem", { enumerable: !0, get: function() {
      return or.DataItem;
    } });
    const lr = requireUtils$5(), Ir = requireCryptoMultiAccounts$5();
    Object.defineProperty(n, "CryptoMultiAccounts", { enumerable: !0, get: function() {
      return Ir.CryptoMultiAccounts;
    } });
    const xr = {
      URRegistryDecoder: $.URRegistryDecoder,
      Bytes: F.Bytes,
      CryptoAccount: pe.CryptoAccount,
      CryptoHDKey: p.CryptoHDKey,
      CryptoMultiAccounts: Ir.CryptoMultiAccounts,
      CryptoKeypath: a.CryptoKeypath,
      CryptoCoinInfo: A.CryptoCoinInfo,
      CryptoCoinInfoType: A.Type,
      CryptoCoinInfoNetwork: A.Network,
      CryptoECKey: b.CryptoECKey,
      CryptoOutput: le.CryptoOutput,
      CryptoPSBT: L.CryptoPSBT,
      MultiKey: Ee.MultiKey,
      ScriptExpressions: be.ScriptExpressions,
      PathComponent: He.PathComponent
    }, kr = {
      addReader: ir.addReader,
      addSemanticDecode: ir.addSemanticDecode,
      addSemanticEncode: ir.addSemanticEncode,
      addWriter: ir.addWriter,
      patchTags: lr.patchTags
    }, Ce = {
      RegistryTypes: nr.RegistryTypes,
      RegistryItem: Pe.RegistryItem,
      RegistryType: nr.RegistryType,
      decodeToDataItem: ir.decodeToDataItem,
      encodeDataItem: ir.encodeDataItem,
      cbor: kr
    };
    n.extend = Ce, (0, c.__exportStar)(requireErrors$5(), n), (0, c.__exportStar)(requireDecoder$5(), n), (0, c.__exportStar)(requireLib$5(), n), (0, c.__exportStar)(requireCryptoAccount$5(), n), (0, c.__exportStar)(requireCryptoPSBT$5(), n), (0, c.__exportStar)(requireCryptoHDKey$5(), n), (0, c.__exportStar)(requireCryptoMultiAccounts$5(), n), (0, c.__exportStar)(requireQRHardwareCall$5(), n), (0, c.__exportStar)(requireKeyDerivation$5(), n), (0, c.__exportStar)(requireDerivationSchema$5(), n), (0, c.__exportStar)(requireCryptoOutput$5(), n), (0, c.__exportStar)(requireCryptoCoinInfo$5(), n), (0, c.__exportStar)(requireCryptoECKey$5(), n), (0, c.__exportStar)(requireMultiKey$5(), n), (0, c.__exportStar)(requireCryptoKeypath$5(), n), (0, c.__exportStar)(requirePatchCBOR$5(), n), (0, c.__exportStar)(requirePathComponent$5(), n), (0, c.__exportStar)(requireRegistryItem$5(), n), (0, c.__exportStar)(requireRegistryType$5(), n), (0, c.__exportStar)(requireTypes$5(), n), (0, c.__exportStar)(requireUtils$5(), n), n.default = xr;
  }(dist$e)), dist$e;
}
var getRandomValues$6, rnds8$4 = new Uint8Array(16);
function rng$6() {
  if (!getRandomValues$6 && (getRandomValues$6 = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !getRandomValues$6))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return getRandomValues$6(rnds8$4);
}
const REGEX$3 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function validate$6(n) {
  return typeof n == "string" && REGEX$3.test(n);
}
var byteToHex$4 = [];
for (var i$5 = 0; i$5 < 256; ++i$5)
  byteToHex$4.push((i$5 + 256).toString(16).substr(1));
function stringify$5(n) {
  var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, u = (byteToHex$4[n[c + 0]] + byteToHex$4[n[c + 1]] + byteToHex$4[n[c + 2]] + byteToHex$4[n[c + 3]] + "-" + byteToHex$4[n[c + 4]] + byteToHex$4[n[c + 5]] + "-" + byteToHex$4[n[c + 6]] + byteToHex$4[n[c + 7]] + "-" + byteToHex$4[n[c + 8]] + byteToHex$4[n[c + 9]] + "-" + byteToHex$4[n[c + 10]] + byteToHex$4[n[c + 11]] + byteToHex$4[n[c + 12]] + byteToHex$4[n[c + 13]] + byteToHex$4[n[c + 14]] + byteToHex$4[n[c + 15]]).toLowerCase();
  if (!validate$6(u))
    throw TypeError("Stringified UUID is invalid");
  return u;
}
var _nodeId$3, _clockseq$3, _lastMSecs$3 = 0, _lastNSecs$3 = 0;
function v1$5(n, c, u) {
  var p = c && u || 0, a = c || new Array(16);
  n = n || {};
  var A = n.node || _nodeId$3, b = n.clockseq !== void 0 ? n.clockseq : _clockseq$3;
  if (A == null || b == null) {
    var F = n.random || (n.rng || rng$6)();
    A == null && (A = _nodeId$3 = [F[0] | 1, F[1], F[2], F[3], F[4], F[5]]), b == null && (b = _clockseq$3 = (F[6] << 8 | F[7]) & 16383);
  }
  var le = n.msecs !== void 0 ? n.msecs : Date.now(), L = n.nsecs !== void 0 ? n.nsecs : _lastNSecs$3 + 1, pe = le - _lastMSecs$3 + (L - _lastNSecs$3) / 1e4;
  if (pe < 0 && n.clockseq === void 0 && (b = b + 1 & 16383), (pe < 0 || le > _lastMSecs$3) && n.nsecs === void 0 && (L = 0), L >= 1e4)
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  _lastMSecs$3 = le, _lastNSecs$3 = L, _clockseq$3 = b, le += 122192928e5;
  var $ = ((le & 268435455) * 1e4 + L) % 4294967296;
  a[p++] = $ >>> 24 & 255, a[p++] = $ >>> 16 & 255, a[p++] = $ >>> 8 & 255, a[p++] = $ & 255;
  var Ee = le / 4294967296 * 1e4 & 268435455;
  a[p++] = Ee >>> 8 & 255, a[p++] = Ee & 255, a[p++] = Ee >>> 24 & 15 | 16, a[p++] = Ee >>> 16 & 255, a[p++] = b >>> 8 | 128, a[p++] = b & 255;
  for (var be = 0; be < 6; ++be)
    a[p + be] = A[be];
  return c || stringify$5(a);
}
function parse$c(n) {
  if (!validate$6(n))
    throw TypeError("Invalid UUID");
  var c, u = new Uint8Array(16);
  return u[0] = (c = parseInt(n.slice(0, 8), 16)) >>> 24, u[1] = c >>> 16 & 255, u[2] = c >>> 8 & 255, u[3] = c & 255, u[4] = (c = parseInt(n.slice(9, 13), 16)) >>> 8, u[5] = c & 255, u[6] = (c = parseInt(n.slice(14, 18), 16)) >>> 8, u[7] = c & 255, u[8] = (c = parseInt(n.slice(19, 23), 16)) >>> 8, u[9] = c & 255, u[10] = (c = parseInt(n.slice(24, 36), 16)) / 1099511627776 & 255, u[11] = c / 4294967296 & 255, u[12] = c >>> 24 & 255, u[13] = c >>> 16 & 255, u[14] = c >>> 8 & 255, u[15] = c & 255, u;
}
function stringToBytes$4(n) {
  n = unescape(encodeURIComponent(n));
  for (var c = [], u = 0; u < n.length; ++u)
    c.push(n.charCodeAt(u));
  return c;
}
var DNS$3 = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", URL$4 = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
function v35$5(n, c, u) {
  function p(a, A, b, F) {
    if (typeof a == "string" && (a = stringToBytes$4(a)), typeof A == "string" && (A = parse$c(A)), A.length !== 16)
      throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    var le = new Uint8Array(16 + a.length);
    if (le.set(A), le.set(a, A.length), le = u(le), le[6] = le[6] & 15 | c, le[8] = le[8] & 63 | 128, b) {
      F = F || 0;
      for (var L = 0; L < 16; ++L)
        b[F + L] = le[L];
      return b;
    }
    return stringify$5(le);
  }
  try {
    p.name = n;
  } catch {
  }
  return p.DNS = DNS$3, p.URL = URL$4, p;
}
function md5$5(n) {
  if (typeof n == "string") {
    var c = unescape(encodeURIComponent(n));
    n = new Uint8Array(c.length);
    for (var u = 0; u < c.length; ++u)
      n[u] = c.charCodeAt(u);
  }
  return md5ToHexEncodedArray$3(wordsToMd5$3(bytesToWords$3(n), n.length * 8));
}
function md5ToHexEncodedArray$3(n) {
  for (var c = [], u = n.length * 32, p = "0123456789abcdef", a = 0; a < u; a += 8) {
    var A = n[a >> 5] >>> a % 32 & 255, b = parseInt(p.charAt(A >>> 4 & 15) + p.charAt(A & 15), 16);
    c.push(b);
  }
  return c;
}
function getOutputLength$3(n) {
  return (n + 64 >>> 9 << 4) + 14 + 1;
}
function wordsToMd5$3(n, c) {
  n[c >> 5] |= 128 << c % 32, n[getOutputLength$3(c) - 1] = c;
  for (var u = 1732584193, p = -271733879, a = -1732584194, A = 271733878, b = 0; b < n.length; b += 16) {
    var F = u, le = p, L = a, pe = A;
    u = md5ff$3(u, p, a, A, n[b], 7, -680876936), A = md5ff$3(A, u, p, a, n[b + 1], 12, -389564586), a = md5ff$3(a, A, u, p, n[b + 2], 17, 606105819), p = md5ff$3(p, a, A, u, n[b + 3], 22, -1044525330), u = md5ff$3(u, p, a, A, n[b + 4], 7, -176418897), A = md5ff$3(A, u, p, a, n[b + 5], 12, 1200080426), a = md5ff$3(a, A, u, p, n[b + 6], 17, -1473231341), p = md5ff$3(p, a, A, u, n[b + 7], 22, -45705983), u = md5ff$3(u, p, a, A, n[b + 8], 7, 1770035416), A = md5ff$3(A, u, p, a, n[b + 9], 12, -1958414417), a = md5ff$3(a, A, u, p, n[b + 10], 17, -42063), p = md5ff$3(p, a, A, u, n[b + 11], 22, -1990404162), u = md5ff$3(u, p, a, A, n[b + 12], 7, 1804603682), A = md5ff$3(A, u, p, a, n[b + 13], 12, -40341101), a = md5ff$3(a, A, u, p, n[b + 14], 17, -1502002290), p = md5ff$3(p, a, A, u, n[b + 15], 22, 1236535329), u = md5gg$3(u, p, a, A, n[b + 1], 5, -165796510), A = md5gg$3(A, u, p, a, n[b + 6], 9, -1069501632), a = md5gg$3(a, A, u, p, n[b + 11], 14, 643717713), p = md5gg$3(p, a, A, u, n[b], 20, -373897302), u = md5gg$3(u, p, a, A, n[b + 5], 5, -701558691), A = md5gg$3(A, u, p, a, n[b + 10], 9, 38016083), a = md5gg$3(a, A, u, p, n[b + 15], 14, -660478335), p = md5gg$3(p, a, A, u, n[b + 4], 20, -405537848), u = md5gg$3(u, p, a, A, n[b + 9], 5, 568446438), A = md5gg$3(A, u, p, a, n[b + 14], 9, -1019803690), a = md5gg$3(a, A, u, p, n[b + 3], 14, -187363961), p = md5gg$3(p, a, A, u, n[b + 8], 20, 1163531501), u = md5gg$3(u, p, a, A, n[b + 13], 5, -1444681467), A = md5gg$3(A, u, p, a, n[b + 2], 9, -51403784), a = md5gg$3(a, A, u, p, n[b + 7], 14, 1735328473), p = md5gg$3(p, a, A, u, n[b + 12], 20, -1926607734), u = md5hh$3(u, p, a, A, n[b + 5], 4, -378558), A = md5hh$3(A, u, p, a, n[b + 8], 11, -2022574463), a = md5hh$3(a, A, u, p, n[b + 11], 16, 1839030562), p = md5hh$3(p, a, A, u, n[b + 14], 23, -35309556), u = md5hh$3(u, p, a, A, n[b + 1], 4, -1530992060), A = md5hh$3(A, u, p, a, n[b + 4], 11, 1272893353), a = md5hh$3(a, A, u, p, n[b + 7], 16, -155497632), p = md5hh$3(p, a, A, u, n[b + 10], 23, -1094730640), u = md5hh$3(u, p, a, A, n[b + 13], 4, 681279174), A = md5hh$3(A, u, p, a, n[b], 11, -358537222), a = md5hh$3(a, A, u, p, n[b + 3], 16, -722521979), p = md5hh$3(p, a, A, u, n[b + 6], 23, 76029189), u = md5hh$3(u, p, a, A, n[b + 9], 4, -640364487), A = md5hh$3(A, u, p, a, n[b + 12], 11, -421815835), a = md5hh$3(a, A, u, p, n[b + 15], 16, 530742520), p = md5hh$3(p, a, A, u, n[b + 2], 23, -995338651), u = md5ii$3(u, p, a, A, n[b], 6, -198630844), A = md5ii$3(A, u, p, a, n[b + 7], 10, 1126891415), a = md5ii$3(a, A, u, p, n[b + 14], 15, -1416354905), p = md5ii$3(p, a, A, u, n[b + 5], 21, -57434055), u = md5ii$3(u, p, a, A, n[b + 12], 6, 1700485571), A = md5ii$3(A, u, p, a, n[b + 3], 10, -1894986606), a = md5ii$3(a, A, u, p, n[b + 10], 15, -1051523), p = md5ii$3(p, a, A, u, n[b + 1], 21, -2054922799), u = md5ii$3(u, p, a, A, n[b + 8], 6, 1873313359), A = md5ii$3(A, u, p, a, n[b + 15], 10, -30611744), a = md5ii$3(a, A, u, p, n[b + 6], 15, -1560198380), p = md5ii$3(p, a, A, u, n[b + 13], 21, 1309151649), u = md5ii$3(u, p, a, A, n[b + 4], 6, -145523070), A = md5ii$3(A, u, p, a, n[b + 11], 10, -1120210379), a = md5ii$3(a, A, u, p, n[b + 2], 15, 718787259), p = md5ii$3(p, a, A, u, n[b + 9], 21, -343485551), u = safeAdd$3(u, F), p = safeAdd$3(p, le), a = safeAdd$3(a, L), A = safeAdd$3(A, pe);
  }
  return [u, p, a, A];
}
function bytesToWords$3(n) {
  if (n.length === 0)
    return [];
  for (var c = n.length * 8, u = new Uint32Array(getOutputLength$3(c)), p = 0; p < c; p += 8)
    u[p >> 5] |= (n[p / 8] & 255) << p % 32;
  return u;
}
function safeAdd$3(n, c) {
  var u = (n & 65535) + (c & 65535), p = (n >> 16) + (c >> 16) + (u >> 16);
  return p << 16 | u & 65535;
}
function bitRotateLeft$3(n, c) {
  return n << c | n >>> 32 - c;
}
function md5cmn$3(n, c, u, p, a, A) {
  return safeAdd$3(bitRotateLeft$3(safeAdd$3(safeAdd$3(c, n), safeAdd$3(p, A)), a), u);
}
function md5ff$3(n, c, u, p, a, A, b) {
  return md5cmn$3(c & u | ~c & p, n, c, a, A, b);
}
function md5gg$3(n, c, u, p, a, A, b) {
  return md5cmn$3(c & p | u & ~p, n, c, a, A, b);
}
function md5hh$3(n, c, u, p, a, A, b) {
  return md5cmn$3(c ^ u ^ p, n, c, a, A, b);
}
function md5ii$3(n, c, u, p, a, A, b) {
  return md5cmn$3(u ^ (c | ~p), n, c, a, A, b);
}
var v3$5 = v35$5("v3", 48, md5$5);
function v4$6(n, c, u) {
  n = n || {};
  var p = n.random || (n.rng || rng$6)();
  if (p[6] = p[6] & 15 | 64, p[8] = p[8] & 63 | 128, c) {
    u = u || 0;
    for (var a = 0; a < 16; ++a)
      c[u + a] = p[a];
    return c;
  }
  return stringify$5(p);
}
function f$5(n, c, u, p) {
  switch (n) {
    case 0:
      return c & u ^ ~c & p;
    case 1:
      return c ^ u ^ p;
    case 2:
      return c & u ^ c & p ^ u & p;
    case 3:
      return c ^ u ^ p;
  }
}
function ROTL$3(n, c) {
  return n << c | n >>> 32 - c;
}
function sha1$5(n) {
  var c = [1518500249, 1859775393, 2400959708, 3395469782], u = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
  if (typeof n == "string") {
    var p = unescape(encodeURIComponent(n));
    n = [];
    for (var a = 0; a < p.length; ++a)
      n.push(p.charCodeAt(a));
  } else Array.isArray(n) || (n = Array.prototype.slice.call(n));
  n.push(128);
  for (var A = n.length / 4 + 2, b = Math.ceil(A / 16), F = new Array(b), le = 0; le < b; ++le) {
    for (var L = new Uint32Array(16), pe = 0; pe < 16; ++pe)
      L[pe] = n[le * 64 + pe * 4] << 24 | n[le * 64 + pe * 4 + 1] << 16 | n[le * 64 + pe * 4 + 2] << 8 | n[le * 64 + pe * 4 + 3];
    F[le] = L;
  }
  F[b - 1][14] = (n.length - 1) * 8 / Math.pow(2, 32), F[b - 1][14] = Math.floor(F[b - 1][14]), F[b - 1][15] = (n.length - 1) * 8 & 4294967295;
  for (var $ = 0; $ < b; ++$) {
    for (var Ee = new Uint32Array(80), be = 0; be < 16; ++be)
      Ee[be] = F[$][be];
    for (var He = 16; He < 80; ++He)
      Ee[He] = ROTL$3(Ee[He - 3] ^ Ee[He - 8] ^ Ee[He - 14] ^ Ee[He - 16], 1);
    for (var Pe = u[0], nr = u[1], ir = u[2], or = u[3], lr = u[4], Ir = 0; Ir < 80; ++Ir) {
      var xr = Math.floor(Ir / 20), kr = ROTL$3(Pe, 5) + f$5(xr, nr, ir, or) + lr + c[xr] + Ee[Ir] >>> 0;
      lr = or, or = ir, ir = ROTL$3(nr, 30) >>> 0, nr = Pe, Pe = kr;
    }
    u[0] = u[0] + Pe >>> 0, u[1] = u[1] + nr >>> 0, u[2] = u[2] + ir >>> 0, u[3] = u[3] + or >>> 0, u[4] = u[4] + lr >>> 0;
  }
  return [u[0] >> 24 & 255, u[0] >> 16 & 255, u[0] >> 8 & 255, u[0] & 255, u[1] >> 24 & 255, u[1] >> 16 & 255, u[1] >> 8 & 255, u[1] & 255, u[2] >> 24 & 255, u[2] >> 16 & 255, u[2] >> 8 & 255, u[2] & 255, u[3] >> 24 & 255, u[3] >> 16 & 255, u[3] >> 8 & 255, u[3] & 255, u[4] >> 24 & 255, u[4] >> 16 & 255, u[4] >> 8 & 255, u[4] & 255];
}
var v5$5 = v35$5("v5", 80, sha1$5);
const nil$5 = "00000000-0000-0000-0000-000000000000";
function version$6(n) {
  if (!validate$6(n))
    throw TypeError("Invalid UUID");
  return parseInt(n.substr(14, 1), 16);
}
const esmBrowser$3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  NIL: nil$5,
  parse: parse$c,
  stringify: stringify$5,
  v1: v1$5,
  v3: v3$5,
  v4: v4$6,
  v5: v5$5,
  validate: validate$6,
  version: version$6
}, Symbol.toStringTag, { value: "Module" })), require$$1$3 = /* @__PURE__ */ getAugmentedNamespace(esmBrowser$3);
var hasRequiredBcUrRegistryNear_cjs_production_min;
function requireBcUrRegistryNear_cjs_production_min() {
  return hasRequiredBcUrRegistryNear_cjs_production_min || (hasRequiredBcUrRegistryNear_cjs_production_min = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 });
    var c = requireDist$5(), u = require$$1$3;
    const p = { NEAR_SIGN_REQUEST: new c.RegistryType("near-sign-request", 2101), NEAR_SIGNATURE: new c.RegistryType("near-signature", 2102), CRYPTO_MULTI_ACCOUNTS: new c.RegistryType("crypto-multi-accounts", 2103) }, { decodeToDataItem: a, RegistryTypes: A } = c.extend;
    var b;
    (function(Ee) {
      Ee[Ee.requestId = 1] = "requestId", Ee[Ee.signData = 2] = "signData", Ee[Ee.derivationPath = 3] = "derivationPath", Ee[Ee.account = 4] = "account", Ee[Ee.origin = 5] = "origin";
    })(b || (b = {}));
    class F extends c.RegistryItem {
      constructor(be) {
        super(), this.getRegistryType = () => p.NEAR_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDerivationPath = () => this.derivationPath.getPath(), this.getSignRequestAccount = () => this.account, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const He = {};
          this.requestId && (He[b.requestId] = new c.DataItem(this.requestId, A.UUID.getTag())), this.account && (He[b.account] = this.account), this.origin && (He[b.origin] = this.origin), He[b.signData] = this.signData;
          const Pe = this.derivationPath.toDataItem();
          return Pe.setTag(this.derivationPath.getRegistryType().getTag()), He[b.derivationPath] = Pe, new c.DataItem(He);
        }, this.requestId = be.requestId, this.signData = be.signData, this.derivationPath = be.derivationPath, this.account = be.account, this.origin = be.origin;
      }
      static constructNearRequest(be, He, Pe, nr, ir, or) {
        const lr = He.replace(/[m|M]\//, "").split("/"), Ir = new c.CryptoKeypath(lr.map((xr) => {
          const kr = parseInt(xr.replace("'", ""));
          let Ce = !1;
          return xr.endsWith("'") && (Ce = !0), new c.PathComponent({ index: kr, hardened: Ce });
        }), Buffer$f.from(Pe, "hex"));
        return new F({ requestId: nr ? Buffer$f.from(u.parse(nr)) : void 0, signData: be, derivationPath: Ir, account: ir || void 0, origin: or || void 0 });
      }
    }
    F.fromDataItem = (Ee) => {
      const be = Ee.getData(), He = be[b.signData], Pe = c.CryptoKeypath.fromDataItem(be[b.derivationPath]), nr = be[b.account] ? be[b.account] : void 0, ir = be[b.requestId] ? be[b.requestId].getData() : void 0;
      return new F({ requestId: ir, signData: He, derivationPath: Pe, account: nr, origin: be[b.origin] ? be[b.origin] : void 0 });
    }, F.fromCBOR = (Ee) => {
      const be = a(Ee);
      return F.fromDataItem(be);
    };
    const { RegistryTypes: le, decodeToDataItem: L } = c.extend;
    var pe;
    (function(Ee) {
      Ee[Ee.requestId = 1] = "requestId", Ee[Ee.signature = 2] = "signature";
    })(pe || (pe = {}));
    class $ extends c.RegistryItem {
      constructor(be, He) {
        super(), this.getRegistryType = () => p.NEAR_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.toDataItem = () => {
          const Pe = {};
          return this.requestId && (Pe[pe.requestId] = new c.DataItem(this.requestId, le.UUID.getTag())), Pe[pe.signature] = this.signature, new c.DataItem(Pe);
        }, this.signature = be, this.requestId = He;
      }
    }
    $.fromDataItem = (Ee) => {
      const be = Ee.getData(), He = be[pe.signature], Pe = be[pe.requestId] ? be[pe.requestId].getData() : void 0;
      return new $(He, Pe);
    }, $.fromCBOR = (Ee) => {
      const be = L(Ee);
      return $.fromDataItem(be);
    }, c.patchTags(Object.values(p).filter((Ee) => !!Ee.getTag()).map((Ee) => Ee.getTag())), Object.keys(c).forEach(function(Ee) {
      Ee !== "default" && Object.defineProperty(n, Ee, { enumerable: !0, get: function() {
        return c[Ee];
      } });
    }), n.NearSignRequest = F, n.NearSignature = $;
  }(bcUrRegistryNear_cjs_production_min)), bcUrRegistryNear_cjs_production_min;
}
var bcUrRegistryNear_cjs_development = {}, hasRequiredBcUrRegistryNear_cjs_development;
function requireBcUrRegistryNear_cjs_development() {
  return hasRequiredBcUrRegistryNear_cjs_development || (hasRequiredBcUrRegistryNear_cjs_development = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 });
    var c = requireDist$5(), u = require$$1$3;
    const p = {
      NEAR_SIGN_REQUEST: /* @__PURE__ */ new c.RegistryType("near-sign-request", 2101),
      NEAR_SIGNATURE: /* @__PURE__ */ new c.RegistryType("near-signature", 2102),
      CRYPTO_MULTI_ACCOUNTS: /* @__PURE__ */ new c.RegistryType("crypto-multi-accounts", 2103)
    }, {
      decodeToDataItem: a,
      RegistryTypes: A
    } = c.extend;
    var b;
    (function(Ee) {
      Ee[Ee.requestId = 1] = "requestId", Ee[Ee.signData = 2] = "signData", Ee[Ee.derivationPath = 3] = "derivationPath", Ee[Ee.account = 4] = "account", Ee[Ee.origin = 5] = "origin";
    })(b || (b = {}));
    class F extends c.RegistryItem {
      constructor(be) {
        super(), this.getRegistryType = () => p.NEAR_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDerivationPath = () => this.derivationPath.getPath(), this.getSignRequestAccount = () => this.account, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const He = {};
          this.requestId && (He[b.requestId] = new c.DataItem(this.requestId, A.UUID.getTag())), this.account && (He[b.account] = this.account), this.origin && (He[b.origin] = this.origin), He[b.signData] = this.signData;
          const Pe = this.derivationPath.toDataItem();
          return Pe.setTag(this.derivationPath.getRegistryType().getTag()), He[b.derivationPath] = Pe, new c.DataItem(He);
        }, this.requestId = be.requestId, this.signData = be.signData, this.derivationPath = be.derivationPath, this.account = be.account, this.origin = be.origin;
      }
      static constructNearRequest(be, He, Pe, nr, ir, or) {
        const lr = He.replace(/[m|M]\//, "").split("/"), Ir = new c.CryptoKeypath(lr.map((xr) => {
          const kr = parseInt(xr.replace("'", ""));
          let Ce = !1;
          return xr.endsWith("'") && (Ce = !0), new c.PathComponent({
            index: kr,
            hardened: Ce
          });
        }), Buffer$f.from(Pe, "hex"));
        return new F({
          requestId: nr ? Buffer$f.from(u.parse(nr)) : void 0,
          signData: be,
          derivationPath: Ir,
          account: ir || void 0,
          origin: or || void 0
        });
      }
    }
    F.fromDataItem = (Ee) => {
      const be = Ee.getData(), He = be[b.signData], Pe = c.CryptoKeypath.fromDataItem(be[b.derivationPath]), nr = be[b.account] ? be[b.account] : void 0, ir = be[b.requestId] ? be[b.requestId].getData() : void 0, or = be[b.origin] ? be[b.origin] : void 0;
      return new F({
        requestId: ir,
        signData: He,
        derivationPath: Pe,
        account: nr,
        origin: or
      });
    }, F.fromCBOR = (Ee) => {
      const be = a(Ee);
      return F.fromDataItem(be);
    };
    const {
      RegistryTypes: le,
      decodeToDataItem: L
    } = c.extend;
    var pe;
    (function(Ee) {
      Ee[Ee.requestId = 1] = "requestId", Ee[Ee.signature = 2] = "signature";
    })(pe || (pe = {}));
    class $ extends c.RegistryItem {
      constructor(be, He) {
        super(), this.getRegistryType = () => p.NEAR_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.toDataItem = () => {
          const Pe = {};
          return this.requestId && (Pe[pe.requestId] = new c.DataItem(this.requestId, le.UUID.getTag())), Pe[pe.signature] = this.signature, new c.DataItem(Pe);
        }, this.signature = be, this.requestId = He;
      }
    }
    $.fromDataItem = (Ee) => {
      const be = Ee.getData(), He = be[pe.signature], Pe = be[pe.requestId] ? be[pe.requestId].getData() : void 0;
      return new $(He, Pe);
    }, $.fromCBOR = (Ee) => {
      const be = L(Ee);
      return $.fromDataItem(be);
    }, c.patchTags(Object.values(p).filter((Ee) => !!Ee.getTag()).map((Ee) => Ee.getTag())), Object.keys(c).forEach(function(Ee) {
      Ee !== "default" && Object.defineProperty(n, Ee, {
        enumerable: !0,
        get: function() {
          return c[Ee];
        }
      });
    }), n.NearSignRequest = F, n.NearSignature = $;
  }(bcUrRegistryNear_cjs_development)), bcUrRegistryNear_cjs_development;
}
process$1.env.NODE_ENV === "production" ? dist$f.exports = requireBcUrRegistryNear_cjs_production_min() : dist$f.exports = requireBcUrRegistryNear_cjs_development();
var distExports$5 = dist$f.exports;
Object.defineProperty(near, "__esModule", { value: !0 });
near.KeystoneNearSDK = void 0;
const utils_1$f = utils$K, ur_1$5 = ur, bc_ur_registry_near_1 = distExports$5;
class KeystoneNearSDK {
  parseSignature(c) {
    if (c.type !== ur_1$5.URType.NearSignature)
      throw new Error("type not match");
    const u = bc_ur_registry_near_1.NearSignature.fromCBOR(c.cbor), p = u.getRequestId();
    return {
      requestId: p === void 0 ? void 0 : (0, utils_1$f.uuidStringify)(p),
      signature: u.getSignature().map((a) => (0, utils_1$f.toHex)(a))
    };
  }
  generateSignRequest({ requestId: c, signData: u, path: p, xfp: a, account: A, origin: b }) {
    return new bc_ur_registry_near_1.NearSignRequest({
      requestId: (0, utils_1$f.uuidParse)(c),
      signData: u.map((F) => (0, utils_1$f.toBuffer)(F)),
      derivationPath: new bc_ur_registry_near_1.CryptoKeypath((0, utils_1$f.parsePath)(p).map((F) => new bc_ur_registry_near_1.PathComponent(F)), (0, utils_1$f.toBuffer)(a)),
      account: A,
      origin: b
    }).toUR();
  }
}
near.KeystoneNearSDK = KeystoneNearSDK;
var cardano = {}, dist$d = { exports: {} }, bcUrRegistryCardano_cjs_production_min = {}, dist$c = {}, patchCBOR$4 = {}, utils$9 = {}, lib$6 = {}, cborSync$4 = { exports: {} }, DataItem$4 = {}, hasRequiredDataItem$4;
function requireDataItem$4() {
  if (hasRequiredDataItem$4) return DataItem$4;
  hasRequiredDataItem$4 = 1, Object.defineProperty(DataItem$4, "__esModule", { value: !0 }), DataItem$4.DataItem = void 0;
  class n {
    constructor(u, p) {
      this.setTag = (a) => {
        this.tag = a;
      }, this.clearTag = () => {
        this.tag = void 0;
      }, this.getTag = () => this.tag, this.getData = () => this.data, this.data = u, this.tag = p;
    }
  }
  return DataItem$4.DataItem = n, DataItem$4;
}
var hasRequiredCborSync$4;
function requireCborSync$4() {
  return hasRequiredCborSync$4 || (hasRequiredCborSync$4 = 1, function(n) {
    (function(c, u) {
      n.exports ? n.exports = u() : c.CBOR = u();
    })(commonjsGlobal, function() {
      const { DataItem: c } = requireDataItem$4();
      var u = function() {
        function p(Ce) {
          this.$hex = Ce;
        }
        p.prototype = {
          length: function() {
            return this.$hex.length / 2;
          },
          toString: function(Ce) {
            if (!Ce || Ce === "hex" || Ce === 16)
              return this.$hex;
            if (Ce === "utf-8") {
              for (var tr = "", Fe = 0; Fe < this.$hex.length; Fe += 2)
                tr += "%" + this.$hex.substring(Fe, Fe + 2);
              return decodeURIComponent(tr);
            }
            if (Ce === "latin") {
              for (var tr = [], Fe = 0; Fe < this.$hex.length; Fe += 2)
                tr.push(parseInt(this.$hex.substring(Fe, Fe + 2), 16));
              return String.fromCharCode.apply(String, tr);
            }
            throw new Error("Unrecognised format: " + Ce);
          }
        }, p.fromLatinString = function(Ce) {
          for (var tr = "", Fe = 0; Fe < Ce.length; Fe++) {
            var Sr = Ce.charCodeAt(Fe).toString(16);
            Sr.length === 1 && (Sr = "0" + Sr), tr += Sr;
          }
          return new p(tr);
        }, p.fromUtf8String = function(Ce) {
          for (var tr = encodeURIComponent(Ce), Fe = "", Sr = 0; Sr < tr.length; Sr++)
            if (tr.charAt(Sr) === "%")
              Fe += tr.substring(Sr + 1, Sr + 3), Sr += 2;
            else {
              var er = tr.charCodeAt(Sr).toString(16);
              er.length < 2 && (er = "0" + er), Fe += er;
            }
          return new p(Fe);
        };
        var a = [], A = {}, b = function(Ce) {
          return function() {
            throw new Error(Ce + " not implemented");
          };
        };
        function F() {
        }
        F.prototype = {
          peekByte: b("peekByte"),
          readByte: b("readByte"),
          readChunk: b("readChunk"),
          readFloat16: function() {
            var Ce = this.readUint16(), tr = (Ce & 32767) >> 10, Fe = Ce & 1023, Sr = Ce & 32768;
            if (tr === 31)
              return Fe === 0 ? Sr ? -1 / 0 : 1 / 0 : NaN;
            var er = tr ? Math.pow(2, tr - 25) * (1024 + Fe) : Math.pow(2, -24) * Fe;
            return Sr ? -er : er;
          },
          readFloat32: function() {
            var Ce = this.readUint32(), tr = (Ce & 2147483647) >> 23, Fe = Ce & 8388607, Sr = Ce & 2147483648;
            if (tr === 255)
              return Fe === 0 ? Sr ? -1 / 0 : 1 / 0 : NaN;
            var er = tr ? Math.pow(2, tr - 23 - 127) * (8388608 + Fe) : Math.pow(2, -149) * Fe;
            return Sr ? -er : er;
          },
          readFloat64: function() {
            var Ce = this.readUint32(), tr = this.readUint32(), Fe = Ce >> 20 & 2047, Sr = (Ce & 1048575) * 4294967296 + tr, er = Ce & 2147483648;
            if (Fe === 2047)
              return Sr === 0 ? er ? -1 / 0 : 1 / 0 : NaN;
            var Ie = Fe ? Math.pow(2, Fe - 52 - 1023) * (4503599627370496 + Sr) : Math.pow(2, -1074) * Sr;
            return er ? -Ie : Ie;
          },
          readUint16: function() {
            return this.readByte() * 256 + this.readByte();
          },
          readUint32: function() {
            return this.readUint16() * 65536 + this.readUint16();
          },
          readUint64: function() {
            return this.readUint32() * 4294967296 + this.readUint32();
          }
        };
        function le() {
        }
        le.prototype = {
          writeByte: b("writeByte"),
          result: b("result"),
          writeFloat16: b("writeFloat16"),
          writeFloat32: b("writeFloat32"),
          writeFloat64: b("writeFloat64"),
          writeUint16: function(Ce) {
            this.writeByte(Ce >> 8 & 255), this.writeByte(Ce & 255);
          },
          writeUint32: function(Ce) {
            this.writeUint16(Ce >> 16 & 65535), this.writeUint16(Ce & 65535);
          },
          writeUint64: function(Ce) {
            if (Ce >= 9007199254740992 || Ce <= -9007199254740992)
              throw new Error("Cannot encode Uint64 of: " + Ce + " magnitude to big (floating point errors)");
            this.writeUint32(Math.floor(Ce / 4294967296)), this.writeUint32(Ce % 4294967296);
          },
          writeString: b("writeString"),
          canWriteBinary: function(Ce) {
            return !1;
          },
          writeBinary: b("writeChunk")
        };
        function L(Ce) {
          var tr = Ce.readByte(), Fe = tr >> 5, Sr = tr & 31;
          return { type: Fe, value: Sr };
        }
        function pe(Ce, tr) {
          var Fe = Ce.value;
          if (Fe < 24)
            return Fe;
          if (Fe == 24)
            return tr.readByte();
          if (Fe == 25)
            return tr.readUint16();
          if (Fe == 26)
            return tr.readUint32();
          if (Fe == 27)
            return tr.readUint64();
          if (Fe == 31)
            return null;
          b("Additional info: " + Fe)();
        }
        function $(Ce, tr, Fe) {
          Fe.writeByte(Ce << 5 | tr);
        }
        function Ee(Ce, tr, Fe) {
          var Sr = Ce << 5;
          tr < 24 ? Fe.writeByte(Sr | tr) : tr < 256 ? (Fe.writeByte(Sr | 24), Fe.writeByte(tr)) : tr < 65536 ? (Fe.writeByte(Sr | 25), Fe.writeUint16(tr)) : tr < 4294967296 ? (Fe.writeByte(Sr | 26), Fe.writeUint32(tr)) : (Fe.writeByte(Sr | 27), Fe.writeUint64(tr));
        }
        var be = new Error();
        function He(Ce) {
          var tr = L(Ce);
          switch (tr.type) {
            case 0:
              return pe(tr, Ce);
            case 1:
              return -1 - pe(tr, Ce);
            case 2:
              return Ce.readChunk(pe(tr, Ce));
            case 3:
              var Fe = Ce.readChunk(pe(tr, Ce));
              return Fe.toString("utf-8");
            case 4:
            case 5:
              var Sr = pe(tr, Ce), yr = [];
              if (Sr !== null) {
                tr.type === 5 && (Sr *= 2);
                for (var er = 0; er < Sr; er++)
                  yr[er] = He(Ce);
              } else
                for (var Ie; (Ie = He(Ce)) !== be; )
                  yr.push(Ie);
              if (tr.type === 5) {
                for (var xe = {}, er = 0; er < yr.length; er += 2)
                  xe[yr[er]] = yr[er + 1];
                return xe;
              } else
                return yr;
            case 6:
              var rr = pe(tr, Ce), ar = A[rr], yr = He(Ce);
              return ar ? ar(yr) : yr;
            case 7:
              if (tr.value === 25)
                return Ce.readFloat16();
              if (tr.value === 26)
                return Ce.readFloat32();
              if (tr.value === 27)
                return Ce.readFloat64();
              switch (pe(tr, Ce)) {
                case 20:
                  return !1;
                case 21:
                  return !0;
                case 22:
                  return null;
                case 23:
                  return;
                case null:
                  return be;
                default:
                  throw new Error("Unknown fixed value: " + tr.value);
              }
            default:
              throw new Error("Unsupported header: " + JSON.stringify(tr));
          }
          throw new Error("not implemented yet");
        }
        function Pe(Ce, tr) {
          for (var Fe = 0; Fe < a.length; Fe++) {
            var Sr = a[Fe].fn(Ce);
            if (Sr !== void 0)
              return Ee(6, a[Fe].tag, tr), Pe(Sr, tr);
          }
          if (Ce && typeof Ce.toCBOR == "function" && (Ce = Ce.toCBOR()), Ce === !1)
            Ee(7, 20, tr);
          else if (Ce === !0)
            Ee(7, 21, tr);
          else if (Ce === null)
            Ee(7, 22, tr);
          else if (Ce === void 0)
            Ee(7, 23, tr);
          else if (typeof Ce == "number")
            Math.floor(Ce) === Ce && Ce < 9007199254740992 && Ce > -9007199254740992 ? Ce < 0 ? Ee(1, -1 - Ce, tr) : Ee(0, Ce, tr) : ($(7, 27, tr), tr.writeFloat64(Ce));
          else if (typeof Ce == "string")
            tr.writeString(Ce, function(Ie) {
              Ee(3, Ie, tr);
            });
          else if (tr.canWriteBinary(Ce))
            tr.writeBinary(Ce, function(Ie) {
              Ee(2, Ie, tr);
            });
          else if (typeof Ce == "object")
            if (or.config.useToJSON && typeof Ce.toJSON == "function" && (Ce = Ce.toJSON()), Array.isArray(Ce)) {
              Ee(4, Ce.length, tr);
              for (var Fe = 0; Fe < Ce.length; Fe++)
                Pe(Ce[Fe], tr);
            } else {
              var er = Object.keys(Ce);
              Ee(5, er.length, tr);
              for (var Fe = 0; Fe < er.length; Fe++) {
                const xe = parseInt(er[Fe]);
                isNaN(xe) ? (Pe(er[Fe], tr), Pe(Ce[er[Fe]], tr)) : (Pe(xe, tr), Pe(Ce[er[Fe]], tr));
              }
            }
          else
            throw new Error("CBOR encoding not supported: " + Ce);
        }
        var nr = [], ir = [], or = {
          config: {
            useToJSON: !0
          },
          addWriter: function(Ce, tr) {
            typeof Ce == "string" ? ir.push(function(Fe) {
              if (Ce === Fe)
                return tr(Fe);
            }) : ir.push(Ce);
          },
          addReader: function(Ce, tr) {
            typeof Ce == "string" ? nr.push(function(Fe, Sr) {
              if (Ce === Sr)
                return tr(Fe, Sr);
            }) : nr.push(Ce);
          },
          encode: function(Ce, tr) {
            for (var Fe = 0; Fe < ir.length; Fe++) {
              var Sr = ir[Fe], er = Sr(tr);
              if (er)
                return Pe(Ce, er), er.result();
            }
            throw new Error("Unsupported output format: " + tr);
          },
          encodeDataItem: function(Ce, tr) {
            for (var Fe = 0; Fe < ir.length; Fe++) {
              var Sr = ir[Fe], er = Sr(tr);
              if (er)
                return Ce.getTag() !== void 0 ? (Pe(Ce, er), er.result()) : (Pe(Ce.getData(), er), er.result());
            }
            throw new Error("Unsupported output format: " + tr);
          },
          decode: function(Ce, tr) {
            for (var Fe = 0; Fe < nr.length; Fe++) {
              var Sr = nr[Fe], er = Sr(Ce, tr);
              if (er)
                return He(er);
            }
            throw new Error("Unsupported input format: " + tr);
          },
          decodeToDataItem: function(Ce, tr) {
            for (var Fe = 0; Fe < nr.length; Fe++) {
              var Sr = nr[Fe], er = Sr(Ce, tr);
              if (er) {
                const Ie = He(er);
                return Ie instanceof c ? Ie : new c(Ie);
              }
            }
            throw new Error("Unsupported input format: " + tr);
          },
          addSemanticEncode: function(Ce, tr) {
            if (typeof Ce != "number" || Ce % 1 !== 0 || Ce < 0)
              throw new Error("Tag must be a positive integer");
            return a.push({ tag: Ce, fn: tr }), this;
          },
          addSemanticDecode: function(Ce, tr) {
            if (typeof Ce != "number" || Ce % 1 !== 0 || Ce < 0)
              throw new Error("Tag must be a positive integer");
            return A[Ce] = tr, this;
          }
        };
        function lr(Ce) {
          this.buffer = Ce, this.pos = 0;
        }
        lr.prototype = Object.create(F.prototype), lr.prototype.peekByte = function() {
          return this.buffer[this.pos];
        }, lr.prototype.readByte = function() {
          return this.buffer[this.pos++];
        }, lr.prototype.readUint16 = function() {
          var Ce = this.buffer.readUInt16BE(this.pos);
          return this.pos += 2, Ce;
        }, lr.prototype.readUint32 = function() {
          var Ce = this.buffer.readUInt32BE(this.pos);
          return this.pos += 4, Ce;
        }, lr.prototype.readFloat32 = function() {
          var Ce = this.buffer.readFloatBE(this.pos);
          return this.pos += 4, Ce;
        }, lr.prototype.readFloat64 = function() {
          var Ce = this.buffer.readDoubleBE(this.pos);
          return this.pos += 8, Ce;
        }, lr.prototype.readChunk = function(Ce) {
          var tr = Buffer$f.alloc(Ce);
          return this.buffer.copy(tr, 0, this.pos, this.pos += Ce), tr;
        };
        function Ir(Ce) {
          this.byteLength = 0, this.defaultBufferLength = 16384, this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0, this.completeBuffers = [], this.stringFormat = Ce;
        }
        Ir.prototype = Object.create(le.prototype), Ir.prototype.writeByte = function(Ce) {
          this.latestBuffer[this.latestBufferOffset++] = Ce, this.latestBufferOffset >= this.latestBuffer.length && (this.completeBuffers.push(this.latestBuffer), this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0), this.byteLength++;
        }, Ir.prototype.writeFloat32 = function(Ce) {
          var tr = Buffer$f.alloc(4);
          tr.writeFloatBE(Ce, 0), this.writeBuffer(tr);
        }, Ir.prototype.writeFloat64 = function(Ce) {
          var tr = Buffer$f.alloc(8);
          tr.writeDoubleBE(Ce, 0), this.writeBuffer(tr);
        }, Ir.prototype.writeString = function(Ce, tr) {
          var Fe = Buffer$f.from(Ce, "utf-8");
          tr(Fe.length), this.writeBuffer(Fe);
        }, Ir.prototype.canWriteBinary = function(Ce) {
          return Ce instanceof Buffer$f;
        }, Ir.prototype.writeBinary = function(Ce, tr) {
          tr(Ce.length), this.writeBuffer(Ce);
        }, Ir.prototype.writeBuffer = function(Ce) {
          if (!(Ce instanceof Buffer$f))
            throw new TypeError("BufferWriter only accepts Buffers");
          this.latestBufferOffset ? this.latestBuffer.length - this.latestBufferOffset >= Ce.length ? (Ce.copy(this.latestBuffer, this.latestBufferOffset), this.latestBufferOffset += Ce.length, this.latestBufferOffset >= this.latestBuffer.length && (this.completeBuffers.push(this.latestBuffer), this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0)) : (this.completeBuffers.push(this.latestBuffer.slice(0, this.latestBufferOffset)), this.completeBuffers.push(Ce), this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0) : this.completeBuffers.push(Ce), this.byteLength += Ce.length;
        }, Ir.prototype.result = function() {
          for (var Ce = Buffer$f.alloc(this.byteLength), tr = 0, Fe = 0; Fe < this.completeBuffers.length; Fe++) {
            var Sr = this.completeBuffers[Fe];
            Sr.copy(Ce, tr, 0, Sr.length), tr += Sr.length;
          }
          return this.latestBufferOffset && this.latestBuffer.copy(Ce, tr, 0, this.latestBufferOffset), this.stringFormat ? Ce.toString(this.stringFormat) : Ce;
        }, typeof Buffer$f == "function" && (or.addReader(function(Ce, tr) {
          if (Buffer$f.isBuffer(Ce))
            return new lr(Ce);
          if (tr === "hex" || tr === "base64") {
            var Fe = Buffer$f.from(Ce, tr);
            return new lr(Fe);
          }
        }), or.addWriter(function(Ce) {
          if (!Ce || Ce === "buffer")
            return new Ir();
          if (Ce === "hex" || Ce === "base64")
            return new Ir(Ce);
        }));
        function xr(Ce) {
          this.hex = Ce, this.pos = 0;
        }
        xr.prototype = Object.create(F.prototype), xr.prototype.peekByte = function() {
          var Ce = this.hex.substring(this.pos, 2);
          return parseInt(Ce, 16);
        }, xr.prototype.readByte = function() {
          var Ce = this.hex.substring(this.pos, this.pos + 2);
          return this.pos += 2, parseInt(Ce, 16);
        }, xr.prototype.readChunk = function(Ce) {
          var tr = this.hex.substring(this.pos, this.pos + Ce * 2);
          return this.pos += Ce * 2, typeof Buffer$f == "function" ? Buffer$f.from(tr, "hex") : new p(tr);
        };
        function kr(Ce) {
          this.$hex = "", this.finalFormat = Ce || "hex";
        }
        return kr.prototype = Object.create(le.prototype), kr.prototype.writeByte = function(Ce) {
          if (Ce < 0 || Ce > 255)
            throw new Error("Byte value out of range: " + Ce);
          var tr = Ce.toString(16);
          tr.length == 1 && (tr = "0" + tr), this.$hex += tr;
        }, kr.prototype.canWriteBinary = function(Ce) {
          return Ce instanceof p || typeof Buffer$f == "function" && Ce instanceof Buffer$f;
        }, kr.prototype.writeBinary = function(Ce, tr) {
          if (Ce instanceof p)
            tr(Ce.length()), this.$hex += Ce.$hex;
          else if (typeof Buffer$f == "function" && Ce instanceof Buffer$f)
            tr(Ce.length), this.$hex += Ce.toString("hex");
          else
            throw new TypeError("HexWriter only accepts BinaryHex or Buffers");
        }, kr.prototype.result = function() {
          return this.finalFormat === "buffer" && typeof Buffer$f == "function" ? Buffer$f.from(this.$hex, "hex") : new p(this.$hex).toString(this.finalFormat);
        }, kr.prototype.writeString = function(Ce, tr) {
          var Fe = p.fromUtf8String(Ce);
          tr(Fe.length()), this.$hex += Fe.$hex;
        }, or.addReader(function(Ce, tr) {
          if (Ce instanceof p || Ce.$hex)
            return new xr(Ce.$hex);
          if (tr === "hex")
            return new xr(Ce);
        }), or.addWriter(function(Ce) {
          if (Ce === "hex")
            return new kr();
        }), or;
      }();
      return u.addSemanticEncode(0, function(p) {
        if (p instanceof Date)
          return p.toISOString();
      }).addSemanticDecode(0, function(p) {
        return new Date(p);
      }).addSemanticDecode(1, function(p) {
        return new Date(p);
      }), u;
    });
  }(cborSync$4)), cborSync$4.exports;
}
var hasRequiredLib$4;
function requireLib$4() {
  return hasRequiredLib$4 || (hasRequiredLib$4 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.DataItem = n.addWriter = n.addReader = n.addSemanticEncode = n.addSemanticDecode = n.decodeToDataItem = n.encodeDataItem = void 0;
    var c = requireCborSync$4();
    Object.defineProperty(n, "encodeDataItem", { enumerable: !0, get: function() {
      return c.encodeDataItem;
    } }), Object.defineProperty(n, "decodeToDataItem", { enumerable: !0, get: function() {
      return c.decodeToDataItem;
    } }), Object.defineProperty(n, "addSemanticDecode", { enumerable: !0, get: function() {
      return c.addSemanticDecode;
    } }), Object.defineProperty(n, "addSemanticEncode", { enumerable: !0, get: function() {
      return c.addSemanticEncode;
    } }), Object.defineProperty(n, "addReader", { enumerable: !0, get: function() {
      return c.addReader;
    } }), Object.defineProperty(n, "addWriter", { enumerable: !0, get: function() {
      return c.addWriter;
    } });
    var u = requireDataItem$4();
    Object.defineProperty(n, "DataItem", { enumerable: !0, get: function() {
      return u.DataItem;
    } });
  }(lib$6)), lib$6;
}
var hasRequiredUtils$4;
function requireUtils$4() {
  if (hasRequiredUtils$4) return utils$9;
  hasRequiredUtils$4 = 1, Object.defineProperty(utils$9, "__esModule", { value: !0 }), utils$9.patchTags = void 0;
  const n = requireLib$4(), c = [], u = (p) => {
    p.forEach((a) => {
      c.find((A) => A === a) || ((0, n.addSemanticEncode)(a, (A) => {
        if (A instanceof n.DataItem && A.getTag() === a)
          return A.getData();
      }), (0, n.addSemanticDecode)(a, (A) => new n.DataItem(A, a)), c.push(a));
    });
  };
  return utils$9.patchTags = u, utils$9;
}
var RegistryType$4 = {}, hasRequiredRegistryType$4;
function requireRegistryType$4() {
  if (hasRequiredRegistryType$4) return RegistryType$4;
  hasRequiredRegistryType$4 = 1, Object.defineProperty(RegistryType$4, "__esModule", { value: !0 }), RegistryType$4.RegistryTypes = RegistryType$4.RegistryType = void 0;
  class n {
    constructor(u, p) {
      this.type = u, this.tag = p, this.getTag = () => this.tag, this.getType = () => this.type;
    }
  }
  return RegistryType$4.RegistryType = n, RegistryType$4.RegistryTypes = {
    UUID: new n("uuid", 37),
    BYTES: new n("bytes", void 0),
    CRYPTO_HDKEY: new n("crypto-hdkey", 303),
    CRYPTO_KEYPATH: new n("crypto-keypath", 304),
    CRYPTO_COIN_INFO: new n("crypto-coin-info", 305),
    CRYPTO_ECKEY: new n("crypto-eckey", 306),
    CRYPTO_OUTPUT: new n("crypto-output", 308),
    CRYPTO_PSBT: new n("crypto-psbt", 310),
    CRYPTO_ACCOUNT: new n("crypto-account", 311),
    CRYPTO_MULTI_ACCOUNTS: new n("crypto-multi-accounts", 1103),
    QR_HARDWARE_CALL: new n("qr-hardware-call", 1201),
    KEY_DERIVATION_CALL: new n("key-derivation-call", 1301),
    KEY_DERIVATION_SCHEMA: new n("key-derivation-schema", 1302)
  }, RegistryType$4;
}
var ScriptExpression$4 = {}, hasRequiredScriptExpression$4;
function requireScriptExpression$4() {
  return hasRequiredScriptExpression$4 || (hasRequiredScriptExpression$4 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.ScriptExpressions = n.ScriptExpression = void 0;
    class c {
      constructor(p, a) {
        this.tag = p, this.expression = a, this.getTag = () => this.tag, this.getExpression = () => this.expression;
      }
    }
    n.ScriptExpression = c, c.fromTag = (u) => Object.values(n.ScriptExpressions).find((a) => a.getTag() === u), n.ScriptExpressions = {
      SCRIPT_HASH: new c(400, "sh"),
      WITNESS_SCRIPT_HASH: new c(401, "wsh"),
      PUBLIC_KEY: new c(402, "pk"),
      PUBLIC_KEY_HASH: new c(403, "pkh"),
      WITNESS_PUBLIC_KEY_HASH: new c(404, "wpkh"),
      COMBO: new c(405, "combo"),
      MULTISIG: new c(406, "multi"),
      SORTED_MULTISIG: new c(407, "sortedmulti"),
      ADDRESS: new c(307, "addr"),
      RAW_SCRIPT: new c(408, "raw")
    };
  }(ScriptExpression$4)), ScriptExpression$4;
}
var hasRequiredPatchCBOR$4;
function requirePatchCBOR$4() {
  if (hasRequiredPatchCBOR$4) return patchCBOR$4;
  hasRequiredPatchCBOR$4 = 1, Object.defineProperty(patchCBOR$4, "__esModule", { value: !0 });
  const n = requireUtils$4(), c = requireRegistryType$4(), u = requireScriptExpression$4(), p = Object.values(c.RegistryTypes).filter((A) => !!A.getTag()).map((A) => A.getTag()), a = Object.values(u.ScriptExpressions).map((A) => A.getTag());
  return (0, n.patchTags)(p.concat(a)), patchCBOR$4;
}
var CryptoHDKey$4 = {}, src$8, hasRequiredSrc$4;
function requireSrc$4() {
  if (hasRequiredSrc$4) return src$8;
  hasRequiredSrc$4 = 1;
  var n = safeBufferExports.Buffer;
  function c(u) {
    if (u.length >= 255)
      throw new TypeError("Alphabet too long");
    for (var p = new Uint8Array(256), a = 0; a < p.length; a++)
      p[a] = 255;
    for (var A = 0; A < u.length; A++) {
      var b = u.charAt(A), F = b.charCodeAt(0);
      if (p[F] !== 255)
        throw new TypeError(b + " is ambiguous");
      p[F] = A;
    }
    var le = u.length, L = u.charAt(0), pe = Math.log(le) / Math.log(256), $ = Math.log(256) / Math.log(le);
    function Ee(Pe) {
      if ((Array.isArray(Pe) || Pe instanceof Uint8Array) && (Pe = n.from(Pe)), !n.isBuffer(Pe))
        throw new TypeError("Expected Buffer");
      if (Pe.length === 0)
        return "";
      for (var nr = 0, ir = 0, or = 0, lr = Pe.length; or !== lr && Pe[or] === 0; )
        or++, nr++;
      for (var Ir = (lr - or) * $ + 1 >>> 0, xr = new Uint8Array(Ir); or !== lr; ) {
        for (var kr = Pe[or], Ce = 0, tr = Ir - 1; (kr !== 0 || Ce < ir) && tr !== -1; tr--, Ce++)
          kr += 256 * xr[tr] >>> 0, xr[tr] = kr % le >>> 0, kr = kr / le >>> 0;
        if (kr !== 0)
          throw new Error("Non-zero carry");
        ir = Ce, or++;
      }
      for (var Fe = Ir - ir; Fe !== Ir && xr[Fe] === 0; )
        Fe++;
      for (var Sr = L.repeat(nr); Fe < Ir; ++Fe)
        Sr += u.charAt(xr[Fe]);
      return Sr;
    }
    function be(Pe) {
      if (typeof Pe != "string")
        throw new TypeError("Expected String");
      if (Pe.length === 0)
        return n.alloc(0);
      for (var nr = 0, ir = 0, or = 0; Pe[nr] === L; )
        ir++, nr++;
      for (var lr = (Pe.length - nr) * pe + 1 >>> 0, Ir = new Uint8Array(lr); nr < Pe.length; ) {
        var xr = Pe.charCodeAt(nr);
        if (xr > 255)
          return;
        var kr = p[xr];
        if (kr === 255)
          return;
        for (var Ce = 0, tr = lr - 1; (kr !== 0 || Ce < or) && tr !== -1; tr--, Ce++)
          kr += le * Ir[tr] >>> 0, Ir[tr] = kr % 256 >>> 0, kr = kr / 256 >>> 0;
        if (kr !== 0)
          throw new Error("Non-zero carry");
        or = Ce, nr++;
      }
      for (var Fe = lr - or; Fe !== lr && Ir[Fe] === 0; )
        Fe++;
      var Sr = n.allocUnsafe(ir + (lr - Fe));
      Sr.fill(0, 0, ir);
      for (var er = ir; Fe !== lr; )
        Sr[er++] = Ir[Fe++];
      return Sr;
    }
    function He(Pe) {
      var nr = be(Pe);
      if (nr)
        return nr;
      throw new Error("Non-base" + le + " character");
    }
    return {
      encode: Ee,
      decodeUnsafe: be,
      decode: He
    };
  }
  return src$8 = c, src$8;
}
var bs58$5, hasRequiredBs58$4;
function requireBs58$4() {
  if (hasRequiredBs58$4) return bs58$5;
  hasRequiredBs58$4 = 1;
  var n = requireSrc$4(), c = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
  return bs58$5 = n(c), bs58$5;
}
var base$7, hasRequiredBase$4;
function requireBase$4() {
  if (hasRequiredBase$4) return base$7;
  hasRequiredBase$4 = 1;
  var n = requireBs58$4(), c = safeBufferExports.Buffer;
  return base$7 = function(u) {
    function p(F) {
      var le = u(F);
      return n.encode(c.concat([
        F,
        le
      ], F.length + 4));
    }
    function a(F) {
      var le = F.slice(0, -4), L = F.slice(-4), pe = u(le);
      if (!(L[0] ^ pe[0] | L[1] ^ pe[1] | L[2] ^ pe[2] | L[3] ^ pe[3]))
        return le;
    }
    function A(F) {
      var le = n.decodeUnsafe(F);
      if (le)
        return a(le);
    }
    function b(F) {
      var le = n.decode(F), L = a(le);
      if (!L) throw new Error("Invalid checksum");
      return L;
    }
    return {
      encode: p,
      decode: b,
      decodeUnsafe: A
    };
  }, base$7;
}
var bs58check$7, hasRequiredBs58check$4;
function requireBs58check$4() {
  if (hasRequiredBs58check$4) return bs58check$7;
  hasRequiredBs58check$4 = 1;
  var n = browser$a, c = requireBase$4();
  function u(p) {
    var a = n("sha256").update(p).digest();
    return n("sha256").update(a).digest();
  }
  return bs58check$7 = c(u), bs58check$7;
}
var CryptoCoinInfo$4 = {}, RegistryItem$4 = {}, hasRequiredRegistryItem$4;
function requireRegistryItem$4() {
  if (hasRequiredRegistryItem$4) return RegistryItem$4;
  hasRequiredRegistryItem$4 = 1, Object.defineProperty(RegistryItem$4, "__esModule", { value: !0 }), RegistryItem$4.RegistryItem = void 0;
  const n = dist$t, c = requireLib$4();
  class u {
    constructor() {
      this.toCBOR = () => {
        if (this.toDataItem() === void 0)
          throw new Error(`#[ur-registry][RegistryItem][fn.toCBOR]: registry ${this.getRegistryType()}'s method toDataItem returns undefined`);
        return (0, c.encodeDataItem)(this.toDataItem());
      }, this.toUR = () => new n.UR(this.toCBOR(), this.getRegistryType().getType()), this.toUREncoder = (a, A, b) => {
        const F = this.toUR();
        return new n.UREncoder(F, a, A, b);
      };
    }
  }
  return RegistryItem$4.RegistryItem = u, RegistryItem$4;
}
var hasRequiredCryptoCoinInfo$4;
function requireCryptoCoinInfo$4() {
  return hasRequiredCryptoCoinInfo$4 || (hasRequiredCryptoCoinInfo$4 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.CryptoCoinInfo = n.Network = n.Type = void 0;
    const c = requireLib$4(), u = requireRegistryItem$4(), p = requireRegistryType$4();
    var a;
    (function(le) {
      le.type = "1", le.network = "2";
    })(a || (a = {}));
    var A;
    (function(le) {
      le[le.bitcoin = 0] = "bitcoin";
    })(A = n.Type || (n.Type = {}));
    var b;
    (function(le) {
      le[le.mainnet = 0] = "mainnet", le[le.testnet = 1] = "testnet";
    })(b = n.Network || (n.Network = {}));
    class F extends u.RegistryItem {
      constructor(L, pe) {
        super(), this.type = L, this.network = pe, this.getRegistryType = () => p.RegistryTypes.CRYPTO_COIN_INFO, this.getType = () => this.type || A.bitcoin, this.getNetwork = () => this.network || b.mainnet, this.toDataItem = () => {
          const $ = {};
          return this.type && ($[a.type] = this.type), this.network && ($[a.network] = this.network), new c.DataItem($);
        };
      }
    }
    n.CryptoCoinInfo = F, F.fromDataItem = (le) => {
      const L = le.getData(), pe = L[a.type], $ = L[a.network];
      return new F(pe, $);
    }, F.fromCBOR = (le) => {
      const L = (0, c.decodeToDataItem)(le);
      return F.fromDataItem(L);
    };
  }(CryptoCoinInfo$4)), CryptoCoinInfo$4;
}
var CryptoKeypath$4 = {}, PathComponent$4 = {}, hasRequiredPathComponent$4;
function requirePathComponent$4() {
  if (hasRequiredPathComponent$4) return PathComponent$4;
  hasRequiredPathComponent$4 = 1, Object.defineProperty(PathComponent$4, "__esModule", { value: !0 }), PathComponent$4.PathComponent = void 0;
  class n {
    constructor(u) {
      if (this.getIndex = () => this.index, this.isWildcard = () => this.wildcard, this.isHardened = () => this.hardened, this.index = u.index, this.hardened = u.hardened, this.index !== void 0 ? this.wildcard = !1 : this.wildcard = !0, this.index && this.index & n.HARDENED_BIT)
        throw new Error(`#[ur-registry][PathComponent][fn.constructor]: Invalid index ${this.index} - most significant bit cannot be set`);
    }
  }
  return PathComponent$4.PathComponent = n, n.HARDENED_BIT = 2147483648, PathComponent$4;
}
var hasRequiredCryptoKeypath$4;
function requireCryptoKeypath$4() {
  if (hasRequiredCryptoKeypath$4) return CryptoKeypath$4;
  hasRequiredCryptoKeypath$4 = 1, Object.defineProperty(CryptoKeypath$4, "__esModule", { value: !0 }), CryptoKeypath$4.CryptoKeypath = void 0;
  const n = requireLib$4(), c = requirePathComponent$4(), u = requireRegistryItem$4(), p = requireRegistryType$4();
  var a;
  (function(b) {
    b[b.components = 1] = "components", b[b.source_fingerprint = 2] = "source_fingerprint", b[b.depth = 3] = "depth";
  })(a || (a = {}));
  class A extends u.RegistryItem {
    constructor(F = [], le, L) {
      super(), this.components = F, this.sourceFingerprint = le, this.depth = L, this.getRegistryType = () => p.RegistryTypes.CRYPTO_KEYPATH, this.getPath = () => this.components.length === 0 ? void 0 : this.components.map(($) => `${$.isWildcard() ? "*" : $.getIndex()}${$.isHardened() ? "'" : ""}`).join("/"), this.getComponents = () => this.components, this.getSourceFingerprint = () => this.sourceFingerprint, this.getDepth = () => this.depth, this.toDataItem = () => {
        const pe = {}, $ = [];
        return this.components && this.components.forEach((Ee) => {
          Ee.isWildcard() ? $.push([]) : $.push(Ee.getIndex()), $.push(Ee.isHardened());
        }), pe[a.components] = $, this.sourceFingerprint && (pe[a.source_fingerprint] = this.sourceFingerprint.readUInt32BE(0)), this.depth !== void 0 && (pe[a.depth] = this.depth), new n.DataItem(pe);
      };
    }
  }
  return CryptoKeypath$4.CryptoKeypath = A, A.fromDataItem = (b) => {
    const F = b.getData(), le = [], L = F[a.components];
    if (L)
      for (let be = 0; be < L.length; be += 2) {
        const He = L[be + 1], Pe = L[be];
        typeof Pe == "number" ? le.push(new c.PathComponent({ index: Pe, hardened: He })) : le.push(new c.PathComponent({ hardened: He }));
      }
    const pe = F[a.source_fingerprint];
    let $;
    pe && ($ = Buffer$f.alloc(4), $.writeUInt32BE(pe, 0));
    const Ee = F[a.depth];
    return new A(le, $, Ee);
  }, A.fromCBOR = (b) => {
    const F = (0, n.decodeToDataItem)(b);
    return A.fromDataItem(F);
  }, CryptoKeypath$4;
}
var hasRequiredCryptoHDKey$4;
function requireCryptoHDKey$4() {
  if (hasRequiredCryptoHDKey$4) return CryptoHDKey$4;
  hasRequiredCryptoHDKey$4 = 1, Object.defineProperty(CryptoHDKey$4, "__esModule", { value: !0 }), CryptoHDKey$4.CryptoHDKey = void 0;
  const n = requireBs58check$4(), c = requireCryptoCoinInfo$4(), u = requireCryptoKeypath$4(), p = requireLib$4(), a = requireRegistryItem$4(), A = requireRegistryType$4();
  var b;
  (function(le) {
    le[le.is_master = 1] = "is_master", le[le.is_private = 2] = "is_private", le[le.key_data = 3] = "key_data", le[le.chain_code = 4] = "chain_code", le[le.use_info = 5] = "use_info", le[le.origin = 6] = "origin", le[le.children = 7] = "children", le[le.parent_fingerprint = 8] = "parent_fingerprint", le[le.name = 9] = "name", le[le.note = 10] = "note";
  })(b || (b = {}));
  class F extends a.RegistryItem {
    constructor(L) {
      super(), this.isECKey = () => !1, this.getKey = () => this.key, this.getChainCode = () => this.chainCode, this.isMaster = () => this.master, this.isPrivateKey = () => !!this.privateKey, this.getUseInfo = () => this.useInfo, this.getOrigin = () => this.origin, this.getChildren = () => this.children, this.getParentFingerprint = () => this.parentFingerprint, this.getName = () => this.name, this.getNote = () => this.note, this.getBip32Key = () => {
        var pe, $, Ee;
        let be, He, Pe = 0, nr = Buffer$f.alloc(4).fill(0);
        if (this.isMaster())
          be = Buffer$f.from("0488ADE4", "hex"), He = 0, Pe = 0;
        else {
          He = ((pe = this.getOrigin()) === null || pe === void 0 ? void 0 : pe.getComponents().length) || (($ = this.getOrigin()) === null || $ === void 0 ? void 0 : $.getDepth());
          const xr = (Ee = this.getOrigin()) === null || Ee === void 0 ? void 0 : Ee.getComponents(), kr = xr[xr.length - 1];
          kr && (Pe = kr.isHardened() ? kr.getIndex() + 2147483648 : kr.getIndex(), this.getParentFingerprint() && (nr = this.getParentFingerprint())), this.isPrivateKey() ? be = Buffer$f.from("0488ADE4", "hex") : be = Buffer$f.from("0488B21E", "hex");
        }
        const ir = Buffer$f.alloc(1);
        ir.writeUInt8(He, 0);
        const or = Buffer$f.alloc(4);
        or.writeUInt32BE(Pe, 0);
        const lr = this.getChainCode(), Ir = this.getKey();
        return (0, n.encode)(Buffer$f.concat([be, ir, nr, or, lr, Ir]));
      }, this.getRegistryType = () => A.RegistryTypes.CRYPTO_HDKEY, this.getOutputDescriptorContent = () => {
        var pe, $, Ee, be, He, Pe, nr;
        let ir = "";
        return this.getOrigin() && !((pe = this.getOrigin()) === null || pe === void 0) && pe.getSourceFingerprint() && !(($ = this.getOrigin()) === null || $ === void 0) && $.getPath() && (ir += `${(be = (Ee = this.getOrigin()) === null || Ee === void 0 ? void 0 : Ee.getSourceFingerprint()) === null || be === void 0 ? void 0 : be.toString("hex")}/${(He = this.getOrigin()) === null || He === void 0 ? void 0 : He.getPath()}`), ir += this.getBip32Key(), this.getChildren() && !((Pe = this.getChildren()) === null || Pe === void 0) && Pe.getPath() && (ir += `/${(nr = this.getChildren()) === null || nr === void 0 ? void 0 : nr.getPath()}`), ir;
      }, this.setupMasterKey = (pe) => {
        this.master = !0, this.key = pe.key, this.chainCode = pe.chainCode;
      }, this.setupDeriveKey = (pe) => {
        this.master = !1, this.privateKey = pe.isPrivateKey, this.key = pe.key, this.chainCode = pe.chainCode, this.useInfo = pe.useInfo, this.origin = pe.origin, this.children = pe.children, this.parentFingerprint = pe.parentFingerprint, this.name = pe.name, this.note = pe.note;
      }, this.toDataItem = () => {
        const pe = {};
        if (this.master)
          pe[b.is_master] = !0, pe[b.key_data] = this.key, pe[b.chain_code] = this.chainCode;
        else {
          if (this.privateKey !== void 0 && (pe[b.is_private] = this.privateKey), pe[b.key_data] = this.key, this.chainCode && (pe[b.chain_code] = this.chainCode), this.useInfo) {
            const $ = this.useInfo.toDataItem();
            $.setTag(this.useInfo.getRegistryType().getTag()), pe[b.use_info] = $;
          }
          if (this.origin) {
            const $ = this.origin.toDataItem();
            $.setTag(this.origin.getRegistryType().getTag()), pe[b.origin] = $;
          }
          if (this.children) {
            const $ = this.children.toDataItem();
            $.setTag(this.children.getRegistryType().getTag()), pe[b.children] = $;
          }
          this.parentFingerprint && (pe[b.parent_fingerprint] = this.parentFingerprint.readUInt32BE(0)), this.name !== void 0 && (pe[b.name] = this.name), this.note !== void 0 && (pe[b.note] = this.note);
        }
        return new p.DataItem(pe);
      }, L.isMaster ? this.setupMasterKey(L) : this.setupDeriveKey(L);
    }
  }
  return CryptoHDKey$4.CryptoHDKey = F, F.fromDataItem = (le) => {
    const L = le.getData(), pe = !!L[b.is_master], $ = L[b.is_private], Ee = L[b.key_data], be = L[b.chain_code], He = L[b.use_info] ? c.CryptoCoinInfo.fromDataItem(L[b.use_info]) : void 0, Pe = L[b.origin] ? u.CryptoKeypath.fromDataItem(L[b.origin]) : void 0, nr = L[b.children] ? u.CryptoKeypath.fromDataItem(L[b.children]) : void 0, ir = L[b.parent_fingerprint];
    let or;
    ir && (or = Buffer$f.alloc(4), or.writeUInt32BE(ir, 0));
    const lr = L[b.name], Ir = L[b.note];
    return new F({
      isMaster: pe,
      isPrivateKey: $,
      key: Ee,
      chainCode: be,
      useInfo: He,
      origin: Pe,
      children: nr,
      parentFingerprint: or,
      name: lr,
      note: Ir
    });
  }, F.fromCBOR = (le) => {
    const L = (0, p.decodeToDataItem)(le);
    return F.fromDataItem(L);
  }, CryptoHDKey$4;
}
var CryptoECKey$4 = {}, hasRequiredCryptoECKey$4;
function requireCryptoECKey$4() {
  if (hasRequiredCryptoECKey$4) return CryptoECKey$4;
  hasRequiredCryptoECKey$4 = 1, Object.defineProperty(CryptoECKey$4, "__esModule", { value: !0 }), CryptoECKey$4.CryptoECKey = void 0;
  const n = requireLib$4(), c = requireRegistryItem$4(), u = requireRegistryType$4();
  var p;
  (function(A) {
    A[A.curve = 1] = "curve", A[A.private = 2] = "private", A[A.data = 3] = "data";
  })(p || (p = {}));
  class a extends c.RegistryItem {
    constructor(b) {
      super(), this.isECKey = () => !0, this.getCurve = () => this.curve || 0, this.isPrivateKey = () => this.privateKey || !1, this.getData = () => this.data, this.getRegistryType = () => u.RegistryTypes.CRYPTO_ECKEY, this.toDataItem = () => {
        const F = {};
        return this.curve && (F[p.curve] = this.curve), this.privateKey !== void 0 && (F[p.private] = this.privateKey), F[p.data] = this.data, new n.DataItem(F);
      }, this.getOutputDescriptorContent = () => this.data.toString("hex"), this.data = b.data, this.curve = b.curve, this.privateKey = b.privateKey || void 0;
    }
  }
  return CryptoECKey$4.CryptoECKey = a, a.fromDataItem = (A) => {
    const b = A.getData(), F = b[p.curve], le = b[p.private], L = b[p.data];
    if (!L)
      throw new Error(`#[ur-registry][CryptoECKey][fn.fromDataItem]: decoded [dataItem][#data.data] is undefined: ${A}`);
    return new a({ data: L, curve: F, privateKey: le });
  }, a.fromCBOR = (A) => {
    const b = (0, n.decodeToDataItem)(A);
    return a.fromDataItem(b);
  }, CryptoECKey$4;
}
var Bytes$5 = {}, hasRequiredBytes$4;
function requireBytes$4() {
  if (hasRequiredBytes$4) return Bytes$5;
  hasRequiredBytes$4 = 1, Object.defineProperty(Bytes$5, "__esModule", { value: !0 }), Bytes$5.Bytes = void 0;
  const n = requireLib$4(), c = requireRegistryItem$4(), u = requireRegistryType$4();
  class p extends c.RegistryItem {
    constructor(A) {
      super(), this.bytes = A, this.getRegistryType = () => u.RegistryTypes.BYTES, this.getData = () => this.bytes, this.toDataItem = () => new n.DataItem(this.bytes);
    }
  }
  return Bytes$5.Bytes = p, p.fromDataItem = (a) => {
    const A = a.getData();
    if (!A)
      throw new Error(`#[ur-registry][Bytes][fn.fromDataItem]: decoded [dataItem][#data] is undefined: ${a}`);
    return new p(A);
  }, p.fromCBOR = (a) => {
    const A = (0, n.decodeToDataItem)(a);
    return p.fromDataItem(A);
  }, Bytes$5;
}
var CryptoOutput$4 = {}, MultiKey$4 = {}, hasRequiredMultiKey$4;
function requireMultiKey$4() {
  if (hasRequiredMultiKey$4) return MultiKey$4;
  hasRequiredMultiKey$4 = 1, Object.defineProperty(MultiKey$4, "__esModule", { value: !0 }), MultiKey$4.MultiKey = void 0;
  const n = requireCryptoECKey$4(), c = requireCryptoHDKey$4(), u = requireDataItem$4(), p = requireRegistryItem$4(), a = requireRegistryType$4();
  var A;
  (function(F) {
    F[F.threshold = 1] = "threshold", F[F.keys = 2] = "keys";
  })(A || (A = {}));
  class b extends p.RegistryItem {
    constructor(le, L) {
      super(), this.threshold = le, this.keys = L, this.getThreshold = () => this.threshold, this.getKeys = () => this.keys, this.toDataItem = () => {
        const pe = {};
        pe[A.threshold] = this.threshold;
        const $ = this.keys.map((Ee) => {
          const be = Ee.toDataItem();
          return be.setTag(Ee.getRegistryType().getTag()), be;
        });
        return pe[A.keys] = $, new u.DataItem(pe);
      }, this.getOutputDescriptorContent = () => [
        this.getThreshold(),
        this.keys.map((pe) => pe.getOutputDescriptorContent()).join(",")
      ].join(",");
    }
  }
  return MultiKey$4.MultiKey = b, b.fromDataItem = (F) => {
    const le = F.getData(), L = le[A.threshold], pe = le[A.keys], $ = [];
    return pe.forEach((Ee) => {
      Ee.getTag() === a.RegistryTypes.CRYPTO_HDKEY.getTag() ? $.push(c.CryptoHDKey.fromDataItem(Ee)) : Ee.getTag() === a.RegistryTypes.CRYPTO_ECKEY.getTag() && $.push(n.CryptoECKey.fromDataItem(Ee));
    }), new b(L, $);
  }, MultiKey$4;
}
var hasRequiredCryptoOutput$4;
function requireCryptoOutput$4() {
  if (hasRequiredCryptoOutput$4) return CryptoOutput$4;
  hasRequiredCryptoOutput$4 = 1, Object.defineProperty(CryptoOutput$4, "__esModule", { value: !0 }), CryptoOutput$4.CryptoOutput = void 0;
  const n = requireCryptoECKey$4(), c = requireCryptoHDKey$4(), u = requireLib$4(), p = requireMultiKey$4(), a = requireRegistryItem$4(), A = requireRegistryType$4(), b = requireScriptExpression$4();
  class F extends a.RegistryItem {
    constructor(L, pe) {
      super(), this.scriptExpressions = L, this.cryptoKey = pe, this.getRegistryType = () => A.RegistryTypes.CRYPTO_OUTPUT, this.getCryptoKey = () => this.cryptoKey, this.getHDKey = () => {
        if (this.cryptoKey instanceof c.CryptoHDKey)
          return this.cryptoKey;
      }, this.getECKey = () => {
        if (this.cryptoKey instanceof n.CryptoECKey)
          return this.cryptoKey;
      }, this.getMultiKey = () => {
        if (this.cryptoKey instanceof p.MultiKey)
          return this.cryptoKey;
      }, this.getScriptExpressions = () => this.scriptExpressions, this._toOutputDescriptor = ($) => $ >= this.scriptExpressions.length ? this.cryptoKey.getOutputDescriptorContent() : `${this.scriptExpressions[$].getExpression()}(${this._toOutputDescriptor($ + 1)})`, this.toString = () => this._toOutputDescriptor(0), this.toDataItem = () => {
        let $ = this.cryptoKey.toDataItem();
        return (this.cryptoKey instanceof n.CryptoECKey || this.cryptoKey instanceof c.CryptoHDKey) && $.setTag(this.cryptoKey.getRegistryType().getTag()), [...this.scriptExpressions].reverse().forEach((be) => {
          const He = be.getTag();
          $.getTag() === void 0 ? $.setTag(He) : $ = new u.DataItem($, He);
        }), $;
      };
    }
  }
  return CryptoOutput$4.CryptoOutput = F, F.fromDataItem = (le) => {
    const L = [];
    let pe = le;
    for (; ; ) {
      let be = pe.getTag();
      const He = b.ScriptExpression.fromTag(be);
      if (He)
        if (L.push(He), pe.getData() instanceof u.DataItem)
          pe = pe.getData(), be = pe.getTag();
        else
          break;
      else
        break;
    }
    const $ = L.length;
    if ($ > 0 && (L[$ - 1].getExpression() === b.ScriptExpressions.MULTISIG.getExpression() || L[$ - 1].getExpression() === b.ScriptExpressions.SORTED_MULTISIG.getExpression())) {
      const be = p.MultiKey.fromDataItem(pe);
      return new F(L, be);
    }
    if (pe.getTag() === A.RegistryTypes.CRYPTO_HDKEY.getTag()) {
      const be = c.CryptoHDKey.fromDataItem(pe);
      return new F(L, be);
    } else {
      const be = n.CryptoECKey.fromDataItem(pe);
      return new F(L, be);
    }
  }, F.fromCBOR = (le) => {
    const L = (0, u.decodeToDataItem)(le);
    return F.fromDataItem(L);
  }, CryptoOutput$4;
}
var CryptoPSBT$4 = {}, hasRequiredCryptoPSBT$4;
function requireCryptoPSBT$4() {
  if (hasRequiredCryptoPSBT$4) return CryptoPSBT$4;
  hasRequiredCryptoPSBT$4 = 1, Object.defineProperty(CryptoPSBT$4, "__esModule", { value: !0 }), CryptoPSBT$4.CryptoPSBT = void 0;
  const n = requireLib$4(), c = requireRegistryItem$4(), u = requireRegistryType$4();
  class p extends c.RegistryItem {
    constructor(A) {
      super(), this.psbt = A, this.getRegistryType = () => u.RegistryTypes.CRYPTO_PSBT, this.getPSBT = () => this.psbt, this.toDataItem = () => new n.DataItem(this.psbt);
    }
  }
  return CryptoPSBT$4.CryptoPSBT = p, p.fromDataItem = (a) => {
    const A = a.getData();
    if (!A)
      throw new Error(`#[ur-registry][CryptoPSBT][fn.fromDataItem]: decoded [dataItem][#data] is undefined: ${a}`);
    return new p(A);
  }, p.fromCBOR = (a) => {
    const A = (0, n.decodeToDataItem)(a);
    return p.fromDataItem(A);
  }, CryptoPSBT$4;
}
var CryptoAccount$4 = {}, hasRequiredCryptoAccount$4;
function requireCryptoAccount$4() {
  if (hasRequiredCryptoAccount$4) return CryptoAccount$4;
  hasRequiredCryptoAccount$4 = 1, Object.defineProperty(CryptoAccount$4, "__esModule", { value: !0 }), CryptoAccount$4.CryptoAccount = void 0;
  const n = requireDist$4(), c = requireLib$4(), u = requireRegistryItem$4(), p = requireRegistryType$4();
  var a;
  (function(b) {
    b[b.masterFingerprint = 1] = "masterFingerprint", b[b.outputDescriptors = 2] = "outputDescriptors";
  })(a || (a = {}));
  class A extends u.RegistryItem {
    constructor(F, le) {
      super(), this.masterFingerprint = F, this.outputDescriptors = le, this.getRegistryType = () => p.RegistryTypes.CRYPTO_ACCOUNT, this.getMasterFingerprint = () => this.masterFingerprint, this.getOutputDescriptors = () => this.outputDescriptors, this.toDataItem = () => {
        const L = {};
        return this.masterFingerprint && (L[a.masterFingerprint] = this.masterFingerprint.readUInt32BE(0)), this.outputDescriptors && (L[a.outputDescriptors] = this.outputDescriptors.map((pe) => pe.toDataItem())), new c.DataItem(L);
      };
    }
  }
  return CryptoAccount$4.CryptoAccount = A, A.fromDataItem = (b) => {
    const F = b.getData(), le = Buffer$f.alloc(4), L = F[a.masterFingerprint];
    L && le.writeUInt32BE(L, 0);
    const $ = F[a.outputDescriptors].map((Ee) => n.CryptoOutput.fromDataItem(Ee));
    return new A(le, $);
  }, A.fromCBOR = (b) => {
    const F = (0, c.decodeToDataItem)(b);
    return A.fromDataItem(F);
  }, CryptoAccount$4;
}
var Decoder$4 = {}, errors$5 = {}, hasRequiredErrors$4;
function requireErrors$4() {
  if (hasRequiredErrors$4) return errors$5;
  hasRequiredErrors$4 = 1, Object.defineProperty(errors$5, "__esModule", { value: !0 }), errors$5.UnknownURTypeError = void 0;
  class n extends Error {
    constructor(u) {
      super(u);
    }
  }
  return errors$5.UnknownURTypeError = n, errors$5;
}
var hasRequiredDecoder$4;
function requireDecoder$4() {
  if (hasRequiredDecoder$4) return Decoder$4;
  hasRequiredDecoder$4 = 1, Object.defineProperty(Decoder$4, "__esModule", { value: !0 }), Decoder$4.URRegistryDecoder = void 0;
  const n = dist$t, c = requireDist$4(), u = requireRegistryType$4(), p = requireErrors$4();
  class a extends n.URDecoder {
    constructor() {
      super(...arguments), this.resultRegistryType = () => {
        const b = this.resultUR();
        switch (b.type) {
          case u.RegistryTypes.BYTES.getType():
            return c.Bytes.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_HDKEY.getType():
            return c.CryptoHDKey.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_KEYPATH.getType():
            return c.CryptoKeypath.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_COIN_INFO.getType():
            return c.CryptoCoinInfo.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_ECKEY.getType():
            return c.CryptoECKey.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_OUTPUT.getType():
            return c.CryptoOutput.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_PSBT.getType():
            return c.CryptoPSBT.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_ACCOUNT.getType():
            return c.CryptoAccount.fromCBOR(b.cbor);
          default:
            throw new p.UnknownURTypeError(`#[ur-registry][Decoder][fn.resultRegistryType]: registry type ${b.type} is not supported now`);
        }
      };
    }
  }
  return Decoder$4.URRegistryDecoder = a, Decoder$4;
}
var CryptoMultiAccounts$4 = {}, hasRequiredCryptoMultiAccounts$4;
function requireCryptoMultiAccounts$4() {
  if (hasRequiredCryptoMultiAccounts$4) return CryptoMultiAccounts$4;
  hasRequiredCryptoMultiAccounts$4 = 1, Object.defineProperty(CryptoMultiAccounts$4, "__esModule", { value: !0 }), CryptoMultiAccounts$4.CryptoMultiAccounts = void 0;
  const n = requireRegistryType$4(), c = requireCryptoHDKey$4(), u = requireRegistryItem$4(), p = requireLib$4();
  var a;
  (function(b) {
    b[b.masterFingerprint = 1] = "masterFingerprint", b[b.keys = 2] = "keys", b[b.device = 3] = "device", b[b.deviceId = 4] = "deviceId", b[b.version = 5] = "version";
  })(a || (a = {}));
  class A extends u.RegistryItem {
    constructor(F, le, L, pe, $) {
      super(), this.masterFingerprint = F, this.keys = le, this.device = L, this.deviceId = pe, this.version = $, this.getRegistryType = () => n.RegistryTypes.CRYPTO_MULTI_ACCOUNTS, this.getMasterFingerprint = () => this.masterFingerprint, this.getKeys = () => this.keys, this.getDevice = () => this.device, this.getDeviceId = () => this.deviceId, this.getVersion = () => this.version, this.toDataItem = () => {
        const Ee = {};
        return this.masterFingerprint && (Ee[a.masterFingerprint] = this.masterFingerprint.readUInt32BE(0)), this.keys && (Ee[a.keys] = this.keys.map((be) => {
          const He = be.toDataItem();
          return He.setTag(be.getRegistryType().getTag()), He;
        })), this.device && (Ee[a.device] = this.device), this.deviceId && (Ee[a.deviceId] = this.deviceId), this.version && (Ee[a.version] = this.version), new p.DataItem(Ee);
      };
    }
  }
  return CryptoMultiAccounts$4.CryptoMultiAccounts = A, A.fromDataItem = (b) => {
    const F = b.getData(), le = Buffer$f.alloc(4), L = F[a.masterFingerprint];
    L && le.writeUInt32BE(L, 0);
    const $ = F[a.keys].map((Pe) => c.CryptoHDKey.fromDataItem(Pe)), Ee = F[a.device], be = F[a.deviceId], He = F[a.version];
    return new A(le, $, Ee, be, He);
  }, A.fromCBOR = (b) => {
    const F = (0, p.decodeToDataItem)(b);
    return A.fromDataItem(F);
  }, CryptoMultiAccounts$4;
}
var QRHardwareCall$4 = {}, KeyDerivation$4 = {}, DerivationSchema$4 = {}, hasRequiredDerivationSchema$4;
function requireDerivationSchema$4() {
  return hasRequiredDerivationSchema$4 || (hasRequiredDerivationSchema$4 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.KeyDerivationSchema = n.DerivationAlgorithm = n.Curve = void 0;
    const c = requireRegistryType$4(), u = requireRegistryItem$4(), p = requireLib$4(), a = requireCryptoKeypath$4();
    var A;
    (function(L) {
      L[L.keyPath = 1] = "keyPath", L[L.curve = 2] = "curve", L[L.algo = 3] = "algo";
    })(A || (A = {}));
    var b;
    (function(L) {
      L[L.secp256k1 = 0] = "secp256k1", L[L.ed25519 = 1] = "ed25519";
    })(b = n.Curve || (n.Curve = {}));
    var F;
    (function(L) {
      L[L.slip10 = 0] = "slip10", L[L.bip32ed25519 = 1] = "bip32ed25519";
    })(F = n.DerivationAlgorithm || (n.DerivationAlgorithm = {}));
    class le extends u.RegistryItem {
      constructor(pe, $ = b.secp256k1, Ee = F.slip10) {
        super(), this.keypath = pe, this.curve = $, this.algo = Ee, this.getRegistryType = () => c.RegistryTypes.KEY_DERIVATION_SCHEMA, this.getKeypath = () => this.keypath, this.getCurve = () => this.curve, this.getAlgo = () => this.algo, this.toDataItem = () => {
          const be = {}, He = this.getKeypath().toDataItem();
          return He.setTag(this.getKeypath().getRegistryType().getTag()), be[A.keyPath] = He, be[A.curve] = this.curve, be[A.algo] = this.algo, new p.DataItem(be);
        };
      }
    }
    n.KeyDerivationSchema = le, le.fromDataItem = (L) => {
      const pe = L.getData(), $ = a.CryptoKeypath.fromDataItem(pe[A.keyPath]), Ee = pe[A.curve], be = pe[A.algo];
      return new le($, Ee, be);
    }, le.fromCBOR = (L) => {
      const pe = (0, p.decodeToDataItem)(L);
      return le.fromDataItem(pe);
    };
  }(DerivationSchema$4)), DerivationSchema$4;
}
var hasRequiredKeyDerivation$4;
function requireKeyDerivation$4() {
  if (hasRequiredKeyDerivation$4) return KeyDerivation$4;
  hasRequiredKeyDerivation$4 = 1, Object.defineProperty(KeyDerivation$4, "__esModule", { value: !0 }), KeyDerivation$4.KeyDerivation = void 0;
  const n = requireRegistryType$4(), c = requireRegistryItem$4(), u = requireLib$4(), p = requireDerivationSchema$4();
  var a;
  (function(b) {
    b[b.schemas = 1] = "schemas";
  })(a || (a = {}));
  class A extends c.RegistryItem {
    constructor(F) {
      super(), this.schemas = F, this.getRegistryType = () => n.RegistryTypes.KEY_DERIVATION_CALL, this.getSchemas = () => this.schemas, this.toDataItem = () => {
        const le = {};
        return le[a.schemas] = this.schemas.map((L) => {
          const pe = L.toDataItem();
          return pe.setTag(L.getRegistryType().getTag()), pe;
        }), new u.DataItem(le);
      };
    }
  }
  return KeyDerivation$4.KeyDerivation = A, A.fromDataItem = (b) => {
    const le = b.getData()[a.schemas].map((L) => p.KeyDerivationSchema.fromDataItem(L));
    return new A(le);
  }, A.fromCBOR = (b) => {
    const F = (0, u.decodeToDataItem)(b);
    return A.fromDataItem(F);
  }, KeyDerivation$4;
}
var hasRequiredQRHardwareCall$4;
function requireQRHardwareCall$4() {
  return hasRequiredQRHardwareCall$4 || (hasRequiredQRHardwareCall$4 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.QRHardwareCall = n.QRHardwareCallType = void 0;
    const c = requireRegistryType$4(), u = requireRegistryItem$4(), p = requireLib$4(), a = requireKeyDerivation$4();
    var A;
    (function(le) {
      le[le.type = 1] = "type", le[le.params = 2] = "params", le[le.origin = 3] = "origin";
    })(A || (A = {}));
    var b;
    (function(le) {
      le[le.KeyDerivation = 0] = "KeyDerivation";
    })(b = n.QRHardwareCallType || (n.QRHardwareCallType = {}));
    class F extends u.RegistryItem {
      constructor(L, pe, $) {
        super(), this.type = L, this.params = pe, this.origin = $, this.getRegistryType = () => c.RegistryTypes.QR_HARDWARE_CALL, this.getType = () => this.type, this.getParams = () => this.params, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const Ee = {};
          Ee[A.type] = this.type;
          const be = this.params.toDataItem();
          return be.setTag(this.params.getRegistryType().getTag()), Ee[A.params] = be, this.origin && (Ee[A.origin] = this.origin), new p.DataItem(Ee);
        };
      }
    }
    n.QRHardwareCall = F, F.fromDataItem = (le) => {
      const L = le.getData(), pe = L[A.type] || b.KeyDerivation;
      let $;
      switch (pe) {
        case b.KeyDerivation:
          $ = a.KeyDerivation.fromDataItem(L[A.params]);
      }
      const Ee = L[A.origin];
      return new F(pe, $, Ee);
    }, F.fromCBOR = (le) => {
      const L = (0, p.decodeToDataItem)(le);
      return F.fromDataItem(L);
    };
  }(QRHardwareCall$4)), QRHardwareCall$4;
}
var types$9 = {}, hasRequiredTypes$4;
function requireTypes$4() {
  return hasRequiredTypes$4 || (hasRequiredTypes$4 = 1, Object.defineProperty(types$9, "__esModule", { value: !0 })), types$9;
}
var hasRequiredDist$4;
function requireDist$4() {
  return hasRequiredDist$4 || (hasRequiredDist$4 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.Buffer = n.extend = n.PathComponent = n.ScriptExpressions = n.MultiKey = n.CryptoPSBT = n.CryptoOutput = n.CryptoECKey = n.CryptoCoinInfoNetwork = n.CryptoCoinInfoType = n.CryptoCoinInfo = n.CryptoKeypath = n.CryptoMultiAccounts = n.CryptoHDKey = n.CryptoAccount = n.Bytes = n.URRegistryDecoder = n.DataItem = void 0;
    const c = require$$0$4;
    requirePatchCBOR$4();
    const u = dist$u;
    Object.defineProperty(n, "Buffer", { enumerable: !0, get: function() {
      return u.Buffer;
    } });
    const p = requireCryptoHDKey$4();
    Object.defineProperty(n, "CryptoHDKey", { enumerable: !0, get: function() {
      return p.CryptoHDKey;
    } });
    const a = requireCryptoKeypath$4();
    Object.defineProperty(n, "CryptoKeypath", { enumerable: !0, get: function() {
      return a.CryptoKeypath;
    } });
    const A = requireCryptoCoinInfo$4();
    Object.defineProperty(n, "CryptoCoinInfo", { enumerable: !0, get: function() {
      return A.CryptoCoinInfo;
    } }), Object.defineProperty(n, "CryptoCoinInfoType", { enumerable: !0, get: function() {
      return A.Type;
    } }), Object.defineProperty(n, "CryptoCoinInfoNetwork", { enumerable: !0, get: function() {
      return A.Network;
    } });
    const b = requireCryptoECKey$4();
    Object.defineProperty(n, "CryptoECKey", { enumerable: !0, get: function() {
      return b.CryptoECKey;
    } });
    const F = requireBytes$4();
    Object.defineProperty(n, "Bytes", { enumerable: !0, get: function() {
      return F.Bytes;
    } });
    const le = requireCryptoOutput$4();
    Object.defineProperty(n, "CryptoOutput", { enumerable: !0, get: function() {
      return le.CryptoOutput;
    } });
    const L = requireCryptoPSBT$4();
    Object.defineProperty(n, "CryptoPSBT", { enumerable: !0, get: function() {
      return L.CryptoPSBT;
    } });
    const pe = requireCryptoAccount$4();
    Object.defineProperty(n, "CryptoAccount", { enumerable: !0, get: function() {
      return pe.CryptoAccount;
    } });
    const $ = requireDecoder$4();
    Object.defineProperty(n, "URRegistryDecoder", { enumerable: !0, get: function() {
      return $.URRegistryDecoder;
    } });
    const Ee = requireMultiKey$4();
    Object.defineProperty(n, "MultiKey", { enumerable: !0, get: function() {
      return Ee.MultiKey;
    } });
    const be = requireScriptExpression$4();
    Object.defineProperty(n, "ScriptExpressions", { enumerable: !0, get: function() {
      return be.ScriptExpressions;
    } });
    const He = requirePathComponent$4();
    Object.defineProperty(n, "PathComponent", { enumerable: !0, get: function() {
      return He.PathComponent;
    } });
    const Pe = requireRegistryItem$4(), nr = requireRegistryType$4(), ir = requireLib$4();
    var or = requireLib$4();
    Object.defineProperty(n, "DataItem", { enumerable: !0, get: function() {
      return or.DataItem;
    } });
    const lr = requireUtils$4(), Ir = requireCryptoMultiAccounts$4();
    Object.defineProperty(n, "CryptoMultiAccounts", { enumerable: !0, get: function() {
      return Ir.CryptoMultiAccounts;
    } });
    const xr = {
      URRegistryDecoder: $.URRegistryDecoder,
      Bytes: F.Bytes,
      CryptoAccount: pe.CryptoAccount,
      CryptoHDKey: p.CryptoHDKey,
      CryptoMultiAccounts: Ir.CryptoMultiAccounts,
      CryptoKeypath: a.CryptoKeypath,
      CryptoCoinInfo: A.CryptoCoinInfo,
      CryptoCoinInfoType: A.Type,
      CryptoCoinInfoNetwork: A.Network,
      CryptoECKey: b.CryptoECKey,
      CryptoOutput: le.CryptoOutput,
      CryptoPSBT: L.CryptoPSBT,
      MultiKey: Ee.MultiKey,
      ScriptExpressions: be.ScriptExpressions,
      PathComponent: He.PathComponent
    }, kr = {
      addReader: ir.addReader,
      addSemanticDecode: ir.addSemanticDecode,
      addSemanticEncode: ir.addSemanticEncode,
      addWriter: ir.addWriter,
      patchTags: lr.patchTags
    }, Ce = {
      RegistryTypes: nr.RegistryTypes,
      RegistryItem: Pe.RegistryItem,
      RegistryType: nr.RegistryType,
      decodeToDataItem: ir.decodeToDataItem,
      encodeDataItem: ir.encodeDataItem,
      cbor: kr
    };
    n.extend = Ce, (0, c.__exportStar)(requireErrors$4(), n), (0, c.__exportStar)(requireDecoder$4(), n), (0, c.__exportStar)(requireLib$4(), n), (0, c.__exportStar)(requireCryptoAccount$4(), n), (0, c.__exportStar)(requireCryptoPSBT$4(), n), (0, c.__exportStar)(requireCryptoHDKey$4(), n), (0, c.__exportStar)(requireCryptoMultiAccounts$4(), n), (0, c.__exportStar)(requireQRHardwareCall$4(), n), (0, c.__exportStar)(requireKeyDerivation$4(), n), (0, c.__exportStar)(requireDerivationSchema$4(), n), (0, c.__exportStar)(requireCryptoOutput$4(), n), (0, c.__exportStar)(requireCryptoCoinInfo$4(), n), (0, c.__exportStar)(requireCryptoECKey$4(), n), (0, c.__exportStar)(requireMultiKey$4(), n), (0, c.__exportStar)(requireCryptoKeypath$4(), n), (0, c.__exportStar)(requirePatchCBOR$4(), n), (0, c.__exportStar)(requirePathComponent$4(), n), (0, c.__exportStar)(requireRegistryItem$4(), n), (0, c.__exportStar)(requireRegistryType$4(), n), (0, c.__exportStar)(requireTypes$4(), n), (0, c.__exportStar)(requireUtils$4(), n), n.default = xr;
  }(dist$c)), dist$c;
}
var getRandomValues$5, rnds8$3 = new Uint8Array(16);
function rng$5() {
  if (!getRandomValues$5 && (getRandomValues$5 = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !getRandomValues$5))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return getRandomValues$5(rnds8$3);
}
const REGEX$2 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function validate$5(n) {
  return typeof n == "string" && REGEX$2.test(n);
}
var byteToHex$3 = [];
for (var i$4 = 0; i$4 < 256; ++i$4)
  byteToHex$3.push((i$4 + 256).toString(16).substr(1));
function stringify$4(n) {
  var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, u = (byteToHex$3[n[c + 0]] + byteToHex$3[n[c + 1]] + byteToHex$3[n[c + 2]] + byteToHex$3[n[c + 3]] + "-" + byteToHex$3[n[c + 4]] + byteToHex$3[n[c + 5]] + "-" + byteToHex$3[n[c + 6]] + byteToHex$3[n[c + 7]] + "-" + byteToHex$3[n[c + 8]] + byteToHex$3[n[c + 9]] + "-" + byteToHex$3[n[c + 10]] + byteToHex$3[n[c + 11]] + byteToHex$3[n[c + 12]] + byteToHex$3[n[c + 13]] + byteToHex$3[n[c + 14]] + byteToHex$3[n[c + 15]]).toLowerCase();
  if (!validate$5(u))
    throw TypeError("Stringified UUID is invalid");
  return u;
}
var _nodeId$2, _clockseq$2, _lastMSecs$2 = 0, _lastNSecs$2 = 0;
function v1$4(n, c, u) {
  var p = c && u || 0, a = c || new Array(16);
  n = n || {};
  var A = n.node || _nodeId$2, b = n.clockseq !== void 0 ? n.clockseq : _clockseq$2;
  if (A == null || b == null) {
    var F = n.random || (n.rng || rng$5)();
    A == null && (A = _nodeId$2 = [F[0] | 1, F[1], F[2], F[3], F[4], F[5]]), b == null && (b = _clockseq$2 = (F[6] << 8 | F[7]) & 16383);
  }
  var le = n.msecs !== void 0 ? n.msecs : Date.now(), L = n.nsecs !== void 0 ? n.nsecs : _lastNSecs$2 + 1, pe = le - _lastMSecs$2 + (L - _lastNSecs$2) / 1e4;
  if (pe < 0 && n.clockseq === void 0 && (b = b + 1 & 16383), (pe < 0 || le > _lastMSecs$2) && n.nsecs === void 0 && (L = 0), L >= 1e4)
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  _lastMSecs$2 = le, _lastNSecs$2 = L, _clockseq$2 = b, le += 122192928e5;
  var $ = ((le & 268435455) * 1e4 + L) % 4294967296;
  a[p++] = $ >>> 24 & 255, a[p++] = $ >>> 16 & 255, a[p++] = $ >>> 8 & 255, a[p++] = $ & 255;
  var Ee = le / 4294967296 * 1e4 & 268435455;
  a[p++] = Ee >>> 8 & 255, a[p++] = Ee & 255, a[p++] = Ee >>> 24 & 15 | 16, a[p++] = Ee >>> 16 & 255, a[p++] = b >>> 8 | 128, a[p++] = b & 255;
  for (var be = 0; be < 6; ++be)
    a[p + be] = A[be];
  return c || stringify$4(a);
}
function parse$b(n) {
  if (!validate$5(n))
    throw TypeError("Invalid UUID");
  var c, u = new Uint8Array(16);
  return u[0] = (c = parseInt(n.slice(0, 8), 16)) >>> 24, u[1] = c >>> 16 & 255, u[2] = c >>> 8 & 255, u[3] = c & 255, u[4] = (c = parseInt(n.slice(9, 13), 16)) >>> 8, u[5] = c & 255, u[6] = (c = parseInt(n.slice(14, 18), 16)) >>> 8, u[7] = c & 255, u[8] = (c = parseInt(n.slice(19, 23), 16)) >>> 8, u[9] = c & 255, u[10] = (c = parseInt(n.slice(24, 36), 16)) / 1099511627776 & 255, u[11] = c / 4294967296 & 255, u[12] = c >>> 24 & 255, u[13] = c >>> 16 & 255, u[14] = c >>> 8 & 255, u[15] = c & 255, u;
}
function stringToBytes$3(n) {
  n = unescape(encodeURIComponent(n));
  for (var c = [], u = 0; u < n.length; ++u)
    c.push(n.charCodeAt(u));
  return c;
}
var DNS$2 = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", URL$3 = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
function v35$4(n, c, u) {
  function p(a, A, b, F) {
    if (typeof a == "string" && (a = stringToBytes$3(a)), typeof A == "string" && (A = parse$b(A)), A.length !== 16)
      throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    var le = new Uint8Array(16 + a.length);
    if (le.set(A), le.set(a, A.length), le = u(le), le[6] = le[6] & 15 | c, le[8] = le[8] & 63 | 128, b) {
      F = F || 0;
      for (var L = 0; L < 16; ++L)
        b[F + L] = le[L];
      return b;
    }
    return stringify$4(le);
  }
  try {
    p.name = n;
  } catch {
  }
  return p.DNS = DNS$2, p.URL = URL$3, p;
}
function md5$4(n) {
  if (typeof n == "string") {
    var c = unescape(encodeURIComponent(n));
    n = new Uint8Array(c.length);
    for (var u = 0; u < c.length; ++u)
      n[u] = c.charCodeAt(u);
  }
  return md5ToHexEncodedArray$2(wordsToMd5$2(bytesToWords$2(n), n.length * 8));
}
function md5ToHexEncodedArray$2(n) {
  for (var c = [], u = n.length * 32, p = "0123456789abcdef", a = 0; a < u; a += 8) {
    var A = n[a >> 5] >>> a % 32 & 255, b = parseInt(p.charAt(A >>> 4 & 15) + p.charAt(A & 15), 16);
    c.push(b);
  }
  return c;
}
function getOutputLength$2(n) {
  return (n + 64 >>> 9 << 4) + 14 + 1;
}
function wordsToMd5$2(n, c) {
  n[c >> 5] |= 128 << c % 32, n[getOutputLength$2(c) - 1] = c;
  for (var u = 1732584193, p = -271733879, a = -1732584194, A = 271733878, b = 0; b < n.length; b += 16) {
    var F = u, le = p, L = a, pe = A;
    u = md5ff$2(u, p, a, A, n[b], 7, -680876936), A = md5ff$2(A, u, p, a, n[b + 1], 12, -389564586), a = md5ff$2(a, A, u, p, n[b + 2], 17, 606105819), p = md5ff$2(p, a, A, u, n[b + 3], 22, -1044525330), u = md5ff$2(u, p, a, A, n[b + 4], 7, -176418897), A = md5ff$2(A, u, p, a, n[b + 5], 12, 1200080426), a = md5ff$2(a, A, u, p, n[b + 6], 17, -1473231341), p = md5ff$2(p, a, A, u, n[b + 7], 22, -45705983), u = md5ff$2(u, p, a, A, n[b + 8], 7, 1770035416), A = md5ff$2(A, u, p, a, n[b + 9], 12, -1958414417), a = md5ff$2(a, A, u, p, n[b + 10], 17, -42063), p = md5ff$2(p, a, A, u, n[b + 11], 22, -1990404162), u = md5ff$2(u, p, a, A, n[b + 12], 7, 1804603682), A = md5ff$2(A, u, p, a, n[b + 13], 12, -40341101), a = md5ff$2(a, A, u, p, n[b + 14], 17, -1502002290), p = md5ff$2(p, a, A, u, n[b + 15], 22, 1236535329), u = md5gg$2(u, p, a, A, n[b + 1], 5, -165796510), A = md5gg$2(A, u, p, a, n[b + 6], 9, -1069501632), a = md5gg$2(a, A, u, p, n[b + 11], 14, 643717713), p = md5gg$2(p, a, A, u, n[b], 20, -373897302), u = md5gg$2(u, p, a, A, n[b + 5], 5, -701558691), A = md5gg$2(A, u, p, a, n[b + 10], 9, 38016083), a = md5gg$2(a, A, u, p, n[b + 15], 14, -660478335), p = md5gg$2(p, a, A, u, n[b + 4], 20, -405537848), u = md5gg$2(u, p, a, A, n[b + 9], 5, 568446438), A = md5gg$2(A, u, p, a, n[b + 14], 9, -1019803690), a = md5gg$2(a, A, u, p, n[b + 3], 14, -187363961), p = md5gg$2(p, a, A, u, n[b + 8], 20, 1163531501), u = md5gg$2(u, p, a, A, n[b + 13], 5, -1444681467), A = md5gg$2(A, u, p, a, n[b + 2], 9, -51403784), a = md5gg$2(a, A, u, p, n[b + 7], 14, 1735328473), p = md5gg$2(p, a, A, u, n[b + 12], 20, -1926607734), u = md5hh$2(u, p, a, A, n[b + 5], 4, -378558), A = md5hh$2(A, u, p, a, n[b + 8], 11, -2022574463), a = md5hh$2(a, A, u, p, n[b + 11], 16, 1839030562), p = md5hh$2(p, a, A, u, n[b + 14], 23, -35309556), u = md5hh$2(u, p, a, A, n[b + 1], 4, -1530992060), A = md5hh$2(A, u, p, a, n[b + 4], 11, 1272893353), a = md5hh$2(a, A, u, p, n[b + 7], 16, -155497632), p = md5hh$2(p, a, A, u, n[b + 10], 23, -1094730640), u = md5hh$2(u, p, a, A, n[b + 13], 4, 681279174), A = md5hh$2(A, u, p, a, n[b], 11, -358537222), a = md5hh$2(a, A, u, p, n[b + 3], 16, -722521979), p = md5hh$2(p, a, A, u, n[b + 6], 23, 76029189), u = md5hh$2(u, p, a, A, n[b + 9], 4, -640364487), A = md5hh$2(A, u, p, a, n[b + 12], 11, -421815835), a = md5hh$2(a, A, u, p, n[b + 15], 16, 530742520), p = md5hh$2(p, a, A, u, n[b + 2], 23, -995338651), u = md5ii$2(u, p, a, A, n[b], 6, -198630844), A = md5ii$2(A, u, p, a, n[b + 7], 10, 1126891415), a = md5ii$2(a, A, u, p, n[b + 14], 15, -1416354905), p = md5ii$2(p, a, A, u, n[b + 5], 21, -57434055), u = md5ii$2(u, p, a, A, n[b + 12], 6, 1700485571), A = md5ii$2(A, u, p, a, n[b + 3], 10, -1894986606), a = md5ii$2(a, A, u, p, n[b + 10], 15, -1051523), p = md5ii$2(p, a, A, u, n[b + 1], 21, -2054922799), u = md5ii$2(u, p, a, A, n[b + 8], 6, 1873313359), A = md5ii$2(A, u, p, a, n[b + 15], 10, -30611744), a = md5ii$2(a, A, u, p, n[b + 6], 15, -1560198380), p = md5ii$2(p, a, A, u, n[b + 13], 21, 1309151649), u = md5ii$2(u, p, a, A, n[b + 4], 6, -145523070), A = md5ii$2(A, u, p, a, n[b + 11], 10, -1120210379), a = md5ii$2(a, A, u, p, n[b + 2], 15, 718787259), p = md5ii$2(p, a, A, u, n[b + 9], 21, -343485551), u = safeAdd$2(u, F), p = safeAdd$2(p, le), a = safeAdd$2(a, L), A = safeAdd$2(A, pe);
  }
  return [u, p, a, A];
}
function bytesToWords$2(n) {
  if (n.length === 0)
    return [];
  for (var c = n.length * 8, u = new Uint32Array(getOutputLength$2(c)), p = 0; p < c; p += 8)
    u[p >> 5] |= (n[p / 8] & 255) << p % 32;
  return u;
}
function safeAdd$2(n, c) {
  var u = (n & 65535) + (c & 65535), p = (n >> 16) + (c >> 16) + (u >> 16);
  return p << 16 | u & 65535;
}
function bitRotateLeft$2(n, c) {
  return n << c | n >>> 32 - c;
}
function md5cmn$2(n, c, u, p, a, A) {
  return safeAdd$2(bitRotateLeft$2(safeAdd$2(safeAdd$2(c, n), safeAdd$2(p, A)), a), u);
}
function md5ff$2(n, c, u, p, a, A, b) {
  return md5cmn$2(c & u | ~c & p, n, c, a, A, b);
}
function md5gg$2(n, c, u, p, a, A, b) {
  return md5cmn$2(c & p | u & ~p, n, c, a, A, b);
}
function md5hh$2(n, c, u, p, a, A, b) {
  return md5cmn$2(c ^ u ^ p, n, c, a, A, b);
}
function md5ii$2(n, c, u, p, a, A, b) {
  return md5cmn$2(u ^ (c | ~p), n, c, a, A, b);
}
var v3$4 = v35$4("v3", 48, md5$4);
function v4$5(n, c, u) {
  n = n || {};
  var p = n.random || (n.rng || rng$5)();
  if (p[6] = p[6] & 15 | 64, p[8] = p[8] & 63 | 128, c) {
    u = u || 0;
    for (var a = 0; a < 16; ++a)
      c[u + a] = p[a];
    return c;
  }
  return stringify$4(p);
}
function f$4(n, c, u, p) {
  switch (n) {
    case 0:
      return c & u ^ ~c & p;
    case 1:
      return c ^ u ^ p;
    case 2:
      return c & u ^ c & p ^ u & p;
    case 3:
      return c ^ u ^ p;
  }
}
function ROTL$2(n, c) {
  return n << c | n >>> 32 - c;
}
function sha1$4(n) {
  var c = [1518500249, 1859775393, 2400959708, 3395469782], u = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
  if (typeof n == "string") {
    var p = unescape(encodeURIComponent(n));
    n = [];
    for (var a = 0; a < p.length; ++a)
      n.push(p.charCodeAt(a));
  } else Array.isArray(n) || (n = Array.prototype.slice.call(n));
  n.push(128);
  for (var A = n.length / 4 + 2, b = Math.ceil(A / 16), F = new Array(b), le = 0; le < b; ++le) {
    for (var L = new Uint32Array(16), pe = 0; pe < 16; ++pe)
      L[pe] = n[le * 64 + pe * 4] << 24 | n[le * 64 + pe * 4 + 1] << 16 | n[le * 64 + pe * 4 + 2] << 8 | n[le * 64 + pe * 4 + 3];
    F[le] = L;
  }
  F[b - 1][14] = (n.length - 1) * 8 / Math.pow(2, 32), F[b - 1][14] = Math.floor(F[b - 1][14]), F[b - 1][15] = (n.length - 1) * 8 & 4294967295;
  for (var $ = 0; $ < b; ++$) {
    for (var Ee = new Uint32Array(80), be = 0; be < 16; ++be)
      Ee[be] = F[$][be];
    for (var He = 16; He < 80; ++He)
      Ee[He] = ROTL$2(Ee[He - 3] ^ Ee[He - 8] ^ Ee[He - 14] ^ Ee[He - 16], 1);
    for (var Pe = u[0], nr = u[1], ir = u[2], or = u[3], lr = u[4], Ir = 0; Ir < 80; ++Ir) {
      var xr = Math.floor(Ir / 20), kr = ROTL$2(Pe, 5) + f$4(xr, nr, ir, or) + lr + c[xr] + Ee[Ir] >>> 0;
      lr = or, or = ir, ir = ROTL$2(nr, 30) >>> 0, nr = Pe, Pe = kr;
    }
    u[0] = u[0] + Pe >>> 0, u[1] = u[1] + nr >>> 0, u[2] = u[2] + ir >>> 0, u[3] = u[3] + or >>> 0, u[4] = u[4] + lr >>> 0;
  }
  return [u[0] >> 24 & 255, u[0] >> 16 & 255, u[0] >> 8 & 255, u[0] & 255, u[1] >> 24 & 255, u[1] >> 16 & 255, u[1] >> 8 & 255, u[1] & 255, u[2] >> 24 & 255, u[2] >> 16 & 255, u[2] >> 8 & 255, u[2] & 255, u[3] >> 24 & 255, u[3] >> 16 & 255, u[3] >> 8 & 255, u[3] & 255, u[4] >> 24 & 255, u[4] >> 16 & 255, u[4] >> 8 & 255, u[4] & 255];
}
var v5$4 = v35$4("v5", 80, sha1$4);
const nil$4 = "00000000-0000-0000-0000-000000000000";
function version$5(n) {
  if (!validate$5(n))
    throw TypeError("Invalid UUID");
  return parseInt(n.substr(14, 1), 16);
}
const esmBrowser$2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  NIL: nil$4,
  parse: parse$b,
  stringify: stringify$4,
  v1: v1$4,
  v3: v3$4,
  v4: v4$5,
  v5: v5$4,
  validate: validate$5,
  version: version$5
}, Symbol.toStringTag, { value: "Module" })), require$$1$2 = /* @__PURE__ */ getAugmentedNamespace(esmBrowser$2);
var hasRequiredBcUrRegistryCardano_cjs_production_min;
function requireBcUrRegistryCardano_cjs_production_min() {
  return hasRequiredBcUrRegistryCardano_cjs_production_min || (hasRequiredBcUrRegistryCardano_cjs_production_min = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 });
    var c = requireDist$4(), u = require$$1$2;
    const p = { CARDANO_UTXO: new c.RegistryType("cardano-utxo", 2201), CARDANO_SIGN_REQUEST: new c.RegistryType("cardano-sign-request", 2202), CARDANO_SIGNATURE: new c.RegistryType("cardano-signature", 2203), CARDANO_CERT_KEY: new c.RegistryType("cardano-cert-key", 2204), CARDANO_SIGN_DATA_REQUEST: new c.RegistryType("cardano-sign-data-request", 2205), CARDANO_SIGN_DATA_SIGNATURE: new c.RegistryType("cardano-sign-data-signature", 2206), CARDANO_CATALYST_VOTING_REGISTRATION: new c.RegistryType("cardano-catalyst-voting-registration", 2207), CARDANO_CATALYST_VOTING_REGISTRATION_SIGNATURE: new c.RegistryType("cardano-catalyst-voting-registration-signature", 2208), CARDANO_DELEGATION: new c.RegistryType("cardano-delegation", 2209), CARDANO_SIGN_CIP8_DATA_REQUEST: new c.RegistryType("cardano-sign-cip8-data-request", 2210), CARDANO_SIGN_CIP8_DATA_SIGNATURE: new c.RegistryType("cardano-sign-cip8-data-signature", 2211) }, { decodeToDataItem: a } = c.extend;
    var A;
    (function(ei) {
      ei[ei.transactionHash = 1] = "transactionHash", ei[ei.index = 2] = "index", ei[ei.amount = 3] = "amount", ei[ei.keyPath = 4] = "keyPath", ei[ei.address = 5] = "address";
    })(A || (A = {}));
    class b extends c.RegistryItem {
      constructor(Vr) {
        super(), this.getRegistryType = () => p.CARDANO_UTXO, this.getTransactionHash = () => this.transactionHash, this.getIndex = () => this.index, this.getKeyPath = () => this.keyPath.getPath(), this.getAmount = () => this.amount, this.getAddress = () => this.address, this.toDataItem = () => {
          const qr = {};
          this.transactionHash && (qr[A.transactionHash] = this.transactionHash), qr[A.index] = this.index, qr[A.amount] = this.amount;
          const Zi = this.keyPath.toDataItem();
          return Zi.setTag(this.keyPath.getRegistryType().getTag()), qr[A.keyPath] = Zi, qr[A.address] = this.address, new c.DataItem(qr);
        }, this.transactionHash = Vr.transactionHash, this.index = Vr.index, this.amount = Vr.amount, this.keyPath = Vr.keyPath, this.address = Vr.address;
      }
      static constructCardanoUtxo({ transactionHash: Vr, index: qr, amount: Zi, xfp: Wr, hdPath: ri, address: _i }) {
        const Er = ri.replace(/[m|M]\//, "").split("/"), Di = new c.CryptoKeypath(Er.map((_n) => {
          const On = parseInt(_n.replace("'", "")), so = _n.endsWith("'");
          return new c.PathComponent({ index: On, hardened: so });
        }), Buffer$f.from(Wr, "hex"));
        return new b({ transactionHash: Buffer$f.from(Vr, "hex"), index: qr, amount: Zi, keyPath: Di, address: _i });
      }
    }
    b.fromDataItem = (ei) => {
      const Vr = ei.getData(), qr = Vr[A.transactionHash], Zi = Vr[A.index], Wr = c.CryptoKeypath.fromDataItem(Vr[A.keyPath]);
      return new b({ transactionHash: qr, index: Zi, amount: Vr[A.amount], keyPath: Wr, address: Vr[A.address] });
    }, b.fromCBOR = (ei) => {
      const Vr = a(ei);
      return b.fromDataItem(Vr);
    };
    const { decodeToDataItem: F } = c.extend;
    var le;
    (function(ei) {
      ei[ei.keyHash = 1] = "keyHash", ei[ei.keyPath = 2] = "keyPath";
    })(le || (le = {}));
    class L extends c.RegistryItem {
      constructor(Vr) {
        super(), this.getRegistryType = () => p.CARDANO_CERT_KEY, this.getKeyHash = () => this.keyHash, this.getKeyPath = () => this.keyPath.getPath(), this.toDataItem = () => {
          const qr = {};
          qr[le.keyHash] = this.keyHash;
          const Zi = this.keyPath.toDataItem();
          return Zi.setTag(this.keyPath.getRegistryType().getTag()), qr[le.keyPath] = Zi, new c.DataItem(qr);
        }, this.keyHash = Vr.keyHash, this.keyPath = Vr.keyPath;
      }
      static constructCardanoCertKey({ keyHash: Vr, xfp: qr, keyPath: Zi }) {
        const Wr = Zi.replace(/[m|M]\//, "").split("/"), ri = new c.CryptoKeypath(Wr.map((_i) => {
          const Er = parseInt(_i.replace("'", "")), Di = _i.endsWith("'");
          return new c.PathComponent({ index: Er, hardened: Di });
        }), Buffer$f.from(qr, "hex"));
        return new L({ keyHash: Buffer$f.from(Vr, "hex"), keyPath: ri });
      }
    }
    L.fromDataItem = (ei) => {
      const Vr = ei.getData(), qr = Vr[le.keyHash], Zi = c.CryptoKeypath.fromDataItem(Vr[le.keyPath]);
      return new L({ keyHash: qr, keyPath: Zi });
    }, L.fromCBOR = (ei) => {
      const Vr = F(ei);
      return L.fromDataItem(Vr);
    };
    const { decodeToDataItem: pe, RegistryTypes: $ } = c.extend;
    var Ee;
    (function(ei) {
      ei[ei.requestId = 1] = "requestId", ei[ei.signData = 2] = "signData", ei[ei.utxos = 3] = "utxos", ei[ei.extraSigners = 4] = "extraSigners", ei[ei.origin = 5] = "origin";
    })(Ee || (Ee = {}));
    class be extends c.RegistryItem {
      constructor(Vr) {
        super(), this.getRegistryType = () => p.CARDANO_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getUtxos = () => this.utxos, this.getAdditionalSigners = () => this.extraSigners, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const qr = {};
          return this.requestId && (qr[Ee.requestId] = new c.DataItem(this.requestId, $.UUID.getTag())), qr[Ee.signData] = this.signData, qr[Ee.utxos] = this.utxos.map((Zi) => {
            const Wr = Zi.toDataItem();
            return Wr.setTag(Zi.getRegistryType().getTag()), Wr;
          }), qr[Ee.extraSigners] = this.extraSigners.map((Zi) => {
            const Wr = Zi.toDataItem();
            return Wr.setTag(Zi.getRegistryType().getTag()), Wr;
          }), this.origin && (qr[Ee.origin] = this.origin), new c.DataItem(qr);
        }, this.requestId = Vr.requestId, this.signData = Vr.signData, this.utxos = Vr.utxos, this.extraSigners = Vr.extraSigners, this.origin = Vr.origin;
      }
      static constructCardanoSignRequest(Vr, qr, Zi, Wr, ri) {
        const _i = qr.map((Di) => b.constructCardanoUtxo(Di)), Er = Zi.map((Di) => L.constructCardanoCertKey(Di));
        return new be({ requestId: Wr ? Buffer$f.from(u.parse(Wr)) : void 0, signData: Vr, utxos: _i, extraSigners: Er, origin: ri || void 0 });
      }
    }
    be.fromDataItem = (ei) => {
      const Vr = ei.getData(), qr = Vr[Ee.signData], Zi = Vr[Ee.utxos].map((_i) => b.fromDataItem(_i)), Wr = Vr[Ee.extraSigners].map((_i) => L.fromDataItem(_i)), ri = Vr[Ee.requestId] ? Vr[Ee.requestId].getData() : void 0;
      return new be({ requestId: ri, signData: qr, utxos: Zi, extraSigners: Wr, origin: Vr[Ee.origin] ? Vr[Ee.origin] : void 0 });
    }, be.fromCBOR = (ei) => {
      const Vr = pe(ei);
      return be.fromDataItem(Vr);
    };
    const { RegistryTypes: He, decodeToDataItem: Pe } = c.extend;
    var nr;
    (function(ei) {
      ei[ei.requestId = 1] = "requestId", ei[ei.signature = 2] = "signature";
    })(nr || (nr = {}));
    class ir extends c.RegistryItem {
      constructor(Vr, qr) {
        super(), this.getRegistryType = () => p.CARDANO_SIGNATURE, this.getRequestId = () => this.requestId, this.getWitnessSet = () => this.witnessSet, this.toDataItem = () => {
          const Zi = {};
          return this.requestId && (Zi[nr.requestId] = new c.DataItem(this.requestId, He.UUID.getTag())), Zi[nr.signature] = this.witnessSet, new c.DataItem(Zi);
        }, this.witnessSet = Vr, this.requestId = qr;
      }
    }
    ir.fromDataItem = (ei) => {
      const Vr = ei.getData(), qr = Vr[nr.signature], Zi = Vr[nr.requestId] ? Vr[nr.requestId].getData() : void 0;
      return new ir(qr, Zi);
    }, ir.fromCBOR = (ei) => {
      const Vr = Pe(ei);
      return ir.fromDataItem(Vr);
    };
    const { decodeToDataItem: or, RegistryTypes: lr } = c.extend;
    var Ir;
    (function(ei) {
      ei[ei.requestId = 1] = "requestId", ei[ei.signData = 2] = "signData", ei[ei.derivationPath = 3] = "derivationPath", ei[ei.origin = 4] = "origin", ei[ei.signType = 5] = "signType", ei[ei.xpub = 6] = "xpub";
    })(Ir || (Ir = {}));
    class xr extends c.RegistryItem {
      constructor(Vr) {
        super(), this.getRegistryType = () => p.CARDANO_SIGN_DATA_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDerivationPath = () => this.derivationPath.getPath(), this.getOrigin = () => this.origin, this.getXpub = () => this.xpub, this.toDataItem = () => {
          const qr = {};
          this.requestId && (qr[Ir.requestId] = new c.DataItem(this.requestId, lr.UUID.getTag())), this.origin && (qr[Ir.origin] = this.origin), qr[Ir.signData] = this.signData;
          const Zi = this.derivationPath.toDataItem();
          return Zi.setTag(this.derivationPath.getRegistryType().getTag()), qr[Ir.derivationPath] = Zi, qr[Ir.xpub] = this.xpub, new c.DataItem(qr);
        }, this.requestId = Vr.requestId, this.signData = Vr.signData, this.derivationPath = Vr.derivationPath, this.origin = Vr.origin, this.xpub = Vr.xpub;
      }
      static constructCardanoSignDataRequest(Vr, qr, Zi, Wr, ri, _i) {
        const Er = qr.replace(/[m|M]\//, "").split("/"), Di = new c.CryptoKeypath(Er.map((_n) => {
          const On = parseInt(_n.replace("'", ""));
          let so = !1;
          return _n.endsWith("'") && (so = !0), new c.PathComponent({ index: On, hardened: so });
        }), Buffer$f.from(Zi, "hex"));
        return new xr({ requestId: ri ? Buffer$f.from(u.parse(ri)) : void 0, signData: Buffer$f.from(Vr, "hex"), derivationPath: Di, origin: _i || void 0, xpub: Buffer$f.from(Wr, "hex") });
      }
    }
    xr.fromDataItem = (ei) => {
      const Vr = ei.getData(), qr = Vr[Ir.signData], Zi = c.CryptoKeypath.fromDataItem(Vr[Ir.derivationPath]), Wr = Vr[Ir.requestId] ? Vr[Ir.requestId].getData() : void 0;
      return new xr({ requestId: Wr, signData: qr, derivationPath: Zi, origin: Vr[Ir.origin] ? Vr[Ir.origin] : void 0, xpub: Vr[Ir.xpub] });
    }, xr.fromCBOR = (ei) => {
      const Vr = or(ei);
      return xr.fromDataItem(Vr);
    };
    const { RegistryTypes: kr, decodeToDataItem: Ce } = c.extend;
    var tr;
    (function(ei) {
      ei[ei.requestId = 1] = "requestId", ei[ei.signature = 2] = "signature", ei[ei.publicKey = 3] = "publicKey";
    })(tr || (tr = {}));
    class Fe extends c.RegistryItem {
      constructor(Vr, qr, Zi) {
        super(), this.getRegistryType = () => p.CARDANO_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.getPublicKey = () => this.publicKey, this.toDataItem = () => {
          const Wr = {};
          return this.requestId && (Wr[tr.requestId] = new c.DataItem(this.requestId, kr.UUID.getTag())), Wr[tr.signature] = this.getSignature(), Wr[tr.publicKey] = this.getPublicKey(), new c.DataItem(Wr);
        }, this.signature = Vr, this.publicKey = qr, this.requestId = Zi;
      }
    }
    Fe.fromDataItem = (ei) => {
      const Vr = ei.getData(), qr = Vr[tr.signature], Zi = Vr[tr.publicKey], Wr = Vr[tr.requestId] ? Vr[tr.requestId].getData() : void 0;
      return new Fe(qr, Zi, Wr);
    }, Fe.fromCBOR = (ei) => {
      const Vr = Ce(ei);
      return Fe.fromDataItem(Vr);
    };
    const { decodeToDataItem: Sr } = c.extend;
    var er;
    (function(ei) {
      ei[ei.pubKey = 1] = "pubKey", ei[ei.weight = 2] = "weight";
    })(er || (er = {}));
    class Ie extends c.RegistryItem {
      constructor(Vr) {
        super(), this.getRegistryType = () => p.CARDANO_DELEGATION, this.getPubKey = () => this.pubKey, this.getWeight = () => this.weight, this.toDataItem = () => {
          const qr = {};
          return qr[er.pubKey] = this.getPubKey(), qr[er.weight] = this.getWeight(), new c.DataItem(qr);
        }, this.pubKey = Vr.pubKey, this.weight = Vr.weight;
      }
      static constructCardanoDelegation({ pubKey: Vr, weight: qr }) {
        return new Ie({ pubKey: Vr, weight: qr });
      }
    }
    Ie.fromDataItem = (ei) => {
      const Vr = ei.getData();
      return new Ie({ pubKey: Vr[er.pubKey], weight: Vr[er.weight] });
    }, Ie.fromCBOR = (ei) => {
      const Vr = Sr(ei);
      return Ie.fromDataItem(Vr);
    };
    const { decodeToDataItem: xe, RegistryTypes: rr } = c.extend;
    var ar;
    (function(ei) {
      ei[ei.requestId = 1] = "requestId", ei[ei.delegations = 2] = "delegations", ei[ei.stakePub = 3] = "stakePub", ei[ei.paymentAddress = 4] = "paymentAddress", ei[ei.nonce = 5] = "nonce", ei[ei.voting_purpose = 6] = "voting_purpose", ei[ei.derivationPath = 7] = "derivationPath", ei[ei.origin = 8] = "origin", ei[ei.signType = 9] = "signType";
    })(ar || (ar = {}));
    const yr = (ei, Vr) => {
      const qr = ei.replace(/[m|M]\//, "").split("/");
      return new c.CryptoKeypath(qr.map((Zi) => {
        const Wr = parseInt(Zi.replace("'", ""));
        let ri = !1;
        return Zi.endsWith("'") && (ri = !0), new c.PathComponent({ index: Wr, hardened: ri });
      }), Buffer$f.from(Vr, "hex"));
    };
    class _r extends c.RegistryItem {
      constructor(Vr) {
        super(), this.getRegistryType = () => p.CARDANO_CATALYST_VOTING_REGISTRATION, this.getRequestId = () => this.requestId, this.getDelegations = () => this.delegations, this.getStakePub = () => this.stakePub, this.getPaymentAddress = () => this.paymentAddress, this.getNonce = () => this.nonce, this.getVotingPurpose = () => this.voting_purpose, this.getDerivationPath = () => this.derivationPath.getPath(), this.getOrigin = () => this.origin, this.toDataItem = () => {
          const qr = {};
          this.requestId && (qr[ar.requestId] = new c.DataItem(this.requestId, rr.UUID.getTag())), qr[ar.stakePub] = this.stakePub, qr[ar.paymentAddress] = this.paymentAddress, qr[ar.nonce] = this.nonce, qr[ar.voting_purpose] = this.voting_purpose, qr[ar.delegations] = this.delegations.map((Wr) => {
            const ri = Wr.toDataItem();
            return ri.setTag(Wr.getRegistryType().getTag()), ri;
          }), this.origin && (qr[ar.origin] = this.origin);
          const Zi = this.derivationPath.toDataItem();
          return Zi.setTag(this.derivationPath.getRegistryType().getTag()), qr[ar.derivationPath] = Zi, new c.DataItem(qr);
        }, this.requestId = Vr.requestId, this.derivationPath = Vr.derivationPath, this.delegations = Vr.delegations, this.stakePub = Vr.stakePub, this.paymentAddress = Vr.paymentAddress, this.nonce = Vr.nonce, this.voting_purpose = Vr.voting_purpose, this.origin = Vr.origin;
      }
      static constructCardanoCatalystRequest(Vr, qr, Zi, Wr, ri, _i, Er, Di, _n) {
        const On = Di ? Buffer$f.from(u.parse(Di)) : void 0, so = Vr.map((Do) => Ie.constructCardanoDelegation({ pubKey: Buffer$f.from(Do.pubKey, "hex"), weight: Do.weight }));
        return new _r({ requestId: On, delegations: so, stakePub: Buffer$f.from(qr, "hex"), paymentAddress: Buffer$f.from(Zi, "hex"), nonce: Wr, voting_purpose: ri, derivationPath: yr(_i, Er), origin: _n });
      }
    }
    _r.fromDataItem = (ei) => {
      const Vr = ei.getData(), qr = Vr[ar.delegations].map((_n) => Ie.fromDataItem(_n)), Zi = Vr[ar.stakePub], Wr = Vr[ar.paymentAddress], ri = Vr[ar.nonce], _i = Vr[ar.voting_purpose], Er = c.CryptoKeypath.fromDataItem(Vr[ar.derivationPath]), Di = Vr[ar.requestId] ? Vr[ar.requestId].getData() : void 0;
      return new _r({ requestId: Di, delegations: qr, stakePub: Zi, paymentAddress: Wr, nonce: ri, voting_purpose: _i, derivationPath: Er, origin: Vr[ar.origin] ? Vr[ar.origin] : void 0 });
    }, _r.fromCBOR = (ei) => {
      const Vr = xe(ei);
      return _r.fromDataItem(Vr);
    };
    const { RegistryTypes: Or, decodeToDataItem: vr } = c.extend;
    var Te;
    (function(ei) {
      ei[ei.requestId = 1] = "requestId", ei[ei.signature = 2] = "signature";
    })(Te || (Te = {}));
    class Cr extends c.RegistryItem {
      constructor(Vr, qr) {
        super(), this.getRegistryType = () => p.CARDANO_CATALYST_VOTING_REGISTRATION_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.toDataItem = () => {
          const Zi = {};
          return this.requestId && (Zi[Te.requestId] = new c.DataItem(this.requestId, Or.UUID.getTag())), Zi[Te.signature] = this.getSignature(), new c.DataItem(Zi);
        }, this.signature = Vr, this.requestId = qr;
      }
    }
    Cr.fromDataItem = (ei) => {
      const Vr = ei.getData(), qr = Vr[Te.signature], Zi = Vr[Te.requestId] ? Vr[Te.requestId].getData() : void 0;
      return new Cr(qr, Zi);
    }, Cr.fromCBOR = (ei) => {
      const Vr = vr(ei);
      return Cr.fromDataItem(Vr);
    };
    const { decodeToDataItem: Hr, RegistryTypes: si } = c.extend;
    var ui, Li;
    (function(ei) {
      ei[ei.requestId = 1] = "requestId", ei[ei.signData = 2] = "signData", ei[ei.derivationPath = 3] = "derivationPath", ei[ei.origin = 4] = "origin", ei[ei.signType = 5] = "signType", ei[ei.xpub = 6] = "xpub", ei[ei.hashPayload = 7] = "hashPayload", ei[ei.addressBench32 = 8] = "addressBench32", ei[ei.addressFieldType = 9] = "addressFieldType";
    })(ui || (ui = {})), (Li = n.MessageAddressFieldType || (n.MessageAddressFieldType = {})).ADDRESS = "ADDRESS", Li.KEY_HASH = "KEY_HASH";
    class Qi extends c.RegistryItem {
      constructor(Vr) {
        super(), this.getRegistryType = () => p.CARDANO_SIGN_CIP8_DATA_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDerivationPath = () => this.derivationPath.getPath(), this.getOrigin = () => this.origin, this.getXpub = () => this.xpub, this.getHashPayload = () => this.hashPayload, this.getAddressBench32 = () => this.addressBench32, this.getAddressFieldType = () => this.addressFieldType, this.toDataItem = () => {
          const qr = {};
          this.requestId && (qr[ui.requestId] = new c.DataItem(this.requestId, si.UUID.getTag())), this.origin && (qr[ui.origin] = this.origin), qr[ui.signData] = this.signData;
          const Zi = this.derivationPath.toDataItem();
          return Zi.setTag(this.derivationPath.getRegistryType().getTag()), qr[ui.derivationPath] = Zi, qr[ui.xpub] = this.xpub, qr[ui.hashPayload] = this.hashPayload, this.addressBench32 && (qr[ui.addressBench32] = this.addressBench32), qr[ui.addressFieldType] = this.addressFieldType, new c.DataItem(qr);
        }, this.requestId = Vr.requestId, this.signData = Vr.signData, this.derivationPath = Vr.derivationPath, this.origin = Vr.origin, this.xpub = Vr.xpub, this.hashPayload = Vr.hashPayload, this.addressBench32 = Vr.addressBench32, this.addressFieldType = Vr.addressFieldType;
      }
      static constructCardanoSignCip8DataRequest(Vr, qr, Zi, Wr, ri, _i, Er, Di, _n) {
        const On = qr.replace(/[m|M]\//, "").split("/"), so = new c.CryptoKeypath(On.map((Do) => {
          const gn = parseInt(Do.replace("'", ""));
          let Gn = !1;
          return Do.endsWith("'") && (Gn = !0), new c.PathComponent({ index: gn, hardened: Gn });
        }), Buffer$f.from(Zi, "hex"));
        return new Qi({ requestId: Di ? Buffer$f.from(u.parse(Di)) : void 0, signData: Buffer$f.from(Vr, "hex"), derivationPath: so, origin: _n || void 0, xpub: Buffer$f.from(Wr, "hex"), hashPayload: ri, addressBench32: Er || void 0, addressFieldType: _i });
      }
    }
    Qi.fromDataItem = (ei) => {
      const Vr = ei.getData(), qr = Vr[ui.signData], Zi = c.CryptoKeypath.fromDataItem(Vr[ui.derivationPath]), Wr = Vr[ui.requestId] ? Vr[ui.requestId].getData() : void 0;
      return new Qi({ requestId: Wr, signData: qr, derivationPath: Zi, origin: Vr[ui.origin] ? Vr[ui.origin] : void 0, xpub: Vr[ui.xpub], hashPayload: Vr[ui.hashPayload], addressBench32: Vr[ui.addressBench32] ? Vr[ui.addressBench32] : void 0, addressFieldType: Vr[ui.addressFieldType] });
    }, Qi.fromCBOR = (ei) => {
      const Vr = Hr(ei);
      return Qi.fromDataItem(Vr);
    };
    const { RegistryTypes: wi, decodeToDataItem: Ji } = c.extend;
    var mn;
    (function(ei) {
      ei[ei.requestId = 1] = "requestId", ei[ei.signature = 2] = "signature", ei[ei.publicKey = 3] = "publicKey", ei[ei.addressField = 4] = "addressField";
    })(mn || (mn = {}));
    class pi extends c.RegistryItem {
      constructor(Vr, qr, Zi, Wr) {
        super(), this.getRegistryType = () => p.CARDANO_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.getPublicKey = () => this.publicKey, this.getAddressField = () => this.addressField, this.toDataItem = () => {
          const ri = {};
          return this.requestId && (ri[mn.requestId] = new c.DataItem(this.requestId, wi.UUID.getTag())), ri[mn.signature] = this.getSignature(), ri[mn.publicKey] = this.getPublicKey(), ri[mn.addressField] = this.getAddressField(), new c.DataItem(ri);
        }, this.signature = Vr, this.publicKey = qr, this.requestId = Wr, this.addressField = Zi;
      }
    }
    pi.fromDataItem = (ei) => {
      const Vr = ei.getData(), qr = Vr[mn.signature], Zi = Vr[mn.publicKey], Wr = Vr[mn.requestId] ? Vr[mn.requestId].getData() : void 0;
      return new pi(qr, Zi, Vr[mn.addressField], Wr);
    }, pi.fromCBOR = (ei) => {
      const Vr = Ji(ei);
      return pi.fromDataItem(Vr);
    }, c.patchTags(Object.values(p).filter((ei) => !!ei.getTag()).map((ei) => ei.getTag())), Object.keys(c).forEach(function(ei) {
      ei !== "default" && Object.defineProperty(n, ei, { enumerable: !0, get: function() {
        return c[ei];
      } });
    }), n.CardanoCatalystRequest = _r, n.CardanoCatalystSignature = Cr, n.CardanoCertKey = L, n.CardanoSignCip8DataRequest = Qi, n.CardanoSignCip8DataSignature = pi, n.CardanoSignDataRequest = xr, n.CardanoSignDataSignature = Fe, n.CardanoSignRequest = be, n.CardanoSignature = ir;
  }(bcUrRegistryCardano_cjs_production_min)), bcUrRegistryCardano_cjs_production_min;
}
var bcUrRegistryCardano_cjs_development = {}, hasRequiredBcUrRegistryCardano_cjs_development;
function requireBcUrRegistryCardano_cjs_development() {
  return hasRequiredBcUrRegistryCardano_cjs_development || (hasRequiredBcUrRegistryCardano_cjs_development = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 });
    var c = requireDist$4(), u = require$$1$2;
    const p = {
      CARDANO_UTXO: /* @__PURE__ */ new c.RegistryType("cardano-utxo", 2201),
      CARDANO_SIGN_REQUEST: /* @__PURE__ */ new c.RegistryType("cardano-sign-request", 2202),
      CARDANO_SIGNATURE: /* @__PURE__ */ new c.RegistryType("cardano-signature", 2203),
      CARDANO_CERT_KEY: /* @__PURE__ */ new c.RegistryType("cardano-cert-key", 2204),
      CARDANO_SIGN_DATA_REQUEST: /* @__PURE__ */ new c.RegistryType("cardano-sign-data-request", 2205),
      CARDANO_SIGN_DATA_SIGNATURE: /* @__PURE__ */ new c.RegistryType("cardano-sign-data-signature", 2206),
      CARDANO_CATALYST_VOTING_REGISTRATION: /* @__PURE__ */ new c.RegistryType("cardano-catalyst-voting-registration", 2207),
      CARDANO_CATALYST_VOTING_REGISTRATION_SIGNATURE: /* @__PURE__ */ new c.RegistryType("cardano-catalyst-voting-registration-signature", 2208),
      CARDANO_DELEGATION: /* @__PURE__ */ new c.RegistryType("cardano-delegation", 2209),
      CARDANO_SIGN_CIP8_DATA_REQUEST: /* @__PURE__ */ new c.RegistryType("cardano-sign-cip8-data-request", 2210),
      CARDANO_SIGN_CIP8_DATA_SIGNATURE: /* @__PURE__ */ new c.RegistryType("cardano-sign-cip8-data-signature", 2211)
    }, {
      decodeToDataItem: a
    } = c.extend;
    var A;
    (function(pi) {
      pi[pi.transactionHash = 1] = "transactionHash", pi[pi.index = 2] = "index", pi[pi.amount = 3] = "amount", pi[pi.keyPath = 4] = "keyPath", pi[pi.address = 5] = "address";
    })(A || (A = {}));
    class b extends c.RegistryItem {
      constructor(ei) {
        super(), this.getRegistryType = () => p.CARDANO_UTXO, this.getTransactionHash = () => this.transactionHash, this.getIndex = () => this.index, this.getKeyPath = () => this.keyPath.getPath(), this.getAmount = () => this.amount, this.getAddress = () => this.address, this.toDataItem = () => {
          const Vr = {};
          this.transactionHash && (Vr[A.transactionHash] = this.transactionHash), Vr[A.index] = this.index, Vr[A.amount] = this.amount;
          const qr = this.keyPath.toDataItem();
          return qr.setTag(this.keyPath.getRegistryType().getTag()), Vr[A.keyPath] = qr, Vr[A.address] = this.address, new c.DataItem(Vr);
        }, this.transactionHash = ei.transactionHash, this.index = ei.index, this.amount = ei.amount, this.keyPath = ei.keyPath, this.address = ei.address;
      }
      static constructCardanoUtxo({
        transactionHash: ei,
        index: Vr,
        amount: qr,
        xfp: Zi,
        hdPath: Wr,
        address: ri
      }) {
        const _i = Wr.replace(/[m|M]\//, "").split("/"), Er = new c.CryptoKeypath(_i.map((Di) => {
          const _n = parseInt(Di.replace("'", "")), On = Di.endsWith("'");
          return new c.PathComponent({
            index: _n,
            hardened: On
          });
        }), Buffer$f.from(Zi, "hex"));
        return new b({
          transactionHash: Buffer$f.from(ei, "hex"),
          index: Vr,
          amount: qr,
          keyPath: Er,
          address: ri
        });
      }
    }
    b.fromDataItem = (pi) => {
      const ei = pi.getData(), Vr = ei[A.transactionHash], qr = ei[A.index], Zi = c.CryptoKeypath.fromDataItem(ei[A.keyPath]), Wr = ei[A.address], ri = ei[A.amount];
      return new b({
        transactionHash: Vr,
        index: qr,
        amount: ri,
        keyPath: Zi,
        address: Wr
      });
    }, b.fromCBOR = (pi) => {
      const ei = a(pi);
      return b.fromDataItem(ei);
    };
    const {
      decodeToDataItem: F
    } = c.extend;
    var le;
    (function(pi) {
      pi[pi.keyHash = 1] = "keyHash", pi[pi.keyPath = 2] = "keyPath";
    })(le || (le = {}));
    class L extends c.RegistryItem {
      constructor(ei) {
        super(), this.getRegistryType = () => p.CARDANO_CERT_KEY, this.getKeyHash = () => this.keyHash, this.getKeyPath = () => this.keyPath.getPath(), this.toDataItem = () => {
          const Vr = {};
          Vr[le.keyHash] = this.keyHash;
          const qr = this.keyPath.toDataItem();
          return qr.setTag(this.keyPath.getRegistryType().getTag()), Vr[le.keyPath] = qr, new c.DataItem(Vr);
        }, this.keyHash = ei.keyHash, this.keyPath = ei.keyPath;
      }
      static constructCardanoCertKey({
        keyHash: ei,
        xfp: Vr,
        keyPath: qr
      }) {
        const Zi = qr.replace(/[m|M]\//, "").split("/"), Wr = new c.CryptoKeypath(Zi.map((ri) => {
          const _i = parseInt(ri.replace("'", "")), Er = ri.endsWith("'");
          return new c.PathComponent({
            index: _i,
            hardened: Er
          });
        }), Buffer$f.from(Vr, "hex"));
        return new L({
          keyHash: Buffer$f.from(ei, "hex"),
          keyPath: Wr
        });
      }
    }
    L.fromDataItem = (pi) => {
      const ei = pi.getData(), Vr = ei[le.keyHash], qr = c.CryptoKeypath.fromDataItem(ei[le.keyPath]);
      return new L({
        keyHash: Vr,
        keyPath: qr
      });
    }, L.fromCBOR = (pi) => {
      const ei = F(pi);
      return L.fromDataItem(ei);
    };
    const {
      decodeToDataItem: pe,
      RegistryTypes: $
    } = c.extend;
    var Ee;
    (function(pi) {
      pi[pi.requestId = 1] = "requestId", pi[pi.signData = 2] = "signData", pi[pi.utxos = 3] = "utxos", pi[pi.extraSigners = 4] = "extraSigners", pi[pi.origin = 5] = "origin";
    })(Ee || (Ee = {}));
    class be extends c.RegistryItem {
      constructor(ei) {
        super(), this.getRegistryType = () => p.CARDANO_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getUtxos = () => this.utxos, this.getAdditionalSigners = () => this.extraSigners, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const Vr = {};
          return this.requestId && (Vr[Ee.requestId] = new c.DataItem(this.requestId, $.UUID.getTag())), Vr[Ee.signData] = this.signData, Vr[Ee.utxos] = this.utxos.map((qr) => {
            const Zi = qr.toDataItem();
            return Zi.setTag(qr.getRegistryType().getTag()), Zi;
          }), Vr[Ee.extraSigners] = this.extraSigners.map((qr) => {
            const Zi = qr.toDataItem();
            return Zi.setTag(qr.getRegistryType().getTag()), Zi;
          }), this.origin && (Vr[Ee.origin] = this.origin), new c.DataItem(Vr);
        }, this.requestId = ei.requestId, this.signData = ei.signData, this.utxos = ei.utxos, this.extraSigners = ei.extraSigners, this.origin = ei.origin;
      }
      static constructCardanoSignRequest(ei, Vr, qr, Zi, Wr) {
        const ri = Vr.map((Er) => b.constructCardanoUtxo(Er)), _i = qr.map((Er) => L.constructCardanoCertKey(Er));
        return new be({
          requestId: Zi ? Buffer$f.from(u.parse(Zi)) : void 0,
          signData: ei,
          utxos: ri,
          extraSigners: _i,
          origin: Wr || void 0
        });
      }
    }
    be.fromDataItem = (pi) => {
      const ei = pi.getData(), Vr = ei[Ee.signData], qr = ei[Ee.utxos].map((_i) => b.fromDataItem(_i)), Zi = ei[Ee.extraSigners].map((_i) => L.fromDataItem(_i)), Wr = ei[Ee.requestId] ? ei[Ee.requestId].getData() : void 0, ri = ei[Ee.origin] ? ei[Ee.origin] : void 0;
      return new be({
        requestId: Wr,
        signData: Vr,
        utxos: qr,
        extraSigners: Zi,
        origin: ri
      });
    }, be.fromCBOR = (pi) => {
      const ei = pe(pi);
      return be.fromDataItem(ei);
    };
    const {
      RegistryTypes: He,
      decodeToDataItem: Pe
    } = c.extend;
    var nr;
    (function(pi) {
      pi[pi.requestId = 1] = "requestId", pi[pi.signature = 2] = "signature";
    })(nr || (nr = {}));
    class ir extends c.RegistryItem {
      constructor(ei, Vr) {
        super(), this.getRegistryType = () => p.CARDANO_SIGNATURE, this.getRequestId = () => this.requestId, this.getWitnessSet = () => this.witnessSet, this.toDataItem = () => {
          const qr = {};
          return this.requestId && (qr[nr.requestId] = new c.DataItem(this.requestId, He.UUID.getTag())), qr[nr.signature] = this.witnessSet, new c.DataItem(qr);
        }, this.witnessSet = ei, this.requestId = Vr;
      }
    }
    ir.fromDataItem = (pi) => {
      const ei = pi.getData(), Vr = ei[nr.signature], qr = ei[nr.requestId] ? ei[nr.requestId].getData() : void 0;
      return new ir(Vr, qr);
    }, ir.fromCBOR = (pi) => {
      const ei = Pe(pi);
      return ir.fromDataItem(ei);
    };
    const {
      decodeToDataItem: or,
      RegistryTypes: lr
    } = c.extend;
    var Ir;
    (function(pi) {
      pi[pi.requestId = 1] = "requestId", pi[pi.signData = 2] = "signData", pi[pi.derivationPath = 3] = "derivationPath", pi[pi.origin = 4] = "origin", pi[pi.signType = 5] = "signType", pi[pi.xpub = 6] = "xpub";
    })(Ir || (Ir = {}));
    class xr extends c.RegistryItem {
      constructor(ei) {
        super(), this.getRegistryType = () => p.CARDANO_SIGN_DATA_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDerivationPath = () => this.derivationPath.getPath(), this.getOrigin = () => this.origin, this.getXpub = () => this.xpub, this.toDataItem = () => {
          const Vr = {};
          this.requestId && (Vr[Ir.requestId] = new c.DataItem(this.requestId, lr.UUID.getTag())), this.origin && (Vr[Ir.origin] = this.origin), Vr[Ir.signData] = this.signData;
          const qr = this.derivationPath.toDataItem();
          return qr.setTag(this.derivationPath.getRegistryType().getTag()), Vr[Ir.derivationPath] = qr, Vr[Ir.xpub] = this.xpub, new c.DataItem(Vr);
        }, this.requestId = ei.requestId, this.signData = ei.signData, this.derivationPath = ei.derivationPath, this.origin = ei.origin, this.xpub = ei.xpub;
      }
      static constructCardanoSignDataRequest(ei, Vr, qr, Zi, Wr, ri) {
        const _i = Vr.replace(/[m|M]\//, "").split("/"), Er = new c.CryptoKeypath(_i.map((Di) => {
          const _n = parseInt(Di.replace("'", ""));
          let On = !1;
          return Di.endsWith("'") && (On = !0), new c.PathComponent({
            index: _n,
            hardened: On
          });
        }), Buffer$f.from(qr, "hex"));
        return new xr({
          requestId: Wr ? Buffer$f.from(u.parse(Wr)) : void 0,
          signData: Buffer$f.from(ei, "hex"),
          derivationPath: Er,
          origin: ri || void 0,
          xpub: Buffer$f.from(Zi, "hex")
        });
      }
    }
    xr.fromDataItem = (pi) => {
      const ei = pi.getData(), Vr = ei[Ir.signData], qr = c.CryptoKeypath.fromDataItem(ei[Ir.derivationPath]), Zi = ei[Ir.requestId] ? ei[Ir.requestId].getData() : void 0, Wr = ei[Ir.origin] ? ei[Ir.origin] : void 0, ri = ei[Ir.xpub];
      return new xr({
        requestId: Zi,
        signData: Vr,
        derivationPath: qr,
        origin: Wr,
        xpub: ri
      });
    }, xr.fromCBOR = (pi) => {
      const ei = or(pi);
      return xr.fromDataItem(ei);
    };
    const {
      RegistryTypes: kr,
      decodeToDataItem: Ce
    } = c.extend;
    var tr;
    (function(pi) {
      pi[pi.requestId = 1] = "requestId", pi[pi.signature = 2] = "signature", pi[pi.publicKey = 3] = "publicKey";
    })(tr || (tr = {}));
    class Fe extends c.RegistryItem {
      constructor(ei, Vr, qr) {
        super(), this.getRegistryType = () => p.CARDANO_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.getPublicKey = () => this.publicKey, this.toDataItem = () => {
          const Zi = {};
          return this.requestId && (Zi[tr.requestId] = new c.DataItem(this.requestId, kr.UUID.getTag())), Zi[tr.signature] = this.getSignature(), Zi[tr.publicKey] = this.getPublicKey(), new c.DataItem(Zi);
        }, this.signature = ei, this.publicKey = Vr, this.requestId = qr;
      }
    }
    Fe.fromDataItem = (pi) => {
      const ei = pi.getData(), Vr = ei[tr.signature], qr = ei[tr.publicKey], Zi = ei[tr.requestId] ? ei[tr.requestId].getData() : void 0;
      return new Fe(Vr, qr, Zi);
    }, Fe.fromCBOR = (pi) => {
      const ei = Ce(pi);
      return Fe.fromDataItem(ei);
    };
    const {
      decodeToDataItem: Sr
    } = c.extend;
    var er;
    (function(pi) {
      pi[pi.pubKey = 1] = "pubKey", pi[pi.weight = 2] = "weight";
    })(er || (er = {}));
    class Ie extends c.RegistryItem {
      constructor(ei) {
        super(), this.getRegistryType = () => p.CARDANO_DELEGATION, this.getPubKey = () => this.pubKey, this.getWeight = () => this.weight, this.toDataItem = () => {
          const Vr = {};
          return Vr[er.pubKey] = this.getPubKey(), Vr[er.weight] = this.getWeight(), new c.DataItem(Vr);
        }, this.pubKey = ei.pubKey, this.weight = ei.weight;
      }
      static constructCardanoDelegation({
        pubKey: ei,
        weight: Vr
      }) {
        return new Ie({
          pubKey: ei,
          weight: Vr
        });
      }
    }
    Ie.fromDataItem = (pi) => {
      const ei = pi.getData(), Vr = ei[er.pubKey], qr = ei[er.weight];
      return new Ie({
        pubKey: Vr,
        weight: qr
      });
    }, Ie.fromCBOR = (pi) => {
      const ei = Sr(pi);
      return Ie.fromDataItem(ei);
    };
    const {
      decodeToDataItem: xe,
      RegistryTypes: rr
    } = c.extend;
    var ar;
    (function(pi) {
      pi[pi.requestId = 1] = "requestId", pi[pi.delegations = 2] = "delegations", pi[pi.stakePub = 3] = "stakePub", pi[pi.paymentAddress = 4] = "paymentAddress", pi[pi.nonce = 5] = "nonce", pi[pi.voting_purpose = 6] = "voting_purpose", pi[pi.derivationPath = 7] = "derivationPath", pi[pi.origin = 8] = "origin", pi[pi.signType = 9] = "signType";
    })(ar || (ar = {}));
    const yr = (pi, ei) => {
      const Vr = pi.replace(/[m|M]\//, "").split("/");
      return new c.CryptoKeypath(Vr.map((qr) => {
        const Zi = parseInt(qr.replace("'", ""));
        let Wr = !1;
        return qr.endsWith("'") && (Wr = !0), new c.PathComponent({
          index: Zi,
          hardened: Wr
        });
      }), Buffer$f.from(ei, "hex"));
    };
    class _r extends c.RegistryItem {
      constructor(ei) {
        super(), this.getRegistryType = () => p.CARDANO_CATALYST_VOTING_REGISTRATION, this.getRequestId = () => this.requestId, this.getDelegations = () => this.delegations, this.getStakePub = () => this.stakePub, this.getPaymentAddress = () => this.paymentAddress, this.getNonce = () => this.nonce, this.getVotingPurpose = () => this.voting_purpose, this.getDerivationPath = () => this.derivationPath.getPath(), this.getOrigin = () => this.origin, this.toDataItem = () => {
          const Vr = {};
          this.requestId && (Vr[ar.requestId] = new c.DataItem(this.requestId, rr.UUID.getTag())), Vr[ar.stakePub] = this.stakePub, Vr[ar.paymentAddress] = this.paymentAddress, Vr[ar.nonce] = this.nonce, Vr[ar.voting_purpose] = this.voting_purpose, Vr[ar.delegations] = this.delegations.map((Zi) => {
            const Wr = Zi.toDataItem();
            return Wr.setTag(Zi.getRegistryType().getTag()), Wr;
          }), this.origin && (Vr[ar.origin] = this.origin);
          const qr = this.derivationPath.toDataItem();
          return qr.setTag(this.derivationPath.getRegistryType().getTag()), Vr[ar.derivationPath] = qr, new c.DataItem(Vr);
        }, this.requestId = ei.requestId, this.derivationPath = ei.derivationPath, this.delegations = ei.delegations, this.stakePub = ei.stakePub, this.paymentAddress = ei.paymentAddress, this.nonce = ei.nonce, this.voting_purpose = ei.voting_purpose, this.origin = ei.origin;
      }
      static constructCardanoCatalystRequest(ei, Vr, qr, Zi, Wr, ri, _i, Er, Di) {
        const _n = Er ? Buffer$f.from(u.parse(Er)) : void 0, On = ei.map((so) => Ie.constructCardanoDelegation({
          pubKey: Buffer$f.from(so.pubKey, "hex"),
          weight: so.weight
        }));
        return new _r({
          requestId: _n,
          delegations: On,
          stakePub: Buffer$f.from(Vr, "hex"),
          paymentAddress: Buffer$f.from(qr, "hex"),
          nonce: Zi,
          voting_purpose: Wr,
          derivationPath: yr(ri, _i),
          origin: Di
        });
      }
    }
    _r.fromDataItem = (pi) => {
      const ei = pi.getData(), Vr = ei[ar.delegations].map((_n) => Ie.fromDataItem(_n)), qr = ei[ar.stakePub], Zi = ei[ar.paymentAddress], Wr = ei[ar.nonce], ri = ei[ar.voting_purpose], _i = c.CryptoKeypath.fromDataItem(ei[ar.derivationPath]), Er = ei[ar.requestId] ? ei[ar.requestId].getData() : void 0, Di = ei[ar.origin] ? ei[ar.origin] : void 0;
      return new _r({
        requestId: Er,
        delegations: Vr,
        stakePub: qr,
        paymentAddress: Zi,
        nonce: Wr,
        voting_purpose: ri,
        derivationPath: _i,
        origin: Di
      });
    }, _r.fromCBOR = (pi) => {
      const ei = xe(pi);
      return _r.fromDataItem(ei);
    };
    const {
      RegistryTypes: Or,
      decodeToDataItem: vr
    } = c.extend;
    var Te;
    (function(pi) {
      pi[pi.requestId = 1] = "requestId", pi[pi.signature = 2] = "signature";
    })(Te || (Te = {}));
    class Cr extends c.RegistryItem {
      constructor(ei, Vr) {
        super(), this.getRegistryType = () => p.CARDANO_CATALYST_VOTING_REGISTRATION_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.toDataItem = () => {
          const qr = {};
          return this.requestId && (qr[Te.requestId] = new c.DataItem(this.requestId, Or.UUID.getTag())), qr[Te.signature] = this.getSignature(), new c.DataItem(qr);
        }, this.signature = ei, this.requestId = Vr;
      }
    }
    Cr.fromDataItem = (pi) => {
      const ei = pi.getData(), Vr = ei[Te.signature], qr = ei[Te.requestId] ? ei[Te.requestId].getData() : void 0;
      return new Cr(Vr, qr);
    }, Cr.fromCBOR = (pi) => {
      const ei = vr(pi);
      return Cr.fromDataItem(ei);
    };
    const {
      decodeToDataItem: Hr,
      RegistryTypes: si
    } = c.extend;
    var ui;
    (function(pi) {
      pi[pi.requestId = 1] = "requestId", pi[pi.signData = 2] = "signData", pi[pi.derivationPath = 3] = "derivationPath", pi[pi.origin = 4] = "origin", pi[pi.signType = 5] = "signType", pi[pi.xpub = 6] = "xpub", pi[pi.hashPayload = 7] = "hashPayload", pi[pi.addressBench32 = 8] = "addressBench32", pi[pi.addressFieldType = 9] = "addressFieldType";
    })(ui || (ui = {})), function(pi) {
      pi.ADDRESS = "ADDRESS", pi.KEY_HASH = "KEY_HASH";
    }(n.MessageAddressFieldType || (n.MessageAddressFieldType = {}));
    class Li extends c.RegistryItem {
      constructor(ei) {
        super(), this.getRegistryType = () => p.CARDANO_SIGN_CIP8_DATA_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDerivationPath = () => this.derivationPath.getPath(), this.getOrigin = () => this.origin, this.getXpub = () => this.xpub, this.getHashPayload = () => this.hashPayload, this.getAddressBench32 = () => this.addressBench32, this.getAddressFieldType = () => this.addressFieldType, this.toDataItem = () => {
          const Vr = {};
          this.requestId && (Vr[ui.requestId] = new c.DataItem(this.requestId, si.UUID.getTag())), this.origin && (Vr[ui.origin] = this.origin), Vr[ui.signData] = this.signData;
          const qr = this.derivationPath.toDataItem();
          return qr.setTag(this.derivationPath.getRegistryType().getTag()), Vr[ui.derivationPath] = qr, Vr[ui.xpub] = this.xpub, Vr[ui.hashPayload] = this.hashPayload, this.addressBench32 && (Vr[ui.addressBench32] = this.addressBench32), Vr[ui.addressFieldType] = this.addressFieldType, new c.DataItem(Vr);
        }, this.requestId = ei.requestId, this.signData = ei.signData, this.derivationPath = ei.derivationPath, this.origin = ei.origin, this.xpub = ei.xpub, this.hashPayload = ei.hashPayload, this.addressBench32 = ei.addressBench32, this.addressFieldType = ei.addressFieldType;
      }
      static constructCardanoSignCip8DataRequest(ei, Vr, qr, Zi, Wr, ri, _i, Er, Di) {
        const _n = Vr.replace(/[m|M]\//, "").split("/"), On = new c.CryptoKeypath(_n.map((so) => {
          const Do = parseInt(so.replace("'", ""));
          let gn = !1;
          return so.endsWith("'") && (gn = !0), new c.PathComponent({
            index: Do,
            hardened: gn
          });
        }), Buffer$f.from(qr, "hex"));
        return new Li({
          requestId: Er ? Buffer$f.from(u.parse(Er)) : void 0,
          signData: Buffer$f.from(ei, "hex"),
          derivationPath: On,
          origin: Di || void 0,
          xpub: Buffer$f.from(Zi, "hex"),
          hashPayload: Wr,
          addressBench32: _i || void 0,
          addressFieldType: ri
        });
      }
    }
    Li.fromDataItem = (pi) => {
      const ei = pi.getData(), Vr = ei[ui.signData], qr = c.CryptoKeypath.fromDataItem(ei[ui.derivationPath]), Zi = ei[ui.requestId] ? ei[ui.requestId].getData() : void 0, Wr = ei[ui.origin] ? ei[ui.origin] : void 0, ri = ei[ui.xpub], _i = ei[ui.hashPayload], Er = ei[ui.addressBench32] ? ei[ui.addressBench32] : void 0, Di = ei[ui.addressFieldType];
      return new Li({
        requestId: Zi,
        signData: Vr,
        derivationPath: qr,
        origin: Wr,
        xpub: ri,
        hashPayload: _i,
        addressBench32: Er,
        addressFieldType: Di
      });
    }, Li.fromCBOR = (pi) => {
      const ei = Hr(pi);
      return Li.fromDataItem(ei);
    };
    const {
      RegistryTypes: Qi,
      decodeToDataItem: wi
    } = c.extend;
    var Ji;
    (function(pi) {
      pi[pi.requestId = 1] = "requestId", pi[pi.signature = 2] = "signature", pi[pi.publicKey = 3] = "publicKey", pi[pi.addressField = 4] = "addressField";
    })(Ji || (Ji = {}));
    class mn extends c.RegistryItem {
      constructor(ei, Vr, qr, Zi) {
        super(), this.getRegistryType = () => p.CARDANO_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.getPublicKey = () => this.publicKey, this.getAddressField = () => this.addressField, this.toDataItem = () => {
          const Wr = {};
          return this.requestId && (Wr[Ji.requestId] = new c.DataItem(this.requestId, Qi.UUID.getTag())), Wr[Ji.signature] = this.getSignature(), Wr[Ji.publicKey] = this.getPublicKey(), Wr[Ji.addressField] = this.getAddressField(), new c.DataItem(Wr);
        }, this.signature = ei, this.publicKey = Vr, this.requestId = Zi, this.addressField = qr;
      }
    }
    mn.fromDataItem = (pi) => {
      const ei = pi.getData(), Vr = ei[Ji.signature], qr = ei[Ji.publicKey], Zi = ei[Ji.requestId] ? ei[Ji.requestId].getData() : void 0, Wr = ei[Ji.addressField];
      return new mn(Vr, qr, Wr, Zi);
    }, mn.fromCBOR = (pi) => {
      const ei = wi(pi);
      return mn.fromDataItem(ei);
    }, c.patchTags(Object.values(p).filter((pi) => !!pi.getTag()).map((pi) => pi.getTag())), Object.keys(c).forEach(function(pi) {
      pi !== "default" && Object.defineProperty(n, pi, {
        enumerable: !0,
        get: function() {
          return c[pi];
        }
      });
    }), n.CardanoCatalystRequest = _r, n.CardanoCatalystSignature = Cr, n.CardanoCertKey = L, n.CardanoSignCip8DataRequest = Li, n.CardanoSignCip8DataSignature = mn, n.CardanoSignDataRequest = xr, n.CardanoSignDataSignature = Fe, n.CardanoSignRequest = be, n.CardanoSignature = ir;
  }(bcUrRegistryCardano_cjs_development)), bcUrRegistryCardano_cjs_development;
}
process$1.env.NODE_ENV === "production" ? dist$d.exports = requireBcUrRegistryCardano_cjs_production_min() : dist$d.exports = requireBcUrRegistryCardano_cjs_development();
var distExports$4 = dist$d.exports;
Object.defineProperty(cardano, "__esModule", { value: !0 });
cardano.KeystoneCardanoSDK = void 0;
const bc_ur_registry_cardano_1 = distExports$4, utils_1$e = utils$K, ur_1$4 = ur;
class KeystoneCardanoSDK {
  parseSignature(c) {
    if (c.type !== ur_1$4.URType.CardanoSignature)
      throw new Error("type not match");
    const u = bc_ur_registry_cardano_1.CardanoSignature.fromCBOR(c.cbor), p = u.getRequestId();
    return {
      requestId: Buffer$f.isBuffer(p) ? (0, utils_1$e.uuidStringify)(p) : "",
      witnessSet: (0, utils_1$e.toHex)(u.getWitnessSet())
    };
  }
  parseSignDataSignature(c) {
    if (c.type !== ur_1$4.URType.CardanoSignDataSignature)
      throw new Error("type not match");
    const u = bc_ur_registry_cardano_1.CardanoSignDataSignature.fromCBOR(c.cbor), p = u.getRequestId();
    return {
      requestId: Buffer$f.isBuffer(p) ? (0, utils_1$e.uuidStringify)(p) : "",
      signature: (0, utils_1$e.toHex)(u.getSignature()),
      publicKey: (0, utils_1$e.toHex)(u.getPublicKey())
    };
  }
  parseSignCip8DataSignature(c) {
    if (c.type !== ur_1$4.URType.CardanoSignCip8DataSignature)
      throw new Error("type not match");
    const u = bc_ur_registry_cardano_1.CardanoSignCip8DataSignature.fromCBOR(c.cbor), p = u.getSignature(), a = u.getPublicKey(), A = u.getAddressField();
    return {
      requestId: "",
      signature: (0, utils_1$e.toHex)(p),
      publicKey: (0, utils_1$e.toHex)(a),
      addressField: (0, utils_1$e.toHex)(A)
    };
  }
  parseCatalystSignature(c) {
    if (c.type !== ur_1$4.URType.CardanoCatalystSignature)
      throw new Error("type not match");
    const u = bc_ur_registry_cardano_1.CardanoCatalystSignature.fromCBOR(c.cbor), p = u.getRequestId();
    return {
      requestId: Buffer$f.isBuffer(p) ? (0, utils_1$e.uuidStringify)(p) : "",
      signature: (0, utils_1$e.toHex)(u.getSignature())
    };
  }
  generateSignDataRequest({ requestId: c, payload: u, sigStructure: p, path: a, xpub: A, pubKey: b, xfp: F, origin: le }) {
    return bc_ur_registry_cardano_1.CardanoSignDataRequest.constructCardanoSignDataRequest(p ?? u, a, F, b ?? A, c, le).toUR();
  }
  generateSignCip8DataRequest(c) {
    return bc_ur_registry_cardano_1.CardanoSignCip8DataRequest.constructCardanoSignCip8DataRequest(c.messageHex, c.path, c.xfp, c.xpub, c.hashPayload, c.addressFieldType, "address" in c ? c.address : void 0, c.requestId, c.origin).toUR();
  }
  generateCatalystRequest(c) {
    return bc_ur_registry_cardano_1.CardanoCatalystRequest.constructCardanoCatalystRequest(c.delegations, c.stakePub, c.paymentAddress, c.nonce, c.voting_purpose, c.path, c.xfp, c.requestId, c.origin).toUR();
  }
  generateSignRequest({ signData: c, utxos: u, extraSigners: p, requestId: a, origin: A }) {
    return bc_ur_registry_cardano_1.CardanoSignRequest.constructCardanoSignRequest(c, u, p, a, A).toUR();
  }
}
cardano.KeystoneCardanoSDK = KeystoneCardanoSDK;
var arweave = {}, dist$b = { exports: {} }, bcUrRegistryArweave_cjs_production_min = {}, dist$a = {}, patchCBOR$3 = {}, utils$8 = {}, lib$5 = {}, cborSync$3 = { exports: {} }, DataItem$3 = {}, hasRequiredDataItem$3;
function requireDataItem$3() {
  if (hasRequiredDataItem$3) return DataItem$3;
  hasRequiredDataItem$3 = 1, Object.defineProperty(DataItem$3, "__esModule", { value: !0 }), DataItem$3.DataItem = void 0;
  class n {
    constructor(u, p) {
      this.setTag = (a) => {
        this.tag = a;
      }, this.clearTag = () => {
        this.tag = void 0;
      }, this.getTag = () => this.tag, this.getData = () => this.data, this.data = u, this.tag = p;
    }
  }
  return DataItem$3.DataItem = n, DataItem$3;
}
var hasRequiredCborSync$3;
function requireCborSync$3() {
  return hasRequiredCborSync$3 || (hasRequiredCborSync$3 = 1, function(n) {
    (function(c, u) {
      n.exports ? n.exports = u() : c.CBOR = u();
    })(commonjsGlobal, function() {
      const { DataItem: c } = requireDataItem$3();
      var u = function() {
        function p(Ce) {
          this.$hex = Ce;
        }
        p.prototype = {
          length: function() {
            return this.$hex.length / 2;
          },
          toString: function(Ce) {
            if (!Ce || Ce === "hex" || Ce === 16)
              return this.$hex;
            if (Ce === "utf-8") {
              for (var tr = "", Fe = 0; Fe < this.$hex.length; Fe += 2)
                tr += "%" + this.$hex.substring(Fe, Fe + 2);
              return decodeURIComponent(tr);
            }
            if (Ce === "latin") {
              for (var tr = [], Fe = 0; Fe < this.$hex.length; Fe += 2)
                tr.push(parseInt(this.$hex.substring(Fe, Fe + 2), 16));
              return String.fromCharCode.apply(String, tr);
            }
            throw new Error("Unrecognised format: " + Ce);
          }
        }, p.fromLatinString = function(Ce) {
          for (var tr = "", Fe = 0; Fe < Ce.length; Fe++) {
            var Sr = Ce.charCodeAt(Fe).toString(16);
            Sr.length === 1 && (Sr = "0" + Sr), tr += Sr;
          }
          return new p(tr);
        }, p.fromUtf8String = function(Ce) {
          for (var tr = encodeURIComponent(Ce), Fe = "", Sr = 0; Sr < tr.length; Sr++)
            if (tr.charAt(Sr) === "%")
              Fe += tr.substring(Sr + 1, Sr + 3), Sr += 2;
            else {
              var er = tr.charCodeAt(Sr).toString(16);
              er.length < 2 && (er = "0" + er), Fe += er;
            }
          return new p(Fe);
        };
        var a = [], A = {}, b = function(Ce) {
          return function() {
            throw new Error(Ce + " not implemented");
          };
        };
        function F() {
        }
        F.prototype = {
          peekByte: b("peekByte"),
          readByte: b("readByte"),
          readChunk: b("readChunk"),
          readFloat16: function() {
            var Ce = this.readUint16(), tr = (Ce & 32767) >> 10, Fe = Ce & 1023, Sr = Ce & 32768;
            if (tr === 31)
              return Fe === 0 ? Sr ? -1 / 0 : 1 / 0 : NaN;
            var er = tr ? Math.pow(2, tr - 25) * (1024 + Fe) : Math.pow(2, -24) * Fe;
            return Sr ? -er : er;
          },
          readFloat32: function() {
            var Ce = this.readUint32(), tr = (Ce & 2147483647) >> 23, Fe = Ce & 8388607, Sr = Ce & 2147483648;
            if (tr === 255)
              return Fe === 0 ? Sr ? -1 / 0 : 1 / 0 : NaN;
            var er = tr ? Math.pow(2, tr - 23 - 127) * (8388608 + Fe) : Math.pow(2, -149) * Fe;
            return Sr ? -er : er;
          },
          readFloat64: function() {
            var Ce = this.readUint32(), tr = this.readUint32(), Fe = Ce >> 20 & 2047, Sr = (Ce & 1048575) * 4294967296 + tr, er = Ce & 2147483648;
            if (Fe === 2047)
              return Sr === 0 ? er ? -1 / 0 : 1 / 0 : NaN;
            var Ie = Fe ? Math.pow(2, Fe - 52 - 1023) * (4503599627370496 + Sr) : Math.pow(2, -1074) * Sr;
            return er ? -Ie : Ie;
          },
          readUint16: function() {
            return this.readByte() * 256 + this.readByte();
          },
          readUint32: function() {
            return this.readUint16() * 65536 + this.readUint16();
          },
          readUint64: function() {
            return this.readUint32() * 4294967296 + this.readUint32();
          }
        };
        function le() {
        }
        le.prototype = {
          writeByte: b("writeByte"),
          result: b("result"),
          writeFloat16: b("writeFloat16"),
          writeFloat32: b("writeFloat32"),
          writeFloat64: b("writeFloat64"),
          writeUint16: function(Ce) {
            this.writeByte(Ce >> 8 & 255), this.writeByte(Ce & 255);
          },
          writeUint32: function(Ce) {
            this.writeUint16(Ce >> 16 & 65535), this.writeUint16(Ce & 65535);
          },
          writeUint64: function(Ce) {
            if (Ce >= 9007199254740992 || Ce <= -9007199254740992)
              throw new Error("Cannot encode Uint64 of: " + Ce + " magnitude to big (floating point errors)");
            this.writeUint32(Math.floor(Ce / 4294967296)), this.writeUint32(Ce % 4294967296);
          },
          writeString: b("writeString"),
          canWriteBinary: function(Ce) {
            return !1;
          },
          writeBinary: b("writeChunk")
        };
        function L(Ce) {
          var tr = Ce.readByte(), Fe = tr >> 5, Sr = tr & 31;
          return { type: Fe, value: Sr };
        }
        function pe(Ce, tr) {
          var Fe = Ce.value;
          if (Fe < 24)
            return Fe;
          if (Fe == 24)
            return tr.readByte();
          if (Fe == 25)
            return tr.readUint16();
          if (Fe == 26)
            return tr.readUint32();
          if (Fe == 27)
            return tr.readUint64();
          if (Fe == 31)
            return null;
          b("Additional info: " + Fe)();
        }
        function $(Ce, tr, Fe) {
          Fe.writeByte(Ce << 5 | tr);
        }
        function Ee(Ce, tr, Fe) {
          var Sr = Ce << 5;
          tr < 24 ? Fe.writeByte(Sr | tr) : tr < 256 ? (Fe.writeByte(Sr | 24), Fe.writeByte(tr)) : tr < 65536 ? (Fe.writeByte(Sr | 25), Fe.writeUint16(tr)) : tr < 4294967296 ? (Fe.writeByte(Sr | 26), Fe.writeUint32(tr)) : (Fe.writeByte(Sr | 27), Fe.writeUint64(tr));
        }
        var be = new Error();
        function He(Ce) {
          var tr = L(Ce);
          switch (tr.type) {
            case 0:
              return pe(tr, Ce);
            case 1:
              return -1 - pe(tr, Ce);
            case 2:
              return Ce.readChunk(pe(tr, Ce));
            case 3:
              var Fe = Ce.readChunk(pe(tr, Ce));
              return Fe.toString("utf-8");
            case 4:
            case 5:
              var Sr = pe(tr, Ce), yr = [];
              if (Sr !== null) {
                tr.type === 5 && (Sr *= 2);
                for (var er = 0; er < Sr; er++)
                  yr[er] = He(Ce);
              } else
                for (var Ie; (Ie = He(Ce)) !== be; )
                  yr.push(Ie);
              if (tr.type === 5) {
                for (var xe = {}, er = 0; er < yr.length; er += 2)
                  xe[yr[er]] = yr[er + 1];
                return xe;
              } else
                return yr;
            case 6:
              var rr = pe(tr, Ce), ar = A[rr], yr = He(Ce);
              return ar ? ar(yr) : yr;
            case 7:
              if (tr.value === 25)
                return Ce.readFloat16();
              if (tr.value === 26)
                return Ce.readFloat32();
              if (tr.value === 27)
                return Ce.readFloat64();
              switch (pe(tr, Ce)) {
                case 20:
                  return !1;
                case 21:
                  return !0;
                case 22:
                  return null;
                case 23:
                  return;
                case null:
                  return be;
                default:
                  throw new Error("Unknown fixed value: " + tr.value);
              }
            default:
              throw new Error("Unsupported header: " + JSON.stringify(tr));
          }
          throw new Error("not implemented yet");
        }
        function Pe(Ce, tr) {
          for (var Fe = 0; Fe < a.length; Fe++) {
            var Sr = a[Fe].fn(Ce);
            if (Sr !== void 0)
              return Ee(6, a[Fe].tag, tr), Pe(Sr, tr);
          }
          if (Ce && typeof Ce.toCBOR == "function" && (Ce = Ce.toCBOR()), Ce === !1)
            Ee(7, 20, tr);
          else if (Ce === !0)
            Ee(7, 21, tr);
          else if (Ce === null)
            Ee(7, 22, tr);
          else if (Ce === void 0)
            Ee(7, 23, tr);
          else if (typeof Ce == "number")
            Math.floor(Ce) === Ce && Ce < 9007199254740992 && Ce > -9007199254740992 ? Ce < 0 ? Ee(1, -1 - Ce, tr) : Ee(0, Ce, tr) : ($(7, 27, tr), tr.writeFloat64(Ce));
          else if (typeof Ce == "string")
            tr.writeString(Ce, function(Ie) {
              Ee(3, Ie, tr);
            });
          else if (tr.canWriteBinary(Ce))
            tr.writeBinary(Ce, function(Ie) {
              Ee(2, Ie, tr);
            });
          else if (typeof Ce == "object")
            if (or.config.useToJSON && typeof Ce.toJSON == "function" && (Ce = Ce.toJSON()), Array.isArray(Ce)) {
              Ee(4, Ce.length, tr);
              for (var Fe = 0; Fe < Ce.length; Fe++)
                Pe(Ce[Fe], tr);
            } else {
              var er = Object.keys(Ce);
              Ee(5, er.length, tr);
              for (var Fe = 0; Fe < er.length; Fe++) {
                const xe = parseInt(er[Fe]);
                isNaN(xe) ? (Pe(er[Fe], tr), Pe(Ce[er[Fe]], tr)) : (Pe(xe, tr), Pe(Ce[er[Fe]], tr));
              }
            }
          else
            throw new Error("CBOR encoding not supported: " + Ce);
        }
        var nr = [], ir = [], or = {
          config: {
            useToJSON: !0
          },
          addWriter: function(Ce, tr) {
            typeof Ce == "string" ? ir.push(function(Fe) {
              if (Ce === Fe)
                return tr(Fe);
            }) : ir.push(Ce);
          },
          addReader: function(Ce, tr) {
            typeof Ce == "string" ? nr.push(function(Fe, Sr) {
              if (Ce === Sr)
                return tr(Fe, Sr);
            }) : nr.push(Ce);
          },
          encode: function(Ce, tr) {
            for (var Fe = 0; Fe < ir.length; Fe++) {
              var Sr = ir[Fe], er = Sr(tr);
              if (er)
                return Pe(Ce, er), er.result();
            }
            throw new Error("Unsupported output format: " + tr);
          },
          encodeDataItem: function(Ce, tr) {
            for (var Fe = 0; Fe < ir.length; Fe++) {
              var Sr = ir[Fe], er = Sr(tr);
              if (er)
                return Ce.getTag() !== void 0 ? (Pe(Ce, er), er.result()) : (Pe(Ce.getData(), er), er.result());
            }
            throw new Error("Unsupported output format: " + tr);
          },
          decode: function(Ce, tr) {
            for (var Fe = 0; Fe < nr.length; Fe++) {
              var Sr = nr[Fe], er = Sr(Ce, tr);
              if (er)
                return He(er);
            }
            throw new Error("Unsupported input format: " + tr);
          },
          decodeToDataItem: function(Ce, tr) {
            for (var Fe = 0; Fe < nr.length; Fe++) {
              var Sr = nr[Fe], er = Sr(Ce, tr);
              if (er) {
                const Ie = He(er);
                return Ie instanceof c ? Ie : new c(Ie);
              }
            }
            throw new Error("Unsupported input format: " + tr);
          },
          addSemanticEncode: function(Ce, tr) {
            if (typeof Ce != "number" || Ce % 1 !== 0 || Ce < 0)
              throw new Error("Tag must be a positive integer");
            return a.push({ tag: Ce, fn: tr }), this;
          },
          addSemanticDecode: function(Ce, tr) {
            if (typeof Ce != "number" || Ce % 1 !== 0 || Ce < 0)
              throw new Error("Tag must be a positive integer");
            return A[Ce] = tr, this;
          }
        };
        function lr(Ce) {
          this.buffer = Ce, this.pos = 0;
        }
        lr.prototype = Object.create(F.prototype), lr.prototype.peekByte = function() {
          return this.buffer[this.pos];
        }, lr.prototype.readByte = function() {
          return this.buffer[this.pos++];
        }, lr.prototype.readUint16 = function() {
          var Ce = this.buffer.readUInt16BE(this.pos);
          return this.pos += 2, Ce;
        }, lr.prototype.readUint32 = function() {
          var Ce = this.buffer.readUInt32BE(this.pos);
          return this.pos += 4, Ce;
        }, lr.prototype.readFloat32 = function() {
          var Ce = this.buffer.readFloatBE(this.pos);
          return this.pos += 4, Ce;
        }, lr.prototype.readFloat64 = function() {
          var Ce = this.buffer.readDoubleBE(this.pos);
          return this.pos += 8, Ce;
        }, lr.prototype.readChunk = function(Ce) {
          var tr = Buffer$f.alloc(Ce);
          return this.buffer.copy(tr, 0, this.pos, this.pos += Ce), tr;
        };
        function Ir(Ce) {
          this.byteLength = 0, this.defaultBufferLength = 16384, this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0, this.completeBuffers = [], this.stringFormat = Ce;
        }
        Ir.prototype = Object.create(le.prototype), Ir.prototype.writeByte = function(Ce) {
          this.latestBuffer[this.latestBufferOffset++] = Ce, this.latestBufferOffset >= this.latestBuffer.length && (this.completeBuffers.push(this.latestBuffer), this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0), this.byteLength++;
        }, Ir.prototype.writeFloat32 = function(Ce) {
          var tr = Buffer$f.alloc(4);
          tr.writeFloatBE(Ce, 0), this.writeBuffer(tr);
        }, Ir.prototype.writeFloat64 = function(Ce) {
          var tr = Buffer$f.alloc(8);
          tr.writeDoubleBE(Ce, 0), this.writeBuffer(tr);
        }, Ir.prototype.writeString = function(Ce, tr) {
          var Fe = Buffer$f.from(Ce, "utf-8");
          tr(Fe.length), this.writeBuffer(Fe);
        }, Ir.prototype.canWriteBinary = function(Ce) {
          return Ce instanceof Buffer$f;
        }, Ir.prototype.writeBinary = function(Ce, tr) {
          tr(Ce.length), this.writeBuffer(Ce);
        }, Ir.prototype.writeBuffer = function(Ce) {
          if (!(Ce instanceof Buffer$f))
            throw new TypeError("BufferWriter only accepts Buffers");
          this.latestBufferOffset ? this.latestBuffer.length - this.latestBufferOffset >= Ce.length ? (Ce.copy(this.latestBuffer, this.latestBufferOffset), this.latestBufferOffset += Ce.length, this.latestBufferOffset >= this.latestBuffer.length && (this.completeBuffers.push(this.latestBuffer), this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0)) : (this.completeBuffers.push(this.latestBuffer.slice(0, this.latestBufferOffset)), this.completeBuffers.push(Ce), this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0) : this.completeBuffers.push(Ce), this.byteLength += Ce.length;
        }, Ir.prototype.result = function() {
          for (var Ce = Buffer$f.alloc(this.byteLength), tr = 0, Fe = 0; Fe < this.completeBuffers.length; Fe++) {
            var Sr = this.completeBuffers[Fe];
            Sr.copy(Ce, tr, 0, Sr.length), tr += Sr.length;
          }
          return this.latestBufferOffset && this.latestBuffer.copy(Ce, tr, 0, this.latestBufferOffset), this.stringFormat ? Ce.toString(this.stringFormat) : Ce;
        }, typeof Buffer$f == "function" && (or.addReader(function(Ce, tr) {
          if (Buffer$f.isBuffer(Ce))
            return new lr(Ce);
          if (tr === "hex" || tr === "base64") {
            var Fe = Buffer$f.from(Ce, tr);
            return new lr(Fe);
          }
        }), or.addWriter(function(Ce) {
          if (!Ce || Ce === "buffer")
            return new Ir();
          if (Ce === "hex" || Ce === "base64")
            return new Ir(Ce);
        }));
        function xr(Ce) {
          this.hex = Ce, this.pos = 0;
        }
        xr.prototype = Object.create(F.prototype), xr.prototype.peekByte = function() {
          var Ce = this.hex.substring(this.pos, 2);
          return parseInt(Ce, 16);
        }, xr.prototype.readByte = function() {
          var Ce = this.hex.substring(this.pos, this.pos + 2);
          return this.pos += 2, parseInt(Ce, 16);
        }, xr.prototype.readChunk = function(Ce) {
          var tr = this.hex.substring(this.pos, this.pos + Ce * 2);
          return this.pos += Ce * 2, typeof Buffer$f == "function" ? Buffer$f.from(tr, "hex") : new p(tr);
        };
        function kr(Ce) {
          this.$hex = "", this.finalFormat = Ce || "hex";
        }
        return kr.prototype = Object.create(le.prototype), kr.prototype.writeByte = function(Ce) {
          if (Ce < 0 || Ce > 255)
            throw new Error("Byte value out of range: " + Ce);
          var tr = Ce.toString(16);
          tr.length == 1 && (tr = "0" + tr), this.$hex += tr;
        }, kr.prototype.canWriteBinary = function(Ce) {
          return Ce instanceof p || typeof Buffer$f == "function" && Ce instanceof Buffer$f;
        }, kr.prototype.writeBinary = function(Ce, tr) {
          if (Ce instanceof p)
            tr(Ce.length()), this.$hex += Ce.$hex;
          else if (typeof Buffer$f == "function" && Ce instanceof Buffer$f)
            tr(Ce.length), this.$hex += Ce.toString("hex");
          else
            throw new TypeError("HexWriter only accepts BinaryHex or Buffers");
        }, kr.prototype.result = function() {
          return this.finalFormat === "buffer" && typeof Buffer$f == "function" ? Buffer$f.from(this.$hex, "hex") : new p(this.$hex).toString(this.finalFormat);
        }, kr.prototype.writeString = function(Ce, tr) {
          var Fe = p.fromUtf8String(Ce);
          tr(Fe.length()), this.$hex += Fe.$hex;
        }, or.addReader(function(Ce, tr) {
          if (Ce instanceof p || Ce.$hex)
            return new xr(Ce.$hex);
          if (tr === "hex")
            return new xr(Ce);
        }), or.addWriter(function(Ce) {
          if (Ce === "hex")
            return new kr();
        }), or;
      }();
      return u.addSemanticEncode(0, function(p) {
        if (p instanceof Date)
          return p.toISOString();
      }).addSemanticDecode(0, function(p) {
        return new Date(p);
      }).addSemanticDecode(1, function(p) {
        return new Date(p);
      }), u;
    });
  }(cborSync$3)), cborSync$3.exports;
}
var hasRequiredLib$3;
function requireLib$3() {
  return hasRequiredLib$3 || (hasRequiredLib$3 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.DataItem = n.addWriter = n.addReader = n.addSemanticEncode = n.addSemanticDecode = n.decodeToDataItem = n.encodeDataItem = void 0;
    var c = requireCborSync$3();
    Object.defineProperty(n, "encodeDataItem", { enumerable: !0, get: function() {
      return c.encodeDataItem;
    } }), Object.defineProperty(n, "decodeToDataItem", { enumerable: !0, get: function() {
      return c.decodeToDataItem;
    } }), Object.defineProperty(n, "addSemanticDecode", { enumerable: !0, get: function() {
      return c.addSemanticDecode;
    } }), Object.defineProperty(n, "addSemanticEncode", { enumerable: !0, get: function() {
      return c.addSemanticEncode;
    } }), Object.defineProperty(n, "addReader", { enumerable: !0, get: function() {
      return c.addReader;
    } }), Object.defineProperty(n, "addWriter", { enumerable: !0, get: function() {
      return c.addWriter;
    } });
    var u = requireDataItem$3();
    Object.defineProperty(n, "DataItem", { enumerable: !0, get: function() {
      return u.DataItem;
    } });
  }(lib$5)), lib$5;
}
var hasRequiredUtils$3;
function requireUtils$3() {
  if (hasRequiredUtils$3) return utils$8;
  hasRequiredUtils$3 = 1, Object.defineProperty(utils$8, "__esModule", { value: !0 }), utils$8.patchTags = void 0;
  const n = requireLib$3(), c = [], u = (p) => {
    p.forEach((a) => {
      c.find((A) => A === a) || ((0, n.addSemanticEncode)(a, (A) => {
        if (A instanceof n.DataItem && A.getTag() === a)
          return A.getData();
      }), (0, n.addSemanticDecode)(a, (A) => new n.DataItem(A, a)), c.push(a));
    });
  };
  return utils$8.patchTags = u, utils$8;
}
var RegistryType$3 = {}, hasRequiredRegistryType$3;
function requireRegistryType$3() {
  if (hasRequiredRegistryType$3) return RegistryType$3;
  hasRequiredRegistryType$3 = 1, Object.defineProperty(RegistryType$3, "__esModule", { value: !0 }), RegistryType$3.RegistryTypes = RegistryType$3.RegistryType = void 0;
  class n {
    constructor(u, p) {
      this.type = u, this.tag = p, this.getTag = () => this.tag, this.getType = () => this.type;
    }
  }
  return RegistryType$3.RegistryType = n, RegistryType$3.RegistryTypes = {
    UUID: new n("uuid", 37),
    BYTES: new n("bytes", void 0),
    CRYPTO_HDKEY: new n("crypto-hdkey", 303),
    CRYPTO_KEYPATH: new n("crypto-keypath", 304),
    CRYPTO_COIN_INFO: new n("crypto-coin-info", 305),
    CRYPTO_ECKEY: new n("crypto-eckey", 306),
    CRYPTO_OUTPUT: new n("crypto-output", 308),
    CRYPTO_PSBT: new n("crypto-psbt", 310),
    CRYPTO_ACCOUNT: new n("crypto-account", 311),
    CRYPTO_MULTI_ACCOUNTS: new n("crypto-multi-accounts", 1103),
    QR_HARDWARE_CALL: new n("qr-hardware-call", 1201),
    KEY_DERIVATION_CALL: new n("key-derivation-call", 1301),
    KEY_DERIVATION_SCHEMA: new n("key-derivation-schema", 1302)
  }, RegistryType$3;
}
var ScriptExpression$3 = {}, hasRequiredScriptExpression$3;
function requireScriptExpression$3() {
  return hasRequiredScriptExpression$3 || (hasRequiredScriptExpression$3 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.ScriptExpressions = n.ScriptExpression = void 0;
    class c {
      constructor(p, a) {
        this.tag = p, this.expression = a, this.getTag = () => this.tag, this.getExpression = () => this.expression;
      }
    }
    n.ScriptExpression = c, c.fromTag = (u) => Object.values(n.ScriptExpressions).find((a) => a.getTag() === u), n.ScriptExpressions = {
      SCRIPT_HASH: new c(400, "sh"),
      WITNESS_SCRIPT_HASH: new c(401, "wsh"),
      PUBLIC_KEY: new c(402, "pk"),
      PUBLIC_KEY_HASH: new c(403, "pkh"),
      WITNESS_PUBLIC_KEY_HASH: new c(404, "wpkh"),
      COMBO: new c(405, "combo"),
      MULTISIG: new c(406, "multi"),
      SORTED_MULTISIG: new c(407, "sortedmulti"),
      ADDRESS: new c(307, "addr"),
      RAW_SCRIPT: new c(408, "raw")
    };
  }(ScriptExpression$3)), ScriptExpression$3;
}
var hasRequiredPatchCBOR$3;
function requirePatchCBOR$3() {
  if (hasRequiredPatchCBOR$3) return patchCBOR$3;
  hasRequiredPatchCBOR$3 = 1, Object.defineProperty(patchCBOR$3, "__esModule", { value: !0 });
  const n = requireUtils$3(), c = requireRegistryType$3(), u = requireScriptExpression$3(), p = Object.values(c.RegistryTypes).filter((A) => !!A.getTag()).map((A) => A.getTag()), a = Object.values(u.ScriptExpressions).map((A) => A.getTag());
  return (0, n.patchTags)(p.concat(a)), patchCBOR$3;
}
var CryptoHDKey$3 = {}, src$7, hasRequiredSrc$3;
function requireSrc$3() {
  if (hasRequiredSrc$3) return src$7;
  hasRequiredSrc$3 = 1;
  var n = safeBufferExports.Buffer;
  function c(u) {
    if (u.length >= 255)
      throw new TypeError("Alphabet too long");
    for (var p = new Uint8Array(256), a = 0; a < p.length; a++)
      p[a] = 255;
    for (var A = 0; A < u.length; A++) {
      var b = u.charAt(A), F = b.charCodeAt(0);
      if (p[F] !== 255)
        throw new TypeError(b + " is ambiguous");
      p[F] = A;
    }
    var le = u.length, L = u.charAt(0), pe = Math.log(le) / Math.log(256), $ = Math.log(256) / Math.log(le);
    function Ee(Pe) {
      if ((Array.isArray(Pe) || Pe instanceof Uint8Array) && (Pe = n.from(Pe)), !n.isBuffer(Pe))
        throw new TypeError("Expected Buffer");
      if (Pe.length === 0)
        return "";
      for (var nr = 0, ir = 0, or = 0, lr = Pe.length; or !== lr && Pe[or] === 0; )
        or++, nr++;
      for (var Ir = (lr - or) * $ + 1 >>> 0, xr = new Uint8Array(Ir); or !== lr; ) {
        for (var kr = Pe[or], Ce = 0, tr = Ir - 1; (kr !== 0 || Ce < ir) && tr !== -1; tr--, Ce++)
          kr += 256 * xr[tr] >>> 0, xr[tr] = kr % le >>> 0, kr = kr / le >>> 0;
        if (kr !== 0)
          throw new Error("Non-zero carry");
        ir = Ce, or++;
      }
      for (var Fe = Ir - ir; Fe !== Ir && xr[Fe] === 0; )
        Fe++;
      for (var Sr = L.repeat(nr); Fe < Ir; ++Fe)
        Sr += u.charAt(xr[Fe]);
      return Sr;
    }
    function be(Pe) {
      if (typeof Pe != "string")
        throw new TypeError("Expected String");
      if (Pe.length === 0)
        return n.alloc(0);
      for (var nr = 0, ir = 0, or = 0; Pe[nr] === L; )
        ir++, nr++;
      for (var lr = (Pe.length - nr) * pe + 1 >>> 0, Ir = new Uint8Array(lr); nr < Pe.length; ) {
        var xr = Pe.charCodeAt(nr);
        if (xr > 255)
          return;
        var kr = p[xr];
        if (kr === 255)
          return;
        for (var Ce = 0, tr = lr - 1; (kr !== 0 || Ce < or) && tr !== -1; tr--, Ce++)
          kr += le * Ir[tr] >>> 0, Ir[tr] = kr % 256 >>> 0, kr = kr / 256 >>> 0;
        if (kr !== 0)
          throw new Error("Non-zero carry");
        or = Ce, nr++;
      }
      for (var Fe = lr - or; Fe !== lr && Ir[Fe] === 0; )
        Fe++;
      var Sr = n.allocUnsafe(ir + (lr - Fe));
      Sr.fill(0, 0, ir);
      for (var er = ir; Fe !== lr; )
        Sr[er++] = Ir[Fe++];
      return Sr;
    }
    function He(Pe) {
      var nr = be(Pe);
      if (nr)
        return nr;
      throw new Error("Non-base" + le + " character");
    }
    return {
      encode: Ee,
      decodeUnsafe: be,
      decode: He
    };
  }
  return src$7 = c, src$7;
}
var bs58$4, hasRequiredBs58$3;
function requireBs58$3() {
  if (hasRequiredBs58$3) return bs58$4;
  hasRequiredBs58$3 = 1;
  var n = requireSrc$3(), c = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
  return bs58$4 = n(c), bs58$4;
}
var base$6, hasRequiredBase$3;
function requireBase$3() {
  if (hasRequiredBase$3) return base$6;
  hasRequiredBase$3 = 1;
  var n = requireBs58$3(), c = safeBufferExports.Buffer;
  return base$6 = function(u) {
    function p(F) {
      var le = u(F);
      return n.encode(c.concat([
        F,
        le
      ], F.length + 4));
    }
    function a(F) {
      var le = F.slice(0, -4), L = F.slice(-4), pe = u(le);
      if (!(L[0] ^ pe[0] | L[1] ^ pe[1] | L[2] ^ pe[2] | L[3] ^ pe[3]))
        return le;
    }
    function A(F) {
      var le = n.decodeUnsafe(F);
      if (le)
        return a(le);
    }
    function b(F) {
      var le = n.decode(F), L = a(le);
      if (!L) throw new Error("Invalid checksum");
      return L;
    }
    return {
      encode: p,
      decode: b,
      decodeUnsafe: A
    };
  }, base$6;
}
var bs58check$6, hasRequiredBs58check$3;
function requireBs58check$3() {
  if (hasRequiredBs58check$3) return bs58check$6;
  hasRequiredBs58check$3 = 1;
  var n = browser$a, c = requireBase$3();
  function u(p) {
    var a = n("sha256").update(p).digest();
    return n("sha256").update(a).digest();
  }
  return bs58check$6 = c(u), bs58check$6;
}
var CryptoCoinInfo$3 = {}, RegistryItem$3 = {}, hasRequiredRegistryItem$3;
function requireRegistryItem$3() {
  if (hasRequiredRegistryItem$3) return RegistryItem$3;
  hasRequiredRegistryItem$3 = 1, Object.defineProperty(RegistryItem$3, "__esModule", { value: !0 }), RegistryItem$3.RegistryItem = void 0;
  const n = dist$t, c = requireLib$3();
  class u {
    constructor() {
      this.toCBOR = () => {
        if (this.toDataItem() === void 0)
          throw new Error(`#[ur-registry][RegistryItem][fn.toCBOR]: registry ${this.getRegistryType()}'s method toDataItem returns undefined`);
        return (0, c.encodeDataItem)(this.toDataItem());
      }, this.toUR = () => new n.UR(this.toCBOR(), this.getRegistryType().getType()), this.toUREncoder = (a, A, b) => {
        const F = this.toUR();
        return new n.UREncoder(F, a, A, b);
      };
    }
  }
  return RegistryItem$3.RegistryItem = u, RegistryItem$3;
}
var hasRequiredCryptoCoinInfo$3;
function requireCryptoCoinInfo$3() {
  return hasRequiredCryptoCoinInfo$3 || (hasRequiredCryptoCoinInfo$3 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.CryptoCoinInfo = n.Network = n.Type = void 0;
    const c = requireLib$3(), u = requireRegistryItem$3(), p = requireRegistryType$3();
    var a;
    (function(le) {
      le.type = "1", le.network = "2";
    })(a || (a = {}));
    var A;
    (function(le) {
      le[le.bitcoin = 0] = "bitcoin";
    })(A = n.Type || (n.Type = {}));
    var b;
    (function(le) {
      le[le.mainnet = 0] = "mainnet", le[le.testnet = 1] = "testnet";
    })(b = n.Network || (n.Network = {}));
    class F extends u.RegistryItem {
      constructor(L, pe) {
        super(), this.type = L, this.network = pe, this.getRegistryType = () => p.RegistryTypes.CRYPTO_COIN_INFO, this.getType = () => this.type || A.bitcoin, this.getNetwork = () => this.network || b.mainnet, this.toDataItem = () => {
          const $ = {};
          return this.type && ($[a.type] = this.type), this.network && ($[a.network] = this.network), new c.DataItem($);
        };
      }
    }
    n.CryptoCoinInfo = F, F.fromDataItem = (le) => {
      const L = le.getData(), pe = L[a.type], $ = L[a.network];
      return new F(pe, $);
    }, F.fromCBOR = (le) => {
      const L = (0, c.decodeToDataItem)(le);
      return F.fromDataItem(L);
    };
  }(CryptoCoinInfo$3)), CryptoCoinInfo$3;
}
var CryptoKeypath$3 = {}, PathComponent$3 = {}, hasRequiredPathComponent$3;
function requirePathComponent$3() {
  if (hasRequiredPathComponent$3) return PathComponent$3;
  hasRequiredPathComponent$3 = 1, Object.defineProperty(PathComponent$3, "__esModule", { value: !0 }), PathComponent$3.PathComponent = void 0;
  class n {
    constructor(u) {
      if (this.getIndex = () => this.index, this.isWildcard = () => this.wildcard, this.isHardened = () => this.hardened, this.index = u.index, this.hardened = u.hardened, this.index !== void 0 ? this.wildcard = !1 : this.wildcard = !0, this.index && this.index & n.HARDENED_BIT)
        throw new Error(`#[ur-registry][PathComponent][fn.constructor]: Invalid index ${this.index} - most significant bit cannot be set`);
    }
  }
  return PathComponent$3.PathComponent = n, n.HARDENED_BIT = 2147483648, PathComponent$3;
}
var hasRequiredCryptoKeypath$3;
function requireCryptoKeypath$3() {
  if (hasRequiredCryptoKeypath$3) return CryptoKeypath$3;
  hasRequiredCryptoKeypath$3 = 1, Object.defineProperty(CryptoKeypath$3, "__esModule", { value: !0 }), CryptoKeypath$3.CryptoKeypath = void 0;
  const n = requireLib$3(), c = requirePathComponent$3(), u = requireRegistryItem$3(), p = requireRegistryType$3();
  var a;
  (function(b) {
    b[b.components = 1] = "components", b[b.source_fingerprint = 2] = "source_fingerprint", b[b.depth = 3] = "depth";
  })(a || (a = {}));
  class A extends u.RegistryItem {
    constructor(F = [], le, L) {
      super(), this.components = F, this.sourceFingerprint = le, this.depth = L, this.getRegistryType = () => p.RegistryTypes.CRYPTO_KEYPATH, this.getPath = () => this.components.length === 0 ? void 0 : this.components.map(($) => `${$.isWildcard() ? "*" : $.getIndex()}${$.isHardened() ? "'" : ""}`).join("/"), this.getComponents = () => this.components, this.getSourceFingerprint = () => this.sourceFingerprint, this.getDepth = () => this.depth, this.toDataItem = () => {
        const pe = {}, $ = [];
        return this.components && this.components.forEach((Ee) => {
          Ee.isWildcard() ? $.push([]) : $.push(Ee.getIndex()), $.push(Ee.isHardened());
        }), pe[a.components] = $, this.sourceFingerprint && (pe[a.source_fingerprint] = this.sourceFingerprint.readUInt32BE(0)), this.depth !== void 0 && (pe[a.depth] = this.depth), new n.DataItem(pe);
      };
    }
  }
  return CryptoKeypath$3.CryptoKeypath = A, A.fromDataItem = (b) => {
    const F = b.getData(), le = [], L = F[a.components];
    if (L)
      for (let be = 0; be < L.length; be += 2) {
        const He = L[be + 1], Pe = L[be];
        typeof Pe == "number" ? le.push(new c.PathComponent({ index: Pe, hardened: He })) : le.push(new c.PathComponent({ hardened: He }));
      }
    const pe = F[a.source_fingerprint];
    let $;
    pe && ($ = Buffer$f.alloc(4), $.writeUInt32BE(pe, 0));
    const Ee = F[a.depth];
    return new A(le, $, Ee);
  }, A.fromCBOR = (b) => {
    const F = (0, n.decodeToDataItem)(b);
    return A.fromDataItem(F);
  }, CryptoKeypath$3;
}
var hasRequiredCryptoHDKey$3;
function requireCryptoHDKey$3() {
  if (hasRequiredCryptoHDKey$3) return CryptoHDKey$3;
  hasRequiredCryptoHDKey$3 = 1, Object.defineProperty(CryptoHDKey$3, "__esModule", { value: !0 }), CryptoHDKey$3.CryptoHDKey = void 0;
  const n = requireBs58check$3(), c = requireCryptoCoinInfo$3(), u = requireCryptoKeypath$3(), p = requireLib$3(), a = requireRegistryItem$3(), A = requireRegistryType$3();
  var b;
  (function(le) {
    le[le.is_master = 1] = "is_master", le[le.is_private = 2] = "is_private", le[le.key_data = 3] = "key_data", le[le.chain_code = 4] = "chain_code", le[le.use_info = 5] = "use_info", le[le.origin = 6] = "origin", le[le.children = 7] = "children", le[le.parent_fingerprint = 8] = "parent_fingerprint", le[le.name = 9] = "name", le[le.note = 10] = "note";
  })(b || (b = {}));
  class F extends a.RegistryItem {
    constructor(L) {
      super(), this.isECKey = () => !1, this.getKey = () => this.key, this.getChainCode = () => this.chainCode, this.isMaster = () => this.master, this.isPrivateKey = () => !!this.privateKey, this.getUseInfo = () => this.useInfo, this.getOrigin = () => this.origin, this.getChildren = () => this.children, this.getParentFingerprint = () => this.parentFingerprint, this.getName = () => this.name, this.getNote = () => this.note, this.getBip32Key = () => {
        var pe, $, Ee;
        let be, He, Pe = 0, nr = Buffer$f.alloc(4).fill(0);
        if (this.isMaster())
          be = Buffer$f.from("0488ADE4", "hex"), He = 0, Pe = 0;
        else {
          He = ((pe = this.getOrigin()) === null || pe === void 0 ? void 0 : pe.getComponents().length) || (($ = this.getOrigin()) === null || $ === void 0 ? void 0 : $.getDepth());
          const xr = (Ee = this.getOrigin()) === null || Ee === void 0 ? void 0 : Ee.getComponents(), kr = xr[xr.length - 1];
          kr && (Pe = kr.isHardened() ? kr.getIndex() + 2147483648 : kr.getIndex(), this.getParentFingerprint() && (nr = this.getParentFingerprint())), this.isPrivateKey() ? be = Buffer$f.from("0488ADE4", "hex") : be = Buffer$f.from("0488B21E", "hex");
        }
        const ir = Buffer$f.alloc(1);
        ir.writeUInt8(He, 0);
        const or = Buffer$f.alloc(4);
        or.writeUInt32BE(Pe, 0);
        const lr = this.getChainCode(), Ir = this.getKey();
        return (0, n.encode)(Buffer$f.concat([be, ir, nr, or, lr, Ir]));
      }, this.getRegistryType = () => A.RegistryTypes.CRYPTO_HDKEY, this.getOutputDescriptorContent = () => {
        var pe, $, Ee, be, He, Pe, nr;
        let ir = "";
        return this.getOrigin() && !((pe = this.getOrigin()) === null || pe === void 0) && pe.getSourceFingerprint() && !(($ = this.getOrigin()) === null || $ === void 0) && $.getPath() && (ir += `${(be = (Ee = this.getOrigin()) === null || Ee === void 0 ? void 0 : Ee.getSourceFingerprint()) === null || be === void 0 ? void 0 : be.toString("hex")}/${(He = this.getOrigin()) === null || He === void 0 ? void 0 : He.getPath()}`), ir += this.getBip32Key(), this.getChildren() && !((Pe = this.getChildren()) === null || Pe === void 0) && Pe.getPath() && (ir += `/${(nr = this.getChildren()) === null || nr === void 0 ? void 0 : nr.getPath()}`), ir;
      }, this.setupMasterKey = (pe) => {
        this.master = !0, this.key = pe.key, this.chainCode = pe.chainCode;
      }, this.setupDeriveKey = (pe) => {
        this.master = !1, this.privateKey = pe.isPrivateKey, this.key = pe.key, this.chainCode = pe.chainCode, this.useInfo = pe.useInfo, this.origin = pe.origin, this.children = pe.children, this.parentFingerprint = pe.parentFingerprint, this.name = pe.name, this.note = pe.note;
      }, this.toDataItem = () => {
        const pe = {};
        if (this.master)
          pe[b.is_master] = !0, pe[b.key_data] = this.key, pe[b.chain_code] = this.chainCode;
        else {
          if (this.privateKey !== void 0 && (pe[b.is_private] = this.privateKey), pe[b.key_data] = this.key, this.chainCode && (pe[b.chain_code] = this.chainCode), this.useInfo) {
            const $ = this.useInfo.toDataItem();
            $.setTag(this.useInfo.getRegistryType().getTag()), pe[b.use_info] = $;
          }
          if (this.origin) {
            const $ = this.origin.toDataItem();
            $.setTag(this.origin.getRegistryType().getTag()), pe[b.origin] = $;
          }
          if (this.children) {
            const $ = this.children.toDataItem();
            $.setTag(this.children.getRegistryType().getTag()), pe[b.children] = $;
          }
          this.parentFingerprint && (pe[b.parent_fingerprint] = this.parentFingerprint.readUInt32BE(0)), this.name !== void 0 && (pe[b.name] = this.name), this.note !== void 0 && (pe[b.note] = this.note);
        }
        return new p.DataItem(pe);
      }, L.isMaster ? this.setupMasterKey(L) : this.setupDeriveKey(L);
    }
  }
  return CryptoHDKey$3.CryptoHDKey = F, F.fromDataItem = (le) => {
    const L = le.getData(), pe = !!L[b.is_master], $ = L[b.is_private], Ee = L[b.key_data], be = L[b.chain_code], He = L[b.use_info] ? c.CryptoCoinInfo.fromDataItem(L[b.use_info]) : void 0, Pe = L[b.origin] ? u.CryptoKeypath.fromDataItem(L[b.origin]) : void 0, nr = L[b.children] ? u.CryptoKeypath.fromDataItem(L[b.children]) : void 0, ir = L[b.parent_fingerprint];
    let or;
    ir && (or = Buffer$f.alloc(4), or.writeUInt32BE(ir, 0));
    const lr = L[b.name], Ir = L[b.note];
    return new F({
      isMaster: pe,
      isPrivateKey: $,
      key: Ee,
      chainCode: be,
      useInfo: He,
      origin: Pe,
      children: nr,
      parentFingerprint: or,
      name: lr,
      note: Ir
    });
  }, F.fromCBOR = (le) => {
    const L = (0, p.decodeToDataItem)(le);
    return F.fromDataItem(L);
  }, CryptoHDKey$3;
}
var CryptoECKey$3 = {}, hasRequiredCryptoECKey$3;
function requireCryptoECKey$3() {
  if (hasRequiredCryptoECKey$3) return CryptoECKey$3;
  hasRequiredCryptoECKey$3 = 1, Object.defineProperty(CryptoECKey$3, "__esModule", { value: !0 }), CryptoECKey$3.CryptoECKey = void 0;
  const n = requireLib$3(), c = requireRegistryItem$3(), u = requireRegistryType$3();
  var p;
  (function(A) {
    A[A.curve = 1] = "curve", A[A.private = 2] = "private", A[A.data = 3] = "data";
  })(p || (p = {}));
  class a extends c.RegistryItem {
    constructor(b) {
      super(), this.isECKey = () => !0, this.getCurve = () => this.curve || 0, this.isPrivateKey = () => this.privateKey || !1, this.getData = () => this.data, this.getRegistryType = () => u.RegistryTypes.CRYPTO_ECKEY, this.toDataItem = () => {
        const F = {};
        return this.curve && (F[p.curve] = this.curve), this.privateKey !== void 0 && (F[p.private] = this.privateKey), F[p.data] = this.data, new n.DataItem(F);
      }, this.getOutputDescriptorContent = () => this.data.toString("hex"), this.data = b.data, this.curve = b.curve, this.privateKey = b.privateKey || void 0;
    }
  }
  return CryptoECKey$3.CryptoECKey = a, a.fromDataItem = (A) => {
    const b = A.getData(), F = b[p.curve], le = b[p.private], L = b[p.data];
    if (!L)
      throw new Error(`#[ur-registry][CryptoECKey][fn.fromDataItem]: decoded [dataItem][#data.data] is undefined: ${A}`);
    return new a({ data: L, curve: F, privateKey: le });
  }, a.fromCBOR = (A) => {
    const b = (0, n.decodeToDataItem)(A);
    return a.fromDataItem(b);
  }, CryptoECKey$3;
}
var Bytes$4 = {}, hasRequiredBytes$3;
function requireBytes$3() {
  if (hasRequiredBytes$3) return Bytes$4;
  hasRequiredBytes$3 = 1, Object.defineProperty(Bytes$4, "__esModule", { value: !0 }), Bytes$4.Bytes = void 0;
  const n = requireLib$3(), c = requireRegistryItem$3(), u = requireRegistryType$3();
  class p extends c.RegistryItem {
    constructor(A) {
      super(), this.bytes = A, this.getRegistryType = () => u.RegistryTypes.BYTES, this.getData = () => this.bytes, this.toDataItem = () => new n.DataItem(this.bytes);
    }
  }
  return Bytes$4.Bytes = p, p.fromDataItem = (a) => {
    const A = a.getData();
    if (!A)
      throw new Error(`#[ur-registry][Bytes][fn.fromDataItem]: decoded [dataItem][#data] is undefined: ${a}`);
    return new p(A);
  }, p.fromCBOR = (a) => {
    const A = (0, n.decodeToDataItem)(a);
    return p.fromDataItem(A);
  }, Bytes$4;
}
var CryptoOutput$3 = {}, MultiKey$3 = {}, hasRequiredMultiKey$3;
function requireMultiKey$3() {
  if (hasRequiredMultiKey$3) return MultiKey$3;
  hasRequiredMultiKey$3 = 1, Object.defineProperty(MultiKey$3, "__esModule", { value: !0 }), MultiKey$3.MultiKey = void 0;
  const n = requireCryptoECKey$3(), c = requireCryptoHDKey$3(), u = requireDataItem$3(), p = requireRegistryItem$3(), a = requireRegistryType$3();
  var A;
  (function(F) {
    F[F.threshold = 1] = "threshold", F[F.keys = 2] = "keys";
  })(A || (A = {}));
  class b extends p.RegistryItem {
    constructor(le, L) {
      super(), this.threshold = le, this.keys = L, this.getThreshold = () => this.threshold, this.getKeys = () => this.keys, this.toDataItem = () => {
        const pe = {};
        pe[A.threshold] = this.threshold;
        const $ = this.keys.map((Ee) => {
          const be = Ee.toDataItem();
          return be.setTag(Ee.getRegistryType().getTag()), be;
        });
        return pe[A.keys] = $, new u.DataItem(pe);
      }, this.getOutputDescriptorContent = () => [
        this.getThreshold(),
        this.keys.map((pe) => pe.getOutputDescriptorContent()).join(",")
      ].join(",");
    }
  }
  return MultiKey$3.MultiKey = b, b.fromDataItem = (F) => {
    const le = F.getData(), L = le[A.threshold], pe = le[A.keys], $ = [];
    return pe.forEach((Ee) => {
      Ee.getTag() === a.RegistryTypes.CRYPTO_HDKEY.getTag() ? $.push(c.CryptoHDKey.fromDataItem(Ee)) : Ee.getTag() === a.RegistryTypes.CRYPTO_ECKEY.getTag() && $.push(n.CryptoECKey.fromDataItem(Ee));
    }), new b(L, $);
  }, MultiKey$3;
}
var hasRequiredCryptoOutput$3;
function requireCryptoOutput$3() {
  if (hasRequiredCryptoOutput$3) return CryptoOutput$3;
  hasRequiredCryptoOutput$3 = 1, Object.defineProperty(CryptoOutput$3, "__esModule", { value: !0 }), CryptoOutput$3.CryptoOutput = void 0;
  const n = requireCryptoECKey$3(), c = requireCryptoHDKey$3(), u = requireLib$3(), p = requireMultiKey$3(), a = requireRegistryItem$3(), A = requireRegistryType$3(), b = requireScriptExpression$3();
  class F extends a.RegistryItem {
    constructor(L, pe) {
      super(), this.scriptExpressions = L, this.cryptoKey = pe, this.getRegistryType = () => A.RegistryTypes.CRYPTO_OUTPUT, this.getCryptoKey = () => this.cryptoKey, this.getHDKey = () => {
        if (this.cryptoKey instanceof c.CryptoHDKey)
          return this.cryptoKey;
      }, this.getECKey = () => {
        if (this.cryptoKey instanceof n.CryptoECKey)
          return this.cryptoKey;
      }, this.getMultiKey = () => {
        if (this.cryptoKey instanceof p.MultiKey)
          return this.cryptoKey;
      }, this.getScriptExpressions = () => this.scriptExpressions, this._toOutputDescriptor = ($) => $ >= this.scriptExpressions.length ? this.cryptoKey.getOutputDescriptorContent() : `${this.scriptExpressions[$].getExpression()}(${this._toOutputDescriptor($ + 1)})`, this.toString = () => this._toOutputDescriptor(0), this.toDataItem = () => {
        let $ = this.cryptoKey.toDataItem();
        return (this.cryptoKey instanceof n.CryptoECKey || this.cryptoKey instanceof c.CryptoHDKey) && $.setTag(this.cryptoKey.getRegistryType().getTag()), [...this.scriptExpressions].reverse().forEach((be) => {
          const He = be.getTag();
          $.getTag() === void 0 ? $.setTag(He) : $ = new u.DataItem($, He);
        }), $;
      };
    }
  }
  return CryptoOutput$3.CryptoOutput = F, F.fromDataItem = (le) => {
    const L = [];
    let pe = le;
    for (; ; ) {
      let be = pe.getTag();
      const He = b.ScriptExpression.fromTag(be);
      if (He)
        if (L.push(He), pe.getData() instanceof u.DataItem)
          pe = pe.getData(), be = pe.getTag();
        else
          break;
      else
        break;
    }
    const $ = L.length;
    if ($ > 0 && (L[$ - 1].getExpression() === b.ScriptExpressions.MULTISIG.getExpression() || L[$ - 1].getExpression() === b.ScriptExpressions.SORTED_MULTISIG.getExpression())) {
      const be = p.MultiKey.fromDataItem(pe);
      return new F(L, be);
    }
    if (pe.getTag() === A.RegistryTypes.CRYPTO_HDKEY.getTag()) {
      const be = c.CryptoHDKey.fromDataItem(pe);
      return new F(L, be);
    } else {
      const be = n.CryptoECKey.fromDataItem(pe);
      return new F(L, be);
    }
  }, F.fromCBOR = (le) => {
    const L = (0, u.decodeToDataItem)(le);
    return F.fromDataItem(L);
  }, CryptoOutput$3;
}
var CryptoPSBT$3 = {}, hasRequiredCryptoPSBT$3;
function requireCryptoPSBT$3() {
  if (hasRequiredCryptoPSBT$3) return CryptoPSBT$3;
  hasRequiredCryptoPSBT$3 = 1, Object.defineProperty(CryptoPSBT$3, "__esModule", { value: !0 }), CryptoPSBT$3.CryptoPSBT = void 0;
  const n = requireLib$3(), c = requireRegistryItem$3(), u = requireRegistryType$3();
  class p extends c.RegistryItem {
    constructor(A) {
      super(), this.psbt = A, this.getRegistryType = () => u.RegistryTypes.CRYPTO_PSBT, this.getPSBT = () => this.psbt, this.toDataItem = () => new n.DataItem(this.psbt);
    }
  }
  return CryptoPSBT$3.CryptoPSBT = p, p.fromDataItem = (a) => {
    const A = a.getData();
    if (!A)
      throw new Error(`#[ur-registry][CryptoPSBT][fn.fromDataItem]: decoded [dataItem][#data] is undefined: ${a}`);
    return new p(A);
  }, p.fromCBOR = (a) => {
    const A = (0, n.decodeToDataItem)(a);
    return p.fromDataItem(A);
  }, CryptoPSBT$3;
}
var CryptoAccount$3 = {}, hasRequiredCryptoAccount$3;
function requireCryptoAccount$3() {
  if (hasRequiredCryptoAccount$3) return CryptoAccount$3;
  hasRequiredCryptoAccount$3 = 1, Object.defineProperty(CryptoAccount$3, "__esModule", { value: !0 }), CryptoAccount$3.CryptoAccount = void 0;
  const n = requireDist$3(), c = requireLib$3(), u = requireRegistryItem$3(), p = requireRegistryType$3();
  var a;
  (function(b) {
    b[b.masterFingerprint = 1] = "masterFingerprint", b[b.outputDescriptors = 2] = "outputDescriptors";
  })(a || (a = {}));
  class A extends u.RegistryItem {
    constructor(F, le) {
      super(), this.masterFingerprint = F, this.outputDescriptors = le, this.getRegistryType = () => p.RegistryTypes.CRYPTO_ACCOUNT, this.getMasterFingerprint = () => this.masterFingerprint, this.getOutputDescriptors = () => this.outputDescriptors, this.toDataItem = () => {
        const L = {};
        return this.masterFingerprint && (L[a.masterFingerprint] = this.masterFingerprint.readUInt32BE(0)), this.outputDescriptors && (L[a.outputDescriptors] = this.outputDescriptors.map((pe) => pe.toDataItem())), new c.DataItem(L);
      };
    }
  }
  return CryptoAccount$3.CryptoAccount = A, A.fromDataItem = (b) => {
    const F = b.getData(), le = Buffer$f.alloc(4), L = F[a.masterFingerprint];
    L && le.writeUInt32BE(L, 0);
    const $ = F[a.outputDescriptors].map((Ee) => n.CryptoOutput.fromDataItem(Ee));
    return new A(le, $);
  }, A.fromCBOR = (b) => {
    const F = (0, c.decodeToDataItem)(b);
    return A.fromDataItem(F);
  }, CryptoAccount$3;
}
var Decoder$3 = {}, errors$4 = {}, hasRequiredErrors$3;
function requireErrors$3() {
  if (hasRequiredErrors$3) return errors$4;
  hasRequiredErrors$3 = 1, Object.defineProperty(errors$4, "__esModule", { value: !0 }), errors$4.UnknownURTypeError = void 0;
  class n extends Error {
    constructor(u) {
      super(u);
    }
  }
  return errors$4.UnknownURTypeError = n, errors$4;
}
var hasRequiredDecoder$3;
function requireDecoder$3() {
  if (hasRequiredDecoder$3) return Decoder$3;
  hasRequiredDecoder$3 = 1, Object.defineProperty(Decoder$3, "__esModule", { value: !0 }), Decoder$3.URRegistryDecoder = void 0;
  const n = dist$t, c = requireDist$3(), u = requireRegistryType$3(), p = requireErrors$3();
  class a extends n.URDecoder {
    constructor() {
      super(...arguments), this.resultRegistryType = () => {
        const b = this.resultUR();
        switch (b.type) {
          case u.RegistryTypes.BYTES.getType():
            return c.Bytes.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_HDKEY.getType():
            return c.CryptoHDKey.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_KEYPATH.getType():
            return c.CryptoKeypath.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_COIN_INFO.getType():
            return c.CryptoCoinInfo.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_ECKEY.getType():
            return c.CryptoECKey.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_OUTPUT.getType():
            return c.CryptoOutput.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_PSBT.getType():
            return c.CryptoPSBT.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_ACCOUNT.getType():
            return c.CryptoAccount.fromCBOR(b.cbor);
          default:
            throw new p.UnknownURTypeError(`#[ur-registry][Decoder][fn.resultRegistryType]: registry type ${b.type} is not supported now`);
        }
      };
    }
  }
  return Decoder$3.URRegistryDecoder = a, Decoder$3;
}
var CryptoMultiAccounts$3 = {}, hasRequiredCryptoMultiAccounts$3;
function requireCryptoMultiAccounts$3() {
  if (hasRequiredCryptoMultiAccounts$3) return CryptoMultiAccounts$3;
  hasRequiredCryptoMultiAccounts$3 = 1, Object.defineProperty(CryptoMultiAccounts$3, "__esModule", { value: !0 }), CryptoMultiAccounts$3.CryptoMultiAccounts = void 0;
  const n = requireRegistryType$3(), c = requireCryptoHDKey$3(), u = requireRegistryItem$3(), p = requireLib$3();
  var a;
  (function(b) {
    b[b.masterFingerprint = 1] = "masterFingerprint", b[b.keys = 2] = "keys", b[b.device = 3] = "device", b[b.deviceId = 4] = "deviceId", b[b.version = 5] = "version";
  })(a || (a = {}));
  class A extends u.RegistryItem {
    constructor(F, le, L, pe, $) {
      super(), this.masterFingerprint = F, this.keys = le, this.device = L, this.deviceId = pe, this.version = $, this.getRegistryType = () => n.RegistryTypes.CRYPTO_MULTI_ACCOUNTS, this.getMasterFingerprint = () => this.masterFingerprint, this.getKeys = () => this.keys, this.getDevice = () => this.device, this.getDeviceId = () => this.deviceId, this.getVersion = () => this.version, this.toDataItem = () => {
        const Ee = {};
        return this.masterFingerprint && (Ee[a.masterFingerprint] = this.masterFingerprint.readUInt32BE(0)), this.keys && (Ee[a.keys] = this.keys.map((be) => {
          const He = be.toDataItem();
          return He.setTag(be.getRegistryType().getTag()), He;
        })), this.device && (Ee[a.device] = this.device), this.deviceId && (Ee[a.deviceId] = this.deviceId), this.version && (Ee[a.version] = this.version), new p.DataItem(Ee);
      };
    }
  }
  return CryptoMultiAccounts$3.CryptoMultiAccounts = A, A.fromDataItem = (b) => {
    const F = b.getData(), le = Buffer$f.alloc(4), L = F[a.masterFingerprint];
    L && le.writeUInt32BE(L, 0);
    const $ = F[a.keys].map((Pe) => c.CryptoHDKey.fromDataItem(Pe)), Ee = F[a.device], be = F[a.deviceId], He = F[a.version];
    return new A(le, $, Ee, be, He);
  }, A.fromCBOR = (b) => {
    const F = (0, p.decodeToDataItem)(b);
    return A.fromDataItem(F);
  }, CryptoMultiAccounts$3;
}
var QRHardwareCall$3 = {}, KeyDerivation$3 = {}, DerivationSchema$3 = {}, hasRequiredDerivationSchema$3;
function requireDerivationSchema$3() {
  return hasRequiredDerivationSchema$3 || (hasRequiredDerivationSchema$3 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.KeyDerivationSchema = n.DerivationAlgorithm = n.Curve = void 0;
    const c = requireRegistryType$3(), u = requireRegistryItem$3(), p = requireLib$3(), a = requireCryptoKeypath$3();
    var A;
    (function(L) {
      L[L.keyPath = 1] = "keyPath", L[L.curve = 2] = "curve", L[L.algo = 3] = "algo";
    })(A || (A = {}));
    var b;
    (function(L) {
      L[L.secp256k1 = 0] = "secp256k1", L[L.ed25519 = 1] = "ed25519";
    })(b = n.Curve || (n.Curve = {}));
    var F;
    (function(L) {
      L[L.slip10 = 0] = "slip10", L[L.bip32ed25519 = 1] = "bip32ed25519";
    })(F = n.DerivationAlgorithm || (n.DerivationAlgorithm = {}));
    class le extends u.RegistryItem {
      constructor(pe, $ = b.secp256k1, Ee = F.slip10) {
        super(), this.keypath = pe, this.curve = $, this.algo = Ee, this.getRegistryType = () => c.RegistryTypes.KEY_DERIVATION_SCHEMA, this.getKeypath = () => this.keypath, this.getCurve = () => this.curve, this.getAlgo = () => this.algo, this.toDataItem = () => {
          const be = {}, He = this.getKeypath().toDataItem();
          return He.setTag(this.getKeypath().getRegistryType().getTag()), be[A.keyPath] = He, be[A.curve] = this.curve, be[A.algo] = this.algo, new p.DataItem(be);
        };
      }
    }
    n.KeyDerivationSchema = le, le.fromDataItem = (L) => {
      const pe = L.getData(), $ = a.CryptoKeypath.fromDataItem(pe[A.keyPath]), Ee = pe[A.curve], be = pe[A.algo];
      return new le($, Ee, be);
    }, le.fromCBOR = (L) => {
      const pe = (0, p.decodeToDataItem)(L);
      return le.fromDataItem(pe);
    };
  }(DerivationSchema$3)), DerivationSchema$3;
}
var hasRequiredKeyDerivation$3;
function requireKeyDerivation$3() {
  if (hasRequiredKeyDerivation$3) return KeyDerivation$3;
  hasRequiredKeyDerivation$3 = 1, Object.defineProperty(KeyDerivation$3, "__esModule", { value: !0 }), KeyDerivation$3.KeyDerivation = void 0;
  const n = requireRegistryType$3(), c = requireRegistryItem$3(), u = requireLib$3(), p = requireDerivationSchema$3();
  var a;
  (function(b) {
    b[b.schemas = 1] = "schemas";
  })(a || (a = {}));
  class A extends c.RegistryItem {
    constructor(F) {
      super(), this.schemas = F, this.getRegistryType = () => n.RegistryTypes.KEY_DERIVATION_CALL, this.getSchemas = () => this.schemas, this.toDataItem = () => {
        const le = {};
        return le[a.schemas] = this.schemas.map((L) => {
          const pe = L.toDataItem();
          return pe.setTag(L.getRegistryType().getTag()), pe;
        }), new u.DataItem(le);
      };
    }
  }
  return KeyDerivation$3.KeyDerivation = A, A.fromDataItem = (b) => {
    const le = b.getData()[a.schemas].map((L) => p.KeyDerivationSchema.fromDataItem(L));
    return new A(le);
  }, A.fromCBOR = (b) => {
    const F = (0, u.decodeToDataItem)(b);
    return A.fromDataItem(F);
  }, KeyDerivation$3;
}
var hasRequiredQRHardwareCall$3;
function requireQRHardwareCall$3() {
  return hasRequiredQRHardwareCall$3 || (hasRequiredQRHardwareCall$3 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.QRHardwareCall = n.QRHardwareCallType = void 0;
    const c = requireRegistryType$3(), u = requireRegistryItem$3(), p = requireLib$3(), a = requireKeyDerivation$3();
    var A;
    (function(le) {
      le[le.type = 1] = "type", le[le.params = 2] = "params", le[le.origin = 3] = "origin";
    })(A || (A = {}));
    var b;
    (function(le) {
      le[le.KeyDerivation = 0] = "KeyDerivation";
    })(b = n.QRHardwareCallType || (n.QRHardwareCallType = {}));
    class F extends u.RegistryItem {
      constructor(L, pe, $) {
        super(), this.type = L, this.params = pe, this.origin = $, this.getRegistryType = () => c.RegistryTypes.QR_HARDWARE_CALL, this.getType = () => this.type, this.getParams = () => this.params, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const Ee = {};
          Ee[A.type] = this.type;
          const be = this.params.toDataItem();
          return be.setTag(this.params.getRegistryType().getTag()), Ee[A.params] = be, this.origin && (Ee[A.origin] = this.origin), new p.DataItem(Ee);
        };
      }
    }
    n.QRHardwareCall = F, F.fromDataItem = (le) => {
      const L = le.getData(), pe = L[A.type] || b.KeyDerivation;
      let $;
      switch (pe) {
        case b.KeyDerivation:
          $ = a.KeyDerivation.fromDataItem(L[A.params]);
      }
      const Ee = L[A.origin];
      return new F(pe, $, Ee);
    }, F.fromCBOR = (le) => {
      const L = (0, p.decodeToDataItem)(le);
      return F.fromDataItem(L);
    };
  }(QRHardwareCall$3)), QRHardwareCall$3;
}
var types$8 = {}, hasRequiredTypes$3;
function requireTypes$3() {
  return hasRequiredTypes$3 || (hasRequiredTypes$3 = 1, Object.defineProperty(types$8, "__esModule", { value: !0 })), types$8;
}
var hasRequiredDist$3;
function requireDist$3() {
  return hasRequiredDist$3 || (hasRequiredDist$3 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.Buffer = n.extend = n.PathComponent = n.ScriptExpressions = n.MultiKey = n.CryptoPSBT = n.CryptoOutput = n.CryptoECKey = n.CryptoCoinInfoNetwork = n.CryptoCoinInfoType = n.CryptoCoinInfo = n.CryptoKeypath = n.CryptoMultiAccounts = n.CryptoHDKey = n.CryptoAccount = n.Bytes = n.URRegistryDecoder = n.DataItem = void 0;
    const c = require$$0$4;
    requirePatchCBOR$3();
    const u = dist$u;
    Object.defineProperty(n, "Buffer", { enumerable: !0, get: function() {
      return u.Buffer;
    } });
    const p = requireCryptoHDKey$3();
    Object.defineProperty(n, "CryptoHDKey", { enumerable: !0, get: function() {
      return p.CryptoHDKey;
    } });
    const a = requireCryptoKeypath$3();
    Object.defineProperty(n, "CryptoKeypath", { enumerable: !0, get: function() {
      return a.CryptoKeypath;
    } });
    const A = requireCryptoCoinInfo$3();
    Object.defineProperty(n, "CryptoCoinInfo", { enumerable: !0, get: function() {
      return A.CryptoCoinInfo;
    } }), Object.defineProperty(n, "CryptoCoinInfoType", { enumerable: !0, get: function() {
      return A.Type;
    } }), Object.defineProperty(n, "CryptoCoinInfoNetwork", { enumerable: !0, get: function() {
      return A.Network;
    } });
    const b = requireCryptoECKey$3();
    Object.defineProperty(n, "CryptoECKey", { enumerable: !0, get: function() {
      return b.CryptoECKey;
    } });
    const F = requireBytes$3();
    Object.defineProperty(n, "Bytes", { enumerable: !0, get: function() {
      return F.Bytes;
    } });
    const le = requireCryptoOutput$3();
    Object.defineProperty(n, "CryptoOutput", { enumerable: !0, get: function() {
      return le.CryptoOutput;
    } });
    const L = requireCryptoPSBT$3();
    Object.defineProperty(n, "CryptoPSBT", { enumerable: !0, get: function() {
      return L.CryptoPSBT;
    } });
    const pe = requireCryptoAccount$3();
    Object.defineProperty(n, "CryptoAccount", { enumerable: !0, get: function() {
      return pe.CryptoAccount;
    } });
    const $ = requireDecoder$3();
    Object.defineProperty(n, "URRegistryDecoder", { enumerable: !0, get: function() {
      return $.URRegistryDecoder;
    } });
    const Ee = requireMultiKey$3();
    Object.defineProperty(n, "MultiKey", { enumerable: !0, get: function() {
      return Ee.MultiKey;
    } });
    const be = requireScriptExpression$3();
    Object.defineProperty(n, "ScriptExpressions", { enumerable: !0, get: function() {
      return be.ScriptExpressions;
    } });
    const He = requirePathComponent$3();
    Object.defineProperty(n, "PathComponent", { enumerable: !0, get: function() {
      return He.PathComponent;
    } });
    const Pe = requireRegistryItem$3(), nr = requireRegistryType$3(), ir = requireLib$3();
    var or = requireLib$3();
    Object.defineProperty(n, "DataItem", { enumerable: !0, get: function() {
      return or.DataItem;
    } });
    const lr = requireUtils$3(), Ir = requireCryptoMultiAccounts$3();
    Object.defineProperty(n, "CryptoMultiAccounts", { enumerable: !0, get: function() {
      return Ir.CryptoMultiAccounts;
    } });
    const xr = {
      URRegistryDecoder: $.URRegistryDecoder,
      Bytes: F.Bytes,
      CryptoAccount: pe.CryptoAccount,
      CryptoHDKey: p.CryptoHDKey,
      CryptoMultiAccounts: Ir.CryptoMultiAccounts,
      CryptoKeypath: a.CryptoKeypath,
      CryptoCoinInfo: A.CryptoCoinInfo,
      CryptoCoinInfoType: A.Type,
      CryptoCoinInfoNetwork: A.Network,
      CryptoECKey: b.CryptoECKey,
      CryptoOutput: le.CryptoOutput,
      CryptoPSBT: L.CryptoPSBT,
      MultiKey: Ee.MultiKey,
      ScriptExpressions: be.ScriptExpressions,
      PathComponent: He.PathComponent
    }, kr = {
      addReader: ir.addReader,
      addSemanticDecode: ir.addSemanticDecode,
      addSemanticEncode: ir.addSemanticEncode,
      addWriter: ir.addWriter,
      patchTags: lr.patchTags
    }, Ce = {
      RegistryTypes: nr.RegistryTypes,
      RegistryItem: Pe.RegistryItem,
      RegistryType: nr.RegistryType,
      decodeToDataItem: ir.decodeToDataItem,
      encodeDataItem: ir.encodeDataItem,
      cbor: kr
    };
    n.extend = Ce, (0, c.__exportStar)(requireErrors$3(), n), (0, c.__exportStar)(requireDecoder$3(), n), (0, c.__exportStar)(requireLib$3(), n), (0, c.__exportStar)(requireCryptoAccount$3(), n), (0, c.__exportStar)(requireCryptoPSBT$3(), n), (0, c.__exportStar)(requireCryptoHDKey$3(), n), (0, c.__exportStar)(requireCryptoMultiAccounts$3(), n), (0, c.__exportStar)(requireQRHardwareCall$3(), n), (0, c.__exportStar)(requireKeyDerivation$3(), n), (0, c.__exportStar)(requireDerivationSchema$3(), n), (0, c.__exportStar)(requireCryptoOutput$3(), n), (0, c.__exportStar)(requireCryptoCoinInfo$3(), n), (0, c.__exportStar)(requireCryptoECKey$3(), n), (0, c.__exportStar)(requireMultiKey$3(), n), (0, c.__exportStar)(requireCryptoKeypath$3(), n), (0, c.__exportStar)(requirePatchCBOR$3(), n), (0, c.__exportStar)(requirePathComponent$3(), n), (0, c.__exportStar)(requireRegistryItem$3(), n), (0, c.__exportStar)(requireRegistryType$3(), n), (0, c.__exportStar)(requireTypes$3(), n), (0, c.__exportStar)(requireUtils$3(), n), n.default = xr;
  }(dist$a)), dist$a;
}
var getRandomValues$4, rnds8$2 = new Uint8Array(16);
function rng$4() {
  if (!getRandomValues$4 && (getRandomValues$4 = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !getRandomValues$4))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return getRandomValues$4(rnds8$2);
}
const REGEX$1 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function validate$4(n) {
  return typeof n == "string" && REGEX$1.test(n);
}
var byteToHex$2 = [];
for (var i$3 = 0; i$3 < 256; ++i$3)
  byteToHex$2.push((i$3 + 256).toString(16).substr(1));
function stringify$3(n) {
  var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, u = (byteToHex$2[n[c + 0]] + byteToHex$2[n[c + 1]] + byteToHex$2[n[c + 2]] + byteToHex$2[n[c + 3]] + "-" + byteToHex$2[n[c + 4]] + byteToHex$2[n[c + 5]] + "-" + byteToHex$2[n[c + 6]] + byteToHex$2[n[c + 7]] + "-" + byteToHex$2[n[c + 8]] + byteToHex$2[n[c + 9]] + "-" + byteToHex$2[n[c + 10]] + byteToHex$2[n[c + 11]] + byteToHex$2[n[c + 12]] + byteToHex$2[n[c + 13]] + byteToHex$2[n[c + 14]] + byteToHex$2[n[c + 15]]).toLowerCase();
  if (!validate$4(u))
    throw TypeError("Stringified UUID is invalid");
  return u;
}
var _nodeId$1, _clockseq$1, _lastMSecs$1 = 0, _lastNSecs$1 = 0;
function v1$3(n, c, u) {
  var p = c && u || 0, a = c || new Array(16);
  n = n || {};
  var A = n.node || _nodeId$1, b = n.clockseq !== void 0 ? n.clockseq : _clockseq$1;
  if (A == null || b == null) {
    var F = n.random || (n.rng || rng$4)();
    A == null && (A = _nodeId$1 = [F[0] | 1, F[1], F[2], F[3], F[4], F[5]]), b == null && (b = _clockseq$1 = (F[6] << 8 | F[7]) & 16383);
  }
  var le = n.msecs !== void 0 ? n.msecs : Date.now(), L = n.nsecs !== void 0 ? n.nsecs : _lastNSecs$1 + 1, pe = le - _lastMSecs$1 + (L - _lastNSecs$1) / 1e4;
  if (pe < 0 && n.clockseq === void 0 && (b = b + 1 & 16383), (pe < 0 || le > _lastMSecs$1) && n.nsecs === void 0 && (L = 0), L >= 1e4)
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  _lastMSecs$1 = le, _lastNSecs$1 = L, _clockseq$1 = b, le += 122192928e5;
  var $ = ((le & 268435455) * 1e4 + L) % 4294967296;
  a[p++] = $ >>> 24 & 255, a[p++] = $ >>> 16 & 255, a[p++] = $ >>> 8 & 255, a[p++] = $ & 255;
  var Ee = le / 4294967296 * 1e4 & 268435455;
  a[p++] = Ee >>> 8 & 255, a[p++] = Ee & 255, a[p++] = Ee >>> 24 & 15 | 16, a[p++] = Ee >>> 16 & 255, a[p++] = b >>> 8 | 128, a[p++] = b & 255;
  for (var be = 0; be < 6; ++be)
    a[p + be] = A[be];
  return c || stringify$3(a);
}
function parse$a(n) {
  if (!validate$4(n))
    throw TypeError("Invalid UUID");
  var c, u = new Uint8Array(16);
  return u[0] = (c = parseInt(n.slice(0, 8), 16)) >>> 24, u[1] = c >>> 16 & 255, u[2] = c >>> 8 & 255, u[3] = c & 255, u[4] = (c = parseInt(n.slice(9, 13), 16)) >>> 8, u[5] = c & 255, u[6] = (c = parseInt(n.slice(14, 18), 16)) >>> 8, u[7] = c & 255, u[8] = (c = parseInt(n.slice(19, 23), 16)) >>> 8, u[9] = c & 255, u[10] = (c = parseInt(n.slice(24, 36), 16)) / 1099511627776 & 255, u[11] = c / 4294967296 & 255, u[12] = c >>> 24 & 255, u[13] = c >>> 16 & 255, u[14] = c >>> 8 & 255, u[15] = c & 255, u;
}
function stringToBytes$2(n) {
  n = unescape(encodeURIComponent(n));
  for (var c = [], u = 0; u < n.length; ++u)
    c.push(n.charCodeAt(u));
  return c;
}
var DNS$1 = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", URL$2 = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
function v35$3(n, c, u) {
  function p(a, A, b, F) {
    if (typeof a == "string" && (a = stringToBytes$2(a)), typeof A == "string" && (A = parse$a(A)), A.length !== 16)
      throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    var le = new Uint8Array(16 + a.length);
    if (le.set(A), le.set(a, A.length), le = u(le), le[6] = le[6] & 15 | c, le[8] = le[8] & 63 | 128, b) {
      F = F || 0;
      for (var L = 0; L < 16; ++L)
        b[F + L] = le[L];
      return b;
    }
    return stringify$3(le);
  }
  try {
    p.name = n;
  } catch {
  }
  return p.DNS = DNS$1, p.URL = URL$2, p;
}
function md5$3(n) {
  if (typeof n == "string") {
    var c = unescape(encodeURIComponent(n));
    n = new Uint8Array(c.length);
    for (var u = 0; u < c.length; ++u)
      n[u] = c.charCodeAt(u);
  }
  return md5ToHexEncodedArray$1(wordsToMd5$1(bytesToWords$1(n), n.length * 8));
}
function md5ToHexEncodedArray$1(n) {
  for (var c = [], u = n.length * 32, p = "0123456789abcdef", a = 0; a < u; a += 8) {
    var A = n[a >> 5] >>> a % 32 & 255, b = parseInt(p.charAt(A >>> 4 & 15) + p.charAt(A & 15), 16);
    c.push(b);
  }
  return c;
}
function getOutputLength$1(n) {
  return (n + 64 >>> 9 << 4) + 14 + 1;
}
function wordsToMd5$1(n, c) {
  n[c >> 5] |= 128 << c % 32, n[getOutputLength$1(c) - 1] = c;
  for (var u = 1732584193, p = -271733879, a = -1732584194, A = 271733878, b = 0; b < n.length; b += 16) {
    var F = u, le = p, L = a, pe = A;
    u = md5ff$1(u, p, a, A, n[b], 7, -680876936), A = md5ff$1(A, u, p, a, n[b + 1], 12, -389564586), a = md5ff$1(a, A, u, p, n[b + 2], 17, 606105819), p = md5ff$1(p, a, A, u, n[b + 3], 22, -1044525330), u = md5ff$1(u, p, a, A, n[b + 4], 7, -176418897), A = md5ff$1(A, u, p, a, n[b + 5], 12, 1200080426), a = md5ff$1(a, A, u, p, n[b + 6], 17, -1473231341), p = md5ff$1(p, a, A, u, n[b + 7], 22, -45705983), u = md5ff$1(u, p, a, A, n[b + 8], 7, 1770035416), A = md5ff$1(A, u, p, a, n[b + 9], 12, -1958414417), a = md5ff$1(a, A, u, p, n[b + 10], 17, -42063), p = md5ff$1(p, a, A, u, n[b + 11], 22, -1990404162), u = md5ff$1(u, p, a, A, n[b + 12], 7, 1804603682), A = md5ff$1(A, u, p, a, n[b + 13], 12, -40341101), a = md5ff$1(a, A, u, p, n[b + 14], 17, -1502002290), p = md5ff$1(p, a, A, u, n[b + 15], 22, 1236535329), u = md5gg$1(u, p, a, A, n[b + 1], 5, -165796510), A = md5gg$1(A, u, p, a, n[b + 6], 9, -1069501632), a = md5gg$1(a, A, u, p, n[b + 11], 14, 643717713), p = md5gg$1(p, a, A, u, n[b], 20, -373897302), u = md5gg$1(u, p, a, A, n[b + 5], 5, -701558691), A = md5gg$1(A, u, p, a, n[b + 10], 9, 38016083), a = md5gg$1(a, A, u, p, n[b + 15], 14, -660478335), p = md5gg$1(p, a, A, u, n[b + 4], 20, -405537848), u = md5gg$1(u, p, a, A, n[b + 9], 5, 568446438), A = md5gg$1(A, u, p, a, n[b + 14], 9, -1019803690), a = md5gg$1(a, A, u, p, n[b + 3], 14, -187363961), p = md5gg$1(p, a, A, u, n[b + 8], 20, 1163531501), u = md5gg$1(u, p, a, A, n[b + 13], 5, -1444681467), A = md5gg$1(A, u, p, a, n[b + 2], 9, -51403784), a = md5gg$1(a, A, u, p, n[b + 7], 14, 1735328473), p = md5gg$1(p, a, A, u, n[b + 12], 20, -1926607734), u = md5hh$1(u, p, a, A, n[b + 5], 4, -378558), A = md5hh$1(A, u, p, a, n[b + 8], 11, -2022574463), a = md5hh$1(a, A, u, p, n[b + 11], 16, 1839030562), p = md5hh$1(p, a, A, u, n[b + 14], 23, -35309556), u = md5hh$1(u, p, a, A, n[b + 1], 4, -1530992060), A = md5hh$1(A, u, p, a, n[b + 4], 11, 1272893353), a = md5hh$1(a, A, u, p, n[b + 7], 16, -155497632), p = md5hh$1(p, a, A, u, n[b + 10], 23, -1094730640), u = md5hh$1(u, p, a, A, n[b + 13], 4, 681279174), A = md5hh$1(A, u, p, a, n[b], 11, -358537222), a = md5hh$1(a, A, u, p, n[b + 3], 16, -722521979), p = md5hh$1(p, a, A, u, n[b + 6], 23, 76029189), u = md5hh$1(u, p, a, A, n[b + 9], 4, -640364487), A = md5hh$1(A, u, p, a, n[b + 12], 11, -421815835), a = md5hh$1(a, A, u, p, n[b + 15], 16, 530742520), p = md5hh$1(p, a, A, u, n[b + 2], 23, -995338651), u = md5ii$1(u, p, a, A, n[b], 6, -198630844), A = md5ii$1(A, u, p, a, n[b + 7], 10, 1126891415), a = md5ii$1(a, A, u, p, n[b + 14], 15, -1416354905), p = md5ii$1(p, a, A, u, n[b + 5], 21, -57434055), u = md5ii$1(u, p, a, A, n[b + 12], 6, 1700485571), A = md5ii$1(A, u, p, a, n[b + 3], 10, -1894986606), a = md5ii$1(a, A, u, p, n[b + 10], 15, -1051523), p = md5ii$1(p, a, A, u, n[b + 1], 21, -2054922799), u = md5ii$1(u, p, a, A, n[b + 8], 6, 1873313359), A = md5ii$1(A, u, p, a, n[b + 15], 10, -30611744), a = md5ii$1(a, A, u, p, n[b + 6], 15, -1560198380), p = md5ii$1(p, a, A, u, n[b + 13], 21, 1309151649), u = md5ii$1(u, p, a, A, n[b + 4], 6, -145523070), A = md5ii$1(A, u, p, a, n[b + 11], 10, -1120210379), a = md5ii$1(a, A, u, p, n[b + 2], 15, 718787259), p = md5ii$1(p, a, A, u, n[b + 9], 21, -343485551), u = safeAdd$1(u, F), p = safeAdd$1(p, le), a = safeAdd$1(a, L), A = safeAdd$1(A, pe);
  }
  return [u, p, a, A];
}
function bytesToWords$1(n) {
  if (n.length === 0)
    return [];
  for (var c = n.length * 8, u = new Uint32Array(getOutputLength$1(c)), p = 0; p < c; p += 8)
    u[p >> 5] |= (n[p / 8] & 255) << p % 32;
  return u;
}
function safeAdd$1(n, c) {
  var u = (n & 65535) + (c & 65535), p = (n >> 16) + (c >> 16) + (u >> 16);
  return p << 16 | u & 65535;
}
function bitRotateLeft$1(n, c) {
  return n << c | n >>> 32 - c;
}
function md5cmn$1(n, c, u, p, a, A) {
  return safeAdd$1(bitRotateLeft$1(safeAdd$1(safeAdd$1(c, n), safeAdd$1(p, A)), a), u);
}
function md5ff$1(n, c, u, p, a, A, b) {
  return md5cmn$1(c & u | ~c & p, n, c, a, A, b);
}
function md5gg$1(n, c, u, p, a, A, b) {
  return md5cmn$1(c & p | u & ~p, n, c, a, A, b);
}
function md5hh$1(n, c, u, p, a, A, b) {
  return md5cmn$1(c ^ u ^ p, n, c, a, A, b);
}
function md5ii$1(n, c, u, p, a, A, b) {
  return md5cmn$1(u ^ (c | ~p), n, c, a, A, b);
}
var v3$3 = v35$3("v3", 48, md5$3);
function v4$4(n, c, u) {
  n = n || {};
  var p = n.random || (n.rng || rng$4)();
  if (p[6] = p[6] & 15 | 64, p[8] = p[8] & 63 | 128, c) {
    u = u || 0;
    for (var a = 0; a < 16; ++a)
      c[u + a] = p[a];
    return c;
  }
  return stringify$3(p);
}
function f$3(n, c, u, p) {
  switch (n) {
    case 0:
      return c & u ^ ~c & p;
    case 1:
      return c ^ u ^ p;
    case 2:
      return c & u ^ c & p ^ u & p;
    case 3:
      return c ^ u ^ p;
  }
}
function ROTL$1(n, c) {
  return n << c | n >>> 32 - c;
}
function sha1$3(n) {
  var c = [1518500249, 1859775393, 2400959708, 3395469782], u = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
  if (typeof n == "string") {
    var p = unescape(encodeURIComponent(n));
    n = [];
    for (var a = 0; a < p.length; ++a)
      n.push(p.charCodeAt(a));
  } else Array.isArray(n) || (n = Array.prototype.slice.call(n));
  n.push(128);
  for (var A = n.length / 4 + 2, b = Math.ceil(A / 16), F = new Array(b), le = 0; le < b; ++le) {
    for (var L = new Uint32Array(16), pe = 0; pe < 16; ++pe)
      L[pe] = n[le * 64 + pe * 4] << 24 | n[le * 64 + pe * 4 + 1] << 16 | n[le * 64 + pe * 4 + 2] << 8 | n[le * 64 + pe * 4 + 3];
    F[le] = L;
  }
  F[b - 1][14] = (n.length - 1) * 8 / Math.pow(2, 32), F[b - 1][14] = Math.floor(F[b - 1][14]), F[b - 1][15] = (n.length - 1) * 8 & 4294967295;
  for (var $ = 0; $ < b; ++$) {
    for (var Ee = new Uint32Array(80), be = 0; be < 16; ++be)
      Ee[be] = F[$][be];
    for (var He = 16; He < 80; ++He)
      Ee[He] = ROTL$1(Ee[He - 3] ^ Ee[He - 8] ^ Ee[He - 14] ^ Ee[He - 16], 1);
    for (var Pe = u[0], nr = u[1], ir = u[2], or = u[3], lr = u[4], Ir = 0; Ir < 80; ++Ir) {
      var xr = Math.floor(Ir / 20), kr = ROTL$1(Pe, 5) + f$3(xr, nr, ir, or) + lr + c[xr] + Ee[Ir] >>> 0;
      lr = or, or = ir, ir = ROTL$1(nr, 30) >>> 0, nr = Pe, Pe = kr;
    }
    u[0] = u[0] + Pe >>> 0, u[1] = u[1] + nr >>> 0, u[2] = u[2] + ir >>> 0, u[3] = u[3] + or >>> 0, u[4] = u[4] + lr >>> 0;
  }
  return [u[0] >> 24 & 255, u[0] >> 16 & 255, u[0] >> 8 & 255, u[0] & 255, u[1] >> 24 & 255, u[1] >> 16 & 255, u[1] >> 8 & 255, u[1] & 255, u[2] >> 24 & 255, u[2] >> 16 & 255, u[2] >> 8 & 255, u[2] & 255, u[3] >> 24 & 255, u[3] >> 16 & 255, u[3] >> 8 & 255, u[3] & 255, u[4] >> 24 & 255, u[4] >> 16 & 255, u[4] >> 8 & 255, u[4] & 255];
}
var v5$3 = v35$3("v5", 80, sha1$3);
const nil$3 = "00000000-0000-0000-0000-000000000000";
function version$4(n) {
  if (!validate$4(n))
    throw TypeError("Invalid UUID");
  return parseInt(n.substr(14, 1), 16);
}
const esmBrowser$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  NIL: nil$3,
  parse: parse$a,
  stringify: stringify$3,
  v1: v1$3,
  v3: v3$3,
  v4: v4$4,
  v5: v5$3,
  validate: validate$4,
  version: version$4
}, Symbol.toStringTag, { value: "Module" })), require$$1$1 = /* @__PURE__ */ getAugmentedNamespace(esmBrowser$1);
var hasRequiredBcUrRegistryArweave_cjs_production_min;
function requireBcUrRegistryArweave_cjs_production_min() {
  return hasRequiredBcUrRegistryArweave_cjs_production_min || (hasRequiredBcUrRegistryArweave_cjs_production_min = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 });
    var c = requireDist$3(), u = require$$1$1;
    const p = { ARWEAVE_CRYPTO_ACCOUNT: new c.RegistryType("arweave-crypto-account", 5101), ARWEAVE_SIGN_REQUEST: new c.RegistryType("arweave-sign-request", 5102), ARWEAVE_SIGNATURE: new c.RegistryType("arweave-signature", 5103) }, { decodeToDataItem: a, RegistryTypes: A } = c.extend;
    var b, F, le;
    (b = n.SignType || (n.SignType = {}))[b.Transaction = 1] = "Transaction", b[b.DataItem = 2] = "DataItem", b[b.Message = 3] = "Message", (F = n.SaltLen || (n.SaltLen = {}))[F.Zero = 0] = "Zero", F[F.Digest = 32] = "Digest", function(ir) {
      ir[ir.masterFingerprint = 1] = "masterFingerprint", ir[ir.requestId = 2] = "requestId", ir[ir.signData = 3] = "signData", ir[ir.signType = 4] = "signType", ir[ir.saltLen = 5] = "saltLen", ir[ir.origin = 6] = "origin", ir[ir.account = 7] = "account";
    }(le || (le = {}));
    class L extends c.RegistryItem {
      constructor(or) {
        super(), this.getRegistryType = () => p.ARWEAVE_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getSignType = () => this.signType, this.getSaltLen = () => this.saltLen, this.getOrigin = () => this.origin, this.getAccount = () => this.account, this.getMasterFingerprint = () => this.masterFingerprint, this.toDataItem = () => {
          const lr = {};
          return this.requestId && (lr[le.requestId] = new c.DataItem(this.requestId, A.UUID.getTag())), this.account && (lr[le.account] = this.account), this.origin && (lr[le.origin] = this.origin), lr[le.masterFingerprint] = this.masterFingerprint.readUInt32BE(0), lr[le.signData] = this.signData, lr[le.signType] = this.signType, lr[le.saltLen] = this.saltLen, new c.DataItem(lr);
        }, this.masterFingerprint = or.masterFingerprint, this.requestId = or.requestId, this.signData = or.signData, this.signType = or.signType, this.saltLen = or.saltLen, this.origin = or.origin, this.account = or.account;
      }
      static constructArweaveRequest(or, lr, Ir, xr, kr, Ce, tr) {
        return new L({ masterFingerprint: Buffer$f.from(lr, "hex"), requestId: kr ? Buffer$f.from(u.parse(kr)) : void 0, signData: or, signType: Ir, saltLen: xr, account: Ce, origin: tr });
      }
    }
    L.fromDataItem = (ir) => {
      const or = ir.getData(), lr = or[le.signData], Ir = or[le.account] ? or[le.account] : void 0, xr = or[le.requestId] ? or[le.requestId].getData() : void 0, kr = or[le.origin] ? or[le.origin] : void 0, Ce = or[le.signType], tr = or[le.saltLen], Fe = Buffer$f.alloc(4);
      return Fe.writeUInt32BE(or[le.masterFingerprint], 0), new L({ masterFingerprint: Fe, requestId: xr, signData: lr, signType: Ce, saltLen: tr, origin: kr, account: Ir });
    }, L.fromCBOR = (ir) => {
      const or = a(ir);
      return L.fromDataItem(or);
    };
    const { RegistryTypes: pe, decodeToDataItem: $ } = c.extend;
    var Ee;
    (function(ir) {
      ir[ir.requestId = 1] = "requestId", ir[ir.signature = 2] = "signature";
    })(Ee || (Ee = {}));
    class be extends c.RegistryItem {
      constructor(or, lr) {
        super(), this.getRegistryType = () => p.ARWEAVE_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.toDataItem = () => {
          const Ir = {};
          return this.requestId && (Ir[Ee.requestId] = new c.DataItem(this.requestId, pe.UUID.getTag())), Ir[Ee.signature] = this.signature, new c.DataItem(Ir);
        }, this.signature = or, this.requestId = lr;
      }
    }
    be.fromDataItem = (ir) => {
      const or = ir.getData(), lr = or[Ee.signature], Ir = or[Ee.requestId] ? or[Ee.requestId].getData() : void 0;
      return new be(lr, Ir);
    }, be.fromCBOR = (ir) => {
      const or = $(ir);
      return be.fromDataItem(or);
    };
    const { decodeToDataItem: He } = c.extend;
    var Pe;
    (function(ir) {
      ir[ir.masterFingerprint = 1] = "masterFingerprint", ir[ir.keyData = 2] = "keyData", ir[ir.device = 3] = "device";
    })(Pe || (Pe = {}));
    class nr extends c.RegistryItem {
      constructor(or, lr, Ir) {
        super(), this.masterFingerprint = or, this.keyData = lr, this.device = Ir, this.getRegistryType = () => p.ARWEAVE_CRYPTO_ACCOUNT, this.getMasterFingerprint = () => this.masterFingerprint, this.getKeyData = () => this.keyData, this.getDevice = () => this.device, this.toDataItem = () => {
          const xr = {};
          return xr[Pe.masterFingerprint] = this.masterFingerprint.readUInt32BE(0), xr[Pe.keyData] = this.keyData, this.device && (xr[Pe.device] = this.device), new c.DataItem(xr);
        };
      }
    }
    nr.fromDataItem = (ir) => {
      const or = ir.getData(), lr = or[Pe.keyData], Ir = Buffer$f.alloc(4);
      return Ir.writeUInt32BE(or[Pe.masterFingerprint], 0), new nr(Ir, lr, or[Pe.device] ? or[Pe.device] : void 0);
    }, nr.fromCBOR = (ir) => {
      const or = He(ir);
      return nr.fromDataItem(or);
    }, c.patchTags(Object.values(p).filter((ir) => !!ir.getTag()).map((ir) => ir.getTag())), Object.keys(c).forEach(function(ir) {
      ir !== "default" && Object.defineProperty(n, ir, { enumerable: !0, get: function() {
        return c[ir];
      } });
    }), n.ArweaveCryptoAccount = nr, n.ArweaveSignRequest = L, n.ArweaveSignature = be;
  }(bcUrRegistryArweave_cjs_production_min)), bcUrRegistryArweave_cjs_production_min;
}
var bcUrRegistryArweave_cjs_development = {}, hasRequiredBcUrRegistryArweave_cjs_development;
function requireBcUrRegistryArweave_cjs_development() {
  return hasRequiredBcUrRegistryArweave_cjs_development || (hasRequiredBcUrRegistryArweave_cjs_development = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 });
    var c = requireDist$3(), u = require$$1$1;
    const p = {
      ARWEAVE_CRYPTO_ACCOUNT: /* @__PURE__ */ new c.RegistryType("arweave-crypto-account", 5101),
      ARWEAVE_SIGN_REQUEST: /* @__PURE__ */ new c.RegistryType("arweave-sign-request", 5102),
      ARWEAVE_SIGNATURE: /* @__PURE__ */ new c.RegistryType("arweave-signature", 5103)
    }, {
      decodeToDataItem: a,
      RegistryTypes: A
    } = c.extend;
    (function(Pe) {
      Pe[Pe.Transaction = 1] = "Transaction", Pe[Pe.DataItem = 2] = "DataItem", Pe[Pe.Message = 3] = "Message";
    })(n.SignType || (n.SignType = {})), function(Pe) {
      Pe[Pe.Zero = 0] = "Zero", Pe[Pe.Digest = 32] = "Digest";
    }(n.SaltLen || (n.SaltLen = {}));
    var b;
    (function(Pe) {
      Pe[Pe.masterFingerprint = 1] = "masterFingerprint", Pe[Pe.requestId = 2] = "requestId", Pe[Pe.signData = 3] = "signData", Pe[Pe.signType = 4] = "signType", Pe[Pe.saltLen = 5] = "saltLen", Pe[Pe.origin = 6] = "origin", Pe[Pe.account = 7] = "account";
    })(b || (b = {}));
    class F extends c.RegistryItem {
      constructor(nr) {
        super(), this.getRegistryType = () => p.ARWEAVE_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getSignType = () => this.signType, this.getSaltLen = () => this.saltLen, this.getOrigin = () => this.origin, this.getAccount = () => this.account, this.getMasterFingerprint = () => this.masterFingerprint, this.toDataItem = () => {
          const ir = {};
          return this.requestId && (ir[b.requestId] = new c.DataItem(this.requestId, A.UUID.getTag())), this.account && (ir[b.account] = this.account), this.origin && (ir[b.origin] = this.origin), ir[b.masterFingerprint] = this.masterFingerprint.readUInt32BE(0), ir[b.signData] = this.signData, ir[b.signType] = this.signType, ir[b.saltLen] = this.saltLen, new c.DataItem(ir);
        }, this.masterFingerprint = nr.masterFingerprint, this.requestId = nr.requestId, this.signData = nr.signData, this.signType = nr.signType, this.saltLen = nr.saltLen, this.origin = nr.origin, this.account = nr.account;
      }
      static constructArweaveRequest(nr, ir, or, lr, Ir, xr, kr) {
        return new F({
          masterFingerprint: Buffer$f.from(ir, "hex"),
          requestId: Ir ? Buffer$f.from(u.parse(Ir)) : void 0,
          signData: nr,
          signType: or,
          saltLen: lr,
          account: xr,
          origin: kr
        });
      }
    }
    F.fromDataItem = (Pe) => {
      const nr = Pe.getData(), ir = nr[b.signData], or = nr[b.account] ? nr[b.account] : void 0, lr = nr[b.requestId] ? nr[b.requestId].getData() : void 0, Ir = nr[b.origin] ? nr[b.origin] : void 0, xr = nr[b.signType], kr = nr[b.saltLen], Ce = Buffer$f.alloc(4), tr = nr[b.masterFingerprint];
      return Ce.writeUInt32BE(tr, 0), new F({
        masterFingerprint: Ce,
        requestId: lr,
        signData: ir,
        signType: xr,
        saltLen: kr,
        origin: Ir,
        account: or
      });
    }, F.fromCBOR = (Pe) => {
      const nr = a(Pe);
      return F.fromDataItem(nr);
    };
    const {
      RegistryTypes: le,
      decodeToDataItem: L
    } = c.extend;
    var pe;
    (function(Pe) {
      Pe[Pe.requestId = 1] = "requestId", Pe[Pe.signature = 2] = "signature";
    })(pe || (pe = {}));
    class $ extends c.RegistryItem {
      constructor(nr, ir) {
        super(), this.getRegistryType = () => p.ARWEAVE_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.toDataItem = () => {
          const or = {};
          return this.requestId && (or[pe.requestId] = new c.DataItem(this.requestId, le.UUID.getTag())), or[pe.signature] = this.signature, new c.DataItem(or);
        }, this.signature = nr, this.requestId = ir;
      }
    }
    $.fromDataItem = (Pe) => {
      const nr = Pe.getData(), ir = nr[pe.signature], or = nr[pe.requestId] ? nr[pe.requestId].getData() : void 0;
      return new $(ir, or);
    }, $.fromCBOR = (Pe) => {
      const nr = L(Pe);
      return $.fromDataItem(nr);
    };
    const {
      decodeToDataItem: Ee
    } = c.extend;
    var be;
    (function(Pe) {
      Pe[Pe.masterFingerprint = 1] = "masterFingerprint", Pe[Pe.keyData = 2] = "keyData", Pe[Pe.device = 3] = "device";
    })(be || (be = {}));
    class He extends c.RegistryItem {
      constructor(nr, ir, or) {
        super(), this.masterFingerprint = nr, this.keyData = ir, this.device = or, this.getRegistryType = () => p.ARWEAVE_CRYPTO_ACCOUNT, this.getMasterFingerprint = () => this.masterFingerprint, this.getKeyData = () => this.keyData, this.getDevice = () => this.device, this.toDataItem = () => {
          const lr = {};
          return lr[be.masterFingerprint] = this.masterFingerprint.readUInt32BE(0), lr[be.keyData] = this.keyData, this.device && (lr[be.device] = this.device), new c.DataItem(lr);
        };
      }
    }
    He.fromDataItem = (Pe) => {
      const nr = Pe.getData(), ir = nr[be.keyData], or = Buffer$f.alloc(4), lr = nr[be.masterFingerprint];
      or.writeUInt32BE(lr, 0);
      const Ir = nr[be.device] ? nr[be.device] : void 0;
      return new He(or, ir, Ir);
    }, He.fromCBOR = (Pe) => {
      const nr = Ee(Pe);
      return He.fromDataItem(nr);
    }, c.patchTags(Object.values(p).filter((Pe) => !!Pe.getTag()).map((Pe) => Pe.getTag())), Object.keys(c).forEach(function(Pe) {
      Pe !== "default" && Object.defineProperty(n, Pe, {
        enumerable: !0,
        get: function() {
          return c[Pe];
        }
      });
    }), n.ArweaveCryptoAccount = He, n.ArweaveSignRequest = F, n.ArweaveSignature = $;
  }(bcUrRegistryArweave_cjs_development)), bcUrRegistryArweave_cjs_development;
}
process$1.env.NODE_ENV === "production" ? dist$b.exports = requireBcUrRegistryArweave_cjs_production_min() : dist$b.exports = requireBcUrRegistryArweave_cjs_development();
var distExports$3 = dist$b.exports;
Object.defineProperty(arweave, "__esModule", { value: !0 });
arweave.KeystoneArweaveSDK = void 0;
const utils_1$d = utils$K, ur_1$3 = ur, bc_ur_registry_arweave_1 = distExports$3;
class KeystoneArweaveSDK {
  parseAccount(c) {
    if (c.type !== ur_1$3.URType.ArweaveCryptoAccount)
      throw new Error("type not match");
    const u = bc_ur_registry_arweave_1.ArweaveCryptoAccount.fromCBOR(c.cbor);
    return {
      masterFingerprint: (0, utils_1$d.toHex)(u.getMasterFingerprint()),
      keyData: (0, utils_1$d.toHex)(u.getKeyData()),
      device: u.getDevice()
    };
  }
  parseSignature(c) {
    if (c.type !== ur_1$3.URType.ArweaveSignature)
      throw new Error("type not match");
    const u = bc_ur_registry_arweave_1.ArweaveSignature.fromCBOR(c.cbor), p = u.getRequestId();
    return {
      requestId: (0, utils_1$d.uuidStringify)(p),
      signature: (0, utils_1$d.toHex)(u.getSignature())
    };
  }
  generateSignRequest({ requestId: c, signData: u, signType: p, saltLen: a, masterFingerprint: A, account: b, origin: F }) {
    return new bc_ur_registry_arweave_1.ArweaveSignRequest({
      requestId: (0, utils_1$d.uuidParse)(c),
      signData: (0, utils_1$d.toBuffer)(u),
      signType: p,
      saltLen: a,
      masterFingerprint: (0, utils_1$d.toBuffer)(A),
      account: b !== void 0 ? (0, utils_1$d.toBuffer)(b) : void 0,
      origin: F
    }).toUR();
  }
}
KeystoneArweaveSDK.SignType = bc_ur_registry_arweave_1.SignType;
KeystoneArweaveSDK.SaltLen = bc_ur_registry_arweave_1.SaltLen;
arweave.KeystoneArweaveSDK = KeystoneArweaveSDK;
var sui = {}, dist$9 = { exports: {} }, bcUrRegistrySui_cjs_production_min = {}, dist$8 = {}, patchCBOR$2 = {}, utils$7 = {}, lib$4 = {}, cborSync$2 = { exports: {} }, DataItem$2 = {}, hasRequiredDataItem$2;
function requireDataItem$2() {
  if (hasRequiredDataItem$2) return DataItem$2;
  hasRequiredDataItem$2 = 1, Object.defineProperty(DataItem$2, "__esModule", { value: !0 }), DataItem$2.DataItem = void 0;
  class n {
    constructor(u, p) {
      this.setTag = (a) => {
        this.tag = a;
      }, this.clearTag = () => {
        this.tag = void 0;
      }, this.getTag = () => this.tag, this.getData = () => this.data, this.data = u, this.tag = p;
    }
  }
  return DataItem$2.DataItem = n, DataItem$2;
}
var hasRequiredCborSync$2;
function requireCborSync$2() {
  return hasRequiredCborSync$2 || (hasRequiredCborSync$2 = 1, function(n) {
    (function(c, u) {
      n.exports ? n.exports = u() : c.CBOR = u();
    })(commonjsGlobal, function() {
      const { DataItem: c } = requireDataItem$2();
      var u = function() {
        function p(Ce) {
          this.$hex = Ce;
        }
        p.prototype = {
          length: function() {
            return this.$hex.length / 2;
          },
          toString: function(Ce) {
            if (!Ce || Ce === "hex" || Ce === 16)
              return this.$hex;
            if (Ce === "utf-8") {
              for (var tr = "", Fe = 0; Fe < this.$hex.length; Fe += 2)
                tr += "%" + this.$hex.substring(Fe, Fe + 2);
              return decodeURIComponent(tr);
            }
            if (Ce === "latin") {
              for (var tr = [], Fe = 0; Fe < this.$hex.length; Fe += 2)
                tr.push(parseInt(this.$hex.substring(Fe, Fe + 2), 16));
              return String.fromCharCode.apply(String, tr);
            }
            throw new Error("Unrecognised format: " + Ce);
          }
        }, p.fromLatinString = function(Ce) {
          for (var tr = "", Fe = 0; Fe < Ce.length; Fe++) {
            var Sr = Ce.charCodeAt(Fe).toString(16);
            Sr.length === 1 && (Sr = "0" + Sr), tr += Sr;
          }
          return new p(tr);
        }, p.fromUtf8String = function(Ce) {
          for (var tr = encodeURIComponent(Ce), Fe = "", Sr = 0; Sr < tr.length; Sr++)
            if (tr.charAt(Sr) === "%")
              Fe += tr.substring(Sr + 1, Sr + 3), Sr += 2;
            else {
              var er = tr.charCodeAt(Sr).toString(16);
              er.length < 2 && (er = "0" + er), Fe += er;
            }
          return new p(Fe);
        };
        var a = [], A = {}, b = function(Ce) {
          return function() {
            throw new Error(Ce + " not implemented");
          };
        };
        function F() {
        }
        F.prototype = {
          peekByte: b("peekByte"),
          readByte: b("readByte"),
          readChunk: b("readChunk"),
          readFloat16: function() {
            var Ce = this.readUint16(), tr = (Ce & 32767) >> 10, Fe = Ce & 1023, Sr = Ce & 32768;
            if (tr === 31)
              return Fe === 0 ? Sr ? -1 / 0 : 1 / 0 : NaN;
            var er = tr ? Math.pow(2, tr - 25) * (1024 + Fe) : Math.pow(2, -24) * Fe;
            return Sr ? -er : er;
          },
          readFloat32: function() {
            var Ce = this.readUint32(), tr = (Ce & 2147483647) >> 23, Fe = Ce & 8388607, Sr = Ce & 2147483648;
            if (tr === 255)
              return Fe === 0 ? Sr ? -1 / 0 : 1 / 0 : NaN;
            var er = tr ? Math.pow(2, tr - 23 - 127) * (8388608 + Fe) : Math.pow(2, -149) * Fe;
            return Sr ? -er : er;
          },
          readFloat64: function() {
            var Ce = this.readUint32(), tr = this.readUint32(), Fe = Ce >> 20 & 2047, Sr = (Ce & 1048575) * 4294967296 + tr, er = Ce & 2147483648;
            if (Fe === 2047)
              return Sr === 0 ? er ? -1 / 0 : 1 / 0 : NaN;
            var Ie = Fe ? Math.pow(2, Fe - 52 - 1023) * (4503599627370496 + Sr) : Math.pow(2, -1074) * Sr;
            return er ? -Ie : Ie;
          },
          readUint16: function() {
            return this.readByte() * 256 + this.readByte();
          },
          readUint32: function() {
            return this.readUint16() * 65536 + this.readUint16();
          },
          readUint64: function() {
            return this.readUint32() * 4294967296 + this.readUint32();
          }
        };
        function le() {
        }
        le.prototype = {
          writeByte: b("writeByte"),
          result: b("result"),
          writeFloat16: b("writeFloat16"),
          writeFloat32: b("writeFloat32"),
          writeFloat64: b("writeFloat64"),
          writeUint16: function(Ce) {
            this.writeByte(Ce >> 8 & 255), this.writeByte(Ce & 255);
          },
          writeUint32: function(Ce) {
            this.writeUint16(Ce >> 16 & 65535), this.writeUint16(Ce & 65535);
          },
          writeUint64: function(Ce) {
            if (Ce >= 9007199254740992 || Ce <= -9007199254740992)
              throw new Error("Cannot encode Uint64 of: " + Ce + " magnitude to big (floating point errors)");
            this.writeUint32(Math.floor(Ce / 4294967296)), this.writeUint32(Ce % 4294967296);
          },
          writeString: b("writeString"),
          canWriteBinary: function(Ce) {
            return !1;
          },
          writeBinary: b("writeChunk")
        };
        function L(Ce) {
          var tr = Ce.readByte(), Fe = tr >> 5, Sr = tr & 31;
          return { type: Fe, value: Sr };
        }
        function pe(Ce, tr) {
          var Fe = Ce.value;
          if (Fe < 24)
            return Fe;
          if (Fe == 24)
            return tr.readByte();
          if (Fe == 25)
            return tr.readUint16();
          if (Fe == 26)
            return tr.readUint32();
          if (Fe == 27)
            return tr.readUint64();
          if (Fe == 31)
            return null;
          b("Additional info: " + Fe)();
        }
        function $(Ce, tr, Fe) {
          Fe.writeByte(Ce << 5 | tr);
        }
        function Ee(Ce, tr, Fe) {
          var Sr = Ce << 5;
          tr < 24 ? Fe.writeByte(Sr | tr) : tr < 256 ? (Fe.writeByte(Sr | 24), Fe.writeByte(tr)) : tr < 65536 ? (Fe.writeByte(Sr | 25), Fe.writeUint16(tr)) : tr < 4294967296 ? (Fe.writeByte(Sr | 26), Fe.writeUint32(tr)) : (Fe.writeByte(Sr | 27), Fe.writeUint64(tr));
        }
        var be = new Error();
        function He(Ce) {
          var tr = L(Ce);
          switch (tr.type) {
            case 0:
              return pe(tr, Ce);
            case 1:
              return -1 - pe(tr, Ce);
            case 2:
              return Ce.readChunk(pe(tr, Ce));
            case 3:
              var Fe = Ce.readChunk(pe(tr, Ce));
              return Fe.toString("utf-8");
            case 4:
            case 5:
              var Sr = pe(tr, Ce), yr = [];
              if (Sr !== null) {
                tr.type === 5 && (Sr *= 2);
                for (var er = 0; er < Sr; er++)
                  yr[er] = He(Ce);
              } else
                for (var Ie; (Ie = He(Ce)) !== be; )
                  yr.push(Ie);
              if (tr.type === 5) {
                for (var xe = {}, er = 0; er < yr.length; er += 2)
                  xe[yr[er]] = yr[er + 1];
                return xe;
              } else
                return yr;
            case 6:
              var rr = pe(tr, Ce), ar = A[rr], yr = He(Ce);
              return ar ? ar(yr) : yr;
            case 7:
              if (tr.value === 25)
                return Ce.readFloat16();
              if (tr.value === 26)
                return Ce.readFloat32();
              if (tr.value === 27)
                return Ce.readFloat64();
              switch (pe(tr, Ce)) {
                case 20:
                  return !1;
                case 21:
                  return !0;
                case 22:
                  return null;
                case 23:
                  return;
                case null:
                  return be;
                default:
                  throw new Error("Unknown fixed value: " + tr.value);
              }
            default:
              throw new Error("Unsupported header: " + JSON.stringify(tr));
          }
          throw new Error("not implemented yet");
        }
        function Pe(Ce, tr) {
          for (var Fe = 0; Fe < a.length; Fe++) {
            var Sr = a[Fe].fn(Ce);
            if (Sr !== void 0)
              return Ee(6, a[Fe].tag, tr), Pe(Sr, tr);
          }
          if (Ce && typeof Ce.toCBOR == "function" && (Ce = Ce.toCBOR()), Ce === !1)
            Ee(7, 20, tr);
          else if (Ce === !0)
            Ee(7, 21, tr);
          else if (Ce === null)
            Ee(7, 22, tr);
          else if (Ce === void 0)
            Ee(7, 23, tr);
          else if (typeof Ce == "number")
            Math.floor(Ce) === Ce && Ce < 9007199254740992 && Ce > -9007199254740992 ? Ce < 0 ? Ee(1, -1 - Ce, tr) : Ee(0, Ce, tr) : ($(7, 27, tr), tr.writeFloat64(Ce));
          else if (typeof Ce == "string")
            tr.writeString(Ce, function(Ie) {
              Ee(3, Ie, tr);
            });
          else if (tr.canWriteBinary(Ce))
            tr.writeBinary(Ce, function(Ie) {
              Ee(2, Ie, tr);
            });
          else if (typeof Ce == "object")
            if (or.config.useToJSON && typeof Ce.toJSON == "function" && (Ce = Ce.toJSON()), Array.isArray(Ce)) {
              Ee(4, Ce.length, tr);
              for (var Fe = 0; Fe < Ce.length; Fe++)
                Pe(Ce[Fe], tr);
            } else {
              var er = Object.keys(Ce);
              Ee(5, er.length, tr);
              for (var Fe = 0; Fe < er.length; Fe++) {
                const xe = parseInt(er[Fe]);
                isNaN(xe) ? (Pe(er[Fe], tr), Pe(Ce[er[Fe]], tr)) : (Pe(xe, tr), Pe(Ce[er[Fe]], tr));
              }
            }
          else
            throw new Error("CBOR encoding not supported: " + Ce);
        }
        var nr = [], ir = [], or = {
          config: {
            useToJSON: !0
          },
          addWriter: function(Ce, tr) {
            typeof Ce == "string" ? ir.push(function(Fe) {
              if (Ce === Fe)
                return tr(Fe);
            }) : ir.push(Ce);
          },
          addReader: function(Ce, tr) {
            typeof Ce == "string" ? nr.push(function(Fe, Sr) {
              if (Ce === Sr)
                return tr(Fe, Sr);
            }) : nr.push(Ce);
          },
          encode: function(Ce, tr) {
            for (var Fe = 0; Fe < ir.length; Fe++) {
              var Sr = ir[Fe], er = Sr(tr);
              if (er)
                return Pe(Ce, er), er.result();
            }
            throw new Error("Unsupported output format: " + tr);
          },
          encodeDataItem: function(Ce, tr) {
            for (var Fe = 0; Fe < ir.length; Fe++) {
              var Sr = ir[Fe], er = Sr(tr);
              if (er)
                return Ce.getTag() !== void 0 ? (Pe(Ce, er), er.result()) : (Pe(Ce.getData(), er), er.result());
            }
            throw new Error("Unsupported output format: " + tr);
          },
          decode: function(Ce, tr) {
            for (var Fe = 0; Fe < nr.length; Fe++) {
              var Sr = nr[Fe], er = Sr(Ce, tr);
              if (er)
                return He(er);
            }
            throw new Error("Unsupported input format: " + tr);
          },
          decodeToDataItem: function(Ce, tr) {
            for (var Fe = 0; Fe < nr.length; Fe++) {
              var Sr = nr[Fe], er = Sr(Ce, tr);
              if (er) {
                const Ie = He(er);
                return Ie instanceof c ? Ie : new c(Ie);
              }
            }
            throw new Error("Unsupported input format: " + tr);
          },
          addSemanticEncode: function(Ce, tr) {
            if (typeof Ce != "number" || Ce % 1 !== 0 || Ce < 0)
              throw new Error("Tag must be a positive integer");
            return a.push({ tag: Ce, fn: tr }), this;
          },
          addSemanticDecode: function(Ce, tr) {
            if (typeof Ce != "number" || Ce % 1 !== 0 || Ce < 0)
              throw new Error("Tag must be a positive integer");
            return A[Ce] = tr, this;
          }
        };
        function lr(Ce) {
          this.buffer = Ce, this.pos = 0;
        }
        lr.prototype = Object.create(F.prototype), lr.prototype.peekByte = function() {
          return this.buffer[this.pos];
        }, lr.prototype.readByte = function() {
          return this.buffer[this.pos++];
        }, lr.prototype.readUint16 = function() {
          var Ce = this.buffer.readUInt16BE(this.pos);
          return this.pos += 2, Ce;
        }, lr.prototype.readUint32 = function() {
          var Ce = this.buffer.readUInt32BE(this.pos);
          return this.pos += 4, Ce;
        }, lr.prototype.readFloat32 = function() {
          var Ce = this.buffer.readFloatBE(this.pos);
          return this.pos += 4, Ce;
        }, lr.prototype.readFloat64 = function() {
          var Ce = this.buffer.readDoubleBE(this.pos);
          return this.pos += 8, Ce;
        }, lr.prototype.readChunk = function(Ce) {
          var tr = Buffer$f.alloc(Ce);
          return this.buffer.copy(tr, 0, this.pos, this.pos += Ce), tr;
        };
        function Ir(Ce) {
          this.byteLength = 0, this.defaultBufferLength = 16384, this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0, this.completeBuffers = [], this.stringFormat = Ce;
        }
        Ir.prototype = Object.create(le.prototype), Ir.prototype.writeByte = function(Ce) {
          this.latestBuffer[this.latestBufferOffset++] = Ce, this.latestBufferOffset >= this.latestBuffer.length && (this.completeBuffers.push(this.latestBuffer), this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0), this.byteLength++;
        }, Ir.prototype.writeFloat32 = function(Ce) {
          var tr = Buffer$f.alloc(4);
          tr.writeFloatBE(Ce, 0), this.writeBuffer(tr);
        }, Ir.prototype.writeFloat64 = function(Ce) {
          var tr = Buffer$f.alloc(8);
          tr.writeDoubleBE(Ce, 0), this.writeBuffer(tr);
        }, Ir.prototype.writeString = function(Ce, tr) {
          var Fe = Buffer$f.from(Ce, "utf-8");
          tr(Fe.length), this.writeBuffer(Fe);
        }, Ir.prototype.canWriteBinary = function(Ce) {
          return Ce instanceof Buffer$f;
        }, Ir.prototype.writeBinary = function(Ce, tr) {
          tr(Ce.length), this.writeBuffer(Ce);
        }, Ir.prototype.writeBuffer = function(Ce) {
          if (!(Ce instanceof Buffer$f))
            throw new TypeError("BufferWriter only accepts Buffers");
          this.latestBufferOffset ? this.latestBuffer.length - this.latestBufferOffset >= Ce.length ? (Ce.copy(this.latestBuffer, this.latestBufferOffset), this.latestBufferOffset += Ce.length, this.latestBufferOffset >= this.latestBuffer.length && (this.completeBuffers.push(this.latestBuffer), this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0)) : (this.completeBuffers.push(this.latestBuffer.slice(0, this.latestBufferOffset)), this.completeBuffers.push(Ce), this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0) : this.completeBuffers.push(Ce), this.byteLength += Ce.length;
        }, Ir.prototype.result = function() {
          for (var Ce = Buffer$f.alloc(this.byteLength), tr = 0, Fe = 0; Fe < this.completeBuffers.length; Fe++) {
            var Sr = this.completeBuffers[Fe];
            Sr.copy(Ce, tr, 0, Sr.length), tr += Sr.length;
          }
          return this.latestBufferOffset && this.latestBuffer.copy(Ce, tr, 0, this.latestBufferOffset), this.stringFormat ? Ce.toString(this.stringFormat) : Ce;
        }, typeof Buffer$f == "function" && (or.addReader(function(Ce, tr) {
          if (Buffer$f.isBuffer(Ce))
            return new lr(Ce);
          if (tr === "hex" || tr === "base64") {
            var Fe = Buffer$f.from(Ce, tr);
            return new lr(Fe);
          }
        }), or.addWriter(function(Ce) {
          if (!Ce || Ce === "buffer")
            return new Ir();
          if (Ce === "hex" || Ce === "base64")
            return new Ir(Ce);
        }));
        function xr(Ce) {
          this.hex = Ce, this.pos = 0;
        }
        xr.prototype = Object.create(F.prototype), xr.prototype.peekByte = function() {
          var Ce = this.hex.substring(this.pos, 2);
          return parseInt(Ce, 16);
        }, xr.prototype.readByte = function() {
          var Ce = this.hex.substring(this.pos, this.pos + 2);
          return this.pos += 2, parseInt(Ce, 16);
        }, xr.prototype.readChunk = function(Ce) {
          var tr = this.hex.substring(this.pos, this.pos + Ce * 2);
          return this.pos += Ce * 2, typeof Buffer$f == "function" ? Buffer$f.from(tr, "hex") : new p(tr);
        };
        function kr(Ce) {
          this.$hex = "", this.finalFormat = Ce || "hex";
        }
        return kr.prototype = Object.create(le.prototype), kr.prototype.writeByte = function(Ce) {
          if (Ce < 0 || Ce > 255)
            throw new Error("Byte value out of range: " + Ce);
          var tr = Ce.toString(16);
          tr.length == 1 && (tr = "0" + tr), this.$hex += tr;
        }, kr.prototype.canWriteBinary = function(Ce) {
          return Ce instanceof p || typeof Buffer$f == "function" && Ce instanceof Buffer$f;
        }, kr.prototype.writeBinary = function(Ce, tr) {
          if (Ce instanceof p)
            tr(Ce.length()), this.$hex += Ce.$hex;
          else if (typeof Buffer$f == "function" && Ce instanceof Buffer$f)
            tr(Ce.length), this.$hex += Ce.toString("hex");
          else
            throw new TypeError("HexWriter only accepts BinaryHex or Buffers");
        }, kr.prototype.result = function() {
          return this.finalFormat === "buffer" && typeof Buffer$f == "function" ? Buffer$f.from(this.$hex, "hex") : new p(this.$hex).toString(this.finalFormat);
        }, kr.prototype.writeString = function(Ce, tr) {
          var Fe = p.fromUtf8String(Ce);
          tr(Fe.length()), this.$hex += Fe.$hex;
        }, or.addReader(function(Ce, tr) {
          if (Ce instanceof p || Ce.$hex)
            return new xr(Ce.$hex);
          if (tr === "hex")
            return new xr(Ce);
        }), or.addWriter(function(Ce) {
          if (Ce === "hex")
            return new kr();
        }), or;
      }();
      return u.addSemanticEncode(0, function(p) {
        if (p instanceof Date)
          return p.toISOString();
      }).addSemanticDecode(0, function(p) {
        return new Date(p);
      }).addSemanticDecode(1, function(p) {
        return new Date(p);
      }), u;
    });
  }(cborSync$2)), cborSync$2.exports;
}
var hasRequiredLib$2;
function requireLib$2() {
  return hasRequiredLib$2 || (hasRequiredLib$2 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.DataItem = n.addWriter = n.addReader = n.addSemanticEncode = n.addSemanticDecode = n.decodeToDataItem = n.encodeDataItem = void 0;
    var c = requireCborSync$2();
    Object.defineProperty(n, "encodeDataItem", { enumerable: !0, get: function() {
      return c.encodeDataItem;
    } }), Object.defineProperty(n, "decodeToDataItem", { enumerable: !0, get: function() {
      return c.decodeToDataItem;
    } }), Object.defineProperty(n, "addSemanticDecode", { enumerable: !0, get: function() {
      return c.addSemanticDecode;
    } }), Object.defineProperty(n, "addSemanticEncode", { enumerable: !0, get: function() {
      return c.addSemanticEncode;
    } }), Object.defineProperty(n, "addReader", { enumerable: !0, get: function() {
      return c.addReader;
    } }), Object.defineProperty(n, "addWriter", { enumerable: !0, get: function() {
      return c.addWriter;
    } });
    var u = requireDataItem$2();
    Object.defineProperty(n, "DataItem", { enumerable: !0, get: function() {
      return u.DataItem;
    } });
  }(lib$4)), lib$4;
}
var hasRequiredUtils$2;
function requireUtils$2() {
  if (hasRequiredUtils$2) return utils$7;
  hasRequiredUtils$2 = 1, Object.defineProperty(utils$7, "__esModule", { value: !0 }), utils$7.patchTags = void 0;
  const n = requireLib$2(), c = [], u = (p) => {
    p.forEach((a) => {
      c.find((A) => A === a) || ((0, n.addSemanticEncode)(a, (A) => {
        if (A instanceof n.DataItem && A.getTag() === a)
          return A.getData();
      }), (0, n.addSemanticDecode)(a, (A) => new n.DataItem(A, a)), c.push(a));
    });
  };
  return utils$7.patchTags = u, utils$7;
}
var RegistryType$2 = {}, hasRequiredRegistryType$2;
function requireRegistryType$2() {
  if (hasRequiredRegistryType$2) return RegistryType$2;
  hasRequiredRegistryType$2 = 1, Object.defineProperty(RegistryType$2, "__esModule", { value: !0 }), RegistryType$2.RegistryTypes = RegistryType$2.RegistryType = void 0;
  class n {
    constructor(u, p) {
      this.type = u, this.tag = p, this.getTag = () => this.tag, this.getType = () => this.type;
    }
  }
  return RegistryType$2.RegistryType = n, RegistryType$2.RegistryTypes = {
    UUID: new n("uuid", 37),
    BYTES: new n("bytes", void 0),
    CRYPTO_HDKEY: new n("crypto-hdkey", 303),
    CRYPTO_KEYPATH: new n("crypto-keypath", 304),
    CRYPTO_COIN_INFO: new n("crypto-coin-info", 305),
    CRYPTO_ECKEY: new n("crypto-eckey", 306),
    CRYPTO_OUTPUT: new n("crypto-output", 308),
    CRYPTO_PSBT: new n("crypto-psbt", 310),
    CRYPTO_ACCOUNT: new n("crypto-account", 311),
    CRYPTO_MULTI_ACCOUNTS: new n("crypto-multi-accounts", 1103),
    QR_HARDWARE_CALL: new n("qr-hardware-call", 1201),
    KEY_DERIVATION_CALL: new n("key-derivation-call", 1301),
    KEY_DERIVATION_SCHEMA: new n("key-derivation-schema", 1302)
  }, RegistryType$2;
}
var ScriptExpression$2 = {}, hasRequiredScriptExpression$2;
function requireScriptExpression$2() {
  return hasRequiredScriptExpression$2 || (hasRequiredScriptExpression$2 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.ScriptExpressions = n.ScriptExpression = void 0;
    class c {
      constructor(p, a) {
        this.tag = p, this.expression = a, this.getTag = () => this.tag, this.getExpression = () => this.expression;
      }
    }
    n.ScriptExpression = c, c.fromTag = (u) => Object.values(n.ScriptExpressions).find((a) => a.getTag() === u), n.ScriptExpressions = {
      SCRIPT_HASH: new c(400, "sh"),
      WITNESS_SCRIPT_HASH: new c(401, "wsh"),
      PUBLIC_KEY: new c(402, "pk"),
      PUBLIC_KEY_HASH: new c(403, "pkh"),
      WITNESS_PUBLIC_KEY_HASH: new c(404, "wpkh"),
      COMBO: new c(405, "combo"),
      MULTISIG: new c(406, "multi"),
      SORTED_MULTISIG: new c(407, "sortedmulti"),
      ADDRESS: new c(307, "addr"),
      RAW_SCRIPT: new c(408, "raw")
    };
  }(ScriptExpression$2)), ScriptExpression$2;
}
var hasRequiredPatchCBOR$2;
function requirePatchCBOR$2() {
  if (hasRequiredPatchCBOR$2) return patchCBOR$2;
  hasRequiredPatchCBOR$2 = 1, Object.defineProperty(patchCBOR$2, "__esModule", { value: !0 });
  const n = requireUtils$2(), c = requireRegistryType$2(), u = requireScriptExpression$2(), p = Object.values(c.RegistryTypes).filter((A) => !!A.getTag()).map((A) => A.getTag()), a = Object.values(u.ScriptExpressions).map((A) => A.getTag());
  return (0, n.patchTags)(p.concat(a)), patchCBOR$2;
}
var CryptoHDKey$2 = {}, src$6, hasRequiredSrc$2;
function requireSrc$2() {
  if (hasRequiredSrc$2) return src$6;
  hasRequiredSrc$2 = 1;
  var n = safeBufferExports.Buffer;
  function c(u) {
    if (u.length >= 255)
      throw new TypeError("Alphabet too long");
    for (var p = new Uint8Array(256), a = 0; a < p.length; a++)
      p[a] = 255;
    for (var A = 0; A < u.length; A++) {
      var b = u.charAt(A), F = b.charCodeAt(0);
      if (p[F] !== 255)
        throw new TypeError(b + " is ambiguous");
      p[F] = A;
    }
    var le = u.length, L = u.charAt(0), pe = Math.log(le) / Math.log(256), $ = Math.log(256) / Math.log(le);
    function Ee(Pe) {
      if ((Array.isArray(Pe) || Pe instanceof Uint8Array) && (Pe = n.from(Pe)), !n.isBuffer(Pe))
        throw new TypeError("Expected Buffer");
      if (Pe.length === 0)
        return "";
      for (var nr = 0, ir = 0, or = 0, lr = Pe.length; or !== lr && Pe[or] === 0; )
        or++, nr++;
      for (var Ir = (lr - or) * $ + 1 >>> 0, xr = new Uint8Array(Ir); or !== lr; ) {
        for (var kr = Pe[or], Ce = 0, tr = Ir - 1; (kr !== 0 || Ce < ir) && tr !== -1; tr--, Ce++)
          kr += 256 * xr[tr] >>> 0, xr[tr] = kr % le >>> 0, kr = kr / le >>> 0;
        if (kr !== 0)
          throw new Error("Non-zero carry");
        ir = Ce, or++;
      }
      for (var Fe = Ir - ir; Fe !== Ir && xr[Fe] === 0; )
        Fe++;
      for (var Sr = L.repeat(nr); Fe < Ir; ++Fe)
        Sr += u.charAt(xr[Fe]);
      return Sr;
    }
    function be(Pe) {
      if (typeof Pe != "string")
        throw new TypeError("Expected String");
      if (Pe.length === 0)
        return n.alloc(0);
      for (var nr = 0, ir = 0, or = 0; Pe[nr] === L; )
        ir++, nr++;
      for (var lr = (Pe.length - nr) * pe + 1 >>> 0, Ir = new Uint8Array(lr); nr < Pe.length; ) {
        var xr = Pe.charCodeAt(nr);
        if (xr > 255)
          return;
        var kr = p[xr];
        if (kr === 255)
          return;
        for (var Ce = 0, tr = lr - 1; (kr !== 0 || Ce < or) && tr !== -1; tr--, Ce++)
          kr += le * Ir[tr] >>> 0, Ir[tr] = kr % 256 >>> 0, kr = kr / 256 >>> 0;
        if (kr !== 0)
          throw new Error("Non-zero carry");
        or = Ce, nr++;
      }
      for (var Fe = lr - or; Fe !== lr && Ir[Fe] === 0; )
        Fe++;
      var Sr = n.allocUnsafe(ir + (lr - Fe));
      Sr.fill(0, 0, ir);
      for (var er = ir; Fe !== lr; )
        Sr[er++] = Ir[Fe++];
      return Sr;
    }
    function He(Pe) {
      var nr = be(Pe);
      if (nr)
        return nr;
      throw new Error("Non-base" + le + " character");
    }
    return {
      encode: Ee,
      decodeUnsafe: be,
      decode: He
    };
  }
  return src$6 = c, src$6;
}
var bs58$3, hasRequiredBs58$2;
function requireBs58$2() {
  if (hasRequiredBs58$2) return bs58$3;
  hasRequiredBs58$2 = 1;
  var n = requireSrc$2(), c = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
  return bs58$3 = n(c), bs58$3;
}
var base$5, hasRequiredBase$2;
function requireBase$2() {
  if (hasRequiredBase$2) return base$5;
  hasRequiredBase$2 = 1;
  var n = requireBs58$2(), c = safeBufferExports.Buffer;
  return base$5 = function(u) {
    function p(F) {
      var le = u(F);
      return n.encode(c.concat([
        F,
        le
      ], F.length + 4));
    }
    function a(F) {
      var le = F.slice(0, -4), L = F.slice(-4), pe = u(le);
      if (!(L[0] ^ pe[0] | L[1] ^ pe[1] | L[2] ^ pe[2] | L[3] ^ pe[3]))
        return le;
    }
    function A(F) {
      var le = n.decodeUnsafe(F);
      if (le)
        return a(le);
    }
    function b(F) {
      var le = n.decode(F), L = a(le);
      if (!L) throw new Error("Invalid checksum");
      return L;
    }
    return {
      encode: p,
      decode: b,
      decodeUnsafe: A
    };
  }, base$5;
}
var bs58check$5, hasRequiredBs58check$2;
function requireBs58check$2() {
  if (hasRequiredBs58check$2) return bs58check$5;
  hasRequiredBs58check$2 = 1;
  var n = browser$a, c = requireBase$2();
  function u(p) {
    var a = n("sha256").update(p).digest();
    return n("sha256").update(a).digest();
  }
  return bs58check$5 = c(u), bs58check$5;
}
var CryptoCoinInfo$2 = {}, RegistryItem$2 = {}, hasRequiredRegistryItem$2;
function requireRegistryItem$2() {
  if (hasRequiredRegistryItem$2) return RegistryItem$2;
  hasRequiredRegistryItem$2 = 1, Object.defineProperty(RegistryItem$2, "__esModule", { value: !0 }), RegistryItem$2.RegistryItem = void 0;
  const n = dist$t, c = requireLib$2();
  class u {
    constructor() {
      this.toCBOR = () => {
        if (this.toDataItem() === void 0)
          throw new Error(`#[ur-registry][RegistryItem][fn.toCBOR]: registry ${this.getRegistryType()}'s method toDataItem returns undefined`);
        return (0, c.encodeDataItem)(this.toDataItem());
      }, this.toUR = () => new n.UR(this.toCBOR(), this.getRegistryType().getType()), this.toUREncoder = (a, A, b) => {
        const F = this.toUR();
        return new n.UREncoder(F, a, A, b);
      };
    }
  }
  return RegistryItem$2.RegistryItem = u, RegistryItem$2;
}
var hasRequiredCryptoCoinInfo$2;
function requireCryptoCoinInfo$2() {
  return hasRequiredCryptoCoinInfo$2 || (hasRequiredCryptoCoinInfo$2 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.CryptoCoinInfo = n.Network = n.Type = void 0;
    const c = requireLib$2(), u = requireRegistryItem$2(), p = requireRegistryType$2();
    var a;
    (function(le) {
      le.type = "1", le.network = "2";
    })(a || (a = {}));
    var A;
    (function(le) {
      le[le.bitcoin = 0] = "bitcoin";
    })(A = n.Type || (n.Type = {}));
    var b;
    (function(le) {
      le[le.mainnet = 0] = "mainnet", le[le.testnet = 1] = "testnet";
    })(b = n.Network || (n.Network = {}));
    class F extends u.RegistryItem {
      constructor(L, pe) {
        super(), this.type = L, this.network = pe, this.getRegistryType = () => p.RegistryTypes.CRYPTO_COIN_INFO, this.getType = () => this.type || A.bitcoin, this.getNetwork = () => this.network || b.mainnet, this.toDataItem = () => {
          const $ = {};
          return this.type && ($[a.type] = this.type), this.network && ($[a.network] = this.network), new c.DataItem($);
        };
      }
    }
    n.CryptoCoinInfo = F, F.fromDataItem = (le) => {
      const L = le.getData(), pe = L[a.type], $ = L[a.network];
      return new F(pe, $);
    }, F.fromCBOR = (le) => {
      const L = (0, c.decodeToDataItem)(le);
      return F.fromDataItem(L);
    };
  }(CryptoCoinInfo$2)), CryptoCoinInfo$2;
}
var CryptoKeypath$2 = {}, PathComponent$2 = {}, hasRequiredPathComponent$2;
function requirePathComponent$2() {
  if (hasRequiredPathComponent$2) return PathComponent$2;
  hasRequiredPathComponent$2 = 1, Object.defineProperty(PathComponent$2, "__esModule", { value: !0 }), PathComponent$2.PathComponent = void 0;
  class n {
    constructor(u) {
      if (this.getIndex = () => this.index, this.isWildcard = () => this.wildcard, this.isHardened = () => this.hardened, this.index = u.index, this.hardened = u.hardened, this.index !== void 0 ? this.wildcard = !1 : this.wildcard = !0, this.index && this.index & n.HARDENED_BIT)
        throw new Error(`#[ur-registry][PathComponent][fn.constructor]: Invalid index ${this.index} - most significant bit cannot be set`);
    }
  }
  return PathComponent$2.PathComponent = n, n.HARDENED_BIT = 2147483648, PathComponent$2;
}
var hasRequiredCryptoKeypath$2;
function requireCryptoKeypath$2() {
  if (hasRequiredCryptoKeypath$2) return CryptoKeypath$2;
  hasRequiredCryptoKeypath$2 = 1, Object.defineProperty(CryptoKeypath$2, "__esModule", { value: !0 }), CryptoKeypath$2.CryptoKeypath = void 0;
  const n = requireLib$2(), c = requirePathComponent$2(), u = requireRegistryItem$2(), p = requireRegistryType$2();
  var a;
  (function(b) {
    b[b.components = 1] = "components", b[b.source_fingerprint = 2] = "source_fingerprint", b[b.depth = 3] = "depth";
  })(a || (a = {}));
  class A extends u.RegistryItem {
    constructor(F = [], le, L) {
      super(), this.components = F, this.sourceFingerprint = le, this.depth = L, this.getRegistryType = () => p.RegistryTypes.CRYPTO_KEYPATH, this.getPath = () => this.components.length === 0 ? void 0 : this.components.map(($) => `${$.isWildcard() ? "*" : $.getIndex()}${$.isHardened() ? "'" : ""}`).join("/"), this.getComponents = () => this.components, this.getSourceFingerprint = () => this.sourceFingerprint, this.getDepth = () => this.depth, this.toDataItem = () => {
        const pe = {}, $ = [];
        return this.components && this.components.forEach((Ee) => {
          Ee.isWildcard() ? $.push([]) : $.push(Ee.getIndex()), $.push(Ee.isHardened());
        }), pe[a.components] = $, this.sourceFingerprint && (pe[a.source_fingerprint] = this.sourceFingerprint.readUInt32BE(0)), this.depth !== void 0 && (pe[a.depth] = this.depth), new n.DataItem(pe);
      };
    }
  }
  return CryptoKeypath$2.CryptoKeypath = A, A.fromDataItem = (b) => {
    const F = b.getData(), le = [], L = F[a.components];
    if (L)
      for (let be = 0; be < L.length; be += 2) {
        const He = L[be + 1], Pe = L[be];
        typeof Pe == "number" ? le.push(new c.PathComponent({ index: Pe, hardened: He })) : le.push(new c.PathComponent({ hardened: He }));
      }
    const pe = F[a.source_fingerprint];
    let $;
    pe && ($ = Buffer$f.alloc(4), $.writeUInt32BE(pe, 0));
    const Ee = F[a.depth];
    return new A(le, $, Ee);
  }, A.fromCBOR = (b) => {
    const F = (0, n.decodeToDataItem)(b);
    return A.fromDataItem(F);
  }, CryptoKeypath$2;
}
var hasRequiredCryptoHDKey$2;
function requireCryptoHDKey$2() {
  if (hasRequiredCryptoHDKey$2) return CryptoHDKey$2;
  hasRequiredCryptoHDKey$2 = 1, Object.defineProperty(CryptoHDKey$2, "__esModule", { value: !0 }), CryptoHDKey$2.CryptoHDKey = void 0;
  const n = requireBs58check$2(), c = requireCryptoCoinInfo$2(), u = requireCryptoKeypath$2(), p = requireLib$2(), a = requireRegistryItem$2(), A = requireRegistryType$2();
  var b;
  (function(le) {
    le[le.is_master = 1] = "is_master", le[le.is_private = 2] = "is_private", le[le.key_data = 3] = "key_data", le[le.chain_code = 4] = "chain_code", le[le.use_info = 5] = "use_info", le[le.origin = 6] = "origin", le[le.children = 7] = "children", le[le.parent_fingerprint = 8] = "parent_fingerprint", le[le.name = 9] = "name", le[le.note = 10] = "note";
  })(b || (b = {}));
  class F extends a.RegistryItem {
    constructor(L) {
      super(), this.isECKey = () => !1, this.getKey = () => this.key, this.getChainCode = () => this.chainCode, this.isMaster = () => this.master, this.isPrivateKey = () => !!this.privateKey, this.getUseInfo = () => this.useInfo, this.getOrigin = () => this.origin, this.getChildren = () => this.children, this.getParentFingerprint = () => this.parentFingerprint, this.getName = () => this.name, this.getNote = () => this.note, this.getBip32Key = () => {
        var pe, $, Ee;
        let be, He, Pe = 0, nr = Buffer$f.alloc(4).fill(0);
        if (this.isMaster())
          be = Buffer$f.from("0488ADE4", "hex"), He = 0, Pe = 0;
        else {
          He = ((pe = this.getOrigin()) === null || pe === void 0 ? void 0 : pe.getComponents().length) || (($ = this.getOrigin()) === null || $ === void 0 ? void 0 : $.getDepth());
          const xr = (Ee = this.getOrigin()) === null || Ee === void 0 ? void 0 : Ee.getComponents(), kr = xr[xr.length - 1];
          kr && (Pe = kr.isHardened() ? kr.getIndex() + 2147483648 : kr.getIndex(), this.getParentFingerprint() && (nr = this.getParentFingerprint())), this.isPrivateKey() ? be = Buffer$f.from("0488ADE4", "hex") : be = Buffer$f.from("0488B21E", "hex");
        }
        const ir = Buffer$f.alloc(1);
        ir.writeUInt8(He, 0);
        const or = Buffer$f.alloc(4);
        or.writeUInt32BE(Pe, 0);
        const lr = this.getChainCode(), Ir = this.getKey();
        return (0, n.encode)(Buffer$f.concat([be, ir, nr, or, lr, Ir]));
      }, this.getRegistryType = () => A.RegistryTypes.CRYPTO_HDKEY, this.getOutputDescriptorContent = () => {
        var pe, $, Ee, be, He, Pe, nr;
        let ir = "";
        return this.getOrigin() && !((pe = this.getOrigin()) === null || pe === void 0) && pe.getSourceFingerprint() && !(($ = this.getOrigin()) === null || $ === void 0) && $.getPath() && (ir += `${(be = (Ee = this.getOrigin()) === null || Ee === void 0 ? void 0 : Ee.getSourceFingerprint()) === null || be === void 0 ? void 0 : be.toString("hex")}/${(He = this.getOrigin()) === null || He === void 0 ? void 0 : He.getPath()}`), ir += this.getBip32Key(), this.getChildren() && !((Pe = this.getChildren()) === null || Pe === void 0) && Pe.getPath() && (ir += `/${(nr = this.getChildren()) === null || nr === void 0 ? void 0 : nr.getPath()}`), ir;
      }, this.setupMasterKey = (pe) => {
        this.master = !0, this.key = pe.key, this.chainCode = pe.chainCode;
      }, this.setupDeriveKey = (pe) => {
        this.master = !1, this.privateKey = pe.isPrivateKey, this.key = pe.key, this.chainCode = pe.chainCode, this.useInfo = pe.useInfo, this.origin = pe.origin, this.children = pe.children, this.parentFingerprint = pe.parentFingerprint, this.name = pe.name, this.note = pe.note;
      }, this.toDataItem = () => {
        const pe = {};
        if (this.master)
          pe[b.is_master] = !0, pe[b.key_data] = this.key, pe[b.chain_code] = this.chainCode;
        else {
          if (this.privateKey !== void 0 && (pe[b.is_private] = this.privateKey), pe[b.key_data] = this.key, this.chainCode && (pe[b.chain_code] = this.chainCode), this.useInfo) {
            const $ = this.useInfo.toDataItem();
            $.setTag(this.useInfo.getRegistryType().getTag()), pe[b.use_info] = $;
          }
          if (this.origin) {
            const $ = this.origin.toDataItem();
            $.setTag(this.origin.getRegistryType().getTag()), pe[b.origin] = $;
          }
          if (this.children) {
            const $ = this.children.toDataItem();
            $.setTag(this.children.getRegistryType().getTag()), pe[b.children] = $;
          }
          this.parentFingerprint && (pe[b.parent_fingerprint] = this.parentFingerprint.readUInt32BE(0)), this.name !== void 0 && (pe[b.name] = this.name), this.note !== void 0 && (pe[b.note] = this.note);
        }
        return new p.DataItem(pe);
      }, L.isMaster ? this.setupMasterKey(L) : this.setupDeriveKey(L);
    }
  }
  return CryptoHDKey$2.CryptoHDKey = F, F.fromDataItem = (le) => {
    const L = le.getData(), pe = !!L[b.is_master], $ = L[b.is_private], Ee = L[b.key_data], be = L[b.chain_code], He = L[b.use_info] ? c.CryptoCoinInfo.fromDataItem(L[b.use_info]) : void 0, Pe = L[b.origin] ? u.CryptoKeypath.fromDataItem(L[b.origin]) : void 0, nr = L[b.children] ? u.CryptoKeypath.fromDataItem(L[b.children]) : void 0, ir = L[b.parent_fingerprint];
    let or;
    ir && (or = Buffer$f.alloc(4), or.writeUInt32BE(ir, 0));
    const lr = L[b.name], Ir = L[b.note];
    return new F({
      isMaster: pe,
      isPrivateKey: $,
      key: Ee,
      chainCode: be,
      useInfo: He,
      origin: Pe,
      children: nr,
      parentFingerprint: or,
      name: lr,
      note: Ir
    });
  }, F.fromCBOR = (le) => {
    const L = (0, p.decodeToDataItem)(le);
    return F.fromDataItem(L);
  }, CryptoHDKey$2;
}
var CryptoECKey$2 = {}, hasRequiredCryptoECKey$2;
function requireCryptoECKey$2() {
  if (hasRequiredCryptoECKey$2) return CryptoECKey$2;
  hasRequiredCryptoECKey$2 = 1, Object.defineProperty(CryptoECKey$2, "__esModule", { value: !0 }), CryptoECKey$2.CryptoECKey = void 0;
  const n = requireLib$2(), c = requireRegistryItem$2(), u = requireRegistryType$2();
  var p;
  (function(A) {
    A[A.curve = 1] = "curve", A[A.private = 2] = "private", A[A.data = 3] = "data";
  })(p || (p = {}));
  class a extends c.RegistryItem {
    constructor(b) {
      super(), this.isECKey = () => !0, this.getCurve = () => this.curve || 0, this.isPrivateKey = () => this.privateKey || !1, this.getData = () => this.data, this.getRegistryType = () => u.RegistryTypes.CRYPTO_ECKEY, this.toDataItem = () => {
        const F = {};
        return this.curve && (F[p.curve] = this.curve), this.privateKey !== void 0 && (F[p.private] = this.privateKey), F[p.data] = this.data, new n.DataItem(F);
      }, this.getOutputDescriptorContent = () => this.data.toString("hex"), this.data = b.data, this.curve = b.curve, this.privateKey = b.privateKey || void 0;
    }
  }
  return CryptoECKey$2.CryptoECKey = a, a.fromDataItem = (A) => {
    const b = A.getData(), F = b[p.curve], le = b[p.private], L = b[p.data];
    if (!L)
      throw new Error(`#[ur-registry][CryptoECKey][fn.fromDataItem]: decoded [dataItem][#data.data] is undefined: ${A}`);
    return new a({ data: L, curve: F, privateKey: le });
  }, a.fromCBOR = (A) => {
    const b = (0, n.decodeToDataItem)(A);
    return a.fromDataItem(b);
  }, CryptoECKey$2;
}
var Bytes$3 = {}, hasRequiredBytes$2;
function requireBytes$2() {
  if (hasRequiredBytes$2) return Bytes$3;
  hasRequiredBytes$2 = 1, Object.defineProperty(Bytes$3, "__esModule", { value: !0 }), Bytes$3.Bytes = void 0;
  const n = requireLib$2(), c = requireRegistryItem$2(), u = requireRegistryType$2();
  class p extends c.RegistryItem {
    constructor(A) {
      super(), this.bytes = A, this.getRegistryType = () => u.RegistryTypes.BYTES, this.getData = () => this.bytes, this.toDataItem = () => new n.DataItem(this.bytes);
    }
  }
  return Bytes$3.Bytes = p, p.fromDataItem = (a) => {
    const A = a.getData();
    if (!A)
      throw new Error(`#[ur-registry][Bytes][fn.fromDataItem]: decoded [dataItem][#data] is undefined: ${a}`);
    return new p(A);
  }, p.fromCBOR = (a) => {
    const A = (0, n.decodeToDataItem)(a);
    return p.fromDataItem(A);
  }, Bytes$3;
}
var CryptoOutput$2 = {}, MultiKey$2 = {}, hasRequiredMultiKey$2;
function requireMultiKey$2() {
  if (hasRequiredMultiKey$2) return MultiKey$2;
  hasRequiredMultiKey$2 = 1, Object.defineProperty(MultiKey$2, "__esModule", { value: !0 }), MultiKey$2.MultiKey = void 0;
  const n = requireCryptoECKey$2(), c = requireCryptoHDKey$2(), u = requireDataItem$2(), p = requireRegistryItem$2(), a = requireRegistryType$2();
  var A;
  (function(F) {
    F[F.threshold = 1] = "threshold", F[F.keys = 2] = "keys";
  })(A || (A = {}));
  class b extends p.RegistryItem {
    constructor(le, L) {
      super(), this.threshold = le, this.keys = L, this.getThreshold = () => this.threshold, this.getKeys = () => this.keys, this.toDataItem = () => {
        const pe = {};
        pe[A.threshold] = this.threshold;
        const $ = this.keys.map((Ee) => {
          const be = Ee.toDataItem();
          return be.setTag(Ee.getRegistryType().getTag()), be;
        });
        return pe[A.keys] = $, new u.DataItem(pe);
      }, this.getOutputDescriptorContent = () => [
        this.getThreshold(),
        this.keys.map((pe) => pe.getOutputDescriptorContent()).join(",")
      ].join(",");
    }
  }
  return MultiKey$2.MultiKey = b, b.fromDataItem = (F) => {
    const le = F.getData(), L = le[A.threshold], pe = le[A.keys], $ = [];
    return pe.forEach((Ee) => {
      Ee.getTag() === a.RegistryTypes.CRYPTO_HDKEY.getTag() ? $.push(c.CryptoHDKey.fromDataItem(Ee)) : Ee.getTag() === a.RegistryTypes.CRYPTO_ECKEY.getTag() && $.push(n.CryptoECKey.fromDataItem(Ee));
    }), new b(L, $);
  }, MultiKey$2;
}
var hasRequiredCryptoOutput$2;
function requireCryptoOutput$2() {
  if (hasRequiredCryptoOutput$2) return CryptoOutput$2;
  hasRequiredCryptoOutput$2 = 1, Object.defineProperty(CryptoOutput$2, "__esModule", { value: !0 }), CryptoOutput$2.CryptoOutput = void 0;
  const n = requireCryptoECKey$2(), c = requireCryptoHDKey$2(), u = requireLib$2(), p = requireMultiKey$2(), a = requireRegistryItem$2(), A = requireRegistryType$2(), b = requireScriptExpression$2();
  class F extends a.RegistryItem {
    constructor(L, pe) {
      super(), this.scriptExpressions = L, this.cryptoKey = pe, this.getRegistryType = () => A.RegistryTypes.CRYPTO_OUTPUT, this.getCryptoKey = () => this.cryptoKey, this.getHDKey = () => {
        if (this.cryptoKey instanceof c.CryptoHDKey)
          return this.cryptoKey;
      }, this.getECKey = () => {
        if (this.cryptoKey instanceof n.CryptoECKey)
          return this.cryptoKey;
      }, this.getMultiKey = () => {
        if (this.cryptoKey instanceof p.MultiKey)
          return this.cryptoKey;
      }, this.getScriptExpressions = () => this.scriptExpressions, this._toOutputDescriptor = ($) => $ >= this.scriptExpressions.length ? this.cryptoKey.getOutputDescriptorContent() : `${this.scriptExpressions[$].getExpression()}(${this._toOutputDescriptor($ + 1)})`, this.toString = () => this._toOutputDescriptor(0), this.toDataItem = () => {
        let $ = this.cryptoKey.toDataItem();
        return (this.cryptoKey instanceof n.CryptoECKey || this.cryptoKey instanceof c.CryptoHDKey) && $.setTag(this.cryptoKey.getRegistryType().getTag()), [...this.scriptExpressions].reverse().forEach((be) => {
          const He = be.getTag();
          $.getTag() === void 0 ? $.setTag(He) : $ = new u.DataItem($, He);
        }), $;
      };
    }
  }
  return CryptoOutput$2.CryptoOutput = F, F.fromDataItem = (le) => {
    const L = [];
    let pe = le;
    for (; ; ) {
      let be = pe.getTag();
      const He = b.ScriptExpression.fromTag(be);
      if (He)
        if (L.push(He), pe.getData() instanceof u.DataItem)
          pe = pe.getData(), be = pe.getTag();
        else
          break;
      else
        break;
    }
    const $ = L.length;
    if ($ > 0 && (L[$ - 1].getExpression() === b.ScriptExpressions.MULTISIG.getExpression() || L[$ - 1].getExpression() === b.ScriptExpressions.SORTED_MULTISIG.getExpression())) {
      const be = p.MultiKey.fromDataItem(pe);
      return new F(L, be);
    }
    if (pe.getTag() === A.RegistryTypes.CRYPTO_HDKEY.getTag()) {
      const be = c.CryptoHDKey.fromDataItem(pe);
      return new F(L, be);
    } else {
      const be = n.CryptoECKey.fromDataItem(pe);
      return new F(L, be);
    }
  }, F.fromCBOR = (le) => {
    const L = (0, u.decodeToDataItem)(le);
    return F.fromDataItem(L);
  }, CryptoOutput$2;
}
var CryptoPSBT$2 = {}, hasRequiredCryptoPSBT$2;
function requireCryptoPSBT$2() {
  if (hasRequiredCryptoPSBT$2) return CryptoPSBT$2;
  hasRequiredCryptoPSBT$2 = 1, Object.defineProperty(CryptoPSBT$2, "__esModule", { value: !0 }), CryptoPSBT$2.CryptoPSBT = void 0;
  const n = requireLib$2(), c = requireRegistryItem$2(), u = requireRegistryType$2();
  class p extends c.RegistryItem {
    constructor(A) {
      super(), this.psbt = A, this.getRegistryType = () => u.RegistryTypes.CRYPTO_PSBT, this.getPSBT = () => this.psbt, this.toDataItem = () => new n.DataItem(this.psbt);
    }
  }
  return CryptoPSBT$2.CryptoPSBT = p, p.fromDataItem = (a) => {
    const A = a.getData();
    if (!A)
      throw new Error(`#[ur-registry][CryptoPSBT][fn.fromDataItem]: decoded [dataItem][#data] is undefined: ${a}`);
    return new p(A);
  }, p.fromCBOR = (a) => {
    const A = (0, n.decodeToDataItem)(a);
    return p.fromDataItem(A);
  }, CryptoPSBT$2;
}
var CryptoAccount$2 = {}, hasRequiredCryptoAccount$2;
function requireCryptoAccount$2() {
  if (hasRequiredCryptoAccount$2) return CryptoAccount$2;
  hasRequiredCryptoAccount$2 = 1, Object.defineProperty(CryptoAccount$2, "__esModule", { value: !0 }), CryptoAccount$2.CryptoAccount = void 0;
  const n = requireDist$2(), c = requireLib$2(), u = requireRegistryItem$2(), p = requireRegistryType$2();
  var a;
  (function(b) {
    b[b.masterFingerprint = 1] = "masterFingerprint", b[b.outputDescriptors = 2] = "outputDescriptors";
  })(a || (a = {}));
  class A extends u.RegistryItem {
    constructor(F, le) {
      super(), this.masterFingerprint = F, this.outputDescriptors = le, this.getRegistryType = () => p.RegistryTypes.CRYPTO_ACCOUNT, this.getMasterFingerprint = () => this.masterFingerprint, this.getOutputDescriptors = () => this.outputDescriptors, this.toDataItem = () => {
        const L = {};
        return this.masterFingerprint && (L[a.masterFingerprint] = this.masterFingerprint.readUInt32BE(0)), this.outputDescriptors && (L[a.outputDescriptors] = this.outputDescriptors.map((pe) => pe.toDataItem())), new c.DataItem(L);
      };
    }
  }
  return CryptoAccount$2.CryptoAccount = A, A.fromDataItem = (b) => {
    const F = b.getData(), le = Buffer$f.alloc(4), L = F[a.masterFingerprint];
    L && le.writeUInt32BE(L, 0);
    const $ = F[a.outputDescriptors].map((Ee) => n.CryptoOutput.fromDataItem(Ee));
    return new A(le, $);
  }, A.fromCBOR = (b) => {
    const F = (0, c.decodeToDataItem)(b);
    return A.fromDataItem(F);
  }, CryptoAccount$2;
}
var Decoder$2 = {}, errors$3 = {}, hasRequiredErrors$2;
function requireErrors$2() {
  if (hasRequiredErrors$2) return errors$3;
  hasRequiredErrors$2 = 1, Object.defineProperty(errors$3, "__esModule", { value: !0 }), errors$3.UnknownURTypeError = void 0;
  class n extends Error {
    constructor(u) {
      super(u);
    }
  }
  return errors$3.UnknownURTypeError = n, errors$3;
}
var hasRequiredDecoder$2;
function requireDecoder$2() {
  if (hasRequiredDecoder$2) return Decoder$2;
  hasRequiredDecoder$2 = 1, Object.defineProperty(Decoder$2, "__esModule", { value: !0 }), Decoder$2.URRegistryDecoder = void 0;
  const n = dist$t, c = requireDist$2(), u = requireRegistryType$2(), p = requireErrors$2();
  class a extends n.URDecoder {
    constructor() {
      super(...arguments), this.resultRegistryType = () => {
        const b = this.resultUR();
        switch (b.type) {
          case u.RegistryTypes.BYTES.getType():
            return c.Bytes.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_HDKEY.getType():
            return c.CryptoHDKey.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_KEYPATH.getType():
            return c.CryptoKeypath.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_COIN_INFO.getType():
            return c.CryptoCoinInfo.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_ECKEY.getType():
            return c.CryptoECKey.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_OUTPUT.getType():
            return c.CryptoOutput.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_PSBT.getType():
            return c.CryptoPSBT.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_ACCOUNT.getType():
            return c.CryptoAccount.fromCBOR(b.cbor);
          default:
            throw new p.UnknownURTypeError(`#[ur-registry][Decoder][fn.resultRegistryType]: registry type ${b.type} is not supported now`);
        }
      };
    }
  }
  return Decoder$2.URRegistryDecoder = a, Decoder$2;
}
var CryptoMultiAccounts$2 = {}, hasRequiredCryptoMultiAccounts$2;
function requireCryptoMultiAccounts$2() {
  if (hasRequiredCryptoMultiAccounts$2) return CryptoMultiAccounts$2;
  hasRequiredCryptoMultiAccounts$2 = 1, Object.defineProperty(CryptoMultiAccounts$2, "__esModule", { value: !0 }), CryptoMultiAccounts$2.CryptoMultiAccounts = void 0;
  const n = requireRegistryType$2(), c = requireCryptoHDKey$2(), u = requireRegistryItem$2(), p = requireLib$2();
  var a;
  (function(b) {
    b[b.masterFingerprint = 1] = "masterFingerprint", b[b.keys = 2] = "keys", b[b.device = 3] = "device", b[b.deviceId = 4] = "deviceId", b[b.version = 5] = "version";
  })(a || (a = {}));
  class A extends u.RegistryItem {
    constructor(F, le, L, pe, $) {
      super(), this.masterFingerprint = F, this.keys = le, this.device = L, this.deviceId = pe, this.version = $, this.getRegistryType = () => n.RegistryTypes.CRYPTO_MULTI_ACCOUNTS, this.getMasterFingerprint = () => this.masterFingerprint, this.getKeys = () => this.keys, this.getDevice = () => this.device, this.getDeviceId = () => this.deviceId, this.getVersion = () => this.version, this.toDataItem = () => {
        const Ee = {};
        return this.masterFingerprint && (Ee[a.masterFingerprint] = this.masterFingerprint.readUInt32BE(0)), this.keys && (Ee[a.keys] = this.keys.map((be) => {
          const He = be.toDataItem();
          return He.setTag(be.getRegistryType().getTag()), He;
        })), this.device && (Ee[a.device] = this.device), this.deviceId && (Ee[a.deviceId] = this.deviceId), this.version && (Ee[a.version] = this.version), new p.DataItem(Ee);
      };
    }
  }
  return CryptoMultiAccounts$2.CryptoMultiAccounts = A, A.fromDataItem = (b) => {
    const F = b.getData(), le = Buffer$f.alloc(4), L = F[a.masterFingerprint];
    L && le.writeUInt32BE(L, 0);
    const $ = F[a.keys].map((Pe) => c.CryptoHDKey.fromDataItem(Pe)), Ee = F[a.device], be = F[a.deviceId], He = F[a.version];
    return new A(le, $, Ee, be, He);
  }, A.fromCBOR = (b) => {
    const F = (0, p.decodeToDataItem)(b);
    return A.fromDataItem(F);
  }, CryptoMultiAccounts$2;
}
var QRHardwareCall$2 = {}, KeyDerivation$2 = {}, DerivationSchema$2 = {}, hasRequiredDerivationSchema$2;
function requireDerivationSchema$2() {
  return hasRequiredDerivationSchema$2 || (hasRequiredDerivationSchema$2 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.KeyDerivationSchema = n.DerivationAlgorithm = n.Curve = void 0;
    const c = requireRegistryType$2(), u = requireRegistryItem$2(), p = requireLib$2(), a = requireCryptoKeypath$2();
    var A;
    (function(L) {
      L[L.keyPath = 1] = "keyPath", L[L.curve = 2] = "curve", L[L.algo = 3] = "algo";
    })(A || (A = {}));
    var b;
    (function(L) {
      L[L.secp256k1 = 0] = "secp256k1", L[L.ed25519 = 1] = "ed25519";
    })(b = n.Curve || (n.Curve = {}));
    var F;
    (function(L) {
      L[L.slip10 = 0] = "slip10", L[L.bip32ed25519 = 1] = "bip32ed25519";
    })(F = n.DerivationAlgorithm || (n.DerivationAlgorithm = {}));
    class le extends u.RegistryItem {
      constructor(pe, $ = b.secp256k1, Ee = F.slip10) {
        super(), this.keypath = pe, this.curve = $, this.algo = Ee, this.getRegistryType = () => c.RegistryTypes.KEY_DERIVATION_SCHEMA, this.getKeypath = () => this.keypath, this.getCurve = () => this.curve, this.getAlgo = () => this.algo, this.toDataItem = () => {
          const be = {}, He = this.getKeypath().toDataItem();
          return He.setTag(this.getKeypath().getRegistryType().getTag()), be[A.keyPath] = He, be[A.curve] = this.curve, be[A.algo] = this.algo, new p.DataItem(be);
        };
      }
    }
    n.KeyDerivationSchema = le, le.fromDataItem = (L) => {
      const pe = L.getData(), $ = a.CryptoKeypath.fromDataItem(pe[A.keyPath]), Ee = pe[A.curve], be = pe[A.algo];
      return new le($, Ee, be);
    }, le.fromCBOR = (L) => {
      const pe = (0, p.decodeToDataItem)(L);
      return le.fromDataItem(pe);
    };
  }(DerivationSchema$2)), DerivationSchema$2;
}
var hasRequiredKeyDerivation$2;
function requireKeyDerivation$2() {
  if (hasRequiredKeyDerivation$2) return KeyDerivation$2;
  hasRequiredKeyDerivation$2 = 1, Object.defineProperty(KeyDerivation$2, "__esModule", { value: !0 }), KeyDerivation$2.KeyDerivation = void 0;
  const n = requireRegistryType$2(), c = requireRegistryItem$2(), u = requireLib$2(), p = requireDerivationSchema$2();
  var a;
  (function(b) {
    b[b.schemas = 1] = "schemas";
  })(a || (a = {}));
  class A extends c.RegistryItem {
    constructor(F) {
      super(), this.schemas = F, this.getRegistryType = () => n.RegistryTypes.KEY_DERIVATION_CALL, this.getSchemas = () => this.schemas, this.toDataItem = () => {
        const le = {};
        return le[a.schemas] = this.schemas.map((L) => {
          const pe = L.toDataItem();
          return pe.setTag(L.getRegistryType().getTag()), pe;
        }), new u.DataItem(le);
      };
    }
  }
  return KeyDerivation$2.KeyDerivation = A, A.fromDataItem = (b) => {
    const le = b.getData()[a.schemas].map((L) => p.KeyDerivationSchema.fromDataItem(L));
    return new A(le);
  }, A.fromCBOR = (b) => {
    const F = (0, u.decodeToDataItem)(b);
    return A.fromDataItem(F);
  }, KeyDerivation$2;
}
var hasRequiredQRHardwareCall$2;
function requireQRHardwareCall$2() {
  return hasRequiredQRHardwareCall$2 || (hasRequiredQRHardwareCall$2 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.QRHardwareCall = n.QRHardwareCallType = void 0;
    const c = requireRegistryType$2(), u = requireRegistryItem$2(), p = requireLib$2(), a = requireKeyDerivation$2();
    var A;
    (function(le) {
      le[le.type = 1] = "type", le[le.params = 2] = "params", le[le.origin = 3] = "origin";
    })(A || (A = {}));
    var b;
    (function(le) {
      le[le.KeyDerivation = 0] = "KeyDerivation";
    })(b = n.QRHardwareCallType || (n.QRHardwareCallType = {}));
    class F extends u.RegistryItem {
      constructor(L, pe, $) {
        super(), this.type = L, this.params = pe, this.origin = $, this.getRegistryType = () => c.RegistryTypes.QR_HARDWARE_CALL, this.getType = () => this.type, this.getParams = () => this.params, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const Ee = {};
          Ee[A.type] = this.type;
          const be = this.params.toDataItem();
          return be.setTag(this.params.getRegistryType().getTag()), Ee[A.params] = be, this.origin && (Ee[A.origin] = this.origin), new p.DataItem(Ee);
        };
      }
    }
    n.QRHardwareCall = F, F.fromDataItem = (le) => {
      const L = le.getData(), pe = L[A.type] || b.KeyDerivation;
      let $;
      switch (pe) {
        case b.KeyDerivation:
          $ = a.KeyDerivation.fromDataItem(L[A.params]);
      }
      const Ee = L[A.origin];
      return new F(pe, $, Ee);
    }, F.fromCBOR = (le) => {
      const L = (0, p.decodeToDataItem)(le);
      return F.fromDataItem(L);
    };
  }(QRHardwareCall$2)), QRHardwareCall$2;
}
var types$7 = {}, hasRequiredTypes$2;
function requireTypes$2() {
  return hasRequiredTypes$2 || (hasRequiredTypes$2 = 1, Object.defineProperty(types$7, "__esModule", { value: !0 })), types$7;
}
var hasRequiredDist$2;
function requireDist$2() {
  return hasRequiredDist$2 || (hasRequiredDist$2 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.Buffer = n.extend = n.PathComponent = n.ScriptExpressions = n.MultiKey = n.CryptoPSBT = n.CryptoOutput = n.CryptoECKey = n.CryptoCoinInfoNetwork = n.CryptoCoinInfoType = n.CryptoCoinInfo = n.CryptoKeypath = n.CryptoMultiAccounts = n.CryptoHDKey = n.CryptoAccount = n.Bytes = n.URRegistryDecoder = n.DataItem = void 0;
    const c = require$$0$4;
    requirePatchCBOR$2();
    const u = dist$u;
    Object.defineProperty(n, "Buffer", { enumerable: !0, get: function() {
      return u.Buffer;
    } });
    const p = requireCryptoHDKey$2();
    Object.defineProperty(n, "CryptoHDKey", { enumerable: !0, get: function() {
      return p.CryptoHDKey;
    } });
    const a = requireCryptoKeypath$2();
    Object.defineProperty(n, "CryptoKeypath", { enumerable: !0, get: function() {
      return a.CryptoKeypath;
    } });
    const A = requireCryptoCoinInfo$2();
    Object.defineProperty(n, "CryptoCoinInfo", { enumerable: !0, get: function() {
      return A.CryptoCoinInfo;
    } }), Object.defineProperty(n, "CryptoCoinInfoType", { enumerable: !0, get: function() {
      return A.Type;
    } }), Object.defineProperty(n, "CryptoCoinInfoNetwork", { enumerable: !0, get: function() {
      return A.Network;
    } });
    const b = requireCryptoECKey$2();
    Object.defineProperty(n, "CryptoECKey", { enumerable: !0, get: function() {
      return b.CryptoECKey;
    } });
    const F = requireBytes$2();
    Object.defineProperty(n, "Bytes", { enumerable: !0, get: function() {
      return F.Bytes;
    } });
    const le = requireCryptoOutput$2();
    Object.defineProperty(n, "CryptoOutput", { enumerable: !0, get: function() {
      return le.CryptoOutput;
    } });
    const L = requireCryptoPSBT$2();
    Object.defineProperty(n, "CryptoPSBT", { enumerable: !0, get: function() {
      return L.CryptoPSBT;
    } });
    const pe = requireCryptoAccount$2();
    Object.defineProperty(n, "CryptoAccount", { enumerable: !0, get: function() {
      return pe.CryptoAccount;
    } });
    const $ = requireDecoder$2();
    Object.defineProperty(n, "URRegistryDecoder", { enumerable: !0, get: function() {
      return $.URRegistryDecoder;
    } });
    const Ee = requireMultiKey$2();
    Object.defineProperty(n, "MultiKey", { enumerable: !0, get: function() {
      return Ee.MultiKey;
    } });
    const be = requireScriptExpression$2();
    Object.defineProperty(n, "ScriptExpressions", { enumerable: !0, get: function() {
      return be.ScriptExpressions;
    } });
    const He = requirePathComponent$2();
    Object.defineProperty(n, "PathComponent", { enumerable: !0, get: function() {
      return He.PathComponent;
    } });
    const Pe = requireRegistryItem$2(), nr = requireRegistryType$2(), ir = requireLib$2();
    var or = requireLib$2();
    Object.defineProperty(n, "DataItem", { enumerable: !0, get: function() {
      return or.DataItem;
    } });
    const lr = requireUtils$2(), Ir = requireCryptoMultiAccounts$2();
    Object.defineProperty(n, "CryptoMultiAccounts", { enumerable: !0, get: function() {
      return Ir.CryptoMultiAccounts;
    } });
    const xr = {
      URRegistryDecoder: $.URRegistryDecoder,
      Bytes: F.Bytes,
      CryptoAccount: pe.CryptoAccount,
      CryptoHDKey: p.CryptoHDKey,
      CryptoMultiAccounts: Ir.CryptoMultiAccounts,
      CryptoKeypath: a.CryptoKeypath,
      CryptoCoinInfo: A.CryptoCoinInfo,
      CryptoCoinInfoType: A.Type,
      CryptoCoinInfoNetwork: A.Network,
      CryptoECKey: b.CryptoECKey,
      CryptoOutput: le.CryptoOutput,
      CryptoPSBT: L.CryptoPSBT,
      MultiKey: Ee.MultiKey,
      ScriptExpressions: be.ScriptExpressions,
      PathComponent: He.PathComponent
    }, kr = {
      addReader: ir.addReader,
      addSemanticDecode: ir.addSemanticDecode,
      addSemanticEncode: ir.addSemanticEncode,
      addWriter: ir.addWriter,
      patchTags: lr.patchTags
    }, Ce = {
      RegistryTypes: nr.RegistryTypes,
      RegistryItem: Pe.RegistryItem,
      RegistryType: nr.RegistryType,
      decodeToDataItem: ir.decodeToDataItem,
      encodeDataItem: ir.encodeDataItem,
      cbor: kr
    };
    n.extend = Ce, (0, c.__exportStar)(requireErrors$2(), n), (0, c.__exportStar)(requireDecoder$2(), n), (0, c.__exportStar)(requireLib$2(), n), (0, c.__exportStar)(requireCryptoAccount$2(), n), (0, c.__exportStar)(requireCryptoPSBT$2(), n), (0, c.__exportStar)(requireCryptoHDKey$2(), n), (0, c.__exportStar)(requireCryptoMultiAccounts$2(), n), (0, c.__exportStar)(requireQRHardwareCall$2(), n), (0, c.__exportStar)(requireKeyDerivation$2(), n), (0, c.__exportStar)(requireDerivationSchema$2(), n), (0, c.__exportStar)(requireCryptoOutput$2(), n), (0, c.__exportStar)(requireCryptoCoinInfo$2(), n), (0, c.__exportStar)(requireCryptoECKey$2(), n), (0, c.__exportStar)(requireMultiKey$2(), n), (0, c.__exportStar)(requireCryptoKeypath$2(), n), (0, c.__exportStar)(requirePatchCBOR$2(), n), (0, c.__exportStar)(requirePathComponent$2(), n), (0, c.__exportStar)(requireRegistryItem$2(), n), (0, c.__exportStar)(requireRegistryType$2(), n), (0, c.__exportStar)(requireTypes$2(), n), (0, c.__exportStar)(requireUtils$2(), n), n.default = xr;
  }(dist$8)), dist$8;
}
var commonjsBrowser$1 = {}, v1$2 = {}, rng$3 = {}, hasRequiredRng$1;
function requireRng$1() {
  if (hasRequiredRng$1) return rng$3;
  hasRequiredRng$1 = 1, Object.defineProperty(rng$3, "__esModule", {
    value: !0
  }), rng$3.default = u;
  let n;
  const c = new Uint8Array(16);
  function u() {
    if (!n && (n = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !n))
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    return n(c);
  }
  return rng$3;
}
var stringify$2 = {}, validate$3 = {}, regex$1 = {}, hasRequiredRegex$1;
function requireRegex$1() {
  if (hasRequiredRegex$1) return regex$1;
  hasRequiredRegex$1 = 1, Object.defineProperty(regex$1, "__esModule", {
    value: !0
  }), regex$1.default = void 0;
  var n = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
  return regex$1.default = n, regex$1;
}
var hasRequiredValidate$1;
function requireValidate$1() {
  if (hasRequiredValidate$1) return validate$3;
  hasRequiredValidate$1 = 1, Object.defineProperty(validate$3, "__esModule", {
    value: !0
  }), validate$3.default = void 0;
  var n = c(requireRegex$1());
  function c(a) {
    return a && a.__esModule ? a : { default: a };
  }
  function u(a) {
    return typeof a == "string" && n.default.test(a);
  }
  var p = u;
  return validate$3.default = p, validate$3;
}
var hasRequiredStringify$1;
function requireStringify$1() {
  if (hasRequiredStringify$1) return stringify$2;
  hasRequiredStringify$1 = 1, Object.defineProperty(stringify$2, "__esModule", {
    value: !0
  }), stringify$2.default = void 0, stringify$2.unsafeStringify = p;
  var n = c(requireValidate$1());
  function c(b) {
    return b && b.__esModule ? b : { default: b };
  }
  const u = [];
  for (let b = 0; b < 256; ++b)
    u.push((b + 256).toString(16).slice(1));
  function p(b, F = 0) {
    return u[b[F + 0]] + u[b[F + 1]] + u[b[F + 2]] + u[b[F + 3]] + "-" + u[b[F + 4]] + u[b[F + 5]] + "-" + u[b[F + 6]] + u[b[F + 7]] + "-" + u[b[F + 8]] + u[b[F + 9]] + "-" + u[b[F + 10]] + u[b[F + 11]] + u[b[F + 12]] + u[b[F + 13]] + u[b[F + 14]] + u[b[F + 15]];
  }
  function a(b, F = 0) {
    const le = p(b, F);
    if (!(0, n.default)(le))
      throw TypeError("Stringified UUID is invalid");
    return le;
  }
  var A = a;
  return stringify$2.default = A, stringify$2;
}
var hasRequiredV1$1;
function requireV1$1() {
  if (hasRequiredV1$1) return v1$2;
  hasRequiredV1$1 = 1, Object.defineProperty(v1$2, "__esModule", {
    value: !0
  }), v1$2.default = void 0;
  var n = u(requireRng$1()), c = requireStringify$1();
  function u(L) {
    return L && L.__esModule ? L : { default: L };
  }
  let p, a, A = 0, b = 0;
  function F(L, pe, $) {
    let Ee = pe && $ || 0;
    const be = pe || new Array(16);
    L = L || {};
    let He = L.node || p, Pe = L.clockseq !== void 0 ? L.clockseq : a;
    if (He == null || Pe == null) {
      const xr = L.random || (L.rng || n.default)();
      He == null && (He = p = [xr[0] | 1, xr[1], xr[2], xr[3], xr[4], xr[5]]), Pe == null && (Pe = a = (xr[6] << 8 | xr[7]) & 16383);
    }
    let nr = L.msecs !== void 0 ? L.msecs : Date.now(), ir = L.nsecs !== void 0 ? L.nsecs : b + 1;
    const or = nr - A + (ir - b) / 1e4;
    if (or < 0 && L.clockseq === void 0 && (Pe = Pe + 1 & 16383), (or < 0 || nr > A) && L.nsecs === void 0 && (ir = 0), ir >= 1e4)
      throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    A = nr, b = ir, a = Pe, nr += 122192928e5;
    const lr = ((nr & 268435455) * 1e4 + ir) % 4294967296;
    be[Ee++] = lr >>> 24 & 255, be[Ee++] = lr >>> 16 & 255, be[Ee++] = lr >>> 8 & 255, be[Ee++] = lr & 255;
    const Ir = nr / 4294967296 * 1e4 & 268435455;
    be[Ee++] = Ir >>> 8 & 255, be[Ee++] = Ir & 255, be[Ee++] = Ir >>> 24 & 15 | 16, be[Ee++] = Ir >>> 16 & 255, be[Ee++] = Pe >>> 8 | 128, be[Ee++] = Pe & 255;
    for (let xr = 0; xr < 6; ++xr)
      be[Ee + xr] = He[xr];
    return pe || (0, c.unsafeStringify)(be);
  }
  var le = F;
  return v1$2.default = le, v1$2;
}
var v3$2 = {}, v35$2 = {}, parse$9 = {}, hasRequiredParse$1;
function requireParse$1() {
  if (hasRequiredParse$1) return parse$9;
  hasRequiredParse$1 = 1, Object.defineProperty(parse$9, "__esModule", {
    value: !0
  }), parse$9.default = void 0;
  var n = c(requireValidate$1());
  function c(a) {
    return a && a.__esModule ? a : { default: a };
  }
  function u(a) {
    if (!(0, n.default)(a))
      throw TypeError("Invalid UUID");
    let A;
    const b = new Uint8Array(16);
    return b[0] = (A = parseInt(a.slice(0, 8), 16)) >>> 24, b[1] = A >>> 16 & 255, b[2] = A >>> 8 & 255, b[3] = A & 255, b[4] = (A = parseInt(a.slice(9, 13), 16)) >>> 8, b[5] = A & 255, b[6] = (A = parseInt(a.slice(14, 18), 16)) >>> 8, b[7] = A & 255, b[8] = (A = parseInt(a.slice(19, 23), 16)) >>> 8, b[9] = A & 255, b[10] = (A = parseInt(a.slice(24, 36), 16)) / 1099511627776 & 255, b[11] = A / 4294967296 & 255, b[12] = A >>> 24 & 255, b[13] = A >>> 16 & 255, b[14] = A >>> 8 & 255, b[15] = A & 255, b;
  }
  var p = u;
  return parse$9.default = p, parse$9;
}
var hasRequiredV35$1;
function requireV35$1() {
  if (hasRequiredV35$1) return v35$2;
  hasRequiredV35$1 = 1, Object.defineProperty(v35$2, "__esModule", {
    value: !0
  }), v35$2.URL = v35$2.DNS = void 0, v35$2.default = b;
  var n = requireStringify$1(), c = u(requireParse$1());
  function u(F) {
    return F && F.__esModule ? F : { default: F };
  }
  function p(F) {
    F = unescape(encodeURIComponent(F));
    const le = [];
    for (let L = 0; L < F.length; ++L)
      le.push(F.charCodeAt(L));
    return le;
  }
  const a = "6ba7b810-9dad-11d1-80b4-00c04fd430c8";
  v35$2.DNS = a;
  const A = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
  v35$2.URL = A;
  function b(F, le, L) {
    function pe($, Ee, be, He) {
      var Pe;
      if (typeof $ == "string" && ($ = p($)), typeof Ee == "string" && (Ee = (0, c.default)(Ee)), ((Pe = Ee) === null || Pe === void 0 ? void 0 : Pe.length) !== 16)
        throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
      let nr = new Uint8Array(16 + $.length);
      if (nr.set(Ee), nr.set($, Ee.length), nr = L(nr), nr[6] = nr[6] & 15 | le, nr[8] = nr[8] & 63 | 128, be) {
        He = He || 0;
        for (let ir = 0; ir < 16; ++ir)
          be[He + ir] = nr[ir];
        return be;
      }
      return (0, n.unsafeStringify)(nr);
    }
    try {
      pe.name = F;
    } catch {
    }
    return pe.DNS = a, pe.URL = A, pe;
  }
  return v35$2;
}
var md5$2 = {}, hasRequiredMd5$1;
function requireMd5$1() {
  if (hasRequiredMd5$1) return md5$2;
  hasRequiredMd5$1 = 1, Object.defineProperty(md5$2, "__esModule", {
    value: !0
  }), md5$2.default = void 0;
  function n(be) {
    if (typeof be == "string") {
      const He = unescape(encodeURIComponent(be));
      be = new Uint8Array(He.length);
      for (let Pe = 0; Pe < He.length; ++Pe)
        be[Pe] = He.charCodeAt(Pe);
    }
    return c(p(a(be), be.length * 8));
  }
  function c(be) {
    const He = [], Pe = be.length * 32, nr = "0123456789abcdef";
    for (let ir = 0; ir < Pe; ir += 8) {
      const or = be[ir >> 5] >>> ir % 32 & 255, lr = parseInt(nr.charAt(or >>> 4 & 15) + nr.charAt(or & 15), 16);
      He.push(lr);
    }
    return He;
  }
  function u(be) {
    return (be + 64 >>> 9 << 4) + 14 + 1;
  }
  function p(be, He) {
    be[He >> 5] |= 128 << He % 32, be[u(He) - 1] = He;
    let Pe = 1732584193, nr = -271733879, ir = -1732584194, or = 271733878;
    for (let lr = 0; lr < be.length; lr += 16) {
      const Ir = Pe, xr = nr, kr = ir, Ce = or;
      Pe = le(Pe, nr, ir, or, be[lr], 7, -680876936), or = le(or, Pe, nr, ir, be[lr + 1], 12, -389564586), ir = le(ir, or, Pe, nr, be[lr + 2], 17, 606105819), nr = le(nr, ir, or, Pe, be[lr + 3], 22, -1044525330), Pe = le(Pe, nr, ir, or, be[lr + 4], 7, -176418897), or = le(or, Pe, nr, ir, be[lr + 5], 12, 1200080426), ir = le(ir, or, Pe, nr, be[lr + 6], 17, -1473231341), nr = le(nr, ir, or, Pe, be[lr + 7], 22, -45705983), Pe = le(Pe, nr, ir, or, be[lr + 8], 7, 1770035416), or = le(or, Pe, nr, ir, be[lr + 9], 12, -1958414417), ir = le(ir, or, Pe, nr, be[lr + 10], 17, -42063), nr = le(nr, ir, or, Pe, be[lr + 11], 22, -1990404162), Pe = le(Pe, nr, ir, or, be[lr + 12], 7, 1804603682), or = le(or, Pe, nr, ir, be[lr + 13], 12, -40341101), ir = le(ir, or, Pe, nr, be[lr + 14], 17, -1502002290), nr = le(nr, ir, or, Pe, be[lr + 15], 22, 1236535329), Pe = L(Pe, nr, ir, or, be[lr + 1], 5, -165796510), or = L(or, Pe, nr, ir, be[lr + 6], 9, -1069501632), ir = L(ir, or, Pe, nr, be[lr + 11], 14, 643717713), nr = L(nr, ir, or, Pe, be[lr], 20, -373897302), Pe = L(Pe, nr, ir, or, be[lr + 5], 5, -701558691), or = L(or, Pe, nr, ir, be[lr + 10], 9, 38016083), ir = L(ir, or, Pe, nr, be[lr + 15], 14, -660478335), nr = L(nr, ir, or, Pe, be[lr + 4], 20, -405537848), Pe = L(Pe, nr, ir, or, be[lr + 9], 5, 568446438), or = L(or, Pe, nr, ir, be[lr + 14], 9, -1019803690), ir = L(ir, or, Pe, nr, be[lr + 3], 14, -187363961), nr = L(nr, ir, or, Pe, be[lr + 8], 20, 1163531501), Pe = L(Pe, nr, ir, or, be[lr + 13], 5, -1444681467), or = L(or, Pe, nr, ir, be[lr + 2], 9, -51403784), ir = L(ir, or, Pe, nr, be[lr + 7], 14, 1735328473), nr = L(nr, ir, or, Pe, be[lr + 12], 20, -1926607734), Pe = pe(Pe, nr, ir, or, be[lr + 5], 4, -378558), or = pe(or, Pe, nr, ir, be[lr + 8], 11, -2022574463), ir = pe(ir, or, Pe, nr, be[lr + 11], 16, 1839030562), nr = pe(nr, ir, or, Pe, be[lr + 14], 23, -35309556), Pe = pe(Pe, nr, ir, or, be[lr + 1], 4, -1530992060), or = pe(or, Pe, nr, ir, be[lr + 4], 11, 1272893353), ir = pe(ir, or, Pe, nr, be[lr + 7], 16, -155497632), nr = pe(nr, ir, or, Pe, be[lr + 10], 23, -1094730640), Pe = pe(Pe, nr, ir, or, be[lr + 13], 4, 681279174), or = pe(or, Pe, nr, ir, be[lr], 11, -358537222), ir = pe(ir, or, Pe, nr, be[lr + 3], 16, -722521979), nr = pe(nr, ir, or, Pe, be[lr + 6], 23, 76029189), Pe = pe(Pe, nr, ir, or, be[lr + 9], 4, -640364487), or = pe(or, Pe, nr, ir, be[lr + 12], 11, -421815835), ir = pe(ir, or, Pe, nr, be[lr + 15], 16, 530742520), nr = pe(nr, ir, or, Pe, be[lr + 2], 23, -995338651), Pe = $(Pe, nr, ir, or, be[lr], 6, -198630844), or = $(or, Pe, nr, ir, be[lr + 7], 10, 1126891415), ir = $(ir, or, Pe, nr, be[lr + 14], 15, -1416354905), nr = $(nr, ir, or, Pe, be[lr + 5], 21, -57434055), Pe = $(Pe, nr, ir, or, be[lr + 12], 6, 1700485571), or = $(or, Pe, nr, ir, be[lr + 3], 10, -1894986606), ir = $(ir, or, Pe, nr, be[lr + 10], 15, -1051523), nr = $(nr, ir, or, Pe, be[lr + 1], 21, -2054922799), Pe = $(Pe, nr, ir, or, be[lr + 8], 6, 1873313359), or = $(or, Pe, nr, ir, be[lr + 15], 10, -30611744), ir = $(ir, or, Pe, nr, be[lr + 6], 15, -1560198380), nr = $(nr, ir, or, Pe, be[lr + 13], 21, 1309151649), Pe = $(Pe, nr, ir, or, be[lr + 4], 6, -145523070), or = $(or, Pe, nr, ir, be[lr + 11], 10, -1120210379), ir = $(ir, or, Pe, nr, be[lr + 2], 15, 718787259), nr = $(nr, ir, or, Pe, be[lr + 9], 21, -343485551), Pe = A(Pe, Ir), nr = A(nr, xr), ir = A(ir, kr), or = A(or, Ce);
    }
    return [Pe, nr, ir, or];
  }
  function a(be) {
    if (be.length === 0)
      return [];
    const He = be.length * 8, Pe = new Uint32Array(u(He));
    for (let nr = 0; nr < He; nr += 8)
      Pe[nr >> 5] |= (be[nr / 8] & 255) << nr % 32;
    return Pe;
  }
  function A(be, He) {
    const Pe = (be & 65535) + (He & 65535);
    return (be >> 16) + (He >> 16) + (Pe >> 16) << 16 | Pe & 65535;
  }
  function b(be, He) {
    return be << He | be >>> 32 - He;
  }
  function F(be, He, Pe, nr, ir, or) {
    return A(b(A(A(He, be), A(nr, or)), ir), Pe);
  }
  function le(be, He, Pe, nr, ir, or, lr) {
    return F(He & Pe | ~He & nr, be, He, ir, or, lr);
  }
  function L(be, He, Pe, nr, ir, or, lr) {
    return F(He & nr | Pe & ~nr, be, He, ir, or, lr);
  }
  function pe(be, He, Pe, nr, ir, or, lr) {
    return F(He ^ Pe ^ nr, be, He, ir, or, lr);
  }
  function $(be, He, Pe, nr, ir, or, lr) {
    return F(Pe ^ (He | ~nr), be, He, ir, or, lr);
  }
  var Ee = n;
  return md5$2.default = Ee, md5$2;
}
var hasRequiredV3$1;
function requireV3$1() {
  if (hasRequiredV3$1) return v3$2;
  hasRequiredV3$1 = 1, Object.defineProperty(v3$2, "__esModule", {
    value: !0
  }), v3$2.default = void 0;
  var n = u(requireV35$1()), c = u(requireMd5$1());
  function u(A) {
    return A && A.__esModule ? A : { default: A };
  }
  var a = (0, n.default)("v3", 48, c.default);
  return v3$2.default = a, v3$2;
}
var v4$3 = {}, native$2 = {}, hasRequiredNative$1;
function requireNative$1() {
  if (hasRequiredNative$1) return native$2;
  hasRequiredNative$1 = 1, Object.defineProperty(native$2, "__esModule", {
    value: !0
  }), native$2.default = void 0;
  var c = {
    randomUUID: typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto)
  };
  return native$2.default = c, native$2;
}
var hasRequiredV4$1;
function requireV4$1() {
  if (hasRequiredV4$1) return v4$3;
  hasRequiredV4$1 = 1, Object.defineProperty(v4$3, "__esModule", {
    value: !0
  }), v4$3.default = void 0;
  var n = p(requireNative$1()), c = p(requireRng$1()), u = requireStringify$1();
  function p(b) {
    return b && b.__esModule ? b : { default: b };
  }
  function a(b, F, le) {
    if (n.default.randomUUID && !F && !b)
      return n.default.randomUUID();
    b = b || {};
    const L = b.random || (b.rng || c.default)();
    if (L[6] = L[6] & 15 | 64, L[8] = L[8] & 63 | 128, F) {
      le = le || 0;
      for (let pe = 0; pe < 16; ++pe)
        F[le + pe] = L[pe];
      return F;
    }
    return (0, u.unsafeStringify)(L);
  }
  var A = a;
  return v4$3.default = A, v4$3;
}
var v5$2 = {}, sha1$2 = {}, hasRequiredSha1$1;
function requireSha1$1() {
  if (hasRequiredSha1$1) return sha1$2;
  hasRequiredSha1$1 = 1, Object.defineProperty(sha1$2, "__esModule", {
    value: !0
  }), sha1$2.default = void 0;
  function n(a, A, b, F) {
    switch (a) {
      case 0:
        return A & b ^ ~A & F;
      case 1:
        return A ^ b ^ F;
      case 2:
        return A & b ^ A & F ^ b & F;
      case 3:
        return A ^ b ^ F;
    }
  }
  function c(a, A) {
    return a << A | a >>> 32 - A;
  }
  function u(a) {
    const A = [1518500249, 1859775393, 2400959708, 3395469782], b = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
    if (typeof a == "string") {
      const pe = unescape(encodeURIComponent(a));
      a = [];
      for (let $ = 0; $ < pe.length; ++$)
        a.push(pe.charCodeAt($));
    } else Array.isArray(a) || (a = Array.prototype.slice.call(a));
    a.push(128);
    const F = a.length / 4 + 2, le = Math.ceil(F / 16), L = new Array(le);
    for (let pe = 0; pe < le; ++pe) {
      const $ = new Uint32Array(16);
      for (let Ee = 0; Ee < 16; ++Ee)
        $[Ee] = a[pe * 64 + Ee * 4] << 24 | a[pe * 64 + Ee * 4 + 1] << 16 | a[pe * 64 + Ee * 4 + 2] << 8 | a[pe * 64 + Ee * 4 + 3];
      L[pe] = $;
    }
    L[le - 1][14] = (a.length - 1) * 8 / Math.pow(2, 32), L[le - 1][14] = Math.floor(L[le - 1][14]), L[le - 1][15] = (a.length - 1) * 8 & 4294967295;
    for (let pe = 0; pe < le; ++pe) {
      const $ = new Uint32Array(80);
      for (let ir = 0; ir < 16; ++ir)
        $[ir] = L[pe][ir];
      for (let ir = 16; ir < 80; ++ir)
        $[ir] = c($[ir - 3] ^ $[ir - 8] ^ $[ir - 14] ^ $[ir - 16], 1);
      let Ee = b[0], be = b[1], He = b[2], Pe = b[3], nr = b[4];
      for (let ir = 0; ir < 80; ++ir) {
        const or = Math.floor(ir / 20), lr = c(Ee, 5) + n(or, be, He, Pe) + nr + A[or] + $[ir] >>> 0;
        nr = Pe, Pe = He, He = c(be, 30) >>> 0, be = Ee, Ee = lr;
      }
      b[0] = b[0] + Ee >>> 0, b[1] = b[1] + be >>> 0, b[2] = b[2] + He >>> 0, b[3] = b[3] + Pe >>> 0, b[4] = b[4] + nr >>> 0;
    }
    return [b[0] >> 24 & 255, b[0] >> 16 & 255, b[0] >> 8 & 255, b[0] & 255, b[1] >> 24 & 255, b[1] >> 16 & 255, b[1] >> 8 & 255, b[1] & 255, b[2] >> 24 & 255, b[2] >> 16 & 255, b[2] >> 8 & 255, b[2] & 255, b[3] >> 24 & 255, b[3] >> 16 & 255, b[3] >> 8 & 255, b[3] & 255, b[4] >> 24 & 255, b[4] >> 16 & 255, b[4] >> 8 & 255, b[4] & 255];
  }
  var p = u;
  return sha1$2.default = p, sha1$2;
}
var hasRequiredV5$1;
function requireV5$1() {
  if (hasRequiredV5$1) return v5$2;
  hasRequiredV5$1 = 1, Object.defineProperty(v5$2, "__esModule", {
    value: !0
  }), v5$2.default = void 0;
  var n = u(requireV35$1()), c = u(requireSha1$1());
  function u(A) {
    return A && A.__esModule ? A : { default: A };
  }
  var a = (0, n.default)("v5", 80, c.default);
  return v5$2.default = a, v5$2;
}
var nil$2 = {}, hasRequiredNil$1;
function requireNil$1() {
  if (hasRequiredNil$1) return nil$2;
  hasRequiredNil$1 = 1, Object.defineProperty(nil$2, "__esModule", {
    value: !0
  }), nil$2.default = void 0;
  var n = "00000000-0000-0000-0000-000000000000";
  return nil$2.default = n, nil$2;
}
var version$3 = {}, hasRequiredVersion$1;
function requireVersion$1() {
  if (hasRequiredVersion$1) return version$3;
  hasRequiredVersion$1 = 1, Object.defineProperty(version$3, "__esModule", {
    value: !0
  }), version$3.default = void 0;
  var n = c(requireValidate$1());
  function c(a) {
    return a && a.__esModule ? a : { default: a };
  }
  function u(a) {
    if (!(0, n.default)(a))
      throw TypeError("Invalid UUID");
    return parseInt(a.slice(14, 15), 16);
  }
  var p = u;
  return version$3.default = p, version$3;
}
var hasRequiredCommonjsBrowser$1;
function requireCommonjsBrowser$1() {
  return hasRequiredCommonjsBrowser$1 || (hasRequiredCommonjsBrowser$1 = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "NIL", {
      enumerable: !0,
      get: function() {
        return A.default;
      }
    }), Object.defineProperty(n, "parse", {
      enumerable: !0,
      get: function() {
        return L.default;
      }
    }), Object.defineProperty(n, "stringify", {
      enumerable: !0,
      get: function() {
        return le.default;
      }
    }), Object.defineProperty(n, "v1", {
      enumerable: !0,
      get: function() {
        return c.default;
      }
    }), Object.defineProperty(n, "v3", {
      enumerable: !0,
      get: function() {
        return u.default;
      }
    }), Object.defineProperty(n, "v4", {
      enumerable: !0,
      get: function() {
        return p.default;
      }
    }), Object.defineProperty(n, "v5", {
      enumerable: !0,
      get: function() {
        return a.default;
      }
    }), Object.defineProperty(n, "validate", {
      enumerable: !0,
      get: function() {
        return F.default;
      }
    }), Object.defineProperty(n, "version", {
      enumerable: !0,
      get: function() {
        return b.default;
      }
    });
    var c = pe(requireV1$1()), u = pe(requireV3$1()), p = pe(requireV4$1()), a = pe(requireV5$1()), A = pe(requireNil$1()), b = pe(requireVersion$1()), F = pe(requireValidate$1()), le = pe(requireStringify$1()), L = pe(requireParse$1());
    function pe($) {
      return $ && $.__esModule ? $ : { default: $ };
    }
  }(commonjsBrowser$1)), commonjsBrowser$1;
}
var hasRequiredBcUrRegistrySui_cjs_production_min;
function requireBcUrRegistrySui_cjs_production_min() {
  return hasRequiredBcUrRegistrySui_cjs_production_min || (hasRequiredBcUrRegistrySui_cjs_production_min = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 });
    var c = requireDist$2(), u = requireCommonjsBrowser$1();
    const p = { SUI_SIGN_REQUEST: new c.RegistryType("sui-sign-request", 7101), SUI_SIGNATURE: new c.RegistryType("sui-signature", 7102), SUI_SIGN_HASH_REQUEST: new c.RegistryType("sui-sign-hash-request", 7103) }, { decodeToDataItem: a, RegistryTypes: A } = c.extend;
    var b;
    (function(nr) {
      nr[nr.requestId = 1] = "requestId", nr[nr.intentMessage = 2] = "intentMessage", nr[nr.derivationPaths = 3] = "derivationPaths", nr[nr.addresses = 4] = "addresses", nr[nr.origin = 5] = "origin";
    })(b || (b = {}));
    class F extends c.RegistryItem {
      constructor(ir) {
        super(), this.getRegistryType = () => p.SUI_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getIntentMessage = () => this.intentMessage, this.getDerivationPaths = () => this.derivationPaths.map((or) => or.getPath()), this.getAddresses = () => this.addresses, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const or = {};
          return this.requestId && (or[b.requestId] = new c.DataItem(this.requestId, A.UUID.getTag())), this.addresses && (or[b.addresses] = this.addresses), this.origin && (or[b.origin] = this.origin), or[b.intentMessage] = this.intentMessage, or[b.derivationPaths] = this.derivationPaths.map((lr) => {
            const Ir = lr.toDataItem();
            return Ir.setTag(lr.getRegistryType().getTag()), Ir;
          }), new c.DataItem(or);
        }, this.requestId = ir.requestId, this.intentMessage = ir.intentMessage, this.derivationPaths = ir.derivationPaths, this.addresses = ir.addresses, this.origin = ir.origin;
      }
      static constructSuiRequest(ir, or, lr, Ir, xr, kr) {
        const Ce = or.map((tr, Fe) => {
          const Sr = tr.replace(/[m|M]\//, "").split("/").map((er) => {
            const Ie = parseInt(er.replace("'", ""));
            let xe = !1;
            return er.endsWith("'") && (xe = !0), new c.PathComponent({ index: Ie, hardened: xe });
          });
          return new c.CryptoKeypath(Sr, Buffer$f.from(lr[Fe], "hex"));
        });
        return new F({ requestId: Buffer$f.from(u.parse(Ir)), intentMessage: ir, derivationPaths: Ce, addresses: xr || void 0, origin: kr || void 0 });
      }
    }
    F.fromDataItem = (nr) => {
      const ir = nr.getData(), or = ir[b.intentMessage], lr = ir[b.derivationPaths].map((kr) => c.CryptoKeypath.fromDataItem(kr)), Ir = ir[b.addresses] ? ir[b.addresses] : void 0, xr = ir[b.requestId] ? ir[b.requestId].getData() : void 0;
      return new F({ requestId: xr, intentMessage: or, derivationPaths: lr, addresses: Ir, origin: ir[b.origin] ? ir[b.origin] : void 0 });
    }, F.fromCBOR = (nr) => {
      const ir = a(nr);
      return F.fromDataItem(ir);
    };
    const { RegistryTypes: le, decodeToDataItem: L } = c.extend;
    var pe;
    (function(nr) {
      nr[nr.requestId = 1] = "requestId", nr[nr.signature = 2] = "signature", nr[nr.publicKey = 3] = "publicKey";
    })(pe || (pe = {}));
    class $ extends c.RegistryItem {
      constructor(ir, or, lr) {
        super(), this.getRegistryType = () => p.SUI_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.getPublicKey = () => this.publicKey, this.toDataItem = () => {
          const Ir = {};
          return this.requestId && (Ir[pe.requestId] = new c.DataItem(this.requestId, le.UUID.getTag())), Ir[pe.signature] = this.signature, this.publicKey && (Ir[pe.publicKey] = this.publicKey), new c.DataItem(Ir);
        }, this.signature = ir, this.requestId = or, this.publicKey = lr;
      }
    }
    $.fromDataItem = (nr) => {
      const ir = nr.getData(), or = ir[pe.signature], lr = ir[pe.requestId].getData();
      return new $(or, lr, ir[pe.publicKey]);
    }, $.fromCBOR = (nr) => {
      const ir = L(nr);
      return $.fromDataItem(ir);
    };
    const { decodeToDataItem: Ee, RegistryTypes: be } = c.extend;
    var He;
    (function(nr) {
      nr[nr.requestId = 1] = "requestId", nr[nr.messageHash = 2] = "messageHash", nr[nr.derivationPaths = 3] = "derivationPaths", nr[nr.addresses = 4] = "addresses", nr[nr.origin = 5] = "origin";
    })(He || (He = {}));
    class Pe extends c.RegistryItem {
      constructor(ir) {
        super(), this.getRegistryType = () => p.SUI_SIGN_HASH_REQUEST, this.getRequestId = () => this.requestId, this.getMessageHash = () => this.messageHash, this.getDerivationPaths = () => this.derivationPaths.map((or) => or.getPath()), this.getAddresses = () => this.addresses, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const or = {};
          return this.requestId && (or[He.requestId] = new c.DataItem(this.requestId, be.UUID.getTag())), this.addresses && (or[He.addresses] = this.addresses), this.origin && (or[He.origin] = this.origin), or[He.messageHash] = this.messageHash, or[He.derivationPaths] = this.derivationPaths.map((lr) => {
            const Ir = lr.toDataItem();
            return Ir.setTag(lr.getRegistryType().getTag()), Ir;
          }), new c.DataItem(or);
        }, this.requestId = ir.requestId, this.messageHash = ir.messageHash, this.derivationPaths = ir.derivationPaths, this.addresses = ir.addresses, this.origin = ir.origin;
      }
      static constructSuiRequest(ir, or, lr, Ir, xr, kr) {
        const Ce = or.map((tr, Fe) => {
          const Sr = tr.replace(/[m|M]\//, "").split("/").map((er) => {
            const Ie = parseInt(er.replace("'", ""));
            let xe = !1;
            return er.endsWith("'") && (xe = !0), new c.PathComponent({ index: Ie, hardened: xe });
          });
          return new c.CryptoKeypath(Sr, Buffer$f.from(lr[Fe], "hex"));
        });
        return new Pe({ requestId: Buffer$f.from(u.parse(Ir)), messageHash: ir, derivationPaths: Ce, addresses: xr || void 0, origin: kr || void 0 });
      }
    }
    Pe.fromDataItem = (nr) => {
      const ir = nr.getData(), or = ir[He.messageHash], lr = ir[He.derivationPaths].map((kr) => c.CryptoKeypath.fromDataItem(kr)), Ir = ir[He.addresses] ? ir[He.addresses] : void 0, xr = ir[He.requestId] ? ir[He.requestId].getData() : void 0;
      return new Pe({ requestId: xr, messageHash: or, derivationPaths: lr, addresses: Ir, origin: ir[He.origin] ? ir[He.origin] : void 0 });
    }, Pe.fromCBOR = (nr) => {
      const ir = Ee(nr);
      return Pe.fromDataItem(ir);
    }, c.patchTags(Object.values(p).filter((nr) => !!nr.getTag()).map((nr) => nr.getTag())), Object.keys(c).forEach(function(nr) {
      nr !== "default" && Object.defineProperty(n, nr, { enumerable: !0, get: function() {
        return c[nr];
      } });
    }), n.SuiSignHashRequest = Pe, n.SuiSignRequest = F, n.SuiSignature = $;
  }(bcUrRegistrySui_cjs_production_min)), bcUrRegistrySui_cjs_production_min;
}
var bcUrRegistrySui_cjs_development = {}, hasRequiredBcUrRegistrySui_cjs_development;
function requireBcUrRegistrySui_cjs_development() {
  return hasRequiredBcUrRegistrySui_cjs_development || (hasRequiredBcUrRegistrySui_cjs_development = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 });
    var c = requireDist$2(), u = requireCommonjsBrowser$1();
    const p = {
      SUI_SIGN_REQUEST: /* @__PURE__ */ new c.RegistryType("sui-sign-request", 7101),
      SUI_SIGNATURE: /* @__PURE__ */ new c.RegistryType("sui-signature", 7102),
      SUI_SIGN_HASH_REQUEST: /* @__PURE__ */ new c.RegistryType("sui-sign-hash-request", 7103)
    }, {
      decodeToDataItem: a,
      RegistryTypes: A
    } = c.extend;
    var b;
    (function(nr) {
      nr[nr.requestId = 1] = "requestId", nr[nr.intentMessage = 2] = "intentMessage", nr[nr.derivationPaths = 3] = "derivationPaths", nr[nr.addresses = 4] = "addresses", nr[nr.origin = 5] = "origin";
    })(b || (b = {}));
    class F extends c.RegistryItem {
      constructor(ir) {
        super(), this.getRegistryType = () => p.SUI_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getIntentMessage = () => this.intentMessage, this.getDerivationPaths = () => this.derivationPaths.map((or) => or.getPath()), this.getAddresses = () => this.addresses, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const or = {};
          return this.requestId && (or[b.requestId] = new c.DataItem(this.requestId, A.UUID.getTag())), this.addresses && (or[b.addresses] = this.addresses), this.origin && (or[b.origin] = this.origin), or[b.intentMessage] = this.intentMessage, or[b.derivationPaths] = this.derivationPaths.map((lr) => {
            const Ir = lr.toDataItem();
            return Ir.setTag(lr.getRegistryType().getTag()), Ir;
          }), new c.DataItem(or);
        }, this.requestId = ir.requestId, this.intentMessage = ir.intentMessage, this.derivationPaths = ir.derivationPaths, this.addresses = ir.addresses, this.origin = ir.origin;
      }
      static constructSuiRequest(ir, or, lr, Ir, xr, kr) {
        const Ce = or.map((tr, Fe) => {
          const er = tr.replace(/[m|M]\//, "").split("/").map((Ie) => {
            const xe = parseInt(Ie.replace("'", ""));
            let rr = !1;
            return Ie.endsWith("'") && (rr = !0), new c.PathComponent({
              index: xe,
              hardened: rr
            });
          });
          return new c.CryptoKeypath(er, Buffer$f.from(lr[Fe], "hex"));
        });
        return new F({
          requestId: Buffer$f.from(u.parse(Ir)),
          intentMessage: ir,
          derivationPaths: Ce,
          addresses: xr || void 0,
          origin: kr || void 0
        });
      }
    }
    F.fromDataItem = (nr) => {
      const ir = nr.getData(), or = ir[b.intentMessage], lr = ir[b.derivationPaths].map((Ce) => c.CryptoKeypath.fromDataItem(Ce)), Ir = ir[b.addresses] ? ir[b.addresses] : void 0, xr = ir[b.requestId] ? ir[b.requestId].getData() : void 0, kr = ir[b.origin] ? ir[b.origin] : void 0;
      return new F({
        requestId: xr,
        intentMessage: or,
        derivationPaths: lr,
        addresses: Ir,
        origin: kr
      });
    }, F.fromCBOR = (nr) => {
      const ir = a(nr);
      return F.fromDataItem(ir);
    };
    const {
      RegistryTypes: le,
      decodeToDataItem: L
    } = c.extend;
    var pe;
    (function(nr) {
      nr[nr.requestId = 1] = "requestId", nr[nr.signature = 2] = "signature", nr[nr.publicKey = 3] = "publicKey";
    })(pe || (pe = {}));
    class $ extends c.RegistryItem {
      constructor(ir, or, lr) {
        super(), this.getRegistryType = () => p.SUI_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.getPublicKey = () => this.publicKey, this.toDataItem = () => {
          const Ir = {};
          return this.requestId && (Ir[pe.requestId] = new c.DataItem(this.requestId, le.UUID.getTag())), Ir[pe.signature] = this.signature, this.publicKey && (Ir[pe.publicKey] = this.publicKey), new c.DataItem(Ir);
        }, this.signature = ir, this.requestId = or, this.publicKey = lr;
      }
    }
    $.fromDataItem = (nr) => {
      const ir = nr.getData(), or = ir[pe.signature], lr = ir[pe.requestId].getData(), Ir = ir[pe.publicKey];
      return new $(or, lr, Ir);
    }, $.fromCBOR = (nr) => {
      const ir = L(nr);
      return $.fromDataItem(ir);
    };
    const {
      decodeToDataItem: Ee,
      RegistryTypes: be
    } = c.extend;
    var He;
    (function(nr) {
      nr[nr.requestId = 1] = "requestId", nr[nr.messageHash = 2] = "messageHash", nr[nr.derivationPaths = 3] = "derivationPaths", nr[nr.addresses = 4] = "addresses", nr[nr.origin = 5] = "origin";
    })(He || (He = {}));
    class Pe extends c.RegistryItem {
      constructor(ir) {
        super(), this.getRegistryType = () => p.SUI_SIGN_HASH_REQUEST, this.getRequestId = () => this.requestId, this.getMessageHash = () => this.messageHash, this.getDerivationPaths = () => this.derivationPaths.map((or) => or.getPath()), this.getAddresses = () => this.addresses, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const or = {};
          return this.requestId && (or[He.requestId] = new c.DataItem(this.requestId, be.UUID.getTag())), this.addresses && (or[He.addresses] = this.addresses), this.origin && (or[He.origin] = this.origin), or[He.messageHash] = this.messageHash, or[He.derivationPaths] = this.derivationPaths.map((lr) => {
            const Ir = lr.toDataItem();
            return Ir.setTag(lr.getRegistryType().getTag()), Ir;
          }), new c.DataItem(or);
        }, this.requestId = ir.requestId, this.messageHash = ir.messageHash, this.derivationPaths = ir.derivationPaths, this.addresses = ir.addresses, this.origin = ir.origin;
      }
      static constructSuiRequest(ir, or, lr, Ir, xr, kr) {
        const Ce = or.map((tr, Fe) => {
          const er = tr.replace(/[m|M]\//, "").split("/").map((Ie) => {
            const xe = parseInt(Ie.replace("'", ""));
            let rr = !1;
            return Ie.endsWith("'") && (rr = !0), new c.PathComponent({
              index: xe,
              hardened: rr
            });
          });
          return new c.CryptoKeypath(er, Buffer$f.from(lr[Fe], "hex"));
        });
        return new Pe({
          requestId: Buffer$f.from(u.parse(Ir)),
          messageHash: ir,
          derivationPaths: Ce,
          addresses: xr || void 0,
          origin: kr || void 0
        });
      }
    }
    Pe.fromDataItem = (nr) => {
      const ir = nr.getData(), or = ir[He.messageHash], lr = ir[He.derivationPaths].map((Ce) => c.CryptoKeypath.fromDataItem(Ce)), Ir = ir[He.addresses] ? ir[He.addresses] : void 0, xr = ir[He.requestId] ? ir[He.requestId].getData() : void 0, kr = ir[He.origin] ? ir[He.origin] : void 0;
      return new Pe({
        requestId: xr,
        messageHash: or,
        derivationPaths: lr,
        addresses: Ir,
        origin: kr
      });
    }, Pe.fromCBOR = (nr) => {
      const ir = Ee(nr);
      return Pe.fromDataItem(ir);
    }, c.patchTags(Object.values(p).filter((nr) => !!nr.getTag()).map((nr) => nr.getTag())), Object.keys(c).forEach(function(nr) {
      nr !== "default" && Object.defineProperty(n, nr, {
        enumerable: !0,
        get: function() {
          return c[nr];
        }
      });
    }), n.SuiSignHashRequest = Pe, n.SuiSignRequest = F, n.SuiSignature = $;
  }(bcUrRegistrySui_cjs_development)), bcUrRegistrySui_cjs_development;
}
process$1.env.NODE_ENV === "production" ? dist$9.exports = requireBcUrRegistrySui_cjs_production_min() : dist$9.exports = requireBcUrRegistrySui_cjs_development();
var distExports$2 = dist$9.exports, blake2b = {}, blake2 = {}, _blake = {};
Object.defineProperty(_blake, "__esModule", { value: !0 });
_blake.BSIGMA = void 0;
_blake.G1s = G1s;
_blake.G2s = G2s;
const utils_ts_1$3 = utils$O;
_blake.BSIGMA = Uint8Array.from([
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  14,
  10,
  4,
  8,
  9,
  15,
  13,
  6,
  1,
  12,
  0,
  2,
  11,
  7,
  5,
  3,
  11,
  8,
  12,
  0,
  5,
  2,
  15,
  13,
  10,
  14,
  3,
  6,
  7,
  1,
  9,
  4,
  7,
  9,
  3,
  1,
  13,
  12,
  11,
  14,
  2,
  6,
  5,
  10,
  4,
  0,
  15,
  8,
  9,
  0,
  5,
  7,
  2,
  4,
  10,
  15,
  14,
  1,
  11,
  12,
  6,
  8,
  3,
  13,
  2,
  12,
  6,
  10,
  0,
  11,
  8,
  3,
  4,
  13,
  7,
  5,
  15,
  14,
  1,
  9,
  12,
  5,
  1,
  15,
  14,
  13,
  4,
  10,
  0,
  7,
  6,
  3,
  9,
  2,
  8,
  11,
  13,
  11,
  7,
  14,
  12,
  1,
  3,
  9,
  5,
  0,
  15,
  4,
  8,
  6,
  2,
  10,
  6,
  15,
  14,
  9,
  11,
  3,
  0,
  8,
  12,
  2,
  13,
  7,
  1,
  4,
  10,
  5,
  10,
  2,
  8,
  4,
  7,
  6,
  1,
  5,
  15,
  11,
  9,
  14,
  3,
  12,
  13,
  0,
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  14,
  10,
  4,
  8,
  9,
  15,
  13,
  6,
  1,
  12,
  0,
  2,
  11,
  7,
  5,
  3,
  // Blake1, unused in others
  11,
  8,
  12,
  0,
  5,
  2,
  15,
  13,
  10,
  14,
  3,
  6,
  7,
  1,
  9,
  4,
  7,
  9,
  3,
  1,
  13,
  12,
  11,
  14,
  2,
  6,
  5,
  10,
  4,
  0,
  15,
  8,
  9,
  0,
  5,
  7,
  2,
  4,
  10,
  15,
  14,
  1,
  11,
  12,
  6,
  8,
  3,
  13,
  2,
  12,
  6,
  10,
  0,
  11,
  8,
  3,
  4,
  13,
  7,
  5,
  15,
  14,
  1,
  9
]);
function G1s(n, c, u, p, a) {
  return n = n + c + a | 0, p = (0, utils_ts_1$3.rotr)(p ^ n, 16), u = u + p | 0, c = (0, utils_ts_1$3.rotr)(c ^ u, 12), { a: n, b: c, c: u, d: p };
}
function G2s(n, c, u, p, a) {
  return n = n + c + a | 0, p = (0, utils_ts_1$3.rotr)(p ^ n, 8), u = u + p | 0, c = (0, utils_ts_1$3.rotr)(c ^ u, 7), { a: n, b: c, c: u, d: p };
}
Object.defineProperty(blake2, "__esModule", { value: !0 });
blake2.blake2s = blake2.BLAKE2s = blake2.blake2b = blake2.BLAKE2b = blake2.BLAKE2 = void 0;
blake2.compress = compress;
const _blake_ts_1 = _blake, _md_ts_1 = _md$2, u64$3 = _u64$1, utils_ts_1$2 = utils$O, B2B_IV = /* @__PURE__ */ Uint32Array.from([
  4089235720,
  1779033703,
  2227873595,
  3144134277,
  4271175723,
  1013904242,
  1595750129,
  2773480762,
  2917565137,
  1359893119,
  725511199,
  2600822924,
  4215389547,
  528734635,
  327033209,
  1541459225
]), BBUF = /* @__PURE__ */ new Uint32Array(32);
function G1b(n, c, u, p, a, A) {
  const b = a[A], F = a[A + 1];
  let le = BBUF[2 * n], L = BBUF[2 * n + 1], pe = BBUF[2 * c], $ = BBUF[2 * c + 1], Ee = BBUF[2 * u], be = BBUF[2 * u + 1], He = BBUF[2 * p], Pe = BBUF[2 * p + 1], nr = u64$3.add3L(le, pe, b);
  L = u64$3.add3H(nr, L, $, F), le = nr | 0, { Dh: Pe, Dl: He } = { Dh: Pe ^ L, Dl: He ^ le }, { Dh: Pe, Dl: He } = { Dh: u64$3.rotr32H(Pe, He), Dl: u64$3.rotr32L(Pe, He) }, { h: be, l: Ee } = u64$3.add(be, Ee, Pe, He), { Bh: $, Bl: pe } = { Bh: $ ^ be, Bl: pe ^ Ee }, { Bh: $, Bl: pe } = { Bh: u64$3.rotrSH($, pe, 24), Bl: u64$3.rotrSL($, pe, 24) }, BBUF[2 * n] = le, BBUF[2 * n + 1] = L, BBUF[2 * c] = pe, BBUF[2 * c + 1] = $, BBUF[2 * u] = Ee, BBUF[2 * u + 1] = be, BBUF[2 * p] = He, BBUF[2 * p + 1] = Pe;
}
function G2b(n, c, u, p, a, A) {
  const b = a[A], F = a[A + 1];
  let le = BBUF[2 * n], L = BBUF[2 * n + 1], pe = BBUF[2 * c], $ = BBUF[2 * c + 1], Ee = BBUF[2 * u], be = BBUF[2 * u + 1], He = BBUF[2 * p], Pe = BBUF[2 * p + 1], nr = u64$3.add3L(le, pe, b);
  L = u64$3.add3H(nr, L, $, F), le = nr | 0, { Dh: Pe, Dl: He } = { Dh: Pe ^ L, Dl: He ^ le }, { Dh: Pe, Dl: He } = { Dh: u64$3.rotrSH(Pe, He, 16), Dl: u64$3.rotrSL(Pe, He, 16) }, { h: be, l: Ee } = u64$3.add(be, Ee, Pe, He), { Bh: $, Bl: pe } = { Bh: $ ^ be, Bl: pe ^ Ee }, { Bh: $, Bl: pe } = { Bh: u64$3.rotrBH($, pe, 63), Bl: u64$3.rotrBL($, pe, 63) }, BBUF[2 * n] = le, BBUF[2 * n + 1] = L, BBUF[2 * c] = pe, BBUF[2 * c + 1] = $, BBUF[2 * u] = Ee, BBUF[2 * u + 1] = be, BBUF[2 * p] = He, BBUF[2 * p + 1] = Pe;
}
function checkBlake2Opts(n, c = {}, u, p, a) {
  if ((0, utils_ts_1$2.anumber)(u), n < 0 || n > u)
    throw new Error("outputLen bigger than keyLen");
  const { key: A, salt: b, personalization: F } = c;
  if (A !== void 0 && (A.length < 1 || A.length > u))
    throw new Error("key length must be undefined or 1.." + u);
  if (b !== void 0 && b.length !== p)
    throw new Error("salt must be undefined or " + p);
  if (F !== void 0 && F.length !== a)
    throw new Error("personalization must be undefined or " + a);
}
class BLAKE2 extends utils_ts_1$2.Hash {
  constructor(c, u) {
    super(), this.finished = !1, this.destroyed = !1, this.length = 0, this.pos = 0, (0, utils_ts_1$2.anumber)(c), (0, utils_ts_1$2.anumber)(u), this.blockLen = c, this.outputLen = u, this.buffer = new Uint8Array(c), this.buffer32 = (0, utils_ts_1$2.u32)(this.buffer);
  }
  update(c) {
    (0, utils_ts_1$2.aexists)(this), c = (0, utils_ts_1$2.toBytes)(c), (0, utils_ts_1$2.abytes)(c);
    const { blockLen: u, buffer: p, buffer32: a } = this, A = c.length, b = c.byteOffset, F = c.buffer;
    for (let le = 0; le < A; ) {
      this.pos === u && ((0, utils_ts_1$2.swap32IfBE)(a), this.compress(a, 0, !1), (0, utils_ts_1$2.swap32IfBE)(a), this.pos = 0);
      const L = Math.min(u - this.pos, A - le), pe = b + le;
      if (L === u && !(pe % 4) && le + L < A) {
        const $ = new Uint32Array(F, pe, Math.floor((A - le) / 4));
        (0, utils_ts_1$2.swap32IfBE)($);
        for (let Ee = 0; le + u < A; Ee += a.length, le += u)
          this.length += u, this.compress($, Ee, !1);
        (0, utils_ts_1$2.swap32IfBE)($);
        continue;
      }
      p.set(c.subarray(le, le + L), this.pos), this.pos += L, this.length += L, le += L;
    }
    return this;
  }
  digestInto(c) {
    (0, utils_ts_1$2.aexists)(this), (0, utils_ts_1$2.aoutput)(c, this);
    const { pos: u, buffer32: p } = this;
    this.finished = !0, (0, utils_ts_1$2.clean)(this.buffer.subarray(u)), (0, utils_ts_1$2.swap32IfBE)(p), this.compress(p, 0, !0), (0, utils_ts_1$2.swap32IfBE)(p);
    const a = (0, utils_ts_1$2.u32)(c);
    this.get().forEach((A, b) => a[b] = (0, utils_ts_1$2.swap8IfBE)(A));
  }
  digest() {
    const { buffer: c, outputLen: u } = this;
    this.digestInto(c);
    const p = c.slice(0, u);
    return this.destroy(), p;
  }
  _cloneInto(c) {
    const { buffer: u, length: p, finished: a, destroyed: A, outputLen: b, pos: F } = this;
    return c || (c = new this.constructor({ dkLen: b })), c.set(...this.get()), c.buffer.set(u), c.destroyed = A, c.finished = a, c.length = p, c.pos = F, c.outputLen = b, c;
  }
  clone() {
    return this._cloneInto();
  }
}
blake2.BLAKE2 = BLAKE2;
class BLAKE2b extends BLAKE2 {
  constructor(c = {}) {
    const u = c.dkLen === void 0 ? 64 : c.dkLen;
    super(128, u), this.v0l = B2B_IV[0] | 0, this.v0h = B2B_IV[1] | 0, this.v1l = B2B_IV[2] | 0, this.v1h = B2B_IV[3] | 0, this.v2l = B2B_IV[4] | 0, this.v2h = B2B_IV[5] | 0, this.v3l = B2B_IV[6] | 0, this.v3h = B2B_IV[7] | 0, this.v4l = B2B_IV[8] | 0, this.v4h = B2B_IV[9] | 0, this.v5l = B2B_IV[10] | 0, this.v5h = B2B_IV[11] | 0, this.v6l = B2B_IV[12] | 0, this.v6h = B2B_IV[13] | 0, this.v7l = B2B_IV[14] | 0, this.v7h = B2B_IV[15] | 0, checkBlake2Opts(u, c, 64, 16, 16);
    let { key: p, personalization: a, salt: A } = c, b = 0;
    if (p !== void 0 && (p = (0, utils_ts_1$2.toBytes)(p), b = p.length), this.v0l ^= this.outputLen | b << 8 | 65536 | 1 << 24, A !== void 0) {
      A = (0, utils_ts_1$2.toBytes)(A);
      const F = (0, utils_ts_1$2.u32)(A);
      this.v4l ^= (0, utils_ts_1$2.swap8IfBE)(F[0]), this.v4h ^= (0, utils_ts_1$2.swap8IfBE)(F[1]), this.v5l ^= (0, utils_ts_1$2.swap8IfBE)(F[2]), this.v5h ^= (0, utils_ts_1$2.swap8IfBE)(F[3]);
    }
    if (a !== void 0) {
      a = (0, utils_ts_1$2.toBytes)(a);
      const F = (0, utils_ts_1$2.u32)(a);
      this.v6l ^= (0, utils_ts_1$2.swap8IfBE)(F[0]), this.v6h ^= (0, utils_ts_1$2.swap8IfBE)(F[1]), this.v7l ^= (0, utils_ts_1$2.swap8IfBE)(F[2]), this.v7h ^= (0, utils_ts_1$2.swap8IfBE)(F[3]);
    }
    if (p !== void 0) {
      const F = new Uint8Array(this.blockLen);
      F.set(p), this.update(F);
    }
  }
  // prettier-ignore
  get() {
    let { v0l: c, v0h: u, v1l: p, v1h: a, v2l: A, v2h: b, v3l: F, v3h: le, v4l: L, v4h: pe, v5l: $, v5h: Ee, v6l: be, v6h: He, v7l: Pe, v7h: nr } = this;
    return [c, u, p, a, A, b, F, le, L, pe, $, Ee, be, He, Pe, nr];
  }
  // prettier-ignore
  set(c, u, p, a, A, b, F, le, L, pe, $, Ee, be, He, Pe, nr) {
    this.v0l = c | 0, this.v0h = u | 0, this.v1l = p | 0, this.v1h = a | 0, this.v2l = A | 0, this.v2h = b | 0, this.v3l = F | 0, this.v3h = le | 0, this.v4l = L | 0, this.v4h = pe | 0, this.v5l = $ | 0, this.v5h = Ee | 0, this.v6l = be | 0, this.v6h = He | 0, this.v7l = Pe | 0, this.v7h = nr | 0;
  }
  compress(c, u, p) {
    this.get().forEach((le, L) => BBUF[L] = le), BBUF.set(B2B_IV, 16);
    let { h: a, l: A } = u64$3.fromBig(BigInt(this.length));
    BBUF[24] = B2B_IV[8] ^ A, BBUF[25] = B2B_IV[9] ^ a, p && (BBUF[28] = ~BBUF[28], BBUF[29] = ~BBUF[29]);
    let b = 0;
    const F = _blake_ts_1.BSIGMA;
    for (let le = 0; le < 12; le++)
      G1b(0, 4, 8, 12, c, u + 2 * F[b++]), G2b(0, 4, 8, 12, c, u + 2 * F[b++]), G1b(1, 5, 9, 13, c, u + 2 * F[b++]), G2b(1, 5, 9, 13, c, u + 2 * F[b++]), G1b(2, 6, 10, 14, c, u + 2 * F[b++]), G2b(2, 6, 10, 14, c, u + 2 * F[b++]), G1b(3, 7, 11, 15, c, u + 2 * F[b++]), G2b(3, 7, 11, 15, c, u + 2 * F[b++]), G1b(0, 5, 10, 15, c, u + 2 * F[b++]), G2b(0, 5, 10, 15, c, u + 2 * F[b++]), G1b(1, 6, 11, 12, c, u + 2 * F[b++]), G2b(1, 6, 11, 12, c, u + 2 * F[b++]), G1b(2, 7, 8, 13, c, u + 2 * F[b++]), G2b(2, 7, 8, 13, c, u + 2 * F[b++]), G1b(3, 4, 9, 14, c, u + 2 * F[b++]), G2b(3, 4, 9, 14, c, u + 2 * F[b++]);
    this.v0l ^= BBUF[0] ^ BBUF[16], this.v0h ^= BBUF[1] ^ BBUF[17], this.v1l ^= BBUF[2] ^ BBUF[18], this.v1h ^= BBUF[3] ^ BBUF[19], this.v2l ^= BBUF[4] ^ BBUF[20], this.v2h ^= BBUF[5] ^ BBUF[21], this.v3l ^= BBUF[6] ^ BBUF[22], this.v3h ^= BBUF[7] ^ BBUF[23], this.v4l ^= BBUF[8] ^ BBUF[24], this.v4h ^= BBUF[9] ^ BBUF[25], this.v5l ^= BBUF[10] ^ BBUF[26], this.v5h ^= BBUF[11] ^ BBUF[27], this.v6l ^= BBUF[12] ^ BBUF[28], this.v6h ^= BBUF[13] ^ BBUF[29], this.v7l ^= BBUF[14] ^ BBUF[30], this.v7h ^= BBUF[15] ^ BBUF[31], (0, utils_ts_1$2.clean)(BBUF);
  }
  destroy() {
    this.destroyed = !0, (0, utils_ts_1$2.clean)(this.buffer32), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
  }
}
blake2.BLAKE2b = BLAKE2b;
blake2.blake2b = (0, utils_ts_1$2.createOptHasher)((n) => new BLAKE2b(n));
function compress(n, c, u, p, a, A, b, F, le, L, pe, $, Ee, be, He, Pe, nr, ir, or, lr) {
  let Ir = 0;
  for (let xr = 0; xr < p; xr++)
    ({ a, b: le, c: Ee, d: nr } = (0, _blake_ts_1.G1s)(a, le, Ee, nr, u[c + n[Ir++]])), { a, b: le, c: Ee, d: nr } = (0, _blake_ts_1.G2s)(a, le, Ee, nr, u[c + n[Ir++]]), { a: A, b: L, c: be, d: ir } = (0, _blake_ts_1.G1s)(A, L, be, ir, u[c + n[Ir++]]), { a: A, b: L, c: be, d: ir } = (0, _blake_ts_1.G2s)(A, L, be, ir, u[c + n[Ir++]]), { a: b, b: pe, c: He, d: or } = (0, _blake_ts_1.G1s)(b, pe, He, or, u[c + n[Ir++]]), { a: b, b: pe, c: He, d: or } = (0, _blake_ts_1.G2s)(b, pe, He, or, u[c + n[Ir++]]), { a: F, b: $, c: Pe, d: lr } = (0, _blake_ts_1.G1s)(F, $, Pe, lr, u[c + n[Ir++]]), { a: F, b: $, c: Pe, d: lr } = (0, _blake_ts_1.G2s)(F, $, Pe, lr, u[c + n[Ir++]]), { a, b: L, c: He, d: lr } = (0, _blake_ts_1.G1s)(a, L, He, lr, u[c + n[Ir++]]), { a, b: L, c: He, d: lr } = (0, _blake_ts_1.G2s)(a, L, He, lr, u[c + n[Ir++]]), { a: A, b: pe, c: Pe, d: nr } = (0, _blake_ts_1.G1s)(A, pe, Pe, nr, u[c + n[Ir++]]), { a: A, b: pe, c: Pe, d: nr } = (0, _blake_ts_1.G2s)(A, pe, Pe, nr, u[c + n[Ir++]]), { a: b, b: $, c: Ee, d: ir } = (0, _blake_ts_1.G1s)(b, $, Ee, ir, u[c + n[Ir++]]), { a: b, b: $, c: Ee, d: ir } = (0, _blake_ts_1.G2s)(b, $, Ee, ir, u[c + n[Ir++]]), { a: F, b: le, c: be, d: or } = (0, _blake_ts_1.G1s)(F, le, be, or, u[c + n[Ir++]]), { a: F, b: le, c: be, d: or } = (0, _blake_ts_1.G2s)(F, le, be, or, u[c + n[Ir++]]);
  return { v0: a, v1: A, v2: b, v3: F, v4: le, v5: L, v6: pe, v7: $, v8: Ee, v9: be, v10: He, v11: Pe, v12: nr, v13: ir, v14: or, v15: lr };
}
const B2S_IV = _md_ts_1.SHA256_IV;
class BLAKE2s extends BLAKE2 {
  constructor(c = {}) {
    const u = c.dkLen === void 0 ? 32 : c.dkLen;
    super(64, u), this.v0 = B2S_IV[0] | 0, this.v1 = B2S_IV[1] | 0, this.v2 = B2S_IV[2] | 0, this.v3 = B2S_IV[3] | 0, this.v4 = B2S_IV[4] | 0, this.v5 = B2S_IV[5] | 0, this.v6 = B2S_IV[6] | 0, this.v7 = B2S_IV[7] | 0, checkBlake2Opts(u, c, 32, 8, 8);
    let { key: p, personalization: a, salt: A } = c, b = 0;
    if (p !== void 0 && (p = (0, utils_ts_1$2.toBytes)(p), b = p.length), this.v0 ^= this.outputLen | b << 8 | 65536 | 1 << 24, A !== void 0) {
      A = (0, utils_ts_1$2.toBytes)(A);
      const F = (0, utils_ts_1$2.u32)(A);
      this.v4 ^= (0, utils_ts_1$2.swap8IfBE)(F[0]), this.v5 ^= (0, utils_ts_1$2.swap8IfBE)(F[1]);
    }
    if (a !== void 0) {
      a = (0, utils_ts_1$2.toBytes)(a);
      const F = (0, utils_ts_1$2.u32)(a);
      this.v6 ^= (0, utils_ts_1$2.swap8IfBE)(F[0]), this.v7 ^= (0, utils_ts_1$2.swap8IfBE)(F[1]);
    }
    if (p !== void 0) {
      (0, utils_ts_1$2.abytes)(p);
      const F = new Uint8Array(this.blockLen);
      F.set(p), this.update(F);
    }
  }
  get() {
    const { v0: c, v1: u, v2: p, v3: a, v4: A, v5: b, v6: F, v7: le } = this;
    return [c, u, p, a, A, b, F, le];
  }
  // prettier-ignore
  set(c, u, p, a, A, b, F, le) {
    this.v0 = c | 0, this.v1 = u | 0, this.v2 = p | 0, this.v3 = a | 0, this.v4 = A | 0, this.v5 = b | 0, this.v6 = F | 0, this.v7 = le | 0;
  }
  compress(c, u, p) {
    const { h: a, l: A } = u64$3.fromBig(BigInt(this.length)), { v0: b, v1: F, v2: le, v3: L, v4: pe, v5: $, v6: Ee, v7: be, v8: He, v9: Pe, v10: nr, v11: ir, v12: or, v13: lr, v14: Ir, v15: xr } = compress(_blake_ts_1.BSIGMA, u, c, 10, this.v0, this.v1, this.v2, this.v3, this.v4, this.v5, this.v6, this.v7, B2S_IV[0], B2S_IV[1], B2S_IV[2], B2S_IV[3], A ^ B2S_IV[4], a ^ B2S_IV[5], p ? ~B2S_IV[6] : B2S_IV[6], B2S_IV[7]);
    this.v0 ^= b ^ He, this.v1 ^= F ^ Pe, this.v2 ^= le ^ nr, this.v3 ^= L ^ ir, this.v4 ^= pe ^ or, this.v5 ^= $ ^ lr, this.v6 ^= Ee ^ Ir, this.v7 ^= be ^ xr;
  }
  destroy() {
    this.destroyed = !0, (0, utils_ts_1$2.clean)(this.buffer32), this.set(0, 0, 0, 0, 0, 0, 0, 0);
  }
}
blake2.BLAKE2s = BLAKE2s;
blake2.blake2s = (0, utils_ts_1$2.createOptHasher)((n) => new BLAKE2s(n));
Object.defineProperty(blake2b, "__esModule", { value: !0 });
blake2b.blake2b = blake2b.BLAKE2b = void 0;
const blake2_ts_1 = blake2;
blake2b.BLAKE2b = blake2_ts_1.BLAKE2b;
blake2b.blake2b = blake2_ts_1.blake2b;
Object.defineProperty(sui, "__esModule", { value: !0 });
sui.KeystoneSuiSDK = void 0;
const bc_ur_registry_sui_1 = distExports$2, utils_1$c = utils$K, ur_1$2 = ur, blake2b_1 = blake2b;
class KeystoneSuiSDK {
  constructor(c) {
    this.config = c;
  }
  parseSignature(c) {
    if (c.type !== ur_1$2.URType.SuiSignature)
      throw new Error("type not match");
    const u = bc_ur_registry_sui_1.SuiSignature.fromCBOR(c.cbor), p = u.getRequestId();
    return {
      requestId: Buffer$f.isBuffer(p) ? (0, utils_1$c.uuidStringify)(p) : "",
      signature: (0, utils_1$c.toHex)(u.getSignature()),
      publicKey: (0, utils_1$c.toHex)(u.getPublicKey())
    };
  }
  generateSignHashRequest({ requestId: c, messageHash: u, accounts: p, origin: a }) {
    const A = [], b = [];
    if (p.forEach((F) => {
      A.push(new bc_ur_registry_sui_1.CryptoKeypath((0, utils_1$c.parsePath)(F.path).map((le) => new bc_ur_registry_sui_1.PathComponent(le)), (0, utils_1$c.toBuffer)(F.xfp))), F.address !== void 0 && b.push((0, utils_1$c.toBuffer)(F.address.startsWith("0x") ? F.address.substring(2) : F.address));
    }), b.length > 0 && b.length !== A.length)
      throw new Error("address and path count must match");
    return new bc_ur_registry_sui_1.SuiSignHashRequest({
      requestId: (0, utils_1$c.uuidParse)(c),
      messageHash: u,
      derivationPaths: A,
      addresses: b,
      origin: a
    }).toUR();
  }
  generateIntentMessageHash(c) {
    let u = (0, utils_1$c.toBuffer)(c);
    const p = (0, blake2b_1.blake2b)(Uint8Array.from(u), { dkLen: 32 });
    return (0, utils_1$c.toHex)(p);
  }
  generateSignRequest({ requestId: c, intentMessage: u, accounts: p, origin: a }) {
    var A, b, F;
    const le = (F = (b = (A = this.config) === null || A === void 0 ? void 0 : A.sizeLimit) === null || b === void 0 ? void 0 : b.sui) !== null && F !== void 0 ? F : 2048, L = [], pe = [];
    if (p.forEach((Ee) => {
      L.push(new bc_ur_registry_sui_1.CryptoKeypath((0, utils_1$c.parsePath)(Ee.path).map((be) => new bc_ur_registry_sui_1.PathComponent(be)), (0, utils_1$c.toBuffer)(Ee.xfp))), Ee.address !== void 0 && pe.push((0, utils_1$c.toBuffer)(Ee.address.startsWith("0x") ? Ee.address.substring(2) : Ee.address));
    }), pe.length > 0 && pe.length !== L.length)
      throw new Error("address and path count must match");
    let $ = (0, utils_1$c.toBuffer)(u);
    if ($.length > le) {
      const Ee = (0, blake2b_1.blake2b)(Uint8Array.from($), { dkLen: 32 });
      if (Ee.length !== 32)
        throw new Error("hash length must be 32");
      return u = (0, utils_1$c.toHex)(Ee), new bc_ur_registry_sui_1.SuiSignHashRequest({
        requestId: (0, utils_1$c.uuidParse)(c),
        messageHash: u,
        derivationPaths: L,
        addresses: pe,
        origin: a
      }).toUR();
    }
    return new bc_ur_registry_sui_1.SuiSignRequest({
      requestId: (0, utils_1$c.uuidParse)(c),
      intentMessage: (0, utils_1$c.toBuffer)(u),
      derivationPaths: L,
      addresses: pe,
      origin: a
    }).toUR();
  }
}
sui.KeystoneSuiSDK = KeystoneSuiSDK;
var ton = {}, dist$7 = { exports: {} }, bcUrRegistryTon_cjs_production_min = {}, dist$6 = {}, patchCBOR$1 = {}, utils$6 = {}, lib$3 = {}, cborSync$1 = { exports: {} }, DataItem$1 = {}, hasRequiredDataItem$1;
function requireDataItem$1() {
  if (hasRequiredDataItem$1) return DataItem$1;
  hasRequiredDataItem$1 = 1, Object.defineProperty(DataItem$1, "__esModule", { value: !0 }), DataItem$1.DataItem = void 0;
  class n {
    constructor(u, p) {
      this.setTag = (a) => {
        this.tag = a;
      }, this.clearTag = () => {
        this.tag = void 0;
      }, this.getTag = () => this.tag, this.getData = () => this.data, this.data = u, this.tag = p;
    }
  }
  return DataItem$1.DataItem = n, DataItem$1;
}
var hasRequiredCborSync$1;
function requireCborSync$1() {
  return hasRequiredCborSync$1 || (hasRequiredCborSync$1 = 1, function(n) {
    (function(c, u) {
      n.exports ? n.exports = u() : c.CBOR = u();
    })(commonjsGlobal, function() {
      const { DataItem: c } = requireDataItem$1();
      var u = function() {
        function p(Ce) {
          this.$hex = Ce;
        }
        p.prototype = {
          length: function() {
            return this.$hex.length / 2;
          },
          toString: function(Ce) {
            if (!Ce || Ce === "hex" || Ce === 16)
              return this.$hex;
            if (Ce === "utf-8") {
              for (var tr = "", Fe = 0; Fe < this.$hex.length; Fe += 2)
                tr += "%" + this.$hex.substring(Fe, Fe + 2);
              return decodeURIComponent(tr);
            }
            if (Ce === "latin") {
              for (var tr = [], Fe = 0; Fe < this.$hex.length; Fe += 2)
                tr.push(parseInt(this.$hex.substring(Fe, Fe + 2), 16));
              return String.fromCharCode.apply(String, tr);
            }
            throw new Error("Unrecognised format: " + Ce);
          }
        }, p.fromLatinString = function(Ce) {
          for (var tr = "", Fe = 0; Fe < Ce.length; Fe++) {
            var Sr = Ce.charCodeAt(Fe).toString(16);
            Sr.length === 1 && (Sr = "0" + Sr), tr += Sr;
          }
          return new p(tr);
        }, p.fromUtf8String = function(Ce) {
          for (var tr = encodeURIComponent(Ce), Fe = "", Sr = 0; Sr < tr.length; Sr++)
            if (tr.charAt(Sr) === "%")
              Fe += tr.substring(Sr + 1, Sr + 3), Sr += 2;
            else {
              var er = tr.charCodeAt(Sr).toString(16);
              er.length < 2 && (er = "0" + er), Fe += er;
            }
          return new p(Fe);
        };
        var a = [], A = {}, b = function(Ce) {
          return function() {
            throw new Error(Ce + " not implemented");
          };
        };
        function F() {
        }
        F.prototype = {
          peekByte: b("peekByte"),
          readByte: b("readByte"),
          readChunk: b("readChunk"),
          readFloat16: function() {
            var Ce = this.readUint16(), tr = (Ce & 32767) >> 10, Fe = Ce & 1023, Sr = Ce & 32768;
            if (tr === 31)
              return Fe === 0 ? Sr ? -1 / 0 : 1 / 0 : NaN;
            var er = tr ? Math.pow(2, tr - 25) * (1024 + Fe) : Math.pow(2, -24) * Fe;
            return Sr ? -er : er;
          },
          readFloat32: function() {
            var Ce = this.readUint32(), tr = (Ce & 2147483647) >> 23, Fe = Ce & 8388607, Sr = Ce & 2147483648;
            if (tr === 255)
              return Fe === 0 ? Sr ? -1 / 0 : 1 / 0 : NaN;
            var er = tr ? Math.pow(2, tr - 23 - 127) * (8388608 + Fe) : Math.pow(2, -149) * Fe;
            return Sr ? -er : er;
          },
          readFloat64: function() {
            var Ce = this.readUint32(), tr = this.readUint32(), Fe = Ce >> 20 & 2047, Sr = (Ce & 1048575) * 4294967296 + tr, er = Ce & 2147483648;
            if (Fe === 2047)
              return Sr === 0 ? er ? -1 / 0 : 1 / 0 : NaN;
            var Ie = Fe ? Math.pow(2, Fe - 52 - 1023) * (4503599627370496 + Sr) : Math.pow(2, -1074) * Sr;
            return er ? -Ie : Ie;
          },
          readUint16: function() {
            return this.readByte() * 256 + this.readByte();
          },
          readUint32: function() {
            return this.readUint16() * 65536 + this.readUint16();
          },
          readUint64: function() {
            return this.readUint32() * 4294967296 + this.readUint32();
          }
        };
        function le() {
        }
        le.prototype = {
          writeByte: b("writeByte"),
          result: b("result"),
          writeFloat16: b("writeFloat16"),
          writeFloat32: b("writeFloat32"),
          writeFloat64: b("writeFloat64"),
          writeUint16: function(Ce) {
            this.writeByte(Ce >> 8 & 255), this.writeByte(Ce & 255);
          },
          writeUint32: function(Ce) {
            this.writeUint16(Ce >> 16 & 65535), this.writeUint16(Ce & 65535);
          },
          writeUint64: function(Ce) {
            if (Ce >= 9007199254740992 || Ce <= -9007199254740992)
              throw new Error("Cannot encode Uint64 of: " + Ce + " magnitude to big (floating point errors)");
            this.writeUint32(Math.floor(Ce / 4294967296)), this.writeUint32(Ce % 4294967296);
          },
          writeString: b("writeString"),
          canWriteBinary: function(Ce) {
            return !1;
          },
          writeBinary: b("writeChunk")
        };
        function L(Ce) {
          var tr = Ce.readByte(), Fe = tr >> 5, Sr = tr & 31;
          return { type: Fe, value: Sr };
        }
        function pe(Ce, tr) {
          var Fe = Ce.value;
          if (Fe < 24)
            return Fe;
          if (Fe == 24)
            return tr.readByte();
          if (Fe == 25)
            return tr.readUint16();
          if (Fe == 26)
            return tr.readUint32();
          if (Fe == 27)
            return tr.readUint64();
          if (Fe == 31)
            return null;
          b("Additional info: " + Fe)();
        }
        function $(Ce, tr, Fe) {
          Fe.writeByte(Ce << 5 | tr);
        }
        function Ee(Ce, tr, Fe) {
          var Sr = Ce << 5;
          tr < 24 ? Fe.writeByte(Sr | tr) : tr < 256 ? (Fe.writeByte(Sr | 24), Fe.writeByte(tr)) : tr < 65536 ? (Fe.writeByte(Sr | 25), Fe.writeUint16(tr)) : tr < 4294967296 ? (Fe.writeByte(Sr | 26), Fe.writeUint32(tr)) : (Fe.writeByte(Sr | 27), Fe.writeUint64(tr));
        }
        var be = new Error();
        function He(Ce) {
          var tr = L(Ce);
          switch (tr.type) {
            case 0:
              return pe(tr, Ce);
            case 1:
              return -1 - pe(tr, Ce);
            case 2:
              return Ce.readChunk(pe(tr, Ce));
            case 3:
              var Fe = Ce.readChunk(pe(tr, Ce));
              return Fe.toString("utf-8");
            case 4:
            case 5:
              var Sr = pe(tr, Ce), yr = [];
              if (Sr !== null) {
                tr.type === 5 && (Sr *= 2);
                for (var er = 0; er < Sr; er++)
                  yr[er] = He(Ce);
              } else
                for (var Ie; (Ie = He(Ce)) !== be; )
                  yr.push(Ie);
              if (tr.type === 5) {
                for (var xe = {}, er = 0; er < yr.length; er += 2)
                  xe[yr[er]] = yr[er + 1];
                return xe;
              } else
                return yr;
            case 6:
              var rr = pe(tr, Ce), ar = A[rr], yr = He(Ce);
              return ar ? ar(yr) : yr;
            case 7:
              if (tr.value === 25)
                return Ce.readFloat16();
              if (tr.value === 26)
                return Ce.readFloat32();
              if (tr.value === 27)
                return Ce.readFloat64();
              switch (pe(tr, Ce)) {
                case 20:
                  return !1;
                case 21:
                  return !0;
                case 22:
                  return null;
                case 23:
                  return;
                case null:
                  return be;
                default:
                  throw new Error("Unknown fixed value: " + tr.value);
              }
            default:
              throw new Error("Unsupported header: " + JSON.stringify(tr));
          }
          throw new Error("not implemented yet");
        }
        function Pe(Ce, tr) {
          for (var Fe = 0; Fe < a.length; Fe++) {
            var Sr = a[Fe].fn(Ce);
            if (Sr !== void 0)
              return Ee(6, a[Fe].tag, tr), Pe(Sr, tr);
          }
          if (Ce && typeof Ce.toCBOR == "function" && (Ce = Ce.toCBOR()), Ce === !1)
            Ee(7, 20, tr);
          else if (Ce === !0)
            Ee(7, 21, tr);
          else if (Ce === null)
            Ee(7, 22, tr);
          else if (Ce === void 0)
            Ee(7, 23, tr);
          else if (typeof Ce == "number")
            Math.floor(Ce) === Ce && Ce < 9007199254740992 && Ce > -9007199254740992 ? Ce < 0 ? Ee(1, -1 - Ce, tr) : Ee(0, Ce, tr) : ($(7, 27, tr), tr.writeFloat64(Ce));
          else if (typeof Ce == "string")
            tr.writeString(Ce, function(Ie) {
              Ee(3, Ie, tr);
            });
          else if (tr.canWriteBinary(Ce))
            tr.writeBinary(Ce, function(Ie) {
              Ee(2, Ie, tr);
            });
          else if (typeof Ce == "object")
            if (or.config.useToJSON && typeof Ce.toJSON == "function" && (Ce = Ce.toJSON()), Array.isArray(Ce)) {
              Ee(4, Ce.length, tr);
              for (var Fe = 0; Fe < Ce.length; Fe++)
                Pe(Ce[Fe], tr);
            } else {
              var er = Object.keys(Ce);
              Ee(5, er.length, tr);
              for (var Fe = 0; Fe < er.length; Fe++) {
                const xe = parseInt(er[Fe]);
                isNaN(xe) ? (Pe(er[Fe], tr), Pe(Ce[er[Fe]], tr)) : (Pe(xe, tr), Pe(Ce[er[Fe]], tr));
              }
            }
          else
            throw new Error("CBOR encoding not supported: " + Ce);
        }
        var nr = [], ir = [], or = {
          config: {
            useToJSON: !0
          },
          addWriter: function(Ce, tr) {
            typeof Ce == "string" ? ir.push(function(Fe) {
              if (Ce === Fe)
                return tr(Fe);
            }) : ir.push(Ce);
          },
          addReader: function(Ce, tr) {
            typeof Ce == "string" ? nr.push(function(Fe, Sr) {
              if (Ce === Sr)
                return tr(Fe, Sr);
            }) : nr.push(Ce);
          },
          encode: function(Ce, tr) {
            for (var Fe = 0; Fe < ir.length; Fe++) {
              var Sr = ir[Fe], er = Sr(tr);
              if (er)
                return Pe(Ce, er), er.result();
            }
            throw new Error("Unsupported output format: " + tr);
          },
          encodeDataItem: function(Ce, tr) {
            for (var Fe = 0; Fe < ir.length; Fe++) {
              var Sr = ir[Fe], er = Sr(tr);
              if (er)
                return Ce.getTag() !== void 0 ? (Pe(Ce, er), er.result()) : (Pe(Ce.getData(), er), er.result());
            }
            throw new Error("Unsupported output format: " + tr);
          },
          decode: function(Ce, tr) {
            for (var Fe = 0; Fe < nr.length; Fe++) {
              var Sr = nr[Fe], er = Sr(Ce, tr);
              if (er)
                return He(er);
            }
            throw new Error("Unsupported input format: " + tr);
          },
          decodeToDataItem: function(Ce, tr) {
            for (var Fe = 0; Fe < nr.length; Fe++) {
              var Sr = nr[Fe], er = Sr(Ce, tr);
              if (er) {
                const Ie = He(er);
                return Ie instanceof c ? Ie : new c(Ie);
              }
            }
            throw new Error("Unsupported input format: " + tr);
          },
          addSemanticEncode: function(Ce, tr) {
            if (typeof Ce != "number" || Ce % 1 !== 0 || Ce < 0)
              throw new Error("Tag must be a positive integer");
            return a.push({ tag: Ce, fn: tr }), this;
          },
          addSemanticDecode: function(Ce, tr) {
            if (typeof Ce != "number" || Ce % 1 !== 0 || Ce < 0)
              throw new Error("Tag must be a positive integer");
            return A[Ce] = tr, this;
          }
        };
        function lr(Ce) {
          this.buffer = Ce, this.pos = 0;
        }
        lr.prototype = Object.create(F.prototype), lr.prototype.peekByte = function() {
          return this.buffer[this.pos];
        }, lr.prototype.readByte = function() {
          return this.buffer[this.pos++];
        }, lr.prototype.readUint16 = function() {
          var Ce = this.buffer.readUInt16BE(this.pos);
          return this.pos += 2, Ce;
        }, lr.prototype.readUint32 = function() {
          var Ce = this.buffer.readUInt32BE(this.pos);
          return this.pos += 4, Ce;
        }, lr.prototype.readFloat32 = function() {
          var Ce = this.buffer.readFloatBE(this.pos);
          return this.pos += 4, Ce;
        }, lr.prototype.readFloat64 = function() {
          var Ce = this.buffer.readDoubleBE(this.pos);
          return this.pos += 8, Ce;
        }, lr.prototype.readChunk = function(Ce) {
          var tr = Buffer$f.alloc(Ce);
          return this.buffer.copy(tr, 0, this.pos, this.pos += Ce), tr;
        };
        function Ir(Ce) {
          this.byteLength = 0, this.defaultBufferLength = 16384, this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0, this.completeBuffers = [], this.stringFormat = Ce;
        }
        Ir.prototype = Object.create(le.prototype), Ir.prototype.writeByte = function(Ce) {
          this.latestBuffer[this.latestBufferOffset++] = Ce, this.latestBufferOffset >= this.latestBuffer.length && (this.completeBuffers.push(this.latestBuffer), this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0), this.byteLength++;
        }, Ir.prototype.writeFloat32 = function(Ce) {
          var tr = Buffer$f.alloc(4);
          tr.writeFloatBE(Ce, 0), this.writeBuffer(tr);
        }, Ir.prototype.writeFloat64 = function(Ce) {
          var tr = Buffer$f.alloc(8);
          tr.writeDoubleBE(Ce, 0), this.writeBuffer(tr);
        }, Ir.prototype.writeString = function(Ce, tr) {
          var Fe = Buffer$f.from(Ce, "utf-8");
          tr(Fe.length), this.writeBuffer(Fe);
        }, Ir.prototype.canWriteBinary = function(Ce) {
          return Ce instanceof Buffer$f;
        }, Ir.prototype.writeBinary = function(Ce, tr) {
          tr(Ce.length), this.writeBuffer(Ce);
        }, Ir.prototype.writeBuffer = function(Ce) {
          if (!(Ce instanceof Buffer$f))
            throw new TypeError("BufferWriter only accepts Buffers");
          this.latestBufferOffset ? this.latestBuffer.length - this.latestBufferOffset >= Ce.length ? (Ce.copy(this.latestBuffer, this.latestBufferOffset), this.latestBufferOffset += Ce.length, this.latestBufferOffset >= this.latestBuffer.length && (this.completeBuffers.push(this.latestBuffer), this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0)) : (this.completeBuffers.push(this.latestBuffer.slice(0, this.latestBufferOffset)), this.completeBuffers.push(Ce), this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0) : this.completeBuffers.push(Ce), this.byteLength += Ce.length;
        }, Ir.prototype.result = function() {
          for (var Ce = Buffer$f.alloc(this.byteLength), tr = 0, Fe = 0; Fe < this.completeBuffers.length; Fe++) {
            var Sr = this.completeBuffers[Fe];
            Sr.copy(Ce, tr, 0, Sr.length), tr += Sr.length;
          }
          return this.latestBufferOffset && this.latestBuffer.copy(Ce, tr, 0, this.latestBufferOffset), this.stringFormat ? Ce.toString(this.stringFormat) : Ce;
        }, typeof Buffer$f == "function" && (or.addReader(function(Ce, tr) {
          if (Buffer$f.isBuffer(Ce))
            return new lr(Ce);
          if (tr === "hex" || tr === "base64") {
            var Fe = Buffer$f.from(Ce, tr);
            return new lr(Fe);
          }
        }), or.addWriter(function(Ce) {
          if (!Ce || Ce === "buffer")
            return new Ir();
          if (Ce === "hex" || Ce === "base64")
            return new Ir(Ce);
        }));
        function xr(Ce) {
          this.hex = Ce, this.pos = 0;
        }
        xr.prototype = Object.create(F.prototype), xr.prototype.peekByte = function() {
          var Ce = this.hex.substring(this.pos, 2);
          return parseInt(Ce, 16);
        }, xr.prototype.readByte = function() {
          var Ce = this.hex.substring(this.pos, this.pos + 2);
          return this.pos += 2, parseInt(Ce, 16);
        }, xr.prototype.readChunk = function(Ce) {
          var tr = this.hex.substring(this.pos, this.pos + Ce * 2);
          return this.pos += Ce * 2, typeof Buffer$f == "function" ? Buffer$f.from(tr, "hex") : new p(tr);
        };
        function kr(Ce) {
          this.$hex = "", this.finalFormat = Ce || "hex";
        }
        return kr.prototype = Object.create(le.prototype), kr.prototype.writeByte = function(Ce) {
          if (Ce < 0 || Ce > 255)
            throw new Error("Byte value out of range: " + Ce);
          var tr = Ce.toString(16);
          tr.length == 1 && (tr = "0" + tr), this.$hex += tr;
        }, kr.prototype.canWriteBinary = function(Ce) {
          return Ce instanceof p || typeof Buffer$f == "function" && Ce instanceof Buffer$f;
        }, kr.prototype.writeBinary = function(Ce, tr) {
          if (Ce instanceof p)
            tr(Ce.length()), this.$hex += Ce.$hex;
          else if (typeof Buffer$f == "function" && Ce instanceof Buffer$f)
            tr(Ce.length), this.$hex += Ce.toString("hex");
          else
            throw new TypeError("HexWriter only accepts BinaryHex or Buffers");
        }, kr.prototype.result = function() {
          return this.finalFormat === "buffer" && typeof Buffer$f == "function" ? Buffer$f.from(this.$hex, "hex") : new p(this.$hex).toString(this.finalFormat);
        }, kr.prototype.writeString = function(Ce, tr) {
          var Fe = p.fromUtf8String(Ce);
          tr(Fe.length()), this.$hex += Fe.$hex;
        }, or.addReader(function(Ce, tr) {
          if (Ce instanceof p || Ce.$hex)
            return new xr(Ce.$hex);
          if (tr === "hex")
            return new xr(Ce);
        }), or.addWriter(function(Ce) {
          if (Ce === "hex")
            return new kr();
        }), or;
      }();
      return u.addSemanticEncode(0, function(p) {
        if (p instanceof Date)
          return p.toISOString();
      }).addSemanticDecode(0, function(p) {
        return new Date(p);
      }).addSemanticDecode(1, function(p) {
        return new Date(p);
      }), u;
    });
  }(cborSync$1)), cborSync$1.exports;
}
var hasRequiredLib$1;
function requireLib$1() {
  return hasRequiredLib$1 || (hasRequiredLib$1 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.DataItem = n.addWriter = n.addReader = n.addSemanticEncode = n.addSemanticDecode = n.decodeToDataItem = n.encodeDataItem = void 0;
    var c = requireCborSync$1();
    Object.defineProperty(n, "encodeDataItem", { enumerable: !0, get: function() {
      return c.encodeDataItem;
    } }), Object.defineProperty(n, "decodeToDataItem", { enumerable: !0, get: function() {
      return c.decodeToDataItem;
    } }), Object.defineProperty(n, "addSemanticDecode", { enumerable: !0, get: function() {
      return c.addSemanticDecode;
    } }), Object.defineProperty(n, "addSemanticEncode", { enumerable: !0, get: function() {
      return c.addSemanticEncode;
    } }), Object.defineProperty(n, "addReader", { enumerable: !0, get: function() {
      return c.addReader;
    } }), Object.defineProperty(n, "addWriter", { enumerable: !0, get: function() {
      return c.addWriter;
    } });
    var u = requireDataItem$1();
    Object.defineProperty(n, "DataItem", { enumerable: !0, get: function() {
      return u.DataItem;
    } });
  }(lib$3)), lib$3;
}
var hasRequiredUtils$1;
function requireUtils$1() {
  if (hasRequiredUtils$1) return utils$6;
  hasRequiredUtils$1 = 1, Object.defineProperty(utils$6, "__esModule", { value: !0 }), utils$6.patchTags = void 0;
  const n = requireLib$1(), c = [], u = (p) => {
    p.forEach((a) => {
      c.find((A) => A === a) || ((0, n.addSemanticEncode)(a, (A) => {
        if (A instanceof n.DataItem && A.getTag() === a)
          return A.getData();
      }), (0, n.addSemanticDecode)(a, (A) => new n.DataItem(A, a)), c.push(a));
    });
  };
  return utils$6.patchTags = u, utils$6;
}
var RegistryType$1 = {}, hasRequiredRegistryType$1;
function requireRegistryType$1() {
  if (hasRequiredRegistryType$1) return RegistryType$1;
  hasRequiredRegistryType$1 = 1, Object.defineProperty(RegistryType$1, "__esModule", { value: !0 }), RegistryType$1.RegistryTypes = RegistryType$1.RegistryType = void 0;
  class n {
    constructor(u, p) {
      this.type = u, this.tag = p, this.getTag = () => this.tag, this.getType = () => this.type;
    }
  }
  return RegistryType$1.RegistryType = n, RegistryType$1.RegistryTypes = {
    UUID: new n("uuid", 37),
    BYTES: new n("bytes", void 0),
    CRYPTO_HDKEY: new n("crypto-hdkey", 303),
    CRYPTO_KEYPATH: new n("crypto-keypath", 304),
    CRYPTO_COIN_INFO: new n("crypto-coin-info", 305),
    CRYPTO_ECKEY: new n("crypto-eckey", 306),
    CRYPTO_OUTPUT: new n("crypto-output", 308),
    CRYPTO_PSBT: new n("crypto-psbt", 310),
    CRYPTO_ACCOUNT: new n("crypto-account", 311),
    CRYPTO_MULTI_ACCOUNTS: new n("crypto-multi-accounts", 1103),
    QR_HARDWARE_CALL: new n("qr-hardware-call", 1201),
    KEY_DERIVATION_CALL: new n("key-derivation-call", 1301),
    KEY_DERIVATION_SCHEMA: new n("key-derivation-schema", 1302)
  }, RegistryType$1;
}
var ScriptExpression$1 = {}, hasRequiredScriptExpression$1;
function requireScriptExpression$1() {
  return hasRequiredScriptExpression$1 || (hasRequiredScriptExpression$1 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.ScriptExpressions = n.ScriptExpression = void 0;
    class c {
      constructor(p, a) {
        this.tag = p, this.expression = a, this.getTag = () => this.tag, this.getExpression = () => this.expression;
      }
    }
    n.ScriptExpression = c, c.fromTag = (u) => Object.values(n.ScriptExpressions).find((a) => a.getTag() === u), n.ScriptExpressions = {
      SCRIPT_HASH: new c(400, "sh"),
      WITNESS_SCRIPT_HASH: new c(401, "wsh"),
      PUBLIC_KEY: new c(402, "pk"),
      PUBLIC_KEY_HASH: new c(403, "pkh"),
      WITNESS_PUBLIC_KEY_HASH: new c(404, "wpkh"),
      COMBO: new c(405, "combo"),
      MULTISIG: new c(406, "multi"),
      SORTED_MULTISIG: new c(407, "sortedmulti"),
      ADDRESS: new c(307, "addr"),
      RAW_SCRIPT: new c(408, "raw")
    };
  }(ScriptExpression$1)), ScriptExpression$1;
}
var hasRequiredPatchCBOR$1;
function requirePatchCBOR$1() {
  if (hasRequiredPatchCBOR$1) return patchCBOR$1;
  hasRequiredPatchCBOR$1 = 1, Object.defineProperty(patchCBOR$1, "__esModule", { value: !0 });
  const n = requireUtils$1(), c = requireRegistryType$1(), u = requireScriptExpression$1(), p = Object.values(c.RegistryTypes).filter((A) => !!A.getTag()).map((A) => A.getTag()), a = Object.values(u.ScriptExpressions).map((A) => A.getTag());
  return (0, n.patchTags)(p.concat(a)), patchCBOR$1;
}
var CryptoHDKey$1 = {}, src$5, hasRequiredSrc$1;
function requireSrc$1() {
  if (hasRequiredSrc$1) return src$5;
  hasRequiredSrc$1 = 1;
  var n = safeBufferExports.Buffer;
  function c(u) {
    if (u.length >= 255)
      throw new TypeError("Alphabet too long");
    for (var p = new Uint8Array(256), a = 0; a < p.length; a++)
      p[a] = 255;
    for (var A = 0; A < u.length; A++) {
      var b = u.charAt(A), F = b.charCodeAt(0);
      if (p[F] !== 255)
        throw new TypeError(b + " is ambiguous");
      p[F] = A;
    }
    var le = u.length, L = u.charAt(0), pe = Math.log(le) / Math.log(256), $ = Math.log(256) / Math.log(le);
    function Ee(Pe) {
      if ((Array.isArray(Pe) || Pe instanceof Uint8Array) && (Pe = n.from(Pe)), !n.isBuffer(Pe))
        throw new TypeError("Expected Buffer");
      if (Pe.length === 0)
        return "";
      for (var nr = 0, ir = 0, or = 0, lr = Pe.length; or !== lr && Pe[or] === 0; )
        or++, nr++;
      for (var Ir = (lr - or) * $ + 1 >>> 0, xr = new Uint8Array(Ir); or !== lr; ) {
        for (var kr = Pe[or], Ce = 0, tr = Ir - 1; (kr !== 0 || Ce < ir) && tr !== -1; tr--, Ce++)
          kr += 256 * xr[tr] >>> 0, xr[tr] = kr % le >>> 0, kr = kr / le >>> 0;
        if (kr !== 0)
          throw new Error("Non-zero carry");
        ir = Ce, or++;
      }
      for (var Fe = Ir - ir; Fe !== Ir && xr[Fe] === 0; )
        Fe++;
      for (var Sr = L.repeat(nr); Fe < Ir; ++Fe)
        Sr += u.charAt(xr[Fe]);
      return Sr;
    }
    function be(Pe) {
      if (typeof Pe != "string")
        throw new TypeError("Expected String");
      if (Pe.length === 0)
        return n.alloc(0);
      for (var nr = 0, ir = 0, or = 0; Pe[nr] === L; )
        ir++, nr++;
      for (var lr = (Pe.length - nr) * pe + 1 >>> 0, Ir = new Uint8Array(lr); nr < Pe.length; ) {
        var xr = Pe.charCodeAt(nr);
        if (xr > 255)
          return;
        var kr = p[xr];
        if (kr === 255)
          return;
        for (var Ce = 0, tr = lr - 1; (kr !== 0 || Ce < or) && tr !== -1; tr--, Ce++)
          kr += le * Ir[tr] >>> 0, Ir[tr] = kr % 256 >>> 0, kr = kr / 256 >>> 0;
        if (kr !== 0)
          throw new Error("Non-zero carry");
        or = Ce, nr++;
      }
      for (var Fe = lr - or; Fe !== lr && Ir[Fe] === 0; )
        Fe++;
      var Sr = n.allocUnsafe(ir + (lr - Fe));
      Sr.fill(0, 0, ir);
      for (var er = ir; Fe !== lr; )
        Sr[er++] = Ir[Fe++];
      return Sr;
    }
    function He(Pe) {
      var nr = be(Pe);
      if (nr)
        return nr;
      throw new Error("Non-base" + le + " character");
    }
    return {
      encode: Ee,
      decodeUnsafe: be,
      decode: He
    };
  }
  return src$5 = c, src$5;
}
var bs58$2, hasRequiredBs58$1;
function requireBs58$1() {
  if (hasRequiredBs58$1) return bs58$2;
  hasRequiredBs58$1 = 1;
  var n = requireSrc$1(), c = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
  return bs58$2 = n(c), bs58$2;
}
var base$4, hasRequiredBase$1;
function requireBase$1() {
  if (hasRequiredBase$1) return base$4;
  hasRequiredBase$1 = 1;
  var n = requireBs58$1(), c = safeBufferExports.Buffer;
  return base$4 = function(u) {
    function p(F) {
      var le = u(F);
      return n.encode(c.concat([
        F,
        le
      ], F.length + 4));
    }
    function a(F) {
      var le = F.slice(0, -4), L = F.slice(-4), pe = u(le);
      if (!(L[0] ^ pe[0] | L[1] ^ pe[1] | L[2] ^ pe[2] | L[3] ^ pe[3]))
        return le;
    }
    function A(F) {
      var le = n.decodeUnsafe(F);
      if (le)
        return a(le);
    }
    function b(F) {
      var le = n.decode(F), L = a(le);
      if (!L) throw new Error("Invalid checksum");
      return L;
    }
    return {
      encode: p,
      decode: b,
      decodeUnsafe: A
    };
  }, base$4;
}
var bs58check$4, hasRequiredBs58check$1;
function requireBs58check$1() {
  if (hasRequiredBs58check$1) return bs58check$4;
  hasRequiredBs58check$1 = 1;
  var n = browser$a, c = requireBase$1();
  function u(p) {
    var a = n("sha256").update(p).digest();
    return n("sha256").update(a).digest();
  }
  return bs58check$4 = c(u), bs58check$4;
}
var CryptoCoinInfo$1 = {}, RegistryItem$1 = {}, hasRequiredRegistryItem$1;
function requireRegistryItem$1() {
  if (hasRequiredRegistryItem$1) return RegistryItem$1;
  hasRequiredRegistryItem$1 = 1, Object.defineProperty(RegistryItem$1, "__esModule", { value: !0 }), RegistryItem$1.RegistryItem = void 0;
  const n = dist$t, c = requireLib$1();
  class u {
    constructor() {
      this.toCBOR = () => {
        if (this.toDataItem() === void 0)
          throw new Error(`#[ur-registry][RegistryItem][fn.toCBOR]: registry ${this.getRegistryType()}'s method toDataItem returns undefined`);
        return (0, c.encodeDataItem)(this.toDataItem());
      }, this.toUR = () => new n.UR(this.toCBOR(), this.getRegistryType().getType()), this.toUREncoder = (a, A, b) => {
        const F = this.toUR();
        return new n.UREncoder(F, a, A, b);
      };
    }
  }
  return RegistryItem$1.RegistryItem = u, RegistryItem$1;
}
var hasRequiredCryptoCoinInfo$1;
function requireCryptoCoinInfo$1() {
  return hasRequiredCryptoCoinInfo$1 || (hasRequiredCryptoCoinInfo$1 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.CryptoCoinInfo = n.Network = n.Type = void 0;
    const c = requireLib$1(), u = requireRegistryItem$1(), p = requireRegistryType$1();
    var a;
    (function(le) {
      le.type = "1", le.network = "2";
    })(a || (a = {}));
    var A;
    (function(le) {
      le[le.bitcoin = 0] = "bitcoin";
    })(A = n.Type || (n.Type = {}));
    var b;
    (function(le) {
      le[le.mainnet = 0] = "mainnet", le[le.testnet = 1] = "testnet";
    })(b = n.Network || (n.Network = {}));
    class F extends u.RegistryItem {
      constructor(L, pe) {
        super(), this.type = L, this.network = pe, this.getRegistryType = () => p.RegistryTypes.CRYPTO_COIN_INFO, this.getType = () => this.type || A.bitcoin, this.getNetwork = () => this.network || b.mainnet, this.toDataItem = () => {
          const $ = {};
          return this.type && ($[a.type] = this.type), this.network && ($[a.network] = this.network), new c.DataItem($);
        };
      }
    }
    n.CryptoCoinInfo = F, F.fromDataItem = (le) => {
      const L = le.getData(), pe = L[a.type], $ = L[a.network];
      return new F(pe, $);
    }, F.fromCBOR = (le) => {
      const L = (0, c.decodeToDataItem)(le);
      return F.fromDataItem(L);
    };
  }(CryptoCoinInfo$1)), CryptoCoinInfo$1;
}
var CryptoKeypath$1 = {}, PathComponent$1 = {}, hasRequiredPathComponent$1;
function requirePathComponent$1() {
  if (hasRequiredPathComponent$1) return PathComponent$1;
  hasRequiredPathComponent$1 = 1, Object.defineProperty(PathComponent$1, "__esModule", { value: !0 }), PathComponent$1.PathComponent = void 0;
  class n {
    constructor(u) {
      if (this.getIndex = () => this.index, this.isWildcard = () => this.wildcard, this.isHardened = () => this.hardened, this.index = u.index, this.hardened = u.hardened, this.index !== void 0 ? this.wildcard = !1 : this.wildcard = !0, this.index && this.index & n.HARDENED_BIT)
        throw new Error(`#[ur-registry][PathComponent][fn.constructor]: Invalid index ${this.index} - most significant bit cannot be set`);
    }
  }
  return PathComponent$1.PathComponent = n, n.HARDENED_BIT = 2147483648, PathComponent$1;
}
var hasRequiredCryptoKeypath$1;
function requireCryptoKeypath$1() {
  if (hasRequiredCryptoKeypath$1) return CryptoKeypath$1;
  hasRequiredCryptoKeypath$1 = 1, Object.defineProperty(CryptoKeypath$1, "__esModule", { value: !0 }), CryptoKeypath$1.CryptoKeypath = void 0;
  const n = requireLib$1(), c = requirePathComponent$1(), u = requireRegistryItem$1(), p = requireRegistryType$1();
  var a;
  (function(b) {
    b[b.components = 1] = "components", b[b.source_fingerprint = 2] = "source_fingerprint", b[b.depth = 3] = "depth";
  })(a || (a = {}));
  class A extends u.RegistryItem {
    constructor(F = [], le, L) {
      super(), this.components = F, this.sourceFingerprint = le, this.depth = L, this.getRegistryType = () => p.RegistryTypes.CRYPTO_KEYPATH, this.getPath = () => this.components.length === 0 ? void 0 : this.components.map(($) => `${$.isWildcard() ? "*" : $.getIndex()}${$.isHardened() ? "'" : ""}`).join("/"), this.getComponents = () => this.components, this.getSourceFingerprint = () => this.sourceFingerprint, this.getDepth = () => this.depth, this.toDataItem = () => {
        const pe = {}, $ = [];
        return this.components && this.components.forEach((Ee) => {
          Ee.isWildcard() ? $.push([]) : $.push(Ee.getIndex()), $.push(Ee.isHardened());
        }), pe[a.components] = $, this.sourceFingerprint && (pe[a.source_fingerprint] = this.sourceFingerprint.readUInt32BE(0)), this.depth !== void 0 && (pe[a.depth] = this.depth), new n.DataItem(pe);
      };
    }
  }
  return CryptoKeypath$1.CryptoKeypath = A, A.fromDataItem = (b) => {
    const F = b.getData(), le = [], L = F[a.components];
    if (L)
      for (let be = 0; be < L.length; be += 2) {
        const He = L[be + 1], Pe = L[be];
        typeof Pe == "number" ? le.push(new c.PathComponent({ index: Pe, hardened: He })) : le.push(new c.PathComponent({ hardened: He }));
      }
    const pe = F[a.source_fingerprint];
    let $;
    pe && ($ = Buffer$f.alloc(4), $.writeUInt32BE(pe, 0));
    const Ee = F[a.depth];
    return new A(le, $, Ee);
  }, A.fromCBOR = (b) => {
    const F = (0, n.decodeToDataItem)(b);
    return A.fromDataItem(F);
  }, CryptoKeypath$1;
}
var hasRequiredCryptoHDKey$1;
function requireCryptoHDKey$1() {
  if (hasRequiredCryptoHDKey$1) return CryptoHDKey$1;
  hasRequiredCryptoHDKey$1 = 1, Object.defineProperty(CryptoHDKey$1, "__esModule", { value: !0 }), CryptoHDKey$1.CryptoHDKey = void 0;
  const n = requireBs58check$1(), c = requireCryptoCoinInfo$1(), u = requireCryptoKeypath$1(), p = requireLib$1(), a = requireRegistryItem$1(), A = requireRegistryType$1();
  var b;
  (function(le) {
    le[le.is_master = 1] = "is_master", le[le.is_private = 2] = "is_private", le[le.key_data = 3] = "key_data", le[le.chain_code = 4] = "chain_code", le[le.use_info = 5] = "use_info", le[le.origin = 6] = "origin", le[le.children = 7] = "children", le[le.parent_fingerprint = 8] = "parent_fingerprint", le[le.name = 9] = "name", le[le.note = 10] = "note";
  })(b || (b = {}));
  class F extends a.RegistryItem {
    constructor(L) {
      super(), this.isECKey = () => !1, this.getKey = () => this.key, this.getChainCode = () => this.chainCode, this.isMaster = () => this.master, this.isPrivateKey = () => !!this.privateKey, this.getUseInfo = () => this.useInfo, this.getOrigin = () => this.origin, this.getChildren = () => this.children, this.getParentFingerprint = () => this.parentFingerprint, this.getName = () => this.name, this.getNote = () => this.note, this.getBip32Key = () => {
        var pe, $, Ee;
        let be, He, Pe = 0, nr = Buffer$f.alloc(4).fill(0);
        if (this.isMaster())
          be = Buffer$f.from("0488ADE4", "hex"), He = 0, Pe = 0;
        else {
          He = ((pe = this.getOrigin()) === null || pe === void 0 ? void 0 : pe.getComponents().length) || (($ = this.getOrigin()) === null || $ === void 0 ? void 0 : $.getDepth());
          const xr = (Ee = this.getOrigin()) === null || Ee === void 0 ? void 0 : Ee.getComponents(), kr = xr[xr.length - 1];
          kr && (Pe = kr.isHardened() ? kr.getIndex() + 2147483648 : kr.getIndex(), this.getParentFingerprint() && (nr = this.getParentFingerprint())), this.isPrivateKey() ? be = Buffer$f.from("0488ADE4", "hex") : be = Buffer$f.from("0488B21E", "hex");
        }
        const ir = Buffer$f.alloc(1);
        ir.writeUInt8(He, 0);
        const or = Buffer$f.alloc(4);
        or.writeUInt32BE(Pe, 0);
        const lr = this.getChainCode(), Ir = this.getKey();
        return (0, n.encode)(Buffer$f.concat([be, ir, nr, or, lr, Ir]));
      }, this.getRegistryType = () => A.RegistryTypes.CRYPTO_HDKEY, this.getOutputDescriptorContent = () => {
        var pe, $, Ee, be, He, Pe, nr;
        let ir = "";
        return this.getOrigin() && !((pe = this.getOrigin()) === null || pe === void 0) && pe.getSourceFingerprint() && !(($ = this.getOrigin()) === null || $ === void 0) && $.getPath() && (ir += `${(be = (Ee = this.getOrigin()) === null || Ee === void 0 ? void 0 : Ee.getSourceFingerprint()) === null || be === void 0 ? void 0 : be.toString("hex")}/${(He = this.getOrigin()) === null || He === void 0 ? void 0 : He.getPath()}`), ir += this.getBip32Key(), this.getChildren() && !((Pe = this.getChildren()) === null || Pe === void 0) && Pe.getPath() && (ir += `/${(nr = this.getChildren()) === null || nr === void 0 ? void 0 : nr.getPath()}`), ir;
      }, this.setupMasterKey = (pe) => {
        this.master = !0, this.key = pe.key, this.chainCode = pe.chainCode;
      }, this.setupDeriveKey = (pe) => {
        this.master = !1, this.privateKey = pe.isPrivateKey, this.key = pe.key, this.chainCode = pe.chainCode, this.useInfo = pe.useInfo, this.origin = pe.origin, this.children = pe.children, this.parentFingerprint = pe.parentFingerprint, this.name = pe.name, this.note = pe.note;
      }, this.toDataItem = () => {
        const pe = {};
        if (this.master)
          pe[b.is_master] = !0, pe[b.key_data] = this.key, pe[b.chain_code] = this.chainCode;
        else {
          if (this.privateKey !== void 0 && (pe[b.is_private] = this.privateKey), pe[b.key_data] = this.key, this.chainCode && (pe[b.chain_code] = this.chainCode), this.useInfo) {
            const $ = this.useInfo.toDataItem();
            $.setTag(this.useInfo.getRegistryType().getTag()), pe[b.use_info] = $;
          }
          if (this.origin) {
            const $ = this.origin.toDataItem();
            $.setTag(this.origin.getRegistryType().getTag()), pe[b.origin] = $;
          }
          if (this.children) {
            const $ = this.children.toDataItem();
            $.setTag(this.children.getRegistryType().getTag()), pe[b.children] = $;
          }
          this.parentFingerprint && (pe[b.parent_fingerprint] = this.parentFingerprint.readUInt32BE(0)), this.name !== void 0 && (pe[b.name] = this.name), this.note !== void 0 && (pe[b.note] = this.note);
        }
        return new p.DataItem(pe);
      }, L.isMaster ? this.setupMasterKey(L) : this.setupDeriveKey(L);
    }
  }
  return CryptoHDKey$1.CryptoHDKey = F, F.fromDataItem = (le) => {
    const L = le.getData(), pe = !!L[b.is_master], $ = L[b.is_private], Ee = L[b.key_data], be = L[b.chain_code], He = L[b.use_info] ? c.CryptoCoinInfo.fromDataItem(L[b.use_info]) : void 0, Pe = L[b.origin] ? u.CryptoKeypath.fromDataItem(L[b.origin]) : void 0, nr = L[b.children] ? u.CryptoKeypath.fromDataItem(L[b.children]) : void 0, ir = L[b.parent_fingerprint];
    let or;
    ir && (or = Buffer$f.alloc(4), or.writeUInt32BE(ir, 0));
    const lr = L[b.name], Ir = L[b.note];
    return new F({
      isMaster: pe,
      isPrivateKey: $,
      key: Ee,
      chainCode: be,
      useInfo: He,
      origin: Pe,
      children: nr,
      parentFingerprint: or,
      name: lr,
      note: Ir
    });
  }, F.fromCBOR = (le) => {
    const L = (0, p.decodeToDataItem)(le);
    return F.fromDataItem(L);
  }, CryptoHDKey$1;
}
var CryptoECKey$1 = {}, hasRequiredCryptoECKey$1;
function requireCryptoECKey$1() {
  if (hasRequiredCryptoECKey$1) return CryptoECKey$1;
  hasRequiredCryptoECKey$1 = 1, Object.defineProperty(CryptoECKey$1, "__esModule", { value: !0 }), CryptoECKey$1.CryptoECKey = void 0;
  const n = requireLib$1(), c = requireRegistryItem$1(), u = requireRegistryType$1();
  var p;
  (function(A) {
    A[A.curve = 1] = "curve", A[A.private = 2] = "private", A[A.data = 3] = "data";
  })(p || (p = {}));
  class a extends c.RegistryItem {
    constructor(b) {
      super(), this.isECKey = () => !0, this.getCurve = () => this.curve || 0, this.isPrivateKey = () => this.privateKey || !1, this.getData = () => this.data, this.getRegistryType = () => u.RegistryTypes.CRYPTO_ECKEY, this.toDataItem = () => {
        const F = {};
        return this.curve && (F[p.curve] = this.curve), this.privateKey !== void 0 && (F[p.private] = this.privateKey), F[p.data] = this.data, new n.DataItem(F);
      }, this.getOutputDescriptorContent = () => this.data.toString("hex"), this.data = b.data, this.curve = b.curve, this.privateKey = b.privateKey || void 0;
    }
  }
  return CryptoECKey$1.CryptoECKey = a, a.fromDataItem = (A) => {
    const b = A.getData(), F = b[p.curve], le = b[p.private], L = b[p.data];
    if (!L)
      throw new Error(`#[ur-registry][CryptoECKey][fn.fromDataItem]: decoded [dataItem][#data.data] is undefined: ${A}`);
    return new a({ data: L, curve: F, privateKey: le });
  }, a.fromCBOR = (A) => {
    const b = (0, n.decodeToDataItem)(A);
    return a.fromDataItem(b);
  }, CryptoECKey$1;
}
var Bytes$2 = {}, hasRequiredBytes$1;
function requireBytes$1() {
  if (hasRequiredBytes$1) return Bytes$2;
  hasRequiredBytes$1 = 1, Object.defineProperty(Bytes$2, "__esModule", { value: !0 }), Bytes$2.Bytes = void 0;
  const n = requireLib$1(), c = requireRegistryItem$1(), u = requireRegistryType$1();
  class p extends c.RegistryItem {
    constructor(A) {
      super(), this.bytes = A, this.getRegistryType = () => u.RegistryTypes.BYTES, this.getData = () => this.bytes, this.toDataItem = () => new n.DataItem(this.bytes);
    }
  }
  return Bytes$2.Bytes = p, p.fromDataItem = (a) => {
    const A = a.getData();
    if (!A)
      throw new Error(`#[ur-registry][Bytes][fn.fromDataItem]: decoded [dataItem][#data] is undefined: ${a}`);
    return new p(A);
  }, p.fromCBOR = (a) => {
    const A = (0, n.decodeToDataItem)(a);
    return p.fromDataItem(A);
  }, Bytes$2;
}
var CryptoOutput$1 = {}, MultiKey$1 = {}, hasRequiredMultiKey$1;
function requireMultiKey$1() {
  if (hasRequiredMultiKey$1) return MultiKey$1;
  hasRequiredMultiKey$1 = 1, Object.defineProperty(MultiKey$1, "__esModule", { value: !0 }), MultiKey$1.MultiKey = void 0;
  const n = requireCryptoECKey$1(), c = requireCryptoHDKey$1(), u = requireDataItem$1(), p = requireRegistryItem$1(), a = requireRegistryType$1();
  var A;
  (function(F) {
    F[F.threshold = 1] = "threshold", F[F.keys = 2] = "keys";
  })(A || (A = {}));
  class b extends p.RegistryItem {
    constructor(le, L) {
      super(), this.threshold = le, this.keys = L, this.getThreshold = () => this.threshold, this.getKeys = () => this.keys, this.toDataItem = () => {
        const pe = {};
        pe[A.threshold] = this.threshold;
        const $ = this.keys.map((Ee) => {
          const be = Ee.toDataItem();
          return be.setTag(Ee.getRegistryType().getTag()), be;
        });
        return pe[A.keys] = $, new u.DataItem(pe);
      }, this.getOutputDescriptorContent = () => [
        this.getThreshold(),
        this.keys.map((pe) => pe.getOutputDescriptorContent()).join(",")
      ].join(",");
    }
  }
  return MultiKey$1.MultiKey = b, b.fromDataItem = (F) => {
    const le = F.getData(), L = le[A.threshold], pe = le[A.keys], $ = [];
    return pe.forEach((Ee) => {
      Ee.getTag() === a.RegistryTypes.CRYPTO_HDKEY.getTag() ? $.push(c.CryptoHDKey.fromDataItem(Ee)) : Ee.getTag() === a.RegistryTypes.CRYPTO_ECKEY.getTag() && $.push(n.CryptoECKey.fromDataItem(Ee));
    }), new b(L, $);
  }, MultiKey$1;
}
var hasRequiredCryptoOutput$1;
function requireCryptoOutput$1() {
  if (hasRequiredCryptoOutput$1) return CryptoOutput$1;
  hasRequiredCryptoOutput$1 = 1, Object.defineProperty(CryptoOutput$1, "__esModule", { value: !0 }), CryptoOutput$1.CryptoOutput = void 0;
  const n = requireCryptoECKey$1(), c = requireCryptoHDKey$1(), u = requireLib$1(), p = requireMultiKey$1(), a = requireRegistryItem$1(), A = requireRegistryType$1(), b = requireScriptExpression$1();
  class F extends a.RegistryItem {
    constructor(L, pe) {
      super(), this.scriptExpressions = L, this.cryptoKey = pe, this.getRegistryType = () => A.RegistryTypes.CRYPTO_OUTPUT, this.getCryptoKey = () => this.cryptoKey, this.getHDKey = () => {
        if (this.cryptoKey instanceof c.CryptoHDKey)
          return this.cryptoKey;
      }, this.getECKey = () => {
        if (this.cryptoKey instanceof n.CryptoECKey)
          return this.cryptoKey;
      }, this.getMultiKey = () => {
        if (this.cryptoKey instanceof p.MultiKey)
          return this.cryptoKey;
      }, this.getScriptExpressions = () => this.scriptExpressions, this._toOutputDescriptor = ($) => $ >= this.scriptExpressions.length ? this.cryptoKey.getOutputDescriptorContent() : `${this.scriptExpressions[$].getExpression()}(${this._toOutputDescriptor($ + 1)})`, this.toString = () => this._toOutputDescriptor(0), this.toDataItem = () => {
        let $ = this.cryptoKey.toDataItem();
        return (this.cryptoKey instanceof n.CryptoECKey || this.cryptoKey instanceof c.CryptoHDKey) && $.setTag(this.cryptoKey.getRegistryType().getTag()), [...this.scriptExpressions].reverse().forEach((be) => {
          const He = be.getTag();
          $.getTag() === void 0 ? $.setTag(He) : $ = new u.DataItem($, He);
        }), $;
      };
    }
  }
  return CryptoOutput$1.CryptoOutput = F, F.fromDataItem = (le) => {
    const L = [];
    let pe = le;
    for (; ; ) {
      let be = pe.getTag();
      const He = b.ScriptExpression.fromTag(be);
      if (He)
        if (L.push(He), pe.getData() instanceof u.DataItem)
          pe = pe.getData(), be = pe.getTag();
        else
          break;
      else
        break;
    }
    const $ = L.length;
    if ($ > 0 && (L[$ - 1].getExpression() === b.ScriptExpressions.MULTISIG.getExpression() || L[$ - 1].getExpression() === b.ScriptExpressions.SORTED_MULTISIG.getExpression())) {
      const be = p.MultiKey.fromDataItem(pe);
      return new F(L, be);
    }
    if (pe.getTag() === A.RegistryTypes.CRYPTO_HDKEY.getTag()) {
      const be = c.CryptoHDKey.fromDataItem(pe);
      return new F(L, be);
    } else {
      const be = n.CryptoECKey.fromDataItem(pe);
      return new F(L, be);
    }
  }, F.fromCBOR = (le) => {
    const L = (0, u.decodeToDataItem)(le);
    return F.fromDataItem(L);
  }, CryptoOutput$1;
}
var CryptoPSBT$1 = {}, hasRequiredCryptoPSBT$1;
function requireCryptoPSBT$1() {
  if (hasRequiredCryptoPSBT$1) return CryptoPSBT$1;
  hasRequiredCryptoPSBT$1 = 1, Object.defineProperty(CryptoPSBT$1, "__esModule", { value: !0 }), CryptoPSBT$1.CryptoPSBT = void 0;
  const n = requireLib$1(), c = requireRegistryItem$1(), u = requireRegistryType$1();
  class p extends c.RegistryItem {
    constructor(A) {
      super(), this.psbt = A, this.getRegistryType = () => u.RegistryTypes.CRYPTO_PSBT, this.getPSBT = () => this.psbt, this.toDataItem = () => new n.DataItem(this.psbt);
    }
  }
  return CryptoPSBT$1.CryptoPSBT = p, p.fromDataItem = (a) => {
    const A = a.getData();
    if (!A)
      throw new Error(`#[ur-registry][CryptoPSBT][fn.fromDataItem]: decoded [dataItem][#data] is undefined: ${a}`);
    return new p(A);
  }, p.fromCBOR = (a) => {
    const A = (0, n.decodeToDataItem)(a);
    return p.fromDataItem(A);
  }, CryptoPSBT$1;
}
var CryptoAccount$1 = {}, hasRequiredCryptoAccount$1;
function requireCryptoAccount$1() {
  if (hasRequiredCryptoAccount$1) return CryptoAccount$1;
  hasRequiredCryptoAccount$1 = 1, Object.defineProperty(CryptoAccount$1, "__esModule", { value: !0 }), CryptoAccount$1.CryptoAccount = void 0;
  const n = requireDist$1(), c = requireLib$1(), u = requireRegistryItem$1(), p = requireRegistryType$1();
  var a;
  (function(b) {
    b[b.masterFingerprint = 1] = "masterFingerprint", b[b.outputDescriptors = 2] = "outputDescriptors";
  })(a || (a = {}));
  class A extends u.RegistryItem {
    constructor(F, le) {
      super(), this.masterFingerprint = F, this.outputDescriptors = le, this.getRegistryType = () => p.RegistryTypes.CRYPTO_ACCOUNT, this.getMasterFingerprint = () => this.masterFingerprint, this.getOutputDescriptors = () => this.outputDescriptors, this.toDataItem = () => {
        const L = {};
        return this.masterFingerprint && (L[a.masterFingerprint] = this.masterFingerprint.readUInt32BE(0)), this.outputDescriptors && (L[a.outputDescriptors] = this.outputDescriptors.map((pe) => pe.toDataItem())), new c.DataItem(L);
      };
    }
  }
  return CryptoAccount$1.CryptoAccount = A, A.fromDataItem = (b) => {
    const F = b.getData(), le = Buffer$f.alloc(4), L = F[a.masterFingerprint];
    L && le.writeUInt32BE(L, 0);
    const $ = F[a.outputDescriptors].map((Ee) => n.CryptoOutput.fromDataItem(Ee));
    return new A(le, $);
  }, A.fromCBOR = (b) => {
    const F = (0, c.decodeToDataItem)(b);
    return A.fromDataItem(F);
  }, CryptoAccount$1;
}
var Decoder$1 = {}, errors$2 = {}, hasRequiredErrors$1;
function requireErrors$1() {
  if (hasRequiredErrors$1) return errors$2;
  hasRequiredErrors$1 = 1, Object.defineProperty(errors$2, "__esModule", { value: !0 }), errors$2.UnknownURTypeError = void 0;
  class n extends Error {
    constructor(u) {
      super(u);
    }
  }
  return errors$2.UnknownURTypeError = n, errors$2;
}
var hasRequiredDecoder$1;
function requireDecoder$1() {
  if (hasRequiredDecoder$1) return Decoder$1;
  hasRequiredDecoder$1 = 1, Object.defineProperty(Decoder$1, "__esModule", { value: !0 }), Decoder$1.URRegistryDecoder = void 0;
  const n = dist$t, c = requireDist$1(), u = requireRegistryType$1(), p = requireErrors$1();
  class a extends n.URDecoder {
    constructor() {
      super(...arguments), this.resultRegistryType = () => {
        const b = this.resultUR();
        switch (b.type) {
          case u.RegistryTypes.BYTES.getType():
            return c.Bytes.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_HDKEY.getType():
            return c.CryptoHDKey.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_KEYPATH.getType():
            return c.CryptoKeypath.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_COIN_INFO.getType():
            return c.CryptoCoinInfo.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_ECKEY.getType():
            return c.CryptoECKey.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_OUTPUT.getType():
            return c.CryptoOutput.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_PSBT.getType():
            return c.CryptoPSBT.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_ACCOUNT.getType():
            return c.CryptoAccount.fromCBOR(b.cbor);
          default:
            throw new p.UnknownURTypeError(`#[ur-registry][Decoder][fn.resultRegistryType]: registry type ${b.type} is not supported now`);
        }
      };
    }
  }
  return Decoder$1.URRegistryDecoder = a, Decoder$1;
}
var CryptoMultiAccounts$1 = {}, hasRequiredCryptoMultiAccounts$1;
function requireCryptoMultiAccounts$1() {
  if (hasRequiredCryptoMultiAccounts$1) return CryptoMultiAccounts$1;
  hasRequiredCryptoMultiAccounts$1 = 1, Object.defineProperty(CryptoMultiAccounts$1, "__esModule", { value: !0 }), CryptoMultiAccounts$1.CryptoMultiAccounts = void 0;
  const n = requireRegistryType$1(), c = requireCryptoHDKey$1(), u = requireRegistryItem$1(), p = requireLib$1();
  var a;
  (function(b) {
    b[b.masterFingerprint = 1] = "masterFingerprint", b[b.keys = 2] = "keys", b[b.device = 3] = "device", b[b.deviceId = 4] = "deviceId", b[b.version = 5] = "version";
  })(a || (a = {}));
  class A extends u.RegistryItem {
    constructor(F, le, L, pe, $) {
      super(), this.masterFingerprint = F, this.keys = le, this.device = L, this.deviceId = pe, this.version = $, this.getRegistryType = () => n.RegistryTypes.CRYPTO_MULTI_ACCOUNTS, this.getMasterFingerprint = () => this.masterFingerprint, this.getKeys = () => this.keys, this.getDevice = () => this.device, this.getDeviceId = () => this.deviceId, this.getVersion = () => this.version, this.toDataItem = () => {
        const Ee = {};
        return this.masterFingerprint && (Ee[a.masterFingerprint] = this.masterFingerprint.readUInt32BE(0)), this.keys && (Ee[a.keys] = this.keys.map((be) => {
          const He = be.toDataItem();
          return He.setTag(be.getRegistryType().getTag()), He;
        })), this.device && (Ee[a.device] = this.device), this.deviceId && (Ee[a.deviceId] = this.deviceId), this.version && (Ee[a.version] = this.version), new p.DataItem(Ee);
      };
    }
  }
  return CryptoMultiAccounts$1.CryptoMultiAccounts = A, A.fromDataItem = (b) => {
    const F = b.getData(), le = Buffer$f.alloc(4), L = F[a.masterFingerprint];
    L && le.writeUInt32BE(L, 0);
    const $ = F[a.keys].map((Pe) => c.CryptoHDKey.fromDataItem(Pe)), Ee = F[a.device], be = F[a.deviceId], He = F[a.version];
    return new A(le, $, Ee, be, He);
  }, A.fromCBOR = (b) => {
    const F = (0, p.decodeToDataItem)(b);
    return A.fromDataItem(F);
  }, CryptoMultiAccounts$1;
}
var QRHardwareCall$1 = {}, KeyDerivation$1 = {}, DerivationSchema$1 = {}, hasRequiredDerivationSchema$1;
function requireDerivationSchema$1() {
  return hasRequiredDerivationSchema$1 || (hasRequiredDerivationSchema$1 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.KeyDerivationSchema = n.DerivationAlgorithm = n.Curve = void 0;
    const c = requireRegistryType$1(), u = requireRegistryItem$1(), p = requireLib$1(), a = requireCryptoKeypath$1();
    var A;
    (function(L) {
      L[L.keyPath = 1] = "keyPath", L[L.curve = 2] = "curve", L[L.algo = 3] = "algo";
    })(A || (A = {}));
    var b;
    (function(L) {
      L[L.secp256k1 = 0] = "secp256k1", L[L.ed25519 = 1] = "ed25519";
    })(b = n.Curve || (n.Curve = {}));
    var F;
    (function(L) {
      L[L.slip10 = 0] = "slip10", L[L.bip32ed25519 = 1] = "bip32ed25519";
    })(F = n.DerivationAlgorithm || (n.DerivationAlgorithm = {}));
    class le extends u.RegistryItem {
      constructor(pe, $ = b.secp256k1, Ee = F.slip10) {
        super(), this.keypath = pe, this.curve = $, this.algo = Ee, this.getRegistryType = () => c.RegistryTypes.KEY_DERIVATION_SCHEMA, this.getKeypath = () => this.keypath, this.getCurve = () => this.curve, this.getAlgo = () => this.algo, this.toDataItem = () => {
          const be = {}, He = this.getKeypath().toDataItem();
          return He.setTag(this.getKeypath().getRegistryType().getTag()), be[A.keyPath] = He, be[A.curve] = this.curve, be[A.algo] = this.algo, new p.DataItem(be);
        };
      }
    }
    n.KeyDerivationSchema = le, le.fromDataItem = (L) => {
      const pe = L.getData(), $ = a.CryptoKeypath.fromDataItem(pe[A.keyPath]), Ee = pe[A.curve], be = pe[A.algo];
      return new le($, Ee, be);
    }, le.fromCBOR = (L) => {
      const pe = (0, p.decodeToDataItem)(L);
      return le.fromDataItem(pe);
    };
  }(DerivationSchema$1)), DerivationSchema$1;
}
var hasRequiredKeyDerivation$1;
function requireKeyDerivation$1() {
  if (hasRequiredKeyDerivation$1) return KeyDerivation$1;
  hasRequiredKeyDerivation$1 = 1, Object.defineProperty(KeyDerivation$1, "__esModule", { value: !0 }), KeyDerivation$1.KeyDerivation = void 0;
  const n = requireRegistryType$1(), c = requireRegistryItem$1(), u = requireLib$1(), p = requireDerivationSchema$1();
  var a;
  (function(b) {
    b[b.schemas = 1] = "schemas";
  })(a || (a = {}));
  class A extends c.RegistryItem {
    constructor(F) {
      super(), this.schemas = F, this.getRegistryType = () => n.RegistryTypes.KEY_DERIVATION_CALL, this.getSchemas = () => this.schemas, this.toDataItem = () => {
        const le = {};
        return le[a.schemas] = this.schemas.map((L) => {
          const pe = L.toDataItem();
          return pe.setTag(L.getRegistryType().getTag()), pe;
        }), new u.DataItem(le);
      };
    }
  }
  return KeyDerivation$1.KeyDerivation = A, A.fromDataItem = (b) => {
    const le = b.getData()[a.schemas].map((L) => p.KeyDerivationSchema.fromDataItem(L));
    return new A(le);
  }, A.fromCBOR = (b) => {
    const F = (0, u.decodeToDataItem)(b);
    return A.fromDataItem(F);
  }, KeyDerivation$1;
}
var hasRequiredQRHardwareCall$1;
function requireQRHardwareCall$1() {
  return hasRequiredQRHardwareCall$1 || (hasRequiredQRHardwareCall$1 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.QRHardwareCall = n.QRHardwareCallType = void 0;
    const c = requireRegistryType$1(), u = requireRegistryItem$1(), p = requireLib$1(), a = requireKeyDerivation$1();
    var A;
    (function(le) {
      le[le.type = 1] = "type", le[le.params = 2] = "params", le[le.origin = 3] = "origin";
    })(A || (A = {}));
    var b;
    (function(le) {
      le[le.KeyDerivation = 0] = "KeyDerivation";
    })(b = n.QRHardwareCallType || (n.QRHardwareCallType = {}));
    class F extends u.RegistryItem {
      constructor(L, pe, $) {
        super(), this.type = L, this.params = pe, this.origin = $, this.getRegistryType = () => c.RegistryTypes.QR_HARDWARE_CALL, this.getType = () => this.type, this.getParams = () => this.params, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const Ee = {};
          Ee[A.type] = this.type;
          const be = this.params.toDataItem();
          return be.setTag(this.params.getRegistryType().getTag()), Ee[A.params] = be, this.origin && (Ee[A.origin] = this.origin), new p.DataItem(Ee);
        };
      }
    }
    n.QRHardwareCall = F, F.fromDataItem = (le) => {
      const L = le.getData(), pe = L[A.type] || b.KeyDerivation;
      let $;
      switch (pe) {
        case b.KeyDerivation:
          $ = a.KeyDerivation.fromDataItem(L[A.params]);
      }
      const Ee = L[A.origin];
      return new F(pe, $, Ee);
    }, F.fromCBOR = (le) => {
      const L = (0, p.decodeToDataItem)(le);
      return F.fromDataItem(L);
    };
  }(QRHardwareCall$1)), QRHardwareCall$1;
}
var types$6 = {}, hasRequiredTypes$1;
function requireTypes$1() {
  return hasRequiredTypes$1 || (hasRequiredTypes$1 = 1, Object.defineProperty(types$6, "__esModule", { value: !0 })), types$6;
}
var hasRequiredDist$1;
function requireDist$1() {
  return hasRequiredDist$1 || (hasRequiredDist$1 = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.Buffer = n.extend = n.PathComponent = n.ScriptExpressions = n.MultiKey = n.CryptoPSBT = n.CryptoOutput = n.CryptoECKey = n.CryptoCoinInfoNetwork = n.CryptoCoinInfoType = n.CryptoCoinInfo = n.CryptoKeypath = n.CryptoMultiAccounts = n.CryptoHDKey = n.CryptoAccount = n.Bytes = n.URRegistryDecoder = n.DataItem = void 0;
    const c = require$$0$4;
    requirePatchCBOR$1();
    const u = dist$u;
    Object.defineProperty(n, "Buffer", { enumerable: !0, get: function() {
      return u.Buffer;
    } });
    const p = requireCryptoHDKey$1();
    Object.defineProperty(n, "CryptoHDKey", { enumerable: !0, get: function() {
      return p.CryptoHDKey;
    } });
    const a = requireCryptoKeypath$1();
    Object.defineProperty(n, "CryptoKeypath", { enumerable: !0, get: function() {
      return a.CryptoKeypath;
    } });
    const A = requireCryptoCoinInfo$1();
    Object.defineProperty(n, "CryptoCoinInfo", { enumerable: !0, get: function() {
      return A.CryptoCoinInfo;
    } }), Object.defineProperty(n, "CryptoCoinInfoType", { enumerable: !0, get: function() {
      return A.Type;
    } }), Object.defineProperty(n, "CryptoCoinInfoNetwork", { enumerable: !0, get: function() {
      return A.Network;
    } });
    const b = requireCryptoECKey$1();
    Object.defineProperty(n, "CryptoECKey", { enumerable: !0, get: function() {
      return b.CryptoECKey;
    } });
    const F = requireBytes$1();
    Object.defineProperty(n, "Bytes", { enumerable: !0, get: function() {
      return F.Bytes;
    } });
    const le = requireCryptoOutput$1();
    Object.defineProperty(n, "CryptoOutput", { enumerable: !0, get: function() {
      return le.CryptoOutput;
    } });
    const L = requireCryptoPSBT$1();
    Object.defineProperty(n, "CryptoPSBT", { enumerable: !0, get: function() {
      return L.CryptoPSBT;
    } });
    const pe = requireCryptoAccount$1();
    Object.defineProperty(n, "CryptoAccount", { enumerable: !0, get: function() {
      return pe.CryptoAccount;
    } });
    const $ = requireDecoder$1();
    Object.defineProperty(n, "URRegistryDecoder", { enumerable: !0, get: function() {
      return $.URRegistryDecoder;
    } });
    const Ee = requireMultiKey$1();
    Object.defineProperty(n, "MultiKey", { enumerable: !0, get: function() {
      return Ee.MultiKey;
    } });
    const be = requireScriptExpression$1();
    Object.defineProperty(n, "ScriptExpressions", { enumerable: !0, get: function() {
      return be.ScriptExpressions;
    } });
    const He = requirePathComponent$1();
    Object.defineProperty(n, "PathComponent", { enumerable: !0, get: function() {
      return He.PathComponent;
    } });
    const Pe = requireRegistryItem$1(), nr = requireRegistryType$1(), ir = requireLib$1();
    var or = requireLib$1();
    Object.defineProperty(n, "DataItem", { enumerable: !0, get: function() {
      return or.DataItem;
    } });
    const lr = requireUtils$1(), Ir = requireCryptoMultiAccounts$1();
    Object.defineProperty(n, "CryptoMultiAccounts", { enumerable: !0, get: function() {
      return Ir.CryptoMultiAccounts;
    } });
    const xr = {
      URRegistryDecoder: $.URRegistryDecoder,
      Bytes: F.Bytes,
      CryptoAccount: pe.CryptoAccount,
      CryptoHDKey: p.CryptoHDKey,
      CryptoMultiAccounts: Ir.CryptoMultiAccounts,
      CryptoKeypath: a.CryptoKeypath,
      CryptoCoinInfo: A.CryptoCoinInfo,
      CryptoCoinInfoType: A.Type,
      CryptoCoinInfoNetwork: A.Network,
      CryptoECKey: b.CryptoECKey,
      CryptoOutput: le.CryptoOutput,
      CryptoPSBT: L.CryptoPSBT,
      MultiKey: Ee.MultiKey,
      ScriptExpressions: be.ScriptExpressions,
      PathComponent: He.PathComponent
    }, kr = {
      addReader: ir.addReader,
      addSemanticDecode: ir.addSemanticDecode,
      addSemanticEncode: ir.addSemanticEncode,
      addWriter: ir.addWriter,
      patchTags: lr.patchTags
    }, Ce = {
      RegistryTypes: nr.RegistryTypes,
      RegistryItem: Pe.RegistryItem,
      RegistryType: nr.RegistryType,
      decodeToDataItem: ir.decodeToDataItem,
      encodeDataItem: ir.encodeDataItem,
      cbor: kr
    };
    n.extend = Ce, (0, c.__exportStar)(requireErrors$1(), n), (0, c.__exportStar)(requireDecoder$1(), n), (0, c.__exportStar)(requireLib$1(), n), (0, c.__exportStar)(requireCryptoAccount$1(), n), (0, c.__exportStar)(requireCryptoPSBT$1(), n), (0, c.__exportStar)(requireCryptoHDKey$1(), n), (0, c.__exportStar)(requireCryptoMultiAccounts$1(), n), (0, c.__exportStar)(requireQRHardwareCall$1(), n), (0, c.__exportStar)(requireKeyDerivation$1(), n), (0, c.__exportStar)(requireDerivationSchema$1(), n), (0, c.__exportStar)(requireCryptoOutput$1(), n), (0, c.__exportStar)(requireCryptoCoinInfo$1(), n), (0, c.__exportStar)(requireCryptoECKey$1(), n), (0, c.__exportStar)(requireMultiKey$1(), n), (0, c.__exportStar)(requireCryptoKeypath$1(), n), (0, c.__exportStar)(requirePatchCBOR$1(), n), (0, c.__exportStar)(requirePathComponent$1(), n), (0, c.__exportStar)(requireRegistryItem$1(), n), (0, c.__exportStar)(requireRegistryType$1(), n), (0, c.__exportStar)(requireTypes$1(), n), (0, c.__exportStar)(requireUtils$1(), n), n.default = xr;
  }(dist$6)), dist$6;
}
var commonjsBrowser = {}, v1$1 = {}, rng$2 = {}, hasRequiredRng;
function requireRng() {
  if (hasRequiredRng) return rng$2;
  hasRequiredRng = 1, Object.defineProperty(rng$2, "__esModule", {
    value: !0
  }), rng$2.default = u;
  let n;
  const c = new Uint8Array(16);
  function u() {
    if (!n && (n = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !n))
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    return n(c);
  }
  return rng$2;
}
var stringify$1 = {}, validate$2 = {}, regex = {}, hasRequiredRegex;
function requireRegex() {
  if (hasRequiredRegex) return regex;
  hasRequiredRegex = 1, Object.defineProperty(regex, "__esModule", {
    value: !0
  }), regex.default = void 0;
  var n = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
  return regex.default = n, regex;
}
var hasRequiredValidate;
function requireValidate() {
  if (hasRequiredValidate) return validate$2;
  hasRequiredValidate = 1, Object.defineProperty(validate$2, "__esModule", {
    value: !0
  }), validate$2.default = void 0;
  var n = c(requireRegex());
  function c(a) {
    return a && a.__esModule ? a : { default: a };
  }
  function u(a) {
    return typeof a == "string" && n.default.test(a);
  }
  var p = u;
  return validate$2.default = p, validate$2;
}
var hasRequiredStringify;
function requireStringify() {
  if (hasRequiredStringify) return stringify$1;
  hasRequiredStringify = 1, Object.defineProperty(stringify$1, "__esModule", {
    value: !0
  }), stringify$1.default = void 0, stringify$1.unsafeStringify = p;
  var n = c(requireValidate());
  function c(b) {
    return b && b.__esModule ? b : { default: b };
  }
  const u = [];
  for (let b = 0; b < 256; ++b)
    u.push((b + 256).toString(16).slice(1));
  function p(b, F = 0) {
    return u[b[F + 0]] + u[b[F + 1]] + u[b[F + 2]] + u[b[F + 3]] + "-" + u[b[F + 4]] + u[b[F + 5]] + "-" + u[b[F + 6]] + u[b[F + 7]] + "-" + u[b[F + 8]] + u[b[F + 9]] + "-" + u[b[F + 10]] + u[b[F + 11]] + u[b[F + 12]] + u[b[F + 13]] + u[b[F + 14]] + u[b[F + 15]];
  }
  function a(b, F = 0) {
    const le = p(b, F);
    if (!(0, n.default)(le))
      throw TypeError("Stringified UUID is invalid");
    return le;
  }
  var A = a;
  return stringify$1.default = A, stringify$1;
}
var hasRequiredV1;
function requireV1() {
  if (hasRequiredV1) return v1$1;
  hasRequiredV1 = 1, Object.defineProperty(v1$1, "__esModule", {
    value: !0
  }), v1$1.default = void 0;
  var n = u(requireRng()), c = requireStringify();
  function u(L) {
    return L && L.__esModule ? L : { default: L };
  }
  let p, a, A = 0, b = 0;
  function F(L, pe, $) {
    let Ee = pe && $ || 0;
    const be = pe || new Array(16);
    L = L || {};
    let He = L.node || p, Pe = L.clockseq !== void 0 ? L.clockseq : a;
    if (He == null || Pe == null) {
      const xr = L.random || (L.rng || n.default)();
      He == null && (He = p = [xr[0] | 1, xr[1], xr[2], xr[3], xr[4], xr[5]]), Pe == null && (Pe = a = (xr[6] << 8 | xr[7]) & 16383);
    }
    let nr = L.msecs !== void 0 ? L.msecs : Date.now(), ir = L.nsecs !== void 0 ? L.nsecs : b + 1;
    const or = nr - A + (ir - b) / 1e4;
    if (or < 0 && L.clockseq === void 0 && (Pe = Pe + 1 & 16383), (or < 0 || nr > A) && L.nsecs === void 0 && (ir = 0), ir >= 1e4)
      throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    A = nr, b = ir, a = Pe, nr += 122192928e5;
    const lr = ((nr & 268435455) * 1e4 + ir) % 4294967296;
    be[Ee++] = lr >>> 24 & 255, be[Ee++] = lr >>> 16 & 255, be[Ee++] = lr >>> 8 & 255, be[Ee++] = lr & 255;
    const Ir = nr / 4294967296 * 1e4 & 268435455;
    be[Ee++] = Ir >>> 8 & 255, be[Ee++] = Ir & 255, be[Ee++] = Ir >>> 24 & 15 | 16, be[Ee++] = Ir >>> 16 & 255, be[Ee++] = Pe >>> 8 | 128, be[Ee++] = Pe & 255;
    for (let xr = 0; xr < 6; ++xr)
      be[Ee + xr] = He[xr];
    return pe || (0, c.unsafeStringify)(be);
  }
  var le = F;
  return v1$1.default = le, v1$1;
}
var v3$1 = {}, v35$1 = {}, parse$8 = {}, hasRequiredParse;
function requireParse() {
  if (hasRequiredParse) return parse$8;
  hasRequiredParse = 1, Object.defineProperty(parse$8, "__esModule", {
    value: !0
  }), parse$8.default = void 0;
  var n = c(requireValidate());
  function c(a) {
    return a && a.__esModule ? a : { default: a };
  }
  function u(a) {
    if (!(0, n.default)(a))
      throw TypeError("Invalid UUID");
    let A;
    const b = new Uint8Array(16);
    return b[0] = (A = parseInt(a.slice(0, 8), 16)) >>> 24, b[1] = A >>> 16 & 255, b[2] = A >>> 8 & 255, b[3] = A & 255, b[4] = (A = parseInt(a.slice(9, 13), 16)) >>> 8, b[5] = A & 255, b[6] = (A = parseInt(a.slice(14, 18), 16)) >>> 8, b[7] = A & 255, b[8] = (A = parseInt(a.slice(19, 23), 16)) >>> 8, b[9] = A & 255, b[10] = (A = parseInt(a.slice(24, 36), 16)) / 1099511627776 & 255, b[11] = A / 4294967296 & 255, b[12] = A >>> 24 & 255, b[13] = A >>> 16 & 255, b[14] = A >>> 8 & 255, b[15] = A & 255, b;
  }
  var p = u;
  return parse$8.default = p, parse$8;
}
var hasRequiredV35;
function requireV35() {
  if (hasRequiredV35) return v35$1;
  hasRequiredV35 = 1, Object.defineProperty(v35$1, "__esModule", {
    value: !0
  }), v35$1.URL = v35$1.DNS = void 0, v35$1.default = b;
  var n = requireStringify(), c = u(requireParse());
  function u(F) {
    return F && F.__esModule ? F : { default: F };
  }
  function p(F) {
    F = unescape(encodeURIComponent(F));
    const le = [];
    for (let L = 0; L < F.length; ++L)
      le.push(F.charCodeAt(L));
    return le;
  }
  const a = "6ba7b810-9dad-11d1-80b4-00c04fd430c8";
  v35$1.DNS = a;
  const A = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
  v35$1.URL = A;
  function b(F, le, L) {
    function pe($, Ee, be, He) {
      var Pe;
      if (typeof $ == "string" && ($ = p($)), typeof Ee == "string" && (Ee = (0, c.default)(Ee)), ((Pe = Ee) === null || Pe === void 0 ? void 0 : Pe.length) !== 16)
        throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
      let nr = new Uint8Array(16 + $.length);
      if (nr.set(Ee), nr.set($, Ee.length), nr = L(nr), nr[6] = nr[6] & 15 | le, nr[8] = nr[8] & 63 | 128, be) {
        He = He || 0;
        for (let ir = 0; ir < 16; ++ir)
          be[He + ir] = nr[ir];
        return be;
      }
      return (0, n.unsafeStringify)(nr);
    }
    try {
      pe.name = F;
    } catch {
    }
    return pe.DNS = a, pe.URL = A, pe;
  }
  return v35$1;
}
var md5$1 = {}, hasRequiredMd5;
function requireMd5() {
  if (hasRequiredMd5) return md5$1;
  hasRequiredMd5 = 1, Object.defineProperty(md5$1, "__esModule", {
    value: !0
  }), md5$1.default = void 0;
  function n(be) {
    if (typeof be == "string") {
      const He = unescape(encodeURIComponent(be));
      be = new Uint8Array(He.length);
      for (let Pe = 0; Pe < He.length; ++Pe)
        be[Pe] = He.charCodeAt(Pe);
    }
    return c(p(a(be), be.length * 8));
  }
  function c(be) {
    const He = [], Pe = be.length * 32, nr = "0123456789abcdef";
    for (let ir = 0; ir < Pe; ir += 8) {
      const or = be[ir >> 5] >>> ir % 32 & 255, lr = parseInt(nr.charAt(or >>> 4 & 15) + nr.charAt(or & 15), 16);
      He.push(lr);
    }
    return He;
  }
  function u(be) {
    return (be + 64 >>> 9 << 4) + 14 + 1;
  }
  function p(be, He) {
    be[He >> 5] |= 128 << He % 32, be[u(He) - 1] = He;
    let Pe = 1732584193, nr = -271733879, ir = -1732584194, or = 271733878;
    for (let lr = 0; lr < be.length; lr += 16) {
      const Ir = Pe, xr = nr, kr = ir, Ce = or;
      Pe = le(Pe, nr, ir, or, be[lr], 7, -680876936), or = le(or, Pe, nr, ir, be[lr + 1], 12, -389564586), ir = le(ir, or, Pe, nr, be[lr + 2], 17, 606105819), nr = le(nr, ir, or, Pe, be[lr + 3], 22, -1044525330), Pe = le(Pe, nr, ir, or, be[lr + 4], 7, -176418897), or = le(or, Pe, nr, ir, be[lr + 5], 12, 1200080426), ir = le(ir, or, Pe, nr, be[lr + 6], 17, -1473231341), nr = le(nr, ir, or, Pe, be[lr + 7], 22, -45705983), Pe = le(Pe, nr, ir, or, be[lr + 8], 7, 1770035416), or = le(or, Pe, nr, ir, be[lr + 9], 12, -1958414417), ir = le(ir, or, Pe, nr, be[lr + 10], 17, -42063), nr = le(nr, ir, or, Pe, be[lr + 11], 22, -1990404162), Pe = le(Pe, nr, ir, or, be[lr + 12], 7, 1804603682), or = le(or, Pe, nr, ir, be[lr + 13], 12, -40341101), ir = le(ir, or, Pe, nr, be[lr + 14], 17, -1502002290), nr = le(nr, ir, or, Pe, be[lr + 15], 22, 1236535329), Pe = L(Pe, nr, ir, or, be[lr + 1], 5, -165796510), or = L(or, Pe, nr, ir, be[lr + 6], 9, -1069501632), ir = L(ir, or, Pe, nr, be[lr + 11], 14, 643717713), nr = L(nr, ir, or, Pe, be[lr], 20, -373897302), Pe = L(Pe, nr, ir, or, be[lr + 5], 5, -701558691), or = L(or, Pe, nr, ir, be[lr + 10], 9, 38016083), ir = L(ir, or, Pe, nr, be[lr + 15], 14, -660478335), nr = L(nr, ir, or, Pe, be[lr + 4], 20, -405537848), Pe = L(Pe, nr, ir, or, be[lr + 9], 5, 568446438), or = L(or, Pe, nr, ir, be[lr + 14], 9, -1019803690), ir = L(ir, or, Pe, nr, be[lr + 3], 14, -187363961), nr = L(nr, ir, or, Pe, be[lr + 8], 20, 1163531501), Pe = L(Pe, nr, ir, or, be[lr + 13], 5, -1444681467), or = L(or, Pe, nr, ir, be[lr + 2], 9, -51403784), ir = L(ir, or, Pe, nr, be[lr + 7], 14, 1735328473), nr = L(nr, ir, or, Pe, be[lr + 12], 20, -1926607734), Pe = pe(Pe, nr, ir, or, be[lr + 5], 4, -378558), or = pe(or, Pe, nr, ir, be[lr + 8], 11, -2022574463), ir = pe(ir, or, Pe, nr, be[lr + 11], 16, 1839030562), nr = pe(nr, ir, or, Pe, be[lr + 14], 23, -35309556), Pe = pe(Pe, nr, ir, or, be[lr + 1], 4, -1530992060), or = pe(or, Pe, nr, ir, be[lr + 4], 11, 1272893353), ir = pe(ir, or, Pe, nr, be[lr + 7], 16, -155497632), nr = pe(nr, ir, or, Pe, be[lr + 10], 23, -1094730640), Pe = pe(Pe, nr, ir, or, be[lr + 13], 4, 681279174), or = pe(or, Pe, nr, ir, be[lr], 11, -358537222), ir = pe(ir, or, Pe, nr, be[lr + 3], 16, -722521979), nr = pe(nr, ir, or, Pe, be[lr + 6], 23, 76029189), Pe = pe(Pe, nr, ir, or, be[lr + 9], 4, -640364487), or = pe(or, Pe, nr, ir, be[lr + 12], 11, -421815835), ir = pe(ir, or, Pe, nr, be[lr + 15], 16, 530742520), nr = pe(nr, ir, or, Pe, be[lr + 2], 23, -995338651), Pe = $(Pe, nr, ir, or, be[lr], 6, -198630844), or = $(or, Pe, nr, ir, be[lr + 7], 10, 1126891415), ir = $(ir, or, Pe, nr, be[lr + 14], 15, -1416354905), nr = $(nr, ir, or, Pe, be[lr + 5], 21, -57434055), Pe = $(Pe, nr, ir, or, be[lr + 12], 6, 1700485571), or = $(or, Pe, nr, ir, be[lr + 3], 10, -1894986606), ir = $(ir, or, Pe, nr, be[lr + 10], 15, -1051523), nr = $(nr, ir, or, Pe, be[lr + 1], 21, -2054922799), Pe = $(Pe, nr, ir, or, be[lr + 8], 6, 1873313359), or = $(or, Pe, nr, ir, be[lr + 15], 10, -30611744), ir = $(ir, or, Pe, nr, be[lr + 6], 15, -1560198380), nr = $(nr, ir, or, Pe, be[lr + 13], 21, 1309151649), Pe = $(Pe, nr, ir, or, be[lr + 4], 6, -145523070), or = $(or, Pe, nr, ir, be[lr + 11], 10, -1120210379), ir = $(ir, or, Pe, nr, be[lr + 2], 15, 718787259), nr = $(nr, ir, or, Pe, be[lr + 9], 21, -343485551), Pe = A(Pe, Ir), nr = A(nr, xr), ir = A(ir, kr), or = A(or, Ce);
    }
    return [Pe, nr, ir, or];
  }
  function a(be) {
    if (be.length === 0)
      return [];
    const He = be.length * 8, Pe = new Uint32Array(u(He));
    for (let nr = 0; nr < He; nr += 8)
      Pe[nr >> 5] |= (be[nr / 8] & 255) << nr % 32;
    return Pe;
  }
  function A(be, He) {
    const Pe = (be & 65535) + (He & 65535);
    return (be >> 16) + (He >> 16) + (Pe >> 16) << 16 | Pe & 65535;
  }
  function b(be, He) {
    return be << He | be >>> 32 - He;
  }
  function F(be, He, Pe, nr, ir, or) {
    return A(b(A(A(He, be), A(nr, or)), ir), Pe);
  }
  function le(be, He, Pe, nr, ir, or, lr) {
    return F(He & Pe | ~He & nr, be, He, ir, or, lr);
  }
  function L(be, He, Pe, nr, ir, or, lr) {
    return F(He & nr | Pe & ~nr, be, He, ir, or, lr);
  }
  function pe(be, He, Pe, nr, ir, or, lr) {
    return F(He ^ Pe ^ nr, be, He, ir, or, lr);
  }
  function $(be, He, Pe, nr, ir, or, lr) {
    return F(Pe ^ (He | ~nr), be, He, ir, or, lr);
  }
  var Ee = n;
  return md5$1.default = Ee, md5$1;
}
var hasRequiredV3;
function requireV3() {
  if (hasRequiredV3) return v3$1;
  hasRequiredV3 = 1, Object.defineProperty(v3$1, "__esModule", {
    value: !0
  }), v3$1.default = void 0;
  var n = u(requireV35()), c = u(requireMd5());
  function u(A) {
    return A && A.__esModule ? A : { default: A };
  }
  var a = (0, n.default)("v3", 48, c.default);
  return v3$1.default = a, v3$1;
}
var v4$2 = {}, native$1 = {}, hasRequiredNative;
function requireNative() {
  if (hasRequiredNative) return native$1;
  hasRequiredNative = 1, Object.defineProperty(native$1, "__esModule", {
    value: !0
  }), native$1.default = void 0;
  var c = {
    randomUUID: typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto)
  };
  return native$1.default = c, native$1;
}
var hasRequiredV4;
function requireV4() {
  if (hasRequiredV4) return v4$2;
  hasRequiredV4 = 1, Object.defineProperty(v4$2, "__esModule", {
    value: !0
  }), v4$2.default = void 0;
  var n = p(requireNative()), c = p(requireRng()), u = requireStringify();
  function p(b) {
    return b && b.__esModule ? b : { default: b };
  }
  function a(b, F, le) {
    if (n.default.randomUUID && !F && !b)
      return n.default.randomUUID();
    b = b || {};
    const L = b.random || (b.rng || c.default)();
    if (L[6] = L[6] & 15 | 64, L[8] = L[8] & 63 | 128, F) {
      le = le || 0;
      for (let pe = 0; pe < 16; ++pe)
        F[le + pe] = L[pe];
      return F;
    }
    return (0, u.unsafeStringify)(L);
  }
  var A = a;
  return v4$2.default = A, v4$2;
}
var v5$1 = {}, sha1$1 = {}, hasRequiredSha1;
function requireSha1() {
  if (hasRequiredSha1) return sha1$1;
  hasRequiredSha1 = 1, Object.defineProperty(sha1$1, "__esModule", {
    value: !0
  }), sha1$1.default = void 0;
  function n(a, A, b, F) {
    switch (a) {
      case 0:
        return A & b ^ ~A & F;
      case 1:
        return A ^ b ^ F;
      case 2:
        return A & b ^ A & F ^ b & F;
      case 3:
        return A ^ b ^ F;
    }
  }
  function c(a, A) {
    return a << A | a >>> 32 - A;
  }
  function u(a) {
    const A = [1518500249, 1859775393, 2400959708, 3395469782], b = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
    if (typeof a == "string") {
      const pe = unescape(encodeURIComponent(a));
      a = [];
      for (let $ = 0; $ < pe.length; ++$)
        a.push(pe.charCodeAt($));
    } else Array.isArray(a) || (a = Array.prototype.slice.call(a));
    a.push(128);
    const F = a.length / 4 + 2, le = Math.ceil(F / 16), L = new Array(le);
    for (let pe = 0; pe < le; ++pe) {
      const $ = new Uint32Array(16);
      for (let Ee = 0; Ee < 16; ++Ee)
        $[Ee] = a[pe * 64 + Ee * 4] << 24 | a[pe * 64 + Ee * 4 + 1] << 16 | a[pe * 64 + Ee * 4 + 2] << 8 | a[pe * 64 + Ee * 4 + 3];
      L[pe] = $;
    }
    L[le - 1][14] = (a.length - 1) * 8 / Math.pow(2, 32), L[le - 1][14] = Math.floor(L[le - 1][14]), L[le - 1][15] = (a.length - 1) * 8 & 4294967295;
    for (let pe = 0; pe < le; ++pe) {
      const $ = new Uint32Array(80);
      for (let ir = 0; ir < 16; ++ir)
        $[ir] = L[pe][ir];
      for (let ir = 16; ir < 80; ++ir)
        $[ir] = c($[ir - 3] ^ $[ir - 8] ^ $[ir - 14] ^ $[ir - 16], 1);
      let Ee = b[0], be = b[1], He = b[2], Pe = b[3], nr = b[4];
      for (let ir = 0; ir < 80; ++ir) {
        const or = Math.floor(ir / 20), lr = c(Ee, 5) + n(or, be, He, Pe) + nr + A[or] + $[ir] >>> 0;
        nr = Pe, Pe = He, He = c(be, 30) >>> 0, be = Ee, Ee = lr;
      }
      b[0] = b[0] + Ee >>> 0, b[1] = b[1] + be >>> 0, b[2] = b[2] + He >>> 0, b[3] = b[3] + Pe >>> 0, b[4] = b[4] + nr >>> 0;
    }
    return [b[0] >> 24 & 255, b[0] >> 16 & 255, b[0] >> 8 & 255, b[0] & 255, b[1] >> 24 & 255, b[1] >> 16 & 255, b[1] >> 8 & 255, b[1] & 255, b[2] >> 24 & 255, b[2] >> 16 & 255, b[2] >> 8 & 255, b[2] & 255, b[3] >> 24 & 255, b[3] >> 16 & 255, b[3] >> 8 & 255, b[3] & 255, b[4] >> 24 & 255, b[4] >> 16 & 255, b[4] >> 8 & 255, b[4] & 255];
  }
  var p = u;
  return sha1$1.default = p, sha1$1;
}
var hasRequiredV5;
function requireV5() {
  if (hasRequiredV5) return v5$1;
  hasRequiredV5 = 1, Object.defineProperty(v5$1, "__esModule", {
    value: !0
  }), v5$1.default = void 0;
  var n = u(requireV35()), c = u(requireSha1());
  function u(A) {
    return A && A.__esModule ? A : { default: A };
  }
  var a = (0, n.default)("v5", 80, c.default);
  return v5$1.default = a, v5$1;
}
var nil$1 = {}, hasRequiredNil;
function requireNil() {
  if (hasRequiredNil) return nil$1;
  hasRequiredNil = 1, Object.defineProperty(nil$1, "__esModule", {
    value: !0
  }), nil$1.default = void 0;
  var n = "00000000-0000-0000-0000-000000000000";
  return nil$1.default = n, nil$1;
}
var version$2 = {}, hasRequiredVersion;
function requireVersion() {
  if (hasRequiredVersion) return version$2;
  hasRequiredVersion = 1, Object.defineProperty(version$2, "__esModule", {
    value: !0
  }), version$2.default = void 0;
  var n = c(requireValidate());
  function c(a) {
    return a && a.__esModule ? a : { default: a };
  }
  function u(a) {
    if (!(0, n.default)(a))
      throw TypeError("Invalid UUID");
    return parseInt(a.slice(14, 15), 16);
  }
  var p = u;
  return version$2.default = p, version$2;
}
var hasRequiredCommonjsBrowser;
function requireCommonjsBrowser() {
  return hasRequiredCommonjsBrowser || (hasRequiredCommonjsBrowser = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "NIL", {
      enumerable: !0,
      get: function() {
        return A.default;
      }
    }), Object.defineProperty(n, "parse", {
      enumerable: !0,
      get: function() {
        return L.default;
      }
    }), Object.defineProperty(n, "stringify", {
      enumerable: !0,
      get: function() {
        return le.default;
      }
    }), Object.defineProperty(n, "v1", {
      enumerable: !0,
      get: function() {
        return c.default;
      }
    }), Object.defineProperty(n, "v3", {
      enumerable: !0,
      get: function() {
        return u.default;
      }
    }), Object.defineProperty(n, "v4", {
      enumerable: !0,
      get: function() {
        return p.default;
      }
    }), Object.defineProperty(n, "v5", {
      enumerable: !0,
      get: function() {
        return a.default;
      }
    }), Object.defineProperty(n, "validate", {
      enumerable: !0,
      get: function() {
        return F.default;
      }
    }), Object.defineProperty(n, "version", {
      enumerable: !0,
      get: function() {
        return b.default;
      }
    });
    var c = pe(requireV1()), u = pe(requireV3()), p = pe(requireV4()), a = pe(requireV5()), A = pe(requireNil()), b = pe(requireVersion()), F = pe(requireValidate()), le = pe(requireStringify()), L = pe(requireParse());
    function pe($) {
      return $ && $.__esModule ? $ : { default: $ };
    }
  }(commonjsBrowser)), commonjsBrowser;
}
var hasRequiredBcUrRegistryTon_cjs_production_min;
function requireBcUrRegistryTon_cjs_production_min() {
  return hasRequiredBcUrRegistryTon_cjs_production_min || (hasRequiredBcUrRegistryTon_cjs_production_min = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 });
    var c = requireDist$1(), u = requireCommonjsBrowser();
    const p = { TRON_SIGN_REQUEST: new c.RegistryType("ton-sign-request", 7201), TRON_SIGNATURE: new c.RegistryType("ton-signature", 7202) }, { decodeToDataItem: a, RegistryTypes: A } = c.extend;
    var b, F;
    (function(be) {
      be[be.requestId = 1] = "requestId", be[be.signData = 2] = "signData", be[be.dataType = 3] = "dataType", be[be.derivationPath = 4] = "derivationPath", be[be.address = 5] = "address", be[be.origin = 6] = "origin";
    })(b || (b = {})), (F = n.DataType || (n.DataType = {}))[F.TRANSACTION = 1] = "TRANSACTION", F[F.SIGN_PROOF = 2] = "SIGN_PROOF";
    class le extends c.RegistryItem {
      constructor(He) {
        super(), this.getRegistryType = () => p.TRON_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDerivationPath = () => this.derivationPath ? this.derivationPath.getPath() : void 0, this.getAddress = () => this.address, this.getOrigin = () => this.origin, this.getDataType = () => this.dataType, this.toDataItem = () => {
          const Pe = {};
          if (Pe[b.signData] = this.signData, Pe[b.dataType] = this.dataType, this.derivationPath) {
            const nr = this.derivationPath.toDataItem();
            nr.setTag(this.derivationPath.getRegistryType().getTag()), Pe[b.derivationPath] = nr;
          }
          return this.requestId && (Pe[b.requestId] = new c.DataItem(this.requestId, A.UUID.getTag())), this.address && (Pe[b.address] = this.address), this.origin && (Pe[b.origin] = this.origin), new c.DataItem(Pe);
        }, this.requestId = He.requestId, this.signData = He.signData, this.derivationPath = He.derivationPath, this.address = He.address, this.origin = He.origin, this.dataType = He.dataType;
      }
      static parsePath(He, Pe) {
        const nr = He.replace(/[m|M]\//, "").split("/").map((ir) => {
          const or = parseInt(ir.replace("'", ""));
          let lr = !1;
          return ir.endsWith("'") && (lr = !0), new c.PathComponent({ index: or, hardened: lr });
        });
        return new c.CryptoKeypath(nr, Buffer$f.from(Pe, "hex"));
      }
      static constructTonRequest(He, Pe, nr, ir, or, lr, Ir) {
        return new le({ requestId: ir ? Buffer$f.from(u.parse(ir)) : void 0, signData: He, dataType: Pe, derivationPath: Ir && lr ? le.parsePath(Ir, lr) : void 0, address: nr, origin: or });
      }
    }
    le.fromDataItem = (be) => {
      const He = be.getData(), Pe = He[b.requestId] ? He[b.requestId].getData() : void 0, nr = He[b.derivationPath] ? c.CryptoKeypath.fromDataItem(He[b.derivationPath]) : void 0;
      return new le({ requestId: Pe, signData: He[b.signData], dataType: He[b.dataType], derivationPath: nr, address: He[b.address], origin: He[b.origin] });
    }, le.fromCBOR = (be) => {
      const He = a(be);
      return le.fromDataItem(He);
    };
    const { RegistryTypes: L, decodeToDataItem: pe } = c.extend;
    var $;
    (function(be) {
      be[be.requestId = 1] = "requestId", be[be.signature = 2] = "signature", be[be.origin = 3] = "origin";
    })($ || ($ = {}));
    class Ee extends c.RegistryItem {
      constructor(He, Pe, nr) {
        super(), this.getRegistryType = () => p.TRON_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const ir = {};
          return this.requestId && (ir[$.requestId] = new c.DataItem(this.requestId, L.UUID.getTag())), this.origin && (ir[$.origin] = this.origin), ir[$.signature] = this.signature, new c.DataItem(ir);
        }, this.signature = He, this.requestId = Pe, this.origin = nr;
      }
    }
    Ee.fromDataItem = (be) => {
      const He = be.getData(), Pe = He[$.signature];
      let nr, ir;
      return He[$.requestId] && (nr = He[$.requestId].getData()), He[$.origin] && (ir = He[$.origin]), new Ee(Pe, nr, ir);
    }, Ee.fromCBOR = (be) => {
      const He = pe(be);
      return Ee.fromDataItem(He);
    }, c.patchTags(Object.values(p).filter((be) => !!be.getTag()).map((be) => be.getTag())), Object.keys(c).forEach(function(be) {
      be !== "default" && Object.defineProperty(n, be, { enumerable: !0, get: function() {
        return c[be];
      } });
    }), n.TonSignRequest = le, n.TonSignature = Ee;
  }(bcUrRegistryTon_cjs_production_min)), bcUrRegistryTon_cjs_production_min;
}
var bcUrRegistryTon_cjs_development = {}, hasRequiredBcUrRegistryTon_cjs_development;
function requireBcUrRegistryTon_cjs_development() {
  return hasRequiredBcUrRegistryTon_cjs_development || (hasRequiredBcUrRegistryTon_cjs_development = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 });
    var c = requireDist$1(), u = requireCommonjsBrowser();
    const p = {
      TRON_SIGN_REQUEST: /* @__PURE__ */ new c.RegistryType("ton-sign-request", 7201),
      TRON_SIGNATURE: /* @__PURE__ */ new c.RegistryType("ton-signature", 7202)
    }, {
      decodeToDataItem: a,
      RegistryTypes: A
    } = c.extend;
    var b;
    (function(Ee) {
      Ee[Ee.requestId = 1] = "requestId", Ee[Ee.signData = 2] = "signData", Ee[Ee.dataType = 3] = "dataType", Ee[Ee.derivationPath = 4] = "derivationPath", Ee[Ee.address = 5] = "address", Ee[Ee.origin = 6] = "origin";
    })(b || (b = {})), function(Ee) {
      Ee[Ee.TRANSACTION = 1] = "TRANSACTION", Ee[Ee.SIGN_PROOF = 2] = "SIGN_PROOF";
    }(n.DataType || (n.DataType = {}));
    class F extends c.RegistryItem {
      constructor(be) {
        super(), this.getRegistryType = () => p.TRON_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDerivationPath = () => this.derivationPath ? this.derivationPath.getPath() : void 0, this.getAddress = () => this.address, this.getOrigin = () => this.origin, this.getDataType = () => this.dataType, this.toDataItem = () => {
          const He = {};
          if (He[b.signData] = this.signData, He[b.dataType] = this.dataType, this.derivationPath) {
            const Pe = this.derivationPath.toDataItem();
            Pe.setTag(this.derivationPath.getRegistryType().getTag()), He[b.derivationPath] = Pe;
          }
          return this.requestId && (He[b.requestId] = new c.DataItem(this.requestId, A.UUID.getTag())), this.address && (He[b.address] = this.address), this.origin && (He[b.origin] = this.origin), new c.DataItem(He);
        }, this.requestId = be.requestId, this.signData = be.signData, this.derivationPath = be.derivationPath, this.address = be.address, this.origin = be.origin, this.dataType = be.dataType;
      }
      static parsePath(be, He) {
        const nr = be.replace(/[m|M]\//, "").split("/").map((ir) => {
          const or = parseInt(ir.replace("'", ""));
          let lr = !1;
          return ir.endsWith("'") && (lr = !0), new c.PathComponent({
            index: or,
            hardened: lr
          });
        });
        return new c.CryptoKeypath(nr, Buffer$f.from(He, "hex"));
      }
      static constructTonRequest(be, He, Pe, nr, ir, or, lr) {
        return new F({
          requestId: nr ? Buffer$f.from(u.parse(nr)) : void 0,
          signData: be,
          dataType: He,
          derivationPath: lr && or ? F.parsePath(lr, or) : void 0,
          address: Pe,
          origin: ir
        });
      }
    }
    F.fromDataItem = (Ee) => {
      const be = Ee.getData(), He = be[b.requestId] ? be[b.requestId].getData() : void 0, Pe = be[b.derivationPath] ? c.CryptoKeypath.fromDataItem(be[b.derivationPath]) : void 0;
      return new F({
        requestId: He,
        signData: be[b.signData],
        dataType: be[b.dataType],
        derivationPath: Pe,
        address: be[b.address],
        origin: be[b.origin]
      });
    }, F.fromCBOR = (Ee) => {
      const be = a(Ee);
      return F.fromDataItem(be);
    };
    const {
      RegistryTypes: le,
      decodeToDataItem: L
    } = c.extend;
    var pe;
    (function(Ee) {
      Ee[Ee.requestId = 1] = "requestId", Ee[Ee.signature = 2] = "signature", Ee[Ee.origin = 3] = "origin";
    })(pe || (pe = {}));
    class $ extends c.RegistryItem {
      constructor(be, He, Pe) {
        super(), this.getRegistryType = () => p.TRON_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const nr = {};
          return this.requestId && (nr[pe.requestId] = new c.DataItem(this.requestId, le.UUID.getTag())), this.origin && (nr[pe.origin] = this.origin), nr[pe.signature] = this.signature, new c.DataItem(nr);
        }, this.signature = be, this.requestId = He, this.origin = Pe;
      }
    }
    $.fromDataItem = (Ee) => {
      const be = Ee.getData(), He = be[pe.signature];
      let Pe, nr;
      return be[pe.requestId] && (Pe = be[pe.requestId].getData()), be[pe.origin] && (nr = be[pe.origin]), new $(He, Pe, nr);
    }, $.fromCBOR = (Ee) => {
      const be = L(Ee);
      return $.fromDataItem(be);
    }, c.patchTags(Object.values(p).filter((Ee) => !!Ee.getTag()).map((Ee) => Ee.getTag())), Object.keys(c).forEach(function(Ee) {
      Ee !== "default" && Object.defineProperty(n, Ee, {
        enumerable: !0,
        get: function() {
          return c[Ee];
        }
      });
    }), n.TonSignRequest = F, n.TonSignature = $;
  }(bcUrRegistryTon_cjs_development)), bcUrRegistryTon_cjs_development;
}
process$1.env.NODE_ENV === "production" ? dist$7.exports = requireBcUrRegistryTon_cjs_production_min() : dist$7.exports = requireBcUrRegistryTon_cjs_development();
var distExports$1 = dist$7.exports;
Object.defineProperty(ton, "__esModule", { value: !0 });
ton.KeystoneTonSDK = void 0;
const bc_ur_registry_ton_1 = distExports$1, utils_1$b = utils$K, ur_1$1 = ur;
class KeystoneTonSDK {
  constructor(c) {
    this.config = c;
  }
  parseSignature(c) {
    if (c.type !== ur_1$1.URType.TonSignature)
      throw new Error("type not match");
    const u = bc_ur_registry_ton_1.TonSignature.fromCBOR(c.cbor), p = u.getRequestId();
    return {
      requestId: Buffer$f.isBuffer(p) ? (0, utils_1$b.uuidStringify)(p) : "",
      signature: (0, utils_1$b.toHex)(u.getSignature()),
      origin: u.getOrigin()
    };
  }
  generateSignRequest({ requestId: c, signData: u, dataType: p, xfp: a, derivationPath: A, address: b }) {
    var F;
    return bc_ur_registry_ton_1.TonSignRequest.constructTonRequest((0, utils_1$b.toBuffer)(u), p, b, c, (F = this.config) === null || F === void 0 ? void 0 : F.origin, a, A).toUR();
  }
}
KeystoneTonSDK.DataType = bc_ur_registry_ton_1.DataType;
ton.KeystoneTonSDK = KeystoneTonSDK;
var stellar = {}, dist$5 = { exports: {} }, bcUrRegistryStellar_cjs_production_min = {}, dist$4 = {}, patchCBOR = {}, utils$5 = {}, lib$2 = {}, cborSync = { exports: {} }, DataItem = {}, hasRequiredDataItem;
function requireDataItem() {
  if (hasRequiredDataItem) return DataItem;
  hasRequiredDataItem = 1, Object.defineProperty(DataItem, "__esModule", { value: !0 }), DataItem.DataItem = void 0;
  let n = class {
    constructor(u, p) {
      this.setTag = (a) => {
        this.tag = a;
      }, this.clearTag = () => {
        this.tag = void 0;
      }, this.getTag = () => this.tag, this.getData = () => this.data, this.data = u, this.tag = p;
    }
  };
  return DataItem.DataItem = n, DataItem;
}
var hasRequiredCborSync;
function requireCborSync() {
  return hasRequiredCborSync || (hasRequiredCborSync = 1, function(n) {
    (function(c, u) {
      n.exports ? n.exports = u() : c.CBOR = u();
    })(commonjsGlobal, function() {
      const { DataItem: c } = requireDataItem();
      var u = function() {
        function p(Ce) {
          this.$hex = Ce;
        }
        p.prototype = {
          length: function() {
            return this.$hex.length / 2;
          },
          toString: function(Ce) {
            if (!Ce || Ce === "hex" || Ce === 16)
              return this.$hex;
            if (Ce === "utf-8") {
              for (var tr = "", Fe = 0; Fe < this.$hex.length; Fe += 2)
                tr += "%" + this.$hex.substring(Fe, Fe + 2);
              return decodeURIComponent(tr);
            }
            if (Ce === "latin") {
              for (var tr = [], Fe = 0; Fe < this.$hex.length; Fe += 2)
                tr.push(parseInt(this.$hex.substring(Fe, Fe + 2), 16));
              return String.fromCharCode.apply(String, tr);
            }
            throw new Error("Unrecognised format: " + Ce);
          }
        }, p.fromLatinString = function(Ce) {
          for (var tr = "", Fe = 0; Fe < Ce.length; Fe++) {
            var Sr = Ce.charCodeAt(Fe).toString(16);
            Sr.length === 1 && (Sr = "0" + Sr), tr += Sr;
          }
          return new p(tr);
        }, p.fromUtf8String = function(Ce) {
          for (var tr = encodeURIComponent(Ce), Fe = "", Sr = 0; Sr < tr.length; Sr++)
            if (tr.charAt(Sr) === "%")
              Fe += tr.substring(Sr + 1, Sr + 3), Sr += 2;
            else {
              var er = tr.charCodeAt(Sr).toString(16);
              er.length < 2 && (er = "0" + er), Fe += er;
            }
          return new p(Fe);
        };
        var a = [], A = {}, b = function(Ce) {
          return function() {
            throw new Error(Ce + " not implemented");
          };
        };
        function F() {
        }
        F.prototype = {
          peekByte: b("peekByte"),
          readByte: b("readByte"),
          readChunk: b("readChunk"),
          readFloat16: function() {
            var Ce = this.readUint16(), tr = (Ce & 32767) >> 10, Fe = Ce & 1023, Sr = Ce & 32768;
            if (tr === 31)
              return Fe === 0 ? Sr ? -1 / 0 : 1 / 0 : NaN;
            var er = tr ? Math.pow(2, tr - 25) * (1024 + Fe) : Math.pow(2, -24) * Fe;
            return Sr ? -er : er;
          },
          readFloat32: function() {
            var Ce = this.readUint32(), tr = (Ce & 2147483647) >> 23, Fe = Ce & 8388607, Sr = Ce & 2147483648;
            if (tr === 255)
              return Fe === 0 ? Sr ? -1 / 0 : 1 / 0 : NaN;
            var er = tr ? Math.pow(2, tr - 23 - 127) * (8388608 + Fe) : Math.pow(2, -149) * Fe;
            return Sr ? -er : er;
          },
          readFloat64: function() {
            var Ce = this.readUint32(), tr = this.readUint32(), Fe = Ce >> 20 & 2047, Sr = (Ce & 1048575) * 4294967296 + tr, er = Ce & 2147483648;
            if (Fe === 2047)
              return Sr === 0 ? er ? -1 / 0 : 1 / 0 : NaN;
            var Ie = Fe ? Math.pow(2, Fe - 52 - 1023) * (4503599627370496 + Sr) : Math.pow(2, -1074) * Sr;
            return er ? -Ie : Ie;
          },
          readUint16: function() {
            return this.readByte() * 256 + this.readByte();
          },
          readUint32: function() {
            return this.readUint16() * 65536 + this.readUint16();
          },
          readUint64: function() {
            return this.readUint32() * 4294967296 + this.readUint32();
          }
        };
        function le() {
        }
        le.prototype = {
          writeByte: b("writeByte"),
          result: b("result"),
          writeFloat16: b("writeFloat16"),
          writeFloat32: b("writeFloat32"),
          writeFloat64: b("writeFloat64"),
          writeUint16: function(Ce) {
            this.writeByte(Ce >> 8 & 255), this.writeByte(Ce & 255);
          },
          writeUint32: function(Ce) {
            this.writeUint16(Ce >> 16 & 65535), this.writeUint16(Ce & 65535);
          },
          writeUint64: function(Ce) {
            if (Ce >= 9007199254740992 || Ce <= -9007199254740992)
              throw new Error("Cannot encode Uint64 of: " + Ce + " magnitude to big (floating point errors)");
            this.writeUint32(Math.floor(Ce / 4294967296)), this.writeUint32(Ce % 4294967296);
          },
          writeString: b("writeString"),
          canWriteBinary: function(Ce) {
            return !1;
          },
          writeBinary: b("writeChunk")
        };
        function L(Ce) {
          var tr = Ce.readByte(), Fe = tr >> 5, Sr = tr & 31;
          return { type: Fe, value: Sr };
        }
        function pe(Ce, tr) {
          var Fe = Ce.value;
          if (Fe < 24)
            return Fe;
          if (Fe == 24)
            return tr.readByte();
          if (Fe == 25)
            return tr.readUint16();
          if (Fe == 26)
            return tr.readUint32();
          if (Fe == 27)
            return tr.readUint64();
          if (Fe == 31)
            return null;
          b("Additional info: " + Fe)();
        }
        function $(Ce, tr, Fe) {
          Fe.writeByte(Ce << 5 | tr);
        }
        function Ee(Ce, tr, Fe) {
          var Sr = Ce << 5;
          tr < 24 ? Fe.writeByte(Sr | tr) : tr < 256 ? (Fe.writeByte(Sr | 24), Fe.writeByte(tr)) : tr < 65536 ? (Fe.writeByte(Sr | 25), Fe.writeUint16(tr)) : tr < 4294967296 ? (Fe.writeByte(Sr | 26), Fe.writeUint32(tr)) : (Fe.writeByte(Sr | 27), Fe.writeUint64(tr));
        }
        var be = new Error();
        function He(Ce) {
          var tr = L(Ce);
          switch (tr.type) {
            case 0:
              return pe(tr, Ce);
            case 1:
              return -1 - pe(tr, Ce);
            case 2:
              return Ce.readChunk(pe(tr, Ce));
            case 3:
              var Fe = Ce.readChunk(pe(tr, Ce));
              return Fe.toString("utf-8");
            case 4:
            case 5:
              var Sr = pe(tr, Ce), yr = [];
              if (Sr !== null) {
                tr.type === 5 && (Sr *= 2);
                for (var er = 0; er < Sr; er++)
                  yr[er] = He(Ce);
              } else
                for (var Ie; (Ie = He(Ce)) !== be; )
                  yr.push(Ie);
              if (tr.type === 5) {
                for (var xe = {}, er = 0; er < yr.length; er += 2)
                  xe[yr[er]] = yr[er + 1];
                return xe;
              } else
                return yr;
            case 6:
              var rr = pe(tr, Ce), ar = A[rr], yr = He(Ce);
              return ar ? ar(yr) : yr;
            case 7:
              if (tr.value === 25)
                return Ce.readFloat16();
              if (tr.value === 26)
                return Ce.readFloat32();
              if (tr.value === 27)
                return Ce.readFloat64();
              switch (pe(tr, Ce)) {
                case 20:
                  return !1;
                case 21:
                  return !0;
                case 22:
                  return null;
                case 23:
                  return;
                case null:
                  return be;
                default:
                  throw new Error("Unknown fixed value: " + tr.value);
              }
            default:
              throw new Error("Unsupported header: " + JSON.stringify(tr));
          }
          throw new Error("not implemented yet");
        }
        function Pe(Ce, tr) {
          for (var Fe = 0; Fe < a.length; Fe++) {
            var Sr = a[Fe].fn(Ce);
            if (Sr !== void 0)
              return Ee(6, a[Fe].tag, tr), Pe(Sr, tr);
          }
          if (Ce && typeof Ce.toCBOR == "function" && (Ce = Ce.toCBOR()), Ce === !1)
            Ee(7, 20, tr);
          else if (Ce === !0)
            Ee(7, 21, tr);
          else if (Ce === null)
            Ee(7, 22, tr);
          else if (Ce === void 0)
            Ee(7, 23, tr);
          else if (typeof Ce == "number")
            Math.floor(Ce) === Ce && Ce < 9007199254740992 && Ce > -9007199254740992 ? Ce < 0 ? Ee(1, -1 - Ce, tr) : Ee(0, Ce, tr) : ($(7, 27, tr), tr.writeFloat64(Ce));
          else if (typeof Ce == "string")
            tr.writeString(Ce, function(Ie) {
              Ee(3, Ie, tr);
            });
          else if (tr.canWriteBinary(Ce))
            tr.writeBinary(Ce, function(Ie) {
              Ee(2, Ie, tr);
            });
          else if (typeof Ce == "object")
            if (or.config.useToJSON && typeof Ce.toJSON == "function" && (Ce = Ce.toJSON()), Array.isArray(Ce)) {
              Ee(4, Ce.length, tr);
              for (var Fe = 0; Fe < Ce.length; Fe++)
                Pe(Ce[Fe], tr);
            } else {
              var er = Object.keys(Ce);
              Ee(5, er.length, tr);
              for (var Fe = 0; Fe < er.length; Fe++) {
                const xe = parseInt(er[Fe]);
                isNaN(xe) ? (Pe(er[Fe], tr), Pe(Ce[er[Fe]], tr)) : (Pe(xe, tr), Pe(Ce[er[Fe]], tr));
              }
            }
          else
            throw new Error("CBOR encoding not supported: " + Ce);
        }
        var nr = [], ir = [], or = {
          config: {
            useToJSON: !0
          },
          addWriter: function(Ce, tr) {
            typeof Ce == "string" ? ir.push(function(Fe) {
              if (Ce === Fe)
                return tr(Fe);
            }) : ir.push(Ce);
          },
          addReader: function(Ce, tr) {
            typeof Ce == "string" ? nr.push(function(Fe, Sr) {
              if (Ce === Sr)
                return tr(Fe, Sr);
            }) : nr.push(Ce);
          },
          encode: function(Ce, tr) {
            for (var Fe = 0; Fe < ir.length; Fe++) {
              var Sr = ir[Fe], er = Sr(tr);
              if (er)
                return Pe(Ce, er), er.result();
            }
            throw new Error("Unsupported output format: " + tr);
          },
          encodeDataItem: function(Ce, tr) {
            for (var Fe = 0; Fe < ir.length; Fe++) {
              var Sr = ir[Fe], er = Sr(tr);
              if (er)
                return Ce.getTag() !== void 0 ? (Pe(Ce, er), er.result()) : (Pe(Ce.getData(), er), er.result());
            }
            throw new Error("Unsupported output format: " + tr);
          },
          decode: function(Ce, tr) {
            for (var Fe = 0; Fe < nr.length; Fe++) {
              var Sr = nr[Fe], er = Sr(Ce, tr);
              if (er)
                return He(er);
            }
            throw new Error("Unsupported input format: " + tr);
          },
          decodeToDataItem: function(Ce, tr) {
            for (var Fe = 0; Fe < nr.length; Fe++) {
              var Sr = nr[Fe], er = Sr(Ce, tr);
              if (er) {
                const Ie = He(er);
                return Ie instanceof c ? Ie : new c(Ie);
              }
            }
            throw new Error("Unsupported input format: " + tr);
          },
          addSemanticEncode: function(Ce, tr) {
            if (typeof Ce != "number" || Ce % 1 !== 0 || Ce < 0)
              throw new Error("Tag must be a positive integer");
            return a.push({ tag: Ce, fn: tr }), this;
          },
          addSemanticDecode: function(Ce, tr) {
            if (typeof Ce != "number" || Ce % 1 !== 0 || Ce < 0)
              throw new Error("Tag must be a positive integer");
            return A[Ce] = tr, this;
          }
        };
        function lr(Ce) {
          this.buffer = Ce, this.pos = 0;
        }
        lr.prototype = Object.create(F.prototype), lr.prototype.peekByte = function() {
          return this.buffer[this.pos];
        }, lr.prototype.readByte = function() {
          return this.buffer[this.pos++];
        }, lr.prototype.readUint16 = function() {
          var Ce = this.buffer.readUInt16BE(this.pos);
          return this.pos += 2, Ce;
        }, lr.prototype.readUint32 = function() {
          var Ce = this.buffer.readUInt32BE(this.pos);
          return this.pos += 4, Ce;
        }, lr.prototype.readFloat32 = function() {
          var Ce = this.buffer.readFloatBE(this.pos);
          return this.pos += 4, Ce;
        }, lr.prototype.readFloat64 = function() {
          var Ce = this.buffer.readDoubleBE(this.pos);
          return this.pos += 8, Ce;
        }, lr.prototype.readChunk = function(Ce) {
          var tr = Buffer$f.alloc(Ce);
          return this.buffer.copy(tr, 0, this.pos, this.pos += Ce), tr;
        };
        function Ir(Ce) {
          this.byteLength = 0, this.defaultBufferLength = 16384, this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0, this.completeBuffers = [], this.stringFormat = Ce;
        }
        Ir.prototype = Object.create(le.prototype), Ir.prototype.writeByte = function(Ce) {
          this.latestBuffer[this.latestBufferOffset++] = Ce, this.latestBufferOffset >= this.latestBuffer.length && (this.completeBuffers.push(this.latestBuffer), this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0), this.byteLength++;
        }, Ir.prototype.writeFloat32 = function(Ce) {
          var tr = Buffer$f.alloc(4);
          tr.writeFloatBE(Ce, 0), this.writeBuffer(tr);
        }, Ir.prototype.writeFloat64 = function(Ce) {
          var tr = Buffer$f.alloc(8);
          tr.writeDoubleBE(Ce, 0), this.writeBuffer(tr);
        }, Ir.prototype.writeString = function(Ce, tr) {
          var Fe = Buffer$f.from(Ce, "utf-8");
          tr(Fe.length), this.writeBuffer(Fe);
        }, Ir.prototype.canWriteBinary = function(Ce) {
          return Ce instanceof Buffer$f;
        }, Ir.prototype.writeBinary = function(Ce, tr) {
          tr(Ce.length), this.writeBuffer(Ce);
        }, Ir.prototype.writeBuffer = function(Ce) {
          if (!(Ce instanceof Buffer$f))
            throw new TypeError("BufferWriter only accepts Buffers");
          this.latestBufferOffset ? this.latestBuffer.length - this.latestBufferOffset >= Ce.length ? (Ce.copy(this.latestBuffer, this.latestBufferOffset), this.latestBufferOffset += Ce.length, this.latestBufferOffset >= this.latestBuffer.length && (this.completeBuffers.push(this.latestBuffer), this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0)) : (this.completeBuffers.push(this.latestBuffer.slice(0, this.latestBufferOffset)), this.completeBuffers.push(Ce), this.latestBuffer = Buffer$f.alloc(this.defaultBufferLength), this.latestBufferOffset = 0) : this.completeBuffers.push(Ce), this.byteLength += Ce.length;
        }, Ir.prototype.result = function() {
          for (var Ce = Buffer$f.alloc(this.byteLength), tr = 0, Fe = 0; Fe < this.completeBuffers.length; Fe++) {
            var Sr = this.completeBuffers[Fe];
            Sr.copy(Ce, tr, 0, Sr.length), tr += Sr.length;
          }
          return this.latestBufferOffset && this.latestBuffer.copy(Ce, tr, 0, this.latestBufferOffset), this.stringFormat ? Ce.toString(this.stringFormat) : Ce;
        }, typeof Buffer$f == "function" && (or.addReader(function(Ce, tr) {
          if (Buffer$f.isBuffer(Ce))
            return new lr(Ce);
          if (tr === "hex" || tr === "base64") {
            var Fe = Buffer$f.from(Ce, tr);
            return new lr(Fe);
          }
        }), or.addWriter(function(Ce) {
          if (!Ce || Ce === "buffer")
            return new Ir();
          if (Ce === "hex" || Ce === "base64")
            return new Ir(Ce);
        }));
        function xr(Ce) {
          this.hex = Ce, this.pos = 0;
        }
        xr.prototype = Object.create(F.prototype), xr.prototype.peekByte = function() {
          var Ce = this.hex.substring(this.pos, 2);
          return parseInt(Ce, 16);
        }, xr.prototype.readByte = function() {
          var Ce = this.hex.substring(this.pos, this.pos + 2);
          return this.pos += 2, parseInt(Ce, 16);
        }, xr.prototype.readChunk = function(Ce) {
          var tr = this.hex.substring(this.pos, this.pos + Ce * 2);
          return this.pos += Ce * 2, typeof Buffer$f == "function" ? Buffer$f.from(tr, "hex") : new p(tr);
        };
        function kr(Ce) {
          this.$hex = "", this.finalFormat = Ce || "hex";
        }
        return kr.prototype = Object.create(le.prototype), kr.prototype.writeByte = function(Ce) {
          if (Ce < 0 || Ce > 255)
            throw new Error("Byte value out of range: " + Ce);
          var tr = Ce.toString(16);
          tr.length == 1 && (tr = "0" + tr), this.$hex += tr;
        }, kr.prototype.canWriteBinary = function(Ce) {
          return Ce instanceof p || typeof Buffer$f == "function" && Ce instanceof Buffer$f;
        }, kr.prototype.writeBinary = function(Ce, tr) {
          if (Ce instanceof p)
            tr(Ce.length()), this.$hex += Ce.$hex;
          else if (typeof Buffer$f == "function" && Ce instanceof Buffer$f)
            tr(Ce.length), this.$hex += Ce.toString("hex");
          else
            throw new TypeError("HexWriter only accepts BinaryHex or Buffers");
        }, kr.prototype.result = function() {
          return this.finalFormat === "buffer" && typeof Buffer$f == "function" ? Buffer$f.from(this.$hex, "hex") : new p(this.$hex).toString(this.finalFormat);
        }, kr.prototype.writeString = function(Ce, tr) {
          var Fe = p.fromUtf8String(Ce);
          tr(Fe.length()), this.$hex += Fe.$hex;
        }, or.addReader(function(Ce, tr) {
          if (Ce instanceof p || Ce.$hex)
            return new xr(Ce.$hex);
          if (tr === "hex")
            return new xr(Ce);
        }), or.addWriter(function(Ce) {
          if (Ce === "hex")
            return new kr();
        }), or;
      }();
      return u.addSemanticEncode(0, function(p) {
        if (p instanceof Date)
          return p.toISOString();
      }).addSemanticDecode(0, function(p) {
        return new Date(p);
      }).addSemanticDecode(1, function(p) {
        return new Date(p);
      }), u;
    });
  }(cborSync)), cborSync.exports;
}
var hasRequiredLib;
function requireLib() {
  return hasRequiredLib || (hasRequiredLib = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.DataItem = n.addWriter = n.addReader = n.addSemanticEncode = n.addSemanticDecode = n.decodeToDataItem = n.encodeDataItem = void 0;
    var c = requireCborSync();
    Object.defineProperty(n, "encodeDataItem", { enumerable: !0, get: function() {
      return c.encodeDataItem;
    } }), Object.defineProperty(n, "decodeToDataItem", { enumerable: !0, get: function() {
      return c.decodeToDataItem;
    } }), Object.defineProperty(n, "addSemanticDecode", { enumerable: !0, get: function() {
      return c.addSemanticDecode;
    } }), Object.defineProperty(n, "addSemanticEncode", { enumerable: !0, get: function() {
      return c.addSemanticEncode;
    } }), Object.defineProperty(n, "addReader", { enumerable: !0, get: function() {
      return c.addReader;
    } }), Object.defineProperty(n, "addWriter", { enumerable: !0, get: function() {
      return c.addWriter;
    } });
    var u = requireDataItem();
    Object.defineProperty(n, "DataItem", { enumerable: !0, get: function() {
      return u.DataItem;
    } });
  }(lib$2)), lib$2;
}
var hasRequiredUtils;
function requireUtils() {
  if (hasRequiredUtils) return utils$5;
  hasRequiredUtils = 1, Object.defineProperty(utils$5, "__esModule", { value: !0 }), utils$5.patchTags = void 0;
  const n = requireLib(), c = [], u = (p) => {
    p.forEach((a) => {
      c.find((A) => A === a) || ((0, n.addSemanticEncode)(a, (A) => {
        if (A instanceof n.DataItem && A.getTag() === a)
          return A.getData();
      }), (0, n.addSemanticDecode)(a, (A) => new n.DataItem(A, a)), c.push(a));
    });
  };
  return utils$5.patchTags = u, utils$5;
}
var RegistryType = {}, hasRequiredRegistryType;
function requireRegistryType() {
  if (hasRequiredRegistryType) return RegistryType;
  hasRequiredRegistryType = 1, Object.defineProperty(RegistryType, "__esModule", { value: !0 }), RegistryType.RegistryTypes = RegistryType.RegistryType = void 0;
  let n = class {
    constructor(u, p) {
      this.type = u, this.tag = p, this.getTag = () => this.tag, this.getType = () => this.type;
    }
  };
  return RegistryType.RegistryType = n, RegistryType.RegistryTypes = {
    UUID: new n("uuid", 37),
    BYTES: new n("bytes", void 0),
    CRYPTO_HDKEY: new n("crypto-hdkey", 303),
    CRYPTO_KEYPATH: new n("crypto-keypath", 304),
    CRYPTO_COIN_INFO: new n("crypto-coin-info", 305),
    CRYPTO_ECKEY: new n("crypto-eckey", 306),
    CRYPTO_OUTPUT: new n("crypto-output", 308),
    CRYPTO_PSBT: new n("crypto-psbt", 310),
    CRYPTO_ACCOUNT: new n("crypto-account", 311),
    CRYPTO_MULTI_ACCOUNTS: new n("crypto-multi-accounts", 1103),
    QR_HARDWARE_CALL: new n("qr-hardware-call", 1201),
    KEY_DERIVATION_CALL: new n("key-derivation-call", 1301),
    KEY_DERIVATION_SCHEMA: new n("key-derivation-schema", 1302)
  }, RegistryType;
}
var ScriptExpression = {}, hasRequiredScriptExpression;
function requireScriptExpression() {
  return hasRequiredScriptExpression || (hasRequiredScriptExpression = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.ScriptExpressions = n.ScriptExpression = void 0;
    class c {
      constructor(p, a) {
        this.tag = p, this.expression = a, this.getTag = () => this.tag, this.getExpression = () => this.expression;
      }
    }
    n.ScriptExpression = c, c.fromTag = (u) => Object.values(n.ScriptExpressions).find((a) => a.getTag() === u), n.ScriptExpressions = {
      SCRIPT_HASH: new c(400, "sh"),
      WITNESS_SCRIPT_HASH: new c(401, "wsh"),
      PUBLIC_KEY: new c(402, "pk"),
      PUBLIC_KEY_HASH: new c(403, "pkh"),
      WITNESS_PUBLIC_KEY_HASH: new c(404, "wpkh"),
      COMBO: new c(405, "combo"),
      MULTISIG: new c(406, "multi"),
      SORTED_MULTISIG: new c(407, "sortedmulti"),
      ADDRESS: new c(307, "addr"),
      RAW_SCRIPT: new c(408, "raw")
    };
  }(ScriptExpression)), ScriptExpression;
}
var hasRequiredPatchCBOR;
function requirePatchCBOR() {
  if (hasRequiredPatchCBOR) return patchCBOR;
  hasRequiredPatchCBOR = 1, Object.defineProperty(patchCBOR, "__esModule", { value: !0 });
  const n = requireUtils(), c = requireRegistryType(), u = requireScriptExpression(), p = Object.values(c.RegistryTypes).filter((A) => !!A.getTag()).map((A) => A.getTag()), a = Object.values(u.ScriptExpressions).map((A) => A.getTag());
  return (0, n.patchTags)(p.concat(a)), patchCBOR;
}
var CryptoHDKey = {}, src$4, hasRequiredSrc;
function requireSrc() {
  if (hasRequiredSrc) return src$4;
  hasRequiredSrc = 1;
  var n = safeBufferExports.Buffer;
  function c(u) {
    if (u.length >= 255)
      throw new TypeError("Alphabet too long");
    for (var p = new Uint8Array(256), a = 0; a < p.length; a++)
      p[a] = 255;
    for (var A = 0; A < u.length; A++) {
      var b = u.charAt(A), F = b.charCodeAt(0);
      if (p[F] !== 255)
        throw new TypeError(b + " is ambiguous");
      p[F] = A;
    }
    var le = u.length, L = u.charAt(0), pe = Math.log(le) / Math.log(256), $ = Math.log(256) / Math.log(le);
    function Ee(Pe) {
      if ((Array.isArray(Pe) || Pe instanceof Uint8Array) && (Pe = n.from(Pe)), !n.isBuffer(Pe))
        throw new TypeError("Expected Buffer");
      if (Pe.length === 0)
        return "";
      for (var nr = 0, ir = 0, or = 0, lr = Pe.length; or !== lr && Pe[or] === 0; )
        or++, nr++;
      for (var Ir = (lr - or) * $ + 1 >>> 0, xr = new Uint8Array(Ir); or !== lr; ) {
        for (var kr = Pe[or], Ce = 0, tr = Ir - 1; (kr !== 0 || Ce < ir) && tr !== -1; tr--, Ce++)
          kr += 256 * xr[tr] >>> 0, xr[tr] = kr % le >>> 0, kr = kr / le >>> 0;
        if (kr !== 0)
          throw new Error("Non-zero carry");
        ir = Ce, or++;
      }
      for (var Fe = Ir - ir; Fe !== Ir && xr[Fe] === 0; )
        Fe++;
      for (var Sr = L.repeat(nr); Fe < Ir; ++Fe)
        Sr += u.charAt(xr[Fe]);
      return Sr;
    }
    function be(Pe) {
      if (typeof Pe != "string")
        throw new TypeError("Expected String");
      if (Pe.length === 0)
        return n.alloc(0);
      for (var nr = 0, ir = 0, or = 0; Pe[nr] === L; )
        ir++, nr++;
      for (var lr = (Pe.length - nr) * pe + 1 >>> 0, Ir = new Uint8Array(lr); nr < Pe.length; ) {
        var xr = Pe.charCodeAt(nr);
        if (xr > 255)
          return;
        var kr = p[xr];
        if (kr === 255)
          return;
        for (var Ce = 0, tr = lr - 1; (kr !== 0 || Ce < or) && tr !== -1; tr--, Ce++)
          kr += le * Ir[tr] >>> 0, Ir[tr] = kr % 256 >>> 0, kr = kr / 256 >>> 0;
        if (kr !== 0)
          throw new Error("Non-zero carry");
        or = Ce, nr++;
      }
      for (var Fe = lr - or; Fe !== lr && Ir[Fe] === 0; )
        Fe++;
      var Sr = n.allocUnsafe(ir + (lr - Fe));
      Sr.fill(0, 0, ir);
      for (var er = ir; Fe !== lr; )
        Sr[er++] = Ir[Fe++];
      return Sr;
    }
    function He(Pe) {
      var nr = be(Pe);
      if (nr)
        return nr;
      throw new Error("Non-base" + le + " character");
    }
    return {
      encode: Ee,
      decodeUnsafe: be,
      decode: He
    };
  }
  return src$4 = c, src$4;
}
var bs58$1, hasRequiredBs58;
function requireBs58() {
  if (hasRequiredBs58) return bs58$1;
  hasRequiredBs58 = 1;
  var n = requireSrc(), c = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
  return bs58$1 = n(c), bs58$1;
}
var base$3, hasRequiredBase;
function requireBase() {
  if (hasRequiredBase) return base$3;
  hasRequiredBase = 1;
  var n = requireBs58(), c = safeBufferExports.Buffer;
  return base$3 = function(u) {
    function p(F) {
      var le = u(F);
      return n.encode(c.concat([
        F,
        le
      ], F.length + 4));
    }
    function a(F) {
      var le = F.slice(0, -4), L = F.slice(-4), pe = u(le);
      if (!(L[0] ^ pe[0] | L[1] ^ pe[1] | L[2] ^ pe[2] | L[3] ^ pe[3]))
        return le;
    }
    function A(F) {
      var le = n.decodeUnsafe(F);
      if (le)
        return a(le);
    }
    function b(F) {
      var le = n.decode(F), L = a(le);
      if (!L) throw new Error("Invalid checksum");
      return L;
    }
    return {
      encode: p,
      decode: b,
      decodeUnsafe: A
    };
  }, base$3;
}
var bs58check$3, hasRequiredBs58check;
function requireBs58check() {
  if (hasRequiredBs58check) return bs58check$3;
  hasRequiredBs58check = 1;
  var n = browser$a, c = requireBase();
  function u(p) {
    var a = n("sha256").update(p).digest();
    return n("sha256").update(a).digest();
  }
  return bs58check$3 = c(u), bs58check$3;
}
var CryptoCoinInfo = {}, RegistryItem = {}, hasRequiredRegistryItem;
function requireRegistryItem() {
  if (hasRequiredRegistryItem) return RegistryItem;
  hasRequiredRegistryItem = 1, Object.defineProperty(RegistryItem, "__esModule", { value: !0 }), RegistryItem.RegistryItem = void 0;
  const n = dist$t, c = requireLib();
  let u = class {
    constructor() {
      this.toCBOR = () => {
        if (this.toDataItem() === void 0)
          throw new Error(`#[ur-registry][RegistryItem][fn.toCBOR]: registry ${this.getRegistryType()}'s method toDataItem returns undefined`);
        return (0, c.encodeDataItem)(this.toDataItem());
      }, this.toUR = () => new n.UR(this.toCBOR(), this.getRegistryType().getType()), this.toUREncoder = (a, A, b) => {
        const F = this.toUR();
        return new n.UREncoder(F, a, A, b);
      };
    }
  };
  return RegistryItem.RegistryItem = u, RegistryItem;
}
var hasRequiredCryptoCoinInfo;
function requireCryptoCoinInfo() {
  return hasRequiredCryptoCoinInfo || (hasRequiredCryptoCoinInfo = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.CryptoCoinInfo = n.Network = n.Type = void 0;
    const c = requireLib(), u = requireRegistryItem(), p = requireRegistryType();
    var a;
    (function(le) {
      le.type = "1", le.network = "2";
    })(a || (a = {}));
    var A;
    (function(le) {
      le[le.bitcoin = 0] = "bitcoin";
    })(A = n.Type || (n.Type = {}));
    var b;
    (function(le) {
      le[le.mainnet = 0] = "mainnet", le[le.testnet = 1] = "testnet";
    })(b = n.Network || (n.Network = {}));
    class F extends u.RegistryItem {
      constructor(L, pe) {
        super(), this.type = L, this.network = pe, this.getRegistryType = () => p.RegistryTypes.CRYPTO_COIN_INFO, this.getType = () => this.type || A.bitcoin, this.getNetwork = () => this.network || b.mainnet, this.toDataItem = () => {
          const $ = {};
          return this.type && ($[a.type] = this.type), this.network && ($[a.network] = this.network), new c.DataItem($);
        };
      }
    }
    n.CryptoCoinInfo = F, F.fromDataItem = (le) => {
      const L = le.getData(), pe = L[a.type], $ = L[a.network];
      return new F(pe, $);
    }, F.fromCBOR = (le) => {
      const L = (0, c.decodeToDataItem)(le);
      return F.fromDataItem(L);
    };
  }(CryptoCoinInfo)), CryptoCoinInfo;
}
var CryptoKeypath = {}, PathComponent = {}, hasRequiredPathComponent;
function requirePathComponent() {
  if (hasRequiredPathComponent) return PathComponent;
  hasRequiredPathComponent = 1, Object.defineProperty(PathComponent, "__esModule", { value: !0 }), PathComponent.PathComponent = void 0;
  let n = class Vp {
    constructor(u) {
      if (this.getIndex = () => this.index, this.isWildcard = () => this.wildcard, this.isHardened = () => this.hardened, this.index = u.index, this.hardened = u.hardened, this.index !== void 0 ? this.wildcard = !1 : this.wildcard = !0, this.index && this.index & Vp.HARDENED_BIT)
        throw new Error(`#[ur-registry][PathComponent][fn.constructor]: Invalid index ${this.index} - most significant bit cannot be set`);
    }
  };
  return PathComponent.PathComponent = n, n.HARDENED_BIT = 2147483648, PathComponent;
}
var hasRequiredCryptoKeypath;
function requireCryptoKeypath() {
  if (hasRequiredCryptoKeypath) return CryptoKeypath;
  hasRequiredCryptoKeypath = 1, Object.defineProperty(CryptoKeypath, "__esModule", { value: !0 }), CryptoKeypath.CryptoKeypath = void 0;
  const n = requireLib(), c = requirePathComponent(), u = requireRegistryItem(), p = requireRegistryType();
  var a;
  (function(b) {
    b[b.components = 1] = "components", b[b.source_fingerprint = 2] = "source_fingerprint", b[b.depth = 3] = "depth";
  })(a || (a = {}));
  let A = class extends u.RegistryItem {
    constructor(F = [], le, L) {
      super(), this.components = F, this.sourceFingerprint = le, this.depth = L, this.getRegistryType = () => p.RegistryTypes.CRYPTO_KEYPATH, this.getPath = () => this.components.length === 0 ? void 0 : this.components.map(($) => `${$.isWildcard() ? "*" : $.getIndex()}${$.isHardened() ? "'" : ""}`).join("/"), this.getComponents = () => this.components, this.getSourceFingerprint = () => this.sourceFingerprint, this.getDepth = () => this.depth, this.toDataItem = () => {
        const pe = {}, $ = [];
        return this.components && this.components.forEach((Ee) => {
          Ee.isWildcard() ? $.push([]) : $.push(Ee.getIndex()), $.push(Ee.isHardened());
        }), pe[a.components] = $, this.sourceFingerprint && (pe[a.source_fingerprint] = this.sourceFingerprint.readUInt32BE(0)), this.depth !== void 0 && (pe[a.depth] = this.depth), new n.DataItem(pe);
      };
    }
  };
  return CryptoKeypath.CryptoKeypath = A, A.fromDataItem = (b) => {
    const F = b.getData(), le = [], L = F[a.components];
    if (L)
      for (let be = 0; be < L.length; be += 2) {
        const He = L[be + 1], Pe = L[be];
        typeof Pe == "number" ? le.push(new c.PathComponent({ index: Pe, hardened: He })) : le.push(new c.PathComponent({ hardened: He }));
      }
    const pe = F[a.source_fingerprint];
    let $;
    pe && ($ = Buffer$f.alloc(4), $.writeUInt32BE(pe, 0));
    const Ee = F[a.depth];
    return new A(le, $, Ee);
  }, A.fromCBOR = (b) => {
    const F = (0, n.decodeToDataItem)(b);
    return A.fromDataItem(F);
  }, CryptoKeypath;
}
var hasRequiredCryptoHDKey;
function requireCryptoHDKey() {
  if (hasRequiredCryptoHDKey) return CryptoHDKey;
  hasRequiredCryptoHDKey = 1, Object.defineProperty(CryptoHDKey, "__esModule", { value: !0 }), CryptoHDKey.CryptoHDKey = void 0;
  const n = requireBs58check(), c = requireCryptoCoinInfo(), u = requireCryptoKeypath(), p = requireLib(), a = requireRegistryItem(), A = requireRegistryType();
  var b;
  (function(le) {
    le[le.is_master = 1] = "is_master", le[le.is_private = 2] = "is_private", le[le.key_data = 3] = "key_data", le[le.chain_code = 4] = "chain_code", le[le.use_info = 5] = "use_info", le[le.origin = 6] = "origin", le[le.children = 7] = "children", le[le.parent_fingerprint = 8] = "parent_fingerprint", le[le.name = 9] = "name", le[le.note = 10] = "note";
  })(b || (b = {}));
  let F = class extends a.RegistryItem {
    constructor(L) {
      super(), this.isECKey = () => !1, this.getKey = () => this.key, this.getChainCode = () => this.chainCode, this.isMaster = () => this.master, this.isPrivateKey = () => !!this.privateKey, this.getUseInfo = () => this.useInfo, this.getOrigin = () => this.origin, this.getChildren = () => this.children, this.getParentFingerprint = () => this.parentFingerprint, this.getName = () => this.name, this.getNote = () => this.note, this.getBip32Key = () => {
        var pe, $, Ee;
        let be, He, Pe = 0, nr = Buffer$f.alloc(4).fill(0);
        if (this.isMaster())
          be = Buffer$f.from("0488ADE4", "hex"), He = 0, Pe = 0;
        else {
          He = ((pe = this.getOrigin()) === null || pe === void 0 ? void 0 : pe.getComponents().length) || (($ = this.getOrigin()) === null || $ === void 0 ? void 0 : $.getDepth());
          const xr = (Ee = this.getOrigin()) === null || Ee === void 0 ? void 0 : Ee.getComponents(), kr = xr[xr.length - 1];
          kr && (Pe = kr.isHardened() ? kr.getIndex() + 2147483648 : kr.getIndex(), this.getParentFingerprint() && (nr = this.getParentFingerprint())), this.isPrivateKey() ? be = Buffer$f.from("0488ADE4", "hex") : be = Buffer$f.from("0488B21E", "hex");
        }
        const ir = Buffer$f.alloc(1);
        ir.writeUInt8(He, 0);
        const or = Buffer$f.alloc(4);
        or.writeUInt32BE(Pe, 0);
        const lr = this.getChainCode(), Ir = this.getKey();
        return (0, n.encode)(Buffer$f.concat([be, ir, nr, or, lr, Ir]));
      }, this.getRegistryType = () => A.RegistryTypes.CRYPTO_HDKEY, this.getOutputDescriptorContent = () => {
        var pe, $, Ee, be, He, Pe, nr;
        let ir = "";
        return this.getOrigin() && !((pe = this.getOrigin()) === null || pe === void 0) && pe.getSourceFingerprint() && !(($ = this.getOrigin()) === null || $ === void 0) && $.getPath() && (ir += `${(be = (Ee = this.getOrigin()) === null || Ee === void 0 ? void 0 : Ee.getSourceFingerprint()) === null || be === void 0 ? void 0 : be.toString("hex")}/${(He = this.getOrigin()) === null || He === void 0 ? void 0 : He.getPath()}`), ir += this.getBip32Key(), this.getChildren() && !((Pe = this.getChildren()) === null || Pe === void 0) && Pe.getPath() && (ir += `/${(nr = this.getChildren()) === null || nr === void 0 ? void 0 : nr.getPath()}`), ir;
      }, this.setupMasterKey = (pe) => {
        this.master = !0, this.key = pe.key, this.chainCode = pe.chainCode;
      }, this.setupDeriveKey = (pe) => {
        this.master = !1, this.privateKey = pe.isPrivateKey, this.key = pe.key, this.chainCode = pe.chainCode, this.useInfo = pe.useInfo, this.origin = pe.origin, this.children = pe.children, this.parentFingerprint = pe.parentFingerprint, this.name = pe.name, this.note = pe.note;
      }, this.toDataItem = () => {
        const pe = {};
        if (this.master)
          pe[b.is_master] = !0, pe[b.key_data] = this.key, pe[b.chain_code] = this.chainCode;
        else {
          if (this.privateKey !== void 0 && (pe[b.is_private] = this.privateKey), pe[b.key_data] = this.key, this.chainCode && (pe[b.chain_code] = this.chainCode), this.useInfo) {
            const $ = this.useInfo.toDataItem();
            $.setTag(this.useInfo.getRegistryType().getTag()), pe[b.use_info] = $;
          }
          if (this.origin) {
            const $ = this.origin.toDataItem();
            $.setTag(this.origin.getRegistryType().getTag()), pe[b.origin] = $;
          }
          if (this.children) {
            const $ = this.children.toDataItem();
            $.setTag(this.children.getRegistryType().getTag()), pe[b.children] = $;
          }
          this.parentFingerprint && (pe[b.parent_fingerprint] = this.parentFingerprint.readUInt32BE(0)), this.name !== void 0 && (pe[b.name] = this.name), this.note !== void 0 && (pe[b.note] = this.note);
        }
        return new p.DataItem(pe);
      }, L.isMaster ? this.setupMasterKey(L) : this.setupDeriveKey(L);
    }
  };
  return CryptoHDKey.CryptoHDKey = F, F.fromDataItem = (le) => {
    const L = le.getData(), pe = !!L[b.is_master], $ = L[b.is_private], Ee = L[b.key_data], be = L[b.chain_code], He = L[b.use_info] ? c.CryptoCoinInfo.fromDataItem(L[b.use_info]) : void 0, Pe = L[b.origin] ? u.CryptoKeypath.fromDataItem(L[b.origin]) : void 0, nr = L[b.children] ? u.CryptoKeypath.fromDataItem(L[b.children]) : void 0, ir = L[b.parent_fingerprint];
    let or;
    ir && (or = Buffer$f.alloc(4), or.writeUInt32BE(ir, 0));
    const lr = L[b.name], Ir = L[b.note];
    return new F({
      isMaster: pe,
      isPrivateKey: $,
      key: Ee,
      chainCode: be,
      useInfo: He,
      origin: Pe,
      children: nr,
      parentFingerprint: or,
      name: lr,
      note: Ir
    });
  }, F.fromCBOR = (le) => {
    const L = (0, p.decodeToDataItem)(le);
    return F.fromDataItem(L);
  }, CryptoHDKey;
}
var CryptoECKey = {}, hasRequiredCryptoECKey;
function requireCryptoECKey() {
  if (hasRequiredCryptoECKey) return CryptoECKey;
  hasRequiredCryptoECKey = 1, Object.defineProperty(CryptoECKey, "__esModule", { value: !0 }), CryptoECKey.CryptoECKey = void 0;
  const n = requireLib(), c = requireRegistryItem(), u = requireRegistryType();
  var p;
  (function(A) {
    A[A.curve = 1] = "curve", A[A.private = 2] = "private", A[A.data = 3] = "data";
  })(p || (p = {}));
  let a = class extends c.RegistryItem {
    constructor(b) {
      super(), this.isECKey = () => !0, this.getCurve = () => this.curve || 0, this.isPrivateKey = () => this.privateKey || !1, this.getData = () => this.data, this.getRegistryType = () => u.RegistryTypes.CRYPTO_ECKEY, this.toDataItem = () => {
        const F = {};
        return this.curve && (F[p.curve] = this.curve), this.privateKey !== void 0 && (F[p.private] = this.privateKey), F[p.data] = this.data, new n.DataItem(F);
      }, this.getOutputDescriptorContent = () => this.data.toString("hex"), this.data = b.data, this.curve = b.curve, this.privateKey = b.privateKey || void 0;
    }
  };
  return CryptoECKey.CryptoECKey = a, a.fromDataItem = (A) => {
    const b = A.getData(), F = b[p.curve], le = b[p.private], L = b[p.data];
    if (!L)
      throw new Error(`#[ur-registry][CryptoECKey][fn.fromDataItem]: decoded [dataItem][#data.data] is undefined: ${A}`);
    return new a({ data: L, curve: F, privateKey: le });
  }, a.fromCBOR = (A) => {
    const b = (0, n.decodeToDataItem)(A);
    return a.fromDataItem(b);
  }, CryptoECKey;
}
var Bytes$1 = {}, hasRequiredBytes;
function requireBytes() {
  if (hasRequiredBytes) return Bytes$1;
  hasRequiredBytes = 1, Object.defineProperty(Bytes$1, "__esModule", { value: !0 }), Bytes$1.Bytes = void 0;
  const n = requireLib(), c = requireRegistryItem(), u = requireRegistryType();
  class p extends c.RegistryItem {
    constructor(A) {
      super(), this.bytes = A, this.getRegistryType = () => u.RegistryTypes.BYTES, this.getData = () => this.bytes, this.toDataItem = () => new n.DataItem(this.bytes);
    }
  }
  return Bytes$1.Bytes = p, p.fromDataItem = (a) => {
    const A = a.getData();
    if (!A)
      throw new Error(`#[ur-registry][Bytes][fn.fromDataItem]: decoded [dataItem][#data] is undefined: ${a}`);
    return new p(A);
  }, p.fromCBOR = (a) => {
    const A = (0, n.decodeToDataItem)(a);
    return p.fromDataItem(A);
  }, Bytes$1;
}
var CryptoOutput = {}, MultiKey = {}, hasRequiredMultiKey;
function requireMultiKey() {
  if (hasRequiredMultiKey) return MultiKey;
  hasRequiredMultiKey = 1, Object.defineProperty(MultiKey, "__esModule", { value: !0 }), MultiKey.MultiKey = void 0;
  const n = requireCryptoECKey(), c = requireCryptoHDKey(), u = requireDataItem(), p = requireRegistryItem(), a = requireRegistryType();
  var A;
  (function(F) {
    F[F.threshold = 1] = "threshold", F[F.keys = 2] = "keys";
  })(A || (A = {}));
  let b = class extends p.RegistryItem {
    constructor(le, L) {
      super(), this.threshold = le, this.keys = L, this.getThreshold = () => this.threshold, this.getKeys = () => this.keys, this.toDataItem = () => {
        const pe = {};
        pe[A.threshold] = this.threshold;
        const $ = this.keys.map((Ee) => {
          const be = Ee.toDataItem();
          return be.setTag(Ee.getRegistryType().getTag()), be;
        });
        return pe[A.keys] = $, new u.DataItem(pe);
      }, this.getOutputDescriptorContent = () => [
        this.getThreshold(),
        this.keys.map((pe) => pe.getOutputDescriptorContent()).join(",")
      ].join(",");
    }
  };
  return MultiKey.MultiKey = b, b.fromDataItem = (F) => {
    const le = F.getData(), L = le[A.threshold], pe = le[A.keys], $ = [];
    return pe.forEach((Ee) => {
      Ee.getTag() === a.RegistryTypes.CRYPTO_HDKEY.getTag() ? $.push(c.CryptoHDKey.fromDataItem(Ee)) : Ee.getTag() === a.RegistryTypes.CRYPTO_ECKEY.getTag() && $.push(n.CryptoECKey.fromDataItem(Ee));
    }), new b(L, $);
  }, MultiKey;
}
var hasRequiredCryptoOutput;
function requireCryptoOutput() {
  if (hasRequiredCryptoOutput) return CryptoOutput;
  hasRequiredCryptoOutput = 1, Object.defineProperty(CryptoOutput, "__esModule", { value: !0 }), CryptoOutput.CryptoOutput = void 0;
  const n = requireCryptoECKey(), c = requireCryptoHDKey(), u = requireLib(), p = requireMultiKey(), a = requireRegistryItem(), A = requireRegistryType(), b = requireScriptExpression();
  let F = class extends a.RegistryItem {
    constructor(L, pe) {
      super(), this.scriptExpressions = L, this.cryptoKey = pe, this.getRegistryType = () => A.RegistryTypes.CRYPTO_OUTPUT, this.getCryptoKey = () => this.cryptoKey, this.getHDKey = () => {
        if (this.cryptoKey instanceof c.CryptoHDKey)
          return this.cryptoKey;
      }, this.getECKey = () => {
        if (this.cryptoKey instanceof n.CryptoECKey)
          return this.cryptoKey;
      }, this.getMultiKey = () => {
        if (this.cryptoKey instanceof p.MultiKey)
          return this.cryptoKey;
      }, this.getScriptExpressions = () => this.scriptExpressions, this._toOutputDescriptor = ($) => $ >= this.scriptExpressions.length ? this.cryptoKey.getOutputDescriptorContent() : `${this.scriptExpressions[$].getExpression()}(${this._toOutputDescriptor($ + 1)})`, this.toString = () => this._toOutputDescriptor(0), this.toDataItem = () => {
        let $ = this.cryptoKey.toDataItem();
        return (this.cryptoKey instanceof n.CryptoECKey || this.cryptoKey instanceof c.CryptoHDKey) && $.setTag(this.cryptoKey.getRegistryType().getTag()), [...this.scriptExpressions].reverse().forEach((be) => {
          const He = be.getTag();
          $.getTag() === void 0 ? $.setTag(He) : $ = new u.DataItem($, He);
        }), $;
      };
    }
  };
  return CryptoOutput.CryptoOutput = F, F.fromDataItem = (le) => {
    const L = [];
    let pe = le;
    for (; ; ) {
      let be = pe.getTag();
      const He = b.ScriptExpression.fromTag(be);
      if (He)
        if (L.push(He), pe.getData() instanceof u.DataItem)
          pe = pe.getData(), be = pe.getTag();
        else
          break;
      else
        break;
    }
    const $ = L.length;
    if ($ > 0 && (L[$ - 1].getExpression() === b.ScriptExpressions.MULTISIG.getExpression() || L[$ - 1].getExpression() === b.ScriptExpressions.SORTED_MULTISIG.getExpression())) {
      const be = p.MultiKey.fromDataItem(pe);
      return new F(L, be);
    }
    if (pe.getTag() === A.RegistryTypes.CRYPTO_HDKEY.getTag()) {
      const be = c.CryptoHDKey.fromDataItem(pe);
      return new F(L, be);
    } else {
      const be = n.CryptoECKey.fromDataItem(pe);
      return new F(L, be);
    }
  }, F.fromCBOR = (le) => {
    const L = (0, u.decodeToDataItem)(le);
    return F.fromDataItem(L);
  }, CryptoOutput;
}
var CryptoPSBT = {}, hasRequiredCryptoPSBT;
function requireCryptoPSBT() {
  if (hasRequiredCryptoPSBT) return CryptoPSBT;
  hasRequiredCryptoPSBT = 1, Object.defineProperty(CryptoPSBT, "__esModule", { value: !0 }), CryptoPSBT.CryptoPSBT = void 0;
  const n = requireLib(), c = requireRegistryItem(), u = requireRegistryType();
  let p = class extends c.RegistryItem {
    constructor(A) {
      super(), this.psbt = A, this.getRegistryType = () => u.RegistryTypes.CRYPTO_PSBT, this.getPSBT = () => this.psbt, this.toDataItem = () => new n.DataItem(this.psbt);
    }
  };
  return CryptoPSBT.CryptoPSBT = p, p.fromDataItem = (a) => {
    const A = a.getData();
    if (!A)
      throw new Error(`#[ur-registry][CryptoPSBT][fn.fromDataItem]: decoded [dataItem][#data] is undefined: ${a}`);
    return new p(A);
  }, p.fromCBOR = (a) => {
    const A = (0, n.decodeToDataItem)(a);
    return p.fromDataItem(A);
  }, CryptoPSBT;
}
var CryptoAccount = {}, hasRequiredCryptoAccount;
function requireCryptoAccount() {
  if (hasRequiredCryptoAccount) return CryptoAccount;
  hasRequiredCryptoAccount = 1, Object.defineProperty(CryptoAccount, "__esModule", { value: !0 }), CryptoAccount.CryptoAccount = void 0;
  const n = requireDist(), c = requireLib(), u = requireRegistryItem(), p = requireRegistryType();
  var a;
  (function(b) {
    b[b.masterFingerprint = 1] = "masterFingerprint", b[b.outputDescriptors = 2] = "outputDescriptors";
  })(a || (a = {}));
  let A = class extends u.RegistryItem {
    constructor(F, le) {
      super(), this.masterFingerprint = F, this.outputDescriptors = le, this.getRegistryType = () => p.RegistryTypes.CRYPTO_ACCOUNT, this.getMasterFingerprint = () => this.masterFingerprint, this.getOutputDescriptors = () => this.outputDescriptors, this.toDataItem = () => {
        const L = {};
        return this.masterFingerprint && (L[a.masterFingerprint] = this.masterFingerprint.readUInt32BE(0)), this.outputDescriptors && (L[a.outputDescriptors] = this.outputDescriptors.map((pe) => pe.toDataItem())), new c.DataItem(L);
      };
    }
  };
  return CryptoAccount.CryptoAccount = A, A.fromDataItem = (b) => {
    const F = b.getData(), le = Buffer$f.alloc(4), L = F[a.masterFingerprint];
    L && le.writeUInt32BE(L, 0);
    const $ = F[a.outputDescriptors].map((Ee) => n.CryptoOutput.fromDataItem(Ee));
    return new A(le, $);
  }, A.fromCBOR = (b) => {
    const F = (0, c.decodeToDataItem)(b);
    return A.fromDataItem(F);
  }, CryptoAccount;
}
var Decoder = {}, errors$1 = {}, hasRequiredErrors;
function requireErrors() {
  if (hasRequiredErrors) return errors$1;
  hasRequiredErrors = 1, Object.defineProperty(errors$1, "__esModule", { value: !0 }), errors$1.UnknownURTypeError = void 0;
  class n extends Error {
    constructor(u) {
      super(u);
    }
  }
  return errors$1.UnknownURTypeError = n, errors$1;
}
var hasRequiredDecoder;
function requireDecoder() {
  if (hasRequiredDecoder) return Decoder;
  hasRequiredDecoder = 1, Object.defineProperty(Decoder, "__esModule", { value: !0 }), Decoder.URRegistryDecoder = void 0;
  const n = dist$t, c = requireDist(), u = requireRegistryType(), p = requireErrors();
  class a extends n.URDecoder {
    constructor() {
      super(...arguments), this.resultRegistryType = () => {
        const b = this.resultUR();
        switch (b.type) {
          case u.RegistryTypes.BYTES.getType():
            return c.Bytes.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_HDKEY.getType():
            return c.CryptoHDKey.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_KEYPATH.getType():
            return c.CryptoKeypath.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_COIN_INFO.getType():
            return c.CryptoCoinInfo.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_ECKEY.getType():
            return c.CryptoECKey.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_OUTPUT.getType():
            return c.CryptoOutput.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_PSBT.getType():
            return c.CryptoPSBT.fromCBOR(b.cbor);
          case u.RegistryTypes.CRYPTO_ACCOUNT.getType():
            return c.CryptoAccount.fromCBOR(b.cbor);
          default:
            throw new p.UnknownURTypeError(`#[ur-registry][Decoder][fn.resultRegistryType]: registry type ${b.type} is not supported now`);
        }
      };
    }
  }
  return Decoder.URRegistryDecoder = a, Decoder;
}
var CryptoMultiAccounts = {}, hasRequiredCryptoMultiAccounts;
function requireCryptoMultiAccounts() {
  if (hasRequiredCryptoMultiAccounts) return CryptoMultiAccounts;
  hasRequiredCryptoMultiAccounts = 1, Object.defineProperty(CryptoMultiAccounts, "__esModule", { value: !0 }), CryptoMultiAccounts.CryptoMultiAccounts = void 0;
  const n = requireRegistryType(), c = requireCryptoHDKey(), u = requireRegistryItem(), p = requireLib();
  var a;
  (function(b) {
    b[b.masterFingerprint = 1] = "masterFingerprint", b[b.keys = 2] = "keys", b[b.device = 3] = "device", b[b.deviceId = 4] = "deviceId", b[b.version = 5] = "version";
  })(a || (a = {}));
  let A = class extends u.RegistryItem {
    constructor(F, le, L, pe, $) {
      super(), this.masterFingerprint = F, this.keys = le, this.device = L, this.deviceId = pe, this.version = $, this.getRegistryType = () => n.RegistryTypes.CRYPTO_MULTI_ACCOUNTS, this.getMasterFingerprint = () => this.masterFingerprint, this.getKeys = () => this.keys, this.getDevice = () => this.device, this.getDeviceId = () => this.deviceId, this.getVersion = () => this.version, this.toDataItem = () => {
        const Ee = {};
        return this.masterFingerprint && (Ee[a.masterFingerprint] = this.masterFingerprint.readUInt32BE(0)), this.keys && (Ee[a.keys] = this.keys.map((be) => {
          const He = be.toDataItem();
          return He.setTag(be.getRegistryType().getTag()), He;
        })), this.device && (Ee[a.device] = this.device), this.deviceId && (Ee[a.deviceId] = this.deviceId), this.version && (Ee[a.version] = this.version), new p.DataItem(Ee);
      };
    }
  };
  return CryptoMultiAccounts.CryptoMultiAccounts = A, A.fromDataItem = (b) => {
    const F = b.getData(), le = Buffer$f.alloc(4), L = F[a.masterFingerprint];
    L && le.writeUInt32BE(L, 0);
    const $ = F[a.keys].map((Pe) => c.CryptoHDKey.fromDataItem(Pe)), Ee = F[a.device], be = F[a.deviceId], He = F[a.version];
    return new A(le, $, Ee, be, He);
  }, A.fromCBOR = (b) => {
    const F = (0, p.decodeToDataItem)(b);
    return A.fromDataItem(F);
  }, CryptoMultiAccounts;
}
var QRHardwareCall = {}, KeyDerivation = {}, DerivationSchema = {}, hasRequiredDerivationSchema;
function requireDerivationSchema() {
  return hasRequiredDerivationSchema || (hasRequiredDerivationSchema = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.KeyDerivationSchema = n.DerivationAlgorithm = n.Curve = void 0;
    const c = requireRegistryType(), u = requireRegistryItem(), p = requireLib(), a = requireCryptoKeypath();
    var A;
    (function(L) {
      L[L.keyPath = 1] = "keyPath", L[L.curve = 2] = "curve", L[L.algo = 3] = "algo";
    })(A || (A = {}));
    var b;
    (function(L) {
      L[L.secp256k1 = 0] = "secp256k1", L[L.ed25519 = 1] = "ed25519";
    })(b = n.Curve || (n.Curve = {}));
    var F;
    (function(L) {
      L[L.slip10 = 0] = "slip10", L[L.bip32ed25519 = 1] = "bip32ed25519";
    })(F = n.DerivationAlgorithm || (n.DerivationAlgorithm = {}));
    class le extends u.RegistryItem {
      constructor(pe, $ = b.secp256k1, Ee = F.slip10) {
        super(), this.keypath = pe, this.curve = $, this.algo = Ee, this.getRegistryType = () => c.RegistryTypes.KEY_DERIVATION_SCHEMA, this.getKeypath = () => this.keypath, this.getCurve = () => this.curve, this.getAlgo = () => this.algo, this.toDataItem = () => {
          const be = {}, He = this.getKeypath().toDataItem();
          return He.setTag(this.getKeypath().getRegistryType().getTag()), be[A.keyPath] = He, be[A.curve] = this.curve, be[A.algo] = this.algo, new p.DataItem(be);
        };
      }
    }
    n.KeyDerivationSchema = le, le.fromDataItem = (L) => {
      const pe = L.getData(), $ = a.CryptoKeypath.fromDataItem(pe[A.keyPath]), Ee = pe[A.curve], be = pe[A.algo];
      return new le($, Ee, be);
    }, le.fromCBOR = (L) => {
      const pe = (0, p.decodeToDataItem)(L);
      return le.fromDataItem(pe);
    };
  }(DerivationSchema)), DerivationSchema;
}
var hasRequiredKeyDerivation;
function requireKeyDerivation() {
  if (hasRequiredKeyDerivation) return KeyDerivation;
  hasRequiredKeyDerivation = 1, Object.defineProperty(KeyDerivation, "__esModule", { value: !0 }), KeyDerivation.KeyDerivation = void 0;
  const n = requireRegistryType(), c = requireRegistryItem(), u = requireLib(), p = requireDerivationSchema();
  var a;
  (function(b) {
    b[b.schemas = 1] = "schemas";
  })(a || (a = {}));
  let A = class extends c.RegistryItem {
    constructor(F) {
      super(), this.schemas = F, this.getRegistryType = () => n.RegistryTypes.KEY_DERIVATION_CALL, this.getSchemas = () => this.schemas, this.toDataItem = () => {
        const le = {};
        return le[a.schemas] = this.schemas.map((L) => {
          const pe = L.toDataItem();
          return pe.setTag(L.getRegistryType().getTag()), pe;
        }), new u.DataItem(le);
      };
    }
  };
  return KeyDerivation.KeyDerivation = A, A.fromDataItem = (b) => {
    const le = b.getData()[a.schemas].map((L) => p.KeyDerivationSchema.fromDataItem(L));
    return new A(le);
  }, A.fromCBOR = (b) => {
    const F = (0, u.decodeToDataItem)(b);
    return A.fromDataItem(F);
  }, KeyDerivation;
}
var hasRequiredQRHardwareCall;
function requireQRHardwareCall() {
  return hasRequiredQRHardwareCall || (hasRequiredQRHardwareCall = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.QRHardwareCall = n.QRHardwareCallType = void 0;
    const c = requireRegistryType(), u = requireRegistryItem(), p = requireLib(), a = requireKeyDerivation();
    var A;
    (function(le) {
      le[le.type = 1] = "type", le[le.params = 2] = "params", le[le.origin = 3] = "origin";
    })(A || (A = {}));
    var b;
    (function(le) {
      le[le.KeyDerivation = 0] = "KeyDerivation";
    })(b = n.QRHardwareCallType || (n.QRHardwareCallType = {}));
    class F extends u.RegistryItem {
      constructor(L, pe, $) {
        super(), this.type = L, this.params = pe, this.origin = $, this.getRegistryType = () => c.RegistryTypes.QR_HARDWARE_CALL, this.getType = () => this.type, this.getParams = () => this.params, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const Ee = {};
          Ee[A.type] = this.type;
          const be = this.params.toDataItem();
          return be.setTag(this.params.getRegistryType().getTag()), Ee[A.params] = be, this.origin && (Ee[A.origin] = this.origin), new p.DataItem(Ee);
        };
      }
    }
    n.QRHardwareCall = F, F.fromDataItem = (le) => {
      const L = le.getData(), pe = L[A.type] || b.KeyDerivation;
      let $;
      switch (pe) {
        case b.KeyDerivation:
          $ = a.KeyDerivation.fromDataItem(L[A.params]);
      }
      const Ee = L[A.origin];
      return new F(pe, $, Ee);
    }, F.fromCBOR = (le) => {
      const L = (0, p.decodeToDataItem)(le);
      return F.fromDataItem(L);
    };
  }(QRHardwareCall)), QRHardwareCall;
}
var types$5 = {}, hasRequiredTypes;
function requireTypes() {
  return hasRequiredTypes || (hasRequiredTypes = 1, Object.defineProperty(types$5, "__esModule", { value: !0 })), types$5;
}
var hasRequiredDist;
function requireDist() {
  return hasRequiredDist || (hasRequiredDist = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.Buffer = n.extend = n.PathComponent = n.ScriptExpressions = n.MultiKey = n.CryptoPSBT = n.CryptoOutput = n.CryptoECKey = n.CryptoCoinInfoNetwork = n.CryptoCoinInfoType = n.CryptoCoinInfo = n.CryptoKeypath = n.CryptoMultiAccounts = n.CryptoHDKey = n.CryptoAccount = n.Bytes = n.URRegistryDecoder = n.DataItem = void 0;
    const c = require$$0$4;
    requirePatchCBOR();
    const u = dist$u;
    Object.defineProperty(n, "Buffer", { enumerable: !0, get: function() {
      return u.Buffer;
    } });
    const p = requireCryptoHDKey();
    Object.defineProperty(n, "CryptoHDKey", { enumerable: !0, get: function() {
      return p.CryptoHDKey;
    } });
    const a = requireCryptoKeypath();
    Object.defineProperty(n, "CryptoKeypath", { enumerable: !0, get: function() {
      return a.CryptoKeypath;
    } });
    const A = requireCryptoCoinInfo();
    Object.defineProperty(n, "CryptoCoinInfo", { enumerable: !0, get: function() {
      return A.CryptoCoinInfo;
    } }), Object.defineProperty(n, "CryptoCoinInfoType", { enumerable: !0, get: function() {
      return A.Type;
    } }), Object.defineProperty(n, "CryptoCoinInfoNetwork", { enumerable: !0, get: function() {
      return A.Network;
    } });
    const b = requireCryptoECKey();
    Object.defineProperty(n, "CryptoECKey", { enumerable: !0, get: function() {
      return b.CryptoECKey;
    } });
    const F = requireBytes();
    Object.defineProperty(n, "Bytes", { enumerable: !0, get: function() {
      return F.Bytes;
    } });
    const le = requireCryptoOutput();
    Object.defineProperty(n, "CryptoOutput", { enumerable: !0, get: function() {
      return le.CryptoOutput;
    } });
    const L = requireCryptoPSBT();
    Object.defineProperty(n, "CryptoPSBT", { enumerable: !0, get: function() {
      return L.CryptoPSBT;
    } });
    const pe = requireCryptoAccount();
    Object.defineProperty(n, "CryptoAccount", { enumerable: !0, get: function() {
      return pe.CryptoAccount;
    } });
    const $ = requireDecoder();
    Object.defineProperty(n, "URRegistryDecoder", { enumerable: !0, get: function() {
      return $.URRegistryDecoder;
    } });
    const Ee = requireMultiKey();
    Object.defineProperty(n, "MultiKey", { enumerable: !0, get: function() {
      return Ee.MultiKey;
    } });
    const be = requireScriptExpression();
    Object.defineProperty(n, "ScriptExpressions", { enumerable: !0, get: function() {
      return be.ScriptExpressions;
    } });
    const He = requirePathComponent();
    Object.defineProperty(n, "PathComponent", { enumerable: !0, get: function() {
      return He.PathComponent;
    } });
    const Pe = requireRegistryItem(), nr = requireRegistryType(), ir = requireLib();
    var or = requireLib();
    Object.defineProperty(n, "DataItem", { enumerable: !0, get: function() {
      return or.DataItem;
    } });
    const lr = requireUtils(), Ir = requireCryptoMultiAccounts();
    Object.defineProperty(n, "CryptoMultiAccounts", { enumerable: !0, get: function() {
      return Ir.CryptoMultiAccounts;
    } });
    const xr = {
      URRegistryDecoder: $.URRegistryDecoder,
      Bytes: F.Bytes,
      CryptoAccount: pe.CryptoAccount,
      CryptoHDKey: p.CryptoHDKey,
      CryptoMultiAccounts: Ir.CryptoMultiAccounts,
      CryptoKeypath: a.CryptoKeypath,
      CryptoCoinInfo: A.CryptoCoinInfo,
      CryptoCoinInfoType: A.Type,
      CryptoCoinInfoNetwork: A.Network,
      CryptoECKey: b.CryptoECKey,
      CryptoOutput: le.CryptoOutput,
      CryptoPSBT: L.CryptoPSBT,
      MultiKey: Ee.MultiKey,
      ScriptExpressions: be.ScriptExpressions,
      PathComponent: He.PathComponent
    }, kr = {
      addReader: ir.addReader,
      addSemanticDecode: ir.addSemanticDecode,
      addSemanticEncode: ir.addSemanticEncode,
      addWriter: ir.addWriter,
      patchTags: lr.patchTags
    }, Ce = {
      RegistryTypes: nr.RegistryTypes,
      RegistryItem: Pe.RegistryItem,
      RegistryType: nr.RegistryType,
      decodeToDataItem: ir.decodeToDataItem,
      encodeDataItem: ir.encodeDataItem,
      cbor: kr
    };
    n.extend = Ce, (0, c.__exportStar)(requireErrors(), n), (0, c.__exportStar)(requireDecoder(), n), (0, c.__exportStar)(requireLib(), n), (0, c.__exportStar)(requireCryptoAccount(), n), (0, c.__exportStar)(requireCryptoPSBT(), n), (0, c.__exportStar)(requireCryptoHDKey(), n), (0, c.__exportStar)(requireCryptoMultiAccounts(), n), (0, c.__exportStar)(requireQRHardwareCall(), n), (0, c.__exportStar)(requireKeyDerivation(), n), (0, c.__exportStar)(requireDerivationSchema(), n), (0, c.__exportStar)(requireCryptoOutput(), n), (0, c.__exportStar)(requireCryptoCoinInfo(), n), (0, c.__exportStar)(requireCryptoECKey(), n), (0, c.__exportStar)(requireMultiKey(), n), (0, c.__exportStar)(requireCryptoKeypath(), n), (0, c.__exportStar)(requirePatchCBOR(), n), (0, c.__exportStar)(requirePathComponent(), n), (0, c.__exportStar)(requireRegistryItem(), n), (0, c.__exportStar)(requireRegistryType(), n), (0, c.__exportStar)(requireTypes(), n), (0, c.__exportStar)(requireUtils(), n), n.default = xr;
  }(dist$4)), dist$4;
}
var getRandomValues$3, rnds8$1 = new Uint8Array(16);
function rng$1() {
  if (!getRandomValues$3 && (getRandomValues$3 = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !getRandomValues$3))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return getRandomValues$3(rnds8$1);
}
const REGEX = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function validate$1(n) {
  return typeof n == "string" && REGEX.test(n);
}
var byteToHex$1 = [];
for (var i$2 = 0; i$2 < 256; ++i$2)
  byteToHex$1.push((i$2 + 256).toString(16).substr(1));
function stringify(n) {
  var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, u = (byteToHex$1[n[c + 0]] + byteToHex$1[n[c + 1]] + byteToHex$1[n[c + 2]] + byteToHex$1[n[c + 3]] + "-" + byteToHex$1[n[c + 4]] + byteToHex$1[n[c + 5]] + "-" + byteToHex$1[n[c + 6]] + byteToHex$1[n[c + 7]] + "-" + byteToHex$1[n[c + 8]] + byteToHex$1[n[c + 9]] + "-" + byteToHex$1[n[c + 10]] + byteToHex$1[n[c + 11]] + byteToHex$1[n[c + 12]] + byteToHex$1[n[c + 13]] + byteToHex$1[n[c + 14]] + byteToHex$1[n[c + 15]]).toLowerCase();
  if (!validate$1(u))
    throw TypeError("Stringified UUID is invalid");
  return u;
}
var _nodeId, _clockseq, _lastMSecs = 0, _lastNSecs = 0;
function v1(n, c, u) {
  var p = c && u || 0, a = c || new Array(16);
  n = n || {};
  var A = n.node || _nodeId, b = n.clockseq !== void 0 ? n.clockseq : _clockseq;
  if (A == null || b == null) {
    var F = n.random || (n.rng || rng$1)();
    A == null && (A = _nodeId = [F[0] | 1, F[1], F[2], F[3], F[4], F[5]]), b == null && (b = _clockseq = (F[6] << 8 | F[7]) & 16383);
  }
  var le = n.msecs !== void 0 ? n.msecs : Date.now(), L = n.nsecs !== void 0 ? n.nsecs : _lastNSecs + 1, pe = le - _lastMSecs + (L - _lastNSecs) / 1e4;
  if (pe < 0 && n.clockseq === void 0 && (b = b + 1 & 16383), (pe < 0 || le > _lastMSecs) && n.nsecs === void 0 && (L = 0), L >= 1e4)
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  _lastMSecs = le, _lastNSecs = L, _clockseq = b, le += 122192928e5;
  var $ = ((le & 268435455) * 1e4 + L) % 4294967296;
  a[p++] = $ >>> 24 & 255, a[p++] = $ >>> 16 & 255, a[p++] = $ >>> 8 & 255, a[p++] = $ & 255;
  var Ee = le / 4294967296 * 1e4 & 268435455;
  a[p++] = Ee >>> 8 & 255, a[p++] = Ee & 255, a[p++] = Ee >>> 24 & 15 | 16, a[p++] = Ee >>> 16 & 255, a[p++] = b >>> 8 | 128, a[p++] = b & 255;
  for (var be = 0; be < 6; ++be)
    a[p + be] = A[be];
  return c || stringify(a);
}
function parse$7(n) {
  if (!validate$1(n))
    throw TypeError("Invalid UUID");
  var c, u = new Uint8Array(16);
  return u[0] = (c = parseInt(n.slice(0, 8), 16)) >>> 24, u[1] = c >>> 16 & 255, u[2] = c >>> 8 & 255, u[3] = c & 255, u[4] = (c = parseInt(n.slice(9, 13), 16)) >>> 8, u[5] = c & 255, u[6] = (c = parseInt(n.slice(14, 18), 16)) >>> 8, u[7] = c & 255, u[8] = (c = parseInt(n.slice(19, 23), 16)) >>> 8, u[9] = c & 255, u[10] = (c = parseInt(n.slice(24, 36), 16)) / 1099511627776 & 255, u[11] = c / 4294967296 & 255, u[12] = c >>> 24 & 255, u[13] = c >>> 16 & 255, u[14] = c >>> 8 & 255, u[15] = c & 255, u;
}
function stringToBytes$1(n) {
  n = unescape(encodeURIComponent(n));
  for (var c = [], u = 0; u < n.length; ++u)
    c.push(n.charCodeAt(u));
  return c;
}
var DNS = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", URL$1 = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
function v35(n, c, u) {
  function p(a, A, b, F) {
    if (typeof a == "string" && (a = stringToBytes$1(a)), typeof A == "string" && (A = parse$7(A)), A.length !== 16)
      throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    var le = new Uint8Array(16 + a.length);
    if (le.set(A), le.set(a, A.length), le = u(le), le[6] = le[6] & 15 | c, le[8] = le[8] & 63 | 128, b) {
      F = F || 0;
      for (var L = 0; L < 16; ++L)
        b[F + L] = le[L];
      return b;
    }
    return stringify(le);
  }
  try {
    p.name = n;
  } catch {
  }
  return p.DNS = DNS, p.URL = URL$1, p;
}
function md5(n) {
  if (typeof n == "string") {
    var c = unescape(encodeURIComponent(n));
    n = new Uint8Array(c.length);
    for (var u = 0; u < c.length; ++u)
      n[u] = c.charCodeAt(u);
  }
  return md5ToHexEncodedArray(wordsToMd5(bytesToWords(n), n.length * 8));
}
function md5ToHexEncodedArray(n) {
  for (var c = [], u = n.length * 32, p = "0123456789abcdef", a = 0; a < u; a += 8) {
    var A = n[a >> 5] >>> a % 32 & 255, b = parseInt(p.charAt(A >>> 4 & 15) + p.charAt(A & 15), 16);
    c.push(b);
  }
  return c;
}
function getOutputLength(n) {
  return (n + 64 >>> 9 << 4) + 14 + 1;
}
function wordsToMd5(n, c) {
  n[c >> 5] |= 128 << c % 32, n[getOutputLength(c) - 1] = c;
  for (var u = 1732584193, p = -271733879, a = -1732584194, A = 271733878, b = 0; b < n.length; b += 16) {
    var F = u, le = p, L = a, pe = A;
    u = md5ff(u, p, a, A, n[b], 7, -680876936), A = md5ff(A, u, p, a, n[b + 1], 12, -389564586), a = md5ff(a, A, u, p, n[b + 2], 17, 606105819), p = md5ff(p, a, A, u, n[b + 3], 22, -1044525330), u = md5ff(u, p, a, A, n[b + 4], 7, -176418897), A = md5ff(A, u, p, a, n[b + 5], 12, 1200080426), a = md5ff(a, A, u, p, n[b + 6], 17, -1473231341), p = md5ff(p, a, A, u, n[b + 7], 22, -45705983), u = md5ff(u, p, a, A, n[b + 8], 7, 1770035416), A = md5ff(A, u, p, a, n[b + 9], 12, -1958414417), a = md5ff(a, A, u, p, n[b + 10], 17, -42063), p = md5ff(p, a, A, u, n[b + 11], 22, -1990404162), u = md5ff(u, p, a, A, n[b + 12], 7, 1804603682), A = md5ff(A, u, p, a, n[b + 13], 12, -40341101), a = md5ff(a, A, u, p, n[b + 14], 17, -1502002290), p = md5ff(p, a, A, u, n[b + 15], 22, 1236535329), u = md5gg(u, p, a, A, n[b + 1], 5, -165796510), A = md5gg(A, u, p, a, n[b + 6], 9, -1069501632), a = md5gg(a, A, u, p, n[b + 11], 14, 643717713), p = md5gg(p, a, A, u, n[b], 20, -373897302), u = md5gg(u, p, a, A, n[b + 5], 5, -701558691), A = md5gg(A, u, p, a, n[b + 10], 9, 38016083), a = md5gg(a, A, u, p, n[b + 15], 14, -660478335), p = md5gg(p, a, A, u, n[b + 4], 20, -405537848), u = md5gg(u, p, a, A, n[b + 9], 5, 568446438), A = md5gg(A, u, p, a, n[b + 14], 9, -1019803690), a = md5gg(a, A, u, p, n[b + 3], 14, -187363961), p = md5gg(p, a, A, u, n[b + 8], 20, 1163531501), u = md5gg(u, p, a, A, n[b + 13], 5, -1444681467), A = md5gg(A, u, p, a, n[b + 2], 9, -51403784), a = md5gg(a, A, u, p, n[b + 7], 14, 1735328473), p = md5gg(p, a, A, u, n[b + 12], 20, -1926607734), u = md5hh(u, p, a, A, n[b + 5], 4, -378558), A = md5hh(A, u, p, a, n[b + 8], 11, -2022574463), a = md5hh(a, A, u, p, n[b + 11], 16, 1839030562), p = md5hh(p, a, A, u, n[b + 14], 23, -35309556), u = md5hh(u, p, a, A, n[b + 1], 4, -1530992060), A = md5hh(A, u, p, a, n[b + 4], 11, 1272893353), a = md5hh(a, A, u, p, n[b + 7], 16, -155497632), p = md5hh(p, a, A, u, n[b + 10], 23, -1094730640), u = md5hh(u, p, a, A, n[b + 13], 4, 681279174), A = md5hh(A, u, p, a, n[b], 11, -358537222), a = md5hh(a, A, u, p, n[b + 3], 16, -722521979), p = md5hh(p, a, A, u, n[b + 6], 23, 76029189), u = md5hh(u, p, a, A, n[b + 9], 4, -640364487), A = md5hh(A, u, p, a, n[b + 12], 11, -421815835), a = md5hh(a, A, u, p, n[b + 15], 16, 530742520), p = md5hh(p, a, A, u, n[b + 2], 23, -995338651), u = md5ii(u, p, a, A, n[b], 6, -198630844), A = md5ii(A, u, p, a, n[b + 7], 10, 1126891415), a = md5ii(a, A, u, p, n[b + 14], 15, -1416354905), p = md5ii(p, a, A, u, n[b + 5], 21, -57434055), u = md5ii(u, p, a, A, n[b + 12], 6, 1700485571), A = md5ii(A, u, p, a, n[b + 3], 10, -1894986606), a = md5ii(a, A, u, p, n[b + 10], 15, -1051523), p = md5ii(p, a, A, u, n[b + 1], 21, -2054922799), u = md5ii(u, p, a, A, n[b + 8], 6, 1873313359), A = md5ii(A, u, p, a, n[b + 15], 10, -30611744), a = md5ii(a, A, u, p, n[b + 6], 15, -1560198380), p = md5ii(p, a, A, u, n[b + 13], 21, 1309151649), u = md5ii(u, p, a, A, n[b + 4], 6, -145523070), A = md5ii(A, u, p, a, n[b + 11], 10, -1120210379), a = md5ii(a, A, u, p, n[b + 2], 15, 718787259), p = md5ii(p, a, A, u, n[b + 9], 21, -343485551), u = safeAdd(u, F), p = safeAdd(p, le), a = safeAdd(a, L), A = safeAdd(A, pe);
  }
  return [u, p, a, A];
}
function bytesToWords(n) {
  if (n.length === 0)
    return [];
  for (var c = n.length * 8, u = new Uint32Array(getOutputLength(c)), p = 0; p < c; p += 8)
    u[p >> 5] |= (n[p / 8] & 255) << p % 32;
  return u;
}
function safeAdd(n, c) {
  var u = (n & 65535) + (c & 65535), p = (n >> 16) + (c >> 16) + (u >> 16);
  return p << 16 | u & 65535;
}
function bitRotateLeft(n, c) {
  return n << c | n >>> 32 - c;
}
function md5cmn(n, c, u, p, a, A) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(c, n), safeAdd(p, A)), a), u);
}
function md5ff(n, c, u, p, a, A, b) {
  return md5cmn(c & u | ~c & p, n, c, a, A, b);
}
function md5gg(n, c, u, p, a, A, b) {
  return md5cmn(c & p | u & ~p, n, c, a, A, b);
}
function md5hh(n, c, u, p, a, A, b) {
  return md5cmn(c ^ u ^ p, n, c, a, A, b);
}
function md5ii(n, c, u, p, a, A, b) {
  return md5cmn(u ^ (c | ~p), n, c, a, A, b);
}
var v3 = v35("v3", 48, md5);
function v4$1(n, c, u) {
  n = n || {};
  var p = n.random || (n.rng || rng$1)();
  if (p[6] = p[6] & 15 | 64, p[8] = p[8] & 63 | 128, c) {
    u = u || 0;
    for (var a = 0; a < 16; ++a)
      c[u + a] = p[a];
    return c;
  }
  return stringify(p);
}
function f$2(n, c, u, p) {
  switch (n) {
    case 0:
      return c & u ^ ~c & p;
    case 1:
      return c ^ u ^ p;
    case 2:
      return c & u ^ c & p ^ u & p;
    case 3:
      return c ^ u ^ p;
  }
}
function ROTL(n, c) {
  return n << c | n >>> 32 - c;
}
function sha1(n) {
  var c = [1518500249, 1859775393, 2400959708, 3395469782], u = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
  if (typeof n == "string") {
    var p = unescape(encodeURIComponent(n));
    n = [];
    for (var a = 0; a < p.length; ++a)
      n.push(p.charCodeAt(a));
  } else Array.isArray(n) || (n = Array.prototype.slice.call(n));
  n.push(128);
  for (var A = n.length / 4 + 2, b = Math.ceil(A / 16), F = new Array(b), le = 0; le < b; ++le) {
    for (var L = new Uint32Array(16), pe = 0; pe < 16; ++pe)
      L[pe] = n[le * 64 + pe * 4] << 24 | n[le * 64 + pe * 4 + 1] << 16 | n[le * 64 + pe * 4 + 2] << 8 | n[le * 64 + pe * 4 + 3];
    F[le] = L;
  }
  F[b - 1][14] = (n.length - 1) * 8 / Math.pow(2, 32), F[b - 1][14] = Math.floor(F[b - 1][14]), F[b - 1][15] = (n.length - 1) * 8 & 4294967295;
  for (var $ = 0; $ < b; ++$) {
    for (var Ee = new Uint32Array(80), be = 0; be < 16; ++be)
      Ee[be] = F[$][be];
    for (var He = 16; He < 80; ++He)
      Ee[He] = ROTL(Ee[He - 3] ^ Ee[He - 8] ^ Ee[He - 14] ^ Ee[He - 16], 1);
    for (var Pe = u[0], nr = u[1], ir = u[2], or = u[3], lr = u[4], Ir = 0; Ir < 80; ++Ir) {
      var xr = Math.floor(Ir / 20), kr = ROTL(Pe, 5) + f$2(xr, nr, ir, or) + lr + c[xr] + Ee[Ir] >>> 0;
      lr = or, or = ir, ir = ROTL(nr, 30) >>> 0, nr = Pe, Pe = kr;
    }
    u[0] = u[0] + Pe >>> 0, u[1] = u[1] + nr >>> 0, u[2] = u[2] + ir >>> 0, u[3] = u[3] + or >>> 0, u[4] = u[4] + lr >>> 0;
  }
  return [u[0] >> 24 & 255, u[0] >> 16 & 255, u[0] >> 8 & 255, u[0] & 255, u[1] >> 24 & 255, u[1] >> 16 & 255, u[1] >> 8 & 255, u[1] & 255, u[2] >> 24 & 255, u[2] >> 16 & 255, u[2] >> 8 & 255, u[2] & 255, u[3] >> 24 & 255, u[3] >> 16 & 255, u[3] >> 8 & 255, u[3] & 255, u[4] >> 24 & 255, u[4] >> 16 & 255, u[4] >> 8 & 255, u[4] & 255];
}
var v5 = v35("v5", 80, sha1);
const nil = "00000000-0000-0000-0000-000000000000";
function version$1(n) {
  if (!validate$1(n))
    throw TypeError("Invalid UUID");
  return parseInt(n.substr(14, 1), 16);
}
const esmBrowser = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  NIL: nil,
  parse: parse$7,
  stringify,
  v1,
  v3,
  v4: v4$1,
  v5,
  validate: validate$1,
  version: version$1
}, Symbol.toStringTag, { value: "Module" })), require$$1 = /* @__PURE__ */ getAugmentedNamespace(esmBrowser);
var hasRequiredBcUrRegistryStellar_cjs_production_min;
function requireBcUrRegistryStellar_cjs_production_min() {
  return hasRequiredBcUrRegistryStellar_cjs_production_min || (hasRequiredBcUrRegistryStellar_cjs_production_min = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 });
    var c = requireDist(), u = require$$1;
    const p = { STELLAR_SIGN_REQUEST: new c.RegistryType("stellar-sign-request", 8201), STELLAR_SIGNATURE: new c.RegistryType("stellar-signature", 8202) }, { decodeToDataItem: a, RegistryTypes: A } = c.extend;
    var b, F;
    (b = n.SignType || (n.SignType = {}))[b.Transaction = 1] = "Transaction", b[b.TransactionHash = 2] = "TransactionHash", b[b.Message = 3] = "Message", function(be) {
      be[be.requestId = 1] = "requestId", be[be.signData = 2] = "signData", be[be.derivationPath = 3] = "derivationPath", be[be.address = 4] = "address", be[be.origin = 5] = "origin", be[be.signType = 6] = "signType";
    }(F || (F = {}));
    class le extends c.RegistryItem {
      constructor(He) {
        super(), this.getRegistryType = () => p.STELLAR_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDerivationPath = () => this.derivationPath.getPath(), this.getSignRequestAddress = () => this.address, this.getOrigin = () => this.origin, this.getSignType = () => this.signType, this.toDataItem = () => {
          const Pe = {};
          this.requestId && (Pe[F.requestId] = new c.DataItem(this.requestId, A.UUID.getTag())), this.address && (Pe[F.address] = this.address), this.origin && (Pe[F.origin] = this.origin), Pe[F.signData] = this.signData, Pe[F.signType] = this.signType;
          const nr = this.derivationPath.toDataItem();
          return nr.setTag(this.derivationPath.getRegistryType().getTag()), Pe[F.derivationPath] = nr, new c.DataItem(Pe);
        }, this.requestId = He.requestId, this.signData = He.signData, this.derivationPath = He.derivationPath, this.address = He.address, this.origin = He.origin, this.signType = He.signType;
      }
      static constructStellarRequest(He, Pe, nr, ir, or, lr, Ir) {
        const xr = Pe.replace(/[m|M]\//, "").split("/"), kr = new c.CryptoKeypath(xr.map((Ce) => {
          const tr = parseInt(Ce.replace("'", ""));
          let Fe = !1;
          return Ce.endsWith("'") && (Fe = !0), new c.PathComponent({ index: tr, hardened: Fe });
        }), Buffer$f.from(nr, "hex"));
        return new le({ requestId: or ? Buffer$f.from(u.parse(or)) : void 0, signData: He, derivationPath: kr, address: lr ? Buffer$f.from(lr.replace("0x", ""), "hex") : void 0, origin: Ir || void 0, signType: ir });
      }
    }
    le.fromDataItem = (be) => {
      const He = be.getData(), Pe = He[F.signData], nr = c.CryptoKeypath.fromDataItem(He[F.derivationPath]), ir = He[F.address] ? He[F.address] : void 0, or = He[F.requestId] ? He[F.requestId].getData() : void 0;
      return new le({ requestId: or, signData: Pe, derivationPath: nr, address: ir, origin: He[F.origin] ? He[F.origin] : void 0, signType: He[F.signType] });
    }, le.fromCBOR = (be) => {
      const He = a(be);
      return le.fromDataItem(He);
    };
    const { RegistryTypes: L, decodeToDataItem: pe } = c.extend;
    var $;
    (function(be) {
      be[be.requestId = 1] = "requestId", be[be.signature = 2] = "signature";
    })($ || ($ = {}));
    class Ee extends c.RegistryItem {
      constructor(He, Pe) {
        super(), this.getRegistryType = () => p.STELLAR_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.toDataItem = () => {
          const nr = {};
          return this.requestId && (nr[$.requestId] = new c.DataItem(this.requestId, L.UUID.getTag())), nr[$.signature] = this.signature, new c.DataItem(nr);
        }, this.signature = He, this.requestId = Pe;
      }
    }
    Ee.fromDataItem = (be) => {
      const He = be.getData(), Pe = He[$.signature], nr = He[$.requestId] ? He[$.requestId].getData() : void 0;
      return new Ee(Pe, nr);
    }, Ee.fromCBOR = (be) => {
      const He = pe(be);
      return Ee.fromDataItem(He);
    }, c.patchTags(Object.values(p).filter((be) => !!be.getTag()).map((be) => be.getTag())), Object.keys(c).forEach(function(be) {
      be !== "default" && Object.defineProperty(n, be, { enumerable: !0, get: function() {
        return c[be];
      } });
    }), n.StellarSignRequest = le, n.StellarSignature = Ee;
  }(bcUrRegistryStellar_cjs_production_min)), bcUrRegistryStellar_cjs_production_min;
}
var bcUrRegistryStellar_cjs_development = {}, hasRequiredBcUrRegistryStellar_cjs_development;
function requireBcUrRegistryStellar_cjs_development() {
  return hasRequiredBcUrRegistryStellar_cjs_development || (hasRequiredBcUrRegistryStellar_cjs_development = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 });
    var c = requireDist(), u = require$$1;
    const p = {
      STELLAR_SIGN_REQUEST: /* @__PURE__ */ new c.RegistryType("stellar-sign-request", 8201),
      STELLAR_SIGNATURE: /* @__PURE__ */ new c.RegistryType("stellar-signature", 8202)
    }, {
      decodeToDataItem: a,
      RegistryTypes: A
    } = c.extend;
    (function(Ee) {
      Ee[Ee.Transaction = 1] = "Transaction", Ee[Ee.TransactionHash = 2] = "TransactionHash", Ee[Ee.Message = 3] = "Message";
    })(n.SignType || (n.SignType = {}));
    var b;
    (function(Ee) {
      Ee[Ee.requestId = 1] = "requestId", Ee[Ee.signData = 2] = "signData", Ee[Ee.derivationPath = 3] = "derivationPath", Ee[Ee.address = 4] = "address", Ee[Ee.origin = 5] = "origin", Ee[Ee.signType = 6] = "signType";
    })(b || (b = {}));
    class F extends c.RegistryItem {
      constructor(be) {
        super(), this.getRegistryType = () => p.STELLAR_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDerivationPath = () => this.derivationPath.getPath(), this.getSignRequestAddress = () => this.address, this.getOrigin = () => this.origin, this.getSignType = () => this.signType, this.toDataItem = () => {
          const He = {};
          this.requestId && (He[b.requestId] = new c.DataItem(this.requestId, A.UUID.getTag())), this.address && (He[b.address] = this.address), this.origin && (He[b.origin] = this.origin), He[b.signData] = this.signData, He[b.signType] = this.signType;
          const Pe = this.derivationPath.toDataItem();
          return Pe.setTag(this.derivationPath.getRegistryType().getTag()), He[b.derivationPath] = Pe, new c.DataItem(He);
        }, this.requestId = be.requestId, this.signData = be.signData, this.derivationPath = be.derivationPath, this.address = be.address, this.origin = be.origin, this.signType = be.signType;
      }
      static constructStellarRequest(be, He, Pe, nr, ir, or, lr) {
        const Ir = He.replace(/[m|M]\//, "").split("/"), xr = new c.CryptoKeypath(Ir.map((kr) => {
          const Ce = parseInt(kr.replace("'", ""));
          let tr = !1;
          return kr.endsWith("'") && (tr = !0), new c.PathComponent({
            index: Ce,
            hardened: tr
          });
        }), Buffer$f.from(Pe, "hex"));
        return new F({
          requestId: ir ? Buffer$f.from(u.parse(ir)) : void 0,
          signData: be,
          derivationPath: xr,
          address: or ? Buffer$f.from(or.replace("0x", ""), "hex") : void 0,
          origin: lr || void 0,
          signType: nr
        });
      }
    }
    F.fromDataItem = (Ee) => {
      const be = Ee.getData(), He = be[b.signData], Pe = c.CryptoKeypath.fromDataItem(be[b.derivationPath]), nr = be[b.address] ? be[b.address] : void 0, ir = be[b.requestId] ? be[b.requestId].getData() : void 0, or = be[b.origin] ? be[b.origin] : void 0, lr = be[b.signType];
      return new F({
        requestId: ir,
        signData: He,
        derivationPath: Pe,
        address: nr,
        origin: or,
        signType: lr
      });
    }, F.fromCBOR = (Ee) => {
      const be = a(Ee);
      return F.fromDataItem(be);
    };
    const {
      RegistryTypes: le,
      decodeToDataItem: L
    } = c.extend;
    var pe;
    (function(Ee) {
      Ee[Ee.requestId = 1] = "requestId", Ee[Ee.signature = 2] = "signature";
    })(pe || (pe = {}));
    class $ extends c.RegistryItem {
      constructor(be, He) {
        super(), this.getRegistryType = () => p.STELLAR_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.toDataItem = () => {
          const Pe = {};
          return this.requestId && (Pe[pe.requestId] = new c.DataItem(this.requestId, le.UUID.getTag())), Pe[pe.signature] = this.signature, new c.DataItem(Pe);
        }, this.signature = be, this.requestId = He;
      }
    }
    $.fromDataItem = (Ee) => {
      const be = Ee.getData(), He = be[pe.signature], Pe = be[pe.requestId] ? be[pe.requestId].getData() : void 0;
      return new $(He, Pe);
    }, $.fromCBOR = (Ee) => {
      const be = L(Ee);
      return $.fromDataItem(be);
    }, c.patchTags(Object.values(p).filter((Ee) => !!Ee.getTag()).map((Ee) => Ee.getTag())), Object.keys(c).forEach(function(Ee) {
      Ee !== "default" && Object.defineProperty(n, Ee, {
        enumerable: !0,
        get: function() {
          return c[Ee];
        }
      });
    }), n.StellarSignRequest = F, n.StellarSignature = $;
  }(bcUrRegistryStellar_cjs_development)), bcUrRegistryStellar_cjs_development;
}
process$1.env.NODE_ENV === "production" ? dist$5.exports = requireBcUrRegistryStellar_cjs_production_min() : dist$5.exports = requireBcUrRegistryStellar_cjs_development();
var distExports = dist$5.exports;
Object.defineProperty(stellar, "__esModule", { value: !0 });
stellar.KeystoneStellarSDK = void 0;
const utils_1$a = utils$K, ur_1 = ur, bc_ur_registry_stellar_1 = distExports;
class KeystoneStellarSDK {
  parseSignature(c) {
    if (c.type !== ur_1.URType.StellarSignature)
      throw new Error("type not match");
    const u = bc_ur_registry_stellar_1.StellarSignature.fromCBOR(c.cbor), p = u.getRequestId();
    return {
      requestId: p === void 0 ? void 0 : (0, utils_1$a.uuidStringify)(p),
      signature: (0, utils_1$a.toHex)(u.getSignature())
    };
  }
  generateSignRequest({ requestId: c, signData: u, dataType: p, path: a, xfp: A, address: b, origin: F }) {
    return new bc_ur_registry_stellar_1.StellarSignRequest({
      requestId: (0, utils_1$a.uuidParse)(c),
      signData: (0, utils_1$a.toBuffer)(u),
      signType: p,
      derivationPath: new bc_ur_registry_stellar_1.CryptoKeypath((0, utils_1$a.parsePath)(a).map((le) => new bc_ur_registry_stellar_1.PathComponent(le)), (0, utils_1$a.toBuffer)(A)),
      address: b !== void 0 ? (0, utils_1$a.toBuffer)(b) : void 0,
      origin: F
    }).toUR();
  }
}
KeystoneStellarSDK.DataType = bc_ur_registry_stellar_1.SignType;
stellar.KeystoneStellarSDK = KeystoneStellarSDK;
(function(n) {
  var c = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(p, a, A, b) {
    b === void 0 && (b = A);
    var F = Object.getOwnPropertyDescriptor(a, A);
    (!F || ("get" in F ? !a.__esModule : F.writable || F.configurable)) && (F = { enumerable: !0, get: function() {
      return a[A];
    } }), Object.defineProperty(p, b, F);
  } : function(p, a, A, b) {
    b === void 0 && (b = A), p[b] = a[A];
  }), u = commonjsGlobal && commonjsGlobal.__exportStar || function(p, a) {
    for (var A in p) A !== "default" && !Object.prototype.hasOwnProperty.call(a, A) && c(a, p, A);
  };
  Object.defineProperty(n, "__esModule", { value: !0 }), u(bitcoin$1, n), u(cosmos, n), u(evm, n), u(ethereum$2, n), u(solana, n), u(tron, n), u(aptos, n), u(bitcoin_cash, n), u(dash, n), u(litecoin, n), u(near, n), u(cardano, n), u(arweave, n), u(sui, n), u(ton, n), u(stellar, n);
})(chains);
var wallet$1 = {}, hardwareCall = {};
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.generateKeyDerivationCall = n.QRHardwareCallVersion = n.DerivationAlgorithm = n.Curve = void 0;
  const c = requireDist$c();
  Object.defineProperty(n, "Curve", { enumerable: !0, get: function() {
    return c.Curve;
  } }), Object.defineProperty(n, "DerivationAlgorithm", { enumerable: !0, get: function() {
    return c.DerivationAlgorithm;
  } }), Object.defineProperty(n, "QRHardwareCallVersion", { enumerable: !0, get: function() {
    return c.QRHardwareCallVersion;
  } });
  const u = utils$K, p = ({ schemas: a, origin: A, version: b }) => {
    const F = a.map(({ path: pe, curve: $ = c.Curve.secp256k1, algo: Ee = c.DerivationAlgorithm.slip10, chainType: be }) => {
      if ($ === c.Curve.secp256k1 && Ee === c.DerivationAlgorithm.bip32ed25519)
        throw new Error("the combination of the given curve and algo not supported");
      return new c.KeyDerivationSchema((0, u.pathToKeypath)(pe), $, Ee, be);
    }), le = new c.KeyDerivation(F);
    return new c.QRHardwareCall(c.QRHardwareCallType.KeyDerivation, le, A, b ? c.QRHardwareCallVersion.V1 : c.QRHardwareCallVersion.V0).toUR();
  };
  n.generateKeyDerivationCall = p;
})(hardwareCall);
var multiAccounts = {}, types$4 = {}, account$1 = {};
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.AccountNote = void 0, function(c) {
    c.Standard = "account.standard", c.LedgerLegacy = "account.ledger_legacy", c.LedgerLive = "account.ledger_live";
  }(n.AccountNote || (n.AccountNote = {}));
})(account$1);
var props = {};
Object.defineProperty(props, "__esModule", { value: !0 });
var signature = {};
Object.defineProperty(signature, "__esModule", { value: !0 });
var token = {};
Object.defineProperty(token, "__esModule", { value: !0 });
var config = {};
Object.defineProperty(config, "__esModule", { value: !0 });
(function(n) {
  var c = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(p, a, A, b) {
    b === void 0 && (b = A);
    var F = Object.getOwnPropertyDescriptor(a, A);
    (!F || ("get" in F ? !a.__esModule : F.writable || F.configurable)) && (F = { enumerable: !0, get: function() {
      return a[A];
    } }), Object.defineProperty(p, b, F);
  } : function(p, a, A, b) {
    b === void 0 && (b = A), p[b] = a[A];
  }), u = commonjsGlobal && commonjsGlobal.__exportStar || function(p, a) {
    for (var A in p) A !== "default" && !Object.prototype.hasOwnProperty.call(a, A) && c(a, p, A);
  };
  Object.defineProperty(n, "__esModule", { value: !0 }), u(account$1, n), u(props, n), u(signature, n), u(token, n), u(ur, n), u(config, n);
})(types$4);
var accountHelper = {};
Object.defineProperty(accountHelper, "__esModule", { value: !0 });
accountHelper.generateExtraData = void 0;
const OKX_CHAIN_ID = {
  60: 1
  // ETH
}, generateExtraData = (n) => {
  var c;
  return {
    okx: {
      chainId: (c = OKX_CHAIN_ID[n]) !== null && c !== void 0 ? c : n
    }
  };
};
accountHelper.generateExtraData = generateExtraData;
Object.defineProperty(multiAccounts, "__esModule", { value: !0 });
multiAccounts.parseMultiAccounts = void 0;
const types_1$6 = types$4, bc_ur_registry_1$2 = requireDist$c(), utils_1$9 = utils$K, accountHelper_1$2 = accountHelper, parseMultiAccounts = (n) => {
  if (n.type !== types_1$6.URType.CryptoMultiAccounts)
    throw new Error("type not match");
  const c = bc_ur_registry_1$2.CryptoMultiAccounts.fromCBOR(n.cbor), u = (0, utils_1$9.toHex)(c.getMasterFingerprint());
  return {
    device: c.getDevice(),
    masterFingerprint: u,
    keys: c.getKeys().map((p) => {
      const a = (0, utils_1$9.toHex)(p.getChainCode()), A = (0, utils_1$9.toHex)(p.getParentFingerprint()), b = p.getOrigin();
      if (b === void 0)
        throw new Error("multi accounts is invalid");
      let F;
      a.length !== 0 && A.length !== 0 && (F = p.getBip32Key());
      const le = b.getComponents()[1].getIndex();
      return {
        chain: (0, utils_1$9.getCoinSymbol)(le),
        path: `m/${b.getPath()}`,
        publicKey: (0, utils_1$9.toHex)(p.getKey()),
        name: p.getName(),
        chainCode: a,
        extendedPublicKey: F,
        note: p.getNote(),
        extra: (0, accountHelper_1$2.generateExtraData)(le)
      };
    }),
    deviceId: c.getDeviceId(),
    deviceVersion: c.getVersion()
  };
};
multiAccounts.parseMultiAccounts = parseMultiAccounts;
var hdKey = {};
Object.defineProperty(hdKey, "__esModule", { value: !0 });
hdKey.parseTonAccount = hdKey.parseHDKey = void 0;
const types_1$5 = types$4, bc_ur_registry_1$1 = requireDist$c(), utils_1$8 = utils$K, accountHelper_1$1 = accountHelper, parseHDKey = (n) => {
  var c;
  if (n.type !== types_1$5.URType.CryptoHDKey)
    throw new Error("type not match");
  const u = bc_ur_registry_1$1.CryptoHDKey.fromCBOR(n.cbor), p = (0, utils_1$8.toHex)(u.getChainCode()), a = (0, utils_1$8.toHex)(u.getParentFingerprint()), A = u.getOrigin();
  if (((c = u.getOrigin().getSourceFingerprint()) === null || c === void 0 ? void 0 : c.toString("hex")) === void 0)
    throw new Error("HDKey is invalid");
  let F;
  p.length !== 0 && a.length !== 0 && (F = u.getBip32Key());
  const le = A.getComponents()[1].getIndex();
  return {
    chain: (0, utils_1$8.getCoinSymbol)(le),
    path: `m/${A.getPath()}`,
    publicKey: (0, utils_1$8.toHex)(u.getKey()),
    name: u.getName(),
    xfp: A.getSourceFingerprint().toString("hex"),
    chainCode: p,
    extendedPublicKey: F,
    note: u.getNote(),
    extra: (0, accountHelper_1$1.generateExtraData)(le)
  };
};
hdKey.parseHDKey = parseHDKey;
const parseTonAccount = (n) => {
  var c;
  if (n.type !== types_1$5.URType.CryptoHDKey)
    throw new Error("type not match");
  const u = bc_ur_registry_1$1.CryptoHDKey.fromCBOR(n.cbor), p = u.getOrigin();
  if (p) {
    if (((c = u.getOrigin().getSourceFingerprint()) === null || c === void 0 ? void 0 : c.toString("hex")) === void 0)
      throw new Error("HDKey is invalid");
    return {
      path: `m/${p.getPath()}`,
      publicKey: (0, utils_1$8.toHex)(u.getKey()),
      name: u.getName(),
      xfp: p.getSourceFingerprint().toString("hex")
    };
  } else
    return {
      publicKey: (0, utils_1$8.toHex)(u.getKey()),
      name: u.getName()
    };
};
hdKey.parseTonAccount = parseTonAccount;
var account = {};
Object.defineProperty(account, "__esModule", { value: !0 });
account.parseAccount = void 0;
const types_1$4 = types$4, bc_ur_registry_1 = requireDist$c(), utils_1$7 = utils$K, accountHelper_1 = accountHelper, parseAccount = (n) => {
  if (n.type !== types_1$4.URType.CryptoAccount)
    throw new Error("type not match");
  const c = bc_ur_registry_1.CryptoAccount.fromCBOR(n.cbor), u = (0, utils_1$7.toHex)(c.getMasterFingerprint()), p = [];
  return c.getOutputDescriptors().forEach((a) => {
    if (a.getRegistryType() !== bc_ur_registry_1.RegistryTypes.CRYPTO_HDKEY) {
      const A = a.getCryptoKey(), b = (0, utils_1$7.toHex)(A.getChainCode()), F = (0, utils_1$7.toHex)(A.getParentFingerprint()), le = A.getOrigin();
      if (le === void 0)
        throw new Error("account is invalid");
      let L;
      b.length !== 0 && F.length !== 0 && (L = A.getBip32Key());
      const pe = le.getComponents()[1].getIndex();
      p.push({
        chain: (0, utils_1$7.getCoinSymbol)(pe),
        path: `m/${le.getPath()}`,
        publicKey: (0, utils_1$7.toHex)(A.getKey()),
        name: A.getName(),
        chainCode: b,
        extendedPublicKey: L,
        note: A.getNote(),
        extra: (0, accountHelper_1.generateExtraData)(pe)
      });
    }
  }), {
    masterFingerprint: u,
    keys: p
  };
};
account.parseAccount = parseAccount;
(function(n) {
  var c = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(p, a, A, b) {
    b === void 0 && (b = A);
    var F = Object.getOwnPropertyDescriptor(a, A);
    (!F || ("get" in F ? !a.__esModule : F.writable || F.configurable)) && (F = { enumerable: !0, get: function() {
      return a[A];
    } }), Object.defineProperty(p, b, F);
  } : function(p, a, A, b) {
    b === void 0 && (b = A), p[b] = a[A];
  }), u = commonjsGlobal && commonjsGlobal.__exportStar || function(p, a) {
    for (var A in p) A !== "default" && !Object.prototype.hasOwnProperty.call(a, A) && c(a, p, A);
  };
  Object.defineProperty(n, "__esModule", { value: !0 }), u(hardwareCall, n), u(multiAccounts, n), u(hdKey, n), u(account, n);
})(wallet$1);
var xrp$1 = {}, xrp = {}, dist$3 = {}, coretypes = {}, enums = {};
const TYPES = {
  Done: -1,
  Unknown: -2,
  NotPresent: 0,
  UInt16: 1,
  UInt32: 2,
  UInt64: 3,
  Hash128: 4,
  Hash256: 5,
  Amount: 6,
  Blob: 7,
  AccountID: 8,
  STObject: 14,
  STArray: 15,
  UInt8: 16,
  Hash160: 17,
  PathSet: 18,
  Vector256: 19,
  UInt96: 20,
  UInt192: 21,
  UInt384: 22,
  UInt512: 23,
  Issue: 24,
  XChainBridge: 25,
  Transaction: 10001,
  LedgerEntry: 10002,
  Validation: 10003,
  Metadata: 10004
}, LEDGER_ENTRY_TYPES = {
  Invalid: -1,
  AccountRoot: 97,
  DirectoryNode: 100,
  RippleState: 114,
  Ticket: 84,
  SignerList: 83,
  Offer: 111,
  Bridge: 105,
  LedgerHashes: 104,
  Amendments: 102,
  XChainOwnedClaimID: 113,
  XChainOwnedCreateAccountClaimID: 116,
  FeeSettings: 115,
  Escrow: 117,
  PayChannel: 120,
  Check: 67,
  DepositPreauth: 112,
  NegativeUNL: 78,
  NFTokenPage: 80,
  NFTokenOffer: 55,
  AMM: 121,
  DID: 73,
  Any: -3,
  Child: -2,
  Nickname: 110,
  Contract: 99,
  GeneratorMap: 103
}, FIELDS = [
  [
    "Generic",
    {
      nth: 0,
      isVLEncoded: !1,
      isSerialized: !1,
      isSigningField: !1,
      type: "Unknown"
    }
  ],
  [
    "Invalid",
    {
      nth: -1,
      isVLEncoded: !1,
      isSerialized: !1,
      isSigningField: !1,
      type: "Unknown"
    }
  ],
  [
    "ObjectEndMarker",
    {
      nth: 1,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "STObject"
    }
  ],
  [
    "ArrayEndMarker",
    {
      nth: 1,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "STArray"
    }
  ],
  [
    "hash",
    {
      nth: 257,
      isVLEncoded: !1,
      isSerialized: !1,
      isSigningField: !1,
      type: "Hash256"
    }
  ],
  [
    "index",
    {
      nth: 258,
      isVLEncoded: !1,
      isSerialized: !1,
      isSigningField: !1,
      type: "Hash256"
    }
  ],
  [
    "taker_gets_funded",
    {
      nth: 258,
      isVLEncoded: !1,
      isSerialized: !1,
      isSigningField: !1,
      type: "Amount"
    }
  ],
  [
    "taker_pays_funded",
    {
      nth: 259,
      isVLEncoded: !1,
      isSerialized: !1,
      isSigningField: !1,
      type: "Amount"
    }
  ],
  [
    "LedgerEntry",
    {
      nth: 257,
      isVLEncoded: !1,
      isSerialized: !1,
      isSigningField: !1,
      type: "LedgerEntry"
    }
  ],
  [
    "Transaction",
    {
      nth: 257,
      isVLEncoded: !1,
      isSerialized: !1,
      isSigningField: !1,
      type: "Transaction"
    }
  ],
  [
    "Validation",
    {
      nth: 257,
      isVLEncoded: !1,
      isSerialized: !1,
      isSigningField: !1,
      type: "Validation"
    }
  ],
  [
    "Metadata",
    {
      nth: 257,
      isVLEncoded: !1,
      isSerialized: !1,
      isSigningField: !1,
      type: "Metadata"
    }
  ],
  [
    "CloseResolution",
    {
      nth: 1,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt8"
    }
  ],
  [
    "Method",
    {
      nth: 2,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt8"
    }
  ],
  [
    "TransactionResult",
    {
      nth: 3,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt8"
    }
  ],
  [
    "TickSize",
    {
      nth: 16,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt8"
    }
  ],
  [
    "UNLModifyDisabling",
    {
      nth: 17,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt8"
    }
  ],
  [
    "HookResult",
    {
      nth: 18,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt8"
    }
  ],
  [
    "WasLockingChainSend",
    {
      nth: 19,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt8"
    }
  ],
  [
    "LedgerEntryType",
    {
      nth: 1,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt16"
    }
  ],
  [
    "TransactionType",
    {
      nth: 2,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt16"
    }
  ],
  [
    "SignerWeight",
    {
      nth: 3,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt16"
    }
  ],
  [
    "TransferFee",
    {
      nth: 4,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt16"
    }
  ],
  [
    "TradingFee",
    {
      nth: 5,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt16"
    }
  ],
  [
    "DiscountedFee",
    {
      nth: 6,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt16"
    }
  ],
  [
    "Version",
    {
      nth: 16,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt16"
    }
  ],
  [
    "HookStateChangeCount",
    {
      nth: 17,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt16"
    }
  ],
  [
    "HookEmitCount",
    {
      nth: 18,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt16"
    }
  ],
  [
    "HookExecutionIndex",
    {
      nth: 19,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt16"
    }
  ],
  [
    "HookApiVersion",
    {
      nth: 20,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt16"
    }
  ],
  [
    "NetworkID",
    {
      nth: 1,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt32"
    }
  ],
  [
    "Flags",
    {
      nth: 2,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt32"
    }
  ],
  [
    "SourceTag",
    {
      nth: 3,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt32"
    }
  ],
  [
    "Sequence",
    {
      nth: 4,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt32"
    }
  ],
  [
    "PreviousTxnLgrSeq",
    {
      nth: 5,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt32"
    }
  ],
  [
    "LedgerSequence",
    {
      nth: 6,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt32"
    }
  ],
  [
    "CloseTime",
    {
      nth: 7,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt32"
    }
  ],
  [
    "ParentCloseTime",
    {
      nth: 8,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt32"
    }
  ],
  [
    "SigningTime",
    {
      nth: 9,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt32"
    }
  ],
  [
    "Expiration",
    {
      nth: 10,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt32"
    }
  ],
  [
    "TransferRate",
    {
      nth: 11,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt32"
    }
  ],
  [
    "WalletSize",
    {
      nth: 12,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt32"
    }
  ],
  [
    "OwnerCount",
    {
      nth: 13,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt32"
    }
  ],
  [
    "DestinationTag",
    {
      nth: 14,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt32"
    }
  ],
  [
    "HighQualityIn",
    {
      nth: 16,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt32"
    }
  ],
  [
    "HighQualityOut",
    {
      nth: 17,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt32"
    }
  ],
  [
    "LowQualityIn",
    {
      nth: 18,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt32"
    }
  ],
  [
    "LowQualityOut",
    {
      nth: 19,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt32"
    }
  ],
  [
    "QualityIn",
    {
      nth: 20,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt32"
    }
  ],
  [
    "QualityOut",
    {
      nth: 21,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt32"
    }
  ],
  [
    "StampEscrow",
    {
      nth: 22,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt32"
    }
  ],
  [
    "BondAmount",
    {
      nth: 23,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt32"
    }
  ],
  [
    "LoadFee",
    {
      nth: 24,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt32"
    }
  ],
  [
    "OfferSequence",
    {
      nth: 25,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt32"
    }
  ],
  [
    "FirstLedgerSequence",
    {
      nth: 26,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt32"
    }
  ],
  [
    "LastLedgerSequence",
    {
      nth: 27,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt32"
    }
  ],
  [
    "TransactionIndex",
    {
      nth: 28,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt32"
    }
  ],
  [
    "OperationLimit",
    {
      nth: 29,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt32"
    }
  ],
  [
    "ReferenceFeeUnits",
    {
      nth: 30,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt32"
    }
  ],
  [
    "ReserveBase",
    {
      nth: 31,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt32"
    }
  ],
  [
    "ReserveIncrement",
    {
      nth: 32,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt32"
    }
  ],
  [
    "SetFlag",
    {
      nth: 33,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt32"
    }
  ],
  [
    "ClearFlag",
    {
      nth: 34,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt32"
    }
  ],
  [
    "SignerQuorum",
    {
      nth: 35,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt32"
    }
  ],
  [
    "CancelAfter",
    {
      nth: 36,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt32"
    }
  ],
  [
    "FinishAfter",
    {
      nth: 37,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt32"
    }
  ],
  [
    "SignerListID",
    {
      nth: 38,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt32"
    }
  ],
  [
    "SettleDelay",
    {
      nth: 39,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt32"
    }
  ],
  [
    "TicketCount",
    {
      nth: 40,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt32"
    }
  ],
  [
    "TicketSequence",
    {
      nth: 41,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt32"
    }
  ],
  [
    "NFTokenTaxon",
    {
      nth: 42,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt32"
    }
  ],
  [
    "MintedNFTokens",
    {
      nth: 43,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt32"
    }
  ],
  [
    "BurnedNFTokens",
    {
      nth: 44,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt32"
    }
  ],
  [
    "HookStateCount",
    {
      nth: 45,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt32"
    }
  ],
  [
    "EmitGeneration",
    {
      nth: 46,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt32"
    }
  ],
  [
    "VoteWeight",
    {
      nth: 48,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt32"
    }
  ],
  [
    "FirstNFTokenSequence",
    {
      nth: 50,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt32"
    }
  ],
  [
    "IndexNext",
    {
      nth: 1,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt64"
    }
  ],
  [
    "IndexPrevious",
    {
      nth: 2,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt64"
    }
  ],
  [
    "BookNode",
    {
      nth: 3,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt64"
    }
  ],
  [
    "OwnerNode",
    {
      nth: 4,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt64"
    }
  ],
  [
    "BaseFee",
    {
      nth: 5,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt64"
    }
  ],
  [
    "ExchangeRate",
    {
      nth: 6,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt64"
    }
  ],
  [
    "LowNode",
    {
      nth: 7,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt64"
    }
  ],
  [
    "HighNode",
    {
      nth: 8,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt64"
    }
  ],
  [
    "DestinationNode",
    {
      nth: 9,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt64"
    }
  ],
  [
    "Cookie",
    {
      nth: 10,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt64"
    }
  ],
  [
    "ServerVersion",
    {
      nth: 11,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt64"
    }
  ],
  [
    "NFTokenOfferNode",
    {
      nth: 12,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt64"
    }
  ],
  [
    "EmitBurden",
    {
      nth: 13,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt64"
    }
  ],
  [
    "HookOn",
    {
      nth: 16,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt64"
    }
  ],
  [
    "HookInstructionCount",
    {
      nth: 17,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt64"
    }
  ],
  [
    "HookReturnCode",
    {
      nth: 18,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt64"
    }
  ],
  [
    "ReferenceCount",
    {
      nth: 19,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt64"
    }
  ],
  [
    "XChainClaimID",
    {
      nth: 20,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt64"
    }
  ],
  [
    "XChainAccountCreateCount",
    {
      nth: 21,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt64"
    }
  ],
  [
    "XChainAccountClaimCount",
    {
      nth: 22,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "UInt64"
    }
  ],
  [
    "EmailHash",
    {
      nth: 1,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Hash128"
    }
  ],
  [
    "TakerPaysCurrency",
    {
      nth: 1,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Hash160"
    }
  ],
  [
    "TakerPaysIssuer",
    {
      nth: 2,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Hash160"
    }
  ],
  [
    "TakerGetsCurrency",
    {
      nth: 3,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Hash160"
    }
  ],
  [
    "TakerGetsIssuer",
    {
      nth: 4,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Hash160"
    }
  ],
  [
    "LedgerHash",
    {
      nth: 1,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Hash256"
    }
  ],
  [
    "ParentHash",
    {
      nth: 2,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Hash256"
    }
  ],
  [
    "TransactionHash",
    {
      nth: 3,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Hash256"
    }
  ],
  [
    "AccountHash",
    {
      nth: 4,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Hash256"
    }
  ],
  [
    "PreviousTxnID",
    {
      nth: 5,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Hash256"
    }
  ],
  [
    "LedgerIndex",
    {
      nth: 6,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Hash256"
    }
  ],
  [
    "WalletLocator",
    {
      nth: 7,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Hash256"
    }
  ],
  [
    "RootIndex",
    {
      nth: 8,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Hash256"
    }
  ],
  [
    "AccountTxnID",
    {
      nth: 9,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Hash256"
    }
  ],
  [
    "NFTokenID",
    {
      nth: 10,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Hash256"
    }
  ],
  [
    "EmitParentTxnID",
    {
      nth: 11,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Hash256"
    }
  ],
  [
    "EmitNonce",
    {
      nth: 12,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Hash256"
    }
  ],
  [
    "EmitHookHash",
    {
      nth: 13,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Hash256"
    }
  ],
  [
    "AMMID",
    {
      nth: 14,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Hash256"
    }
  ],
  [
    "BookDirectory",
    {
      nth: 16,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Hash256"
    }
  ],
  [
    "InvoiceID",
    {
      nth: 17,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Hash256"
    }
  ],
  [
    "Nickname",
    {
      nth: 18,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Hash256"
    }
  ],
  [
    "Amendment",
    {
      nth: 19,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Hash256"
    }
  ],
  [
    "Digest",
    {
      nth: 21,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Hash256"
    }
  ],
  [
    "Channel",
    {
      nth: 22,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Hash256"
    }
  ],
  [
    "ConsensusHash",
    {
      nth: 23,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Hash256"
    }
  ],
  [
    "CheckID",
    {
      nth: 24,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Hash256"
    }
  ],
  [
    "ValidatedHash",
    {
      nth: 25,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Hash256"
    }
  ],
  [
    "PreviousPageMin",
    {
      nth: 26,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Hash256"
    }
  ],
  [
    "NextPageMin",
    {
      nth: 27,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Hash256"
    }
  ],
  [
    "NFTokenBuyOffer",
    {
      nth: 28,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Hash256"
    }
  ],
  [
    "NFTokenSellOffer",
    {
      nth: 29,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Hash256"
    }
  ],
  [
    "HookStateKey",
    {
      nth: 30,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Hash256"
    }
  ],
  [
    "HookHash",
    {
      nth: 31,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Hash256"
    }
  ],
  [
    "HookNamespace",
    {
      nth: 32,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Hash256"
    }
  ],
  [
    "HookSetTxnID",
    {
      nth: 33,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Hash256"
    }
  ],
  [
    "Amount",
    {
      nth: 1,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Amount"
    }
  ],
  [
    "Balance",
    {
      nth: 2,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Amount"
    }
  ],
  [
    "LimitAmount",
    {
      nth: 3,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Amount"
    }
  ],
  [
    "TakerPays",
    {
      nth: 4,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Amount"
    }
  ],
  [
    "TakerGets",
    {
      nth: 5,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Amount"
    }
  ],
  [
    "LowLimit",
    {
      nth: 6,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Amount"
    }
  ],
  [
    "HighLimit",
    {
      nth: 7,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Amount"
    }
  ],
  [
    "Fee",
    {
      nth: 8,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Amount"
    }
  ],
  [
    "SendMax",
    {
      nth: 9,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Amount"
    }
  ],
  [
    "DeliverMin",
    {
      nth: 10,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Amount"
    }
  ],
  [
    "Amount2",
    {
      nth: 11,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Amount"
    }
  ],
  [
    "BidMin",
    {
      nth: 12,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Amount"
    }
  ],
  [
    "BidMax",
    {
      nth: 13,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Amount"
    }
  ],
  [
    "MinimumOffer",
    {
      nth: 16,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Amount"
    }
  ],
  [
    "RippleEscrow",
    {
      nth: 17,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Amount"
    }
  ],
  [
    "DeliveredAmount",
    {
      nth: 18,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Amount"
    }
  ],
  [
    "NFTokenBrokerFee",
    {
      nth: 19,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Amount"
    }
  ],
  [
    "BaseFeeDrops",
    {
      nth: 22,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Amount"
    }
  ],
  [
    "ReserveBaseDrops",
    {
      nth: 23,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Amount"
    }
  ],
  [
    "ReserveIncrementDrops",
    {
      nth: 24,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Amount"
    }
  ],
  [
    "LPTokenOut",
    {
      nth: 25,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Amount"
    }
  ],
  [
    "LPTokenIn",
    {
      nth: 26,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Amount"
    }
  ],
  [
    "EPrice",
    {
      nth: 27,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Amount"
    }
  ],
  [
    "Price",
    {
      nth: 28,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Amount"
    }
  ],
  [
    "SignatureReward",
    {
      nth: 29,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Amount"
    }
  ],
  [
    "MinAccountCreateAmount",
    {
      nth: 30,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Amount"
    }
  ],
  [
    "LPTokenBalance",
    {
      nth: 31,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Amount"
    }
  ],
  [
    "PublicKey",
    {
      nth: 1,
      isVLEncoded: !0,
      isSerialized: !0,
      isSigningField: !0,
      type: "Blob"
    }
  ],
  [
    "MessageKey",
    {
      nth: 2,
      isVLEncoded: !0,
      isSerialized: !0,
      isSigningField: !0,
      type: "Blob"
    }
  ],
  [
    "SigningPubKey",
    {
      nth: 3,
      isVLEncoded: !0,
      isSerialized: !0,
      isSigningField: !0,
      type: "Blob"
    }
  ],
  [
    "TxnSignature",
    {
      nth: 4,
      isVLEncoded: !0,
      isSerialized: !0,
      isSigningField: !1,
      type: "Blob"
    }
  ],
  [
    "URI",
    {
      nth: 5,
      isVLEncoded: !0,
      isSerialized: !0,
      isSigningField: !0,
      type: "Blob"
    }
  ],
  [
    "Signature",
    {
      nth: 6,
      isVLEncoded: !0,
      isSerialized: !0,
      isSigningField: !1,
      type: "Blob"
    }
  ],
  [
    "Domain",
    {
      nth: 7,
      isVLEncoded: !0,
      isSerialized: !0,
      isSigningField: !0,
      type: "Blob"
    }
  ],
  [
    "FundCode",
    {
      nth: 8,
      isVLEncoded: !0,
      isSerialized: !0,
      isSigningField: !0,
      type: "Blob"
    }
  ],
  [
    "RemoveCode",
    {
      nth: 9,
      isVLEncoded: !0,
      isSerialized: !0,
      isSigningField: !0,
      type: "Blob"
    }
  ],
  [
    "ExpireCode",
    {
      nth: 10,
      isVLEncoded: !0,
      isSerialized: !0,
      isSigningField: !0,
      type: "Blob"
    }
  ],
  [
    "CreateCode",
    {
      nth: 11,
      isVLEncoded: !0,
      isSerialized: !0,
      isSigningField: !0,
      type: "Blob"
    }
  ],
  [
    "MemoType",
    {
      nth: 12,
      isVLEncoded: !0,
      isSerialized: !0,
      isSigningField: !0,
      type: "Blob"
    }
  ],
  [
    "MemoData",
    {
      nth: 13,
      isVLEncoded: !0,
      isSerialized: !0,
      isSigningField: !0,
      type: "Blob"
    }
  ],
  [
    "MemoFormat",
    {
      nth: 14,
      isVLEncoded: !0,
      isSerialized: !0,
      isSigningField: !0,
      type: "Blob"
    }
  ],
  [
    "Fulfillment",
    {
      nth: 16,
      isVLEncoded: !0,
      isSerialized: !0,
      isSigningField: !0,
      type: "Blob"
    }
  ],
  [
    "Condition",
    {
      nth: 17,
      isVLEncoded: !0,
      isSerialized: !0,
      isSigningField: !0,
      type: "Blob"
    }
  ],
  [
    "MasterSignature",
    {
      nth: 18,
      isVLEncoded: !0,
      isSerialized: !0,
      isSigningField: !1,
      type: "Blob"
    }
  ],
  [
    "UNLModifyValidator",
    {
      nth: 19,
      isVLEncoded: !0,
      isSerialized: !0,
      isSigningField: !0,
      type: "Blob"
    }
  ],
  [
    "ValidatorToDisable",
    {
      nth: 20,
      isVLEncoded: !0,
      isSerialized: !0,
      isSigningField: !0,
      type: "Blob"
    }
  ],
  [
    "ValidatorToReEnable",
    {
      nth: 21,
      isVLEncoded: !0,
      isSerialized: !0,
      isSigningField: !0,
      type: "Blob"
    }
  ],
  [
    "HookStateData",
    {
      nth: 22,
      isVLEncoded: !0,
      isSerialized: !0,
      isSigningField: !0,
      type: "Blob"
    }
  ],
  [
    "HookReturnString",
    {
      nth: 23,
      isVLEncoded: !0,
      isSerialized: !0,
      isSigningField: !0,
      type: "Blob"
    }
  ],
  [
    "HookParameterName",
    {
      nth: 24,
      isVLEncoded: !0,
      isSerialized: !0,
      isSigningField: !0,
      type: "Blob"
    }
  ],
  [
    "HookParameterValue",
    {
      nth: 25,
      isVLEncoded: !0,
      isSerialized: !0,
      isSigningField: !0,
      type: "Blob"
    }
  ],
  [
    "DIDDocument",
    {
      nth: 26,
      isVLEncoded: !0,
      isSerialized: !0,
      isSigningField: !0,
      type: "Blob"
    }
  ],
  [
    "Data",
    {
      nth: 27,
      isVLEncoded: !0,
      isSerialized: !0,
      isSigningField: !0,
      type: "Blob"
    }
  ],
  [
    "Account",
    {
      nth: 1,
      isVLEncoded: !0,
      isSerialized: !0,
      isSigningField: !0,
      type: "AccountID"
    }
  ],
  [
    "Owner",
    {
      nth: 2,
      isVLEncoded: !0,
      isSerialized: !0,
      isSigningField: !0,
      type: "AccountID"
    }
  ],
  [
    "Destination",
    {
      nth: 3,
      isVLEncoded: !0,
      isSerialized: !0,
      isSigningField: !0,
      type: "AccountID"
    }
  ],
  [
    "Issuer",
    {
      nth: 4,
      isVLEncoded: !0,
      isSerialized: !0,
      isSigningField: !0,
      type: "AccountID"
    }
  ],
  [
    "Authorize",
    {
      nth: 5,
      isVLEncoded: !0,
      isSerialized: !0,
      isSigningField: !0,
      type: "AccountID"
    }
  ],
  [
    "Unauthorize",
    {
      nth: 6,
      isVLEncoded: !0,
      isSerialized: !0,
      isSigningField: !0,
      type: "AccountID"
    }
  ],
  [
    "RegularKey",
    {
      nth: 8,
      isVLEncoded: !0,
      isSerialized: !0,
      isSigningField: !0,
      type: "AccountID"
    }
  ],
  [
    "NFTokenMinter",
    {
      nth: 9,
      isVLEncoded: !0,
      isSerialized: !0,
      isSigningField: !0,
      type: "AccountID"
    }
  ],
  [
    "EmitCallback",
    {
      nth: 10,
      isVLEncoded: !0,
      isSerialized: !0,
      isSigningField: !0,
      type: "AccountID"
    }
  ],
  [
    "HookAccount",
    {
      nth: 16,
      isVLEncoded: !0,
      isSerialized: !0,
      isSigningField: !0,
      type: "AccountID"
    }
  ],
  [
    "OtherChainSource",
    {
      nth: 18,
      isVLEncoded: !0,
      isSerialized: !0,
      isSigningField: !0,
      type: "AccountID"
    }
  ],
  [
    "OtherChainDestination",
    {
      nth: 19,
      isVLEncoded: !0,
      isSerialized: !0,
      isSigningField: !0,
      type: "AccountID"
    }
  ],
  [
    "AttestationSignerAccount",
    {
      nth: 20,
      isVLEncoded: !0,
      isSerialized: !0,
      isSigningField: !0,
      type: "AccountID"
    }
  ],
  [
    "AttestationRewardAccount",
    {
      nth: 21,
      isVLEncoded: !0,
      isSerialized: !0,
      isSigningField: !0,
      type: "AccountID"
    }
  ],
  [
    "LockingChainDoor",
    {
      nth: 22,
      isVLEncoded: !0,
      isSerialized: !0,
      isSigningField: !0,
      type: "AccountID"
    }
  ],
  [
    "IssuingChainDoor",
    {
      nth: 23,
      isVLEncoded: !0,
      isSerialized: !0,
      isSigningField: !0,
      type: "AccountID"
    }
  ],
  [
    "Indexes",
    {
      nth: 1,
      isVLEncoded: !0,
      isSerialized: !0,
      isSigningField: !0,
      type: "Vector256"
    }
  ],
  [
    "Hashes",
    {
      nth: 2,
      isVLEncoded: !0,
      isSerialized: !0,
      isSigningField: !0,
      type: "Vector256"
    }
  ],
  [
    "Amendments",
    {
      nth: 3,
      isVLEncoded: !0,
      isSerialized: !0,
      isSigningField: !0,
      type: "Vector256"
    }
  ],
  [
    "NFTokenOffers",
    {
      nth: 4,
      isVLEncoded: !0,
      isSerialized: !0,
      isSigningField: !0,
      type: "Vector256"
    }
  ],
  [
    "Paths",
    {
      nth: 1,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "PathSet"
    }
  ],
  [
    "LockingChainIssue",
    {
      nth: 1,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Issue"
    }
  ],
  [
    "IssuingChainIssue",
    {
      nth: 2,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Issue"
    }
  ],
  [
    "Asset",
    {
      nth: 3,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Issue"
    }
  ],
  [
    "Asset2",
    {
      nth: 4,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "Issue"
    }
  ],
  [
    "XChainBridge",
    {
      nth: 1,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "XChainBridge"
    }
  ],
  [
    "TransactionMetaData",
    {
      nth: 2,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "STObject"
    }
  ],
  [
    "CreatedNode",
    {
      nth: 3,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "STObject"
    }
  ],
  [
    "DeletedNode",
    {
      nth: 4,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "STObject"
    }
  ],
  [
    "ModifiedNode",
    {
      nth: 5,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "STObject"
    }
  ],
  [
    "PreviousFields",
    {
      nth: 6,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "STObject"
    }
  ],
  [
    "FinalFields",
    {
      nth: 7,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "STObject"
    }
  ],
  [
    "NewFields",
    {
      nth: 8,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "STObject"
    }
  ],
  [
    "TemplateEntry",
    {
      nth: 9,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "STObject"
    }
  ],
  [
    "Memo",
    {
      nth: 10,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "STObject"
    }
  ],
  [
    "SignerEntry",
    {
      nth: 11,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "STObject"
    }
  ],
  [
    "NFToken",
    {
      nth: 12,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "STObject"
    }
  ],
  [
    "EmitDetails",
    {
      nth: 13,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "STObject"
    }
  ],
  [
    "Hook",
    {
      nth: 14,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "STObject"
    }
  ],
  [
    "Signer",
    {
      nth: 16,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "STObject"
    }
  ],
  [
    "Majority",
    {
      nth: 18,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "STObject"
    }
  ],
  [
    "DisabledValidator",
    {
      nth: 19,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "STObject"
    }
  ],
  [
    "EmittedTxn",
    {
      nth: 20,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "STObject"
    }
  ],
  [
    "HookExecution",
    {
      nth: 21,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "STObject"
    }
  ],
  [
    "HookDefinition",
    {
      nth: 22,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "STObject"
    }
  ],
  [
    "HookParameter",
    {
      nth: 23,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "STObject"
    }
  ],
  [
    "HookGrant",
    {
      nth: 24,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "STObject"
    }
  ],
  [
    "VoteEntry",
    {
      nth: 25,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "STObject"
    }
  ],
  [
    "AuctionSlot",
    {
      nth: 26,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "STObject"
    }
  ],
  [
    "AuthAccount",
    {
      nth: 27,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "STObject"
    }
  ],
  [
    "XChainClaimProofSig",
    {
      nth: 28,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "STObject"
    }
  ],
  [
    "XChainCreateAccountProofSig",
    {
      nth: 29,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "STObject"
    }
  ],
  [
    "XChainClaimAttestationCollectionElement",
    {
      nth: 30,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "STObject"
    }
  ],
  [
    "XChainCreateAccountAttestationCollectionElement",
    {
      nth: 31,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "STObject"
    }
  ],
  [
    "Signers",
    {
      nth: 3,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !1,
      type: "STArray"
    }
  ],
  [
    "SignerEntries",
    {
      nth: 4,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "STArray"
    }
  ],
  [
    "Template",
    {
      nth: 5,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "STArray"
    }
  ],
  [
    "Necessary",
    {
      nth: 6,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "STArray"
    }
  ],
  [
    "Sufficient",
    {
      nth: 7,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "STArray"
    }
  ],
  [
    "AffectedNodes",
    {
      nth: 8,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "STArray"
    }
  ],
  [
    "Memos",
    {
      nth: 9,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "STArray"
    }
  ],
  [
    "NFTokens",
    {
      nth: 10,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "STArray"
    }
  ],
  [
    "Hooks",
    {
      nth: 11,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "STArray"
    }
  ],
  [
    "VoteSlots",
    {
      nth: 12,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "STArray"
    }
  ],
  [
    "Majorities",
    {
      nth: 16,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "STArray"
    }
  ],
  [
    "DisabledValidators",
    {
      nth: 17,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "STArray"
    }
  ],
  [
    "HookExecutions",
    {
      nth: 18,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "STArray"
    }
  ],
  [
    "HookParameters",
    {
      nth: 19,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "STArray"
    }
  ],
  [
    "HookGrants",
    {
      nth: 20,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "STArray"
    }
  ],
  [
    "XChainClaimAttestations",
    {
      nth: 21,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "STArray"
    }
  ],
  [
    "XChainCreateAccountAttestations",
    {
      nth: 22,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "STArray"
    }
  ],
  [
    "AuthAccounts",
    {
      nth: 25,
      isVLEncoded: !1,
      isSerialized: !0,
      isSigningField: !0,
      type: "STArray"
    }
  ]
], TRANSACTION_RESULTS = {
  telLOCAL_ERROR: -399,
  telBAD_DOMAIN: -398,
  telBAD_PATH_COUNT: -397,
  telBAD_PUBLIC_KEY: -396,
  telFAILED_PROCESSING: -395,
  telINSUF_FEE_P: -394,
  telNO_DST_PARTIAL: -393,
  telCAN_NOT_QUEUE: -392,
  telCAN_NOT_QUEUE_BALANCE: -391,
  telCAN_NOT_QUEUE_BLOCKS: -390,
  telCAN_NOT_QUEUE_BLOCKED: -389,
  telCAN_NOT_QUEUE_FEE: -388,
  telCAN_NOT_QUEUE_FULL: -387,
  telWRONG_NETWORK: -386,
  telREQUIRES_NETWORK_ID: -385,
  telNETWORK_ID_MAKES_TX_NON_CANONICAL: -384,
  temMALFORMED: -299,
  temBAD_AMOUNT: -298,
  temBAD_CURRENCY: -297,
  temBAD_EXPIRATION: -296,
  temBAD_FEE: -295,
  temBAD_ISSUER: -294,
  temBAD_LIMIT: -293,
  temBAD_OFFER: -292,
  temBAD_PATH: -291,
  temBAD_PATH_LOOP: -290,
  temBAD_REGKEY: -289,
  temBAD_SEND_XRP_LIMIT: -288,
  temBAD_SEND_XRP_MAX: -287,
  temBAD_SEND_XRP_NO_DIRECT: -286,
  temBAD_SEND_XRP_PARTIAL: -285,
  temBAD_SEND_XRP_PATHS: -284,
  temBAD_SEQUENCE: -283,
  temBAD_SIGNATURE: -282,
  temBAD_SRC_ACCOUNT: -281,
  temBAD_TRANSFER_RATE: -280,
  temDST_IS_SRC: -279,
  temDST_NEEDED: -278,
  temINVALID: -277,
  temINVALID_FLAG: -276,
  temREDUNDANT: -275,
  temRIPPLE_EMPTY: -274,
  temDISABLED: -273,
  temBAD_SIGNER: -272,
  temBAD_QUORUM: -271,
  temBAD_WEIGHT: -270,
  temBAD_TICK_SIZE: -269,
  temINVALID_ACCOUNT_ID: -268,
  temCANNOT_PREAUTH_SELF: -267,
  temINVALID_COUNT: -266,
  temUNCERTAIN: -265,
  temUNKNOWN: -264,
  temSEQ_AND_TICKET: -263,
  temBAD_NFTOKEN_TRANSFER_FEE: -262,
  temBAD_AMM_TOKENS: -261,
  temXCHAIN_EQUAL_DOOR_ACCOUNTS: -260,
  temXCHAIN_BAD_PROOF: -259,
  temXCHAIN_BRIDGE_BAD_ISSUES: -258,
  temXCHAIN_BRIDGE_NONDOOR_OWNER: -257,
  temXCHAIN_BRIDGE_BAD_MIN_ACCOUNT_CREATE_AMOUNT: -256,
  temXCHAIN_BRIDGE_BAD_REWARD_AMOUNT: -255,
  temEMPTY_DID: -254,
  tefFAILURE: -199,
  tefALREADY: -198,
  tefBAD_ADD_AUTH: -197,
  tefBAD_AUTH: -196,
  tefBAD_LEDGER: -195,
  tefCREATED: -194,
  tefEXCEPTION: -193,
  tefINTERNAL: -192,
  tefNO_AUTH_REQUIRED: -191,
  tefPAST_SEQ: -190,
  tefWRONG_PRIOR: -189,
  tefMASTER_DISABLED: -188,
  tefMAX_LEDGER: -187,
  tefBAD_SIGNATURE: -186,
  tefBAD_QUORUM: -185,
  tefNOT_MULTI_SIGNING: -184,
  tefBAD_AUTH_MASTER: -183,
  tefINVARIANT_FAILED: -182,
  tefTOO_BIG: -181,
  tefNO_TICKET: -180,
  tefNFTOKEN_IS_NOT_TRANSFERABLE: -179,
  terRETRY: -99,
  terFUNDS_SPENT: -98,
  terINSUF_FEE_B: -97,
  terNO_ACCOUNT: -96,
  terNO_AUTH: -95,
  terNO_LINE: -94,
  terOWNERS: -93,
  terPRE_SEQ: -92,
  terLAST: -91,
  terNO_RIPPLE: -90,
  terQUEUED: -89,
  terPRE_TICKET: -88,
  terNO_AMM: -87,
  terSUBMITTED: -86,
  tesSUCCESS: 0,
  tecCLAIM: 100,
  tecPATH_PARTIAL: 101,
  tecUNFUNDED_ADD: 102,
  tecUNFUNDED_OFFER: 103,
  tecUNFUNDED_PAYMENT: 104,
  tecFAILED_PROCESSING: 105,
  tecDIR_FULL: 121,
  tecINSUF_RESERVE_LINE: 122,
  tecINSUF_RESERVE_OFFER: 123,
  tecNO_DST: 124,
  tecNO_DST_INSUF_XRP: 125,
  tecNO_LINE_INSUF_RESERVE: 126,
  tecNO_LINE_REDUNDANT: 127,
  tecPATH_DRY: 128,
  tecUNFUNDED: 129,
  tecNO_ALTERNATIVE_KEY: 130,
  tecNO_REGULAR_KEY: 131,
  tecOWNERS: 132,
  tecNO_ISSUER: 133,
  tecNO_AUTH: 134,
  tecNO_LINE: 135,
  tecINSUFF_FEE: 136,
  tecFROZEN: 137,
  tecNO_TARGET: 138,
  tecNO_PERMISSION: 139,
  tecNO_ENTRY: 140,
  tecINSUFFICIENT_RESERVE: 141,
  tecNEED_MASTER_KEY: 142,
  tecDST_TAG_NEEDED: 143,
  tecINTERNAL: 144,
  tecOVERSIZE: 145,
  tecCRYPTOCONDITION_ERROR: 146,
  tecINVARIANT_FAILED: 147,
  tecEXPIRED: 148,
  tecDUPLICATE: 149,
  tecKILLED: 150,
  tecHAS_OBLIGATIONS: 151,
  tecTOO_SOON: 152,
  tecHOOK_REJECTED: 153,
  tecMAX_SEQUENCE_REACHED: 154,
  tecNO_SUITABLE_NFTOKEN_PAGE: 155,
  tecNFTOKEN_BUY_SELL_MISMATCH: 156,
  tecNFTOKEN_OFFER_TYPE_MISMATCH: 157,
  tecCANT_ACCEPT_OWN_NFTOKEN_OFFER: 158,
  tecINSUFFICIENT_FUNDS: 159,
  tecOBJECT_NOT_FOUND: 160,
  tecINSUFFICIENT_PAYMENT: 161,
  tecUNFUNDED_AMM: 162,
  tecAMM_BALANCE: 163,
  tecAMM_FAILED: 164,
  tecAMM_INVALID_TOKENS: 165,
  tecAMM_EMPTY: 166,
  tecAMM_NOT_EMPTY: 167,
  tecAMM_ACCOUNT: 168,
  tecINCOMPLETE: 169,
  tecXCHAIN_BAD_TRANSFER_ISSUE: 170,
  tecXCHAIN_NO_CLAIM_ID: 171,
  tecXCHAIN_BAD_CLAIM_ID: 172,
  tecXCHAIN_CLAIM_NO_QUORUM: 173,
  tecXCHAIN_PROOF_UNKNOWN_KEY: 174,
  tecXCHAIN_CREATE_ACCOUNT_NONXRP_ISSUE: 175,
  tecXCHAIN_WRONG_CHAIN: 176,
  tecXCHAIN_REWARD_MISMATCH: 177,
  tecXCHAIN_NO_SIGNERS_LIST: 178,
  tecXCHAIN_SENDING_ACCOUNT_MISMATCH: 179,
  tecXCHAIN_INSUFF_CREATE_AMOUNT: 180,
  tecXCHAIN_ACCOUNT_CREATE_PAST: 181,
  tecXCHAIN_ACCOUNT_CREATE_TOO_MANY: 182,
  tecXCHAIN_PAYMENT_FAILED: 183,
  tecXCHAIN_SELF_COMMIT: 184,
  tecXCHAIN_BAD_PUBLIC_KEY_ACCOUNT_PAIR: 185,
  tecXCHAIN_CREATE_ACCOUNT_DISABLED: 186,
  tecEMPTY_DID: 187
}, TRANSACTION_TYPES = {
  Invalid: -1,
  Payment: 0,
  EscrowCreate: 1,
  EscrowFinish: 2,
  AccountSet: 3,
  EscrowCancel: 4,
  SetRegularKey: 5,
  NickNameSet: 6,
  OfferCreate: 7,
  OfferCancel: 8,
  Contract: 9,
  TicketCreate: 10,
  TicketCancel: 11,
  SignerListSet: 12,
  PaymentChannelCreate: 13,
  PaymentChannelFund: 14,
  PaymentChannelClaim: 15,
  CheckCreate: 16,
  CheckCash: 17,
  CheckCancel: 18,
  DepositPreauth: 19,
  TrustSet: 20,
  AccountDelete: 21,
  SetHook: 22,
  NFTokenMint: 25,
  NFTokenBurn: 26,
  NFTokenCreateOffer: 27,
  NFTokenCancelOffer: 28,
  NFTokenAcceptOffer: 29,
  Clawback: 30,
  AMMCreate: 35,
  AMMDeposit: 36,
  AMMWithdraw: 37,
  AMMVote: 38,
  AMMBid: 39,
  AMMDelete: 40,
  XChainCreateClaimID: 41,
  XChainCommit: 42,
  XChainClaim: 43,
  XChainAccountCreateCommit: 44,
  XChainAddClaimAttestation: 45,
  XChainAddAccountCreateAttestation: 46,
  XChainModifyBridge: 47,
  XChainCreateBridge: 48,
  DIDSet: 49,
  DIDDelete: 50,
  EnableAmendment: 100,
  SetFee: 101,
  UNLModify: 102
}, require$$0$1 = {
  TYPES,
  LEDGER_ENTRY_TYPES,
  FIELDS,
  TRANSACTION_RESULTS,
  TRANSACTION_TYPES
};
var xrplDefinitionsBase = {}, bytes$7 = {};
Object.defineProperty(bytes$7, "__esModule", { value: !0 });
bytes$7.BytesLookup = bytes$7.Bytes = void 0;
const buffer_1$n = dist$u;
class Bytes {
  constructor(c, u, p) {
    this.name = c, this.ordinal = u, this.ordinalWidth = p, this.bytes = buffer_1$n.Buffer.alloc(p);
    for (let a = 0; a < p; a++)
      this.bytes[p - a - 1] = u >>> a * 8 & 255;
  }
  toJSON() {
    return this.name;
  }
  toBytesSink(c) {
    c.put(this.bytes);
  }
  toBytes() {
    return this.bytes;
  }
}
bytes$7.Bytes = Bytes;
class BytesLookup {
  constructor(c, u) {
    this.ordinalWidth = u, Object.entries(c).forEach(([p, a]) => {
      this.add(p, a);
    });
  }
  /**
   * Add a new name value pair to the BytesLookup.
   *
   * @param name - A human readable name for the field.
   * @param value - The numeric value for the field.
   * @throws if the name or value already exist in the lookup because it's unclear how to decode.
   */
  add(c, u) {
    if (this[c])
      throw new SyntaxError(`Attempted to add a value with a duplicate name "${c}". This is not allowed because it is unclear how to decode.`);
    if (this[u.toString()])
      throw new SyntaxError(`Attempted to add a duplicate value under a different name (Given name: "${c}" and previous name: "${this[u.toString()]}. This is not allowed because it is unclear how to decode.
Given value: ${u.toString()}`);
    this[c] = new Bytes(c, u, this.ordinalWidth), this[u.toString()] = this[c];
  }
  from(c) {
    return c instanceof Bytes ? c : this[c];
  }
  fromParser(c) {
    return this.from(c.readUIntN(this.ordinalWidth).toString());
  }
}
bytes$7.BytesLookup = BytesLookup;
var field = {}, serializedType = {}, binarySerializer = {}, __createBinding$e = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(n, c, u, p) {
  p === void 0 && (p = u);
  var a = Object.getOwnPropertyDescriptor(c, u);
  (!a || ("get" in a ? !c.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
    return c[u];
  } }), Object.defineProperty(n, p, a);
} : function(n, c, u, p) {
  p === void 0 && (p = u), n[p] = c[u];
}), __setModuleDefault$e = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(n, c) {
  Object.defineProperty(n, "default", { enumerable: !0, value: c });
} : function(n, c) {
  n.default = c;
}), __importStar$e = commonjsGlobal && commonjsGlobal.__importStar || function(n) {
  if (n && n.__esModule) return n;
  var c = {};
  if (n != null) for (var u in n) u !== "default" && Object.prototype.hasOwnProperty.call(n, u) && __createBinding$e(c, n, u);
  return __setModuleDefault$e(c, n), c;
};
Object.defineProperty(binarySerializer, "__esModule", { value: !0 });
binarySerializer.BinarySerializer = binarySerializer.BytesList = void 0;
const assert$b = __importStar$e(requireAssert()), buffer_1$m = dist$u;
class BytesList {
  constructor() {
    this.bytesArray = [];
  }
  /**
   * Get the total number of bytes in the BytesList
   *
   * @return the number of bytes
   */
  getLength() {
    return buffer_1$m.Buffer.concat(this.bytesArray).byteLength;
  }
  /**
   * Put bytes in the BytesList
   *
   * @param bytesArg A Buffer
   * @return this BytesList
   */
  put(c) {
    const u = buffer_1$m.Buffer.from(c);
    return this.bytesArray.push(u), this;
  }
  /**
   * Write this BytesList to the back of another bytes list
   *
   *  @param list The BytesList to write to
   */
  toBytesSink(c) {
    c.put(this.toBytes());
  }
  toBytes() {
    return buffer_1$m.Buffer.concat(this.bytesArray);
  }
  toHex() {
    return this.toBytes().toString("hex").toUpperCase();
  }
}
binarySerializer.BytesList = BytesList;
class BinarySerializer {
  constructor(c) {
    this.sink = new BytesList(), this.sink = c;
  }
  /**
   * Write a value to this BinarySerializer
   *
   * @param value a SerializedType value
   */
  write(c) {
    c.toBytesSink(this.sink);
  }
  /**
   * Write bytes to this BinarySerializer
   *
   * @param bytes the bytes to write
   */
  put(c) {
    this.sink.put(c);
  }
  /**
   * Write a value of a given type to this BinarySerializer
   *
   * @param type the type to write
   * @param value a value of that type
   */
  writeType(c, u) {
    this.write(c.from(u));
  }
  /**
   * Write BytesList to this BinarySerializer
   *
   * @param bl BytesList to write to BinarySerializer
   */
  writeBytesList(c) {
    c.toBytesSink(this.sink);
  }
  /**
   * Calculate the header of Variable Length encoded bytes
   *
   * @param length the length of the bytes
   */
  encodeVariableLength(c) {
    const u = buffer_1$m.Buffer.alloc(3);
    if (c <= 192)
      return u[0] = c, u.slice(0, 1);
    if (c <= 12480)
      return c -= 193, u[0] = 193 + (c >>> 8), u[1] = c & 255, u.slice(0, 2);
    if (c <= 918744)
      return c -= 12481, u[0] = 241 + (c >>> 16), u[1] = c >> 8 & 255, u[2] = c & 255, u.slice(0, 3);
    throw new Error("Overflow error");
  }
  /**
   * Write field and value to BinarySerializer
   *
   * @param field field to write to BinarySerializer
   * @param value value to write to BinarySerializer
   */
  writeFieldAndValue(c, u, p = !1) {
    const a = c.associatedType.from(u);
    assert$b.ok(a.toBytesSink !== void 0), assert$b.ok(c.name !== void 0), this.sink.put(c.header), c.isVariableLengthEncoded ? this.writeLengthEncoded(a, p) : a.toBytesSink(this.sink);
  }
  /**
   * Write a variable length encoded value to the BinarySerializer
   *
   * @param value length encoded value to write to BytesList
   */
  writeLengthEncoded(c, u = !1) {
    const p = new BytesList();
    u || c.toBytesSink(p), this.put(this.encodeVariableLength(p.getLength())), this.writeBytesList(p);
  }
}
binarySerializer.BinarySerializer = BinarySerializer;
Object.defineProperty(serializedType, "__esModule", { value: !0 });
serializedType.Comparable = serializedType.SerializedType = void 0;
const binary_serializer_1$2 = binarySerializer, buffer_1$l = dist$u;
class SerializedType {
  constructor(c) {
    this.bytes = buffer_1$l.Buffer.alloc(0), this.bytes = c ?? buffer_1$l.Buffer.alloc(0);
  }
  static fromParser(c, u) {
    throw new Error("fromParser not implemented");
  }
  static from(c) {
    throw new Error("from not implemented");
  }
  /**
   * Write the bytes representation of a SerializedType to a BytesList
   *
   * @param list The BytesList to write SerializedType bytes to
   */
  toBytesSink(c) {
    c.put(this.bytes);
  }
  /**
   * Get the hex representation of a SerializedType's bytes
   *
   * @returns hex String of this.bytes
   */
  toHex() {
    return this.toBytes().toString("hex").toUpperCase();
  }
  /**
   * Get the bytes representation of a SerializedType
   *
   * @returns A buffer of the bytes
   */
  toBytes() {
    if (this.bytes)
      return this.bytes;
    const c = new binary_serializer_1$2.BytesList();
    return this.toBytesSink(c), c.toBytes();
  }
  /**
   * Return the JSON representation of a SerializedType
   *
   * @param _definitions rippled definitions used to parse the values of transaction types and such.
   *                          Unused in default, but used in STObject, STArray
   *                          Can be customized for sidechains and amendments.
   * @returns any type, if not overloaded returns hexString representation of bytes
   */
  toJSON(c) {
    return this.toHex();
  }
  /**
   * @returns hexString representation of this.bytes
   */
  toString() {
    return this.toHex();
  }
}
serializedType.SerializedType = SerializedType;
class Comparable extends SerializedType {
  lt(c) {
    return this.compareTo(c) < 0;
  }
  eq(c) {
    return this.compareTo(c) === 0;
  }
  gt(c) {
    return this.compareTo(c) > 0;
  }
  gte(c) {
    return this.compareTo(c) > -1;
  }
  lte(c) {
    return this.compareTo(c) < 1;
  }
  /**
   * Overload this method to define how two Comparable SerializedTypes are compared
   *
   * @param other The comparable object to compare this to
   * @returns A number denoting the relationship of this and other
   */
  compareTo(c) {
    throw new Error(`cannot compare ${this.toString()} and ${c.toString()}`);
  }
}
serializedType.Comparable = Comparable;
var constants$3 = {};
Object.defineProperty(constants$3, "__esModule", { value: !0 });
constants$3.TRANSACTION_RESULT_WIDTH = constants$3.TRANSACTION_TYPE_WIDTH = constants$3.LEDGER_ENTRY_WIDTH = constants$3.TYPE_WIDTH = void 0;
constants$3.TYPE_WIDTH = 2;
constants$3.LEDGER_ENTRY_WIDTH = 2;
constants$3.TRANSACTION_TYPE_WIDTH = 2;
constants$3.TRANSACTION_RESULT_WIDTH = 1;
Object.defineProperty(field, "__esModule", { value: !0 });
field.FieldLookup = void 0;
const bytes_1 = bytes$7, serialized_type_1$8 = serializedType, constants_1$1 = constants$3, buffer_1$k = dist$u;
function fieldHeader(n, c) {
  const u = [];
  return n < 16 ? c < 16 ? u.push(n << 4 | c) : u.push(n << 4, c) : c < 16 ? u.push(c, n) : u.push(0, n, c), buffer_1$k.Buffer.from(u);
}
function buildField([n, c], u) {
  const p = fieldHeader(u, c.nth);
  return {
    name: n,
    nth: c.nth,
    isVariableLengthEncoded: c.isVLEncoded,
    isSerialized: c.isSerialized,
    isSigningField: c.isSigningField,
    ordinal: u << 16 | c.nth,
    type: new bytes_1.Bytes(c.type, u, constants_1$1.TYPE_WIDTH),
    header: p,
    associatedType: serialized_type_1$8.SerializedType
    // For later assignment in ./types/index.js or Definitions.updateAll(...)
  };
}
class FieldLookup {
  constructor(c, u) {
    c.forEach(([p, a]) => {
      const A = u[a.type];
      this[p] = buildField([p, a], A), this[this[p].ordinal.toString()] = this[p];
    });
  }
  fromString(c) {
    return this[c];
  }
}
field.FieldLookup = FieldLookup;
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.BytesLookup = n.Bytes = n.FieldLookup = n.XrplDefinitionsBase = void 0;
  const c = bytes$7;
  Object.defineProperty(n, "Bytes", { enumerable: !0, get: function() {
    return c.Bytes;
  } }), Object.defineProperty(n, "BytesLookup", { enumerable: !0, get: function() {
    return c.BytesLookup;
  } });
  const u = field;
  Object.defineProperty(n, "FieldLookup", { enumerable: !0, get: function() {
    return u.FieldLookup;
  } });
  const p = constants$3;
  class a {
    /**
     * Present rippled types in a typed and updatable format.
     * For an example of the input format see `definitions.json`
     * To generate a new definitions file from rippled source code, use this tool: https://github.com/RichardAH/xrpl-codec-gen
     *
     * See the definitions.test.js file for examples of how to create your own updated definitions.json.
     *
     * @param enums - A json encoding of the core types, transaction types, transaction results, transaction names, and fields.
     * @param types - A list of type objects with the same name as the fields defined.
     *              You can use the coreTypes object if you are not adding new types.
     */
    constructor(b, F) {
      this.type = new c.BytesLookup(b.TYPES, p.TYPE_WIDTH), this.ledgerEntryType = new c.BytesLookup(b.LEDGER_ENTRY_TYPES, p.LEDGER_ENTRY_WIDTH), this.transactionType = new c.BytesLookup(b.TRANSACTION_TYPES, p.TRANSACTION_TYPE_WIDTH), this.transactionResult = new c.BytesLookup(b.TRANSACTION_RESULTS, p.TRANSACTION_RESULT_WIDTH), this.field = new u.FieldLookup(b.FIELDS, b.TYPES), this.transactionNames = Object.entries(b.TRANSACTION_TYPES).filter(([le, L]) => L >= 0).map(([le, L]) => le), this.dataTypes = {}, this.associateTypes(F);
    }
    /**
     * Associates each Field to a corresponding class that TypeScript can recognize.
     *
     * @param types a list of type objects with the same name as the fields defined.
     *              Defaults to xrpl.js's core type definitions.
     */
    associateTypes(b) {
      this.dataTypes = Object.assign({}, this.dataTypes, b), Object.values(this.field).forEach((F) => {
        F.associatedType = this.dataTypes[F.type.name];
      }), this.field.TransactionType.associatedType = this.transactionType, this.field.TransactionResult.associatedType = this.transactionResult, this.field.LedgerEntryType.associatedType = this.ledgerEntryType;
    }
    getAssociatedTypes() {
      return this.dataTypes;
    }
  }
  n.XrplDefinitionsBase = a;
})(xrplDefinitionsBase);
(function(n) {
  var c = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(be, He, Pe, nr) {
    nr === void 0 && (nr = Pe);
    var ir = Object.getOwnPropertyDescriptor(He, Pe);
    (!ir || ("get" in ir ? !He.__esModule : ir.writable || ir.configurable)) && (ir = { enumerable: !0, get: function() {
      return He[Pe];
    } }), Object.defineProperty(be, nr, ir);
  } : function(be, He, Pe, nr) {
    nr === void 0 && (nr = Pe), be[nr] = He[Pe];
  }), u = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(be, He) {
    Object.defineProperty(be, "default", { enumerable: !0, value: He });
  } : function(be, He) {
    be.default = He;
  }), p = commonjsGlobal && commonjsGlobal.__importStar || function(be) {
    if (be && be.__esModule) return be;
    var He = {};
    if (be != null) for (var Pe in be) Pe !== "default" && Object.prototype.hasOwnProperty.call(be, Pe) && c(He, be, Pe);
    return u(He, be), He;
  };
  Object.defineProperty(n, "__esModule", { value: !0 }), n.TRANSACTION_TYPES = n.TransactionType = n.TransactionResult = n.LedgerEntryType = n.Type = n.Field = n.DEFAULT_DEFINITIONS = n.XrplDefinitionsBase = n.Bytes = void 0;
  const a = p(require$$0$1), A = xrplDefinitionsBase;
  Object.defineProperty(n, "XrplDefinitionsBase", { enumerable: !0, get: function() {
    return A.XrplDefinitionsBase;
  } }), Object.defineProperty(n, "Bytes", { enumerable: !0, get: function() {
    return A.Bytes;
  } });
  const b = new A.XrplDefinitionsBase(a, {});
  n.DEFAULT_DEFINITIONS = b;
  const F = b.type;
  n.Type = F;
  const le = b.ledgerEntryType;
  n.LedgerEntryType = le;
  const L = b.transactionType;
  n.TransactionType = L;
  const pe = b.transactionResult;
  n.TransactionResult = pe;
  const $ = b.field;
  n.Field = $;
  const Ee = b.transactionNames;
  n.TRANSACTION_TYPES = Ee;
})(enums);
var types$3 = {}, accountId = {}, dist$2 = {}, xrpCodec = {}, _Buffer$1 = safeBufferExports.Buffer;
function base$2(n) {
  if (n.length >= 255)
    throw new TypeError("Alphabet too long");
  for (var c = new Uint8Array(256), u = 0; u < c.length; u++)
    c[u] = 255;
  for (var p = 0; p < n.length; p++) {
    var a = n.charAt(p), A = a.charCodeAt(0);
    if (c[A] !== 255)
      throw new TypeError(a + " is ambiguous");
    c[A] = p;
  }
  var b = n.length, F = n.charAt(0), le = Math.log(b) / Math.log(256), L = Math.log(256) / Math.log(b);
  function pe(be) {
    if ((Array.isArray(be) || be instanceof Uint8Array) && (be = _Buffer$1.from(be)), !_Buffer$1.isBuffer(be))
      throw new TypeError("Expected Buffer");
    if (be.length === 0)
      return "";
    for (var He = 0, Pe = 0, nr = 0, ir = be.length; nr !== ir && be[nr] === 0; )
      nr++, He++;
    for (var or = (ir - nr) * L + 1 >>> 0, lr = new Uint8Array(or); nr !== ir; ) {
      for (var Ir = be[nr], xr = 0, kr = or - 1; (Ir !== 0 || xr < Pe) && kr !== -1; kr--, xr++)
        Ir += 256 * lr[kr] >>> 0, lr[kr] = Ir % b >>> 0, Ir = Ir / b >>> 0;
      if (Ir !== 0)
        throw new Error("Non-zero carry");
      Pe = xr, nr++;
    }
    for (var Ce = or - Pe; Ce !== or && lr[Ce] === 0; )
      Ce++;
    for (var tr = F.repeat(He); Ce < or; ++Ce)
      tr += n.charAt(lr[Ce]);
    return tr;
  }
  function $(be) {
    if (typeof be != "string")
      throw new TypeError("Expected String");
    if (be.length === 0)
      return _Buffer$1.alloc(0);
    for (var He = 0, Pe = 0, nr = 0; be[He] === F; )
      Pe++, He++;
    for (var ir = (be.length - He) * le + 1 >>> 0, or = new Uint8Array(ir); He < be.length; ) {
      var lr = be.charCodeAt(He);
      if (lr > 255)
        return;
      var Ir = c[lr];
      if (Ir === 255)
        return;
      for (var xr = 0, kr = ir - 1; (Ir !== 0 || xr < nr) && kr !== -1; kr--, xr++)
        Ir += b * or[kr] >>> 0, or[kr] = Ir % 256 >>> 0, Ir = Ir / 256 >>> 0;
      if (Ir !== 0)
        throw new Error("Non-zero carry");
      nr = xr, He++;
    }
    for (var Ce = ir - nr; Ce !== ir && or[Ce] === 0; )
      Ce++;
    var tr = _Buffer$1.allocUnsafe(Pe + (ir - Ce));
    tr.fill(0, 0, Pe);
    for (var Fe = Pe; Ce !== ir; )
      tr[Fe++] = or[Ce++];
    return tr;
  }
  function Ee(be) {
    var He = $(be);
    if (He)
      return He;
    throw new Error("Non-base" + b + " character");
  }
  return {
    encode: pe,
    decodeUnsafe: $,
    decode: Ee
  };
}
var src$3 = base$2, utils$4 = {};
Object.defineProperty(utils$4, "__esModule", { value: !0 });
utils$4.concatArgs = utils$4.seqEqual = void 0;
function seqEqual(n, c) {
  if (n.length !== c.length)
    return !1;
  for (let u = 0; u < n.length; u++)
    if (n[u] !== c[u])
      return !1;
  return !0;
}
utils$4.seqEqual = seqEqual;
function isSequence(n) {
  return typeof n != "number";
}
function concatArgs(...n) {
  const c = [];
  return n.forEach((u) => {
    if (isSequence(u))
      for (const p of u)
        c.push(p);
    else
      c.push(u);
  }), c;
}
utils$4.concatArgs = concatArgs;
Object.defineProperty(xrpCodec, "__esModule", { value: !0 });
xrpCodec.isValidClassicAddress = xrpCodec.decodeAccountPublic = xrpCodec.encodeAccountPublic = xrpCodec.encodeNodePublic = xrpCodec.decodeNodePublic = xrpCodec.decodeAddress = xrpCodec.decodeAccountID = xrpCodec.encodeAddress = xrpCodec.encodeAccountID = xrpCodec.decodeSeed = xrpCodec.encodeSeed = xrpCodec.codec = void 0;
const baseCodec = src$3, createHash$2 = browser$a, utils_1$6 = utils$4;
class Codec {
  constructor(c) {
    this._sha256 = c.sha256, this._alphabet = c.alphabet, this._codec = baseCodec(this._alphabet);
  }
  /**
   * Encoder.
   *
   * @param bytes - Buffer of data to encode.
   * @param opts - Options object including the version bytes and the expected length of the data to encode.
   */
  encode(c, u) {
    const p = u.versions;
    return this._encodeVersioned(c, p, u.expectedLength);
  }
  /**
   * Decoder.
   *
   * @param base58string - Base58Check-encoded string to decode.
   * @param opts - Options object including the version byte(s) and the expected length of the data after decoding.
   */
  /* eslint-disable max-lines-per-function --
   * TODO refactor */
  decode(c, u) {
    var p;
    const a = u.versions, A = u.versionTypes, b = this.decodeChecked(c);
    if (a.length > 1 && !u.expectedLength)
      throw new Error("expectedLength is required because there are >= 2 possible versions");
    const F = typeof a[0] == "number" ? 1 : a[0].length, le = (p = u.expectedLength) !== null && p !== void 0 ? p : b.length - F, L = b.slice(0, -le), pe = b.slice(-le);
    for (let $ = 0; $ < a.length; $++) {
      const Ee = Array.isArray(a[$]) ? a[$] : [a[$]];
      if ((0, utils_1$6.seqEqual)(L, Ee))
        return {
          version: Ee,
          bytes: pe,
          type: A ? A[$] : null
        };
    }
    throw new Error("version_invalid: version bytes do not match any of the provided version(s)");
  }
  encodeChecked(c) {
    const u = this._sha256(this._sha256(c)).slice(0, 4);
    return this._encodeRaw(Buffer$f.from((0, utils_1$6.concatArgs)(c, u)));
  }
  decodeChecked(c) {
    const u = this._decodeRaw(c);
    if (u.length < 5)
      throw new Error("invalid_input_size: decoded data must have length >= 5");
    if (!this._verifyCheckSum(u))
      throw new Error("checksum_invalid");
    return u.slice(0, -4);
  }
  _encodeVersioned(c, u, p) {
    if (p && c.length !== p)
      throw new Error("unexpected_payload_length: bytes.length does not match expectedLength. Ensure that the bytes are a Buffer.");
    return this.encodeChecked(Buffer$f.from((0, utils_1$6.concatArgs)(u, c)));
  }
  _encodeRaw(c) {
    return this._codec.encode(c);
  }
  /* eslint-enable max-lines-per-function */
  _decodeRaw(c) {
    return this._codec.decode(c);
  }
  _verifyCheckSum(c) {
    const u = this._sha256(this._sha256(c.slice(0, -4))).slice(0, 4), p = c.slice(-4);
    return (0, utils_1$6.seqEqual)(u, p);
  }
}
const ACCOUNT_ID = 0, ACCOUNT_PUBLIC_KEY = 35, FAMILY_SEED = 33, NODE_PUBLIC = 28, ED25519_SEED = [1, 225, 75], codecOptions = {
  sha256(n) {
    return createHash$2("sha256").update(Buffer$f.from(n)).digest();
  },
  alphabet: "rpshnaf39wBUDNEGHJKLM4PQRST7VWXYZ2bcdeCg65jkm8oFqi1tuvAxyz"
}, codecWithXrpAlphabet = new Codec(codecOptions);
xrpCodec.codec = codecWithXrpAlphabet;
function encodeSeed(n, c) {
  if (n.length !== 16)
    throw new Error("entropy must have length 16");
  const u = {
    expectedLength: 16,
    // for secp256k1, use `FAMILY_SEED`
    versions: c === "ed25519" ? ED25519_SEED : [FAMILY_SEED]
  };
  return codecWithXrpAlphabet.encode(n, u);
}
xrpCodec.encodeSeed = encodeSeed;
function decodeSeed(n, c = {
  versionTypes: ["ed25519", "secp256k1"],
  versions: [ED25519_SEED, FAMILY_SEED],
  expectedLength: 16
}) {
  return codecWithXrpAlphabet.decode(n, c);
}
xrpCodec.decodeSeed = decodeSeed;
function encodeAccountID(n) {
  const c = { versions: [ACCOUNT_ID], expectedLength: 20 };
  return codecWithXrpAlphabet.encode(n, c);
}
xrpCodec.encodeAccountID = encodeAccountID;
xrpCodec.encodeAddress = encodeAccountID;
function decodeAccountID(n) {
  const c = { versions: [ACCOUNT_ID], expectedLength: 20 };
  return codecWithXrpAlphabet.decode(n, c).bytes;
}
xrpCodec.decodeAccountID = decodeAccountID;
xrpCodec.decodeAddress = decodeAccountID;
function decodeNodePublic(n) {
  const c = { versions: [NODE_PUBLIC], expectedLength: 33 };
  return codecWithXrpAlphabet.decode(n, c).bytes;
}
xrpCodec.decodeNodePublic = decodeNodePublic;
function encodeNodePublic(n) {
  const c = { versions: [NODE_PUBLIC], expectedLength: 33 };
  return codecWithXrpAlphabet.encode(n, c);
}
xrpCodec.encodeNodePublic = encodeNodePublic;
function encodeAccountPublic(n) {
  const c = { versions: [ACCOUNT_PUBLIC_KEY], expectedLength: 33 };
  return codecWithXrpAlphabet.encode(n, c);
}
xrpCodec.encodeAccountPublic = encodeAccountPublic;
function decodeAccountPublic(n) {
  const c = { versions: [ACCOUNT_PUBLIC_KEY], expectedLength: 33 };
  return codecWithXrpAlphabet.decode(n, c).bytes;
}
xrpCodec.decodeAccountPublic = decodeAccountPublic;
function isValidClassicAddress(n) {
  try {
    decodeAccountID(n);
  } catch {
    return !1;
  }
  return !0;
}
xrpCodec.isValidClassicAddress = isValidClassicAddress;
(function(n) {
  var c = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(Pe, nr, ir, or) {
    or === void 0 && (or = ir);
    var lr = Object.getOwnPropertyDescriptor(nr, ir);
    (!lr || ("get" in lr ? !nr.__esModule : lr.writable || lr.configurable)) && (lr = { enumerable: !0, get: function() {
      return nr[ir];
    } }), Object.defineProperty(Pe, or, lr);
  } : function(Pe, nr, ir, or) {
    or === void 0 && (or = ir), Pe[or] = nr[ir];
  }), u = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(Pe, nr) {
    Object.defineProperty(Pe, "default", { enumerable: !0, value: nr });
  } : function(Pe, nr) {
    Pe.default = nr;
  }), p = commonjsGlobal && commonjsGlobal.__importStar || function(Pe) {
    if (Pe && Pe.__esModule) return Pe;
    var nr = {};
    if (Pe != null) for (var ir in Pe) ir !== "default" && Object.prototype.hasOwnProperty.call(Pe, ir) && c(nr, Pe, ir);
    return u(nr, Pe), nr;
  };
  Object.defineProperty(n, "__esModule", { value: !0 }), n.isValidXAddress = n.decodeXAddress = n.xAddressToClassicAddress = n.encodeXAddress = n.classicAddressToXAddress = n.isValidClassicAddress = n.decodeAccountPublic = n.encodeAccountPublic = n.decodeNodePublic = n.encodeNodePublic = n.decodeAccountID = n.encodeAccountID = n.decodeSeed = n.encodeSeed = n.codec = void 0;
  const a = p(requireAssert()), A = xrpCodec;
  Object.defineProperty(n, "codec", { enumerable: !0, get: function() {
    return A.codec;
  } }), Object.defineProperty(n, "encodeSeed", { enumerable: !0, get: function() {
    return A.encodeSeed;
  } }), Object.defineProperty(n, "decodeSeed", { enumerable: !0, get: function() {
    return A.decodeSeed;
  } }), Object.defineProperty(n, "encodeAccountID", { enumerable: !0, get: function() {
    return A.encodeAccountID;
  } }), Object.defineProperty(n, "decodeAccountID", { enumerable: !0, get: function() {
    return A.decodeAccountID;
  } }), Object.defineProperty(n, "encodeNodePublic", { enumerable: !0, get: function() {
    return A.encodeNodePublic;
  } }), Object.defineProperty(n, "decodeNodePublic", { enumerable: !0, get: function() {
    return A.decodeNodePublic;
  } }), Object.defineProperty(n, "encodeAccountPublic", { enumerable: !0, get: function() {
    return A.encodeAccountPublic;
  } }), Object.defineProperty(n, "decodeAccountPublic", { enumerable: !0, get: function() {
    return A.decodeAccountPublic;
  } }), Object.defineProperty(n, "isValidClassicAddress", { enumerable: !0, get: function() {
    return A.isValidClassicAddress;
  } });
  const b = {
    // 5, 68
    main: Buffer$f.from([5, 68]),
    // 4, 147
    test: Buffer$f.from([4, 147])
  }, F = 4294967295;
  function le(Pe, nr, ir) {
    const or = (0, A.decodeAccountID)(Pe);
    return L(or, nr, ir);
  }
  n.classicAddressToXAddress = le;
  function L(Pe, nr, ir) {
    if (Pe.length !== 20)
      throw new Error("Account ID must be 20 bytes");
    if (nr > F)
      throw new Error("Invalid tag");
    const or = nr || 0, lr = nr === !1 || nr == null ? 0 : 1, Ir = Buffer$f.concat([
      ir ? b.test : b.main,
      Pe,
      Buffer$f.from([
        // 0x00 if no tag, 0x01 if 32-bit tag
        lr,
        // first byte
        or & 255,
        // second byte
        or >> 8 & 255,
        // third byte
        or >> 16 & 255,
        // fourth byte
        or >> 24 & 255,
        0,
        0,
        0,
        // four zero bytes (reserved for 64-bit tags)
        0
      ])
    ]);
    return A.codec.encodeChecked(Ir);
  }
  n.encodeXAddress = L;
  function pe(Pe) {
    const { accountId: nr, tag: ir, test: or } = $(Pe);
    return {
      classicAddress: (0, A.encodeAccountID)(nr),
      tag: ir,
      test: or
    };
  }
  n.xAddressToClassicAddress = pe;
  function $(Pe) {
    const nr = A.codec.decodeChecked(Pe), ir = Ee(nr), or = nr.slice(2, 22), lr = be(nr);
    return {
      accountId: or,
      tag: lr,
      test: ir
    };
  }
  n.decodeXAddress = $;
  function Ee(Pe) {
    const nr = Pe.slice(0, 2);
    if (b.main.equals(nr))
      return !1;
    if (b.test.equals(nr))
      return !0;
    throw new Error("Invalid X-address: bad prefix");
  }
  function be(Pe) {
    const nr = Pe[22];
    if (nr >= 2)
      throw new Error("Unsupported X-address");
    return nr === 1 ? Pe[23] + Pe[24] * 256 + Pe[25] * 65536 + Pe[26] * 16777216 : (a.strictEqual(nr, 0, "flag must be zero to indicate no tag"), a.ok(Buffer$f.from("0000000000000000", "hex").equals(Pe.slice(23, 31)), "remaining bytes must be zero"), !1);
  }
  function He(Pe) {
    try {
      $(Pe);
    } catch {
      return !1;
    }
    return !0;
  }
  n.isValidXAddress = He;
})(dist$2);
var hash160$4 = {}, hash$6 = {};
Object.defineProperty(hash$6, "__esModule", { value: !0 });
hash$6.Hash = void 0;
const serialized_type_1$7 = serializedType, buffer_1$j = dist$u;
let Hash$6 = class extends serialized_type_1$7.Comparable {
  constructor(c) {
    if (super(c), this.bytes.byteLength !== this.constructor.width)
      throw new Error(`Invalid Hash length ${this.bytes.byteLength}`);
  }
  /**
   * Construct a Hash object from an existing Hash object or a hex-string
   *
   * @param value A hash object or hex-string of a hash
   */
  static from(c) {
    if (c instanceof this)
      return c;
    if (typeof c == "string")
      return new this(buffer_1$j.Buffer.from(c, "hex"));
    throw new Error("Cannot construct Hash from given value");
  }
  /**
   * Read a Hash object from a BinaryParser
   *
   * @param parser BinaryParser to read the hash from
   * @param hint length of the bytes to read, optional
   */
  static fromParser(c, u) {
    return new this(c.read(u ?? this.width));
  }
  /**
   * Overloaded operator for comparing two hash objects
   *
   * @param other The Hash to compare this to
   */
  compareTo(c) {
    return this.bytes.compare(this.constructor.from(c).bytes);
  }
  /**
   * @returns the hex-string representation of this Hash
   */
  toString() {
    return this.toHex();
  }
  /**
   * Returns four bits at the specified depth within a hash
   *
   * @param depth The depth of the four bits
   * @returns The number represented by the four bits
   */
  nibblet(c) {
    const u = c > 0 ? c / 2 | 0 : 0;
    let p = this.bytes[u];
    return c % 2 === 0 ? p = (p & 240) >>> 4 : p = p & 15, p;
  }
};
hash$6.Hash = Hash$6;
Object.defineProperty(hash160$4, "__esModule", { value: !0 });
hash160$4.Hash160 = void 0;
const hash_1$2 = hash$6, buffer_1$i = dist$u;
class Hash160 extends hash_1$2.Hash {
  constructor(c) {
    c && c.byteLength === 0 && (c = Hash160.ZERO_160.bytes), super(c ?? Hash160.ZERO_160.bytes);
  }
}
hash160$4.Hash160 = Hash160;
Hash160.width = 20;
Hash160.ZERO_160 = new Hash160(buffer_1$i.Buffer.alloc(Hash160.width));
Object.defineProperty(accountId, "__esModule", { value: !0 });
accountId.AccountID = void 0;
const ripple_address_codec_1 = dist$2, hash_160_1$1 = hash160$4, buffer_1$h = dist$u, HEX_REGEX$2 = /^[A-F0-9]{40}$/;
class AccountID extends hash_160_1$1.Hash160 {
  constructor(c) {
    super(c ?? AccountID.defaultAccountID.bytes);
  }
  /**
   * Defines how to construct an AccountID
   *
   * @param value either an existing AccountID, a hex-string, or a base58 r-Address
   * @returns an AccountID object
   */
  static from(c) {
    if (c instanceof AccountID)
      return c;
    if (typeof c == "string")
      return c === "" ? new AccountID() : HEX_REGEX$2.test(c) ? new AccountID(buffer_1$h.Buffer.from(c, "hex")) : this.fromBase58(c);
    throw new Error("Cannot construct AccountID from value given");
  }
  /**
   * Defines how to build an AccountID from a base58 r-Address
   *
   * @param value a base58 r-Address
   * @returns an AccountID object
   */
  static fromBase58(c) {
    if ((0, ripple_address_codec_1.isValidXAddress)(c)) {
      const u = (0, ripple_address_codec_1.xAddressToClassicAddress)(c);
      if (u.tag !== !1)
        throw new Error("Only allowed to have tag on Account or Destination");
      c = u.classicAddress;
    }
    return new AccountID(buffer_1$h.Buffer.from((0, ripple_address_codec_1.decodeAccountID)(c)));
  }
  /**
   * Overload of toJSON
   *
   * @returns the base58 string for this AccountID
   */
  toJSON() {
    return this.toBase58();
  }
  /**
   * Defines how to encode AccountID into a base58 address
   *
   * @returns the base58 string defined by this.bytes
   */
  toBase58() {
    return (0, ripple_address_codec_1.encodeAccountID)(this.bytes);
  }
}
accountId.AccountID = AccountID;
AccountID.defaultAccountID = new AccountID(buffer_1$h.Buffer.alloc(20));
var amount = {}, decimal$2 = { exports: {} };
(function(n) {
  (function(c) {
    var u = 9e15, p = 1e9, a = "0123456789abcdef", A = "2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058", b = "3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789", F = {
      // These values must be integers within the stated ranges (inclusive).
      // Most of these values can be changed at run-time using the `Decimal.config` method.
      // The maximum number of significant digits of the result of a calculation or base conversion.
      // E.g. `Decimal.config({ precision: 20 });`
      precision: 20,
      // 1 to MAX_DIGITS
      // The rounding mode used when rounding to `precision`.
      //
      // ROUND_UP         0 Away from zero.
      // ROUND_DOWN       1 Towards zero.
      // ROUND_CEIL       2 Towards +Infinity.
      // ROUND_FLOOR      3 Towards -Infinity.
      // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
      // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
      // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
      // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
      // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
      //
      // E.g.
      // `Decimal.rounding = 4;`
      // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
      rounding: 4,
      // 0 to 8
      // The modulo mode used when calculating the modulus: a mod n.
      // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
      // The remainder (r) is calculated as: r = a - n * q.
      //
      // UP         0 The remainder is positive if the dividend is negative, else is negative.
      // DOWN       1 The remainder has the same sign as the dividend (JavaScript %).
      // FLOOR      3 The remainder has the same sign as the divisor (Python %).
      // HALF_EVEN  6 The IEEE 754 remainder function.
      // EUCLID     9 Euclidian division. q = sign(n) * floor(a / abs(n)). Always positive.
      //
      // Truncated division (1), floored division (3), the IEEE 754 remainder (6), and Euclidian
      // division (9) are commonly used for the modulus operation. The other rounding modes can also
      // be used, but they may not give useful results.
      modulo: 1,
      // 0 to 9
      // The exponent value at and beneath which `toString` returns exponential notation.
      // JavaScript numbers: -7
      toExpNeg: -7,
      // 0 to -EXP_LIMIT
      // The exponent value at and above which `toString` returns exponential notation.
      // JavaScript numbers: 21
      toExpPos: 21,
      // 0 to EXP_LIMIT
      // The minimum exponent value, beneath which underflow to zero occurs.
      // JavaScript numbers: -324  (5e-324)
      minE: -u,
      // -1 to -EXP_LIMIT
      // The maximum exponent value, above which overflow to Infinity occurs.
      // JavaScript numbers: 308  (1.7976931348623157e+308)
      maxE: u,
      // 1 to EXP_LIMIT
      // Whether to use cryptographically-secure random number generation, if available.
      crypto: !1
      // true/false
    }, le, L, pe, $, Ee = !0, be = "[DecimalError] ", He = be + "Invalid argument: ", Pe = be + "Precision limit exceeded", nr = be + "crypto unavailable", ir = "[object Decimal]", or = Math.floor, lr = Math.pow, Ir = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i, xr = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i, kr = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i, Ce = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, tr = 1e7, Fe = 7, Sr = 9007199254740991, er = A.length - 1, Ie = b.length - 1, xe = { toStringTag: ir };
    xe.absoluteValue = xe.abs = function() {
      var oi = new this.constructor(this);
      return oi.s < 0 && (oi.s = 1), Te(oi);
    }, xe.ceil = function() {
      return Te(new this.constructor(this), this.e + 1, 2);
    }, xe.clampedTo = xe.clamp = function(oi, Yr) {
      var ji, Cn = this, Mn = Cn.constructor;
      if (oi = new Mn(oi), Yr = new Mn(Yr), !oi.s || !Yr.s) return new Mn(NaN);
      if (oi.gt(Yr)) throw Error(He + Yr);
      return ji = Cn.cmp(oi), ji < 0 ? oi : Cn.cmp(Yr) > 0 ? Yr : new Mn(Cn);
    }, xe.comparedTo = xe.cmp = function(oi) {
      var Yr, ji, Cn, Mn, B = this, o = B.d, m = (oi = new B.constructor(oi)).d, d = B.s, v = oi.s;
      if (!o || !m)
        return !d || !v ? NaN : d !== v ? d : o === m ? 0 : !o ^ d < 0 ? 1 : -1;
      if (!o[0] || !m[0]) return o[0] ? d : m[0] ? -v : 0;
      if (d !== v) return d;
      if (B.e !== oi.e) return B.e > oi.e ^ d < 0 ? 1 : -1;
      for (Cn = o.length, Mn = m.length, Yr = 0, ji = Cn < Mn ? Cn : Mn; Yr < ji; ++Yr)
        if (o[Yr] !== m[Yr]) return o[Yr] > m[Yr] ^ d < 0 ? 1 : -1;
      return Cn === Mn ? 0 : Cn > Mn ^ d < 0 ? 1 : -1;
    }, xe.cosine = xe.cos = function() {
      var oi, Yr, ji = this, Cn = ji.constructor;
      return ji.d ? ji.d[0] ? (oi = Cn.precision, Yr = Cn.rounding, Cn.precision = oi + Math.max(ji.e, ji.sd()) + Fe, Cn.rounding = 1, ji = Or(Cn, Er(Cn, ji)), Cn.precision = oi, Cn.rounding = Yr, Te($ == 2 || $ == 3 ? ji.neg() : ji, oi, Yr, !0)) : new Cn(1) : new Cn(NaN);
    }, xe.cubeRoot = xe.cbrt = function() {
      var oi, Yr, ji, Cn, Mn, B, o, m, d, v, he = this, we = he.constructor;
      if (!he.isFinite() || he.isZero()) return new we(he);
      for (Ee = !1, B = he.s * lr(he.s * he, 1 / 3), !B || Math.abs(B) == 1 / 0 ? (ji = rr(he.d), oi = he.e, (B = (oi - ji.length + 1) % 3) && (ji += B == 1 || B == -2 ? "0" : "00"), B = lr(ji, 1 / 3), oi = or((oi + 1) / 3) - (oi % 3 == (oi < 0 ? -1 : 2)), B == 1 / 0 ? ji = "5e" + oi : (ji = B.toExponential(), ji = ji.slice(0, ji.indexOf("e") + 1) + oi), Cn = new we(ji), Cn.s = he.s) : Cn = new we(B.toString()), o = (oi = we.precision) + 3; ; )
        if (m = Cn, d = m.times(m).times(m), v = d.plus(he), Cn = vr(v.plus(he).times(m), v.plus(d), o + 2, 1), rr(m.d).slice(0, o) === (ji = rr(Cn.d)).slice(0, o))
          if (ji = ji.slice(o - 3, o + 1), ji == "9999" || !Mn && ji == "4999") {
            if (!Mn && (Te(m, oi + 1, 0), m.times(m).times(m).eq(he))) {
              Cn = m;
              break;
            }
            o += 4, Mn = 1;
          } else {
            (!+ji || !+ji.slice(1) && ji.charAt(0) == "5") && (Te(Cn, oi + 1, 1), Yr = !Cn.times(Cn).times(Cn).eq(he));
            break;
          }
      return Ee = !0, Te(Cn, oi, we.rounding, Yr);
    }, xe.decimalPlaces = xe.dp = function() {
      var oi, Yr = this.d, ji = NaN;
      if (Yr) {
        if (oi = Yr.length - 1, ji = (oi - or(this.e / Fe)) * Fe, oi = Yr[oi], oi) for (; oi % 10 == 0; oi /= 10) ji--;
        ji < 0 && (ji = 0);
      }
      return ji;
    }, xe.dividedBy = xe.div = function(oi) {
      return vr(this, new this.constructor(oi));
    }, xe.dividedToIntegerBy = xe.divToInt = function(oi) {
      var Yr = this, ji = Yr.constructor;
      return Te(vr(Yr, new ji(oi), 0, 1, 1), ji.precision, ji.rounding);
    }, xe.equals = xe.eq = function(oi) {
      return this.cmp(oi) === 0;
    }, xe.floor = function() {
      return Te(new this.constructor(this), this.e + 1, 3);
    }, xe.greaterThan = xe.gt = function(oi) {
      return this.cmp(oi) > 0;
    }, xe.greaterThanOrEqualTo = xe.gte = function(oi) {
      var Yr = this.cmp(oi);
      return Yr == 1 || Yr === 0;
    }, xe.hyperbolicCosine = xe.cosh = function() {
      var oi, Yr, ji, Cn, Mn, B = this, o = B.constructor, m = new o(1);
      if (!B.isFinite()) return new o(B.s ? 1 / 0 : NaN);
      if (B.isZero()) return m;
      ji = o.precision, Cn = o.rounding, o.precision = ji + Math.max(B.e, B.sd()) + 4, o.rounding = 1, Mn = B.d.length, Mn < 32 ? (oi = Math.ceil(Mn / 3), Yr = (1 / _i(4, oi)).toString()) : (oi = 16, Yr = "2.3283064365386962890625e-10"), B = ri(o, 1, B.times(Yr), new o(1), !0);
      for (var d, v = oi, he = new o(8); v--; )
        d = B.times(B), B = m.minus(d.times(he.minus(d.times(he))));
      return Te(B, o.precision = ji, o.rounding = Cn, !0);
    }, xe.hyperbolicSine = xe.sinh = function() {
      var oi, Yr, ji, Cn, Mn = this, B = Mn.constructor;
      if (!Mn.isFinite() || Mn.isZero()) return new B(Mn);
      if (Yr = B.precision, ji = B.rounding, B.precision = Yr + Math.max(Mn.e, Mn.sd()) + 4, B.rounding = 1, Cn = Mn.d.length, Cn < 3)
        Mn = ri(B, 2, Mn, Mn, !0);
      else {
        oi = 1.4 * Math.sqrt(Cn), oi = oi > 16 ? 16 : oi | 0, Mn = Mn.times(1 / _i(5, oi)), Mn = ri(B, 2, Mn, Mn, !0);
        for (var o, m = new B(5), d = new B(16), v = new B(20); oi--; )
          o = Mn.times(Mn), Mn = Mn.times(m.plus(o.times(d.times(o).plus(v))));
      }
      return B.precision = Yr, B.rounding = ji, Te(Mn, Yr, ji, !0);
    }, xe.hyperbolicTangent = xe.tanh = function() {
      var oi, Yr, ji = this, Cn = ji.constructor;
      return ji.isFinite() ? ji.isZero() ? new Cn(ji) : (oi = Cn.precision, Yr = Cn.rounding, Cn.precision = oi + 7, Cn.rounding = 1, vr(ji.sinh(), ji.cosh(), Cn.precision = oi, Cn.rounding = Yr)) : new Cn(ji.s);
    }, xe.inverseCosine = xe.acos = function() {
      var oi, Yr = this, ji = Yr.constructor, Cn = Yr.abs().cmp(1), Mn = ji.precision, B = ji.rounding;
      return Cn !== -1 ? Cn === 0 ? Yr.isNeg() ? ui(ji, Mn, B) : new ji(0) : new ji(NaN) : Yr.isZero() ? ui(ji, Mn + 4, B).times(0.5) : (ji.precision = Mn + 6, ji.rounding = 1, Yr = Yr.asin(), oi = ui(ji, Mn + 4, B).times(0.5), ji.precision = Mn, ji.rounding = B, oi.minus(Yr));
    }, xe.inverseHyperbolicCosine = xe.acosh = function() {
      var oi, Yr, ji = this, Cn = ji.constructor;
      return ji.lte(1) ? new Cn(ji.eq(1) ? 0 : NaN) : ji.isFinite() ? (oi = Cn.precision, Yr = Cn.rounding, Cn.precision = oi + Math.max(Math.abs(ji.e), ji.sd()) + 4, Cn.rounding = 1, Ee = !1, ji = ji.times(ji).minus(1).sqrt().plus(ji), Ee = !0, Cn.precision = oi, Cn.rounding = Yr, ji.ln()) : new Cn(ji);
    }, xe.inverseHyperbolicSine = xe.asinh = function() {
      var oi, Yr, ji = this, Cn = ji.constructor;
      return !ji.isFinite() || ji.isZero() ? new Cn(ji) : (oi = Cn.precision, Yr = Cn.rounding, Cn.precision = oi + 2 * Math.max(Math.abs(ji.e), ji.sd()) + 6, Cn.rounding = 1, Ee = !1, ji = ji.times(ji).plus(1).sqrt().plus(ji), Ee = !0, Cn.precision = oi, Cn.rounding = Yr, ji.ln());
    }, xe.inverseHyperbolicTangent = xe.atanh = function() {
      var oi, Yr, ji, Cn, Mn = this, B = Mn.constructor;
      return Mn.isFinite() ? Mn.e >= 0 ? new B(Mn.abs().eq(1) ? Mn.s / 0 : Mn.isZero() ? Mn : NaN) : (oi = B.precision, Yr = B.rounding, Cn = Mn.sd(), Math.max(Cn, oi) < 2 * -Mn.e - 1 ? Te(new B(Mn), oi, Yr, !0) : (B.precision = ji = Cn - Mn.e, Mn = vr(Mn.plus(1), new B(1).minus(Mn), ji + oi, 1), B.precision = oi + 4, B.rounding = 1, Mn = Mn.ln(), B.precision = oi, B.rounding = Yr, Mn.times(0.5))) : new B(NaN);
    }, xe.inverseSine = xe.asin = function() {
      var oi, Yr, ji, Cn, Mn = this, B = Mn.constructor;
      return Mn.isZero() ? new B(Mn) : (Yr = Mn.abs().cmp(1), ji = B.precision, Cn = B.rounding, Yr !== -1 ? Yr === 0 ? (oi = ui(B, ji + 4, Cn).times(0.5), oi.s = Mn.s, oi) : new B(NaN) : (B.precision = ji + 6, B.rounding = 1, Mn = Mn.div(new B(1).minus(Mn.times(Mn)).sqrt().plus(1)).atan(), B.precision = ji, B.rounding = Cn, Mn.times(2)));
    }, xe.inverseTangent = xe.atan = function() {
      var oi, Yr, ji, Cn, Mn, B, o, m, d, v = this, he = v.constructor, we = he.precision, Be = he.rounding;
      if (v.isFinite()) {
        if (v.isZero())
          return new he(v);
        if (v.abs().eq(1) && we + 4 <= Ie)
          return o = ui(he, we + 4, Be).times(0.25), o.s = v.s, o;
      } else {
        if (!v.s) return new he(NaN);
        if (we + 4 <= Ie)
          return o = ui(he, we + 4, Be).times(0.5), o.s = v.s, o;
      }
      for (he.precision = m = we + 10, he.rounding = 1, ji = Math.min(28, m / Fe + 2 | 0), oi = ji; oi; --oi) v = v.div(v.times(v).plus(1).sqrt().plus(1));
      for (Ee = !1, Yr = Math.ceil(m / Fe), Cn = 1, d = v.times(v), o = new he(v), Mn = v; oi !== -1; )
        if (Mn = Mn.times(d), B = o.minus(Mn.div(Cn += 2)), Mn = Mn.times(d), o = B.plus(Mn.div(Cn += 2)), o.d[Yr] !== void 0) for (oi = Yr; o.d[oi] === B.d[oi] && oi--; ) ;
      return ji && (o = o.times(2 << ji - 1)), Ee = !0, Te(o, he.precision = we, he.rounding = Be, !0);
    }, xe.isFinite = function() {
      return !!this.d;
    }, xe.isInteger = xe.isInt = function() {
      return !!this.d && or(this.e / Fe) > this.d.length - 2;
    }, xe.isNaN = function() {
      return !this.s;
    }, xe.isNegative = xe.isNeg = function() {
      return this.s < 0;
    }, xe.isPositive = xe.isPos = function() {
      return this.s > 0;
    }, xe.isZero = function() {
      return !!this.d && this.d[0] === 0;
    }, xe.lessThan = xe.lt = function(oi) {
      return this.cmp(oi) < 0;
    }, xe.lessThanOrEqualTo = xe.lte = function(oi) {
      return this.cmp(oi) < 1;
    }, xe.logarithm = xe.log = function(oi) {
      var Yr, ji, Cn, Mn, B, o, m, d, v = this, he = v.constructor, we = he.precision, Be = he.rounding, Me = 5;
      if (oi == null)
        oi = new he(10), Yr = !0;
      else {
        if (oi = new he(oi), ji = oi.d, oi.s < 0 || !ji || !ji[0] || oi.eq(1)) return new he(NaN);
        Yr = oi.eq(10);
      }
      if (ji = v.d, v.s < 0 || !ji || !ji[0] || v.eq(1))
        return new he(ji && !ji[0] ? -1 / 0 : v.s != 1 ? NaN : ji ? 0 : 1 / 0);
      if (Yr)
        if (ji.length > 1)
          B = !0;
        else {
          for (Mn = ji[0]; Mn % 10 === 0; ) Mn /= 10;
          B = Mn !== 1;
        }
      if (Ee = !1, m = we + Me, o = ei(v, m), Cn = Yr ? si(he, m + 10) : ei(oi, m), d = vr(o, Cn, m, 1), yr(d.d, Mn = we, Be))
        do
          if (m += 10, o = ei(v, m), Cn = Yr ? si(he, m + 10) : ei(oi, m), d = vr(o, Cn, m, 1), !B) {
            +rr(d.d).slice(Mn + 1, Mn + 15) + 1 == 1e14 && (d = Te(d, we + 1, 0));
            break;
          }
        while (yr(d.d, Mn += 10, Be));
      return Ee = !0, Te(d, we, Be);
    }, xe.minus = xe.sub = function(oi) {
      var Yr, ji, Cn, Mn, B, o, m, d, v, he, we, Be, Me = this, fr = Me.constructor;
      if (oi = new fr(oi), !Me.d || !oi.d)
        return !Me.s || !oi.s ? oi = new fr(NaN) : Me.d ? oi.s = -oi.s : oi = new fr(oi.d || Me.s !== oi.s ? Me : NaN), oi;
      if (Me.s != oi.s)
        return oi.s = -oi.s, Me.plus(oi);
      if (v = Me.d, Be = oi.d, m = fr.precision, d = fr.rounding, !v[0] || !Be[0]) {
        if (Be[0]) oi.s = -oi.s;
        else if (v[0]) oi = new fr(Me);
        else return new fr(d === 3 ? -0 : 0);
        return Ee ? Te(oi, m, d) : oi;
      }
      if (ji = or(oi.e / Fe), he = or(Me.e / Fe), v = v.slice(), B = he - ji, B) {
        for (we = B < 0, we ? (Yr = v, B = -B, o = Be.length) : (Yr = Be, ji = he, o = v.length), Cn = Math.max(Math.ceil(m / Fe), o) + 2, B > Cn && (B = Cn, Yr.length = 1), Yr.reverse(), Cn = B; Cn--; ) Yr.push(0);
        Yr.reverse();
      } else {
        for (Cn = v.length, o = Be.length, we = Cn < o, we && (o = Cn), Cn = 0; Cn < o; Cn++)
          if (v[Cn] != Be[Cn]) {
            we = v[Cn] < Be[Cn];
            break;
          }
        B = 0;
      }
      for (we && (Yr = v, v = Be, Be = Yr, oi.s = -oi.s), o = v.length, Cn = Be.length - o; Cn > 0; --Cn) v[o++] = 0;
      for (Cn = Be.length; Cn > B; ) {
        if (v[--Cn] < Be[Cn]) {
          for (Mn = Cn; Mn && v[--Mn] === 0; ) v[Mn] = tr - 1;
          --v[Mn], v[Cn] += tr;
        }
        v[Cn] -= Be[Cn];
      }
      for (; v[--o] === 0; ) v.pop();
      for (; v[0] === 0; v.shift()) --ji;
      return v[0] ? (oi.d = v, oi.e = Hr(v, ji), Ee ? Te(oi, m, d) : oi) : new fr(d === 3 ? -0 : 0);
    }, xe.modulo = xe.mod = function(oi) {
      var Yr, ji = this, Cn = ji.constructor;
      return oi = new Cn(oi), !ji.d || !oi.s || oi.d && !oi.d[0] ? new Cn(NaN) : !oi.d || ji.d && !ji.d[0] ? Te(new Cn(ji), Cn.precision, Cn.rounding) : (Ee = !1, Cn.modulo == 9 ? (Yr = vr(ji, oi.abs(), 0, 3, 1), Yr.s *= oi.s) : Yr = vr(ji, oi, 0, Cn.modulo, 1), Yr = Yr.times(oi), Ee = !0, ji.minus(Yr));
    }, xe.naturalExponential = xe.exp = function() {
      return pi(this);
    }, xe.naturalLogarithm = xe.ln = function() {
      return ei(this);
    }, xe.negated = xe.neg = function() {
      var oi = new this.constructor(this);
      return oi.s = -oi.s, Te(oi);
    }, xe.plus = xe.add = function(oi) {
      var Yr, ji, Cn, Mn, B, o, m, d, v, he, we = this, Be = we.constructor;
      if (oi = new Be(oi), !we.d || !oi.d)
        return !we.s || !oi.s ? oi = new Be(NaN) : we.d || (oi = new Be(oi.d || we.s === oi.s ? we : NaN)), oi;
      if (we.s != oi.s)
        return oi.s = -oi.s, we.minus(oi);
      if (v = we.d, he = oi.d, m = Be.precision, d = Be.rounding, !v[0] || !he[0])
        return he[0] || (oi = new Be(we)), Ee ? Te(oi, m, d) : oi;
      if (B = or(we.e / Fe), Cn = or(oi.e / Fe), v = v.slice(), Mn = B - Cn, Mn) {
        for (Mn < 0 ? (ji = v, Mn = -Mn, o = he.length) : (ji = he, Cn = B, o = v.length), B = Math.ceil(m / Fe), o = B > o ? B + 1 : o + 1, Mn > o && (Mn = o, ji.length = 1), ji.reverse(); Mn--; ) ji.push(0);
        ji.reverse();
      }
      for (o = v.length, Mn = he.length, o - Mn < 0 && (Mn = o, ji = he, he = v, v = ji), Yr = 0; Mn; )
        Yr = (v[--Mn] = v[Mn] + he[Mn] + Yr) / tr | 0, v[Mn] %= tr;
      for (Yr && (v.unshift(Yr), ++Cn), o = v.length; v[--o] == 0; ) v.pop();
      return oi.d = v, oi.e = Hr(v, Cn), Ee ? Te(oi, m, d) : oi;
    }, xe.precision = xe.sd = function(oi) {
      var Yr, ji = this;
      if (oi !== void 0 && oi !== !!oi && oi !== 1 && oi !== 0) throw Error(He + oi);
      return ji.d ? (Yr = Li(ji.d), oi && ji.e + 1 > Yr && (Yr = ji.e + 1)) : Yr = NaN, Yr;
    }, xe.round = function() {
      var oi = this, Yr = oi.constructor;
      return Te(new Yr(oi), oi.e + 1, Yr.rounding);
    }, xe.sine = xe.sin = function() {
      var oi, Yr, ji = this, Cn = ji.constructor;
      return ji.isFinite() ? ji.isZero() ? new Cn(ji) : (oi = Cn.precision, Yr = Cn.rounding, Cn.precision = oi + Math.max(ji.e, ji.sd()) + Fe, Cn.rounding = 1, ji = Wr(Cn, Er(Cn, ji)), Cn.precision = oi, Cn.rounding = Yr, Te($ > 2 ? ji.neg() : ji, oi, Yr, !0)) : new Cn(NaN);
    }, xe.squareRoot = xe.sqrt = function() {
      var oi, Yr, ji, Cn, Mn, B, o = this, m = o.d, d = o.e, v = o.s, he = o.constructor;
      if (v !== 1 || !m || !m[0])
        return new he(!v || v < 0 && (!m || m[0]) ? NaN : m ? o : 1 / 0);
      for (Ee = !1, v = Math.sqrt(+o), v == 0 || v == 1 / 0 ? (Yr = rr(m), (Yr.length + d) % 2 == 0 && (Yr += "0"), v = Math.sqrt(Yr), d = or((d + 1) / 2) - (d < 0 || d % 2), v == 1 / 0 ? Yr = "5e" + d : (Yr = v.toExponential(), Yr = Yr.slice(0, Yr.indexOf("e") + 1) + d), Cn = new he(Yr)) : Cn = new he(v.toString()), ji = (d = he.precision) + 3; ; )
        if (B = Cn, Cn = B.plus(vr(o, B, ji + 2, 1)).times(0.5), rr(B.d).slice(0, ji) === (Yr = rr(Cn.d)).slice(0, ji))
          if (Yr = Yr.slice(ji - 3, ji + 1), Yr == "9999" || !Mn && Yr == "4999") {
            if (!Mn && (Te(B, d + 1, 0), B.times(B).eq(o))) {
              Cn = B;
              break;
            }
            ji += 4, Mn = 1;
          } else {
            (!+Yr || !+Yr.slice(1) && Yr.charAt(0) == "5") && (Te(Cn, d + 1, 1), oi = !Cn.times(Cn).eq(o));
            break;
          }
      return Ee = !0, Te(Cn, d, he.rounding, oi);
    }, xe.tangent = xe.tan = function() {
      var oi, Yr, ji = this, Cn = ji.constructor;
      return ji.isFinite() ? ji.isZero() ? new Cn(ji) : (oi = Cn.precision, Yr = Cn.rounding, Cn.precision = oi + 10, Cn.rounding = 1, ji = ji.sin(), ji.s = 1, ji = vr(ji, new Cn(1).minus(ji.times(ji)).sqrt(), oi + 10, 0), Cn.precision = oi, Cn.rounding = Yr, Te($ == 2 || $ == 4 ? ji.neg() : ji, oi, Yr, !0)) : new Cn(NaN);
    }, xe.times = xe.mul = function(oi) {
      var Yr, ji, Cn, Mn, B, o, m, d, v, he = this, we = he.constructor, Be = he.d, Me = (oi = new we(oi)).d;
      if (oi.s *= he.s, !Be || !Be[0] || !Me || !Me[0])
        return new we(!oi.s || Be && !Be[0] && !Me || Me && !Me[0] && !Be ? NaN : !Be || !Me ? oi.s / 0 : oi.s * 0);
      for (ji = or(he.e / Fe) + or(oi.e / Fe), d = Be.length, v = Me.length, d < v && (B = Be, Be = Me, Me = B, o = d, d = v, v = o), B = [], o = d + v, Cn = o; Cn--; ) B.push(0);
      for (Cn = v; --Cn >= 0; ) {
        for (Yr = 0, Mn = d + Cn; Mn > Cn; )
          m = B[Mn] + Me[Cn] * Be[Mn - Cn - 1] + Yr, B[Mn--] = m % tr | 0, Yr = m / tr | 0;
        B[Mn] = (B[Mn] + Yr) % tr | 0;
      }
      for (; !B[--o]; ) B.pop();
      return Yr ? ++ji : B.shift(), oi.d = B, oi.e = Hr(B, ji), Ee ? Te(oi, we.precision, we.rounding) : oi;
    }, xe.toBinary = function(oi, Yr) {
      return Di(this, 2, oi, Yr);
    }, xe.toDecimalPlaces = xe.toDP = function(oi, Yr) {
      var ji = this, Cn = ji.constructor;
      return ji = new Cn(ji), oi === void 0 ? ji : (ar(oi, 0, p), Yr === void 0 ? Yr = Cn.rounding : ar(Yr, 0, 8), Te(ji, oi + ji.e + 1, Yr));
    }, xe.toExponential = function(oi, Yr) {
      var ji, Cn = this, Mn = Cn.constructor;
      return oi === void 0 ? ji = Cr(Cn, !0) : (ar(oi, 0, p), Yr === void 0 ? Yr = Mn.rounding : ar(Yr, 0, 8), Cn = Te(new Mn(Cn), oi + 1, Yr), ji = Cr(Cn, !0, oi + 1)), Cn.isNeg() && !Cn.isZero() ? "-" + ji : ji;
    }, xe.toFixed = function(oi, Yr) {
      var ji, Cn, Mn = this, B = Mn.constructor;
      return oi === void 0 ? ji = Cr(Mn) : (ar(oi, 0, p), Yr === void 0 ? Yr = B.rounding : ar(Yr, 0, 8), Cn = Te(new B(Mn), oi + Mn.e + 1, Yr), ji = Cr(Cn, !1, oi + Cn.e + 1)), Mn.isNeg() && !Mn.isZero() ? "-" + ji : ji;
    }, xe.toFraction = function(oi) {
      var Yr, ji, Cn, Mn, B, o, m, d, v, he, we, Be, Me = this, fr = Me.d, wr = Me.constructor;
      if (!fr) return new wr(Me);
      if (v = ji = new wr(1), Cn = d = new wr(0), Yr = new wr(Cn), B = Yr.e = Li(fr) - Me.e - 1, o = B % Fe, Yr.d[0] = lr(10, o < 0 ? Fe + o : o), oi == null)
        oi = B > 0 ? Yr : v;
      else {
        if (m = new wr(oi), !m.isInt() || m.lt(v)) throw Error(He + m);
        oi = m.gt(Yr) ? B > 0 ? Yr : v : m;
      }
      for (Ee = !1, m = new wr(rr(fr)), he = wr.precision, wr.precision = B = fr.length * Fe * 2; we = vr(m, Yr, 0, 1, 1), Mn = ji.plus(we.times(Cn)), Mn.cmp(oi) != 1; )
        ji = Cn, Cn = Mn, Mn = v, v = d.plus(we.times(Mn)), d = Mn, Mn = Yr, Yr = m.minus(we.times(Mn)), m = Mn;
      return Mn = vr(oi.minus(ji), Cn, 0, 1, 1), d = d.plus(Mn.times(v)), ji = ji.plus(Mn.times(Cn)), d.s = v.s = Me.s, Be = vr(v, Cn, B, 1).minus(Me).abs().cmp(vr(d, ji, B, 1).minus(Me).abs()) < 1 ? [v, Cn] : [d, ji], wr.precision = he, Ee = !0, Be;
    }, xe.toHexadecimal = xe.toHex = function(oi, Yr) {
      return Di(this, 16, oi, Yr);
    }, xe.toNearest = function(oi, Yr) {
      var ji = this, Cn = ji.constructor;
      if (ji = new Cn(ji), oi == null) {
        if (!ji.d) return ji;
        oi = new Cn(1), Yr = Cn.rounding;
      } else {
        if (oi = new Cn(oi), Yr === void 0 ? Yr = Cn.rounding : ar(Yr, 0, 8), !ji.d) return oi.s ? ji : oi;
        if (!oi.d)
          return oi.s && (oi.s = ji.s), oi;
      }
      return oi.d[0] ? (Ee = !1, ji = vr(ji, oi, 0, Yr, 1).times(oi), Ee = !0, Te(ji)) : (oi.s = ji.s, ji = oi), ji;
    }, xe.toNumber = function() {
      return +this;
    }, xe.toOctal = function(oi, Yr) {
      return Di(this, 8, oi, Yr);
    }, xe.toPower = xe.pow = function(oi) {
      var Yr, ji, Cn, Mn, B, o, m = this, d = m.constructor, v = +(oi = new d(oi));
      if (!m.d || !oi.d || !m.d[0] || !oi.d[0]) return new d(lr(+m, v));
      if (m = new d(m), m.eq(1)) return m;
      if (Cn = d.precision, B = d.rounding, oi.eq(1)) return Te(m, Cn, B);
      if (Yr = or(oi.e / Fe), Yr >= oi.d.length - 1 && (ji = v < 0 ? -v : v) <= Sr)
        return Mn = wi(d, m, ji, Cn), oi.s < 0 ? new d(1).div(Mn) : Te(Mn, Cn, B);
      if (o = m.s, o < 0) {
        if (Yr < oi.d.length - 1) return new d(NaN);
        if (oi.d[Yr] & 1 || (o = 1), m.e == 0 && m.d[0] == 1 && m.d.length == 1)
          return m.s = o, m;
      }
      return ji = lr(+m, v), Yr = ji == 0 || !isFinite(ji) ? or(v * (Math.log("0." + rr(m.d)) / Math.LN10 + m.e + 1)) : new d(ji + "").e, Yr > d.maxE + 1 || Yr < d.minE - 1 ? new d(Yr > 0 ? o / 0 : 0) : (Ee = !1, d.rounding = m.s = 1, ji = Math.min(12, (Yr + "").length), Mn = pi(oi.times(ei(m, Cn + ji)), Cn), Mn.d && (Mn = Te(Mn, Cn + 5, 1), yr(Mn.d, Cn, B) && (Yr = Cn + 10, Mn = Te(pi(oi.times(ei(m, Yr + ji)), Yr), Yr + 5, 1), +rr(Mn.d).slice(Cn + 1, Cn + 15) + 1 == 1e14 && (Mn = Te(Mn, Cn + 1, 0)))), Mn.s = o, Ee = !0, d.rounding = B, Te(Mn, Cn, B));
    }, xe.toPrecision = function(oi, Yr) {
      var ji, Cn = this, Mn = Cn.constructor;
      return oi === void 0 ? ji = Cr(Cn, Cn.e <= Mn.toExpNeg || Cn.e >= Mn.toExpPos) : (ar(oi, 1, p), Yr === void 0 ? Yr = Mn.rounding : ar(Yr, 0, 8), Cn = Te(new Mn(Cn), oi, Yr), ji = Cr(Cn, oi <= Cn.e || Cn.e <= Mn.toExpNeg, oi)), Cn.isNeg() && !Cn.isZero() ? "-" + ji : ji;
    }, xe.toSignificantDigits = xe.toSD = function(oi, Yr) {
      var ji = this, Cn = ji.constructor;
      return oi === void 0 ? (oi = Cn.precision, Yr = Cn.rounding) : (ar(oi, 1, p), Yr === void 0 ? Yr = Cn.rounding : ar(Yr, 0, 8)), Te(new Cn(ji), oi, Yr);
    }, xe.toString = function() {
      var oi = this, Yr = oi.constructor, ji = Cr(oi, oi.e <= Yr.toExpNeg || oi.e >= Yr.toExpPos);
      return oi.isNeg() && !oi.isZero() ? "-" + ji : ji;
    }, xe.truncated = xe.trunc = function() {
      return Te(new this.constructor(this), this.e + 1, 1);
    }, xe.valueOf = xe.toJSON = function() {
      var oi = this, Yr = oi.constructor, ji = Cr(oi, oi.e <= Yr.toExpNeg || oi.e >= Yr.toExpPos);
      return oi.isNeg() ? "-" + ji : ji;
    };
    function rr(oi) {
      var Yr, ji, Cn, Mn = oi.length - 1, B = "", o = oi[0];
      if (Mn > 0) {
        for (B += o, Yr = 1; Yr < Mn; Yr++)
          Cn = oi[Yr] + "", ji = Fe - Cn.length, ji && (B += Qi(ji)), B += Cn;
        o = oi[Yr], Cn = o + "", ji = Fe - Cn.length, ji && (B += Qi(ji));
      } else if (o === 0)
        return "0";
      for (; o % 10 === 0; ) o /= 10;
      return B + o;
    }
    function ar(oi, Yr, ji) {
      if (oi !== ~~oi || oi < Yr || oi > ji)
        throw Error(He + oi);
    }
    function yr(oi, Yr, ji, Cn) {
      var Mn, B, o, m;
      for (B = oi[0]; B >= 10; B /= 10) --Yr;
      return --Yr < 0 ? (Yr += Fe, Mn = 0) : (Mn = Math.ceil((Yr + 1) / Fe), Yr %= Fe), B = lr(10, Fe - Yr), m = oi[Mn] % B | 0, Cn == null ? Yr < 3 ? (Yr == 0 ? m = m / 100 | 0 : Yr == 1 && (m = m / 10 | 0), o = ji < 4 && m == 99999 || ji > 3 && m == 49999 || m == 5e4 || m == 0) : o = (ji < 4 && m + 1 == B || ji > 3 && m + 1 == B / 2) && (oi[Mn + 1] / B / 100 | 0) == lr(10, Yr - 2) - 1 || (m == B / 2 || m == 0) && (oi[Mn + 1] / B / 100 | 0) == 0 : Yr < 4 ? (Yr == 0 ? m = m / 1e3 | 0 : Yr == 1 ? m = m / 100 | 0 : Yr == 2 && (m = m / 10 | 0), o = (Cn || ji < 4) && m == 9999 || !Cn && ji > 3 && m == 4999) : o = ((Cn || ji < 4) && m + 1 == B || !Cn && ji > 3 && m + 1 == B / 2) && (oi[Mn + 1] / B / 1e3 | 0) == lr(10, Yr - 3) - 1, o;
    }
    function _r(oi, Yr, ji) {
      for (var Cn, Mn = [0], B, o = 0, m = oi.length; o < m; ) {
        for (B = Mn.length; B--; ) Mn[B] *= Yr;
        for (Mn[0] += a.indexOf(oi.charAt(o++)), Cn = 0; Cn < Mn.length; Cn++)
          Mn[Cn] > ji - 1 && (Mn[Cn + 1] === void 0 && (Mn[Cn + 1] = 0), Mn[Cn + 1] += Mn[Cn] / ji | 0, Mn[Cn] %= ji);
      }
      return Mn.reverse();
    }
    function Or(oi, Yr) {
      var ji, Cn, Mn;
      if (Yr.isZero()) return Yr;
      Cn = Yr.d.length, Cn < 32 ? (ji = Math.ceil(Cn / 3), Mn = (1 / _i(4, ji)).toString()) : (ji = 16, Mn = "2.3283064365386962890625e-10"), oi.precision += ji, Yr = ri(oi, 1, Yr.times(Mn), new oi(1));
      for (var B = ji; B--; ) {
        var o = Yr.times(Yr);
        Yr = o.times(o).minus(o).times(8).plus(1);
      }
      return oi.precision -= ji, Yr;
    }
    var vr = /* @__PURE__ */ function() {
      function oi(Cn, Mn, B) {
        var o, m = 0, d = Cn.length;
        for (Cn = Cn.slice(); d--; )
          o = Cn[d] * Mn + m, Cn[d] = o % B | 0, m = o / B | 0;
        return m && Cn.unshift(m), Cn;
      }
      function Yr(Cn, Mn, B, o) {
        var m, d;
        if (B != o)
          d = B > o ? 1 : -1;
        else
          for (m = d = 0; m < B; m++)
            if (Cn[m] != Mn[m]) {
              d = Cn[m] > Mn[m] ? 1 : -1;
              break;
            }
        return d;
      }
      function ji(Cn, Mn, B, o) {
        for (var m = 0; B--; )
          Cn[B] -= m, m = Cn[B] < Mn[B] ? 1 : 0, Cn[B] = m * o + Cn[B] - Mn[B];
        for (; !Cn[0] && Cn.length > 1; ) Cn.shift();
      }
      return function(Cn, Mn, B, o, m, d) {
        var v, he, we, Be, Me, fr, wr, dr, Dr, Rr, Qe, Fr, Gr, $r, ni, mi, Si, Oi, $i, zi, un = Cn.constructor, In = Cn.s == Mn.s ? 1 : -1, Ti = Cn.d, Sn = Mn.d;
        if (!Ti || !Ti[0] || !Sn || !Sn[0])
          return new un(
            // Return NaN if either NaN, or both Infinity or 0.
            !Cn.s || !Mn.s || (Ti ? Sn && Ti[0] == Sn[0] : !Sn) ? NaN : (
              // Return ±0 if x is 0 or y is ±Infinity, or return ±Infinity as y is 0.
              Ti && Ti[0] == 0 || !Sn ? In * 0 : In / 0
            )
          );
        for (d ? (Me = 1, he = Cn.e - Mn.e) : (d = tr, Me = Fe, he = or(Cn.e / Me) - or(Mn.e / Me)), $i = Sn.length, Si = Ti.length, Dr = new un(In), Rr = Dr.d = [], we = 0; Sn[we] == (Ti[we] || 0); we++) ;
        if (Sn[we] > (Ti[we] || 0) && he--, B == null ? ($r = B = un.precision, o = un.rounding) : m ? $r = B + (Cn.e - Mn.e) + 1 : $r = B, $r < 0)
          Rr.push(1), fr = !0;
        else {
          if ($r = $r / Me + 2 | 0, we = 0, $i == 1) {
            for (Be = 0, Sn = Sn[0], $r++; (we < Si || Be) && $r--; we++)
              ni = Be * d + (Ti[we] || 0), Rr[we] = ni / Sn | 0, Be = ni % Sn | 0;
            fr = Be || we < Si;
          } else {
            for (Be = d / (Sn[0] + 1) | 0, Be > 1 && (Sn = oi(Sn, Be, d), Ti = oi(Ti, Be, d), $i = Sn.length, Si = Ti.length), mi = $i, Qe = Ti.slice(0, $i), Fr = Qe.length; Fr < $i; ) Qe[Fr++] = 0;
            zi = Sn.slice(), zi.unshift(0), Oi = Sn[0], Sn[1] >= d / 2 && ++Oi;
            do
              Be = 0, v = Yr(Sn, Qe, $i, Fr), v < 0 ? (Gr = Qe[0], $i != Fr && (Gr = Gr * d + (Qe[1] || 0)), Be = Gr / Oi | 0, Be > 1 ? (Be >= d && (Be = d - 1), wr = oi(Sn, Be, d), dr = wr.length, Fr = Qe.length, v = Yr(wr, Qe, dr, Fr), v == 1 && (Be--, ji(wr, $i < dr ? zi : Sn, dr, d))) : (Be == 0 && (v = Be = 1), wr = Sn.slice()), dr = wr.length, dr < Fr && wr.unshift(0), ji(Qe, wr, Fr, d), v == -1 && (Fr = Qe.length, v = Yr(Sn, Qe, $i, Fr), v < 1 && (Be++, ji(Qe, $i < Fr ? zi : Sn, Fr, d))), Fr = Qe.length) : v === 0 && (Be++, Qe = [0]), Rr[we++] = Be, v && Qe[0] ? Qe[Fr++] = Ti[mi] || 0 : (Qe = [Ti[mi]], Fr = 1);
            while ((mi++ < Si || Qe[0] !== void 0) && $r--);
            fr = Qe[0] !== void 0;
          }
          Rr[0] || Rr.shift();
        }
        if (Me == 1)
          Dr.e = he, L = fr;
        else {
          for (we = 1, Be = Rr[0]; Be >= 10; Be /= 10) we++;
          Dr.e = we + he * Me - 1, Te(Dr, m ? B + Dr.e + 1 : B, o, fr);
        }
        return Dr;
      };
    }();
    function Te(oi, Yr, ji, Cn) {
      var Mn, B, o, m, d, v, he, we, Be, Me = oi.constructor;
      e: if (Yr != null) {
        if (we = oi.d, !we) return oi;
        for (Mn = 1, m = we[0]; m >= 10; m /= 10) Mn++;
        if (B = Yr - Mn, B < 0)
          B += Fe, o = Yr, he = we[Be = 0], d = he / lr(10, Mn - o - 1) % 10 | 0;
        else if (Be = Math.ceil((B + 1) / Fe), m = we.length, Be >= m)
          if (Cn) {
            for (; m++ <= Be; ) we.push(0);
            he = d = 0, Mn = 1, B %= Fe, o = B - Fe + 1;
          } else
            break e;
        else {
          for (he = m = we[Be], Mn = 1; m >= 10; m /= 10) Mn++;
          B %= Fe, o = B - Fe + Mn, d = o < 0 ? 0 : he / lr(10, Mn - o - 1) % 10 | 0;
        }
        if (Cn = Cn || Yr < 0 || we[Be + 1] !== void 0 || (o < 0 ? he : he % lr(10, Mn - o - 1)), v = ji < 4 ? (d || Cn) && (ji == 0 || ji == (oi.s < 0 ? 3 : 2)) : d > 5 || d == 5 && (ji == 4 || Cn || ji == 6 && // Check whether the digit to the left of the rounding digit is odd.
        (B > 0 ? o > 0 ? he / lr(10, Mn - o) : 0 : we[Be - 1]) % 10 & 1 || ji == (oi.s < 0 ? 8 : 7)), Yr < 1 || !we[0])
          return we.length = 0, v ? (Yr -= oi.e + 1, we[0] = lr(10, (Fe - Yr % Fe) % Fe), oi.e = -Yr || 0) : we[0] = oi.e = 0, oi;
        if (B == 0 ? (we.length = Be, m = 1, Be--) : (we.length = Be + 1, m = lr(10, Fe - B), we[Be] = o > 0 ? (he / lr(10, Mn - o) % lr(10, o) | 0) * m : 0), v)
          for (; ; )
            if (Be == 0) {
              for (B = 1, o = we[0]; o >= 10; o /= 10) B++;
              for (o = we[0] += m, m = 1; o >= 10; o /= 10) m++;
              B != m && (oi.e++, we[0] == tr && (we[0] = 1));
              break;
            } else {
              if (we[Be] += m, we[Be] != tr) break;
              we[Be--] = 0, m = 1;
            }
        for (B = we.length; we[--B] === 0; ) we.pop();
      }
      return Ee && (oi.e > Me.maxE ? (oi.d = null, oi.e = NaN) : oi.e < Me.minE && (oi.e = 0, oi.d = [0])), oi;
    }
    function Cr(oi, Yr, ji) {
      if (!oi.isFinite()) return Vr(oi);
      var Cn, Mn = oi.e, B = rr(oi.d), o = B.length;
      return Yr ? (ji && (Cn = ji - o) > 0 ? B = B.charAt(0) + "." + B.slice(1) + Qi(Cn) : o > 1 && (B = B.charAt(0) + "." + B.slice(1)), B = B + (oi.e < 0 ? "e" : "e+") + oi.e) : Mn < 0 ? (B = "0." + Qi(-Mn - 1) + B, ji && (Cn = ji - o) > 0 && (B += Qi(Cn))) : Mn >= o ? (B += Qi(Mn + 1 - o), ji && (Cn = ji - Mn - 1) > 0 && (B = B + "." + Qi(Cn))) : ((Cn = Mn + 1) < o && (B = B.slice(0, Cn) + "." + B.slice(Cn)), ji && (Cn = ji - o) > 0 && (Mn + 1 === o && (B += "."), B += Qi(Cn))), B;
    }
    function Hr(oi, Yr) {
      var ji = oi[0];
      for (Yr *= Fe; ji >= 10; ji /= 10) Yr++;
      return Yr;
    }
    function si(oi, Yr, ji) {
      if (Yr > er)
        throw Ee = !0, ji && (oi.precision = ji), Error(Pe);
      return Te(new oi(A), Yr, 1, !0);
    }
    function ui(oi, Yr, ji) {
      if (Yr > Ie) throw Error(Pe);
      return Te(new oi(b), Yr, ji, !0);
    }
    function Li(oi) {
      var Yr = oi.length - 1, ji = Yr * Fe + 1;
      if (Yr = oi[Yr], Yr) {
        for (; Yr % 10 == 0; Yr /= 10) ji--;
        for (Yr = oi[0]; Yr >= 10; Yr /= 10) ji++;
      }
      return ji;
    }
    function Qi(oi) {
      for (var Yr = ""; oi--; ) Yr += "0";
      return Yr;
    }
    function wi(oi, Yr, ji, Cn) {
      var Mn, B = new oi(1), o = Math.ceil(Cn / Fe + 4);
      for (Ee = !1; ; ) {
        if (ji % 2 && (B = B.times(Yr), _n(B.d, o) && (Mn = !0)), ji = or(ji / 2), ji === 0) {
          ji = B.d.length - 1, Mn && B.d[ji] === 0 && ++B.d[ji];
          break;
        }
        Yr = Yr.times(Yr), _n(Yr.d, o);
      }
      return Ee = !0, B;
    }
    function Ji(oi) {
      return oi.d[oi.d.length - 1] & 1;
    }
    function mn(oi, Yr, ji) {
      for (var Cn, Mn = new oi(Yr[0]), B = 0; ++B < Yr.length; )
        if (Cn = new oi(Yr[B]), Cn.s)
          Mn[ji](Cn) && (Mn = Cn);
        else {
          Mn = Cn;
          break;
        }
      return Mn;
    }
    function pi(oi, Yr) {
      var ji, Cn, Mn, B, o, m, d, v = 0, he = 0, we = 0, Be = oi.constructor, Me = Be.rounding, fr = Be.precision;
      if (!oi.d || !oi.d[0] || oi.e > 17)
        return new Be(oi.d ? oi.d[0] ? oi.s < 0 ? 0 : 1 / 0 : 1 : oi.s ? oi.s < 0 ? 0 : oi : NaN);
      for (Yr == null ? (Ee = !1, d = fr) : d = Yr, m = new Be(0.03125); oi.e > -2; )
        oi = oi.times(m), we += 5;
      for (Cn = Math.log(lr(2, we)) / Math.LN10 * 2 + 5 | 0, d += Cn, ji = B = o = new Be(1), Be.precision = d; ; ) {
        if (B = Te(B.times(oi), d, 1), ji = ji.times(++he), m = o.plus(vr(B, ji, d, 1)), rr(m.d).slice(0, d) === rr(o.d).slice(0, d)) {
          for (Mn = we; Mn--; ) o = Te(o.times(o), d, 1);
          if (Yr == null)
            if (v < 3 && yr(o.d, d - Cn, Me, v))
              Be.precision = d += 10, ji = B = m = new Be(1), he = 0, v++;
            else
              return Te(o, Be.precision = fr, Me, Ee = !0);
          else
            return Be.precision = fr, o;
        }
        o = m;
      }
    }
    function ei(oi, Yr) {
      var ji, Cn, Mn, B, o, m, d, v, he, we, Be, Me = 1, fr = 10, wr = oi, dr = wr.d, Dr = wr.constructor, Rr = Dr.rounding, Qe = Dr.precision;
      if (wr.s < 0 || !dr || !dr[0] || !wr.e && dr[0] == 1 && dr.length == 1)
        return new Dr(dr && !dr[0] ? -1 / 0 : wr.s != 1 ? NaN : dr ? 0 : wr);
      if (Yr == null ? (Ee = !1, he = Qe) : he = Yr, Dr.precision = he += fr, ji = rr(dr), Cn = ji.charAt(0), Math.abs(B = wr.e) < 15e14) {
        for (; Cn < 7 && Cn != 1 || Cn == 1 && ji.charAt(1) > 3; )
          wr = wr.times(oi), ji = rr(wr.d), Cn = ji.charAt(0), Me++;
        B = wr.e, Cn > 1 ? (wr = new Dr("0." + ji), B++) : wr = new Dr(Cn + "." + ji.slice(1));
      } else
        return v = si(Dr, he + 2, Qe).times(B + ""), wr = ei(new Dr(Cn + "." + ji.slice(1)), he - fr).plus(v), Dr.precision = Qe, Yr == null ? Te(wr, Qe, Rr, Ee = !0) : wr;
      for (we = wr, d = o = wr = vr(wr.minus(1), wr.plus(1), he, 1), Be = Te(wr.times(wr), he, 1), Mn = 3; ; ) {
        if (o = Te(o.times(Be), he, 1), v = d.plus(vr(o, new Dr(Mn), he, 1)), rr(v.d).slice(0, he) === rr(d.d).slice(0, he))
          if (d = d.times(2), B !== 0 && (d = d.plus(si(Dr, he + 2, Qe).times(B + ""))), d = vr(d, new Dr(Me), he, 1), Yr == null)
            if (yr(d.d, he - fr, Rr, m))
              Dr.precision = he += fr, v = o = wr = vr(we.minus(1), we.plus(1), he, 1), Be = Te(wr.times(wr), he, 1), Mn = m = 1;
            else
              return Te(d, Dr.precision = Qe, Rr, Ee = !0);
          else
            return Dr.precision = Qe, d;
        d = v, Mn += 2;
      }
    }
    function Vr(oi) {
      return String(oi.s * oi.s / 0);
    }
    function qr(oi, Yr) {
      var ji, Cn, Mn;
      for ((ji = Yr.indexOf(".")) > -1 && (Yr = Yr.replace(".", "")), (Cn = Yr.search(/e/i)) > 0 ? (ji < 0 && (ji = Cn), ji += +Yr.slice(Cn + 1), Yr = Yr.substring(0, Cn)) : ji < 0 && (ji = Yr.length), Cn = 0; Yr.charCodeAt(Cn) === 48; Cn++) ;
      for (Mn = Yr.length; Yr.charCodeAt(Mn - 1) === 48; --Mn) ;
      if (Yr = Yr.slice(Cn, Mn), Yr) {
        if (Mn -= Cn, oi.e = ji = ji - Cn - 1, oi.d = [], Cn = (ji + 1) % Fe, ji < 0 && (Cn += Fe), Cn < Mn) {
          for (Cn && oi.d.push(+Yr.slice(0, Cn)), Mn -= Fe; Cn < Mn; ) oi.d.push(+Yr.slice(Cn, Cn += Fe));
          Yr = Yr.slice(Cn), Cn = Fe - Yr.length;
        } else
          Cn -= Mn;
        for (; Cn--; ) Yr += "0";
        oi.d.push(+Yr), Ee && (oi.e > oi.constructor.maxE ? (oi.d = null, oi.e = NaN) : oi.e < oi.constructor.minE && (oi.e = 0, oi.d = [0]));
      } else
        oi.e = 0, oi.d = [0];
      return oi;
    }
    function Zi(oi, Yr) {
      var ji, Cn, Mn, B, o, m, d, v, he;
      if (Yr.indexOf("_") > -1) {
        if (Yr = Yr.replace(/(\d)_(?=\d)/g, "$1"), Ce.test(Yr)) return qr(oi, Yr);
      } else if (Yr === "Infinity" || Yr === "NaN")
        return +Yr || (oi.s = NaN), oi.e = NaN, oi.d = null, oi;
      if (xr.test(Yr))
        ji = 16, Yr = Yr.toLowerCase();
      else if (Ir.test(Yr))
        ji = 2;
      else if (kr.test(Yr))
        ji = 8;
      else
        throw Error(He + Yr);
      for (B = Yr.search(/p/i), B > 0 ? (d = +Yr.slice(B + 1), Yr = Yr.substring(2, B)) : Yr = Yr.slice(2), B = Yr.indexOf("."), o = B >= 0, Cn = oi.constructor, o && (Yr = Yr.replace(".", ""), m = Yr.length, B = m - B, Mn = wi(Cn, new Cn(ji), B, B * 2)), v = _r(Yr, ji, tr), he = v.length - 1, B = he; v[B] === 0; --B) v.pop();
      return B < 0 ? new Cn(oi.s * 0) : (oi.e = Hr(v, he), oi.d = v, Ee = !1, o && (oi = vr(oi, Mn, m * 4)), d && (oi = oi.times(Math.abs(d) < 54 ? lr(2, d) : le.pow(2, d))), Ee = !0, oi);
    }
    function Wr(oi, Yr) {
      var ji, Cn = Yr.d.length;
      if (Cn < 3)
        return Yr.isZero() ? Yr : ri(oi, 2, Yr, Yr);
      ji = 1.4 * Math.sqrt(Cn), ji = ji > 16 ? 16 : ji | 0, Yr = Yr.times(1 / _i(5, ji)), Yr = ri(oi, 2, Yr, Yr);
      for (var Mn, B = new oi(5), o = new oi(16), m = new oi(20); ji--; )
        Mn = Yr.times(Yr), Yr = Yr.times(B.plus(Mn.times(o.times(Mn).minus(m))));
      return Yr;
    }
    function ri(oi, Yr, ji, Cn, Mn) {
      var B, o, m, d, v = oi.precision, he = Math.ceil(v / Fe);
      for (Ee = !1, d = ji.times(ji), m = new oi(Cn); ; ) {
        if (o = vr(m.times(d), new oi(Yr++ * Yr++), v, 1), m = Mn ? Cn.plus(o) : Cn.minus(o), Cn = vr(o.times(d), new oi(Yr++ * Yr++), v, 1), o = m.plus(Cn), o.d[he] !== void 0) {
          for (B = he; o.d[B] === m.d[B] && B--; ) ;
          if (B == -1) break;
        }
        B = m, m = Cn, Cn = o, o = B;
      }
      return Ee = !0, o.d.length = he + 1, o;
    }
    function _i(oi, Yr) {
      for (var ji = oi; --Yr; ) ji *= oi;
      return ji;
    }
    function Er(oi, Yr) {
      var ji, Cn = Yr.s < 0, Mn = ui(oi, oi.precision, 1), B = Mn.times(0.5);
      if (Yr = Yr.abs(), Yr.lte(B))
        return $ = Cn ? 4 : 1, Yr;
      if (ji = Yr.divToInt(Mn), ji.isZero())
        $ = Cn ? 3 : 2;
      else {
        if (Yr = Yr.minus(ji.times(Mn)), Yr.lte(B))
          return $ = Ji(ji) ? Cn ? 2 : 3 : Cn ? 4 : 1, Yr;
        $ = Ji(ji) ? Cn ? 1 : 4 : Cn ? 3 : 2;
      }
      return Yr.minus(Mn).abs();
    }
    function Di(oi, Yr, ji, Cn) {
      var Mn, B, o, m, d, v, he, we, Be, Me = oi.constructor, fr = ji !== void 0;
      if (fr ? (ar(ji, 1, p), Cn === void 0 ? Cn = Me.rounding : ar(Cn, 0, 8)) : (ji = Me.precision, Cn = Me.rounding), !oi.isFinite())
        he = Vr(oi);
      else {
        for (he = Cr(oi), o = he.indexOf("."), fr ? (Mn = 2, Yr == 16 ? ji = ji * 4 - 3 : Yr == 8 && (ji = ji * 3 - 2)) : Mn = Yr, o >= 0 && (he = he.replace(".", ""), Be = new Me(1), Be.e = he.length - o, Be.d = _r(Cr(Be), 10, Mn), Be.e = Be.d.length), we = _r(he, 10, Mn), B = d = we.length; we[--d] == 0; ) we.pop();
        if (!we[0])
          he = fr ? "0p+0" : "0";
        else {
          if (o < 0 ? B-- : (oi = new Me(oi), oi.d = we, oi.e = B, oi = vr(oi, Be, ji, Cn, 0, Mn), we = oi.d, B = oi.e, v = L), o = we[ji], m = Mn / 2, v = v || we[ji + 1] !== void 0, v = Cn < 4 ? (o !== void 0 || v) && (Cn === 0 || Cn === (oi.s < 0 ? 3 : 2)) : o > m || o === m && (Cn === 4 || v || Cn === 6 && we[ji - 1] & 1 || Cn === (oi.s < 0 ? 8 : 7)), we.length = ji, v)
            for (; ++we[--ji] > Mn - 1; )
              we[ji] = 0, ji || (++B, we.unshift(1));
          for (d = we.length; !we[d - 1]; --d) ;
          for (o = 0, he = ""; o < d; o++) he += a.charAt(we[o]);
          if (fr) {
            if (d > 1)
              if (Yr == 16 || Yr == 8) {
                for (o = Yr == 16 ? 4 : 3, --d; d % o; d++) he += "0";
                for (we = _r(he, Mn, Yr), d = we.length; !we[d - 1]; --d) ;
                for (o = 1, he = "1."; o < d; o++) he += a.charAt(we[o]);
              } else
                he = he.charAt(0) + "." + he.slice(1);
            he = he + (B < 0 ? "p" : "p+") + B;
          } else if (B < 0) {
            for (; ++B; ) he = "0" + he;
            he = "0." + he;
          } else if (++B > d) for (B -= d; B--; ) he += "0";
          else B < d && (he = he.slice(0, B) + "." + he.slice(B));
        }
        he = (Yr == 16 ? "0x" : Yr == 2 ? "0b" : Yr == 8 ? "0o" : "") + he;
      }
      return oi.s < 0 ? "-" + he : he;
    }
    function _n(oi, Yr) {
      if (oi.length > Yr)
        return oi.length = Yr, !0;
    }
    function On(oi) {
      return new this(oi).abs();
    }
    function so(oi) {
      return new this(oi).acos();
    }
    function Do(oi) {
      return new this(oi).acosh();
    }
    function gn(oi, Yr) {
      return new this(oi).plus(Yr);
    }
    function Gn(oi) {
      return new this(oi).asin();
    }
    function pn(oi) {
      return new this(oi).asinh();
    }
    function hn(oi) {
      return new this(oi).atan();
    }
    function Rn(oi) {
      return new this(oi).atanh();
    }
    function vo(oi, Yr) {
      oi = new this(oi), Yr = new this(Yr);
      var ji, Cn = this.precision, Mn = this.rounding, B = Cn + 4;
      return !oi.s || !Yr.s ? ji = new this(NaN) : !oi.d && !Yr.d ? (ji = ui(this, B, 1).times(Yr.s > 0 ? 0.25 : 0.75), ji.s = oi.s) : !Yr.d || oi.isZero() ? (ji = Yr.s < 0 ? ui(this, Cn, Mn) : new this(0), ji.s = oi.s) : !oi.d || Yr.isZero() ? (ji = ui(this, B, 1).times(0.5), ji.s = oi.s) : Yr.s < 0 ? (this.precision = B, this.rounding = 1, ji = this.atan(vr(oi, Yr, B, 1)), Yr = ui(this, B, 1), this.precision = Cn, this.rounding = Mn, ji = oi.s < 0 ? ji.minus(Yr) : ji.plus(Yr)) : ji = this.atan(vr(oi, Yr, B, 1)), ji;
    }
    function Hi(oi) {
      return new this(oi).cbrt();
    }
    function di(oi) {
      return Te(oi = new this(oi), oi.e + 1, 2);
    }
    function Ui(oi, Yr, ji) {
      return new this(oi).clamp(Yr, ji);
    }
    function ln(oi) {
      if (!oi || typeof oi != "object") throw Error(be + "Object expected");
      var Yr, ji, Cn, Mn = oi.defaults === !0, B = [
        "precision",
        1,
        p,
        "rounding",
        0,
        8,
        "toExpNeg",
        -u,
        0,
        "toExpPos",
        0,
        u,
        "maxE",
        0,
        u,
        "minE",
        -u,
        0,
        "modulo",
        0,
        9
      ];
      for (Yr = 0; Yr < B.length; Yr += 3)
        if (ji = B[Yr], Mn && (this[ji] = F[ji]), (Cn = oi[ji]) !== void 0)
          if (or(Cn) === Cn && Cn >= B[Yr + 1] && Cn <= B[Yr + 2]) this[ji] = Cn;
          else throw Error(He + ji + ": " + Cn);
      if (ji = "crypto", Mn && (this[ji] = F[ji]), (Cn = oi[ji]) !== void 0)
        if (Cn === !0 || Cn === !1 || Cn === 0 || Cn === 1)
          if (Cn)
            if (typeof crypto < "u" && crypto && (crypto.getRandomValues || crypto.randomBytes))
              this[ji] = !0;
            else
              throw Error(nr);
          else
            this[ji] = !1;
        else
          throw Error(He + ji + ": " + Cn);
      return this;
    }
    function Un(oi) {
      return new this(oi).cos();
    }
    function Bo(oi) {
      return new this(oi).cosh();
    }
    function co(oi) {
      var Yr, ji, Cn;
      function Mn(B) {
        var o, m, d, v = this;
        if (!(v instanceof Mn)) return new Mn(B);
        if (v.constructor = Mn, $s(B)) {
          v.s = B.s, Ee ? !B.d || B.e > Mn.maxE ? (v.e = NaN, v.d = null) : B.e < Mn.minE ? (v.e = 0, v.d = [0]) : (v.e = B.e, v.d = B.d.slice()) : (v.e = B.e, v.d = B.d ? B.d.slice() : B.d);
          return;
        }
        if (d = typeof B, d === "number") {
          if (B === 0) {
            v.s = 1 / B < 0 ? -1 : 1, v.e = 0, v.d = [0];
            return;
          }
          if (B < 0 ? (B = -B, v.s = -1) : v.s = 1, B === ~~B && B < 1e7) {
            for (o = 0, m = B; m >= 10; m /= 10) o++;
            Ee ? o > Mn.maxE ? (v.e = NaN, v.d = null) : o < Mn.minE ? (v.e = 0, v.d = [0]) : (v.e = o, v.d = [B]) : (v.e = o, v.d = [B]);
            return;
          } else if (B * 0 !== 0) {
            B || (v.s = NaN), v.e = NaN, v.d = null;
            return;
          }
          return qr(v, B.toString());
        } else if (d !== "string")
          throw Error(He + B);
        return (m = B.charCodeAt(0)) === 45 ? (B = B.slice(1), v.s = -1) : (m === 43 && (B = B.slice(1)), v.s = 1), Ce.test(B) ? qr(v, B) : Zi(v, B);
      }
      if (Mn.prototype = xe, Mn.ROUND_UP = 0, Mn.ROUND_DOWN = 1, Mn.ROUND_CEIL = 2, Mn.ROUND_FLOOR = 3, Mn.ROUND_HALF_UP = 4, Mn.ROUND_HALF_DOWN = 5, Mn.ROUND_HALF_EVEN = 6, Mn.ROUND_HALF_CEIL = 7, Mn.ROUND_HALF_FLOOR = 8, Mn.EUCLID = 9, Mn.config = Mn.set = ln, Mn.clone = co, Mn.isDecimal = $s, Mn.abs = On, Mn.acos = so, Mn.acosh = Do, Mn.add = gn, Mn.asin = Gn, Mn.asinh = pn, Mn.atan = hn, Mn.atanh = Rn, Mn.atan2 = vo, Mn.cbrt = Hi, Mn.ceil = di, Mn.clamp = Ui, Mn.cos = Un, Mn.cosh = Bo, Mn.div = To, Mn.exp = xs, Mn.floor = Fo, Mn.hypot = Zo, Mn.ln = rs, Mn.log = ls, Mn.log10 = os, Mn.log2 = na, Mn.max = fs, Mn.min = da, Mn.mod = Bn, Mn.mul = hi, Mn.pow = Ii, Mn.random = Gi, Mn.round = kn, Mn.sign = ho, Mn.sin = eo, Mn.sinh = Ei, Mn.sqrt = vs, Mn.sub = vi, Mn.sum = xi, Mn.tan = Lr, Mn.tanh = dn, Mn.trunc = xn, oi === void 0 && (oi = {}), oi && oi.defaults !== !0)
        for (Cn = ["precision", "rounding", "toExpNeg", "toExpPos", "maxE", "minE", "modulo", "crypto"], Yr = 0; Yr < Cn.length; ) oi.hasOwnProperty(ji = Cn[Yr++]) || (oi[ji] = this[ji]);
      return Mn.config(oi), Mn;
    }
    function To(oi, Yr) {
      return new this(oi).div(Yr);
    }
    function xs(oi) {
      return new this(oi).exp();
    }
    function Fo(oi) {
      return Te(oi = new this(oi), oi.e + 1, 3);
    }
    function Zo() {
      var oi, Yr, ji = new this(0);
      for (Ee = !1, oi = 0; oi < arguments.length; )
        if (Yr = new this(arguments[oi++]), Yr.d)
          ji.d && (ji = ji.plus(Yr.times(Yr)));
        else {
          if (Yr.s)
            return Ee = !0, new this(1 / 0);
          ji = Yr;
        }
      return Ee = !0, ji.sqrt();
    }
    function $s(oi) {
      return oi instanceof le || oi && oi.toStringTag === ir || !1;
    }
    function rs(oi) {
      return new this(oi).ln();
    }
    function ls(oi, Yr) {
      return new this(oi).log(Yr);
    }
    function na(oi) {
      return new this(oi).log(2);
    }
    function os(oi) {
      return new this(oi).log(10);
    }
    function fs() {
      return mn(this, arguments, "lt");
    }
    function da() {
      return mn(this, arguments, "gt");
    }
    function Bn(oi, Yr) {
      return new this(oi).mod(Yr);
    }
    function hi(oi, Yr) {
      return new this(oi).mul(Yr);
    }
    function Ii(oi, Yr) {
      return new this(oi).pow(Yr);
    }
    function Gi(oi) {
      var Yr, ji, Cn, Mn, B = 0, o = new this(1), m = [];
      if (oi === void 0 ? oi = this.precision : ar(oi, 1, p), Cn = Math.ceil(oi / Fe), this.crypto)
        if (crypto.getRandomValues)
          for (Yr = crypto.getRandomValues(new Uint32Array(Cn)); B < Cn; )
            Mn = Yr[B], Mn >= 429e7 ? Yr[B] = crypto.getRandomValues(new Uint32Array(1))[0] : m[B++] = Mn % 1e7;
        else if (crypto.randomBytes) {
          for (Yr = crypto.randomBytes(Cn *= 4); B < Cn; )
            Mn = Yr[B] + (Yr[B + 1] << 8) + (Yr[B + 2] << 16) + ((Yr[B + 3] & 127) << 24), Mn >= 214e7 ? crypto.randomBytes(4).copy(Yr, B) : (m.push(Mn % 1e7), B += 4);
          B = Cn / 4;
        } else
          throw Error(nr);
      else for (; B < Cn; ) m[B++] = Math.random() * 1e7 | 0;
      for (Cn = m[--B], oi %= Fe, Cn && oi && (Mn = lr(10, Fe - oi), m[B] = (Cn / Mn | 0) * Mn); m[B] === 0; B--) m.pop();
      if (B < 0)
        ji = 0, m = [0];
      else {
        for (ji = -1; m[0] === 0; ji -= Fe) m.shift();
        for (Cn = 1, Mn = m[0]; Mn >= 10; Mn /= 10) Cn++;
        Cn < Fe && (ji -= Fe - Cn);
      }
      return o.e = ji, o.d = m, o;
    }
    function kn(oi) {
      return Te(oi = new this(oi), oi.e + 1, this.rounding);
    }
    function ho(oi) {
      return oi = new this(oi), oi.d ? oi.d[0] ? oi.s : 0 * oi.s : oi.s || NaN;
    }
    function eo(oi) {
      return new this(oi).sin();
    }
    function Ei(oi) {
      return new this(oi).sinh();
    }
    function vs(oi) {
      return new this(oi).sqrt();
    }
    function vi(oi, Yr) {
      return new this(oi).sub(Yr);
    }
    function xi() {
      var oi = 0, Yr = arguments, ji = new this(Yr[oi]);
      for (Ee = !1; ji.s && ++oi < Yr.length; ) ji = ji.plus(Yr[oi]);
      return Ee = !0, Te(ji, this.precision, this.rounding);
    }
    function Lr(oi) {
      return new this(oi).tan();
    }
    function dn(oi) {
      return new this(oi).tanh();
    }
    function xn(oi) {
      return Te(oi = new this(oi), oi.e + 1, 1);
    }
    le = co(F), le.prototype.constructor = le, le.default = le.Decimal = le, A = new le(A), b = new le(b), n.exports ? (typeof Symbol == "function" && typeof Symbol.iterator == "symbol" && (xe[Symbol.for("nodejs.util.inspect.custom")] = xe.toString, xe[Symbol.toStringTag] = "Decimal"), n.exports = le) : (c || (c = typeof self < "u" && self && self.self == self ? self : window), pe = c.Decimal, le.noConflict = function() {
      return c.Decimal = pe, le;
    }, c.Decimal = le);
  })(commonjsGlobal);
})(decimal$2);
var decimalExports = decimal$2.exports, binaryParser = {}, __createBinding$d = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(n, c, u, p) {
  p === void 0 && (p = u);
  var a = Object.getOwnPropertyDescriptor(c, u);
  (!a || ("get" in a ? !c.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
    return c[u];
  } }), Object.defineProperty(n, p, a);
} : function(n, c, u, p) {
  p === void 0 && (p = u), n[p] = c[u];
}), __setModuleDefault$d = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(n, c) {
  Object.defineProperty(n, "default", { enumerable: !0, value: c });
} : function(n, c) {
  n.default = c;
}), __importStar$d = commonjsGlobal && commonjsGlobal.__importStar || function(n) {
  if (n && n.__esModule) return n;
  var c = {};
  if (n != null) for (var u in n) u !== "default" && Object.prototype.hasOwnProperty.call(n, u) && __createBinding$d(c, n, u);
  return __setModuleDefault$d(c, n), c;
};
Object.defineProperty(binaryParser, "__esModule", { value: !0 });
binaryParser.BinaryParser = void 0;
const assert$a = __importStar$d(requireAssert()), enums_1 = enums, buffer_1$g = dist$u;
class BinaryParser {
  /**
   * Initialize bytes to a hex string
   *
   * @param hexBytes a hex string
   * @param definitions Rippled definitions used to parse the values of transaction types and such.
   *                          Can be customized for sidechains and amendments.
   */
  constructor(c, u = enums_1.DEFAULT_DEFINITIONS) {
    this.bytes = buffer_1$g.Buffer.from(c, "hex"), this.definitions = u;
  }
  /**
   * Peek the first byte of the BinaryParser
   *
   * @returns The first byte of the BinaryParser
   */
  peek() {
    return assert$a.ok(this.bytes.byteLength !== 0), this.bytes[0];
  }
  /**
   * Consume the first n bytes of the BinaryParser
   *
   * @param n the number of bytes to skip
   */
  skip(c) {
    assert$a.ok(c <= this.bytes.byteLength), this.bytes = this.bytes.slice(c);
  }
  /**
   * read the first n bytes from the BinaryParser
   *
   * @param n The number of bytes to read
   * @return The bytes
   */
  read(c) {
    assert$a.ok(c <= this.bytes.byteLength);
    const u = this.bytes.slice(0, c);
    return this.skip(c), u;
  }
  /**
   * Read an integer of given size
   *
   * @param n The number of bytes to read
   * @return The number represented by those bytes
   */
  readUIntN(c) {
    return assert$a.ok(0 < c && c <= 4, "invalid n"), this.read(c).reduce((u, p) => u << 8 | p) >>> 0;
  }
  readUInt8() {
    return this.readUIntN(1);
  }
  readUInt16() {
    return this.readUIntN(2);
  }
  readUInt32() {
    return this.readUIntN(4);
  }
  size() {
    return this.bytes.byteLength;
  }
  end(c) {
    const u = this.bytes.byteLength;
    return u === 0 || c !== void 0 && u <= c;
  }
  /**
   * Reads variable length encoded bytes
   *
   * @return The variable length bytes
   */
  readVariableLength() {
    return this.read(this.readVariableLengthLength());
  }
  /**
   * Reads the length of the variable length encoded bytes
   *
   * @return The length of the variable length encoded bytes
   */
  readVariableLengthLength() {
    const c = this.readUInt8();
    if (c <= 192)
      return c;
    if (c <= 240) {
      const u = this.readUInt8();
      return 193 + (c - 193) * 256 + u;
    } else if (c <= 254) {
      const u = this.readUInt8(), p = this.readUInt8();
      return 12481 + (c - 241) * 65536 + u * 256 + p;
    }
    throw new Error("Invalid variable length indicator");
  }
  /**
   * Reads the field ordinal from the BinaryParser
   *
   * @return Field ordinal
   */
  readFieldOrdinal() {
    let c = this.readUInt8(), u = c & 15;
    if (c >>= 4, c === 0 && (c = this.readUInt8(), c === 0 || c < 16))
      throw new Error("Cannot read FieldOrdinal, type_code out of range");
    if (u === 0 && (u = this.readUInt8(), u === 0 || u < 16))
      throw new Error("Cannot read FieldOrdinal, field_code out of range");
    return c << 16 | u;
  }
  /**
   * Read the field from the BinaryParser
   *
   * @return The field represented by the bytes at the head of the BinaryParser
   */
  readField() {
    return this.definitions.field.fromString(this.readFieldOrdinal().toString());
  }
  /**
   * Read a given type from the BinaryParser
   *
   * @param type The type that you want to read from the BinaryParser
   * @return The instance of that type read from the BinaryParser
   */
  readType(c) {
    return c.fromParser(this);
  }
  /**
   * Get the type associated with a given field
   *
   * @param field The field that you wan to get the type of
   * @return The type associated with the given field
   */
  typeForField(c) {
    return c.associatedType;
  }
  /**
   * Read value of the type specified by field from the BinaryParser
   *
   * @param field The field that you want to get the associated value for
   * @return The value associated with the given field
   */
  readFieldValue(c) {
    const u = this.typeForField(c);
    if (!u)
      throw new Error(`unsupported: (${c.name}, ${c.type.name})`);
    const p = c.isVariableLengthEncoded ? this.readVariableLengthLength() : void 0, a = u.fromParser(this, p);
    if (a === void 0)
      throw new Error(`fromParser for (${c.name}, ${c.type.name}) -> undefined `);
    return a;
  }
  /**
   * Get the next field and value from the BinaryParser
   *
   * @return The field and value
   */
  readFieldAndValue() {
    const c = this.readField();
    return [c, this.readFieldValue(c)];
  }
}
binaryParser.BinaryParser = BinaryParser;
var currency$1 = {};
Object.defineProperty(currency$1, "__esModule", { value: !0 });
currency$1.Currency = void 0;
const hash_160_1 = hash160$4, buffer_1$f = dist$u, XRP_HEX_REGEX = /^0{40}$/, ISO_REGEX = /^[A-Z0-9a-z?!@#$%^&*(){}[\]|]{3}$/, HEX_REGEX$1 = /^[A-F0-9]{40}$/, STANDARD_FORMAT_HEX_REGEX = /^0{24}[\x00-\x7F]{6}0{10}$/;
function isoToBytes(n) {
  const c = buffer_1$f.Buffer.alloc(20);
  if (n !== "XRP") {
    const u = n.split("").map((p) => p.charCodeAt(0));
    c.set(u, 12);
  }
  return c;
}
function isIsoCode(n) {
  return ISO_REGEX.test(n);
}
function isoCodeFromHex(n) {
  const c = n.toString();
  return c === "XRP" ? null : isIsoCode(c) ? c : null;
}
function isHex$1(n) {
  return HEX_REGEX$1.test(n);
}
function isStringRepresentation(n) {
  return n.length === 3 || isHex$1(n);
}
function isBytesArray(n) {
  return n.byteLength === 20;
}
function isValidRepresentation(n) {
  return n instanceof buffer_1$f.Buffer ? isBytesArray(n) : isStringRepresentation(n);
}
function bytesFromRepresentation(n) {
  if (!isValidRepresentation(n))
    throw new Error(`Unsupported Currency representation: ${n}`);
  return n.length === 3 ? isoToBytes(n) : buffer_1$f.Buffer.from(n, "hex");
}
class Currency extends hash_160_1.Hash160 {
  constructor(c) {
    super(c ?? Currency.XRP.bytes);
    const u = this.bytes.toString("hex");
    XRP_HEX_REGEX.test(u) ? this._iso = "XRP" : STANDARD_FORMAT_HEX_REGEX.test(u) ? this._iso = isoCodeFromHex(this.bytes.slice(12, 15)) : this._iso = null;
  }
  /**
   * Return the ISO code of this currency
   *
   * @returns ISO code if it exists, else null
   */
  iso() {
    return this._iso;
  }
  /**
   * Constructs a Currency object
   *
   * @param val Currency object or a string representation of a currency
   */
  static from(c) {
    if (c instanceof Currency)
      return c;
    if (typeof c == "string")
      return new Currency(bytesFromRepresentation(c));
    throw new Error("Cannot construct Currency from value given");
  }
  /**
   * Gets the JSON representation of a currency
   *
   * @returns JSON representation
   */
  toJSON() {
    const c = this.iso();
    return c !== null ? c : this.bytes.toString("hex").toUpperCase();
  }
}
currency$1.Currency = Currency;
Currency.XRP = new Currency(buffer_1$f.Buffer.alloc(20));
var BigInteger = { exports: {} };
(function(n) {
  var c = function(u) {
    var p = 1e7, a = 7, A = 9007199254740992, b = He(A), F = "0123456789abcdefghijklmnopqrstuvwxyz", le = typeof BigInt == "function";
    function L(pn, hn, Rn, vo) {
      return typeof pn > "u" ? L[0] : typeof hn < "u" ? +hn == 10 && !Rn ? gn(pn) : _i(pn, hn, Rn, vo) : gn(pn);
    }
    function pe(pn, hn) {
      this.value = pn, this.sign = hn, this.isSmall = !1;
    }
    pe.prototype = Object.create(L.prototype);
    function $(pn) {
      this.value = pn, this.sign = pn < 0, this.isSmall = !0;
    }
    $.prototype = Object.create(L.prototype);
    function Ee(pn) {
      this.value = pn;
    }
    Ee.prototype = Object.create(L.prototype);
    function be(pn) {
      return -A < pn && pn < A;
    }
    function He(pn) {
      return pn < 1e7 ? [pn] : pn < 1e14 ? [pn % 1e7, Math.floor(pn / 1e7)] : [pn % 1e7, Math.floor(pn / 1e7) % 1e7, Math.floor(pn / 1e14)];
    }
    function Pe(pn) {
      nr(pn);
      var hn = pn.length;
      if (hn < 4 && Te(pn, b) < 0)
        switch (hn) {
          case 0:
            return 0;
          case 1:
            return pn[0];
          case 2:
            return pn[0] + pn[1] * p;
          default:
            return pn[0] + (pn[1] + pn[2] * p) * p;
        }
      return pn;
    }
    function nr(pn) {
      for (var hn = pn.length; pn[--hn] === 0; ) ;
      pn.length = hn + 1;
    }
    function ir(pn) {
      for (var hn = new Array(pn), Rn = -1; ++Rn < pn; )
        hn[Rn] = 0;
      return hn;
    }
    function or(pn) {
      return pn > 0 ? Math.floor(pn) : Math.ceil(pn);
    }
    function lr(pn, hn) {
      var Rn = pn.length, vo = hn.length, Hi = new Array(Rn), di = 0, Ui = p, ln, Un;
      for (Un = 0; Un < vo; Un++)
        ln = pn[Un] + hn[Un] + di, di = ln >= Ui ? 1 : 0, Hi[Un] = ln - di * Ui;
      for (; Un < Rn; )
        ln = pn[Un] + di, di = ln === Ui ? 1 : 0, Hi[Un++] = ln - di * Ui;
      return di > 0 && Hi.push(di), Hi;
    }
    function Ir(pn, hn) {
      return pn.length >= hn.length ? lr(pn, hn) : lr(hn, pn);
    }
    function xr(pn, hn) {
      var Rn = pn.length, vo = new Array(Rn), Hi = p, di, Ui;
      for (Ui = 0; Ui < Rn; Ui++)
        di = pn[Ui] - Hi + hn, hn = Math.floor(di / Hi), vo[Ui] = di - hn * Hi, hn += 1;
      for (; hn > 0; )
        vo[Ui++] = hn % Hi, hn = Math.floor(hn / Hi);
      return vo;
    }
    pe.prototype.add = function(pn) {
      var hn = gn(pn);
      if (this.sign !== hn.sign)
        return this.subtract(hn.negate());
      var Rn = this.value, vo = hn.value;
      return hn.isSmall ? new pe(xr(Rn, Math.abs(vo)), this.sign) : new pe(Ir(Rn, vo), this.sign);
    }, pe.prototype.plus = pe.prototype.add, $.prototype.add = function(pn) {
      var hn = gn(pn), Rn = this.value;
      if (Rn < 0 !== hn.sign)
        return this.subtract(hn.negate());
      var vo = hn.value;
      if (hn.isSmall) {
        if (be(Rn + vo)) return new $(Rn + vo);
        vo = He(Math.abs(vo));
      }
      return new pe(xr(vo, Math.abs(Rn)), Rn < 0);
    }, $.prototype.plus = $.prototype.add, Ee.prototype.add = function(pn) {
      return new Ee(this.value + gn(pn).value);
    }, Ee.prototype.plus = Ee.prototype.add;
    function kr(pn, hn) {
      var Rn = pn.length, vo = hn.length, Hi = new Array(Rn), di = 0, Ui = p, ln, Un;
      for (ln = 0; ln < vo; ln++)
        Un = pn[ln] - di - hn[ln], Un < 0 ? (Un += Ui, di = 1) : di = 0, Hi[ln] = Un;
      for (ln = vo; ln < Rn; ln++) {
        if (Un = pn[ln] - di, Un < 0) Un += Ui;
        else {
          Hi[ln++] = Un;
          break;
        }
        Hi[ln] = Un;
      }
      for (; ln < Rn; ln++)
        Hi[ln] = pn[ln];
      return nr(Hi), Hi;
    }
    function Ce(pn, hn, Rn) {
      var vo;
      return Te(pn, hn) >= 0 ? vo = kr(pn, hn) : (vo = kr(hn, pn), Rn = !Rn), vo = Pe(vo), typeof vo == "number" ? (Rn && (vo = -vo), new $(vo)) : new pe(vo, Rn);
    }
    function tr(pn, hn, Rn) {
      var vo = pn.length, Hi = new Array(vo), di = -hn, Ui = p, ln, Un;
      for (ln = 0; ln < vo; ln++)
        Un = pn[ln] + di, di = Math.floor(Un / Ui), Un %= Ui, Hi[ln] = Un < 0 ? Un + Ui : Un;
      return Hi = Pe(Hi), typeof Hi == "number" ? (Rn && (Hi = -Hi), new $(Hi)) : new pe(Hi, Rn);
    }
    pe.prototype.subtract = function(pn) {
      var hn = gn(pn);
      if (this.sign !== hn.sign)
        return this.add(hn.negate());
      var Rn = this.value, vo = hn.value;
      return hn.isSmall ? tr(Rn, Math.abs(vo), this.sign) : Ce(Rn, vo, this.sign);
    }, pe.prototype.minus = pe.prototype.subtract, $.prototype.subtract = function(pn) {
      var hn = gn(pn), Rn = this.value;
      if (Rn < 0 !== hn.sign)
        return this.add(hn.negate());
      var vo = hn.value;
      return hn.isSmall ? new $(Rn - vo) : tr(vo, Math.abs(Rn), Rn >= 0);
    }, $.prototype.minus = $.prototype.subtract, Ee.prototype.subtract = function(pn) {
      return new Ee(this.value - gn(pn).value);
    }, Ee.prototype.minus = Ee.prototype.subtract, pe.prototype.negate = function() {
      return new pe(this.value, !this.sign);
    }, $.prototype.negate = function() {
      var pn = this.sign, hn = new $(-this.value);
      return hn.sign = !pn, hn;
    }, Ee.prototype.negate = function() {
      return new Ee(-this.value);
    }, pe.prototype.abs = function() {
      return new pe(this.value, !1);
    }, $.prototype.abs = function() {
      return new $(Math.abs(this.value));
    }, Ee.prototype.abs = function() {
      return new Ee(this.value >= 0 ? this.value : -this.value);
    };
    function Fe(pn, hn) {
      var Rn = pn.length, vo = hn.length, Hi = Rn + vo, di = ir(Hi), Ui = p, ln, Un, Bo, co, To;
      for (Bo = 0; Bo < Rn; ++Bo) {
        co = pn[Bo];
        for (var xs = 0; xs < vo; ++xs)
          To = hn[xs], ln = co * To + di[Bo + xs], Un = Math.floor(ln / Ui), di[Bo + xs] = ln - Un * Ui, di[Bo + xs + 1] += Un;
      }
      return nr(di), di;
    }
    function Sr(pn, hn) {
      var Rn = pn.length, vo = new Array(Rn), Hi = p, di = 0, Ui, ln;
      for (ln = 0; ln < Rn; ln++)
        Ui = pn[ln] * hn + di, di = Math.floor(Ui / Hi), vo[ln] = Ui - di * Hi;
      for (; di > 0; )
        vo[ln++] = di % Hi, di = Math.floor(di / Hi);
      return vo;
    }
    function er(pn, hn) {
      for (var Rn = []; hn-- > 0; ) Rn.push(0);
      return Rn.concat(pn);
    }
    function Ie(pn, hn) {
      var Rn = Math.max(pn.length, hn.length);
      if (Rn <= 30) return Fe(pn, hn);
      Rn = Math.ceil(Rn / 2);
      var vo = pn.slice(Rn), Hi = pn.slice(0, Rn), di = hn.slice(Rn), Ui = hn.slice(0, Rn), ln = Ie(Hi, Ui), Un = Ie(vo, di), Bo = Ie(Ir(Hi, vo), Ir(Ui, di)), co = Ir(Ir(ln, er(kr(kr(Bo, ln), Un), Rn)), er(Un, 2 * Rn));
      return nr(co), co;
    }
    function xe(pn, hn) {
      return -0.012 * pn - 0.012 * hn + 15e-6 * pn * hn > 0;
    }
    pe.prototype.multiply = function(pn) {
      var hn = gn(pn), Rn = this.value, vo = hn.value, Hi = this.sign !== hn.sign, di;
      if (hn.isSmall) {
        if (vo === 0) return L[0];
        if (vo === 1) return this;
        if (vo === -1) return this.negate();
        if (di = Math.abs(vo), di < p)
          return new pe(Sr(Rn, di), Hi);
        vo = He(di);
      }
      return xe(Rn.length, vo.length) ? new pe(Ie(Rn, vo), Hi) : new pe(Fe(Rn, vo), Hi);
    }, pe.prototype.times = pe.prototype.multiply;
    function rr(pn, hn, Rn) {
      return pn < p ? new pe(Sr(hn, pn), Rn) : new pe(Fe(hn, He(pn)), Rn);
    }
    $.prototype._multiplyBySmall = function(pn) {
      return be(pn.value * this.value) ? new $(pn.value * this.value) : rr(Math.abs(pn.value), He(Math.abs(this.value)), this.sign !== pn.sign);
    }, pe.prototype._multiplyBySmall = function(pn) {
      return pn.value === 0 ? L[0] : pn.value === 1 ? this : pn.value === -1 ? this.negate() : rr(Math.abs(pn.value), this.value, this.sign !== pn.sign);
    }, $.prototype.multiply = function(pn) {
      return gn(pn)._multiplyBySmall(this);
    }, $.prototype.times = $.prototype.multiply, Ee.prototype.multiply = function(pn) {
      return new Ee(this.value * gn(pn).value);
    }, Ee.prototype.times = Ee.prototype.multiply;
    function ar(pn) {
      var hn = pn.length, Rn = ir(hn + hn), vo = p, Hi, di, Ui, ln, Un;
      for (Ui = 0; Ui < hn; Ui++) {
        ln = pn[Ui], di = 0 - ln * ln;
        for (var Bo = Ui; Bo < hn; Bo++)
          Un = pn[Bo], Hi = 2 * (ln * Un) + Rn[Ui + Bo] + di, di = Math.floor(Hi / vo), Rn[Ui + Bo] = Hi - di * vo;
        Rn[Ui + hn] = di;
      }
      return nr(Rn), Rn;
    }
    pe.prototype.square = function() {
      return new pe(ar(this.value), !1);
    }, $.prototype.square = function() {
      var pn = this.value * this.value;
      return be(pn) ? new $(pn) : new pe(ar(He(Math.abs(this.value))), !1);
    }, Ee.prototype.square = function(pn) {
      return new Ee(this.value * this.value);
    };
    function yr(pn, hn) {
      var Rn = pn.length, vo = hn.length, Hi = p, di = ir(hn.length), Ui = hn[vo - 1], ln = Math.ceil(Hi / (2 * Ui)), Un = Sr(pn, ln), Bo = Sr(hn, ln), co, To, xs, Fo, Zo, $s, rs;
      for (Un.length <= Rn && Un.push(0), Bo.push(0), Ui = Bo[vo - 1], To = Rn - vo; To >= 0; To--) {
        for (co = Hi - 1, Un[To + vo] !== Ui && (co = Math.floor((Un[To + vo] * Hi + Un[To + vo - 1]) / Ui)), xs = 0, Fo = 0, $s = Bo.length, Zo = 0; Zo < $s; Zo++)
          xs += co * Bo[Zo], rs = Math.floor(xs / Hi), Fo += Un[To + Zo] - (xs - rs * Hi), xs = rs, Fo < 0 ? (Un[To + Zo] = Fo + Hi, Fo = -1) : (Un[To + Zo] = Fo, Fo = 0);
        for (; Fo !== 0; ) {
          for (co -= 1, xs = 0, Zo = 0; Zo < $s; Zo++)
            xs += Un[To + Zo] - Hi + Bo[Zo], xs < 0 ? (Un[To + Zo] = xs + Hi, xs = 0) : (Un[To + Zo] = xs, xs = 1);
          Fo += xs;
        }
        di[To] = co;
      }
      return Un = Or(Un, ln)[0], [Pe(di), Pe(Un)];
    }
    function _r(pn, hn) {
      for (var Rn = pn.length, vo = hn.length, Hi = [], di = [], Ui = p, ln, Un, Bo, co, To; Rn; ) {
        if (di.unshift(pn[--Rn]), nr(di), Te(di, hn) < 0) {
          Hi.push(0);
          continue;
        }
        Un = di.length, Bo = di[Un - 1] * Ui + di[Un - 2], co = hn[vo - 1] * Ui + hn[vo - 2], Un > vo && (Bo = (Bo + 1) * Ui), ln = Math.ceil(Bo / co);
        do {
          if (To = Sr(hn, ln), Te(To, di) <= 0) break;
          ln--;
        } while (ln);
        Hi.push(ln), di = kr(di, To);
      }
      return Hi.reverse(), [Pe(Hi), Pe(di)];
    }
    function Or(pn, hn) {
      var Rn = pn.length, vo = ir(Rn), Hi = p, di, Ui, ln, Un;
      for (ln = 0, di = Rn - 1; di >= 0; --di)
        Un = ln * Hi + pn[di], Ui = or(Un / hn), ln = Un - Ui * hn, vo[di] = Ui | 0;
      return [vo, ln | 0];
    }
    function vr(pn, hn) {
      var Rn, vo = gn(hn);
      if (le)
        return [new Ee(pn.value / vo.value), new Ee(pn.value % vo.value)];
      var Hi = pn.value, di = vo.value, Ui;
      if (di === 0) throw new Error("Cannot divide by zero");
      if (pn.isSmall)
        return vo.isSmall ? [new $(or(Hi / di)), new $(Hi % di)] : [L[0], pn];
      if (vo.isSmall) {
        if (di === 1) return [pn, L[0]];
        if (di == -1) return [pn.negate(), L[0]];
        var ln = Math.abs(di);
        if (ln < p) {
          Rn = Or(Hi, ln), Ui = Pe(Rn[0]);
          var Un = Rn[1];
          return pn.sign && (Un = -Un), typeof Ui == "number" ? (pn.sign !== vo.sign && (Ui = -Ui), [new $(Ui), new $(Un)]) : [new pe(Ui, pn.sign !== vo.sign), new $(Un)];
        }
        di = He(ln);
      }
      var Bo = Te(Hi, di);
      if (Bo === -1) return [L[0], pn];
      if (Bo === 0) return [L[pn.sign === vo.sign ? 1 : -1], L[0]];
      Hi.length + di.length <= 200 ? Rn = yr(Hi, di) : Rn = _r(Hi, di), Ui = Rn[0];
      var co = pn.sign !== vo.sign, To = Rn[1], xs = pn.sign;
      return typeof Ui == "number" ? (co && (Ui = -Ui), Ui = new $(Ui)) : Ui = new pe(Ui, co), typeof To == "number" ? (xs && (To = -To), To = new $(To)) : To = new pe(To, xs), [Ui, To];
    }
    pe.prototype.divmod = function(pn) {
      var hn = vr(this, pn);
      return {
        quotient: hn[0],
        remainder: hn[1]
      };
    }, Ee.prototype.divmod = $.prototype.divmod = pe.prototype.divmod, pe.prototype.divide = function(pn) {
      return vr(this, pn)[0];
    }, Ee.prototype.over = Ee.prototype.divide = function(pn) {
      return new Ee(this.value / gn(pn).value);
    }, $.prototype.over = $.prototype.divide = pe.prototype.over = pe.prototype.divide, pe.prototype.mod = function(pn) {
      return vr(this, pn)[1];
    }, Ee.prototype.mod = Ee.prototype.remainder = function(pn) {
      return new Ee(this.value % gn(pn).value);
    }, $.prototype.remainder = $.prototype.mod = pe.prototype.remainder = pe.prototype.mod, pe.prototype.pow = function(pn) {
      var hn = gn(pn), Rn = this.value, vo = hn.value, Hi, di, Ui;
      if (vo === 0) return L[1];
      if (Rn === 0) return L[0];
      if (Rn === 1) return L[1];
      if (Rn === -1) return hn.isEven() ? L[1] : L[-1];
      if (hn.sign)
        return L[0];
      if (!hn.isSmall) throw new Error("The exponent " + hn.toString() + " is too large.");
      if (this.isSmall && be(Hi = Math.pow(Rn, vo)))
        return new $(or(Hi));
      for (di = this, Ui = L[1]; vo & !0 && (Ui = Ui.times(di), --vo), vo !== 0; )
        vo /= 2, di = di.square();
      return Ui;
    }, $.prototype.pow = pe.prototype.pow, Ee.prototype.pow = function(pn) {
      var hn = gn(pn), Rn = this.value, vo = hn.value, Hi = BigInt(0), di = BigInt(1), Ui = BigInt(2);
      if (vo === Hi) return L[1];
      if (Rn === Hi) return L[0];
      if (Rn === di) return L[1];
      if (Rn === BigInt(-1)) return hn.isEven() ? L[1] : L[-1];
      if (hn.isNegative()) return new Ee(Hi);
      for (var ln = this, Un = L[1]; (vo & di) === di && (Un = Un.times(ln), --vo), vo !== Hi; )
        vo /= Ui, ln = ln.square();
      return Un;
    }, pe.prototype.modPow = function(pn, hn) {
      if (pn = gn(pn), hn = gn(hn), hn.isZero()) throw new Error("Cannot take modPow with modulus 0");
      var Rn = L[1], vo = this.mod(hn);
      for (pn.isNegative() && (pn = pn.multiply(L[-1]), vo = vo.modInv(hn)); pn.isPositive(); ) {
        if (vo.isZero()) return L[0];
        pn.isOdd() && (Rn = Rn.multiply(vo).mod(hn)), pn = pn.divide(2), vo = vo.square().mod(hn);
      }
      return Rn;
    }, Ee.prototype.modPow = $.prototype.modPow = pe.prototype.modPow;
    function Te(pn, hn) {
      if (pn.length !== hn.length)
        return pn.length > hn.length ? 1 : -1;
      for (var Rn = pn.length - 1; Rn >= 0; Rn--)
        if (pn[Rn] !== hn[Rn]) return pn[Rn] > hn[Rn] ? 1 : -1;
      return 0;
    }
    pe.prototype.compareAbs = function(pn) {
      var hn = gn(pn), Rn = this.value, vo = hn.value;
      return hn.isSmall ? 1 : Te(Rn, vo);
    }, $.prototype.compareAbs = function(pn) {
      var hn = gn(pn), Rn = Math.abs(this.value), vo = hn.value;
      return hn.isSmall ? (vo = Math.abs(vo), Rn === vo ? 0 : Rn > vo ? 1 : -1) : -1;
    }, Ee.prototype.compareAbs = function(pn) {
      var hn = this.value, Rn = gn(pn).value;
      return hn = hn >= 0 ? hn : -hn, Rn = Rn >= 0 ? Rn : -Rn, hn === Rn ? 0 : hn > Rn ? 1 : -1;
    }, pe.prototype.compare = function(pn) {
      if (pn === 1 / 0)
        return -1;
      if (pn === -1 / 0)
        return 1;
      var hn = gn(pn), Rn = this.value, vo = hn.value;
      return this.sign !== hn.sign ? hn.sign ? 1 : -1 : hn.isSmall ? this.sign ? -1 : 1 : Te(Rn, vo) * (this.sign ? -1 : 1);
    }, pe.prototype.compareTo = pe.prototype.compare, $.prototype.compare = function(pn) {
      if (pn === 1 / 0)
        return -1;
      if (pn === -1 / 0)
        return 1;
      var hn = gn(pn), Rn = this.value, vo = hn.value;
      return hn.isSmall ? Rn == vo ? 0 : Rn > vo ? 1 : -1 : Rn < 0 !== hn.sign ? Rn < 0 ? -1 : 1 : Rn < 0 ? 1 : -1;
    }, $.prototype.compareTo = $.prototype.compare, Ee.prototype.compare = function(pn) {
      if (pn === 1 / 0)
        return -1;
      if (pn === -1 / 0)
        return 1;
      var hn = this.value, Rn = gn(pn).value;
      return hn === Rn ? 0 : hn > Rn ? 1 : -1;
    }, Ee.prototype.compareTo = Ee.prototype.compare, pe.prototype.equals = function(pn) {
      return this.compare(pn) === 0;
    }, Ee.prototype.eq = Ee.prototype.equals = $.prototype.eq = $.prototype.equals = pe.prototype.eq = pe.prototype.equals, pe.prototype.notEquals = function(pn) {
      return this.compare(pn) !== 0;
    }, Ee.prototype.neq = Ee.prototype.notEquals = $.prototype.neq = $.prototype.notEquals = pe.prototype.neq = pe.prototype.notEquals, pe.prototype.greater = function(pn) {
      return this.compare(pn) > 0;
    }, Ee.prototype.gt = Ee.prototype.greater = $.prototype.gt = $.prototype.greater = pe.prototype.gt = pe.prototype.greater, pe.prototype.lesser = function(pn) {
      return this.compare(pn) < 0;
    }, Ee.prototype.lt = Ee.prototype.lesser = $.prototype.lt = $.prototype.lesser = pe.prototype.lt = pe.prototype.lesser, pe.prototype.greaterOrEquals = function(pn) {
      return this.compare(pn) >= 0;
    }, Ee.prototype.geq = Ee.prototype.greaterOrEquals = $.prototype.geq = $.prototype.greaterOrEquals = pe.prototype.geq = pe.prototype.greaterOrEquals, pe.prototype.lesserOrEquals = function(pn) {
      return this.compare(pn) <= 0;
    }, Ee.prototype.leq = Ee.prototype.lesserOrEquals = $.prototype.leq = $.prototype.lesserOrEquals = pe.prototype.leq = pe.prototype.lesserOrEquals, pe.prototype.isEven = function() {
      return (this.value[0] & 1) === 0;
    }, $.prototype.isEven = function() {
      return (this.value & 1) === 0;
    }, Ee.prototype.isEven = function() {
      return (this.value & BigInt(1)) === BigInt(0);
    }, pe.prototype.isOdd = function() {
      return (this.value[0] & 1) === 1;
    }, $.prototype.isOdd = function() {
      return (this.value & 1) === 1;
    }, Ee.prototype.isOdd = function() {
      return (this.value & BigInt(1)) === BigInt(1);
    }, pe.prototype.isPositive = function() {
      return !this.sign;
    }, $.prototype.isPositive = function() {
      return this.value > 0;
    }, Ee.prototype.isPositive = $.prototype.isPositive, pe.prototype.isNegative = function() {
      return this.sign;
    }, $.prototype.isNegative = function() {
      return this.value < 0;
    }, Ee.prototype.isNegative = $.prototype.isNegative, pe.prototype.isUnit = function() {
      return !1;
    }, $.prototype.isUnit = function() {
      return Math.abs(this.value) === 1;
    }, Ee.prototype.isUnit = function() {
      return this.abs().value === BigInt(1);
    }, pe.prototype.isZero = function() {
      return !1;
    }, $.prototype.isZero = function() {
      return this.value === 0;
    }, Ee.prototype.isZero = function() {
      return this.value === BigInt(0);
    }, pe.prototype.isDivisibleBy = function(pn) {
      var hn = gn(pn);
      return hn.isZero() ? !1 : hn.isUnit() ? !0 : hn.compareAbs(2) === 0 ? this.isEven() : this.mod(hn).isZero();
    }, Ee.prototype.isDivisibleBy = $.prototype.isDivisibleBy = pe.prototype.isDivisibleBy;
    function Cr(pn) {
      var hn = pn.abs();
      if (hn.isUnit()) return !1;
      if (hn.equals(2) || hn.equals(3) || hn.equals(5)) return !0;
      if (hn.isEven() || hn.isDivisibleBy(3) || hn.isDivisibleBy(5)) return !1;
      if (hn.lesser(49)) return !0;
    }
    function Hr(pn, hn) {
      for (var Rn = pn.prev(), vo = Rn, Hi = 0, di, Ui, ln; vo.isEven(); ) vo = vo.divide(2), Hi++;
      e: for (Ui = 0; Ui < hn.length; Ui++)
        if (!pn.lesser(hn[Ui]) && (ln = c(hn[Ui]).modPow(vo, pn), !(ln.isUnit() || ln.equals(Rn)))) {
          for (di = Hi - 1; di != 0; di--) {
            if (ln = ln.square().mod(pn), ln.isUnit()) return !1;
            if (ln.equals(Rn)) continue e;
          }
          return !1;
        }
      return !0;
    }
    pe.prototype.isPrime = function(pn) {
      var hn = Cr(this);
      if (hn !== u) return hn;
      var Rn = this.abs(), vo = Rn.bitLength();
      if (vo <= 64)
        return Hr(Rn, [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37]);
      for (var Hi = Math.log(2) * vo.toJSNumber(), di = Math.ceil(pn === !0 ? 2 * Math.pow(Hi, 2) : Hi), Ui = [], ln = 0; ln < di; ln++)
        Ui.push(c(ln + 2));
      return Hr(Rn, Ui);
    }, Ee.prototype.isPrime = $.prototype.isPrime = pe.prototype.isPrime, pe.prototype.isProbablePrime = function(pn, hn) {
      var Rn = Cr(this);
      if (Rn !== u) return Rn;
      for (var vo = this.abs(), Hi = pn === u ? 5 : pn, di = [], Ui = 0; Ui < Hi; Ui++)
        di.push(c.randBetween(2, vo.minus(2), hn));
      return Hr(vo, di);
    }, Ee.prototype.isProbablePrime = $.prototype.isProbablePrime = pe.prototype.isProbablePrime, pe.prototype.modInv = function(pn) {
      for (var hn = c.zero, Rn = c.one, vo = gn(pn), Hi = this.abs(), di, Ui, ln; !Hi.isZero(); )
        di = vo.divide(Hi), Ui = hn, ln = vo, hn = Rn, vo = Hi, Rn = Ui.subtract(di.multiply(Rn)), Hi = ln.subtract(di.multiply(Hi));
      if (!vo.isUnit()) throw new Error(this.toString() + " and " + pn.toString() + " are not co-prime");
      return hn.compare(0) === -1 && (hn = hn.add(pn)), this.isNegative() ? hn.negate() : hn;
    }, Ee.prototype.modInv = $.prototype.modInv = pe.prototype.modInv, pe.prototype.next = function() {
      var pn = this.value;
      return this.sign ? tr(pn, 1, this.sign) : new pe(xr(pn, 1), this.sign);
    }, $.prototype.next = function() {
      var pn = this.value;
      return pn + 1 < A ? new $(pn + 1) : new pe(b, !1);
    }, Ee.prototype.next = function() {
      return new Ee(this.value + BigInt(1));
    }, pe.prototype.prev = function() {
      var pn = this.value;
      return this.sign ? new pe(xr(pn, 1), !0) : tr(pn, 1, this.sign);
    }, $.prototype.prev = function() {
      var pn = this.value;
      return pn - 1 > -A ? new $(pn - 1) : new pe(b, !0);
    }, Ee.prototype.prev = function() {
      return new Ee(this.value - BigInt(1));
    };
    for (var si = [1]; 2 * si[si.length - 1] <= p; ) si.push(2 * si[si.length - 1]);
    var ui = si.length, Li = si[ui - 1];
    function Qi(pn) {
      return Math.abs(pn) <= p;
    }
    pe.prototype.shiftLeft = function(pn) {
      var hn = gn(pn).toJSNumber();
      if (!Qi(hn))
        throw new Error(String(hn) + " is too large for shifting.");
      if (hn < 0) return this.shiftRight(-hn);
      var Rn = this;
      if (Rn.isZero()) return Rn;
      for (; hn >= ui; )
        Rn = Rn.multiply(Li), hn -= ui - 1;
      return Rn.multiply(si[hn]);
    }, Ee.prototype.shiftLeft = $.prototype.shiftLeft = pe.prototype.shiftLeft, pe.prototype.shiftRight = function(pn) {
      var hn, Rn = gn(pn).toJSNumber();
      if (!Qi(Rn))
        throw new Error(String(Rn) + " is too large for shifting.");
      if (Rn < 0) return this.shiftLeft(-Rn);
      for (var vo = this; Rn >= ui; ) {
        if (vo.isZero() || vo.isNegative() && vo.isUnit()) return vo;
        hn = vr(vo, Li), vo = hn[1].isNegative() ? hn[0].prev() : hn[0], Rn -= ui - 1;
      }
      return hn = vr(vo, si[Rn]), hn[1].isNegative() ? hn[0].prev() : hn[0];
    }, Ee.prototype.shiftRight = $.prototype.shiftRight = pe.prototype.shiftRight;
    function wi(pn, hn, Rn) {
      hn = gn(hn);
      for (var vo = pn.isNegative(), Hi = hn.isNegative(), di = vo ? pn.not() : pn, Ui = Hi ? hn.not() : hn, ln = 0, Un = 0, Bo = null, co = null, To = []; !di.isZero() || !Ui.isZero(); )
        Bo = vr(di, Li), ln = Bo[1].toJSNumber(), vo && (ln = Li - 1 - ln), co = vr(Ui, Li), Un = co[1].toJSNumber(), Hi && (Un = Li - 1 - Un), di = Bo[0], Ui = co[0], To.push(Rn(ln, Un));
      for (var xs = Rn(vo ? 1 : 0, Hi ? 1 : 0) !== 0 ? c(-1) : c(0), Fo = To.length - 1; Fo >= 0; Fo -= 1)
        xs = xs.multiply(Li).add(c(To[Fo]));
      return xs;
    }
    pe.prototype.not = function() {
      return this.negate().prev();
    }, Ee.prototype.not = $.prototype.not = pe.prototype.not, pe.prototype.and = function(pn) {
      return wi(this, pn, function(hn, Rn) {
        return hn & Rn;
      });
    }, Ee.prototype.and = $.prototype.and = pe.prototype.and, pe.prototype.or = function(pn) {
      return wi(this, pn, function(hn, Rn) {
        return hn | Rn;
      });
    }, Ee.prototype.or = $.prototype.or = pe.prototype.or, pe.prototype.xor = function(pn) {
      return wi(this, pn, function(hn, Rn) {
        return hn ^ Rn;
      });
    }, Ee.prototype.xor = $.prototype.xor = pe.prototype.xor;
    var Ji = 1 << 30, mn = (p & -p) * (p & -p) | Ji;
    function pi(pn) {
      var hn = pn.value, Rn = typeof hn == "number" ? hn | Ji : typeof hn == "bigint" ? hn | BigInt(Ji) : hn[0] + hn[1] * p | mn;
      return Rn & -Rn;
    }
    function ei(pn, hn) {
      if (hn.compareTo(pn) <= 0) {
        var Rn = ei(pn, hn.square(hn)), vo = Rn.p, Hi = Rn.e, di = vo.multiply(hn);
        return di.compareTo(pn) <= 0 ? { p: di, e: Hi * 2 + 1 } : { p: vo, e: Hi * 2 };
      }
      return { p: c(1), e: 0 };
    }
    pe.prototype.bitLength = function() {
      var pn = this;
      return pn.compareTo(c(0)) < 0 && (pn = pn.negate().subtract(c(1))), pn.compareTo(c(0)) === 0 ? c(0) : c(ei(pn, c(2)).e).add(c(1));
    }, Ee.prototype.bitLength = $.prototype.bitLength = pe.prototype.bitLength;
    function Vr(pn, hn) {
      return pn = gn(pn), hn = gn(hn), pn.greater(hn) ? pn : hn;
    }
    function qr(pn, hn) {
      return pn = gn(pn), hn = gn(hn), pn.lesser(hn) ? pn : hn;
    }
    function Zi(pn, hn) {
      if (pn = gn(pn).abs(), hn = gn(hn).abs(), pn.equals(hn)) return pn;
      if (pn.isZero()) return hn;
      if (hn.isZero()) return pn;
      for (var Rn = L[1], vo, Hi; pn.isEven() && hn.isEven(); )
        vo = qr(pi(pn), pi(hn)), pn = pn.divide(vo), hn = hn.divide(vo), Rn = Rn.multiply(vo);
      for (; pn.isEven(); )
        pn = pn.divide(pi(pn));
      do {
        for (; hn.isEven(); )
          hn = hn.divide(pi(hn));
        pn.greater(hn) && (Hi = hn, hn = pn, pn = Hi), hn = hn.subtract(pn);
      } while (!hn.isZero());
      return Rn.isUnit() ? pn : pn.multiply(Rn);
    }
    function Wr(pn, hn) {
      return pn = gn(pn).abs(), hn = gn(hn).abs(), pn.divide(Zi(pn, hn)).multiply(hn);
    }
    function ri(pn, hn, Rn) {
      pn = gn(pn), hn = gn(hn);
      var vo = Rn || Math.random, Hi = qr(pn, hn), di = Vr(pn, hn), Ui = di.subtract(Hi).add(1);
      if (Ui.isSmall) return Hi.add(Math.floor(vo() * Ui));
      for (var ln = _n(Ui, p).value, Un = [], Bo = !0, co = 0; co < ln.length; co++) {
        var To = Bo ? ln[co] + (co + 1 < ln.length ? ln[co + 1] / p : 0) : p, xs = or(vo() * To);
        Un.push(xs), xs < ln[co] && (Bo = !1);
      }
      return Hi.add(L.fromArray(Un, p, !1));
    }
    var _i = function(pn, hn, Rn, vo) {
      Rn = Rn || F, pn = String(pn), vo || (pn = pn.toLowerCase(), Rn = Rn.toLowerCase());
      var Hi = pn.length, di, Ui = Math.abs(hn), ln = {};
      for (di = 0; di < Rn.length; di++)
        ln[Rn[di]] = di;
      for (di = 0; di < Hi; di++) {
        var Un = pn[di];
        if (Un !== "-" && Un in ln && ln[Un] >= Ui) {
          if (Un === "1" && Ui === 1) continue;
          throw new Error(Un + " is not a valid digit in base " + hn + ".");
        }
      }
      hn = gn(hn);
      var Bo = [], co = pn[0] === "-";
      for (di = co ? 1 : 0; di < pn.length; di++) {
        var Un = pn[di];
        if (Un in ln) Bo.push(gn(ln[Un]));
        else if (Un === "<") {
          var To = di;
          do
            di++;
          while (pn[di] !== ">" && di < pn.length);
          Bo.push(gn(pn.slice(To + 1, di)));
        } else throw new Error(Un + " is not a valid character");
      }
      return Er(Bo, hn, co);
    };
    function Er(pn, hn, Rn) {
      var vo = L[0], Hi = L[1], di;
      for (di = pn.length - 1; di >= 0; di--)
        vo = vo.add(pn[di].times(Hi)), Hi = Hi.times(hn);
      return Rn ? vo.negate() : vo;
    }
    function Di(pn, hn) {
      return hn = hn || F, pn < hn.length ? hn[pn] : "<" + pn + ">";
    }
    function _n(pn, hn) {
      if (hn = c(hn), hn.isZero()) {
        if (pn.isZero()) return { value: [0], isNegative: !1 };
        throw new Error("Cannot convert nonzero numbers to base 0.");
      }
      if (hn.equals(-1)) {
        if (pn.isZero()) return { value: [0], isNegative: !1 };
        if (pn.isNegative())
          return {
            value: [].concat.apply(
              [],
              Array.apply(null, Array(-pn.toJSNumber())).map(Array.prototype.valueOf, [1, 0])
            ),
            isNegative: !1
          };
        var Rn = Array.apply(null, Array(pn.toJSNumber() - 1)).map(Array.prototype.valueOf, [0, 1]);
        return Rn.unshift([1]), {
          value: [].concat.apply([], Rn),
          isNegative: !1
        };
      }
      var vo = !1;
      if (pn.isNegative() && hn.isPositive() && (vo = !0, pn = pn.abs()), hn.isUnit())
        return pn.isZero() ? { value: [0], isNegative: !1 } : {
          value: Array.apply(null, Array(pn.toJSNumber())).map(Number.prototype.valueOf, 1),
          isNegative: vo
        };
      for (var Hi = [], di = pn, Ui; di.isNegative() || di.compareAbs(hn) >= 0; ) {
        Ui = di.divmod(hn), di = Ui.quotient;
        var ln = Ui.remainder;
        ln.isNegative() && (ln = hn.minus(ln).abs(), di = di.next()), Hi.push(ln.toJSNumber());
      }
      return Hi.push(di.toJSNumber()), { value: Hi.reverse(), isNegative: vo };
    }
    function On(pn, hn, Rn) {
      var vo = _n(pn, hn);
      return (vo.isNegative ? "-" : "") + vo.value.map(function(Hi) {
        return Di(Hi, Rn);
      }).join("");
    }
    pe.prototype.toArray = function(pn) {
      return _n(this, pn);
    }, $.prototype.toArray = function(pn) {
      return _n(this, pn);
    }, Ee.prototype.toArray = function(pn) {
      return _n(this, pn);
    }, pe.prototype.toString = function(pn, hn) {
      if (pn === u && (pn = 10), pn !== 10 || hn) return On(this, pn, hn);
      for (var Rn = this.value, vo = Rn.length, Hi = String(Rn[--vo]), di = "0000000", Ui; --vo >= 0; )
        Ui = String(Rn[vo]), Hi += di.slice(Ui.length) + Ui;
      var ln = this.sign ? "-" : "";
      return ln + Hi;
    }, $.prototype.toString = function(pn, hn) {
      return pn === u && (pn = 10), pn != 10 || hn ? On(this, pn, hn) : String(this.value);
    }, Ee.prototype.toString = $.prototype.toString, Ee.prototype.toJSON = pe.prototype.toJSON = $.prototype.toJSON = function() {
      return this.toString();
    }, pe.prototype.valueOf = function() {
      return parseInt(this.toString(), 10);
    }, pe.prototype.toJSNumber = pe.prototype.valueOf, $.prototype.valueOf = function() {
      return this.value;
    }, $.prototype.toJSNumber = $.prototype.valueOf, Ee.prototype.valueOf = Ee.prototype.toJSNumber = function() {
      return parseInt(this.toString(), 10);
    };
    function so(pn) {
      if (be(+pn)) {
        var hn = +pn;
        if (hn === or(hn))
          return le ? new Ee(BigInt(hn)) : new $(hn);
        throw new Error("Invalid integer: " + pn);
      }
      var Rn = pn[0] === "-";
      Rn && (pn = pn.slice(1));
      var vo = pn.split(/e/i);
      if (vo.length > 2) throw new Error("Invalid integer: " + vo.join("e"));
      if (vo.length === 2) {
        var Hi = vo[1];
        if (Hi[0] === "+" && (Hi = Hi.slice(1)), Hi = +Hi, Hi !== or(Hi) || !be(Hi)) throw new Error("Invalid integer: " + Hi + " is not a valid exponent.");
        var di = vo[0], Ui = di.indexOf(".");
        if (Ui >= 0 && (Hi -= di.length - Ui - 1, di = di.slice(0, Ui) + di.slice(Ui + 1)), Hi < 0) throw new Error("Cannot include negative exponent part for integers");
        di += new Array(Hi + 1).join("0"), pn = di;
      }
      var ln = /^([0-9][0-9]*)$/.test(pn);
      if (!ln) throw new Error("Invalid integer: " + pn);
      if (le)
        return new Ee(BigInt(Rn ? "-" + pn : pn));
      for (var Un = [], Bo = pn.length, co = a, To = Bo - co; Bo > 0; )
        Un.push(+pn.slice(To, Bo)), To -= co, To < 0 && (To = 0), Bo -= co;
      return nr(Un), new pe(Un, Rn);
    }
    function Do(pn) {
      if (le)
        return new Ee(BigInt(pn));
      if (be(pn)) {
        if (pn !== or(pn)) throw new Error(pn + " is not an integer.");
        return new $(pn);
      }
      return so(pn.toString());
    }
    function gn(pn) {
      return typeof pn == "number" ? Do(pn) : typeof pn == "string" ? so(pn) : typeof pn == "bigint" ? new Ee(pn) : pn;
    }
    for (var Gn = 0; Gn < 1e3; Gn++)
      L[Gn] = gn(Gn), Gn > 0 && (L[-Gn] = gn(-Gn));
    return L.one = L[1], L.zero = L[0], L.minusOne = L[-1], L.max = Vr, L.min = qr, L.gcd = Zi, L.lcm = Wr, L.isInstance = function(pn) {
      return pn instanceof pe || pn instanceof $ || pn instanceof Ee;
    }, L.randBetween = ri, L.fromArray = function(pn, hn, Rn) {
      return Er(pn.map(gn), gn(hn || 10), Rn);
    }, L;
  }();
  n.hasOwnProperty("exports") && (n.exports = c);
})(BigInteger);
var BigIntegerExports = BigInteger.exports;
Object.defineProperty(amount, "__esModule", { value: !0 });
amount.Amount = void 0;
const decimal_js_1$1 = decimalExports, binary_parser_1$4 = binaryParser, account_id_1$3 = accountId, currency_1$2 = currency$1, serialized_type_1$6 = serializedType, bigInt$3 = BigIntegerExports, buffer_1$e = dist$u, MIN_IOU_EXPONENT = -96, MAX_IOU_EXPONENT = 80, MAX_IOU_PRECISION = 16, MAX_DROPS = new decimal_js_1$1.Decimal("1e17"), MIN_XRP = new decimal_js_1$1.Decimal("1e-6"), mask$1 = bigInt$3(4294967295);
decimal_js_1$1.Decimal.config({
  toExpPos: MAX_IOU_EXPONENT + MAX_IOU_PRECISION,
  toExpNeg: MIN_IOU_EXPONENT - MAX_IOU_PRECISION
});
function isAmountObject(n) {
  const c = Object.keys(n).sort();
  return c.length === 3 && c[0] === "currency" && c[1] === "issuer" && c[2] === "value";
}
class Amount extends serialized_type_1$6.SerializedType {
  constructor(c) {
    super(c ?? Amount.defaultAmount.bytes);
  }
  /**
   * Construct an amount from an IOU or string amount
   *
   * @param value An Amount, object representing an IOU, or a string
   *     representing an integer amount
   * @returns An Amount object
   */
  static from(c) {
    if (c instanceof Amount)
      return c;
    let u = buffer_1$e.Buffer.alloc(8);
    if (typeof c == "string") {
      Amount.assertXrpIsValid(c);
      const p = bigInt$3(c), a = [buffer_1$e.Buffer.alloc(4), buffer_1$e.Buffer.alloc(4)];
      return a[0].writeUInt32BE(Number(p.shiftRight(32)), 0), a[1].writeUInt32BE(Number(p.and(mask$1)), 0), u = buffer_1$e.Buffer.concat(a), u[0] |= 64, new Amount(u);
    }
    if (isAmountObject(c)) {
      const p = new decimal_js_1$1.Decimal(c.value);
      if (Amount.assertIouIsValid(p), p.isZero())
        u[0] |= 128;
      else {
        const b = p.times(`1e${-(p.e - 15)}`).abs().toString(), F = bigInt$3(b), le = [buffer_1$e.Buffer.alloc(4), buffer_1$e.Buffer.alloc(4)];
        le[0].writeUInt32BE(Number(F.shiftRight(32)), 0), le[1].writeUInt32BE(Number(F.and(mask$1)), 0), u = buffer_1$e.Buffer.concat(le), u[0] |= 128, p.gt(new decimal_js_1$1.Decimal(0)) && (u[0] |= 64);
        const pe = 97 + (p.e - 15);
        u[0] |= pe >>> 2, u[1] |= (pe & 3) << 6;
      }
      const a = currency_1$2.Currency.from(c.currency).toBytes(), A = account_id_1$3.AccountID.from(c.issuer).toBytes();
      return new Amount(buffer_1$e.Buffer.concat([u, a, A]));
    }
    throw new Error("Invalid type to construct an Amount");
  }
  /**
   * Read an amount from a BinaryParser
   *
   * @param parser BinaryParser to read the Amount from
   * @returns An Amount object
   */
  static fromParser(c) {
    const p = c.peek() & 128 ? 48 : 8;
    return new Amount(c.read(p));
  }
  /**
   * Get the JSON representation of this Amount
   *
   * @returns the JSON interpretation of this.bytes
   */
  toJSON() {
    if (this.isNative()) {
      const c = this.bytes, p = c[0] & 64 ? "" : "-";
      c[0] &= 63;
      const a = bigInt$3(c.slice(0, 4).readUInt32BE(0)), A = bigInt$3(c.slice(4).readUInt32BE(0)), b = a.shiftLeft(32).or(A);
      return `${p}${b.toString()}`;
    } else {
      const c = new binary_parser_1$4.BinaryParser(this.toString()), u = c.read(8), p = currency_1$2.Currency.fromParser(c), a = account_id_1$3.AccountID.fromParser(c), A = u[0], b = u[1], le = A & 64 ? "" : "-", L = ((A & 63) << 2) + ((b & 255) >> 6) - 97;
      u[0] = 0, u[1] &= 63;
      const pe = new decimal_js_1$1.Decimal(`${le}0x${u.toString("hex")}`).times(`1e${L}`);
      return Amount.assertIouIsValid(pe), {
        value: pe.toString(),
        currency: p.toJSON(),
        issuer: a.toJSON()
      };
    }
  }
  /**
   * Validate XRP amount
   *
   * @param amount String representing XRP amount
   * @returns void, but will throw if invalid amount
   */
  static assertXrpIsValid(c) {
    if (c.indexOf(".") !== -1)
      throw new Error(`${c.toString()} is an illegal amount`);
    const u = new decimal_js_1$1.Decimal(c);
    if (!u.isZero() && (u.lt(MIN_XRP) || u.gt(MAX_DROPS)))
      throw new Error(`${c.toString()} is an illegal amount`);
  }
  /**
   * Validate IOU.value amount
   *
   * @param decimal Decimal.js object representing IOU.value
   * @returns void, but will throw if invalid amount
   */
  static assertIouIsValid(c) {
    if (!c.isZero()) {
      const u = c.precision(), p = c.e - 15;
      if (u > MAX_IOU_PRECISION || p > MAX_IOU_EXPONENT || p < MIN_IOU_EXPONENT)
        throw new Error("Decimal precision out of range");
      this.verifyNoDecimal(c);
    }
  }
  /**
   * Ensure that the value after being multiplied by the exponent does not
   * contain a decimal.
   *
   * @param decimal a Decimal object
   * @returns a string of the object without a decimal
   */
  static verifyNoDecimal(c) {
    if (c.times(`1e${-(c.e - 15)}`).abs().toString().indexOf(".") !== -1)
      throw new Error("Decimal place found in integerNumberString");
  }
  /**
   * Test if this amount is in units of Native Currency(XRP)
   *
   * @returns true if Native (XRP)
   */
  isNative() {
    return (this.bytes[0] & 128) === 0;
  }
}
amount.Amount = Amount;
Amount.defaultAmount = new Amount(buffer_1$e.Buffer.from("4000000000000000", "hex"));
var blob = {};
Object.defineProperty(blob, "__esModule", { value: !0 });
blob.Blob = void 0;
const serialized_type_1$5 = serializedType, buffer_1$d = dist$u;
class Blob extends serialized_type_1$5.SerializedType {
  constructor(c) {
    super(c);
  }
  /**
   * Defines how to read a Blob from a BinaryParser
   *
   * @param parser The binary parser to read the Blob from
   * @param hint The length of the blob, computed by readVariableLengthLength() and passed in
   * @returns A Blob object
   */
  static fromParser(c, u) {
    return new Blob(c.read(u));
  }
  /**
   * Create a Blob object from a hex-string
   *
   * @param value existing Blob object or a hex-string
   * @returns A Blob object
   */
  static from(c) {
    if (c instanceof Blob)
      return c;
    if (typeof c == "string")
      return new Blob(buffer_1$d.Buffer.from(c, "hex"));
    throw new Error("Cannot construct Blob from value given");
  }
}
blob.Blob = Blob;
var hash128 = {};
Object.defineProperty(hash128, "__esModule", { value: !0 });
hash128.Hash128 = void 0;
const hash_1$1 = hash$6, buffer_1$c = dist$u;
class Hash128 extends hash_1$1.Hash {
  constructor(c) {
    c && c.byteLength === 0 && (c = Hash128.ZERO_128.bytes), super(c ?? Hash128.ZERO_128.bytes);
  }
  /**
   * Get the hex representation of a hash-128 bytes, allowing unset
   *
   * @returns hex String of this.bytes
   */
  toHex() {
    const c = this.toBytes().toString("hex").toUpperCase();
    return /^0+$/.exec(c) ? "" : c;
  }
}
hash128.Hash128 = Hash128;
Hash128.width = 16;
Hash128.ZERO_128 = new Hash128(buffer_1$c.Buffer.alloc(Hash128.width));
var hash256$4 = {};
Object.defineProperty(hash256$4, "__esModule", { value: !0 });
hash256$4.Hash256 = void 0;
const hash_1 = hash$6, buffer_1$b = dist$u;
class Hash256 extends hash_1.Hash {
  constructor(c) {
    super(c ?? Hash256.ZERO_256.bytes);
  }
}
hash256$4.Hash256 = Hash256;
Hash256.width = 32;
Hash256.ZERO_256 = new Hash256(buffer_1$b.Buffer.alloc(Hash256.width));
var issue = {};
Object.defineProperty(issue, "__esModule", { value: !0 });
issue.Issue = void 0;
const binary_parser_1$3 = binaryParser, account_id_1$2 = accountId, currency_1$1 = currency$1, serialized_type_1$4 = serializedType, buffer_1$a = dist$u;
function isIssueObject(n) {
  const c = Object.keys(n).sort();
  return c.length === 1 ? c[0] === "currency" : c.length === 2 && c[0] === "currency" && c[1] === "issuer";
}
class Issue extends serialized_type_1$4.SerializedType {
  constructor(c) {
    super(c ?? Issue.ZERO_ISSUED_CURRENCY.bytes);
  }
  /**
   * Construct an amount from an IOU or string amount
   *
   * @param value An Amount, object representing an IOU, or a string
   *     representing an integer amount
   * @returns An Amount object
   */
  static from(c) {
    if (c instanceof Issue)
      return c;
    if (isIssueObject(c)) {
      const u = currency_1$1.Currency.from(c.currency).toBytes();
      if (c.issuer == null)
        return new Issue(u);
      const p = account_id_1$2.AccountID.from(c.issuer).toBytes();
      return new Issue(buffer_1$a.Buffer.concat([u, p]));
    }
    throw new Error("Invalid type to construct an Amount");
  }
  /**
   * Read an amount from a BinaryParser
   *
   * @param parser BinaryParser to read the Amount from
   * @returns An Amount object
   */
  static fromParser(c) {
    const u = c.read(20);
    if (new currency_1$1.Currency(u).toJSON() === "XRP")
      return new Issue(u);
    const p = [u, c.read(20)];
    return new Issue(buffer_1$a.Buffer.concat(p));
  }
  /**
   * Get the JSON representation of this Amount
   *
   * @returns the JSON interpretation of this.bytes
   */
  toJSON() {
    const c = new binary_parser_1$3.BinaryParser(this.toString()), u = currency_1$1.Currency.fromParser(c);
    if (u.toJSON() === "XRP")
      return { currency: u.toJSON() };
    const p = account_id_1$2.AccountID.fromParser(c);
    return {
      currency: u.toJSON(),
      issuer: p.toJSON()
    };
  }
}
issue.Issue = Issue;
Issue.ZERO_ISSUED_CURRENCY = new Issue(buffer_1$a.Buffer.alloc(20));
var pathSet = {};
Object.defineProperty(pathSet, "__esModule", { value: !0 });
pathSet.PathSet = void 0;
const account_id_1$1 = accountId, currency_1 = currency$1, binary_parser_1$2 = binaryParser, serialized_type_1$3 = serializedType, buffer_1$9 = dist$u, PATHSET_END_BYTE = 0, PATH_SEPARATOR_BYTE = 255, TYPE_ACCOUNT = 1, TYPE_CURRENCY = 16, TYPE_ISSUER = 32;
function isHopObject(n) {
  return n.issuer !== void 0 || n.account !== void 0 || n.currency !== void 0;
}
function isPathSet(n) {
  return Array.isArray(n) && n.length === 0 || Array.isArray(n) && Array.isArray(n[0]) && n[0].length === 0 || Array.isArray(n) && Array.isArray(n[0]) && isHopObject(n[0][0]);
}
class Hop extends serialized_type_1$3.SerializedType {
  /**
   * Create a Hop from a HopObject
   *
   * @param value Either a hop or HopObject to create a hop with
   * @returns a Hop
   */
  static from(c) {
    if (c instanceof Hop)
      return c;
    const u = [buffer_1$9.Buffer.from([0])];
    return c.account && (u.push(account_id_1$1.AccountID.from(c.account).toBytes()), u[0][0] |= TYPE_ACCOUNT), c.currency && (u.push(currency_1.Currency.from(c.currency).toBytes()), u[0][0] |= TYPE_CURRENCY), c.issuer && (u.push(account_id_1$1.AccountID.from(c.issuer).toBytes()), u[0][0] |= TYPE_ISSUER), new Hop(buffer_1$9.Buffer.concat(u));
  }
  /**
   * Construct a Hop from a BinaryParser
   *
   * @param parser BinaryParser to read the Hop from
   * @returns a Hop
   */
  static fromParser(c) {
    const u = c.readUInt8(), p = [buffer_1$9.Buffer.from([u])];
    return u & TYPE_ACCOUNT && p.push(c.read(account_id_1$1.AccountID.width)), u & TYPE_CURRENCY && p.push(c.read(currency_1.Currency.width)), u & TYPE_ISSUER && p.push(c.read(account_id_1$1.AccountID.width)), new Hop(buffer_1$9.Buffer.concat(p));
  }
  /**
   * Get the JSON interpretation of this hop
   *
   * @returns a HopObject, an JS object with optional account, issuer, and currency
   */
  toJSON() {
    const c = new binary_parser_1$2.BinaryParser(this.bytes.toString("hex")), u = c.readUInt8();
    let p, a, A;
    u & TYPE_ACCOUNT && (p = account_id_1$1.AccountID.fromParser(c).toJSON()), u & TYPE_CURRENCY && (a = currency_1.Currency.fromParser(c).toJSON()), u & TYPE_ISSUER && (A = account_id_1$1.AccountID.fromParser(c).toJSON());
    const b = {};
    return p && (b.account = p), A && (b.issuer = A), a && (b.currency = a), b;
  }
  /**
   * get a number representing the type of this hop
   *
   * @returns a number to be bitwise and-ed with TYPE_ constants to describe the types in the hop
   */
  type() {
    return this.bytes[0];
  }
}
let Path$1 = class f1 extends serialized_type_1$3.SerializedType {
  /**
   * construct a Path from an array of Hops
   *
   * @param value Path or array of HopObjects to construct a Path
   * @returns the Path
   */
  static from(c) {
    if (c instanceof f1)
      return c;
    const u = [];
    return c.forEach((p) => {
      u.push(Hop.from(p).toBytes());
    }), new f1(buffer_1$9.Buffer.concat(u));
  }
  /**
   * Read a Path from a BinaryParser
   *
   * @param parser BinaryParser to read Path from
   * @returns the Path represented by the bytes read from the BinaryParser
   */
  static fromParser(c) {
    const u = [];
    for (; !c.end() && (u.push(Hop.fromParser(c).toBytes()), !(c.peek() === PATHSET_END_BYTE || c.peek() === PATH_SEPARATOR_BYTE)); )
      ;
    return new f1(buffer_1$9.Buffer.concat(u));
  }
  /**
   * Get the JSON representation of this Path
   *
   * @returns an Array of HopObject constructed from this.bytes
   */
  toJSON() {
    const c = [], u = new binary_parser_1$2.BinaryParser(this.toString());
    for (; !u.end(); )
      c.push(Hop.fromParser(u).toJSON());
    return c;
  }
};
class PathSet extends serialized_type_1$3.SerializedType {
  /**
   * Construct a PathSet from an Array of Arrays representing paths
   *
   * @param value A PathSet or Array of Array of HopObjects
   * @returns the PathSet constructed from value
   */
  static from(c) {
    if (c instanceof PathSet)
      return c;
    if (isPathSet(c)) {
      const u = [];
      return c.forEach((p) => {
        u.push(Path$1.from(p).toBytes()), u.push(buffer_1$9.Buffer.from([PATH_SEPARATOR_BYTE]));
      }), u[u.length - 1] = buffer_1$9.Buffer.from([PATHSET_END_BYTE]), new PathSet(buffer_1$9.Buffer.concat(u));
    }
    throw new Error("Cannot construct PathSet from given value");
  }
  /**
   * Construct a PathSet from a BinaryParser
   *
   * @param parser A BinaryParser to read PathSet from
   * @returns the PathSet read from parser
   */
  static fromParser(c) {
    const u = [];
    for (; !c.end() && (u.push(Path$1.fromParser(c).toBytes()), u.push(c.read(1)), u[u.length - 1][0] != PATHSET_END_BYTE); )
      ;
    return new PathSet(buffer_1$9.Buffer.concat(u));
  }
  /**
   * Get the JSON representation of this PathSet
   *
   * @returns an Array of Array of HopObjects, representing this PathSet
   */
  toJSON() {
    const c = [], u = new binary_parser_1$2.BinaryParser(this.toString());
    for (; !u.end(); )
      c.push(Path$1.fromParser(u).toJSON()), u.skip(1);
    return c;
  }
}
pathSet.PathSet = PathSet;
var stArray = {}, stObject = {}, hasRequiredStObject;
function requireStObject() {
  if (hasRequiredStObject) return stObject;
  hasRequiredStObject = 1, Object.defineProperty(stObject, "__esModule", { value: !0 }), stObject.STObject = void 0;
  const n = enums, c = serializedType, u = dist$2, p = binaryParser, a = binarySerializer, A = dist$u, b = requireStArray(), F = A.Buffer.from([225]), le = "ObjectEndMarker", L = "STObject", pe = "Destination", $ = "Account", Ee = "SourceTag", be = "DestinationTag";
  function He(ir, or) {
    const lr = (0, u.xAddressToClassicAddress)(or);
    let Ir;
    if (ir === pe)
      Ir = be;
    else if (ir === $)
      Ir = Ee;
    else if (lr.tag !== !1)
      throw new Error(`${ir} cannot have an associated tag`);
    return lr.tag !== !1 ? { [ir]: lr.classicAddress, [Ir]: lr.tag } : { [ir]: lr.classicAddress };
  }
  function Pe(ir, or) {
    if (!(ir[Ee] === void 0 || or[Ee] === void 0))
      throw new Error("Cannot have Account X-Address and SourceTag");
    if (!(ir[be] === void 0 || or[be] === void 0))
      throw new Error("Cannot have Destination X-Address and DestinationTag");
  }
  class nr extends c.SerializedType {
    /**
     * Construct a STObject from a BinaryParser
     *
     * @param parser BinaryParser to read STObject from
     * @returns A STObject object
     */
    static fromParser(or) {
      const lr = new a.BytesList(), Ir = new a.BinarySerializer(lr);
      for (; !or.end(); ) {
        const xr = or.readField();
        if (xr.name === le)
          break;
        const kr = or.readFieldValue(xr);
        Ir.writeFieldAndValue(xr, kr), xr.type.name === L && Ir.put(F);
      }
      return new nr(lr.toBytes());
    }
    /**
     * Construct a STObject from a JSON object
     *
     * @param value An object to include
     * @param filter optional, denote which field to include in serialized object
     * @param definitions optional, types and values to use to encode/decode a transaction
     * @returns a STObject object
     */
    static from(or, lr, Ir = n.DEFAULT_DEFINITIONS) {
      if (or instanceof nr)
        return or;
      const xr = new a.BytesList(), kr = new a.BinarySerializer(xr);
      let Ce = !1;
      const tr = Object.entries(or).reduce((Sr, [er, Ie]) => {
        let xe;
        return Ie && (0, u.isValidXAddress)(Ie.toString()) && (xe = He(er, Ie.toString()), Pe(xe, or)), Object.assign(Sr, xe ?? { [er]: Ie });
      }, {});
      let Fe = Object.keys(tr).map((Sr) => Ir.field[Sr]).filter((Sr) => Sr !== void 0 && tr[Sr.name] !== void 0 && Sr.isSerialized).sort((Sr, er) => Sr.ordinal - er.ordinal);
      return lr !== void 0 && (Fe = Fe.filter(lr)), Fe.forEach((Sr) => {
        const er = Sr.type.name === L ? this.from(tr[Sr.name], void 0, Ir) : Sr.type.name === "STArray" ? b.STArray.from(tr[Sr.name], Ir) : Sr.associatedType.from(tr[Sr.name]);
        if (er == null)
          throw new TypeError(`Unable to interpret "${Sr.name}: ${tr[Sr.name]}".`);
        er.name === "UNLModify" && (Ce = !0);
        const Ie = Sr.name == "Account" && Ce;
        kr.writeFieldAndValue(Sr, er, Ie), Sr.type.name === L && kr.put(F);
      }), new nr(xr.toBytes());
    }
    /**
     * Get the JSON interpretation of this.bytes
     * @param definitions rippled definitions used to parse the values of transaction types and such.
     *                          Can be customized for sidechains and amendments.
     * @returns a JSON object
     */
    toJSON(or) {
      const lr = new p.BinaryParser(this.toString(), or), Ir = {};
      for (; !lr.end(); ) {
        const xr = lr.readField();
        if (xr.name === le)
          break;
        Ir[xr.name] = lr.readFieldValue(xr).toJSON(or);
      }
      return Ir;
    }
  }
  return stObject.STObject = nr, stObject;
}
var hasRequiredStArray;
function requireStArray() {
  if (hasRequiredStArray) return stArray;
  hasRequiredStArray = 1, Object.defineProperty(stArray, "__esModule", { value: !0 }), stArray.STArray = void 0;
  const n = enums, c = serializedType, u = requireStObject(), p = binaryParser, a = dist$u, A = a.Buffer.from([241]), b = "ArrayEndMarker", F = a.Buffer.from([225]);
  function le(pe) {
    return Array.isArray(pe) && (pe.length === 0 || typeof pe[0] == "object");
  }
  class L extends c.SerializedType {
    /**
     * Construct an STArray from a BinaryParser
     *
     * @param parser BinaryParser to parse an STArray from
     * @returns An STArray Object
     */
    static fromParser($) {
      const Ee = [];
      for (; !$.end(); ) {
        const be = $.readField();
        if (be.name === b)
          break;
        Ee.push(be.header, $.readFieldValue(be).toBytes(), F);
      }
      return Ee.push(A), new L(a.Buffer.concat(Ee));
    }
    /**
     * Construct an STArray from an Array of JSON Objects
     *
     * @param value STArray or Array of Objects to parse into an STArray
     * @param definitions optional, types and values to use to encode/decode a transaction
     * @returns An STArray object
     */
    static from($, Ee = n.DEFAULT_DEFINITIONS) {
      if ($ instanceof L)
        return $;
      if (le($)) {
        const be = [];
        return $.forEach((He) => {
          be.push(u.STObject.from(He, void 0, Ee).toBytes());
        }), be.push(A), new L(a.Buffer.concat(be));
      }
      throw new Error("Cannot construct STArray from value given");
    }
    /**
     * Return the JSON representation of this.bytes
     *
     * @param definitions optional, types and values to use to encode/decode a transaction
     * @returns An Array of JSON objects
     */
    toJSON($ = n.DEFAULT_DEFINITIONS) {
      const Ee = [], be = new p.BinaryParser(this.toString(), $);
      for (; !be.end(); ) {
        const He = be.readField();
        if (He.name === b)
          break;
        const Pe = {};
        Pe[He.name] = u.STObject.fromParser(be).toJSON($), Ee.push(Pe);
      }
      return Ee;
    }
  }
  return stArray.STArray = L, stArray;
}
var uint16 = {}, uint = {};
Object.defineProperty(uint, "__esModule", { value: !0 });
uint.UInt = void 0;
const serialized_type_1$2 = serializedType;
function compare$d(n, c) {
  return n < c ? -1 : n == c ? 0 : 1;
}
class UInt extends serialized_type_1$2.Comparable {
  constructor(c) {
    super(c);
  }
  /**
   * Overload of compareTo for Comparable
   *
   * @param other other UInt to compare this to
   * @returns -1, 0, or 1 depending on how the objects relate to each other
   */
  compareTo(c) {
    return compare$d(this.valueOf(), c.valueOf());
  }
  /**
   * Convert a UInt object to JSON
   *
   * @returns number or string represented by this.bytes
   */
  toJSON() {
    const c = this.valueOf();
    return typeof c == "number" ? c : c.toString();
  }
}
uint.UInt = UInt;
Object.defineProperty(uint16, "__esModule", { value: !0 });
uint16.UInt16 = void 0;
const uint_1$3 = uint, buffer_1$8 = dist$u;
class UInt16 extends uint_1$3.UInt {
  constructor(c) {
    super(c ?? UInt16.defaultUInt16.bytes);
  }
  static fromParser(c) {
    return new UInt16(c.read(UInt16.width));
  }
  /**
   * Construct a UInt16 object from a number
   *
   * @param val UInt16 object or number
   */
  static from(c) {
    if (c instanceof UInt16)
      return c;
    if (typeof c == "number") {
      const u = buffer_1$8.Buffer.alloc(UInt16.width);
      return u.writeUInt16BE(c, 0), new UInt16(u);
    }
    throw new Error("Can not construct UInt16 with given value");
  }
  /**
   * get the value of a UInt16 object
   *
   * @returns the number represented by this.bytes
   */
  valueOf() {
    return this.bytes.readUInt16BE(0);
  }
}
uint16.UInt16 = UInt16;
UInt16.width = 16 / 8;
UInt16.defaultUInt16 = new UInt16(buffer_1$8.Buffer.alloc(UInt16.width));
var uint32$1 = {};
Object.defineProperty(uint32$1, "__esModule", { value: !0 });
uint32$1.UInt32 = void 0;
const uint_1$2 = uint, buffer_1$7 = dist$u;
class UInt32 extends uint_1$2.UInt {
  constructor(c) {
    super(c ?? UInt32.defaultUInt32.bytes);
  }
  static fromParser(c) {
    return new UInt32(c.read(UInt32.width));
  }
  /**
   * Construct a UInt32 object from a number
   *
   * @param val UInt32 object or number
   */
  static from(c) {
    if (c instanceof UInt32)
      return c;
    const u = buffer_1$7.Buffer.alloc(UInt32.width);
    if (typeof c == "string") {
      const p = Number.parseInt(c);
      return u.writeUInt32BE(p, 0), new UInt32(u);
    }
    if (typeof c == "number")
      return u.writeUInt32BE(c, 0), new UInt32(u);
    throw new Error("Cannot construct UInt32 from given value");
  }
  /**
   * get the value of a UInt32 object
   *
   * @returns the number represented by this.bytes
   */
  valueOf() {
    return this.bytes.readUInt32BE(0);
  }
}
uint32$1.UInt32 = UInt32;
UInt32.width = 32 / 8;
UInt32.defaultUInt32 = new UInt32(buffer_1$7.Buffer.alloc(UInt32.width));
var uint64$1 = {};
Object.defineProperty(uint64$1, "__esModule", { value: !0 });
uint64$1.UInt64 = void 0;
const uint_1$1 = uint, bigInt$2 = BigIntegerExports, big_integer_1 = BigIntegerExports, buffer_1$6 = dist$u, HEX_REGEX = /^[a-fA-F0-9]{1,16}$/, mask = bigInt$2(4294967295);
class UInt64 extends uint_1$1.UInt {
  constructor(c) {
    super(c ?? UInt64.defaultUInt64.bytes);
  }
  static fromParser(c) {
    return new UInt64(c.read(UInt64.width));
  }
  /**
   * Construct a UInt64 object
   *
   * @param val A UInt64, hex-string, bigInt, or number
   * @returns A UInt64 object
   */
  static from(c) {
    if (c instanceof UInt64)
      return c;
    let u = buffer_1$6.Buffer.alloc(UInt64.width);
    if (typeof c == "number") {
      if (c < 0)
        throw new Error("value must be an unsigned integer");
      const p = bigInt$2(c), a = [buffer_1$6.Buffer.alloc(4), buffer_1$6.Buffer.alloc(4)];
      return a[0].writeUInt32BE(Number(p.shiftRight(32)), 0), a[1].writeUInt32BE(Number(p.and(mask)), 0), new UInt64(buffer_1$6.Buffer.concat(a));
    }
    if (typeof c == "string") {
      if (!HEX_REGEX.test(c))
        throw new Error(`${c} is not a valid hex-string`);
      const p = c.padStart(16, "0");
      return u = buffer_1$6.Buffer.from(p, "hex"), new UInt64(u);
    }
    if ((0, big_integer_1.isInstance)(c)) {
      const p = [buffer_1$6.Buffer.alloc(4), buffer_1$6.Buffer.alloc(4)];
      return p[0].writeUInt32BE(Number(c.shiftRight(bigInt$2(32))), 0), p[1].writeUInt32BE(Number(c.and(mask)), 0), new UInt64(buffer_1$6.Buffer.concat(p));
    }
    throw new Error("Cannot construct UInt64 from given value");
  }
  /**
   * The JSON representation of a UInt64 object
   *
   * @returns a hex-string
   */
  toJSON() {
    return this.bytes.toString("hex").toUpperCase();
  }
  /**
   * Get the value of the UInt64
   *
   * @returns the number represented buy this.bytes
   */
  valueOf() {
    const c = bigInt$2(this.bytes.slice(0, 4).readUInt32BE(0)), u = bigInt$2(this.bytes.slice(4).readUInt32BE(0));
    return c.shiftLeft(bigInt$2(32)).or(u);
  }
  /**
   * Get the bytes representation of the UInt64 object
   *
   * @returns 8 bytes representing the UInt64
   */
  toBytes() {
    return this.bytes;
  }
}
uint64$1.UInt64 = UInt64;
UInt64.width = 64 / 8;
UInt64.defaultUInt64 = new UInt64(buffer_1$6.Buffer.alloc(UInt64.width));
var uint8 = {};
Object.defineProperty(uint8, "__esModule", { value: !0 });
uint8.UInt8 = void 0;
const uint_1 = uint, buffer_1$5 = dist$u;
class UInt8 extends uint_1.UInt {
  constructor(c) {
    super(c ?? UInt8.defaultUInt8.bytes);
  }
  static fromParser(c) {
    return new UInt8(c.read(UInt8.width));
  }
  /**
   * Construct a UInt8 object from a number
   *
   * @param val UInt8 object or number
   */
  static from(c) {
    if (c instanceof UInt8)
      return c;
    if (typeof c == "number") {
      const u = buffer_1$5.Buffer.alloc(UInt8.width);
      return u.writeUInt8(c, 0), new UInt8(u);
    }
    throw new Error("Cannot construct UInt8 from given value");
  }
  /**
   * get the value of a UInt8 object
   *
   * @returns the number represented by this.bytes
   */
  valueOf() {
    return this.bytes.readUInt8(0);
  }
}
uint8.UInt8 = UInt8;
UInt8.width = 8 / 8;
UInt8.defaultUInt8 = new UInt8(buffer_1$5.Buffer.alloc(UInt8.width));
var vector256 = {};
Object.defineProperty(vector256, "__esModule", { value: !0 });
vector256.Vector256 = void 0;
const serialized_type_1$1 = serializedType, hash_256_1$2 = hash256$4, binary_serializer_1$1 = binarySerializer;
function isStrings(n) {
  return Array.isArray(n) && (n.length === 0 || typeof n[0] == "string");
}
class Vector256 extends serialized_type_1$1.SerializedType {
  constructor(c) {
    super(c);
  }
  /**
   * Construct a Vector256 from a BinaryParser
   *
   * @param parser BinaryParser to
   * @param hint length of the vector, in bytes, optional
   * @returns a Vector256 object
   */
  static fromParser(c, u) {
    const p = new binary_serializer_1$1.BytesList(), A = (u ?? c.size()) / 32;
    for (let b = 0; b < A; b++)
      hash_256_1$2.Hash256.fromParser(c).toBytesSink(p);
    return new Vector256(p.toBytes());
  }
  /**
   * Construct a Vector256 object from an array of hashes
   *
   * @param value A Vector256 object or array of hex-strings representing Hash256's
   * @returns a Vector256 object
   */
  static from(c) {
    if (c instanceof Vector256)
      return c;
    if (isStrings(c)) {
      const u = new binary_serializer_1$1.BytesList();
      return c.forEach((p) => {
        hash_256_1$2.Hash256.from(p).toBytesSink(u);
      }), new Vector256(u.toBytes());
    }
    throw new Error("Cannot construct Vector256 from given value");
  }
  /**
   * Return an Array of hex-strings represented by this.bytes
   *
   * @returns An Array of strings representing the Hash256 objects
   */
  toJSON() {
    if (this.bytes.byteLength % 32 !== 0)
      throw new Error("Invalid bytes for Vector256");
    const c = [];
    for (let u = 0; u < this.bytes.byteLength; u += 32)
      c.push(this.bytes.slice(u, u + 32).toString("hex").toUpperCase());
    return c;
  }
}
vector256.Vector256 = Vector256;
var xchainBridge = {};
Object.defineProperty(xchainBridge, "__esModule", { value: !0 });
xchainBridge.XChainBridge = void 0;
const binary_parser_1$1 = binaryParser, account_id_1 = accountId, serialized_type_1 = serializedType, buffer_1$4 = dist$u, issue_1 = issue;
function isXChainBridgeObject(n) {
  const c = Object.keys(n).sort();
  return c.length === 4 && c[0] === "IssuingChainDoor" && c[1] === "IssuingChainIssue" && c[2] === "LockingChainDoor" && c[3] === "LockingChainIssue";
}
class XChainBridge extends serialized_type_1.SerializedType {
  constructor(c) {
    super(c ?? XChainBridge.ZERO_XCHAIN_BRIDGE.bytes);
  }
  /**
   * Construct a cross-chain bridge from a JSON
   *
   * @param value XChainBridge or JSON to parse into an XChainBridge
   * @returns An XChainBridge object
   */
  static from(c) {
    if (c instanceof XChainBridge)
      return c;
    if (!isXChainBridgeObject(c))
      throw new Error("Invalid type to construct an XChainBridge");
    const u = [];
    return this.TYPE_ORDER.forEach((p) => {
      const { name: a, type: A } = p;
      A === account_id_1.AccountID && u.push(buffer_1$4.Buffer.from([20]));
      const b = A.from(c[a]);
      u.push(b.toBytes());
    }), new XChainBridge(buffer_1$4.Buffer.concat(u));
  }
  /**
   * Read an XChainBridge from a BinaryParser
   *
   * @param parser BinaryParser to read the XChainBridge from
   * @returns An XChainBridge object
   */
  static fromParser(c) {
    const u = [];
    return this.TYPE_ORDER.forEach((p) => {
      const { type: a } = p;
      a === account_id_1.AccountID && (c.skip(1), u.push(buffer_1$4.Buffer.from([20])));
      const A = a.fromParser(c);
      u.push(A.toBytes());
    }), new XChainBridge(buffer_1$4.Buffer.concat(u));
  }
  /**
   * Get the JSON representation of this XChainBridge
   *
   * @returns the JSON interpretation of this.bytes
   */
  toJSON() {
    const c = new binary_parser_1$1.BinaryParser(this.toString()), u = {};
    return XChainBridge.TYPE_ORDER.forEach((p) => {
      const { name: a, type: A } = p;
      A === account_id_1.AccountID && c.skip(1);
      const b = A.fromParser(c).toJSON();
      u[a] = b;
    }), u;
  }
}
xchainBridge.XChainBridge = XChainBridge;
XChainBridge.ZERO_XCHAIN_BRIDGE = new XChainBridge(buffer_1$4.Buffer.concat([
  buffer_1$4.Buffer.from([20]),
  buffer_1$4.Buffer.alloc(40),
  buffer_1$4.Buffer.from([20]),
  buffer_1$4.Buffer.alloc(40)
]));
XChainBridge.TYPE_ORDER = [
  { name: "LockingChainDoor", type: account_id_1.AccountID },
  { name: "LockingChainIssue", type: issue_1.Issue },
  { name: "IssuingChainDoor", type: account_id_1.AccountID },
  { name: "IssuingChainIssue", type: issue_1.Issue }
];
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.Vector256 = n.UInt64 = n.UInt32 = n.UInt16 = n.UInt8 = n.STObject = n.STArray = n.PathSet = n.Hash256 = n.Hash160 = n.Hash128 = n.Currency = n.Blob = n.Amount = n.AccountID = n.coreTypes = void 0;
  const c = accountId;
  Object.defineProperty(n, "AccountID", { enumerable: !0, get: function() {
    return c.AccountID;
  } });
  const u = amount;
  Object.defineProperty(n, "Amount", { enumerable: !0, get: function() {
    return u.Amount;
  } });
  const p = blob;
  Object.defineProperty(n, "Blob", { enumerable: !0, get: function() {
    return p.Blob;
  } });
  const a = currency$1;
  Object.defineProperty(n, "Currency", { enumerable: !0, get: function() {
    return a.Currency;
  } });
  const A = hash128;
  Object.defineProperty(n, "Hash128", { enumerable: !0, get: function() {
    return A.Hash128;
  } });
  const b = hash160$4;
  Object.defineProperty(n, "Hash160", { enumerable: !0, get: function() {
    return b.Hash160;
  } });
  const F = hash256$4;
  Object.defineProperty(n, "Hash256", { enumerable: !0, get: function() {
    return F.Hash256;
  } });
  const le = issue, L = pathSet;
  Object.defineProperty(n, "PathSet", { enumerable: !0, get: function() {
    return L.PathSet;
  } });
  const pe = requireStArray();
  Object.defineProperty(n, "STArray", { enumerable: !0, get: function() {
    return pe.STArray;
  } });
  const $ = requireStObject();
  Object.defineProperty(n, "STObject", { enumerable: !0, get: function() {
    return $.STObject;
  } });
  const Ee = uint16;
  Object.defineProperty(n, "UInt16", { enumerable: !0, get: function() {
    return Ee.UInt16;
  } });
  const be = uint32$1;
  Object.defineProperty(n, "UInt32", { enumerable: !0, get: function() {
    return be.UInt32;
  } });
  const He = uint64$1;
  Object.defineProperty(n, "UInt64", { enumerable: !0, get: function() {
    return He.UInt64;
  } });
  const Pe = uint8;
  Object.defineProperty(n, "UInt8", { enumerable: !0, get: function() {
    return Pe.UInt8;
  } });
  const nr = vector256;
  Object.defineProperty(n, "Vector256", { enumerable: !0, get: function() {
    return nr.Vector256;
  } });
  const ir = xchainBridge, or = enums, lr = {
    AccountID: c.AccountID,
    Amount: u.Amount,
    Blob: p.Blob,
    Currency: a.Currency,
    Hash128: A.Hash128,
    Hash160: b.Hash160,
    Hash256: F.Hash256,
    Issue: le.Issue,
    PathSet: L.PathSet,
    STArray: pe.STArray,
    STObject: $.STObject,
    UInt8: Pe.UInt8,
    UInt16: Ee.UInt16,
    UInt32: be.UInt32,
    UInt64: He.UInt64,
    Vector256: nr.Vector256,
    XChainBridge: ir.XChainBridge
  };
  n.coreTypes = lr, or.DEFAULT_DEFINITIONS.associateTypes(lr);
})(types$3);
var binary = {}, hashPrefixes = {};
Object.defineProperty(hashPrefixes, "__esModule", { value: !0 });
hashPrefixes.HashPrefix = void 0;
const buffer_1$3 = dist$u;
function bytes$6(n) {
  const c = buffer_1$3.Buffer.alloc(4);
  return c.writeUInt32BE(n, 0), c;
}
const HashPrefix = {
  transactionID: bytes$6(1415073280),
  // transaction plus metadata
  transaction: bytes$6(1397638144),
  // account state
  accountStateEntry: bytes$6(1296846336),
  // inner node in tree
  innerNode: bytes$6(1296649728),
  // ledger master data for signing
  ledgerHeader: bytes$6(1280791040),
  // inner transaction to sign
  transactionSig: bytes$6(1398036480),
  // inner transaction to sign
  transactionMultiSig: bytes$6(1397576704),
  // validation for signing
  validation: bytes$6(1447119872),
  // proposal for signing
  proposal: bytes$6(1347571712),
  // payment channel claim
  paymentChannelClaim: bytes$6(1129073920)
};
hashPrefixes.HashPrefix = HashPrefix;
var hashes = {};
Object.defineProperty(hashes, "__esModule", { value: !0 });
hashes.transactionID = hashes.sha512Half = hashes.Sha512Half = void 0;
const hash_prefixes_1$2 = hashPrefixes, createHash$1 = browser$a, hash_256_1$1 = hash256$4, binary_serializer_1 = binarySerializer, buffer_1$2 = dist$u;
class Sha512Half extends binary_serializer_1.BytesList {
  constructor() {
    super(...arguments), this.hash = createHash$1("sha512");
  }
  /**
   * Construct a new Sha512Hash and write bytes this.hash
   *
   * @param bytes bytes to write to this.hash
   * @returns the new Sha512Hash object
   */
  static put(c) {
    return new Sha512Half().put(c);
  }
  /**
   * Write bytes to an existing Sha512Hash
   *
   * @param bytes bytes to write to object
   * @returns the Sha512 object
   */
  put(c) {
    return this.hash.update(c), this;
  }
  /**
   * Compute SHA512 hash and slice in half
   *
   * @returns half of a SHA512 hash
   */
  finish256() {
    return buffer_1$2.Buffer.from(this.hash.digest().slice(0, 32));
  }
  /**
   * Constructs a Hash256 from the Sha512Half object
   *
   * @returns a Hash256 object
   */
  finish() {
    return new hash_256_1$1.Hash256(this.finish256());
  }
}
hashes.Sha512Half = Sha512Half;
function sha512Half(...n) {
  const c = new Sha512Half();
  return n.forEach((u) => c.put(u)), c.finish256();
}
hashes.sha512Half = sha512Half;
function transactionID(n) {
  return new hash_256_1$1.Hash256(sha512Half(hash_prefixes_1$2.HashPrefix.transactionID, n));
}
hashes.transactionID = transactionID;
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.transactionID = n.sha512Half = n.binaryToJSON = n.signingClaimData = n.signingData = n.multiSigningData = n.readJSON = n.serializeObject = n.makeParser = n.BytesList = n.BinarySerializer = n.BinaryParser = void 0;
  const c = types$3, u = binaryParser;
  Object.defineProperty(n, "BinaryParser", { enumerable: !0, get: function() {
    return u.BinaryParser;
  } });
  const p = hashPrefixes, a = binarySerializer;
  Object.defineProperty(n, "BinarySerializer", { enumerable: !0, get: function() {
    return a.BinarySerializer;
  } }), Object.defineProperty(n, "BytesList", { enumerable: !0, get: function() {
    return a.BytesList;
  } });
  const A = hashes;
  Object.defineProperty(n, "sha512Half", { enumerable: !0, get: function() {
    return A.sha512Half;
  } }), Object.defineProperty(n, "transactionID", { enumerable: !0, get: function() {
    return A.transactionID;
  } });
  const b = enums, F = BigIntegerExports, le = (Pe, nr) => new u.BinaryParser(Pe, nr);
  n.makeParser = le;
  const L = (Pe, nr = b.DEFAULT_DEFINITIONS) => Pe.readType(c.coreTypes.STObject).toJSON(nr);
  n.readJSON = L;
  const pe = (Pe, nr) => L(le(Pe, nr), nr);
  n.binaryToJSON = pe;
  function $(Pe, nr = {}) {
    const { prefix: ir, suffix: or, signingFieldsOnly: lr = !1, definitions: Ir } = nr, xr = new a.BytesList();
    ir && xr.put(ir);
    const kr = lr ? (Ce) => Ce.isSigningField : void 0;
    return c.coreTypes.STObject.from(Pe, kr, Ir).toBytesSink(xr), or && xr.put(or), xr.toBytes();
  }
  n.serializeObject = $;
  function Ee(Pe, nr = p.HashPrefix.transactionSig, ir = {}) {
    return $(Pe, {
      prefix: nr,
      signingFieldsOnly: !0,
      definitions: ir.definitions
    });
  }
  n.signingData = Ee;
  function be(Pe) {
    const nr = F(String(Pe.amount)), ir = p.HashPrefix.paymentChannelClaim, or = c.coreTypes.Hash256.from(Pe.channel).toBytes(), lr = c.coreTypes.UInt64.from(nr).toBytes(), Ir = new a.BytesList();
    return Ir.put(ir), Ir.put(or), Ir.put(lr), Ir.toBytes();
  }
  n.signingClaimData = be;
  function He(Pe, nr, ir = {
    definitions: b.DEFAULT_DEFINITIONS
  }) {
    const or = p.HashPrefix.transactionMultiSig, lr = c.coreTypes.AccountID.from(nr).toBytes();
    return $(Pe, {
      prefix: or,
      suffix: lr,
      signingFieldsOnly: !0,
      definitions: ir.definitions
    });
  }
  n.multiSigningData = He;
})(binary);
var shamap = {};
Object.defineProperty(shamap, "__esModule", { value: !0 });
shamap.ShaMapLeaf = shamap.ShaMapNode = shamap.ShaMap = void 0;
const assert_1 = requireAssert(), types_1$3 = types$3, hash_prefixes_1$1 = hashPrefixes, hashes_1$1 = hashes, buffer_1$1 = dist$u;
class ShaMapNode {
}
shamap.ShaMapNode = ShaMapNode;
class ShaMapLeaf extends ShaMapNode {
  constructor(c, u) {
    super(), this.index = c, this.item = u;
  }
  /**
   * @returns true as ShaMapLeaf is a leaf node
   */
  isLeaf() {
    return !0;
  }
  /**
   * @returns false as ShaMapLeaf is not an inner node
   */
  isInner() {
    return !1;
  }
  /**
   * Get the prefix of the this.item
   *
   * @returns The hash prefix, unless this.item is undefined, then it returns an empty Buffer
   */
  hashPrefix() {
    return this.item === void 0 ? buffer_1$1.Buffer.alloc(0) : this.item.hashPrefix();
  }
  /**
   * Hash the bytes representation of this
   *
   * @returns hash of this.item concatenated with this.index
   */
  hash() {
    const c = hashes_1$1.Sha512Half.put(this.hashPrefix());
    return this.toBytesSink(c), c.finish();
  }
  /**
   * Write the bytes representation of this to a BytesList
   * @param list BytesList to write bytes to
   */
  toBytesSink(c) {
    this.item !== void 0 && this.item.toBytesSink(c), this.index.toBytesSink(c);
  }
}
shamap.ShaMapLeaf = ShaMapLeaf;
class ShaMapInner extends ShaMapNode {
  constructor(c = 0) {
    super(), this.depth = c, this.slotBits = 0, this.branches = Array(16);
  }
  /**
   * @returns true as ShaMapInner is an inner node
   */
  isInner() {
    return !0;
  }
  /**
   * @returns false as ShaMapInner is not a leaf node
   */
  isLeaf() {
    return !1;
  }
  /**
   * Get the hash prefix for this node
   *
   * @returns hash prefix describing an inner node
   */
  hashPrefix() {
    return hash_prefixes_1$1.HashPrefix.innerNode;
  }
  /**
   * Set a branch of this node to be another node
   *
   * @param slot Slot to add branch to this.branches
   * @param branch Branch to add
   */
  setBranch(c, u) {
    this.slotBits = this.slotBits | 1 << c, this.branches[c] = u;
  }
  /**
   * @returns true if node is empty
   */
  empty() {
    return this.slotBits === 0;
  }
  /**
   * Compute the hash of this node
   *
   * @returns The hash of this node
   */
  hash() {
    if (this.empty())
      return types_1$3.coreTypes.Hash256.ZERO_256;
    const c = hashes_1$1.Sha512Half.put(this.hashPrefix());
    return this.toBytesSink(c), c.finish();
  }
  /**
   * Writes the bytes representation of this node to a BytesList
   *
   * @param list BytesList to write bytes to
   */
  toBytesSink(c) {
    for (let u = 0; u < this.branches.length; u++) {
      const p = this.branches[u];
      (p ? p.hash() : types_1$3.coreTypes.Hash256.ZERO_256).toBytesSink(c);
    }
  }
  /**
   * Add item to the SHAMap
   *
   * @param index Hash of the index of the item being inserted
   * @param item Item to insert in the map
   * @param leaf Leaf node to insert when branch doesn't exist
   */
  addItem(c, u, p) {
    if (assert_1.strict.ok(c !== void 0), c !== void 0) {
      const a = c.nibblet(this.depth), A = this.branches[a];
      if (A === void 0)
        this.setBranch(a, p || new ShaMapLeaf(c, u));
      else if (A instanceof ShaMapLeaf) {
        const b = new ShaMapInner(this.depth + 1);
        b.addItem(A.index, void 0, A), b.addItem(c, u, p), this.setBranch(a, b);
      } else if (A instanceof ShaMapInner)
        A.addItem(c, u, p);
      else
        throw new Error("invalid ShaMap.addItem call");
    }
  }
}
class ShaMap extends ShaMapInner {
}
shamap.ShaMap = ShaMap;
var ledgerHashes = {}, __createBinding$c = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(n, c, u, p) {
  p === void 0 && (p = u);
  var a = Object.getOwnPropertyDescriptor(c, u);
  (!a || ("get" in a ? !c.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
    return c[u];
  } }), Object.defineProperty(n, p, a);
} : function(n, c, u, p) {
  p === void 0 && (p = u), n[p] = c[u];
}), __setModuleDefault$c = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(n, c) {
  Object.defineProperty(n, "default", { enumerable: !0, value: c });
} : function(n, c) {
  n.default = c;
}), __importStar$c = commonjsGlobal && commonjsGlobal.__importStar || function(n) {
  if (n && n.__esModule) return n;
  var c = {};
  if (n != null) for (var u in n) u !== "default" && Object.prototype.hasOwnProperty.call(n, u) && __createBinding$c(c, n, u);
  return __setModuleDefault$c(c, n), c;
};
Object.defineProperty(ledgerHashes, "__esModule", { value: !0 });
ledgerHashes.decodeLedgerData = ledgerHashes.ledgerHash = ledgerHashes.transactionTreeHash = ledgerHashes.accountStateHash = void 0;
const assert$9 = __importStar$c(requireAssert()), shamap_1 = shamap, hash_prefixes_1 = hashPrefixes, hashes_1 = hashes, binary_1 = binary, hash_256_1 = hash256$4, st_object_1 = requireStObject(), uint_64_1 = uint64$1, uint_32_1 = uint32$1, uint_8_1 = uint8, binary_parser_1 = binaryParser, bigInt$1 = BigIntegerExports;
function computeHash(n, c) {
  const u = new shamap_1.ShaMap();
  return c.forEach((p) => u.addItem(...n(p))), u.hash();
}
function transactionItemizer(n) {
  return assert$9.ok(n.hash), [hash_256_1.Hash256.from(n.hash), {
    hashPrefix() {
      return hash_prefixes_1.HashPrefix.transaction;
    },
    toBytesSink(p) {
      const a = new binary_1.BinarySerializer(p);
      a.writeLengthEncoded(st_object_1.STObject.from(n)), a.writeLengthEncoded(st_object_1.STObject.from(n.metaData));
    }
  }, void 0];
}
function entryItemizer(n) {
  const c = hash_256_1.Hash256.from(n.index), u = (0, binary_1.serializeObject)(n);
  return [c, {
    hashPrefix() {
      return hash_prefixes_1.HashPrefix.accountStateEntry;
    },
    toBytesSink(a) {
      a.put(u);
    }
  }, void 0];
}
function transactionTreeHash(n) {
  return computeHash(transactionItemizer, n);
}
ledgerHashes.transactionTreeHash = transactionTreeHash;
function accountStateHash(n) {
  return computeHash(entryItemizer, n);
}
ledgerHashes.accountStateHash = accountStateHash;
function ledgerHash(n) {
  const c = new hashes_1.Sha512Half();
  return c.put(hash_prefixes_1.HashPrefix.ledgerHeader), assert$9.ok(n.parent_close_time !== void 0), assert$9.ok(n.close_flags !== void 0), uint_32_1.UInt32.from(n.ledger_index).toBytesSink(c), uint_64_1.UInt64.from(bigInt$1(String(n.total_coins))).toBytesSink(c), hash_256_1.Hash256.from(n.parent_hash).toBytesSink(c), hash_256_1.Hash256.from(n.transaction_hash).toBytesSink(c), hash_256_1.Hash256.from(n.account_hash).toBytesSink(c), uint_32_1.UInt32.from(n.parent_close_time).toBytesSink(c), uint_32_1.UInt32.from(n.close_time).toBytesSink(c), uint_8_1.UInt8.from(n.close_time_resolution).toBytesSink(c), uint_8_1.UInt8.from(n.close_flags).toBytesSink(c), c.finish();
}
ledgerHashes.ledgerHash = ledgerHash;
function decodeLedgerData(n, c) {
  assert$9.ok(typeof n == "string", "binary must be a hex string");
  const u = new binary_parser_1.BinaryParser(n, c);
  return {
    ledger_index: u.readUInt32(),
    total_coins: u.readType(uint_64_1.UInt64).valueOf().toString(),
    parent_hash: u.readType(hash_256_1.Hash256).toHex(),
    transaction_hash: u.readType(hash_256_1.Hash256).toHex(),
    account_hash: u.readType(hash_256_1.Hash256).toHex(),
    parent_close_time: u.readUInt32(),
    close_time: u.readUInt32(),
    close_time_resolution: u.readUInt8(),
    close_flags: u.readUInt8()
  };
}
ledgerHashes.decodeLedgerData = decodeLedgerData;
var quality$1 = {};
Object.defineProperty(quality$1, "__esModule", { value: !0 });
quality$1.quality = void 0;
const types_1$2 = types$3, decimal_js_1 = decimalExports, bigInt = BigIntegerExports, buffer_1 = dist$u;
class quality {
  /**
   * Encode quality amount
   *
   * @param arg string representation of an amount
   * @returns Serialized quality
   */
  static encode(c) {
    const u = new decimal_js_1.Decimal(c), p = u.e - 15, a = u.times(`1e${-p}`).abs().toString(), A = types_1$2.coreTypes.UInt64.from(bigInt(a)).toBytes();
    return A[0] = p + 100, A;
  }
  /**
   * Decode quality amount
   *
   * @param arg hex-string denoting serialized quality
   * @returns deserialized quality
   */
  static decode(c) {
    const u = buffer_1.Buffer.from(c, "hex").slice(-8), p = u[0] - 100;
    return new decimal_js_1.Decimal(`0x${u.slice(1).toString("hex")}`).times(`1e${p}`);
  }
}
quality$1.quality = quality;
(function(n) {
  var c = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(Ee, be, He, Pe) {
    Pe === void 0 && (Pe = He);
    var nr = Object.getOwnPropertyDescriptor(be, He);
    (!nr || ("get" in nr ? !be.__esModule : nr.writable || nr.configurable)) && (nr = { enumerable: !0, get: function() {
      return be[He];
    } }), Object.defineProperty(Ee, Pe, nr);
  } : function(Ee, be, He, Pe) {
    Pe === void 0 && (Pe = He), Ee[Pe] = be[He];
  }), u = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(Ee, be) {
    Object.defineProperty(Ee, "default", { enumerable: !0, value: be });
  } : function(Ee, be) {
    Ee.default = be;
  }), p = commonjsGlobal && commonjsGlobal.__importStar || function(Ee) {
    if (Ee && Ee.__esModule) return Ee;
    var be = {};
    if (Ee != null) for (var He in Ee) He !== "default" && Object.prototype.hasOwnProperty.call(Ee, He) && c(be, Ee, He);
    return u(be, Ee), be;
  };
  Object.defineProperty(n, "__esModule", { value: !0 }), n.types = n.ShaMap = n.HashPrefix = n.quality = n.TransactionResult = n.Type = n.LedgerEntryType = n.TransactionType = n.Field = n.DEFAULT_DEFINITIONS = n.ledgerHashes = n.binary = n.hashes = void 0;
  const a = enums;
  Object.defineProperty(n, "DEFAULT_DEFINITIONS", { enumerable: !0, get: function() {
    return a.DEFAULT_DEFINITIONS;
  } }), Object.defineProperty(n, "Field", { enumerable: !0, get: function() {
    return a.Field;
  } }), Object.defineProperty(n, "TransactionType", { enumerable: !0, get: function() {
    return a.TransactionType;
  } }), Object.defineProperty(n, "LedgerEntryType", { enumerable: !0, get: function() {
    return a.LedgerEntryType;
  } }), Object.defineProperty(n, "Type", { enumerable: !0, get: function() {
    return a.Type;
  } }), Object.defineProperty(n, "TransactionResult", { enumerable: !0, get: function() {
    return a.TransactionResult;
  } });
  const A = p(types$3);
  n.types = A;
  const b = p(binary);
  n.binary = b;
  const F = shamap;
  Object.defineProperty(n, "ShaMap", { enumerable: !0, get: function() {
    return F.ShaMap;
  } });
  const le = p(ledgerHashes);
  n.ledgerHashes = le;
  const L = p(hashes);
  n.hashes = L;
  const pe = quality$1;
  Object.defineProperty(n, "quality", { enumerable: !0, get: function() {
    return pe.quality;
  } });
  const $ = hashPrefixes;
  Object.defineProperty(n, "HashPrefix", { enumerable: !0, get: function() {
    return $.HashPrefix;
  } });
})(coretypes);
var xrplDefinitions = {};
Object.defineProperty(xrplDefinitions, "__esModule", { value: !0 });
xrplDefinitions.XrplDefinitions = void 0;
const xrpl_definitions_base_1 = xrplDefinitionsBase, types_1$1 = types$3;
class XrplDefinitions extends xrpl_definitions_base_1.XrplDefinitionsBase {
  /**
   * Present rippled types in a typed and updatable format.
   * For an example of the input format see `definitions.json`
   * To generate a new definitions file from rippled source code, use this tool: https://github.com/RichardAH/xrpl-codec-gen
   *
   * See the definitions.test.js file for examples of how to create your own updated definitions.json.
   *
   * @param enums - A json encoding of the core types, transaction types, transaction results, transaction names, and fields.
   * @param additionalTypes - A list of SerializedType objects with the same name as the fields defined.
   *              These types will be included in addition to the coreTypes used on mainnet.
   */
  constructor(c, u) {
    const p = Object.assign({}, types_1$1.coreTypes, u);
    super(c, p);
  }
}
xrplDefinitions.XrplDefinitions = XrplDefinitions;
(function(n) {
  var c = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(kr, Ce, tr, Fe) {
    Fe === void 0 && (Fe = tr);
    var Sr = Object.getOwnPropertyDescriptor(Ce, tr);
    (!Sr || ("get" in Sr ? !Ce.__esModule : Sr.writable || Sr.configurable)) && (Sr = { enumerable: !0, get: function() {
      return Ce[tr];
    } }), Object.defineProperty(kr, Fe, Sr);
  } : function(kr, Ce, tr, Fe) {
    Fe === void 0 && (Fe = tr), kr[Fe] = Ce[tr];
  }), u = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(kr, Ce) {
    Object.defineProperty(kr, "default", { enumerable: !0, value: Ce });
  } : function(kr, Ce) {
    kr.default = Ce;
  }), p = commonjsGlobal && commonjsGlobal.__importStar || function(kr) {
    if (kr && kr.__esModule) return kr;
    var Ce = {};
    if (kr != null) for (var tr in kr) tr !== "default" && Object.prototype.hasOwnProperty.call(kr, tr) && c(Ce, kr, tr);
    return u(Ce, kr), Ce;
  };
  Object.defineProperty(n, "__esModule", { value: !0 }), n.coreTypes = n.DEFAULT_DEFINITIONS = n.XrplDefinitionsBase = n.XrplDefinitions = n.TRANSACTION_TYPES = n.decodeLedgerData = n.decodeQuality = n.encodeQuality = n.encodeForMultisigning = n.encodeForSigningClaim = n.encodeForSigning = n.encode = n.decode = void 0;
  const a = p(requireAssert()), A = coretypes, b = ledgerHashes;
  Object.defineProperty(n, "decodeLedgerData", { enumerable: !0, get: function() {
    return b.decodeLedgerData;
  } });
  const F = enums;
  Object.defineProperty(n, "XrplDefinitionsBase", { enumerable: !0, get: function() {
    return F.XrplDefinitionsBase;
  } }), Object.defineProperty(n, "TRANSACTION_TYPES", { enumerable: !0, get: function() {
    return F.TRANSACTION_TYPES;
  } }), Object.defineProperty(n, "DEFAULT_DEFINITIONS", { enumerable: !0, get: function() {
    return F.DEFAULT_DEFINITIONS;
  } });
  const le = xrplDefinitions;
  Object.defineProperty(n, "XrplDefinitions", { enumerable: !0, get: function() {
    return le.XrplDefinitions;
  } });
  const L = types$3;
  Object.defineProperty(n, "coreTypes", { enumerable: !0, get: function() {
    return L.coreTypes;
  } });
  const { signingData: pe, signingClaimData: $, multiSigningData: Ee, binaryToJSON: be, serializeObject: He } = A.binary;
  function Pe(kr, Ce) {
    return a.ok(typeof kr == "string", "binary must be a hex string"), be(kr, Ce);
  }
  n.decode = Pe;
  function nr(kr, Ce) {
    return a.ok(typeof kr == "object"), He(kr, { definitions: Ce }).toString("hex").toUpperCase();
  }
  n.encode = nr;
  function ir(kr, Ce) {
    return a.ok(typeof kr == "object"), pe(kr, A.HashPrefix.transactionSig, {
      definitions: Ce
    }).toString("hex").toUpperCase();
  }
  n.encodeForSigning = ir;
  function or(kr) {
    return a.ok(typeof kr == "object"), $(kr).toString("hex").toUpperCase();
  }
  n.encodeForSigningClaim = or;
  function lr(kr, Ce, tr) {
    return a.ok(typeof kr == "object"), a.equal(kr.SigningPubKey, ""), Ee(kr, Ce, tr ? { definitions: tr } : void 0).toString("hex").toUpperCase();
  }
  n.encodeForMultisigning = lr;
  function Ir(kr) {
    return a.ok(typeof kr == "string"), A.quality.encode(kr).toString("hex").toUpperCase();
  }
  n.encodeQuality = Ir;
  function xr(kr) {
    return a.ok(typeof kr == "string"), A.quality.decode(kr).toString();
  }
  n.decodeQuality = xr;
})(dist$3);
Object.defineProperty(xrp, "__esModule", { value: !0 });
xrp.KeystoneXrpSDK = void 0;
const bc_ur_1 = dist$t, ripple_binary_codec_1 = dist$3;
class KeystoneXrpSDK {
  parseAccount(c) {
    const u = c.decodeCBOR().toString();
    return JSON.parse(u);
  }
  parseSignature(c) {
    if (c.type !== "bytes")
      throw new Error("type not match");
    try {
      const u = c.decodeCBOR().toString("hex");
      return (0, ripple_binary_codec_1.decode)(u).TxnSignature;
    } catch {
      throw new Error("signature is invalid");
    }
  }
  generateSignRequest(c) {
    const u = JSON.stringify(c);
    return bc_ur_1.UR.fromBuffer(Buffer$f.from(u));
  }
}
xrp.KeystoneXrpSDK = KeystoneXrpSDK;
(function(n) {
  var c = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(p, a, A, b) {
    b === void 0 && (b = A);
    var F = Object.getOwnPropertyDescriptor(a, A);
    (!F || ("get" in F ? !a.__esModule : F.writable || F.configurable)) && (F = { enumerable: !0, get: function() {
      return a[A];
    } }), Object.defineProperty(p, b, F);
  } : function(p, a, A, b) {
    b === void 0 && (b = A), p[b] = a[A];
  }), u = commonjsGlobal && commonjsGlobal.__exportStar || function(p, a) {
    for (var A in p) A !== "default" && !Object.prototype.hasOwnProperty.call(a, A) && c(a, p, A);
  };
  Object.defineProperty(n, "__esModule", { value: !0 }), u(xrp, n);
})(xrp$1);
var __awaiter$6 = commonjsGlobal && commonjsGlobal.__awaiter || function(n, c, u, p) {
  function a(A) {
    return A instanceof u ? A : new u(function(b) {
      b(A);
    });
  }
  return new (u || (u = Promise))(function(A, b) {
    function F(pe) {
      try {
        L(p.next(pe));
      } catch ($) {
        b($);
      }
    }
    function le(pe) {
      try {
        L(p.throw(pe));
      } catch ($) {
        b($);
      }
    }
    function L(pe) {
      pe.done ? A(pe.value) : a(pe.value).then(F, le);
    }
    L((p = p.apply(n, c || [])).next());
  });
};
Object.defineProperty(sdk, "__esModule", { value: !0 });
sdk.KeystoneSDK = void 0;
const chains_1 = chains, wallet_1 = wallet$1, xrp_1 = xrp$1, CONFIG_URL = "https://keyst.one/statics/sdk/config.json";
class KeystoneSDK {
  constructor(c) {
    this.parseMultiAccounts = wallet_1.parseMultiAccounts, this.parseTonAccount = wallet_1.parseTonAccount, this.parseHDKey = wallet_1.parseHDKey, this.parseAccount = wallet_1.parseAccount, this.generateKeyDerivationCall = wallet_1.generateKeyDerivationCall, this.config = c;
  }
  static create(c) {
    return __awaiter$6(this, void 0, void 0, function* () {
      try {
        const p = yield (yield fetch(CONFIG_URL)).json();
        return new KeystoneSDK(Object.assign(Object.assign({}, c), p));
      } catch (u) {
        return console.error("fetch config error", u), new KeystoneSDK(c);
      }
    });
  }
  get btc() {
    return this._btc === void 0 && (this._btc = new chains_1.KeystoneBitcoinSDK()), this._btc;
  }
  get eth() {
    return this._eth === void 0 && (this._eth = new chains_1.KeystoneEthereumSDK(this.config)), this._eth;
  }
  get sol() {
    return this._sol === void 0 && (this._sol = new chains_1.KeystoneSolanaSDK()), this._sol;
  }
  get stellar() {
    return this._stellar === void 0 && (this._stellar = new chains_1.KeystoneStellarSDK()), this._stellar;
  }
  get cosmos() {
    return this._cosmos === void 0 && (this._cosmos = new chains_1.KeystoneCosmosSDK(this.config)), this._cosmos;
  }
  get evm() {
    return this._evm === void 0 && (this._evm = new chains_1.KeystoneEvmSDK(this.config)), this._evm;
  }
  get tron() {
    return this._tron === void 0 && (this._tron = new chains_1.KeystoneTronSDK()), this._tron;
  }
  get ltc() {
    return this._ltc === void 0 && (this._ltc = new chains_1.KeystoneLitecoinSDK()), this._ltc;
  }
  get bch() {
    return this._bch === void 0 && (this._bch = new chains_1.KeystoneBitcoinCashSDK()), this._bch;
  }
  get dash() {
    return this._dash === void 0 && (this._dash = new chains_1.KeystoneDashSDK()), this._dash;
  }
  get aptos() {
    return this._aptos === void 0 && (this._aptos = new chains_1.KeystoneAptosSDK()), this._aptos;
  }
  get near() {
    return this._near === void 0 && (this._near = new chains_1.KeystoneNearSDK()), this._near;
  }
  get arweave() {
    return this._arweave === void 0 && (this._arweave = new chains_1.KeystoneArweaveSDK()), this._arweave;
  }
  get sui() {
    return this._sui === void 0 && (this._sui = new chains_1.KeystoneSuiSDK(this.config)), this._sui;
  }
  get cardano() {
    return this._cardano === void 0 && (this._cardano = new chains_1.KeystoneCardanoSDK()), this._cardano;
  }
  get xrp() {
    return this._xrp === void 0 && (this._xrp = new xrp_1.KeystoneXrpSDK()), this._xrp;
  }
  get ton() {
    return this._ton === void 0 && (this._ton = new chains_1.KeystoneTonSDK(this.config)), this._ton;
  }
}
KeystoneSDK.parseMultiAccounts = wallet_1.parseMultiAccounts;
KeystoneSDK.parseHDKey = wallet_1.parseHDKey;
KeystoneSDK.generateKeyDerivationCall = wallet_1.generateKeyDerivationCall;
sdk.KeystoneSDK = KeystoneSDK;
(function(n) {
  var c = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(L, pe, $, Ee) {
    Ee === void 0 && (Ee = $);
    var be = Object.getOwnPropertyDescriptor(pe, $);
    (!be || ("get" in be ? !pe.__esModule : be.writable || be.configurable)) && (be = { enumerable: !0, get: function() {
      return pe[$];
    } }), Object.defineProperty(L, Ee, be);
  } : function(L, pe, $, Ee) {
    Ee === void 0 && (Ee = $), L[Ee] = pe[$];
  }), u = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(L, pe) {
    Object.defineProperty(L, "default", { enumerable: !0, value: pe });
  } : function(L, pe) {
    L.default = pe;
  }), p = commonjsGlobal && commonjsGlobal.__importStar || function(L) {
    if (L && L.__esModule) return L;
    var pe = {};
    if (L != null) for (var $ in L) $ !== "default" && Object.prototype.hasOwnProperty.call(L, $) && c(pe, L, $);
    return u(pe, L), pe;
  }, a = commonjsGlobal && commonjsGlobal.__exportStar || function(L, pe) {
    for (var $ in L) $ !== "default" && !Object.prototype.hasOwnProperty.call(pe, $) && c(pe, L, $);
  };
  Object.defineProperty(n, "__esModule", { value: !0 }), n.utils = n.KeystoneSDK = n.QRHardwareCallVersion = n.DerivationAlgorithm = n.Curve = void 0;
  const A = p(utils$K);
  n.utils = A;
  const b = sdk;
  Object.defineProperty(n, "KeystoneSDK", { enumerable: !0, get: function() {
    return b.KeystoneSDK;
  } }), a(dist$t, n), a(types$4, n), a(chains, n);
  var F = hardwareCall;
  Object.defineProperty(n, "Curve", { enumerable: !0, get: function() {
    return F.Curve;
  } }), Object.defineProperty(n, "DerivationAlgorithm", { enumerable: !0, get: function() {
    return F.DerivationAlgorithm;
  } });
  var le = requireDist$c();
  Object.defineProperty(n, "QRHardwareCallVersion", { enumerable: !0, get: function() {
    return le.QRHardwareCallVersion;
  } }), n.default = b.KeystoneSDK;
})(dist$w);
const q = /* @__PURE__ */ getDefaultExportFromCjs(dist$w);
function number$4(n) {
  if (!Number.isSafeInteger(n) || n < 0)
    throw new Error(`positive integer expected, not ${n}`);
}
function isBytes$9(n) {
  return n instanceof Uint8Array || n != null && typeof n == "object" && n.constructor.name === "Uint8Array";
}
function bytes$5(n, ...c) {
  if (!isBytes$9(n))
    throw new Error("Uint8Array expected");
  if (c.length > 0 && !c.includes(n.length))
    throw new Error(`Uint8Array expected of length ${c}, not of length=${n.length}`);
}
function hash$5(n) {
  if (typeof n != "function" || typeof n.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  number$4(n.outputLen), number$4(n.blockLen);
}
function exists$4(n, c = !0) {
  if (n.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (c && n.finished)
    throw new Error("Hash#digest() has already been called");
}
function output$4(n, c) {
  bytes$5(n);
  const u = c.outputLen;
  if (n.length < u)
    throw new Error(`digestInto() expects output buffer of length at least ${u}`);
}
const createView$6 = (n) => new DataView(n.buffer, n.byteOffset, n.byteLength), rotr$5 = (n, c) => n << 32 - c | n >>> c, rotl$2 = (n, c) => n << c | n >>> 32 - c >>> 0;
new Uint8Array(new Uint32Array([287454020]).buffer)[0];
const hexes$2 = /* @__PURE__ */ Array.from({ length: 256 }, (n, c) => c.toString(16).padStart(2, "0"));
function bytesToHex$4(n) {
  bytes$5(n);
  let c = "";
  for (let u = 0; u < n.length; u++)
    c += hexes$2[n[u]];
  return c;
}
const asciis$1 = { _0: 48, _9: 57, _A: 65, _F: 70, _a: 97, _f: 102 };
function asciiToBase16$1(n) {
  if (n >= asciis$1._0 && n <= asciis$1._9)
    return n - asciis$1._0;
  if (n >= asciis$1._A && n <= asciis$1._F)
    return n - (asciis$1._A - 10);
  if (n >= asciis$1._a && n <= asciis$1._f)
    return n - (asciis$1._a - 10);
}
function hexToBytes$4(n) {
  if (typeof n != "string")
    throw new Error("hex string expected, got " + typeof n);
  const c = n.length, u = c / 2;
  if (c % 2)
    throw new Error("padded hex string expected, got unpadded hex of length " + c);
  const p = new Uint8Array(u);
  for (let a = 0, A = 0; a < u; a++, A += 2) {
    const b = asciiToBase16$1(n.charCodeAt(A)), F = asciiToBase16$1(n.charCodeAt(A + 1));
    if (b === void 0 || F === void 0) {
      const le = n[A] + n[A + 1];
      throw new Error('hex string expected, got non-hex character "' + le + '" at index ' + A);
    }
    p[a] = b * 16 + F;
  }
  return p;
}
function utf8ToBytes$6(n) {
  if (typeof n != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof n}`);
  return new Uint8Array(new TextEncoder().encode(n));
}
function toBytes$7(n) {
  return typeof n == "string" && (n = utf8ToBytes$6(n)), bytes$5(n), n;
}
function concatBytes$5(...n) {
  let c = 0;
  for (let p = 0; p < n.length; p++) {
    const a = n[p];
    bytes$5(a), c += a.length;
  }
  const u = new Uint8Array(c);
  for (let p = 0, a = 0; p < n.length; p++) {
    const A = n[p];
    u.set(A, a), a += A.length;
  }
  return u;
}
let Hash$5 = class {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
};
function wrapConstructor$4(n) {
  const c = (p) => n().update(toBytes$7(p)).digest(), u = n();
  return c.outputLen = u.outputLen, c.blockLen = u.blockLen, c.create = () => n(), c;
}
let HMAC$2 = class extends Hash$5 {
  constructor(c, u) {
    super(), this.finished = !1, this.destroyed = !1, hash$5(c);
    const p = toBytes$7(u);
    if (this.iHash = c.create(), typeof this.iHash.update != "function")
      throw new Error("Expected instance of class which extends utils.Hash");
    this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
    const a = this.blockLen, A = new Uint8Array(a);
    A.set(p.length > a ? c.create().update(p).digest() : p);
    for (let b = 0; b < A.length; b++)
      A[b] ^= 54;
    this.iHash.update(A), this.oHash = c.create();
    for (let b = 0; b < A.length; b++)
      A[b] ^= 106;
    this.oHash.update(A), A.fill(0);
  }
  update(c) {
    return exists$4(this), this.iHash.update(c), this;
  }
  digestInto(c) {
    exists$4(this), bytes$5(c, this.outputLen), this.finished = !0, this.iHash.digestInto(c), this.oHash.update(c), this.oHash.digestInto(c), this.destroy();
  }
  digest() {
    const c = new Uint8Array(this.oHash.outputLen);
    return this.digestInto(c), c;
  }
  _cloneInto(c) {
    c || (c = Object.create(Object.getPrototypeOf(this), {}));
    const { oHash: u, iHash: p, finished: a, destroyed: A, blockLen: b, outputLen: F } = this;
    return c = c, c.finished = a, c.destroyed = A, c.blockLen = b, c.outputLen = F, c.oHash = u._cloneInto(c.oHash), c.iHash = p._cloneInto(c.iHash), c;
  }
  destroy() {
    this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
  }
};
const hmac$3 = (n, c, u) => new HMAC$2(n, c).update(u).digest();
hmac$3.create = (n, c) => new HMAC$2(n, c);
function setBigUint64$5(n, c, u, p) {
  if (typeof n.setBigUint64 == "function")
    return n.setBigUint64(c, u, p);
  const a = BigInt(32), A = BigInt(4294967295), b = Number(u >> a & A), F = Number(u & A), le = p ? 4 : 0, L = p ? 0 : 4;
  n.setUint32(c + le, b, p), n.setUint32(c + L, F, p);
}
const Chi$5 = (n, c, u) => n & c ^ ~n & u, Maj$5 = (n, c, u) => n & c ^ n & u ^ c & u;
let HashMD$1 = class extends Hash$5 {
  constructor(c, u, p, a) {
    super(), this.blockLen = c, this.outputLen = u, this.padOffset = p, this.isLE = a, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(c), this.view = createView$6(this.buffer);
  }
  update(c) {
    exists$4(this);
    const { view: u, buffer: p, blockLen: a } = this;
    c = toBytes$7(c);
    const A = c.length;
    for (let b = 0; b < A; ) {
      const F = Math.min(a - this.pos, A - b);
      if (F === a) {
        const le = createView$6(c);
        for (; a <= A - b; b += a)
          this.process(le, b);
        continue;
      }
      p.set(c.subarray(b, b + F), this.pos), this.pos += F, b += F, this.pos === a && (this.process(u, 0), this.pos = 0);
    }
    return this.length += c.length, this.roundClean(), this;
  }
  digestInto(c) {
    exists$4(this), output$4(c, this), this.finished = !0;
    const { buffer: u, view: p, blockLen: a, isLE: A } = this;
    let { pos: b } = this;
    u[b++] = 128, this.buffer.subarray(b).fill(0), this.padOffset > a - b && (this.process(p, 0), b = 0);
    for (let $ = b; $ < a; $++)
      u[$] = 0;
    setBigUint64$5(p, a - 8, BigInt(this.length * 8), A), this.process(p, 0);
    const F = createView$6(c), le = this.outputLen;
    if (le % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const L = le / 4, pe = this.get();
    if (L > pe.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let $ = 0; $ < L; $++)
      F.setUint32(4 * $, pe[$], A);
  }
  digest() {
    const { buffer: c, outputLen: u } = this;
    this.digestInto(c);
    const p = c.slice(0, u);
    return this.destroy(), p;
  }
  _cloneInto(c) {
    c || (c = new this.constructor()), c.set(...this.get());
    const { blockLen: u, buffer: p, length: a, finished: A, destroyed: b, pos: F } = this;
    return c.length = a, c.pos = F, c.finished = A, c.destroyed = b, a % u && c.buffer.set(p), c;
  }
};
const Rho$1 = /* @__PURE__ */ new Uint8Array([7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8]), Id$1 = /* @__PURE__ */ new Uint8Array(new Array(16).fill(0).map((n, c) => c)), Pi$1 = /* @__PURE__ */ Id$1.map((n) => (9 * n + 5) % 16);
let idxL$2 = [Id$1], idxR$2 = [Pi$1];
for (let n = 0; n < 4; n++)
  for (let c of [idxL$2, idxR$2])
    c.push(c[n].map((u) => Rho$1[u]));
const shifts$1 = /* @__PURE__ */ [
  [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8],
  [12, 13, 11, 15, 6, 9, 9, 7, 12, 15, 11, 13, 7, 8, 7, 7],
  [13, 15, 14, 11, 7, 7, 6, 8, 13, 14, 13, 12, 5, 5, 6, 9],
  [14, 11, 12, 14, 8, 6, 5, 5, 15, 12, 15, 14, 9, 9, 8, 6],
  [15, 12, 13, 13, 9, 5, 8, 6, 14, 11, 12, 11, 8, 6, 5, 5]
].map((n) => new Uint8Array(n)), shiftsL$1 = /* @__PURE__ */ idxL$2.map((n, c) => n.map((u) => shifts$1[c][u])), shiftsR$1 = /* @__PURE__ */ idxR$2.map((n, c) => n.map((u) => shifts$1[c][u])), Kl$1 = /* @__PURE__ */ new Uint32Array([
  0,
  1518500249,
  1859775393,
  2400959708,
  2840853838
]), Kr$1 = /* @__PURE__ */ new Uint32Array([
  1352829926,
  1548603684,
  1836072691,
  2053994217,
  0
]);
function f$1(n, c, u, p) {
  return n === 0 ? c ^ u ^ p : n === 1 ? c & u | ~c & p : n === 2 ? (c | ~u) ^ p : n === 3 ? c & p | u & ~p : c ^ (u | ~p);
}
const R_BUF = /* @__PURE__ */ new Uint32Array(16);
let RIPEMD160$2 = class extends HashMD$1 {
  constructor() {
    super(64, 20, 8, !0), this.h0 = 1732584193, this.h1 = -271733879, this.h2 = -1732584194, this.h3 = 271733878, this.h4 = -1009589776;
  }
  get() {
    const { h0: c, h1: u, h2: p, h3: a, h4: A } = this;
    return [c, u, p, a, A];
  }
  set(c, u, p, a, A) {
    this.h0 = c | 0, this.h1 = u | 0, this.h2 = p | 0, this.h3 = a | 0, this.h4 = A | 0;
  }
  process(c, u) {
    for (let be = 0; be < 16; be++, u += 4)
      R_BUF[be] = c.getUint32(u, !0);
    let p = this.h0 | 0, a = p, A = this.h1 | 0, b = A, F = this.h2 | 0, le = F, L = this.h3 | 0, pe = L, $ = this.h4 | 0, Ee = $;
    for (let be = 0; be < 5; be++) {
      const He = 4 - be, Pe = Kl$1[be], nr = Kr$1[be], ir = idxL$2[be], or = idxR$2[be], lr = shiftsL$1[be], Ir = shiftsR$1[be];
      for (let xr = 0; xr < 16; xr++) {
        const kr = rotl$2(p + f$1(be, A, F, L) + R_BUF[ir[xr]] + Pe, lr[xr]) + $ | 0;
        p = $, $ = L, L = rotl$2(F, 10) | 0, F = A, A = kr;
      }
      for (let xr = 0; xr < 16; xr++) {
        const kr = rotl$2(a + f$1(He, b, le, pe) + R_BUF[or[xr]] + nr, Ir[xr]) + Ee | 0;
        a = Ee, Ee = pe, pe = rotl$2(le, 10) | 0, le = b, b = kr;
      }
    }
    this.set(this.h1 + F + pe | 0, this.h2 + L + Ee | 0, this.h3 + $ + a | 0, this.h4 + p + b | 0, this.h0 + A + le | 0);
  }
  roundClean() {
    R_BUF.fill(0);
  }
  destroy() {
    this.destroyed = !0, this.buffer.fill(0), this.set(0, 0, 0, 0, 0);
  }
};
const ripemd160$3 = /* @__PURE__ */ wrapConstructor$4(() => new RIPEMD160$2()), SHA256_K$5 = /* @__PURE__ */ new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), SHA256_IV$1 = /* @__PURE__ */ new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), SHA256_W$5 = /* @__PURE__ */ new Uint32Array(64);
let SHA256$5 = class extends HashMD$1 {
  constructor() {
    super(64, 32, 8, !1), this.A = SHA256_IV$1[0] | 0, this.B = SHA256_IV$1[1] | 0, this.C = SHA256_IV$1[2] | 0, this.D = SHA256_IV$1[3] | 0, this.E = SHA256_IV$1[4] | 0, this.F = SHA256_IV$1[5] | 0, this.G = SHA256_IV$1[6] | 0, this.H = SHA256_IV$1[7] | 0;
  }
  get() {
    const { A: c, B: u, C: p, D: a, E: A, F: b, G: F, H: le } = this;
    return [c, u, p, a, A, b, F, le];
  }
  // prettier-ignore
  set(c, u, p, a, A, b, F, le) {
    this.A = c | 0, this.B = u | 0, this.C = p | 0, this.D = a | 0, this.E = A | 0, this.F = b | 0, this.G = F | 0, this.H = le | 0;
  }
  process(c, u) {
    for (let $ = 0; $ < 16; $++, u += 4)
      SHA256_W$5[$] = c.getUint32(u, !1);
    for (let $ = 16; $ < 64; $++) {
      const Ee = SHA256_W$5[$ - 15], be = SHA256_W$5[$ - 2], He = rotr$5(Ee, 7) ^ rotr$5(Ee, 18) ^ Ee >>> 3, Pe = rotr$5(be, 17) ^ rotr$5(be, 19) ^ be >>> 10;
      SHA256_W$5[$] = Pe + SHA256_W$5[$ - 7] + He + SHA256_W$5[$ - 16] | 0;
    }
    let { A: p, B: a, C: A, D: b, E: F, F: le, G: L, H: pe } = this;
    for (let $ = 0; $ < 64; $++) {
      const Ee = rotr$5(F, 6) ^ rotr$5(F, 11) ^ rotr$5(F, 25), be = pe + Ee + Chi$5(F, le, L) + SHA256_K$5[$] + SHA256_W$5[$] | 0, Pe = (rotr$5(p, 2) ^ rotr$5(p, 13) ^ rotr$5(p, 22)) + Maj$5(p, a, A) | 0;
      pe = L, L = le, le = F, F = b + be | 0, b = A, A = a, a = p, p = be + Pe | 0;
    }
    p = p + this.A | 0, a = a + this.B | 0, A = A + this.C | 0, b = b + this.D | 0, F = F + this.E | 0, le = le + this.F | 0, L = L + this.G | 0, pe = pe + this.H | 0, this.set(p, a, A, b, F, le, L, pe);
  }
  roundClean() {
    SHA256_W$5.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
};
const sha256$8 = /* @__PURE__ */ wrapConstructor$4(() => new SHA256$5()), U32_MASK64$1 = /* @__PURE__ */ BigInt(2 ** 32 - 1), _32n$1 = /* @__PURE__ */ BigInt(32);
function fromBig$1(n, c = !1) {
  return c ? { h: Number(n & U32_MASK64$1), l: Number(n >> _32n$1 & U32_MASK64$1) } : { h: Number(n >> _32n$1 & U32_MASK64$1) | 0, l: Number(n & U32_MASK64$1) | 0 };
}
function split$1(n, c = !1) {
  let u = new Uint32Array(n.length), p = new Uint32Array(n.length);
  for (let a = 0; a < n.length; a++) {
    const { h: A, l: b } = fromBig$1(n[a], c);
    [u[a], p[a]] = [A, b];
  }
  return [u, p];
}
const toBig$1 = (n, c) => BigInt(n >>> 0) << _32n$1 | BigInt(c >>> 0), shrSH$1 = (n, c, u) => n >>> u, shrSL$1 = (n, c, u) => n << 32 - u | c >>> u, rotrSH$1 = (n, c, u) => n >>> u | c << 32 - u, rotrSL$1 = (n, c, u) => n << 32 - u | c >>> u, rotrBH$1 = (n, c, u) => n << 64 - u | c >>> u - 32, rotrBL$1 = (n, c, u) => n >>> u - 32 | c << 64 - u, rotr32H$1 = (n, c) => c, rotr32L$1 = (n, c) => n, rotlSH$1 = (n, c, u) => n << u | c >>> 32 - u, rotlSL$1 = (n, c, u) => c << u | n >>> 32 - u, rotlBH$1 = (n, c, u) => c << u - 32 | n >>> 64 - u, rotlBL$1 = (n, c, u) => n << u - 32 | c >>> 64 - u;
function add$1(n, c, u, p) {
  const a = (c >>> 0) + (p >>> 0);
  return { h: n + u + (a / 2 ** 32 | 0) | 0, l: a | 0 };
}
const add3L$1 = (n, c, u) => (n >>> 0) + (c >>> 0) + (u >>> 0), add3H$1 = (n, c, u, p) => c + u + p + (n / 2 ** 32 | 0) | 0, add4L$1 = (n, c, u, p) => (n >>> 0) + (c >>> 0) + (u >>> 0) + (p >>> 0), add4H$1 = (n, c, u, p, a) => c + u + p + a + (n / 2 ** 32 | 0) | 0, add5L$1 = (n, c, u, p, a) => (n >>> 0) + (c >>> 0) + (u >>> 0) + (p >>> 0) + (a >>> 0), add5H$1 = (n, c, u, p, a, A) => c + u + p + a + A + (n / 2 ** 32 | 0) | 0, u64$2 = {
  fromBig: fromBig$1,
  split: split$1,
  toBig: toBig$1,
  shrSH: shrSH$1,
  shrSL: shrSL$1,
  rotrSH: rotrSH$1,
  rotrSL: rotrSL$1,
  rotrBH: rotrBH$1,
  rotrBL: rotrBL$1,
  rotr32H: rotr32H$1,
  rotr32L: rotr32L$1,
  rotlSH: rotlSH$1,
  rotlSL: rotlSL$1,
  rotlBH: rotlBH$1,
  rotlBL: rotlBL$1,
  add: add$1,
  add3L: add3L$1,
  add3H: add3H$1,
  add4L: add4L$1,
  add4H: add4H$1,
  add5H: add5H$1,
  add5L: add5L$1
}, [SHA512_Kh$1, SHA512_Kl$1] = u64$2.split([
  "0x428a2f98d728ae22",
  "0x7137449123ef65cd",
  "0xb5c0fbcfec4d3b2f",
  "0xe9b5dba58189dbbc",
  "0x3956c25bf348b538",
  "0x59f111f1b605d019",
  "0x923f82a4af194f9b",
  "0xab1c5ed5da6d8118",
  "0xd807aa98a3030242",
  "0x12835b0145706fbe",
  "0x243185be4ee4b28c",
  "0x550c7dc3d5ffb4e2",
  "0x72be5d74f27b896f",
  "0x80deb1fe3b1696b1",
  "0x9bdc06a725c71235",
  "0xc19bf174cf692694",
  "0xe49b69c19ef14ad2",
  "0xefbe4786384f25e3",
  "0x0fc19dc68b8cd5b5",
  "0x240ca1cc77ac9c65",
  "0x2de92c6f592b0275",
  "0x4a7484aa6ea6e483",
  "0x5cb0a9dcbd41fbd4",
  "0x76f988da831153b5",
  "0x983e5152ee66dfab",
  "0xa831c66d2db43210",
  "0xb00327c898fb213f",
  "0xbf597fc7beef0ee4",
  "0xc6e00bf33da88fc2",
  "0xd5a79147930aa725",
  "0x06ca6351e003826f",
  "0x142929670a0e6e70",
  "0x27b70a8546d22ffc",
  "0x2e1b21385c26c926",
  "0x4d2c6dfc5ac42aed",
  "0x53380d139d95b3df",
  "0x650a73548baf63de",
  "0x766a0abb3c77b2a8",
  "0x81c2c92e47edaee6",
  "0x92722c851482353b",
  "0xa2bfe8a14cf10364",
  "0xa81a664bbc423001",
  "0xc24b8b70d0f89791",
  "0xc76c51a30654be30",
  "0xd192e819d6ef5218",
  "0xd69906245565a910",
  "0xf40e35855771202a",
  "0x106aa07032bbd1b8",
  "0x19a4c116b8d2d0c8",
  "0x1e376c085141ab53",
  "0x2748774cdf8eeb99",
  "0x34b0bcb5e19b48a8",
  "0x391c0cb3c5c95a63",
  "0x4ed8aa4ae3418acb",
  "0x5b9cca4f7763e373",
  "0x682e6ff3d6b2b8a3",
  "0x748f82ee5defb2fc",
  "0x78a5636f43172f60",
  "0x84c87814a1f0ab72",
  "0x8cc702081a6439ec",
  "0x90befffa23631e28",
  "0xa4506cebde82bde9",
  "0xbef9a3f7b2c67915",
  "0xc67178f2e372532b",
  "0xca273eceea26619c",
  "0xd186b8c721c0c207",
  "0xeada7dd6cde0eb1e",
  "0xf57d4f7fee6ed178",
  "0x06f067aa72176fba",
  "0x0a637dc5a2c898a6",
  "0x113f9804bef90dae",
  "0x1b710b35131c471b",
  "0x28db77f523047d84",
  "0x32caab7b40c72493",
  "0x3c9ebe0a15c9bebc",
  "0x431d67c49c100d4c",
  "0x4cc5d4becb3e42b6",
  "0x597f299cfc657e2a",
  "0x5fcb6fab3ad6faec",
  "0x6c44198c4a475817"
].map((n) => BigInt(n))), SHA512_W_H$1 = /* @__PURE__ */ new Uint32Array(80), SHA512_W_L$1 = /* @__PURE__ */ new Uint32Array(80);
let SHA512$1 = class extends HashMD$1 {
  constructor() {
    super(128, 64, 16, !1), this.Ah = 1779033703, this.Al = -205731576, this.Bh = -1150833019, this.Bl = -2067093701, this.Ch = 1013904242, this.Cl = -23791573, this.Dh = -1521486534, this.Dl = 1595750129, this.Eh = 1359893119, this.El = -1377402159, this.Fh = -1694144372, this.Fl = 725511199, this.Gh = 528734635, this.Gl = -79577749, this.Hh = 1541459225, this.Hl = 327033209;
  }
  // prettier-ignore
  get() {
    const { Ah: c, Al: u, Bh: p, Bl: a, Ch: A, Cl: b, Dh: F, Dl: le, Eh: L, El: pe, Fh: $, Fl: Ee, Gh: be, Gl: He, Hh: Pe, Hl: nr } = this;
    return [c, u, p, a, A, b, F, le, L, pe, $, Ee, be, He, Pe, nr];
  }
  // prettier-ignore
  set(c, u, p, a, A, b, F, le, L, pe, $, Ee, be, He, Pe, nr) {
    this.Ah = c | 0, this.Al = u | 0, this.Bh = p | 0, this.Bl = a | 0, this.Ch = A | 0, this.Cl = b | 0, this.Dh = F | 0, this.Dl = le | 0, this.Eh = L | 0, this.El = pe | 0, this.Fh = $ | 0, this.Fl = Ee | 0, this.Gh = be | 0, this.Gl = He | 0, this.Hh = Pe | 0, this.Hl = nr | 0;
  }
  process(c, u) {
    for (let lr = 0; lr < 16; lr++, u += 4)
      SHA512_W_H$1[lr] = c.getUint32(u), SHA512_W_L$1[lr] = c.getUint32(u += 4);
    for (let lr = 16; lr < 80; lr++) {
      const Ir = SHA512_W_H$1[lr - 15] | 0, xr = SHA512_W_L$1[lr - 15] | 0, kr = u64$2.rotrSH(Ir, xr, 1) ^ u64$2.rotrSH(Ir, xr, 8) ^ u64$2.shrSH(Ir, xr, 7), Ce = u64$2.rotrSL(Ir, xr, 1) ^ u64$2.rotrSL(Ir, xr, 8) ^ u64$2.shrSL(Ir, xr, 7), tr = SHA512_W_H$1[lr - 2] | 0, Fe = SHA512_W_L$1[lr - 2] | 0, Sr = u64$2.rotrSH(tr, Fe, 19) ^ u64$2.rotrBH(tr, Fe, 61) ^ u64$2.shrSH(tr, Fe, 6), er = u64$2.rotrSL(tr, Fe, 19) ^ u64$2.rotrBL(tr, Fe, 61) ^ u64$2.shrSL(tr, Fe, 6), Ie = u64$2.add4L(Ce, er, SHA512_W_L$1[lr - 7], SHA512_W_L$1[lr - 16]), xe = u64$2.add4H(Ie, kr, Sr, SHA512_W_H$1[lr - 7], SHA512_W_H$1[lr - 16]);
      SHA512_W_H$1[lr] = xe | 0, SHA512_W_L$1[lr] = Ie | 0;
    }
    let { Ah: p, Al: a, Bh: A, Bl: b, Ch: F, Cl: le, Dh: L, Dl: pe, Eh: $, El: Ee, Fh: be, Fl: He, Gh: Pe, Gl: nr, Hh: ir, Hl: or } = this;
    for (let lr = 0; lr < 80; lr++) {
      const Ir = u64$2.rotrSH($, Ee, 14) ^ u64$2.rotrSH($, Ee, 18) ^ u64$2.rotrBH($, Ee, 41), xr = u64$2.rotrSL($, Ee, 14) ^ u64$2.rotrSL($, Ee, 18) ^ u64$2.rotrBL($, Ee, 41), kr = $ & be ^ ~$ & Pe, Ce = Ee & He ^ ~Ee & nr, tr = u64$2.add5L(or, xr, Ce, SHA512_Kl$1[lr], SHA512_W_L$1[lr]), Fe = u64$2.add5H(tr, ir, Ir, kr, SHA512_Kh$1[lr], SHA512_W_H$1[lr]), Sr = tr | 0, er = u64$2.rotrSH(p, a, 28) ^ u64$2.rotrBH(p, a, 34) ^ u64$2.rotrBH(p, a, 39), Ie = u64$2.rotrSL(p, a, 28) ^ u64$2.rotrBL(p, a, 34) ^ u64$2.rotrBL(p, a, 39), xe = p & A ^ p & F ^ A & F, rr = a & b ^ a & le ^ b & le;
      ir = Pe | 0, or = nr | 0, Pe = be | 0, nr = He | 0, be = $ | 0, He = Ee | 0, { h: $, l: Ee } = u64$2.add(L | 0, pe | 0, Fe | 0, Sr | 0), L = F | 0, pe = le | 0, F = A | 0, le = b | 0, A = p | 0, b = a | 0;
      const ar = u64$2.add3L(Sr, Ie, rr);
      p = u64$2.add3H(ar, Fe, er, xe), a = ar | 0;
    }
    ({ h: p, l: a } = u64$2.add(this.Ah | 0, this.Al | 0, p | 0, a | 0)), { h: A, l: b } = u64$2.add(this.Bh | 0, this.Bl | 0, A | 0, b | 0), { h: F, l: le } = u64$2.add(this.Ch | 0, this.Cl | 0, F | 0, le | 0), { h: L, l: pe } = u64$2.add(this.Dh | 0, this.Dl | 0, L | 0, pe | 0), { h: $, l: Ee } = u64$2.add(this.Eh | 0, this.El | 0, $ | 0, Ee | 0), { h: be, l: He } = u64$2.add(this.Fh | 0, this.Fl | 0, be | 0, He | 0), { h: Pe, l: nr } = u64$2.add(this.Gh | 0, this.Gl | 0, Pe | 0, nr | 0), { h: ir, l: or } = u64$2.add(this.Hh | 0, this.Hl | 0, ir | 0, or | 0), this.set(p, a, A, b, F, le, L, pe, $, Ee, be, He, Pe, nr, ir, or);
  }
  roundClean() {
    SHA512_W_H$1.fill(0), SHA512_W_L$1.fill(0);
  }
  destroy() {
    this.buffer.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
  }
};
const sha512$3 = /* @__PURE__ */ wrapConstructor$4(() => new SHA512$1());
// @__NO_SIDE_EFFECTS__
function assertNumber(n) {
  if (!Number.isSafeInteger(n))
    throw new Error(`Wrong integer: ${n}`);
}
function isBytes$8(n) {
  return n instanceof Uint8Array || n != null && typeof n == "object" && n.constructor.name === "Uint8Array";
}
// @__NO_SIDE_EFFECTS__
function chain$2(...n) {
  const c = (A) => A, u = (A, b) => (F) => A(b(F)), p = n.map((A) => A.encode).reduceRight(u, c), a = n.map((A) => A.decode).reduce(u, c);
  return { encode: p, decode: a };
}
// @__NO_SIDE_EFFECTS__
function alphabet$2(n) {
  return {
    encode: (c) => {
      if (!Array.isArray(c) || c.length && typeof c[0] != "number")
        throw new Error("alphabet.encode input should be an array of numbers");
      return c.map((u) => {
        if (u < 0 || u >= n.length)
          throw new Error(`Digit index outside alphabet: ${u} (alphabet: ${n.length})`);
        return n[u];
      });
    },
    decode: (c) => {
      if (!Array.isArray(c) || c.length && typeof c[0] != "string")
        throw new Error("alphabet.decode input should be array of strings");
      return c.map((u) => {
        if (typeof u != "string")
          throw new Error(`alphabet.decode: not string element=${u}`);
        const p = n.indexOf(u);
        if (p === -1)
          throw new Error(`Unknown letter: "${u}". Allowed: ${n}`);
        return p;
      });
    }
  };
}
// @__NO_SIDE_EFFECTS__
function join$2(n = "") {
  if (typeof n != "string")
    throw new Error("join separator should be string");
  return {
    encode: (c) => {
      if (!Array.isArray(c) || c.length && typeof c[0] != "string")
        throw new Error("join.encode input should be array of strings");
      for (let u of c)
        if (typeof u != "string")
          throw new Error(`join.encode: non-string input=${u}`);
      return c.join(n);
    },
    decode: (c) => {
      if (typeof c != "string")
        throw new Error("join.decode input should be string");
      return c.split(n);
    }
  };
}
// @__NO_SIDE_EFFECTS__
function padding(n, c = "=") {
  if (typeof c != "string")
    throw new Error("padding chr should be string");
  return {
    encode(u) {
      if (!Array.isArray(u) || u.length && typeof u[0] != "string")
        throw new Error("padding.encode input should be array of strings");
      for (let p of u)
        if (typeof p != "string")
          throw new Error(`padding.encode: non-string input=${p}`);
      for (; u.length * n % 8; )
        u.push(c);
      return u;
    },
    decode(u) {
      if (!Array.isArray(u) || u.length && typeof u[0] != "string")
        throw new Error("padding.encode input should be array of strings");
      for (let a of u)
        if (typeof a != "string")
          throw new Error(`padding.decode: non-string input=${a}`);
      let p = u.length;
      if (p * n % 8)
        throw new Error("Invalid padding: string should have whole number of bytes");
      for (; p > 0 && u[p - 1] === c; p--)
        if (!((p - 1) * n % 8))
          throw new Error("Invalid padding: string has too much padding");
      return u.slice(0, p);
    }
  };
}
// @__NO_SIDE_EFFECTS__
function normalize$3(n) {
  if (typeof n != "function")
    throw new Error("normalize fn should be function");
  return { encode: (c) => c, decode: (c) => n(c) };
}
// @__NO_SIDE_EFFECTS__
function convertRadix$1(n, c, u) {
  if (c < 2)
    throw new Error(`convertRadix: wrong from=${c}, base cannot be less than 2`);
  if (u < 2)
    throw new Error(`convertRadix: wrong to=${u}, base cannot be less than 2`);
  if (!Array.isArray(n))
    throw new Error("convertRadix: data should be array");
  if (!n.length)
    return [];
  let p = 0;
  const a = [], A = Array.from(n);
  for (A.forEach((b) => {
    if (b < 0 || b >= c)
      throw new Error(`Wrong integer: ${b}`);
  }); ; ) {
    let b = 0, F = !0;
    for (let le = p; le < A.length; le++) {
      const L = A[le], pe = c * b + L;
      if (!Number.isSafeInteger(pe) || c * b / c !== b || pe - L !== c * b)
        throw new Error("convertRadix: carry overflow");
      b = pe % u;
      const $ = Math.floor(pe / u);
      if (A[le] = $, !Number.isSafeInteger($) || $ * u + b !== pe)
        throw new Error("convertRadix: carry overflow");
      if (F)
        $ ? F = !1 : p = le;
      else continue;
    }
    if (a.push(b), F)
      break;
  }
  for (let b = 0; b < n.length - 1 && n[b] === 0; b++)
    a.push(0);
  return a.reverse();
}
const gcd$2 = /* @__NO_SIDE_EFFECTS__ */ (n, c) => c ? /* @__PURE__ */ gcd$2(c, n % c) : n, radix2carry$2 = /* @__NO_SIDE_EFFECTS__ */ (n, c) => n + (c - /* @__PURE__ */ gcd$2(n, c));
// @__NO_SIDE_EFFECTS__
function convertRadix2$2(n, c, u, p) {
  if (!Array.isArray(n))
    throw new Error("convertRadix2: data should be array");
  if (c <= 0 || c > 32)
    throw new Error(`convertRadix2: wrong from=${c}`);
  if (u <= 0 || u > 32)
    throw new Error(`convertRadix2: wrong to=${u}`);
  if (/* @__PURE__ */ radix2carry$2(c, u) > 32)
    throw new Error(`convertRadix2: carry overflow from=${c} to=${u} carryBits=${/* @__PURE__ */ radix2carry$2(c, u)}`);
  let a = 0, A = 0;
  const b = 2 ** u - 1, F = [];
  for (const le of n) {
    if (le >= 2 ** c)
      throw new Error(`convertRadix2: invalid data word=${le} from=${c}`);
    if (a = a << c | le, A + c > 32)
      throw new Error(`convertRadix2: carry overflow pos=${A} from=${c}`);
    for (A += c; A >= u; A -= u)
      F.push((a >> A - u & b) >>> 0);
    a &= 2 ** A - 1;
  }
  if (a = a << u - A & b, !p && A >= c)
    throw new Error("Excess padding");
  if (!p && a)
    throw new Error(`Non-zero padding: ${a}`);
  return p && A > 0 && F.push(a >>> 0), F;
}
// @__NO_SIDE_EFFECTS__
function radix$1(n) {
  return {
    encode: (c) => {
      if (!isBytes$8(c))
        throw new Error("radix.encode input should be Uint8Array");
      return /* @__PURE__ */ convertRadix$1(Array.from(c), 2 ** 8, n);
    },
    decode: (c) => {
      if (!Array.isArray(c) || c.length && typeof c[0] != "number")
        throw new Error("radix.decode input should be array of numbers");
      return Uint8Array.from(/* @__PURE__ */ convertRadix$1(c, n, 2 ** 8));
    }
  };
}
// @__NO_SIDE_EFFECTS__
function radix2$2(n, c = !1) {
  if (n <= 0 || n > 32)
    throw new Error("radix2: bits should be in (0..32]");
  if (/* @__PURE__ */ radix2carry$2(8, n) > 32 || /* @__PURE__ */ radix2carry$2(n, 8) > 32)
    throw new Error("radix2: carry overflow");
  return {
    encode: (u) => {
      if (!isBytes$8(u))
        throw new Error("radix2.encode input should be Uint8Array");
      return /* @__PURE__ */ convertRadix2$2(Array.from(u), 8, n, !c);
    },
    decode: (u) => {
      if (!Array.isArray(u) || u.length && typeof u[0] != "number")
        throw new Error("radix2.decode input should be array of numbers");
      return Uint8Array.from(/* @__PURE__ */ convertRadix2$2(u, n, 8, c));
    }
  };
}
// @__NO_SIDE_EFFECTS__
function unsafeWrapper$1(n) {
  if (typeof n != "function")
    throw new Error("unsafeWrapper fn should be function");
  return function(...c) {
    try {
      return n.apply(null, c);
    } catch {
    }
  };
}
// @__NO_SIDE_EFFECTS__
function checksum$2(n, c) {
  if (typeof c != "function")
    throw new Error("checksum fn should be function");
  return {
    encode(u) {
      if (!isBytes$8(u))
        throw new Error("checksum.encode: input should be Uint8Array");
      const p = c(u).slice(0, n), a = new Uint8Array(u.length + n);
      return a.set(u), a.set(p, u.length), a;
    },
    decode(u) {
      if (!isBytes$8(u))
        throw new Error("checksum.decode: input should be Uint8Array");
      const p = u.slice(0, -n), a = c(p).slice(0, n), A = u.slice(-n);
      for (let b = 0; b < n; b++)
        if (a[b] !== A[b])
          throw new Error("Invalid checksum");
      return p;
    }
  };
}
const utils$3 = {
  alphabet: alphabet$2,
  chain: chain$2,
  checksum: checksum$2,
  convertRadix: convertRadix$1,
  convertRadix2: convertRadix2$2,
  radix: radix$1,
  radix2: radix2$2,
  join: join$2,
  padding
}, base16 = /* @__PURE__ */ chain$2(/* @__PURE__ */ radix2$2(4), /* @__PURE__ */ alphabet$2("0123456789ABCDEF"), /* @__PURE__ */ join$2("")), base32 = /* @__PURE__ */ chain$2(/* @__PURE__ */ radix2$2(5), /* @__PURE__ */ alphabet$2("ABCDEFGHIJKLMNOPQRSTUVWXYZ234567"), /* @__PURE__ */ padding(5), /* @__PURE__ */ join$2("")), base32nopad = /* @__PURE__ */ chain$2(/* @__PURE__ */ radix2$2(5), /* @__PURE__ */ alphabet$2("ABCDEFGHIJKLMNOPQRSTUVWXYZ234567"), /* @__PURE__ */ join$2("")), base32hex = /* @__PURE__ */ chain$2(/* @__PURE__ */ radix2$2(5), /* @__PURE__ */ alphabet$2("0123456789ABCDEFGHIJKLMNOPQRSTUV"), /* @__PURE__ */ padding(5), /* @__PURE__ */ join$2("")), base32hexnopad = /* @__PURE__ */ chain$2(/* @__PURE__ */ radix2$2(5), /* @__PURE__ */ alphabet$2("0123456789ABCDEFGHIJKLMNOPQRSTUV"), /* @__PURE__ */ join$2("")), base32crockford = /* @__PURE__ */ chain$2(/* @__PURE__ */ radix2$2(5), /* @__PURE__ */ alphabet$2("0123456789ABCDEFGHJKMNPQRSTVWXYZ"), /* @__PURE__ */ join$2(""), /* @__PURE__ */ normalize$3((n) => n.toUpperCase().replace(/O/g, "0").replace(/[IL]/g, "1"))), base64$4 = /* @__PURE__ */ chain$2(/* @__PURE__ */ radix2$2(6), /* @__PURE__ */ alphabet$2("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"), /* @__PURE__ */ padding(6), /* @__PURE__ */ join$2("")), base64nopad = /* @__PURE__ */ chain$2(/* @__PURE__ */ radix2$2(6), /* @__PURE__ */ alphabet$2("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"), /* @__PURE__ */ join$2("")), base64url$3 = /* @__PURE__ */ chain$2(/* @__PURE__ */ radix2$2(6), /* @__PURE__ */ alphabet$2("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"), /* @__PURE__ */ padding(6), /* @__PURE__ */ join$2("")), base64urlnopad = /* @__PURE__ */ chain$2(/* @__PURE__ */ radix2$2(6), /* @__PURE__ */ alphabet$2("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"), /* @__PURE__ */ join$2("")), genBase58$1 = (n) => /* @__PURE__ */ chain$2(/* @__PURE__ */ radix$1(58), /* @__PURE__ */ alphabet$2(n), /* @__PURE__ */ join$2("")), base58$2 = /* @__PURE__ */ genBase58$1("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"), base58flickr = /* @__PURE__ */ genBase58$1("123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"), base58xrp = /* @__PURE__ */ genBase58$1("rpshnaf39wBUDNEGHJKLM4PQRST7VWXYZ2bcdeCg65jkm8oFqi1tuvAxyz"), XMR_BLOCK_LEN = [0, 2, 3, 5, 6, 7, 9, 10, 11], base58xmr = {
  encode(n) {
    let c = "";
    for (let u = 0; u < n.length; u += 8) {
      const p = n.subarray(u, u + 8);
      c += base58$2.encode(p).padStart(XMR_BLOCK_LEN[p.length], "1");
    }
    return c;
  },
  decode(n) {
    let c = [];
    for (let u = 0; u < n.length; u += 11) {
      const p = n.slice(u, u + 11), a = XMR_BLOCK_LEN.indexOf(p.length), A = base58$2.decode(p);
      for (let b = 0; b < A.length - a; b++)
        if (A[b] !== 0)
          throw new Error("base58xmr: wrong padding");
      c = c.concat(Array.from(A.slice(A.length - a)));
    }
    return Uint8Array.from(c);
  }
}, createBase58check$1 = (n) => /* @__PURE__ */ chain$2(/* @__PURE__ */ checksum$2(4, (c) => n(n(c))), base58$2), base58check$2 = createBase58check$1, BECH_ALPHABET$1 = /* @__PURE__ */ chain$2(/* @__PURE__ */ alphabet$2("qpzry9x8gf2tvdw0s3jn54khce6mua7l"), /* @__PURE__ */ join$2("")), POLYMOD_GENERATORS$1 = [996825010, 642813549, 513874426, 1027748829, 705979059];
// @__NO_SIDE_EFFECTS__
function bech32Polymod$1(n) {
  const c = n >> 25;
  let u = (n & 33554431) << 5;
  for (let p = 0; p < POLYMOD_GENERATORS$1.length; p++)
    (c >> p & 1) === 1 && (u ^= POLYMOD_GENERATORS$1[p]);
  return u;
}
// @__NO_SIDE_EFFECTS__
function bechChecksum$1(n, c, u = 1) {
  const p = n.length;
  let a = 1;
  for (let A = 0; A < p; A++) {
    const b = n.charCodeAt(A);
    if (b < 33 || b > 126)
      throw new Error(`Invalid prefix (${n})`);
    a = /* @__PURE__ */ bech32Polymod$1(a) ^ b >> 5;
  }
  a = /* @__PURE__ */ bech32Polymod$1(a);
  for (let A = 0; A < p; A++)
    a = /* @__PURE__ */ bech32Polymod$1(a) ^ n.charCodeAt(A) & 31;
  for (let A of c)
    a = /* @__PURE__ */ bech32Polymod$1(a) ^ A;
  for (let A = 0; A < 6; A++)
    a = /* @__PURE__ */ bech32Polymod$1(a);
  return a ^= u, BECH_ALPHABET$1.encode(/* @__PURE__ */ convertRadix2$2([a % 2 ** 30], 30, 5, !1));
}
// @__NO_SIDE_EFFECTS__
function genBech32$1(n) {
  const c = n === "bech32" ? 1 : 734539939, u = /* @__PURE__ */ radix2$2(5), p = u.decode, a = u.encode, A = /* @__PURE__ */ unsafeWrapper$1(p);
  function b($, Ee, be = 90) {
    if (typeof $ != "string")
      throw new Error(`bech32.encode prefix should be string, not ${typeof $}`);
    if (Ee instanceof Uint8Array && (Ee = Array.from(Ee)), !Array.isArray(Ee) || Ee.length && typeof Ee[0] != "number")
      throw new Error(`bech32.encode words should be array of numbers, not ${typeof Ee}`);
    if ($.length === 0)
      throw new TypeError(`Invalid prefix length ${$.length}`);
    const He = $.length + 7 + Ee.length;
    if (be !== !1 && He > be)
      throw new TypeError(`Length ${He} exceeds limit ${be}`);
    const Pe = $.toLowerCase(), nr = /* @__PURE__ */ bechChecksum$1(Pe, Ee, c);
    return `${Pe}1${BECH_ALPHABET$1.encode(Ee)}${nr}`;
  }
  function F($, Ee = 90) {
    if (typeof $ != "string")
      throw new Error(`bech32.decode input should be string, not ${typeof $}`);
    if ($.length < 8 || Ee !== !1 && $.length > Ee)
      throw new TypeError(`Wrong string length: ${$.length} (${$}). Expected (8..${Ee})`);
    const be = $.toLowerCase();
    if ($ !== be && $ !== $.toUpperCase())
      throw new Error("String must be lowercase or uppercase");
    const He = be.lastIndexOf("1");
    if (He === 0 || He === -1)
      throw new Error('Letter "1" must be present between prefix and data only');
    const Pe = be.slice(0, He), nr = be.slice(He + 1);
    if (nr.length < 6)
      throw new Error("Data must be at least 6 characters long");
    const ir = BECH_ALPHABET$1.decode(nr).slice(0, -6), or = /* @__PURE__ */ bechChecksum$1(Pe, ir, c);
    if (!nr.endsWith(or))
      throw new Error(`Invalid checksum in ${$}: expected "${or}"`);
    return { prefix: Pe, words: ir };
  }
  const le = /* @__PURE__ */ unsafeWrapper$1(F);
  function L($) {
    const { prefix: Ee, words: be } = F($, !1);
    return { prefix: Ee, words: be, bytes: p(be) };
  }
  function pe($, Ee) {
    return b($, a(Ee));
  }
  return {
    encode: b,
    decode: F,
    encodeFromBytes: pe,
    decodeToBytes: L,
    decodeUnsafe: le,
    fromWords: p,
    fromWordsUnsafe: A,
    toWords: a
  };
}
const bech32$7 = /* @__PURE__ */ genBech32$1("bech32"), bech32m$1 = /* @__PURE__ */ genBech32$1("bech32m"), utf8$6 = {
  encode: (n) => new TextDecoder().decode(n),
  decode: (n) => new TextEncoder().encode(n)
}, hex$5 = /* @__PURE__ */ chain$2(/* @__PURE__ */ radix2$2(4), /* @__PURE__ */ alphabet$2("0123456789abcdef"), /* @__PURE__ */ join$2(""), /* @__PURE__ */ normalize$3((n) => {
  if (typeof n != "string" || n.length % 2)
    throw new TypeError(`hex.decode: expected string, got ${typeof n} with length ${n.length}`);
  return n.toLowerCase();
})), CODERS = {
  utf8: utf8$6,
  hex: hex$5,
  base16,
  base32,
  base64: base64$4,
  base64url: base64url$3,
  base58: base58$2,
  base58xmr
}, coderTypeError = "Invalid encoding type. Available types: utf8, hex, base16, base32, base64, base64url, base58, base58xmr", bytesToString = (n, c) => {
  if (typeof n != "string" || !CODERS.hasOwnProperty(n))
    throw new TypeError(coderTypeError);
  if (!isBytes$8(c))
    throw new TypeError("bytesToString() expects Uint8Array");
  return CODERS[n].encode(c);
}, str = bytesToString, stringToBytes = (n, c) => {
  if (!CODERS.hasOwnProperty(n))
    throw new TypeError(coderTypeError);
  if (typeof c != "string")
    throw new TypeError("stringToBytes() expects string");
  return CODERS[n].decode(c);
}, bytes$4 = stringToBytes, esm$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  assertNumber,
  base16,
  base32,
  base32crockford,
  base32hex,
  base32hexnopad,
  base32nopad,
  base58: base58$2,
  base58check: base58check$2,
  base58flickr,
  base58xmr,
  base58xrp,
  base64: base64$4,
  base64nopad,
  base64url: base64url$3,
  base64urlnopad,
  bech32: bech32$7,
  bech32m: bech32m$1,
  bytes: bytes$4,
  bytesToString,
  createBase58check: createBase58check$1,
  hex: hex$5,
  str,
  stringToBytes,
  utf8: utf8$6,
  utils: utils$3
}, Symbol.toStringTag, { value: "Module" }));
const Point$4 = secp256k1$6.ProjectivePoint, base58check$1 = createBase58check$1(sha256$8);
function bytesToNumber(n) {
  return BigInt(`0x${bytesToHex$4(n)}`);
}
function numberToBytes(n) {
  return hexToBytes$4(n.toString(16).padStart(64, "0"));
}
const MASTER_SECRET = utf8ToBytes$6("Bitcoin seed"), BITCOIN_VERSIONS = { private: 76066276, public: 76067358 }, HARDENED_OFFSET$1 = 2147483648, hash160$3 = (n) => ripemd160$3(sha256$8(n)), fromU32 = (n) => createView$6(n).getUint32(0, !1), toU32 = (n) => {
  if (!Number.isSafeInteger(n) || n < 0 || n > 2 ** 32 - 1)
    throw new Error(`Invalid number=${n}. Should be from 0 to 2 ** 32 - 1`);
  const c = new Uint8Array(4);
  return createView$6(c).setUint32(0, n, !1), c;
};
class HDKey {
  get fingerprint() {
    if (!this.pubHash)
      throw new Error("No publicKey set!");
    return fromU32(this.pubHash);
  }
  get identifier() {
    return this.pubHash;
  }
  get pubKeyHash() {
    return this.pubHash;
  }
  get privateKey() {
    return this.privKeyBytes || null;
  }
  get publicKey() {
    return this.pubKey || null;
  }
  get privateExtendedKey() {
    const c = this.privateKey;
    if (!c)
      throw new Error("No private key");
    return base58check$1.encode(this.serialize(this.versions.private, concatBytes$5(new Uint8Array([0]), c)));
  }
  get publicExtendedKey() {
    if (!this.pubKey)
      throw new Error("No public key");
    return base58check$1.encode(this.serialize(this.versions.public, this.pubKey));
  }
  static fromMasterSeed(c, u = BITCOIN_VERSIONS) {
    if (bytes$5(c), 8 * c.length < 128 || 8 * c.length > 512)
      throw new Error(`HDKey: wrong seed length=${c.length}. Should be between 128 and 512 bits; 256 bits is advised)`);
    const p = hmac$3(sha512$3, MASTER_SECRET, c);
    return new HDKey({
      versions: u,
      chainCode: p.slice(32),
      privateKey: p.slice(0, 32)
    });
  }
  static fromExtendedKey(c, u = BITCOIN_VERSIONS) {
    const p = base58check$1.decode(c), a = createView$6(p), A = a.getUint32(0, !1), b = {
      versions: u,
      depth: p[4],
      parentFingerprint: a.getUint32(5, !1),
      index: a.getUint32(9, !1),
      chainCode: p.slice(13, 45)
    }, F = p.slice(45), le = F[0] === 0;
    if (A !== u[le ? "private" : "public"])
      throw new Error("Version mismatch");
    return le ? new HDKey({ ...b, privateKey: F.slice(1) }) : new HDKey({ ...b, publicKey: F });
  }
  static fromJSON(c) {
    return HDKey.fromExtendedKey(c.xpriv);
  }
  constructor(c) {
    if (this.depth = 0, this.index = 0, this.chainCode = null, this.parentFingerprint = 0, !c || typeof c != "object")
      throw new Error("HDKey.constructor must not be called directly");
    if (this.versions = c.versions || BITCOIN_VERSIONS, this.depth = c.depth || 0, this.chainCode = c.chainCode || null, this.index = c.index || 0, this.parentFingerprint = c.parentFingerprint || 0, !this.depth && (this.parentFingerprint || this.index))
      throw new Error("HDKey: zero depth with non-zero index/parent fingerprint");
    if (c.publicKey && c.privateKey)
      throw new Error("HDKey: publicKey and privateKey at same time.");
    if (c.privateKey) {
      if (!secp256k1$6.utils.isValidPrivateKey(c.privateKey))
        throw new Error("Invalid private key");
      this.privKey = typeof c.privateKey == "bigint" ? c.privateKey : bytesToNumber(c.privateKey), this.privKeyBytes = numberToBytes(this.privKey), this.pubKey = secp256k1$6.getPublicKey(c.privateKey, !0);
    } else if (c.publicKey)
      this.pubKey = Point$4.fromHex(c.publicKey).toRawBytes(!0);
    else
      throw new Error("HDKey: no public or private key provided");
    this.pubHash = hash160$3(this.pubKey);
  }
  derive(c) {
    if (!/^[mM]'?/.test(c))
      throw new Error('Path must start with "m" or "M"');
    if (/^[mM]'?$/.test(c))
      return this;
    const u = c.replace(/^[mM]'?\//, "").split("/");
    let p = this;
    for (const a of u) {
      const A = /^(\d+)('?)$/.exec(a), b = A && A[1];
      if (!A || A.length !== 3 || typeof b != "string")
        throw new Error(`Invalid child index: ${a}`);
      let F = +b;
      if (!Number.isSafeInteger(F) || F >= HARDENED_OFFSET$1)
        throw new Error("Invalid index");
      A[2] === "'" && (F += HARDENED_OFFSET$1), p = p.deriveChild(F);
    }
    return p;
  }
  deriveChild(c) {
    if (!this.pubKey || !this.chainCode)
      throw new Error("No publicKey or chainCode set");
    let u = toU32(c);
    if (c >= HARDENED_OFFSET$1) {
      const F = this.privateKey;
      if (!F)
        throw new Error("Could not derive hardened child key");
      u = concatBytes$5(new Uint8Array([0]), F, u);
    } else
      u = concatBytes$5(this.pubKey, u);
    const p = hmac$3(sha512$3, this.chainCode, u), a = bytesToNumber(p.slice(0, 32)), A = p.slice(32);
    if (!secp256k1$6.utils.isValidPrivateKey(a))
      throw new Error("Tweak bigger than curve order");
    const b = {
      versions: this.versions,
      chainCode: A,
      depth: this.depth + 1,
      parentFingerprint: this.fingerprint,
      index: c
    };
    try {
      if (this.privateKey) {
        const F = mod$2(this.privKey + a, secp256k1$6.CURVE.n);
        if (!secp256k1$6.utils.isValidPrivateKey(F))
          throw new Error("The tweak was out of range or the resulted private key is invalid");
        b.privateKey = F;
      } else {
        const F = Point$4.fromHex(this.pubKey).add(Point$4.fromPrivateKey(a));
        if (F.equals(Point$4.ZERO))
          throw new Error("The tweak was equal to negative P, which made the result key invalid");
        b.publicKey = F.toRawBytes(!0);
      }
      return new HDKey(b);
    } catch {
      return this.deriveChild(c + 1);
    }
  }
  sign(c) {
    if (!this.privateKey)
      throw new Error("No privateKey set!");
    return bytes$5(c, 32), secp256k1$6.sign(c, this.privKey).toCompactRawBytes();
  }
  verify(c, u) {
    if (bytes$5(c, 32), bytes$5(u, 64), !this.publicKey)
      throw new Error("No publicKey set!");
    let p;
    try {
      p = secp256k1$6.Signature.fromCompact(u);
    } catch {
      return !1;
    }
    return secp256k1$6.verify(p, c, this.publicKey);
  }
  wipePrivateData() {
    return this.privKey = void 0, this.privKeyBytes && (this.privKeyBytes.fill(0), this.privKeyBytes = void 0), this;
  }
  toJSON() {
    return {
      xpriv: this.privateExtendedKey,
      xpub: this.publicExtendedKey
    };
  }
  serialize(c, u) {
    if (!this.chainCode)
      throw new Error("No chainCode set");
    return bytes$5(u, 33), concatBytes$5(toU32(c), new Uint8Array([this.depth]), toU32(this.parentFingerprint), toU32(this.index), this.chainCode, u);
  }
}
var build$6 = {}, keplr$1 = {}, build$5 = {}, currency = {};
Object.defineProperty(currency, "__esModule", { value: !0 });
var bech32$6 = {};
Object.defineProperty(bech32$6, "__esModule", { value: !0 });
var bip44 = {};
Object.defineProperty(bip44, "__esModule", { value: !0 });
var chainInfo = {};
Object.defineProperty(chainInfo, "__esModule", { value: !0 });
var wallet = {}, keplr = {};
Object.defineProperty(keplr, "__esModule", { value: !0 });
var eip6963 = {};
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.EIP6963EventNames = void 0, function(c) {
    c.Announce = "eip6963:announceProvider", c.Request = "eip6963:requestProvider";
  }(n.EIP6963EventNames || (n.EIP6963EventNames = {}));
})(eip6963);
var ethereum$1 = {};
Object.defineProperty(ethereum$1, "__esModule", { value: !0 });
var starknet = {};
Object.defineProperty(starknet, "__esModule", { value: !0 });
var bitcoin = {};
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.CHAIN_TYPE_TO_GENESIS_HASH = n.GENESIS_HASH_TO_CHAIN_TYPE = n.NETWORK_TO_GENESIS_HASH = n.GENESIS_HASH_TO_NETWORK = n.ChainType = n.Network = n.GenesisHash = n.BitcoinSignMessageType = void 0, function(a) {
    a.ECDSA = "ecdsa", a.BIP322_SIMPLE = "bip322-simple";
  }(n.BitcoinSignMessageType || (n.BitcoinSignMessageType = {}));
  var c;
  (function(a) {
    a.MAINNET = "000000000019d6689c085ae165831e934ff763ae46a2a6c172b3f1b60a8ce26f", a.TESTNET = "000000000933ea01ad0ee984209779baaec3ced90fa3f408719526f8d77f4943", a.SIGNET = "00000008819873e925422c1ff0f99f7cc9bbb232af63a077a480a3633bee1ef6";
  })(c = n.GenesisHash || (n.GenesisHash = {}));
  var u;
  (function(a) {
    a.MAINNET = "mainnet", a.LIVENET = "livenet", a.TESTNET = "testnet", a.SIGNET = "signet";
  })(u = n.Network || (n.Network = {}));
  var p;
  (function(a) {
    a.BITCOIN_MAINNET = "BITCOIN_MAINNET", a.BITCOIN_TESTNET = "BITCOIN_TESTNET", a.BITCOIN_SIGNET = "BITCOIN_SIGNET";
  })(p = n.ChainType || (n.ChainType = {})), n.GENESIS_HASH_TO_NETWORK = {
    [c.MAINNET]: u.MAINNET,
    [c.TESTNET]: u.TESTNET,
    [c.SIGNET]: u.SIGNET
  }, n.NETWORK_TO_GENESIS_HASH = {
    [u.MAINNET]: c.MAINNET,
    [u.LIVENET]: c.MAINNET,
    [u.TESTNET]: c.TESTNET,
    [u.SIGNET]: c.SIGNET
  }, n.GENESIS_HASH_TO_CHAIN_TYPE = {
    [c.MAINNET]: p.BITCOIN_MAINNET,
    [c.TESTNET]: p.BITCOIN_TESTNET,
    [c.SIGNET]: p.BITCOIN_SIGNET
  }, n.CHAIN_TYPE_TO_GENESIS_HASH = {
    [p.BITCOIN_MAINNET]: c.MAINNET,
    [p.BITCOIN_TESTNET]: c.TESTNET,
    [p.BITCOIN_SIGNET]: c.SIGNET
  };
})(bitcoin);
(function(n) {
  var c = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(p, a, A, b) {
    b === void 0 && (b = A);
    var F = Object.getOwnPropertyDescriptor(a, A);
    (!F || ("get" in F ? !a.__esModule : F.writable || F.configurable)) && (F = { enumerable: !0, get: function() {
      return a[A];
    } }), Object.defineProperty(p, b, F);
  } : function(p, a, A, b) {
    b === void 0 && (b = A), p[b] = a[A];
  }), u = commonjsGlobal && commonjsGlobal.__exportStar || function(p, a) {
    for (var A in p) A !== "default" && !Object.prototype.hasOwnProperty.call(a, A) && c(a, p, A);
  };
  Object.defineProperty(n, "__esModule", { value: !0 }), u(keplr, n), u(eip6963, n), u(ethereum$1, n), u(starknet, n), u(bitcoin, n);
})(wallet);
var window$1 = {};
Object.defineProperty(window$1, "__esModule", { value: !0 });
var ethereum = {};
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.EthTxStatus = n.EthSignType = void 0, function(c) {
    c.MESSAGE = "message", c.TRANSACTION = "transaction", c.EIP712 = "eip-712";
  }(n.EthSignType || (n.EthSignType = {})), function(c) {
    c.Success = "0x1", c.Failure = "0x0";
  }(n.EthTxStatus || (n.EthTxStatus = {}));
})(ethereum);
var cosmjs$1 = {};
Object.defineProperty(cosmjs$1, "__esModule", { value: !0 });
var cosmjsAlt = {};
Object.defineProperty(cosmjsAlt, "__esModule", { value: !0 });
var secretjs = {};
Object.defineProperty(secretjs, "__esModule", { value: !0 });
var settled = {};
Object.defineProperty(settled, "__esModule", { value: !0 });
(function(n) {
  var c = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(p, a, A, b) {
    b === void 0 && (b = A);
    var F = Object.getOwnPropertyDescriptor(a, A);
    (!F || ("get" in F ? !a.__esModule : F.writable || F.configurable)) && (F = { enumerable: !0, get: function() {
      return a[A];
    } }), Object.defineProperty(p, b, F);
  } : function(p, a, A, b) {
    b === void 0 && (b = A), p[b] = a[A];
  }), u = commonjsGlobal && commonjsGlobal.__exportStar || function(p, a) {
    for (var A in p) A !== "default" && !Object.prototype.hasOwnProperty.call(a, A) && c(a, p, A);
  };
  Object.defineProperty(n, "__esModule", { value: !0 }), u(currency, n), u(bech32$6, n), u(bip44, n), u(chainInfo, n), u(wallet, n), u(window$1, n), u(ethereum, n), u(cosmjs$1, n), u(cosmjsAlt, n), u(secretjs, n), u(settled, n);
})(build$5);
var uint8Array = {}, hex$4 = {};
Object.defineProperty(hex$4, "__esModule", { value: !0 });
hex$4.fromHex = hex$4.toHex = void 0;
function toHex$2(n) {
  let c = "";
  for (const u of n)
    c += ("0" + u.toString(16)).slice(-2);
  return c;
}
hex$4.toHex = toHex$2;
function fromHex$2(n) {
  if (n.length % 2 !== 0)
    throw new Error("hex string length must be a multiple of 2");
  const c = [];
  for (let u = 0; u < n.length; u += 2) {
    const p = n.substr(u, 2);
    if (!p.match(/[0-9a-f]{2}/i))
      throw new Error("hex string contains invalid characters");
    c.push(parseInt(p, 16));
  }
  return new Uint8Array(c);
}
hex$4.fromHex = fromHex$2;
Object.defineProperty(uint8Array, "__esModule", { value: !0 });
uint8Array.JSONUint8Array = void 0;
const hex_1 = hex$4;
class JSONUint8Array {
  static parse(c) {
    return JSON.parse(c, (u, p) => {
      if (u === "__proto__")
        throw new Error("__proto__ is disallowed");
      return p && typeof p == "string" && p.startsWith("__uint8array__") ? (0, hex_1.fromHex)(p.replace("__uint8array__", "")) : typeof BigInt < "u" && p && typeof p == "string" && p.startsWith("__bigint__") ? BigInt(p.replace("__bigint__", "")) : p;
    });
  }
  static stringify(c) {
    return JSON.stringify(c, (u, p) => {
      if (u === "__proto__")
        throw new Error("__proto__ is disallowed");
      if (p && (p instanceof Uint8Array || typeof p == "object" && "type" in p && "data" in p && p.type === "Buffer" && Array.isArray(p.data))) {
        const a = p instanceof Uint8Array ? p : new Uint8Array(p.data);
        return `__uint8array__${(0, hex_1.toHex)(a)}`;
      }
      return typeof p == "bigint" ? `__bigint__${p.toString()}` : p;
    });
  }
  static wrap(c) {
    if (c !== void 0)
      return JSON.parse(JSONUint8Array.stringify(c));
  }
  static unwrap(c) {
    if (c !== void 0)
      return JSONUint8Array.parse(JSONUint8Array.stringify(c));
  }
}
uint8Array.JSONUint8Array = JSONUint8Array;
var isMergeableObject = function n(c) {
  return isNonNullObject$1(c) && !isSpecial(c);
};
function isNonNullObject$1(n) {
  return !!n && typeof n == "object";
}
function isSpecial(n) {
  var c = Object.prototype.toString.call(n);
  return c === "[object RegExp]" || c === "[object Date]" || isReactElement(n);
}
var canUseSymbol = typeof Symbol == "function" && Symbol.for, REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for("react.element") : 60103;
function isReactElement(n) {
  return n.$$typeof === REACT_ELEMENT_TYPE;
}
function emptyTarget(n) {
  return Array.isArray(n) ? [] : {};
}
function cloneUnlessOtherwiseSpecified(n, c) {
  return c.clone !== !1 && c.isMergeableObject(n) ? deepmerge(emptyTarget(n), n, c) : n;
}
function defaultArrayMerge(n, c, u) {
  return n.concat(c).map(function(p) {
    return cloneUnlessOtherwiseSpecified(p, u);
  });
}
function getMergeFunction(n, c) {
  if (!c.customMerge)
    return deepmerge;
  var u = c.customMerge(n);
  return typeof u == "function" ? u : deepmerge;
}
function getEnumerableOwnPropertySymbols(n) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(n).filter(function(c) {
    return Object.propertyIsEnumerable.call(n, c);
  }) : [];
}
function getKeys(n) {
  return Object.keys(n).concat(getEnumerableOwnPropertySymbols(n));
}
function propertyIsOnObject(n, c) {
  try {
    return c in n;
  } catch {
    return !1;
  }
}
function propertyIsUnsafe(n, c) {
  return propertyIsOnObject(n, c) && !(Object.hasOwnProperty.call(n, c) && Object.propertyIsEnumerable.call(n, c));
}
function mergeObject(n, c, u) {
  var p = {};
  return u.isMergeableObject(n) && getKeys(n).forEach(function(a) {
    p[a] = cloneUnlessOtherwiseSpecified(n[a], u);
  }), getKeys(c).forEach(function(a) {
    propertyIsUnsafe(n, a) || (propertyIsOnObject(n, a) && u.isMergeableObject(c[a]) ? p[a] = getMergeFunction(a, u)(n[a], c[a], u) : p[a] = cloneUnlessOtherwiseSpecified(c[a], u));
  }), p;
}
function deepmerge(n, c, u) {
  u = u || {}, u.arrayMerge = u.arrayMerge || defaultArrayMerge, u.isMergeableObject = u.isMergeableObject || isMergeableObject, u.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;
  var p = Array.isArray(c), a = Array.isArray(n), A = p === a;
  return A ? p ? u.arrayMerge(n, c, u) : mergeObject(n, c, u) : cloneUnlessOtherwiseSpecified(c, u);
}
deepmerge.all = function n(c, u) {
  if (!Array.isArray(c))
    throw new Error("first argument should be an array");
  return c.reduce(function(p, a) {
    return deepmerge(p, a, u);
  }, {});
};
var deepmerge_1$1 = deepmerge, cjs = deepmerge_1$1, long = Long$1, wasm$2 = null;
try {
  wasm$2 = new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([
    0,
    97,
    115,
    109,
    1,
    0,
    0,
    0,
    1,
    13,
    2,
    96,
    0,
    1,
    127,
    96,
    4,
    127,
    127,
    127,
    127,
    1,
    127,
    3,
    7,
    6,
    0,
    1,
    1,
    1,
    1,
    1,
    6,
    6,
    1,
    127,
    1,
    65,
    0,
    11,
    7,
    50,
    6,
    3,
    109,
    117,
    108,
    0,
    1,
    5,
    100,
    105,
    118,
    95,
    115,
    0,
    2,
    5,
    100,
    105,
    118,
    95,
    117,
    0,
    3,
    5,
    114,
    101,
    109,
    95,
    115,
    0,
    4,
    5,
    114,
    101,
    109,
    95,
    117,
    0,
    5,
    8,
    103,
    101,
    116,
    95,
    104,
    105,
    103,
    104,
    0,
    0,
    10,
    191,
    1,
    6,
    4,
    0,
    35,
    0,
    11,
    36,
    1,
    1,
    126,
    32,
    0,
    173,
    32,
    1,
    173,
    66,
    32,
    134,
    132,
    32,
    2,
    173,
    32,
    3,
    173,
    66,
    32,
    134,
    132,
    126,
    34,
    4,
    66,
    32,
    135,
    167,
    36,
    0,
    32,
    4,
    167,
    11,
    36,
    1,
    1,
    126,
    32,
    0,
    173,
    32,
    1,
    173,
    66,
    32,
    134,
    132,
    32,
    2,
    173,
    32,
    3,
    173,
    66,
    32,
    134,
    132,
    127,
    34,
    4,
    66,
    32,
    135,
    167,
    36,
    0,
    32,
    4,
    167,
    11,
    36,
    1,
    1,
    126,
    32,
    0,
    173,
    32,
    1,
    173,
    66,
    32,
    134,
    132,
    32,
    2,
    173,
    32,
    3,
    173,
    66,
    32,
    134,
    132,
    128,
    34,
    4,
    66,
    32,
    135,
    167,
    36,
    0,
    32,
    4,
    167,
    11,
    36,
    1,
    1,
    126,
    32,
    0,
    173,
    32,
    1,
    173,
    66,
    32,
    134,
    132,
    32,
    2,
    173,
    32,
    3,
    173,
    66,
    32,
    134,
    132,
    129,
    34,
    4,
    66,
    32,
    135,
    167,
    36,
    0,
    32,
    4,
    167,
    11,
    36,
    1,
    1,
    126,
    32,
    0,
    173,
    32,
    1,
    173,
    66,
    32,
    134,
    132,
    32,
    2,
    173,
    32,
    3,
    173,
    66,
    32,
    134,
    132,
    130,
    34,
    4,
    66,
    32,
    135,
    167,
    36,
    0,
    32,
    4,
    167,
    11
  ])), {}).exports;
} catch (n) {
}
function Long$1(n, c, u) {
  this.low = n | 0, this.high = c | 0, this.unsigned = !!u;
}
Long$1.prototype.__isLong__;
Object.defineProperty(Long$1.prototype, "__isLong__", { value: !0 });
function isLong$1(n) {
  return (n && n.__isLong__) === !0;
}
Long$1.isLong = isLong$1;
var INT_CACHE$1 = {}, UINT_CACHE$1 = {};
function fromInt$1(n, c) {
  var u, p, a;
  return c ? (n >>>= 0, (a = 0 <= n && n < 256) && (p = UINT_CACHE$1[n], p) ? p : (u = fromBits$1(n, (n | 0) < 0 ? -1 : 0, !0), a && (UINT_CACHE$1[n] = u), u)) : (n |= 0, (a = -128 <= n && n < 128) && (p = INT_CACHE$1[n], p) ? p : (u = fromBits$1(n, n < 0 ? -1 : 0, !1), a && (INT_CACHE$1[n] = u), u));
}
Long$1.fromInt = fromInt$1;
function fromNumber$1(n, c) {
  if (isNaN(n))
    return c ? UZERO$1 : ZERO$1;
  if (c) {
    if (n < 0)
      return UZERO$1;
    if (n >= TWO_PWR_64_DBL$1)
      return MAX_UNSIGNED_VALUE$1;
  } else {
    if (n <= -TWO_PWR_63_DBL$1)
      return MIN_VALUE$1;
    if (n + 1 >= TWO_PWR_63_DBL$1)
      return MAX_VALUE$1;
  }
  return n < 0 ? fromNumber$1(-n, c).neg() : fromBits$1(n % TWO_PWR_32_DBL$1 | 0, n / TWO_PWR_32_DBL$1 | 0, c);
}
Long$1.fromNumber = fromNumber$1;
function fromBits$1(n, c, u) {
  return new Long$1(n, c, u);
}
Long$1.fromBits = fromBits$1;
var pow_dbl$1 = Math.pow;
function fromString$1(n, c, u) {
  if (n.length === 0)
    throw Error("empty string");
  if (n === "NaN" || n === "Infinity" || n === "+Infinity" || n === "-Infinity")
    return ZERO$1;
  if (typeof c == "number" ? (u = c, c = !1) : c = !!c, u = u || 10, u < 2 || 36 < u)
    throw RangeError("radix");
  var p;
  if ((p = n.indexOf("-")) > 0)
    throw Error("interior hyphen");
  if (p === 0)
    return fromString$1(n.substring(1), c, u).neg();
  for (var a = fromNumber$1(pow_dbl$1(u, 8)), A = ZERO$1, b = 0; b < n.length; b += 8) {
    var F = Math.min(8, n.length - b), le = parseInt(n.substring(b, b + F), u);
    if (F < 8) {
      var L = fromNumber$1(pow_dbl$1(u, F));
      A = A.mul(L).add(fromNumber$1(le));
    } else
      A = A.mul(a), A = A.add(fromNumber$1(le));
  }
  return A.unsigned = c, A;
}
Long$1.fromString = fromString$1;
function fromValue$1(n, c) {
  return typeof n == "number" ? fromNumber$1(n, c) : typeof n == "string" ? fromString$1(n, c) : fromBits$1(n.low, n.high, typeof c == "boolean" ? c : n.unsigned);
}
Long$1.fromValue = fromValue$1;
var TWO_PWR_16_DBL$1 = 65536, TWO_PWR_24_DBL$1 = 1 << 24, TWO_PWR_32_DBL$1 = TWO_PWR_16_DBL$1 * TWO_PWR_16_DBL$1, TWO_PWR_64_DBL$1 = TWO_PWR_32_DBL$1 * TWO_PWR_32_DBL$1, TWO_PWR_63_DBL$1 = TWO_PWR_64_DBL$1 / 2, TWO_PWR_24$1 = fromInt$1(TWO_PWR_24_DBL$1), ZERO$1 = fromInt$1(0);
Long$1.ZERO = ZERO$1;
var UZERO$1 = fromInt$1(0, !0);
Long$1.UZERO = UZERO$1;
var ONE$1 = fromInt$1(1);
Long$1.ONE = ONE$1;
var UONE$1 = fromInt$1(1, !0);
Long$1.UONE = UONE$1;
var NEG_ONE$1 = fromInt$1(-1);
Long$1.NEG_ONE = NEG_ONE$1;
var MAX_VALUE$1 = fromBits$1(-1, 2147483647, !1);
Long$1.MAX_VALUE = MAX_VALUE$1;
var MAX_UNSIGNED_VALUE$1 = fromBits$1(-1, -1, !0);
Long$1.MAX_UNSIGNED_VALUE = MAX_UNSIGNED_VALUE$1;
var MIN_VALUE$1 = fromBits$1(0, -2147483648, !1);
Long$1.MIN_VALUE = MIN_VALUE$1;
var LongPrototype$1 = Long$1.prototype;
LongPrototype$1.toInt = function n() {
  return this.unsigned ? this.low >>> 0 : this.low;
};
LongPrototype$1.toNumber = function n() {
  return this.unsigned ? (this.high >>> 0) * TWO_PWR_32_DBL$1 + (this.low >>> 0) : this.high * TWO_PWR_32_DBL$1 + (this.low >>> 0);
};
LongPrototype$1.toString = function n(c) {
  if (c = c || 10, c < 2 || 36 < c)
    throw RangeError("radix");
  if (this.isZero())
    return "0";
  if (this.isNegative())
    if (this.eq(MIN_VALUE$1)) {
      var u = fromNumber$1(c), p = this.div(u), a = p.mul(u).sub(this);
      return p.toString(c) + a.toInt().toString(c);
    } else
      return "-" + this.neg().toString(c);
  for (var A = fromNumber$1(pow_dbl$1(c, 6), this.unsigned), b = this, F = ""; ; ) {
    var le = b.div(A), L = b.sub(le.mul(A)).toInt() >>> 0, pe = L.toString(c);
    if (b = le, b.isZero())
      return pe + F;
    for (; pe.length < 6; )
      pe = "0" + pe;
    F = "" + pe + F;
  }
};
LongPrototype$1.getHighBits = function n() {
  return this.high;
};
LongPrototype$1.getHighBitsUnsigned = function n() {
  return this.high >>> 0;
};
LongPrototype$1.getLowBits = function n() {
  return this.low;
};
LongPrototype$1.getLowBitsUnsigned = function n() {
  return this.low >>> 0;
};
LongPrototype$1.getNumBitsAbs = function n() {
  if (this.isNegative())
    return this.eq(MIN_VALUE$1) ? 64 : this.neg().getNumBitsAbs();
  for (var c = this.high != 0 ? this.high : this.low, u = 31; u > 0 && !(c & 1 << u); u--)
    ;
  return this.high != 0 ? u + 33 : u + 1;
};
LongPrototype$1.isZero = function n() {
  return this.high === 0 && this.low === 0;
};
LongPrototype$1.eqz = LongPrototype$1.isZero;
LongPrototype$1.isNegative = function n() {
  return !this.unsigned && this.high < 0;
};
LongPrototype$1.isPositive = function n() {
  return this.unsigned || this.high >= 0;
};
LongPrototype$1.isOdd = function n() {
  return (this.low & 1) === 1;
};
LongPrototype$1.isEven = function n() {
  return (this.low & 1) === 0;
};
LongPrototype$1.equals = function n(c) {
  return isLong$1(c) || (c = fromValue$1(c)), this.unsigned !== c.unsigned && this.high >>> 31 === 1 && c.high >>> 31 === 1 ? !1 : this.high === c.high && this.low === c.low;
};
LongPrototype$1.eq = LongPrototype$1.equals;
LongPrototype$1.notEquals = function n(c) {
  return !this.eq(
    /* validates */
    c
  );
};
LongPrototype$1.neq = LongPrototype$1.notEquals;
LongPrototype$1.ne = LongPrototype$1.notEquals;
LongPrototype$1.lessThan = function n(c) {
  return this.comp(
    /* validates */
    c
  ) < 0;
};
LongPrototype$1.lt = LongPrototype$1.lessThan;
LongPrototype$1.lessThanOrEqual = function n(c) {
  return this.comp(
    /* validates */
    c
  ) <= 0;
};
LongPrototype$1.lte = LongPrototype$1.lessThanOrEqual;
LongPrototype$1.le = LongPrototype$1.lessThanOrEqual;
LongPrototype$1.greaterThan = function n(c) {
  return this.comp(
    /* validates */
    c
  ) > 0;
};
LongPrototype$1.gt = LongPrototype$1.greaterThan;
LongPrototype$1.greaterThanOrEqual = function n(c) {
  return this.comp(
    /* validates */
    c
  ) >= 0;
};
LongPrototype$1.gte = LongPrototype$1.greaterThanOrEqual;
LongPrototype$1.ge = LongPrototype$1.greaterThanOrEqual;
LongPrototype$1.compare = function n(c) {
  if (isLong$1(c) || (c = fromValue$1(c)), this.eq(c))
    return 0;
  var u = this.isNegative(), p = c.isNegative();
  return u && !p ? -1 : !u && p ? 1 : this.unsigned ? c.high >>> 0 > this.high >>> 0 || c.high === this.high && c.low >>> 0 > this.low >>> 0 ? -1 : 1 : this.sub(c).isNegative() ? -1 : 1;
};
LongPrototype$1.comp = LongPrototype$1.compare;
LongPrototype$1.negate = function n() {
  return !this.unsigned && this.eq(MIN_VALUE$1) ? MIN_VALUE$1 : this.not().add(ONE$1);
};
LongPrototype$1.neg = LongPrototype$1.negate;
LongPrototype$1.add = function n(c) {
  isLong$1(c) || (c = fromValue$1(c));
  var u = this.high >>> 16, p = this.high & 65535, a = this.low >>> 16, A = this.low & 65535, b = c.high >>> 16, F = c.high & 65535, le = c.low >>> 16, L = c.low & 65535, pe = 0, $ = 0, Ee = 0, be = 0;
  return be += A + L, Ee += be >>> 16, be &= 65535, Ee += a + le, $ += Ee >>> 16, Ee &= 65535, $ += p + F, pe += $ >>> 16, $ &= 65535, pe += u + b, pe &= 65535, fromBits$1(Ee << 16 | be, pe << 16 | $, this.unsigned);
};
LongPrototype$1.subtract = function n(c) {
  return isLong$1(c) || (c = fromValue$1(c)), this.add(c.neg());
};
LongPrototype$1.sub = LongPrototype$1.subtract;
LongPrototype$1.multiply = function n(c) {
  if (this.isZero())
    return ZERO$1;
  if (isLong$1(c) || (c = fromValue$1(c)), wasm$2) {
    var u = wasm$2.mul(
      this.low,
      this.high,
      c.low,
      c.high
    );
    return fromBits$1(u, wasm$2.get_high(), this.unsigned);
  }
  if (c.isZero())
    return ZERO$1;
  if (this.eq(MIN_VALUE$1))
    return c.isOdd() ? MIN_VALUE$1 : ZERO$1;
  if (c.eq(MIN_VALUE$1))
    return this.isOdd() ? MIN_VALUE$1 : ZERO$1;
  if (this.isNegative())
    return c.isNegative() ? this.neg().mul(c.neg()) : this.neg().mul(c).neg();
  if (c.isNegative())
    return this.mul(c.neg()).neg();
  if (this.lt(TWO_PWR_24$1) && c.lt(TWO_PWR_24$1))
    return fromNumber$1(this.toNumber() * c.toNumber(), this.unsigned);
  var p = this.high >>> 16, a = this.high & 65535, A = this.low >>> 16, b = this.low & 65535, F = c.high >>> 16, le = c.high & 65535, L = c.low >>> 16, pe = c.low & 65535, $ = 0, Ee = 0, be = 0, He = 0;
  return He += b * pe, be += He >>> 16, He &= 65535, be += A * pe, Ee += be >>> 16, be &= 65535, be += b * L, Ee += be >>> 16, be &= 65535, Ee += a * pe, $ += Ee >>> 16, Ee &= 65535, Ee += A * L, $ += Ee >>> 16, Ee &= 65535, Ee += b * le, $ += Ee >>> 16, Ee &= 65535, $ += p * pe + a * L + A * le + b * F, $ &= 65535, fromBits$1(be << 16 | He, $ << 16 | Ee, this.unsigned);
};
LongPrototype$1.mul = LongPrototype$1.multiply;
LongPrototype$1.divide = function n(c) {
  if (isLong$1(c) || (c = fromValue$1(c)), c.isZero())
    throw Error("division by zero");
  if (wasm$2) {
    if (!this.unsigned && this.high === -2147483648 && c.low === -1 && c.high === -1)
      return this;
    var u = (this.unsigned ? wasm$2.div_u : wasm$2.div_s)(
      this.low,
      this.high,
      c.low,
      c.high
    );
    return fromBits$1(u, wasm$2.get_high(), this.unsigned);
  }
  if (this.isZero())
    return this.unsigned ? UZERO$1 : ZERO$1;
  var p, a, A;
  if (this.unsigned) {
    if (c.unsigned || (c = c.toUnsigned()), c.gt(this))
      return UZERO$1;
    if (c.gt(this.shru(1)))
      return UONE$1;
    A = UZERO$1;
  } else {
    if (this.eq(MIN_VALUE$1)) {
      if (c.eq(ONE$1) || c.eq(NEG_ONE$1))
        return MIN_VALUE$1;
      if (c.eq(MIN_VALUE$1))
        return ONE$1;
      var b = this.shr(1);
      return p = b.div(c).shl(1), p.eq(ZERO$1) ? c.isNegative() ? ONE$1 : NEG_ONE$1 : (a = this.sub(c.mul(p)), A = p.add(a.div(c)), A);
    } else if (c.eq(MIN_VALUE$1))
      return this.unsigned ? UZERO$1 : ZERO$1;
    if (this.isNegative())
      return c.isNegative() ? this.neg().div(c.neg()) : this.neg().div(c).neg();
    if (c.isNegative())
      return this.div(c.neg()).neg();
    A = ZERO$1;
  }
  for (a = this; a.gte(c); ) {
    p = Math.max(1, Math.floor(a.toNumber() / c.toNumber()));
    for (var F = Math.ceil(Math.log(p) / Math.LN2), le = F <= 48 ? 1 : pow_dbl$1(2, F - 48), L = fromNumber$1(p), pe = L.mul(c); pe.isNegative() || pe.gt(a); )
      p -= le, L = fromNumber$1(p, this.unsigned), pe = L.mul(c);
    L.isZero() && (L = ONE$1), A = A.add(L), a = a.sub(pe);
  }
  return A;
};
LongPrototype$1.div = LongPrototype$1.divide;
LongPrototype$1.modulo = function n(c) {
  if (isLong$1(c) || (c = fromValue$1(c)), wasm$2) {
    var u = (this.unsigned ? wasm$2.rem_u : wasm$2.rem_s)(
      this.low,
      this.high,
      c.low,
      c.high
    );
    return fromBits$1(u, wasm$2.get_high(), this.unsigned);
  }
  return this.sub(this.div(c).mul(c));
};
LongPrototype$1.mod = LongPrototype$1.modulo;
LongPrototype$1.rem = LongPrototype$1.modulo;
LongPrototype$1.not = function n() {
  return fromBits$1(~this.low, ~this.high, this.unsigned);
};
LongPrototype$1.and = function n(c) {
  return isLong$1(c) || (c = fromValue$1(c)), fromBits$1(this.low & c.low, this.high & c.high, this.unsigned);
};
LongPrototype$1.or = function n(c) {
  return isLong$1(c) || (c = fromValue$1(c)), fromBits$1(this.low | c.low, this.high | c.high, this.unsigned);
};
LongPrototype$1.xor = function n(c) {
  return isLong$1(c) || (c = fromValue$1(c)), fromBits$1(this.low ^ c.low, this.high ^ c.high, this.unsigned);
};
LongPrototype$1.shiftLeft = function n(c) {
  return isLong$1(c) && (c = c.toInt()), (c &= 63) === 0 ? this : c < 32 ? fromBits$1(this.low << c, this.high << c | this.low >>> 32 - c, this.unsigned) : fromBits$1(0, this.low << c - 32, this.unsigned);
};
LongPrototype$1.shl = LongPrototype$1.shiftLeft;
LongPrototype$1.shiftRight = function n(c) {
  return isLong$1(c) && (c = c.toInt()), (c &= 63) === 0 ? this : c < 32 ? fromBits$1(this.low >>> c | this.high << 32 - c, this.high >> c, this.unsigned) : fromBits$1(this.high >> c - 32, this.high >= 0 ? 0 : -1, this.unsigned);
};
LongPrototype$1.shr = LongPrototype$1.shiftRight;
LongPrototype$1.shiftRightUnsigned = function n(c) {
  if (isLong$1(c) && (c = c.toInt()), c &= 63, c === 0)
    return this;
  var u = this.high;
  if (c < 32) {
    var p = this.low;
    return fromBits$1(p >>> c | u << 32 - c, u >>> c, this.unsigned);
  } else return c === 32 ? fromBits$1(u, 0, this.unsigned) : fromBits$1(u >>> c - 32, 0, this.unsigned);
};
LongPrototype$1.shru = LongPrototype$1.shiftRightUnsigned;
LongPrototype$1.shr_u = LongPrototype$1.shiftRightUnsigned;
LongPrototype$1.toSigned = function n() {
  return this.unsigned ? fromBits$1(this.low, this.high, !1) : this;
};
LongPrototype$1.toUnsigned = function n() {
  return this.unsigned ? this : fromBits$1(this.low, this.high, !0);
};
LongPrototype$1.toBytes = function n(c) {
  return c ? this.toBytesLE() : this.toBytesBE();
};
LongPrototype$1.toBytesLE = function n() {
  var c = this.high, u = this.low;
  return [
    u & 255,
    u >>> 8 & 255,
    u >>> 16 & 255,
    u >>> 24,
    c & 255,
    c >>> 8 & 255,
    c >>> 16 & 255,
    c >>> 24
  ];
};
LongPrototype$1.toBytesBE = function n() {
  var c = this.high, u = this.low;
  return [
    c >>> 24,
    c >>> 16 & 255,
    c >>> 8 & 255,
    c & 255,
    u >>> 24,
    u >>> 16 & 255,
    u >>> 8 & 255,
    u & 255
  ];
};
Long$1.fromBytes = function n(c, u, p) {
  return p ? Long$1.fromBytesLE(c, u) : Long$1.fromBytesBE(c, u);
};
Long$1.fromBytesLE = function n(c, u) {
  return new Long$1(
    c[0] | c[1] << 8 | c[2] << 16 | c[3] << 24,
    c[4] | c[5] << 8 | c[6] << 16 | c[7] << 24,
    u
  );
};
Long$1.fromBytesBE = function n(c, u) {
  return new Long$1(
    c[4] << 24 | c[5] << 16 | c[6] << 8 | c[7],
    c[0] << 24 | c[1] << 16 | c[2] << 8 | c[3],
    u
  );
};
var cosmjs = {}, __awaiter$5 = commonjsGlobal && commonjsGlobal.__awaiter || function(n, c, u, p) {
  function a(A) {
    return A instanceof u ? A : new u(function(b) {
      b(A);
    });
  }
  return new (u || (u = Promise))(function(A, b) {
    function F(pe) {
      try {
        L(p.next(pe));
      } catch ($) {
        b($);
      }
    }
    function le(pe) {
      try {
        L(p.throw(pe));
      } catch ($) {
        b($);
      }
    }
    function L(pe) {
      pe.done ? A(pe.value) : a(pe.value).then(F, le);
    }
    L((p = p.apply(n, c || [])).next());
  });
};
Object.defineProperty(cosmjs, "__esModule", { value: !0 });
cosmjs.CosmJSOfflineSigner = cosmjs.CosmJSOfflineSignerOnlyAmino = void 0;
class CosmJSOfflineSignerOnlyAmino {
  constructor(c, u, p) {
    this.chainId = c, this.keplr = u, this.signOptions = p;
  }
  getAccounts() {
    return __awaiter$5(this, void 0, void 0, function* () {
      const c = yield this.keplr.getKey(this.chainId);
      return [
        {
          address: c.bech32Address,
          // Currently, only secp256k1 is supported.
          algo: "secp256k1",
          pubkey: c.pubKey
        }
      ];
    });
  }
  signAmino(c, u) {
    return __awaiter$5(this, void 0, void 0, function* () {
      if (this.chainId !== u.chain_id)
        throw new Error("Unmatched chain id with the offline signer");
      if ((yield this.keplr.getKey(u.chain_id)).bech32Address !== c)
        throw new Error("Unknown signer address");
      return yield this.keplr.signAmino(this.chainId, c, u, this.signOptions);
    });
  }
  // Fallback function for the legacy cosmjs implementation before the stargate.
  sign(c, u) {
    return __awaiter$5(this, void 0, void 0, function* () {
      return yield this.signAmino(c, u);
    });
  }
}
cosmjs.CosmJSOfflineSignerOnlyAmino = CosmJSOfflineSignerOnlyAmino;
class CosmJSOfflineSigner extends CosmJSOfflineSignerOnlyAmino {
  constructor(c, u, p) {
    super(c, u, p);
  }
  signDirect(c, u) {
    return __awaiter$5(this, void 0, void 0, function* () {
      if (this.chainId !== u.chainId)
        throw new Error("Unmatched chain id with the offline signer");
      if ((yield this.keplr.getKey(u.chainId)).bech32Address !== c)
        throw new Error("Unknown signer address");
      return yield this.keplr.signDirect(this.chainId, c, u, this.signOptions);
    });
  }
}
cosmjs.CosmJSOfflineSigner = CosmJSOfflineSigner;
var enigma = {}, __awaiter$4 = commonjsGlobal && commonjsGlobal.__awaiter || function(n, c, u, p) {
  function a(A) {
    return A instanceof u ? A : new u(function(b) {
      b(A);
    });
  }
  return new (u || (u = Promise))(function(A, b) {
    function F(pe) {
      try {
        L(p.next(pe));
      } catch ($) {
        b($);
      }
    }
    function le(pe) {
      try {
        L(p.throw(pe));
      } catch ($) {
        b($);
      }
    }
    function L(pe) {
      pe.done ? A(pe.value) : a(pe.value).then(F, le);
    }
    L((p = p.apply(n, c || [])).next());
  });
};
Object.defineProperty(enigma, "__esModule", { value: !0 });
enigma.KeplrEnigmaUtils = void 0;
class KeplrEnigmaUtils {
  constructor(c, u) {
    this.chainId = c, this.keplr = u;
  }
  getPubkey() {
    return __awaiter$4(this, void 0, void 0, function* () {
      return yield this.keplr.getEnigmaPubKey(this.chainId);
    });
  }
  getTxEncryptionKey(c) {
    return __awaiter$4(this, void 0, void 0, function* () {
      return yield this.keplr.getEnigmaTxEncryptionKey(this.chainId, c);
    });
  }
  encrypt(c, u) {
    return __awaiter$4(this, void 0, void 0, function* () {
      return yield this.keplr.enigmaEncrypt(this.chainId, c, u);
    });
  }
  decrypt(c, u) {
    return __awaiter$4(this, void 0, void 0, function* () {
      return yield this.keplr.enigmaDecrypt(this.chainId, c, u);
    });
  }
}
enigma.KeplrEnigmaUtils = KeplrEnigmaUtils;
var version = {};
Object.defineProperty(version, "__esModule", { value: !0 });
version.BUILD_VERSION = void 0;
version.BUILD_VERSION = "0.12.220";
var constants$2 = {};
Object.defineProperty(constants$2, "__esModule", { value: !0 });
constants$2.metaId = constants$2.KeplrLogoBase64 = void 0;
constants$2.KeplrLogoBase64 = "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";
constants$2.metaId = "d_2hxd99brRo";
var __awaiter$3 = commonjsGlobal && commonjsGlobal.__awaiter || function(n, c, u, p) {
  function a(A) {
    return A instanceof u ? A : new u(function(b) {
      b(A);
    });
  }
  return new (u || (u = Promise))(function(A, b) {
    function F(pe) {
      try {
        L(p.next(pe));
      } catch ($) {
        b($);
      }
    }
    function le(pe) {
      try {
        L(p.throw(pe));
      } catch ($) {
        b($);
      }
    }
    function L(pe) {
      pe.done ? A(pe.value) : a(pe.value).then(F, le);
    }
    L((p = p.apply(n, c || [])).next());
  });
}, __importDefault$9 = commonjsGlobal && commonjsGlobal.__importDefault || function(n) {
  return n && n.__esModule ? n : { default: n };
};
Object.defineProperty(keplr$1, "__esModule", { value: !0 });
keplr$1.BitcoinProvider = keplr$1.Keplr = keplr$1.EthereumProviderRpcError = void 0;
const types_1 = build$5, uint8_array_1 = uint8Array, deepmerge_1 = __importDefault$9(cjs), long_1$3 = __importDefault$9(long), cosmjs_1 = cosmjs, enigma_1 = enigma, version_1 = version, events_1 = __importDefault$9(eventsExports), constants_1 = constants$2;
class EthereumProviderRpcError extends Error {
  constructor(c, u, p) {
    super(u), this.code = c, this.data = p, Object.setPrototypeOf(this, EthereumProviderRpcError.prototype);
  }
}
keplr$1.EthereumProviderRpcError = EthereumProviderRpcError;
class Keplr {
  constructor() {
    this.enigmaUtils = /* @__PURE__ */ new Map(), this.version = version_1.BUILD_VERSION, this.mode = "extension", this.defaultOptions = {}, this.ethereum = new EthereumProvider(this), this.starknet = void 0, this.bitcoin = new BitcoinProvider(this);
  }
  static staticRequestMethod(c, u) {
    const p = "ReactNativeWebView" in window, a = p ? (pe) => {
      window.ReactNativeWebView.postMessage(JSON.stringify(pe));
    } : (pe) => {
      window.postMessage(pe, window.location.origin);
    }, A = p ? (pe) => {
      if (pe && typeof pe == "string")
        try {
          return JSON.parse(pe);
        } catch {
        }
      return pe;
    } : (pe) => pe, b = new Uint8Array(8), F = Array.from(crypto.getRandomValues(b)).map((pe) => pe.toString(16)).join(""), L = {
      type: window.keplrRequestMetaIdSupport ? `proxy-request${constants_1.metaId ? `-${constants_1.metaId}` : ""}` : "proxy-request",
      id: F,
      method: c,
      args: uint8_array_1.JSONUint8Array.wrap(u)
    };
    return new Promise((pe, $) => {
      const Ee = (be) => {
        const He = A(be.data);
        if (!He || He.type !== "proxy-request-response" || He.id !== F)
          return;
        window.removeEventListener("message", Ee);
        const Pe = uint8_array_1.JSONUint8Array.unwrap(He.result);
        if (!Pe) {
          $(new Error("Result is null"));
          return;
        }
        if (Pe.error) {
          $(new Error(Pe.error));
          return;
        }
        pe(Pe.return);
      };
      window.addEventListener("message", Ee), a(L);
    });
  }
  requestMethod(c, u) {
    return Keplr.staticRequestMethod(c, u);
  }
  static getKeplr(c = 1500) {
    return __awaiter$3(this, void 0, void 0, function* () {
      yield waitDocumentReady();
      const u = "ReactNativeWebView" in window, p = typeof navigator < "u" && "userAgent" in navigator ? navigator.userAgent.includes("Firefox") : !1;
      if (!(!u && !p && window.keplrRequestMetaIdSupport == null))
        return new Promise((a, A) => {
          const b = setTimeout(() => {
            a(void 0);
          }, c);
          Keplr.staticRequestMethod("ping", []).then(() => {
            clearTimeout(b), a(new Keplr());
          }).catch((F) => {
            var le;
            !((le = F == null ? void 0 : F.message) === null || le === void 0) && le.includes("Invalid method: ping") ? (clearTimeout(b), a(new Keplr())) : A(F);
          });
        });
    });
  }
  ping() {
    return __awaiter$3(this, void 0, void 0, function* () {
      yield this.requestMethod("ping", []);
    });
  }
  enable(c) {
    return __awaiter$3(this, void 0, void 0, function* () {
      yield this.requestMethod("enable", [c]);
    });
  }
  disable(c) {
    return __awaiter$3(this, void 0, void 0, function* () {
      yield this.requestMethod("disable", [c]);
    });
  }
  experimentalSuggestChain(c) {
    var u, p;
    return __awaiter$3(this, void 0, void 0, function* () {
      if (c.hideInUI)
        throw new Error("hideInUI is not allowed");
      (!((u = c.features) === null || u === void 0) && u.includes("stargate") || !((p = c.features) === null || p === void 0) && p.includes("no-legacy-stdTx")) && console.warn("“stargate”, “no-legacy-stdTx” feature has been deprecated. The launchpad is no longer supported, thus works without the two features. We would keep the aforementioned two feature for a while, but the upcoming update would potentially cause errors. Remove the two feature."), yield this.requestMethod("experimentalSuggestChain", [c]);
    });
  }
  getKey(c) {
    return __awaiter$3(this, void 0, void 0, function* () {
      return yield this.requestMethod("getKey", [c]);
    });
  }
  getKeysSettled(c) {
    return __awaiter$3(this, void 0, void 0, function* () {
      return yield this.requestMethod("getKeysSettled", [c]);
    });
  }
  sendTx(c, u, p) {
    return __awaiter$3(this, void 0, void 0, function* () {
      return "length" in u || console.warn("Do not send legacy std tx via `sendTx` API. We now only support protobuf tx. The usage of legeacy std tx would throw an error in the near future."), yield this.requestMethod("sendTx", [c, u, p]);
    });
  }
  signAmino(c, u, p, a = {}) {
    var A;
    return __awaiter$3(this, void 0, void 0, function* () {
      return yield this.requestMethod("signAmino", [
        c,
        u,
        p,
        (0, deepmerge_1.default)((A = this.defaultOptions.sign) !== null && A !== void 0 ? A : {}, a)
      ]);
    });
  }
  signDirect(c, u, p, a = {}) {
    var A;
    return __awaiter$3(this, void 0, void 0, function* () {
      const b = yield this.requestMethod("signDirect", [
        c,
        u,
        // We can't send the `Long` with remaing the type.
        // Receiver should change the `string` to `Long`.
        {
          bodyBytes: p.bodyBytes,
          authInfoBytes: p.authInfoBytes,
          chainId: p.chainId,
          accountNumber: p.accountNumber ? p.accountNumber.toString() : null
        },
        (0, deepmerge_1.default)((A = this.defaultOptions.sign) !== null && A !== void 0 ? A : {}, a)
      ]), F = b.signed;
      return {
        signed: {
          bodyBytes: F.bodyBytes,
          authInfoBytes: F.authInfoBytes,
          chainId: F.chainId,
          // We can't send the `Long` with remaing the type.
          // Sender should change the `Long` to `string`.
          accountNumber: long_1$3.default.fromString(F.accountNumber)
        },
        signature: b.signature
      };
    });
  }
  signDirectAux(c, u, p, a = {}) {
    var A;
    return __awaiter$3(this, void 0, void 0, function* () {
      const b = yield this.requestMethod("signDirectAux", [
        c,
        u,
        // We can't send the `Long` with remaing the type.
        // Receiver should change the `string` to `Long`.
        {
          bodyBytes: p.bodyBytes,
          publicKey: p.publicKey,
          chainId: p.chainId,
          accountNumber: p.accountNumber ? p.accountNumber.toString() : null,
          sequence: p.sequence ? p.sequence.toString() : null
        },
        (0, deepmerge_1.default)({
          preferNoSetMemo: (A = this.defaultOptions.sign) === null || A === void 0 ? void 0 : A.preferNoSetMemo
        }, a)
      ]), F = b.signed;
      return {
        signed: {
          bodyBytes: F.bodyBytes,
          publicKey: F.publicKey || void 0,
          chainId: F.chainId,
          // We can't send the `Long` with remaing the type.
          // Sender should change the `Long` to `string`.
          accountNumber: long_1$3.default.fromString(F.accountNumber),
          sequence: long_1$3.default.fromString(F.sequence)
        },
        signature: b.signature
      };
    });
  }
  signArbitrary(c, u, p) {
    return __awaiter$3(this, void 0, void 0, function* () {
      return yield this.requestMethod("signArbitrary", [c, u, p]);
    });
  }
  signICNSAdr36(c, u, p, a, A) {
    return this.requestMethod("signICNSAdr36", [
      c,
      u,
      p,
      a,
      A
    ]);
  }
  verifyArbitrary(c, u, p, a) {
    return __awaiter$3(this, void 0, void 0, function* () {
      return yield this.requestMethod("verifyArbitrary", [
        c,
        u,
        p,
        a
      ]);
    });
  }
  signEthereum(c, u, p, a) {
    return __awaiter$3(this, void 0, void 0, function* () {
      return yield this.requestMethod("signEthereum", [
        c,
        u,
        p,
        a
      ]);
    });
  }
  getOfflineSigner(c, u) {
    return new cosmjs_1.CosmJSOfflineSigner(c, this, u);
  }
  getOfflineSignerOnlyAmino(c, u) {
    return new cosmjs_1.CosmJSOfflineSignerOnlyAmino(c, this, u);
  }
  getOfflineSignerAuto(c, u) {
    return __awaiter$3(this, void 0, void 0, function* () {
      return (yield this.getKey(c)).isNanoLedger ? new cosmjs_1.CosmJSOfflineSignerOnlyAmino(c, this, u) : new cosmjs_1.CosmJSOfflineSigner(c, this, u);
    });
  }
  suggestToken(c, u, p) {
    return __awaiter$3(this, void 0, void 0, function* () {
      return yield this.requestMethod("suggestToken", [
        c,
        u,
        p
      ]);
    });
  }
  getSecret20ViewingKey(c, u) {
    return __awaiter$3(this, void 0, void 0, function* () {
      return yield this.requestMethod("getSecret20ViewingKey", [
        c,
        u
      ]);
    });
  }
  getEnigmaPubKey(c) {
    return __awaiter$3(this, void 0, void 0, function* () {
      return yield this.requestMethod("getEnigmaPubKey", [c]);
    });
  }
  getEnigmaTxEncryptionKey(c, u) {
    return __awaiter$3(this, void 0, void 0, function* () {
      return yield this.requestMethod("getEnigmaTxEncryptionKey", [
        c,
        u
      ]);
    });
  }
  enigmaEncrypt(c, u, p) {
    return __awaiter$3(this, void 0, void 0, function* () {
      return yield this.requestMethod("enigmaEncrypt", [
        c,
        u,
        p
      ]);
    });
  }
  enigmaDecrypt(c, u, p) {
    return __awaiter$3(this, void 0, void 0, function* () {
      return yield this.requestMethod("enigmaDecrypt", [
        c,
        u,
        p
      ]);
    });
  }
  getEnigmaUtils(c) {
    if (this.enigmaUtils.has(c))
      return this.enigmaUtils.get(c);
    const u = new enigma_1.KeplrEnigmaUtils(c, this);
    return this.enigmaUtils.set(c, u), u;
  }
  experimentalSignEIP712CosmosTx_v0(c, u, p, a, A = {}) {
    var b;
    return __awaiter$3(this, void 0, void 0, function* () {
      return yield this.requestMethod("experimentalSignEIP712CosmosTx_v0", [
        c,
        u,
        p,
        a,
        (0, deepmerge_1.default)((b = this.defaultOptions.sign) !== null && b !== void 0 ? b : {}, A)
      ]);
    });
  }
  getChainInfosWithoutEndpoints() {
    return __awaiter$3(this, void 0, void 0, function* () {
      return yield this.requestMethod("getChainInfosWithoutEndpoints", []);
    });
  }
  changeKeyRingName({ defaultName: c, editable: u = !0 }) {
    return __awaiter$3(this, void 0, void 0, function* () {
      return yield this.requestMethod("changeKeyRingName", [
        { defaultName: c, editable: u }
      ]);
    });
  }
  sendEthereumTx(c, u) {
    return __awaiter$3(this, void 0, void 0, function* () {
      return yield this.requestMethod("sendEthereumTx", [c, u]);
    });
  }
  suggestERC20(c, u) {
    return __awaiter$3(this, void 0, void 0, function* () {
      return yield this.requestMethod("suggestERC20", [c, u]);
    });
  }
  getChainInfoWithoutEndpoints(c) {
    return __awaiter$3(this, void 0, void 0, function* () {
      return yield this.requestMethod("getChainInfoWithoutEndpoints", [c]);
    });
  }
  getStarknetKey(c) {
    return __awaiter$3(this, void 0, void 0, function* () {
      return yield this.requestMethod("getStarknetKey", [c]);
    });
  }
  getStarknetKeysSettled(c) {
    return __awaiter$3(this, void 0, void 0, function* () {
      return yield this.requestMethod("getStarknetKeysSettled", [c]);
    });
  }
  signStarknetTx(c, u, p) {
    return __awaiter$3(this, void 0, void 0, function* () {
      return yield this.requestMethod("signStarknetTx", [
        c,
        u,
        p
      ]);
    });
  }
  signStarknetDeployAccountTransaction(c, u) {
    return __awaiter$3(this, void 0, void 0, function* () {
      return yield this.requestMethod("signStarknetDeployAccountTransaction", [
        c,
        u
      ]);
    });
  }
  getBitcoinKey(c) {
    return __awaiter$3(this, void 0, void 0, function* () {
      return yield this.requestMethod("getBitcoinKey", [c]);
    });
  }
  getBitcoinKeysSettled(c) {
    return __awaiter$3(this, void 0, void 0, function* () {
      return yield this.requestMethod("getBitcoinKeysSettled", [c]);
    });
  }
  signPsbt(c, u, p) {
    return __awaiter$3(this, void 0, void 0, function* () {
      return yield this.requestMethod("signPsbt", [c, u, p]);
    });
  }
  signPsbts(c, u, p) {
    return __awaiter$3(this, void 0, void 0, function* () {
      return yield this.requestMethod("signPsbts", [
        c,
        u,
        p
      ]);
    });
  }
  __core__getAnalyticsId() {
    return __awaiter$3(this, void 0, void 0, function* () {
      return yield this.requestMethod("__core__getAnalyticsId", []);
    });
  }
  __core__privilageSignAminoWithdrawRewards(c, u, p) {
    return __awaiter$3(this, void 0, void 0, function* () {
      return yield this.requestMethod("__core__privilageSignAminoWithdrawRewards", [c, u, p]);
    });
  }
  __core__privilageSignAminoDelegate(c, u, p) {
    return __awaiter$3(this, void 0, void 0, function* () {
      return yield this.requestMethod("__core__privilageSignAminoDelegate", [c, u, p]);
    });
  }
  __core__privilageSignAminoExecuteCosmWasm(c, u, p) {
    return __awaiter$3(this, void 0, void 0, function* () {
      return yield this.requestMethod("__core__privilageSignAminoExecuteCosmWasm", [c, u, p]);
    });
  }
  __core__webpageClosed() {
    return __awaiter$3(this, void 0, void 0, function* () {
      return yield this.requestMethod("__core__webpageClosed", []);
    });
  }
}
keplr$1.Keplr = Keplr;
const waitDocumentReady = () => document.readyState === "complete" ? Promise.resolve() : new Promise((n) => {
  const c = (u) => {
    u.target && u.target.readyState === "complete" && (n(), document.removeEventListener("readystatechange", c));
  };
  document.addEventListener("readystatechange", c);
});
class EthereumProvider extends events_1.default {
  constructor(c) {
    if (super(), this.keplr = c, this.eip6963ProviderInfo = {
      uuid: crypto.randomUUID(),
      name: "Keplr",
      rdns: "app.keplr",
      icon: `data:image/png;base64,${constants_1.KeplrLogoBase64}`
    }, this.chainId = null, this.networkVersion = null, this.selectedAddress = null, this.isKeplr = !0, this.isMetaMask = !0, this._isConnected = !1, this._currentChainId = null, window.addEventListener("keplr_keystorechange", () => __awaiter$3(this, void 0, void 0, function* () {
      if (this._currentChainId && (yield c.getChainInfoWithoutEndpoints(this._currentChainId))) {
        const p = (yield c.getKey(this._currentChainId)).ethereumHexAddress;
        this.handleAccountsChanged(p);
      }
    })), window.addEventListener("keplr_chainChanged", (u) => {
      if (u.detail.origin === window.location.origin) {
        const a = u.detail.evmChainId;
        this.handleChainChanged(a);
      }
    }), window.addEventListener("keplr_ethSubscription", (u) => {
      var p;
      const a = u.detail.origin, A = u.detail.providerId;
      if (a === window.location.origin && A === ((p = this.eip6963ProviderInfo) === null || p === void 0 ? void 0 : p.uuid)) {
        const b = u.detail.data;
        this.emit("message", {
          type: "eth_subscription",
          data: b
        });
      }
    }), this.eip6963ProviderInfo) {
      const u = new CustomEvent(types_1.EIP6963EventNames.Announce, {
        detail: Object.freeze({
          info: this.eip6963ProviderInfo,
          provider: this
        })
      });
      window.addEventListener(types_1.EIP6963EventNames.Request, () => window.dispatchEvent(u)), window.dispatchEvent(u);
    }
  }
  static requestMethod(c, u) {
    return __awaiter$3(this, void 0, void 0, function* () {
      const p = "ReactNativeWebView" in window, a = p ? (pe) => {
        window.ReactNativeWebView.postMessage(JSON.stringify(pe));
      } : (pe) => {
        window.postMessage(pe, window.location.origin);
      }, A = p ? (pe) => {
        if (pe && typeof pe == "string")
          try {
            return JSON.parse(pe);
          } catch {
          }
        return pe;
      } : (pe) => pe, b = new Uint8Array(8), F = Array.from(crypto.getRandomValues(b)).map((pe) => pe.toString(16)).join(""), L = {
        type: window.keplrRequestMetaIdSupport ? `proxy-request${constants_1.metaId ? `-${constants_1.metaId}` : ""}` : "proxy-request",
        id: F,
        method: "ethereum",
        args: uint8_array_1.JSONUint8Array.wrap(u),
        ethereumProviderMethod: c
      };
      return new Promise((pe, $) => {
        const Ee = (be) => {
          const He = A(be.data);
          if (!He || He.type !== "proxy-request-response" || He.id !== F)
            return;
          window.removeEventListener("message", Ee);
          const Pe = uint8_array_1.JSONUint8Array.unwrap(He.result);
          if (!Pe) {
            $(new Error("Result is null"));
            return;
          }
          if (Pe.error) {
            const nr = Pe.error;
            $(nr.code && !nr.module ? new EthereumProviderRpcError(nr.code, nr.message, nr.data) : new Error(nr));
            return;
          }
          pe(Pe.return);
        };
        window.addEventListener("message", Ee), a(L);
      });
    });
  }
  handleConnect(c) {
    return __awaiter$3(this, void 0, void 0, function* () {
      if (!this._isConnected) {
        const { currentEvmChainId: u, currentChainId: p, selectedAddress: a } = yield EthereumProvider.requestMethod("request", Object.assign({ method: "keplr_connect" }, c && { params: [c] }));
        this._isConnected = !0, this._currentChainId = p, this.chainId = `0x${u.toString(16)}`, this.networkVersion = u.toString(10), this.selectedAddress = a, this.emit("connect", { chainId: this.chainId });
      }
    });
  }
  handleDisconnect() {
    return __awaiter$3(this, void 0, void 0, function* () {
      this._isConnected && (yield EthereumProvider.requestMethod("request", {
        method: "keplr_disconnect"
      }), this._isConnected = !1, this.chainId = null, this.selectedAddress = null, this.networkVersion = null, this.emit("disconnect"));
    });
  }
  handleChainChanged(c) {
    return __awaiter$3(this, void 0, void 0, function* () {
      yield this.handleConnect(c);
      const u = `0x${c.toString(16)}`;
      this.emit("chainChanged", u);
    });
  }
  handleAccountsChanged(c) {
    return __awaiter$3(this, void 0, void 0, function* () {
      this._isConnected && (this.selectedAddress = c, this.emit("accountsChanged", [c]));
    });
  }
  isConnected() {
    return this._isConnected;
  }
  request({ method: c, params: u, chainId: p }) {
    var a;
    return __awaiter$3(this, void 0, void 0, function* () {
      if (!this._isConnected) {
        if (c === "eth_accounts")
          return [];
        yield this.handleConnect();
      }
      return yield EthereumProvider.requestMethod("request", {
        method: c,
        params: u,
        providerId: (a = this.eip6963ProviderInfo) === null || a === void 0 ? void 0 : a.uuid,
        chainId: p
      });
    });
  }
  enable() {
    return __awaiter$3(this, void 0, void 0, function* () {
      return yield EthereumProvider.requestMethod("request", {
        method: "eth_requestAccounts"
      });
    });
  }
  net_version() {
    return __awaiter$3(this, void 0, void 0, function* () {
      return yield EthereumProvider.requestMethod("request", {
        method: "net_version"
      });
    });
  }
}
class BitcoinProvider extends events_1.default {
  constructor(c) {
    super(), this.keplr = c;
  }
  static _requestMethod(c, u) {
    return __awaiter$3(this, void 0, void 0, function* () {
      const p = "ReactNativeWebView" in window, a = p ? (pe) => {
        window.ReactNativeWebView.postMessage(JSON.stringify(pe));
      } : (pe) => {
        window.postMessage(pe, window.location.origin);
      }, A = p ? (pe) => {
        if (pe && typeof pe == "string")
          try {
            return JSON.parse(pe);
          } catch {
          }
        return pe;
      } : (pe) => pe, b = new Uint8Array(8), F = Array.from(crypto.getRandomValues(b)).map((pe) => pe.toString(16)).join(""), L = {
        type: window.keplrRequestMetaIdSupport ? `proxy-request${constants_1.metaId ? `-${constants_1.metaId}` : ""}` : "proxy-request",
        id: F,
        method: "bitcoin",
        args: uint8_array_1.JSONUint8Array.wrap(u),
        bitcoinProviderMethod: c
      };
      return new Promise((pe, $) => {
        const Ee = (be) => {
          const He = A(be.data);
          if (!He || He.type !== "proxy-request-response" || He.id !== F)
            return;
          window.removeEventListener("message", Ee);
          const Pe = uint8_array_1.JSONUint8Array.unwrap(He.result);
          if (!Pe) {
            $(new Error("Result is null"));
            return;
          }
          if (Pe.error) {
            $(new Error(Pe.error));
            return;
          }
          pe(Pe.return);
        };
        window.addEventListener("message", Ee), a(L);
      });
    });
  }
  getAccounts() {
    return BitcoinProvider._requestMethod("getAccounts", []);
  }
  requestAccounts() {
    return __awaiter$3(this, void 0, void 0, function* () {
      return BitcoinProvider._requestMethod("requestAccounts", []);
    });
  }
  disconnect() {
    return __awaiter$3(this, void 0, void 0, function* () {
      return BitcoinProvider._requestMethod("disconnect", []);
    });
  }
  getNetwork() {
    return __awaiter$3(this, void 0, void 0, function* () {
      return BitcoinProvider._requestMethod("getNetwork", []);
    });
  }
  switchNetwork(c) {
    return __awaiter$3(this, void 0, void 0, function* () {
      return BitcoinProvider._requestMethod("switchNetwork", [c]);
    });
  }
  getChain() {
    return __awaiter$3(this, void 0, void 0, function* () {
      return BitcoinProvider._requestMethod("getChain", []);
    });
  }
  switchChain(c) {
    return __awaiter$3(this, void 0, void 0, function* () {
      return BitcoinProvider._requestMethod("switchChain", [c]);
    });
  }
  getPublicKey() {
    return __awaiter$3(this, void 0, void 0, function* () {
      return BitcoinProvider._requestMethod("getPublicKey", []);
    });
  }
  getBalance() {
    return __awaiter$3(this, void 0, void 0, function* () {
      return BitcoinProvider._requestMethod("getBalance", []);
    });
  }
  getInscriptions() {
    return __awaiter$3(this, void 0, void 0, function* () {
      return BitcoinProvider._requestMethod("getInscriptions", []);
    });
  }
  signMessage(c, u) {
    return __awaiter$3(this, void 0, void 0, function* () {
      return BitcoinProvider._requestMethod("signMessage", [c, u]);
    });
  }
  sendBitcoin(c, u) {
    return __awaiter$3(this, void 0, void 0, function* () {
      return BitcoinProvider._requestMethod("sendBitcoin", [c, u]);
    });
  }
  pushTx(c) {
    return __awaiter$3(this, void 0, void 0, function* () {
      return BitcoinProvider._requestMethod("pushTx", [c]);
    });
  }
  signPsbt(c, u) {
    return __awaiter$3(this, void 0, void 0, function* () {
      return BitcoinProvider._requestMethod("signPsbt", [c, u]);
    });
  }
  signPsbts(c, u) {
    return __awaiter$3(this, void 0, void 0, function* () {
      return BitcoinProvider._requestMethod("signPsbts", [c, u]);
    });
  }
  getAddress() {
    return __awaiter$3(this, void 0, void 0, function* () {
      return (yield this.getAccounts())[0];
    });
  }
  connectWallet() {
    return __awaiter$3(this, void 0, void 0, function* () {
      return this.requestAccounts();
    });
  }
}
keplr$1.BitcoinProvider = BitcoinProvider;
var keplrFallback = {}, __awaiter$2 = commonjsGlobal && commonjsGlobal.__awaiter || function(n, c, u, p) {
  function a(A) {
    return A instanceof u ? A : new u(function(b) {
      b(A);
    });
  }
  return new (u || (u = Promise))(function(A, b) {
    function F(pe) {
      try {
        L(p.next(pe));
      } catch ($) {
        b($);
      }
    }
    function le(pe) {
      try {
        L(p.throw(pe));
      } catch ($) {
        b($);
      }
    }
    function L(pe) {
      pe.done ? A(pe.value) : a(pe.value).then(F, le);
    }
    L((p = p.apply(n, c || [])).next());
  });
};
Object.defineProperty(keplrFallback, "__esModule", { value: !0 });
keplrFallback.KeplrFallback = void 0;
const keplr_1 = keplr$1;
class KeplrFallback extends keplr_1.Keplr {
  constructor(c) {
    super(), this.onKeplrNotDetected = c, this.isKeplrDetected = null, this.onKeplrNotDetected && keplr_1.Keplr.getKeplr(500).then((u) => {
      var p;
      u || (p = this.onKeplrNotDetected) === null || p === void 0 || p.call(this);
    });
  }
  requestMethod(c, u) {
    return __awaiter$2(this, void 0, void 0, function* () {
      if (this.isKeplrDetected == null && ((yield keplr_1.Keplr.getKeplr(500)) ? this.isKeplrDetected = !0 : this.isKeplrDetected = !1), this.isKeplrDetected)
        return keplr_1.Keplr.staticRequestMethod(c, u);
      {
        const p = window.keplr;
        if (p)
          return p[c](...u);
        throw new Error("Can't detect keplr fallback");
      }
    });
  }
}
keplrFallback.KeplrFallback = KeplrFallback;
(function(n) {
  var c = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(p, a, A, b) {
    b === void 0 && (b = A);
    var F = Object.getOwnPropertyDescriptor(a, A);
    (!F || ("get" in F ? !a.__esModule : F.writable || F.configurable)) && (F = { enumerable: !0, get: function() {
      return a[A];
    } }), Object.defineProperty(p, b, F);
  } : function(p, a, A, b) {
    b === void 0 && (b = A), p[b] = a[A];
  }), u = commonjsGlobal && commonjsGlobal.__exportStar || function(p, a) {
    for (var A in p) A !== "default" && !Object.prototype.hasOwnProperty.call(a, A) && c(a, p, A);
  };
  Object.defineProperty(n, "__esModule", { value: !0 }), u(keplr$1, n), u(keplrFallback, n);
})(build$6);
var lib$1 = {}, signer = {}, base64Url = {}, base64Js = {};
base64Js.byteLength = byteLength;
base64Js.toByteArray = toByteArray;
base64Js.fromByteArray = fromByteArray;
var lookup = [], revLookup = [], Arr = typeof Uint8Array < "u" ? Uint8Array : Array, code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var i$1 = 0, len = code.length; i$1 < len; ++i$1)
  lookup[i$1] = code[i$1], revLookup[code.charCodeAt(i$1)] = i$1;
revLookup[45] = 62;
revLookup[95] = 63;
function getLens(n) {
  var c = n.length;
  if (c % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var u = n.indexOf("=");
  u === -1 && (u = c);
  var p = u === c ? 0 : 4 - u % 4;
  return [u, p];
}
function byteLength(n) {
  var c = getLens(n), u = c[0], p = c[1];
  return (u + p) * 3 / 4 - p;
}
function _byteLength(n, c, u) {
  return (c + u) * 3 / 4 - u;
}
function toByteArray(n) {
  var c, u = getLens(n), p = u[0], a = u[1], A = new Arr(_byteLength(n, p, a)), b = 0, F = a > 0 ? p - 4 : p, le;
  for (le = 0; le < F; le += 4)
    c = revLookup[n.charCodeAt(le)] << 18 | revLookup[n.charCodeAt(le + 1)] << 12 | revLookup[n.charCodeAt(le + 2)] << 6 | revLookup[n.charCodeAt(le + 3)], A[b++] = c >> 16 & 255, A[b++] = c >> 8 & 255, A[b++] = c & 255;
  return a === 2 && (c = revLookup[n.charCodeAt(le)] << 2 | revLookup[n.charCodeAt(le + 1)] >> 4, A[b++] = c & 255), a === 1 && (c = revLookup[n.charCodeAt(le)] << 10 | revLookup[n.charCodeAt(le + 1)] << 4 | revLookup[n.charCodeAt(le + 2)] >> 2, A[b++] = c >> 8 & 255, A[b++] = c & 255), A;
}
function tripletToBase64(n) {
  return lookup[n >> 18 & 63] + lookup[n >> 12 & 63] + lookup[n >> 6 & 63] + lookup[n & 63];
}
function encodeChunk(n, c, u) {
  for (var p, a = [], A = c; A < u; A += 3)
    p = (n[A] << 16 & 16711680) + (n[A + 1] << 8 & 65280) + (n[A + 2] & 255), a.push(tripletToBase64(p));
  return a.join("");
}
function fromByteArray(n) {
  for (var c, u = n.length, p = u % 3, a = [], A = 16383, b = 0, F = u - p; b < F; b += A)
    a.push(encodeChunk(n, b, b + A > F ? F : b + A));
  return p === 1 ? (c = n[u - 1], a.push(
    lookup[c >> 2] + lookup[c << 4 & 63] + "=="
  )) : p === 2 && (c = (n[u - 2] << 8) + n[u - 1], a.push(
    lookup[c >> 10] + lookup[c >> 4 & 63] + lookup[c << 2 & 63] + "="
  )), a.join("");
}
Object.defineProperty(base64Url, "__esModule", { value: !0 });
base64Url.decode = base64Url.encode = base64Url.unescape = base64Url.escape = base64Url.pad = void 0;
const base64_js_1$1 = base64Js;
function pad(n) {
  return `${n}${"=".repeat(4 - (n.length % 4 || 4))}`;
}
base64Url.pad = pad;
function escape$1(n) {
  return n.replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}
base64Url.escape = escape$1;
function unescape$1(n) {
  return pad(n).replace(/-/g, "+").replace(/_/g, "/");
}
base64Url.unescape = unescape$1;
function encode$a(n) {
  return escape$1((0, base64_js_1$1.fromByteArray)(new TextEncoder().encode(n)));
}
base64Url.encode = encode$a;
function decode$b(n) {
  return new TextDecoder().decode((0, base64_js_1$1.toByteArray)(pad(unescape$1(n))));
}
base64Url.decode = decode$b;
var cryptoClients = {}, secp256k1$5 = {}, lib = {};
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.utils = n.schnorr = n.verify = n.signSync = n.sign = n.getSharedSecret = n.recoverPublicKey = n.getPublicKey = n.hexToBytes = n.bytesToHex = n.Signature = n.Point = n.CURVE = void 0;
  const c = requireCryptoBrowserify(), u = BigInt(0), p = BigInt(1), a = BigInt(2), A = BigInt(3), b = BigInt(8), F = Object.freeze({
    a: u,
    b: BigInt(7),
    P: BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"),
    n: BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"),
    h: p,
    Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
    Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
    beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee")
  });
  n.CURVE = F;
  const le = (hi, Ii) => (hi + Ii / a) / Ii, L = {
    beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
    splitScalar(hi) {
      const { n: Ii } = F, Gi = BigInt("0x3086d221a7d46bcde86c90e49284eb15"), kn = -p * BigInt("0xe4437ed6010e88286f547fa90abfe4c3"), ho = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), eo = Gi, Ei = BigInt("0x100000000000000000000000000000000"), vs = le(eo * hi, Ii), vi = le(-kn * hi, Ii);
      let xi = wi(hi - vs * Gi - vi * ho, Ii), Lr = wi(-vs * kn - vi * eo, Ii);
      const dn = xi > Ei, xn = Lr > Ei;
      if (dn && (xi = Ii - xi), xn && (Lr = Ii - Lr), xi > Ei || Lr > Ei)
        throw new Error("splitScalarEndo: Endomorphism failed, k=" + hi);
      return { k1neg: dn, k1: xi, k2neg: xn, k2: Lr };
    }
  }, pe = 32, $ = 32, Ee = 32, be = pe + 1, He = 2 * pe + 1;
  function Pe(hi) {
    const { a: Ii, b: Gi } = F, kn = wi(hi * hi), ho = wi(kn * hi);
    return wi(ho + Ii * hi + Gi);
  }
  const nr = F.a === u;
  class ir extends Error {
    constructor(Ii) {
      super(Ii);
    }
  }
  function or(hi) {
    if (!(hi instanceof lr))
      throw new TypeError("JacobianPoint expected");
  }
  class lr {
    constructor(Ii, Gi, kn) {
      this.x = Ii, this.y = Gi, this.z = kn;
    }
    static fromAffine(Ii) {
      if (!(Ii instanceof kr))
        throw new TypeError("JacobianPoint#fromAffine: expected Point");
      return Ii.equals(kr.ZERO) ? lr.ZERO : new lr(Ii.x, Ii.y, p);
    }
    static toAffineBatch(Ii) {
      const Gi = ei(Ii.map((kn) => kn.z));
      return Ii.map((kn, ho) => kn.toAffine(Gi[ho]));
    }
    static normalizeZ(Ii) {
      return lr.toAffineBatch(Ii).map(lr.fromAffine);
    }
    equals(Ii) {
      or(Ii);
      const { x: Gi, y: kn, z: ho } = this, { x: eo, y: Ei, z: vs } = Ii, vi = wi(ho * ho), xi = wi(vs * vs), Lr = wi(Gi * xi), dn = wi(eo * vi), xn = wi(wi(kn * vs) * xi), oi = wi(wi(Ei * ho) * vi);
      return Lr === dn && xn === oi;
    }
    negate() {
      return new lr(this.x, wi(-this.y), this.z);
    }
    double() {
      const { x: Ii, y: Gi, z: kn } = this, ho = wi(Ii * Ii), eo = wi(Gi * Gi), Ei = wi(eo * eo), vs = Ii + eo, vi = wi(a * (wi(vs * vs) - ho - Ei)), xi = wi(A * ho), Lr = wi(xi * xi), dn = wi(Lr - a * vi), xn = wi(xi * (vi - dn) - b * Ei), oi = wi(a * Gi * kn);
      return new lr(dn, xn, oi);
    }
    add(Ii) {
      or(Ii);
      const { x: Gi, y: kn, z: ho } = this, { x: eo, y: Ei, z: vs } = Ii;
      if (eo === u || Ei === u)
        return this;
      if (Gi === u || kn === u)
        return Ii;
      const vi = wi(ho * ho), xi = wi(vs * vs), Lr = wi(Gi * xi), dn = wi(eo * vi), xn = wi(wi(kn * vs) * xi), oi = wi(wi(Ei * ho) * vi), Yr = wi(dn - Lr), ji = wi(oi - xn);
      if (Yr === u)
        return ji === u ? this.double() : lr.ZERO;
      const Cn = wi(Yr * Yr), Mn = wi(Yr * Cn), B = wi(Lr * Cn), o = wi(ji * ji - Mn - a * B), m = wi(ji * (B - o) - xn * Mn), d = wi(ho * vs * Yr);
      return new lr(o, m, d);
    }
    subtract(Ii) {
      return this.add(Ii.negate());
    }
    multiplyUnsafe(Ii) {
      const Gi = lr.ZERO;
      if (typeof Ii == "bigint" && Ii === u)
        return Gi;
      let kn = Qi(Ii);
      if (kn === p)
        return this;
      if (!nr) {
        let dn = Gi, xn = this;
        for (; kn > u; )
          kn & p && (dn = dn.add(xn)), xn = xn.double(), kn >>= p;
        return dn;
      }
      let { k1neg: ho, k1: eo, k2neg: Ei, k2: vs } = L.splitScalar(kn), vi = Gi, xi = Gi, Lr = this;
      for (; eo > u || vs > u; )
        eo & p && (vi = vi.add(Lr)), vs & p && (xi = xi.add(Lr)), Lr = Lr.double(), eo >>= p, vs >>= p;
      return ho && (vi = vi.negate()), Ei && (xi = xi.negate()), xi = new lr(wi(xi.x * L.beta), xi.y, xi.z), vi.add(xi);
    }
    precomputeWindow(Ii) {
      const Gi = nr ? 128 / Ii + 1 : 256 / Ii + 1, kn = [];
      let ho = this, eo = ho;
      for (let Ei = 0; Ei < Gi; Ei++) {
        eo = ho, kn.push(eo);
        for (let vs = 1; vs < 2 ** (Ii - 1); vs++)
          eo = eo.add(ho), kn.push(eo);
        ho = eo.double();
      }
      return kn;
    }
    wNAF(Ii, Gi) {
      !Gi && this.equals(lr.BASE) && (Gi = kr.BASE);
      const kn = Gi && Gi._WINDOW_SIZE || 1;
      if (256 % kn)
        throw new Error("Point#wNAF: Invalid precomputation window, must be power of 2");
      let ho = Gi && xr.get(Gi);
      ho || (ho = this.precomputeWindow(kn), Gi && kn !== 1 && (ho = lr.normalizeZ(ho), xr.set(Gi, ho)));
      let eo = lr.ZERO, Ei = lr.BASE;
      const vs = 1 + (nr ? 128 / kn : 256 / kn), vi = 2 ** (kn - 1), xi = BigInt(2 ** kn - 1), Lr = 2 ** kn, dn = BigInt(kn);
      for (let xn = 0; xn < vs; xn++) {
        const oi = xn * vi;
        let Yr = Number(Ii & xi);
        Ii >>= dn, Yr > vi && (Yr -= Lr, Ii += p);
        const ji = oi, Cn = oi + Math.abs(Yr) - 1, Mn = xn % 2 !== 0, B = Yr < 0;
        Yr === 0 ? Ei = Ei.add(Ir(Mn, ho[ji])) : eo = eo.add(Ir(B, ho[Cn]));
      }
      return { p: eo, f: Ei };
    }
    multiply(Ii, Gi) {
      let kn = Qi(Ii), ho, eo;
      if (nr) {
        const { k1neg: Ei, k1: vs, k2neg: vi, k2: xi } = L.splitScalar(kn);
        let { p: Lr, f: dn } = this.wNAF(vs, Gi), { p: xn, f: oi } = this.wNAF(xi, Gi);
        Lr = Ir(Ei, Lr), xn = Ir(vi, xn), xn = new lr(wi(xn.x * L.beta), xn.y, xn.z), ho = Lr.add(xn), eo = dn.add(oi);
      } else {
        const { p: Ei, f: vs } = this.wNAF(kn, Gi);
        ho = Ei, eo = vs;
      }
      return lr.normalizeZ([ho, eo])[0];
    }
    toAffine(Ii) {
      const { x: Gi, y: kn, z: ho } = this, eo = this.equals(lr.ZERO);
      Ii == null && (Ii = eo ? b : pi(ho));
      const Ei = Ii, vs = wi(Ei * Ei), vi = wi(vs * Ei), xi = wi(Gi * vs), Lr = wi(kn * vi), dn = wi(ho * Ei);
      if (eo)
        return kr.ZERO;
      if (dn !== p)
        throw new Error("invZ was invalid");
      return new kr(xi, Lr);
    }
  }
  lr.BASE = new lr(F.Gx, F.Gy, p), lr.ZERO = new lr(u, p, u);
  function Ir(hi, Ii) {
    const Gi = Ii.negate();
    return hi ? Gi : Ii;
  }
  const xr = /* @__PURE__ */ new WeakMap();
  class kr {
    constructor(Ii, Gi) {
      this.x = Ii, this.y = Gi;
    }
    _setWindowSize(Ii) {
      this._WINDOW_SIZE = Ii, xr.delete(this);
    }
    hasEvenY() {
      return this.y % a === u;
    }
    static fromCompressedHex(Ii) {
      const Gi = Ii.length === 32, kn = ui(Gi ? Ii : Ii.subarray(1));
      if (!Er(kn))
        throw new Error("Point is not on curve");
      const ho = Pe(kn);
      let eo = mn(ho);
      const Ei = (eo & p) === p;
      Gi ? Ei && (eo = wi(-eo)) : (Ii[0] & 1) === 1 !== Ei && (eo = wi(-eo));
      const vs = new kr(kn, eo);
      return vs.assertValidity(), vs;
    }
    static fromUncompressedHex(Ii) {
      const Gi = ui(Ii.subarray(1, pe + 1)), kn = ui(Ii.subarray(pe + 1, pe * 2 + 1)), ho = new kr(Gi, kn);
      return ho.assertValidity(), ho;
    }
    static fromHex(Ii) {
      const Gi = Li(Ii), kn = Gi.length, ho = Gi[0];
      if (kn === pe)
        return this.fromCompressedHex(Gi);
      if (kn === be && (ho === 2 || ho === 3))
        return this.fromCompressedHex(Gi);
      if (kn === He && ho === 4)
        return this.fromUncompressedHex(Gi);
      throw new Error(`Point.fromHex: received invalid point. Expected 32-${be} compressed bytes or ${He} uncompressed bytes, not ${kn}`);
    }
    static fromPrivateKey(Ii) {
      return kr.BASE.multiply(_n(Ii));
    }
    static fromSignature(Ii, Gi, kn) {
      const { r: ho, s: eo } = so(Gi);
      if (![0, 1, 2, 3].includes(kn))
        throw new Error("Cannot recover: invalid recovery bit");
      const Ei = qr(Li(Ii)), { n: vs } = F, vi = kn === 2 || kn === 3 ? ho + vs : ho, xi = pi(vi, vs), Lr = wi(-Ei * xi, vs), dn = wi(eo * xi, vs), xn = kn & 1 ? "03" : "02", oi = kr.fromHex(xn + Te(vi)), Yr = kr.BASE.multiplyAndAddUnsafe(oi, Lr, dn);
      if (!Yr)
        throw new Error("Cannot recover signature: point at infinify");
      return Yr.assertValidity(), Yr;
    }
    toRawBytes(Ii = !1) {
      return Or(this.toHex(Ii));
    }
    toHex(Ii = !1) {
      const Gi = Te(this.x);
      return Ii ? `${this.hasEvenY() ? "02" : "03"}${Gi}` : `04${Gi}${Te(this.y)}`;
    }
    toHexX() {
      return this.toHex(!0).slice(2);
    }
    toRawX() {
      return this.toRawBytes(!0).slice(1);
    }
    assertValidity() {
      const Ii = "Point is not on elliptic curve", { x: Gi, y: kn } = this;
      if (!Er(Gi) || !Er(kn))
        throw new Error(Ii);
      const ho = wi(kn * kn), eo = Pe(Gi);
      if (wi(ho - eo) !== u)
        throw new Error(Ii);
    }
    equals(Ii) {
      return this.x === Ii.x && this.y === Ii.y;
    }
    negate() {
      return new kr(this.x, wi(-this.y));
    }
    double() {
      return lr.fromAffine(this).double().toAffine();
    }
    add(Ii) {
      return lr.fromAffine(this).add(lr.fromAffine(Ii)).toAffine();
    }
    subtract(Ii) {
      return this.add(Ii.negate());
    }
    multiply(Ii) {
      return lr.fromAffine(this).multiply(Ii, this).toAffine();
    }
    multiplyAndAddUnsafe(Ii, Gi, kn) {
      const ho = lr.fromAffine(this), eo = Gi === u || Gi === p || this !== kr.BASE ? ho.multiplyUnsafe(Gi) : ho.multiply(Gi), Ei = lr.fromAffine(Ii).multiplyUnsafe(kn), vs = eo.add(Ei);
      return vs.equals(lr.ZERO) ? void 0 : vs.toAffine();
    }
  }
  n.Point = kr, kr.BASE = new kr(F.Gx, F.Gy), kr.ZERO = new kr(u, u);
  function Ce(hi) {
    return Number.parseInt(hi[0], 16) >= 8 ? "00" + hi : hi;
  }
  function tr(hi) {
    if (hi.length < 2 || hi[0] !== 2)
      throw new Error(`Invalid signature integer tag: ${ar(hi)}`);
    const Ii = hi[1], Gi = hi.subarray(2, Ii + 2);
    if (!Ii || Gi.length !== Ii)
      throw new Error("Invalid signature integer: wrong length");
    if (Gi[0] === 0 && Gi[1] <= 127)
      throw new Error("Invalid signature integer: trailing length");
    return { data: ui(Gi), left: hi.subarray(Ii + 2) };
  }
  function Fe(hi) {
    if (hi.length < 2 || hi[0] != 48)
      throw new Error(`Invalid signature tag: ${ar(hi)}`);
    if (hi[1] !== hi.length - 2)
      throw new Error("Invalid signature: incorrect length");
    const { data: Ii, left: Gi } = tr(hi.subarray(2)), { data: kn, left: ho } = tr(Gi);
    if (ho.length)
      throw new Error(`Invalid signature: left bytes after parsing: ${ar(ho)}`);
    return { r: Ii, s: kn };
  }
  class Sr {
    constructor(Ii, Gi) {
      this.r = Ii, this.s = Gi, this.assertValidity();
    }
    static fromCompact(Ii) {
      const Gi = er(Ii), kn = "Signature.fromCompact";
      if (typeof Ii != "string" && !Gi)
        throw new TypeError(`${kn}: Expected string or Uint8Array`);
      const ho = Gi ? ar(Ii) : Ii;
      if (ho.length !== 128)
        throw new Error(`${kn}: Expected 64-byte hex`);
      return new Sr(si(ho.slice(0, 64)), si(ho.slice(64, 128)));
    }
    static fromDER(Ii) {
      const Gi = er(Ii);
      if (typeof Ii != "string" && !Gi)
        throw new TypeError("Signature.fromDER: Expected string or Uint8Array");
      const { r: kn, s: ho } = Fe(Gi ? Ii : Or(Ii));
      return new Sr(kn, ho);
    }
    static fromHex(Ii) {
      return this.fromDER(Ii);
    }
    assertValidity() {
      const { r: Ii, s: Gi } = this;
      if (!_i(Ii))
        throw new Error("Invalid Signature: r must be 0 < r < n");
      if (!_i(Gi))
        throw new Error("Invalid Signature: s must be 0 < s < n");
    }
    hasHighS() {
      const Ii = F.n >> p;
      return this.s > Ii;
    }
    normalizeS() {
      return this.hasHighS() ? new Sr(this.r, wi(-this.s, F.n)) : this;
    }
    toDERRawBytes() {
      return Or(this.toDERHex());
    }
    toDERHex() {
      const Ii = Ce(Hr(this.s)), Gi = Ce(Hr(this.r)), kn = Ii.length / 2, ho = Gi.length / 2, eo = Hr(kn), Ei = Hr(ho);
      return `30${Hr(ho + kn + 4)}02${Ei}${Gi}02${eo}${Ii}`;
    }
    toRawBytes() {
      return this.toDERRawBytes();
    }
    toHex() {
      return this.toDERHex();
    }
    toCompactRawBytes() {
      return Or(this.toCompactHex());
    }
    toCompactHex() {
      return Te(this.r) + Te(this.s);
    }
  }
  n.Signature = Sr;
  function er(hi) {
    return hi instanceof Uint8Array || ArrayBuffer.isView(hi) && hi.constructor.name === "Uint8Array";
  }
  function Ie(hi) {
    if (!er(hi))
      throw new Error("Uint8Array expected");
  }
  function xe(...hi) {
    if (hi.every(Ie), hi.length === 1)
      return hi[0];
    const Ii = hi.reduce((kn, ho) => kn + ho.length, 0), Gi = new Uint8Array(Ii);
    for (let kn = 0, ho = 0; kn < hi.length; kn++) {
      const eo = hi[kn];
      Gi.set(eo, ho), ho += eo.length;
    }
    return Gi;
  }
  const rr = Array.from({ length: 256 }, (hi, Ii) => Ii.toString(16).padStart(2, "0"));
  function ar(hi) {
    Ie(hi);
    let Ii = "";
    for (let Gi = 0; Gi < hi.length; Gi++)
      Ii += rr[hi[Gi]];
    return Ii;
  }
  n.bytesToHex = ar;
  const yr = { _0: 48, _9: 57, A: 65, F: 70, a: 97, f: 102 };
  function _r(hi) {
    if (hi >= yr._0 && hi <= yr._9)
      return hi - yr._0;
    if (hi >= yr.A && hi <= yr.F)
      return hi - (yr.A - 10);
    if (hi >= yr.a && hi <= yr.f)
      return hi - (yr.a - 10);
  }
  function Or(hi) {
    if (typeof hi != "string")
      throw new Error("hex string expected, got " + typeof hi);
    const Ii = hi.length, Gi = Ii / 2;
    if (Ii % 2)
      throw new Error("hex string expected, got unpadded hex of length " + Ii);
    const kn = new Uint8Array(Gi);
    for (let ho = 0, eo = 0; ho < Gi; ho++, eo += 2) {
      const Ei = _r(hi.charCodeAt(eo)), vs = _r(hi.charCodeAt(eo + 1));
      if (Ei === void 0 || vs === void 0) {
        const vi = hi[eo] + hi[eo + 1];
        throw new Error('hex string expected, got non-hex character "' + vi + '" at index ' + eo);
      }
      kn[ho] = Ei * 16 + vs;
    }
    return kn;
  }
  n.hexToBytes = Or;
  const vr = BigInt("0x10000000000000000000000000000000000000000000000000000000000000000");
  function Te(hi) {
    if (typeof hi != "bigint")
      throw new Error("Expected bigint");
    if (!(u <= hi && hi < vr))
      throw new Error("Expected number 0 <= n < 2^256");
    return hi.toString(16).padStart(64, "0");
  }
  function Cr(hi) {
    const Ii = Or(Te(hi));
    if (Ii.length !== 32)
      throw new Error("Error: expected 32 bytes");
    return Ii;
  }
  function Hr(hi) {
    const Ii = hi.toString(16);
    return Ii.length & 1 ? `0${Ii}` : Ii;
  }
  function si(hi) {
    if (typeof hi != "string")
      throw new TypeError("hexToNumber: expected string, got " + typeof hi);
    return BigInt(`0x${hi}`);
  }
  function ui(hi) {
    return si(ar(hi));
  }
  function Li(hi) {
    return er(hi) ? Uint8Array.from(hi) : Or(hi);
  }
  function Qi(hi) {
    if (typeof hi == "number" && Number.isSafeInteger(hi) && hi > 0)
      return BigInt(hi);
    if (typeof hi == "bigint" && _i(hi))
      return hi;
    throw new TypeError("Expected valid private scalar: 0 < scalar < curve.n");
  }
  function wi(hi, Ii = F.P) {
    const Gi = hi % Ii;
    return Gi >= u ? Gi : Ii + Gi;
  }
  function Ji(hi, Ii) {
    const { P: Gi } = F;
    let kn = hi;
    for (; Ii-- > u; )
      kn *= kn, kn %= Gi;
    return kn;
  }
  function mn(hi) {
    const { P: Ii } = F, Gi = BigInt(6), kn = BigInt(11), ho = BigInt(22), eo = BigInt(23), Ei = BigInt(44), vs = BigInt(88), vi = hi * hi * hi % Ii, xi = vi * vi * hi % Ii, Lr = Ji(xi, A) * xi % Ii, dn = Ji(Lr, A) * xi % Ii, xn = Ji(dn, a) * vi % Ii, oi = Ji(xn, kn) * xn % Ii, Yr = Ji(oi, ho) * oi % Ii, ji = Ji(Yr, Ei) * Yr % Ii, Cn = Ji(ji, vs) * ji % Ii, Mn = Ji(Cn, Ei) * Yr % Ii, B = Ji(Mn, A) * xi % Ii, o = Ji(B, eo) * oi % Ii, m = Ji(o, Gi) * vi % Ii, d = Ji(m, a);
    if (d * d % Ii !== hi)
      throw new Error("Cannot find square root");
    return d;
  }
  function pi(hi, Ii = F.P) {
    if (hi === u || Ii <= u)
      throw new Error(`invert: expected positive integers, got n=${hi} mod=${Ii}`);
    let Gi = wi(hi, Ii), kn = Ii, ho = u, eo = p;
    for (; Gi !== u; ) {
      const vs = kn / Gi, vi = kn % Gi, xi = ho - eo * vs;
      kn = Gi, Gi = vi, ho = eo, eo = xi;
    }
    if (kn !== p)
      throw new Error("invert: does not exist");
    return wi(ho, Ii);
  }
  function ei(hi, Ii = F.P) {
    const Gi = new Array(hi.length), kn = hi.reduce((eo, Ei, vs) => Ei === u ? eo : (Gi[vs] = eo, wi(eo * Ei, Ii)), p), ho = pi(kn, Ii);
    return hi.reduceRight((eo, Ei, vs) => Ei === u ? eo : (Gi[vs] = wi(eo * Gi[vs], Ii), wi(eo * Ei, Ii)), ho), Gi;
  }
  function Vr(hi) {
    const Ii = hi.length * 8 - $ * 8, Gi = ui(hi);
    return Ii > 0 ? Gi >> BigInt(Ii) : Gi;
  }
  function qr(hi, Ii = !1) {
    const Gi = Vr(hi);
    if (Ii)
      return Gi;
    const { n: kn } = F;
    return Gi >= kn ? Gi - kn : Gi;
  }
  let Zi, Wr;
  class ri {
    constructor(Ii, Gi) {
      if (this.hashLen = Ii, this.qByteLen = Gi, typeof Ii != "number" || Ii < 2)
        throw new Error("hashLen must be a number");
      if (typeof Gi != "number" || Gi < 2)
        throw new Error("qByteLen must be a number");
      this.v = new Uint8Array(Ii).fill(1), this.k = new Uint8Array(Ii).fill(0), this.counter = 0;
    }
    hmac(...Ii) {
      return n.utils.hmacSha256(this.k, ...Ii);
    }
    hmacSync(...Ii) {
      return Wr(this.k, ...Ii);
    }
    checkSync() {
      if (typeof Wr != "function")
        throw new ir("hmacSha256Sync needs to be set");
    }
    incr() {
      if (this.counter >= 1e3)
        throw new Error("Tried 1,000 k values for sign(), all were invalid");
      this.counter += 1;
    }
    async reseed(Ii = new Uint8Array()) {
      this.k = await this.hmac(this.v, Uint8Array.from([0]), Ii), this.v = await this.hmac(this.v), Ii.length !== 0 && (this.k = await this.hmac(this.v, Uint8Array.from([1]), Ii), this.v = await this.hmac(this.v));
    }
    reseedSync(Ii = new Uint8Array()) {
      this.checkSync(), this.k = this.hmacSync(this.v, Uint8Array.from([0]), Ii), this.v = this.hmacSync(this.v), Ii.length !== 0 && (this.k = this.hmacSync(this.v, Uint8Array.from([1]), Ii), this.v = this.hmacSync(this.v));
    }
    async generate() {
      this.incr();
      let Ii = 0;
      const Gi = [];
      for (; Ii < this.qByteLen; ) {
        this.v = await this.hmac(this.v);
        const kn = this.v.slice();
        Gi.push(kn), Ii += this.v.length;
      }
      return xe(...Gi);
    }
    generateSync() {
      this.checkSync(), this.incr();
      let Ii = 0;
      const Gi = [];
      for (; Ii < this.qByteLen; ) {
        this.v = this.hmacSync(this.v);
        const kn = this.v.slice();
        Gi.push(kn), Ii += this.v.length;
      }
      return xe(...Gi);
    }
  }
  function _i(hi) {
    return u < hi && hi < F.n;
  }
  function Er(hi) {
    return u < hi && hi < F.P;
  }
  function Di(hi, Ii, Gi, kn = !0) {
    const { n: ho } = F, eo = qr(hi, !0);
    if (!_i(eo))
      return;
    const Ei = pi(eo, ho), vs = kr.BASE.multiply(eo), vi = wi(vs.x, ho);
    if (vi === u)
      return;
    const xi = wi(Ei * wi(Ii + Gi * vi, ho), ho);
    if (xi === u)
      return;
    let Lr = new Sr(vi, xi), dn = (vs.x === Lr.r ? 0 : 2) | Number(vs.y & p);
    return kn && Lr.hasHighS() && (Lr = Lr.normalizeS(), dn ^= 1), { sig: Lr, recovery: dn };
  }
  function _n(hi) {
    let Ii;
    if (typeof hi == "bigint")
      Ii = hi;
    else if (typeof hi == "number" && Number.isSafeInteger(hi) && hi > 0)
      Ii = BigInt(hi);
    else if (typeof hi == "string") {
      if (hi.length !== 2 * $)
        throw new Error("Expected 32 bytes of private key");
      Ii = si(hi);
    } else if (er(hi)) {
      if (hi.length !== $)
        throw new Error("Expected 32 bytes of private key");
      Ii = ui(hi);
    } else
      throw new TypeError("Expected valid private key");
    if (!_i(Ii))
      throw new Error("Expected private key: 0 < key < n");
    return Ii;
  }
  function On(hi) {
    return hi instanceof kr ? (hi.assertValidity(), hi) : kr.fromHex(hi);
  }
  function so(hi) {
    if (hi instanceof Sr)
      return hi.assertValidity(), hi;
    try {
      return Sr.fromDER(hi);
    } catch {
      return Sr.fromCompact(hi);
    }
  }
  function Do(hi, Ii = !1) {
    return kr.fromPrivateKey(hi).toRawBytes(Ii);
  }
  n.getPublicKey = Do;
  function gn(hi, Ii, Gi, kn = !1) {
    return kr.fromSignature(hi, Ii, Gi).toRawBytes(kn);
  }
  n.recoverPublicKey = gn;
  function Gn(hi) {
    const Ii = er(hi), Gi = typeof hi == "string", kn = (Ii || Gi) && hi.length;
    return Ii ? kn === be || kn === He : Gi ? kn === be * 2 || kn === He * 2 : hi instanceof kr;
  }
  function pn(hi, Ii, Gi = !1) {
    if (Gn(hi))
      throw new TypeError("getSharedSecret: first arg must be private key");
    if (!Gn(Ii))
      throw new TypeError("getSharedSecret: second arg must be public key");
    const kn = On(Ii);
    return kn.assertValidity(), kn.multiply(_n(hi)).toRawBytes(Gi);
  }
  n.getSharedSecret = pn;
  function hn(hi) {
    const Ii = hi.length > pe ? hi.slice(0, pe) : hi;
    return ui(Ii);
  }
  function Rn(hi) {
    const Ii = hn(hi), Gi = wi(Ii, F.n);
    return vo(Gi < u ? Ii : Gi);
  }
  function vo(hi) {
    return Cr(hi);
  }
  function Hi(hi, Ii, Gi) {
    if (hi == null)
      throw new Error(`sign: expected valid message hash, not "${hi}"`);
    const kn = Li(hi), ho = _n(Ii), eo = [vo(ho), Rn(kn)];
    if (Gi != null) {
      Gi === !0 && (Gi = n.utils.randomBytes(pe));
      const vi = Li(Gi);
      if (vi.length !== pe)
        throw new Error(`sign: Expected ${pe} bytes of extra data`);
      eo.push(vi);
    }
    const Ei = xe(...eo), vs = hn(kn);
    return { seed: Ei, m: vs, d: ho };
  }
  function di(hi, Ii) {
    const { sig: Gi, recovery: kn } = hi, { der: ho, recovered: eo } = Object.assign({ canonical: !0, der: !0 }, Ii), Ei = ho ? Gi.toDERRawBytes() : Gi.toCompactRawBytes();
    return eo ? [Ei, kn] : Ei;
  }
  async function Ui(hi, Ii, Gi = {}) {
    const { seed: kn, m: ho, d: eo } = Hi(hi, Ii, Gi.extraEntropy), Ei = new ri(Ee, $);
    await Ei.reseed(kn);
    let vs;
    for (; !(vs = Di(await Ei.generate(), ho, eo, Gi.canonical)); )
      await Ei.reseed();
    return di(vs, Gi);
  }
  n.sign = Ui;
  function ln(hi, Ii, Gi = {}) {
    const { seed: kn, m: ho, d: eo } = Hi(hi, Ii, Gi.extraEntropy), Ei = new ri(Ee, $);
    Ei.reseedSync(kn);
    let vs;
    for (; !(vs = Di(Ei.generateSync(), ho, eo, Gi.canonical)); )
      Ei.reseedSync();
    return di(vs, Gi);
  }
  n.signSync = ln;
  const Un = { strict: !0 };
  function Bo(hi, Ii, Gi, kn = Un) {
    let ho;
    try {
      ho = so(hi), Ii = Li(Ii);
    } catch {
      return !1;
    }
    const { r: eo, s: Ei } = ho;
    if (kn.strict && ho.hasHighS())
      return !1;
    const vs = qr(Ii);
    let vi;
    try {
      vi = On(Gi);
    } catch {
      return !1;
    }
    const { n: xi } = F, Lr = pi(Ei, xi), dn = wi(vs * Lr, xi), xn = wi(eo * Lr, xi), oi = kr.BASE.multiplyAndAddUnsafe(vi, dn, xn);
    return oi ? wi(oi.x, xi) === eo : !1;
  }
  n.verify = Bo;
  function co(hi) {
    return wi(ui(hi), F.n);
  }
  class To {
    constructor(Ii, Gi) {
      this.r = Ii, this.s = Gi, this.assertValidity();
    }
    static fromHex(Ii) {
      const Gi = Li(Ii);
      if (Gi.length !== 64)
        throw new TypeError(`SchnorrSignature.fromHex: expected 64 bytes, not ${Gi.length}`);
      const kn = ui(Gi.subarray(0, 32)), ho = ui(Gi.subarray(32, 64));
      return new To(kn, ho);
    }
    assertValidity() {
      const { r: Ii, s: Gi } = this;
      if (!Er(Ii) || !_i(Gi))
        throw new Error("Invalid signature");
    }
    toHex() {
      return Te(this.r) + Te(this.s);
    }
    toRawBytes() {
      return Or(this.toHex());
    }
  }
  function xs(hi) {
    return kr.fromPrivateKey(hi).toRawX();
  }
  class Fo {
    constructor(Ii, Gi, kn = n.utils.randomBytes()) {
      if (Ii == null)
        throw new TypeError(`sign: Expected valid message, not "${Ii}"`);
      this.m = Li(Ii);
      const { x: ho, scalar: eo } = this.getScalar(_n(Gi));
      if (this.px = ho, this.d = eo, this.rand = Li(kn), this.rand.length !== 32)
        throw new TypeError("sign: Expected 32 bytes of aux randomness");
    }
    getScalar(Ii) {
      const Gi = kr.fromPrivateKey(Ii), kn = Gi.hasEvenY() ? Ii : F.n - Ii;
      return { point: Gi, scalar: kn, x: Gi.toRawX() };
    }
    initNonce(Ii, Gi) {
      return Cr(Ii ^ ui(Gi));
    }
    finalizeNonce(Ii) {
      const Gi = wi(ui(Ii), F.n);
      if (Gi === u)
        throw new Error("sign: Creation of signature failed. k is zero");
      const { point: kn, x: ho, scalar: eo } = this.getScalar(Gi);
      return { R: kn, rx: ho, k: eo };
    }
    finalizeSig(Ii, Gi, kn, ho) {
      return new To(Ii.x, wi(Gi + kn * ho, F.n)).toRawBytes();
    }
    error() {
      throw new Error("sign: Invalid signature produced");
    }
    async calc() {
      const { m: Ii, d: Gi, px: kn, rand: ho } = this, eo = n.utils.taggedHash, Ei = this.initNonce(Gi, await eo(da.aux, ho)), { R: vs, rx: vi, k: xi } = this.finalizeNonce(await eo(da.nonce, Ei, kn, Ii)), Lr = co(await eo(da.challenge, vi, kn, Ii)), dn = this.finalizeSig(vs, xi, Lr, Gi);
      return await na(dn, Ii, kn) || this.error(), dn;
    }
    calcSync() {
      const { m: Ii, d: Gi, px: kn, rand: ho } = this, eo = n.utils.taggedHashSync, Ei = this.initNonce(Gi, eo(da.aux, ho)), { R: vs, rx: vi, k: xi } = this.finalizeNonce(eo(da.nonce, Ei, kn, Ii)), Lr = co(eo(da.challenge, vi, kn, Ii)), dn = this.finalizeSig(vs, xi, Lr, Gi);
      return os(dn, Ii, kn) || this.error(), dn;
    }
  }
  async function Zo(hi, Ii, Gi) {
    return new Fo(hi, Ii, Gi).calc();
  }
  function $s(hi, Ii, Gi) {
    return new Fo(hi, Ii, Gi).calcSync();
  }
  function rs(hi, Ii, Gi) {
    const kn = hi instanceof To, ho = kn ? hi : To.fromHex(hi);
    return kn && ho.assertValidity(), {
      ...ho,
      m: Li(Ii),
      P: On(Gi)
    };
  }
  function ls(hi, Ii, Gi, kn) {
    const ho = kr.BASE.multiplyAndAddUnsafe(Ii, _n(Gi), wi(-kn, F.n));
    return !(!ho || !ho.hasEvenY() || ho.x !== hi);
  }
  async function na(hi, Ii, Gi) {
    try {
      const { r: kn, s: ho, m: eo, P: Ei } = rs(hi, Ii, Gi), vs = co(await n.utils.taggedHash(da.challenge, Cr(kn), Ei.toRawX(), eo));
      return ls(kn, Ei, ho, vs);
    } catch {
      return !1;
    }
  }
  function os(hi, Ii, Gi) {
    try {
      const { r: kn, s: ho, m: eo, P: Ei } = rs(hi, Ii, Gi), vs = co(n.utils.taggedHashSync(da.challenge, Cr(kn), Ei.toRawX(), eo));
      return ls(kn, Ei, ho, vs);
    } catch (kn) {
      if (kn instanceof ir)
        throw kn;
      return !1;
    }
  }
  n.schnorr = {
    Signature: To,
    getPublicKey: xs,
    sign: Zo,
    verify: na,
    signSync: $s,
    verifySync: os
  }, kr.BASE._setWindowSize(8);
  const fs = {
    node: c,
    web: typeof self == "object" && "crypto" in self ? self.crypto : void 0
  }, da = {
    challenge: "BIP0340/challenge",
    aux: "BIP0340/aux",
    nonce: "BIP0340/nonce"
  }, Bn = {};
  n.utils = {
    bytesToHex: ar,
    hexToBytes: Or,
    concatBytes: xe,
    mod: wi,
    invert: pi,
    isValidPrivateKey(hi) {
      try {
        return _n(hi), !0;
      } catch {
        return !1;
      }
    },
    _bigintTo32Bytes: Cr,
    _normalizePrivateKey: _n,
    hashToPrivateKey: (hi) => {
      hi = Li(hi);
      const Ii = $ + 8;
      if (hi.length < Ii || hi.length > 1024)
        throw new Error("Expected valid bytes of private key as per FIPS 186");
      const Gi = wi(ui(hi), F.n - p) + p;
      return Cr(Gi);
    },
    randomBytes: (hi = 32) => {
      if (fs.web)
        return fs.web.getRandomValues(new Uint8Array(hi));
      if (fs.node) {
        const { randomBytes: Ii } = fs.node;
        return Uint8Array.from(Ii(hi));
      } else
        throw new Error("The environment doesn't have randomBytes function");
    },
    randomPrivateKey: () => n.utils.hashToPrivateKey(n.utils.randomBytes($ + 8)),
    precompute(hi = 8, Ii = kr.BASE) {
      const Gi = Ii === kr.BASE ? Ii : new kr(Ii.x, Ii.y);
      return Gi._setWindowSize(hi), Gi.multiply(A), Gi;
    },
    sha256: async (...hi) => {
      if (fs.web) {
        const Ii = await fs.web.subtle.digest("SHA-256", xe(...hi));
        return new Uint8Array(Ii);
      } else if (fs.node) {
        const { createHash: Ii } = fs.node, Gi = Ii("sha256");
        return hi.forEach((kn) => Gi.update(kn)), Uint8Array.from(Gi.digest());
      } else
        throw new Error("The environment doesn't have sha256 function");
    },
    hmacSha256: async (hi, ...Ii) => {
      if (fs.web) {
        const Gi = await fs.web.subtle.importKey("raw", hi, { name: "HMAC", hash: { name: "SHA-256" } }, !1, ["sign"]), kn = xe(...Ii), ho = await fs.web.subtle.sign("HMAC", Gi, kn);
        return new Uint8Array(ho);
      } else if (fs.node) {
        const { createHmac: Gi } = fs.node, kn = Gi("sha256", hi);
        return Ii.forEach((ho) => kn.update(ho)), Uint8Array.from(kn.digest());
      } else
        throw new Error("The environment doesn't have hmac-sha256 function");
    },
    sha256Sync: void 0,
    hmacSha256Sync: void 0,
    taggedHash: async (hi, ...Ii) => {
      let Gi = Bn[hi];
      if (Gi === void 0) {
        const kn = await n.utils.sha256(Uint8Array.from(hi, (ho) => ho.charCodeAt(0)));
        Gi = xe(kn, kn), Bn[hi] = Gi;
      }
      return n.utils.sha256(Gi, ...Ii);
    },
    taggedHashSync: (hi, ...Ii) => {
      if (typeof Zi != "function")
        throw new ir("sha256Sync is undefined, you need to set it");
      let Gi = Bn[hi];
      if (Gi === void 0) {
        const kn = Zi(Uint8Array.from(hi, (ho) => ho.charCodeAt(0)));
        Gi = xe(kn, kn), Bn[hi] = Gi;
      }
      return Zi(Gi, ...Ii);
    },
    _JacobianPoint: lr
  }, Object.defineProperties(n.utils, {
    sha256Sync: {
      configurable: !1,
      get() {
        return Zi;
      },
      set(hi) {
        Zi || (Zi = hi);
      }
    },
    hmacSha256Sync: {
      configurable: !1,
      get() {
        return Wr;
      },
      set(hi) {
        Wr || (Wr = hi);
      }
    }
  });
})(lib);
var ecdsaSigFormatter = {};
Object.defineProperty(ecdsaSigFormatter, "__esModule", { value: !0 });
ecdsaSigFormatter.joseToDer = ecdsaSigFormatter.derToJose = void 0;
const base64_js_1 = base64Js, base64Url_1 = base64Url;
function getParamSize(n) {
  return (n / 8 | 0) + (n % 8 === 0 ? 0 : 1);
}
const paramBytesForAlg = {
  ES256: getParamSize(256),
  ES384: getParamSize(384),
  ES512: getParamSize(521)
};
function getParamBytesForAlg(n) {
  const c = paramBytesForAlg[n];
  if (c)
    return c;
  throw new Error(`Unknown algorithm "${n}"`);
}
const MAX_OCTET = 128, CLASS_UNIVERSAL = 0, PRIMITIVE_BIT = 32, TAG_SEQ = 16, TAG_INT = 2, ENCODED_TAG_SEQ = TAG_SEQ | PRIMITIVE_BIT | CLASS_UNIVERSAL << 6, ENCODED_TAG_INT = TAG_INT | CLASS_UNIVERSAL << 6;
function signatureAsBytes(n) {
  if (n instanceof Uint8Array)
    return n;
  if (typeof n == "string")
    return (0, base64_js_1.toByteArray)((0, base64Url_1.pad)(n));
  throw new TypeError("ECDSA signature must be a Base64 string or a Uint8Array");
}
function derToJose(n, c) {
  const u = signatureAsBytes(n), p = getParamBytesForAlg(c), a = p + 1, A = u.length;
  let b = 0;
  if (u[b++] !== ENCODED_TAG_SEQ)
    throw new Error('Could not find expected "seq"');
  let F = u[b++];
  if (F === (MAX_OCTET | 1) && (F = u[b++]), A - b < F)
    throw new Error(`"seq" specified length of "${F}", only "${A - b}" remaining`);
  if (u[b++] !== ENCODED_TAG_INT)
    throw new Error('Could not find expected "int" for "r"');
  const le = u[b++];
  if (A - b - 2 < le)
    throw new Error(`"r" specified length of "${le}", only "${A - b - 2}" available`);
  if (a < le)
    throw new Error(`"r" specified length of "${le}", max of "${a}" is acceptable`);
  const L = b;
  if (b += le, u[b++] !== ENCODED_TAG_INT)
    throw new Error('Could not find expected "int" for "s"');
  const pe = u[b++];
  if (A - b !== pe)
    throw new Error(`"s" specified length of "${pe}", expected "${A - b}"`);
  if (a < pe)
    throw new Error(`"s" specified length of "${pe}", max of "${a}" is acceptable`);
  const $ = b;
  if (b += pe, b !== A)
    throw new Error(`Expected to consume entire array, but "${A - b}" bytes remain`);
  const Ee = p - le, be = p - pe, He = new Uint8Array(Ee + le + be + pe);
  for (b = 0; b < Ee; ++b)
    He[b] = 0;
  He.set(u.subarray(L + Math.max(-Ee, 0), L + le), b), b = p;
  for (const Pe = b; b < Pe + be; ++b)
    He[b] = 0;
  return He.set(u.subarray($ + Math.max(-be, 0), $ + pe), b), (0, base64Url_1.escape)((0, base64_js_1.fromByteArray)(He));
}
ecdsaSigFormatter.derToJose = derToJose;
function countPadding(n, c, u) {
  let p = 0;
  for (; c + p < u && n[c + p] === 0; )
    ++p;
  return n[c + p] >= MAX_OCTET && --p, p;
}
function joseToDer(n, c) {
  n = signatureAsBytes(n);
  const u = getParamBytesForAlg(c), p = n.length;
  if (p !== u * 2)
    throw new TypeError(`"${c}" signatures must be "${u * 2}" bytes, saw "${p}"`);
  const a = countPadding(n, 0, u), A = countPadding(n, u, n.length), b = u - a, F = u - A, le = 2 + b + 1 + 1 + F, L = le < MAX_OCTET, pe = new Uint8Array((L ? 2 : 3) + le);
  let $ = 0;
  return pe[$++] = ENCODED_TAG_SEQ, L ? pe[$++] = le : (pe[$++] = MAX_OCTET | 1, pe[$++] = le & 255), pe[$++] = ENCODED_TAG_INT, pe[$++] = b, a < 0 ? (pe[$++] = 0, pe.set(n.subarray(0, u), $), $ += u) : (pe.set(n.subarray(a, u), $), $ += u - a), pe[$++] = ENCODED_TAG_INT, pe[$++] = F, A < 0 ? (pe[$++] = 0, pe.set(n.subarray(u), $)) : pe.set(n.subarray(u + A), $), pe;
}
ecdsaSigFormatter.joseToDer = joseToDer;
var errors = {};
Object.defineProperty(errors, "__esModule", { value: !0 });
errors.InvalidTokenError = errors.MissingParametersError = void 0;
class MissingParametersError extends Error {
  constructor(c) {
    super(), this.name = "MissingParametersError", this.message = c || "";
  }
}
errors.MissingParametersError = MissingParametersError;
class InvalidTokenError extends Error {
  constructor(c) {
    super(), this.name = "InvalidTokenError", this.message = c || "";
  }
}
errors.InvalidTokenError = InvalidTokenError;
Object.defineProperty(secp256k1$5, "__esModule", { value: !0 });
secp256k1$5.SECP256K1Client = void 0;
const hmac_1$1 = hmac$6, sha256_1$6 = sha256$g, secp = lib, ecdsaSigFormatter_1 = ecdsaSigFormatter, errors_1$2 = errors, utils_1$5 = utils$O;
secp.utils.hmacSha256Sync = (n, ...c) => {
  const u = hmac_1$1.hmac.create(sha256_1$6.sha256, n);
  return c.forEach((p) => u.update(p)), u.digest();
};
class SECP256K1Client {
  static derivePublicKey(c, u = !0) {
    return c.length === 66 && (c = c.slice(0, 64)), c.length < 64 && (c = c.padStart(64, "0")), (0, utils_1$5.bytesToHex)(secp.getPublicKey(c, u));
  }
  static signHash(c, u, p = "jose") {
    if (!c || !u)
      throw new errors_1$2.MissingParametersError("a signing input hash and private key are all required");
    const a = secp.signSync(c, u.slice(0, 64), {
      der: !0,
      canonical: !1
    });
    if (p === "der")
      return (0, utils_1$5.bytesToHex)(a);
    if (p === "jose")
      return (0, ecdsaSigFormatter_1.derToJose)(a, "ES256");
    throw Error("Invalid signature format");
  }
  static loadSignature(c) {
    return (0, ecdsaSigFormatter_1.joseToDer)(c, "ES256");
  }
  static verifyHash(c, u, p) {
    if (!c || !u || !p)
      throw new errors_1$2.MissingParametersError("a signing input hash, der signature, and public key are all required");
    return secp.verify(u, c, p, { strict: !1 });
  }
}
secp256k1$5.SECP256K1Client = SECP256K1Client;
SECP256K1Client.algorithmName = "ES256K";
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.cryptoClients = n.SECP256K1Client = void 0;
  const c = secp256k1$5;
  Object.defineProperty(n, "SECP256K1Client", { enumerable: !0, get: function() {
    return c.SECP256K1Client;
  } });
  const u = {
    ES256K: c.SECP256K1Client
  };
  n.cryptoClients = u;
})(cryptoClients);
var sha256$7 = {}, __awaiter$1 = commonjsGlobal && commonjsGlobal.__awaiter || function(n, c, u, p) {
  function a(A) {
    return A instanceof u ? A : new u(function(b) {
      b(A);
    });
  }
  return new (u || (u = Promise))(function(A, b) {
    function F(pe) {
      try {
        L(p.next(pe));
      } catch ($) {
        b($);
      }
    }
    function le(pe) {
      try {
        L(p.throw(pe));
      } catch ($) {
        b($);
      }
    }
    function L(pe) {
      pe.done ? A(pe.value) : a(pe.value).then(F, le);
    }
    L((p = p.apply(n, c || [])).next());
  });
};
Object.defineProperty(sha256$7, "__esModule", { value: !0 });
sha256$7.hashSha256Async = sha256$7.hashSha256 = void 0;
const sha256_1$5 = sha256$g;
function hashSha256(n) {
  return (0, sha256_1$5.sha256)(n);
}
sha256$7.hashSha256 = hashSha256;
function hashSha256Async(n) {
  return __awaiter$1(this, void 0, void 0, function* () {
    try {
      if (typeof crypto < "u" && typeof crypto.subtle < "u") {
        const u = typeof n == "string" ? new TextEncoder().encode(n) : n, p = yield crypto.subtle.digest("SHA-256", u);
        return new Uint8Array(p);
      } else {
        const u = requireCryptoBrowserify();
        if (!u.createHash)
          throw new Error("`crypto` module does not contain `createHash`");
        return Promise.resolve(u.createHash("sha256").update(n).digest());
      }
    } catch (c) {
      return console.log(c), console.log('Crypto lib not found. Neither the global `crypto.subtle` Web Crypto API, nor the or the Node.js `require("crypto").createHash` module is available. Falling back to JS implementation.'), Promise.resolve(hashSha256(n));
    }
  });
}
sha256$7.hashSha256Async = hashSha256Async;
var __awaiter = commonjsGlobal && commonjsGlobal.__awaiter || function(n, c, u, p) {
  function a(A) {
    return A instanceof u ? A : new u(function(b) {
      b(A);
    });
  }
  return new (u || (u = Promise))(function(A, b) {
    function F(pe) {
      try {
        L(p.next(pe));
      } catch ($) {
        b($);
      }
    }
    function le(pe) {
      try {
        L(p.throw(pe));
      } catch ($) {
        b($);
      }
    }
    function L(pe) {
      pe.done ? A(pe.value) : a(pe.value).then(F, le);
    }
    L((p = p.apply(n, c || [])).next());
  });
};
Object.defineProperty(signer, "__esModule", { value: !0 });
signer.TokenSigner = signer.createUnsecuredToken = void 0;
const base64url$2 = base64Url, cryptoClients_1$1 = cryptoClients, errors_1$1 = errors, sha256_1$4 = sha256$7;
function createSigningInput(n, c) {
  const u = [], p = base64url$2.encode(JSON.stringify(c));
  u.push(p);
  const a = base64url$2.encode(JSON.stringify(n));
  return u.push(a), u.join(".");
}
function createUnsecuredToken(n) {
  return createSigningInput(n, { typ: "JWT", alg: "none" }) + ".";
}
signer.createUnsecuredToken = createUnsecuredToken;
class TokenSigner {
  constructor(c, u) {
    if (!(c && u))
      throw new errors_1$1.MissingParametersError("a signing algorithm and private key are required");
    if (typeof c != "string")
      throw new Error("signing algorithm parameter must be a string");
    if (c = c.toUpperCase(), !cryptoClients_1$1.cryptoClients.hasOwnProperty(c))
      throw new Error("invalid signing algorithm");
    this.tokenType = "JWT", this.cryptoClient = cryptoClients_1$1.cryptoClients[c], this.rawPrivateKey = u;
  }
  header(c = {}) {
    const u = { typ: this.tokenType, alg: this.cryptoClient.algorithmName };
    return Object.assign({}, u, c);
  }
  sign(c, u = !1, p = {}) {
    const a = this.header(p), A = createSigningInput(c, a), b = (0, sha256_1$4.hashSha256)(A);
    return this.createWithSignedHash(c, u, a, A, b);
  }
  signAsync(c, u = !1, p = {}) {
    return __awaiter(this, void 0, void 0, function* () {
      const a = this.header(p), A = createSigningInput(c, a), b = yield (0, sha256_1$4.hashSha256Async)(A);
      return this.createWithSignedHash(c, u, a, A, b);
    });
  }
  createWithSignedHash(c, u, p, a, A) {
    const b = this.cryptoClient.signHash(A, this.rawPrivateKey);
    return u ? {
      header: [base64url$2.encode(JSON.stringify(p))],
      payload: JSON.stringify(c),
      signature: [b]
    } : [a, b].join(".");
  }
}
signer.TokenSigner = TokenSigner;
var verifier = {};
Object.defineProperty(verifier, "__esModule", { value: !0 });
verifier.TokenVerifier = void 0;
const base64url$1 = base64Url, cryptoClients_1 = cryptoClients, errors_1 = errors, sha256_1$3 = sha256$7;
class TokenVerifier {
  constructor(c, u) {
    if (!(c && u))
      throw new errors_1.MissingParametersError("a signing algorithm and public key are required");
    if (typeof c != "string")
      throw "signing algorithm parameter must be a string";
    if (c = c.toUpperCase(), !cryptoClients_1.cryptoClients.hasOwnProperty(c))
      throw "invalid signing algorithm";
    this.tokenType = "JWT", this.cryptoClient = cryptoClients_1.cryptoClients[c], this.rawPublicKey = u;
  }
  verify(c) {
    return typeof c == "string" ? this.verifyCompact(c, !1) : typeof c == "object" ? this.verifyExpanded(c, !1) : !1;
  }
  verifyAsync(c) {
    return typeof c == "string" ? this.verifyCompact(c, !0) : typeof c == "object" ? this.verifyExpanded(c, !0) : Promise.resolve(!1);
  }
  verifyCompact(c, u) {
    const p = c.split("."), a = p[0] + "." + p[1], A = (b) => {
      const F = this.cryptoClient.loadSignature(p[2]);
      return this.cryptoClient.verifyHash(b, F, this.rawPublicKey);
    };
    if (u)
      return (0, sha256_1$3.hashSha256Async)(a).then((b) => A(b));
    {
      const b = (0, sha256_1$3.hashSha256)(a);
      return A(b);
    }
  }
  verifyExpanded(c, u) {
    const p = [c.header.join("."), base64url$1.encode(c.payload)].join(".");
    let a = !0;
    const A = (b) => (c.signature.map((F) => {
      const le = this.cryptoClient.loadSignature(F);
      this.cryptoClient.verifyHash(b, le, this.rawPublicKey) || (a = !1);
    }), a);
    if (u)
      return (0, sha256_1$3.hashSha256Async)(p).then((b) => A(b));
    {
      const b = (0, sha256_1$3.hashSha256)(p);
      return A(b);
    }
  }
}
verifier.TokenVerifier = TokenVerifier;
var decode$a = {};
Object.defineProperty(decode$a, "__esModule", { value: !0 });
decode$a.decodeToken = void 0;
const base64url = base64Url;
function decodeToken(n) {
  if (typeof n == "string") {
    const c = n.split("."), u = JSON.parse(base64url.decode(c[0])), p = JSON.parse(base64url.decode(c[1])), a = c[2];
    return {
      header: u,
      payload: p,
      signature: a
    };
  } else if (typeof n == "object") {
    if (typeof n.payload != "string")
      throw new Error("Expected token payload to be a base64 or json string");
    let c = n.payload;
    n.payload[0] !== "{" && (c = base64url.decode(c));
    const u = [];
    return n.header.map((p) => {
      const a = JSON.parse(base64url.decode(p));
      u.push(a);
    }), {
      header: u,
      payload: JSON.parse(c),
      signature: n.signature
    };
  }
}
decode$a.decodeToken = decodeToken;
(function(n) {
  var c = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(p, a, A, b) {
    b === void 0 && (b = A);
    var F = Object.getOwnPropertyDescriptor(a, A);
    (!F || ("get" in F ? !a.__esModule : F.writable || F.configurable)) && (F = { enumerable: !0, get: function() {
      return a[A];
    } }), Object.defineProperty(p, b, F);
  } : function(p, a, A, b) {
    b === void 0 && (b = A), p[b] = a[A];
  }), u = commonjsGlobal && commonjsGlobal.__exportStar || function(p, a) {
    for (var A in p) A !== "default" && !Object.prototype.hasOwnProperty.call(a, A) && c(a, p, A);
  };
  Object.defineProperty(n, "__esModule", { value: !0 }), u(signer, n), u(verifier, n), u(decode$a, n), u(errors, n), u(cryptoClients, n);
})(lib$1);
var build$4 = {}, bip39 = {}, build$3 = {}, ascii$1 = {};
Object.defineProperty(ascii$1, "__esModule", { value: !0 });
ascii$1.fromAscii = ascii$1.toAscii = void 0;
function toAscii$1(n) {
  const c = (u) => u.split("").map((p) => {
    const a = p.charCodeAt(0);
    if (a < 32 || a > 126)
      throw new Error("Cannot encode character that is out of printable ASCII range: " + a);
    return a;
  });
  return Uint8Array.from(c(n));
}
ascii$1.toAscii = toAscii$1;
function fromAscii$1(n) {
  return ((u) => u.map((p) => {
    if (p < 32 || p > 126)
      throw new Error("Cannot decode character that is out of printable ASCII range: " + p);
    return String.fromCharCode(p);
  }))(Array.from(n)).join("");
}
ascii$1.fromAscii = fromAscii$1;
var base64$3 = {}, __createBinding$b = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(n, c, u, p) {
  p === void 0 && (p = u);
  var a = Object.getOwnPropertyDescriptor(c, u);
  (!a || ("get" in a ? !c.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
    return c[u];
  } }), Object.defineProperty(n, p, a);
} : function(n, c, u, p) {
  p === void 0 && (p = u), n[p] = c[u];
}), __setModuleDefault$b = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(n, c) {
  Object.defineProperty(n, "default", { enumerable: !0, value: c });
} : function(n, c) {
  n.default = c;
}), __importStar$b = commonjsGlobal && commonjsGlobal.__importStar || function(n) {
  if (n && n.__esModule) return n;
  var c = {};
  if (n != null) for (var u in n) u !== "default" && Object.prototype.hasOwnProperty.call(n, u) && __createBinding$b(c, n, u);
  return __setModuleDefault$b(c, n), c;
};
Object.defineProperty(base64$3, "__esModule", { value: !0 });
base64$3.fromBase64 = base64$3.toBase64 = void 0;
const base64js$1 = __importStar$b(base64Js);
function toBase64$1(n) {
  return base64js$1.fromByteArray(n);
}
base64$3.toBase64 = toBase64$1;
function fromBase64$1(n) {
  if (!n.match(/^[a-zA-Z0-9+/]*={0,2}$/))
    throw new Error("Invalid base64 string format");
  return base64js$1.toByteArray(n);
}
base64$3.fromBase64 = fromBase64$1;
var bech32$5 = {}, ALPHABET$1 = "qpzry9x8gf2tvdw0s3jn54khce6mua7l", ALPHABET_MAP = {};
for (var z$2 = 0; z$2 < ALPHABET$1.length; z$2++) {
  var x = ALPHABET$1.charAt(z$2);
  if (ALPHABET_MAP[x] !== void 0) throw new TypeError(x + " is ambiguous");
  ALPHABET_MAP[x] = z$2;
}
function polymodStep(n) {
  var c = n >> 25;
  return (n & 33554431) << 5 ^ -(c >> 0 & 1) & 996825010 ^ -(c >> 1 & 1) & 642813549 ^ -(c >> 2 & 1) & 513874426 ^ -(c >> 3 & 1) & 1027748829 ^ -(c >> 4 & 1) & 705979059;
}
function prefixChk(n) {
  for (var c = 1, u = 0; u < n.length; ++u) {
    var p = n.charCodeAt(u);
    if (p < 33 || p > 126) return "Invalid prefix (" + n + ")";
    c = polymodStep(c) ^ p >> 5;
  }
  for (c = polymodStep(c), u = 0; u < n.length; ++u) {
    var a = n.charCodeAt(u);
    c = polymodStep(c) ^ a & 31;
  }
  return c;
}
function encode$9(n, c, u) {
  if (u = u || 90, n.length + 7 + c.length > u) throw new TypeError("Exceeds length limit");
  n = n.toLowerCase();
  var p = prefixChk(n);
  if (typeof p == "string") throw new Error(p);
  for (var a = n + "1", A = 0; A < c.length; ++A) {
    var b = c[A];
    if (b >> 5) throw new Error("Non 5-bit word");
    p = polymodStep(p) ^ b, a += ALPHABET$1.charAt(b);
  }
  for (A = 0; A < 6; ++A)
    p = polymodStep(p);
  for (p ^= 1, A = 0; A < 6; ++A) {
    var F = p >> (5 - A) * 5 & 31;
    a += ALPHABET$1.charAt(F);
  }
  return a;
}
function __decode(n, c) {
  if (c = c || 90, n.length < 8) return n + " too short";
  if (n.length > c) return "Exceeds length limit";
  var u = n.toLowerCase(), p = n.toUpperCase();
  if (n !== u && n !== p) return "Mixed-case string " + n;
  n = u;
  var a = n.lastIndexOf("1");
  if (a === -1) return "No separator character for " + n;
  if (a === 0) return "Missing prefix for " + n;
  var A = n.slice(0, a), b = n.slice(a + 1);
  if (b.length < 6) return "Data too short";
  var F = prefixChk(A);
  if (typeof F == "string") return F;
  for (var le = [], L = 0; L < b.length; ++L) {
    var pe = b.charAt(L), $ = ALPHABET_MAP[pe];
    if ($ === void 0) return "Unknown character " + pe;
    F = polymodStep(F) ^ $, !(L + 6 >= b.length) && le.push($);
  }
  return F !== 1 ? "Invalid checksum for " + n : { prefix: A, words: le };
}
function decodeUnsafe() {
  var n = __decode.apply(null, arguments);
  if (typeof n == "object") return n;
}
function decode$9(n) {
  var c = __decode.apply(null, arguments);
  if (typeof c == "object") return c;
  throw new Error(c);
}
function convert(n, c, u, p) {
  for (var a = 0, A = 0, b = (1 << u) - 1, F = [], le = 0; le < n.length; ++le)
    for (a = a << c | n[le], A += c; A >= u; )
      A -= u, F.push(a >> A & b);
  if (p)
    A > 0 && F.push(a << u - A & b);
  else {
    if (A >= c) return "Excess padding";
    if (a << u - A & b) return "Non-zero padding";
  }
  return F;
}
function toWordsUnsafe(n) {
  var c = convert(n, 8, 5, !0);
  if (Array.isArray(c)) return c;
}
function toWords(n) {
  var c = convert(n, 8, 5, !0);
  if (Array.isArray(c)) return c;
  throw new Error(c);
}
function fromWordsUnsafe(n) {
  var c = convert(n, 5, 8, !1);
  if (Array.isArray(c)) return c;
}
function fromWords(n) {
  var c = convert(n, 5, 8, !1);
  if (Array.isArray(c)) return c;
  throw new Error(c);
}
var bech32$4 = {
  decodeUnsafe,
  decode: decode$9,
  encode: encode$9,
  toWordsUnsafe,
  toWords,
  fromWordsUnsafe,
  fromWords
}, __createBinding$a = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(n, c, u, p) {
  p === void 0 && (p = u);
  var a = Object.getOwnPropertyDescriptor(c, u);
  (!a || ("get" in a ? !c.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
    return c[u];
  } }), Object.defineProperty(n, p, a);
} : function(n, c, u, p) {
  p === void 0 && (p = u), n[p] = c[u];
}), __setModuleDefault$a = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(n, c) {
  Object.defineProperty(n, "default", { enumerable: !0, value: c });
} : function(n, c) {
  n.default = c;
}), __importStar$a = commonjsGlobal && commonjsGlobal.__importStar || function(n) {
  if (n && n.__esModule) return n;
  var c = {};
  if (n != null) for (var u in n) u !== "default" && Object.prototype.hasOwnProperty.call(n, u) && __createBinding$a(c, n, u);
  return __setModuleDefault$a(c, n), c;
};
Object.defineProperty(bech32$5, "__esModule", { value: !0 });
bech32$5.normalizeBech32 = bech32$5.fromBech32 = bech32$5.toBech32 = void 0;
const bech32$3 = __importStar$a(bech32$4);
function toBech32$1(n, c, u) {
  return bech32$3.encode(n, bech32$3.toWords(c), u);
}
bech32$5.toBech32 = toBech32$1;
function fromBech32$1(n, c = 1 / 0) {
  const u = bech32$3.decode(n, c);
  return {
    prefix: u.prefix,
    data: new Uint8Array(bech32$3.fromWords(u.words))
  };
}
bech32$5.fromBech32 = fromBech32$1;
function normalizeBech32$1(n) {
  const { prefix: c, data: u } = fromBech32$1(n);
  return toBech32$1(c, u);
}
bech32$5.normalizeBech32 = normalizeBech32$1;
var hex$3 = {};
Object.defineProperty(hex$3, "__esModule", { value: !0 });
hex$3.fromHex = hex$3.toHex = void 0;
function toHex$1(n) {
  let c = "";
  for (const u of n)
    c += ("0" + u.toString(16)).slice(-2);
  return c;
}
hex$3.toHex = toHex$1;
function fromHex$1(n) {
  if (n.length % 2 !== 0)
    throw new Error("hex string length must be a multiple of 2");
  const c = new Uint8Array(n.length / 2);
  for (let u = 0; u < c.length; u++) {
    const p = 2 * u, a = n.slice(p, p + 2);
    if (!a.match(/[0-9a-f]{2}/i))
      throw new Error("hex string contains invalid characters");
    c[u] = parseInt(a, 16);
  }
  return c;
}
hex$3.fromHex = fromHex$1;
var rfc3339$1 = {};
Object.defineProperty(rfc3339$1, "__esModule", { value: !0 });
rfc3339$1.toRfc3339 = rfc3339$1.fromRfc3339 = void 0;
const rfc3339Matcher$1 = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(\.\d{1,9})?((?:[+-]\d{2}:\d{2})|Z)$/;
function padded$1(n, c = 2) {
  return n.toString().padStart(c, "0");
}
function fromRfc3339$1(n) {
  const c = rfc3339Matcher$1.exec(n);
  if (!c)
    throw new Error("Date string is not in RFC3339 format");
  const u = +c[1], p = +c[2], a = +c[3], A = +c[4], b = +c[5], F = +c[6], le = c[7] ? Math.floor(+c[7] * 1e3) : 0;
  let L, pe, $;
  c[8] === "Z" ? (L = 1, pe = 0, $ = 0) : (L = c[8].substring(0, 1) === "-" ? -1 : 1, pe = +c[8].substring(1, 3), $ = +c[8].substring(4, 6));
  const Ee = L * (pe * 60 + $) * 60, be = /* @__PURE__ */ new Date();
  return be.setUTCFullYear(u, p - 1, a), be.setUTCHours(A, b, F, le), new Date(be.getTime() - Ee * 1e3);
}
rfc3339$1.fromRfc3339 = fromRfc3339$1;
function toRfc3339$1(n) {
  const c = n.getUTCFullYear(), u = padded$1(n.getUTCMonth() + 1), p = padded$1(n.getUTCDate()), a = padded$1(n.getUTCHours()), A = padded$1(n.getUTCMinutes()), b = padded$1(n.getUTCSeconds()), F = padded$1(n.getUTCMilliseconds(), 3);
  return `${c}-${u}-${p}T${a}:${A}:${b}.${F}Z`;
}
rfc3339$1.toRfc3339 = toRfc3339$1;
var utf8$5 = {};
Object.defineProperty(utf8$5, "__esModule", { value: !0 });
utf8$5.fromUtf8 = utf8$5.toUtf8 = void 0;
function toUtf8$1(n) {
  return new TextEncoder().encode(n);
}
utf8$5.toUtf8 = toUtf8$1;
function fromUtf8$1(n, c = !1) {
  const u = !c;
  return new TextDecoder("utf-8", { fatal: u }).decode(n);
}
utf8$5.fromUtf8 = fromUtf8$1;
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.toUtf8 = n.fromUtf8 = n.toRfc3339 = n.fromRfc3339 = n.toHex = n.fromHex = n.toBech32 = n.normalizeBech32 = n.fromBech32 = n.toBase64 = n.fromBase64 = n.toAscii = n.fromAscii = void 0;
  var c = ascii$1;
  Object.defineProperty(n, "fromAscii", { enumerable: !0, get: function() {
    return c.fromAscii;
  } }), Object.defineProperty(n, "toAscii", { enumerable: !0, get: function() {
    return c.toAscii;
  } });
  var u = base64$3;
  Object.defineProperty(n, "fromBase64", { enumerable: !0, get: function() {
    return u.fromBase64;
  } }), Object.defineProperty(n, "toBase64", { enumerable: !0, get: function() {
    return u.toBase64;
  } });
  var p = bech32$5;
  Object.defineProperty(n, "fromBech32", { enumerable: !0, get: function() {
    return p.fromBech32;
  } }), Object.defineProperty(n, "normalizeBech32", { enumerable: !0, get: function() {
    return p.normalizeBech32;
  } }), Object.defineProperty(n, "toBech32", { enumerable: !0, get: function() {
    return p.toBech32;
  } });
  var a = hex$3;
  Object.defineProperty(n, "fromHex", { enumerable: !0, get: function() {
    return a.fromHex;
  } }), Object.defineProperty(n, "toHex", { enumerable: !0, get: function() {
    return a.toHex;
  } });
  var A = rfc3339$1;
  Object.defineProperty(n, "fromRfc3339", { enumerable: !0, get: function() {
    return A.fromRfc3339;
  } }), Object.defineProperty(n, "toRfc3339", { enumerable: !0, get: function() {
    return A.toRfc3339;
  } });
  var b = utf8$5;
  Object.defineProperty(n, "fromUtf8", { enumerable: !0, get: function() {
    return b.fromUtf8;
  } }), Object.defineProperty(n, "toUtf8", { enumerable: !0, get: function() {
    return b.toUtf8;
  } });
})(build$3);
var pbkdf2$2 = {}, build$2 = {}, arrays = {};
Object.defineProperty(arrays, "__esModule", { value: !0 });
arrays.arrayContentStartsWith = arrays.arrayContentEquals = void 0;
function arrayContentEquals(n, c) {
  if (n.length !== c.length)
    return !1;
  for (let u = 0; u < n.length; ++u)
    if (n[u] !== c[u])
      return !1;
  return !0;
}
arrays.arrayContentEquals = arrayContentEquals;
function arrayContentStartsWith(n, c) {
  if (n.length < c.length)
    return !1;
  for (let u = 0; u < c.length; ++u)
    if (n[u] !== c[u])
      return !1;
  return !0;
}
arrays.arrayContentStartsWith = arrayContentStartsWith;
var assert$8 = {};
Object.defineProperty(assert$8, "__esModule", { value: !0 });
assert$8.assertDefinedAndNotNull = assert$8.assertDefined = assert$8.assert = void 0;
function assert$7(n, c) {
  if (!n)
    throw new Error(c || "condition is not truthy");
}
assert$8.assert = assert$7;
function assertDefined(n, c) {
  if (n === void 0)
    throw new Error(c ?? "value is undefined");
}
assert$8.assertDefined = assertDefined;
function assertDefinedAndNotNull(n, c) {
  if (n == null)
    throw new Error(c ?? "value is undefined or null");
}
assert$8.assertDefinedAndNotNull = assertDefinedAndNotNull;
var sleep$1 = {};
Object.defineProperty(sleep$1, "__esModule", { value: !0 });
sleep$1.sleep = void 0;
async function sleep(n) {
  return new Promise((c) => setTimeout(c, n));
}
sleep$1.sleep = sleep;
var typechecks = {};
Object.defineProperty(typechecks, "__esModule", { value: !0 });
typechecks.isDefined = typechecks.isUint8Array = typechecks.isNonNullObject = void 0;
function isNonNullObject(n) {
  return typeof n == "object" && n !== null;
}
typechecks.isNonNullObject = isNonNullObject;
function isUint8Array$1(n) {
  return !(!isNonNullObject(n) || Object.prototype.toString.call(n) !== "[object Uint8Array]" || typeof Buffer$f < "u" && typeof Buffer$f.isBuffer < "u" && Buffer$f.isBuffer(n));
}
typechecks.isUint8Array = isUint8Array$1;
function isDefined(n) {
  return n !== void 0;
}
typechecks.isDefined = isDefined;
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.isUint8Array = n.isNonNullObject = n.isDefined = n.sleep = n.assertDefinedAndNotNull = n.assertDefined = n.assert = n.arrayContentStartsWith = n.arrayContentEquals = void 0;
  var c = arrays;
  Object.defineProperty(n, "arrayContentEquals", { enumerable: !0, get: function() {
    return c.arrayContentEquals;
  } }), Object.defineProperty(n, "arrayContentStartsWith", { enumerable: !0, get: function() {
    return c.arrayContentStartsWith;
  } });
  var u = assert$8;
  Object.defineProperty(n, "assert", { enumerable: !0, get: function() {
    return u.assert;
  } }), Object.defineProperty(n, "assertDefined", { enumerable: !0, get: function() {
    return u.assertDefined;
  } }), Object.defineProperty(n, "assertDefinedAndNotNull", { enumerable: !0, get: function() {
    return u.assertDefinedAndNotNull;
  } });
  var p = sleep$1;
  Object.defineProperty(n, "sleep", { enumerable: !0, get: function() {
    return p.sleep;
  } });
  var a = typechecks;
  Object.defineProperty(n, "isDefined", { enumerable: !0, get: function() {
    return a.isDefined;
  } }), Object.defineProperty(n, "isNonNullObject", { enumerable: !0, get: function() {
    return a.isNonNullObject;
  } }), Object.defineProperty(n, "isUint8Array", { enumerable: !0, get: function() {
    return a.isUint8Array;
  } });
})(build$2);
var pbkdf2$1 = {};
Object.defineProperty(pbkdf2$1, "__esModule", { value: !0 });
pbkdf2$1.pbkdf2 = pbkdf2;
pbkdf2$1.pbkdf2Async = pbkdf2Async;
const hmac_ts_1 = hmac$6, utils_ts_1$1 = utils$O;
function pbkdf2Init(n, c, u, p) {
  (0, utils_ts_1$1.ahash)(n);
  const a = (0, utils_ts_1$1.checkOpts)({ dkLen: 32, asyncTick: 10 }, p), { c: A, dkLen: b, asyncTick: F } = a;
  if ((0, utils_ts_1$1.anumber)(A), (0, utils_ts_1$1.anumber)(b), (0, utils_ts_1$1.anumber)(F), A < 1)
    throw new Error("iterations (c) should be >= 1");
  const le = (0, utils_ts_1$1.kdfInputToBytes)(c), L = (0, utils_ts_1$1.kdfInputToBytes)(u), pe = new Uint8Array(b), $ = hmac_ts_1.hmac.create(n, le), Ee = $._cloneInto().update(L);
  return { c: A, dkLen: b, asyncTick: F, DK: pe, PRF: $, PRFSalt: Ee };
}
function pbkdf2Output(n, c, u, p, a) {
  return n.destroy(), c.destroy(), p && p.destroy(), (0, utils_ts_1$1.clean)(a), u;
}
function pbkdf2(n, c, u, p) {
  const { c: a, dkLen: A, DK: b, PRF: F, PRFSalt: le } = pbkdf2Init(n, c, u, p);
  let L;
  const pe = new Uint8Array(4), $ = (0, utils_ts_1$1.createView)(pe), Ee = new Uint8Array(F.outputLen);
  for (let be = 1, He = 0; He < A; be++, He += F.outputLen) {
    const Pe = b.subarray(He, He + F.outputLen);
    $.setInt32(0, be, !1), (L = le._cloneInto(L)).update(pe).digestInto(Ee), Pe.set(Ee.subarray(0, Pe.length));
    for (let nr = 1; nr < a; nr++) {
      F._cloneInto(L).update(Ee).digestInto(Ee);
      for (let ir = 0; ir < Pe.length; ir++)
        Pe[ir] ^= Ee[ir];
    }
  }
  return pbkdf2Output(F, le, b, L, Ee);
}
async function pbkdf2Async(n, c, u, p) {
  const { c: a, dkLen: A, asyncTick: b, DK: F, PRF: le, PRFSalt: L } = pbkdf2Init(n, c, u, p);
  let pe;
  const $ = new Uint8Array(4), Ee = (0, utils_ts_1$1.createView)($), be = new Uint8Array(le.outputLen);
  for (let He = 1, Pe = 0; Pe < A; He++, Pe += le.outputLen) {
    const nr = F.subarray(Pe, Pe + le.outputLen);
    Ee.setInt32(0, He, !1), (pe = L._cloneInto(pe)).update($).digestInto(be), nr.set(be.subarray(0, nr.length)), await (0, utils_ts_1$1.asyncLoop)(a - 1, b, () => {
      le._cloneInto(pe).update(be).digestInto(be);
      for (let ir = 0; ir < nr.length; ir++)
        nr[ir] ^= be[ir];
    });
  }
  return pbkdf2Output(le, L, F, pe, be);
}
var sha512$2 = {};
Object.defineProperty(sha512$2, "__esModule", { value: !0 });
sha512$2.sha512_256 = sha512$2.SHA512_256 = sha512$2.sha512_224 = sha512$2.SHA512_224 = sha512$2.sha384 = sha512$2.SHA384 = sha512$2.sha512 = sha512$2.SHA512 = void 0;
const sha2_ts_1 = sha2;
sha512$2.SHA512 = sha2_ts_1.SHA512;
sha512$2.sha512 = sha2_ts_1.sha512;
sha512$2.SHA384 = sha2_ts_1.SHA384;
sha512$2.sha384 = sha2_ts_1.sha384;
sha512$2.SHA512_224 = sha2_ts_1.SHA512_224;
sha512$2.sha512_224 = sha2_ts_1.sha512_224;
sha512$2.SHA512_256 = sha2_ts_1.SHA512_256;
sha512$2.sha512_256 = sha2_ts_1.sha512_256;
var __createBinding$9 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(n, c, u, p) {
  p === void 0 && (p = u);
  var a = Object.getOwnPropertyDescriptor(c, u);
  (!a || ("get" in a ? !c.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
    return c[u];
  } }), Object.defineProperty(n, p, a);
} : function(n, c, u, p) {
  p === void 0 && (p = u), n[p] = c[u];
}), __setModuleDefault$9 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(n, c) {
  Object.defineProperty(n, "default", { enumerable: !0, value: c });
} : function(n, c) {
  n.default = c;
}), __importStar$9 = commonjsGlobal && commonjsGlobal.__importStar || function(n) {
  if (n && n.__esModule) return n;
  var c = {};
  if (n != null) for (var u in n) u !== "default" && Object.prototype.hasOwnProperty.call(n, u) && __createBinding$9(c, n, u);
  return __setModuleDefault$9(c, n), c;
};
Object.defineProperty(pbkdf2$2, "__esModule", { value: !0 });
pbkdf2$2.pbkdf2Sha512 = pbkdf2$2.pbkdf2Sha512Noble = pbkdf2$2.pbkdf2Sha512NodeCrypto = pbkdf2$2.pbkdf2Sha512Subtle = pbkdf2$2.getSubtle = pbkdf2$2.getNodeCrypto = void 0;
const utils_1$4 = build$2, pbkdf2_1$1 = pbkdf2$1, sha512_1$2 = sha512$2;
async function getNodeCrypto() {
  try {
    const n = await Promise.resolve().then(() => __importStar$9(requireCryptoBrowserify()));
    return typeof n == "object" && Object.keys(n).length <= 1 ? void 0 : n;
  } catch {
    return;
  }
}
pbkdf2$2.getNodeCrypto = getNodeCrypto;
async function getSubtle() {
  var c, u, p;
  let n = (c = globalThis == null ? void 0 : globalThis.crypto) == null ? void 0 : c.subtle;
  return n || (n = (p = (u = globalThis == null ? void 0 : globalThis.crypto) == null ? void 0 : u.webcrypto) == null ? void 0 : p.subtle), n;
}
pbkdf2$2.getSubtle = getSubtle;
async function pbkdf2Sha512Subtle(n, c, u, p, a) {
  return (0, utils_1$4.assert)(n, "Argument subtle is falsy"), (0, utils_1$4.assert)(typeof n == "object", "Argument subtle is not of type object"), (0, utils_1$4.assert)(typeof n.importKey == "function", "subtle.importKey is not a function"), (0, utils_1$4.assert)(typeof n.deriveBits == "function", "subtle.deriveBits is not a function"), n.importKey("raw", c, { name: "PBKDF2" }, !1, ["deriveBits"]).then((A) => n.deriveBits({
    name: "PBKDF2",
    salt: u,
    iterations: p,
    hash: { name: "SHA-512" }
  }, A, a * 8).then((b) => new Uint8Array(b)));
}
pbkdf2$2.pbkdf2Sha512Subtle = pbkdf2Sha512Subtle;
async function pbkdf2Sha512NodeCrypto(n, c, u, p, a) {
  return (0, utils_1$4.assert)(n, "Argument nodeCrypto is falsy"), (0, utils_1$4.assert)(typeof n == "object", "Argument nodeCrypto is not of type object"), (0, utils_1$4.assert)(typeof n.pbkdf2 == "function", "nodeCrypto.pbkdf2 is not a function"), new Promise((A, b) => {
    n.pbkdf2(c, u, p, a, "sha512", (F, le) => {
      F ? b(F) : A(Uint8Array.from(le));
    });
  });
}
pbkdf2$2.pbkdf2Sha512NodeCrypto = pbkdf2Sha512NodeCrypto;
async function pbkdf2Sha512Noble(n, c, u, p) {
  return (0, pbkdf2_1$1.pbkdf2Async)(sha512_1$2.sha512, n, c, { c: u, dkLen: p });
}
pbkdf2$2.pbkdf2Sha512Noble = pbkdf2Sha512Noble;
async function pbkdf2Sha512(n, c, u, p) {
  const a = await getSubtle();
  if (a)
    return pbkdf2Sha512Subtle(a, n, c, u, p);
  {
    const A = await getNodeCrypto();
    return A ? pbkdf2Sha512NodeCrypto(A, n, c, u, p) : pbkdf2Sha512Noble(n, c, u, p);
  }
}
pbkdf2$2.pbkdf2Sha512 = pbkdf2Sha512;
var sha = {}, utils$2 = {};
Object.defineProperty(utils$2, "__esModule", { value: !0 });
utils$2.toRealUint8Array = void 0;
function toRealUint8Array(n) {
  return n instanceof Uint8Array ? n : Uint8Array.from(n);
}
utils$2.toRealUint8Array = toRealUint8Array;
Object.defineProperty(sha, "__esModule", { value: !0 });
sha.sha512 = sha.Sha512 = sha.sha256 = sha.Sha256 = void 0;
const sha256_1$2 = sha256$g, sha512_1$1 = sha512$2, utils_1$3 = utils$2;
class Sha256 {
  constructor(c) {
    this.blockSize = 512 / 8, this.impl = sha256_1$2.sha256.create(), c && this.update(c);
  }
  update(c) {
    return this.impl.update((0, utils_1$3.toRealUint8Array)(c)), this;
  }
  digest() {
    return this.impl.digest();
  }
}
sha.Sha256 = Sha256;
function sha256$6(n) {
  return new Sha256(n).digest();
}
sha.sha256 = sha256$6;
class Sha512 {
  constructor(c) {
    this.blockSize = 1024 / 8, this.impl = sha512_1$1.sha512.create(), c && this.update(c);
  }
  update(c) {
    return this.impl.update((0, utils_1$3.toRealUint8Array)(c)), this;
  }
  digest() {
    return this.impl.digest();
  }
}
sha.Sha512 = Sha512;
function sha512(n) {
  return new Sha512(n).digest();
}
sha.sha512 = sha512;
Object.defineProperty(bip39, "__esModule", { value: !0 });
bip39.Bip39 = bip39.EnglishMnemonic = bip39.mnemonicToEntropy = bip39.entropyToMnemonic = void 0;
const encoding_1$1 = build$3, pbkdf2_1 = pbkdf2$2, sha_1 = sha, wordlist = [
  "abandon",
  "ability",
  "able",
  "about",
  "above",
  "absent",
  "absorb",
  "abstract",
  "absurd",
  "abuse",
  "access",
  "accident",
  "account",
  "accuse",
  "achieve",
  "acid",
  "acoustic",
  "acquire",
  "across",
  "act",
  "action",
  "actor",
  "actress",
  "actual",
  "adapt",
  "add",
  "addict",
  "address",
  "adjust",
  "admit",
  "adult",
  "advance",
  "advice",
  "aerobic",
  "affair",
  "afford",
  "afraid",
  "again",
  "age",
  "agent",
  "agree",
  "ahead",
  "aim",
  "air",
  "airport",
  "aisle",
  "alarm",
  "album",
  "alcohol",
  "alert",
  "alien",
  "all",
  "alley",
  "allow",
  "almost",
  "alone",
  "alpha",
  "already",
  "also",
  "alter",
  "always",
  "amateur",
  "amazing",
  "among",
  "amount",
  "amused",
  "analyst",
  "anchor",
  "ancient",
  "anger",
  "angle",
  "angry",
  "animal",
  "ankle",
  "announce",
  "annual",
  "another",
  "answer",
  "antenna",
  "antique",
  "anxiety",
  "any",
  "apart",
  "apology",
  "appear",
  "apple",
  "approve",
  "april",
  "arch",
  "arctic",
  "area",
  "arena",
  "argue",
  "arm",
  "armed",
  "armor",
  "army",
  "around",
  "arrange",
  "arrest",
  "arrive",
  "arrow",
  "art",
  "artefact",
  "artist",
  "artwork",
  "ask",
  "aspect",
  "assault",
  "asset",
  "assist",
  "assume",
  "asthma",
  "athlete",
  "atom",
  "attack",
  "attend",
  "attitude",
  "attract",
  "auction",
  "audit",
  "august",
  "aunt",
  "author",
  "auto",
  "autumn",
  "average",
  "avocado",
  "avoid",
  "awake",
  "aware",
  "away",
  "awesome",
  "awful",
  "awkward",
  "axis",
  "baby",
  "bachelor",
  "bacon",
  "badge",
  "bag",
  "balance",
  "balcony",
  "ball",
  "bamboo",
  "banana",
  "banner",
  "bar",
  "barely",
  "bargain",
  "barrel",
  "base",
  "basic",
  "basket",
  "battle",
  "beach",
  "bean",
  "beauty",
  "because",
  "become",
  "beef",
  "before",
  "begin",
  "behave",
  "behind",
  "believe",
  "below",
  "belt",
  "bench",
  "benefit",
  "best",
  "betray",
  "better",
  "between",
  "beyond",
  "bicycle",
  "bid",
  "bike",
  "bind",
  "biology",
  "bird",
  "birth",
  "bitter",
  "black",
  "blade",
  "blame",
  "blanket",
  "blast",
  "bleak",
  "bless",
  "blind",
  "blood",
  "blossom",
  "blouse",
  "blue",
  "blur",
  "blush",
  "board",
  "boat",
  "body",
  "boil",
  "bomb",
  "bone",
  "bonus",
  "book",
  "boost",
  "border",
  "boring",
  "borrow",
  "boss",
  "bottom",
  "bounce",
  "box",
  "boy",
  "bracket",
  "brain",
  "brand",
  "brass",
  "brave",
  "bread",
  "breeze",
  "brick",
  "bridge",
  "brief",
  "bright",
  "bring",
  "brisk",
  "broccoli",
  "broken",
  "bronze",
  "broom",
  "brother",
  "brown",
  "brush",
  "bubble",
  "buddy",
  "budget",
  "buffalo",
  "build",
  "bulb",
  "bulk",
  "bullet",
  "bundle",
  "bunker",
  "burden",
  "burger",
  "burst",
  "bus",
  "business",
  "busy",
  "butter",
  "buyer",
  "buzz",
  "cabbage",
  "cabin",
  "cable",
  "cactus",
  "cage",
  "cake",
  "call",
  "calm",
  "camera",
  "camp",
  "can",
  "canal",
  "cancel",
  "candy",
  "cannon",
  "canoe",
  "canvas",
  "canyon",
  "capable",
  "capital",
  "captain",
  "car",
  "carbon",
  "card",
  "cargo",
  "carpet",
  "carry",
  "cart",
  "case",
  "cash",
  "casino",
  "castle",
  "casual",
  "cat",
  "catalog",
  "catch",
  "category",
  "cattle",
  "caught",
  "cause",
  "caution",
  "cave",
  "ceiling",
  "celery",
  "cement",
  "census",
  "century",
  "cereal",
  "certain",
  "chair",
  "chalk",
  "champion",
  "change",
  "chaos",
  "chapter",
  "charge",
  "chase",
  "chat",
  "cheap",
  "check",
  "cheese",
  "chef",
  "cherry",
  "chest",
  "chicken",
  "chief",
  "child",
  "chimney",
  "choice",
  "choose",
  "chronic",
  "chuckle",
  "chunk",
  "churn",
  "cigar",
  "cinnamon",
  "circle",
  "citizen",
  "city",
  "civil",
  "claim",
  "clap",
  "clarify",
  "claw",
  "clay",
  "clean",
  "clerk",
  "clever",
  "click",
  "client",
  "cliff",
  "climb",
  "clinic",
  "clip",
  "clock",
  "clog",
  "close",
  "cloth",
  "cloud",
  "clown",
  "club",
  "clump",
  "cluster",
  "clutch",
  "coach",
  "coast",
  "coconut",
  "code",
  "coffee",
  "coil",
  "coin",
  "collect",
  "color",
  "column",
  "combine",
  "come",
  "comfort",
  "comic",
  "common",
  "company",
  "concert",
  "conduct",
  "confirm",
  "congress",
  "connect",
  "consider",
  "control",
  "convince",
  "cook",
  "cool",
  "copper",
  "copy",
  "coral",
  "core",
  "corn",
  "correct",
  "cost",
  "cotton",
  "couch",
  "country",
  "couple",
  "course",
  "cousin",
  "cover",
  "coyote",
  "crack",
  "cradle",
  "craft",
  "cram",
  "crane",
  "crash",
  "crater",
  "crawl",
  "crazy",
  "cream",
  "credit",
  "creek",
  "crew",
  "cricket",
  "crime",
  "crisp",
  "critic",
  "crop",
  "cross",
  "crouch",
  "crowd",
  "crucial",
  "cruel",
  "cruise",
  "crumble",
  "crunch",
  "crush",
  "cry",
  "crystal",
  "cube",
  "culture",
  "cup",
  "cupboard",
  "curious",
  "current",
  "curtain",
  "curve",
  "cushion",
  "custom",
  "cute",
  "cycle",
  "dad",
  "damage",
  "damp",
  "dance",
  "danger",
  "daring",
  "dash",
  "daughter",
  "dawn",
  "day",
  "deal",
  "debate",
  "debris",
  "decade",
  "december",
  "decide",
  "decline",
  "decorate",
  "decrease",
  "deer",
  "defense",
  "define",
  "defy",
  "degree",
  "delay",
  "deliver",
  "demand",
  "demise",
  "denial",
  "dentist",
  "deny",
  "depart",
  "depend",
  "deposit",
  "depth",
  "deputy",
  "derive",
  "describe",
  "desert",
  "design",
  "desk",
  "despair",
  "destroy",
  "detail",
  "detect",
  "develop",
  "device",
  "devote",
  "diagram",
  "dial",
  "diamond",
  "diary",
  "dice",
  "diesel",
  "diet",
  "differ",
  "digital",
  "dignity",
  "dilemma",
  "dinner",
  "dinosaur",
  "direct",
  "dirt",
  "disagree",
  "discover",
  "disease",
  "dish",
  "dismiss",
  "disorder",
  "display",
  "distance",
  "divert",
  "divide",
  "divorce",
  "dizzy",
  "doctor",
  "document",
  "dog",
  "doll",
  "dolphin",
  "domain",
  "donate",
  "donkey",
  "donor",
  "door",
  "dose",
  "double",
  "dove",
  "draft",
  "dragon",
  "drama",
  "drastic",
  "draw",
  "dream",
  "dress",
  "drift",
  "drill",
  "drink",
  "drip",
  "drive",
  "drop",
  "drum",
  "dry",
  "duck",
  "dumb",
  "dune",
  "during",
  "dust",
  "dutch",
  "duty",
  "dwarf",
  "dynamic",
  "eager",
  "eagle",
  "early",
  "earn",
  "earth",
  "easily",
  "east",
  "easy",
  "echo",
  "ecology",
  "economy",
  "edge",
  "edit",
  "educate",
  "effort",
  "egg",
  "eight",
  "either",
  "elbow",
  "elder",
  "electric",
  "elegant",
  "element",
  "elephant",
  "elevator",
  "elite",
  "else",
  "embark",
  "embody",
  "embrace",
  "emerge",
  "emotion",
  "employ",
  "empower",
  "empty",
  "enable",
  "enact",
  "end",
  "endless",
  "endorse",
  "enemy",
  "energy",
  "enforce",
  "engage",
  "engine",
  "enhance",
  "enjoy",
  "enlist",
  "enough",
  "enrich",
  "enroll",
  "ensure",
  "enter",
  "entire",
  "entry",
  "envelope",
  "episode",
  "equal",
  "equip",
  "era",
  "erase",
  "erode",
  "erosion",
  "error",
  "erupt",
  "escape",
  "essay",
  "essence",
  "estate",
  "eternal",
  "ethics",
  "evidence",
  "evil",
  "evoke",
  "evolve",
  "exact",
  "example",
  "excess",
  "exchange",
  "excite",
  "exclude",
  "excuse",
  "execute",
  "exercise",
  "exhaust",
  "exhibit",
  "exile",
  "exist",
  "exit",
  "exotic",
  "expand",
  "expect",
  "expire",
  "explain",
  "expose",
  "express",
  "extend",
  "extra",
  "eye",
  "eyebrow",
  "fabric",
  "face",
  "faculty",
  "fade",
  "faint",
  "faith",
  "fall",
  "false",
  "fame",
  "family",
  "famous",
  "fan",
  "fancy",
  "fantasy",
  "farm",
  "fashion",
  "fat",
  "fatal",
  "father",
  "fatigue",
  "fault",
  "favorite",
  "feature",
  "february",
  "federal",
  "fee",
  "feed",
  "feel",
  "female",
  "fence",
  "festival",
  "fetch",
  "fever",
  "few",
  "fiber",
  "fiction",
  "field",
  "figure",
  "file",
  "film",
  "filter",
  "final",
  "find",
  "fine",
  "finger",
  "finish",
  "fire",
  "firm",
  "first",
  "fiscal",
  "fish",
  "fit",
  "fitness",
  "fix",
  "flag",
  "flame",
  "flash",
  "flat",
  "flavor",
  "flee",
  "flight",
  "flip",
  "float",
  "flock",
  "floor",
  "flower",
  "fluid",
  "flush",
  "fly",
  "foam",
  "focus",
  "fog",
  "foil",
  "fold",
  "follow",
  "food",
  "foot",
  "force",
  "forest",
  "forget",
  "fork",
  "fortune",
  "forum",
  "forward",
  "fossil",
  "foster",
  "found",
  "fox",
  "fragile",
  "frame",
  "frequent",
  "fresh",
  "friend",
  "fringe",
  "frog",
  "front",
  "frost",
  "frown",
  "frozen",
  "fruit",
  "fuel",
  "fun",
  "funny",
  "furnace",
  "fury",
  "future",
  "gadget",
  "gain",
  "galaxy",
  "gallery",
  "game",
  "gap",
  "garage",
  "garbage",
  "garden",
  "garlic",
  "garment",
  "gas",
  "gasp",
  "gate",
  "gather",
  "gauge",
  "gaze",
  "general",
  "genius",
  "genre",
  "gentle",
  "genuine",
  "gesture",
  "ghost",
  "giant",
  "gift",
  "giggle",
  "ginger",
  "giraffe",
  "girl",
  "give",
  "glad",
  "glance",
  "glare",
  "glass",
  "glide",
  "glimpse",
  "globe",
  "gloom",
  "glory",
  "glove",
  "glow",
  "glue",
  "goat",
  "goddess",
  "gold",
  "good",
  "goose",
  "gorilla",
  "gospel",
  "gossip",
  "govern",
  "gown",
  "grab",
  "grace",
  "grain",
  "grant",
  "grape",
  "grass",
  "gravity",
  "great",
  "green",
  "grid",
  "grief",
  "grit",
  "grocery",
  "group",
  "grow",
  "grunt",
  "guard",
  "guess",
  "guide",
  "guilt",
  "guitar",
  "gun",
  "gym",
  "habit",
  "hair",
  "half",
  "hammer",
  "hamster",
  "hand",
  "happy",
  "harbor",
  "hard",
  "harsh",
  "harvest",
  "hat",
  "have",
  "hawk",
  "hazard",
  "head",
  "health",
  "heart",
  "heavy",
  "hedgehog",
  "height",
  "hello",
  "helmet",
  "help",
  "hen",
  "hero",
  "hidden",
  "high",
  "hill",
  "hint",
  "hip",
  "hire",
  "history",
  "hobby",
  "hockey",
  "hold",
  "hole",
  "holiday",
  "hollow",
  "home",
  "honey",
  "hood",
  "hope",
  "horn",
  "horror",
  "horse",
  "hospital",
  "host",
  "hotel",
  "hour",
  "hover",
  "hub",
  "huge",
  "human",
  "humble",
  "humor",
  "hundred",
  "hungry",
  "hunt",
  "hurdle",
  "hurry",
  "hurt",
  "husband",
  "hybrid",
  "ice",
  "icon",
  "idea",
  "identify",
  "idle",
  "ignore",
  "ill",
  "illegal",
  "illness",
  "image",
  "imitate",
  "immense",
  "immune",
  "impact",
  "impose",
  "improve",
  "impulse",
  "inch",
  "include",
  "income",
  "increase",
  "index",
  "indicate",
  "indoor",
  "industry",
  "infant",
  "inflict",
  "inform",
  "inhale",
  "inherit",
  "initial",
  "inject",
  "injury",
  "inmate",
  "inner",
  "innocent",
  "input",
  "inquiry",
  "insane",
  "insect",
  "inside",
  "inspire",
  "install",
  "intact",
  "interest",
  "into",
  "invest",
  "invite",
  "involve",
  "iron",
  "island",
  "isolate",
  "issue",
  "item",
  "ivory",
  "jacket",
  "jaguar",
  "jar",
  "jazz",
  "jealous",
  "jeans",
  "jelly",
  "jewel",
  "job",
  "join",
  "joke",
  "journey",
  "joy",
  "judge",
  "juice",
  "jump",
  "jungle",
  "junior",
  "junk",
  "just",
  "kangaroo",
  "keen",
  "keep",
  "ketchup",
  "key",
  "kick",
  "kid",
  "kidney",
  "kind",
  "kingdom",
  "kiss",
  "kit",
  "kitchen",
  "kite",
  "kitten",
  "kiwi",
  "knee",
  "knife",
  "knock",
  "know",
  "lab",
  "label",
  "labor",
  "ladder",
  "lady",
  "lake",
  "lamp",
  "language",
  "laptop",
  "large",
  "later",
  "latin",
  "laugh",
  "laundry",
  "lava",
  "law",
  "lawn",
  "lawsuit",
  "layer",
  "lazy",
  "leader",
  "leaf",
  "learn",
  "leave",
  "lecture",
  "left",
  "leg",
  "legal",
  "legend",
  "leisure",
  "lemon",
  "lend",
  "length",
  "lens",
  "leopard",
  "lesson",
  "letter",
  "level",
  "liar",
  "liberty",
  "library",
  "license",
  "life",
  "lift",
  "light",
  "like",
  "limb",
  "limit",
  "link",
  "lion",
  "liquid",
  "list",
  "little",
  "live",
  "lizard",
  "load",
  "loan",
  "lobster",
  "local",
  "lock",
  "logic",
  "lonely",
  "long",
  "loop",
  "lottery",
  "loud",
  "lounge",
  "love",
  "loyal",
  "lucky",
  "luggage",
  "lumber",
  "lunar",
  "lunch",
  "luxury",
  "lyrics",
  "machine",
  "mad",
  "magic",
  "magnet",
  "maid",
  "mail",
  "main",
  "major",
  "make",
  "mammal",
  "man",
  "manage",
  "mandate",
  "mango",
  "mansion",
  "manual",
  "maple",
  "marble",
  "march",
  "margin",
  "marine",
  "market",
  "marriage",
  "mask",
  "mass",
  "master",
  "match",
  "material",
  "math",
  "matrix",
  "matter",
  "maximum",
  "maze",
  "meadow",
  "mean",
  "measure",
  "meat",
  "mechanic",
  "medal",
  "media",
  "melody",
  "melt",
  "member",
  "memory",
  "mention",
  "menu",
  "mercy",
  "merge",
  "merit",
  "merry",
  "mesh",
  "message",
  "metal",
  "method",
  "middle",
  "midnight",
  "milk",
  "million",
  "mimic",
  "mind",
  "minimum",
  "minor",
  "minute",
  "miracle",
  "mirror",
  "misery",
  "miss",
  "mistake",
  "mix",
  "mixed",
  "mixture",
  "mobile",
  "model",
  "modify",
  "mom",
  "moment",
  "monitor",
  "monkey",
  "monster",
  "month",
  "moon",
  "moral",
  "more",
  "morning",
  "mosquito",
  "mother",
  "motion",
  "motor",
  "mountain",
  "mouse",
  "move",
  "movie",
  "much",
  "muffin",
  "mule",
  "multiply",
  "muscle",
  "museum",
  "mushroom",
  "music",
  "must",
  "mutual",
  "myself",
  "mystery",
  "myth",
  "naive",
  "name",
  "napkin",
  "narrow",
  "nasty",
  "nation",
  "nature",
  "near",
  "neck",
  "need",
  "negative",
  "neglect",
  "neither",
  "nephew",
  "nerve",
  "nest",
  "net",
  "network",
  "neutral",
  "never",
  "news",
  "next",
  "nice",
  "night",
  "noble",
  "noise",
  "nominee",
  "noodle",
  "normal",
  "north",
  "nose",
  "notable",
  "note",
  "nothing",
  "notice",
  "novel",
  "now",
  "nuclear",
  "number",
  "nurse",
  "nut",
  "oak",
  "obey",
  "object",
  "oblige",
  "obscure",
  "observe",
  "obtain",
  "obvious",
  "occur",
  "ocean",
  "october",
  "odor",
  "off",
  "offer",
  "office",
  "often",
  "oil",
  "okay",
  "old",
  "olive",
  "olympic",
  "omit",
  "once",
  "one",
  "onion",
  "online",
  "only",
  "open",
  "opera",
  "opinion",
  "oppose",
  "option",
  "orange",
  "orbit",
  "orchard",
  "order",
  "ordinary",
  "organ",
  "orient",
  "original",
  "orphan",
  "ostrich",
  "other",
  "outdoor",
  "outer",
  "output",
  "outside",
  "oval",
  "oven",
  "over",
  "own",
  "owner",
  "oxygen",
  "oyster",
  "ozone",
  "pact",
  "paddle",
  "page",
  "pair",
  "palace",
  "palm",
  "panda",
  "panel",
  "panic",
  "panther",
  "paper",
  "parade",
  "parent",
  "park",
  "parrot",
  "party",
  "pass",
  "patch",
  "path",
  "patient",
  "patrol",
  "pattern",
  "pause",
  "pave",
  "payment",
  "peace",
  "peanut",
  "pear",
  "peasant",
  "pelican",
  "pen",
  "penalty",
  "pencil",
  "people",
  "pepper",
  "perfect",
  "permit",
  "person",
  "pet",
  "phone",
  "photo",
  "phrase",
  "physical",
  "piano",
  "picnic",
  "picture",
  "piece",
  "pig",
  "pigeon",
  "pill",
  "pilot",
  "pink",
  "pioneer",
  "pipe",
  "pistol",
  "pitch",
  "pizza",
  "place",
  "planet",
  "plastic",
  "plate",
  "play",
  "please",
  "pledge",
  "pluck",
  "plug",
  "plunge",
  "poem",
  "poet",
  "point",
  "polar",
  "pole",
  "police",
  "pond",
  "pony",
  "pool",
  "popular",
  "portion",
  "position",
  "possible",
  "post",
  "potato",
  "pottery",
  "poverty",
  "powder",
  "power",
  "practice",
  "praise",
  "predict",
  "prefer",
  "prepare",
  "present",
  "pretty",
  "prevent",
  "price",
  "pride",
  "primary",
  "print",
  "priority",
  "prison",
  "private",
  "prize",
  "problem",
  "process",
  "produce",
  "profit",
  "program",
  "project",
  "promote",
  "proof",
  "property",
  "prosper",
  "protect",
  "proud",
  "provide",
  "public",
  "pudding",
  "pull",
  "pulp",
  "pulse",
  "pumpkin",
  "punch",
  "pupil",
  "puppy",
  "purchase",
  "purity",
  "purpose",
  "purse",
  "push",
  "put",
  "puzzle",
  "pyramid",
  "quality",
  "quantum",
  "quarter",
  "question",
  "quick",
  "quit",
  "quiz",
  "quote",
  "rabbit",
  "raccoon",
  "race",
  "rack",
  "radar",
  "radio",
  "rail",
  "rain",
  "raise",
  "rally",
  "ramp",
  "ranch",
  "random",
  "range",
  "rapid",
  "rare",
  "rate",
  "rather",
  "raven",
  "raw",
  "razor",
  "ready",
  "real",
  "reason",
  "rebel",
  "rebuild",
  "recall",
  "receive",
  "recipe",
  "record",
  "recycle",
  "reduce",
  "reflect",
  "reform",
  "refuse",
  "region",
  "regret",
  "regular",
  "reject",
  "relax",
  "release",
  "relief",
  "rely",
  "remain",
  "remember",
  "remind",
  "remove",
  "render",
  "renew",
  "rent",
  "reopen",
  "repair",
  "repeat",
  "replace",
  "report",
  "require",
  "rescue",
  "resemble",
  "resist",
  "resource",
  "response",
  "result",
  "retire",
  "retreat",
  "return",
  "reunion",
  "reveal",
  "review",
  "reward",
  "rhythm",
  "rib",
  "ribbon",
  "rice",
  "rich",
  "ride",
  "ridge",
  "rifle",
  "right",
  "rigid",
  "ring",
  "riot",
  "ripple",
  "risk",
  "ritual",
  "rival",
  "river",
  "road",
  "roast",
  "robot",
  "robust",
  "rocket",
  "romance",
  "roof",
  "rookie",
  "room",
  "rose",
  "rotate",
  "rough",
  "round",
  "route",
  "royal",
  "rubber",
  "rude",
  "rug",
  "rule",
  "run",
  "runway",
  "rural",
  "sad",
  "saddle",
  "sadness",
  "safe",
  "sail",
  "salad",
  "salmon",
  "salon",
  "salt",
  "salute",
  "same",
  "sample",
  "sand",
  "satisfy",
  "satoshi",
  "sauce",
  "sausage",
  "save",
  "say",
  "scale",
  "scan",
  "scare",
  "scatter",
  "scene",
  "scheme",
  "school",
  "science",
  "scissors",
  "scorpion",
  "scout",
  "scrap",
  "screen",
  "script",
  "scrub",
  "sea",
  "search",
  "season",
  "seat",
  "second",
  "secret",
  "section",
  "security",
  "seed",
  "seek",
  "segment",
  "select",
  "sell",
  "seminar",
  "senior",
  "sense",
  "sentence",
  "series",
  "service",
  "session",
  "settle",
  "setup",
  "seven",
  "shadow",
  "shaft",
  "shallow",
  "share",
  "shed",
  "shell",
  "sheriff",
  "shield",
  "shift",
  "shine",
  "ship",
  "shiver",
  "shock",
  "shoe",
  "shoot",
  "shop",
  "short",
  "shoulder",
  "shove",
  "shrimp",
  "shrug",
  "shuffle",
  "shy",
  "sibling",
  "sick",
  "side",
  "siege",
  "sight",
  "sign",
  "silent",
  "silk",
  "silly",
  "silver",
  "similar",
  "simple",
  "since",
  "sing",
  "siren",
  "sister",
  "situate",
  "six",
  "size",
  "skate",
  "sketch",
  "ski",
  "skill",
  "skin",
  "skirt",
  "skull",
  "slab",
  "slam",
  "sleep",
  "slender",
  "slice",
  "slide",
  "slight",
  "slim",
  "slogan",
  "slot",
  "slow",
  "slush",
  "small",
  "smart",
  "smile",
  "smoke",
  "smooth",
  "snack",
  "snake",
  "snap",
  "sniff",
  "snow",
  "soap",
  "soccer",
  "social",
  "sock",
  "soda",
  "soft",
  "solar",
  "soldier",
  "solid",
  "solution",
  "solve",
  "someone",
  "song",
  "soon",
  "sorry",
  "sort",
  "soul",
  "sound",
  "soup",
  "source",
  "south",
  "space",
  "spare",
  "spatial",
  "spawn",
  "speak",
  "special",
  "speed",
  "spell",
  "spend",
  "sphere",
  "spice",
  "spider",
  "spike",
  "spin",
  "spirit",
  "split",
  "spoil",
  "sponsor",
  "spoon",
  "sport",
  "spot",
  "spray",
  "spread",
  "spring",
  "spy",
  "square",
  "squeeze",
  "squirrel",
  "stable",
  "stadium",
  "staff",
  "stage",
  "stairs",
  "stamp",
  "stand",
  "start",
  "state",
  "stay",
  "steak",
  "steel",
  "stem",
  "step",
  "stereo",
  "stick",
  "still",
  "sting",
  "stock",
  "stomach",
  "stone",
  "stool",
  "story",
  "stove",
  "strategy",
  "street",
  "strike",
  "strong",
  "struggle",
  "student",
  "stuff",
  "stumble",
  "style",
  "subject",
  "submit",
  "subway",
  "success",
  "such",
  "sudden",
  "suffer",
  "sugar",
  "suggest",
  "suit",
  "summer",
  "sun",
  "sunny",
  "sunset",
  "super",
  "supply",
  "supreme",
  "sure",
  "surface",
  "surge",
  "surprise",
  "surround",
  "survey",
  "suspect",
  "sustain",
  "swallow",
  "swamp",
  "swap",
  "swarm",
  "swear",
  "sweet",
  "swift",
  "swim",
  "swing",
  "switch",
  "sword",
  "symbol",
  "symptom",
  "syrup",
  "system",
  "table",
  "tackle",
  "tag",
  "tail",
  "talent",
  "talk",
  "tank",
  "tape",
  "target",
  "task",
  "taste",
  "tattoo",
  "taxi",
  "teach",
  "team",
  "tell",
  "ten",
  "tenant",
  "tennis",
  "tent",
  "term",
  "test",
  "text",
  "thank",
  "that",
  "theme",
  "then",
  "theory",
  "there",
  "they",
  "thing",
  "this",
  "thought",
  "three",
  "thrive",
  "throw",
  "thumb",
  "thunder",
  "ticket",
  "tide",
  "tiger",
  "tilt",
  "timber",
  "time",
  "tiny",
  "tip",
  "tired",
  "tissue",
  "title",
  "toast",
  "tobacco",
  "today",
  "toddler",
  "toe",
  "together",
  "toilet",
  "token",
  "tomato",
  "tomorrow",
  "tone",
  "tongue",
  "tonight",
  "tool",
  "tooth",
  "top",
  "topic",
  "topple",
  "torch",
  "tornado",
  "tortoise",
  "toss",
  "total",
  "tourist",
  "toward",
  "tower",
  "town",
  "toy",
  "track",
  "trade",
  "traffic",
  "tragic",
  "train",
  "transfer",
  "trap",
  "trash",
  "travel",
  "tray",
  "treat",
  "tree",
  "trend",
  "trial",
  "tribe",
  "trick",
  "trigger",
  "trim",
  "trip",
  "trophy",
  "trouble",
  "truck",
  "true",
  "truly",
  "trumpet",
  "trust",
  "truth",
  "try",
  "tube",
  "tuition",
  "tumble",
  "tuna",
  "tunnel",
  "turkey",
  "turn",
  "turtle",
  "twelve",
  "twenty",
  "twice",
  "twin",
  "twist",
  "two",
  "type",
  "typical",
  "ugly",
  "umbrella",
  "unable",
  "unaware",
  "uncle",
  "uncover",
  "under",
  "undo",
  "unfair",
  "unfold",
  "unhappy",
  "uniform",
  "unique",
  "unit",
  "universe",
  "unknown",
  "unlock",
  "until",
  "unusual",
  "unveil",
  "update",
  "upgrade",
  "uphold",
  "upon",
  "upper",
  "upset",
  "urban",
  "urge",
  "usage",
  "use",
  "used",
  "useful",
  "useless",
  "usual",
  "utility",
  "vacant",
  "vacuum",
  "vague",
  "valid",
  "valley",
  "valve",
  "van",
  "vanish",
  "vapor",
  "various",
  "vast",
  "vault",
  "vehicle",
  "velvet",
  "vendor",
  "venture",
  "venue",
  "verb",
  "verify",
  "version",
  "very",
  "vessel",
  "veteran",
  "viable",
  "vibrant",
  "vicious",
  "victory",
  "video",
  "view",
  "village",
  "vintage",
  "violin",
  "virtual",
  "virus",
  "visa",
  "visit",
  "visual",
  "vital",
  "vivid",
  "vocal",
  "voice",
  "void",
  "volcano",
  "volume",
  "vote",
  "voyage",
  "wage",
  "wagon",
  "wait",
  "walk",
  "wall",
  "walnut",
  "want",
  "warfare",
  "warm",
  "warrior",
  "wash",
  "wasp",
  "waste",
  "water",
  "wave",
  "way",
  "wealth",
  "weapon",
  "wear",
  "weasel",
  "weather",
  "web",
  "wedding",
  "weekend",
  "weird",
  "welcome",
  "west",
  "wet",
  "whale",
  "what",
  "wheat",
  "wheel",
  "when",
  "where",
  "whip",
  "whisper",
  "wide",
  "width",
  "wife",
  "wild",
  "will",
  "win",
  "window",
  "wine",
  "wing",
  "wink",
  "winner",
  "winter",
  "wire",
  "wisdom",
  "wise",
  "wish",
  "witness",
  "wolf",
  "woman",
  "wonder",
  "wood",
  "wool",
  "word",
  "work",
  "world",
  "worry",
  "worth",
  "wrap",
  "wreck",
  "wrestle",
  "wrist",
  "write",
  "wrong",
  "yard",
  "year",
  "yellow",
  "you",
  "young",
  "youth",
  "zebra",
  "zero",
  "zone",
  "zoo"
];
function bytesToBitstring(n) {
  return Array.from(n).map((c) => c.toString(2).padStart(8, "0")).join("");
}
function deriveChecksumBits(n) {
  const u = n.length * 8 / 32, p = (0, sha_1.sha256)(n);
  return bytesToBitstring(p).slice(0, u);
}
function bitstringToByte(n) {
  return parseInt(n, 2);
}
const allowedEntropyLengths = [16, 20, 24, 28, 32], allowedWordLengths = [12, 15, 18, 21, 24];
function entropyToMnemonic(n) {
  if (allowedEntropyLengths.indexOf(n.length) === -1)
    throw new Error("invalid input length");
  const c = bytesToBitstring(n), u = deriveChecksumBits(n);
  return (c + u).match(/(.{11})/g).map((b) => {
    const F = bitstringToByte(b);
    return wordlist[F];
  }).join(" ");
}
bip39.entropyToMnemonic = entropyToMnemonic;
const invalidNumberOfWorks = "Invalid number of words", wordNotInWordlist = "Found word that is not in the wordlist", invalidEntropy = "Invalid entropy", invalidChecksum = "Invalid mnemonic checksum";
function normalize$2(n) {
  return n.normalize("NFKD");
}
function mnemonicToEntropy(n) {
  const c = normalize$2(n).split(" ");
  if (!allowedWordLengths.includes(c.length))
    throw new Error(invalidNumberOfWorks);
  const u = c.map((L) => {
    const pe = wordlist.indexOf(L);
    if (pe === -1)
      throw new Error(wordNotInWordlist);
    return pe.toString(2).padStart(11, "0");
  }).join(""), p = Math.floor(u.length / 33) * 32, a = u.slice(0, p), A = u.slice(p), b = a.match(/(.{1,8})/g).map(bitstringToByte);
  if (b.length < 16 || b.length > 32 || b.length % 4 !== 0)
    throw new Error(invalidEntropy);
  const F = Uint8Array.from(b);
  if (deriveChecksumBits(F) !== A)
    throw new Error(invalidChecksum);
  return F;
}
bip39.mnemonicToEntropy = mnemonicToEntropy;
class EnglishMnemonic {
  constructor(c) {
    if (!EnglishMnemonic.mnemonicMatcher.test(c))
      throw new Error("Invalid mnemonic format");
    const u = c.split(" "), p = [12, 15, 18, 21, 24];
    if (p.indexOf(u.length) === -1)
      throw new Error(`Invalid word count in mnemonic (allowed: ${p} got: ${u.length})`);
    for (const a of u)
      if (EnglishMnemonic.wordlist.indexOf(a) === -1)
        throw new Error("Mnemonic contains invalid word");
    mnemonicToEntropy(c), this.data = c;
  }
  toString() {
    return this.data;
  }
}
bip39.EnglishMnemonic = EnglishMnemonic;
EnglishMnemonic.wordlist = wordlist;
EnglishMnemonic.mnemonicMatcher = /^[a-z]+( [a-z]+)*$/;
class Bip39 {
  /**
   * Encodes raw entropy of length 16, 20, 24, 28 or 32 bytes as an English mnemonic between 12 and 24 words.
   *
   * | Entropy            | Words |
   * |--------------------|-------|
   * | 128 bit (16 bytes) |    12 |
   * | 160 bit (20 bytes) |    15 |
   * | 192 bit (24 bytes) |    18 |
   * | 224 bit (28 bytes) |    21 |
   * | 256 bit (32 bytes) |    24 |
   *
   *
   * @see https://github.com/bitcoin/bips/blob/master/bip-0039.mediawiki#generating-the-mnemonic
   * @param entropy The entropy to be encoded. This must be cryptographically secure.
   */
  static encode(c) {
    return new EnglishMnemonic(entropyToMnemonic(c));
  }
  static decode(c) {
    return mnemonicToEntropy(c.toString());
  }
  static async mnemonicToSeed(c, u) {
    const p = (0, encoding_1$1.toUtf8)(normalize$2(c.toString())), a = "mnemonic" + (u ? normalize$2(u) : ""), A = (0, encoding_1$1.toUtf8)(a);
    return (0, pbkdf2_1.pbkdf2Sha512)(p, A, 2048, 64);
  }
}
bip39.Bip39 = Bip39;
var hmac = {};
Object.defineProperty(hmac, "__esModule", { value: !0 });
hmac.Hmac = void 0;
class Hmac {
  constructor(c, u) {
    const p = new c().blockSize;
    this.hash = (A) => new c().update(A).digest();
    let a = u;
    if (a.length > p && (a = this.hash(a)), a.length < p) {
      const A = new Uint8Array(p - a.length);
      a = new Uint8Array([...a, ...A]);
    }
    this.oKeyPad = a.map((A) => A ^ 92), this.iKeyPad = a.map((A) => A ^ 54), this.messageHasher = new c(), this.blockSize = p, this.update(this.iKeyPad);
  }
  update(c) {
    return this.messageHasher.update(c), this;
  }
  digest() {
    const c = this.messageHasher.digest();
    return this.hash(new Uint8Array([...this.oKeyPad, ...c]));
  }
}
hmac.Hmac = Hmac;
var keccak = {}, sha3 = {};
Object.defineProperty(sha3, "__esModule", { value: !0 });
sha3.shake256 = sha3.shake128 = sha3.keccak_512 = sha3.keccak_384 = sha3.keccak_256 = sha3.keccak_224 = sha3.sha3_512 = sha3.sha3_384 = sha3.sha3_256 = sha3.sha3_224 = sha3.Keccak = void 0;
sha3.keccakP = keccakP;
const _u64_ts_1 = _u64$1, utils_ts_1 = utils$O, _0n$e = BigInt(0), _1n$b = BigInt(1), _2n$7 = BigInt(2), _7n = BigInt(7), _256n$2 = BigInt(256), _0x71n = BigInt(113), SHA3_PI = [], SHA3_ROTL = [], _SHA3_IOTA = [];
for (let n = 0, c = _1n$b, u = 1, p = 0; n < 24; n++) {
  [u, p] = [p, (2 * u + 3 * p) % 5], SHA3_PI.push(2 * (5 * p + u)), SHA3_ROTL.push((n + 1) * (n + 2) / 2 % 64);
  let a = _0n$e;
  for (let A = 0; A < 7; A++)
    c = (c << _1n$b ^ (c >> _7n) * _0x71n) % _256n$2, c & _2n$7 && (a ^= _1n$b << (_1n$b << /* @__PURE__ */ BigInt(A)) - _1n$b);
  _SHA3_IOTA.push(a);
}
const IOTAS = (0, _u64_ts_1.split)(_SHA3_IOTA, !0), SHA3_IOTA_H = IOTAS[0], SHA3_IOTA_L = IOTAS[1], rotlH = (n, c, u) => u > 32 ? (0, _u64_ts_1.rotlBH)(n, c, u) : (0, _u64_ts_1.rotlSH)(n, c, u), rotlL = (n, c, u) => u > 32 ? (0, _u64_ts_1.rotlBL)(n, c, u) : (0, _u64_ts_1.rotlSL)(n, c, u);
function keccakP(n, c = 24) {
  const u = new Uint32Array(10);
  for (let p = 24 - c; p < 24; p++) {
    for (let b = 0; b < 10; b++)
      u[b] = n[b] ^ n[b + 10] ^ n[b + 20] ^ n[b + 30] ^ n[b + 40];
    for (let b = 0; b < 10; b += 2) {
      const F = (b + 8) % 10, le = (b + 2) % 10, L = u[le], pe = u[le + 1], $ = rotlH(L, pe, 1) ^ u[F], Ee = rotlL(L, pe, 1) ^ u[F + 1];
      for (let be = 0; be < 50; be += 10)
        n[b + be] ^= $, n[b + be + 1] ^= Ee;
    }
    let a = n[2], A = n[3];
    for (let b = 0; b < 24; b++) {
      const F = SHA3_ROTL[b], le = rotlH(a, A, F), L = rotlL(a, A, F), pe = SHA3_PI[b];
      a = n[pe], A = n[pe + 1], n[pe] = le, n[pe + 1] = L;
    }
    for (let b = 0; b < 50; b += 10) {
      for (let F = 0; F < 10; F++)
        u[F] = n[b + F];
      for (let F = 0; F < 10; F++)
        n[b + F] ^= ~u[(F + 2) % 10] & u[(F + 4) % 10];
    }
    n[0] ^= SHA3_IOTA_H[p], n[1] ^= SHA3_IOTA_L[p];
  }
  (0, utils_ts_1.clean)(u);
}
class Keccak extends utils_ts_1.Hash {
  // NOTE: we accept arguments in bytes instead of bits here.
  constructor(c, u, p, a = !1, A = 24) {
    if (super(), this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, this.enableXOF = !1, this.blockLen = c, this.suffix = u, this.outputLen = p, this.enableXOF = a, this.rounds = A, (0, utils_ts_1.anumber)(p), !(0 < c && c < 200))
      throw new Error("only keccak-f1600 function is supported");
    this.state = new Uint8Array(200), this.state32 = (0, utils_ts_1.u32)(this.state);
  }
  clone() {
    return this._cloneInto();
  }
  keccak() {
    (0, utils_ts_1.swap32IfBE)(this.state32), keccakP(this.state32, this.rounds), (0, utils_ts_1.swap32IfBE)(this.state32), this.posOut = 0, this.pos = 0;
  }
  update(c) {
    (0, utils_ts_1.aexists)(this), c = (0, utils_ts_1.toBytes)(c), (0, utils_ts_1.abytes)(c);
    const { blockLen: u, state: p } = this, a = c.length;
    for (let A = 0; A < a; ) {
      const b = Math.min(u - this.pos, a - A);
      for (let F = 0; F < b; F++)
        p[this.pos++] ^= c[A++];
      this.pos === u && this.keccak();
    }
    return this;
  }
  finish() {
    if (this.finished)
      return;
    this.finished = !0;
    const { state: c, suffix: u, pos: p, blockLen: a } = this;
    c[p] ^= u, u & 128 && p === a - 1 && this.keccak(), c[a - 1] ^= 128, this.keccak();
  }
  writeInto(c) {
    (0, utils_ts_1.aexists)(this, !1), (0, utils_ts_1.abytes)(c), this.finish();
    const u = this.state, { blockLen: p } = this;
    for (let a = 0, A = c.length; a < A; ) {
      this.posOut >= p && this.keccak();
      const b = Math.min(p - this.posOut, A - a);
      c.set(u.subarray(this.posOut, this.posOut + b), a), this.posOut += b, a += b;
    }
    return c;
  }
  xofInto(c) {
    if (!this.enableXOF)
      throw new Error("XOF is not possible for this instance");
    return this.writeInto(c);
  }
  xof(c) {
    return (0, utils_ts_1.anumber)(c), this.xofInto(new Uint8Array(c));
  }
  digestInto(c) {
    if ((0, utils_ts_1.aoutput)(c, this), this.finished)
      throw new Error("digest() was already called");
    return this.writeInto(c), this.destroy(), c;
  }
  digest() {
    return this.digestInto(new Uint8Array(this.outputLen));
  }
  destroy() {
    this.destroyed = !0, (0, utils_ts_1.clean)(this.state);
  }
  _cloneInto(c) {
    const { blockLen: u, suffix: p, outputLen: a, rounds: A, enableXOF: b } = this;
    return c || (c = new Keccak(u, p, a, b, A)), c.state32.set(this.state32), c.pos = this.pos, c.posOut = this.posOut, c.finished = this.finished, c.rounds = A, c.suffix = p, c.outputLen = a, c.enableXOF = b, c.destroyed = this.destroyed, c;
  }
}
sha3.Keccak = Keccak;
const gen = (n, c, u) => (0, utils_ts_1.createHasher)(() => new Keccak(c, n, u));
sha3.sha3_224 = gen(6, 144, 224 / 8);
sha3.sha3_256 = gen(6, 136, 256 / 8);
sha3.sha3_384 = gen(6, 104, 384 / 8);
sha3.sha3_512 = gen(6, 72, 512 / 8);
sha3.keccak_224 = gen(1, 144, 224 / 8);
sha3.keccak_256 = gen(1, 136, 256 / 8);
sha3.keccak_384 = gen(1, 104, 384 / 8);
sha3.keccak_512 = gen(1, 72, 512 / 8);
const genShake = (n, c, u) => (0, utils_ts_1.createXOFer)((p = {}) => new Keccak(c, n, p.dkLen === void 0 ? u : p.dkLen, !0));
sha3.shake128 = genShake(31, 168, 128 / 8);
sha3.shake256 = genShake(31, 136, 256 / 8);
Object.defineProperty(keccak, "__esModule", { value: !0 });
keccak.keccak256 = keccak.Keccak256 = void 0;
const sha3_1 = sha3, utils_1$2 = utils$2;
class Keccak256 {
  constructor(c) {
    this.blockSize = 512 / 8, this.impl = sha3_1.keccak_256.create(), c && this.update(c);
  }
  update(c) {
    return this.impl.update((0, utils_1$2.toRealUint8Array)(c)), this;
  }
  digest() {
    return this.impl.digest();
  }
}
keccak.Keccak256 = Keccak256;
function keccak256(n) {
  return new Keccak256(n).digest();
}
keccak.keccak256 = keccak256;
var libsodium = {}, libsodiumWrappers = {}, libsodiumSumo = { exports: {} }, empty = null;
const empty$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: empty
}, Symbol.toStringTag, { value: "Module" })), require$$0 = /* @__PURE__ */ getAugmentedNamespace(empty$1);
var pathBrowserify, hasRequiredPathBrowserify;
function requirePathBrowserify() {
  if (hasRequiredPathBrowserify) return pathBrowserify;
  hasRequiredPathBrowserify = 1;
  function n(a) {
    if (typeof a != "string")
      throw new TypeError("Path must be a string. Received " + JSON.stringify(a));
  }
  function c(a, A) {
    for (var b = "", F = 0, le = -1, L = 0, pe, $ = 0; $ <= a.length; ++$) {
      if ($ < a.length)
        pe = a.charCodeAt($);
      else {
        if (pe === 47)
          break;
        pe = 47;
      }
      if (pe === 47) {
        if (!(le === $ - 1 || L === 1)) if (le !== $ - 1 && L === 2) {
          if (b.length < 2 || F !== 2 || b.charCodeAt(b.length - 1) !== 46 || b.charCodeAt(b.length - 2) !== 46) {
            if (b.length > 2) {
              var Ee = b.lastIndexOf("/");
              if (Ee !== b.length - 1) {
                Ee === -1 ? (b = "", F = 0) : (b = b.slice(0, Ee), F = b.length - 1 - b.lastIndexOf("/")), le = $, L = 0;
                continue;
              }
            } else if (b.length === 2 || b.length === 1) {
              b = "", F = 0, le = $, L = 0;
              continue;
            }
          }
          A && (b.length > 0 ? b += "/.." : b = "..", F = 2);
        } else
          b.length > 0 ? b += "/" + a.slice(le + 1, $) : b = a.slice(le + 1, $), F = $ - le - 1;
        le = $, L = 0;
      } else pe === 46 && L !== -1 ? ++L : L = -1;
    }
    return b;
  }
  function u(a, A) {
    var b = A.dir || A.root, F = A.base || (A.name || "") + (A.ext || "");
    return b ? b === A.root ? b + F : b + a + F : F;
  }
  var p = {
    // path.resolve([from ...], to)
    resolve: function() {
      for (var A = "", b = !1, F, le = arguments.length - 1; le >= -1 && !b; le--) {
        var L;
        le >= 0 ? L = arguments[le] : (F === void 0 && (F = process$1.cwd()), L = F), n(L), L.length !== 0 && (A = L + "/" + A, b = L.charCodeAt(0) === 47);
      }
      return A = c(A, !b), b ? A.length > 0 ? "/" + A : "/" : A.length > 0 ? A : ".";
    },
    normalize: function(A) {
      if (n(A), A.length === 0) return ".";
      var b = A.charCodeAt(0) === 47, F = A.charCodeAt(A.length - 1) === 47;
      return A = c(A, !b), A.length === 0 && !b && (A = "."), A.length > 0 && F && (A += "/"), b ? "/" + A : A;
    },
    isAbsolute: function(A) {
      return n(A), A.length > 0 && A.charCodeAt(0) === 47;
    },
    join: function() {
      if (arguments.length === 0)
        return ".";
      for (var A, b = 0; b < arguments.length; ++b) {
        var F = arguments[b];
        n(F), F.length > 0 && (A === void 0 ? A = F : A += "/" + F);
      }
      return A === void 0 ? "." : p.normalize(A);
    },
    relative: function(A, b) {
      if (n(A), n(b), A === b || (A = p.resolve(A), b = p.resolve(b), A === b)) return "";
      for (var F = 1; F < A.length && A.charCodeAt(F) === 47; ++F)
        ;
      for (var le = A.length, L = le - F, pe = 1; pe < b.length && b.charCodeAt(pe) === 47; ++pe)
        ;
      for (var $ = b.length, Ee = $ - pe, be = L < Ee ? L : Ee, He = -1, Pe = 0; Pe <= be; ++Pe) {
        if (Pe === be) {
          if (Ee > be) {
            if (b.charCodeAt(pe + Pe) === 47)
              return b.slice(pe + Pe + 1);
            if (Pe === 0)
              return b.slice(pe + Pe);
          } else L > be && (A.charCodeAt(F + Pe) === 47 ? He = Pe : Pe === 0 && (He = 0));
          break;
        }
        var nr = A.charCodeAt(F + Pe), ir = b.charCodeAt(pe + Pe);
        if (nr !== ir)
          break;
        nr === 47 && (He = Pe);
      }
      var or = "";
      for (Pe = F + He + 1; Pe <= le; ++Pe)
        (Pe === le || A.charCodeAt(Pe) === 47) && (or.length === 0 ? or += ".." : or += "/..");
      return or.length > 0 ? or + b.slice(pe + He) : (pe += He, b.charCodeAt(pe) === 47 && ++pe, b.slice(pe));
    },
    _makeLong: function(A) {
      return A;
    },
    dirname: function(A) {
      if (n(A), A.length === 0) return ".";
      for (var b = A.charCodeAt(0), F = b === 47, le = -1, L = !0, pe = A.length - 1; pe >= 1; --pe)
        if (b = A.charCodeAt(pe), b === 47) {
          if (!L) {
            le = pe;
            break;
          }
        } else
          L = !1;
      return le === -1 ? F ? "/" : "." : F && le === 1 ? "//" : A.slice(0, le);
    },
    basename: function(A, b) {
      if (b !== void 0 && typeof b != "string") throw new TypeError('"ext" argument must be a string');
      n(A);
      var F = 0, le = -1, L = !0, pe;
      if (b !== void 0 && b.length > 0 && b.length <= A.length) {
        if (b.length === A.length && b === A) return "";
        var $ = b.length - 1, Ee = -1;
        for (pe = A.length - 1; pe >= 0; --pe) {
          var be = A.charCodeAt(pe);
          if (be === 47) {
            if (!L) {
              F = pe + 1;
              break;
            }
          } else
            Ee === -1 && (L = !1, Ee = pe + 1), $ >= 0 && (be === b.charCodeAt($) ? --$ === -1 && (le = pe) : ($ = -1, le = Ee));
        }
        return F === le ? le = Ee : le === -1 && (le = A.length), A.slice(F, le);
      } else {
        for (pe = A.length - 1; pe >= 0; --pe)
          if (A.charCodeAt(pe) === 47) {
            if (!L) {
              F = pe + 1;
              break;
            }
          } else le === -1 && (L = !1, le = pe + 1);
        return le === -1 ? "" : A.slice(F, le);
      }
    },
    extname: function(A) {
      n(A);
      for (var b = -1, F = 0, le = -1, L = !0, pe = 0, $ = A.length - 1; $ >= 0; --$) {
        var Ee = A.charCodeAt($);
        if (Ee === 47) {
          if (!L) {
            F = $ + 1;
            break;
          }
          continue;
        }
        le === -1 && (L = !1, le = $ + 1), Ee === 46 ? b === -1 ? b = $ : pe !== 1 && (pe = 1) : b !== -1 && (pe = -1);
      }
      return b === -1 || le === -1 || // We saw a non-dot character immediately before the dot
      pe === 0 || // The (right-most) trimmed path component is exactly '..'
      pe === 1 && b === le - 1 && b === F + 1 ? "" : A.slice(b, le);
    },
    format: function(A) {
      if (A === null || typeof A != "object")
        throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof A);
      return u("/", A);
    },
    parse: function(A) {
      n(A);
      var b = { root: "", dir: "", base: "", ext: "", name: "" };
      if (A.length === 0) return b;
      var F = A.charCodeAt(0), le = F === 47, L;
      le ? (b.root = "/", L = 1) : L = 0;
      for (var pe = -1, $ = 0, Ee = -1, be = !0, He = A.length - 1, Pe = 0; He >= L; --He) {
        if (F = A.charCodeAt(He), F === 47) {
          if (!be) {
            $ = He + 1;
            break;
          }
          continue;
        }
        Ee === -1 && (be = !1, Ee = He + 1), F === 46 ? pe === -1 ? pe = He : Pe !== 1 && (Pe = 1) : pe !== -1 && (Pe = -1);
      }
      return pe === -1 || Ee === -1 || // We saw a non-dot character immediately before the dot
      Pe === 0 || // The (right-most) trimmed path component is exactly '..'
      Pe === 1 && pe === Ee - 1 && pe === $ + 1 ? Ee !== -1 && ($ === 0 && le ? b.base = b.name = A.slice(1, Ee) : b.base = b.name = A.slice($, Ee)) : ($ === 0 && le ? (b.name = A.slice(1, pe), b.base = A.slice(1, Ee)) : (b.name = A.slice($, pe), b.base = A.slice($, Ee)), b.ext = A.slice(pe, Ee)), $ > 0 ? b.dir = A.slice(0, $ - 1) : le && (b.dir = "/"), b;
    },
    sep: "/",
    delimiter: ":",
    win32: null,
    posix: null
  };
  return p.posix = p, pathBrowserify = p, pathBrowserify;
}
var hasRequiredLibsodiumSumo;
function requireLibsodiumSumo() {
  return hasRequiredLibsodiumSumo || (hasRequiredLibsodiumSumo = 1, function(n, c) {
    (function(u) {
      function p(a) {
        var A;
        (A = a) === void 0 && (A = {});
        var b = A;
        typeof b.sodium != "object" && (typeof commonjsGlobal == "object" ? b = commonjsGlobal : typeof window == "object" && (b = window));
        var F = A;
        return A.ready = new Promise(function(le, L) {
          ($ = F).onAbort = L, $.print = function(Wr) {
          }, $.printErr = function(Wr) {
          }, $.onRuntimeInitialized = function() {
            try {
              $._crypto_secretbox_keybytes(), le();
            } catch (Wr) {
              L(Wr);
            }
          }, $.useBackupModule = function() {
            return new Promise(function(Wr, ri) {
              (Er = {}).onAbort = ri, Er.onRuntimeInitialized = function() {
                Object.keys(F).forEach(function(vi) {
                  vi !== "getRandomValue" && delete F[vi];
                }), Object.keys(Er).forEach(function(vi) {
                  F[vi] = Er[vi];
                }), Wr();
              };
              var _i, Er = Er !== void 0 ? Er : {}, Di = typeof window == "object", _n = typeof importScripts == "function", On = typeof process$1 == "object" && typeof process$1.versions == "object" && typeof process$1.versions.node == "string", so = Object.assign({}, Er), Do = "";
              if (On) {
                var gn = require$$0, Gn = requirePathBrowserify();
                Do = __dirname + "/", _i = (vi) => (vi = fs(vi) ? new URL(vi) : Gn.normalize(vi), gn.readFileSync(vi)), !Er.thisProgram && process$1.argv.length > 1 && process$1.argv[1].replace(/\\/g, "/"), process$1.argv.slice(2), n.exports = Er;
              } else (Di || _n) && (_n ? Do = self.location.href : typeof document < "u" && document.currentScript && (Do = document.currentScript.src), Do = Do.startsWith("blob:") ? "" : Do.substr(0, Do.replace(/[?#].*/, "").lastIndexOf("/") + 1), _n && (_i = (vi) => {
                var xi = new XMLHttpRequest();
                return xi.open("GET", vi, !1), xi.responseType = "arraybuffer", xi.send(null), new Uint8Array(xi.response);
              }));
              Er.print;
              var pn, hn = Er.printErr || void 0;
              Object.assign(Er, so), so = null, Er.arguments && Er.arguments, Er.thisProgram && Er.thisProgram, Er.quit && Er.quit, Er.wasmBinary && (pn = Er.wasmBinary);
              var Rn, vo = { Memory: function(vi) {
                this.buffer = new ArrayBuffer(65536 * vi.initial);
              }, Module: function(vi) {
              }, Instance: function(vi, xi) {
                this.exports = function(Lr) {
                  for (var dn, xn = new Uint8Array(123), oi = 25; oi >= 0; --oi) xn[48 + oi] = 52 + oi, xn[65 + oi] = oi, xn[97 + oi] = 26 + oi;
                  function Yr(Cn, Mn, B) {
                    for (var o, m, d = 0, v = Mn, he = B.length, we = Mn + (3 * he >> 2) - (B[he - 2] == "=") - (B[he - 1] == "="); d < he; d += 4) o = xn[B.charCodeAt(d + 1)], m = xn[B.charCodeAt(d + 2)], Cn[v++] = xn[B.charCodeAt(d)] << 2 | o >> 4, v < we && (Cn[v++] = o << 4 | m >> 2), v < we && (Cn[v++] = m << 6 | xn[B.charCodeAt(d + 3)]);
                  }
                  function ji() {
                    throw new Error("abort");
                  }
                  return xn[43] = 62, xn[47] = 63, function(Cn) {
                    var Mn = new ArrayBuffer(50331648), B = new Int8Array(Mn), o = new Int32Array(Mn), m = new Uint8Array(Mn), d = new Uint32Array(Mn), v = Math.imul, he = Math.clz32, we = Cn.a, Be = we.a, Me = we.b, fr = we.c, wr = we.d, dr = 103696, Dr = 0, Rr = 0, Qe = 0;
                    function Fr(k, E) {
                      var T, M, ye, Ne, pr, ve = 0, cr = 0, gr = 0, Pr = 0, Nr = 0, Br = 0, Mr = 0, jr = 0, ti = 0, fi = 0, Jr = 0, li = 0, Tr = 0, Mi = 0, Wi = 0, vn = 0, Tn = 0, Ni = 0, Yi = 0, Xi = 0, $n = 0, Zn = 0, to = 0, fo = 0, wo = 0, bo = 0, go = 0, qn = 0, io = 0, So = 0, qo = 0, Ln = 0, ro = 0, Qo = 0, Vo = 0, as = 0, cs = 0, ms = 0, ai = 0, ci = 0, Fi = 0, Eo = 0, is = 0, ws = 0, ys = 0, Is = 0, ks = 0, Ps = 0, Po = 0, fn = 0, Qn = 0, zn = 0, es = 0, us = 0, Cs = 0, Es = 0, Rs = 0, Ds = 0, Ns = 0, Fs = 0, Qs = 0, Ys = 0, Vs = 0, Hs = 0, ra = 0, ca = 0, ua = 0, la = 0, ma = 0, Ba = 0, Ea = 0, _a = 0, xa = 0, Ka = 0;
                      Ds = m[E + 40 | 0] | m[E + 41 | 0] << 8 | m[E + 42 | 0] << 16 | m[E + 43 | 0] << 24, Fs = ve = m[E + 44 | 0] | m[E + 45 | 0] << 8 | m[E + 46 | 0] << 16 | m[E + 47 | 0] << 24, ks = m[E + 104 | 0] | m[E + 105 | 0] << 8 | m[E + 106 | 0] << 16 | m[E + 107 | 0] << 24, Qs = ve = m[E + 108 | 0] | m[E + 109 | 0] << 8 | m[E + 110 | 0] << 16 | m[E + 111 | 0] << 24, ve = m[E + 68 | 0] | m[E + 69 | 0] << 8 | m[E + 70 | 0] << 16 | m[E + 71 | 0] << 24, cs = m[E + 64 | 0] | m[E + 65 | 0] << 8 | m[E + 66 | 0] << 16 | m[E + 67 | 0] << 24, Po = ve, Ea = ve = m[E + 36 | 0] | m[E + 37 | 0] << 8 | m[E + 38 | 0] << 16 | m[E + 39 | 0] << 24, Tn = ve, es = m[E + 120 | 0] | m[E + 121 | 0] << 8 | m[E + 122 | 0] << 16 | m[E + 123 | 0] << 24, ra = ve = m[E + 124 | 0] | m[E + 125 | 0] << 8 | m[E + 126 | 0] << 16 | m[E + 127 | 0] << 24, ye = ve = m[E + 92 | 0] | m[E + 93 | 0] << 8 | m[E + 94 | 0] << 16 | m[E + 95 | 0] << 24, T = m[E + 88 | 0] | m[E + 89 | 0] << 8 | m[E + 90 | 0] << 16 | m[E + 91 | 0] << 24, as = ve, zn = m[E + 80 | 0] | m[E + 81 | 0] << 8 | m[E + 82 | 0] << 16 | m[E + 83 | 0] << 24, Vs = ve = m[E + 84 | 0] | m[E + 85 | 0] << 8 | m[E + 86 | 0] << 16 | m[E + 87 | 0] << 24, ms = ve, fn = m[k + 16 | 0] | m[k + 17 | 0] << 8 | m[k + 18 | 0] << 16 | m[k + 19 | 0] << 24, ve = (Cs = m[k + 52 | 0] | m[k + 53 | 0] << 8 | m[k + 54 | 0] << 16 | m[k + 55 | 0] << 24) + Tn | 0, Qo = (us = m[k + 48 | 0] | m[k + 49 | 0] << 8 | m[k + 50 | 0] << 16 | m[k + 51 | 0] << 24) + (Es = m[E + 32 | 0] | m[E + 33 | 0] << 8 | m[E + 34 | 0] << 16 | m[E + 35 | 0] << 24) | 0, ve = (m[k + 20 | 0] | m[k + 21 | 0] << 8 | m[k + 22 | 0] << 16 | m[k + 23 | 0] << 24) + (us >>> 0 > Qo >>> 0 ? ve + 1 | 0 : ve) | 0, ve = (fn = (cr = Qo) >>> 0 > (Qo = Qo + fn | 0) >>> 0 ? ve + 1 | 0 : ve) + Fs | 0, Qn = Ns = Qo + Ds | 0, Ns = ve = Ns >>> 0 < Qo >>> 0 ? ve + 1 | 0 : ve, Qo = Ci(Qo ^ (m[k + 80 | 0] | m[k + 81 | 0] << 8 | m[k + 82 | 0] << 16 | m[k + 83 | 0] << 24) ^ -79577749, fn ^ (m[k + 84 | 0] | m[k + 85 | 0] << 8 | m[k + 86 | 0] << 16 | m[k + 87 | 0] << 24) ^ 528734635, 32), la = ve = Qe, ve = ve + 1013904242 | 0, fn = Qo, Fi = ve = (Qo = Qo - 23791573 | 0) >>> 0 < 4271175723 ? ve + 1 | 0 : ve, Cs = Ci(Qo ^ us, ve ^ Cs, 40), ve = (ve = Ns) + (Ns = Qe) | 0, us = Ci(fn ^ (ti = us = Cs + Qn | 0), la ^ (fi = ti >>> 0 < Cs >>> 0 ? ve + 1 | 0 : ve), 48), ve = Fi + (Ln = Qe) | 0, Mi = ve = (us = Qo + (Jr = us) | 0) >>> 0 < Qo >>> 0 ? ve + 1 | 0 : ve, us = ve = Ci(Cs ^ (Tr = us), Ns ^ ve, 1), Fi = Qo = Qe, Ns = m[E + 24 | 0] | m[E + 25 | 0] << 8 | m[E + 26 | 0] << 16 | m[E + 27 | 0] << 24, la = ve = m[E + 28 | 0] | m[E + 29 | 0] << 8 | m[E + 30 | 0] << 16 | m[E + 31 | 0] << 24, Rs = m[k + 8 | 0] | m[k + 9 | 0] << 8 | m[k + 10 | 0] << 16 | m[k + 11 | 0] << 24, Qo = (Cs = m[E + 16 | 0] | m[E + 17 | 0] << 8 | m[E + 18 | 0] << 16 | m[E + 19 | 0] << 24) + (fn = m[k + 40 | 0] | m[k + 41 | 0] << 8 | m[k + 42 | 0] << 16 | m[k + 43 | 0] << 24) | 0, ve = (_a = m[E + 20 | 0] | m[E + 21 | 0] << 8 | m[E + 22 | 0] << 16 | m[E + 23 | 0] << 24) + (Ka = m[k + 44 | 0] | m[k + 45 | 0] << 8 | m[k + 46 | 0] << 16 | m[k + 47 | 0] << 24) | 0, ve = (m[k + 12 | 0] | m[k + 13 | 0] << 8 | m[k + 14 | 0] << 16 | m[k + 15 | 0] << 24) + (Qo >>> 0 < fn >>> 0 ? ve + 1 | 0 : ve) | 0, ve = la + (Qn = (cr = Qo) >>> 0 > (Qo = Qo + Rs | 0) >>> 0 ? ve + 1 | 0 : ve) | 0, ve = (Rs = Qo + Ns | 0) >>> 0 < Qo >>> 0 ? ve + 1 | 0 : ve, cr = Ci(Qo ^ (m[k + 72 | 0] | m[k + 73 | 0] << 8 | m[k + 74 | 0] << 16 | m[k + 75 | 0] << 24) ^ 725511199, Qn ^ (m[k + 76 | 0] | m[k + 77 | 0] << 8 | m[k + 78 | 0] << 16 | m[k + 79 | 0] << 24) ^ -1694144372, 32), Br = Ci(fn ^ (gr = cr - 2067093701 | 0), Ka ^ (So = (wo = Qo = Qe) - ((cr >>> 0 < 2067093701) + 1150833018 | 0) | 0), 40), ve = (ro = Qe) + ve | 0, ve = (fo = (Wi = Qo = Br + Rs | 0) >>> 0 < Br >>> 0 ? ve + 1 | 0 : ve) + Fi | 0, ve = (Wi >>> 0 > (Qo = Wi + us | 0) >>> 0 ? ve + 1 | 0 : ve) + ms | 0, ve = (fn = (Pr = Qo) >>> 0 > (Qo = Qo + zn | 0) >>> 0 ? ve + 1 | 0 : ve) + as | 0, qn = as = Qo + T | 0, jr = ve = as >>> 0 < Qo >>> 0 ? ve + 1 | 0 : ve, li = us, ca = Fi, Fi = Qo, Qn = fn, us = m[E + 8 | 0] | m[E + 9 | 0] << 8 | m[E + 10 | 0] << 16 | m[E + 11 | 0] << 24, Qo = ve = m[E + 12 | 0] | m[E + 13 | 0] << 8 | m[E + 14 | 0] << 16 | m[E + 15 | 0] << 24, Ka = ve = m[0 | k] | m[k + 1 | 0] << 8 | m[k + 2 | 0] << 16 | m[k + 3 | 0] << 24, Ne = fn = m[k + 4 | 0] | m[k + 5 | 0] << 8 | m[k + 6 | 0] << 16 | m[k + 7 | 0] << 24, ms = ve, ve = (ma = m[E + 4 | 0] | m[E + 5 | 0] << 8 | m[E + 6 | 0] << 16 | m[E + 7 | 0] << 24) + (Nr = m[k + 36 | 0] | m[k + 37 | 0] << 8 | m[k + 38 | 0] << 16 | m[k + 39 | 0] << 24) | 0, ve = Ne + ((as = m[k + 32 | 0] | m[k + 33 | 0] << 8 | m[k + 34 | 0] << 16 | m[k + 35 | 0] << 24) >>> 0 > (Pr = as + (fn = m[0 | E] | m[E + 1 | 0] << 8 | m[E + 2 | 0] << 16 | m[E + 3 | 0] << 24) | 0) >>> 0 ? ve + 1 | 0 : ve) | 0, ve = (Rs = (ms = Pr + ms | 0) >>> 0 < Pr >>> 0 ? ve + 1 | 0 : ve) + Qo | 0, Hs = Pr = ms + us | 0, Pr = ve = Pr >>> 0 < ms >>> 0 ? ve + 1 | 0 : ve, Mr = as, as = Ci(ms ^ (m[k + 64 | 0] | m[k + 65 | 0] << 8 | m[k + 66 | 0] << 16 | m[k + 67 | 0] << 24) ^ -1377402159, Rs ^ (m[k + 68 | 0] | m[k + 69 | 0] << 8 | m[k + 70 | 0] << 16 | m[k + 71 | 0] << 24) ^ 1359893119, 32), Rs = ve = Qe, ve = ve + 1779033703 | 0, ms = as, $n = ve = (as = as - 205731576 | 0) >>> 0 < 4089235720 ? ve + 1 | 0 : ve, Nr = Ci(Mr ^ (vn = as), ve ^ Nr, 40), ve = (go = Qe) + Pr | 0, Mr = Ci(ms ^ (Pr = as = Nr + Hs | 0), Rs ^ (Ni = Nr >>> 0 > Pr >>> 0 ? ve + 1 | 0 : ve), 48), ve = Ci(Mr ^ Fi, (is = Qe) ^ Qn, 32), ci = as = Qe, io = ve, M = ve = m[E + 60 | 0] | m[E + 61 | 0] << 8 | m[E + 62 | 0] << 16 | m[E + 63 | 0] << 24, Rs = Hs = m[E + 56 | 0] | m[E + 57 | 0] << 8 | m[E + 58 | 0] << 16 | m[E + 59 | 0] << 24, Xi = m[k + 24 | 0] | m[k + 25 | 0] << 8 | m[k + 26 | 0] << 16 | m[k + 27 | 0] << 24, as = (Qn = m[E + 48 | 0] | m[E + 49 | 0] << 8 | m[E + 50 | 0] << 16 | m[E + 51 | 0] << 24) + (ms = m[k + 56 | 0] | m[k + 57 | 0] << 8 | m[k + 58 | 0] << 16 | m[k + 59 | 0] << 24) | 0, ve = (Ba = m[E + 52 | 0] | m[E + 53 | 0] << 8 | m[E + 54 | 0] << 16 | m[E + 55 | 0] << 24) + (bo = m[k + 60 | 0] | m[k + 61 | 0] << 8 | m[k + 62 | 0] << 16 | m[k + 63 | 0] << 24) | 0, ve = (m[k + 28 | 0] | m[k + 29 | 0] << 8 | m[k + 30 | 0] << 16 | m[k + 31 | 0] << 24) + (as >>> 0 < ms >>> 0 ? ve + 1 | 0 : ve) | 0, ve = M + (Fi = (Yi = as) >>> 0 > (as = Xi + as | 0) >>> 0 ? ve + 1 | 0 : ve) | 0, ve = (Xi = as + Rs | 0) >>> 0 < as >>> 0 ? ve + 1 | 0 : ve, Fi = Ci(as ^ (m[k + 88 | 0] | m[k + 89 | 0] << 8 | m[k + 90 | 0] << 16 | m[k + 91 | 0] << 24) ^ 327033209, Fi ^ (m[k + 92 | 0] | m[k + 93 | 0] << 8 | m[k + 94 | 0] << 16 | m[k + 95 | 0] << 24) ^ 1541459225, 32), ms = Ci(ms ^ (Rs = Fi + 1595750129 | 0), (Yi = bo) ^ (bo = (Zn = as = Qe) - ((Fi >>> 0 < 2699217167) + 1521486533 | 0) | 0), 40), ve = (Is = Qe) + ve | 0, as = Ci((Xi = as = ms + Xi | 0) ^ Fi, Zn ^ (Yi = Xi >>> 0 < ms >>> 0 ? ve + 1 | 0 : ve), 48), ve = bo + (ws = Qe) | 0, to = ve = (as = Rs + (bo = as) | 0) >>> 0 < Rs >>> 0 ? ve + 1 | 0 : ve, ve = ci + ve | 0, ai = li ^ (Fi = io + (Zn = as) | 0), li = ve = Fi >>> 0 < Zn >>> 0 ? ve + 1 | 0 : ve, Rs = Ci(ai, ve ^ ca, 40), ve = (ca = Qe) + jr | 0, as = Ci(qn = io ^ (jr = as = Rs + qn | 0), ci ^ (io = jr >>> 0 < Rs >>> 0 ? ve + 1 | 0 : ve), 48), ve = li + (Ps = Qe) | 0, ci = ve = (li = Fi + (qn = as) | 0) >>> 0 < Fi >>> 0 ? ve + 1 | 0 : ve, as = (qo = Ci(li ^ Rs, ca ^ ve, 1)) + (Fi = m[E + 72 | 0] | m[E + 73 | 0] << 8 | m[E + 74 | 0] << 16 | m[E + 75 | 0] << 24) | 0, ve = (Ys = Qe) + (ca = m[E + 76 | 0] | m[E + 77 | 0] << 8 | m[E + 78 | 0] << 16 | m[E + 79 | 0] << 24) | 0, ua = as, Vo = as >>> 0 < Fi >>> 0 ? ve + 1 | 0 : ve, Eo = Qs, as = m[E + 96 | 0] | m[E + 97 | 0] << 8 | m[E + 98 | 0] << 16 | m[E + 99 | 0] << 24, Rs = ve = m[E + 100 | 0] | m[E + 101 | 0] << 8 | m[E + 102 | 0] << 16 | m[E + 103 | 0] << 24, ms = (ve = ti) + (ti = Ci(Zn ^ ms, to ^ Is, 1)) | 0, ve = (Zn = Qe) + fi | 0, ve = (ti >>> 0 > ms >>> 0 ? ve + 1 | 0 : ve) + Rs | 0, ve = (fi = (fi = ms) >>> 0 > (ms = as + ms | 0) >>> 0 ? ve + 1 | 0 : ve) + Eo | 0, ai = to = ms + ks | 0, to = ve = to >>> 0 < ms >>> 0 ? ve + 1 | 0 : ve, Wi = Ci(cr ^ Wi, fo ^ wo, 48), fo = ve = Ci(Wi ^ ms, (wo = Qe) ^ fi, 32), ve = $n + is | 0, ve = (Is = ms = Qe) + (vn = (ms = Mr + vn | 0) >>> 0 < Mr >>> 0 ? ve + 1 | 0 : ve) | 0, $n = ve = (fi = ms) >>> 0 > (Mr = fi + fo | 0) >>> 0 ? ve + 1 | 0 : ve, ti = Ci(Mr ^ ti, Zn ^ ve, 40), ve = (is = Qe) + to | 0, ve = (Zn = ti >>> 0 > (to = ms = ti + ai | 0) >>> 0 ? ve + 1 | 0 : ve) + Vo | 0, ve = (cr = to >>> 0 > (ms = to + ua | 0) >>> 0 ? ve + 1 | 0 : ve) + ra | 0, ua = Vo = ms + es | 0, Vo = ve = Vo >>> 0 < ms >>> 0 ? ve + 1 | 0 : ve, ai = ms, Eo = cr, ms = m[E + 116 | 0] | m[E + 117 | 0] << 8 | m[E + 118 | 0] << 16 | m[E + 119 | 0] << 24, E = m[E + 112 | 0] | m[E + 113 | 0] << 8 | m[E + 114 | 0] << 16 | m[E + 115 | 0] << 24, Nr = Ci(Nr ^ fi, vn ^ go, 1), ve = (go = Qe) + Yi | 0, ve = ((cr = Nr + Xi | 0) >>> 0 < Nr >>> 0 ? ve + 1 | 0 : ve) + ms | 0, ve = (fi = (vn = cr) >>> 0 > (cr = E + cr | 0) >>> 0 ? ve + 1 | 0 : ve) + ra | 0, xa = vn = cr + es | 0, vn = ve = vn >>> 0 < cr >>> 0 ? ve + 1 | 0 : ve, ve = Ci(cr ^ Jr, fi ^ Ln, 32), ys = cr = Qe, Jr = ve, fi = cr, ve = wo + So | 0, Wi = cr = gr + Wi | 0, Xi = ve = cr >>> 0 < gr >>> 0 ? ve + 1 | 0 : ve, ve = ve + fi | 0, Yi = cr = cr + Jr | 0, Ln = ve = Wi >>> 0 > cr >>> 0 ? ve + 1 | 0 : ve, fi = Ci(cr ^ Nr, go ^ ve, 40), ve = (go = Qe) + vn | 0, Jr = Ci((cr = fi + xa | 0) ^ Jr, ys ^ (gr = cr >>> 0 < fi >>> 0 ? ve + 1 | 0 : ve), 48), ve = Ci(Jr ^ ai, (xa = Qe) ^ Eo, 32), ys = Nr = Qe, vn = ve, ai = Nr, Br = Ci(Br ^ Wi, Xi ^ ro, 1), ve = Ni + (Wi = Qe) | 0, ve = ((Nr = Pr) >>> 0 > (Pr = Pr + Br | 0) >>> 0 ? ve + 1 | 0 : ve) + Po | 0, ve = (Pr = (Nr = Pr + cs | 0) >>> 0 < Pr >>> 0 ? ve + 1 | 0 : ve) + ca | 0, Eo = Ni = Nr + Fi | 0, Ni = ve = Ni >>> 0 < Nr >>> 0 ? ve + 1 | 0 : ve, Xi = Br, Nr = Ci(Nr ^ bo, Pr ^ ws, 32), ve = (bo = Qe) + Mi | 0, Tr = Ci(Xi ^ (Pr = Br = Nr + Tr | 0), (Mi = Nr >>> 0 > Pr >>> 0 ? ve + 1 | 0 : ve) ^ Wi, 40), ve = (ws = Qe) + Ni | 0, Wi = Br = Tr + Eo | 0, Br = Ci(Nr ^ Br, bo ^ (Ni = Br >>> 0 < Tr >>> 0 ? ve + 1 | 0 : ve), 48), ve = Mi + (pr = Qe) | 0, Mi = Br, bo = ve = (Br = Pr + Br | 0) >>> 0 < Pr >>> 0 ? ve + 1 | 0 : ve, ve = ve + ai | 0, ve = (Xi = Br) >>> 0 > (Br = Br + vn | 0) >>> 0 ? ve + 1 | 0 : ve, ai = Br, Br ^= qo, qo = ve, Nr = Ci(Br, Ys ^ ve, 40), ve = (Ys = Qe) + Vo | 0, Vo = Br = Nr + ua | 0, ve = ye + (Eo = Nr >>> 0 > Br >>> 0 ? ve + 1 | 0 : ve) | 0, ua = Br = Br + T | 0, wo = ve = Br >>> 0 < T >>> 0 ? ve + 1 | 0 : ve, Br = cr, So = ks, ro = Qs, cr = Ci(fo ^ to, Zn ^ Is, 48), ve = $n + (Is = Qe) | 0, fo = cr, $n = ve = (Pr = Mr + cr | 0) >>> 0 < Mr >>> 0 ? ve + 1 | 0 : ve, cr = Ci(Pr ^ ti, is ^ ve, 1), ve = (Mr = Qe) + ro | 0, ve = ((ti = cr + So | 0) >>> 0 < cr >>> 0 ? ve + 1 | 0 : ve) + gr | 0, ve = Ba + (Br = (gr = Br + ti | 0) >>> 0 < ti >>> 0 ? ve + 1 | 0 : ve) | 0, to = ti = gr + Qn | 0, ti = ve = ti >>> 0 < Qn >>> 0 ? ve + 1 | 0 : ve, gr = Ci(gr ^ Mi, Br ^ pr, 32), ve = ci + (Zn = Qe) | 0, Mi = gr, li = ve = (gr = li + gr | 0) >>> 0 < li >>> 0 ? ve + 1 | 0 : ve, Br = Ci(cr ^ gr, ve ^ Mr, 40), ve = (ve = ti) + (ti = Qe) | 0, Mr = cr = Br + to | 0, cr = Ci(cr ^ Mi, Zn ^ (to = cr >>> 0 < Br >>> 0 ? ve + 1 | 0 : ve), 48), ve = li + (is = Qe) | 0, Zn = cr, ci = ve = (li = gr + cr | 0) >>> 0 < gr >>> 0 ? ve + 1 | 0 : ve, cr = Ci(Br ^ li, ti ^ ve, 1), ve = (ti = Qe) + wo | 0, ve = M + (Br = (gr = cr + ua | 0) >>> 0 < cr >>> 0 ? ve + 1 | 0 : ve) | 0, ua = Mi = gr + Hs | 0, Mi = ve = Mi >>> 0 < Hs >>> 0 ? ve + 1 | 0 : ve, wo = cr, So = ti, ve = Ln + xa | 0, ve = (cr = Jr + Yi | 0) >>> 0 < Jr >>> 0 ? ve + 1 | 0 : ve, Jr = cr, Yi = ve, ve = Ci(cr ^ fi, go ^ ve, 1), fi = ti = Qe, cr = ve, ve = Ni + ms | 0, ve = ((Wi = E + Wi | 0) >>> 0 < E >>> 0 ? ve + 1 | 0 : ve) + ti | 0, ve = Vs + (Wi = (ti = cr + Wi | 0) >>> 0 < Wi >>> 0 ? ve + 1 | 0 : ve) | 0, Ln = Ni = ti + zn | 0, Ni = ve = Ni >>> 0 < zn >>> 0 ? ve + 1 | 0 : ve, ti = Ci(ti ^ qn, Wi ^ Ps, 32), ve = $n + (qn = Qe) | 0, Wi = ti, $n = ve = ($n = Pr) >>> 0 > (Pr = Pr + ti | 0) >>> 0 ? ve + 1 | 0 : ve, ti = Ci(cr ^ Pr, ve ^ fi, 40), ve = (go = Qe) + Ni | 0, fi = cr = ti + Ln | 0, cr = Ci(Ni = cr ^ Wi, qn ^ (Wi = cr >>> 0 < ti >>> 0 ? ve + 1 | 0 : ve), 48), ve = $n + (Ps = Qe) | 0, $n = cr, Ni = cr = Pr + cr | 0, qn = ve = cr >>> 0 < Pr >>> 0 ? ve + 1 | 0 : ve, Ln = gr, ro = Br, cr = Ci(Tr ^ Xi, bo ^ ws, 1), ve = (Pr = Qe) + Tn | 0, ve = io + ((gr = cr + Es | 0) >>> 0 < cr >>> 0 ? ve + 1 | 0 : ve) | 0, ve = Po + (Br = (gr = gr + jr | 0) >>> 0 < jr >>> 0 ? ve + 1 | 0 : ve) | 0, io = jr = gr + cs | 0, jr = ve = jr >>> 0 < gr >>> 0 ? ve + 1 | 0 : ve, Tr = cr, cr = (gr = Ci(gr ^ fo, Br ^ Is, 32)) + Jr | 0, ve = (Jr = Qe) + Yi | 0, Br = cr, Pr = Ci(cr ^ Tr, (fo = cr >>> 0 < gr >>> 0 ? ve + 1 | 0 : ve) ^ Pr, 40), ve = (Is = Qe) + jr | 0, jr = cr = Pr + io | 0, Xi = Ci(cr ^ gr, Jr ^ (io = cr >>> 0 < Pr >>> 0 ? ve + 1 | 0 : ve), 48), gr = Ci(Xi ^ Ln, (ve = ro) ^ (ro = Qe), 32), ve = (Ln = Qe) + qn | 0, Jr = cr = gr + Ni | 0, Tr = Ci(cr ^ wo, (Yi = cr >>> 0 < gr >>> 0 ? ve + 1 | 0 : ve) ^ So, 40), ve = (wo = Qe) + Mi | 0, Mi = cr = Tr + ua | 0, cr = Ci(cr ^ gr, Ln ^ (bo = cr >>> 0 < Tr >>> 0 ? ve + 1 | 0 : ve), 48), ve = Yi + (ws = Qe) | 0, Yi = cr, Ln = ve = (gr = Jr) >>> 0 > (Jr = Jr + cr | 0) >>> 0 ? ve + 1 | 0 : ve, cr = Ci(Jr ^ Tr, wo ^ ve, 1), ve = ra + (ua = Qe) | 0, wo = cr, xa = cr = es + cr | 0, Tr = ve = cr >>> 0 < es >>> 0 ? ve + 1 | 0 : ve, gr = Ds, cr = Ci(ti ^ Ni, go ^ qn, 1), ve = to + (ti = Qe) | 0, ve = ((Ni = Mr) >>> 0 > (Mr = cr + Mr | 0) >>> 0 ? ve + 1 | 0 : ve) + Fs | 0, ve = (Ni = (gr = gr + Mr | 0) >>> 0 < Mr >>> 0 ? ve + 1 | 0 : ve) + la | 0, So = Mr = gr + Ns | 0, to = ve = Mr >>> 0 < gr >>> 0 ? ve + 1 | 0 : ve, qn = cr, Mr = Ci(vn ^ Vo, Eo ^ ys, 48), ve = Ci(Mr ^ gr, (go = Qe) ^ Ni, 32), ys = cr = Qe, vn = ve, gr = cr, ve = fo + ro | 0, ve = (cr = Br + Xi | 0) >>> 0 < Br >>> 0 ? ve + 1 | 0 : ve, Br = cr, fo = ve, ve = ve + gr | 0, Ni = cr = cr + vn | 0, Xi = ve = Br >>> 0 > cr >>> 0 ? ve + 1 | 0 : ve, gr = Ci(cr ^ qn, ve ^ ti, 40), ve = (ve = to) + (to = Qe) | 0, qn = cr = gr + So | 0, Vo = ve = cr >>> 0 < gr >>> 0 ? ve + 1 | 0 : ve, ve = ve + Tr | 0, Eo = ve = (ti = cr + xa | 0) >>> 0 < cr >>> 0 ? ve + 1 | 0 : ve, Tr = ve, cr = Ci(Pr ^ Br, fo ^ Is, 1), ve = Qo + (Pr = Qe) | 0, ve = Wi + ((Br = cr + us | 0) >>> 0 < us >>> 0 ? ve + 1 | 0 : ve) | 0, ve = Rs + (fi = (Br = Br + fi | 0) >>> 0 < fi >>> 0 ? ve + 1 | 0 : ve) | 0, So = Wi = Br + as | 0, Wi = ve = Wi >>> 0 < as >>> 0 ? ve + 1 | 0 : ve, fo = cr, ve = Ci(Br ^ Zn, fi ^ is, 32), ro = cr = Qe, Br = ve, fi = cr, ve = go + qo | 0, Zn = cr = Mr + ai | 0, qo = ve = cr >>> 0 < Mr >>> 0 ? ve + 1 | 0 : ve, ve = ve + fi | 0, ve = (Mr = cr + Br | 0) >>> 0 < cr >>> 0 ? ve + 1 | 0 : ve, cr = Mr ^ fo, fo = ve, fi = Ci(cr, ve ^ Pr, 40), ve = (is = Qe) + Wi | 0, Pr = cr = fi + So | 0, ai = Ci(cr ^ Br, ro ^ (Wi = cr >>> 0 < fi >>> 0 ? ve + 1 | 0 : ve), 48), ve = Ci(ai ^ ti, (Is = Qe) ^ Tr, 32), xa = cr = Qe, So = ve, Tr = cr, cr = Ci(Nr ^ Zn, qo ^ Ys, 1), ve = io + (Nr = Qe) | 0, ve = ma + ((Br = cr + jr | 0) >>> 0 < jr >>> 0 ? ve + 1 | 0 : ve) | 0, ve = (jr = (Br = Br + fn | 0) >>> 0 < fn >>> 0 ? ve + 1 | 0 : ve) + _a | 0, Zn = io = Br + Cs | 0, io = ve = io >>> 0 < Br >>> 0 ? ve + 1 | 0 : ve, Br = Ci(Br ^ $n, jr ^ Ps, 32), ve = ci + (qo = Qe) | 0, $n = Br, jr = Nr, Nr = ve = (Br = li + Br | 0) >>> 0 < li >>> 0 ? ve + 1 | 0 : ve, jr = Ci(cr ^ Br, jr ^ ve, 40), ve = (Ps = Qe) + io | 0, li = cr = jr + Zn | 0, cr = Ci(Zn = cr ^ $n, qo ^ ($n = cr >>> 0 < jr >>> 0 ? ve + 1 | 0 : ve), 48), ve = Nr + (go = Qe) | 0, Nr = cr, io = cr = Br + cr | 0, Zn = ve = cr >>> 0 < Br >>> 0 ? ve + 1 | 0 : ve, ve = ve + Tr | 0, ci = ve = (Tr = cr + So | 0) >>> 0 < cr >>> 0 ? ve + 1 | 0 : ve, Br = Ci(Tr ^ wo, ua ^ ve, 40), ve = Eo + (qo = Qe) | 0, ve = ((cr = Br + ti | 0) >>> 0 < ti >>> 0 ? ve + 1 | 0 : ve) + Qs | 0, ti = cr, Eo = cr = cr + ks | 0, wo = ve = ti >>> 0 > cr >>> 0 ? ve + 1 | 0 : ve, ro = Po, ti = Ci(vn ^ qn, Vo ^ ys, 48), ve = (Ys = Qe) + Xi | 0, vn = cr = ti + Ni | 0, ve = Ci(cr ^ gr, (Ni = cr >>> 0 < ti >>> 0 ? ve + 1 | 0 : ve) ^ to, 1), to = gr = Qe, cr = ve, ve = Wi + ye | 0, ve = ((Pr = Pr + T | 0) >>> 0 < T >>> 0 ? ve + 1 | 0 : ve) + gr | 0, ve = (Pr = (gr = cr + Pr | 0) >>> 0 < Pr >>> 0 ? ve + 1 | 0 : ve) + ro | 0, Xi = Wi = gr + cs | 0, Wi = ve = Wi >>> 0 < gr >>> 0 ? ve + 1 | 0 : ve, gr = Ci(gr ^ Nr, Pr ^ go, 32), ve = Ln + (qn = Qe) | 0, Jr = ve = (Nr = gr + Jr | 0) >>> 0 < Jr >>> 0 ? ve + 1 | 0 : ve, Pr = Ci(cr ^ Nr, ve ^ to, 40), ve = (Vo = Qe) + Wi | 0, Wi = cr = Pr + Xi | 0, gr = Ci(cr ^ gr, qn ^ (to = cr >>> 0 < Pr >>> 0 ? ve + 1 | 0 : ve), 48), ve = Jr + (Xi = Qe) | 0, qn = ve = (Jr = gr + Nr | 0) >>> 0 < Nr >>> 0 ? ve + 1 | 0 : ve, cr = Ci(Pr ^ Jr, Vo ^ ve, 1), ve = (Vo = Qe) + wo | 0, ve = ca + ((Nr = cr + Eo | 0) >>> 0 < cr >>> 0 ? ve + 1 | 0 : ve) | 0, ve = (Pr = (Nr = Nr + Fi | 0) >>> 0 < Fi >>> 0 ? ve + 1 | 0 : ve) + Tn | 0, ua = Tn = Nr + Es | 0, Tn = ve = Tn >>> 0 < Nr >>> 0 ? ve + 1 | 0 : ve, Ln = cr, ro = Nr, go = Pr, Nr = Ds, cr = Ci(jr ^ io, Zn ^ Ps, 1), ve = bo + (jr = Qe) | 0, ve = ((Pr = Mi) >>> 0 > (Mi = cr + Mi | 0) >>> 0 ? ve + 1 | 0 : ve) + Fs | 0, ve = _a + (Pr = (Nr = Nr + Mi | 0) >>> 0 < Mi >>> 0 ? ve + 1 | 0 : ve) | 0, bo = Mi = Nr + Cs | 0, io = ve = Mi >>> 0 < Cs >>> 0 ? ve + 1 | 0 : ve, Mi = cr, Pr = ve = Ci(Nr ^ ti, Pr ^ Ys, 32), ve = fo + Is | 0, ve = (Zn = cr = Qe) + (Mr = (cr = Mr + ai | 0) >>> 0 < Mr >>> 0 ? ve + 1 | 0 : ve) | 0, fo = ve = (ti = cr + Pr | 0) >>> 0 < cr >>> 0 ? ve + 1 | 0 : ve, Mi = Ci(ti ^ Mi, ve ^ jr, 40), ve = (Is = Qe) + io | 0, io = Ci(bo = (Nr = Mi + bo | 0) ^ Pr, Zn ^ (Pr = Nr >>> 0 < Mi >>> 0 ? ve + 1 | 0 : ve), 48), ve = Ci(io ^ ro, (Ps = Qe) ^ go, 32), Ys = jr = Qe, bo = ve, Zn = jr, cr = Ci(cr ^ fi, Mr ^ is, 1), ve = Rs + (jr = Qe) | 0, ve = $n + ((Mr = cr + as | 0) >>> 0 < as >>> 0 ? ve + 1 | 0 : ve) | 0, ve = ma + (li = (Mr = Mr + li | 0) >>> 0 < li >>> 0 ? ve + 1 | 0 : ve) | 0, ro = fi = Mr + fn | 0, fi = ve = fi >>> 0 < fn >>> 0 ? ve + 1 | 0 : ve, $n = cr, ai = jr, Mr = Ci(Mr ^ Yi, li ^ ws, 32), ve = (Yi = Qe) + Ni | 0, jr = cr = Mr + vn | 0, li = Ci(cr ^ $n, (vn = cr >>> 0 < Mr >>> 0 ? ve + 1 | 0 : ve) ^ ai, 40), ve = (is = Qe) + fi | 0, $n = cr = li + ro | 0, cr = Ci(cr ^ Mr, Yi ^ (Ni = cr >>> 0 < li >>> 0 ? ve + 1 | 0 : ve), 48), ve = vn + (ro = Qe) | 0, fi = cr, vn = cr = jr + cr | 0, Yi = ve = cr >>> 0 < jr >>> 0 ? ve + 1 | 0 : ve, ve = ve + Zn | 0, Zn = cr = cr + bo | 0, Mr = Vo, Vo = ve = vn >>> 0 > cr >>> 0 ? ve + 1 | 0 : ve, Mr = Ci(cr ^ Ln, Mr ^ ve, 40), ve = (ve = Tn) + (Tn = Qe) | 0, ai = cr = Mr + ua | 0, Ln = ve = cr >>> 0 < Mr >>> 0 ? ve + 1 | 0 : ve, jr = Pr, cr = Ci(So ^ Eo, wo ^ xa, 48), ve = ci + (ws = Qe) | 0, ci = cr, Pr = (cr = Tr + cr | 0) ^ Br, Br = ve = cr >>> 0 < Tr >>> 0 ? ve + 1 | 0 : ve, Pr = Ci(Pr, ve ^ qo, 1), ve = (qo = Qe) + jr | 0, ve = M + ((Nr = Pr + Nr | 0) >>> 0 < Pr >>> 0 ? ve + 1 | 0 : ve) | 0, ve = (jr = (Nr = Nr + Hs | 0) >>> 0 < Hs >>> 0 ? ve + 1 | 0 : ve) + Qo | 0, Eo = Tr = Nr + us | 0, Tr = ve = Tr >>> 0 < Nr >>> 0 ? ve + 1 | 0 : ve, Nr = Ci(Nr ^ fi, jr ^ ro, 32), ve = qn + (wo = Qe) | 0, qn = Nr, Jr = ve = (jr = Jr + Nr | 0) >>> 0 < Jr >>> 0 ? ve + 1 | 0 : ve, Pr = Ci(Pr ^ jr, qo ^ ve, 40), ve = (ve = Tr) + (Tr = Qe) | 0, fi = Nr = Pr + Eo | 0, Nr = Ci(So = Nr ^ qn, wo ^ (qn = Nr >>> 0 < Pr >>> 0 ? ve + 1 | 0 : ve), 48), ve = Jr + (ua = Qe) | 0, qo = Nr, Eo = ve = (Jr = jr + Nr | 0) >>> 0 < jr >>> 0 ? ve + 1 | 0 : ve, Nr = Ci(Pr ^ Jr, Tr ^ ve, 1), ve = (Tr = Qe) + Ln | 0, ve = ye + ((Pr = Nr + ai | 0) >>> 0 < Nr >>> 0 ? ve + 1 | 0 : ve) | 0, ve = ms + (jr = (Pr = Pr + T | 0) >>> 0 < T >>> 0 ? ve + 1 | 0 : ve) | 0, xa = wo = E + Pr | 0, wo = ve = wo >>> 0 < E >>> 0 ? ve + 1 | 0 : ve, So = Nr, ro = Tr, Tr = Pr, go = jr, Nr = Ci(li ^ vn, Yi ^ is, 1), ve = (jr = Qe) + to | 0, ve = Vs + ((Pr = Nr + Wi | 0) >>> 0 < Nr >>> 0 ? ve + 1 | 0 : ve) | 0, ve = (li = (Pr = Pr + zn | 0) >>> 0 < zn >>> 0 ? ve + 1 | 0 : ve) + ms | 0, to = Wi = E + Pr | 0, Wi = ve = Wi >>> 0 < Pr >>> 0 ? ve + 1 | 0 : ve, vn = Nr, Pr = ve = Ci(Pr ^ ci, li ^ ws, 32), li = Nr = Qe, ve = fo + Ps | 0, fo = ve = (Nr = ti + io | 0) >>> 0 < ti >>> 0 ? ve + 1 | 0 : ve, ve = ve + li | 0, ve = (ti = Nr) >>> 0 > (Nr = Nr + Pr | 0) >>> 0 ? ve + 1 | 0 : ve, io = Nr, Nr ^= vn, vn = ve, jr = Ci(Nr, ve ^ jr, 40), ve = (is = Qe) + Wi | 0, li = Ci(Wi = (Nr = jr + to | 0) ^ Pr, li ^ (Pr = Nr >>> 0 < jr >>> 0 ? ve + 1 | 0 : ve), 48), ve = Ci(li ^ Tr, (ve = go) ^ (go = Qe), 32), ws = Tr = Qe, Wi = ve, to = Br, Br = gr, ve = Ci(ti ^ Mi, fo ^ Is, 1), Yi = gr = Qe, ti = ve, ve = Ni + la | 0, ve = ((Mi = $n + Ns | 0) >>> 0 < Ns >>> 0 ? ve + 1 | 0 : ve) + gr | 0, Mi = ve = (gr = ti + Mi | 0) >>> 0 < Mi >>> 0 ? ve + 1 | 0 : ve, Br = Ci(gr ^ Br, ve ^ Xi, 32), ve = (ve = to) + (to = Qe) | 0, ti = Ci((cr = Br + cr | 0) ^ ti, Yi ^ (fo = cr >>> 0 < Br >>> 0 ? ve + 1 | 0 : ve), 40), ve = Mi + (Is = Qe) | 0, $n = ti, ve = Ba + ((Ni = gr) >>> 0 > (gr = gr + ti | 0) >>> 0 ? ve + 1 | 0 : ve) | 0, Ni = ve = (ti = gr + Qn | 0) >>> 0 < Qn >>> 0 ? ve + 1 | 0 : ve, gr = Ci(Br ^ ti, to ^ ve, 48), ve = fo + (Ps = Qe) | 0, Xi = cr, Br = gr, fo = cr = cr + gr | 0, to = ve = Xi >>> 0 > cr >>> 0 ? ve + 1 | 0 : ve, ve = ve + Tr | 0, Xi = ve = (Tr = cr + Wi | 0) >>> 0 < cr >>> 0 ? ve + 1 | 0 : ve, cr = (Mi = Ci(Tr ^ So, ve ^ ro, 40)) + xa | 0, ve = (xa = Qe) + wo | 0, Yi = cr, ci = cr >>> 0 < Mi >>> 0 ? ve + 1 | 0 : ve, cr = Ci(bo ^ ai, Ln ^ Ys, 48), ve = (bo = Qe) + Vo | 0, Zn = gr = cr + Zn | 0, So = Tn, Tn = ve = gr >>> 0 < cr >>> 0 ? ve + 1 | 0 : ve, ve = Ci(gr ^ Mr, So ^ ve, 1), ai = gr = Qe, Mr = ve, ve = Pr + M | 0, ve = ((Nr = Nr + Hs | 0) >>> 0 < Hs >>> 0 ? ve + 1 | 0 : ve) + gr | 0, ve = ca + (Nr = (gr = Nr + Mr | 0) >>> 0 < Nr >>> 0 ? ve + 1 | 0 : ve) | 0, Ln = Pr = gr + Fi | 0, Pr = ve = Pr >>> 0 < Fi >>> 0 ? ve + 1 | 0 : ve, gr = Ci(gr ^ Br, Nr ^ Ps, 32), ve = Eo + (wo = Qe) | 0, Vo = gr, gr = (Br = Jr + gr | 0) ^ Mr, Mr = ve = Br >>> 0 < Jr >>> 0 ? ve + 1 | 0 : ve, Nr = Ci(gr, ai ^ ve, 40), ve = (ve = Pr) + (Pr = Qe) | 0, ai = gr = Nr + Ln | 0, gr = Ci(Jr = gr ^ Vo, wo ^ (Vo = gr >>> 0 < Nr >>> 0 ? ve + 1 | 0 : ve), 48), ve = Mr + (Ps = Qe) | 0, Eo = gr, Br = ve = (gr = Br + gr | 0) >>> 0 < Br >>> 0 ? ve + 1 | 0 : ve, Nr = Ci(gr ^ Nr, Pr ^ ve, 1), ve = (Jr = Qe) + ci | 0, ve = ra + ((Pr = Nr + Yi | 0) >>> 0 < Nr >>> 0 ? ve + 1 | 0 : ve) | 0, ve = (Mr = (Pr = Pr + es | 0) >>> 0 < es >>> 0 ? ve + 1 | 0 : ve) + Po | 0, ys = Ln = Pr + cs | 0, Ln = ve = Ln >>> 0 < Pr >>> 0 ? ve + 1 | 0 : ve, wo = Nr, So = Pr, ro = Mr, Nr = Ci($n ^ fo, to ^ Is, 1), ve = (to = Qe) + Qs | 0, ve = qn + (Nr >>> 0 > (Pr = Nr + ks | 0) >>> 0 ? ve + 1 | 0 : ve) | 0, Mr = ve = (Pr = Pr + fi | 0) >>> 0 < fi >>> 0 ? ve + 1 | 0 : ve, ve = Ci(cr ^ Pr, ve ^ bo, 32), bo = cr = Qe, fi = ve, ve = vn + go | 0, ve = (cr = li + io | 0) >>> 0 < li >>> 0 ? ve + 1 | 0 : ve, li = cr, fo = ve, ve = bo + ve | 0, vn = cr = cr + fi | 0, $n = ve = li >>> 0 > cr >>> 0 ? ve + 1 | 0 : ve, cr = Ci(cr ^ Nr, to ^ ve, 40), ve = Mr + (go = Qe) | 0, io = cr, ve = Rs + ((cr = Pr + cr | 0) >>> 0 < Pr >>> 0 ? ve + 1 | 0 : ve) | 0, ve = (cr = cr + as | 0) >>> 0 < as >>> 0 ? ve + 1 | 0 : ve, to = cr, cr ^= fi, fi = ve, Mr = Ci(cr, bo ^ ve, 48), ve = Ci(Mr ^ So, (ve = ro) ^ (ro = Qe), 32), Is = cr = Qe, bo = ve, qn = cr, cr = Ci(jr ^ li, fo ^ is, 1), ve = la + (Pr = Qe) | 0, ve = Ni + ((Nr = cr + Ns | 0) >>> 0 < Ns >>> 0 ? ve + 1 | 0 : ve) | 0, ve = (jr = (Nr = Nr + ti | 0) >>> 0 < ti >>> 0 ? ve + 1 | 0 : ve) + Qo | 0, Ni = li = Nr + us | 0, li = ve = li >>> 0 < Nr >>> 0 ? ve + 1 | 0 : ve, ti = cr, fo = Pr, cr = (Nr = Ci(Nr ^ qo, jr ^ ua, 32)) + Zn | 0, ve = (Zn = Qe) + Tn | 0, Pr = cr, jr = Ci(jr = cr ^ ti, (ti = cr >>> 0 < Nr >>> 0 ? ve + 1 | 0 : ve) ^ fo, 40), ve = (is = Qe) + li | 0, li = cr = jr + Ni | 0, Nr = Ci(cr ^ Nr, Zn ^ (Tn = cr >>> 0 < jr >>> 0 ? ve + 1 | 0 : ve), 48), ve = ti + (fo = Qe) | 0, Ni = cr = Nr + Pr | 0, Zn = ve = cr >>> 0 < Pr >>> 0 ? ve + 1 | 0 : ve, ve = ve + qn | 0, qn = ve = (ti = cr + bo | 0) >>> 0 < cr >>> 0 ? ve + 1 | 0 : ve, Pr = Ci(ti ^ wo, ve ^ Jr, 40), ve = (qo = Qe) + Ln | 0, Ln = cr = Pr + ys | 0, wo = ve = cr >>> 0 < Pr >>> 0 ? ve + 1 | 0 : ve, cr = gr, Jr = Br, Br = Nr, gr = Ci(Wi ^ Yi, ci ^ ws, 48), ve = Xi + (ys = Qe) | 0, Wi = gr, Tr = ve = (Nr = Tr + gr | 0) >>> 0 < Tr >>> 0 ? ve + 1 | 0 : ve, ve = Ci(Nr ^ Mi, xa ^ ve, 1), Xi = gr = Qe, Mi = ve, ve = fi + Ea | 0, ve = ((fi = to + Es | 0) >>> 0 < Es >>> 0 ? ve + 1 | 0 : ve) + gr | 0, fi = ve = (gr = fi + Mi | 0) >>> 0 < fi >>> 0 ? ve + 1 | 0 : ve, Br = Ci(gr ^ Br, ve ^ fo, 32), ve = (to = Qe) + Jr | 0, Mi = Ci((cr = Br + cr | 0) ^ Mi, Xi ^ (Jr = cr >>> 0 < Br >>> 0 ? ve + 1 | 0 : ve), 40), ve = fi + (Yi = Qe) | 0, ve = ma + ((fi = gr) >>> 0 > (gr = gr + Mi | 0) >>> 0 ? ve + 1 | 0 : ve) | 0, fo = ve = (fi = gr + fn | 0) >>> 0 < fn >>> 0 ? ve + 1 | 0 : ve, gr = Ci(Br ^ fi, to ^ ve, 48), ve = Jr + (ws = Qe) | 0, to = gr, Xi = ve = (Jr = cr + gr | 0) >>> 0 < cr >>> 0 ? ve + 1 | 0 : ve, cr = Ci(Jr ^ Mi, Yi ^ ve, 1), ve = (Mi = Qe) + wo | 0, ve = Vs + ((gr = cr + Ln | 0) >>> 0 < cr >>> 0 ? ve + 1 | 0 : ve) | 0, ve = ra + (Br = (gr = gr + zn | 0) >>> 0 < zn >>> 0 ? ve + 1 | 0 : ve) | 0, Ys = Yi = gr + es | 0, Yi = ve = Yi >>> 0 < es >>> 0 ? ve + 1 | 0 : ve, ci = cr, So = gr, cr = Ci(jr ^ Ni, Zn ^ is, 1), ve = (jr = Qe) + Vo | 0, ve = _a + ((gr = cr + ai | 0) >>> 0 < cr >>> 0 ? ve + 1 | 0 : ve) | 0, ve = Ba + (Ni = (gr = gr + Cs | 0) >>> 0 < Cs >>> 0 ? ve + 1 | 0 : ve) | 0, ai = Zn = gr + Qn | 0, Zn = ve = Zn >>> 0 < Qn >>> 0 ? ve + 1 | 0 : ve, Vo = cr, ve = Ci(gr ^ Wi, Ni ^ ys, 32), ys = cr = Qe, gr = ve, ve = $n + ro | 0, vn = cr = Mr + vn | 0, Wi = ve = cr >>> 0 < Mr >>> 0 ? ve + 1 | 0 : ve, ve = ys + ve | 0, $n = ve = (Mr = cr + gr | 0) >>> 0 < cr >>> 0 ? ve + 1 | 0 : ve, jr = Ci(Mr ^ Vo, ve ^ jr, 40), ve = (ro = Qe) + Zn | 0, Ni = cr = jr + ai | 0, Vo = Ci(cr ^ gr, ys ^ (Zn = cr >>> 0 < jr >>> 0 ? ve + 1 | 0 : ve), 48), ve = Ci(Vo ^ So, (ys = Qe) ^ Br, 32), is = cr = Qe, ai = ve, Br = cr, gr = Ds, cr = Ci(vn ^ io, Wi ^ go, 1), ve = Tn + (Wi = Qe) | 0, ve = ((vn = li) >>> 0 > (li = cr + li | 0) >>> 0 ? ve + 1 | 0 : ve) + Fs | 0, ve = Vs + (li = (gr = gr + li | 0) >>> 0 < li >>> 0 ? ve + 1 | 0 : ve) | 0, vn = Tn = gr + zn | 0, Tn = ve = Tn >>> 0 < zn >>> 0 ? ve + 1 | 0 : ve, gr = Ci(gr ^ Eo, li ^ Ps, 32), ve = Tr + (io = Qe) | 0, Tr = gr, ve = (gr = Nr + gr | 0) >>> 0 < Nr >>> 0 ? ve + 1 | 0 : ve, Nr = Wi, Wi = ve, Nr = Ci(cr ^ gr, Nr ^ ve, 40), ve = (go = Qe) + Tn | 0, li = cr = Nr + vn | 0, cr = Ci(cr ^ Tr, io ^ (Tn = cr >>> 0 < Nr >>> 0 ? ve + 1 | 0 : ve), 48), ve = Wi + (So = Qe) | 0, Wi = cr, vn = cr = gr + cr | 0, io = ve = cr >>> 0 < gr >>> 0 ? ve + 1 | 0 : ve, ve = ve + Br | 0, ve = (Tr = cr + ai | 0) >>> 0 < cr >>> 0 ? ve + 1 | 0 : ve, cr = Tr ^ ci, ci = ve, Mi = Ci(cr, ve ^ Mi, 40), ve = (Ps = Qe) + Yi | 0, Yi = cr = Mi + Ys | 0, Eo = cr >>> 0 < Mi >>> 0 ? ve + 1 | 0 : ve, cr = Ci(bo ^ Ln, wo ^ Is, 48), ve = qn + (Is = Qe) | 0, bo = cr, ve = (cr = ti + cr | 0) >>> 0 < ti >>> 0 ? ve + 1 | 0 : ve, ti = cr, qn = ve, ve = Ci(cr ^ Pr, ve ^ qo, 1), qo = cr = Qe, Br = ve, ve = Zn + ca | 0, ve = ((gr = Ni + Fi | 0) >>> 0 < Fi >>> 0 ? ve + 1 | 0 : ve) + cr | 0, ve = ma + (gr = (cr = gr + Br | 0) >>> 0 < gr >>> 0 ? ve + 1 | 0 : ve) | 0, Ni = Pr = cr + fn | 0, Pr = ve = Pr >>> 0 < fn >>> 0 ? ve + 1 | 0 : ve, cr = Ci(cr ^ Wi, gr ^ So, 32), ve = Xi + (Zn = Qe) | 0, Wi = cr, Jr = ve = (gr = Jr + cr | 0) >>> 0 < Jr >>> 0 ? ve + 1 | 0 : ve, Br = Ci(gr ^ Br, qo ^ ve, 40), ve = (qo = Qe) + Pr | 0, Ni = cr = Br + Ni | 0, cr = Ci(Pr = cr ^ Wi, Zn ^ (Wi = cr >>> 0 < Br >>> 0 ? ve + 1 | 0 : ve), 48), ve = Jr + (Ys = Qe) | 0, Jr = cr, Xi = ve = (Pr = gr + cr | 0) >>> 0 < gr >>> 0 ? ve + 1 | 0 : ve, cr = Ci(Pr ^ Br, qo ^ ve, 1), ve = (Zn = Qe) + Eo | 0, ve = la + ((gr = cr + Yi | 0) >>> 0 < cr >>> 0 ? ve + 1 | 0 : ve) | 0, ve = (Br = (gr = gr + Ns | 0) >>> 0 < Ns >>> 0 ? ve + 1 | 0 : ve) + Qs | 0, ua = qo = gr + ks | 0, qo = ve = qo >>> 0 < gr >>> 0 ? ve + 1 | 0 : ve, Ln = cr, wo = gr, So = Br, cr = Ci(Nr ^ vn, go ^ io, 1), ve = _a + (Br = Qe) | 0, ve = fo + ((gr = cr + Cs | 0) >>> 0 < Cs >>> 0 ? ve + 1 | 0 : ve) | 0, ve = Ea + (Nr = (gr = gr + fi | 0) >>> 0 < fi >>> 0 ? ve + 1 | 0 : ve) | 0, io = fi = gr + Es | 0, fi = ve = fi >>> 0 < Es >>> 0 ? ve + 1 | 0 : ve, fo = cr, vn = Br, ve = Ci(gr ^ bo, Nr ^ Is, 32), bo = cr = Qe, Nr = ve, gr = cr, ve = $n + ys | 0, ve = (cr = Mr + Vo | 0) >>> 0 < Mr >>> 0 ? ve + 1 | 0 : ve, Mr = cr, $n = ve, ve = ve + gr | 0, ve = (Br = cr + Nr | 0) >>> 0 < cr >>> 0 ? ve + 1 | 0 : ve, cr = Br ^ fo, fo = ve, cr = Ci(cr, ve ^ vn, 40), ve = (ve = fi) + (fi = Qe) | 0, vn = gr = cr + io | 0, io = ve = gr >>> 0 < cr >>> 0 ? ve + 1 | 0 : ve, bo = Ci(gr ^ Nr, bo ^ ve, 48), ve = Ci(bo ^ wo, (ve = So) ^ (So = Qe), 32), go = gr = Qe, Vo = ve, gr = Ci(Mr ^ jr, $n ^ ro, 1), ve = (Mr = Qe) + Fs | 0, ve = Tn + ((Nr = gr + Ds | 0) >>> 0 < gr >>> 0 ? ve + 1 | 0 : ve) | 0, ve = M + (jr = (Nr = Nr + li | 0) >>> 0 < li >>> 0 ? ve + 1 | 0 : ve) | 0, ro = li = Nr + Hs | 0, li = ve = li >>> 0 < Hs >>> 0 ? ve + 1 | 0 : ve, Tn = gr, $n = Mr, Nr = Ci(Nr ^ to, jr ^ ws, 32), ve = (to = Qe) + qn | 0, Mr = gr = Nr + ti | 0, gr = (jr = Ci(gr ^ Tn, (ti = gr >>> 0 < Nr >>> 0 ? ve + 1 | 0 : ve) ^ $n, 40)) + ro | 0, ve = (ro = Qe) + li | 0, Tn = gr, gr = Ci(gr ^ Nr, to ^ ($n = gr >>> 0 < jr >>> 0 ? ve + 1 | 0 : ve), 48), ve = ti + (ys = Qe) | 0, to = gr, qn = gr = Mr + gr | 0, wo = ve = gr >>> 0 < Mr >>> 0 ? ve + 1 | 0 : ve, ve = go + ve | 0, ve = (Nr = gr + Vo | 0) >>> 0 < gr >>> 0 ? ve + 1 | 0 : ve, gr = Zn, Zn = ve, Mr = Ci(Nr ^ Ln, gr ^ ve, 40), ve = (Is = Qe) + qo | 0, li = gr = Mr + ua | 0, ve = Ci(gr ^ Vo, go ^ (qo = gr >>> 0 < Mr >>> 0 ? ve + 1 | 0 : ve), 48), go = gr = Qe, Vo = ve, gr = cr, ve = fo + So | 0, fo = cr = Br + bo | 0, bo = ve = cr >>> 0 < Br >>> 0 ? ve + 1 | 0 : ve, ve = Ci(cr ^ gr, ve ^ fi, 1), Br = gr = Qe, cr = ve, ve = $n + ye | 0, ve = ((ti = Tn + T | 0) >>> 0 < T >>> 0 ? ve + 1 | 0 : ve) + gr | 0, ve = Rs + (ti = (gr = cr + ti | 0) >>> 0 < ti >>> 0 ? ve + 1 | 0 : ve) | 0, So = fi = gr + as | 0, fi = ve = fi >>> 0 < as >>> 0 ? ve + 1 | 0 : ve, Tn = cr, $n = Br, cr = Ci(Yi ^ ai, Eo ^ is, 48), ve = ci + (is = Qe) | 0, Yi = cr, ve = (cr = Tr + cr | 0) >>> 0 < Tr >>> 0 ? ve + 1 | 0 : ve, Tr = cr, gr = Ci(gr ^ Jr, ti ^ Ys, 32), ci = ve, ve = ve + (ai = Qe) | 0, Br = cr = gr + cr | 0, ti = Ci(cr ^ Tn, (Jr = cr >>> 0 < gr >>> 0 ? ve + 1 | 0 : ve) ^ $n, 40), ve = (Eo = Qe) + fi | 0, fi = cr = ti + So | 0, cr = Ci(cr ^ gr, ai ^ (Tn = cr >>> 0 < ti >>> 0 ? ve + 1 | 0 : ve), 48), ve = Jr + (ws = Qe) | 0, $n = cr, ai = ve = (Jr = Br + cr | 0) >>> 0 < Br >>> 0 ? ve + 1 | 0 : ve, cr = Ci(ti ^ Jr, Eo ^ ve, 1), ve = ma + (So = Qe) | 0, Eo = cr, Ys = cr = fn + cr | 0, Br = ve = cr >>> 0 < fn >>> 0 ? ve + 1 | 0 : ve, cr = Ci(Mi ^ Tr, ci ^ Ps, 1), ve = (ti = Qe) + io | 0, ve = Ba + ((gr = cr + vn | 0) >>> 0 < cr >>> 0 ? ve + 1 | 0 : ve) | 0, ve = Po + (Tr = (gr = gr + Qn | 0) >>> 0 < Qn >>> 0 ? ve + 1 | 0 : ve) | 0, ci = Mi = gr + cs | 0, Mi = ve = Mi >>> 0 < cs >>> 0 ? ve + 1 | 0 : ve, vn = ti, gr = Ci(gr ^ to, Tr ^ ys, 32), ve = Xi + (ys = Qe) | 0, io = gr, ve = (ti = Pr + gr | 0) >>> 0 < Pr >>> 0 ? ve + 1 | 0 : ve, Pr = vn, vn = ve, Tr = Ci(cr ^ ti, Pr ^ ve, 40), ve = (Ps = Qe) + Mi | 0, to = cr = Tr + ci | 0, ve = (Xi = cr >>> 0 < Tr >>> 0 ? ve + 1 | 0 : ve) + Br | 0, Mi = ve = (Br = cr + Ys | 0) >>> 0 < cr >>> 0 ? ve + 1 | 0 : ve, ci = ve = Ci(Br ^ Vo, ve ^ go, 32), Ln = cr = Qe, cr = Ci(jr ^ qn, wo ^ ro, 1), ve = (Pr = Qe) + Wi | 0, ve = ms + ((gr = cr + Ni | 0) >>> 0 < cr >>> 0 ? ve + 1 | 0 : ve) | 0, ve = (jr = (gr = E + gr | 0) >>> 0 < E >>> 0 ? ve + 1 | 0 : ve) + Qo | 0, wo = Wi = gr + us | 0, Wi = ve = Wi >>> 0 < gr >>> 0 ? ve + 1 | 0 : ve, Ni = cr, qn = Pr, gr = Ci(gr ^ Yi, jr ^ is, 32), ve = (Yi = Qe) + bo | 0, Pr = cr = gr + fo | 0, cr = (jr = Ci(cr ^ Ni, (fo = cr >>> 0 < gr >>> 0 ? ve + 1 | 0 : ve) ^ qn, 40)) + wo | 0, ve = (wo = Qe) + Wi | 0, Wi = cr, cr = Ci(cr ^ gr, Yi ^ (Ni = cr >>> 0 < jr >>> 0 ? ve + 1 | 0 : ve), 48), ve = fo + (is = Qe) | 0, fo = cr, Yi = ve = (cr = Pr + cr | 0) >>> 0 < Pr >>> 0 ? ve + 1 | 0 : ve, ve = ve + Ln | 0, bo = ve = (Pr = cr) >>> 0 > (cr = cr + ci | 0) >>> 0 ? ve + 1 | 0 : ve, gr = Ci(cr ^ Eo, So ^ ve, 40), ve = Mi + (So = Qe) | 0, qn = gr, ve = ye + ((gr = Br + gr | 0) >>> 0 < Br >>> 0 ? ve + 1 | 0 : ve) | 0, Eo = gr = gr + T | 0, Br = gr ^ ci, ci = ve = gr >>> 0 < T >>> 0 ? ve + 1 | 0 : ve, gr = Ci(Br, Ln ^ ve, 48), ve = bo + (Ln = Qe) | 0, bo = ve = (Mi = cr + gr | 0) >>> 0 < cr >>> 0 ? ve + 1 | 0 : ve, cr = ve = Ci(Mi ^ qn, So ^ ve, 1), qn = Br = Qe, Br = Ci(Pr ^ jr, Yi ^ wo, 1), ve = Tn + (jr = Qe) | 0, ve = Ba + ((Pr = Br + fi | 0) >>> 0 < fi >>> 0 ? ve + 1 | 0 : ve) | 0, ve = Vs + (fi = (Pr = Pr + Qn | 0) >>> 0 < Qn >>> 0 ? ve + 1 | 0 : ve) | 0, So = Tn = Pr + zn | 0, Tn = ve = Tn >>> 0 < zn >>> 0 ? ve + 1 | 0 : ve, Yi = Br, wo = jr, ve = Zn + go | 0, ve = (Br = Nr + Vo | 0) >>> 0 < Nr >>> 0 ? ve + 1 | 0 : ve, Zn = Br, io = Ci(to ^ io, Xi ^ ys, 48), jr = Ci(Pr ^ io, fi ^ (ys = Qe), 32), to = ve, ve = ve + (Ys = Qe) | 0, fi = Br = jr + Br | 0, Br = Ci(Br ^ Yi, (Xi = Br >>> 0 < jr >>> 0 ? ve + 1 | 0 : ve) ^ wo, 40), ve = (Yi = Qe) + Tn | 0, wo = ve = (Nr = Br + So | 0) >>> 0 < Br >>> 0 ? ve + 1 | 0 : ve, ve = ve + qn | 0, ve = M + ((Vo = Nr) >>> 0 > (Nr = cr + Nr | 0) >>> 0 ? ve + 1 | 0 : ve) | 0, ve = (Pr = (Nr = Nr + Hs | 0) >>> 0 < Hs >>> 0 ? ve + 1 | 0 : ve) + Fs | 0, ua = Tn = Nr + Ds | 0, So = ve = Tn >>> 0 < Nr >>> 0 ? ve + 1 | 0 : ve, ro = cr, go = Nr, ve = Ci(Mr ^ Zn, to ^ Is, 1), Mr = Nr = Qe, cr = ve, ve = Ni + _a | 0, ve = ((Tn = Wi + Cs | 0) >>> 0 < Cs >>> 0 ? ve + 1 | 0 : ve) + Nr | 0, ve = Rs + (Tn = (Nr = cr + Tn | 0) >>> 0 < Tn >>> 0 ? ve + 1 | 0 : ve) | 0, to = Wi = Nr + as | 0, Wi = ve = Wi >>> 0 < as >>> 0 ? ve + 1 | 0 : ve, Ni = cr, ve = Ci(Nr ^ $n, Tn ^ ws, 32), Zn = cr = Qe, Nr = ve, Tn = cr, ve = vn + ys | 0, vn = cr = ti + io | 0, $n = ve = cr >>> 0 < ti >>> 0 ? ve + 1 | 0 : ve, ve = ve + Tn | 0, ve = (ti = cr + Nr | 0) >>> 0 < cr >>> 0 ? ve + 1 | 0 : ve, cr = ti ^ Ni, Ni = ve, Tn = Ci(cr, ve ^ Mr, 40), ve = (ys = Qe) + Wi | 0, io = Ci(Wi = (cr = Tn + to | 0) ^ Nr, Zn ^ (Nr = cr >>> 0 < Tn >>> 0 ? ve + 1 | 0 : ve), 48), ve = Ci(ve = io ^ go, (go = Qe) ^ Pr, 32), Is = Pr = Qe, to = ve, Wi = Pr, Pr = Ci(Tr ^ vn, $n ^ Ps, 1), ve = Po + (Tr = Qe) | 0, ve = qo + ((Mr = Pr + cs | 0) >>> 0 < cs >>> 0 ? ve + 1 | 0 : ve) | 0, ve = la + (li = (Mr = Mr + li | 0) >>> 0 < li >>> 0 ? ve + 1 | 0 : ve) | 0, $n = vn = Mr + Ns | 0, vn = ve = vn >>> 0 < Ns >>> 0 ? ve + 1 | 0 : ve, Mr = Ci(Mr ^ fo, li ^ is, 32), ve = ai + (Zn = Qe) | 0, fo = Mr, Jr = ve = (Mr = Jr + Mr | 0) >>> 0 < Jr >>> 0 ? ve + 1 | 0 : ve, li = Ci(Pr ^ Mr, ve ^ Tr, 40), ve = (is = Qe) + vn | 0, Tr = Pr = li + $n | 0, Pr = Ci(vn = Pr ^ fo, Zn ^ (fo = Pr >>> 0 < li >>> 0 ? ve + 1 | 0 : ve), 48), ve = Jr + (ws = Qe) | 0, vn = Pr, $n = Pr = Mr + Pr | 0, Zn = ve = Pr >>> 0 < Mr >>> 0 ? ve + 1 | 0 : ve, ve = ve + Wi | 0, ve = (Mr = Pr + to | 0) >>> 0 < Pr >>> 0 ? ve + 1 | 0 : ve, Pr = qn, qn = ve, Jr = Ci(Mr ^ ro, Pr ^ ve, 40), ve = (qo = Qe) + So | 0, Wi = Pr = Jr + ua | 0, Pr = Ci(So = Pr ^ to, Is ^ (to = Pr >>> 0 < Jr >>> 0 ? ve + 1 | 0 : ve), 48), ve = qn + (Is = Qe) | 0, qn = Pr, Mr = ve = (Pr = Mr + Pr | 0) >>> 0 < Mr >>> 0 ? ve + 1 | 0 : ve, qo = ve = Ci(Pr ^ Jr, qo ^ ve, 1), Ps = ve, ai = Jr = Qe, Jr = Nr, Nr = Br, Br = Ci(jr ^ Vo, wo ^ Ys, 48), ve = Xi + (Ys = Qe) | 0, Xi = Br, ve = (Br = fi + Br | 0) >>> 0 < fi >>> 0 ? ve + 1 | 0 : ve, fi = cr, cr = Nr ^ Br, Nr = ve, cr = Ci(cr, ve ^ Yi, 1), ve = (Yi = Qe) + Jr | 0, ve = Ea + (cr >>> 0 > (jr = fi + cr | 0) >>> 0 ? ve + 1 | 0 : ve) | 0, ve = Qs + (fi = (jr = jr + Es | 0) >>> 0 < Es >>> 0 ? ve + 1 | 0 : ve) | 0, Vo = Jr = jr + ks | 0, Jr = ve = Jr >>> 0 < ks >>> 0 ? ve + 1 | 0 : ve, jr = Ci(jr ^ vn, fi ^ ws, 32), ve = bo + (wo = Qe) | 0, vn = ve = (fi = jr + Mi | 0) >>> 0 < Mi >>> 0 ? ve + 1 | 0 : ve, Mi = Ci(cr ^ fi, Yi ^ ve, 40), ve = (ws = Qe) + Jr | 0, Yi = cr = Mi + Vo | 0, jr = Ci(cr ^ jr, wo ^ (bo = cr >>> 0 < Mi >>> 0 ? ve + 1 | 0 : ve), 48), ve = vn + (Vo = Qe) | 0, wo = cr = jr + fi | 0, vn = cr, So = ve = cr >>> 0 < fi >>> 0 ? ve + 1 | 0 : ve, fi = Br, Jr = Nr, ve = Ni + go | 0, ve = (cr = ti + io | 0) >>> 0 < ti >>> 0 ? ve + 1 | 0 : ve, ti = cr, cr ^= Tn, Tn = ve, ve = Ci(cr, ys ^ ve, 1), ro = cr = Qe, Ni = ve, Nr = ve, ve = fo + Qo | 0, ve = ((Br = Tr + us | 0) >>> 0 < us >>> 0 ? ve + 1 | 0 : ve) + cr | 0, Tr = ve = (cr = Br) >>> 0 > (Br = Nr + Br | 0) >>> 0 ? ve + 1 | 0 : ve, Nr = Ci(gr ^ Br, ve ^ Ln, 32), ve = (ve = Jr) + (Jr = Qe) | 0, io = cr = Nr + fi | 0, gr = Ci(gr = cr ^ Ni, ro ^ (Ni = cr >>> 0 < Nr >>> 0 ? ve + 1 | 0 : ve), 40), ve = Tr + (Ln = Qe) | 0, ve = ca + ((cr = gr + Br | 0) >>> 0 < Br >>> 0 ? ve + 1 | 0 : ve) | 0, ro = ve = (fi = cr + Fi | 0) >>> 0 < Fi >>> 0 ? ve + 1 | 0 : ve, Jr = Ci(Nr ^ fi, Jr ^ ve, 48), ua = ve = Qe, cr = Ci(li ^ $n, Zn ^ is, 1), ve = (Nr = Qe) + ci | 0, ve = ra + ((Br = cr + Eo | 0) >>> 0 < cr >>> 0 ? ve + 1 | 0 : ve) | 0, ve = ms + (li = (Br = Br + es | 0) >>> 0 < es >>> 0 ? ve + 1 | 0 : ve) | 0, ci = Tr = E + Br | 0, $n = ve = Tr >>> 0 < E >>> 0 ? ve + 1 | 0 : ve, Zn = cr, Tr = Ci(Br ^ Xi, li ^ Ys, 32), ve = (is = Qe) + Tn | 0, Tn = cr = Tr + ti | 0, Br = Ci(cr ^ Zn, (Xi = cr >>> 0 < Tr >>> 0 ? ve + 1 | 0 : ve) ^ Nr, 40), ve = (ve = $n) + ($n = Qe) | 0, Zn = cr = Br + ci | 0, ci = ve = cr >>> 0 < Br >>> 0 ? ve + 1 | 0 : ve, Nr = ve, ve = ms + ai | 0, ve = ((li = E + qo | 0) >>> 0 < E >>> 0 ? ve + 1 | 0 : ve) + Nr | 0, fo = ve = (Nr = cr + li | 0) >>> 0 < li >>> 0 ? ve + 1 | 0 : ve, cr = Ci(Nr ^ Jr, ua ^ ve, 32), ve = (qo = Qe) + So | 0, ti = Ci((li = cr + vn | 0) ^ Ps, (ve = li >>> 0 < cr >>> 0 ? ve + 1 | 0 : ve) ^ ai, 40), ai = ve, ve = Qs + (vn = Qe) | 0, ve = fo + ((Eo = ti + ks | 0) >>> 0 < ks >>> 0 ? ve + 1 | 0 : ve) | 0, ve = (fo = Nr + Eo | 0) >>> 0 < Nr >>> 0 ? ve + 1 | 0 : ve, Nr = qo, qo = ve, Nr = Ci(cr ^ fo, Nr ^ ve, 48), ve = (ve = ai) + (ai = Qe) | 0, cr = ti ^ (li = Nr + li | 0), ti = ve = li >>> 0 < Nr >>> 0 ? ve + 1 | 0 : ve, Eo = ve = Ci(cr, ve ^ vn, 1), Ps = ve, go = cr = Qe, vn = Pr, ys = Mr, Pr = Br, Br = Ci(Tr ^ Zn, ci ^ is, 48), ve = Xi + (Zn = Qe) | 0, Tr = cr = Br + Tn | 0, Tn = ve = cr >>> 0 < Tn >>> 0 ? ve + 1 | 0 : ve, Pr = Ci(cr ^ Pr, ve ^ $n, 1), ve = (ci = Qe) + Ea | 0, ve = ro + ((cr = Pr + Es | 0) >>> 0 < Pr >>> 0 ? ve + 1 | 0 : ve) | 0, fi = ve = (Mr = cr + fi | 0) >>> 0 < fi >>> 0 ? ve + 1 | 0 : ve, cr = Ci(Mr ^ jr, ve ^ Vo, 32), ve = ($n = Qe) + ys | 0, vn = jr = cr + vn | 0, Xi = ve = jr >>> 0 < cr >>> 0 ? ve + 1 | 0 : ve, Pr = Ci(Pr ^ jr, ve ^ ci, 40), ve = Vs + (Ys = Qe) | 0, ci = Pr, ve = fi + ((Pr = zn + Pr | 0) >>> 0 < zn >>> 0 ? ve + 1 | 0 : ve) | 0, Mr = ve = (Pr = Pr + Mr | 0) >>> 0 < Mr >>> 0 ? ve + 1 | 0 : ve, jr = Ci(cr ^ Pr, ve ^ $n, 48), ve = (ve = Xi) + (Xi = Qe) | 0, Vo = cr = jr + vn | 0, $n = cr, ro = ve = cr >>> 0 < jr >>> 0 ? ve + 1 | 0 : ve, ve = Ni + ua | 0, vn = (cr = Jr + io | 0) ^ gr, gr = ve = cr >>> 0 < Jr >>> 0 ? ve + 1 | 0 : ve, ve = Ci(vn, ve ^ Ln, 1), Ln = fi = Qe, vn = ve, ve = bo + Rs | 0, ve = ((Jr = Yi + as | 0) >>> 0 < as >>> 0 ? ve + 1 | 0 : ve) + fi | 0, Ni = ve = (Ni = Jr) >>> 0 > (Jr = Jr + vn | 0) >>> 0 ? ve + 1 | 0 : ve, io = fi = Ci(Jr ^ qn, Is ^ ve, 32), Yi = ve = Qe, ve = ve + Tn | 0, bo = fi = fi + Tr | 0, qn = ve = io >>> 0 > fi >>> 0 ? ve + 1 | 0 : ve, fi = Ci(fi ^ vn, Ln ^ ve, 40), ve = Fs + (Ln = Qe) | 0, ve = Ni + ((Tr = fi + Ds | 0) >>> 0 < Ds >>> 0 ? ve + 1 | 0 : ve) | 0, Tr = ve = (vn = Jr) >>> 0 > (Jr = Jr + Tr | 0) >>> 0 ? ve + 1 | 0 : ve, vn = Ci(Jr ^ io, ve ^ Yi, 48), Is = ve = Qe, Tn = ve, Mi = Ci(Mi ^ wo, So ^ ws, 1), Ni = ve = Qe, io = Br, ve = ve + Qo | 0, ve = to + ((Br = Mi + us | 0) >>> 0 < us >>> 0 ? ve + 1 | 0 : ve) | 0, ve = (Br = Br + Wi | 0) >>> 0 < Wi >>> 0 ? ve + 1 | 0 : ve, Wi = Br ^ io, io = ve, Wi = Ci(Wi, ve ^ Zn, 32), ve = (ws = Qe) + gr | 0, to = cr = Wi + cr | 0, gr = Ci(cr ^ Mi, (gr = Ni) ^ (Ni = cr >>> 0 < Wi >>> 0 ? ve + 1 | 0 : ve), 40), ve = ra + (Yi = Qe) | 0, ve = io + ((cr = gr + es | 0) >>> 0 < es >>> 0 ? ve + 1 | 0 : ve) | 0, io = cr = cr + Br | 0, Zn = ve = cr >>> 0 < Br >>> 0 ? ve + 1 | 0 : ve, Br = ve, ve = go + Ba | 0, ve = ((Mi = Eo + Qn | 0) >>> 0 < Qn >>> 0 ? ve + 1 | 0 : ve) + Br | 0, Eo = ve = (Br = cr + Mi | 0) >>> 0 < Mi >>> 0 ? ve + 1 | 0 : ve, cr = Ci(Br ^ vn, ve ^ Tn, 32), ve = (wo = Qe) + ro | 0, Tn = Ci((Mi = cr + $n | 0) ^ Ps, (ve = Mi >>> 0 < cr >>> 0 ? ve + 1 | 0 : ve) ^ go, 40), So = $n = Qe, go = ve, ve = $n + la | 0, ve = Eo + (($n = Tn + Ns | 0) >>> 0 < Ns >>> 0 ? ve + 1 | 0 : ve) | 0, Eo = ve = ($n = Br + $n | 0) >>> 0 < Br >>> 0 ? ve + 1 | 0 : ve, Br = Ci(cr ^ $n, ve ^ wo, 48), ve = (wo = Qe) + go | 0, cr = (Mi = Br + Mi | 0) ^ Tn, Tn = ve = Mi >>> 0 < Br >>> 0 ? ve + 1 | 0 : ve, So = ve = Ci(cr, ve ^ So, 1), go = cr = Qe, ys = li, is = jr, jr = gr, gr = Ci(Wi ^ io, Zn ^ ws, 48), ve = (Wi = Qe) + Ni | 0, Ni = cr = gr + to | 0, io = ve = cr >>> 0 < gr >>> 0 ? ve + 1 | 0 : ve, jr = Ci(cr ^ jr, ve ^ Yi, 1), ve = (Yi = Qe) + ma | 0, ve = ((cr = jr + fn | 0) >>> 0 < jr >>> 0 ? ve + 1 | 0 : ve) + Tr | 0, Jr = ve = (li = cr + Jr | 0) >>> 0 < cr >>> 0 ? ve + 1 | 0 : ve, cr = Ci(li ^ is, ve ^ Xi, 32), ve = (Tr = Qe) + ti | 0, to = ti = cr + ys | 0, Xi = ve = ti >>> 0 < cr >>> 0 ? ve + 1 | 0 : ve, jr = Ci(jr ^ ti, ve ^ Yi, 40), ve = M + (is = Qe) | 0, Yi = jr, ve = Jr + ((jr = Hs + jr | 0) >>> 0 < Hs >>> 0 ? ve + 1 | 0 : ve) | 0, Zn = ve = (ti = jr + li | 0) >>> 0 < li >>> 0 ? ve + 1 | 0 : ve, jr = Ci(cr ^ ti, ve ^ Tr, 48), ve = (ve = Xi) + (Xi = Qe) | 0, to = cr = jr + to | 0, ys = ve = cr >>> 0 < jr >>> 0 ? ve + 1 | 0 : ve, Jr = Nr, li = Pr, ve = qn + Is | 0, Nr = ve = (cr = vn + bo | 0) >>> 0 < vn >>> 0 ? ve + 1 | 0 : ve, Pr = Ci(cr ^ fi, ve ^ Ln, 1), ve = (fi = Qe) + Po | 0, ve = ((Tr = Pr + cs | 0) >>> 0 < Pr >>> 0 ? ve + 1 | 0 : ve) + Mr | 0, Mr = Ci(Jr ^ (li = li + Tr | 0), (ve = li >>> 0 < Tr >>> 0 ? ve + 1 | 0 : ve) ^ ai, 32), Tr = ve, vn = Pr, ve = (Jr = Qe) + io | 0, ve = (Pr = Mr + Ni | 0) >>> 0 < Mr >>> 0 ? ve + 1 | 0 : ve, Ni = Pr, Pr ^= vn, vn = ve, Pr = Ci(Pr, ve ^ fi, 40), ve = ye + (io = Qe) | 0, ve = ((fi = Pr + T | 0) >>> 0 < T >>> 0 ? ve + 1 | 0 : ve) + Tr | 0, bo = ve = (Tr = fi) >>> 0 > (fi = fi + li | 0) >>> 0 ? ve + 1 | 0 : ve, Jr = Ci(Mr ^ fi, ve ^ Jr, 48), Is = ve = Qe, li = ve, Mr = Ci(Vo ^ ci, ro ^ Ys, 1), qn = ve = Qe, ci = Nr, ve = ve + ca | 0, ve = qo + ((Nr = Mr + Fi | 0) >>> 0 < Fi >>> 0 ? ve + 1 | 0 : ve) | 0, Tr = Wi, Wi = ve = (Nr = Nr + fo | 0) >>> 0 < fo >>> 0 ? ve + 1 | 0 : ve, Tr = Ci(gr ^ Nr, Tr ^ ve, 32), ve = (ws = Qe) + ci | 0, fo = cr = Tr + cr | 0, gr = Ci(cr ^ Mr, (gr = qn) ^ (qn = cr >>> 0 < Tr >>> 0 ? ve + 1 | 0 : ve), 40), ve = _a + (ci = Qe) | 0, ve = Wi + ((cr = gr + Cs | 0) >>> 0 < Cs >>> 0 ? ve + 1 | 0 : ve) | 0, qo = cr = cr + Nr | 0, Vo = ve = cr >>> 0 < Nr >>> 0 ? ve + 1 | 0 : ve, Nr = ve, ve = go + Rs | 0, ve = ((Mr = as + So | 0) >>> 0 < as >>> 0 ? ve + 1 | 0 : ve) + Nr | 0, Wi = ve = (Nr = cr + Mr | 0) >>> 0 < Mr >>> 0 ? ve + 1 | 0 : ve, cr = Ci(Nr ^ Jr, ve ^ li, 32), ve = (ai = Qe) + ys | 0, li = Ci((Mr = cr + to | 0) ^ So, (ve = Mr >>> 0 < cr >>> 0 ? ve + 1 | 0 : ve) ^ go, 40), So = ve, ve = Qo + (Ln = Qe) | 0, ve = Wi + ((ro = li + us | 0) >>> 0 < us >>> 0 ? ve + 1 | 0 : ve) | 0, ve = (Wi = Nr + ro | 0) >>> 0 < Nr >>> 0 ? ve + 1 | 0 : ve, Nr = ai, ai = ve, Nr = Ci(cr ^ Wi, Nr ^ ve, 48), ve = (ve = So) + (So = Qe) | 0, cr = (Mr = Nr + Mr | 0) ^ li, li = ve = Mr >>> 0 < Nr >>> 0 ? ve + 1 | 0 : ve, Ln = ve = Ci(cr, ve ^ Ln, 1), ro = cr = Qe, go = jr, jr = gr, gr = Ci(Tr ^ qo, Vo ^ ws, 48), ve = (ve = qn) + (qn = Qe) | 0, fo = cr = gr + fo | 0, Tr = ci, ci = ve = cr >>> 0 < gr >>> 0 ? ve + 1 | 0 : ve, jr = Ci(cr ^ jr, Tr ^ ve, 1), ve = (qo = Qe) + la | 0, ve = bo + ((cr = jr + Ns | 0) >>> 0 < jr >>> 0 ? ve + 1 | 0 : ve) | 0, Tr = fi, fi = cr + fi | 0, cr = Xi, Xi = ve = Tr >>> 0 > fi >>> 0 ? ve + 1 | 0 : ve, cr = Ci(fi ^ go, cr ^ ve, 32), ve = (ve = Tn) + (Tn = Qe) | 0, bo = ve = (Tr = cr + Mi | 0) >>> 0 < cr >>> 0 ? ve + 1 | 0 : ve, Mi = Tr, jr = Ci(jr ^ Tr, ve ^ qo, 40), ve = ca + (ws = Qe) | 0, qo = jr, ve = Xi + ((jr = Fi + jr | 0) >>> 0 < Fi >>> 0 ? ve + 1 | 0 : ve) | 0, Xi = ve = (Tr = jr + fi | 0) >>> 0 < fi >>> 0 ? ve + 1 | 0 : ve, jr = Ci(cr ^ Tr, ve ^ Tn, 48), ve = (ve = bo) + (bo = Qe) | 0, Vo = cr = jr + Mi | 0, go = ve = cr >>> 0 < jr >>> 0 ? ve + 1 | 0 : ve, Mi = Br, ve = vn + Is | 0, Br = ve = (cr = Jr + Ni | 0) >>> 0 < Jr >>> 0 ? ve + 1 | 0 : ve, Pr = Ci(cr ^ Pr, ve ^ io, 1), ve = Qs + (Jr = Qe) | 0, ve = Zn + ((fi = Pr + ks | 0) >>> 0 < ks >>> 0 ? ve + 1 | 0 : ve) | 0, vn = (fi = ti + fi | 0) ^ Mi, Mi = ve = fi >>> 0 < ti >>> 0 ? ve + 1 | 0 : ve, ti = Ci(vn, ve ^ wo, 32), Tn = ve = Qe, vn = Pr, ve = ve + ci | 0, ve = (Pr = ti + fo | 0) >>> 0 < ti >>> 0 ? ve + 1 | 0 : ve, Ni = Pr, Pr ^= vn, vn = ve, Pr = Ci(Pr, ve ^ Jr, 40), ve = ye + (io = Qe) | 0, ve = Mi + ((Jr = Pr + T | 0) >>> 0 < T >>> 0 ? ve + 1 | 0 : ve) | 0, Zn = ve = (Jr = fi + Jr | 0) >>> 0 < fi >>> 0 ? ve + 1 | 0 : ve, Mi = Ci(ti ^ Jr, ve ^ Tn, 48), Is = ve = Qe, fi = ve, ti = Ci(Yi ^ to, is ^ ys, 1), fo = ve = Qe, to = Br, ve = ve + M | 0, ve = Eo + ((Br = ti + Hs | 0) >>> 0 < Hs >>> 0 ? ve + 1 | 0 : ve) | 0, $n = ve = (Br = Br + $n | 0) >>> 0 < $n >>> 0 ? ve + 1 | 0 : ve, Tn = Ci(gr ^ Br, ve ^ qn, 32), ve = (Ps = Qe) + to | 0, to = cr = Tn + cr | 0, gr = Ci(cr ^ ti, (Yi = cr >>> 0 < Tn >>> 0 ? ve + 1 | 0 : ve) ^ fo, 40), ve = ms + (qn = Qe) | 0, ve = $n + ((cr = E + gr | 0) >>> 0 < E >>> 0 ? ve + 1 | 0 : ve) | 0, $n = cr = cr + Br | 0, ci = ve = cr >>> 0 < Br >>> 0 ? ve + 1 | 0 : ve, Br = ve, ve = ro + ra | 0, ve = ((ti = Ln + es | 0) >>> 0 < es >>> 0 ? ve + 1 | 0 : ve) + Br | 0, fo = ve = (Br = cr + ti | 0) >>> 0 < ti >>> 0 ? ve + 1 | 0 : ve, cr = Ci(Br ^ Mi, ve ^ fi, 32), ve = (Eo = Qe) + go | 0, fi = Ci((ti = cr + Vo | 0) ^ Ln, (ve = ti >>> 0 < cr >>> 0 ? ve + 1 | 0 : ve) ^ ro, 40), wo = ve, ve = Ea + (Ln = Qe) | 0, ve = fo + ((ro = fi + Es | 0) >>> 0 < Es >>> 0 ? ve + 1 | 0 : ve) | 0, ve = (fo = Br + ro | 0) >>> 0 < Br >>> 0 ? ve + 1 | 0 : ve, Br = Eo, Eo = ve, Br = Ci(cr ^ fo, Br ^ ve, 48), ve = (ve = wo) + (wo = Qe) | 0, cr = (ti = Br + ti | 0) ^ fi, fi = ve = ti >>> 0 < Br >>> 0 ? ve + 1 | 0 : ve, Ln = ve = Ci(cr, ve ^ Ln, 1), Ys = ve, ro = cr = Qe, ys = Mr, is = jr, Mr = gr, gr = Ci(Tn ^ $n, ci ^ Ps, 48), ve = (Tn = Qe) + Yi | 0, $n = cr = gr + to | 0, to = ve = cr >>> 0 < gr >>> 0 ? ve + 1 | 0 : ve, Mr = Ci(cr ^ Mr, ve ^ qn, 1), ve = (qn = Qe) + Fs | 0, ve = Zn + ((cr = Mr + Ds | 0) >>> 0 < Mr >>> 0 ? ve + 1 | 0 : ve) | 0, Jr = ve = (jr = cr + Jr | 0) >>> 0 < Jr >>> 0 ? ve + 1 | 0 : ve, cr = Ci(jr ^ is, ve ^ bo, 32), ve = (Yi = Qe) + li | 0, bo = ve = (li = cr + ys | 0) >>> 0 < cr >>> 0 ? ve + 1 | 0 : ve, Mr = Ci(Mr ^ li, ve ^ qn, 40), ve = ma + (Ps = Qe) | 0, Zn = Mr, ve = Jr + ((Mr = fn + Mr | 0) >>> 0 < fn >>> 0 ? ve + 1 | 0 : ve) | 0, Jr = Mr + jr | 0, Mr = Yi, Yi = ve = Jr >>> 0 < jr >>> 0 ? ve + 1 | 0 : ve, Mr = Ci(cr ^ Jr, Mr ^ ve, 48), ve = (ve = bo) + (bo = Qe) | 0, qn = cr = Mr + li | 0, ci = ve = cr >>> 0 < Mr >>> 0 ? ve + 1 | 0 : ve, jr = Nr, ve = vn + Is | 0, Nr = ve = (cr = Mi + Ni | 0) >>> 0 < Mi >>> 0 ? ve + 1 | 0 : ve, Pr = Ci(cr ^ Pr, ve ^ io, 1), ve = (Mi = Qe) + _a | 0, ve = Xi + ((li = Pr + Cs | 0) >>> 0 < Pr >>> 0 ? ve + 1 | 0 : ve) | 0, jr = Ci(jr ^ (li = li + Tr | 0), (ve = li >>> 0 < Tr >>> 0 ? ve + 1 | 0 : ve) ^ So, 32), vn = Tr = Qe, Tr = ve, Ni = Pr, ve = vn + to | 0, ve = (Pr = jr + $n | 0) >>> 0 < jr >>> 0 ? ve + 1 | 0 : ve, $n = Pr, Pr ^= Ni, Ni = ve, Pr = Ci(Pr, ve ^ Mi, 40), ve = Vs + (io = Qe) | 0, ve = ((Mi = Pr + zn | 0) >>> 0 < zn >>> 0 ? ve + 1 | 0 : ve) + Tr | 0, Xi = vn, vn = ve = (Tr = li + Mi | 0) >>> 0 < Mi >>> 0 ? ve + 1 | 0 : ve, Mi = Ci(jr ^ Tr, Xi ^ ve, 48), Is = ve = Qe, li = ve, jr = Ci(Vo ^ qo, go ^ ws, 1), to = ve = Qe, Xi = Nr, ve = ve + Po | 0, ve = ai + ((Nr = jr + cs | 0) >>> 0 < cs >>> 0 ? ve + 1 | 0 : ve) | 0, Wi = ve = (Nr = Nr + Wi | 0) >>> 0 < Wi >>> 0 ? ve + 1 | 0 : ve, Tn = Ci(gr ^ Nr, ve ^ Tn, 32), ve = (ws = Qe) + Xi | 0, Xi = cr = Tn + cr | 0, gr = Ci(cr ^ jr, (gr = to) ^ (to = cr >>> 0 < Tn >>> 0 ? ve + 1 | 0 : ve), 40), ve = Ba + (qo = Qe) | 0, ve = Wi + ((cr = gr + Qn | 0) >>> 0 < Qn >>> 0 ? ve + 1 | 0 : ve) | 0, Vo = cr = cr + Nr | 0, ai = ve = cr >>> 0 < Nr >>> 0 ? ve + 1 | 0 : ve, Nr = ve, ve = ro + ye | 0, ve = ((jr = Ln + T | 0) >>> 0 < T >>> 0 ? ve + 1 | 0 : ve) + Nr | 0, Wi = ve = (Nr = cr + jr | 0) >>> 0 < jr >>> 0 ? ve + 1 | 0 : ve, cr = Ci(Nr ^ Mi, ve ^ li, 32), ve = (Ln = Qe) + ci | 0, li = Ci((jr = cr + qn | 0) ^ Ys, (ve = jr >>> 0 < cr >>> 0 ? ve + 1 | 0 : ve) ^ ro, 40), ro = ve, ve = la + (So = Qe) | 0, ve = Wi + ((go = li + Ns | 0) >>> 0 < Ns >>> 0 ? ve + 1 | 0 : ve) | 0, ve = (Wi = Nr + go | 0) >>> 0 < Nr >>> 0 ? ve + 1 | 0 : ve, Nr = Ln, Ln = ve, Nr = Ci(cr ^ Wi, Nr ^ ve, 48), ve = (ve = ro) + (ro = Qe) | 0, cr = (jr = Nr + jr | 0) ^ li, li = ve = jr >>> 0 < Nr >>> 0 ? ve + 1 | 0 : ve, So = ve = Ci(cr, ve ^ So, 1), go = cr = Qe, ys = ti, is = Mr, Mr = gr, gr = Ci(Tn ^ Vo, ai ^ ws, 48), ve = (Tn = Qe) + to | 0, to = cr = gr + Xi | 0, Xi = ve = cr >>> 0 < gr >>> 0 ? ve + 1 | 0 : ve, Mr = Ci(cr ^ Mr, ve ^ qo, 1), ve = (qo = Qe) + ma | 0, ve = vn + ((cr = Mr + fn | 0) >>> 0 < Mr >>> 0 ? ve + 1 | 0 : ve) | 0, Tr = ve = (ti = cr + Tr | 0) >>> 0 < Tr >>> 0 ? ve + 1 | 0 : ve, cr = Ci(ti ^ is, ve ^ bo, 32), ve = (vn = Qe) + fi | 0, bo = ve = (fi = cr + ys | 0) >>> 0 < cr >>> 0 ? ve + 1 | 0 : ve, Mr = Ci(Mr ^ fi, ve ^ qo, 40), ve = Po + (ws = Qe) | 0, qo = Mr, ve = Tr + ((Mr = cs + Mr | 0) >>> 0 < cs >>> 0 ? ve + 1 | 0 : ve) | 0, Tr = Mr + ti | 0, Mr = vn, vn = ve = Tr >>> 0 < ti >>> 0 ? ve + 1 | 0 : ve, Mr = Ci(cr ^ Tr, Mr ^ ve, 48), ve = (ve = bo) + (bo = Qe) | 0, Vo = cr = Mr + fi | 0, ai = ve = cr >>> 0 < Mr >>> 0 ? ve + 1 | 0 : ve, ti = Br, ve = Ni + Is | 0, Br = ve = (cr = Mi + $n | 0) >>> 0 < Mi >>> 0 ? ve + 1 | 0 : ve, Pr = Ci(cr ^ Pr, ve ^ io, 1), ve = Ba + (Mi = Qe) | 0, ve = Yi + ((fi = Pr + Qn | 0) >>> 0 < Qn >>> 0 ? ve + 1 | 0 : ve) | 0, Jr = ve = (fi = fi + Jr | 0) >>> 0 < Jr >>> 0 ? ve + 1 | 0 : ve, ti = Ci(ti ^ fi, ve ^ wo, 32), $n = ve = Qe, Ni = Pr, ve = ve + Xi | 0, ve = (Pr = ti + to | 0) >>> 0 < ti >>> 0 ? ve + 1 | 0 : ve, io = Pr, Pr ^= Ni, Ni = ve, Pr = Ci(Pr, ve ^ Mi, 40), ve = ra + (to = Qe) | 0, ve = Jr + ((Mi = Pr + es | 0) >>> 0 < es >>> 0 ? ve + 1 | 0 : ve) | 0, ve = (Jr = fi + Mi | 0) >>> 0 < fi >>> 0 ? ve + 1 | 0 : ve, fi = $n, $n = ve, Mi = Ci(ti ^ Jr, fi ^ ve, 48), Is = ve = Qe, fi = ve, ti = Ci(Zn ^ qn, ci ^ Ps, 1), Xi = ve = Qe, Yi = Br, ve = ve + ms | 0, ve = Eo + ((Br = E + ti | 0) >>> 0 < E >>> 0 ? ve + 1 | 0 : ve) | 0, fo = ve = (Br = Br + fo | 0) >>> 0 < fo >>> 0 ? ve + 1 | 0 : ve, Tn = Ci(gr ^ Br, ve ^ Tn, 32), ve = (Ps = Qe) + Yi | 0, Yi = cr = Tn + cr | 0, gr = Ci(cr ^ ti, (gr = Xi) ^ (Xi = cr >>> 0 < Tn >>> 0 ? ve + 1 | 0 : ve), 40), ve = ca + (Zn = Qe) | 0, ve = fo + ((cr = gr + Fi | 0) >>> 0 < Fi >>> 0 ? ve + 1 | 0 : ve) | 0, qn = cr = cr + Br | 0, ci = ve = cr >>> 0 < Br >>> 0 ? ve + 1 | 0 : ve, Br = ve, ve = go + Qs | 0, ve = ((ti = So + ks | 0) >>> 0 < ks >>> 0 ? ve + 1 | 0 : ve) + Br | 0, fo = ve = (Br = cr + ti | 0) >>> 0 < ti >>> 0 ? ve + 1 | 0 : ve, cr = Ci(Br ^ Mi, ve ^ fi, 32), ve = (Eo = Qe) + ai | 0, fi = Ci((ti = cr + Vo | 0) ^ So, (ve = ti >>> 0 < cr >>> 0 ? ve + 1 | 0 : ve) ^ go, 40), So = ve, ve = M + (wo = Qe) | 0, ve = fo + ((go = fi + Hs | 0) >>> 0 < Hs >>> 0 ? ve + 1 | 0 : ve) | 0, ve = (fo = Br + go | 0) >>> 0 < Br >>> 0 ? ve + 1 | 0 : ve, Br = Eo, Eo = ve, Br = Ci(cr ^ fo, Br ^ ve, 48), ve = (ve = So) + (So = Qe) | 0, cr = (ti = Br + ti | 0) ^ fi, fi = ve = ti >>> 0 < Br >>> 0 ? ve + 1 | 0 : ve, wo = ve = Ci(cr, ve ^ wo, 1), go = cr = Qe, ys = jr, is = Mr, Mr = gr, gr = Ci(Tn ^ qn, ci ^ Ps, 48), ve = (Tn = Qe) + Xi | 0, Xi = cr = gr + Yi | 0, Yi = ve = cr >>> 0 < gr >>> 0 ? ve + 1 | 0 : ve, Mr = Ci(cr ^ Mr, ve ^ Zn, 1), ve = (Zn = Qe) + Rs | 0, ve = $n + ((cr = Mr + as | 0) >>> 0 < Mr >>> 0 ? ve + 1 | 0 : ve) | 0, Jr = ve = (jr = cr + Jr | 0) >>> 0 < Jr >>> 0 ? ve + 1 | 0 : ve, cr = Ci(jr ^ is, ve ^ bo, 32), ve = ($n = Qe) + li | 0, bo = ve = (li = cr + ys | 0) >>> 0 < cr >>> 0 ? ve + 1 | 0 : ve, Mr = Ci(Mr ^ li, ve ^ Zn, 40), ve = _a + (Ps = Qe) | 0, Zn = Mr, ve = Jr + ((Mr = Cs + Mr | 0) >>> 0 < Cs >>> 0 ? ve + 1 | 0 : ve) | 0, Jr = Mr + jr | 0, Mr = $n, $n = ve = Jr >>> 0 < jr >>> 0 ? ve + 1 | 0 : ve, Mr = Ci(cr ^ Jr, Mr ^ ve, 48), ve = (ve = bo) + (bo = Qe) | 0, qn = cr = Mr + li | 0, ci = ve = cr >>> 0 < Mr >>> 0 ? ve + 1 | 0 : ve, jr = Nr, ve = Ni + Is | 0, Nr = ve = (cr = Mi + io | 0) >>> 0 < Mi >>> 0 ? ve + 1 | 0 : ve, Pr = Ci(cr ^ Pr, ve ^ to, 1), ve = (Mi = Qe) + Vs | 0, ve = vn + ((li = Pr + zn | 0) >>> 0 < Pr >>> 0 ? ve + 1 | 0 : ve) | 0, Tr = ve = (li = li + Tr | 0) >>> 0 < Tr >>> 0 ? ve + 1 | 0 : ve, jr = Ci(jr ^ li, ve ^ ro, 32), vn = ve = Qe, Ni = Pr, ve = ve + Yi | 0, ve = (Pr = jr + Xi | 0) >>> 0 < jr >>> 0 ? ve + 1 | 0 : ve, io = Pr, Pr ^= Ni, Ni = ve, Pr = Ci(Pr, ve ^ Mi, 40), ve = Fs + (to = Qe) | 0, ve = Tr + ((Mi = Pr + Ds | 0) >>> 0 < Ds >>> 0 ? ve + 1 | 0 : ve) | 0, Xi = vn, vn = ve = (Tr = li + Mi | 0) >>> 0 < li >>> 0 ? ve + 1 | 0 : ve, Mi = Ci(jr ^ Tr, Xi ^ ve, 48), Is = ve = Qe, li = ve, jr = Ci(Vo ^ qo, ai ^ ws, 1), Xi = ve = Qe, Yi = Nr, ve = ve + Qo | 0, ve = Ln + ((Nr = jr + us | 0) >>> 0 < us >>> 0 ? ve + 1 | 0 : ve) | 0, Wi = ve = (Nr = Nr + Wi | 0) >>> 0 < Wi >>> 0 ? ve + 1 | 0 : ve, Tn = Ci(gr ^ Nr, ve ^ Tn, 32), ve = (ws = Qe) + Yi | 0, Yi = cr = Tn + cr | 0, gr = Ci(cr ^ jr, (gr = Xi) ^ (Xi = cr >>> 0 < Tn >>> 0 ? ve + 1 | 0 : ve), 40), ve = Ea + (qo = Qe) | 0, ve = Wi + ((cr = gr + Es | 0) >>> 0 < Es >>> 0 ? ve + 1 | 0 : ve) | 0, Vo = cr = cr + Nr | 0, ai = ve = cr >>> 0 < Nr >>> 0 ? ve + 1 | 0 : ve, Nr = ve, ve = go + M | 0, ve = ((jr = wo + Hs | 0) >>> 0 < Hs >>> 0 ? ve + 1 | 0 : ve) + Nr | 0, Wi = ve = (Nr = cr + jr | 0) >>> 0 < jr >>> 0 ? ve + 1 | 0 : ve, cr = Ci(Nr ^ Mi, ve ^ li, 32), ve = (Ln = Qe) + ci | 0, li = Ci((jr = cr + qn | 0) ^ wo, (ve = jr >>> 0 < cr >>> 0 ? ve + 1 | 0 : ve) ^ go, 40), ro = ve, ve = Ba + (wo = Qe) | 0, ve = Wi + ((go = li + Qn | 0) >>> 0 < Qn >>> 0 ? ve + 1 | 0 : ve) | 0, ve = (Wi = Nr + go | 0) >>> 0 < Nr >>> 0 ? ve + 1 | 0 : ve, Nr = Ln, Ln = ve, Nr = Ci(cr ^ Wi, Nr ^ ve, 48), ve = (ve = ro) + (ro = Qe) | 0, cr = (jr = Nr + jr | 0) ^ li, li = ve = jr >>> 0 < Nr >>> 0 ? ve + 1 | 0 : ve, wo = ve = Ci(cr, ve ^ wo, 1), go = cr = Qe, ys = ti, is = Mr, Mr = gr, gr = Ci(Tn ^ Vo, ai ^ ws, 48), ve = (Tn = Qe) + Xi | 0, Xi = cr = gr + Yi | 0, Yi = ve = cr >>> 0 < gr >>> 0 ? ve + 1 | 0 : ve, Mr = Ci(cr ^ Mr, ve ^ qo, 1), ve = (qo = Qe) + Qo | 0, ve = vn + ((cr = Mr + us | 0) >>> 0 < Mr >>> 0 ? ve + 1 | 0 : ve) | 0, Tr = ve = (ti = cr + Tr | 0) >>> 0 < Tr >>> 0 ? ve + 1 | 0 : ve, cr = Ci(ti ^ is, ve ^ bo, 32), ve = (vn = Qe) + fi | 0, bo = ve = (fi = cr + ys | 0) >>> 0 < cr >>> 0 ? ve + 1 | 0 : ve, Mr = Ci(Mr ^ fi, ve ^ qo, 40), ve = Fs + (ws = Qe) | 0, qo = Mr, ve = Tr + ((Mr = Ds + Mr | 0) >>> 0 < Ds >>> 0 ? ve + 1 | 0 : ve) | 0, Tr = Mr + ti | 0, Mr = vn, vn = ve = Tr >>> 0 < ti >>> 0 ? ve + 1 | 0 : ve, Mr = Ci(cr ^ Tr, Mr ^ ve, 48), ve = (ve = bo) + (bo = Qe) | 0, Vo = cr = Mr + fi | 0, ai = ve = cr >>> 0 < Mr >>> 0 ? ve + 1 | 0 : ve, ti = Br, ve = Ni + Is | 0, Br = ve = (cr = Mi + io | 0) >>> 0 < Mi >>> 0 ? ve + 1 | 0 : ve, Pr = Ci(cr ^ Pr, ve ^ to, 1), ve = Vs + (Mi = Qe) | 0, ve = $n + ((fi = Pr + zn | 0) >>> 0 < zn >>> 0 ? ve + 1 | 0 : ve) | 0, Jr = ve = (fi = fi + Jr | 0) >>> 0 < Jr >>> 0 ? ve + 1 | 0 : ve, ti = Ci(ti ^ fi, ve ^ So, 32), $n = ve = Qe, Ni = Pr, ve = ve + Yi | 0, ve = (Pr = ti + Xi | 0) >>> 0 < ti >>> 0 ? ve + 1 | 0 : ve, io = Pr, Pr ^= Ni, Ni = ve, Pr = Ci(Pr, ve ^ Mi, 40), ve = _a + (to = Qe) | 0, ve = Jr + ((Mi = Pr + Cs | 0) >>> 0 < Cs >>> 0 ? ve + 1 | 0 : ve) | 0, ve = (Jr = fi + Mi | 0) >>> 0 < fi >>> 0 ? ve + 1 | 0 : ve, fi = $n, $n = ve, Mi = Ci(ti ^ Jr, fi ^ ve, 48), Is = ve = Qe, fi = ve, ti = Ci(Zn ^ qn, ci ^ Ps, 1), Xi = ve = Qe, Yi = Br, ve = ve + Po | 0, ve = Eo + ((Br = ti + cs | 0) >>> 0 < cs >>> 0 ? ve + 1 | 0 : ve) | 0, fo = ve = (Br = Br + fo | 0) >>> 0 < fo >>> 0 ? ve + 1 | 0 : ve, Tn = Ci(gr ^ Br, ve ^ Tn, 32), ve = (Ps = Qe) + Yi | 0, Yi = cr = Tn + cr | 0, gr = Ci(cr ^ ti, (gr = Xi) ^ (Xi = cr >>> 0 < Tn >>> 0 ? ve + 1 | 0 : ve), 40), ve = Ea + (Zn = Qe) | 0, ve = fo + ((cr = gr + Es | 0) >>> 0 < Es >>> 0 ? ve + 1 | 0 : ve) | 0, qn = cr = cr + Br | 0, ci = ve = cr >>> 0 < Br >>> 0 ? ve + 1 | 0 : ve, Br = ve, ve = go + ca | 0, ve = ((ti = wo + Fi | 0) >>> 0 < Fi >>> 0 ? ve + 1 | 0 : ve) + Br | 0, fo = ve = (Br = cr + ti | 0) >>> 0 < ti >>> 0 ? ve + 1 | 0 : ve, cr = Ci(Br ^ Mi, ve ^ fi, 32), ve = (Eo = Qe) + ai | 0, fi = Ci((ti = cr + Vo | 0) ^ wo, (ve = ti >>> 0 < cr >>> 0 ? ve + 1 | 0 : ve) ^ go, 40), So = ve, ve = ms + (wo = Qe) | 0, ve = fo + ((go = E + fi | 0) >>> 0 < E >>> 0 ? ve + 1 | 0 : ve) | 0, ve = (fo = Br + go | 0) >>> 0 < Br >>> 0 ? ve + 1 | 0 : ve, Br = Eo, Eo = ve, Br = Ci(cr ^ fo, Br ^ ve, 48), ve = (ve = So) + (So = Qe) | 0, cr = (ti = Br + ti | 0) ^ fi, fi = ve = ti >>> 0 < Br >>> 0 ? ve + 1 | 0 : ve, wo = ve = Ci(cr, ve ^ wo, 1), go = cr = Qe, ys = jr, is = Mr, Mr = gr, gr = Ci(Tn ^ qn, ci ^ Ps, 48), ve = (Tn = Qe) + Xi | 0, Xi = cr = gr + Yi | 0, Yi = ve = cr >>> 0 < gr >>> 0 ? ve + 1 | 0 : ve, Mr = Ci(cr ^ Mr, ve ^ Zn, 1), ve = (Zn = Qe) + ra | 0, ve = $n + ((cr = Mr + es | 0) >>> 0 < Mr >>> 0 ? ve + 1 | 0 : ve) | 0, Jr = ve = (jr = cr + Jr | 0) >>> 0 < Jr >>> 0 ? ve + 1 | 0 : ve, cr = Ci(jr ^ is, ve ^ bo, 32), ve = ($n = Qe) + li | 0, bo = ve = (li = cr + ys | 0) >>> 0 < cr >>> 0 ? ve + 1 | 0 : ve, Mr = Ci(Mr ^ li, ve ^ Zn, 40), ve = ye + (Ps = Qe) | 0, Zn = Mr, ve = Jr + ((Mr = T + Mr | 0) >>> 0 < T >>> 0 ? ve + 1 | 0 : ve) | 0, Jr = Mr + jr | 0, Mr = $n, $n = ve = Jr >>> 0 < jr >>> 0 ? ve + 1 | 0 : ve, Mr = Ci(cr ^ Jr, Mr ^ ve, 48), ve = (ve = bo) + (bo = Qe) | 0, qn = cr = Mr + li | 0, ci = ve = cr >>> 0 < Mr >>> 0 ? ve + 1 | 0 : ve, jr = Nr, ve = Ni + Is | 0, Nr = ve = (cr = Mi + io | 0) >>> 0 < Mi >>> 0 ? ve + 1 | 0 : ve, Pr = Ci(cr ^ Pr, ve ^ to, 1), ve = (Mi = Qe) + Qs | 0, ve = vn + ((li = Pr + ks | 0) >>> 0 < Pr >>> 0 ? ve + 1 | 0 : ve) | 0, Tr = ve = (li = li + Tr | 0) >>> 0 < Tr >>> 0 ? ve + 1 | 0 : ve, jr = Ci(jr ^ li, ve ^ ro, 32), vn = ve = Qe, Ni = Pr, ve = ve + Yi | 0, ve = (Pr = jr + Xi | 0) >>> 0 < jr >>> 0 ? ve + 1 | 0 : ve, io = Pr, Pr ^= Ni, Ni = ve, Pr = Ci(Pr, ve ^ Mi, 40), ve = ma + (to = Qe) | 0, ve = Tr + ((Mi = Pr + fn | 0) >>> 0 < fn >>> 0 ? ve + 1 | 0 : ve) | 0, Xi = vn, vn = ve = (Tr = li + Mi | 0) >>> 0 < li >>> 0 ? ve + 1 | 0 : ve, Mi = Ci(jr ^ Tr, Xi ^ ve, 48), Is = ve = Qe, li = ve, jr = Ci(Vo ^ qo, ai ^ ws, 1), Xi = ve = Qe, Yi = Nr, ve = ve + la | 0, ve = Ln + ((Nr = jr + Ns | 0) >>> 0 < Ns >>> 0 ? ve + 1 | 0 : ve) | 0, Wi = ve = (Nr = Nr + Wi | 0) >>> 0 < Wi >>> 0 ? ve + 1 | 0 : ve, Tn = Ci(gr ^ Nr, ve ^ Tn, 32), ve = (ws = Qe) + Yi | 0, Yi = cr = Tn + cr | 0, gr = Ci(cr ^ jr, (gr = Xi) ^ (Xi = cr >>> 0 < Tn >>> 0 ? ve + 1 | 0 : ve), 40), ve = Rs + (qo = Qe) | 0, ve = Wi + ((cr = gr + as | 0) >>> 0 < as >>> 0 ? ve + 1 | 0 : ve) | 0, Vo = cr = cr + Nr | 0, ai = ve = cr >>> 0 < Nr >>> 0 ? ve + 1 | 0 : ve, Nr = ve, ve = go + Ea | 0, ve = ((jr = wo + Es | 0) >>> 0 < Es >>> 0 ? ve + 1 | 0 : ve) + Nr | 0, Wi = ve = (Nr = cr + jr | 0) >>> 0 < jr >>> 0 ? ve + 1 | 0 : ve, cr = Ci(Nr ^ Mi, ve ^ li, 32), ve = (Ln = Qe) + ci | 0, li = Ci((jr = cr + qn | 0) ^ wo, (ve = jr >>> 0 < cr >>> 0 ? ve + 1 | 0 : ve) ^ go, 40), ro = ve, ve = Fs + (wo = Qe) | 0, ve = Wi + ((go = li + Ds | 0) >>> 0 < Ds >>> 0 ? ve + 1 | 0 : ve) | 0, ve = (Wi = Nr + go | 0) >>> 0 < Nr >>> 0 ? ve + 1 | 0 : ve, Nr = Ln, Ln = ve, Nr = Ci(cr ^ Wi, Nr ^ ve, 48), ve = (ve = ro) + (ro = Qe) | 0, cr = (jr = Nr + jr | 0) ^ li, li = ve = jr >>> 0 < Nr >>> 0 ? ve + 1 | 0 : ve, wo = ve = Ci(cr, ve ^ wo, 1), go = cr = Qe, ys = ti, is = Mr, Mr = gr, gr = Ci(Tn ^ Vo, ai ^ ws, 48), ve = (Tn = Qe) + Xi | 0, Xi = cr = gr + Yi | 0, Yi = ve = cr >>> 0 < gr >>> 0 ? ve + 1 | 0 : ve, Mr = Ci(cr ^ Mr, ve ^ qo, 1), ve = (qo = Qe) + Ba | 0, ve = vn + ((cr = Mr + Qn | 0) >>> 0 < Mr >>> 0 ? ve + 1 | 0 : ve) | 0, Tr = ve = (ti = cr + Tr | 0) >>> 0 < Tr >>> 0 ? ve + 1 | 0 : ve, cr = Ci(ti ^ is, ve ^ bo, 32), ve = (vn = Qe) + fi | 0, bo = ve = (fi = cr + ys | 0) >>> 0 < cr >>> 0 ? ve + 1 | 0 : ve, Mr = Ci(Mr ^ fi, ve ^ qo, 40), ve = M + (ws = Qe) | 0, qo = Mr, ve = Tr + ((Mr = Hs + Mr | 0) >>> 0 < Hs >>> 0 ? ve + 1 | 0 : ve) | 0, Tr = Mr + ti | 0, Mr = vn, vn = ve = Tr >>> 0 < ti >>> 0 ? ve + 1 | 0 : ve, Mr = Ci(cr ^ Tr, Mr ^ ve, 48), ve = (ve = bo) + (bo = Qe) | 0, Vo = cr = Mr + fi | 0, ai = ve = cr >>> 0 < Mr >>> 0 ? ve + 1 | 0 : ve, ti = Br, ve = Ni + Is | 0, Br = ve = (cr = Mi + io | 0) >>> 0 < Mi >>> 0 ? ve + 1 | 0 : ve, Pr = Ci(cr ^ Pr, ve ^ to, 1), ve = ma + (Mi = Qe) | 0, ve = $n + ((fi = Pr + fn | 0) >>> 0 < fn >>> 0 ? ve + 1 | 0 : ve) | 0, Jr = ve = (fi = fi + Jr | 0) >>> 0 < Jr >>> 0 ? ve + 1 | 0 : ve, ti = Ci(ti ^ fi, ve ^ So, 32), $n = ve = Qe, Ni = Pr, ve = ve + Yi | 0, ve = (Pr = ti + Xi | 0) >>> 0 < ti >>> 0 ? ve + 1 | 0 : ve, io = Pr, Pr ^= Ni, Ni = ve, Pr = Ci(Pr, ve ^ Mi, 40), ve = Qo + (to = Qe) | 0, ve = Jr + ((Mi = Pr + us | 0) >>> 0 < us >>> 0 ? ve + 1 | 0 : ve) | 0, ve = (Jr = fi + Mi | 0) >>> 0 < fi >>> 0 ? ve + 1 | 0 : ve, fi = $n, $n = ve, Mi = Ci(ti ^ Jr, fi ^ ve, 48), Is = ve = Qe, fi = ve, ti = Ci(Zn ^ qn, ci ^ Ps, 1), Xi = ve = Qe, Yi = Br, ve = ve + _a | 0, ve = Eo + ((Br = ti + Cs | 0) >>> 0 < Cs >>> 0 ? ve + 1 | 0 : ve) | 0, fo = ve = (Br = Br + fo | 0) >>> 0 < fo >>> 0 ? ve + 1 | 0 : ve, Tn = Ci(gr ^ Br, ve ^ Tn, 32), ve = (Ps = Qe) + Yi | 0, Yi = cr = Tn + cr | 0, gr = Ci(cr ^ ti, (gr = Xi) ^ (Xi = cr >>> 0 < Tn >>> 0 ? ve + 1 | 0 : ve), 40), ve = la + (Zn = Qe) | 0, ve = fo + ((cr = gr + Ns | 0) >>> 0 < Ns >>> 0 ? ve + 1 | 0 : ve) | 0, qn = cr = cr + Br | 0, ci = ve = cr >>> 0 < Br >>> 0 ? ve + 1 | 0 : ve, Br = ve, ve = go + Vs | 0, ve = ((ti = wo + zn | 0) >>> 0 < zn >>> 0 ? ve + 1 | 0 : ve) + Br | 0, fo = ve = (Br = cr + ti | 0) >>> 0 < ti >>> 0 ? ve + 1 | 0 : ve, cr = Ci(Br ^ Mi, ve ^ fi, 32), ve = (Eo = Qe) + ai | 0, fi = Ci((ti = cr + Vo | 0) ^ wo, (ve = ti >>> 0 < cr >>> 0 ? ve + 1 | 0 : ve) ^ go, 40), So = ve, ve = ye + (wo = Qe) | 0, ve = fo + ((go = fi + T | 0) >>> 0 < T >>> 0 ? ve + 1 | 0 : ve) | 0, ve = (fo = Br + go | 0) >>> 0 < Br >>> 0 ? ve + 1 | 0 : ve, Br = Eo, Eo = ve, Br = Ci(cr ^ fo, Br ^ ve, 48), ve = (ve = So) + (So = Qe) | 0, cr = (ti = Br + ti | 0) ^ fi, fi = ve = ti >>> 0 < Br >>> 0 ? ve + 1 | 0 : ve, wo = ve = Ci(cr, ve ^ wo, 1), go = cr = Qe, ys = jr, is = Mr, Mr = gr, gr = Ci(Tn ^ qn, ci ^ Ps, 48), ve = (Tn = Qe) + Xi | 0, Xi = cr = gr + Yi | 0, Yi = ve = cr >>> 0 < gr >>> 0 ? ve + 1 | 0 : ve, Mr = Ci(cr ^ Mr, ve ^ Zn, 1), ve = (qn = Qe) + Po | 0, ve = $n + ((cr = Mr + cs | 0) >>> 0 < Mr >>> 0 ? ve + 1 | 0 : ve) | 0, Jr = ve = (jr = cr + Jr | 0) >>> 0 < Jr >>> 0 ? ve + 1 | 0 : ve, cr = Ci(jr ^ is, ve ^ bo, 32), ve = ($n = Qe) + li | 0, bo = li = cr + ys | 0, Zn = ve = li >>> 0 < cr >>> 0 ? ve + 1 | 0 : ve, Mr = Ci(Mr ^ li, ve ^ qn, 40), ve = ca + (ys = Qe) | 0, qn = Mr, ve = Jr + ((Mr = Fi + Mr | 0) >>> 0 < Fi >>> 0 ? ve + 1 | 0 : ve) | 0, li = Mr + jr | 0, Mr = $n, $n = ve = li >>> 0 < jr >>> 0 ? ve + 1 | 0 : ve, Mr = Ci(cr ^ li, Mr ^ ve, 48), ve = (ve = Zn) + (Zn = Qe) | 0, bo = cr = Mr + bo | 0, ci = ve = cr >>> 0 < Mr >>> 0 ? ve + 1 | 0 : ve, jr = Nr, ve = Ni + Is | 0, Nr = ve = (cr = Mi + io | 0) >>> 0 < Mi >>> 0 ? ve + 1 | 0 : ve, Pr = Ci(cr ^ Pr, ve ^ to, 1), ve = (Mi = Qe) + ms | 0, ve = vn + ((Jr = E + Pr | 0) >>> 0 < Pr >>> 0 ? ve + 1 | 0 : ve) | 0, Tr = ve = (Jr = Jr + Tr | 0) >>> 0 < Tr >>> 0 ? ve + 1 | 0 : ve, vn = jr = Ci(jr ^ Jr, ve ^ ro, 32), Ni = ve = Qe, io = Pr, ve = ve + Yi | 0, ve = (Pr = jr + Xi | 0) >>> 0 < jr >>> 0 ? ve + 1 | 0 : ve, to = Pr, Pr ^= io, io = ve, Pr = Ci(Pr, ve ^ Mi, 40), ve = ra + (Xi = Qe) | 0, ve = Tr + ((jr = Pr + es | 0) >>> 0 < es >>> 0 ? ve + 1 | 0 : ve) | 0, Yi = (jr = jr + Jr | 0) ^ vn, vn = ve = jr >>> 0 < Jr >>> 0 ? ve + 1 | 0 : ve, Jr = Ci(Yi, ve ^ Ni, 48), ro = ve = Qe, Mi = ve, Ni = Tr = Ci(Vo ^ qo, ai ^ ws, 1), Yi = ve = Qe, qo = Nr, ve = ve + Rs | 0, ve = Ln + ((Nr = Tr + as | 0) >>> 0 < as >>> 0 ? ve + 1 | 0 : ve) | 0, ve = (Nr = Nr + Wi | 0) >>> 0 < Wi >>> 0 ? ve + 1 | 0 : ve, Wi = Tn, Tn = ve, Tr = Ci(gr ^ Nr, Wi ^ ve, 32), ve = (is = Qe) + qo | 0, Wi = cr = Tr + cr | 0, gr = Ci(gr = cr ^ Ni, (Ni = cr >>> 0 < Tr >>> 0 ? ve + 1 | 0 : ve) ^ Yi, 40), ve = Qs + (Yi = Qe) | 0, ve = Tn + ((cr = gr + ks | 0) >>> 0 < ks >>> 0 ? ve + 1 | 0 : ve) | 0, Tn = cr = cr + Nr | 0, qo = ve = cr >>> 0 < Nr >>> 0 ? ve + 1 | 0 : ve, Nr = ve, ve = go + ca | 0, ve = ((Ln = Fi) >>> 0 > (Fi = wo + Fi | 0) >>> 0 ? ve + 1 | 0 : ve) + Nr | 0, ca = ve = (cr = cr + Fi | 0) >>> 0 < Fi >>> 0 ? ve + 1 | 0 : ve, Fi = Ci(cr ^ Jr, ve ^ Mi, 32), ve = (Vo = Qe) + ci | 0, Mi = Ci((Nr = bo + Fi | 0) ^ wo, (ve = Nr >>> 0 < Fi >>> 0 ? ve + 1 | 0 : ve) ^ go, 40), Ln = ve, ve = ra + (ai = Qe) | 0, ve = ca + ((wo = es) >>> 0 > (es = Mi + es | 0) >>> 0 ? ve + 1 | 0 : ve) | 0, ve = (es = cr + es | 0) >>> 0 < cr >>> 0 ? ve + 1 | 0 : ve, cr = Fi ^ es, Fi = ve, ra = Ci(cr, ve ^ Vo, 48), ve = (ca = Qe) + Ln | 0, Nr = ve = (cr = Nr + ra | 0) >>> 0 < ra >>> 0 ? ve + 1 | 0 : ve, ve = Ci(cr ^ Mi, ve ^ ai, 1), Mi = Qe, Vo = ve, ai = ti, ti = ks, Ln = Qs, Qs = Ci(Tr ^ Tn, qo ^ is, 48), ve = (Tr = Qe) + Ni | 0, Ni = ti, Wi = ve = (ks = Wi + Qs | 0) >>> 0 < Qs >>> 0 ? ve + 1 | 0 : ve, ti = Ci(gr ^ (Tn = ks), ve ^ Yi, 1), ve = (Yi = Qe) + Ln | 0, ve = vn + (ti >>> 0 > (ks = Ni + ti | 0) >>> 0 ? ve + 1 | 0 : ve) | 0, gr = ve = (ks = jr + ks | 0) >>> 0 < jr >>> 0 ? ve + 1 | 0 : ve, Mr = Ci(Mr ^ ks, ve ^ Zn, 32), ve = (ve = fi) + (fi = Qe) | 0, vn = jr = Mr + ai | 0, Ni = ve = jr >>> 0 < Mr >>> 0 ? ve + 1 | 0 : ve, jr = Ci(jr ^ ti, ve ^ Yi, 40), ve = (Yi = Qe) + Ba | 0, ve = (jr >>> 0 > (Qn = jr + Qn | 0) >>> 0 ? ve + 1 | 0 : ve) + gr | 0, gr = ve = (gr = Qn) >>> 0 > (Qn = ks + Qn | 0) >>> 0 ? ve + 1 | 0 : ve, Mr = Ci(Mr ^ Qn, ve ^ fi, 48), ve = (ti = Qe) + Ni | 0, fi = ks = Mr + vn | 0, Ba = ve = ks >>> 0 < Mr >>> 0 ? ve + 1 | 0 : ve, vn = E, Ni = ms, ve = io + ro | 0, ks = ve = (E = Jr + to | 0) >>> 0 < Jr >>> 0 ? ve + 1 | 0 : ve, ms = Ci(E ^ Pr, ve ^ Xi, 1), ve = (Jr = Qe) + Ni | 0, ve = $n + ((Pr = vn + ms | 0) >>> 0 < ms >>> 0 ? ve + 1 | 0 : ve) | 0, Br = Ci((Pr = Pr + li | 0) ^ Br, (ve = Pr >>> 0 < li >>> 0 ? ve + 1 | 0 : ve) ^ So, 32), vn = ve, $n = zn, zn = ms, ve = (li = Qe) + Wi | 0, Wi = Jr, Jr = ve = (ms = Br + Tn | 0) >>> 0 < Br >>> 0 ? ve + 1 | 0 : ve, zn = Ci(ms ^ zn, Wi ^ ve, 40), ve = (Tn = Qe) + Vs | 0, ve = ((Vs = $n + zn | 0) >>> 0 < zn >>> 0 ? ve + 1 | 0 : ve) + vn | 0, vn = Vs, Pr = Br ^ (Vs = Pr + Vs | 0), Br = ve = vn >>> 0 > Vs >>> 0 ? ve + 1 | 0 : ve, ve = Ci(Pr, ve ^ li, 48), io = Pr = Qe, li = ve, Wi = cs, vn = Po, cs = Ci(bo ^ qn, ci ^ ys, 1), Ni = ve = Qe, ve = ve + Ea | 0, ve = Eo + ((cs = ($n = cs) + Es | 0) >>> 0 < Es >>> 0 ? ve + 1 | 0 : ve) | 0, Es = ve = (cs = fo + cs | 0) >>> 0 < fo >>> 0 ? ve + 1 | 0 : ve, Po = Ci(cs ^ Qs, ve ^ Tr, 32), ve = (fo = Qe) + ks | 0, ks = E = Po + E | 0, Qs = Ci(E ^ $n, (Tr = E >>> 0 < Po >>> 0 ? ve + 1 | 0 : ve) ^ Ni, 40), ve = (ve = vn) + (vn = Qe) | 0, ve = Es + ((E = Qs + Wi | 0) >>> 0 < Qs >>> 0 ? ve + 1 | 0 : ve) | 0, Es = E = E + cs | 0, Ea = ve = E >>> 0 < cs >>> 0 ? ve + 1 | 0 : ve, cs = ve, ve = Mi + ma | 0, ve = (($n = fn) >>> 0 > (fn = Vo + fn | 0) >>> 0 ? ve + 1 | 0 : ve) + cs | 0, ma = ve = (cs = E + fn | 0) >>> 0 < fn >>> 0 ? ve + 1 | 0 : ve, fn = Ci(li ^ cs, ve ^ Pr, 32), ve = ($n = Qe) + Ba | 0, Pr = E = fn + fi | 0, E = Ci(E ^ Vo, (Wi = Mi) ^ (Mi = E >>> 0 < fn >>> 0 ? ve + 1 | 0 : ve), 40), ve = _a + (Ni = Qe) | 0, _a = E, ve = ma + ((E = Cs + E | 0) >>> 0 < Cs >>> 0 ? ve + 1 | 0 : ve) | 0, ve = (E = E + cs | 0) >>> 0 < cs >>> 0 ? ve + 1 | 0 : ve, ma = E, to = (m[k + 8 | 0] | m[k + 9 | 0] << 8 | m[k + 10 | 0] << 16 | m[k + 11 | 0] << 24) ^ E, Wi = ve, Xi = ve ^ (m[k + 12 | 0] | m[k + 13 | 0] << 8 | m[k + 14 | 0] << 16 | m[k + 15 | 0] << 24), cs = Ci(Po ^ Es, fo ^ Ea, 48), ve = (Es = Qe) + Tr | 0, Tr = E = cs + ks | 0, Ea = ve = E >>> 0 < cs >>> 0 ? ve + 1 | 0 : ve, Po = Ds, ve = Jr + io | 0, Ds = ve = (E = li + ms | 0) >>> 0 < ms >>> 0 ? ve + 1 | 0 : ve, zn = Ci(E ^ zn, ve ^ Tn, 1), ve = (li = Qe) + Fs | 0, ve = ((Po = zn + Po | 0) >>> 0 < zn >>> 0 ? ve + 1 | 0 : ve) + gr | 0, Po = ve = (Fs = Po + Qn | 0) >>> 0 < Po >>> 0 ? ve + 1 | 0 : ve, ks = Ci(Fs ^ ra, ve ^ ca, 32), ve = (ms = Qe) + Ea | 0, Qn = ve = (Cs = ks + Tr | 0) >>> 0 < ks >>> 0 ? ve + 1 | 0 : ve, ra = ks, ks = Ci(zn ^ Cs, ve ^ li, 40), ve = (gr = Qe) + la | 0, ve = (ks >>> 0 > (zn = ks + Ns | 0) >>> 0 ? ve + 1 | 0 : ve) + Po | 0, Jr = ms, ms = ve = (Fs = zn + Fs | 0) >>> 0 < zn >>> 0 ? ve + 1 | 0 : ve, zn = Ci(ra ^ (Ns = Fs), Jr ^ ve, 48), ve = (li = Qe) + Qn | 0, ve = (Po = zn + Cs | 0) >>> 0 < zn >>> 0 ? ve + 1 | 0 : ve, Cs = Po, Po ^= to, B[k + 8 | 0] = Po, B[k + 9 | 0] = Po >>> 8, B[k + 10 | 0] = Po >>> 16, B[k + 11 | 0] = Po >>> 24, Qn = ve, ve ^= Xi, B[k + 12 | 0] = ve, B[k + 13 | 0] = ve >>> 8, B[k + 14 | 0] = ve >>> 16, B[k + 15 | 0] = ve >>> 24, Fs = E, Po = Ds, E = cs, cs = Ci(jr ^ fi, Yi ^ Ba, 1), ve = (la = Qe) + ye | 0, ve = (cs >>> 0 > (Ds = cs + T | 0) >>> 0 ? ve + 1 | 0 : ve) + Fi | 0, es = ve = (fi = Ds) >>> 0 > (Ds = es + Ds | 0) >>> 0 ? ve + 1 | 0 : ve, E = Ci(E ^ Ds, ve ^ Es, 32), ve = (ve = Po) + (Po = Qe) | 0, Es = ve = (Fs = E + Fs | 0) >>> 0 < E >>> 0 ? ve + 1 | 0 : ve, ra = E, Fs = Ci(cs ^ (Fi = Fs), ve ^ la, 40), ve = (jr = Qe) + M | 0, ve = es + ((E = Fs + Hs | 0) >>> 0 < Fs >>> 0 ? ve + 1 | 0 : ve) | 0, ve = (E = E + Ds | 0) >>> 0 < Ds >>> 0 ? ve + 1 | 0 : ve, es = E, E ^= ra, ra = ve, Ds = Ci(E, ve ^ Po, 48), ve = (fi = Qe) + Es | 0, Fi = E = Ds + Fi | 0, Es = E >>> 0 < Ds >>> 0 ? ve + 1 | 0 : ve, Qs = E = Ci(Tr ^ Qs, vn ^ Ea, 1), la = ve = Qe, ve = ve + Qo | 0, ve = Br + ((E = E + us | 0) >>> 0 < us >>> 0 ? ve + 1 | 0 : ve) | 0, Qo = ve = (cs = E + Vs | 0) >>> 0 < Vs >>> 0 ? ve + 1 | 0 : ve, E = (Po = Ci(Mr ^ cs, ve ^ ti, 32)) + cr | 0, ve = (cr = Qe) + Nr | 0, Vs = E, E = (us = Ci(Br = E ^ Qs, (Qs = E >>> 0 < Po >>> 0 ? ve + 1 | 0 : ve) ^ la, 40)) + as | 0, ve = (as = Qe) + Rs | 0, ve = Qo + (E >>> 0 < us >>> 0 ? ve + 1 | 0 : ve) | 0, ve = (Qo = E + cs | 0) >>> 0 < cs >>> 0 ? ve + 1 | 0 : ve, cs = Qo ^ Ka ^ Fi, B[0 | (E = k)] = cs, B[E + 1 | 0] = cs >>> 8, B[E + 2 | 0] = cs >>> 16, B[E + 3 | 0] = cs >>> 24, cs = ve ^ Ne ^ Es, B[E + 4 | 0] = cs, B[E + 5 | 0] = cs >>> 8, B[E + 6 | 0] = cs >>> 16, B[E + 7 | 0] = cs >>> 24, cs = (Po = Ci(Qo ^ Po, ve ^ cr, 48)) + Vs | 0, ve = (Vs = Qe) + Qs | 0, ve = (Qs = cs >>> 0 < Po >>> 0 ? ve + 1 | 0 : ve) ^ (m[E + 20 | 0] | m[E + 21 | 0] << 8 | m[E + 22 | 0] << 16 | m[E + 23 | 0] << 24) ^ ra, Qo = (m[E + 16 | 0] | m[E + 17 | 0] << 8 | m[E + 18 | 0] << 16 | m[E + 19 | 0] << 24) ^ es ^ cs, B[E + 16 | 0] = Qo, B[E + 17 | 0] = Qo >>> 8, B[E + 18 | 0] = Qo >>> 16, B[E + 19 | 0] = Qo >>> 24, B[E + 20 | 0] = ve, B[E + 21 | 0] = ve >>> 8, B[E + 22 | 0] = ve >>> 16, B[E + 23 | 0] = ve >>> 24, E = Ci(fn ^ ma, Wi ^ $n, 48), Qo = Qe, es = m[k + 36 | 0] | m[k + 37 | 0] << 8 | m[k + 38 | 0] << 16 | m[k + 39 | 0] << 24, ve = (m[k + 32 | 0] | m[k + 33 | 0] << 8 | m[k + 34 | 0] << 16 | m[k + 35 | 0] << 24) ^ Ci(ks ^ Cs, gr ^ Qn, 1) ^ E, B[k + 32 | 0] = ve, B[k + 33 | 0] = ve >>> 8, B[k + 34 | 0] = ve >>> 16, B[k + 35 | 0] = ve >>> 24, ve = Qe ^ es ^ Qo, B[k + 36 | 0] = ve, B[k + 37 | 0] = ve >>> 8, B[k + 38 | 0] = ve >>> 16, B[k + 39 | 0] = ve >>> 24, ve = Mi + Qo | 0, ve = (es = E + Pr | 0) >>> 0 < E >>> 0 ? ve + 1 | 0 : ve, ks = (m[(E = k) + 28 | 0] | m[E + 29 | 0] << 8 | m[E + 30 | 0] << 16 | m[E + 31 | 0] << 24) ^ ms ^ ve, Qo = (m[E + 24 | 0] | m[E + 25 | 0] << 8 | m[E + 26 | 0] << 16 | m[E + 27 | 0] << 24) ^ Ns ^ es, B[E + 24 | 0] = Qo, B[E + 25 | 0] = Qo >>> 8, B[E + 26 | 0] = Qo >>> 16, B[E + 27 | 0] = Qo >>> 24, B[E + 28 | 0] = ks, B[E + 29 | 0] = ks >>> 8, B[E + 30 | 0] = ks >>> 16, B[E + 31 | 0] = ks >>> 24, ks = m[E + 44 | 0] | m[E + 45 | 0] << 8 | m[E + 46 | 0] << 16 | m[E + 47 | 0] << 24, E = Ds ^ (m[E + 40 | 0] | m[E + 41 | 0] << 8 | m[E + 42 | 0] << 16 | m[E + 43 | 0] << 24) ^ Ci(cs ^ us, as ^ Qs, 1), B[k + 40 | 0] = E, B[k + 41 | 0] = E >>> 8, B[k + 42 | 0] = E >>> 16, B[k + 43 | 0] = E >>> 24, E = fi ^ Qe ^ ks, B[k + 44 | 0] = E, B[k + 45 | 0] = E >>> 8, B[k + 46 | 0] = E >>> 16, B[k + 47 | 0] = E >>> 24, cs = m[k + 60 | 0] | m[k + 61 | 0] << 8 | m[k + 62 | 0] << 16 | m[k + 63 | 0] << 24, E = Po ^ (m[k + 56 | 0] | m[k + 57 | 0] << 8 | m[k + 58 | 0] << 16 | m[k + 59 | 0] << 24) ^ Ci(Fi ^ Fs, jr ^ Es, 1), B[k + 56 | 0] = E, B[k + 57 | 0] = E >>> 8, B[k + 58 | 0] = E >>> 16, B[k + 59 | 0] = E >>> 24, E = Vs ^ Qe ^ cs, B[k + 60 | 0] = E, B[k + 61 | 0] = E >>> 8, B[k + 62 | 0] = E >>> 16, B[k + 63 | 0] = E >>> 24, cs = m[k + 52 | 0] | m[k + 53 | 0] << 8 | m[k + 54 | 0] << 16 | m[k + 55 | 0] << 24, E = zn ^ (m[k + 48 | 0] | m[k + 49 | 0] << 8 | m[k + 50 | 0] << 16 | m[k + 51 | 0] << 24) ^ Ci(es ^ _a, ve ^ Ni, 1), B[k + 48 | 0] = E, B[k + 49 | 0] = E >>> 8, B[k + 50 | 0] = E >>> 16, B[k + 51 | 0] = E >>> 24, E = li ^ Qe ^ cs, B[k + 52 | 0] = E, B[k + 53 | 0] = E >>> 8, B[k + 54 | 0] = E >>> 16, B[k + 55 | 0] = E >>> 24;
                    }
                    function Gr(k, E, T, M, ye, Ne, pr) {
                      var ve, cr, gr, Pr, Nr, Br, Mr, jr, ti, fi, Jr, li, Tr, Mi, Wi, vn, Tn, Ni, Yi, Xi, $n, Zn, to, fo, wo, bo, go, qn, io, So, qo, Ln, ro, Qo, Vo, as, cs, ms, ai, ci, Fi, Eo, is, ws, ys, Is, ks, Ps, Po = 0, fn = 0, Qn = 0, zn = 0, es = 0, us = 0, Cs = 0, Es = 0, Rs = 0, Ds = 0, Ns = 0, Fs = 0, Qs = 0, Ys = 0, Vs = 0, Hs = 0, ra = 0, ca = 0, ua = 0, la = 0, ma = 0, Ba = 0, Ea = 0, _a = 0, xa = 0, Ka = 0, nf = 0, of = 0, sf = 0, ef = 0, gf = 0, yf = 0, Df = 0, Bf = 0, Ja = 0, Vf = 0, Ff = 0, Qa = 0, ic = 0, nc = 0, ff = 0, bf = 0, qc = 0, iu = 0, Ou = 0, fh = 0;
                      return dr = gr = dr - 560 | 0, Ks(Qn = gr + 352 | 0), pr && qs(Qn, 35600, 34, 0), Zs(gr + 288 | 0, Ne, 32, 0), qs(us = gr + 352 | 0, gr + 320 | 0, 32, 0), qs(us, T, M, ye), ds(us, Es = gr + 224 | 0), Ds = m[(fn = Ne) + 32 | 0] | m[fn + 33 | 0] << 8 | m[fn + 34 | 0] << 16 | m[fn + 35 | 0] << 24, Ns = m[fn + 36 | 0] | m[fn + 37 | 0] << 8 | m[fn + 38 | 0] << 16 | m[fn + 39 | 0] << 24, zn = m[fn + 40 | 0] | m[fn + 41 | 0] << 8 | m[fn + 42 | 0] << 16 | m[fn + 43 | 0] << 24, Po = m[fn + 44 | 0] | m[fn + 45 | 0] << 8 | m[fn + 46 | 0] << 16 | m[fn + 47 | 0] << 24, Qn = m[fn + 48 | 0] | m[fn + 49 | 0] << 8 | m[fn + 50 | 0] << 16 | m[fn + 51 | 0] << 24, Ne = m[fn + 52 | 0] | m[fn + 53 | 0] << 8 | m[fn + 54 | 0] << 16 | m[fn + 55 | 0] << 24, es = m[fn + 60 | 0] | m[fn + 61 | 0] << 8 | m[fn + 62 | 0] << 16 | m[fn + 63 | 0] << 24, fn = m[fn + 56 | 0] | m[fn + 57 | 0] << 8 | m[fn + 58 | 0] << 16 | m[fn + 59 | 0] << 24, B[k + 56 | 0] = fn, B[k + 57 | 0] = fn >>> 8, B[k + 58 | 0] = fn >>> 16, B[k + 59 | 0] = fn >>> 24, B[k + 60 | 0] = es, B[k + 61 | 0] = es >>> 8, B[k + 62 | 0] = es >>> 16, B[k + 63 | 0] = es >>> 24, B[k + 48 | 0] = Qn, B[k + 49 | 0] = Qn >>> 8, B[k + 50 | 0] = Qn >>> 16, B[k + 51 | 0] = Qn >>> 24, B[k + 52 | 0] = Ne, B[k + 53 | 0] = Ne >>> 8, B[k + 54 | 0] = Ne >>> 16, B[k + 55 | 0] = Ne >>> 24, B[k + 40 | 0] = zn, B[k + 41 | 0] = zn >>> 8, B[k + 42 | 0] = zn >>> 16, B[k + 43 | 0] = zn >>> 24, B[k + 44 | 0] = Po, B[k + 45 | 0] = Po >>> 8, B[k + 46 | 0] = Po >>> 16, B[k + 47 | 0] = Po >>> 24, B[0 | (Ne = k + 32 | 0)] = Ds, B[Ne + 1 | 0] = Ds >>> 8, B[Ne + 2 | 0] = Ds >>> 16, B[Ne + 3 | 0] = Ds >>> 24, B[Ne + 4 | 0] = Ns, B[Ne + 5 | 0] = Ns >>> 8, B[Ne + 6 | 0] = Ns >>> 16, B[Ne + 7 | 0] = Ns >>> 24, Si(Es), e(gr, Es), Rc(k, gr), Ks(us), pr && qs(us, 35600, 34, 0), qs(pr = gr + 352 | 0, k, 64, 0), qs(pr, T, M, ye), ds(pr, Cs = gr + 160 | 0), Si(Cs), B[gr + 288 | 0] = 248 & m[gr + 288 | 0], B[gr + 319 | 0] = 63 & m[gr + 319 | 0] | 64, T = m[23 + (k = cr = gr + 288 | 0) | 0], zn = Zr(Pr = m[k + 21 | 0] | m[k + 22 | 0] << 8 | T << 16 & 2031616, 0, Nr = (m[Cs + 28 | 0] | m[Cs + 29 | 0] << 8 | m[Cs + 30 | 0] << 16 | m[Cs + 31 | 0] << 24) >>> 7 | 0, 0), Qn = Qe, T = (k = m[Cs + 27 | 0]) >>> 24 | 0, ye = k << 8 | (Po = m[Cs + 23 | 0] | m[Cs + 24 | 0] << 8 | m[Cs + 25 | 0] << 16 | m[Cs + 26 | 0] << 24) >>> 24, k = Zr(Br = 2097151 & ((3 & (Ns = (k = (M = m[Cs + 28 | 0]) >>> 16 | 0) | T)) << 30 | (T = (M <<= 16) | ye) >>> 2), 0, Mr = (pr = m[cr + 23 | 0] | m[cr + 24 | 0] << 8 | m[cr + 25 | 0] << 16 | m[cr + 26 | 0] << 24) >>> 5 & 2097151, 0), T = Qe + Qn | 0, M = k >>> 0 > (ye = k + zn | 0) >>> 0 ? T + 1 | 0 : T, k = Zr(jr = (T = m[Cs + 23 | 0]) << 16 & 2031616 | m[Cs + 21 | 0] | m[Cs + 22 | 0] << 8, 0, ti = (m[cr + 28 | 0] | m[cr + 29 | 0] << 8 | m[cr + 30 | 0] << 16 | m[cr + 31 | 0] << 24) >>> 7 | 0, 0), M = Qe + M | 0, Qn = T = k + ye | 0, ye = k >>> 0 > T >>> 0 ? M + 1 | 0 : M, M = (k = m[cr + 27 | 0]) >>> 24 | 0, pr = k << 8 | pr >>> 24, k = Zr(fi = 2097151 & ((3 & (M |= T = (k = m[cr + 28 | 0]) >>> 16 | 0)) << 30 | (T = (k <<= 16) | pr) >>> 2), 0, Jr = Po >>> 5 & 2097151, 0), T = Qe + ye | 0, fn = M = k + Qn | 0, ye = k >>> 0 > M >>> 0 ? T + 1 | 0 : T, Po = Zr(Mr, 0, Jr, 0), Qn = Qe, T = (k = m[cr + 19 | 0]) >>> 24 | 0, pr = k << 8 | (ca = m[cr + 15 | 0] | m[cr + 16 | 0] << 8 | m[cr + 17 | 0] << 16 | m[cr + 18 | 0] << 24) >>> 24, M = T, T = Zr(li = (7 & (M |= T = (k = m[cr + 20 | 0]) >>> 16 | 0)) << 29 | (T = (k <<= 16) | pr) >>> 3, Ns = M >>> 3 | 0, Nr, 0), k = Qe + Qn | 0, k = T >>> 0 > (M = T + Po | 0) >>> 0 ? k + 1 | 0 : k, pr = (T = Zr(Pr, 0, Br, 0)) + M | 0, M = Qe + k | 0, T = T >>> 0 > (Po = pr) >>> 0 ? M + 1 | 0 : M, M = (k = m[Cs + 19 | 0]) >>> 24 | 0, Qn = k << 8 | (Vs = m[Cs + 15 | 0] | m[Cs + 16 | 0] << 8 | m[Cs + 17 | 0] << 16 | m[Cs + 18 | 0] << 24) >>> 24, k = Zr(Tr = (7 & (zn = (k = (pr = m[Cs + 20 | 0]) >>> 16 | 0) | M)) << 29 | (M = (pr <<= 16) | Qn) >>> 3, Mi = zn >>> 3 | 0, ti, 0), T = Qe + T | 0, T = k >>> 0 > (M = k + Po | 0) >>> 0 ? T + 1 | 0 : T, k = Zr(jr, 0, fi, 0), T = Qe + T | 0, Ds = T = k >>> 0 > (Es = k + M | 0) >>> 0 ? T + 1 | 0 : T, Fs = k = T - ((Es >>> 0 < 4293918720) - 1 | 0) | 0, M = (T = k >>> 21 | 0) + ye | 0, Po = M = (k = (2097151 & k) << 11 | (zn = Es - -1048576 | 0) >>> 21) >>> 0 > (fn = k + fn | 0) >>> 0 ? M + 1 | 0 : M, Ys = k = M - ((fn >>> 0 < 4293918720) - 1 | 0) | 0, es = (2097151 & k) << 11 | (Qn = fn - -1048576 | 0) >>> 21, pr = k >>> 21 | 0, k = Zr(ti, 0, Jr, 0), T = Qe, M = k, k = Zr(Nr, 0, Mr, 0), T = Qe + T | 0, T = k >>> 0 > (M = M + k | 0) >>> 0 ? T + 1 | 0 : T, Qs = (k = M) + (M = Zr(Br, 0, fi, 0)) | 0, k = Qe + T | 0, k = M >>> 0 > Qs >>> 0 ? k + 1 | 0 : k, us = Qs - (T = -2097152 & (M = Qs - -1048576 | 0)) | 0, T = (k - ((131071 & (ye = k - ((Qs >>> 0 < 4293918720) - 1 | 0) | 0)) + (T >>> 0 > Qs >>> 0) | 0) | 0) + pr | 0, io = T = (k = es + us | 0) >>> 0 < us >>> 0 ? T + 1 | 0 : T, So = k, us = Zr(k, T, 470296, 0), es = Qe, T = Zr(Nr, 0, fi, 0), k = Qe, pr = T, T = Zr(Br, 0, ti, 0), k = Qe + k | 0, T = T >>> 0 > (pr = pr + T | 0) >>> 0 ? k + 1 | 0 : k, k = ye >>> 21 | 0, ye = (2097151 & ye) << 11 | M >>> 21, M = k + T | 0, Ba = ye = (M = ye >>> 0 > (pr = ye + pr | 0) >>> 0 ? M + 1 | 0 : M) - ((pr >>> 0 < 4293918720) - 1 | 0) | 0, k = pr - (T = -2097152 & (ma = pr - -1048576 | 0)) | 0, qo = pr = M - ((131071 & ye) + (T >>> 0 > pr >>> 0) | 0) | 0, Ln = T = fn - (M = -2097152 & Qn) | 0, ro = ye = Po - ((M >>> 0 > fn >>> 0) + Ys | 0) | 0, Qo = k, M = Zr(k, pr, 666643, 0), k = Qe + es | 0, k = M >>> 0 > (pr = M + us | 0) >>> 0 ? k + 1 | 0 : k, M = Zr(T, ye, 654183, 0), T = Qe + k | 0, Rs = ye = M + pr | 0, Qn = M >>> 0 > ye >>> 0 ? T + 1 | 0 : T, Qs = Es - (k = -2097152 & zn) | 0, Fs = Ds - ((k >>> 0 > Es >>> 0) + Fs | 0) | 0, T = Zr(Br, 0, li, Ns), M = Qe, ye = (k = T) + (T = Zr(Wi = ca >>> 6 & 2097151, 0, Nr, 0)) | 0, k = Qe + M | 0, k = T >>> 0 > ye >>> 0 ? k + 1 | 0 : k, T = Zr(Mr, 0, jr, 0), M = Qe + k | 0, M = T >>> 0 > (ye = T + ye | 0) >>> 0 ? M + 1 | 0 : M, k = Zr(Pr, 0, Jr, 0), T = Qe + M | 0, T = k >>> 0 > (ye = k + ye | 0) >>> 0 ? T + 1 | 0 : T, M = Zr(ti, 0, vn = Vs >>> 6 & 2097151, 0), k = Qe + T | 0, k = M >>> 0 > (ye = M + ye | 0) >>> 0 ? k + 1 | 0 : k, M = Zr(fi, 0, Tr, Mi), T = Qe + k | 0, Es = ye = M + ye | 0, pr = M >>> 0 > ye >>> 0 ? T + 1 | 0 : T, T = (k = m[cr + 14 | 0]) >>> 24 | 0, ye = k << 8 | (Ds = m[cr + 10 | 0] | m[cr + 11 | 0] << 8 | m[cr + 12 | 0] << 16 | m[cr + 13 | 0] << 24) >>> 24, T = Zr(Tn = 2097151 & ((1 & (T |= k = (M = m[cr + 15 | 0]) >>> 16 | 0)) << 31 | (k = (M <<= 16) | ye) >>> 1), 0, Nr, 0), k = Qe, M = T, T = Zr(Br, 0, Wi, 0), k = Qe + k | 0, k = T >>> 0 > (M = M + T | 0) >>> 0 ? k + 1 | 0 : k, ye = (T = Zr(Jr, 0, li, Ns)) + M | 0, M = Qe + k | 0, M = T >>> 0 > ye >>> 0 ? M + 1 | 0 : M, k = Zr(Mr, 0, Tr, Mi), T = Qe + M | 0, T = k >>> 0 > (ye = k + ye | 0) >>> 0 ? T + 1 | 0 : T, k = Zr(Pr, 0, jr, 0), T = Qe + T | 0, zn = M = k + ye | 0, ye = k >>> 0 > M >>> 0 ? T + 1 | 0 : T, T = (k = m[Cs + 14 | 0]) >>> 24 | 0, Po = k << 8 | (fn = m[Cs + 10 | 0] | m[Cs + 11 | 0] << 8 | m[Cs + 12 | 0] << 16 | m[Cs + 13 | 0] << 24) >>> 24, M = T, T = (k = m[Cs + 15 | 0]) >>> 16 | 0, T = Zr(Ni = 2097151 & ((1 & (T |= M)) << 31 | (k = k << 16 | Po) >>> 1), 0, ti, 0), k = Qe + ye | 0, k = T >>> 0 > (M = T + zn | 0) >>> 0 ? k + 1 | 0 : k, T = Zr(fi, 0, vn, 0), k = Qe + k | 0, Po = k = T >>> 0 > (zn = T + M | 0) >>> 0 ? k + 1 | 0 : k, Ea = T = k - ((zn >>> 0 < 4293918720) - 1 | 0) | 0, M = (k = T >>> 21 | 0) + pr | 0, es = M = (T = (2097151 & T) << 11 | (us = zn - -1048576 | 0) >>> 21) >>> 0 > (Ys = T + Es | 0) >>> 0 ? M + 1 | 0 : M, ua = T = M - ((Ys >>> 0 < 4293918720) - 1 | 0) | 0, k = (k = T >>> 21 | 0) + Fs | 0, Vo = k = (T = (M = (2097151 & T) << 11 | (Es = Ys - -1048576 | 0) >>> 21) + Qs | 0) >>> 0 < M >>> 0 ? k + 1 | 0 : k, as = T, k = Zr(T, k, -997805, -1), T = Qe + Qn | 0, Rs = M = k + Rs | 0, Qn = k >>> 0 > M >>> 0 ? T + 1 | 0 : T, Qs = (Ka = m[23 + (ve = gr + 224 | 0) | 0] | m[ve + 24 | 0] << 8 | m[ve + 25 | 0] << 16 | m[ve + 26 | 0] << 24) >>> 5 & 2097151, M = Zr(Yi = (k = m[cr + 2 | 0]) << 16 & 2031616 | m[0 | cr] | m[cr + 1 | 0] << 8, 0, Jr, 0), T = Qe, ye = (k = Zr(jr, 0, Xi = (pr = m[cr + 2 | 0] | m[cr + 3 | 0] << 8 | m[cr + 4 | 0] << 16 | m[cr + 5 | 0] << 24) >>> 5 & 2097151, 0)) + M | 0, M = Qe + T | 0, M = k >>> 0 > ye >>> 0 ? M + 1 | 0 : M, k = Zr($n = (m[cr + 7 | 0] | m[cr + 8 | 0] << 8 | m[cr + 9 | 0] << 16 | m[cr + 10 | 0] << 24) >>> 7 & 2097151, 0, vn, 0), T = Qe + M | 0, T = k >>> 0 > (ye = k + ye | 0) >>> 0 ? T + 1 | 0 : T, M = Zr(Ni, 0, Zn = Ds >>> 4 & 2097151, 0), k = Qe + T | 0, Ds = ye = M + ye | 0, ye = M >>> 0 > ye >>> 0 ? k + 1 | 0 : k, pr = (T = m[cr + 6 | 0]) << 8 | pr >>> 24, M = k = T >>> 24 | 0, T = (k = m[cr + 7 | 0]) >>> 16 | 0, T = Zr(to = 2097151 & ((3 & (T |= M)) << 30 | (k = k << 16 | pr) >>> 2), 0, Tr, Mi), k = Qe + ye | 0, k = T >>> 0 > (M = T + Ds | 0) >>> 0 ? k + 1 | 0 : k, ye = (T = Zr(Wi, 0, fo = (m[Cs + 7 | 0] | m[Cs + 8 | 0] << 8 | m[Cs + 9 | 0] << 16 | m[Cs + 10 | 0] << 24) >>> 7 & 2097151, 0)) + M | 0, M = Qe + k | 0, M = T >>> 0 > ye >>> 0 ? M + 1 | 0 : M, T = Zr(Tn, 0, la = fn >>> 4 & 2097151, 0), k = Qe + M | 0, pr = T >>> 0 > (ye = T + ye | 0) >>> 0 ? k + 1 | 0 : k, k = (T = m[Cs + 6 | 0]) >>> 24 | 0, Ds = T << 8 | (fn = m[Cs + 2 | 0] | m[Cs + 3 | 0] << 8 | m[Cs + 4 | 0] << 16 | m[Cs + 5 | 0] << 24) >>> 24, T = k, k = Zr(li, Ns, wo = 2097151 & ((3 & (T |= M = (k = m[Cs + 7 | 0]) >>> 16 | 0)) << 30 | (k = k << 16 | Ds) >>> 2), 0), T = Qe + pr | 0, T = k >>> 0 > (M = k + ye | 0) >>> 0 ? T + 1 | 0 : T, ye = M, M = Zr(bo = (k = m[Cs + 2 | 0]) << 16 & 2031616 | m[0 | Cs] | m[Cs + 1 | 0] << 8, 0, Mr, 0), k = Qe + T | 0, k = M >>> 0 > (ye = ye + M | 0) >>> 0 ? k + 1 | 0 : k, T = Zr(Pr, 0, go = fn >>> 5 & 2097151, 0), k = Qe + k | 0, k = T >>> 0 > (M = T + ye | 0) >>> 0 ? k + 1 | 0 : k, T = M, Ds = M = M + Qs | 0, pr = T = T >>> 0 > M >>> 0 ? k + 1 | 0 : k, ye = m[ve + 21 | 0] | m[ve + 22 | 0] << 8, k = Zr(jr, 0, Yi, 0), T = Qe, fn = (M = k) + (k = Zr(Tr, Mi, Xi, 0)) | 0, M = Qe + T | 0, M = k >>> 0 > fn >>> 0 ? M + 1 | 0 : M, k = Zr(Ni, 0, $n, 0), T = Qe + M | 0, T = k >>> 0 > (fn = k + fn | 0) >>> 0 ? T + 1 | 0 : T, k = Zr(Zn, 0, la, 0), T = Qe + T | 0, T = k >>> 0 > (M = k + fn | 0) >>> 0 ? T + 1 | 0 : T, fn = (k = M) + (M = Zr(vn, 0, to, 0)) | 0, k = Qe + T | 0, k = M >>> 0 > fn >>> 0 ? k + 1 | 0 : k, T = Zr(Wi, 0, wo, 0), k = Qe + k | 0, k = T >>> 0 > (M = T + fn | 0) >>> 0 ? k + 1 | 0 : k, fn = (T = Zr(Tn, 0, fo, 0)) + M | 0, M = Qe + k | 0, M = T >>> 0 > fn >>> 0 ? M + 1 | 0 : M, k = Zr(li, Ns, go, 0), T = Qe + M | 0, T = k >>> 0 > (fn = k + fn | 0) >>> 0 ? T + 1 | 0 : T, k = Zr(Pr, 0, bo, 0), T = Qe + T | 0, k = k >>> 0 > (M = k + fn | 0) >>> 0 ? T + 1 | 0 : T, T = (T = M) >>> 0 > (M = M + ye | 0) >>> 0 ? k + 1 | 0 : k, ye = M, M = (k = m[ve + 23 | 0]) << 16 & 2031616, k = T, M = k = M >>> 0 > (ye = ye + M | 0) >>> 0 ? k + 1 | 0 : k, Cs = k = k - ((ye >>> 0 < 4293918720) - 1 | 0) | 0, T = (T = k >>> 21 | 0) + pr | 0, k = (T = (pr = Ds = (k = (2097151 & k) << 11 | (fn = ye - -1048576 | 0) >>> 21) + Ds | 0) >>> 0 < k >>> 0 ? T + 1 | 0 : T) + Qn | 0, k = (Qn = pr + Rs | 0) >>> 0 < pr >>> 0 ? k + 1 | 0 : k, Vs = pr - -1048576 | 0, Hs = pr = T - ((pr >>> 0 < 4293918720) - 1 | 0) | 0, ra = Qn - (T = -2097152 & Vs) | 0, _a = k - ((T >>> 0 > Qn >>> 0) + pr | 0) | 0, Ds = ye, Qn = M, k = Zr(Ln, ro, 470296, 0), T = Qe, M = k, k = Zr(So, io, 666643, 0), T = Qe + T | 0, T = k >>> 0 > (M = M + k | 0) >>> 0 ? T + 1 | 0 : T, ye = (k = M) + (M = Zr(as, Vo, 654183, 0)) | 0, k = Qe + T | 0, ca = ye, pr = M >>> 0 > ye >>> 0 ? k + 1 | 0 : k, T = Zr(Tr, Mi, Yi, 0), k = Qe, M = T, T = Zr(vn, 0, Xi, 0), k = Qe + k | 0, k = T >>> 0 > (M = M + T | 0) >>> 0 ? k + 1 | 0 : k, ye = (T = M) + (M = Zr($n, 0, la, 0)) | 0, T = Qe + k | 0, T = M >>> 0 > ye >>> 0 ? T + 1 | 0 : T, k = Zr(Zn, 0, fo, 0), M = Qe + T | 0, M = k >>> 0 > (ye = k + ye | 0) >>> 0 ? M + 1 | 0 : M, k = Zr(Ni, 0, to, 0), T = Qe + M | 0, T = k >>> 0 > (ye = k + ye | 0) >>> 0 ? T + 1 | 0 : T, M = Zr(Wi, 0, go, 0), k = Qe + T | 0, k = M >>> 0 > (ye = M + ye | 0) >>> 0 ? k + 1 | 0 : k, T = Zr(Tn, 0, wo, 0), k = Qe + k | 0, k = T >>> 0 > (M = T + ye | 0) >>> 0 ? k + 1 | 0 : k, ye = (T = M) + (M = Zr(li, Ns, bo, 0)) | 0, T = Qe + k | 0, Qs = ye, M = M >>> 0 > ye >>> 0 ? T + 1 | 0 : T, T = (k = m[ve + 19 | 0]) >>> 24 | 0, Fs = k << 8 | (Rs = m[ve + 15 | 0] | m[ve + 16 | 0] << 8 | m[ve + 17 | 0] << 16 | m[ve + 18 | 0] << 24) >>> 24, M = ((xa = (k = (ye = m[ve + 20 | 0]) >>> 16 | 0) | T) >>> 3 | 0) + M | 0, Qs = ye = (T = (7 & xa) << 29 | (T = (ye <<= 16) | Fs) >>> 3) + Qs | 0, ye = T >>> 0 > ye >>> 0 ? M + 1 | 0 : M, Fs = Rs >>> 6 & 2097151, k = Zr(vn, 0, Yi, 0), T = Qe, M = k, k = Zr(Ni, 0, Xi, 0), T = Qe + T | 0, T = k >>> 0 > (M = M + k | 0) >>> 0 ? T + 1 | 0 : T, Rs = (k = M) + (M = Zr($n, 0, fo, 0)) | 0, k = Qe + T | 0, k = M >>> 0 > Rs >>> 0 ? k + 1 | 0 : k, M = Zr(Zn, 0, wo, 0), T = Qe + k | 0, T = M >>> 0 > (Rs = M + Rs | 0) >>> 0 ? T + 1 | 0 : T, M = Zr(to, 0, la, 0), k = Qe + T | 0, k = M >>> 0 > (Rs = M + Rs | 0) >>> 0 ? k + 1 | 0 : k, T = Zr(Wi, 0, bo, 0), M = Qe + k | 0, M = T >>> 0 > (Rs = T + Rs | 0) >>> 0 ? M + 1 | 0 : M, k = Zr(Tn, 0, go, 0), T = Qe + M | 0, k = k >>> 0 > (Rs = k + Rs | 0) >>> 0 ? T + 1 | 0 : T, Ja = k = (of = Rs + Fs | 0) >>> 0 < Rs >>> 0 ? k + 1 | 0 : k, bf = k = k - ((of >>> 0 < 4293918720) - 1 | 0) | 0, M = (2097151 & k) << 11 | (Df = of - -1048576 | 0) >>> 21, k = (k >>> 21 | 0) + ye | 0, Ff = k = M >>> 0 > (Vf = M + Qs | 0) >>> 0 ? k + 1 | 0 : k, qc = k = k - ((Vf >>> 0 < 4293918720) - 1 | 0) | 0, M = (2097151 & k) << 11 | (ef = Vf - -1048576 | 0) >>> 21, k = (k >>> 21 | 0) + pr | 0, T = (M >>> 0 > (ye = M + ca | 0) >>> 0 ? k + 1 | 0 : k) + Qn | 0, Qn = (M = ye + Ds | 0) - (k = -2097152 & fn) | 0, Cs = k = (T = M >>> 0 < ye >>> 0 ? T + 1 | 0 : T) - ((k >>> 0 > M >>> 0) + Cs | 0) | 0, iu = k = k - ((Qn >>> 0 < 4293918720) - 1 | 0) | 0, M = (2097151 & k) << 11 | (gf = Qn - -1048576 | 0) >>> 21, k = (k >> 21) + _a | 0, ye = k = M >>> 0 > (pr = M + ra | 0) >>> 0 ? k + 1 | 0 : k, ff = k = k - ((pr >>> 0 < 4293918720) - 1 | 0) | 0, yf = (2097151 & k) << 11 | (ca = pr - -1048576 | 0) >>> 21, Ds = k >> 21, xa = Ys - (k = -2097152 & Es) | 0, ua = es - ((k >>> 0 > Ys >>> 0) + ua | 0) | 0, k = Zr(Nr, 0, ti, 0), Bf = T = Qe, ra = k, Rs = k - -1048576 | 0, sf = T = T - ((k >>> 0 < 4293918720) - 1 | 0) | 0, cs = k = T >>> 21 | 0, k = Zr(qn = (2097151 & T) << 11 | Rs >>> 21, k, -683901, -1), T = Qe + Po | 0, T = k >>> 0 > (M = k + zn | 0) >>> 0 ? T + 1 | 0 : T, Es = M - (k = -2097152 & us) | 0, fn = T - ((k >>> 0 > M >>> 0) + Ea | 0) | 0, T = Zr(Jr, 0, Wi, 0), k = Qe, M = T, T = Zr(Nr, 0, Zn, 0), k = Qe + k | 0, k = T >>> 0 > (M = M + T | 0) >>> 0 ? k + 1 | 0 : k, T = Zr(Br, 0, Tn, 0), k = Qe + k | 0, k = T >>> 0 > (M = T + M | 0) >>> 0 ? k + 1 | 0 : k, Po = (T = M) + (M = Zr(jr, 0, li, Ns)) | 0, T = Qe + k | 0, T = M >>> 0 > Po >>> 0 ? T + 1 | 0 : T, k = Zr(Mr, 0, vn, 0), M = Qe + T | 0, M = k >>> 0 > (Po = k + Po | 0) >>> 0 ? M + 1 | 0 : M, k = Zr(Pr, 0, Tr, Mi), T = Qe + M | 0, T = k >>> 0 > (Po = k + Po | 0) >>> 0 ? T + 1 | 0 : T, M = Zr(ti, 0, la, 0), k = Qe + T | 0, k = M >>> 0 > (Po = M + Po | 0) >>> 0 ? k + 1 | 0 : k, T = Zr(fi, 0, Ni, 0), k = Qe + k | 0, zn = M = T + Po | 0, Po = T >>> 0 > M >>> 0 ? k + 1 | 0 : k, k = Zr(Br, 0, Zn, 0), T = Qe, M = k, k = Zr(Nr, 0, $n, 0), T = Qe + T | 0, T = k >>> 0 > (M = M + k | 0) >>> 0 ? T + 1 | 0 : T, es = (k = Zr(jr, 0, Wi, 0)) + M | 0, M = Qe + T | 0, M = k >>> 0 > es >>> 0 ? M + 1 | 0 : M, k = Zr(Jr, 0, Tn, 0), T = Qe + M | 0, T = k >>> 0 > (es = k + es | 0) >>> 0 ? T + 1 | 0 : T, M = Zr(li, Ns, Tr, Mi), k = Qe + T | 0, k = M >>> 0 > (es = M + es | 0) >>> 0 ? k + 1 | 0 : k, T = Zr(Mr, 0, Ni, 0), k = Qe + k | 0, k = T >>> 0 > (M = T + es | 0) >>> 0 ? k + 1 | 0 : k, es = (T = M) + (M = Zr(Pr, 0, vn, 0)) | 0, T = Qe + k | 0, T = M >>> 0 > es >>> 0 ? T + 1 | 0 : T, k = Zr(ti, 0, fo, 0), M = Qe + T | 0, M = k >>> 0 > (es = k + es | 0) >>> 0 ? M + 1 | 0 : M, k = Zr(fi, 0, la, 0), T = Qe + M | 0, Fs = T = k >>> 0 > (Qs = k + es | 0) >>> 0 ? T + 1 | 0 : T, ic = k = T - ((Qs >>> 0 < 4293918720) - 1 | 0) | 0, T = (2097151 & k) << 11 | (Ys = Qs - -1048576 | 0) >>> 21, k = (k >>> 21 | 0) + Po | 0, us = k = T >>> 0 > (Ea = T + zn | 0) >>> 0 ? k + 1 | 0 : k, nf = k = k - ((Ea >>> 0 < 4293918720) - 1 | 0) | 0, T = (M = k >>> 21 | 0) + fn | 0, Es = T = (k = (2097151 & k) << 11 | (es = Ea - -1048576 | 0) >>> 21) >>> 0 > (_a = k + Es | 0) >>> 0 ? T + 1 | 0 : T, Qa = k = T - ((_a >>> 0 < 4293918720) - 1 | 0) | 0, Po = (2097151 & k) << 11 | (fn = _a - -1048576 | 0) >>> 21, k = (k >> 21) + ua | 0, ms = k = (T = Po + xa | 0) >>> 0 < Po >>> 0 ? k + 1 | 0 : k, ai = T, k = Zr(T, k, -683901, -1), T = Qe + Ds | 0, yf = M = k + yf | 0, Ds = k >>> 0 > M >>> 0 ? T + 1 | 0 : T, k = Zr(Br, 0, Yi, 0), T = Qe, M = k, k = Zr(Jr, 0, Xi, 0), T = Qe + T | 0, T = k >>> 0 > (M = M + k | 0) >>> 0 ? T + 1 | 0 : T, Po = (k = M) + (M = Zr(Tr, Mi, $n, 0)) | 0, k = Qe + T | 0, k = M >>> 0 > Po >>> 0 ? k + 1 | 0 : k, T = Zr(vn, 0, Zn, 0), M = Qe + k | 0, M = T >>> 0 > (Po = T + Po | 0) >>> 0 ? M + 1 | 0 : M, T = Zr(jr, 0, to, 0), k = Qe + M | 0, k = T >>> 0 > (Po = T + Po | 0) >>> 0 ? k + 1 | 0 : k, M = Zr(Wi, 0, la, 0), T = Qe + k | 0, T = M >>> 0 > (Po = M + Po | 0) >>> 0 ? T + 1 | 0 : T, k = Zr(Tn, 0, Ni, 0), T = Qe + T | 0, T = k >>> 0 > (M = k + Po | 0) >>> 0 ? T + 1 | 0 : T, Po = (k = M) + (M = Zr(li, Ns, fo, 0)) | 0, k = Qe + T | 0, k = M >>> 0 > Po >>> 0 ? k + 1 | 0 : k, T = Zr(Mr, 0, go, 0), M = Qe + k | 0, M = T >>> 0 > (Po = T + Po | 0) >>> 0 ? M + 1 | 0 : M, T = Zr(Pr, 0, wo, 0), k = Qe + M | 0, k = T >>> 0 > (Po = T + Po | 0) >>> 0 ? k + 1 | 0 : k, M = Zr(fi, 0, bo, 0), T = Qe + k | 0, ua = Po = M + Po | 0, M = M >>> 0 > Po >>> 0 ? T + 1 | 0 : T, T = (k = m[ve + 27 | 0]) >>> 24 | 0, zn = k << 8 | Ka >>> 24, Po = 2097151 & ((3 & (T |= k = (Po = m[ve + 28 | 0]) >>> 16 | 0)) << 30 | (k = (Po <<= 16) | zn) >>> 2), T = M, zn = k = Po + ua | 0, Po = k >>> 0 < Po >>> 0 ? T + 1 | 0 : T, xa = Zr(Qo, qo, 470296, 0), ua = Qe, k = (M = (2097151 & Ba) << 11 | ma >>> 21) + (ra - (T = -2097152 & Rs) | 0) | 0, T = Bf - ((524287 & sf) + (T >>> 0 > ra >>> 0) | 0) + (Ba >>> 21) | 0, ci = T = k >>> 0 < M >>> 0 ? T + 1 | 0 : T, Fi = k, T = Zr(k, T, 666643, 0), k = Qe + ua | 0, k = T >>> 0 > (M = T + xa | 0) >>> 0 ? k + 1 | 0 : k, Rs = (T = Zr(So, io, 654183, 0)) + M | 0, M = Qe + k | 0, M = T >>> 0 > Rs >>> 0 ? M + 1 | 0 : M, T = Zr(Ln, ro, -997805, -1), k = Qe + M | 0, k = T >>> 0 > (Rs = T + Rs | 0) >>> 0 ? k + 1 | 0 : k, M = Zr(as, Vo, 136657, 0), T = Qe + k | 0, Vs = (k = (2097151 & Hs) << 11 | Vs >>> 21) + (Rs = M + Rs | 0) | 0, T = (Hs >>> 21 | 0) + (M >>> 0 > Rs >>> 0 ? T + 1 | 0 : T) | 0, sf = Rs = Po - ((zn >>> 0 < 4293918720) - 1 | 0) | 0, k = (k >>> 0 > Vs >>> 0 ? T + 1 | 0 : T) + Po | 0, T = (Po = zn + Vs | 0) - (M = -2097152 & (Bf = zn - -1048576 | 0)) | 0, M = (k = (k = Po >>> 0 < Vs >>> 0 ? k + 1 | 0 : k) - ((M >>> 0 > Po >>> 0) + Rs | 0) | 0) + Ds | 0, xa = Po = k - ((T >>> 0 < 4293918720) - 1 | 0) | 0, ra = (M = (zn = T + yf | 0) >>> 0 < T >>> 0 ? M + 1 | 0 : M) - (((T = -2097152 & (ua = T - -1048576 | 0)) >>> 0 > zn >>> 0) + Po | 0) | 0, Ka = k = zn - T | 0, Po = pr, pr = ye, nc = _a - (k = -2097152 & fn) | 0, Rs = Es - ((k >>> 0 > _a >>> 0) + Qa | 0) | 0, k = Zr(Fi, ci, -683901, -1), T = Qe, ye = (M = k) + (k = Zr(qn, cs, 136657, 0)) | 0, M = Qe + T | 0, T = us + (k >>> 0 > ye >>> 0 ? M + 1 | 0 : M) | 0, es = (M = ye + Ea | 0) - (k = -2097152 & es) | 0, Es = (T = M >>> 0 < Ea >>> 0 ? T + 1 | 0 : T) - ((k >>> 0 > M >>> 0) + nf | 0) | 0, T = Zr(qn, cs, -997805, -1), k = Qe + Fs | 0, k = T >>> 0 > (M = T + Qs | 0) >>> 0 ? k + 1 | 0 : k, ye = (T = Zr(Fi, ci, 136657, 0)) + M | 0, M = Qe + k | 0, M = T >>> 0 > ye >>> 0 ? M + 1 | 0 : M, k = Zr(Qo, qo, -683901, -1), T = Qe + M | 0, T = k >>> 0 > (ye = k + ye | 0) >>> 0 ? T + 1 | 0 : T, fn = ye - (k = -2097152 & Ys) | 0, Ds = T - ((k >>> 0 > ye >>> 0) + ic | 0) | 0, T = Zr(Jr, 0, Zn, 0), k = Qe, M = T, T = Zr(Br, 0, $n, 0), k = Qe + k | 0, k = T >>> 0 > (M = M + T | 0) >>> 0 ? k + 1 | 0 : k, ye = (T = Zr(Nr, 0, to, 0)) + M | 0, M = Qe + k | 0, M = T >>> 0 > ye >>> 0 ? M + 1 | 0 : M, k = Zr(Tr, Mi, Wi, 0), T = Qe + M | 0, T = k >>> 0 > (ye = k + ye | 0) >>> 0 ? T + 1 | 0 : T, M = Zr(jr, 0, Tn, 0), k = Qe + T | 0, k = M >>> 0 > (ye = M + ye | 0) >>> 0 ? k + 1 | 0 : k, M = Zr(li, Ns, vn, 0), T = Qe + k | 0, T = M >>> 0 > (ye = M + ye | 0) >>> 0 ? T + 1 | 0 : T, M = Zr(Mr, 0, la, 0), k = Qe + T | 0, k = M >>> 0 > (ye = M + ye | 0) >>> 0 ? k + 1 | 0 : k, T = Zr(Pr, 0, Ni, 0), M = Qe + k | 0, M = T >>> 0 > (ye = T + ye | 0) >>> 0 ? M + 1 | 0 : M, k = Zr(ti, 0, wo, 0), T = Qe + M | 0, T = k >>> 0 > (ye = k + ye | 0) >>> 0 ? T + 1 | 0 : T, M = Zr(fi, 0, fo, 0), k = Qe + T | 0, zn = ye = M + ye | 0, ye = M >>> 0 > ye >>> 0 ? k + 1 | 0 : k, k = Zr(Jr, 0, $n, 0), T = Qe, M = k, k = Zr(Nr, 0, Xi, 0), T = Qe + T | 0, T = k >>> 0 > (M = M + k | 0) >>> 0 ? T + 1 | 0 : T, us = (k = M) + (M = Zr(jr, 0, Zn, 0)) | 0, k = Qe + T | 0, k = M >>> 0 > us >>> 0 ? k + 1 | 0 : k, T = Zr(Br, 0, to, 0), M = Qe + k | 0, M = T >>> 0 > (us = T + us | 0) >>> 0 ? M + 1 | 0 : M, k = Zr(Wi, 0, vn, 0), T = Qe + M | 0, T = k >>> 0 > (us = k + us | 0) >>> 0 ? T + 1 | 0 : T, M = Zr(Tr, Mi, Tn, 0), k = Qe + T | 0, k = M >>> 0 > (us = M + us | 0) >>> 0 ? k + 1 | 0 : k, M = Zr(li, Ns, Ni, 0), T = Qe + k | 0, T = M >>> 0 > (us = M + us | 0) >>> 0 ? T + 1 | 0 : T, M = Zr(Mr, 0, fo, 0), k = Qe + T | 0, k = M >>> 0 > (us = M + us | 0) >>> 0 ? k + 1 | 0 : k, T = Zr(Pr, 0, la, 0), M = Qe + k | 0, M = T >>> 0 > (us = T + us | 0) >>> 0 ? M + 1 | 0 : M, us = (k = Zr(ti, 0, go, 0)) + us | 0, T = Qe + M | 0, M = Zr(fi, 0, wo, 0), k = Qe + (k >>> 0 > us >>> 0 ? T + 1 | 0 : T) | 0, _a = k = M >>> 0 > (Qa = M + us | 0) >>> 0 ? k + 1 | 0 : k, is = k = k - ((Qa >>> 0 < 4293918720) - 1 | 0) | 0, M = (2097151 & k) << 11 | (Ba = Qa - -1048576 | 0) >>> 21, k = (k >>> 21 | 0) + ye | 0, ma = k = M >>> 0 > (yf = M + zn | 0) >>> 0 ? k + 1 | 0 : k, ws = k = k - ((yf >>> 0 < 4293918720) - 1 | 0) | 0, M = (2097151 & k) << 11 | (Hs = yf - -1048576 | 0) >>> 21, k = (k >>> 21 | 0) + Ds | 0, Vs = k = M >>> 0 > (Ea = M + fn | 0) >>> 0 ? k + 1 | 0 : k, ys = k = k - ((Ea >>> 0 < 4293918720) - 1 | 0) | 0, M = (2097151 & k) << 11 | (Fs = Ea - -1048576 | 0) >>> 21, k = (k >> 21) + Es | 0, ye = k = M >>> 0 > (fn = M + es | 0) >>> 0 ? k + 1 | 0 : k, Es = k = k - ((fn >>> 0 < 4293918720) - 1 | 0) | 0, Ds = (2097151 & k) << 11 | (M = fn - -1048576 | 0) >>> 21, k = (k >> 21) + Rs | 0, ic = k = (zn = Ds + nc | 0) >>> 0 < Ds >>> 0 ? k + 1 | 0 : k, nf = zn, k = Zr(zn, k, -683901, -1), T = Qe, zn = k, k = Zr(ai, ms, 136657, 0), T = Qe + T | 0, k = (k >>> 0 > (zn = zn + k | 0) >>> 0 ? T + 1 | 0 : T) + pr | 0, Ou = (pr = Po + zn | 0) - (T = -2097152 & ca) | 0, fh = (k = pr >>> 0 < zn >>> 0 ? k + 1 | 0 : k) - ((T >>> 0 > pr >>> 0) + ff | 0) | 0, Ds = Qn, zn = Cs, Qn = Zr(nf, ic, 136657, 0), pr = Qe, nc = k = fn - (T = -2097152 & M) | 0, Eo = ye = ye - ((T >>> 0 > fn >>> 0) + Es | 0) | 0, M = Zr(ai, ms, -997805, -1), T = Qe + pr | 0, T = M >>> 0 > (Qn = M + Qn | 0) >>> 0 ? T + 1 | 0 : T, M = Zr(k, ye, -683901, -1), k = Qe + T | 0, ff = ye = M + Qn | 0, Po = M >>> 0 > ye >>> 0 ? k + 1 | 0 : k, k = Zr(as, Vo, 470296, 0), T = Qe, ye = (M = k) + (k = Zr(Ln, ro, 666643, 0)) | 0, M = Qe + T | 0, T = Ff + (k >>> 0 > ye >>> 0 ? M + 1 | 0 : M) | 0, ca = k = ye + Vf | 0, pr = T = k >>> 0 < Vf >>> 0 ? T + 1 | 0 : T, T = Zr(as, Vo, 666643, 0), k = Qe + Ja | 0, k = T >>> 0 > (M = T + of | 0) >>> 0 ? k + 1 | 0 : k, es = M - (T = -2097152 & Df) | 0, Qs = k - ((T >>> 0 > M >>> 0) + bf | 0) | 0, T = Zr(Ni, 0, Yi, 0), k = Qe, M = T, T = Zr(Xi, 0, la, 0), k = Qe + k | 0, k = T >>> 0 > (M = M + T | 0) >>> 0 ? k + 1 | 0 : k, ye = (T = M) + (M = Zr($n, 0, wo, 0)) | 0, T = Qe + k | 0, T = M >>> 0 > ye >>> 0 ? T + 1 | 0 : T, M = Zr(Zn, 0, go, 0), k = Qe + T | 0, k = M >>> 0 > (ye = M + ye | 0) >>> 0 ? k + 1 | 0 : k, T = Zr(to, 0, fo, 0), M = Qe + k | 0, M = T >>> 0 > (ye = T + ye | 0) >>> 0 ? M + 1 | 0 : M, k = Zr(Tn, 0, bo, 0), T = Qe + M | 0, fn = ye = k + ye | 0, ye = k >>> 0 > ye >>> 0 ? T + 1 | 0 : T, T = (k = m[ve + 14 | 0]) >>> 24 | 0, Qn = k << 8 | (Es = m[ve + 10 | 0] | m[ve + 11 | 0] << 8 | m[ve + 12 | 0] << 16 | m[ve + 13 | 0] << 24) >>> 24, T = 2097151 & ((1 & (T |= M = (k = m[ve + 15 | 0]) >>> 16 | 0)) << 31 | (k = Qn | k << 16) >>> 1), k = ye, fn = M = T + fn | 0, ye = T >>> 0 > M >>> 0 ? k + 1 | 0 : k, Qn = Es >>> 4 & 2097151, k = Zr(Yi, 0, la, 0), T = Qe, M = k, k = Zr(Xi, 0, fo, 0), T = Qe + T | 0, T = k >>> 0 > (M = M + k | 0) >>> 0 ? T + 1 | 0 : T, k = Zr($n, 0, go, 0), T = Qe + T | 0, T = k >>> 0 > (M = k + M | 0) >>> 0 ? T + 1 | 0 : T, Es = (k = M) + (M = Zr(Zn, 0, bo, 0)) | 0, k = Qe + T | 0, k = M >>> 0 > Es >>> 0 ? k + 1 | 0 : k, T = Zr(to, 0, wo, 0), M = Qe + k | 0, k = T >>> 0 > (Es = T + Es | 0) >>> 0 ? M + 1 | 0 : M, Cs = k = (Df = Qn + Es | 0) >>> 0 < Es >>> 0 ? k + 1 | 0 : k, Is = k = k - ((Df >>> 0 < 4293918720) - 1 | 0) | 0, T = (M = k >>> 21 | 0) + ye | 0, Ys = T = (k = (2097151 & k) << 11 | (Rs = Df - -1048576 | 0) >>> 21) >>> 0 > (Ff = k + fn | 0) >>> 0 ? T + 1 | 0 : T, ks = k = T - ((Ff >>> 0 < 4293918720) - 1 | 0) | 0, T = (2097151 & k) << 11 | (us = Ff - -1048576 | 0) >>> 21, k = (k >>> 21 | 0) + Qs | 0, Es = k = T >>> 0 > (es = T + es | 0) >>> 0 ? k + 1 | 0 : k, Ps = k = k - ((es >>> 0 < 4293918720) - 1 | 0) | 0, T = (M = k >> 21) + pr | 0, bf = T = (T = (k = (2097151 & k) << 11 | (fn = es - -1048576 | 0) >>> 21) >>> 0 > (ye = k + ca | 0) >>> 0 ? T + 1 | 0 : T) - (((M = -2097152 & ef) >>> 0 > ye >>> 0) + qc | 0) | 0, ef = k = ye - M | 0, Qn = k - -1048576 | 0, qc = k = T - ((k >>> 0 < 4293918720) - 1 | 0) | 0, M = (T = k >> 21) + Po | 0, T = ((k = (2097151 & k) << 11 | Qn >>> 21) >>> 0 > (ye = k + ff | 0) >>> 0 ? M + 1 | 0 : M) + zn | 0, of = T = (T = (k = ye) >>> 0 > (ye = ye + Ds | 0) >>> 0 ? T + 1 | 0 : T) - (((M = -2097152 & gf) >>> 0 > ye >>> 0) + iu | 0) | 0, zn = k = ye - M | 0, pr = k - -1048576 | 0, Ja = k = T - ((k >>> 0 < 4293918720) - 1 | 0) | 0, M = (T = k >> 21) + fh | 0, gf = k = (M = (k = (2097151 & k) << 11 | pr >>> 21) >>> 0 > (Po = k + Ou | 0) >>> 0 ? M + 1 | 0 : M) - ((Po >>> 0 < 4293918720) - 1 | 0) | 0, ca = Ka - -1048576 | 0, Qs = ra - ((Ka >>> 0 < 4293918720) - 1 | 0) | 0, Ds = (2097151 & k) << 11 | (ye = Po - -1048576 | 0) >>> 21, k = (k >> 21) + ra | 0, iu = (Ka = Ds + Ka | 0) - (T = -2097152 & ca) | 0, Ou = (Ds >>> 0 > Ka >>> 0 ? k + 1 | 0 : k) - ((T >>> 0 > Ka >>> 0) + Qs | 0) | 0, fh = Po - (k = -2097152 & ye) | 0, ff = M - ((k >>> 0 > Po >>> 0) + gf | 0) | 0, Vf = zn - (k = -2097152 & pr) | 0, Ka = of - ((k >>> 0 > zn >>> 0) + Ja | 0) | 0, k = Zr(nf, ic, -997805, -1), T = Qe, M = k, k = Zr(ai, ms, 654183, 0), T = Qe + T | 0, T = k >>> 0 > (M = M + k | 0) >>> 0 ? T + 1 | 0 : T, ye = (k = M) + (M = Zr(nc, Eo, 136657, 0)) | 0, k = Qe + T | 0, T = bf + (M >>> 0 > ye >>> 0 ? k + 1 | 0 : k) | 0, of = (M = ye + ef | 0) - (k = -2097152 & Qn) | 0, Ja = (T = M >>> 0 < ef >>> 0 ? T + 1 | 0 : T) - ((k >>> 0 > M >>> 0) + qc | 0) | 0, ef = Ea - (k = -2097152 & Fs) | 0, ra = Vs - ((k >>> 0 > Ea >>> 0) + ys | 0) | 0, T = Zr(Fi, ci, -997805, -1), k = Qe, M = T, T = Zr(qn, cs, 654183, 0), k = Qe + k | 0, k = T >>> 0 > (M = M + T | 0) >>> 0 ? k + 1 | 0 : k, ye = (T = M) + (M = Zr(Qo, qo, 136657, 0)) | 0, T = Qe + k | 0, T = M >>> 0 > ye >>> 0 ? T + 1 | 0 : T, k = Zr(So, io, -683901, -1), M = Qe + T | 0, T = ma + (k >>> 0 > (ye = k + ye | 0) >>> 0 ? M + 1 | 0 : M) | 0, Fs = (M = ye + yf | 0) - (k = -2097152 & Hs) | 0, Vs = (T = M >>> 0 < yf >>> 0 ? T + 1 | 0 : T) - ((k >>> 0 > M >>> 0) + ws | 0) | 0, T = Zr(Fi, ci, 654183, 0), k = Qe, M = T, T = Zr(qn, cs, 470296, 0), k = Qe + k | 0, k = T >>> 0 > (M = M + T | 0) >>> 0 ? k + 1 | 0 : k, ye = (T = Zr(Qo, qo, -997805, -1)) + M | 0, M = Qe + k | 0, T = _a + (T >>> 0 > ye >>> 0 ? M + 1 | 0 : M) | 0, T = (k = ye + Qa | 0) >>> 0 < Qa >>> 0 ? T + 1 | 0 : T, M = k, k = Zr(So, io, 136657, 0), T = Qe + T | 0, T = k >>> 0 > (M = M + k | 0) >>> 0 ? T + 1 | 0 : T, ye = (k = M) + (M = Zr(Ln, ro, -683901, -1)) | 0, k = Qe + T | 0, Qn = ye - (T = -2097152 & Ba) | 0, pr = (M >>> 0 > ye >>> 0 ? k + 1 | 0 : k) - ((T >>> 0 > ye >>> 0) + is | 0) | 0, ye = (m[ve + 28 | 0] | m[ve + 29 | 0] << 8 | m[ve + 30 | 0] << 16 | m[ve + 31 | 0] << 24) >>> 7 | 0, k = Zr(Nr, 0, Yi, 0), T = Qe, Po = (M = k) + (k = Zr(Br, 0, Xi, 0)) | 0, M = Qe + T | 0, M = k >>> 0 > Po >>> 0 ? M + 1 | 0 : M, k = Zr(jr, 0, $n, 0), T = Qe + M | 0, T = k >>> 0 > (Po = k + Po | 0) >>> 0 ? T + 1 | 0 : T, M = Zr(Tr, Mi, Zn, 0), k = Qe + T | 0, k = M >>> 0 > (Po = M + Po | 0) >>> 0 ? k + 1 | 0 : k, M = Zr(Jr, 0, to, 0), T = Qe + k | 0, T = M >>> 0 > (Po = M + Po | 0) >>> 0 ? T + 1 | 0 : T, M = Zr(Wi, 0, Ni, 0), k = Qe + T | 0, k = M >>> 0 > (Po = M + Po | 0) >>> 0 ? k + 1 | 0 : k, T = Zr(vn, 0, Tn, 0), M = Qe + k | 0, M = T >>> 0 > (Po = T + Po | 0) >>> 0 ? M + 1 | 0 : M, k = Zr(li, Ns, la, 0), T = Qe + M | 0, T = k >>> 0 > (Po = k + Po | 0) >>> 0 ? T + 1 | 0 : T, M = Zr(Mr, 0, wo, 0), k = Qe + T | 0, k = M >>> 0 > (Po = M + Po | 0) >>> 0 ? k + 1 | 0 : k, M = Zr(Pr, 0, fo, 0), T = Qe + k | 0, T = M >>> 0 > (Po = M + Po | 0) >>> 0 ? T + 1 | 0 : T, M = Zr(ti, 0, bo, 0), k = Qe + T | 0, k = M >>> 0 > (Po = M + Po | 0) >>> 0 ? k + 1 | 0 : k, T = Zr(fi, 0, go, 0), M = Qe + k | 0, T = M = T >>> 0 > (Po = T + Po | 0) >>> 0 ? M + 1 | 0 : M, ma = (M = (2097151 & sf) << 11 | Bf >>> 21) + (k = ye + Po | 0) | 0, k = (sf >>> 21 | 0) + (T = k >>> 0 < Po >>> 0 ? T + 1 | 0 : T) | 0, Ds = k = M >>> 0 > ma >>> 0 ? k + 1 | 0 : k, gf = T = k - ((ma >>> 0 < 4293918720) - 1 | 0) | 0, M = (k = T >>> 21 | 0) + pr | 0, zn = M = (T = (2097151 & T) << 11 | (Ns = ma - -1048576 | 0) >>> 21) >>> 0 > (Hs = T + Qn | 0) >>> 0 ? M + 1 | 0 : M, Bf = T = M - ((Hs >>> 0 < 4293918720) - 1 | 0) | 0, k = (k = T >> 21) + Vs | 0, Qn = k = (T = (2097151 & T) << 11 | (Po = Hs - -1048576 | 0) >>> 21) >>> 0 > (Fs = T + Fs | 0) >>> 0 ? k + 1 | 0 : k, Ba = T = k - ((Fs >>> 0 < 4293918720) - 1 | 0) | 0, M = (k = T >> 21) + ra | 0, sf = M = (T = (ye = (2097151 & T) << 11 | (pr = Fs - -1048576 | 0) >>> 21) + ef | 0) >>> 0 < ye >>> 0 ? M + 1 | 0 : M, ra = T, k = Zr(T, M, -683901, -1), T = Qe + Ja | 0, Vs = M = k + of | 0, ye = k >>> 0 > M >>> 0 ? T + 1 | 0 : T, T = Zr(ai, ms, 470296, 0), k = Qe + Es | 0, k = T >>> 0 > (es = T + es | 0) >>> 0 ? k + 1 | 0 : k, T = Zr(nf, ic, 654183, 0), k = Qe + (k - (((M = -2097152 & fn) >>> 0 > es >>> 0) + Ps | 0) | 0) | 0, k = T >>> 0 > (fn = T + (es - M | 0) | 0) >>> 0 ? k + 1 | 0 : k, M = Zr(nc, Eo, -997805, -1), T = Qe + k | 0, T = M >>> 0 > (fn = M + fn | 0) >>> 0 ? T + 1 | 0 : T, _a = M = Fs - (k = -2097152 & pr) | 0, la = Qn = Qn - ((k >>> 0 > Fs >>> 0) + Ba | 0) | 0, fn = (pr = Zr(ra, sf, 136657, 0)) + fn | 0, k = Qe + T | 0, M = Zr(M, Qn, -683901, -1), T = Qe + (pr >>> 0 > fn >>> 0 ? k + 1 | 0 : k) | 0, Qn = T = M >>> 0 > (Es = M + fn | 0) >>> 0 ? T + 1 | 0 : T, Ba = k = T - ((Es >>> 0 < 4293918720) - 1 | 0) | 0, T = (2097151 & k) << 11 | (pr = Es - -1048576 | 0) >>> 21, k = (k >> 21) + ye | 0, Fs = T = (k = T >>> 0 > (fn = T + Vs | 0) >>> 0 ? k + 1 | 0 : k) - ((fn >>> 0 < 4293918720) - 1 | 0) | 0, es = (2097151 & T) << 11 | (ye = fn - -1048576 | 0) >>> 21, T = (T >> 21) + Ka | 0, Vf = Vs = es + Vf | 0, Vs = es >>> 0 > Vs >>> 0 ? T + 1 | 0 : T, Ka = fn - (T = -2097152 & ye) | 0, Qa = k - ((T >>> 0 > fn >>> 0) + Fs | 0) | 0, of = Es - (k = -2097152 & pr) | 0, Ja = Qn - ((k >>> 0 > Es >>> 0) + Ba | 0) | 0, k = Zr(ai, ms, 666643, 0), M = Ys + Qe | 0, M = (pr = k + Ff | 0) >>> 0 < Ff >>> 0 ? M + 1 | 0 : M, ye = (k = Zr(nf, ic, 470296, 0)) + (pr - (T = -2097152 & us) | 0) | 0, T = Qe + (M - ((T >>> 0 > pr >>> 0) + ks | 0) | 0) | 0, T = k >>> 0 > ye >>> 0 ? T + 1 | 0 : T, M = Zr(nc, Eo, 654183, 0), k = Qe + T | 0, fn = ye = M + ye | 0, ye = M >>> 0 > ye >>> 0 ? k + 1 | 0 : k, pr = Hs - (k = -2097152 & Po) | 0, Qn = zn - ((k >>> 0 > Hs >>> 0) + Bf | 0) | 0, k = Zr(Fi, ci, 470296, 0), T = Qe, M = k, k = Zr(qn, cs, 666643, 0), T = Qe + T | 0, T = k >>> 0 > (M = M + k | 0) >>> 0 ? T + 1 | 0 : T, k = Zr(Qo, qo, 654183, 0), T = Qe + T | 0, T = k >>> 0 > (M = k + M | 0) >>> 0 ? T + 1 | 0 : T, Po = (k = M) + (M = Zr(So, io, -997805, -1)) | 0, k = Qe + T | 0, k = M >>> 0 > Po >>> 0 ? k + 1 | 0 : k, T = Zr(Ln, ro, 136657, 0), k = Qe + k | 0, k = T >>> 0 > (M = T + Po | 0) >>> 0 ? k + 1 | 0 : k, Po = (T = Zr(as, Vo, -683901, -1)) + M | 0, M = Qe + k | 0, T = Ds + (T >>> 0 > Po >>> 0 ? M + 1 | 0 : M) | 0, Hs = (M = (2097151 & xa) << 11 | ua >>> 21) + ((Po = Po + ma | 0) - (k = -2097152 & Ns) | 0) | 0, k = ((T = Po >>> 0 < ma >>> 0 ? T + 1 | 0 : T) - ((k >>> 0 > Po >>> 0) + gf | 0) | 0) + (xa >> 21) | 0, Fs = k = M >>> 0 > Hs >>> 0 ? k + 1 | 0 : k, ef = k = k - ((Hs >>> 0 < 4293918720) - 1 | 0) | 0, T = pr, pr = (2097151 & k) << 11 | (us = Hs - -1048576 | 0) >>> 21, k = (k >> 21) + Qn | 0, Ba = k = (M = T + pr | 0) >>> 0 < pr >>> 0 ? k + 1 | 0 : k, ma = M, k = Zr(M, k, -683901, -1), T = Qe + ye | 0, T = k >>> 0 > (M = k + fn | 0) >>> 0 ? T + 1 | 0 : T, ye = (k = M) + (M = Zr(ra, sf, -997805, -1)) | 0, k = Qe + T | 0, k = M >>> 0 > ye >>> 0 ? k + 1 | 0 : k, T = Zr(_a, la, 136657, 0), M = Qe + k | 0, ua = ye = T + ye | 0, zn = T >>> 0 > ye >>> 0 ? M + 1 | 0 : M, fn = Df - (k = -2097152 & Rs) | 0, Ds = Cs - ((k >>> 0 > Df >>> 0) + Is | 0) | 0, T = Zr(Yi, 0, fo, 0), k = Qe, M = T, T = Zr(Xi, 0, wo, 0), k = Qe + k | 0, k = T >>> 0 > (M = M + T | 0) >>> 0 ? k + 1 | 0 : k, T = Zr($n, 0, bo, 0), k = Qe + k | 0, k = T >>> 0 > (M = T + M | 0) >>> 0 ? k + 1 | 0 : k, ye = (T = Zr(to, 0, go, 0)) + M | 0, M = Qe + k | 0, T = T >>> 0 > ye >>> 0 ? M + 1 | 0 : M, Ns = M = (k = (m[ve + 7 | 0] | m[ve + 8 | 0] << 8 | m[ve + 9 | 0] << 16 | m[ve + 10 | 0] << 24) >>> 7 & 2097151) + ye | 0, Po = k >>> 0 > M >>> 0 ? T + 1 | 0 : T, k = Zr(Yi, 0, wo, 0), T = Qe, M = k, k = Zr(Xi, 0, go, 0), T = Qe + T | 0, T = k >>> 0 > (M = M + k | 0) >>> 0 ? T + 1 | 0 : T, ye = (k = M) + (M = Zr(to, 0, bo, 0)) | 0, k = Qe + T | 0, Qn = ye, ye = M >>> 0 > ye >>> 0 ? k + 1 | 0 : k, k = (T = m[ve + 6 | 0]) >>> 24 | 0, pr = T << 8 | (gf = m[ve + 2 | 0] | m[ve + 3 | 0] << 8 | m[ve + 4 | 0] << 16 | m[ve + 5 | 0] << 24) >>> 24, M = k, T = (k = m[ve + 7 | 0]) >>> 16 | 0, T |= M, M = ye, pr = M = (k = 2097151 & ((3 & T) << 30 | (k = k << 16 | pr) >>> 2)) >>> 0 > (Qn = k + Qn | 0) >>> 0 ? M + 1 | 0 : M, yf = k = M - ((Qn >>> 0 < 4293918720) - 1 | 0) | 0, M = (2097151 & k) << 11 | (Ys = Qn - -1048576 | 0) >>> 21, k = (k >>> 21 | 0) + Po | 0, es = k = M >>> 0 > (Cs = M + Ns | 0) >>> 0 ? k + 1 | 0 : k, Bf = k = k - ((Cs >>> 0 < 4293918720) - 1 | 0) | 0, M = (T = k >>> 21 | 0) + Ds | 0, M = (k = (2097151 & k) << 11 | (Es = Cs - -1048576 | 0) >>> 21) >>> 0 > (ye = k + fn | 0) >>> 0 ? M + 1 | 0 : M, T = Zr(nf, ic, 666643, 0), k = Qe + M | 0, k = T >>> 0 > (ye = T + ye | 0) >>> 0 ? k + 1 | 0 : k, T = Zr(nc, Eo, 470296, 0), k = Qe + k | 0, k = T >>> 0 > (M = T + ye | 0) >>> 0 ? k + 1 | 0 : k, ye = (T = M) + (M = Zr(ma, Ba, 136657, 0)) | 0, T = Qe + k | 0, T = M >>> 0 > ye >>> 0 ? T + 1 | 0 : T, k = Zr(ra, sf, 654183, 0), T = Qe + T | 0, T = k >>> 0 > (M = k + ye | 0) >>> 0 ? T + 1 | 0 : T, fn = (k = Zr(_a, la, -997805, -1)) + M | 0, M = Qe + T | 0, Ds = M = k >>> 0 > fn >>> 0 ? M + 1 | 0 : M, xa = k = M - ((fn >>> 0 < 4293918720) - 1 | 0) | 0, M = (2097151 & k) << 11 | (Ns = fn - -1048576 | 0) >>> 21, k = (k >> 21) + zn | 0, ua = M = (k = M >>> 0 > (ye = M + ua | 0) >>> 0 ? k + 1 | 0 : k) - ((ye >>> 0 < 4293918720) - 1 | 0) | 0, Po = (2097151 & M) << 11 | (zn = ye - -1048576 | 0) >>> 21, M = (M >> 21) + Ja | 0, Ea = Rs = Po + of | 0, Rs = Po >>> 0 > Rs >>> 0 ? M + 1 | 0 : M, Po = ye, T = k, ye = (Hs - (k = -2097152 & us) | 0) + (us = (2097151 & Qs) << 11 | ca >>> 21) | 0, k = (Fs - ((k >>> 0 > Hs >>> 0) + ef | 0) | 0) + (Qs >> 21) | 0, Qs = k = ye >>> 0 < us >>> 0 ? k + 1 | 0 : k, of = k = k - ((ye >>> 0 < 4293918720) - 1 | 0) | 0, Hs = M = k >> 21, k = Zr(nf = (2097151 & k) << 11 | (Fs = ye - -1048576 | 0) >>> 21, M, -683901, -1), T = Qe + T | 0, T = k >>> 0 > (M = k + Po | 0) >>> 0 ? T + 1 | 0 : T, Ja = M - (k = -2097152 & zn) | 0, Df = T - ((k >>> 0 > M >>> 0) + ua | 0) | 0, T = Zr(nf, Hs, 136657, 0), k = Qe + Ds | 0, k = T >>> 0 > (M = T + fn | 0) >>> 0 ? k + 1 | 0 : k, Ff = M - (T = -2097152 & Ns) | 0, xa = k - ((T >>> 0 > M >>> 0) + xa | 0) | 0, T = Zr(nc, Eo, 666643, 0), k = Qe + (es - (((M = -2097152 & Es) >>> 0 > Cs >>> 0) + Bf | 0) | 0) | 0, k = T >>> 0 > (Po = T + (Cs - M | 0) | 0) >>> 0 ? k + 1 | 0 : k, M = Zr(ma, Ba, -997805, -1), T = Qe + k | 0, T = M >>> 0 > (Po = M + Po | 0) >>> 0 ? T + 1 | 0 : T, k = Zr(ra, sf, 470296, 0), M = Qe + T | 0, M = k >>> 0 > (Po = k + Po | 0) >>> 0 ? M + 1 | 0 : M, T = Zr(_a, la, 654183, 0), k = Qe + M | 0, ua = Po = T + Po | 0, Ds = T >>> 0 > Po >>> 0 ? k + 1 | 0 : k, M = gf >>> 5 & 2097151, k = Zr(Yi, 0, go, 0), T = Qe, zn = k, k = Zr(Xi, 0, bo, 0), T = Qe + T | 0, k = k >>> 0 > (Po = zn + k | 0) >>> 0 ? T + 1 | 0 : T, zn = T = M + Po | 0, M = k = T >>> 0 < Po >>> 0 ? k + 1 | 0 : k, Cs = (T = Zr(Yi, 0, bo, 0)) + (k = (k = m[ve + 2 | 0]) << 16 & 2031616 | m[0 | ve] | m[ve + 1 | 0] << 8) | 0, T = Qe, us = T = k >>> 0 > Cs >>> 0 ? T + 1 | 0 : T, ef = T = T - ((Cs >>> 0 < 4293918720) - 1 | 0) | 0, k = (k = T >>> 21 | 0) + M | 0, Es = k = (T = (2097151 & T) << 11 | (es = Cs - -1048576 | 0) >>> 21) >>> 0 > (ca = T + zn | 0) >>> 0 ? k + 1 | 0 : k, gf = T = k - ((ca >>> 0 < 4293918720) - 1 | 0) | 0, M = (2097151 & T) << 11 | (fn = ca - -1048576 | 0) >>> 21, T = (T >>> 21 | 0) + pr | 0, T = M >>> 0 > (Po = M + Qn | 0) >>> 0 ? T + 1 | 0 : T, M = Zr(ma, Ba, 654183, 0), k = Qe + (T - (((pr = -2097152 & Ys) >>> 0 > Po >>> 0) + yf | 0) | 0) | 0, k = M >>> 0 > (Qn = M + (Po - pr | 0) | 0) >>> 0 ? k + 1 | 0 : k, T = Zr(ra, sf, 666643, 0), k = Qe + k | 0, k = T >>> 0 > (M = T + Qn | 0) >>> 0 ? k + 1 | 0 : k, Ns = (T = M) + (M = Zr(_a, la, 470296, 0)) | 0, T = Qe + k | 0, zn = T = M >>> 0 > Ns >>> 0 ? T + 1 | 0 : T, Bf = T = T - ((Ns >>> 0 < 4293918720) - 1 | 0) | 0, M = (k = T >> 21) + Ds | 0, Ys = T = (M = (T = (2097151 & T) << 11 | (Po = Ns - -1048576 | 0) >>> 21) >>> 0 > (Qn = T + ua | 0) >>> 0 ? M + 1 | 0 : M) - ((Qn >>> 0 < 4293918720) - 1 | 0) | 0, Ds = (2097151 & T) << 11 | (pr = Qn - -1048576 | 0) >>> 21, T = (T >> 21) + xa | 0, sf = ra = Ds + Ff | 0, Ds = Ds >>> 0 > ra >>> 0 ? T + 1 | 0 : T, k = Zr(nf, Hs, -997805, -1), T = Qe + M | 0, T = k >>> 0 > (Qn = k + Qn | 0) >>> 0 ? T + 1 | 0 : T, xa = Qn - (k = -2097152 & pr) | 0, ua = T - ((k >>> 0 > Qn >>> 0) + Ys | 0) | 0, T = Zr(nf, Hs, 654183, 0), k = Qe + zn | 0, k = T >>> 0 > (M = T + Ns | 0) >>> 0 ? k + 1 | 0 : k, ra = M - (T = -2097152 & Po) | 0, Ys = k - ((T >>> 0 > M >>> 0) + Bf | 0) | 0, k = Zr(ma, Ba, 470296, 0), M = Qe + (Es - (((T = -2097152 & fn) >>> 0 > ca >>> 0) + gf | 0) | 0) | 0, M = k >>> 0 > (pr = k + (ca - T | 0) | 0) >>> 0 ? M + 1 | 0 : M, T = Zr(_a, la, 666643, 0), k = Qe + M | 0, Qn = pr = T + pr | 0, M = T >>> 0 > pr >>> 0 ? k + 1 | 0 : k, T = Zr(ma, Ba, 666643, 0), k = Qe + (us - ((4095 & ef) + ((pr = -2097152 & es) >>> 0 > Cs >>> 0) | 0) | 0) | 0, Ns = k = T >>> 0 > (fn = T + (Cs - pr | 0) | 0) >>> 0 ? k + 1 | 0 : k, us = k = k - ((fn >>> 0 < 4293918720) - 1 | 0) | 0, pr = (2097151 & k) << 11 | (zn = fn - -1048576 | 0) >>> 21, k = (k >> 21) + M | 0, M = k = pr >>> 0 > (Po = pr + Qn | 0) >>> 0 ? k + 1 | 0 : k, es = k = k - ((Po >>> 0 < 4293918720) - 1 | 0) | 0, pr = (2097151 & k) << 11 | (Qn = Po - -1048576 | 0) >>> 21, k = (k >> 21) + Ys | 0, pr = pr >>> 0 > (Es = pr + ra | 0) >>> 0 ? k + 1 | 0 : k, k = Zr(nf, Hs, 470296, 0), M = Qe + M | 0, M = k >>> 0 > (T = k + Po | 0) >>> 0 ? M + 1 | 0 : M, Po = T - (k = -2097152 & Qn) | 0, Qn = M - ((k >>> 0 > T >>> 0) + es | 0) | 0, T = Zr(nf, Hs, 666643, 0), k = Qe + (Ns - (((M = -2097152 & zn) >>> 0 > fn >>> 0) + us | 0) | 0) | 0, T = (M = (k = T >>> 0 > (Ys = T + (fn - M | 0) | 0) >>> 0 ? k + 1 | 0 : k) >> 21) + Qn | 0, k = (k = (T = (k = (2097151 & k) << 11 | Ys >>> 21) >>> 0 > (us = k + Po | 0) >>> 0 ? T + 1 | 0 : T) >> 21) + pr | 0, T = (T = (k = (T = (2097151 & T) << 11 | us >>> 21) >>> 0 > (es = T + Es | 0) >>> 0 ? k + 1 | 0 : k) >> 21) + ua | 0, M = (k = (T = (k = (2097151 & k) << 11 | es >>> 21) >>> 0 > (pr = k + xa | 0) >>> 0 ? T + 1 | 0 : T) >> 21) + Ds | 0, k = (T = (M = (T = (2097151 & T) << 11 | pr >>> 21) >>> 0 > (Es = T + sf | 0) >>> 0 ? M + 1 | 0 : M) >> 21) + Df | 0, T = (M = (k = (M = (2097151 & M) << 11 | Es >>> 21) >>> 0 > (fn = M + Ja | 0) >>> 0 ? k + 1 | 0 : k) >> 21) + Rs | 0, k = (k = (T = (k = (2097151 & k) << 11 | fn >>> 21) >>> 0 > (Ds = k + Ea | 0) >>> 0 ? T + 1 | 0 : T) >> 21) + Qa | 0, T = (T = (k = (T = (2097151 & T) << 11 | Ds >>> 21) >>> 0 > (Ns = T + Ka | 0) >>> 0 ? k + 1 | 0 : k) >> 21) + Vs | 0, M = (k = (T = (k = (2097151 & k) << 11 | Ns >>> 21) >>> 0 > (zn = k + Vf | 0) >>> 0 ? T + 1 | 0 : T) >> 21) + ff | 0, k = (T = (M = (T = (2097151 & T) << 11 | zn >>> 21) >>> 0 > (Po = T + fh | 0) >>> 0 ? M + 1 | 0 : M) >> 21) + Ou | 0, Fs = (Rs = ye - (T = -2097152 & Fs) | 0) + ((2097151 & (k = (M = (2097151 & M) << 11 | Po >>> 21) >>> 0 > (Qn = M + iu | 0) >>> 0 ? k + 1 | 0 : k)) << 11 | Qn >>> 21) | 0, k = (Qs - ((T >>> 0 > ye >>> 0) + of | 0) | 0) + (k >> 21) | 0, Qs = T = (k = Rs >>> 0 > Fs >>> 0 ? k + 1 | 0 : k) >> 21, Ys = (k = Zr(Vs = (2097151 & k) << 11 | Fs >>> 21, T, 666643, 0)) + (T = 2097151 & Ys) | 0, k = Qe, ye = k = T >>> 0 > Ys >>> 0 ? k + 1 | 0 : k, B[0 | Ne] = Ys, B[Ne + 1 | 0] = (255 & k) << 24 | Ys >>> 8, k = 2097151 & us, T = Zr(Vs, Qs, 470296, 0) + k | 0, M = Qe, k = (ye >> 21) + (k >>> 0 > T >>> 0 ? M + 1 | 0 : M) | 0, k = (us = (Rs = (2097151 & ye) << 11 | Ys >>> 21) + T | 0) >>> 0 < Rs >>> 0 ? k + 1 | 0 : k, B[Ne + 4 | 0] = (2047 & k) << 21 | us >>> 11, T = k, M = us, B[Ne + 3 | 0] = (7 & k) << 29 | M >>> 3, B[Ne + 2 | 0] = 31 & ((65535 & ye) << 16 | Ys >>> 16) | M << 5, ye = 2097151 & es, es = Zr(Vs, Qs, 654183, 0) + ye | 0, k = Qe, us = (2097151 & T) << 11 | M >>> 21, T = (T >> 21) + (ye = ye >>> 0 > es >>> 0 ? k + 1 | 0 : k) | 0, k = T = (es = us + es | 0) >>> 0 < us >>> 0 ? T + 1 | 0 : T, B[Ne + 6 | 0] = (63 & k) << 26 | es >>> 6, ye = es, es = 0, B[Ne + 5 | 0] = es << 13 | (1572864 & M) >>> 19 | ye << 2, M = 2097151 & pr, pr = Zr(Vs, Qs, -997805, -1) + M | 0, T = Qe, T = M >>> 0 > pr >>> 0 ? T + 1 | 0 : T, es = (2097151 & (M = k)) << 11 | ye >>> 21, M = (k >>= 21) + T | 0, M = (pr = es + pr | 0) >>> 0 < es >>> 0 ? M + 1 | 0 : M, B[Ne + 9 | 0] = (511 & M) << 23 | pr >>> 9, B[Ne + 8 | 0] = (1 & M) << 31 | pr >>> 1, T = 0, B[Ne + 7 | 0] = T << 18 | (2080768 & ye) >>> 14 | pr << 7, T = 2097151 & Es, ye = Zr(Vs, Qs, 136657, 0) + T | 0, k = Qe, k = T >>> 0 > ye >>> 0 ? k + 1 | 0 : k, Es = (2097151 & (T = M)) << 11 | pr >>> 21, T = k + (M = T >> 21) | 0, T = (ye = Es + ye | 0) >>> 0 < Es >>> 0 ? T + 1 | 0 : T, B[Ne + 12 | 0] = (4095 & T) << 20 | ye >>> 12, M = ye, B[Ne + 11 | 0] = (15 & T) << 28 | M >>> 4, ye = 0, B[Ne + 10 | 0] = ye << 15 | (1966080 & pr) >>> 17 | M << 4, ye = 2097151 & fn, pr = Zr(Vs, Qs, -683901, -1) + ye | 0, k = Qe, k = ye >>> 0 > pr >>> 0 ? k + 1 | 0 : k, ye = T, T = k + (T >>= 21) | 0, T = (ye = (fn = pr) + (pr = (2097151 & ye) << 11 | M >>> 21) | 0) >>> 0 < pr >>> 0 ? T + 1 | 0 : T, B[Ne + 14 | 0] = (127 & T) << 25 | ye >>> 7, pr = 0, B[Ne + 13 | 0] = pr << 12 | (1048576 & M) >>> 20 | ye << 1, k = T >> 21, M = (T = (2097151 & T) << 11 | ye >>> 21) >>> 0 > (pr = T + (2097151 & Ds) | 0) >>> 0 ? k + 1 | 0 : k, B[Ne + 17 | 0] = (1023 & M) << 22 | pr >>> 10, B[Ne + 16 | 0] = (3 & M) << 30 | pr >>> 2, T = 0, B[Ne + 15 | 0] = T << 17 | (2064384 & ye) >>> 15 | pr << 6, k = M >> 21, k = (T = (2097151 & M) << 11 | pr >>> 21) >>> 0 > (M = T + (2097151 & Ns) | 0) >>> 0 ? k + 1 | 0 : k, B[Ne + 20 | 0] = (8191 & k) << 19 | M >>> 13, B[Ne + 19 | 0] = (31 & k) << 27 | M >>> 5, ye = (T = 2097151 & zn) + (zn = (2097151 & k) << 11 | M >>> 21) | 0, T = k >> 21, T = ye >>> 0 < zn >>> 0 ? T + 1 | 0 : T, zn = ye, B[Ne + 21 | 0] = ye, Ns = 0, B[Ne + 18 | 0] = Ns << 14 | (1835008 & pr) >>> 18 | M << 3, B[Ne + 22 | 0] = (255 & T) << 24 | ye >>> 8, M = T >> 21, M = (ye = (pr = (2097151 & T) << 11 | ye >>> 21) + (2097151 & Po) | 0) >>> 0 < pr >>> 0 ? M + 1 | 0 : M, B[Ne + 25 | 0] = (2047 & M) << 21 | ye >>> 11, B[Ne + 24 | 0] = (7 & M) << 29 | ye >>> 3, B[Ne + 23 | 0] = 31 & ((65535 & T) << 16 | zn >>> 16) | ye << 5, k = M >> 21, k = (T = (2097151 & M) << 11 | ye >>> 21) >>> 0 > (M = T + (2097151 & Qn) | 0) >>> 0 ? k + 1 | 0 : k, B[Ne + 27 | 0] = (63 & k) << 26 | M >>> 6, pr = 0, B[Ne + 26 | 0] = pr << 13 | (1572864 & ye) >>> 19 | M << 2, T = k, k >>= 21, T = (ye = (Qn = (2097151 & T) << 11 | M >>> 21) + (pr = 2097151 & Fs) | 0) >>> 0 < pr >>> 0 ? k + 1 | 0 : k, B[Ne + 31 | 0] = (131071 & T) << 15 | ye >>> 17, k = ye, B[Ne + 30 | 0] = (511 & T) << 23 | k >>> 9, ye = 0, B[Ne + 28 | 0] = ye << 18 | (2080768 & M) >>> 14 | k << 7, B[Ne + 29 | 0] = Qn + Fs >>> 1, _s(cr, 64), _s(ve, 64), E && (o[E >> 2] = 64, o[E + 4 >> 2] = 0), dr = gr + 560 | 0, 0;
                    }
                    function $r(k, E, T) {
                      var M, ye, Ne, pr, ve, cr, gr, Pr, Nr, Br, Mr, jr, ti, fi, Jr, li, Tr, Mi, Wi, vn, Tn, Ni, Yi, Xi, $n, Zn, to, fo, wo, bo, go, qn, io, So, qo, Ln, ro, Qo, Vo, as, cs, ms, ai = 0, ci = 0, Fi = 0, Eo = 0, is = 0, ws = 0, ys = 0, Is = 0, ks = 0, Ps = 0, Po = 0, fn = 0, Qn = 0, zn = 0, es = 0, us = 0, Cs = 0, Es = 0, Rs = 0, Ds = 0, Ns = 0, Fs = 0, Qs = 0, Ys = 0, Vs = 0, Hs = 0, ra = 0, ca = 0, ua = 0, la = 0, ma = 0, Ba = 0, Ea = 0, _a = 0, xa = 0, Ka = 0, nf = 0, of = 0, sf = 0, ef = 0, gf = 0, yf = 0, Df = 0, Bf = 0, Ja = 0, Vf = 0, Ff = 0, Qa = 0, ic = 0, nc = 0, ff = 0;
                      Eo = Zr(M = (ci = m[T + 2 | 0]) << 16 & 2031616 | m[0 | T] | m[T + 1 | 0] << 8, 0, ye = (fn = m[E + 23 | 0] | m[E + 24 | 0] << 8 | m[E + 25 | 0] << 16 | m[E + 26 | 0] << 24) >>> 5 & 2097151, 0), Fi = Qe, ai = Zr(Ne = (ci = m[E + 23 | 0]) << 16 & 2031616 | m[E + 21 | 0] | m[E + 22 | 0] << 8, 0, pr = (is = m[T + 2 | 0] | m[T + 3 | 0] << 8 | m[T + 4 | 0] << 16 | m[T + 5 | 0] << 24) >>> 5 & 2097151, 0), ci = Qe + Fi | 0, ci = ai >>> 0 > (Eo = ai + Eo | 0) >>> 0 ? ci + 1 | 0 : ci, Fi = Zr(ve = (m[T + 7 | 0] | m[T + 8 | 0] << 8 | m[T + 9 | 0] << 16 | m[T + 10 | 0] << 24) >>> 7 & 2097151, 0, cr = (us = m[E + 15 | 0] | m[E + 16 | 0] << 8 | m[E + 17 | 0] << 16 | m[E + 18 | 0] << 24) >>> 6 & 2097151, 0), ai = Qe + ci | 0, Is = Eo = Fi + Eo | 0, Fi = Fi >>> 0 > Eo >>> 0 ? ai + 1 | 0 : ai, ai = (ci = m[E + 14 | 0]) >>> 24 | 0, ws = ci << 8 | (ks = m[E + 10 | 0] | m[E + 11 | 0] << 8 | m[E + 12 | 0] << 16 | m[E + 13 | 0] << 24) >>> 24, ai = Zr(gr = 2097151 & ((1 & (Ps = (ci = ai) | (ai = (Eo = m[E + 15 | 0]) >>> 16 | 0))) << 31 | (ci = (Eo <<= 16) | ws) >>> 1), 0, Pr = (ys = m[T + 10 | 0] | m[T + 11 | 0] << 8 | m[T + 12 | 0] << 16 | m[T + 13 | 0] << 24) >>> 4 & 2097151, 0), Fi = Qe + Fi | 0, Ps = ci = ai + Is | 0, Eo = ci >>> 0 < ai >>> 0 ? Fi + 1 | 0 : Fi, Fi = (ai = m[T + 6 | 0]) >>> 24 | 0, Is = ai << 8 | is >>> 24, is = Nr = 2097151 & ((3 & (Fi |= ai = (ci = m[T + 7 | 0]) >>> 16 | 0)) << 30 | (ci = Is | ci << 16) >>> 2), Is = 0, ws = (ci = m[E + 19 | 0]) << 8 | us >>> 24, Fi = ai = ci >>> 24 | 0, ci = (ai = m[E + 20 | 0]) >>> 16 | 0, Ni = Fi = (ci |= Fi) >>> 3 | 0, ai = Zr(is, Is, Br = (7 & ci) << 29 | (ai = ai << 16 | ws) >>> 3, Fi), ci = Qe + Eo | 0, ci = ai >>> 0 > (ws = ai + Ps | 0) >>> 0 ? ci + 1 | 0 : ci, Fi = Zr(Mr = (is = m[T + 15 | 0] | m[T + 16 | 0] << 8 | m[T + 17 | 0] << 16 | m[T + 18 | 0] << 24) >>> 6 & 2097151, 0, jr = (m[E + 7 | 0] | m[E + 8 | 0] << 8 | m[E + 9 | 0] << 16 | m[E + 10 | 0] << 24) >>> 7 & 2097151, 0), ai = Qe + ci | 0, Is = Eo = Fi + ws | 0, Eo = Fi >>> 0 > Eo >>> 0 ? ai + 1 | 0 : ai, ws = (ci = m[T + 14 | 0]) << 8 | ys >>> 24, ci = ai = ci >>> 24 | 0, Fi = (ai = m[T + 15 | 0]) >>> 16 | 0, ai = Zr(ti = 2097151 & ((1 & (Fi |= ci)) << 31 | (ci = (ai <<= 16) | ws) >>> 1), 0, fi = ks >>> 4 & 2097151, 0), ci = Qe + Eo | 0, ys = Fi = ai + Is | 0, Is = ai >>> 0 > Fi >>> 0 ? ci + 1 | 0 : ci, ci = (ai = m[T + 19 | 0]) >>> 24 | 0, Eo = ai << 8 | is >>> 24, Fi = (ai = m[T + 20 | 0]) >>> 16 | 0, Jr = (7 & (Fi |= ci)) << 29 | (ai = Eo | ai << 16) >>> 3, Ns = ci = Fi >>> 3 | 0, Eo = ci, ci = (ai = m[E + 6 | 0]) >>> 24 | 0, is = ai << 8 | (Ps = m[E + 2 | 0] | m[E + 3 | 0] << 8 | m[E + 4 | 0] << 16 | m[E + 5 | 0] << 24) >>> 24, Fi = ci, ci = (ai = m[E + 7 | 0]) >>> 16 | 0, ci = Zr(Jr, Eo, li = 2097151 & ((3 & (ci |= Fi)) << 30 | (ai = ai << 16 | is) >>> 2), 0), ai = Qe + Is | 0, Fi = ci >>> 0 > (Eo = ci + ys | 0) >>> 0 ? ai + 1 | 0 : ai, ci = Zr(Tr = (ci = m[T + 23 | 0]) << 16 & 2031616 | m[T + 21 | 0] | m[T + 22 | 0] << 8, 0, Mi = Ps >>> 5 & 2097151, 0), ai = Qe + Fi | 0, Fi = ci >>> 0 > (Eo = ci + Eo | 0) >>> 0 ? ai + 1 | 0 : ai, ai = Zr(Wi = (ci = m[E + 2 | 0]) << 16 & 2031616 | m[0 | E] | m[E + 1 | 0] << 8, 0, Ys = (Ps = m[T + 23 | 0] | m[T + 24 | 0] << 8 | m[T + 25 | 0] << 16 | m[T + 26 | 0] << 24) >>> 5 & 2097151, 0), ci = Qe + Fi | 0, is = Eo = ai + Eo | 0, Is = ai >>> 0 > Eo >>> 0 ? ci + 1 | 0 : ci, ai = Zr(Ne, 0, M, 0), ci = Qe, Eo = (Fi = ai) + (ai = Zr(Br, Ni, pr, 0)) | 0, Fi = Qe + ci | 0, Fi = ai >>> 0 > Eo >>> 0 ? Fi + 1 | 0 : Fi, ai = Zr(ve, 0, gr, 0), ci = Qe + Fi | 0, ci = ai >>> 0 > (Eo = ai + Eo | 0) >>> 0 ? ci + 1 | 0 : ci, Fi = Zr(Pr, 0, fi, 0), ai = Qe + ci | 0, ai = Fi >>> 0 > (Eo = Fi + Eo | 0) >>> 0 ? ai + 1 | 0 : ai, ci = Zr(cr, 0, Nr, 0), ai = Qe + ai | 0, ai = ci >>> 0 > (Fi = ci + Eo | 0) >>> 0 ? ai + 1 | 0 : ai, Eo = (ci = Fi) + (Fi = Zr(Mr, 0, li, 0)) | 0, ci = Qe + ai | 0, ci = Fi >>> 0 > Eo >>> 0 ? ci + 1 | 0 : ci, ai = Zr(ti, 0, jr, 0), Fi = Qe + ci | 0, Fi = ai >>> 0 > (Eo = ai + Eo | 0) >>> 0 ? Fi + 1 | 0 : Fi, Eo = (ai = Zr(Jr, Ns, Mi, 0)) + Eo | 0, ci = Qe + Fi | 0, Fi = Zr(Tr, 0, Wi, 0), ai = Qe + (ai >>> 0 > Eo >>> 0 ? ci + 1 | 0 : ci) | 0, Eo = ai = Fi >>> 0 > (ws = Fi + Eo | 0) >>> 0 ? ai + 1 | 0 : ai, Fs = ai = ai - ((ws >>> 0 < 4293918720) - 1 | 0) | 0, ci = (ci = ai >>> 21 | 0) + Is | 0, zn = Fi = (ci = (ai = (2097151 & ai) << 11 | (Es = ws - -1048576 | 0) >>> 21) >>> 0 > (is = ai + is | 0) >>> 0 ? ci + 1 | 0 : ci) - ((is >>> 0 < 4293918720) - 1 | 0) | 0, Qn = is - (ai = -2097152 & (es = is - -1048576 | 0)) | 0, Po = ci - ((ai >>> 0 > is >>> 0) + Fi | 0) | 0, Is = (ci = m[T + 27 | 0]) << 8 | Ps >>> 24, Fi = ai = ci >>> 24 | 0, is = Zr(vn = 2097151 & ((3 & (Fi |= ci = (ai = m[T + 28 | 0]) >>> 16 | 0)) << 30 | (ci = (ai <<= 16) | Is) >>> 2), 0, Vs = (m[E + 28 | 0] | m[E + 29 | 0] << 8 | m[E + 30 | 0] << 16 | m[E + 31 | 0] << 24) >>> 7 | 0, 0), Is = Qe, ci = (ai = m[E + 27 | 0]) >>> 24 | 0, E = Zr(Tn = 2097151 & ((3 & (ci |= Fi = (E = m[E + 28 | 0]) >>> 16 | 0)) << 30 | (ai = ai << 8 | fn >>> 24 | E << 16) >>> 2), 0, Hs = (m[T + 28 | 0] | m[T + 29 | 0] << 8 | m[T + 30 | 0] << 16 | m[T + 31 | 0] << 24) >>> 7 | 0, 0), ai = Qe + Is | 0, ai = E >>> 0 > (T = E + is | 0) >>> 0 ? ai + 1 | 0 : ai, Fi = T, E = Zr(ye, 0, Hs, 0), T = Qe, Is = (ci = E) + (E = Zr(Ys, 0, Vs, 0)) | 0, ci = Qe + T | 0, ci = E >>> 0 > Is >>> 0 ? ci + 1 | 0 : ci, E = Zr(vn, 0, Tn, 0), ci = Qe + ci | 0, Is = ci = E >>> 0 > (Ps = E + Is | 0) >>> 0 ? ci + 1 | 0 : ci, ys = E = ci - ((Ps >>> 0 < 4293918720) - 1 | 0) | 0, ci = E >>> 21 | 0, is = (E = (2097151 & E) << 11 | (T = Ps - -1048576 | 0) >>> 21) + Fi | 0, Fi = ci + ai | 0, us = ci = (Fi = E >>> 0 > is >>> 0 ? Fi + 1 | 0 : Fi) - ((is >>> 0 < 4293918720) - 1 | 0) | 0, E = is - (ai = -2097152 & (ks = is - -1048576 | 0)) | 0, Xi = ai = Fi - ((131071 & ci) + (ai >>> 0 > is >>> 0) | 0) | 0, $n = E, E = Zr(E, ai, 666643, 0), ai = Qe + Po | 0, ua = ci = E + Qn | 0, is = E >>> 0 > ci >>> 0 ? ai + 1 | 0 : ai, Qn = Ps - (E = -2097152 & T) | 0, Rs = Is - ((131071 & ys) + (E >>> 0 > Ps >>> 0) | 0) | 0, E = Zr(Tr, 0, Vs, 0), T = Qe, ci = (ai = E) + (E = Zr(Ys, 0, Tn, 0)) | 0, ai = Qe + T | 0, ai = E >>> 0 > ci >>> 0 ? ai + 1 | 0 : ai, T = (E = Zr(Ne, 0, Hs, 0)) + ci | 0, ci = Qe + ai | 0, ci = E >>> 0 > T >>> 0 ? ci + 1 | 0 : ci, E = Zr(ye, 0, vn, 0), ai = Qe + ci | 0, ys = T = E + T | 0, E = E >>> 0 > T >>> 0 ? ai + 1 | 0 : ai, T = Zr(ye, 0, Ys, 0), ai = Qe, Fi = (ci = T) + (T = Zr(Jr, Ns, Vs, 0)) | 0, ci = Qe + ai | 0, ci = T >>> 0 > Fi >>> 0 ? ci + 1 | 0 : ci, ai = (T = Zr(Tr, 0, Tn, 0)) + Fi | 0, Fi = Qe + ci | 0, Fi = T >>> 0 > ai >>> 0 ? Fi + 1 | 0 : Fi, ci = (T = Zr(Br, Ni, Hs, 0)) + ai | 0, ai = Qe + Fi | 0, ai = T >>> 0 > ci >>> 0 ? ai + 1 | 0 : ai, Po = (T = Zr(Ne, 0, vn, 0)) + ci | 0, ci = Qe + ai | 0, Ps = ci = T >>> 0 > Po >>> 0 ? ci + 1 | 0 : ci, Cs = T = ci - ((Po >>> 0 < 4293918720) - 1 | 0) | 0, ci = E + (ai = T >>> 21 | 0) | 0, T = ci = (T = (2097151 & T) << 11 | (Is = Po - -1048576 | 0) >>> 21) >>> 0 > (ys = T + ys | 0) >>> 0 ? ci + 1 | 0 : ci, fn = ci = ci - ((ys >>> 0 < 4293918720) - 1 | 0) | 0, ai = Qn, Qn = (2097151 & ci) << 11 | (E = ys - -1048576 | 0) >>> 21, ci = (ci >>> 21 | 0) + Rs | 0, Zn = ci = (Fi = ai + Qn | 0) >>> 0 < Qn >>> 0 ? ci + 1 | 0 : ci, to = E = ys - (ai = -2097152 & E) | 0, fo = ys = T - ((ai >>> 0 > ys >>> 0) + fn | 0) | 0, wo = Fi, T = Zr(Fi, ci, 470296, 0), ai = Qe + is | 0, ai = T >>> 0 > (ci = T + ua | 0) >>> 0 ? ai + 1 | 0 : ai, E = Zr(E, ys, 654183, 0), Fi = Qe + ai | 0, Rs = T = E + ci | 0, is = E >>> 0 > T >>> 0 ? Fi + 1 | 0 : Fi, fn = Po - (E = -2097152 & Is) | 0, Po = Ps - ((E >>> 0 > Po >>> 0) + Cs | 0) | 0, E = Zr(Jr, Ns, Tn, 0), T = Qe, ci = (ai = E) + (E = Zr(Mr, 0, Vs, 0)) | 0, ai = Qe + T | 0, ai = E >>> 0 > ci >>> 0 ? ai + 1 | 0 : ai, T = (E = Zr(Ne, 0, Ys, 0)) + ci | 0, ci = Qe + ai | 0, ci = E >>> 0 > T >>> 0 ? ci + 1 | 0 : ci, E = Zr(ye, 0, Tr, 0), Fi = Qe + ci | 0, Fi = E >>> 0 > (T = E + T | 0) >>> 0 ? Fi + 1 | 0 : Fi, E = Zr(cr, 0, Hs, 0), ai = Qe + Fi | 0, ai = E >>> 0 > (T = E + T | 0) >>> 0 ? ai + 1 | 0 : ai, E = Zr(Br, Ni, vn, 0), ci = Qe + ai | 0, Ps = T = E + T | 0, Is = E >>> 0 > T >>> 0 ? ci + 1 | 0 : ci, E = Zr(ti, 0, Vs, 0), T = Qe, ci = (ai = E) + (E = Zr(Mr, 0, Tn, 0)) | 0, ai = Qe + T | 0, ai = E >>> 0 > ci >>> 0 ? ai + 1 | 0 : ai, T = (E = Zr(ye, 0, Jr, Ns)) + ci | 0, ci = Qe + ai | 0, ci = E >>> 0 > T >>> 0 ? ci + 1 | 0 : ci, E = Zr(Br, Ni, Ys, 0), Fi = Qe + ci | 0, Fi = E >>> 0 > (T = E + T | 0) >>> 0 ? Fi + 1 | 0 : Fi, E = Zr(Ne, 0, Tr, 0), ai = Qe + Fi | 0, ai = E >>> 0 > (T = E + T | 0) >>> 0 ? ai + 1 | 0 : ai, E = Zr(gr, 0, Hs, 0), ci = Qe + ai | 0, ci = E >>> 0 > (T = E + T | 0) >>> 0 ? ci + 1 | 0 : ci, E = Zr(cr, 0, vn, 0), ai = Qe + ci | 0, E = ai = E >>> 0 > (T = E + T | 0) >>> 0 ? ai + 1 | 0 : ai, Qs = ai = ai - ((T >>> 0 < 4293918720) - 1 | 0) | 0, Fi = (ci = ai >>> 21 | 0) + Is | 0, Qn = Fi = (ai = (2097151 & ai) << 11 | (Cs = T - -1048576 | 0) >>> 21) >>> 0 > (ra = ai + Ps | 0) >>> 0 ? Fi + 1 | 0 : Fi, Ea = ai = Fi - ((ra >>> 0 < 4293918720) - 1 | 0) | 0, Is = (2097151 & ai) << 11 | (ys = ra - -1048576 | 0) >>> 21, ai = (ai >>> 21 | 0) + Po | 0, bo = ai = (Fi = Is + fn | 0) >>> 0 < Is >>> 0 ? ai + 1 | 0 : ai, go = Fi, ai = Zr(Fi, ai, -997805, -1), ci = Qe + is | 0, Po = Fi = ai + Rs | 0, is = ai >>> 0 > Fi >>> 0 ? ci + 1 | 0 : ci, Is = ws, ws = Eo, ai = Zr(M, 0, Br, Ni), ci = Qe, Eo = (Fi = ai) + (ai = Zr(cr, 0, pr, 0)) | 0, Fi = Qe + ci | 0, Fi = ai >>> 0 > Eo >>> 0 ? Fi + 1 | 0 : Fi, ci = Zr(ve, 0, fi, 0), ai = Qe + Fi | 0, ai = ci >>> 0 > (Eo = ci + Eo | 0) >>> 0 ? ai + 1 | 0 : ai, Fi = Zr(Pr, 0, jr, 0), ci = Qe + ai | 0, ci = Fi >>> 0 > (Eo = Fi + Eo | 0) >>> 0 ? ci + 1 | 0 : ci, Fi = Zr(gr, 0, Nr, 0), ai = Qe + ci | 0, ai = Fi >>> 0 > (Eo = Fi + Eo | 0) >>> 0 ? ai + 1 | 0 : ai, Fi = Zr(Mr, 0, Mi, 0), ci = Qe + ai | 0, ci = Fi >>> 0 > (Eo = Fi + Eo | 0) >>> 0 ? ci + 1 | 0 : ci, ai = Zr(ti, 0, li, 0), Fi = Qe + ci | 0, Fi = ai >>> 0 > (Eo = ai + Eo | 0) >>> 0 ? Fi + 1 | 0 : Fi, ci = Zr(Jr, Ns, Wi, 0), ai = Qe + Fi | 0, Ps = Eo = ci + Eo | 0, Eo = ci >>> 0 > Eo >>> 0 ? ai + 1 | 0 : ai, ai = Zr(M, 0, cr, 0), ci = Qe, Fi = ai, ai = Zr(pr, 0, gr, 0), ci = Qe + ci | 0, ci = ai >>> 0 > (Fi = Fi + ai | 0) >>> 0 ? ci + 1 | 0 : ci, fn = (ai = Fi) + (Fi = Zr(ve, 0, jr, 0)) | 0, ai = Qe + ci | 0, ai = Fi >>> 0 > fn >>> 0 ? ai + 1 | 0 : ai, Fi = Zr(Pr, 0, li, 0), ci = Qe + ai | 0, ci = Fi >>> 0 > (fn = Fi + fn | 0) >>> 0 ? ci + 1 | 0 : ci, ai = Zr(Nr, 0, fi, 0), Fi = Qe + ci | 0, Fi = ai >>> 0 > (fn = ai + fn | 0) >>> 0 ? Fi + 1 | 0 : Fi, fn = (ci = Zr(Mr, 0, Wi, 0)) + fn | 0, ai = Qe + Fi | 0, Fi = Zr(ti, 0, Mi, 0), ci = Qe + (ci >>> 0 > fn >>> 0 ? ai + 1 | 0 : ai) | 0, Ka = ci = Fi >>> 0 > (xa = Fi + fn | 0) >>> 0 ? ci + 1 | 0 : ci, Vf = ci = ci - ((xa >>> 0 < 4293918720) - 1 | 0) | 0, Fi = (2097151 & ci) << 11 | (_a = xa - -1048576 | 0) >>> 21, ci = (ci >>> 21 | 0) + Eo | 0, Ds = ci = Fi >>> 0 > (nf = Fi + Ps | 0) >>> 0 ? ci + 1 | 0 : ci, Ff = ci = ci - ((nf >>> 0 < 4293918720) - 1 | 0) | 0, Fi = (2097151 & ci) << 11 | (ua = nf - -1048576 | 0) >>> 21, ci = (ci >>> 21 | 0) + ws | 0, ci = Fi >>> 0 > (Is = Fi + Is | 0) >>> 0 ? ci + 1 | 0 : ci, ai = Zr(wo, Zn, 666643, 0), ci = Qe + (ci - (((Fi = -2097152 & Es) >>> 0 > Is >>> 0) + Fs | 0) | 0) | 0, ci = ai >>> 0 > (Eo = ai + (Is - Fi | 0) | 0) >>> 0 ? ci + 1 | 0 : ci, Fi = Zr(to, fo, 470296, 0), ai = Qe + ci | 0, ai = Fi >>> 0 > (Eo = Fi + Eo | 0) >>> 0 ? ai + 1 | 0 : ai, Fi = Zr(go, bo, 654183, 0), ci = Qe + ai | 0, Rs = ci = Fi >>> 0 > (la = Fi + Eo | 0) >>> 0 ? ci + 1 | 0 : ci, Df = ci = ci - ((la >>> 0 < 4293918720) - 1 | 0) | 0, ai = (ai = ci >> 21) + is | 0, Po = ai = (ci = (2097151 & ci) << 11 | (fn = la - -1048576 | 0) >>> 21) >>> 0 > (Fs = ci + Po | 0) >>> 0 ? ai + 1 | 0 : ai, of = ci = ai - ((Fs >>> 0 < 4293918720) - 1 | 0) | 0, gf = (2097151 & ci) << 11 | (Es = Fs - -1048576 | 0) >>> 21, Ps = ci >> 21, ai = Zr(M, 0, Tn, 0), ci = Qe, Fi = ai, ai = Zr(ye, 0, pr, 0), ci = Qe + ci | 0, ci = ai >>> 0 > (Fi = Fi + ai | 0) >>> 0 ? ci + 1 | 0 : ci, Eo = (ai = Zr(ve, 0, Br, Ni)) + Fi | 0, Fi = Qe + ci | 0, Fi = ai >>> 0 > Eo >>> 0 ? Fi + 1 | 0 : Fi, ci = Zr(cr, 0, Pr, 0), ai = Qe + Fi | 0, ai = ci >>> 0 > (Eo = ci + Eo | 0) >>> 0 ? ai + 1 | 0 : ai, Fi = Zr(Ne, 0, Nr, 0), ci = Qe + ai | 0, ci = Fi >>> 0 > (Eo = Fi + Eo | 0) >>> 0 ? ci + 1 | 0 : ci, Fi = Zr(Mr, 0, fi, 0), ai = Qe + ci | 0, ai = Fi >>> 0 > (Eo = Fi + Eo | 0) >>> 0 ? ai + 1 | 0 : ai, Fi = Zr(ti, 0, gr, 0), ci = Qe + ai | 0, ci = Fi >>> 0 > (Eo = Fi + Eo | 0) >>> 0 ? ci + 1 | 0 : ci, ai = Zr(jr, 0, Jr, Ns), Fi = Qe + ci | 0, Fi = ai >>> 0 > (Eo = ai + Eo | 0) >>> 0 ? Fi + 1 | 0 : Fi, ci = Zr(Mi, 0, Ys, 0), ai = Qe + Fi | 0, ai = ci >>> 0 > (Eo = ci + Eo | 0) >>> 0 ? ai + 1 | 0 : ai, Fi = Zr(li, 0, Tr, 0), ci = Qe + ai | 0, ci = Fi >>> 0 > (Eo = Fi + Eo | 0) >>> 0 ? ci + 1 | 0 : ci, Fi = (ai = Eo) + (Eo = Zr(vn, 0, Wi, 0)) | 0, ai = Qe + ci | 0, is = Fi, Is = Fi >>> 0 < Eo >>> 0 ? ai + 1 | 0 : ai, ma = Zr(Vs, 0, Hs, 0), ws = Fi = (Ba = Qe) - ((ma >>> 0 < 4293918720) - 1 | 0) | 0, ci = ma - (ai = -2097152 & (Eo = ma - -1048576 | 0)) | 0, ai = (us >>> 21 | 0) + (ai = Ba - ((524287 & Fi) + (ai >>> 0 > ma >>> 0) | 0) | 0) | 0, qn = ai = (Fi = (ks = (2097151 & us) << 11 | ks >>> 21) + ci | 0) >>> 0 < ks >>> 0 ? ai + 1 | 0 : ai, io = Fi, ci = (2097151 & zn) << 11 | es >>> 21, ks = Zr(Fi, ai, 666643, 0) + ci | 0, ai = Qe + (zn >>> 21 | 0) | 0, ai = ci >>> 0 > ks >>> 0 ? ai + 1 | 0 : ai, Fi = Zr($n, Xi, 470296, 0), ci = Qe + ai | 0, ci = (Fi >>> 0 > (ks = Fi + ks | 0) >>> 0 ? ci + 1 | 0 : ci) + Is | 0, ci = (ai = is + ks | 0) >>> 0 < ks >>> 0 ? ci + 1 | 0 : ci, ks = (Fi = Zr(wo, Zn, 654183, 0)) + ai | 0, ai = Qe + ci | 0, yf = is - -1048576 | 0, ma = Is = Is - ((is >>> 0 < 4293918720) - 1 | 0) | 0, ci = Zr(to, fo, -997805, -1), Fi = Qe + (Fi >>> 0 > ks >>> 0 ? ai + 1 | 0 : ai) | 0, Fi = ci >>> 0 > (is = ci + ks | 0) >>> 0 ? Fi + 1 | 0 : Fi, es = (ai = Zr(go, bo, 136657, 0)) + (is - (ci = -2097152 & yf) | 0) | 0, ci = Qe + (Fi - ((ci >>> 0 > is >>> 0) + Is | 0) | 0) | 0, Fi = (us = ai >>> 0 > es >>> 0 ? ci + 1 | 0 : ci) + Ps | 0, sf = ai = es + gf | 0, ks = Fi = ai >>> 0 < es >>> 0 ? Fi + 1 | 0 : Fi, Ba = ra - (ai = -2097152 & ys) | 0, ra = Qn - ((ai >>> 0 > ra >>> 0) + Ea | 0) | 0, So = Fi = ws >>> 21 | 0, ci = (ai = T) + (T = Zr(Yi = (2097151 & ws) << 11 | Eo >>> 21, Fi, -683901, -1)) | 0, ai = Qe + E | 0, Qn = ci - (E = -2097152 & Cs) | 0, zn = (T >>> 0 > ci >>> 0 ? ai + 1 | 0 : ai) - ((E >>> 0 > ci >>> 0) + Qs | 0) | 0, E = Zr(ye, 0, Mr, 0), T = Qe, ai = E, E = Zr(Pr, 0, Vs, 0), ci = Qe + T | 0, ci = E >>> 0 > (ai = ai + E | 0) >>> 0 ? ci + 1 | 0 : ci, E = Zr(ti, 0, Tn, 0), Fi = Qe + ci | 0, Fi = E >>> 0 > (T = E + ai | 0) >>> 0 ? Fi + 1 | 0 : Fi, E = Zr(Ne, 0, Jr, Ns), ai = Qe + Fi | 0, ai = E >>> 0 > (T = E + T | 0) >>> 0 ? ai + 1 | 0 : ai, E = Zr(cr, 0, Ys, 0), ai = Qe + ai | 0, ai = E >>> 0 > (T = E + T | 0) >>> 0 ? ai + 1 | 0 : ai, E = Zr(Br, Ni, Tr, 0), ci = Qe + ai | 0, ci = E >>> 0 > (T = E + T | 0) >>> 0 ? ci + 1 | 0 : ci, E = Zr(fi, 0, Hs, 0), ci = Qe + ci | 0, ci = E >>> 0 > (T = E + T | 0) >>> 0 ? ci + 1 | 0 : ci, E = Zr(gr, 0, vn, 0), Fi = Qe + ci | 0, Eo = T = E + T | 0, E = E >>> 0 > T >>> 0 ? Fi + 1 | 0 : Fi, T = Zr(Pr, 0, Tn, 0), ai = Qe, ci = T, T = Zr(ve, 0, Vs, 0), ai = Qe + ai | 0, ai = T >>> 0 > (ci = ci + T | 0) >>> 0 ? ai + 1 | 0 : ai, T = Zr(Ne, 0, Mr, 0), ai = Qe + ai | 0, ai = T >>> 0 > (ci = T + ci | 0) >>> 0 ? ai + 1 | 0 : ai, Fi = (T = Zr(ye, 0, ti, 0)) + ci | 0, ci = Qe + ai | 0, ci = T >>> 0 > Fi >>> 0 ? ci + 1 | 0 : ci, T = Zr(Br, Ni, Jr, Ns), ci = Qe + ci | 0, ci = T >>> 0 > (ai = T + Fi | 0) >>> 0 ? ci + 1 | 0 : ci, T = Zr(gr, 0, Ys, 0), Fi = Qe + ci | 0, Fi = T >>> 0 > (ai = T + ai | 0) >>> 0 ? Fi + 1 | 0 : Fi, ci = (T = Zr(cr, 0, Tr, 0)) + ai | 0, ai = Qe + Fi | 0, ai = T >>> 0 > ci >>> 0 ? ai + 1 | 0 : ai, T = Zr(jr, 0, Hs, 0), ai = Qe + ai | 0, ai = T >>> 0 > (ci = T + ci | 0) >>> 0 ? ai + 1 | 0 : ai, ys = (T = Zr(fi, 0, vn, 0)) + ci | 0, ci = Qe + ai | 0, Ps = ci = T >>> 0 > ys >>> 0 ? ci + 1 | 0 : ci, ef = T = ci - ((ys >>> 0 < 4293918720) - 1 | 0) | 0, Fi = E + (ai = T >>> 21 | 0) | 0, Is = Fi = (T = (2097151 & T) << 11 | (is = ys - -1048576 | 0) >>> 21) >>> 0 > (Cs = T + Eo | 0) >>> 0 ? Fi + 1 | 0 : Fi, Qs = E = Fi - ((Cs >>> 0 < 4293918720) - 1 | 0) | 0, ci = (ai = E >>> 21 | 0) + zn | 0, Eo = ci = (E = (2097151 & E) << 11 | (ws = Cs - -1048576 | 0) >>> 21) >>> 0 > (Qn = E + Qn | 0) >>> 0 ? ci + 1 | 0 : ci, zn = T = ci - ((Qn >>> 0 < 4293918720) - 1 | 0) | 0, Fi = (ai = T >> 21) + ra | 0, qo = Fi = (T = (ci = (2097151 & T) << 11 | (E = Qn - -1048576 | 0) >>> 21) + Ba | 0) >>> 0 < ci >>> 0 ? Fi + 1 | 0 : Fi, Ea = es - -1048576 | 0, gf = ci = us - ((es >>> 0 < 4293918720) - 1 | 0) | 0, Bf = T, T = Zr(T, Fi, -683901, -1), ai = Qe + ks | 0, Ba = ai = (ci = (ai = T >>> 0 > (Fi = T + sf | 0) >>> 0 ? ai + 1 | 0 : ai) - (((T = -2097152 & Ea) >>> 0 > Fi >>> 0) + ci | 0) | 0) - (((ks = Fi - T | 0) >>> 0 < 4293918720) - 1 | 0) | 0, Qo = ks - (T = -2097152 & (ra = ks - -1048576 | 0)) | 0, Qa = ci - ((T >>> 0 > ks >>> 0) + ai | 0) | 0, T = Zr(Bf, qo, 136657, 0), ci = Qe + (Po - (((ai = -2097152 & Es) >>> 0 > Fs >>> 0) + of | 0) | 0) | 0, Ja = Fi = T + (Fs - ai | 0) | 0, T = T >>> 0 > Fi >>> 0 ? ci + 1 | 0 : ci, ca = Qn - (E &= -2097152) | 0, Es = Eo - ((E >>> 0 > Qn >>> 0) + zn | 0) | 0, E = Zr(io, qn, -683901, -1), ai = Qe, ci = E, E = Zr(Yi, So, 136657, 0), ai = Qe + ai | 0, ci = Is + (E >>> 0 > (Fi = ci + E | 0) >>> 0 ? ai + 1 | 0 : ai) | 0, us = (ai = Fi + Cs | 0) - (E = -2097152 & ws) | 0, ks = (ci = ai >>> 0 < Cs >>> 0 ? ci + 1 | 0 : ci) - ((E >>> 0 > ai >>> 0) + Qs | 0) | 0, E = Zr(Yi, So, -997805, -1), ai = Qe + Ps | 0, ai = E >>> 0 > (ci = E + ys | 0) >>> 0 ? ai + 1 | 0 : ai, E = Zr(io, qn, 136657, 0), ai = Qe + ai | 0, ai = E >>> 0 > (ci = E + ci | 0) >>> 0 ? ai + 1 | 0 : ai, Fi = (E = Zr($n, Xi, -683901, -1)) + ci | 0, ci = Qe + ai | 0, ci = E >>> 0 > Fi >>> 0 ? ci + 1 | 0 : ci, Is = Fi - (E = -2097152 & is) | 0, ws = ci - ((E >>> 0 > Fi >>> 0) + ef | 0) | 0, E = Zr(ye, 0, Pr, 0), ai = Qe, Fi = (ci = E) + (E = Zr(ve, 0, Tn, 0)) | 0, ci = Qe + ai | 0, ci = E >>> 0 > Fi >>> 0 ? ci + 1 | 0 : ci, E = Zr(Nr, 0, Vs, 0), ai = Qe + ci | 0, ai = E >>> 0 > (Fi = E + Fi | 0) >>> 0 ? ai + 1 | 0 : ai, E = Zr(Mr, 0, Br, Ni), ci = Qe + ai | 0, ci = E >>> 0 > (Fi = E + Fi | 0) >>> 0 ? ci + 1 | 0 : ci, E = Zr(Ne, 0, ti, 0), ai = Qe + ci | 0, ai = E >>> 0 > (Fi = E + Fi | 0) >>> 0 ? ai + 1 | 0 : ai, ci = (E = Zr(cr, 0, Jr, Ns)) + Fi | 0, Fi = Qe + ai | 0, Fi = E >>> 0 > ci >>> 0 ? Fi + 1 | 0 : Fi, ai = (E = Zr(fi, 0, Ys, 0)) + ci | 0, ci = Qe + Fi | 0, ci = E >>> 0 > ai >>> 0 ? ci + 1 | 0 : ci, Fi = (E = Zr(gr, 0, Tr, 0)) + ai | 0, ai = Qe + ci | 0, ai = E >>> 0 > Fi >>> 0 ? ai + 1 | 0 : ai, E = Zr(li, 0, Hs, 0), ci = Qe + ai | 0, ci = E >>> 0 > (Fi = E + Fi | 0) >>> 0 ? ci + 1 | 0 : ci, E = Zr(jr, 0, vn, 0), ai = Qe + ci | 0, Eo = Fi = E + Fi | 0, E = E >>> 0 > Fi >>> 0 ? ai + 1 | 0 : ai, ai = Zr(ye, 0, ve, 0), ci = Qe, is = (Fi = ai) + (ai = Zr(pr, 0, Vs, 0)) | 0, Fi = Qe + ci | 0, Fi = ai >>> 0 > is >>> 0 ? Fi + 1 | 0 : Fi, ai = Zr(Ne, 0, Pr, 0), ci = Qe + Fi | 0, ci = ai >>> 0 > (is = ai + is | 0) >>> 0 ? ci + 1 | 0 : ci, Fi = Zr(Nr, 0, Tn, 0), ai = Qe + ci | 0, ai = Fi >>> 0 > (is = Fi + is | 0) >>> 0 ? ai + 1 | 0 : ai, Fi = Zr(cr, 0, Mr, 0), ci = Qe + ai | 0, ci = Fi >>> 0 > (is = Fi + is | 0) >>> 0 ? ci + 1 | 0 : ci, Fi = Zr(Br, Ni, ti, 0), ai = Qe + ci | 0, ai = Fi >>> 0 > (is = Fi + is | 0) >>> 0 ? ai + 1 | 0 : ai, ci = Zr(gr, 0, Jr, Ns), Fi = Qe + ai | 0, Fi = ci >>> 0 > (is = ci + is | 0) >>> 0 ? Fi + 1 | 0 : Fi, ai = Zr(jr, 0, Ys, 0), ci = Qe + Fi | 0, ci = ai >>> 0 > (is = ai + is | 0) >>> 0 ? ci + 1 | 0 : ci, Fi = Zr(fi, 0, Tr, 0), ai = Qe + ci | 0, ai = Fi >>> 0 > (is = Fi + is | 0) >>> 0 ? ai + 1 | 0 : ai, Fi = Zr(Mi, 0, Hs, 0), ci = Qe + ai | 0, ci = Fi >>> 0 > (is = Fi + is | 0) >>> 0 ? ci + 1 | 0 : ci, Fi = Zr(li, 0, vn, 0), ai = Qe + ci | 0, Fs = ai = Fi >>> 0 > (of = Fi + is | 0) >>> 0 ? ai + 1 | 0 : ai, Vo = ai = ai - ((of >>> 0 < 4293918720) - 1 | 0) | 0, ci = E + (ci = ai >>> 21 | 0) | 0, es = ci = (ai = (2097151 & ai) << 11 | (zn = of - -1048576 | 0) >>> 21) >>> 0 > (sf = ai + Eo | 0) >>> 0 ? ci + 1 | 0 : ci, as = E = ci - ((sf >>> 0 < 4293918720) - 1 | 0) | 0, ai = (ci = E >>> 21 | 0) + ws | 0, Qn = ai = (E = (2097151 & E) << 11 | (Cs = sf - -1048576 | 0) >>> 21) >>> 0 > (ef = E + Is | 0) >>> 0 ? ai + 1 | 0 : ai, cs = E = ai - ((ef >>> 0 < 4293918720) - 1 | 0) | 0, ci = (ci = E >> 21) + ks | 0, Ps = ci = (E = (2097151 & E) << 11 | (Po = ef - -1048576 | 0) >>> 21) >>> 0 > (Qs = E + us | 0) >>> 0 ? ci + 1 | 0 : ci, ic = E = ci - ((Qs >>> 0 < 4293918720) - 1 | 0) | 0, ai = (ci = E >> 21) + Es | 0, Ln = ai = (E = (Fi = (2097151 & E) << 11 | (Eo = Qs - -1048576 | 0) >>> 21) + ca | 0) >>> 0 < Fi >>> 0 ? ai + 1 | 0 : ai, ca = E, E = Zr(E, ai, -683901, -1), Fi = Qe + T | 0, nc = ai = E + Ja | 0, is = E >>> 0 > ai >>> 0 ? Fi + 1 | 0 : Fi, ff = la - (E = -2097152 & fn) | 0, Df = Rs - ((E >>> 0 > la >>> 0) + Df | 0) | 0, E = Zr(to, fo, 666643, 0), ai = Qe + (Ds - (((T = -2097152 & ua) >>> 0 > nf >>> 0) + Ff | 0) | 0) | 0, ai = E >>> 0 > (ci = E + (nf - T | 0) | 0) >>> 0 ? ai + 1 | 0 : ai, T = (E = Zr(go, bo, 470296, 0)) + ci | 0, ci = Qe + ai | 0, ua = T, T = E >>> 0 > T >>> 0 ? ci + 1 | 0 : ci, ys = xa - (E = -2097152 & _a) | 0, Is = Ka - ((E >>> 0 > xa >>> 0) + Vf | 0) | 0, E = Zr(M, 0, gr, 0), ai = Qe, ci = E, E = Zr(pr, 0, fi, 0), Fi = Qe + ai | 0, Fi = E >>> 0 > (ci = ci + E | 0) >>> 0 ? Fi + 1 | 0 : Fi, E = Zr(ve, 0, li, 0), ai = Qe + Fi | 0, ai = E >>> 0 > (ci = E + ci | 0) >>> 0 ? ai + 1 | 0 : ai, Fi = (E = Zr(Pr, 0, Mi, 0)) + ci | 0, ci = Qe + ai | 0, ci = E >>> 0 > Fi >>> 0 ? ci + 1 | 0 : ci, E = Zr(Nr, 0, jr, 0), ai = Qe + ci | 0, ai = E >>> 0 > (Fi = E + Fi | 0) >>> 0 ? ai + 1 | 0 : ai, E = Zr(ti, 0, Wi, 0), ci = Qe + ai | 0, ws = Fi = E + Fi | 0, E = E >>> 0 > Fi >>> 0 ? ci + 1 | 0 : ci, ai = Zr(M, 0, fi, 0), ci = Qe, ks = (Fi = ai) + (ai = Zr(pr, 0, jr, 0)) | 0, Fi = Qe + ci | 0, Fi = ai >>> 0 > ks >>> 0 ? Fi + 1 | 0 : Fi, ci = Zr(ve, 0, Mi, 0), ai = Qe + Fi | 0, ai = ci >>> 0 > (ks = ci + ks | 0) >>> 0 ? ai + 1 | 0 : ai, Fi = Zr(Pr, 0, Wi, 0), ci = Qe + ai | 0, ci = Fi >>> 0 > (ks = Fi + ks | 0) >>> 0 ? ci + 1 | 0 : ci, Fi = Zr(Nr, 0, li, 0), ai = Qe + ci | 0, Rs = ai = Fi >>> 0 > (la = Fi + ks | 0) >>> 0 ? ai + 1 | 0 : ai, ms = ai = ai - ((la >>> 0 < 4293918720) - 1 | 0) | 0, Fi = E + (ci = ai >>> 21 | 0) | 0, Es = Fi = (ai = (2097151 & ai) << 11 | (fn = la - -1048576 | 0) >>> 21) >>> 0 > (Ka = ai + ws | 0) >>> 0 ? Fi + 1 | 0 : Fi, Vf = E = Fi - ((Ka >>> 0 < 4293918720) - 1 | 0) | 0, ai = (ci = E >>> 21 | 0) + Is | 0, ai = (E = (2097151 & E) << 11 | (us = Ka - -1048576 | 0) >>> 21) >>> 0 > (Fi = E + ys | 0) >>> 0 ? ai + 1 | 0 : ai, E = Zr(go, bo, 666643, 0), ci = Qe + ai | 0, ks = ci = E >>> 0 > (_a = E + Fi | 0) >>> 0 ? ci + 1 | 0 : ci, Ff = E = ci - ((_a >>> 0 < 4293918720) - 1 | 0) | 0, ai = T + (ai = E >> 21) | 0, Is = ai = (E = (2097151 & E) << 11 | (ys = _a - -1048576 | 0) >>> 21) >>> 0 > (Ds = E + ua | 0) >>> 0 ? ai + 1 | 0 : ai, Ja = E = ai - ((Ds >>> 0 < 4293918720) - 1 | 0) | 0, ci = (ai = E >> 21) + Df | 0, ci = (E = (2097151 & E) << 11 | (ws = Ds - -1048576 | 0) >>> 21) >>> 0 > (T = E + ff | 0) >>> 0 ? ci + 1 | 0 : ci, E = Zr(Bf, qo, -997805, -1), Fi = Qe + ci | 0, Fi = E >>> 0 > (ai = E + T | 0) >>> 0 ? Fi + 1 | 0 : Fi, nf = E = Qs - (T = -2097152 & Eo) | 0, ro = ci = Ps - ((T >>> 0 > Qs >>> 0) + ic | 0) | 0, Eo = (T = Zr(ca, Ln, 136657, 0)) + ai | 0, ai = Qe + Fi | 0, E = Zr(E, ci, -683901, -1), ai = Qe + (T >>> 0 > Eo >>> 0 ? ai + 1 | 0 : ai) | 0, Eo = ai = E >>> 0 > (Ps = E + Eo | 0) >>> 0 ? ai + 1 | 0 : ai, xa = E = ai - ((Ps >>> 0 < 4293918720) - 1 | 0) | 0, ai = (ci = E >> 21) + is | 0, T = ai = (is = ua = (E = (2097151 & E) << 11 | (Fi = Ps - -1048576 | 0) >>> 21) + nc | 0) >>> 0 < E >>> 0 ? ai + 1 | 0 : ai, Qs = ai = ai - ((is >>> 0 < 4293918720) - 1 | 0) | 0, ua = (2097151 & ai) << 11 | (E = is - -1048576 | 0) >>> 21, ai = (ai >> 21) + Qa | 0, Qa = Df = ua + Qo | 0, ua = ua >>> 0 > Df >>> 0 ? ai + 1 | 0 : ai, ic = is - (E &= -2097152) | 0, nc = T - ((E >>> 0 > is >>> 0) + Qs | 0) | 0, ff = Ps - (E = -2097152 & Fi) | 0, Df = Eo - ((E >>> 0 > Ps >>> 0) + xa | 0) | 0, E = Zr(Bf, qo, 654183, 0), ci = Qe + (Is - (((T = -2097152 & ws) >>> 0 > Ds >>> 0) + Ja | 0) | 0) | 0, ci = E >>> 0 > (ai = E + (Ds - T | 0) | 0) >>> 0 ? ci + 1 | 0 : ci, T = (E = Zr(ca, Ln, -997805, -1)) + ai | 0, ai = Qe + ci | 0, ai = E >>> 0 > T >>> 0 ? ai + 1 | 0 : ai, E = Zr(nf, ro, 136657, 0), ai = Qe + ai | 0, Ja = T = E + T | 0, E = E >>> 0 > T >>> 0 ? ai + 1 | 0 : ai, xa = ef - (T = -2097152 & Po) | 0, Ds = Qn - ((T >>> 0 > ef >>> 0) + cs | 0) | 0, T = Zr(io, qn, -997805, -1), ai = Qe, Fi = (ci = T) + (T = Zr(Yi, So, 654183, 0)) | 0, ci = Qe + ai | 0, ci = T >>> 0 > Fi >>> 0 ? ci + 1 | 0 : ci, T = Zr($n, Xi, 136657, 0), ai = Qe + ci | 0, ai = T >>> 0 > (Fi = T + Fi | 0) >>> 0 ? ai + 1 | 0 : ai, T = Zr(wo, Zn, -683901, -1), ai = Qe + ai | 0, ci = es + (T >>> 0 > (Fi = T + Fi | 0) >>> 0 ? ai + 1 | 0 : ai) | 0, Po = (ai = Fi + sf | 0) - (T = -2097152 & Cs) | 0, Cs = (ci = ai >>> 0 < sf >>> 0 ? ci + 1 | 0 : ci) - ((T >>> 0 > ai >>> 0) + as | 0) | 0, T = Zr(io, qn, 654183, 0), ai = Qe, Fi = (ci = T) + (T = Zr(Yi, So, 470296, 0)) | 0, ci = Qe + ai | 0, ci = T >>> 0 > Fi >>> 0 ? ci + 1 | 0 : ci, T = Zr($n, Xi, -997805, -1), ai = Qe + ci | 0, ci = Fs + (T >>> 0 > (Fi = T + Fi | 0) >>> 0 ? ai + 1 | 0 : ai) | 0, ci = (T = Fi + of | 0) >>> 0 < of >>> 0 ? ci + 1 | 0 : ci, Fi = (ai = T) + (T = Zr(wo, Zn, 136657, 0)) | 0, ai = Qe + ci | 0, ai = T >>> 0 > Fi >>> 0 ? ai + 1 | 0 : ai, ci = (T = Zr(to, fo, -683901, -1)) + Fi | 0, Fi = Qe + ai | 0, Fi = T >>> 0 > ci >>> 0 ? Fi + 1 | 0 : Fi, ws = ci - (T = -2097152 & zn) | 0, Eo = Fi - ((T >>> 0 > ci >>> 0) + Vo | 0) | 0, T = Zr(M, 0, Vs, 0), ai = Qe, ci = T, T = Zr(pr, 0, Tn, 0), ai = Qe + ai | 0, ai = T >>> 0 > (ci = ci + T | 0) >>> 0 ? ai + 1 | 0 : ai, T = Zr(Ne, 0, ve, 0), ai = Qe + ai | 0, ai = T >>> 0 > (ci = T + ci | 0) >>> 0 ? ai + 1 | 0 : ai, T = Zr(Br, Ni, Pr, 0), Fi = Qe + ai | 0, Fi = T >>> 0 > (ci = T + ci | 0) >>> 0 ? Fi + 1 | 0 : Fi, ai = (T = Zr(ye, 0, Nr, 0)) + ci | 0, ci = Qe + Fi | 0, ci = T >>> 0 > ai >>> 0 ? ci + 1 | 0 : ci, T = Zr(Mr, 0, gr, 0), ci = Qe + ci | 0, ci = T >>> 0 > (ai = T + ai | 0) >>> 0 ? ci + 1 | 0 : ci, Fi = (T = Zr(cr, 0, ti, 0)) + ai | 0, ai = Qe + ci | 0, ai = T >>> 0 > Fi >>> 0 ? ai + 1 | 0 : ai, T = Zr(fi, 0, Jr, Ns), ai = Qe + ai | 0, ai = T >>> 0 > (ci = T + Fi | 0) >>> 0 ? ai + 1 | 0 : ai, T = Zr(li, 0, Ys, 0), Fi = Qe + ai | 0, Fi = T >>> 0 > (ci = T + ci | 0) >>> 0 ? Fi + 1 | 0 : Fi, ai = (T = Zr(jr, 0, Tr, 0)) + ci | 0, ci = Qe + Fi | 0, ci = T >>> 0 > ai >>> 0 ? ci + 1 | 0 : ci, T = Zr(Wi, 0, Hs, 0), ci = Qe + ci | 0, ci = T >>> 0 > (ai = T + ai | 0) >>> 0 ? ci + 1 | 0 : ci, Fi = (T = Zr(vn, 0, Mi, 0)) + ai | 0, ai = Qe + ci | 0, ai = (ma >>> 21 | 0) + (ai = T >>> 0 > Fi >>> 0 ? ai + 1 | 0 : ai) | 0, Ps = ai = (T = (2097151 & ma) << 11 | yf >>> 21) >>> 0 > (es = T + Fi | 0) >>> 0 ? ai + 1 | 0 : ai, of = T = ai - ((es >>> 0 < 4293918720) - 1 | 0) | 0, ci = (ci = T >>> 21 | 0) + Eo | 0, Is = ci = (T = (2097151 & T) << 11 | (is = es - -1048576 | 0) >>> 21) >>> 0 > (Qn = T + ws | 0) >>> 0 ? ci + 1 | 0 : ci, Qs = T = ci - ((Qn >>> 0 < 4293918720) - 1 | 0) | 0, ai = (ci = T >> 21) + Cs | 0, Eo = ai = (T = (2097151 & T) << 11 | (ws = Qn - -1048576 | 0) >>> 21) >>> 0 > (Po = T + Po | 0) >>> 0 ? ai + 1 | 0 : ai, zn = ai = ai - ((Po >>> 0 < 4293918720) - 1 | 0) | 0, ci = (ci = ai >> 21) + Ds | 0, Ds = ci = (ai = (Fi = (2097151 & ai) << 11 | (T = Po - -1048576 | 0) >>> 21) + xa | 0) >>> 0 < Fi >>> 0 ? ci + 1 | 0 : ci, yf = ai, ci = Zr(ai, ci, -683901, -1), ai = Qe + E | 0, Cs = Fi = ci + Ja | 0, E = ci >>> 0 > Fi >>> 0 ? ai + 1 | 0 : ai, ai = Zr(Bf, qo, 470296, 0), Fi = Qe + (ks - (((ci = -2097152 & ys) >>> 0 > _a >>> 0) + Ff | 0) | 0) | 0, Fi = ai >>> 0 > (ys = ai + (_a - ci | 0) | 0) >>> 0 ? Fi + 1 | 0 : Fi, ai = Zr(ca, Ln, 654183, 0), ci = Qe + Fi | 0, ci = ai >>> 0 > (ys = ai + ys | 0) >>> 0 ? ci + 1 | 0 : ci, Fi = Zr(nf, ro, -997805, -1), ai = Qe + ci | 0, ai = Fi >>> 0 > (ys = Fi + ys | 0) >>> 0 ? ai + 1 | 0 : ai, ma = T = Po - (ci = -2097152 & T) | 0, Ns = Eo = Eo - ((ci >>> 0 > Po >>> 0) + zn | 0) | 0, ys = (Fi = Zr(yf, Ds, 136657, 0)) + ys | 0, ci = Qe + ai | 0, T = Zr(T, Eo, -683901, -1), Fi = Qe + (Fi >>> 0 > ys >>> 0 ? ci + 1 | 0 : ci) | 0, Eo = Fi = T >>> 0 > (ks = T + ys | 0) >>> 0 ? Fi + 1 | 0 : Fi, Fs = ci = Fi - ((ks >>> 0 < 4293918720) - 1 | 0) | 0, Fi = (2097151 & ci) << 11 | (T = ks - -1048576 | 0) >>> 21, ci = (ci >> 21) + E | 0, zn = Fi = (ci = Fi >>> 0 > (ys = Fi + Cs | 0) >>> 0 ? ci + 1 | 0 : ci) - ((ys >>> 0 < 4293918720) - 1 | 0) | 0, Po = (2097151 & Fi) << 11 | (E = ys - -1048576 | 0) >>> 21, Fi = (Fi >> 21) + Df | 0, Ys = Cs = Po + ff | 0, Cs = Po >>> 0 > Cs >>> 0 ? Fi + 1 | 0 : Fi, Vs = ys - (E &= -2097152) | 0, Hs = ci - ((E >>> 0 > ys >>> 0) + zn | 0) | 0, sf = ks - (E = -2097152 & T) | 0, ef = Eo - ((E >>> 0 > ks >>> 0) + Fs | 0) | 0, E = Zr(Bf, qo, 666643, 0), ci = Qe + (Es - (((T = -2097152 & us) >>> 0 > Ka >>> 0) + Vf | 0) | 0) | 0, ci = E >>> 0 > (ai = E + (Ka - T | 0) | 0) >>> 0 ? ci + 1 | 0 : ci, E = Zr(ca, Ln, 470296, 0), Fi = Qe + ci | 0, Fi = E >>> 0 > (T = E + ai | 0) >>> 0 ? Fi + 1 | 0 : Fi, E = Zr(nf, ro, 654183, 0), ci = Qe + Fi | 0, ys = T = E + T | 0, E = E >>> 0 > T >>> 0 ? ci + 1 | 0 : ci, ws = Qn - (T = -2097152 & ws) | 0, Eo = Is - ((T >>> 0 > Qn >>> 0) + Qs | 0) | 0, T = Zr(io, qn, 470296, 0), ai = Qe, ci = T, T = Zr(Yi, So, 666643, 0), ai = Qe + ai | 0, ai = T >>> 0 > (ci = ci + T | 0) >>> 0 ? ai + 1 | 0 : ai, T = Zr($n, Xi, 654183, 0), Fi = Qe + ai | 0, Fi = T >>> 0 > (ci = T + ci | 0) >>> 0 ? Fi + 1 | 0 : Fi, ai = (T = Zr(wo, Zn, -997805, -1)) + ci | 0, ci = Qe + Fi | 0, ci = T >>> 0 > ai >>> 0 ? ci + 1 | 0 : ci, T = Zr(to, fo, 136657, 0), ci = Qe + ci | 0, ai = Ps + (T >>> 0 > (Fi = T + ai | 0) >>> 0 ? ci + 1 | 0 : ci) | 0, ai = (T = Fi + es | 0) >>> 0 < es >>> 0 ? ai + 1 | 0 : ai, ci = T, T = Zr(go, bo, -683901, -1), ai = Qe + ai | 0, ai = T >>> 0 > (Fi = ci + T | 0) >>> 0 ? ai + 1 | 0 : ai, zn = (T = (2097151 & gf) << 11 | Ea >>> 21) + (Fi - (ci = -2097152 & is) | 0) | 0, ci = (ai - ((ci >>> 0 > Fi >>> 0) + of | 0) | 0) + (gf >> 21) | 0, Qn = ci = T >>> 0 > zn >>> 0 ? ci + 1 | 0 : ci, Qs = T = ci - ((zn >>> 0 < 4293918720) - 1 | 0) | 0, ci = (ai = T >> 21) + Eo | 0, gf = ci = (T = (Fi = (2097151 & T) << 11 | (Po = zn - -1048576 | 0) >>> 21) + ws | 0) >>> 0 < Fi >>> 0 ? ci + 1 | 0 : ci, Fs = T, T = Zr(T, ci, -683901, -1), Fi = Qe + E | 0, Fi = T >>> 0 > (ai = T + ys | 0) >>> 0 ? Fi + 1 | 0 : Fi, E = Zr(yf, Ds, -997805, -1), ci = Qe + Fi | 0, ci = E >>> 0 > (T = E + ai | 0) >>> 0 ? ci + 1 | 0 : ci, E = Zr(ma, Ns, 136657, 0), ai = Qe + ci | 0, Ea = T = E + T | 0, ws = E >>> 0 > T >>> 0 ? ai + 1 | 0 : ai, is = la - (E = -2097152 & fn) | 0, Is = Rs - ((E >>> 0 > la >>> 0) + ms | 0) | 0, E = Zr(M, 0, jr, 0), T = Qe, ai = E, E = Zr(pr, 0, li, 0), ci = Qe + T | 0, ci = E >>> 0 > (ai = ai + E | 0) >>> 0 ? ci + 1 | 0 : ci, E = Zr(ve, 0, Wi, 0), ci = Qe + ci | 0, ci = E >>> 0 > (T = E + ai | 0) >>> 0 ? ci + 1 | 0 : ci, E = Zr(Nr, 0, Mi, 0), ai = Qe + ci | 0, E = E >>> 0 > (ci = T = E + T | 0) >>> 0 ? ai + 1 | 0 : ai, T = Zr(M, 0, li, 0), ai = Qe, Eo = (Fi = T) + (T = Zr(pr, 0, Mi, 0)) | 0, Fi = Qe + ai | 0, Fi = T >>> 0 > Eo >>> 0 ? Fi + 1 | 0 : Fi, T = Zr(Nr, 0, Wi, 0), ai = Qe + Fi | 0, T = ai = T >>> 0 > (Eo = T + Eo | 0) >>> 0 ? ai + 1 | 0 : ai, Bf = ai = ai - ((Eo >>> 0 < 4293918720) - 1 | 0) | 0, Fi = ai >>> 21 | 0, es = (ai = (2097151 & ai) << 11 | (Es = Eo - -1048576 | 0) >>> 21) + ci | 0, ci = E + Fi | 0, us = ci = ai >>> 0 > es >>> 0 ? ci + 1 | 0 : ci, Ka = E = ci - ((es >>> 0 < 4293918720) - 1 | 0) | 0, ai = (Fi = E >>> 21 | 0) + Is | 0, ai = (E = (2097151 & E) << 11 | (ks = es - -1048576 | 0) >>> 21) >>> 0 > (ci = E + is | 0) >>> 0 ? ai + 1 | 0 : ai, Fi = (E = Zr(ca, Ln, 666643, 0)) + ci | 0, ci = Qe + ai | 0, ci = E >>> 0 > Fi >>> 0 ? ci + 1 | 0 : ci, E = Zr(nf, ro, 470296, 0), ci = Qe + ci | 0, ci = E >>> 0 > (ai = E + Fi | 0) >>> 0 ? ci + 1 | 0 : ci, Fi = (E = Zr(Fs, gf, 136657, 0)) + ai | 0, ai = Qe + ci | 0, ai = E >>> 0 > Fi >>> 0 ? ai + 1 | 0 : ai, ci = (E = Zr(yf, Ds, 654183, 0)) + Fi | 0, Fi = Qe + ai | 0, Fi = E >>> 0 > ci >>> 0 ? Fi + 1 | 0 : Fi, E = Zr(ma, Ns, -997805, -1), ai = Qe + Fi | 0, Ps = ai = E >>> 0 > (ys = E + ci | 0) >>> 0 ? ai + 1 | 0 : ai, _a = E = ai - ((ys >>> 0 < 4293918720) - 1 | 0) | 0, ci = (Fi = E >> 21) + ws | 0, Ea = ai = (ci = (E = (ai = (2097151 & E) << 11 | (is = ys - -1048576 | 0) >>> 21) + Ea | 0) >>> 0 < ai >>> 0 ? ci + 1 | 0 : ci) - ((E >>> 0 < 4293918720) - 1 | 0) | 0, ws = (2097151 & ai) << 11 | (Is = E - -1048576 | 0) >>> 21, ai = (ai >> 21) + ef | 0, xa = fn = ws + sf | 0, Rs = ws >>> 0 > fn >>> 0 ? ai + 1 | 0 : ai, ws = E, Fi = ci, ci = (Qn - (((ai = -2097152 & Po) >>> 0 > zn >>> 0) + Qs | 0) | 0) + (Ba >> 21) | 0, fn = ci = (E = (zn - ai | 0) + (Po = (2097151 & Ba) << 11 | ra >>> 21) | 0) >>> 0 < Po >>> 0 ? ci + 1 | 0 : ci, of = ci = ci - ((E >>> 0 < 4293918720) - 1 | 0) | 0, zn = ai = ci >> 21, ci = Zr(ca = (2097151 & ci) << 11 | (Qn = E - -1048576 | 0) >>> 21, ai, -683901, -1), ai = Qe + Fi | 0, ai = ci >>> 0 > (ws = ci + ws | 0) >>> 0 ? ai + 1 | 0 : ai, sf = ws - (ci = -2097152 & Is) | 0, ef = ai - ((ci >>> 0 > ws >>> 0) + Ea | 0) | 0, ai = Zr(ca, zn, 136657, 0), ci = Qe + Ps | 0, ci = ai >>> 0 > (Fi = ai + ys | 0) >>> 0 ? ci + 1 | 0 : ci, Qs = Fi - (ai = -2097152 & is) | 0, Ea = ci - ((ai >>> 0 > Fi >>> 0) + _a | 0) | 0, Fi = (ai = Zr(nf, ro, 666643, 0)) + (es - (ci = -2097152 & ks) | 0) | 0, ci = Qe + (us - ((ci >>> 0 > es >>> 0) + Ka | 0) | 0) | 0, ci = ai >>> 0 > Fi >>> 0 ? ci + 1 | 0 : ci, ws = (ai = Zr(Fs, gf, -997805, -1)) + Fi | 0, Fi = Qe + ci | 0, Fi = ai >>> 0 > ws >>> 0 ? Fi + 1 | 0 : Fi, ci = Zr(yf, Ds, 470296, 0), ai = Qe + Fi | 0, ai = ci >>> 0 > (ws = ci + ws | 0) >>> 0 ? ai + 1 | 0 : ai, Fi = Zr(ma, Ns, 654183, 0), ci = Qe + ai | 0, Ba = ws = Fi + ws | 0, Ps = Fi >>> 0 > ws >>> 0 ? ci + 1 | 0 : ci, ws = Eo, Eo = T, T = Zr(pr, 0, Wi, 0), ai = Qe, ci = T, T = Zr(M, 0, Mi, 0), ai = Qe + ai | 0, ai = T >>> 0 > (Fi = ci + T | 0) >>> 0 ? ai + 1 | 0 : ai, T = Zr(M, 0, Wi, 0), la = ci = Qe, es = T, us = T - -1048576 | 0, Ka = T = ci - ((T >>> 0 < 4293918720) - 1 | 0) | 0, ci = T >>> 21 | 0, Po = (T = (2097151 & T) << 11 | us >>> 21) + Fi | 0, Fi = ci + ai | 0, ks = Fi = T >>> 0 > Po >>> 0 ? Fi + 1 | 0 : Fi, _a = T = Fi - ((Po >>> 0 < 4293918720) - 1 | 0) | 0, ai = (ci = T >>> 21 | 0) + Eo | 0, ai = (T = (2097151 & T) << 11 | (ys = Po - -1048576 | 0) >>> 21) >>> 0 > (Fi = T + ws | 0) >>> 0 ? ai + 1 | 0 : ai, Eo = (T = Zr(Fs, gf, 654183, 0)) + (Fi - (ci = -2097152 & Es) | 0) | 0, Fi = Qe + (ai - ((8191 & Bf) + (ci >>> 0 > Fi >>> 0) | 0) | 0) | 0, Fi = T >>> 0 > Eo >>> 0 ? Fi + 1 | 0 : Fi, T = Zr(yf, Ds, 666643, 0), ci = Qe + Fi | 0, ci = T >>> 0 > (ai = T + Eo | 0) >>> 0 ? ci + 1 | 0 : ci, is = (T = Zr(ma, Ns, 470296, 0)) + ai | 0, ai = Qe + ci | 0, Is = ai = T >>> 0 > is >>> 0 ? ai + 1 | 0 : ai, ra = T = ai - ((is >>> 0 < 4293918720) - 1 | 0) | 0, ci = (ci = T >> 21) + Ps | 0, Fi = ci = (T = (2097151 & T) << 11 | (ws = is - -1048576 | 0) >>> 21) >>> 0 > (Eo = T + Ba | 0) >>> 0 ? ci + 1 | 0 : ci, Es = ai = ci - ((Eo >>> 0 < 4293918720) - 1 | 0) | 0, Ps = (2097151 & ai) << 11 | (T = Eo - -1048576 | 0) >>> 21, ai = (ai >> 21) + Ea | 0, Ps = Ps >>> 0 > (Ds = Ba = Ps + Qs | 0) >>> 0 ? ai + 1 | 0 : ai, ci = Zr(ca, zn, -997805, -1), ai = Qe + Fi | 0, yf = (Eo = ci + Eo | 0) - (T &= -2097152) | 0, Ea = (ci >>> 0 > Eo >>> 0 ? ai + 1 | 0 : ai) - ((T >>> 0 > Eo >>> 0) + Es | 0) | 0, T = Zr(ca, zn, 654183, 0), Fi = Qe + Is | 0, Fi = T >>> 0 > (ai = T + is | 0) >>> 0 ? Fi + 1 | 0 : Fi, Ba = ai - (T = -2097152 & ws) | 0, ra = Fi - ((T >>> 0 > ai >>> 0) + ra | 0) | 0, T = Zr(Fs, gf, 470296, 0), ci = Qe + (ks - ((8191 & _a) + ((ai = -2097152 & ys) >>> 0 > Po >>> 0) | 0) | 0) | 0, ci = T >>> 0 > (Fi = T + (Po - ai | 0) | 0) >>> 0 ? ci + 1 | 0 : ci, T = Zr(ma, Ns, 666643, 0), ci = Qe + ci | 0, ci = T >>> 0 > (ai = T + Fi | 0) >>> 0 ? ci + 1 | 0 : ci, Eo = ai, T = Zr(Fs, gf, 666643, 0), Fi = Qe + (la - ((2047 & Ka) + ((ai = -2097152 & us) >>> 0 > es >>> 0) | 0) | 0) | 0, is = Fi = T >>> 0 > (ys = T + (es - ai | 0) | 0) >>> 0 ? Fi + 1 | 0 : Fi, Es = T = Fi - ((ys >>> 0 < 4293918720) - 1 | 0) | 0, ci = ci + (ai = T >> 21) | 0, us = T = (ci = (T = (2097151 & T) << 11 | (Is = ys - -1048576 | 0) >>> 21) >>> 0 > (ws = T + Eo | 0) >>> 0 ? ci + 1 | 0 : ci) - ((ws >>> 0 < 4293918720) - 1 | 0) | 0, Fi = (ai = T >> 21) + ra | 0, T = (T = (2097151 & T) << 11 | (Eo = ws - -1048576 | 0) >>> 21) >>> 0 > (ks = T + Ba | 0) >>> 0 ? Fi + 1 | 0 : Fi, ai = Zr(ca, zn, 470296, 0), ci = Qe + ci | 0, ci = ai >>> 0 > (Fi = ai + ws | 0) >>> 0 ? ci + 1 | 0 : ci, Eo = Fi - (ai = -2097152 & Eo) | 0, ws = ci - ((ai >>> 0 > Fi >>> 0) + us | 0) | 0, ai = Zr(ca, zn, 666643, 0), Fi = Qe + (is - (((ci = -2097152 & Is) >>> 0 > ys >>> 0) + Es | 0) | 0) | 0, ai = (ci = (Fi = ai >>> 0 > (Po = ai + (ys - ci | 0) | 0) >>> 0 ? Fi + 1 | 0 : Fi) >> 21) + ws | 0, ci = T + (Fi = (ai = (Fi = (2097151 & Fi) << 11 | Po >>> 21) >>> 0 > (Eo = Fi + Eo | 0) >>> 0 ? ai + 1 | 0 : ai) >> 21) | 0, ai = (ai = (ci = (T = ws = (ai = (2097151 & ai) << 11 | Eo >>> 21) + ks | 0) >>> 0 < ai >>> 0 ? ci + 1 | 0 : ci) >> 21) + Ea | 0, ci = (ci = (ai = (ci = (2097151 & ci) << 11 | T >>> 21) >>> 0 > (Es = ci + yf | 0) >>> 0 ? ai + 1 | 0 : ai) >> 21) + Ps | 0, Fi = (ai = (ci = (ai = (2097151 & ai) << 11 | Es >>> 21) >>> 0 > (us = ai + Ds | 0) >>> 0 ? ci + 1 | 0 : ci) >> 21) + ef | 0, ai = (ci = (Fi = (ci = (2097151 & ci) << 11 | us >>> 21) >>> 0 > (ks = ci + sf | 0) >>> 0 ? Fi + 1 | 0 : Fi) >> 21) + Rs | 0, ci = (Fi = (ai = (Fi = (2097151 & Fi) << 11 | ks >>> 21) >>> 0 > (ys = Fi + xa | 0) >>> 0 ? ai + 1 | 0 : ai) >> 21) + Hs | 0, ai = (ai = (ci = (ai = (2097151 & ai) << 11 | ys >>> 21) >>> 0 > (Ps = ai + Vs | 0) >>> 0 ? ci + 1 | 0 : ci) >> 21) + Cs | 0, ci = (ci = (ai = (ci = (2097151 & ci) << 11 | Ps >>> 21) >>> 0 > (is = ci + Ys | 0) >>> 0 ? ai + 1 | 0 : ai) >> 21) + nc | 0, Fi = (ai = (ci = (ai = (2097151 & ai) << 11 | is >>> 21) >>> 0 > (Is = ai + ic | 0) >>> 0 ? ci + 1 | 0 : ci) >> 21) + ua | 0, ci = (fn - ((E >>> 0 < (ai = -2097152 & Qn) >>> 0) + of | 0) | 0) + ((Fi = (ci = (2097151 & ci) << 11 | Is >>> 21) >>> 0 > (ws = ci + Qa | 0) >>> 0 ? Fi + 1 | 0 : Fi) >> 21) | 0, fn = ai = (ci = (Qn = (Rs = E - ai | 0) + ((2097151 & Fi) << 11 | ws >>> 21) | 0) >>> 0 < Rs >>> 0 ? ci + 1 | 0 : ci) >> 21, E = (E = Zr(Rs = (2097151 & ci) << 11 | Qn >>> 21, ai, 666643, 0)) + (ai = 2097151 & Po) | 0, Fi = Qe, B[0 | k] = E, Fi = E >>> 0 < ai >>> 0 ? Fi + 1 | 0 : Fi, B[k + 1 | 0] = (255 & Fi) << 24 | E >>> 8, ai = 2097151 & Eo, Eo = Zr(Rs, fn, 470296, 0) + ai | 0, ci = Qe, ci = (Fi >> 21) + (ci = ai >>> 0 > Eo >>> 0 ? ci + 1 | 0 : ci) | 0, ci = (Eo = (Po = (2097151 & Fi) << 11 | E >>> 21) + Eo | 0) >>> 0 < Po >>> 0 ? ci + 1 | 0 : ci, B[k + 4 | 0] = (2047 & ci) << 21 | Eo >>> 11, B[k + 3 | 0] = (7 & ci) << 29 | Eo >>> 3, B[k + 2 | 0] = 31 & ((65535 & Fi) << 16 | E >>> 16) | Eo << 5, E = 2097151 & T, T = Zr(Rs, fn, 654183, 0) + E | 0, Fi = Qe, Fi = E >>> 0 > T >>> 0 ? Fi + 1 | 0 : Fi, E = ci, ai = (ci >>= 21) + Fi | 0, E = ai = (E = (2097151 & E) << 11 | Eo >>> 21) >>> 0 > (T = E + T | 0) >>> 0 ? ai + 1 | 0 : ai, B[k + 6 | 0] = (63 & ai) << 26 | T >>> 6, ci = 0, B[k + 5 | 0] = ci << 13 | (1572864 & Eo) >>> 19 | T << 2, ci = 2097151 & Es, Fi = Zr(Rs, fn, -997805, -1) + ci | 0, ai = Qe, ai = ci >>> 0 > Fi >>> 0 ? ai + 1 | 0 : ai, ci = (ci = E >> 21) + ai | 0, ci = (E = (Eo = Fi) + (Fi = (2097151 & E) << 11 | T >>> 21) | 0) >>> 0 < Fi >>> 0 ? ci + 1 | 0 : ci, B[k + 9 | 0] = (511 & ci) << 23 | E >>> 9, B[k + 8 | 0] = (1 & ci) << 31 | E >>> 1, ai = 0, B[k + 7 | 0] = ai << 18 | (2080768 & T) >>> 14 | E << 7, T = 2097151 & us, ai = Zr(Rs, fn, 136657, 0) + T | 0, Fi = Qe, Fi = T >>> 0 > ai >>> 0 ? Fi + 1 | 0 : Fi, T = (Eo = (2097151 & (T = ci)) << 11 | E >>> 21) + ai | 0, ai = (ci >>= 21) + Fi | 0, ai = T >>> 0 < Eo >>> 0 ? ai + 1 | 0 : ai, B[k + 12 | 0] = (4095 & ai) << 20 | T >>> 12, B[k + 11 | 0] = (15 & ai) << 28 | T >>> 4, ci = 0, B[k + 10 | 0] = ci << 15 | (1966080 & E) >>> 17 | T << 4, E = 2097151 & ks, Fi = Zr(Rs, fn, -683901, -1) + E | 0, ci = Qe, ci = E >>> 0 > Fi >>> 0 ? ci + 1 | 0 : ci, E = ai, ai = ci + (ai >>= 21) | 0, ai = (E = (Eo = Fi) + (Fi = (2097151 & E) << 11 | T >>> 21) | 0) >>> 0 < Fi >>> 0 ? ai + 1 | 0 : ai, B[k + 14 | 0] = (127 & ai) << 25 | E >>> 7, ci = 0, B[k + 13 | 0] = ci << 12 | (1048576 & T) >>> 20 | E << 1, ci = ai >> 21, ci = (T = (ai = (2097151 & ai) << 11 | E >>> 21) + (2097151 & ys) | 0) >>> 0 < ai >>> 0 ? ci + 1 | 0 : ci, B[k + 17 | 0] = (1023 & ci) << 22 | T >>> 10, B[k + 16 | 0] = (3 & ci) << 30 | T >>> 2, ai = 0, B[k + 15 | 0] = ai << 17 | (2064384 & E) >>> 15 | T << 6, E = ci, ci >>= 21, Fi = (E = (ai = (2097151 & E) << 11 | T >>> 21) + (2097151 & Ps) | 0) >>> 0 < ai >>> 0 ? ci + 1 | 0 : ci, B[k + 20 | 0] = (8191 & Fi) << 19 | E >>> 13, B[k + 19 | 0] = (31 & Fi) << 27 | E >>> 5, ai = Fi >> 21, ai = (ci = (Eo = (2097151 & Fi) << 11 | E >>> 21) + (2097151 & is) | 0) >>> 0 < Eo >>> 0 ? ai + 1 | 0 : ai, Eo = ci, B[k + 21 | 0] = ci, ci = 0, B[k + 18 | 0] = ci << 14 | (1835008 & T) >>> 18 | E << 3, B[k + 22 | 0] = (255 & ai) << 24 | Eo >>> 8, ci = ai >> 21, ci = (E = (T = (2097151 & ai) << 11 | Eo >>> 21) + (2097151 & Is) | 0) >>> 0 < T >>> 0 ? ci + 1 | 0 : ci, B[k + 25 | 0] = (2047 & ci) << 21 | E >>> 11, B[k + 24 | 0] = (7 & ci) << 29 | E >>> 3, B[k + 23 | 0] = 31 & ((65535 & ai) << 16 | Eo >>> 16) | E << 5, ai = (2097151 & ci) << 11 | E >>> 21, ci >>= 21, ci = (T = ai + (2097151 & ws) | 0) >>> 0 < ai >>> 0 ? ci + 1 | 0 : ci, B[k + 27 | 0] = (63 & ci) << 26 | T >>> 6, ai = 0, B[k + 26 | 0] = ai << 13 | (1572864 & E) >>> 19 | T << 2, E = ci, ai = ci >>= 21, ai = (E = (Eo = (2097151 & E) << 11 | T >>> 21) + (Fi = 2097151 & Qn) | 0) >>> 0 < Fi >>> 0 ? ai + 1 | 0 : ai, B[k + 31 | 0] = (131071 & ai) << 15 | E >>> 17, B[k + 30 | 0] = (511 & ai) << 23 | E >>> 9, ci = 0, B[k + 28 | 0] = ci << 18 | (2080768 & T) >>> 14 | E << 7, B[k + 29 | 0] = Eo + Qn >>> 1;
                    }
                    function ni(k, E, T, M) {
                      for (var ye = 0, Ne = 0, pr = 0, ve = 0, cr = 0, gr = 0, Pr = 0, Nr = 0, Br = 0, Mr = 0, jr = 0, ti = 0, fi = 0, Jr = 0, li = 0, Tr = 0, Mi = 0, Wi = 0, vn = 0, Tn = 0, Ni = 0, Yi = 0, Xi = 0, $n = 0, Zn = 0, to = 0, fo = 0, wo = 0, bo = 0, go = 0, qn = 0, io = 0, So = 0, qo = 0, Ln = 0, ro = 0, Qo = 0; pr = (ye = cr << 3) + T | 0, Ne = m[0 | (ye = E + ye | 0)] | m[ye + 1 | 0] << 8 | m[ye + 2 | 0] << 16 | m[ye + 3 | 0] << 24, Ni = m[ye + 4 | 0] | m[ye + 5 | 0] << 8 | m[ye + 6 | 0] << 16 | m[ye + 7 | 0] << 24, gr = Ne << 24 | (65280 & Ne) << 8, Pr = (ve = 16711680 & Ne) << 24, ve = ve >>> 8 | 0, ye = (Br = -16777216 & Ne) >>> 24 | 0, o[pr >> 2] = Pr | Br << 8 | -16777216 & ((255 & Ni) << 24 | Ne >>> 8) | 16711680 & ((16777215 & Ni) << 8 | Ne >>> 24) | Ni >>> 8 & 65280 | Ni >>> 24, Ne = ye | ve | gr, ye = 0, o[pr + 4 >> 2] = Ne | ye, (0 | (cr = cr + 1 | 0)) != 16; ) ;
                      for (E = o[k + 4 >> 2], o[M >> 2] = o[k >> 2], o[M + 4 >> 2] = E, E = o[k + 60 >> 2], o[M + 56 >> 2] = o[k + 56 >> 2], o[M + 60 >> 2] = E, E = o[k + 52 >> 2], o[M + 48 >> 2] = o[k + 48 >> 2], o[M + 52 >> 2] = E, E = o[k + 44 >> 2], o[M + 40 >> 2] = o[k + 40 >> 2], o[M + 44 >> 2] = E, E = o[k + 36 >> 2], o[M + 32 >> 2] = o[k + 32 >> 2], o[M + 36 >> 2] = E, E = o[k + 28 >> 2], o[M + 24 >> 2] = o[k + 24 >> 2], o[M + 28 >> 2] = E, E = o[k + 20 >> 2], o[M + 16 >> 2] = o[k + 16 >> 2], o[M + 20 >> 2] = E, E = o[k + 12 >> 2], o[M + 8 >> 2] = o[k + 8 >> 2], o[M + 12 >> 2] = E; pr = o[M + 56 >> 2], ve = o[M + 60 >> 2], ye = o[(E = Ni = (Yi = Qo << 3) + T | 0) >> 2], E = o[E + 4 >> 2], Mi = Ne = o[M + 36 >> 2], Ne = Ci(Jr = o[M + 32 >> 2], Ne, 50), cr = Qe, Ne = Ci(Jr, Mi, 46) ^ Ne, cr ^= Qe, Ne = Ci(Jr, Mi, 23) ^ Ne, E = (Qe ^ cr) + E | 0, E = (ye = Ne + ye | 0) >>> 0 < Ne >>> 0 ? E + 1 | 0 : E, ye = (cr = o[(Ne = Yi + 34416 | 0) >> 2]) + ye | 0, E = o[Ne + 4 >> 2] + E | 0, E = ye >>> 0 < cr >>> 0 ? E + 1 | 0 : E, Ne = (cr = ((Pr = o[M + 48 >> 2]) ^ (Mr = o[M + 40 >> 2])) & Jr ^ Pr) + ye | 0, ye = (((li = o[M + 52 >> 2]) ^ (Wi = o[M + 44 >> 2])) & Mi ^ li) + E | 0, E = (Ne >>> 0 < cr >>> 0 ? ye + 1 | 0 : ye) + ve | 0, E = (pr = Ne + pr | 0) >>> 0 < Ne >>> 0 ? E + 1 | 0 : E, cr = (Ne = o[M + 24 >> 2]) + pr | 0, ye = o[M + 28 >> 2] + E | 0, jr = ye = Ne >>> 0 > cr >>> 0 ? ye + 1 | 0 : ye, o[M + 24 >> 2] = cr, o[M + 28 >> 2] = ye, Tr = ye = o[M + 4 >> 2], ye = Ci(Ne = o[M >> 2], ye, 36), ve = Qe, ye = Ci(Ne, Tr, 30) ^ ye, ve ^= Qe, Br = pr + (Ci(Ne, Tr, 25) ^ ye) | 0, ye = E + (Qe ^ ve) | 0, ye = pr >>> 0 > Br >>> 0 ? ye + 1 | 0 : ye, gr = (E = Br) + (Br = Ne & ((ve = o[M + 16 >> 2]) | (pr = o[M + 8 >> 2])) | pr & ve) | 0, E = (E = ye) + (Tr & ((ye = o[M + 20 >> 2]) | (ti = o[M + 12 >> 2])) | ye & ti) | 0, Br = E = gr >>> 0 < Br >>> 0 ? E + 1 | 0 : E, o[M + 56 >> 2] = gr, o[M + 60 >> 2] = E, Nr = ve, fi = ye, Tn = o[(E = qn = (vn = 8 | Yi) + T | 0) >> 2], $n = o[E + 4 >> 2], ye = ((Mi ^ Wi) & jr ^ Wi) + li | 0, ye = (E = (ve = (Mr ^ Jr) & cr ^ Mr) + Pr | 0) >>> 0 < ve >>> 0 ? ye + 1 | 0 : ye, ve = Ci(cr, jr, 50), Pr = Qe, ve = Ci(cr, jr, 46) ^ ve, Pr ^= Qe, ve = (li = Ci(cr, jr, 23) ^ ve) + E | 0, E = (Qe ^ Pr) + ye | 0, E = (ve >>> 0 < li >>> 0 ? E + 1 | 0 : E) + $n | 0, E = (ye = ve + Tn | 0) >>> 0 < ve >>> 0 ? E + 1 | 0 : E, ve = (ve = ye) + (Pr = o[(ye = vn + 34416 | 0) >> 2]) | 0, ye = o[ye + 4 >> 2] + E | 0, ye = (E = ve >>> 0 < Pr >>> 0 ? ye + 1 | 0 : ye) + fi | 0, li = ye = (Pr = ve + Nr | 0) >>> 0 < ve >>> 0 ? ye + 1 | 0 : ye, o[M + 16 >> 2] = Pr, o[M + 20 >> 2] = ye, E = E + ((ti | Tr) & Br | ti & Tr) | 0, E = (ye = ve + ((Ne | pr) & gr | Ne & pr) | 0) >>> 0 < ve >>> 0 ? E + 1 | 0 : E, ve = Ci(gr, Br, 36), Nr = Qe, ve = Ci(gr, Br, 30) ^ ve, Nr ^= Qe, fi = ye, ye = Ci(gr, Br, 25) ^ ve, E = (Qe ^ Nr) + E | 0, Nr = E = ye >>> 0 > (ve = fi + ye | 0) >>> 0 ? E + 1 | 0 : E, o[M + 48 >> 2] = ve, o[M + 52 >> 2] = E, fi = pr, vn = ti, E = (ti = o[(ye = fo = (pr = 16 | Yi) + T | 0) >> 2]) + Mr | 0, ye = o[ye + 4 >> 2] + Wi | 0, ye = E >>> 0 < ti >>> 0 ? ye + 1 | 0 : ye, pr = (Mr = E) + (ti = o[(E = pr + 34416 | 0) >> 2]) | 0, E = o[E + 4 >> 2] + ye | 0, E = ((jr ^ Mi) & li ^ Mi) + (E = pr >>> 0 < ti >>> 0 ? E + 1 | 0 : E) | 0, E = (ye = (ye = pr) + (pr = (cr ^ Jr) & Pr ^ Jr) | 0) >>> 0 < pr >>> 0 ? E + 1 | 0 : E, pr = Ci(Pr, li, 50), ti = Qe, pr = Ci(Pr, li, 46) ^ pr, ti ^= Qe, pr = (Mr = Ci(Pr, li, 23) ^ pr) + ye | 0, ye = (Qe ^ ti) + E | 0, ye = (Mr = pr >>> 0 < Mr >>> 0 ? ye + 1 | 0 : ye) + vn | 0, vn = ye = (ti = pr) >>> 0 > (pr = pr + fi | 0) >>> 0 ? ye + 1 | 0 : ye, o[M + 8 >> 2] = pr, o[M + 12 >> 2] = ye, E = Ci(ve, Nr, 36), ye = Qe, E = Ci(ve, Nr, 30) ^ E, ye ^= Qe, Wi = Ci(ve, Nr, 25) ^ E, E = ((Br | Tr) & Nr | Br & Tr) + (Qe ^ ye) | 0, ye = Mr + ((fi = Wi + ((Ne | gr) & ve | Ne & gr) | 0) >>> 0 < Wi >>> 0 ? E + 1 | 0 : E) | 0, ti = ye = (Mr = ti + fi | 0) >>> 0 < ti >>> 0 ? ye + 1 | 0 : ye, o[M + 40 >> 2] = Mr, o[M + 44 >> 2] = ye, fi = Ne, ye = (ye = Jr) + (Jr = o[(E = io = (Ne = 24 | Yi) + T | 0) >> 2]) | 0, E = o[E + 4 >> 2] + Mi | 0, E = ye >>> 0 < Jr >>> 0 ? E + 1 | 0 : E, Ne = (Wi = ye) + (Jr = o[(ye = Ne + 34416 | 0) >> 2]) | 0, ye = o[ye + 4 >> 2] + E | 0, ye = (jr ^ (jr ^ li) & vn) + (ye = Ne >>> 0 < Jr >>> 0 ? ye + 1 | 0 : ye) | 0, ye = (E = (E = Ne) + (Ne = cr ^ (cr ^ Pr) & pr) | 0) >>> 0 < Ne >>> 0 ? ye + 1 | 0 : ye, Ne = Ci(pr, vn, 50), Jr = Qe, Ne = Ci(pr, vn, 46) ^ Ne, Jr ^= Qe, Ne = (Mi = Ci(pr, vn, 23) ^ Ne) + E | 0, E = (Qe ^ Jr) + ye | 0, ye = (E = Ne >>> 0 < Mi >>> 0 ? E + 1 | 0 : E) + Tr | 0, Mi = ye = (Tr = Ne + fi | 0) >>> 0 < Ne >>> 0 ? ye + 1 | 0 : ye, o[M >> 2] = Tr, o[M + 4 >> 2] = ye, ye = Ci(Mr, ti, 36), Jr = Qe, ye = Ci(Mr, ti, 30) ^ ye, fi = Qe ^ Jr, Wi = Ci(Mr, ti, 25) ^ ye, ye = ((Br | Nr) & ti | Br & Nr) + (Qe ^ fi) | 0, E = E + ((Jr = Wi + ((ve | gr) & Mr | ve & gr) | 0) >>> 0 < Wi >>> 0 ? ye + 1 | 0 : ye) | 0, Jr = E = (fi = Ne + Jr | 0) >>> 0 < Ne >>> 0 ? E + 1 | 0 : E, o[M + 32 >> 2] = fi, o[M + 36 >> 2] = E, Ne = o[(ye = go = (E = 32 | Yi) + T | 0) >> 2], ye = jr + o[ye + 4 >> 2] | 0, ye = (Ne = Ne + cr | 0) >>> 0 < cr >>> 0 ? ye + 1 | 0 : ye, Ne = (cr = o[(E = E + 34416 | 0) >> 2]) + Ne | 0, E = o[E + 4 >> 2] + ye | 0, E = (li ^ (li ^ vn) & Mi) + (E = Ne >>> 0 < cr >>> 0 ? E + 1 | 0 : E) | 0, E = (ye = (ye = Ne) + (Ne = Pr ^ (pr ^ Pr) & Tr) | 0) >>> 0 < Ne >>> 0 ? E + 1 | 0 : E, Ne = Ci(Tr, Mi, 50), cr = Qe, Ne = Ci(Tr, Mi, 46) ^ Ne, cr ^= Qe, Ne = (jr = Ci(Tr, Mi, 23) ^ Ne) + ye | 0, ye = (Qe ^ cr) + E | 0, Wi = ye = Ne >>> 0 < jr >>> 0 ? ye + 1 | 0 : ye, E = ye, ye = Ci(fi, Jr, 36), cr = Qe, ye = Ci(fi, Jr, 30) ^ ye, jr = Qe ^ cr, Tn = Ci(fi, Jr, 25) ^ ye, ye = ((Nr | ti) & Jr | Nr & ti) + (Qe ^ jr) | 0, E = ((cr = Tn + ((ve | Mr) & fi | ve & Mr) | 0) >>> 0 < Tn >>> 0 ? ye + 1 | 0 : ye) + E | 0, cr = E = (jr = Ne + cr | 0) >>> 0 < cr >>> 0 ? E + 1 | 0 : E, o[M + 24 >> 2] = jr, o[M + 28 >> 2] = E, ye = Br + Wi | 0, Wi = ye = (Br = Ne + gr | 0) >>> 0 < Ne >>> 0 ? ye + 1 | 0 : ye, o[M + 56 >> 2] = Br, o[M + 60 >> 2] = ye, Ne = o[(E = wo = (ye = 40 | Yi) + T | 0) >> 2], E = li + o[E + 4 >> 2] | 0, E = (Ne = Ne + Pr | 0) >>> 0 < Pr >>> 0 ? E + 1 | 0 : E, Ne = (gr = o[(ye = ye + 34416 | 0) >> 2]) + Ne | 0, ye = o[ye + 4 >> 2] + E | 0, ye = (vn ^ (Mi ^ vn) & Wi) + (ye = Ne >>> 0 < gr >>> 0 ? ye + 1 | 0 : ye) | 0, ye = (E = (E = Ne) + (Ne = pr ^ (pr ^ Tr) & Br) | 0) >>> 0 < Ne >>> 0 ? ye + 1 | 0 : ye, Ne = Ci(Br, Wi, 50), gr = Qe, Ne = Ci(Br, Wi, 46) ^ Ne, gr ^= Qe, Ne = (Pr = Ci(Br, Wi, 23) ^ Ne) + E | 0, E = (Qe ^ gr) + ye | 0, E = Ne >>> 0 < Pr >>> 0 ? E + 1 | 0 : E, ye = Ci(jr, cr, 36), gr = Qe, ye = Ci(jr, cr, 30) ^ ye, Pr = Qe ^ gr, li = Ci(jr, cr, 25) ^ ye, ye = ((ti | Jr) & cr | ti & Jr) + (Qe ^ Pr) | 0, ye = ((gr = li + ((Mr | fi) & jr | Mr & fi) | 0) >>> 0 < li >>> 0 ? ye + 1 | 0 : ye) + E | 0, gr = ye = (Pr = Ne + gr | 0) >>> 0 < gr >>> 0 ? ye + 1 | 0 : ye, o[M + 16 >> 2] = Pr, o[M + 20 >> 2] = ye, E = E + Nr | 0, Tn = E = (Nr = Ne + ve | 0) >>> 0 < ve >>> 0 ? E + 1 | 0 : E, o[M + 48 >> 2] = Nr, o[M + 52 >> 2] = E, Ne = o[(ye = to = (E = 48 | Yi) + T | 0) >> 2], ye = vn + o[ye + 4 >> 2] | 0, ye = (Ne = Ne + pr | 0) >>> 0 < pr >>> 0 ? ye + 1 | 0 : ye, Ne = (pr = o[(E = E + 34416 | 0) >> 2]) + Ne | 0, E = o[E + 4 >> 2] + ye | 0, E = (Mi ^ (Mi ^ Wi) & Tn) + (E = Ne >>> 0 < pr >>> 0 ? E + 1 | 0 : E) | 0, E = (ye = (ye = Ne) + (Ne = Tr ^ (Br ^ Tr) & Nr) | 0) >>> 0 < Ne >>> 0 ? E + 1 | 0 : E, Ne = Ci(Nr, Tn, 50), pr = Qe, Ne = Ci(Nr, Tn, 46) ^ Ne, pr ^= Qe, Ne = (ve = Ci(Nr, Tn, 23) ^ Ne) + ye | 0, ye = (Qe ^ pr) + E | 0, ve = ye = Ne >>> 0 < ve >>> 0 ? ye + 1 | 0 : ye, E = ye, ye = Ci(Pr, gr, 36), pr = Qe, ye = Ci(Pr, gr, 30) ^ ye, li = Qe ^ pr, vn = Ci(Pr, gr, 25) ^ ye, ye = ((cr | Jr) & gr | cr & Jr) + (Qe ^ li) | 0, E = ((pr = vn + ((jr | fi) & Pr | jr & fi) | 0) >>> 0 < vn >>> 0 ? ye + 1 | 0 : ye) + E | 0, li = E = (ye = pr) >>> 0 > (pr = Ne + pr | 0) >>> 0 ? E + 1 | 0 : E, o[M + 8 >> 2] = pr, o[M + 12 >> 2] = E, ye = ve + ti | 0, vn = ye = ($n = Ne + Mr | 0) >>> 0 < Ne >>> 0 ? ye + 1 | 0 : ye, o[M + 40 >> 2] = $n, o[M + 44 >> 2] = ye, Ne = o[(E = bo = (ye = 56 | Yi) + T | 0) >> 2], E = Mi + o[E + 4 >> 2] | 0, E = (Ne = Ne + Tr | 0) >>> 0 < Tr >>> 0 ? E + 1 | 0 : E, Ne = (ve = o[(ye = ye + 34416 | 0) >> 2]) + Ne | 0, ye = o[ye + 4 >> 2] + E | 0, ye = (Wi ^ (Wi ^ Tn) & vn) + (ye = Ne >>> 0 < ve >>> 0 ? ye + 1 | 0 : ye) | 0, ye = (E = (E = Ne) + (Ne = Br ^ (Br ^ Nr) & $n) | 0) >>> 0 < Ne >>> 0 ? ye + 1 | 0 : ye, Ne = Ci($n, vn, 50), ve = Qe, Ne = Ci($n, vn, 46) ^ Ne, ve ^= Qe, Ne = (ti = Ci($n, vn, 23) ^ Ne) + E | 0, E = (Qe ^ ve) + ye | 0, E = Ne >>> 0 < ti >>> 0 ? E + 1 | 0 : E, ye = Ci(pr, li, 36), ve = Qe, ye = Ci(pr, li, 30) ^ ye, ti = Qe ^ ve, Mr = Ci(pr, li, 25) ^ ye, ye = ((cr | gr) & li | cr & gr) + (Qe ^ ti) | 0, ye = ((ve = Mr + ((Pr | jr) & pr | Pr & jr) | 0) >>> 0 < Mr >>> 0 ? ye + 1 | 0 : ye) + E | 0, ti = ye = (ti = ve) >>> 0 > (ve = Ne + ve | 0) >>> 0 ? ye + 1 | 0 : ye, o[M >> 2] = ve, o[M + 4 >> 2] = ye, E = E + Jr | 0, Mi = E = (Mr = Ne + fi | 0) >>> 0 < Ne >>> 0 ? E + 1 | 0 : E, o[M + 32 >> 2] = Mr, o[M + 36 >> 2] = E, Ne = o[(ye = So = (E = 64 | Yi) + T | 0) >> 2], ye = Wi + o[ye + 4 >> 2] | 0, ye = (Ne = Ne + Br | 0) >>> 0 < Br >>> 0 ? ye + 1 | 0 : ye, Ne = (Br = o[(E = E + 34416 | 0) >> 2]) + Ne | 0, E = o[E + 4 >> 2] + ye | 0, E = (Tn ^ (vn ^ Tn) & Mi) + (E = Ne >>> 0 < Br >>> 0 ? E + 1 | 0 : E) | 0, E = (ye = (ye = Ne) + (Ne = Nr ^ (Nr ^ $n) & Mr) | 0) >>> 0 < Ne >>> 0 ? E + 1 | 0 : E, Ne = Ci(Mr, Mi, 50), Br = Qe, Ne = Ci(Mr, Mi, 46) ^ Ne, Br ^= Qe, Ne = (Tr = Ci(Mr, Mi, 23) ^ Ne) + ye | 0, ye = (Qe ^ Br) + E | 0, Jr = ye = Ne >>> 0 < Tr >>> 0 ? ye + 1 | 0 : ye, E = ye, ye = Ci(ve, ti, 36), Br = Qe, ye = Ci(ve, ti, 30) ^ ye, Tr = Qe ^ Br, fi = Ci(ve, ti, 25) ^ ye, ye = ((gr | li) & ti | gr & li) + (Qe ^ Tr) | 0, E = ((Br = fi + ((pr | Pr) & ve | pr & Pr) | 0) >>> 0 < fi >>> 0 ? ye + 1 | 0 : ye) + E | 0, Br = E = (Tr = Ne + Br | 0) >>> 0 < Br >>> 0 ? E + 1 | 0 : E, o[M + 56 >> 2] = Tr, o[M + 60 >> 2] = E, ye = cr + Jr | 0, Wi = ye = (cr = Ne + jr | 0) >>> 0 < Ne >>> 0 ? ye + 1 | 0 : ye, o[M + 24 >> 2] = cr, o[M + 28 >> 2] = ye, Ne = o[(E = Zn = (ye = 72 | Yi) + T | 0) >> 2], E = Tn + o[E + 4 >> 2] | 0, E = (Ne = Ne + Nr | 0) >>> 0 < Nr >>> 0 ? E + 1 | 0 : E, Ne = (Nr = o[(ye = ye + 34416 | 0) >> 2]) + Ne | 0, ye = o[ye + 4 >> 2] + E | 0, ye = (vn ^ (Mi ^ vn) & Wi) + (ye = Ne >>> 0 < Nr >>> 0 ? ye + 1 | 0 : ye) | 0, ye = (E = (E = Ne) + (Ne = $n ^ (Mr ^ $n) & cr) | 0) >>> 0 < Ne >>> 0 ? ye + 1 | 0 : ye, Ne = Ci(cr, Wi, 50), Nr = Qe, Ne = Ci(cr, Wi, 46) ^ Ne, Nr ^= Qe, Ne = (Jr = Ci(cr, Wi, 23) ^ Ne) + E | 0, E = (Qe ^ Nr) + ye | 0, E = Ne >>> 0 < Jr >>> 0 ? E + 1 | 0 : E, ye = Ci(Tr, Br, 36), Nr = Qe, ye = Ci(Tr, Br, 30) ^ ye, Jr = Qe ^ Nr, fi = Ci(Tr, Br, 25) ^ ye, ye = ((ti | li) & Br | ti & li) + (Qe ^ Jr) | 0, ye = ((Nr = fi + ((pr | ve) & Tr | pr & ve) | 0) >>> 0 < fi >>> 0 ? ye + 1 | 0 : ye) + E | 0, Nr = ye = (Jr = Ne + Nr | 0) >>> 0 < Nr >>> 0 ? ye + 1 | 0 : ye, o[M + 48 >> 2] = Jr, o[M + 52 >> 2] = ye, E = E + gr | 0, Tn = E = (gr = Ne + Pr | 0) >>> 0 < Ne >>> 0 ? E + 1 | 0 : E, o[M + 16 >> 2] = gr, o[M + 20 >> 2] = E, E = (E = $n) + (Pr = o[(ye = $n = (Ne = 80 | Yi) + T | 0) >> 2]) | 0, ye = o[ye + 4 >> 2] + vn | 0, ye = E >>> 0 < Pr >>> 0 ? ye + 1 | 0 : ye, Ne = (jr = E) + (Pr = o[(E = Ne + 34416 | 0) >> 2]) | 0, E = o[E + 4 >> 2] + ye | 0, E = (Mi ^ (Mi ^ Wi) & Tn) + (E = Ne >>> 0 < Pr >>> 0 ? E + 1 | 0 : E) | 0, E = (ye = (ye = Ne) + (Ne = Mr ^ (cr ^ Mr) & gr) | 0) >>> 0 < Ne >>> 0 ? E + 1 | 0 : E, Ne = Ci(gr, Tn, 50), Pr = Qe, Ne = Ci(gr, Tn, 46) ^ Ne, Pr ^= Qe, Ne = (fi = Ci(gr, Tn, 23) ^ Ne) + ye | 0, ye = (Qe ^ Pr) + E | 0, jr = ye = Ne >>> 0 < fi >>> 0 ? ye + 1 | 0 : ye, E = ye, ye = Ci(Jr, Nr, 36), Pr = Qe, ye = Ci(Jr, Nr, 30) ^ ye, fi = Qe ^ Pr, vn = Ci(Jr, Nr, 25) ^ ye, ye = ((Br | ti) & Nr | Br & ti) + (Qe ^ fi) | 0, E = ((Pr = vn + ((ve | Tr) & Jr | ve & Tr) | 0) >>> 0 < vn >>> 0 ? ye + 1 | 0 : ye) + E | 0, Pr = E = (fi = Ne + Pr | 0) >>> 0 < Pr >>> 0 ? E + 1 | 0 : E, o[M + 40 >> 2] = fi, o[M + 44 >> 2] = E, ye = jr + li | 0, li = ye = (jr = Ne + pr | 0) >>> 0 < pr >>> 0 ? ye + 1 | 0 : ye, o[M + 8 >> 2] = jr, o[M + 12 >> 2] = ye, ye = 34416 + (E = 88 | Yi) | 0, pr = o[(E = Xi = E + T | 0) >> 2], Ne = o[ye >> 2] + pr | 0, E = o[ye + 4 >> 2] + o[E + 4 >> 2] | 0, ye = Mi + (Ne >>> 0 < pr >>> 0 ? E + 1 | 0 : E) | 0, ye = (Wi ^ (Wi ^ Tn) & li) + (ye = (E = Ne + Mr | 0) >>> 0 < Mr >>> 0 ? ye + 1 | 0 : ye) | 0, ye = (E = (Ne = cr ^ (cr ^ gr) & jr) + E | 0) >>> 0 < Ne >>> 0 ? ye + 1 | 0 : ye, Ne = Ci(jr, li, 50), pr = Qe, Ne = Ci(jr, li, 46) ^ Ne, pr ^= Qe, Ne = (Mr = Ci(jr, li, 23) ^ Ne) + E | 0, E = (Qe ^ pr) + ye | 0, E = Ne >>> 0 < Mr >>> 0 ? E + 1 | 0 : E, ye = Ci(fi, Pr, 36), pr = Qe, ye = Ci(fi, Pr, 30) ^ ye, Mr = Qe ^ pr, vn = Ci(fi, Pr, 25) ^ ye, ye = ((Br | Nr) & Pr | Br & Nr) + (Qe ^ Mr) | 0, ye = ((pr = vn + ((Jr | Tr) & fi | Jr & Tr) | 0) >>> 0 < vn >>> 0 ? ye + 1 | 0 : ye) + E | 0, Mr = ye = (Mr = pr) >>> 0 > (pr = Ne + pr | 0) >>> 0 ? ye + 1 | 0 : ye, o[M + 32 >> 2] = pr, o[M + 36 >> 2] = ye, E = E + ti | 0, ti = E = (ye = ve) >>> 0 > (ve = Ne + ve | 0) >>> 0 ? E + 1 | 0 : E, o[M >> 2] = ve, o[M + 4 >> 2] = E, ye = 34416 + (E = 96 | Yi) | 0, vn = o[(E = qo = E + T | 0) >> 2], Ne = o[ye >> 2] + vn | 0, ye = o[ye + 4 >> 2] + o[E + 4 >> 2] | 0, E = Wi + (Ne >>> 0 < vn >>> 0 ? ye + 1 | 0 : ye) | 0, E = (ye = Ne + cr | 0) >>> 0 < cr >>> 0 ? E + 1 | 0 : E, Ne = (cr = gr ^ (gr ^ jr) & ve) + ye | 0, ye = (Tn ^ (li ^ Tn) & ti) + E | 0, ye = Ne >>> 0 < cr >>> 0 ? ye + 1 | 0 : ye, E = Ci(ve, ti, 50), cr = Qe, E = Ci(ve, ti, 46) ^ E, cr ^= Qe, Wi = Ne, Ne = Ci(ve, ti, 23) ^ E, ye = (Qe ^ cr) + ye | 0, Mi = ye = (E = Wi + Ne | 0) >>> 0 < Ne >>> 0 ? ye + 1 | 0 : ye, Ne = E, E = Ci(pr, Mr, 36), cr = Qe, E = Ci(pr, Mr, 30) ^ E, vn = Qe ^ cr, Wi = Ci(pr, Mr, 25) ^ E, E = ((Pr | Nr) & Mr | Pr & Nr) + (Qe ^ vn) | 0, ye = ((cr = Wi + ((Jr | fi) & pr | Jr & fi) | 0) >>> 0 < Wi >>> 0 ? E + 1 | 0 : E) + ye | 0, cr = ye = (vn = Ne + cr | 0) >>> 0 < cr >>> 0 ? ye + 1 | 0 : ye, o[M + 24 >> 2] = vn, o[M + 28 >> 2] = ye, ye = Br + Mi | 0, Br = ye = (Tr = Ne + Tr | 0) >>> 0 < Ne >>> 0 ? ye + 1 | 0 : ye, o[M + 56 >> 2] = Tr, o[M + 60 >> 2] = ye, ye = 34416 + (E = 104 | Yi) | 0, Mi = o[(E = ro = E + T | 0) >> 2], Ne = o[ye >> 2] + Mi | 0, E = o[ye + 4 >> 2] + o[E + 4 >> 2] | 0, ye = Tn + (Ne >>> 0 < Mi >>> 0 ? E + 1 | 0 : E) | 0, ye = (E = Ne + gr | 0) >>> 0 < gr >>> 0 ? ye + 1 | 0 : ye, Ne = (gr = jr ^ (ve ^ jr) & Tr) + E | 0, E = (li ^ (ti ^ li) & Br) + ye | 0, E = Ne >>> 0 < gr >>> 0 ? E + 1 | 0 : E, ye = Ci(Tr, Br, 50), gr = Qe, ye = Ci(Tr, Br, 46) ^ ye, gr ^= Qe, Mi = Ci(Tr, Br, 23) ^ ye, ye = (Qe ^ gr) + E | 0, Wi = ye = (Ne = Mi + Ne | 0) >>> 0 < Mi >>> 0 ? ye + 1 | 0 : ye, E = ye, ye = Ci(vn, cr, 36), gr = Qe, ye = Ci(vn, cr, 30) ^ ye, Mi = Qe ^ gr, Tn = Ci(vn, cr, 25) ^ ye, ye = ((Pr | Mr) & cr | Pr & Mr) + (Qe ^ Mi) | 0, E = ((gr = Tn + ((pr | fi) & vn | pr & fi) | 0) >>> 0 < Tn >>> 0 ? ye + 1 | 0 : ye) + E | 0, gr = E = (Mi = Ne + gr | 0) >>> 0 < gr >>> 0 ? E + 1 | 0 : E, o[M + 16 >> 2] = Mi, o[M + 20 >> 2] = E, E = Nr + Wi | 0, Nr = E = (Jr = Ne + Jr | 0) >>> 0 < Ne >>> 0 ? E + 1 | 0 : E, o[M + 48 >> 2] = Jr, o[M + 52 >> 2] = E, ye = 34416 + (E = 112 | Yi) | 0, Wi = o[(Ne = Tn = E + T | 0) >> 2], E = o[ye >> 2] + Wi | 0, ye = o[ye + 4 >> 2] + o[Ne + 4 >> 2] | 0, ye = li + (E >>> 0 < Wi >>> 0 ? ye + 1 | 0 : ye) | 0, ye = (ti ^ (Br ^ ti) & Nr) + (ye = (E = E + jr | 0) >>> 0 < jr >>> 0 ? ye + 1 | 0 : ye) | 0, ye = (E = (Ne = ve ^ (ve ^ Tr) & Jr) + E | 0) >>> 0 < Ne >>> 0 ? ye + 1 | 0 : ye, Ne = Ci(Jr, Nr, 50), jr = Qe, Ne = Ci(Jr, Nr, 46) ^ Ne, jr ^= Qe, Ne = (li = Ci(Jr, Nr, 23) ^ Ne) + E | 0, E = (Qe ^ jr) + ye | 0, Wi = E = Ne >>> 0 < li >>> 0 ? E + 1 | 0 : E, ye = E, E = Ci(Mi, gr, 36), jr = Qe, E = Ci(Mi, gr, 30) ^ E, li = Qe ^ jr, Ln = Ci(Mi, gr, 25) ^ E, E = ((cr | Mr) & gr | cr & Mr) + (Qe ^ li) | 0, ye = ((jr = Ln + ((pr | vn) & Mi | pr & vn) | 0) >>> 0 < Ln >>> 0 ? E + 1 | 0 : E) + ye | 0, jr = ye = (li = Ne + jr | 0) >>> 0 < jr >>> 0 ? ye + 1 | 0 : ye, o[M + 8 >> 2] = li, o[M + 12 >> 2] = ye, ye = Pr + Wi | 0, Ne = ye = (Pr = Ne + fi | 0) >>> 0 < Ne >>> 0 ? ye + 1 | 0 : ye, o[M + 40 >> 2] = Pr, o[M + 44 >> 2] = ye, ye = 34416 + (E = 120 | Yi) | 0, Yi = o[(E = fi = E + T | 0) >> 2], Wi = o[ye >> 2] + Yi | 0, ye = o[ye + 4 >> 2] + o[E + 4 >> 2] | 0, E = ti + (Wi >>> 0 < Yi >>> 0 ? ye + 1 | 0 : ye) | 0, E = (Br ^ (Br ^ Nr) & Ne) + (E = (ye = ve + Wi | 0) >>> 0 < ve >>> 0 ? E + 1 | 0 : E) | 0, E = (ye = (ve = Tr ^ (Jr ^ Tr) & Pr) + ye | 0) >>> 0 < ve >>> 0 ? E + 1 | 0 : E, ve = Ci(Pr, Ne, 50), Br = Qe, ve = Ci(Pr, Ne, 46) ^ ve, Br ^= Qe, Ne = (ve = Ci(Pr, Ne, 23) ^ ve) + ye | 0, ye = (Qe ^ Br) + E | 0, ye = Ne >>> 0 < ve >>> 0 ? ye + 1 | 0 : ye, ve = Ne, Br = ye, E = ye, ye = Ci(li, jr, 36), Pr = Qe, ye = Ci(li, jr, 30) ^ ye, Nr = Qe ^ Pr, ti = Ci(li, jr, 25) ^ ye, ye = ((cr | gr) & jr | cr & gr) + (Qe ^ Nr) | 0, E = ((Pr = ti + ((Mi | vn) & li | Mi & vn) | 0) >>> 0 < ti >>> 0 ? ye + 1 | 0 : ye) + E | 0, E = (Ne = Ne + Pr | 0) >>> 0 < Pr >>> 0 ? E + 1 | 0 : E, o[M >> 2] = Ne, o[M + 4 >> 2] = E, ye = Br + Mr | 0, ye = (Nr = pr) >>> 0 > (pr = pr + ve | 0) >>> 0 ? ye + 1 | 0 : ye, o[M + 32 >> 2] = pr, o[M + 36 >> 2] = ye, (0 | Qo) != 64; ) gr = ((Qo = Qo + 16 | 0) << 3) + T | 0, ve = o[Ni >> 2], cr = o[Ni + 4 >> 2], Ln = o[Zn >> 2], Br = E = o[Zn + 4 >> 2], ye = E, Ne = E = o[Tn + 4 >> 2], E = Ci(vn = o[Tn >> 2], E, 45), pr = Qe, Nr = ((63 & Ne) << 26 | vn >>> 6) ^ (E = Ci(vn, Ne, 3) ^ E), E = (Ne >>> 6 ^ (Pr = Qe ^ pr)) + ye | 0, ye = ((pr = Nr + Ln | 0) >>> 0 < Nr >>> 0 ? E + 1 | 0 : E) + cr | 0, ye = (E = pr + ve | 0) >>> 0 < pr >>> 0 ? ye + 1 | 0 : ye, ve = pr = o[qn + 4 >> 2], pr = Ci(cr = o[qn >> 2], pr, 63), Pr = Qe, pr = ((127 & ve) << 25 | cr >>> 7) ^ Ci(cr, ve, 56) ^ pr, ye = (Qe ^ Pr ^ ve >>> 7) + ye | 0, pr = ye = pr >>> 0 > (Mi = pr + E | 0) >>> 0 ? ye + 1 | 0 : ye, o[gr >> 2] = Mi, o[gr + 4 >> 2] = ye, cr = (Tn = o[$n >> 2]) + cr | 0, E = (gr = o[$n + 4 >> 2]) + ve | 0, ye = cr >>> 0 < Tn >>> 0 ? E + 1 | 0 : E, ve = E = o[fi + 4 >> 2], E = Ci(Wi = o[fi >> 2], E, 45), Pr = Qe, Nr = cr, cr = ((63 & ve) << 26 | Wi >>> 6) ^ Ci(Wi, ve, 3) ^ E, ye = (Qe ^ Pr ^ ve >>> 6) + ye | 0, cr = cr >>> 0 > (Nr = Nr + cr | 0) >>> 0 ? ye + 1 | 0 : ye, ye = Ci(Pr = o[fo >> 2], E = o[fo + 4 >> 2], 63), ti = Qe, jr = Nr, Nr = ((127 & E) << 25 | Pr >>> 7) ^ Ci(Pr, E, 56) ^ ye, ye = (Qe ^ ti ^ E >>> 7) + cr | 0, cr = ye = Nr >>> 0 > (li = jr + Nr | 0) >>> 0 ? ye + 1 | 0 : ye, o[Ni + 136 >> 2] = li, o[Ni + 140 >> 2] = ye, ye = ($n = o[Xi >> 2]) + Pr | 0, E = (Pr = o[Xi + 4 >> 2]) + E | 0, Nr = Ci(Mi, pr, 45), ti = Qe, Nr = (Mr = ((63 & pr) << 26 | Mi >>> 6) ^ Ci(Mi, pr, 3) ^ Nr) + ye | 0, ye = (Qe ^ ti ^ pr >>> 6) + (ye >>> 0 < $n >>> 0 ? E + 1 | 0 : E) | 0, ye = Nr >>> 0 < Mr >>> 0 ? ye + 1 | 0 : ye, ti = E = o[io + 4 >> 2], E = Ci(Mr = o[io >> 2], E, 63), Tr = Qe, jr = Nr, Nr = ((127 & ti) << 25 | Mr >>> 7) ^ Ci(Mr, ti, 56) ^ E, ye = (Qe ^ Tr ^ ti >>> 7) + ye | 0, Nr = ye = Nr >>> 0 > (Yi = jr + Nr | 0) >>> 0 ? ye + 1 | 0 : ye, o[Ni + 144 >> 2] = Yi, o[Ni + 148 >> 2] = ye, Mr = (qn = o[qo >> 2]) + Mr | 0, E = (E = ti) + (ti = o[qo + 4 >> 2]) | 0, ye = Mr >>> 0 < qn >>> 0 ? E + 1 | 0 : E, E = Ci(li, cr, 45), Tr = Qe, Jr = ((63 & cr) << 26 | li >>> 6) ^ Ci(li, cr, 3) ^ E, ye = (Qe ^ Tr ^ cr >>> 6) + ye | 0, ye = (Mr = Jr + Mr | 0) >>> 0 < Jr >>> 0 ? ye + 1 | 0 : ye, Tr = E = o[go + 4 >> 2], E = Ci(Jr = o[go >> 2], E, 63), fi = Qe, jr = Mr, Mr = ((127 & Tr) << 25 | Jr >>> 7) ^ Ci(Jr, Tr, 56) ^ E, ye = (Qe ^ fi ^ Tr >>> 7) + ye | 0, Mr = ye = Mr >>> 0 > (fo = jr + Mr | 0) >>> 0 ? ye + 1 | 0 : ye, o[Ni + 152 >> 2] = fo, o[Ni + 156 >> 2] = ye, E = (io = o[ro >> 2]) + Jr | 0, ye = (ye = Tr) + (Tr = o[ro + 4 >> 2]) | 0, Jr = Ci(Yi, Nr, 45), fi = Qe, Jr = ((63 & Nr) << 26 | Yi >>> 6) ^ Ci(Yi, Nr, 3) ^ Jr, ye = (Qe ^ fi ^ Nr >>> 6) + (E >>> 0 < io >>> 0 ? ye + 1 | 0 : ye) | 0, Jr = (jr = Jr + E | 0) >>> 0 < Jr >>> 0 ? ye + 1 | 0 : ye, ye = Ci(fi = o[wo >> 2], E = o[wo + 4 >> 2], 63), go = Qe, Xi = jr, jr = ((127 & E) << 25 | fi >>> 7) ^ (ye = Ci(fi, E, 56) ^ ye), ye = (E >>> 7 ^ (wo = Qe ^ go)) + Jr | 0, Jr = ye = jr >>> 0 > (go = Xi + jr | 0) >>> 0 ? ye + 1 | 0 : ye, o[Ni + 160 >> 2] = go, o[Ni + 164 >> 2] = ye, E = E + Ne | 0, E = (ye = fi + vn | 0) >>> 0 < fi >>> 0 ? E + 1 | 0 : E, fi = Ci(fo, Mr, 45), jr = Qe, fi = (wo = ((63 & Mr) << 26 | fo >>> 6) ^ Ci(fo, Mr, 3) ^ fi) + ye | 0, ye = (Qe ^ jr ^ Mr >>> 6) + E | 0, ye = fi >>> 0 < wo >>> 0 ? ye + 1 | 0 : ye, jr = o[to >> 2], to = E = o[to + 4 >> 2], E = Ci(jr, E, 63), wo = Qe, E = Ci(jr, to, 56) ^ E, Xi = fi, ye = (to >>> 7 ^ (Zn = Qe ^ wo)) + ye | 0, fi = ye = (fi = ((127 & to) << 25 | jr >>> 7) ^ E) >>> 0 > (wo = Xi + fi | 0) >>> 0 ? ye + 1 | 0 : ye, o[Ni + 168 >> 2] = wo, o[Ni + 172 >> 2] = ye, E = ve + to | 0, E = (ye = jr + Wi | 0) >>> 0 < jr >>> 0 ? E + 1 | 0 : E, Xi = jr = o[bo + 4 >> 2], jr = Ci(Zn = o[bo >> 2], jr, 63), to = Qe, jr = (bo = ((127 & Xi) << 25 | Zn >>> 7) ^ Ci(Zn, Xi, 56) ^ jr) + ye | 0, ye = (Qe ^ to ^ Xi >>> 7) + E | 0, E = jr >>> 0 < bo >>> 0 ? ye + 1 | 0 : ye, ye = Ci(go, Jr, 45), to = Qe, ye = Ci(go, Jr, 3) ^ ye, bo = Qe ^ to, to = jr, E = (Jr >>> 6 ^ bo) + E | 0, jr = E = (jr = ((63 & Jr) << 26 | go >>> 6) ^ ye) >>> 0 > (to = to + jr | 0) >>> 0 ? E + 1 | 0 : E, o[Ni + 176 >> 2] = to, o[Ni + 180 >> 2] = E, qo = o[So >> 2], So = E = o[So + 4 >> 2], bo = E, E = Ci(Ln, Br, 63), ye = Qe, ro = ((127 & Br) << 25 | Ln >>> 7) ^ Ci(Ln, Br, 56) ^ E, E = (Qe ^ ye ^ Br >>> 7) + cr | 0, ye = ((li = ro + li | 0) >>> 0 < ro >>> 0 ? E + 1 | 0 : E) + bo | 0, ye = (E = li + qo | 0) >>> 0 < li >>> 0 ? ye + 1 | 0 : ye, cr = Ci(to, jr, 45), li = Qe, bo = (cr = ((63 & jr) << 26 | to >>> 6) ^ Ci(to, jr, 3) ^ cr) + E | 0, E = (Qe ^ li ^ jr >>> 6) + ye | 0, cr = E = cr >>> 0 > bo >>> 0 ? E + 1 | 0 : E, o[Ni + 192 >> 2] = bo, o[Ni + 196 >> 2] = E, ye = pr + Xi | 0, ye = (E = Mi + Zn | 0) >>> 0 < Zn >>> 0 ? ye + 1 | 0 : ye, li = Ci(qo, So, 63), Zn = Qe, Xi = ((127 & So) << 25 | qo >>> 7) ^ Ci(qo, So, 56) ^ li, ye = (Qe ^ Zn ^ So >>> 7) + ye | 0, E = (li = Xi + E | 0) >>> 0 < Xi >>> 0 ? ye + 1 | 0 : ye, ye = Ci(wo, fi, 45), Zn = Qe, ye = Ci(wo, fi, 3) ^ ye, So = li, E = (fi >>> 6 ^ (Xi = Qe ^ Zn)) + E | 0, li = E = (li = ((63 & fi) << 26 | wo >>> 6) ^ ye) >>> 0 > (Zn = So + li | 0) >>> 0 ? E + 1 | 0 : E, o[Ni + 184 >> 2] = Zn, o[Ni + 188 >> 2] = E, E = Ci($n, Pr, 63), ye = Qe, E = ((127 & Pr) << 25 | $n >>> 7) ^ Ci($n, Pr, 56) ^ E, ye = (Qe ^ ye ^ Pr >>> 7) + gr | 0, E = Mr + (E >>> 0 > (Xi = E + Tn | 0) >>> 0 ? ye + 1 | 0 : ye) | 0, E = (ye = fo + Xi | 0) >>> 0 < fo >>> 0 ? E + 1 | 0 : E, Mr = Ci(bo, cr, 45), fo = Qe, Mr = Ci(bo, cr, 3) ^ Mr, Xi = Qe ^ fo, fo = (Mr ^= (63 & cr) << 26 | bo >>> 6) + ye | 0, ye = (cr >>> 6 ^ Xi) + E | 0, Mr = ye = Mr >>> 0 > fo >>> 0 ? ye + 1 | 0 : ye, o[Ni + 208 >> 2] = fo, o[Ni + 212 >> 2] = ye, E = Ci(Tn, gr, 63), ye = Qe, Xi = Ci(Tn, gr, 56) ^ E, ye = ((E = gr >>> 7 | 0) ^ Qe ^ ye) + Br | 0, E = Nr + ((gr = (Tn = Xi ^ ((127 & gr) << 25 | Tn >>> 7)) + Ln | 0) >>> 0 < Tn >>> 0 ? ye + 1 | 0 : ye) | 0, E = (ye = gr + Yi | 0) >>> 0 < Yi >>> 0 ? E + 1 | 0 : E, Br = Ci(Zn, li, 45), gr = Qe, Nr = (Br = ((63 & li) << 26 | Zn >>> 6) ^ Ci(Zn, li, 3) ^ Br) + ye | 0, ye = (Qe ^ gr ^ li >>> 6) + E | 0, Br = ye = Br >>> 0 > Nr >>> 0 ? ye + 1 | 0 : ye, o[Ni + 200 >> 2] = Nr, o[Ni + 204 >> 2] = ye, E = Ci(io, Tr, 63), ye = Qe, Tn = ((127 & Tr) << 25 | io >>> 7) ^ Ci(io, Tr, 56) ^ E, E = (Qe ^ ye ^ Tr >>> 7) + ti | 0, ye = fi + ((gr = Tn + qn | 0) >>> 0 < Tn >>> 0 ? E + 1 | 0 : E) | 0, ye = (E = gr + wo | 0) >>> 0 < wo >>> 0 ? ye + 1 | 0 : ye, gr = Ci(fo, Mr, 45), fi = Qe, Tn = E, E = Mr >>> 6 | 0, gr = ((63 & Mr) << 26 | fo >>> 6) ^ Ci(fo, Mr, 3) ^ gr, ye = (E ^ Qe ^ fi) + ye | 0, gr = ye = gr >>> 0 > (Mr = Tn + gr | 0) >>> 0 ? ye + 1 | 0 : ye, o[Ni + 224 >> 2] = Mr, o[Ni + 228 >> 2] = ye, E = Ci(qn, ti, 63), ye = Qe, E = Ci(qn, ti, 56) ^ E, fi = Qe ^ ye, Tn = ((127 & ti) << 25 | qn >>> 7) ^ E, E = ((ye = ti >>> 7 | 0) ^ fi) + Pr | 0, ye = Jr + ((ti = Tn + $n | 0) >>> 0 < Tn >>> 0 ? E + 1 | 0 : E) | 0, ye = (E = ti + go | 0) >>> 0 < go >>> 0 ? ye + 1 | 0 : ye, Pr = Ci(Nr, Br, 45), ti = Qe, fi = E, E = Br >>> 6 | 0, Br = ((63 & Br) << 26 | Nr >>> 6) ^ Ci(Nr, Br, 3) ^ Pr, E = (E ^ Qe ^ ti) + ye | 0, Br = E = (Pr = fi + Br | 0) >>> 0 < Br >>> 0 ? E + 1 | 0 : E, o[Ni + 216 >> 2] = Pr, o[Ni + 220 >> 2] = E, E = Ci(Wi, ve, 63), ye = Qe, ti = ((127 & ve) << 25 | Wi >>> 7) ^ Ci(Wi, ve, 56) ^ E, ye = (Qe ^ ye ^ ve >>> 7) + Ne | 0, ye = li + ((E = ti + vn | 0) >>> 0 < ti >>> 0 ? ye + 1 | 0 : ye) | 0, E = (Nr = E + Zn | 0) >>> 0 < Zn >>> 0 ? ye + 1 | 0 : ye, ye = Ci(Mr, gr, 45), ti = Qe, fi = Nr, Nr = Ci(Mr, gr, 3) ^ ye, ye = gr >>> 6 | 0, gr = fi + (Nr ^= (63 & gr) << 26 | Mr >>> 6) | 0, E = (ye ^ Qe ^ ti) + E | 0, o[Ni + 240 >> 2] = gr, o[Ni + 244 >> 2] = gr >>> 0 < Nr >>> 0 ? E + 1 | 0 : E, E = Ci(vn, Ne, 63), ye = Qe, E = Ci(vn, Ne, 56) ^ E, gr = Qe ^ ye, ye = ((ye = Ne >>> 7 | 0) ^ gr) + Tr | 0, E = jr + ((E ^= (127 & Ne) << 25 | vn >>> 7) >>> 0 > (Ne = E + io | 0) >>> 0 ? ye + 1 | 0 : ye) | 0, E = (ye = Ne + to | 0) >>> 0 < to >>> 0 ? E + 1 | 0 : E, Ne = Ci(Pr, Br, 45), gr = Qe, Nr = ye, ye = Br >>> 6 | 0, Ne = ((63 & Br) << 26 | Pr >>> 6) ^ Ci(Pr, Br, 3) ^ Ne, ye = (ye ^ Qe ^ gr) + E | 0, Ne = ye = Ne >>> 0 > (Br = Nr + Ne | 0) >>> 0 ? ye + 1 | 0 : ye, o[Ni + 232 >> 2] = Br, o[Ni + 236 >> 2] = ye, E = Ci(Mi, pr, 63), ye = Qe, Nr = Ci(Mi, pr, 56) ^ E, ye = ((E = pr >>> 7 | 0) ^ Qe ^ ye) + ve | 0, E = cr + ((pr = (gr = Nr ^ ((127 & pr) << 25 | Mi >>> 7)) + Wi | 0) >>> 0 < gr >>> 0 ? ye + 1 | 0 : ye) | 0, E = (ye = pr + bo | 0) >>> 0 < bo >>> 0 ? E + 1 | 0 : E, pr = Ci(Br, Ne, 45), ve = Qe, Nr = ye, ye = Ne >>> 6 | 0, Ne = Nr + (pr = ((63 & Ne) << 26 | Br >>> 6) ^ Ci(Br, Ne, 3) ^ pr) | 0, ye = (ye ^ Qe ^ ve) + E | 0, o[Ni + 248 >> 2] = Ne, o[Ni + 252 >> 2] = Ne >>> 0 < pr >>> 0 ? ye + 1 | 0 : ye;
                      E = E + o[k + 4 >> 2] | 0, E = (T = Ne + o[k >> 2] | 0) >>> 0 < Ne >>> 0 ? E + 1 | 0 : E, o[k >> 2] = T, o[k + 4 >> 2] = E, ye = o[k + 12 >> 2] + o[M + 12 >> 2] | 0, E = (T = o[M + 8 >> 2]) + o[k + 8 >> 2] | 0, o[k + 8 >> 2] = E, o[k + 12 >> 2] = E >>> 0 < T >>> 0 ? ye + 1 | 0 : ye, ye = o[k + 20 >> 2] + o[M + 20 >> 2] | 0, E = (T = o[M + 16 >> 2]) + o[k + 16 >> 2] | 0, o[k + 16 >> 2] = E, o[k + 20 >> 2] = E >>> 0 < T >>> 0 ? ye + 1 | 0 : ye, E = o[k + 28 >> 2] + o[M + 28 >> 2] | 0, T = (ye = o[M + 24 >> 2]) + o[k + 24 >> 2] | 0, o[k + 24 >> 2] = T, o[k + 28 >> 2] = T >>> 0 < ye >>> 0 ? E + 1 | 0 : E, ye = o[k + 36 >> 2] + o[M + 36 >> 2] | 0, E = (T = o[M + 32 >> 2]) + o[k + 32 >> 2] | 0, o[k + 32 >> 2] = E, o[k + 36 >> 2] = E >>> 0 < T >>> 0 ? ye + 1 | 0 : ye, E = o[k + 44 >> 2] + o[M + 44 >> 2] | 0, T = (ye = o[M + 40 >> 2]) + o[k + 40 >> 2] | 0, o[k + 40 >> 2] = T, o[k + 44 >> 2] = T >>> 0 < ye >>> 0 ? E + 1 | 0 : E, ye = o[k + 52 >> 2] + o[M + 52 >> 2] | 0, E = (T = o[M + 48 >> 2]) + o[k + 48 >> 2] | 0, o[k + 48 >> 2] = E, o[k + 52 >> 2] = E >>> 0 < T >>> 0 ? ye + 1 | 0 : ye, ye = o[k + 60 >> 2] + o[M + 60 >> 2] | 0, E = (T = o[M + 56 >> 2]) + o[k + 56 >> 2] | 0, o[k + 56 >> 2] = E, o[k + 60 >> 2] = E >>> 0 < T >>> 0 ? ye + 1 | 0 : ye;
                    }
                    function mi(k, E) {
                      var T, M = 0, ye = 0, Ne = 0, pr = 0, ve = 0, cr = 0, gr = 0, Pr = 0, Nr = 0, Br = 0, Mr = 0, jr = 0, ti = 0, fi = 0, Jr = 0, li = 0, Tr = 0, Mi = 0, Wi = 0, vn = 0, Tn = 0, Ni = 0, Yi = 0, Xi = 0, $n = 0, Zn = 0, to = 0, fo = 0, wo = 0, bo = 0, go = 0, qn = 0, io = 0, So = 0, qo = 0, Ln = 0, ro = 0, Qo = 0, Vo = 0, as = 0, cs = 0, ms = 0, ai = 0, ci = 0, Fi = 0, Eo = 0, is = 0, ws = 0, ys = 0, Is = 0, ks = 0, Ps = 0, Po = 0, fn = 0, Qn = 0, zn = 0, es = 0, us = 0;
                      if (dr = T = dr - 4096 | 0, k) {
                        e: {
                          t: {
                            if ((0 | (pr = o[k + 36 >> 2])) == 2) {
                              if (Is = o[k + 4 >> 2], (ci = o[E >> 2]) | (Vo = m[E + 8 | 0]) >>> 0 >= 2) break t;
                              ci = 0;
                            } else Vo = m[E + 8 | 0], Is = o[k + 4 >> 2], ci = o[E >> 2];
                            if (Ca(T + 3072 | 0, 0, 1024), Ca(T + 2104 | 0, 0, 968), o[T + 2048 >> 2] = ci, o[T + 2052 >> 2] = 0, to = o[E + 4 >> 2], o[T + 2064 >> 2] = Vo, o[T + 2068 >> 2] = 0, o[T + 2056 >> 2] = to, o[T + 2060 >> 2] = 0, o[T + 2072 >> 2] = o[k + 16 >> 2], o[T + 2076 >> 2] = 0, to = o[k + 8 >> 2], o[T + 2088 >> 2] = pr, o[T + 2092 >> 2] = 0, o[T + 2080 >> 2] = to, o[T + 2084 >> 2] = 0, !o[k + 20 >> 2]) break e;
                            for (to = 0; (Jr = 127 & gr) || (to = (So = So + 1 | 0) ? to : to + 1 | 0, o[T + 2096 >> 2] = So, o[T + 2100 >> 2] = to, pr = Ca(T, 0, 1024), Ca(pr + 1024 | 0, 0, 1024), Oi(M = pr + 3072 | 0, pr + 2048 | 0, pr), Oi(M, pr, pr + 1024 | 0)), Jr = o[4 + (pr = (T + 1024 | 0) + (Jr << 3) | 0) >> 2], o[(M = (gr << 3) + Is | 0) >> 2] = o[pr >> 2], o[M + 4 >> 2] = Jr, (Jr = o[k + 20 >> 2]) >>> 0 > (gr = gr + 1 | 0) >>> 0; ) ;
                            break e;
                          }
                          Jr = o[k + 20 >> 2], fn = 1;
                        }
                        if (!((to = (Ps = !(Vo | ci)) << 1) >>> 0 >= Jr >>> 0)) for (pr = o[k + 24 >> 2], ys = o[E + 4 >> 2], gr = (So = (v(pr, ys) + to | 0) + v(Jr, Vo) | 0) + ((So >>> 0) % (pr >>> 0) | 0 ? -1 : pr - 1 | 0) | 0, Qn = Vo + 1 | 0; ; ) {
                          M = o[k + 28 >> 2], ks = ((So >>> 0) % ((pr = o[k + 24 >> 2]) >>> 0) | 0) == 1 ? So - 1 | 0 : gr, gr = fn ? o[o[k >> 2] + 4 >> 2] + (ks << 10) | 0 : (to << 3) + Is | 0, ye = o[gr >> 2], gr = o[gr + 4 >> 2], o[E + 12 >> 2] = to, M = Ps ? ys : (gr >>> 0) % (M >>> 0) | 0;
                          e: if (ci) gr = pr + ((0 | M) == (0 | ys) ? ~Jr + to | 0 : (to ? 0 : -1) - Jr | 0) | 0, Ne = 0, (0 | Vo) != 3 && (Ne = v(Jr, Qn));
                          else {
                            if (!Vo) {
                              gr = to - 1 | 0, Ne = 0;
                              break e;
                            }
                            if (gr = v(Jr, Vo), (0 | M) == (0 | ys)) {
                              gr = (gr + to | 0) - 1 | 0, Ne = 0;
                              break e;
                            }
                            gr = gr - !to | 0, Ne = 0;
                          }
                          Jr = Ne, ve = (Br = o[o[k >> 2] + 4 >> 2]) + (v(M, pr) << 10) | 0, Nr = (M = gr - 1 | 0) >>> 0 > (Ne = M + Jr | 0) >>> 0, Zr(ye, 0, ye, 0), Zr(gr, 0, Qe, 0), Jr = Ne - (gr = Qe) | 0, M = 0, Pr = 0;
                          e: {
                            t: {
                              r: {
                                i: {
                                  n: {
                                    o: {
                                      a: {
                                        s: {
                                          A: {
                                            u: {
                                              if (gr = Nr - (Ne >>> 0 < gr >>> 0) | 0) {
                                                if (!pr) break u;
                                                break A;
                                              }
                                              Dr = Jr - v((Jr >>> 0) / (pr >>> 0) | 0, pr) | 0, Rr = 0, Qe = 0;
                                              break e;
                                            }
                                            if (!Jr) break s;
                                            break a;
                                          }
                                          if (!((ye = pr - 1 | 0) & pr)) break o;
                                          cr = 0 - (ye = (he(pr) + 33 | 0) - he(gr) | 0) | 0;
                                          break i;
                                        }
                                        Dr = 0, Rr = gr, Qe = 0;
                                        break e;
                                      }
                                      if ((M = 32 - he(gr) | 0) >>> 0 < 31) break n;
                                      break r;
                                    }
                                    if (Dr = ye & Jr, Rr = 0, (0 | pr) == 1) break t;
                                    pr = 31 & (Jr = pA(pr)), (63 & Jr) >>> 0 >= 32 ? ye = gr >>> pr | 0 : (M = gr >>> pr | 0, ye = 0), Qe = M;
                                    break e;
                                  }
                                  ye = M + 1 | 0, cr = 63 - M | 0;
                                }
                                if (Ne = 31 & (M = 63 & ye), M >>> 0 >= 32 ? (M = 0, Nr = gr >>> Ne | 0) : (M = gr >>> Ne | 0, Nr = ((1 << Ne) - 1 & gr) << 32 - Ne | Jr >>> Ne), Ne = 31 & (cr &= 63), cr >>> 0 >= 32 ? (gr = Jr << Ne, Jr = 0) : (gr = (1 << Ne) - 1 & Jr >>> 32 - Ne | gr << Ne, Jr <<= Ne), ye) for (fi = (0 | (cr = pr - 1 | 0)) == -1 ? -1 : 0; Xi = M << 1 | Nr >>> 31, Nr = (M = Nr << 1 | gr >>> 31) - (vn = pr & (Ne = fi - (Xi + (M >>> 0 > cr >>> 0) | 0) >> 31)) | 0, M = Xi - (M >>> 0 < vn >>> 0) | 0, gr = gr << 1 | Jr >>> 31, Jr = Pr | Jr << 1, Pr = 1 & Ne, ye = ye - 1 | 0; ) ;
                                Dr = Nr, Rr = M, Qe = gr << 1 | Jr >>> 31;
                                break e;
                              }
                              Dr = Jr, Rr = gr, gr = 0;
                            }
                            Qe = gr;
                          }
                          if (Qe = Rr, gr = (Dr << 10) + ve | 0, pr = Br + (ks << 10) | 0, Po = Br + (So << 10) | 0, ci) Oi(pr, gr, Po);
                          else {
                            for (fa(T + 3072 | 0, gr, 1024), gr = 0; Ne = o[(ye = (Jr = gr << 3) + (M = T + 3072 | 0) | 0) >> 2], Br = o[(Nr = pr + Jr | 0) >> 2], Nr = o[ye + 4 >> 2] ^ o[Nr + 4 >> 2], o[ye >> 2] = Ne ^ Br, o[ye + 4 >> 2] = Nr, Nr = o[(ye = (Ne = 8 | Jr) + M | 0) >> 2], Br = o[(Ne = pr + Ne | 0) >> 2], Ne = o[ye + 4 >> 2] ^ o[Ne + 4 >> 2], o[ye >> 2] = Nr ^ Br, o[ye + 4 >> 2] = Ne, Nr = o[(ye = (Ne = 16 | Jr) + M | 0) >> 2], Br = o[(Ne = pr + Ne | 0) >> 2], Ne = o[ye + 4 >> 2] ^ o[Ne + 4 >> 2], o[ye >> 2] = Nr ^ Br, o[ye + 4 >> 2] = Ne, Ne = o[(Jr = (ye = 24 | Jr) + M | 0) >> 2], Nr = o[(ye = ye + pr | 0) >> 2], ye = o[Jr + 4 >> 2] ^ o[ye + 4 >> 2], o[Jr >> 2] = Ne ^ Nr, o[Jr + 4 >> 2] = ye, (0 | (gr = gr + 4 | 0)) != 128; ) ;
                            for (fa(T + 2048 | 0, M, 1024), Jr = 0, gr = 0; Ne = (Nr = o[56 + (pr = (T + 3072 | 0) + (gr << 7) | 0) >> 2]) + (ye = o[pr + 24 >> 2]) | 0, Br = (fi = o[pr + 60 >> 2]) + (M = o[pr + 28 >> 2]) | 0, Pr = Zr(ye << 1 & -2, 1 & (M << 1 | ye >>> 31), Nr, 0), ye = Qe + (ye >>> 0 > Ne >>> 0 ? Br + 1 | 0 : Br) | 0, Br = (M = Pr + Ne | 0) >>> 0 < Pr >>> 0 ? ye + 1 | 0 : ye, ve = (Pr = Ci(M ^ o[pr + 120 >> 2], Br ^ o[pr + 124 >> 2], 32)) + (ye = o[pr + 88 >> 2]) | 0, cr = (ti = Qe) + (Ne = o[pr + 92 >> 2]) | 0, Xi = Zr(Pr, 0, ye << 1 & -2, 1 & (Ne << 1 | ye >>> 31)), ye = Qe + (ye >>> 0 > ve >>> 0 ? cr + 1 | 0 : cr) | 0, vn = Ci(Nr ^ (Ne = Xi + ve | 0), fi ^ (wo = Ne >>> 0 < Xi >>> 0 ? ye + 1 | 0 : ye), 40), Mr = 1 + (ye = Br + (is = Qe) | 0) | 0, cr = ye, Nr = (ye = M + vn | 0) >>> 0 < M >>> 0 ? Mr : cr, Xi = (M = Zr(vn, 0, M << 1 & -2, 1 & (Br << 1 | M >>> 31))) + ye | 0, ye = Qe + Nr | 0, ti = Ci(Xi ^ Pr, ti ^ (Ln = M >>> 0 > Xi >>> 0 ? ye + 1 | 0 : ye), 48), Ni = Mr = Qe, Nr = (jr = o[pr + 44 >> 2]) + (M = o[pr + 12 >> 2]) | 0, Pr = (Br = o[pr + 40 >> 2]) + (ye = o[pr + 8 >> 2]) | 0, ve = Zr(ye << 1 & -2, 1 & (M << 1 | ye >>> 31), Br, 0), ye = Qe + (ye >>> 0 > Pr >>> 0 ? Nr + 1 | 0 : Nr) | 0, ve = (M = Pr + ve | 0) >>> 0 < ve >>> 0 ? ye + 1 | 0 : ye, Pr = (cr = Ci(M ^ o[pr + 104 >> 2], ve ^ o[pr + 108 >> 2], 32)) + (Nr = o[pr + 72 >> 2]) | 0, fi = (Tr = Qe) + (ye = o[pr + 76 >> 2]) | 0, li = Zr(cr, 0, Nr << 1 & -2, 1 & (ye << 1 | Nr >>> 31)), Nr = Qe + (Pr >>> 0 < Nr >>> 0 ? fi + 1 | 0 : fi) | 0, Pr = Ci(Tn = Br ^ (ye = li + Pr | 0), jr ^ (Br = ye >>> 0 < li >>> 0 ? Nr + 1 | 0 : Nr), 40), li = 1 + (Nr = ve + (fi = Qe) | 0) | 0, jr = Nr, jr = (Nr = M + Pr | 0) >>> 0 < M >>> 0 ? li : jr, M = Zr(Pr, 0, M << 1 & -2, 1 & (ve << 1 | M >>> 31)), ve = Qe + jr | 0, jr = Ci((Nr = M + Nr | 0) ^ cr, Tr ^ (ro = M >>> 0 > Nr >>> 0 ? ve + 1 | 0 : ve), 48), li = 1 + (M = Br + (ws = Qe) | 0) | 0, cr = M, ve = (M = ye + jr | 0) >>> 0 < ye >>> 0 ? li : cr, Br = M + (ye = Zr(jr, 0, ye << 1 & -2, 1 & (Br << 1 | ye >>> 31))) | 0, M = Qe + ve | 0, Tr = Ci(Pr ^ Br, fi ^ (as = ye >>> 0 > Br >>> 0 ? M + 1 | 0 : M), 1), Fi = Tn = Qe, Pr = (Yi = o[pr + 36 >> 2]) + (M = o[pr + 4 >> 2]) | 0, cr = (ve = o[pr + 32 >> 2]) + (ye = o[pr >> 2]) | 0, fi = Zr(ye << 1 & -2, 1 & (M << 1 | ye >>> 31), ve, 0), ye = Qe + (ye >>> 0 > cr >>> 0 ? Pr + 1 | 0 : Pr) | 0, cr = (M = cr + fi | 0) >>> 0 < fi >>> 0 ? ye + 1 | 0 : ye, fi = (io = Ci(M ^ o[pr + 96 >> 2], cr ^ o[pr + 100 >> 2], 32)) + (ye = o[(Pr = qo = pr - -64 | 0) >> 2]) | 0, li = (ms = Qe) + (Pr = o[Pr + 4 >> 2]) | 0, bo = Zr(io, 0, ye << 1 & -2, 1 & (Pr << 1 | ye >>> 31)), ye = Qe + (ye >>> 0 > fi >>> 0 ? li + 1 | 0 : li) | 0, li = Ci(ve ^ (Pr = bo + fi | 0), Yi ^ (bo = Pr >>> 0 < bo >>> 0 ? ye + 1 | 0 : ye), 40), fi = 1 + (ye = cr + (ai = Qe) | 0) | 0, ve = ye, ve = (ye = M + li | 0) >>> 0 < M >>> 0 ? fi : ve, M = ye + (cr = Zr(li, 0, M << 1 & -2, 1 & (cr << 1 | M >>> 31))) | 0, ye = Qe + ve | 0, ve = 1 + (ye = (Qo = M >>> 0 < cr >>> 0 ? ye + 1 | 0 : ye) + Tn | 0) | 0, cr = ye, cr = (ye = M + Tr | 0) >>> 0 < M >>> 0 ? ve : cr, ve = ye + (fi = Zr(Tr, 0, M << 1 & -2, 1 & (Qo << 1 | M >>> 31))) | 0, ye = Qe + cr | 0, Mr = Ci(ve ^ ti, (Zn = ve >>> 0 < fi >>> 0 ? ye + 1 | 0 : ye) ^ Mr, 32), go = Qe, fi = (Mi = o[pr + 52 >> 2]) + (ye = o[pr + 20 >> 2]) | 0, Yi = (Tn = o[pr + 48 >> 2]) + (cr = o[pr + 16 >> 2]) | 0, $n = Zr(cr << 1 & -2, 1 & (ye << 1 | cr >>> 31), Tn, 0), cr = Qe + (cr >>> 0 > Yi >>> 0 ? fi + 1 | 0 : fi) | 0, Yi = (ye = Yi + $n | 0) >>> 0 < $n >>> 0 ? cr + 1 | 0 : cr, qn = ($n = Ci(ye ^ o[pr + 112 >> 2], Yi ^ o[pr + 116 >> 2], 32)) + (fi = o[pr + 80 >> 2]) | 0, fo = (Eo = Qe) + (cr = o[pr + 84 >> 2]) | 0, Wi = Zr($n, 0, fi << 1 & -2, 1 & (cr << 1 | fi >>> 31)), fi = Qe + (fi >>> 0 > qn >>> 0 ? fo + 1 | 0 : fo) | 0, Tn = Ci(Tn ^ (cr = Wi + qn | 0), Mi ^ (qn = cr >>> 0 < Wi >>> 0 ? fi + 1 | 0 : fi), 40), Wi = 1 + (fi = Yi + (Mi = Qe) | 0) | 0, fo = fi, fo = (fi = ye + Tn | 0) >>> 0 < ye >>> 0 ? Wi : fo, ye = Zr(Tn, 0, ye << 1 & -2, 1 & (Yi << 1 | ye >>> 31)), Yi = Qe + fo | 0, Yi = Ci(Wi = (fi = ye + fi | 0) ^ $n, Eo ^ ($n = ye >>> 0 > fi >>> 0 ? Yi + 1 | 0 : Yi), 48), Wi = 1 + (ye = qn + (Eo = Qe) | 0) | 0, fo = ye, fo = (ye = cr + Yi | 0) >>> 0 < cr >>> 0 ? Wi : fo, cr = Zr(Yi, 0, cr << 1 & -2, 1 & (qn << 1 | cr >>> 31)), qn = Qe + fo | 0, Wi = 1 + (cr = (qn = (ye = cr + ye | 0) >>> 0 < cr >>> 0 ? qn + 1 | 0 : qn) + go | 0) | 0, fo = cr, fo = (cr = ye + Mr | 0) >>> 0 < ye >>> 0 ? Wi : fo, cs = Tr ^ (cr = (Wi = Zr(Mr, 0, ye << 1 & -2, 1 & (qn << 1 | ye >>> 31))) + cr | 0), Tr = Qe + fo | 0, Tr = Ci(cs, Fi ^ (fo = cr >>> 0 < Wi >>> 0 ? Tr + 1 | 0 : Tr), 40), zn = 1 + (Wi = Zn + (Fi = Qe) | 0) | 0, cs = Wi, cs = (Wi = ve + Tr | 0) >>> 0 < ve >>> 0 ? zn : cs, ve = (Zn = Zr(Tr, 0, ve << 1 & -2, 1 & (Zn << 1 | ve >>> 31))) + Wi | 0, o[pr >> 2] = ve, Wi = Qe + cs | 0, Zn = ve >>> 0 < Zn >>> 0 ? Wi + 1 | 0 : Wi, o[pr + 4 >> 2] = Zn, ve = Ci(ve ^ Mr, Zn ^ go, 48), o[pr + 120 >> 2] = ve, Mr = Qe, o[pr + 124 >> 2] = Mr, cs = 1 + (Mr = Mr + fo | 0) | 0, Wi = Mr, Zn = (Mr = ve + cr | 0) >>> 0 < cr >>> 0 ? cs : Wi, ve = (cr = Zr(ve, 0, cr << 1 & -2, 1 & (fo << 1 | cr >>> 31))) + Mr | 0, o[pr + 80 >> 2] = ve, Mr = Qe + Zn | 0, cr = ve >>> 0 < cr >>> 0 ? Mr + 1 | 0 : Mr, o[pr + 84 >> 2] = cr, es = pr, us = Ci(ve ^ Tr, cr ^ Fi, 1), o[es + 40 >> 2] = us, o[pr + 44 >> 2] = Qe, ve = Ci(ye ^ Tn, Mi ^ qn, 1), Mr = 1 + (ye = ro + (Tn = Qe) | 0) | 0, cr = ye, cr = (ye = ve + Nr | 0) >>> 0 < Nr >>> 0 ? Mr : cr, ye = ye + (Tr = Zr(ve, 0, Nr << 1 & -2, 1 & (ro << 1 | Nr >>> 31))) | 0, Nr = Qe + cr | 0, cr = Ci(M ^ io, Qo ^ ms, 48), Nr = Ci(cr ^ ye, (Tr = ye >>> 0 < Tr >>> 0 ? Nr + 1 | 0 : Nr) ^ (ro = Qe), 32), io = Mr = Qe, Mi = 1 + (M = wo + Ni | 0) | 0, Ni = M, Qo = (M = Ne + ti | 0) >>> 0 < Ne >>> 0 ? Mi : Ni, Ne = Zr(ti, 0, Ne << 1 & -2, 1 & (wo << 1 | Ne >>> 31)), ti = Qe + Qo | 0, Ni = 1 + (Ne = (ti = (M = Ne + M | 0) >>> 0 < Ne >>> 0 ? ti + 1 | 0 : ti) + Mr | 0) | 0, Mr = Ne, Mr = (Ne = M + Nr | 0) >>> 0 < M >>> 0 ? Ni : Mr, Ni = ve ^ (Ne = (wo = Zr(Nr, 0, M << 1 & -2, 1 & (ti << 1 | M >>> 31))) + Ne | 0), ve = Qe + Mr | 0, ve = Ci(Ni, Tn ^ (Mr = Ne >>> 0 < wo >>> 0 ? ve + 1 | 0 : ve), 40), Mi = 1 + (wo = Tr + (Tn = Qe) | 0) | 0, Ni = wo, Qo = (wo = ye + ve | 0) >>> 0 < ye >>> 0 ? Mi : Ni, Ni = Nr ^ (ye = (Tr = Zr(ve, 0, ye << 1 & -2, 1 & (Tr << 1 | ye >>> 31))) + wo | 0), Nr = Qe + Qo | 0, Nr = Ci(Ni, io ^ (Tr = ye >>> 0 < Tr >>> 0 ? Nr + 1 | 0 : Nr), 48), o[pr + 96 >> 2] = Nr, wo = Qe, o[pr + 100 >> 2] = wo, o[pr + 8 >> 2] = ye, o[pr + 12 >> 2] = Tr, Mi = 1 + (ye = Mr + wo | 0) | 0, Ni = ye, Tr = (ye = Ne + Nr | 0) >>> 0 < Ne >>> 0 ? Mi : Ni, Ne = Zr(Nr, 0, Ne << 1 & -2, 1 & (Mr << 1 | Ne >>> 31)), Nr = Qe + Tr | 0, es = pr, us = Ci((ye = Ne + ye | 0) ^ ve, Tn ^ (Ne = ye >>> 0 < Ne >>> 0 ? Nr + 1 | 0 : Nr), 1), o[es + 48 >> 2] = us, o[pr + 52 >> 2] = Qe, o[pr + 88 >> 2] = ye, o[pr + 92 >> 2] = Ne, Nr = Ci(M ^ vn, ti ^ is, 1), Ne = 1 + (M = $n + (vn = Qe) | 0) | 0, ye = M, Ne = (M = Nr + fi | 0) >>> 0 < fi >>> 0 ? Ne : ye, ye = M + (ve = Zr(Nr, 0, fi << 1 & -2, 1 & ($n << 1 | fi >>> 31))) | 0, M = Qe + Ne | 0, ve = Ci(ye ^ jr, ws ^ (fi = ye >>> 0 < ve >>> 0 ? M + 1 | 0 : M), 32), ti = Ne = Qe, Mr = 1 + (M = bo + ro | 0) | 0, Ne = M, jr = (M = Pr + cr | 0) >>> 0 < Pr >>> 0 ? Mr : Ne, Pr = Zr(cr, 0, Pr << 1 & -2, 1 & (bo << 1 | Pr >>> 31)), Ne = Qe + jr | 0, Mr = 1 + (Ne = ti + (Pr = (M = Pr + M | 0) >>> 0 < Pr >>> 0 ? Ne + 1 | 0 : Ne) | 0) | 0, cr = Ne, cr = (Ne = M + ve | 0) >>> 0 < M >>> 0 ? Mr : cr, Mr = Nr ^ (Ne = Ne + (jr = Zr(ve, 0, M << 1 & -2, 1 & (Pr << 1 | M >>> 31))) | 0), Nr = Qe + cr | 0, Nr = Ci(Mr, vn ^ (cr = Ne >>> 0 < jr >>> 0 ? Nr + 1 | 0 : Nr), 40), Ni = 1 + (jr = fi + (vn = Qe) | 0) | 0, Mr = jr, Tr = (jr = ye + Nr | 0) >>> 0 < ye >>> 0 ? Ni : Mr, ye = (fi = Zr(Nr, 0, ye << 1 & -2, 1 & (fi << 1 | ye >>> 31))) + jr | 0, o[pr + 16 >> 2] = ye, jr = Qe + Tr | 0, fi = ye >>> 0 < fi >>> 0 ? jr + 1 | 0 : jr, o[pr + 20 >> 2] = fi, ye = Ci(ye ^ ve, fi ^ ti, 48), o[pr + 104 >> 2] = ye, ve = Qe, o[pr + 108 >> 2] = ve, Mr = 1 + (ve = ve + cr | 0) | 0, ti = ve, fi = (ve = ye + Ne | 0) >>> 0 < Ne >>> 0 ? Mr : ti, Ne = (ye = Zr(ye, 0, Ne << 1 & -2, 1 & (cr << 1 | Ne >>> 31))) + ve | 0, ve = Qe + fi | 0, fi = ye = ye >>> 0 > Ne >>> 0 ? ve + 1 | 0 : ve, o[qo >> 2] = Ne, o[qo + 4 >> 2] = ye, ye = (Pr = Ci(M ^ li, Pr ^ ai, 1)) + Xi | 0, ve = (ti = Qe) + Ln | 0, M = (cr = Zr(Xi << 1 & -2, 1 & (Ln << 1 | Xi >>> 31), Pr, 0)) + ye | 0, ye = Qe + (ye >>> 0 < Pr >>> 0 ? ve + 1 | 0 : ve) | 0, ve = Ci(M ^ Yi, Eo ^ (cr = M >>> 0 < cr >>> 0 ? ye + 1 | 0 : ye), 32), jr = 1 + (ye = as + (Xi = Qe) | 0) | 0, Mr = ye, jr = (ye = ve + Br | 0) >>> 0 < Br >>> 0 ? jr : Mr, Mr = Pr ^ (ye = (Br = Zr(ve, 0, Br << 1 & -2, 1 & (as << 1 | Br >>> 31))) + ye | 0), Pr = Qe + jr | 0, Br = Ci(Mr, ti ^ (Pr = ye >>> 0 < Br >>> 0 ? Pr + 1 | 0 : Pr), 40), li = 1 + (jr = cr + (ti = Qe) | 0) | 0, Mr = jr, Tr = (jr = M + Br | 0) >>> 0 < M >>> 0 ? li : Mr, Mr = ve ^ (cr = (M = Zr(Br, 0, M << 1 & -2, 1 & (cr << 1 | M >>> 31))) + jr | 0), ve = Qe + Tr | 0, M = Ci(Mr, Xi ^ (ve = M >>> 0 > cr >>> 0 ? ve + 1 | 0 : ve), 48), li = 1 + (jr = Pr + (Xi = Qe) | 0) | 0, Mr = jr, Tr = (jr = M + ye | 0) >>> 0 < ye >>> 0 ? li : Mr, ye = (Pr = Zr(M, 0, ye << 1 & -2, 1 & (Pr << 1 | ye >>> 31))) + jr | 0, o[pr + 72 >> 2] = ye, jr = Qe + Tr | 0, Pr = ye >>> 0 < Pr >>> 0 ? jr + 1 | 0 : jr, o[pr + 76 >> 2] = Pr, o[pr + 112 >> 2] = M, o[pr + 116 >> 2] = Xi, o[pr + 24 >> 2] = cr, o[pr + 28 >> 2] = ve, es = pr, us = Ci(Ne ^ Nr, fi ^ vn, 1), o[es + 56 >> 2] = us, o[pr + 60 >> 2] = Qe, es = pr, us = Ci(ye ^ Br, Pr ^ ti, 1), o[es + 32 >> 2] = us, o[pr + 36 >> 2] = Qe, (0 | (gr = gr + 1 | 0)) != 8; ) ;
                            for (; ye = (Ne = o[392 + (pr = (T + 3072 | 0) + (Jr << 4) | 0) >> 2]) + (M = o[pr + 136 >> 2]) | 0, Nr = (cr = o[pr + 396 >> 2]) + (gr = o[pr + 140 >> 2]) | 0, Br = Zr(M << 1 & -2, 1 & (gr << 1 | M >>> 31), Ne, 0), M = Qe + (M >>> 0 > ye >>> 0 ? Nr + 1 | 0 : Nr) | 0, Nr = (gr = Br + ye | 0) >>> 0 < Br >>> 0 ? M + 1 | 0 : M, Pr = (Br = Ci(gr ^ o[pr + 904 >> 2], Nr ^ o[pr + 908 >> 2], 32)) + (M = o[pr + 648 >> 2]) | 0, ve = (vn = Qe) + (ye = o[pr + 652 >> 2]) | 0, fi = Zr(Br, 0, M << 1 & -2, 1 & (ye << 1 | M >>> 31)), M = Qe + (M >>> 0 > Pr >>> 0 ? ve + 1 | 0 : ve) | 0, Xi = Ci(Ne ^ (ye = fi + Pr | 0), cr ^ (Yi = ye >>> 0 < fi >>> 0 ? M + 1 | 0 : M), 40), cr = 1 + (M = Nr + (qn = Qe) | 0) | 0, Ne = M, Ne = (M = gr + Xi | 0) >>> 0 < gr >>> 0 ? cr : Ne, fi = (gr = Zr(Xi, 0, gr << 1 & -2, 1 & (Nr << 1 | gr >>> 31))) + M | 0, M = Qe + Ne | 0, vn = Ci(fi ^ Br, vn ^ (wo = gr >>> 0 > fi >>> 0 ? M + 1 | 0 : M), 48), fo = li = Qe, Ne = (ti = o[pr + 268 >> 2]) + (gr = o[pr + 12 >> 2]) | 0, Br = (Nr = o[pr + 264 >> 2]) + (M = o[pr + 8 >> 2]) | 0, Pr = Zr(M << 1 & -2, 1 & (gr << 1 | M >>> 31), Nr, 0), M = Qe + (M >>> 0 > Br >>> 0 ? Ne + 1 | 0 : Ne) | 0, Pr = (gr = Br + Pr | 0) >>> 0 < Pr >>> 0 ? M + 1 | 0 : M, Br = (ve = Ci(gr ^ o[pr + 776 >> 2], Pr ^ o[pr + 780 >> 2], 32)) + (Ne = o[pr + 520 >> 2]) | 0, cr = (jr = Qe) + (M = o[pr + 524 >> 2]) | 0, Tr = Zr(ve, 0, Ne << 1 & -2, 1 & (M << 1 | Ne >>> 31)), Ne = Qe + (Ne >>> 0 > Br >>> 0 ? cr + 1 | 0 : cr) | 0, Br = Ci(Mr = Nr ^ (M = Tr + Br | 0), ti ^ (Nr = M >>> 0 < Tr >>> 0 ? Ne + 1 | 0 : Ne), 40), Mr = 1 + (Ne = Pr + (cr = Qe) | 0) | 0, ti = Ne, ti = (Ne = gr + Br | 0) >>> 0 < gr >>> 0 ? Mr : ti, gr = Zr(Br, 0, gr << 1 & -2, 1 & (Pr << 1 | gr >>> 31)), Pr = Qe + ti | 0, ti = Ci((Ne = gr + Ne | 0) ^ ve, jr ^ (Ln = Ne >>> 0 < gr >>> 0 ? Pr + 1 | 0 : Pr), 48), jr = 1 + (gr = Nr + (is = Qe) | 0) | 0, Mr = gr, Pr = (gr = M + ti | 0) >>> 0 < M >>> 0 ? jr : Mr, Nr = gr + (M = Zr(ti, 0, M << 1 & -2, 1 & (Nr << 1 | M >>> 31))) | 0, gr = Qe + Pr | 0, jr = Ci(Br ^ Nr, cr ^ (ro = M >>> 0 > Nr >>> 0 ? gr + 1 | 0 : gr), 1), Ni = Mr = Qe, Br = (Tn = o[pr + 260 >> 2]) + (gr = o[pr + 4 >> 2]) | 0, ve = (Pr = o[pr + 256 >> 2]) + (M = o[pr >> 2]) | 0, cr = Zr(M << 1 & -2, 1 & (gr << 1 | M >>> 31), Pr, 0), M = Qe + (M >>> 0 > ve >>> 0 ? Br + 1 | 0 : Br) | 0, ve = (gr = ve + cr | 0) >>> 0 < cr >>> 0 ? M + 1 | 0 : M, cr = (as = Ci(gr ^ o[pr + 768 >> 2], ve ^ o[pr + 772 >> 2], 32)) + (M = o[pr + 512 >> 2]) | 0, Tr = (ws = Qe) + (Br = o[pr + 516 >> 2]) | 0, io = Zr(as, 0, M << 1 & -2, 1 & (Br << 1 | M >>> 31)), M = Qe + (M >>> 0 > cr >>> 0 ? Tr + 1 | 0 : Tr) | 0, Tr = Ci(Pr ^ (Br = io + cr | 0), Tn ^ (io = Br >>> 0 < io >>> 0 ? M + 1 | 0 : M), 40), Pr = 1 + (M = ve + (Fi = Qe) | 0) | 0, cr = M, Pr = (M = gr + Tr | 0) >>> 0 < gr >>> 0 ? Pr : cr, gr = M + (ve = Zr(Tr, 0, gr << 1 & -2, 1 & (ve << 1 | gr >>> 31))) | 0, M = Qe + Pr | 0, Mr = 1 + (M = (qo = gr >>> 0 < ve >>> 0 ? M + 1 | 0 : M) + Mr | 0) | 0, cr = M, ve = (M = gr + jr | 0) >>> 0 < gr >>> 0 ? Mr : cr, Pr = M + (cr = Zr(jr, 0, gr << 1 & -2, 1 & (qo << 1 | gr >>> 31))) | 0, M = Qe + ve | 0, li = Ci(Pr ^ vn, (bo = Pr >>> 0 < cr >>> 0 ? M + 1 | 0 : M) ^ li, 32), Qo = Qe, cr = (ms = o[pr + 388 >> 2]) + (M = o[pr + 132 >> 2]) | 0, Tn = (Mr = o[pr + 384 >> 2]) + (ve = o[pr + 128 >> 2]) | 0, Zn = Zr(ve << 1 & -2, 1 & (M << 1 | ve >>> 31), Mr, 0), ve = Qe + (ve >>> 0 > Tn >>> 0 ? cr + 1 | 0 : cr) | 0, Tn = (M = Tn + Zn | 0) >>> 0 < Zn >>> 0 ? ve + 1 | 0 : ve, go = (Zn = Ci(M ^ o[pr + 896 >> 2], Tn ^ o[pr + 900 >> 2], 32)) + (cr = o[pr + 640 >> 2]) | 0, $n = (ai = Qe) + (ve = o[pr + 644 >> 2]) | 0, Mi = Zr(Zn, 0, cr << 1 & -2, 1 & (ve << 1 | cr >>> 31)), cr = Qe + (cr >>> 0 > go >>> 0 ? $n + 1 | 0 : $n) | 0, Mr = Ci(Mr ^ (ve = Mi + go | 0), ms ^ (go = ve >>> 0 < Mi >>> 0 ? cr + 1 | 0 : cr), 40), Wi = 1 + (cr = Tn + (ms = Qe) | 0) | 0, Mi = cr, $n = (cr = M + Mr | 0) >>> 0 < M >>> 0 ? Wi : Mi, M = Zr(Mr, 0, M << 1 & -2, 1 & (Tn << 1 | M >>> 31)), Tn = Qe + $n | 0, Tn = Ci(Mi = (cr = M + cr | 0) ^ Zn, ai ^ (Zn = M >>> 0 > cr >>> 0 ? Tn + 1 | 0 : Tn), 48), Wi = 1 + (M = go + (ai = Qe) | 0) | 0, Mi = M, $n = (M = ve + Tn | 0) >>> 0 < ve >>> 0 ? Wi : Mi, ve = Zr(Tn, 0, ve << 1 & -2, 1 & (go << 1 | ve >>> 31)), go = Qe + $n | 0, Wi = 1 + (ve = (go = (M = ve + M | 0) >>> 0 < ve >>> 0 ? go + 1 | 0 : go) + Qo | 0) | 0, Mi = ve, $n = (ve = M + li | 0) >>> 0 < M >>> 0 ? Wi : Mi, Wi = jr ^ (ve = (Mi = Zr(li, 0, M << 1 & -2, 1 & (go << 1 | M >>> 31))) + ve | 0), jr = Qe + $n | 0, jr = Ci(Wi, Ni ^ ($n = ve >>> 0 < Mi >>> 0 ? jr + 1 | 0 : jr), 40), cs = 1 + (Mi = bo + (Ni = Qe) | 0) | 0, Wi = Mi, Eo = (Mi = Pr + jr | 0) >>> 0 < Pr >>> 0 ? cs : Wi, Pr = (bo = Zr(jr, 0, Pr << 1 & -2, 1 & (bo << 1 | Pr >>> 31))) + Mi | 0, o[pr >> 2] = Pr, Mi = Qe + Eo | 0, bo = Pr >>> 0 < bo >>> 0 ? Mi + 1 | 0 : Mi, o[pr + 4 >> 2] = bo, Pr = Ci(Pr ^ li, bo ^ Qo, 48), o[pr + 904 >> 2] = Pr, li = Qe, o[pr + 908 >> 2] = li, Wi = 1 + (li = li + $n | 0) | 0, Mi = li, bo = (li = ve + Pr | 0) >>> 0 < ve >>> 0 ? Wi : Mi, Pr = (ve = Zr(Pr, 0, ve << 1 & -2, 1 & ($n << 1 | ve >>> 31))) + li | 0, o[pr + 640 >> 2] = Pr, li = Qe + bo | 0, ve = ve >>> 0 > Pr >>> 0 ? li + 1 | 0 : li, o[pr + 644 >> 2] = ve, es = pr, us = Ci(Pr ^ jr, ve ^ Ni, 1), o[es + 264 >> 2] = us, o[pr + 268 >> 2] = Qe, Pr = Ci(M ^ Mr, go ^ ms, 1), li = 1 + (M = Ln + (Mr = Qe) | 0) | 0, jr = M, ve = (M = Ne + Pr | 0) >>> 0 < Ne >>> 0 ? li : jr, M = M + (jr = Zr(Pr, 0, Ne << 1 & -2, 1 & (Ln << 1 | Ne >>> 31))) | 0, Ne = Qe + ve | 0, ve = Ci(gr ^ as, qo ^ ws, 48), Ne = Ci(ve ^ M, (jr = M >>> 0 < jr >>> 0 ? Ne + 1 | 0 : Ne) ^ (Ln = Qe), 32), as = li = Qe, Mi = 1 + (gr = Yi + fo | 0) | 0, Ni = gr, qo = (gr = ye + vn | 0) >>> 0 < ye >>> 0 ? Mi : Ni, ye = Zr(vn, 0, ye << 1 & -2, 1 & (Yi << 1 | ye >>> 31)), vn = Qe + qo | 0, Ni = 1 + (ye = (vn = ye >>> 0 > (gr = ye + gr | 0) >>> 0 ? vn + 1 | 0 : vn) + li | 0) | 0, li = ye, li = (ye = Ne + gr | 0) >>> 0 < gr >>> 0 ? Ni : li, Ni = Pr ^ (ye = (Yi = Zr(Ne, 0, gr << 1 & -2, 1 & (vn << 1 | gr >>> 31))) + ye | 0), Pr = Qe + li | 0, Pr = Ci(Ni, Mr ^ (li = ye >>> 0 < Yi >>> 0 ? Pr + 1 | 0 : Pr), 40), Mi = 1 + (Yi = jr + (Mr = Qe) | 0) | 0, Ni = Yi, qo = (Yi = M + Pr | 0) >>> 0 < M >>> 0 ? Mi : Ni, Ni = Ne ^ (M = (jr = Zr(Pr, 0, M << 1 & -2, 1 & (jr << 1 | M >>> 31))) + Yi | 0), Ne = Qe + qo | 0, Ne = Ci(Ni, as ^ (jr = M >>> 0 < jr >>> 0 ? Ne + 1 | 0 : Ne), 48), o[pr + 768 >> 2] = Ne, Yi = Qe, o[pr + 772 >> 2] = Yi, o[pr + 8 >> 2] = M, o[pr + 12 >> 2] = jr, Ni = 1 + (M = li + Yi | 0) | 0, jr = M, jr = (M = ye + Ne | 0) >>> 0 < ye >>> 0 ? Ni : jr, ye = Zr(Ne, 0, ye << 1 & -2, 1 & (li << 1 | ye >>> 31)), Ne = Qe + jr | 0, es = pr, us = Ci((M = ye + M | 0) ^ Pr, Mr ^ (ye = M >>> 0 < ye >>> 0 ? Ne + 1 | 0 : Ne), 1), o[es + 384 >> 2] = us, o[pr + 388 >> 2] = Qe, o[pr + 648 >> 2] = M, o[pr + 652 >> 2] = ye, Ne = Ci(gr ^ Xi, vn ^ qn, 1), ye = 1 + (gr = Zn + (Xi = Qe) | 0) | 0, M = gr, ye = (gr = Ne + cr | 0) >>> 0 < cr >>> 0 ? ye : M, M = gr + (Pr = Zr(Ne, 0, cr << 1 & -2, 1 & (Zn << 1 | cr >>> 31))) | 0, gr = Qe + ye | 0, Pr = Ci(M ^ ti, is ^ (cr = M >>> 0 < Pr >>> 0 ? gr + 1 | 0 : gr), 32), vn = ye = Qe, ti = 1 + (gr = io + Ln | 0) | 0, ye = gr, ti = (gr = ve + Br | 0) >>> 0 < Br >>> 0 ? ti : ye, Br = Zr(ve, 0, Br << 1 & -2, 1 & (io << 1 | Br >>> 31)), ye = Qe + ti | 0, Mr = 1 + (ye = vn + (Br = (gr = Br + gr | 0) >>> 0 < Br >>> 0 ? ye + 1 | 0 : ye) | 0) | 0, ti = ye, ve = (ye = gr + Pr | 0) >>> 0 < gr >>> 0 ? Mr : ti, Mr = Ne ^ (ye = ye + (ti = Zr(Pr, 0, gr << 1 & -2, 1 & (Br << 1 | gr >>> 31))) | 0), Ne = Qe + ve | 0, Ne = Ci(Mr, Xi ^ (ve = ye >>> 0 < ti >>> 0 ? Ne + 1 | 0 : Ne), 40), jr = 1 + (ti = cr + (Xi = Qe) | 0) | 0, Mr = ti, jr = (ti = M + Ne | 0) >>> 0 < M >>> 0 ? jr : Mr, M = (cr = Zr(Ne, 0, M << 1 & -2, 1 & (cr << 1 | M >>> 31))) + ti | 0, o[pr + 128 >> 2] = M, ti = Qe + jr | 0, cr = M >>> 0 < cr >>> 0 ? ti + 1 | 0 : ti, o[pr + 132 >> 2] = cr, M = Ci(M ^ Pr, cr ^ vn, 48), o[pr + 776 >> 2] = M, Pr = Qe, o[pr + 780 >> 2] = Pr, ti = 1 + (Pr = ve + Pr | 0) | 0, cr = Pr, cr = (Pr = M + ye | 0) >>> 0 < ye >>> 0 ? ti : cr, ye = (M = Zr(M, 0, ye << 1 & -2, 1 & (ve << 1 | ye >>> 31))) + Pr | 0, Pr = Qe + cr | 0, cr = M = M >>> 0 > ye >>> 0 ? Pr + 1 | 0 : Pr, o[pr + 512 >> 2] = ye, o[pr + 516 >> 2] = M, M = (Br = Ci(gr ^ Tr, Br ^ Fi, 1)) + fi | 0, Pr = (vn = Qe) + wo | 0, gr = (ve = Zr(fi << 1 & -2, 1 & (wo << 1 | fi >>> 31), Br, 0)) + M | 0, M = Qe + (M >>> 0 < Br >>> 0 ? Pr + 1 | 0 : Pr) | 0, Pr = Ci(gr ^ Tn, ai ^ (ve = gr >>> 0 < ve >>> 0 ? M + 1 | 0 : M), 32), Mr = 1 + (M = ro + (fi = Qe) | 0) | 0, ti = M, ti = (M = Pr + Nr | 0) >>> 0 < Nr >>> 0 ? Mr : ti, Mr = Br ^ (M = (Nr = Zr(Pr, 0, Nr << 1 & -2, 1 & (ro << 1 | Nr >>> 31))) + M | 0), Br = Qe + ti | 0, Nr = Ci(Mr, vn ^ (Br = M >>> 0 < Nr >>> 0 ? Br + 1 | 0 : Br), 40), jr = 1 + (ti = ve + (vn = Qe) | 0) | 0, Mr = ti, jr = (ti = gr + Nr | 0) >>> 0 < gr >>> 0 ? jr : Mr, ti = Pr ^ (ve = (gr = Zr(Nr, 0, gr << 1 & -2, 1 & (ve << 1 | gr >>> 31))) + ti | 0), Pr = Qe + jr | 0, gr = Ci(ti, fi ^ (Pr = gr >>> 0 > ve >>> 0 ? Pr + 1 | 0 : Pr), 48), jr = 1 + (ti = Br + (fi = Qe) | 0) | 0, Mr = ti, jr = (ti = M + gr | 0) >>> 0 < M >>> 0 ? jr : Mr, M = (Br = Zr(gr, 0, M << 1 & -2, 1 & (Br << 1 | M >>> 31))) + ti | 0, o[pr + 520 >> 2] = M, ti = Qe + jr | 0, Br = M >>> 0 < Br >>> 0 ? ti + 1 | 0 : ti, o[pr + 524 >> 2] = Br, o[pr + 896 >> 2] = gr, o[pr + 900 >> 2] = fi, o[pr + 136 >> 2] = ve, o[pr + 140 >> 2] = Pr, es = pr, us = Ci(ye ^ Ne, cr ^ Xi, 1), o[es + 392 >> 2] = us, o[pr + 396 >> 2] = Qe, es = pr, us = Ci(M ^ Nr, Br ^ vn, 1), o[es + 256 >> 2] = us, o[pr + 260 >> 2] = Qe, (0 | (Jr = Jr + 1 | 0)) != 8; ) ;
                            for (pr = fa(Po, T + 2048 | 0, 1024), gr = 0; Ne = o[(M = (Jr = gr << 3) + pr | 0) >> 2], Br = o[(Nr = (ye = T + 3072 | 0) + Jr | 0) >> 2], Nr = o[M + 4 >> 2] ^ o[Nr + 4 >> 2], o[M >> 2] = Ne ^ Br, o[M + 4 >> 2] = Nr, Nr = o[(M = (Ne = 8 | Jr) + pr | 0) >> 2], Br = o[(Ne = ye + Ne | 0) >> 2], Ne = o[M + 4 >> 2] ^ o[Ne + 4 >> 2], o[M >> 2] = Nr ^ Br, o[M + 4 >> 2] = Ne, Nr = o[(M = (Ne = 16 | Jr) + pr | 0) >> 2], Br = o[(Ne = ye + Ne | 0) >> 2], Ne = o[M + 4 >> 2] ^ o[Ne + 4 >> 2], o[M >> 2] = Nr ^ Br, o[M + 4 >> 2] = Ne, Ne = o[(Jr = (M = 24 | Jr) + pr | 0) >> 2], ye = o[(M = M + ye | 0) >> 2], M = o[Jr + 4 >> 2] ^ o[M + 4 >> 2], o[Jr >> 2] = ye ^ Ne, o[Jr + 4 >> 2] = M, (0 | (gr = gr + 4 | 0)) != 128; ) ;
                          }
                          if (gr = ks + 1 | 0, So = So + 1 | 0, !((Jr = o[k + 20 >> 2]) >>> 0 > (to = to + 1 | 0) >>> 0)) break;
                        }
                      }
                      dr = T + 4096 | 0;
                    }
                    function Si(k) {
                      var E, T, M, ye, Ne, pr, ve, cr, gr, Pr, Nr, Br = 0, Mr = 0, jr = 0, ti = 0, fi = 0, Jr = 0, li = 0, Tr = 0, Mi = 0, Wi = 0, vn = 0, Tn = 0, Ni = 0, Yi = 0, Xi = 0, $n = 0, Zn = 0, to = 0, fo = 0, wo = 0, bo = 0, go = 0, qn = 0, io = 0, So = 0, qo = 0, Ln = 0, ro = 0, Qo = 0, Vo = 0, as = 0, cs = 0, ms = 0, ai = 0, ci = 0, Fi = 0, Eo = 0;
                      ti = ($n = m[k + 44 | 0] | m[k + 45 | 0] << 8 | m[k + 46 | 0] << 16 | m[k + 47 | 0] << 24) >>> 5 & 2097151, jr = Zr(E = (m[k + 60 | 0] | m[k + 61 | 0] << 8 | m[k + 62 | 0] << 16 | m[k + 63 | 0] << 24) >>> 3 | 0, 0, -683901, -1), Mr = (Br = m[k + 44 | 0]) << 16 & 2031616 | m[k + 42 | 0] | m[k + 43 | 0] << 8, Br = Qe, Tr = Br = Mr >>> 0 > (Wi = jr + Mr | 0) >>> 0 ? Br + 1 | 0 : Br, Yi = Br = Br - ((Wi >>> 0 < 4293918720) - 1 | 0) | 0, jr = Br >> 21, Br = (Mr = ti) + (ti = (2097151 & Br) << 11 | (Jr = Wi - -1048576 | 0) >>> 21) | 0, Mr = jr, go = Mr = Br >>> 0 < ti >>> 0 ? Mr + 1 | 0 : Mr, as = Br, Ni = Zr(Br, Mr, -683901, -1), Mi = Qe, li = Zr(T = (m[k + 49 | 0] | m[k + 50 | 0] << 8 | m[k + 51 | 0] << 16 | m[k + 52 | 0] << 24) >>> 7 & 2097151, 0, -997805, -1), jr = (Br = m[k + 27 | 0]) >>> 24 | 0, ti = Br << 8 | (Xi = m[k + 23 | 0] | m[k + 24 | 0] << 8 | m[k + 25 | 0] << 16 | m[k + 26 | 0] << 24) >>> 24, Mr = (Br = m[k + 28 | 0]) >>> 16 | 0, Mr = 2097151 & ((3 & (Mr |= jr)) << 30 | (Br = ti | Br << 16) >>> 2), Br = Qe, Br = Mr >>> 0 > (jr = Mr + li | 0) >>> 0 ? Br + 1 | 0 : Br, Mr = Zr(Qo = (vn = m[k + 52 | 0] | m[k + 53 | 0] << 8 | m[k + 54 | 0] << 16 | m[k + 55 | 0] << 24) >>> 4 & 2097151, 0, 654183, 0), Br = Qe + Br | 0, li = jr = Mr + jr | 0, jr = Mr >>> 0 > jr >>> 0 ? Br + 1 | 0 : Br, fi = (Mr = m[k + 48 | 0]) << 8 | $n >>> 24, Mr = Br = Mr >>> 24 | 0, Br = Zr(M = 2097151 & ((3 & ($n = (Br = (ti = m[k + 49 | 0]) >>> 16 | 0) | Mr)) << 30 | (Mr = (ti <<= 16) | fi) >>> 2), 0, 136657, 0), jr = Qe + jr | 0, jr = Br >>> 0 > (Mr = Br + li | 0) >>> 0 ? jr + 1 | 0 : jr, ti = (Br = Zr(ye = (m[k + 57 | 0] | m[k + 58 | 0] << 8 | m[k + 59 | 0] << 16 | m[k + 60 | 0] << 24) >>> 6 & 2097151, 0, 666643, 0)) + Mr | 0, Mr = Qe + jr | 0, li = ti, jr = Br >>> 0 > ti >>> 0 ? Mr + 1 | 0 : Mr, Mr = (Br = m[k + 56 | 0]) >>> 24 | 0, fi = Br << 8 | vn >>> 24, Mr = Zr(Ne = 2097151 & ((1 & (vn = (Br = (ti = m[k + 57 | 0]) >>> 16 | 0) | Mr)) << 31 | (Mr = (ti <<= 16) | fi) >>> 1), 0, 470296, 0), Br = Qe + jr | 0, Mr = (Br = (jr = ti = Mr + li | 0) >>> 0 < Mr >>> 0 ? Br + 1 | 0 : Br) + Mi | 0, Mr = jr >>> 0 > (ti = jr + Ni | 0) >>> 0 ? Mr + 1 | 0 : Mr, Zn = jr - -1048576 | 0, qn = jr = Br - ((jr >>> 0 < 4293918720) - 1 | 0) | 0, Mi = ti - (Br = -2097152 & Zn) | 0, Ni = Mr - ((Br >>> 0 > ti >>> 0) + jr | 0) | 0, Mr = Zr(T, 0, 654183, 0), Br = Qe, Br = Mr >>> 0 > (jr = Mr + (Xi >>> 5 & 2097151) | 0) >>> 0 ? Br + 1 | 0 : Br, ti = (Mr = jr) + (jr = Zr(Qo, 0, 470296, 0)) | 0, Mr = Qe + Br | 0, Mr = jr >>> 0 > ti >>> 0 ? Mr + 1 | 0 : Mr, Br = Zr(M, cs, -997805, -1), Mr = Qe + Mr | 0, Mr = Br >>> 0 > (jr = Br + ti | 0) >>> 0 ? Mr + 1 | 0 : Mr, ti = (Br = jr) + (jr = Zr(Ne, ms, 666643, 0)) | 0, Br = Qe + Mr | 0, fi = ti, ti = jr >>> 0 > ti >>> 0 ? Br + 1 | 0 : Br, li = (jr = Zr(T, 0, 470296, 0)) + (Br = (Br = m[k + 23 | 0]) << 16 & 2031616 | m[k + 21 | 0] | m[k + 22 | 0] << 8) | 0, jr = Qe, jr = Br >>> 0 > li >>> 0 ? jr + 1 | 0 : jr, li = (Mr = Zr(Qo, 0, 666643, 0)) + li | 0, Br = Qe + jr | 0, jr = Zr(M, cs, 654183, 0), Mr = Qe + (Mr >>> 0 > li >>> 0 ? Br + 1 | 0 : Br) | 0, vn = Mr = jr >>> 0 > (Xi = jr + li | 0) >>> 0 ? Mr + 1 | 0 : Mr, ro = Mr = Mr - ((Xi >>> 0 < 4293918720) - 1 | 0) | 0, Br = (Br = Mr >>> 21 | 0) + ti | 0, jr = Br = (Mr = (2097151 & Mr) << 11 | (li = Xi - -1048576 | 0) >>> 21) >>> 0 > (fi = Mr + fi | 0) >>> 0 ? Br + 1 | 0 : Br, Tn = Mr = Br - ((fi >>> 0 < 4293918720) - 1 | 0) | 0, Br = Mi, Mi = (2097151 & Mr) << 11 | (ti = fi - -1048576 | 0) >>> 21, Mr = (Mr >> 21) + Ni | 0, $n = Mi = (Mr = Mi >>> 0 > (to = Br + Mi | 0) >>> 0 ? Mr + 1 | 0 : Mr) - ((to >>> 0 < 4293918720) - 1 | 0) | 0, Vo = to - (Br = -2097152 & (Ni = to - -1048576 | 0)) | 0, ai = Mr - ((Br >>> 0 > to >>> 0) + Mi | 0) | 0, Br = Zr(as, go, 136657, 0), jr = Qe + jr | 0, jr = Br >>> 0 > (Mr = Br + fi | 0) >>> 0 ? jr + 1 | 0 : jr, bo = Mr - (Br = -2097152 & ti) | 0, fo = jr - ((Br >>> 0 > Mr >>> 0) + Tn | 0) | 0, to = Wi - (Br = -2097152 & Jr) | 0, Yi = Tr - ((Br >>> 0 > Wi >>> 0) + Yi | 0) | 0, Tr = Zr(E, 0, 136657, 0), Mr = (Br = m[k + 40 | 0]) >>> 24 | 0, ti = Br << 8 | (Jr = m[k + 36 | 0] | m[k + 37 | 0] << 8 | m[k + 38 | 0] << 16 | m[k + 39 | 0] << 24) >>> 24, jr = (Br = m[k + 41 | 0]) >>> 16 | 0, Mr = (jr |= Mr) >>> 3 | 0, jr = (7 & jr) << 29 | (Br = ti | Br << 16) >>> 3, Br = Mr + Qe | 0, Br = jr >>> 0 > (ti = jr + Tr | 0) >>> 0 ? Br + 1 | 0 : Br, Mr = Zr(ye, 0, -683901, -1), Br = Qe + Br | 0, Br = Mr >>> 0 > (jr = Mr + ti | 0) >>> 0 ? Br + 1 | 0 : Br, fi = jr, Mr = Zr(E, 0, -997805, -1), jr = Qe, jr = Mr >>> 0 > (ti = Mr + (Jr >>> 6 & 2097151) | 0) >>> 0 ? jr + 1 | 0 : jr, Jr = (Mr = ti) + (ti = Zr(ye, 0, 136657, 0)) | 0, Mr = Qe + jr | 0, jr = Zr(Ne, ms, -683901, -1), Mr = Qe + (ti >>> 0 > Jr >>> 0 ? Mr + 1 | 0 : Mr) | 0, Mi = Mr = jr >>> 0 > (io = jr + Jr | 0) >>> 0 ? Mr + 1 | 0 : Mr, ci = jr = Mr - ((io >>> 0 < 4293918720) - 1 | 0) | 0, Br = Br + (Mr = jr >> 21) | 0, Jr = Br = (jr = (2097151 & jr) << 11 | (Wi = io - -1048576 | 0) >>> 21) >>> 0 > (Tn = jr + fi | 0) >>> 0 ? Br + 1 | 0 : Br, So = Br = Br - ((Tn >>> 0 < 4293918720) - 1 | 0) | 0, Mr = (Mr = Br >> 21) + Yi | 0, Ln = Mr = (Br = (jr = (2097151 & Br) << 11 | (fi = Tn - -1048576 | 0) >>> 21) + to | 0) >>> 0 < jr >>> 0 ? Mr + 1 | 0 : Mr, qo = Br, Mr = Zr(Br, Mr, -683901, -1), Br = Qe + fo | 0, wo = jr = Mr + bo | 0, ti = Mr >>> 0 > jr >>> 0 ? Br + 1 | 0 : Br, to = Xi - (Br = -2097152 & li) | 0, Yi = vn - ((4095 & ro) + (Br >>> 0 > Xi >>> 0) | 0) | 0, Xi = Zr(T, 0, 666643, 0), Br = (Mr = m[k + 19 | 0]) >>> 24 | 0, li = Mr << 8 | (vn = m[k + 15 | 0] | m[k + 16 | 0] << 8 | m[k + 17 | 0] << 16 | m[k + 18 | 0] << 24) >>> 24, jr = Br, Mr = (7 & (jr |= Mr = (Br = m[k + 20 | 0]) >>> 16 | 0)) << 29 | (Mr = (Br <<= 16) | li) >>> 3, jr = Qe + (jr >>> 3 | 0) | 0, jr = Mr >>> 0 > (li = Mr + Xi | 0) >>> 0 ? jr + 1 | 0 : jr, Br = Zr(M, cs, 470296, 0), Mr = Qe + jr | 0, Br = Br >>> 0 > (li = Br + li | 0) >>> 0 ? Mr + 1 | 0 : Mr, jr = Zr(M, cs, 666643, 0), Mr = Qe, Xi = Mr = jr >>> 0 > (bo = jr + (vn >>> 6 & 2097151) | 0) >>> 0 ? Mr + 1 | 0 : Mr, Fi = jr = Mr - ((bo >>> 0 < 4293918720) - 1 | 0) | 0, Br = Br + (Mr = jr >>> 21 | 0) | 0, vn = Br = (jr = (2097151 & jr) << 11 | (Tr = bo - -1048576 | 0) >>> 21) >>> 0 > (fo = jr + li | 0) >>> 0 ? Br + 1 | 0 : Br, Eo = Br = Br - ((fo >>> 0 < 4293918720) - 1 | 0) | 0, Mr = (Mr = Br >>> 21 | 0) + Yi | 0, Mr = (Br = (2097151 & Br) << 11 | (li = fo - -1048576 | 0) >>> 21) >>> 0 > (jr = Br + to | 0) >>> 0 ? Mr + 1 | 0 : Mr, Yi = (Br = jr) + (jr = Zr(as, go, -997805, -1)) | 0, Br = Qe + Mr | 0, Br = jr >>> 0 > Yi >>> 0 ? Br + 1 | 0 : Br, ro = Mr = Tn - (jr = -2097152 & fi) | 0, pr = fi = Jr - ((jr >>> 0 > Tn >>> 0) + So | 0) | 0, jr = Zr(qo, Ln, 136657, 0), Br = Qe + Br | 0, Br = jr >>> 0 > (Jr = jr + Yi | 0) >>> 0 ? Br + 1 | 0 : Br, jr = Zr(Mr, fi, -683901, -1), Mr = Qe + Br | 0, Jr = Mr = jr >>> 0 > (Yi = jr + Jr | 0) >>> 0 ? Mr + 1 | 0 : Mr, So = Br = Mr - ((Yi >>> 0 < 4293918720) - 1 | 0) | 0, Mr = (2097151 & Br) << 11 | (fi = Yi - -1048576 | 0) >>> 21, Br = (Br >> 21) + ti | 0, wo = Mr = (Br = Mr >>> 0 > (Tn = Mr + wo | 0) >>> 0 ? Br + 1 | 0 : Br) - ((Tn >>> 0 < 4293918720) - 1 | 0) | 0, to = (2097151 & Mr) << 11 | (ti = Tn - -1048576 | 0) >>> 21, Mr = (Mr >> 21) + ai | 0, cr = Vo = to + Vo | 0, to = to >>> 0 > Vo >>> 0 ? Mr + 1 | 0 : Mr, gr = Tn - (Mr = -2097152 & ti) | 0, Pr = Br - ((Mr >>> 0 > Tn >>> 0) + wo | 0) | 0, Vo = Yi - (Br = -2097152 & fi) | 0, ai = Jr - ((Br >>> 0 > Yi >>> 0) + So | 0) | 0, jr = (Br = Zr(as, go, 654183, 0)) + (fo - (Mr = -2097152 & li) | 0) | 0, Mr = Qe + (vn - ((2147483647 & Eo) + (Mr >>> 0 > fo >>> 0) | 0) | 0) | 0, Mr = Br >>> 0 > jr >>> 0 ? Mr + 1 | 0 : Mr, Br = Zr(qo, Ln, -997805, -1), Mr = Qe + Mr | 0, Mr = Br >>> 0 > (jr = Br + jr | 0) >>> 0 ? Mr + 1 | 0 : Mr, ti = (Br = jr) + (jr = Zr(ro, pr, 136657, 0)) | 0, Br = Qe + Mr | 0, wo = ti, Jr = jr >>> 0 > ti >>> 0 ? Br + 1 | 0 : Br, fo = io - (Br = -2097152 & Wi) | 0, Tn = Mi - ((Br >>> 0 > io >>> 0) + ci | 0) | 0, vn = Zr(Qo, 0, -683901, -1), Br = (Mr = m[k + 35 | 0]) >>> 24 | 0, ti = Mr << 8 | (li = m[k + 31 | 0] | m[k + 32 | 0] << 8 | m[k + 33 | 0] << 16 | m[k + 34 | 0] << 24) >>> 24, jr = Br, Mr = (Br = m[k + 36 | 0]) >>> 16 | 0, Mr |= jr, jr = Qe, jr = (Br = 2097151 & ((1 & Mr) << 31 | (Br = Br << 16 | ti) >>> 1)) >>> 0 > (Mr = Br + vn | 0) >>> 0 ? jr + 1 | 0 : jr, ti = (Br = Zr(E, 0, 654183, 0)) + Mr | 0, Mr = Qe + jr | 0, Mr = Br >>> 0 > ti >>> 0 ? Mr + 1 | 0 : Mr, jr = Zr(ye, 0, -997805, -1), Br = Qe + Mr | 0, Br = jr >>> 0 > (ti = jr + ti | 0) >>> 0 ? Br + 1 | 0 : Br, Mr = Zr(Ne, ms, 136657, 0), Br = Qe + Br | 0, fi = jr = Mr + ti | 0, ti = Mr >>> 0 > jr >>> 0 ? Br + 1 | 0 : Br, Br = Zr(T, 0, -683901, -1), Mr = Qe, Mr = Br >>> 0 > (jr = Br + (li >>> 4 & 2097151) | 0) >>> 0 ? Mr + 1 | 0 : Mr, li = (Br = Zr(Qo, 0, 136657, 0)) + jr | 0, jr = Qe + Mr | 0, jr = Br >>> 0 > li >>> 0 ? jr + 1 | 0 : jr, Br = Zr(E, 0, 470296, 0), Mr = Qe + jr | 0, Mr = Br >>> 0 > (li = Br + li | 0) >>> 0 ? Mr + 1 | 0 : Mr, li = (jr = Zr(ye, 0, 654183, 0)) + li | 0, Br = Qe + Mr | 0, Mr = Zr(Ne, ms, -997805, -1), Br = Qe + (jr >>> 0 > li >>> 0 ? Br + 1 | 0 : Br) | 0, vn = Br = Mr >>> 0 > (Mi = Mr + li | 0) >>> 0 ? Br + 1 | 0 : Br, Nr = Mr = Br - ((Mi >>> 0 < 4293918720) - 1 | 0) | 0, jr = (Br = Mr >> 21) + ti | 0, Yi = Mr = (jr = (Mr = (2097151 & Mr) << 11 | (li = Mi - -1048576 | 0) >>> 21) >>> 0 > (Wi = Mr + fi | 0) >>> 0 ? jr + 1 | 0 : jr) - ((Wi >>> 0 < 4293918720) - 1 | 0) | 0, Br = (Br = Mr >> 21) + Tn | 0, So = Br = (Mr = (ti = (2097151 & Mr) << 11 | (fi = Wi - -1048576 | 0) >>> 21) + fo | 0) >>> 0 < ti >>> 0 ? Br + 1 | 0 : Br, ti = wo, wo = Mr, Br = Zr(Mr, Br, -683901, -1), Mr = Qe + Jr | 0, Tn = ti = ti + Br | 0, ti = Br >>> 0 > ti >>> 0 ? Mr + 1 | 0 : Mr, Jr = (Br = Zr(as, go, 470296, 0)) + (bo - (Mr = -2097152 & Tr) | 0) | 0, Mr = Qe + (Xi - ((2047 & Fi) + (Mr >>> 0 > bo >>> 0) | 0) | 0) | 0, Mr = Br >>> 0 > Jr >>> 0 ? Mr + 1 | 0 : Mr, Tr = (Br = Jr) + (Jr = Zr(qo, Ln, 654183, 0)) | 0, Br = Qe + Mr | 0, Br = Jr >>> 0 > Tr >>> 0 ? Br + 1 | 0 : Br, Jr = Zr(ro, pr, -997805, -1), Mr = Qe + Br | 0, Mr = Jr >>> 0 > (Tr = Jr + Tr | 0) >>> 0 ? Mr + 1 | 0 : Mr, io = fi = Wi - (Br = -2097152 & fi) | 0, ve = Jr = jr - ((Br >>> 0 > Wi >>> 0) + Yi | 0) | 0, jr = Zr(wo, So, 136657, 0), Br = Qe + Mr | 0, Br = jr >>> 0 > (Tr = jr + Tr | 0) >>> 0 ? Br + 1 | 0 : Br, jr = Zr(fi, Jr, -683901, -1), Mr = Qe + Br | 0, Jr = Mr = jr >>> 0 > (Xi = jr + Tr | 0) >>> 0 ? Mr + 1 | 0 : Mr, fo = Br = Mr - ((Xi >>> 0 < 4293918720) - 1 | 0) | 0, Mr = (2097151 & Br) << 11 | (fi = Xi - -1048576 | 0) >>> 21, Br = (Br >> 21) + ti | 0, Tn = Mr = (Br = Mr >>> 0 > (Tr = Mr + Tn | 0) >>> 0 ? Br + 1 | 0 : Br) - ((Tr >>> 0 < 4293918720) - 1 | 0) | 0, Wi = (2097151 & Mr) << 11 | (ti = Tr - -1048576 | 0) >>> 21, Mr = (Mr >> 21) + ai | 0, ci = Yi = Wi + Vo | 0, Yi = Wi >>> 0 > Yi >>> 0 ? Mr + 1 | 0 : Mr, Fi = Tr - (Mr = -2097152 & ti) | 0, Eo = Br - ((Mr >>> 0 > Tr >>> 0) + Tn | 0) | 0, Vo = Xi - (Br = -2097152 & fi) | 0, ai = Jr - ((Br >>> 0 > Xi >>> 0) + fo | 0) | 0, Jr = Zr(as, go, 666643, 0), Br = (Mr = m[k + 14 | 0]) >>> 24 | 0, ti = Mr << 8 | (Tn = m[k + 10 | 0] | m[k + 11 | 0] << 8 | m[k + 12 | 0] << 16 | m[k + 13 | 0] << 24) >>> 24, jr = Br, Mr = (Br = m[k + 15 | 0]) >>> 16 | 0, Mr |= jr, jr = Qe, jr = (Br = 2097151 & ((1 & Mr) << 31 | (Br = Br << 16 | ti) >>> 1)) >>> 0 > (Mr = Br + Jr | 0) >>> 0 ? jr + 1 | 0 : jr, ti = (Br = Mr) + (Mr = Zr(qo, Ln, 470296, 0)) | 0, Br = Qe + jr | 0, Br = Mr >>> 0 > ti >>> 0 ? Br + 1 | 0 : Br, Mr = Zr(ro, pr, 654183, 0), Br = Qe + Br | 0, Br = Mr >>> 0 > (jr = Mr + ti | 0) >>> 0 ? Br + 1 | 0 : Br, ti = (Mr = jr) + (jr = Zr(wo, So, -997805, -1)) | 0, Mr = Qe + Br | 0, Mr = jr >>> 0 > ti >>> 0 ? Mr + 1 | 0 : Mr, Br = Zr(io, ve, 136657, 0), Mr = Qe + Mr | 0, Xi = jr = Br + ti | 0, ti = Br >>> 0 > jr >>> 0 ? Mr + 1 | 0 : Mr, li = Mi - (Br = -2097152 & li) | 0, Jr = vn - ((Br >>> 0 > Mi >>> 0) + Nr | 0) | 0, jr = Zr(T, 0, 136657, 0), Br = Qe, Br = (Mr = (m[k + 28 | 0] | m[k + 29 | 0] << 8 | m[k + 30 | 0] << 16 | m[k + 31 | 0] << 24) >>> 7 & 2097151) >>> 0 > (jr = Mr + jr | 0) >>> 0 ? Br + 1 | 0 : Br, fi = (Mr = jr) + (jr = Zr(Qo, 0, -997805, -1)) | 0, Mr = Qe + Br | 0, Mr = jr >>> 0 > fi >>> 0 ? Mr + 1 | 0 : Mr, Br = Zr(M, cs, -683901, -1), Mr = Qe + Mr | 0, Mr = Br >>> 0 > (jr = Br + fi | 0) >>> 0 ? Mr + 1 | 0 : Mr, fi = (Br = Zr(E, 0, 666643, 0)) + jr | 0, jr = Qe + Mr | 0, jr = Br >>> 0 > fi >>> 0 ? jr + 1 | 0 : jr, Mr = Zr(ye, 0, 470296, 0), Br = Qe + jr | 0, Br = Mr >>> 0 > (fi = Mr + fi | 0) >>> 0 ? Br + 1 | 0 : Br, Mr = Zr(Ne, ms, 654183, 0), Br = Qe + Br | 0, Mr = (qn >> 21) + (Mr >>> 0 > (jr = Mr + fi | 0) >>> 0 ? Br + 1 | 0 : Br) | 0, Wi = Mr = (fi = (2097151 & qn) << 11 | Zn >>> 21) >>> 0 > (Zn = fi + jr | 0) >>> 0 ? Mr + 1 | 0 : Mr, qn = Br = Mr - ((Zn >>> 0 < 4293918720) - 1 | 0) | 0, fi = (2097151 & Br) << 11 | (Tr = Zn - -1048576 | 0) >>> 21, Br = (Br >> 21) + Jr | 0, bo = Br = (Mr = fi + li | 0) >>> 0 < fi >>> 0 ? Br + 1 | 0 : Br, fo = Mr, Mr = Zr(Mr, Br, -683901, -1), Br = Qe + ti | 0, fi = jr = Mr + Xi | 0, ti = Mr >>> 0 > jr >>> 0 ? Br + 1 | 0 : Br, Br = Zr(qo, Ln, 666643, 0), Mr = Qe, Mr = Br >>> 0 > (jr = Br + (Tn >>> 4 & 2097151) | 0) >>> 0 ? Mr + 1 | 0 : Mr, Br = Zr(ro, pr, 470296, 0), Mr = Qe + Mr | 0, Mr = Br >>> 0 > (jr = Br + jr | 0) >>> 0 ? Mr + 1 | 0 : Mr, Jr = (Br = Zr(wo, So, 654183, 0)) + jr | 0, jr = Qe + Mr | 0, jr = Br >>> 0 > Jr >>> 0 ? jr + 1 | 0 : jr, Mr = Zr(io, ve, -997805, -1), Br = Qe + jr | 0, Br = Mr >>> 0 > (Jr = Mr + Jr | 0) >>> 0 ? Br + 1 | 0 : Br, Mr = Zr(fo, bo, 136657, 0), Br = Qe + Br | 0, vn = Br = Mr >>> 0 > (Mi = Mr + Jr | 0) >>> 0 ? Br + 1 | 0 : Br, Ln = Mr = Br - ((Mi >>> 0 < 4293918720) - 1 | 0) | 0, Br = fi, fi = (2097151 & Mr) << 11 | (li = Mi - -1048576 | 0) >>> 21, Mr = (Mr >> 21) + ti | 0, qo = ti = (Mr = (jr = Br + fi | 0) >>> 0 < fi >>> 0 ? Mr + 1 | 0 : Mr) - ((jr >>> 0 < 4293918720) - 1 | 0) | 0, Br = (Br = ti >> 21) + ai | 0, as = fi = (ti = (2097151 & ti) << 11 | (Jr = jr - -1048576 | 0) >>> 21) + Vo | 0, Xi = ti >>> 0 > fi >>> 0 ? Br + 1 | 0 : Br, fi = jr, jr = Mr, ti = (Zn - (Mr = -2097152 & Tr) | 0) + (Tr = (2097151 & $n) << 11 | Ni >>> 21) | 0, Mr = (Wi - ((Mr >>> 0 > Zn >>> 0) + qn | 0) | 0) + ($n >> 21) | 0, Tn = Mr = ti >>> 0 < Tr >>> 0 ? Mr + 1 | 0 : Mr, Qo = Mr = Mr - ((ti >>> 0 < 4293918720) - 1 | 0) | 0, Ni = Br = Mr >> 21, Br = Zr(go = (2097151 & Mr) << 11 | (qn = ti - -1048576 | 0) >>> 21, Br, -683901, -1), jr = Qe + jr | 0, jr = Br >>> 0 > (Mr = Br + fi | 0) >>> 0 ? jr + 1 | 0 : jr, cs = Mr - (Br = -2097152 & Jr) | 0, ms = jr - ((Br >>> 0 > Mr >>> 0) + qo | 0) | 0, Br = Zr(go, Ni, 136657, 0), Mr = vn + Qe | 0, qo = (jr = Br + Mi | 0) - (Br = -2097152 & li) | 0, Zn = (Mr = jr >>> 0 < Mi >>> 0 ? Mr + 1 | 0 : Mr) - ((Br >>> 0 > jr >>> 0) + Ln | 0) | 0, Mr = Zr(ro, pr, 666643, 0), jr = Qe, jr = (Br = (m[k + 7 | 0] | m[k + 8 | 0] << 8 | m[k + 9 | 0] << 16 | m[k + 10 | 0] << 24) >>> 7 & 2097151) >>> 0 > (Mr = Br + Mr | 0) >>> 0 ? jr + 1 | 0 : jr, fi = (Br = Zr(wo, So, 470296, 0)) + Mr | 0, Mr = Qe + jr | 0, Mr = Br >>> 0 > fi >>> 0 ? Mr + 1 | 0 : Mr, Br = Zr(io, ve, 654183, 0), Mr = Qe + Mr | 0, Mr = Br >>> 0 > (jr = Br + fi | 0) >>> 0 ? Mr + 1 | 0 : Mr, fi = (Br = jr) + (jr = Zr(fo, bo, -997805, -1)) | 0, Br = Qe + Mr | 0, Tr = fi, fi = jr >>> 0 > fi >>> 0 ? Br + 1 | 0 : Br, vn = Zr(wo, So, 666643, 0), Br = (Mr = m[k + 6 | 0]) >>> 24 | 0, Jr = Mr << 8 | (Ln = m[k + 2 | 0] | m[k + 3 | 0] << 8 | m[k + 4 | 0] << 16 | m[k + 5 | 0] << 24) >>> 24, jr = Br, Mr = (Br = m[k + 7 | 0]) >>> 16 | 0, Mr = 2097151 & ((3 & (Mr |= jr)) << 30 | (Br = Br << 16 | Jr) >>> 2), Br = Qe, Br = Mr >>> 0 > (jr = Mr + vn | 0) >>> 0 ? Br + 1 | 0 : Br, Jr = (Mr = Zr(io, ve, 470296, 0)) + jr | 0, jr = Qe + Br | 0, jr = Mr >>> 0 > Jr >>> 0 ? jr + 1 | 0 : jr, Mr = Zr(fo, bo, 654183, 0), Br = Qe + jr | 0, vn = Br = Mr >>> 0 > (Wi = Mr + Jr | 0) >>> 0 ? Br + 1 | 0 : Br, $n = Br = Br - ((Wi >>> 0 < 4293918720) - 1 | 0) | 0, Mr = (jr = Br >> 21) + fi | 0, Mi = Br = (Mr = (Br = (2097151 & Br) << 11 | (li = Wi - -1048576 | 0) >>> 21) >>> 0 > (Jr = Br + Tr | 0) >>> 0 ? Mr + 1 | 0 : Mr) - ((Jr >>> 0 < 4293918720) - 1 | 0) | 0, Tr = (2097151 & Br) << 11 | (fi = Jr - -1048576 | 0) >>> 21, Br = (Br >> 21) + Zn | 0, qo = wo = Tr + qo | 0, Tr = Tr >>> 0 > wo >>> 0 ? Br + 1 | 0 : Br, Br = Zr(go, Ni, -997805, -1), Mr = Qe + Mr | 0, Mr = Br >>> 0 > (jr = Br + Jr | 0) >>> 0 ? Mr + 1 | 0 : Mr, ro = jr - (Br = -2097152 & fi) | 0, So = Mr - ((Br >>> 0 > jr >>> 0) + Mi | 0) | 0, Mr = Zr(go, Ni, 654183, 0), Br = vn + Qe | 0, wo = (jr = Mr + Wi | 0) - (Mr = -2097152 & li) | 0, Zn = (Br = jr >>> 0 < Wi >>> 0 ? Br + 1 | 0 : Br) - ((Mr >>> 0 > jr >>> 0) + $n | 0) | 0, Br = Zr(io, ve, 666643, 0), Mr = Qe, Mr = Br >>> 0 > (jr = Br + (Ln >>> 5 & 2097151) | 0) >>> 0 ? Mr + 1 | 0 : Mr, Br = Zr(fo, bo, 470296, 0), Mr = Qe + Mr | 0, Jr = jr = Br + jr | 0, jr = Br >>> 0 > jr >>> 0 ? Mr + 1 | 0 : Mr, fi = Zr(fo, bo, 666643, 0), Mr = (Br = m[k + 2 | 0]) << 16 & 2031616 | m[0 | k] | m[k + 1 | 0] << 8, Br = Qe, vn = Br = Mr >>> 0 > (Mi = fi + Mr | 0) >>> 0 ? Br + 1 | 0 : Br, bo = Br = Br - ((Mi >>> 0 < 4293918720) - 1 | 0) | 0, fi = (2097151 & Br) << 11 | (li = Mi - -1048576 | 0) >>> 21, Br = (Br >> 21) + jr | 0, jr = Br = fi >>> 0 > (Wi = fi + Jr | 0) >>> 0 ? Br + 1 | 0 : Br, $n = Br = Br - ((Wi >>> 0 < 4293918720) - 1 | 0) | 0, fi = (2097151 & Br) << 11 | (Jr = Wi - -1048576 | 0) >>> 21, Br = (Br >> 21) + Zn | 0, fi = fi >>> 0 > (fo = fi + wo | 0) >>> 0 ? Br + 1 | 0 : Br, Br = Zr(go, Ni, 470296, 0), jr = jr + Qe | 0, jr = (Mr = Br + Wi | 0) >>> 0 < Wi >>> 0 ? jr + 1 | 0 : jr, Wi = Mr - (Br = -2097152 & Jr) | 0, Jr = jr - ((Br >>> 0 > Mr >>> 0) + $n | 0) | 0, Mr = Zr(go, Ni, 666643, 0), Br = Qe + (vn - (((jr = -2097152 & li) >>> 0 > Mi >>> 0) + bo | 0) | 0) | 0, Mr = (jr = (Br = Mr >>> 0 > (Zn = Mr + (Mi - jr | 0) | 0) >>> 0 ? Br + 1 | 0 : Br) >> 21) + Jr | 0, Br = (Br = (Mr = (Br = (2097151 & Br) << 11 | Zn >>> 21) >>> 0 > ($n = Br + Wi | 0) >>> 0 ? Mr + 1 | 0 : Mr) >> 21) + fi | 0, Mr = (Mr = (Br = (Mr = (2097151 & Mr) << 11 | $n >>> 21) >>> 0 > (Ni = Mr + fo | 0) >>> 0 ? Br + 1 | 0 : Br) >> 21) + So | 0, jr = (Br = (Mr = (Br = (2097151 & Br) << 11 | Ni >>> 21) >>> 0 > (fi = Br + ro | 0) >>> 0 ? Mr + 1 | 0 : Mr) >> 21) + Tr | 0, Br = (Mr = (jr = (Mr = (2097151 & Mr) << 11 | fi >>> 21) >>> 0 > (Mi = Mr + qo | 0) >>> 0 ? jr + 1 | 0 : jr) >> 21) + ms | 0, Mr = (jr = (Br = (jr = (2097151 & jr) << 11 | Mi >>> 21) >>> 0 > (Wi = jr + cs | 0) >>> 0 ? Br + 1 | 0 : Br) >> 21) + Xi | 0, Xi = Jr = (Br = (2097151 & Br) << 11 | Wi >>> 21) + as | 0, Br = (Br = (Mr = Br >>> 0 > Jr >>> 0 ? Mr + 1 | 0 : Mr) >> 21) + Eo | 0, Mr = (Mr = (Br = (Mr = (2097151 & Mr) << 11 | Jr >>> 21) >>> 0 > (Tr = Mr + Fi | 0) >>> 0 ? Br + 1 | 0 : Br) >> 21) + Yi | 0, jr = (Br = (Mr = (Br = (2097151 & Br) << 11 | Tr >>> 21) >>> 0 > (vn = Br + ci | 0) >>> 0 ? Mr + 1 | 0 : Mr) >> 21) + Pr | 0, Br = (Mr = (jr = (Mr = (2097151 & Mr) << 11 | vn >>> 21) >>> 0 > (li = Mr + gr | 0) >>> 0 ? jr + 1 | 0 : jr) >> 21) + to | 0, qn = (Yi = ti - (Mr = -2097152 & qn) | 0) + ((2097151 & (Br = (jr = (2097151 & jr) << 11 | li >>> 21) >>> 0 > (Jr = jr + cr | 0) >>> 0 ? Br + 1 | 0 : Br)) << 11 | Jr >>> 21) | 0, Br = (Tn - ((Mr >>> 0 > ti >>> 0) + Qo | 0) | 0) + (Br >> 21) | 0, Tn = Mr = (Br = Yi >>> 0 > qn >>> 0 ? Br + 1 | 0 : Br) >> 21, Zn = (Br = Zr(to = (2097151 & Br) << 11 | qn >>> 21, Mr, 666643, 0)) + (Mr = 2097151 & Zn) | 0, Br = Qe, ti = Br = Mr >>> 0 > Zn >>> 0 ? Br + 1 | 0 : Br, B[0 | k] = Zn, B[k + 1 | 0] = (255 & Br) << 24 | Zn >>> 8, Br = 2097151 & $n, Mr = Zr(to, Tn, 470296, 0) + Br | 0, jr = Qe, Br = (ti >> 21) + (Br >>> 0 > Mr >>> 0 ? jr + 1 | 0 : jr) | 0, Br = (Yi = (2097151 & ti) << 11 | Zn >>> 21) >>> 0 > ($n = Yi + Mr | 0) >>> 0 ? Br + 1 | 0 : Br, B[k + 4 | 0] = (2047 & Br) << 21 | $n >>> 11, Mr = Br, jr = $n, B[k + 3 | 0] = (7 & Br) << 29 | jr >>> 3, B[k + 2 | 0] = 31 & ((65535 & ti) << 16 | Zn >>> 16) | jr << 5, ti = 2097151 & Ni, Ni = Zr(to, Tn, 654183, 0) + ti | 0, Br = Qe, $n = (2097151 & Mr) << 11 | jr >>> 21, Mr = (Mr >> 21) + (ti = ti >>> 0 > Ni >>> 0 ? Br + 1 | 0 : Br) | 0, Br = Mr = (Ni = $n + Ni | 0) >>> 0 < $n >>> 0 ? Mr + 1 | 0 : Mr, B[k + 6 | 0] = (63 & Br) << 26 | Ni >>> 6, ti = Ni, Ni = 0, B[k + 5 | 0] = Ni << 13 | (1572864 & jr) >>> 19 | ti << 2, jr = 2097151 & fi, fi = Zr(to, Tn, -997805, -1) + jr | 0, Mr = Qe, Mr = jr >>> 0 > fi >>> 0 ? Mr + 1 | 0 : Mr, Ni = (2097151 & (jr = Br)) << 11 | ti >>> 21, jr = (Br >>= 21) + Mr | 0, jr = (fi = Ni + fi | 0) >>> 0 < Ni >>> 0 ? jr + 1 | 0 : jr, B[k + 9 | 0] = (511 & jr) << 23 | fi >>> 9, B[k + 8 | 0] = (1 & jr) << 31 | fi >>> 1, Mr = 0, B[k + 7 | 0] = Mr << 18 | (2080768 & ti) >>> 14 | fi << 7, Mr = 2097151 & Mi, ti = Zr(to, Tn, 136657, 0) + Mr | 0, Br = Qe, Br = Mr >>> 0 > ti >>> 0 ? Br + 1 | 0 : Br, Mi = (2097151 & (Mr = jr)) << 11 | fi >>> 21, Mr = Br + (jr = Mr >> 21) | 0, Mr = (ti = Mi + ti | 0) >>> 0 < Mi >>> 0 ? Mr + 1 | 0 : Mr, B[k + 12 | 0] = (4095 & Mr) << 20 | ti >>> 12, jr = ti, B[k + 11 | 0] = (15 & Mr) << 28 | jr >>> 4, ti = 0, B[k + 10 | 0] = ti << 15 | (1966080 & fi) >>> 17 | jr << 4, ti = 2097151 & Wi, fi = Zr(to, Tn, -683901, -1) + ti | 0, Br = Qe, Br = ti >>> 0 > fi >>> 0 ? Br + 1 | 0 : Br, ti = Mr, Mr = Br + (Mr >>= 21) | 0, Mr = (ti = (wo = fi) + (fi = (2097151 & ti) << 11 | jr >>> 21) | 0) >>> 0 < fi >>> 0 ? Mr + 1 | 0 : Mr, B[k + 14 | 0] = (127 & Mr) << 25 | ti >>> 7, fi = 0, B[k + 13 | 0] = fi << 12 | (1048576 & jr) >>> 20 | ti << 1, Br = Mr >> 21, jr = (Mr = (2097151 & Mr) << 11 | ti >>> 21) >>> 0 > (fi = Mr + (2097151 & Xi) | 0) >>> 0 ? Br + 1 | 0 : Br, B[k + 17 | 0] = (1023 & jr) << 22 | fi >>> 10, B[k + 16 | 0] = (3 & jr) << 30 | fi >>> 2, Mr = 0, B[k + 15 | 0] = Mr << 17 | (2064384 & ti) >>> 15 | fi << 6, Br = jr >> 21, Br = (Mr = (2097151 & jr) << 11 | fi >>> 21) >>> 0 > (jr = Mr + (2097151 & Tr) | 0) >>> 0 ? Br + 1 | 0 : Br, B[k + 20 | 0] = (8191 & Br) << 19 | jr >>> 13, B[k + 19 | 0] = (31 & Br) << 27 | jr >>> 5, ti = (Mr = 2097151 & vn) + (vn = (2097151 & Br) << 11 | jr >>> 21) | 0, Mr = Br >> 21, Mr = ti >>> 0 < vn >>> 0 ? Mr + 1 | 0 : Mr, vn = ti, B[k + 21 | 0] = ti, Tr = 0, B[k + 18 | 0] = Tr << 14 | (1835008 & fi) >>> 18 | jr << 3, B[k + 22 | 0] = (255 & Mr) << 24 | ti >>> 8, jr = Mr >> 21, jr = (ti = (fi = (2097151 & Mr) << 11 | ti >>> 21) + (2097151 & li) | 0) >>> 0 < fi >>> 0 ? jr + 1 | 0 : jr, B[k + 25 | 0] = (2047 & jr) << 21 | ti >>> 11, B[k + 24 | 0] = (7 & jr) << 29 | ti >>> 3, B[k + 23 | 0] = 31 & ((65535 & Mr) << 16 | vn >>> 16) | ti << 5, Br = jr >> 21, Br = (Mr = (2097151 & jr) << 11 | ti >>> 21) >>> 0 > (jr = Mr + (2097151 & Jr) | 0) >>> 0 ? Br + 1 | 0 : Br, B[k + 27 | 0] = (63 & Br) << 26 | jr >>> 6, fi = 0, B[k + 26 | 0] = fi << 13 | (1572864 & ti) >>> 19 | jr << 2, Mr = Br, Br >>= 21, Mr = (ti = (Jr = (2097151 & Mr) << 11 | jr >>> 21) + (fi = 2097151 & qn) | 0) >>> 0 < fi >>> 0 ? Br + 1 | 0 : Br, B[k + 31 | 0] = (131071 & Mr) << 15 | ti >>> 17, Br = ti, B[k + 30 | 0] = (511 & Mr) << 23 | Br >>> 9, ti = 0, B[k + 28 | 0] = ti << 18 | (2080768 & jr) >>> 14 | Br << 7, B[k + 29 | 0] = Jr + qn >>> 1;
                    }
                    function Oi(k, E, T) {
                      var M, ye = 0, Ne = 0, pr = 0, ve = 0, cr = 0, gr = 0, Pr = 0, Nr = 0, Br = 0, Mr = 0, jr = 0, ti = 0, fi = 0, Jr = 0, li = 0, Tr = 0, Mi = 0, Wi = 0, vn = 0, Tn = 0, Ni = 0, Yi = 0, Xi = 0, $n = 0, Zn = 0, to = 0, fo = 0, wo = 0, bo = 0, go = 0, qn = 0, io = 0, So = 0, qo = 0, Ln = 0, ro = 0, Qo = 0, Vo = 0, as = 0, cs = 0, ms = 0, ai = 0, ci = 0, Fi = 0;
                      for (dr = ve = dr - 2048 | 0, fa(ve + 1024 | 0, E, 1024), E = 0; Ne = o[(gr = (pr = ve + 1024 | 0) + (ye = E << 3) | 0) >> 2], cr = o[(Pr = k + ye | 0) >> 2], Pr = o[gr + 4 >> 2] ^ o[Pr + 4 >> 2], o[gr >> 2] = Ne ^ cr, o[gr + 4 >> 2] = Pr, Pr = o[(gr = (Ne = 8 | ye) + pr | 0) >> 2], cr = o[(Ne = k + Ne | 0) >> 2], Ne = o[gr + 4 >> 2] ^ o[Ne + 4 >> 2], o[gr >> 2] = cr ^ Pr, o[gr + 4 >> 2] = Ne, Pr = o[(gr = (Ne = 16 | ye) + pr | 0) >> 2], cr = o[(Ne = k + Ne | 0) >> 2], Ne = o[gr + 4 >> 2] ^ o[Ne + 4 >> 2], o[gr >> 2] = cr ^ Pr, o[gr + 4 >> 2] = Ne, Ne = o[(ye = (gr = 24 | ye) + pr | 0) >> 2], Pr = o[(gr = k + gr | 0) >> 2], gr = o[ye + 4 >> 2] ^ o[gr + 4 >> 2], o[ye >> 2] = Ne ^ Pr, o[ye + 4 >> 2] = gr, (0 | (E = E + 4 | 0)) != 128; ) ;
                      for (M = fa(ve, pr, 1024), k = 0, E = 0; ve = o[(ye = (pr = E << 3) + M | 0) >> 2], Ne = o[(gr = T + pr | 0) >> 2], gr = o[ye + 4 >> 2] ^ o[gr + 4 >> 2], o[ye >> 2] = Ne ^ ve, o[ye + 4 >> 2] = gr, gr = o[(ye = (ve = 8 | pr) + M | 0) >> 2], Ne = o[(ve = T + ve | 0) >> 2], ve = o[ye + 4 >> 2] ^ o[ve + 4 >> 2], o[ye >> 2] = Ne ^ gr, o[ye + 4 >> 2] = ve, gr = o[(ye = (ve = 16 | pr) + M | 0) >> 2], Ne = o[(ve = T + ve | 0) >> 2], ve = o[ye + 4 >> 2] ^ o[ve + 4 >> 2], o[ye >> 2] = Ne ^ gr, o[ye + 4 >> 2] = ve, ve = o[(pr = (ye = 24 | pr) + M | 0) >> 2], gr = o[(ye = T + ye | 0) >> 2], ye = o[pr + 4 >> 2] ^ o[ye + 4 >> 2], o[pr >> 2] = ve ^ gr, o[pr + 4 >> 2] = ye, (0 | (E = E + 4 | 0)) != 128; ) ;
                      for (; Pr = (Ne = o[56 + (pr = (M + 1024 | 0) + (k << 7) | 0) >> 2]) + (ye = o[pr + 24 >> 2]) | 0, E = (Nr = o[pr + 60 >> 2]) + (ve = o[pr + 28 >> 2]) | 0, gr = ye >>> 0 > Pr >>> 0 ? E + 1 | 0 : E, ve = Zr(ye << 1 & -2, 1 & (ve << 1 | ye >>> 31), Ne, 0), E = Qe + gr | 0, gr = (ye = ve + Pr | 0) >>> 0 < ve >>> 0 ? E + 1 | 0 : E, Mr = (Pr = Ci(o[pr + 120 >> 2] ^ ye, gr ^ o[pr + 124 >> 2], 32)) + (ve = o[pr + 88 >> 2]) | 0, E = (jr = Qe) + (cr = o[pr + 92 >> 2]) | 0, Br = ve >>> 0 > Mr >>> 0 ? E + 1 | 0 : E, cr = Zr(ve << 1 & -2, 1 & (cr << 1 | ve >>> 31), Pr, 0), E = Qe + Br | 0, So = Ci(Ne ^ (ve = cr + Mr | 0), Nr ^ (ti = ve >>> 0 < cr >>> 0 ? E + 1 | 0 : E), 40), E = gr + (as = Qe) | 0, Ne = (cr = ye + So | 0) >>> 0 < ye >>> 0 ? E + 1 | 0 : E, ye = Zr(So, 0, ye << 1 & -2, 1 & (gr << 1 | ye >>> 31)), E = Qe + Ne | 0, to = Ci(Pr ^ (Wi = ye + cr | 0), jr ^ (Zn = ye >>> 0 > Wi >>> 0 ? E + 1 | 0 : E), 48), cs = E = Qe, Jr = to, Mr = E, cr = (Pr = o[pr + 40 >> 2]) + (ye = o[pr + 8 >> 2]) | 0, E = (fo = o[pr + 44 >> 2]) + (gr = o[pr + 12 >> 2]) | 0, Ne = ye >>> 0 > cr >>> 0 ? E + 1 | 0 : E, gr = Zr(ye << 1 & -2, 1 & (gr << 1 | ye >>> 31), Pr, 0), E = Qe + Ne | 0, Ne = (ye = gr + cr | 0) >>> 0 < gr >>> 0 ? E + 1 | 0 : E, jr = (cr = Ci(o[pr + 104 >> 2] ^ ye, Ne ^ o[pr + 108 >> 2], 32)) + (gr = o[pr + 72 >> 2]) | 0, E = (li = Qe) + (Br = o[pr + 76 >> 2]) | 0, Nr = gr >>> 0 > jr >>> 0 ? E + 1 | 0 : E, Br = Zr(gr << 1 & -2, 1 & (Br << 1 | gr >>> 31), cr, 0), E = Qe + Nr | 0, Br = Ci(Nr = (gr = Br + jr | 0) ^ Pr, fo ^ (Pr = gr >>> 0 < Br >>> 0 ? E + 1 | 0 : E), 40), E = Ne + (Tr = Qe) | 0, Nr = (jr = ye + Br | 0) >>> 0 < ye >>> 0 ? E + 1 | 0 : E, Ne = Zr(Br, 0, ye << 1 & -2, 1 & (Ne << 1 | ye >>> 31)), E = Qe + Nr | 0, qo = Ci((ye = Ne + jr | 0) ^ cr, li ^ (jr = ye >>> 0 < Ne >>> 0 ? E + 1 | 0 : E), 48), E = Pr + (Ln = Qe) | 0, Ne = (cr = gr + qo | 0) >>> 0 < gr >>> 0 ? E + 1 | 0 : E, Pr = Zr(qo, 0, gr << 1 & -2, 1 & (Pr << 1 | gr >>> 31)), E = Qe + Ne | 0, Yi = Ci((gr = Pr + cr | 0) ^ Br, Tr ^ (fo = gr >>> 0 < Pr >>> 0 ? E + 1 | 0 : E), 1), ro = E = Qe, Mi = Yi, Nr = E, li = (Br = o[pr + 32 >> 2]) + (Ne = o[pr >> 2]) | 0, E = (wo = o[pr + 36 >> 2]) + (Pr = o[pr + 4 >> 2]) | 0, cr = Ne >>> 0 > li >>> 0 ? E + 1 | 0 : E, Pr = Zr(Ne << 1 & -2, 1 & (Pr << 1 | Ne >>> 31), Br, 0), E = Qe + cr | 0, cr = (Ne = Pr + li | 0) >>> 0 < Pr >>> 0 ? E + 1 | 0 : E, fi = (bo = Ci(o[pr + 96 >> 2] ^ Ne, cr ^ o[pr + 100 >> 2], 32)) + (Pr = o[(E = vn = pr - -64 | 0) >> 2]) | 0, E = (Vo = Qe) + (li = o[E + 4 >> 2]) | 0, Tr = Pr >>> 0 > fi >>> 0 ? E + 1 | 0 : E, li = Zr(Pr << 1 & -2, 1 & (li << 1 | Pr >>> 31), bo, 0), E = Qe + Tr | 0, wo = Ci((Pr = li + fi | 0) ^ Br, wo ^ (li = Pr >>> 0 < li >>> 0 ? E + 1 | 0 : E), 40), E = cr + (ms = Qe) | 0, Br = (Tr = Ne + wo | 0) >>> 0 < Ne >>> 0 ? E + 1 | 0 : E, cr = Zr(wo, 0, Ne << 1 & -2, 1 & (cr << 1 | Ne >>> 31)), E = Qe + Br | 0, E = (Tr = (Ne = cr + Tr | 0) >>> 0 < cr >>> 0 ? E + 1 | 0 : E) + Nr | 0, Br = (cr = Ne + Mi | 0) >>> 0 < Ne >>> 0 ? E + 1 | 0 : E, Nr = Zr(Mi, 0, Ne << 1 & -2, 1 & (Tr << 1 | Ne >>> 31)), E = Qe + Br | 0, go = Ci((cr = Nr + cr | 0) ^ Jr, (fi = cr >>> 0 < Nr >>> 0 ? E + 1 | 0 : E) ^ Mr, 32), Qo = E = Qe, Tn = E, Mi = (Jr = o[pr + 48 >> 2]) + (Br = o[pr + 16 >> 2]) | 0, E = (qn = o[pr + 52 >> 2]) + (Mr = o[pr + 20 >> 2]) | 0, Nr = Br >>> 0 > Mi >>> 0 ? E + 1 | 0 : E, Mr = Zr(Br << 1 & -2, 1 & (Mr << 1 | Br >>> 31), Jr, 0), E = Qe + Nr | 0, Nr = (Br = Mr + Mi | 0) >>> 0 < Mr >>> 0 ? E + 1 | 0 : E, Ni = (Mi = Ci(o[pr + 112 >> 2] ^ Br, Nr ^ o[pr + 116 >> 2], 32)) + (Mr = o[pr + 80 >> 2]) | 0, E = (io = Qe) + (Xi = o[pr + 84 >> 2]) | 0, $n = Mr >>> 0 > Ni >>> 0 ? E + 1 | 0 : E, Xi = Zr(Mr << 1 & -2, 1 & (Xi << 1 | Mr >>> 31), Mi, 0), E = Qe + $n | 0, Xi = Ci(Ni = (Mr = Xi + Ni | 0) ^ Jr, qn ^ (Jr = Mr >>> 0 < Xi >>> 0 ? E + 1 | 0 : E), 40), E = Nr + (qn = Qe) | 0, $n = (Ni = Br + Xi | 0) >>> 0 < Br >>> 0 ? E + 1 | 0 : E, Nr = Zr(Xi, 0, Br << 1 & -2, 1 & (Nr << 1 | Br >>> 31)), E = Qe + $n | 0, $n = Ci(Ni = (Br = Nr + Ni | 0) ^ Mi, io ^ (Mi = Nr >>> 0 > Br >>> 0 ? E + 1 | 0 : E), 48), E = Jr + (io = Qe) | 0, Nr = (Ni = Mr + $n | 0) >>> 0 < Mr >>> 0 ? E + 1 | 0 : E, Jr = Zr($n, 0, Mr << 1 & -2, 1 & (Jr << 1 | Mr >>> 31)), E = Qe + Nr | 0, E = (Jr = (Mr = Jr + Ni | 0) >>> 0 < Jr >>> 0 ? E + 1 | 0 : E) + Tn | 0, Tn = (Nr = Mr + go | 0) >>> 0 < Mr >>> 0 ? E + 1 | 0 : E, Ni = Zr(go, 0, Mr << 1 & -2, 1 & (Jr << 1 | Mr >>> 31)), E = Qe + Tn | 0, Tn = Ci(Tn = (Nr = Ni + Nr | 0) ^ Yi, ro ^ (Yi = Nr >>> 0 < Ni >>> 0 ? E + 1 | 0 : E), 40), E = fi + (ro = Qe) | 0, Ni = (ai = cr + Tn | 0) >>> 0 < cr >>> 0 ? E + 1 | 0 : E, cr = (fi = Zr(Tn, 0, cr << 1 & -2, 1 & (fi << 1 | cr >>> 31))) + ai | 0, E = Qe + Ni | 0, o[pr >> 2] = cr, E = cr >>> 0 < fi >>> 0 ? E + 1 | 0 : E, o[pr + 4 >> 2] = E, cr = Ci(cr ^ go, E ^ Qo, 48), o[pr + 120 >> 2] = cr, E = Qe, o[pr + 124 >> 2] = E, E = E + Yi | 0, fi = (go = cr + Nr | 0) >>> 0 < Nr >>> 0 ? E + 1 | 0 : E, cr = (Nr = Zr(cr, 0, Nr << 1 & -2, 1 & (Yi << 1 | Nr >>> 31))) + go | 0, E = Qe + fi | 0, o[pr + 80 >> 2] = cr, E = cr >>> 0 < Nr >>> 0 ? E + 1 | 0 : E, o[pr + 84 >> 2] = E, ci = pr, Fi = Ci(cr ^ Tn, E ^ ro, 1), o[ci + 40 >> 2] = Fi, o[pr + 44 >> 2] = Qe, E = ti + cs | 0, cr = (Nr = ve + to | 0) >>> 0 < ve >>> 0 ? E + 1 | 0 : E, ve = Zr(to, 0, ve << 1 & -2, 1 & (ti << 1 | ve >>> 31)), E = Qe + cr | 0, cr = E = ve >>> 0 > (Nr = ve + Nr | 0) >>> 0 ? E + 1 | 0 : E, ve = E, Mr = Ci(Mr ^ Xi, Jr ^ qn, 1), E = jr + (Jr = Qe) | 0, ti = (fi = ye + Mr | 0) >>> 0 < ye >>> 0 ? E + 1 | 0 : E, ye = (jr = Zr(Mr, 0, ye << 1 & -2, 1 & (jr << 1 | ye >>> 31))) + fi | 0, E = Qe + ti | 0, Tr = Ci(Ne ^ bo, Tr ^ Vo, 48), jr = Ci(Tr ^ ye, (Ne = ye >>> 0 < jr >>> 0 ? E + 1 | 0 : E) ^ (Yi = Qe), 32), E = (to = Qe) + ve | 0, ti = jr >>> 0 > (fi = jr + Nr | 0) >>> 0 ? E + 1 | 0 : E, ve = (E = fi) + (fi = Zr(Nr << 1 & -2, 1 & (ve << 1 | Nr >>> 31), jr, 0)) | 0, E = Qe + ti | 0, ti = Ci(Tn = ve ^ Mr, Jr ^ (Mr = ve >>> 0 < fi >>> 0 ? E + 1 | 0 : E), 40), E = Ne + (fi = Qe) | 0, Jr = (bo = ye + ti | 0) >>> 0 < ye >>> 0 ? E + 1 | 0 : E, ye = Zr(ti, 0, ye << 1 & -2, 1 & (Ne << 1 | ye >>> 31)), E = Qe + Jr | 0, ye = Ci((Ne = ye + bo | 0) ^ jr, to ^ (E = ye >>> 0 > Ne >>> 0 ? E + 1 | 0 : E), 48), o[pr + 96 >> 2] = ye, jr = Qe, o[pr + 100 >> 2] = jr, o[pr + 8 >> 2] = Ne, o[pr + 12 >> 2] = E, E = Mr + jr | 0, Ne = (jr = ye + ve | 0) >>> 0 < ve >>> 0 ? E + 1 | 0 : E, ve = Zr(ye, 0, ve << 1 & -2, 1 & (Mr << 1 | ve >>> 31)), E = Qe + Ne | 0, ci = pr, Fi = Ci((ye = ve + jr | 0) ^ ti, (E = ye >>> 0 < ve >>> 0 ? E + 1 | 0 : E) ^ fi, 1), o[ci + 48 >> 2] = Fi, o[pr + 52 >> 2] = Qe, o[pr + 88 >> 2] = ye, o[pr + 92 >> 2] = E, Mr = Ci(Nr ^ So, cr ^ as, 1), E = Mi + (ti = Qe) | 0, ve = (ye = Br + Mr | 0) >>> 0 < Br >>> 0 ? E + 1 | 0 : E, Ne = Zr(Mr, 0, Br << 1 & -2, 1 & (Mi << 1 | Br >>> 31)), E = Qe + ve | 0, Nr = Ci((ye = Ne + ye | 0) ^ qo, Ln ^ (cr = ye >>> 0 < Ne >>> 0 ? E + 1 | 0 : E), 32), jr = E = Qe, Ne = E, E = li + Yi | 0, Br = (ve = Pr + Tr | 0) >>> 0 < Pr >>> 0 ? E + 1 | 0 : E, Pr = Zr(Tr, 0, Pr << 1 & -2, 1 & (li << 1 | Pr >>> 31)), E = Qe + Br | 0, E = (Pr = (ve = Pr + ve | 0) >>> 0 < Pr >>> 0 ? E + 1 | 0 : E) + Ne | 0, Br = (Ne = ve + Nr | 0) >>> 0 < ve >>> 0 ? E + 1 | 0 : E, li = Zr(Nr, 0, ve << 1 & -2, 1 & (Pr << 1 | ve >>> 31)), E = Qe + Br | 0, Mr = Ci((Ne = li + Ne | 0) ^ Mr, ti ^ (Br = Ne >>> 0 < li >>> 0 ? E + 1 | 0 : E), 40), E = cr + (li = Qe) | 0, ti = (Tr = ye + Mr | 0) >>> 0 < ye >>> 0 ? E + 1 | 0 : E, ye = (cr = Zr(Mr, 0, ye << 1 & -2, 1 & (cr << 1 | ye >>> 31))) + Tr | 0, E = Qe + ti | 0, o[pr + 16 >> 2] = ye, E = ye >>> 0 < cr >>> 0 ? E + 1 | 0 : E, o[pr + 20 >> 2] = E, ye = Ci(ye ^ Nr, E ^ jr, 48), o[pr + 104 >> 2] = ye, E = Qe, o[pr + 108 >> 2] = E, cr = vn, E = E + Br | 0, Nr = (ti = ye + Ne | 0) >>> 0 < Ne >>> 0 ? E + 1 | 0 : E, Ne = Zr(ye, 0, Ne << 1 & -2, 1 & (Br << 1 | Ne >>> 31)), E = Qe + Nr | 0, Br = ye = Ne + ti | 0, Nr = E = ye >>> 0 < Ne >>> 0 ? E + 1 | 0 : E, o[cr >> 2] = ye, o[cr + 4 >> 2] = E, Pr = Ci(ve ^ wo, Pr ^ ms, 1), E = (jr = Qe) + Zn | 0, ve = (ye = Pr + Wi | 0) >>> 0 < Pr >>> 0 ? E + 1 | 0 : E, Ne = Zr(Wi << 1 & -2, 1 & (Zn << 1 | Wi >>> 31), Pr, 0), E = Qe + ve | 0, cr = Ci((ye = Ne + ye | 0) ^ $n, io ^ (Ne = ye >>> 0 < Ne >>> 0 ? E + 1 | 0 : E), 32), E = fo + (Wi = Qe) | 0, ti = (ve = cr + gr | 0) >>> 0 < gr >>> 0 ? E + 1 | 0 : E, gr = Zr(cr, 0, gr << 1 & -2, 1 & (fo << 1 | gr >>> 31)), E = Qe + ti | 0, Pr = Ci((ve = gr + ve | 0) ^ Pr, jr ^ (gr = ve >>> 0 < gr >>> 0 ? E + 1 | 0 : E), 40), E = Ne + (Zn = Qe) | 0, ti = (jr = ye + Pr | 0) >>> 0 < ye >>> 0 ? E + 1 | 0 : E, Ne = Zr(Pr, 0, ye << 1 & -2, 1 & (Ne << 1 | ye >>> 31)), E = Qe + ti | 0, E = (ye = Ne + jr | 0) >>> 0 < Ne >>> 0 ? E + 1 | 0 : E, Ne = ye, ye ^= cr, cr = E, ye = Ci(ye, Wi ^ E, 48), E = gr + (Wi = Qe) | 0, ti = (jr = ye + ve | 0) >>> 0 < ve >>> 0 ? E + 1 | 0 : E, ve = (gr = Zr(ye, 0, ve << 1 & -2, 1 & (gr << 1 | ve >>> 31))) + jr | 0, E = Qe + ti | 0, o[pr + 72 >> 2] = ve, E = ve >>> 0 < gr >>> 0 ? E + 1 | 0 : E, o[pr + 76 >> 2] = E, o[pr + 112 >> 2] = ye, o[pr + 116 >> 2] = Wi, o[pr + 24 >> 2] = Ne, o[pr + 28 >> 2] = cr, ci = pr, Fi = Ci(Br ^ Mr, Nr ^ li, 1), o[ci + 56 >> 2] = Fi, o[pr + 60 >> 2] = Qe, ci = pr, Fi = Ci(ve ^ Pr, E ^ Zn, 1), o[ci + 32 >> 2] = Fi, o[pr + 36 >> 2] = Qe, (0 | (k = k + 1 | 0)) != 8; ) ;
                      for (k = 0; Pr = (Ne = o[392 + (pr = (M + 1024 | 0) + (k << 4) | 0) >> 2]) + (ye = o[pr + 136 >> 2]) | 0, E = (Nr = o[pr + 396 >> 2]) + (ve = o[pr + 140 >> 2]) | 0, gr = ye >>> 0 > Pr >>> 0 ? E + 1 | 0 : E, ve = Zr(ye << 1 & -2, 1 & (ve << 1 | ye >>> 31), Ne, 0), E = Qe + gr | 0, gr = (ye = ve + Pr | 0) >>> 0 < ve >>> 0 ? E + 1 | 0 : E, Mr = (Pr = Ci(o[pr + 904 >> 2] ^ ye, gr ^ o[pr + 908 >> 2], 32)) + (ve = o[pr + 648 >> 2]) | 0, E = (jr = Qe) + (cr = o[pr + 652 >> 2]) | 0, Br = ve >>> 0 > Mr >>> 0 ? E + 1 | 0 : E, cr = Zr(ve << 1 & -2, 1 & (cr << 1 | ve >>> 31), Pr, 0), E = Qe + Br | 0, So = Ci(Ne ^ (ve = cr + Mr | 0), Nr ^ (ti = ve >>> 0 < cr >>> 0 ? E + 1 | 0 : E), 40), E = gr + (Ni = Qe) | 0, Ne = (cr = ye + So | 0) >>> 0 < ye >>> 0 ? E + 1 | 0 : E, ye = Zr(So, 0, ye << 1 & -2, 1 & (gr << 1 | ye >>> 31)), E = Qe + Ne | 0, to = Ci(Pr ^ (Wi = ye + cr | 0), jr ^ (Zn = ye >>> 0 > Wi >>> 0 ? E + 1 | 0 : E), 48), as = E = Qe, Jr = to, Mr = E, cr = (Pr = o[pr + 264 >> 2]) + (ye = o[pr + 8 >> 2]) | 0, E = (fo = o[pr + 268 >> 2]) + (gr = o[pr + 12 >> 2]) | 0, Ne = ye >>> 0 > cr >>> 0 ? E + 1 | 0 : E, gr = Zr(ye << 1 & -2, 1 & (gr << 1 | ye >>> 31), Pr, 0), E = Qe + Ne | 0, Ne = (ye = gr + cr | 0) >>> 0 < gr >>> 0 ? E + 1 | 0 : E, jr = (cr = Ci(o[pr + 776 >> 2] ^ ye, Ne ^ o[pr + 780 >> 2], 32)) + (gr = o[pr + 520 >> 2]) | 0, E = (li = Qe) + (Br = o[pr + 524 >> 2]) | 0, Nr = gr >>> 0 > jr >>> 0 ? E + 1 | 0 : E, Br = Zr(gr << 1 & -2, 1 & (Br << 1 | gr >>> 31), cr, 0), E = Qe + Nr | 0, Br = Ci(Nr = (gr = Br + jr | 0) ^ Pr, fo ^ (Pr = gr >>> 0 < Br >>> 0 ? E + 1 | 0 : E), 40), E = Ne + (Tr = Qe) | 0, Nr = (jr = ye + Br | 0) >>> 0 < ye >>> 0 ? E + 1 | 0 : E, Ne = Zr(Br, 0, ye << 1 & -2, 1 & (Ne << 1 | ye >>> 31)), E = Qe + Nr | 0, qo = Ci((ye = Ne + jr | 0) ^ cr, li ^ (jr = ye >>> 0 < Ne >>> 0 ? E + 1 | 0 : E), 48), E = Pr + (cs = Qe) | 0, Ne = (cr = gr + qo | 0) >>> 0 < gr >>> 0 ? E + 1 | 0 : E, Pr = Zr(qo, 0, gr << 1 & -2, 1 & (Pr << 1 | gr >>> 31)), E = Qe + Ne | 0, Yi = Ci((gr = Pr + cr | 0) ^ Br, Tr ^ (fo = gr >>> 0 < Pr >>> 0 ? E + 1 | 0 : E), 1), Ln = E = Qe, Mi = Yi, Nr = E, li = (Br = o[pr + 256 >> 2]) + (Ne = o[pr >> 2]) | 0, E = (wo = o[pr + 260 >> 2]) + (Pr = o[pr + 4 >> 2]) | 0, cr = Ne >>> 0 > li >>> 0 ? E + 1 | 0 : E, Pr = Zr(Ne << 1 & -2, 1 & (Pr << 1 | Ne >>> 31), Br, 0), E = Qe + cr | 0, cr = (Ne = Pr + li | 0) >>> 0 < Pr >>> 0 ? E + 1 | 0 : E, fi = (bo = Ci(o[pr + 768 >> 2] ^ Ne, cr ^ o[pr + 772 >> 2], 32)) + (Pr = o[pr + 512 >> 2]) | 0, E = (ro = Qe) + (li = o[pr + 516 >> 2]) | 0, Tr = Pr >>> 0 > fi >>> 0 ? E + 1 | 0 : E, li = Zr(Pr << 1 & -2, 1 & (li << 1 | Pr >>> 31), bo, 0), E = Qe + Tr | 0, wo = Ci((Pr = li + fi | 0) ^ Br, wo ^ (li = Pr >>> 0 < li >>> 0 ? E + 1 | 0 : E), 40), E = cr + (Vo = Qe) | 0, Br = (Tr = Ne + wo | 0) >>> 0 < Ne >>> 0 ? E + 1 | 0 : E, cr = Zr(wo, 0, Ne << 1 & -2, 1 & (cr << 1 | Ne >>> 31)), E = Qe + Br | 0, E = (Tr = (Ne = cr + Tr | 0) >>> 0 < cr >>> 0 ? E + 1 | 0 : E) + Nr | 0, Br = (cr = Ne + Mi | 0) >>> 0 < Ne >>> 0 ? E + 1 | 0 : E, Nr = Zr(Mi, 0, Ne << 1 & -2, 1 & (Tr << 1 | Ne >>> 31)), E = Qe + Br | 0, go = Ci((cr = Nr + cr | 0) ^ Jr, (fi = cr >>> 0 < Nr >>> 0 ? E + 1 | 0 : E) ^ Mr, 32), ms = E = Qe, Tn = E, Mi = (Jr = o[pr + 384 >> 2]) + (Br = o[pr + 128 >> 2]) | 0, E = (Qo = o[pr + 388 >> 2]) + (Mr = o[pr + 132 >> 2]) | 0, Nr = Br >>> 0 > Mi >>> 0 ? E + 1 | 0 : E, Mr = Zr(Br << 1 & -2, 1 & (Mr << 1 | Br >>> 31), Jr, 0), E = Qe + Nr | 0, Nr = (Br = Mr + Mi | 0) >>> 0 < Mr >>> 0 ? E + 1 | 0 : E, vn = (Mi = Ci(o[pr + 896 >> 2] ^ Br, Nr ^ o[pr + 900 >> 2], 32)) + (Mr = o[pr + 640 >> 2]) | 0, E = (qn = Qe) + (Xi = o[pr + 644 >> 2]) | 0, $n = Mr >>> 0 > vn >>> 0 ? E + 1 | 0 : E, Xi = Zr(Mr << 1 & -2, 1 & (Xi << 1 | Mr >>> 31), Mi, 0), E = Qe + $n | 0, Xi = Ci(vn = (Mr = Xi + vn | 0) ^ Jr, Qo ^ (Jr = Mr >>> 0 < Xi >>> 0 ? E + 1 | 0 : E), 40), E = Nr + (Qo = Qe) | 0, $n = (vn = Br + Xi | 0) >>> 0 < Br >>> 0 ? E + 1 | 0 : E, Nr = Zr(Xi, 0, Br << 1 & -2, 1 & (Nr << 1 | Br >>> 31)), E = Qe + $n | 0, $n = Ci(vn = (Br = Nr + vn | 0) ^ Mi, qn ^ (Mi = Nr >>> 0 > Br >>> 0 ? E + 1 | 0 : E), 48), E = Jr + (qn = Qe) | 0, Nr = (vn = Mr + $n | 0) >>> 0 < Mr >>> 0 ? E + 1 | 0 : E, Jr = Zr($n, 0, Mr << 1 & -2, 1 & (Jr << 1 | Mr >>> 31)), E = Qe + Nr | 0, E = (Jr = (Mr = Jr + vn | 0) >>> 0 < Jr >>> 0 ? E + 1 | 0 : E) + Tn | 0, Tn = (Nr = Mr + go | 0) >>> 0 < Mr >>> 0 ? E + 1 | 0 : E, vn = Zr(go, 0, Mr << 1 & -2, 1 & (Jr << 1 | Mr >>> 31)), E = Qe + Tn | 0, Tn = Ci(Tn = (Nr = vn + Nr | 0) ^ Yi, Ln ^ (Yi = Nr >>> 0 < vn >>> 0 ? E + 1 | 0 : E), 40), E = fi + (Ln = Qe) | 0, vn = (io = cr + Tn | 0) >>> 0 < cr >>> 0 ? E + 1 | 0 : E, cr = (fi = Zr(Tn, 0, cr << 1 & -2, 1 & (fi << 1 | cr >>> 31))) + io | 0, E = Qe + vn | 0, o[pr >> 2] = cr, E = cr >>> 0 < fi >>> 0 ? E + 1 | 0 : E, o[pr + 4 >> 2] = E, cr = Ci(cr ^ go, E ^ ms, 48), o[pr + 904 >> 2] = cr, E = Qe, o[pr + 908 >> 2] = E, E = E + Yi | 0, fi = (go = cr + Nr | 0) >>> 0 < Nr >>> 0 ? E + 1 | 0 : E, cr = (Nr = Zr(cr, 0, Nr << 1 & -2, 1 & (Yi << 1 | Nr >>> 31))) + go | 0, E = Qe + fi | 0, o[pr + 640 >> 2] = cr, E = cr >>> 0 < Nr >>> 0 ? E + 1 | 0 : E, o[pr + 644 >> 2] = E, ci = pr, Fi = Ci(cr ^ Tn, E ^ Ln, 1), o[ci + 264 >> 2] = Fi, o[pr + 268 >> 2] = Qe, E = ti + as | 0, cr = (Nr = ve + to | 0) >>> 0 < ve >>> 0 ? E + 1 | 0 : E, ve = Zr(to, 0, ve << 1 & -2, 1 & (ti << 1 | ve >>> 31)), E = Qe + cr | 0, cr = E = ve >>> 0 > (Nr = ve + Nr | 0) >>> 0 ? E + 1 | 0 : E, ve = E, Mr = Ci(Mr ^ Xi, Jr ^ Qo, 1), E = jr + (Jr = Qe) | 0, ti = (fi = ye + Mr | 0) >>> 0 < ye >>> 0 ? E + 1 | 0 : E, ye = (jr = Zr(Mr, 0, ye << 1 & -2, 1 & (jr << 1 | ye >>> 31))) + fi | 0, E = Qe + ti | 0, Tr = Ci(Ne ^ bo, Tr ^ ro, 48), jr = Ci(Tr ^ ye, (Ne = ye >>> 0 < jr >>> 0 ? E + 1 | 0 : E) ^ (Yi = Qe), 32), E = (to = Qe) + ve | 0, ti = jr >>> 0 > (fi = jr + Nr | 0) >>> 0 ? E + 1 | 0 : E, ve = (E = fi) + (fi = Zr(Nr << 1 & -2, 1 & (ve << 1 | Nr >>> 31), jr, 0)) | 0, E = Qe + ti | 0, ti = Ci(vn = ve ^ Mr, Jr ^ (Mr = ve >>> 0 < fi >>> 0 ? E + 1 | 0 : E), 40), E = Ne + (fi = Qe) | 0, Jr = (bo = ye + ti | 0) >>> 0 < ye >>> 0 ? E + 1 | 0 : E, ye = Zr(ti, 0, ye << 1 & -2, 1 & (Ne << 1 | ye >>> 31)), E = Qe + Jr | 0, ye = Ci((Ne = ye + bo | 0) ^ jr, to ^ (E = ye >>> 0 > Ne >>> 0 ? E + 1 | 0 : E), 48), o[pr + 768 >> 2] = ye, jr = Qe, o[pr + 772 >> 2] = jr, o[pr + 8 >> 2] = Ne, o[pr + 12 >> 2] = E, E = Mr + jr | 0, Ne = (jr = ye + ve | 0) >>> 0 < ve >>> 0 ? E + 1 | 0 : E, ve = Zr(ye, 0, ve << 1 & -2, 1 & (Mr << 1 | ve >>> 31)), E = Qe + Ne | 0, ci = pr, Fi = Ci((ye = ve + jr | 0) ^ ti, (E = ye >>> 0 < ve >>> 0 ? E + 1 | 0 : E) ^ fi, 1), o[ci + 384 >> 2] = Fi, o[pr + 388 >> 2] = Qe, o[pr + 648 >> 2] = ye, o[pr + 652 >> 2] = E, Mr = Ci(Nr ^ So, cr ^ Ni, 1), E = Mi + (ti = Qe) | 0, ve = (ye = Br + Mr | 0) >>> 0 < Br >>> 0 ? E + 1 | 0 : E, Ne = Zr(Mr, 0, Br << 1 & -2, 1 & (Mi << 1 | Br >>> 31)), E = Qe + ve | 0, Nr = Ci((ye = Ne + ye | 0) ^ qo, cs ^ (cr = ye >>> 0 < Ne >>> 0 ? E + 1 | 0 : E), 32), jr = E = Qe, Ne = E, E = li + Yi | 0, Br = (ve = Pr + Tr | 0) >>> 0 < Pr >>> 0 ? E + 1 | 0 : E, Pr = Zr(Tr, 0, Pr << 1 & -2, 1 & (li << 1 | Pr >>> 31)), E = Qe + Br | 0, E = (Pr = (ve = Pr + ve | 0) >>> 0 < Pr >>> 0 ? E + 1 | 0 : E) + Ne | 0, Br = (Ne = ve + Nr | 0) >>> 0 < ve >>> 0 ? E + 1 | 0 : E, li = Zr(Nr, 0, ve << 1 & -2, 1 & (Pr << 1 | ve >>> 31)), E = Qe + Br | 0, Mr = Ci((Ne = li + Ne | 0) ^ Mr, ti ^ (Br = Ne >>> 0 < li >>> 0 ? E + 1 | 0 : E), 40), E = cr + (li = Qe) | 0, ti = (Tr = ye + Mr | 0) >>> 0 < ye >>> 0 ? E + 1 | 0 : E, ye = (cr = Zr(Mr, 0, ye << 1 & -2, 1 & (cr << 1 | ye >>> 31))) + Tr | 0, E = Qe + ti | 0, o[pr + 128 >> 2] = ye, E = ye >>> 0 < cr >>> 0 ? E + 1 | 0 : E, o[pr + 132 >> 2] = E, ye = Ci(ye ^ Nr, E ^ jr, 48), o[pr + 776 >> 2] = ye, E = Qe, o[pr + 780 >> 2] = E, E = E + Br | 0, cr = (Nr = ye + Ne | 0) >>> 0 < Ne >>> 0 ? E + 1 | 0 : E, Ne = Zr(ye, 0, Ne << 1 & -2, 1 & (Br << 1 | Ne >>> 31)), E = Qe + cr | 0, Br = ye = Ne + Nr | 0, Nr = E = ye >>> 0 < Ne >>> 0 ? E + 1 | 0 : E, o[pr + 512 >> 2] = ye, o[pr + 516 >> 2] = E, Pr = Ci(ve ^ wo, Pr ^ Vo, 1), E = (jr = Qe) + Zn | 0, ve = (ye = Pr + Wi | 0) >>> 0 < Pr >>> 0 ? E + 1 | 0 : E, Ne = Zr(Wi << 1 & -2, 1 & (Zn << 1 | Wi >>> 31), Pr, 0), E = Qe + ve | 0, cr = Ci((ye = Ne + ye | 0) ^ $n, qn ^ (Ne = ye >>> 0 < Ne >>> 0 ? E + 1 | 0 : E), 32), E = fo + (Wi = Qe) | 0, ti = (ve = cr + gr | 0) >>> 0 < gr >>> 0 ? E + 1 | 0 : E, gr = Zr(cr, 0, gr << 1 & -2, 1 & (fo << 1 | gr >>> 31)), E = Qe + ti | 0, Pr = Ci((ve = gr + ve | 0) ^ Pr, jr ^ (gr = ve >>> 0 < gr >>> 0 ? E + 1 | 0 : E), 40), E = Ne + (Zn = Qe) | 0, ti = (jr = ye + Pr | 0) >>> 0 < ye >>> 0 ? E + 1 | 0 : E, Ne = Zr(Pr, 0, ye << 1 & -2, 1 & (Ne << 1 | ye >>> 31)), E = Qe + ti | 0, E = (ye = Ne + jr | 0) >>> 0 < Ne >>> 0 ? E + 1 | 0 : E, Ne = ye, ye ^= cr, cr = E, ye = Ci(ye, Wi ^ E, 48), E = gr + (Wi = Qe) | 0, ti = (jr = ye + ve | 0) >>> 0 < ve >>> 0 ? E + 1 | 0 : E, ve = (gr = Zr(ye, 0, ve << 1 & -2, 1 & (gr << 1 | ve >>> 31))) + jr | 0, E = Qe + ti | 0, o[pr + 520 >> 2] = ve, E = ve >>> 0 < gr >>> 0 ? E + 1 | 0 : E, o[pr + 524 >> 2] = E, o[pr + 896 >> 2] = ye, o[pr + 900 >> 2] = Wi, o[pr + 136 >> 2] = Ne, o[pr + 140 >> 2] = cr, ci = pr, Fi = Ci(Br ^ Mr, Nr ^ li, 1), o[ci + 392 >> 2] = Fi, o[pr + 396 >> 2] = Qe, ci = pr, Fi = Ci(ve ^ Pr, E ^ Zn, 1), o[ci + 256 >> 2] = Fi, o[pr + 260 >> 2] = Qe, (0 | (k = k + 1 | 0)) != 8; ) ;
                      for (E = fa(T, M, 1024), k = 0; ye = o[(pr = (T = k << 3) + E | 0) >> 2], Ne = o[(gr = (ve = cr = M + 1024 | 0) + T | 0) >> 2], gr = o[pr + 4 >> 2] ^ o[gr + 4 >> 2], o[pr >> 2] = ye ^ Ne, o[pr + 4 >> 2] = gr, gr = o[(pr = (ye = 8 | T) + E | 0) >> 2], ve = o[(ye = ye + ve | 0) >> 2], ye = o[pr + 4 >> 2] ^ o[ye + 4 >> 2], o[pr >> 2] = ve ^ gr, o[pr + 4 >> 2] = ye, ve = o[(pr = (ye = 16 | T) + E | 0) >> 2], gr = o[(ye = ye + cr | 0) >> 2], ye = o[pr + 4 >> 2] ^ o[ye + 4 >> 2], o[pr >> 2] = ve ^ gr, o[pr + 4 >> 2] = ye, ye = o[(T = (pr = 24 | T) + E | 0) >> 2], ve = o[(pr = pr + cr | 0) >> 2], pr = o[T + 4 >> 2] ^ o[pr + 4 >> 2], o[T >> 2] = ye ^ ve, o[T + 4 >> 2] = pr, (0 | (k = k + 4 | 0)) != 128; ) ;
                      dr = M + 2048 | 0;
                    }
                    function $i(k, E, T) {
                      var M, ye, Ne, pr, ve, cr, gr, Pr, Nr, Br, Mr, jr, ti, fi, Jr = 0, li = 0, Tr = 0, Mi = 0, Wi = 0, vn = 0, Tn = 0, Ni = 0, Yi = 0, Xi = 0, $n = 0;
                      for (dr = M = dr - 800 | 0, Mi = m[E + 4 | 0] | m[E + 5 | 0] << 8 | m[E + 6 | 0] << 16 | m[E + 7 | 0] << 24, vn = m[E + 8 | 0] | m[E + 9 | 0] << 8 | m[E + 10 | 0] << 16 | m[E + 11 | 0] << 24, Ni = m[E + 12 | 0] | m[E + 13 | 0] << 8 | m[E + 14 | 0] << 16 | m[E + 15 | 0] << 24, Yi = m[E + 16 | 0] | m[E + 17 | 0] << 8 | m[E + 18 | 0] << 16 | m[E + 19 | 0] << 24, li = m[E + 20 | 0] | m[E + 21 | 0] << 8 | m[E + 22 | 0] << 16 | m[E + 23 | 0] << 24, Xi = m[E + 24 | 0] | m[E + 25 | 0] << 8 | m[E + 26 | 0] << 16 | m[E + 27 | 0] << 24, $n = m[E + 28 | 0] | m[E + 29 | 0] << 8 | m[E + 30 | 0] << 16 | m[E + 31 | 0] << 24, Ne = m[k + 4 | 0] | m[k + 5 | 0] << 8 | m[k + 6 | 0] << 16 | m[k + 7 | 0] << 24, pr = m[k + 8 | 0] | m[k + 9 | 0] << 8 | m[k + 10 | 0] << 16 | m[k + 11 | 0] << 24, ve = m[k + 12 | 0] | m[k + 13 | 0] << 8 | m[k + 14 | 0] << 16 | m[k + 15 | 0] << 24, cr = m[k + 16 | 0] | m[k + 17 | 0] << 8 | m[k + 18 | 0] << 16 | m[k + 19 | 0] << 24, gr = m[k + 20 | 0] | m[k + 21 | 0] << 8 | m[k + 22 | 0] << 16 | m[k + 23 | 0] << 24, Pr = m[k + 24 | 0] | m[k + 25 | 0] << 8 | m[k + 26 | 0] << 16 | m[k + 27 | 0] << 24, Nr = m[k + 28 | 0] | m[k + 29 | 0] << 8 | m[k + 30 | 0] << 16 | m[k + 31 | 0] << 24, Tr = m[0 | E] | m[E + 1 | 0] << 8 | m[E + 2 | 0] << 16 | m[E + 3 | 0] << 24, E = T - -64 | 0, Br = m[0 | k] | m[k + 1 | 0] << 8 | m[k + 2 | 0] << 16 | m[k + 3 | 0] << 24, o[E >> 2] = 33620224 ^ Br, o[T + 56 >> 2] = 1496785429, o[T + 60 >> 2] = 1652156816, o[(k = T + 48 | 0) >> 2] = 33620224, o[k + 4 >> 2] = 218629379, o[T + 40 >> 2] = 1110511904, o[T + 44 >> 2] = -584534669, o[(ye = T + 32 | 0) >> 2] = 1427652059, o[ye + 4 >> 2] = -248528275, Mr = Tr ^ Br, o[T >> 2] = Mr, o[T + 92 >> 2] = -584534669 ^ Nr, o[T + 88 >> 2] = 1110511904 ^ Pr, o[T + 84 >> 2] = -248528275 ^ gr, o[(Tr = T + 80 | 0) >> 2] = 1427652059 ^ cr, o[T + 76 >> 2] = 1652156816 ^ ve, o[T + 72 >> 2] = 1496785429 ^ pr, o[T + 68 >> 2] = 218629379 ^ Ne, $n ^= Nr, o[T + 28 >> 2] = $n, Xi ^= Pr, o[T + 24 >> 2] = Xi, jr = li ^ gr, o[T + 20 >> 2] = jr, Yi ^= cr, o[(li = T + 16 | 0) >> 2] = Yi, Ni ^= ve, o[T + 12 >> 2] = Ni, ti = vn ^ pr, o[T + 8 >> 2] = ti, fi = Mi ^ Ne, o[T + 4 >> 2] = fi, vn = 0; Mi = o[Tr + 12 >> 2], o[M + 792 >> 2] = o[Tr + 8 >> 2], o[M + 796 >> 2] = Mi, Mi = o[Tr + 4 >> 2], o[M + 784 >> 2] = o[Tr >> 2], o[M + 788 >> 2] = Mi, Mi = o[E + 12 >> 2], o[M + 760 >> 2] = o[E + 8 >> 2], o[M + 764 >> 2] = Mi, Mi = o[E + 4 >> 2], o[M + 752 >> 2] = o[E >> 2], o[M + 756 >> 2] = Mi, Mi = o[Tr + 12 >> 2], o[M + 744 >> 2] = o[Tr + 8 >> 2], o[M + 748 >> 2] = Mi, Mi = o[Tr + 4 >> 2], o[M + 736 >> 2] = o[Tr >> 2], o[M + 740 >> 2] = Mi, gs(Mi = M + 768 | 0, M + 752 | 0, M + 736 | 0), Jr = o[M + 780 >> 2], o[Tr + 8 >> 2] = o[M + 776 >> 2], o[Tr + 12 >> 2] = Jr, Jr = o[M + 772 >> 2], o[Tr >> 2] = o[M + 768 >> 2], o[Tr + 4 >> 2] = Jr, Jr = o[k + 12 >> 2], o[M + 728 >> 2] = o[k + 8 >> 2], o[M + 732 >> 2] = Jr, Jr = o[k + 4 >> 2], o[M + 720 >> 2] = o[k >> 2], o[M + 724 >> 2] = Jr, Jr = o[E + 12 >> 2], o[M + 712 >> 2] = o[E + 8 >> 2], o[M + 716 >> 2] = Jr, Jr = o[E + 4 >> 2], o[M + 704 >> 2] = o[E >> 2], o[M + 708 >> 2] = Jr, gs(Mi, M + 720 | 0, M + 704 | 0), Jr = o[M + 780 >> 2], o[E + 8 >> 2] = o[M + 776 >> 2], o[E + 12 >> 2] = Jr, Jr = o[M + 772 >> 2], o[E >> 2] = o[M + 768 >> 2], o[E + 4 >> 2] = Jr, Jr = o[ye + 12 >> 2], o[M + 696 >> 2] = o[ye + 8 >> 2], o[M + 700 >> 2] = Jr, Jr = o[ye + 4 >> 2], o[M + 688 >> 2] = o[ye >> 2], o[M + 692 >> 2] = Jr, Jr = o[k + 12 >> 2], o[M + 680 >> 2] = o[k + 8 >> 2], o[M + 684 >> 2] = Jr, Jr = o[k + 4 >> 2], o[M + 672 >> 2] = o[k >> 2], o[M + 676 >> 2] = Jr, gs(Mi, M + 688 | 0, M + 672 | 0), Jr = o[M + 780 >> 2], o[k + 8 >> 2] = o[M + 776 >> 2], o[k + 12 >> 2] = Jr, Jr = o[M + 772 >> 2], o[k >> 2] = o[M + 768 >> 2], o[k + 4 >> 2] = Jr, Jr = o[li + 12 >> 2], o[M + 664 >> 2] = o[li + 8 >> 2], o[M + 668 >> 2] = Jr, Jr = o[li + 4 >> 2], o[M + 656 >> 2] = o[li >> 2], o[M + 660 >> 2] = Jr, Jr = o[ye + 12 >> 2], o[M + 648 >> 2] = o[ye + 8 >> 2], o[M + 652 >> 2] = Jr, Jr = o[ye + 4 >> 2], o[M + 640 >> 2] = o[ye >> 2], o[M + 644 >> 2] = Jr, gs(Mi, M + 656 | 0, M + 640 | 0), Jr = o[M + 780 >> 2], o[ye + 8 >> 2] = o[M + 776 >> 2], o[ye + 12 >> 2] = Jr, Jr = o[M + 772 >> 2], o[ye >> 2] = o[M + 768 >> 2], o[ye + 4 >> 2] = Jr, Jr = o[T + 12 >> 2], o[M + 632 >> 2] = o[T + 8 >> 2], o[M + 636 >> 2] = Jr, Jr = o[T + 4 >> 2], o[M + 624 >> 2] = o[T >> 2], o[M + 628 >> 2] = Jr, Jr = o[li + 12 >> 2], o[M + 616 >> 2] = o[li + 8 >> 2], o[M + 620 >> 2] = Jr, Jr = o[li + 4 >> 2], o[M + 608 >> 2] = o[li >> 2], o[M + 612 >> 2] = Jr, gs(Mi, M + 624 | 0, M + 608 | 0), Jr = o[M + 780 >> 2], o[li + 8 >> 2] = o[M + 776 >> 2], o[li + 12 >> 2] = Jr, Jr = o[M + 772 >> 2], o[li >> 2] = o[M + 768 >> 2], o[li + 4 >> 2] = Jr, Jr = o[M + 796 >> 2], o[M + 600 >> 2] = o[M + 792 >> 2], o[M + 604 >> 2] = Jr, Jr = o[M + 788 >> 2], o[M + 592 >> 2] = o[M + 784 >> 2], o[M + 596 >> 2] = Jr, Jr = o[T + 12 >> 2], o[M + 584 >> 2] = o[T + 8 >> 2], o[M + 588 >> 2] = Jr, Jr = o[T + 4 >> 2], o[M + 576 >> 2] = o[T >> 2], o[M + 580 >> 2] = Jr, gs(Mi, M + 592 | 0, M + 576 | 0), Jr = o[M + 768 >> 2], Wi = o[M + 772 >> 2], Tn = o[M + 776 >> 2], o[T + 12 >> 2] = o[M + 780 >> 2] ^ ve, o[T + 8 >> 2] = Tn ^ pr, o[T + 4 >> 2] = Wi ^ Ne, o[T >> 2] = Jr ^ Br, Jr = o[Tr + 12 >> 2], o[M + 792 >> 2] = o[Tr + 8 >> 2], o[M + 796 >> 2] = Jr, Jr = o[Tr + 4 >> 2], o[M + 784 >> 2] = o[Tr >> 2], o[M + 788 >> 2] = Jr, Jr = o[E + 12 >> 2], o[M + 568 >> 2] = o[E + 8 >> 2], o[M + 572 >> 2] = Jr, Jr = o[E + 4 >> 2], o[M + 560 >> 2] = o[E >> 2], o[M + 564 >> 2] = Jr, Jr = o[Tr + 12 >> 2], o[M + 552 >> 2] = o[Tr + 8 >> 2], o[M + 556 >> 2] = Jr, Jr = o[Tr + 4 >> 2], o[M + 544 >> 2] = o[Tr >> 2], o[M + 548 >> 2] = Jr, gs(Mi, M + 560 | 0, M + 544 | 0), Jr = o[M + 780 >> 2], o[Tr + 8 >> 2] = o[M + 776 >> 2], o[Tr + 12 >> 2] = Jr, Jr = o[M + 772 >> 2], o[Tr >> 2] = o[M + 768 >> 2], o[Tr + 4 >> 2] = Jr, Jr = o[k + 12 >> 2], o[M + 536 >> 2] = o[k + 8 >> 2], o[M + 540 >> 2] = Jr, Jr = o[k + 4 >> 2], o[M + 528 >> 2] = o[k >> 2], o[M + 532 >> 2] = Jr, Jr = o[E + 12 >> 2], o[M + 520 >> 2] = o[E + 8 >> 2], o[M + 524 >> 2] = Jr, Jr = o[E + 4 >> 2], o[M + 512 >> 2] = o[E >> 2], o[M + 516 >> 2] = Jr, gs(Mi, M + 528 | 0, M + 512 | 0), Jr = o[M + 780 >> 2], o[E + 8 >> 2] = o[M + 776 >> 2], o[E + 12 >> 2] = Jr, Jr = o[M + 772 >> 2], o[E >> 2] = o[M + 768 >> 2], o[E + 4 >> 2] = Jr, Jr = o[ye + 12 >> 2], o[M + 504 >> 2] = o[ye + 8 >> 2], o[M + 508 >> 2] = Jr, Jr = o[ye + 4 >> 2], o[M + 496 >> 2] = o[ye >> 2], o[M + 500 >> 2] = Jr, Jr = o[k + 12 >> 2], o[M + 488 >> 2] = o[k + 8 >> 2], o[M + 492 >> 2] = Jr, Jr = o[k + 4 >> 2], o[M + 480 >> 2] = o[k >> 2], o[M + 484 >> 2] = Jr, gs(Mi, M + 496 | 0, M + 480 | 0), Jr = o[M + 780 >> 2], o[k + 8 >> 2] = o[M + 776 >> 2], o[k + 12 >> 2] = Jr, Jr = o[M + 772 >> 2], o[k >> 2] = o[M + 768 >> 2], o[k + 4 >> 2] = Jr, Jr = o[li + 12 >> 2], o[M + 472 >> 2] = o[li + 8 >> 2], o[M + 476 >> 2] = Jr, Jr = o[li + 4 >> 2], o[M + 464 >> 2] = o[li >> 2], o[M + 468 >> 2] = Jr, Jr = o[ye + 12 >> 2], o[M + 456 >> 2] = o[ye + 8 >> 2], o[M + 460 >> 2] = Jr, Jr = o[ye + 4 >> 2], o[M + 448 >> 2] = o[ye >> 2], o[M + 452 >> 2] = Jr, gs(Mi, M + 464 | 0, M + 448 | 0), Jr = o[M + 780 >> 2], o[ye + 8 >> 2] = o[M + 776 >> 2], o[ye + 12 >> 2] = Jr, Jr = o[M + 772 >> 2], o[ye >> 2] = o[M + 768 >> 2], o[ye + 4 >> 2] = Jr, Jr = o[T + 12 >> 2], o[M + 440 >> 2] = o[T + 8 >> 2], o[M + 444 >> 2] = Jr, Jr = o[T + 4 >> 2], o[M + 432 >> 2] = o[T >> 2], o[M + 436 >> 2] = Jr, Jr = o[li + 12 >> 2], o[M + 424 >> 2] = o[li + 8 >> 2], o[M + 428 >> 2] = Jr, Jr = o[li + 4 >> 2], o[M + 416 >> 2] = o[li >> 2], o[M + 420 >> 2] = Jr, gs(Mi, M + 432 | 0, M + 416 | 0), Jr = o[M + 780 >> 2], o[li + 8 >> 2] = o[M + 776 >> 2], o[li + 12 >> 2] = Jr, Jr = o[M + 772 >> 2], o[li >> 2] = o[M + 768 >> 2], o[li + 4 >> 2] = Jr, Jr = o[M + 796 >> 2], o[M + 408 >> 2] = o[M + 792 >> 2], o[M + 412 >> 2] = Jr, Jr = o[M + 788 >> 2], o[M + 400 >> 2] = o[M + 784 >> 2], o[M + 404 >> 2] = Jr, Jr = o[T + 12 >> 2], o[M + 392 >> 2] = o[T + 8 >> 2], o[M + 396 >> 2] = Jr, Jr = o[T + 4 >> 2], o[M + 384 >> 2] = o[T >> 2], o[M + 388 >> 2] = Jr, gs(Mi, M + 400 | 0, M + 384 | 0), Jr = o[M + 768 >> 2], Wi = o[M + 772 >> 2], Tn = o[M + 776 >> 2], o[T + 12 >> 2] = o[M + 780 >> 2] ^ Nr, o[T + 8 >> 2] = Tn ^ Pr, o[T + 4 >> 2] = Wi ^ gr, o[T >> 2] = Jr ^ cr, Jr = o[Tr + 12 >> 2], o[M + 792 >> 2] = o[Tr + 8 >> 2], o[M + 796 >> 2] = Jr, Jr = o[Tr + 4 >> 2], o[M + 784 >> 2] = o[Tr >> 2], o[M + 788 >> 2] = Jr, Jr = o[E + 12 >> 2], o[M + 376 >> 2] = o[E + 8 >> 2], o[M + 380 >> 2] = Jr, Jr = o[E + 4 >> 2], o[M + 368 >> 2] = o[E >> 2], o[M + 372 >> 2] = Jr, Jr = o[Tr + 12 >> 2], o[M + 360 >> 2] = o[Tr + 8 >> 2], o[M + 364 >> 2] = Jr, Jr = o[Tr + 4 >> 2], o[M + 352 >> 2] = o[Tr >> 2], o[M + 356 >> 2] = Jr, gs(Mi, M + 368 | 0, M + 352 | 0), Jr = o[M + 780 >> 2], o[Tr + 8 >> 2] = o[M + 776 >> 2], o[Tr + 12 >> 2] = Jr, Jr = o[M + 772 >> 2], o[Tr >> 2] = o[M + 768 >> 2], o[Tr + 4 >> 2] = Jr, Jr = o[k + 12 >> 2], o[M + 344 >> 2] = o[k + 8 >> 2], o[M + 348 >> 2] = Jr, Jr = o[k + 4 >> 2], o[M + 336 >> 2] = o[k >> 2], o[M + 340 >> 2] = Jr, Jr = o[E + 12 >> 2], o[M + 328 >> 2] = o[E + 8 >> 2], o[M + 332 >> 2] = Jr, Jr = o[E + 4 >> 2], o[M + 320 >> 2] = o[E >> 2], o[M + 324 >> 2] = Jr, gs(Mi, M + 336 | 0, M + 320 | 0), Jr = o[M + 780 >> 2], o[E + 8 >> 2] = o[M + 776 >> 2], o[E + 12 >> 2] = Jr, Jr = o[M + 772 >> 2], o[E >> 2] = o[M + 768 >> 2], o[E + 4 >> 2] = Jr, Jr = o[ye + 12 >> 2], o[M + 312 >> 2] = o[ye + 8 >> 2], o[M + 316 >> 2] = Jr, Jr = o[ye + 4 >> 2], o[M + 304 >> 2] = o[ye >> 2], o[M + 308 >> 2] = Jr, Jr = o[k + 12 >> 2], o[M + 296 >> 2] = o[k + 8 >> 2], o[M + 300 >> 2] = Jr, Jr = o[k + 4 >> 2], o[M + 288 >> 2] = o[k >> 2], o[M + 292 >> 2] = Jr, gs(Mi, M + 304 | 0, M + 288 | 0), Jr = o[M + 780 >> 2], o[k + 8 >> 2] = o[M + 776 >> 2], o[k + 12 >> 2] = Jr, Jr = o[M + 772 >> 2], o[k >> 2] = o[M + 768 >> 2], o[k + 4 >> 2] = Jr, Jr = o[li + 12 >> 2], o[M + 280 >> 2] = o[li + 8 >> 2], o[M + 284 >> 2] = Jr, Jr = o[li + 4 >> 2], o[M + 272 >> 2] = o[li >> 2], o[M + 276 >> 2] = Jr, Jr = o[ye + 12 >> 2], o[M + 264 >> 2] = o[ye + 8 >> 2], o[M + 268 >> 2] = Jr, Jr = o[ye + 4 >> 2], o[M + 256 >> 2] = o[ye >> 2], o[M + 260 >> 2] = Jr, gs(Mi, M + 272 | 0, M + 256 | 0), Jr = o[M + 780 >> 2], o[ye + 8 >> 2] = o[M + 776 >> 2], o[ye + 12 >> 2] = Jr, Jr = o[M + 772 >> 2], o[ye >> 2] = o[M + 768 >> 2], o[ye + 4 >> 2] = Jr, Jr = o[T + 12 >> 2], o[M + 248 >> 2] = o[T + 8 >> 2], o[M + 252 >> 2] = Jr, Jr = o[T + 4 >> 2], o[M + 240 >> 2] = o[T >> 2], o[M + 244 >> 2] = Jr, Jr = o[li + 12 >> 2], o[M + 232 >> 2] = o[li + 8 >> 2], o[M + 236 >> 2] = Jr, Jr = o[li + 4 >> 2], o[M + 224 >> 2] = o[li >> 2], o[M + 228 >> 2] = Jr, gs(Mi, M + 240 | 0, M + 224 | 0), Jr = o[M + 780 >> 2], o[li + 8 >> 2] = o[M + 776 >> 2], o[li + 12 >> 2] = Jr, Jr = o[M + 772 >> 2], o[li >> 2] = o[M + 768 >> 2], o[li + 4 >> 2] = Jr, Jr = o[M + 796 >> 2], o[M + 216 >> 2] = o[M + 792 >> 2], o[M + 220 >> 2] = Jr, Jr = o[M + 788 >> 2], o[M + 208 >> 2] = o[M + 784 >> 2], o[M + 212 >> 2] = Jr, Jr = o[T + 12 >> 2], o[M + 200 >> 2] = o[T + 8 >> 2], o[M + 204 >> 2] = Jr, Jr = o[T + 4 >> 2], o[M + 192 >> 2] = o[T >> 2], o[M + 196 >> 2] = Jr, gs(Mi, M + 208 | 0, M + 192 | 0), Jr = o[M + 768 >> 2], Wi = o[M + 772 >> 2], Tn = o[M + 776 >> 2], o[T + 12 >> 2] = Ni ^ o[M + 780 >> 2], o[T + 8 >> 2] = Tn ^ ti, o[T + 4 >> 2] = Wi ^ fi, o[T >> 2] = Jr ^ Mr, Jr = o[Tr + 12 >> 2], o[M + 792 >> 2] = o[Tr + 8 >> 2], o[M + 796 >> 2] = Jr, Jr = o[Tr + 4 >> 2], o[M + 784 >> 2] = o[Tr >> 2], o[M + 788 >> 2] = Jr, Jr = o[E + 12 >> 2], o[M + 184 >> 2] = o[E + 8 >> 2], o[M + 188 >> 2] = Jr, Jr = o[E + 4 >> 2], o[M + 176 >> 2] = o[E >> 2], o[M + 180 >> 2] = Jr, Jr = o[Tr + 12 >> 2], o[M + 168 >> 2] = o[Tr + 8 >> 2], o[M + 172 >> 2] = Jr, Jr = o[Tr + 4 >> 2], o[M + 160 >> 2] = o[Tr >> 2], o[M + 164 >> 2] = Jr, gs(Mi, M + 176 | 0, M + 160 | 0), Jr = o[M + 780 >> 2], o[Tr + 8 >> 2] = o[M + 776 >> 2], o[Tr + 12 >> 2] = Jr, Jr = o[M + 772 >> 2], o[Tr >> 2] = o[M + 768 >> 2], o[Tr + 4 >> 2] = Jr, Jr = o[k + 12 >> 2], o[M + 152 >> 2] = o[k + 8 >> 2], o[M + 156 >> 2] = Jr, Jr = o[k + 4 >> 2], o[M + 144 >> 2] = o[k >> 2], o[M + 148 >> 2] = Jr, Jr = o[E + 12 >> 2], o[M + 136 >> 2] = o[E + 8 >> 2], o[M + 140 >> 2] = Jr, Jr = o[E + 4 >> 2], o[M + 128 >> 2] = o[E >> 2], o[M + 132 >> 2] = Jr, gs(Mi, M + 144 | 0, M + 128 | 0), Jr = o[M + 780 >> 2], o[E + 8 >> 2] = o[M + 776 >> 2], o[E + 12 >> 2] = Jr, Jr = o[M + 772 >> 2], o[E >> 2] = o[M + 768 >> 2], o[E + 4 >> 2] = Jr, Jr = o[ye + 12 >> 2], o[M + 120 >> 2] = o[ye + 8 >> 2], o[M + 124 >> 2] = Jr, Jr = o[ye + 4 >> 2], o[M + 112 >> 2] = o[ye >> 2], o[M + 116 >> 2] = Jr, Jr = o[k + 12 >> 2], o[M + 104 >> 2] = o[k + 8 >> 2], o[M + 108 >> 2] = Jr, Jr = o[k + 4 >> 2], o[M + 96 >> 2] = o[k >> 2], o[M + 100 >> 2] = Jr, gs(Mi, M + 112 | 0, M + 96 | 0), Jr = o[M + 780 >> 2], o[k + 8 >> 2] = o[M + 776 >> 2], o[k + 12 >> 2] = Jr, Jr = o[M + 772 >> 2], o[k >> 2] = o[M + 768 >> 2], o[k + 4 >> 2] = Jr, Jr = o[li + 12 >> 2], o[M + 88 >> 2] = o[li + 8 >> 2], o[M + 92 >> 2] = Jr, Jr = o[li + 4 >> 2], o[M + 80 >> 2] = o[li >> 2], o[M + 84 >> 2] = Jr, Jr = o[ye + 12 >> 2], o[M + 72 >> 2] = o[ye + 8 >> 2], o[M + 76 >> 2] = Jr, Jr = o[ye + 4 >> 2], o[M + 64 >> 2] = o[ye >> 2], o[M + 68 >> 2] = Jr, gs(Mi, M + 80 | 0, M - -64 | 0), Jr = o[M + 780 >> 2], o[ye + 8 >> 2] = o[M + 776 >> 2], o[ye + 12 >> 2] = Jr, Jr = o[M + 772 >> 2], o[ye >> 2] = o[M + 768 >> 2], o[ye + 4 >> 2] = Jr, Jr = o[T + 12 >> 2], o[M + 56 >> 2] = o[T + 8 >> 2], o[M + 60 >> 2] = Jr, Jr = o[T + 4 >> 2], o[M + 48 >> 2] = o[T >> 2], o[M + 52 >> 2] = Jr, Jr = o[li + 12 >> 2], o[M + 40 >> 2] = o[li + 8 >> 2], o[M + 44 >> 2] = Jr, Jr = o[li + 4 >> 2], o[M + 32 >> 2] = o[li >> 2], o[M + 36 >> 2] = Jr, gs(Mi, M + 48 | 0, M + 32 | 0), Jr = o[M + 780 >> 2], o[li + 8 >> 2] = o[M + 776 >> 2], o[li + 12 >> 2] = Jr, Jr = o[M + 772 >> 2], o[li >> 2] = o[M + 768 >> 2], o[li + 4 >> 2] = Jr, Jr = o[M + 796 >> 2], o[M + 24 >> 2] = o[M + 792 >> 2], o[M + 28 >> 2] = Jr, Jr = o[M + 788 >> 2], o[M + 16 >> 2] = o[M + 784 >> 2], o[M + 20 >> 2] = Jr, Jr = o[T + 12 >> 2], o[M + 8 >> 2] = o[T + 8 >> 2], o[M + 12 >> 2] = Jr, Jr = o[T + 4 >> 2], o[M >> 2] = o[T >> 2], o[M + 4 >> 2] = Jr, gs(Mi, M + 16 | 0, M), Mi = o[M + 768 >> 2], Jr = o[M + 772 >> 2], Wi = o[M + 776 >> 2], o[T + 12 >> 2] = $n ^ o[M + 780 >> 2], o[T + 8 >> 2] = Wi ^ Xi, o[T + 4 >> 2] = Jr ^ jr, o[T >> 2] = Mi ^ Yi, (0 | (vn = vn + 1 | 0)) != 4; ) ;
                      dr = M + 800 | 0;
                    }
                    function zi(k, E) {
                      var T, M, ye, Ne, pr, ve, cr, gr, Pr, Nr, Br, Mr, jr, ti, fi, Jr, li, Tr, Mi, Wi, vn, Tn, Ni = 0, Yi = 0, Xi = 0, $n = 0, Zn = 0, to = 0, fo = 0, wo = 0, bo = 0, go = 0, qn = 0, io = 0, So = 0, qo = 0, Ln = 0, ro = 0, Qo = 0, Vo = 0;
                      for (dr = T = dr - 48 | 0, Xi = m[E + 28 | 0] | m[E + 29 | 0] << 8 | m[E + 30 | 0] << 16 | m[E + 31 | 0] << 24, Yi = m[E + 24 | 0] | m[E + 25 | 0] << 8 | m[E + 26 | 0] << 16 | m[E + 27 | 0] << 24, B[k + 24 | 0] = Yi, B[k + 25 | 0] = Yi >>> 8, B[k + 26 | 0] = Yi >>> 16, B[k + 27 | 0] = Yi >>> 24, B[k + 28 | 0] = Xi, B[k + 29 | 0] = Xi >>> 8, B[k + 30 | 0] = Xi >>> 16, B[k + 31 | 0] = Xi >>> 24, Xi = m[E + 4 | 0] | m[E + 5 | 0] << 8 | m[E + 6 | 0] << 16 | m[E + 7 | 0] << 24, Yi = m[0 | E] | m[E + 1 | 0] << 8 | m[E + 2 | 0] << 16 | m[E + 3 | 0] << 24, B[0 | k] = Yi, B[k + 1 | 0] = Yi >>> 8, B[k + 2 | 0] = Yi >>> 16, B[k + 3 | 0] = Yi >>> 24, B[k + 4 | 0] = Xi, B[k + 5 | 0] = Xi >>> 8, B[k + 6 | 0] = Xi >>> 16, B[k + 7 | 0] = Xi >>> 24, Xi = m[E + 20 | 0] | m[E + 21 | 0] << 8 | m[E + 22 | 0] << 16 | m[E + 23 | 0] << 24, Yi = m[E + 16 | 0] | m[E + 17 | 0] << 8 | m[E + 18 | 0] << 16 | m[E + 19 | 0] << 24, B[k + 16 | 0] = Yi, B[k + 17 | 0] = Yi >>> 8, B[k + 18 | 0] = Yi >>> 16, B[k + 19 | 0] = Yi >>> 24, B[k + 20 | 0] = Xi, B[k + 21 | 0] = Xi >>> 8, B[k + 22 | 0] = Xi >>> 16, B[k + 23 | 0] = Xi >>> 24, Yi = m[E + 12 | 0] | m[E + 13 | 0] << 8 | m[E + 14 | 0] << 16 | m[E + 15 | 0] << 24, E = m[E + 8 | 0] | m[E + 9 | 0] << 8 | m[E + 10 | 0] << 16 | m[E + 11 | 0] << 24, B[k + 8 | 0] = E, B[k + 9 | 0] = E >>> 8, B[k + 10 | 0] = E >>> 16, B[k + 11 | 0] = E >>> 24, B[k + 12 | 0] = Yi, B[k + 13 | 0] = Yi >>> 8, B[k + 14 | 0] = Yi >>> 16, B[k + 15 | 0] = Yi >>> 24, E = m[k + 31 | 0], B[k + 31 | 0] = 127 & E, Va(T, k), Nr = 128 & E, dr = E = dr - 960 | 0, Mo(Yi = E + 304 | 0, T), o[E + 304 >> 2] = o[E + 304 >> 2] + 1, ia(Yi, Yi), Xi = Zr(Yi = o[E + 340 >> 2], Yi >> 31, 486662, 0), Yi = Qe, fo = (qn = Xi + 16777216 | 0) >>> 0 < 16777216 ? Yi + 1 | 0 : Yi, bo = Xi - (-33554432 & qn) | 0, Ni = Zr(Yi = o[E + 336 >> 2], Yi >> 31, 486662, 0), Xi = Qe, $n = Zr(Yi = o[E + 332 >> 2], Yi >> 31, 486662, 0), Yi = Qe, wo = Ni, Ni = (Ni = (Yi = (to = $n + 16777216 | 0) >>> 0 < 16777216 ? Yi + 1 | 0 : Yi) >> 25) + Xi | 0, Yi = (Yi = (33554431 & Yi) << 7 | to >>> 25) >>> 0 > (Zn = wo + Yi | 0) >>> 0 ? Ni + 1 | 0 : Ni, M = ((67108863 & (Yi = (Xi = Zn + 33554432 | 0) >>> 0 < 33554432 ? Yi + 1 | 0 : Yi)) << 6 | Xi >>> 26) + bo | 0, o[E + 292 >> 2] = 0 - M, Qo = Zn - (-67108864 & Xi) | 0, o[E + 288 >> 2] = 0 - Qo, bo = $n - (-33554432 & to) | 0, Xi = Zr(Yi = o[E + 328 >> 2], Yi >> 31, 486662, 0), Yi = Qe, to = Zr(Ni = o[E + 324 >> 2], Ni >> 31, 486662, 0), Ni = Qe, wo = Xi, Yi = Yi + (Xi = (Ni = (Zn = to + 16777216 | 0) >>> 0 < 16777216 ? Ni + 1 | 0 : Ni) >> 25) | 0, Yi = (Ni = wo + ($n = (33554431 & Ni) << 7 | Zn >>> 25) | 0) >>> 0 < $n >>> 0 ? Yi + 1 | 0 : Yi, ye = ((67108863 & (Yi = (Xi = Ni + 33554432 | 0) >>> 0 < 33554432 ? Yi + 1 | 0 : Yi)) << 6 | Xi >>> 26) + bo | 0, o[E + 284 >> 2] = 0 - ye, Ne = Ni - (-67108864 & Xi) | 0, o[E + 280 >> 2] = 0 - Ne, bo = to - (-33554432 & Zn) | 0, Ni = Zr(Yi = o[E + 320 >> 2], Yi >> 31, 486662, 0), Yi = Qe, to = Zr(Xi = o[E + 316 >> 2], Xi >> 31, 486662, 0), Xi = Qe, wo = Ni, Yi = (Ni = (Xi = (Zn = to + 16777216 | 0) >>> 0 < 16777216 ? Xi + 1 | 0 : Xi) >> 25) + Yi | 0, Ni = Yi = (Xi = wo + ($n = (33554431 & Xi) << 7 | Zn >>> 25) | 0) >>> 0 < $n >>> 0 ? Yi + 1 | 0 : Yi, pr = ((67108863 & (Ni = ($n = Xi + 33554432 | 0) >>> 0 < 33554432 ? Ni + 1 | 0 : Ni)) << 6 | $n >>> 26) + bo | 0, o[E + 276 >> 2] = 0 - pr, ve = Xi - (-67108864 & $n) | 0, o[E + 272 >> 2] = 0 - ve, wo = to - (-33554432 & Zn) | 0, Yi = Zr(Yi = o[E + 312 >> 2], Yi >> 31, 486662, 0), bo = Qe, $n = Zr(Xi = o[E + 308 >> 2], Xi >> 31, 486662, 0), Ni = Qe, Xi = (33554431 & (Ni = (to = $n + 16777216 | 0) >>> 0 < 16777216 ? Ni + 1 | 0 : Ni)) << 7 | to >>> 25, Ni = (Ni >> 25) + bo | 0, Xi = Xi >>> 0 > (Zn = Xi + Yi | 0) >>> 0 ? Ni + 1 | 0 : Ni, cr = ((67108863 & (Xi = (Yi = Zn + 33554432 | 0) >>> 0 < 33554432 ? Xi + 1 | 0 : Xi)) << 6 | Yi >>> 26) + wo | 0, o[E + 268 >> 2] = 0 - cr, gr = Zn - (-67108864 & Yi) | 0, o[E + 264 >> 2] = 0 - gr, Zn = $n - (-33554432 & to) | 0, Xi = Zr((33554431 & fo) << 7 | qn >>> 25, fo >> 25, 19, 0), Yi = Qe, $n = Xi, Xi = Zr(Ni = o[E + 304 >> 2], Ni >> 31, 486662, 0), Yi = Qe + Yi | 0, Xi = (Ni = $n + Xi | 0) >>> 0 < Xi >>> 0 ? Yi + 1 | 0 : Yi, Pr = ((67108863 & (Xi = (Yi = Ni + 33554432 | 0) >>> 0 < 33554432 ? Xi + 1 | 0 : Xi)) << 6 | Yi >>> 26) + Zn | 0, o[E + 260 >> 2] = 0 - Pr, go = Ni - (-67108864 & Yi) | 0, o[E + 256 >> 2] = 0 - go, qi(Xi = E + 208 | 0, Yi = E + 256 | 0), Ti(E + 160 | 0, Yi, Xi), Br = o[E + 196 >> 2], Mr = o[E + 160 >> 2], io = o[E + 208 >> 2], jr = o[E + 164 >> 2], ti = o[E + 168 >> 2], So = o[E + 212 >> 2], qo = o[E + 216 >> 2], fi = o[E + 172 >> 2], Jr = o[E + 176 >> 2], Ln = o[E + 220 >> 2], ro = o[E + 224 >> 2], li = o[E + 180 >> 2], Tr = o[E + 184 >> 2], wo = o[E + 228 >> 2], bo = o[E + 232 >> 2], Mi = o[E + 188 >> 2], Wi = o[E + 192 >> 2], Xi = Zr(Yi = o[E + 244 >> 2], Yi >> 31, 486662, 0), Yi = Qe, fo = (qn = Xi + 16777216 | 0) >>> 0 < 16777216 ? Yi + 1 | 0 : Yi, vn = Xi - (-33554432 & qn) | 0, Yi = Zr(Yi = o[E + 240 >> 2], Yi >> 31, 486662, 0), Tn = Qe, $n = Zr(Xi = o[E + 236 >> 2], Xi >> 31, 486662, 0), Ni = Qe, Xi = Yi, Yi = (33554431 & (Ni = (to = $n + 16777216 | 0) >>> 0 < 16777216 ? Ni + 1 | 0 : Ni)) << 7 | to >>> 25, Ni = (Ni >> 25) + Tn | 0, Yi = Yi >>> 0 > (Zn = Xi + Yi | 0) >>> 0 ? Ni + 1 | 0 : Ni, Ni = ((67108863 & (Yi = (Xi = Zn + 33554432 | 0) >>> 0 < 33554432 ? Yi + 1 | 0 : Yi)) << 6 | Xi >>> 26) + vn | 0, o[E + 244 >> 2] = Ni, o[E + 388 >> 2] = Ni + (Br - M | 0), Yi = Zn - (-67108864 & Xi) | 0, o[E + 240 >> 2] = Yi, o[E + 384 >> 2] = Yi + (Wi - Qo | 0), Qo = $n - (-33554432 & to) | 0, Yi = Zr(bo, bo >> 31, 486662, 0), $n = Qe, to = Zr(wo, wo >> 31, 486662, 0), Xi = Qe, wo = Yi, Yi = (Yi = (Xi = (Zn = to + 16777216 | 0) >>> 0 < 16777216 ? Xi + 1 | 0 : Xi) >> 25) + $n | 0, Ni = Yi = (Ni = (33554431 & Xi) << 7 | Zn >>> 25) >>> 0 > (Xi = wo + Ni | 0) >>> 0 ? Yi + 1 | 0 : Yi, $n = ((67108863 & (Ni = ($n = Xi + 33554432 | 0) >>> 0 < 33554432 ? Ni + 1 | 0 : Ni)) << 6 | (Yi = $n) >>> 26) + Qo | 0, o[E + 236 >> 2] = $n, o[E + 380 >> 2] = $n + (Mi - ye | 0), Yi = Xi - (-67108864 & Yi) | 0, o[E + 232 >> 2] = Yi, o[E + 376 >> 2] = Yi + (Tr - Ne | 0), bo = to - (-33554432 & Zn) | 0, Ni = Zr(ro, ro >> 31, 486662, 0), Xi = Qe, $n = Zr(Ln, Ln >> 31, 486662, 0), Yi = Qe, wo = Ni, Ni = (Ni = (Yi = (to = $n + 16777216 | 0) >>> 0 < 16777216 ? Yi + 1 | 0 : Yi) >> 25) + Xi | 0, Xi = (Yi = (33554431 & Yi) << 7 | to >>> 25) >>> 0 > (Zn = wo + Yi | 0) >>> 0 ? Ni + 1 | 0 : Ni, Ni = ((67108863 & (Xi = (Yi = Zn + 33554432 | 0) >>> 0 < 33554432 ? Xi + 1 | 0 : Xi)) << 6 | Yi >>> 26) + bo | 0, o[E + 228 >> 2] = Ni, o[E + 372 >> 2] = Ni + (li - pr | 0), Yi = Zn - (-67108864 & Yi) | 0, o[E + 224 >> 2] = Yi, o[E + 368 >> 2] = Yi + (Jr - ve | 0), bo = $n - (-33554432 & to) | 0, Yi = Zr(qo, qo >> 31, 486662, 0), Xi = Qe, to = Zr(So, So >> 31, 486662, 0), Ni = Qe, wo = Yi, Xi = (Yi = (Ni = (Zn = to + 16777216 | 0) >>> 0 < 16777216 ? Ni + 1 | 0 : Ni) >> 25) + Xi | 0, Yi = Xi = (Ni = wo + ($n = (33554431 & Ni) << 7 | Zn >>> 25) | 0) >>> 0 < $n >>> 0 ? Xi + 1 | 0 : Xi, $n = ((67108863 & (Yi = ($n = Ni + 33554432 | 0) >>> 0 < 33554432 ? Yi + 1 | 0 : Yi)) << 6 | (Xi = $n) >>> 26) + bo | 0, o[E + 220 >> 2] = $n, o[E + 364 >> 2] = $n + (fi - cr | 0), Yi = Ni - (-67108864 & Xi) | 0, o[E + 216 >> 2] = Yi, o[E + 360 >> 2] = Yi + (ti - gr | 0), Zn = to - (-33554432 & Zn) | 0, Xi = Zr((33554431 & fo) << 7 | qn >>> 25, fo >> 25, 19, 0), Yi = Qe, Ni = Xi, Xi = Zr(io, io >> 31, 486662, 0), Yi = Qe + Yi | 0, Yi = (Ni = Ni + Xi | 0) >>> 0 < Xi >>> 0 ? Yi + 1 | 0 : Yi, fo = ((67108863 & (Yi = (Xi = Ni + 33554432 | 0) >>> 0 < 33554432 ? Yi + 1 | 0 : Yi)) << 6 | Xi >>> 26) + Zn | 0, o[E + 212 >> 2] = fo, o[E + 356 >> 2] = fo + (jr - Pr | 0), Yi = Ni - (-67108864 & Xi) | 0, o[E + 208 >> 2] = Yi, o[E + 352 >> 2] = Yi + (Mr - go | 0), Ti(Yi = E + 624 | 0, Xi = E + 352 | 0, Xi), Ti(E, Xi, Yi), qi(Xi = E + 784 | 0, E), qi(Xi, Xi), Ti(Yi = E + 912 | 0, E, Xi), qi(Xi = E + 576 | 0, Yi), qi(Xi, Xi), qi(Xi, Xi), qi(Xi, Xi), Ti(Ni = E + 528 | 0, Yi, Xi), qi(Ni, Ni), qi(Ni, Ni), Ti(Ni, Ni, E), Yi = o[E + 564 >> 2], o[E + 512 >> 2] = o[E + 560 >> 2], o[E + 516 >> 2] = Yi, Yi = o[E + 556 >> 2], o[E + 504 >> 2] = o[E + 552 >> 2], o[E + 508 >> 2] = Yi, Yi = o[E + 548 >> 2], o[E + 496 >> 2] = o[E + 544 >> 2], o[E + 500 >> 2] = Yi, Yi = o[E + 540 >> 2], o[E + 488 >> 2] = o[E + 536 >> 2], o[E + 492 >> 2] = Yi, Yi = o[E + 532 >> 2], o[E + 480 >> 2] = o[E + 528 >> 2], o[E + 484 >> 2] = Yi, qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), Ti(Ni, Ni, Yi = E + 480 | 0), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), Ti(Ni, Ni, Yi), Yi = o[E + 564 >> 2], o[E + 464 >> 2] = o[E + 560 >> 2], o[E + 468 >> 2] = Yi, Yi = o[E + 556 >> 2], o[E + 456 >> 2] = o[E + 552 >> 2], o[E + 460 >> 2] = Yi, Yi = o[E + 548 >> 2], o[E + 448 >> 2] = o[E + 544 >> 2], o[E + 452 >> 2] = Yi, Yi = o[E + 540 >> 2], o[E + 440 >> 2] = o[E + 536 >> 2], o[E + 444 >> 2] = Yi, Yi = o[E + 532 >> 2], o[E + 432 >> 2] = o[E + 528 >> 2], o[E + 436 >> 2] = Yi, qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), Ti(Ni, Ni, Xi = E + 432 | 0), Yi = o[E + 564 >> 2], o[E + 464 >> 2] = o[E + 560 >> 2], o[E + 468 >> 2] = Yi, Yi = o[E + 556 >> 2], o[E + 456 >> 2] = o[E + 552 >> 2], o[E + 460 >> 2] = Yi, Yi = o[E + 548 >> 2], o[E + 448 >> 2] = o[E + 544 >> 2], o[E + 452 >> 2] = Yi, Yi = o[E + 540 >> 2], o[E + 440 >> 2] = o[E + 536 >> 2], o[E + 444 >> 2] = Yi, Yi = o[E + 532 >> 2], o[E + 432 >> 2] = o[E + 528 >> 2], o[E + 436 >> 2] = Yi, qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), qi(Ni, Ni), Ti(Ni, Ni, Xi), Yi = o[E + 564 >> 2], o[E + 464 >> 2] = o[E + 560 >> 2], o[E + 468 >> 2] = Yi, Yi = o[E + 556 >> 2], o[E + 456 >> 2] = o[E + 552 >> 2], o[E + 460 >> 2] = Yi, Yi = o[E + 548 >> 2], o[E + 448 >> 2] = o[E + 544 >> 2], o[E + 452 >> 2] = Yi, Yi = o[E + 540 >> 2], o[E + 440 >> 2] = o[E + 536 >> 2], o[E + 444 >> 2] = Yi, Yi = o[E + 532 >> 2], o[E + 432 >> 2] = o[E + 528 >> 2], o[E + 436 >> 2] = Yi; qi(Yi = E + 528 | 0, Yi), (0 | (Vo = Vo + 1 | 0)) != 120; ) ;
                      Ti(Yi, Yi, E + 432 | 0), qi(Yi, Yi), qi(Yi, Yi), qi(Yi, Yi), qi(Yi, Yi), qi(Yi, Yi), qi(Yi, Yi), qi(Yi, Yi), qi(Yi, Yi), qi(Yi, Yi), qi(Yi, Yi), Ti(Yi, Yi, E + 480 | 0), qi(Yi, Yi), qi(Yi, Yi), qi(Yi, Yi), Ti(Yi, Yi, E), qi(Yi, Yi), i2(E + 400 | 0, Yi), io = o[E + 256 >> 2], So = o[E + 260 >> 2], qo = o[E + 264 >> 2], Ln = o[E + 268 >> 2], ro = o[E + 272 >> 2], Zn = o[E + 276 >> 2], fo = o[E + 280 >> 2], Ni = o[E + 284 >> 2], Xi = o[E + 288 >> 2], wo = (go = 0 - (1 & B[E + 401 | 0]) | 0) & (0 - (Yi = o[E + 292 >> 2]) ^ Yi) ^ Yi, o[E + 660 >> 2] = wo, bo = Xi ^ go & (Xi ^ 0 - Xi), o[E + 656 >> 2] = bo, qn = Ni ^ go & (Ni ^ 0 - Ni), o[E + 652 >> 2] = qn, $n = fo ^ go & (fo ^ 0 - fo), o[E + 648 >> 2] = $n, to = Zn ^ go & (Zn ^ 0 - Zn), o[E + 644 >> 2] = to, Zn = ro ^ go & (ro ^ 0 - ro), o[E + 640 >> 2] = Zn, fo = Ln ^ go & (Ln ^ 0 - Ln), o[E + 636 >> 2] = fo, Ni = qo ^ go & (qo ^ 0 - qo), o[E + 632 >> 2] = Ni, Xi = So ^ go & (So ^ 0 - So), o[E + 628 >> 2] = Xi, Yi = (io ^ go & (io ^ 0 - io)) - (486662 & go) | 0, o[E + 624 >> 2] = Yi + 1, o[E + 820 >> 2] = wo, o[E + 816 >> 2] = bo, o[E + 812 >> 2] = qn, o[E + 808 >> 2] = $n, o[E + 804 >> 2] = to, o[E + 800 >> 2] = Zn, o[E + 796 >> 2] = fo, o[E + 792 >> 2] = Ni, o[E + 788 >> 2] = Xi, o[E + 784 >> 2] = Yi - 1, ia(E, E + 624 | 0), Ti(Yi = E + 912 | 0, E + 784 | 0, E), i2(k, Yi), B[k + 31 | 0] = m[k + 31 | 0] | Nr, No(E, k) && (Hl(), ji()), Yi = o[E + 36 >> 2], o[E + 816 >> 2] = o[E + 32 >> 2], o[E + 820 >> 2] = Yi, Yi = o[E + 28 >> 2], o[E + 808 >> 2] = o[E + 24 >> 2], o[E + 812 >> 2] = Yi, Yi = o[E + 20 >> 2], o[E + 800 >> 2] = o[E + 16 >> 2], o[E + 804 >> 2] = Yi, Yi = o[E + 12 >> 2], o[E + 792 >> 2] = o[E + 8 >> 2], o[E + 796 >> 2] = Yi, Yi = o[E + 52 >> 2], o[E + 832 >> 2] = o[E + 48 >> 2], o[E + 836 >> 2] = Yi, Yi = o[E + 60 >> 2], o[E + 840 >> 2] = o[E + 56 >> 2], o[E + 844 >> 2] = Yi, Yi = o[4 + (Xi = E - -64 | 0) >> 2], o[E + 848 >> 2] = o[Xi >> 2], o[E + 852 >> 2] = Yi, Yi = o[E + 76 >> 2], o[E + 856 >> 2] = o[E + 72 >> 2], o[E + 860 >> 2] = Yi, Yi = o[E + 4 >> 2], o[E + 784 >> 2] = o[E >> 2], o[E + 788 >> 2] = Yi, Yi = o[E + 44 >> 2], o[E + 824 >> 2] = o[E + 40 >> 2], o[E + 828 >> 2] = Yi, Yi = o[E + 116 >> 2], o[E + 896 >> 2] = o[E + 112 >> 2], o[E + 900 >> 2] = Yi, Yi = o[E + 108 >> 2], o[E + 888 >> 2] = o[E + 104 >> 2], o[E + 892 >> 2] = Yi, Yi = o[E + 100 >> 2], o[E + 880 >> 2] = o[E + 96 >> 2], o[E + 884 >> 2] = Yi, Yi = o[E + 92 >> 2], o[E + 872 >> 2] = o[E + 88 >> 2], o[E + 876 >> 2] = Yi, Yi = o[E + 84 >> 2], o[E + 864 >> 2] = o[E + 80 >> 2], o[E + 868 >> 2] = Yi, Oa($n = E + 624 | 0, to = E + 784 | 0), Ti(to, $n, Zn = E + 744 | 0), Ti(Xi = E + 824 | 0, Ni = E + 664 | 0, fo = E + 704 | 0), Ti(Yi = E + 864 | 0, fo, Zn), Oa($n, to), Ti(to, $n, Zn), Ti(Xi, Ni, fo), Ti(Yi, fo, Zn), Oa($n, to), Ti(E, $n, Zn), Ti(Xi = E + 40 | 0, Ni, fo), Ti(Yi = E + 80 | 0, fo, Zn), Ti(E + 120 | 0, $n, Ni), ia($n, Yi), Ti(to, E, $n), Ti(Yi = E + 912 | 0, Xi, $n), i2(k, Yi), i2(E + 576 | 0, to), B[k + 31 | 0] = m[k + 31 | 0] ^ m[E + 576 | 0] << 7, dr = E + 960 | 0, dr = T + 48 | 0;
                    }
                    function un(k) {
                      var E, T = 0, M = 0, ye = 0, Ne = 0, pr = 0, ve = 0, cr = 0, gr = 0, Pr = 0, Nr = 0, Br = 0, Mr = 0;
                      dr = E = dr - 16 | 0;
                      e: {
                        t: {
                          r: {
                            i: {
                              n: {
                                o: {
                                  a: {
                                    s: {
                                      A: {
                                        u: {
                                          if ((k |= 0) >>> 0 <= 244) {
                                            if (3 & (T = (Ne = o[9405]) >>> (k = (cr = k >>> 0 < 11 ? 16 : k + 11 & 504) >>> 3 | 0) | 0)) {
                                              k = 37660 + (T = (M = k + (1 & ~T) | 0) << 3) | 0, T = o[T + 37668 >> 2], (0 | k) != (0 | (ye = o[T + 8 >> 2])) ? (o[ye + 12 >> 2] = k, o[k + 8 >> 2] = ye) : (Br = 37620, Mr = ao(-2, M) & Ne, o[Br >> 2] = Mr), k = T + 8 | 0, M <<= 3, o[T + 4 >> 2] = 3 | M, o[4 + (T = T + M | 0) >> 2] = 1 | o[T + 4 >> 2];
                                              break e;
                                            }
                                            if ((gr = o[9407]) >>> 0 >= cr >>> 0) break u;
                                            if (T) {
                                              T = 37660 + (M = (k = pA((0 - (M = 2 << k) | M) & T << k)) << 3) | 0, M = o[M + 37668 >> 2], (0 | T) != (0 | (ye = o[M + 8 >> 2])) ? (o[ye + 12 >> 2] = T, o[T + 8 >> 2] = ye) : (Ne = ao(-2, k) & Ne, o[9405] = Ne), o[M + 4 >> 2] = 3 | cr, pr = (k <<= 3) - cr | 0, o[4 + (ve = M + cr | 0) >> 2] = 1 | pr, o[k + M >> 2] = pr, gr && (k = 37660 + (-8 & gr) | 0, ye = o[9410], (T = 1 << (gr >>> 3)) & Ne ? T = o[k + 8 >> 2] : (o[9405] = T | Ne, T = k), o[k + 8 >> 2] = ye, o[T + 12 >> 2] = ye, o[ye + 12 >> 2] = k, o[ye + 8 >> 2] = T), k = M + 8 | 0, o[9410] = ve, o[9407] = pr;
                                              break e;
                                            }
                                            if (!(Nr = o[9406])) break u;
                                            for (M = o[37924 + (pA(Nr) << 2) >> 2], pr = (-8 & o[M + 4 >> 2]) - cr | 0, T = M; (k = o[T + 16 >> 2]) || (k = o[T + 20 >> 2]); ) pr = (T = (ye = (-8 & o[k + 4 >> 2]) - cr | 0) >>> 0 < pr >>> 0) ? ye : pr, M = T ? k : M, T = k;
                                            if (Pr = o[M + 24 >> 2], (0 | M) != (0 | (k = o[M + 12 >> 2]))) {
                                              T = o[M + 8 >> 2], o[T + 12 >> 2] = k, o[k + 8 >> 2] = T;
                                              break t;
                                            }
                                            if (T = o[M + 20 >> 2]) ye = M + 20 | 0;
                                            else {
                                              if (!(T = o[M + 16 >> 2])) break A;
                                              ye = M + 16 | 0;
                                            }
                                            for (; ve = ye, ye = (k = T) + 20 | 0, (T = o[k + 20 >> 2]) || (ye = k + 16 | 0, T = o[k + 16 >> 2]); ) ;
                                            o[ve >> 2] = 0;
                                            break t;
                                          }
                                          if (cr = -1, !(k >>> 0 > 4294967231) && (cr = -8 & (T = k + 11 | 0), ve = o[9406])) {
                                            gr = 31, pr = 0 - cr | 0, k >>> 0 <= 16777204 && (gr = 62 + ((cr >>> 38 - (k = he(T >>> 8 | 0)) & 1) - (k << 1) | 0) | 0);
                                            h: {
                                              c: {
                                                if (T = o[37924 + (gr << 2) >> 2]) for (k = 0, M = cr << ((0 | gr) != 31 ? 25 - (gr >>> 1 | 0) : 0); ; ) {
                                                  if (!((Ne = (-8 & o[T + 4 >> 2]) - cr | 0) >>> 0 >= pr >>> 0 || (ye = T, pr = Ne))) {
                                                    pr = 0, k = T;
                                                    break c;
                                                  }
                                                  if (Ne = o[T + 20 >> 2], T = o[16 + ((M >>> 29 & 4) + T | 0) >> 2], k = Ne ? (0 | Ne) == (0 | T) ? k : Ne : k, M <<= 1, !T) break;
                                                }
                                                else k = 0;
                                                if (!(k | ye)) {
                                                  if (ye = 0, !(k = (0 - (k = 2 << gr) | k) & ve)) break u;
                                                  k = o[37924 + (pA(k) << 2) >> 2];
                                                }
                                                if (!k) break h;
                                              }
                                              for (; pr = (T = (M = (-8 & o[k + 4 >> 2]) - cr | 0) >>> 0 < pr >>> 0) ? M : pr, ye = T ? k : ye, k = (T = o[k + 16 >> 2]) || o[k + 20 >> 2]; ) ;
                                            }
                                            if (!(!ye | o[9407] - cr >>> 0 <= pr >>> 0)) {
                                              if (gr = o[ye + 24 >> 2], (0 | ye) != (0 | (k = o[ye + 12 >> 2]))) {
                                                T = o[ye + 8 >> 2], o[T + 12 >> 2] = k, o[k + 8 >> 2] = T;
                                                break r;
                                              }
                                              if (T = o[ye + 20 >> 2]) M = ye + 20 | 0;
                                              else {
                                                if (!(T = o[ye + 16 >> 2])) break s;
                                                M = ye + 16 | 0;
                                              }
                                              for (; Ne = M, M = (k = T) + 20 | 0, (T = o[k + 20 >> 2]) || (M = k + 16 | 0, T = o[k + 16 >> 2]); ) ;
                                              o[Ne >> 2] = 0;
                                              break r;
                                            }
                                          }
                                        }
                                        if ((ye = o[9407]) >>> 0 >= cr >>> 0) {
                                          k = o[9410], (T = ye - cr | 0) >>> 0 >= 16 ? (o[4 + (M = k + cr | 0) >> 2] = 1 | T, o[k + ye >> 2] = T, o[k + 4 >> 2] = 3 | cr) : (o[k + 4 >> 2] = 3 | ye, o[4 + (T = k + ye | 0) >> 2] = 1 | o[T + 4 >> 2], M = 0, T = 0), o[9407] = T, o[9410] = M, k = k + 8 | 0;
                                          break e;
                                        }
                                        if ((M = o[9408]) >>> 0 > cr >>> 0) {
                                          T = M - cr | 0, o[9408] = T, M = (k = o[9411]) + cr | 0, o[9411] = M, o[M + 4 >> 2] = 1 | T, o[k + 4 >> 2] = 3 | cr, k = k + 8 | 0;
                                          break e;
                                        }
                                        if (k = 0, pr = cr + 47 | 0, o[9523] ? T = o[9525] : (o[9526] = -1, o[9527] = -1, o[9524] = 4096, o[9525] = 4096, o[9523] = E + 12 & -16 ^ 1431655768, o[9528] = 0, o[9516] = 0, T = 4096), (T = (Ne = pr + T | 0) & (ve = 0 - T | 0)) >>> 0 <= cr >>> 0 || (gr = o[9515]) && (ye = (Pr = o[9513]) + T | 0) >>> 0 <= Pr >>> 0 | ye >>> 0 > gr >>> 0) break e;
                                        u: {
                                          if (!(4 & m[38064])) {
                                            h: {
                                              c: {
                                                f: {
                                                  p: {
                                                    if (ye = o[9411]) for (k = 38068; ; ) {
                                                      if ((gr = o[k >> 2]) >>> 0 <= ye >>> 0 & ye >>> 0 < gr + o[k + 4 >> 2] >>> 0) break p;
                                                      if (!(k = o[k + 8 >> 2])) break;
                                                    }
                                                    if ((0 | (M = bc(0))) == -1 || (Ne = T, (ye = (k = o[9524]) - 1 | 0) & M && (Ne = (T - M | 0) + (M + ye & 0 - k) | 0), Ne >>> 0 <= cr >>> 0) || (ye = o[9515]) && (k = (ve = o[9513]) + Ne | 0) >>> 0 <= ve >>> 0 | k >>> 0 > ye >>> 0) break h;
                                                    if ((0 | M) != (0 | (k = bc(Ne)))) break f;
                                                    break u;
                                                  }
                                                  if ((0 | (M = bc(Ne = ve & Ne - M))) == (o[k >> 2] + o[k + 4 >> 2] | 0)) break c;
                                                  k = M;
                                                }
                                                if ((0 | k) == -1) break h;
                                                if (cr + 48 >>> 0 <= Ne >>> 0) {
                                                  M = k;
                                                  break u;
                                                }
                                                if ((0 | bc(M = (M = o[9525]) + (pr - Ne | 0) & 0 - M)) == -1) break h;
                                                Ne = M + Ne | 0, M = k;
                                                break u;
                                              }
                                              if ((0 | M) != -1) break u;
                                            }
                                            o[9516] = 4 | o[9516];
                                          }
                                          if ((0 | (M = bc(T))) == -1 | (0 | (k = bc(0))) == -1 | k >>> 0 <= M >>> 0 || (Ne = k - M | 0) >>> 0 <= cr + 40 >>> 0) break n;
                                        }
                                        k = o[9513] + Ne | 0, o[9513] = k, k >>> 0 > d[9514] && (o[9514] = k);
                                        u: {
                                          if (pr = o[9411]) {
                                            for (k = 38068; ; ) {
                                              if (((T = o[k >> 2]) + (ye = o[k + 4 >> 2]) | 0) == (0 | M)) break u;
                                              if (!(k = o[k + 8 >> 2])) break;
                                            }
                                            break a;
                                          }
                                          for ((k = o[9409]) >>> 0 <= M >>> 0 && k || (o[9409] = M), k = 0, o[9518] = Ne, o[9517] = M, o[9413] = -1, o[9414] = o[9523], o[9520] = 0; ye = 37660 + (T = k << 3) | 0, o[T + 37668 >> 2] = ye, o[T + 37672 >> 2] = ye, (0 | (k = k + 1 | 0)) != 32; ) ;
                                          ye = (k = Ne - 40 | 0) - (T = -8 - M & 7) | 0, o[9408] = ye, T = T + M | 0, o[9411] = T, o[T + 4 >> 2] = 1 | ye, o[4 + (k + M | 0) >> 2] = 40, o[9412] = o[9527];
                                          break o;
                                        }
                                        if (8 & o[k + 12 >> 2] | M >>> 0 <= pr >>> 0 | T >>> 0 > pr >>> 0) break a;
                                        o[k + 4 >> 2] = ye + Ne, T = (k = -8 - pr & 7) + pr | 0, o[9411] = T, k = (M = o[9408] + Ne | 0) - k | 0, o[9408] = k, o[T + 4 >> 2] = 1 | k, o[4 + (M + pr | 0) >> 2] = 40, o[9412] = o[9527];
                                        break o;
                                      }
                                      k = 0;
                                      break t;
                                    }
                                    k = 0;
                                    break r;
                                  }
                                  d[9409] > M >>> 0 && (o[9409] = M), ye = M + Ne | 0, k = 38068;
                                  a: {
                                    for (; ; ) {
                                      if ((0 | (T = o[k >> 2])) != (0 | ye)) {
                                        if (k = o[k + 8 >> 2]) continue;
                                        break a;
                                      }
                                      break;
                                    }
                                    if (!(8 & m[k + 12 | 0])) break i;
                                  }
                                  for (k = 38068; !((T = o[k >> 2]) >>> 0 <= pr >>> 0 && (ye = T + o[k + 4 >> 2] | 0) >>> 0 > pr >>> 0); ) k = o[k + 8 >> 2];
                                  for (ve = (k = Ne - 40 | 0) - (T = -8 - M & 7) | 0, o[9408] = ve, T = T + M | 0, o[9411] = T, o[T + 4 >> 2] = 1 | ve, o[4 + (k + M | 0) >> 2] = 40, o[9412] = o[9527], o[(T = (k = (ye + (39 - ye & 7) | 0) - 47 | 0) >>> 0 < pr + 16 >>> 0 ? pr : k) + 4 >> 2] = 27, k = o[9520], o[T + 16 >> 2] = o[9519], o[T + 20 >> 2] = k, k = o[9518], o[T + 8 >> 2] = o[9517], o[T + 12 >> 2] = k, o[9519] = T + 8, o[9518] = Ne, o[9517] = M, o[9520] = 0, k = T + 24 | 0; o[k + 4 >> 2] = 7, M = k + 8 | 0, k = k + 4 | 0, M >>> 0 < ye >>> 0; ) ;
                                  if ((0 | T) != (0 | pr)) {
                                    o[T + 4 >> 2] = -2 & o[T + 4 >> 2], M = T - pr | 0, o[pr + 4 >> 2] = 1 | M, o[T >> 2] = M;
                                    a: if (M >>> 0 <= 255) k = 37660 + (-8 & M) | 0, (T = o[9405]) & (M = 1 << (M >>> 3)) ? T = o[k + 8 >> 2] : (o[9405] = T | M, T = k), o[k + 8 >> 2] = pr, o[T + 12 >> 2] = pr, ye = 8, M = 12;
                                    else {
                                      k = 31, M >>> 0 <= 16777215 && (k = 62 + ((M >>> 38 - (k = he(M >>> 8 | 0)) & 1) - (k << 1) | 0) | 0), o[pr + 28 >> 2] = k, o[pr + 16 >> 2] = 0, o[pr + 20 >> 2] = 0, T = 37924 + (k << 2) | 0;
                                      s: {
                                        if ((ye = o[9406]) & (Ne = 1 << k)) {
                                          for (k = M << ((0 | k) != 31 ? 25 - (k >>> 1 | 0) : 0), ye = o[T >> 2]; ; ) {
                                            if ((0 | M) == (-8 & o[(T = ye) + 4 >> 2])) break s;
                                            if (ye = k >>> 29 | 0, k <<= 1, !(ye = o[16 + (Ne = (4 & ye) + T | 0) >> 2])) break;
                                          }
                                          o[Ne + 16 >> 2] = pr;
                                        } else o[9406] = ye | Ne, o[T >> 2] = pr;
                                        o[pr + 24 >> 2] = T, k = T = pr, ye = 12, M = 8;
                                        break a;
                                      }
                                      k = o[T + 8 >> 2], o[k + 12 >> 2] = pr, o[T + 8 >> 2] = pr, o[pr + 8 >> 2] = k, k = 0, ye = 12, M = 24;
                                    }
                                    o[ye + pr >> 2] = T, o[M + pr >> 2] = k;
                                  }
                                }
                                if (!((k = o[9408]) >>> 0 <= cr >>> 0)) {
                                  T = k - cr | 0, o[9408] = T, M = (k = o[9411]) + cr | 0, o[9411] = M, o[M + 4 >> 2] = 1 | T, o[k + 4 >> 2] = 3 | cr, k = k + 8 | 0;
                                  break e;
                                }
                              }
                              o[9404] = 48, k = 0;
                              break e;
                            }
                            o[k >> 2] = M, o[k + 4 >> 2] = o[k + 4 >> 2] + Ne, o[4 + (gr = (-8 - M & 7) + M | 0) >> 2] = 3 | cr, ve = (Ne = T + (-8 - T & 7) | 0) - (pr = cr + gr | 0) | 0;
                            i: if (o[9411] != (0 | Ne)) if (o[9410] != (0 | Ne)) {
                              if ((3 & (k = o[Ne + 4 >> 2])) == 1) {
                                Pr = -8 & k, M = o[Ne + 12 >> 2];
                                n: if (k >>> 0 <= 255) {
                                  if ((0 | (T = o[Ne + 8 >> 2])) == (0 | M)) {
                                    Br = 37620, Mr = o[9405] & ao(-2, k >>> 3 | 0), o[Br >> 2] = Mr;
                                    break n;
                                  }
                                  o[T + 12 >> 2] = M, o[M + 8 >> 2] = T;
                                } else {
                                  cr = o[Ne + 24 >> 2];
                                  o: if ((0 | M) == (0 | Ne)) {
                                    a: {
                                      if (k = o[Ne + 20 >> 2]) T = Ne + 20 | 0;
                                      else {
                                        if (!(k = o[Ne + 16 >> 2])) break a;
                                        T = Ne + 16 | 0;
                                      }
                                      for (; ye = T, M = k, T = k + 20 | 0, (k = o[k + 20 >> 2]) || (T = M + 16 | 0, k = o[M + 16 >> 2]); ) ;
                                      o[ye >> 2] = 0;
                                      break o;
                                    }
                                    M = 0;
                                  } else k = o[Ne + 8 >> 2], o[k + 12 >> 2] = M, o[M + 8 >> 2] = k;
                                  if (cr) {
                                    k = o[Ne + 28 >> 2];
                                    o: {
                                      if (o[(T = 37924 + (k << 2) | 0) >> 2] == (0 | Ne)) {
                                        if (o[T >> 2] = M, M) break o;
                                        Br = 37624, Mr = o[9406] & ao(-2, k), o[Br >> 2] = Mr;
                                        break n;
                                      }
                                      if (o[cr + (o[cr + 16 >> 2] == (0 | Ne) ? 16 : 20) >> 2] = M, !M) break n;
                                    }
                                    o[M + 24 >> 2] = cr, (k = o[Ne + 16 >> 2]) && (o[M + 16 >> 2] = k, o[k + 24 >> 2] = M), (k = o[Ne + 20 >> 2]) && (o[M + 20 >> 2] = k, o[k + 24 >> 2] = M);
                                  }
                                }
                                ve = ve + Pr | 0, k = o[4 + (Ne = Ne + Pr | 0) >> 2];
                              }
                              if (o[Ne + 4 >> 2] = -2 & k, o[pr + 4 >> 2] = 1 | ve, o[pr + ve >> 2] = ve, ve >>> 0 <= 255) k = 37660 + (-8 & ve) | 0, (T = o[9405]) & (M = 1 << (ve >>> 3)) ? T = o[k + 8 >> 2] : (o[9405] = T | M, T = k), o[k + 8 >> 2] = pr, o[T + 12 >> 2] = pr, o[pr + 12 >> 2] = k, o[pr + 8 >> 2] = T;
                              else {
                                M = 31, ve >>> 0 <= 16777215 && (M = 62 + ((ve >>> 38 - (k = he(ve >>> 8 | 0)) & 1) - (k << 1) | 0) | 0), o[pr + 28 >> 2] = M, o[pr + 16 >> 2] = 0, o[pr + 20 >> 2] = 0, k = 37924 + (M << 2) | 0;
                                n: {
                                  if ((T = o[9406]) & (ye = 1 << M)) {
                                    for (M = ve << ((0 | M) != 31 ? 25 - (M >>> 1 | 0) : 0), T = o[k >> 2]; ; ) {
                                      if ((-8 & o[(k = T) + 4 >> 2]) == (0 | ve)) break n;
                                      if (T = M >>> 29 | 0, M <<= 1, !(T = o[16 + (ye = (4 & T) + k | 0) >> 2])) break;
                                    }
                                    o[ye + 16 >> 2] = pr;
                                  } else o[9406] = T | ye, o[k >> 2] = pr;
                                  o[pr + 24 >> 2] = k, o[pr + 12 >> 2] = pr, o[pr + 8 >> 2] = pr;
                                  break i;
                                }
                                T = o[k + 8 >> 2], o[T + 12 >> 2] = pr, o[k + 8 >> 2] = pr, o[pr + 24 >> 2] = 0, o[pr + 12 >> 2] = k, o[pr + 8 >> 2] = T;
                              }
                            } else o[9410] = pr, k = o[9407] + ve | 0, o[9407] = k, o[pr + 4 >> 2] = 1 | k, o[k + pr >> 2] = k;
                            else o[9411] = pr, k = o[9408] + ve | 0, o[9408] = k, o[pr + 4 >> 2] = 1 | k;
                            k = gr + 8 | 0;
                            break e;
                          }
                          r: if (gr) {
                            T = o[ye + 28 >> 2];
                            i: {
                              if (o[(M = 37924 + (T << 2) | 0) >> 2] == (0 | ye)) {
                                if (o[M >> 2] = k, k) break i;
                                ve = ao(-2, T) & ve, o[9406] = ve;
                                break r;
                              }
                              if (o[gr + (o[gr + 16 >> 2] == (0 | ye) ? 16 : 20) >> 2] = k, !k) break r;
                            }
                            o[k + 24 >> 2] = gr, (T = o[ye + 16 >> 2]) && (o[k + 16 >> 2] = T, o[T + 24 >> 2] = k), (T = o[ye + 20 >> 2]) && (o[k + 20 >> 2] = T, o[T + 24 >> 2] = k);
                          }
                          r: if (pr >>> 0 <= 15) k = pr + cr | 0, o[ye + 4 >> 2] = 3 | k, o[4 + (k = k + ye | 0) >> 2] = 1 | o[k + 4 >> 2];
                          else if (o[ye + 4 >> 2] = 3 | cr, o[4 + (Ne = ye + cr | 0) >> 2] = 1 | pr, o[pr + Ne >> 2] = pr, pr >>> 0 <= 255) k = 37660 + (-8 & pr) | 0, (T = o[9405]) & (M = 1 << (pr >>> 3)) ? T = o[k + 8 >> 2] : (o[9405] = T | M, T = k), o[k + 8 >> 2] = Ne, o[T + 12 >> 2] = Ne, o[Ne + 12 >> 2] = k, o[Ne + 8 >> 2] = T;
                          else {
                            k = 31, pr >>> 0 <= 16777215 && (k = 62 + ((pr >>> 38 - (k = he(pr >>> 8 | 0)) & 1) - (k << 1) | 0) | 0), o[Ne + 28 >> 2] = k, o[Ne + 16 >> 2] = 0, o[Ne + 20 >> 2] = 0, T = 37924 + (k << 2) | 0;
                            i: {
                              if ((M = 1 << k) & ve) {
                                for (k = pr << ((0 | k) != 31 ? 25 - (k >>> 1 | 0) : 0), T = o[T >> 2]; ; ) {
                                  if (M = T, (-8 & o[T + 4 >> 2]) == (0 | pr)) break i;
                                  if (ve = k >>> 29 | 0, k <<= 1, !(T = o[16 + (ve = T + (4 & ve) | 0) >> 2])) break;
                                }
                                o[ve + 16 >> 2] = Ne, o[Ne + 24 >> 2] = M;
                              } else o[9406] = M | ve, o[T >> 2] = Ne, o[Ne + 24 >> 2] = T;
                              o[Ne + 12 >> 2] = Ne, o[Ne + 8 >> 2] = Ne;
                              break r;
                            }
                            k = o[M + 8 >> 2], o[k + 12 >> 2] = Ne, o[M + 8 >> 2] = Ne, o[Ne + 24 >> 2] = 0, o[Ne + 12 >> 2] = M, o[Ne + 8 >> 2] = k;
                          }
                          k = ye + 8 | 0;
                          break e;
                        }
                        t: if (Pr) {
                          T = o[M + 28 >> 2];
                          r: {
                            if (o[(ye = 37924 + (T << 2) | 0) >> 2] == (0 | M)) {
                              if (o[ye >> 2] = k, k) break r;
                              Br = 37624, Mr = ao(-2, T) & Nr, o[Br >> 2] = Mr;
                              break t;
                            }
                            if (o[Pr + (o[Pr + 16 >> 2] == (0 | M) ? 16 : 20) >> 2] = k, !k) break t;
                          }
                          o[k + 24 >> 2] = Pr, (T = o[M + 16 >> 2]) && (o[k + 16 >> 2] = T, o[T + 24 >> 2] = k), (T = o[M + 20 >> 2]) && (o[k + 20 >> 2] = T, o[T + 24 >> 2] = k);
                        }
                        pr >>> 0 <= 15 ? (k = pr + cr | 0, o[M + 4 >> 2] = 3 | k, o[4 + (k = k + M | 0) >> 2] = 1 | o[k + 4 >> 2]) : (o[M + 4 >> 2] = 3 | cr, o[4 + (ve = M + cr | 0) >> 2] = 1 | pr, o[pr + ve >> 2] = pr, gr && (k = 37660 + (-8 & gr) | 0, ye = o[9410], (T = 1 << (gr >>> 3)) & Ne ? T = o[k + 8 >> 2] : (o[9405] = T | Ne, T = k), o[k + 8 >> 2] = ye, o[T + 12 >> 2] = ye, o[ye + 12 >> 2] = k, o[ye + 8 >> 2] = T), o[9410] = ve, o[9407] = pr), k = M + 8 | 0;
                      }
                      return dr = E + 16 | 0, 0 | k;
                    }
                    function In(k, E, T, M, ye, Ne) {
                      var pr, ve = 0, cr = 0, gr = 0, Pr = 0, Nr = 0, Br = 0, Mr = 0, jr = 0, ti = 0, fi = 0, Jr = 0, li = 0, Tr = 0, Mi = 0, Wi = 0, vn = 0, Tn = 0, Ni = 0, Yi = 0, Xi = 0, $n = 0, Zn = 0, to = 0, fo = 0, wo = 0, bo = 0, go = 0, qn = 0, io = 0, So = 0, qo = 0, Ln = 0, ro = 0, Qo = 0, Vo = 0, as = 0, cs = 0, ms = 0;
                      if (dr = pr = dr - 592 | 0, gr = -1, gc(cr = k + 32 | 0) && !Ia(k) && ha(ye) && !Ia(ye) && !mf(Nr = pr + 128 | 0, ye)) {
                        for (Ks(gr = pr + 384 | 0), Ne && qs(gr, 35600, 34, 0), qs(gr, k, 32, 0), qs(gr, ye, 32, 0), qs(gr, E, T, M), ds(E = gr, gr = pr + 320 | 0), Si(gr), M = pr + 8 | 0, T = cr, ye = 0, E = 0, dr = ve = dr - 2272 | 0; Ne = ve + 2016 | 0, cr = m[gr + (ye >>> 3 | 0) | 0], B[Ne + ye | 0] = cr >>> (6 & ye) & 1, B[(Pr = Ne) + (Ne = 1 | ye) | 0] = cr >>> (7 & Ne) & 1, (0 | (ye = ye + 2 | 0)) != 256; ) ;
                        for (; ; ) {
                          E = (Ne = E) + 1 | 0;
                          e: if (!(Ne >>> 0 > 254) && m[0 | (Mr = (ye = ve + 2016 | 0) + Ne | 0)]) {
                            t: if (ye = B[0 | (Br = E + ye | 0)]) if ((0 | (ye = (gr = ye << 1) + (cr = B[0 | Mr]) | 0)) <= 15) B[0 | Mr] = ye, B[0 | Br] = 0;
                            else {
                              if ((0 | (ye = cr - gr | 0)) < -15) break e;
                              for (B[0 | Mr] = ye, ye = E; ; ) {
                                if (!m[0 | (cr = (ve + 2016 | 0) + ye | 0)]) {
                                  B[0 | cr] = 1;
                                  break t;
                                }
                                if (B[0 | cr] = 0, cr = ye >>> 0 < 255, ye = ye + 1 | 0, !cr) break;
                              }
                            }
                            if (!(Ne >>> 0 > 253)) {
                              t: if (cr = B[0 | (Pr = (ye = Ne + 2 | 0) + (ve + 2016 | 0) | 0)]) if ((0 | (cr = (Br = cr << 2) + (gr = B[0 | Mr]) | 0)) >= 16) {
                                if ((0 | (cr = gr - Br | 0)) < -15) break e;
                                for (B[0 | Mr] = cr; ; ) {
                                  if (m[0 | (cr = (ve + 2016 | 0) + ye | 0)]) {
                                    if (B[0 | cr] = 0, cr = ye >>> 0 < 255, ye = ye + 1 | 0, cr) continue;
                                    break t;
                                  }
                                  break;
                                }
                                B[0 | cr] = 1;
                              } else B[0 | Mr] = cr, B[0 | Pr] = 0;
                              if ((0 | Ne) != 253) {
                                t: if (cr = B[0 | (Pr = (ye = Ne + 3 | 0) + (ve + 2016 | 0) | 0)]) if ((0 | (cr = (Br = cr << 3) + (gr = B[0 | Mr]) | 0)) >= 16) {
                                  if ((0 | (cr = gr - Br | 0)) < -15) break e;
                                  for (B[0 | Mr] = cr; ; ) {
                                    if (m[0 | (cr = (ve + 2016 | 0) + ye | 0)]) {
                                      if (B[0 | cr] = 0, cr = ye >>> 0 < 255, ye = ye + 1 | 0, cr) continue;
                                      break t;
                                    }
                                    break;
                                  }
                                  B[0 | cr] = 1;
                                } else B[0 | Mr] = cr, B[0 | Pr] = 0;
                                if (!(Ne >>> 0 > 251)) {
                                  t: if (cr = B[0 | (Pr = (ye = Ne + 4 | 0) + (ve + 2016 | 0) | 0)]) if ((0 | (cr = (Br = cr << 4) + (gr = B[0 | Mr]) | 0)) >= 16) {
                                    if ((0 | (cr = gr - Br | 0)) < -15) break e;
                                    for (B[0 | Mr] = cr; ; ) {
                                      if (m[0 | (cr = (ve + 2016 | 0) + ye | 0)]) {
                                        if (B[0 | cr] = 0, cr = ye >>> 0 < 255, ye = ye + 1 | 0, cr) continue;
                                        break t;
                                      }
                                      break;
                                    }
                                    B[0 | cr] = 1;
                                  } else B[0 | Mr] = cr, B[0 | Pr] = 0;
                                  if ((0 | Ne) != 251) {
                                    t: if (cr = B[0 | (Pr = (ye = Ne + 5 | 0) + (ve + 2016 | 0) | 0)]) if ((0 | (cr = (Br = cr << 5) + (gr = B[0 | Mr]) | 0)) >= 16) {
                                      if ((0 | (cr = gr - Br | 0)) < -15) break e;
                                      for (B[0 | Mr] = cr; ; ) {
                                        if (m[0 | (cr = (ve + 2016 | 0) + ye | 0)]) {
                                          if (B[0 | cr] = 0, cr = ye >>> 0 < 255, ye = ye + 1 | 0, cr) continue;
                                          break t;
                                        }
                                        break;
                                      }
                                      B[0 | cr] = 1;
                                    } else B[0 | Mr] = cr, B[0 | Pr] = 0;
                                    if (!(Ne >>> 0 > 249) && (Ne = B[0 | (Br = (ye = Ne + 6 | 0) + (ve + 2016 | 0) | 0)])) if ((0 | (Ne = (gr = Ne << 6) + (cr = B[0 | Mr]) | 0)) >= 16) {
                                      if ((0 | (Ne = cr - gr | 0)) < -15) break e;
                                      for (B[0 | Mr] = Ne; ; ) {
                                        if (m[0 | (Ne = (ve + 2016 | 0) + ye | 0)]) {
                                          if (B[0 | Ne] = 0, Ne = ye >>> 0 < 255, ye = ye + 1 | 0, Ne) continue;
                                          break e;
                                        }
                                        break;
                                      }
                                      B[0 | Ne] = 1;
                                    } else B[0 | Mr] = Ne, B[0 | Br] = 0;
                                  }
                                }
                              }
                            }
                          }
                          if ((0 | E) == 256) break;
                        }
                        for (ye = 0; E = ve + 1760 | 0, Ne = m[T + (ye >>> 3 | 0) | 0], B[E + ye | 0] = Ne >>> (6 & ye) & 1, B[(cr = E) + (E = 1 | ye) | 0] = Ne >>> (7 & E) & 1, (0 | (ye = ye + 2 | 0)) != 256; ) ;
                        for (E = 0; ; ) {
                          T = E, E = E + 1 | 0;
                          e: if (!(T >>> 0 > 254) && m[0 | (Pr = (ye = ve + 1760 | 0) + T | 0)]) {
                            t: if (ye = B[0 | (gr = E + ye | 0)]) if ((0 | (ye = (cr = ye << 1) + (Ne = B[0 | Pr]) | 0)) <= 15) B[0 | Pr] = ye, B[0 | gr] = 0;
                            else {
                              if ((0 | (ye = Ne - cr | 0)) < -15) break e;
                              for (B[0 | Pr] = ye, ye = E; ; ) {
                                if (!m[0 | (Ne = (ve + 1760 | 0) + ye | 0)]) {
                                  B[0 | Ne] = 1;
                                  break t;
                                }
                                if (B[0 | Ne] = 0, Ne = ye >>> 0 < 255, ye = ye + 1 | 0, !Ne) break;
                              }
                            }
                            if (!(T >>> 0 > 253)) {
                              t: if (Ne = B[0 | (Br = (ye = T + 2 | 0) + (ve + 1760 | 0) | 0)]) if ((0 | (Ne = (gr = Ne << 2) + (cr = B[0 | Pr]) | 0)) >= 16) {
                                if ((0 | (Ne = cr - gr | 0)) < -15) break e;
                                for (B[0 | Pr] = Ne; ; ) {
                                  if (m[0 | (Ne = (ve + 1760 | 0) + ye | 0)]) {
                                    if (B[0 | Ne] = 0, Ne = ye >>> 0 < 255, ye = ye + 1 | 0, Ne) continue;
                                    break t;
                                  }
                                  break;
                                }
                                B[0 | Ne] = 1;
                              } else B[0 | Pr] = Ne, B[0 | Br] = 0;
                              if ((0 | T) != 253) {
                                t: if (Ne = B[0 | (Br = (ye = T + 3 | 0) + (ve + 1760 | 0) | 0)]) if ((0 | (Ne = (gr = Ne << 3) + (cr = B[0 | Pr]) | 0)) >= 16) {
                                  if ((0 | (Ne = cr - gr | 0)) < -15) break e;
                                  for (B[0 | Pr] = Ne; ; ) {
                                    if (m[0 | (Ne = (ve + 1760 | 0) + ye | 0)]) {
                                      if (B[0 | Ne] = 0, Ne = ye >>> 0 < 255, ye = ye + 1 | 0, Ne) continue;
                                      break t;
                                    }
                                    break;
                                  }
                                  B[0 | Ne] = 1;
                                } else B[0 | Pr] = Ne, B[0 | Br] = 0;
                                if (!(T >>> 0 > 251)) {
                                  t: if (Ne = B[0 | (Br = (ye = T + 4 | 0) + (ve + 1760 | 0) | 0)]) if ((0 | (Ne = (gr = Ne << 4) + (cr = B[0 | Pr]) | 0)) >= 16) {
                                    if ((0 | (Ne = cr - gr | 0)) < -15) break e;
                                    for (B[0 | Pr] = Ne; ; ) {
                                      if (m[0 | (Ne = (ve + 1760 | 0) + ye | 0)]) {
                                        if (B[0 | Ne] = 0, Ne = ye >>> 0 < 255, ye = ye + 1 | 0, Ne) continue;
                                        break t;
                                      }
                                      break;
                                    }
                                    B[0 | Ne] = 1;
                                  } else B[0 | Pr] = Ne, B[0 | Br] = 0;
                                  if ((0 | T) != 251) {
                                    t: if (Ne = B[0 | (Br = (ye = T + 5 | 0) + (ve + 1760 | 0) | 0)]) if ((0 | (Ne = (gr = Ne << 5) + (cr = B[0 | Pr]) | 0)) >= 16) {
                                      if ((0 | (Ne = cr - gr | 0)) < -15) break e;
                                      for (B[0 | Pr] = Ne; ; ) {
                                        if (m[0 | (Ne = (ve + 1760 | 0) + ye | 0)]) {
                                          if (B[0 | Ne] = 0, Ne = ye >>> 0 < 255, ye = ye + 1 | 0, Ne) continue;
                                          break t;
                                        }
                                        break;
                                      }
                                      B[0 | Ne] = 1;
                                    } else B[0 | Pr] = Ne, B[0 | Br] = 0;
                                    if (!(T >>> 0 > 249) && (T = B[0 | (gr = (ye = T + 6 | 0) + (ve + 1760 | 0) | 0)])) if ((0 | (T = (cr = T << 6) + (Ne = B[0 | Pr]) | 0)) >= 16) {
                                      if ((0 | (T = Ne - cr | 0)) < -15) break e;
                                      for (B[0 | Pr] = T; ; ) {
                                        if (m[0 | (T = (ve + 1760 | 0) + ye | 0)]) {
                                          if (B[0 | T] = 0, T = ye >>> 0 < 255, ye = ye + 1 | 0, T) continue;
                                          break e;
                                        }
                                        break;
                                      }
                                      B[0 | T] = 1;
                                    } else B[0 | Pr] = T, B[0 | gr] = 0;
                                  }
                                }
                              }
                            }
                          }
                          if ((0 | E) == 256) break;
                        }
                        for ($a(ye = ve + 480 | 0, Nr), E = o[Nr + 36 >> 2], o[ve + 192 >> 2] = o[Nr + 32 >> 2], o[ve + 196 >> 2] = E, E = o[Nr + 28 >> 2], o[ve + 184 >> 2] = o[Nr + 24 >> 2], o[ve + 188 >> 2] = E, E = o[Nr + 20 >> 2], o[ve + 176 >> 2] = o[Nr + 16 >> 2], o[ve + 180 >> 2] = E, E = o[Nr + 12 >> 2], o[ve + 168 >> 2] = o[Nr + 8 >> 2], o[ve + 172 >> 2] = E, E = o[Nr + 4 >> 2], o[ve + 160 >> 2] = o[Nr >> 2], o[ve + 164 >> 2] = E, E = o[Nr + 52 >> 2], o[ve + 208 >> 2] = o[Nr + 48 >> 2], o[ve + 212 >> 2] = E, E = o[Nr + 60 >> 2], o[ve + 216 >> 2] = o[Nr + 56 >> 2], o[ve + 220 >> 2] = E, E = o[4 + (T = Nr - -64 | 0) >> 2], o[ve + 224 >> 2] = o[T >> 2], o[ve + 228 >> 2] = E, E = o[Nr + 76 >> 2], o[ve + 232 >> 2] = o[Nr + 72 >> 2], o[ve + 236 >> 2] = E, E = o[Nr + 44 >> 2], o[ve + 200 >> 2] = o[Nr + 40 >> 2], o[ve + 204 >> 2] = E, E = o[Nr + 92 >> 2], o[ve + 248 >> 2] = o[Nr + 88 >> 2], o[ve + 252 >> 2] = E, E = o[Nr + 100 >> 2], o[ve + 256 >> 2] = o[Nr + 96 >> 2], o[ve + 260 >> 2] = E, E = o[Nr + 108 >> 2], o[ve + 264 >> 2] = o[Nr + 104 >> 2], o[ve + 268 >> 2] = E, E = o[Nr + 116 >> 2], o[ve + 272 >> 2] = o[Nr + 112 >> 2], o[ve + 276 >> 2] = E, E = o[Nr + 84 >> 2], o[ve + 240 >> 2] = o[Nr + 80 >> 2], o[ve + 244 >> 2] = E, Oa(Ne = ve + 320 | 0, T = ve + 160 | 0), Ti(ve, Ne, jr = ve + 440 | 0), Ti(ve + 40 | 0, ti = ve + 360 | 0, fi = ve + 400 | 0), Ti(ve + 80 | 0, fi, jr), Ti(ve + 120 | 0, Ne, ti), Aa(Ne, ve, ye), Ti(T, Ne, jr), Ti(li = ve + 200 | 0, ti, fi), Ti(Tr = ve + 240 | 0, fi, jr), Ti(Jr = ve + 280 | 0, Ne, ti), $a(E = ve + 640 | 0, T), Aa(Ne, ve, E), Ti(T, Ne, jr), Ti(li, ti, fi), Ti(Tr, fi, jr), Ti(Jr, Ne, ti), $a(E = ve + 800 | 0, T), Aa(Ne, ve, E), Ti(T, Ne, jr), Ti(li, ti, fi), Ti(Tr, fi, jr), Ti(Jr, Ne, ti), $a(E = ve + 960 | 0, T), Aa(Ne, ve, E), Ti(T, Ne, jr), Ti(li, ti, fi), Ti(Tr, fi, jr), Ti(Jr, Ne, ti), $a(E = ve + 1120 | 0, T), Aa(Ne, ve, E), Ti(T, Ne, jr), Ti(li, ti, fi), Ti(Tr, fi, jr), Ti(Jr, Ne, ti), $a(E = ve + 1280 | 0, T), Aa(Ne, ve, E), Ti(T, Ne, jr), Ti(li, ti, fi), Ti(Tr, fi, jr), Ti(Jr, Ne, ti), $a(E = ve + 1440 | 0, T), Aa(Ne, ve, E), Ti(T, Ne, jr), Ti(li, ti, fi), Ti(Tr, fi, jr), Ti(Jr, Ne, ti), $a(ve + 1600 | 0, T), o[M + 32 >> 2] = 0, o[M + 36 >> 2] = 0, o[M + 24 >> 2] = 0, o[M + 28 >> 2] = 0, o[M + 16 >> 2] = 0, o[M + 20 >> 2] = 0, o[M + 8 >> 2] = 0, o[M + 12 >> 2] = 0, o[M >> 2] = 0, o[M + 4 >> 2] = 0, o[M + 44 >> 2] = 0, o[M + 48 >> 2] = 0, o[M + 40 >> 2] = 1, o[M + 52 >> 2] = 0, o[M + 56 >> 2] = 0, o[M + 60 >> 2] = 0, o[M + 64 >> 2] = 0, o[M + 68 >> 2] = 0, o[M + 72 >> 2] = 0, o[M + 84 >> 2] = 0, o[M + 88 >> 2] = 0, o[M + 76 >> 2] = 0, o[M + 80 >> 2] = 1, o[M + 92 >> 2] = 0, o[M + 96 >> 2] = 0, o[M + 100 >> 2] = 0, o[M + 104 >> 2] = 0, o[M + 108 >> 2] = 0, o[M + 112 >> 2] = 0, o[M + 116 >> 2] = 0, ro = M + 80 | 0, Qo = M + 40 | 0, E = 255; ; ) {
                          e: {
                            t: {
                              if (!m[(T = ve + 2016 | 0) + E | 0] && !m[(ye = ve + 1760 | 0) + E | 0]) {
                                if (!(m[(Ne = T) + (T = E - 1 | 0) | 0] | m[T + ye | 0])) break t;
                                E = T;
                              }
                              if ((0 | E) < 0) break e;
                              for (; Oa(ye = ve + 320 | 0, M), T = E, (0 | (Ne = B[E + (ve + 2016 | 0) | 0])) > 0 ? (Ti(E = ve + 160 | 0, ye, jr), Ti(li, ti, fi), Ti(Tr, fi, jr), Ti(Jr, ye, ti), Aa(ye, E, (ve + 480 | 0) + v((254 & Ne) >>> 1 | 0, 160) | 0)) : (0 | Ne) >= 0 || (Ti(E = ve + 160 | 0, ye = ve + 320 | 0, jr), Ti(li, ti, fi), Ti(Tr, fi, jr), Ti(Jr, ye, ti), zs(ye, E, (ve + 480 | 0) + v((0 - Ne & 254) >>> 1 | 0, 160) | 0)), (0 | (wo = B[T + (ve + 1760 | 0) | 0])) > 0 ? (Ti(E = ve + 160 | 0, ye = ve + 320 | 0, jr), Ti(li, ti, fi), Ti(Tr, fi, jr), Ti(Jr, ye, ti), x2(ye, E, v((254 & wo) >>> 1 | 0, 120) + 1728 | 0)) : (0 | wo) >= 0 || (Ti(ve + 160 | 0, bo = ve + 320 | 0, jr), Ti(li, ti, fi), Ti(Tr, fi, jr), Ti(Jr, bo, ti), Mi = o[ve + 160 >> 2], Wi = o[ve + 200 >> 2], vn = o[ve + 164 >> 2], Tn = o[ve + 204 >> 2], Ni = o[ve + 168 >> 2], Yi = o[ve + 208 >> 2], Xi = o[ve + 172 >> 2], $n = o[ve + 212 >> 2], Zn = o[ve + 176 >> 2], to = o[ve + 216 >> 2], fo = o[ve + 180 >> 2], Mr = o[ve + 220 >> 2], Pr = o[ve + 184 >> 2], Br = o[ve + 224 >> 2], gr = o[ve + 188 >> 2], Nr = o[ve + 228 >> 2], cr = o[ve + 192 >> 2], Ne = o[ve + 232 >> 2], ye = o[ve + 236 >> 2], E = o[ve + 196 >> 2], o[ve + 396 >> 2] = ye - E, o[ve + 392 >> 2] = Ne - cr, o[ve + 388 >> 2] = Nr - gr, o[ve + 384 >> 2] = Br - Pr, o[ve + 380 >> 2] = Mr - fo, o[ve + 376 >> 2] = to - Zn, o[ve + 372 >> 2] = $n - Xi, o[ve + 368 >> 2] = Yi - Ni, o[ve + 364 >> 2] = Tn - vn, o[ve + 360 >> 2] = Wi - Mi, o[ve + 356 >> 2] = E + ye, o[ve + 352 >> 2] = Ne + cr, o[ve + 348 >> 2] = gr + Nr, o[ve + 344 >> 2] = Pr + Br, o[ve + 340 >> 2] = Mr + fo, o[ve + 336 >> 2] = Zn + to, o[ve + 332 >> 2] = Xi + $n, o[ve + 328 >> 2] = Ni + Yi, o[ve + 324 >> 2] = vn + Tn, o[ve + 320 >> 2] = Mi + Wi, Ti(fi, bo, 40 + (E = v((0 - wo & 254) >>> 1 | 0, 120) + 1728 | 0) | 0), Ti(ti, ti, E), Ti(jr, E + 80 | 0, Jr), Vo = o[ve + 276 >> 2], as = o[ve + 272 >> 2], wo = o[ve + 268 >> 2], bo = o[ve + 264 >> 2], Pr = o[ve + 260 >> 2], Br = o[ve + 256 >> 2], gr = o[ve + 252 >> 2], Nr = o[ve + 248 >> 2], cr = o[ve + 244 >> 2], Ne = o[ve + 240 >> 2], go = o[ve + 360 >> 2], qn = o[ve + 400 >> 2], io = o[ve + 364 >> 2], So = o[ve + 404 >> 2], qo = o[ve + 368 >> 2], Ln = o[ve + 408 >> 2], Mi = o[ve + 372 >> 2], Wi = o[ve + 412 >> 2], vn = o[ve + 376 >> 2], Tn = o[ve + 416 >> 2], Ni = o[ve + 380 >> 2], Yi = o[ve + 420 >> 2], Xi = o[ve + 384 >> 2], $n = o[ve + 424 >> 2], Zn = o[ve + 388 >> 2], to = o[ve + 428 >> 2], fo = o[ve + 392 >> 2], Mr = o[ve + 432 >> 2], ye = o[ve + 396 >> 2], E = o[ve + 436 >> 2], o[ve + 396 >> 2] = ye + E, o[ve + 392 >> 2] = Mr + fo, o[ve + 388 >> 2] = Zn + to, o[ve + 384 >> 2] = Xi + $n, o[ve + 380 >> 2] = Ni + Yi, o[ve + 376 >> 2] = vn + Tn, o[ve + 372 >> 2] = Mi + Wi, o[ve + 368 >> 2] = qo + Ln, o[ve + 364 >> 2] = io + So, o[ve + 360 >> 2] = go + qn, o[ve + 356 >> 2] = E - ye, o[ve + 352 >> 2] = Mr - fo, o[ve + 348 >> 2] = to - Zn, o[ve + 344 >> 2] = $n - Xi, o[ve + 340 >> 2] = Yi - Ni, o[ve + 336 >> 2] = Tn - vn, o[ve + 332 >> 2] = Wi - Mi, o[ve + 328 >> 2] = Ln - qo, o[ve + 324 >> 2] = So - io, o[ve + 320 >> 2] = qn - go, Mi = Ne << 1, Wi = o[ve + 440 >> 2], o[ve + 400 >> 2] = Mi - Wi, vn = cr << 1, Tn = o[ve + 444 >> 2], o[ve + 404 >> 2] = vn - Tn, Ni = Nr << 1, Yi = o[ve + 448 >> 2], o[ve + 408 >> 2] = Ni - Yi, Xi = gr << 1, $n = o[ve + 452 >> 2], o[ve + 412 >> 2] = Xi - $n, Zn = Br << 1, to = o[ve + 456 >> 2], o[ve + 416 >> 2] = Zn - to, fo = Pr << 1, Mr = o[ve + 460 >> 2], o[ve + 420 >> 2] = fo - Mr, Pr = bo << 1, Br = o[ve + 464 >> 2], o[ve + 424 >> 2] = Pr - Br, gr = wo << 1, Nr = o[ve + 468 >> 2], o[ve + 428 >> 2] = gr - Nr, cr = as << 1, Ne = o[ve + 472 >> 2], o[ve + 432 >> 2] = cr - Ne, ye = Vo << 1, E = o[ve + 476 >> 2], o[ve + 436 >> 2] = ye - E, o[ve + 440 >> 2] = Mi + Wi, o[ve + 444 >> 2] = vn + Tn, o[ve + 448 >> 2] = Ni + Yi, o[ve + 452 >> 2] = Xi + $n, o[ve + 456 >> 2] = Zn + to, o[ve + 460 >> 2] = Mr + fo, o[ve + 464 >> 2] = Pr + Br, o[ve + 468 >> 2] = gr + Nr, o[ve + 472 >> 2] = Ne + cr, o[ve + 476 >> 2] = E + ye), Ti(M, ve + 320 | 0, jr), Ti(Qo, ti, fi), Ti(ro, fi, jr), E = T - 1 | 0, (0 | T) > 0; ) ;
                              break e;
                            }
                            if (E = E - 2 | 0, T) continue;
                          }
                          break;
                        }
                        dr = ve + 2272 | 0, Rc(E = pr + 288 | 0, M), cs = -1, ms = tu(E, k), gr = ((0 | k) == (0 | E) ? cs : ms) | bi(k, E, 32);
                      }
                      return dr = pr + 592 | 0, gr;
                    }
                    function Ti(k, E, T) {
                      var M, ye, Ne, pr, ve, cr, gr, Pr, Nr, Br, Mr, jr, ti, fi, Jr, li, Tr, Mi, Wi, vn, Tn, Ni, Yi, Xi, $n, Zn, to, fo, wo, bo, go, qn, io, So, qo, Ln, ro, Qo, Vo, as, cs, ms, ai, ci, Fi, Eo, is, ws, ys, Is, ks, Ps, Po, fn = 0, Qn = 0, zn = 0, es = 0, us = 0, Cs = 0, Es = 0, Rs = 0, Ds = 0, Ns = 0, Fs = 0, Qs = 0, Ys = 0, Vs = 0, Hs = 0, ra = 0, ca = 0, ua = 0, la = 0, ma = 0, Ba = 0, Ea = 0, _a = 0, xa = 0, Ka = 0;
                      fn = Zr(M = o[T + 4 >> 2], Br = M >> 31, ca = (li = o[E + 20 >> 2]) << 1, go = ca >> 31), zn = Qe, Qn = (Ys = Zr(Hs = o[T >> 2], Ne = Hs >> 31, ye = o[E + 24 >> 2], pr = ye >> 31)) + fn | 0, fn = Qe + zn | 0, fn = Qn >>> 0 < Ys >>> 0 ? fn + 1 | 0 : fn, Ds = Zr(ve = o[T + 8 >> 2], ti = ve >> 31, Ys = o[E + 16 >> 2], cr = Ys >> 31), zn = Qe + fn | 0, zn = (Qn = Ds + Qn | 0) >>> 0 < Ds >>> 0 ? zn + 1 | 0 : zn, fn = (Ds = Zr(Mr = o[T + 12 >> 2], Tr = Mr >> 31, Xi = (Mi = o[E + 12 >> 2]) << 1, qn = Xi >> 31)) + Qn | 0, Qn = Qe + zn | 0, Qn = fn >>> 0 < Ds >>> 0 ? Qn + 1 | 0 : Qn, zn = (Vs = Zr(fi = o[T + 16 >> 2], $n = fi >> 31, Ds = o[E + 8 >> 2], gr = Ds >> 31)) + fn | 0, fn = Qe + Qn | 0, fn = zn >>> 0 < Vs >>> 0 ? fn + 1 | 0 : fn, Qn = zn, zn = Zr(Wi = o[T + 20 >> 2], io = Wi >> 31, Zn = (vn = o[E + 4 >> 2]) << 1, So = Zn >> 31), fn = Qe + fn | 0, fn = (Qn = Qn + zn | 0) >>> 0 < zn >>> 0 ? fn + 1 | 0 : fn, Eo = Es = o[T + 24 >> 2], zn = (Ns = Zr(Es, ci = Es >> 31, Vs = o[E >> 2], Pr = Vs >> 31)) + Qn | 0, Qn = Qe + fn | 0, Qn = zn >>> 0 < Ns >>> 0 ? Qn + 1 | 0 : Qn, qo = o[T + 28 >> 2], fn = (Ns = Zr(Qs = v(qo, 19), Tn = Qs >> 31, to = (Ni = o[E + 36 >> 2]) << 1, Ln = to >> 31)) + zn | 0, zn = Qe + Qn | 0, zn = fn >>> 0 < Ns >>> 0 ? zn + 1 | 0 : zn, Ba = o[T + 32 >> 2], Qn = (Rs = Zr(es = v(Ba, 19), Jr = es >> 31, Ns = o[E + 32 >> 2], Nr = Ns >> 31)) + fn | 0, fn = Qe + zn | 0, fn = Qn >>> 0 < Rs >>> 0 ? fn + 1 | 0 : fn, is = o[T + 36 >> 2], T = Zr(Rs = v(is, 19), jr = Rs >> 31, fo = (Yi = o[E + 28 >> 2]) << 1, ro = fo >> 31), fn = Qe + fn | 0, us = E = T + Qn | 0, T = E >>> 0 < T >>> 0 ? fn + 1 | 0 : fn, E = Zr(Ys, cr, M, Br), fn = Qe, Qn = Zr(Hs, Ne, li, Qo = li >> 31), zn = Qe + fn | 0, zn = (E = Qn + E | 0) >>> 0 < Qn >>> 0 ? zn + 1 | 0 : zn, fn = Zr(ve, ti, Mi, Vo = Mi >> 31), Qn = Qe + zn | 0, Qn = (E = fn + E | 0) >>> 0 < fn >>> 0 ? Qn + 1 | 0 : Qn, zn = Zr(Ds, gr, Mr, Tr), fn = Qe + Qn | 0, fn = (E = zn + E | 0) >>> 0 < zn >>> 0 ? fn + 1 | 0 : fn, Qn = Zr(fi, $n, vn, as = vn >> 31), fn = Qe + fn | 0, fn = (E = Qn + E | 0) >>> 0 < Qn >>> 0 ? fn + 1 | 0 : fn, Qn = Zr(Vs, Pr, Wi, io), fn = Qe + fn | 0, fn = (E = Qn + E | 0) >>> 0 < Qn >>> 0 ? fn + 1 | 0 : fn, Qn = Zr(Es = v(Es, 19), wo = Es >> 31, Ni, cs = Ni >> 31), zn = Qe + fn | 0, zn = (E = Qn + E | 0) >>> 0 < Qn >>> 0 ? zn + 1 | 0 : zn, fn = Zr(Ns, Nr, Qs, Tn), Qn = Qe + zn | 0, Qn = (E = fn + E | 0) >>> 0 < fn >>> 0 ? Qn + 1 | 0 : Qn, zn = Zr(es, Jr, Yi, ms = Yi >> 31), fn = Qe + Qn | 0, fn = (E = zn + E | 0) >>> 0 < zn >>> 0 ? fn + 1 | 0 : fn, Qn = Zr(Rs, jr, ye, pr), fn = Qe + fn | 0, _a = E = Qn + E | 0, ua = E >>> 0 < Qn >>> 0 ? fn + 1 | 0 : fn, E = Zr(M, Br, Xi, qn), fn = Qe, Qn = Zr(Hs, Ne, Ys, cr), fn = Qe + fn | 0, fn = (E = Qn + E | 0) >>> 0 < Qn >>> 0 ? fn + 1 | 0 : fn, Qn = Zr(Ds, gr, ve, ti), zn = Qe + fn | 0, zn = (E = Qn + E | 0) >>> 0 < Qn >>> 0 ? zn + 1 | 0 : zn, fn = Zr(Mr, Tr, Zn, So), Qn = Qe + zn | 0, Qn = (E = fn + E | 0) >>> 0 < fn >>> 0 ? Qn + 1 | 0 : Qn, zn = Zr(Vs, Pr, fi, $n), fn = Qe + Qn | 0, fn = (E = zn + E | 0) >>> 0 < zn >>> 0 ? fn + 1 | 0 : fn, Qn = Zr(bo = v(Wi, 19), ai = bo >> 31, to, Ln), fn = Qe + fn | 0, fn = (E = Qn + E | 0) >>> 0 < Qn >>> 0 ? fn + 1 | 0 : fn, Qn = Zr(Ns, Nr, Es, wo), fn = Qe + fn | 0, fn = (E = Qn + E | 0) >>> 0 < Qn >>> 0 ? fn + 1 | 0 : fn, Qn = Zr(Qs, Tn, fo, ro), zn = Qe + fn | 0, zn = (E = Qn + E | 0) >>> 0 < Qn >>> 0 ? zn + 1 | 0 : zn, fn = Zr(es, Jr, ye, pr), Qn = Qe + zn | 0, Qn = (E = fn + E | 0) >>> 0 < fn >>> 0 ? Qn + 1 | 0 : Qn, zn = Zr(Rs, jr, ca, go), fn = Qe + Qn | 0, ws = E = zn + E | 0, ys = fn = E >>> 0 < zn >>> 0 ? fn + 1 | 0 : fn, Is = E = E + 33554432 | 0, ks = fn = E >>> 0 < 33554432 ? fn + 1 | 0 : fn, zn = (67108863 & fn) << 6 | E >>> 26, fn = (fn >> 26) + ua | 0, _a = E = zn + _a | 0, fn = E >>> 0 < zn >>> 0 ? fn + 1 | 0 : fn, Ps = E = E + 16777216 | 0, fn = T + (Qn = (zn = E >>> 0 < 16777216 ? fn + 1 | 0 : fn) >> 25) | 0, fn = (E = (zn = (33554431 & zn) << 7 | E >>> 25) + us | 0) >>> 0 < zn >>> 0 ? fn + 1 | 0 : fn, la = T = (Qn = E) + 33554432 | 0, E = fn = T >>> 0 < 33554432 ? fn + 1 | 0 : fn, o[k + 24 >> 2] = Qn - (-67108864 & T), T = Zr(M, Br, Zn, So), fn = Qe, Qn = Zr(Hs, Ne, Ds, gr), zn = Qe + fn | 0, zn = (T = Qn + T | 0) >>> 0 < Qn >>> 0 ? zn + 1 | 0 : zn, Qn = (fn = T) + (T = Zr(Vs, Pr, ve, ti)) | 0, fn = Qe + zn | 0, fn = T >>> 0 > Qn >>> 0 ? fn + 1 | 0 : fn, zn = Zr(T = v(Mr, 19), ma = T >> 31, to, Ln), fn = Qe + fn | 0, fn = (Qn = zn + Qn | 0) >>> 0 < zn >>> 0 ? fn + 1 | 0 : fn, zn = (us = Zr(Ns, Nr, ua = v(fi, 19), Fi = ua >> 31)) + Qn | 0, Qn = Qe + fn | 0, Qn = zn >>> 0 < us >>> 0 ? Qn + 1 | 0 : Qn, us = Zr(fo, ro, bo, ai), fn = Qe + Qn | 0, fn = (zn = us + zn | 0) >>> 0 < us >>> 0 ? fn + 1 | 0 : fn, Qn = (us = Zr(ye, pr, Es, wo)) + zn | 0, zn = Qe + fn | 0, zn = Qn >>> 0 < us >>> 0 ? zn + 1 | 0 : zn, us = Zr(Qs, Tn, ca, go), fn = Qe + zn | 0, fn = (Qn = us + Qn | 0) >>> 0 < us >>> 0 ? fn + 1 | 0 : fn, zn = Zr(es, Jr, Ys, cr), fn = Qe + fn | 0, fn = (Qn = zn + Qn | 0) >>> 0 < zn >>> 0 ? fn + 1 | 0 : fn, zn = (us = Zr(Rs, jr, Xi, qn)) + Qn | 0, Qn = Qe + fn | 0, Fs = zn, xa = zn >>> 0 < us >>> 0 ? Qn + 1 | 0 : Qn, fn = Zr(Vs, Pr, M, Br), Qn = Qe, zn = (us = Zr(Hs, Ne, vn, as)) + fn | 0, fn = Qe + Qn | 0, fn = zn >>> 0 < us >>> 0 ? fn + 1 | 0 : fn, us = Qn = v(ve, 19), Qn = (Cs = Zr(Qn, Ea = Qn >> 31, Ni, cs)) + zn | 0, zn = Qe + fn | 0, zn = Qn >>> 0 < Cs >>> 0 ? zn + 1 | 0 : zn, Cs = Zr(Ns, Nr, T, ma), fn = Qe + zn | 0, fn = (Qn = Cs + Qn | 0) >>> 0 < Cs >>> 0 ? fn + 1 | 0 : fn, zn = Zr(ua, Fi, Yi, ms), fn = Qe + fn | 0, fn = (Qn = zn + Qn | 0) >>> 0 < zn >>> 0 ? fn + 1 | 0 : fn, zn = (Cs = Zr(ye, pr, bo, ai)) + Qn | 0, Qn = Qe + fn | 0, Qn = zn >>> 0 < Cs >>> 0 ? Qn + 1 | 0 : Qn, Cs = Zr(Es, wo, li, Qo), fn = Qe + Qn | 0, fn = (zn = Cs + zn | 0) >>> 0 < Cs >>> 0 ? fn + 1 | 0 : fn, Qn = (Cs = Zr(Ys, cr, Qs, Tn)) + zn | 0, zn = Qe + fn | 0, zn = Qn >>> 0 < Cs >>> 0 ? zn + 1 | 0 : zn, Cs = Zr(es, Jr, Mi, Vo), fn = Qe + zn | 0, fn = (Qn = Cs + Qn | 0) >>> 0 < Cs >>> 0 ? fn + 1 | 0 : fn, zn = Zr(Rs, jr, Ds, gr), fn = Qe + fn | 0, Ka = Qn = zn + Qn | 0, Cs = Qn >>> 0 < zn >>> 0 ? fn + 1 | 0 : fn, fn = Zr(fn = v(M, 19), fn >> 31, to, Ln), Qn = Qe, zn = Zr(Hs, Ne, Vs, Pr), Qn = Qe + Qn | 0, Qn = (fn = zn + fn | 0) >>> 0 < zn >>> 0 ? Qn + 1 | 0 : Qn, zn = (us = Zr(Ns, Nr, us, Ea)) + fn | 0, fn = Qe + Qn | 0, T = (Qn = Zr(T, ma, fo, ro)) + zn | 0, zn = Qe + (zn >>> 0 < us >>> 0 ? fn + 1 | 0 : fn) | 0, zn = T >>> 0 < Qn >>> 0 ? zn + 1 | 0 : zn, Qn = Zr(ye, pr, ua, Fi), fn = Qe + zn | 0, fn = (T = Qn + T | 0) >>> 0 < Qn >>> 0 ? fn + 1 | 0 : fn, Qn = Zr(ca, go, bo, ai), fn = Qe + fn | 0, fn = (T = Qn + T | 0) >>> 0 < Qn >>> 0 ? fn + 1 | 0 : fn, zn = Zr(Ys, cr, Es, wo), Qn = Qe + fn | 0, Qn = (T = zn + T | 0) >>> 0 < zn >>> 0 ? Qn + 1 | 0 : Qn, zn = Zr(Qs, Tn, Xi, qn), fn = Qe + Qn | 0, fn = (T = zn + T | 0) >>> 0 < zn >>> 0 ? fn + 1 | 0 : fn, Qn = Zr(es, Jr, Ds, gr), zn = Qe + fn | 0, zn = (T = Qn + T | 0) >>> 0 < Qn >>> 0 ? zn + 1 | 0 : zn, Qn = Zr(Rs, jr, Zn, So), fn = Qe + zn | 0, us = T = Qn + T | 0, ma = fn = T >>> 0 < Qn >>> 0 ? fn + 1 | 0 : fn, Ea = T = T + 33554432 | 0, Po = fn = T >>> 0 < 33554432 ? fn + 1 | 0 : fn, Qn = (zn = fn >> 26) + Cs | 0, Cs = T = (fn = (67108863 & fn) << 6 | T >>> 26) + Ka | 0, fn = T >>> 0 < fn >>> 0 ? Qn + 1 | 0 : Qn, Ka = T = T + 16777216 | 0, Qn = (33554431 & (fn = T >>> 0 < 16777216 ? fn + 1 | 0 : fn)) << 7 | T >>> 25, fn = (fn >> 25) + xa | 0, fn = (T = Qn + Fs | 0) >>> 0 < Qn >>> 0 ? fn + 1 | 0 : fn, xa = Qn = (zn = T) + 33554432 | 0, T = fn = Qn >>> 0 < 33554432 ? fn + 1 | 0 : fn, o[k + 8 >> 2] = zn - (-67108864 & Qn), fn = Zr(ye, pr, M, Br), zn = Qe, Qn = (Fs = Zr(Hs, Ne, Yi, ms)) + fn | 0, fn = Qe + zn | 0, fn = Qn >>> 0 < Fs >>> 0 ? fn + 1 | 0 : fn, zn = Zr(ve, ti, li, Qo), fn = Qe + fn | 0, fn = (Qn = zn + Qn | 0) >>> 0 < zn >>> 0 ? fn + 1 | 0 : fn, zn = Zr(Ys, cr, Mr, Tr), fn = Qe + fn | 0, fn = (Qn = zn + Qn | 0) >>> 0 < zn >>> 0 ? fn + 1 | 0 : fn, Fs = Zr(fi, $n, Mi, Vo), zn = Qe + fn | 0, zn = (Qn = Fs + Qn | 0) >>> 0 < Fs >>> 0 ? zn + 1 | 0 : zn, fn = (Fs = Zr(Ds, gr, Wi, io)) + Qn | 0, Qn = Qe + zn | 0, Qn = fn >>> 0 < Fs >>> 0 ? Qn + 1 | 0 : Qn, zn = (Fs = Zr(vn, as, Eo, ci)) + fn | 0, fn = Qe + Qn | 0, fn = zn >>> 0 < Fs >>> 0 ? fn + 1 | 0 : fn, Qn = zn, zn = Zr(Vs, Pr, qo, Fs = qo >> 31), fn = Qe + fn | 0, fn = (Qn = Qn + zn | 0) >>> 0 < zn >>> 0 ? fn + 1 | 0 : fn, zn = Zr(es, Jr, Ni, cs), fn = Qe + fn | 0, fn = (Qn = zn + Qn | 0) >>> 0 < zn >>> 0 ? fn + 1 | 0 : fn, ra = Zr(Rs, jr, Ns, Nr), zn = Qe + fn | 0, fn = E >> 26, E = (la = (67108863 & E) << 6 | la >>> 26) + (Qn = ra + Qn | 0) | 0, Qn = fn + (Qn >>> 0 < ra >>> 0 ? zn + 1 | 0 : zn) | 0, fn = (zn = E) >>> 0 < la >>> 0 ? Qn + 1 | 0 : Qn, la = Qn = zn + 16777216 | 0, E = fn = Qn >>> 0 < 16777216 ? fn + 1 | 0 : fn, o[k + 28 >> 2] = zn - (-33554432 & Qn), fn = Zr(Ds, gr, M, Br), Qn = Qe, ra = Zr(Hs, Ne, Mi, Vo), zn = Qe + Qn | 0, zn = (fn = ra + fn | 0) >>> 0 < ra >>> 0 ? zn + 1 | 0 : zn, ra = Zr(ve, ti, vn, as), Qn = Qe + zn | 0, Qn = (fn = ra + fn | 0) >>> 0 < ra >>> 0 ? Qn + 1 | 0 : Qn, zn = (ra = Zr(Vs, Pr, Mr, Tr)) + fn | 0, fn = Qe + Qn | 0, fn = zn >>> 0 < ra >>> 0 ? fn + 1 | 0 : fn, Qn = zn, zn = Zr(ua, Fi, Ni, cs), fn = Qe + fn | 0, fn = (Qn = Qn + zn | 0) >>> 0 < zn >>> 0 ? fn + 1 | 0 : fn, zn = Zr(Ns, Nr, bo, ai), fn = Qe + fn | 0, fn = (Qn = zn + Qn | 0) >>> 0 < zn >>> 0 ? fn + 1 | 0 : fn, Qn = (Es = Zr(Es, wo, Yi, ms)) + Qn | 0, zn = Qe + fn | 0, fn = (Qs = Zr(ye, pr, Qs, Tn)) + Qn | 0, Qn = Qe + (Qn >>> 0 < Es >>> 0 ? zn + 1 | 0 : zn) | 0, zn = (es = Zr(es, Jr, li, Qo)) + fn | 0, fn = Qe + (fn >>> 0 < Qs >>> 0 ? Qn + 1 | 0 : Qn) | 0, fn = zn >>> 0 < es >>> 0 ? fn + 1 | 0 : fn, Qn = zn, zn = Zr(Rs, jr, Ys, cr), fn = Qe + fn | 0, es = Qn = Qn + zn | 0, fn = (fn = Qn >>> 0 < zn >>> 0 ? fn + 1 | 0 : fn) + (Qn = T >> 26) | 0, es = T = es + (zn = (67108863 & T) << 6 | xa >>> 26) | 0, fn = T >>> 0 < zn >>> 0 ? fn + 1 | 0 : fn, Qs = Qn = T + 16777216 | 0, T = zn = Qn >>> 0 < 16777216 ? fn + 1 | 0 : fn, o[k + 12 >> 2] = es - (-33554432 & Qn), fn = Zr(M, Br, fo, ro), zn = Qe, Qn = (es = Zr(Hs, Ne, Ns, Nr)) + fn | 0, fn = Qe + zn | 0, fn = Qn >>> 0 < es >>> 0 ? fn + 1 | 0 : fn, zn = Zr(ye, pr, ve, ti), fn = Qe + fn | 0, fn = (Qn = zn + Qn | 0) >>> 0 < zn >>> 0 ? fn + 1 | 0 : fn, es = Zr(Mr, Tr, ca, go), zn = Qe + fn | 0, zn = (Qn = es + Qn | 0) >>> 0 < es >>> 0 ? zn + 1 | 0 : zn, fn = (es = Zr(Ys, cr, fi, $n)) + Qn | 0, Qn = Qe + zn | 0, Qn = fn >>> 0 < es >>> 0 ? Qn + 1 | 0 : Qn, zn = (es = Zr(Xi, qn, Wi, io)) + fn | 0, fn = Qe + Qn | 0, fn = zn >>> 0 < es >>> 0 ? fn + 1 | 0 : fn, Qn = zn, zn = Zr(Ds, gr, Eo, ci), fn = Qe + fn | 0, fn = (Qn = Qn + zn | 0) >>> 0 < zn >>> 0 ? fn + 1 | 0 : fn, zn = Zr(qo, Fs, Zn, So), fn = Qe + fn | 0, fn = (Qn = zn + Qn | 0) >>> 0 < zn >>> 0 ? fn + 1 | 0 : fn, Qn = (ca = Zr(Vs, Pr, es = Ba, Es = es >> 31)) + Qn | 0, zn = Qe + fn | 0, fn = (Rs = Zr(Rs, jr, to, Ln)) + Qn | 0, Qn = Qe + (Qn >>> 0 < ca >>> 0 ? zn + 1 | 0 : zn) | 0, Qn = fn >>> 0 < Rs >>> 0 ? Qn + 1 | 0 : Qn, Ba = fn, fn = (fn = E >> 25) + Qn | 0, fn = (E = Ba + (zn = (33554431 & E) << 7 | la >>> 25) | 0) >>> 0 < zn >>> 0 ? fn + 1 | 0 : fn, Rs = Qn = (zn = E) + 33554432 | 0, E = fn = Qn >>> 0 < 33554432 ? fn + 1 | 0 : fn, o[k + 32 >> 2] = zn - (-67108864 & Qn), Qn = T >> 25, T = (Qs = (33554431 & T) << 7 | Qs >>> 25) + (ws - (fn = -67108864 & Is) | 0) | 0, fn = Qn + (ys - ((fn >>> 0 > ws >>> 0) + ks | 0) | 0) | 0, fn = T >>> 0 < Qs >>> 0 ? fn + 1 | 0 : fn, fn = ((67108863 & (fn = (T = (Qn = T) + 33554432 | 0) >>> 0 < 33554432 ? fn + 1 | 0 : fn)) << 6 | T >>> 26) + (zn = _a - (-33554432 & Ps) | 0) | 0, o[k + 20 >> 2] = fn, o[k + 16 >> 2] = Qn - (-67108864 & T), T = Zr(Ns, Nr, M, Br), fn = Qe, Qn = Zr(Hs, Ne, Ni, cs), fn = Qe + fn | 0, fn = (T = Qn + T | 0) >>> 0 < Qn >>> 0 ? fn + 1 | 0 : fn, zn = Zr(ve, ti, Yi, ms), Qn = Qe + fn | 0, Qn = (T = zn + T | 0) >>> 0 < zn >>> 0 ? Qn + 1 | 0 : Qn, fn = Zr(ye, pr, Mr, Tr), zn = Qe + Qn | 0, zn = (T = fn + T | 0) >>> 0 < fn >>> 0 ? zn + 1 | 0 : zn, Qn = Zr(fi, $n, li, Qo), fn = Qe + zn | 0, fn = (T = Qn + T | 0) >>> 0 < Qn >>> 0 ? fn + 1 | 0 : fn, Qn = Zr(Ys, cr, Wi, io), fn = Qe + fn | 0, fn = (T = Qn + T | 0) >>> 0 < Qn >>> 0 ? fn + 1 | 0 : fn, Qn = Zr(Mi, Vo, Eo, ci), fn = Qe + fn | 0, fn = (T = Qn + T | 0) >>> 0 < Qn >>> 0 ? fn + 1 | 0 : fn, zn = Zr(Ds, gr, qo, Fs), Qn = Qe + fn | 0, Qn = (T = zn + T | 0) >>> 0 < zn >>> 0 ? Qn + 1 | 0 : Qn, fn = Zr(es, Es, vn, as), zn = Qe + Qn | 0, zn = (T = fn + T | 0) >>> 0 < fn >>> 0 ? zn + 1 | 0 : zn, Qn = Zr(Vs, Pr, is, is >> 31), fn = Qe + zn | 0, fn = (fn = (T = Qn + T | 0) >>> 0 < Qn >>> 0 ? fn + 1 | 0 : fn) + (Qn = E >> 26) | 0, fn = (E = (zn = T) + (T = (67108863 & E) << 6 | Rs >>> 26) | 0) >>> 0 < T >>> 0 ? fn + 1 | 0 : fn, fn = (E = (T = E) + 16777216 | 0) >>> 0 < 16777216 ? fn + 1 | 0 : fn, o[k + 36 >> 2] = T - (-33554432 & E), zn = Cs - (-33554432 & Ka) | 0, Qn = us - (T = -67108864 & Ea) | 0, Hs = ma - ((T >>> 0 > us >>> 0) + Po | 0) | 0, E = (T = Zr((33554431 & (T = fn)) << 7 | E >>> 25, fn >>= 25, 19, 0)) + Qn | 0, Qn = Qe + Hs | 0, fn = E >>> 0 < T >>> 0 ? Qn + 1 | 0 : Qn, fn = ((67108863 & (fn = (E = (T = E) + 33554432 | 0) >>> 0 < 33554432 ? fn + 1 | 0 : fn)) << 6 | E >>> 26) + zn | 0, o[k + 4 >> 2] = fn, o[k >> 2] = T - (-67108864 & E);
                    }
                    function Sn(k, E) {
                      var T, M, ye, Ne, pr, ve, cr, gr, Pr, Nr, Br, Mr, jr, ti, fi, Jr, li = 0, Tr = 0, Mi = 0;
                      dr = T = dr - 544 | 0, M = m[k + 60 | 0] | m[k + 61 | 0] << 8 | m[k + 62 | 0] << 16 | m[k + 63 | 0] << 24, ye = m[k + 56 | 0] | m[k + 57 | 0] << 8 | m[k + 58 | 0] << 16 | m[k + 59 | 0] << 24, Ne = m[k + 52 | 0] | m[k + 53 | 0] << 8 | m[k + 54 | 0] << 16 | m[k + 55 | 0] << 24, pr = m[k + 48 | 0] | m[k + 49 | 0] << 8 | m[k + 50 | 0] << 16 | m[k + 51 | 0] << 24, ve = m[k + 32 | 0] | m[k + 33 | 0] << 8 | m[k + 34 | 0] << 16 | m[k + 35 | 0] << 24, cr = m[k + 36 | 0] | m[k + 37 | 0] << 8 | m[k + 38 | 0] << 16 | m[k + 39 | 0] << 24, gr = m[k + 40 | 0] | m[k + 41 | 0] << 8 | m[k + 42 | 0] << 16 | m[k + 43 | 0] << 24, Pr = m[k + 44 | 0] | m[k + 45 | 0] << 8 | m[k + 46 | 0] << 16 | m[k + 47 | 0] << 24, li = m[k + 28 | 0] | m[k + 29 | 0] << 8 | m[k + 30 | 0] << 16 | m[k + 31 | 0] << 24, Nr = m[k + 24 | 0] | m[k + 25 | 0] << 8 | m[k + 26 | 0] << 16 | m[k + 27 | 0] << 24, Br = m[k + 20 | 0] | m[k + 21 | 0] << 8 | m[k + 22 | 0] << 16 | m[k + 23 | 0] << 24, Mr = m[k + 16 | 0] | m[k + 17 | 0] << 8 | m[k + 18 | 0] << 16 | m[k + 19 | 0] << 24, jr = m[k + 4 | 0] | m[k + 5 | 0] << 8 | m[k + 6 | 0] << 16 | m[k + 7 | 0] << 24, ti = m[k + 8 | 0] | m[k + 9 | 0] << 8 | m[k + 10 | 0] << 16 | m[k + 11 | 0] << 24, fi = m[k + 12 | 0] | m[k + 13 | 0] << 8 | m[k + 14 | 0] << 16 | m[k + 15 | 0] << 24, Jr = m[0 | k] | m[k + 1 | 0] << 8 | m[k + 2 | 0] << 16 | m[k + 3 | 0] << 24, k = o[E + 124 >> 2], o[T + 536 >> 2] = o[E + 120 >> 2], o[T + 540 >> 2] = k, k = o[E + 116 >> 2], o[T + 528 >> 2] = o[E + 112 >> 2], o[T + 532 >> 2] = k, k = o[E + 108 >> 2], o[T + 504 >> 2] = o[E + 104 >> 2], o[T + 508 >> 2] = k, k = o[E + 100 >> 2], o[T + 496 >> 2] = o[E + 96 >> 2], o[T + 500 >> 2] = k, k = o[E + 124 >> 2], o[T + 488 >> 2] = o[E + 120 >> 2], o[T + 492 >> 2] = k, k = o[E + 116 >> 2], o[T + 480 >> 2] = o[E + 112 >> 2], o[T + 484 >> 2] = k, gs(Mi = T + 512 | 0, T + 496 | 0, T + 480 | 0), k = o[T + 524 >> 2], o[E + 120 >> 2] = o[T + 520 >> 2], o[E + 124 >> 2] = k, k = o[T + 516 >> 2], o[E + 112 >> 2] = o[T + 512 >> 2], o[E + 116 >> 2] = k, k = o[E + 92 >> 2], o[T + 472 >> 2] = o[E + 88 >> 2], o[T + 476 >> 2] = k, k = o[E + 84 >> 2], o[T + 464 >> 2] = o[E + 80 >> 2], o[T + 468 >> 2] = k, k = o[E + 108 >> 2], o[T + 456 >> 2] = o[E + 104 >> 2], o[T + 460 >> 2] = k, k = o[E + 100 >> 2], o[T + 448 >> 2] = o[E + 96 >> 2], o[T + 452 >> 2] = k, gs(Mi, T + 464 | 0, T + 448 | 0), k = o[T + 524 >> 2], o[E + 104 >> 2] = o[T + 520 >> 2], o[E + 108 >> 2] = k, k = o[T + 516 >> 2], o[E + 96 >> 2] = o[T + 512 >> 2], o[E + 100 >> 2] = k, k = o[E + 76 >> 2], o[T + 440 >> 2] = o[E + 72 >> 2], o[T + 444 >> 2] = k, Tr = o[4 + (k = E - -64 | 0) >> 2], o[T + 432 >> 2] = o[k >> 2], o[T + 436 >> 2] = Tr, Tr = o[E + 92 >> 2], o[T + 424 >> 2] = o[E + 88 >> 2], o[T + 428 >> 2] = Tr, Tr = o[E + 84 >> 2], o[T + 416 >> 2] = o[E + 80 >> 2], o[T + 420 >> 2] = Tr, gs(Mi, T + 432 | 0, T + 416 | 0), Tr = o[T + 524 >> 2], o[E + 88 >> 2] = o[T + 520 >> 2], o[E + 92 >> 2] = Tr, Tr = o[T + 516 >> 2], o[E + 80 >> 2] = o[T + 512 >> 2], o[E + 84 >> 2] = Tr, Tr = o[E + 60 >> 2], o[T + 408 >> 2] = o[E + 56 >> 2], o[T + 412 >> 2] = Tr, Tr = o[E + 52 >> 2], o[T + 400 >> 2] = o[E + 48 >> 2], o[T + 404 >> 2] = Tr, Tr = o[E + 76 >> 2], o[T + 392 >> 2] = o[E + 72 >> 2], o[T + 396 >> 2] = Tr, Tr = o[k + 4 >> 2], o[T + 384 >> 2] = o[k >> 2], o[T + 388 >> 2] = Tr, gs(Mi, T + 400 | 0, T + 384 | 0), Tr = o[T + 524 >> 2], o[E + 72 >> 2] = o[T + 520 >> 2], o[E + 76 >> 2] = Tr, Tr = o[T + 516 >> 2], o[k >> 2] = o[T + 512 >> 2], o[k + 4 >> 2] = Tr, Tr = o[E + 44 >> 2], o[T + 376 >> 2] = o[E + 40 >> 2], o[T + 380 >> 2] = Tr, Tr = o[E + 36 >> 2], o[T + 368 >> 2] = o[E + 32 >> 2], o[T + 372 >> 2] = Tr, Tr = o[E + 60 >> 2], o[T + 360 >> 2] = o[E + 56 >> 2], o[T + 364 >> 2] = Tr, Tr = o[E + 52 >> 2], o[T + 352 >> 2] = o[E + 48 >> 2], o[T + 356 >> 2] = Tr, gs(Mi, T + 368 | 0, T + 352 | 0), Tr = o[T + 524 >> 2], o[E + 56 >> 2] = o[T + 520 >> 2], o[E + 60 >> 2] = Tr, Tr = o[T + 516 >> 2], o[E + 48 >> 2] = o[T + 512 >> 2], o[E + 52 >> 2] = Tr, Tr = o[E + 28 >> 2], o[T + 344 >> 2] = o[E + 24 >> 2], o[T + 348 >> 2] = Tr, Tr = o[E + 20 >> 2], o[T + 336 >> 2] = o[E + 16 >> 2], o[T + 340 >> 2] = Tr, Tr = o[E + 44 >> 2], o[T + 328 >> 2] = o[E + 40 >> 2], o[T + 332 >> 2] = Tr, Tr = o[E + 36 >> 2], o[T + 320 >> 2] = o[E + 32 >> 2], o[T + 324 >> 2] = Tr, gs(Mi, T + 336 | 0, T + 320 | 0), Tr = o[T + 524 >> 2], o[E + 40 >> 2] = o[T + 520 >> 2], o[E + 44 >> 2] = Tr, Tr = o[T + 516 >> 2], o[E + 32 >> 2] = o[T + 512 >> 2], o[E + 36 >> 2] = Tr, Tr = o[E + 12 >> 2], o[T + 312 >> 2] = o[E + 8 >> 2], o[T + 316 >> 2] = Tr, Tr = o[E + 4 >> 2], o[T + 304 >> 2] = o[E >> 2], o[T + 308 >> 2] = Tr, Tr = o[E + 28 >> 2], o[T + 296 >> 2] = o[E + 24 >> 2], o[T + 300 >> 2] = Tr, Tr = o[E + 20 >> 2], o[T + 288 >> 2] = o[E + 16 >> 2], o[T + 292 >> 2] = Tr, gs(Mi, T + 304 | 0, T + 288 | 0), Tr = o[T + 524 >> 2], o[E + 24 >> 2] = o[T + 520 >> 2], o[E + 28 >> 2] = Tr, Tr = o[T + 516 >> 2], o[E + 16 >> 2] = o[T + 512 >> 2], o[E + 20 >> 2] = Tr, Tr = o[T + 540 >> 2], o[T + 280 >> 2] = o[T + 536 >> 2], o[T + 284 >> 2] = Tr, Tr = o[T + 532 >> 2], o[T + 272 >> 2] = o[T + 528 >> 2], o[T + 276 >> 2] = Tr, Tr = o[E + 12 >> 2], o[T + 264 >> 2] = o[E + 8 >> 2], o[T + 268 >> 2] = Tr, Tr = o[E + 4 >> 2], o[T + 256 >> 2] = o[E >> 2], o[T + 260 >> 2] = Tr, gs(Mi, T + 272 | 0, T + 256 | 0), Tr = o[T + 524 >> 2], o[E + 8 >> 2] = o[T + 520 >> 2], o[E + 12 >> 2] = Tr, Tr = o[T + 516 >> 2], o[E >> 2] = o[T + 512 >> 2], o[E + 4 >> 2] = Tr, o[E + 12 >> 2] = (m[E + 12 | 0] | m[E + 13 | 0] << 8 | m[E + 14 | 0] << 16 | m[E + 15 | 0] << 24) ^ fi, o[E + 8 >> 2] = (m[E + 8 | 0] | m[E + 9 | 0] << 8 | m[E + 10 | 0] << 16 | m[E + 11 | 0] << 24) ^ ti, o[E + 4 >> 2] = (m[E + 4 | 0] | m[E + 5 | 0] << 8 | m[E + 6 | 0] << 16 | m[E + 7 | 0] << 24) ^ jr, o[E >> 2] = (m[0 | E] | m[E + 1 | 0] << 8 | m[E + 2 | 0] << 16 | m[E + 3 | 0] << 24) ^ Jr, o[k >> 2] = (m[0 | k] | m[k + 1 | 0] << 8 | m[k + 2 | 0] << 16 | m[k + 3 | 0] << 24) ^ Mr, o[E + 68 >> 2] = (m[E + 68 | 0] | m[E + 69 | 0] << 8 | m[E + 70 | 0] << 16 | m[E + 71 | 0] << 24) ^ Br, o[E + 72 >> 2] = (m[E + 72 | 0] | m[E + 73 | 0] << 8 | m[E + 74 | 0] << 16 | m[E + 75 | 0] << 24) ^ Nr, o[E + 76 >> 2] = (m[E + 76 | 0] | m[E + 77 | 0] << 8 | m[E + 78 | 0] << 16 | m[E + 79 | 0] << 24) ^ li, li = o[E + 124 >> 2], o[T + 536 >> 2] = o[E + 120 >> 2], o[T + 540 >> 2] = li, li = o[E + 116 >> 2], o[T + 528 >> 2] = o[E + 112 >> 2], o[T + 532 >> 2] = li, li = o[E + 108 >> 2], o[T + 248 >> 2] = o[E + 104 >> 2], o[T + 252 >> 2] = li, li = o[E + 100 >> 2], o[T + 240 >> 2] = o[E + 96 >> 2], o[T + 244 >> 2] = li, li = o[E + 124 >> 2], o[T + 232 >> 2] = o[E + 120 >> 2], o[T + 236 >> 2] = li, li = o[E + 116 >> 2], o[T + 224 >> 2] = o[E + 112 >> 2], o[T + 228 >> 2] = li, gs(Mi, T + 240 | 0, T + 224 | 0), li = o[T + 524 >> 2], o[E + 120 >> 2] = o[T + 520 >> 2], o[E + 124 >> 2] = li, li = o[T + 516 >> 2], o[E + 112 >> 2] = o[T + 512 >> 2], o[E + 116 >> 2] = li, li = o[E + 92 >> 2], o[T + 216 >> 2] = o[E + 88 >> 2], o[T + 220 >> 2] = li, li = o[E + 84 >> 2], o[T + 208 >> 2] = o[E + 80 >> 2], o[T + 212 >> 2] = li, li = o[E + 108 >> 2], o[T + 200 >> 2] = o[E + 104 >> 2], o[T + 204 >> 2] = li, li = o[E + 100 >> 2], o[T + 192 >> 2] = o[E + 96 >> 2], o[T + 196 >> 2] = li, gs(Mi, T + 208 | 0, T + 192 | 0), li = o[T + 524 >> 2], o[E + 104 >> 2] = o[T + 520 >> 2], o[E + 108 >> 2] = li, li = o[T + 516 >> 2], o[E + 96 >> 2] = o[T + 512 >> 2], o[E + 100 >> 2] = li, li = o[E + 76 >> 2], o[T + 184 >> 2] = o[E + 72 >> 2], o[T + 188 >> 2] = li, li = o[k + 4 >> 2], o[T + 176 >> 2] = o[k >> 2], o[T + 180 >> 2] = li, li = o[E + 92 >> 2], o[T + 168 >> 2] = o[E + 88 >> 2], o[T + 172 >> 2] = li, li = o[E + 84 >> 2], o[T + 160 >> 2] = o[E + 80 >> 2], o[T + 164 >> 2] = li, gs(Mi, T + 176 | 0, T + 160 | 0), li = o[T + 524 >> 2], o[E + 88 >> 2] = o[T + 520 >> 2], o[E + 92 >> 2] = li, li = o[T + 516 >> 2], o[E + 80 >> 2] = o[T + 512 >> 2], o[E + 84 >> 2] = li, li = o[E + 60 >> 2], o[T + 152 >> 2] = o[E + 56 >> 2], o[T + 156 >> 2] = li, li = o[E + 52 >> 2], o[T + 144 >> 2] = o[E + 48 >> 2], o[T + 148 >> 2] = li, li = o[E + 76 >> 2], o[T + 136 >> 2] = o[E + 72 >> 2], o[T + 140 >> 2] = li, li = o[k + 4 >> 2], o[T + 128 >> 2] = o[k >> 2], o[T + 132 >> 2] = li, gs(Mi, T + 144 | 0, T + 128 | 0), li = o[T + 524 >> 2], o[E + 72 >> 2] = o[T + 520 >> 2], o[E + 76 >> 2] = li, li = o[T + 516 >> 2], o[k >> 2] = o[T + 512 >> 2], o[k + 4 >> 2] = li, li = o[E + 44 >> 2], o[T + 120 >> 2] = o[E + 40 >> 2], o[T + 124 >> 2] = li, li = o[E + 36 >> 2], o[T + 112 >> 2] = o[E + 32 >> 2], o[T + 116 >> 2] = li, li = o[E + 60 >> 2], o[T + 104 >> 2] = o[E + 56 >> 2], o[T + 108 >> 2] = li, li = o[E + 52 >> 2], o[T + 96 >> 2] = o[E + 48 >> 2], o[T + 100 >> 2] = li, gs(Mi, T + 112 | 0, T + 96 | 0), li = o[T + 524 >> 2], o[E + 56 >> 2] = o[T + 520 >> 2], o[E + 60 >> 2] = li, li = o[T + 516 >> 2], o[E + 48 >> 2] = o[T + 512 >> 2], o[E + 52 >> 2] = li, li = o[E + 28 >> 2], o[T + 88 >> 2] = o[E + 24 >> 2], o[T + 92 >> 2] = li, li = o[E + 20 >> 2], o[T + 80 >> 2] = o[E + 16 >> 2], o[T + 84 >> 2] = li, li = o[E + 44 >> 2], o[T + 72 >> 2] = o[E + 40 >> 2], o[T + 76 >> 2] = li, li = o[E + 36 >> 2], o[T + 64 >> 2] = o[E + 32 >> 2], o[T + 68 >> 2] = li, gs(Mi, T + 80 | 0, T - -64 | 0), li = o[T + 524 >> 2], o[E + 40 >> 2] = o[T + 520 >> 2], o[E + 44 >> 2] = li, li = o[T + 516 >> 2], o[E + 32 >> 2] = o[T + 512 >> 2], o[E + 36 >> 2] = li, li = o[E + 12 >> 2], o[T + 56 >> 2] = o[E + 8 >> 2], o[T + 60 >> 2] = li, li = o[E + 4 >> 2], o[T + 48 >> 2] = o[E >> 2], o[T + 52 >> 2] = li, li = o[E + 28 >> 2], o[T + 40 >> 2] = o[E + 24 >> 2], o[T + 44 >> 2] = li, li = o[E + 20 >> 2], o[T + 32 >> 2] = o[E + 16 >> 2], o[T + 36 >> 2] = li, gs(Mi, T + 48 | 0, T + 32 | 0), li = o[T + 524 >> 2], o[E + 24 >> 2] = o[T + 520 >> 2], o[E + 28 >> 2] = li, li = o[T + 516 >> 2], o[E + 16 >> 2] = o[T + 512 >> 2], o[E + 20 >> 2] = li, li = o[T + 540 >> 2], o[T + 24 >> 2] = o[T + 536 >> 2], o[T + 28 >> 2] = li, li = o[T + 532 >> 2], o[T + 16 >> 2] = o[T + 528 >> 2], o[T + 20 >> 2] = li, li = o[E + 12 >> 2], o[T + 8 >> 2] = o[E + 8 >> 2], o[T + 12 >> 2] = li, li = o[E + 4 >> 2], o[T >> 2] = o[E >> 2], o[T + 4 >> 2] = li, gs(Mi, T + 16 | 0, T), Mi = o[T + 524 >> 2], o[E + 8 >> 2] = o[T + 520 >> 2], o[E + 12 >> 2] = Mi, Mi = o[T + 516 >> 2], o[E >> 2] = o[T + 512 >> 2], o[E + 4 >> 2] = Mi, o[E + 12 >> 2] = (m[E + 12 | 0] | m[E + 13 | 0] << 8 | m[E + 14 | 0] << 16 | m[E + 15 | 0] << 24) ^ Pr, o[E + 8 >> 2] = (m[E + 8 | 0] | m[E + 9 | 0] << 8 | m[E + 10 | 0] << 16 | m[E + 11 | 0] << 24) ^ gr, o[E + 4 >> 2] = (m[E + 4 | 0] | m[E + 5 | 0] << 8 | m[E + 6 | 0] << 16 | m[E + 7 | 0] << 24) ^ cr, o[E >> 2] = (m[0 | E] | m[E + 1 | 0] << 8 | m[E + 2 | 0] << 16 | m[E + 3 | 0] << 24) ^ ve, o[k >> 2] = (m[0 | k] | m[k + 1 | 0] << 8 | m[k + 2 | 0] << 16 | m[k + 3 | 0] << 24) ^ pr, o[E + 68 >> 2] = (m[E + 68 | 0] | m[E + 69 | 0] << 8 | m[E + 70 | 0] << 16 | m[E + 71 | 0] << 24) ^ Ne, o[E + 72 >> 2] = (m[E + 72 | 0] | m[E + 73 | 0] << 8 | m[E + 74 | 0] << 16 | m[E + 75 | 0] << 24) ^ ye, o[E + 76 >> 2] = (m[E + 76 | 0] | m[E + 77 | 0] << 8 | m[E + 78 | 0] << 16 | m[E + 79 | 0] << 24) ^ M, dr = T + 544 | 0;
                    }
                    function Kn(k, E, T, M, ye) {
                      var Ne, pr = 0, ve = 0, cr = 0, gr = 0, Pr = 0, Nr = 0, Br = 0, Mr = 0, jr = 0, ti = 0, fi = 0, Jr = 0, li = 0, Tr = 0, Mi = 0, Wi = 0, vn = 0, Tn = 0, Ni = 0, Yi = 0;
                      for (dr = Ne = dr - 288 | 0, jr = (m[ye + 44 | 0] | m[ye + 45 | 0] << 8 | m[ye + 46 | 0] << 16 | m[ye + 47 | 0] << 24) ^ M >>> 29, ti = (m[ye + 40 | 0] | m[ye + 41 | 0] << 8 | m[ye + 42 | 0] << 16 | m[ye + 43 | 0] << 24) ^ M << 3, fi = (m[ye + 36 | 0] | m[ye + 37 | 0] << 8 | m[ye + 38 | 0] << 16 | m[ye + 39 | 0] << 24) ^ T >>> 29, M = (m[0 | (cr = ye + 32 | 0)] | m[cr + 1 | 0] << 8 | m[cr + 2 | 0] << 16 | m[cr + 3 | 0] << 24) ^ T << 3, Br = ye + 16 | 0, Pr = ye + 48 | 0, ve = ye - -64 | 0, Nr = ye + 80 | 0, pr = ye + 96 | 0, gr = ye + 112 | 0; T = o[gr + 12 >> 2], o[Ne + 280 >> 2] = o[gr + 8 >> 2], o[Ne + 284 >> 2] = T, T = o[gr + 4 >> 2], o[Ne + 272 >> 2] = o[gr >> 2], o[Ne + 276 >> 2] = T, T = o[pr + 12 >> 2], o[Ne + 248 >> 2] = o[pr + 8 >> 2], o[Ne + 252 >> 2] = T, T = o[pr + 4 >> 2], o[Ne + 240 >> 2] = o[pr >> 2], o[Ne + 244 >> 2] = T, T = o[gr + 12 >> 2], o[Ne + 232 >> 2] = o[gr + 8 >> 2], o[Ne + 236 >> 2] = T, T = o[gr + 4 >> 2], o[Ne + 224 >> 2] = o[gr >> 2], o[Ne + 228 >> 2] = T, gs(Mr = Ne + 256 | 0, Ne + 240 | 0, Ne + 224 | 0), T = o[Ne + 268 >> 2], o[gr + 8 >> 2] = o[Ne + 264 >> 2], o[gr + 12 >> 2] = T, T = o[Ne + 260 >> 2], o[gr >> 2] = o[Ne + 256 >> 2], o[gr + 4 >> 2] = T, T = o[Nr + 12 >> 2], o[Ne + 216 >> 2] = o[Nr + 8 >> 2], o[Ne + 220 >> 2] = T, T = o[Nr + 4 >> 2], o[Ne + 208 >> 2] = o[Nr >> 2], o[Ne + 212 >> 2] = T, T = o[pr + 12 >> 2], o[Ne + 200 >> 2] = o[pr + 8 >> 2], o[Ne + 204 >> 2] = T, T = o[pr + 4 >> 2], o[Ne + 192 >> 2] = o[pr >> 2], o[Ne + 196 >> 2] = T, gs(Mr, Ne + 208 | 0, Ne + 192 | 0), T = o[Ne + 268 >> 2], o[pr + 8 >> 2] = o[Ne + 264 >> 2], o[pr + 12 >> 2] = T, T = o[Ne + 260 >> 2], o[pr >> 2] = o[Ne + 256 >> 2], o[pr + 4 >> 2] = T, T = o[ve + 12 >> 2], o[Ne + 184 >> 2] = o[ve + 8 >> 2], o[Ne + 188 >> 2] = T, T = o[ve + 4 >> 2], o[Ne + 176 >> 2] = o[ve >> 2], o[Ne + 180 >> 2] = T, T = o[Nr + 12 >> 2], o[Ne + 168 >> 2] = o[Nr + 8 >> 2], o[Ne + 172 >> 2] = T, T = o[Nr + 4 >> 2], o[Ne + 160 >> 2] = o[Nr >> 2], o[Ne + 164 >> 2] = T, gs(Mr, Ne + 176 | 0, Ne + 160 | 0), T = o[Ne + 268 >> 2], o[Nr + 8 >> 2] = o[Ne + 264 >> 2], o[Nr + 12 >> 2] = T, T = o[Ne + 260 >> 2], o[Nr >> 2] = o[Ne + 256 >> 2], o[Nr + 4 >> 2] = T, T = o[Pr + 12 >> 2], o[Ne + 152 >> 2] = o[Pr + 8 >> 2], o[Ne + 156 >> 2] = T, T = o[Pr + 4 >> 2], o[Ne + 144 >> 2] = o[Pr >> 2], o[Ne + 148 >> 2] = T, T = o[ve + 12 >> 2], o[Ne + 136 >> 2] = o[ve + 8 >> 2], o[Ne + 140 >> 2] = T, T = o[ve + 4 >> 2], o[Ne + 128 >> 2] = o[ve >> 2], o[Ne + 132 >> 2] = T, gs(Mr, Ne + 144 | 0, Ne + 128 | 0), T = o[Ne + 268 >> 2], o[ve + 8 >> 2] = o[Ne + 264 >> 2], o[ve + 12 >> 2] = T, T = o[Ne + 260 >> 2], o[ve >> 2] = o[Ne + 256 >> 2], o[ve + 4 >> 2] = T, T = o[cr + 12 >> 2], o[Ne + 120 >> 2] = o[cr + 8 >> 2], o[Ne + 124 >> 2] = T, T = o[cr + 4 >> 2], o[Ne + 112 >> 2] = o[cr >> 2], o[Ne + 116 >> 2] = T, T = o[Pr + 12 >> 2], o[Ne + 104 >> 2] = o[Pr + 8 >> 2], o[Ne + 108 >> 2] = T, T = o[Pr + 4 >> 2], o[Ne + 96 >> 2] = o[Pr >> 2], o[Ne + 100 >> 2] = T, gs(Mr, Ne + 112 | 0, Ne + 96 | 0), T = o[Ne + 268 >> 2], o[Pr + 8 >> 2] = o[Ne + 264 >> 2], o[Pr + 12 >> 2] = T, T = o[Ne + 260 >> 2], o[Pr >> 2] = o[Ne + 256 >> 2], o[Pr + 4 >> 2] = T, T = o[Br + 12 >> 2], o[Ne + 88 >> 2] = o[Br + 8 >> 2], o[Ne + 92 >> 2] = T, T = o[Br + 4 >> 2], o[Ne + 80 >> 2] = o[Br >> 2], o[Ne + 84 >> 2] = T, T = o[cr + 12 >> 2], o[Ne + 72 >> 2] = o[cr + 8 >> 2], o[Ne + 76 >> 2] = T, T = o[cr + 4 >> 2], o[Ne + 64 >> 2] = o[cr >> 2], o[Ne + 68 >> 2] = T, gs(Mr, Ne + 80 | 0, Ne - -64 | 0), T = o[Ne + 268 >> 2], o[cr + 8 >> 2] = o[Ne + 264 >> 2], o[cr + 12 >> 2] = T, T = o[Ne + 260 >> 2], o[cr >> 2] = o[Ne + 256 >> 2], o[cr + 4 >> 2] = T, T = o[ye + 12 >> 2], o[Ne + 56 >> 2] = o[ye + 8 >> 2], o[Ne + 60 >> 2] = T, T = o[ye + 4 >> 2], o[Ne + 48 >> 2] = o[ye >> 2], o[Ne + 52 >> 2] = T, T = o[Br + 12 >> 2], o[Ne + 40 >> 2] = o[Br + 8 >> 2], o[Ne + 44 >> 2] = T, T = o[Br + 4 >> 2], o[Ne + 32 >> 2] = o[Br >> 2], o[Ne + 36 >> 2] = T, gs(Mr, Ne + 48 | 0, Ne + 32 | 0), T = o[Ne + 268 >> 2], o[Br + 8 >> 2] = o[Ne + 264 >> 2], o[Br + 12 >> 2] = T, T = o[Ne + 260 >> 2], o[Br >> 2] = o[Ne + 256 >> 2], o[Br + 4 >> 2] = T, T = o[Ne + 284 >> 2], o[Ne + 24 >> 2] = o[Ne + 280 >> 2], o[Ne + 28 >> 2] = T, T = o[Ne + 276 >> 2], o[Ne + 16 >> 2] = o[Ne + 272 >> 2], o[Ne + 20 >> 2] = T, T = o[ye + 12 >> 2], o[Ne + 8 >> 2] = o[ye + 8 >> 2], o[Ne + 12 >> 2] = T, T = o[ye + 4 >> 2], o[Ne >> 2] = o[ye >> 2], o[Ne + 4 >> 2] = T, gs(Mr, Ne + 16 | 0, Ne), T = o[Ne + 268 >> 2], o[ye + 8 >> 2] = o[Ne + 264 >> 2], o[ye + 12 >> 2] = T, T = o[Ne + 260 >> 2], o[ye >> 2] = o[Ne + 256 >> 2], o[ye + 4 >> 2] = T, li = jr ^ (m[ye + 12 | 0] | m[ye + 13 | 0] << 8 | m[ye + 14 | 0] << 16 | m[ye + 15 | 0] << 24), o[ye + 12 >> 2] = li, Tr = ti ^ (m[ye + 8 | 0] | m[ye + 9 | 0] << 8 | m[ye + 10 | 0] << 16 | m[ye + 11 | 0] << 24), o[ye + 8 >> 2] = Tr, Mi = fi ^ (m[ye + 4 | 0] | m[ye + 5 | 0] << 8 | m[ye + 6 | 0] << 16 | m[ye + 7 | 0] << 24), o[ye + 4 >> 2] = Mi, Wi = M ^ (m[0 | ye] | m[ye + 1 | 0] << 8 | m[ye + 2 | 0] << 16 | m[ye + 3 | 0] << 24), o[ye >> 2] = Wi, vn = M ^ (m[0 | ve] | m[ve + 1 | 0] << 8 | m[ve + 2 | 0] << 16 | m[ve + 3 | 0] << 24), o[ve >> 2] = vn, Tn = fi ^ (m[ye + 68 | 0] | m[ye + 69 | 0] << 8 | m[ye + 70 | 0] << 16 | m[ye + 71 | 0] << 24), o[ye + 68 >> 2] = Tn, Ni = ti ^ (m[ye + 72 | 0] | m[ye + 73 | 0] << 8 | m[ye + 74 | 0] << 16 | m[ye + 75 | 0] << 24), o[ye + 72 >> 2] = Ni, Yi = jr ^ (m[ye + 76 | 0] | m[ye + 77 | 0] << 8 | m[ye + 78 | 0] << 16 | m[ye + 79 | 0] << 24), o[ye + 76 >> 2] = Yi, (0 | (Jr = Jr + 1 | 0)) != 7; ) ;
                      e: {
                        t: {
                          r: {
                            if (T = E - 16 | 0) {
                              if ((0 | T) == 16) break r;
                              break t;
                            }
                            ve = m[ye + 16 | 0] | m[ye + 17 | 0] << 8 | m[ye + 18 | 0] << 16 | m[ye + 19 | 0] << 24, cr = m[ye + 48 | 0] | m[ye + 49 | 0] << 8 | m[ye + 50 | 0] << 16 | m[ye + 51 | 0] << 24, Br = m[ye + 32 | 0] | m[ye + 33 | 0] << 8 | m[ye + 34 | 0] << 16 | m[ye + 35 | 0] << 24, Pr = m[ye + 96 | 0] | m[ye + 97 | 0] << 8 | m[ye + 98 | 0] << 16 | m[ye + 99 | 0] << 24, Nr = m[ye + 80 | 0] | m[ye + 81 | 0] << 8 | m[ye + 82 | 0] << 16 | m[ye + 83 | 0] << 24, pr = m[ye + 20 | 0] | m[ye + 21 | 0] << 8 | m[ye + 22 | 0] << 16 | m[ye + 23 | 0] << 24, gr = m[ye + 52 | 0] | m[ye + 53 | 0] << 8 | m[ye + 54 | 0] << 16 | m[ye + 55 | 0] << 24, Mr = m[ye + 36 | 0] | m[ye + 37 | 0] << 8 | m[ye + 38 | 0] << 16 | m[ye + 39 | 0] << 24, jr = m[ye + 100 | 0] | m[ye + 101 | 0] << 8 | m[ye + 102 | 0] << 16 | m[ye + 103 | 0] << 24, ti = m[ye + 84 | 0] | m[ye + 85 | 0] << 8 | m[ye + 86 | 0] << 16 | m[ye + 87 | 0] << 24, fi = m[ye + 24 | 0] | m[ye + 25 | 0] << 8 | m[ye + 26 | 0] << 16 | m[ye + 27 | 0] << 24, Jr = m[ye + 56 | 0] | m[ye + 57 | 0] << 8 | m[ye + 58 | 0] << 16 | m[ye + 59 | 0] << 24, M = m[ye + 40 | 0] | m[ye + 41 | 0] << 8 | m[ye + 42 | 0] << 16 | m[ye + 43 | 0] << 24, T = m[ye + 104 | 0] | m[ye + 105 | 0] << 8 | m[ye + 106 | 0] << 16 | m[ye + 107 | 0] << 24, E = m[ye + 88 | 0] | m[ye + 89 | 0] << 8 | m[ye + 90 | 0] << 16 | m[ye + 91 | 0] << 24, ye = li ^ (m[ye + 28 | 0] | m[ye + 29 | 0] << 8 | m[ye + 30 | 0] << 16 | m[ye + 31 | 0] << 24) ^ (m[ye + 60 | 0] | m[ye + 61 | 0] << 8 | m[ye + 62 | 0] << 16 | m[ye + 63 | 0] << 24) ^ (m[ye + 44 | 0] | m[ye + 45 | 0] << 8 | m[ye + 46 | 0] << 16 | m[ye + 47 | 0] << 24) ^ (m[ye + 92 | 0] | m[ye + 93 | 0] << 8 | m[ye + 94 | 0] << 16 | m[ye + 95 | 0] << 24) ^ (m[ye + 108 | 0] | m[ye + 109 | 0] << 8 | m[ye + 110 | 0] << 16 | m[ye + 111 | 0] << 24) ^ Yi, B[k + 12 | 0] = ye, B[k + 13 | 0] = ye >>> 8, B[k + 14 | 0] = ye >>> 16, B[k + 15 | 0] = ye >>> 24, E = fi ^ Jr ^ M ^ E ^ T ^ Ni ^ Tr, B[k + 8 | 0] = E, B[k + 9 | 0] = E >>> 8, B[k + 10 | 0] = E >>> 16, B[k + 11 | 0] = E >>> 24, E = pr ^ gr ^ Mr ^ jr ^ ti ^ Tn ^ Mi, B[k + 4 | 0] = E, B[k + 5 | 0] = E >>> 8, B[k + 6 | 0] = E >>> 16, B[k + 7 | 0] = E >>> 24, E = ve ^ cr ^ Br ^ Pr ^ Nr ^ vn ^ Wi, B[0 | k] = E, B[k + 1 | 0] = E >>> 8, B[k + 2 | 0] = E >>> 16, B[k + 3 | 0] = E >>> 24;
                            break e;
                          }
                          gr = m[ye + 16 | 0] | m[ye + 17 | 0] << 8 | m[ye + 18 | 0] << 16 | m[ye + 19 | 0] << 24, Mr = m[ye + 48 | 0] | m[ye + 49 | 0] << 8 | m[ye + 50 | 0] << 16 | m[ye + 51 | 0] << 24, jr = m[ye + 32 | 0] | m[ye + 33 | 0] << 8 | m[ye + 34 | 0] << 16 | m[ye + 35 | 0] << 24, ti = m[ye + 20 | 0] | m[ye + 21 | 0] << 8 | m[ye + 22 | 0] << 16 | m[ye + 23 | 0] << 24, fi = m[ye + 52 | 0] | m[ye + 53 | 0] << 8 | m[ye + 54 | 0] << 16 | m[ye + 55 | 0] << 24, Jr = m[ye + 36 | 0] | m[ye + 37 | 0] << 8 | m[ye + 38 | 0] << 16 | m[ye + 39 | 0] << 24, M = m[ye + 24 | 0] | m[ye + 25 | 0] << 8 | m[ye + 26 | 0] << 16 | m[ye + 27 | 0] << 24, T = m[ye + 56 | 0] | m[ye + 57 | 0] << 8 | m[ye + 58 | 0] << 16 | m[ye + 59 | 0] << 24, E = m[ye + 40 | 0] | m[ye + 41 | 0] << 8 | m[ye + 42 | 0] << 16 | m[ye + 43 | 0] << 24, pr = li ^ (m[ye + 28 | 0] | m[ye + 29 | 0] << 8 | m[ye + 30 | 0] << 16 | m[ye + 31 | 0] << 24) ^ (m[ye + 60 | 0] | m[ye + 61 | 0] << 8 | m[ye + 62 | 0] << 16 | m[ye + 63 | 0] << 24) ^ (m[ye + 44 | 0] | m[ye + 45 | 0] << 8 | m[ye + 46 | 0] << 16 | m[ye + 47 | 0] << 24), B[k + 12 | 0] = pr, B[k + 13 | 0] = pr >>> 8, B[k + 14 | 0] = pr >>> 16, B[k + 15 | 0] = pr >>> 24, E = M ^ E ^ T ^ Tr, B[k + 8 | 0] = E, B[k + 9 | 0] = E >>> 8, B[k + 10 | 0] = E >>> 16, B[k + 11 | 0] = E >>> 24, E = ti ^ fi ^ Jr ^ Mi, B[k + 4 | 0] = E, B[k + 5 | 0] = E >>> 8, B[k + 6 | 0] = E >>> 16, B[k + 7 | 0] = E >>> 24, E = gr ^ Mr ^ jr ^ Wi, B[0 | k] = E, B[k + 1 | 0] = E >>> 8, B[k + 2 | 0] = E >>> 16, B[k + 3 | 0] = E >>> 24, Pr = m[ye + 80 | 0] | m[ye + 81 | 0] << 8 | m[ye + 82 | 0] << 16 | m[ye + 83 | 0] << 24, Nr = m[0 | (E = ye - -64 | 0)] | m[E + 1 | 0] << 8 | m[E + 2 | 0] << 16 | m[E + 3 | 0] << 24, pr = m[ye + 112 | 0] | m[ye + 113 | 0] << 8 | m[ye + 114 | 0] << 16 | m[ye + 115 | 0] << 24, gr = m[ye + 96 | 0] | m[ye + 97 | 0] << 8 | m[ye + 98 | 0] << 16 | m[ye + 99 | 0] << 24, Mr = m[ye + 84 | 0] | m[ye + 85 | 0] << 8 | m[ye + 86 | 0] << 16 | m[ye + 87 | 0] << 24, jr = m[ye + 68 | 0] | m[ye + 69 | 0] << 8 | m[ye + 70 | 0] << 16 | m[ye + 71 | 0] << 24, ti = m[ye + 116 | 0] | m[ye + 117 | 0] << 8 | m[ye + 118 | 0] << 16 | m[ye + 119 | 0] << 24, fi = m[ye + 100 | 0] | m[ye + 101 | 0] << 8 | m[ye + 102 | 0] << 16 | m[ye + 103 | 0] << 24, Jr = m[ye + 88 | 0] | m[ye + 89 | 0] << 8 | m[ye + 90 | 0] << 16 | m[ye + 91 | 0] << 24, M = m[ye + 72 | 0] | m[ye + 73 | 0] << 8 | m[ye + 74 | 0] << 16 | m[ye + 75 | 0] << 24, T = m[ye + 120 | 0] | m[ye + 121 | 0] << 8 | m[ye + 122 | 0] << 16 | m[ye + 123 | 0] << 24, E = m[ye + 104 | 0] | m[ye + 105 | 0] << 8 | m[ye + 106 | 0] << 16 | m[ye + 107 | 0] << 24, ye = (m[ye + 92 | 0] | m[ye + 93 | 0] << 8 | m[ye + 94 | 0] << 16 | m[ye + 95 | 0] << 24) ^ (m[ye + 76 | 0] | m[ye + 77 | 0] << 8 | m[ye + 78 | 0] << 16 | m[ye + 79 | 0] << 24) ^ (m[ye + 124 | 0] | m[ye + 125 | 0] << 8 | m[ye + 126 | 0] << 16 | m[ye + 127 | 0] << 24) ^ (m[ye + 108 | 0] | m[ye + 109 | 0] << 8 | m[ye + 110 | 0] << 16 | m[ye + 111 | 0] << 24), B[k + 28 | 0] = ye, B[k + 29 | 0] = ye >>> 8, B[k + 30 | 0] = ye >>> 16, B[k + 31 | 0] = ye >>> 24, E = Jr ^ M ^ E ^ T, B[k + 24 | 0] = E, B[k + 25 | 0] = E >>> 8, B[k + 26 | 0] = E >>> 16, B[k + 27 | 0] = E >>> 24, E = Mr ^ jr ^ ti ^ fi, B[k + 20 | 0] = E, B[k + 21 | 0] = E >>> 8, B[k + 22 | 0] = E >>> 16, B[k + 23 | 0] = E >>> 24, E = Pr ^ Nr ^ pr ^ gr, B[k + 16 | 0] = E, B[k + 17 | 0] = E >>> 8, B[k + 18 | 0] = E >>> 16, B[k + 19 | 0] = E >>> 24;
                          break e;
                        }
                        Ca(k, 0, E);
                      }
                      dr = Ne + 288 | 0;
                    }
                    function Vn(k, E, T, M) {
                      var ye = 0, Ne = 0, pr = 0, ve = 0, cr = 0, gr = 0, Pr = 0, Nr = 0, Br = 0, Mr = 0, jr = 0, ti = 0, fi = 0, Jr = 0, li = 0, Tr = 0, Mi = 0, Wi = 0, vn = 0, Tn = 0, Ni = 0, Yi = 0, Xi = 0, $n = 0, Zn = 0, to = 0, fo = 0;
                      for (ye = m[0 | E] | m[E + 1 | 0] << 8 | m[E + 2 | 0] << 16 | m[E + 3 | 0] << 24, o[T >> 2] = ye << 24 | (65280 & ye) << 8 | ye >>> 8 & 65280 | ye >>> 24, ye = m[E + 4 | 0] | m[E + 5 | 0] << 8 | m[E + 6 | 0] << 16 | m[E + 7 | 0] << 24, o[T + 4 >> 2] = ye << 24 | (65280 & ye) << 8 | ye >>> 8 & 65280 | ye >>> 24, ye = m[E + 8 | 0] | m[E + 9 | 0] << 8 | m[E + 10 | 0] << 16 | m[E + 11 | 0] << 24, o[T + 8 >> 2] = ye << 24 | (65280 & ye) << 8 | ye >>> 8 & 65280 | ye >>> 24, ye = m[E + 12 | 0] | m[E + 13 | 0] << 8 | m[E + 14 | 0] << 16 | m[E + 15 | 0] << 24, o[T + 12 >> 2] = ye << 24 | (65280 & ye) << 8 | ye >>> 8 & 65280 | ye >>> 24, ye = m[E + 16 | 0] | m[E + 17 | 0] << 8 | m[E + 18 | 0] << 16 | m[E + 19 | 0] << 24, o[T + 16 >> 2] = ye << 24 | (65280 & ye) << 8 | ye >>> 8 & 65280 | ye >>> 24, ye = m[E + 20 | 0] | m[E + 21 | 0] << 8 | m[E + 22 | 0] << 16 | m[E + 23 | 0] << 24, o[T + 20 >> 2] = ye << 24 | (65280 & ye) << 8 | ye >>> 8 & 65280 | ye >>> 24, ye = m[E + 24 | 0] | m[E + 25 | 0] << 8 | m[E + 26 | 0] << 16 | m[E + 27 | 0] << 24, o[T + 24 >> 2] = ye << 24 | (65280 & ye) << 8 | ye >>> 8 & 65280 | ye >>> 24, ye = m[E + 28 | 0] | m[E + 29 | 0] << 8 | m[E + 30 | 0] << 16 | m[E + 31 | 0] << 24, o[T + 28 >> 2] = ye << 24 | (65280 & ye) << 8 | ye >>> 8 & 65280 | ye >>> 24, ye = m[E + 32 | 0] | m[E + 33 | 0] << 8 | m[E + 34 | 0] << 16 | m[E + 35 | 0] << 24, o[T + 32 >> 2] = ye << 24 | (65280 & ye) << 8 | ye >>> 8 & 65280 | ye >>> 24, ye = m[E + 36 | 0] | m[E + 37 | 0] << 8 | m[E + 38 | 0] << 16 | m[E + 39 | 0] << 24, o[T + 36 >> 2] = ye << 24 | (65280 & ye) << 8 | ye >>> 8 & 65280 | ye >>> 24, ye = m[E + 40 | 0] | m[E + 41 | 0] << 8 | m[E + 42 | 0] << 16 | m[E + 43 | 0] << 24, o[T + 40 >> 2] = ye << 24 | (65280 & ye) << 8 | ye >>> 8 & 65280 | ye >>> 24, ye = m[E + 44 | 0] | m[E + 45 | 0] << 8 | m[E + 46 | 0] << 16 | m[E + 47 | 0] << 24, o[T + 44 >> 2] = ye << 24 | (65280 & ye) << 8 | ye >>> 8 & 65280 | ye >>> 24, ye = m[E + 48 | 0] | m[E + 49 | 0] << 8 | m[E + 50 | 0] << 16 | m[E + 51 | 0] << 24, o[T + 48 >> 2] = ye << 24 | (65280 & ye) << 8 | ye >>> 8 & 65280 | ye >>> 24, ye = m[E + 52 | 0] | m[E + 53 | 0] << 8 | m[E + 54 | 0] << 16 | m[E + 55 | 0] << 24, o[T + 52 >> 2] = ye << 24 | (65280 & ye) << 8 | ye >>> 8 & 65280 | ye >>> 24, ye = m[E + 56 | 0] | m[E + 57 | 0] << 8 | m[E + 58 | 0] << 16 | m[E + 59 | 0] << 24, o[T + 56 >> 2] = ye << 24 | (65280 & ye) << 8 | ye >>> 8 & 65280 | ye >>> 24, E = m[E + 60 | 0] | m[E + 61 | 0] << 8 | m[E + 62 | 0] << 16 | m[E + 63 | 0] << 24, o[T + 60 >> 2] = E << 24 | (65280 & E) << 8 | E >>> 8 & 65280 | E >>> 24, E = o[k + 28 >> 2], o[M + 24 >> 2] = o[k + 24 >> 2], o[M + 28 >> 2] = E, E = o[k + 20 >> 2], o[M + 16 >> 2] = o[k + 16 >> 2], o[M + 20 >> 2] = E, E = o[k + 12 >> 2], o[M + 8 >> 2] = o[k + 8 >> 2], o[M + 12 >> 2] = E, E = o[k + 4 >> 2], o[M >> 2] = o[k >> 2], o[M + 4 >> 2] = E; cr = o[M + 28 >> 2], ye = (E = Mi << 2) + T | 0, pr = o[M + 16 >> 2], gr = o[ye >> 2] + (ao(pr, 26) ^ ao(pr, 21) ^ ao(pr, 7)) | 0, Nr = (cr = ((Ne = o[E + 35264 >> 2] + gr | 0) + (pr & ((gr = o[M + 24 >> 2]) ^ (Br = o[M + 20 >> 2])) ^ gr) | 0) + cr | 0) + o[M + 12 >> 2] | 0, o[M + 12 >> 2] = Nr, cr = (jr = cr + (ao(Pr = o[M >> 2], 30) ^ ao(Pr, 19) ^ ao(Pr, 10)) | 0) + (Pr & ((Ne = o[M + 8 >> 2]) | (ve = o[M + 4 >> 2])) | Ne & ve) | 0, o[M + 28 >> 2] = cr, Ne = (jr = Ne) + (gr = (o[(fi = (Ne = 4 | E) + T | 0) >> 2] + ((gr + (Br ^ Nr & (pr ^ Br)) | 0) + (ao(Nr, 26) ^ ao(Nr, 21) ^ ao(Nr, 7)) | 0) | 0) + o[Ne + 35264 >> 2] | 0) | 0, o[M + 8 >> 2] = Ne, gr = (gr + (cr & (ve | Pr) | ve & Pr) | 0) + (ao(cr, 30) ^ ao(cr, 19) ^ ao(cr, 10)) | 0, o[M + 24 >> 2] = gr, Br = (jr = ve) + (ve = (((Br + o[(Tr = (ve = 8 | E) + T | 0) >> 2] | 0) + o[ve + 35264 >> 2] | 0) + (pr ^ Ne & (pr ^ Nr)) | 0) + (ao(Ne, 26) ^ ao(Ne, 21) ^ ao(Ne, 7)) | 0) | 0, o[M + 4 >> 2] = Br, ve = ve + ((gr & (cr | Pr) | cr & Pr) + (ao(gr, 30) ^ ao(gr, 19) ^ ao(gr, 10)) | 0) | 0, o[M + 20 >> 2] = ve, pr = (jr = Pr) + (Pr = (((pr + o[(Wi = (Pr = 12 | E) + T | 0) >> 2] | 0) + o[Pr + 35264 >> 2] | 0) + (Nr ^ Br & (Ne ^ Nr)) | 0) + (ao(Br, 26) ^ ao(Br, 21) ^ ao(Br, 7)) | 0) | 0, o[M >> 2] = pr, Pr = Pr + ((ve & (cr | gr) | cr & gr) + (ao(ve, 30) ^ ao(ve, 19) ^ ao(ve, 10)) | 0) | 0, o[M + 16 >> 2] = Pr, Nr = (Mr = ((((jr = Nr) + o[(vn = (Nr = 16 | E) + T | 0) >> 2] | 0) + o[Nr + 35264 >> 2] | 0) + (Ne ^ pr & (Ne ^ Br)) | 0) + (ao(pr, 26) ^ ao(pr, 21) ^ ao(pr, 7)) | 0) + ((Pr & (ve | gr) | ve & gr) + (ao(Pr, 30) ^ ao(Pr, 19) ^ ao(Pr, 10)) | 0) | 0, o[M + 12 >> 2] = Nr, Mr = cr + Mr | 0, o[M + 28 >> 2] = Mr, cr = (Ne = (((Ne + o[(Tn = (cr = 20 | E) + T | 0) >> 2] | 0) + o[cr + 35264 >> 2] | 0) + (Br ^ Mr & (pr ^ Br)) | 0) + (ao(Mr, 26) ^ ao(Mr, 21) ^ ao(Mr, 7)) | 0) + ((Nr & (ve | Pr) | ve & Pr) + (ao(Nr, 30) ^ ao(Nr, 19) ^ ao(Nr, 10)) | 0) | 0, o[M + 8 >> 2] = cr, Ne = Ne + gr | 0, o[M + 24 >> 2] = Ne, gr = (Br = (((Br + o[(Ni = (gr = 24 | E) + T | 0) >> 2] | 0) + o[gr + 35264 >> 2] | 0) + (pr ^ Ne & (pr ^ Mr)) | 0) + (ao(Ne, 26) ^ ao(Ne, 21) ^ ao(Ne, 7)) | 0) + ((cr & (Pr | Nr) | Pr & Nr) + (ao(cr, 30) ^ ao(cr, 19) ^ ao(cr, 10)) | 0) | 0, o[M + 4 >> 2] = gr, Br = ve + Br | 0, o[M + 20 >> 2] = Br, ve = (pr = (((pr + o[(Yi = (ve = 28 | E) + T | 0) >> 2] | 0) + o[ve + 35264 >> 2] | 0) + (Mr ^ Br & (Ne ^ Mr)) | 0) + (ao(Br, 26) ^ ao(Br, 21) ^ ao(Br, 7)) | 0) + ((gr & (cr | Nr) | cr & Nr) + (ao(gr, 30) ^ ao(gr, 19) ^ ao(gr, 10)) | 0) | 0, o[M >> 2] = ve, pr = pr + Pr | 0, o[M + 16 >> 2] = pr, Pr = (Mr = (((Mr + o[(Xi = (Pr = 32 | E) + T | 0) >> 2] | 0) + o[Pr + 35264 >> 2] | 0) + (Ne ^ pr & (Ne ^ Br)) | 0) + (ao(pr, 26) ^ ao(pr, 21) ^ ao(pr, 7)) | 0) + ((ve & (cr | gr) | cr & gr) + (ao(ve, 30) ^ ao(ve, 19) ^ ao(ve, 10)) | 0) | 0, o[M + 28 >> 2] = Pr, Mr = Nr + Mr | 0, o[M + 12 >> 2] = Mr, Nr = (Ne = (((Ne + o[($n = (Nr = 36 | E) + T | 0) >> 2] | 0) + o[Nr + 35264 >> 2] | 0) + (Br ^ Mr & (pr ^ Br)) | 0) + (ao(Mr, 26) ^ ao(Mr, 21) ^ ao(Mr, 7)) | 0) + ((Pr & (ve | gr) | ve & gr) + (ao(Pr, 30) ^ ao(Pr, 19) ^ ao(Pr, 10)) | 0) | 0, o[M + 24 >> 2] = Nr, Ne = Ne + cr | 0, o[M + 8 >> 2] = Ne, cr = (Br = (((Br + o[(Zn = (cr = 40 | E) + T | 0) >> 2] | 0) + o[cr + 35264 >> 2] | 0) + (pr ^ Ne & (pr ^ Mr)) | 0) + (ao(Ne, 26) ^ ao(Ne, 21) ^ ao(Ne, 7)) | 0) + ((Nr & (ve | Pr) | ve & Pr) + (ao(Nr, 30) ^ ao(Nr, 19) ^ ao(Nr, 10)) | 0) | 0, o[M + 20 >> 2] = cr, Br = gr + Br | 0, o[M + 4 >> 2] = Br, jr = (gr = 44 | E) + T | 0, gr = (pr = ((pr + (o[gr + 35264 >> 2] + o[jr >> 2] | 0) | 0) + (Mr ^ Br & (Ne ^ Mr)) | 0) + (ao(Br, 26) ^ ao(Br, 21) ^ ao(Br, 7)) | 0) + ((cr & (Pr | Nr) | Pr & Nr) + (ao(cr, 30) ^ ao(cr, 19) ^ ao(cr, 10)) | 0) | 0, o[M + 16 >> 2] = gr, ve = ve + pr | 0, o[M >> 2] = ve, li = (pr = 48 | E) + T | 0, pr = (Mr = ((Mr + (o[pr + 35264 >> 2] + o[li >> 2] | 0) | 0) + (Ne ^ ve & (Ne ^ Br)) | 0) + (ao(ve, 26) ^ ao(ve, 21) ^ ao(ve, 7)) | 0) + ((gr & (cr | Nr) | cr & Nr) + (ao(gr, 30) ^ ao(gr, 19) ^ ao(gr, 10)) | 0) | 0, o[M + 12 >> 2] = pr, Pr = Pr + Mr | 0, o[M + 28 >> 2] = Pr, Jr = (Mr = 52 | E) + T | 0, Ne = (Mr = (((o[Mr + 35264 >> 2] + o[Jr >> 2] | 0) + Ne | 0) + (Br ^ Pr & (ve ^ Br)) | 0) + (ao(Pr, 26) ^ ao(Pr, 21) ^ ao(Pr, 7)) | 0) + ((pr & (cr | gr) | cr & gr) + (ao(pr, 30) ^ ao(pr, 19) ^ ao(pr, 10)) | 0) | 0, o[M + 8 >> 2] = Ne, Nr = Nr + Mr | 0, o[M + 24 >> 2] = Nr, Mr = (ti = 56 | E) + T | 0, Br = (ti = (((o[ti + 35264 >> 2] + o[Mr >> 2] | 0) + Br | 0) + (ve ^ Nr & (ve ^ Pr)) | 0) + (ao(Nr, 26) ^ ao(Nr, 21) ^ ao(Nr, 7)) | 0) + ((Ne & (gr | pr) | gr & pr) + (ao(Ne, 30) ^ ao(Ne, 19) ^ ao(Ne, 10)) | 0) | 0, o[M + 4 >> 2] = Br, cr = cr + ti | 0, o[M + 20 >> 2] = cr, ti = (E |= 60) + T | 0, cr = (E = ((ve + (o[E + 35264 >> 2] + o[ti >> 2] | 0) | 0) + (Pr ^ cr & (Pr ^ Nr)) | 0) + (ao(cr, 26) ^ ao(cr, 21) ^ ao(cr, 7)) | 0) + ((Br & (Ne | pr) | Ne & pr) + (ao(Br, 30) ^ ao(Br, 19) ^ ao(Br, 10)) | 0) | 0, o[M >> 2] = cr, o[M + 16 >> 2] = E + gr, (0 | Mi) != 48; ) ve = o[$n >> 2], Mi = Mi + 16 | 0, E = o[Mr >> 2], cr = (Ne = o[ye >> 2] + (ve + (ao(E, 15) ^ ao(E, 13) ^ E >>> 10) | 0) | 0) + (ao(gr = o[fi >> 2], 25) ^ ao(gr, 14) ^ gr >>> 3) | 0, o[(Mi << 2) + T >> 2] = cr, Nr = (pr = (Ne = (Pr = o[Zn >> 2]) + gr | 0) + (ao(gr = o[ti >> 2], 15) ^ ao(gr, 13) ^ gr >>> 10) | 0) + (ao(Ne = o[Tr >> 2], 25) ^ ao(Ne, 14) ^ Ne >>> 3) | 0, o[ye + 68 >> 2] = Nr, Br = (jr = ((pr = Ne) + (Ne = o[jr >> 2]) | 0) + (ao(cr, 15) ^ ao(cr, 13) ^ cr >>> 10) | 0) + (ao(pr = o[Wi >> 2], 25) ^ ao(pr, 14) ^ pr >>> 3) | 0, o[ye + 72 >> 2] = Br, Mr = (ti = ((jr = pr) + (pr = o[li >> 2]) | 0) + (ao(Nr, 15) ^ ao(Nr, 13) ^ Nr >>> 10) | 0) + (ao(jr = o[vn >> 2], 25) ^ ao(jr, 14) ^ jr >>> 3) | 0, o[ye + 76 >> 2] = Mr, li = (ti = ((ti = jr) + (jr = o[Jr >> 2]) | 0) + (ao(Br, 15) ^ ao(Br, 13) ^ Br >>> 10) | 0) + (ao(Jr = o[Tn >> 2], 25) ^ ao(Jr, 14) ^ Jr >>> 3) | 0, o[ye + 80 >> 2] = li, Jr = (fi = (E + Jr | 0) + (ao(Mr, 15) ^ ao(Mr, 13) ^ Mr >>> 10) | 0) + (ao(ti = o[Ni >> 2], 25) ^ ao(ti, 14) ^ ti >>> 3) | 0, o[ye + 84 >> 2] = Jr, ti = ((gr + ti | 0) + (ao(Tr = o[Yi >> 2], 25) ^ ao(Tr, 14) ^ Tr >>> 3) | 0) + (ao(li, 15) ^ ao(li, 13) ^ li >>> 10) | 0, o[ye + 88 >> 2] = ti, Nr = ((fi = o[Xi >> 2]) + (Nr + (ao(ve, 25) ^ ao(ve, 14) ^ ve >>> 3) | 0) | 0) + (ao(ti, 15) ^ ao(ti, 13) ^ ti >>> 10) | 0, o[ye + 96 >> 2] = Nr, fi = ((cr + Tr | 0) + (ao(fi, 25) ^ ao(fi, 14) ^ fi >>> 3) | 0) + (ao(Jr, 15) ^ ao(Jr, 13) ^ Jr >>> 10) | 0, o[ye + 92 >> 2] = fi, Mr = (Mr + (Pr + (ao(Ne, 25) ^ ao(Ne, 14) ^ Ne >>> 3) | 0) | 0) + (ao(Nr, 15) ^ ao(Nr, 13) ^ Nr >>> 10) | 0, o[ye + 104 >> 2] = Mr, ve = (Br + (ve + (ao(Pr, 25) ^ ao(Pr, 14) ^ Pr >>> 3) | 0) | 0) + (ao(fi, 15) ^ ao(fi, 13) ^ fi >>> 10) | 0, o[ye + 100 >> 2] = ve, Pr = (Jr + (pr + (ao(jr, 25) ^ ao(jr, 14) ^ jr >>> 3) | 0) | 0) + (ao(Mr, 15) ^ ao(Mr, 13) ^ Mr >>> 10) | 0, o[ye + 112 >> 2] = Pr, ve = (li + (Ne + (ao(pr, 25) ^ ao(pr, 14) ^ pr >>> 3) | 0) | 0) + (ao(ve, 15) ^ ao(ve, 13) ^ ve >>> 10) | 0, o[ye + 108 >> 2] = ve, to = ye, fo = (fi + (E + (ao(gr, 25) ^ ao(gr, 14) ^ gr >>> 3) | 0) | 0) + (ao(Pr, 15) ^ ao(Pr, 13) ^ Pr >>> 10) | 0, o[to + 120 >> 2] = fo, E = (ti + (jr + (ao(E, 25) ^ ao(E, 14) ^ E >>> 3) | 0) | 0) + (ao(ve, 15) ^ ao(ve, 13) ^ ve >>> 10) | 0, o[ye + 116 >> 2] = E, to = ye, fo = (Nr + (gr + (ao(cr, 25) ^ ao(cr, 14) ^ cr >>> 3) | 0) | 0) + (ao(E, 15) ^ ao(E, 13) ^ E >>> 10) | 0, o[to + 124 >> 2] = fo;
                      o[k >> 2] = cr + o[k >> 2], o[k + 4 >> 2] = o[k + 4 >> 2] + o[M + 4 >> 2], o[k + 8 >> 2] = o[k + 8 >> 2] + o[M + 8 >> 2], o[k + 12 >> 2] = o[k + 12 >> 2] + o[M + 12 >> 2], o[k + 16 >> 2] = o[k + 16 >> 2] + o[M + 16 >> 2], o[k + 20 >> 2] = o[k + 20 >> 2] + o[M + 20 >> 2], o[k + 24 >> 2] = o[k + 24 >> 2] + o[M + 24 >> 2], o[k + 28 >> 2] = o[k + 28 >> 2] + o[M + 28 >> 2];
                    }
                    function Xn(k, E, T) {
                      var M, ye, Ne, pr, ve, cr, gr, Pr, Nr, Br, Mr, jr, ti, fi, Jr, li, Tr, Mi, Wi, vn, Tn, Ni, Yi, Xi = 0, $n = 0, Zn = 0, to = 0, fo = 0, wo = 0, bo = 0, go = 0;
                      dr = M = dr - 288 | 0, gr = m[T + 16 | 0] | m[T + 17 | 0] << 8 | m[T + 18 | 0] << 16 | m[T + 19 | 0] << 24, Pr = m[T + 48 | 0] | m[T + 49 | 0] << 8 | m[T + 50 | 0] << 16 | m[T + 51 | 0] << 24, Nr = m[T + 20 | 0] | m[T + 21 | 0] << 8 | m[T + 22 | 0] << 16 | m[T + 23 | 0] << 24, Br = m[E + 4 | 0] | m[E + 5 | 0] << 8 | m[E + 6 | 0] << 16 | m[E + 7 | 0] << 24, Mr = m[T + 52 | 0] | m[T + 53 | 0] << 8 | m[T + 54 | 0] << 16 | m[T + 55 | 0] << 24, jr = m[T + 24 | 0] | m[T + 25 | 0] << 8 | m[T + 26 | 0] << 16 | m[T + 27 | 0] << 24, ti = m[E + 8 | 0] | m[E + 9 | 0] << 8 | m[E + 10 | 0] << 16 | m[E + 11 | 0] << 24, fi = m[T + 56 | 0] | m[T + 57 | 0] << 8 | m[T + 58 | 0] << 16 | m[T + 59 | 0] << 24, fo = m[T + 28 | 0] | m[T + 29 | 0] << 8 | m[T + 30 | 0] << 16 | m[T + 31 | 0] << 24, Jr = m[E + 12 | 0] | m[E + 13 | 0] << 8 | m[E + 14 | 0] << 16 | m[E + 15 | 0] << 24, li = m[T + 60 | 0] | m[T + 61 | 0] << 8 | m[T + 62 | 0] << 16 | m[T + 63 | 0] << 24, $n = m[T + 32 | 0] | m[T + 33 | 0] << 8 | m[T + 34 | 0] << 16 | m[T + 35 | 0] << 24, wo = m[T + 80 | 0] | m[T + 81 | 0] << 8 | m[T + 82 | 0] << 16 | m[T + 83 | 0] << 24, Tr = m[E + 16 | 0] | m[E + 17 | 0] << 8 | m[E + 18 | 0] << 16 | m[E + 19 | 0] << 24, Mi = m[T + 112 | 0] | m[T + 113 | 0] << 8 | m[T + 114 | 0] << 16 | m[T + 115 | 0] << 24, Xi = m[T + 96 | 0] | m[T + 97 | 0] << 8 | m[T + 98 | 0] << 16 | m[T + 99 | 0] << 24, Zn = m[T + 36 | 0] | m[T + 37 | 0] << 8 | m[T + 38 | 0] << 16 | m[T + 39 | 0] << 24, bo = m[T + 84 | 0] | m[T + 85 | 0] << 8 | m[T + 86 | 0] << 16 | m[T + 87 | 0] << 24, Wi = m[E + 20 | 0] | m[E + 21 | 0] << 8 | m[E + 22 | 0] << 16 | m[E + 23 | 0] << 24, vn = m[T + 116 | 0] | m[T + 117 | 0] << 8 | m[T + 118 | 0] << 16 | m[T + 119 | 0] << 24, Ne = m[T + 100 | 0] | m[T + 101 | 0] << 8 | m[T + 102 | 0] << 16 | m[T + 103 | 0] << 24, to = m[T + 40 | 0] | m[T + 41 | 0] << 8 | m[T + 42 | 0] << 16 | m[T + 43 | 0] << 24, go = m[T + 88 | 0] | m[T + 89 | 0] << 8 | m[T + 90 | 0] << 16 | m[T + 91 | 0] << 24, Tn = m[E + 24 | 0] | m[E + 25 | 0] << 8 | m[E + 26 | 0] << 16 | m[E + 27 | 0] << 24, Ni = m[T + 120 | 0] | m[T + 121 | 0] << 8 | m[T + 122 | 0] << 16 | m[T + 123 | 0] << 24, pr = m[T + 104 | 0] | m[T + 105 | 0] << 8 | m[T + 106 | 0] << 16 | m[T + 107 | 0] << 24, Yi = m[0 | E] | m[E + 1 | 0] << 8 | m[E + 2 | 0] << 16 | m[E + 3 | 0] << 24, ye = (ve = m[T + 44 | 0] | m[T + 45 | 0] << 8 | m[T + 46 | 0] << 16 | m[T + 47 | 0] << 24) ^ (cr = m[T + 108 | 0] | m[T + 109 | 0] << 8 | m[T + 110 | 0] << 16 | m[T + 111 | 0] << 24) & (m[T + 124 | 0] | m[T + 125 | 0] << 8 | m[T + 126 | 0] << 16 | m[T + 127 | 0] << 24) ^ (m[T + 92 | 0] | m[T + 93 | 0] << 8 | m[T + 94 | 0] << 16 | m[T + 95 | 0] << 24) ^ (m[E + 28 | 0] | m[E + 29 | 0] << 8 | m[E + 30 | 0] << 16 | m[E + 31 | 0] << 24), B[k + 28 | 0] = ye, B[k + 29 | 0] = ye >>> 8, B[k + 30 | 0] = ye >>> 16, B[k + 31 | 0] = ye >>> 24, go = to ^ pr & Ni ^ go ^ Tn, B[k + 24 | 0] = go, B[k + 25 | 0] = go >>> 8, B[k + 26 | 0] = go >>> 16, B[k + 27 | 0] = go >>> 24, bo = Zn ^ Ne & vn ^ bo ^ Wi, B[k + 20 | 0] = bo, B[k + 21 | 0] = bo >>> 8, B[k + 22 | 0] = bo >>> 16, B[k + 23 | 0] = bo >>> 24, wo = $n ^ Xi & Mi ^ wo ^ Tr, B[k + 16 | 0] = wo, B[k + 17 | 0] = wo >>> 8, B[k + 18 | 0] = wo >>> 16, B[k + 19 | 0] = wo >>> 24, fo = li & ve ^ fo ^ Jr ^ cr, B[k + 12 | 0] = fo, B[k + 13 | 0] = fo >>> 8, B[k + 14 | 0] = fo >>> 16, B[k + 15 | 0] = fo >>> 24, to = to & fi ^ jr ^ ti ^ pr, B[k + 8 | 0] = to, B[k + 9 | 0] = to >>> 8, B[k + 10 | 0] = to >>> 16, B[k + 11 | 0] = to >>> 24, Zn = Zn & Mr ^ Nr ^ Br ^ Ne, B[k + 4 | 0] = Zn, B[k + 5 | 0] = Zn >>> 8, B[k + 6 | 0] = Zn >>> 16, B[k + 7 | 0] = Zn >>> 24, $n = Xi ^ $n & Pr ^ gr ^ Yi, B[0 | k] = $n, B[k + 1 | 0] = $n >>> 8, B[k + 2 | 0] = $n >>> 16, B[k + 3 | 0] = $n >>> 24, k = o[T + 124 >> 2], o[M + 280 >> 2] = o[T + 120 >> 2], o[M + 284 >> 2] = k, k = o[T + 116 >> 2], o[M + 272 >> 2] = o[T + 112 >> 2], o[M + 276 >> 2] = k, k = o[T + 108 >> 2], o[M + 248 >> 2] = o[T + 104 >> 2], o[M + 252 >> 2] = k, k = o[T + 100 >> 2], o[M + 240 >> 2] = o[T + 96 >> 2], o[M + 244 >> 2] = k, k = o[T + 124 >> 2], o[M + 232 >> 2] = o[T + 120 >> 2], o[M + 236 >> 2] = k, k = o[T + 116 >> 2], o[M + 224 >> 2] = o[T + 112 >> 2], o[M + 228 >> 2] = k, gs(E = M + 256 | 0, M + 240 | 0, M + 224 | 0), k = o[M + 268 >> 2], o[T + 120 >> 2] = o[M + 264 >> 2], o[T + 124 >> 2] = k, k = o[M + 260 >> 2], o[T + 112 >> 2] = o[M + 256 >> 2], o[T + 116 >> 2] = k, k = o[T + 92 >> 2], o[M + 216 >> 2] = o[T + 88 >> 2], o[M + 220 >> 2] = k, k = o[T + 84 >> 2], o[M + 208 >> 2] = o[T + 80 >> 2], o[M + 212 >> 2] = k, k = o[T + 108 >> 2], o[M + 200 >> 2] = o[T + 104 >> 2], o[M + 204 >> 2] = k, k = o[T + 100 >> 2], o[M + 192 >> 2] = o[T + 96 >> 2], o[M + 196 >> 2] = k, gs(E, M + 208 | 0, M + 192 | 0), k = o[M + 268 >> 2], o[T + 104 >> 2] = o[M + 264 >> 2], o[T + 108 >> 2] = k, k = o[M + 260 >> 2], o[T + 96 >> 2] = o[M + 256 >> 2], o[T + 100 >> 2] = k, k = o[T + 76 >> 2], o[M + 184 >> 2] = o[T + 72 >> 2], o[M + 188 >> 2] = k, Xi = o[4 + (k = T - -64 | 0) >> 2], o[M + 176 >> 2] = o[k >> 2], o[M + 180 >> 2] = Xi, Xi = o[T + 92 >> 2], o[M + 168 >> 2] = o[T + 88 >> 2], o[M + 172 >> 2] = Xi, Xi = o[T + 84 >> 2], o[M + 160 >> 2] = o[T + 80 >> 2], o[M + 164 >> 2] = Xi, gs(E, M + 176 | 0, M + 160 | 0), Xi = o[M + 268 >> 2], o[T + 88 >> 2] = o[M + 264 >> 2], o[T + 92 >> 2] = Xi, Xi = o[M + 260 >> 2], o[T + 80 >> 2] = o[M + 256 >> 2], o[T + 84 >> 2] = Xi, Xi = o[T + 60 >> 2], o[M + 152 >> 2] = o[T + 56 >> 2], o[M + 156 >> 2] = Xi, Xi = o[T + 52 >> 2], o[M + 144 >> 2] = o[T + 48 >> 2], o[M + 148 >> 2] = Xi, Xi = o[T + 76 >> 2], o[M + 136 >> 2] = o[T + 72 >> 2], o[M + 140 >> 2] = Xi, Xi = o[k + 4 >> 2], o[M + 128 >> 2] = o[k >> 2], o[M + 132 >> 2] = Xi, gs(E, M + 144 | 0, M + 128 | 0), Xi = o[M + 268 >> 2], o[T + 72 >> 2] = o[M + 264 >> 2], o[T + 76 >> 2] = Xi, Xi = o[M + 260 >> 2], o[k >> 2] = o[M + 256 >> 2], o[k + 4 >> 2] = Xi, Xi = o[T + 44 >> 2], o[M + 120 >> 2] = o[T + 40 >> 2], o[M + 124 >> 2] = Xi, Xi = o[T + 36 >> 2], o[M + 112 >> 2] = o[T + 32 >> 2], o[M + 116 >> 2] = Xi, Xi = o[T + 60 >> 2], o[M + 104 >> 2] = o[T + 56 >> 2], o[M + 108 >> 2] = Xi, Xi = o[T + 52 >> 2], o[M + 96 >> 2] = o[T + 48 >> 2], o[M + 100 >> 2] = Xi, gs(E, M + 112 | 0, M + 96 | 0), Xi = o[M + 268 >> 2], o[T + 56 >> 2] = o[M + 264 >> 2], o[T + 60 >> 2] = Xi, Xi = o[M + 260 >> 2], o[T + 48 >> 2] = o[M + 256 >> 2], o[T + 52 >> 2] = Xi, Xi = o[T + 28 >> 2], o[M + 88 >> 2] = o[T + 24 >> 2], o[M + 92 >> 2] = Xi, Xi = o[T + 20 >> 2], o[M + 80 >> 2] = o[T + 16 >> 2], o[M + 84 >> 2] = Xi, Xi = o[T + 44 >> 2], o[M + 72 >> 2] = o[T + 40 >> 2], o[M + 76 >> 2] = Xi, Xi = o[T + 36 >> 2], o[M + 64 >> 2] = o[T + 32 >> 2], o[M + 68 >> 2] = Xi, gs(E, M + 80 | 0, M - -64 | 0), Xi = o[M + 268 >> 2], o[T + 40 >> 2] = o[M + 264 >> 2], o[T + 44 >> 2] = Xi, Xi = o[M + 260 >> 2], o[T + 32 >> 2] = o[M + 256 >> 2], o[T + 36 >> 2] = Xi, Xi = o[T + 12 >> 2], o[M + 56 >> 2] = o[T + 8 >> 2], o[M + 60 >> 2] = Xi, Xi = o[T + 4 >> 2], o[M + 48 >> 2] = o[T >> 2], o[M + 52 >> 2] = Xi, Xi = o[T + 28 >> 2], o[M + 40 >> 2] = o[T + 24 >> 2], o[M + 44 >> 2] = Xi, Xi = o[T + 20 >> 2], o[M + 32 >> 2] = o[T + 16 >> 2], o[M + 36 >> 2] = Xi, gs(E, M + 48 | 0, M + 32 | 0), Xi = o[M + 268 >> 2], o[T + 24 >> 2] = o[M + 264 >> 2], o[T + 28 >> 2] = Xi, Xi = o[M + 260 >> 2], o[T + 16 >> 2] = o[M + 256 >> 2], o[T + 20 >> 2] = Xi, Xi = o[M + 284 >> 2], o[M + 24 >> 2] = o[M + 280 >> 2], o[M + 28 >> 2] = Xi, Xi = o[M + 276 >> 2], o[M + 16 >> 2] = o[M + 272 >> 2], o[M + 20 >> 2] = Xi, Xi = o[T + 12 >> 2], o[M + 8 >> 2] = o[T + 8 >> 2], o[M + 12 >> 2] = Xi, Xi = o[T + 4 >> 2], o[M >> 2] = o[T >> 2], o[M + 4 >> 2] = Xi, gs(E, M + 16 | 0, M), E = o[M + 268 >> 2], o[T + 8 >> 2] = o[M + 264 >> 2], o[T + 12 >> 2] = E, E = o[M + 260 >> 2], o[T >> 2] = o[M + 256 >> 2], o[T + 4 >> 2] = E, o[T + 12 >> 2] = fo ^ (m[T + 12 | 0] | m[T + 13 | 0] << 8 | m[T + 14 | 0] << 16 | m[T + 15 | 0] << 24), o[T + 8 >> 2] = to ^ (m[T + 8 | 0] | m[T + 9 | 0] << 8 | m[T + 10 | 0] << 16 | m[T + 11 | 0] << 24), o[T + 4 >> 2] = Zn ^ (m[T + 4 | 0] | m[T + 5 | 0] << 8 | m[T + 6 | 0] << 16 | m[T + 7 | 0] << 24), o[T >> 2] = $n ^ (m[0 | T] | m[T + 1 | 0] << 8 | m[T + 2 | 0] << 16 | m[T + 3 | 0] << 24), o[k >> 2] = wo ^ (m[0 | k] | m[k + 1 | 0] << 8 | m[k + 2 | 0] << 16 | m[k + 3 | 0] << 24), o[T + 68 >> 2] = bo ^ (m[T + 68 | 0] | m[T + 69 | 0] << 8 | m[T + 70 | 0] << 16 | m[T + 71 | 0] << 24), o[T + 72 >> 2] = go ^ (m[T + 72 | 0] | m[T + 73 | 0] << 8 | m[T + 74 | 0] << 16 | m[T + 75 | 0] << 24), o[T + 76 >> 2] = ye ^ (m[T + 76 | 0] | m[T + 77 | 0] << 8 | m[T + 78 | 0] << 16 | m[T + 79 | 0] << 24), dr = M + 288 | 0;
                    }
                    function uo(k, E, T) {
                      var M, ye, Ne, pr, ve, cr, gr, Pr, Nr, Br, Mr, jr, ti, fi, Jr, li, Tr, Mi, Wi, vn, Tn, Ni, Yi, Xi, $n, Zn, to, fo, wo, bo, go = 0;
                      dr = M = dr - 288 | 0, Tr = m[T + 16 | 0] | m[T + 17 | 0] << 8 | m[T + 18 | 0] << 16 | m[T + 19 | 0] << 24, Mi = m[T + 48 | 0] | m[T + 49 | 0] << 8 | m[T + 50 | 0] << 16 | m[T + 51 | 0] << 24, ye = m[E + 4 | 0] | m[E + 5 | 0] << 8 | m[E + 6 | 0] << 16 | m[E + 7 | 0] << 24, Wi = m[T + 20 | 0] | m[T + 21 | 0] << 8 | m[T + 22 | 0] << 16 | m[T + 23 | 0] << 24, vn = m[T + 52 | 0] | m[T + 53 | 0] << 8 | m[T + 54 | 0] << 16 | m[T + 55 | 0] << 24, Ne = m[E + 8 | 0] | m[E + 9 | 0] << 8 | m[E + 10 | 0] << 16 | m[E + 11 | 0] << 24, Tn = m[T + 24 | 0] | m[T + 25 | 0] << 8 | m[T + 26 | 0] << 16 | m[T + 27 | 0] << 24, Ni = m[T + 56 | 0] | m[T + 57 | 0] << 8 | m[T + 58 | 0] << 16 | m[T + 59 | 0] << 24, pr = m[E + 12 | 0] | m[E + 13 | 0] << 8 | m[E + 14 | 0] << 16 | m[E + 15 | 0] << 24, Yi = m[T + 28 | 0] | m[T + 29 | 0] << 8 | m[T + 30 | 0] << 16 | m[T + 31 | 0] << 24, Xi = m[T + 60 | 0] | m[T + 61 | 0] << 8 | m[T + 62 | 0] << 16 | m[T + 63 | 0] << 24, go = m[T + 32 | 0] | m[T + 33 | 0] << 8 | m[T + 34 | 0] << 16 | m[T + 35 | 0] << 24, ve = m[E + 16 | 0] | m[E + 17 | 0] << 8 | m[E + 18 | 0] << 16 | m[E + 19 | 0] << 24, $n = m[T + 80 | 0] | m[T + 81 | 0] << 8 | m[T + 82 | 0] << 16 | m[T + 83 | 0] << 24, Zn = m[T + 112 | 0] | m[T + 113 | 0] << 8 | m[T + 114 | 0] << 16 | m[T + 115 | 0] << 24, cr = m[T + 96 | 0] | m[T + 97 | 0] << 8 | m[T + 98 | 0] << 16 | m[T + 99 | 0] << 24, gr = m[T + 36 | 0] | m[T + 37 | 0] << 8 | m[T + 38 | 0] << 16 | m[T + 39 | 0] << 24, Pr = m[E + 20 | 0] | m[E + 21 | 0] << 8 | m[E + 22 | 0] << 16 | m[E + 23 | 0] << 24, to = m[T + 84 | 0] | m[T + 85 | 0] << 8 | m[T + 86 | 0] << 16 | m[T + 87 | 0] << 24, fo = m[T + 116 | 0] | m[T + 117 | 0] << 8 | m[T + 118 | 0] << 16 | m[T + 119 | 0] << 24, Nr = m[T + 100 | 0] | m[T + 101 | 0] << 8 | m[T + 102 | 0] << 16 | m[T + 103 | 0] << 24, Br = m[T + 40 | 0] | m[T + 41 | 0] << 8 | m[T + 42 | 0] << 16 | m[T + 43 | 0] << 24, Mr = m[E + 24 | 0] | m[E + 25 | 0] << 8 | m[E + 26 | 0] << 16 | m[E + 27 | 0] << 24, wo = m[T + 88 | 0] | m[T + 89 | 0] << 8 | m[T + 90 | 0] << 16 | m[T + 91 | 0] << 24, bo = m[T + 120 | 0] | m[T + 121 | 0] << 8 | m[T + 122 | 0] << 16 | m[T + 123 | 0] << 24, jr = m[T + 104 | 0] | m[T + 105 | 0] << 8 | m[T + 106 | 0] << 16 | m[T + 107 | 0] << 24, ti = m[0 | E] | m[E + 1 | 0] << 8 | m[E + 2 | 0] << 16 | m[E + 3 | 0] << 24, E = (fi = m[T + 44 | 0] | m[T + 45 | 0] << 8 | m[T + 46 | 0] << 16 | m[T + 47 | 0] << 24) ^ (Jr = m[E + 28 | 0] | m[E + 29 | 0] << 8 | m[E + 30 | 0] << 16 | m[E + 31 | 0] << 24) ^ (li = m[T + 108 | 0] | m[T + 109 | 0] << 8 | m[T + 110 | 0] << 16 | m[T + 111 | 0] << 24) & (m[T + 124 | 0] | m[T + 125 | 0] << 8 | m[T + 126 | 0] << 16 | m[T + 127 | 0] << 24) ^ (m[T + 92 | 0] | m[T + 93 | 0] << 8 | m[T + 94 | 0] << 16 | m[T + 95 | 0] << 24), B[k + 28 | 0] = E, B[k + 29 | 0] = E >>> 8, B[k + 30 | 0] = E >>> 16, B[k + 31 | 0] = E >>> 24, E = jr & bo ^ wo ^ Mr ^ Br, B[k + 24 | 0] = E, B[k + 25 | 0] = E >>> 8, B[k + 26 | 0] = E >>> 16, B[k + 27 | 0] = E >>> 24, E = Nr & fo ^ to ^ Pr ^ gr, B[k + 20 | 0] = E, B[k + 21 | 0] = E >>> 8, B[k + 22 | 0] = E >>> 16, B[k + 23 | 0] = E >>> 24, E = go ^ cr & Zn ^ $n ^ ve, B[k + 16 | 0] = E, B[k + 17 | 0] = E >>> 8, B[k + 18 | 0] = E >>> 16, B[k + 19 | 0] = E >>> 24, E = Xi & fi ^ Yi ^ pr ^ li, B[k + 12 | 0] = E, B[k + 13 | 0] = E >>> 8, B[k + 14 | 0] = E >>> 16, B[k + 15 | 0] = E >>> 24, E = Br & Ni ^ Tn ^ Ne ^ jr, B[k + 8 | 0] = E, B[k + 9 | 0] = E >>> 8, B[k + 10 | 0] = E >>> 16, B[k + 11 | 0] = E >>> 24, E = gr & vn ^ Wi ^ ye ^ Nr, B[k + 4 | 0] = E, B[k + 5 | 0] = E >>> 8, B[k + 6 | 0] = E >>> 16, B[k + 7 | 0] = E >>> 24, E = go & Mi ^ Tr ^ ti ^ cr, B[0 | k] = E, B[k + 1 | 0] = E >>> 8, B[k + 2 | 0] = E >>> 16, B[k + 3 | 0] = E >>> 24, k = o[T + 124 >> 2], o[M + 280 >> 2] = o[T + 120 >> 2], o[M + 284 >> 2] = k, k = o[T + 116 >> 2], o[M + 272 >> 2] = o[T + 112 >> 2], o[M + 276 >> 2] = k, k = o[T + 108 >> 2], o[M + 248 >> 2] = o[T + 104 >> 2], o[M + 252 >> 2] = k, k = o[T + 100 >> 2], o[M + 240 >> 2] = o[T + 96 >> 2], o[M + 244 >> 2] = k, k = o[T + 124 >> 2], o[M + 232 >> 2] = o[T + 120 >> 2], o[M + 236 >> 2] = k, k = o[T + 116 >> 2], o[M + 224 >> 2] = o[T + 112 >> 2], o[M + 228 >> 2] = k, gs(E = M + 256 | 0, M + 240 | 0, M + 224 | 0), k = o[M + 268 >> 2], o[T + 120 >> 2] = o[M + 264 >> 2], o[T + 124 >> 2] = k, k = o[M + 260 >> 2], o[T + 112 >> 2] = o[M + 256 >> 2], o[T + 116 >> 2] = k, k = o[T + 92 >> 2], o[M + 216 >> 2] = o[T + 88 >> 2], o[M + 220 >> 2] = k, k = o[T + 84 >> 2], o[M + 208 >> 2] = o[T + 80 >> 2], o[M + 212 >> 2] = k, k = o[T + 108 >> 2], o[M + 200 >> 2] = o[T + 104 >> 2], o[M + 204 >> 2] = k, k = o[T + 100 >> 2], o[M + 192 >> 2] = o[T + 96 >> 2], o[M + 196 >> 2] = k, gs(E, M + 208 | 0, M + 192 | 0), k = o[M + 268 >> 2], o[T + 104 >> 2] = o[M + 264 >> 2], o[T + 108 >> 2] = k, k = o[M + 260 >> 2], o[T + 96 >> 2] = o[M + 256 >> 2], o[T + 100 >> 2] = k, k = o[T + 76 >> 2], o[M + 184 >> 2] = o[T + 72 >> 2], o[M + 188 >> 2] = k, go = o[4 + (k = T - -64 | 0) >> 2], o[M + 176 >> 2] = o[k >> 2], o[M + 180 >> 2] = go, go = o[T + 92 >> 2], o[M + 168 >> 2] = o[T + 88 >> 2], o[M + 172 >> 2] = go, go = o[T + 84 >> 2], o[M + 160 >> 2] = o[T + 80 >> 2], o[M + 164 >> 2] = go, gs(E, M + 176 | 0, M + 160 | 0), go = o[M + 268 >> 2], o[T + 88 >> 2] = o[M + 264 >> 2], o[T + 92 >> 2] = go, go = o[M + 260 >> 2], o[T + 80 >> 2] = o[M + 256 >> 2], o[T + 84 >> 2] = go, go = o[T + 60 >> 2], o[M + 152 >> 2] = o[T + 56 >> 2], o[M + 156 >> 2] = go, go = o[T + 52 >> 2], o[M + 144 >> 2] = o[T + 48 >> 2], o[M + 148 >> 2] = go, go = o[T + 76 >> 2], o[M + 136 >> 2] = o[T + 72 >> 2], o[M + 140 >> 2] = go, go = o[k + 4 >> 2], o[M + 128 >> 2] = o[k >> 2], o[M + 132 >> 2] = go, gs(E, M + 144 | 0, M + 128 | 0), go = o[M + 268 >> 2], o[T + 72 >> 2] = o[M + 264 >> 2], o[T + 76 >> 2] = go, go = o[M + 260 >> 2], o[k >> 2] = o[M + 256 >> 2], o[k + 4 >> 2] = go, go = o[T + 44 >> 2], o[M + 120 >> 2] = o[T + 40 >> 2], o[M + 124 >> 2] = go, go = o[T + 36 >> 2], o[M + 112 >> 2] = o[T + 32 >> 2], o[M + 116 >> 2] = go, go = o[T + 60 >> 2], o[M + 104 >> 2] = o[T + 56 >> 2], o[M + 108 >> 2] = go, go = o[T + 52 >> 2], o[M + 96 >> 2] = o[T + 48 >> 2], o[M + 100 >> 2] = go, gs(E, M + 112 | 0, M + 96 | 0), go = o[M + 268 >> 2], o[T + 56 >> 2] = o[M + 264 >> 2], o[T + 60 >> 2] = go, go = o[M + 260 >> 2], o[T + 48 >> 2] = o[M + 256 >> 2], o[T + 52 >> 2] = go, go = o[T + 28 >> 2], o[M + 88 >> 2] = o[T + 24 >> 2], o[M + 92 >> 2] = go, go = o[T + 20 >> 2], o[M + 80 >> 2] = o[T + 16 >> 2], o[M + 84 >> 2] = go, go = o[T + 44 >> 2], o[M + 72 >> 2] = o[T + 40 >> 2], o[M + 76 >> 2] = go, go = o[T + 36 >> 2], o[M + 64 >> 2] = o[T + 32 >> 2], o[M + 68 >> 2] = go, gs(E, M + 80 | 0, M - -64 | 0), go = o[M + 268 >> 2], o[T + 40 >> 2] = o[M + 264 >> 2], o[T + 44 >> 2] = go, go = o[M + 260 >> 2], o[T + 32 >> 2] = o[M + 256 >> 2], o[T + 36 >> 2] = go, go = o[T + 12 >> 2], o[M + 56 >> 2] = o[T + 8 >> 2], o[M + 60 >> 2] = go, go = o[T + 4 >> 2], o[M + 48 >> 2] = o[T >> 2], o[M + 52 >> 2] = go, go = o[T + 28 >> 2], o[M + 40 >> 2] = o[T + 24 >> 2], o[M + 44 >> 2] = go, go = o[T + 20 >> 2], o[M + 32 >> 2] = o[T + 16 >> 2], o[M + 36 >> 2] = go, gs(E, M + 48 | 0, M + 32 | 0), go = o[M + 268 >> 2], o[T + 24 >> 2] = o[M + 264 >> 2], o[T + 28 >> 2] = go, go = o[M + 260 >> 2], o[T + 16 >> 2] = o[M + 256 >> 2], o[T + 20 >> 2] = go, go = o[M + 284 >> 2], o[M + 24 >> 2] = o[M + 280 >> 2], o[M + 28 >> 2] = go, go = o[M + 276 >> 2], o[M + 16 >> 2] = o[M + 272 >> 2], o[M + 20 >> 2] = go, go = o[T + 12 >> 2], o[M + 8 >> 2] = o[T + 8 >> 2], o[M + 12 >> 2] = go, go = o[T + 4 >> 2], o[M >> 2] = o[T >> 2], o[M + 4 >> 2] = go, gs(E, M + 16 | 0, M), E = o[M + 268 >> 2], o[T + 8 >> 2] = o[M + 264 >> 2], o[T + 12 >> 2] = E, E = o[M + 260 >> 2], o[T >> 2] = o[M + 256 >> 2], o[T + 4 >> 2] = E, o[T + 12 >> 2] = (m[T + 12 | 0] | m[T + 13 | 0] << 8 | m[T + 14 | 0] << 16 | m[T + 15 | 0] << 24) ^ pr, o[T + 8 >> 2] = (m[T + 8 | 0] | m[T + 9 | 0] << 8 | m[T + 10 | 0] << 16 | m[T + 11 | 0] << 24) ^ Ne, o[T + 4 >> 2] = (m[T + 4 | 0] | m[T + 5 | 0] << 8 | m[T + 6 | 0] << 16 | m[T + 7 | 0] << 24) ^ ye, o[T >> 2] = (m[0 | T] | m[T + 1 | 0] << 8 | m[T + 2 | 0] << 16 | m[T + 3 | 0] << 24) ^ ti, o[k >> 2] = (m[0 | k] | m[k + 1 | 0] << 8 | m[k + 2 | 0] << 16 | m[k + 3 | 0] << 24) ^ ve, o[T + 68 >> 2] = (m[T + 68 | 0] | m[T + 69 | 0] << 8 | m[T + 70 | 0] << 16 | m[T + 71 | 0] << 24) ^ Pr, o[T + 72 >> 2] = (m[T + 72 | 0] | m[T + 73 | 0] << 8 | m[T + 74 | 0] << 16 | m[T + 75 | 0] << 24) ^ Mr, o[T + 76 >> 2] = Jr ^ (m[T + 76 | 0] | m[T + 77 | 0] << 8 | m[T + 78 | 0] << 16 | m[T + 79 | 0] << 24), dr = M + 288 | 0;
                    }
                    function yo(k, E, T, M, ye) {
                      var Ne, pr = 0, ve = 0, cr = 0, gr = 0, Pr = 0, Nr = 0, Br = 0, Mr = 0, jr = 0, ti = 0, fi = 0, Jr = 0, li = 0, Tr = 0, Mi = 0, Wi = 0;
                      for (dr = Ne = dr - 224 | 0, ti = (m[ye + 60 | 0] | m[ye + 61 | 0] << 8 | m[ye + 62 | 0] << 16 | m[ye + 63 | 0] << 24) ^ M >>> 29, fi = (m[ye + 56 | 0] | m[ye + 57 | 0] << 8 | m[ye + 58 | 0] << 16 | m[ye + 59 | 0] << 24) ^ M << 3, Nr = (m[ye + 52 | 0] | m[ye + 53 | 0] << 8 | m[ye + 54 | 0] << 16 | m[ye + 55 | 0] << 24) ^ T >>> 29, Mr = (m[0 | (pr = ye + 48 | 0)] | m[pr + 1 | 0] << 8 | m[pr + 2 | 0] << 16 | m[pr + 3 | 0] << 24) ^ T << 3, ve = ye + 16 | 0, cr = ye + 32 | 0, gr = ye - -64 | 0, Pr = ye + 80 | 0; T = o[Pr + 12 >> 2], o[Ne + 216 >> 2] = o[Pr + 8 >> 2], o[Ne + 220 >> 2] = T, T = o[Pr + 4 >> 2], o[Ne + 208 >> 2] = o[Pr >> 2], o[Ne + 212 >> 2] = T, T = o[gr + 12 >> 2], o[Ne + 184 >> 2] = o[gr + 8 >> 2], o[Ne + 188 >> 2] = T, T = o[gr + 4 >> 2], o[Ne + 176 >> 2] = o[gr >> 2], o[Ne + 180 >> 2] = T, T = o[Pr + 12 >> 2], o[Ne + 168 >> 2] = o[Pr + 8 >> 2], o[Ne + 172 >> 2] = T, T = o[Pr + 4 >> 2], o[Ne + 160 >> 2] = o[Pr >> 2], o[Ne + 164 >> 2] = T, gs(M = Ne + 192 | 0, Ne + 176 | 0, Ne + 160 | 0), T = o[Ne + 204 >> 2], o[Pr + 8 >> 2] = o[Ne + 200 >> 2], o[Pr + 12 >> 2] = T, T = o[Ne + 196 >> 2], o[Pr >> 2] = o[Ne + 192 >> 2], o[Pr + 4 >> 2] = T, T = o[pr + 12 >> 2], o[Ne + 152 >> 2] = o[pr + 8 >> 2], o[Ne + 156 >> 2] = T, T = o[pr + 4 >> 2], o[Ne + 144 >> 2] = o[pr >> 2], o[Ne + 148 >> 2] = T, T = o[gr + 12 >> 2], o[Ne + 136 >> 2] = o[gr + 8 >> 2], o[Ne + 140 >> 2] = T, T = o[gr + 4 >> 2], o[Ne + 128 >> 2] = o[gr >> 2], o[Ne + 132 >> 2] = T, gs(M, Ne + 144 | 0, Ne + 128 | 0), T = o[Ne + 204 >> 2], o[gr + 8 >> 2] = o[Ne + 200 >> 2], o[gr + 12 >> 2] = T, T = o[Ne + 196 >> 2], o[gr >> 2] = o[Ne + 192 >> 2], o[gr + 4 >> 2] = T, T = o[cr + 12 >> 2], o[Ne + 120 >> 2] = o[cr + 8 >> 2], o[Ne + 124 >> 2] = T, T = o[cr + 4 >> 2], o[Ne + 112 >> 2] = o[cr >> 2], o[Ne + 116 >> 2] = T, T = o[pr + 12 >> 2], o[Ne + 104 >> 2] = o[pr + 8 >> 2], o[Ne + 108 >> 2] = T, T = o[pr + 4 >> 2], o[Ne + 96 >> 2] = o[pr >> 2], o[Ne + 100 >> 2] = T, gs(M, Ne + 112 | 0, Ne + 96 | 0), T = o[Ne + 204 >> 2], o[pr + 8 >> 2] = o[Ne + 200 >> 2], o[pr + 12 >> 2] = T, T = o[Ne + 196 >> 2], o[pr >> 2] = o[Ne + 192 >> 2], o[pr + 4 >> 2] = T, T = o[ve + 12 >> 2], o[Ne + 88 >> 2] = o[ve + 8 >> 2], o[Ne + 92 >> 2] = T, T = o[ve + 4 >> 2], o[Ne + 80 >> 2] = o[ve >> 2], o[Ne + 84 >> 2] = T, T = o[cr + 12 >> 2], o[Ne + 72 >> 2] = o[cr + 8 >> 2], o[Ne + 76 >> 2] = T, T = o[cr + 4 >> 2], o[Ne + 64 >> 2] = o[cr >> 2], o[Ne + 68 >> 2] = T, gs(M, Ne + 80 | 0, Ne - -64 | 0), T = o[Ne + 204 >> 2], o[cr + 8 >> 2] = o[Ne + 200 >> 2], o[cr + 12 >> 2] = T, T = o[Ne + 196 >> 2], o[cr >> 2] = o[Ne + 192 >> 2], o[cr + 4 >> 2] = T, T = o[ye + 12 >> 2], o[Ne + 56 >> 2] = o[ye + 8 >> 2], o[Ne + 60 >> 2] = T, T = o[ye + 4 >> 2], o[Ne + 48 >> 2] = o[ye >> 2], o[Ne + 52 >> 2] = T, T = o[ve + 12 >> 2], o[Ne + 40 >> 2] = o[ve + 8 >> 2], o[Ne + 44 >> 2] = T, T = o[ve + 4 >> 2], o[Ne + 32 >> 2] = o[ve >> 2], o[Ne + 36 >> 2] = T, gs(M, Ne + 48 | 0, Ne + 32 | 0), T = o[Ne + 204 >> 2], o[ve + 8 >> 2] = o[Ne + 200 >> 2], o[ve + 12 >> 2] = T, T = o[Ne + 196 >> 2], o[ve >> 2] = o[Ne + 192 >> 2], o[ve + 4 >> 2] = T, T = o[Ne + 220 >> 2], o[Ne + 24 >> 2] = o[Ne + 216 >> 2], o[Ne + 28 >> 2] = T, T = o[Ne + 212 >> 2], o[Ne + 16 >> 2] = o[Ne + 208 >> 2], o[Ne + 20 >> 2] = T, T = o[ye + 12 >> 2], o[Ne + 8 >> 2] = o[ye + 8 >> 2], o[Ne + 12 >> 2] = T, T = o[ye + 4 >> 2], o[Ne >> 2] = o[ye >> 2], o[Ne + 4 >> 2] = T, gs(M, Ne + 16 | 0, Ne), jr = o[Ne + 192 >> 2], M = o[Ne + 196 >> 2], T = o[Ne + 200 >> 2], Jr = ti ^ o[Ne + 204 >> 2], o[ye + 12 >> 2] = Jr, li = T ^ fi, o[ye + 8 >> 2] = li, Tr = M ^ Nr, o[ye + 4 >> 2] = Tr, Mi = Mr ^ jr, o[ye >> 2] = Mi, (0 | (Br = Br + 1 | 0)) != 7; ) ;
                      e: {
                        t: {
                          r: {
                            if (T = E - 16 | 0) {
                              if ((0 | T) == 16) break r;
                              break t;
                            }
                            Wi = m[ye + 16 | 0] | m[ye + 17 | 0] << 8 | m[ye + 18 | 0] << 16 | m[ye + 19 | 0] << 24, pr = m[ye + 48 | 0] | m[ye + 49 | 0] << 8 | m[ye + 50 | 0] << 16 | m[ye + 51 | 0] << 24, ve = m[ye + 32 | 0] | m[ye + 33 | 0] << 8 | m[ye + 34 | 0] << 16 | m[ye + 35 | 0] << 24, cr = m[ye + 80 | 0] | m[ye + 81 | 0] << 8 | m[ye + 82 | 0] << 16 | m[ye + 83 | 0] << 24, gr = m[0 | (E = ye - -64 | 0)] | m[E + 1 | 0] << 8 | m[E + 2 | 0] << 16 | m[E + 3 | 0] << 24, Pr = m[ye + 20 | 0] | m[ye + 21 | 0] << 8 | m[ye + 22 | 0] << 16 | m[ye + 23 | 0] << 24, ti = m[ye + 52 | 0] | m[ye + 53 | 0] << 8 | m[ye + 54 | 0] << 16 | m[ye + 55 | 0] << 24, fi = m[ye + 36 | 0] | m[ye + 37 | 0] << 8 | m[ye + 38 | 0] << 16 | m[ye + 39 | 0] << 24, Nr = m[ye + 84 | 0] | m[ye + 85 | 0] << 8 | m[ye + 86 | 0] << 16 | m[ye + 87 | 0] << 24, Mr = m[ye + 68 | 0] | m[ye + 69 | 0] << 8 | m[ye + 70 | 0] << 16 | m[ye + 71 | 0] << 24, jr = m[ye + 24 | 0] | m[ye + 25 | 0] << 8 | m[ye + 26 | 0] << 16 | m[ye + 27 | 0] << 24, Br = m[ye + 56 | 0] | m[ye + 57 | 0] << 8 | m[ye + 58 | 0] << 16 | m[ye + 59 | 0] << 24, M = m[ye + 40 | 0] | m[ye + 41 | 0] << 8 | m[ye + 42 | 0] << 16 | m[ye + 43 | 0] << 24, T = m[ye + 88 | 0] | m[ye + 89 | 0] << 8 | m[ye + 90 | 0] << 16 | m[ye + 91 | 0] << 24, E = m[ye + 72 | 0] | m[ye + 73 | 0] << 8 | m[ye + 74 | 0] << 16 | m[ye + 75 | 0] << 24, ye = Jr ^ (m[ye + 28 | 0] | m[ye + 29 | 0] << 8 | m[ye + 30 | 0] << 16 | m[ye + 31 | 0] << 24) ^ (m[ye + 60 | 0] | m[ye + 61 | 0] << 8 | m[ye + 62 | 0] << 16 | m[ye + 63 | 0] << 24) ^ (m[ye + 44 | 0] | m[ye + 45 | 0] << 8 | m[ye + 46 | 0] << 16 | m[ye + 47 | 0] << 24) ^ (m[ye + 92 | 0] | m[ye + 93 | 0] << 8 | m[ye + 94 | 0] << 16 | m[ye + 95 | 0] << 24) ^ (m[ye + 76 | 0] | m[ye + 77 | 0] << 8 | m[ye + 78 | 0] << 16 | m[ye + 79 | 0] << 24), B[k + 12 | 0] = ye, B[k + 13 | 0] = ye >>> 8, B[k + 14 | 0] = ye >>> 16, B[k + 15 | 0] = ye >>> 24, E = li ^ jr ^ E ^ T ^ M ^ Br, B[k + 8 | 0] = E, B[k + 9 | 0] = E >>> 8, B[k + 10 | 0] = E >>> 16, B[k + 11 | 0] = E >>> 24, E = Tr ^ Pr ^ ti ^ fi ^ Nr ^ Mr, B[k + 4 | 0] = E, B[k + 5 | 0] = E >>> 8, B[k + 6 | 0] = E >>> 16, B[k + 7 | 0] = E >>> 24, E = Mi ^ Wi ^ pr ^ ve ^ cr ^ gr, B[0 | k] = E, B[k + 1 | 0] = E >>> 8, B[k + 2 | 0] = E >>> 16, B[k + 3 | 0] = E >>> 24;
                            break e;
                          }
                          Mr = m[ye + 32 | 0] | m[ye + 33 | 0] << 8 | m[ye + 34 | 0] << 16 | m[ye + 35 | 0] << 24, jr = m[ye + 16 | 0] | m[ye + 17 | 0] << 8 | m[ye + 18 | 0] << 16 | m[ye + 19 | 0] << 24, Br = m[ye + 36 | 0] | m[ye + 37 | 0] << 8 | m[ye + 38 | 0] << 16 | m[ye + 39 | 0] << 24, M = m[ye + 20 | 0] | m[ye + 21 | 0] << 8 | m[ye + 22 | 0] << 16 | m[ye + 23 | 0] << 24, T = m[ye + 40 | 0] | m[ye + 41 | 0] << 8 | m[ye + 42 | 0] << 16 | m[ye + 43 | 0] << 24, E = m[ye + 24 | 0] | m[ye + 25 | 0] << 8 | m[ye + 26 | 0] << 16 | m[ye + 27 | 0] << 24, Nr = Jr ^ (m[ye + 44 | 0] | m[ye + 45 | 0] << 8 | m[ye + 46 | 0] << 16 | m[ye + 47 | 0] << 24) ^ (m[ye + 28 | 0] | m[ye + 29 | 0] << 8 | m[ye + 30 | 0] << 16 | m[ye + 31 | 0] << 24), B[k + 12 | 0] = Nr, B[k + 13 | 0] = Nr >>> 8, B[k + 14 | 0] = Nr >>> 16, B[k + 15 | 0] = Nr >>> 24, E = li ^ E ^ T, B[k + 8 | 0] = E, B[k + 9 | 0] = E >>> 8, B[k + 10 | 0] = E >>> 16, B[k + 11 | 0] = E >>> 24, E = Tr ^ M ^ Br, B[k + 4 | 0] = E, B[k + 5 | 0] = E >>> 8, B[k + 6 | 0] = E >>> 16, B[k + 7 | 0] = E >>> 24, E = Mi ^ Mr ^ jr, B[0 | k] = E, B[k + 1 | 0] = E >>> 8, B[k + 2 | 0] = E >>> 16, B[k + 3 | 0] = E >>> 24, ti = m[ye + 48 | 0] | m[ye + 49 | 0] << 8 | m[ye + 50 | 0] << 16 | m[ye + 51 | 0] << 24, fi = m[ye + 80 | 0] | m[ye + 81 | 0] << 8 | m[ye + 82 | 0] << 16 | m[ye + 83 | 0] << 24, Nr = m[0 | (E = ye - -64 | 0)] | m[E + 1 | 0] << 8 | m[E + 2 | 0] << 16 | m[E + 3 | 0] << 24, Mr = m[ye + 52 | 0] | m[ye + 53 | 0] << 8 | m[ye + 54 | 0] << 16 | m[ye + 55 | 0] << 24, jr = m[ye + 84 | 0] | m[ye + 85 | 0] << 8 | m[ye + 86 | 0] << 16 | m[ye + 87 | 0] << 24, Br = m[ye + 68 | 0] | m[ye + 69 | 0] << 8 | m[ye + 70 | 0] << 16 | m[ye + 71 | 0] << 24, M = m[ye + 56 | 0] | m[ye + 57 | 0] << 8 | m[ye + 58 | 0] << 16 | m[ye + 59 | 0] << 24, T = m[ye + 88 | 0] | m[ye + 89 | 0] << 8 | m[ye + 90 | 0] << 16 | m[ye + 91 | 0] << 24, E = m[ye + 72 | 0] | m[ye + 73 | 0] << 8 | m[ye + 74 | 0] << 16 | m[ye + 75 | 0] << 24, ye = (m[ye + 60 | 0] | m[ye + 61 | 0] << 8 | m[ye + 62 | 0] << 16 | m[ye + 63 | 0] << 24) ^ (m[ye + 92 | 0] | m[ye + 93 | 0] << 8 | m[ye + 94 | 0] << 16 | m[ye + 95 | 0] << 24) ^ (m[ye + 76 | 0] | m[ye + 77 | 0] << 8 | m[ye + 78 | 0] << 16 | m[ye + 79 | 0] << 24), B[k + 28 | 0] = ye, B[k + 29 | 0] = ye >>> 8, B[k + 30 | 0] = ye >>> 16, B[k + 31 | 0] = ye >>> 24, E = M ^ E ^ T, B[k + 24 | 0] = E, B[k + 25 | 0] = E >>> 8, B[k + 26 | 0] = E >>> 16, B[k + 27 | 0] = E >>> 24, E = Mr ^ jr ^ Br, B[k + 20 | 0] = E, B[k + 21 | 0] = E >>> 8, B[k + 22 | 0] = E >>> 16, B[k + 23 | 0] = E >>> 24, E = ti ^ Nr ^ fi, B[k + 16 | 0] = E, B[k + 17 | 0] = E >>> 8, B[k + 18 | 0] = E >>> 16, B[k + 19 | 0] = E >>> 24;
                          break e;
                        }
                        Ca(k, 0, E);
                      }
                      dr = Ne + 224 | 0;
                    }
                    function Io(k, E, T) {
                      var M, ye = 0, Ne = 0, pr = 0, ve = 0, cr = 0, gr = 0, Pr = 0, Nr = 0, Br = 0, Mr = 0, jr = 0, ti = 0, fi = 0, Jr = 0, li = 0, Tr = 0, Mi = 0, Wi = 0;
                      for (dr = M = dr - 4032 | 0, $a(M + 160 | 0, T), ve = o[T + 36 >> 2], o[(pr = M + 3840 | 0) >> 2] = o[T + 32 >> 2], o[pr + 4 >> 2] = ve, cr = o[T + 28 >> 2], o[(ve = M + 3832 | 0) >> 2] = o[T + 24 >> 2], o[ve + 4 >> 2] = cr, Pr = o[T + 20 >> 2], o[(cr = M + 3824 | 0) >> 2] = o[T + 16 >> 2], o[cr + 4 >> 2] = Pr, Nr = o[T + 12 >> 2], o[(Pr = M + 3816 | 0) >> 2] = o[T + 8 >> 2], o[Pr + 4 >> 2] = Nr, Nr = o[T + 4 >> 2], o[M + 3808 >> 2] = o[T >> 2], o[M + 3812 >> 2] = Nr, jr = o[T + 52 >> 2], o[(Nr = M + 3856 | 0) >> 2] = o[T + 48 >> 2], o[Nr + 4 >> 2] = jr, Jr = o[T + 60 >> 2], o[(jr = M + 3864 | 0) >> 2] = o[T + 56 >> 2], o[jr + 4 >> 2] = Jr, Br = o[4 + (ti = T - -64 | 0) >> 2], o[(Jr = M + 3872 | 0) >> 2] = o[ti >> 2], o[Jr + 4 >> 2] = Br, Br = o[T + 76 >> 2], o[(ti = M + 3880 | 0) >> 2] = o[T + 72 >> 2], o[ti + 4 >> 2] = Br, Br = o[T + 44 >> 2], o[M + 3848 >> 2] = o[T + 40 >> 2], o[M + 3852 >> 2] = Br, li = o[T + 92 >> 2], o[(Br = M + 3896 | 0) >> 2] = o[T + 88 >> 2], o[Br + 4 >> 2] = li, Tr = o[T + 100 >> 2], o[(li = M + 3904 | 0) >> 2] = o[T + 96 >> 2], o[li + 4 >> 2] = Tr, Mi = o[T + 108 >> 2], o[(Tr = M + 3912 | 0) >> 2] = o[T + 104 >> 2], o[Tr + 4 >> 2] = Mi, Wi = o[T + 116 >> 2], o[(Mi = M + 3920 | 0) >> 2] = o[T + 112 >> 2], o[Mi + 4 >> 2] = Wi, Wi = o[T + 84 >> 2], o[M + 3888 >> 2] = o[T + 80 >> 2], o[M + 3892 >> 2] = Wi, Oa(ye = M + 3528 | 0, Wi = M + 3808 | 0), Ti(Ne = M + 2408 | 0, ye, gr = M + 3648 | 0), Ti(M + 2448 | 0, Mr = M + 3568 | 0, fi = M + 3608 | 0), Ti(M + 2488 | 0, fi, gr), Ti(M + 2528 | 0, ye, Mr), $a(gr = M + 320 | 0, Ne), Aa(ye = M + 3368 | 0, T, gr), Ti(Ne = M + 2248 | 0, ye, gr = M + 3488 | 0), Ti(M + 2288 | 0, Mr = M + 3408 | 0, fi = M + 3448 | 0), Ti(M + 2328 | 0, fi, gr), Ti(M + 2368 | 0, ye, Mr), $a(M + 480 | 0, Ne), Ne = o[4 + (ye = M + 2440 | 0) >> 2], o[pr >> 2] = o[ye >> 2], o[pr + 4 >> 2] = Ne, Ne = o[4 + (ye = M + 2432 | 0) >> 2], o[ve >> 2] = o[ye >> 2], o[ve + 4 >> 2] = Ne, Ne = o[4 + (ye = M + 2424 | 0) >> 2], o[cr >> 2] = o[ye >> 2], o[cr + 4 >> 2] = Ne, Ne = o[4 + (ye = M + 2416 | 0) >> 2], o[Pr >> 2] = o[ye >> 2], o[Pr + 4 >> 2] = Ne, Ne = o[4 + (ye = M + 2456 | 0) >> 2], o[Nr >> 2] = o[ye >> 2], o[Nr + 4 >> 2] = Ne, Ne = o[4 + (ye = M + 2464 | 0) >> 2], o[jr >> 2] = o[ye >> 2], o[jr + 4 >> 2] = Ne, Ne = o[4 + (ye = M + 2472 | 0) >> 2], o[Jr >> 2] = o[ye >> 2], o[Jr + 4 >> 2] = Ne, Ne = o[4 + (ye = M + 2480 | 0) >> 2], o[ti >> 2] = o[ye >> 2], o[ti + 4 >> 2] = Ne, ye = o[M + 2412 >> 2], o[M + 3808 >> 2] = o[M + 2408 >> 2], o[M + 3812 >> 2] = ye, ye = o[M + 2452 >> 2], o[M + 3848 >> 2] = o[M + 2448 >> 2], o[M + 3852 >> 2] = ye, Ne = o[4 + (ye = M + 2520 | 0) >> 2], o[Mi >> 2] = o[ye >> 2], o[Mi + 4 >> 2] = Ne, Ne = o[4 + (ye = M + 2512 | 0) >> 2], o[Tr >> 2] = o[ye >> 2], o[Tr + 4 >> 2] = Ne, Ne = o[4 + (ye = M + 2504 | 0) >> 2], o[li >> 2] = o[ye >> 2], o[li + 4 >> 2] = Ne, Ne = o[4 + (ye = M + 2496 | 0) >> 2], o[Br >> 2] = o[ye >> 2], o[Br + 4 >> 2] = Ne, ye = o[M + 2492 >> 2], o[M + 3888 >> 2] = o[M + 2488 >> 2], o[M + 3892 >> 2] = ye, Oa(ye = M + 3208 | 0, Wi), Ti(Ne = M + 2088 | 0, ye, gr = M + 3328 | 0), Ti(M + 2128 | 0, Mr = M + 3248 | 0, fi = M + 3288 | 0), Ti(M + 2168 | 0, fi, gr), Ti(M + 2208 | 0, ye, Mr), $a(gr = M + 640 | 0, Ne), Aa(ye = M + 3048 | 0, T, gr), Ti(Ne = M + 1928 | 0, ye, gr = M + 3168 | 0), Ti(M + 1968 | 0, Mr = M + 3088 | 0, fi = M + 3128 | 0), Ti(M + 2008 | 0, fi, gr), Ti(M + 2048 | 0, ye, Mr), $a(M + 800 | 0, Ne), Ne = o[4 + (ye = M + 2280 | 0) >> 2], o[pr >> 2] = o[ye >> 2], o[pr + 4 >> 2] = Ne, Ne = o[4 + (ye = M + 2272 | 0) >> 2], o[ve >> 2] = o[ye >> 2], o[ve + 4 >> 2] = Ne, Ne = o[4 + (ye = M + 2264 | 0) >> 2], o[cr >> 2] = o[ye >> 2], o[cr + 4 >> 2] = Ne, Ne = o[4 + (ye = M + 2256 | 0) >> 2], o[Pr >> 2] = o[ye >> 2], o[Pr + 4 >> 2] = Ne, Ne = o[4 + (ye = M + 2296 | 0) >> 2], o[Nr >> 2] = o[ye >> 2], o[Nr + 4 >> 2] = Ne, Ne = o[4 + (ye = M + 2304 | 0) >> 2], o[jr >> 2] = o[ye >> 2], o[jr + 4 >> 2] = Ne, Ne = o[4 + (ye = M + 2312 | 0) >> 2], o[Jr >> 2] = o[ye >> 2], o[Jr + 4 >> 2] = Ne, Ne = o[4 + (ye = M + 2320 | 0) >> 2], o[ti >> 2] = o[ye >> 2], o[ti + 4 >> 2] = Ne, ye = o[M + 2252 >> 2], o[M + 3808 >> 2] = o[M + 2248 >> 2], o[M + 3812 >> 2] = ye, ye = o[M + 2292 >> 2], o[M + 3848 >> 2] = o[M + 2288 >> 2], o[M + 3852 >> 2] = ye, Ne = o[4 + (ye = M + 2360 | 0) >> 2], o[Mi >> 2] = o[ye >> 2], o[Mi + 4 >> 2] = Ne, Ne = o[4 + (ye = M + 2352 | 0) >> 2], o[Tr >> 2] = o[ye >> 2], o[Tr + 4 >> 2] = Ne, Ne = o[4 + (ye = M + 2344 | 0) >> 2], o[li >> 2] = o[ye >> 2], o[li + 4 >> 2] = Ne, Ne = o[4 + (ye = M + 2336 | 0) >> 2], o[Br >> 2] = o[ye >> 2], o[Br + 4 >> 2] = Ne, ye = o[M + 2332 >> 2], o[M + 3888 >> 2] = o[M + 2328 >> 2], o[M + 3892 >> 2] = ye, Oa(ye = M + 2888 | 0, Wi), Ti(Ne = M + 1768 | 0, ye, gr = M + 3008 | 0), Ti(M + 1808 | 0, Mr = M + 2928 | 0, fi = M + 2968 | 0), Ti(M + 1848 | 0, fi, gr), Ti(M + 1888 | 0, ye, Mr), $a(gr = M + 960 | 0, Ne), Aa(ye = M + 2728 | 0, T, gr), Ti(T = M + 1608 | 0, ye, Ne = M + 2848 | 0), Ti(M + 1648 | 0, gr = M + 2768 | 0, Mr = M + 2808 | 0), Ti(M + 1688 | 0, Mr, Ne), Ti(M + 1728 | 0, ye, gr), $a(M + 1120 | 0, T), ye = o[4 + (T = M + 2120 | 0) >> 2], o[pr >> 2] = o[T >> 2], o[pr + 4 >> 2] = ye, pr = o[4 + (T = M + 2112 | 0) >> 2], o[ve >> 2] = o[T >> 2], o[ve + 4 >> 2] = pr, pr = o[4 + (T = M + 2104 | 0) >> 2], o[cr >> 2] = o[T >> 2], o[cr + 4 >> 2] = pr, pr = o[4 + (T = M + 2096 | 0) >> 2], o[Pr >> 2] = o[T >> 2], o[Pr + 4 >> 2] = pr, pr = o[4 + (T = M + 2136 | 0) >> 2], o[Nr >> 2] = o[T >> 2], o[Nr + 4 >> 2] = pr, pr = o[4 + (T = M + 2144 | 0) >> 2], o[jr >> 2] = o[T >> 2], o[jr + 4 >> 2] = pr, pr = o[4 + (T = M + 2152 | 0) >> 2], o[Jr >> 2] = o[T >> 2], o[Jr + 4 >> 2] = pr, pr = o[4 + (T = M + 2160 | 0) >> 2], o[ti >> 2] = o[T >> 2], o[ti + 4 >> 2] = pr, T = o[M + 2092 >> 2], o[M + 3808 >> 2] = o[M + 2088 >> 2], o[M + 3812 >> 2] = T, T = o[M + 2132 >> 2], o[M + 3848 >> 2] = o[M + 2128 >> 2], o[M + 3852 >> 2] = T, pr = o[4 + (T = M + 2200 | 0) >> 2], o[Mi >> 2] = o[T >> 2], o[Mi + 4 >> 2] = pr, pr = o[4 + (T = M + 2192 | 0) >> 2], o[Tr >> 2] = o[T >> 2], o[Tr + 4 >> 2] = pr, pr = o[4 + (T = M + 2184 | 0) >> 2], o[li >> 2] = o[T >> 2], o[li + 4 >> 2] = pr, pr = o[4 + (T = M + 2176 | 0) >> 2], o[Br >> 2] = o[T >> 2], o[Br + 4 >> 2] = pr, T = o[M + 2172 >> 2], o[M + 3888 >> 2] = o[M + 2168 >> 2], o[M + 3892 >> 2] = T, Oa(T = M + 2568 | 0, Wi), Ti(pr = M + 1448 | 0, T, ve = M + 2688 | 0), Ti(M + 1488 | 0, cr = M + 2608 | 0, Pr = M + 2648 | 0), Ti(M + 1528 | 0, Pr, ve), Ti(M + 1568 | 0, T, cr), $a(M + 1280 | 0, pr), pr = 0, T = 0; cr = (ve = M + 3968 | 0) + (T << 1) | 0, Pr = m[E + T | 0], B[cr + 1 | 0] = Pr >>> 4, B[0 | cr] = 15 & Pr, ve = ve + ((cr = 1 | T) << 1) | 0, cr = m[E + cr | 0], B[ve + 1 | 0] = cr >>> 4, B[0 | ve] = 15 & cr, (0 | (T = T + 2 | 0)) != 32; ) ;
                      for (E = 0; T = 8 + (ve = (T = E) + m[0 | (E = (M + 3968 | 0) + pr | 0)] | 0) | 0, B[0 | E] = ve - (240 & T), T = 8 + (ve = m[E + 1 | 0] + (T << 24 >> 24 >> 4) | 0) | 0, B[E + 1 | 0] = ve - (240 & T), T = 8 + (ve = m[E + 2 | 0] + (T << 24 >> 24 >> 4) | 0) | 0, B[E + 2 | 0] = ve - (240 & T), E = T << 24 >> 24 >> 4, (0 | (pr = pr + 3 | 0)) != 63; ) ;
                      for (B[M + 4031 | 0] = m[M + 4031 | 0] + E, o[k + 32 >> 2] = 0, o[k + 36 >> 2] = 0, o[k + 24 >> 2] = 0, o[k + 28 >> 2] = 0, o[k + 16 >> 2] = 0, o[k + 20 >> 2] = 0, o[k + 8 >> 2] = 0, o[k + 12 >> 2] = 0, o[k >> 2] = 0, o[k + 4 >> 2] = 0, o[k + 44 >> 2] = 0, o[k + 48 >> 2] = 0, o[k + 40 >> 2] = 1, o[k + 52 >> 2] = 0, o[k + 56 >> 2] = 0, o[k + 60 >> 2] = 0, o[k + 64 >> 2] = 0, o[k + 68 >> 2] = 0, o[k + 72 >> 2] = 0, o[k + 76 >> 2] = 0, o[k + 80 >> 2] = 1, Ca(k + 84 | 0, 0, 76), Jr = k + 120 | 0, ti = k + 80 | 0, Br = k + 40 | 0, Pr = M + 3768 | 0, T = M + 3888 | 0, ve = M + 3848 | 0, Nr = M + 3728 | 0, pr = M + 3928 | 0, jr = 63; Cu(M, li = M + 160 | 0, B[(M + 3968 | 0) + jr | 0]), Aa(E = M + 3808 | 0, k, M), Ti(cr = M + 3688 | 0, E, pr), Ti(Nr, ve, T), Ti(Pr, T, pr), Oa(E, cr), Ti(cr, E, pr), Ti(Nr, ve, T), Ti(Pr, T, pr), Oa(E, cr), Ti(cr, E, pr), Ti(Nr, ve, T), Ti(Pr, T, pr), Oa(E, cr), Ti(cr, E, pr), Ti(Nr, ve, T), Ti(Pr, T, pr), Oa(E, cr), Ti(k, E, pr), Ti(Br, ve, T), Ti(ti, T, pr), Ti(Jr, E, ve), jr = jr - 1 | 0; ) ;
                      Cu(M, li, B[M + 3968 | 0]), Aa(E, k, M), Ti(k, E, pr), Ti(Br, ve, T), Ti(ti, T, pr), Ti(Jr, E, ve), dr = M + 4032 | 0;
                    }
                    function xo(k, E, T, M) {
                      var ye, Ne, pr, ve, cr, gr, Pr, Nr, Br, Mr, jr, ti, fi, Jr, li, Tr, Mi, Wi, vn, Tn, Ni, Yi, Xi = 0, $n = 0, Zn = 0, to = 0, fo = 0, wo = 0, bo = 0, go = 0;
                      dr = ye = dr - 320 | 0, o[ye + 280 >> 2] = 0, o[ye + 284 >> 2] = 0, o[ye + 272 >> 2] = 0, o[ye + 276 >> 2] = 0, o[ye + 264 >> 2] = 0, o[ye + 268 >> 2] = 0, o[ye + 256 >> 2] = 0, o[ye + 260 >> 2] = 0, fa($n = ye + 256 | 0, E, T), go = m[M + 16 | 0] | m[M + 17 | 0] << 8 | m[M + 18 | 0] << 16 | m[M + 19 | 0] << 24, Xi = m[M + 48 | 0] | m[M + 49 | 0] << 8 | m[M + 50 | 0] << 16 | m[M + 51 | 0] << 24, ve = m[M + 20 | 0] | m[M + 21 | 0] << 8 | m[M + 22 | 0] << 16 | m[M + 23 | 0] << 24, cr = m[M + 52 | 0] | m[M + 53 | 0] << 8 | m[M + 54 | 0] << 16 | m[M + 55 | 0] << 24, gr = m[M + 24 | 0] | m[M + 25 | 0] << 8 | m[M + 26 | 0] << 16 | m[M + 27 | 0] << 24, Pr = m[M + 56 | 0] | m[M + 57 | 0] << 8 | m[M + 58 | 0] << 16 | m[M + 59 | 0] << 24, Nr = m[M + 28 | 0] | m[M + 29 | 0] << 8 | m[M + 30 | 0] << 16 | m[M + 31 | 0] << 24, Br = m[M + 60 | 0] | m[M + 61 | 0] << 8 | m[M + 62 | 0] << 16 | m[M + 63 | 0] << 24, E = m[M + 36 | 0] | m[M + 37 | 0] << 8 | m[M + 38 | 0] << 16 | m[M + 39 | 0] << 24, Mr = m[M + 84 | 0] | m[M + 85 | 0] << 8 | m[M + 86 | 0] << 16 | m[M + 87 | 0] << 24, jr = m[M + 116 | 0] | m[M + 117 | 0] << 8 | m[M + 118 | 0] << 16 | m[M + 119 | 0] << 24, Zn = m[M + 100 | 0] | m[M + 101 | 0] << 8 | m[M + 102 | 0] << 16 | m[M + 103 | 0] << 24, to = m[M + 44 | 0] | m[M + 45 | 0] << 8 | m[M + 46 | 0] << 16 | m[M + 47 | 0] << 24, ti = m[M + 92 | 0] | m[M + 93 | 0] << 8 | m[M + 94 | 0] << 16 | m[M + 95 | 0] << 24, fi = m[M + 124 | 0] | m[M + 125 | 0] << 8 | m[M + 126 | 0] << 16 | m[M + 127 | 0] << 24, fo = m[M + 108 | 0] | m[M + 109 | 0] << 8 | m[M + 110 | 0] << 16 | m[M + 111 | 0] << 24, wo = m[M + 32 | 0] | m[M + 33 | 0] << 8 | m[M + 34 | 0] << 16 | m[M + 35 | 0] << 24, Jr = m[M + 80 | 0] | m[M + 81 | 0] << 8 | m[M + 82 | 0] << 16 | m[M + 83 | 0] << 24, li = m[M + 112 | 0] | m[M + 113 | 0] << 8 | m[M + 114 | 0] << 16 | m[M + 115 | 0] << 24, bo = m[M + 96 | 0] | m[M + 97 | 0] << 8 | m[M + 98 | 0] << 16 | m[M + 99 | 0] << 24, Tr = o[ye + 272 >> 2], Mi = o[ye + 256 >> 2], Wi = o[ye + 260 >> 2], vn = o[ye + 264 >> 2], Tn = o[ye + 268 >> 2], Ni = o[ye + 276 >> 2], Yi = o[ye + 284 >> 2], Ne = m[M + 40 | 0] | m[M + 41 | 0] << 8 | m[M + 42 | 0] << 16 | m[M + 43 | 0] << 24, pr = m[M + 104 | 0] | m[M + 105 | 0] << 8 | m[M + 106 | 0] << 16 | m[M + 107 | 0] << 24, o[ye + 280 >> 2] = Ne ^ pr & (m[M + 120 | 0] | m[M + 121 | 0] << 8 | m[M + 122 | 0] << 16 | m[M + 123 | 0] << 24) ^ o[ye + 280 >> 2] ^ (m[M + 88 | 0] | m[M + 89 | 0] << 8 | m[M + 90 | 0] << 16 | m[M + 91 | 0] << 24), o[ye + 272 >> 2] = wo ^ bo & li ^ Jr ^ Tr, o[ye + 284 >> 2] = to ^ fo & fi ^ ti ^ Yi, o[ye + 276 >> 2] = E ^ Zn & jr ^ Mr ^ Ni, o[ye + 268 >> 2] = fo ^ to & Br ^ Nr ^ Tn, o[ye + 264 >> 2] = Pr & Ne ^ gr ^ vn ^ pr, o[ye + 260 >> 2] = Zn ^ E & cr ^ ve ^ Wi, o[ye + 256 >> 2] = bo ^ Xi & wo ^ go ^ Mi, Ca(T + $n | 0, 0, 32 - T | 0), fa(k, $n, T), T = o[ye + 280 >> 2], $n = o[ye + 272 >> 2], Zn = o[ye + 284 >> 2], to = o[ye + 276 >> 2], fo = o[ye + 256 >> 2], wo = o[ye + 260 >> 2], bo = o[ye + 264 >> 2], go = o[ye + 268 >> 2], k = o[M + 124 >> 2], o[ye + 312 >> 2] = o[M + 120 >> 2], o[ye + 316 >> 2] = k, k = o[M + 116 >> 2], o[ye + 304 >> 2] = o[M + 112 >> 2], o[ye + 308 >> 2] = k, k = o[M + 108 >> 2], o[ye + 248 >> 2] = o[M + 104 >> 2], o[ye + 252 >> 2] = k, k = o[M + 100 >> 2], o[ye + 240 >> 2] = o[M + 96 >> 2], o[ye + 244 >> 2] = k, k = o[M + 124 >> 2], o[ye + 232 >> 2] = o[M + 120 >> 2], o[ye + 236 >> 2] = k, k = o[M + 116 >> 2], o[ye + 224 >> 2] = o[M + 112 >> 2], o[ye + 228 >> 2] = k, gs(E = ye + 288 | 0, ye + 240 | 0, ye + 224 | 0), k = o[ye + 300 >> 2], o[M + 120 >> 2] = o[ye + 296 >> 2], o[M + 124 >> 2] = k, k = o[ye + 292 >> 2], o[M + 112 >> 2] = o[ye + 288 >> 2], o[M + 116 >> 2] = k, k = o[M + 92 >> 2], o[ye + 216 >> 2] = o[M + 88 >> 2], o[ye + 220 >> 2] = k, k = o[M + 84 >> 2], o[ye + 208 >> 2] = o[M + 80 >> 2], o[ye + 212 >> 2] = k, k = o[M + 108 >> 2], o[ye + 200 >> 2] = o[M + 104 >> 2], o[ye + 204 >> 2] = k, k = o[M + 100 >> 2], o[ye + 192 >> 2] = o[M + 96 >> 2], o[ye + 196 >> 2] = k, gs(E, ye + 208 | 0, ye + 192 | 0), k = o[ye + 300 >> 2], o[M + 104 >> 2] = o[ye + 296 >> 2], o[M + 108 >> 2] = k, k = o[ye + 292 >> 2], o[M + 96 >> 2] = o[ye + 288 >> 2], o[M + 100 >> 2] = k, k = o[M + 76 >> 2], o[ye + 184 >> 2] = o[M + 72 >> 2], o[ye + 188 >> 2] = k, Xi = o[4 + (k = M - -64 | 0) >> 2], o[ye + 176 >> 2] = o[k >> 2], o[ye + 180 >> 2] = Xi, Xi = o[M + 92 >> 2], o[ye + 168 >> 2] = o[M + 88 >> 2], o[ye + 172 >> 2] = Xi, Xi = o[M + 84 >> 2], o[ye + 160 >> 2] = o[M + 80 >> 2], o[ye + 164 >> 2] = Xi, gs(E, ye + 176 | 0, ye + 160 | 0), Xi = o[ye + 300 >> 2], o[M + 88 >> 2] = o[ye + 296 >> 2], o[M + 92 >> 2] = Xi, Xi = o[ye + 292 >> 2], o[M + 80 >> 2] = o[ye + 288 >> 2], o[M + 84 >> 2] = Xi, Xi = o[M + 60 >> 2], o[ye + 152 >> 2] = o[M + 56 >> 2], o[ye + 156 >> 2] = Xi, Xi = o[M + 52 >> 2], o[ye + 144 >> 2] = o[M + 48 >> 2], o[ye + 148 >> 2] = Xi, Xi = o[M + 76 >> 2], o[ye + 136 >> 2] = o[M + 72 >> 2], o[ye + 140 >> 2] = Xi, Xi = o[k + 4 >> 2], o[ye + 128 >> 2] = o[k >> 2], o[ye + 132 >> 2] = Xi, gs(E, ye + 144 | 0, ye + 128 | 0), Xi = o[ye + 300 >> 2], o[M + 72 >> 2] = o[ye + 296 >> 2], o[M + 76 >> 2] = Xi, Xi = o[ye + 292 >> 2], o[k >> 2] = o[ye + 288 >> 2], o[k + 4 >> 2] = Xi, Xi = o[M + 44 >> 2], o[ye + 120 >> 2] = o[M + 40 >> 2], o[ye + 124 >> 2] = Xi, Xi = o[M + 36 >> 2], o[ye + 112 >> 2] = o[M + 32 >> 2], o[ye + 116 >> 2] = Xi, Xi = o[M + 60 >> 2], o[ye + 104 >> 2] = o[M + 56 >> 2], o[ye + 108 >> 2] = Xi, Xi = o[M + 52 >> 2], o[ye + 96 >> 2] = o[M + 48 >> 2], o[ye + 100 >> 2] = Xi, gs(E, ye + 112 | 0, ye + 96 | 0), Xi = o[ye + 300 >> 2], o[M + 56 >> 2] = o[ye + 296 >> 2], o[M + 60 >> 2] = Xi, Xi = o[ye + 292 >> 2], o[M + 48 >> 2] = o[ye + 288 >> 2], o[M + 52 >> 2] = Xi, Xi = o[M + 28 >> 2], o[ye + 88 >> 2] = o[M + 24 >> 2], o[ye + 92 >> 2] = Xi, Xi = o[M + 20 >> 2], o[ye + 80 >> 2] = o[M + 16 >> 2], o[ye + 84 >> 2] = Xi, Xi = o[M + 44 >> 2], o[ye + 72 >> 2] = o[M + 40 >> 2], o[ye + 76 >> 2] = Xi, Xi = o[M + 36 >> 2], o[ye + 64 >> 2] = o[M + 32 >> 2], o[ye + 68 >> 2] = Xi, gs(E, ye + 80 | 0, ye - -64 | 0), Xi = o[ye + 300 >> 2], o[M + 40 >> 2] = o[ye + 296 >> 2], o[M + 44 >> 2] = Xi, Xi = o[ye + 292 >> 2], o[M + 32 >> 2] = o[ye + 288 >> 2], o[M + 36 >> 2] = Xi, Xi = o[M + 12 >> 2], o[ye + 56 >> 2] = o[M + 8 >> 2], o[ye + 60 >> 2] = Xi, Xi = o[M + 4 >> 2], o[ye + 48 >> 2] = o[M >> 2], o[ye + 52 >> 2] = Xi, Xi = o[M + 28 >> 2], o[ye + 40 >> 2] = o[M + 24 >> 2], o[ye + 44 >> 2] = Xi, Xi = o[M + 20 >> 2], o[ye + 32 >> 2] = o[M + 16 >> 2], o[ye + 36 >> 2] = Xi, gs(E, ye + 48 | 0, ye + 32 | 0), Xi = o[ye + 300 >> 2], o[M + 24 >> 2] = o[ye + 296 >> 2], o[M + 28 >> 2] = Xi, Xi = o[ye + 292 >> 2], o[M + 16 >> 2] = o[ye + 288 >> 2], o[M + 20 >> 2] = Xi, Xi = o[ye + 316 >> 2], o[ye + 24 >> 2] = o[ye + 312 >> 2], o[ye + 28 >> 2] = Xi, Xi = o[ye + 308 >> 2], o[ye + 16 >> 2] = o[ye + 304 >> 2], o[ye + 20 >> 2] = Xi, Xi = o[M + 12 >> 2], o[ye + 8 >> 2] = o[M + 8 >> 2], o[ye + 12 >> 2] = Xi, Xi = o[M + 4 >> 2], o[ye >> 2] = o[M >> 2], o[ye + 4 >> 2] = Xi, gs(E, ye + 16 | 0, ye), E = o[ye + 300 >> 2], o[M + 8 >> 2] = o[ye + 296 >> 2], o[M + 12 >> 2] = E, E = o[ye + 292 >> 2], o[M >> 2] = o[ye + 288 >> 2], o[M + 4 >> 2] = E, o[M + 12 >> 2] = go ^ (m[M + 12 | 0] | m[M + 13 | 0] << 8 | m[M + 14 | 0] << 16 | m[M + 15 | 0] << 24), o[M + 8 >> 2] = bo ^ (m[M + 8 | 0] | m[M + 9 | 0] << 8 | m[M + 10 | 0] << 16 | m[M + 11 | 0] << 24), o[M + 4 >> 2] = wo ^ (m[M + 4 | 0] | m[M + 5 | 0] << 8 | m[M + 6 | 0] << 16 | m[M + 7 | 0] << 24), o[M >> 2] = fo ^ (m[0 | M] | m[M + 1 | 0] << 8 | m[M + 2 | 0] << 16 | m[M + 3 | 0] << 24), o[k >> 2] = $n ^ (m[0 | k] | m[k + 1 | 0] << 8 | m[k + 2 | 0] << 16 | m[k + 3 | 0] << 24), o[M + 68 >> 2] = to ^ (m[M + 68 | 0] | m[M + 69 | 0] << 8 | m[M + 70 | 0] << 16 | m[M + 71 | 0] << 24), o[M + 72 >> 2] = T ^ (m[M + 72 | 0] | m[M + 73 | 0] << 8 | m[M + 74 | 0] << 16 | m[M + 75 | 0] << 24), o[M + 76 >> 2] = Zn ^ (m[M + 76 | 0] | m[M + 77 | 0] << 8 | m[M + 78 | 0] << 16 | m[M + 79 | 0] << 24), dr = ye + 320 | 0;
                    }
                    function Mo(k, E) {
                      var T, M, ye, Ne, pr, ve, cr, gr, Pr, Nr, Br, Mr, jr, ti, fi, Jr, li, Tr, Mi, Wi, vn, Tn, Ni, Yi, Xi, $n, Zn, to, fo, wo, bo, go, qn, io, So, qo, Ln = 0, ro = 0, Qo = 0, Vo = 0, as = 0, cs = 0, ms = 0, ai = 0, ci = 0, Fi = 0, Eo = 0, is = 0, ws = 0, ys = 0, Is = 0, ks = 0, Ps = 0, Po = 0, fn = 0, Qn = 0, zn = 0;
                      Ln = Zr(M = (fi = o[E + 12 >> 2]) << 1, ve = M >> 31, ws = (Vo = o[E + 4 >> 2]) << 1, ye = ws >> 31), Qo = Qe, Wi = Fi = o[E + 8 >> 2], ro = (Eo = Zr(Fi, Jr = Fi >> 31, Fi, Jr)) + Ln | 0, Ln = Qe + Qo | 0, Ln = ro >>> 0 < Eo >>> 0 ? Ln + 1 | 0 : Ln, Qo = Zr(cs = o[E + 16 >> 2], cr = cs >> 31, Eo = (as = o[E >> 2]) << 1, Ne = Eo >> 31), Ln = Qe + Ln | 0, Ln = (ro = Qo + ro | 0) >>> 0 < Qo >>> 0 ? Ln + 1 | 0 : Ln, Br = o[E + 28 >> 2], Qo = Zr(Po = v(Br, 38), li = Po >> 31, Br, vn = Br >> 31), Ln = Qe + Ln | 0, Ln = (ro = Qo + ro | 0) >>> 0 < Qo >>> 0 ? Ln + 1 | 0 : Ln, Qo = ro, Mr = o[E + 32 >> 2], ms = Zr(ai = v(Mr, 19), gr = ai >> 31, ro = (T = o[E + 24 >> 2]) << 1, ro >> 31), ro = Qe + Ln | 0, ro = (Qo = Qo + ms | 0) >>> 0 < ms >>> 0 ? ro + 1 | 0 : ro, to = o[E + 36 >> 2], Ln = Zr(ms = v(to, 38), pr = ms >> 31, ys = (Pr = o[E + 20 >> 2]) << 1, jr = ys >> 31), E = Qe + ro | 0, wo = Ln = (Ln >>> 0 > (Qo = Ln + Qo | 0) >>> 0 ? E + 1 : E) << 1 | Qo >>> 31, bo = ro = 33554432 + (Tn = Qo << 1) | 0, go = Ln = ro >>> 0 < 33554432 ? Ln + 1 | 0 : Ln, E = Ln >> 26, is = (67108863 & Ln) << 6 | ro >>> 26, Ln = Zr(ws, ye, cs, cr), Qo = Qe, ro = (Is = Zr(Fi <<= 1, ti = Fi >> 31, fi, Ni = fi >> 31)) + Ln | 0, Ln = Qe + Qo | 0, Ln = ro >>> 0 < Is >>> 0 ? Ln + 1 | 0 : Ln, Qo = (Is = Zr(Pr, Tr = Pr >> 31, Eo, Ne)) + ro | 0, ro = Qe + Ln | 0, ro = Qo >>> 0 < Is >>> 0 ? ro + 1 | 0 : ro, Qn = Zr(ai, gr, Is = Br << 1, Yi = Is >> 31), Ln = Qe + ro | 0, Ln = (Qo = Qn + Qo | 0) >>> 0 < Qn >>> 0 ? Ln + 1 | 0 : Ln, ro = Zr(ms, pr, T, Nr = T >> 31), Ln = Qe + Ln | 0, E = E + (ro = (ro >>> 0 > (Qo = ro + Qo | 0) >>> 0 ? Ln + 1 : Ln) << 1 | Qo >>> 31) | 0, Qn = Qo = (Ln = Qo << 1) + is | 0, Ln = E = Ln >>> 0 > Qo >>> 0 ? E + 1 | 0 : E, qn = Qo = Qo + 16777216 | 0, is = (33554431 & (Ln = Qo >>> 0 < 16777216 ? Ln + 1 | 0 : Ln)) << 7 | Qo >>> 25, Qo = Ln >> 25, E = Zr(M, ve, fi, Ni), Ln = Qe, ro = Zr(cs, cr, Fi, ti), Ln = Qe + Ln | 0, Ln = (E = ro + E | 0) >>> 0 < ro >>> 0 ? Ln + 1 | 0 : Ln, ro = Zr(ws, ye, ys, jr), Ln = Qe + Ln | 0, Ln = (E = ro + E | 0) >>> 0 < ro >>> 0 ? Ln + 1 | 0 : Ln, ro = (ks = Zr(Eo, Ne, T, Nr)) + E | 0, E = Qe + Ln | 0, E = ro >>> 0 < ks >>> 0 ? E + 1 | 0 : E, ks = Zr(ai, gr, Mr, Mi = Mr >> 31), Ln = Qe + E | 0, Ln = (ro = ks + ro | 0) >>> 0 < ks >>> 0 ? Ln + 1 | 0 : Ln, E = (ks = Zr(ms, pr, Is, Yi)) + ro | 0, ro = Qe + Ln | 0, E = ((Ln = E) >>> 0 < ks >>> 0 ? ro + 1 : ro) << 1 | Ln >>> 31, ro = is, is = Ln << 1, Ln = E + Qo | 0, Ln = (ro = ro + is | 0) >>> 0 < is >>> 0 ? Ln + 1 | 0 : Ln, ks = E = ro + 33554432 | 0, Qo = Ln = E >>> 0 < 33554432 ? Ln + 1 | 0 : Ln, o[k + 24 >> 2] = ro - (-67108864 & E), ro = Zr(E = v(Pr, 38), E >> 31, Pr, Tr), is = Qe, E = (Ln = Zr(E = as, Ln = E >> 31, E, Ln)) + ro | 0, ro = Qe + is | 0, ro = E >>> 0 < Ln >>> 0 ? ro + 1 | 0 : ro, Ps = Zr(as = v(T, 19), Xi = as >> 31, is = cs << 1, $n = is >> 31), Ln = Qe + ro | 0, Ln = (E = Ps + E | 0) >>> 0 < Ps >>> 0 ? Ln + 1 | 0 : Ln, ro = Zr(M, ve, Po, li), Ln = Qe + Ln | 0, Ln = (E = ro + E | 0) >>> 0 < ro >>> 0 ? Ln + 1 | 0 : Ln, ro = (Ps = Zr(ai, gr, Fi, ti)) + E | 0, E = Qe + Ln | 0, E = ro >>> 0 < Ps >>> 0 ? E + 1 | 0 : E, Ps = Zr(ws, ye, ms, pr), Ln = Qe + E | 0, Ps = Ln = ((ro = Ps + ro | 0) >>> 0 < Ps >>> 0 ? Ln + 1 : Ln) << 1 | ro >>> 31, io = E = 33554432 + (Zn = ro << 1) | 0, So = ro = E >>> 0 < 33554432 ? Ln + 1 | 0 : Ln, fn = (67108863 & ro) << 6 | E >>> 26, zn = ro >> 26, E = Zr(as, Xi, ys, jr), Ln = Qe, ro = Zr(Eo, Ne, Vo, fo = Vo >> 31), Ln = Qe + Ln | 0, Ln = (E = ro + E | 0) >>> 0 < ro >>> 0 ? Ln + 1 | 0 : Ln, ro = (ci = Zr(cs, cr, Po, li)) + E | 0, E = Qe + Ln | 0, E = ro >>> 0 < ci >>> 0 ? E + 1 | 0 : E, ci = Zr(ai, gr, M, ve), Ln = Qe + E | 0, Ln = (ro = ci + ro | 0) >>> 0 < ci >>> 0 ? Ln + 1 | 0 : Ln, ci = (E = Zr(ms, pr, Wi, Jr)) + ro | 0, ro = Qe + Ln | 0, Ln = (E = (E >>> 0 > ci >>> 0 ? ro + 1 : ro) << 1 | ci >>> 31) + zn | 0, Ln = (ro = (ci <<= 1) + fn | 0) >>> 0 < ci >>> 0 ? Ln + 1 | 0 : Ln, zn = ro, ci = ro = ro + 16777216 | 0, qo = (33554431 & (Ln = ro >>> 0 < 16777216 ? Ln + 1 | 0 : Ln)) << 7 | ro >>> 25, fn = Ln >> 25, E = Zr(Eo, Ne, Wi, Jr), Ln = Qe, ro = Zr(ws, ye, Vo, fo), Ln = Qe + Ln | 0, Ln = (E = ro + E | 0) >>> 0 < ro >>> 0 ? Ln + 1 | 0 : Ln, Vo = Zr(as, Xi, T, Nr), ro = Qe + Ln | 0, ro = (E = Vo + E | 0) >>> 0 < Vo >>> 0 ? ro + 1 | 0 : ro, Vo = Zr(ys, jr, Po, li), Ln = Qe + ro | 0, Ln = (E = Vo + E | 0) >>> 0 < Vo >>> 0 ? Ln + 1 | 0 : Ln, ro = Zr(ai, gr, is, $n), Ln = Qe + Ln | 0, Ln = (E = ro + E | 0) >>> 0 < ro >>> 0 ? Ln + 1 | 0 : Ln, ro = (Vo = Zr(ms, pr, M, ve)) + E | 0, E = Qe + Ln | 0, Ln = (Ln = (ro >>> 0 < Vo >>> 0 ? E + 1 : E) << 1 | ro >>> 31) + fn | 0, as = E = (ro <<= 1) + qo | 0, Ln = E >>> 0 < ro >>> 0 ? Ln + 1 | 0 : Ln, fn = E = E + 33554432 | 0, Vo = ro = E >>> 0 < 33554432 ? Ln + 1 | 0 : Ln, o[k + 8 >> 2] = as - (-67108864 & E), E = Zr(Fi, ti, Pr, Tr), ro = Qe, Ln = (as = Zr(cs, cr, M, ve)) + E | 0, E = Qe + ro | 0, E = Ln >>> 0 < as >>> 0 ? E + 1 | 0 : E, ro = (as = Zr(ws, ye, T, Nr)) + Ln | 0, Ln = Qe + E | 0, Ln = ro >>> 0 < as >>> 0 ? Ln + 1 | 0 : Ln, E = (as = Zr(Eo, Ne, Br, vn)) + ro | 0, ro = Qe + Ln | 0, ro = E >>> 0 < as >>> 0 ? ro + 1 | 0 : ro, as = Zr(ms, pr, Mr, Mi), Ln = Qe + ro | 0, Ln = (Ln = ((E = as + E | 0) >>> 0 < as >>> 0 ? Ln + 1 : Ln) << 1 | E >>> 31) + (ro = Qo >> 26) | 0, E = (ro = Qo = (as = E << 1) + (E = (67108863 & Qo) << 6 | ks >>> 26) | 0) >>> 0 < E >>> 0 ? Ln + 1 | 0 : Ln, as = Ln = ro + 16777216 | 0, Qo = E = Ln >>> 0 < 16777216 ? E + 1 | 0 : E, o[k + 28 >> 2] = ro - (-33554432 & Ln), E = Zr(Eo, Ne, fi, Ni), Ln = Qe, ro = Zr(ws, ye, Wi, Jr), Ln = Qe + Ln | 0, Ln = (E = ro + E | 0) >>> 0 < ro >>> 0 ? Ln + 1 | 0 : Ln, ro = Zr(T, Nr, Po, li), Ln = Qe + Ln | 0, Ln = (E = ro + E | 0) >>> 0 < ro >>> 0 ? Ln + 1 | 0 : Ln, ro = (ai = Zr(ai, gr, ys, jr)) + E | 0, E = Qe + Ln | 0, E = ro >>> 0 < ai >>> 0 ? E + 1 | 0 : E, Ln = (ai = Zr(ms, pr, cs, cr)) + ro | 0, ro = Qe + E | 0, E = Ln, Ln = (Ln >>> 0 < ai >>> 0 ? ro + 1 : ro) << 1 | Ln >>> 31, ro = E << 1, Ln = (E = Vo >> 26) + Ln | 0, Ln = (ro = ro + (Vo = (67108863 & Vo) << 6 | fn >>> 26) | 0) >>> 0 < Vo >>> 0 ? Ln + 1 | 0 : Ln, ai = E = ro + 16777216 | 0, Vo = Ln = E >>> 0 < 16777216 ? Ln + 1 | 0 : Ln, o[k + 12 >> 2] = ro - (-33554432 & E), E = Zr(T, Nr, Fi, ti), Ln = Qe, ro = Zr(cs, cr, cs, cr), Ln = Qe + Ln | 0, Ln = (E = ro + E | 0) >>> 0 < ro >>> 0 ? Ln + 1 | 0 : Ln, ro = Zr(M, ve, ys, jr), Ln = Qe + Ln | 0, Ln = (E = ro + E | 0) >>> 0 < ro >>> 0 ? Ln + 1 | 0 : Ln, ro = Zr(ws, ye, Is, Yi), Ln = Qe + Ln | 0, Ln = (E = ro + E | 0) >>> 0 < ro >>> 0 ? Ln + 1 | 0 : Ln, ro = (cs = Zr(Eo, Ne, Mr, Mi)) + E | 0, E = Qe + Ln | 0, E = ro >>> 0 < cs >>> 0 ? E + 1 | 0 : E, Ln = (cs = Zr(Ln = ms, pr, ms = to, ys = ms >> 31)) + ro | 0, ro = Qe + E | 0, E = Ln, Ln = (Ln >>> 0 < cs >>> 0 ? ro + 1 : ro) << 1 | Ln >>> 31, ro = E << 1, Ln = (E = Qo >> 25) + Ln | 0, Ln = (ro = ro + (Qo = (33554431 & Qo) << 7 | as >>> 25) | 0) >>> 0 < Qo >>> 0 ? Ln + 1 | 0 : Ln, cs = E = ro + 33554432 | 0, Qo = Ln = E >>> 0 < 33554432 ? Ln + 1 | 0 : Ln, o[k + 32 >> 2] = ro - (-67108864 & E), Ln = Vo >> 25, ro = (Vo = (33554431 & Vo) << 7 | ai >>> 25) + (Tn - (E = -67108864 & bo) | 0) | 0, E = Ln + (wo - ((E >>> 0 > Tn >>> 0) + go | 0) | 0) | 0, E = ro >>> 0 < Vo >>> 0 ? E + 1 | 0 : E, Vo = ro, Ln = E, E = ((67108863 & (Ln = (ro = ro + 33554432 | 0) >>> 0 < 33554432 ? Ln + 1 | 0 : Ln)) << 6 | ro >>> 26) + (Po = Qn - (-33554432 & qn) | 0) | 0, o[k + 20 >> 2] = E, o[k + 16 >> 2] = Vo - (-67108864 & ro), E = Zr(M, ve, T, Nr), ro = Qe, Ln = (Vo = Zr(Pr, Tr, is, $n)) + E | 0, E = Qe + ro | 0, E = Ln >>> 0 < Vo >>> 0 ? E + 1 | 0 : E, ro = (Vo = Zr(Fi, ti, Br, vn)) + Ln | 0, Ln = Qe + E | 0, Ln = ro >>> 0 < Vo >>> 0 ? Ln + 1 | 0 : Ln, E = (Vo = Zr(ws, ye, Mr, Mi)) + ro | 0, ro = Qe + Ln | 0, ro = E >>> 0 < Vo >>> 0 ? ro + 1 | 0 : ro, Vo = Zr(Eo, Ne, ms, ys), Ln = Qe + ro | 0, Ln = ((E = Vo + E | 0) >>> 0 < Vo >>> 0 ? Ln + 1 : Ln) << 1 | E >>> 31, Vo = E << 1, Ln = Ln + (ro = Qo >> 26) | 0, E = (E = (67108863 & Qo) << 6 | cs >>> 26) >>> 0 > (Qo = Vo + E | 0) >>> 0 ? Ln + 1 | 0 : Ln, E = (Ln = Qo + 16777216 | 0) >>> 0 < 16777216 ? E + 1 | 0 : E, o[k + 36 >> 2] = Qo - (-33554432 & Ln), Vo = zn - (-33554432 & ci) | 0, Qo = Zn - (ro = -67108864 & io) | 0, ws = Ps - ((ro >>> 0 > Zn >>> 0) + So | 0) | 0, E = Zr((33554431 & E) << 7 | Ln >>> 25, E >> 25, 19, 0), ro = Qe + ws | 0, Qo = Ln = E + Qo | 0, E = E >>> 0 > Ln >>> 0 ? ro + 1 | 0 : ro, E = ((67108863 & (E = (Ln = Ln + 33554432 | 0) >>> 0 < 33554432 ? E + 1 | 0 : E)) << 6 | Ln >>> 26) + Vo | 0, o[k + 4 >> 2] = E, o[k >> 2] = Qo - (-67108864 & Ln);
                    }
                    function qi(k, E) {
                      var T, M, ye, Ne, pr, ve, cr, gr, Pr, Nr, Br, Mr, jr, ti, fi, Jr, li, Tr, Mi, Wi, vn, Tn, Ni, Yi, Xi, $n, Zn, to, fo, wo, bo, go, qn = 0, io = 0, So = 0, qo = 0, Ln = 0, ro = 0, Qo = 0, Vo = 0, as = 0, cs = 0, ms = 0, ai = 0, ci = 0, Fi = 0, Eo = 0, is = 0, ws = 0, ys = 0, Is = 0, ks = 0, Ps = 0, Po = 0;
                      qn = Zr(M = (Jr = o[E + 12 >> 2]) << 1, ve = M >> 31, Jr, vn = Jr >> 31), So = Qe, io = (as = Zr(Ln = o[E + 16 >> 2], cr = Ln >> 31, gr = (qo = o[E + 8 >> 2]) << 1, Mr = gr >> 31)) + qn | 0, qn = Qe + So | 0, qn = io >>> 0 < as >>> 0 ? qn + 1 | 0 : qn, So = (cs = Zr(ci = (Pr = o[E + 20 >> 2]) << 1, jr = ci >> 31, as = (ro = o[E + 4 >> 2]) << 1, ye = as >> 31)) + io | 0, io = Qe + qn | 0, io = So >>> 0 < cs >>> 0 ? io + 1 | 0 : io, Qo = Zr(T = o[E + 24 >> 2], Nr = T >> 31, cs = (is = o[E >> 2]) << 1, Ne = cs >> 31), qn = Qe + io | 0, qn = (So = Qo + So | 0) >>> 0 < Qo >>> 0 ? qn + 1 | 0 : qn, io = So, ti = o[E + 32 >> 2], So = Zr(ms = v(ti, 19), Br = ms >> 31, ti, Tr = ti >> 31), qn = Qe + qn | 0, qn = (io = io + So | 0) >>> 0 < So >>> 0 ? qn + 1 | 0 : qn, $n = o[E + 36 >> 2], So = Zr(Qo = v($n, 38), pr = Qo >> 31, Mi = (fi = o[E + 28 >> 2]) << 1, Tn = Mi >> 31), E = Qe + qn | 0, Eo = io = So + io | 0, So = io >>> 0 < So >>> 0 ? E + 1 | 0 : E, E = Zr(as, ye, Ln, cr), qn = Qe, io = Zr(gr, Mr, Jr, vn), qn = Qe + qn | 0, qn = (E = io + E | 0) >>> 0 < io >>> 0 ? qn + 1 | 0 : qn, Vo = Zr(Pr, Wi = Pr >> 31, cs, Ne), io = Qe + qn | 0, io = (E = Vo + E | 0) >>> 0 < Vo >>> 0 ? io + 1 | 0 : io, Vo = Zr(ms, Br, Mi, Tn), qn = Qe + io | 0, qn = (E = Vo + E | 0) >>> 0 < Vo >>> 0 ? qn + 1 | 0 : qn, io = Zr(Qo, pr, T, Nr), qn = Qe + qn | 0, Ps = E = io + E | 0, ai = E >>> 0 < io >>> 0 ? qn + 1 | 0 : qn, qn = Zr(as, ye, M, ve), io = Qe, Ni = E = qo, qo = Zr(E, Fi = E >> 31, E, Fi), E = Qe + io | 0, E = (qn = qo + qn | 0) >>> 0 < qo >>> 0 ? E + 1 | 0 : E, io = (qo = Zr(cs, Ne, Ln, cr)) + qn | 0, qn = Qe + E | 0, qn = io >>> 0 < qo >>> 0 ? qn + 1 | 0 : qn, E = (qo = Zr(Vo = v(fi, 38), li = Vo >> 31, fi, Yi = fi >> 31)) + io | 0, io = Qe + qn | 0, io = E >>> 0 < qo >>> 0 ? io + 1 | 0 : io, E = (qn = E) + (qo = Zr(ms, Br, E = T << 1, E >> 31)) | 0, qn = Qe + io | 0, qn = E >>> 0 < qo >>> 0 ? qn + 1 | 0 : qn, io = E, E = Zr(Qo, pr, ci, jr), qn = Qe + qn | 0, Zn = io = io + E | 0, to = qn = E >>> 0 > io >>> 0 ? qn + 1 | 0 : qn, E = qn, fo = io = io + 33554432 | 0, wo = E = io >>> 0 < 33554432 ? E + 1 | 0 : E, qn = (qn = E >> 26) + ai | 0, Ps = E = (io = (67108863 & E) << 6 | io >>> 26) + Ps | 0, qn = E >>> 0 < io >>> 0 ? qn + 1 | 0 : qn, bo = E = E + 16777216 | 0, qn = (qn = (io = E >>> 0 < 16777216 ? qn + 1 | 0 : qn) >> 25) + So | 0, E = (E = (33554431 & io) << 7 | E >>> 25) >>> 0 > (io = E + Eo | 0) >>> 0 ? qn + 1 | 0 : qn, Eo = qn = io + 33554432 | 0, qo = E = qn >>> 0 < 33554432 ? E + 1 | 0 : E, o[k + 24 >> 2] = io - (-67108864 & qn), E = Zr(cs, Ne, Ni, Fi), qn = Qe, So = Zr(as, ye, ro, ws = ro >> 31), io = Qe + qn | 0, io = (E = So + E | 0) >>> 0 < So >>> 0 ? io + 1 | 0 : io, ai = Zr(So = v(T, 19), ks = So >> 31, T, Nr), qn = Qe + io | 0, qn = (E = ai + E | 0) >>> 0 < ai >>> 0 ? qn + 1 | 0 : qn, io = (ai = Zr(ci, jr, Vo, li)) + E | 0, E = Qe + qn | 0, E = io >>> 0 < ai >>> 0 ? E + 1 | 0 : E, ys = Zr(ms, Br, ai = Ln << 1, Xi = ai >> 31), qn = Qe + E | 0, qn = (io = ys + io | 0) >>> 0 < ys >>> 0 ? qn + 1 | 0 : qn, E = io, io = Zr(Qo, pr, M, ve), qn = Qe + qn | 0, Is = E = E + io | 0, ys = E >>> 0 < io >>> 0 ? qn + 1 | 0 : qn, E = Zr(ci, jr, So, ks), qn = Qe, ro = Zr(cs, Ne, ro, ws), io = Qe + qn | 0, io = (E = ro + E | 0) >>> 0 < ro >>> 0 ? io + 1 | 0 : io, ro = Zr(Ln, cr, Vo, li), qn = Qe + io | 0, qn = (E = ro + E | 0) >>> 0 < ro >>> 0 ? qn + 1 | 0 : qn, io = (ro = Zr(ms, Br, M, ve)) + E | 0, E = Qe + qn | 0, E = io >>> 0 < ro >>> 0 ? E + 1 | 0 : E, ro = Zr(Qo, pr, Ni, Fi), qn = Qe + E | 0, Po = io = ro + io | 0, ws = io >>> 0 < ro >>> 0 ? qn + 1 | 0 : qn, io = Zr(E = v(Pr, 38), E >> 31, Pr, Wi), ro = Qe, E = is, is = io, io = Zr(E, qn = E >> 31, E, qn), qn = Qe + ro | 0, qn = (E = is + io | 0) >>> 0 < io >>> 0 ? qn + 1 | 0 : qn, So = Zr(So, ks, ai, Xi), io = Qe + qn | 0, io = (E = So + E | 0) >>> 0 < So >>> 0 ? io + 1 | 0 : io, So = Zr(M, ve, Vo, li), qn = Qe + io | 0, qn = (E = So + E | 0) >>> 0 < So >>> 0 ? qn + 1 | 0 : qn, io = (So = Zr(ms, Br, gr, Mr)) + E | 0, E = Qe + qn | 0, E = io >>> 0 < So >>> 0 ? E + 1 | 0 : E, So = Zr(as, ye, Qo, pr), qn = Qe + E | 0, ro = io = So + io | 0, is = qn = io >>> 0 < So >>> 0 ? qn + 1 | 0 : qn, ks = io = io + 33554432 | 0, go = qn = io >>> 0 < 33554432 ? qn + 1 | 0 : qn, E = qn >> 26, qn = (67108863 & qn) << 6 | io >>> 26, io = E + ws | 0, ws = So = qn + Po | 0, qn = qn >>> 0 > So >>> 0 ? io + 1 | 0 : io, Po = io = So + 16777216 | 0, So = (33554431 & (qn = io >>> 0 < 16777216 ? qn + 1 | 0 : qn)) << 7 | io >>> 25, qn = (qn >> 25) + ys | 0, qn = (io = So + Is | 0) >>> 0 < So >>> 0 ? qn + 1 | 0 : qn, ys = E = io + 33554432 | 0, So = qn = E >>> 0 < 33554432 ? qn + 1 | 0 : qn, o[k + 8 >> 2] = io - (-67108864 & E), E = Zr(gr, Mr, Pr, Wi), qn = Qe, io = Zr(Ln, cr, M, ve), qn = Qe + qn | 0, qn = (E = io + E | 0) >>> 0 < io >>> 0 ? qn + 1 | 0 : qn, io = Zr(as, ye, T, Nr), qn = Qe + qn | 0, qn = (E = io + E | 0) >>> 0 < io >>> 0 ? qn + 1 | 0 : qn, io = Zr(cs, Ne, fi, Yi), qn = Qe + qn | 0, qn = (E = io + E | 0) >>> 0 < io >>> 0 ? qn + 1 | 0 : qn, Is = (io = Zr(Qo, pr, ti, Tr)) + E | 0, E = Qe + qn | 0, io = (qn = qo >> 26) + (io = io >>> 0 > Is >>> 0 ? E + 1 | 0 : E) | 0, Eo = E = (qo = (67108863 & qo) << 6 | Eo >>> 26) + Is | 0, qn = E >>> 0 < qo >>> 0 ? io + 1 | 0 : io, Is = E = E + 16777216 | 0, qo = qn = E >>> 0 < 16777216 ? qn + 1 | 0 : qn, o[k + 28 >> 2] = Eo - (-33554432 & E), E = Zr(cs, Ne, Jr, vn), io = Qe, qn = (Fi = Zr(as, ye, Ni, Fi)) + E | 0, E = Qe + io | 0, E = qn >>> 0 < Fi >>> 0 ? E + 1 | 0 : E, qn = (Vo = Zr(T, Nr, Vo, li)) + qn | 0, io = Qe + E | 0, E = (ms = Zr(ms, Br, ci, jr)) + qn | 0, qn = Qe + (qn >>> 0 < Vo >>> 0 ? io + 1 | 0 : io) | 0, qn = E >>> 0 < ms >>> 0 ? qn + 1 | 0 : qn, io = Zr(Qo, pr, Ln, cr), qn = Qe + qn | 0, qn = (qn = (E = io + E | 0) >>> 0 < io >>> 0 ? qn + 1 | 0 : qn) + (io = So >> 26) | 0, E = (io = So = (Eo = E) + (E = (67108863 & So) << 6 | ys >>> 26) | 0) >>> 0 < E >>> 0 ? qn + 1 | 0 : qn, ms = qn = io + 16777216 | 0, So = E = qn >>> 0 < 16777216 ? E + 1 | 0 : E, o[k + 12 >> 2] = io - (-33554432 & qn), E = Zr(T, Nr, gr, Mr), qn = Qe, io = Zr(Ln, cr, Ln, cr), qn = Qe + qn | 0, qn = (E = io + E | 0) >>> 0 < io >>> 0 ? qn + 1 | 0 : qn, io = Zr(M, ve, ci, jr), qn = Qe + qn | 0, qn = (E = io + E | 0) >>> 0 < io >>> 0 ? qn + 1 | 0 : qn, io = (Ln = Zr(as, ye, Mi, Tn)) + E | 0, E = Qe + qn | 0, E = io >>> 0 < Ln >>> 0 ? E + 1 | 0 : E, qn = (Ln = Zr(cs, Ne, ti, Tr)) + io | 0, io = Qe + E | 0, io = qn >>> 0 < Ln >>> 0 ? io + 1 | 0 : io, E = (Ln = Zr(E = Qo, pr, Qo = $n, ci = Qo >> 31)) + qn | 0, qn = Qe + io | 0, qn = E >>> 0 < Ln >>> 0 ? qn + 1 | 0 : qn, io = E, qn = (E = qo >> 25) + qn | 0, qn = (io = io + (qo = (33554431 & qo) << 7 | Is >>> 25) | 0) >>> 0 < qo >>> 0 ? qn + 1 | 0 : qn, Ln = E = io + 33554432 | 0, qo = qn = E >>> 0 < 33554432 ? qn + 1 | 0 : qn, o[k + 32 >> 2] = io - (-67108864 & E), qn = So >> 25, io = (So = (33554431 & So) << 7 | ms >>> 25) + (Zn - (E = -67108864 & fo) | 0) | 0, E = qn + (to - ((E >>> 0 > Zn >>> 0) + wo | 0) | 0) | 0, E = io >>> 0 < So >>> 0 ? E + 1 | 0 : E, So = io, E = ((67108863 & (qn = (io = io + 33554432 | 0) >>> 0 < 33554432 ? E + 1 | 0 : E)) << 6 | io >>> 26) + (Vo = Ps - (-33554432 & bo) | 0) | 0, o[k + 20 >> 2] = E, o[k + 16 >> 2] = So - (-67108864 & io), E = Zr(M, ve, T, Nr), io = Qe, qn = (So = Zr(Pr, Wi, ai, Xi)) + E | 0, E = Qe + io | 0, E = qn >>> 0 < So >>> 0 ? E + 1 | 0 : E, io = (So = Zr(gr, Mr, fi, Yi)) + qn | 0, qn = Qe + E | 0, qn = io >>> 0 < So >>> 0 ? qn + 1 | 0 : qn, E = (So = Zr(as, ye, ti, Tr)) + io | 0, io = Qe + qn | 0, io = E >>> 0 < So >>> 0 ? io + 1 | 0 : io, So = (qn = E) + (E = Zr(cs, Ne, Qo, ci)) | 0, qn = Qe + io | 0, qn = (E = E >>> 0 > So >>> 0 ? qn + 1 | 0 : qn) + (qn = qo >> 26) | 0, E = (io = (qo = (67108863 & qo) << 6 | Ln >>> 26) + So | 0) >>> 0 < qo >>> 0 ? qn + 1 | 0 : qn, E = (qn = io + 16777216 | 0) >>> 0 < 16777216 ? E + 1 | 0 : E, o[k + 36 >> 2] = io - (-33554432 & qn), qo = ws - (-33554432 & Po) | 0, So = ro - (io = -67108864 & ks) | 0, as = is - ((io >>> 0 > ro >>> 0) + go | 0) | 0, E = Zr((33554431 & E) << 7 | qn >>> 25, E >> 25, 19, 0), qn = Qe + as | 0, E = E >>> 0 > (io = E + So | 0) >>> 0 ? qn + 1 | 0 : qn, E = ((67108863 & (E = (qn = io + 33554432 | 0) >>> 0 < 33554432 ? E + 1 | 0 : E)) << 6 | qn >>> 26) + qo | 0, o[k + 4 >> 2] = E, o[k >> 2] = io - (-67108864 & qn);
                    }
                    function Oo(k, E) {
                      var T, M, ye, Ne, pr, ve, cr, gr, Pr, Nr, Br = 0, Mr = 0, jr = 0;
                      dr = T = dr - 416 | 0, M = m[k + 16 | 0] | m[k + 17 | 0] << 8 | m[k + 18 | 0] << 16 | m[k + 19 | 0] << 24, ye = m[k + 20 | 0] | m[k + 21 | 0] << 8 | m[k + 22 | 0] << 16 | m[k + 23 | 0] << 24, Ne = m[k + 24 | 0] | m[k + 25 | 0] << 8 | m[k + 26 | 0] << 16 | m[k + 27 | 0] << 24, pr = m[k + 28 | 0] | m[k + 29 | 0] << 8 | m[k + 30 | 0] << 16 | m[k + 31 | 0] << 24, jr = m[k + 4 | 0] | m[k + 5 | 0] << 8 | m[k + 6 | 0] << 16 | m[k + 7 | 0] << 24, ve = m[k + 8 | 0] | m[k + 9 | 0] << 8 | m[k + 10 | 0] << 16 | m[k + 11 | 0] << 24, cr = m[k + 12 | 0] | m[k + 13 | 0] << 8 | m[k + 14 | 0] << 16 | m[k + 15 | 0] << 24, gr = m[0 | k] | m[k + 1 | 0] << 8 | m[k + 2 | 0] << 16 | m[k + 3 | 0] << 24, k = o[E + 92 >> 2], o[T + 408 >> 2] = o[E + 88 >> 2], o[T + 412 >> 2] = k, k = o[E + 84 >> 2], o[T + 400 >> 2] = o[E + 80 >> 2], o[T + 404 >> 2] = k, k = o[E + 76 >> 2], o[T + 376 >> 2] = o[E + 72 >> 2], o[T + 380 >> 2] = k, Br = o[4 + (k = Mr = E - -64 | 0) >> 2], o[T + 368 >> 2] = o[k >> 2], o[T + 372 >> 2] = Br, k = o[E + 92 >> 2], o[T + 360 >> 2] = o[E + 88 >> 2], o[T + 364 >> 2] = k, k = o[E + 84 >> 2], o[T + 352 >> 2] = o[E + 80 >> 2], o[T + 356 >> 2] = k, gs(k = T + 384 | 0, T + 368 | 0, T + 352 | 0), Br = o[T + 396 >> 2], o[E + 88 >> 2] = o[T + 392 >> 2], o[E + 92 >> 2] = Br, Br = o[T + 388 >> 2], o[E + 80 >> 2] = o[T + 384 >> 2], o[E + 84 >> 2] = Br, Br = o[E + 60 >> 2], o[T + 344 >> 2] = o[E + 56 >> 2], o[T + 348 >> 2] = Br, Br = o[E + 52 >> 2], o[T + 336 >> 2] = o[E + 48 >> 2], o[T + 340 >> 2] = Br, Br = o[E + 76 >> 2], o[T + 328 >> 2] = o[E + 72 >> 2], o[T + 332 >> 2] = Br, Br = o[Mr + 4 >> 2], o[T + 320 >> 2] = o[Mr >> 2], o[T + 324 >> 2] = Br, gs(k, T + 336 | 0, T + 320 | 0), Br = o[T + 396 >> 2], o[E + 72 >> 2] = o[T + 392 >> 2], o[E + 76 >> 2] = Br, Br = o[T + 388 >> 2], o[Mr >> 2] = o[T + 384 >> 2], o[Mr + 4 >> 2] = Br, Br = o[E + 44 >> 2], o[T + 312 >> 2] = o[E + 40 >> 2], o[T + 316 >> 2] = Br, Br = o[E + 36 >> 2], o[T + 304 >> 2] = o[E + 32 >> 2], o[T + 308 >> 2] = Br, Br = o[E + 60 >> 2], o[T + 296 >> 2] = o[E + 56 >> 2], o[T + 300 >> 2] = Br, Br = o[E + 52 >> 2], o[T + 288 >> 2] = o[E + 48 >> 2], o[T + 292 >> 2] = Br, gs(k, T + 304 | 0, T + 288 | 0), Br = o[T + 396 >> 2], o[E + 56 >> 2] = o[T + 392 >> 2], o[E + 60 >> 2] = Br, Br = o[T + 388 >> 2], o[E + 48 >> 2] = o[T + 384 >> 2], o[E + 52 >> 2] = Br, Br = o[E + 28 >> 2], o[T + 280 >> 2] = o[E + 24 >> 2], o[T + 284 >> 2] = Br, Br = o[E + 20 >> 2], o[T + 272 >> 2] = o[E + 16 >> 2], o[T + 276 >> 2] = Br, Br = o[E + 44 >> 2], o[T + 264 >> 2] = o[E + 40 >> 2], o[T + 268 >> 2] = Br, Br = o[E + 36 >> 2], o[T + 256 >> 2] = o[E + 32 >> 2], o[T + 260 >> 2] = Br, gs(k, T + 272 | 0, T + 256 | 0), Br = o[T + 396 >> 2], o[E + 40 >> 2] = o[T + 392 >> 2], o[E + 44 >> 2] = Br, Br = o[T + 388 >> 2], o[E + 32 >> 2] = o[T + 384 >> 2], o[E + 36 >> 2] = Br, Br = o[E + 12 >> 2], o[T + 248 >> 2] = o[E + 8 >> 2], o[T + 252 >> 2] = Br, Br = o[E + 4 >> 2], o[T + 240 >> 2] = o[E >> 2], o[T + 244 >> 2] = Br, Br = o[E + 28 >> 2], o[T + 232 >> 2] = o[E + 24 >> 2], o[T + 236 >> 2] = Br, Br = o[E + 20 >> 2], o[T + 224 >> 2] = o[E + 16 >> 2], o[T + 228 >> 2] = Br, gs(k, T + 240 | 0, T + 224 | 0), Br = o[T + 396 >> 2], o[E + 24 >> 2] = o[T + 392 >> 2], o[E + 28 >> 2] = Br, Br = o[T + 388 >> 2], o[E + 16 >> 2] = o[T + 384 >> 2], o[E + 20 >> 2] = Br, Br = o[T + 412 >> 2], o[T + 216 >> 2] = o[T + 408 >> 2], o[T + 220 >> 2] = Br, Br = o[T + 404 >> 2], o[T + 208 >> 2] = o[T + 400 >> 2], o[T + 212 >> 2] = Br, Br = o[E + 12 >> 2], o[T + 200 >> 2] = o[E + 8 >> 2], o[T + 204 >> 2] = Br, Br = o[E + 4 >> 2], o[T + 192 >> 2] = o[E >> 2], o[T + 196 >> 2] = Br, gs(k, T + 208 | 0, T + 192 | 0), Br = o[T + 384 >> 2], Pr = o[T + 388 >> 2], Nr = o[T + 392 >> 2], o[E + 12 >> 2] = o[T + 396 >> 2] ^ cr, o[E + 8 >> 2] = ve ^ Nr, o[E + 4 >> 2] = jr ^ Pr, o[E >> 2] = Br ^ gr, jr = o[E + 92 >> 2], o[T + 408 >> 2] = o[E + 88 >> 2], o[T + 412 >> 2] = jr, jr = o[E + 84 >> 2], o[T + 400 >> 2] = o[E + 80 >> 2], o[T + 404 >> 2] = jr, jr = o[E + 76 >> 2], o[T + 184 >> 2] = o[E + 72 >> 2], o[T + 188 >> 2] = jr, jr = o[Mr + 4 >> 2], o[T + 176 >> 2] = o[Mr >> 2], o[T + 180 >> 2] = jr, jr = o[E + 92 >> 2], o[T + 168 >> 2] = o[E + 88 >> 2], o[T + 172 >> 2] = jr, jr = o[E + 84 >> 2], o[T + 160 >> 2] = o[E + 80 >> 2], o[T + 164 >> 2] = jr, gs(k, T + 176 | 0, T + 160 | 0), jr = o[T + 396 >> 2], o[E + 88 >> 2] = o[T + 392 >> 2], o[E + 92 >> 2] = jr, jr = o[T + 388 >> 2], o[E + 80 >> 2] = o[T + 384 >> 2], o[E + 84 >> 2] = jr, jr = o[E + 60 >> 2], o[T + 152 >> 2] = o[E + 56 >> 2], o[T + 156 >> 2] = jr, jr = o[E + 52 >> 2], o[T + 144 >> 2] = o[E + 48 >> 2], o[T + 148 >> 2] = jr, jr = o[E + 76 >> 2], o[T + 136 >> 2] = o[E + 72 >> 2], o[T + 140 >> 2] = jr, jr = o[Mr + 4 >> 2], o[T + 128 >> 2] = o[Mr >> 2], o[T + 132 >> 2] = jr, gs(k, T + 144 | 0, T + 128 | 0), jr = o[T + 396 >> 2], o[E + 72 >> 2] = o[T + 392 >> 2], o[E + 76 >> 2] = jr, jr = o[T + 388 >> 2], o[Mr >> 2] = o[T + 384 >> 2], o[Mr + 4 >> 2] = jr, Mr = o[E + 44 >> 2], o[T + 120 >> 2] = o[E + 40 >> 2], o[T + 124 >> 2] = Mr, Mr = o[E + 36 >> 2], o[T + 112 >> 2] = o[E + 32 >> 2], o[T + 116 >> 2] = Mr, Mr = o[E + 60 >> 2], o[T + 104 >> 2] = o[E + 56 >> 2], o[T + 108 >> 2] = Mr, Mr = o[E + 52 >> 2], o[T + 96 >> 2] = o[E + 48 >> 2], o[T + 100 >> 2] = Mr, gs(k, T + 112 | 0, T + 96 | 0), Mr = o[T + 396 >> 2], o[E + 56 >> 2] = o[T + 392 >> 2], o[E + 60 >> 2] = Mr, Mr = o[T + 388 >> 2], o[E + 48 >> 2] = o[T + 384 >> 2], o[E + 52 >> 2] = Mr, Mr = o[E + 28 >> 2], o[T + 88 >> 2] = o[E + 24 >> 2], o[T + 92 >> 2] = Mr, Mr = o[E + 20 >> 2], o[T + 80 >> 2] = o[E + 16 >> 2], o[T + 84 >> 2] = Mr, Mr = o[E + 44 >> 2], o[T + 72 >> 2] = o[E + 40 >> 2], o[T + 76 >> 2] = Mr, Mr = o[E + 36 >> 2], o[T + 64 >> 2] = o[E + 32 >> 2], o[T + 68 >> 2] = Mr, gs(k, T + 80 | 0, T - -64 | 0), Mr = o[T + 396 >> 2], o[E + 40 >> 2] = o[T + 392 >> 2], o[E + 44 >> 2] = Mr, Mr = o[T + 388 >> 2], o[E + 32 >> 2] = o[T + 384 >> 2], o[E + 36 >> 2] = Mr, Mr = o[E + 12 >> 2], o[T + 56 >> 2] = o[E + 8 >> 2], o[T + 60 >> 2] = Mr, Mr = o[E + 4 >> 2], o[T + 48 >> 2] = o[E >> 2], o[T + 52 >> 2] = Mr, Mr = o[E + 28 >> 2], o[T + 40 >> 2] = o[E + 24 >> 2], o[T + 44 >> 2] = Mr, Mr = o[E + 20 >> 2], o[T + 32 >> 2] = o[E + 16 >> 2], o[T + 36 >> 2] = Mr, gs(k, T + 48 | 0, T + 32 | 0), Mr = o[T + 396 >> 2], o[E + 24 >> 2] = o[T + 392 >> 2], o[E + 28 >> 2] = Mr, Mr = o[T + 388 >> 2], o[E + 16 >> 2] = o[T + 384 >> 2], o[E + 20 >> 2] = Mr, Mr = o[T + 412 >> 2], o[T + 24 >> 2] = o[T + 408 >> 2], o[T + 28 >> 2] = Mr, Mr = o[T + 404 >> 2], o[T + 16 >> 2] = o[T + 400 >> 2], o[T + 20 >> 2] = Mr, Mr = o[E + 12 >> 2], o[T + 8 >> 2] = o[E + 8 >> 2], o[T + 12 >> 2] = Mr, Mr = o[E + 4 >> 2], o[T >> 2] = o[E >> 2], o[T + 4 >> 2] = Mr, gs(k, T + 16 | 0, T), k = o[T + 384 >> 2], Mr = o[T + 388 >> 2], jr = o[T + 392 >> 2], o[E + 12 >> 2] = o[T + 396 >> 2] ^ pr, o[E + 8 >> 2] = jr ^ Ne, o[E + 4 >> 2] = Mr ^ ye, o[E >> 2] = k ^ M, dr = T + 416 | 0;
                    }
                    function Ho(k, E, T) {
                      var M, ye, Ne, pr, ve, cr, gr, Pr, Nr, Br, Mr, jr, ti, fi, Jr = 0, li = 0, Tr = 0;
                      for (dr = M = dr - 288 | 0, Mr = m[E + 4 | 0] | m[E + 5 | 0] << 8 | m[E + 6 | 0] << 16 | m[E + 7 | 0] << 24, jr = m[E + 8 | 0] | m[E + 9 | 0] << 8 | m[E + 10 | 0] << 16 | m[E + 11 | 0] << 24, ti = m[E + 12 | 0] | m[E + 13 | 0] << 8 | m[E + 14 | 0] << 16 | m[E + 15 | 0] << 24, gr = m[k + 4 | 0] | m[k + 5 | 0] << 8 | m[k + 6 | 0] << 16 | m[k + 7 | 0] << 24, Pr = m[k + 8 | 0] | m[k + 9 | 0] << 8 | m[k + 10 | 0] << 16 | m[k + 11 | 0] << 24, Nr = m[k + 12 | 0] | m[k + 13 | 0] << 8 | m[k + 14 | 0] << 16 | m[k + 15 | 0] << 24, fi = m[0 | E] | m[E + 1 | 0] << 8 | m[E + 2 | 0] << 16 | m[E + 3 | 0] << 24, E = T + 112 | 0, k = 33620224 ^ (Br = m[0 | k] | m[k + 1 | 0] << 8 | m[k + 2 | 0] << 16 | m[k + 3 | 0] << 24), o[E >> 2] = k, o[(ve = T + 96 | 0) >> 2] = 1427652059 ^ Br, o[(cr = T + 80 | 0) >> 2] = k, li = Br ^ fi, o[(k = T - -64 | 0) >> 2] = li, o[T + 56 >> 2] = 1110511904, o[T + 60 >> 2] = -584534669, o[(ye = T + 48 | 0) >> 2] = 1427652059, o[ye + 4 >> 2] = -248528275, o[T + 40 >> 2] = 1496785429, o[T + 44 >> 2] = 1652156816, o[(Ne = T + 32 | 0) >> 2] = 33620224, o[Ne + 4 >> 2] = 218629379, o[T + 24 >> 2] = 1110511904, o[T + 28 >> 2] = -584534669, o[(pr = T + 16 | 0) >> 2] = 1427652059, o[pr + 4 >> 2] = -248528275, o[T >> 2] = li, li = 1652156816 ^ Nr, o[T + 124 >> 2] = li, Tr = 1496785429 ^ Pr, o[T + 120 >> 2] = Tr, Jr = 218629379 ^ gr, o[T + 116 >> 2] = Jr, o[T + 108 >> 2] = -584534669 ^ Nr, o[T + 104 >> 2] = 1110511904 ^ Pr, o[T + 100 >> 2] = -248528275 ^ gr, o[T + 92 >> 2] = li, o[T + 88 >> 2] = Tr, o[T + 84 >> 2] = Jr, li = Nr ^ ti, o[T + 76 >> 2] = li, Tr = Pr ^ jr, o[T + 72 >> 2] = Tr, Jr = gr ^ Mr, o[T + 68 >> 2] = Jr, o[T + 12 >> 2] = li, o[T + 8 >> 2] = Tr, o[T + 4 >> 2] = Jr, Tr = 0; li = o[E + 12 >> 2], o[M + 280 >> 2] = o[E + 8 >> 2], o[M + 284 >> 2] = li, li = o[E + 4 >> 2], o[M + 272 >> 2] = o[E >> 2], o[M + 276 >> 2] = li, li = o[ve + 12 >> 2], o[M + 248 >> 2] = o[ve + 8 >> 2], o[M + 252 >> 2] = li, li = o[ve + 4 >> 2], o[M + 240 >> 2] = o[ve >> 2], o[M + 244 >> 2] = li, li = o[E + 12 >> 2], o[M + 232 >> 2] = o[E + 8 >> 2], o[M + 236 >> 2] = li, li = o[E + 4 >> 2], o[M + 224 >> 2] = o[E >> 2], o[M + 228 >> 2] = li, gs(li = M + 256 | 0, M + 240 | 0, M + 224 | 0), Jr = o[M + 268 >> 2], o[E + 8 >> 2] = o[M + 264 >> 2], o[E + 12 >> 2] = Jr, Jr = o[M + 260 >> 2], o[E >> 2] = o[M + 256 >> 2], o[E + 4 >> 2] = Jr, Jr = o[cr + 12 >> 2], o[M + 216 >> 2] = o[cr + 8 >> 2], o[M + 220 >> 2] = Jr, Jr = o[cr + 4 >> 2], o[M + 208 >> 2] = o[cr >> 2], o[M + 212 >> 2] = Jr, Jr = o[ve + 12 >> 2], o[M + 200 >> 2] = o[ve + 8 >> 2], o[M + 204 >> 2] = Jr, Jr = o[ve + 4 >> 2], o[M + 192 >> 2] = o[ve >> 2], o[M + 196 >> 2] = Jr, gs(li, M + 208 | 0, M + 192 | 0), Jr = o[M + 268 >> 2], o[ve + 8 >> 2] = o[M + 264 >> 2], o[ve + 12 >> 2] = Jr, Jr = o[M + 260 >> 2], o[ve >> 2] = o[M + 256 >> 2], o[ve + 4 >> 2] = Jr, Jr = o[k + 12 >> 2], o[M + 184 >> 2] = o[k + 8 >> 2], o[M + 188 >> 2] = Jr, Jr = o[k + 4 >> 2], o[M + 176 >> 2] = o[k >> 2], o[M + 180 >> 2] = Jr, Jr = o[cr + 12 >> 2], o[M + 168 >> 2] = o[cr + 8 >> 2], o[M + 172 >> 2] = Jr, Jr = o[cr + 4 >> 2], o[M + 160 >> 2] = o[cr >> 2], o[M + 164 >> 2] = Jr, gs(li, M + 176 | 0, M + 160 | 0), Jr = o[M + 268 >> 2], o[cr + 8 >> 2] = o[M + 264 >> 2], o[cr + 12 >> 2] = Jr, Jr = o[M + 260 >> 2], o[cr >> 2] = o[M + 256 >> 2], o[cr + 4 >> 2] = Jr, Jr = o[ye + 12 >> 2], o[M + 152 >> 2] = o[ye + 8 >> 2], o[M + 156 >> 2] = Jr, Jr = o[ye + 4 >> 2], o[M + 144 >> 2] = o[ye >> 2], o[M + 148 >> 2] = Jr, Jr = o[k + 12 >> 2], o[M + 136 >> 2] = o[k + 8 >> 2], o[M + 140 >> 2] = Jr, Jr = o[k + 4 >> 2], o[M + 128 >> 2] = o[k >> 2], o[M + 132 >> 2] = Jr, gs(li, M + 144 | 0, M + 128 | 0), Jr = o[M + 268 >> 2], o[k + 8 >> 2] = o[M + 264 >> 2], o[k + 12 >> 2] = Jr, Jr = o[M + 260 >> 2], o[k >> 2] = o[M + 256 >> 2], o[k + 4 >> 2] = Jr, Jr = o[Ne + 12 >> 2], o[M + 120 >> 2] = o[Ne + 8 >> 2], o[M + 124 >> 2] = Jr, Jr = o[Ne + 4 >> 2], o[M + 112 >> 2] = o[Ne >> 2], o[M + 116 >> 2] = Jr, Jr = o[ye + 12 >> 2], o[M + 104 >> 2] = o[ye + 8 >> 2], o[M + 108 >> 2] = Jr, Jr = o[ye + 4 >> 2], o[M + 96 >> 2] = o[ye >> 2], o[M + 100 >> 2] = Jr, gs(li, M + 112 | 0, M + 96 | 0), Jr = o[M + 268 >> 2], o[ye + 8 >> 2] = o[M + 264 >> 2], o[ye + 12 >> 2] = Jr, Jr = o[M + 260 >> 2], o[ye >> 2] = o[M + 256 >> 2], o[ye + 4 >> 2] = Jr, Jr = o[pr + 12 >> 2], o[M + 88 >> 2] = o[pr + 8 >> 2], o[M + 92 >> 2] = Jr, Jr = o[pr + 4 >> 2], o[M + 80 >> 2] = o[pr >> 2], o[M + 84 >> 2] = Jr, Jr = o[Ne + 12 >> 2], o[M + 72 >> 2] = o[Ne + 8 >> 2], o[M + 76 >> 2] = Jr, Jr = o[Ne + 4 >> 2], o[M + 64 >> 2] = o[Ne >> 2], o[M + 68 >> 2] = Jr, gs(li, M + 80 | 0, M - -64 | 0), Jr = o[M + 268 >> 2], o[Ne + 8 >> 2] = o[M + 264 >> 2], o[Ne + 12 >> 2] = Jr, Jr = o[M + 260 >> 2], o[Ne >> 2] = o[M + 256 >> 2], o[Ne + 4 >> 2] = Jr, Jr = o[T + 12 >> 2], o[M + 56 >> 2] = o[T + 8 >> 2], o[M + 60 >> 2] = Jr, Jr = o[T + 4 >> 2], o[M + 48 >> 2] = o[T >> 2], o[M + 52 >> 2] = Jr, Jr = o[pr + 12 >> 2], o[M + 40 >> 2] = o[pr + 8 >> 2], o[M + 44 >> 2] = Jr, Jr = o[pr + 4 >> 2], o[M + 32 >> 2] = o[pr >> 2], o[M + 36 >> 2] = Jr, gs(li, M + 48 | 0, M + 32 | 0), Jr = o[M + 268 >> 2], o[pr + 8 >> 2] = o[M + 264 >> 2], o[pr + 12 >> 2] = Jr, Jr = o[M + 260 >> 2], o[pr >> 2] = o[M + 256 >> 2], o[pr + 4 >> 2] = Jr, Jr = o[M + 284 >> 2], o[M + 24 >> 2] = o[M + 280 >> 2], o[M + 28 >> 2] = Jr, Jr = o[M + 276 >> 2], o[M + 16 >> 2] = o[M + 272 >> 2], o[M + 20 >> 2] = Jr, Jr = o[T + 12 >> 2], o[M + 8 >> 2] = o[T + 8 >> 2], o[M + 12 >> 2] = Jr, Jr = o[T + 4 >> 2], o[M >> 2] = o[T >> 2], o[M + 4 >> 2] = Jr, gs(li, M + 16 | 0, M), li = o[M + 268 >> 2], o[T + 8 >> 2] = o[M + 264 >> 2], o[T + 12 >> 2] = li, li = o[M + 260 >> 2], o[T >> 2] = o[M + 256 >> 2], o[T + 4 >> 2] = li, o[T + 12 >> 2] = (m[T + 12 | 0] | m[T + 13 | 0] << 8 | m[T + 14 | 0] << 16 | m[T + 15 | 0] << 24) ^ ti, o[T + 8 >> 2] = (m[T + 8 | 0] | m[T + 9 | 0] << 8 | m[T + 10 | 0] << 16 | m[T + 11 | 0] << 24) ^ jr, o[T + 4 >> 2] = (m[T + 4 | 0] | m[T + 5 | 0] << 8 | m[T + 6 | 0] << 16 | m[T + 7 | 0] << 24) ^ Mr, o[T >> 2] = (m[0 | T] | m[T + 1 | 0] << 8 | m[T + 2 | 0] << 16 | m[T + 3 | 0] << 24) ^ fi, o[k >> 2] = (m[0 | k] | m[k + 1 | 0] << 8 | m[k + 2 | 0] << 16 | m[k + 3 | 0] << 24) ^ Br, o[T + 68 >> 2] = (m[T + 68 | 0] | m[T + 69 | 0] << 8 | m[T + 70 | 0] << 16 | m[T + 71 | 0] << 24) ^ gr, o[T + 72 >> 2] = (m[T + 72 | 0] | m[T + 73 | 0] << 8 | m[T + 74 | 0] << 16 | m[T + 75 | 0] << 24) ^ Pr, o[T + 76 >> 2] = (m[T + 76 | 0] | m[T + 77 | 0] << 8 | m[T + 78 | 0] << 16 | m[T + 79 | 0] << 24) ^ Nr, (0 | (Tr = Tr + 1 | 0)) != 10; ) ;
                      dr = M + 288 | 0;
                    }
                    function Go(k, E) {
                      var T, M = 0, ye = 0, Ne = 0, pr = 0, ve = 0, cr = 0, gr = 0, Pr = 0, Nr = 0, Br = 0, Mr = 0, jr = 0, ti = 0;
                      if (dr = T = dr - 48 | 0, !((M = Ss(k)) || (M = -26, E - 3 >>> 0 < 4294967294))) {
                        Ne = o[k + 44 >> 2], M = o[k + 48 >> 2], o[T + 4 >> 2] = 0, ye = o[k + 40 >> 2], o[T + 32 >> 2] = M, o[T + 16 >> 2] = -1, o[T + 12 >> 2] = ye, M = ((gr = (ye = M << 3) >>> 0 < Ne >>> 0 ? Ne : ye) >>> 0) / ((Ne = M << 2) >>> 0) | 0, o[T + 24 >> 2] = M, o[T + 28 >> 2] = M << 2, o[T + 20 >> 2] = v(M, Ne), M = o[k + 52 >> 2], o[T + 40 >> 2] = E, o[T + 36 >> 2] = M, Nr = E = dr, dr = M = E - 1152 & -64, E = -25;
                        e: {
                          if (!(!(Ne = T + 4 | 0) | !k) && (ye = un(o[Ne + 20 >> 2] << 3), o[Ne + 4 >> 2] = ye, E = -22, ye)) {
                            t: {
                              if ((E = o[Ne + 16 >> 2]) && (((ye = E << 10) >>> 0) / (E >>> 0) | 0) == 1024 && (E = un(12), o[Ne >> 2] = E, E)) {
                                if (o[E >> 2] = 0, o[E + 4 >> 2] = 0, E = ki(M + 128 | 0, ye), o[9404] = E, E) o[M + 128 >> 2] = 0;
                                else if (E = o[M + 128 >> 2]) break t;
                                js(o[Ne >> 2]), o[Ne >> 2] = 0;
                              }
                              Bh(Ne, o[k + 56 >> 2]), dr = Nr, E = -22;
                              break e;
                            }
                            if (o[o[Ne >> 2] >> 2] = E, o[o[Ne >> 2] + 4 >> 2] = E, o[o[Ne >> 2] + 8 >> 2] = ye, Br = o[Ne + 36 >> 2], Na(E = M + 128 | 0, 0, 0, 64), o[M + 124 >> 2] = o[k + 48 >> 2], E2(E, ye = M + 124 | 0, 4, 0), o[M + 124 >> 2] = o[k + 4 >> 2], E2(E, ye, 4, 0), o[M + 124 >> 2] = o[k + 44 >> 2], E2(E, ye, 4, 0), o[M + 124 >> 2] = o[k + 40 >> 2], E2(E, ye, 4, 0), o[M + 124 >> 2] = 19, E2(E, ye, 4, 0), o[M + 124 >> 2] = Br, E2(E, ye, 4, 0), o[M + 124 >> 2] = o[k + 12 >> 2], E2(E, ye, 4, 0), (ye = o[k + 8 >> 2]) && (E2(E, ye, o[k + 12 >> 2], 0), 1 & B[k + 56 | 0] && (_s(o[k + 8 >> 2], o[k + 12 >> 2]), o[k + 12 >> 2] = 0)), o[M + 124 >> 2] = o[k + 20 >> 2], E2(E = M + 128 | 0, M + 124 | 0, 4, 0), (ye = o[k + 16 >> 2]) && E2(E, ye, o[k + 20 >> 2], 0), o[M + 124 >> 2] = o[k + 28 >> 2], E2(E = M + 128 | 0, M + 124 | 0, 4, 0), (ye = o[k + 24 >> 2]) && (E2(E, ye, o[k + 28 >> 2], 0), 2 & m[k + 56 | 0] && (_s(o[k + 24 >> 2], o[k + 28 >> 2]), o[k + 28 >> 2] = 0)), o[M + 124 >> 2] = o[k + 36 >> 2], E2(E = M + 128 | 0, M + 124 | 0, 4, 0), (ye = o[k + 32 >> 2]) && E2(E, ye, o[k + 36 >> 2], 0), Bu(M + 128 | 0, M + 48 | 0, 64), _s(M + 112 | 0, 8), o[Ne + 28 >> 2]) for (ye = 0; ; ) {
                              for (o[M + 112 >> 2] = 0, o[M + 116 >> 2] = ye, wa(M + 128 | 0, 1024, M + 48 | 0, 72), Br = o[o[Ne >> 2] + 4 >> 2] + (v(o[Ne + 24 >> 2], ye) << 10) | 0, E = 0; pr = (cr = E << 3) + Br | 0, ve = o[4 + (Pr = (gr = M + 128 | 0) + cr | 0) >> 2], o[pr >> 2] = o[Pr >> 2], o[pr + 4 >> 2] = ve, Pr = (pr = 8 | cr) + Br | 0, ve = o[4 + (pr = pr + gr | 0) >> 2], o[Pr >> 2] = o[pr >> 2], o[Pr + 4 >> 2] = ve, Pr = (pr = 16 | cr) + Br | 0, ve = o[4 + (pr = pr + gr | 0) >> 2], o[Pr >> 2] = o[pr >> 2], o[Pr + 4 >> 2] = ve, pr = (cr |= 24) + Br | 0, Pr = o[4 + (cr = cr + gr | 0) >> 2], o[pr >> 2] = o[cr >> 2], o[pr + 4 >> 2] = Pr, (0 | (E = E + 4 | 0)) != 128; ) ;
                              for (o[M + 112 >> 2] = 1, wa(gr, 1024, M + 48 | 0, 72), Br = 1024 + (o[o[Ne >> 2] + 4 >> 2] + (v(o[Ne + 24 >> 2], ye) << 10) | 0) | 0, E = 0; pr = (cr = E << 3) + Br | 0, ve = o[4 + (Pr = (gr = M + 128 | 0) + cr | 0) >> 2], o[pr >> 2] = o[Pr >> 2], o[pr + 4 >> 2] = ve, Pr = (pr = 8 | cr) + Br | 0, ve = o[4 + (pr = pr + gr | 0) >> 2], o[Pr >> 2] = o[pr >> 2], o[Pr + 4 >> 2] = ve, Pr = (pr = 16 | cr) + Br | 0, ve = o[4 + (pr = pr + gr | 0) >> 2], o[Pr >> 2] = o[pr >> 2], o[Pr + 4 >> 2] = ve, pr = (cr |= 24) + Br | 0, gr = o[4 + (cr = cr + gr | 0) >> 2], o[pr >> 2] = o[cr >> 2], o[pr + 4 >> 2] = gr, (0 | (E = E + 4 | 0)) != 128; ) ;
                              if (!((ye = ye + 1 | 0) >>> 0 < d[Ne + 28 >> 2])) break;
                            }
                            _s(M + 128 | 0, 1024), _s(M + 48 | 0, 72), E = 0;
                          }
                          dr = Nr;
                        }
                        if (M = E, !E) {
                          if (o[T + 12 >> 2]) for (; ; ) {
                            if (dr = E = dr - 80 | 0, !(!(Ne = T + 4 | 0) | !o[Ne + 28 >> 2])) {
                              for (B[E + 72 | 0] = 0, o[E + 64 >> 2] = jr, M = 0; o[E + 76 >> 2] = 0, ye = o[E + 76 >> 2], o[E + 56 >> 2] = o[E + 72 >> 2], o[E + 60 >> 2] = ye, o[E + 68 >> 2] = M, ye = o[E + 68 >> 2], o[E + 48 >> 2] = o[E + 64 >> 2], o[E + 52 >> 2] = ye, mi(Ne, E + 48 | 0), (M = M + 1 | 0) >>> 0 < (ye = o[Ne + 28 >> 2]) >>> 0; ) ;
                              if (B[E + 72 | 0] = 1, ye) {
                                for (M = 0; o[E + 76 >> 2] = 0, ye = o[E + 76 >> 2], o[E + 40 >> 2] = o[E + 72 >> 2], o[E + 44 >> 2] = ye, o[E + 68 >> 2] = M, ye = o[E + 68 >> 2], o[E + 32 >> 2] = o[E + 64 >> 2], o[E + 36 >> 2] = ye, mi(Ne, E + 32 | 0), (M = M + 1 | 0) >>> 0 < (ye = o[Ne + 28 >> 2]) >>> 0; ) ;
                                if (B[E + 72 | 0] = 2, ye) {
                                  for (M = 0; o[E + 76 >> 2] = 0, ye = o[E + 76 >> 2], o[E + 24 >> 2] = o[E + 72 >> 2], o[E + 28 >> 2] = ye, o[E + 68 >> 2] = M, ye = o[E + 68 >> 2], o[E + 16 >> 2] = o[E + 64 >> 2], o[E + 20 >> 2] = ye, mi(Ne, E + 16 | 0), (M = M + 1 | 0) >>> 0 < (ye = o[Ne + 28 >> 2]) >>> 0; ) ;
                                  if (B[E + 72 | 0] = 3, ye) for (M = 0; o[E + 76 >> 2] = 0, ye = o[E + 76 >> 2], o[E + 8 >> 2] = o[E + 72 >> 2], o[E + 12 >> 2] = ye, o[E + 68 >> 2] = M, ye = o[E + 68 >> 2], o[E >> 2] = o[E + 64 >> 2], o[E + 4 >> 2] = ye, mi(Ne, E), (M = M + 1 | 0) >>> 0 < d[Ne + 28 >> 2]; ) ;
                                }
                              }
                            }
                            if (dr = E + 80 | 0, !((jr = jr + 1 | 0) >>> 0 < d[T + 12 >> 2])) break;
                          }
                          if (dr = E = dr - 2048 | 0, !(!k | !(M = T + 4 | 0))) {
                            if (jr = o[M + 24 >> 2], fa(E + 1024 | 0, pr = (o[o[M >> 2] + 4 >> 2] + (jr << 10) | 0) - 1024 | 0, 1024), (Pr = o[M + 28 >> 2]) >>> 0 >= 2) for (Br = 1; ; ) {
                              for (Ne = pr + (v(Br, jr) << 10) | 0, cr = 0; ve = o[(Nr = (ye = cr << 3) + (gr = E + 1024 | 0) | 0) >> 2], ti = o[(Mr = ye + Ne | 0) >> 2], Mr = o[Nr + 4 >> 2] ^ o[Mr + 4 >> 2], o[Nr >> 2] = ve ^ ti, o[Nr + 4 >> 2] = Mr, Mr = o[(Nr = (ve = 8 | ye) + gr | 0) >> 2], ti = o[(ve = Ne + ve | 0) >> 2], ve = o[Nr + 4 >> 2] ^ o[ve + 4 >> 2], o[Nr >> 2] = Mr ^ ti, o[Nr + 4 >> 2] = ve, Mr = o[(Nr = (ve = 16 | ye) + gr | 0) >> 2], ti = o[(ve = Ne + ve | 0) >> 2], ve = o[Nr + 4 >> 2] ^ o[ve + 4 >> 2], o[Nr >> 2] = Mr ^ ti, o[Nr + 4 >> 2] = ve, Nr = o[(ye = (Nr = gr) + (gr = 24 | ye) | 0) >> 2], ve = o[(gr = Ne + gr | 0) >> 2], gr = o[ye + 4 >> 2] ^ o[gr + 4 >> 2], o[ye >> 2] = ve ^ Nr, o[ye + 4 >> 2] = gr, (0 | (cr = cr + 4 | 0)) != 128; ) ;
                              if ((0 | Pr) == (0 | (Br = Br + 1 | 0))) break;
                            }
                            Ne = fa(E, E + 1024 | 0, 1024), wa(o[k >> 2], o[k + 4 >> 2], Ne, 1024), _s(Ne + 1024 | 0, 1024), _s(Ne, 1024), Bh(M, o[k + 56 >> 2]);
                          }
                          dr = E + 2048 | 0, M = 0;
                        }
                      }
                      return dr = T + 48 | 0, M;
                    }
                    function ns(k, E, T, M, ye) {
                      var Ne, pr, ve, cr, gr, Pr, Nr, Br, Mr, jr, ti, fi, Jr, li, Tr, Mi = 0, Wi = 0, vn = 0, Tn = 0, Ni = 0, Yi = 0, Xi = 0, $n = 0, Zn = 0, to = 0, fo = 0, wo = 0, bo = 0, go = 0, qn = 0, io = 0, So = 0, qo = 0, Ln = 0, ro = 0, Qo = 0, Vo = 0, as = 0, cs = 0, ms = 0, ai = 0, ci = 0, Fi = 0, Eo = 0, is = 0, ws = 0, ys = 0, Is = 0, ks = 0;
                      for (Ne = dr + -64 | 0, pr = o[k + 60 >> 2], ve = o[k + 56 >> 2], ro = o[k + 52 >> 2], Ln = o[k + 48 >> 2], cr = o[k + 44 >> 2], gr = o[k + 40 >> 2], Pr = o[k + 36 >> 2], Nr = o[k + 32 >> 2], Br = o[k + 28 >> 2], Mr = o[k + 24 >> 2], jr = o[k + 20 >> 2], ti = o[k + 16 >> 2], fi = o[k + 12 >> 2], Jr = o[k + 8 >> 2], li = o[k + 4 >> 2], Tr = o[k >> 2]; ; ) {
                        if (!ye & M >>> 0 > 63 | ye) Mi = T;
                        else {
                          if (o[Ne + 56 >> 2] = 0, o[Ne + 60 >> 2] = 0, o[Ne + 48 >> 2] = 0, o[Ne + 52 >> 2] = 0, o[Ne + 40 >> 2] = 0, o[Ne + 44 >> 2] = 0, o[Ne + 32 >> 2] = 0, o[Ne + 36 >> 2] = 0, o[Ne + 24 >> 2] = 0, o[Ne + 28 >> 2] = 0, o[Ne + 16 >> 2] = 0, o[Ne + 20 >> 2] = 0, o[Ne + 8 >> 2] = 0, o[Ne + 12 >> 2] = 0, o[Ne >> 2] = 0, o[Ne + 4 >> 2] = 0, vn = 0, M | ye) for (; B[vn + Ne | 0] = m[E + vn | 0], !ye & (vn = vn + 1 | 0) >>> 0 < M >>> 0 | ye; ) ;
                          E = Mi = Ne, ms = T;
                        }
                        for (Qo = 20, Wi = Tr, to = li, fo = Jr, go = fi, vn = ti, T = jr, Ni = Mr, Yi = Br, Xi = Nr, io = Pr, wo = gr, Tn = pr, So = ve, qn = ro, bo = Ln, $n = cr; Zn = vn, Wi = ao((vn = Wi + vn | 0) ^ bo, 16), Zn = bo = ao(Zn ^ (Xi = Wi + Xi | 0), 12), bo = ao((qo = vn + bo | 0) ^ Wi, 8), vn = ao(Zn ^ (Xi = bo + Xi | 0), 7), Tn = ao((Wi = Yi + go | 0) ^ Tn, 16), Yi = ao(($n = Tn + $n | 0) ^ Yi, 12), go = ao((fo = Ni + fo | 0) ^ So, 16), Ni = ao((wo = go + wo | 0) ^ Ni, 12), So = (Vo = Wi + Yi | 0) + vn | 0, as = ao((fo = Ni + fo | 0) ^ go, 8), Wi = ao(So ^ as, 16), go = ao((to = T + to | 0) ^ qn, 16), T = ao((io = go + io | 0) ^ T, 12), Zn = vn, qn = ao((to = T + to | 0) ^ go, 8), Zn = ao(Zn ^ (vn = (cs = qn + io | 0) + Wi | 0), 12), So = ao(Wi ^ (go = Zn + So | 0), 8), vn = ao((io = So + vn | 0) ^ Zn, 7), Zn = Xi, Xi = fo, Wi = ao(Tn ^ Vo, 8), fo = ao((Tn = Wi + $n | 0) ^ Yi, 7), qn = ao((Xi = Xi + fo | 0) ^ qn, 16), $n = ao((Yi = Zn + qn | 0) ^ fo, 12), qn = ao(qn ^ (fo = $n + Xi | 0), 8), Yi = ao((Xi = Yi + qn | 0) ^ $n, 7), $n = Tn, Tn = to, to = ao((wo = wo + as | 0) ^ Ni, 7), Ni = $n + (bo = ao((Tn = Tn + to | 0) ^ bo, 16)) | 0, $n = Tn, Tn = ao(Ni ^ to, 12), bo = ao(bo ^ (to = $n + Tn | 0), 8), Ni = ao(($n = Ni + bo | 0) ^ Tn, 7), Zn = wo, Tn = Wi, Wi = ao(T ^ cs, 7), Tn = ao(Tn ^ (wo = Wi + qo | 0), 16), qo = ao((T = Zn + Tn | 0) ^ Wi, 12), Tn = ao(Tn ^ (Wi = qo + wo | 0), 8), T = ao((wo = T + Tn | 0) ^ qo, 7), Qo = Qo - 2 | 0; ) ;
                        if (Qo = m[E + 4 | 0] | m[E + 5 | 0] << 8 | m[E + 6 | 0] << 16 | m[E + 7 | 0] << 24, qo = m[E + 8 | 0] | m[E + 9 | 0] << 8 | m[E + 10 | 0] << 16 | m[E + 11 | 0] << 24, Vo = m[E + 12 | 0] | m[E + 13 | 0] << 8 | m[E + 14 | 0] << 16 | m[E + 15 | 0] << 24, as = m[E + 16 | 0] | m[E + 17 | 0] << 8 | m[E + 18 | 0] << 16 | m[E + 19 | 0] << 24, cs = m[E + 20 | 0] | m[E + 21 | 0] << 8 | m[E + 22 | 0] << 16 | m[E + 23 | 0] << 24, Zn = m[E + 24 | 0] | m[E + 25 | 0] << 8 | m[E + 26 | 0] << 16 | m[E + 27 | 0] << 24, ai = m[E + 28 | 0] | m[E + 29 | 0] << 8 | m[E + 30 | 0] << 16 | m[E + 31 | 0] << 24, ci = m[E + 32 | 0] | m[E + 33 | 0] << 8 | m[E + 34 | 0] << 16 | m[E + 35 | 0] << 24, Fi = m[E + 36 | 0] | m[E + 37 | 0] << 8 | m[E + 38 | 0] << 16 | m[E + 39 | 0] << 24, Eo = m[E + 40 | 0] | m[E + 41 | 0] << 8 | m[E + 42 | 0] << 16 | m[E + 43 | 0] << 24, is = m[E + 44 | 0] | m[E + 45 | 0] << 8 | m[E + 46 | 0] << 16 | m[E + 47 | 0] << 24, ws = m[E + 48 | 0] | m[E + 49 | 0] << 8 | m[E + 50 | 0] << 16 | m[E + 51 | 0] << 24, ys = m[E + 52 | 0] | m[E + 53 | 0] << 8 | m[E + 54 | 0] << 16 | m[E + 55 | 0] << 24, Is = m[E + 56 | 0] | m[E + 57 | 0] << 8 | m[E + 58 | 0] << 16 | m[E + 59 | 0] << 24, ks = m[E + 60 | 0] | m[E + 61 | 0] << 8 | m[E + 62 | 0] << 16 | m[E + 63 | 0] << 24, Wi = Wi + Tr ^ (m[0 | E] | m[E + 1 | 0] << 8 | m[E + 2 | 0] << 16 | m[E + 3 | 0] << 24), B[0 | Mi] = Wi, B[Mi + 1 | 0] = Wi >>> 8, B[Mi + 2 | 0] = Wi >>> 16, B[Mi + 3 | 0] = Wi >>> 24, Wi = Tn + pr ^ ks, B[Mi + 60 | 0] = Wi, B[Mi + 61 | 0] = Wi >>> 8, B[Mi + 62 | 0] = Wi >>> 16, B[Mi + 63 | 0] = Wi >>> 24, Wi = So + ve ^ Is, B[Mi + 56 | 0] = Wi, B[Mi + 57 | 0] = Wi >>> 8, B[Mi + 58 | 0] = Wi >>> 16, B[Mi + 59 | 0] = Wi >>> 24, Wi = qn + ro ^ ys, B[Mi + 52 | 0] = Wi, B[Mi + 53 | 0] = Wi >>> 8, B[Mi + 54 | 0] = Wi >>> 16, B[Mi + 55 | 0] = Wi >>> 24, Wi = bo + Ln ^ ws, B[Mi + 48 | 0] = Wi, B[Mi + 49 | 0] = Wi >>> 8, B[Mi + 50 | 0] = Wi >>> 16, B[Mi + 51 | 0] = Wi >>> 24, Wi = $n + cr ^ is, B[Mi + 44 | 0] = Wi, B[Mi + 45 | 0] = Wi >>> 8, B[Mi + 46 | 0] = Wi >>> 16, B[Mi + 47 | 0] = Wi >>> 24, Wi = wo + gr ^ Eo, B[Mi + 40 | 0] = Wi, B[Mi + 41 | 0] = Wi >>> 8, B[Mi + 42 | 0] = Wi >>> 16, B[Mi + 43 | 0] = Wi >>> 24, Wi = io + Pr ^ Fi, B[Mi + 36 | 0] = Wi, B[Mi + 37 | 0] = Wi >>> 8, B[Mi + 38 | 0] = Wi >>> 16, B[Mi + 39 | 0] = Wi >>> 24, Wi = Xi + Nr ^ ci, B[Mi + 32 | 0] = Wi, B[Mi + 33 | 0] = Wi >>> 8, B[Mi + 34 | 0] = Wi >>> 16, B[Mi + 35 | 0] = Wi >>> 24, Yi = Yi + Br ^ ai, B[Mi + 28 | 0] = Yi, B[Mi + 29 | 0] = Yi >>> 8, B[Mi + 30 | 0] = Yi >>> 16, B[Mi + 31 | 0] = Yi >>> 24, Ni = Zn ^ Ni + Mr, B[Mi + 24 | 0] = Ni, B[Mi + 25 | 0] = Ni >>> 8, B[Mi + 26 | 0] = Ni >>> 16, B[Mi + 27 | 0] = Ni >>> 24, T = cs ^ T + jr, B[Mi + 20 | 0] = T, B[Mi + 21 | 0] = T >>> 8, B[Mi + 22 | 0] = T >>> 16, B[Mi + 23 | 0] = T >>> 24, T = as ^ vn + ti, B[Mi + 16 | 0] = T, B[Mi + 17 | 0] = T >>> 8, B[Mi + 18 | 0] = T >>> 16, B[Mi + 19 | 0] = T >>> 24, T = Vo ^ go + fi, B[Mi + 12 | 0] = T, B[Mi + 13 | 0] = T >>> 8, B[Mi + 14 | 0] = T >>> 16, B[Mi + 15 | 0] = T >>> 24, T = qo ^ fo + Jr, B[Mi + 8 | 0] = T, B[Mi + 9 | 0] = T >>> 8, B[Mi + 10 | 0] = T >>> 16, B[Mi + 11 | 0] = T >>> 24, T = Qo ^ to + li, B[Mi + 4 | 0] = T, B[Mi + 5 | 0] = T >>> 8, B[Mi + 6 | 0] = T >>> 16, B[Mi + 7 | 0] = T >>> 24, ro = !(Ln = Ln + 1 | 0) + ro | 0, !ye & M >>> 0 <= 64) {
                          if (!(!(M | ye) | !ye & M >>> 0 > 63 | !!(0 | ye))) for (vn = 0; B[vn + ms | 0] = m[Mi + vn | 0], M >>> 0 > (vn = vn + 1 | 0) >>> 0; ) ;
                          o[k + 52 >> 2] = ro, o[k + 48 >> 2] = Ln;
                          break;
                        }
                        E = E - -64 | 0, T = Mi - -64 | 0, ye = ye - 1 | 0, ye = (M = M + -64 | 0) >>> 0 < 4294967232 ? ye + 1 | 0 : ye;
                      }
                    }
                    function ds(k, E) {
                      E |= 0;
                      var T, M = 0, ye = 0, Ne = 0, pr = 0, ve = 0, cr = 0, gr = 0;
                      return dr = T = dr - 704 | 0, M = 80 + ((ye = o[72 + (k |= 0) >> 2] >>> 3 & 127) + k | 0) | 0, ye >>> 0 >= 112 ? (fa(M, 35056, 128 - ye | 0), ni(k, ye = k + 80 | 0, T, T + 640 | 0), Ca(ye, 0, 112)) : fa(M, 35056, 112 - ye | 0), cr = (Ne = o[k + 64 >> 2]) << 24 | (65280 & Ne) << 8, ye = (pr = 16711680 & Ne) >>> 8 | 0, gr = pr << 24, pr = (ve = -16777216 & Ne) >>> 24 | 0, M = gr | ve << 8 | -16777216 & ((255 & (M = o[k + 68 >> 2])) << 24 | Ne >>> 8) | 16711680 & ((16777215 & M) << 8 | Ne >>> 24) | M >>> 8 & 65280 | M >>> 24, B[k + 192 | 0] = M, B[k + 193 | 0] = M >>> 8, B[k + 194 | 0] = M >>> 16, B[k + 195 | 0] = M >>> 24, M = ye | pr | cr, ye = 0, ye |= M, B[k + 196 | 0] = ye, B[k + 197 | 0] = ye >>> 8, B[k + 198 | 0] = ye >>> 16, B[k + 199 | 0] = ye >>> 24, cr = (Ne = o[k + 72 >> 2]) << 24 | (65280 & Ne) << 8, ye = (pr = 16711680 & Ne) >>> 8 | 0, gr = pr << 24, pr = (ve = -16777216 & Ne) >>> 24 | 0, M = gr | ve << 8 | -16777216 & ((255 & (M = o[k + 76 >> 2])) << 24 | Ne >>> 8) | 16711680 & ((16777215 & M) << 8 | Ne >>> 24) | M >>> 8 & 65280 | M >>> 24, B[k + 200 | 0] = M, B[k + 201 | 0] = M >>> 8, B[k + 202 | 0] = M >>> 16, B[k + 203 | 0] = M >>> 24, M = ye | pr | cr, ye = 0, ye |= M, B[k + 204 | 0] = ye, B[k + 205 | 0] = ye >>> 8, B[k + 206 | 0] = ye >>> 16, B[k + 207 | 0] = ye >>> 24, ni(k, k + 80 | 0, T, T + 640 | 0), cr = (Ne = o[k >> 2]) << 24 | (65280 & Ne) << 8, ye = (pr = 16711680 & Ne) >>> 8 | 0, gr = pr << 24, pr = (ve = -16777216 & Ne) >>> 24 | 0, M = gr | ve << 8 | -16777216 & ((255 & (M = o[k + 4 >> 2])) << 24 | Ne >>> 8) | 16711680 & ((16777215 & M) << 8 | Ne >>> 24) | M >>> 8 & 65280 | M >>> 24, B[0 | E] = M, B[E + 1 | 0] = M >>> 8, B[E + 2 | 0] = M >>> 16, B[E + 3 | 0] = M >>> 24, M = ye | pr | cr, ye = 0, ye |= M, B[E + 4 | 0] = ye, B[E + 5 | 0] = ye >>> 8, B[E + 6 | 0] = ye >>> 16, B[E + 7 | 0] = ye >>> 24, cr = (Ne = o[k + 8 >> 2]) << 24 | (65280 & Ne) << 8, ye = (pr = 16711680 & Ne) >>> 8 | 0, gr = pr << 24, pr = (ve = -16777216 & Ne) >>> 24 | 0, M = gr | ve << 8 | -16777216 & ((255 & (M = o[k + 12 >> 2])) << 24 | Ne >>> 8) | 16711680 & ((16777215 & M) << 8 | Ne >>> 24) | M >>> 8 & 65280 | M >>> 24, B[E + 8 | 0] = M, B[E + 9 | 0] = M >>> 8, B[E + 10 | 0] = M >>> 16, B[E + 11 | 0] = M >>> 24, M = ye | pr | cr, ye = 0, ye |= M, B[E + 12 | 0] = ye, B[E + 13 | 0] = ye >>> 8, B[E + 14 | 0] = ye >>> 16, B[E + 15 | 0] = ye >>> 24, cr = (Ne = o[k + 16 >> 2]) << 24 | (65280 & Ne) << 8, ye = (pr = 16711680 & Ne) >>> 8 | 0, gr = pr << 24, pr = (ve = -16777216 & Ne) >>> 24 | 0, M = gr | ve << 8 | -16777216 & ((255 & (M = o[k + 20 >> 2])) << 24 | Ne >>> 8) | 16711680 & ((16777215 & M) << 8 | Ne >>> 24) | M >>> 8 & 65280 | M >>> 24, B[E + 16 | 0] = M, B[E + 17 | 0] = M >>> 8, B[E + 18 | 0] = M >>> 16, B[E + 19 | 0] = M >>> 24, M = ye | pr | cr, ye = 0, ye |= M, B[E + 20 | 0] = ye, B[E + 21 | 0] = ye >>> 8, B[E + 22 | 0] = ye >>> 16, B[E + 23 | 0] = ye >>> 24, cr = (Ne = o[k + 24 >> 2]) << 24 | (65280 & Ne) << 8, ye = (pr = 16711680 & Ne) >>> 8 | 0, gr = pr << 24, pr = (ve = -16777216 & Ne) >>> 24 | 0, M = gr | ve << 8 | -16777216 & ((255 & (M = o[k + 28 >> 2])) << 24 | Ne >>> 8) | 16711680 & ((16777215 & M) << 8 | Ne >>> 24) | M >>> 8 & 65280 | M >>> 24, B[E + 24 | 0] = M, B[E + 25 | 0] = M >>> 8, B[E + 26 | 0] = M >>> 16, B[E + 27 | 0] = M >>> 24, M = ye | pr | cr, ye = 0, ye |= M, B[E + 28 | 0] = ye, B[E + 29 | 0] = ye >>> 8, B[E + 30 | 0] = ye >>> 16, B[E + 31 | 0] = ye >>> 24, cr = (Ne = o[k + 32 >> 2]) << 24 | (65280 & Ne) << 8, ye = (pr = 16711680 & Ne) >>> 8 | 0, gr = pr << 24, pr = (ve = -16777216 & Ne) >>> 24 | 0, M = gr | ve << 8 | -16777216 & ((255 & (M = o[k + 36 >> 2])) << 24 | Ne >>> 8) | 16711680 & ((16777215 & M) << 8 | Ne >>> 24) | M >>> 8 & 65280 | M >>> 24, B[E + 32 | 0] = M, B[E + 33 | 0] = M >>> 8, B[E + 34 | 0] = M >>> 16, B[E + 35 | 0] = M >>> 24, M = ye | pr | cr, ye = 0, ye |= M, B[E + 36 | 0] = ye, B[E + 37 | 0] = ye >>> 8, B[E + 38 | 0] = ye >>> 16, B[E + 39 | 0] = ye >>> 24, cr = (Ne = o[k + 40 >> 2]) << 24 | (65280 & Ne) << 8, ye = (pr = 16711680 & Ne) >>> 8 | 0, gr = pr << 24, pr = (ve = -16777216 & Ne) >>> 24 | 0, M = gr | ve << 8 | -16777216 & ((255 & (M = o[k + 44 >> 2])) << 24 | Ne >>> 8) | 16711680 & ((16777215 & M) << 8 | Ne >>> 24) | M >>> 8 & 65280 | M >>> 24, B[E + 40 | 0] = M, B[E + 41 | 0] = M >>> 8, B[E + 42 | 0] = M >>> 16, B[E + 43 | 0] = M >>> 24, M = ye | pr | cr, ye = 0, ye |= M, B[E + 44 | 0] = ye, B[E + 45 | 0] = ye >>> 8, B[E + 46 | 0] = ye >>> 16, B[E + 47 | 0] = ye >>> 24, cr = (Ne = o[k + 48 >> 2]) << 24 | (65280 & Ne) << 8, ye = (pr = 16711680 & Ne) >>> 8 | 0, gr = pr << 24, pr = (ve = -16777216 & Ne) >>> 24 | 0, M = gr | ve << 8 | -16777216 & ((255 & (M = o[k + 52 >> 2])) << 24 | Ne >>> 8) | 16711680 & ((16777215 & M) << 8 | Ne >>> 24) | M >>> 8 & 65280 | M >>> 24, B[E + 48 | 0] = M, B[E + 49 | 0] = M >>> 8, B[E + 50 | 0] = M >>> 16, B[E + 51 | 0] = M >>> 24, M = ye | pr | cr, ye = 0, ye |= M, B[E + 52 | 0] = ye, B[E + 53 | 0] = ye >>> 8, B[E + 54 | 0] = ye >>> 16, B[E + 55 | 0] = ye >>> 24, cr = (Ne = o[k + 56 >> 2]) << 24 | (65280 & Ne) << 8, ye = (pr = 16711680 & Ne) >>> 8 | 0, M = E, gr = pr << 24, pr = (ve = -16777216 & Ne) >>> 24 | 0, E = gr | ve << 8 | -16777216 & ((255 & (E = o[k + 60 >> 2])) << 24 | Ne >>> 8) | 16711680 & ((16777215 & E) << 8 | Ne >>> 24) | E >>> 8 & 65280 | E >>> 24, B[M + 56 | 0] = E, B[M + 57 | 0] = E >>> 8, B[M + 58 | 0] = E >>> 16, B[M + 59 | 0] = E >>> 24, E = ye | pr | cr, E |= ye = 0, B[M + 60 | 0] = E, B[M + 61 | 0] = E >>> 8, B[M + 62 | 0] = E >>> 16, B[M + 63 | 0] = E >>> 24, _s(T, 704), _s(k, 208), dr = T + 704 | 0, 0;
                    }
                    function Ts(k, E, T) {
                      var M, ye, Ne, pr, ve, cr, gr, Pr, Nr, Br, Mr, jr, ti, fi, Jr, li, Tr, Mi, Wi, vn, Tn = 0;
                      dr = M = dr - 224 | 0, cr = m[T + 16 | 0] | m[T + 17 | 0] << 8 | m[T + 18 | 0] << 16 | m[T + 19 | 0] << 24, gr = m[0 | (Tn = T - -64 | 0)] | m[Tn + 1 | 0] << 8 | m[Tn + 2 | 0] << 16 | m[Tn + 3 | 0] << 24, Pr = m[T + 80 | 0] | m[T + 81 | 0] << 8 | m[T + 82 | 0] << 16 | m[T + 83 | 0] << 24, Nr = m[T + 32 | 0] | m[T + 33 | 0] << 8 | m[T + 34 | 0] << 16 | m[T + 35 | 0] << 24, Br = m[T + 48 | 0] | m[T + 49 | 0] << 8 | m[T + 50 | 0] << 16 | m[T + 51 | 0] << 24, ye = m[E + 4 | 0] | m[E + 5 | 0] << 8 | m[E + 6 | 0] << 16 | m[E + 7 | 0] << 24, Mr = m[T + 20 | 0] | m[T + 21 | 0] << 8 | m[T + 22 | 0] << 16 | m[T + 23 | 0] << 24, jr = m[T + 68 | 0] | m[T + 69 | 0] << 8 | m[T + 70 | 0] << 16 | m[T + 71 | 0] << 24, ti = m[T + 84 | 0] | m[T + 85 | 0] << 8 | m[T + 86 | 0] << 16 | m[T + 87 | 0] << 24, fi = m[T + 36 | 0] | m[T + 37 | 0] << 8 | m[T + 38 | 0] << 16 | m[T + 39 | 0] << 24, Jr = m[T + 52 | 0] | m[T + 53 | 0] << 8 | m[T + 54 | 0] << 16 | m[T + 55 | 0] << 24, Ne = m[E + 8 | 0] | m[E + 9 | 0] << 8 | m[E + 10 | 0] << 16 | m[E + 11 | 0] << 24, li = m[T + 24 | 0] | m[T + 25 | 0] << 8 | m[T + 26 | 0] << 16 | m[T + 27 | 0] << 24, Tr = m[T + 72 | 0] | m[T + 73 | 0] << 8 | m[T + 74 | 0] << 16 | m[T + 75 | 0] << 24, Mi = m[T + 88 | 0] | m[T + 89 | 0] << 8 | m[T + 90 | 0] << 16 | m[T + 91 | 0] << 24, Wi = m[T + 40 | 0] | m[T + 41 | 0] << 8 | m[T + 42 | 0] << 16 | m[T + 43 | 0] << 24, vn = m[T + 56 | 0] | m[T + 57 | 0] << 8 | m[T + 58 | 0] << 16 | m[T + 59 | 0] << 24, pr = m[0 | E] | m[E + 1 | 0] << 8 | m[E + 2 | 0] << 16 | m[E + 3 | 0] << 24, E = (ve = m[E + 12 | 0] | m[E + 13 | 0] << 8 | m[E + 14 | 0] << 16 | m[E + 15 | 0] << 24) ^ (m[T + 44 | 0] | m[T + 45 | 0] << 8 | m[T + 46 | 0] << 16 | m[T + 47 | 0] << 24) & (m[T + 60 | 0] | m[T + 61 | 0] << 8 | m[T + 62 | 0] << 16 | m[T + 63 | 0] << 24) ^ (m[T + 28 | 0] | m[T + 29 | 0] << 8 | m[T + 30 | 0] << 16 | m[T + 31 | 0] << 24) ^ (m[T + 92 | 0] | m[T + 93 | 0] << 8 | m[T + 94 | 0] << 16 | m[T + 95 | 0] << 24) ^ (m[T + 76 | 0] | m[T + 77 | 0] << 8 | m[T + 78 | 0] << 16 | m[T + 79 | 0] << 24), B[k + 12 | 0] = E, B[k + 13 | 0] = E >>> 8, B[k + 14 | 0] = E >>> 16, B[k + 15 | 0] = E >>> 24, E = Wi & vn ^ Tr ^ Mi ^ li ^ Ne, B[k + 8 | 0] = E, B[k + 9 | 0] = E >>> 8, B[k + 10 | 0] = E >>> 16, B[k + 11 | 0] = E >>> 24, E = fi & Jr ^ jr ^ ti ^ Mr ^ ye, B[k + 4 | 0] = E, B[k + 5 | 0] = E >>> 8, B[k + 6 | 0] = E >>> 16, B[k + 7 | 0] = E >>> 24, E = Nr & Br ^ cr ^ gr ^ Pr ^ pr, B[0 | k] = E, B[k + 1 | 0] = E >>> 8, B[k + 2 | 0] = E >>> 16, B[k + 3 | 0] = E >>> 24, k = o[T + 92 >> 2], o[M + 216 >> 2] = o[T + 88 >> 2], o[M + 220 >> 2] = k, k = o[T + 84 >> 2], o[M + 208 >> 2] = o[T + 80 >> 2], o[M + 212 >> 2] = k, k = o[T + 76 >> 2], o[M + 184 >> 2] = o[T + 72 >> 2], o[M + 188 >> 2] = k, k = o[Tn + 4 >> 2], o[M + 176 >> 2] = o[Tn >> 2], o[M + 180 >> 2] = k, k = o[T + 92 >> 2], o[M + 168 >> 2] = o[T + 88 >> 2], o[M + 172 >> 2] = k, k = o[T + 84 >> 2], o[M + 160 >> 2] = o[T + 80 >> 2], o[M + 164 >> 2] = k, gs(k = M + 192 | 0, M + 176 | 0, M + 160 | 0), E = o[M + 204 >> 2], o[T + 88 >> 2] = o[M + 200 >> 2], o[T + 92 >> 2] = E, E = o[M + 196 >> 2], o[T + 80 >> 2] = o[M + 192 >> 2], o[T + 84 >> 2] = E, E = o[T + 60 >> 2], o[M + 152 >> 2] = o[T + 56 >> 2], o[M + 156 >> 2] = E, E = o[T + 52 >> 2], o[M + 144 >> 2] = o[T + 48 >> 2], o[M + 148 >> 2] = E, E = o[T + 76 >> 2], o[M + 136 >> 2] = o[T + 72 >> 2], o[M + 140 >> 2] = E, E = o[Tn + 4 >> 2], o[M + 128 >> 2] = o[Tn >> 2], o[M + 132 >> 2] = E, gs(k, M + 144 | 0, M + 128 | 0), E = o[M + 204 >> 2], o[T + 72 >> 2] = o[M + 200 >> 2], o[T + 76 >> 2] = E, E = o[M + 196 >> 2], o[Tn >> 2] = o[M + 192 >> 2], o[Tn + 4 >> 2] = E, E = o[T + 44 >> 2], o[M + 120 >> 2] = o[T + 40 >> 2], o[M + 124 >> 2] = E, E = o[T + 36 >> 2], o[M + 112 >> 2] = o[T + 32 >> 2], o[M + 116 >> 2] = E, E = o[T + 60 >> 2], o[M + 104 >> 2] = o[T + 56 >> 2], o[M + 108 >> 2] = E, E = o[T + 52 >> 2], o[M + 96 >> 2] = o[T + 48 >> 2], o[M + 100 >> 2] = E, gs(k, M + 112 | 0, M + 96 | 0), E = o[M + 204 >> 2], o[T + 56 >> 2] = o[M + 200 >> 2], o[T + 60 >> 2] = E, E = o[M + 196 >> 2], o[T + 48 >> 2] = o[M + 192 >> 2], o[T + 52 >> 2] = E, E = o[T + 28 >> 2], o[M + 88 >> 2] = o[T + 24 >> 2], o[M + 92 >> 2] = E, E = o[T + 20 >> 2], o[M + 80 >> 2] = o[T + 16 >> 2], o[M + 84 >> 2] = E, E = o[T + 44 >> 2], o[M + 72 >> 2] = o[T + 40 >> 2], o[M + 76 >> 2] = E, E = o[T + 36 >> 2], o[M + 64 >> 2] = o[T + 32 >> 2], o[M + 68 >> 2] = E, gs(k, M + 80 | 0, M - -64 | 0), E = o[M + 204 >> 2], o[T + 40 >> 2] = o[M + 200 >> 2], o[T + 44 >> 2] = E, E = o[M + 196 >> 2], o[T + 32 >> 2] = o[M + 192 >> 2], o[T + 36 >> 2] = E, E = o[T + 12 >> 2], o[M + 56 >> 2] = o[T + 8 >> 2], o[M + 60 >> 2] = E, E = o[T + 4 >> 2], o[M + 48 >> 2] = o[T >> 2], o[M + 52 >> 2] = E, E = o[T + 28 >> 2], o[M + 40 >> 2] = o[T + 24 >> 2], o[M + 44 >> 2] = E, E = o[T + 20 >> 2], o[M + 32 >> 2] = o[T + 16 >> 2], o[M + 36 >> 2] = E, gs(k, M + 48 | 0, M + 32 | 0), E = o[M + 204 >> 2], o[T + 24 >> 2] = o[M + 200 >> 2], o[T + 28 >> 2] = E, E = o[M + 196 >> 2], o[T + 16 >> 2] = o[M + 192 >> 2], o[T + 20 >> 2] = E, E = o[M + 220 >> 2], o[M + 24 >> 2] = o[M + 216 >> 2], o[M + 28 >> 2] = E, E = o[M + 212 >> 2], o[M + 16 >> 2] = o[M + 208 >> 2], o[M + 20 >> 2] = E, E = o[T + 12 >> 2], o[M + 8 >> 2] = o[T + 8 >> 2], o[M + 12 >> 2] = E, E = o[T + 4 >> 2], o[M >> 2] = o[T >> 2], o[M + 4 >> 2] = E, gs(k, M + 16 | 0, M), k = o[M + 192 >> 2], E = o[M + 196 >> 2], Tn = o[M + 200 >> 2], o[T + 12 >> 2] = ve ^ o[M + 204 >> 2], o[T + 8 >> 2] = Tn ^ Ne, o[T + 4 >> 2] = E ^ ye, o[T >> 2] = k ^ pr, dr = M + 224 | 0;
                    }
                    function Ao(k, E, T) {
                      var M, ye, Ne, pr, ve, cr, gr, Pr, Nr, Br, Mr, jr, ti, fi, Jr, li = 0, Tr = 0, Mi = 0, Wi = 0, vn = 0;
                      dr = M = dr - 224 | 0, Mi = m[T + 16 | 0] | m[T + 17 | 0] << 8 | m[T + 18 | 0] << 16 | m[T + 19 | 0] << 24, Tr = m[0 | (li = T - -64 | 0)] | m[li + 1 | 0] << 8 | m[li + 2 | 0] << 16 | m[li + 3 | 0] << 24, ye = m[T + 80 | 0] | m[T + 81 | 0] << 8 | m[T + 82 | 0] << 16 | m[T + 83 | 0] << 24, Ne = m[T + 32 | 0] | m[T + 33 | 0] << 8 | m[T + 34 | 0] << 16 | m[T + 35 | 0] << 24, pr = m[T + 48 | 0] | m[T + 49 | 0] << 8 | m[T + 50 | 0] << 16 | m[T + 51 | 0] << 24, Wi = m[T + 20 | 0] | m[T + 21 | 0] << 8 | m[T + 22 | 0] << 16 | m[T + 23 | 0] << 24, ve = m[T + 68 | 0] | m[T + 69 | 0] << 8 | m[T + 70 | 0] << 16 | m[T + 71 | 0] << 24, cr = m[T + 84 | 0] | m[T + 85 | 0] << 8 | m[T + 86 | 0] << 16 | m[T + 87 | 0] << 24, gr = m[E + 4 | 0] | m[E + 5 | 0] << 8 | m[E + 6 | 0] << 16 | m[E + 7 | 0] << 24, Pr = m[T + 36 | 0] | m[T + 37 | 0] << 8 | m[T + 38 | 0] << 16 | m[T + 39 | 0] << 24, Nr = m[T + 52 | 0] | m[T + 53 | 0] << 8 | m[T + 54 | 0] << 16 | m[T + 55 | 0] << 24, vn = m[T + 24 | 0] | m[T + 25 | 0] << 8 | m[T + 26 | 0] << 16 | m[T + 27 | 0] << 24, Br = m[T + 72 | 0] | m[T + 73 | 0] << 8 | m[T + 74 | 0] << 16 | m[T + 75 | 0] << 24, Mr = m[T + 88 | 0] | m[T + 89 | 0] << 8 | m[T + 90 | 0] << 16 | m[T + 91 | 0] << 24, jr = m[E + 8 | 0] | m[E + 9 | 0] << 8 | m[E + 10 | 0] << 16 | m[E + 11 | 0] << 24, ti = m[T + 40 | 0] | m[T + 41 | 0] << 8 | m[T + 42 | 0] << 16 | m[T + 43 | 0] << 24, fi = m[T + 56 | 0] | m[T + 57 | 0] << 8 | m[T + 58 | 0] << 16 | m[T + 59 | 0] << 24, Jr = m[0 | E] | m[E + 1 | 0] << 8 | m[E + 2 | 0] << 16 | m[E + 3 | 0] << 24, E = (m[T + 44 | 0] | m[T + 45 | 0] << 8 | m[T + 46 | 0] << 16 | m[T + 47 | 0] << 24) & (m[T + 60 | 0] | m[T + 61 | 0] << 8 | m[T + 62 | 0] << 16 | m[T + 63 | 0] << 24) ^ (m[T + 28 | 0] | m[T + 29 | 0] << 8 | m[T + 30 | 0] << 16 | m[T + 31 | 0] << 24) ^ (m[T + 76 | 0] | m[T + 77 | 0] << 8 | m[T + 78 | 0] << 16 | m[T + 79 | 0] << 24) ^ (m[T + 92 | 0] | m[T + 93 | 0] << 8 | m[T + 94 | 0] << 16 | m[T + 95 | 0] << 24) ^ (m[E + 12 | 0] | m[E + 13 | 0] << 8 | m[E + 14 | 0] << 16 | m[E + 15 | 0] << 24), B[k + 12 | 0] = E, B[k + 13 | 0] = E >>> 8, B[k + 14 | 0] = E >>> 16, B[k + 15 | 0] = E >>> 24, vn = ti & fi ^ vn ^ Mr ^ jr ^ Br, B[k + 8 | 0] = vn, B[k + 9 | 0] = vn >>> 8, B[k + 10 | 0] = vn >>> 16, B[k + 11 | 0] = vn >>> 24, Wi = Pr & Nr ^ Wi ^ cr ^ gr ^ ve, B[k + 4 | 0] = Wi, B[k + 5 | 0] = Wi >>> 8, B[k + 6 | 0] = Wi >>> 16, B[k + 7 | 0] = Wi >>> 24, Mi = Ne & pr ^ Mi ^ Tr ^ ye ^ Jr, B[0 | k] = Mi, B[k + 1 | 0] = Mi >>> 8, B[k + 2 | 0] = Mi >>> 16, B[k + 3 | 0] = Mi >>> 24, k = o[T + 92 >> 2], o[M + 216 >> 2] = o[T + 88 >> 2], o[M + 220 >> 2] = k, k = o[T + 84 >> 2], o[M + 208 >> 2] = o[T + 80 >> 2], o[M + 212 >> 2] = k, k = o[T + 76 >> 2], o[M + 184 >> 2] = o[T + 72 >> 2], o[M + 188 >> 2] = k, k = o[li + 4 >> 2], o[M + 176 >> 2] = o[li >> 2], o[M + 180 >> 2] = k, k = o[T + 92 >> 2], o[M + 168 >> 2] = o[T + 88 >> 2], o[M + 172 >> 2] = k, k = o[T + 84 >> 2], o[M + 160 >> 2] = o[T + 80 >> 2], o[M + 164 >> 2] = k, gs(k = M + 192 | 0, M + 176 | 0, M + 160 | 0), Tr = o[M + 204 >> 2], o[T + 88 >> 2] = o[M + 200 >> 2], o[T + 92 >> 2] = Tr, Tr = o[M + 196 >> 2], o[T + 80 >> 2] = o[M + 192 >> 2], o[T + 84 >> 2] = Tr, Tr = o[T + 60 >> 2], o[M + 152 >> 2] = o[T + 56 >> 2], o[M + 156 >> 2] = Tr, Tr = o[T + 52 >> 2], o[M + 144 >> 2] = o[T + 48 >> 2], o[M + 148 >> 2] = Tr, Tr = o[T + 76 >> 2], o[M + 136 >> 2] = o[T + 72 >> 2], o[M + 140 >> 2] = Tr, Tr = o[li + 4 >> 2], o[M + 128 >> 2] = o[li >> 2], o[M + 132 >> 2] = Tr, gs(k, M + 144 | 0, M + 128 | 0), Tr = o[M + 204 >> 2], o[T + 72 >> 2] = o[M + 200 >> 2], o[T + 76 >> 2] = Tr, Tr = o[M + 196 >> 2], o[li >> 2] = o[M + 192 >> 2], o[li + 4 >> 2] = Tr, li = o[T + 44 >> 2], o[M + 120 >> 2] = o[T + 40 >> 2], o[M + 124 >> 2] = li, li = o[T + 36 >> 2], o[M + 112 >> 2] = o[T + 32 >> 2], o[M + 116 >> 2] = li, li = o[T + 60 >> 2], o[M + 104 >> 2] = o[T + 56 >> 2], o[M + 108 >> 2] = li, li = o[T + 52 >> 2], o[M + 96 >> 2] = o[T + 48 >> 2], o[M + 100 >> 2] = li, gs(k, M + 112 | 0, M + 96 | 0), li = o[M + 204 >> 2], o[T + 56 >> 2] = o[M + 200 >> 2], o[T + 60 >> 2] = li, li = o[M + 196 >> 2], o[T + 48 >> 2] = o[M + 192 >> 2], o[T + 52 >> 2] = li, li = o[T + 28 >> 2], o[M + 88 >> 2] = o[T + 24 >> 2], o[M + 92 >> 2] = li, li = o[T + 20 >> 2], o[M + 80 >> 2] = o[T + 16 >> 2], o[M + 84 >> 2] = li, li = o[T + 44 >> 2], o[M + 72 >> 2] = o[T + 40 >> 2], o[M + 76 >> 2] = li, li = o[T + 36 >> 2], o[M + 64 >> 2] = o[T + 32 >> 2], o[M + 68 >> 2] = li, gs(k, M + 80 | 0, M - -64 | 0), li = o[M + 204 >> 2], o[T + 40 >> 2] = o[M + 200 >> 2], o[T + 44 >> 2] = li, li = o[M + 196 >> 2], o[T + 32 >> 2] = o[M + 192 >> 2], o[T + 36 >> 2] = li, li = o[T + 12 >> 2], o[M + 56 >> 2] = o[T + 8 >> 2], o[M + 60 >> 2] = li, li = o[T + 4 >> 2], o[M + 48 >> 2] = o[T >> 2], o[M + 52 >> 2] = li, li = o[T + 28 >> 2], o[M + 40 >> 2] = o[T + 24 >> 2], o[M + 44 >> 2] = li, li = o[T + 20 >> 2], o[M + 32 >> 2] = o[T + 16 >> 2], o[M + 36 >> 2] = li, gs(k, M + 48 | 0, M + 32 | 0), li = o[M + 204 >> 2], o[T + 24 >> 2] = o[M + 200 >> 2], o[T + 28 >> 2] = li, li = o[M + 196 >> 2], o[T + 16 >> 2] = o[M + 192 >> 2], o[T + 20 >> 2] = li, li = o[M + 220 >> 2], o[M + 24 >> 2] = o[M + 216 >> 2], o[M + 28 >> 2] = li, li = o[M + 212 >> 2], o[M + 16 >> 2] = o[M + 208 >> 2], o[M + 20 >> 2] = li, li = o[T + 12 >> 2], o[M + 8 >> 2] = o[T + 8 >> 2], o[M + 12 >> 2] = li, li = o[T + 4 >> 2], o[M >> 2] = o[T >> 2], o[M + 4 >> 2] = li, gs(k, M + 16 | 0, M), k = o[M + 192 >> 2], li = o[M + 196 >> 2], Tr = o[M + 200 >> 2], o[T + 12 >> 2] = E ^ o[M + 204 >> 2], o[T + 8 >> 2] = Tr ^ vn, o[T + 4 >> 2] = li ^ Wi, o[T >> 2] = k ^ Mi, dr = M + 224 | 0;
                    }
                    function po(k, E) {
                      var T, M, ye, Ne, pr, ve, cr, gr, Pr, Nr, Br = 0, Mr = 0, jr = 0, ti = 0, fi = 0, Jr = 0, li = 0, Tr = 0, Mi = 0, Wi = 0, vn = 0, Tn = 0, Ni = 0, Yi = 0, Xi = 0, $n = 0, Zn = 0, to = 0, fo = 0, wo = 0, bo = 0, go = 0, qn = 0, io = 0, So = 0, qo = 0, Ln = 0, ro = 0, Qo = 0, Vo = 0, as = 0, cs = 0, ms = 0, ai = 0;
                      dr = T = dr - 800 | 0, Br = o[E + 44 >> 2], jr = o[E + 84 >> 2], ti = o[E + 48 >> 2], fi = o[E + 88 >> 2], Jr = o[E + 52 >> 2], Mr = o[E + 92 >> 2], Wi = o[E + 56 >> 2], li = o[E + 96 >> 2], Yi = o[E + 60 >> 2], vn = o[E + 100 >> 2], $n = o[(Xi = E - -64 | 0) >> 2], Zn = o[E + 104 >> 2], to = o[E + 68 >> 2], fo = o[E + 108 >> 2], wo = o[E + 72 >> 2], bo = o[E + 112 >> 2], go = o[E + 40 >> 2], qn = o[E + 80 >> 2], Tr = o[E + 76 >> 2], Mi = o[E + 116 >> 2], o[T + 324 >> 2] = Tr + Mi, o[T + 320 >> 2] = wo + bo, o[T + 316 >> 2] = to + fo, o[T + 312 >> 2] = $n + Zn, o[T + 308 >> 2] = vn + Yi, o[T + 304 >> 2] = li + Wi, o[T + 300 >> 2] = Mr + Jr, o[T + 296 >> 2] = ti + fi, o[T + 292 >> 2] = Br + jr, o[T + 288 >> 2] = go + qn, o[T + 36 >> 2] = Mi - Tr, o[T + 32 >> 2] = bo - wo, o[T + 28 >> 2] = fo - to, o[T + 24 >> 2] = Zn - $n, o[T + 20 >> 2] = vn - Yi, o[T + 16 >> 2] = li - Wi, o[T + 12 >> 2] = Mr - Jr, o[T + 8 >> 2] = fi - ti, o[T + 4 >> 2] = jr - Br, o[T >> 2] = qn - go, Ti(Br = T + 288 | 0, Br, T), Ti(ti = T + 240 | 0, E, Jr = E + 40 | 0), qi(jr = T + 192 | 0, ti), Ti(jr, Br, jr), o[T + 452 >> 2] = 0, o[T + 456 >> 2] = 0, o[T + 460 >> 2] = 0, o[T + 464 >> 2] = 0, o[T + 468 >> 2] = 0, o[T + 436 >> 2] = 0, o[T + 440 >> 2] = 0, o[T + 444 >> 2] = 0, o[T + 448 >> 2] = 0, o[T + 432 >> 2] = 1, zo(fi = T + 576 | 0, T + 432 | 0, jr), Ti(jr = T + 720 | 0, fi, Br), Ti(Yi = T + 672 | 0, fi, ti), Ti(li = T + 48 | 0, jr, Yi), Ti(li, li, Br = E + 120 | 0), Ti(T + 528 | 0, E, 1632), Ti(T + 480 | 0, Jr, 1632), Ti(T + 624 | 0, jr, 2944), Ti(jr = T + 336 | 0, Br, li), i2(Wi = T + 384 | 0, jr), Mr = m[T + 384 | 0], jr = o[E + 36 >> 2], Br = o[E + 32 >> 2], o[T + 176 >> 2] = Br, o[T + 180 >> 2] = jr, ti = o[E + 28 >> 2], jr = o[E + 24 >> 2], o[T + 168 >> 2] = jr, o[T + 172 >> 2] = ti, fi = o[E + 20 >> 2], ti = o[E + 16 >> 2], o[T + 160 >> 2] = ti, o[T + 164 >> 2] = fi, Jr = o[E + 12 >> 2], fi = o[E + 8 >> 2], o[T + 152 >> 2] = fi, o[T + 156 >> 2] = Jr, vn = o[E + 4 >> 2], Jr = o[E >> 2], o[T + 144 >> 2] = Jr, o[T + 148 >> 2] = vn, vn = o[E + 44 >> 2], $n = o[E + 48 >> 2], Zn = o[E + 52 >> 2], to = o[E + 56 >> 2], fo = o[E + 60 >> 2], wo = o[Xi >> 2], bo = o[E + 68 >> 2], go = o[E + 72 >> 2], qn = o[E + 76 >> 2], Xi = o[E + 40 >> 2], qo = o[T + 484 >> 2], Tr = o[T + 148 >> 2], Ln = o[T + 492 >> 2], Mi = o[T + 156 >> 2], ro = o[T + 500 >> 2], Tn = o[T + 164 >> 2], Qo = o[T + 508 >> 2], Ni = o[T + 172 >> 2], Vo = o[T + 516 >> 2], io = o[T + 180 >> 2], as = o[T + 480 >> 2], cs = o[T + 488 >> 2], ms = o[T + 496 >> 2], ai = o[T + 504 >> 2], Mr = 0 - (1 & Mr) | 0, o[T + 176 >> 2] = Br ^ Mr & (Br ^ o[T + 512 >> 2]), o[T + 168 >> 2] = jr ^ Mr & (jr ^ ai), o[T + 160 >> 2] = ti ^ Mr & (ti ^ ms), o[T + 152 >> 2] = fi ^ Mr & (fi ^ cs), o[T + 144 >> 2] = Jr ^ Mr & (Jr ^ as), o[T + 180 >> 2] = io ^ Mr & (io ^ Vo), o[T + 172 >> 2] = Ni ^ Mr & (Ni ^ Qo), o[T + 164 >> 2] = Tn ^ Mr & (Tn ^ ro), o[T + 156 >> 2] = Mi ^ Mr & (Mi ^ Ln), o[T + 148 >> 2] = Tr ^ Mr & (Tr ^ qo), io = o[T + 528 >> 2], qo = o[T + 532 >> 2], Ln = o[T + 536 >> 2], ro = o[T + 540 >> 2], Qo = o[T + 544 >> 2], Vo = o[T + 548 >> 2], as = o[T + 552 >> 2], cs = o[T + 556 >> 2], ms = o[T + 560 >> 2], ai = o[T + 564 >> 2], Br = o[T + 672 >> 2], M = o[T + 624 >> 2], jr = o[T + 676 >> 2], ye = o[T + 628 >> 2], ti = o[T + 680 >> 2], Ne = o[T + 632 >> 2], fi = o[T + 684 >> 2], pr = o[T + 636 >> 2], Jr = o[T + 688 >> 2], ve = o[T + 640 >> 2], Tr = o[T + 692 >> 2], cr = o[T + 644 >> 2], Mi = o[T + 696 >> 2], gr = o[T + 648 >> 2], Tn = o[T + 700 >> 2], Pr = o[T + 652 >> 2], Ni = o[T + 704 >> 2], Nr = o[T + 656 >> 2], So = o[T + 708 >> 2], o[T + 708 >> 2] = So ^ Mr & (o[T + 660 >> 2] ^ So), o[T + 704 >> 2] = Ni ^ Mr & (Ni ^ Nr), o[T + 700 >> 2] = Tn ^ Mr & (Tn ^ Pr), o[T + 696 >> 2] = Mi ^ Mr & (Mi ^ gr), o[T + 692 >> 2] = Tr ^ Mr & (Tr ^ cr), o[T + 688 >> 2] = Jr ^ Mr & (Jr ^ ve), o[T + 684 >> 2] = fi ^ Mr & (fi ^ pr), o[T + 680 >> 2] = ti ^ Mr & (ti ^ Ne), o[T + 676 >> 2] = jr ^ Mr & (jr ^ ye), o[T + 672 >> 2] = Br ^ Mr & (Br ^ M), Ti(Br = T + 96 | 0, T + 144 | 0, li), i2(Wi, Br), jr = o[E + 84 >> 2], ti = o[E + 88 >> 2], fi = o[E + 92 >> 2], Jr = o[E + 96 >> 2], li = o[E + 100 >> 2], Tr = o[E + 104 >> 2], Mi = o[E + 108 >> 2], Tn = o[E + 112 >> 2], Ni = o[E + 80 >> 2], So = o[E + 116 >> 2], E = 0 - (1 & B[T + 384 | 0]) | 0, Br = qn ^ Mr & (qn ^ ai), o[T + 420 >> 2] = So - (E & (0 - Br ^ Br) ^ Br), Br = go ^ Mr & (go ^ ms), o[T + 416 >> 2] = Tn - (E & (0 - Br ^ Br) ^ Br), Br = bo ^ Mr & (bo ^ cs), o[T + 412 >> 2] = Mi - (E & (0 - Br ^ Br) ^ Br), Br = wo ^ Mr & (wo ^ as), o[T + 408 >> 2] = Tr - (E & (0 - Br ^ Br) ^ Br), Br = fo ^ Mr & (fo ^ Vo), o[T + 404 >> 2] = li - (E & (0 - Br ^ Br) ^ Br), Br = to ^ Mr & (to ^ Qo), o[T + 400 >> 2] = Jr - (E & (0 - Br ^ Br) ^ Br), Br = Zn ^ Mr & (Zn ^ ro), o[T + 396 >> 2] = fi - (E & (0 - Br ^ Br) ^ Br), Br = $n ^ Mr & ($n ^ Ln), o[T + 392 >> 2] = ti - (E & (0 - Br ^ Br) ^ Br), Br = vn ^ Mr & (vn ^ qo), o[T + 388 >> 2] = jr - (E & (0 - Br ^ Br) ^ Br), Br = E, E = Xi ^ Mr & (Xi ^ io), o[T + 384 >> 2] = Ni - (Br & (0 - E ^ E) ^ E), Ti(Wi, Yi, Wi), i2(T + 768 | 0, Wi), E = 0 - (1 & B[T + 768 | 0]) | 0, Br = o[T + 384 >> 2], o[T + 384 >> 2] = E & (0 - Br ^ Br) ^ Br, Br = o[T + 388 >> 2], o[T + 388 >> 2] = E & (0 - Br ^ Br) ^ Br, Br = o[T + 392 >> 2], o[T + 392 >> 2] = E & (0 - Br ^ Br) ^ Br, Br = o[T + 396 >> 2], o[T + 396 >> 2] = E & (0 - Br ^ Br) ^ Br, Br = o[T + 400 >> 2], o[T + 400 >> 2] = E & (0 - Br ^ Br) ^ Br, Br = o[T + 404 >> 2], o[T + 404 >> 2] = E & (0 - Br ^ Br) ^ Br, Br = o[T + 408 >> 2], o[T + 408 >> 2] = E & (0 - Br ^ Br) ^ Br, Br = o[T + 412 >> 2], o[T + 412 >> 2] = E & (0 - Br ^ Br) ^ Br, Br = o[T + 416 >> 2], o[T + 416 >> 2] = E & (0 - Br ^ Br) ^ Br, Br = E, E = o[T + 420 >> 2], o[T + 420 >> 2] = Br & (0 - E ^ E) ^ E, i2(k, Wi), dr = T + 800 | 0;
                    }
                    function _o(k, E) {
                      var T, M, ye, Ne, pr, ve, cr, gr, Pr, Nr = 0, Br = 0;
                      dr = T = dr - 288 | 0, M = m[k + 28 | 0] | m[k + 29 | 0] << 8 | m[k + 30 | 0] << 16 | m[k + 31 | 0] << 24, ye = m[k + 24 | 0] | m[k + 25 | 0] << 8 | m[k + 26 | 0] << 16 | m[k + 27 | 0] << 24, Ne = m[k + 20 | 0] | m[k + 21 | 0] << 8 | m[k + 22 | 0] << 16 | m[k + 23 | 0] << 24, pr = m[k + 16 | 0] | m[k + 17 | 0] << 8 | m[k + 18 | 0] << 16 | m[k + 19 | 0] << 24, ve = m[k + 4 | 0] | m[k + 5 | 0] << 8 | m[k + 6 | 0] << 16 | m[k + 7 | 0] << 24, cr = m[k + 8 | 0] | m[k + 9 | 0] << 8 | m[k + 10 | 0] << 16 | m[k + 11 | 0] << 24, gr = m[k + 12 | 0] | m[k + 13 | 0] << 8 | m[k + 14 | 0] << 16 | m[k + 15 | 0] << 24, Pr = m[0 | k] | m[k + 1 | 0] << 8 | m[k + 2 | 0] << 16 | m[k + 3 | 0] << 24, k = o[E + 124 >> 2], o[T + 280 >> 2] = o[E + 120 >> 2], o[T + 284 >> 2] = k, k = o[E + 116 >> 2], o[T + 272 >> 2] = o[E + 112 >> 2], o[T + 276 >> 2] = k, k = o[E + 108 >> 2], o[T + 248 >> 2] = o[E + 104 >> 2], o[T + 252 >> 2] = k, k = o[E + 100 >> 2], o[T + 240 >> 2] = o[E + 96 >> 2], o[T + 244 >> 2] = k, k = o[E + 124 >> 2], o[T + 232 >> 2] = o[E + 120 >> 2], o[T + 236 >> 2] = k, k = o[E + 116 >> 2], o[T + 224 >> 2] = o[E + 112 >> 2], o[T + 228 >> 2] = k, gs(Br = T + 256 | 0, T + 240 | 0, T + 224 | 0), k = o[T + 268 >> 2], o[E + 120 >> 2] = o[T + 264 >> 2], o[E + 124 >> 2] = k, k = o[T + 260 >> 2], o[E + 112 >> 2] = o[T + 256 >> 2], o[E + 116 >> 2] = k, k = o[E + 92 >> 2], o[T + 216 >> 2] = o[E + 88 >> 2], o[T + 220 >> 2] = k, k = o[E + 84 >> 2], o[T + 208 >> 2] = o[E + 80 >> 2], o[T + 212 >> 2] = k, k = o[E + 108 >> 2], o[T + 200 >> 2] = o[E + 104 >> 2], o[T + 204 >> 2] = k, k = o[E + 100 >> 2], o[T + 192 >> 2] = o[E + 96 >> 2], o[T + 196 >> 2] = k, gs(Br, T + 208 | 0, T + 192 | 0), k = o[T + 268 >> 2], o[E + 104 >> 2] = o[T + 264 >> 2], o[E + 108 >> 2] = k, k = o[T + 260 >> 2], o[E + 96 >> 2] = o[T + 256 >> 2], o[E + 100 >> 2] = k, k = o[E + 76 >> 2], o[T + 184 >> 2] = o[E + 72 >> 2], o[T + 188 >> 2] = k, Nr = o[4 + (k = E - -64 | 0) >> 2], o[T + 176 >> 2] = o[k >> 2], o[T + 180 >> 2] = Nr, Nr = o[E + 92 >> 2], o[T + 168 >> 2] = o[E + 88 >> 2], o[T + 172 >> 2] = Nr, Nr = o[E + 84 >> 2], o[T + 160 >> 2] = o[E + 80 >> 2], o[T + 164 >> 2] = Nr, gs(Br, T + 176 | 0, T + 160 | 0), Nr = o[T + 268 >> 2], o[E + 88 >> 2] = o[T + 264 >> 2], o[E + 92 >> 2] = Nr, Nr = o[T + 260 >> 2], o[E + 80 >> 2] = o[T + 256 >> 2], o[E + 84 >> 2] = Nr, Nr = o[E + 60 >> 2], o[T + 152 >> 2] = o[E + 56 >> 2], o[T + 156 >> 2] = Nr, Nr = o[E + 52 >> 2], o[T + 144 >> 2] = o[E + 48 >> 2], o[T + 148 >> 2] = Nr, Nr = o[E + 76 >> 2], o[T + 136 >> 2] = o[E + 72 >> 2], o[T + 140 >> 2] = Nr, Nr = o[k + 4 >> 2], o[T + 128 >> 2] = o[k >> 2], o[T + 132 >> 2] = Nr, gs(Br, T + 144 | 0, T + 128 | 0), Nr = o[T + 268 >> 2], o[E + 72 >> 2] = o[T + 264 >> 2], o[E + 76 >> 2] = Nr, Nr = o[T + 260 >> 2], o[k >> 2] = o[T + 256 >> 2], o[k + 4 >> 2] = Nr, Nr = o[E + 44 >> 2], o[T + 120 >> 2] = o[E + 40 >> 2], o[T + 124 >> 2] = Nr, Nr = o[E + 36 >> 2], o[T + 112 >> 2] = o[E + 32 >> 2], o[T + 116 >> 2] = Nr, Nr = o[E + 60 >> 2], o[T + 104 >> 2] = o[E + 56 >> 2], o[T + 108 >> 2] = Nr, Nr = o[E + 52 >> 2], o[T + 96 >> 2] = o[E + 48 >> 2], o[T + 100 >> 2] = Nr, gs(Br, T + 112 | 0, T + 96 | 0), Nr = o[T + 268 >> 2], o[E + 56 >> 2] = o[T + 264 >> 2], o[E + 60 >> 2] = Nr, Nr = o[T + 260 >> 2], o[E + 48 >> 2] = o[T + 256 >> 2], o[E + 52 >> 2] = Nr, Nr = o[E + 28 >> 2], o[T + 88 >> 2] = o[E + 24 >> 2], o[T + 92 >> 2] = Nr, Nr = o[E + 20 >> 2], o[T + 80 >> 2] = o[E + 16 >> 2], o[T + 84 >> 2] = Nr, Nr = o[E + 44 >> 2], o[T + 72 >> 2] = o[E + 40 >> 2], o[T + 76 >> 2] = Nr, Nr = o[E + 36 >> 2], o[T + 64 >> 2] = o[E + 32 >> 2], o[T + 68 >> 2] = Nr, gs(Br, T + 80 | 0, T - -64 | 0), Nr = o[T + 268 >> 2], o[E + 40 >> 2] = o[T + 264 >> 2], o[E + 44 >> 2] = Nr, Nr = o[T + 260 >> 2], o[E + 32 >> 2] = o[T + 256 >> 2], o[E + 36 >> 2] = Nr, Nr = o[E + 12 >> 2], o[T + 56 >> 2] = o[E + 8 >> 2], o[T + 60 >> 2] = Nr, Nr = o[E + 4 >> 2], o[T + 48 >> 2] = o[E >> 2], o[T + 52 >> 2] = Nr, Nr = o[E + 28 >> 2], o[T + 40 >> 2] = o[E + 24 >> 2], o[T + 44 >> 2] = Nr, Nr = o[E + 20 >> 2], o[T + 32 >> 2] = o[E + 16 >> 2], o[T + 36 >> 2] = Nr, gs(Br, T + 48 | 0, T + 32 | 0), Nr = o[T + 268 >> 2], o[E + 24 >> 2] = o[T + 264 >> 2], o[E + 28 >> 2] = Nr, Nr = o[T + 260 >> 2], o[E + 16 >> 2] = o[T + 256 >> 2], o[E + 20 >> 2] = Nr, Nr = o[T + 284 >> 2], o[T + 24 >> 2] = o[T + 280 >> 2], o[T + 28 >> 2] = Nr, Nr = o[T + 276 >> 2], o[T + 16 >> 2] = o[T + 272 >> 2], o[T + 20 >> 2] = Nr, Nr = o[E + 12 >> 2], o[T + 8 >> 2] = o[E + 8 >> 2], o[T + 12 >> 2] = Nr, Nr = o[E + 4 >> 2], o[T >> 2] = o[E >> 2], o[T + 4 >> 2] = Nr, gs(Br, T + 16 | 0, T), Br = o[T + 268 >> 2], o[E + 8 >> 2] = o[T + 264 >> 2], o[E + 12 >> 2] = Br, Br = o[T + 260 >> 2], o[E >> 2] = o[T + 256 >> 2], o[E + 4 >> 2] = Br, o[E + 12 >> 2] = (m[E + 12 | 0] | m[E + 13 | 0] << 8 | m[E + 14 | 0] << 16 | m[E + 15 | 0] << 24) ^ gr, o[E + 8 >> 2] = (m[E + 8 | 0] | m[E + 9 | 0] << 8 | m[E + 10 | 0] << 16 | m[E + 11 | 0] << 24) ^ cr, o[E + 4 >> 2] = (m[E + 4 | 0] | m[E + 5 | 0] << 8 | m[E + 6 | 0] << 16 | m[E + 7 | 0] << 24) ^ ve, o[E >> 2] = (m[0 | E] | m[E + 1 | 0] << 8 | m[E + 2 | 0] << 16 | m[E + 3 | 0] << 24) ^ Pr, o[k >> 2] = (m[0 | k] | m[k + 1 | 0] << 8 | m[k + 2 | 0] << 16 | m[k + 3 | 0] << 24) ^ pr, o[E + 68 >> 2] = (m[E + 68 | 0] | m[E + 69 | 0] << 8 | m[E + 70 | 0] << 16 | m[E + 71 | 0] << 24) ^ Ne, o[E + 72 >> 2] = (m[E + 72 | 0] | m[E + 73 | 0] << 8 | m[E + 74 | 0] << 16 | m[E + 75 | 0] << 24) ^ ye, o[E + 76 >> 2] = (m[E + 76 | 0] | m[E + 77 | 0] << 8 | m[E + 78 | 0] << 16 | m[E + 79 | 0] << 24) ^ M, dr = T + 288 | 0;
                    }
                    function Uo(k, E, T, M) {
                      var ye, Ne, pr, ve, cr, gr, Pr, Nr, Br, Mr, jr, ti, fi, Jr, li, Tr, Mi = 0, Wi = 0, vn = 0, Tn = 0;
                      dr = ye = dr - 240 | 0, o[ye + 200 >> 2] = 0, o[ye + 204 >> 2] = 0, o[ye + 192 >> 2] = 0, o[ye + 196 >> 2] = 0, fa(Wi = ye + 192 | 0, E, T), vn = m[M + 16 | 0] | m[M + 17 | 0] << 8 | m[M + 18 | 0] << 16 | m[M + 19 | 0] << 24, Tn = m[0 | (E = M - -64 | 0)] | m[E + 1 | 0] << 8 | m[E + 2 | 0] << 16 | m[E + 3 | 0] << 24, Mi = m[M + 80 | 0] | m[M + 81 | 0] << 8 | m[M + 82 | 0] << 16 | m[M + 83 | 0] << 24, Ne = m[M + 32 | 0] | m[M + 33 | 0] << 8 | m[M + 34 | 0] << 16 | m[M + 35 | 0] << 24, pr = m[M + 48 | 0] | m[M + 49 | 0] << 8 | m[M + 50 | 0] << 16 | m[M + 51 | 0] << 24, ve = m[M + 20 | 0] | m[M + 21 | 0] << 8 | m[M + 22 | 0] << 16 | m[M + 23 | 0] << 24, cr = m[M + 68 | 0] | m[M + 69 | 0] << 8 | m[M + 70 | 0] << 16 | m[M + 71 | 0] << 24, gr = m[M + 84 | 0] | m[M + 85 | 0] << 8 | m[M + 86 | 0] << 16 | m[M + 87 | 0] << 24, Pr = m[M + 36 | 0] | m[M + 37 | 0] << 8 | m[M + 38 | 0] << 16 | m[M + 39 | 0] << 24, Nr = m[M + 52 | 0] | m[M + 53 | 0] << 8 | m[M + 54 | 0] << 16 | m[M + 55 | 0] << 24, Br = m[M + 24 | 0] | m[M + 25 | 0] << 8 | m[M + 26 | 0] << 16 | m[M + 27 | 0] << 24, Mr = m[M + 72 | 0] | m[M + 73 | 0] << 8 | m[M + 74 | 0] << 16 | m[M + 75 | 0] << 24, jr = m[M + 88 | 0] | m[M + 89 | 0] << 8 | m[M + 90 | 0] << 16 | m[M + 91 | 0] << 24, ti = m[M + 40 | 0] | m[M + 41 | 0] << 8 | m[M + 42 | 0] << 16 | m[M + 43 | 0] << 24, fi = m[M + 56 | 0] | m[M + 57 | 0] << 8 | m[M + 58 | 0] << 16 | m[M + 59 | 0] << 24, Jr = o[ye + 192 >> 2], li = o[ye + 196 >> 2], Tr = o[ye + 200 >> 2], o[ye + 204 >> 2] = (m[M + 44 | 0] | m[M + 45 | 0] << 8 | m[M + 46 | 0] << 16 | m[M + 47 | 0] << 24) & (m[M + 60 | 0] | m[M + 61 | 0] << 8 | m[M + 62 | 0] << 16 | m[M + 63 | 0] << 24) ^ (m[M + 28 | 0] | m[M + 29 | 0] << 8 | m[M + 30 | 0] << 16 | m[M + 31 | 0] << 24) ^ (m[M + 76 | 0] | m[M + 77 | 0] << 8 | m[M + 78 | 0] << 16 | m[M + 79 | 0] << 24) ^ o[ye + 204 >> 2] ^ (m[M + 92 | 0] | m[M + 93 | 0] << 8 | m[M + 94 | 0] << 16 | m[M + 95 | 0] << 24), o[ye + 200 >> 2] = ti & fi ^ jr ^ Tr ^ Mr ^ Br, o[ye + 196 >> 2] = Pr & Nr ^ gr ^ li ^ cr ^ ve, o[ye + 192 >> 2] = Ne & pr ^ vn ^ Tn ^ Mi ^ Jr, Ca(T + Wi | 0, 0, 16 - T | 0), fa(k, Wi, T), T = o[ye + 192 >> 2], Wi = o[ye + 196 >> 2], vn = o[ye + 200 >> 2], Tn = o[ye + 204 >> 2], k = o[M + 92 >> 2], o[ye + 232 >> 2] = o[M + 88 >> 2], o[ye + 236 >> 2] = k, k = o[M + 84 >> 2], o[ye + 224 >> 2] = o[M + 80 >> 2], o[ye + 228 >> 2] = k, k = o[M + 76 >> 2], o[ye + 184 >> 2] = o[M + 72 >> 2], o[ye + 188 >> 2] = k, k = o[E + 4 >> 2], o[ye + 176 >> 2] = o[E >> 2], o[ye + 180 >> 2] = k, k = o[M + 92 >> 2], o[ye + 168 >> 2] = o[M + 88 >> 2], o[ye + 172 >> 2] = k, k = o[M + 84 >> 2], o[ye + 160 >> 2] = o[M + 80 >> 2], o[ye + 164 >> 2] = k, gs(k = ye + 208 | 0, ye + 176 | 0, ye + 160 | 0), Mi = o[ye + 220 >> 2], o[M + 88 >> 2] = o[ye + 216 >> 2], o[M + 92 >> 2] = Mi, Mi = o[ye + 212 >> 2], o[M + 80 >> 2] = o[ye + 208 >> 2], o[M + 84 >> 2] = Mi, Mi = o[M + 60 >> 2], o[ye + 152 >> 2] = o[M + 56 >> 2], o[ye + 156 >> 2] = Mi, Mi = o[M + 52 >> 2], o[ye + 144 >> 2] = o[M + 48 >> 2], o[ye + 148 >> 2] = Mi, Mi = o[M + 76 >> 2], o[ye + 136 >> 2] = o[M + 72 >> 2], o[ye + 140 >> 2] = Mi, Mi = o[E + 4 >> 2], o[ye + 128 >> 2] = o[E >> 2], o[ye + 132 >> 2] = Mi, gs(k, ye + 144 | 0, ye + 128 | 0), Mi = o[ye + 220 >> 2], o[M + 72 >> 2] = o[ye + 216 >> 2], o[M + 76 >> 2] = Mi, Mi = o[ye + 212 >> 2], o[E >> 2] = o[ye + 208 >> 2], o[E + 4 >> 2] = Mi, E = o[M + 44 >> 2], o[ye + 120 >> 2] = o[M + 40 >> 2], o[ye + 124 >> 2] = E, E = o[M + 36 >> 2], o[ye + 112 >> 2] = o[M + 32 >> 2], o[ye + 116 >> 2] = E, E = o[M + 60 >> 2], o[ye + 104 >> 2] = o[M + 56 >> 2], o[ye + 108 >> 2] = E, E = o[M + 52 >> 2], o[ye + 96 >> 2] = o[M + 48 >> 2], o[ye + 100 >> 2] = E, gs(k, ye + 112 | 0, ye + 96 | 0), E = o[ye + 220 >> 2], o[M + 56 >> 2] = o[ye + 216 >> 2], o[M + 60 >> 2] = E, E = o[ye + 212 >> 2], o[M + 48 >> 2] = o[ye + 208 >> 2], o[M + 52 >> 2] = E, E = o[M + 28 >> 2], o[ye + 88 >> 2] = o[M + 24 >> 2], o[ye + 92 >> 2] = E, E = o[M + 20 >> 2], o[ye + 80 >> 2] = o[M + 16 >> 2], o[ye + 84 >> 2] = E, E = o[M + 44 >> 2], o[ye + 72 >> 2] = o[M + 40 >> 2], o[ye + 76 >> 2] = E, E = o[M + 36 >> 2], o[ye + 64 >> 2] = o[M + 32 >> 2], o[ye + 68 >> 2] = E, gs(k, ye + 80 | 0, ye - -64 | 0), E = o[ye + 220 >> 2], o[M + 40 >> 2] = o[ye + 216 >> 2], o[M + 44 >> 2] = E, E = o[ye + 212 >> 2], o[M + 32 >> 2] = o[ye + 208 >> 2], o[M + 36 >> 2] = E, E = o[M + 12 >> 2], o[ye + 56 >> 2] = o[M + 8 >> 2], o[ye + 60 >> 2] = E, E = o[M + 4 >> 2], o[ye + 48 >> 2] = o[M >> 2], o[ye + 52 >> 2] = E, E = o[M + 28 >> 2], o[ye + 40 >> 2] = o[M + 24 >> 2], o[ye + 44 >> 2] = E, E = o[M + 20 >> 2], o[ye + 32 >> 2] = o[M + 16 >> 2], o[ye + 36 >> 2] = E, gs(k, ye + 48 | 0, ye + 32 | 0), E = o[ye + 220 >> 2], o[M + 24 >> 2] = o[ye + 216 >> 2], o[M + 28 >> 2] = E, E = o[ye + 212 >> 2], o[M + 16 >> 2] = o[ye + 208 >> 2], o[M + 20 >> 2] = E, E = o[ye + 236 >> 2], o[ye + 24 >> 2] = o[ye + 232 >> 2], o[ye + 28 >> 2] = E, E = o[ye + 228 >> 2], o[ye + 16 >> 2] = o[ye + 224 >> 2], o[ye + 20 >> 2] = E, E = o[M + 12 >> 2], o[ye + 8 >> 2] = o[M + 8 >> 2], o[ye + 12 >> 2] = E, E = o[M + 4 >> 2], o[ye >> 2] = o[M >> 2], o[ye + 4 >> 2] = E, gs(k, ye + 16 | 0, ye), k = o[ye + 208 >> 2], E = o[ye + 212 >> 2], Mi = o[ye + 216 >> 2], o[M + 12 >> 2] = Tn ^ o[ye + 220 >> 2], o[M + 8 >> 2] = Mi ^ vn, o[M + 4 >> 2] = E ^ Wi, o[M >> 2] = k ^ T, dr = ye + 240 | 0;
                    }
                    function ts(k, E, T, M, ye) {
                      k |= 0, E |= 0, T |= 0, M |= 0;
                      var Ne = 0, pr = 0, ve = 0, cr = 0, gr = 0, Pr = 0, Nr = 0, Br = 0, Mr = 0, jr = 0, ti = 0, fi = 0, Jr = 0, li = 0, Tr = 0, Mi = 0;
                      if (ve = 1886610805 ^ (M = m[0 | (ye |= 0)] | m[ye + 1 | 0] << 8 | m[ye + 2 | 0] << 16 | m[ye + 3 | 0] << 24), pr = 1936682341 ^ (Ne = m[ye + 4 | 0] | m[ye + 5 | 0] << 8 | m[ye + 6 | 0] << 16 | m[ye + 7 | 0] << 24), gr = 1852142177 ^ M, cr = 1819895653 ^ Ne, Ne = 1852075885 ^ (M = m[ye + 8 | 0] | m[ye + 9 | 0] << 8 | m[ye + 10 | 0] << 16 | m[ye + 11 | 0] << 24), ye = 1685025377 ^ (Nr = m[ye + 12 | 0] | m[ye + 13 | 0] << 8 | m[ye + 14 | 0] << 16 | m[ye + 15 | 0] << 24), Pr = 2037671283 ^ M, Nr ^= 1952801890, (0 | (ti = (E + T | 0) - (Mr = 7 & T) | 0)) != (0 | E)) for (; Pr = gr = gr + (M = Pr ^ (li = m[0 | E] | m[E + 1 | 0] << 8 | m[E + 2 | 0] << 16 | m[E + 3 | 0] << 24)) | 0, cr = cr + (Nr ^= Tr = m[E + 4 | 0] | m[E + 5 | 0] << 8 | m[E + 6 | 0] << 16 | m[E + 7 | 0] << 24) | 0, cr = M >>> 0 > gr >>> 0 ? cr + 1 | 0 : cr, pr = ye + pr | 0, pr = (jr = ve) >>> 0 > (ve = Ne + ve | 0) >>> 0 ? pr + 1 | 0 : pr, ye = gr + (Ne = Ci(Ne, ye, 13) ^ ve) | 0, gr = cr + (Br = Qe ^ pr) | 0, Br = Ci(Ne, Br, 17) ^ ye, fi = Ci(Br, gr = (jr = ye >>> 0 < Ne >>> 0 ? gr + 1 | 0 : gr) ^ Qe, 13), Jr = Qe, M = Ci(M, Nr, 16), Ne = cr ^ Qe, cr = M ^ Pr, ve = Ci(ve, pr, 32), Pr = gr, gr = Qe + Ne | 0, Pr = 1 + (ve = Pr + (pr = (M = cr + ve | 0) >>> 0 < ve >>> 0 ? gr + 1 | 0 : gr) | 0) | 0, gr = ve, gr = (ve = M + Br | 0) >>> 0 < M >>> 0 ? Pr : gr, fi = Ci(Pr = ve ^ fi, Nr = gr ^ Jr, 17), Jr = Qe, Ne = Ci(cr, Ne, 21), pr ^= Qe, Mi = M ^ Ne, ye = Ci(ye, jr, 32), Ne = Qe + pr | 0, ye = Nr + (jr = (M = Mi + ye | 0) >>> 0 < ye >>> 0 ? Ne + 1 | 0 : Ne) | 0, Ne = (cr = M + Pr | 0) ^ fi, ye = (Br = cr >>> 0 < M >>> 0 ? ye + 1 | 0 : ye) ^ Jr, pr = Ci(Mi, pr, 16), Nr = Pr = jr ^ Qe, pr = Ci(M ^= pr, Pr, 21), jr = Qe, Pr = (M = (ve = Ci(ve, gr, 32)) + M | 0) ^ pr, gr = Qe + Nr | 0, Nr = (pr = M >>> 0 < ve >>> 0 ? gr + 1 | 0 : gr) ^ jr, gr = Ci(cr, Br, 32), cr = Qe, ve = M ^ li, pr ^= Tr, (0 | ti) != (0 | (E = E + 8 | 0)); ) ;
                      switch (T <<= 24, M = 0, Mr - 1 | 0) {
                        case 6:
                          T |= m[E + 6 | 0] << 16;
                        case 5:
                          T |= m[E + 5 | 0] << 8;
                        case 4:
                          T |= m[E + 4 | 0];
                        case 3:
                          Br = (M = m[E + 3 | 0]) >>> 8 | 0, M <<= 24, T |= Br;
                        case 2:
                          M |= (Br = m[E + 2 | 0]) << 16, T |= Mr = Br >>> 16 | 0;
                        case 1:
                          M |= (Br = m[E + 1 | 0]) << 8, T |= Mr = Br >>> 24 | 0;
                        case 0:
                          M = m[0 | E] | M;
                      }
                      return Nr = Ci(E = M ^ Pr, Pr = T ^ Nr, 16), cr = cr + Pr | 0, gr = (E = E + gr | 0) >>> 0 < gr >>> 0 ? cr + 1 | 0 : cr, Nr = Ci(cr = E ^ Nr, Pr = gr ^ Qe, 21), Br = Qe, jr = 1 + (pr = ye + pr | 0) | 0, Mr = pr, Mr = ve = ve >>> 0 > (pr = Ne + ve | 0) >>> 0 ? jr : Mr, ti = Ci(pr, ve, 32), Pr = Qe + Pr | 0, Br = Ci(cr = Nr ^ (ve = cr + ti | 0), Nr = Br ^ (Pr = ve >>> 0 < ti >>> 0 ? Pr + 1 | 0 : Pr), 16), ti = Qe, ye = Ci(Ne, ye, 13) ^ pr, Ne = (Ne = gr) + (gr = Qe ^ Mr) | 0, Mr = Ci(E = E + ye | 0, pr = E >>> 0 < ye >>> 0 ? Ne + 1 | 0 : Ne, 32), Nr = Qe + Nr | 0, Mr = Ci(cr = Br ^ (Ne = cr + Mr | 0), Br = (Nr = Ne >>> 0 < Mr >>> 0 ? Nr + 1 | 0 : Nr) ^ ti, 21), ti = Qe, E = ve + (ye = gr = Ci(ye, gr, 17) ^ E) | 0, ve = (pr ^= Qe) + Pr | 0, Pr = ye = E >>> 0 < ye >>> 0 ? ve + 1 | 0 : ve, jr = Mr, ve = cr + (Mr = Ci(E, ye, 32)) | 0, cr = Qe + Br | 0, Mr = Ci(ye = jr ^ ve, Br = (cr = ve >>> 0 < Mr >>> 0 ? cr + 1 | 0 : cr) ^ ti, 16), ti = Qe, jr = Ne, pr = Ci(gr, pr, 13) ^ E, gr = (Pr ^= Qe) + Nr | 0, Nr = Ne = (E = jr + (Ne = pr) | 0) >>> 0 < Ne >>> 0 ? gr + 1 | 0 : gr, Ne = Ci(E, Ne, 32), gr = Br + Qe | 0, Br = (jr = ye) >>> 0 > (ye = ye + (255 ^ Ne) | 0) >>> 0 ? gr + 1 | 0 : gr, Mr = Ci(gr = ye ^ Mr, Ne = ti ^ Br, 21), ti = Qe, pr = Ci(pr, Pr, 17) ^ E, T = (Pr = Nr ^ Qe) + (T ^ cr) | 0, cr = T = (E = pr + (M ^= ve) | 0) >>> 0 < M >>> 0 ? T + 1 | 0 : T, T = Ci(E, T, 32), M = Ne + Qe | 0, gr = Ci(ve = (T = T + gr | 0) ^ Mr, M = (Ne = T >>> 0 < gr >>> 0 ? M + 1 | 0 : M) ^ ti, 16), Nr = Qe, pr = Ci(pr, Pr, 13) ^ E, Pr = Br + (cr ^= Qe) | 0, Pr = ye = (E = ye + pr | 0) >>> 0 < ye >>> 0 ? Pr + 1 | 0 : Pr, ye = Ci(E, ye, 32), Mr = Nr, jr = 1 + (M = M + Qe | 0) | 0, Nr = M, Nr = (M = ye + ve | 0) >>> 0 < ve >>> 0 ? jr : Nr, gr = Ci(ve = M ^ gr, ye = Mr ^ Nr, 21), Br = Qe, pr = Ci(pr, cr, 17), jr = 1 + (Ne = Ne + (cr = Pr ^ Qe) | 0) | 0, Pr = Ne, pr = E = (Mr = T) >>> 0 > (T = T + (Ne = E ^ pr) | 0) >>> 0 ? jr : Pr, E = Ci(T, E, 32), ye = ye + Qe | 0, Pr = (E = E + ve | 0) >>> 0 < ve >>> 0 ? ye + 1 | 0 : ye, gr = Ci(ve = E ^ gr, ye = Pr ^ Br, 16), Br = Qe, Ne = Ci(Ne, cr, 13), cr = Nr + (pr ^= Qe) | 0, cr = T = (Nr = M) >>> 0 > (M = M + (Ne ^= T) | 0) >>> 0 ? cr + 1 | 0 : cr, T = Ci(M, T, 32), ye = ye + Qe | 0, Nr = (T = T + ve | 0) >>> 0 < ve >>> 0 ? ye + 1 | 0 : ye, gr = Ci(ve = T ^ gr, ye = Nr ^ Br, 21), Br = Qe, Ne = Ci(Ne, pr, 17), Mr = 1 + (cr = Pr + (pr = cr ^ Qe) | 0) | 0, Pr = cr, E = Ci(M = E + (cr = M ^ Ne) | 0, Ne = M >>> 0 < E >>> 0 ? Mr : Pr, 32), ye = ye + Qe | 0, Pr = (E = E + ve | 0) >>> 0 < ve >>> 0 ? ye + 1 | 0 : ye, gr = Ci(ve = E ^ gr, ye = Pr ^ Br, 16), Br = Qe, pr = Ci(cr, pr, 13), cr = Nr + (Ne ^= Qe) | 0, cr = T = (M = T + (pr ^= M) | 0) >>> 0 < T >>> 0 ? cr + 1 | 0 : cr, T = Ci(M, T, 32), ye = ye + Qe | 0, ve = Ci((T = T + ve | 0) ^ gr, (ye = T >>> 0 < ve >>> 0 ? ye + 1 | 0 : ye) ^ Br, 21), gr = Qe, M = Ci(pr, Ne, 17) ^ M, pr = Ci(M, Ne = cr ^ Qe, 13), Ne = Ne + Pr | 0, E = Qe ^ (E >>> 0 > (M = E + M | 0) >>> 0 ? Ne + 1 : Ne), ve = Ci(M ^= pr, E, 17) ^ ve, Ne = Qe ^ gr, cr = 1 + (E = E + ye | 0) | 0, ye = E, E = Ci(E = T + M | 0, T = T >>> 0 > E >>> 0 ? cr : ye, 32) ^ ve ^ E, B[0 | k] = E, B[k + 1 | 0] = E >>> 8, B[k + 2 | 0] = E >>> 16, B[k + 3 | 0] = E >>> 24, E = T ^ Qe ^ Ne, B[k + 4 | 0] = E, B[k + 5 | 0] = E >>> 8, B[k + 6 | 0] = E >>> 16, B[k + 7 | 0] = E >>> 24, 0;
                    }
                    function Lo(k, E) {
                      var T, M, ye, Ne, pr, ve = 0, cr = 0, gr = 0, Pr = 0, Nr = 0, Br = 0, Mr = 0, jr = 0, ti = 0, fi = 0, Jr = 0, li = 0, Tr = 0, Mi = 0, Wi = 0, vn = 0, Tn = 0, Ni = 0, Yi = 0, Xi = 0, $n = 0, Zn = 0, to = 0, fo = 0, wo = 0, bo = 0, go = 0, qn = 0, io = 0, So = 0, qo = 0;
                      dr = T = dr - 624 | 0, qi(ve = T + 480 | 0, E), Ti(ve, 1632, ve), gr = o[T + 516 >> 2], o[T + 276 >> 2] = gr, Pr = o[T + 512 >> 2], o[T + 272 >> 2] = Pr, Nr = o[T + 508 >> 2], o[T + 268 >> 2] = Nr, Br = o[T + 504 >> 2], o[T + 264 >> 2] = Br, Mr = o[T + 500 >> 2], o[T + 260 >> 2] = Mr, jr = o[T + 496 >> 2], o[T + 256 >> 2] = jr, ti = o[T + 492 >> 2], o[T + 252 >> 2] = ti, fi = o[T + 488 >> 2], o[T + 248 >> 2] = fi, Jr = o[T + 484 >> 2], o[T + 244 >> 2] = Jr, Tr = o[T + 480 >> 2], o[T + 240 >> 2] = Tr + 1, Ti(cr = T + 240 | 0, cr, 33968), o[T + 468 >> 2] = gr - 12055116, o[T + 464 >> 2] = Pr - 18696448, o[T + 460 >> 2] = Nr - 3247719, o[T + 456 >> 2] = Br - 6275908, o[T + 452 >> 2] = Mr - 8787816, o[T + 448 >> 2] = jr + 114729, o[T + 444 >> 2] = ti + 6949391, o[T + 440 >> 2] = fi - 15372611, o[T + 436 >> 2] = Jr + 13857413, o[T + 432 >> 2] = Tr - 10913610, Ti(li = T + 192 | 0, ve, 1584), o[T + 228 >> 2] = 0 - o[T + 228 >> 2], o[T + 224 >> 2] = 0 - o[T + 224 >> 2], o[T + 220 >> 2] = 0 - o[T + 220 >> 2], o[T + 216 >> 2] = 0 - o[T + 216 >> 2], o[T + 212 >> 2] = 0 - o[T + 212 >> 2], o[T + 208 >> 2] = 0 - o[T + 208 >> 2], o[T + 204 >> 2] = 0 - o[T + 204 >> 2], o[T + 200 >> 2] = 0 - o[T + 200 >> 2], o[T + 196 >> 2] = 0 - o[T + 196 >> 2], o[T + 192 >> 2] = ~o[T + 192 >> 2], Ti(li, li, T + 432 | 0), ve = zo(M = T + 384 | 0, cr, li), Ti(cr = T + 336 | 0, M, E), i2(ye = T + 576 | 0, cr), pr = m[T + 576 | 0], to = o[T + 420 >> 2], cr = o[T + 372 >> 2], fo = o[T + 416 >> 2], Mi = o[T + 368 >> 2], wo = o[T + 412 >> 2], Wi = o[T + 364 >> 2], bo = o[T + 408 >> 2], vn = o[T + 360 >> 2], go = o[T + 404 >> 2], Tn = o[T + 356 >> 2], qn = o[T + 400 >> 2], Ni = o[T + 352 >> 2], io = o[T + 396 >> 2], Yi = o[T + 348 >> 2], So = o[T + 392 >> 2], Xi = o[T + 344 >> 2], qo = o[T + 388 >> 2], $n = o[T + 340 >> 2], Ne = o[T + 384 >> 2], Zn = o[T + 336 >> 2], E = ve - 1 | 0, o[T + 612 >> 2] = E & gr, o[T + 608 >> 2] = E & Pr, o[T + 604 >> 2] = E & Nr, o[T + 600 >> 2] = E & Br, o[T + 596 >> 2] = E & Mr, o[T + 592 >> 2] = E & jr, o[T + 588 >> 2] = E & ti, o[T + 584 >> 2] = E & fi, o[T + 580 >> 2] = E & Jr, o[T + 576 >> 2] = Tr | 0 - ve, Zn = E & (0 - (Zn ^ (ve = 0 - (1 & pr) | 0) & (Zn ^ 0 - Zn)) ^ Ne) ^ Ne, o[T + 384 >> 2] = Zn, $n = qo ^ E & (qo ^ 0 - ($n ^ ve & ($n ^ 0 - $n))), o[T + 388 >> 2] = $n, Xi = So ^ E & (So ^ 0 - (Xi ^ ve & (Xi ^ 0 - Xi))), o[T + 392 >> 2] = Xi, Yi = io ^ E & (io ^ 0 - (Yi ^ ve & (Yi ^ 0 - Yi))), o[T + 396 >> 2] = Yi, Ni = qn ^ E & (qn ^ 0 - (Ni ^ ve & (Ni ^ 0 - Ni))), o[T + 400 >> 2] = Ni, Tn = go ^ E & (go ^ 0 - (Tn ^ ve & (Tn ^ 0 - Tn))), o[T + 404 >> 2] = Tn, vn = bo ^ E & (bo ^ 0 - (vn ^ ve & (vn ^ 0 - vn))), o[T + 408 >> 2] = vn, Wi = wo ^ E & (wo ^ 0 - (Wi ^ ve & (Wi ^ 0 - Wi))), o[T + 412 >> 2] = Wi, Mi = fo ^ E & (fo ^ 0 - (Mi ^ ve & (Mi ^ 0 - Mi))), o[T + 416 >> 2] = Mi, ve = to ^ E & (to ^ 0 - (cr ^ ve & (cr ^ 0 - cr))), o[T + 420 >> 2] = ve, o[T + 564 >> 2] = gr, o[T + 560 >> 2] = Pr, o[T + 556 >> 2] = Nr, o[T + 552 >> 2] = Br, o[T + 548 >> 2] = Mr, o[T + 544 >> 2] = jr, o[T + 540 >> 2] = ti, o[T + 536 >> 2] = fi, o[T + 532 >> 2] = Jr, o[T + 528 >> 2] = Tr - 1, Ti(E = T + 528 | 0, E, ye), Ti(E, E, 34016), gr = o[T + 192 >> 2], Pr = o[T + 528 >> 2], Nr = o[T + 196 >> 2], Br = o[T + 532 >> 2], Mr = o[T + 200 >> 2], jr = o[T + 536 >> 2], ti = o[T + 204 >> 2], fi = o[T + 540 >> 2], Jr = o[T + 208 >> 2], Tr = o[T + 544 >> 2], cr = o[T + 212 >> 2], to = o[T + 548 >> 2], fo = o[T + 216 >> 2], wo = o[T + 552 >> 2], bo = o[T + 220 >> 2], go = o[T + 556 >> 2], qn = o[T + 224 >> 2], io = o[T + 560 >> 2], So = o[T + 228 >> 2], qo = o[T + 564 >> 2], o[T + 180 >> 2] = ve << 1, o[T + 176 >> 2] = Mi << 1, o[T + 172 >> 2] = Wi << 1, o[T + 168 >> 2] = vn << 1, o[T + 164 >> 2] = Tn << 1, o[T + 160 >> 2] = Ni << 1, o[T + 156 >> 2] = Yi << 1, o[T + 152 >> 2] = Xi << 1, o[T + 148 >> 2] = $n << 1, o[T + 144 >> 2] = Zn << 1, o[T + 564 >> 2] = qo - So, o[T + 560 >> 2] = io - qn, o[T + 556 >> 2] = go - bo, o[T + 552 >> 2] = wo - fo, o[T + 548 >> 2] = to - cr, o[T + 544 >> 2] = Tr - Jr, o[T + 540 >> 2] = fi - ti, o[T + 536 >> 2] = jr - Mr, o[T + 532 >> 2] = Br - Nr, o[T + 528 >> 2] = Pr - gr, Ti(ve = T + 144 | 0, ve, li), Ti(li = T + 96 | 0, E, 34064), qi(T + 288 | 0, M), E = o[T + 324 >> 2], o[T + 84 >> 2] = 0 - E, gr = o[T + 320 >> 2], o[T + 80 >> 2] = 0 - gr, Pr = o[T + 316 >> 2], o[T + 76 >> 2] = 0 - Pr, Nr = o[T + 312 >> 2], o[T + 72 >> 2] = 0 - Nr, Br = o[T + 308 >> 2], o[T + 68 >> 2] = 0 - Br, Mr = o[T + 304 >> 2], o[T + 64 >> 2] = 0 - Mr, jr = o[T + 300 >> 2], o[T + 60 >> 2] = 0 - jr, ti = o[T + 296 >> 2], o[T + 56 >> 2] = 0 - ti, fi = o[T + 292 >> 2], o[T + 52 >> 2] = 0 - fi, Jr = o[T + 288 >> 2], o[T + 48 >> 2] = 1 - Jr, o[T + 36 >> 2] = E, o[T + 32 >> 2] = gr, o[T + 28 >> 2] = Pr, o[T + 24 >> 2] = Nr, o[T + 20 >> 2] = Br, o[T + 16 >> 2] = Mr, o[T + 12 >> 2] = jr, o[T + 8 >> 2] = ti, o[T + 4 >> 2] = fi, o[T >> 2] = Jr + 1, Ti(k, ve, T), Ti(k + 40 | 0, E = T + 48 | 0, li), Ti(k + 80 | 0, li, T), Ti(k + 120 | 0, ve, E), dr = T + 624 | 0;
                    }
                    function Wo(k, E, T) {
                      var M, ye = 0, Ne = 0, pr = 0, ve = 0, cr = 0;
                      dr = M = dr + -64 | 0;
                      e: {
                        if ((T - 65 & 255) >>> 0 > 191) {
                          if (Ne = -1, !(m[k + 80 | 0] | m[k + 81 | 0] << 8 | m[k + 82 | 0] << 16 | m[k + 83 | 0] << 24 | m[k + 84 | 0] | m[k + 85 | 0] << 8 | m[k + 86 | 0] << 16 | m[k + 87 | 0] << 24)) {
                            if ((pr = m[k + 352 | 0] | m[k + 353 | 0] << 8 | m[k + 354 | 0] << 16 | m[k + 355 | 0] << 24) >>> 0 >= 129) {
                              if (ve = ye = m[k + 68 | 0] | m[k + 69 | 0] << 8 | m[k + 70 | 0] << 16 | m[k + 71 | 0] << 24, ye = (pr = 128 + (Ne = m[k + 64 | 0] | m[k + 65 | 0] << 8 | m[k + 66 | 0] << 16 | m[k + 67 | 0] << 24) | 0) >>> 0 < 128 ? ye + 1 | 0 : ye, B[k + 64 | 0] = pr, B[k + 65 | 0] = pr >>> 8, B[k + 66 | 0] = pr >>> 16, B[k + 67 | 0] = pr >>> 24, B[k + 68 | 0] = ye, B[k + 69 | 0] = ye >>> 8, B[k + 70 | 0] = ye >>> 16, B[k + 71 | 0] = ye >>> 24, ye = m[k + 76 | 0] | m[k + 77 | 0] << 8 | m[k + 78 | 0] << 16 | m[k + 79 | 0] << 24, ye = (cr = Ne = (0 | ve) == -1 & Ne >>> 0 > 4294967167) >>> 0 > (Ne = Ne + (m[k + 72 | 0] | m[k + 73 | 0] << 8 | m[k + 74 | 0] << 16 | m[k + 75 | 0] << 24) | 0) >>> 0 ? ye + 1 | 0 : ye, B[k + 72 | 0] = Ne, B[k + 73 | 0] = Ne >>> 8, B[k + 74 | 0] = Ne >>> 16, B[k + 75 | 0] = Ne >>> 24, B[k + 76 | 0] = ye, B[k + 77 | 0] = ye >>> 8, B[k + 78 | 0] = ye >>> 16, B[k + 79 | 0] = ye >>> 24, Fr(k, ye = k + 96 | 0), Ne = (m[k + 352 | 0] | m[k + 353 | 0] << 8 | m[k + 354 | 0] << 16 | m[k + 355 | 0] << 24) - 128 | 0, B[k + 352 | 0] = Ne, B[k + 353 | 0] = Ne >>> 8, B[k + 354 | 0] = Ne >>> 16, B[k + 355 | 0] = Ne >>> 24, Ne >>> 0 >= 129) break e;
                              fa(ye, k + 224 | 0, Ne), pr = m[k + 352 | 0] | m[k + 353 | 0] << 8 | m[k + 354 | 0] << 16 | m[k + 355 | 0] << 24;
                            }
                            Ne = cr = m[k + 68 | 0] | m[k + 69 | 0] << 8 | m[k + 70 | 0] << 16 | m[k + 71 | 0] << 24, Ne = (ve = pr + (ye = m[k + 64 | 0] | m[k + 65 | 0] << 8 | m[k + 66 | 0] << 16 | m[k + 67 | 0] << 24) | 0) >>> 0 < pr >>> 0 ? Ne + 1 | 0 : Ne, B[k + 64 | 0] = ve, B[k + 65 | 0] = ve >>> 8, B[k + 66 | 0] = ve >>> 16, B[k + 67 | 0] = ve >>> 24, B[k + 68 | 0] = Ne, B[k + 69 | 0] = Ne >>> 8, B[k + 70 | 0] = Ne >>> 16, B[k + 71 | 0] = Ne >>> 24, Ne = (0 | Ne) == (0 | cr) & ye >>> 0 > ve >>> 0 | Ne >>> 0 < cr >>> 0, ye = m[k + 76 | 0] | m[k + 77 | 0] << 8 | m[k + 78 | 0] << 16 | m[k + 79 | 0] << 24, ye = (cr = Ne) >>> 0 > (Ne = Ne + (m[k + 72 | 0] | m[k + 73 | 0] << 8 | m[k + 74 | 0] << 16 | m[k + 75 | 0] << 24) | 0) >>> 0 ? ye + 1 | 0 : ye, B[k + 72 | 0] = Ne, B[k + 73 | 0] = Ne >>> 8, B[k + 74 | 0] = Ne >>> 16, B[k + 75 | 0] = Ne >>> 24, B[k + 76 | 0] = ye, B[k + 77 | 0] = ye >>> 8, B[k + 78 | 0] = ye >>> 16, B[k + 79 | 0] = ye >>> 24, m[k + 356 | 0] && (B[k + 88 | 0] = 255, B[k + 89 | 0] = 255, B[k + 90 | 0] = 255, B[k + 91 | 0] = 255, B[k + 92 | 0] = 255, B[k + 93 | 0] = 255, B[k + 94 | 0] = 255, B[k + 95 | 0] = 255), B[k + 80 | 0] = 255, B[k + 81 | 0] = 255, B[k + 82 | 0] = 255, B[k + 83 | 0] = 255, B[k + 84 | 0] = 255, B[k + 85 | 0] = 255, B[k + 86 | 0] = 255, B[k + 87 | 0] = 255, Ca((Ne = k + 96 | 0) + pr | 0, 0, 256 - pr | 0), Fr(k, Ne), ye = m[k + 4 | 0] | m[k + 5 | 0] << 8 | m[k + 6 | 0] << 16 | m[k + 7 | 0] << 24, o[M >> 2] = m[0 | k] | m[k + 1 | 0] << 8 | m[k + 2 | 0] << 16 | m[k + 3 | 0] << 24, o[M + 4 >> 2] = ye, ye = m[k + 12 | 0] | m[k + 13 | 0] << 8 | m[k + 14 | 0] << 16 | m[k + 15 | 0] << 24, o[M + 8 >> 2] = m[k + 8 | 0] | m[k + 9 | 0] << 8 | m[k + 10 | 0] << 16 | m[k + 11 | 0] << 24, o[M + 12 >> 2] = ye, ye = m[k + 20 | 0] | m[k + 21 | 0] << 8 | m[k + 22 | 0] << 16 | m[k + 23 | 0] << 24, o[M + 16 >> 2] = m[k + 16 | 0] | m[k + 17 | 0] << 8 | m[k + 18 | 0] << 16 | m[k + 19 | 0] << 24, o[M + 20 >> 2] = ye, ye = m[k + 28 | 0] | m[k + 29 | 0] << 8 | m[k + 30 | 0] << 16 | m[k + 31 | 0] << 24, o[M + 24 >> 2] = m[k + 24 | 0] | m[k + 25 | 0] << 8 | m[k + 26 | 0] << 16 | m[k + 27 | 0] << 24, o[M + 28 >> 2] = ye, ye = m[k + 36 | 0] | m[k + 37 | 0] << 8 | m[k + 38 | 0] << 16 | m[k + 39 | 0] << 24, o[M + 32 >> 2] = m[k + 32 | 0] | m[k + 33 | 0] << 8 | m[k + 34 | 0] << 16 | m[k + 35 | 0] << 24, o[M + 36 >> 2] = ye, ye = m[k + 44 | 0] | m[k + 45 | 0] << 8 | m[k + 46 | 0] << 16 | m[k + 47 | 0] << 24, o[M + 40 >> 2] = m[k + 40 | 0] | m[k + 41 | 0] << 8 | m[k + 42 | 0] << 16 | m[k + 43 | 0] << 24, o[M + 44 >> 2] = ye, ye = m[k + 52 | 0] | m[k + 53 | 0] << 8 | m[k + 54 | 0] << 16 | m[k + 55 | 0] << 24, o[M + 48 >> 2] = m[k + 48 | 0] | m[k + 49 | 0] << 8 | m[k + 50 | 0] << 16 | m[k + 51 | 0] << 24, o[M + 52 >> 2] = ye, ye = m[k + 60 | 0] | m[k + 61 | 0] << 8 | m[k + 62 | 0] << 16 | m[k + 63 | 0] << 24, o[M + 56 >> 2] = m[k + 56 | 0] | m[k + 57 | 0] << 8 | m[k + 58 | 0] << 16 | m[k + 59 | 0] << 24, o[M + 60 >> 2] = ye, fa(E, M, T), _s(k, 64), _s(Ne, 256), Ne = 0;
                          }
                          return dr = M - -64 | 0, Ne;
                        }
                        Wa(), ji();
                      }
                      Me(1386, 1234, 306, 1142), ji();
                    }
                    function ps(k, E, T) {
                      k |= 0, E |= 0, T |= 0;
                      var M, ye, Ne, pr = 0, ve = 0;
                      dr = M = dr - 192 | 0, o[M + 144 >> 2] = 0, o[M + 148 >> 2] = 0, o[M + 152 >> 2] = 0, o[M + 156 >> 2] = 0, o[M + 104 >> 2] = 0, o[M + 108 >> 2] = 0, o[M + 112 >> 2] = 0, o[M + 116 >> 2] = 0, o[M + 120 >> 2] = 0, o[M + 124 >> 2] = 0, pr = o[8799], o[M + 168 >> 2] = o[8798], o[M + 172 >> 2] = pr, pr = o[8801], o[M + 176 >> 2] = o[8800], o[M + 180 >> 2] = pr, pr = o[8803], o[M + 184 >> 2] = o[8802], o[M + 188 >> 2] = pr, o[M + 128 >> 2] = 0, o[M + 132 >> 2] = 0, o[M + 136 >> 2] = 0, o[M + 140 >> 2] = 0, o[M + 96 >> 2] = 0, o[M + 100 >> 2] = 0, pr = o[8797], o[M + 160 >> 2] = o[8796], o[M + 164 >> 2] = pr, pr = m[T + 20 | 0] | m[T + 21 | 0] << 8 | m[T + 22 | 0] << 16 | m[T + 23 | 0] << 24, o[M + 80 >> 2] = m[T + 16 | 0] | m[T + 17 | 0] << 8 | m[T + 18 | 0] << 16 | m[T + 19 | 0] << 24, o[M + 84 >> 2] = pr, pr = m[T + 28 | 0] | m[T + 29 | 0] << 8 | m[T + 30 | 0] << 16 | m[T + 31 | 0] << 24, o[M + 88 >> 2] = m[T + 24 | 0] | m[T + 25 | 0] << 8 | m[T + 26 | 0] << 16 | m[T + 27 | 0] << 24, o[M + 92 >> 2] = pr, pr = m[T + 4 | 0] | m[T + 5 | 0] << 8 | m[T + 6 | 0] << 16 | m[T + 7 | 0] << 24, o[M + 64 >> 2] = m[0 | T] | m[T + 1 | 0] << 8 | m[T + 2 | 0] << 16 | m[T + 3 | 0] << 24, o[M + 68 >> 2] = pr, pr = m[T + 12 | 0] | m[T + 13 | 0] << 8 | m[T + 14 | 0] << 16 | m[T + 15 | 0] << 24, o[M + 72 >> 2] = m[T + 8 | 0] | m[T + 9 | 0] << 8 | m[T + 10 | 0] << 16 | m[T + 11 | 0] << 24, o[M + 76 >> 2] = pr, Th(T = M + 128 | 0, pr = M - -64 | 0), Si(T), ve = o[M + 156 >> 2], o[M + 24 >> 2] = o[M + 152 >> 2], o[M + 28 >> 2] = ve, ve = o[M + 148 >> 2], o[M + 16 >> 2] = o[M + 144 >> 2], o[M + 20 >> 2] = ve, ve = o[M + 140 >> 2], o[M + 8 >> 2] = o[M + 136 >> 2], o[M + 12 >> 2] = ve, ve = o[M + 132 >> 2], o[M >> 2] = o[M + 128 >> 2], o[M + 4 >> 2] = ve, o[M + 120 >> 2] = 0, o[M + 124 >> 2] = 0, o[M + 112 >> 2] = 0, o[M + 116 >> 2] = 0, o[M + 104 >> 2] = 0, o[M + 108 >> 2] = 0, o[M + 96 >> 2] = 0, o[M + 100 >> 2] = 0, ve = m[E + 20 | 0] | m[E + 21 | 0] << 8 | m[E + 22 | 0] << 16 | m[E + 23 | 0] << 24, o[M + 80 >> 2] = m[E + 16 | 0] | m[E + 17 | 0] << 8 | m[E + 18 | 0] << 16 | m[E + 19 | 0] << 24, o[M + 84 >> 2] = ve, ve = m[E + 28 | 0] | m[E + 29 | 0] << 8 | m[E + 30 | 0] << 16 | m[E + 31 | 0] << 24, o[M + 88 >> 2] = m[E + 24 | 0] | m[E + 25 | 0] << 8 | m[E + 26 | 0] << 16 | m[E + 27 | 0] << 24, o[M + 92 >> 2] = ve, ve = m[E + 8 | 0] | m[E + 9 | 0] << 8 | m[E + 10 | 0] << 16 | m[E + 11 | 0] << 24, ye = m[E + 12 | 0] | m[E + 13 | 0] << 8 | m[E + 14 | 0] << 16 | m[E + 15 | 0] << 24, Ne = m[0 | E] | m[E + 1 | 0] << 8 | m[E + 2 | 0] << 16 | m[E + 3 | 0] << 24, E = m[E + 4 | 0] | m[E + 5 | 0] << 8 | m[E + 6 | 0] << 16 | m[E + 7 | 0] << 24, o[M + 56 >> 2] = 0, o[M + 60 >> 2] = 0, o[M + 48 >> 2] = 0, o[M + 52 >> 2] = 0, o[M + 40 >> 2] = 0, o[M + 44 >> 2] = 0, o[M + 64 >> 2] = Ne, o[M + 68 >> 2] = E, o[M + 72 >> 2] = ve, o[M + 76 >> 2] = ye, o[M + 32 >> 2] = 0, o[M + 36 >> 2] = 0, Sh(pr, M), E = o[M + 124 >> 2], o[M + 184 >> 2] = o[M + 120 >> 2], o[M + 188 >> 2] = E, E = o[M + 116 >> 2], o[M + 176 >> 2] = o[M + 112 >> 2], o[M + 180 >> 2] = E, E = o[M + 108 >> 2], o[M + 168 >> 2] = o[M + 104 >> 2], o[M + 172 >> 2] = E, E = o[M + 100 >> 2], o[M + 160 >> 2] = o[M + 96 >> 2], o[M + 164 >> 2] = E, E = o[M + 92 >> 2], o[M + 152 >> 2] = o[M + 88 >> 2], o[M + 156 >> 2] = E, E = o[M + 84 >> 2], o[M + 144 >> 2] = o[M + 80 >> 2], o[M + 148 >> 2] = E, E = o[M + 76 >> 2], o[M + 136 >> 2] = o[M + 72 >> 2], o[M + 140 >> 2] = E, E = o[M + 68 >> 2], o[M + 128 >> 2] = o[M + 64 >> 2], o[M + 132 >> 2] = E, Si(T), E = o[M + 156 >> 2], pr = o[M + 152 >> 2], B[k + 24 | 0] = pr, B[k + 25 | 0] = pr >>> 8, B[k + 26 | 0] = pr >>> 16, B[k + 27 | 0] = pr >>> 24, B[k + 28 | 0] = E, B[k + 29 | 0] = E >>> 8, B[k + 30 | 0] = E >>> 16, B[k + 31 | 0] = E >>> 24, E = o[M + 148 >> 2], pr = o[M + 144 >> 2], B[k + 16 | 0] = pr, B[k + 17 | 0] = pr >>> 8, B[k + 18 | 0] = pr >>> 16, B[k + 19 | 0] = pr >>> 24, B[k + 20 | 0] = E, B[k + 21 | 0] = E >>> 8, B[k + 22 | 0] = E >>> 16, B[k + 23 | 0] = E >>> 24, E = o[M + 140 >> 2], pr = o[M + 136 >> 2], B[k + 8 | 0] = pr, B[k + 9 | 0] = pr >>> 8, B[k + 10 | 0] = pr >>> 16, B[k + 11 | 0] = pr >>> 24, B[k + 12 | 0] = E, B[k + 13 | 0] = E >>> 8, B[k + 14 | 0] = E >>> 16, B[k + 15 | 0] = E >>> 24, E = o[M + 132 >> 2], pr = o[M + 128 >> 2], B[0 | k] = pr, B[k + 1 | 0] = pr >>> 8, B[k + 2 | 0] = pr >>> 16, B[k + 3 | 0] = pr >>> 24, B[k + 4 | 0] = E, B[k + 5 | 0] = E >>> 8, B[k + 6 | 0] = E >>> 16, B[k + 7 | 0] = E >>> 24, _s(T, 64), dr = M + 192 | 0;
                    }
                    function Bs(k) {
                      var E, T, M, ye, Ne, pr, ve, cr, gr, Pr, Nr = 0, Br = 0, Mr = 0, jr = 0, ti = 0;
                      for (dr = E = dr - 2048 | 0, $a(jr = E + 640 | 0, k), Nr = o[k + 36 >> 2], o[E + 352 >> 2] = o[k + 32 >> 2], o[E + 356 >> 2] = Nr, Nr = o[k + 28 >> 2], o[E + 344 >> 2] = o[k + 24 >> 2], o[E + 348 >> 2] = Nr, Nr = o[k + 20 >> 2], o[E + 336 >> 2] = o[k + 16 >> 2], o[E + 340 >> 2] = Nr, Nr = o[k + 12 >> 2], o[E + 328 >> 2] = o[k + 8 >> 2], o[E + 332 >> 2] = Nr, Nr = o[k + 4 >> 2], o[E + 320 >> 2] = o[k >> 2], o[E + 324 >> 2] = Nr, Nr = o[k + 52 >> 2], o[E + 368 >> 2] = o[k + 48 >> 2], o[E + 372 >> 2] = Nr, Nr = o[k + 60 >> 2], o[E + 376 >> 2] = o[k + 56 >> 2], o[E + 380 >> 2] = Nr, Nr = o[4 + (Mr = k - -64 | 0) >> 2], o[E + 384 >> 2] = o[Mr >> 2], o[E + 388 >> 2] = Nr, Nr = o[k + 76 >> 2], o[E + 392 >> 2] = o[k + 72 >> 2], o[E + 396 >> 2] = Nr, Nr = o[k + 44 >> 2], o[E + 360 >> 2] = o[k + 40 >> 2], o[E + 364 >> 2] = Nr, Nr = o[k + 92 >> 2], o[E + 408 >> 2] = o[k + 88 >> 2], o[E + 412 >> 2] = Nr, Nr = o[k + 100 >> 2], o[E + 416 >> 2] = o[k + 96 >> 2], o[E + 420 >> 2] = Nr, Nr = o[k + 108 >> 2], o[E + 424 >> 2] = o[k + 104 >> 2], o[E + 428 >> 2] = Nr, Nr = o[k + 116 >> 2], o[E + 432 >> 2] = o[k + 112 >> 2], o[E + 436 >> 2] = Nr, Nr = o[k + 84 >> 2], o[E + 400 >> 2] = o[k + 80 >> 2], o[E + 404 >> 2] = Nr, Oa(Br = E + 480 | 0, Mr = E + 320 | 0), Ti(Nr = E + 160 | 0, Br, T = E + 600 | 0), Ti(E + 200 | 0, M = E + 520 | 0, ye = E + 560 | 0), Ti(E + 240 | 0, ye, T), Ti(E + 280 | 0, Br, M), Aa(Br, Nr, jr), Ti(Mr, Br, T), Ti(ve = E + 360 | 0, M, ye), Ti(cr = E + 400 | 0, ye, T), Ti(gr = E + 440 | 0, Br, M), $a(k = E + 800 | 0, Mr), Aa(Br, Nr, k), Ti(Mr, Br, T), Ti(ve, M, ye), Ti(cr, ye, T), Ti(gr, Br, M), $a(k = E + 960 | 0, Mr), Aa(Br, Nr, k), Ti(Mr, Br, T), Ti(ve, M, ye), Ti(cr, ye, T), Ti(gr, Br, M), $a(k = E + 1120 | 0, Mr), Aa(Br, Nr, k), Ti(Mr, Br, T), Ti(ve, M, ye), Ti(cr, ye, T), Ti(gr, Br, M), $a(k = E + 1280 | 0, Mr), Aa(Br, Nr, k), Ti(Mr, Br, T), Ti(ve, M, ye), Ti(cr, ye, T), Ti(gr, Br, M), $a(k = E + 1440 | 0, Mr), Aa(Br, Nr, k), Ti(Mr, Br, T), Ti(ve, M, ye), Ti(cr, ye, T), Ti(gr, Br, M), $a(k = E + 1600 | 0, Mr), Aa(Br, Nr, k), Ti(Mr, Br, T), Ti(ve, M, ye), Ti(cr, ye, T), Ti(gr, Br, M), $a(E + 1760 | 0, Mr), o[E + 32 >> 2] = 0, o[E + 36 >> 2] = 0, o[E + 24 >> 2] = 0, o[E + 28 >> 2] = 0, o[E + 16 >> 2] = 0, o[E + 20 >> 2] = 0, o[E + 8 >> 2] = 0, o[E + 12 >> 2] = 0, o[E + 52 >> 2] = 0, o[E + 56 >> 2] = 0, o[E + 60 >> 2] = 0, o[E + 64 >> 2] = 0, o[E + 68 >> 2] = 0, o[E + 72 >> 2] = 0, o[E + 76 >> 2] = 0, o[E + 80 >> 2] = 1, o[E >> 2] = 0, o[E + 4 >> 2] = 0, o[E + 44 >> 2] = 0, o[E + 48 >> 2] = 0, o[E + 40 >> 2] = 1, Ca(E + 84 | 0, 0, 76), Pr = E + 120 | 0, Ne = E + 2008 | 0, pr = E + 1968 | 0, jr = E + 80 | 0, Mr = E + 40 | 0, k = 252; Nr = o[E + 36 >> 2], o[(Br = E + 1960 | 0) >> 2] = o[E + 32 >> 2], o[Br + 4 >> 2] = Nr, Nr = o[E + 28 >> 2], o[(Br = E + 1952 | 0) >> 2] = o[E + 24 >> 2], o[Br + 4 >> 2] = Nr, Nr = o[E + 20 >> 2], o[(Br = E + 1944 | 0) >> 2] = o[E + 16 >> 2], o[Br + 4 >> 2] = Nr, Nr = o[E + 12 >> 2], o[(Br = E + 1936 | 0) >> 2] = o[E + 8 >> 2], o[Br + 4 >> 2] = Nr, Nr = o[E + 4 >> 2], o[E + 1928 >> 2] = o[E >> 2], o[E + 1932 >> 2] = Nr, Nr = o[Mr + 36 >> 2], o[pr + 32 >> 2] = o[Mr + 32 >> 2], o[pr + 36 >> 2] = Nr, Nr = o[Mr + 28 >> 2], o[pr + 24 >> 2] = o[Mr + 24 >> 2], o[pr + 28 >> 2] = Nr, Nr = o[Mr + 20 >> 2], o[pr + 16 >> 2] = o[Mr + 16 >> 2], o[pr + 20 >> 2] = Nr, Nr = o[Mr + 12 >> 2], o[pr + 8 >> 2] = o[Mr + 8 >> 2], o[pr + 12 >> 2] = Nr, Nr = o[Mr + 4 >> 2], o[pr >> 2] = o[Mr >> 2], o[pr + 4 >> 2] = Nr, Nr = o[jr + 36 >> 2], o[Ne + 32 >> 2] = o[jr + 32 >> 2], o[Ne + 36 >> 2] = Nr, Nr = o[jr + 28 >> 2], o[Ne + 24 >> 2] = o[jr + 24 >> 2], o[Ne + 28 >> 2] = Nr, Nr = o[jr + 20 >> 2], o[Ne + 16 >> 2] = o[jr + 16 >> 2], o[Ne + 20 >> 2] = Nr, Nr = o[jr + 12 >> 2], o[Ne + 8 >> 2] = o[jr + 8 >> 2], o[Ne + 12 >> 2] = Nr, Nr = o[jr + 4 >> 2], o[Ne >> 2] = o[jr >> 2], o[Ne + 4 >> 2] = Nr, Nr = k, ti = B[k + 33712 | 0], Oa(Br = E + 480 | 0, E + 1928 | 0), (0 | ti) > 0 ? (Ti(k = E + 320 | 0, Br, T), Ti(ve, M, ye), Ti(cr, ye, T), Ti(gr, Br, M), Aa(Br, k, (E + 640 | 0) + v((254 & ti) >>> 1 | 0, 160) | 0)) : (0 | ti) >= 0 || (Ti(k = E + 320 | 0, Br = E + 480 | 0, T), Ti(ve, M, ye), Ti(cr, ye, T), Ti(gr, Br, M), zs(Br, k, (E + 640 | 0) + v((0 - ti & 254) >>> 1 | 0, 160) | 0)), Ti(E, k = E + 480 | 0, T), Ti(Mr, M, ye), Ti(jr, ye, T), Ti(Pr, k, M), k = Nr - 1 | 0, Nr; ) ;
                      return i2(k = E + 640 | 0, E), k = pa(k, 32), dr = E + 2048 | 0, k;
                    }
                    function Xs(k, E, T, M, ye) {
                      var Ne, pr, ve, cr, gr, Pr, Nr, Br, Mr, jr, ti, fi, Jr = 0, li = 0, Tr = 0, Mi = 0, Wi = 0, vn = 0, Tn = 0, Ni = 0, Yi = 0, Xi = 0, $n = 0, Zn = 0, to = 0, fo = 0, wo = 0, bo = 0, go = 0, qn = 0, io = 0, So = 0, qo = 0, Ln = 0, ro = 0, Qo = 0;
                      if (M ? (go = m[M + 12 | 0] | m[M + 13 | 0] << 8 | m[M + 14 | 0] << 16 | m[M + 15 | 0] << 24, io = m[M + 8 | 0] | m[M + 9 | 0] << 8 | m[M + 10 | 0] << 16 | m[M + 11 | 0] << 24, qn = m[0 | M] | m[M + 1 | 0] << 8 | m[M + 2 | 0] << 16 | m[M + 3 | 0] << 24, So = m[M + 4 | 0] | m[M + 5 | 0] << 8 | m[M + 6 | 0] << 16 | m[M + 7 | 0] << 24) : (go = 1797285236, qn = 1634760805, io = 2036477234, So = 857760878), M = Ne = m[T + 20 | 0] | m[T + 21 | 0] << 8 | m[T + 22 | 0] << 16 | m[T + 23 | 0] << 24, Ni = pr = m[T + 24 | 0] | m[T + 25 | 0] << 8 | m[T + 26 | 0] << 16 | m[T + 27 | 0] << 24, Zn = ve = m[T + 28 | 0] | m[T + 29 | 0] << 8 | m[T + 30 | 0] << 16 | m[T + 31 | 0] << 24, Tr = go, Tn = cr = m[T + 16 | 0] | m[T + 17 | 0] << 8 | m[T + 18 | 0] << 16 | m[T + 19 | 0] << 24, Yi = io, to = gr = m[E + 12 | 0] | m[E + 13 | 0] << 8 | m[E + 14 | 0] << 16 | m[E + 15 | 0] << 24, Xi = Pr = m[E + 8 | 0] | m[E + 9 | 0] << 8 | m[E + 10 | 0] << 16 | m[E + 11 | 0] << 24, Mi = Nr = m[E + 4 | 0] | m[E + 5 | 0] << 8 | m[E + 6 | 0] << 16 | m[E + 7 | 0] << 24, E = Br = m[0 | E] | m[E + 1 | 0] << 8 | m[E + 2 | 0] << 16 | m[E + 3 | 0] << 24, $n = So, Jr = Mr = m[T + 12 | 0] | m[T + 13 | 0] << 8 | m[T + 14 | 0] << 16 | m[T + 15 | 0] << 24, li = jr = m[T + 8 | 0] | m[T + 9 | 0] << 8 | m[T + 10 | 0] << 16 | m[T + 11 | 0] << 24, Wi = ti = m[T + 4 | 0] | m[T + 5 | 0] << 8 | m[T + 6 | 0] << 16 | m[T + 7 | 0] << 24, T = fi = m[0 | T] | m[T + 1 | 0] << 8 | m[T + 2 | 0] << 16 | m[T + 3 | 0] << 24, vn = qn, (0 | ye) > 0) for (; fo = ao(T + $n | 0, 7) ^ to, qo = ao(fo + $n | 0, 9) ^ Ni, wo = ao(M + vn | 0, 7) ^ Jr, Ln = ao(wo + vn | 0, 9) ^ Xi, ro = ao(wo + Ln | 0, 13) ^ M, bo = ao(Tr + Tn | 0, 7) ^ li, Mi = ao(bo + Tr | 0, 9) ^ Mi, li = ao(Mi + bo | 0, 13) ^ Tn, Tr = ao(Mi + li | 0, 18) ^ Tr, Jr = ao(E + Yi | 0, 7) ^ Zn, M = ro ^ ao(Tr + Jr | 0, 7), Ni = ao(M + Tr | 0, 9) ^ qo, Zn = ao(M + Ni | 0, 13) ^ Jr, Tr = ao(Ni + Zn | 0, 18) ^ Tr, Wi = ao(Jr + Yi | 0, 9) ^ Wi, Jr = ao(Wi + Jr | 0, 13) ^ E, E = ao(Jr + Wi | 0, 18) ^ Yi, Tn = ao(E + fo | 0, 7) ^ li, Xi = ao(Tn + E | 0, 9) ^ Ln, to = ao(Tn + Xi | 0, 13) ^ fo, Yi = ao(Xi + to | 0, 18) ^ E, T = ao(fo + qo | 0, 13) ^ T, li = ao(T + qo | 0, 18) ^ $n, E = ao(li + wo | 0, 7) ^ Jr, Mi = ao(E + li | 0, 9) ^ Mi, Jr = ao(E + Mi | 0, 13) ^ wo, $n = ao(Mi + Jr | 0, 18) ^ li, vn = ao(Ln + ro | 0, 18) ^ vn, T = ao(vn + bo | 0, 7) ^ T, Wi = ao(T + vn | 0, 9) ^ Wi, li = ao(T + Wi | 0, 13) ^ bo, vn = ao(Wi + li | 0, 18) ^ vn, (0 | (Qo = Qo + 2 | 0)) < (0 | ye); ) ;
                      ye = Tr + go | 0, B[k + 60 | 0] = ye, B[k + 61 | 0] = ye >>> 8, B[k + 62 | 0] = ye >>> 16, B[k + 63 | 0] = ye >>> 24, ye = Zn + ve | 0, B[k + 56 | 0] = ye, B[k + 57 | 0] = ye >>> 8, B[k + 58 | 0] = ye >>> 16, B[k + 59 | 0] = ye >>> 24, ye = Ni + pr | 0, B[k + 52 | 0] = ye, B[k + 53 | 0] = ye >>> 8, B[k + 54 | 0] = ye >>> 16, B[k + 55 | 0] = ye >>> 24, M = M + Ne | 0, B[k + 48 | 0] = M, B[k + 49 | 0] = M >>> 8, B[k + 50 | 0] = M >>> 16, B[k + 51 | 0] = M >>> 24, M = Tn + cr | 0, B[k + 44 | 0] = M, B[k + 45 | 0] = M >>> 8, B[k + 46 | 0] = M >>> 16, B[k + 47 | 0] = M >>> 24, M = Yi + io | 0, B[k + 40 | 0] = M, B[k + 41 | 0] = M >>> 8, B[k + 42 | 0] = M >>> 16, B[k + 43 | 0] = M >>> 24, M = to + gr | 0, B[k + 36 | 0] = M, B[k + 37 | 0] = M >>> 8, B[k + 38 | 0] = M >>> 16, B[k + 39 | 0] = M >>> 24, M = Xi + Pr | 0, B[k + 32 | 0] = M, B[k + 33 | 0] = M >>> 8, B[k + 34 | 0] = M >>> 16, B[k + 35 | 0] = M >>> 24, M = Mi + Nr | 0, B[k + 28 | 0] = M, B[k + 29 | 0] = M >>> 8, B[k + 30 | 0] = M >>> 16, B[k + 31 | 0] = M >>> 24, E = E + Br | 0, B[k + 24 | 0] = E, B[k + 25 | 0] = E >>> 8, B[k + 26 | 0] = E >>> 16, B[k + 27 | 0] = E >>> 24, E = $n + So | 0, B[k + 20 | 0] = E, B[k + 21 | 0] = E >>> 8, B[k + 22 | 0] = E >>> 16, B[k + 23 | 0] = E >>> 24, E = Jr + Mr | 0, B[k + 16 | 0] = E, B[k + 17 | 0] = E >>> 8, B[k + 18 | 0] = E >>> 16, B[k + 19 | 0] = E >>> 24, E = li + jr | 0, B[k + 12 | 0] = E, B[k + 13 | 0] = E >>> 8, B[k + 14 | 0] = E >>> 16, B[k + 15 | 0] = E >>> 24, E = Wi + ti | 0, B[k + 8 | 0] = E, B[k + 9 | 0] = E >>> 8, B[k + 10 | 0] = E >>> 16, B[k + 11 | 0] = E >>> 24, E = T + fi | 0, B[k + 4 | 0] = E, B[k + 5 | 0] = E >>> 8, B[k + 6 | 0] = E >>> 16, B[k + 7 | 0] = E >>> 24, E = vn + qn | 0, B[0 | k] = E, B[k + 1 | 0] = E >>> 8, B[k + 2 | 0] = E >>> 16, B[k + 3 | 0] = E >>> 24;
                    }
                    function js(k) {
                      var E = 0, T = 0, M = 0, ye = 0, Ne = 0, pr = 0, ve = 0, cr = 0, gr = 0;
                      e: if (k |= 0) {
                        Ne = (M = k - 8 | 0) + (k = -8 & (E = o[k - 4 >> 2])) | 0;
                        t: if (!(1 & E)) {
                          if (!(2 & E) || (M = M - (E = o[M >> 2]) | 0) >>> 0 < d[9409]) break e;
                          k = k + E | 0;
                          r: {
                            i: {
                              n: {
                                if (o[9410] != (0 | M)) {
                                  if (T = o[M + 12 >> 2], E >>> 0 <= 255) {
                                    if ((0 | (ye = o[M + 8 >> 2])) != (0 | T)) break n;
                                    cr = 37620, gr = o[9405] & ao(-2, E >>> 3 | 0), o[cr >> 2] = gr;
                                    break t;
                                  }
                                  if (ve = o[M + 24 >> 2], (0 | T) != (0 | M)) {
                                    E = o[M + 8 >> 2], o[E + 12 >> 2] = T, o[T + 8 >> 2] = E;
                                    break r;
                                  }
                                  if (ye = o[M + 20 >> 2]) E = M + 20 | 0;
                                  else {
                                    if (!(ye = o[M + 16 >> 2])) break i;
                                    E = M + 16 | 0;
                                  }
                                  for (; pr = E, E = (T = ye) + 20 | 0, (ye = o[T + 20 >> 2]) || (E = T + 16 | 0, ye = o[T + 16 >> 2]); ) ;
                                  o[pr >> 2] = 0;
                                  break r;
                                }
                                if (3 & ~(E = o[Ne + 4 >> 2])) break t;
                                return o[9407] = k, o[Ne + 4 >> 2] = -2 & E, o[M + 4 >> 2] = 1 | k, void (o[Ne >> 2] = k);
                              }
                              o[ye + 12 >> 2] = T, o[T + 8 >> 2] = ye;
                              break t;
                            }
                            T = 0;
                          }
                          if (ve) {
                            E = o[M + 28 >> 2];
                            r: {
                              if (o[(ye = 37924 + (E << 2) | 0) >> 2] == (0 | M)) {
                                if (o[ye >> 2] = T, T) break r;
                                cr = 37624, gr = o[9406] & ao(-2, E), o[cr >> 2] = gr;
                                break t;
                              }
                              if (o[ve + (o[ve + 16 >> 2] == (0 | M) ? 16 : 20) >> 2] = T, !T) break t;
                            }
                            o[T + 24 >> 2] = ve, (E = o[M + 16 >> 2]) && (o[T + 16 >> 2] = E, o[E + 24 >> 2] = T), (E = o[M + 20 >> 2]) && (o[T + 20 >> 2] = E, o[E + 24 >> 2] = T);
                          }
                        }
                        if (!(M >>> 0 >= Ne >>> 0) && 1 & (E = o[Ne + 4 >> 2])) {
                          t: {
                            r: {
                              i: {
                                n: {
                                  if (!(2 & E)) {
                                    if ((0 | Ne) == o[9411]) {
                                      if (o[9411] = M, k = o[9408] + k | 0, o[9408] = k, o[M + 4 >> 2] = 1 | k, o[9410] != (0 | M)) break e;
                                      return o[9407] = 0, void (o[9410] = 0);
                                    }
                                    if ((0 | Ne) == o[9410]) return o[9410] = M, k = o[9407] + k | 0, o[9407] = k, o[M + 4 >> 2] = 1 | k, void (o[k + M >> 2] = k);
                                    if (k = (-8 & E) + k | 0, T = o[Ne + 12 >> 2], E >>> 0 <= 255) {
                                      if ((0 | (ye = o[Ne + 8 >> 2])) == (0 | T)) {
                                        cr = 37620, gr = o[9405] & ao(-2, E >>> 3 | 0), o[cr >> 2] = gr;
                                        break r;
                                      }
                                      o[ye + 12 >> 2] = T, o[T + 8 >> 2] = ye;
                                      break r;
                                    }
                                    if (ve = o[Ne + 24 >> 2], (0 | T) != (0 | Ne)) {
                                      E = o[Ne + 8 >> 2], o[E + 12 >> 2] = T, o[T + 8 >> 2] = E;
                                      break i;
                                    }
                                    if (ye = o[Ne + 20 >> 2]) E = Ne + 20 | 0;
                                    else {
                                      if (!(ye = o[Ne + 16 >> 2])) break n;
                                      E = Ne + 16 | 0;
                                    }
                                    for (; pr = E, E = (T = ye) + 20 | 0, (ye = o[T + 20 >> 2]) || (E = T + 16 | 0, ye = o[T + 16 >> 2]); ) ;
                                    o[pr >> 2] = 0;
                                    break i;
                                  }
                                  o[Ne + 4 >> 2] = -2 & E, o[M + 4 >> 2] = 1 | k, o[k + M >> 2] = k;
                                  break t;
                                }
                                T = 0;
                              }
                              if (ve) {
                                E = o[Ne + 28 >> 2];
                                i: {
                                  if ((0 | Ne) == o[(ye = 37924 + (E << 2) | 0) >> 2]) {
                                    if (o[ye >> 2] = T, T) break i;
                                    cr = 37624, gr = o[9406] & ao(-2, E), o[cr >> 2] = gr;
                                    break r;
                                  }
                                  if (o[ve + ((0 | Ne) == o[ve + 16 >> 2] ? 16 : 20) >> 2] = T, !T) break r;
                                }
                                o[T + 24 >> 2] = ve, (E = o[Ne + 16 >> 2]) && (o[T + 16 >> 2] = E, o[E + 24 >> 2] = T), (E = o[Ne + 20 >> 2]) && (o[T + 20 >> 2] = E, o[E + 24 >> 2] = T);
                              }
                            }
                            if (o[M + 4 >> 2] = 1 | k, o[k + M >> 2] = k, o[9410] == (0 | M)) return void (o[9407] = k);
                          }
                          if (k >>> 0 <= 255) return E = 37660 + (-8 & k) | 0, (ye = o[9405]) & (k = 1 << (k >>> 3)) ? k = o[E + 8 >> 2] : (o[9405] = k | ye, k = E), o[E + 8 >> 2] = M, o[k + 12 >> 2] = M, o[M + 12 >> 2] = E, void (o[M + 8 >> 2] = k);
                          T = 31, k >>> 0 <= 16777215 && (T = 62 + ((k >>> 38 - (E = he(k >>> 8 | 0)) & 1) - (E << 1) | 0) | 0), o[M + 28 >> 2] = T, o[M + 16 >> 2] = 0, o[M + 20 >> 2] = 0, pr = 37924 + (T << 2) | 0;
                          t: {
                            r: {
                              if ((E = o[9406]) & (ye = 1 << T)) {
                                for (T = k << ((0 | T) != 31 ? 25 - (T >>> 1 | 0) : 0), E = o[pr >> 2]; ; ) {
                                  if (ye = E, (-8 & o[E + 4 >> 2]) == (0 | k)) break r;
                                  if (E = T >>> 29 | 0, T <<= 1, !(E = o[(pr = 16 + ((4 & E) + ye | 0) | 0) >> 2])) break;
                                }
                                T = 24, E = ye;
                              } else o[9406] = E | ye, T = 24, E = pr;
                              ye = M, Ne = M, k = 8;
                              break t;
                            }
                            E = o[ye + 8 >> 2], o[E + 12 >> 2] = M, T = 8, pr = ye + 8 | 0, Ne = 0, k = 24;
                          }
                          o[pr >> 2] = M, o[T + M >> 2] = E, o[M + 12 >> 2] = ye, o[k + M >> 2] = Ne, k = o[9413] - 1 | 0, o[9413] = k || -1;
                        }
                      }
                    }
                    function ya(k, E, T, M, ye, Ne, pr, ve, cr) {
                      var gr = 0, Pr = 0, Nr = 0, Br = 0, Mr = 0, jr = 0, ti = 0, fi = 0;
                      if (E - 65 >>> 0 < 4294967232 | pr >>> 0 > 64) k = -1;
                      else {
                        fi = gr = dr, dr = gr = gr - 512 & -64;
                        e: {
                          t: if (!(!(!(M | ye) | T) | !k | ((jr = 255 & E) - 65 & 255) >>> 0 <= 191 | !(!(E = 255 & pr) || Ne) | E >>> 0 >= 65)) {
                            if (E) {
                              if (!Ne) break t;
                              ve ? (Pr = 725511199 ^ (m[ve + 8 | 0] | m[ve + 9 | 0] << 8 | m[ve + 10 | 0] << 16 | m[ve + 11 | 0] << 24), Nr = -1694144372 ^ (m[ve + 12 | 0] | m[ve + 13 | 0] << 8 | m[ve + 14 | 0] << 16 | m[ve + 15 | 0] << 24), pr = -1377402159 ^ (m[0 | ve] | m[ve + 1 | 0] << 8 | m[ve + 2 | 0] << 16 | m[ve + 3 | 0] << 24), ve = 1359893119 ^ (m[ve + 4 | 0] | m[ve + 5 | 0] << 8 | m[ve + 6 | 0] << 16 | m[ve + 7 | 0] << 24)) : (Pr = 725511199, Nr = -1694144372, pr = -1377402159, ve = 1359893119), cr ? (Br = 327033209 ^ (m[cr + 8 | 0] | m[cr + 9 | 0] << 8 | m[cr + 10 | 0] << 16 | m[cr + 11 | 0] << 24), Mr = 1541459225 ^ (m[cr + 12 | 0] | m[cr + 13 | 0] << 8 | m[cr + 14 | 0] << 16 | m[cr + 15 | 0] << 24), ti = -79577749 ^ (m[0 | cr] | m[cr + 1 | 0] << 8 | m[cr + 2 | 0] << 16 | m[cr + 3 | 0] << 24), cr = 528734635 ^ (m[cr + 4 | 0] | m[cr + 5 | 0] << 8 | m[cr + 6 | 0] << 16 | m[cr + 7 | 0] << 24)) : (Br = 327033209, Mr = 1541459225, ti = -79577749, cr = 528734635), Ca(gr - -64 | 0, 0, 293), o[gr + 56 >> 2] = Br, o[gr + 60 >> 2] = Mr, o[gr + 48 >> 2] = ti, o[gr + 52 >> 2] = cr, o[gr + 40 >> 2] = Pr, o[gr + 44 >> 2] = Nr, o[gr + 32 >> 2] = pr, o[gr + 36 >> 2] = ve, o[gr + 24 >> 2] = 1595750129, o[gr + 28 >> 2] = -1521486534, o[gr + 16 >> 2] = -23791573, o[gr + 20 >> 2] = 1013904242, o[gr + 8 >> 2] = -2067093701, o[gr + 12 >> 2] = -1150833019, o[gr >> 2] = -222443256 ^ (E << 8 | jr), o[gr + 4 >> 2] = E >>> 24 ^ 1779033703, Ca((pr = gr + 384 | 0) + E | 0, 0, 128 - E | 0), fa(pr, Ne, E), fa(gr + 96 | 0, pr, 128), o[gr + 352 >> 2] = 128, _s(pr, 128), E = 128;
                            } else ve ? (Pr = 725511199 ^ (m[ve + 8 | 0] | m[ve + 9 | 0] << 8 | m[ve + 10 | 0] << 16 | m[ve + 11 | 0] << 24), Nr = -1694144372 ^ (m[ve + 12 | 0] | m[ve + 13 | 0] << 8 | m[ve + 14 | 0] << 16 | m[ve + 15 | 0] << 24), Ne = 1359893119 ^ (m[ve + 4 | 0] | m[ve + 5 | 0] << 8 | m[ve + 6 | 0] << 16 | m[ve + 7 | 0] << 24), E = -1377402159 ^ (m[0 | ve] | m[ve + 1 | 0] << 8 | m[ve + 2 | 0] << 16 | m[ve + 3 | 0] << 24)) : (Pr = 725511199, Nr = -1694144372, Ne = 1359893119, E = -1377402159), cr ? (Br = 327033209 ^ (m[cr + 8 | 0] | m[cr + 9 | 0] << 8 | m[cr + 10 | 0] << 16 | m[cr + 11 | 0] << 24), Mr = 1541459225 ^ (m[cr + 12 | 0] | m[cr + 13 | 0] << 8 | m[cr + 14 | 0] << 16 | m[cr + 15 | 0] << 24), ve = 528734635 ^ (m[cr + 4 | 0] | m[cr + 5 | 0] << 8 | m[cr + 6 | 0] << 16 | m[cr + 7 | 0] << 24), pr = -79577749 ^ (m[0 | cr] | m[cr + 1 | 0] << 8 | m[cr + 2 | 0] << 16 | m[cr + 3 | 0] << 24)) : (Br = 327033209, Mr = 1541459225, ve = 528734635, pr = -79577749), Ca(gr - -64 | 0, 0, 293), o[gr + 56 >> 2] = Br, o[gr + 60 >> 2] = Mr, o[gr + 48 >> 2] = pr, o[gr + 52 >> 2] = ve, o[gr + 40 >> 2] = Pr, o[gr + 44 >> 2] = Nr, o[gr + 32 >> 2] = E, o[gr + 36 >> 2] = Ne, o[gr + 24 >> 2] = 1595750129, o[gr + 28 >> 2] = -1521486534, o[gr + 16 >> 2] = -23791573, o[gr + 20 >> 2] = 1013904242, o[gr + 8 >> 2] = -2067093701, o[gr + 12 >> 2] = -1150833019, o[gr >> 2] = -222443256 ^ jr, o[gr + 4 >> 2] = 1779033703, E = 0;
                            r: if (M | ye) for (cr = gr + 224 | 0, ve = gr + 96 | 0; ; ) {
                              if (pr = E + ve | 0, !ye & M >>> 0 <= (Ne = 256 - E | 0) >>> 0) {
                                fa(pr, T, M), o[gr + 352 >> 2] = M + o[gr + 352 >> 2];
                                break r;
                              }
                              if (fa(pr, T, Ne), o[gr + 352 >> 2] = Ne + o[gr + 352 >> 2], Pr = E = o[gr + 68 >> 2], E = (Nr = (pr = o[gr + 64 >> 2]) + 128 | 0) >>> 0 < 128 ? E + 1 | 0 : E, o[gr + 64 >> 2] = Nr, o[gr + 68 >> 2] = E, E = o[gr + 76 >> 2], E = (Pr = pr = (0 | Pr) == -1 & pr >>> 0 > 4294967167) >>> 0 > (pr = pr + o[gr + 72 >> 2] | 0) >>> 0 ? E + 1 | 0 : E, o[gr + 72 >> 2] = pr, o[gr + 76 >> 2] = E, Fr(gr, ve), fa(ve, cr, 128), E = o[gr + 352 >> 2] - 128 | 0, o[gr + 352 >> 2] = E, T = T + Ne | 0, !((ye = ye - (M >>> 0 < Ne >>> 0) | 0) | (M = M - Ne | 0))) break;
                            }
                            Wo(gr, k, jr), dr = fi;
                            break e;
                          }
                          Wa(), ji();
                        }
                        k = 0;
                      }
                      return k;
                    }
                    function sa(k, E, T, M, ye, Ne, pr) {
                      var ve, cr, gr = 0, Pr = 0, Nr = 0;
                      if (dr = ve = dr + -64 | 0, cr = un(32)) {
                        o[ve + 36 >> 2] = 0, o[ve + 40 >> 2] = 0, o[ve + 28 >> 2] = 0, o[ve + 32 >> 2] = 0, o[ve + 24 >> 2] = 16, o[ve + 20 >> 2] = ye, o[ve + 16 >> 2] = M, o[ve + 12 >> 2] = T, o[ve + 8 >> 2] = 32, o[ve + 4 >> 2] = cr, o[ve + 60 >> 2] = 0, o[ve + 56 >> 2] = 1, o[ve + 52 >> 2] = 1, o[ve + 48 >> 2] = E, o[ve + 44 >> 2] = k;
                        e: if (k = Go(ve + 4 | 0, pr)) _s(cr, 32);
                        else {
                          if (Ne) {
                            gr = ve + 4 | 0, dr = ye = dr - 32 | 0, k = -31;
                            t: {
                              r: {
                                i: switch (pr - 1 | 0) {
                                  case 1:
                                    k = m[1434] | m[1435] << 8 | m[1436] << 16 | m[1437] << 24, E = m[1430] | m[1431] << 8 | m[1432] << 16 | m[1433] << 24, B[0 | Ne] = E, B[Ne + 1 | 0] = E >>> 8, B[Ne + 2 | 0] = E >>> 16, B[Ne + 3 | 0] = E >>> 24, B[Ne + 4 | 0] = k, B[Ne + 5 | 0] = k >>> 8, B[Ne + 6 | 0] = k >>> 16, B[Ne + 7 | 0] = k >>> 24, k = m[1439] | m[1440] << 8 | m[1441] << 16 | m[1442] << 24, E = m[1435] | m[1436] << 8 | m[1437] << 16 | m[1438] << 24, B[Ne + 5 | 0] = E, B[Ne + 6 | 0] = E >>> 8, B[Ne + 7 | 0] = E >>> 16, B[Ne + 8 | 0] = E >>> 24, B[Ne + 9 | 0] = k, B[Ne + 10 | 0] = k >>> 8, B[Ne + 11 | 0] = k >>> 16, B[Ne + 12 | 0] = k >>> 24, T = -12, E = 12;
                                    break r;
                                  case 0:
                                    break i;
                                  default:
                                    break t;
                                }
                                k = m[1422] | m[1423] << 8 | m[1424] << 16 | m[1425] << 24, E = m[1418] | m[1419] << 8 | m[1420] << 16 | m[1421] << 24, B[0 | Ne] = E, B[Ne + 1 | 0] = E >>> 8, B[Ne + 2 | 0] = E >>> 16, B[Ne + 3 | 0] = E >>> 24, B[Ne + 4 | 0] = k, B[Ne + 5 | 0] = k >>> 8, B[Ne + 6 | 0] = k >>> 16, B[Ne + 7 | 0] = k >>> 24, k = m[1426] | m[1427] << 8 | m[1428] << 16 | m[1429] << 24, B[Ne + 8 | 0] = k, B[Ne + 9 | 0] = k >>> 8, B[Ne + 10 | 0] = k >>> 16, B[Ne + 11 | 0] = k >>> 24, T = -11, E = 11;
                              }
                              if (!(k = Ss(gr))) if (B[ye + 13 | 0] = 0, B[ye + 11 | 0] = 49, B[ye + 12 | 0] = 57, (T = T + 128 | 0) >>> 0 <= (k = sc(ye + 11 | 0)) >>> 0) k = -31;
                              else if (E = fa(E + Ne | 0, ye + 11 | 0, k + 1 | 0), (Pr = T - k | 0) >>> 0 < 4) k = -31;
                              else {
                                for (B[0 | (pr = k + E | 0)] = 36, B[pr + 1 | 0] = 109, B[pr + 2 | 0] = 61, B[pr + 3 | 0] = 0, k = o[gr + 44 >> 2], E = 10; T = E, M = (k >>> 0) / 10 | 0, B[0 | (Nr = (E = E - 1 | 0) + (ye + 22 | 0) | 0)] = k - v(M, 10) | 48, !(k >>> 0 < 10) && (k = M, E); ) ;
                                if (fa(k = ye + 11 | 0, Nr, E = 11 - T | 0), B[k + E | 0] = 0, (E = Pr - 3 | 0) >>> 0 <= (k = sc(k)) >>> 0) k = -31;
                                else if (T = fa(pr + 3 | 0, ye + 11 | 0, k + 1 | 0), (Pr = E - k | 0) >>> 0 < 4) k = -31;
                                else {
                                  for (B[0 | (pr = k + T | 0)] = 44, B[pr + 1 | 0] = 116, B[pr + 2 | 0] = 61, B[pr + 3 | 0] = 0, k = o[gr + 40 >> 2], E = 10; T = E, M = (k >>> 0) / 10 | 0, B[0 | (Nr = (E = E - 1 | 0) + (ye + 22 | 0) | 0)] = k - v(M, 10) | 48, !(k >>> 0 < 10) && (k = M, E); ) ;
                                  if (fa(k = ye + 11 | 0, Nr, E = 11 - T | 0), B[k + E | 0] = 0, (E = Pr - 3 | 0) >>> 0 <= (k = sc(k)) >>> 0) k = -31;
                                  else if (T = fa(pr + 3 | 0, ye + 11 | 0, k + 1 | 0), (Pr = E - k | 0) >>> 0 < 4) k = -31;
                                  else {
                                    for (B[0 | (pr = k + T | 0)] = 44, B[pr + 1 | 0] = 112, B[pr + 2 | 0] = 61, B[pr + 3 | 0] = 0, k = o[gr + 48 >> 2], E = 10; T = E, M = (k >>> 0) / 10 | 0, B[0 | (Nr = (E = E - 1 | 0) + (ye + 22 | 0) | 0)] = k - v(M, 10) | 48, !(k >>> 0 < 10) && (k = M, E); ) ;
                                    fa(k = ye + 11 | 0, Nr, E = 11 - T | 0), B[k + E | 0] = 0, (E = Pr - 3 | 0) >>> 0 <= (k = sc(k)) >>> 0 ? k = -31 : (T = fa(pr + 3 | 0, ye + 11 | 0, k + 1 | 0), (M = E - k | 0) >>> 0 < 2 ? k = -31 : (B[0 | (k = k + T | 0)] = 36, B[k + 1 | 0] = 0, Nf(E = k + 1 | 0, T = M - 1 | 0, o[gr + 16 >> 2], o[gr + 20 >> 2], 3) ? (k = -31, (M = (M = T) - (T = sc(E)) | 0) >>> 0 < 2 || (B[0 | (k = E + T | 0)] = 36, B[k + 1 | 0] = 0, k = Nf(k + 1 | 0, M - 1 | 0, o[gr >> 2], o[gr + 4 >> 2], 3) ? 0 : -31)) : k = -31));
                                  }
                                }
                              }
                            }
                            if (dr = ye + 32 | 0, k) {
                              _s(cr, 32), _s(Ne, 128), k = -31;
                              break e;
                            }
                          }
                          _s(cr, 32), k = 0;
                        }
                        js(cr);
                      } else k = -22;
                      return dr = ve - -64 | 0, k;
                    }
                    function va(k, E) {
                      var T, M = 0, ye = 0, Ne = 0, pr = 0, ve = 0, cr = 0, gr = 0;
                      T = k + E | 0;
                      e: {
                        t: if (!(1 & (M = o[k + 4 >> 2]))) {
                          if (!(2 & M)) break e;
                          E = (M = o[k >> 2]) + E | 0;
                          r: {
                            i: {
                              n: {
                                if ((0 | (k = k - M | 0)) != o[9410]) {
                                  if (ye = o[k + 12 >> 2], M >>> 0 <= 255) {
                                    if ((0 | (Ne = o[k + 8 >> 2])) != (0 | ye)) break n;
                                    cr = 37620, gr = o[9405] & ao(-2, M >>> 3 | 0), o[cr >> 2] = gr;
                                    break t;
                                  }
                                  if (pr = o[k + 24 >> 2], (0 | k) != (0 | ye)) {
                                    M = o[k + 8 >> 2], o[M + 12 >> 2] = ye, o[ye + 8 >> 2] = M;
                                    break r;
                                  }
                                  if (Ne = o[k + 20 >> 2]) M = k + 20 | 0;
                                  else {
                                    if (!(Ne = o[k + 16 >> 2])) break i;
                                    M = k + 16 | 0;
                                  }
                                  for (; ve = M, M = (ye = Ne) + 20 | 0, (Ne = o[ye + 20 >> 2]) || (M = ye + 16 | 0, Ne = o[ye + 16 >> 2]); ) ;
                                  o[ve >> 2] = 0;
                                  break r;
                                }
                                if (3 & ~(M = o[T + 4 >> 2])) break t;
                                return o[9407] = E, o[T + 4 >> 2] = -2 & M, o[k + 4 >> 2] = 1 | E, void (o[T >> 2] = E);
                              }
                              o[Ne + 12 >> 2] = ye, o[ye + 8 >> 2] = Ne;
                              break t;
                            }
                            ye = 0;
                          }
                          if (pr) {
                            M = o[k + 28 >> 2];
                            r: {
                              if (o[(Ne = 37924 + (M << 2) | 0) >> 2] == (0 | k)) {
                                if (o[Ne >> 2] = ye, ye) break r;
                                cr = 37624, gr = o[9406] & ao(-2, M), o[cr >> 2] = gr;
                                break t;
                              }
                              if (o[pr + (o[pr + 16 >> 2] == (0 | k) ? 16 : 20) >> 2] = ye, !ye) break t;
                            }
                            o[ye + 24 >> 2] = pr, (M = o[k + 16 >> 2]) && (o[ye + 16 >> 2] = M, o[M + 24 >> 2] = ye), (M = o[k + 20 >> 2]) && (o[ye + 20 >> 2] = M, o[M + 24 >> 2] = ye);
                          }
                        }
                        t: {
                          r: {
                            i: {
                              n: {
                                if (!(2 & (M = o[T + 4 >> 2]))) {
                                  if (o[9411] == (0 | T)) {
                                    if (o[9411] = k, E = o[9408] + E | 0, o[9408] = E, o[k + 4 >> 2] = 1 | E, o[9410] != (0 | k)) break e;
                                    return o[9407] = 0, void (o[9410] = 0);
                                  }
                                  if (o[9410] == (0 | T)) return o[9410] = k, E = o[9407] + E | 0, o[9407] = E, o[k + 4 >> 2] = 1 | E, void (o[k + E >> 2] = E);
                                  if (E = (-8 & M) + E | 0, ye = o[T + 12 >> 2], M >>> 0 <= 255) {
                                    if ((0 | (Ne = o[T + 8 >> 2])) == (0 | ye)) {
                                      cr = 37620, gr = o[9405] & ao(-2, M >>> 3 | 0), o[cr >> 2] = gr;
                                      break r;
                                    }
                                    o[Ne + 12 >> 2] = ye, o[ye + 8 >> 2] = Ne;
                                    break r;
                                  }
                                  if (pr = o[T + 24 >> 2], (0 | ye) != (0 | T)) {
                                    M = o[T + 8 >> 2], o[M + 12 >> 2] = ye, o[ye + 8 >> 2] = M;
                                    break i;
                                  }
                                  if (Ne = o[T + 20 >> 2]) M = T + 20 | 0;
                                  else {
                                    if (!(Ne = o[T + 16 >> 2])) break n;
                                    M = T + 16 | 0;
                                  }
                                  for (; ve = M, M = (ye = Ne) + 20 | 0, (Ne = o[ye + 20 >> 2]) || (M = ye + 16 | 0, Ne = o[ye + 16 >> 2]); ) ;
                                  o[ve >> 2] = 0;
                                  break i;
                                }
                                o[T + 4 >> 2] = -2 & M, o[k + 4 >> 2] = 1 | E, o[k + E >> 2] = E;
                                break t;
                              }
                              ye = 0;
                            }
                            if (pr) {
                              M = o[T + 28 >> 2];
                              i: {
                                if (o[(Ne = 37924 + (M << 2) | 0) >> 2] == (0 | T)) {
                                  if (o[Ne >> 2] = ye, ye) break i;
                                  cr = 37624, gr = o[9406] & ao(-2, M), o[cr >> 2] = gr;
                                  break r;
                                }
                                if (o[pr + (o[pr + 16 >> 2] == (0 | T) ? 16 : 20) >> 2] = ye, !ye) break r;
                              }
                              o[ye + 24 >> 2] = pr, (M = o[T + 16 >> 2]) && (o[ye + 16 >> 2] = M, o[M + 24 >> 2] = ye), (M = o[T + 20 >> 2]) && (o[ye + 20 >> 2] = M, o[M + 24 >> 2] = ye);
                            }
                          }
                          if (o[k + 4 >> 2] = 1 | E, o[k + E >> 2] = E, o[9410] == (0 | k)) return void (o[9407] = E);
                        }
                        if (E >>> 0 <= 255) return M = 37660 + (-8 & E) | 0, (ye = o[9405]) & (E = 1 << (E >>> 3)) ? E = o[M + 8 >> 2] : (o[9405] = E | ye, E = M), o[M + 8 >> 2] = k, o[E + 12 >> 2] = k, o[k + 12 >> 2] = M, void (o[k + 8 >> 2] = E);
                        ye = 31, E >>> 0 <= 16777215 && (ye = 62 + ((E >>> 38 - (M = he(E >>> 8 | 0)) & 1) - (M << 1) | 0) | 0), o[k + 28 >> 2] = ye, o[k + 16 >> 2] = 0, o[k + 20 >> 2] = 0, M = 37924 + (ye << 2) | 0;
                        t: {
                          if ((Ne = o[9406]) & (ve = 1 << ye)) {
                            for (ye = E << ((0 | ye) != 31 ? 25 - (ye >>> 1 | 0) : 0), M = o[M >> 2]; ; ) {
                              if (Ne = M, (-8 & o[M + 4 >> 2]) == (0 | E)) break t;
                              if (M = ye >>> 29 | 0, ye <<= 1, !(M = o[16 + (ve = Ne + (4 & M) | 0) >> 2])) break;
                            }
                            o[ve + 16 >> 2] = k, o[k + 24 >> 2] = Ne;
                          } else o[9406] = Ne | ve, o[M >> 2] = k, o[k + 24 >> 2] = M;
                          return o[k + 12 >> 2] = k, void (o[k + 8 >> 2] = k);
                        }
                        E = o[Ne + 8 >> 2], o[E + 12 >> 2] = k, o[Ne + 8 >> 2] = k, o[k + 24 >> 2] = 0, o[k + 12 >> 2] = Ne, o[k + 8 >> 2] = E;
                      }
                    }
                    function oa(k, E) {
                      var T, M = 0, ye = 0, Ne = 0, pr = 0, ve = 0, cr = 0, gr = 0, Pr = 0, Nr = 0, Br = 0, Mr = 0, jr = 0, ti = 0, fi = 0, Jr = 0, li = 0, Tr = 0, Mi = 0, Wi = 0, vn = 0, Tn = 0, Ni = 0;
                      return dr = T = dr - 512 | 0, M = -1, Ne = m[E + 31 | 0], ye = m[0 | E], 1 & (((255 & (127 & ~Ne | ~(m[E + 1 | 0] & m[E + 2 | 0] & m[E + 3 | 0] & m[E + 4 | 0] & m[E + 5 | 0] & m[E + 6 | 0] & m[E + 7 | 0] & m[E + 8 | 0] & m[E + 9 | 0] & m[E + 10 | 0] & m[E + 11 | 0] & m[E + 12 | 0] & m[E + 13 | 0] & m[E + 14 | 0] & m[E + 15 | 0] & m[E + 16 | 0] & m[E + 17 | 0] & m[E + 18 | 0] & m[E + 19 | 0] & m[E + 20 | 0] & m[E + 21 | 0] & m[E + 22 | 0] & m[E + 23 | 0] & m[E + 24 | 0] & m[E + 25 | 0] & m[E + 26 | 0] & m[E + 27 | 0] & m[E + 28 | 0] & m[E + 29 | 0] & m[E + 30 | 0]))) - 1 & 236 - ye) >>> 8 | ye | Ne >>> 7) || (Va(Ne = T + 336 | 0, E), qi(T + 288 | 0, Ne), E = o[T + 324 >> 2], o[T + 276 >> 2] = 0 - E, M = o[T + 320 >> 2], o[T + 272 >> 2] = 0 - M, ye = o[T + 316 >> 2], o[T + 268 >> 2] = 0 - ye, pr = o[T + 312 >> 2], o[T + 264 >> 2] = 0 - pr, ve = o[T + 308 >> 2], o[T + 260 >> 2] = 0 - ve, cr = o[T + 304 >> 2], o[T + 256 >> 2] = 0 - cr, gr = o[T + 300 >> 2], o[T + 252 >> 2] = 0 - gr, Pr = o[T + 296 >> 2], o[T + 248 >> 2] = 0 - Pr, Nr = o[T + 292 >> 2], o[T + 244 >> 2] = 0 - Nr, Br = o[T + 288 >> 2], o[T + 240 >> 2] = 1 - Br, qi(Mr = T + 144 | 0, fi = T + 240 | 0), o[T + 228 >> 2] = E, o[T + 224 >> 2] = M, o[T + 220 >> 2] = ye, o[T + 216 >> 2] = pr, o[T + 212 >> 2] = ve, o[T + 208 >> 2] = cr, o[T + 204 >> 2] = gr, o[T + 200 >> 2] = Pr, o[T + 196 >> 2] = Nr, o[T + 192 >> 2] = Br + 1, qi(M = T + 96 | 0, pr = T + 192 | 0), Ti(E = T + 48 | 0, 1584, Mr), ye = o[T + 96 >> 2], ve = o[T + 48 >> 2], cr = o[T + 100 >> 2], gr = o[T + 52 >> 2], Pr = o[T + 104 >> 2], Nr = o[T + 56 >> 2], Br = o[T + 108 >> 2], Mr = o[T + 60 >> 2], jr = o[T + 112 >> 2], ti = o[T + 64 >> 2], Jr = o[T + 116 >> 2], li = o[T + 68 >> 2], Tr = o[T + 120 >> 2], Mi = o[T + 72 >> 2], Wi = o[T + 124 >> 2], vn = o[T + 76 >> 2], Tn = o[T + 128 >> 2], Ni = o[T + 80 >> 2], o[T + 84 >> 2] = 0 - (o[T + 84 >> 2] + o[T + 132 >> 2] | 0), o[T + 80 >> 2] = 0 - (Tn + Ni | 0), o[T + 76 >> 2] = 0 - (Wi + vn | 0), o[T + 72 >> 2] = 0 - (Tr + Mi | 0), o[T + 68 >> 2] = 0 - (Jr + li | 0), o[T + 64 >> 2] = 0 - (jr + ti | 0), o[T + 60 >> 2] = 0 - (Br + Mr | 0), o[T + 56 >> 2] = 0 - (Pr + Nr | 0), o[T + 52 >> 2] = 0 - (cr + gr | 0), o[T + 48 >> 2] = 0 - (ye + ve | 0), Ti(T, E, M), o[T + 404 >> 2] = 0, o[T + 408 >> 2] = 0, o[T + 412 >> 2] = 0, o[T + 416 >> 2] = 0, o[T + 420 >> 2] = 0, o[T + 388 >> 2] = 0, o[T + 392 >> 2] = 0, o[T + 384 >> 2] = 1, o[T + 396 >> 2] = 0, o[T + 400 >> 2] = 0, ti = zo(ye = T + 432 | 0, T + 384 | 0, T), Ti(k, ye, pr), Ti(M = k + 40 | 0, ye, k), Ti(M, M, E), Ti(k, k, Ne), Ne = o[k + 36 >> 2] << 1, o[k + 36 >> 2] = Ne, ye = o[k + 32 >> 2] << 1, o[k + 32 >> 2] = ye, pr = o[k + 28 >> 2] << 1, o[k + 28 >> 2] = pr, ve = o[k + 24 >> 2] << 1, o[k + 24 >> 2] = ve, cr = o[k + 20 >> 2] << 1, o[k + 20 >> 2] = cr, gr = o[k + 16 >> 2] << 1, o[k + 16 >> 2] = gr, Pr = o[k + 12 >> 2] << 1, o[k + 12 >> 2] = Pr, Nr = o[k + 8 >> 2] << 1, o[k + 8 >> 2] = Nr, Br = o[k + 4 >> 2] << 1, o[k + 4 >> 2] = Br, Mr = o[k >> 2] << 1, o[k >> 2] = Mr, i2(jr = T + 480 | 0, k), E = 0 - (1 & B[T + 480 | 0]) | 0, o[k + 36 >> 2] = Ne ^ E & (Ne ^ 0 - Ne), o[k + 32 >> 2] = ye ^ E & (ye ^ 0 - ye), o[k + 28 >> 2] = pr ^ E & (pr ^ 0 - pr), o[k + 24 >> 2] = ve ^ E & (ve ^ 0 - ve), o[k + 20 >> 2] = cr ^ E & (cr ^ 0 - cr), o[k + 16 >> 2] = gr ^ E & (gr ^ 0 - gr), o[k + 12 >> 2] = Pr ^ E & (Pr ^ 0 - Pr), o[k + 8 >> 2] = Nr ^ E & (Nr ^ 0 - Nr), o[k + 4 >> 2] = Br ^ E & (Br ^ 0 - Br), o[k >> 2] = Mr ^ E & (Mr ^ 0 - Mr), Ti(M, fi, M), o[k + 84 >> 2] = 0, o[k + 88 >> 2] = 0, o[k + 80 >> 2] = 1, o[k + 92 >> 2] = 0, o[k + 96 >> 2] = 0, o[k + 100 >> 2] = 0, o[k + 104 >> 2] = 0, o[k + 108 >> 2] = 0, o[k + 112 >> 2] = 0, o[k + 116 >> 2] = 0, Ti(E = k + 120 | 0, k, M), i2(jr, E), k = m[T + 480 | 0], i2(jr, M), M = 0 - (pa(jr, 32) | 1 - ti | 1 & k) | 0), dr = T + 512 | 0, M;
                    }
                    function wa(k, E, T, M) {
                      var ye, Ne = 0, pr = 0;
                      ye = Ne = dr, dr = Ne = Ne - 576 & -64, o[Ne + 188 >> 2] = E;
                      e: if (E >>> 0 <= 64) {
                        if ((0 | Na(pr = Ne + 192 | 0, 0, 0, E)) < 0) break e;
                        (0 | E2(pr, Ne + 188 | 0, 4, 0)) < 0, (0 | E2(pr, T, M, 0)) < 0, Bu(pr, k, E);
                      } else if (!((0 | Na(pr = Ne + 192 | 0, 0, 0, 64)) < 0 || (0 | E2(pr, Ne + 188 | 0, 4, 0)) < 0 || (0 | E2(pr, T, M, 0)) < 0 || (0 | Bu(pr, Ne + 112 | 0, 64)) < 0)) {
                        if (T = o[Ne + 116 >> 2], M = o[Ne + 112 >> 2], B[0 | k] = M, B[k + 1 | 0] = M >>> 8, B[k + 2 | 0] = M >>> 16, B[k + 3 | 0] = M >>> 24, B[k + 4 | 0] = T, B[k + 5 | 0] = T >>> 8, B[k + 6 | 0] = T >>> 16, B[k + 7 | 0] = T >>> 24, T = o[Ne + 124 >> 2], M = o[Ne + 120 >> 2], B[k + 8 | 0] = M, B[k + 9 | 0] = M >>> 8, B[k + 10 | 0] = M >>> 16, B[k + 11 | 0] = M >>> 24, B[k + 12 | 0] = T, B[k + 13 | 0] = T >>> 8, B[k + 14 | 0] = T >>> 16, B[k + 15 | 0] = T >>> 24, T = o[Ne + 140 >> 2], M = o[Ne + 136 >> 2], B[k + 24 | 0] = M, B[k + 25 | 0] = M >>> 8, B[k + 26 | 0] = M >>> 16, B[k + 27 | 0] = M >>> 24, B[k + 28 | 0] = T, B[k + 29 | 0] = T >>> 8, B[k + 30 | 0] = T >>> 16, B[k + 31 | 0] = T >>> 24, T = o[Ne + 132 >> 2], M = o[Ne + 128 >> 2], B[k + 16 | 0] = M, B[k + 17 | 0] = M >>> 8, B[k + 18 | 0] = M >>> 16, B[k + 19 | 0] = M >>> 24, B[k + 20 | 0] = T, B[k + 21 | 0] = T >>> 8, B[k + 22 | 0] = T >>> 16, B[k + 23 | 0] = T >>> 24, k = k + 32 | 0, (E = E - 32 | 0) >>> 0 >= 65) for (; ; ) {
                          if (T = o[Ne + 172 >> 2], o[Ne + 104 >> 2] = o[Ne + 168 >> 2], o[Ne + 108 >> 2] = T, T = o[Ne + 164 >> 2], o[Ne + 96 >> 2] = o[Ne + 160 >> 2], o[Ne + 100 >> 2] = T, T = o[Ne + 156 >> 2], o[Ne + 88 >> 2] = o[Ne + 152 >> 2], o[Ne + 92 >> 2] = T, T = o[Ne + 148 >> 2], o[Ne + 80 >> 2] = o[Ne + 144 >> 2], o[Ne + 84 >> 2] = T, T = o[Ne + 140 >> 2], o[Ne + 72 >> 2] = o[Ne + 136 >> 2], o[Ne + 76 >> 2] = T, M = o[Ne + 132 >> 2], o[(T = Ne - -64 | 0) >> 2] = o[Ne + 128 >> 2], o[T + 4 >> 2] = M, T = o[Ne + 124 >> 2], o[Ne + 56 >> 2] = o[Ne + 120 >> 2], o[Ne + 60 >> 2] = T, T = o[Ne + 116 >> 2], o[Ne + 48 >> 2] = o[Ne + 112 >> 2], o[Ne + 52 >> 2] = T, (0 | Ko(Ne + 112 | 0, 64, Ne + 48 | 0, 64, 0, 0, 0)) < 0) break e;
                          if (T = o[Ne + 116 >> 2], M = o[Ne + 112 >> 2], B[0 | k] = M, B[k + 1 | 0] = M >>> 8, B[k + 2 | 0] = M >>> 16, B[k + 3 | 0] = M >>> 24, B[k + 4 | 0] = T, B[k + 5 | 0] = T >>> 8, B[k + 6 | 0] = T >>> 16, B[k + 7 | 0] = T >>> 24, T = o[Ne + 124 >> 2], M = o[Ne + 120 >> 2], B[k + 8 | 0] = M, B[k + 9 | 0] = M >>> 8, B[k + 10 | 0] = M >>> 16, B[k + 11 | 0] = M >>> 24, B[k + 12 | 0] = T, B[k + 13 | 0] = T >>> 8, B[k + 14 | 0] = T >>> 16, B[k + 15 | 0] = T >>> 24, T = o[Ne + 140 >> 2], M = o[Ne + 136 >> 2], B[k + 24 | 0] = M, B[k + 25 | 0] = M >>> 8, B[k + 26 | 0] = M >>> 16, B[k + 27 | 0] = M >>> 24, B[k + 28 | 0] = T, B[k + 29 | 0] = T >>> 8, B[k + 30 | 0] = T >>> 16, B[k + 31 | 0] = T >>> 24, T = o[Ne + 132 >> 2], M = o[Ne + 128 >> 2], B[k + 16 | 0] = M, B[k + 17 | 0] = M >>> 8, B[k + 18 | 0] = M >>> 16, B[k + 19 | 0] = M >>> 24, B[k + 20 | 0] = T, B[k + 21 | 0] = T >>> 8, B[k + 22 | 0] = T >>> 16, B[k + 23 | 0] = T >>> 24, k = k + 32 | 0, !((E = E - 32 | 0) >>> 0 > 64)) break;
                        }
                        T = o[Ne + 172 >> 2], o[Ne + 104 >> 2] = o[Ne + 168 >> 2], o[Ne + 108 >> 2] = T, T = o[Ne + 164 >> 2], o[Ne + 96 >> 2] = o[Ne + 160 >> 2], o[Ne + 100 >> 2] = T, T = o[Ne + 156 >> 2], o[Ne + 88 >> 2] = o[Ne + 152 >> 2], o[Ne + 92 >> 2] = T, T = o[Ne + 148 >> 2], o[Ne + 80 >> 2] = o[Ne + 144 >> 2], o[Ne + 84 >> 2] = T, T = o[Ne + 140 >> 2], o[Ne + 72 >> 2] = o[Ne + 136 >> 2], o[Ne + 76 >> 2] = T, M = o[Ne + 132 >> 2], o[(T = Ne - -64 | 0) >> 2] = o[Ne + 128 >> 2], o[T + 4 >> 2] = M, T = o[Ne + 124 >> 2], o[Ne + 56 >> 2] = o[Ne + 120 >> 2], o[Ne + 60 >> 2] = T, T = o[Ne + 116 >> 2], o[Ne + 48 >> 2] = o[Ne + 112 >> 2], o[Ne + 52 >> 2] = T, (0 | Ko(T = Ne + 112 | 0, E, Ne + 48 | 0, 64, 0, 0, 0)) < 0 || fa(k, T, E);
                      }
                      _s(Ne + 192 | 0, 384), dr = ye;
                    }
                    function Pa(k, E, T, M, ye, Ne, pr, ve, cr, gr, Pr) {
                      var Nr = 0, Br = 0, Mr = 0, jr = 0, ti = 0, fi = 0, Jr = 0, li = 0, Tr = 0, Mi = 0, Wi = 0, vn = 0, Tn = 0, Ni = 0, Yi = 0, Xi = 0, $n = 0;
                      if (Nr = Zr(cr, 0, ve, 0), !(ti = Qe) & Nr >>> 0 >= 1073741824 | ti || (0 | pr) == 1 | pr >>> 0 > 1) return o[9404] = 22, -1;
                      if (Nr = pr, !(!(Ne & (ti = Ne - 1 | 0) | pr & (Nr = (0 | ti) != -1 ? Nr + 1 | 0 : Nr)) & (!pr & Ne >>> 0 >= 2 | !!(0 | pr))) || !cr || !ve) return o[9404] = 28, -1;
                      if (!(33554431 / (cr >>> 0) >>> 0 < ve >>> 0 | ve >>> 0 > 16777215) && !pr & 33554431 / (ve >>> 0) >>> 0 >= Ne >>> 0 && !((Wi = v(Mi = ve << 7, cr)) >>> 0 > (Nr = (fi = v(Ne, Mi)) + Wi | 0) >>> 0 || (Br = Nr) >>> 0 > (Nr = ((Jr = ve << 8) + Nr | 0) - -64 | 0) >>> 0)) {
                        e: {
                          if (Nr >>> 0 > d[k + 8 >> 2] && (jr = -1, Ju(k), dr = ti = dr - 16 | 0, Br = ki(ti + 12 | 0, Nr), o[9404] = Br, Br = Br ? 0 : o[ti + 12 >> 2], o[k + 4 >> 2] = Br, o[k >> 2] = Br, o[k + 8 >> 2] = Br ? Nr : 0, dr = ti + 16 | 0, !Br))
                            break e;
                          for (ko(E, T, M, ye, Tn = o[k + 4 >> 2], Wi), Xi = ((fi = (Br = (vn = Wi + Tn | 0) + fi | 0) + (ve << 7) | 0) + Mi | 0) - 64 | 0, ye = Ne - 1 | 0, Tr = ve << 5, Ni = Br + Jr | 0, $n = (Br + Mi | 0) - 64 | 0; ; ) {
                            for (Jr = v(Mi, Yi) + Tn | 0, jr = 0; M = (k = jr << 2) + Jr | 0, o[k + Br >> 2] = m[0 | M] | m[M + 1 | 0] << 8 | m[M + 2 | 0] << 16 | m[M + 3 | 0] << 24, Nr = (M = 4 | k) + Br | 0, M = M + Jr | 0, o[Nr >> 2] = m[0 | M] | m[M + 1 | 0] << 8 | m[M + 2 | 0] << 16 | m[M + 3 | 0] << 24, Nr = (M = 8 | k) + Br | 0, M = M + Jr | 0, o[Nr >> 2] = m[0 | M] | m[M + 1 | 0] << 8 | m[M + 2 | 0] << 16 | m[M + 3 | 0] << 24, M = (k |= 12) + Br | 0, k = k + Jr | 0, o[M >> 2] = m[0 | k] | m[k + 1 | 0] << 8 | m[k + 2 | 0] << 16 | m[k + 3 | 0] << 24, ti = 0, Nr = 0, (0 | Tr) != (0 | (jr = jr + 4 | 0)); ) ;
                            for (M = 0, k = 0; fa(vn + (v(M, Tr) << 2) | 0, Br, Mi), jn(Br, fi, Ni, ve), fa(vn + (v(Tr, 1 | M) << 2) | 0, fi, Mi), jn(fi, Br, Ni, ve), (0 | pr) == (0 | (k = (M = M + 2 | 0) >>> 0 < 2 ? k + 1 | 0 : k)) & M >>> 0 < Ne >>> 0 | k >>> 0 < pr >>> 0; ) ;
                            for (; ; ) {
                              for (k = vn + (v(Tr, ye & o[$n >> 2]) << 2) | 0, jr = 0; o[(Mr = (M = jr << 2) + Br | 0) >> 2] = o[Mr >> 2] ^ o[k + M >> 2], o[(li = (Mr = 4 | M) + Br | 0) >> 2] = o[li >> 2] ^ o[k + Mr >> 2], o[(li = (Mr = 8 | M) + Br | 0) >> 2] = o[li >> 2] ^ o[k + Mr >> 2], o[(Mr = (M |= 12) + Br | 0) >> 2] = o[Mr >> 2] ^ o[k + M >> 2], (0 | Tr) != (0 | (jr = jr + 4 | 0)); ) ;
                              for (jn(Br, fi, Ni, ve), k = vn + (v(Tr, ye & o[Xi >> 2]) << 2) | 0, jr = 0; o[(Mr = (M = jr << 2) + fi | 0) >> 2] = o[Mr >> 2] ^ o[k + M >> 2], o[(li = (Mr = 4 | M) + fi | 0) >> 2] = o[li >> 2] ^ o[k + Mr >> 2], o[(li = (Mr = 8 | M) + fi | 0) >> 2] = o[li >> 2] ^ o[k + Mr >> 2], o[(Mr = (M |= 12) + fi | 0) >> 2] = o[Mr >> 2] ^ o[k + M >> 2], (0 | Tr) != (0 | (jr = jr + 4 | 0)); ) ;
                              if (jn(fi, Br, Ni, ve), jr = 0, !((0 | pr) == (0 | (Nr = (ti = ti + 2 | 0) >>> 0 < 2 ? Nr + 1 | 0 : Nr)) & Ne >>> 0 > ti >>> 0 | pr >>> 0 > Nr >>> 0)) break;
                            }
                            for (; M = (k = jr << 2) + Jr | 0, Nr = o[k + Br >> 2], B[0 | M] = Nr, B[M + 1 | 0] = Nr >>> 8, B[M + 2 | 0] = Nr >>> 16, B[M + 3 | 0] = Nr >>> 24, M = (Nr = 4 | k) + Jr | 0, Nr = o[Nr + Br >> 2], B[0 | M] = Nr, B[M + 1 | 0] = Nr >>> 8, B[M + 2 | 0] = Nr >>> 16, B[M + 3 | 0] = Nr >>> 24, M = (Nr = 8 | k) + Jr | 0, Nr = o[Nr + Br >> 2], B[0 | M] = Nr, B[M + 1 | 0] = Nr >>> 8, B[M + 2 | 0] = Nr >>> 16, B[M + 3 | 0] = Nr >>> 24, k = (M = 12 | k) + Jr | 0, M = o[M + Br >> 2], B[0 | k] = M, B[k + 1 | 0] = M >>> 8, B[k + 2 | 0] = M >>> 16, B[k + 3 | 0] = M >>> 24, (0 | Tr) != (0 | (jr = jr + 4 | 0)); ) ;
                            if ((0 | (Yi = Yi + 1 | 0)) == (0 | cr)) break;
                          }
                          ko(E, T, Tn, Wi, gr, Pr), jr = 0;
                        }
                        return jr;
                      }
                      return o[9404] = 48, -1;
                    }
                    function Ta(k, E, T) {
                      k |= 0, E |= 0, T |= 0;
                      var M, ye, Ne, pr = 0;
                      dr = M = dr - 192 | 0, o[M + 96 >> 2] = 0, o[M + 100 >> 2] = 0, o[M + 104 >> 2] = 0, o[M + 108 >> 2] = 0, o[M + 112 >> 2] = 0, o[M + 116 >> 2] = 0, o[M + 120 >> 2] = 0, o[M + 124 >> 2] = 0, pr = m[E + 20 | 0] | m[E + 21 | 0] << 8 | m[E + 22 | 0] << 16 | m[E + 23 | 0] << 24, o[M + 80 >> 2] = m[E + 16 | 0] | m[E + 17 | 0] << 8 | m[E + 18 | 0] << 16 | m[E + 19 | 0] << 24, o[M + 84 >> 2] = pr, pr = m[E + 28 | 0] | m[E + 29 | 0] << 8 | m[E + 30 | 0] << 16 | m[E + 31 | 0] << 24, o[M + 88 >> 2] = m[E + 24 | 0] | m[E + 25 | 0] << 8 | m[E + 26 | 0] << 16 | m[E + 27 | 0] << 24, o[M + 92 >> 2] = pr, ye = m[E + 8 | 0] | m[E + 9 | 0] << 8 | m[E + 10 | 0] << 16 | m[E + 11 | 0] << 24, Ne = m[E + 12 | 0] | m[E + 13 | 0] << 8 | m[E + 14 | 0] << 16 | m[E + 15 | 0] << 24, pr = m[0 | E] | m[E + 1 | 0] << 8 | m[E + 2 | 0] << 16 | m[E + 3 | 0] << 24, E = m[E + 4 | 0] | m[E + 5 | 0] << 8 | m[E + 6 | 0] << 16 | m[E + 7 | 0] << 24, o[M + 40 >> 2] = 0, o[M + 44 >> 2] = 0, o[M + 48 >> 2] = 0, o[M + 52 >> 2] = 0, o[M + 56 >> 2] = 0, o[M + 60 >> 2] = 0, o[M + 64 >> 2] = pr, o[M + 68 >> 2] = E, o[M + 72 >> 2] = ye, o[M + 76 >> 2] = Ne, o[M + 32 >> 2] = 0, o[M + 36 >> 2] = 0, E = m[T + 20 | 0] | m[T + 21 | 0] << 8 | m[T + 22 | 0] << 16 | m[T + 23 | 0] << 24, o[M + 16 >> 2] = m[T + 16 | 0] | m[T + 17 | 0] << 8 | m[T + 18 | 0] << 16 | m[T + 19 | 0] << 24, o[M + 20 >> 2] = E, E = m[T + 28 | 0] | m[T + 29 | 0] << 8 | m[T + 30 | 0] << 16 | m[T + 31 | 0] << 24, o[M + 24 >> 2] = m[T + 24 | 0] | m[T + 25 | 0] << 8 | m[T + 26 | 0] << 16 | m[T + 27 | 0] << 24, o[M + 28 >> 2] = E, E = m[T + 4 | 0] | m[T + 5 | 0] << 8 | m[T + 6 | 0] << 16 | m[T + 7 | 0] << 24, o[M >> 2] = m[0 | T] | m[T + 1 | 0] << 8 | m[T + 2 | 0] << 16 | m[T + 3 | 0] << 24, o[M + 4 >> 2] = E, E = m[T + 12 | 0] | m[T + 13 | 0] << 8 | m[T + 14 | 0] << 16 | m[T + 15 | 0] << 24, o[M + 8 >> 2] = m[T + 8 | 0] | m[T + 9 | 0] << 8 | m[T + 10 | 0] << 16 | m[T + 11 | 0] << 24, o[M + 12 >> 2] = E, Sh(M - -64 | 0, M), T = o[M + 124 >> 2], o[M + 184 >> 2] = o[M + 120 >> 2], o[M + 188 >> 2] = T, E = o[M + 116 >> 2], o[M + 176 >> 2] = o[M + 112 >> 2], o[M + 180 >> 2] = E, E = o[M + 108 >> 2], o[M + 168 >> 2] = o[M + 104 >> 2], o[M + 172 >> 2] = E, E = o[M + 100 >> 2], o[M + 160 >> 2] = o[M + 96 >> 2], o[M + 164 >> 2] = E, E = o[M + 92 >> 2], o[M + 152 >> 2] = o[M + 88 >> 2], o[M + 156 >> 2] = E, E = o[M + 84 >> 2], o[M + 144 >> 2] = o[M + 80 >> 2], o[M + 148 >> 2] = E, E = o[M + 76 >> 2], o[M + 136 >> 2] = o[M + 72 >> 2], o[M + 140 >> 2] = E, E = o[M + 68 >> 2], o[M + 128 >> 2] = o[M + 64 >> 2], o[M + 132 >> 2] = E, Si(E = M + 128 | 0), pr = o[M + 156 >> 2], T = o[M + 152 >> 2], B[k + 24 | 0] = T, B[k + 25 | 0] = T >>> 8, B[k + 26 | 0] = T >>> 16, B[k + 27 | 0] = T >>> 24, B[k + 28 | 0] = pr, B[k + 29 | 0] = pr >>> 8, B[k + 30 | 0] = pr >>> 16, B[k + 31 | 0] = pr >>> 24, pr = o[M + 148 >> 2], T = o[M + 144 >> 2], B[k + 16 | 0] = T, B[k + 17 | 0] = T >>> 8, B[k + 18 | 0] = T >>> 16, B[k + 19 | 0] = T >>> 24, B[k + 20 | 0] = pr, B[k + 21 | 0] = pr >>> 8, B[k + 22 | 0] = pr >>> 16, B[k + 23 | 0] = pr >>> 24, pr = o[M + 140 >> 2], T = o[M + 136 >> 2], B[k + 8 | 0] = T, B[k + 9 | 0] = T >>> 8, B[k + 10 | 0] = T >>> 16, B[k + 11 | 0] = T >>> 24, B[k + 12 | 0] = pr, B[k + 13 | 0] = pr >>> 8, B[k + 14 | 0] = pr >>> 16, B[k + 15 | 0] = pr >>> 24, pr = o[M + 132 >> 2], T = o[M + 128 >> 2], B[0 | k] = T, B[k + 1 | 0] = T >>> 8, B[k + 2 | 0] = T >>> 16, B[k + 3 | 0] = T >>> 24, B[k + 4 | 0] = pr, B[k + 5 | 0] = pr >>> 8, B[k + 6 | 0] = pr >>> 16, B[k + 7 | 0] = pr >>> 24, _s(E, 64), dr = M + 192 | 0;
                    }
                    function jn(k, E, T, M) {
                      var ye = 0, Ne = 0, pr = 0, ve = 0, cr = 0;
                      if (Ne = o[4 + (ye = ((M << 7) + k | 0) - 64 | 0) >> 2], o[T >> 2] = o[ye >> 2], o[T + 4 >> 2] = Ne, Ne = o[ye + 60 >> 2], o[T + 56 >> 2] = o[ye + 56 >> 2], o[T + 60 >> 2] = Ne, Ne = o[ye + 52 >> 2], o[T + 48 >> 2] = o[ye + 48 >> 2], o[T + 52 >> 2] = Ne, Ne = o[ye + 44 >> 2], o[T + 40 >> 2] = o[ye + 40 >> 2], o[T + 44 >> 2] = Ne, Ne = o[ye + 36 >> 2], o[T + 32 >> 2] = o[ye + 32 >> 2], o[T + 36 >> 2] = Ne, Ne = o[ye + 28 >> 2], o[T + 24 >> 2] = o[ye + 24 >> 2], o[T + 28 >> 2] = Ne, Ne = o[ye + 20 >> 2], o[T + 16 >> 2] = o[ye + 16 >> 2], o[T + 20 >> 2] = Ne, Ne = o[ye + 12 >> 2], o[T + 8 >> 2] = o[ye + 8 >> 2], o[T + 12 >> 2] = Ne, M) for (Ne = M << 1, cr = M << 6; M = (ve << 6) + k | 0, o[T >> 2] = o[T >> 2] ^ o[M >> 2], o[T + 4 >> 2] = o[T + 4 >> 2] ^ o[M + 4 >> 2], o[T + 8 >> 2] = o[T + 8 >> 2] ^ o[M + 8 >> 2], o[T + 12 >> 2] = o[T + 12 >> 2] ^ o[M + 12 >> 2], o[T + 16 >> 2] = o[T + 16 >> 2] ^ o[M + 16 >> 2], o[T + 20 >> 2] = o[T + 20 >> 2] ^ o[M + 20 >> 2], o[T + 24 >> 2] = o[T + 24 >> 2] ^ o[M + 24 >> 2], o[T + 28 >> 2] = o[T + 28 >> 2] ^ o[M + 28 >> 2], o[T + 32 >> 2] = o[T + 32 >> 2] ^ o[M + 32 >> 2], o[T + 36 >> 2] = o[T + 36 >> 2] ^ o[M + 36 >> 2], o[T + 40 >> 2] = o[T + 40 >> 2] ^ o[M + 40 >> 2], o[T + 44 >> 2] = o[T + 44 >> 2] ^ o[M + 44 >> 2], o[T + 48 >> 2] = o[T + 48 >> 2] ^ o[M + 48 >> 2], o[T + 52 >> 2] = o[T + 52 >> 2] ^ o[M + 52 >> 2], o[T + 56 >> 2] = o[T + 56 >> 2] ^ o[M + 56 >> 2], o[T + 60 >> 2] = o[T + 60 >> 2] ^ o[M + 60 >> 2], Xf(T), pr = o[T + 60 >> 2], o[56 + (ye = (ve << 5) + E | 0) >> 2] = o[T + 56 >> 2], o[ye + 60 >> 2] = pr, pr = o[T + 52 >> 2], o[ye + 48 >> 2] = o[T + 48 >> 2], o[ye + 52 >> 2] = pr, pr = o[T + 44 >> 2], o[ye + 40 >> 2] = o[T + 40 >> 2], o[ye + 44 >> 2] = pr, pr = o[T + 36 >> 2], o[ye + 32 >> 2] = o[T + 32 >> 2], o[ye + 36 >> 2] = pr, pr = o[T + 28 >> 2], o[ye + 24 >> 2] = o[T + 24 >> 2], o[ye + 28 >> 2] = pr, pr = o[T + 20 >> 2], o[ye + 16 >> 2] = o[T + 16 >> 2], o[ye + 20 >> 2] = pr, pr = o[T + 12 >> 2], o[ye + 8 >> 2] = o[T + 8 >> 2], o[ye + 12 >> 2] = pr, pr = o[T + 4 >> 2], o[ye >> 2] = o[T >> 2], o[ye + 4 >> 2] = pr, o[T >> 2] = o[T >> 2] ^ o[M - -64 >> 2], o[T + 4 >> 2] = o[T + 4 >> 2] ^ o[M + 68 >> 2], o[T + 8 >> 2] = o[T + 8 >> 2] ^ o[M + 72 >> 2], o[T + 12 >> 2] = o[T + 12 >> 2] ^ o[M + 76 >> 2], o[T + 16 >> 2] = o[T + 16 >> 2] ^ o[M + 80 >> 2], o[T + 20 >> 2] = o[T + 20 >> 2] ^ o[M + 84 >> 2], o[T + 24 >> 2] = o[T + 24 >> 2] ^ o[M + 88 >> 2], o[T + 28 >> 2] = o[T + 28 >> 2] ^ o[M + 92 >> 2], o[T + 32 >> 2] = o[T + 32 >> 2] ^ o[M + 96 >> 2], o[T + 36 >> 2] = o[T + 36 >> 2] ^ o[M + 100 >> 2], o[T + 40 >> 2] = o[T + 40 >> 2] ^ o[M + 104 >> 2], o[T + 44 >> 2] = o[T + 44 >> 2] ^ o[M + 108 >> 2], o[T + 48 >> 2] = o[T + 48 >> 2] ^ o[M + 112 >> 2], o[T + 52 >> 2] = o[T + 52 >> 2] ^ o[M + 116 >> 2], o[T + 56 >> 2] = o[T + 56 >> 2] ^ o[M + 120 >> 2], o[T + 60 >> 2] = o[T + 60 >> 2] ^ o[M + 124 >> 2], Xf(T), M = ye + cr | 0, ye = o[T + 60 >> 2], o[M + 56 >> 2] = o[T + 56 >> 2], o[M + 60 >> 2] = ye, ye = o[T + 52 >> 2], o[M + 48 >> 2] = o[T + 48 >> 2], o[M + 52 >> 2] = ye, ye = o[T + 44 >> 2], o[M + 40 >> 2] = o[T + 40 >> 2], o[M + 44 >> 2] = ye, ye = o[T + 36 >> 2], o[M + 32 >> 2] = o[T + 32 >> 2], o[M + 36 >> 2] = ye, ye = o[T + 28 >> 2], o[M + 24 >> 2] = o[T + 24 >> 2], o[M + 28 >> 2] = ye, ye = o[T + 20 >> 2], o[M + 16 >> 2] = o[T + 16 >> 2], o[M + 20 >> 2] = ye, ye = o[T + 12 >> 2], o[M + 8 >> 2] = o[T + 8 >> 2], o[M + 12 >> 2] = ye, ye = o[T + 4 >> 2], o[M >> 2] = o[T >> 2], o[M + 4 >> 2] = ye, Ne >>> 0 > (ve = ve + 2 | 0) >>> 0; ) ;
                    }
                    function ta(k, E, T, M) {
                      var ye = 0, Ne = 0, pr = 0, ve = 0, cr = 0, gr = 0, Pr = 0, Nr = 0, Br = 0, Mr = 0, jr = 0, ti = 0, fi = 0, Jr = 0, li = 0, Tr = 0, Mi = 0, Wi = 0, vn = 0, Tn = 0, Ni = 0, Yi = 0, Xi = 0, $n = 0, Zn = 0;
                      if (jr = o[k + 36 >> 2], Br = o[k + 32 >> 2], Mr = o[k + 28 >> 2], Pr = o[k + 24 >> 2], Nr = o[k + 20 >> 2], !M & T >>> 0 >= 16 | M) for (Ni = !m[k + 80 | 0] << 24, fi = o[k + 4 >> 2], Yi = v(fi, 5), li = o[k + 8 >> 2], vn = v(li, 5), Mi = o[k + 12 >> 2], Wi = v(Mi, 5), Tn = o[k + 16 >> 2], Tr = v(Tn, 5), Jr = o[k >> 2]; ye = Zr(pr = ((m[E + 3 | 0] | m[E + 4 | 0] << 8 | m[E + 5 | 0] << 16 | m[E + 6 | 0] << 24) >>> 2 & 67108863) + Pr | 0, 0, Mi, 0), cr = Qe, Nr = (ve = Zr(Pr = (67108863 & (m[0 | E] | m[E + 1 | 0] << 8 | m[E + 2 | 0] << 16 | m[E + 3 | 0] << 24)) + Nr | 0, 0, Tn, 0)) + ye | 0, ye = Qe + cr | 0, ye = ve >>> 0 > Nr >>> 0 ? ye + 1 | 0 : ye, cr = Zr(Mr = ((m[E + 6 | 0] | m[E + 7 | 0] << 8 | m[E + 8 | 0] << 16 | m[E + 9 | 0] << 24) >>> 4 & 67108863) + Mr | 0, 0, li, 0), ye = Qe + ye | 0, ye = cr >>> 0 > (Nr = cr + Nr | 0) >>> 0 ? ye + 1 | 0 : ye, cr = Zr(Br = ((m[E + 9 | 0] | m[E + 10 | 0] << 8 | m[E + 11 | 0] << 16 | m[E + 12 | 0] << 24) >>> 6 | 0) + Br | 0, 0, fi, 0), ye = Qe + ye | 0, ye = cr >>> 0 > (Nr = cr + Nr | 0) >>> 0 ? ye + 1 | 0 : ye, cr = Zr(jr = jr + Ni + ((m[E + 12 | 0] | m[E + 13 | 0] << 8 | m[E + 14 | 0] << 16 | m[E + 15 | 0] << 24) >>> 8) | 0, 0, Jr, 0), ye = Qe + ye | 0, Xi = Nr = cr + Nr | 0, Nr = cr >>> 0 > Nr >>> 0 ? ye + 1 | 0 : ye, ye = Zr(pr, 0, li, 0), cr = Qe, ve = Zr(Pr, 0, Mi, 0), Ne = Qe + cr | 0, Ne = (ye = ve + ye | 0) >>> 0 < ve >>> 0 ? Ne + 1 | 0 : Ne, cr = (ve = Zr(Mr, 0, fi, 0)) + ye | 0, ye = Qe + Ne | 0, ye = ve >>> 0 > cr >>> 0 ? ye + 1 | 0 : ye, ve = Zr(Br, 0, Jr, 0), ye = Qe + ye | 0, ye = ve >>> 0 > (cr = ve + cr | 0) >>> 0 ? ye + 1 | 0 : ye, ve = Zr(jr, 0, Tr, 0), ye = Qe + ye | 0, $n = cr = ve + cr | 0, cr = ve >>> 0 > cr >>> 0 ? ye + 1 | 0 : ye, ye = Zr(pr, 0, fi, 0), gr = Qe, ve = (Ne = Zr(Pr, 0, li, 0)) + ye | 0, ye = Qe + gr | 0, ye = Ne >>> 0 > ve >>> 0 ? ye + 1 | 0 : ye, gr = Zr(Mr, 0, Jr, 0), Ne = Qe + ye | 0, Ne = (ve = gr + ve | 0) >>> 0 < gr >>> 0 ? Ne + 1 | 0 : Ne, gr = Zr(Br, 0, Tr, 0), ye = Qe + Ne | 0, ye = (ve = gr + ve | 0) >>> 0 < gr >>> 0 ? ye + 1 | 0 : ye, gr = Zr(jr, 0, Wi, 0), ye = Qe + ye | 0, Zn = ve = gr + ve | 0, ve = ve >>> 0 < gr >>> 0 ? ye + 1 | 0 : ye, ye = Zr(pr, 0, Jr, 0), Ne = Qe, gr = (ti = Zr(Pr, 0, fi, 0)) + ye | 0, ye = Qe + Ne | 0, ye = gr >>> 0 < ti >>> 0 ? ye + 1 | 0 : ye, Ne = Zr(Mr, 0, Tr, 0), ye = Qe + ye | 0, ye = Ne >>> 0 > (gr = Ne + gr | 0) >>> 0 ? ye + 1 | 0 : ye, ti = Zr(Br, 0, Wi, 0), Ne = Qe + ye | 0, Ne = (gr = ti + gr | 0) >>> 0 < ti >>> 0 ? Ne + 1 | 0 : Ne, ti = Zr(jr, 0, vn, 0), ye = Qe + Ne | 0, ye = (gr = ti + gr | 0) >>> 0 < ti >>> 0 ? ye + 1 | 0 : ye, ti = gr, gr = ye, ye = Zr(pr, 0, Tr, 0), Ne = Qe, pr = (Pr = Zr(Pr, 0, Jr, 0)) + ye | 0, ye = Qe + Ne | 0, ye = pr >>> 0 < Pr >>> 0 ? ye + 1 | 0 : ye, Pr = Zr(Mr, 0, Wi, 0), ye = Qe + ye | 0, ye = (pr = Pr + pr | 0) >>> 0 < Pr >>> 0 ? ye + 1 | 0 : ye, Pr = Zr(Br, 0, vn, 0), ye = Qe + ye | 0, ye = (pr = Pr + pr | 0) >>> 0 < Pr >>> 0 ? ye + 1 | 0 : ye, Pr = Zr(jr, 0, Yi, 0), Ne = Qe + ye | 0, Ne = (pr = Pr + pr | 0) >>> 0 < Pr >>> 0 ? Ne + 1 | 0 : Ne, Pr = pr, ye = gr, ye = (pr = (Mr = (67108863 & Ne) << 6 | pr >>> 26) + ti | 0) >>> 0 < Mr >>> 0 ? ye + 1 | 0 : ye, Mr = pr, Br = (67108863 & ye) << 6 | pr >>> 26, ye = ve, ye = (pr = Br + Zn | 0) >>> 0 < Br >>> 0 ? ye + 1 | 0 : ye, Br = pr, Ne = cr, jr = ye = (pr = (67108863 & ye) << 6 | pr >>> 26) + $n | 0, cr = (67108863 & (Ne = ye >>> 0 < pr >>> 0 ? Ne + 1 | 0 : Ne)) << 6 | ye >>> 26, ye = Nr, Pr = (67108863 & Mr) + ((ye = v((67108863 & ((pr = cr + Xi | 0) >>> 0 < cr >>> 0 ? ye + 1 : ye)) << 6 | pr >>> 26, 5) + (67108863 & Pr) | 0) >>> 26 | 0) | 0, Mr = 67108863 & Br, Br = 67108863 & jr, jr = 67108863 & pr, Nr = 67108863 & ye, E = E + 16 | 0, !(M = M - (T >>> 0 < 16) | 0) & (T = T - 16 | 0) >>> 0 > 15 | M; ) ;
                      o[k + 20 >> 2] = Nr, o[k + 36 >> 2] = jr, o[k + 32 >> 2] = Br, o[k + 28 >> 2] = Mr, o[k + 24 >> 2] = Pr;
                    }
                    function Na(k, E, T, M) {
                      k |= 0, E |= 0;
                      var ye = 0;
                      return ye = -1, (M |= 0) - 65 >>> 0 < 4294967232 | (T |= 0) >>> 0 > 64 || (T && E ? (dr = ye = dr - 128 | 0, !E | ((M &= 255) - 65 & 255) >>> 0 <= 191 | ((T &= 255) - 65 & 255) >>> 0 <= 191 ? (Wa(), ji()) : (Ca(k - -64 | 0, 0, 293), B[k + 56 | 0] = 121, B[k + 57 | 0] = 33, B[k + 58 | 0] = 126, B[k + 59 | 0] = 19, B[k + 60 | 0] = 25, B[k + 61 | 0] = 205, B[k + 62 | 0] = 224, B[k + 63 | 0] = 91, B[k + 48 | 0] = 107, B[k + 49 | 0] = 189, B[k + 50 | 0] = 65, B[k + 51 | 0] = 251, B[k + 52 | 0] = 171, B[k + 53 | 0] = 217, B[k + 54 | 0] = 131, B[k + 55 | 0] = 31, B[k + 40 | 0] = 31, B[k + 41 | 0] = 108, B[k + 42 | 0] = 62, B[k + 43 | 0] = 43, B[k + 44 | 0] = 140, B[k + 45 | 0] = 104, B[k + 46 | 0] = 5, B[k + 47 | 0] = 155, B[k + 32 | 0] = 209, B[k + 33 | 0] = 130, B[k + 34 | 0] = 230, B[k + 35 | 0] = 173, B[k + 36 | 0] = 127, B[k + 37 | 0] = 82, B[k + 38 | 0] = 14, B[k + 39 | 0] = 81, B[k + 24 | 0] = 241, B[k + 25 | 0] = 54, B[k + 26 | 0] = 29, B[k + 27 | 0] = 95, B[k + 28 | 0] = 58, B[k + 29 | 0] = 245, B[k + 30 | 0] = 79, B[k + 31 | 0] = 165, B[k + 16 | 0] = 43, B[k + 17 | 0] = 248, B[k + 18 | 0] = 148, B[k + 19 | 0] = 254, B[k + 20 | 0] = 114, B[k + 21 | 0] = 243, B[k + 22 | 0] = 110, B[k + 23 | 0] = 60, B[k + 8 | 0] = 59, B[k + 9 | 0] = 167, B[k + 10 | 0] = 202, B[k + 11 | 0] = 132, B[k + 12 | 0] = 133, B[k + 13 | 0] = 174, B[k + 14 | 0] = 103, B[k + 15 | 0] = 187, M = -222443256 ^ (T << 8 | M), B[0 | k] = M, B[k + 1 | 0] = M >>> 8, B[k + 2 | 0] = M >>> 16, B[k + 3 | 0] = M >>> 24, M = T >>> 24 ^ 1779033703, B[k + 4 | 0] = M, B[k + 5 | 0] = M >>> 8, B[k + 6 | 0] = M >>> 16, B[k + 7 | 0] = M >>> 24, T = fa(Ca(ye, 0, 128), E, T), fa(k + 96 | 0, T, 128), E = 128 + (m[k + 352 | 0] | m[k + 353 | 0] << 8 | m[k + 354 | 0] << 16 | m[k + 355 | 0] << 24) | 0, B[k + 352 | 0] = E, B[k + 353 | 0] = E >>> 8, B[k + 354 | 0] = E >>> 16, B[k + 355 | 0] = E >>> 24, _s(T, 128), dr = T + 128 | 0)) : (((E = 255 & M) - 65 & 255) >>> 0 <= 191 && (Wa(), ji()), Ca(k - -64 | 0, 0, 293), B[k + 56 | 0] = 121, B[k + 57 | 0] = 33, B[k + 58 | 0] = 126, B[k + 59 | 0] = 19, B[k + 60 | 0] = 25, B[k + 61 | 0] = 205, B[k + 62 | 0] = 224, B[k + 63 | 0] = 91, B[k + 48 | 0] = 107, B[k + 49 | 0] = 189, B[k + 50 | 0] = 65, B[k + 51 | 0] = 251, B[k + 52 | 0] = 171, B[k + 53 | 0] = 217, B[k + 54 | 0] = 131, B[k + 55 | 0] = 31, B[k + 40 | 0] = 31, B[k + 41 | 0] = 108, B[k + 42 | 0] = 62, B[k + 43 | 0] = 43, B[k + 44 | 0] = 140, B[k + 45 | 0] = 104, B[k + 46 | 0] = 5, B[k + 47 | 0] = 155, B[k + 32 | 0] = 209, B[k + 33 | 0] = 130, B[k + 34 | 0] = 230, B[k + 35 | 0] = 173, B[k + 36 | 0] = 127, B[k + 37 | 0] = 82, B[k + 38 | 0] = 14, B[k + 39 | 0] = 81, B[k + 24 | 0] = 241, B[k + 25 | 0] = 54, B[k + 26 | 0] = 29, B[k + 27 | 0] = 95, B[k + 28 | 0] = 58, B[k + 29 | 0] = 245, B[k + 30 | 0] = 79, B[k + 31 | 0] = 165, B[k + 16 | 0] = 43, B[k + 17 | 0] = 248, B[k + 18 | 0] = 148, B[k + 19 | 0] = 254, B[k + 20 | 0] = 114, B[k + 21 | 0] = 243, B[k + 22 | 0] = 110, B[k + 23 | 0] = 60, B[k + 8 | 0] = 59, B[k + 9 | 0] = 167, B[k + 10 | 0] = 202, B[k + 11 | 0] = 132, B[k + 12 | 0] = 133, B[k + 13 | 0] = 174, B[k + 14 | 0] = 103, B[k + 15 | 0] = 187, E ^= -222443256, B[0 | k] = E, B[k + 1 | 0] = E >>> 8, B[k + 2 | 0] = E >>> 16, B[k + 3 | 0] = E >>> 24, B[k + 4 | 0] = 103, B[k + 5 | 0] = 230, B[k + 6 | 0] = 9, B[k + 7 | 0] = 106), ye = 0), 0 | ye;
                    }
                    function ba(k, E, T, M) {
                      k |= 0, E |= 0, T |= 0;
                      var ye = 0, Ne = 0, pr = 0, ve = 0, cr = 0, gr = 0, Pr = 0, Nr = 0, Br = 0, Mr = 0, jr = 0, ti = 0, fi = 0, Jr = 0, li = 0, Tr = 0, Mi = 0, Wi = 0, vn = 0;
                      for ((M |= 0) ? (Ne = m[M + 8 | 0] | m[M + 9 | 0] << 8 | m[M + 10 | 0] << 16 | m[M + 11 | 0] << 24, pr = m[M + 4 | 0] | m[M + 5 | 0] << 8 | m[M + 6 | 0] << 16 | m[M + 7 | 0] << 24, ye = m[0 | M] | m[M + 1 | 0] << 8 | m[M + 2 | 0] << 16 | m[M + 3 | 0] << 24, Pr = m[M + 12 | 0] | m[M + 13 | 0] << 8 | m[M + 14 | 0] << 16 | m[M + 15 | 0] << 24) : (Ne = 2036477234, pr = 857760878, ye = 1634760805, Pr = 1797285236), ve = m[E + 12 | 0] | m[E + 13 | 0] << 8 | m[E + 14 | 0] << 16 | m[E + 15 | 0] << 24, Br = m[E + 8 | 0] | m[E + 9 | 0] << 8 | m[E + 10 | 0] << 16 | m[E + 11 | 0] << 24, cr = m[E + 4 | 0] | m[E + 5 | 0] << 8 | m[E + 6 | 0] << 16 | m[E + 7 | 0] << 24, Mr = m[T + 28 | 0] | m[T + 29 | 0] << 8 | m[T + 30 | 0] << 16 | m[T + 31 | 0] << 24, gr = m[T + 24 | 0] | m[T + 25 | 0] << 8 | m[T + 26 | 0] << 16 | m[T + 27 | 0] << 24, Tr = m[T + 20 | 0] | m[T + 21 | 0] << 8 | m[T + 22 | 0] << 16 | m[T + 23 | 0] << 24, jr = m[T + 16 | 0] | m[T + 17 | 0] << 8 | m[T + 18 | 0] << 16 | m[T + 19 | 0] << 24, M = m[T + 12 | 0] | m[T + 13 | 0] << 8 | m[T + 14 | 0] << 16 | m[T + 15 | 0] << 24, ti = m[T + 8 | 0] | m[T + 9 | 0] << 8 | m[T + 10 | 0] << 16 | m[T + 11 | 0] << 24, fi = m[T + 4 | 0] | m[T + 5 | 0] << 8 | m[T + 6 | 0] << 16 | m[T + 7 | 0] << 24, E = m[0 | E] | m[E + 1 | 0] << 8 | m[E + 2 | 0] << 16 | m[E + 3 | 0] << 24, T = m[0 | T] | m[T + 1 | 0] << 8 | m[T + 2 | 0] << 16 | m[T + 3 | 0] << 24; Nr = T, T = ao((Jr = E) ^ (E = T + ye | 0), 16), Nr = jr = ao(Nr ^ (ye = T + jr | 0), 12), li = ao((Jr = E + jr | 0) ^ T, 8), E = ao(Nr ^ (jr = li + ye | 0), 7), ve = ao((T = M + Pr | 0) ^ ve, 16), M = ao((Mr = ve + Mr | 0) ^ M, 12), Nr = ti, Ne = ao((Pr = Ne + ti | 0) ^ Br, 16), ye = ao(Nr ^ (ti = Ne + gr | 0), 12), gr = ao((gr = Ne) ^ (Ne = ye + Pr | 0), 8), T = ao(gr ^ (Pr = (Mi = T + M | 0) + E | 0), 16), Br = ao((pr = pr + fi | 0) ^ cr, 16), fi = ao((cr = Br + Tr | 0) ^ fi, 12), Nr = E, E = ao((pr = fi + pr | 0) ^ Br, 8), Nr = ao(Nr ^ (cr = (Wi = E + cr | 0) + T | 0), 12), Br = ao(T ^ (Pr = Nr + Pr | 0), 8), T = ao((Tr = Br + cr | 0) ^ Nr, 7), ve = ao(ve ^ Mi, 8), M = ao((Mr = ve + Mr | 0) ^ M, 7), cr = ao((Ne = M + Ne | 0) ^ E, 16), M = ao((E = cr + jr | 0) ^ M, 12), cr = ao(cr ^ (Ne = M + Ne | 0), 8), M = ao((jr = E + cr | 0) ^ M, 7), E = ao((gr = gr + ti | 0) ^ ye, 7), ti = ao((pr = E + pr | 0) ^ li, 16), li = ao(E ^ (ye = ti + Mr | 0), 12), E = ao(ti ^ (pr = li + pr | 0), 8), ti = ao((Mr = ye + E | 0) ^ li, 7), Nr = gr, gr = ve, ye = ao(fi ^ Wi, 7), gr = ao(gr ^ (ve = ye + Jr | 0), 16), Jr = ao(ye ^ (fi = Nr + gr | 0), 12), ve = ao(gr ^ (ye = Jr + ve | 0), 8), fi = ao((gr = fi + ve | 0) ^ Jr, 7), (0 | (vn = vn + 1 | 0)) != 10; ) ;
                      return B[0 | k] = ye, B[k + 1 | 0] = ye >>> 8, B[k + 2 | 0] = ye >>> 16, B[k + 3 | 0] = ye >>> 24, B[k + 28 | 0] = ve, B[k + 29 | 0] = ve >>> 8, B[k + 30 | 0] = ve >>> 16, B[k + 31 | 0] = ve >>> 24, B[k + 24 | 0] = Br, B[k + 25 | 0] = Br >>> 8, B[k + 26 | 0] = Br >>> 16, B[k + 27 | 0] = Br >>> 24, B[k + 20 | 0] = cr, B[k + 21 | 0] = cr >>> 8, B[k + 22 | 0] = cr >>> 16, B[k + 23 | 0] = cr >>> 24, B[k + 16 | 0] = E, B[k + 17 | 0] = E >>> 8, B[k + 18 | 0] = E >>> 16, B[k + 19 | 0] = E >>> 24, B[k + 12 | 0] = Pr, B[k + 13 | 0] = Pr >>> 8, B[k + 14 | 0] = Pr >>> 16, B[k + 15 | 0] = Pr >>> 24, B[k + 8 | 0] = Ne, B[k + 9 | 0] = Ne >>> 8, B[k + 10 | 0] = Ne >>> 16, B[k + 11 | 0] = Ne >>> 24, B[k + 4 | 0] = pr, B[k + 5 | 0] = pr >>> 8, B[k + 6 | 0] = pr >>> 16, B[k + 7 | 0] = pr >>> 24, 0;
                    }
                    function Aa(k, E, T) {
                      var M, ye, Ne, pr, ve, cr, gr, Pr, Nr, Br, Mr = 0, jr = 0, ti = 0, fi = 0, Jr = 0, li = 0, Tr = 0, Mi = 0, Wi = 0, vn = 0, Tn = 0, Ni = 0, Yi = 0, Xi = 0, $n = 0, Zn = 0, to = 0, fo = 0, wo = 0;
                      jr = o[E + 4 >> 2], Mr = o[E + 44 >> 2], fi = o[E + 8 >> 2], Jr = o[E + 48 >> 2], li = o[E + 12 >> 2], Tr = o[E + 52 >> 2], Mi = o[E + 16 >> 2], Wi = o[E + 56 >> 2], vn = o[E + 20 >> 2], Tn = o[E + 60 >> 2], Ni = o[E + 24 >> 2], Yi = o[(ti = E - -64 | 0) >> 2], Xi = o[E + 28 >> 2], $n = o[E + 68 >> 2], Zn = o[E + 32 >> 2], to = o[E + 72 >> 2], fo = o[E + 36 >> 2], wo = o[E + 76 >> 2], o[k >> 2] = o[E >> 2] + o[E + 40 >> 2], o[k + 36 >> 2] = fo + wo, o[k + 32 >> 2] = Zn + to, o[k + 28 >> 2] = Xi + $n, o[k + 24 >> 2] = Ni + Yi, o[k + 20 >> 2] = vn + Tn, o[k + 16 >> 2] = Mi + Wi, o[k + 12 >> 2] = li + Tr, o[k + 8 >> 2] = fi + Jr, o[k + 4 >> 2] = Mr + jr, Mr = o[E + 4 >> 2], fi = o[E + 44 >> 2], Jr = o[E + 8 >> 2], li = o[E + 48 >> 2], Tr = o[E + 12 >> 2], Mi = o[E + 52 >> 2], Wi = o[E + 16 >> 2], vn = o[E + 56 >> 2], Tn = o[E + 20 >> 2], Ni = o[E + 60 >> 2], Yi = o[E + 24 >> 2], ti = o[ti >> 2], jr = o[E + 28 >> 2], Xi = o[E + 68 >> 2], $n = o[E + 32 >> 2], Zn = o[E + 72 >> 2], to = o[E >> 2], fo = o[E + 40 >> 2], o[k + 76 >> 2] = o[E + 76 >> 2] - o[E + 36 >> 2], o[k + 72 >> 2] = Zn - $n, o[k + 68 >> 2] = Xi - jr, o[(jr = k - -64 | 0) >> 2] = ti - Yi, o[k + 60 >> 2] = Ni - Tn, o[k + 56 >> 2] = vn - Wi, o[k + 52 >> 2] = Mi - Tr, o[k + 48 >> 2] = li - Jr, o[k + 44 >> 2] = fi - Mr, o[k + 40 >> 2] = fo - to, Ti(k + 80 | 0, k, T), Ti(Mr = k + 40 | 0, Mr, T + 40 | 0), Ti(k + 120 | 0, T + 120 | 0, E + 120 | 0), Ti(k, E + 80 | 0, T + 80 | 0), fo = o[k + 4 >> 2], wo = o[k + 8 >> 2], Ne = o[k + 12 >> 2], pr = o[k + 16 >> 2], ve = o[k + 20 >> 2], cr = o[k + 24 >> 2], gr = o[k + 28 >> 2], Pr = o[k + 32 >> 2], Nr = o[k + 36 >> 2], E = o[k + 44 >> 2], T = o[k + 84 >> 2], Mr = o[k + 48 >> 2], fi = o[k + 88 >> 2], Jr = o[k + 52 >> 2], li = o[k + 92 >> 2], Tr = o[k + 56 >> 2], Mi = o[k + 96 >> 2], Wi = o[k + 60 >> 2], vn = o[k + 100 >> 2], Tn = o[jr >> 2], Ni = o[k + 104 >> 2], ti = o[k + 68 >> 2], Yi = o[k + 108 >> 2], Xi = o[k + 72 >> 2], $n = o[k + 112 >> 2], Br = o[k >> 2], Zn = o[k + 40 >> 2], to = o[k + 80 >> 2], M = o[k + 76 >> 2], ye = o[k + 116 >> 2], o[k + 76 >> 2] = M + ye, o[k + 72 >> 2] = Xi + $n, o[k + 68 >> 2] = ti + Yi, o[jr >> 2] = Tn + Ni, o[k + 60 >> 2] = Wi + vn, o[k + 56 >> 2] = Tr + Mi, o[k + 52 >> 2] = Jr + li, o[k + 48 >> 2] = Mr + fi, o[k + 44 >> 2] = E + T, o[k + 40 >> 2] = Zn + to, o[k + 36 >> 2] = ye - M, o[k + 32 >> 2] = $n - Xi, o[k + 28 >> 2] = Yi - ti, o[k + 24 >> 2] = Ni - Tn, o[k + 20 >> 2] = vn - Wi, o[k + 16 >> 2] = Mi - Tr, o[k + 12 >> 2] = li - Jr, o[k + 8 >> 2] = fi - Mr, o[k + 4 >> 2] = T - E, o[k >> 2] = to - Zn, E = Nr << 1, T = o[k + 156 >> 2], o[k + 156 >> 2] = E - T, jr = Pr << 1, Mr = o[k + 152 >> 2], o[k + 152 >> 2] = jr - Mr, fi = gr << 1, Jr = o[k + 148 >> 2], o[k + 148 >> 2] = fi - Jr, li = cr << 1, Tr = o[k + 144 >> 2], o[k + 144 >> 2] = li - Tr, Mi = ve << 1, Wi = o[k + 140 >> 2], o[k + 140 >> 2] = Mi - Wi, vn = pr << 1, Tn = o[k + 136 >> 2], o[k + 136 >> 2] = vn - Tn, Ni = Ne << 1, ti = o[k + 132 >> 2], o[k + 132 >> 2] = Ni - ti, Yi = wo << 1, Xi = o[k + 128 >> 2], o[k + 128 >> 2] = Yi - Xi, $n = fo << 1, Zn = o[k + 124 >> 2], o[k + 124 >> 2] = $n - Zn, to = Br << 1, fo = o[k + 120 >> 2], o[k + 120 >> 2] = to - fo, o[k + 112 >> 2] = Mr + jr, o[k + 108 >> 2] = fi + Jr, o[k + 104 >> 2] = li + Tr, o[k + 100 >> 2] = Mi + Wi, o[k + 96 >> 2] = vn + Tn, o[k + 92 >> 2] = Ni + ti, o[k + 88 >> 2] = Yi + Xi, o[k + 84 >> 2] = $n + Zn, o[k + 80 >> 2] = to + fo, o[k + 116 >> 2] = E + T;
                    }
                    function zs(k, E, T) {
                      var M, ye, Ne, pr, ve, cr, gr, Pr, Nr, Br, Mr = 0, jr = 0, ti = 0, fi = 0, Jr = 0, li = 0, Tr = 0, Mi = 0, Wi = 0, vn = 0, Tn = 0, Ni = 0, Yi = 0, Xi = 0, $n = 0, Zn = 0, to = 0, fo = 0, wo = 0;
                      jr = o[E + 4 >> 2], Mr = o[E + 44 >> 2], fi = o[E + 8 >> 2], Jr = o[E + 48 >> 2], li = o[E + 12 >> 2], Tr = o[E + 52 >> 2], Mi = o[E + 16 >> 2], Wi = o[E + 56 >> 2], vn = o[E + 20 >> 2], Tn = o[E + 60 >> 2], Ni = o[E + 24 >> 2], Yi = o[(ti = E - -64 | 0) >> 2], Xi = o[E + 28 >> 2], $n = o[E + 68 >> 2], Zn = o[E + 32 >> 2], to = o[E + 72 >> 2], fo = o[E + 36 >> 2], wo = o[E + 76 >> 2], o[k >> 2] = o[E >> 2] + o[E + 40 >> 2], o[k + 36 >> 2] = fo + wo, o[k + 32 >> 2] = Zn + to, o[k + 28 >> 2] = Xi + $n, o[k + 24 >> 2] = Ni + Yi, o[k + 20 >> 2] = vn + Tn, o[k + 16 >> 2] = Mi + Wi, o[k + 12 >> 2] = li + Tr, o[k + 8 >> 2] = fi + Jr, o[k + 4 >> 2] = Mr + jr, Mr = o[E + 4 >> 2], fi = o[E + 44 >> 2], Jr = o[E + 8 >> 2], li = o[E + 48 >> 2], Tr = o[E + 12 >> 2], Mi = o[E + 52 >> 2], Wi = o[E + 16 >> 2], vn = o[E + 56 >> 2], Tn = o[E + 20 >> 2], Ni = o[E + 60 >> 2], Yi = o[E + 24 >> 2], ti = o[ti >> 2], jr = o[E + 28 >> 2], Xi = o[E + 68 >> 2], $n = o[E + 32 >> 2], Zn = o[E + 72 >> 2], to = o[E >> 2], fo = o[E + 40 >> 2], o[k + 76 >> 2] = o[E + 76 >> 2] - o[E + 36 >> 2], o[k + 72 >> 2] = Zn - $n, o[k + 68 >> 2] = Xi - jr, o[(jr = k - -64 | 0) >> 2] = ti - Yi, o[k + 60 >> 2] = Ni - Tn, o[k + 56 >> 2] = vn - Wi, o[k + 52 >> 2] = Mi - Tr, o[k + 48 >> 2] = li - Jr, o[k + 44 >> 2] = fi - Mr, o[k + 40 >> 2] = fo - to, Ti(k + 80 | 0, k, T + 40 | 0), Ti(Mr = k + 40 | 0, Mr, T), Ti(k + 120 | 0, T + 120 | 0, E + 120 | 0), Ti(k, E + 80 | 0, T + 80 | 0), fo = o[k + 4 >> 2], wo = o[k + 8 >> 2], Ne = o[k + 12 >> 2], pr = o[k + 16 >> 2], ve = o[k + 20 >> 2], cr = o[k + 24 >> 2], gr = o[k + 28 >> 2], Pr = o[k + 32 >> 2], Nr = o[k + 36 >> 2], E = o[k + 44 >> 2], T = o[k + 84 >> 2], Mr = o[k + 48 >> 2], fi = o[k + 88 >> 2], Jr = o[k + 52 >> 2], li = o[k + 92 >> 2], Tr = o[k + 56 >> 2], Mi = o[k + 96 >> 2], Wi = o[k + 60 >> 2], vn = o[k + 100 >> 2], Tn = o[jr >> 2], Ni = o[k + 104 >> 2], ti = o[k + 68 >> 2], Yi = o[k + 108 >> 2], Xi = o[k + 72 >> 2], $n = o[k + 112 >> 2], Br = o[k >> 2], Zn = o[k + 40 >> 2], to = o[k + 80 >> 2], M = o[k + 76 >> 2], ye = o[k + 116 >> 2], o[k + 76 >> 2] = M + ye, o[k + 72 >> 2] = Xi + $n, o[k + 68 >> 2] = ti + Yi, o[jr >> 2] = Tn + Ni, o[k + 60 >> 2] = Wi + vn, o[k + 56 >> 2] = Tr + Mi, o[k + 52 >> 2] = Jr + li, o[k + 48 >> 2] = Mr + fi, o[k + 44 >> 2] = E + T, o[k + 40 >> 2] = Zn + to, o[k + 36 >> 2] = ye - M, o[k + 32 >> 2] = $n - Xi, o[k + 28 >> 2] = Yi - ti, o[k + 24 >> 2] = Ni - Tn, o[k + 20 >> 2] = vn - Wi, o[k + 16 >> 2] = Mi - Tr, o[k + 12 >> 2] = li - Jr, o[k + 8 >> 2] = fi - Mr, o[k + 4 >> 2] = T - E, o[k >> 2] = to - Zn, E = o[k + 156 >> 2], T = Nr << 1, o[k + 156 >> 2] = E + T, jr = o[k + 152 >> 2], Mr = Pr << 1, o[k + 152 >> 2] = jr + Mr, fi = o[k + 148 >> 2], Jr = gr << 1, o[k + 148 >> 2] = fi + Jr, li = o[k + 144 >> 2], Tr = cr << 1, o[k + 144 >> 2] = li + Tr, Mi = o[k + 140 >> 2], Wi = ve << 1, o[k + 140 >> 2] = Mi + Wi, vn = o[k + 136 >> 2], Tn = pr << 1, o[k + 136 >> 2] = vn + Tn, Ni = o[k + 132 >> 2], ti = Ne << 1, o[k + 132 >> 2] = Ni + ti, Yi = o[k + 128 >> 2], Xi = wo << 1, o[k + 128 >> 2] = Yi + Xi, $n = o[k + 124 >> 2], Zn = fo << 1, o[k + 124 >> 2] = $n + Zn, to = o[k + 120 >> 2], fo = Br << 1, o[k + 120 >> 2] = to + fo, o[k + 112 >> 2] = Mr - jr, o[k + 108 >> 2] = Jr - fi, o[k + 104 >> 2] = Tr - li, o[k + 100 >> 2] = Wi - Mi, o[k + 96 >> 2] = Tn - vn, o[k + 92 >> 2] = ti - Ni, o[k + 88 >> 2] = Xi - Yi, o[k + 84 >> 2] = Zn - $n, o[k + 80 >> 2] = fo - to, o[k + 116 >> 2] = T - E;
                    }
                    function x2(k, E, T) {
                      var M, ye, Ne, pr, ve, cr, gr, Pr, Nr, Br, Mr = 0, jr = 0, ti = 0, fi = 0, Jr = 0, li = 0, Tr = 0, Mi = 0, Wi = 0, vn = 0, Tn = 0, Ni = 0, Yi = 0, Xi = 0, $n = 0, Zn = 0, to = 0, fo = 0, wo = 0;
                      jr = o[E + 4 >> 2], Mr = o[E + 44 >> 2], fi = o[E + 8 >> 2], Jr = o[E + 48 >> 2], li = o[E + 12 >> 2], Tr = o[E + 52 >> 2], Mi = o[E + 16 >> 2], Wi = o[E + 56 >> 2], vn = o[E + 20 >> 2], Tn = o[E + 60 >> 2], Ni = o[E + 24 >> 2], Yi = o[(ti = E - -64 | 0) >> 2], Xi = o[E + 28 >> 2], $n = o[E + 68 >> 2], Zn = o[E + 32 >> 2], to = o[E + 72 >> 2], fo = o[E + 36 >> 2], wo = o[E + 76 >> 2], o[k >> 2] = o[E >> 2] + o[E + 40 >> 2], o[k + 36 >> 2] = fo + wo, o[k + 32 >> 2] = Zn + to, o[k + 28 >> 2] = Xi + $n, o[k + 24 >> 2] = Ni + Yi, o[k + 20 >> 2] = vn + Tn, o[k + 16 >> 2] = Mi + Wi, o[k + 12 >> 2] = li + Tr, o[k + 8 >> 2] = fi + Jr, o[k + 4 >> 2] = Mr + jr, Mr = o[E + 4 >> 2], fi = o[E + 44 >> 2], Jr = o[E + 8 >> 2], li = o[E + 48 >> 2], Tr = o[E + 12 >> 2], Mi = o[E + 52 >> 2], Wi = o[E + 16 >> 2], vn = o[E + 56 >> 2], Tn = o[E + 20 >> 2], Ni = o[E + 60 >> 2], Yi = o[E + 24 >> 2], ti = o[ti >> 2], jr = o[E + 28 >> 2], Xi = o[E + 68 >> 2], $n = o[E + 32 >> 2], Zn = o[E + 72 >> 2], to = o[E >> 2], fo = o[E + 40 >> 2], o[k + 76 >> 2] = o[E + 76 >> 2] - o[E + 36 >> 2], o[k + 72 >> 2] = Zn - $n, o[k + 68 >> 2] = Xi - jr, o[(jr = k - -64 | 0) >> 2] = ti - Yi, o[k + 60 >> 2] = Ni - Tn, o[k + 56 >> 2] = vn - Wi, o[k + 52 >> 2] = Mi - Tr, o[k + 48 >> 2] = li - Jr, o[k + 44 >> 2] = fi - Mr, o[k + 40 >> 2] = fo - to, Ti(k + 80 | 0, k, T), Ti(Mr = k + 40 | 0, Mr, T + 40 | 0), Ti(k + 120 | 0, T + 80 | 0, E + 120 | 0), fo = o[E + 84 >> 2], wo = o[E + 88 >> 2], Ne = o[E + 92 >> 2], pr = o[E + 96 >> 2], ve = o[E + 100 >> 2], cr = o[E + 104 >> 2], gr = o[E + 108 >> 2], Pr = o[E + 112 >> 2], Nr = o[E + 116 >> 2], T = o[k + 44 >> 2], Mr = o[k + 84 >> 2], fi = o[k + 48 >> 2], Jr = o[k + 88 >> 2], li = o[k + 52 >> 2], Tr = o[k + 92 >> 2], Mi = o[k + 56 >> 2], Wi = o[k + 96 >> 2], vn = o[k + 60 >> 2], Tn = o[k + 100 >> 2], Ni = o[jr >> 2], ti = o[k + 104 >> 2], Yi = o[k + 68 >> 2], Xi = o[k + 108 >> 2], $n = o[k + 72 >> 2], Zn = o[k + 112 >> 2], Br = o[E + 80 >> 2], E = o[k + 40 >> 2], to = o[k + 80 >> 2], M = o[k + 76 >> 2], ye = o[k + 116 >> 2], o[k + 76 >> 2] = M + ye, o[k + 72 >> 2] = $n + Zn, o[k + 68 >> 2] = Yi + Xi, o[jr >> 2] = Ni + ti, o[k + 60 >> 2] = vn + Tn, o[k + 56 >> 2] = Mi + Wi, o[k + 52 >> 2] = li + Tr, o[k + 48 >> 2] = fi + Jr, o[k + 44 >> 2] = T + Mr, o[k + 40 >> 2] = E + to, o[k + 36 >> 2] = ye - M, o[k + 32 >> 2] = Zn - $n, o[k + 28 >> 2] = Xi - Yi, o[k + 24 >> 2] = ti - Ni, o[k + 20 >> 2] = Tn - vn, o[k + 16 >> 2] = Wi - Mi, o[k + 12 >> 2] = Tr - li, o[k + 8 >> 2] = Jr - fi, o[k + 4 >> 2] = Mr - T, o[k >> 2] = to - E, E = Nr << 1, T = o[k + 156 >> 2], o[k + 156 >> 2] = E - T, jr = Pr << 1, Mr = o[k + 152 >> 2], o[k + 152 >> 2] = jr - Mr, fi = gr << 1, Jr = o[k + 148 >> 2], o[k + 148 >> 2] = fi - Jr, li = cr << 1, Tr = o[k + 144 >> 2], o[k + 144 >> 2] = li - Tr, Mi = ve << 1, Wi = o[k + 140 >> 2], o[k + 140 >> 2] = Mi - Wi, vn = pr << 1, Tn = o[k + 136 >> 2], o[k + 136 >> 2] = vn - Tn, Ni = Ne << 1, ti = o[k + 132 >> 2], o[k + 132 >> 2] = Ni - ti, Yi = wo << 1, Xi = o[k + 128 >> 2], o[k + 128 >> 2] = Yi - Xi, $n = fo << 1, Zn = o[k + 124 >> 2], o[k + 124 >> 2] = $n - Zn, to = Br << 1, fo = o[k + 120 >> 2], o[k + 120 >> 2] = to - fo, o[k + 112 >> 2] = Mr + jr, o[k + 108 >> 2] = fi + Jr, o[k + 104 >> 2] = li + Tr, o[k + 100 >> 2] = Mi + Wi, o[k + 96 >> 2] = vn + Tn, o[k + 92 >> 2] = Ni + ti, o[k + 88 >> 2] = Yi + Xi, o[k + 84 >> 2] = $n + Zn, o[k + 80 >> 2] = to + fo, o[k + 116 >> 2] = E + T;
                    }
                    function Va(k, E) {
                      var T, M, ye, Ne, pr, ve, cr, gr, Pr, Nr, Br, Mr, jr, ti, fi = 0, Jr = 0, li = 0, Tr = 0, Mi = 0, Wi = 0, vn = 0, Tn = 0, Ni = 0, Yi = 0, Xi = 0, $n = 0, Zn = 0;
                      jr = m[E + 31 | 0], T = m[E + 30 | 0], M = m[E + 29 | 0], ye = m[E + 6 | 0], Ne = m[E + 5 | 0], pr = m[E + 4 | 0], ve = m[E + 9 | 0], cr = m[E + 8 | 0], gr = m[E + 7 | 0], Pr = m[E + 12 | 0], Xi = m[E + 11 | 0], $n = m[E + 10 | 0], Nr = m[E + 15 | 0], Zn = m[E + 14 | 0], Br = m[E + 13 | 0], vn = m[E + 28 | 0], Yi = m[E + 27 | 0], Tn = m[E + 26 | 0], Wi = m[E + 25 | 0], Tr = m[E + 24 | 0], li = m[E + 23 | 0], ti = m[0 | E] | m[E + 1 | 0] << 8 | m[E + 2 | 0] << 16 | m[E + 3 | 0] << 24, Mi = (Jr = m[E + 21 | 0]) << 15, Jr = fi = Jr >>> 17 | 0, Ni = Mi, Ni |= (Mi = m[E + 20 | 0]) << 7, Mi = (fi = Mi >>> 25 | 0) | Jr, Jr = (fi = m[E + 22 | 0]) >>> 9 | 0, fi = fi << 23 | Ni, Jr |= Mi, Mr = m[E + 16 | 0] | m[E + 17 | 0] << 8 | m[E + 18 | 0] << 16 | m[E + 19 | 0] << 24, E = 0, Mi = fi, fi = (33554431 & (E = (Ni = Mr + 16777216 | 0) >>> 0 < 16777216 ? 1 : E)) << 7 | Ni >>> 25, E = (E >>> 25 | 0) + Jr | 0, fi = (Jr = Mi = Mi + fi | 0) >>> 0 < fi >>> 0 ? E + 1 | 0 : E, E = (Mi = Jr + 33554432 | 0) >>> 0 < 33554432 ? fi + 1 | 0 : fi, o[k + 24 >> 2] = Jr - (-67108864 & Mi), fi = (Jr = li >>> 27 | 0) | Tr >>> 19 | Wi >>> 11, Jr = li = (Tr = Wi << 21 | (li = Tr << 13 | li << 5)) + (Jr = (67108863 & (Jr = E)) << 6 | Mi >>> 26) | 0, E = fi, fi = (li = Tr + 16777216 | 0) >>> 0 < 16777216 ? E + 1 | 0 : E, o[k + 28 >> 2] = Jr - (1040187392 & li), Jr = (fi = (E = fi) >>> 25 | 0) + (Jr = Yi >>> 20 | Tn >>> 28 | vn >>> 12) | 0, E = Jr = (fi = li = (E = (33554431 & E) << 7 | li >>> 25) + (Yi << 12 | Tn << 4 | vn << 20) | 0) >>> 0 < E >>> 0 ? Jr + 1 | 0 : Jr, li = (vn = fi + 33554432 | 0) >>> 0 < 33554432 ? E + 1 | 0 : E, o[k + 32 >> 2] = fi - (-67108864 & vn), Jr = Pr >>> 13 | (fi = Xi >>> 21 | $n >>> 29), E = (Jr = (Yi = 16777216 + (Xi = Xi << 11 | $n << 3 | Pr << 19) | 0) >>> 0 < 16777216 ? Jr + 1 | 0 : Jr) >>> 25 | 0, Jr = (fi = Tr = Zn << 10 | Br << 2 | Nr << 18) + (Tr = (33554431 & Jr) << 7 | Yi >>> 25) | 0, fi = E + (Wi = Zn >>> 22 | Br >>> 30 | Nr >>> 14) | 0, E = fi = Jr >>> 0 < Tr >>> 0 ? fi + 1 | 0 : fi, Tr = ((67108863 & (E = (Tr = Jr + 33554432 | 0) >>> 0 < 33554432 ? E + 1 | 0 : E)) << 6 | (fi = Tr) >>> 26) + (Tn = Mr - (-33554432 & Ni) | 0) | 0, o[k + 20 >> 2] = Tr, o[k + 16 >> 2] = Jr - (-67108864 & fi), fi = Ne >>> 18 | pr >>> 26 | ye >>> 10, Jr = (fi = (Tn = 16777216 + ($n = Ne << 14 | pr << 6 | ye << 22) | 0) >>> 0 < 16777216 ? fi + 1 | 0 : fi) >>> 25 | 0, fi = (E = Tr = cr << 13 | gr << 5 | ve << 21) + (Tr = (33554431 & fi) << 7 | Tn >>> 25) | 0, E = Jr + (Wi = cr >>> 19 | gr >>> 27 | ve >>> 11) | 0, E = fi >>> 0 < Tr >>> 0 ? E + 1 | 0 : E, Jr = (Wi = fi + 33554432 | 0) >>> 0 < 33554432 ? E + 1 | 0 : E, o[k + 8 >> 2] = fi - (-67108864 & Wi), vn = (li = (67108863 & li) << 6 | vn >>> 26) + (Zn = jr << 18 & 33292288 | T << 10 | M << 2) | 0, E = fi = T >>> 22 | M >>> 30, fi = (li = Zn + 16777216 | 0) >>> 0 < 16777216 ? E + 1 | 0 : E, o[k + 36 >> 2] = vn - (33554432 & li), Jr = Xi + ((67108863 & Jr) << 6 | Wi >>> 26) | 0, o[k + 12 >> 2] = Jr - (234881024 & Yi), Tr = $n - (2113929216 & Tn) | 0, Jr = Zr((33554431 & (E = fi)) << 7 | li >>> 25, fi = E >>> 25 | 0, 19, 0), E = Qe, Jr = (fi = Jr + ti | 0) >>> 0 < Jr >>> 0 ? E + 1 | 0 : E, li = ((67108863 & (Jr = (E = fi + 33554432 | 0) >>> 0 < 33554432 ? Jr + 1 | 0 : Jr)) << 6 | E >>> 26) + Tr | 0, o[k + 4 >> 2] = li, o[k >> 2] = fi - (-67108864 & E);
                    }
                    function Se(k, E, T, M, ye, Ne, pr, ve) {
                      k |= 0, E |= 0, T |= 0, M |= 0, ye |= 0, Ne |= 0, pr |= 0;
                      var cr = 0, gr = 0, Pr = 0, Nr = 0, Br = 0, Mr = 0, jr = 0, ti = 0;
                      if ((-7 & (ve |= 0)) == 1) {
                        e: {
                          t: {
                            r: {
                              i: {
                                n: {
                                  o: {
                                    a: {
                                      if (M) {
                                        s: {
                                          A: {
                                            if (ve >>> 0 <= 3) {
                                              for (; ; ) {
                                                Nr = gr;
                                                u: {
                                                  h: {
                                                    c: {
                                                      f: {
                                                        for (; ; ) {
                                                          if (cr = (cr = (Pr = B[T + Nr | 0]) - 65 | 0) & (~(90 - Pr) & ~cr) >>> 8 & 255 | Pr + 4 & (~(Pr + 65488) & ~(57 - Pr)) >>> 8 & 255 | Pr + 185 & (~(Pr + 65439) & ~(122 - Pr)) >>> 8 & 255 | ~(1 + (16336 ^ Pr)) >>> 8 & 63 | ~(1 + (16340 ^ Pr)) >>> 8 & 62, (0 | (cr |= (cr - 1 & 1 + (65470 ^ Pr)) >>> 8 & 255)) != 255) break f;
                                                          if (cr = 0, !ye) break s;
                                                          if (!Us(ye, Pr)) break;
                                                          if ((Nr = Nr + 1 | 0) >>> 0 >= M >>> 0) break c;
                                                        }
                                                        gr = Nr;
                                                        break s;
                                                      }
                                                      if (jr = cr + (jr << 6) | 0, Br >>> 0 > 1) break h;
                                                      Br = Br + 6 | 0;
                                                      break u;
                                                    }
                                                    gr = (k = gr + 1 | 0) >>> 0 < M >>> 0 ? M : k;
                                                    break s;
                                                  }
                                                  if (Br = Br - 2 | 0, E >>> 0 <= Mr >>> 0) break A;
                                                  B[k + Mr | 0] = jr >>> Br, Mr = Mr + 1 | 0;
                                                }
                                                if (cr = 0, !((gr = Nr + 1 | 0) >>> 0 < M >>> 0)) break;
                                              }
                                              break s;
                                            }
                                            for (; ; ) {
                                              u: {
                                                if (cr = (cr = (Pr = B[T + Nr | 0]) - 65 | 0) & (~(90 - Pr) & ~cr) >>> 8 & 255 | Pr + 4 & (~(Pr + 65488) & ~(57 - Pr)) >>> 8 & 255 | Pr + 185 & (~(Pr + 65439) & ~(122 - Pr)) >>> 8 & 255 | ~(1 + (16288 ^ Pr)) >>> 8 & 63 | ~(1 + (16338 ^ Pr)) >>> 8 & 62, (0 | (cr |= (cr - 1 & 1 + (65470 ^ Pr)) >>> 8 & 255)) == 255) {
                                                  if (cr = 0, !ye) break s;
                                                  if (Us(ye, Pr)) {
                                                    if ((Nr = Nr + 1 | 0) >>> 0 >= M >>> 0) break u;
                                                    continue;
                                                  }
                                                  gr = Nr;
                                                  break s;
                                                }
                                                if (jr = cr + (jr << 6) | 0, Br >>> 0 < 2) Br = Br + 6 | 0;
                                                else {
                                                  if (Br = Br - 2 | 0, E >>> 0 <= Mr >>> 0) break A;
                                                  B[k + Mr | 0] = jr >>> Br, Mr = Mr + 1 | 0;
                                                }
                                                if (cr = 0, (gr = Nr + 1 | 0) >>> 0 >= M >>> 0) break s;
                                                Nr = gr;
                                                continue;
                                              }
                                              break;
                                            }
                                            gr = (k = gr + 1 | 0) >>> 0 < M >>> 0 ? M : k;
                                            break s;
                                          }
                                          gr = Nr, o[9404] = 68, cr = 1;
                                        }
                                        if (Br >>> 0 > 4) break a;
                                        k = gr;
                                      } else k = 0;
                                      if (E = -1, cr) {
                                        gr = k;
                                        break e;
                                      }
                                      if (~(-1 << Br) & jr) {
                                        gr = k;
                                        break e;
                                      }
                                      if (2 & ve) {
                                        ve = k;
                                        break n;
                                      }
                                      if (Br >>> 0 < 2) {
                                        ve = k;
                                        break n;
                                      }
                                      if (gr = k >>> 0 > M >>> 0 ? k : M, Nr = Br >>> 1 | 0, !ye) break o;
                                      for (ve = k; ; ) {
                                        if ((0 | ve) == (0 | gr)) {
                                          cr = 68;
                                          break i;
                                        }
                                        if ((0 | (k = B[T + ve | 0])) != 61) {
                                          if (!Us(ye, k)) {
                                            cr = 28, gr = ve;
                                            break i;
                                          }
                                        } else Nr = Nr - 1 | 0;
                                        if (ve = ve + 1 | 0, !Nr) break;
                                      }
                                      break n;
                                    }
                                    E = -1;
                                    break e;
                                  }
                                  if (cr = 68, k >>> 0 >= M >>> 0) break i;
                                  if (m[k + T | 0] != 61) {
                                    gr = k, cr = 28;
                                    break i;
                                  }
                                  if (ve = k + Nr | 0, (0 | Nr) != 1) {
                                    if ((0 | (Br = k + 1 | 0)) == (0 | gr)) break i;
                                    if (m[T + Br | 0] != 61) {
                                      gr = Br, cr = 28;
                                      break i;
                                    }
                                    if ((0 | Nr) != 2 && ((0 | (k = k + 2 | 0)) == (0 | gr) || (cr = 28, gr = k, m[k + T | 0] != 61)))
                                      break i;
                                  }
                                }
                                if (E = 0, ye) break r;
                                break t;
                              }
                              o[9404] = cr;
                              break e;
                            }
                            if (!(M >>> 0 <= ve >>> 0)) {
                              for (; ; ) {
                                if (!Us(ye, B[T + ve | 0])) break t;
                                if ((0 | (ve = ve + 1 | 0)) == (0 | M)) break;
                              }
                              ve = M;
                            }
                          }
                          gr = ve, ti = Mr;
                        }
                        return pr ? o[pr >> 2] = T + gr : (0 | M) != (0 | gr) && (o[9404] = 28, E = -1), Ne && (o[Ne >> 2] = ti), 0 | E;
                      }
                      Wa(), ji();
                    }
                    function ea(k, E, T, M) {
                      k |= 0, E |= 0, T |= 0;
                      var ye = 0, Ne = 0, pr = 0, ve = 0, cr = 0, gr = 0, Pr = 0, Nr = 0, Br = 0, Mr = 0, jr = 0, ti = 0, fi = 0, Jr = 0, li = 0, Tr = 0, Mi = 0, Wi = 0, vn = 0;
                      for ((M |= 0) ? (ye = m[M + 12 | 0] | m[M + 13 | 0] << 8 | m[M + 14 | 0] << 16 | m[M + 15 | 0] << 24, cr = m[M + 8 | 0] | m[M + 9 | 0] << 8 | m[M + 10 | 0] << 16 | m[M + 11 | 0] << 24, gr = m[M + 4 | 0] | m[M + 5 | 0] << 8 | m[M + 6 | 0] << 16 | m[M + 7 | 0] << 24, M = m[0 | M] | m[M + 1 | 0] << 8 | m[M + 2 | 0] << 16 | m[M + 3 | 0] << 24) : (ye = 1797285236, cr = 2036477234, gr = 857760878, M = 1634760805), Ne = m[E + 12 | 0] | m[E + 13 | 0] << 8 | m[E + 14 | 0] << 16 | m[E + 15 | 0] << 24, ve = m[E + 8 | 0] | m[E + 9 | 0] << 8 | m[E + 10 | 0] << 16 | m[E + 11 | 0] << 24, pr = m[E + 4 | 0] | m[E + 5 | 0] << 8 | m[E + 6 | 0] << 16 | m[E + 7 | 0] << 24, Jr = m[T + 28 | 0] | m[T + 29 | 0] << 8 | m[T + 30 | 0] << 16 | m[T + 31 | 0] << 24, fi = m[T + 24 | 0] | m[T + 25 | 0] << 8 | m[T + 26 | 0] << 16 | m[T + 27 | 0] << 24, li = 20, jr = m[T + 20 | 0] | m[T + 21 | 0] << 8 | m[T + 22 | 0] << 16 | m[T + 23 | 0] << 24, ti = m[T + 16 | 0] | m[T + 17 | 0] << 8 | m[T + 18 | 0] << 16 | m[T + 19 | 0] << 24, Nr = m[T + 12 | 0] | m[T + 13 | 0] << 8 | m[T + 14 | 0] << 16 | m[T + 15 | 0] << 24, Br = m[T + 8 | 0] | m[T + 9 | 0] << 8 | m[T + 10 | 0] << 16 | m[T + 11 | 0] << 24, Mr = m[T + 4 | 0] | m[T + 5 | 0] << 8 | m[T + 6 | 0] << 16 | m[T + 7 | 0] << 24, E = m[0 | E] | m[E + 1 | 0] << 8 | m[E + 2 | 0] << 16 | m[E + 3 | 0] << 24, T = m[0 | T] | m[T + 1 | 0] << 8 | m[T + 2 | 0] << 16 | m[T + 3 | 0] << 24; Pr = ao(T + gr | 0, 7) ^ Ne, Tr = ao(Pr + gr | 0, 9) ^ fi, Nr = ao(M + jr | 0, 7) ^ Nr, Mi = ao(Nr + M | 0, 9) ^ ve, Wi = ao(Mi + Nr | 0, 13) ^ jr, Br = ao(ye + ti | 0, 7) ^ Br, pr = ao(Br + ye | 0, 9) ^ pr, ve = ao(pr + Br | 0, 13) ^ ti, ye = ao(pr + ve | 0, 18) ^ ye, Ne = ao(E + cr | 0, 7) ^ Jr, jr = Wi ^ ao(ye + Ne | 0, 7), fi = Tr ^ ao(jr + ye | 0, 9), Jr = ao(jr + fi | 0, 13) ^ Ne, ye = ao(fi + Jr | 0, 18) ^ ye, Mr = ao(Ne + cr | 0, 9) ^ Mr, vn = ao(Mr + Ne | 0, 13) ^ E, E = ao(vn + Mr | 0, 18) ^ cr, ti = ao(E + Pr | 0, 7) ^ ve, ve = ao(ti + E | 0, 9) ^ Mi, Ne = ao(ve + ti | 0, 13) ^ Pr, cr = ao(Ne + ve | 0, 18) ^ E, Pr = ao(Pr + Tr | 0, 13) ^ T, T = ao(Pr + Tr | 0, 18) ^ gr, E = ao(T + Nr | 0, 7) ^ vn, pr = ao(E + T | 0, 9) ^ pr, Nr = ao(E + pr | 0, 13) ^ Nr, gr = ao(pr + Nr | 0, 18) ^ T, M = ao(Mi + Wi | 0, 18) ^ M, T = ao(M + Br | 0, 7) ^ Pr, Mr = ao(T + M | 0, 9) ^ Mr, Br = ao(T + Mr | 0, 13) ^ Br, M = ao(Mr + Br | 0, 18) ^ M, Pr = li >>> 0 > 2, li = li - 2 | 0, Pr; ) ;
                      return B[0 | k] = M, B[k + 1 | 0] = M >>> 8, B[k + 2 | 0] = M >>> 16, B[k + 3 | 0] = M >>> 24, B[k + 28 | 0] = Ne, B[k + 29 | 0] = Ne >>> 8, B[k + 30 | 0] = Ne >>> 16, B[k + 31 | 0] = Ne >>> 24, B[k + 24 | 0] = ve, B[k + 25 | 0] = ve >>> 8, B[k + 26 | 0] = ve >>> 16, B[k + 27 | 0] = ve >>> 24, B[k + 20 | 0] = pr, B[k + 21 | 0] = pr >>> 8, B[k + 22 | 0] = pr >>> 16, B[k + 23 | 0] = pr >>> 24, B[k + 16 | 0] = E, B[k + 17 | 0] = E >>> 8, B[k + 18 | 0] = E >>> 16, B[k + 19 | 0] = E >>> 24, B[k + 12 | 0] = ye, B[k + 13 | 0] = ye >>> 8, B[k + 14 | 0] = ye >>> 16, B[k + 15 | 0] = ye >>> 24, B[k + 8 | 0] = cr, B[k + 9 | 0] = cr >>> 8, B[k + 10 | 0] = cr >>> 16, B[k + 11 | 0] = cr >>> 24, B[k + 4 | 0] = gr, B[k + 5 | 0] = gr >>> 8, B[k + 6 | 0] = gr >>> 16, B[k + 7 | 0] = gr >>> 24, 0;
                    }
                    function e(k, E) {
                      var T, M, ye, Ne, pr = 0, ve = 0, cr = 0, gr = 0, Pr = 0, Nr = 0;
                      for (dr = T = dr - 480 | 0; cr = (ve = T + 288 | 0) + (pr << 1) | 0, gr = m[E + pr | 0], B[cr + 1 | 0] = gr >>> 4, B[0 | cr] = 15 & gr, ve = ve + ((cr = 1 | pr) << 1) | 0, cr = m[E + cr | 0], B[ve + 1 | 0] = cr >>> 4, B[0 | ve] = 15 & cr, (0 | (pr = pr + 2 | 0)) != 32; ) ;
                      for (E = 0; pr = 8 + (ve = (pr = E) + m[0 | (E = (T + 288 | 0) + Pr | 0)] | 0) | 0, B[0 | E] = ve - (240 & pr), pr = 8 + (ve = m[E + 1 | 0] + (pr << 24 >> 24 >> 4) | 0) | 0, B[E + 1 | 0] = ve - (240 & pr), pr = 8 + (ve = m[E + 2 | 0] + (pr << 24 >> 24 >> 4) | 0) | 0, B[E + 2 | 0] = ve - (240 & pr), E = pr << 24 >> 24 >> 4, (0 | (Pr = Pr + 3 | 0)) != 63; ) ;
                      for (B[T + 351 | 0] = m[T + 351 | 0] + E, o[k + 32 >> 2] = 0, o[k + 36 >> 2] = 0, o[k + 24 >> 2] = 0, o[k + 28 >> 2] = 0, o[k + 16 >> 2] = 0, o[k + 20 >> 2] = 0, o[k + 8 >> 2] = 0, o[k + 12 >> 2] = 0, o[k >> 2] = 0, o[k + 4 >> 2] = 0, o[k + 44 >> 2] = 0, o[k + 48 >> 2] = 0, o[k + 40 >> 2] = 1, o[k + 52 >> 2] = 0, o[k + 56 >> 2] = 0, o[k + 60 >> 2] = 0, o[k + 64 >> 2] = 0, o[k + 68 >> 2] = 0, o[k + 72 >> 2] = 0, o[k + 76 >> 2] = 0, o[k + 80 >> 2] = 1, Ca(k + 84 | 0, 0, 76), ye = k + 120 | 0, Pr = k + 80 | 0, E = k + 40 | 0, ve = T + 208 | 0, M = T + 168 | 0, cr = T + 248 | 0, pr = 1; kf(Nr = T + 8 | 0, pr >>> 1 | 0, B[(T + 288 | 0) + pr | 0]), x2(gr = T + 128 | 0, k, Nr), Ti(k, gr, cr), Ti(E, M, ve), Ti(Pr, ve, cr), Ti(ye, gr, M), Nr = pr >>> 0 < 62, pr = pr + 2 | 0, Nr; ) ;
                      for (pr = o[k + 36 >> 2], o[T + 392 >> 2] = o[k + 32 >> 2], o[T + 396 >> 2] = pr, pr = o[k + 28 >> 2], o[T + 384 >> 2] = o[k + 24 >> 2], o[T + 388 >> 2] = pr, pr = o[k + 20 >> 2], o[T + 376 >> 2] = o[k + 16 >> 2], o[T + 380 >> 2] = pr, pr = o[k + 12 >> 2], o[T + 368 >> 2] = o[k + 8 >> 2], o[T + 372 >> 2] = pr, pr = o[k + 4 >> 2], o[T + 360 >> 2] = o[k >> 2], o[T + 364 >> 2] = pr, pr = o[E + 12 >> 2], o[T + 408 >> 2] = o[E + 8 >> 2], o[T + 412 >> 2] = pr, pr = o[E + 20 >> 2], o[T + 416 >> 2] = o[E + 16 >> 2], o[T + 420 >> 2] = pr, pr = o[E + 28 >> 2], o[T + 424 >> 2] = o[E + 24 >> 2], o[T + 428 >> 2] = pr, pr = o[E + 36 >> 2], o[T + 432 >> 2] = o[E + 32 >> 2], o[T + 436 >> 2] = pr, pr = o[E + 4 >> 2], o[T + 400 >> 2] = o[E >> 2], o[T + 404 >> 2] = pr, pr = o[Pr + 12 >> 2], o[T + 448 >> 2] = o[Pr + 8 >> 2], o[T + 452 >> 2] = pr, pr = o[Pr + 20 >> 2], o[T + 456 >> 2] = o[Pr + 16 >> 2], o[T + 460 >> 2] = pr, pr = o[Pr + 28 >> 2], o[T + 464 >> 2] = o[Pr + 24 >> 2], o[T + 468 >> 2] = pr, pr = o[Pr + 36 >> 2], o[T + 472 >> 2] = o[Pr + 32 >> 2], o[T + 476 >> 2] = pr, pr = o[Pr + 4 >> 2], o[T + 440 >> 2] = o[Pr >> 2], o[T + 444 >> 2] = pr, Oa(gr, pr = T + 360 | 0), Ti(pr, gr, cr), Ti(Nr = T + 400 | 0, M, ve), Ti(Ne = T + 440 | 0, ve, cr), Oa(gr, pr), Ti(pr, gr, cr), Ti(Nr, M, ve), Ti(Ne, ve, cr), Oa(gr, pr), Ti(pr, gr, cr), Ti(Nr, M, ve), Ti(Ne, ve, cr), Oa(gr, pr), Ti(k, gr, cr), Ti(E, M, ve), Ti(Pr, ve, cr), Ti(ye, gr, M), pr = 0; kf(Nr = T + 8 | 0, pr >>> 1 | 0, B[(T + 288 | 0) + pr | 0]), x2(gr = T + 128 | 0, k, Nr), Ti(k, gr, cr), Ti(E, M, ve), Ti(Pr, ve, cr), Ti(ye, gr, M), gr = pr >>> 0 < 62, pr = pr + 2 | 0, gr; ) ;
                      dr = T + 480 | 0;
                    }
                    function Je(k, E) {
                      k |= 0;
                      var T, M, ye, Ne, pr, ve = 0, cr = 0, gr = 0, Pr = 0, Nr = 0, Br = 0;
                      for (dr = T = dr - 736 | 0, $r(Nr = T + 704 | 0, E |= 0, E), $r(cr = T + 224 | 0, E, Nr), $r(Pr = T + 672 | 0, E, cr), $r(gr = T + 640 | 0, Pr, Pr), $r(M = T + 416 | 0, Nr, gr), $r(Nr = T + 320 | 0, E, M), $r(ve = T + 608 | 0, gr, gr), $r(gr = T + 288 | 0, Nr, Nr), $r(Br = T + 576 | 0, M, gr), $r(pr = T + 448 | 0, ve, gr), $r(ye = T + 544 | 0, Br, Br), $r(Br = T + 384 | 0, ve, ye), $r(Ne = T + 352 | 0, cr, Br), $r(cr = T + 192 | 0, ve, Ne), $r(ve = T + 160 | 0, Pr, cr), $r(T + 96 | 0, Pr, ve), $r(cr = T + 512 | 0, ye, Ne), $r(ve = T + 480 | 0, Pr, cr), $r(cr = T + 256 | 0, pr, ve), $r(T + 128 | 0, gr, cr), $r(gr = T - -64 | 0, Br, ve), $r(ve = T + 32 | 0, Pr, gr), $r(T, M, ve), $r(k, Nr, T), Pr = 0; $r(k, k, k), (0 | (Pr = Pr + 1 | 0)) != 126; ) ;
                      return $r(k, k, T + 352 | 0), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, T + 704 | 0), $r(k, k, T), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, T + 160 | 0), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, T), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, T + 256 | 0), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, T - -64 | 0), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, T + 96 | 0), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, T + 320 | 0), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, T + 512 | 0), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, T + 192 | 0), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, T + 480 | 0), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, T), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, T + 128 | 0), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, k), $r(k, k, T + 32 | 0), dr = T + 736 | 0, 0 - pa(E, 32) | 0;
                    }
                    function N2(k, E, T) {
                      k |= 0;
                      var M, ye, Ne, pr, ve = 0, cr = 0, gr = 0, Pr = 0, Nr = 0;
                      return dr = Ne = dr - 160 | 0, Zs(E |= 0, T |= 0, 32, 0), B[0 | E] = 248 & m[0 | E], B[E + 31 | 0] = 63 & m[E + 31 | 0] | 64, e(Ne, E), Rc(k, Ne), cr = m[(ye = T) + 8 | 0] | m[ye + 9 | 0] << 8 | m[ye + 10 | 0] << 16 | m[ye + 11 | 0] << 24, ve = m[ye + 12 | 0] | m[ye + 13 | 0] << 8 | m[ye + 14 | 0] << 16 | m[ye + 15 | 0] << 24, gr = m[ye + 16 | 0] | m[ye + 17 | 0] << 8 | m[ye + 18 | 0] << 16 | m[ye + 19 | 0] << 24, Pr = m[ye + 20 | 0] | m[ye + 21 | 0] << 8 | m[ye + 22 | 0] << 16 | m[ye + 23 | 0] << 24, Nr = m[0 | ye] | m[ye + 1 | 0] << 8 | m[ye + 2 | 0] << 16 | m[ye + 3 | 0] << 24, T = m[ye + 4 | 0] | m[ye + 5 | 0] << 8 | m[ye + 6 | 0] << 16 | m[ye + 7 | 0] << 24, pr = m[ye + 28 | 0] | m[ye + 29 | 0] << 8 | m[ye + 30 | 0] << 16 | m[ye + 31 | 0] << 24, M = E, E = m[ye + 24 | 0] | m[ye + 25 | 0] << 8 | m[ye + 26 | 0] << 16 | m[ye + 27 | 0] << 24, B[M + 24 | 0] = E, B[M + 25 | 0] = E >>> 8, B[M + 26 | 0] = E >>> 16, B[M + 27 | 0] = E >>> 24, B[M + 28 | 0] = pr, B[M + 29 | 0] = pr >>> 8, B[M + 30 | 0] = pr >>> 16, B[M + 31 | 0] = pr >>> 24, B[M + 16 | 0] = gr, B[M + 17 | 0] = gr >>> 8, B[M + 18 | 0] = gr >>> 16, B[M + 19 | 0] = gr >>> 24, B[M + 20 | 0] = Pr, B[M + 21 | 0] = Pr >>> 8, B[M + 22 | 0] = Pr >>> 16, B[M + 23 | 0] = Pr >>> 24, B[M + 8 | 0] = cr, B[M + 9 | 0] = cr >>> 8, B[M + 10 | 0] = cr >>> 16, B[M + 11 | 0] = cr >>> 24, B[M + 12 | 0] = ve, B[M + 13 | 0] = ve >>> 8, B[M + 14 | 0] = ve >>> 16, B[M + 15 | 0] = ve >>> 24, B[0 | M] = Nr, B[M + 1 | 0] = Nr >>> 8, B[M + 2 | 0] = Nr >>> 16, B[M + 3 | 0] = Nr >>> 24, B[M + 4 | 0] = T, B[M + 5 | 0] = T >>> 8, B[M + 6 | 0] = T >>> 16, B[M + 7 | 0] = T >>> 24, gr = m[(ve = k) + 8 | 0] | m[ve + 9 | 0] << 8 | m[ve + 10 | 0] << 16 | m[ve + 11 | 0] << 24, Pr = m[ve + 12 | 0] | m[ve + 13 | 0] << 8 | m[ve + 14 | 0] << 16 | m[ve + 15 | 0] << 24, Nr = m[ve + 16 | 0] | m[ve + 17 | 0] << 8 | m[ve + 18 | 0] << 16 | m[ve + 19 | 0] << 24, T = m[ve + 20 | 0] | m[ve + 21 | 0] << 8 | m[ve + 22 | 0] << 16 | m[ve + 23 | 0] << 24, E = m[0 | ve] | m[ve + 1 | 0] << 8 | m[ve + 2 | 0] << 16 | m[ve + 3 | 0] << 24, k = m[ve + 4 | 0] | m[ve + 5 | 0] << 8 | m[ve + 6 | 0] << 16 | m[ve + 7 | 0] << 24, cr = m[ve + 28 | 0] | m[ve + 29 | 0] << 8 | m[ve + 30 | 0] << 16 | m[ve + 31 | 0] << 24, ve = m[ve + 24 | 0] | m[ve + 25 | 0] << 8 | m[ve + 26 | 0] << 16 | m[ve + 27 | 0] << 24, B[M + 56 | 0] = ve, B[M + 57 | 0] = ve >>> 8, B[M + 58 | 0] = ve >>> 16, B[M + 59 | 0] = ve >>> 24, B[M + 60 | 0] = cr, B[M + 61 | 0] = cr >>> 8, B[M + 62 | 0] = cr >>> 16, B[M + 63 | 0] = cr >>> 24, B[M + 48 | 0] = Nr, B[M + 49 | 0] = Nr >>> 8, B[M + 50 | 0] = Nr >>> 16, B[M + 51 | 0] = Nr >>> 24, B[M + 52 | 0] = T, B[M + 53 | 0] = T >>> 8, B[M + 54 | 0] = T >>> 16, B[M + 55 | 0] = T >>> 24, B[M + 40 | 0] = gr, B[M + 41 | 0] = gr >>> 8, B[M + 42 | 0] = gr >>> 16, B[M + 43 | 0] = gr >>> 24, B[M + 44 | 0] = Pr, B[M + 45 | 0] = Pr >>> 8, B[M + 46 | 0] = Pr >>> 16, B[M + 47 | 0] = Pr >>> 24, B[M + 32 | 0] = E, B[M + 33 | 0] = E >>> 8, B[M + 34 | 0] = E >>> 16, B[M + 35 | 0] = E >>> 24, B[M + 36 | 0] = k, B[M + 37 | 0] = k >>> 8, B[M + 38 | 0] = k >>> 16, B[M + 39 | 0] = k >>> 24, dr = Ne + 160 | 0, 0;
                    }
                    function qs(k, E, T, M) {
                      var ye, Ne = 0, pr = 0, ve = 0, cr = 0, gr = 0, Pr = 0, Nr = 0, Br = 0, Mr = 0, jr = 0, ti = 0, fi = 0;
                      if (dr = ye = dr - 704 | 0, T | M) if (Ne = (M << 3 | T >>> 29) + (pr = cr = o[k + 76 >> 2]) | 0, ve = (Pr = o[k + 72 >> 2]) + (gr = T << 3) | 0, o[k + 72 >> 2] = ve, Ne = ve >>> 0 < gr >>> 0 ? Ne + 1 | 0 : Ne, o[k + 76 >> 2] = Ne, cr = o[k + 68 >> 2], Ne = (Ne = ve = (0 | Ne) == (0 | pr) & ve >>> 0 < Pr >>> 0 | Ne >>> 0 < pr >>> 0) >>> 0 > (ve = ve + o[k + 64 >> 2] | 0) >>> 0 ? cr + 1 | 0 : cr, ve = (gr = M >>> 29 | 0) + ve | 0, o[k + 64 >> 2] = ve, o[k + 68 >> 2] = ve >>> 0 < gr >>> 0 ? Ne + 1 | 0 : Ne, ve = k + 80 | 0, (0 | M) == (0 | (cr = ti = 0 - ((Ne = 0) + ((gr = 127 & ((7 & pr) << 29 | Pr >>> 3)) >>> 0 > 128) | 0) | 0)) & T >>> 0 >= (Pr = 128 - gr | 0) >>> 0 | M >>> 0 > cr >>> 0) {
                        if (pr = 0, cr = 0, !Ne & (127 ^ gr) >>> 0 >= 3 | Ne) for (fi = 252 & Pr; B[(Ne = pr + gr | 0) + ve | 0] = m[E + pr | 0], B[ve + (gr + (Ne = 1 | pr) | 0) | 0] = m[E + Ne | 0], B[ve + (gr + (Ne = 2 | pr) | 0) | 0] = m[E + Ne | 0], B[ve + (gr + (Ne = 3 | pr) | 0) | 0] = m[E + Ne | 0], Ne = cr, cr = (pr = pr + 4 | 0) >>> 0 < 4 ? Ne + 1 | 0 : Ne, Ne = Mr, Mr = Ne = (Nr = Nr + 4 | 0) >>> 0 < 4 ? Ne + 1 | 0 : Ne, (0 | Nr) != (0 | fi) | (0 | jr) != (0 | Ne); ) ;
                        if (Mr = Ne = 0, Ne | (Nr = 3 & Pr)) for (; B[(Ne = pr + gr | 0) + ve | 0] = m[E + pr | 0], Ne = cr, cr = (pr = pr + 1 | 0) ? Ne : Ne + 1 | 0, Ne = jr, jr = Ne = (Br = Br + 1 | 0) ? Ne : Ne + 1 | 0, (0 | Nr) != (0 | Br) | (0 | Mr) != (0 | Ne); ) ;
                        if (ni(k, ve, ye, pr = ye + 640 | 0), E = E + Pr | 0, !(M = M - ((T >>> 0 < Pr >>> 0) + ti | 0) | 0) & (T = T - Pr | 0) >>> 0 > 127 | M) for (; ni(k, E, ye, pr), E = E + 128 | 0, !(M = M - (T >>> 0 < 128) | 0) & (T = T - 128 | 0) >>> 0 > 127 | M; ) ;
                        if (T | M) {
                          if (k = 3 & T, Br = 0, jr = 0, pr = 0, cr = 0, !M & T >>> 0 >= 4 | M) for (Nr = 124 & T, Pr = 0, T = 0, M = 0; B[pr + ve | 0] = m[E + pr | 0], B[(Ne = 1 | pr) + ve | 0] = m[E + Ne | 0], B[(Ne = 2 | pr) + ve | 0] = m[E + Ne | 0], B[(Ne = 3 | pr) + ve | 0] = m[E + Ne | 0], Ne = cr, cr = (pr = pr + 4 | 0) >>> 0 < 4 ? Ne + 1 | 0 : Ne, Ne = M, M = Ne = (T = T + 4 | 0) >>> 0 < 4 ? Ne + 1 | 0 : Ne, (0 | T) != (0 | Nr) | (0 | Pr) != (0 | Ne); ) ;
                          if (k | Mr) for (; B[pr + ve | 0] = m[E + pr | 0], cr = (pr = pr + 1 | 0) ? cr : cr + 1 | 0, Ne = jr, jr = Ne = (Br = Br + 1 | 0) ? Ne : Ne + 1 | 0, (0 | k) != (0 | Br) | (0 | Mr) != (0 | Ne); ) ;
                        }
                        _s(ye, 704);
                      } else {
                        if (pr = 0, cr = 0, !M & T >>> 0 >= 4 | M) for (k = -4 & T; B[(Ne = pr + gr | 0) + ve | 0] = m[E + pr | 0], B[ve + (Pr = gr + (Ne = 1 | pr) | 0) | 0] = m[E + Ne | 0], B[ve + (Pr = gr + (Ne = 2 | pr) | 0) | 0] = m[E + Ne | 0], B[ve + (Pr = gr + (Ne = 3 | pr) | 0) | 0] = m[E + Ne | 0], Ne = cr, cr = (pr = pr + 4 | 0) >>> 0 < 4 ? Ne + 1 | 0 : Ne, Ne = Mr, Mr = Ne = (Nr = Nr + 4 | 0) >>> 0 < 4 ? Ne + 1 | 0 : Ne, (0 | k) != (0 | Nr) | (0 | M) != (0 | Ne); ) ;
                        if ((T &= 3) | (k = 0)) for (; B[(M = pr + gr | 0) + ve | 0] = m[E + pr | 0], cr = (pr = pr + 1 | 0) ? cr : cr + 1 | 0, Ne = jr, jr = Ne = (Br = Br + 1 | 0) ? Ne : Ne + 1 | 0, (0 | T) != (0 | Br) | (0 | k) != (0 | Ne); ) ;
                      }
                      return dr = ye + 704 | 0, 0;
                    }
                    function df(k, E, T) {
                      var M, ye = 0, Ne = 0, pr = 0, ve = 0, cr = 0, gr = 0, Pr = 0, Nr = 0, Br = 0, Mr = 0, jr = 0, ti = 0, fi = 0, Jr = 0, li = 0, Tr = 0, Mi = 0, Wi = 0, vn = 0;
                      ti = o[E + 4 >> 2], ye = o[k + 4 >> 2], fi = o[E + 8 >> 2], Ne = o[k + 8 >> 2], Jr = o[E + 12 >> 2], pr = o[k + 12 >> 2], li = o[E + 16 >> 2], ve = o[k + 16 >> 2], Tr = o[E + 20 >> 2], cr = o[k + 20 >> 2], jr = o[E + 24 >> 2], gr = o[k + 24 >> 2], Mi = o[E + 28 >> 2], Pr = o[k + 28 >> 2], Wi = o[E + 32 >> 2], Nr = o[k + 32 >> 2], vn = o[E + 36 >> 2], Br = o[k + 36 >> 2], T = 0 - T | 0, Mr = o[k >> 2], o[k >> 2] = T & (Mr ^ o[E >> 2]) ^ Mr, o[k + 36 >> 2] = Br ^ T & (Br ^ vn), o[k + 32 >> 2] = Nr ^ T & (Nr ^ Wi), o[k + 28 >> 2] = Pr ^ T & (Pr ^ Mi), o[k + 24 >> 2] = gr ^ T & (gr ^ jr), o[k + 20 >> 2] = cr ^ T & (cr ^ Tr), o[k + 16 >> 2] = ve ^ T & (ve ^ li), o[k + 12 >> 2] = pr ^ T & (pr ^ Jr), o[k + 8 >> 2] = Ne ^ T & (Ne ^ fi), o[k + 4 >> 2] = ye ^ T & (ye ^ ti), ye = o[k + 44 >> 2], ti = o[E + 44 >> 2], Ne = o[k + 48 >> 2], fi = o[E + 48 >> 2], pr = o[k + 52 >> 2], Jr = o[E + 52 >> 2], ve = o[k + 56 >> 2], li = o[E + 56 >> 2], cr = o[k + 60 >> 2], Tr = o[E + 60 >> 2], gr = o[(jr = k - -64 | 0) >> 2], Mi = o[E - -64 >> 2], Pr = o[k + 68 >> 2], Wi = o[E + 68 >> 2], Nr = o[k + 72 >> 2], vn = o[E + 72 >> 2], Br = o[k + 40 >> 2], Mr = o[E + 40 >> 2], M = o[k + 76 >> 2], o[k + 76 >> 2] = M ^ T & (o[E + 76 >> 2] ^ M), o[k + 72 >> 2] = Nr ^ T & (Nr ^ vn), o[k + 68 >> 2] = Pr ^ T & (Pr ^ Wi), o[jr >> 2] = gr ^ T & (gr ^ Mi), o[k + 60 >> 2] = cr ^ T & (cr ^ Tr), o[k + 56 >> 2] = ve ^ T & (ve ^ li), o[k + 52 >> 2] = pr ^ T & (pr ^ Jr), o[k + 48 >> 2] = Ne ^ T & (Ne ^ fi), o[k + 44 >> 2] = ye ^ T & (ye ^ ti), o[k + 40 >> 2] = Br ^ T & (Br ^ Mr), ye = o[k + 84 >> 2], ti = o[E + 84 >> 2], Ne = o[k + 88 >> 2], fi = o[E + 88 >> 2], pr = o[k + 92 >> 2], Jr = o[E + 92 >> 2], ve = o[k + 96 >> 2], li = o[E + 96 >> 2], cr = o[k + 100 >> 2], Tr = o[E + 100 >> 2], gr = o[k + 104 >> 2], jr = o[E + 104 >> 2], Pr = o[k + 108 >> 2], Mi = o[E + 108 >> 2], Nr = o[k + 112 >> 2], Wi = o[E + 112 >> 2], Br = o[k + 80 >> 2], vn = o[E + 80 >> 2], Mr = o[k + 116 >> 2], o[k + 116 >> 2] = T & (Mr ^ o[E + 116 >> 2]) ^ Mr, o[k + 112 >> 2] = Nr ^ T & (Nr ^ Wi), o[k + 108 >> 2] = Pr ^ T & (Pr ^ Mi), o[k + 104 >> 2] = gr ^ T & (gr ^ jr), o[k + 100 >> 2] = cr ^ T & (cr ^ Tr), o[k + 96 >> 2] = ve ^ T & (ve ^ li), o[k + 92 >> 2] = pr ^ T & (pr ^ Jr), o[k + 88 >> 2] = Ne ^ T & (Ne ^ fi), o[k + 84 >> 2] = ye ^ T & (ye ^ ti), o[k + 80 >> 2] = Br ^ T & (Br ^ vn), ye = o[k + 124 >> 2], ti = o[E + 124 >> 2], Ne = o[k + 128 >> 2], fi = o[E + 128 >> 2], pr = o[k + 132 >> 2], Jr = o[E + 132 >> 2], ve = o[k + 136 >> 2], li = o[E + 136 >> 2], cr = o[k + 140 >> 2], Tr = o[E + 140 >> 2], gr = o[k + 144 >> 2], jr = o[E + 144 >> 2], Pr = o[k + 148 >> 2], Mi = o[E + 148 >> 2], Nr = o[k + 152 >> 2], Wi = o[E + 152 >> 2], Br = o[k + 120 >> 2], vn = o[E + 120 >> 2], Mr = o[E + 156 >> 2], E = o[k + 156 >> 2], o[k + 156 >> 2] = T & (Mr ^ E) ^ E, o[k + 152 >> 2] = Nr ^ T & (Nr ^ Wi), o[k + 148 >> 2] = Pr ^ T & (Pr ^ Mi), o[k + 144 >> 2] = gr ^ T & (gr ^ jr), o[k + 140 >> 2] = cr ^ T & (cr ^ Tr), o[k + 136 >> 2] = ve ^ T & (ve ^ li), o[k + 132 >> 2] = pr ^ T & (pr ^ Jr), o[k + 128 >> 2] = Ne ^ T & (Ne ^ fi), o[k + 124 >> 2] = ye ^ T & (ye ^ ti), o[k + 120 >> 2] = Br ^ T & (Br ^ vn);
                    }
                    function zo(k, E, T) {
                      var M, ye, Ne = 0, pr = 0, ve = 0, cr = 0, gr = 0, Pr = 0, Nr = 0, Br = 0, Mr = 0, jr = 0, ti = 0, fi = 0, Jr = 0, li = 0, Tr = 0, Mi = 0, Wi = 0, vn = 0, Tn = 0;
                      return dr = M = dr - 320 | 0, qi(Ne = M + 240 | 0, T), Ti(Ne, Ne, T), qi(k, Ne), Ti(k, k, T), Ti(k, k, E), La(k, k), Ti(k, k, Ne), Ti(k, k, E), qi(Ne = M + 192 | 0, k), Ti(Ne, Ne, T), pr = o[E + 4 >> 2], jr = o[E + 8 >> 2], fi = o[E + 12 >> 2], Jr = o[E + 16 >> 2], li = o[E + 20 >> 2], Tr = o[E + 24 >> 2], Mi = o[E + 28 >> 2], Wi = o[E + 32 >> 2], vn = o[E >> 2], T = o[M + 192 >> 2], Ne = o[M + 196 >> 2], ve = o[M + 200 >> 2], cr = o[M + 204 >> 2], gr = o[M + 208 >> 2], Pr = o[M + 212 >> 2], Nr = o[M + 216 >> 2], Br = o[M + 220 >> 2], Mr = o[M + 224 >> 2], ti = o[M + 228 >> 2], Tn = o[E + 36 >> 2], o[M + 180 >> 2] = ti - Tn, o[M + 176 >> 2] = Mr - Wi, o[M + 172 >> 2] = Br - Mi, o[M + 168 >> 2] = Nr - Tr, o[M + 164 >> 2] = Pr - li, o[M + 160 >> 2] = gr - Jr, o[M + 156 >> 2] = cr - fi, o[M + 152 >> 2] = ve - jr, o[M + 148 >> 2] = Ne - pr, o[M + 144 >> 2] = T - vn, o[M + 132 >> 2] = ti + Tn, o[M + 128 >> 2] = Mr + Wi, o[M + 124 >> 2] = Br + Mi, o[M + 120 >> 2] = Nr + Tr, o[M + 116 >> 2] = Pr + li, o[M + 112 >> 2] = gr + Jr, o[M + 108 >> 2] = cr + fi, o[M + 104 >> 2] = ve + jr, o[M + 100 >> 2] = Ne + pr, o[M + 96 >> 2] = T + vn, Ti(pr = M + 48 | 0, E, 1632), o[M + 84 >> 2] = ti + o[M + 84 >> 2], o[M + 80 >> 2] = Mr + o[M + 80 >> 2], o[M + 76 >> 2] = Br + o[M + 76 >> 2], o[M + 72 >> 2] = Nr + o[M + 72 >> 2], o[M + 68 >> 2] = Pr + o[M + 68 >> 2], o[M + 64 >> 2] = gr + o[M + 64 >> 2], o[M + 60 >> 2] = cr + o[M + 60 >> 2], o[M + 56 >> 2] = ve + o[M + 56 >> 2], o[M + 52 >> 2] = Ne + o[M + 52 >> 2], o[M + 48 >> 2] = T + o[M + 48 >> 2], i2(M, M + 144 | 0), fi = pa(M, 32), i2(M, M + 96 | 0), jr = pa(M, 32), i2(M, pr), E = pa(M, 32), Ti(M, k, 1632), Mr = o[k + 4 >> 2], Br = o[k + 8 >> 2], Nr = o[k + 12 >> 2], Pr = o[k + 16 >> 2], gr = o[k + 20 >> 2], cr = o[k + 24 >> 2], ve = o[k + 28 >> 2], Ne = o[k + 32 >> 2], pr = o[k >> 2], Jr = o[M >> 2], li = o[M + 4 >> 2], Tr = o[M + 8 >> 2], Mi = o[M + 12 >> 2], Wi = o[M + 16 >> 2], vn = o[M + 20 >> 2], ti = o[M + 24 >> 2], Tn = o[M + 28 >> 2], ye = o[M + 32 >> 2], T = (E = 0 - (E | jr) | 0) & ((T = o[k + 36 >> 2]) ^ o[M + 36 >> 2]) ^ T, o[k + 36 >> 2] = T, Ne ^= E & (Ne ^ ye), o[k + 32 >> 2] = Ne, ve ^= E & (ve ^ Tn), o[k + 28 >> 2] = ve, cr ^= E & (cr ^ ti), o[k + 24 >> 2] = cr, gr ^= E & (gr ^ vn), o[k + 20 >> 2] = gr, Pr ^= E & (Pr ^ Wi), o[k + 16 >> 2] = Pr, Nr ^= E & (Nr ^ Mi), o[k + 12 >> 2] = Nr, Br ^= E & (Br ^ Tr), o[k + 8 >> 2] = Br, Mr ^= E & (Mr ^ li), o[k + 4 >> 2] = Mr, pr ^= E & (pr ^ Jr), o[k >> 2] = pr, i2(M + 288 | 0, k), E = 0 - (1 & B[M + 288 | 0]) | 0, o[k + 36 >> 2] = T ^ E & (T ^ 0 - T), o[k + 32 >> 2] = Ne ^ E & (Ne ^ 0 - Ne), o[k + 28 >> 2] = ve ^ E & (ve ^ 0 - ve), o[k + 24 >> 2] = cr ^ E & (cr ^ 0 - cr), o[k + 20 >> 2] = gr ^ E & (gr ^ 0 - gr), o[k + 16 >> 2] = Pr ^ E & (Pr ^ 0 - Pr), o[k + 12 >> 2] = Nr ^ E & (Nr ^ 0 - Nr), o[k + 8 >> 2] = Br ^ E & (Br ^ 0 - Br), o[k + 4 >> 2] = Mr ^ E & (Mr ^ 0 - Mr), o[k >> 2] = pr ^ E & (pr ^ 0 - pr), dr = M + 320 | 0, jr | fi;
                    }
                    function No(k, E) {
                      var T, M, ye, Ne, pr = 0, ve = 0, cr = 0, gr = 0, Pr = 0, Nr = 0, Br = 0, Mr = 0, jr = 0, ti = 0, fi = 0, Jr = 0, li = 0, Tr = 0, Mi = 0, Wi = 0, vn = 0, Tn = 0, Ni = 0, Yi = 0;
                      return dr = T = dr - 320 | 0, Va(M = k + 40 | 0, E), o[k + 84 >> 2] = 0, o[k + 88 >> 2] = 0, o[k + 80 >> 2] = 1, o[k + 92 >> 2] = 0, o[k + 96 >> 2] = 0, o[k + 100 >> 2] = 0, o[k + 104 >> 2] = 0, o[k + 108 >> 2] = 0, o[k + 112 >> 2] = 0, o[k + 116 >> 2] = 0, qi(pr = T + 240 | 0, M), Ti(ve = T + 192 | 0, pr, 1584), o[T + 192 >> 2] = o[T + 192 >> 2] + 1, cr = o[T + 240 >> 2] - 1 | 0, o[T + 240 >> 2] = cr, gr = o[T + 244 >> 2], Pr = o[T + 248 >> 2], Nr = o[T + 252 >> 2], Br = o[T + 256 >> 2], Mr = o[T + 260 >> 2], jr = o[T + 264 >> 2], ti = o[T + 268 >> 2], fi = o[T + 272 >> 2], Jr = o[T + 276 >> 2], Ti(k, pr, ve), La(k, k), Ti(k, pr, k), qi(pr = T + 144 | 0, k), Ti(pr, pr, ve), pr = o[T + 180 >> 2], o[T + 132 >> 2] = pr - Jr, ve = o[T + 176 >> 2], o[T + 128 >> 2] = ve - fi, li = o[T + 172 >> 2], o[T + 124 >> 2] = li - ti, Tr = o[T + 168 >> 2], o[T + 120 >> 2] = Tr - jr, Mi = o[T + 164 >> 2], o[T + 116 >> 2] = Mi - Mr, Wi = o[T + 160 >> 2], o[T + 112 >> 2] = Wi - Br, vn = o[T + 156 >> 2], o[T + 108 >> 2] = vn - Nr, Tn = o[T + 152 >> 2], o[T + 104 >> 2] = Tn - Pr, Ni = o[T + 148 >> 2], o[T + 100 >> 2] = Ni - gr, Yi = o[T + 144 >> 2], o[T + 96 >> 2] = Yi - cr, o[T + 84 >> 2] = pr + Jr, o[T + 80 >> 2] = ve + fi, o[T + 76 >> 2] = ti + li, o[T + 72 >> 2] = jr + Tr, o[T + 68 >> 2] = Mr + Mi, o[T + 64 >> 2] = Br + Wi, o[T + 60 >> 2] = Nr + vn, o[T + 56 >> 2] = Pr + Tn, o[T + 52 >> 2] = gr + Ni, o[T + 48 >> 2] = cr + Yi, i2(T, T + 96 | 0), fi = pa(T, 32), i2(T, T + 48 | 0), li = pa(T, 32), Ti(T, k, 1632), ti = o[k + 4 >> 2], jr = o[k + 8 >> 2], Mr = o[k + 12 >> 2], Br = o[k + 16 >> 2], Nr = o[k + 20 >> 2], Pr = o[k + 24 >> 2], gr = o[k + 28 >> 2], cr = o[k + 32 >> 2], Jr = o[k >> 2], Tr = o[T >> 2], Mi = o[T + 4 >> 2], Wi = o[T + 8 >> 2], vn = o[T + 12 >> 2], Tn = o[T + 16 >> 2], Ni = o[T + 20 >> 2], Yi = o[T + 24 >> 2], ye = o[T + 28 >> 2], Ne = o[T + 32 >> 2], ve = (pr = fi - 1 | 0) & ((ve = o[k + 36 >> 2]) ^ o[T + 36 >> 2]) ^ ve, o[k + 36 >> 2] = ve, cr ^= pr & (cr ^ Ne), o[k + 32 >> 2] = cr, gr ^= pr & (gr ^ ye), o[k + 28 >> 2] = gr, Pr ^= pr & (Pr ^ Yi), o[k + 24 >> 2] = Pr, Nr ^= pr & (Nr ^ Ni), o[k + 20 >> 2] = Nr, Br ^= pr & (Br ^ Tn), o[k + 16 >> 2] = Br, Mr ^= pr & (Mr ^ vn), o[k + 12 >> 2] = Mr, jr ^= pr & (jr ^ Wi), o[k + 8 >> 2] = jr, ti ^= pr & (ti ^ Mi), o[k + 4 >> 2] = ti, pr = Jr ^ pr & (Jr ^ Tr), o[k >> 2] = pr, i2(T + 288 | 0, k), E = 0 - (1 & B[T + 288 | 0] ^ m[E + 31 | 0] >>> 7 ^ m[38144] >>> 2) | 0, o[k + 36 >> 2] = ve ^ E & (ve ^ 0 - ve), o[k + 32 >> 2] = cr ^ E & (cr ^ 0 - cr), o[k + 28 >> 2] = gr ^ E & (gr ^ 0 - gr), o[k + 24 >> 2] = Pr ^ E & (Pr ^ 0 - Pr), o[k + 20 >> 2] = Nr ^ E & (Nr ^ 0 - Nr), o[k + 16 >> 2] = Br ^ E & (Br ^ 0 - Br), o[k + 12 >> 2] = Mr ^ E & (Mr ^ 0 - Mr), o[k + 8 >> 2] = jr ^ E & (jr ^ 0 - jr), o[k + 4 >> 2] = ti ^ E & (ti ^ 0 - ti), o[k >> 2] = pr ^ E & (pr ^ 0 - pr), Ti(k + 120 | 0, k, M), dr = T + 320 | 0, (fi | li) - 1 | 0;
                    }
                    function Oa(k, E) {
                      var T, M, ye, Ne, pr, ve, cr, gr, Pr, Nr, Br, Mr, jr, ti = 0, fi = 0, Jr = 0, li = 0, Tr = 0, Mi = 0, Wi = 0, vn = 0, Tn = 0, Ni = 0, Yi = 0, Xi = 0, $n = 0, Zn = 0, to = 0, fo = 0, wo = 0, bo = 0;
                      dr = T = dr - 48 | 0, qi(k, E), qi(k + 80 | 0, E + 40 | 0), Mo(k + 120 | 0, E + 80 | 0), ti = o[E + 44 >> 2], fi = o[E + 4 >> 2], Mi = o[E + 48 >> 2], Jr = o[E + 8 >> 2], Wi = o[E + 52 >> 2], li = o[E + 12 >> 2], vn = o[E + 56 >> 2], Tr = o[E + 16 >> 2], $n = o[E + 60 >> 2], Tn = o[E + 20 >> 2], Zn = o[E - -64 >> 2], Ni = o[E + 24 >> 2], to = o[E + 68 >> 2], Yi = o[E + 28 >> 2], fo = o[E + 72 >> 2], wo = o[E + 32 >> 2], bo = o[E + 40 >> 2], Xi = o[E >> 2], o[k + 76 >> 2] = o[E + 76 >> 2] + o[E + 36 >> 2], o[k + 72 >> 2] = fo + wo, o[k + 68 >> 2] = to + Yi, o[(M = k - -64 | 0) >> 2] = Zn + Ni, o[k + 60 >> 2] = $n + Tn, o[k + 56 >> 2] = vn + Tr, o[k + 52 >> 2] = Wi + li, o[k + 48 >> 2] = Mi + Jr, o[k + 44 >> 2] = ti + fi, o[k + 40 >> 2] = bo + Xi, qi(T, k + 40 | 0), E = o[k + 4 >> 2], ti = o[k + 84 >> 2], fi = o[k + 8 >> 2], Mi = o[k + 88 >> 2], Jr = o[k + 12 >> 2], Wi = o[k + 92 >> 2], li = o[k + 16 >> 2], vn = o[k + 96 >> 2], Tr = o[k + 20 >> 2], $n = o[k + 100 >> 2], Tn = o[k + 24 >> 2], Zn = o[k + 104 >> 2], Ni = o[k + 28 >> 2], to = o[k + 108 >> 2], Yi = o[k + 32 >> 2], fo = o[k + 112 >> 2], wo = o[k >> 2], bo = o[k + 80 >> 2], Ne = (Xi = o[k + 116 >> 2]) - (ye = o[k + 36 >> 2]) | 0, o[k + 116 >> 2] = Ne, pr = fo - Yi | 0, o[k + 112 >> 2] = pr, ve = to - Ni | 0, o[k + 108 >> 2] = ve, cr = Zn - Tn | 0, o[k + 104 >> 2] = cr, gr = $n - Tr | 0, o[k + 100 >> 2] = gr, Pr = vn - li | 0, o[k + 96 >> 2] = Pr, Nr = Wi - Jr | 0, o[k + 92 >> 2] = Nr, Br = Mi - fi | 0, o[k + 88 >> 2] = Br, Mr = ti - E | 0, o[k + 84 >> 2] = Mr, jr = bo - wo | 0, o[k + 80 >> 2] = jr, Xi = Xi + ye | 0, o[k + 76 >> 2] = Xi, Yi = Yi + fo | 0, o[k + 72 >> 2] = Yi, Ni = Ni + to | 0, o[k + 68 >> 2] = Ni, Tn = Tn + Zn | 0, o[M >> 2] = Tn, Tr = Tr + $n | 0, o[k + 60 >> 2] = Tr, li = li + vn | 0, o[k + 56 >> 2] = li, Jr = Jr + Wi | 0, o[k + 52 >> 2] = Jr, fi = fi + Mi | 0, o[k + 48 >> 2] = fi, E = E + ti | 0, o[k + 44 >> 2] = E, ti = wo + bo | 0, o[k + 40 >> 2] = ti, Mi = o[T >> 2], Wi = o[T + 4 >> 2], vn = o[T + 8 >> 2], $n = o[T + 12 >> 2], Zn = o[T + 16 >> 2], to = o[T + 20 >> 2], fo = o[T + 24 >> 2], wo = o[T + 28 >> 2], bo = o[T + 32 >> 2], o[k + 36 >> 2] = o[T + 36 >> 2] - Xi, o[k + 32 >> 2] = bo - Yi, o[k + 28 >> 2] = wo - Ni, o[k + 24 >> 2] = fo - Tn, o[k + 20 >> 2] = to - Tr, o[k + 16 >> 2] = Zn - li, o[k + 12 >> 2] = $n - Jr, o[k + 8 >> 2] = vn - fi, o[k + 4 >> 2] = Wi - E, o[k >> 2] = Mi - ti, E = o[k + 124 >> 2], ti = o[k + 128 >> 2], fi = o[k + 132 >> 2], Mi = o[k + 136 >> 2], Jr = o[k + 140 >> 2], Wi = o[k + 144 >> 2], li = o[k + 148 >> 2], vn = o[k + 152 >> 2], Tr = o[k + 120 >> 2], o[k + 156 >> 2] = o[k + 156 >> 2] - Ne, o[k + 152 >> 2] = vn - pr, o[k + 148 >> 2] = li - ve, o[k + 144 >> 2] = Wi - cr, o[k + 140 >> 2] = Jr - gr, o[k + 136 >> 2] = Mi - Pr, o[k + 132 >> 2] = fi - Nr, o[k + 128 >> 2] = ti - Br, o[k + 124 >> 2] = E - Mr, o[k + 120 >> 2] = Tr - jr, dr = T + 48 | 0;
                    }
                    function Mf(k, E, T, M) {
                      var ye, Ne = 0, pr = 0, ve = 0, cr = 0, gr = 0, Pr = 0, Nr = 0, Br = 0, Mr = 0, jr = 0, ti = 0, fi = 0;
                      if (dr = ye = dr - 288 | 0, T | M) if (Ne = (M << 3 | T >>> 29) + (pr = cr = o[k + 36 >> 2]) | 0, ve = (gr = o[k + 32 >> 2]) + (Pr = T << 3) | 0, o[k + 32 >> 2] = ve, o[k + 36 >> 2] = ve >>> 0 < Pr >>> 0 ? Ne + 1 | 0 : Ne, cr = k + 40 | 0, (0 | M) == (0 | (ve = ti = 0 - ((Ne = 0) + ((Pr = 63 & ((7 & pr) << 29 | gr >>> 3)) >>> 0 > 64) | 0) | 0)) & T >>> 0 >= (gr = 64 - Pr | 0) >>> 0 | M >>> 0 > ve >>> 0) {
                        if (pr = 0, ve = 0, !Ne & (63 ^ Pr) >>> 0 >= 3 | Ne) for (fi = 124 & gr; B[(Ne = pr + Pr | 0) + cr | 0] = m[E + pr | 0], B[cr + (Pr + (Ne = 1 | pr) | 0) | 0] = m[E + Ne | 0], B[cr + (Pr + (Ne = 2 | pr) | 0) | 0] = m[E + Ne | 0], B[cr + (Pr + (Ne = 3 | pr) | 0) | 0] = m[E + Ne | 0], Ne = ve, ve = (pr = pr + 4 | 0) >>> 0 < 4 ? Ne + 1 | 0 : Ne, Ne = Mr, Mr = Ne = (Nr = Nr + 4 | 0) >>> 0 < 4 ? Ne + 1 | 0 : Ne, (0 | Nr) != (0 | fi) | (0 | jr) != (0 | Ne); ) ;
                        if (Mr = Ne = 0, Ne | (Nr = 3 & gr)) for (; B[(Ne = pr + Pr | 0) + cr | 0] = m[E + pr | 0], Ne = ve, ve = (pr = pr + 1 | 0) ? Ne : Ne + 1 | 0, Ne = jr, jr = Ne = (Br = Br + 1 | 0) ? Ne : Ne + 1 | 0, (0 | Nr) != (0 | Br) | (0 | Mr) != (0 | Ne); ) ;
                        if (Vn(k, cr, ye, pr = ye + 256 | 0), E = E + gr | 0, !(M = M - ((T >>> 0 < gr >>> 0) + ti | 0) | 0) & (T = T - gr | 0) >>> 0 > 63 | M) for (; Vn(k, E, ye, pr), E = E - -64 | 0, Ne = M - 1 | 0, !(M = (T = T + -64 | 0) >>> 0 < 4294967232 ? Ne + 1 | 0 : Ne) & T >>> 0 > 63 | M; ) ;
                        if (T | M) {
                          if (k = 3 & T, Br = 0, jr = 0, pr = 0, ve = 0, !M & T >>> 0 >= 4 | M) for (Nr = 60 & T, gr = 0, T = 0, M = 0; B[pr + cr | 0] = m[E + pr | 0], B[(Ne = 1 | pr) + cr | 0] = m[E + Ne | 0], B[(Ne = 2 | pr) + cr | 0] = m[E + Ne | 0], B[(Ne = 3 | pr) + cr | 0] = m[E + Ne | 0], Ne = ve, ve = (pr = pr + 4 | 0) >>> 0 < 4 ? Ne + 1 | 0 : Ne, Ne = M, M = Ne = (T = T + 4 | 0) >>> 0 < 4 ? Ne + 1 | 0 : Ne, (0 | T) != (0 | Nr) | (0 | gr) != (0 | Ne); ) ;
                          if (k | Mr) for (; B[pr + cr | 0] = m[E + pr | 0], ve = (pr = pr + 1 | 0) ? ve : ve + 1 | 0, Ne = jr, jr = Ne = (Br = Br + 1 | 0) ? Ne : Ne + 1 | 0, (0 | k) != (0 | Br) | (0 | Mr) != (0 | Ne); ) ;
                        }
                        _s(ye, 288);
                      } else {
                        if (pr = 0, ve = 0, !M & T >>> 0 >= 4 | M) for (k = -4 & T; B[(Ne = pr + Pr | 0) + cr | 0] = m[E + pr | 0], B[cr + (gr = Pr + (Ne = 1 | pr) | 0) | 0] = m[E + Ne | 0], B[cr + (gr = Pr + (Ne = 2 | pr) | 0) | 0] = m[E + Ne | 0], B[cr + (gr = Pr + (Ne = 3 | pr) | 0) | 0] = m[E + Ne | 0], Ne = ve, ve = (pr = pr + 4 | 0) >>> 0 < 4 ? Ne + 1 | 0 : Ne, Ne = Mr, Mr = Ne = (Nr = Nr + 4 | 0) >>> 0 < 4 ? Ne + 1 | 0 : Ne, (0 | k) != (0 | Nr) | (0 | M) != (0 | Ne); ) ;
                        if ((T &= 3) | (k = 0)) for (; B[(M = pr + Pr | 0) + cr | 0] = m[E + pr | 0], ve = (pr = pr + 1 | 0) ? ve : ve + 1 | 0, Ne = jr, jr = Ne = (Br = Br + 1 | 0) ? Ne : Ne + 1 | 0, (0 | T) != (0 | Br) | (0 | k) != (0 | Ne); ) ;
                      }
                      return dr = ye + 288 | 0, 0;
                    }
                    function Ha(k, E, T, M, ye, Ne) {
                      var pr = 0;
                      o[Ne >> 2] = 8;
                      e: {
                        t: {
                          pr = k, pr = (k = !E & k >>> 0 <= 32768) ? 32768 : pr;
                          r: {
                            i: {
                              if (!(k = k ? 0 : E) & T >>> 5 >>> 0 <= pr >>> 0 | k) {
                                if (T >>> 0 >= 4096) break i;
                                E = 1;
                                break r;
                              }
                              if (o[ye >> 2] = 1, k = 1, (E = (pr >>> 0) / (o[Ne >> 2] << 2 >>> 0) | 0) >>> 0 < 4 || (k = 2, E >>> 0 < 8)) break e;
                              if (E >>> 0 < 16) return void (o[M >> 2] = 3);
                              if (E >>> 0 < 32) return void (o[M >> 2] = 4);
                              if (E >>> 0 < 64) return void (o[M >> 2] = 5);
                              if (E >>> 0 < 128) return void (o[M >> 2] = 6);
                              if (E >>> 0 < 256) return void (o[M >> 2] = 7);
                              if (E >>> 0 < 512) return void (o[M >> 2] = 8);
                              if (E >>> 0 < 1024) return void (o[M >> 2] = 9);
                              if (E >>> 0 < 2048) return void (o[M >> 2] = 10);
                              if (E >>> 0 < 4096) return void (o[M >> 2] = 11);
                              if (E >>> 0 < 8192) return void (o[M >> 2] = 12);
                              if (E >>> 0 < 16384) return void (o[M >> 2] = 13);
                              if (E >>> 0 < 32768) return void (o[M >> 2] = 14);
                              if (E >>> 0 < 65536) return void (o[M >> 2] = 15);
                              if (E >>> 0 < 131072) return void (o[M >> 2] = 16);
                              if (E >>> 0 < 262144) return void (o[M >> 2] = 17);
                              if (E >>> 0 < 524288) return void (o[M >> 2] = 18);
                              if (E >>> 0 < 1048576) return void (o[M >> 2] = 19);
                              if (E >>> 0 < 2097152) return void (o[M >> 2] = 20);
                              if (E >>> 0 < 4194304) return void (o[M >> 2] = 21);
                              if (E >>> 0 < 8388608) return void (o[M >> 2] = 22);
                              if (E >>> 0 < 16777216) return void (o[M >> 2] = 23);
                              if (E >>> 0 >= 33554432) break t;
                              return void (o[M >> 2] = 24);
                            }
                            E = 2, T >>> 0 < 8192 || (E = 3, T >>> 0 < 16384 || (E = 4, T >>> 0 < 32768 || (E = 5, T >>> 0 < 65536 || (E = 6, T >>> 0 < 131072 || (E = 7, T >>> 0 < 262144 || (E = 8, T >>> 0 < 524288 || (E = 9, T >>> 0 < 1048576 || (E = 10, T >>> 0 < 2097152 || (E = 11, T >>> 0 < 4194304 || (E = 12, T >>> 0 < 8388608 || (E = 13, T >>> 0 < 16777216 || (E = 14, T >>> 0 < 33554432 || (E = 15, T >>> 0 < 67108864 || (E = 16, T >>> 0 < 134217728 || (E = 17, T >>> 0 < 268435456 || (E = 18, T >>> 0 < 536870912 || (E = 19, T >>> 0 < 1073741824 || (E = (0 | T) >= 0 ? 20 : 21))))))))))))))))));
                          }
                          return T = E, o[M >> 2] = T, k = (E = k) >>> 2 | 0, E = (3 & E) << 30 | pr >>> 2, M = 31 & T, (63 & T) >>> 0 >= 32 ? (T = 0, k = k >>> M | 0) : (T = k >>> M | 0, k = ((1 << M) - 1 & k) << 32 - M | E >>> M), void (o[ye >> 2] = ((!T & k >>> 0 >= 1073741823 | T ? 1073741823 : k) >>> 0) / d[Ne >> 2]);
                        }
                        k = E >>> 0 < 67108864 ? 25 : 26;
                      }
                      o[M >> 2] = k;
                    }
                    function Cu(k, E, T) {
                      var M, ye, Ne, pr, ve, cr, gr, Pr, Nr = 0;
                      dr = M = dr - 160 | 0, o[k >> 2] = 1, o[k + 4 >> 2] = 0, o[k + 8 >> 2] = 0, o[k + 12 >> 2] = 0, o[k + 16 >> 2] = 0, o[k + 20 >> 2] = 0, o[k + 24 >> 2] = 0, o[k + 28 >> 2] = 0, o[k + 32 >> 2] = 0, o[k + 44 >> 2] = 0, o[k + 48 >> 2] = 0, o[k + 36 >> 2] = 0, o[k + 40 >> 2] = 1, o[k + 52 >> 2] = 0, o[k + 56 >> 2] = 0, o[k + 60 >> 2] = 0, o[k + 64 >> 2] = 0, o[k + 68 >> 2] = 0, o[k + 72 >> 2] = 0, o[k + 76 >> 2] = 0, o[k + 80 >> 2] = 1, Ca(k + 84 | 0, 0, 76), df(k, E, (255 & (1 ^ (Nr = T - ((T >> 31 & T) << 1) | 0))) - 1 >>> 31 | 0), df(k, E + 160 | 0, (255 & (2 ^ Nr)) - 1 >>> 31 | 0), df(k, E + 320 | 0, (255 & (3 ^ Nr)) - 1 >>> 31 | 0), df(k, E + 480 | 0, (255 & (4 ^ Nr)) - 1 >>> 31 | 0), df(k, E + 640 | 0, (255 & (5 ^ Nr)) - 1 >>> 31 | 0), df(k, E + 800 | 0, (255 & (6 ^ Nr)) - 1 >>> 31 | 0), df(k, E + 960 | 0, (255 & (7 ^ Nr)) - 1 >>> 31 | 0), df(k, E + 1120 | 0, (255 & (8 ^ Nr)) - 1 >>> 31 | 0), E = o[k + 76 >> 2], o[M + 32 >> 2] = o[k + 72 >> 2], o[M + 36 >> 2] = E, Nr = o[4 + (E = k - -64 | 0) >> 2], o[M + 24 >> 2] = o[E >> 2], o[M + 28 >> 2] = Nr, E = o[k + 60 >> 2], o[M + 16 >> 2] = o[k + 56 >> 2], o[M + 20 >> 2] = E, E = o[k + 52 >> 2], o[M + 8 >> 2] = o[k + 48 >> 2], o[M + 12 >> 2] = E, E = o[k + 44 >> 2], o[M >> 2] = o[k + 40 >> 2], o[M + 4 >> 2] = E, E = o[k + 36 >> 2], o[M + 72 >> 2] = o[k + 32 >> 2], o[M + 76 >> 2] = E, Nr = o[k + 28 >> 2], o[(E = M - -64 | 0) >> 2] = o[k + 24 >> 2], o[E + 4 >> 2] = Nr, E = o[k + 20 >> 2], o[M + 56 >> 2] = o[k + 16 >> 2], o[M + 60 >> 2] = E, E = o[k + 12 >> 2], o[M + 48 >> 2] = o[k + 8 >> 2], o[M + 52 >> 2] = E, E = o[k + 4 >> 2], o[M + 40 >> 2] = o[k >> 2], o[M + 44 >> 2] = E, E = o[k + 92 >> 2], o[M + 88 >> 2] = o[k + 88 >> 2], o[M + 92 >> 2] = E, E = o[k + 100 >> 2], o[M + 96 >> 2] = o[k + 96 >> 2], o[M + 100 >> 2] = E, E = o[k + 108 >> 2], o[M + 104 >> 2] = o[k + 104 >> 2], o[M + 108 >> 2] = E, E = o[k + 116 >> 2], o[M + 112 >> 2] = o[k + 112 >> 2], o[M + 116 >> 2] = E, E = o[k + 84 >> 2], o[M + 80 >> 2] = o[k + 80 >> 2], o[M + 84 >> 2] = E, E = o[k + 124 >> 2], Nr = o[k + 128 >> 2], ye = o[k + 132 >> 2], Ne = o[k + 136 >> 2], pr = o[k + 140 >> 2], ve = o[k + 144 >> 2], cr = o[k + 148 >> 2], gr = o[k + 152 >> 2], Pr = o[k + 120 >> 2], o[M + 156 >> 2] = 0 - o[k + 156 >> 2], o[M + 152 >> 2] = 0 - gr, o[M + 148 >> 2] = 0 - cr, o[M + 144 >> 2] = 0 - ve, o[M + 140 >> 2] = 0 - pr, o[M + 136 >> 2] = 0 - Ne, o[M + 132 >> 2] = 0 - ye, o[M + 128 >> 2] = 0 - Nr, o[M + 124 >> 2] = 0 - E, o[M + 120 >> 2] = 0 - Pr, df(k, M, (128 & T) >>> 7 | 0), dr = M + 160 | 0;
                    }
                    function gi(k, E) {
                      k |= 0, E |= 0;
                      var T, M, ye, Ne, pr, ve = 0, cr = 0, gr = 0;
                      return dr = cr = dr - 192 | 0, Sf(cr, 32), Zs(E, cr, 32, 0), B[0 | E] = 248 & m[0 | E], B[E + 31 | 0] = 63 & m[E + 31 | 0] | 64, e(gr = cr + 32 | 0, E), Rc(k, gr), T = cr, gr = o[cr + 28 >> 2], cr = o[cr + 24 >> 2], B[E + 24 | 0] = cr, B[E + 25 | 0] = cr >>> 8, B[E + 26 | 0] = cr >>> 16, B[E + 27 | 0] = cr >>> 24, B[E + 28 | 0] = gr, B[E + 29 | 0] = gr >>> 8, B[E + 30 | 0] = gr >>> 16, B[E + 31 | 0] = gr >>> 24, gr = o[T + 20 >> 2], cr = o[T + 16 >> 2], B[E + 16 | 0] = cr, B[E + 17 | 0] = cr >>> 8, B[E + 18 | 0] = cr >>> 16, B[E + 19 | 0] = cr >>> 24, B[E + 20 | 0] = gr, B[E + 21 | 0] = gr >>> 8, B[E + 22 | 0] = gr >>> 16, B[E + 23 | 0] = gr >>> 24, gr = o[T + 12 >> 2], cr = o[T + 8 >> 2], B[E + 8 | 0] = cr, B[E + 9 | 0] = cr >>> 8, B[E + 10 | 0] = cr >>> 16, B[E + 11 | 0] = cr >>> 24, B[E + 12 | 0] = gr, B[E + 13 | 0] = gr >>> 8, B[E + 14 | 0] = gr >>> 16, B[E + 15 | 0] = gr >>> 24, gr = o[T + 4 >> 2], cr = o[T >> 2], B[0 | E] = cr, B[E + 1 | 0] = cr >>> 8, B[E + 2 | 0] = cr >>> 16, B[E + 3 | 0] = cr >>> 24, B[E + 4 | 0] = gr, B[E + 5 | 0] = gr >>> 8, B[E + 6 | 0] = gr >>> 16, B[E + 7 | 0] = gr >>> 24, M = m[(ve = k) + 8 | 0] | m[ve + 9 | 0] << 8 | m[ve + 10 | 0] << 16 | m[ve + 11 | 0] << 24, ye = m[ve + 12 | 0] | m[ve + 13 | 0] << 8 | m[ve + 14 | 0] << 16 | m[ve + 15 | 0] << 24, Ne = m[ve + 16 | 0] | m[ve + 17 | 0] << 8 | m[ve + 18 | 0] << 16 | m[ve + 19 | 0] << 24, gr = m[ve + 20 | 0] | m[ve + 21 | 0] << 8 | m[ve + 22 | 0] << 16 | m[ve + 23 | 0] << 24, cr = m[0 | ve] | m[ve + 1 | 0] << 8 | m[ve + 2 | 0] << 16 | m[ve + 3 | 0] << 24, k = m[ve + 4 | 0] | m[ve + 5 | 0] << 8 | m[ve + 6 | 0] << 16 | m[ve + 7 | 0] << 24, pr = m[ve + 28 | 0] | m[ve + 29 | 0] << 8 | m[ve + 30 | 0] << 16 | m[ve + 31 | 0] << 24, ve = m[ve + 24 | 0] | m[ve + 25 | 0] << 8 | m[ve + 26 | 0] << 16 | m[ve + 27 | 0] << 24, B[E + 56 | 0] = ve, B[E + 57 | 0] = ve >>> 8, B[E + 58 | 0] = ve >>> 16, B[E + 59 | 0] = ve >>> 24, B[E + 60 | 0] = pr, B[E + 61 | 0] = pr >>> 8, B[E + 62 | 0] = pr >>> 16, B[E + 63 | 0] = pr >>> 24, B[E + 48 | 0] = Ne, B[E + 49 | 0] = Ne >>> 8, B[E + 50 | 0] = Ne >>> 16, B[E + 51 | 0] = Ne >>> 24, B[E + 52 | 0] = gr, B[E + 53 | 0] = gr >>> 8, B[E + 54 | 0] = gr >>> 16, B[E + 55 | 0] = gr >>> 24, B[E + 40 | 0] = M, B[E + 41 | 0] = M >>> 8, B[E + 42 | 0] = M >>> 16, B[E + 43 | 0] = M >>> 24, B[E + 44 | 0] = ye, B[E + 45 | 0] = ye >>> 8, B[E + 46 | 0] = ye >>> 16, B[E + 47 | 0] = ye >>> 24, B[E + 32 | 0] = cr, B[E + 33 | 0] = cr >>> 8, B[E + 34 | 0] = cr >>> 16, B[E + 35 | 0] = cr >>> 24, B[E + 36 | 0] = k, B[E + 37 | 0] = k >>> 8, B[E + 38 | 0] = k >>> 16, B[E + 39 | 0] = k >>> 24, _s(T, 32), dr = T + 192 | 0, 0;
                    }
                    function wn(k, E) {
                      E |= 0;
                      var T, M, ye = 0, Ne = 0, pr = 0, ve = 0;
                      return dr = T = dr - 288 | 0, Ne = 40 + ((ye = o[32 + (k |= 0) >> 2] >>> 3 & 63) + k | 0) | 0, ye >>> 0 >= 56 ? (fa(Ne, 35520, 64 - ye | 0), Vn(k, k + 40 | 0, T, T + 256 | 0), o[k + 88 >> 2] = 0, o[k + 92 >> 2] = 0, o[k + 80 >> 2] = 0, o[k + 84 >> 2] = 0, o[k + 72 >> 2] = 0, o[k + 76 >> 2] = 0, o[(ye = k - -64 | 0) >> 2] = 0, o[ye + 4 >> 2] = 0, o[k + 56 >> 2] = 0, o[k + 60 >> 2] = 0, o[k + 48 >> 2] = 0, o[k + 52 >> 2] = 0, o[k + 40 >> 2] = 0, o[k + 44 >> 2] = 0) : fa(Ne, 35520, 56 - ye | 0), pr = (ye = 16711680 & (Ne = o[k + 32 >> 2])) >>> 8 | 0, ve = ye << 24, M = (ye = -16777216 & Ne) >>> 24 | 0, ye = (ve |= ye << 8) | -16777216 & ((255 & (ye = o[k + 36 >> 2])) << 24 | Ne >>> 8) | 16711680 & ((16777215 & ye) << 8 | Ne >>> 24) | ye >>> 8 & 65280 | ye >>> 24, B[k + 96 | 0] = ye, B[k + 97 | 0] = ye >>> 8, B[k + 98 | 0] = ye >>> 16, B[k + 99 | 0] = ye >>> 24, ye = pr | M | Ne << 24 | (65280 & Ne) << 8, ye |= pr = 0, B[k + 100 | 0] = ye, B[k + 101 | 0] = ye >>> 8, B[k + 102 | 0] = ye >>> 16, B[k + 103 | 0] = ye >>> 24, Vn(k, k + 40 | 0, T, T + 256 | 0), ye = (ye = o[k >> 2]) << 24 | (65280 & ye) << 8 | ye >>> 8 & 65280 | ye >>> 24, B[0 | E] = ye, B[E + 1 | 0] = ye >>> 8, B[E + 2 | 0] = ye >>> 16, B[E + 3 | 0] = ye >>> 24, ye = (ye = o[k + 4 >> 2]) << 24 | (65280 & ye) << 8 | ye >>> 8 & 65280 | ye >>> 24, B[E + 4 | 0] = ye, B[E + 5 | 0] = ye >>> 8, B[E + 6 | 0] = ye >>> 16, B[E + 7 | 0] = ye >>> 24, ye = (ye = o[k + 8 >> 2]) << 24 | (65280 & ye) << 8 | ye >>> 8 & 65280 | ye >>> 24, B[E + 8 | 0] = ye, B[E + 9 | 0] = ye >>> 8, B[E + 10 | 0] = ye >>> 16, B[E + 11 | 0] = ye >>> 24, ye = (ye = o[k + 12 >> 2]) << 24 | (65280 & ye) << 8 | ye >>> 8 & 65280 | ye >>> 24, B[E + 12 | 0] = ye, B[E + 13 | 0] = ye >>> 8, B[E + 14 | 0] = ye >>> 16, B[E + 15 | 0] = ye >>> 24, ye = (ye = o[k + 16 >> 2]) << 24 | (65280 & ye) << 8 | ye >>> 8 & 65280 | ye >>> 24, B[E + 16 | 0] = ye, B[E + 17 | 0] = ye >>> 8, B[E + 18 | 0] = ye >>> 16, B[E + 19 | 0] = ye >>> 24, ye = (ye = o[k + 20 >> 2]) << 24 | (65280 & ye) << 8 | ye >>> 8 & 65280 | ye >>> 24, B[E + 20 | 0] = ye, B[E + 21 | 0] = ye >>> 8, B[E + 22 | 0] = ye >>> 16, B[E + 23 | 0] = ye >>> 24, ye = (ye = o[k + 24 >> 2]) << 24 | (65280 & ye) << 8 | ye >>> 8 & 65280 | ye >>> 24, B[E + 24 | 0] = ye, B[E + 25 | 0] = ye >>> 8, B[E + 26 | 0] = ye >>> 16, B[E + 27 | 0] = ye >>> 24, ye = (ye = o[k + 28 >> 2]) << 24 | (65280 & ye) << 8 | ye >>> 8 & 65280 | ye >>> 24, B[E + 28 | 0] = ye, B[E + 29 | 0] = ye >>> 8, B[E + 30 | 0] = ye >>> 16, B[E + 31 | 0] = ye >>> 24, _s(T, 288), _s(k, 104), dr = T + 288 | 0, 0;
                    }
                    function no(k, E) {
                      k |= 0;
                      var T, M = 0;
                      dr = T = dr + -64 | 0, M = m[60 + (E |= 0) | 0] | m[E + 61 | 0] << 8 | m[E + 62 | 0] << 16 | m[E + 63 | 0] << 24, o[T + 56 >> 2] = m[E + 56 | 0] | m[E + 57 | 0] << 8 | m[E + 58 | 0] << 16 | m[E + 59 | 0] << 24, o[T + 60 >> 2] = M, M = m[E + 52 | 0] | m[E + 53 | 0] << 8 | m[E + 54 | 0] << 16 | m[E + 55 | 0] << 24, o[T + 48 >> 2] = m[E + 48 | 0] | m[E + 49 | 0] << 8 | m[E + 50 | 0] << 16 | m[E + 51 | 0] << 24, o[T + 52 >> 2] = M, M = m[E + 44 | 0] | m[E + 45 | 0] << 8 | m[E + 46 | 0] << 16 | m[E + 47 | 0] << 24, o[T + 40 >> 2] = m[E + 40 | 0] | m[E + 41 | 0] << 8 | m[E + 42 | 0] << 16 | m[E + 43 | 0] << 24, o[T + 44 >> 2] = M, M = m[E + 36 | 0] | m[E + 37 | 0] << 8 | m[E + 38 | 0] << 16 | m[E + 39 | 0] << 24, o[T + 32 >> 2] = m[E + 32 | 0] | m[E + 33 | 0] << 8 | m[E + 34 | 0] << 16 | m[E + 35 | 0] << 24, o[T + 36 >> 2] = M, M = m[E + 28 | 0] | m[E + 29 | 0] << 8 | m[E + 30 | 0] << 16 | m[E + 31 | 0] << 24, o[T + 24 >> 2] = m[E + 24 | 0] | m[E + 25 | 0] << 8 | m[E + 26 | 0] << 16 | m[E + 27 | 0] << 24, o[T + 28 >> 2] = M, M = m[E + 20 | 0] | m[E + 21 | 0] << 8 | m[E + 22 | 0] << 16 | m[E + 23 | 0] << 24, o[T + 16 >> 2] = m[E + 16 | 0] | m[E + 17 | 0] << 8 | m[E + 18 | 0] << 16 | m[E + 19 | 0] << 24, o[T + 20 >> 2] = M, M = m[E + 4 | 0] | m[E + 5 | 0] << 8 | m[E + 6 | 0] << 16 | m[E + 7 | 0] << 24, o[T >> 2] = m[0 | E] | m[E + 1 | 0] << 8 | m[E + 2 | 0] << 16 | m[E + 3 | 0] << 24, o[T + 4 >> 2] = M, M = m[E + 12 | 0] | m[E + 13 | 0] << 8 | m[E + 14 | 0] << 16 | m[E + 15 | 0] << 24, o[T + 8 >> 2] = m[E + 8 | 0] | m[E + 9 | 0] << 8 | m[E + 10 | 0] << 16 | m[E + 11 | 0] << 24, o[T + 12 >> 2] = M, Si(T), E = o[T + 28 >> 2], M = o[T + 24 >> 2], B[k + 24 | 0] = M, B[k + 25 | 0] = M >>> 8, B[k + 26 | 0] = M >>> 16, B[k + 27 | 0] = M >>> 24, B[k + 28 | 0] = E, B[k + 29 | 0] = E >>> 8, B[k + 30 | 0] = E >>> 16, B[k + 31 | 0] = E >>> 24, E = o[T + 20 >> 2], M = o[T + 16 >> 2], B[k + 16 | 0] = M, B[k + 17 | 0] = M >>> 8, B[k + 18 | 0] = M >>> 16, B[k + 19 | 0] = M >>> 24, B[k + 20 | 0] = E, B[k + 21 | 0] = E >>> 8, B[k + 22 | 0] = E >>> 16, B[k + 23 | 0] = E >>> 24, E = o[T + 12 >> 2], M = o[T + 8 >> 2], B[k + 8 | 0] = M, B[k + 9 | 0] = M >>> 8, B[k + 10 | 0] = M >>> 16, B[k + 11 | 0] = M >>> 24, B[k + 12 | 0] = E, B[k + 13 | 0] = E >>> 8, B[k + 14 | 0] = E >>> 16, B[k + 15 | 0] = E >>> 24, E = o[T + 4 >> 2], M = o[T >> 2], B[0 | k] = M, B[k + 1 | 0] = M >>> 8, B[k + 2 | 0] = M >>> 16, B[k + 3 | 0] = M >>> 24, B[k + 4 | 0] = E, B[k + 5 | 0] = E >>> 8, B[k + 6 | 0] = E >>> 16, B[k + 7 | 0] = E >>> 24, _s(T, 64), dr = T - -64 | 0;
                    }
                    function Co(k, E, T) {
                      k |= 0, E |= 0;
                      var M, ye = 0, Ne = 0, pr = 0, ve = 0, cr = 0, gr = 0, Pr = 0, Nr = 0;
                      if (dr = M = dr - 96 | 0, (T |= 0) >>> 0 >= 65 && (Gu(k), Mf(k, E, T, 0), wn(k, M), T = 32, E = M), Gu(k), o[M + 88 >> 2] = 909522486, o[M + 92 >> 2] = 909522486, o[M + 80 >> 2] = 909522486, o[M + 84 >> 2] = 909522486, o[M + 72 >> 2] = 909522486, o[M + 76 >> 2] = 909522486, o[(pr = Pr = M - -64 | 0) >> 2] = 909522486, o[pr + 4 >> 2] = 909522486, o[M + 56 >> 2] = 909522486, o[M + 60 >> 2] = 909522486, o[M + 48 >> 2] = 909522486, o[M + 52 >> 2] = 909522486, o[M + 40 >> 2] = 909522486, o[M + 44 >> 2] = 909522486, o[M + 32 >> 2] = 909522486, o[M + 36 >> 2] = 909522486, T) {
                        if (T >>> 0 >= 4) for (ve = 124 & T; B[0 | (Ne = (pr = M + 32 | 0) + ye | 0)] = m[0 | Ne] ^ m[E + ye | 0], B[0 | (Nr = (Ne = 1 | ye) + pr | 0)] = m[0 | Nr] ^ m[E + Ne | 0], B[0 | (Nr = (Ne = 2 | ye) + pr | 0)] = m[0 | Nr] ^ m[E + Ne | 0], B[0 | (Ne = (Ne = pr) + (pr = 3 | ye) | 0)] = m[0 | Ne] ^ m[E + pr | 0], ye = ye + 4 | 0, (0 | ve) != (0 | (cr = cr + 4 | 0)); ) ;
                        if (cr = 3 & T) for (; B[0 | (pr = (M + 32 | 0) + ye | 0)] = m[0 | pr] ^ m[E + ye | 0], ye = ye + 1 | 0, (0 | cr) != (0 | (gr = gr + 1 | 0)); ) ;
                      }
                      if (Mf(k, M + 32 | 0, 64, 0), Gu(pr = k + 104 | 0), o[M + 88 >> 2] = 1549556828, o[M + 92 >> 2] = 1549556828, o[M + 80 >> 2] = 1549556828, o[M + 84 >> 2] = 1549556828, o[M + 72 >> 2] = 1549556828, o[M + 76 >> 2] = 1549556828, o[Pr >> 2] = 1549556828, o[Pr + 4 >> 2] = 1549556828, o[M + 56 >> 2] = 1549556828, o[M + 60 >> 2] = 1549556828, o[M + 48 >> 2] = 1549556828, o[M + 52 >> 2] = 1549556828, o[M + 40 >> 2] = 1549556828, o[M + 44 >> 2] = 1549556828, o[M + 32 >> 2] = 1549556828, o[M + 36 >> 2] = 1549556828, T) {
                        if (gr = 0, ye = 0, T >>> 0 >= 4) for (Pr = 124 & T, cr = 0; B[0 | (ve = (k = M + 32 | 0) + ye | 0)] = m[0 | ve] ^ m[E + ye | 0], B[0 | (Ne = (ve = 1 | ye) + k | 0)] = m[0 | Ne] ^ m[E + ve | 0], B[0 | (Ne = (ve = 2 | ye) + k | 0)] = m[0 | Ne] ^ m[E + ve | 0], B[0 | (ve = (Ne = k) + (k = 3 | ye) | 0)] = m[0 | ve] ^ m[k + E | 0], ye = ye + 4 | 0, (0 | Pr) != (0 | (cr = cr + 4 | 0)); ) ;
                        if (k = 3 & T) for (; B[0 | (T = (M + 32 | 0) + ye | 0)] = m[0 | T] ^ m[E + ye | 0], ye = ye + 1 | 0, (0 | k) != (0 | (gr = gr + 1 | 0)); ) ;
                      }
                      return Mf(pr, k = M + 32 | 0, 64, 0), _s(k, 64), _s(M, 32), dr = M + 96 | 0, 0;
                    }
                    function Ko(k, E, T, M, ye, Ne, pr) {
                      var ve = 0, cr = 0, gr = 0, Pr = 0, Nr = 0, Br = 0, Mr = 0;
                      if (E - 65 >>> 0 < 4294967232 | pr >>> 0 > 64) k = -1;
                      else {
                        Br = ve = dr, dr = ve = ve - 512 & -64;
                        e: {
                          t: if (!(!(!(M | ye) | T) | !k | ((cr = 255 & E) - 65 & 255) >>> 0 <= 191 | !(!(E = 255 & pr) || Ne) | E >>> 0 >= 65)) {
                            if (E) {
                              if (!Ne) break t;
                              Ca(ve - -64 | 0, 0, 293), o[ve + 56 >> 2] = 327033209, o[ve + 60 >> 2] = 1541459225, o[ve + 48 >> 2] = -79577749, o[ve + 52 >> 2] = 528734635, o[ve + 40 >> 2] = 725511199, o[ve + 44 >> 2] = -1694144372, o[ve + 32 >> 2] = -1377402159, o[ve + 36 >> 2] = 1359893119, o[ve + 24 >> 2] = 1595750129, o[ve + 28 >> 2] = -1521486534, o[ve + 16 >> 2] = -23791573, o[ve + 20 >> 2] = 1013904242, o[ve + 8 >> 2] = -2067093701, o[ve + 12 >> 2] = -1150833019, o[ve >> 2] = -222443256 ^ (E << 8 | cr), o[ve + 4 >> 2] = E >>> 24 ^ 1779033703, Ca((pr = ve + 384 | 0) + E | 0, 0, 128 - E | 0), fa(pr, Ne, E), fa(ve + 96 | 0, pr, 128), o[ve + 352 >> 2] = 128, _s(pr, 128), E = 128;
                            } else Ca(ve - -64 | 0, 0, 293), o[ve + 56 >> 2] = 327033209, o[ve + 60 >> 2] = 1541459225, o[ve + 48 >> 2] = -79577749, o[ve + 52 >> 2] = 528734635, o[ve + 40 >> 2] = 725511199, o[ve + 44 >> 2] = -1694144372, o[ve + 32 >> 2] = -1377402159, o[ve + 36 >> 2] = 1359893119, o[ve + 24 >> 2] = 1595750129, o[ve + 28 >> 2] = -1521486534, o[ve + 16 >> 2] = -23791573, o[ve + 20 >> 2] = 1013904242, o[ve + 8 >> 2] = -2067093701, o[ve + 12 >> 2] = -1150833019, o[ve >> 2] = -222443256 ^ cr, o[ve + 4 >> 2] = 1779033703, E = 0;
                            r: if (M | ye) for (Mr = ve + 224 | 0, gr = ve + 96 | 0; ; ) {
                              if (pr = E + gr | 0, !ye & M >>> 0 <= (Ne = 256 - E | 0) >>> 0) {
                                fa(pr, T, M), o[ve + 352 >> 2] = M + o[ve + 352 >> 2];
                                break r;
                              }
                              if (fa(pr, T, Ne), o[ve + 352 >> 2] = Ne + o[ve + 352 >> 2], Pr = E = o[ve + 68 >> 2], E = (Nr = (pr = o[ve + 64 >> 2]) + 128 | 0) >>> 0 < 128 ? E + 1 | 0 : E, o[ve + 64 >> 2] = Nr, o[ve + 68 >> 2] = E, E = o[ve + 76 >> 2], E = (Pr = pr = (0 | Pr) == -1 & pr >>> 0 > 4294967167) >>> 0 > (pr = pr + o[ve + 72 >> 2] | 0) >>> 0 ? E + 1 | 0 : E, o[ve + 72 >> 2] = pr, o[ve + 76 >> 2] = E, Fr(ve, gr), fa(gr, Mr, 128), E = o[ve + 352 >> 2] - 128 | 0, o[ve + 352 >> 2] = E, T = T + Ne | 0, !((ye = ye - (M >>> 0 < Ne >>> 0) | 0) | (M = M - Ne | 0))) break;
                            }
                            Wo(ve, k, cr), dr = Br;
                            break e;
                          }
                          Wa(), ji();
                        }
                        k = 0;
                      }
                      return k;
                    }
                    function jo(k, E) {
                      k |= 0, E |= 0;
                      var T, M = 0;
                      dr = T = dr - 128 | 0, o[T + 80 >> 2] = 0, o[T + 84 >> 2] = 0, o[T + 88 >> 2] = 0, o[T + 92 >> 2] = 0, o[T + 40 >> 2] = 0, o[T + 44 >> 2] = 0, o[T + 48 >> 2] = 0, o[T + 52 >> 2] = 0, o[T + 56 >> 2] = 0, o[T + 60 >> 2] = 0, M = o[8799], o[T + 104 >> 2] = o[8798], o[T + 108 >> 2] = M, M = o[8801], o[T + 112 >> 2] = o[8800], o[T + 116 >> 2] = M, M = o[8803], o[T + 120 >> 2] = o[8802], o[T + 124 >> 2] = M, o[T + 64 >> 2] = 0, o[T + 68 >> 2] = 0, o[T + 72 >> 2] = 0, o[T + 76 >> 2] = 0, B[T + 64 | 0] = 1, o[T + 32 >> 2] = 0, o[T + 36 >> 2] = 0, M = o[8797], o[T + 96 >> 2] = o[8796], o[T + 100 >> 2] = M, M = m[E + 28 | 0] | m[E + 29 | 0] << 8 | m[E + 30 | 0] << 16 | m[E + 31 | 0] << 24, o[T + 24 >> 2] = m[E + 24 | 0] | m[E + 25 | 0] << 8 | m[E + 26 | 0] << 16 | m[E + 27 | 0] << 24, o[T + 28 >> 2] = M, M = m[E + 20 | 0] | m[E + 21 | 0] << 8 | m[E + 22 | 0] << 16 | m[E + 23 | 0] << 24, o[T + 16 >> 2] = m[E + 16 | 0] | m[E + 17 | 0] << 8 | m[E + 18 | 0] << 16 | m[E + 19 | 0] << 24, o[T + 20 >> 2] = M, M = m[E + 12 | 0] | m[E + 13 | 0] << 8 | m[E + 14 | 0] << 16 | m[E + 15 | 0] << 24, o[T + 8 >> 2] = m[E + 8 | 0] | m[E + 9 | 0] << 8 | m[E + 10 | 0] << 16 | m[E + 11 | 0] << 24, o[T + 12 >> 2] = M, M = m[E + 4 | 0] | m[E + 5 | 0] << 8 | m[E + 6 | 0] << 16 | m[E + 7 | 0] << 24, o[T >> 2] = m[0 | E] | m[E + 1 | 0] << 8 | m[E + 2 | 0] << 16 | m[E + 3 | 0] << 24, o[T + 4 >> 2] = M, Th(E = T - -64 | 0, T), Si(E), E = o[T + 92 >> 2], M = o[T + 88 >> 2], B[k + 24 | 0] = M, B[k + 25 | 0] = M >>> 8, B[k + 26 | 0] = M >>> 16, B[k + 27 | 0] = M >>> 24, B[k + 28 | 0] = E, B[k + 29 | 0] = E >>> 8, B[k + 30 | 0] = E >>> 16, B[k + 31 | 0] = E >>> 24, E = o[T + 84 >> 2], M = o[T + 80 >> 2], B[k + 16 | 0] = M, B[k + 17 | 0] = M >>> 8, B[k + 18 | 0] = M >>> 16, B[k + 19 | 0] = M >>> 24, B[k + 20 | 0] = E, B[k + 21 | 0] = E >>> 8, B[k + 22 | 0] = E >>> 16, B[k + 23 | 0] = E >>> 24, E = o[T + 76 >> 2], M = o[T + 72 >> 2], B[k + 8 | 0] = M, B[k + 9 | 0] = M >>> 8, B[k + 10 | 0] = M >>> 16, B[k + 11 | 0] = M >>> 24, B[k + 12 | 0] = E, B[k + 13 | 0] = E >>> 8, B[k + 14 | 0] = E >>> 16, B[k + 15 | 0] = E >>> 24, E = o[T + 68 >> 2], M = o[T + 64 >> 2], B[0 | k] = M, B[k + 1 | 0] = M >>> 8, B[k + 2 | 0] = M >>> 16, B[k + 3 | 0] = M >>> 24, B[k + 4 | 0] = E, B[k + 5 | 0] = E >>> 8, B[k + 6 | 0] = E >>> 16, B[k + 7 | 0] = E >>> 24, dr = T + 128 | 0;
                    }
                    function ss(k, E) {
                      k |= 0, E |= 0;
                      var T, M = 0;
                      dr = T = dr - 128 | 0, o[T + 80 >> 2] = 0, o[T + 84 >> 2] = 0, o[T + 88 >> 2] = 0, o[T + 92 >> 2] = 0, o[T + 40 >> 2] = 0, o[T + 44 >> 2] = 0, o[T + 48 >> 2] = 0, o[T + 52 >> 2] = 0, o[T + 56 >> 2] = 0, o[T + 60 >> 2] = 0, M = o[8799], o[T + 104 >> 2] = o[8798], o[T + 108 >> 2] = M, M = o[8801], o[T + 112 >> 2] = o[8800], o[T + 116 >> 2] = M, M = o[8803], o[T + 120 >> 2] = o[8802], o[T + 124 >> 2] = M, o[T + 64 >> 2] = 0, o[T + 68 >> 2] = 0, o[T + 72 >> 2] = 0, o[T + 76 >> 2] = 0, o[T + 32 >> 2] = 0, o[T + 36 >> 2] = 0, M = o[8797], o[T + 96 >> 2] = o[8796], o[T + 100 >> 2] = M, M = m[E + 20 | 0] | m[E + 21 | 0] << 8 | m[E + 22 | 0] << 16 | m[E + 23 | 0] << 24, o[T + 16 >> 2] = m[E + 16 | 0] | m[E + 17 | 0] << 8 | m[E + 18 | 0] << 16 | m[E + 19 | 0] << 24, o[T + 20 >> 2] = M, M = m[E + 28 | 0] | m[E + 29 | 0] << 8 | m[E + 30 | 0] << 16 | m[E + 31 | 0] << 24, o[T + 24 >> 2] = m[E + 24 | 0] | m[E + 25 | 0] << 8 | m[E + 26 | 0] << 16 | m[E + 27 | 0] << 24, o[T + 28 >> 2] = M, M = m[E + 4 | 0] | m[E + 5 | 0] << 8 | m[E + 6 | 0] << 16 | m[E + 7 | 0] << 24, o[T >> 2] = m[0 | E] | m[E + 1 | 0] << 8 | m[E + 2 | 0] << 16 | m[E + 3 | 0] << 24, o[T + 4 >> 2] = M, M = m[E + 12 | 0] | m[E + 13 | 0] << 8 | m[E + 14 | 0] << 16 | m[E + 15 | 0] << 24, o[T + 8 >> 2] = m[E + 8 | 0] | m[E + 9 | 0] << 8 | m[E + 10 | 0] << 16 | m[E + 11 | 0] << 24, o[T + 12 >> 2] = M, Th(E = T - -64 | 0, T), Si(E), E = o[T + 92 >> 2], M = o[T + 88 >> 2], B[k + 24 | 0] = M, B[k + 25 | 0] = M >>> 8, B[k + 26 | 0] = M >>> 16, B[k + 27 | 0] = M >>> 24, B[k + 28 | 0] = E, B[k + 29 | 0] = E >>> 8, B[k + 30 | 0] = E >>> 16, B[k + 31 | 0] = E >>> 24, E = o[T + 84 >> 2], M = o[T + 80 >> 2], B[k + 16 | 0] = M, B[k + 17 | 0] = M >>> 8, B[k + 18 | 0] = M >>> 16, B[k + 19 | 0] = M >>> 24, B[k + 20 | 0] = E, B[k + 21 | 0] = E >>> 8, B[k + 22 | 0] = E >>> 16, B[k + 23 | 0] = E >>> 24, E = o[T + 76 >> 2], M = o[T + 72 >> 2], B[k + 8 | 0] = M, B[k + 9 | 0] = M >>> 8, B[k + 10 | 0] = M >>> 16, B[k + 11 | 0] = M >>> 24, B[k + 12 | 0] = E, B[k + 13 | 0] = E >>> 8, B[k + 14 | 0] = E >>> 16, B[k + 15 | 0] = E >>> 24, E = o[T + 68 >> 2], M = o[T + 64 >> 2], B[0 | k] = M, B[k + 1 | 0] = M >>> 8, B[k + 2 | 0] = M >>> 16, B[k + 3 | 0] = M >>> 24, B[k + 4 | 0] = E, B[k + 5 | 0] = E >>> 8, B[k + 6 | 0] = E >>> 16, B[k + 7 | 0] = E >>> 24, dr = T + 128 | 0;
                    }
                    function Ms(k, E, T, M) {
                      var ye = 0, Ne = 0, pr = 0, ve = 0, cr = 0, gr = 0, Pr = 0, Nr = 0, Br = 0, Mr = 0, jr = 0, ti = 0;
                      e: {
                        if ((Ne = o[k + 56 >> 2]) | (ye = o[k + 60 >> 2])) {
                          if (Nr = ve = 16 - Ne | 0, gr = (ve = (0 | (pr = 0 - ((Ne >>> 0 > 16) + ye | 0) | 0)) == (0 | M) & T >>> 0 > ve >>> 0 | M >>> 0 > pr >>> 0) ? Nr : T, Nr = ve = ve ? pr : M, ve | gr) {
                            if (ve = k - -64 | 0, pr = 0, Ne = 0, !Nr & gr >>> 0 >= 4 | Nr) for (Pr = -4 & gr; ye = pr + o[k + 56 >> 2] | 0, B[ye + ve | 0] = m[E + pr | 0], ye = (Br = 1 | pr) + o[k + 56 >> 2] | 0, B[ye + ve | 0] = m[E + Br | 0], ye = (Br = 2 | pr) + o[k + 56 >> 2] | 0, B[ye + ve | 0] = m[E + Br | 0], ye = (Br = 3 | pr) + o[k + 56 >> 2] | 0, B[ye + ve | 0] = m[E + Br | 0], ye = Ne, Ne = (pr = pr + 4 | 0) >>> 0 < 4 ? ye + 1 | 0 : ye, ye = jr, jr = ye = (cr = cr + 4 | 0) >>> 0 < 4 ? ye + 1 | 0 : ye, (0 | cr) != (0 | Pr) | (0 | Nr) != (0 | ye); ) ;
                            if (jr = ye = 0, ye | (cr = 3 & gr)) for (; ye = pr + o[k + 56 >> 2] | 0, B[ye + ve | 0] = m[E + pr | 0], Ne = (pr = pr + 1 | 0) ? Ne : Ne + 1 | 0, ye = ti, ti = ye = (Mr = Mr + 1 | 0) ? ye : ye + 1 | 0, (0 | cr) != (0 | Mr) | (0 | jr) != (0 | ye); ) ;
                            Ne = o[k + 56 >> 2], ye = o[k + 60 >> 2];
                          }
                          if (ye = ye + Nr | 0, ye = (Ne = Ne + gr | 0) >>> 0 < gr >>> 0 ? ye + 1 | 0 : ye, o[k + 56 >> 2] = Ne, o[k + 60 >> 2] = ye, !ye & Ne >>> 0 < 16) break e;
                          ta(k, k - -64 | 0, 16, 0), o[k + 56 >> 2] = 0, o[k + 60 >> 2] = 0, T = (Ne = T) - gr | 0, M = M - ((Ne >>> 0 < gr >>> 0) + Nr | 0) | 0, E = E + gr | 0;
                        }
                        if (!M & T >>> 0 >= 16 | M && (ta(k, E, Ne = -16 & T, M), T &= 15, M = 0, E = E + Ne | 0), T | M) {
                          if (ve = k - -64 | 0, Mr = 0, ti = 0, pr = 0, Ne = 0, !M & T >>> 0 >= 4 | M) for (gr = 12 & T, Nr = 0, cr = 0; ye = pr + o[k + 56 >> 2] | 0, B[ye + ve | 0] = m[E + pr | 0], ye = (Pr = 1 | pr) + o[k + 56 >> 2] | 0, B[ye + ve | 0] = m[E + Pr | 0], ye = (Pr = 2 | pr) + o[k + 56 >> 2] | 0, B[ye + ve | 0] = m[E + Pr | 0], ye = (Pr = 3 | pr) + o[k + 56 >> 2] | 0, B[ye + ve | 0] = m[E + Pr | 0], Ne = (pr = pr + 4 | 0) >>> 0 < 4 ? Ne + 1 | 0 : Ne, ye = jr, jr = ye = (cr = cr + 4 | 0) >>> 0 < 4 ? ye + 1 | 0 : ye, (0 | gr) != (0 | cr) | (0 | Nr) != (0 | ye); ) ;
                          if (jr = ye = 0, ye | (cr = 3 & T)) for (; ye = pr + o[k + 56 >> 2] | 0, B[ye + ve | 0] = m[E + pr | 0], Ne = (pr = pr + 1 | 0) ? Ne : Ne + 1 | 0, ye = ti, ti = ye = (Mr = Mr + 1 | 0) ? ye : ye + 1 | 0, (0 | cr) != (0 | Mr) | (0 | jr) != (0 | ye); ) ;
                          Ne = M + o[k + 60 >> 2] | 0, Ne = (E = T + o[k + 56 >> 2] | 0) >>> 0 < T >>> 0 ? Ne + 1 | 0 : Ne, o[k + 56 >> 2] = E, o[k + 60 >> 2] = Ne;
                        }
                      }
                    }
                    function Ws(k, E, T) {
                      var M, ye = 0, Ne = 0, pr = 0, ve = 0, cr = 0, gr = 0, Pr = 0, Nr = 0, Br = 0, Mr = 0, jr = 0, ti = 0, fi = 0, Jr = 0, li = 0, Tr = 0, Mi = 0, Wi = 0, vn = 0;
                      ti = o[E + 4 >> 2], ye = o[k + 4 >> 2], fi = o[E + 8 >> 2], Ne = o[k + 8 >> 2], Jr = o[E + 12 >> 2], pr = o[k + 12 >> 2], li = o[E + 16 >> 2], ve = o[k + 16 >> 2], Tr = o[E + 20 >> 2], cr = o[k + 20 >> 2], Mr = o[E + 24 >> 2], gr = o[k + 24 >> 2], Mi = o[E + 28 >> 2], Pr = o[k + 28 >> 2], Wi = o[E + 32 >> 2], Nr = o[k + 32 >> 2], vn = o[E + 36 >> 2], Br = o[k + 36 >> 2], T = 0 - T | 0, jr = o[k >> 2], o[k >> 2] = T & (jr ^ o[E >> 2]) ^ jr, o[k + 36 >> 2] = Br ^ T & (Br ^ vn), o[k + 32 >> 2] = Nr ^ T & (Nr ^ Wi), o[k + 28 >> 2] = Pr ^ T & (Pr ^ Mi), o[k + 24 >> 2] = gr ^ T & (gr ^ Mr), o[k + 20 >> 2] = cr ^ T & (cr ^ Tr), o[k + 16 >> 2] = ve ^ T & (ve ^ li), o[k + 12 >> 2] = pr ^ T & (pr ^ Jr), o[k + 8 >> 2] = Ne ^ T & (Ne ^ fi), o[k + 4 >> 2] = ye ^ T & (ye ^ ti), ye = o[k + 44 >> 2], ti = o[E + 44 >> 2], Ne = o[k + 48 >> 2], fi = o[E + 48 >> 2], pr = o[k + 52 >> 2], Jr = o[E + 52 >> 2], ve = o[k + 56 >> 2], li = o[E + 56 >> 2], cr = o[k + 60 >> 2], Tr = o[E + 60 >> 2], gr = o[(Mr = k - -64 | 0) >> 2], Mi = o[E - -64 >> 2], Pr = o[k + 68 >> 2], Wi = o[E + 68 >> 2], Nr = o[k + 72 >> 2], vn = o[E + 72 >> 2], Br = o[k + 40 >> 2], jr = o[E + 40 >> 2], M = o[k + 76 >> 2], o[k + 76 >> 2] = M ^ T & (o[E + 76 >> 2] ^ M), o[k + 72 >> 2] = Nr ^ T & (Nr ^ vn), o[k + 68 >> 2] = Pr ^ T & (Pr ^ Wi), o[Mr >> 2] = gr ^ T & (gr ^ Mi), o[k + 60 >> 2] = cr ^ T & (cr ^ Tr), o[k + 56 >> 2] = ve ^ T & (ve ^ li), o[k + 52 >> 2] = pr ^ T & (pr ^ Jr), o[k + 48 >> 2] = Ne ^ T & (Ne ^ fi), o[k + 44 >> 2] = ye ^ T & (ye ^ ti), o[k + 40 >> 2] = Br ^ T & (Br ^ jr), ye = o[k + 84 >> 2], ti = o[E + 84 >> 2], Ne = o[k + 88 >> 2], fi = o[E + 88 >> 2], pr = o[k + 92 >> 2], Jr = o[E + 92 >> 2], ve = o[k + 96 >> 2], li = o[E + 96 >> 2], cr = o[k + 100 >> 2], Tr = o[E + 100 >> 2], gr = o[k + 104 >> 2], Mr = o[E + 104 >> 2], Pr = o[k + 108 >> 2], Mi = o[E + 108 >> 2], Nr = o[k + 112 >> 2], Wi = o[E + 112 >> 2], Br = o[k + 80 >> 2], vn = o[E + 80 >> 2], jr = o[E + 116 >> 2], E = o[k + 116 >> 2], o[k + 116 >> 2] = T & (jr ^ E) ^ E, o[k + 112 >> 2] = Nr ^ T & (Nr ^ Wi), o[k + 108 >> 2] = Pr ^ T & (Pr ^ Mi), o[k + 104 >> 2] = gr ^ T & (gr ^ Mr), o[k + 100 >> 2] = cr ^ T & (cr ^ Tr), o[k + 96 >> 2] = ve ^ T & (ve ^ li), o[k + 92 >> 2] = pr ^ T & (pr ^ Jr), o[k + 88 >> 2] = Ne ^ T & (Ne ^ fi), o[k + 84 >> 2] = ye ^ T & (ye ^ ti), o[k + 80 >> 2] = Br ^ T & (Br ^ vn);
                    }
                    function ia(k, E) {
                      var T, M, ye = 0;
                      for (dr = T = dr - 192 | 0, qi(M = T + 144 | 0, E), qi(ye = T + 96 | 0, M), qi(ye, ye), Ti(ye, E, ye), Ti(M, M, ye), qi(E = T + 48 | 0, M), Ti(ye, ye, E), qi(E, ye), qi(E, E), qi(E, E), qi(E, E), qi(E, E), Ti(ye, E, ye), qi(E, ye), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), Ti(E, E, ye), qi(T, E), qi(T, T), qi(T, T), qi(T, T), qi(T, T), qi(T, T), qi(T, T), qi(T, T), qi(T, T), qi(T, T), qi(T, T), qi(T, T), qi(T, T), qi(T, T), qi(T, T), qi(T, T), qi(T, T), qi(T, T), qi(T, T), qi(T, T), Ti(E, T, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), Ti(ye, E, ye), qi(E, ye), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), Ti(E, E, ye), qi(T, E), E = 1; qi(T, T), (0 | (E = E + 1 | 0)) != 100; ) ;
                      Ti(E = T + 48 | 0, T, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), qi(E, E), Ti(ye = T + 96 | 0, E, ye), qi(ye, ye), qi(ye, ye), qi(ye, ye), qi(ye, ye), qi(ye, ye), Ti(k, ye, T + 144 | 0), dr = T + 192 | 0;
                    }
                    function La(k, E) {
                      var T, M = 0, ye = 0;
                      for (dr = T = dr - 144 | 0, qi(ye = T + 96 | 0, E), qi(M = T + 48 | 0, ye), qi(M, M), Ti(M, E, M), Ti(ye, ye, M), qi(ye, ye), Ti(ye, M, ye), qi(M, ye), qi(M, M), qi(M, M), qi(M, M), qi(M, M), Ti(ye, M, ye), qi(M, ye), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), Ti(M, M, ye), qi(T, M), qi(T, T), qi(T, T), qi(T, T), qi(T, T), qi(T, T), qi(T, T), qi(T, T), qi(T, T), qi(T, T), qi(T, T), qi(T, T), qi(T, T), qi(T, T), qi(T, T), qi(T, T), qi(T, T), qi(T, T), qi(T, T), qi(T, T), Ti(M, T, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), Ti(ye, M, ye), qi(M, ye), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), Ti(M, M, ye), qi(T, M), M = 1; qi(T, T), (0 | (M = M + 1 | 0)) != 100; ) ;
                      Ti(M = T + 48 | 0, T, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), qi(M, M), Ti(ye = T + 96 | 0, M, ye), qi(ye, ye), qi(ye, ye), Ti(k, ye, E), dr = T + 144 | 0;
                    }
                    function mf(k, E) {
                      var T, M, ye, Ne, pr, ve, cr, gr, Pr, Nr, Br, Mr, jr, ti, fi, Jr, li, Tr, Mi, Wi = 0, vn = 0, Tn = 0, Ni = 0;
                      dr = T = dr - 320 | 0, Va(M = k + 40 | 0, E), o[k + 84 >> 2] = 0, o[k + 88 >> 2] = 0, o[k + 80 >> 2] = 1, o[k + 92 >> 2] = 0, o[k + 96 >> 2] = 0, o[k + 100 >> 2] = 0, o[k + 104 >> 2] = 0, o[k + 108 >> 2] = 0, o[k + 112 >> 2] = 0, o[k + 116 >> 2] = 0, qi(Tn = T + 240 | 0, M), Ti(vn = T + 192 | 0, Tn, 1584), Ni = -1, ye = o[T + 240 >> 2] - 1 | 0, o[T + 240 >> 2] = ye, o[T + 192 >> 2] = o[T + 192 >> 2] + 1, Ne = o[T + 244 >> 2], pr = o[T + 248 >> 2], ve = o[T + 252 >> 2], cr = o[T + 256 >> 2], gr = o[T + 260 >> 2], Pr = o[T + 264 >> 2], Nr = o[T + 268 >> 2], Br = o[T + 272 >> 2], Mr = o[T + 276 >> 2], qi(Wi = T + 144 | 0, vn), Ti(Wi, Wi, vn), qi(k, Wi), Ti(k, k, vn), Ti(k, k, Tn), La(k, k), Ti(k, k, Wi), Ti(k, k, Tn), qi(Wi = T + 96 | 0, k), Ti(Wi, Wi, vn), vn = o[T + 132 >> 2], o[T + 84 >> 2] = vn - Mr, Wi = o[T + 128 >> 2], o[T + 80 >> 2] = Wi - Br, Tn = o[T + 124 >> 2], o[T + 76 >> 2] = Tn - Nr, jr = o[T + 120 >> 2], o[T + 72 >> 2] = jr - Pr, ti = o[T + 116 >> 2], o[T + 68 >> 2] = ti - gr, fi = o[T + 112 >> 2], o[T + 64 >> 2] = fi - cr, Jr = o[T + 108 >> 2], o[T + 60 >> 2] = Jr - ve, li = o[T + 104 >> 2], o[T + 56 >> 2] = li - pr, Tr = o[T + 100 >> 2], o[T + 52 >> 2] = Tr - Ne, Mi = o[T + 96 >> 2], o[T + 48 >> 2] = Mi - ye, i2(T, T + 48 | 0);
                      e: {
                        if (!pa(T, 32)) {
                          if (o[T + 36 >> 2] = vn + Mr, o[T + 32 >> 2] = Wi + Br, o[T + 28 >> 2] = Tn + Nr, o[T + 24 >> 2] = Pr + jr, o[T + 20 >> 2] = gr + ti, o[T + 16 >> 2] = cr + fi, o[T + 12 >> 2] = ve + Jr, o[T + 8 >> 2] = pr + li, o[T + 4 >> 2] = Ne + Tr, o[T >> 2] = ye + Mi, i2(vn = T + 288 | 0, T), !pa(vn, 32)) break e;
                          Ti(k, k, 1632);
                        }
                        i2(T + 288 | 0, k), (1 & B[T + 288 | 0]) == (m[E + 31 | 0] >>> 7 | 0) && (o[k >> 2] = 0 - o[k >> 2], o[k + 36 >> 2] = 0 - o[k + 36 >> 2], o[k + 32 >> 2] = 0 - o[k + 32 >> 2], o[k + 28 >> 2] = 0 - o[k + 28 >> 2], o[k + 24 >> 2] = 0 - o[k + 24 >> 2], o[k + 20 >> 2] = 0 - o[k + 20 >> 2], o[k + 16 >> 2] = 0 - o[k + 16 >> 2], o[k + 12 >> 2] = 0 - o[k + 12 >> 2], o[k + 8 >> 2] = 0 - o[k + 8 >> 2], o[k + 4 >> 2] = 0 - o[k + 4 >> 2]), Ti(k + 120 | 0, k, M), Ni = 0;
                      }
                      return dr = T + 320 | 0, Ni;
                    }
                    function kf(k, E, T) {
                      var M, ye, Ne, pr, ve, cr, gr, Pr, Nr = 0;
                      dr = M = dr - 128 | 0, o[k >> 2] = 1, o[k + 4 >> 2] = 0, o[k + 8 >> 2] = 0, o[k + 12 >> 2] = 0, o[k + 16 >> 2] = 0, o[k + 20 >> 2] = 0, o[k + 24 >> 2] = 0, o[k + 28 >> 2] = 0, o[k + 32 >> 2] = 0, o[k + 36 >> 2] = 0, o[k + 40 >> 2] = 1, Ca(k + 44 | 0, 0, 76), Ws(k, E = v(E, 960) + 2992 | 0, (255 & (1 ^ (Nr = T - ((T >> 31 & T) << 1) | 0))) - 1 >>> 31 | 0), Ws(k, E + 120 | 0, (255 & (2 ^ Nr)) - 1 >>> 31 | 0), Ws(k, E + 240 | 0, (255 & (3 ^ Nr)) - 1 >>> 31 | 0), Ws(k, E + 360 | 0, (255 & (4 ^ Nr)) - 1 >>> 31 | 0), Ws(k, E + 480 | 0, (255 & (5 ^ Nr)) - 1 >>> 31 | 0), Ws(k, E + 600 | 0, (255 & (6 ^ Nr)) - 1 >>> 31 | 0), Ws(k, E + 720 | 0, (255 & (7 ^ Nr)) - 1 >>> 31 | 0), Ws(k, E + 840 | 0, (255 & (8 ^ Nr)) - 1 >>> 31 | 0), E = o[k + 76 >> 2], o[M + 40 >> 2] = o[k + 72 >> 2], o[M + 44 >> 2] = E, Nr = o[4 + (E = k - -64 | 0) >> 2], o[M + 32 >> 2] = o[E >> 2], o[M + 36 >> 2] = Nr, E = o[k + 60 >> 2], o[M + 24 >> 2] = o[k + 56 >> 2], o[M + 28 >> 2] = E, E = o[k + 52 >> 2], o[M + 16 >> 2] = o[k + 48 >> 2], o[M + 20 >> 2] = E, E = o[k + 44 >> 2], o[M + 8 >> 2] = o[k + 40 >> 2], o[M + 12 >> 2] = E, E = o[k + 12 >> 2], o[M + 56 >> 2] = o[k + 8 >> 2], o[M + 60 >> 2] = E, Nr = o[k + 20 >> 2], o[(E = M - -64 | 0) >> 2] = o[k + 16 >> 2], o[E + 4 >> 2] = Nr, E = o[k + 28 >> 2], o[M + 72 >> 2] = o[k + 24 >> 2], o[M + 76 >> 2] = E, E = o[k + 36 >> 2], o[M + 80 >> 2] = o[k + 32 >> 2], o[M + 84 >> 2] = E, E = o[k + 4 >> 2], o[M + 48 >> 2] = o[k >> 2], o[M + 52 >> 2] = E, E = o[k + 84 >> 2], Nr = o[k + 88 >> 2], ye = o[k + 92 >> 2], Ne = o[k + 96 >> 2], pr = o[k + 100 >> 2], ve = o[k + 104 >> 2], cr = o[k + 108 >> 2], gr = o[k + 112 >> 2], Pr = o[k + 80 >> 2], o[M + 124 >> 2] = 0 - o[k + 116 >> 2], o[M + 120 >> 2] = 0 - gr, o[M + 116 >> 2] = 0 - cr, o[M + 112 >> 2] = 0 - ve, o[M + 108 >> 2] = 0 - pr, o[M + 104 >> 2] = 0 - Ne, o[M + 100 >> 2] = 0 - ye, o[M + 96 >> 2] = 0 - Nr, o[M + 92 >> 2] = 0 - E, o[M + 88 >> 2] = 0 - Pr, Ws(k, M + 8 | 0, (128 & T) >>> 7 | 0), dr = M + 128 | 0;
                    }
                    function Cf(k) {
                      var E, T, M, ye, Ne, pr, ve, cr, gr = 0, Pr = 0, Nr = 0, Br = 0, Mr = 0, jr = 0, ti = 0, fi = 0, Jr = 0, li = 0, Tr = 0, Mi = 0, Wi = 0, vn = 0, Tn = 0, Ni = 0, Yi = 0, Xi = 0, $n = 0, Zn = 0;
                      return dr = E = dr - 320 | 0, qi(Pr = E + 240 | 0, k), qi(Nr = E + 192 | 0, k + 40 | 0), qi(gr = E + 144 | 0, k + 80 | 0), k = o[E + 240 >> 2], Br = o[E + 192 >> 2], Mr = o[E + 244 >> 2], jr = o[E + 196 >> 2], ti = o[E + 248 >> 2], fi = o[E + 200 >> 2], Jr = o[E + 252 >> 2], li = o[E + 204 >> 2], Tr = o[E + 256 >> 2], Mi = o[E + 208 >> 2], Wi = o[E + 260 >> 2], vn = o[E + 212 >> 2], Tn = o[E + 264 >> 2], Ni = o[E + 216 >> 2], Yi = o[E + 268 >> 2], Xi = o[E + 220 >> 2], $n = o[E + 272 >> 2], Zn = o[E + 224 >> 2], o[E + 84 >> 2] = o[E + 228 >> 2] - o[E + 276 >> 2], o[E + 80 >> 2] = Zn - $n, o[E + 76 >> 2] = Xi - Yi, o[E + 72 >> 2] = Ni - Tn, o[E + 68 >> 2] = vn - Wi, o[E + 64 >> 2] = Mi - Tr, o[E + 60 >> 2] = li - Jr, o[E + 56 >> 2] = fi - ti, o[E + 52 >> 2] = jr - Mr, o[E + 48 >> 2] = Br - k, Ti(k = E + 48 | 0, k, gr), Ti(E, Pr, Nr), Ti(E, E, 1584), qi(E + 96 | 0, gr), gr = o[E + 48 >> 2], Pr = o[E + 96 >> 2], Nr = o[E >> 2], Br = o[E + 52 >> 2], Mr = o[E + 100 >> 2], jr = o[E + 4 >> 2], ti = o[E + 56 >> 2], fi = o[E + 104 >> 2], Jr = o[E + 8 >> 2], li = o[E + 60 >> 2], Tr = o[E + 108 >> 2], Mi = o[E + 12 >> 2], Wi = o[E + 64 >> 2], vn = o[E + 112 >> 2], Tn = o[E + 16 >> 2], Ni = o[E + 68 >> 2], Yi = o[E + 116 >> 2], Xi = o[E + 20 >> 2], $n = o[E + 72 >> 2], Zn = o[E + 120 >> 2], T = o[E + 24 >> 2], M = o[E + 76 >> 2], ye = o[E + 124 >> 2], Ne = o[E + 28 >> 2], pr = o[E + 80 >> 2], ve = o[E + 128 >> 2], cr = o[E + 32 >> 2], o[E + 84 >> 2] = o[E + 84 >> 2] - (o[E + 132 >> 2] + o[E + 36 >> 2] | 0), o[E + 80 >> 2] = pr - (ve + cr | 0), o[E + 76 >> 2] = M - (ye + Ne | 0), o[E + 72 >> 2] = $n - (Zn + T | 0), o[E + 68 >> 2] = Ni - (Yi + Xi | 0), o[E + 64 >> 2] = Wi - (vn + Tn | 0), o[E + 60 >> 2] = li - (Tr + Mi | 0), o[E + 56 >> 2] = ti - (fi + Jr | 0), o[E + 52 >> 2] = Br - (Mr + jr | 0), o[E + 48 >> 2] = gr - (Pr + Nr | 0), i2(gr = E + 288 | 0, k), k = pa(gr, 32), dr = E + 320 | 0, k;
                    }
                    function Nf(k, E, T, M, ye) {
                      k |= 0, E |= 0, T |= 0, M |= 0;
                      var Ne = 0, pr = 0, ve = 0, cr = 0, gr = 0, Pr = 0, Nr = 0;
                      e: {
                        t: {
                          r: {
                            i: {
                              n: {
                                o: {
                                  a: {
                                    if ((-7 & (ye |= 0)) == 1 && (ve = (Ne = (M >>> 0) / 3 | 0) << 2, (Ne = v(Ne, -3) + M | 0) && (ve = 2 & ye ? 2 + ((Ne >>> 1 | 0) + ve | 0) | 0 : ve + 4 | 0), !(E >>> 0 <= ve >>> 0))) {
                                      if (!(ye >>> 0 >= 4)) {
                                        if (!M) {
                                          ye = 0;
                                          break i;
                                        }
                                        Ne = 0, ye = 0;
                                        break a;
                                      }
                                      if (!M) {
                                        ye = 0;
                                        break i;
                                      }
                                      for (Ne = 0, ye = 0; ; ) {
                                        for (gr = m[T + cr | 0] | gr << 8, Ne |= 8; Pr = 65510 + (pr = gr >>> (Ne = Ne - 6 | 0) & 63) >>> 8 | 0, Nr = pr + 65484 >>> 8 | 0, B[k + ye | 0] = ~(1 + (16321 ^ pr)) >>> 8 & 45 | pr + 252 & pr + 65474 >>> 8 & ~Nr | ~(pr + 32705) >>> 8 & 95 | Pr & pr + 65 | Nr & pr + 71 & ~Pr, ye = ye + 1 | 0, Ne >>> 0 > 5; ) ;
                                        if ((0 | (cr = cr + 1 | 0)) == (0 | M)) break;
                                      }
                                      if (!Ne) break n;
                                      cr = 45, pr = 32705, M = 95;
                                      break o;
                                    }
                                    Wa(), ji();
                                  }
                                  for (; ; ) {
                                    for (gr = m[T + cr | 0] | gr << 8, Ne |= 8; Pr = 65510 + (pr = gr >>> (Ne = Ne - 6 | 0) & 63) >>> 8 | 0, Nr = pr + 65484 >>> 8 | 0, B[k + ye | 0] = ~(1 + (16321 ^ pr)) >>> 8 & 43 | pr + 252 & pr + 65474 >>> 8 & ~Nr | ~(pr + 16321) >>> 8 & 47 | Pr & pr + 65 | Nr & pr + 71 & ~Pr, ye = ye + 1 | 0, Ne >>> 0 > 5; ) ;
                                    if ((0 | (cr = cr + 1 | 0)) == (0 | M)) break;
                                  }
                                  if (!Ne) break n;
                                  cr = 43, pr = 16321, M = 47;
                                }
                                pr = ~((T = gr << 6 - Ne & 63) + pr) >>> 8 & M | (Ne = T + 65510 >>> 8 | 0) & T + 65, M = T + 65484 >>> 8 | 0, B[k + ye | 0] = ~(1 + (16321 ^ T)) >>> 8 & cr | pr | T + 252 & T + 65474 >>> 8 & ~M | M & T + 71 & ~Ne, ye = ye + 1 | 0;
                              }
                              if (ye >>> 0 > ve >>> 0) break r;
                            }
                            if (ye >>> 0 < ve >>> 0) break t;
                            ve = ye;
                            break e;
                          }
                          Me(1104, 1218, 231, 1503), ji();
                        }
                        Ca(k + ye | 0, 61, ve - ye | 0);
                      }
                      return Ca(k + ve | 0, 0, (E >>> 0 > (T = ve + 1 | 0) >>> 0 ? E : T) - ve | 0), 0 | k;
                    }
                    function jf(k, E, T) {
                      var M, ye, Ne, pr = 0, ve = 0, cr = 0, gr = 0, Pr = 0;
                      dr = M = dr - 16 | 0, ye = o[k + 20 >> 2], o[k + 20 >> 2] = 0, Ne = o[k + 4 >> 2], o[k + 4 >> 2] = 0, cr = -26;
                      e: {
                        t: {
                          r: {
                            i: switch (T - 1 | 0) {
                              case 1:
                                if (Jc(E, 1182, 9)) break t;
                                E = E + 9 | 0;
                                break r;
                              case 0:
                                break i;
                              default:
                                break e;
                            }
                            if (Jc(E, 1173, 8)) break t;
                            E = E + 8 | 0;
                          }
                          if (m[0 | E] != 36 | m[E + 1 | 0] != 118 || (pr = m[E + 2 | 0] == 61), pr && !(((gr = m[0 | (T = E + 3 | 0)]) - 58 & 255) >>> 0 < 246)) {
                            for (Pr = pr ? T : E, E = 0, pr = gr; ; ) {
                              if (ve = T, E >>> 0 > 429496729 || (T = (255 & pr) - 48 | 0) >>> 0 > ~(E = v(E, 10)) >>> 0) break t;
                              if (E = E + T | 0, !(((pr = m[0 | (T = ve + 1 | 0)]) - 58 & 255) >>> 0 > 245)) break;
                            }
                            if (!((0 | gr) == 48 & (0 | ve) != (0 | Pr) | (0 | T) == (0 | Pr))) {
                              if ((0 | E) != 19) break e;
                              if (!((255 & pr) != 36 | m[ve + 2 | 0] != 109 | m[ve + 3 | 0] != 61) && (T = Ih(ve + 4 | 0, E = M + 12 | 0)) && (o[k + 44 >> 2] = o[M + 12 >> 2], !(m[0 | T] != 44 | m[T + 1 | 0] != 116 | m[T + 2 | 0] != 61) && (T = Ih(T + 3 | 0, E)) && (o[k + 40 >> 2] = o[M + 12 >> 2], !(m[0 | T] != 44 | m[T + 1 | 0] != 112 | m[T + 2 | 0] != 61) && (T = Ih(T + 3 | 0, E)) && (pr = o[M + 12 >> 2], o[k + 48 >> 2] = pr, o[k + 52 >> 2] = pr, m[0 | T] == 36 && (o[M + 12 >> 2] = ye, !Se(ve = o[k + 16 >> 2], ye, pr = T = T + 1 | 0, gr = sc(T), 0, E, T = M + 8 | 0, 3) && (o[k + 20 >> 2] = o[M + 12 >> 2], pr = o[M + 8 >> 2], m[0 | pr] == 36 && (o[M + 12 >> 2] = Ne, pr = pr + 1 | 0, !Se(o[k >> 2], Ne, pr, sc(pr), 0, E, T, 3)))))))) {
                                if (o[k + 4 >> 2] = o[M + 12 >> 2], E = o[M + 8 >> 2], cr = Ss(k)) break e;
                                cr = m[0 | E] ? -32 : 0;
                                break e;
                              }
                            }
                          }
                        }
                        cr = -32;
                      }
                      return dr = M + 16 | 0, cr;
                    }
                    function E2(k, E, T, M) {
                      var ye = 0, Ne = 0, pr = 0, ve = 0, cr = 0, gr = 0, Pr = 0;
                      if (T | M) e: for (Pr = k + 224 | 0, cr = k + 96 | 0, Ne = m[k + 352 | 0] | m[k + 353 | 0] << 8 | m[k + 354 | 0] << 16 | m[k + 355 | 0] << 24; ; ) {
                        if (ye = Ne + cr | 0, !M & T >>> 0 <= (pr = 256 - Ne | 0) >>> 0) {
                          fa(ye, E, T), E = T + (m[k + 352 | 0] | m[k + 353 | 0] << 8 | m[k + 354 | 0] << 16 | m[k + 355 | 0] << 24) | 0, B[k + 352 | 0] = E, B[k + 353 | 0] = E >>> 8, B[k + 354 | 0] = E >>> 16, B[k + 355 | 0] = E >>> 24;
                          break e;
                        }
                        if (fa(ye, E, pr), ye = (m[k + 352 | 0] | m[k + 353 | 0] << 8 | m[k + 354 | 0] << 16 | m[k + 355 | 0] << 24) + pr | 0, B[k + 352 | 0] = ye, B[k + 353 | 0] = ye >>> 8, B[k + 354 | 0] = ye >>> 16, B[k + 355 | 0] = ye >>> 24, gr = Ne = m[k + 68 | 0] | m[k + 69 | 0] << 8 | m[k + 70 | 0] << 16 | m[k + 71 | 0] << 24, Ne = (ve = 128 + (ye = m[k + 64 | 0] | m[k + 65 | 0] << 8 | m[k + 66 | 0] << 16 | m[k + 67 | 0] << 24) | 0) >>> 0 < 128 ? Ne + 1 | 0 : Ne, B[k + 64 | 0] = ve, B[k + 65 | 0] = ve >>> 8, B[k + 66 | 0] = ve >>> 16, B[k + 67 | 0] = ve >>> 24, B[k + 68 | 0] = Ne, B[k + 69 | 0] = Ne >>> 8, B[k + 70 | 0] = Ne >>> 16, B[k + 71 | 0] = Ne >>> 24, Ne = m[k + 76 | 0] | m[k + 77 | 0] << 8 | m[k + 78 | 0] << 16 | m[k + 79 | 0] << 24, Ne = (gr = ye = (0 | gr) == -1 & ye >>> 0 > 4294967167) >>> 0 > (ye = ye + (m[k + 72 | 0] | m[k + 73 | 0] << 8 | m[k + 74 | 0] << 16 | m[k + 75 | 0] << 24) | 0) >>> 0 ? Ne + 1 | 0 : Ne, B[k + 72 | 0] = ye, B[k + 73 | 0] = ye >>> 8, B[k + 74 | 0] = ye >>> 16, B[k + 75 | 0] = ye >>> 24, B[k + 76 | 0] = Ne, B[k + 77 | 0] = Ne >>> 8, B[k + 78 | 0] = Ne >>> 16, B[k + 79 | 0] = Ne >>> 24, Fr(k, cr), fa(cr, Pr, 128), ye = Ne = (m[k + 352 | 0] | m[k + 353 | 0] << 8 | m[k + 354 | 0] << 16 | m[k + 355 | 0] << 24) - 128 | 0, B[k + 352 | 0] = ye, B[k + 353 | 0] = ye >>> 8, B[k + 354 | 0] = ye >>> 16, B[k + 355 | 0] = ye >>> 24, E = E + pr | 0, !((M = M - (T >>> 0 < pr >>> 0) | 0) | (T = T - pr | 0))) break;
                      }
                      return 0;
                    }
                    function Xf(k) {
                      var E = 0, T = 0, M = 0, ye = 0, Ne = 0, pr = 0, ve = 0, cr = 0, gr = 0, Pr = 0, Nr = 0, Br = 0, Mr = 0, jr = 0, ti = 0, fi = 0, Jr = 0, li = 0, Tr = 0, Mi = 0, Wi = 0;
                      for (T = o[k + 60 >> 2], fi = o[k + 56 >> 2], ti = o[k + 52 >> 2], Mr = o[k + 48 >> 2], E = o[k + 44 >> 2], M = o[k + 40 >> 2], Jr = o[k + 36 >> 2], Br = o[k + 32 >> 2], ye = o[k + 28 >> 2], Ne = o[k + 24 >> 2], pr = o[k + 20 >> 2], ve = o[k + 16 >> 2], cr = o[k + 12 >> 2], gr = o[k + 8 >> 2], Pr = o[k + 4 >> 2], Nr = o[k >> 2]; jr = ao(pr + Pr | 0, 7) ^ Jr, li = ao(jr + pr | 0, 9) ^ ti, ve = ao(Nr + Mr | 0, 7) ^ ve, Tr = ao(ve + Nr | 0, 9) ^ Br, Mi = ao(Tr + ve | 0, 13) ^ Mr, cr = ao(E + T | 0, 7) ^ cr, ye = ao(cr + T | 0, 9) ^ ye, Br = ao(ye + cr | 0, 13) ^ E, T = ao(ye + Br | 0, 18) ^ T, E = ao(M + Ne | 0, 7) ^ fi, Mr = Mi ^ ao(T + E | 0, 7), ti = li ^ ao(Mr + T | 0, 9), fi = ao(Mr + ti | 0, 13) ^ E, T = ao(ti + fi | 0, 18) ^ T, gr = ao(E + M | 0, 9) ^ gr, Ne = ao(gr + E | 0, 13) ^ Ne, M = ao(Ne + gr | 0, 18) ^ M, E = ao(M + jr | 0, 7) ^ Br, Br = ao(E + M | 0, 9) ^ Tr, Jr = ao(E + Br | 0, 13) ^ jr, M = ao(Br + Jr | 0, 18) ^ M, Pr = ao(jr + li | 0, 13) ^ Pr, pr = ao(Pr + li | 0, 18) ^ pr, Ne = ao(pr + ve | 0, 7) ^ Ne, ye = ao(Ne + pr | 0, 9) ^ ye, ve = ao(ye + Ne | 0, 13) ^ ve, pr = ao(ve + ye | 0, 18) ^ pr, Nr = ao(Tr + Mi | 0, 18) ^ Nr, Pr = ao(Nr + cr | 0, 7) ^ Pr, gr = ao(Pr + Nr | 0, 9) ^ gr, cr = ao(gr + Pr | 0, 13) ^ cr, Nr = ao(cr + gr | 0, 18) ^ Nr, jr = Wi >>> 0 < 6, Wi = Wi + 2 | 0, jr; ) ;
                      o[k >> 2] = o[k >> 2] + Nr, o[k + 4 >> 2] = o[k + 4 >> 2] + Pr, o[k + 8 >> 2] = o[k + 8 >> 2] + gr, o[k + 12 >> 2] = o[k + 12 >> 2] + cr, o[k + 16 >> 2] = o[k + 16 >> 2] + ve, o[k + 20 >> 2] = o[k + 20 >> 2] + pr, o[k + 24 >> 2] = o[k + 24 >> 2] + Ne, o[k + 28 >> 2] = o[k + 28 >> 2] + ye, o[k + 32 >> 2] = o[k + 32 >> 2] + Br, o[k + 36 >> 2] = o[k + 36 >> 2] + Jr, o[k + 40 >> 2] = o[k + 40 >> 2] + M, o[k + 44 >> 2] = o[k + 44 >> 2] + E, o[k + 48 >> 2] = o[k + 48 >> 2] + Mr, o[k + 52 >> 2] = o[k + 52 >> 2] + ti, o[k + 56 >> 2] = o[k + 56 >> 2] + fi, o[k + 60 >> 2] = o[k + 60 >> 2] + T;
                    }
                    function Zf(k, E, T, M) {
                      var ye, Ne = 0;
                      return dr = ye = dr - 320 | 0, Ne = -1, ha(T) && (Ia(T) || No(ye, T) || Bs(ye) && (B[0 | k] = m[0 | E], B[k + 1 | 0] = m[E + 1 | 0], B[k + 2 | 0] = m[E + 2 | 0], B[k + 3 | 0] = m[E + 3 | 0], B[k + 4 | 0] = m[E + 4 | 0], B[k + 5 | 0] = m[E + 5 | 0], B[k + 6 | 0] = m[E + 6 | 0], B[k + 7 | 0] = m[E + 7 | 0], B[k + 8 | 0] = m[E + 8 | 0], B[k + 9 | 0] = m[E + 9 | 0], B[k + 10 | 0] = m[E + 10 | 0], B[k + 11 | 0] = m[E + 11 | 0], B[k + 12 | 0] = m[E + 12 | 0], B[k + 13 | 0] = m[E + 13 | 0], B[k + 14 | 0] = m[E + 14 | 0], B[k + 15 | 0] = m[E + 15 | 0], B[k + 16 | 0] = m[E + 16 | 0], B[k + 17 | 0] = m[E + 17 | 0], B[k + 18 | 0] = m[E + 18 | 0], B[k + 19 | 0] = m[E + 19 | 0], B[k + 20 | 0] = m[E + 20 | 0], B[k + 21 | 0] = m[E + 21 | 0], B[k + 22 | 0] = m[E + 22 | 0], B[k + 23 | 0] = m[E + 23 | 0], B[k + 24 | 0] = m[E + 24 | 0], B[k + 25 | 0] = m[E + 25 | 0], B[k + 26 | 0] = m[E + 26 | 0], B[k + 27 | 0] = m[E + 27 | 0], B[k + 28 | 0] = m[E + 28 | 0], B[k + 29 | 0] = m[E + 29 | 0], B[k + 30 | 0] = m[E + 30 | 0], T = m[E + 31 | 0], M && (B[0 | k] = 248 & m[0 | k], T |= 64), B[k + 31 | 0] = 127 & T, Io(T = ye + 160 | 0, k, ye), Rc(k, T), (127 & m[k + 31 | 0] | m[k + 30 | 0] | m[k + 29 | 0] | m[k + 28 | 0] | m[k + 27 | 0] | m[k + 26 | 0] | m[k + 25 | 0] | m[k + 24 | 0] | m[k + 23 | 0] | m[k + 22 | 0] | m[k + 21 | 0] | m[k + 20 | 0] | m[k + 19 | 0] | m[k + 18 | 0] | m[k + 17 | 0] | m[k + 16 | 0] | m[k + 15 | 0] | m[k + 14 | 0] | m[k + 13 | 0] | m[k + 12 | 0] | m[k + 11 | 0] | m[k + 10 | 0] | m[k + 9 | 0] | m[k + 8 | 0] | m[k + 7 | 0] | m[k + 6 | 0] | m[k + 5 | 0] | m[k + 4 | 0] | m[k + 3 | 0] | m[k + 2 | 0] | m[k + 1 | 0] | 1 ^ m[0 | k]) - 1 & 256 || (Ne = pa(E, 32) ? -1 : 0))), dr = ye + 320 | 0, Ne;
                    }
                    function Ic(k, E, T, M, ye) {
                      var Ne, pr = 0, ve = 0, cr = 0, gr = 0, Pr = 0, Nr = 0, Br = 0, Mr = 0;
                      if (dr = Ne = dr - 48 | 0, ye && Sf(ye, 102), !(m[0 | M] != 36 | m[M + 1 | 0] != 55 | m[M + 2 | 0] != 36) && (Pr = Qc(m[M + 3 | 0])) && (pr = ju(Ne + 12 | 0, M + 4 | 0)) && (gr = ju(Ne + 8 | 0, pr))) {
                        for (ve = sc(gr) + 1 | 0; pr = 0, ve && m[0 | (pr = gr + (ve = ve - 1 | 0) | 0)] != 36; ) ;
                        if (cr = pr - gr | 0, pr || (cr = sc(gr)), !((cr = 45 + (ve = (pr = cr) + (gr - M | 0) | 0) | 0) >>> 0 > 102 | pr >>> 0 > cr >>> 0 || (cr = k, Br = E, Mr = T, k = 31 & (Pr = Pr - 1024 | 0), (63 & Pr) >>> 0 >= 32 ? (E = 1 << k, T = 0) : E = (T = 1 << k) - 1 & 1 >>> 32 - k, Pa(cr, Br, Mr, gr, pr, T, E, o[Ne + 12 >> 2], o[Ne + 8 >> 2], Ne + 16 | 0, 32)))) {
                          for (pr = fa(ye, M, ve), B[0 | (k = pr + ve | 0)] = 36, Nr = (cr = pr + 102 | 0) - (ye = k + 1 | 0) | 0, T = 0; ; ) {
                            e: if ((E = T) >>> 0 > 31) M = ye;
                            else if (k = ye, T = (ve = E + 1 | 0) + (Br = (T = 31 - E | 0) >>> 0 >= 2 ? 2 : T) | 0, M = 0, gr = 0, ye = m[(Pr = Ne + 16 | 0) + E | 0], Br && (ye = m[ve + Pr | 0] << 8 | ye, (0 | (E = E + 2 | 0)) != (0 | T) && (gr = 1, ye = m[E + Pr | 0] << 16 | ye)), Nr && (B[0 | k] = m[1024 + (63 & ye) | 0], (0 | Nr) != 1)) {
                              if (B[k + 1 | 0] = m[1024 + (ye >>> 6 & 63) | 0], Br = k + Nr | 0, E = k + 2 | 0, (0 | T) != (0 | ve)) {
                                if ((0 | Nr) == 2) break e;
                                if (B[k + 2 | 0] = m[1024 + (ye >>> 12 & 63) | 0], E = k + 3 | 0, gr) {
                                  if ((0 | Nr) == 3) break e;
                                  B[k + 3 | 0] = m[1024 + (ye >>> 18 | 0) | 0], E = k + 4 | 0;
                                }
                              }
                              if (Nr = Br - (ye = E) | 0, ye) continue;
                            }
                            break;
                          }
                          _s(Ne + 16 | 0, 32), Nr = 0, !M | M >>> 0 >= cr >>> 0 || (B[0 | M] = 0, Nr = pr);
                        }
                      }
                      return dr = Ne + 48 | 0, Nr;
                    }
                    function $a(k, E) {
                      var T, M = 0, ye = 0, Ne = 0, pr = 0, ve = 0, cr = 0, gr = 0, Pr = 0, Nr = 0, Br = 0, Mr = 0, jr = 0, ti = 0, fi = 0, Jr = 0, li = 0, Tr = 0, Mi = 0;
                      M = o[E + 4 >> 2], Ne = o[E + 44 >> 2], pr = o[E + 8 >> 2], ve = o[E + 48 >> 2], cr = o[E + 12 >> 2], gr = o[E + 52 >> 2], Pr = o[E + 16 >> 2], Nr = o[E + 56 >> 2], Br = o[E + 20 >> 2], Mr = o[E + 60 >> 2], jr = o[E + 24 >> 2], ti = o[(ye = E - -64 | 0) >> 2], fi = o[E + 28 >> 2], Jr = o[E + 68 >> 2], li = o[E + 32 >> 2], Tr = o[E + 72 >> 2], Mi = o[E + 36 >> 2], T = o[E + 76 >> 2], o[k >> 2] = o[E >> 2] + o[E + 40 >> 2], o[k + 36 >> 2] = Mi + T, o[k + 32 >> 2] = li + Tr, o[k + 28 >> 2] = fi + Jr, o[k + 24 >> 2] = jr + ti, o[k + 20 >> 2] = Br + Mr, o[k + 16 >> 2] = Pr + Nr, o[k + 12 >> 2] = cr + gr, o[k + 8 >> 2] = pr + ve, o[k + 4 >> 2] = M + Ne, M = o[E + 4 >> 2], Ne = o[E + 44 >> 2], pr = o[E + 8 >> 2], ve = o[E + 48 >> 2], cr = o[E + 12 >> 2], gr = o[E + 52 >> 2], Pr = o[E + 16 >> 2], Nr = o[E + 56 >> 2], Br = o[E + 20 >> 2], Mr = o[E + 60 >> 2], jr = o[E + 24 >> 2], ye = o[ye >> 2], ti = o[E + 28 >> 2], fi = o[E + 68 >> 2], Jr = o[E + 32 >> 2], li = o[E + 72 >> 2], Tr = o[E >> 2], Mi = o[E + 40 >> 2], o[k + 76 >> 2] = o[E + 76 >> 2] - o[E + 36 >> 2], o[k + 72 >> 2] = li - Jr, o[k + 68 >> 2] = fi - ti, o[k - -64 >> 2] = ye - jr, o[k + 60 >> 2] = Mr - Br, o[k + 56 >> 2] = Nr - Pr, o[k + 52 >> 2] = gr - cr, o[k + 48 >> 2] = ve - pr, o[k + 44 >> 2] = Ne - M, o[k + 40 >> 2] = Mi - Tr, M = o[E + 84 >> 2], o[k + 80 >> 2] = o[E + 80 >> 2], o[k + 84 >> 2] = M, M = o[E + 92 >> 2], o[k + 88 >> 2] = o[E + 88 >> 2], o[k + 92 >> 2] = M, M = o[E + 100 >> 2], o[k + 96 >> 2] = o[E + 96 >> 2], o[k + 100 >> 2] = M, M = o[E + 108 >> 2], o[k + 104 >> 2] = o[E + 104 >> 2], o[k + 108 >> 2] = M, M = o[E + 116 >> 2], o[k + 112 >> 2] = o[E + 112 >> 2], o[k + 116 >> 2] = M, Ti(k + 120 | 0, E + 120 | 0, 1680);
                    }
                    function gs(k, E, T) {
                      var M, ye, Ne, pr, ve, cr, gr, Pr, Nr, Br, Mr, jr, ti = 0, fi = 0, Jr = 0, li = 0, Tr = 0;
                      ti = o[E + 12 >> 2], fi = o[E + 8 >> 2], Jr = o[E + 4 >> 2], M = dr + -64 & -64, E = o[E >> 2], o[M >> 2] = o[35744 + ((255 & E) << 2) >> 2], o[M + 4 >> 2] = o[35744 + (Jr >>> 6 & 1020) >> 2], o[M + 8 >> 2] = o[35744 + (fi >>> 14 & 1020) >> 2], o[M + 12 >> 2] = o[35744 + (ti >>> 22 & 1020) >> 2], o[M + 16 >> 2] = o[35744 + ((255 & Jr) << 2) >> 2], o[M + 20 >> 2] = o[35744 + (fi >>> 6 & 1020) >> 2], o[M + 24 >> 2] = o[35744 + (ti >>> 14 & 1020) >> 2], o[M + 28 >> 2] = o[35744 + (E >>> 22 & 1020) >> 2], o[M + 32 >> 2] = o[35744 + ((255 & fi) << 2) >> 2], o[M + 36 >> 2] = o[35744 + (ti >>> 6 & 1020) >> 2], o[M + 40 >> 2] = o[35744 + (E >>> 14 & 1020) >> 2], o[M + 44 >> 2] = o[35744 + (Jr >>> 22 & 1020) >> 2], o[M + 48 >> 2] = o[35744 + ((255 & ti) << 2) >> 2], o[M + 52 >> 2] = o[35744 + (E >>> 6 & 1020) >> 2], o[M + 56 >> 2] = o[35744 + (Jr >>> 14 & 1020) >> 2], o[M + 60 >> 2] = o[35744 + (fi >>> 22 & 1020) >> 2], E = o[M + 12 >> 2], ti = o[M >> 2], fi = o[M + 4 >> 2], Jr = o[M + 8 >> 2], ye = o[M + 28 >> 2], Ne = o[M + 16 >> 2], pr = o[M + 20 >> 2], ve = o[M + 24 >> 2], cr = o[M + 44 >> 2], gr = o[M + 32 >> 2], Pr = o[M + 36 >> 2], Nr = o[M + 40 >> 2], Br = o[T >> 2], Mr = o[T + 4 >> 2], jr = o[T + 8 >> 2], li = k, Tr = o[T + 12 >> 2] ^ o[M + 48 >> 2] ^ ao(o[M + 52 >> 2], 8) ^ ao(o[M + 56 >> 2], 16) ^ ao(o[M + 60 >> 2], 24), o[li + 12 >> 2] = Tr, li = k, Tr = ao(Pr, 8) ^ gr ^ ao(Nr, 16) ^ ao(cr, 24) ^ jr, o[li + 8 >> 2] = Tr, li = k, Tr = ao(pr, 8) ^ Ne ^ ao(ve, 16) ^ ao(ye, 24) ^ Mr, o[li + 4 >> 2] = Tr, li = k, Tr = ao(fi, 8) ^ ti ^ ao(Jr, 16) ^ ao(E, 24) ^ Br, o[li >> 2] = Tr;
                    }
                    function Wc(k, E, T) {
                      var M, ye = 0;
                      return dr = M = dr - 160 | 0, B[0 | k] = m[0 | E], B[k + 1 | 0] = m[E + 1 | 0], B[k + 2 | 0] = m[E + 2 | 0], B[k + 3 | 0] = m[E + 3 | 0], B[k + 4 | 0] = m[E + 4 | 0], B[k + 5 | 0] = m[E + 5 | 0], B[k + 6 | 0] = m[E + 6 | 0], B[k + 7 | 0] = m[E + 7 | 0], B[k + 8 | 0] = m[E + 8 | 0], B[k + 9 | 0] = m[E + 9 | 0], B[k + 10 | 0] = m[E + 10 | 0], B[k + 11 | 0] = m[E + 11 | 0], B[k + 12 | 0] = m[E + 12 | 0], B[k + 13 | 0] = m[E + 13 | 0], B[k + 14 | 0] = m[E + 14 | 0], B[k + 15 | 0] = m[E + 15 | 0], B[k + 16 | 0] = m[E + 16 | 0], B[k + 17 | 0] = m[E + 17 | 0], B[k + 18 | 0] = m[E + 18 | 0], B[k + 19 | 0] = m[E + 19 | 0], B[k + 20 | 0] = m[E + 20 | 0], B[k + 21 | 0] = m[E + 21 | 0], B[k + 22 | 0] = m[E + 22 | 0], B[k + 23 | 0] = m[E + 23 | 0], B[k + 24 | 0] = m[E + 24 | 0], B[k + 25 | 0] = m[E + 25 | 0], B[k + 26 | 0] = m[E + 26 | 0], B[k + 27 | 0] = m[E + 27 | 0], B[k + 28 | 0] = m[E + 28 | 0], B[k + 29 | 0] = m[E + 29 | 0], B[k + 30 | 0] = m[E + 30 | 0], ye = m[E + 31 | 0], T && (B[0 | k] = 248 & m[0 | k], ye |= 64), B[k + 31 | 0] = 127 & ye, e(M, k), Rc(k, M), T = -1, (127 & m[k + 31 | 0] | m[k + 30 | 0] | m[k + 29 | 0] | m[k + 28 | 0] | m[k + 27 | 0] | m[k + 26 | 0] | m[k + 25 | 0] | m[k + 24 | 0] | m[k + 23 | 0] | m[k + 22 | 0] | m[k + 21 | 0] | m[k + 20 | 0] | m[k + 19 | 0] | m[k + 18 | 0] | m[k + 17 | 0] | m[k + 16 | 0] | m[k + 15 | 0] | m[k + 14 | 0] | m[k + 13 | 0] | m[k + 12 | 0] | m[k + 11 | 0] | m[k + 10 | 0] | m[k + 9 | 0] | m[k + 8 | 0] | m[k + 7 | 0] | m[k + 6 | 0] | m[k + 5 | 0] | m[k + 4 | 0] | m[k + 3 | 0] | m[k + 2 | 0] | m[k + 1 | 0] | 1 ^ m[0 | k]) - 1 & 256 || (T = pa(E, 32) ? -1 : 0), dr = M + 160 | 0, T;
                    }
                    function Uc(k, E) {
                      var T, M, ye, Ne, pr, ve = 0, cr = 0, gr = 0, Pr = 0, Nr = 0, Br = 0, Mr = 0, jr = 0, ti = 0, fi = 0;
                      (ve = o[k + 56 >> 2]) | (cr = o[k + 60 >> 2]) && (B[(Pr = k - -64 | 0) + ve | 0] = 1, !((fi = ve + 1 | 0) ? cr : cr + 1 | 0) & fi >>> 0 <= 15 && Ca(65 + (k + ve | 0) | 0, 0, 15 - ve | 0), B[k + 80 | 0] = 1, ta(k, Pr, 16, 0)), fi = o[k + 52 >> 2], jr = o[k + 48 >> 2], Pr = o[k + 44 >> 2], ve = o[k + 24 >> 2], Nr = o[k + 28 >> 2] + (ve >>> 26 | 0) | 0, gr = o[k + 32 >> 2] + (Nr >>> 26 | 0) | 0, T = o[k + 36 >> 2] + (gr >>> 26 | 0) | 0, cr = (Mr = (ve = (ve = (67108863 & ve) + ((Br = o[k + 20 >> 2] + v(T >>> 26 | 0, 5) | 0) >>> 26 | 0) | 0) & (Nr = (gr = (pr = (67108863 & T) + ((Ne = (M = 67108863 & gr) + ((ye = (ti = 67108863 & Nr) + ((Br = ve + ((cr = 5 + (Mr = 67108863 & Br) | 0) >>> 26 | 0) | 0) >>> 26 | 0) | 0) >>> 26 | 0) | 0) >>> 26 | 0) | 0) - 67108864 | 0) >> 31) | Br & (gr = 67108863 & (Br = (gr >>> 31 | 0) - 1 | 0))) << 26 | cr & gr | Nr & Mr) + o[k + 40 >> 2] | 0, B[0 | E] = cr, B[E + 1 | 0] = cr >>> 8, B[E + 2 | 0] = cr >>> 16, B[E + 3 | 0] = cr >>> 24, Mr = cr >>> 0 < Mr >>> 0, cr = 0, cr = (ve = (ti = Nr & ti | gr & ye) << 20 | ve >>> 6) >>> 0 > (ve = ve + Pr | 0) >>> 0 ? 1 : cr, cr = (Pr = ve) >>> 0 > (ve = ve + Mr | 0) >>> 0 ? cr + 1 | 0 : cr, B[E + 4 | 0] = ve, B[E + 5 | 0] = ve >>> 8, B[E + 6 | 0] = ve >>> 16, B[E + 7 | 0] = ve >>> 24, ve = 0, Pr = (Pr = (gr = Nr & M | gr & Ne) << 14 | ti >>> 12) >>> 0 > (jr = Pr + jr | 0) >>> 0 ? 1 : ve, ve = jr, jr = cr, ve = ve + cr | 0, cr = Pr, cr = ve >>> 0 < jr >>> 0 ? cr + 1 | 0 : cr, B[E + 8 | 0] = ve, B[E + 9 | 0] = ve >>> 8, B[E + 10 | 0] = ve >>> 16, B[E + 11 | 0] = ve >>> 24, cr = (ve = (ve = (Br & pr | Nr & T) << 8 | gr >>> 18) + fi | 0) + cr | 0, B[E + 12 | 0] = cr, B[E + 13 | 0] = cr >>> 8, B[E + 14 | 0] = cr >>> 16, B[E + 15 | 0] = cr >>> 24, _s(k, 88);
                    }
                    function Gf(k, E, T) {
                      k |= 0, E |= 0, T |= 0;
                      var M, ye = 0;
                      return dr = M = dr - 16 | 0, B[M + 15 | 0] = 0, ye = -1, 0 | Af[o[8930]](k, E, T) || (B[M + 15 | 0] = m[0 | k] | m[M + 15 | 0], B[M + 15 | 0] = m[k + 1 | 0] | m[M + 15 | 0], B[M + 15 | 0] = m[k + 2 | 0] | m[M + 15 | 0], B[M + 15 | 0] = m[k + 3 | 0] | m[M + 15 | 0], B[M + 15 | 0] = m[k + 4 | 0] | m[M + 15 | 0], B[M + 15 | 0] = m[k + 5 | 0] | m[M + 15 | 0], B[M + 15 | 0] = m[k + 6 | 0] | m[M + 15 | 0], B[M + 15 | 0] = m[k + 7 | 0] | m[M + 15 | 0], B[M + 15 | 0] = m[k + 8 | 0] | m[M + 15 | 0], B[M + 15 | 0] = m[k + 9 | 0] | m[M + 15 | 0], B[M + 15 | 0] = m[k + 10 | 0] | m[M + 15 | 0], B[M + 15 | 0] = m[k + 11 | 0] | m[M + 15 | 0], B[M + 15 | 0] = m[k + 12 | 0] | m[M + 15 | 0], B[M + 15 | 0] = m[k + 13 | 0] | m[M + 15 | 0], B[M + 15 | 0] = m[k + 14 | 0] | m[M + 15 | 0], B[M + 15 | 0] = m[k + 15 | 0] | m[M + 15 | 0], B[M + 15 | 0] = m[k + 16 | 0] | m[M + 15 | 0], B[M + 15 | 0] = m[k + 17 | 0] | m[M + 15 | 0], B[M + 15 | 0] = m[k + 18 | 0] | m[M + 15 | 0], B[M + 15 | 0] = m[k + 19 | 0] | m[M + 15 | 0], B[M + 15 | 0] = m[k + 20 | 0] | m[M + 15 | 0], B[M + 15 | 0] = m[k + 21 | 0] | m[M + 15 | 0], B[M + 15 | 0] = m[k + 22 | 0] | m[M + 15 | 0], B[M + 15 | 0] = m[k + 23 | 0] | m[M + 15 | 0], B[M + 15 | 0] = m[k + 24 | 0] | m[M + 15 | 0], B[M + 15 | 0] = m[k + 25 | 0] | m[M + 15 | 0], B[M + 15 | 0] = m[k + 26 | 0] | m[M + 15 | 0], B[M + 15 | 0] = m[k + 27 | 0] | m[M + 15 | 0], B[M + 15 | 0] = m[k + 28 | 0] | m[M + 15 | 0], B[M + 15 | 0] = m[k + 29 | 0] | m[M + 15 | 0], B[M + 15 | 0] = m[k + 30 | 0] | m[M + 15 | 0], B[M + 15 | 0] = m[k + 31 | 0] | m[M + 15 | 0], ye = (m[M + 15 | 0] << 23) - 8388608 >> 31), dr = M + 16 | 0, 0 | ye;
                    }
                    function su(k, E, T, M, ye) {
                      var Ne = 0, pr = 0, ve = 0, cr = 0, gr = 0, Pr = 0, Nr = 0;
                      e: {
                        if ((0 | M) == 1 | M >>> 0 > 1) o[9404] = 22;
                        else {
                          dr = M = dr - 128 | 0, o[M - -64 >> 2] = 0, o[M + 56 >> 2] = 0, o[M + 60 >> 2] = 0, o[M + 48 >> 2] = 0, o[M + 52 >> 2] = 0, o[M + 40 >> 2] = 0, o[M + 44 >> 2] = 0, o[M + 32 >> 2] = 0, o[M + 36 >> 2] = 0, o[M + 24 >> 2] = 0, o[M + 28 >> 2] = 0, o[M + 16 >> 2] = 0, o[M + 20 >> 2] = 0, Ne = sc(k), o[M + 28 >> 2] = Ne, o[M + 44 >> 2] = Ne, o[M + 12 >> 2] = Ne, pr = un(Ne), o[M + 40 >> 2] = pr, ve = un(Ne), o[M + 24 >> 2] = ve, cr = un(Ne), o[M + 8 >> 2] = cr;
                          t: if (!cr | !pr | !ve || !(Ne = un(Ne))) js(pr), js(ve), js(cr), k = -22;
                          else {
                            if (k = jf(M + 8 | 0, k, ye)) {
                              js(o[M + 40 >> 2]), js(o[M + 24 >> 2]), js(o[M + 8 >> 2]), js(Ne);
                              break t;
                            }
                            cr = o[M + 28 >> 2], gr = o[M + 24 >> 2], k = o[M + 60 >> 2], Pr = o[M + 52 >> 2], Nr = o[M + 48 >> 2], Sf(Ne, pr = o[M + 12 >> 2]), (ve = un(pr)) ? (o[M + 100 >> 2] = 0, o[M + 104 >> 2] = 0, o[M + 92 >> 2] = 0, o[M + 96 >> 2] = 0, o[M + 88 >> 2] = cr, o[M + 84 >> 2] = gr, o[M + 80 >> 2] = T, o[M + 76 >> 2] = E, o[M + 72 >> 2] = pr, o[M + 68 >> 2] = ve, o[M + 124 >> 2] = 0, o[M + 120 >> 2] = k, o[M + 116 >> 2] = k, o[M + 112 >> 2] = Pr, o[M + 108 >> 2] = Nr, (k = Go(M + 68 | 0, ye)) || fa(Ne, ve, pr), _s(ve, pr), js(ve)) : k = -22, js(o[M + 40 >> 2]), js(o[M + 24 >> 2]), k || (k = bi(Ne, o[M + 8 >> 2], o[M + 12 >> 2]) ? -35 : 0), js(Ne), js(o[M + 8 >> 2]);
                          }
                          if (dr = M + 128 | 0, E = k, !k) break e;
                          (0 | k) == -35 && (o[9404] = 28);
                        }
                        E = -1;
                      }
                      return E;
                    }
                    function i2(k, E) {
                      var T, M, ye, Ne, pr, ve, cr, gr = 0, Pr = 0;
                      M = o[E + 32 >> 2], ye = o[E + 28 >> 2], Ne = o[E + 24 >> 2], pr = o[E + 20 >> 2], ve = o[E + 16 >> 2], cr = o[E + 12 >> 2], gr = o[E + 4 >> 2], Pr = o[E >> 2], T = o[E + 36 >> 2], E = o[E + 8 >> 2], Pr = v((M + (ye + (Ne + (pr + (ve + (cr + ((gr + (Pr + (v(T, 19) + 16777216 >>> 25 | 0) >> 26) >> 25) + E >> 26) >> 25) >> 26) >> 25) >> 26) >> 25) >> 26) + T >> 25, 19) + Pr | 0, B[0 | k] = Pr, B[k + 2 | 0] = Pr >>> 16, B[k + 1 | 0] = Pr >>> 8, gr = gr + (Pr >> 26) | 0, B[k + 5 | 0] = gr >>> 14, B[k + 4 | 0] = gr >>> 6, B[k + 3 | 0] = Pr >>> 24 & 3 | gr << 2, E = E + (gr >> 25) | 0, B[k + 8 | 0] = E >>> 13, B[k + 7 | 0] = E >>> 5, B[k + 6 | 0] = E << 3 | (29360128 & gr) >>> 22, Pr = (E >> 26) + cr | 0, B[k + 11 | 0] = Pr >>> 11, B[k + 10 | 0] = Pr >>> 3, B[k + 9 | 0] = Pr << 5 | (65011712 & E) >>> 21, gr = (Pr >> 25) + ve | 0, B[k + 15 | 0] = gr >>> 18, B[k + 14 | 0] = gr >>> 10, B[k + 13 | 0] = gr >>> 2, E = (gr >> 26) + pr | 0, B[k + 16 | 0] = E, B[k + 12 | 0] = gr << 6 | (33030144 & Pr) >>> 19, B[k + 18 | 0] = E >>> 16, B[k + 17 | 0] = E >>> 8, gr = (E >> 25) + Ne | 0, B[k + 21 | 0] = gr >>> 15, B[k + 20 | 0] = gr >>> 7, B[k + 19 | 0] = E >>> 24 & 1 | gr << 1, E = (gr >> 26) + ye | 0, B[k + 24 | 0] = E >>> 13, B[k + 23 | 0] = E >>> 5, B[k + 22 | 0] = E << 3 | (58720256 & gr) >>> 23, gr = (E >> 25) + M | 0, B[k + 27 | 0] = gr >>> 12, B[k + 26 | 0] = gr >>> 4, B[k + 25 | 0] = gr << 4 | (31457280 & E) >>> 21, E = T + (gr >> 26) | 0, B[k + 30 | 0] = E >>> 10, B[k + 29 | 0] = E >>> 2, B[k + 31 | 0] = (33292288 & E) >>> 18, B[k + 28 | 0] = E << 6 | (66060288 & gr) >>> 20;
                    }
                    function tc(k, E, T) {
                      k |= 0, E |= 0;
                      var M, ye = 0, Ne = 0, pr = 0, ve = 0, cr = 0, gr = 0, Pr = 0;
                      if (dr = M = dr - 192 | 0, (T |= 0) >>> 0 >= 129 && (Ks(k), qs(k, E, T, 0), ds(k, M), T = 64, E = M), Ks(k), Ca(M - -64 | 0, 54, 128), T) {
                        if (T >>> 0 >= 4) for (Pr = 252 & T; B[0 | (ye = (pr = M - -64 | 0) + Ne | 0)] = m[0 | ye] ^ m[E + Ne | 0], B[0 | (ve = (ye = 1 | Ne) + pr | 0)] = m[0 | ve] ^ m[E + ye | 0], B[0 | (ve = (ye = 2 | Ne) + pr | 0)] = m[0 | ve] ^ m[E + ye | 0], B[0 | (ye = (ye = pr) + (pr = 3 | Ne) | 0)] = m[0 | ye] ^ m[E + pr | 0], Ne = Ne + 4 | 0, (0 | Pr) != (0 | (cr = cr + 4 | 0)); ) ;
                        if (cr = 3 & T) for (; B[0 | (pr = (M - -64 | 0) + Ne | 0)] = m[0 | pr] ^ m[E + Ne | 0], Ne = Ne + 1 | 0, (0 | cr) != (0 | (gr = gr + 1 | 0)); ) ;
                      }
                      if (qs(k, Ne = M - -64 | 0, 128, 0), Ks(pr = k + 208 | 0), Ca(Ne, 92, 128), T) {
                        if (gr = 0, Ne = 0, T >>> 0 >= 4) for (Pr = 252 & T, cr = 0; B[0 | (ye = (k = M - -64 | 0) + Ne | 0)] = m[0 | ye] ^ m[E + Ne | 0], B[0 | (ve = (ye = 1 | Ne) + k | 0)] = m[0 | ve] ^ m[E + ye | 0], B[0 | (ve = (ye = 2 | Ne) + k | 0)] = m[0 | ve] ^ m[E + ye | 0], B[0 | (ye = (ye = k) + (k = 3 | Ne) | 0)] = m[0 | ye] ^ m[k + E | 0], Ne = Ne + 4 | 0, (0 | Pr) != (0 | (cr = cr + 4 | 0)); ) ;
                        if (k = 3 & T) for (; B[0 | (T = (M - -64 | 0) + Ne | 0)] = m[0 | T] ^ m[E + Ne | 0], Ne = Ne + 1 | 0, (0 | k) != (0 | (gr = gr + 1 | 0)); ) ;
                      }
                      return qs(pr, k = M - -64 | 0, 128, 0), _s(k, 128), _s(M, 64), dr = M + 192 | 0, 0;
                    }
                    function pc(k, E) {
                      var T;
                      return k |= 0, E |= 0, o[12 + (T = dr - 16 | 0) >> 2] = k, o[T + 8 >> 2] = E, o[T + 4 >> 2] = 0, o[T + 4 >> 2] = o[T + 4 >> 2] | m[o[T + 12 >> 2]] ^ m[o[T + 8 >> 2]], o[T + 4 >> 2] = o[T + 4 >> 2] | m[o[T + 12 >> 2] + 1 | 0] ^ m[o[T + 8 >> 2] + 1 | 0], o[T + 4 >> 2] = o[T + 4 >> 2] | m[o[T + 12 >> 2] + 2 | 0] ^ m[o[T + 8 >> 2] + 2 | 0], o[T + 4 >> 2] = o[T + 4 >> 2] | m[o[T + 12 >> 2] + 3 | 0] ^ m[o[T + 8 >> 2] + 3 | 0], o[T + 4 >> 2] = o[T + 4 >> 2] | m[o[T + 12 >> 2] + 4 | 0] ^ m[o[T + 8 >> 2] + 4 | 0], o[T + 4 >> 2] = o[T + 4 >> 2] | m[o[T + 12 >> 2] + 5 | 0] ^ m[o[T + 8 >> 2] + 5 | 0], o[T + 4 >> 2] = o[T + 4 >> 2] | m[o[T + 12 >> 2] + 6 | 0] ^ m[o[T + 8 >> 2] + 6 | 0], o[T + 4 >> 2] = o[T + 4 >> 2] | m[o[T + 12 >> 2] + 7 | 0] ^ m[o[T + 8 >> 2] + 7 | 0], o[T + 4 >> 2] = o[T + 4 >> 2] | m[o[T + 12 >> 2] + 8 | 0] ^ m[o[T + 8 >> 2] + 8 | 0], o[T + 4 >> 2] = o[T + 4 >> 2] | m[o[T + 12 >> 2] + 9 | 0] ^ m[o[T + 8 >> 2] + 9 | 0], o[T + 4 >> 2] = o[T + 4 >> 2] | m[o[T + 12 >> 2] + 10 | 0] ^ m[o[T + 8 >> 2] + 10 | 0], o[T + 4 >> 2] = o[T + 4 >> 2] | m[o[T + 12 >> 2] + 11 | 0] ^ m[o[T + 8 >> 2] + 11 | 0], o[T + 4 >> 2] = o[T + 4 >> 2] | m[o[T + 12 >> 2] + 12 | 0] ^ m[o[T + 8 >> 2] + 12 | 0], o[T + 4 >> 2] = o[T + 4 >> 2] | m[o[T + 12 >> 2] + 13 | 0] ^ m[o[T + 8 >> 2] + 13 | 0], o[T + 4 >> 2] = o[T + 4 >> 2] | m[o[T + 12 >> 2] + 14 | 0] ^ m[o[T + 8 >> 2] + 14 | 0], o[T + 4 >> 2] = o[T + 4 >> 2] | m[o[T + 12 >> 2] + 15 | 0] ^ m[o[T + 8 >> 2] + 15 | 0], (o[T + 4 >> 2] - 1 >>> 8 & 1) - 1 | 0;
                    }
                    function Ai(k, E, T, M, ye, Ne, pr) {
                      var ve, cr, gr, Pr = 0, Nr = 0, Br = 0, Mr = 0;
                      dr = ve = dr - 352 | 0, ba(ve, Ne, pr, 0);
                      e: {
                        if (!(((Pr = !!(0 | ye)) | !ye & M >>> 0 > k - T >>> 0) & k >>> 0 > T >>> 0) & (!ye & T - k >>> 0 >= M >>> 0 | k >>> 0 >= T >>> 0)) {
                          if (o[ve + 56 >> 2] = 0, o[ve + 60 >> 2] = 0, o[ve + 48 >> 2] = 0, o[ve + 52 >> 2] = 0, o[ve + 40 >> 2] = 0, o[ve + 44 >> 2] = 0, o[ve + 32 >> 2] = 0, o[ve + 36 >> 2] = 0, Nr = (pr = (Pr = !!(0 | ye)) | !ye & M >>> 0 >= 32) ? 32 : M, Br = pr ? 0 : ye, pr = Pr | !ye & M >>> 0 > 32, !(M | ye)) {
                            Mr = 1;
                            break e;
                          }
                        } else T = Ef(k, T, M), o[ve + 56 >> 2] = 0, o[ve + 60 >> 2] = 0, o[ve + 48 >> 2] = 0, o[ve + 52 >> 2] = 0, o[ve + 40 >> 2] = 0, o[ve + 44 >> 2] = 0, o[ve + 32 >> 2] = 0, o[ve + 36 >> 2] = 0, Nr = (pr = Pr | !ye & M >>> 0 >= 32) ? 32 : M, Br = pr ? 0 : ye, pr = Pr | !ye & M >>> 0 > 32;
                        fa(ve - -64 | 0, T, Nr), Mr = 0;
                      }
                      return Pr = Br, Vu(cr = ve + 32 | 0, cr, gr = Nr + 32 | 0, Pr = gr >>> 0 < 32 ? Pr + 1 | 0 : Pr, Pr = Ne + 16 | 0, ve), ac(ve + 96 | 0, cr), Mr || fa(k, ve - -64 | 0, Nr), _s(ve + 32 | 0, 64), pr && Cc(k + Nr | 0, T + Nr | 0, M - Nr | 0, ye - ((M >>> 0 < Nr >>> 0) + Br | 0) | 0, Pr, 1, 0, ve), _s(ve, 32), Da(T = ve + 96 | 0, k, M, ye), fc(T, E), _s(T, 256), dr = ve + 352 | 0, 0;
                    }
                    function Bi(k, E, T, M, ye, Ne, pr) {
                      var ve, cr, gr, Pr = 0, Nr = 0, Br = 0, Mr = 0;
                      dr = ve = dr - 352 | 0, ea(ve, Ne, pr, 0);
                      e: {
                        if (!(((Pr = !!(0 | ye)) | !ye & M >>> 0 > k - T >>> 0) & k >>> 0 > T >>> 0) & (!ye & T - k >>> 0 >= M >>> 0 | k >>> 0 >= T >>> 0)) {
                          if (o[ve + 56 >> 2] = 0, o[ve + 60 >> 2] = 0, o[ve + 48 >> 2] = 0, o[ve + 52 >> 2] = 0, o[ve + 40 >> 2] = 0, o[ve + 44 >> 2] = 0, o[ve + 32 >> 2] = 0, o[ve + 36 >> 2] = 0, Nr = (pr = (Pr = !!(0 | ye)) | !ye & M >>> 0 >= 32) ? 32 : M, Br = pr ? 0 : ye, pr = Pr | !ye & M >>> 0 > 32, !(M | ye)) {
                            Mr = 1;
                            break e;
                          }
                        } else T = Ef(k, T, M), o[ve + 56 >> 2] = 0, o[ve + 60 >> 2] = 0, o[ve + 48 >> 2] = 0, o[ve + 52 >> 2] = 0, o[ve + 40 >> 2] = 0, o[ve + 44 >> 2] = 0, o[ve + 32 >> 2] = 0, o[ve + 36 >> 2] = 0, Nr = (pr = Pr | !ye & M >>> 0 >= 32) ? 32 : M, Br = pr ? 0 : ye, pr = Pr | !ye & M >>> 0 > 32;
                        fa(ve - -64 | 0, T, Nr), Mr = 0;
                      }
                      return Pr = Br, eA(cr = ve + 32 | 0, cr, gr = Nr + 32 | 0, Pr = gr >>> 0 < 32 ? Pr + 1 | 0 : Pr, Pr = Ne + 16 | 0, ve), ac(ve + 96 | 0, cr), Mr || fa(k, ve - -64 | 0, Nr), _s(ve + 32 | 0, 64), pr && cu(k + Nr | 0, T + Nr | 0, M - Nr | 0, ye - ((M >>> 0 < Nr >>> 0) + Br | 0) | 0, Pr, 1, 0, ve), _s(ve, 32), Da(T = ve + 96 | 0, k, M, ye), fc(T, E), _s(T, 256), dr = ve + 352 | 0, 0;
                    }
                    function yi(k, E, T, M, ye) {
                      var Ne;
                      return k |= 0, E |= 0, T |= 0, M |= 0, dr = Ne = dr - 480 | 0, tc(Ne, ye |= 0, 32), mc(Ne, E, T, M), Fc(Ne, Ne + 416 | 0), E = o[Ne + 444 >> 2], T = o[Ne + 440 >> 2], B[k + 24 | 0] = T, B[k + 25 | 0] = T >>> 8, B[k + 26 | 0] = T >>> 16, B[k + 27 | 0] = T >>> 24, B[k + 28 | 0] = E, B[k + 29 | 0] = E >>> 8, B[k + 30 | 0] = E >>> 16, B[k + 31 | 0] = E >>> 24, E = o[Ne + 436 >> 2], T = o[Ne + 432 >> 2], B[k + 16 | 0] = T, B[k + 17 | 0] = T >>> 8, B[k + 18 | 0] = T >>> 16, B[k + 19 | 0] = T >>> 24, B[k + 20 | 0] = E, B[k + 21 | 0] = E >>> 8, B[k + 22 | 0] = E >>> 16, B[k + 23 | 0] = E >>> 24, E = o[Ne + 428 >> 2], T = o[Ne + 424 >> 2], B[k + 8 | 0] = T, B[k + 9 | 0] = T >>> 8, B[k + 10 | 0] = T >>> 16, B[k + 11 | 0] = T >>> 24, B[k + 12 | 0] = E, B[k + 13 | 0] = E >>> 8, B[k + 14 | 0] = E >>> 16, B[k + 15 | 0] = E >>> 24, E = o[Ne + 420 >> 2], T = o[Ne + 416 >> 2], B[0 | k] = T, B[k + 1 | 0] = T >>> 8, B[k + 2 | 0] = T >>> 16, B[k + 3 | 0] = T >>> 24, B[k + 4 | 0] = E, B[k + 5 | 0] = E >>> 8, B[k + 6 | 0] = E >>> 16, B[k + 7 | 0] = E >>> 24, dr = Ne + 480 | 0, 0;
                    }
                    function ii(k, E, T) {
                      k |= 0, E |= 0;
                      var M, ye = 0;
                      return dr = M = dr + -64 | 0, Zs(M, T |= 0, 32, 0), T = o[M + 28 >> 2], ye = o[M + 24 >> 2], B[E + 24 | 0] = ye, B[E + 25 | 0] = ye >>> 8, B[E + 26 | 0] = ye >>> 16, B[E + 27 | 0] = ye >>> 24, B[E + 28 | 0] = T, B[E + 29 | 0] = T >>> 8, B[E + 30 | 0] = T >>> 16, B[E + 31 | 0] = T >>> 24, T = o[M + 20 >> 2], ye = o[M + 16 >> 2], B[E + 16 | 0] = ye, B[E + 17 | 0] = ye >>> 8, B[E + 18 | 0] = ye >>> 16, B[E + 19 | 0] = ye >>> 24, B[E + 20 | 0] = T, B[E + 21 | 0] = T >>> 8, B[E + 22 | 0] = T >>> 16, B[E + 23 | 0] = T >>> 24, T = o[M + 12 >> 2], ye = o[M + 8 >> 2], B[E + 8 | 0] = ye, B[E + 9 | 0] = ye >>> 8, B[E + 10 | 0] = ye >>> 16, B[E + 11 | 0] = ye >>> 24, B[E + 12 | 0] = T, B[E + 13 | 0] = T >>> 8, B[E + 14 | 0] = T >>> 16, B[E + 15 | 0] = T >>> 24, T = o[M + 4 >> 2], ye = o[M >> 2], B[0 | E] = ye, B[E + 1 | 0] = ye >>> 8, B[E + 2 | 0] = ye >>> 16, B[E + 3 | 0] = ye >>> 24, B[E + 4 | 0] = T, B[E + 5 | 0] = T >>> 8, B[E + 6 | 0] = T >>> 16, B[E + 7 | 0] = T >>> 24, _s(M, 64), k = lA(k, E), dr = M - -64 | 0, 0 | k;
                    }
                    function ki(k, E) {
                      var T = 0, M = 0, ye = 0, Ne = 0, pr = 0, ve = 0;
                      return E >>> 0 > 4294967168 ? 48 : (E >>> 0 >= 4294967168 ? (o[9404] = 48, T = 0) : (T = 0, (E = un(76 + (Ne = E >>> 0 < 11 ? 16 : E + 11 & -8) | 0)) && (T = E - 8 | 0, 63 & E ? (ye = (-8 & (ve = o[(pr = E - 4 | 0) >> 2])) - (M = (E = ((E = (E + 63 & -64) - 8 | 0) - T >>> 0 <= 15 ? 64 : 0) + E | 0) - T | 0) | 0, 3 & ve ? (o[E + 4 >> 2] = ye | 1 & o[E + 4 >> 2] | 2, o[4 + (ye = E + ye | 0) >> 2] = 1 | o[ye + 4 >> 2], o[pr >> 2] = M | 1 & o[pr >> 2] | 2, o[4 + (ye = T + M | 0) >> 2] = 1 | o[ye + 4 >> 2], va(T, M)) : (T = o[T >> 2], o[E + 4 >> 2] = ye, o[E >> 2] = T + M)) : E = T, 3 & (T = o[E + 4 >> 2]) && ((M = -8 & T) >>> 0 <= Ne + 16 >>> 0 || (o[E + 4 >> 2] = Ne | 1 & T | 2, T = E + Ne | 0, Ne = M - Ne | 0, o[T + 4 >> 2] = 3 | Ne, o[4 + (M = E + M | 0) >> 2] = 1 | o[M + 4 >> 2], va(T, Ne))), T = E + 8 | 0)), T ? (o[k >> 2] = T, 0) : 48);
                    }
                    function Vi(k, E, T, M, ye, Ne, pr, ve, cr, gr, Pr) {
                      var Nr;
                      if (Nr = Ca(k, 0, E), (0 | T) == 1 | T >>> 0 > 1) return o[9404] = 22, -1;
                      if (!(!T & E >>> 0 <= 15)) {
                        if (!(!(Ne | cr) & gr >>> 0 < 2147483649)) return o[9404] = 22, -1;
                        if (!(!((!cr & ve >>> 0 >= 3 | !!(0 | cr)) & gr >>> 0 > 8191) | (0 | M) == (0 | Nr))) return (0 | Pr) == 1 ? (Ne = gr >>> 10 | 0, dr = k = dr + -64 | 0, Nr && Sf(Nr, E), (T = un(E)) ? (o[k + 36 >> 2] = 0, o[k + 40 >> 2] = 0, o[k + 28 >> 2] = 0, o[k + 32 >> 2] = 0, o[k + 24 >> 2] = 16, o[k + 20 >> 2] = pr, o[k + 16 >> 2] = ye, o[k + 12 >> 2] = M, o[k + 8 >> 2] = E, o[k + 4 >> 2] = T, o[k + 60 >> 2] = 0, o[k + 56 >> 2] = 1, o[k + 52 >> 2] = 1, o[k + 48 >> 2] = Ne, o[k + 44 >> 2] = ve, (M = Go(k + 4 | 0, 1)) | !Nr || fa(Nr, T, E), _s(T, E), js(T)) : M = -22, dr = k - -64 | 0, M ? -1 : 0) : (o[9404] = 28, -1);
                      }
                      return o[9404] = 28, -1;
                    }
                    function Ki(k, E, T, M, ye, Ne, pr) {
                      var ve, cr, gr = 0, Pr = 0, Nr = 0;
                      dr = ve = dr - 96 | 0, ea(ve, Ne, pr, 0), Nh(pr = ve + 32 | 0, 32, 0, cr = Ne + 16 | 0, ve), Ne = -1;
                      e: {
                        t: if (!sA(T, E, M, ye, pr)) {
                          if (Ne = 0, !k) break e;
                          r: {
                            if (!(((T = !!(0 | ye)) | !ye & M >>> 0 > E - k >>> 0) & k >>> 0 < E >>> 0) & (!ye & M >>> 0 <= k - E >>> 0 | k >>> 0 <= E >>> 0)) {
                              if (!(M | ye)) break r;
                              T = (Ne = !ye & M >>> 0 >= 32 | !!(0 | ye)) ? 32 : M, gr = Ne ? 0 : ye;
                            } else E = Ef(k, E, M), T = (Ne = T | !ye & M >>> 0 >= 32) ? 32 : M, gr = Ne ? 0 : ye;
                            if (Ne = gr, Nr = fa(ve - -64 | 0, E, T), eA(pr = ve + 32 | 0, pr, Pr = T + 32 | 0, Ne = Pr >>> 0 < 32 ? Ne + 1 | 0 : Ne, cr, ve), k = fa(k, Nr, T), _s(pr, 64), Ne = 0, !ye & M >>> 0 < 33) break t;
                            cu(k + T | 0, E + T | 0, M - T | 0, ye - (gr + (T >>> 0 > M >>> 0) | 0) | 0, cr, 1, 0, ve);
                            break t;
                          }
                          eA(k = ve + 32 | 0, k, 32, 0, cr, ve), _s(k, 64);
                        }
                        _s(ve, 32);
                      }
                      return dr = ve + 96 | 0, Ne;
                    }
                    function Pn(k, E, T, M, ye, Ne, pr, ve, cr, gr, Pr) {
                      var Nr;
                      if (Nr = Ca(k, 0, E), (0 | T) == 1 | T >>> 0 > 1) return o[9404] = 22, -1;
                      if (!(!T & E >>> 0 <= 15)) {
                        if (!(!(Ne | cr) & gr >>> 0 < 2147483649)) return o[9404] = 22, -1;
                        if (!(!(!!(ve | cr) & gr >>> 0 > 8191) | (0 | M) == (0 | Nr))) return (0 | Pr) == 2 ? (Ne = gr >>> 10 | 0, dr = k = dr + -64 | 0, Nr && Sf(Nr, E), (T = un(E)) ? (o[k + 36 >> 2] = 0, o[k + 40 >> 2] = 0, o[k + 28 >> 2] = 0, o[k + 32 >> 2] = 0, o[k + 24 >> 2] = 16, o[k + 20 >> 2] = pr, o[k + 16 >> 2] = ye, o[k + 12 >> 2] = M, o[k + 8 >> 2] = E, o[k + 4 >> 2] = T, o[k + 60 >> 2] = 0, o[k + 56 >> 2] = 1, o[k + 52 >> 2] = 1, o[k + 48 >> 2] = Ne, o[k + 44 >> 2] = ve, (M = Go(k + 4 | 0, 2)) | !Nr || fa(Nr, T, E), _s(T, E), js(T)) : M = -22, dr = k - -64 | 0, M ? -1 : 0) : (o[9404] = 28, -1);
                      }
                      return o[9404] = 28, -1;
                    }
                    function oo(k, E, T, M, ye, Ne, pr) {
                      var ve, cr, gr = 0, Pr = 0;
                      dr = ve = dr - 96 | 0, ba(ve, Ne, pr, 0), ku(pr = ve + 32 | 0, 32, 0, cr = Ne + 16 | 0, ve), Ne = -1;
                      e: {
                        t: if (!sA(T, E, M, ye, pr)) {
                          if (Ne = 0, !k) break e;
                          r: {
                            if (!(((T = !!(0 | ye)) | !ye & M >>> 0 > E - k >>> 0) & k >>> 0 < E >>> 0) & (!ye & M >>> 0 <= k - E >>> 0 | k >>> 0 <= E >>> 0)) {
                              if (!(M | ye)) break r;
                              T = (Ne = !ye & M >>> 0 >= 32 | !!(0 | ye)) ? 32 : M, pr = Ne ? 0 : ye;
                            } else E = Ef(k, E, M), T = (Ne = T | !ye & M >>> 0 >= 32) ? 32 : M, pr = Ne ? 0 : ye;
                            if (gr = T, Pr = fa(ve - -64 | 0, E, T), Vu(T = ve + 32 | 0, T, Ne = gr + 32 | 0, Ne >>> 0 < 32 ? pr + 1 | 0 : pr, cr, ve), T = fa(k, Pr, gr), Ne = 0, !ye & M >>> 0 < 33) break t;
                            Cc(T + gr | 0, E + gr | 0, M - gr | 0, ye - (pr + (M >>> 0 < gr >>> 0) | 0) | 0, cr, 1, 0, ve);
                            break t;
                          }
                          Vu(k = ve + 32 | 0, k, 32, 0, cr, ve);
                        }
                        _s(ve, 32);
                      }
                      return dr = ve + 96 | 0, Ne;
                    }
                    function mo(k, E, T, M, ye, Ne, pr, ve, cr, gr) {
                      var Pr, Nr;
                      return dr = Pr = dr - 400 | 0, o[Pr + 4 >> 2] = 0, ba(Nr = Pr + 16 | 0, cr, gr, 0), gr = m[cr + 20 | 0] | m[cr + 21 | 0] << 8 | m[cr + 22 | 0] << 16 | m[cr + 23 | 0] << 24, o[Pr + 8 >> 2] = m[cr + 16 | 0] | m[cr + 17 | 0] << 8 | m[cr + 18 | 0] << 16 | m[cr + 19 | 0] << 24, o[Pr + 12 >> 2] = gr, Lc(gr = Pr + 80 | 0, 64, 0, Pr + 4 | 0, Nr), ac(cr = Pr + 144 | 0, gr), _s(gr, 64), Da(cr, Ne, pr, ve), Da(cr, 35680, 0 - pr & 15, 0), Da(cr, E, T, M), Da(cr, 35680, 0 - T & 15, 0), o[Pr + 72 >> 2] = pr, o[Pr + 76 >> 2] = ve, Da(cr, Ne = Pr + 72 | 0, 8, 0), o[Pr + 72 >> 2] = T, o[Pr + 76 >> 2] = M, Da(cr, Ne, 8, 0), fc(cr, Ne = Pr + 48 | 0), _s(cr, 256), cr = pc(Ne, ye), _s(Ne, 16), k && (cr ? (Ca(k, 0, T), cr = -1) : (Ec(k, E, T, M, Pr + 4 | 0, Pr + 16 | 0), cr = 0)), _s(Pr + 16 | 0, 32), dr = Pr + 400 | 0, cr;
                    }
                    function ko(k, E, T, M, ye, Ne) {
                      var pr, ve;
                      if (dr = pr = dr - 496 | 0, Co(ve = pr + 288 | 0, k, E), vc(ve, T, M, 0), Ne) for (k = 0, E = 0; T = (E = E + 1 | 0) << 24 | (65280 & E) << 8 | E >>> 8 & 65280 | E >>> 24, B[pr + 76 | 0] = T, B[pr + 77 | 0] = T >>> 8, B[pr + 78 | 0] = T >>> 16, B[pr + 79 | 0] = T >>> 24, fa(T = pr + 80 | 0, pr + 288 | 0, 208), vc(T, pr + 76 | 0, 4, 0), au(T, pr + 32 | 0), T = o[pr + 60 >> 2], o[pr + 24 >> 2] = o[pr + 56 >> 2], o[pr + 28 >> 2] = T, T = o[pr + 52 >> 2], o[pr + 16 >> 2] = o[pr + 48 >> 2], o[pr + 20 >> 2] = T, T = o[pr + 44 >> 2], o[pr + 8 >> 2] = o[pr + 40 >> 2], o[pr + 12 >> 2] = T, T = o[pr + 36 >> 2], o[pr >> 2] = o[pr + 32 >> 2], o[pr + 4 >> 2] = T, fa(T = k + ye | 0, pr, (k = Ne - k | 0) >>> 0 >= 32 ? 32 : k), Ne >>> 0 > (k = E << 5) >>> 0; ) ;
                      _s(pr + 288 | 0, 208), dr = pr + 496 | 0;
                    }
                    function $o(k, E, T, M, ye, Ne) {
                      var pr, ve, cr = 0;
                      return dr = pr = dr - 32 | 0, cr = -1, (ve = T >>> 0 < 32) & !M || (yl(pr, 32, 0, ye, Ne), sA(E + 16 | 0, E + 32 | 0, T - 32 | 0, M - ve | 0, pr) || (Rh(k, E, T, M, ye, Ne), B[k + 24 | 0] = 0, B[k + 25 | 0] = 0, B[k + 26 | 0] = 0, B[k + 27 | 0] = 0, B[k + 28 | 0] = 0, B[k + 29 | 0] = 0, B[k + 30 | 0] = 0, B[k + 31 | 0] = 0, B[k + 16 | 0] = 0, B[k + 17 | 0] = 0, B[k + 18 | 0] = 0, B[k + 19 | 0] = 0, B[k + 20 | 0] = 0, B[k + 21 | 0] = 0, B[k + 22 | 0] = 0, B[k + 23 | 0] = 0, B[k + 8 | 0] = 0, B[k + 9 | 0] = 0, B[k + 10 | 0] = 0, B[k + 11 | 0] = 0, B[k + 12 | 0] = 0, B[k + 13 | 0] = 0, B[k + 14 | 0] = 0, B[k + 15 | 0] = 0, B[0 | k] = 0, B[k + 1 | 0] = 0, B[k + 2 | 0] = 0, B[k + 3 | 0] = 0, B[k + 4 | 0] = 0, B[k + 5 | 0] = 0, B[k + 6 | 0] = 0, B[k + 7 | 0] = 0, cr = 0)), dr = pr + 32 | 0, cr;
                    }
                    function Jo(k, E, T, M, ye, Ne, pr, ve, cr, gr, Pr) {
                      var Nr, Br, Mr;
                      return dr = Nr = dr - 384 | 0, o[Nr + 4 >> 2] = 0, ba(Br = Nr + 16 | 0, gr, Pr, 0), Pr = m[gr + 20 | 0] | m[gr + 21 | 0] << 8 | m[gr + 22 | 0] << 16 | m[gr + 23 | 0] << 24, o[Nr + 8 >> 2] = m[gr + 16 | 0] | m[gr + 17 | 0] << 8 | m[gr + 18 | 0] << 16 | m[gr + 19 | 0] << 24, o[Nr + 12 >> 2] = Pr, Lc(Pr = Nr - -64 | 0, 64, 0, Mr = Nr + 4 | 0, Br), ac(gr = Nr + 128 | 0, Pr), _s(Pr, 64), Da(gr, pr, ve, cr), Da(gr, 35680, 0 - ve & 15, 0), Ec(k, M, ye, Ne, Mr, Br), Da(gr, k, ye, Ne), Da(gr, 35680, 0 - ye & 15, 0), o[Nr + 56 >> 2] = ve, o[Nr + 60 >> 2] = cr, Da(gr, k = Nr + 56 | 0, 8, 0), o[Nr + 56 >> 2] = ye, o[Nr + 60 >> 2] = Ne, Da(gr, k, 8, 0), fc(gr, E), _s(gr, 256), T && (o[T >> 2] = 16, o[T + 4 >> 2] = 0), _s(Nr + 16 | 0, 32), dr = Nr + 384 | 0, 0;
                    }
                    function hs(k, E, T, M, ye) {
                      var Ne, pr, ve = 0;
                      return dr = Ne = dr + -64 | 0, !T & (pr = sc(k)) >>> 0 < 128 ? (o[Ne + 60 >> 2] = 0, o[Ne + 52 >> 2] = 0, o[Ne + 56 >> 2] = 0, o[Ne + 44 >> 2] = 0, o[Ne + 48 >> 2] = 0, T = 0, pr && (T = pr, (1 | pr) >>> 0 < 65536 || (T = pr)), !(ve = un(T)) | !(3 & m[ve - 4 | 0]) || Ca(ve, 0, T), ve ? (o[Ne + 36 >> 2] = 0, o[Ne + 40 >> 2] = 0, o[Ne + 12 >> 2] = ve, o[Ne + 20 >> 2] = ve, o[Ne + 24 >> 2] = pr, o[Ne + 4 >> 2] = ve, o[Ne + 16 >> 2] = pr, o[Ne + 28 >> 2] = 0, o[Ne + 32 >> 2] = 0, o[Ne + 8 >> 2] = pr, jf(Ne + 4 | 0, k, ye) ? (o[9404] = 28, k = -1) : k = o[Ne + 44 >> 2] != (0 | E) | o[Ne + 48 >> 2] != (M >>> 10 | 0), js(ve)) : k = -1) : (o[9404] = 28, k = -1), dr = Ne - -64 | 0, k;
                    }
                    function Ss(k) {
                      var E, T = 0, M = 0;
                      if (!k) return -25;
                      if (!o[k >> 2]) return -1;
                      if (d[k + 4 >> 2] < 16) return -2;
                      if (!(o[k + 8 >> 2] | !o[k + 12 >> 2])) return -18;
                      if (T = o[k + 20 >> 2], !o[k + 16 >> 2]) return T ? -19 : -6;
                      if (T >>> 0 < 8) return -6;
                      if (!(o[k + 24 >> 2] | !o[k + 28 >> 2])) return -20;
                      if (!(o[k + 32 >> 2] | !o[k + 36 >> 2])) return -21;
                      if (!(T = o[k + 48 >> 2])) return -16;
                      if (T >>> 0 > 16777215) return -17;
                      if (M = -14, !((E = o[k + 44 >> 2]) >>> 0 < 8)) {
                        if (E >>> 0 > 2097152) return -15;
                        if (!(T << 3 >>> 0 > E >>> 0)) {
                          if (!o[k + 40 >> 2]) return -12;
                          if (!(k = o[k + 52 >> 2])) return -28;
                          M = k >>> 0 > 16777215 ? -29 : 0;
                        }
                      }
                      return M;
                    }
                    function Us(k, E) {
                      var T, M = 0, ye = 0;
                      T = E;
                      e: {
                        t: {
                          r: {
                            if (E &= 255) {
                              if (3 & k) for (; ; ) {
                                if (!(M = m[0 | k]) | (0 | E) == (0 | M)) break e;
                                if (!(3 & (k = k + 1 | 0))) break;
                              }
                              if ((-2139062144 & ((M = o[k >> 2]) | 16843008 - M)) != -2139062144) break r;
                              for (ye = v(E, 16843009); ; ) {
                                if ((-2139062144 & (16843008 - (E = M ^ ye) | E)) != -2139062144) break r;
                                if (M = o[k + 4 >> 2], k = E = k + 4 | 0, (-2139062144 & (16843008 - M | M)) != -2139062144) break;
                              }
                              break t;
                            }
                            k = sc(k) + k | 0;
                            break e;
                          }
                          E = k;
                        }
                        for (; ; ) {
                          if (!(M = m[0 | (k = E)])) break e;
                          if (E = k + 1 | 0, (0 | M) == (255 & T)) break;
                        }
                      }
                      return m[0 | k] == (255 & T) ? k : 0;
                    }
                    function Zs(k, E, T, M) {
                      var ye, Ne = 0;
                      return dr = ye = dr - 208 | 0, o[ye + 72 >> 2] = 0, o[ye + 76 >> 2] = 0, Ne = o[8591], o[ye + 8 >> 2] = o[8590], o[ye + 12 >> 2] = Ne, Ne = o[8593], o[ye + 16 >> 2] = o[8592], o[ye + 20 >> 2] = Ne, Ne = o[8595], o[ye + 24 >> 2] = o[8594], o[ye + 28 >> 2] = Ne, Ne = o[8597], o[ye + 32 >> 2] = o[8596], o[ye + 36 >> 2] = Ne, Ne = o[8599], o[ye + 40 >> 2] = o[8598], o[ye + 44 >> 2] = Ne, Ne = o[8601], o[ye + 48 >> 2] = o[8600], o[ye + 52 >> 2] = Ne, Ne = o[8603], o[ye + 56 >> 2] = o[8602], o[ye + 60 >> 2] = Ne, o[ye + 64 >> 2] = 0, o[ye + 68 >> 2] = 0, Ne = o[8589], o[ye >> 2] = o[8588], o[ye + 4 >> 2] = Ne, qs(ye, E, T, M), ds(ye, k), dr = ye + 208 | 0, 0;
                    }
                    function Ks(k) {
                      var E = 0;
                      return o[64 + (k |= 0) >> 2] = 0, o[k + 68 >> 2] = 0, o[k + 72 >> 2] = 0, o[k + 76 >> 2] = 0, E = o[8589], o[k >> 2] = o[8588], o[k + 4 >> 2] = E, E = o[8591], o[k + 8 >> 2] = o[8590], o[k + 12 >> 2] = E, E = o[8593], o[k + 16 >> 2] = o[8592], o[k + 20 >> 2] = E, E = o[8595], o[k + 24 >> 2] = o[8594], o[k + 28 >> 2] = E, E = o[8597], o[k + 32 >> 2] = o[8596], o[k + 36 >> 2] = E, E = o[8599], o[k + 40 >> 2] = o[8598], o[k + 44 >> 2] = E, E = o[8601], o[k + 48 >> 2] = o[8600], o[k + 52 >> 2] = E, E = o[8603], o[k + 56 >> 2] = o[8602], o[k + 60 >> 2] = E, 0;
                    }
                    function ha(k) {
                      return ~((127 & ~m[k + 31 | 0] | m[k + 1 | 0] & m[k + 2 | 0] & m[k + 3 | 0] & m[k + 4 | 0] & m[k + 5 | 0] & m[k + 6 | 0] & m[k + 7 | 0] & m[k + 8 | 0] & m[k + 9 | 0] & m[k + 10 | 0] & m[k + 11 | 0] & m[k + 12 | 0] & m[k + 13 | 0] & m[k + 14 | 0] & m[k + 15 | 0] & m[k + 16 | 0] & m[k + 17 | 0] & m[k + 18 | 0] & m[k + 19 | 0] & m[k + 20 | 0] & m[k + 21 | 0] & m[k + 22 | 0] & m[k + 23 | 0] & m[k + 24 | 0] & m[k + 25 | 0] & m[k + 26 | 0] & m[k + 27 | 0] & m[k + 28 | 0] & m[k + 30 | 0] & m[k + 29 | 0] ^ 255) - 1 & 236 - m[0 | k]) >>> 8 & 1;
                    }
                    function pa(k, E) {
                      var T, M = 0, ye = 0, Ne = 0, pr = 0;
                      if (B[15 + (T = dr - 16 | 0) | 0] = 0, E) {
                        if (E >>> 0 >= 4) for (pr = -4 & E; M = k + ye | 0, B[T + 15 | 0] = m[0 | M] | m[T + 15 | 0], B[T + 15 | 0] = m[M + 1 | 0] | m[T + 15 | 0], B[T + 15 | 0] = m[M + 2 | 0] | m[T + 15 | 0], B[T + 15 | 0] = m[M + 3 | 0] | m[T + 15 | 0], ye = ye + 4 | 0, (0 | pr) != (0 | (Ne = Ne + 4 | 0)); ) ;
                        if (M = 3 & E) for (E = 0; B[T + 15 | 0] = m[k + ye | 0] | m[T + 15 | 0], ye = ye + 1 | 0, (0 | M) != (0 | (E = E + 1 | 0)); ) ;
                      }
                      return m[T + 15 | 0] - 1 >>> 8 & 1;
                    }
                    function bi(k, E, T) {
                      var M, ye = 0, Ne = 0;
                      if (o[12 + (M = dr - 16 | 0) >> 2] = k, o[M + 8 >> 2] = E, k = 0, B[M + 7 | 0] = 0, T) {
                        if (E = 1 & T, (0 | T) != 1) for (Ne = -2 & T, T = 0; B[M + 7 | 0] = m[M + 7 | 0] | m[o[M + 12 >> 2] + k | 0] ^ m[o[M + 8 >> 2] + k | 0], ye = 1 | k, B[M + 7 | 0] = m[M + 7 | 0] | m[ye + o[M + 12 >> 2] | 0] ^ m[o[M + 8 >> 2] + ye | 0], k = k + 2 | 0, (0 | Ne) != (0 | (T = T + 2 | 0)); ) ;
                        E && (B[M + 7 | 0] = m[M + 7 | 0] | m[o[M + 12 >> 2] + k | 0] ^ m[o[M + 8 >> 2] + k | 0]);
                      }
                      return (m[M + 7 | 0] - 1 >>> 8 & 1) - 1 | 0;
                    }
                    function Ia(k) {
                      for (var E = 0, T = 0, M = 0, ye = 0, Ne = 0, pr = 0, ve = 0, cr = 0, gr = 0, Pr = 0; ye = (T = m[k + M | 0]) ^ m[0 | (E = M + 2688 | 0)] | ye, Ne = T ^ m[E + 192 | 0] | Ne, pr = T ^ m[E + 160 | 0] | pr, ve = T ^ m[E + 128 | 0] | ve, cr = T ^ m[E + 96 | 0] | cr, gr = T ^ m[E - -64 | 0] | gr, Pr = T ^ m[E + 32 | 0] | Pr, (0 | (M = M + 1 | 0)) != 31; ) ;
                      return ((255 & ((E = 127 ^ (k = 127 & m[k + 31 | 0])) | Ne)) - 1 | (255 & (E | pr)) - 1 | (255 & (E | ve)) - 1 | (255 & (122 ^ k | cr)) - 1 | (255 & (5 ^ k | gr)) - 1 | (255 & (k | Pr)) - 1 | (255 & (k | ye)) - 1) >>> 8 & 1;
                    }
                    function Ci(k, E, T) {
                      var M = 0, ye = 0, Ne = 0, pr = 0;
                      return ye = 31 & (Ne = pr = 63 & T), Ne = Ne >>> 0 >= 32 ? -1 >>> ye | 0 : (M = -1 >>> ye | 0) | (1 << ye) - 1 << 32 - ye, Ne &= k, M &= E, ye = 31 & pr, pr >>> 0 >= 32 ? (M = Ne << ye, pr = 0) : (M = (1 << ye) - 1 & Ne >>> 32 - ye | M << ye, pr = Ne << ye), Ne = M, M = 31 & (ye = 0 - T & 63), ye >>> 0 >= 32 ? (M = -1 << M, T = 0) : M = (T = -1 << M) | (1 << M) - 1 & -1 >>> 32 - M, k &= T, E &= M, M = 31 & ye, ye >>> 0 >= 32 ? (T = 0, k = E >>> M | 0) : (T = E >>> M | 0, k = ((1 << M) - 1 & E) << 32 - M | k >>> M), Qe = T | Ne, k | pr;
                    }
                    function Wh(k, E, T, M, ye, Ne) {
                      k |= 0, E |= 0, T |= 0;
                      var pr = 0, ve = 0;
                      e: t: {
                        r: {
                          if (!(!(ye |= 0) & (M |= 0) >>> 0 < 64 || (ve = 1 + (ye = ye - 1 | 0) | 0, pr = ye, !(M = (ye = M + -64 | 0) >>> 0 < 4294967232 ? ve : pr) & ye >>> 0 > 4294967231 | M))) {
                            if (!In(pr = T, T = T - -64 | 0, ye, M, Ne |= 0, 0)) break r;
                            k && Ca(k, 0, ye);
                          }
                          if (M = -1, !E) break t;
                          o[E >> 2] = 0, o[E + 4 >> 2] = 0, M = -1;
                          break e;
                        }
                        E && (o[E >> 2] = ye, o[E + 4 >> 2] = M), M = 0, k && Ef(k, T, ye);
                      }
                      return 0 | M;
                    }
                    function Jh(k, E, T, M, ye, Ne, pr, ve, cr, gr) {
                      var Pr, Nr, Br;
                      return dr = Pr = dr - 352 | 0, Lc(Br = Pr + 32 | 0, 64, 0, cr, gr), ac(Nr = Pr + 96 | 0, Br), _s(Br, 64), Da(Nr, Ne, pr, ve), Da(Nr, 35648, 0 - pr & 15, 0), Da(Nr, E, T, M), Da(Nr, 35648, 0 - T & 15, 0), o[Pr + 24 >> 2] = pr, o[Pr + 28 >> 2] = ve, Da(Nr, Ne = Pr + 24 | 0, 8, 0), o[Pr + 24 >> 2] = T, o[Pr + 28 >> 2] = M, Da(Nr, Ne, 8, 0), fc(Nr, Pr), _s(Nr, 256), Ne = pc(Pr, ye), _s(Pr, 16), k && (Ne ? (Ca(k, 0, T), Ne = -1) : (zc(k, E, T, M, cr, 1, gr), Ne = 0)), dr = Pr + 352 | 0, Ne;
                    }
                    function zh(k, E, T, M, ye, Ne) {
                      var pr, ve;
                      return k |= 0, E |= 0, T |= 0, M |= 0, Ne |= 0, dr = pr = dr - 32 | 0, ve = m[0 | (ye |= 0)] | m[ye + 1 | 0] << 8 | m[ye + 2 | 0] << 16 | m[ye + 3 | 0] << 24, ye = m[ye + 4 | 0] | m[ye + 5 | 0] << 8 | m[ye + 6 | 0] << 16 | m[ye + 7 | 0] << 24, o[pr + 24 >> 2] = 0, o[pr + 28 >> 2] = 0, o[pr + 16 >> 2] = ve, o[pr + 20 >> 2] = ye, o[pr + 8 >> 2] = 0, o[pr + 12 >> 2] = 0, o[pr >> 2] = T, o[pr + 4 >> 2] = M, E - 65 >>> 0 <= 4294967246 ? (o[9404] = 28, k = -1) : k = ya(k, E, 0, 0, 0, Ne, 32, pr, pr + 16 | 0), dr = pr + 32 | 0, 0 | k;
                    }
                    function Xh(k, E, T, M, ye) {
                      var Ne, pr;
                      return k |= 0, E |= 0, T |= 0, M |= 0, dr = Ne = dr - 512 | 0, tc(pr = Ne + 32 | 0, ye |= 0, 32), mc(pr, E, T, M), Fc(pr, Ne + 448 | 0), E = o[Ne + 476 >> 2], o[Ne + 24 >> 2] = o[Ne + 472 >> 2], o[Ne + 28 >> 2] = E, E = o[Ne + 468 >> 2], o[Ne + 16 >> 2] = o[Ne + 464 >> 2], o[Ne + 20 >> 2] = E, E = o[Ne + 460 >> 2], o[Ne + 8 >> 2] = o[Ne + 456 >> 2], o[Ne + 12 >> 2] = E, E = o[Ne + 452 >> 2], o[Ne >> 2] = o[Ne + 448 >> 2], o[Ne + 4 >> 2] = E, E = tu(k, Ne), T = bi(Ne, k, 32), dr = Ne + 512 | 0, ((0 | k) == (0 | Ne) ? -1 : E) | T;
                    }
                    function wh(k, E, T, M, ye, Ne, pr, ve, cr, gr) {
                      var Pr, Nr, Br;
                      return dr = Pr = dr - 352 | 0, ku(Br = Pr + 32 | 0, 64, 0, cr, gr), ac(Nr = Pr + 96 | 0, Br), _s(Br, 64), Da(Nr, Ne, pr, ve), o[Pr + 24 >> 2] = pr, o[Pr + 28 >> 2] = ve, Da(Nr, Ne = Pr + 24 | 0, 8, 0), Da(Nr, E, T, M), o[Pr + 24 >> 2] = T, o[Pr + 28 >> 2] = M, Da(Nr, Ne, 8, 0), fc(Nr, Pr), _s(Nr, 256), Ne = pc(Pr, ye), _s(Pr, 16), k && (Ne ? (Ca(k, 0, T), Ne = -1) : (Cc(k, E, T, M, cr, 1, 0, gr), Ne = 0)), dr = Pr + 352 | 0, Ne;
                    }
                    function Zh(k, E, T, M, ye, Ne, pr, ve, cr, gr, Pr) {
                      var Nr, Br, Mr;
                      return dr = Nr = dr - 336 | 0, Lc(Mr = Nr + 16 | 0, 64, 0, gr, Pr), ac(Br = Nr + 80 | 0, Mr), _s(Mr, 64), Da(Br, pr, ve, cr), Da(Br, 35648, 0 - ve & 15, 0), zc(k, M, ye, Ne, gr, 1, Pr), Da(Br, k, ye, Ne), Da(Br, 35648, 0 - ye & 15, 0), o[Nr + 8 >> 2] = ve, o[Nr + 12 >> 2] = cr, Da(Br, k = Nr + 8 | 0, 8, 0), o[Nr + 8 >> 2] = ye, o[Nr + 12 >> 2] = Ne, Da(Br, k, 8, 0), fc(Br, E), _s(Br, 256), T && (o[T >> 2] = 16, o[T + 4 >> 2] = 0), dr = Nr + 336 | 0, 0;
                    }
                    function Ih(k, E) {
                      var T, M = 0, ye = 0, Ne = 0, pr = 0, ve = 0;
                      e: if (!(((T = m[0 | k]) - 58 & 255) >>> 0 < 246)) {
                        for (M = T, ye = k; ; ) {
                          if (pr = ye, Ne >>> 0 > 429496729 || (M = (255 & M) - 48 | 0) >>> 0 > ~(Ne = v(Ne, 10)) >>> 0) break e;
                          if (Ne = Ne + M | 0, !(((M = m[0 | (ye = ye + 1 | 0)]) - 58 & 255) >>> 0 > 245)) break;
                        }
                        (0 | T) == 48 & (0 | k) != (0 | pr) | (0 | k) == (0 | ye) || (o[E >> 2] = Ne, ve = ye);
                      }
                      return ve;
                    }
                    function Qc(k) {
                      var E = 0, T = 0, M = 0, ye = 0;
                      E = 65, T = 1024;
                      e: {
                        t: {
                          if ((0 | (M = 255 & k)) != m[1024]) for (M = v(M, 16843009); ; ) {
                            if ((-2139062144 & ((ye = M ^ o[T >> 2]) | 16843008 - ye)) != -2139062144) break t;
                            if (T = T + 4 | 0, !((E = E - 4 | 0) >>> 0 > 3)) break;
                          }
                          if (!E) break e;
                        }
                        for (k &= 255; ; ) {
                          if ((0 | k) == m[0 | T]) return T;
                          if (T = T + 1 | 0, !(E = E - 1 | 0)) break;
                        }
                      }
                      return 0;
                    }
                    function bh(k, E, T, M, ye, Ne, pr, ve, cr, gr, Pr) {
                      var Nr, Br, Mr;
                      return dr = Nr = dr - 336 | 0, ku(Mr = Nr + 16 | 0, 64, 0, gr, Pr), ac(Br = Nr + 80 | 0, Mr), _s(Mr, 64), Da(Br, pr, ve, cr), o[Nr + 8 >> 2] = ve, o[Nr + 12 >> 2] = cr, Da(Br, pr = Nr + 8 | 0, 8, 0), Cc(k, M, ye, Ne, gr, 1, 0, Pr), Da(Br, k, ye, Ne), o[Nr + 8 >> 2] = ye, o[Nr + 12 >> 2] = Ne, Da(Br, pr, 8, 0), fc(Br, E), _s(Br, 256), T && (o[T >> 2] = 16, o[T + 4 >> 2] = 0), dr = Nr + 336 | 0, 0;
                    }
                    function Ku(k, E, T, M, ye, Ne) {
                      return !M & T >>> 0 >= 32 | M ? (Rh(k, E, T, M, ye, Ne), Dl(k + 16 | 0, k + 32 | 0, T - 32 | 0, M - (T >>> 0 < 32) | 0, k), B[k + 8 | 0] = 0, B[k + 9 | 0] = 0, B[k + 10 | 0] = 0, B[k + 11 | 0] = 0, B[k + 12 | 0] = 0, B[k + 13 | 0] = 0, B[k + 14 | 0] = 0, B[k + 15 | 0] = 0, B[0 | k] = 0, B[k + 1 | 0] = 0, B[k + 2 | 0] = 0, B[k + 3 | 0] = 0, B[k + 4 | 0] = 0, B[k + 5 | 0] = 0, B[k + 6 | 0] = 0, B[k + 7 | 0] = 0, k = 0) : k = -1, k;
                    }
                    function sc(k) {
                      var E = 0, T = 0, M = 0;
                      e: {
                        t: if (3 & (E = k)) {
                          if (!m[0 | E]) return 0;
                          for (; ; ) {
                            if (!(3 & (E = E + 1 | 0))) break t;
                            if (!m[0 | E]) break;
                          }
                          break e;
                        }
                        for (; T = E, E = E + 4 | 0, (-2139062144 & ((M = o[T >> 2]) | 16843008 - M)) == -2139062144; ) ;
                        for (; T = (E = T) + 1 | 0, m[0 | E]; ) ;
                      }
                      return E - k | 0;
                    }
                    function el(k, E, T, M, ye, Ne) {
                      E |= 0, ye |= 0, Ne |= 0;
                      var pr, ve = 0;
                      return dr = pr = dr - 16 | 0, Gr(k |= 0, pr + 8 | 0, Ef(k - -64 | 0, T |= 0, M |= 0), M, ye, Ne, 0), o[pr + 12 >> 2] | o[pr + 8 >> 2] != 64 ? (E && (o[E >> 2] = 0, o[E + 4 >> 2] = 0), Ca(k, 0, M - -64 | 0), ve = -1) : E && (o[E >> 2] = M - -64, o[E + 4 >> 2] = ye - ((M >>> 0 < 4294967232) - 1 | 0)), dr = pr + 16 | 0, 0 | ve;
                    }
                    function ju(k, E) {
                      var T, M = 0, ye = 0, Ne = 0, pr = 0;
                      return (T = Qc(m[0 | E])) && (M = Qc(m[E + 1 | 0])) && (ye = Qc(m[E + 2 | 0])) && (Ne = Qc(m[E + 3 | 0])) && (pr = Qc(m[E + 4 | 0])) ? (o[k >> 2] = T - 1024 | M - 1024 << 6 | ye - 1024 << 12 | Ne - 1024 << 18 | pr - 1024 << 24, E + 5 | 0) : (o[k >> 2] = 0, 0);
                    }
                    function tl(k, E, T) {
                      var M;
                      for (o[12 + (M = dr - 16 | 0) >> 2] = k, o[M + 8 >> 2] = E, k = 0, o[M + 4 >> 2] = 0; o[M + 4 >> 2] = o[M + 4 >> 2] | m[o[M + 12 >> 2] + k | 0] ^ m[o[M + 8 >> 2] + k | 0], E = 1 | k, o[M + 4 >> 2] = o[M + 4 >> 2] | m[E + o[M + 12 >> 2] | 0] ^ m[E + o[M + 8 >> 2] | 0], (0 | T) != (0 | (k = k + 2 | 0)); ) ;
                      return (o[M + 4 >> 2] - 1 >>> 8 & 1) - 1 | 0;
                    }
                    function Eh(k, E, T, M, ye, Ne, pr, ve, cr, gr, Pr) {
                      var Nr = 0, Br = 0, Mr = 0;
                      return Br = -1, (Nr = M >>> 0 < 32) & !ye || !(Nr = ye - Nr | 0) & (Mr = M - 32 | 0) >>> 0 > 4294967263 | Nr | !ve & pr >>> 0 > 4294967263 | ve || (Br = 0 | Af[o[Pr >> 2]](k, T, Mr, (T + M | 0) - 32 | 0, 32, Ne, pr, cr, gr)), E && (o[E >> 2] = Br ? 0 : M - 32 | 0, o[E + 4 >> 2] = Br ? 0 : ye - (M >>> 0 < 32) | 0), Br;
                    }
                    function rl(k, E) {
                      var T, M = 0, ye = 0, Ne = 0;
                      dr = T = dr - 896 | 0, Va(M = T + 848 | 0, E), Va(ye = T + 800 | 0, E + 32 | 0), Lo(Ne = T + 320 | 0, M), Lo(E = T + 160 | 0, ye), $a(M = T + 640 | 0, E), Aa(E = T + 480 | 0, Ne, M), Ti(T, E, M = T + 600 | 0), Ti(T + 40 | 0, ye = T + 520 | 0, Ne = T + 560 | 0), Ti(T + 80 | 0, Ne, M), Ti(T + 120 | 0, E, ye), po(k, T), dr = T + 896 | 0;
                    }
                    function Eu(k) {
                      var E = 0, T = 0, M = 0, ye = 0, Ne = 0;
                      for (E = 1; T = (M = E) + m[0 | (E = k + ye | 0)] | 0, B[0 | E] = T, T = m[E + 1 | 0] + (T >>> 8 | 0) | 0, B[E + 1 | 0] = T, T = m[E + 2 | 0] + (T >>> 8 | 0) | 0, B[E + 2 | 0] = T, M = E, E = m[E + 3 | 0] + (T >>> 8 | 0) | 0, B[M + 3 | 0] = E, E = E >>> 8 | 0, ye = ye + 4 | 0, (0 | (Ne = Ne + 4 | 0)) != 4; ) ;
                    }
                    function il(k, E, T, M, ye, Ne, pr) {
                      var ve;
                      return dr = ve = dr - 16 | 0, k = Ca(k, 0, 128), !(M | Ne) & pr >>> 0 < 2147483649 ? (!Ne & ye >>> 0 >= 3 | !!(0 | Ne)) & pr >>> 0 > 8191 ? (Sf(ve, 16), k = sa(ye, pr >>> 10 | 0, E, T, ve, k, 1) ? -1 : 0) : (o[9404] = 28, k = -1) : (o[9404] = 22, k = -1), dr = ve + 16 | 0, k;
                    }
                    function Bh(k, E) {
                      var T = 0;
                      4 & E && ((E = o[k >> 2]) && _s(o[E + 4 >> 2], o[k + 16 >> 2] << 10), (E = o[k + 4 >> 2]) && _s(E, o[k + 20 >> 2] << 3)), js(o[k + 4 >> 2]), o[k + 4 >> 2] = 0, (E = o[k >> 2]) && (T = o[E >> 2]) && js(T), js(E), o[k >> 2] = 0;
                    }
                    function _h(k, E, T, M, ye, Ne, pr, ve, cr, gr, Pr) {
                      return !ye & M >>> 0 > 4294967263 | !!(0 | ye) | !ve & pr >>> 0 >= 4294967264 | !!(0 | ve) ? (Wa(), ji()) : (k = 0 | Af[o[Pr >> 2]](k, k + M | 0, 32, T, M, Ne, pr, cr, gr), E && (M = (T = M + 32 | 0) >>> 0 < 32 ? ye + 1 | 0 : ye, o[E >> 2] = k ? 0 : T, o[E + 4 >> 2] = k ? 0 : M)), k;
                    }
                    function gc(k) {
                      var E = 0, T = 0, M = 0, ye = 0, Ne = 0, pr = 0, ve = 0, cr = 0;
                      for (E = 32, T = 1; cr |= (ye = m[(M = E - 2 | 0) + k | 0]) - (Ne = m[M + 2912 | 0]) >> 8 & (E = ((pr = m[2912 + (E = E - 1 | 0) | 0]) ^ (ve = m[k + E | 0])) - 1 >> 8 & T) | ve - pr >> 8 & T, T = E & (ye ^ Ne) - 1 >> 8, E = M; ) ;
                      return !!(255 & cr);
                    }
                    function nl(k, E, T, M, ye, Ne, pr) {
                      var ve;
                      return dr = ve = dr - 16 | 0, k = Ca(k, 0, 128), !(M | Ne) & pr >>> 0 < 2147483649 ? !!(ye | Ne) & pr >>> 0 > 8191 ? (Sf(ve, 16), k = sa(ye, pr >>> 10 | 0, E, T, ve, k, 2) ? -1 : 0) : (o[9404] = 28, k = -1) : (o[9404] = 22, k = -1), dr = ve + 16 | 0, k;
                    }
                    function Gu(k) {
                      var E = 0;
                      return o[32 + (k |= 0) >> 2] = 0, o[k + 36 >> 2] = 0, E = o[8809], o[k >> 2] = o[8808], o[k + 4 >> 2] = E, E = o[8811], o[k + 8 >> 2] = o[8810], o[k + 12 >> 2] = E, E = o[8813], o[k + 16 >> 2] = o[8812], o[k + 20 >> 2] = E, E = o[8815], o[k + 24 >> 2] = o[8814], o[k + 28 >> 2] = E, 0;
                    }
                    function ol(k, E, T, M, ye, Ne, pr) {
                      var ve, cr, gr = 0, Pr = 0;
                      return dr = ve = dr + -64 | 0, gr = -1, (cr = T >>> 0 < 16) & !M || Gf(Pr = ve + 32 | 0, pr, Ne) || ba(ve, 35584, Pr, 0) || (gr = oo(k, E + 16 | 0, E, T - 16 | 0, M - cr | 0, ye, ve), _s(ve, 32)), dr = ve - -64 | 0, gr;
                    }
                    function Zr(k, E, T, M) {
                      var ye, Ne, pr, ve, cr = 0, gr = 0;
                      return ve = v(cr = T >>> 16 | 0, gr = k >>> 16 | 0), cr = (65535 & (gr = ((pr = v(ye = 65535 & T, Ne = 65535 & k)) >>> 16 | 0) + v(gr, ye) | 0)) + v(cr, Ne) | 0, Qe = (v(E, T) + ve | 0) + v(k, M) + (gr >>> 16) + (cr >>> 16) | 0, 65535 & pr | cr << 16;
                    }
                    function Jc(k, E, T) {
                      var M = 0, ye = 0;
                      if (!T) return 0;
                      if (M = m[0 | k]) e: {
                        for (; ; ) {
                          if ((0 | (ye = m[0 | E])) != (0 | M) | !ye || !(T = T - 1 | 0)) break e;
                          if (E = E + 1 | 0, M = m[k + 1 | 0], k = k + 1 | 0, !M) break;
                        }
                        M = 0;
                      }
                      else M = 0;
                      return M - m[0 | E] | 0;
                    }
                    function zc(k, E, T, M, ye, Ne, pr) {
                      var ve = 0, cr = 0;
                      if (ve = M, !((((ve = (cr = T + 63 | 0) >>> 0 < 63 ? ve + 1 | 0 : ve) >>> 6 | 0) + !!(0 | (ve = (63 & ve) << 26 | cr >>> 6)) | 0) == 1 & Ne >>> 0 > (cr = 0 - ve | 0) >>> 0 | (0 | M) == 1 | M >>> 0 > 1)) return 0 | Af[o[9199]](k, E, T, M, ye, Ne, pr);
                      Wa(), ji();
                    }
                    function kh(k, E, T, M, ye, Ne, pr) {
                      var ve;
                      return k |= 0, E |= 0, T |= 0, M |= 0, ye |= 0, dr = ve = dr + -64 | 0, Gf(ve + 32 | 0, pr |= 0, Ne |= 0) ? Ne = -1 : (Ne = -1, ea(ve, 35664, ve + 32 | 0, 0) || (Ne = Ku(k, E, T, M, ye, ve), _s(ve, 32))), dr = ve - -64 | 0, 0 | Ne;
                    }
                    function al(k, E, T, M, ye, Ne, pr) {
                      var ve;
                      return k |= 0, E |= 0, T |= 0, M |= 0, ye |= 0, dr = ve = dr + -64 | 0, Gf(ve + 32 | 0, pr |= 0, Ne |= 0) ? Ne = -1 : (Ne = -1, ea(ve, 35664, ve + 32 | 0, 0) || (Ne = $o(k, E, T, M, ye, ve), _s(ve, 32))), dr = ve - -64 | 0, 0 | Ne;
                    }
                    function Xa(k, E, T, M, ye, Ne, pr) {
                      var ve;
                      if (dr = ve = dr + -64 | 0, !M & T >>> 0 < 4294967280) return Gf(ve + 32 | 0, pr, Ne) ? pr = -1 : (pr = -1, ba(ve, 35584, ve + 32 | 0, 0) || (pr = Ai(k + 16 | 0, k, E, T, M, ye, ve), _s(ve, 32))), dr = ve - -64 | 0, pr;
                      Wa(), ji();
                    }
                    function Sh(k, E) {
                      for (var T = 0, M = 0, ye = 0, Ne = 0, pr = 0; M = k + ye | 0, T = m[E + ye | 0] + (m[0 | M] + T | 0) | 0, B[0 | M] = T, Ne = (M = 1 | ye) + k | 0, T = m[E + M | 0] + (m[0 | Ne] + (T >>> 8 | 0) | 0) | 0, B[0 | Ne] = T, T = T >>> 8 | 0, ye = ye + 2 | 0, (0 | (pr = pr + 2 | 0)) != 32; ) ;
                    }
                    function Th(k, E) {
                      for (var T = 0, M = 0, ye = 0, Ne = 0, pr = 0; T = (m[0 | (M = k + ye | 0)] - m[E + ye | 0] | 0) + T | 0, B[0 | M] = T, T = (m[0 | (Ne = (M = 1 | ye) + k | 0)] - m[E + M | 0] | 0) + (T >> 8) | 0, B[0 | Ne] = T, T >>= 8, ye = ye + 2 | 0, (0 | (pr = pr + 2 | 0)) != 64; ) ;
                    }
                    function Sf(k, E) {
                      k |= 0;
                      var T, M = 0, ye = 0, Ne = 0;
                      if (dr = T = dr - 16 | 0, E |= 0) for (; B[T + 15 | 0] = 0, ye = k + M | 0, Ne = 0 | Be(36800, T + 15 | 0, 0), B[0 | ye] = Ne, (0 | (M = M + 1 | 0)) != (0 | E); ) ;
                      dr = T + 16 | 0;
                    }
                    function fl(k, E, T, M, ye, Ne, pr) {
                      var ve, cr, gr = 0;
                      return dr = ve = dr - 32 | 0, gr = -1, (cr = T >>> 0 < 16) & !M || xu(ve, Ne, pr) || (gr = Ki(k, E + 16 | 0, E, T - 16 | 0, M - cr | 0, ye, ve), _s(ve, 32)), dr = ve + 32 | 0, gr;
                    }
                    function bc(k) {
                      var E, T;
                      e: {
                        if (!((k = (E = o[8924]) + (T = k + 7 & -8) | 0) >>> 0 <= E >>> 0 && T) && (k >>> 0 <= jl() << 16 >>> 0 || 0 | wr(0 | k)))
                          break e;
                        return o[9404] = 48, -1;
                      }
                      return o[8924] = k, E;
                    }
                    function Rc(k, E) {
                      var T, M, ye;
                      dr = T = dr - 176 | 0, ia(M = T + 96 | 0, E + 80 | 0), Ti(ye = T + 48 | 0, E, M), Ti(T, E + 40 | 0, M), i2(k, T), i2(T + 144 | 0, ye), B[k + 31 | 0] = m[k + 31 | 0] ^ m[T + 144 | 0] << 7, dr = T + 176 | 0;
                    }
                    function cl(k, E, T, M, ye, Ne, pr, ve, cr, gr) {
                      var Pr, Nr, Br = 0, Mr = 0, jr = 0;
                      return dr = Pr = dr - 16 | 0, Br = -1, yc(Nr = Pr + 4 | 0) || (Mr = -1, jr = Pa(Nr, k, E, T, M, ye, Ne, pr, ve, cr, gr), Br = Ju(Nr) ? Mr : jr), dr = Pr + 16 | 0, Br;
                    }
                    function ul(k, E, T, M, ye, Ne, pr, ve, cr, gr, Pr, Nr) {
                      return T && (o[T >> 2] = 32, o[T + 4 >> 2] = 0), !cr & ve >>> 0 < 4294967264 & !Ne & ye >>> 0 <= 4294967263 || (Wa(), ji()), 0 | Af[o[Nr >> 2]](k, E, 32, M, ye, pr, ve, gr, Pr);
                    }
                    function Ef(k, E, T) {
                      var M = 0;
                      if (k >>> 0 < E >>> 0) return fa(k, E, T);
                      if (T) for (M = k + T | 0, E = E + T | 0; E = E - 1 | 0, B[0 | (M = M - 1 | 0)] = m[0 | E], T = T - 1 | 0; ) ;
                      return k;
                    }
                    function Al(k, E, T, M, ye, Ne, pr) {
                      var ve, cr = 0;
                      if (dr = ve = dr - 32 | 0, !M & T >>> 0 < 4294967280) return cr = -1, xu(ve, Ne, pr) || (cr = Bi(k + 16 | 0, k, E, T, M, ye, ve), _s(ve, 32)), dr = ve + 32 | 0, cr;
                      Wa(), ji();
                    }
                    function $u(k, E, T, M, ye, Ne) {
                      return E |= 0, 0 | (!(M |= 0) & (T |= 0) >>> 0 >= 16 | M ? Ki(k |= 0, E + 16 | 0, E, T - 16 | 0, M - (T >>> 0 < 16) | 0, ye |= 0, Ne |= 0) : -1);
                    }
                    function ll(k, E, T, M, ye, Ne) {
                      return E |= 0, 0 | (!(M |= 0) & (T |= 0) >>> 0 >= 16 | M ? oo(k |= 0, E + 16 | 0, E, T - 16 | 0, M - (T >>> 0 < 16) | 0, ye |= 0, Ne |= 0) : -1);
                    }
                    function Dh(k, E, T, M, ye, Ne, pr, ve, cr, gr, Pr) {
                      return !M & T >>> 0 > 4294967263 | M | !ve & pr >>> 0 > 4294967263 | ve ? -1 : 0 | Af[o[Pr >> 2]](k, E, T, ye, 32, Ne, pr, cr, gr);
                    }
                    function dl(k, E, T) {
                      k |= 0;
                      var M, ye = 0;
                      return dr = M = dr - 32 | 0, ye = -1, Gf(M, T |= 0, E |= 0) || (ye = ea(k, 35664, M, 0)), dr = M + 32 | 0, 0 | ye;
                    }
                    function Fc(k, E) {
                      var T;
                      return E |= 0, dr = T = dr + -64 | 0, ds(k |= 0, T), qs(k = k + 208 | 0, T, 64, 0), ds(k, E), _s(T, 64), dr = T - -64 | 0, 0;
                    }
                    function pl(k, E, T, M) {
                      var ye;
                      return E |= 0, T |= 0, M |= 0, dr = ye = dr + -64 | 0, ds(k |= 0, ye), k = Gr(E, T, ye, 64, 0, M, 1), dr = ye - -64 | 0, 0 | k;
                    }
                    function Yu(k, E) {
                      var T, M, ye;
                      Ti(k, E, T = E + 120 | 0), Ti(k + 40 | 0, M = E + 40 | 0, ye = E + 80 | 0), Ti(k + 80 | 0, ye, T), Ti(k + 120 | 0, E, M);
                    }
                    function xh(k, E, T, M, ye, Ne, pr) {
                      return 0 | nl(k |= 0, E |= 0, (k = 0) | (T |= 0), M |= 0, k | (ye |= 0), Ne |= 0, pr |= 0);
                    }
                    function au(k, E) {
                      var T;
                      return E |= 0, dr = T = dr - 32 | 0, wn(k |= 0, T), Mf(k = k + 104 | 0, T, 32, 0), wn(k, E), _s(T, 32), dr = T + 32 | 0, 0;
                    }
                    function fa(k, E, T) {
                      var M = 0;
                      if (T) for (M = k; B[0 | M] = m[0 | E], M = M + 1 | 0, E = E + 1 | 0, T = T - 1 | 0; ) ;
                      return k;
                    }
                    function Rh(k, E, T, M, ye, Ne) {
                      var pr;
                      return dr = pr = dr - 32 | 0, ea(pr, ye, Ne, 0), k = cu(k, E, T, M, ye + 16 | 0, 0, 0, pr), _s(pr, 32), dr = pr + 32 | 0, k;
                    }
                    function Ph(k) {
                      for (k |= 0; Sf(k, 32), B[k + 31 | 0] = 31 & m[k + 31 | 0], !gc(k) || pa(k, 32); ) ;
                    }
                    function gl(k, E, T) {
                      var M;
                      return E |= 0, T |= 0, dr = M = dr + -64 | 0, ds(k |= 0, M), k = In(E, M, 64, 0, T, 1), dr = M - -64 | 0, 0 | k;
                    }
                    function yl(k, E, T, M, ye) {
                      var Ne;
                      return dr = Ne = dr - 32 | 0, ea(Ne, M, ye, 0), k = Nh(k, E, T, M + 16 | 0, Ne), _s(Ne, 32), dr = Ne + 32 | 0, k;
                    }
                    function Ca(k, E, T) {
                      var M = 0;
                      if (T) for (M = k; B[0 | M] = E, M = M + 1 | 0, T = T - 1 | 0; ) ;
                      return k;
                    }
                    function Bu(k, E, T) {
                      return k |= 0, E |= 0, (T |= 0) >>> 0 >= 256 && (Me(1366, 1279, 107, 1123), ji()), 0 | Wo(k, E, 255 & T);
                    }
                    function ml(k, E, T, M, ye, Ne, pr) {
                      return 0 | Bi(k |= 0, E |= 0, T |= 0, M |= 0, ye |= 0, Ne |= 0, pr |= 0);
                    }
                    function vl(k, E, T, M, ye, Ne, pr) {
                      return 0 | Ki(k |= 0, E |= 0, T |= 0, M |= 0, ye |= 0, Ne |= 0, pr |= 0);
                    }
                    function wl(k, E, T, M, ye, Ne, pr) {
                      return 0 | Ai(k |= 0, E |= 0, T |= 0, M |= 0, ye |= 0, Ne |= 0, pr |= 0);
                    }
                    function Cc(k, E, T, M, ye, Ne, pr, ve) {
                      return (0 | M) == 1 | M >>> 0 > 1 && (Wa(), ji()), 0 | Af[o[9198]](k, E, T, M, ye, Ne, pr, ve);
                    }
                    function _u(k, E, T, M, ye, Ne, pr) {
                      return 0 | oo(k |= 0, E |= 0, T |= 0, M |= 0, ye |= 0, Ne |= 0, pr |= 0);
                    }
                    function Vu(k, E, T, M, ye, Ne) {
                      return (0 | M) == 1 | M >>> 0 > 1 && (Wa(), ji()), 0 | Af[o[9198]](k, E, T, M, ye, 0, 0, Ne);
                    }
                    function Wu(k, E, T, M, ye, Ne) {
                      return (0 | M) == 1 | M >>> 0 > 1 && (Wa(), ji()), 0 | Af[o[9199]](k, E, T, M, ye, 0, Ne);
                    }
                    function Il(k, E, T, M, ye, Ne) {
                      return Gr(k |= 0, E |= 0, T |= 0, M |= 0, ye |= 0, Ne |= 0, 0), 0;
                    }
                    function Ju(k) {
                      var E;
                      return (E = o[k >> 2]) && js(E), o[k + 8 >> 2] = 0, o[k >> 2] = 0, o[k + 4 >> 2] = 0, 0;
                    }
                    function ao(k, E) {
                      var T = 0;
                      return (-1 >>> (T = 31 & E) & k) << T | ((T = k) & -1 << (k = 0 - E & 31)) >>> k;
                    }
                    function zu(k, E, T, M, ye, Ne) {
                      return 0 | Ku(k |= 0, E |= 0, T |= 0, M |= 0, ye |= 0, Ne |= 0);
                    }
                    function Xu(k, E, T, M, ye, Ne) {
                      return 0 | $o(k |= 0, E |= 0, T |= 0, M |= 0, ye |= 0, Ne |= 0);
                    }
                    function Zu(k, E, T, M, ye, Ne) {
                      return 0 | Rh(k |= 0, E |= 0, T |= 0, M |= 0, ye |= 0, Ne |= 0);
                    }
                    function Lc(k, E, T, M, ye) {
                      return (0 | T) == 1 | T >>> 0 > 1 && (Wa(), ji()), 0 | Af[o[9197]](k, E, T, M, ye);
                    }
                    function ku(k, E, T, M, ye) {
                      return (0 | T) == 1 | T >>> 0 > 1 && (Wa(), ji()), 0 | Af[o[9196]](k, E, T, M, ye);
                    }
                    function Ec(k, E, T, M, ye, Ne) {
                      (0 | M) == 1 | M >>> 0 > 1 && (Wa(), ji()), Af[o[9199]](k, E, T, M, ye, 1, Ne);
                    }
                    function bl(k, E, T, M, ye) {
                      return 0 | In(k |= 0, E |= 0, T |= 0, M |= 0, ye |= 0, 0);
                    }
                    function Cl(k, E, T, M, ye) {
                      return 0 | Dl(k |= 0, E |= 0, T |= 0, M |= 0, ye |= 0);
                    }
                    function Su(k, E, T, M, ye) {
                      return 0 | sA(k |= 0, E |= 0, T |= 0, M |= 0, ye |= 0);
                    }
                    function El(k, E, T, M, ye) {
                      return 0 | yl(k |= 0, E |= 0, T |= 0, M |= 0, ye |= 0);
                    }
                    function Bl() {
                      var k;
                      dr = k = dr - 16 | 0, B[k + 15 | 0] = 0, Be(36836, k + 15 | 0, 0), dr = k + 16 | 0;
                    }
                    function Tu(k, E, T, M) {
                      return Xs(k |= 0, E |= 0, T |= 0, M |= 0, 20), 0;
                    }
                    function Du(k, E, T, M) {
                      return Xs(k |= 0, E |= 0, T |= 0, M |= 0, 12), 0;
                    }
                    function fu(k, E, T, M) {
                      return Xs(k |= 0, E |= 0, T |= 0, M |= 0, 8), 0;
                    }
                    function _l(k, E, T, M) {
                      return 0 | Zs(k |= 0, E |= 0, T |= 0, M |= 0);
                    }
                    function kl(k, E, T, M) {
                      return 0 | Da(k |= 0, E |= 0, T |= 0, M |= 0);
                    }
                    function Xc(k, E, T, M) {
                      return 0 | qs(k |= 0, E |= 0, T |= 0, M |= 0);
                    }
                    function Zc(k, E, T, M) {
                      return 0 | Na(k |= 0, E |= 0, T |= 0, M |= 0);
                    }
                    function cu(k, E, T, M, ye, Ne, pr, ve) {
                      return 0 | Af[o[8933]](k, E, T, M, ye, Ne, pr, ve);
                    }
                    function Sl(k, E, T, M) {
                      return 0 | mc(k |= 0, E |= 0, T |= 0, M |= 0);
                    }
                    function eA(k, E, T, M, ye, Ne) {
                      return 0 | Af[o[8933]](k, E, T, M, ye, 0, 0, Ne);
                    }
                    function yc(k) {
                      return o[k + 8 >> 2] = 0, o[k >> 2] = 0, o[k + 4 >> 2] = 0, 0;
                    }
                    function xu(k, E, T) {
                      return 0 | dl(k |= 0, E |= 0, T |= 0);
                    }
                    function Mh(k, E, T) {
                      return 0 | Gf(k |= 0, E |= 0, T |= 0);
                    }
                    function Wa() {
                      var k;
                      (k = o[9538]) && Af[0 | k](), Hl(), ji();
                    }
                    function eu(k, E, T) {
                      return 0 | Bu(k |= 0, E |= 0, T |= 0);
                    }
                    function Tl(k, E, T) {
                      return 0 | tc(k |= 0, E |= 0, T |= 0);
                    }
                    function Ru(k, E) {
                      return k |= 0, Sf(E |= 0, 32), 0 | lA(k, E);
                    }
                    function Dl(k, E, T, M, ye) {
                      return 0 | Af[o[8925]](k, E, T, M, ye);
                    }
                    function Nh(k, E, T, M, ye) {
                      return 0 | Af[o[8932]](k, E, T, M, ye);
                    }
                    function sA(k, E, T, M, ye) {
                      return 0 | Af[o[8926]](k, E, T, M, ye);
                    }
                    function lA(k, E) {
                      return k |= 0, E |= 0, 0 | Af[o[8931]](k, E);
                    }
                    function ac(k, E) {
                      return k |= 0, E |= 0, 0 | Af[o[8927]](k, E);
                    }
                    function fc(k, E) {
                      return k |= 0, E |= 0, 0 | Af[o[8929]](k, E);
                    }
                    function dA(k, E, T, M, ye, Ne, pr) {
                      return Ko(k, E, T, M, ye, Ne, pr);
                    }
                    function pA(k) {
                      return k ? 31 - he(k - 1 ^ k) | 0 : 32;
                    }
                    function Da(k, E, T, M) {
                      return 0 | Af[o[8928]](k, E, T, M);
                    }
                    function tu(k, E) {
                      return 0 | tl(k |= 0, E |= 0, 32);
                    }
                    function xl(k, E) {
                      return 0 | tl(k |= 0, E |= 0, 64);
                    }
                    function Rl(k, E, T) {
                      $r(k |= 0, E |= 0, T |= 0);
                    }
                    function Oh(k, E) {
                      return 0 | lA(k |= 0, E |= 0);
                    }
                    function Pl(k, E) {
                      return 0 | Ru(k |= 0, E |= 0);
                    }
                    function wA(k, E, T, M) {
                      return su(k, E, T, M, 1);
                    }
                    function Ml(k, E, T, M) {
                      return hs(k, E, T, M, 1);
                    }
                    function Sa(k, E, T, M) {
                      return hs(k, E, T, M, 2);
                    }
                    function Nl(k, E, T, M) {
                      return su(k, E, T, M, 2);
                    }
                    function mc(k, E, T, M) {
                      return qs(k, E, T, M), 0;
                    }
                    function vc(k, E, T, M) {
                      return Mf(k, E, T, M), 0;
                    }
                    function Qf(k, E, T, M) {
                      return E2(k, E, T, M);
                    }
                    function Ol(k) {
                      return Ks(k |= 0), 0;
                    }
                    function Uh() {
                      return -2147483648;
                    }
                    function uu() {
                      return 1073741824;
                    }
                    function PA() {
                      return 268435456;
                    }
                    function eh() {
                      return 33554432;
                    }
                    function cf(k) {
                      Sf(k |= 0, 32);
                    }
                    function Ul() {
                      return 67108864;
                    }
                    function Pu(k) {
                      Sf(k |= 0, 16);
                    }
                    function Ql() {
                      return 16777216;
                    }
                    function _s(k, E) {
                      Ca(k, 0, E);
                    }
                    function Fl() {
                      return 1564;
                    }
                    function th() {
                      return 1338;
                    }
                    function Qh() {
                      return 8192;
                    }
                    function ih() {
                      return 384;
                    }
                    function Fh() {
                      return 256;
                    }
                    function nh() {
                      return 416;
                    }
                    function oh() {
                      return 128;
                    }
                    function Mu() {
                      return 208;
                    }
                    function pf() {
                      return 64;
                    }
                    function Ra() {
                      return 16;
                    }
                    function Js() {
                      return 32;
                    }
                    function Fa() {
                      return -65;
                    }
                    function Ll() {
                      return -33;
                    }
                    function Lh() {
                      return 48;
                    }
                    function wc() {
                      return -17;
                    }
                    function ql() {
                      return 12;
                    }
                    function rc() {
                      return 24;
                    }
                    function D2() {
                      return -1;
                    }
                    function Bc() {
                      return 2;
                    }
                    function ah() {
                      return 3;
                    }
                    function $f() {
                      return 8;
                    }
                    function ru() {
                      return 1;
                    }
                    function qh() {
                      return 4;
                    }
                    function Yf() {
                      return 0;
                    }
                    function Hl() {
                      fr(), ji();
                    }
                    Yr(dn = m, 1024, "Li8wMTIzNDU2Nzg5QUJDREVGR0hJSktMTU5PUFFSU1RVVldYWVphYmNkZWZnaGlqa2xtbm9wcXJzdHV2d3h5egBqcwByYW5kb21ieXRlcwBiNjRfcG9zIDw9IGI2NF9sZW4AY3J5cHRvX2dlbmVyaWNoYXNoX2JsYWtlMmJfZmluYWwAYXJnb24yaWQsYXJnb24yaQAkYXJnb24yaQAkYXJnb24yaWQAcmFuZG9tYnl0ZXMvcmFuZG9tYnl0ZXMuYwBzb2RpdW0vY29kZWNzLmMAY3J5cHRvX2dlbmVyaWNoYXNoL2JsYWtlMmIvcmVmL2JsYWtlMmItcmVmLmMAY3J5cHRvX2dlbmVyaWNoYXNoL2JsYWtlMmIvcmVmL2dlbmVyaWNoYXNoX2JsYWtlMmIuYwB4MjU1MTlibGFrZTJiAGJ1Zl9sZW4gPD0gU0laRV9NQVgAb3V0bGVuIDw9IFVJTlQ4X01BWABTLT5idWZsZW4gPD0gQkxBS0UyQl9CTE9DS0JZVEVTACRhcmdvbjJpJHY9ACRhcmdvbjJpZCR2PQBjdXJ2ZTI1NTE5AGVkMjU1MTkAaG1hY3NoYTUxMjI1NgBjdXJ2ZTI1NTE5eHNhbHNhMjBwb2x5MTMwNQBzb2RpdW1fYmluMmJhc2U2NABzaXBoYXNoMjQAc2hhNTEyAHhzYWxzYTIwADEuMC4yMAAkYXJnb24yaSQAJGFyZ29uMmlkJAAkNyQAAAAAAAC2eFn/hXLTAL1uFf8PCmoAKcABAJjoef+8PKD/mXHO/wC34v60DUj/AAAAAAAAAACwoA7+08mG/54YjwB/aTUAYAy9AKfX+/+fTID+amXh/x78BACSDK4="), Yr(dn, 1680, "WfGy/grlpv973Sr+HhTUAFKAAwAw0fMAd3lA/zLjnP8AbsUBZxuQ"), Yr(dn, 1728, "hTuMAb3xJP/4JcMBYNw3ALdMPv/DQj0AMkykAeGkTP9MPaP/dT4fAFGRQP92QQ4AonPW/waKLgB85vT/CoqPADQawgC49EwAgY8pAb70E/97qnr/YoFEAHnVkwBWZR7/oWebAIxZQ//v5b4BQwu1AMbwif7uRbz/Q5fuABMqbP/lVXEBMkSH/xFqCQAyZwH/UAGoASOYHv8QqLkBOFno/2XS/AAp+kcAzKpP/w4u7/9QTe8AvdZL/xGN+QAmUEz/vlV1AFbkqgCc2NABw8+k/5ZCTP+v4RD/jVBiAUzb8gDGonIALtqYAJsr8f6boGj/M7ulAAIRrwBCVKAB9zoeACNBNf5F7L8ALYb1AaN73QAgbhT/NBelALrWRwDpsGAA8u82ATlZigBTAFT/iKBkAFyOeP5ofL4AtbE+//opVQCYgioBYPz2AJeXP/7vhT4AIDicAC2nvf+OhbMBg1bTALuzlv76qg7/0qNOACU0lwBjTRoA7pzV/9XA0QFJLlQAFEEpATbOTwDJg5L+qm8Y/7EhMv6rJsv/Tvd0ANHdmQCFgLIBOiwZAMknOwG9E/wAMeXSAXW7dQC1s7gBAHLbADBekwD1KTgAfQ3M/vStdwAs3SD+VOoUAPmgxgHsfur/L2Oo/qrimf9ms9gA4o16/3pCmf629YYA4+QZAdY56//YrTj/tefSAHeAnf+BX4j/bn4zAAKpt/8HgmL+RbBe/3QE4wHZ8pH/yq0fAWkBJ/8ur0UA5C86/9fgRf7POEX/EP6L/xfP1P/KFH7/X9Vg/wmwIQDIBc//8SqA/iMhwP/45cQBgRF4APtnl/8HNHD/jDhC/yji9f/ZRiX+rNYJ/0hDhgGSwNb/LCZwAES4S//OWvsAleuNALWqOgB09O8AXJ0CAGatYgDpiWABfzHLAAWblAAXlAn/03oMACKGGv/bzIgAhggp/+BTK/5VGfcAbX8A/qmIMADud9v/563VAM4S/v4Iugf/fgkHAW8qSABvNOz+YD+NAJO/f/7NTsD/DmrtAbvbTACv87v+aVmtAFUZWQGi85QAAnbR/iGeCQCLoy7/XUYoAGwqjv5v/I7/m9+QADPlp/9J/Jv/XnQM/5ig2v+c7iX/s+rP/8UAs/+apI0A4cRoAAojGf7R1PL/Yf3e/rhl5QDeEn8BpIiH/x7PjP6SYfMAgcAa/slUIf9vCk7/k1Gy/wQEGACh7tf/Bo0hADXXDv8ptdD/54udALPL3f//uXEAveKs/3FC1v/KPi3/ZkAI/06uEP6FdUT/"), Yr(dn, 2720, "AQ=="), Yr(dn, 2752, "JuiVj8KyJ7BFw/SJ8u+Y8NXfrAXTxjM5sTgCiG1T/AXHF2pwPU3YT7o8C3YNEGcPKiBT+iw5zMZOx/13kqwDeuz///////////////////////////////////////9/7f///////////////////////////////////////3/u////////////////////////////////////////f+3T9VwaYxJY1pz3ot753hQ="), Yr(dn, 2943, "EP1AXQCgaj8AOdNX/gzSugBYvHT+QdgBAP/IPQHYQpT/APtcACSy4f8AAAAAAAAAAIU7jAG98ST/+CXDAWDcNwC3TD7/w0I9ADJMpAHhpEz/TD2j/3U+HwBRkUD/dkEOAKJz1v8Gii4AfOb0/wqKjwA0GsIAuPRMAIGPKQG+9BP/e6p6/2KBRAB51ZMAVmUe/6FnmwCMWUP/7+W+AUMLtQDG8In+7kW8/+pxPP8l/zn/RbK2/oDQswB2Gn3+AwfW//EyTf9Vy8X/04f6/xkwZP+71bT+EVhpAFPRngEFc2IABK48/qs3bv/ZtRH/FLyqAJKcZv5X1q7/cnqbAeksqgB/CO8B1uzqAK8F2wAxaj3/BkLQ/wJqbv9R6hP/12vA/0OX7gATKmz/5VVxATJEh/8RagkAMmcB/1ABqAEjmB7/EKi5AThZ6P9l0vwAKfpHAMyqT/8OLu//UE3vAL3WS/8RjfkAJlBM/75VdQBW5KoAnNjQAcPPpP+WQkz/r+EQ/41QYgFM2/IAxqJyAC7amACbK/H+m6Bo/7IJ/P5kbtQADgWnAOnvo/8cl50BZZIK//6eRv5H+eQAWB4yAEQ6oP+/GGgBgUKB/8AyVf8Is4r/JvrJAHNQoACD5nEAfViTAFpExwD9TJ4AHP92AHH6/gBCSy4A5torAOV4ugGURCsAiHzuAbtrxf9UNfb/M3T+/zO7pQACEa8AQlSgAfc6HgAjQTX+Rey/AC2G9QGje90AIG4U/zQXpQC61kcA6bBgAPLvNgE5WYoAUwBU/4igZABcjnj+aHy+ALWxPv/6KVUAmIIqAWD89gCXlz/+74U+ACA4nAAtp73/joWzAYNW0wC7s5b++qoO/0RxFf/eujv/QgfxAUUGSABWnGz+N6dZAG002/4NsBf/xCxq/++VR/+kjH3/n60BADMp5wCRPiEAim9dAblTRQCQcy4AYZcQ/xjkGgAx2eIAcUvq/sGZDP+2MGD/Dg0aAIDD+f5FwTsAhCVR/n1qPADW8KkBpONCANKjTgAlNJcAY00aAO6c1f/VwNEBSS5UABRBKQE2zk8AyYOS/qpvGP+xITL+qybL/073dADR3ZkAhYCyATosGQDJJzsBvRP8ADHl0gF1u3UAtbO4AQBy2wAwXpMA9Sk4AH0NzP70rXcALN0g/lTqFAD5oMYB7H7q/48+3QCBWdb/N4sF/kQUv/8OzLIBI8PZAC8zzgEm9qUAzhsG/p5XJADZNJL/fXvX/1U8H/+rDQcA2vVY/vwjPAA31qD/hWU4AOAgE/6TQOoAGpGiAXJ2fQD4/PoAZV7E/8aN4v4zKrYAhwwJ/m2s0v/F7MIB8UGaADCcL/+ZQzf/2qUi/kq0swDaQkcBWHpjANS12/9cKuf/7wCaAPVNt/9eUaoBEtXYAKtdRwA0XvgAEpeh/sXRQv+u9A/+ojC3ADE98P62XcMAx+QGAcgFEf+JLe3/bJQEAFpP7f8nP03/NVLPAY4Wdv9l6BIBXBpDAAXIWP8hqIr/leFIAALRG/8s9agB3O0R/x7Taf6N7t0AgFD1/m/+DgDeX74B3wnxAJJM1P9szWj/P3WZAJBFMAAj5G8AwCHB/3DWvv5zmJcAF2ZYADNK+ADix4/+zKJl/9BhvQH1aBIA5vYe/xeURQBuWDT+4rVZ/9AvWv5yoVD/IXT4ALOYV/9FkLEBWO4a/zogcQEBTUUAO3k0/5juUwA0CMEA5yfp/8ciigDeRK0AWzny/tzSf//AB/b+lyO7AMPspQBvXc4A1PeFAZqF0f+b5woAQE4mAHr5ZAEeE2H/Plv5AfiFTQDFP6j+dApSALjscf7Uy8L/PWT8/iQFyv93W5n/gU8dAGdnq/7t12//2DVFAO/wFwDCld3/JuHeAOj/tP52UoX/OdGxAYvohQCesC7+wnMuAFj35QEcZ78A3d6v/pXrLACX5Bn+2mlnAI5V0gCVgb7/1UFe/nWG4P9SxnUAnd3cAKNlJADFciUAaKym/gu2AABRSLz/YbwQ/0UGCgDHk5H/CAlzAUHWr//ZrdEAUH+mAPflBP6nt3z/WhzM/q878P8LKfgBbCgz/5Cxw/6W+n4AiltBAXg83v/1we8AHda9/4ACGQBQmqIATdxrAerNSv82pmf/dEgJAOReL/8eyBn/I9ZZ/z2wjP9T4qP/S4KsAIAmEQBfiZj/13yfAU9dAACUUp3+w4L7/yjKTP/7fuAAnWM+/s8H4f9gRMMAjLqd/4MT5/8qgP4ANNs9/mbLSACNBwv/uqTVAB96dwCF8pEA0Pzo/1vVtv+PBPr++ddKAKUebwGrCd8A5XsiAVyCGv9Nmy0Bw4sc/zvgTgCIEfcAbHkgAE/6vf9g4/z+JvE+AD6uff+bb13/CubOAWHFKP8AMTn+QfoNABL7lv/cbdL/Ba6m/iyBvQDrI5P/JfeN/0iNBP9na/8A91oEADUsKgACHvAABDs/AFhOJABxp7QAvkfB/8eepP86CKwATSEMAEE/AwCZTSH/rP5mAeTdBP9XHv4BkilW/4rM7/5sjRH/u/KHANLQfwBELQ7+SWA+AFE8GP+qBiT/A/kaACPVbQAWgTb/FSPh/+o9OP862QYAj3xYAOx+QgDRJrf/Iu4G/66RZgBfFtMAxA+Z/i5U6P91IpIB5/pK/xuGZAFcu8P/qsZwAHgcKgDRRkMAHVEfAB2oZAGpraAAayN1AD5gO/9RDEUBh+++/9z8EgCj3Dr/iYm8/1NmbQBgBkwA6t7S/7muzQE8ntX/DfHWAKyBjABdaPIAwJz7ACt1HgDhUZ4Af+jaAOIcywDpG5f/dSsF//IOL/8hFAYAifss/hsf9f+31n3+KHmVALqe1f9ZCOMARVgA/suH4QDJrssAk0e4ABJ5Kf5eBU4A4Nbw/iQFtAD7h+cBo4rUANL5dP5YgbsAEwgx/j4OkP+fTNMA1jNSAG115P5n38v/S/wPAZpH3P8XDVsBjahg/7W2hQD6MzcA6urU/q8/ngAn8DQBnr0k/9UoVQEgtPf/E2YaAVQYYf9FFd4AlIt6/9zV6wHoy/8AeTmTAOMHmgA1FpMBSAHhAFKGMP5TPJ3/kUipACJn7wDG6S8AdBME/7hqCf+3gVMAJLDmASJnSADbooYA9SqeACCVYP6lLJAAyu9I/teWBQAqQiQBhNevAFauVv8axZz/MeiH/me2UgD9gLABmbJ6APX6CgDsGLIAiWqEACgdKQAyHpj/fGkmAOa/SwCPK6oALIMU/ywNF//t/5sBn21k/3C1GP9o3GwAN9ODAGMM1f+Yl5H/7gWfAGGbCAAhbFEAAQNnAD5tIv/6m7QAIEfD/yZGkQGfX/UAReVlAYgc8ABP4BkATm55//iofAC7gPcAApPr/k8LhABGOgwBtQij/0+Jhf8lqgv/jfNV/7Dn1//MlqT/79cn/y5XnP4Io1j/rCLoAEIsZv8bNin+7GNX/yl7qQE0cisAdYYoAJuGGgDnz1v+I4Qm/xNmff4k44X/dgNx/x0NfACYYEoBWJLO/6e/3P6iElj/tmQXAB91NABRLmoBDAIHAEVQyQHR9qwADDCNAeDTWAB04p8AemKCAEHs6gHh4gn/z+J7AVnWOwBwh1gBWvTL/zELJgGBbLoAWXAPAWUuzP9/zC3+T//d/zNJEv9/KmX/8RXKAKDjBwBpMuwATzTF/2jK0AG0DxAAZcVO/2JNywApufEBI8F8ACObF//PNcAAC32jAfmeuf8EgzAAFV1v/z155wFFyCT/uTC5/2/uFf8nMhn/Y9ej/1fUHv+kkwX/gAYjAWzfbv/CTLIASmW0APMvMACuGSv/Uq39ATZywP8oN1sA12yw/ws4BwDg6UwA0WLK/vIZfQAswV3+ywixAIewEwBwR9X/zjuwAQRDGgAOj9X+KjfQ/zxDeADBFaMAY6RzAAoUdgCc1N7+oAfZ/3L1TAF1O3sAsMJW/tUPsABOzs/+1YE7AOn7FgFgN5j/7P8P/8VZVP9dlYUArqBxAOpjqf+YdFgAkKRT/18dxv8iLw//Y3iG/wXswQD5937/k7seADLmdf9s2dv/o1Gm/0gZqf6beU//HJtZ/gd+EQCTQSEBL+r9ABozEgBpU8f/o8TmAHH4pADi/toAvdHL/6T33v7/I6UABLzzAX+zRwAl7f7/ZLrwAAU5R/5nSEn/9BJR/uXShP/uBrT/C+Wu/+PdwAERMRwAo9fE/gl2BP8z8EcAcYFt/0zw5wC8sX8AfUcsARqv8wBeqRn+G+YdAA+LdwGoqrr/rMVM//xLvACJfMQASBZg/y2X+QHckWQAQMCf/3jv4gCBspIAAMB9AOuK6gC3nZIAU8fA/7isSP9J4YAATQb6/7pBQwBo9s8AvCCK/9oY8gBDilH+7YF5/xTPlgEpxxD/BhSAAJ92BQC1EI//3CYPABdAk/5JGg0AV+Q5Acx8gAArGN8A22PHABZLFP8TG34AnT7XAG4d5gCzp/8BNvy+AN3Mtv6znkH/UZ0DAMLanwCq3wAA4Asg/ybFYgCopCUAF1gHAaS6bgBgJIYA6vLlAPp5EwDy/nD/Ay9eAQnvBv9Rhpn+1v2o/0N84AD1X0oAHB4s/gFt3P+yWVkA/CRMABjGLv9MTW8AhuqI/ydeHQC5SOr/RkSH/+dmB/5N54wApy86AZRhdv8QG+EBps6P/26y1v+0g6IAj43hAQ3aTv9ymSEBYmjMAK9ydQGnzksAysRTATpAQwCKL28BxPeA/4ng4P6ecM8AmmT/AYYlawDGgE//f9Gb/6P+uf48DvMAH9tw/h3ZQQDIDXT+ezzE/+A7uP7yWcQAexBL/pUQzgBF/jAB53Tf/9GgQQHIUGIAJcK4/pQ/IgCL8EH/2ZCE/zgmLf7HeNIAbLGm/6DeBADcfnf+pWug/1Lc+AHxr4gAkI0X/6mKVACgiU7/4nZQ/zQbhP8/YIv/mPonALybDwDoM5b+KA/o//DlCf+Jrxv/S0lhAdrUCwCHBaIBa7nVAAL5a/8o8kYA28gZABmdDQBDUlD/xPkX/5EUlQAySJIAXkyUARj7QQAfwBcAuNTJ/3vpogH3rUgAolfb/n6GWQCfCwz+pmkdAEkb5AFxeLf/QqNtAdSPC/+f56gB/4BaADkOOv5ZNAr//QijAQCR0v8KgVUBLrUbAGeIoP5+vNH/IiNvANfbGP/UC9b+ZQV2AOjFhf/fp23/7VBW/0aLXgCewb8Bmw8z/w++cwBOh8//+QobAbV96QBfrA3+qtWh/yfsiv9fXVf/voBfAH0PzgCmlp8A4w+e/86eeP8qjYAAZbJ4AZxtgwDaDiz+96jO/9RwHABwEeT/WhAlAcXebAD+z1P/CVrz//P0rAAaWHP/zXR6AL/mwQC0ZAsB2SVg/5pOnADr6h//zrKy/5XA+wC2+ocA9hZpAHzBbf8C0pX/qRGqAABgbv91CQgBMnso/8G9YwAi46AAMFBG/tMz7AAtevX+LK4IAK0l6f+eQasAekXX/1pQAv+DamD+43KHAM0xd/6wPkD/UjMR//EU8/+CDQj+gNnz/6IbAf5advEA9sb2/zcQdv/In50AoxEBAIxreQBVoXb/JgCVAJwv7gAJpqYBS2K1/zJKGQBCDy8Ai+GfAEwDjv8O7rgAC881/7fAugGrIK7/v0zdAfeq2wAZrDL+2QnpAMt+RP+3XDAAf6e3AUEx/gAQP38B/hWq/zvgf/4WMD//G06C/ijDHQD6hHD+I8uQAGipqADP/R7/aCgm/l7kWADOEID/1Dd6/98W6gDfxX8A/bW1AZFmdgDsmST/1NlI/xQmGP6KPj4AmIwEAObcY/8BFdT/lMnnAPR7Cf4Aq9IAMzol/wH/Dv/0t5H+APKmABZKhAB52CkAX8Ny/oUYl/+c4uf/9wVN//aUc/7hXFH/3lD2/qp7Wf9Kx40AHRQI/4qIRv9dS1wA3ZMx/jR+4gDlfBcALgm1AM1ANAGD/hwAl57UAINATgDOGasAAOaLAL/9bv5n96cAQCgoASql8f87S+T+fPO9/8Rcsv+CjFb/jVk4AZPGBf/L+J7+kKKNAAus4gCCKhX/AaeP/5AkJP8wWKT+qKrcAGJH1gBb0E8An0zJAaYq1v9F/wD/BoB9/74BjACSU9r/1+5IAXp/NQC9dKX/VAhC/9YD0P/VboUAw6gsAZ7nRQCiQMj+WzpoALY6u/755IgAy4ZM/mPd6QBL/tb+UEWaAECY+P7siMr/nWmZ/pWvFAAWIxP/fHnpALr6xv6E5YsAiVCu/6V9RACQypT+6+/4AIe4dgBlXhH/ekhG/kWCkgB/3vgBRX92/x5S1/68ShP/5afC/nUZQv9B6jj+1RacAJc7Xf4tHBv/un6k/yAG7wB/cmMB2zQC/2Ngpv4+vn7/bN6oAUvirgDm4scAPHXa//z4FAHWvMwAH8KG/ntFwP+prST+N2JbAN8qZv6JAWYAnVoZAO96QP/8BukABzYU/1J0rgCHJTb/D7p9AONwr/9ktOH/Ku30//St4v74EiEAq2OW/0rrMv91UiD+aqjtAM9t0AHkCboAhzyp/rNcjwD0qmj/6y18/0ZjugB1ibcA4B/XACgJZAAaEF8BRNlXAAiXFP8aZDr/sKXLATR2RgAHIP7+9P71/6eQwv99cRf/sHm1AIhU0QCKBh7/WTAcACGbDv8Z8JoAjc1tAUZzPv8UKGv+iprH/17f4v+dqyYAo7EZ/i12A/8O3hcB0b5R/3Z76AEN1WX/ezd7/hv2pQAyY0z/jNYg/2FBQ/8YDBwArlZOAUD3YACgh0MAQjfz/5PMYP8aBiH/YjNTAZnV0P8CuDb/GdoLADFD9v4SlUj/DRlIACpP1gAqBCYBG4uQ/5W7FwASpIQA9VS4/njGaP9+2mAAOHXq/w0d1v5ELwr/p5qE/pgmxgBCsln/yC6r/w1jU//Su/3/qi0qAYrRfADWoo0ADOacAGYkcP4Dk0MANNd7/+mrNv9iiT4A99on/+fa7AD3v38Aw5JUAKWwXP8T1F7/EUrjAFgomQHGkwH/zkP1/vAD2v89jdX/YbdqAMPo6/5fVpoA0TDN/nbR8f/weN8B1R2fAKN/k/8N2l0AVRhE/kYUUP+9BYwBUmH+/2Njv/+EVIX/a9p0/3B6LgBpESAAwqA//0TeJwHY/VwAsWnN/5XJwwAq4Qv/KKJzAAkHUQCl2tsAtBYA/h2S/P+Sz+EBtIdgAB+jcACxC9v/hQzB/itOMgBBcXkBO9kG/25eGAFwrG8ABw9gACRVewBHlhX/0Em8AMALpwHV9SIACeZcAKKOJ//XWhsAYmFZAF5P0wBanfAAX9x+AWaw4gAkHuD+Ix9/AOfocwFVU4IA0kn1/y+Pcv9EQcUAO0g+/7eFrf5deXb/O7FR/+pFrf/NgLEA3PQzABr00QFJ3k3/owhg/paV0wCe/ssBNn+LAKHgOwAEbRb/3iot/9CSZv/sjrsAMs31/wpKWf4wT44A3kyC/x6mPwDsDA3/Mbj0ALtxZgDaZf0AmTm2/iCWKgAZxpIB7fE4AIxEBQBbpKz/TpG6/kM0zQDbz4EBbXMRADaPOgEV+Hj/s/8eAMHsQv8B/wf//cAw/xNF2QED1gD/QGWSAd99I//rSbP/+afiAOGvCgFhojoAanCrAVSsBf+FjLL/hvWOAGFaff+6y7n/300X/8BcagAPxnP/2Zj4AKuyeP/khjUAsDbBAfr7NQDVCmQBIsdqAJcf9P6s4Ff/Du0X//1VGv9/J3T/rGhkAPsORv/U0Ir//dP6ALAxpQAPTHv/Jdqg/1yHEAEKfnL/RgXg//f5jQBEFDwB8dK9/8PZuwGXA3EAl1yuAOc+sv/bt+EAFxch/821UAA5uPj/Q7QB/1p7Xf8nAKL/YPg0/1RCjAAif+T/wooHAaZuvAAVEZsBmr7G/9ZQO/8SB48ASB3iAcfZ+QDooUcBlb7JANmvX/5xk0P/io/H/3/MAQAdtlMBzuab/7rMPAAKfVX/6GAZ//9Z9//V/q8B6MFRABwrnP4MRQgAkxj4ABLGMQCGPCMAdvYS/zFY/v7kFbr/tkFwAdsWAf8WfjT/vTUx/3AZjwAmfzf/4mWj/tCFPf+JRa4BvnaR/zxi2//ZDfX/+ogKAFT+4gDJH30B8DP7/x+Dgv8CijL/19exAd8M7v/8lTj/fFtE/0h+qv53/2QAgofo/w5PsgD6g8UAisbQAHnYi/53EiT/HcF6ABAqLf/V8OsB5r6p/8Yj5P5urUgA1t3x/ziUhwDAdU7+jV3P/49BlQAVEmL/Xyz0AWq/TQD+VQj+1m6w/0mtE/6gxMf/7VqQAMGscf/Im4j+5FrdAIkxSgGk3df/0b0F/2nsN/8qH4EBwf/sAC7ZPACKWLv/4lLs/1FFl/+OvhABDYYIAH96MP9RQJwAq/OLAO0j9gB6j8H+1HqSAF8p/wFXhE0ABNQfABEfTgAnLa3+GI7Z/18JBv/jUwYAYjuC/j4eIQAIc9MBomGA/we4F/50HKj/+IqX/2L08AC6doIAcvjr/2mtyAGgfEf/XiSkAa9Bkv/u8ar+ysbFAORHiv4t9m3/wjSeAIW7sABT/Jr+Wb3d/6pJ/ACUOn0AJEQz/ipFsf+oTFb/JmTM/yY1IwCvE2EA4e79/1FRhwDSG//+60lrAAjPcwBSf4gAVGMV/s8TiABkpGUAUNBN/4TP7f8PAw//IaZuAJxfVf8luW8Blmoj/6aXTAByV4f/n8JAAAx6H//oB2X+rXdiAJpH3P6/OTX/qOig/+AgY//anKUAl5mjANkNlAHFcVkAlRyh/s8XHgBphOP/NuZe/4WtzP9ct53/WJD8/mYhWgCfYQMAtdqb//BydwBq1jX/pb5zAZhb4f9Yaiz/0D1xAJc0fAC/G5z/bjbsAQ4epv8nf88B5cccALzkvP5knesA9tq3AWsWwf/OoF8ATO+TAM+hdQAzpgL/NHUK/kk44/+YweEAhF6I/2W/0QAga+X/xiu0AWTSdgByQ5n/F1ga/1maXAHceIz/kHLP//xz+v8izkgAioV//wiyfAFXS2EAD+Vc/vBDg/92e+P+knho/5HV/wGBu0b/23c2AAETrQAtlpQB+FNIAMvpqQGOazgA9/kmAS3yUP8e6WcAYFJGABfJbwBRJx7/obdO/8LqIf9E44z+2M50AEYb6/9okE8ApOZd/taHnACau/L+vBSD/yRtrgCfcPEABW6VASSl2gCmHRMBsi5JAF0rIP74ve0AZpuNAMldw//xi/3/D29i/2xBo/6bT77/Sa7B/vYoMP9rWAv+ymFV//3MEv9x8kIAbqDC/tASugBRFTwAvGin/3ymYf7ShY4AOPKJ/ilvggBvlzoBb9WN/7es8f8mBsT/uQd7/y4L9gD1aXcBDwKh/wjOLf8Sykr/U3xzAdSNnQBTCNH+iw/o/6w2rf4y94QA1r3VAJC4aQDf/vgA/5Pw/xe8SAAHMzYAvBm0/ty0AP9ToBQAo73z/zrRwv9XSTwAahgxAPX53AAWracAdgvD/xN+7QBunyX/O1IvALS7VgC8lNABZCWF/wdwwQCBvJz/VGqB/4XhygAO7G//KBRlAKysMf4zNkr/+7m4/12b4P+0+eAB5rKSAEg5Nv6yPrgAd81IALnv/f89D9oAxEM4/+ogqwEu2+QA0Gzq/xQ/6P+lNccBheQF/zTNawBK7oz/lpzb/u+ssv/7vd/+II7T/9oPigHxxFAAHCRi/hbqxwA97dz/9jklAI4Rjv+dPhoAK+5f/gPZBv/VGfABJ9yu/5rNMP4TDcD/9CI2/owQmwDwtQX+m8E8AKaABP8kkTj/lvDbAHgzkQBSmSoBjOySAGtc+AG9CgMAP4jyANMnGAATyqEBrRu6/9LM7/4p0aL/tv6f/6x0NADDZ97+zUU7ADUWKQHaMMIAUNLyANK8zwC7oaH+2BEBAIjhcQD6uD8A3x5i/k2oogA7Na8AE8kK/4vgwgCTwZr/1L0M/gHIrv8yhXEBXrNaAK22hwBesXEAK1nX/4j8av97hlP+BfVC/1IxJwHcAuAAYYGxAE07WQA9HZsBy6vc/1xOiwCRIbX/qRiNATeWswCLPFD/2idhAAKTa/88+EgAreYvAQZTtv8QaaL+idRR/7S4hgEn3qT/3Wn7Ae9wfQA/B2EAP2jj/5Q6DABaPOD/VNT8AE/XqAD43ccBc3kBACSseAAgorv/OWsx/5MqFQBqxisBOUpXAH7LUf+Bh8MAjB+xAN2LwgAD3tcAg0TnALFWsv58l7QAuHwmAUajEQD5+7UBKjfjAOKhLAAX7G4AM5WOAV0F7ADat2r+QxhNACj10f/eeZkApTkeAFN9PABGJlIB5Qa8AG3enf83dj//zZe6AOMhlf/+sPYB47HjACJqo/6wK08Aal9OAbnxev+5Dj0AJAHKAA2yov/3C4QAoeZcAUEBuf/UMqUBjZJA/57y2gAVpH0A1Yt6AUNHVwDLnrIBl1wrAJhvBf8nA+//2f/6/7A/R/9K9U0B+q4S/yIx4//2Lvv/miMwAX2dPf9qJE7/YeyZAIi7eP9xhqv/E9XZ/the0f/8BT0AXgPKAAMat/9Avyv/HhcVAIGNTf9meAcBwkyMALyvNP8RUZQA6FY3AeEwrACGKir/7jIvAKkS/gAUk1f/DsPv/0X3FwDu5YD/sTFwAKhi+/95R/gA8wiR/vbjmf/bqbH++4ul/wyjuf+kKKv/mZ8b/vNtW//eGHABEtbnAGudtf7DkwD/wmNo/1mMvv+xQn7+arlCADHaHwD8rp4AvE/mAe4p4ADU6ggBiAu1AKZ1U/9Ew14ALoTJAPCYWACkOUX+oOAq/zvXQ/93w43/JLR5/s8vCP+u0t8AZcVE//9SjQH6iekAYVaFARBQRQCEg58AdF1kAC2NiwCYrJ3/WitbAEeZLgAnEHD/2Yhh/9zGGf6xNTEA3liG/4APPADPwKn/wHTR/2pO0wHI1bf/Bwx6/t7LPP8hbsf++2p1AOThBAF4Ogf/3cFU/nCFGwC9yMn/i4eWAOo3sP89MkEAmGyp/9xVAf9wh+MAohq6AM9guf70iGsAXZkyAcZhlwBuC1b/j3Wu/3PUyAAFyrcA7aQK/rnvPgDseBL+Yntj/6jJwv4u6tYAv4Ux/2OpdwC+uyMBcxUt//mDSABwBnv/1jG1/qbpIgBcxWb+/eTN/wM7yQEqYi4A2yUj/6nDJgBefMEBnCvfAF9Ihf54zr8AesXv/7G7T//+LgIB+qe+AFSBEwDLcab/+R+9/kidyv/QR0n/zxhIAAoQEgHSUUz/WNDA/37za//ujXj/x3nq/4kMO/8k3Hv/lLM8/vAMHQBCAGEBJB4m/3MBXf9gZ+f/xZ47AcCk8ADKyjn/GK4wAFlNmwEqTNcA9JfpABcwUQDvfzT+44Il//h0XQF8hHYArf7AAQbrU/9ur+cB+xy2AIH5Xf5UuIAATLU+AK+AugBkNYj+bR3iAN3pOgEUY0oAABagAIYNFQAJNDf/EVmMAK8iOwBUpXf/4OLq/wdIpv97c/8BEtb2APoHRwHZ3LkA1CNM/yZ9rwC9YdIAcu4s/ym8qf4tupoAUVwWAISgwQB50GL/DVEs/8ucUgBHOhX/0HK//jImkwCa2MMAZRkSADz61//phOv/Z6+OARAOXACNH27+7vEt/5nZ7wFhqC//+VUQARyvPv85/jYA3ud+AKYtdf4SvWD/5EwyAMj0XgDGmHgBRCJF/wxBoP5lE1oAp8V4/0Q2uf8p2rwAcagwAFhpvQEaUiD/uV2kAeTw7f9CtjUAq8Vc/2sJ6QHHeJD/TjEK/22qaf9aBB//HPRx/0o6CwA+3Pb/eZrI/pDSsv9+OYEBK/oO/2VvHAEvVvH/PUaW/zVJBf8eGp4A0RpWAIrtSgCkX7wAjjwd/qJ0+P+7r6AAlxIQANFvQf7Lhif/WGwx/4MaR//dG9f+aGld/x/sH/6HANP/j39uAdRJ5QDpQ6f+wwHQ/4QR3f8z2VoAQ+sy/9/SjwCzNYIB6WrGANmt3P9w5Rj/r5pd/kfL9v8wQoX/A4jm/xfdcf7rb9UAqnhf/vvdAgAtgp7+aV7Z//I0tP7VRC3/aCYcAPSeTAChyGD/zzUN/7tDlACqNvgAd6Ky/1MUCwAqKsABkp+j/7fobwBN5RX/RzWPABtMIgD2iC//2ye2/1zgyQETjg7/Rbbx/6N29QAJbWoBqrX3/04v7v9U0rD/1WuLACcmCwBIFZYASIJFAM1Nm/6OhRUAR2+s/uIqO/+zANcBIYDxAOr8DQG4TwgAbh5J//aNvQCqz9oBSppF/4r2Mf+bIGQAfUpp/1pVPf8j5bH/Pn3B/5lWvAFJeNQA0Xv2/ofRJv+XOiwBXEXW/w4MWP/8mab//c9w/zxOU//jfG4AtGD8/zV1If6k3FL/KQEb/yakpv+kY6n+PZBG/8CmEgBr+kIAxUEyAAGzEv//aAH/K5kj/1BvqABur6gAKWkt/9sOzf+k6Yz+KwF2AOlDwwCyUp//ild6/9TuWv+QI3z+GYykAPvXLP6FRmv/ZeNQ/lypNwDXKjEAcrRV/yHoGwGs1RkAPrB7/iCFGP/hvz4AXUaZALUqaAEWv+D/yMiM//nqJQCVOY0AwzjQ//6CRv8grfD/HdzHAG5kc/+E5fkA5Onf/yXY0f6ysdH/ty2l/uBhcgCJYaj/4d6sAKUNMQHS68z//AQc/kaglwDovjT+U/hd/z7XTQGvr7P/oDJCAHkw0AA/qdH/ANLIAOC7LAFJolIACbCP/xNMwf8dO6cBGCuaABy+vgCNvIEA6OvL/+oAbf82QZ8APFjo/3n9lv786YP/xm4pAVNNR//IFjv+av3y/xUMz//tQr0AWsbKAeGsfwA1FsoAOOaEAAFWtwBtvioA80SuAW3kmgDIsXoBI6C3/7EwVf9a2qn/+JhOAMr+bgAGNCsAjmJB/z+RFgBGal0A6IprAW6zPf/TgdoB8tFcACNa2QG2j2r/dGXZ/3L63f+tzAYAPJajAEmsLP/vblD/7UyZ/qGM+QCV6OUAhR8o/66kdwBxM9YAgeQC/kAi8wBr4/T/rmrI/1SZRgEyIxAA+krY/uy9Qv+Z+Q0A5rIE/90p7gB243n/XleM/v53XABJ7/b+dVeAABPTkf+xLvwA5Vv2AUWA9//KTTYBCAsJ/5lgpgDZ1q3/hsACAQDPAAC9rmsBjIZkAJ7B8wG2ZqsA65ozAI4Fe/88qFkB2Q5c/xPWBQHTp/4ALAbK/ngS7P8Pcbj/uN+LACixd/62e1r/sKWwAPdNwgAb6ngA5wDW/zsnHgB9Y5H/lkREAY3e+ACZe9L/bn+Y/+Uh1gGH3cUAiWECAAyPzP9RKbwAc0+C/14DhACYr7v/fI0K/37As/8LZ8YAlQYtANtVuwHmErL/SLaYAAPGuP+AcOABYaHmAP5jJv86n8UAl0LbADtFj/+5cPkAd4gv/3uChACoR1//cbAoAei5rQDPXXUBRJ1s/2YFk/4xYSEAWUFv/vceo/982d0BZvrYAMauS/45NxIA4wXsAeXVrQDJbdoBMenvAB43ngEZsmoAm2+8AV5+jADXH+4BTfAQANXyGQEmR6gAzbpd/jHTjP/bALT/hnalAKCThv9uuiP/xvMqAPOSdwCG66MBBPGH/8Euwf5ntE//4QS4/vJ2ggCSh7AB6m8eAEVC1f4pYHsAeV4q/7K/w/8ugioAdVQI/+kx1v7uem0ABkdZAezTewD0DTD+d5QOAHIcVv9L7Rn/keUQ/oFkNf+Glnj+qJ0yABdIaP/gMQ4A/3sW/5e5l/+qULgBhrYUAClkZQGZIRAATJpvAVbO6v/AoKT+pXtd/wHYpP5DEa//qQs7/54pPf9JvA7/wwaJ/xaTHf8UZwP/9oLj/3oogADiLxj+IyQgAJi6t/9FyhQAw4XDAN4z9wCpq14BtwCg/0DNEgGcUw//xTr5/vtZbv8yClj+MyvYAGLyxgH1l3EAq+zCAcUfx//lUSYBKTsUAP1o5gCYXQ7/9vKS/tap8P/wZmz+oKfsAJravACW6cr/GxP6AQJHhf+vDD8BkbfGAGh4c/+C+/cAEdSn/z57hP/3ZL0Am9+YAI/FIQCbOyz/ll3wAX8DV/9fR88Bp1UB/7yYdP8KFxcAicNdATZiYQDwAKj/lLx/AIZrlwBM/asAWoTAAJIWNgDgQjb+5rrl/ye2xACU+4L/QYNs/oABoACpMaf+x/6U//sGgwC7/oH/VVI+ALIXOv/+hAUApNUnAIb8kv4lNVH/m4ZSAM2n7v9eLbT/hCihAP5vcAE2S9kAs+bdAetev/8X8zABypHL/yd2Kv91jf0A/gDeACv7MgA2qeoBUETQAJTL8/6RB4cABv4AAPy5fwBiCIH/JiNI/9Mk3AEoGlkAqEDF/gPe7/8CU9f+tJ9pADpzwgC6dGr/5ffb/4F2wQDKrrcBpqFIAMlrk/7tiEoA6eZqAWlvqABA4B4BAeUDAGaXr//C7uT//vrUALvteQBD+2ABxR4LALdfzADNWYoAQN0lAf/fHv+yMNP/8cha/6fRYP85gt0ALnLI/z24QgA3thj+brYhAKu+6P9yXh8AEt0IAC/n/gD/cFMAdg/X/60ZKP7AwR//7hWS/6vBdv9l6jX+g9RwAFnAawEI0BsAtdkP/+eV6ACM7H4AkAnH/wxPtf6Ttsr/E222/zHU4QBKo8sAr+mUABpwMwDBwQn/D4f5AJbjggDMANsBGPLNAO7Qdf8W9HAAGuUiACVQvP8mLc7+8Frh/x0DL/8q4EwAuvOnACCED/8FM30Ai4cYAAbx2wCs5YX/9tYyAOcLz/+/flMBtKOq//U4GAGypNP/AxDKAWI5dv+Ng1n+ITMYAPOVW//9NA4AI6lD/jEeWP+zGyT/pYy3ADq9lwBYHwAAS6lCAEJlx/8Y2McBecQa/w5Py/7w4lH/XhwK/1PB8P/MwYP/Xg9WANoonQAzwdEAAPKxAGa59wCebXQAJodbAN+vlQDcQgH/VjzoABlgJf/heqIB17uo/56dLgA4q6IA6PBlAXoWCQAzCRX/NRnu/9ke6P59qZQADehmAJQJJQClYY0B5IMpAN4P8//+EhEABjztAWoDcQA7hL0AXHAeAGnQ1QAwVLP/u3nn/hvYbf+i3Wv+Se/D//ofOf+Vh1n/uRdzAQOjnf8ScPoAGTm7/6FgpAAvEPMADI37/kPquP8pEqEArwZg/6CsNP4YsLf/xsFVAXx5if+XMnL/3Ms8/8/vBQEAJmv/N+5e/kaYXgDV3E0BeBFF/1Wkvv/L6lEAJjEl/j2QfACJTjH+qPcwAF+k/ABpqYcA/eSGAECmSwBRSRT/z9IKAOpqlv9eIlr//p85/tyFYwCLk7T+GBe5ACk5Hv+9YUwAQbvf/+CsJf8iPl8B55DwAE1qfv5AmFsAHWKbAOL7Nf/q0wX/kMve/6Sw3f4F5xgAs3rNACQBhv99Rpf+YeT8AKyBF/4wWtH/luBSAVSGHgDxxC4AZ3Hq/y5lef4ofPr/hy3y/gn5qP+MbIP/j6OrADKtx/9Y3o7/yF+eAI7Ao/8HdYcAb3wWAOwMQf5EJkH/467+APT1JgDwMtD/oT/6ADzR7wB6IxMADiHm/gKfcQBqFH//5M1gAInSrv601JD/WWKaASJYiwCnonABQW7FAPElqQBCOIP/CslT/oX9u/+xcC3+xPsAAMT6l//u6Nb/ltHNABzwdgBHTFMB7GNbACr6gwFgEkD/dt4jAHHWy/96d7j/QhMkAMxA+QCSWYsAhj6HAWjpZQC8VBoAMfmBANDWS//Pgk3/c6/rAKsCif+vkboBN/WH/5pWtQFkOvb/bcc8/1LMhv/XMeYBjOXA/97B+/9RiA//s5Wi/xcnHf8HX0v+v1HeAPFRWv9rMcn/9NOdAN6Mlf9B2zj+vfZa/7I7nQEw2zQAYiLXABwRu/+vqRgAXE+h/+zIwgGTj+oA5eEHAcWoDgDrMzUB/XiuAMUGqP/KdasAoxXOAHJVWv8PKQr/whNjAEE32P6iknQAMs7U/0CSHf+enoMBZKWC/6wXgf99NQn/D8ESARoxC/+1rskBh8kO/2QTlQDbYk8AKmOP/mAAMP/F+VP+aJVP/+tuiP5SgCz/QSkk/ljTCgC7ebsAYobHAKu8s/7SC+7/QnuC/jTqPQAwcRf+BlZ4/3ey9QBXgckA8o3RAMpyVQCUFqEAZ8MwABkxq/+KQ4IAtkl6/pQYggDT5ZoAIJueAFRpPQCxwgn/pllWATZTuwD5KHX/bQPX/zWSLAE/L7MAwtgD/g5UiACIsQ3/SPO6/3URff/TOtP/XU/fAFpY9f+L0W//Rt4vAAr2T//G2bIA4+ELAU5+s/8+K34AZ5QjAIEIpf718JQAPTOOAFHQhgAPiXP/03fs/5/1+P8Choj/5os6AaCk/gByVY3/Maa2/5BGVAFVtgcALjVdAAmmof83orL/Lbi8AJIcLP6pWjEAeLLxAQ57f/8H8ccBvUIy/8aPZf6984f/jRgY/kthVwB2+5oB7TacAKuSz/+DxPb/iEBxAZfoOQDw2nMAMT0b/0CBSQH8qRv/KIQKAVrJwf/8efABus4pACvGYQCRZLcAzNhQ/qyWQQD55cT+aHtJ/01oYP6CtAgAaHs5ANzK5f9m+dMAVg7o/7ZO0QDv4aQAag0g/3hJEf+GQ+kAU/61ALfscAEwQIP/8djz/0HB4gDO8WT+ZIam/+3KxQA3DVEAIHxm/yjksQB2tR8B56CG/3e7ygAAjjz/gCa9/6bJlgDPeBoBNrisAAzyzP6FQuYAIiYfAbhwUAAgM6X+v/M3ADpJkv6bp83/ZGiY/8X+z/+tE/cA7grKAO+X8gBeOyf/8B1m/wpcmv/lVNv/oYFQANBazAHw267/nmaRATWyTP80bKgBU95rANMkbQB2OjgACB0WAO2gxwCq0Z0AiUcvAI9WIADG8gIA1DCIAVysugDml2kBYL/lAIpQv/7w2IL/YisG/qjEMQD9ElsBkEl5AD2SJwE/aBj/uKVw/n7rYgBQ1WL/ezxX/1KM9QHfeK3/D8aGAc487wDn6lz/Ie4T/6VxjgGwdyYAoCum/u9baQBrPcIBGQREAA+LMwCkhGr/InQu/qhfxQCJ1BcASJw6AIlwRf6WaZr/7MmdABfUmv+IUuP+4jvd/1+VwABRdjT/ISvXAQ6TS/9ZnHn+DhJPAJPQiwGX2j7/nFgIAdK4Yv8Ur3v/ZlPlANxBdAGW+gT/XI7c/yL3Qv/M4bP+l1GXAEco7P+KPz4ABk/w/7e5tQB2MhsAP+PAAHtjOgEy4Jv/EeHf/tzgTf8OLHsBjYCvAPjUyACWO7f/k2EdAJbMtQD9JUcAkVV3AJrIugACgPn/Uxh8AA5XjwCoM/UBfJfn/9DwxQF8vrkAMDr2ABTp6AB9EmL/Df4f//Wxgv9sjiMAq33y/owMIv+loaIAzs1lAPcZIgFkkTkAJ0Y5AHbMy//yAKIApfQeAMZ04gCAb5n/jDa2ATx6D/+bOjkBNjLGAKvTHf9riqf/rWvH/22hwQBZSPL/znNZ//r+jv6xyl7/UVkyAAdpQv8Z/v/+y0AX/0/ebP8n+UsA8XwyAO+YhQDd8WkAk5diANWhef7yMYkA6SX5/iq3GwC4d+b/2SCj/9D75AGJPoP/T0AJ/l4wcQARijL+wf8WAPcSxQFDN2gAEM1f/zAlQgA3nD8BQFJK/8g1R/7vQ30AGuDeAN+JXf8e4Mr/CdyEAMYm6wFmjVYAPCtRAYgcGgDpJAj+z/KUAKSiPwAzLuD/cjBP/wmv4gDeA8H/L6Do//9daf4OKuYAGopSAdAr9AAbJyb/YtB//0CVtv8F+tEAuzwc/jEZ2v+pdM3/dxJ4AJx0k/+ENW3/DQrKAG5TpwCd24n/BgOC/zKnHv88ny//gYCd/l4DvQADpkQAU9/XAJZawgEPqEEA41Mz/82rQv82uzwBmGYt/3ea4QDw94gAZMWy/4tH3//MUhABKc4q/5zA3f/Ye/T/2tq5/7u67//8rKD/wzQWAJCutf67ZHP/006w/xsHwQCT1Wj/WskK/1B7QgEWIboAAQdj/h7OCgDl6gUANR7SAIoI3P5HN6cASOFWAXa+vAD+wWUBq/ms/16et/5dAmz/sF1M/0ljT/9KQIH+9i5BAGPxf/72l2b/LDXQ/jtm6gCar6T/WPIgAG8mAQD/tr7/c7AP/qk8gQB67fEAWkw/AD5KeP96w24AdwSyAN7y0gCCIS7+nCgpAKeScAExo2//ebDrAEzPDv8DGcYBKevVAFUk1gExXG3/yBge/qjswwCRJ3wB7MOVAFokuP9DVar/JiMa/oN8RP/vmyP/NsmkAMQWdf8xD80AGOAdAX5xkAB1FbYAy5+NAN+HTQCw5rD/vuXX/2Mltf8zFYr/Gb1Z/zEwpf6YLfcAqmzeAFDKBQAbRWf+zBaB/7T8Pv7SAVv/km7+/9uiHADf/NUBOwghAM4Q9ACB0zAAa6DQAHA70QBtTdj+IhW5//ZjOP+zixP/uR0y/1RZEwBK+mL/4SrI/8DZzf/SEKcAY4RfASvmOQD+C8v/Y7w//3fB+/5QaTYA6LW9AbdFcP/Qq6X/L220/3tTpQCSojT/mgsE/5fjWv+SiWH+Pekp/14qN/9spOwAmET+AAqMg/8Kak/+856JAEOyQv6xe8b/Dz4iAMVYKv+VX7H/mADG/5X+cf/hWqP/fdn3ABIR4ACAQnj+wBkJ/zLdzQAx1EYA6f+kAALRCQDdNNv+rOD0/144zgHyswL/H1ukAeYuiv+95twAOS89/28LnQCxW5gAHOZiAGFXfgDGWZH/p09rAPlNoAEd6eb/lhVW/jwLwQCXJST+uZbz/+TUUwGsl7QAyambAPQ86gCO6wQBQ9o8AMBxSwF088//QaybAFEenP9QSCH+Eudt/45rFf59GoT/sBA7/5bJOgDOqckA0HniACisDv+WPV7/ODmc/408kf8tbJX/7pGb/9FVH/7ADNIAY2Jd/pgQlwDhudwAjess/6CsFf5HGh//DUBd/hw4xgCxPvgBtgjxAKZllP9OUYX/gd7XAbypgf/oB2EAMXA8/9nl+wB3bIoAJxN7/oMx6wCEVJEAguaU/xlKuwAF9Tb/udvxARLC5P/xymYAaXHKAJvrTwAVCbL/nAHvAMiUPQBz99L/Md2HADq9CAEjLgkAUUEF/zSeuf99dC7/SowN/9JcrP6TF0cA2eD9/nNstP+ROjD+27EY/5z/PAGak/IA/YZXADVL5QAww97/H68y/5zSeP/QI97/EvizAQIKZf+dwvj/nsxl/2j+xf9PPgQAsqxlAWCS+/9BCpwAAoml/3QE5wDy1wEAEyMd/yuhTwA7lfYB+0KwAMghA/9Qbo7/w6ERAeQ4Qv97L5H+hASkAEOurAAZ/XIAV2FXAfrcVABgW8j/JX07ABNBdgChNPH/7awG/7C///8BQYL+377mAGX95/+SI20A+h1NATEAEwB7WpsBFlYg/9rVQQBvXX8APF2p/wh/tgARug7+/Yn2/9UZMP5M7gD/+FxG/2PgiwC4Cf8BB6TQAM2DxgFX1scAgtZfAN2V3gAXJqv+xW7VACtzjP7XsXYAYDRCAXWe7QAOQLb/Lj+u/55fvv/hzbH/KwWO/6xj1P/0u5MAHTOZ/+R0GP4eZc8AE/aW/4bnBQB9huIBTUFiAOyCIf8Fbj4ARWx//wdxFgCRFFP+wqHn/4O1PADZ0bH/5ZTU/gODuAB1sbsBHA4f/7BmUAAyVJf/fR82/xWdhf8Ts4sB4OgaACJ1qv+n/Kv/SY3O/oH6IwBIT+wB3OUU/ynKrf9jTO7/xhbg/2zGw/8kjWAB7J47/2pkVwBu4gIA4+reAJpdd/9KcKT/Q1sC/xWRIf9m1on/r+Zn/qP2pgBd93T+p+Ac/9wCOQGrzlQAe+QR/xt4dwB3C5MBtC/h/2jIuf6lAnIATU7UAC2asf8YxHn+Up22AFoQvgEMk8UAX++Y/wvrRwBWknf/rIbWADyDxACh4YEAH4J4/l/IMwBp59L/OgmU/yuo3f987Y4AxtMy/i71ZwCk+FQAmEbQ/7R1sQBGT7kA80ogAJWczwDFxKEB9TXvAA9d9v6L8DH/xFgk/6ImewCAyJ0Brkxn/62pIv7YAav/cjMRAIjkwgBuljj+avafABO4T/+WTfD/m1CiAAA1qf8dl1YARF4QAFwHbv5idZX/+U3m//0KjADWfFz+I3brAFkwOQEWNaYAuJA9/7P/wgDW+D3+O272AHkVUf6mA+QAakAa/0Xohv/y3DX+LtxVAHGV9/9hs2f/vn8LAIfRtgBfNIEBqpDO/3rIzP+oZJIAPJCV/kY8KAB6NLH/9tNl/67tCAAHM3gAEx+tAH7vnP+PvcsAxIBY/+mF4v8efa3/yWwyAHtkO//+owMB3ZS1/9aIOf7etIn/z1g2/xwh+/9D1jQB0tBkAFGqXgCRKDUA4G/n/iMc9P/ix8P+7hHmANnZpP6pnd0A2i6iAcfPo/9sc6IBDmC7/3Y8TAC4n5gA0edH/iqkuv+6mTP+3au2/6KOrQDrL8EAB4sQAV+kQP8Q3aYA28UQAIQdLP9kRXX/POtY/ihRrQBHvj3/u1idAOcLFwDtdaQA4ajf/5pydP+jmPIBGCCqAH1icf6oE0wAEZ3c/ps0BQATb6H/R1r8/61u8AAKxnn//f/w/0J70gDdwtf+eaMR/+EHYwC+MbYAcwmFAegaiv/VRIQALHd6/7NiMwCVWmoARzLm/wqZdv+xRhkApVfNADeK6gDuHmEAcZvPAGKZfwAia9v+dXKs/0y0//7yObP/3SKs/jiiMf9TA///cd29/7wZ5P4QWFn/RxzG/hYRlf/zef7/a8pj/wnODgHcL5kAa4knAWExwv+VM8X+ujoL/2sr6AHIBg7/tYVB/t3kq/97PucB4+qz/yK91P70u/kAvg1QAYJZAQDfha0ACd7G/0J/SgCn2F3/m6jGAUKRAABEZi4BrFqaANiAS/+gKDMAnhEbAXzwMQDsyrD/l3zA/ybBvgBftj0Ao5N8//+lM/8cKBH+12BOAFaR2v4fJMr/VgkFAG8pyP/tbGEAOT4sAHW4DwEt8XQAmAHc/52lvAD6D4MBPCx9/0Hc+/9LMrgANVqA/+dQwv+IgX8BFRK7/y06of9HkyIArvkL/iONHQDvRLH/c246AO6+sQFX9ab/vjH3/5JTuP+tDif/ktdoAI7feACVyJv/1M+RARC12QCtIFf//yO1AHffoQHI317/Rga6/8BDVf8yqZgAkBp7/zjzs/4URIgAJ4y8/v3QBf/Ic4cBK6zl/5xouwCX+6cANIcXAJeZSACTxWv+lJ4F/+6PzgB+mYn/WJjF/gdEpwD8n6X/7042/xg/N/8m3l4A7bcM/87M0gATJ/b+HkrnAIdsHQGzcwAAdXZ0AYQG/P+RgaEBaUONAFIl4v/u4uT/zNaB/qJ7ZP+5eeoALWznAEIIOP+EiIAArOBC/q+dvADm3+L+8ttFALgOdwFSojgAcnsUAKJnVf8x72P+nIfXAG//p/4nxNYAkCZPAfmofQCbYZz/FzTb/5YWkAAslaX/KH+3AMRN6f92gdL/qofm/9Z3xgDp8CMA/TQH/3VmMP8VzJr/s4ix/xcCAwGVgln//BGfAUY8GgCQaxEAtL48/zi2O/9uRzb/xhKB/5XgV//fFZj/iha2//qczQDsLdD/T5TyAWVG0QBnTq4AZZCs/5iI7QG/wogAcVB9AZgEjQCbljX/xHT1AO9ySf4TUhH/fH3q/yg0vwAq0p7/m4SlALIFKgFAXCj/JFVN/7LkdgCJQmD+c+JCAG7wRf6Xb1AAp67s/+Nsa/+88kH/t1H/ADnOtf8vIrX/1fCeAUdLXwCcKBj/ZtJRAKvH5P+aIikA469LABXvwwCK5V8BTMAxAHV7VwHj4YIAfT4//wLGqwD+JA3+kbrOAJT/9P8jAKYAHpbbAVzk1ABcxjz+PoXI/8kpOwB97m3/tKPuAYx6UgAJFlj/xZ0v/5leOQBYHrYAVKFVALKSfACmpgf/FdDfAJy28gCbebkAU5yu/poQdv+6U+gB3zp5/x0XWAAjfX//qgWV/qQMgv+bxB0AoWCIAAcjHQGiJfsAAy7y/wDZvAA5ruIBzukCADm7iP57vQn/yXV//7okzADnGdgAUE5pABOGgf+Uy0QAjVF9/vilyP/WkIcAlzem/ybrWwAVLpoA3/6W/yOZtP99sB0BK2Ie/9h65v/poAwAObkM/vBxB/8FCRD+GltsAG3GywAIkygAgYbk/3y6KP9yYoT+poQXAGNFLAAJ8u7/uDU7AISBZv80IPP+k9/I/3tTs/6HkMn/jSU4AZc84/9aSZwBy6y7AFCXL/9eief/JL87/+HRtf9K19X+Bnaz/5k2wQEyAOcAaJ1IAYzjmv+24hD+YOFc/3MUqv4G+k4A+Eut/zVZBv8AtHYASK0BAEAIzgGuhd8AuT6F/9YLYgDFH9AAq6f0/xbntQGW2rkA96lhAaWL9/8veJUBZ/gzADxFHP4Zs8QAfAfa/jprUQC46Zz//EokAHa8QwCNXzX/3l6l/i49NQDOO3P/L+z6/0oFIAGBmu7/aiDiAHm7Pf8DpvH+Q6qs/x3Ysv8XyfwA/W7zAMh9OQBtwGD/NHPuACZ58//JOCEAwnaCAEtgGf+qHub+Jz/9ACQt+v/7Ae8AoNRcAS3R7QDzIVf+7VTJ/9QSnf7UY3//2WIQ/ous7wCoyYL/j8Gp/+6XwQHXaCkA7z2l/gID8gAWy7H+scwWAJWB1f4fCyn/AJ95/qAZcv+iUMgAnZcLAJqGTgHYNvwAMGeFAGncxQD9qE3+NbMXABh58AH/LmD/azyH/mLN+f8/+Xf/eDvT/3K0N/5bVe0AldRNAThJMQBWxpYAXdGgAEXNtv/0WisAFCSwAHp03QAzpycB5wE//w3FhgAD0SL/hzvKAKdkTgAv30wAuTw+ALKmewGEDKH/Pa4rAMNFkAB/L78BIixOADnqNAH/Fij/9l6SAFPkgAA8TuD/AGDS/5mv7ACfFUkAtHPE/oPhagD/p4YAnwhw/3hEwv+wxMb/djCo/12pAQBwyGYBShj+ABONBP6OPj8Ag7O7/02cm/93VqQAqtCS/9CFmv+Umzr/onjo/vzVmwDxDSoAXjKDALOqcACMU5f/N3dUAYwj7/+ZLUMB7K8nADaXZ/+eKkH/xO+H/lY1ywCVYS/+2CMR/0YDRgFnJFr/KBqtALgwDQCj29n/UQYB/92qbP7p0F0AZMn5/lYkI//Rmh4B48n7/wK9p/5kOQMADYApAMVkSwCWzOv/ka47AHj4lf9VN+EActI1/sfMdwAO90oBP/uBAENolwGHglAAT1k3/3Xmnf8ZYI8A1ZEFAEXxeAGV81//cioUAINIAgCaNRT/ST5tAMRmmAApDMz/eiYLAfoKkQDPfZQA9vTe/ykgVQFw1X4AovlWAUfGf/9RCRUBYicE/8xHLQFLb4kA6jvnACAwX//MH3IBHcS1/zPxp/5dbY4AaJAtAOsMtf80cKQATP7K/64OogA965P/K0C5/ul92QDzWKf+SjEIAJzMQgB81nsAJt12AZJw7AByYrEAl1nHAFfFcAC5laEALGClAPizFP+829j+KD4NAPOOjQDl487/rMoj/3Ww4f9SbiYBKvUO/xRTYQAxqwoA8nd4ABnoPQDU8JP/BHM4/5ER7/7KEfv/+RL1/2N17wC4BLP/9u0z/yXvif+mcKb/Ubwh/7n6jv82u60A0HDJAPYr5AFouFj/1DTE/zN1bP/+dZsALlsP/1cOkP9X48wAUxpTAZ9M4wCfG9UBGJdsAHWQs/6J0VIAJp8KAHOFyQDftpwBbsRd/zk86QAFp2n/msWkAGAiuv+ThSUB3GO+AAGnVP8UkasAwsX7/l9Ohf/8+PP/4V2D/7uGxP/YmaoAFHae/owBdgBWng8BLdMp/5MBZP5xdEz/039sAWcPMADBEGYBRTNf/2uAnQCJq+kAWnyQAWqhtgCvTOwByI2s/6M6aADptDT/8P0O/6Jx/v8m74r+NC6mAPFlIf6DupwAb9A+/3xeoP8frP4AcK44/7xjG/9DivsAfTqAAZyYrv+yDPf//FSeAFLFDv6syFP/JScuAWrPpwAYvSIAg7KQAM7VBACh4tIASDNp/2Etu/9OuN//sB37AE+gVv90JbIAUk3VAVJUjf/iZdQBr1jH//Ve9wGsdm3/prm+AIO1eABX/l3/hvBJ/yD1j/+Lomf/s2IS/tnMcACT33j/NQrzAKaMlgB9UMj/Dm3b/1vaAf/8/C/+bZx0/3MxfwHMV9P/lMrZ/xpV+f8O9YYBTFmp//It5gA7Yqz/ckmE/k6bMf+eflQAMa8r/xC2VP+dZyMAaMFt/0PdmgDJrAH+CKJYAKUBHf99m+X/HprcAWfvXADcAW3/ysYBAF4CjgEkNiwA6+Ke/6r71v+5TQkAYUryANujlf/wI3b/33JY/sDHAwBqJRj/yaF2/2FZYwHgOmf/ZceT/t48YwDqGTsBNIcbAGYDW/6o2OsA5eiIAGg8gQAuqO4AJ79DAEujLwCPYWL/ONioAajp/P8jbxb/XFQrABrIVwFb/ZgAyjhGAI4ITQBQCq8B/MdMABZuUv+BAcIAC4A9AVcOkf/93r4BD0iuAFWjVv46Yyz/LRi8/hrNDwAT5dL++EPDAGNHuACaxyX/l/N5/yYzS//JVYL+LEH6ADmT8/6SKzv/WRw1ACFUGP+zMxL+vUZTAAucswFihncAnm9vAHeaSf/IP4z+LQ0N/5rAAv5RSCoALqC5/ixwBgCS15UBGrBoAEQcVwHsMpn/s4D6/s7Bv/+mXIn+NSjvANIBzP6orSMAjfMtASQybf8P8sL/4596/7Cvyv5GOUgAKN84ANCiOv+3Yl0AD28MAB4ITP+Ef/b/LfJnAEW1D/8K0R4AA7N5APHo2gF7x1j/AtLKAbyCUf9eZdABZyQtAEzBGAFfGvH/paK7ACRyjADKQgX/JTiTAJgL8wF/Vej/+ofUAbmxcQBa3Ev/RfiSADJvMgBcFlAA9CRz/qNkUv8ZwQYBfz0kAP1DHv5B7Kr/oRHX/j+vjAA3fwQAT3DpAG2gKACPUwf/QRru/9mpjP9OXr3/AJO+/5NHuv5qTX//6Z3pAYdX7f/QDewBm20k/7Rk2gC0oxIAvm4JARE/e/+ziLT/pXt7/5C8Uf5H8Gz/GXAL/+PaM/+nMur/ck9s/x8Tc/+38GMA41eP/0jZ+P9mqV8BgZWVAO6FDAHjzCMA0HMaAWYI6gBwWI8BkPkOAPCerP5kcHcAwo2Z/ig4U/95sC4AKjVM/56/mgBb0VwArQ0QAQVI4v/M/pUAULjPAGQJev52Zav//MsA/qDPNgA4SPkBOIwN/wpAa/5bZTT/4bX4AYv/hADmkREA6TgXAHcB8f/VqZf/Y2MJ/rkPv/+tZ20Brg37/7JYB/4bO0T/CiEC//hhOwAaHpIBsJMKAF95zwG8WBgAuV7+/nM3yQAYMkYAeDUGAI5CkgDk4vn/aMDeAa1E2wCiuCT/j2aJ/50LFwB9LWIA613h/jhwoP9GdPMBmfk3/4EnEQHxUPQAV0UVAV7kSf9OQkH/wuPnAD2SV/+tmxf/cHTb/tgmC/+DuoUAXtS7AGQvWwDM/q//3hLX/q1EbP/j5E//Jt3VAKPjlv4fvhIAoLMLAQpaXv/crlgAo9Pl/8eINACCX93/jLzn/otxgP91q+z+MdwU/zsUq//kbbwAFOEg/sMQrgDj/ogBhydpAJZNzv/S7uIAN9SE/u85fACqwl3/+RD3/xiXPv8KlwoAT4uy/3jyygAa29UAPn0j/5ACbP/mIVP/US3YAeA+EQDW2X0AYpmZ/7Owav6DXYr/bT4k/7J5IP94/EYA3PglAMxYZwGA3Pv/7OMHAWoxxv88OGsAY3LuANzMXgFJuwEAWZoiAE7Zpf8Ow/n/Ceb9/82H9QAa/Af/VM0bAYYCcAAlniAA51vt/7+qzP+YB94AbcAxAMGmkv/oE7X/aY40/2cQGwH9yKUAw9kE/zS9kP97m6D+V4I2/054Pf8OOCkAGSl9/1eo9QDWpUYA1KkG/9vTwv5IXaT/xSFn/yuOjQCD4awA9GkcAERE4QCIVA3/gjko/otNOABUljUANl+dAJANsf5fc7oAdRd2//Sm8f8LuocAsmrL/2HaXQAr/S0ApJgEAIt27wBgARj+65nT/6huFP8y77AAcinoAMH6NQD+oG/+iHop/2FsQwDXmBf/jNHUACq9owDKKjL/amq9/75E2f/pOnUA5dzzAcUDBAAleDb+BJyG/yQ9q/6liGT/1OgOAFquCgDYxkH/DANAAHRxc//4ZwgA530S/6AcxQAeuCMB30n5/3sULv6HOCX/rQ3lAXehIv/1PUkAzX1wAIlohgDZ9h7/7Y6PAEGfZv9spL4A23Wt/yIleP7IRVAAH3za/koboP+6msf/R8f8AGhRnwERyCcA0z3AARruWwCU2QwAO1vV/wtRt/+B5nr/csuRAXe0Qv9IirQA4JVqAHdSaP/QjCsAYgm2/81lhv8SZSYAX8Wm/8vxkwA+0JH/hfb7AAKpDgAN97gAjgf+ACTIF/9Yzd8AW4E0/xW6HgCP5NIB9+r4/+ZFH/6wuof/7s00AYtPKwARsNn+IPNDAPJv6QAsIwn/43JRAQRHDP8mab8AB3Uy/1FPEAA/REH/nSRu/03xA//iLfsBjhnOAHh70QEc/u7/BYB+/1ve1/+iD78AVvBJAIe5Uf4s8aMA1NvS/3CimwDPZXYAqEg4/8QFNABIrPL/fhad/5JgO/+ieZj+jBBfAMP+yP5SlqIAdyuR/sysTv+m4J8AaBPt//V+0P/iO9UAddnFAJhI7QDcHxf+Dlrn/7zUQAE8Zfb/VRhWAAGxbQCSUyABS7bAAHfx4AC57Rv/uGVSAeslTf/9hhMA6PZ6ADxqswDDCwwAbULrAX1xOwA9KKQAr2jwAAIvu/8yDI0Awou1/4f6aABhXN7/2ZXJ/8vxdv9Pl0MAeo7a/5X17wCKKsj+UCVh/3xwp/8kilf/gh2T//FXTv/MYRMBsdEW//fjf/5jd1P/1BnGARCzswCRTaz+WZkO/9q9pwBr6Tv/IyHz/ixwcP+hf08BzK8KACgViv5odOQAx1+J/4W+qP+SpeoBt2MnALfcNv7/3oUAott5/j/vBgDhZjb/+xL2AAQigQGHJIMAzjI7AQ9htwCr2If/ZZgr/5b7WwAmkV8AIswm/rKMU/8ZgfP/TJAlAGokGv52kKz/RLrl/2uh1f8uo0T/lar9ALsRDwDaoKX/qyP2AWANEwCly3UA1mvA//R7sQFkA2gAsvJh//tMgv/TTSoB+k9G/z/0UAFpZfYAPYg6Ae5b1QAOO2L/p1RNABGELv45r8X/uT64AExAzwCsr9D+r0olAIob0/6UfcIACllRAKjLZf8r1dEB6/U2AB4j4v8JfkYA4n1e/px1FP85+HAB5jBA/6RcpgHg1ub/JHiPADcIK//7AfUBamKlAEprav41BDb/WrKWAQN4e//0BVkBcvo9//6ZUgFNDxEAOe5aAV/f5gDsNC/+Z5Sk/3nPJAESELn/SxRKALsLZQAuMIH/Fu/S/03sgf9vTcz/PUhh/8fZ+/8q18wAhZHJ/znmkgHrZMYAkkkj/mzGFP+2T9L/UmeIAPZssAAiETz/E0py/qiqTv+d7xT/lSmoADp5HABPs4b/53mH/67RYv/zer4Aq6bNANR0MAAdbEL/ot62AQ53FQDVJ/n//t/k/7elxgCFvjAAfNBt/3evVf8J0XkBMKu9/8NHhgGI2zP/tluN/jGfSAAjdvX/cLrj/zuJHwCJLKMAcmc8/gjVlgCiCnH/wmhIANyDdP+yT1wAy/rV/l3Bvf+C/yL+1LyXAIgRFP8UZVP/1M6mAOXuSf+XSgP/qFfXAJu8hf+mgUkA8E+F/7LTUf/LSKP+wailAA6kx/4e/8wAQUhbAaZKZv/IKgD/wnHj/0IX0ADl2GT/GO8aAArpPv97CrIBGiSu/3fbxwEto74AEKgqAKY5xv8cGhoAfqXnAPtsZP895Xn/OnaKAEzPEQANInD+WRCoACXQaf8jydf/KGpl/gbvcgAoZ+L+9n9u/z+nOgCE8I4ABZ5Y/4FJnv9eWZIA5jaSAAgtrQBPqQEAc7r3AFRAgwBD4P3/z71AAJocUQEtuDb/V9Tg/wBgSf+BIesBNEJQ//uum/8EsyUA6qRd/l2v/QDGRVf/4GouAGMd0gA+vHL/LOoIAKmv9/8XbYn/5bYnAMClXv71ZdkAv1hgAMReY/9q7gv+NX7zAF4BZf8ukwIAyXx8/40M2gANpp0BMPvt/5v6fP9qlJL/tg3KABw9pwDZmAj+3IIt/8jm/wE3QVf/Xb9h/nL7DgAgaVwBGs+NABjPDf4VMjD/upR0/9Mr4QAlIqL+pNIq/0QXYP+21gj/9XWJ/0LDMgBLDFP+UIykAAmlJAHkbuMA8RFaARk01AAG3wz/i/M5AAxxSwH2t7//1b9F/+YPjgABw8T/iqsv/0A/agEQqdb/z644AVhJhf+2hYwAsQ4Z/5O4Nf8K46H/eNj0/0lN6QCd7osBO0HpAEb72AEpuJn/IMtwAJKT/QBXZW0BLFKF//SWNf9emOj/O10n/1iT3P9OUQ0BIC/8/6ATcv9dayf/dhDTAbl30f/j23/+WGns/6JuF/8kpm7/W+zd/0LqdABvE/T+CukaACC3Bv4Cv/IA2pw1/ik8Rv+o7G8Aebl+/+6Oz/83fjQA3IHQ/lDMpP9DF5D+2ihs/3/KpADLIQP/Ap4AACVgvP/AMUoAbQQAAG+nCv5b2of/y0Kt/5bC4gDJ/Qb/rmZ5AM2/bgA1wgQAUSgt/iNmj/8MbMb/EBvo//xHugGwbnIAjgN1AXFNjgATnMUBXC/8ADXoFgE2EusALiO9/+zUgQACYND+yO7H/zuvpP+SK+cAwtk0/wPfDACKNrL+VevPAOjPIgAxNDL/pnFZ/wot2P8+rRwAb6X2AHZzW/+AVDwAp5DLAFcN8wAWHuQBsXGS/4Gq5v78mYH/keErAEbnBf96aX7+VvaU/24lmv7RA1sARJE+AOQQpf833fn+stJbAFOS4v5FkroAXdJo/hAZrQDnuiYAvXqM//sNcP9pbl0A+0iqAMAX3/8YA8oB4V3kAJmTx/5tqhYA+GX2/7J8DP+y/mb+NwRBAH3WtAC3YJMALXUX/oS/+QCPsMv+iLc2/5LqsQCSZVb/LHuPASHRmADAWin+Uw99/9WsUgDXqZAAEA0iACDRZP9UEvkBxRHs/9m65gAxoLD/b3Zh/+1o6wBPO1z+RfkL/yOsSgETdkQA3nyl/7RCI/9WrvYAK0pv/36QVv/k6lsA8tUY/kUs6//ctCMACPgH/2YvXP/wzWb/cearAR+5yf/C9kb/ehG7AIZGx/+VA5b/dT9nAEFoe//UNhMBBo1YAFOG8/+INWcAqRu0ALExGABvNqcAwz3X/x8BbAE8KkYAuQOi/8KVKP/2fyb+vncm/z13CAFgodv/KsvdAbHypP/1nwoAdMQAAAVdzf6Af7MAfe32/5Wi2f9XJRT+jO7AAAkJwQBhAeIAHSYKAACIP//lSNL+JoZc/07a0AFoJFT/DAXB//KvPf+/qS4Bs5OT/3G+i/59rB8AA0v8/tckDwDBGxgB/0WV/26BdgDLXfkAiolA/iZGBgCZdN4AoUp7AMFjT/92O17/PQwrAZKxnQAuk78AEP8mAAszHwE8OmL/b8JNAZpb9ACMKJABrQr7AMvRMv5sgk4A5LRaAK4H+gAfrjwAKaseAHRjUv92wYv/u63G/tpvOAC5e9gA+Z40ADS0Xf/JCVv/OC2m/oSby/866G4ANNNZ//0AogEJV7cAkYgsAV569QBVvKsBk1zGAAAIaAAeX64A3eY0Aff36/+JrjX/IxXM/0fj1gHoUsIACzDj/6pJuP/G+/z+LHAiAINlg/9IqLsAhId9/4poYf/uuKj/82hU/4fY4v+LkO0AvImWAVA4jP9Wqaf/wk4Z/9wRtP8RDcEAdYnU/43glwAx9K8AwWOv/xNjmgH/QT7/nNI3//L0A//6DpUAnljZ/53Phv776BwALpz7/6s4uP/vM+oAjoqD/xn+8wEKycIAP2FLANLvogDAyB8BddbzABhH3v42KOj/TLdv/pAOV//WT4j/2MTUAIQbjP6DBf0AfGwT/xzXSwBM3jf+6bY/AESrv/40b97/CmlN/1Cq6wCPGFj/Led5AJSB4AE99lQA/S7b/+9MIQAxlBL+5iVFAEOGFv6Om14AH53T/tUqHv8E5Pf+/LAN/ycAH/7x9P//qi0K/v3e+QDecoQA/y8G/7SjswFUXpf/WdFS/uU0qf/V7AAB1jjk/4d3l/9wycEAU6A1/gaXQgASohEA6WFbAIMFTgG1eDX/dV8//+11uQC/foj/kHfpALc5YQEvybv/p6V3AS1kfgAVYgb+kZZf/3g2mADRYmgAj28e/riU+QDr2C4A+MqU/zlfFgDy4aMA6ffo/0erE/9n9DH/VGdd/0R59AFS4A0AKU8r//nOp//XNBX+wCAW//dvPABlSib/FltU/h0cDf/G59f+9JrIAN+J7QDThA4AX0DO/xE+9//pg3kBXRdNAM3MNP5RvYgAtNuKAY8SXgDMK4z+vK/bAG9ij/+XP6L/0zJH/hOSNQCSLVP+slLu/xCFVP/ixl3/yWEU/3h2I/9yMuf/ouWc/9MaDAByJ3P/ztSGAMXZoP90gV7+x9fb/0vf+QH9dLX/6Ndo/+SC9v+5dVYADgUIAO8dPQHtV4X/fZKJ/syo3wAuqPUAmmkWANzUof9rRRj/idq1//FUxv+CetP/jQiZ/76xdgBgWbIA/xAw/npgaf91Nuj/In5p/8xDpgDoNIr/05MMABk2BwAsD9f+M+wtAL5EgQFqk+EAHF0t/uyND/8RPaEA3HPAAOyRGP5vqKkA4Do//3+kvABS6ksB4J6GANFEbgHZptkARuGmAbvBj/8QB1j/Cs2MAHXAnAEROCYAG3xsAavXN/9f/dQAm4eo//aymf6aREoA6D1g/mmEOwAhTMcBvbCC/wloGf5Lxmb/6QFwAGzcFP9y5kYAjMKF/zmepP6SBlD/qcRhAVW3ggBGnt4BO+3q/2AZGv/or2H/C3n4/lgjwgDbtPz+SgjjAMPjSQG4bqH/MemkAYA1LwBSDnn/wb46ADCudf+EFyAAKAqGARYzGf/wC7D/bjmSAHWP7wGdZXb/NlRMAM24Ev8vBEj/TnBV/8EyQgFdEDT/CGmGAAxtSP86nPsAkCPMACygdf4ya8IAAUSl/29uogCeUyj+TNbqADrYzf+rYJP/KONyAbDj8QBG+bcBiFSL/zx69/6PCXX/sa6J/kn3jwDsuX7/Phn3/y1AOP+h9AYAIjk4AWnKUwCAk9AABmcK/0qKQf9hUGT/1q4h/zKGSv9ul4L+b1SsAFTHS/74O3D/CNiyAQm3XwDuGwj+qs3cAMPlhwBiTO3/4lsaAVLbJ//hvscB2ch5/1GzCP+MQc4Ass9X/vr8Lv9oWW4B/b2e/5DWnv+g9Tb/NbdcARXIwv+SIXEB0QH/AOtqK/+nNOgAneXdADMeGQD63RsBQZNX/097xABBxN//TCwRAVXxRADKt/n/QdTU/wkhmgFHO1AAr8I7/41ICQBkoPQA5tA4ADsZS/5QwsIAEgPI/qCfcwCEj/cBb105/zrtCwGG3of/eqNsAXsrvv/7vc7+ULZI/9D24AERPAkAoc8mAI1tWwDYD9P/iE5uAGKjaP8VUHn/rbK3AX+PBABoPFL+1hAN/2DuIQGelOb/f4E+/zP/0v8+jez+nTfg/3In9ADAvPr/5Ew1AGJUUf+tyz3+kzI3/8zrvwA0xfQAWCvT/hu/dwC855oAQlGhAFzBoAH643gAezfiALgRSACFqAr+Foec/ykZZ/8wyjoAupVR/7yG7wDrtb3+2Yu8/0owUgAu2uUAvf37ADLlDP/Tjb8BgPQZ/6nnev5WL73/hLcX/yWylv8zif0AyE4fABZpMgCCPAAAhKNb/hfnuwDAT+8AnWak/8BSFAEYtWf/8AnqAAF7pP+F6QD/yvLyADy69QDxEMf/4HSe/r99W//gVs8AeSXn/+MJxv8Pme//eejZ/ktwUgBfDDn+M9Zp/5TcYQHHYiQAnNEM/grUNADZtDf+1Kro/9gUVP+d+ocAnWN//gHOKQCVJEYBNsTJ/1d0AP7rq5YAG6PqAMqHtADQXwD+e5xdALc+SwCJ67YAzOH//9aL0v8Ccwj/HQxvADScAQD9Ffv/JaUf/gyC0wBqEjX+KmOaAA7ZPf7YC1z/yMVw/pMmxwAk/Hj+a6lNAAF7n//PS2YAo6/EACwB8AB4urD+DWJM/+188f/okrz/yGDgAMwfKQDQyA0AFeFg/6+cxAD30H4APrj0/gKrUQBVc54ANkAt/xOKcgCHR80A4y+TAdrnQgD90RwA9A+t/wYPdv4QltD/uRYy/1Zwz/9LcdcBP5Ir/wThE/7jFz7/Dv/W/i0Izf9XxZf+0lLX//X49/+A+EYA4fdXAFp4RgDV9VwADYXiAC+1BQFco2n/Bh6F/uiyPf/mlRj/EjGeAORkPf508/v/TUtcAVHbk/9Mo/7+jdX2AOglmP5hLGQAySUyAdT0OQCuq7f/+UpwAKacHgDe3WH/811J/vtlZP/Y2V3//oq7/46+NP87y7H/yF40AHNynv+lmGgBfmPi/3ad9AFryBAAwVrlAHkGWACcIF3+ffHT/w7tnf+lmhX/uOAW//oYmP9xTR8A96sX/+2xzP80iZH/wrZyAODqlQAKb2cByYEEAO6OTgA0Bij/btWl/jzP/QA+10UAYGEA/zEtygB4eRb/64swAcYtIv+2MhsBg9Jb/y42gACve2n/xo1O/kP07//1Nmf+Tiby/wJc+f77rlf/iz+QABhsG/8iZhIBIhaYAELldv4yj2MAkKmVAXYemACyCHkBCJ8SAFpl5v+BHXcARCQLAei3NwAX/2D/oSnB/z+L3gAPs/MA/2QP/1I1hwCJOZUBY/Cq/xbm5P4xtFL/PVIrAG712QDHfT0ALv00AI3F2wDTn8EAN3lp/rcUgQCpd6r/y7KL/4cotv+sDcr/QbKUAAjPKwB6NX8BSqEwAOPWgP5WC/P/ZFYHAfVEhv89KxUBmFRe/748+v7vduj/1oglAXFMa/9daGQBkM4X/26WmgHkZ7kA2jEy/odNi/+5AU4AAKGU/2Ed6f/PlJX/oKgAAFuAq/8GHBP+C2/3ACe7lv+K6JUAdT5E/z/YvP/r6iD+HTmg/xkM8QGpPL8AIION/+2fe/9exV7+dP4D/1yzYf55YVz/qnAOABWV+AD44wMAUGBtAEvASgEMWuL/oWpEAdByf/9yKv/+ShpK//ezlv55jDwAk0bI/9Yoof+hvMn/jUGH//Jz/AA+L8oAtJX//oI37QClEbr/CqnCAJxt2v9wjHv/aIDf/rGObP95Jdv/gE0S/29sFwFbwEsArvUW/wTsPv8rQJkB463+AO16hAF/Wbr/jlKA/vxUrgBas7EB89ZX/2c8ov/Qgg7/C4KLAM6B2/9e2Z3/7+bm/3Rzn/6ka18AM9oCAdh9xv+MyoD+C19E/zcJXf6umQb/zKxgAEWgbgDVJjH+G1DVAHZ9cgBGRkP/D45J/4N6uf/zFDL+gu0oANKfjAHFl0H/VJlCAMN+WgAQ7uwBdrtm/wMYhf+7ReYAOMVcAdVFXv9QiuUBzgfmAN5v5gFb6Xf/CVkHAQJiAQCUSoX/M/a0/+SxcAE6vWz/wsvt/hXRwwCTCiMBVp3iAB+ji/44B0v/Plp0ALU8qQCKotT+UacfAM1acP8hcOMAU5d1AbHgSf+ukNn/5sxP/xZN6P9yTuoA4Dl+/gkxjQDyk6UBaLaM/6eEDAF7RH8A4VcnAftsCADGwY8BeYfP/6wWRgAyRHT/Za8o//hp6QCmywcAbsXaANf+Gv6o4v0AH49gAAtnKQC3gcv+ZPdK/9V+hADSkywAx+obAZQvtQCbW54BNmmv/wJOkf5mml8AgM9//jR87P+CVEcA3fPTAJiqzwDeascAt1Re/lzIOP+KtnMBjmCSAIWI5ABhEpYAN/tCAIxmBADKZ5cAHhP4/zO4zwDKxlkAN8Xh/qlf+f9CQUT/vOp+AKbfZAFw7/QAkBfCADontgD0LBj+r0Sz/5h2mgGwooIA2XLM/q1+Tv8h3h7/JAJb/wKP8wAJ69cAA6uXARjX9f+oL6T+8ZLPAEWBtABE83EAkDVI/vstDgAXbqgARERP/25GX/6uW5D/Ic5f/4kpB/8Tu5n+I/9w/wmRuf4ynSUAC3AxAWYIvv/q86kBPFUXAEonvQB0Me8ArdXSAC6hbP+fliUAxHi5/yJiBv+Zwz7/YeZH/2Y9TAAa1Oz/pGEQAMY7kgCjF8QAOBg9ALViwQD7k+X/Yr0Y/y42zv/qUvYAt2cmAW0+zAAK8OAAkhZ1/46aeABF1CMA0GN2AXn/A/9IBsIAdRHF/30PFwCaT5kA1l7F/7k3k/8+/k7+f1KZAG5mP/9sUqH/abvUAVCKJwA8/13/SAy6ANL7HwG+p5D/5CwT/oBD6ADW+Wv+iJFW/4QusAC9u+P/0BaMANnTdAAyUbr+i/ofAB5AxgGHm2QAoM4X/rui0/8QvD8A/tAxAFVUvwDxwPL/mX6RAeqiov/mYdgBQId+AL6U3wE0ACv/HCe9AUCI7gCvxLkAYuLV/3+f9AHirzwAoOmOAbTzz/9FmFkBH2UVAJAZpP6Lv9EAWxl5ACCTBQAnunv/P3Pm/12nxv+P1dz/s5wT/xlCegDWoNn/Ai0+/2pPkv4ziWP/V2Tn/6+R6P9luAH/rgl9AFIloQEkco3/MN6O//W6mgAFrt3+P3Kb/4c3oAFQH4cAfvqzAezaLQAUHJEBEJNJAPm9hAERvcD/347G/0gUD//6Ne3+DwsSABvTcf7Vazj/rpOS/2B+MAAXwW0BJaJeAMed+f4YgLv/zTGy/l2kKv8rd+sBWLft/9rSAf9r/ioA5gpj/6IA4gDb7VsAgbLLANAyX/7O0F//979Z/m7qT/+lPfMAFHpw//b2uf5nBHsA6WPmAdtb/P/H3hb/s/Xp/9Px6gBv+sD/VVSIAGU6Mv+DrZz+dy0z/3bpEP7yWtYAXp/bAQMD6v9iTFz+UDbmAAXk5/41GN//cTh2ARSEAf+r0uwAOPGe/7pzE/8I5a4AMCwAAXJypv8GSeL/zVn0AInjSwH4rTgASnj2/ncDC/9ReMb/iHpi/5Lx3QFtwk7/3/FGAdbIqf9hvi//L2eu/2NcSP526bT/wSPp/hrlIP/e/MYAzCtH/8dUrACGZr4Ab+5h/uYo5gDjzUD+yAzhAKYZ3gBxRTP/j58YAKe4SgAd4HT+ntDpAMF0fv/UC4X/FjqMAcwkM//oHisA60a1/0A4kv6pElT/4gEN/8gysP801fX+qNFhAL9HNwAiTpwA6JA6AblKvQC6jpX+QEV//6HLk/+wl78AiOfL/qO2iQChfvv+6SBCAETPQgAeHCUAXXJgAf5c9/8sq0UAyncL/7x2MgH/U4j/R1IaAEbjAgAg63kBtSmaAEeG5f7K/yQAKZgFAJo/Sf8itnwAed2W/xrM1QEprFcAWp2S/22CFABHa8j/82a9AAHDkf4uWHUACM7jAL9u/f9tgBT+hlUz/4mxcAHYIhb/gxDQ/3mVqgByExcBplAf/3HwegDos/oARG60/tKqdwDfbKT/z0/p/xvl4v7RYlH/T0QHAIO5ZACqHaL/EaJr/zkVCwFkyLX/f0GmAaWGzABop6gAAaRPAJKHOwFGMoD/ZncN/uMGhwCijrP/oGTeABvg2wGeXcP/6o2JABAYff/uzi//YRFi/3RuDP9gc00AW+Po//j+T/9c5Qb+WMaLAM5LgQD6Tc7/jfR7AYpF3AAglwYBg6cW/+1Ep/7HvZYAo6uK/zO8Bv9fHYn+lOKzALVr0P+GH1L/l2Ut/4HK4QDgSJMAMIqX/8NAzv7t2p4Aah2J/v296f9nDxH/wmH/ALItqf7G4ZsAJzB1/4dqcwBhJrUAli9B/1OC5f72JoEAXO+a/ltjfwChbyH/7tny/4O5w//Vv57/KZbaAISpgwBZVPwBq0aA/6P4y/4BMrT/fExVAftvUABjQu//mu22/91+hf5KzGP/QZN3/2M4p/9P+JX/dJvk/+0rDv5FiQv/FvrxAVt6j//N+fMA1Bo8/zC2sAEwF7//y3mY/i1K1f8+WhL+9aPm/7lqdP9TI58ADCEC/1AiPgAQV67/rWVVAMokUf6gRcz/QOG7ADrOXgBWkC8A5Vb1AD+RvgElBScAbfsaAImT6gCieZH/kHTO/8Xouf+3voz/SQz+/4sU8v+qWu//YUK7//W1h/7eiDQA9QUz/ssvTgCYZdgASRd9AP5gIQHr0kn/K9FYAQeBbQB6aOT+qvLLAPLMh//KHOn/QQZ/AJ+QRwBkjF8ATpYNAPtrdgG2On3/ASZs/4290f8Im30BcaNb/3lPvv+G72z/TC/4AKPk7wARbwoAWJVL/9fr7wCnnxj/L5ds/2vRvADp52P+HMqU/64jiv9uGET/AkW1AGtmUgBm7QcAXCTt/92iUwE3ygb/h+qH/xj63gBBXqj+9fjS/6dsyf7/oW8AzQj+AIgNdABksIT/K9d+/7GFgv+eT5QAQ+AlAQzOFf8+Im4B7Wiv/1CEb/+OrkgAVOW0/mmzjABA+A//6YoQAPVDe/7aedT/P1/aAdWFif+PtlL/MBwLAPRyjQHRr0z/nbWW/7rlA/+knW8B572LAHfKvv/aakD/ROs//mAarP+7LwsB1xL7/1FUWQBEOoAAXnEFAVyB0P9hD1P+CRy8AO8JpAA8zZgAwKNi/7gSPADZtosAbTt4/wTA+wCp0vD/Jaxc/pTT9f+zQTQA/Q1zALmuzgFyvJX/7VqtACvHwP9YbHEANCNMAEIZlP/dBAf/l/Fy/77R6ABiMscAl5bV/xJKJAE1KAcAE4dB/xqsRQCu7VUAY18pAAM4EAAnoLH/yGra/rlEVP9buj3+Q4+N/w30pv9jcsYAx26j/8ESugB87/YBbkQWAALrLgHUPGsAaSppAQ7mmAAHBYMAjWia/9UDBgCD5KL/s2QcAed7Vf/ODt8B/WDmACaYlQFiiXoA1s0D/+KYs/8GhYkAnkWM/3Gimv+086z/G71z/48u3P/VhuH/fh1FALwriQHyRgkAWsz//+eqkwAXOBP+OH2d/zCz2v9Ptv3/JtS/ASnrfABglxwAh5S+AM35J/40YIj/1CyI/0PRg//8ghf/24AU/8aBdgBsZQsAsgWSAT4HZP+17F7+HBqkAEwWcP94Zk8AysDlAciw1wApQPT/zrhOAKctPwGgIwD/OwyO/8wJkP/bXuUBehtwAL1pbf9A0Er/+383AQLixgAsTNEAl5hN/9IXLgHJq0X/LNPnAL4l4P/1xD7/qbXe/yLTEQB38cX/5SOYARVFKP+y4qEAlLPBANvC/gEozjP/51z6AUOZqgAVlPEAqkVS/3kS5/9ccgMAuD7mAOHJV/+SYKL/tfLcAK273QHiPqr/OH7ZAXUN4/+zLO8AnY2b/5DdUwDr0dAAKhGlAftRhQB89cn+YdMY/1PWpgCaJAn/+C9/AFrbjP+h2Sb+1JM//0JUlAHPAwEA5oZZAX9Oev/gmwH/UohKALKc0P+6GTH/3gPSAeWWvv9VojT/KVSN/0l7VP5dEZYAdxMcASAW1/8cF8z/jvE0/+Q0fQAdTM8A16f6/q+k5gA3z2kBbbv1/6Es3AEpZYD/pxBeAF3Wa/92SAD+UD3q/3mvfQCLqfsAYSeT/vrEMf+ls27+30a7/xaOfQGas4r/drAqAQqumQCcXGYAqA2h/48QIAD6xbT/y6MsAVcgJAChmRT/e/wPABnjUAA8WI4AERbJAZrNTf8nPy8ACHqNAIAXtv7MJxP/BHAd/xckjP/S6nT+NTI//3mraP+g214AV1IO/ucqBQCli3/+Vk4mAII8Qv7LHi3/LsR6Afk1ov+Ij2f+19JyAOcHoP6pmCr/by32AI6Dh/+DR8z/JOILAAAc8v/hitX/9y7Y/vUDtwBs/EoBzhow/8029v/TxiT/eSMyADTYyv8mi4H+8kmUAEPnjf8qL8wATnQZAQThv/8Gk+QAOlixAHql5f/8U8n/4KdgAbG4nv/yabMB+MbwAIVCywH+JC8ALRhz/3c+/gDE4br+e42sABpVKf/ib7cA1eeXAAQ7B//uipQAQpMh/x/2jf/RjXT/aHAfAFihrABT1+b+L2+XAC0mNAGELcwAioBt/ul1hv/zvq3+8ezwAFJ/7P4o36H/brbh/3uu7wCH8pEBM9GaAJYDc/7ZpPz/N5xFAVRe///oSS0BFBPU/2DFO/5g+yEAJsdJAUCs9/91dDj/5BESAD6KZwH25aT/9HbJ/lYgn/9tIokBVdO6AArBwf56wrEAeu5m/6LaqwBs2aEBnqoiALAvmwG15Av/CJwAABBLXQDOYv8BOpojAAzzuP5DdUL/5uV7AMkqbgCG5LL+umx2/zoTmv9SqT7/co9zAe/EMv+tMMH/kwJU/5aGk/5f6EkAbeM0/r+JCgAozB7+TDRh/6TrfgD+fLwASrYVAXkdI//xHgf+VdrW/wdUlv5RG3X/oJ+Y/kIY3f/jCjwBjYdmANC9lgF1s1wAhBaI/3jHHAAVgU/+tglBANqjqQD2k8b/ayaQAU6vzf/WBfr+L1gd/6QvzP8rNwb/g4bP/nRk1gBgjEsBatyQAMMgHAGsUQX/x7M0/yVUywCqcK4ACwRbAEX0GwF1g1wAIZiv/4yZa//7hyv+V4oE/8bqk/55mFT/zWWbAZ0JGQBIahH+bJkA/73lugDBCLD/rpXRAO6CHQDp1n4BPeJmADmjBAHGbzP/LU9OAXPSCv/aCRn/novG/9NSu/5QhVMAnYHmAfOFhv8oiBAATWtP/7dVXAGxzMoAo0eT/5hFvgCsM7wB+tKs/9PycQFZWRr/QEJv/nSYKgChJxv/NlD+AGrRcwFnfGEA3eZi/x/nBgCywHj+D9nL/3yeTwBwkfcAXPowAaO1wf8lL47+kL2l/y6S8AAGS4AAKZ3I/ld51QABcewABS36AJAMUgAfbOcA4e93/6cHvf+75IT/br0iAF4szAGiNMUATrzx/jkUjQD0ki8BzmQzAH1rlP4bw00AmP1aAQePkP8zJR8AIncm/wfFdgCZvNMAlxR0/vVBNP+0/W4BL7HRAKFjEf923soAfbP8AXs2fv+ROb8AN7p5AArzigDN0+X/fZzx/pScuf/jE7z/fCkg/x8izv4ROVMAzBYl/ypgYgB3ZrgBA74cAG5S2v/IzMD/yZF2AHXMkgCEIGIBwMJ5AGqh+AHtWHwAF9QaAM2rWv/4MNgBjSXm/3zLAP6eqB7/1vgVAHC7B/9Lhe//SuPz//qTRgDWeKIApwmz/xaeEgDaTdEBYW1R//Qhs/85NDn/QazS//lH0f+Oqe4Anr2Z/67+Z/5iIQ4AjUzm/3GLNP8POtQAqNfJ//jM1wHfRKD/OZq3/i/neQBqpokAUYiKAKUrMwDniz0AOV87/nZiGf+XP+wBXr76/6m5cgEF+jr/S2lhAdffhgBxY6MBgD5wAGNqkwCjwwoAIc22ANYOrv+BJuf/NbbfAGIqn//3DSgAvNKxAQYVAP//PZT+iS2B/1kadP5+JnIA+zLy/nmGgP/M+af+pevXAMqx8wCFjT4A8IK+AW6v/wAAFJIBJdJ5/wcnggCO+lT/jcjPAAlfaP8L9K4Ahuh+AKcBe/4QwZX/6OnvAdVGcP/8dKD+8t7c/81V4wAHuToAdvc/AXRNsf8+9cj+PxIl/2s16P4y3dMAotsH/gJeKwC2Prb+oE7I/4eMqgDruOQArzWK/lA6Tf+YyQIBP8QiAAUeuACrsJoAeTvOACZjJwCsUE3+AIaXALoh8f5e/d//LHL8AGx+Of/JKA3/J+Ub/yfvFwGXeTP/mZb4AArqrv929gT+yPUmAEWh8gEQspYAcTiCAKsfaQAaWGz/MSpqAPupQgBFXZUAFDn+AKQZbwBavFr/zATFACjVMgHUYIT/WIq0/uSSfP+49vcAQXVW//1m0v7+eSQAiXMD/zwY2ACGEh0AO+JhALCORwAH0aEAvVQz/pv6SADVVOv/Ld7gAO6Uj/+qKjX/Tqd1ALoAKP99sWf/ReFCAOMHWAFLrAYAqS3jARAkRv8yAgn/i8EWAI+35/7aRTIA7DihAdWDKgCKkSz+iOUo/zE/I/89kfX/ZcAC/uincQCYaCYBebnaAHmL0/538CMAQb3Z/ruzov+gu+YAPvgO/zxOYQD/96P/4Ttb/2tHOv/xLyEBMnXsANuxP/70WrMAI8LX/71DMv8Xh4EAaL0l/7k5wgAjPuf/3PhsAAznsgCPUFsBg11l/5AnAgH/+rIABRHs/osgLgDMvCb+9XM0/79xSf6/bEX/FkX1ARfLsgCqY6oAQfhvACVsmf9AJUUAAFg+/lmUkP+/ROAB8Sc1ACnL7f+RfsL/3Sr9/xljlwBh/d8BSnMx/wavSP87sMsAfLf5AeTkYwCBDM/+qMDD/8ywEP6Y6qsATSVV/yF4h/+OwuMBH9Y6ANW7ff/oLjz/vnQq/peyE/8zPu3+zOzBAMLoPACsIp3/vRC4/mcDX/+N6ST+KRkL/xXDpgB29S0AQ9WV/58MEv+7pOMBoBkFAAxOwwErxeEAMI4p/sSbPP/fxxIBkYicAPx1qf6R4u4A7xdrAG21vP/mcDH+Sart/+e34/9Q3BQAwmt/AX/NZQAuNMUB0qsk/1gDWv84l40AYLv//ypOyAD+RkYB9H2oAMxEigF810YAZkLI/hE05AB13I/+y/h7ADgSrv+6l6T/M+jQAaDkK//5HRkBRL4/AA0AAAAA/wAAAAD1AAAAAAAA+wAAAAAAAP0AAAAA8wAAAAAHAAAAAAADAAAAAPMAAAAABQAAAAAAAAAACwAAAAAACwAAAADzAAAAAAAA/QAAAAAA/wAAAAADAAAAAPUAAAAAAAAADwAAAAAA/wAAAAD/AAAAAAcAAAAABQ=="), Yr(dn, 33964, "AQAAAHbBXwBlcAL/UPyh/vJqxv+FBrIA5N9wAN/uVf4z8xoAPiuL/stBCg=="), Yr(dn, 34016, "M03tAJGqVv82JjP/8YBl/yl5Sv/sTpsAqZdp/pwpSADCZq//zqJl/wAAAAAAAAAAGy57ARKo/f/Tr5f+w9tgADh2vv7+0fX/mWR+/uiBFf81uPL/x6Td"), Yr(dn, 34144, "AQ=="), Yr(dn, 34176, "4Ot6fDtBuK4WVuP68Z/EatoJjeucMrH9hmIFFl9JuABfnJW8o1CMJLHQsVWcg+9bBERcxFgcjobYIk7d0J8RV+z///////////////////////////////////////9/7f///////////////////////////////////////3/u////////////////////////////////////////f0xpYnNvZGl1bURSRwAAAAAIybzzZ+YJajunyoSFrme7K/iU/nLzbjzxNh1fOvVPpdGC5q1/Ug5RH2w+K4xoBZtrvUH7q9mDH3khfhMZzeBbIq4o15gvikLNZe8jkUQ3cS87TezP+8C1vNuJgaXbtek4tUjzW8JWORnQBbbxEfFZm08Zr6SCP5IYgW3a1V4cq0ICA6OYqgfYvm9wRQFbgxKMsuROvoUxJOK0/9XDfQxVb4l78nRdvnKxlhY7/rHegDUSxyWnBtyblCZpz3Txm8HSSvGewWmb5OMlTziGR77vtdWMi8adwQ9lnKx3zKEMJHUCK1lvLOktg+SmbqqEdErU+0G93KmwXLVTEYPaiPl2q99m7lJRPpgQMrQtbcYxqD8h+5jIJwOw5A7vvsd/Wb/Cj6g98wvgxiWnCpNHkafVb4ID4FFjygZwbg4KZykpFPwv0kaFCrcnJskmXDghGy7tKsRa/G0sTd+zlZ0TDThT3mOvi1RzCmWosnc8uwpqduau7UcuycKBOzWCFIUscpJkA/FMoei/ogEwQrxLZhqokZf40HCLS8IwvlQGo1FsxxhS79YZ6JLREKllVSQGmdYqIHFXhTUO9LjRuzJwoGoQyNDSuBbBpBlTq0FRCGw3Hpnrjt9Md0gnqEib4bW8sDRjWsnFswwcOcuKQeNKqthOc+Njd0/KnFujuLLW828uaPyy713ugo90YC8XQ29jpXhyq/ChFHjIhOw5ZBoIAseMKB5jI/r/vpDpvYLe62xQpBV5xrL3o/m+K1Ny4/J4ccacYSbqzj4nygfCwCHHuIbRHuvgzdZ92up40W7uf0999bpvF3KqZ/AGppjIosV9YwquDfm+BJg/ERtHHBM1C3EbhH0EI/V32yiTJMdAe6vKMry+yRUKvp48TA0QnMRnHUO2Qj7LvtTFTCp+ZfycKX9Z7PrWOqtvy18XWEdKjBlEbIA="), Yr(dn, 35184, "7dP1XBpjEljWnPei3vneFA=="), Yr(dn, 35215, "EA=="), Yr(dn, 35232, "Z+YJaoWuZ7ty8248OvVPpX9SDlGMaAWbq9mDHxnN4FuYL4pCkUQ3cc/7wLWl27XpW8JWOfER8Vmkgj+S1V4cq5iqB9gBW4MSvoUxJMN9DFV0Xb5y/rHegKcG3Jt08ZvBwWmb5IZHvu/GncEPzKEMJG8s6S2qhHRK3KmwXNqI+XZSUT6YbcYxqMgnA7DHf1m/8wvgxkeRp9VRY8oGZykpFIUKtyc4IRsu/G0sTRMNOFNUcwpluwpqdi7JwoGFLHKSoei/oktmGqhwi0vCo1FsxxnoktEkBpnWhTUO9HCgahAWwaQZCGw3Hkx3SCe1vLA0swwcOUqq2E5Pypxb828uaO6Cj3RvY6V4FHjIhAgCx4z6/76Q62xQpPej+b7yeHHGgA=="), Yr(dn, 35600, "U2lnRWQyNTUxOSBubyBFZDI1NTE5IGNvbGxpc2lvbnMB"), Yr(dn, 35696, "EJUBAAEAAAACAAAAAwAAAAQAAAAFAAAABgAAAAcAAAAIAAAACQ=="), Yr(dn, 35744, "xmNjpfh8fITud3eZ9nt7jf/y8g3Wa2u93m9vsZHFxVRgMDBQAgEBA85nZ6lWKyt95/7+GbXX12JNq6vm7HZ2mo/KykUfgoKdicnJQPp9fYfv+voVsllZ645HR8n78PALQa2t7LPU1GdfoqL9Ra+v6iOcnL9TpKT35HJylpvAwFt1t7fC4f39HD2Tk65MJiZqbDY2Wn4/P0H19/cCg8zMT2g0NFxRpaX00eXlNPnx8QjicXGTq9jYc2IxMVMqFRU/CAQEDJXHx1JGIyNlncPDXjAYGCg3lpahCgUFDy+amrUOBwcJJBISNhuAgJvf4uI9zevrJk4nJ2l/srLN6nV1nxIJCRsdg4OeWCwsdDQaGi42Gxst3G5usrRaWu5boKD7pFJS9nY7O0231tZhfbOzzlIpKXvd4+M+Xi8vcROEhJemU1P1udHRaAAAAADB7e0sQCAgYOP8/B95sbHItltb7dRqar6Ny8tGZ76+2XI5OUuUSkremExM1LBYWOiFz89Ku9DQa8Xv7ypPqqrl7fv7FoZDQ8WaTU3XZjMzVRGFhZSKRUXP6fn5EAQCAgb+f3+BoFBQ8Hg8PEQln5+6S6io46JRUfNdo6P+gEBAwAWPj4o/kpKtIZ2dvHA4OEjx9fUEY7y833e2tsGv2tp1QiEhYyAQEDDl//8a/fPzDr/S0m2Bzc1MGAwMFCYTEzXD7Owvvl9f4TWXl6KIRETMLhcXOZPExFdVp6fy/H5+gno9PUfIZGSsul1d5zIZGSvmc3OVwGBgoBmBgZieT0/Ro9zcf0QiImZUKip+O5CQqwuIiIOMRkbKx+7uKWu4uNMoFBQ8p97eebxeXuIWCwsdrdvbdtvg4DtkMjJWdDo6ThQKCh6SSUnbDAYGCkgkJGy4XFzkn8LCXb3T025DrKzvxGJipjmRkagxlZWk0+TkN/J5eYvV5+cyi8jIQ243N1nabW23AY2NjLHV1WScTk7SSamp4NhsbLSsVlb68/T0B8/q6iXKZWWv9Hp6jkeurukQCAgYb7q61fB4eIhKJSVvXC4ucjgcHCRXpqbxc7S0x5fGxlHL6Ogjod3dfOh0dJw+Hx8hlktL3WG9vdwNi4uGD4qKheBwcJB8Pj5CcbW1xMxmZqqQSEjYBgMDBff29gEcDg4SwmFho2o1NV+uV1f5abm50BeGhpGZwcFYOh0dJyeenrnZ4eE46/j4EyuYmLMiEREz0mlpu6nZ2XAHjo6JM5SUpy2bm7Y8Hh4iFYeHksnp6SCHzs5JqlVV/1AoKHil3996A4yMj1mhofgJiYmAGg0NF2W/v9rX5uYxhEJCxtBoaLiCQUHDKZmZsFotLXceDw8Re7Cwy6hUVPxtu7vWLBYWOgoAAAALAAAADAAAAA0AAAAOAAAADwAAABAAAAAR");
                    var Nu, Af = (Nu = [null, function(k, E, T, M, ye) {
                      var Ne, pr, ve;
                      return k |= 0, E |= 0, T |= 0, M |= 0, ye |= 0, dr = Ne = (pr = dr) - 128 & -64, o[Ne >> 2] = 67108863 & (m[0 | ye] | m[ye + 1 | 0] << 8 | m[ye + 2 | 0] << 16 | m[ye + 3 | 0] << 24), o[Ne + 4 >> 2] = (m[ye + 3 | 0] | m[ye + 4 | 0] << 8 | m[ye + 5 | 0] << 16 | m[ye + 6 | 0] << 24) >>> 2 & 67108611, o[Ne + 8 >> 2] = (m[ye + 6 | 0] | m[ye + 7 | 0] << 8 | m[ye + 8 | 0] << 16 | m[ye + 9 | 0] << 24) >>> 4 & 67092735, o[Ne + 12 >> 2] = (m[ye + 9 | 0] | m[ye + 10 | 0] << 8 | m[ye + 11 | 0] << 16 | m[ye + 12 | 0] << 24) >>> 6 & 66076671, ve = m[ye + 12 | 0] | m[ye + 13 | 0] << 8 | m[ye + 14 | 0] << 16 | m[ye + 15 | 0] << 24, o[Ne + 20 >> 2] = 0, o[Ne + 24 >> 2] = 0, o[Ne + 28 >> 2] = 0, o[Ne + 32 >> 2] = 0, o[Ne + 36 >> 2] = 0, o[Ne + 16 >> 2] = ve >>> 8 & 1048575, o[Ne + 40 >> 2] = m[ye + 16 | 0] | m[ye + 17 | 0] << 8 | m[ye + 18 | 0] << 16 | m[ye + 19 | 0] << 24, o[Ne + 44 >> 2] = m[ye + 20 | 0] | m[ye + 21 | 0] << 8 | m[ye + 22 | 0] << 16 | m[ye + 23 | 0] << 24, o[Ne + 48 >> 2] = m[ye + 24 | 0] | m[ye + 25 | 0] << 8 | m[ye + 26 | 0] << 16 | m[ye + 27 | 0] << 24, ye = m[ye + 28 | 0] | m[ye + 29 | 0] << 8 | m[ye + 30 | 0] << 16 | m[ye + 31 | 0] << 24, B[Ne + 80 | 0] = 0, o[Ne + 56 >> 2] = 0, o[Ne + 60 >> 2] = 0, o[Ne + 52 >> 2] = ye, Ms(Ne, E, T, M), Uc(Ne, k), dr = pr, 0;
                    }, function(k, E, T, M, ye) {
                      var Ne, pr, ve;
                      return k |= 0, E |= 0, T |= 0, M |= 0, ye |= 0, dr = Ne = (pr = dr) - 192 & -64, o[Ne + 64 >> 2] = 67108863 & (m[0 | ye] | m[ye + 1 | 0] << 8 | m[ye + 2 | 0] << 16 | m[ye + 3 | 0] << 24), o[Ne + 68 >> 2] = (m[ye + 3 | 0] | m[ye + 4 | 0] << 8 | m[ye + 5 | 0] << 16 | m[ye + 6 | 0] << 24) >>> 2 & 67108611, o[Ne + 72 >> 2] = (m[ye + 6 | 0] | m[ye + 7 | 0] << 8 | m[ye + 8 | 0] << 16 | m[ye + 9 | 0] << 24) >>> 4 & 67092735, o[Ne + 76 >> 2] = (m[ye + 9 | 0] | m[ye + 10 | 0] << 8 | m[ye + 11 | 0] << 16 | m[ye + 12 | 0] << 24) >>> 6 & 66076671, ve = m[ye + 12 | 0] | m[ye + 13 | 0] << 8 | m[ye + 14 | 0] << 16 | m[ye + 15 | 0] << 24, o[Ne + 84 >> 2] = 0, o[Ne + 88 >> 2] = 0, o[Ne + 92 >> 2] = 0, o[Ne + 96 >> 2] = 0, o[Ne + 100 >> 2] = 0, o[Ne + 80 >> 2] = ve >>> 8 & 1048575, o[Ne + 104 >> 2] = m[ye + 16 | 0] | m[ye + 17 | 0] << 8 | m[ye + 18 | 0] << 16 | m[ye + 19 | 0] << 24, o[Ne + 108 >> 2] = m[ye + 20 | 0] | m[ye + 21 | 0] << 8 | m[ye + 22 | 0] << 16 | m[ye + 23 | 0] << 24, o[Ne + 112 >> 2] = m[ye + 24 | 0] | m[ye + 25 | 0] << 8 | m[ye + 26 | 0] << 16 | m[ye + 27 | 0] << 24, ye = m[ye + 28 | 0] | m[ye + 29 | 0] << 8 | m[ye + 30 | 0] << 16 | m[ye + 31 | 0] << 24, B[Ne + 144 | 0] = 0, o[Ne + 120 >> 2] = 0, o[Ne + 124 >> 2] = 0, o[Ne + 116 >> 2] = ye, Ms(ye = Ne - -64 | 0, E, T, M), Uc(ye, E = Ne + 48 | 0), k = pc(k, E), dr = pr, 0 | k;
                    }, function(k, E) {
                      var T;
                      return E |= 0, o[(k |= 0) >> 2] = 67108863 & (m[0 | E] | m[E + 1 | 0] << 8 | m[E + 2 | 0] << 16 | m[E + 3 | 0] << 24), o[k + 4 >> 2] = (m[E + 3 | 0] | m[E + 4 | 0] << 8 | m[E + 5 | 0] << 16 | m[E + 6 | 0] << 24) >>> 2 & 67108611, o[k + 8 >> 2] = (m[E + 6 | 0] | m[E + 7 | 0] << 8 | m[E + 8 | 0] << 16 | m[E + 9 | 0] << 24) >>> 4 & 67092735, o[k + 12 >> 2] = (m[E + 9 | 0] | m[E + 10 | 0] << 8 | m[E + 11 | 0] << 16 | m[E + 12 | 0] << 24) >>> 6 & 66076671, T = m[E + 12 | 0] | m[E + 13 | 0] << 8 | m[E + 14 | 0] << 16 | m[E + 15 | 0] << 24, o[k + 20 >> 2] = 0, o[k + 24 >> 2] = 0, o[k + 28 >> 2] = 0, o[k + 32 >> 2] = 0, o[k + 36 >> 2] = 0, o[k + 16 >> 2] = T >>> 8 & 1048575, o[k + 40 >> 2] = m[E + 16 | 0] | m[E + 17 | 0] << 8 | m[E + 18 | 0] << 16 | m[E + 19 | 0] << 24, o[k + 44 >> 2] = m[E + 20 | 0] | m[E + 21 | 0] << 8 | m[E + 22 | 0] << 16 | m[E + 23 | 0] << 24, o[k + 48 >> 2] = m[E + 24 | 0] | m[E + 25 | 0] << 8 | m[E + 26 | 0] << 16 | m[E + 27 | 0] << 24, E = m[E + 28 | 0] | m[E + 29 | 0] << 8 | m[E + 30 | 0] << 16 | m[E + 31 | 0] << 24, B[k + 80 | 0] = 0, o[k + 56 >> 2] = 0, o[k + 60 >> 2] = 0, o[k + 52 >> 2] = E, 0;
                    }, function(k, E, T, M) {
                      return Ms(k |= 0, E |= 0, T |= 0, M |= 0), 0;
                    }, function(k, E) {
                      return Uc(k |= 0, E |= 0), 0;
                    }, function(k, E, T) {
                      k |= 0, E |= 0, T |= 0;
                      var M, ye = 0, Ne = 0, pr = 0, ve = 0, cr = 0, gr = 0, Pr = 0, Nr = 0, Br = 0, Mr = 0, jr = 0, ti = 0, fi = 0, Jr = 0, li = 0, Tr = 0, Mi = 0, Wi = 0, vn = 0, Tn = 0, Ni = 0, Yi = 0, Xi = 0, $n = 0, Zn = 0, to = 0, fo = 0, wo = 0, bo = 0, go = 0, qn = 0, io = 0, So = 0, qo = 0, Ln = 0, ro = 0, Qo = 0, Vo = 0, as = 0, cs = 0, ms = 0, ai = 0, ci = 0, Fi = 0, Eo = 0, is = 0, ws = 0, ys = 0, Is = 0, ks = 0, Ps = 0, Po = 0, fn = 0, Qn = 0, zn = 0, es = 0, us = 0, Cs = 0, Es = 0, Rs = 0, Ds = 0, Ns = 0, Fs = 0, Qs = 0, Ys = 0, Vs = 0;
                      for (dr = M = dr - 368 | 0; jr = (pr = m[T + ye | 0]) ^ m[0 | (cr = ye + 34112 | 0)] | jr, Mr = pr ^ m[cr + 192 | 0] | Mr, Br = pr ^ m[cr + 160 | 0] | Br, Nr = pr ^ m[cr + 128 | 0] | Nr, ve = pr ^ m[cr + 96 | 0] | ve, gr = pr ^ m[cr - -64 | 0] | gr, Ne = pr ^ m[cr + 32 | 0] | Ne, (0 | (ye = ye + 1 | 0)) != 31; ) ;
                      if (ye = -1, !(256 & ((255 & ((pr = 127 ^ (cr = 127 & m[T + 31 | 0])) | Mr)) - 1 | (255 & (pr | Br)) - 1 | (255 & (pr | Nr)) - 1 | (255 & (87 ^ cr | ve)) - 1 | (255 & (gr | cr)) - 1 | (255 & (Ne | cr)) - 1 | (255 & (cr | jr)) - 1))) {
                        for (ye = E, E = m[E + 28 | 0] | m[E + 29 | 0] << 8 | m[E + 30 | 0] << 16 | m[E + 31 | 0] << 24, o[M + 360 >> 2] = m[ye + 24 | 0] | m[ye + 25 | 0] << 8 | m[ye + 26 | 0] << 16 | m[ye + 27 | 0] << 24, o[M + 364 >> 2] = E, E = m[ye + 20 | 0] | m[ye + 21 | 0] << 8 | m[ye + 22 | 0] << 16 | m[ye + 23 | 0] << 24, o[M + 352 >> 2] = m[ye + 16 | 0] | m[ye + 17 | 0] << 8 | m[ye + 18 | 0] << 16 | m[ye + 19 | 0] << 24, o[M + 356 >> 2] = E, Ne = m[ye + 4 | 0] | m[ye + 5 | 0] << 8 | m[ye + 6 | 0] << 16 | m[ye + 7 | 0] << 24, E = m[0 | ye] | m[ye + 1 | 0] << 8 | m[ye + 2 | 0] << 16 | m[ye + 3 | 0] << 24, o[M + 336 >> 2] = E, o[M + 340 >> 2] = Ne, Ne = m[ye + 12 | 0] | m[ye + 13 | 0] << 8 | m[ye + 14 | 0] << 16 | m[ye + 15 | 0] << 24, o[M + 344 >> 2] = m[ye + 8 | 0] | m[ye + 9 | 0] << 8 | m[ye + 10 | 0] << 16 | m[ye + 11 | 0] << 24, o[M + 348 >> 2] = Ne, B[M + 336 | 0] = 248 & E, B[M + 367 | 0] = 63 & m[M + 367 | 0] | 64, Va(M + 288 | 0, T), o[M + 260 >> 2] = 0, o[M + 264 >> 2] = 0, o[M + 268 >> 2] = 0, o[M + 272 >> 2] = 0, o[M + 276 >> 2] = 0, o[M + 208 >> 2] = 0, o[M + 212 >> 2] = 0, o[M + 216 >> 2] = 0, o[M + 220 >> 2] = 0, o[M + 224 >> 2] = 0, o[M + 228 >> 2] = 0, E = o[M + 308 >> 2], o[M + 160 >> 2] = o[M + 304 >> 2], o[M + 164 >> 2] = E, E = o[M + 316 >> 2], o[M + 168 >> 2] = o[M + 312 >> 2], o[M + 172 >> 2] = E, E = o[M + 324 >> 2], o[M + 176 >> 2] = o[M + 320 >> 2], o[M + 180 >> 2] = E, o[M + 244 >> 2] = 0, o[M + 248 >> 2] = 0, o[M + 240 >> 2] = 1, o[M + 252 >> 2] = 0, o[M + 256 >> 2] = 0, o[M + 192 >> 2] = 0, o[M + 196 >> 2] = 0, o[M + 200 >> 2] = 0, o[M + 204 >> 2] = 0, E = o[M + 292 >> 2], o[M + 144 >> 2] = o[M + 288 >> 2], o[M + 148 >> 2] = E, E = o[M + 300 >> 2], o[M + 152 >> 2] = o[M + 296 >> 2], o[M + 156 >> 2] = E, o[M + 116 >> 2] = 0, o[M + 120 >> 2] = 0, o[M + 124 >> 2] = 0, o[M + 128 >> 2] = 0, o[M + 132 >> 2] = 0, o[M + 100 >> 2] = 0, o[M + 104 >> 2] = 0, o[M + 96 >> 2] = 1, o[M + 108 >> 2] = 0, o[M + 112 >> 2] = 0, T = 254; ms = o[M + 276 >> 2], pr = o[M + 180 >> 2], ai = o[M + 96 >> 2], ci = o[M + 192 >> 2], Fi = o[M + 144 >> 2], Eo = o[M + 240 >> 2], is = o[M + 100 >> 2], ws = o[M + 196 >> 2], ys = o[M + 148 >> 2], Is = o[M + 244 >> 2], Yi = o[M + 104 >> 2], ks = o[M + 200 >> 2], Xi = o[M + 152 >> 2], Ps = o[M + 248 >> 2], to = o[M + 108 >> 2], Po = o[M + 204 >> 2], fo = o[M + 156 >> 2], fn = o[M + 252 >> 2], $n = o[M + 112 >> 2], Qn = o[M + 208 >> 2], Tn = o[M + 160 >> 2], zn = o[M + 256 >> 2], jr = o[M + 116 >> 2], es = o[M + 212 >> 2], Pr = o[M + 164 >> 2], us = o[M + 260 >> 2], Mr = o[M + 120 >> 2], Cs = o[M + 216 >> 2], Br = o[M + 168 >> 2], Es = o[M + 264 >> 2], Nr = o[M + 124 >> 2], Rs = o[M + 220 >> 2], ve = o[M + 172 >> 2], Ds = o[M + 268 >> 2], gr = o[M + 128 >> 2], Ns = o[M + 224 >> 2], Ne = o[M + 176 >> 2], vn = o[M + 272 >> 2], Fs = T, Ni = (Tr = (E = 0 - ((E = cs) ^ (cs = m[(Qs = M + 336 | 0) + (T >>> 3 | 0) | 0] >>> (7 & T) & 1)) | 0) & ((ye = o[M + 132 >> 2]) ^ (ro = o[M + 228 >> 2]))) ^ ye, o[M + 132 >> 2] = Ni, Qo = pr ^ (Mi = E & (pr ^ ms)), o[M + 84 >> 2] = Qo - Ni, Zn = gr ^ (fi = E & (gr ^ Ns)), o[M + 128 >> 2] = Zn, Vo = (Wi = E & (Ne ^ vn)) ^ Ne, o[M + 80 >> 2] = Vo - Zn, bo = Nr ^ (Jr = E & (Nr ^ Rs)), o[M + 124 >> 2] = bo, Ys = ve ^ (li = E & (ve ^ Ds)), o[M + 76 >> 2] = Ys - bo, go = Mr ^ (ti = E & (Mr ^ Cs)), o[M + 120 >> 2] = go, Vs = Br ^ (cr = E & (Br ^ Es)), o[M + 72 >> 2] = Vs - go, qn = jr ^ (pr = E & (jr ^ es)), o[M + 116 >> 2] = qn, io = Pr ^ (jr = E & (Pr ^ us)), o[M + 68 >> 2] = io - qn, So = $n ^ (Mr = E & ($n ^ Qn)), o[M + 112 >> 2] = So, wo = Tn ^ (Br = E & (Tn ^ zn)), o[M + 64 >> 2] = wo - So, qo = to ^ (Nr = E & (to ^ Po)), o[M + 108 >> 2] = qo, as = fo ^ (ve = E & (fo ^ fn)), o[M + 60 >> 2] = as - qo, Ln = Yi ^ (gr = E & (Yi ^ ks)), o[M + 104 >> 2] = Ln, to = Xi ^ (Ne = E & (Xi ^ Ps)), o[M + 56 >> 2] = to - Ln, Yi = is ^ (ye = E & (is ^ ws)), o[M + 100 >> 2] = Yi, fo = ys ^ (T = E & (ys ^ Is)), o[M + 52 >> 2] = fo - Yi, Xi = ai ^ ($n = E & (ai ^ ci)), o[M + 96 >> 2] = Xi, Tn = (E &= Fi ^ Eo) ^ Fi, o[M + 48 >> 2] = Tn - Xi, Pr = Mi ^ ms, Tr ^= ro, o[M + 36 >> 2] = Pr - Tr, Mi = Wi ^ vn, fi ^= Ns, o[M + 32 >> 2] = Mi - fi, Wi = li ^ Ds, Jr ^= Rs, o[M + 28 >> 2] = Wi - Jr, li = cr ^ Es, ti ^= Cs, o[M + 24 >> 2] = li - ti, cr = jr ^ us, pr ^= es, o[M + 20 >> 2] = cr - pr, jr = Br ^ zn, Mr ^= Qn, o[M + 16 >> 2] = jr - Mr, Br = ve ^ fn, Nr ^= Po, o[M + 12 >> 2] = Br - Nr, ve = Ne ^ Ps, gr ^= ks, o[M + 8 >> 2] = ve - gr, Ne = T ^ Is, ye ^= ws, o[M + 4 >> 2] = Ne - ye, T = E ^ Eo, E = $n ^ ci, o[M >> 2] = T - E, o[M + 276 >> 2] = Pr + Tr, o[M + 272 >> 2] = Mi + fi, o[M + 268 >> 2] = Jr + Wi, o[M + 264 >> 2] = ti + li, o[M + 260 >> 2] = pr + cr, o[M + 256 >> 2] = Mr + jr, o[M + 248 >> 2] = ve + gr, o[M + 244 >> 2] = ye + Ne, o[M + 240 >> 2] = E + T, o[M + 252 >> 2] = Nr + Br, o[M + 228 >> 2] = Ni + Qo, o[M + 224 >> 2] = Zn + Vo, o[M + 220 >> 2] = bo + Ys, o[M + 216 >> 2] = go + Vs, o[M + 212 >> 2] = qn + io, o[M + 208 >> 2] = wo + So, o[M + 204 >> 2] = qo + as, o[M + 200 >> 2] = to + Ln, o[M + 196 >> 2] = Yi + fo, o[M + 192 >> 2] = Tn + Xi, Ti(Qo = M + 96 | 0, Zn = M + 48 | 0, Ni = M + 240 | 0), Ti(vn = M + 192 | 0, vn, M), qi(Zn, M), qi(M, Ni), Pr = o[M + 192 >> 2], Tr = o[M + 96 >> 2], Mi = o[M + 196 >> 2], fi = o[M + 100 >> 2], Wi = o[M + 200 >> 2], Jr = o[M + 104 >> 2], li = o[M + 204 >> 2], ti = o[M + 108 >> 2], cr = o[M + 208 >> 2], pr = o[M + 112 >> 2], jr = o[M + 212 >> 2], Mr = o[M + 116 >> 2], Br = o[M + 216 >> 2], Nr = o[M + 120 >> 2], ve = o[M + 220 >> 2], gr = o[M + 124 >> 2], Ne = o[M + 224 >> 2], ye = o[M + 128 >> 2], T = o[M + 228 >> 2], E = o[M + 132 >> 2], o[M + 180 >> 2] = T + E, o[M + 176 >> 2] = ye + Ne, o[M + 172 >> 2] = ve + gr, o[M + 168 >> 2] = Nr + Br, o[M + 164 >> 2] = Mr + jr, o[M + 160 >> 2] = pr + cr, o[M + 156 >> 2] = ti + li, o[M + 152 >> 2] = Jr + Wi, o[M + 148 >> 2] = Mi + fi, o[M + 144 >> 2] = Pr + Tr, o[M + 228 >> 2] = E - T, o[M + 224 >> 2] = ye - Ne, o[M + 220 >> 2] = gr - ve, o[M + 216 >> 2] = Nr - Br, o[M + 212 >> 2] = Mr - jr, o[M + 208 >> 2] = pr - cr, o[M + 204 >> 2] = ti - li, o[M + 200 >> 2] = Jr - Wi, o[M + 196 >> 2] = fi - Mi, o[M + 192 >> 2] = Tr - Pr, Ti(Ni, M, Zn), bo = o[M + 52 >> 2], ti = o[M + 4 >> 2], go = o[M + 56 >> 2], cr = o[M + 8 >> 2], qn = o[M + 64 >> 2], Br = o[M + 16 >> 2], So = o[M + 60 >> 2], Nr = o[M + 12 >> 2], qo = o[M + 72 >> 2], ve = o[M + 24 >> 2], Ln = o[M + 68 >> 2], gr = o[M + 20 >> 2], Yi = o[M + 80 >> 2], Ne = o[M + 32 >> 2], Xi = o[M + 76 >> 2], ye = o[M + 28 >> 2], ro = o[M + 84 >> 2], E = o[M + 36 >> 2], Vo = o[M + 48 >> 2], T = o[M >> 2] - Vo | 0, o[M >> 2] = T, E = E - ro | 0, o[M + 36 >> 2] = E, $n = ye - Xi | 0, o[M + 28 >> 2] = $n, Tn = Ne - Yi | 0, o[M + 32 >> 2] = Tn, pr = gr - Ln | 0, o[M + 20 >> 2] = pr, jr = ve - qo | 0, o[M + 24 >> 2] = jr, Mr = Nr - So | 0, o[M + 12 >> 2] = Mr, Br = Br - qn | 0, o[M + 16 >> 2] = Br, Nr = cr - go | 0, o[M + 8 >> 2] = Nr, Ne = ti - bo | 0, o[M + 4 >> 2] = Ne, qi(vn, vn), E = Zr(E, E >> 31, 121666, 0), ye = Qe, as = E, E = Zr((33554431 & (ye = (Pr = E + 16777216 | 0) >>> 0 < 16777216 ? ye + 1 | 0 : ye)) << 7 | Pr >>> 25, ye >> 25, 19, 0), gr = Qe, ye = E, E = Zr(T, T >> 31, 121666, 0), wo = Qe + gr | 0, E = E >>> 0 > (ye = ye + E | 0) >>> 0 ? wo + 1 | 0 : wo, T = (ve = ye + 33554432 | 0) >>> 0 < 33554432 ? E + 1 | 0 : E, Tr = ye - (-67108864 & ve) | 0, o[M + 96 >> 2] = Tr, gr = Zr(Ne, Ne >> 31, 121666, 0), ye = Qe, ye = (Ne = gr + 16777216 | 0) >>> 0 < 16777216 ? ye + 1 | 0 : ye, Mi = (gr - (-33554432 & Ne) | 0) + ((67108863 & T) << 6 | ve >>> 26) | 0, o[M + 100 >> 2] = Mi, wo = (E = ye) >> 25, ye = (33554431 & E) << 7 | Ne >>> 25, T = Zr(Nr, Nr >> 31, 121666, 0) + ye | 0, E = wo + Qe | 0, E = T >>> 0 < ye >>> 0 ? E + 1 | 0 : E, gr = (fi = T + 33554432 | 0) >>> 0 < 33554432 ? E + 1 | 0 : E, Wi = T - (-67108864 & fi) | 0, o[M + 104 >> 2] = Wi, ye = Zr(Br, Br >> 31, 121666, 0), Ne = Qe, T = Zr(Mr, Mr >> 31, 121666, 0), E = Qe, io = ye, to = T, ye = (33554431 & (E = (Jr = T + 16777216 | 0) >>> 0 < 16777216 ? E + 1 | 0 : E)) << 7 | Jr >>> 25, E = (E >> 25) + Ne | 0, E = (T = io + ye | 0) >>> 0 < ye >>> 0 ? E + 1 | 0 : E, Ne = (li = T + 33554432 | 0) >>> 0 < 33554432 ? E + 1 | 0 : E, ti = T - (-67108864 & li) | 0, o[M + 112 >> 2] = ti, ye = Zr(jr, jr >> 31, 121666, 0), ve = Qe, T = Zr(pr, pr >> 31, 121666, 0), E = Qe, io = ye, fo = T, ye = (33554431 & (E = (cr = T + 16777216 | 0) >>> 0 < 16777216 ? E + 1 | 0 : E)) << 7 | cr >>> 25, E = (E >> 25) + ve | 0, E = (T = io + ye | 0) >>> 0 < ye >>> 0 ? E + 1 | 0 : E, ye = (pr = T + 33554432 | 0) >>> 0 < 33554432 ? E + 1 | 0 : E, jr = T - (-67108864 & pr) | 0, o[M + 120 >> 2] = jr, ve = Zr(Tn, Tn >> 31, 121666, 0), Nr = Qe, T = Zr($n, $n >> 31, 121666, 0), E = Qe, Tn = T, T = (33554431 & (E = (Mr = T + 16777216 | 0) >>> 0 < 16777216 ? E + 1 | 0 : E)) << 7 | Mr >>> 25, E = (E >> 25) + Nr | 0, E = T >>> 0 > (ve = T + ve | 0) >>> 0 ? E + 1 | 0 : E, T = (Br = ve + 33554432 | 0) >>> 0 < 33554432 ? E + 1 | 0 : E, Nr = ve - (-67108864 & Br) | 0, o[M + 128 >> 2] = Nr, ve = (gr = to + ((67108863 & gr) << 6 | fi >>> 26) | 0) - (-33554432 & Jr) | 0, o[M + 108 >> 2] = ve, gr = (Ne = fo + ((67108863 & Ne) << 6 | li >>> 26) | 0) - (-33554432 & cr) | 0, o[M + 116 >> 2] = gr, Ne = (E = Tn + ((67108863 & ye) << 6 | pr >>> 26) | 0) - (-33554432 & Mr) | 0, o[M + 124 >> 2] = Ne, T = (T = as + ((67108863 & T) << 6 | Br >>> 26) | 0) - (-33554432 & Pr) | 0, o[M + 132 >> 2] = T, qi(E = M + 144 | 0, E), o[M + 84 >> 2] = T + ro, o[M + 80 >> 2] = Nr + Yi, o[M + 76 >> 2] = Ne + Xi, o[M + 72 >> 2] = jr + qo, o[M + 68 >> 2] = gr + Ln, o[M + 64 >> 2] = ti + qn, o[M + 60 >> 2] = ve + So, o[M + 56 >> 2] = Wi + go, o[M + 52 >> 2] = Mi + bo, o[M + 48 >> 2] = Tr + Vo, T = Fs - 1 | 0, Ti(Qo, M + 288 | 0, vn), Ti(vn, M, Zn), Fs; ) ;
                        jr = o[M + 144 >> 2], Tr = o[M + 240 >> 2], Mr = o[M + 148 >> 2], Mi = o[M + 244 >> 2], Br = o[M + 152 >> 2], fi = o[M + 248 >> 2], Nr = o[M + 156 >> 2], Wi = o[M + 252 >> 2], ve = o[M + 160 >> 2], Jr = o[M + 256 >> 2], gr = o[M + 164 >> 2], li = o[M + 260 >> 2], Ne = o[M + 168 >> 2], ti = o[M + 264 >> 2], ye = o[M + 172 >> 2], cr = o[M + 268 >> 2], T = o[M + 176 >> 2], pr = o[M + 272 >> 2], Pr = 0 - cs | 0, E = o[M + 276 >> 2], o[M + 276 >> 2] = Pr & (E ^ o[M + 180 >> 2]) ^ E, o[M + 272 >> 2] = pr ^ Pr & (T ^ pr), o[M + 268 >> 2] = cr ^ Pr & (ye ^ cr), o[M + 264 >> 2] = ti ^ Pr & (Ne ^ ti), o[M + 260 >> 2] = li ^ Pr & (gr ^ li), o[M + 256 >> 2] = Jr ^ Pr & (ve ^ Jr), o[M + 252 >> 2] = Wi ^ Pr & (Nr ^ Wi), o[M + 248 >> 2] = fi ^ Pr & (Br ^ fi), o[M + 244 >> 2] = Mi ^ Pr & (Mr ^ Mi), o[M + 240 >> 2] = Tr ^ Pr & (jr ^ Tr), Tr = o[M + 192 >> 2], jr = o[M + 96 >> 2], Mi = o[M + 196 >> 2], Mr = o[M + 100 >> 2], fi = o[M + 200 >> 2], Br = o[M + 104 >> 2], Wi = o[M + 204 >> 2], Nr = o[M + 108 >> 2], Jr = o[M + 208 >> 2], ve = o[M + 112 >> 2], li = o[M + 212 >> 2], gr = o[M + 116 >> 2], ti = o[M + 216 >> 2], Ne = o[M + 120 >> 2], cr = o[M + 220 >> 2], ye = o[M + 124 >> 2], pr = o[M + 224 >> 2], T = o[M + 128 >> 2], E = o[M + 228 >> 2], o[M + 228 >> 2] = Pr & (E ^ o[M + 132 >> 2]) ^ E, o[M + 224 >> 2] = pr ^ Pr & (T ^ pr), o[M + 220 >> 2] = cr ^ Pr & (ye ^ cr), o[M + 216 >> 2] = ti ^ Pr & (Ne ^ ti), o[M + 212 >> 2] = li ^ Pr & (gr ^ li), o[M + 208 >> 2] = Jr ^ Pr & (ve ^ Jr), o[M + 204 >> 2] = Wi ^ Pr & (Nr ^ Wi), o[M + 200 >> 2] = fi ^ Pr & (Br ^ fi), o[M + 196 >> 2] = Mi ^ Pr & (Mr ^ Mi), o[M + 192 >> 2] = Tr ^ Pr & (jr ^ Tr), ia(vn, vn), Ti(Ni, Ni, vn), i2(k, Ni), _s(Qs, 32), ye = 0;
                      }
                      return dr = M + 368 | 0, 0 | ye;
                    }, function(k, E) {
                      var T, M, ye, Ne, pr, ve, cr, gr, Pr, Nr, Br, Mr, jr, ti, fi, Jr, li, Tr, Mi, Wi;
                      return E |= 0, dr = T = dr - 304 | 0, B[0 | (k |= 0)] = m[0 | E], B[k + 1 | 0] = m[E + 1 | 0], B[k + 2 | 0] = m[E + 2 | 0], B[k + 3 | 0] = m[E + 3 | 0], B[k + 4 | 0] = m[E + 4 | 0], B[k + 5 | 0] = m[E + 5 | 0], B[k + 6 | 0] = m[E + 6 | 0], B[k + 7 | 0] = m[E + 7 | 0], B[k + 8 | 0] = m[E + 8 | 0], B[k + 9 | 0] = m[E + 9 | 0], B[k + 10 | 0] = m[E + 10 | 0], B[k + 11 | 0] = m[E + 11 | 0], B[k + 12 | 0] = m[E + 12 | 0], B[k + 13 | 0] = m[E + 13 | 0], B[k + 14 | 0] = m[E + 14 | 0], B[k + 15 | 0] = m[E + 15 | 0], B[k + 16 | 0] = m[E + 16 | 0], B[k + 17 | 0] = m[E + 17 | 0], B[k + 18 | 0] = m[E + 18 | 0], B[k + 19 | 0] = m[E + 19 | 0], B[k + 20 | 0] = m[E + 20 | 0], B[k + 21 | 0] = m[E + 21 | 0], B[k + 22 | 0] = m[E + 22 | 0], B[k + 23 | 0] = m[E + 23 | 0], B[k + 24 | 0] = m[E + 24 | 0], B[k + 25 | 0] = m[E + 25 | 0], B[k + 26 | 0] = m[E + 26 | 0], B[k + 27 | 0] = m[E + 27 | 0], B[k + 28 | 0] = m[E + 28 | 0], B[k + 29 | 0] = m[E + 29 | 0], B[k + 30 | 0] = m[E + 30 | 0], E = m[E + 31 | 0], B[0 | k] = 248 & m[0 | k], B[k + 31 | 0] = 63 & E | 64, e(T + 48 | 0, k), E = o[T + 128 >> 2], M = o[T + 88 >> 2], ye = o[T + 132 >> 2], Ne = o[T + 92 >> 2], pr = o[T + 136 >> 2], ve = o[T + 96 >> 2], cr = o[T + 140 >> 2], gr = o[T + 100 >> 2], Pr = o[T + 144 >> 2], Nr = o[T + 104 >> 2], Br = o[T + 148 >> 2], Mr = o[T + 108 >> 2], jr = o[T + 152 >> 2], ti = o[T + 112 >> 2], fi = o[T + 156 >> 2], Jr = o[T + 116 >> 2], li = o[T + 160 >> 2], Tr = o[T + 120 >> 2], Mi = o[T + 124 >> 2], Wi = o[T + 164 >> 2], o[T + 292 >> 2] = Mi + Wi, o[T + 288 >> 2] = li + Tr, o[T + 284 >> 2] = fi + Jr, o[T + 280 >> 2] = jr + ti, o[T + 276 >> 2] = Br + Mr, o[T + 272 >> 2] = Pr + Nr, o[T + 268 >> 2] = cr + gr, o[T + 264 >> 2] = pr + ve, o[T + 260 >> 2] = ye + Ne, o[T + 256 >> 2] = E + M, o[T + 244 >> 2] = Wi - Mi, o[T + 240 >> 2] = li - Tr, o[T + 236 >> 2] = fi - Jr, o[T + 232 >> 2] = jr - ti, o[T + 228 >> 2] = Br - Mr, o[T + 224 >> 2] = Pr - Nr, o[T + 220 >> 2] = cr - gr, o[T + 216 >> 2] = pr - ve, o[T + 212 >> 2] = ye - Ne, o[T + 208 >> 2] = E - M, ia(E = T + 208 | 0, E), Ti(T, T + 256 | 0, E), i2(k, T), dr = T + 304 | 0, 0;
                    }, function(k, E, T, M, ye) {
                      k |= 0, M |= 0, ye |= 0;
                      var Ne, pr = 0, ve = 0, cr = 0, gr = 0;
                      if (dr = Ne = dr - 112 | 0, (E |= 0) | (T |= 0)) {
                        pr = m[ye + 28 | 0] | m[ye + 29 | 0] << 8 | m[ye + 30 | 0] << 16 | m[ye + 31 | 0] << 24, o[Ne + 24 >> 2] = m[ye + 24 | 0] | m[ye + 25 | 0] << 8 | m[ye + 26 | 0] << 16 | m[ye + 27 | 0] << 24, o[Ne + 28 >> 2] = pr, pr = m[ye + 20 | 0] | m[ye + 21 | 0] << 8 | m[ye + 22 | 0] << 16 | m[ye + 23 | 0] << 24, o[Ne + 16 >> 2] = m[ye + 16 | 0] | m[ye + 17 | 0] << 8 | m[ye + 18 | 0] << 16 | m[ye + 19 | 0] << 24, o[Ne + 20 >> 2] = pr, pr = m[ye + 4 | 0] | m[ye + 5 | 0] << 8 | m[ye + 6 | 0] << 16 | m[ye + 7 | 0] << 24, o[Ne >> 2] = m[0 | ye] | m[ye + 1 | 0] << 8 | m[ye + 2 | 0] << 16 | m[ye + 3 | 0] << 24, o[Ne + 4 >> 2] = pr, pr = m[ye + 12 | 0] | m[ye + 13 | 0] << 8 | m[ye + 14 | 0] << 16 | m[ye + 15 | 0] << 24, o[Ne + 8 >> 2] = m[ye + 8 | 0] | m[ye + 9 | 0] << 8 | m[ye + 10 | 0] << 16 | m[ye + 11 | 0] << 24, o[Ne + 12 >> 2] = pr, ye = m[0 | M] | m[M + 1 | 0] << 8 | m[M + 2 | 0] << 16 | m[M + 3 | 0] << 24, M = m[M + 4 | 0] | m[M + 5 | 0] << 8 | m[M + 6 | 0] << 16 | m[M + 7 | 0] << 24, o[Ne + 104 >> 2] = 0, o[Ne + 108 >> 2] = 0, o[Ne + 96 >> 2] = ye, o[Ne + 100 >> 2] = M;
                        e: {
                          if (!T & E >>> 0 >= 64 | T) {
                            for (; Tu(k, Ne + 96 | 0, Ne, 0), M = m[Ne + 104 | 0] + 1 | 0, B[Ne + 104 | 0] = M, M = m[Ne + 105 | 0] + (M >>> 8 | 0) | 0, B[Ne + 105 | 0] = M, M = m[Ne + 106 | 0] + (M >>> 8 | 0) | 0, B[Ne + 106 | 0] = M, M = m[Ne + 107 | 0] + (M >>> 8 | 0) | 0, B[Ne + 107 | 0] = M, M = m[Ne + 108 | 0] + (M >>> 8 | 0) | 0, B[Ne + 108 | 0] = M, M = m[Ne + 109 | 0] + (M >>> 8 | 0) | 0, B[Ne + 109 | 0] = M, M = m[Ne + 110 | 0] + (M >>> 8 | 0) | 0, B[Ne + 110 | 0] = M, B[Ne + 111 | 0] = m[Ne + 111 | 0] + (M >>> 8 | 0), k = k - -64 | 0, T = T - 1 | 0, !(T = (E = E + -64 | 0) >>> 0 < 4294967232 ? T + 1 | 0 : T) & E >>> 0 > 63 | T; ) ;
                            if (!(E | T)) break e;
                          }
                          if (M = 0, Tu(Ne + 32 | 0, Ne + 96 | 0, Ne, 0), pr = 3 & E, ye = 0, !T & E >>> 0 >= 4 | T) for (T = 60 & E, E = 0; ve = cr = Ne + 32 | 0, B[k + ye | 0] = m[ve + ye | 0], B[(gr = 1 | ye) + k | 0] = m[ve + gr | 0], B[(ve = 2 | ye) + k | 0] = m[ve + cr | 0], B[(ve = 3 | ye) + k | 0] = m[ve + (Ne + 32 | 0) | 0], ye = ye + 4 | 0, (0 | T) != (0 | (E = E + 4 | 0)); ) ;
                          if (pr) for (; B[k + ye | 0] = m[(Ne + 32 | 0) + ye | 0], ye = ye + 1 | 0, (0 | pr) != (0 | (M = M + 1 | 0)); ) ;
                        }
                        _s(Ne + 32 | 0, 64), _s(Ne, 32);
                      }
                      return dr = Ne + 112 | 0, 0;
                    }, function(k, E, T, M, ye, Ne, pr, ve) {
                      k |= 0, E |= 0, ye |= 0, Ne |= 0, pr |= 0, ve |= 0;
                      var cr, gr = 0;
                      if (dr = cr = dr - 112 | 0, (T |= 0) | (M |= 0)) {
                        gr = m[ve + 28 | 0] | m[ve + 29 | 0] << 8 | m[ve + 30 | 0] << 16 | m[ve + 31 | 0] << 24, o[cr + 24 >> 2] = m[ve + 24 | 0] | m[ve + 25 | 0] << 8 | m[ve + 26 | 0] << 16 | m[ve + 27 | 0] << 24, o[cr + 28 >> 2] = gr, gr = m[ve + 20 | 0] | m[ve + 21 | 0] << 8 | m[ve + 22 | 0] << 16 | m[ve + 23 | 0] << 24, o[cr + 16 >> 2] = m[ve + 16 | 0] | m[ve + 17 | 0] << 8 | m[ve + 18 | 0] << 16 | m[ve + 19 | 0] << 24, o[cr + 20 >> 2] = gr, gr = m[ve + 4 | 0] | m[ve + 5 | 0] << 8 | m[ve + 6 | 0] << 16 | m[ve + 7 | 0] << 24, o[cr >> 2] = m[0 | ve] | m[ve + 1 | 0] << 8 | m[ve + 2 | 0] << 16 | m[ve + 3 | 0] << 24, o[cr + 4 >> 2] = gr, gr = m[ve + 12 | 0] | m[ve + 13 | 0] << 8 | m[ve + 14 | 0] << 16 | m[ve + 15 | 0] << 24, o[cr + 8 >> 2] = m[ve + 8 | 0] | m[ve + 9 | 0] << 8 | m[ve + 10 | 0] << 16 | m[ve + 11 | 0] << 24, o[cr + 12 >> 2] = gr, ve = m[ye + 4 | 0] | m[ye + 5 | 0] << 8 | m[ye + 6 | 0] << 16 | m[ye + 7 | 0] << 24, o[cr + 96 >> 2] = m[0 | ye] | m[ye + 1 | 0] << 8 | m[ye + 2 | 0] << 16 | m[ye + 3 | 0] << 24, o[cr + 100 >> 2] = ve, B[cr + 104 | 0] = Ne, B[cr + 111 | 0] = pr >>> 24, B[cr + 110 | 0] = pr >>> 16, B[cr + 109 | 0] = pr >>> 8, B[cr + 108 | 0] = pr, B[cr + 107 | 0] = (16777215 & pr) << 8 | Ne >>> 24, B[cr + 106 | 0] = (65535 & pr) << 16 | Ne >>> 16, B[cr + 105 | 0] = (255 & pr) << 24 | Ne >>> 8;
                        e: {
                          if (!M & T >>> 0 >= 64 | M) {
                            for (; ; ) {
                              for (ve = 0, Tu(cr + 32 | 0, cr + 96 | 0, cr, 0); Ne = cr + 32 | 0, B[k + ve | 0] = m[Ne + ve | 0] ^ m[E + ve | 0], B[(ye = 1 | ve) + k | 0] = m[ye + Ne | 0] ^ m[E + ye | 0], (0 | (ve = ve + 2 | 0)) != 64; ) ;
                              if (ye = m[cr + 104 | 0] + 1 | 0, B[cr + 104 | 0] = ye, ye = m[cr + 105 | 0] + (ye >>> 8 | 0) | 0, B[cr + 105 | 0] = ye, ye = m[cr + 106 | 0] + (ye >>> 8 | 0) | 0, B[cr + 106 | 0] = ye, ye = m[cr + 107 | 0] + (ye >>> 8 | 0) | 0, B[cr + 107 | 0] = ye, ye = m[cr + 108 | 0] + (ye >>> 8 | 0) | 0, B[cr + 108 | 0] = ye, ye = m[cr + 109 | 0] + (ye >>> 8 | 0) | 0, B[cr + 109 | 0] = ye, ye = m[cr + 110 | 0] + (ye >>> 8 | 0) | 0, B[cr + 110 | 0] = ye, B[cr + 111 | 0] = m[cr + 111 | 0] + (ye >>> 8 | 0), E = E - -64 | 0, k = k - -64 | 0, M = M - 1 | 0, !(!(M = (T = T + -64 | 0) >>> 0 < 4294967232 ? M + 1 | 0 : M) & T >>> 0 > 63 | M)) break;
                            }
                            if (!(T | M)) break e;
                          }
                          if (ve = 0, Tu(cr + 32 | 0, cr + 96 | 0, cr, 0), Ne = 1 & T, (0 | T) != 1 | M) for (M = 62 & T, ye = 0; pr = cr + 32 | 0, B[k + ve | 0] = m[pr + ve | 0] ^ m[E + ve | 0], B[(T = 1 | ve) + k | 0] = m[T + pr | 0] ^ m[E + T | 0], ve = ve + 2 | 0, (0 | M) != (0 | (ye = ye + 2 | 0)); ) ;
                          Ne && (B[k + ve | 0] = m[(cr + 32 | 0) + ve | 0] ^ m[E + ve | 0]);
                        }
                        _s(cr + 32 | 0, 64), _s(cr, 32);
                      }
                      return dr = cr + 112 | 0, 0;
                    }, function(k, E, T, M, ye, Ne, pr, ve, cr) {
                      k |= 0, E |= 0, T |= 0, M |= 0, ye |= 0, Ne |= 0, pr |= 0;
                      var gr, Pr, Nr = 0;
                      if (Pr = Nr = dr, dr = gr = Nr - 192 & -32, Ho(cr |= 0, ve |= 0, gr - -64 | 0), cr = 0, pr >>> 0 <= 63) ve = 0;
                      else for (Nr = 64; Sn(Ne + cr | 0, gr - -64 | 0), cr = ve = Nr, (Nr = ve - -64 | 0) >>> 0 <= pr >>> 0; ) ;
                      if ((Nr = 32 | ve) >>> 0 > pr >>> 0) cr = ve;
                      else for (; _o(Ne + ve | 0, gr - -64 | 0), cr = Nr, (Nr = (ve = Nr) + 32 | 0) >>> 0 <= pr >>> 0; ) ;
                      if ((ve = 31 & pr) && (Ca((Nr = gr + 32 | 0) | ve, 0, 32 - ve | 0), fa(Nr, Ne + cr | 0, ve), _o(Nr, gr - -64 | 0)), cr = 32, ve = 0, ye >>> 0 < 32) Ne = 0;
                      else for (; uo(k + ve | 0, M + ve | 0, gr - -64 | 0), Ne = cr, (cr = (ve = cr) + 32 | 0) >>> 0 <= ye >>> 0; ) ;
                      return (ve = 31 & ye) && (Ca((cr = gr + 32 | 0) | ve, 0, 32 - ve | 0), fa(cr, M + Ne | 0, ve), uo(gr, cr, gr - -64 | 0), fa(k + Ne | 0, gr, ve)), Kn(E, T, pr, ye, gr - -64 | 0), dr = Pr, 0;
                    }, function(k, E, T, M, ye, Ne, pr, ve, cr) {
                      k |= 0, E |= 0, T |= 0, M |= 0, ye |= 0, Ne |= 0, pr |= 0;
                      var gr, Pr, Nr = 0;
                      if (Pr = Nr = dr, dr = gr = Nr - 224 & -32, Ho(cr |= 0, ve |= 0, gr + 96 | 0), cr = 0, pr >>> 0 <= 63) ve = 0;
                      else for (Nr = 64; Sn(Ne + cr | 0, gr + 96 | 0), cr = ve = Nr, (Nr = ve - -64 | 0) >>> 0 <= pr >>> 0; ) ;
                      if ((Nr = 32 | ve) >>> 0 > pr >>> 0) cr = ve;
                      else for (; _o(Ne + ve | 0, gr + 96 | 0), cr = Nr, (Nr = (ve = Nr) + 32 | 0) >>> 0 <= pr >>> 0; ) ;
                      (ve = 31 & pr) && (Ca((Nr = gr - -64 | 0) | ve, 0, 32 - ve | 0), fa(Nr, Ne + cr | 0, ve), _o(Nr, gr + 96 | 0));
                      e: {
                        t: {
                          r: {
                            i: {
                              n: {
                                if (k) {
                                  if (cr = 32, T >>> 0 < 32) break n;
                                  for (Ne = 0; Xn(k + Ne | 0, E + Ne | 0, gr + 96 | 0), Ne = ve = cr, (cr = ve + 32 | 0) >>> 0 <= T >>> 0; ) ;
                                } else {
                                  if (Ne = 32, T >>> 0 < 32) break r;
                                  for (cr = 0; Xn(gr + 32 | 0, E + cr | 0, gr + 96 | 0), cr = ve = Ne, (Ne = ve + 32 | 0) >>> 0 <= T >>> 0; ) ;
                                }
                                if (!(Ne = 31 & T)) break e;
                                if (k) break i;
                                break t;
                              }
                              if (ve = 0, Ne = T, !T) break e;
                            }
                            xo(k + ve | 0, E + ve | 0, Ne, gr + 96 | 0);
                            break e;
                          }
                          if (ve = 0, Ne = T, !T) break e;
                        }
                        xo(gr + 32 | 0, E + ve | 0, Ne, gr + 96 | 0);
                      }
                      Kn(gr, ye, pr, T, gr + 96 | 0), ve = -1;
                      e: {
                        t: {
                          if (E = ye - 16 | 0) {
                            if ((0 | E) == 16) break t;
                            break e;
                          }
                          ve = pc(gr, M);
                          break e;
                        }
                        ve = tu(gr, M);
                      }
                      return !k | !ve || Ca(k, 0, T), dr = Pr, 0 | ve;
                    }, function(k, E, T, M, ye, Ne, pr, ve, cr) {
                      k |= 0, E |= 0, T |= 0, M |= 0, ye |= 0, Ne |= 0, pr |= 0;
                      var gr, Pr = 0, Nr = 0, Br = 0, Mr = 0, jr = 0, ti = 0, fi = 0, Jr = 0, li = 0, Tr = 0;
                      if (dr = gr = dr - 528 | 0, $i(cr |= 0, ve |= 0, gr + 400 | 0), cr = 0, pr >>> 0 <= 31) ve = 0;
                      else for (Nr = 32; Oo(Ne + cr | 0, gr + 400 | 0), cr = ve = Nr, (Nr = ve + 32 | 0) >>> 0 <= pr >>> 0; ) ;
                      if ((cr = 16 | ve) >>> 0 <= pr >>> 0) for (Nr = gr + 416 | 0, Mr = gr + 432 | 0, jr = gr + 448 | 0, Br = gr + 464 | 0, ti = gr + 480 | 0; fi = m[0 | (ve = Ne + ve | 0)] | m[ve + 1 | 0] << 8 | m[ve + 2 | 0] << 16 | m[ve + 3 | 0] << 24, Jr = m[ve + 4 | 0] | m[ve + 5 | 0] << 8 | m[ve + 6 | 0] << 16 | m[ve + 7 | 0] << 24, li = m[ve + 8 | 0] | m[ve + 9 | 0] << 8 | m[ve + 10 | 0] << 16 | m[ve + 11 | 0] << 24, Tr = m[ve + 12 | 0] | m[ve + 13 | 0] << 8 | m[ve + 14 | 0] << 16 | m[ve + 15 | 0] << 24, ve = o[ti + 12 >> 2], o[gr + 520 >> 2] = o[ti + 8 >> 2], o[gr + 524 >> 2] = ve, ve = o[ti + 4 >> 2], o[gr + 512 >> 2] = o[ti >> 2], o[gr + 516 >> 2] = ve, ve = o[Br + 12 >> 2], o[gr + 376 >> 2] = o[Br + 8 >> 2], o[gr + 380 >> 2] = ve, ve = o[Br + 4 >> 2], o[gr + 368 >> 2] = o[Br >> 2], o[gr + 372 >> 2] = ve, ve = o[ti + 12 >> 2], o[gr + 360 >> 2] = o[ti + 8 >> 2], o[gr + 364 >> 2] = ve, ve = o[ti + 4 >> 2], o[gr + 352 >> 2] = o[ti >> 2], o[gr + 356 >> 2] = ve, gs(ve = gr + 496 | 0, gr + 368 | 0, gr + 352 | 0), Pr = o[gr + 508 >> 2], o[ti + 8 >> 2] = o[gr + 504 >> 2], o[ti + 12 >> 2] = Pr, Pr = o[gr + 500 >> 2], o[ti >> 2] = o[gr + 496 >> 2], o[ti + 4 >> 2] = Pr, Pr = o[jr + 12 >> 2], o[gr + 344 >> 2] = o[jr + 8 >> 2], o[gr + 348 >> 2] = Pr, Pr = o[jr + 4 >> 2], o[gr + 336 >> 2] = o[jr >> 2], o[gr + 340 >> 2] = Pr, Pr = o[Br + 12 >> 2], o[gr + 328 >> 2] = o[Br + 8 >> 2], o[gr + 332 >> 2] = Pr, Pr = o[Br + 4 >> 2], o[gr + 320 >> 2] = o[Br >> 2], o[gr + 324 >> 2] = Pr, gs(ve, gr + 336 | 0, gr + 320 | 0), Pr = o[gr + 508 >> 2], o[Br + 8 >> 2] = o[gr + 504 >> 2], o[Br + 12 >> 2] = Pr, Pr = o[gr + 500 >> 2], o[Br >> 2] = o[gr + 496 >> 2], o[Br + 4 >> 2] = Pr, Pr = o[Mr + 12 >> 2], o[gr + 312 >> 2] = o[Mr + 8 >> 2], o[gr + 316 >> 2] = Pr, Pr = o[Mr + 4 >> 2], o[gr + 304 >> 2] = o[Mr >> 2], o[gr + 308 >> 2] = Pr, Pr = o[jr + 12 >> 2], o[gr + 296 >> 2] = o[jr + 8 >> 2], o[gr + 300 >> 2] = Pr, Pr = o[jr + 4 >> 2], o[gr + 288 >> 2] = o[jr >> 2], o[gr + 292 >> 2] = Pr, gs(ve, gr + 304 | 0, gr + 288 | 0), Pr = o[gr + 508 >> 2], o[jr + 8 >> 2] = o[gr + 504 >> 2], o[jr + 12 >> 2] = Pr, Pr = o[gr + 500 >> 2], o[jr >> 2] = o[gr + 496 >> 2], o[jr + 4 >> 2] = Pr, Pr = o[Nr + 12 >> 2], o[gr + 280 >> 2] = o[Nr + 8 >> 2], o[gr + 284 >> 2] = Pr, Pr = o[Nr + 4 >> 2], o[gr + 272 >> 2] = o[Nr >> 2], o[gr + 276 >> 2] = Pr, Pr = o[Mr + 12 >> 2], o[gr + 264 >> 2] = o[Mr + 8 >> 2], o[gr + 268 >> 2] = Pr, Pr = o[Mr + 4 >> 2], o[gr + 256 >> 2] = o[Mr >> 2], o[gr + 260 >> 2] = Pr, gs(ve, gr + 272 | 0, gr + 256 | 0), Pr = o[gr + 508 >> 2], o[Mr + 8 >> 2] = o[gr + 504 >> 2], o[Mr + 12 >> 2] = Pr, Pr = o[gr + 500 >> 2], o[Mr >> 2] = o[gr + 496 >> 2], o[Mr + 4 >> 2] = Pr, Pr = o[gr + 412 >> 2], o[gr + 248 >> 2] = o[gr + 408 >> 2], o[gr + 252 >> 2] = Pr, Pr = o[gr + 404 >> 2], o[gr + 240 >> 2] = o[gr + 400 >> 2], o[gr + 244 >> 2] = Pr, Pr = o[Nr + 12 >> 2], o[gr + 232 >> 2] = o[Nr + 8 >> 2], o[gr + 236 >> 2] = Pr, Pr = o[Nr + 4 >> 2], o[gr + 224 >> 2] = o[Nr >> 2], o[gr + 228 >> 2] = Pr, gs(ve, gr + 240 | 0, gr + 224 | 0), Pr = o[gr + 508 >> 2], o[Nr + 8 >> 2] = o[gr + 504 >> 2], o[Nr + 12 >> 2] = Pr, Pr = o[gr + 500 >> 2], o[Nr >> 2] = o[gr + 496 >> 2], o[Nr + 4 >> 2] = Pr, Pr = o[gr + 524 >> 2], o[gr + 216 >> 2] = o[gr + 520 >> 2], o[gr + 220 >> 2] = Pr, Pr = o[gr + 412 >> 2], o[gr + 200 >> 2] = o[gr + 408 >> 2], o[gr + 204 >> 2] = Pr, Pr = o[gr + 516 >> 2], o[gr + 208 >> 2] = o[gr + 512 >> 2], o[gr + 212 >> 2] = Pr, Pr = o[gr + 404 >> 2], o[gr + 192 >> 2] = o[gr + 400 >> 2], o[gr + 196 >> 2] = Pr, gs(ve, gr + 208 | 0, gr + 192 | 0), o[gr + 412 >> 2] = Tr ^ o[gr + 508 >> 2], o[gr + 408 >> 2] = o[gr + 504 >> 2] ^ li, o[gr + 404 >> 2] = o[gr + 500 >> 2] ^ Jr, o[gr + 400 >> 2] = o[gr + 496 >> 2] ^ fi, (cr = (ve = cr) + 16 | 0) >>> 0 <= pr >>> 0; ) ;
                      if ((cr = 15 & pr) && (Ca((Nr = gr + 384 | 0) | cr, 0, 16 - cr | 0), fa(Nr, Ne + ve | 0, cr), cr = o[gr + 384 >> 2], Nr = o[gr + 388 >> 2], Mr = o[gr + 392 >> 2], jr = o[gr + 396 >> 2], ve = o[gr + 492 >> 2], Ne = o[gr + 488 >> 2], o[gr + 520 >> 2] = Ne, o[gr + 524 >> 2] = ve, Br = o[gr + 476 >> 2], o[gr + 184 >> 2] = o[gr + 472 >> 2], o[gr + 188 >> 2] = Br, o[gr + 168 >> 2] = Ne, o[gr + 172 >> 2] = ve, ve = o[gr + 484 >> 2], Ne = o[gr + 480 >> 2], o[gr + 512 >> 2] = Ne, o[gr + 516 >> 2] = ve, Br = o[gr + 468 >> 2], o[gr + 176 >> 2] = o[gr + 464 >> 2], o[gr + 180 >> 2] = Br, o[gr + 160 >> 2] = Ne, o[gr + 164 >> 2] = ve, gs(Ne = gr + 496 | 0, gr + 176 | 0, gr + 160 | 0), ve = o[gr + 508 >> 2], o[gr + 488 >> 2] = o[gr + 504 >> 2], o[gr + 492 >> 2] = ve, ve = o[gr + 460 >> 2], o[gr + 152 >> 2] = o[gr + 456 >> 2], o[gr + 156 >> 2] = ve, ve = o[gr + 476 >> 2], o[gr + 136 >> 2] = o[gr + 472 >> 2], o[gr + 140 >> 2] = ve, ve = o[gr + 500 >> 2], o[gr + 480 >> 2] = o[gr + 496 >> 2], o[gr + 484 >> 2] = ve, ve = o[gr + 452 >> 2], o[gr + 144 >> 2] = o[gr + 448 >> 2], o[gr + 148 >> 2] = ve, ve = o[gr + 468 >> 2], o[gr + 128 >> 2] = o[gr + 464 >> 2], o[gr + 132 >> 2] = ve, gs(Ne, gr + 144 | 0, gr + 128 | 0), ve = o[gr + 508 >> 2], o[gr + 472 >> 2] = o[gr + 504 >> 2], o[gr + 476 >> 2] = ve, ve = o[gr + 444 >> 2], o[gr + 120 >> 2] = o[gr + 440 >> 2], o[gr + 124 >> 2] = ve, ve = o[gr + 460 >> 2], o[gr + 104 >> 2] = o[gr + 456 >> 2], o[gr + 108 >> 2] = ve, ve = o[gr + 500 >> 2], o[gr + 464 >> 2] = o[gr + 496 >> 2], o[gr + 468 >> 2] = ve, ve = o[gr + 436 >> 2], o[gr + 112 >> 2] = o[gr + 432 >> 2], o[gr + 116 >> 2] = ve, ve = o[gr + 452 >> 2], o[gr + 96 >> 2] = o[gr + 448 >> 2], o[gr + 100 >> 2] = ve, gs(Ne, gr + 112 | 0, gr + 96 | 0), ve = o[gr + 508 >> 2], o[gr + 456 >> 2] = o[gr + 504 >> 2], o[gr + 460 >> 2] = ve, ve = o[gr + 428 >> 2], o[gr + 88 >> 2] = o[gr + 424 >> 2], o[gr + 92 >> 2] = ve, ve = o[gr + 444 >> 2], o[gr + 72 >> 2] = o[gr + 440 >> 2], o[gr + 76 >> 2] = ve, ve = o[gr + 500 >> 2], o[gr + 448 >> 2] = o[gr + 496 >> 2], o[gr + 452 >> 2] = ve, ve = o[gr + 420 >> 2], o[gr + 80 >> 2] = o[gr + 416 >> 2], o[gr + 84 >> 2] = ve, ve = o[gr + 436 >> 2], o[gr + 64 >> 2] = o[gr + 432 >> 2], o[gr + 68 >> 2] = ve, gs(Ne, gr + 80 | 0, gr - -64 | 0), ve = o[gr + 508 >> 2], o[gr + 440 >> 2] = o[gr + 504 >> 2], o[gr + 444 >> 2] = ve, ve = o[gr + 412 >> 2], o[gr + 56 >> 2] = o[gr + 408 >> 2], o[gr + 60 >> 2] = ve, ve = o[gr + 428 >> 2], o[gr + 40 >> 2] = o[gr + 424 >> 2], o[gr + 44 >> 2] = ve, ve = o[gr + 500 >> 2], o[gr + 432 >> 2] = o[gr + 496 >> 2], o[gr + 436 >> 2] = ve, ve = o[gr + 404 >> 2], o[gr + 48 >> 2] = o[gr + 400 >> 2], o[gr + 52 >> 2] = ve, ve = o[gr + 420 >> 2], o[gr + 32 >> 2] = o[gr + 416 >> 2], o[gr + 36 >> 2] = ve, gs(Ne, gr + 48 | 0, gr + 32 | 0), ve = o[gr + 508 >> 2], o[gr + 424 >> 2] = o[gr + 504 >> 2], o[gr + 428 >> 2] = ve, ve = o[gr + 524 >> 2], o[gr + 24 >> 2] = o[gr + 520 >> 2], o[gr + 28 >> 2] = ve, ve = o[gr + 412 >> 2], o[gr + 8 >> 2] = o[gr + 408 >> 2], o[gr + 12 >> 2] = ve, ve = o[gr + 500 >> 2], o[gr + 416 >> 2] = o[gr + 496 >> 2], o[gr + 420 >> 2] = ve, ve = o[gr + 516 >> 2], o[gr + 16 >> 2] = o[gr + 512 >> 2], o[gr + 20 >> 2] = ve, ve = o[gr + 404 >> 2], o[gr >> 2] = o[gr + 400 >> 2], o[gr + 4 >> 2] = ve, gs(Ne, gr + 16 | 0, gr), o[gr + 412 >> 2] = jr ^ o[gr + 508 >> 2], o[gr + 408 >> 2] = Mr ^ o[gr + 504 >> 2], o[gr + 404 >> 2] = Nr ^ o[gr + 500 >> 2], o[gr + 400 >> 2] = cr ^ o[gr + 496 >> 2]), Nr = 16, ve = 0, ye >>> 0 < 16) cr = 0;
                      else for (; Ts(k + ve | 0, M + ve | 0, gr + 400 | 0), cr = Nr, (Nr = (ve = Nr) + 16 | 0) >>> 0 <= ye >>> 0; ) ;
                      return (Ne = 15 & ye) && (Ca((ve = gr + 384 | 0) | Ne, 0, 16 - Ne | 0), fa(ve, M + cr | 0, Ne), Ts(M = gr + 512 | 0, ve, gr + 400 | 0), fa(k + cr | 0, M, Ne)), yo(E, T, pr, ye, gr + 400 | 0), dr = gr + 528 | 0, 0;
                    }, function(k, E, T, M, ye, Ne, pr, ve, cr) {
                      k |= 0, E |= 0, T |= 0, M |= 0, ye |= 0, Ne |= 0, pr |= 0;
                      var gr, Pr = 0, Nr = 0, Br = 0, Mr = 0, jr = 0, ti = 0, fi = 0, Jr = 0, li = 0, Tr = 0;
                      if (dr = gr = dr - 544 | 0, $i(cr |= 0, ve |= 0, gr + 432 | 0), cr = 0, pr >>> 0 <= 31) ve = 0;
                      else for (Nr = 32; Oo(Ne + cr | 0, gr + 432 | 0), cr = ve = Nr, (Nr = ve + 32 | 0) >>> 0 <= pr >>> 0; ) ;
                      if ((cr = 16 | ve) >>> 0 <= pr >>> 0) for (Nr = gr + 448 | 0, Mr = gr + 464 | 0, jr = gr + 480 | 0, Br = gr + 496 | 0, ti = gr + 512 | 0; fi = m[0 | (ve = Ne + ve | 0)] | m[ve + 1 | 0] << 8 | m[ve + 2 | 0] << 16 | m[ve + 3 | 0] << 24, Jr = m[ve + 4 | 0] | m[ve + 5 | 0] << 8 | m[ve + 6 | 0] << 16 | m[ve + 7 | 0] << 24, li = m[ve + 8 | 0] | m[ve + 9 | 0] << 8 | m[ve + 10 | 0] << 16 | m[ve + 11 | 0] << 24, Tr = m[ve + 12 | 0] | m[ve + 13 | 0] << 8 | m[ve + 14 | 0] << 16 | m[ve + 15 | 0] << 24, ve = o[ti + 12 >> 2], o[gr + 392 >> 2] = o[ti + 8 >> 2], o[gr + 396 >> 2] = ve, ve = o[ti + 4 >> 2], o[gr + 384 >> 2] = o[ti >> 2], o[gr + 388 >> 2] = ve, ve = o[Br + 12 >> 2], o[gr + 376 >> 2] = o[Br + 8 >> 2], o[gr + 380 >> 2] = ve, ve = o[Br + 4 >> 2], o[gr + 368 >> 2] = o[Br >> 2], o[gr + 372 >> 2] = ve, ve = o[ti + 12 >> 2], o[gr + 360 >> 2] = o[ti + 8 >> 2], o[gr + 364 >> 2] = ve, ve = o[ti + 4 >> 2], o[gr + 352 >> 2] = o[ti >> 2], o[gr + 356 >> 2] = ve, gs(ve = gr + 528 | 0, gr + 368 | 0, gr + 352 | 0), Pr = o[gr + 540 >> 2], o[ti + 8 >> 2] = o[gr + 536 >> 2], o[ti + 12 >> 2] = Pr, Pr = o[gr + 532 >> 2], o[ti >> 2] = o[gr + 528 >> 2], o[ti + 4 >> 2] = Pr, Pr = o[jr + 12 >> 2], o[gr + 344 >> 2] = o[jr + 8 >> 2], o[gr + 348 >> 2] = Pr, Pr = o[jr + 4 >> 2], o[gr + 336 >> 2] = o[jr >> 2], o[gr + 340 >> 2] = Pr, Pr = o[Br + 12 >> 2], o[gr + 328 >> 2] = o[Br + 8 >> 2], o[gr + 332 >> 2] = Pr, Pr = o[Br + 4 >> 2], o[gr + 320 >> 2] = o[Br >> 2], o[gr + 324 >> 2] = Pr, gs(ve, gr + 336 | 0, gr + 320 | 0), Pr = o[gr + 540 >> 2], o[Br + 8 >> 2] = o[gr + 536 >> 2], o[Br + 12 >> 2] = Pr, Pr = o[gr + 532 >> 2], o[Br >> 2] = o[gr + 528 >> 2], o[Br + 4 >> 2] = Pr, Pr = o[Mr + 12 >> 2], o[gr + 312 >> 2] = o[Mr + 8 >> 2], o[gr + 316 >> 2] = Pr, Pr = o[Mr + 4 >> 2], o[gr + 304 >> 2] = o[Mr >> 2], o[gr + 308 >> 2] = Pr, Pr = o[jr + 12 >> 2], o[gr + 296 >> 2] = o[jr + 8 >> 2], o[gr + 300 >> 2] = Pr, Pr = o[jr + 4 >> 2], o[gr + 288 >> 2] = o[jr >> 2], o[gr + 292 >> 2] = Pr, gs(ve, gr + 304 | 0, gr + 288 | 0), Pr = o[gr + 540 >> 2], o[jr + 8 >> 2] = o[gr + 536 >> 2], o[jr + 12 >> 2] = Pr, Pr = o[gr + 532 >> 2], o[jr >> 2] = o[gr + 528 >> 2], o[jr + 4 >> 2] = Pr, Pr = o[Nr + 12 >> 2], o[gr + 280 >> 2] = o[Nr + 8 >> 2], o[gr + 284 >> 2] = Pr, Pr = o[Nr + 4 >> 2], o[gr + 272 >> 2] = o[Nr >> 2], o[gr + 276 >> 2] = Pr, Pr = o[Mr + 12 >> 2], o[gr + 264 >> 2] = o[Mr + 8 >> 2], o[gr + 268 >> 2] = Pr, Pr = o[Mr + 4 >> 2], o[gr + 256 >> 2] = o[Mr >> 2], o[gr + 260 >> 2] = Pr, gs(ve, gr + 272 | 0, gr + 256 | 0), Pr = o[gr + 540 >> 2], o[Mr + 8 >> 2] = o[gr + 536 >> 2], o[Mr + 12 >> 2] = Pr, Pr = o[gr + 532 >> 2], o[Mr >> 2] = o[gr + 528 >> 2], o[Mr + 4 >> 2] = Pr, Pr = o[gr + 444 >> 2], o[gr + 248 >> 2] = o[gr + 440 >> 2], o[gr + 252 >> 2] = Pr, Pr = o[gr + 436 >> 2], o[gr + 240 >> 2] = o[gr + 432 >> 2], o[gr + 244 >> 2] = Pr, Pr = o[Nr + 12 >> 2], o[gr + 232 >> 2] = o[Nr + 8 >> 2], o[gr + 236 >> 2] = Pr, Pr = o[Nr + 4 >> 2], o[gr + 224 >> 2] = o[Nr >> 2], o[gr + 228 >> 2] = Pr, gs(ve, gr + 240 | 0, gr + 224 | 0), Pr = o[gr + 540 >> 2], o[Nr + 8 >> 2] = o[gr + 536 >> 2], o[Nr + 12 >> 2] = Pr, Pr = o[gr + 532 >> 2], o[Nr >> 2] = o[gr + 528 >> 2], o[Nr + 4 >> 2] = Pr, Pr = o[gr + 396 >> 2], o[gr + 216 >> 2] = o[gr + 392 >> 2], o[gr + 220 >> 2] = Pr, Pr = o[gr + 444 >> 2], o[gr + 200 >> 2] = o[gr + 440 >> 2], o[gr + 204 >> 2] = Pr, Pr = o[gr + 388 >> 2], o[gr + 208 >> 2] = o[gr + 384 >> 2], o[gr + 212 >> 2] = Pr, Pr = o[gr + 436 >> 2], o[gr + 192 >> 2] = o[gr + 432 >> 2], o[gr + 196 >> 2] = Pr, gs(ve, gr + 208 | 0, gr + 192 | 0), o[gr + 444 >> 2] = Tr ^ o[gr + 540 >> 2], o[gr + 440 >> 2] = o[gr + 536 >> 2] ^ li, o[gr + 436 >> 2] = o[gr + 532 >> 2] ^ Jr, o[gr + 432 >> 2] = o[gr + 528 >> 2] ^ fi, (cr = (ve = cr) + 16 | 0) >>> 0 <= pr >>> 0; ) ;
                      (cr = 15 & pr) && (Ca((Nr = gr + 416 | 0) | cr, 0, 16 - cr | 0), fa(Nr, Ne + ve | 0, cr), cr = o[gr + 416 >> 2], Nr = o[gr + 420 >> 2], Mr = o[gr + 424 >> 2], jr = o[gr + 428 >> 2], ve = o[gr + 524 >> 2], Ne = o[gr + 520 >> 2], o[gr + 392 >> 2] = Ne, o[gr + 396 >> 2] = ve, Br = o[gr + 508 >> 2], o[gr + 184 >> 2] = o[gr + 504 >> 2], o[gr + 188 >> 2] = Br, o[gr + 168 >> 2] = Ne, o[gr + 172 >> 2] = ve, ve = o[gr + 516 >> 2], Ne = o[gr + 512 >> 2], o[gr + 384 >> 2] = Ne, o[gr + 388 >> 2] = ve, Br = o[gr + 500 >> 2], o[gr + 176 >> 2] = o[gr + 496 >> 2], o[gr + 180 >> 2] = Br, o[gr + 160 >> 2] = Ne, o[gr + 164 >> 2] = ve, gs(Ne = gr + 528 | 0, gr + 176 | 0, gr + 160 | 0), ve = o[gr + 540 >> 2], o[gr + 520 >> 2] = o[gr + 536 >> 2], o[gr + 524 >> 2] = ve, ve = o[gr + 492 >> 2], o[gr + 152 >> 2] = o[gr + 488 >> 2], o[gr + 156 >> 2] = ve, ve = o[gr + 508 >> 2], o[gr + 136 >> 2] = o[gr + 504 >> 2], o[gr + 140 >> 2] = ve, ve = o[gr + 532 >> 2], o[gr + 512 >> 2] = o[gr + 528 >> 2], o[gr + 516 >> 2] = ve, ve = o[gr + 484 >> 2], o[gr + 144 >> 2] = o[gr + 480 >> 2], o[gr + 148 >> 2] = ve, ve = o[gr + 500 >> 2], o[gr + 128 >> 2] = o[gr + 496 >> 2], o[gr + 132 >> 2] = ve, gs(Ne, gr + 144 | 0, gr + 128 | 0), ve = o[gr + 540 >> 2], o[gr + 504 >> 2] = o[gr + 536 >> 2], o[gr + 508 >> 2] = ve, ve = o[gr + 476 >> 2], o[gr + 120 >> 2] = o[gr + 472 >> 2], o[gr + 124 >> 2] = ve, ve = o[gr + 492 >> 2], o[gr + 104 >> 2] = o[gr + 488 >> 2], o[gr + 108 >> 2] = ve, ve = o[gr + 532 >> 2], o[gr + 496 >> 2] = o[gr + 528 >> 2], o[gr + 500 >> 2] = ve, ve = o[gr + 468 >> 2], o[gr + 112 >> 2] = o[gr + 464 >> 2], o[gr + 116 >> 2] = ve, ve = o[gr + 484 >> 2], o[gr + 96 >> 2] = o[gr + 480 >> 2], o[gr + 100 >> 2] = ve, gs(Ne, gr + 112 | 0, gr + 96 | 0), ve = o[gr + 540 >> 2], o[gr + 488 >> 2] = o[gr + 536 >> 2], o[gr + 492 >> 2] = ve, ve = o[gr + 460 >> 2], o[gr + 88 >> 2] = o[gr + 456 >> 2], o[gr + 92 >> 2] = ve, ve = o[gr + 476 >> 2], o[gr + 72 >> 2] = o[gr + 472 >> 2], o[gr + 76 >> 2] = ve, ve = o[gr + 532 >> 2], o[gr + 480 >> 2] = o[gr + 528 >> 2], o[gr + 484 >> 2] = ve, ve = o[gr + 452 >> 2], o[gr + 80 >> 2] = o[gr + 448 >> 2], o[gr + 84 >> 2] = ve, ve = o[gr + 468 >> 2], o[gr + 64 >> 2] = o[gr + 464 >> 2], o[gr + 68 >> 2] = ve, gs(Ne, gr + 80 | 0, gr - -64 | 0), ve = o[gr + 540 >> 2], o[gr + 472 >> 2] = o[gr + 536 >> 2], o[gr + 476 >> 2] = ve, ve = o[gr + 444 >> 2], o[gr + 56 >> 2] = o[gr + 440 >> 2], o[gr + 60 >> 2] = ve, ve = o[gr + 460 >> 2], o[gr + 40 >> 2] = o[gr + 456 >> 2], o[gr + 44 >> 2] = ve, ve = o[gr + 532 >> 2], o[gr + 464 >> 2] = o[gr + 528 >> 2], o[gr + 468 >> 2] = ve, ve = o[gr + 436 >> 2], o[gr + 48 >> 2] = o[gr + 432 >> 2], o[gr + 52 >> 2] = ve, ve = o[gr + 452 >> 2], o[gr + 32 >> 2] = o[gr + 448 >> 2], o[gr + 36 >> 2] = ve, gs(Ne, gr + 48 | 0, gr + 32 | 0), ve = o[gr + 540 >> 2], o[gr + 456 >> 2] = o[gr + 536 >> 2], o[gr + 460 >> 2] = ve, ve = o[gr + 396 >> 2], o[gr + 24 >> 2] = o[gr + 392 >> 2], o[gr + 28 >> 2] = ve, ve = o[gr + 444 >> 2], o[gr + 8 >> 2] = o[gr + 440 >> 2], o[gr + 12 >> 2] = ve, ve = o[gr + 532 >> 2], o[gr + 448 >> 2] = o[gr + 528 >> 2], o[gr + 452 >> 2] = ve, ve = o[gr + 388 >> 2], o[gr + 16 >> 2] = o[gr + 384 >> 2], o[gr + 20 >> 2] = ve, ve = o[gr + 436 >> 2], o[gr >> 2] = o[gr + 432 >> 2], o[gr + 4 >> 2] = ve, gs(Ne, gr + 16 | 0, gr), o[gr + 444 >> 2] = jr ^ o[gr + 540 >> 2], o[gr + 440 >> 2] = Mr ^ o[gr + 536 >> 2], o[gr + 436 >> 2] = Nr ^ o[gr + 532 >> 2], o[gr + 432 >> 2] = cr ^ o[gr + 528 >> 2]);
                      e: {
                        t: {
                          r: {
                            i: {
                              n: {
                                if (k) {
                                  if (Nr = 16, T >>> 0 < 16) break n;
                                  for (cr = 0; Ao(k + cr | 0, E + cr | 0, gr + 432 | 0), cr = ve = Nr, (Nr = ve + 16 | 0) >>> 0 <= T >>> 0; ) ;
                                } else {
                                  if (cr = 16, T >>> 0 < 16) break r;
                                  for (Nr = 0; Ao(gr + 528 | 0, E + Nr | 0, gr + 432 | 0), Nr = ve = cr, (cr = ve + 16 | 0) >>> 0 <= T >>> 0; ) ;
                                }
                                if (!(cr = 15 & T)) break e;
                                if (k) break i;
                                break t;
                              }
                              if (ve = 0, !(cr = T)) break e;
                            }
                            Uo(k + ve | 0, E + ve | 0, cr, gr + 432 | 0);
                            break e;
                          }
                          if (ve = 0, !(cr = T)) break e;
                        }
                        Uo(gr + 528 | 0, E + ve | 0, cr, gr + 432 | 0);
                      }
                      yo(gr + 384 | 0, ye, pr, T, gr + 432 | 0), ve = -1;
                      e: {
                        t: {
                          if (E = ye - 16 | 0) {
                            if ((0 | E) == 16) break t;
                            break e;
                          }
                          ve = pc(gr + 384 | 0, M);
                          break e;
                        }
                        ve = tu(gr + 384 | 0, M);
                      }
                      return !k | !ve || Ca(k, 0, T), dr = gr + 544 | 0, 0 | ve;
                    }, function(k, E, T, M, ye) {
                      var Ne;
                      return k |= 0, M |= 0, ye |= 0, dr = Ne = dr + -64 | 0, (E |= 0) | (T |= 0) && (o[Ne + 8 >> 2] = 2036477234, o[Ne + 12 >> 2] = 1797285236, o[Ne >> 2] = 1634760805, o[Ne + 4 >> 2] = 857760878, o[Ne + 16 >> 2] = m[0 | ye] | m[ye + 1 | 0] << 8 | m[ye + 2 | 0] << 16 | m[ye + 3 | 0] << 24, o[Ne + 20 >> 2] = m[ye + 4 | 0] | m[ye + 5 | 0] << 8 | m[ye + 6 | 0] << 16 | m[ye + 7 | 0] << 24, o[Ne + 24 >> 2] = m[ye + 8 | 0] | m[ye + 9 | 0] << 8 | m[ye + 10 | 0] << 16 | m[ye + 11 | 0] << 24, o[Ne + 28 >> 2] = m[ye + 12 | 0] | m[ye + 13 | 0] << 8 | m[ye + 14 | 0] << 16 | m[ye + 15 | 0] << 24, o[Ne + 32 >> 2] = m[ye + 16 | 0] | m[ye + 17 | 0] << 8 | m[ye + 18 | 0] << 16 | m[ye + 19 | 0] << 24, o[Ne + 36 >> 2] = m[ye + 20 | 0] | m[ye + 21 | 0] << 8 | m[ye + 22 | 0] << 16 | m[ye + 23 | 0] << 24, o[Ne + 40 >> 2] = m[ye + 24 | 0] | m[ye + 25 | 0] << 8 | m[ye + 26 | 0] << 16 | m[ye + 27 | 0] << 24, ye = m[ye + 28 | 0] | m[ye + 29 | 0] << 8 | m[ye + 30 | 0] << 16 | m[ye + 31 | 0] << 24, o[Ne + 48 >> 2] = 0, o[Ne + 52 >> 2] = 0, o[Ne + 44 >> 2] = ye, o[Ne + 56 >> 2] = m[0 | M] | m[M + 1 | 0] << 8 | m[M + 2 | 0] << 16 | m[M + 3 | 0] << 24, o[Ne + 60 >> 2] = m[M + 4 | 0] | m[M + 5 | 0] << 8 | m[M + 6 | 0] << 16 | m[M + 7 | 0] << 24, ns(Ne, k = Ca(k, 0, E), k, E, T), _s(Ne, 64)), dr = Ne - -64 | 0, 0;
                    }, function(k, E, T, M, ye) {
                      var Ne;
                      return k |= 0, M |= 0, ye |= 0, dr = Ne = dr + -64 | 0, (E |= 0) | (T |= 0) && (o[Ne + 8 >> 2] = 2036477234, o[Ne + 12 >> 2] = 1797285236, o[Ne >> 2] = 1634760805, o[Ne + 4 >> 2] = 857760878, o[Ne + 16 >> 2] = m[0 | ye] | m[ye + 1 | 0] << 8 | m[ye + 2 | 0] << 16 | m[ye + 3 | 0] << 24, o[Ne + 20 >> 2] = m[ye + 4 | 0] | m[ye + 5 | 0] << 8 | m[ye + 6 | 0] << 16 | m[ye + 7 | 0] << 24, o[Ne + 24 >> 2] = m[ye + 8 | 0] | m[ye + 9 | 0] << 8 | m[ye + 10 | 0] << 16 | m[ye + 11 | 0] << 24, o[Ne + 28 >> 2] = m[ye + 12 | 0] | m[ye + 13 | 0] << 8 | m[ye + 14 | 0] << 16 | m[ye + 15 | 0] << 24, o[Ne + 32 >> 2] = m[ye + 16 | 0] | m[ye + 17 | 0] << 8 | m[ye + 18 | 0] << 16 | m[ye + 19 | 0] << 24, o[Ne + 36 >> 2] = m[ye + 20 | 0] | m[ye + 21 | 0] << 8 | m[ye + 22 | 0] << 16 | m[ye + 23 | 0] << 24, o[Ne + 40 >> 2] = m[ye + 24 | 0] | m[ye + 25 | 0] << 8 | m[ye + 26 | 0] << 16 | m[ye + 27 | 0] << 24, ye = m[ye + 28 | 0] | m[ye + 29 | 0] << 8 | m[ye + 30 | 0] << 16 | m[ye + 31 | 0] << 24, o[Ne + 48 >> 2] = 0, o[Ne + 44 >> 2] = ye, o[Ne + 52 >> 2] = m[0 | M] | m[M + 1 | 0] << 8 | m[M + 2 | 0] << 16 | m[M + 3 | 0] << 24, o[Ne + 56 >> 2] = m[M + 4 | 0] | m[M + 5 | 0] << 8 | m[M + 6 | 0] << 16 | m[M + 7 | 0] << 24, o[Ne + 60 >> 2] = m[M + 8 | 0] | m[M + 9 | 0] << 8 | m[M + 10 | 0] << 16 | m[M + 11 | 0] << 24, ns(Ne, k = Ca(k, 0, E), k, E, T), _s(Ne, 64)), dr = Ne - -64 | 0, 0;
                    }, function(k, E, T, M, ye, Ne, pr, ve) {
                      var cr;
                      return k |= 0, E |= 0, ye |= 0, Ne |= 0, pr |= 0, ve |= 0, dr = cr = dr + -64 | 0, (T |= 0) | (M |= 0) && (o[cr + 8 >> 2] = 2036477234, o[cr + 12 >> 2] = 1797285236, o[cr >> 2] = 1634760805, o[cr + 4 >> 2] = 857760878, o[cr + 16 >> 2] = m[0 | ve] | m[ve + 1 | 0] << 8 | m[ve + 2 | 0] << 16 | m[ve + 3 | 0] << 24, o[cr + 20 >> 2] = m[ve + 4 | 0] | m[ve + 5 | 0] << 8 | m[ve + 6 | 0] << 16 | m[ve + 7 | 0] << 24, o[cr + 24 >> 2] = m[ve + 8 | 0] | m[ve + 9 | 0] << 8 | m[ve + 10 | 0] << 16 | m[ve + 11 | 0] << 24, o[cr + 28 >> 2] = m[ve + 12 | 0] | m[ve + 13 | 0] << 8 | m[ve + 14 | 0] << 16 | m[ve + 15 | 0] << 24, o[cr + 32 >> 2] = m[ve + 16 | 0] | m[ve + 17 | 0] << 8 | m[ve + 18 | 0] << 16 | m[ve + 19 | 0] << 24, o[cr + 36 >> 2] = m[ve + 20 | 0] | m[ve + 21 | 0] << 8 | m[ve + 22 | 0] << 16 | m[ve + 23 | 0] << 24, o[cr + 40 >> 2] = m[ve + 24 | 0] | m[ve + 25 | 0] << 8 | m[ve + 26 | 0] << 16 | m[ve + 27 | 0] << 24, o[cr + 44 >> 2] = m[ve + 28 | 0] | m[ve + 29 | 0] << 8 | m[ve + 30 | 0] << 16 | m[ve + 31 | 0] << 24, o[cr + 48 >> 2] = Ne, o[cr + 52 >> 2] = pr, o[cr + 56 >> 2] = m[0 | ye] | m[ye + 1 | 0] << 8 | m[ye + 2 | 0] << 16 | m[ye + 3 | 0] << 24, o[cr + 60 >> 2] = m[ye + 4 | 0] | m[ye + 5 | 0] << 8 | m[ye + 6 | 0] << 16 | m[ye + 7 | 0] << 24, ns(cr, E, k, T, M), _s(cr, 64)), dr = cr - -64 | 0, 0;
                    }, function(k, E, T, M, ye, Ne, pr) {
                      var ve;
                      return k |= 0, E |= 0, ye |= 0, Ne |= 0, pr |= 0, dr = ve = dr + -64 | 0, (T |= 0) | (M |= 0) && (o[ve + 8 >> 2] = 2036477234, o[ve + 12 >> 2] = 1797285236, o[ve >> 2] = 1634760805, o[ve + 4 >> 2] = 857760878, o[ve + 16 >> 2] = m[0 | pr] | m[pr + 1 | 0] << 8 | m[pr + 2 | 0] << 16 | m[pr + 3 | 0] << 24, o[ve + 20 >> 2] = m[pr + 4 | 0] | m[pr + 5 | 0] << 8 | m[pr + 6 | 0] << 16 | m[pr + 7 | 0] << 24, o[ve + 24 >> 2] = m[pr + 8 | 0] | m[pr + 9 | 0] << 8 | m[pr + 10 | 0] << 16 | m[pr + 11 | 0] << 24, o[ve + 28 >> 2] = m[pr + 12 | 0] | m[pr + 13 | 0] << 8 | m[pr + 14 | 0] << 16 | m[pr + 15 | 0] << 24, o[ve + 32 >> 2] = m[pr + 16 | 0] | m[pr + 17 | 0] << 8 | m[pr + 18 | 0] << 16 | m[pr + 19 | 0] << 24, o[ve + 36 >> 2] = m[pr + 20 | 0] | m[pr + 21 | 0] << 8 | m[pr + 22 | 0] << 16 | m[pr + 23 | 0] << 24, o[ve + 40 >> 2] = m[pr + 24 | 0] | m[pr + 25 | 0] << 8 | m[pr + 26 | 0] << 16 | m[pr + 27 | 0] << 24, pr = m[pr + 28 | 0] | m[pr + 29 | 0] << 8 | m[pr + 30 | 0] << 16 | m[pr + 31 | 0] << 24, o[ve + 48 >> 2] = Ne, o[ve + 44 >> 2] = pr, o[ve + 52 >> 2] = m[0 | ye] | m[ye + 1 | 0] << 8 | m[ye + 2 | 0] << 16 | m[ye + 3 | 0] << 24, o[ve + 56 >> 2] = m[ye + 4 | 0] | m[ye + 5 | 0] << 8 | m[ye + 6 | 0] << 16 | m[ye + 7 | 0] << 24, o[ve + 60 >> 2] = m[ye + 8 | 0] | m[ye + 9 | 0] << 8 | m[ye + 10 | 0] << 16 | m[ye + 11 | 0] << 24, ns(ve, E, k, T, M), _s(ve, 64)), dr = ve - -64 | 0, 0;
                    }], Nu.grow = function(k) {
                      var E = this.length;
                      return this.length = this.length + k, E;
                    }, Nu.set = function(k, E) {
                      this[k] = E;
                    }, Nu.get = function(k) {
                      return this[k];
                    }, Nu);
                    function jl() {
                      return Mn.byteLength / 65536 | 0;
                    }
                    return { e: Object.create(Object.prototype, { grow: { value: function(k) {
                      k |= 0;
                      var E = 0 | jl(), T = E + k | 0;
                      if (E < T && T < 65536) {
                        var M = new ArrayBuffer(v(T, 65536));
                        new Int8Array(M).set(B), B = new Int8Array(M), o = new Int32Array(M), m = new Uint8Array(M), d = new Uint32Array(M), Mn = M, dn = m;
                      }
                      return E;
                    } }, buffer: { get: function() {
                      return Mn;
                    } } }), f: function() {
                    }, g: Ra, h: Yf, i: Ra, j: Js, k: Ll, l: Pu, m: function(k, E, T, M, ye, Ne, pr, ve, cr, gr, Pr) {
                      return 0 | _h(k |= 0, E |= 0, T |= 0, M |= 0, ye |= 0, Ne |= 0, pr |= 0, ve |= 0, gr |= 0, Pr |= 0, 36768);
                    }, n: function(k, E, T, M, ye, Ne, pr, ve, cr, gr, Pr, Nr) {
                      return 0 | ul(k |= 0, E |= 0, T |= 0, M |= 0, ye |= 0, Ne |= 0, pr |= 0, ve |= 0, cr |= 0, Pr |= 0, Nr |= 0, 36768);
                    }, o: function(k, E, T, M, ye, Ne, pr, ve, cr, gr, Pr) {
                      return 0 | Eh(k |= 0, E |= 0, M |= 0, ye |= 0, Ne |= 0, pr |= 0, ve |= 0, cr |= 0, gr |= 0, Pr |= 0, 36772);
                    }, p: function(k, E, T, M, ye, Ne, pr, ve, cr, gr, Pr) {
                      return 0 | Dh(k |= 0, T |= 0, M |= 0, ye |= 0, Ne |= 0, pr |= 0, ve |= 0, cr |= 0, gr |= 0, Pr |= 0, 36772);
                    }, q: Js, r: Yf, s: Js, t: Js, u: Ll, v: cf, w: function(k, E, T, M, ye, Ne, pr, ve, cr, gr, Pr) {
                      return 0 | _h(k |= 0, E |= 0, T |= 0, M |= 0, ye |= 0, Ne |= 0, pr |= 0, ve |= 0, gr |= 0, Pr |= 0, 36776);
                    }, x: function(k, E, T, M, ye, Ne, pr, ve, cr, gr, Pr, Nr) {
                      return 0 | ul(k |= 0, E |= 0, T |= 0, M |= 0, ye |= 0, Ne |= 0, pr |= 0, ve |= 0, cr |= 0, Pr |= 0, Nr |= 0, 36776);
                    }, y: function(k, E, T, M, ye, Ne, pr, ve, cr, gr, Pr) {
                      return 0 | Eh(k |= 0, E |= 0, M |= 0, ye |= 0, Ne |= 0, pr |= 0, ve |= 0, cr |= 0, gr |= 0, Pr |= 0, 36780);
                    }, z: function(k, E, T, M, ye, Ne, pr, ve, cr, gr, Pr) {
                      return 0 | Dh(k |= 0, T |= 0, M |= 0, ye |= 0, Ne |= 0, pr |= 0, ve |= 0, cr |= 0, gr |= 0, Pr |= 0, 36780);
                    }, A: Yf, B: function(k, E, T, M, ye, Ne, pr, ve, cr, gr, Pr, Nr) {
                      return 0 | bh(k |= 0, E |= 0, T |= 0, M |= 0, (k = 0) | (ye |= 0), Ne |= 0, pr |= 0, k | (ve |= 0), cr |= 0, Pr |= 0, Nr |= 0);
                    }, C: function(k, E, T, M, ye, Ne, pr, ve, cr, gr, Pr) {
                      return k |= 0, E |= 0, M |= 0, pr |= 0, cr |= 0, pr |= cr = 0, !(ye |= 0) & (M |= cr) >>> 0 < 4294967280 ? (bh(k, k + M | 0, 0, T |= 0, M, ye, Ne |= 0, pr, ve |= 0, gr |= 0, Pr |= 0), E && (ye = (k = M + 16 | 0) >>> 0 < 16 ? ye + 1 | 0 : ye, o[E >> 2] = k, o[E + 4 >> 2] = ye)) : (Wa(), ji()), 0;
                    }, D: function(k, E, T, M, ye, Ne, pr, ve, cr, gr, Pr, Nr) {
                      return 0 | Zh(k |= 0, E |= 0, T |= 0, M |= 0, (k = 0) | (ye |= 0), Ne |= 0, pr |= 0, k | (ve |= 0), cr |= 0, Pr |= 0, Nr |= 0);
                    }, E: function(k, E, T, M, ye, Ne, pr, ve, cr, gr, Pr) {
                      return k |= 0, E |= 0, M |= 0, pr |= 0, cr |= 0, pr |= cr = 0, !(ye |= 0) & (M |= cr) >>> 0 < 4294967280 ? (Zh(k, k + M | 0, 0, T |= 0, M, ye, Ne |= 0, pr, ve |= 0, gr |= 0, Pr |= 0), E && (ye = (k = M + 16 | 0) >>> 0 < 16 ? ye + 1 | 0 : ye, o[E >> 2] = k, o[E + 4 >> 2] = ye)) : (Wa(), ji()), 0;
                    }, F: function(k, E, T, M, ye, Ne, pr, ve, cr, gr, Pr) {
                      return 0 | wh(k |= 0, T |= 0, (k = 0) | (M |= 0), ye |= 0, Ne |= 0, pr |= 0, k | (ve |= 0), cr |= 0, gr |= 0, Pr |= 0);
                    }, G: function(k, E, T, M, ye, Ne, pr, ve, cr, gr, Pr) {
                      return E |= 0, T |= 0, M |= 0, ye |= 0, ve |= 0, ve |= 0, T = -1, !(Ne |= 0) & (ye |= 0) >>> 0 >= 16 | Ne && (T = wh(k |= 0, M, ye - 16 | 0, Ne - (ye >>> 0 < 16) | 0, (M + ye | 0) - 16 | 0, pr |= 0, ve, cr |= 0, gr |= 0, Pr |= 0)), E && (o[E >> 2] = T ? 0 : ye - 16 | 0, o[E + 4 >> 2] = T ? 0 : Ne - (ye >>> 0 < 16) | 0), 0 | T;
                    }, H: function(k, E, T, M, ye, Ne, pr, ve, cr, gr, Pr) {
                      return 0 | Jh(k |= 0, T |= 0, (k = 0) | (M |= 0), ye |= 0, Ne |= 0, pr |= 0, k | (ve |= 0), cr |= 0, gr |= 0, Pr |= 0);
                    }, I: function(k, E, T, M, ye, Ne, pr, ve, cr, gr, Pr) {
                      return E |= 0, T |= 0, M |= 0, ye |= 0, ve |= 0, ve |= 0, T = -1, !(Ne |= 0) & (ye |= 0) >>> 0 >= 16 | Ne && (T = Jh(k |= 0, M, ye - 16 | 0, Ne - (ye >>> 0 < 16) | 0, (M + ye | 0) - 16 | 0, pr |= 0, ve, cr |= 0, gr |= 0, Pr |= 0)), E && (o[E >> 2] = T ? 0 : ye - 16 | 0, o[E + 4 >> 2] = T ? 0 : Ne - (ye >>> 0 < 16) | 0), 0 | T;
                    }, J: Js, K: ql, L: Yf, M: Ra, N: wc, O: cf, P: Js, Q: $f, R: Yf, S: Ra, T: wc, U: cf, V: function(k, E, T, M, ye, Ne, pr, ve, cr, gr, Pr, Nr) {
                      return 0 | Jo(k |= 0, E |= 0, T |= 0, M |= 0, (k = 0) | (ye |= 0), Ne |= 0, pr |= 0, k | (ve |= 0), cr |= 0, Pr |= 0, Nr |= 0);
                    }, W: function(k, E, T, M, ye, Ne, pr, ve, cr, gr, Pr) {
                      return k |= 0, E |= 0, M |= 0, pr |= 0, cr |= 0, pr |= cr = 0, !(ye |= 0) & (M |= cr) >>> 0 < 4294967280 ? (Jo(k, k + M | 0, 0, T |= 0, M, ye, Ne |= 0, pr, ve |= 0, gr |= 0, Pr |= 0), E && (ye = (k = M + 16 | 0) >>> 0 < 16 ? ye + 1 | 0 : ye, o[E >> 2] = k, o[E + 4 >> 2] = ye)) : (Wa(), ji()), 0;
                    }, X: function(k, E, T, M, ye, Ne, pr, ve, cr, gr, Pr) {
                      return 0 | mo(k |= 0, T |= 0, (k = 0) | (M |= 0), ye |= 0, Ne |= 0, pr |= 0, k | (ve |= 0), cr |= 0, gr |= 0, Pr |= 0);
                    }, Y: function(k, E, T, M, ye, Ne, pr, ve, cr, gr, Pr) {
                      return E |= 0, T |= 0, M |= 0, ye |= 0, ve |= 0, ve |= 0, T = -1, !(Ne |= 0) & (ye |= 0) >>> 0 >= 16 | Ne && (T = mo(k |= 0, M, ye - 16 | 0, Ne - (ye >>> 0 < 16) | 0, (M + ye | 0) - 16 | 0, pr |= 0, ve, cr |= 0, gr |= 0, Pr |= 0)), E && (o[E >> 2] = T ? 0 : ye - 16 | 0, o[E + 4 >> 2] = T ? 0 : Ne - (ye >>> 0 < 16) | 0), 0 | T;
                    }, Z: Js, _: rc, $: Yf, aa: Ra, ba: wc, ca: cf, da: Js, ea: Js, fa: function() {
                      return 1462;
                    }, ga: yi, ha: Xh, ia: cf, ja: Js, ka: Js, la: Mu, ma: cf, na: Co, oa: function(k, E, T, M) {
                      return 0 | vc(k |= 0, E |= 0, T |= 0, M |= 0);
                    }, pa: au, qa: function(k, E, T, M, ye) {
                      var Ne;
                      return k |= 0, E |= 0, T |= 0, M |= 0, dr = Ne = dr - 240 | 0, Co(Ne, ye |= 0, 32), Mf(Ne, E, T, M), wn(Ne, E = Ne + 208 | 0), Mf(T = Ne + 104 | 0, E, 32, 0), wn(T, k), _s(E, 32), dr = Ne + 240 | 0, 0;
                    }, ra: function(k, E, T, M, ye) {
                      var Ne, pr;
                      return k |= 0, E |= 0, T |= 0, M |= 0, dr = Ne = dr - 272 | 0, Co(pr = Ne + 32 | 0, ye |= 0, 32), Mf(pr, E, T, M), wn(pr, E = Ne + 240 | 0), Mf(T = Ne + 136 | 0, E, 32, 0), wn(T, Ne), _s(E, 32), E = tu(k, Ne), T = bi(Ne, k, 32), dr = Ne + 272 | 0, ((0 | k) == (0 | Ne) ? -1 : E) | T;
                    }, sa: pf, ta: Js, ua: nh, va: cf, wa: tc, xa: Sl, ya: Fc, za: function(k, E, T, M, ye) {
                      var Ne;
                      return k |= 0, E |= 0, T |= 0, M |= 0, dr = Ne = dr - 480 | 0, tc(Ne, ye |= 0, 32), qs(Ne, E, T, M), ds(Ne, E = Ne + 416 | 0), qs(T = Ne + 208 | 0, E, 64, 0), ds(T, k), _s(E, 64), dr = Ne + 480 | 0, 0;
                    }, Aa: function(k, E, T, M, ye) {
                      var Ne, pr;
                      return k |= 0, E |= 0, T |= 0, M |= 0, dr = Ne = dr - 544 | 0, tc(pr = Ne - -64 | 0, ye |= 0, 32), qs(pr, E, T, M), ds(pr, E = Ne + 480 | 0), qs(T = Ne + 272 | 0, E, 64, 0), ds(T, Ne), _s(E, 64), E = xl(k, Ne), T = bi(Ne, k, 64), dr = Ne + 544 | 0, ((0 | k) == (0 | Ne) ? -1 : E) | T;
                    }, Ba: Js, Ca: Js, Da: nh, Ea: cf, Fa: Tl, Ga: Sl, Ha: function(k, E) {
                      E |= 0;
                      var T, M = 0;
                      return dr = T = dr + -64 | 0, Fc(k |= 0, T), M = o[T + 28 >> 2], k = o[T + 24 >> 2], B[E + 24 | 0] = k, B[E + 25 | 0] = k >>> 8, B[E + 26 | 0] = k >>> 16, B[E + 27 | 0] = k >>> 24, B[E + 28 | 0] = M, B[E + 29 | 0] = M >>> 8, B[E + 30 | 0] = M >>> 16, B[E + 31 | 0] = M >>> 24, M = o[T + 20 >> 2], k = o[T + 16 >> 2], B[E + 16 | 0] = k, B[E + 17 | 0] = k >>> 8, B[E + 18 | 0] = k >>> 16, B[E + 19 | 0] = k >>> 24, B[E + 20 | 0] = M, B[E + 21 | 0] = M >>> 8, B[E + 22 | 0] = M >>> 16, B[E + 23 | 0] = M >>> 24, M = o[T + 12 >> 2], k = o[T + 8 >> 2], B[E + 8 | 0] = k, B[E + 9 | 0] = k >>> 8, B[E + 10 | 0] = k >>> 16, B[E + 11 | 0] = k >>> 24, B[E + 12 | 0] = M, B[E + 13 | 0] = M >>> 8, B[E + 14 | 0] = M >>> 16, B[E + 15 | 0] = M >>> 24, M = o[T + 4 >> 2], k = o[T >> 2], B[0 | E] = k, B[E + 1 | 0] = k >>> 8, B[E + 2 | 0] = k >>> 16, B[E + 3 | 0] = k >>> 24, B[E + 4 | 0] = M, B[E + 5 | 0] = M >>> 8, B[E + 6 | 0] = M >>> 16, B[E + 7 | 0] = M >>> 24, dr = T - -64 | 0, 0;
                    }, Ia: yi, Ja: Xh, Ka: Js, La: Js, Ma: Js, Na: Js, Oa: rc, Pa: Js, Qa: Ra, Ra, Sa: wc, Ta: function() {
                      return 1476;
                    }, Ua: function(k, E, T) {
                      return 0 | ii(k |= 0, E |= 0, T |= 0);
                    }, Va: Pl, Wa: xu, Xa: zu, Ya: Xu, Za: kh, _a: al, $a: ml, ab: function(k, E, T, M, ye, Ne, pr, ve) {
                      k |= 0, E |= 0, T |= 0, Ne |= 0;
                      var cr, gr = 0;
                      return gr = M |= 0, M = ye |= 0, cr = 0 | gr, dr = gr = dr - 32 | 0, ye = -1, xu(gr, pr |= 0, ve |= 0) || (ye = Bi(k, E, T, cr, M, Ne, gr), _s(gr, 32)), dr = gr + 32 | 0, 0 | ye;
                    }, bb: function(k, E, T, M, ye, Ne) {
                      return k |= 0, E |= 0, ye |= 0, Ne |= 0, !(M |= 0) & (T |= 0) >>> 0 >= 4294967280 | M && (Wa(), ji()), 0 | Bi(k + 16 | 0, k, E, T, M, ye, Ne);
                    }, cb: function(k, E, T, M, ye, Ne, pr) {
                      return 0 | Al(k |= 0, E |= 0, T |= 0, M |= 0, ye |= 0, Ne |= 0, pr |= 0);
                    }, db: vl, eb: function(k, E, T, M, ye, Ne, pr, ve) {
                      k |= 0, E |= 0, T |= 0, Ne |= 0;
                      var cr, gr = 0;
                      return gr = M |= 0, M = ye |= 0, cr = 0 | gr, dr = gr = dr - 32 | 0, ye = -1, xu(gr, pr |= 0, ve |= 0) || (ye = Ki(k, E, T, cr, M, Ne, gr), _s(gr, 32)), dr = gr + 32 | 0, 0 | ye;
                    }, fb: $u, gb: function(k, E, T, M, ye, Ne, pr) {
                      return 0 | fl(k |= 0, E |= 0, T |= 0, M |= 0, ye |= 0, Ne |= 0, pr |= 0);
                    }, hb: function(k, E, T, M, ye) {
                      k |= 0, E |= 0, ye |= 0;
                      var Ne, pr, ve, cr, gr = 0, Pr = 0;
                      return gr = T |= 0, T = M |= 0, cr = 0 | gr, gr = M = dr, dr = Ne = M - 512 & -64, M = -1, Pl(pr = Ne - -64 | 0, ve = Ne + 32 | 0) || (Zc(M = Ne + 128 | 0, 0, 0, 24), Qf(M, pr, 32, 0), Qf(M, ye, 32, 0), eu(M, Pr = Ne + 96 | 0, 24), M = Al(k + 32 | 0, E, cr, T, Pr, ye, ve), E = o[Ne + 92 >> 2], T = o[Ne + 88 >> 2], B[k + 24 | 0] = T, B[k + 25 | 0] = T >>> 8, B[k + 26 | 0] = T >>> 16, B[k + 27 | 0] = T >>> 24, B[k + 28 | 0] = E, B[k + 29 | 0] = E >>> 8, B[k + 30 | 0] = E >>> 16, B[k + 31 | 0] = E >>> 24, E = o[Ne + 84 >> 2], T = o[Ne + 80 >> 2], B[k + 16 | 0] = T, B[k + 17 | 0] = T >>> 8, B[k + 18 | 0] = T >>> 16, B[k + 19 | 0] = T >>> 24, B[k + 20 | 0] = E, B[k + 21 | 0] = E >>> 8, B[k + 22 | 0] = E >>> 16, B[k + 23 | 0] = E >>> 24, E = o[Ne + 76 >> 2], T = o[Ne + 72 >> 2], B[k + 8 | 0] = T, B[k + 9 | 0] = T >>> 8, B[k + 10 | 0] = T >>> 16, B[k + 11 | 0] = T >>> 24, B[k + 12 | 0] = E, B[k + 13 | 0] = E >>> 8, B[k + 14 | 0] = E >>> 16, B[k + 15 | 0] = E >>> 24, E = o[Ne + 68 >> 2], T = o[Ne + 64 >> 2], B[0 | k] = T, B[k + 1 | 0] = T >>> 8, B[k + 2 | 0] = T >>> 16, B[k + 3 | 0] = T >>> 24, B[k + 4 | 0] = E, B[k + 5 | 0] = E >>> 8, B[k + 6 | 0] = E >>> 16, B[k + 7 | 0] = E >>> 24, _s(ve, 32), _s(pr, 32), _s(Pr, 24)), dr = gr, 0 | M;
                    }, ib: function(k, E, T, M, ye, Ne) {
                      k |= 0, E |= 0, ye |= 0, Ne |= 0;
                      var pr, ve, cr = 0;
                      return ve = cr = dr, dr = pr = cr - 448 & -64, cr = -1, !(M |= 0) & (T |= 0) >>> 0 >= 48 | M && (Zc(cr = pr - -64 | 0, 0, 0, 24), Qf(cr, E, 32, 0), Qf(cr, ye, 32, 0), eu(cr, ye = pr + 32 | 0, 24), cr = fl(k, E + 32 | 0, T - 32 | 0, M - (T >>> 0 < 32) | 0, ye, E, Ne)), dr = ve, 0 | cr;
                    }, jb: Lh, kb: ii, lb: Ru, mb: dl, nb: zu, ob: Xu, pb: kh, qb: al, rb: Js, sb: Js, tb: Js, ub: Js, vb: rc, wb: Js, xb: Ra, yb: Ra, zb: wc, Ab: ba, Bb: Js, Cb: Ra, Db: Js, Eb: Ra, Fb: ea, Gb: Js, Hb: Ra, Ib: Js, Jb: Ra, Kb: Tu, Lb: pf, Mb: Ra, Nb: Js, Ob: Ra, Pb: Du, Qb: pf, Rb: Ra, Sb: Js, Tb: Ra, Ub: fu, Vb: pf, Wb: Ra, Xb: Js, Yb: Ra, Zb: Ra, _b: pf, $b: Js, ac: Ra, bc: pf, cc: Js, dc: th, ec: ih, fc: function(k, E, T, M, ye, Ne, pr) {
                      return 0 | dA(k |= 0, E |= 0, T |= 0, M |= 0, ye |= 0, Ne |= 0, pr |= 0);
                    }, gc: Zc, hc: function(k, E, T, M) {
                      return 0 | Qf(k |= 0, E |= 0, T |= 0, M |= 0);
                    }, ic: eu, jc: cf, kc: Ra, lc: pf, mc: Js, nc: Ra, oc: pf, pc: Js, qc: Ra, rc: Ra, sc: ih, tc: cf, uc: dA, vc: function(k, E, T, M, ye, Ne, pr, ve, cr) {
                      return 0 | ya(k |= 0, E |= 0, T |= 0, M |= 0, ye |= 0, Ne |= 0, pr |= 0, ve |= 0, cr |= 0);
                    }, wc: Na, xc: function(k, E, T, M, ye, Ne) {
                      k |= 0, E |= 0, ye |= 0, Ne |= 0;
                      var pr = 0, ve = 0, cr = 0, gr = 0, Pr = 0, Nr = 0, Br = 0;
                      if (pr = -1, !((M |= 0) - 65 >>> 0 < 4294967232 | (T |= 0) >>> 0 > 64)) {
                        e: {
                          if (!T || !E) {
                            if (((gr = 255 & M) - 65 & 255) >>> 0 > 191) {
                              ye ? (ve = 725511199 ^ (m[ye + 8 | 0] | m[ye + 9 | 0] << 8 | m[ye + 10 | 0] << 16 | m[ye + 11 | 0] << 24), T = -1694144372 ^ (m[ye + 12 | 0] | m[ye + 13 | 0] << 8 | m[ye + 14 | 0] << 16 | m[ye + 15 | 0] << 24), E = -1377402159 ^ (m[0 | ye] | m[ye + 1 | 0] << 8 | m[ye + 2 | 0] << 16 | m[ye + 3 | 0] << 24), ye = 1359893119 ^ (m[ye + 4 | 0] | m[ye + 5 | 0] << 8 | m[ye + 6 | 0] << 16 | m[ye + 7 | 0] << 24)) : (ve = 725511199, T = -1694144372, E = -1377402159, ye = 1359893119), Ne ? (cr = 327033209 ^ (m[Ne + 8 | 0] | m[Ne + 9 | 0] << 8 | m[Ne + 10 | 0] << 16 | m[Ne + 11 | 0] << 24), M = 1541459225 ^ (m[Ne + 12 | 0] | m[Ne + 13 | 0] << 8 | m[Ne + 14 | 0] << 16 | m[Ne + 15 | 0] << 24), pr = -79577749 ^ (m[0 | Ne] | m[Ne + 1 | 0] << 8 | m[Ne + 2 | 0] << 16 | m[Ne + 3 | 0] << 24), Ne = 528734635 ^ (m[Ne + 4 | 0] | m[Ne + 5 | 0] << 8 | m[Ne + 6 | 0] << 16 | m[Ne + 7 | 0] << 24)) : (cr = 327033209, M = 1541459225, pr = -79577749, Ne = 528734635), Ca(k - -64 | 0, 0, 293), B[k + 56 | 0] = cr, B[k + 57 | 0] = cr >>> 8, B[k + 58 | 0] = cr >>> 16, B[k + 59 | 0] = cr >>> 24, B[k + 60 | 0] = M, B[k + 61 | 0] = M >>> 8, B[k + 62 | 0] = M >>> 16, B[k + 63 | 0] = M >>> 24, B[k + 48 | 0] = pr, B[k + 49 | 0] = pr >>> 8, B[k + 50 | 0] = pr >>> 16, B[k + 51 | 0] = pr >>> 24, B[k + 52 | 0] = Ne, B[k + 53 | 0] = Ne >>> 8, B[k + 54 | 0] = Ne >>> 16, B[k + 55 | 0] = Ne >>> 24, B[k + 40 | 0] = ve, B[k + 41 | 0] = ve >>> 8, B[k + 42 | 0] = ve >>> 16, B[k + 43 | 0] = ve >>> 24, B[k + 44 | 0] = T, B[k + 45 | 0] = T >>> 8, B[k + 46 | 0] = T >>> 16, B[k + 47 | 0] = T >>> 24, B[k + 32 | 0] = E, B[k + 33 | 0] = E >>> 8, B[k + 34 | 0] = E >>> 16, B[k + 35 | 0] = E >>> 24, B[k + 36 | 0] = ye, B[k + 37 | 0] = ye >>> 8, B[k + 38 | 0] = ye >>> 16, B[k + 39 | 0] = ye >>> 24, B[k + 24 | 0] = 241, B[k + 25 | 0] = 54, B[k + 26 | 0] = 29, B[k + 27 | 0] = 95, B[k + 28 | 0] = 58, B[k + 29 | 0] = 245, B[k + 30 | 0] = 79, B[k + 31 | 0] = 165, B[k + 16 | 0] = 43, B[k + 17 | 0] = 248, B[k + 18 | 0] = 148, B[k + 19 | 0] = 254, B[k + 20 | 0] = 114, B[k + 21 | 0] = 243, B[k + 22 | 0] = 110, B[k + 23 | 0] = 60, B[k + 8 | 0] = 59, B[k + 9 | 0] = 167, B[k + 10 | 0] = 202, B[k + 11 | 0] = 132, B[k + 12 | 0] = 133, B[k + 13 | 0] = 174, B[k + 14 | 0] = 103, B[k + 15 | 0] = 187, E = -222443256 ^ gr, B[0 | k] = E, B[k + 1 | 0] = E >>> 8, B[k + 2 | 0] = E >>> 16, B[k + 3 | 0] = E >>> 24, B[k + 4 | 0] = 103, B[k + 5 | 0] = 230, B[k + 6 | 0] = 9, B[k + 7 | 0] = 106;
                              break e;
                            }
                            Wa(), ji();
                          }
                          dr = Nr = dr - 128 | 0, !E | ((Br = 255 & M) - 65 & 255) >>> 0 <= 191 | ((gr = 255 & T) - 65 & 255) >>> 0 <= 191 ? (Wa(), ji()) : (ye ? (ve = 725511199 ^ (m[ye + 8 | 0] | m[ye + 9 | 0] << 8 | m[ye + 10 | 0] << 16 | m[ye + 11 | 0] << 24), T = -1694144372 ^ (m[ye + 12 | 0] | m[ye + 13 | 0] << 8 | m[ye + 14 | 0] << 16 | m[ye + 15 | 0] << 24), pr = -1377402159 ^ (m[0 | ye] | m[ye + 1 | 0] << 8 | m[ye + 2 | 0] << 16 | m[ye + 3 | 0] << 24), ye = 1359893119 ^ (m[ye + 4 | 0] | m[ye + 5 | 0] << 8 | m[ye + 6 | 0] << 16 | m[ye + 7 | 0] << 24)) : (ve = 725511199, T = -1694144372, pr = -1377402159, ye = 1359893119), Ne ? (cr = 327033209 ^ (m[Ne + 8 | 0] | m[Ne + 9 | 0] << 8 | m[Ne + 10 | 0] << 16 | m[Ne + 11 | 0] << 24), M = 1541459225 ^ (m[Ne + 12 | 0] | m[Ne + 13 | 0] << 8 | m[Ne + 14 | 0] << 16 | m[Ne + 15 | 0] << 24), Pr = -79577749 ^ (m[0 | Ne] | m[Ne + 1 | 0] << 8 | m[Ne + 2 | 0] << 16 | m[Ne + 3 | 0] << 24), Ne = 528734635 ^ (m[Ne + 4 | 0] | m[Ne + 5 | 0] << 8 | m[Ne + 6 | 0] << 16 | m[Ne + 7 | 0] << 24)) : (cr = 327033209, M = 1541459225, Pr = -79577749, Ne = 528734635), Ca(k - -64 | 0, 0, 293), B[k + 56 | 0] = cr, B[k + 57 | 0] = cr >>> 8, B[k + 58 | 0] = cr >>> 16, B[k + 59 | 0] = cr >>> 24, B[k + 60 | 0] = M, B[k + 61 | 0] = M >>> 8, B[k + 62 | 0] = M >>> 16, B[k + 63 | 0] = M >>> 24, B[k + 48 | 0] = Pr, B[k + 49 | 0] = Pr >>> 8, B[k + 50 | 0] = Pr >>> 16, B[k + 51 | 0] = Pr >>> 24, B[k + 52 | 0] = Ne, B[k + 53 | 0] = Ne >>> 8, B[k + 54 | 0] = Ne >>> 16, B[k + 55 | 0] = Ne >>> 24, B[k + 40 | 0] = ve, B[k + 41 | 0] = ve >>> 8, B[k + 42 | 0] = ve >>> 16, B[k + 43 | 0] = ve >>> 24, B[k + 44 | 0] = T, B[k + 45 | 0] = T >>> 8, B[k + 46 | 0] = T >>> 16, B[k + 47 | 0] = T >>> 24, B[k + 32 | 0] = pr, B[k + 33 | 0] = pr >>> 8, B[k + 34 | 0] = pr >>> 16, B[k + 35 | 0] = pr >>> 24, B[k + 36 | 0] = ye, B[k + 37 | 0] = ye >>> 8, B[k + 38 | 0] = ye >>> 16, B[k + 39 | 0] = ye >>> 24, B[k + 24 | 0] = 241, B[k + 25 | 0] = 54, B[k + 26 | 0] = 29, B[k + 27 | 0] = 95, B[k + 28 | 0] = 58, B[k + 29 | 0] = 245, B[k + 30 | 0] = 79, B[k + 31 | 0] = 165, B[k + 16 | 0] = 43, B[k + 17 | 0] = 248, B[k + 18 | 0] = 148, B[k + 19 | 0] = 254, B[k + 20 | 0] = 114, B[k + 21 | 0] = 243, B[k + 22 | 0] = 110, B[k + 23 | 0] = 60, B[k + 8 | 0] = 59, B[k + 9 | 0] = 167, B[k + 10 | 0] = 202, B[k + 11 | 0] = 132, B[k + 12 | 0] = 133, B[k + 13 | 0] = 174, B[k + 14 | 0] = 103, B[k + 15 | 0] = 187, T = -222443256 ^ (gr << 8 | Br), B[0 | k] = T, B[k + 1 | 0] = T >>> 8, B[k + 2 | 0] = T >>> 16, B[k + 3 | 0] = T >>> 24, T = gr >>> 24 ^ 1779033703, B[k + 4 | 0] = T, B[k + 5 | 0] = T >>> 8, B[k + 6 | 0] = T >>> 16, B[k + 7 | 0] = T >>> 24, T = fa(Ca(Nr, 0, 128), E, gr), fa(k + 96 | 0, T, 128), E = 128 + (m[k + 352 | 0] | m[k + 353 | 0] << 8 | m[k + 354 | 0] << 16 | m[k + 355 | 0] << 24) | 0, B[k + 352 | 0] = E, B[k + 353 | 0] = E >>> 8, B[k + 354 | 0] = E >>> 16, B[k + 355 | 0] = E >>> 24, _s(T, 128), dr = T + 128 | 0);
                        }
                        pr = 0;
                      }
                      return 0 | pr;
                    }, yc: Qf, zc: Bu, Ac: pf, Bc: _l, Cc: function() {
                      return 1531;
                    }, Dc: Js, Ec: function() {
                      return 104;
                    }, Fc: Gu, Gc: function(k, E, T, M) {
                      return 0 | Mf(k |= 0, E |= 0, T |= 0, M |= 0);
                    }, Hc: wn, Ic: function(k, E, T, M) {
                      k |= 0, E |= 0, T |= 0, M |= 0;
                      var ye, Ne = 0;
                      return dr = ye = dr - 112 | 0, Ne = o[8811], o[ye + 16 >> 2] = o[8810], o[ye + 20 >> 2] = Ne, Ne = o[8813], o[ye + 24 >> 2] = o[8812], o[ye + 28 >> 2] = Ne, Ne = o[8815], o[ye + 32 >> 2] = o[8814], o[ye + 36 >> 2] = Ne, o[ye + 40 >> 2] = 0, o[ye + 44 >> 2] = 0, Ne = o[8809], o[ye + 8 >> 2] = o[8808], o[ye + 12 >> 2] = Ne, Mf(Ne = ye + 8 | 0, E, T, M), wn(Ne, k), dr = ye + 112 | 0, 0;
                    }, Jc: pf, Kc: Mu, Lc: Ks, Mc: Xc, Nc: ds, Oc: _l, Pc: Ra, Qc: pf, Rc: $f, Sc: Js, Tc: zh, Uc: th, Vc: Ra, Wc: pf, Xc: $f, Yc: Js, Zc: zh, _c: cf, $c: function(k, E, T) {
                      return 0 | Co(k |= 0, E |= 0, T |= 0);
                    }, ad: function(k, E, T) {
                      return 0 | vc(k |= 0, E |= 0, T |= 0, 0);
                    }, bd: function(k, E) {
                      return au(k |= 0, E |= 0), _s(k, 4), 0;
                    }, cd: function(k, E, T, M, ye) {
                      var Ne;
                      return k |= 0, M |= 0, ye |= 0, dr = Ne = dr - 208 | 0, Co(Ne, E |= 0, T |= 0), vc(Ne, M, ye, 0), au(Ne, k), _s(Ne, 4), dr = Ne + 208 | 0, 0;
                    }, dd: cf, ed: function(k, E, T, M, ye) {
                      k |= 0, E |= 0, T |= 0, M |= 0, ye |= 0;
                      var Ne, pr = 0, ve = 0, cr = 0, gr = 0;
                      if (dr = Ne = dr - 256 | 0, B[Ne + 15 | 0] = 1, E >>> 0 <= 8160) {
                        if (E >>> 0 >= 32) for (gr = k - 32 | 0, pr = 32; cr = pr, Co(pr = Ne + 48 | 0, ye, 32), ve && vc(pr, ve + gr | 0, 32, 0), vc(pr = Ne + 48 | 0, T, M, 0), vc(pr, Ne + 15 | 0, 1, 0), au(pr, k + ve | 0), B[Ne + 15 | 0] = m[Ne + 15 | 0] + 1, (pr = (ve = cr) + 32 | 0) >>> 0 <= E >>> 0; ) ;
                        (ve = 31 & E) && (Co(E = Ne + 48 | 0, ye, 32), cr && vc(E, (k + cr | 0) - 32 | 0, 32, 0), vc(E = Ne + 48 | 0, T, M, 0), vc(E, Ne + 15 | 0, 1, 0), au(T = E, E = Ne + 16 | 0), fa(k + cr | 0, E, ve), _s(E, 32)), _s(Ne + 48 | 0, 208), k = 0;
                      } else o[9404] = 28, k = -1;
                      return dr = Ne + 256 | 0, 0 | k;
                    }, fd: Js, gd: Yf, hd: function() {
                      return 8160;
                    }, id: Mu, jd: Tl, kd: function(k, E, T) {
                      return 0 | mc(k |= 0, E |= 0, T |= 0, 0);
                    }, ld: function(k, E) {
                      return Fc(k |= 0, E |= 0), _s(k, 4), 0;
                    }, md: function(k, E, T, M, ye) {
                      var Ne;
                      return k |= 0, M |= 0, ye |= 0, dr = Ne = dr - 416 | 0, tc(Ne, E |= 0, T |= 0), mc(Ne, M, ye, 0), Fc(Ne, k), _s(Ne, 4), dr = Ne + 416 | 0, 0;
                    }, nd: function(k) {
                      Sf(k |= 0, 64);
                    }, od: function(k, E, T, M, ye) {
                      k |= 0, E |= 0, T |= 0, M |= 0, ye |= 0;
                      var Ne, pr = 0, ve = 0, cr = 0, gr = 0;
                      if (dr = Ne = dr - 496 | 0, B[Ne + 15 | 0] = 1, E >>> 0 <= 16320) {
                        if (E >>> 0 >= 64) for (gr = k + -64 | 0, pr = 64; cr = pr, tc(pr = Ne + 80 | 0, ye, 64), ve && mc(pr, ve + gr | 0, 64, 0), mc(pr = Ne + 80 | 0, T, M, 0), mc(pr, Ne + 15 | 0, 1, 0), Fc(pr, k + ve | 0), B[Ne + 15 | 0] = m[Ne + 15 | 0] + 1, (pr = (ve = cr) - -64 | 0) >>> 0 <= E >>> 0; ) ;
                        (ve = 63 & E) && (tc(E = Ne + 80 | 0, ye, 64), cr && mc(E, (k + cr | 0) - 64 | 0, 64, 0), mc(E = Ne + 80 | 0, T, M, 0), mc(E, Ne + 15 | 0, 1, 0), Fc(T = E, E = Ne + 16 | 0), fa(k + cr | 0, E, ve), _s(E, 64)), _s(Ne + 80 | 0, 416), k = 0;
                      } else o[9404] = 28, k = -1;
                      return dr = Ne + 496 | 0, 0 | k;
                    }, pd: pf, qd: Yf, rd: function() {
                      return 16320;
                    }, sd: nh, td: function(k, E, T) {
                      return k |= 0, dA(E |= 0, 32, T |= 0, 32, 0, 0, 0), 0 | Oh(k, E);
                    }, ud: function(k, E) {
                      return k |= 0, Sf(E |= 0, 32), 0 | Oh(k, E);
                    }, vd: function(k, E, T, M, ye) {
                      E |= 0, T |= 0, M |= 0, ye |= 0;
                      var Ne, pr, ve = 0, cr = 0, gr = 0;
                      if (pr = ve = dr, dr = ve = ve - 512 & -64, Ne = (k |= 0) || E) {
                        if (gr = -1, !Mh(cr = ve + 96 | 0, M, ye)) {
                          for (M = E || k, k = 0, Zc(E = ve + 128 | 0, 0, 0, 64), Qf(E, cr, 32, 0), _s(cr, 32), Qf(E, T, 32, 0), Qf(E, ye, 32, 0), eu(E, ve + 32 | 0, 64), _s(E, 384); T = (E = ve + 32 | 0) + k | 0, B[k + Ne | 0] = m[0 | T], B[k + M | 0] = m[T + 32 | 0], B[(T = 1 | k) + Ne | 0] = m[E + T | 0], B[T + M | 0] = m[E + (33 | k) | 0], (0 | (k = k + 2 | 0)) != 32; ) ;
                          _s(E, 64), gr = 0;
                        }
                        return dr = pr, 0 | gr;
                      }
                      Wa(), ji();
                    }, wd: function(k, E, T, M, ye) {
                      E |= 0, T |= 0, M |= 0, ye |= 0;
                      var Ne, pr, ve = 0, cr = 0, gr = 0;
                      if (pr = ve = dr, dr = ve = ve - 512 & -64, Ne = (k |= 0) || E) {
                        if (gr = -1, !Mh(cr = ve + 96 | 0, M, ye)) {
                          for (M = E || k, k = 0, Zc(E = ve + 128 | 0, 0, 0, 64), Qf(E, cr, 32, 0), _s(cr, 32), Qf(E, ye, 32, 0), Qf(E, T, 32, 0), eu(E, ve + 32 | 0, 64), _s(E, 384); T = (E = ve + 32 | 0) + k | 0, B[k + M | 0] = m[0 | T], B[k + Ne | 0] = m[T + 32 | 0], B[(T = 1 | k) + M | 0] = m[E + T | 0], B[T + Ne | 0] = m[E + (33 | k) | 0], (0 | (k = k + 2 | 0)) != 32; ) ;
                          _s(E, 64), gr = 0;
                        }
                        return dr = pr, 0 | gr;
                      }
                      Wa(), ji();
                    }, xd: Js, yd: Js, zd: Js, Ad: Js, Bd: function() {
                      return 1332;
                    }, Cd: Fh, Dd: Ra, Ed: Js, Fd: Cl, Gd: Su, Hd: function(k, E) {
                      return 0 | ac(k |= 0, E |= 0);
                    }, Id: kl, Jd: function(k, E) {
                      return 0 | fc(k |= 0, E |= 0);
                    }, Kd: function() {
                      return 1494;
                    }, Ld: cf, Md: Cl, Nd: Su, Od: ac, Pd: kl, Qd: fc, Rd: Ra, Sd: Js, Td: Fh, Ud: cf, Vd: ru, Wd: Ra, Xd: D2, Yd: Yf, Zd: D2, _d: Ra, $d: oh, ae: function() {
                      return 1554;
                    }, be: ah, ce: D2, de: Qh, ee: Uh, fe: qh, ge: eh, he: function() {
                      return 6;
                    }, ie: function() {
                      return 134217728;
                    }, je: $f, ke: function() {
                      return 536870912;
                    }, le: function(k, E, T, M, ye, Ne, pr, ve, cr, gr, Pr) {
                      return 0 | Vi(k |= 0, (k = 0) | (E |= 0), T |= 0, M |= 0, k | (ye |= 0), Ne |= 0, pr |= 0, k | (ve |= 0), cr |= 0, gr |= 0, Pr |= 0);
                    }, me: function(k, E, T, M, ye, Ne, pr) {
                      return 0 | il(k |= 0, E |= 0, (k = 0) | (T |= 0), M |= 0, k | (ye |= 0), Ne |= 0, pr |= 0);
                    }, ne: function(k, E, T, M) {
                      return 0 | wA(k |= 0, E |= 0, T |= 0, M |= 0);
                    }, oe: function(k, E, T, M) {
                      return 0 | Ml(k |= 0, E |= 0, T |= 0, M |= 0);
                    }, pe: function(k, E, T, M) {
                      return 0 | Sa(k |= 0, E |= 0, T |= 0, M |= 0);
                    }, qe: Bc, re: Ra, se: D2, te: Yf, ue: D2, ve: Ra, we: oh, xe: Fl, ye: ru, ze: D2, Ae: Qh, Be: Uh, Ce: Bc, De: Ul, Ee: ah, Fe: PA, Ge: qh, He: uu, Ie: function(k, E, T, M, ye, Ne, pr, ve, cr, gr, Pr) {
                      return 0 | Pn(k |= 0, (k = 0) | (E |= 0), T |= 0, M |= 0, k | (ye |= 0), Ne |= 0, pr |= 0, k | (ve |= 0), cr |= 0, gr |= 0, Pr |= 0);
                    }, Je: xh, Ke: function(k, E, T, M) {
                      return 0 | Nl(k |= 0, E |= 0, T |= 0, M |= 0);
                    }, Le: ru, Me: Bc, Ne: Bc, Oe: Ra, Pe: D2, Qe: Yf, Re: D2, Se: Ra, Te: oh, Ue: Fl, Ve: ru, We: D2, Xe: Qh, Ye: Uh, Ze: Bc, _e: Ul, $e: ah, af: PA, bf: qh, cf: uu, df: function(k, E, T, M, ye, Ne, pr, ve, cr, gr, Pr) {
                      k |= 0, E |= 0, T |= 0, M |= 0, ye |= 0, Ne |= 0, pr |= 0, ve |= 0, cr |= 0, gr |= 0, E |= 0, ye |= 0, ve |= 0;
                      e: {
                        switch ((Pr |= 0) - 1 | 0) {
                          case 0:
                            k = Vi(k, E, T, M, ye, Ne, pr, ve, cr, gr, 1);
                            break e;
                          case 1:
                            k = Pn(k, E, T, M, ye, Ne, pr, ve, cr, gr, 2);
                            break e;
                        }
                        o[9404] = 28, k = -1;
                      }
                      return 0 | k;
                    }, ef: xh, ff: function(k, E, T, M, ye, Ne, pr, ve) {
                      k |= 0, E |= 0, T |= 0, M |= 0, ye |= 0, Ne |= 0, pr |= 0, T |= 0, ye |= 0;
                      e: {
                        switch ((ve |= 0) - 1 | 0) {
                          case 1:
                            k = nl(k, E, T, M, ye, Ne, pr);
                            break e;
                          default:
                            Wa(), ji();
                          case 0:
                        }
                        k = il(k, E, T, M, ye, Ne, pr);
                      }
                      return 0 | k;
                    }, gf: function(k, E, T, M) {
                      return E |= 0, T |= 0, M |= 0, Jc(k |= 0, 1564, 10) ? Jc(k, 1554, 9) ? (o[9404] = 28, k = -1) : k = wA(k, E, T, M) : k = Nl(k, E, T, M), 0 | k;
                    }, hf: function(k, E, T, M) {
                      return E |= 0, T |= 0, M |= 0, Jc(k |= 0, 1564, 10) ? Jc(k, 1554, 9) ? (o[9404] = 28, k = -1) : k = Ml(k, E, T, M) : k = Sa(k, E, T, M), 0 | k;
                    }, jf: function() {
                      return 1156;
                    }, kf: function() {
                      return 1443;
                    }, lf: Oh, mf: Mh, nf: Js, of: Js, pf: Gf, qf: lA, rf: Js, sf: Js, tf: Js, uf: rc, vf: Js, wf: Ra, xf: Ra, yf: wc, zf: function() {
                      return 1486;
                    }, Af: zu, Bf: Xu, Cf: cf, Df: ml, Ef: function(k, E, T, M, ye, Ne) {
                      return k |= 0, E |= 0, ye |= 0, Ne |= 0, !(M |= 0) & (T |= 0) >>> 0 >= 4294967280 | M && (Wa(), ji()), Bi(k + 16 | 0, k, E, T, M, ye, Ne), 0;
                    }, Ff: vl, Gf: $u, Hf: zu, If: Xu, Jf: Js, Kf: rc, Lf: Js, Mf: Ra, Nf: Ra, Of: wc, Pf: cf, Qf: cf, Rf: function(k, E, T) {
                      return k |= 0, T |= 0, Sf(E |= 0, 24), ba(k, E, T, 0), B[k + 32 | 0] = 1, B[k + 33 | 0] = 0, B[k + 34 | 0] = 0, B[k + 35 | 0] = 0, T = m[E + 16 | 0] | m[E + 17 | 0] << 8 | m[E + 18 | 0] << 16 | m[E + 19 | 0] << 24, E = m[E + 20 | 0] | m[E + 21 | 0] << 8 | m[E + 22 | 0] << 16 | m[E + 23 | 0] << 24, B[k + 44 | 0] = 0, B[k + 45 | 0] = 0, B[k + 46 | 0] = 0, B[k + 47 | 0] = 0, B[k + 48 | 0] = 0, B[k + 49 | 0] = 0, B[k + 50 | 0] = 0, B[k + 51 | 0] = 0, B[k + 36 | 0] = T, B[k + 37 | 0] = T >>> 8, B[k + 38 | 0] = T >>> 16, B[k + 39 | 0] = T >>> 24, B[k + 40 | 0] = E, B[k + 41 | 0] = E >>> 8, B[k + 42 | 0] = E >>> 16, B[k + 43 | 0] = E >>> 24, 0;
                    }, Sf: function(k, E, T) {
                      return ba(k |= 0, E |= 0, T |= 0, 0), B[k + 32 | 0] = 1, B[k + 33 | 0] = 0, B[k + 34 | 0] = 0, B[k + 35 | 0] = 0, T = m[E + 16 | 0] | m[E + 17 | 0] << 8 | m[E + 18 | 0] << 16 | m[E + 19 | 0] << 24, E = m[E + 20 | 0] | m[E + 21 | 0] << 8 | m[E + 22 | 0] << 16 | m[E + 23 | 0] << 24, B[k + 44 | 0] = 0, B[k + 45 | 0] = 0, B[k + 46 | 0] = 0, B[k + 47 | 0] = 0, B[k + 48 | 0] = 0, B[k + 49 | 0] = 0, B[k + 50 | 0] = 0, B[k + 51 | 0] = 0, B[k + 36 | 0] = T, B[k + 37 | 0] = T >>> 8, B[k + 38 | 0] = T >>> 16, B[k + 39 | 0] = T >>> 24, B[k + 40 | 0] = E, B[k + 41 | 0] = E >>> 8, B[k + 42 | 0] = E >>> 16, B[k + 43 | 0] = E >>> 24, 0;
                    }, Tf: function(k) {
                      var E, T = 0, M = 0;
                      dr = E = dr - 48 | 0, T = m[28 + (k |= 0) | 0] | m[k + 29 | 0] << 8 | m[k + 30 | 0] << 16 | m[k + 31 | 0] << 24, o[E + 24 >> 2] = m[k + 24 | 0] | m[k + 25 | 0] << 8 | m[k + 26 | 0] << 16 | m[k + 27 | 0] << 24, o[E + 28 >> 2] = T, T = m[k + 20 | 0] | m[k + 21 | 0] << 8 | m[k + 22 | 0] << 16 | m[k + 23 | 0] << 24, o[E + 16 >> 2] = m[k + 16 | 0] | m[k + 17 | 0] << 8 | m[k + 18 | 0] << 16 | m[k + 19 | 0] << 24, o[E + 20 >> 2] = T, T = m[k + 4 | 0] | m[k + 5 | 0] << 8 | m[k + 6 | 0] << 16 | m[k + 7 | 0] << 24, o[E >> 2] = m[0 | k] | m[k + 1 | 0] << 8 | m[k + 2 | 0] << 16 | m[k + 3 | 0] << 24, o[E + 4 >> 2] = T, T = m[k + 12 | 0] | m[k + 13 | 0] << 8 | m[k + 14 | 0] << 16 | m[k + 15 | 0] << 24, o[E + 8 >> 2] = m[k + 8 | 0] | m[k + 9 | 0] << 8 | m[k + 10 | 0] << 16 | m[k + 11 | 0] << 24, o[E + 12 >> 2] = T, T = m[k + 40 | 0] | m[k + 41 | 0] << 8 | m[k + 42 | 0] << 16 | m[k + 43 | 0] << 24, o[E + 32 >> 2] = m[k + 36 | 0] | m[k + 37 | 0] << 8 | m[k + 38 | 0] << 16 | m[k + 39 | 0] << 24, o[E + 36 >> 2] = T, Wu(E, E, 40, 0, k + 32 | 0, k), T = o[E + 28 >> 2], M = o[E + 24 >> 2], B[k + 24 | 0] = M, B[k + 25 | 0] = M >>> 8, B[k + 26 | 0] = M >>> 16, B[k + 27 | 0] = M >>> 24, B[k + 28 | 0] = T, B[k + 29 | 0] = T >>> 8, B[k + 30 | 0] = T >>> 16, B[k + 31 | 0] = T >>> 24, T = o[E + 20 >> 2], M = o[E + 16 >> 2], B[k + 16 | 0] = M, B[k + 17 | 0] = M >>> 8, B[k + 18 | 0] = M >>> 16, B[k + 19 | 0] = M >>> 24, B[k + 20 | 0] = T, B[k + 21 | 0] = T >>> 8, B[k + 22 | 0] = T >>> 16, B[k + 23 | 0] = T >>> 24, T = o[E + 12 >> 2], M = o[E + 8 >> 2], B[k + 8 | 0] = M, B[k + 9 | 0] = M >>> 8, B[k + 10 | 0] = M >>> 16, B[k + 11 | 0] = M >>> 24, B[k + 12 | 0] = T, B[k + 13 | 0] = T >>> 8, B[k + 14 | 0] = T >>> 16, B[k + 15 | 0] = T >>> 24, T = o[E + 4 >> 2], M = o[E >> 2], B[0 | k] = M, B[k + 1 | 0] = M >>> 8, B[k + 2 | 0] = M >>> 16, B[k + 3 | 0] = M >>> 24, B[k + 4 | 0] = T, B[k + 5 | 0] = T >>> 8, B[k + 6 | 0] = T >>> 16, B[k + 7 | 0] = T >>> 24, M = o[E + 36 >> 2], T = o[E + 32 >> 2], B[k + 32 | 0] = 1, B[k + 33 | 0] = 0, B[k + 34 | 0] = 0, B[k + 35 | 0] = 0, B[k + 36 | 0] = T, B[k + 37 | 0] = T >>> 8, B[k + 38 | 0] = T >>> 16, B[k + 39 | 0] = T >>> 24, B[k + 40 | 0] = M, B[k + 41 | 0] = M >>> 8, B[k + 42 | 0] = M >>> 16, B[k + 43 | 0] = M >>> 24, dr = E + 48 | 0;
                    }, Uf: function(k, E, T, M, ye, Ne, pr, ve, cr, gr) {
                      k |= 0, E |= 0, M |= 0, Ne |= 0, pr |= 0, cr |= 0, gr |= 0;
                      var Pr, Nr = 0, Br = 0, Mr = 0;
                      return Nr = ye |= 0, Nr |= ye = 0, Pr = ye | (ve |= 0), dr = ye = dr - 384 | 0, (T |= 0) && (o[T >> 2] = 0, o[T + 4 >> 2] = 0), !Ne & Nr >>> 0 < 4294967279 ? (Lc(Br = ye + 16 | 0, 64, 0, Mr = k + 32 | 0, k), ac(ve = ye + 80 | 0, Br), _s(Br, 64), Da(ve, pr, Pr, cr), Da(ve, 35216, 0 - Pr & 15, 0), o[ye + 72 >> 2] = 0, o[ye + 76 >> 2] = 0, o[(pr = ye - -64 | 0) >> 2] = 0, o[pr + 4 >> 2] = 0, o[ye + 56 >> 2] = 0, o[ye + 60 >> 2] = 0, o[ye + 48 >> 2] = 0, o[ye + 52 >> 2] = 0, o[ye + 40 >> 2] = 0, o[ye + 44 >> 2] = 0, o[ye + 32 >> 2] = 0, o[ye + 36 >> 2] = 0, o[ye + 16 >> 2] = 0, o[ye + 20 >> 2] = 0, o[ye + 24 >> 2] = 0, o[ye + 28 >> 2] = 0, B[ye + 16 | 0] = gr, zc(Br, Br, 64, 0, Mr, 1, k), Da(ve, Br, 64, 0), B[0 | E] = m[ye + 16 | 0], zc(E = E + 1 | 0, M, Nr, Ne, Mr, 2, k), Da(ve, E, Nr, Ne), Da(ve, 35216, 15 & Nr, 0), o[ye + 8 >> 2] = Pr, o[ye + 12 >> 2] = cr, Da(ve, M = ye + 8 | 0, 8, 0), o[ye + 8 >> 2] = Nr - -64, o[ye + 12 >> 2] = Ne - ((Nr >>> 0 < 4294967232) - 1 | 0), Da(ve, M, 8, 0), fc(ve, E = E + Nr | 0), _s(ve, 256), B[k + 36 | 0] = m[k + 36 | 0] ^ m[0 | E], B[k + 37 | 0] = m[k + 37 | 0] ^ m[E + 1 | 0], B[k + 38 | 0] = m[k + 38 | 0] ^ m[E + 2 | 0], B[k + 39 | 0] = m[k + 39 | 0] ^ m[E + 3 | 0], B[k + 40 | 0] = m[k + 40 | 0] ^ m[E + 4 | 0], B[k + 41 | 0] = m[k + 41 | 0] ^ m[E + 5 | 0], B[k + 42 | 0] = m[k + 42 | 0] ^ m[E + 6 | 0], B[k + 43 | 0] = m[k + 43 | 0] ^ m[E + 7 | 0], Eu(Mr), (2 & gr || pa(Mr, 4)) && (E = m[k + 28 | 0] | m[k + 29 | 0] << 8 | m[k + 30 | 0] << 16 | m[k + 31 | 0] << 24, o[ye + 360 >> 2] = m[k + 24 | 0] | m[k + 25 | 0] << 8 | m[k + 26 | 0] << 16 | m[k + 27 | 0] << 24, o[ye + 364 >> 2] = E, E = m[k + 20 | 0] | m[k + 21 | 0] << 8 | m[k + 22 | 0] << 16 | m[k + 23 | 0] << 24, o[ye + 352 >> 2] = m[k + 16 | 0] | m[k + 17 | 0] << 8 | m[k + 18 | 0] << 16 | m[k + 19 | 0] << 24, o[ye + 356 >> 2] = E, E = m[k + 4 | 0] | m[k + 5 | 0] << 8 | m[k + 6 | 0] << 16 | m[k + 7 | 0] << 24, o[ye + 336 >> 2] = m[0 | k] | m[k + 1 | 0] << 8 | m[k + 2 | 0] << 16 | m[k + 3 | 0] << 24, o[ye + 340 >> 2] = E, E = m[k + 12 | 0] | m[k + 13 | 0] << 8 | m[k + 14 | 0] << 16 | m[k + 15 | 0] << 24, o[ye + 344 >> 2] = m[k + 8 | 0] | m[k + 9 | 0] << 8 | m[k + 10 | 0] << 16 | m[k + 11 | 0] << 24, o[ye + 348 >> 2] = E, E = m[k + 40 | 0] | m[k + 41 | 0] << 8 | m[k + 42 | 0] << 16 | m[k + 43 | 0] << 24, o[ye + 368 >> 2] = m[k + 36 | 0] | m[k + 37 | 0] << 8 | m[k + 38 | 0] << 16 | m[k + 39 | 0] << 24, o[ye + 372 >> 2] = E, Wu(E = ye + 336 | 0, E, 40, 0, Mr, k), E = o[ye + 364 >> 2], M = o[ye + 360 >> 2], B[k + 24 | 0] = M, B[k + 25 | 0] = M >>> 8, B[k + 26 | 0] = M >>> 16, B[k + 27 | 0] = M >>> 24, B[k + 28 | 0] = E, B[k + 29 | 0] = E >>> 8, B[k + 30 | 0] = E >>> 16, B[k + 31 | 0] = E >>> 24, E = o[ye + 356 >> 2], M = o[ye + 352 >> 2], B[k + 16 | 0] = M, B[k + 17 | 0] = M >>> 8, B[k + 18 | 0] = M >>> 16, B[k + 19 | 0] = M >>> 24, B[k + 20 | 0] = E, B[k + 21 | 0] = E >>> 8, B[k + 22 | 0] = E >>> 16, B[k + 23 | 0] = E >>> 24, E = o[ye + 348 >> 2], M = o[ye + 344 >> 2], B[k + 8 | 0] = M, B[k + 9 | 0] = M >>> 8, B[k + 10 | 0] = M >>> 16, B[k + 11 | 0] = M >>> 24, B[k + 12 | 0] = E, B[k + 13 | 0] = E >>> 8, B[k + 14 | 0] = E >>> 16, B[k + 15 | 0] = E >>> 24, E = o[ye + 340 >> 2], M = o[ye + 336 >> 2], B[0 | k] = M, B[k + 1 | 0] = M >>> 8, B[k + 2 | 0] = M >>> 16, B[k + 3 | 0] = M >>> 24, B[k + 4 | 0] = E, B[k + 5 | 0] = E >>> 8, B[k + 6 | 0] = E >>> 16, B[k + 7 | 0] = E >>> 24, E = o[ye + 368 >> 2], M = o[ye + 372 >> 2], B[k + 32 | 0] = 1, B[k + 33 | 0] = 0, B[k + 34 | 0] = 0, B[k + 35 | 0] = 0, B[k + 36 | 0] = E, B[k + 37 | 0] = E >>> 8, B[k + 38 | 0] = E >>> 16, B[k + 39 | 0] = E >>> 24, B[k + 40 | 0] = M, B[k + 41 | 0] = M >>> 8, B[k + 42 | 0] = M >>> 16, B[k + 43 | 0] = M >>> 24), T && (Ne = (k = Nr + 17 | 0) >>> 0 < 17 ? Ne + 1 | 0 : Ne, o[T >> 2] = k, o[T + 4 >> 2] = Ne), dr = ye + 384 | 0) : (Wa(), ji()), 0;
                    }, Vf: function(k, E, T, M, ye, Ne, pr, ve, cr, gr) {
                      k |= 0, E |= 0, M |= 0, ye |= 0, ve |= 0, gr |= 0;
                      var Pr, Nr = 0, Br = 0, Mr = 0, jr = 0, ti = 0, fi = 0;
                      Nr = Ne |= 0, Ne = pr |= 0, Br = 0 | Nr, Pr = cr |= 0, dr = pr = dr - 400 | 0, (T |= 0) && (o[T >> 2] = 0, o[T + 4 >> 2] = 0), M && (B[0 | M] = 255), fi = -1;
                      e: {
                        t: {
                          if (!((cr = Br >>> 0 < 17) & !Ne)) {
                            if (ti = Nr = Ne - cr | 0, !Nr & (cr = Br - 17 | 0) >>> 0 >= 4294967279 | Nr) break t;
                            Lc(Mr = pr + 32 | 0, 64, 0, jr = k + 32 | 0, k), ac(Nr = pr + 96 | 0, Mr), _s(Mr, 64), Da(Nr, ve, Pr, gr), Da(Nr, 35216, 0 - Pr & 15, 0), o[pr + 88 >> 2] = 0, o[pr + 92 >> 2] = 0, o[pr + 80 >> 2] = 0, o[pr + 84 >> 2] = 0, o[pr + 72 >> 2] = 0, o[pr + 76 >> 2] = 0, o[(ve = pr - -64 | 0) >> 2] = 0, o[ve + 4 >> 2] = 0, o[pr + 56 >> 2] = 0, o[pr + 60 >> 2] = 0, o[pr + 48 >> 2] = 0, o[pr + 52 >> 2] = 0, o[pr + 40 >> 2] = 0, o[pr + 44 >> 2] = 0, o[pr + 32 >> 2] = 0, o[pr + 36 >> 2] = 0, B[pr + 32 | 0] = m[0 | ye], zc(Mr, Mr, 64, 0, jr, 1, k), ve = m[pr + 32 | 0], B[pr + 32 | 0] = m[0 | ye], Da(Nr, Mr, 64, 0), Da(Nr, ye = ye + 1 | 0, cr, ti), Da(Nr, 35216, Br - 1 & 15, 0), o[pr + 24 >> 2] = Pr, o[pr + 28 >> 2] = gr, Da(Nr, gr = pr + 24 | 0, 8, 0), Ne = (Br = Br + 47 | 0) >>> 0 < 47 ? Ne + 1 | 0 : Ne, o[pr + 24 >> 2] = Br, o[pr + 28 >> 2] = Ne, Da(Nr, gr, 8, 0), fc(Nr, pr), _s(Nr, 256), bi(pr, ye + cr | 0, 16) ? _s(pr, 16) : (zc(E, ye, cr, ti, jr, 2, k), B[k + 36 | 0] = m[k + 36 | 0] ^ m[0 | pr], B[k + 37 | 0] = m[k + 37 | 0] ^ m[pr + 1 | 0], B[k + 38 | 0] = m[k + 38 | 0] ^ m[pr + 2 | 0], B[k + 39 | 0] = m[k + 39 | 0] ^ m[pr + 3 | 0], B[k + 40 | 0] = m[k + 40 | 0] ^ m[pr + 4 | 0], B[k + 41 | 0] = m[k + 41 | 0] ^ m[pr + 5 | 0], B[k + 42 | 0] = m[k + 42 | 0] ^ m[pr + 6 | 0], B[k + 43 | 0] = m[k + 43 | 0] ^ m[pr + 7 | 0], Eu(jr), (2 & ve || pa(jr, 4)) && (E = m[k + 28 | 0] | m[k + 29 | 0] << 8 | m[k + 30 | 0] << 16 | m[k + 31 | 0] << 24, o[pr + 376 >> 2] = m[k + 24 | 0] | m[k + 25 | 0] << 8 | m[k + 26 | 0] << 16 | m[k + 27 | 0] << 24, o[pr + 380 >> 2] = E, E = m[k + 20 | 0] | m[k + 21 | 0] << 8 | m[k + 22 | 0] << 16 | m[k + 23 | 0] << 24, o[pr + 368 >> 2] = m[k + 16 | 0] | m[k + 17 | 0] << 8 | m[k + 18 | 0] << 16 | m[k + 19 | 0] << 24, o[pr + 372 >> 2] = E, E = m[k + 4 | 0] | m[k + 5 | 0] << 8 | m[k + 6 | 0] << 16 | m[k + 7 | 0] << 24, o[pr + 352 >> 2] = m[0 | k] | m[k + 1 | 0] << 8 | m[k + 2 | 0] << 16 | m[k + 3 | 0] << 24, o[pr + 356 >> 2] = E, E = m[k + 12 | 0] | m[k + 13 | 0] << 8 | m[k + 14 | 0] << 16 | m[k + 15 | 0] << 24, o[pr + 360 >> 2] = m[k + 8 | 0] | m[k + 9 | 0] << 8 | m[k + 10 | 0] << 16 | m[k + 11 | 0] << 24, o[pr + 364 >> 2] = E, E = m[k + 40 | 0] | m[k + 41 | 0] << 8 | m[k + 42 | 0] << 16 | m[k + 43 | 0] << 24, o[pr + 384 >> 2] = m[k + 36 | 0] | m[k + 37 | 0] << 8 | m[k + 38 | 0] << 16 | m[k + 39 | 0] << 24, o[pr + 388 >> 2] = E, Wu(E = pr + 352 | 0, E, 40, 0, jr, k), E = o[pr + 380 >> 2], ye = o[pr + 376 >> 2], B[k + 24 | 0] = ye, B[k + 25 | 0] = ye >>> 8, B[k + 26 | 0] = ye >>> 16, B[k + 27 | 0] = ye >>> 24, B[k + 28 | 0] = E, B[k + 29 | 0] = E >>> 8, B[k + 30 | 0] = E >>> 16, B[k + 31 | 0] = E >>> 24, E = o[pr + 372 >> 2], ye = o[pr + 368 >> 2], B[k + 16 | 0] = ye, B[k + 17 | 0] = ye >>> 8, B[k + 18 | 0] = ye >>> 16, B[k + 19 | 0] = ye >>> 24, B[k + 20 | 0] = E, B[k + 21 | 0] = E >>> 8, B[k + 22 | 0] = E >>> 16, B[k + 23 | 0] = E >>> 24, E = o[pr + 364 >> 2], ye = o[pr + 360 >> 2], B[k + 8 | 0] = ye, B[k + 9 | 0] = ye >>> 8, B[k + 10 | 0] = ye >>> 16, B[k + 11 | 0] = ye >>> 24, B[k + 12 | 0] = E, B[k + 13 | 0] = E >>> 8, B[k + 14 | 0] = E >>> 16, B[k + 15 | 0] = E >>> 24, E = o[pr + 356 >> 2], ye = o[pr + 352 >> 2], B[0 | k] = ye, B[k + 1 | 0] = ye >>> 8, B[k + 2 | 0] = ye >>> 16, B[k + 3 | 0] = ye >>> 24, B[k + 4 | 0] = E, B[k + 5 | 0] = E >>> 8, B[k + 6 | 0] = E >>> 16, B[k + 7 | 0] = E >>> 24, E = o[pr + 384 >> 2], ye = o[pr + 388 >> 2], B[k + 32 | 0] = 1, B[k + 33 | 0] = 0, B[k + 34 | 0] = 0, B[k + 35 | 0] = 0, B[k + 36 | 0] = E, B[k + 37 | 0] = E >>> 8, B[k + 38 | 0] = E >>> 16, B[k + 39 | 0] = E >>> 24, B[k + 40 | 0] = ye, B[k + 41 | 0] = ye >>> 8, B[k + 42 | 0] = ye >>> 16, B[k + 43 | 0] = ye >>> 24), T && (o[T >> 2] = cr, o[T + 4 >> 2] = ti), fi = 0, M && (B[0 | M] = ve));
                          }
                          dr = pr + 400 | 0;
                          break e;
                        }
                        Wa(), ji();
                      }
                      return 0 | fi;
                    }, Wf: function() {
                      return 52;
                    }, Xf: function() {
                      return 17;
                    }, Yf: rc, Zf: Js, _f: function() {
                      return -18;
                    }, $f: Yf, ag: ru, bg: Bc, cg: ah, dg: $f, eg: Ra, fg: function() {
                      return 1521;
                    }, gg: ts, hg: Pu, ig: $f, jg: Ra, kg: ts, lg: Mu, mg: pf, ng: Js, og: Js, pg: pf, qg: Fa, rg: function() {
                      return 1454;
                    }, sg: function(k, E, T) {
                      return 0 | N2(k |= 0, E |= 0, T |= 0);
                    }, tg: function(k, E) {
                      return 0 | gi(k |= 0, E |= 0);
                    }, ug: el, vg: Wh, wg: Il, xg: bl, yg: function(k) {
                      return 0 | Ol(k |= 0);
                    }, zg: Xc, Ag: function(k, E, T, M) {
                      return 0 | pl(k |= 0, E |= 0, T |= 0, M |= 0);
                    }, Bg: function(k, E, T) {
                      return 0 | gl(k |= 0, E |= 0, T |= 0);
                    }, Cg: Mu, Dg: pf, Eg: Js, Fg: Js, Gg: pf, Hg: Fa, Ig: function(k, E) {
                      k |= 0;
                      var T, M, ye, Ne, pr, ve, cr = 0;
                      return T = m[8 + (cr = E |= 0) | 0] | m[cr + 9 | 0] << 8 | m[cr + 10 | 0] << 16 | m[cr + 11 | 0] << 24, M = m[cr + 12 | 0] | m[cr + 13 | 0] << 8 | m[cr + 14 | 0] << 16 | m[cr + 15 | 0] << 24, ye = m[cr + 16 | 0] | m[cr + 17 | 0] << 8 | m[cr + 18 | 0] << 16 | m[cr + 19 | 0] << 24, Ne = m[cr + 20 | 0] | m[cr + 21 | 0] << 8 | m[cr + 22 | 0] << 16 | m[cr + 23 | 0] << 24, pr = m[0 | cr] | m[cr + 1 | 0] << 8 | m[cr + 2 | 0] << 16 | m[cr + 3 | 0] << 24, E = m[cr + 4 | 0] | m[cr + 5 | 0] << 8 | m[cr + 6 | 0] << 16 | m[cr + 7 | 0] << 24, ve = m[cr + 28 | 0] | m[cr + 29 | 0] << 8 | m[cr + 30 | 0] << 16 | m[cr + 31 | 0] << 24, cr = m[cr + 24 | 0] | m[cr + 25 | 0] << 8 | m[cr + 26 | 0] << 16 | m[cr + 27 | 0] << 24, B[k + 24 | 0] = cr, B[k + 25 | 0] = cr >>> 8, B[k + 26 | 0] = cr >>> 16, B[k + 27 | 0] = cr >>> 24, B[k + 28 | 0] = ve, B[k + 29 | 0] = ve >>> 8, B[k + 30 | 0] = ve >>> 16, B[k + 31 | 0] = ve >>> 24, B[k + 16 | 0] = ye, B[k + 17 | 0] = ye >>> 8, B[k + 18 | 0] = ye >>> 16, B[k + 19 | 0] = ye >>> 24, B[k + 20 | 0] = Ne, B[k + 21 | 0] = Ne >>> 8, B[k + 22 | 0] = Ne >>> 16, B[k + 23 | 0] = Ne >>> 24, B[k + 8 | 0] = T, B[k + 9 | 0] = T >>> 8, B[k + 10 | 0] = T >>> 16, B[k + 11 | 0] = T >>> 24, B[k + 12 | 0] = M, B[k + 13 | 0] = M >>> 8, B[k + 14 | 0] = M >>> 16, B[k + 15 | 0] = M >>> 24, B[0 | k] = pr, B[k + 1 | 0] = pr >>> 8, B[k + 2 | 0] = pr >>> 16, B[k + 3 | 0] = pr >>> 24, B[k + 4 | 0] = E, B[k + 5 | 0] = E >>> 8, B[k + 6 | 0] = E >>> 16, B[k + 7 | 0] = E >>> 24, 0;
                    }, Jg: function(k, E) {
                      k |= 0;
                      var T, M, ye, Ne, pr, ve, cr = 0;
                      return T = m[32 + (cr = E |= 0) | 0] | m[cr + 33 | 0] << 8 | m[cr + 34 | 0] << 16 | m[cr + 35 | 0] << 24, M = m[cr + 36 | 0] | m[cr + 37 | 0] << 8 | m[cr + 38 | 0] << 16 | m[cr + 39 | 0] << 24, ye = m[cr + 40 | 0] | m[cr + 41 | 0] << 8 | m[cr + 42 | 0] << 16 | m[cr + 43 | 0] << 24, Ne = m[cr + 44 | 0] | m[cr + 45 | 0] << 8 | m[cr + 46 | 0] << 16 | m[cr + 47 | 0] << 24, pr = m[cr + 48 | 0] | m[cr + 49 | 0] << 8 | m[cr + 50 | 0] << 16 | m[cr + 51 | 0] << 24, E = m[cr + 52 | 0] | m[cr + 53 | 0] << 8 | m[cr + 54 | 0] << 16 | m[cr + 55 | 0] << 24, ve = m[cr + 60 | 0] | m[cr + 61 | 0] << 8 | m[cr + 62 | 0] << 16 | m[cr + 63 | 0] << 24, cr = m[cr + 56 | 0] | m[cr + 57 | 0] << 8 | m[cr + 58 | 0] << 16 | m[cr + 59 | 0] << 24, B[k + 24 | 0] = cr, B[k + 25 | 0] = cr >>> 8, B[k + 26 | 0] = cr >>> 16, B[k + 27 | 0] = cr >>> 24, B[k + 28 | 0] = ve, B[k + 29 | 0] = ve >>> 8, B[k + 30 | 0] = ve >>> 16, B[k + 31 | 0] = ve >>> 24, B[k + 16 | 0] = pr, B[k + 17 | 0] = pr >>> 8, B[k + 18 | 0] = pr >>> 16, B[k + 19 | 0] = pr >>> 24, B[k + 20 | 0] = E, B[k + 21 | 0] = E >>> 8, B[k + 22 | 0] = E >>> 16, B[k + 23 | 0] = E >>> 24, B[k + 8 | 0] = ye, B[k + 9 | 0] = ye >>> 8, B[k + 10 | 0] = ye >>> 16, B[k + 11 | 0] = ye >>> 24, B[k + 12 | 0] = Ne, B[k + 13 | 0] = Ne >>> 8, B[k + 14 | 0] = Ne >>> 16, B[k + 15 | 0] = Ne >>> 24, B[0 | k] = T, B[k + 1 | 0] = T >>> 8, B[k + 2 | 0] = T >>> 16, B[k + 3 | 0] = T >>> 24, B[k + 4 | 0] = M, B[k + 5 | 0] = M >>> 8, B[k + 6 | 0] = M >>> 16, B[k + 7 | 0] = M >>> 24, 0;
                    }, Kg: Ol, Lg: Xc, Mg: pl, Ng: gl, Og: N2, Pg: gi, Qg: function(k, E) {
                      k |= 0;
                      var T, M = 0, ye = 0, Ne = 0, pr = 0, ve = 0, cr = 0, gr = 0, Pr = 0, Nr = 0, Br = 0, Mr = 0, jr = 0, ti = 0, fi = 0, Jr = 0, li = 0, Tr = 0, Mi = 0, Wi = 0, vn = 0, Tn = 0, Ni = 0, Yi = 0, Xi = 0, $n = 0, Zn = 0, to = 0, fo = 0, wo = 0, bo = 0, go = 0, qn = 0, io = 0, So = 0, qo = 0, Ln = 0, ro = 0, Qo = 0, Vo = 0, as = 0, cs = 0, ms = 0, ai = 0, ci = 0, Fi = 0, Eo = 0, is = 0, ws = 0, ys = 0, Is = 0, ks = 0, Ps = 0, Po = 0, fn = 0, Qn = 0, zn = 0, es = 0, us = 0, Cs = 0, Es = 0, Rs = 0, Ds = 0, Ns = 0, Fs = 0, Qs = 0, Ys = 0, Vs = 0, Hs = 0, ra = 0, ca = 0, ua = 0, la = 0, ma = 0, Ba = 0, Ea = 0, _a = 0, xa = 0, Ka = 0, nf = 0, of = 0;
                      return dr = T = dr - 256 | 0, la = -1, Ia(E |= 0) || mf(M = T + 96 | 0, E) || Bs(M) && (la = 0, qn = o[T + 172 >> 2], o[T + 36 >> 2] = 0 - qn, li = o[T + 168 >> 2], o[T + 32 >> 2] = 0 - li, io = o[T + 164 >> 2], o[T + 28 >> 2] = 0 - io, Tr = o[T + 160 >> 2], o[T + 24 >> 2] = 0 - Tr, So = o[T + 156 >> 2], o[T + 20 >> 2] = 0 - So, Mi = o[T + 152 >> 2], o[T + 16 >> 2] = 0 - Mi, qo = o[T + 148 >> 2], o[T + 12 >> 2] = 0 - qo, Wi = o[T + 144 >> 2], o[T + 8 >> 2] = 0 - Wi, Ln = o[T + 140 >> 2], o[T + 4 >> 2] = 0 - Ln, Ne = o[T + 136 >> 2], o[T >> 2] = 1 - Ne, ia(T, T), E = Zr(vn = o[T + 4 >> 2], wo = vn >> 31, Tn = So << 1, ys = Tn >> 31), M = Qe, ye = Zr(fi = o[T >> 2], Ni = fi >> 31, Tr, Yi = Tr >> 31), M = Qe + M | 0, M = (E = ye + E | 0) >>> 0 < ye >>> 0 ? M + 1 | 0 : M, ye = (pr = Zr(Xi = o[T + 8 >> 2], ro = Xi >> 31, Mi, $n = Mi >> 31)) + E | 0, E = Qe + M | 0, E = ye >>> 0 < pr >>> 0 ? E + 1 | 0 : E, M = ye, ye = Zr(bo = o[T + 12 >> 2], as = bo >> 31, ai = qo << 1, Is = ai >> 31), E = Qe + E | 0, E = (M = M + ye | 0) >>> 0 < ye >>> 0 ? E + 1 | 0 : E, ye = Zr(Qo = o[T + 16 >> 2], ci = Qo >> 31, Wi, Zn = Wi >> 31), E = Qe + E | 0, E = (M = ye + M | 0) >>> 0 < ye >>> 0 ? E + 1 | 0 : E, Ys = pr = o[T + 20 >> 2], jr = Zr(pr, ks = pr >> 31, Fi = Ln << 1, Ps = Fi >> 31), ye = Qe + E | 0, ye = (M = jr + M | 0) >>> 0 < jr >>> 0 ? ye + 1 | 0 : ye, Vs = Nr = o[T + 24 >> 2], E = (Ne = Zr(Nr, Ns = Nr >> 31, jr = Ne + 1 | 0, to = jr >> 31)) + M | 0, M = Qe + ye | 0, M = E >>> 0 < Ne >>> 0 ? M + 1 | 0 : M, Po = o[T + 28 >> 2], ye = (Ne = Zr(Jr = v(Po, 19), cs = Jr >> 31, Eo = qn << 1, fn = Eo >> 31)) + E | 0, E = Qe + M | 0, E = ye >>> 0 < Ne >>> 0 ? E + 1 | 0 : E, M = ye, ma = o[T + 32 >> 2], ye = Zr(cr = v(ma, 19), Vo = cr >> 31, li, fo = li >> 31), E = Qe + E | 0, E = (M = M + ye | 0) >>> 0 < ye >>> 0 ? E + 1 | 0 : E, Ba = o[T + 36 >> 2], ye = Zr(Mr = v(Ba, 19), go = Mr >> 31, is = io << 1, Qn = is >> 31), E = Qe + E | 0, gr = M = ye + M | 0, Ne = M >>> 0 < ye >>> 0 ? E + 1 | 0 : E, E = Zr(Mi, $n, vn, wo), M = Qe, ve = Zr(fi, Ni, So, zn = So >> 31), ye = Qe + M | 0, ye = (E = ve + E | 0) >>> 0 < ve >>> 0 ? ye + 1 | 0 : ye, ve = Zr(Xi, ro, qo, es = qo >> 31), M = Qe + ye | 0, M = (E = ve + E | 0) >>> 0 < ve >>> 0 ? M + 1 | 0 : M, ye = (ve = Zr(Wi, Zn, bo, as)) + E | 0, E = Qe + M | 0, E = ye >>> 0 < ve >>> 0 ? E + 1 | 0 : E, M = ye, ye = Zr(Qo, ci, Ln, us = Ln >> 31), E = Qe + E | 0, E = (M = M + ye | 0) >>> 0 < ye >>> 0 ? E + 1 | 0 : E, ye = Zr(jr, to, pr, ks), E = Qe + E | 0, E = (M = ye + M | 0) >>> 0 < ye >>> 0 ? E + 1 | 0 : E, ve = Zr(Nr = v(Nr, 19), ws = Nr >> 31, qn, Cs = qn >> 31), ye = Qe + E | 0, ye = (M = ve + M | 0) >>> 0 < ve >>> 0 ? ye + 1 | 0 : ye, E = (ve = Zr(li, fo, Jr, cs)) + M | 0, M = Qe + ye | 0, M = E >>> 0 < ve >>> 0 ? M + 1 | 0 : M, ye = (ve = Zr(cr, Vo, io, Es = io >> 31)) + E | 0, E = Qe + M | 0, E = ye >>> 0 < ve >>> 0 ? E + 1 | 0 : E, M = ye, ye = Zr(Mr, go, Tr, Yi), E = Qe + E | 0, Hs = M = M + ye | 0, ms = M >>> 0 < ye >>> 0 ? E + 1 | 0 : E, E = Zr(vn, wo, ai, Is), ye = Qe, M = (ve = Zr(fi, Ni, Mi, $n)) + E | 0, E = Qe + ye | 0, E = M >>> 0 < ve >>> 0 ? E + 1 | 0 : E, ve = Zr(Wi, Zn, Xi, ro), ye = Qe + E | 0, ye = (M = ve + M | 0) >>> 0 < ve >>> 0 ? ye + 1 | 0 : ye, E = (ve = Zr(bo, as, Fi, Ps)) + M | 0, M = Qe + ye | 0, M = E >>> 0 < ve >>> 0 ? M + 1 | 0 : M, ye = (ve = Zr(jr, to, Qo, ci)) + E | 0, E = Qe + M | 0, E = ye >>> 0 < ve >>> 0 ? E + 1 | 0 : E, M = ye, ye = Zr(ve = v(pr, 19), Rs = ve >> 31, Eo, fn), E = Qe + E | 0, E = (M = M + ye | 0) >>> 0 < ye >>> 0 ? E + 1 | 0 : E, ye = Zr(li, fo, Nr, ws), E = Qe + E | 0, E = (M = ye + M | 0) >>> 0 < ye >>> 0 ? E + 1 | 0 : E, pr = Zr(Jr, cs, is, Qn), ye = Qe + E | 0, ye = (M = pr + M | 0) >>> 0 < pr >>> 0 ? ye + 1 | 0 : ye, E = (pr = Zr(cr, Vo, Tr, Yi)) + M | 0, M = Qe + ye | 0, M = E >>> 0 < pr >>> 0 ? M + 1 | 0 : M, ye = (pr = Zr(Mr, go, Tn, ys)) + E | 0, E = Qe + M | 0, Ea = ye, _a = E = ye >>> 0 < pr >>> 0 ? E + 1 | 0 : E, xa = ye = ye + 33554432 | 0, Ka = E = ye >>> 0 < 33554432 ? E + 1 | 0 : E, ye = (67108863 & E) << 6 | ye >>> 26, E = (E >> 26) + ms | 0, Hs = pr = ye + Hs | 0, E = ye >>> 0 > pr >>> 0 ? E + 1 | 0 : E, nf = pr = pr + 16777216 | 0, E = (M = (ye = pr >>> 0 < 16777216 ? E + 1 | 0 : E) >> 25) + Ne | 0, E = (ye = (pr = (33554431 & ye) << 7 | pr >>> 25) + gr | 0) >>> 0 < pr >>> 0 ? E + 1 | 0 : E, ti = M = ye + 33554432 | 0, pr = E = M >>> 0 < 33554432 ? E + 1 | 0 : E, o[T + 72 >> 2] = ye - (-67108864 & M), E = Zr(vn, wo, Fi, Ps), M = Qe, Ne = Zr(fi, Ni, Wi, Zn), ye = Qe + M | 0, ye = (E = Ne + E | 0) >>> 0 < Ne >>> 0 ? ye + 1 | 0 : ye, M = (Ne = Zr(jr, to, Xi, ro)) + E | 0, E = Qe + ye | 0, E = M >>> 0 < Ne >>> 0 ? E + 1 | 0 : E, ye = Zr(Ne = v(bo, 19), Ds = Ne >> 31, Eo, fn), E = Qe + E | 0, E = (M = ye + M | 0) >>> 0 < ye >>> 0 ? E + 1 | 0 : E, ye = (gr = Zr(ms = v(Qo, 19), Fs = ms >> 31, li, fo)) + M | 0, M = Qe + E | 0, M = ye >>> 0 < gr >>> 0 ? M + 1 | 0 : M, gr = Zr(is, Qn, ve, Rs), E = Qe + M | 0, E = (ye = gr + ye | 0) >>> 0 < gr >>> 0 ? E + 1 | 0 : E, M = (gr = Zr(Tr, Yi, Nr, ws)) + ye | 0, ye = Qe + E | 0, ye = M >>> 0 < gr >>> 0 ? ye + 1 | 0 : ye, gr = Zr(Jr, cs, Tn, ys), E = Qe + ye | 0, E = (M = gr + M | 0) >>> 0 < gr >>> 0 ? E + 1 | 0 : E, ye = Zr(cr, Vo, Mi, $n), E = Qe + E | 0, E = (M = ye + M | 0) >>> 0 < ye >>> 0 ? E + 1 | 0 : E, ye = (gr = Zr(Mr, go, ai, Is)) + M | 0, M = Qe + E | 0, Br = ye, ra = ye >>> 0 < gr >>> 0 ? M + 1 | 0 : M, E = Zr(jr, to, vn, wo), M = Qe, ye = (gr = Zr(fi, Ni, Ln, us)) + E | 0, E = Qe + M | 0, E = ye >>> 0 < gr >>> 0 ? E + 1 | 0 : E, gr = M = v(Xi, 19), M = (Pr = Zr(M, Qs = M >> 31, qn, Cs)) + ye | 0, ye = Qe + E | 0, ye = M >>> 0 < Pr >>> 0 ? ye + 1 | 0 : ye, Pr = Zr(li, fo, Ne, Ds), E = Qe + ye | 0, E = (M = Pr + M | 0) >>> 0 < Pr >>> 0 ? E + 1 | 0 : E, ye = Zr(ms, Fs, io, Es), E = Qe + E | 0, E = (M = ye + M | 0) >>> 0 < ye >>> 0 ? E + 1 | 0 : E, ye = (Pr = Zr(Tr, Yi, ve, Rs)) + M | 0, M = Qe + E | 0, M = ye >>> 0 < Pr >>> 0 ? M + 1 | 0 : M, Pr = Zr(Nr, ws, So, zn), E = Qe + M | 0, E = (ye = Pr + ye | 0) >>> 0 < Pr >>> 0 ? E + 1 | 0 : E, M = (Pr = Zr(Mi, $n, Jr, cs)) + ye | 0, ye = Qe + E | 0, ye = M >>> 0 < Pr >>> 0 ? ye + 1 | 0 : ye, Pr = Zr(cr, Vo, qo, es), E = Qe + ye | 0, E = (M = Pr + M | 0) >>> 0 < Pr >>> 0 ? E + 1 | 0 : E, ye = Zr(Mr, go, Wi, Zn), E = Qe + E | 0, ca = M = ye + M | 0, Pr = M >>> 0 < ye >>> 0 ? E + 1 | 0 : E, E = Zr(E = v(vn, 19), E >> 31, Eo, fn), M = Qe, ye = Zr(fi, Ni, jr, to), M = Qe + M | 0, M = (E = ye + E | 0) >>> 0 < ye >>> 0 ? M + 1 | 0 : M, ye = (gr = Zr(li, fo, gr, Qs)) + E | 0, E = Qe + M | 0, M = (Ne = Zr(Ne, Ds, is, Qn)) + ye | 0, ye = Qe + (ye >>> 0 < gr >>> 0 ? E + 1 | 0 : E) | 0, ye = M >>> 0 < Ne >>> 0 ? ye + 1 | 0 : ye, Ne = Zr(Tr, Yi, ms, Fs), E = Qe + ye | 0, E = (M = Ne + M | 0) >>> 0 < Ne >>> 0 ? E + 1 | 0 : E, ye = Zr(Tn, ys, ve, Rs), E = Qe + E | 0, E = (M = ye + M | 0) >>> 0 < ye >>> 0 ? E + 1 | 0 : E, ye = (Ne = Zr(Mi, $n, Nr, ws)) + M | 0, M = Qe + E | 0, M = ye >>> 0 < Ne >>> 0 ? M + 1 | 0 : M, Ne = Zr(Jr, cs, ai, Is), E = Qe + M | 0, E = (ye = Ne + ye | 0) >>> 0 < Ne >>> 0 ? E + 1 | 0 : E, M = (Ne = Zr(cr, Vo, Wi, Zn)) + ye | 0, ye = Qe + E | 0, ye = M >>> 0 < Ne >>> 0 ? ye + 1 | 0 : ye, Ne = Zr(Mr, go, Fi, Ps), E = Qe + ye | 0, gr = M = Ne + M | 0, Ds = E = M >>> 0 < Ne >>> 0 ? E + 1 | 0 : E, Qs = M = M + 33554432 | 0, of = E = M >>> 0 < 33554432 ? E + 1 | 0 : E, ye = E >> 26, E = (67108863 & E) << 6 | M >>> 26, M = ye + Pr | 0, Pr = Ne = E + ca | 0, E = M = E >>> 0 > Ne >>> 0 ? M + 1 | 0 : M, ca = Ne = Ne + 16777216 | 0, Ne = (33554431 & (E = Ne >>> 0 < 16777216 ? E + 1 | 0 : E)) << 7 | Ne >>> 25, E = (E >> 25) + ra | 0, E = (M = Ne + Br | 0) >>> 0 < Ne >>> 0 ? E + 1 | 0 : E, ye = M, ra = M = M + 33554432 | 0, Ne = E = M >>> 0 < 33554432 ? E + 1 | 0 : E, o[T + 56 >> 2] = ye - (-67108864 & M), E = Zr(Tr, Yi, vn, wo), ye = Qe, M = (Br = Zr(fi, Ni, io, Es)) + E | 0, E = Qe + ye | 0, E = M >>> 0 < Br >>> 0 ? E + 1 | 0 : E, ye = Zr(Xi, ro, So, zn), E = Qe + E | 0, E = (M = ye + M | 0) >>> 0 < ye >>> 0 ? E + 1 | 0 : E, ye = Zr(Mi, $n, bo, as), E = Qe + E | 0, E = (M = ye + M | 0) >>> 0 < ye >>> 0 ? E + 1 | 0 : E, Br = Zr(Qo, ci, qo, es), ye = Qe + E | 0, ye = (M = Br + M | 0) >>> 0 < Br >>> 0 ? ye + 1 | 0 : ye, E = (Br = Zr(Wi, Zn, Ys, ks)) + M | 0, M = Qe + ye | 0, M = E >>> 0 < Br >>> 0 ? M + 1 | 0 : M, ye = (Br = Zr(Ln, us, Vs, Ns)) + E | 0, E = Qe + M | 0, E = ye >>> 0 < Br >>> 0 ? E + 1 | 0 : E, M = ye, ye = Zr(Po, ua = Po >> 31, jr, to), E = Qe + E | 0, E = (M = M + ye | 0) >>> 0 < ye >>> 0 ? E + 1 | 0 : E, ye = Zr(cr, Vo, qn, Cs), E = Qe + E | 0, E = (M = ye + M | 0) >>> 0 < ye >>> 0 ? E + 1 | 0 : E, Br = (ye = M) + (M = Zr(Mr, go, li, fo)) | 0, ye = Qe + E | 0, M = (E = pr >> 26) + (M = M >>> 0 > Br >>> 0 ? ye + 1 | 0 : ye) | 0, ti = ye = (pr = (67108863 & pr) << 6 | ti >>> 26) + Br | 0, E = M = ye >>> 0 < pr >>> 0 ? M + 1 | 0 : M, Br = ye = ye + 16777216 | 0, pr = E = ye >>> 0 < 16777216 ? E + 1 | 0 : E, o[T + 76 >> 2] = ti - (-33554432 & ye), E = Zr(Wi, Zn, vn, wo), M = Qe, ti = Zr(fi, Ni, qo, es), ye = Qe + M | 0, ye = (E = ti + E | 0) >>> 0 < ti >>> 0 ? ye + 1 | 0 : ye, ti = Zr(Xi, ro, Ln, us), M = Qe + ye | 0, M = (E = ti + E | 0) >>> 0 < ti >>> 0 ? M + 1 | 0 : M, ye = (ti = Zr(jr, to, bo, as)) + E | 0, E = Qe + M | 0, E = ye >>> 0 < ti >>> 0 ? E + 1 | 0 : E, M = ye, ye = Zr(ms, Fs, qn, Cs), E = Qe + E | 0, E = (M = M + ye | 0) >>> 0 < ye >>> 0 ? E + 1 | 0 : E, ye = Zr(li, fo, ve, Rs), E = Qe + E | 0, E = (M = ye + M | 0) >>> 0 < ye >>> 0 ? E + 1 | 0 : E, M = (Nr = Zr(Nr, ws, io, Es)) + M | 0, ye = Qe + E | 0, E = (Jr = Zr(Tr, Yi, Jr, cs)) + M | 0, M = Qe + (M >>> 0 < Nr >>> 0 ? ye + 1 | 0 : ye) | 0, ye = (cr = Zr(cr, Vo, So, zn)) + E | 0, E = Qe + (E >>> 0 < Jr >>> 0 ? M + 1 | 0 : M) | 0, E = ye >>> 0 < cr >>> 0 ? E + 1 | 0 : E, M = ye, ye = Zr(Mr, go, Mi, $n), E = Qe + E | 0, ti = M = M + ye | 0, E = (E = M >>> 0 < ye >>> 0 ? E + 1 | 0 : E) + (M = Ne >> 26) | 0, cr = Ne = ti + (ye = (67108863 & Ne) << 6 | ra >>> 26) | 0, E = ye >>> 0 > Ne >>> 0 ? E + 1 | 0 : E, Jr = M = Ne + 16777216 | 0, Ne = ye = M >>> 0 < 16777216 ? E + 1 | 0 : E, o[T + 60 >> 2] = cr - (-33554432 & M), E = Zr(vn, wo, is, Qn), ye = Qe, M = (cr = Zr(fi, Ni, li, fo)) + E | 0, E = Qe + ye | 0, E = M >>> 0 < cr >>> 0 ? E + 1 | 0 : E, ye = Zr(Tr, Yi, Xi, ro), E = Qe + E | 0, E = (M = ye + M | 0) >>> 0 < ye >>> 0 ? E + 1 | 0 : E, cr = Zr(bo, as, Tn, ys), ye = Qe + E | 0, ye = (M = cr + M | 0) >>> 0 < cr >>> 0 ? ye + 1 | 0 : ye, E = (cr = Zr(Mi, $n, Qo, ci)) + M | 0, M = Qe + ye | 0, M = E >>> 0 < cr >>> 0 ? M + 1 | 0 : M, ye = (cr = Zr(ai, Is, Ys, ks)) + E | 0, E = Qe + M | 0, E = ye >>> 0 < cr >>> 0 ? E + 1 | 0 : E, M = ye, ye = Zr(Wi, Zn, Vs, Ns), E = Qe + E | 0, E = (M = M + ye | 0) >>> 0 < ye >>> 0 ? E + 1 | 0 : E, ye = M, M = Zr(Po, ua, Fi, Ps), E = Qe + E | 0, E = M >>> 0 > (ye = ye + M | 0) >>> 0 ? E + 1 | 0 : E, cr = M = ma, M = (Tn = Zr(M, Nr = M >> 31, jr, to)) + ye | 0, ye = Qe + E | 0, E = (Mr = Zr(Mr, go, Eo, fn)) + M | 0, M = Qe + (M >>> 0 < Tn >>> 0 ? ye + 1 | 0 : ye) | 0, ye = E >>> 0 < Mr >>> 0 ? M + 1 | 0 : M, M = E, E = (E = pr >> 25) + ye | 0, E = (M = M + (pr = (33554431 & pr) << 7 | Br >>> 25) | 0) >>> 0 < pr >>> 0 ? E + 1 | 0 : E, ye = M, Mr = M = M + 33554432 | 0, pr = E = M >>> 0 < 33554432 ? E + 1 | 0 : E, o[T + 80 >> 2] = ye - (-67108864 & M), M = Ne >> 25, ye = (Ne = (33554431 & Ne) << 7 | Jr >>> 25) + (Ea - (E = -67108864 & xa) | 0) | 0, E = M + (_a - ((E >>> 0 > Ea >>> 0) + Ka | 0) | 0) | 0, E = ye >>> 0 < Ne >>> 0 ? E + 1 | 0 : E, E = ((67108863 & (E = (M = ye + 33554432 | 0) >>> 0 < 33554432 ? E + 1 | 0 : E)) << 6 | M >>> 26) + (Tn = Hs - (-33554432 & nf) | 0) | 0, o[T + 68 >> 2] = E, o[T + 64 >> 2] = ye - (-67108864 & M), E = Zr(li, fo, vn, wo), ye = Qe, M = (Ne = Zr(fi, Ni, qn, Cs)) + E | 0, E = Qe + ye | 0, E = M >>> 0 < Ne >>> 0 ? E + 1 | 0 : E, ye = (Ne = Zr(Xi, ro, io, Es)) + M | 0, M = Qe + E | 0, M = ye >>> 0 < Ne >>> 0 ? M + 1 | 0 : M, E = (Ne = Zr(Tr, Yi, bo, as)) + ye | 0, ye = Qe + M | 0, ye = E >>> 0 < Ne >>> 0 ? ye + 1 | 0 : ye, M = (Ne = Zr(Qo, ci, So, zn)) + E | 0, E = Qe + ye | 0, E = M >>> 0 < Ne >>> 0 ? E + 1 | 0 : E, ye = Zr(Mi, $n, Ys, ks), E = Qe + E | 0, E = (M = ye + M | 0) >>> 0 < ye >>> 0 ? E + 1 | 0 : E, ye = Zr(qo, es, Vs, Ns), E = Qe + E | 0, E = (M = ye + M | 0) >>> 0 < ye >>> 0 ? E + 1 | 0 : E, ye = (Ne = Zr(Wi, Zn, Po, ua)) + M | 0, M = Qe + E | 0, M = ye >>> 0 < Ne >>> 0 ? M + 1 | 0 : M, Ne = (E = Zr(cr, Nr, Ln, us)) + ye | 0, ye = Qe + M | 0, ye = E >>> 0 > Ne >>> 0 ? ye + 1 | 0 : ye, M = Ne, Ne = Zr(E = Ba, E >> 31, jr, to), E = Qe + ye | 0, ye = M = M + Ne | 0, E = (E = M >>> 0 < Ne >>> 0 ? E + 1 | 0 : E) + (M = pr >> 26) | 0, E = (ye = ye + (pr = (67108863 & pr) << 6 | Mr >>> 26) | 0) >>> 0 < pr >>> 0 ? E + 1 | 0 : E, E = (M = ye + 16777216 | 0) >>> 0 < 16777216 ? E + 1 | 0 : E, o[T + 84 >> 2] = ye - (-33554432 & M), pr = Pr - (-33554432 & ca) | 0, Ne = gr - (ye = -67108864 & Qs) | 0, fi = Ds - ((ye >>> 0 > gr >>> 0) + of | 0) | 0, E = Zr((33554431 & (ye = E)) << 7 | M >>> 25, E >>= 25, 19, 0), M = Qe + fi | 0, E = E >>> 0 > (ye = E + Ne | 0) >>> 0 ? M + 1 | 0 : M, E = ((67108863 & (E = (M = ye + 33554432 | 0) >>> 0 < 33554432 ? E + 1 | 0 : E)) << 6 | M >>> 26) + pr | 0, o[T + 52 >> 2] = E, o[T + 48 >> 2] = ye - (-67108864 & M), i2(k, T + 48 | 0)), dr = T + 256 | 0, 0 | la;
                    }, Rg: function(k, E) {
                      k |= 0;
                      var T, M = 0;
                      return dr = T = dr + -64 | 0, Zs(T, E |= 0, 32, 0), B[0 | T] = 248 & m[0 | T], B[T + 31 | 0] = 63 & m[T + 31 | 0] | 64, E = o[T + 20 >> 2], M = o[T + 16 >> 2], B[k + 16 | 0] = M, B[k + 17 | 0] = M >>> 8, B[k + 18 | 0] = M >>> 16, B[k + 19 | 0] = M >>> 24, B[k + 20 | 0] = E, B[k + 21 | 0] = E >>> 8, B[k + 22 | 0] = E >>> 16, B[k + 23 | 0] = E >>> 24, E = o[T + 12 >> 2], M = o[T + 8 >> 2], B[k + 8 | 0] = M, B[k + 9 | 0] = M >>> 8, B[k + 10 | 0] = M >>> 16, B[k + 11 | 0] = M >>> 24, B[k + 12 | 0] = E, B[k + 13 | 0] = E >>> 8, B[k + 14 | 0] = E >>> 16, B[k + 15 | 0] = E >>> 24, E = o[T + 4 >> 2], M = o[T >> 2], B[0 | k] = M, B[k + 1 | 0] = M >>> 8, B[k + 2 | 0] = M >>> 16, B[k + 3 | 0] = M >>> 24, B[k + 4 | 0] = E, B[k + 5 | 0] = E >>> 8, B[k + 6 | 0] = E >>> 16, B[k + 7 | 0] = E >>> 24, E = o[T + 28 >> 2], M = o[T + 24 >> 2], B[k + 24 | 0] = M, B[k + 25 | 0] = M >>> 8, B[k + 26 | 0] = M >>> 16, B[k + 27 | 0] = M >>> 24, B[k + 28 | 0] = E, B[k + 29 | 0] = E >>> 8, B[k + 30 | 0] = E >>> 16, B[k + 31 | 0] = E >>> 24, _s(T, 64), dr = T - -64 | 0, 0;
                    }, Sg: bl, Tg: Wh, Ug: Il, Vg: el, Wg: Js, Xg: $f, Yg: D2, Zg: Js, _g: ql, $g: D2, ah: function(k, E, T, M, ye) {
                      return 0 | ku(k |= 0, E |= 0, T |= 0, M |= 0, ye |= 0);
                    }, bh: function(k, E, T, M, ye, Ne, pr, ve) {
                      return 0 | Cc(k |= 0, E |= 0, (k = 0) | (T |= 0), M |= 0, ye |= 0, k | (Ne |= 0), pr |= 0, ve |= 0);
                    }, ch: function(k, E, T, M, ye, Ne) {
                      return 0 | Vu(k |= 0, E |= 0, T |= 0, M |= 0, ye |= 0, Ne |= 0);
                    }, dh: function(k, E, T, M, ye) {
                      return 0 | Lc(k |= 0, E |= 0, T |= 0, M |= 0, ye |= 0);
                    }, eh: function(k, E, T, M, ye, Ne, pr) {
                      return 0 | zc(k |= 0, E |= 0, T |= 0, M |= 0, ye |= 0, Ne |= 0, pr |= 0);
                    }, fh: function(k, E, T, M, ye, Ne) {
                      return 0 | Wu(k |= 0, E |= 0, T |= 0, M |= 0, ye |= 0, Ne |= 0);
                    }, gh: cf, hh: cf, ih: Js, jh: rc, kh: D2, lh: function() {
                      return 1538;
                    }, mh: El, nh: Zu, oh: cf, ph: Js, qh: $f, rh: D2, sh: function(k, E, T, M, ye) {
                      return 0 | Nh(k |= 0, E |= 0, T |= 0, M |= 0, ye |= 0);
                    }, th: function(k, E, T, M, ye, Ne, pr, ve) {
                      return 0 | cu(k |= 0, E |= 0, (k = 0) | (T |= 0), M |= 0, ye |= 0, k | (Ne |= 0), pr |= 0, ve |= 0);
                    }, uh: function(k, E, T, M, ye, Ne) {
                      return 0 | eA(k |= 0, E |= 0, T |= 0, M |= 0, ye |= 0, Ne |= 0);
                    }, vh: cf, wh: El, xh: function(k, E, T, M, ye, Ne, pr, ve) {
                      var cr;
                      return k |= 0, E |= 0, T |= 0, M |= 0, Ne |= 0, pr |= 0, dr = cr = dr - 32 | 0, ea(cr, ye |= 0, ve |= 0, 0), k = cu(ve = k, E, (k = 0) | T, M, ye + 16 | 0, k | Ne, pr, cr), _s(cr, 32), dr = cr + 32 | 0, 0 | k;
                    }, yh: Zu, zh: Js, Ah: rc, Bh: D2, Ch: cf, Dh: Ra, Eh: Js, Fh: pf, Gh: pc, Hh: tu, Ih: xl, Jh: function() {
                      return 1089;
                    }, Kh: function() {
                      var k, E;
                      return dr = k = dr - 16 | 0, B[k + 15 | 0] = 0, E = 0 | Be(36800, k + 15 | 0, 0), dr = k + 16 | 0, 0 | E;
                    }, Lh: Bl, Mh: function(k) {
                      var E, T = 0, M = 0;
                      if (dr = E = dr - 16 | 0, (k |= 0) >>> 0 >= 2) {
                        for (T = (0 - k >>> 0) % (k >>> 0) | 0; B[E + 15 | 0] = 0, T >>> 0 > (M = 0 | Be(36800, E + 15 | 0, 0)) >>> 0; ) ;
                        T = (M >>> 0) % (k >>> 0) | 0;
                      }
                      return dr = E + 16 | 0, 0 | T;
                    }, Nh: Sf, Oh: function(k, E, T) {
                      Lc(k |= 0, E |= 0, 0, 34336, T |= 0);
                    }, Ph: Js, Qh: function() {
                      var k = 0, E = 0;
                      return (k = o[9539]) && (k = o[k + 20 >> 2]) && (E = 0 | Af[0 | k]()), 0 | E;
                    }, Rh: function(k, E, T) {
                      k |= 0, E |= 0;
                      var M, ye = 0, Ne = 0, pr = 0;
                      if (dr = M = dr - 16 | 0, T |= 0) Me(1346, 1192, 198, 1092), ji();
                      else {
                        if (E | T) for (; B[M + 15 | 0] = 0, Ne = k + ye | 0, pr = 0 | Be(36800, M + 15 | 0, 0), B[0 | Ne] = pr, (0 | E) != (0 | (ye = ye + 1 | 0)); ) ;
                        dr = M + 16 | 0;
                      }
                    }, Sh: function(k, E, T, M) {
                      k |= 0, T |= 0;
                      var ye = 0, Ne = 0, pr = 0;
                      if (!((M |= 0) >>> 0 > 2147483646 | M << 1 >>> 0 >= (E |= 0) >>> 0)) {
                        if (E = 0, M) {
                          for (; ye = (E << 1) + k | 0, Ne = 15 & (pr = m[E + T | 0]), B[ye + 1 | 0] = 22272 + ((Ne << 8) + (Ne + 65526 & 55552) | 0) >>> 8, Ne = ye, ye = pr >>> 4 | 0, B[0 | Ne] = 87 + ((ye + 65526 >>> 8 & 217) + ye | 0), (0 | M) != (0 | (E = E + 1 | 0)); ) ;
                          E = M << 1;
                        } else E = 0;
                        return B[E + k | 0] = 0, 0 | k;
                      }
                      Wa(), ji();
                    }, Th: function(k, E, T, M, ye, Ne, pr) {
                      k |= 0, E |= 0, T |= 0, ye |= 0, Ne |= 0, pr |= 0;
                      var ve = 0, cr = 0, gr = 0, Pr = 0, Nr = 0, Br = 0, Mr = 0, jr = 0, ti = 0;
                      e: {
                        t: {
                          r: {
                            i: {
                              n: {
                                o: {
                                  a: {
                                    s: {
                                      A: {
                                        if (M |= 0) {
                                          if (ye) break A;
                                          for (cr = 1, ye = 0; ; ) {
                                            if (!(255 & ((Mr = (65526 + (gr = (223 & (Nr = m[T + ve | 0])) - 55 & 255) ^ gr + 65520) >>> 8 | 0) | (jr = 65526 + (Nr ^= 48) >>> 8 | 0)))) break a;
                                            if (E >>> 0 <= Br >>> 0) break s;
                                            if (gr = gr & Mr | Nr & jr, 255 & Pr ? (B[k + Br | 0] = ye | gr, Br = Br + 1 | 0) : ye = gr << 4, Pr = ~Pr, (0 | (ve = ve + 1 | 0)) == (0 | M)) break;
                                          }
                                          ve = M;
                                          break a;
                                        }
                                        if (k = 0, !pr) break e;
                                        break r;
                                      }
                                      for (; ; ) {
                                        A: {
                                          u: {
                                            h: {
                                              c: {
                                                f: {
                                                  if (!(255 & ((Nr = (65526 + (cr = (223 & (gr = m[T + ve | 0])) - 55 & 255) ^ cr + 65520) >>> 8 | 0) | (jr = 65526 + (Mr = 48 ^ gr) >>> 8 | 0)))) {
                                                    if (255 & Pr) break o;
                                                    if (cr = 0, !Us(ye, gr)) break i;
                                                    if ((ve = Pr = ve + 1 | 0) >>> 0 < M >>> 0) break f;
                                                    break i;
                                                  }
                                                  if (E >>> 0 <= Br >>> 0) break s;
                                                  if (cr = cr & Nr | Mr & jr, !(255 & Pr)) break c;
                                                  B[k + Br | 0] = cr | ti, Br = Br + 1 | 0;
                                                  break A;
                                                }
                                                for (; ; ) {
                                                  if (!(255 & ((Mr = (65526 + (Nr = (223 & (gr = m[T + ve | 0])) - 55 & 255) ^ Nr + 65520) >>> 8 | 0) | (ti = 65526 + (jr = 48 ^ gr) >>> 8 | 0)))) {
                                                    if (!Us(ye, gr)) break i;
                                                    if ((ve = ve + 1 | 0) >>> 0 < M >>> 0) continue;
                                                    break h;
                                                  }
                                                  break;
                                                }
                                                if (E >>> 0 <= Br >>> 0) break u;
                                                cr = Nr & Mr | jr & ti;
                                              }
                                              ti = cr << 4, Pr = 0;
                                              break A;
                                            }
                                            ve = M >>> 0 > Pr >>> 0 ? M : Pr;
                                            break i;
                                          }
                                          Pr = 0;
                                          break s;
                                        }
                                        if (Pr = ~Pr, cr = 1, !((ve = ve + 1 | 0) >>> 0 < M >>> 0)) break;
                                      }
                                      break a;
                                    }
                                    o[9404] = 68, cr = 0;
                                  }
                                  if (!(255 & Pr)) break n;
                                }
                                o[9404] = 28, cr = -1, ve = ve - 1 | 0, Br = 0;
                                break i;
                              }
                              Br = cr ? Br : 0, cr = cr - 1 | 0;
                            }
                            if (!pr) {
                              if ((0 | M) != (0 | ve)) break t;
                              k = cr;
                              break e;
                            }
                          }
                          o[pr >> 2] = T + ve, k = cr;
                          break e;
                        }
                        o[9404] = 28, k = -1;
                      }
                      return Ne && (o[Ne >> 2] = Br), 0 | k;
                    }, Uh: function(k, E) {
                      k |= 0;
                      var T = 0;
                      return (-7 & (E |= 0)) != 1 && (Wa(), ji()), 1 + ((3 & (T = (T = k) + v(k = (k >>> 0) / 3 | 0, -3) | 0) ? 2 & E ? T + 1 | 0 : 4 : 0) + (k << 2) | 0) | 0;
                    }, Vh: Nf, Wh: Se, Xh: function() {
                      var k = 0;
                      return o[9537] ? k = 1 : (Bl(), Sf(38128, 16), o[9537] = 1, k = 0), 0 | k;
                    }, Yh: function(k, E, T, M, ye) {
                      k |= 0, E |= 0, T |= 0, ye |= 0;
                      var Ne, pr = 0, ve = 0, cr = 0;
                      dr = Ne = dr - 16 | 0;
                      e: {
                        if (M |= 0) {
                          if ((pr = M - 1 | 0) & M ? (ve = ~T, pr = pr - ((T >>> 0) % (M >>> 0) | 0) | 0) : pr &= ve = ~T, pr >>> 0 >= ve >>> 0) break e;
                          if ((T = T + pr | 0) >>> 0 >= ye >>> 0) E = -1;
                          else for (k && (o[k >> 2] = T + 1), k = E + T | 0, E = 0, B[Ne + 15 | 0] = 0, T = 0; ve = ye = k - T | 0, cr = m[0 | ye] & m[Ne + 15 | 0], ye = (T ^ pr) - 1 >>> 24 | 0, B[0 | ve] = cr | 128 & ye, B[Ne + 15 | 0] = ye | m[Ne + 15 | 0], (0 | M) != (0 | (T = T + 1 | 0)); ) ;
                        } else E = -1;
                        return dr = Ne + 16 | 0, 0 | E;
                      }
                      Wa(), ji();
                    }, Zh: function(k, E, T, M) {
                      k |= 0, E |= 0, T |= 0, M |= 0;
                      var ye, Ne = 0, pr = 0, ve = 0, cr = 0, gr = 0;
                      if (o[12 + (ye = dr - 16 | 0) >> 2] = 0, M - 1 >>> 0 < T >>> 0) {
                        for (gr = (Ne = T - 1 | 0) + E | 0, T = 0, E = 0; cr = ((128 ^ (pr = m[gr - T | 0])) - 1 & o[ye + 12 >> 2] - 1 & ve - 1) >>> 8 & 1, o[ye + 12 >> 2] = o[ye + 12 >> 2] | 0 - cr & T, E |= cr, ve |= pr, (0 | M) != (0 | (T = T + 1 | 0)); ) ;
                        o[k >> 2] = Ne - o[ye + 12 >> 2], k = (255 & E) - 1 | 0;
                      } else k = -1;
                      return 0 | k;
                    }, _h: function() {
                      return 1547;
                    }, $h: function() {
                      return 26;
                    }, ai: Bc, bi: Yf, ci: ii, di: Ru, ei: function(k, E, T) {
                      k |= 0;
                      var M, ye = 0;
                      return dr = M = dr - 32 | 0, ye = -1, Gf(M, T |= 0, E |= 0) || (ye = ba(k, 35584, M, 0)), dr = M + 32 | 0, 0 | ye;
                    }, fi: wl, gi: function(k, E, T, M, ye, Ne, pr, ve) {
                      var cr, gr;
                      return k |= 0, E |= 0, T |= 0, Ne |= 0, gr = M |= 0, M = ye |= 0, dr = cr = dr + -64 | 0, Gf(cr + 32 | 0, ve |= 0, pr |= 0) ? ye = -1 : (ye = -1, ba(cr, 35584, cr + 32 | 0, 0) || (ye = Ai(k, E, T, gr, M, Ne, cr), _s(cr, 32))), dr = cr - -64 | 0, 0 | ye;
                    }, hi: function(k, E, T, M, ye, Ne) {
                      return k |= 0, E |= 0, ye |= 0, Ne |= 0, !(M |= 0) & (T |= 0) >>> 0 >= 4294967280 | M && (Wa(), ji()), 0 | Ai(k + 16 | 0, k, E, T, M, ye, Ne);
                    }, ii: function(k, E, T, M, ye, Ne, pr) {
                      return 0 | Xa(k |= 0, E |= 0, T |= 0, M |= 0, ye |= 0, Ne |= 0, pr |= 0);
                    }, ji: _u, ki: function(k, E, T, M, ye, Ne, pr, ve) {
                      var cr, gr;
                      return k |= 0, E |= 0, T |= 0, Ne |= 0, gr = M |= 0, M = ye |= 0, dr = cr = dr + -64 | 0, Gf(cr + 32 | 0, ve |= 0, pr |= 0) ? ye = -1 : (ye = -1, ba(cr, 35584, cr + 32 | 0, 0) || (ye = oo(k, E, T, gr, M, Ne, cr), _s(cr, 32))), dr = cr - -64 | 0, 0 | ye;
                    }, li: ll, mi: function(k, E, T, M, ye, Ne, pr) {
                      return 0 | ol(k |= 0, E |= 0, T |= 0, M |= 0, ye |= 0, Ne |= 0, pr |= 0);
                    }, ni: Js, oi: Js, pi: Js, qi: Js, ri: rc, si: Ra, ti: wc, ui: function(k, E, T, M, ye) {
                      k |= 0, E |= 0, ye |= 0;
                      var Ne, pr, ve, cr, gr = 0, Pr = 0;
                      return gr = T |= 0, T = M |= 0, cr = 0 | gr, gr = M = dr, dr = Ne = M - 512 & -64, M = -1, Ru(pr = Ne - -64 | 0, ve = Ne + 32 | 0) || (Zc(M = Ne + 128 | 0, 0, 0, 24), Qf(M, pr, 32, 0), Qf(M, ye, 32, 0), eu(M, Pr = Ne + 96 | 0, 24), M = Xa(k + 32 | 0, E, cr, T, Pr, ye, ve), E = o[Ne + 92 >> 2], T = o[Ne + 88 >> 2], B[k + 24 | 0] = T, B[k + 25 | 0] = T >>> 8, B[k + 26 | 0] = T >>> 16, B[k + 27 | 0] = T >>> 24, B[k + 28 | 0] = E, B[k + 29 | 0] = E >>> 8, B[k + 30 | 0] = E >>> 16, B[k + 31 | 0] = E >>> 24, E = o[Ne + 84 >> 2], T = o[Ne + 80 >> 2], B[k + 16 | 0] = T, B[k + 17 | 0] = T >>> 8, B[k + 18 | 0] = T >>> 16, B[k + 19 | 0] = T >>> 24, B[k + 20 | 0] = E, B[k + 21 | 0] = E >>> 8, B[k + 22 | 0] = E >>> 16, B[k + 23 | 0] = E >>> 24, E = o[Ne + 76 >> 2], T = o[Ne + 72 >> 2], B[k + 8 | 0] = T, B[k + 9 | 0] = T >>> 8, B[k + 10 | 0] = T >>> 16, B[k + 11 | 0] = T >>> 24, B[k + 12 | 0] = E, B[k + 13 | 0] = E >>> 8, B[k + 14 | 0] = E >>> 16, B[k + 15 | 0] = E >>> 24, E = o[Ne + 68 >> 2], T = o[Ne + 64 >> 2], B[0 | k] = T, B[k + 1 | 0] = T >>> 8, B[k + 2 | 0] = T >>> 16, B[k + 3 | 0] = T >>> 24, B[k + 4 | 0] = E, B[k + 5 | 0] = E >>> 8, B[k + 6 | 0] = E >>> 16, B[k + 7 | 0] = E >>> 24, _s(ve, 32), _s(pr, 32), _s(Pr, 24)), dr = gr, 0 | M;
                    }, vi: function(k, E, T, M, ye, Ne) {
                      k |= 0, E |= 0, ye |= 0, Ne |= 0;
                      var pr, ve, cr = 0;
                      return ve = cr = dr, dr = pr = cr - 448 & -64, cr = -1, !(M |= 0) & (T |= 0) >>> 0 >= 48 | M && (Zc(cr = pr - -64 | 0, 0, 0, 24), Qf(cr, E, 32, 0), Qf(cr, ye, 32, 0), eu(cr, ye = pr + 32 | 0, 24), cr = ol(k, E + 32 | 0, T - 32 | 0, M - (T >>> 0 < 32) | 0, ye, E, Ne)), dr = ve, 0 | cr;
                    }, wi: Lh, xi: function(k) {
                      var E, T = 0;
                      return dr = E = dr - 160 | 0, ha(k |= 0) && (Ia(k) || No(E, k) || Cf(E) && (T = !!(0 | Bs(E)))), dr = E + 160 | 0, 0 | T;
                    }, yi: function(k, E, T) {
                      k |= 0, T |= 0;
                      var M, ye, Ne = 0;
                      return dr = M = dr - 800 | 0, Ne = -1, No(ye = M + 640 | 0, E |= 0) || Cf(ye) && (No(E = M + 480 | 0, T) || Cf(E) && ($a(M, E), Aa(E = M + 160 | 0, ye, M), Yu(T = M + 320 | 0, E), Rc(k, T), Ne = 0)), dr = M + 800 | 0, 0 | Ne;
                    }, zi: function(k, E, T) {
                      k |= 0, T |= 0;
                      var M, ye, Ne = 0;
                      return dr = M = dr - 800 | 0, Ne = -1, No(ye = M + 640 | 0, E |= 0) || Cf(ye) && (No(E = M + 480 | 0, T) || Cf(E) && ($a(M, E), zs(E = M + 160 | 0, ye, M), Yu(T = M + 320 | 0, E), Rc(k, T), Ne = 0)), dr = M + 800 | 0, 0 | Ne;
                    }, Ai: function(k, E) {
                      return zi(k |= 0, E |= 0), 0;
                    }, Bi: function(k) {
                      var E;
                      k |= 0, dr = E = dr - 32 | 0, Sf(E, 32), zi(k, E), dr = E + 32 | 0;
                    }, Ci: Ph, Di: Je, Ei: ss, Fi: jo, Gi: Ta, Hi: no, Ii: ps, Ji: Rl, Ki: Js, Li: pf, Mi: Js, Ni: pf, Oi: Js, Pi: function(k) {
                      var E;
                      return dr = E = dr - 160 | 0, k = oa(E, k |= 0), dr = E + 160 | 0, 0 | !k;
                    }, Qi: function(k, E, T) {
                      k |= 0, T |= 0;
                      var M, ye, Ne = 0;
                      return dr = M = dr - 800 | 0, Ne = -1, oa(ye = M + 640 | 0, E |= 0) || oa(E = M + 480 | 0, T) || ($a(M, E), Aa(E = M + 160 | 0, ye, M), Yu(T = M + 320 | 0, E), po(k, T), Ne = 0), dr = M + 800 | 0, 0 | Ne;
                    }, Ri: function(k, E, T) {
                      k |= 0, T |= 0;
                      var M, ye, Ne = 0;
                      return dr = M = dr - 800 | 0, Ne = -1, oa(ye = M + 640 | 0, E |= 0) || oa(E = M + 480 | 0, T) || ($a(M, E), zs(E = M + 160 | 0, ye, M), Yu(T = M + 320 | 0, E), po(k, T), Ne = 0), dr = M + 800 | 0, 0 | Ne;
                    }, Si: function(k, E) {
                      return rl(k |= 0, E |= 0), 0;
                    }, Ti: function(k) {
                      var E;
                      k |= 0, dr = E = dr + -64 | 0, Sf(E, 64), rl(k, E), dr = E - -64 | 0;
                    }, Ui: function(k) {
                      Ph(k |= 0);
                    }, Vi: function(k, E) {
                      return 0 | Je(k |= 0, E |= 0);
                    }, Wi: function(k, E) {
                      ss(k |= 0, E |= 0);
                    }, Xi: function(k, E) {
                      jo(k |= 0, E |= 0);
                    }, Yi: function(k, E, T) {
                      Ta(k |= 0, E |= 0, T |= 0);
                    }, Zi: function(k, E, T) {
                      ps(k |= 0, E |= 0, T |= 0);
                    }, _i: Rl, $i: function(k, E) {
                      no(k |= 0, E |= 0);
                    }, aj: Js, bj: pf, cj: pf, dj: Js, ej: function(k, E, T, M, ye, Ne, pr, ve, cr, gr) {
                      return 0 | cl(k |= 0, E |= 0, T |= 0, M |= 0, ye |= 0, Ne |= 0, pr |= 0, ve |= 0, cr |= 0, gr |= 0);
                    }, fj: Ra, gj: D2, hj: Yf, ij: D2, jj: Js, kj: function() {
                      return 102;
                    }, lj: function() {
                      return 1575;
                    }, mj: function() {
                      return 32768;
                    }, nj: D2, oj: Ql, pj: D2, qj: function() {
                      return 524288;
                    }, rj: Ql, sj: eh, tj: uu, uj: function(k, E, T, M, ye, Ne, pr, ve, cr, gr) {
                      var Pr, Nr, Br;
                      E |= 0, T |= 0, M |= 0, ye |= 0, Ne |= 0, pr |= 0, cr |= 0, gr |= 0, Nr = 0 | (ve |= 0), dr = ve = dr - 16 | 0, Br = E |= 0, Pr = Ca(k |= 0, 0, E), k = 0 | ye;
                      e: if ((0 | (ye = T | Ne)) == 1 | ye >>> 0 > 1) o[9404] = 22, k = -1;
                      else if (!T & E >>> 0 >= 16 | T) {
                        if (Ha(Nr, cr, gr, ve + 12 | 0, ve + 8 | 0, ve + 4 | 0), (0 | M) == (0 | Pr)) {
                          o[9404] = 28, k = -1;
                          break e;
                        }
                        ye = k, k = 31 & (E = o[ve + 12 >> 2]), (63 & E) >>> 0 >= 32 ? (E = 1 << k, T = 0) : E = (T = 1 << k) - 1 & 1 >>> 32 - k, k = cl(M, ye, pr, 32, T, E, o[ve + 4 >> 2], o[ve + 8 >> 2], Pr, Br);
                      } else o[9404] = 28, k = -1;
                      return dr = ve + 16 | 0, 0 | k;
                    }, vj: function(k, E, T, M, ye, Ne, pr) {
                      E |= 0, T |= 0, M |= 0, Ne |= 0, pr |= 0;
                      var ve, cr, gr, Pr = 0, Nr = 0, Br = 0, Mr = 0, jr = 0, ti = 0, fi = 0;
                      Pr = ye |= 0, Pr |= ye = 0, dr = ve = dr - 128 | 0, cr = Ca(k |= 0, 0, 102), jr = 22, gr = T | ye;
                      e: {
                        {
                          if (!M) {
                            Ha(Pr, Ne, pr, ve + 16 | 0, ve + 12 | 0, ve + 8 | 0), Sf(Nr = ve + 96 | 0, 32), jr = 28, T = ve + 32 | 0, Ne = o[ve + 16 >> 2], pr = Zr(k = o[ve + 12 >> 2], 0, M = o[ve + 8 >> 2], 0);
                            t: if (!(!(Pr = Qe) & pr >>> 0 > 1073741823 | Pr | Ne >>> 0 > 63) && (B[0 | T] = 36, B[T + 1 | 0] = 55, B[T + 2 | 0] = 36, B[T + 4 | 0] = m[1024 + (63 & M) | 0], B[T + 3 | 0] = m[Ne + 1024 | 0], B[T + 8 | 0] = m[1024 + (M >>> 24 & 63) | 0], B[T + 7 | 0] = m[1024 + (M >>> 18 & 63) | 0], B[T + 6 | 0] = m[1024 + (M >>> 12 & 63) | 0], B[T + 5 | 0] = m[1024 + (M >>> 6 & 63) | 0], (M = T + 9 | 0) && (0 | M) != (0 | (Br = T + 58 | 0)) && (B[0 | M] = m[1024 + (63 & k) | 0], (0 | (M = Br - M | 0)) != 1 && (B[T + 10 | 0] = m[1024 + (k >>> 6 & 63) | 0], (0 | M) != 2 && (B[T + 11 | 0] = m[1024 + (k >>> 12 & 63) | 0], (0 | M) != 3 && (B[T + 12 | 0] = m[1024 + (k >>> 18 & 63) | 0], (0 | M) != 4 && (B[T + 13 | 0] = m[1024 + (k >>> 24 & 63) | 0], Ne = T + 14 | 0))))))) {
                              for (Pr = Br - Ne | 0, k = 0; ; ) {
                                if (M = Ne, !(k >>> 0 >= 32)) {
                                  if (Ne = m[k + Nr | 0], (ti = (pr = k + 1 | 0) >>> 0 >= 32) ? Mr = 0 : (Ne = m[pr + Nr | 0] << 8 | Ne, (pr = k + 2 | 0) >>> 0 >= 32 ? Mr = 0 : (Ne = m[pr + Nr | 0] << 16 | Ne, Mr = 1, pr = k + 3 | 0)), k = pr, !Pr || (B[0 | M] = m[1024 + (63 & Ne) | 0], (0 | Pr) == 1)) break t;
                                  if (B[M + 1 | 0] = m[1024 + (Ne >>> 6 & 63) | 0], fi = M + Pr | 0, pr = M + 2 | 0, !ti) {
                                    if ((0 | Pr) == 2) break t;
                                    if (B[M + 2 | 0] = m[1024 + (Ne >>> 12 & 63) | 0], pr = M + 3 | 0, Mr) {
                                      if ((0 | Pr) == 3) break t;
                                      B[M + 3 | 0] = m[1024 + (Ne >>> 18 | 0) | 0], pr = M + 4 | 0;
                                    }
                                  }
                                  if (Pr = fi - (Ne = pr) | 0, Ne) continue;
                                  break t;
                                }
                                break;
                              }
                              M >>> 0 >= Br >>> 0 || (B[0 | M] = 0, ye = T);
                            }
                            if (ye && (yc(k = ve + 20 | 0), E = Ic(k, E, gr, T, cr), Ju(k), E)) {
                              k = 0;
                              break e;
                            }
                          }
                          o[9404] = jr;
                        }
                        k = -1;
                      }
                      return dr = ve + 128 | 0, 0 | k;
                    }, wj: function(k, E, T, M) {
                      E |= 0, M |= 0;
                      var ye, Ne, pr = 0;
                      ye = k |= 0, Ne = T |= 0, T = 0, dr = M = dr - 128 | 0;
                      e: {
                        t: {
                          for (; ; ) {
                            if (!m[T + ye | 0]) {
                              k = T;
                              break t;
                            }
                            if (!m[ye + (k = T + 1 | 0) | 0] || !m[ye + (k = T + 2 | 0) | 0]) break t;
                            if ((0 | (T = T + 3 | 0)) == 102) break;
                          }
                          T = -1;
                          break e;
                        }
                        T = -1, (0 | k) == 101 && (yc(pr = M + 4 | 0) || (Ca(k = M + 16 | 0, 0, 102), E = Ic(pr, E, Ne, ye, k), Ju(pr), E && (T = bi(k, ye, 102), _s(k, 102))));
                      }
                      return dr = M + 128 | 0, 0 | T;
                    }, xj: function(k, E, T, M) {
                      var ye, Ne;
                      Ne = k |= 0, dr = ye = dr - 32 | 0, Ha(E |= 0, T |= 0, M |= 0, ye + 28 | 0, ye + 20 | 0, ye + 12 | 0), k = 0;
                      e: {
                        t: {
                          r: {
                            for (; ; ) {
                              if (m[k + Ne | 0]) {
                                if (m[Ne + (E = k + 1 | 0) | 0] && m[Ne + (E = k + 2 | 0) | 0]) {
                                  if ((0 | (k = k + 3 | 0)) != 102) continue;
                                  break r;
                                }
                              } else E = k;
                              break;
                            }
                            if ((0 | E) == 101) {
                              if (T = ye + 8 | 0, M = ye + 16 | 0, k = 0, m[0 | Ne] != 36 | m[Ne + 1 | 0] != 55 | m[Ne + 2 | 0] != 36 || (E = Qc(m[Ne + 3 | 0]), o[ye + 24 >> 2] = E ? E - 1024 | 0 : 0, E && (E = ju(T, Ne + 4 | 0)) && (k = ju(M, E))), k) break t;
                              o[9404] = 28, k = -1;
                              break e;
                            }
                          }
                          o[9404] = 28, k = -1;
                          break e;
                        }
                        k = 1, o[ye + 28 >> 2] != o[ye + 24 >> 2] | o[ye + 12 >> 2] != o[ye + 8 >> 2] || (k = o[ye + 20 >> 2] != o[ye + 16 >> 2]);
                      }
                      return dr = ye + 32 | 0, 0 | k;
                    }, yj: function(k, E, T) {
                      return 0 | Zf(k |= 0, E |= 0, T |= 0, 1);
                    }, zj: function(k, E, T) {
                      return 0 | Zf(k |= 0, E |= 0, T |= 0, 0);
                    }, Aj: function(k, E) {
                      return 0 | Wc(k |= 0, E |= 0, 1);
                    }, Bj: function(k, E) {
                      return 0 | Wc(k |= 0, E |= 0, 0);
                    }, Cj: Js, Dj: Js, Ej: function(k, E, T) {
                      k |= 0, E |= 0;
                      var M, ye = 0;
                      return dr = M = dr - 320 | 0, ye = -1, oa(M, T |= 0) || (B[0 | k] = m[0 | E], B[k + 1 | 0] = m[E + 1 | 0], B[k + 2 | 0] = m[E + 2 | 0], B[k + 3 | 0] = m[E + 3 | 0], B[k + 4 | 0] = m[E + 4 | 0], B[k + 5 | 0] = m[E + 5 | 0], B[k + 6 | 0] = m[E + 6 | 0], B[k + 7 | 0] = m[E + 7 | 0], B[k + 8 | 0] = m[E + 8 | 0], B[k + 9 | 0] = m[E + 9 | 0], B[k + 10 | 0] = m[E + 10 | 0], B[k + 11 | 0] = m[E + 11 | 0], B[k + 12 | 0] = m[E + 12 | 0], B[k + 13 | 0] = m[E + 13 | 0], B[k + 14 | 0] = m[E + 14 | 0], B[k + 15 | 0] = m[E + 15 | 0], B[k + 16 | 0] = m[E + 16 | 0], B[k + 17 | 0] = m[E + 17 | 0], B[k + 18 | 0] = m[E + 18 | 0], B[k + 19 | 0] = m[E + 19 | 0], B[k + 20 | 0] = m[E + 20 | 0], B[k + 21 | 0] = m[E + 21 | 0], B[k + 22 | 0] = m[E + 22 | 0], B[k + 23 | 0] = m[E + 23 | 0], B[k + 24 | 0] = m[E + 24 | 0], B[k + 25 | 0] = m[E + 25 | 0], B[k + 26 | 0] = m[E + 26 | 0], B[k + 27 | 0] = m[E + 27 | 0], B[k + 28 | 0] = m[E + 28 | 0], B[k + 29 | 0] = m[E + 29 | 0], B[k + 30 | 0] = m[E + 30 | 0], B[k + 31 | 0] = 127 & m[E + 31 | 0], Io(E = M + 160 | 0, k, M), po(k, E), ye = pa(k, 32) ? -1 : 0), dr = M + 320 | 0, 0 | ye;
                    }, Fj: function(k, E) {
                      var T;
                      return E |= 0, dr = T = dr - 160 | 0, B[0 | (k |= 0)] = m[0 | E], B[k + 1 | 0] = m[E + 1 | 0], B[k + 2 | 0] = m[E + 2 | 0], B[k + 3 | 0] = m[E + 3 | 0], B[k + 4 | 0] = m[E + 4 | 0], B[k + 5 | 0] = m[E + 5 | 0], B[k + 6 | 0] = m[E + 6 | 0], B[k + 7 | 0] = m[E + 7 | 0], B[k + 8 | 0] = m[E + 8 | 0], B[k + 9 | 0] = m[E + 9 | 0], B[k + 10 | 0] = m[E + 10 | 0], B[k + 11 | 0] = m[E + 11 | 0], B[k + 12 | 0] = m[E + 12 | 0], B[k + 13 | 0] = m[E + 13 | 0], B[k + 14 | 0] = m[E + 14 | 0], B[k + 15 | 0] = m[E + 15 | 0], B[k + 16 | 0] = m[E + 16 | 0], B[k + 17 | 0] = m[E + 17 | 0], B[k + 18 | 0] = m[E + 18 | 0], B[k + 19 | 0] = m[E + 19 | 0], B[k + 20 | 0] = m[E + 20 | 0], B[k + 21 | 0] = m[E + 21 | 0], B[k + 22 | 0] = m[E + 22 | 0], B[k + 23 | 0] = m[E + 23 | 0], B[k + 24 | 0] = m[E + 24 | 0], B[k + 25 | 0] = m[E + 25 | 0], B[k + 26 | 0] = m[E + 26 | 0], B[k + 27 | 0] = m[E + 27 | 0], B[k + 28 | 0] = m[E + 28 | 0], B[k + 29 | 0] = m[E + 29 | 0], B[k + 30 | 0] = m[E + 30 | 0], B[k + 31 | 0] = 127 & m[E + 31 | 0], e(T, k), po(k, T), k = pa(k, 32), dr = T + 160 | 0, 0 | (k ? -1 : 0);
                    }, Gj: Js, Hj: Js, Ij: wl, Jj: function(k, E, T, M, ye, Ne) {
                      return k |= 0, E |= 0, ye |= 0, Ne |= 0, !(M |= 0) & (T |= 0) >>> 0 >= 4294967280 | M && (Wa(), ji()), Ai(k + 16 | 0, k, E, T, M, ye, Ne), 0;
                    }, Kj: _u, Lj: ll, Mj: Js, Nj: rc, Oj: Ra, Pj: wc, Qj: Ra, Rj: Ra, Sj: function(k, E, T, M, ye) {
                      k |= 0, E |= 0, T |= 0, M |= 0;
                      var Ne, pr, ve = 0, cr = 0, gr = 0, Pr = 0, Nr = 0, Br = 0, Mr = 0, jr = 0, ti = 0, fi = 0, Jr = 0, li = 0, Tr = 0, Mi = 0;
                      if (Jr = 1886610805 ^ (ve = m[0 | (ye |= 0)] | m[ye + 1 | 0] << 8 | m[ye + 2 | 0] << 16 | m[ye + 3 | 0] << 24), fi = 1936682341 ^ (cr = m[ye + 4 | 0] | m[ye + 5 | 0] << 8 | m[ye + 6 | 0] << 16 | m[ye + 7 | 0] << 24), ve ^= 1852142177, gr = 1819895653 ^ cr, li = 1852075907 ^ (cr = m[ye + 8 | 0] | m[ye + 9 | 0] << 8 | m[ye + 10 | 0] << 16 | m[ye + 11 | 0] << 24), Tr = 1685025377 ^ (ye = m[ye + 12 | 0] | m[ye + 13 | 0] << 8 | m[ye + 14 | 0] << 16 | m[ye + 15 | 0] << 24), Pr = 2037671283 ^ cr, cr = 1952801890 ^ ye, jr = T, (0 | (pr = (T + E | 0) - (Ne = 7 & T) | 0)) != (0 | E)) for (; T = (Br = cr ^ (Mi = m[E + 4 | 0] | m[E + 5 | 0] << 8 | m[E + 6 | 0] << 16 | m[E + 7 | 0] << 24)) + gr | 0, Pr = M = ve + (ye = Pr ^ (Mr = m[0 | E] | m[E + 1 | 0] << 8 | m[E + 2 | 0] << 16 | m[E + 3 | 0] << 24)) | 0, Nr = T = M >>> 0 < ye >>> 0 ? T + 1 | 0 : T, ve = M, M = T, T = fi + Tr | 0, T = (cr = Jr + li | 0) >>> 0 < Jr >>> 0 ? T + 1 | 0 : T, ti = (gr = Ci(li, Tr, 13) ^ cr) + ve | 0, M = (ve = Qe ^ T) + M | 0, ve = Ci(gr, ve, 17) ^ ti, Jr = Ci(ve, M = (gr = gr >>> 0 > ti >>> 0 ? M + 1 | 0 : M) ^ Qe, 13), fi = Qe, Br = Ci(ye, Br, 16), ye = Nr ^ Qe, Br ^= Pr, Nr = Ci(cr, T, 32), T = Qe + ye | 0, T = (Pr = M) + (M = (cr = Br + Nr | 0) >>> 0 < Nr >>> 0 ? T + 1 | 0 : T) | 0, Nr = T = (Pr = ve + cr | 0) >>> 0 < cr >>> 0 ? T + 1 | 0 : T, Jr = Ci(ve = Pr ^ Jr, T ^= fi, 17), fi = Qe, Br = Ci(Br, ye, 21), ye = M ^ Qe, Br ^= cr, cr = Ci(ti, gr, 32), M = Qe + ye | 0, T = (cr = (gr = Br + cr | 0) >>> 0 < cr >>> 0 ? M + 1 | 0 : M) + T | 0, li = (ve = ve + gr | 0) ^ Jr, M = T = ve >>> 0 < gr >>> 0 ? T + 1 | 0 : T, Tr = T ^ fi, T = Ci(Br, ye, 16), Br = cr ^= Qe, ti = Ci(T ^= gr, cr, 21), gr = Qe, Nr = (cr = Ci(Pr, Nr, 32)) + T | 0, T = Qe + Br | 0, Pr = Nr ^ ti, cr = (T = cr >>> 0 > Nr >>> 0 ? T + 1 | 0 : T) ^ gr, ve = Ci(ve, M, 32), gr = Qe, Jr = Mr ^ Nr, fi = T ^ Mi, (0 | pr) != (0 | (E = E + 8 | 0)); ) ;
                      switch (Mr = 0, ye = jr << 24, Ne - 1 | 0) {
                        case 6:
                          ye |= m[E + 6 | 0] << 16;
                        case 5:
                          ye |= m[E + 5 | 0] << 8;
                        case 4:
                          ye |= m[E + 4 | 0];
                        case 3:
                          Mr |= (T = m[E + 3 | 0]) << 24, ye |= M = T >>> 8 | 0;
                        case 2:
                          Mr |= (M = m[E + 2 | 0]) << 16, ye |= T = M >>> 16 | 0;
                        case 1:
                          Mr |= (T = m[E + 1 | 0]) << 8, ye |= M = T >>> 24 | 0;
                        case 0:
                          Mr = m[0 | E] | Mr;
                      }
                      return ti = ye, E = ye ^ cr, M = Ci(ye = Pr ^ Mr, E, 16), E = E + gr | 0, Nr = E = (Pr = ye + ve | 0) >>> 0 < ve >>> 0 ? E + 1 | 0 : E, jr = Ci(ye = M ^ Pr, E ^= T = Qe, 21), cr = Qe, T = fi + Tr | 0, M = T = (ve = Jr + li | 0) >>> 0 < Jr >>> 0 ? T + 1 | 0 : T, gr = ye, ye = Ci(ve, T, 32), T = Qe + E | 0, E = cr, cr = T = ye >>> 0 > (gr = gr + ye | 0) >>> 0 ? T + 1 | 0 : T, Jr = Ci(ye = gr ^ jr, E ^= T, 16), fi = Qe, T = (ve = Br = Ci(li, Tr, 13) ^ ve) + Pr | 0, M = (Pr = Qe ^ M) + Nr | 0, Nr = ye, ye = Ci(T, M = T >>> 0 < ve >>> 0 ? M + 1 | 0 : M, 32), E = Qe + E | 0, Mi = ye = (ve = ye >>> 0 > (jr = Nr + ye | 0) >>> 0 ? E + 1 | 0 : E) ^ fi, Nr = Jr ^= jr, fi = Ci(Br, Pr, 17) ^ T, T = (Br = Qe ^ M) + cr | 0, E = T = (M = gr = (E = fi) + gr | 0) >>> 0 < E >>> 0 ? T + 1 | 0 : T, cr = Ci(M, T, 32), T = Qe + ye | 0, gr = (Pr = cr + Nr | 0) ^ Mr, ti ^= Nr = cr >>> 0 > Pr >>> 0 ? T + 1 | 0 : T, ye = Ci(fi, Br, 13) ^ M, M = Ci(ye, E ^= Qe, 17), E = E + ve | 0, ye = M ^ (cr = ye + jr | 0), M = E = cr >>> 0 < jr >>> 0 ? E + 1 | 0 : E, T = (E ^= T = Qe) + ti | 0, T = ye >>> 0 > (gr = ye + gr | 0) >>> 0 ? T + 1 | 0 : T, ye = Ci(ye, E, 13) ^ gr, ve = T, jr = Ci(ye, E = T ^ Qe, 17), Mr = Qe, ti = Ci(Jr, Mi, 21), Br = Nr ^ Qe, Nr = Pr ^ ti, cr = 238 ^ Ci(cr, M, 32), T = Qe + Br | 0, T = (ti = E) + (E = (M = Nr + cr | 0) >>> 0 < cr >>> 0 ? T + 1 | 0 : T) | 0, cr = T = (Pr = M + ye | 0) >>> 0 < M >>> 0 ? T + 1 | 0 : T, Mr = Ci(ye = Pr ^ jr, T ^= Mr, 13), ti = Qe, Nr = Ci(Nr, Br, 16), Br = E ^ Qe, jr = M ^ Nr, M = Ci(gr, ve, 32), E = Qe + Br | 0, M = (gr = T) + (T = M >>> 0 > (ve = jr + M | 0) >>> 0 ? E + 1 | 0 : E) | 0, gr = M = (Nr = ye + ve | 0) >>> 0 < ve >>> 0 ? M + 1 | 0 : M, Mr = Ci(ye = Mr ^ Nr, E = M ^ ti, 17), ti = Qe, M = Ci(jr, Br, 21), Br = T ^ Qe, jr = M ^ ve, M = Ci(Pr, cr, 32), T = Qe + Br | 0, T = (M = M >>> 0 > (ve = jr + M | 0) >>> 0 ? T + 1 | 0 : T) + E | 0, cr = T = (Pr = ye + ve | 0) >>> 0 < ve >>> 0 ? T + 1 | 0 : T, Mr = Ci(ye = Pr ^ Mr, E = T ^ ti, 13), ti = Qe, T = Ci(jr, Br, 16), Br = M ^ Qe, jr = T ^ ve, T = Ci(Nr, gr, 32), M = Qe + Br | 0, T = (M = T >>> 0 > (ve = jr + T | 0) >>> 0 ? M + 1 | 0 : M) + E | 0, gr = T = (Nr = ye + ve | 0) >>> 0 < ve >>> 0 ? T + 1 | 0 : T, Mr = Ci(ye = Mr ^ Nr, E = T ^ ti, 17), ti = Qe, T = Ci(jr, Br, 21), Br = M ^ Qe, jr = T ^ ve, ve = Ci(Pr, cr, 32), T = Qe + Br | 0, E = (T = (M = jr + ve | 0) >>> 0 < ve >>> 0 ? T + 1 | 0 : T) + E | 0, ve = E = (cr = M + ye | 0) >>> 0 < M >>> 0 ? E + 1 | 0 : E, Mr = Ci(ye = cr ^ Mr, E ^= ti, 13), ti = Qe, Pr = Ci(jr, Br, 16), jr = T ^ Qe, Pr ^= M, gr = Ci(Nr, gr, 32), T = Qe + jr | 0, T = (Nr = E) + (E = (M = Pr + gr | 0) >>> 0 < gr >>> 0 ? T + 1 | 0 : T) | 0, gr = T = (Nr = M + ye | 0) >>> 0 < M >>> 0 ? T + 1 | 0 : T, Mr = Ci(ye = Mr ^ Nr, T ^= ti, 17), ti = Qe, Pr = Ci(Pr, jr, 21), jr = E ^ Qe, Pr ^= M, M = Ci(cr, ve, 32), E = Qe + jr | 0, M = (cr = T) + (T = M >>> 0 > (ve = Pr + M | 0) >>> 0 ? E + 1 | 0 : E) | 0, cr = ye = (M = (E = ye + ve | 0) >>> 0 < ve >>> 0 ? M + 1 | 0 : M) ^ ti, Mr ^= E, Pr = Ci(Pr, jr, 16), Br = T ^ Qe, ve = (Pr ^= ve) + (gr = Ci(Nr, gr, 32)) | 0, T = Qe + Br | 0, E = Ci(E, M, 32), jr = Qe, M = T = ve >>> 0 < gr >>> 0 ? T + 1 | 0 : T, gr = k, Pr = (Nr = Ci(Pr, Br, 21) ^ ve) ^ E ^ ve ^ Mr, B[0 | gr] = Pr, B[gr + 1 | 0] = Pr >>> 8, B[gr + 2 | 0] = Pr >>> 16, B[gr + 3 | 0] = Pr >>> 24, T = (Br = jr ^ T ^ ye) ^ (ye = T ^ Qe), B[gr + 4 | 0] = T, B[gr + 5 | 0] = T >>> 8, B[gr + 6 | 0] = T >>> 16, B[gr + 7 | 0] = T >>> 24, T = ye + jr | 0, T = (gr = E) >>> 0 > (E = E + Nr | 0) >>> 0 ? T + 1 | 0 : T, ti = E, ye = Ci(Nr, ye, 16) ^ E, Nr = T, jr = E = T ^ Qe, M = (T = cr) + M | 0, cr = ve = (gr = Mr ^= 221) + ve | 0, ve = Ci(ve, M = ve >>> 0 < gr >>> 0 ? M + 1 | 0 : M, 32), E = Qe + E | 0, E = ve >>> 0 > (Pr = ve + ye | 0) >>> 0 ? E + 1 | 0 : E, ve = Ci(ye, jr, 21) ^ Pr, gr = E, fi = Ci(ve, ye = E ^ Qe, 16), Br = Qe, E = Ci(Mr, T, 13), T = Nr + (jr = M ^ Qe) | 0, E = T = (M = ti + (Mr = E ^ cr) | 0) >>> 0 < ti >>> 0 ? T + 1 | 0 : T, cr = ve, ve = Ci(M, T, 32), T = Qe + ye | 0, Br = T = (cr = ve >>> 0 > (Nr = cr + ve | 0) >>> 0 ? T + 1 | 0 : T) ^ Br, ti = Ci(fi ^= Nr, T, 21), ve = Qe, T = Ci(Mr, jr, 17), E = gr + (jr = E ^ Qe) | 0, M = E = (ye = Pr + (Mr = T ^ M) | 0) >>> 0 < Pr >>> 0 ? E + 1 | 0 : E, E = Ci(ye, E, 32), T = Br + Qe | 0, Br = T = (gr = ve) ^ (ve = (E = E + fi | 0) >>> 0 < fi >>> 0 ? T + 1 | 0 : T), gr = E, ti = Ci(fi = ti ^ E, T, 16), Pr = Qe, E = Ci(Mr, jr, 13), T = cr + (jr = M ^ Qe) | 0, E = Ci(ye = Nr + (Mr = E ^ ye) | 0, T = ye >>> 0 < Nr >>> 0 ? T + 1 | 0 : T, 32), M = Br + Qe | 0, Br = M = (cr = (E = E + fi | 0) >>> 0 < fi >>> 0 ? M + 1 | 0 : M) ^ Pr, Nr = E, ti = Ci(fi = ti ^ E, M, 21), Pr = Qe, E = Ci(Mr, jr, 17), T = ve + (jr = T ^ Qe) | 0, M = T = (ye = gr + (Mr = E ^ ye) | 0) >>> 0 < gr >>> 0 ? T + 1 | 0 : T, E = Ci(ye, T, 32), T = Br + Qe | 0, Br = T = (ve = (E = E + fi | 0) >>> 0 < fi >>> 0 ? T + 1 | 0 : T) ^ Pr, gr = E, ti = Ci(fi = ti ^ E, T, 16), Pr = Qe, E = Ci(Mr, jr, 13), M = cr + (jr = M ^ Qe) | 0, T = Ci(ye = Nr + (Mr = E ^ ye) | 0, M = ye >>> 0 < Nr >>> 0 ? M + 1 | 0 : M, 32), E = Br + Qe | 0, cr = T = T + fi | 0, ti = Ci(ti ^ T, (E = T >>> 0 < fi >>> 0 ? E + 1 | 0 : E) ^ Pr, 21), Pr = Qe, Nr = Ci(Mr, jr, 17), T = M ^ Qe, Nr = Ci(M = ye ^ Nr, T, 13), T = T + ve | 0, T = (M = M + gr | 0) >>> 0 < gr >>> 0 ? T + 1 | 0 : T, ye = Ci(ve = M ^ Nr, T ^= ye = Qe, 17) ^ ti, M = Qe ^ Pr, T = E + T | 0, E = Ci(E = ve + cr | 0, T = E >>> 0 < cr >>> 0 ? T + 1 | 0 : T, 32) ^ ye ^ E, B[k + 8 | 0] = E, B[k + 9 | 0] = E >>> 8, B[k + 10 | 0] = E >>> 16, B[k + 11 | 0] = E >>> 24, E = T ^ Qe ^ M, B[k + 12 | 0] = E, B[k + 13 | 0] = E >>> 8, B[k + 14 | 0] = E >>> 16, B[k + 15 | 0] = E >>> 24, 0;
                    }, Tj: function(k, E, T, M, ye) {
                      k |= 0, M |= 0, ye |= 0;
                      var Ne, pr = 0, ve = 0, cr = 0, gr = 0;
                      if (dr = Ne = dr - 112 | 0, pr = E |= 0, E | (ve = T |= 0)) {
                        E = m[ye + 28 | 0] | m[ye + 29 | 0] << 8 | m[ye + 30 | 0] << 16 | m[ye + 31 | 0] << 24, o[Ne + 24 >> 2] = m[ye + 24 | 0] | m[ye + 25 | 0] << 8 | m[ye + 26 | 0] << 16 | m[ye + 27 | 0] << 24, o[Ne + 28 >> 2] = E, E = m[ye + 20 | 0] | m[ye + 21 | 0] << 8 | m[ye + 22 | 0] << 16 | m[ye + 23 | 0] << 24, o[Ne + 16 >> 2] = m[ye + 16 | 0] | m[ye + 17 | 0] << 8 | m[ye + 18 | 0] << 16 | m[ye + 19 | 0] << 24, o[Ne + 20 >> 2] = E, E = m[ye + 4 | 0] | m[ye + 5 | 0] << 8 | m[ye + 6 | 0] << 16 | m[ye + 7 | 0] << 24, o[Ne >> 2] = m[0 | ye] | m[ye + 1 | 0] << 8 | m[ye + 2 | 0] << 16 | m[ye + 3 | 0] << 24, o[Ne + 4 >> 2] = E, E = m[ye + 12 | 0] | m[ye + 13 | 0] << 8 | m[ye + 14 | 0] << 16 | m[ye + 15 | 0] << 24, o[Ne + 8 >> 2] = m[ye + 8 | 0] | m[ye + 9 | 0] << 8 | m[ye + 10 | 0] << 16 | m[ye + 11 | 0] << 24, o[Ne + 12 >> 2] = E, E = m[0 | M] | m[M + 1 | 0] << 8 | m[M + 2 | 0] << 16 | m[M + 3 | 0] << 24, T = m[M + 4 | 0] | m[M + 5 | 0] << 8 | m[M + 6 | 0] << 16 | m[M + 7 | 0] << 24, o[Ne + 104 >> 2] = 0, o[Ne + 108 >> 2] = 0, o[Ne + 96 >> 2] = E, o[Ne + 100 >> 2] = T;
                        e: {
                          if (!ve & pr >>> 0 >= 64 | ve) {
                            for (; Du(k, Ne + 96 | 0, Ne, 0), E = m[Ne + 104 | 0] + 1 | 0, B[Ne + 104 | 0] = E, E = m[Ne + 105 | 0] + (E >>> 8 | 0) | 0, B[Ne + 105 | 0] = E, E = m[Ne + 106 | 0] + (E >>> 8 | 0) | 0, B[Ne + 106 | 0] = E, E = m[Ne + 107 | 0] + (E >>> 8 | 0) | 0, B[Ne + 107 | 0] = E, E = m[Ne + 108 | 0] + (E >>> 8 | 0) | 0, B[Ne + 108 | 0] = E, E = m[Ne + 109 | 0] + (E >>> 8 | 0) | 0, B[Ne + 109 | 0] = E, E = m[Ne + 110 | 0] + (E >>> 8 | 0) | 0, B[Ne + 110 | 0] = E, B[Ne + 111 | 0] = m[Ne + 111 | 0] + (E >>> 8 | 0), k = k - -64 | 0, ve = ve - 1 | 0, !(ve = (pr = pr + -64 | 0) >>> 0 < 4294967232 ? ve + 1 | 0 : ve) & pr >>> 0 > 63 | ve; ) ;
                            if (!(pr | ve)) break e;
                          }
                          if (T = 0, Du(Ne + 32 | 0, Ne + 96 | 0, Ne, 0), M = 3 & pr, E = 0, !ve & pr >>> 0 >= 4 | ve) for (ve = 60 & pr, ye = 0; pr = gr = Ne + 32 | 0, B[k + E | 0] = m[pr + E | 0], B[(cr = 1 | E) + k | 0] = m[pr + cr | 0], B[(cr = 2 | E) + k | 0] = m[pr + cr | 0], B[(pr = 3 | E) + k | 0] = m[pr + gr | 0], E = E + 4 | 0, (0 | ve) != (0 | (ye = ye + 4 | 0)); ) ;
                          if (M) for (; B[k + E | 0] = m[(Ne + 32 | 0) + E | 0], E = E + 1 | 0, (0 | M) != (0 | (T = T + 1 | 0)); ) ;
                        }
                        _s(Ne + 32 | 0, 64), _s(Ne, 32);
                      }
                      return dr = Ne + 112 | 0, 0;
                    }, Uj: function(k, E, T, M, ye, Ne) {
                      k |= 0, E |= 0, ye |= 0, Ne |= 0;
                      var pr, ve = 0, cr = 0;
                      if (dr = pr = dr - 112 | 0, ve = T |= 0, (M |= 0) | T) {
                        T = m[Ne + 28 | 0] | m[Ne + 29 | 0] << 8 | m[Ne + 30 | 0] << 16 | m[Ne + 31 | 0] << 24, o[pr + 24 >> 2] = m[Ne + 24 | 0] | m[Ne + 25 | 0] << 8 | m[Ne + 26 | 0] << 16 | m[Ne + 27 | 0] << 24, o[pr + 28 >> 2] = T, T = m[Ne + 20 | 0] | m[Ne + 21 | 0] << 8 | m[Ne + 22 | 0] << 16 | m[Ne + 23 | 0] << 24, o[pr + 16 >> 2] = m[Ne + 16 | 0] | m[Ne + 17 | 0] << 8 | m[Ne + 18 | 0] << 16 | m[Ne + 19 | 0] << 24, o[pr + 20 >> 2] = T, T = m[Ne + 4 | 0] | m[Ne + 5 | 0] << 8 | m[Ne + 6 | 0] << 16 | m[Ne + 7 | 0] << 24, o[pr >> 2] = m[0 | Ne] | m[Ne + 1 | 0] << 8 | m[Ne + 2 | 0] << 16 | m[Ne + 3 | 0] << 24, o[pr + 4 >> 2] = T, T = m[Ne + 12 | 0] | m[Ne + 13 | 0] << 8 | m[Ne + 14 | 0] << 16 | m[Ne + 15 | 0] << 24, o[pr + 8 >> 2] = m[Ne + 8 | 0] | m[Ne + 9 | 0] << 8 | m[Ne + 10 | 0] << 16 | m[Ne + 11 | 0] << 24, o[pr + 12 >> 2] = T, T = m[0 | ye] | m[ye + 1 | 0] << 8 | m[ye + 2 | 0] << 16 | m[ye + 3 | 0] << 24, ye = m[ye + 4 | 0] | m[ye + 5 | 0] << 8 | m[ye + 6 | 0] << 16 | m[ye + 7 | 0] << 24, o[pr + 104 >> 2] = 0, o[pr + 108 >> 2] = 0, o[pr + 96 >> 2] = T, o[pr + 100 >> 2] = ye;
                        e: {
                          if (!M & ve >>> 0 >= 64 | M) {
                            for (; ; ) {
                              for (T = 0, Du(pr + 32 | 0, pr + 96 | 0, pr, 0); Ne = pr + 32 | 0, B[k + T | 0] = m[Ne + T | 0] ^ m[E + T | 0], B[(ye = 1 | T) + k | 0] = m[ye + Ne | 0] ^ m[E + ye | 0], (0 | (T = T + 2 | 0)) != 64; ) ;
                              if (T = m[pr + 104 | 0] + 1 | 0, B[pr + 104 | 0] = T, T = m[pr + 105 | 0] + (T >>> 8 | 0) | 0, B[pr + 105 | 0] = T, T = m[pr + 106 | 0] + (T >>> 8 | 0) | 0, B[pr + 106 | 0] = T, T = m[pr + 107 | 0] + (T >>> 8 | 0) | 0, B[pr + 107 | 0] = T, T = m[pr + 108 | 0] + (T >>> 8 | 0) | 0, B[pr + 108 | 0] = T, T = m[pr + 109 | 0] + (T >>> 8 | 0) | 0, B[pr + 109 | 0] = T, T = m[pr + 110 | 0] + (T >>> 8 | 0) | 0, B[pr + 110 | 0] = T, B[pr + 111 | 0] = m[pr + 111 | 0] + (T >>> 8 | 0), E = E - -64 | 0, k = k - -64 | 0, M = M - 1 | 0, !(!(M = (ve = ve + -64 | 0) >>> 0 < 4294967232 ? M + 1 | 0 : M) & ve >>> 0 > 63 | M)) break;
                            }
                            if (!(M | ve)) break e;
                          }
                          if (T = 0, Du(pr + 32 | 0, pr + 96 | 0, pr, 0), Ne = 1 & ve, (0 | ve) != 1 | M) for (ve &= 62, M = 0; cr = pr + 32 | 0, B[k + T | 0] = m[cr + T | 0] ^ m[E + T | 0], B[(ye = 1 | T) + k | 0] = m[ye + cr | 0] ^ m[E + ye | 0], T = T + 2 | 0, (0 | ve) != (0 | (M = M + 2 | 0)); ) ;
                          Ne && (B[k + T | 0] = m[(pr + 32 | 0) + T | 0] ^ m[E + T | 0]);
                        }
                        _s(pr + 32 | 0, 64), _s(pr, 32);
                      }
                      return dr = pr + 112 | 0, 0;
                    }, Vj: Js, Wj: $f, Xj: D2, Yj: cf, Zj: function(k, E, T, M, ye) {
                      k |= 0, M |= 0, ye |= 0;
                      var Ne, pr = 0, ve = 0, cr = 0, gr = 0;
                      if (dr = Ne = dr - 112 | 0, pr = E |= 0, E | (ve = T |= 0)) {
                        E = m[ye + 28 | 0] | m[ye + 29 | 0] << 8 | m[ye + 30 | 0] << 16 | m[ye + 31 | 0] << 24, o[Ne + 24 >> 2] = m[ye + 24 | 0] | m[ye + 25 | 0] << 8 | m[ye + 26 | 0] << 16 | m[ye + 27 | 0] << 24, o[Ne + 28 >> 2] = E, E = m[ye + 20 | 0] | m[ye + 21 | 0] << 8 | m[ye + 22 | 0] << 16 | m[ye + 23 | 0] << 24, o[Ne + 16 >> 2] = m[ye + 16 | 0] | m[ye + 17 | 0] << 8 | m[ye + 18 | 0] << 16 | m[ye + 19 | 0] << 24, o[Ne + 20 >> 2] = E, E = m[ye + 4 | 0] | m[ye + 5 | 0] << 8 | m[ye + 6 | 0] << 16 | m[ye + 7 | 0] << 24, o[Ne >> 2] = m[0 | ye] | m[ye + 1 | 0] << 8 | m[ye + 2 | 0] << 16 | m[ye + 3 | 0] << 24, o[Ne + 4 >> 2] = E, E = m[ye + 12 | 0] | m[ye + 13 | 0] << 8 | m[ye + 14 | 0] << 16 | m[ye + 15 | 0] << 24, o[Ne + 8 >> 2] = m[ye + 8 | 0] | m[ye + 9 | 0] << 8 | m[ye + 10 | 0] << 16 | m[ye + 11 | 0] << 24, o[Ne + 12 >> 2] = E, E = m[0 | M] | m[M + 1 | 0] << 8 | m[M + 2 | 0] << 16 | m[M + 3 | 0] << 24, T = m[M + 4 | 0] | m[M + 5 | 0] << 8 | m[M + 6 | 0] << 16 | m[M + 7 | 0] << 24, o[Ne + 104 >> 2] = 0, o[Ne + 108 >> 2] = 0, o[Ne + 96 >> 2] = E, o[Ne + 100 >> 2] = T;
                        e: {
                          if (!ve & pr >>> 0 >= 64 | ve) {
                            for (; fu(k, Ne + 96 | 0, Ne, 0), E = m[Ne + 104 | 0] + 1 | 0, B[Ne + 104 | 0] = E, E = m[Ne + 105 | 0] + (E >>> 8 | 0) | 0, B[Ne + 105 | 0] = E, E = m[Ne + 106 | 0] + (E >>> 8 | 0) | 0, B[Ne + 106 | 0] = E, E = m[Ne + 107 | 0] + (E >>> 8 | 0) | 0, B[Ne + 107 | 0] = E, E = m[Ne + 108 | 0] + (E >>> 8 | 0) | 0, B[Ne + 108 | 0] = E, E = m[Ne + 109 | 0] + (E >>> 8 | 0) | 0, B[Ne + 109 | 0] = E, E = m[Ne + 110 | 0] + (E >>> 8 | 0) | 0, B[Ne + 110 | 0] = E, B[Ne + 111 | 0] = m[Ne + 111 | 0] + (E >>> 8 | 0), k = k - -64 | 0, ve = ve - 1 | 0, !(ve = (pr = pr + -64 | 0) >>> 0 < 4294967232 ? ve + 1 | 0 : ve) & pr >>> 0 > 63 | ve; ) ;
                            if (!(pr | ve)) break e;
                          }
                          if (T = 0, fu(Ne + 32 | 0, Ne + 96 | 0, Ne, 0), M = 3 & pr, E = 0, !ve & pr >>> 0 >= 4 | ve) for (ve = 60 & pr, ye = 0; pr = gr = Ne + 32 | 0, B[k + E | 0] = m[pr + E | 0], B[(cr = 1 | E) + k | 0] = m[pr + cr | 0], B[(cr = 2 | E) + k | 0] = m[pr + cr | 0], B[(pr = 3 | E) + k | 0] = m[pr + gr | 0], E = E + 4 | 0, (0 | ve) != (0 | (ye = ye + 4 | 0)); ) ;
                          if (M) for (; B[k + E | 0] = m[(Ne + 32 | 0) + E | 0], E = E + 1 | 0, (0 | M) != (0 | (T = T + 1 | 0)); ) ;
                        }
                        _s(Ne + 32 | 0, 64), _s(Ne, 32);
                      }
                      return dr = Ne + 112 | 0, 0;
                    }, _j: function(k, E, T, M, ye, Ne) {
                      k |= 0, E |= 0, ye |= 0, Ne |= 0;
                      var pr, ve = 0, cr = 0;
                      if (dr = pr = dr - 112 | 0, ve = T |= 0, (M |= 0) | T) {
                        T = m[Ne + 28 | 0] | m[Ne + 29 | 0] << 8 | m[Ne + 30 | 0] << 16 | m[Ne + 31 | 0] << 24, o[pr + 24 >> 2] = m[Ne + 24 | 0] | m[Ne + 25 | 0] << 8 | m[Ne + 26 | 0] << 16 | m[Ne + 27 | 0] << 24, o[pr + 28 >> 2] = T, T = m[Ne + 20 | 0] | m[Ne + 21 | 0] << 8 | m[Ne + 22 | 0] << 16 | m[Ne + 23 | 0] << 24, o[pr + 16 >> 2] = m[Ne + 16 | 0] | m[Ne + 17 | 0] << 8 | m[Ne + 18 | 0] << 16 | m[Ne + 19 | 0] << 24, o[pr + 20 >> 2] = T, T = m[Ne + 4 | 0] | m[Ne + 5 | 0] << 8 | m[Ne + 6 | 0] << 16 | m[Ne + 7 | 0] << 24, o[pr >> 2] = m[0 | Ne] | m[Ne + 1 | 0] << 8 | m[Ne + 2 | 0] << 16 | m[Ne + 3 | 0] << 24, o[pr + 4 >> 2] = T, T = m[Ne + 12 | 0] | m[Ne + 13 | 0] << 8 | m[Ne + 14 | 0] << 16 | m[Ne + 15 | 0] << 24, o[pr + 8 >> 2] = m[Ne + 8 | 0] | m[Ne + 9 | 0] << 8 | m[Ne + 10 | 0] << 16 | m[Ne + 11 | 0] << 24, o[pr + 12 >> 2] = T, T = m[0 | ye] | m[ye + 1 | 0] << 8 | m[ye + 2 | 0] << 16 | m[ye + 3 | 0] << 24, ye = m[ye + 4 | 0] | m[ye + 5 | 0] << 8 | m[ye + 6 | 0] << 16 | m[ye + 7 | 0] << 24, o[pr + 104 >> 2] = 0, o[pr + 108 >> 2] = 0, o[pr + 96 >> 2] = T, o[pr + 100 >> 2] = ye;
                        e: {
                          if (!M & ve >>> 0 >= 64 | M) {
                            for (; ; ) {
                              for (T = 0, fu(pr + 32 | 0, pr + 96 | 0, pr, 0); Ne = pr + 32 | 0, B[k + T | 0] = m[Ne + T | 0] ^ m[E + T | 0], B[(ye = 1 | T) + k | 0] = m[ye + Ne | 0] ^ m[E + ye | 0], (0 | (T = T + 2 | 0)) != 64; ) ;
                              if (T = m[pr + 104 | 0] + 1 | 0, B[pr + 104 | 0] = T, T = m[pr + 105 | 0] + (T >>> 8 | 0) | 0, B[pr + 105 | 0] = T, T = m[pr + 106 | 0] + (T >>> 8 | 0) | 0, B[pr + 106 | 0] = T, T = m[pr + 107 | 0] + (T >>> 8 | 0) | 0, B[pr + 107 | 0] = T, T = m[pr + 108 | 0] + (T >>> 8 | 0) | 0, B[pr + 108 | 0] = T, T = m[pr + 109 | 0] + (T >>> 8 | 0) | 0, B[pr + 109 | 0] = T, T = m[pr + 110 | 0] + (T >>> 8 | 0) | 0, B[pr + 110 | 0] = T, B[pr + 111 | 0] = m[pr + 111 | 0] + (T >>> 8 | 0), E = E - -64 | 0, k = k - -64 | 0, M = M - 1 | 0, !(!(M = (ve = ve + -64 | 0) >>> 0 < 4294967232 ? M + 1 | 0 : M) & ve >>> 0 > 63 | M)) break;
                            }
                            if (!(M | ve)) break e;
                          }
                          if (T = 0, fu(pr + 32 | 0, pr + 96 | 0, pr, 0), Ne = 1 & ve, (0 | ve) != 1 | M) for (ve &= 62, M = 0; cr = pr + 32 | 0, B[k + T | 0] = m[cr + T | 0] ^ m[E + T | 0], B[(ye = 1 | T) + k | 0] = m[ye + cr | 0] ^ m[E + ye | 0], T = T + 2 | 0, (0 | ve) != (0 | (M = M + 2 | 0)); ) ;
                          Ne && (B[k + T | 0] = m[(pr + 32 | 0) + T | 0] ^ m[E + T | 0]);
                        }
                        _s(pr + 32 | 0, 64), _s(pr, 32);
                      }
                      return dr = pr + 112 | 0, 0;
                    }, $j: Js, ak: $f, bk: D2, ck: cf, dk: Js, ek: rc, fk: D2, gk: function(k, E, T, M, ye) {
                      var Ne;
                      return k |= 0, E |= 0, T |= 0, dr = Ne = dr - 32 | 0, ba(Ne, M |= 0, ye |= 0, 0), k = ku(k, E, T, M + 16 | 0, Ne), dr = Ne + 32 | 0, 0 | k;
                    }, hk: function(k, E, T, M, ye, Ne, pr, ve) {
                      var cr;
                      return k |= 0, E |= 0, T |= 0, M |= 0, Ne |= 0, pr |= 0, dr = cr = dr - 32 | 0, ba(cr, ye |= 0, ve |= 0, 0), k = Cc(ve = k, E, (k = 0) | T, M, ye + 16 | 0, k | Ne, pr, cr), dr = cr + 32 | 0, 0 | k;
                    }, ik: function(k, E, T, M, ye, Ne) {
                      var pr;
                      return k |= 0, E |= 0, T |= 0, M |= 0, dr = pr = dr - 32 | 0, ba(pr, ye |= 0, Ne |= 0, 0), k = Cc(k, E, T, M, ye + 16 | 0, 0, 0, pr), dr = pr + 32 | 0, 0 | k;
                    }, jk: cf, kk: un, lk: js, mk: Af };
                  }(Lr);
                }(xi);
              }, instantiate: function(vi, xi) {
                return { then: function(Lr) {
                  var dn = new vo.Module(vi);
                  Lr({ instance: new vo.Instance(dn, xi) });
                } };
              }, RuntimeError: Error };
              pn = [];
              var Hi, di, Ui, ln, Un, Bo, co, To = !1;
              function xs() {
                var vi = Rn.buffer;
                Er.HEAP8 = Hi = new Int8Array(vi), Er.HEAP16 = Ui = new Int16Array(vi), Er.HEAPU8 = di = new Uint8Array(vi), Er.HEAPU16 = new Uint16Array(vi), Er.HEAP32 = ln = new Int32Array(vi), Er.HEAPU32 = Un = new Uint32Array(vi), Er.HEAPF32 = Bo = new Float32Array(vi), Er.HEAPF64 = co = new Float64Array(vi);
              }
              var Fo = [], Zo = [], $s = [], rs = 0, ls = null;
              function na(vi) {
                var xi;
                throw (xi = Er.onAbort) == null || xi.call(Er, vi), hn(vi = "Aborted(" + vi + ")"), To = !0, vi += ". Build with -sASSERTIONS for more info.", new vo.RuntimeError(vi);
              }
              var os, fs = (vi) => vi.startsWith("file://"), da = { 36800: () => Er.getRandomValue(), 36836: () => {
                if (Er.getRandomValue === void 0) try {
                  var vi = typeof window == "object" ? window : self, xi = vi.crypto !== void 0 ? vi.crypto : vi.msCrypto;
                  xi = xi === void 0 ? dn : xi;
                  var Lr = function() {
                    var oi = new Uint32Array(1);
                    return xi.getRandomValues(oi), oi[0] >>> 0;
                  };
                  Lr(), Er.getRandomValue = Lr;
                } catch {
                  try {
                    var dn = requireCryptoBrowserify(), xn = function() {
                      var Yr = dn.randomBytes(4);
                      return (Yr[0] << 24 | Yr[1] << 16 | Yr[2] << 8 | Yr[3]) >>> 0;
                    };
                    xn(), Er.getRandomValue = xn;
                  } catch {
                    throw "No secure random number generator found";
                  }
                }
              } }, Bn = (vi) => {
                for (; vi.length > 0; ) vi.shift()(Er);
              };
              Er.noExitRuntime;
              var hi, Ii = typeof TextDecoder < "u" ? new TextDecoder() : void 0, Gi = (vi, xi) => vi ? ((Lr, dn, xn) => {
                for (var oi = dn + xn, Yr = dn; Lr[Yr] && !(Yr >= oi); ) ++Yr;
                if (Yr - dn > 16 && Lr.buffer && Ii) return Ii.decode(Lr.subarray(dn, Yr));
                for (var ji = ""; dn < Yr; ) {
                  var Cn = Lr[dn++];
                  if (128 & Cn) {
                    var Mn = 63 & Lr[dn++];
                    if ((224 & Cn) != 192) {
                      var B = 63 & Lr[dn++];
                      if ((Cn = (240 & Cn) == 224 ? (15 & Cn) << 12 | Mn << 6 | B : (7 & Cn) << 18 | Mn << 12 | B << 6 | 63 & Lr[dn++]) < 65536) ji += String.fromCharCode(Cn);
                      else {
                        var o = Cn - 65536;
                        ji += String.fromCharCode(55296 | o >> 10, 56320 | 1023 & o);
                      }
                    } else ji += String.fromCharCode((31 & Cn) << 6 | Mn);
                  } else ji += String.fromCharCode(Cn);
                }
                return ji;
              })(di, vi, xi) : "", kn = [], ho = (vi) => {
                var xi = (vi - Rn.buffer.byteLength + 65535) / 65536;
                try {
                  return Rn.grow(xi), xs(), 1;
                } catch {
                }
              }, eo = { b: (vi, xi, Lr, dn) => {
                na(`Assertion failed: ${Gi(vi)}, at: ` + [xi ? Gi(xi) : "unknown filename", Lr, dn ? Gi(dn) : "unknown function"]);
              }, c: () => {
                na("");
              }, a: (vi, xi, Lr) => ((dn, xn, oi) => {
                var Yr = ((ji, Cn) => {
                  var Mn;
                  for (kn.length = 0; Mn = di[ji++]; ) {
                    var B = Mn != 105;
                    Cn += (B &= Mn != 112) && Cn % 8 ? 4 : 0, kn.push(Mn == 112 ? Un[Cn >> 2] : Mn == 105 ? ln[Cn >> 2] : co[Cn >> 3]), Cn += B ? 8 : 4;
                  }
                  return kn;
                })(xn, oi);
                return da[dn](...Yr);
              })(vi, xi, Lr), d: (vi) => {
                var xi = di.length, Lr = 2147483648;
                if ((vi >>>= 0) > Lr) return !1;
                for (var dn, xn = 1; xn <= 4; xn *= 2) {
                  var oi = xi * (1 + 0.2 / xn);
                  oi = Math.min(oi, vi + 100663296);
                  var Yr = Math.min(Lr, (dn = Math.max(vi, oi)) + (65536 - dn % 65536) % 65536);
                  if (ho(Yr)) return !0;
                }
                return !1;
              } }, Ei = function() {
                var Lr;
                var vi = { a: eo };
                function xi(dn, xn) {
                  var oi;
                  return Ei = dn.exports, Rn = Ei.e, xs(), oi = Ei.f, Zo.unshift(oi), function(Yr) {
                    var Cn;
                    if (rs--, (Cn = Er.monitorRunDependencies) == null || Cn.call(Er, rs), rs == 0 && ls) {
                      var ji = ls;
                      ls = null, ji();
                    }
                  }(), Ei;
                }
                if (rs++, (Lr = Er.monitorRunDependencies) == null || Lr.call(Er, rs), Er.instantiateWasm) try {
                  return Er.instantiateWasm(vi, xi);
                } catch (dn) {
                  return hn(`Module.instantiateWasm callback failed with error: ${dn}`), !1;
                }
                return os || (os = "<<< WASM_BINARY_FILE >>>"), function(dn, xn, oi) {
                  (function(Yr) {
                    return Promise.resolve().then(() => function(ji) {
                      if (ji == os && pn) return new Uint8Array(pn);
                      if (_i) return _i(ji);
                      throw "both async and sync fetching of the wasm failed";
                    }(Yr));
                  })(dn).then((Yr) => vo.instantiate(Yr, xn)).then(oi, (Yr) => {
                    hn(`failed to asynchronously prepare wasm: ${Yr}`), na(Yr);
                  });
                }(os, vi, function(dn) {
                  xi(dn.instance);
                }), {};
              }();
              function vs() {
                function vi() {
                  var xi;
                  hi || (hi = !0, Er.calledRun = !0, To || (Bn(Zo), (xi = Er.onRuntimeInitialized) == null || xi.call(Er), function() {
                    if (Er.postRun) for (typeof Er.postRun == "function" && (Er.postRun = [Er.postRun]); Er.postRun.length; ) Lr = Er.postRun.shift(), $s.unshift(Lr);
                    var Lr;
                    Bn($s);
                  }()));
                }
                rs > 0 || (function() {
                  if (Er.preRun) for (typeof Er.preRun == "function" && (Er.preRun = [Er.preRun]); Er.preRun.length; ) xi = Er.preRun.shift(), Fo.unshift(xi);
                  var xi;
                  Bn(Fo);
                }(), rs > 0 || (Er.setStatus ? (Er.setStatus("Running..."), setTimeout(function() {
                  setTimeout(function() {
                    Er.setStatus("");
                  }, 1), vi();
                }, 1)) : vi()));
              }
              if (Er._crypto_aead_aegis128l_keybytes = () => (Er._crypto_aead_aegis128l_keybytes = Ei.g)(), Er._crypto_aead_aegis128l_nsecbytes = () => (Er._crypto_aead_aegis128l_nsecbytes = Ei.h)(), Er._crypto_aead_aegis128l_npubbytes = () => (Er._crypto_aead_aegis128l_npubbytes = Ei.i)(), Er._crypto_aead_aegis128l_abytes = () => (Er._crypto_aead_aegis128l_abytes = Ei.j)(), Er._crypto_aead_aegis128l_messagebytes_max = () => (Er._crypto_aead_aegis128l_messagebytes_max = Ei.k)(), Er._crypto_aead_aegis128l_keygen = (vi) => (Er._crypto_aead_aegis128l_keygen = Ei.l)(vi), Er._crypto_aead_aegis128l_encrypt = (vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn, B) => (Er._crypto_aead_aegis128l_encrypt = Ei.m)(vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn, B), Er._crypto_aead_aegis128l_encrypt_detached = (vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn, B, o) => (Er._crypto_aead_aegis128l_encrypt_detached = Ei.n)(vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn, B, o), Er._crypto_aead_aegis128l_decrypt = (vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn, B) => (Er._crypto_aead_aegis128l_decrypt = Ei.o)(vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn, B), Er._crypto_aead_aegis128l_decrypt_detached = (vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn, B) => (Er._crypto_aead_aegis128l_decrypt_detached = Ei.p)(vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn, B), Er._crypto_aead_aegis256_keybytes = () => (Er._crypto_aead_aegis256_keybytes = Ei.q)(), Er._crypto_aead_aegis256_nsecbytes = () => (Er._crypto_aead_aegis256_nsecbytes = Ei.r)(), Er._crypto_aead_aegis256_npubbytes = () => (Er._crypto_aead_aegis256_npubbytes = Ei.s)(), Er._crypto_aead_aegis256_abytes = () => (Er._crypto_aead_aegis256_abytes = Ei.t)(), Er._crypto_aead_aegis256_messagebytes_max = () => (Er._crypto_aead_aegis256_messagebytes_max = Ei.u)(), Er._crypto_aead_aegis256_keygen = (vi) => (Er._crypto_aead_aegis256_keygen = Ei.v)(vi), Er._crypto_aead_aegis256_encrypt = (vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn, B) => (Er._crypto_aead_aegis256_encrypt = Ei.w)(vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn, B), Er._crypto_aead_aegis256_encrypt_detached = (vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn, B, o) => (Er._crypto_aead_aegis256_encrypt_detached = Ei.x)(vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn, B, o), Er._crypto_aead_aegis256_decrypt = (vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn, B) => (Er._crypto_aead_aegis256_decrypt = Ei.y)(vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn, B), Er._crypto_aead_aegis256_decrypt_detached = (vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn, B) => (Er._crypto_aead_aegis256_decrypt_detached = Ei.z)(vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn, B), Er._crypto_aead_aes256gcm_is_available = () => (Er._crypto_aead_aes256gcm_is_available = Ei.A)(), Er._crypto_aead_chacha20poly1305_encrypt_detached = (vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn, B, o) => (Er._crypto_aead_chacha20poly1305_encrypt_detached = Ei.B)(vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn, B, o), Er._crypto_aead_chacha20poly1305_encrypt = (vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn, B) => (Er._crypto_aead_chacha20poly1305_encrypt = Ei.C)(vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn, B), Er._crypto_aead_chacha20poly1305_ietf_encrypt_detached = (vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn, B, o) => (Er._crypto_aead_chacha20poly1305_ietf_encrypt_detached = Ei.D)(vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn, B, o), Er._crypto_aead_chacha20poly1305_ietf_encrypt = (vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn, B) => (Er._crypto_aead_chacha20poly1305_ietf_encrypt = Ei.E)(vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn, B), Er._crypto_aead_chacha20poly1305_decrypt_detached = (vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn, B) => (Er._crypto_aead_chacha20poly1305_decrypt_detached = Ei.F)(vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn, B), Er._crypto_aead_chacha20poly1305_decrypt = (vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn, B) => (Er._crypto_aead_chacha20poly1305_decrypt = Ei.G)(vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn, B), Er._crypto_aead_chacha20poly1305_ietf_decrypt_detached = (vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn, B) => (Er._crypto_aead_chacha20poly1305_ietf_decrypt_detached = Ei.H)(vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn, B), Er._crypto_aead_chacha20poly1305_ietf_decrypt = (vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn, B) => (Er._crypto_aead_chacha20poly1305_ietf_decrypt = Ei.I)(vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn, B), Er._crypto_aead_chacha20poly1305_ietf_keybytes = () => (Er._crypto_aead_chacha20poly1305_ietf_keybytes = Ei.J)(), Er._crypto_aead_chacha20poly1305_ietf_npubbytes = () => (Er._crypto_aead_chacha20poly1305_ietf_npubbytes = Ei.K)(), Er._crypto_aead_chacha20poly1305_ietf_nsecbytes = () => (Er._crypto_aead_chacha20poly1305_ietf_nsecbytes = Ei.L)(), Er._crypto_aead_chacha20poly1305_ietf_abytes = () => (Er._crypto_aead_chacha20poly1305_ietf_abytes = Ei.M)(), Er._crypto_aead_chacha20poly1305_ietf_messagebytes_max = () => (Er._crypto_aead_chacha20poly1305_ietf_messagebytes_max = Ei.N)(), Er._crypto_aead_chacha20poly1305_ietf_keygen = (vi) => (Er._crypto_aead_chacha20poly1305_ietf_keygen = Ei.O)(vi), Er._crypto_aead_chacha20poly1305_keybytes = () => (Er._crypto_aead_chacha20poly1305_keybytes = Ei.P)(), Er._crypto_aead_chacha20poly1305_npubbytes = () => (Er._crypto_aead_chacha20poly1305_npubbytes = Ei.Q)(), Er._crypto_aead_chacha20poly1305_nsecbytes = () => (Er._crypto_aead_chacha20poly1305_nsecbytes = Ei.R)(), Er._crypto_aead_chacha20poly1305_abytes = () => (Er._crypto_aead_chacha20poly1305_abytes = Ei.S)(), Er._crypto_aead_chacha20poly1305_messagebytes_max = () => (Er._crypto_aead_chacha20poly1305_messagebytes_max = Ei.T)(), Er._crypto_aead_chacha20poly1305_keygen = (vi) => (Er._crypto_aead_chacha20poly1305_keygen = Ei.U)(vi), Er._crypto_aead_xchacha20poly1305_ietf_encrypt_detached = (vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn, B, o) => (Er._crypto_aead_xchacha20poly1305_ietf_encrypt_detached = Ei.V)(vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn, B, o), Er._crypto_aead_xchacha20poly1305_ietf_encrypt = (vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn, B) => (Er._crypto_aead_xchacha20poly1305_ietf_encrypt = Ei.W)(vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn, B), Er._crypto_aead_xchacha20poly1305_ietf_decrypt_detached = (vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn, B) => (Er._crypto_aead_xchacha20poly1305_ietf_decrypt_detached = Ei.X)(vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn, B), Er._crypto_aead_xchacha20poly1305_ietf_decrypt = (vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn, B) => (Er._crypto_aead_xchacha20poly1305_ietf_decrypt = Ei.Y)(vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn, B), Er._crypto_aead_xchacha20poly1305_ietf_keybytes = () => (Er._crypto_aead_xchacha20poly1305_ietf_keybytes = Ei.Z)(), Er._crypto_aead_xchacha20poly1305_ietf_npubbytes = () => (Er._crypto_aead_xchacha20poly1305_ietf_npubbytes = Ei._)(), Er._crypto_aead_xchacha20poly1305_ietf_nsecbytes = () => (Er._crypto_aead_xchacha20poly1305_ietf_nsecbytes = Ei.$)(), Er._crypto_aead_xchacha20poly1305_ietf_abytes = () => (Er._crypto_aead_xchacha20poly1305_ietf_abytes = Ei.aa)(), Er._crypto_aead_xchacha20poly1305_ietf_messagebytes_max = () => (Er._crypto_aead_xchacha20poly1305_ietf_messagebytes_max = Ei.ba)(), Er._crypto_aead_xchacha20poly1305_ietf_keygen = (vi) => (Er._crypto_aead_xchacha20poly1305_ietf_keygen = Ei.ca)(vi), Er._crypto_auth_bytes = () => (Er._crypto_auth_bytes = Ei.da)(), Er._crypto_auth_keybytes = () => (Er._crypto_auth_keybytes = Ei.ea)(), Er._crypto_auth_primitive = () => (Er._crypto_auth_primitive = Ei.fa)(), Er._crypto_auth = (vi, xi, Lr, dn, xn) => (Er._crypto_auth = Ei.ga)(vi, xi, Lr, dn, xn), Er._crypto_auth_verify = (vi, xi, Lr, dn, xn) => (Er._crypto_auth_verify = Ei.ha)(vi, xi, Lr, dn, xn), Er._crypto_auth_keygen = (vi) => (Er._crypto_auth_keygen = Ei.ia)(vi), Er._crypto_auth_hmacsha256_bytes = () => (Er._crypto_auth_hmacsha256_bytes = Ei.ja)(), Er._crypto_auth_hmacsha256_keybytes = () => (Er._crypto_auth_hmacsha256_keybytes = Ei.ka)(), Er._crypto_auth_hmacsha256_statebytes = () => (Er._crypto_auth_hmacsha256_statebytes = Ei.la)(), Er._crypto_auth_hmacsha256_keygen = (vi) => (Er._crypto_auth_hmacsha256_keygen = Ei.ma)(vi), Er._crypto_auth_hmacsha256_init = (vi, xi, Lr) => (Er._crypto_auth_hmacsha256_init = Ei.na)(vi, xi, Lr), Er._crypto_auth_hmacsha256_update = (vi, xi, Lr, dn) => (Er._crypto_auth_hmacsha256_update = Ei.oa)(vi, xi, Lr, dn), Er._crypto_auth_hmacsha256_final = (vi, xi) => (Er._crypto_auth_hmacsha256_final = Ei.pa)(vi, xi), Er._crypto_auth_hmacsha256 = (vi, xi, Lr, dn, xn) => (Er._crypto_auth_hmacsha256 = Ei.qa)(vi, xi, Lr, dn, xn), Er._crypto_auth_hmacsha256_verify = (vi, xi, Lr, dn, xn) => (Er._crypto_auth_hmacsha256_verify = Ei.ra)(vi, xi, Lr, dn, xn), Er._crypto_auth_hmacsha512_bytes = () => (Er._crypto_auth_hmacsha512_bytes = Ei.sa)(), Er._crypto_auth_hmacsha512_keybytes = () => (Er._crypto_auth_hmacsha512_keybytes = Ei.ta)(), Er._crypto_auth_hmacsha512_statebytes = () => (Er._crypto_auth_hmacsha512_statebytes = Ei.ua)(), Er._crypto_auth_hmacsha512_keygen = (vi) => (Er._crypto_auth_hmacsha512_keygen = Ei.va)(vi), Er._crypto_auth_hmacsha512_init = (vi, xi, Lr) => (Er._crypto_auth_hmacsha512_init = Ei.wa)(vi, xi, Lr), Er._crypto_auth_hmacsha512_update = (vi, xi, Lr, dn) => (Er._crypto_auth_hmacsha512_update = Ei.xa)(vi, xi, Lr, dn), Er._crypto_auth_hmacsha512_final = (vi, xi) => (Er._crypto_auth_hmacsha512_final = Ei.ya)(vi, xi), Er._crypto_auth_hmacsha512 = (vi, xi, Lr, dn, xn) => (Er._crypto_auth_hmacsha512 = Ei.za)(vi, xi, Lr, dn, xn), Er._crypto_auth_hmacsha512_verify = (vi, xi, Lr, dn, xn) => (Er._crypto_auth_hmacsha512_verify = Ei.Aa)(vi, xi, Lr, dn, xn), Er._crypto_auth_hmacsha512256_bytes = () => (Er._crypto_auth_hmacsha512256_bytes = Ei.Ba)(), Er._crypto_auth_hmacsha512256_keybytes = () => (Er._crypto_auth_hmacsha512256_keybytes = Ei.Ca)(), Er._crypto_auth_hmacsha512256_statebytes = () => (Er._crypto_auth_hmacsha512256_statebytes = Ei.Da)(), Er._crypto_auth_hmacsha512256_keygen = (vi) => (Er._crypto_auth_hmacsha512256_keygen = Ei.Ea)(vi), Er._crypto_auth_hmacsha512256_init = (vi, xi, Lr) => (Er._crypto_auth_hmacsha512256_init = Ei.Fa)(vi, xi, Lr), Er._crypto_auth_hmacsha512256_update = (vi, xi, Lr, dn) => (Er._crypto_auth_hmacsha512256_update = Ei.Ga)(vi, xi, Lr, dn), Er._crypto_auth_hmacsha512256_final = (vi, xi) => (Er._crypto_auth_hmacsha512256_final = Ei.Ha)(vi, xi), Er._crypto_auth_hmacsha512256 = (vi, xi, Lr, dn, xn) => (Er._crypto_auth_hmacsha512256 = Ei.Ia)(vi, xi, Lr, dn, xn), Er._crypto_auth_hmacsha512256_verify = (vi, xi, Lr, dn, xn) => (Er._crypto_auth_hmacsha512256_verify = Ei.Ja)(vi, xi, Lr, dn, xn), Er._crypto_box_seedbytes = () => (Er._crypto_box_seedbytes = Ei.Ka)(), Er._crypto_box_publickeybytes = () => (Er._crypto_box_publickeybytes = Ei.La)(), Er._crypto_box_secretkeybytes = () => (Er._crypto_box_secretkeybytes = Ei.Ma)(), Er._crypto_box_beforenmbytes = () => (Er._crypto_box_beforenmbytes = Ei.Na)(), Er._crypto_box_noncebytes = () => (Er._crypto_box_noncebytes = Ei.Oa)(), Er._crypto_box_zerobytes = () => (Er._crypto_box_zerobytes = Ei.Pa)(), Er._crypto_box_boxzerobytes = () => (Er._crypto_box_boxzerobytes = Ei.Qa)(), Er._crypto_box_macbytes = () => (Er._crypto_box_macbytes = Ei.Ra)(), Er._crypto_box_messagebytes_max = () => (Er._crypto_box_messagebytes_max = Ei.Sa)(), Er._crypto_box_primitive = () => (Er._crypto_box_primitive = Ei.Ta)(), Er._crypto_box_seed_keypair = (vi, xi, Lr) => (Er._crypto_box_seed_keypair = Ei.Ua)(vi, xi, Lr), Er._crypto_box_keypair = (vi, xi) => (Er._crypto_box_keypair = Ei.Va)(vi, xi), Er._crypto_box_beforenm = (vi, xi, Lr) => (Er._crypto_box_beforenm = Ei.Wa)(vi, xi, Lr), Er._crypto_box_afternm = (vi, xi, Lr, dn, xn, oi) => (Er._crypto_box_afternm = Ei.Xa)(vi, xi, Lr, dn, xn, oi), Er._crypto_box_open_afternm = (vi, xi, Lr, dn, xn, oi) => (Er._crypto_box_open_afternm = Ei.Ya)(vi, xi, Lr, dn, xn, oi), Er._crypto_box = (vi, xi, Lr, dn, xn, oi, Yr) => (Er._crypto_box = Ei.Za)(vi, xi, Lr, dn, xn, oi, Yr), Er._crypto_box_open = (vi, xi, Lr, dn, xn, oi, Yr) => (Er._crypto_box_open = Ei._a)(vi, xi, Lr, dn, xn, oi, Yr), Er._crypto_box_detached_afternm = (vi, xi, Lr, dn, xn, oi, Yr) => (Er._crypto_box_detached_afternm = Ei.$a)(vi, xi, Lr, dn, xn, oi, Yr), Er._crypto_box_detached = (vi, xi, Lr, dn, xn, oi, Yr, ji) => (Er._crypto_box_detached = Ei.ab)(vi, xi, Lr, dn, xn, oi, Yr, ji), Er._crypto_box_easy_afternm = (vi, xi, Lr, dn, xn, oi) => (Er._crypto_box_easy_afternm = Ei.bb)(vi, xi, Lr, dn, xn, oi), Er._crypto_box_easy = (vi, xi, Lr, dn, xn, oi, Yr) => (Er._crypto_box_easy = Ei.cb)(vi, xi, Lr, dn, xn, oi, Yr), Er._crypto_box_open_detached_afternm = (vi, xi, Lr, dn, xn, oi, Yr) => (Er._crypto_box_open_detached_afternm = Ei.db)(vi, xi, Lr, dn, xn, oi, Yr), Er._crypto_box_open_detached = (vi, xi, Lr, dn, xn, oi, Yr, ji) => (Er._crypto_box_open_detached = Ei.eb)(vi, xi, Lr, dn, xn, oi, Yr, ji), Er._crypto_box_open_easy_afternm = (vi, xi, Lr, dn, xn, oi) => (Er._crypto_box_open_easy_afternm = Ei.fb)(vi, xi, Lr, dn, xn, oi), Er._crypto_box_open_easy = (vi, xi, Lr, dn, xn, oi, Yr) => (Er._crypto_box_open_easy = Ei.gb)(vi, xi, Lr, dn, xn, oi, Yr), Er._crypto_box_seal = (vi, xi, Lr, dn, xn) => (Er._crypto_box_seal = Ei.hb)(vi, xi, Lr, dn, xn), Er._crypto_box_seal_open = (vi, xi, Lr, dn, xn, oi) => (Er._crypto_box_seal_open = Ei.ib)(vi, xi, Lr, dn, xn, oi), Er._crypto_box_sealbytes = () => (Er._crypto_box_sealbytes = Ei.jb)(), Er._crypto_box_curve25519xsalsa20poly1305_seed_keypair = (vi, xi, Lr) => (Er._crypto_box_curve25519xsalsa20poly1305_seed_keypair = Ei.kb)(vi, xi, Lr), Er._crypto_box_curve25519xsalsa20poly1305_keypair = (vi, xi) => (Er._crypto_box_curve25519xsalsa20poly1305_keypair = Ei.lb)(vi, xi), Er._crypto_box_curve25519xsalsa20poly1305_beforenm = (vi, xi, Lr) => (Er._crypto_box_curve25519xsalsa20poly1305_beforenm = Ei.mb)(vi, xi, Lr), Er._crypto_box_curve25519xsalsa20poly1305_afternm = (vi, xi, Lr, dn, xn, oi) => (Er._crypto_box_curve25519xsalsa20poly1305_afternm = Ei.nb)(vi, xi, Lr, dn, xn, oi), Er._crypto_box_curve25519xsalsa20poly1305_open_afternm = (vi, xi, Lr, dn, xn, oi) => (Er._crypto_box_curve25519xsalsa20poly1305_open_afternm = Ei.ob)(vi, xi, Lr, dn, xn, oi), Er._crypto_box_curve25519xsalsa20poly1305 = (vi, xi, Lr, dn, xn, oi, Yr) => (Er._crypto_box_curve25519xsalsa20poly1305 = Ei.pb)(vi, xi, Lr, dn, xn, oi, Yr), Er._crypto_box_curve25519xsalsa20poly1305_open = (vi, xi, Lr, dn, xn, oi, Yr) => (Er._crypto_box_curve25519xsalsa20poly1305_open = Ei.qb)(vi, xi, Lr, dn, xn, oi, Yr), Er._crypto_box_curve25519xsalsa20poly1305_seedbytes = () => (Er._crypto_box_curve25519xsalsa20poly1305_seedbytes = Ei.rb)(), Er._crypto_box_curve25519xsalsa20poly1305_publickeybytes = () => (Er._crypto_box_curve25519xsalsa20poly1305_publickeybytes = Ei.sb)(), Er._crypto_box_curve25519xsalsa20poly1305_secretkeybytes = () => (Er._crypto_box_curve25519xsalsa20poly1305_secretkeybytes = Ei.tb)(), Er._crypto_box_curve25519xsalsa20poly1305_beforenmbytes = () => (Er._crypto_box_curve25519xsalsa20poly1305_beforenmbytes = Ei.ub)(), Er._crypto_box_curve25519xsalsa20poly1305_noncebytes = () => (Er._crypto_box_curve25519xsalsa20poly1305_noncebytes = Ei.vb)(), Er._crypto_box_curve25519xsalsa20poly1305_zerobytes = () => (Er._crypto_box_curve25519xsalsa20poly1305_zerobytes = Ei.wb)(), Er._crypto_box_curve25519xsalsa20poly1305_boxzerobytes = () => (Er._crypto_box_curve25519xsalsa20poly1305_boxzerobytes = Ei.xb)(), Er._crypto_box_curve25519xsalsa20poly1305_macbytes = () => (Er._crypto_box_curve25519xsalsa20poly1305_macbytes = Ei.yb)(), Er._crypto_box_curve25519xsalsa20poly1305_messagebytes_max = () => (Er._crypto_box_curve25519xsalsa20poly1305_messagebytes_max = Ei.zb)(), Er._crypto_core_hchacha20 = (vi, xi, Lr, dn) => (Er._crypto_core_hchacha20 = Ei.Ab)(vi, xi, Lr, dn), Er._crypto_core_hchacha20_outputbytes = () => (Er._crypto_core_hchacha20_outputbytes = Ei.Bb)(), Er._crypto_core_hchacha20_inputbytes = () => (Er._crypto_core_hchacha20_inputbytes = Ei.Cb)(), Er._crypto_core_hchacha20_keybytes = () => (Er._crypto_core_hchacha20_keybytes = Ei.Db)(), Er._crypto_core_hchacha20_constbytes = () => (Er._crypto_core_hchacha20_constbytes = Ei.Eb)(), Er._crypto_core_hsalsa20 = (vi, xi, Lr, dn) => (Er._crypto_core_hsalsa20 = Ei.Fb)(vi, xi, Lr, dn), Er._crypto_core_hsalsa20_outputbytes = () => (Er._crypto_core_hsalsa20_outputbytes = Ei.Gb)(), Er._crypto_core_hsalsa20_inputbytes = () => (Er._crypto_core_hsalsa20_inputbytes = Ei.Hb)(), Er._crypto_core_hsalsa20_keybytes = () => (Er._crypto_core_hsalsa20_keybytes = Ei.Ib)(), Er._crypto_core_hsalsa20_constbytes = () => (Er._crypto_core_hsalsa20_constbytes = Ei.Jb)(), Er._crypto_core_salsa20 = (vi, xi, Lr, dn) => (Er._crypto_core_salsa20 = Ei.Kb)(vi, xi, Lr, dn), Er._crypto_core_salsa20_outputbytes = () => (Er._crypto_core_salsa20_outputbytes = Ei.Lb)(), Er._crypto_core_salsa20_inputbytes = () => (Er._crypto_core_salsa20_inputbytes = Ei.Mb)(), Er._crypto_core_salsa20_keybytes = () => (Er._crypto_core_salsa20_keybytes = Ei.Nb)(), Er._crypto_core_salsa20_constbytes = () => (Er._crypto_core_salsa20_constbytes = Ei.Ob)(), Er._crypto_core_salsa2012 = (vi, xi, Lr, dn) => (Er._crypto_core_salsa2012 = Ei.Pb)(vi, xi, Lr, dn), Er._crypto_core_salsa2012_outputbytes = () => (Er._crypto_core_salsa2012_outputbytes = Ei.Qb)(), Er._crypto_core_salsa2012_inputbytes = () => (Er._crypto_core_salsa2012_inputbytes = Ei.Rb)(), Er._crypto_core_salsa2012_keybytes = () => (Er._crypto_core_salsa2012_keybytes = Ei.Sb)(), Er._crypto_core_salsa2012_constbytes = () => (Er._crypto_core_salsa2012_constbytes = Ei.Tb)(), Er._crypto_core_salsa208 = (vi, xi, Lr, dn) => (Er._crypto_core_salsa208 = Ei.Ub)(vi, xi, Lr, dn), Er._crypto_core_salsa208_outputbytes = () => (Er._crypto_core_salsa208_outputbytes = Ei.Vb)(), Er._crypto_core_salsa208_inputbytes = () => (Er._crypto_core_salsa208_inputbytes = Ei.Wb)(), Er._crypto_core_salsa208_keybytes = () => (Er._crypto_core_salsa208_keybytes = Ei.Xb)(), Er._crypto_core_salsa208_constbytes = () => (Er._crypto_core_salsa208_constbytes = Ei.Yb)(), Er._crypto_generichash_bytes_min = () => (Er._crypto_generichash_bytes_min = Ei.Zb)(), Er._crypto_generichash_bytes_max = () => (Er._crypto_generichash_bytes_max = Ei._b)(), Er._crypto_generichash_bytes = () => (Er._crypto_generichash_bytes = Ei.$b)(), Er._crypto_generichash_keybytes_min = () => (Er._crypto_generichash_keybytes_min = Ei.ac)(), Er._crypto_generichash_keybytes_max = () => (Er._crypto_generichash_keybytes_max = Ei.bc)(), Er._crypto_generichash_keybytes = () => (Er._crypto_generichash_keybytes = Ei.cc)(), Er._crypto_generichash_primitive = () => (Er._crypto_generichash_primitive = Ei.dc)(), Er._crypto_generichash_statebytes = () => (Er._crypto_generichash_statebytes = Ei.ec)(), Er._crypto_generichash = (vi, xi, Lr, dn, xn, oi, Yr) => (Er._crypto_generichash = Ei.fc)(vi, xi, Lr, dn, xn, oi, Yr), Er._crypto_generichash_init = (vi, xi, Lr, dn) => (Er._crypto_generichash_init = Ei.gc)(vi, xi, Lr, dn), Er._crypto_generichash_update = (vi, xi, Lr, dn) => (Er._crypto_generichash_update = Ei.hc)(vi, xi, Lr, dn), Er._crypto_generichash_final = (vi, xi, Lr) => (Er._crypto_generichash_final = Ei.ic)(vi, xi, Lr), Er._crypto_generichash_keygen = (vi) => (Er._crypto_generichash_keygen = Ei.jc)(vi), Er._crypto_generichash_blake2b_bytes_min = () => (Er._crypto_generichash_blake2b_bytes_min = Ei.kc)(), Er._crypto_generichash_blake2b_bytes_max = () => (Er._crypto_generichash_blake2b_bytes_max = Ei.lc)(), Er._crypto_generichash_blake2b_bytes = () => (Er._crypto_generichash_blake2b_bytes = Ei.mc)(), Er._crypto_generichash_blake2b_keybytes_min = () => (Er._crypto_generichash_blake2b_keybytes_min = Ei.nc)(), Er._crypto_generichash_blake2b_keybytes_max = () => (Er._crypto_generichash_blake2b_keybytes_max = Ei.oc)(), Er._crypto_generichash_blake2b_keybytes = () => (Er._crypto_generichash_blake2b_keybytes = Ei.pc)(), Er._crypto_generichash_blake2b_saltbytes = () => (Er._crypto_generichash_blake2b_saltbytes = Ei.qc)(), Er._crypto_generichash_blake2b_personalbytes = () => (Er._crypto_generichash_blake2b_personalbytes = Ei.rc)(), Er._crypto_generichash_blake2b_statebytes = () => (Er._crypto_generichash_blake2b_statebytes = Ei.sc)(), Er._crypto_generichash_blake2b_keygen = (vi) => (Er._crypto_generichash_blake2b_keygen = Ei.tc)(vi), Er._crypto_generichash_blake2b = (vi, xi, Lr, dn, xn, oi, Yr) => (Er._crypto_generichash_blake2b = Ei.uc)(vi, xi, Lr, dn, xn, oi, Yr), Er._crypto_generichash_blake2b_salt_personal = (vi, xi, Lr, dn, xn, oi, Yr, ji, Cn) => (Er._crypto_generichash_blake2b_salt_personal = Ei.vc)(vi, xi, Lr, dn, xn, oi, Yr, ji, Cn), Er._crypto_generichash_blake2b_init = (vi, xi, Lr, dn) => (Er._crypto_generichash_blake2b_init = Ei.wc)(vi, xi, Lr, dn), Er._crypto_generichash_blake2b_init_salt_personal = (vi, xi, Lr, dn, xn, oi) => (Er._crypto_generichash_blake2b_init_salt_personal = Ei.xc)(vi, xi, Lr, dn, xn, oi), Er._crypto_generichash_blake2b_update = (vi, xi, Lr, dn) => (Er._crypto_generichash_blake2b_update = Ei.yc)(vi, xi, Lr, dn), Er._crypto_generichash_blake2b_final = (vi, xi, Lr) => (Er._crypto_generichash_blake2b_final = Ei.zc)(vi, xi, Lr), Er._crypto_hash_bytes = () => (Er._crypto_hash_bytes = Ei.Ac)(), Er._crypto_hash = (vi, xi, Lr, dn) => (Er._crypto_hash = Ei.Bc)(vi, xi, Lr, dn), Er._crypto_hash_primitive = () => (Er._crypto_hash_primitive = Ei.Cc)(), Er._crypto_hash_sha256_bytes = () => (Er._crypto_hash_sha256_bytes = Ei.Dc)(), Er._crypto_hash_sha256_statebytes = () => (Er._crypto_hash_sha256_statebytes = Ei.Ec)(), Er._crypto_hash_sha256_init = (vi) => (Er._crypto_hash_sha256_init = Ei.Fc)(vi), Er._crypto_hash_sha256_update = (vi, xi, Lr, dn) => (Er._crypto_hash_sha256_update = Ei.Gc)(vi, xi, Lr, dn), Er._crypto_hash_sha256_final = (vi, xi) => (Er._crypto_hash_sha256_final = Ei.Hc)(vi, xi), Er._crypto_hash_sha256 = (vi, xi, Lr, dn) => (Er._crypto_hash_sha256 = Ei.Ic)(vi, xi, Lr, dn), Er._crypto_hash_sha512_bytes = () => (Er._crypto_hash_sha512_bytes = Ei.Jc)(), Er._crypto_hash_sha512_statebytes = () => (Er._crypto_hash_sha512_statebytes = Ei.Kc)(), Er._crypto_hash_sha512_init = (vi) => (Er._crypto_hash_sha512_init = Ei.Lc)(vi), Er._crypto_hash_sha512_update = (vi, xi, Lr, dn) => (Er._crypto_hash_sha512_update = Ei.Mc)(vi, xi, Lr, dn), Er._crypto_hash_sha512_final = (vi, xi) => (Er._crypto_hash_sha512_final = Ei.Nc)(vi, xi), Er._crypto_hash_sha512 = (vi, xi, Lr, dn) => (Er._crypto_hash_sha512 = Ei.Oc)(vi, xi, Lr, dn), Er._crypto_kdf_blake2b_bytes_min = () => (Er._crypto_kdf_blake2b_bytes_min = Ei.Pc)(), Er._crypto_kdf_blake2b_bytes_max = () => (Er._crypto_kdf_blake2b_bytes_max = Ei.Qc)(), Er._crypto_kdf_blake2b_contextbytes = () => (Er._crypto_kdf_blake2b_contextbytes = Ei.Rc)(), Er._crypto_kdf_blake2b_keybytes = () => (Er._crypto_kdf_blake2b_keybytes = Ei.Sc)(), Er._crypto_kdf_blake2b_derive_from_key = (vi, xi, Lr, dn, xn, oi) => (Er._crypto_kdf_blake2b_derive_from_key = Ei.Tc)(vi, xi, Lr, dn, xn, oi), Er._crypto_kdf_primitive = () => (Er._crypto_kdf_primitive = Ei.Uc)(), Er._crypto_kdf_bytes_min = () => (Er._crypto_kdf_bytes_min = Ei.Vc)(), Er._crypto_kdf_bytes_max = () => (Er._crypto_kdf_bytes_max = Ei.Wc)(), Er._crypto_kdf_contextbytes = () => (Er._crypto_kdf_contextbytes = Ei.Xc)(), Er._crypto_kdf_keybytes = () => (Er._crypto_kdf_keybytes = Ei.Yc)(), Er._crypto_kdf_derive_from_key = (vi, xi, Lr, dn, xn, oi) => (Er._crypto_kdf_derive_from_key = Ei.Zc)(vi, xi, Lr, dn, xn, oi), Er._crypto_kdf_keygen = (vi) => (Er._crypto_kdf_keygen = Ei._c)(vi), Er._crypto_kdf_hkdf_sha256_extract_init = (vi, xi, Lr) => (Er._crypto_kdf_hkdf_sha256_extract_init = Ei.$c)(vi, xi, Lr), Er._crypto_kdf_hkdf_sha256_extract_update = (vi, xi, Lr) => (Er._crypto_kdf_hkdf_sha256_extract_update = Ei.ad)(vi, xi, Lr), Er._crypto_kdf_hkdf_sha256_extract_final = (vi, xi) => (Er._crypto_kdf_hkdf_sha256_extract_final = Ei.bd)(vi, xi), Er._crypto_kdf_hkdf_sha256_extract = (vi, xi, Lr, dn, xn) => (Er._crypto_kdf_hkdf_sha256_extract = Ei.cd)(vi, xi, Lr, dn, xn), Er._crypto_kdf_hkdf_sha256_keygen = (vi) => (Er._crypto_kdf_hkdf_sha256_keygen = Ei.dd)(vi), Er._crypto_kdf_hkdf_sha256_expand = (vi, xi, Lr, dn, xn) => (Er._crypto_kdf_hkdf_sha256_expand = Ei.ed)(vi, xi, Lr, dn, xn), Er._crypto_kdf_hkdf_sha256_keybytes = () => (Er._crypto_kdf_hkdf_sha256_keybytes = Ei.fd)(), Er._crypto_kdf_hkdf_sha256_bytes_min = () => (Er._crypto_kdf_hkdf_sha256_bytes_min = Ei.gd)(), Er._crypto_kdf_hkdf_sha256_bytes_max = () => (Er._crypto_kdf_hkdf_sha256_bytes_max = Ei.hd)(), Er._crypto_kdf_hkdf_sha256_statebytes = () => (Er._crypto_kdf_hkdf_sha256_statebytes = Ei.id)(), Er._crypto_kdf_hkdf_sha512_extract_init = (vi, xi, Lr) => (Er._crypto_kdf_hkdf_sha512_extract_init = Ei.jd)(vi, xi, Lr), Er._crypto_kdf_hkdf_sha512_extract_update = (vi, xi, Lr) => (Er._crypto_kdf_hkdf_sha512_extract_update = Ei.kd)(vi, xi, Lr), Er._crypto_kdf_hkdf_sha512_extract_final = (vi, xi) => (Er._crypto_kdf_hkdf_sha512_extract_final = Ei.ld)(vi, xi), Er._crypto_kdf_hkdf_sha512_extract = (vi, xi, Lr, dn, xn) => (Er._crypto_kdf_hkdf_sha512_extract = Ei.md)(vi, xi, Lr, dn, xn), Er._crypto_kdf_hkdf_sha512_keygen = (vi) => (Er._crypto_kdf_hkdf_sha512_keygen = Ei.nd)(vi), Er._crypto_kdf_hkdf_sha512_expand = (vi, xi, Lr, dn, xn) => (Er._crypto_kdf_hkdf_sha512_expand = Ei.od)(vi, xi, Lr, dn, xn), Er._crypto_kdf_hkdf_sha512_keybytes = () => (Er._crypto_kdf_hkdf_sha512_keybytes = Ei.pd)(), Er._crypto_kdf_hkdf_sha512_bytes_min = () => (Er._crypto_kdf_hkdf_sha512_bytes_min = Ei.qd)(), Er._crypto_kdf_hkdf_sha512_bytes_max = () => (Er._crypto_kdf_hkdf_sha512_bytes_max = Ei.rd)(), Er._crypto_kdf_hkdf_sha512_statebytes = () => (Er._crypto_kdf_hkdf_sha512_statebytes = Ei.sd)(), Er._crypto_kx_seed_keypair = (vi, xi, Lr) => (Er._crypto_kx_seed_keypair = Ei.td)(vi, xi, Lr), Er._crypto_kx_keypair = (vi, xi) => (Er._crypto_kx_keypair = Ei.ud)(vi, xi), Er._crypto_kx_client_session_keys = (vi, xi, Lr, dn, xn) => (Er._crypto_kx_client_session_keys = Ei.vd)(vi, xi, Lr, dn, xn), Er._crypto_kx_server_session_keys = (vi, xi, Lr, dn, xn) => (Er._crypto_kx_server_session_keys = Ei.wd)(vi, xi, Lr, dn, xn), Er._crypto_kx_publickeybytes = () => (Er._crypto_kx_publickeybytes = Ei.xd)(), Er._crypto_kx_secretkeybytes = () => (Er._crypto_kx_secretkeybytes = Ei.yd)(), Er._crypto_kx_seedbytes = () => (Er._crypto_kx_seedbytes = Ei.zd)(), Er._crypto_kx_sessionkeybytes = () => (Er._crypto_kx_sessionkeybytes = Ei.Ad)(), Er._crypto_kx_primitive = () => (Er._crypto_kx_primitive = Ei.Bd)(), Er._crypto_onetimeauth_statebytes = () => (Er._crypto_onetimeauth_statebytes = Ei.Cd)(), Er._crypto_onetimeauth_bytes = () => (Er._crypto_onetimeauth_bytes = Ei.Dd)(), Er._crypto_onetimeauth_keybytes = () => (Er._crypto_onetimeauth_keybytes = Ei.Ed)(), Er._crypto_onetimeauth = (vi, xi, Lr, dn, xn) => (Er._crypto_onetimeauth = Ei.Fd)(vi, xi, Lr, dn, xn), Er._crypto_onetimeauth_verify = (vi, xi, Lr, dn, xn) => (Er._crypto_onetimeauth_verify = Ei.Gd)(vi, xi, Lr, dn, xn), Er._crypto_onetimeauth_init = (vi, xi) => (Er._crypto_onetimeauth_init = Ei.Hd)(vi, xi), Er._crypto_onetimeauth_update = (vi, xi, Lr, dn) => (Er._crypto_onetimeauth_update = Ei.Id)(vi, xi, Lr, dn), Er._crypto_onetimeauth_final = (vi, xi) => (Er._crypto_onetimeauth_final = Ei.Jd)(vi, xi), Er._crypto_onetimeauth_primitive = () => (Er._crypto_onetimeauth_primitive = Ei.Kd)(), Er._crypto_onetimeauth_keygen = (vi) => (Er._crypto_onetimeauth_keygen = Ei.Ld)(vi), Er._crypto_onetimeauth_poly1305 = (vi, xi, Lr, dn, xn) => (Er._crypto_onetimeauth_poly1305 = Ei.Md)(vi, xi, Lr, dn, xn), Er._crypto_onetimeauth_poly1305_verify = (vi, xi, Lr, dn, xn) => (Er._crypto_onetimeauth_poly1305_verify = Ei.Nd)(vi, xi, Lr, dn, xn), Er._crypto_onetimeauth_poly1305_init = (vi, xi) => (Er._crypto_onetimeauth_poly1305_init = Ei.Od)(vi, xi), Er._crypto_onetimeauth_poly1305_update = (vi, xi, Lr, dn) => (Er._crypto_onetimeauth_poly1305_update = Ei.Pd)(vi, xi, Lr, dn), Er._crypto_onetimeauth_poly1305_final = (vi, xi) => (Er._crypto_onetimeauth_poly1305_final = Ei.Qd)(vi, xi), Er._crypto_onetimeauth_poly1305_bytes = () => (Er._crypto_onetimeauth_poly1305_bytes = Ei.Rd)(), Er._crypto_onetimeauth_poly1305_keybytes = () => (Er._crypto_onetimeauth_poly1305_keybytes = Ei.Sd)(), Er._crypto_onetimeauth_poly1305_statebytes = () => (Er._crypto_onetimeauth_poly1305_statebytes = Ei.Td)(), Er._crypto_onetimeauth_poly1305_keygen = (vi) => (Er._crypto_onetimeauth_poly1305_keygen = Ei.Ud)(vi), Er._crypto_pwhash_argon2i_alg_argon2i13 = () => (Er._crypto_pwhash_argon2i_alg_argon2i13 = Ei.Vd)(), Er._crypto_pwhash_argon2i_bytes_min = () => (Er._crypto_pwhash_argon2i_bytes_min = Ei.Wd)(), Er._crypto_pwhash_argon2i_bytes_max = () => (Er._crypto_pwhash_argon2i_bytes_max = Ei.Xd)(), Er._crypto_pwhash_argon2i_passwd_min = () => (Er._crypto_pwhash_argon2i_passwd_min = Ei.Yd)(), Er._crypto_pwhash_argon2i_passwd_max = () => (Er._crypto_pwhash_argon2i_passwd_max = Ei.Zd)(), Er._crypto_pwhash_argon2i_saltbytes = () => (Er._crypto_pwhash_argon2i_saltbytes = Ei._d)(), Er._crypto_pwhash_argon2i_strbytes = () => (Er._crypto_pwhash_argon2i_strbytes = Ei.$d)(), Er._crypto_pwhash_argon2i_strprefix = () => (Er._crypto_pwhash_argon2i_strprefix = Ei.ae)(), Er._crypto_pwhash_argon2i_opslimit_min = () => (Er._crypto_pwhash_argon2i_opslimit_min = Ei.be)(), Er._crypto_pwhash_argon2i_opslimit_max = () => (Er._crypto_pwhash_argon2i_opslimit_max = Ei.ce)(), Er._crypto_pwhash_argon2i_memlimit_min = () => (Er._crypto_pwhash_argon2i_memlimit_min = Ei.de)(), Er._crypto_pwhash_argon2i_memlimit_max = () => (Er._crypto_pwhash_argon2i_memlimit_max = Ei.ee)(), Er._crypto_pwhash_argon2i_opslimit_interactive = () => (Er._crypto_pwhash_argon2i_opslimit_interactive = Ei.fe)(), Er._crypto_pwhash_argon2i_memlimit_interactive = () => (Er._crypto_pwhash_argon2i_memlimit_interactive = Ei.ge)(), Er._crypto_pwhash_argon2i_opslimit_moderate = () => (Er._crypto_pwhash_argon2i_opslimit_moderate = Ei.he)(), Er._crypto_pwhash_argon2i_memlimit_moderate = () => (Er._crypto_pwhash_argon2i_memlimit_moderate = Ei.ie)(), Er._crypto_pwhash_argon2i_opslimit_sensitive = () => (Er._crypto_pwhash_argon2i_opslimit_sensitive = Ei.je)(), Er._crypto_pwhash_argon2i_memlimit_sensitive = () => (Er._crypto_pwhash_argon2i_memlimit_sensitive = Ei.ke)(), Er._crypto_pwhash_argon2i = (vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn, B) => (Er._crypto_pwhash_argon2i = Ei.le)(vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn, B), Er._crypto_pwhash_argon2i_str = (vi, xi, Lr, dn, xn, oi, Yr) => (Er._crypto_pwhash_argon2i_str = Ei.me)(vi, xi, Lr, dn, xn, oi, Yr), Er._crypto_pwhash_argon2i_str_verify = (vi, xi, Lr, dn) => (Er._crypto_pwhash_argon2i_str_verify = Ei.ne)(vi, xi, Lr, dn), Er._crypto_pwhash_argon2i_str_needs_rehash = (vi, xi, Lr, dn) => (Er._crypto_pwhash_argon2i_str_needs_rehash = Ei.oe)(vi, xi, Lr, dn), Er._crypto_pwhash_argon2id_str_needs_rehash = (vi, xi, Lr, dn) => (Er._crypto_pwhash_argon2id_str_needs_rehash = Ei.pe)(vi, xi, Lr, dn), Er._crypto_pwhash_argon2id_alg_argon2id13 = () => (Er._crypto_pwhash_argon2id_alg_argon2id13 = Ei.qe)(), Er._crypto_pwhash_argon2id_bytes_min = () => (Er._crypto_pwhash_argon2id_bytes_min = Ei.re)(), Er._crypto_pwhash_argon2id_bytes_max = () => (Er._crypto_pwhash_argon2id_bytes_max = Ei.se)(), Er._crypto_pwhash_argon2id_passwd_min = () => (Er._crypto_pwhash_argon2id_passwd_min = Ei.te)(), Er._crypto_pwhash_argon2id_passwd_max = () => (Er._crypto_pwhash_argon2id_passwd_max = Ei.ue)(), Er._crypto_pwhash_argon2id_saltbytes = () => (Er._crypto_pwhash_argon2id_saltbytes = Ei.ve)(), Er._crypto_pwhash_argon2id_strbytes = () => (Er._crypto_pwhash_argon2id_strbytes = Ei.we)(), Er._crypto_pwhash_argon2id_strprefix = () => (Er._crypto_pwhash_argon2id_strprefix = Ei.xe)(), Er._crypto_pwhash_argon2id_opslimit_min = () => (Er._crypto_pwhash_argon2id_opslimit_min = Ei.ye)(), Er._crypto_pwhash_argon2id_opslimit_max = () => (Er._crypto_pwhash_argon2id_opslimit_max = Ei.ze)(), Er._crypto_pwhash_argon2id_memlimit_min = () => (Er._crypto_pwhash_argon2id_memlimit_min = Ei.Ae)(), Er._crypto_pwhash_argon2id_memlimit_max = () => (Er._crypto_pwhash_argon2id_memlimit_max = Ei.Be)(), Er._crypto_pwhash_argon2id_opslimit_interactive = () => (Er._crypto_pwhash_argon2id_opslimit_interactive = Ei.Ce)(), Er._crypto_pwhash_argon2id_memlimit_interactive = () => (Er._crypto_pwhash_argon2id_memlimit_interactive = Ei.De)(), Er._crypto_pwhash_argon2id_opslimit_moderate = () => (Er._crypto_pwhash_argon2id_opslimit_moderate = Ei.Ee)(), Er._crypto_pwhash_argon2id_memlimit_moderate = () => (Er._crypto_pwhash_argon2id_memlimit_moderate = Ei.Fe)(), Er._crypto_pwhash_argon2id_opslimit_sensitive = () => (Er._crypto_pwhash_argon2id_opslimit_sensitive = Ei.Ge)(), Er._crypto_pwhash_argon2id_memlimit_sensitive = () => (Er._crypto_pwhash_argon2id_memlimit_sensitive = Ei.He)(), Er._crypto_pwhash_argon2id = (vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn, B) => (Er._crypto_pwhash_argon2id = Ei.Ie)(vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn, B), Er._crypto_pwhash_argon2id_str = (vi, xi, Lr, dn, xn, oi, Yr) => (Er._crypto_pwhash_argon2id_str = Ei.Je)(vi, xi, Lr, dn, xn, oi, Yr), Er._crypto_pwhash_argon2id_str_verify = (vi, xi, Lr, dn) => (Er._crypto_pwhash_argon2id_str_verify = Ei.Ke)(vi, xi, Lr, dn), Er._crypto_pwhash_alg_argon2i13 = () => (Er._crypto_pwhash_alg_argon2i13 = Ei.Le)(), Er._crypto_pwhash_alg_argon2id13 = () => (Er._crypto_pwhash_alg_argon2id13 = Ei.Me)(), Er._crypto_pwhash_alg_default = () => (Er._crypto_pwhash_alg_default = Ei.Ne)(), Er._crypto_pwhash_bytes_min = () => (Er._crypto_pwhash_bytes_min = Ei.Oe)(), Er._crypto_pwhash_bytes_max = () => (Er._crypto_pwhash_bytes_max = Ei.Pe)(), Er._crypto_pwhash_passwd_min = () => (Er._crypto_pwhash_passwd_min = Ei.Qe)(), Er._crypto_pwhash_passwd_max = () => (Er._crypto_pwhash_passwd_max = Ei.Re)(), Er._crypto_pwhash_saltbytes = () => (Er._crypto_pwhash_saltbytes = Ei.Se)(), Er._crypto_pwhash_strbytes = () => (Er._crypto_pwhash_strbytes = Ei.Te)(), Er._crypto_pwhash_strprefix = () => (Er._crypto_pwhash_strprefix = Ei.Ue)(), Er._crypto_pwhash_opslimit_min = () => (Er._crypto_pwhash_opslimit_min = Ei.Ve)(), Er._crypto_pwhash_opslimit_max = () => (Er._crypto_pwhash_opslimit_max = Ei.We)(), Er._crypto_pwhash_memlimit_min = () => (Er._crypto_pwhash_memlimit_min = Ei.Xe)(), Er._crypto_pwhash_memlimit_max = () => (Er._crypto_pwhash_memlimit_max = Ei.Ye)(), Er._crypto_pwhash_opslimit_interactive = () => (Er._crypto_pwhash_opslimit_interactive = Ei.Ze)(), Er._crypto_pwhash_memlimit_interactive = () => (Er._crypto_pwhash_memlimit_interactive = Ei._e)(), Er._crypto_pwhash_opslimit_moderate = () => (Er._crypto_pwhash_opslimit_moderate = Ei.$e)(), Er._crypto_pwhash_memlimit_moderate = () => (Er._crypto_pwhash_memlimit_moderate = Ei.af)(), Er._crypto_pwhash_opslimit_sensitive = () => (Er._crypto_pwhash_opslimit_sensitive = Ei.bf)(), Er._crypto_pwhash_memlimit_sensitive = () => (Er._crypto_pwhash_memlimit_sensitive = Ei.cf)(), Er._crypto_pwhash = (vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn, B) => (Er._crypto_pwhash = Ei.df)(vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn, B), Er._crypto_pwhash_str = (vi, xi, Lr, dn, xn, oi, Yr) => (Er._crypto_pwhash_str = Ei.ef)(vi, xi, Lr, dn, xn, oi, Yr), Er._crypto_pwhash_str_alg = (vi, xi, Lr, dn, xn, oi, Yr, ji) => (Er._crypto_pwhash_str_alg = Ei.ff)(vi, xi, Lr, dn, xn, oi, Yr, ji), Er._crypto_pwhash_str_verify = (vi, xi, Lr, dn) => (Er._crypto_pwhash_str_verify = Ei.gf)(vi, xi, Lr, dn), Er._crypto_pwhash_str_needs_rehash = (vi, xi, Lr, dn) => (Er._crypto_pwhash_str_needs_rehash = Ei.hf)(vi, xi, Lr, dn), Er._crypto_pwhash_primitive = () => (Er._crypto_pwhash_primitive = Ei.jf)(), Er._crypto_scalarmult_primitive = () => (Er._crypto_scalarmult_primitive = Ei.kf)(), Er._crypto_scalarmult_base = (vi, xi) => (Er._crypto_scalarmult_base = Ei.lf)(vi, xi), Er._crypto_scalarmult = (vi, xi, Lr) => (Er._crypto_scalarmult = Ei.mf)(vi, xi, Lr), Er._crypto_scalarmult_bytes = () => (Er._crypto_scalarmult_bytes = Ei.nf)(), Er._crypto_scalarmult_scalarbytes = () => (Er._crypto_scalarmult_scalarbytes = Ei.of)(), Er._crypto_scalarmult_curve25519 = (vi, xi, Lr) => (Er._crypto_scalarmult_curve25519 = Ei.pf)(vi, xi, Lr), Er._crypto_scalarmult_curve25519_base = (vi, xi) => (Er._crypto_scalarmult_curve25519_base = Ei.qf)(vi, xi), Er._crypto_scalarmult_curve25519_bytes = () => (Er._crypto_scalarmult_curve25519_bytes = Ei.rf)(), Er._crypto_scalarmult_curve25519_scalarbytes = () => (Er._crypto_scalarmult_curve25519_scalarbytes = Ei.sf)(), Er._crypto_secretbox_keybytes = () => (Er._crypto_secretbox_keybytes = Ei.tf)(), Er._crypto_secretbox_noncebytes = () => (Er._crypto_secretbox_noncebytes = Ei.uf)(), Er._crypto_secretbox_zerobytes = () => (Er._crypto_secretbox_zerobytes = Ei.vf)(), Er._crypto_secretbox_boxzerobytes = () => (Er._crypto_secretbox_boxzerobytes = Ei.wf)(), Er._crypto_secretbox_macbytes = () => (Er._crypto_secretbox_macbytes = Ei.xf)(), Er._crypto_secretbox_messagebytes_max = () => (Er._crypto_secretbox_messagebytes_max = Ei.yf)(), Er._crypto_secretbox_primitive = () => (Er._crypto_secretbox_primitive = Ei.zf)(), Er._crypto_secretbox = (vi, xi, Lr, dn, xn, oi) => (Er._crypto_secretbox = Ei.Af)(vi, xi, Lr, dn, xn, oi), Er._crypto_secretbox_open = (vi, xi, Lr, dn, xn, oi) => (Er._crypto_secretbox_open = Ei.Bf)(vi, xi, Lr, dn, xn, oi), Er._crypto_secretbox_keygen = (vi) => (Er._crypto_secretbox_keygen = Ei.Cf)(vi), Er._crypto_secretbox_detached = (vi, xi, Lr, dn, xn, oi, Yr) => (Er._crypto_secretbox_detached = Ei.Df)(vi, xi, Lr, dn, xn, oi, Yr), Er._crypto_secretbox_easy = (vi, xi, Lr, dn, xn, oi) => (Er._crypto_secretbox_easy = Ei.Ef)(vi, xi, Lr, dn, xn, oi), Er._crypto_secretbox_open_detached = (vi, xi, Lr, dn, xn, oi, Yr) => (Er._crypto_secretbox_open_detached = Ei.Ff)(vi, xi, Lr, dn, xn, oi, Yr), Er._crypto_secretbox_open_easy = (vi, xi, Lr, dn, xn, oi) => (Er._crypto_secretbox_open_easy = Ei.Gf)(vi, xi, Lr, dn, xn, oi), Er._crypto_secretbox_xsalsa20poly1305 = (vi, xi, Lr, dn, xn, oi) => (Er._crypto_secretbox_xsalsa20poly1305 = Ei.Hf)(vi, xi, Lr, dn, xn, oi), Er._crypto_secretbox_xsalsa20poly1305_open = (vi, xi, Lr, dn, xn, oi) => (Er._crypto_secretbox_xsalsa20poly1305_open = Ei.If)(vi, xi, Lr, dn, xn, oi), Er._crypto_secretbox_xsalsa20poly1305_keybytes = () => (Er._crypto_secretbox_xsalsa20poly1305_keybytes = Ei.Jf)(), Er._crypto_secretbox_xsalsa20poly1305_noncebytes = () => (Er._crypto_secretbox_xsalsa20poly1305_noncebytes = Ei.Kf)(), Er._crypto_secretbox_xsalsa20poly1305_zerobytes = () => (Er._crypto_secretbox_xsalsa20poly1305_zerobytes = Ei.Lf)(), Er._crypto_secretbox_xsalsa20poly1305_boxzerobytes = () => (Er._crypto_secretbox_xsalsa20poly1305_boxzerobytes = Ei.Mf)(), Er._crypto_secretbox_xsalsa20poly1305_macbytes = () => (Er._crypto_secretbox_xsalsa20poly1305_macbytes = Ei.Nf)(), Er._crypto_secretbox_xsalsa20poly1305_messagebytes_max = () => (Er._crypto_secretbox_xsalsa20poly1305_messagebytes_max = Ei.Of)(), Er._crypto_secretbox_xsalsa20poly1305_keygen = (vi) => (Er._crypto_secretbox_xsalsa20poly1305_keygen = Ei.Pf)(vi), Er._crypto_secretstream_xchacha20poly1305_keygen = (vi) => (Er._crypto_secretstream_xchacha20poly1305_keygen = Ei.Qf)(vi), Er._crypto_secretstream_xchacha20poly1305_init_push = (vi, xi, Lr) => (Er._crypto_secretstream_xchacha20poly1305_init_push = Ei.Rf)(vi, xi, Lr), Er._crypto_secretstream_xchacha20poly1305_init_pull = (vi, xi, Lr) => (Er._crypto_secretstream_xchacha20poly1305_init_pull = Ei.Sf)(vi, xi, Lr), Er._crypto_secretstream_xchacha20poly1305_rekey = (vi) => (Er._crypto_secretstream_xchacha20poly1305_rekey = Ei.Tf)(vi), Er._crypto_secretstream_xchacha20poly1305_push = (vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn) => (Er._crypto_secretstream_xchacha20poly1305_push = Ei.Uf)(vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn), Er._crypto_secretstream_xchacha20poly1305_pull = (vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn) => (Er._crypto_secretstream_xchacha20poly1305_pull = Ei.Vf)(vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn), Er._crypto_secretstream_xchacha20poly1305_statebytes = () => (Er._crypto_secretstream_xchacha20poly1305_statebytes = Ei.Wf)(), Er._crypto_secretstream_xchacha20poly1305_abytes = () => (Er._crypto_secretstream_xchacha20poly1305_abytes = Ei.Xf)(), Er._crypto_secretstream_xchacha20poly1305_headerbytes = () => (Er._crypto_secretstream_xchacha20poly1305_headerbytes = Ei.Yf)(), Er._crypto_secretstream_xchacha20poly1305_keybytes = () => (Er._crypto_secretstream_xchacha20poly1305_keybytes = Ei.Zf)(), Er._crypto_secretstream_xchacha20poly1305_messagebytes_max = () => (Er._crypto_secretstream_xchacha20poly1305_messagebytes_max = Ei._f)(), Er._crypto_secretstream_xchacha20poly1305_tag_message = () => (Er._crypto_secretstream_xchacha20poly1305_tag_message = Ei.$f)(), Er._crypto_secretstream_xchacha20poly1305_tag_push = () => (Er._crypto_secretstream_xchacha20poly1305_tag_push = Ei.ag)(), Er._crypto_secretstream_xchacha20poly1305_tag_rekey = () => (Er._crypto_secretstream_xchacha20poly1305_tag_rekey = Ei.bg)(), Er._crypto_secretstream_xchacha20poly1305_tag_final = () => (Er._crypto_secretstream_xchacha20poly1305_tag_final = Ei.cg)(), Er._crypto_shorthash_bytes = () => (Er._crypto_shorthash_bytes = Ei.dg)(), Er._crypto_shorthash_keybytes = () => (Er._crypto_shorthash_keybytes = Ei.eg)(), Er._crypto_shorthash_primitive = () => (Er._crypto_shorthash_primitive = Ei.fg)(), Er._crypto_shorthash = (vi, xi, Lr, dn, xn) => (Er._crypto_shorthash = Ei.gg)(vi, xi, Lr, dn, xn), Er._crypto_shorthash_keygen = (vi) => (Er._crypto_shorthash_keygen = Ei.hg)(vi), Er._crypto_shorthash_siphash24_bytes = () => (Er._crypto_shorthash_siphash24_bytes = Ei.ig)(), Er._crypto_shorthash_siphash24_keybytes = () => (Er._crypto_shorthash_siphash24_keybytes = Ei.jg)(), Er._crypto_shorthash_siphash24 = (vi, xi, Lr, dn, xn) => (Er._crypto_shorthash_siphash24 = Ei.kg)(vi, xi, Lr, dn, xn), Er._crypto_sign_statebytes = () => (Er._crypto_sign_statebytes = Ei.lg)(), Er._crypto_sign_bytes = () => (Er._crypto_sign_bytes = Ei.mg)(), Er._crypto_sign_seedbytes = () => (Er._crypto_sign_seedbytes = Ei.ng)(), Er._crypto_sign_publickeybytes = () => (Er._crypto_sign_publickeybytes = Ei.og)(), Er._crypto_sign_secretkeybytes = () => (Er._crypto_sign_secretkeybytes = Ei.pg)(), Er._crypto_sign_messagebytes_max = () => (Er._crypto_sign_messagebytes_max = Ei.qg)(), Er._crypto_sign_primitive = () => (Er._crypto_sign_primitive = Ei.rg)(), Er._crypto_sign_seed_keypair = (vi, xi, Lr) => (Er._crypto_sign_seed_keypair = Ei.sg)(vi, xi, Lr), Er._crypto_sign_keypair = (vi, xi) => (Er._crypto_sign_keypair = Ei.tg)(vi, xi), Er._crypto_sign = (vi, xi, Lr, dn, xn, oi) => (Er._crypto_sign = Ei.ug)(vi, xi, Lr, dn, xn, oi), Er._crypto_sign_open = (vi, xi, Lr, dn, xn, oi) => (Er._crypto_sign_open = Ei.vg)(vi, xi, Lr, dn, xn, oi), Er._crypto_sign_detached = (vi, xi, Lr, dn, xn, oi) => (Er._crypto_sign_detached = Ei.wg)(vi, xi, Lr, dn, xn, oi), Er._crypto_sign_verify_detached = (vi, xi, Lr, dn, xn) => (Er._crypto_sign_verify_detached = Ei.xg)(vi, xi, Lr, dn, xn), Er._crypto_sign_init = (vi) => (Er._crypto_sign_init = Ei.yg)(vi), Er._crypto_sign_update = (vi, xi, Lr, dn) => (Er._crypto_sign_update = Ei.zg)(vi, xi, Lr, dn), Er._crypto_sign_final_create = (vi, xi, Lr, dn) => (Er._crypto_sign_final_create = Ei.Ag)(vi, xi, Lr, dn), Er._crypto_sign_final_verify = (vi, xi, Lr) => (Er._crypto_sign_final_verify = Ei.Bg)(vi, xi, Lr), Er._crypto_sign_ed25519ph_statebytes = () => (Er._crypto_sign_ed25519ph_statebytes = Ei.Cg)(), Er._crypto_sign_ed25519_bytes = () => (Er._crypto_sign_ed25519_bytes = Ei.Dg)(), Er._crypto_sign_ed25519_seedbytes = () => (Er._crypto_sign_ed25519_seedbytes = Ei.Eg)(), Er._crypto_sign_ed25519_publickeybytes = () => (Er._crypto_sign_ed25519_publickeybytes = Ei.Fg)(), Er._crypto_sign_ed25519_secretkeybytes = () => (Er._crypto_sign_ed25519_secretkeybytes = Ei.Gg)(), Er._crypto_sign_ed25519_messagebytes_max = () => (Er._crypto_sign_ed25519_messagebytes_max = Ei.Hg)(), Er._crypto_sign_ed25519_sk_to_seed = (vi, xi) => (Er._crypto_sign_ed25519_sk_to_seed = Ei.Ig)(vi, xi), Er._crypto_sign_ed25519_sk_to_pk = (vi, xi) => (Er._crypto_sign_ed25519_sk_to_pk = Ei.Jg)(vi, xi), Er._crypto_sign_ed25519ph_init = (vi) => (Er._crypto_sign_ed25519ph_init = Ei.Kg)(vi), Er._crypto_sign_ed25519ph_update = (vi, xi, Lr, dn) => (Er._crypto_sign_ed25519ph_update = Ei.Lg)(vi, xi, Lr, dn), Er._crypto_sign_ed25519ph_final_create = (vi, xi, Lr, dn) => (Er._crypto_sign_ed25519ph_final_create = Ei.Mg)(vi, xi, Lr, dn), Er._crypto_sign_ed25519ph_final_verify = (vi, xi, Lr) => (Er._crypto_sign_ed25519ph_final_verify = Ei.Ng)(vi, xi, Lr), Er._crypto_sign_ed25519_seed_keypair = (vi, xi, Lr) => (Er._crypto_sign_ed25519_seed_keypair = Ei.Og)(vi, xi, Lr), Er._crypto_sign_ed25519_keypair = (vi, xi) => (Er._crypto_sign_ed25519_keypair = Ei.Pg)(vi, xi), Er._crypto_sign_ed25519_pk_to_curve25519 = (vi, xi) => (Er._crypto_sign_ed25519_pk_to_curve25519 = Ei.Qg)(vi, xi), Er._crypto_sign_ed25519_sk_to_curve25519 = (vi, xi) => (Er._crypto_sign_ed25519_sk_to_curve25519 = Ei.Rg)(vi, xi), Er._crypto_sign_ed25519_verify_detached = (vi, xi, Lr, dn, xn) => (Er._crypto_sign_ed25519_verify_detached = Ei.Sg)(vi, xi, Lr, dn, xn), Er._crypto_sign_ed25519_open = (vi, xi, Lr, dn, xn, oi) => (Er._crypto_sign_ed25519_open = Ei.Tg)(vi, xi, Lr, dn, xn, oi), Er._crypto_sign_ed25519_detached = (vi, xi, Lr, dn, xn, oi) => (Er._crypto_sign_ed25519_detached = Ei.Ug)(vi, xi, Lr, dn, xn, oi), Er._crypto_sign_ed25519 = (vi, xi, Lr, dn, xn, oi) => (Er._crypto_sign_ed25519 = Ei.Vg)(vi, xi, Lr, dn, xn, oi), Er._crypto_stream_chacha20_keybytes = () => (Er._crypto_stream_chacha20_keybytes = Ei.Wg)(), Er._crypto_stream_chacha20_noncebytes = () => (Er._crypto_stream_chacha20_noncebytes = Ei.Xg)(), Er._crypto_stream_chacha20_messagebytes_max = () => (Er._crypto_stream_chacha20_messagebytes_max = Ei.Yg)(), Er._crypto_stream_chacha20_ietf_keybytes = () => (Er._crypto_stream_chacha20_ietf_keybytes = Ei.Zg)(), Er._crypto_stream_chacha20_ietf_noncebytes = () => (Er._crypto_stream_chacha20_ietf_noncebytes = Ei._g)(), Er._crypto_stream_chacha20_ietf_messagebytes_max = () => (Er._crypto_stream_chacha20_ietf_messagebytes_max = Ei.$g)(), Er._crypto_stream_chacha20 = (vi, xi, Lr, dn, xn) => (Er._crypto_stream_chacha20 = Ei.ah)(vi, xi, Lr, dn, xn), Er._crypto_stream_chacha20_xor_ic = (vi, xi, Lr, dn, xn, oi, Yr, ji) => (Er._crypto_stream_chacha20_xor_ic = Ei.bh)(vi, xi, Lr, dn, xn, oi, Yr, ji), Er._crypto_stream_chacha20_xor = (vi, xi, Lr, dn, xn, oi) => (Er._crypto_stream_chacha20_xor = Ei.ch)(vi, xi, Lr, dn, xn, oi), Er._crypto_stream_chacha20_ietf = (vi, xi, Lr, dn, xn) => (Er._crypto_stream_chacha20_ietf = Ei.dh)(vi, xi, Lr, dn, xn), Er._crypto_stream_chacha20_ietf_xor_ic = (vi, xi, Lr, dn, xn, oi, Yr) => (Er._crypto_stream_chacha20_ietf_xor_ic = Ei.eh)(vi, xi, Lr, dn, xn, oi, Yr), Er._crypto_stream_chacha20_ietf_xor = (vi, xi, Lr, dn, xn, oi) => (Er._crypto_stream_chacha20_ietf_xor = Ei.fh)(vi, xi, Lr, dn, xn, oi), Er._crypto_stream_chacha20_ietf_keygen = (vi) => (Er._crypto_stream_chacha20_ietf_keygen = Ei.gh)(vi), Er._crypto_stream_chacha20_keygen = (vi) => (Er._crypto_stream_chacha20_keygen = Ei.hh)(vi), Er._crypto_stream_keybytes = () => (Er._crypto_stream_keybytes = Ei.ih)(), Er._crypto_stream_noncebytes = () => (Er._crypto_stream_noncebytes = Ei.jh)(), Er._crypto_stream_messagebytes_max = () => (Er._crypto_stream_messagebytes_max = Ei.kh)(), Er._crypto_stream_primitive = () => (Er._crypto_stream_primitive = Ei.lh)(), Er._crypto_stream = (vi, xi, Lr, dn, xn) => (Er._crypto_stream = Ei.mh)(vi, xi, Lr, dn, xn), Er._crypto_stream_xor = (vi, xi, Lr, dn, xn, oi) => (Er._crypto_stream_xor = Ei.nh)(vi, xi, Lr, dn, xn, oi), Er._crypto_stream_keygen = (vi) => (Er._crypto_stream_keygen = Ei.oh)(vi), Er._crypto_stream_salsa20_keybytes = () => (Er._crypto_stream_salsa20_keybytes = Ei.ph)(), Er._crypto_stream_salsa20_noncebytes = () => (Er._crypto_stream_salsa20_noncebytes = Ei.qh)(), Er._crypto_stream_salsa20_messagebytes_max = () => (Er._crypto_stream_salsa20_messagebytes_max = Ei.rh)(), Er._crypto_stream_salsa20 = (vi, xi, Lr, dn, xn) => (Er._crypto_stream_salsa20 = Ei.sh)(vi, xi, Lr, dn, xn), Er._crypto_stream_salsa20_xor_ic = (vi, xi, Lr, dn, xn, oi, Yr, ji) => (Er._crypto_stream_salsa20_xor_ic = Ei.th)(vi, xi, Lr, dn, xn, oi, Yr, ji), Er._crypto_stream_salsa20_xor = (vi, xi, Lr, dn, xn, oi) => (Er._crypto_stream_salsa20_xor = Ei.uh)(vi, xi, Lr, dn, xn, oi), Er._crypto_stream_salsa20_keygen = (vi) => (Er._crypto_stream_salsa20_keygen = Ei.vh)(vi), Er._crypto_stream_xsalsa20 = (vi, xi, Lr, dn, xn) => (Er._crypto_stream_xsalsa20 = Ei.wh)(vi, xi, Lr, dn, xn), Er._crypto_stream_xsalsa20_xor_ic = (vi, xi, Lr, dn, xn, oi, Yr, ji) => (Er._crypto_stream_xsalsa20_xor_ic = Ei.xh)(vi, xi, Lr, dn, xn, oi, Yr, ji), Er._crypto_stream_xsalsa20_xor = (vi, xi, Lr, dn, xn, oi) => (Er._crypto_stream_xsalsa20_xor = Ei.yh)(vi, xi, Lr, dn, xn, oi), Er._crypto_stream_xsalsa20_keybytes = () => (Er._crypto_stream_xsalsa20_keybytes = Ei.zh)(), Er._crypto_stream_xsalsa20_noncebytes = () => (Er._crypto_stream_xsalsa20_noncebytes = Ei.Ah)(), Er._crypto_stream_xsalsa20_messagebytes_max = () => (Er._crypto_stream_xsalsa20_messagebytes_max = Ei.Bh)(), Er._crypto_stream_xsalsa20_keygen = (vi) => (Er._crypto_stream_xsalsa20_keygen = Ei.Ch)(vi), Er._crypto_verify_16_bytes = () => (Er._crypto_verify_16_bytes = Ei.Dh)(), Er._crypto_verify_32_bytes = () => (Er._crypto_verify_32_bytes = Ei.Eh)(), Er._crypto_verify_64_bytes = () => (Er._crypto_verify_64_bytes = Ei.Fh)(), Er._crypto_verify_16 = (vi, xi) => (Er._crypto_verify_16 = Ei.Gh)(vi, xi), Er._crypto_verify_32 = (vi, xi) => (Er._crypto_verify_32 = Ei.Hh)(vi, xi), Er._crypto_verify_64 = (vi, xi) => (Er._crypto_verify_64 = Ei.Ih)(vi, xi), Er._randombytes_implementation_name = () => (Er._randombytes_implementation_name = Ei.Jh)(), Er._randombytes_random = () => (Er._randombytes_random = Ei.Kh)(), Er._randombytes_stir = () => (Er._randombytes_stir = Ei.Lh)(), Er._randombytes_uniform = (vi) => (Er._randombytes_uniform = Ei.Mh)(vi), Er._randombytes_buf = (vi, xi) => (Er._randombytes_buf = Ei.Nh)(vi, xi), Er._randombytes_buf_deterministic = (vi, xi, Lr) => (Er._randombytes_buf_deterministic = Ei.Oh)(vi, xi, Lr), Er._randombytes_seedbytes = () => (Er._randombytes_seedbytes = Ei.Ph)(), Er._randombytes_close = () => (Er._randombytes_close = Ei.Qh)(), Er._randombytes = (vi, xi, Lr) => (Er._randombytes = Ei.Rh)(vi, xi, Lr), Er._sodium_bin2hex = (vi, xi, Lr, dn) => (Er._sodium_bin2hex = Ei.Sh)(vi, xi, Lr, dn), Er._sodium_hex2bin = (vi, xi, Lr, dn, xn, oi, Yr) => (Er._sodium_hex2bin = Ei.Th)(vi, xi, Lr, dn, xn, oi, Yr), Er._sodium_base64_encoded_len = (vi, xi) => (Er._sodium_base64_encoded_len = Ei.Uh)(vi, xi), Er._sodium_bin2base64 = (vi, xi, Lr, dn, xn) => (Er._sodium_bin2base64 = Ei.Vh)(vi, xi, Lr, dn, xn), Er._sodium_base642bin = (vi, xi, Lr, dn, xn, oi, Yr, ji) => (Er._sodium_base642bin = Ei.Wh)(vi, xi, Lr, dn, xn, oi, Yr, ji), Er._sodium_init = () => (Er._sodium_init = Ei.Xh)(), Er._sodium_pad = (vi, xi, Lr, dn, xn) => (Er._sodium_pad = Ei.Yh)(vi, xi, Lr, dn, xn), Er._sodium_unpad = (vi, xi, Lr, dn) => (Er._sodium_unpad = Ei.Zh)(vi, xi, Lr, dn), Er._sodium_version_string = () => (Er._sodium_version_string = Ei._h)(), Er._sodium_library_version_major = () => (Er._sodium_library_version_major = Ei.$h)(), Er._sodium_library_version_minor = () => (Er._sodium_library_version_minor = Ei.ai)(), Er._sodium_library_minimal = () => (Er._sodium_library_minimal = Ei.bi)(), Er._crypto_box_curve25519xchacha20poly1305_seed_keypair = (vi, xi, Lr) => (Er._crypto_box_curve25519xchacha20poly1305_seed_keypair = Ei.ci)(vi, xi, Lr), Er._crypto_box_curve25519xchacha20poly1305_keypair = (vi, xi) => (Er._crypto_box_curve25519xchacha20poly1305_keypair = Ei.di)(vi, xi), Er._crypto_box_curve25519xchacha20poly1305_beforenm = (vi, xi, Lr) => (Er._crypto_box_curve25519xchacha20poly1305_beforenm = Ei.ei)(vi, xi, Lr), Er._crypto_box_curve25519xchacha20poly1305_detached_afternm = (vi, xi, Lr, dn, xn, oi, Yr) => (Er._crypto_box_curve25519xchacha20poly1305_detached_afternm = Ei.fi)(vi, xi, Lr, dn, xn, oi, Yr), Er._crypto_box_curve25519xchacha20poly1305_detached = (vi, xi, Lr, dn, xn, oi, Yr, ji) => (Er._crypto_box_curve25519xchacha20poly1305_detached = Ei.gi)(vi, xi, Lr, dn, xn, oi, Yr, ji), Er._crypto_box_curve25519xchacha20poly1305_easy_afternm = (vi, xi, Lr, dn, xn, oi) => (Er._crypto_box_curve25519xchacha20poly1305_easy_afternm = Ei.hi)(vi, xi, Lr, dn, xn, oi), Er._crypto_box_curve25519xchacha20poly1305_easy = (vi, xi, Lr, dn, xn, oi, Yr) => (Er._crypto_box_curve25519xchacha20poly1305_easy = Ei.ii)(vi, xi, Lr, dn, xn, oi, Yr), Er._crypto_box_curve25519xchacha20poly1305_open_detached_afternm = (vi, xi, Lr, dn, xn, oi, Yr) => (Er._crypto_box_curve25519xchacha20poly1305_open_detached_afternm = Ei.ji)(vi, xi, Lr, dn, xn, oi, Yr), Er._crypto_box_curve25519xchacha20poly1305_open_detached = (vi, xi, Lr, dn, xn, oi, Yr, ji) => (Er._crypto_box_curve25519xchacha20poly1305_open_detached = Ei.ki)(vi, xi, Lr, dn, xn, oi, Yr, ji), Er._crypto_box_curve25519xchacha20poly1305_open_easy_afternm = (vi, xi, Lr, dn, xn, oi) => (Er._crypto_box_curve25519xchacha20poly1305_open_easy_afternm = Ei.li)(vi, xi, Lr, dn, xn, oi), Er._crypto_box_curve25519xchacha20poly1305_open_easy = (vi, xi, Lr, dn, xn, oi, Yr) => (Er._crypto_box_curve25519xchacha20poly1305_open_easy = Ei.mi)(vi, xi, Lr, dn, xn, oi, Yr), Er._crypto_box_curve25519xchacha20poly1305_seedbytes = () => (Er._crypto_box_curve25519xchacha20poly1305_seedbytes = Ei.ni)(), Er._crypto_box_curve25519xchacha20poly1305_publickeybytes = () => (Er._crypto_box_curve25519xchacha20poly1305_publickeybytes = Ei.oi)(), Er._crypto_box_curve25519xchacha20poly1305_secretkeybytes = () => (Er._crypto_box_curve25519xchacha20poly1305_secretkeybytes = Ei.pi)(), Er._crypto_box_curve25519xchacha20poly1305_beforenmbytes = () => (Er._crypto_box_curve25519xchacha20poly1305_beforenmbytes = Ei.qi)(), Er._crypto_box_curve25519xchacha20poly1305_noncebytes = () => (Er._crypto_box_curve25519xchacha20poly1305_noncebytes = Ei.ri)(), Er._crypto_box_curve25519xchacha20poly1305_macbytes = () => (Er._crypto_box_curve25519xchacha20poly1305_macbytes = Ei.si)(), Er._crypto_box_curve25519xchacha20poly1305_messagebytes_max = () => (Er._crypto_box_curve25519xchacha20poly1305_messagebytes_max = Ei.ti)(), Er._crypto_box_curve25519xchacha20poly1305_seal = (vi, xi, Lr, dn, xn) => (Er._crypto_box_curve25519xchacha20poly1305_seal = Ei.ui)(vi, xi, Lr, dn, xn), Er._crypto_box_curve25519xchacha20poly1305_seal_open = (vi, xi, Lr, dn, xn, oi) => (Er._crypto_box_curve25519xchacha20poly1305_seal_open = Ei.vi)(vi, xi, Lr, dn, xn, oi), Er._crypto_box_curve25519xchacha20poly1305_sealbytes = () => (Er._crypto_box_curve25519xchacha20poly1305_sealbytes = Ei.wi)(), Er._crypto_core_ed25519_is_valid_point = (vi) => (Er._crypto_core_ed25519_is_valid_point = Ei.xi)(vi), Er._crypto_core_ed25519_add = (vi, xi, Lr) => (Er._crypto_core_ed25519_add = Ei.yi)(vi, xi, Lr), Er._crypto_core_ed25519_sub = (vi, xi, Lr) => (Er._crypto_core_ed25519_sub = Ei.zi)(vi, xi, Lr), Er._crypto_core_ed25519_from_uniform = (vi, xi) => (Er._crypto_core_ed25519_from_uniform = Ei.Ai)(vi, xi), Er._crypto_core_ed25519_random = (vi) => (Er._crypto_core_ed25519_random = Ei.Bi)(vi), Er._crypto_core_ed25519_scalar_random = (vi) => (Er._crypto_core_ed25519_scalar_random = Ei.Ci)(vi), Er._crypto_core_ed25519_scalar_invert = (vi, xi) => (Er._crypto_core_ed25519_scalar_invert = Ei.Di)(vi, xi), Er._crypto_core_ed25519_scalar_negate = (vi, xi) => (Er._crypto_core_ed25519_scalar_negate = Ei.Ei)(vi, xi), Er._crypto_core_ed25519_scalar_complement = (vi, xi) => (Er._crypto_core_ed25519_scalar_complement = Ei.Fi)(vi, xi), Er._crypto_core_ed25519_scalar_add = (vi, xi, Lr) => (Er._crypto_core_ed25519_scalar_add = Ei.Gi)(vi, xi, Lr), Er._crypto_core_ed25519_scalar_reduce = (vi, xi) => (Er._crypto_core_ed25519_scalar_reduce = Ei.Hi)(vi, xi), Er._crypto_core_ed25519_scalar_sub = (vi, xi, Lr) => (Er._crypto_core_ed25519_scalar_sub = Ei.Ii)(vi, xi, Lr), Er._crypto_core_ed25519_scalar_mul = (vi, xi, Lr) => (Er._crypto_core_ed25519_scalar_mul = Ei.Ji)(vi, xi, Lr), Er._crypto_core_ed25519_bytes = () => (Er._crypto_core_ed25519_bytes = Ei.Ki)(), Er._crypto_core_ed25519_nonreducedscalarbytes = () => (Er._crypto_core_ed25519_nonreducedscalarbytes = Ei.Li)(), Er._crypto_core_ed25519_uniformbytes = () => (Er._crypto_core_ed25519_uniformbytes = Ei.Mi)(), Er._crypto_core_ed25519_hashbytes = () => (Er._crypto_core_ed25519_hashbytes = Ei.Ni)(), Er._crypto_core_ed25519_scalarbytes = () => (Er._crypto_core_ed25519_scalarbytes = Ei.Oi)(), Er._crypto_core_ristretto255_is_valid_point = (vi) => (Er._crypto_core_ristretto255_is_valid_point = Ei.Pi)(vi), Er._crypto_core_ristretto255_add = (vi, xi, Lr) => (Er._crypto_core_ristretto255_add = Ei.Qi)(vi, xi, Lr), Er._crypto_core_ristretto255_sub = (vi, xi, Lr) => (Er._crypto_core_ristretto255_sub = Ei.Ri)(vi, xi, Lr), Er._crypto_core_ristretto255_from_hash = (vi, xi) => (Er._crypto_core_ristretto255_from_hash = Ei.Si)(vi, xi), Er._crypto_core_ristretto255_random = (vi) => (Er._crypto_core_ristretto255_random = Ei.Ti)(vi), Er._crypto_core_ristretto255_scalar_random = (vi) => (Er._crypto_core_ristretto255_scalar_random = Ei.Ui)(vi), Er._crypto_core_ristretto255_scalar_invert = (vi, xi) => (Er._crypto_core_ristretto255_scalar_invert = Ei.Vi)(vi, xi), Er._crypto_core_ristretto255_scalar_negate = (vi, xi) => (Er._crypto_core_ristretto255_scalar_negate = Ei.Wi)(vi, xi), Er._crypto_core_ristretto255_scalar_complement = (vi, xi) => (Er._crypto_core_ristretto255_scalar_complement = Ei.Xi)(vi, xi), Er._crypto_core_ristretto255_scalar_add = (vi, xi, Lr) => (Er._crypto_core_ristretto255_scalar_add = Ei.Yi)(vi, xi, Lr), Er._crypto_core_ristretto255_scalar_sub = (vi, xi, Lr) => (Er._crypto_core_ristretto255_scalar_sub = Ei.Zi)(vi, xi, Lr), Er._crypto_core_ristretto255_scalar_mul = (vi, xi, Lr) => (Er._crypto_core_ristretto255_scalar_mul = Ei._i)(vi, xi, Lr), Er._crypto_core_ristretto255_scalar_reduce = (vi, xi) => (Er._crypto_core_ristretto255_scalar_reduce = Ei.$i)(vi, xi), Er._crypto_core_ristretto255_bytes = () => (Er._crypto_core_ristretto255_bytes = Ei.aj)(), Er._crypto_core_ristretto255_nonreducedscalarbytes = () => (Er._crypto_core_ristretto255_nonreducedscalarbytes = Ei.bj)(), Er._crypto_core_ristretto255_hashbytes = () => (Er._crypto_core_ristretto255_hashbytes = Ei.cj)(), Er._crypto_core_ristretto255_scalarbytes = () => (Er._crypto_core_ristretto255_scalarbytes = Ei.dj)(), Er._crypto_pwhash_scryptsalsa208sha256_ll = (vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn) => (Er._crypto_pwhash_scryptsalsa208sha256_ll = Ei.ej)(vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn), Er._crypto_pwhash_scryptsalsa208sha256_bytes_min = () => (Er._crypto_pwhash_scryptsalsa208sha256_bytes_min = Ei.fj)(), Er._crypto_pwhash_scryptsalsa208sha256_bytes_max = () => (Er._crypto_pwhash_scryptsalsa208sha256_bytes_max = Ei.gj)(), Er._crypto_pwhash_scryptsalsa208sha256_passwd_min = () => (Er._crypto_pwhash_scryptsalsa208sha256_passwd_min = Ei.hj)(), Er._crypto_pwhash_scryptsalsa208sha256_passwd_max = () => (Er._crypto_pwhash_scryptsalsa208sha256_passwd_max = Ei.ij)(), Er._crypto_pwhash_scryptsalsa208sha256_saltbytes = () => (Er._crypto_pwhash_scryptsalsa208sha256_saltbytes = Ei.jj)(), Er._crypto_pwhash_scryptsalsa208sha256_strbytes = () => (Er._crypto_pwhash_scryptsalsa208sha256_strbytes = Ei.kj)(), Er._crypto_pwhash_scryptsalsa208sha256_strprefix = () => (Er._crypto_pwhash_scryptsalsa208sha256_strprefix = Ei.lj)(), Er._crypto_pwhash_scryptsalsa208sha256_opslimit_min = () => (Er._crypto_pwhash_scryptsalsa208sha256_opslimit_min = Ei.mj)(), Er._crypto_pwhash_scryptsalsa208sha256_opslimit_max = () => (Er._crypto_pwhash_scryptsalsa208sha256_opslimit_max = Ei.nj)(), Er._crypto_pwhash_scryptsalsa208sha256_memlimit_min = () => (Er._crypto_pwhash_scryptsalsa208sha256_memlimit_min = Ei.oj)(), Er._crypto_pwhash_scryptsalsa208sha256_memlimit_max = () => (Er._crypto_pwhash_scryptsalsa208sha256_memlimit_max = Ei.pj)(), Er._crypto_pwhash_scryptsalsa208sha256_opslimit_interactive = () => (Er._crypto_pwhash_scryptsalsa208sha256_opslimit_interactive = Ei.qj)(), Er._crypto_pwhash_scryptsalsa208sha256_memlimit_interactive = () => (Er._crypto_pwhash_scryptsalsa208sha256_memlimit_interactive = Ei.rj)(), Er._crypto_pwhash_scryptsalsa208sha256_opslimit_sensitive = () => (Er._crypto_pwhash_scryptsalsa208sha256_opslimit_sensitive = Ei.sj)(), Er._crypto_pwhash_scryptsalsa208sha256_memlimit_sensitive = () => (Er._crypto_pwhash_scryptsalsa208sha256_memlimit_sensitive = Ei.tj)(), Er._crypto_pwhash_scryptsalsa208sha256 = (vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn) => (Er._crypto_pwhash_scryptsalsa208sha256 = Ei.uj)(vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn), Er._crypto_pwhash_scryptsalsa208sha256_str = (vi, xi, Lr, dn, xn, oi, Yr) => (Er._crypto_pwhash_scryptsalsa208sha256_str = Ei.vj)(vi, xi, Lr, dn, xn, oi, Yr), Er._crypto_pwhash_scryptsalsa208sha256_str_verify = (vi, xi, Lr, dn) => (Er._crypto_pwhash_scryptsalsa208sha256_str_verify = Ei.wj)(vi, xi, Lr, dn), Er._crypto_pwhash_scryptsalsa208sha256_str_needs_rehash = (vi, xi, Lr, dn) => (Er._crypto_pwhash_scryptsalsa208sha256_str_needs_rehash = Ei.xj)(vi, xi, Lr, dn), Er._crypto_scalarmult_ed25519 = (vi, xi, Lr) => (Er._crypto_scalarmult_ed25519 = Ei.yj)(vi, xi, Lr), Er._crypto_scalarmult_ed25519_noclamp = (vi, xi, Lr) => (Er._crypto_scalarmult_ed25519_noclamp = Ei.zj)(vi, xi, Lr), Er._crypto_scalarmult_ed25519_base = (vi, xi) => (Er._crypto_scalarmult_ed25519_base = Ei.Aj)(vi, xi), Er._crypto_scalarmult_ed25519_base_noclamp = (vi, xi) => (Er._crypto_scalarmult_ed25519_base_noclamp = Ei.Bj)(vi, xi), Er._crypto_scalarmult_ed25519_bytes = () => (Er._crypto_scalarmult_ed25519_bytes = Ei.Cj)(), Er._crypto_scalarmult_ed25519_scalarbytes = () => (Er._crypto_scalarmult_ed25519_scalarbytes = Ei.Dj)(), Er._crypto_scalarmult_ristretto255 = (vi, xi, Lr) => (Er._crypto_scalarmult_ristretto255 = Ei.Ej)(vi, xi, Lr), Er._crypto_scalarmult_ristretto255_base = (vi, xi) => (Er._crypto_scalarmult_ristretto255_base = Ei.Fj)(vi, xi), Er._crypto_scalarmult_ristretto255_bytes = () => (Er._crypto_scalarmult_ristretto255_bytes = Ei.Gj)(), Er._crypto_scalarmult_ristretto255_scalarbytes = () => (Er._crypto_scalarmult_ristretto255_scalarbytes = Ei.Hj)(), Er._crypto_secretbox_xchacha20poly1305_detached = (vi, xi, Lr, dn, xn, oi, Yr) => (Er._crypto_secretbox_xchacha20poly1305_detached = Ei.Ij)(vi, xi, Lr, dn, xn, oi, Yr), Er._crypto_secretbox_xchacha20poly1305_easy = (vi, xi, Lr, dn, xn, oi) => (Er._crypto_secretbox_xchacha20poly1305_easy = Ei.Jj)(vi, xi, Lr, dn, xn, oi), Er._crypto_secretbox_xchacha20poly1305_open_detached = (vi, xi, Lr, dn, xn, oi, Yr) => (Er._crypto_secretbox_xchacha20poly1305_open_detached = Ei.Kj)(vi, xi, Lr, dn, xn, oi, Yr), Er._crypto_secretbox_xchacha20poly1305_open_easy = (vi, xi, Lr, dn, xn, oi) => (Er._crypto_secretbox_xchacha20poly1305_open_easy = Ei.Lj)(vi, xi, Lr, dn, xn, oi), Er._crypto_secretbox_xchacha20poly1305_keybytes = () => (Er._crypto_secretbox_xchacha20poly1305_keybytes = Ei.Mj)(), Er._crypto_secretbox_xchacha20poly1305_noncebytes = () => (Er._crypto_secretbox_xchacha20poly1305_noncebytes = Ei.Nj)(), Er._crypto_secretbox_xchacha20poly1305_macbytes = () => (Er._crypto_secretbox_xchacha20poly1305_macbytes = Ei.Oj)(), Er._crypto_secretbox_xchacha20poly1305_messagebytes_max = () => (Er._crypto_secretbox_xchacha20poly1305_messagebytes_max = Ei.Pj)(), Er._crypto_shorthash_siphashx24_bytes = () => (Er._crypto_shorthash_siphashx24_bytes = Ei.Qj)(), Er._crypto_shorthash_siphashx24_keybytes = () => (Er._crypto_shorthash_siphashx24_keybytes = Ei.Rj)(), Er._crypto_shorthash_siphashx24 = (vi, xi, Lr, dn, xn) => (Er._crypto_shorthash_siphashx24 = Ei.Sj)(vi, xi, Lr, dn, xn), Er._crypto_stream_salsa2012 = (vi, xi, Lr, dn, xn) => (Er._crypto_stream_salsa2012 = Ei.Tj)(vi, xi, Lr, dn, xn), Er._crypto_stream_salsa2012_xor = (vi, xi, Lr, dn, xn, oi) => (Er._crypto_stream_salsa2012_xor = Ei.Uj)(vi, xi, Lr, dn, xn, oi), Er._crypto_stream_salsa2012_keybytes = () => (Er._crypto_stream_salsa2012_keybytes = Ei.Vj)(), Er._crypto_stream_salsa2012_noncebytes = () => (Er._crypto_stream_salsa2012_noncebytes = Ei.Wj)(), Er._crypto_stream_salsa2012_messagebytes_max = () => (Er._crypto_stream_salsa2012_messagebytes_max = Ei.Xj)(), Er._crypto_stream_salsa2012_keygen = (vi) => (Er._crypto_stream_salsa2012_keygen = Ei.Yj)(vi), Er._crypto_stream_salsa208 = (vi, xi, Lr, dn, xn) => (Er._crypto_stream_salsa208 = Ei.Zj)(vi, xi, Lr, dn, xn), Er._crypto_stream_salsa208_xor = (vi, xi, Lr, dn, xn, oi) => (Er._crypto_stream_salsa208_xor = Ei._j)(vi, xi, Lr, dn, xn, oi), Er._crypto_stream_salsa208_keybytes = () => (Er._crypto_stream_salsa208_keybytes = Ei.$j)(), Er._crypto_stream_salsa208_noncebytes = () => (Er._crypto_stream_salsa208_noncebytes = Ei.ak)(), Er._crypto_stream_salsa208_messagebytes_max = () => (Er._crypto_stream_salsa208_messagebytes_max = Ei.bk)(), Er._crypto_stream_salsa208_keygen = (vi) => (Er._crypto_stream_salsa208_keygen = Ei.ck)(vi), Er._crypto_stream_xchacha20_keybytes = () => (Er._crypto_stream_xchacha20_keybytes = Ei.dk)(), Er._crypto_stream_xchacha20_noncebytes = () => (Er._crypto_stream_xchacha20_noncebytes = Ei.ek)(), Er._crypto_stream_xchacha20_messagebytes_max = () => (Er._crypto_stream_xchacha20_messagebytes_max = Ei.fk)(), Er._crypto_stream_xchacha20 = (vi, xi, Lr, dn, xn) => (Er._crypto_stream_xchacha20 = Ei.gk)(vi, xi, Lr, dn, xn), Er._crypto_stream_xchacha20_xor_ic = (vi, xi, Lr, dn, xn, oi, Yr, ji) => (Er._crypto_stream_xchacha20_xor_ic = Ei.hk)(vi, xi, Lr, dn, xn, oi, Yr, ji), Er._crypto_stream_xchacha20_xor = (vi, xi, Lr, dn, xn, oi) => (Er._crypto_stream_xchacha20_xor = Ei.ik)(vi, xi, Lr, dn, xn, oi), Er._crypto_stream_xchacha20_keygen = (vi) => (Er._crypto_stream_xchacha20_keygen = Ei.jk)(vi), Er._malloc = (vi) => (Er._malloc = Ei.kk)(vi), Er._free = (vi) => (Er._free = Ei.lk)(vi), Er.setValue = function(vi, xi, Lr = "i8") {
                switch (Lr.endsWith("*") && (Lr = "*"), Lr) {
                  case "i1":
                  case "i8":
                    Hi[vi] = xi;
                    break;
                  case "i16":
                    Ui[vi >> 1] = xi;
                    break;
                  case "i32":
                    ln[vi >> 2] = xi;
                    break;
                  case "i64":
                    na("to do setValue(i64) use WASM_BIGINT");
                  case "float":
                    Bo[vi >> 2] = xi;
                    break;
                  case "double":
                    co[vi >> 3] = xi;
                    break;
                  case "*":
                    Un[vi >> 2] = xi;
                    break;
                  default:
                    na(`invalid type for setValue: ${Lr}`);
                }
              }, Er.getValue = function(vi, xi = "i8") {
                switch (xi.endsWith("*") && (xi = "*"), xi) {
                  case "i1":
                  case "i8":
                    return Hi[vi];
                  case "i16":
                    return Ui[vi >> 1];
                  case "i32":
                    return ln[vi >> 2];
                  case "i64":
                    na("to do getValue(i64) use WASM_BIGINT");
                  case "float":
                    return Bo[vi >> 2];
                  case "double":
                    return co[vi >> 3];
                  case "*":
                    return Un[vi >> 2];
                  default:
                    na(`invalid type for getValue: ${xi}`);
                }
              }, Er.UTF8ToString = Gi, ls = function vi() {
                hi || vs(), hi || (ls = vi);
              }, Er.preInit) for (typeof Er.preInit == "function" && (Er.preInit = [Er.preInit]); Er.preInit.length > 0; ) Er.preInit.pop()();
              vs();
            });
          };
          var pe, $ = $ !== void 0 ? $ : {}, Ee = typeof window == "object", be = typeof importScripts == "function", He = typeof process$1 == "object" && typeof process$1.versions == "object" && typeof process$1.versions.node == "string", Pe = Object.assign({}, $), nr = "";
          if (He) {
            var ir = require$$0, or = requirePathBrowserify();
            nr = __dirname + "/", pe = (Wr) => (Wr = si(Wr) ? new URL(Wr) : or.normalize(Wr), ir.readFileSync(Wr)), !$.thisProgram && process$1.argv.length > 1 && process$1.argv[1].replace(/\\/g, "/"), process$1.argv.slice(2), n.exports = $;
          } else (Ee || be) && (be ? nr = self.location.href : typeof document < "u" && document.currentScript && (nr = document.currentScript.src), nr = nr.startsWith("blob:") ? "" : nr.substr(0, nr.replace(/[?#].*/, "").lastIndexOf("/") + 1), be && (pe = (Wr) => {
            var ri = new XMLHttpRequest();
            return ri.open("GET", Wr, !1), ri.responseType = "arraybuffer", ri.send(null), new Uint8Array(ri.response);
          }));
          $.print;
          var lr, Ir, xr = $.printErr || void 0;
          Object.assign($, Pe), Pe = null, $.arguments && $.arguments, $.thisProgram && $.thisProgram, $.quit && $.quit, $.wasmBinary && (lr = $.wasmBinary);
          var kr, Ce, tr, Fe, Sr, er, Ie, xe = !1;
          function rr() {
            var Wr = Ir.buffer;
            $.HEAP8 = kr = new Int8Array(Wr), $.HEAP16 = tr = new Int16Array(Wr), $.HEAPU8 = Ce = new Uint8Array(Wr), $.HEAPU16 = new Uint16Array(Wr), $.HEAP32 = Fe = new Int32Array(Wr), $.HEAPU32 = Sr = new Uint32Array(Wr), $.HEAPF32 = er = new Float32Array(Wr), $.HEAPF64 = Ie = new Float64Array(Wr);
          }
          var ar = [], yr = [], _r = [], Or = 0, vr = null;
          function Te(Wr) {
            var ri;
            throw (ri = $.onAbort) == null || ri.call($, Wr), xr(Wr = "Aborted(" + Wr + ")"), xe = !0, Wr += ". Build with -sASSERTIONS for more info.", new WebAssembly.RuntimeError(Wr);
          }
          var Cr, Hr = "data:application/octet-stream;base64,", si = (Wr) => Wr.startsWith("file://");
          function ui(Wr) {
            return Promise.resolve().then(() => function(ri) {
              if (ri == Cr && lr) return new Uint8Array(lr);
              var _i = function(Er) {
                if (((Di) => Di.startsWith(Hr))(Er)) return function(Di) {
                  if (He !== void 0 && He) {
                    var _n = Buffer$f.from(Di, "base64");
                    return new Uint8Array(_n.buffer, _n.byteOffset, _n.length);
                  }
                  for (var On = atob(Di), so = new Uint8Array(On.length), Do = 0; Do < On.length; ++Do) so[Do] = On.charCodeAt(Do);
                  return so;
                }(Er.slice(37));
              }(ri);
              if (_i) return _i;
              if (pe) return pe(ri);
              throw "both async and sync fetching of the wasm failed";
            }(Wr));
          }
          var Li = { 36800: () => $.getRandomValue(), 36836: () => {
            if ($.getRandomValue === void 0) try {
              var Wr = typeof window == "object" ? window : self, ri = Wr.crypto !== void 0 ? Wr.crypto : Wr.msCrypto;
              ri = ri === void 0 ? Er : ri;
              var _i = function() {
                var _n = new Uint32Array(1);
                return ri.getRandomValues(_n), _n[0] >>> 0;
              };
              _i(), $.getRandomValue = _i;
            } catch {
              try {
                var Er = requireCryptoBrowserify(), Di = function() {
                  var On = Er.randomBytes(4);
                  return (On[0] << 24 | On[1] << 16 | On[2] << 8 | On[3]) >>> 0;
                };
                Di(), $.getRandomValue = Di;
              } catch {
                throw "No secure random number generator found";
              }
            }
          } }, Qi = (Wr) => {
            for (; Wr.length > 0; ) Wr.shift()($);
          };
          $.noExitRuntime;
          var wi, Ji = typeof TextDecoder < "u" ? new TextDecoder() : void 0, mn = (Wr, ri) => Wr ? ((_i, Er, Di) => {
            for (var _n = Er + Di, On = Er; _i[On] && !(On >= _n); ) ++On;
            if (On - Er > 16 && _i.buffer && Ji) return Ji.decode(_i.subarray(Er, On));
            for (var so = ""; Er < On; ) {
              var Do = _i[Er++];
              if (128 & Do) {
                var gn = 63 & _i[Er++];
                if ((224 & Do) != 192) {
                  var Gn = 63 & _i[Er++];
                  if ((Do = (240 & Do) == 224 ? (15 & Do) << 12 | gn << 6 | Gn : (7 & Do) << 18 | gn << 12 | Gn << 6 | 63 & _i[Er++]) < 65536) so += String.fromCharCode(Do);
                  else {
                    var pn = Do - 65536;
                    so += String.fromCharCode(55296 | pn >> 10, 56320 | 1023 & pn);
                  }
                } else so += String.fromCharCode((31 & Do) << 6 | gn);
              } else so += String.fromCharCode(Do);
            }
            return so;
          })(Ce, Wr, ri) : "", pi = [], ei = (Wr) => {
            var ri = (Wr - Ir.buffer.byteLength + 65535) / 65536;
            try {
              return Ir.grow(ri), rr(), 1;
            } catch {
            }
          }, Vr = { b: (Wr, ri, _i, Er) => {
            Te(`Assertion failed: ${mn(Wr)}, at: ` + [ri ? mn(ri) : "unknown filename", _i, Er ? mn(Er) : "unknown function"]);
          }, c: () => {
            Te("");
          }, d: (Wr, ri, _i) => Ce.copyWithin(Wr, ri, ri + _i), a: (Wr, ri, _i) => ((Er, Di, _n) => {
            var On = ((so, Do) => {
              var gn;
              for (pi.length = 0; gn = Ce[so++]; ) {
                var Gn = gn != 105;
                Do += (Gn &= gn != 112) && Do % 8 ? 4 : 0, pi.push(gn == 112 ? Sr[Do >> 2] : gn == 105 ? Fe[Do >> 2] : Ie[Do >> 3]), Do += Gn ? 8 : 4;
              }
              return pi;
            })(Di, _n);
            return Li[Er](...On);
          })(Wr, ri, _i), e: (Wr) => {
            var ri = Ce.length, _i = 2147483648;
            if ((Wr >>>= 0) > _i) return !1;
            for (var Er, Di = 1; Di <= 4; Di *= 2) {
              var _n = ri * (1 + 0.2 / Di);
              _n = Math.min(_n, Wr + 100663296);
              var On = Math.min(_i, (Er = Math.max(Wr, _n)) + (65536 - Er % 65536) % 65536);
              if (ei(On)) return !0;
            }
            return !1;
          } }, qr = function() {
            var Er;
            var Wr, ri = { a: Vr };
            function _i(Di, _n) {
              return qr = Di.exports, Ir = qr.f, rr(), function(On) {
                var Do;
                if (Or--, (Do = $.monitorRunDependencies) == null || Do.call($, Or), Or == 0 && vr) {
                  var so = vr;
                  vr = null, so();
                }
              }(), qr;
            }
            if (Or++, (Er = $.monitorRunDependencies) == null || Er.call($, Or), $.instantiateWasm) try {
              return $.instantiateWasm(ri, _i);
            } catch (Di) {
              return xr(`Module.instantiateWasm callback failed with error: ${Di}`), !1;
            }
            return Cr || (Cr = "data:application/octet-stream;base64,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"), Wr = ri, ui(Cr).then((Di) => WebAssembly.instantiate(Di, Wr)).then(function(Di) {
              _i(Di.instance);
            }, (Di) => {
              xr(`failed to asynchronously prepare wasm: ${Di}`), Te(Di);
            }), {};
          }();
          function Zi() {
            function Wr() {
              var ri;
              wi || (wi = !0, $.calledRun = !0, xe || (Qi(yr), (ri = $.onRuntimeInitialized) == null || ri.call($), function() {
                if ($.postRun) for (typeof $.postRun == "function" && ($.postRun = [$.postRun]); $.postRun.length; ) _i = $.postRun.shift(), _r.unshift(_i);
                var _i;
                Qi(_r);
              }()));
            }
            Or > 0 || (function() {
              if ($.preRun) for (typeof $.preRun == "function" && ($.preRun = [$.preRun]); $.preRun.length; ) ri = $.preRun.shift(), ar.unshift(ri);
              var ri;
              Qi(ar);
            }(), Or > 0 || ($.setStatus ? ($.setStatus("Running..."), setTimeout(function() {
              setTimeout(function() {
                $.setStatus("");
              }, 1), Wr();
            }, 1)) : Wr()));
          }
          if ($._crypto_aead_aegis128l_keybytes = () => ($._crypto_aead_aegis128l_keybytes = qr.g)(), $._crypto_aead_aegis128l_nsecbytes = () => ($._crypto_aead_aegis128l_nsecbytes = qr.h)(), $._crypto_aead_aegis128l_npubbytes = () => ($._crypto_aead_aegis128l_npubbytes = qr.i)(), $._crypto_aead_aegis128l_abytes = () => ($._crypto_aead_aegis128l_abytes = qr.j)(), $._crypto_aead_aegis128l_messagebytes_max = () => ($._crypto_aead_aegis128l_messagebytes_max = qr.k)(), $._crypto_aead_aegis128l_keygen = (Wr) => ($._crypto_aead_aegis128l_keygen = qr.l)(Wr), $._crypto_aead_aegis128l_encrypt = (Wr, ri, _i, Er, Di, _n, On, so, Do, gn, Gn) => ($._crypto_aead_aegis128l_encrypt = qr.m)(Wr, ri, _i, Er, Di, _n, On, so, Do, gn, Gn), $._crypto_aead_aegis128l_encrypt_detached = (Wr, ri, _i, Er, Di, _n, On, so, Do, gn, Gn, pn) => ($._crypto_aead_aegis128l_encrypt_detached = qr.n)(Wr, ri, _i, Er, Di, _n, On, so, Do, gn, Gn, pn), $._crypto_aead_aegis128l_decrypt = (Wr, ri, _i, Er, Di, _n, On, so, Do, gn, Gn) => ($._crypto_aead_aegis128l_decrypt = qr.o)(Wr, ri, _i, Er, Di, _n, On, so, Do, gn, Gn), $._crypto_aead_aegis128l_decrypt_detached = (Wr, ri, _i, Er, Di, _n, On, so, Do, gn, Gn) => ($._crypto_aead_aegis128l_decrypt_detached = qr.p)(Wr, ri, _i, Er, Di, _n, On, so, Do, gn, Gn), $._crypto_aead_aegis256_keybytes = () => ($._crypto_aead_aegis256_keybytes = qr.q)(), $._crypto_aead_aegis256_nsecbytes = () => ($._crypto_aead_aegis256_nsecbytes = qr.r)(), $._crypto_aead_aegis256_npubbytes = () => ($._crypto_aead_aegis256_npubbytes = qr.s)(), $._crypto_aead_aegis256_abytes = () => ($._crypto_aead_aegis256_abytes = qr.t)(), $._crypto_aead_aegis256_messagebytes_max = () => ($._crypto_aead_aegis256_messagebytes_max = qr.u)(), $._crypto_aead_aegis256_keygen = (Wr) => ($._crypto_aead_aegis256_keygen = qr.v)(Wr), $._crypto_aead_aegis256_encrypt = (Wr, ri, _i, Er, Di, _n, On, so, Do, gn, Gn) => ($._crypto_aead_aegis256_encrypt = qr.w)(Wr, ri, _i, Er, Di, _n, On, so, Do, gn, Gn), $._crypto_aead_aegis256_encrypt_detached = (Wr, ri, _i, Er, Di, _n, On, so, Do, gn, Gn, pn) => ($._crypto_aead_aegis256_encrypt_detached = qr.x)(Wr, ri, _i, Er, Di, _n, On, so, Do, gn, Gn, pn), $._crypto_aead_aegis256_decrypt = (Wr, ri, _i, Er, Di, _n, On, so, Do, gn, Gn) => ($._crypto_aead_aegis256_decrypt = qr.y)(Wr, ri, _i, Er, Di, _n, On, so, Do, gn, Gn), $._crypto_aead_aegis256_decrypt_detached = (Wr, ri, _i, Er, Di, _n, On, so, Do, gn, Gn) => ($._crypto_aead_aegis256_decrypt_detached = qr.z)(Wr, ri, _i, Er, Di, _n, On, so, Do, gn, Gn), $._crypto_aead_aes256gcm_is_available = () => ($._crypto_aead_aes256gcm_is_available = qr.A)(), $._crypto_aead_chacha20poly1305_encrypt_detached = (Wr, ri, _i, Er, Di, _n, On, so, Do, gn, Gn, pn) => ($._crypto_aead_chacha20poly1305_encrypt_detached = qr.B)(Wr, ri, _i, Er, Di, _n, On, so, Do, gn, Gn, pn), $._crypto_aead_chacha20poly1305_encrypt = (Wr, ri, _i, Er, Di, _n, On, so, Do, gn, Gn) => ($._crypto_aead_chacha20poly1305_encrypt = qr.C)(Wr, ri, _i, Er, Di, _n, On, so, Do, gn, Gn), $._crypto_aead_chacha20poly1305_ietf_encrypt_detached = (Wr, ri, _i, Er, Di, _n, On, so, Do, gn, Gn, pn) => ($._crypto_aead_chacha20poly1305_ietf_encrypt_detached = qr.D)(Wr, ri, _i, Er, Di, _n, On, so, Do, gn, Gn, pn), $._crypto_aead_chacha20poly1305_ietf_encrypt = (Wr, ri, _i, Er, Di, _n, On, so, Do, gn, Gn) => ($._crypto_aead_chacha20poly1305_ietf_encrypt = qr.E)(Wr, ri, _i, Er, Di, _n, On, so, Do, gn, Gn), $._crypto_aead_chacha20poly1305_decrypt_detached = (Wr, ri, _i, Er, Di, _n, On, so, Do, gn, Gn) => ($._crypto_aead_chacha20poly1305_decrypt_detached = qr.F)(Wr, ri, _i, Er, Di, _n, On, so, Do, gn, Gn), $._crypto_aead_chacha20poly1305_decrypt = (Wr, ri, _i, Er, Di, _n, On, so, Do, gn, Gn) => ($._crypto_aead_chacha20poly1305_decrypt = qr.G)(Wr, ri, _i, Er, Di, _n, On, so, Do, gn, Gn), $._crypto_aead_chacha20poly1305_ietf_decrypt_detached = (Wr, ri, _i, Er, Di, _n, On, so, Do, gn, Gn) => ($._crypto_aead_chacha20poly1305_ietf_decrypt_detached = qr.H)(Wr, ri, _i, Er, Di, _n, On, so, Do, gn, Gn), $._crypto_aead_chacha20poly1305_ietf_decrypt = (Wr, ri, _i, Er, Di, _n, On, so, Do, gn, Gn) => ($._crypto_aead_chacha20poly1305_ietf_decrypt = qr.I)(Wr, ri, _i, Er, Di, _n, On, so, Do, gn, Gn), $._crypto_aead_chacha20poly1305_ietf_keybytes = () => ($._crypto_aead_chacha20poly1305_ietf_keybytes = qr.J)(), $._crypto_aead_chacha20poly1305_ietf_npubbytes = () => ($._crypto_aead_chacha20poly1305_ietf_npubbytes = qr.K)(), $._crypto_aead_chacha20poly1305_ietf_nsecbytes = () => ($._crypto_aead_chacha20poly1305_ietf_nsecbytes = qr.L)(), $._crypto_aead_chacha20poly1305_ietf_abytes = () => ($._crypto_aead_chacha20poly1305_ietf_abytes = qr.M)(), $._crypto_aead_chacha20poly1305_ietf_messagebytes_max = () => ($._crypto_aead_chacha20poly1305_ietf_messagebytes_max = qr.N)(), $._crypto_aead_chacha20poly1305_ietf_keygen = (Wr) => ($._crypto_aead_chacha20poly1305_ietf_keygen = qr.O)(Wr), $._crypto_aead_chacha20poly1305_keybytes = () => ($._crypto_aead_chacha20poly1305_keybytes = qr.P)(), $._crypto_aead_chacha20poly1305_npubbytes = () => ($._crypto_aead_chacha20poly1305_npubbytes = qr.Q)(), $._crypto_aead_chacha20poly1305_nsecbytes = () => ($._crypto_aead_chacha20poly1305_nsecbytes = qr.R)(), $._crypto_aead_chacha20poly1305_abytes = () => ($._crypto_aead_chacha20poly1305_abytes = qr.S)(), $._crypto_aead_chacha20poly1305_messagebytes_max = () => ($._crypto_aead_chacha20poly1305_messagebytes_max = qr.T)(), $._crypto_aead_chacha20poly1305_keygen = (Wr) => ($._crypto_aead_chacha20poly1305_keygen = qr.U)(Wr), $._crypto_aead_xchacha20poly1305_ietf_encrypt_detached = (Wr, ri, _i, Er, Di, _n, On, so, Do, gn, Gn, pn) => ($._crypto_aead_xchacha20poly1305_ietf_encrypt_detached = qr.V)(Wr, ri, _i, Er, Di, _n, On, so, Do, gn, Gn, pn), $._crypto_aead_xchacha20poly1305_ietf_encrypt = (Wr, ri, _i, Er, Di, _n, On, so, Do, gn, Gn) => ($._crypto_aead_xchacha20poly1305_ietf_encrypt = qr.W)(Wr, ri, _i, Er, Di, _n, On, so, Do, gn, Gn), $._crypto_aead_xchacha20poly1305_ietf_decrypt_detached = (Wr, ri, _i, Er, Di, _n, On, so, Do, gn, Gn) => ($._crypto_aead_xchacha20poly1305_ietf_decrypt_detached = qr.X)(Wr, ri, _i, Er, Di, _n, On, so, Do, gn, Gn), $._crypto_aead_xchacha20poly1305_ietf_decrypt = (Wr, ri, _i, Er, Di, _n, On, so, Do, gn, Gn) => ($._crypto_aead_xchacha20poly1305_ietf_decrypt = qr.Y)(Wr, ri, _i, Er, Di, _n, On, so, Do, gn, Gn), $._crypto_aead_xchacha20poly1305_ietf_keybytes = () => ($._crypto_aead_xchacha20poly1305_ietf_keybytes = qr.Z)(), $._crypto_aead_xchacha20poly1305_ietf_npubbytes = () => ($._crypto_aead_xchacha20poly1305_ietf_npubbytes = qr._)(), $._crypto_aead_xchacha20poly1305_ietf_nsecbytes = () => ($._crypto_aead_xchacha20poly1305_ietf_nsecbytes = qr.$)(), $._crypto_aead_xchacha20poly1305_ietf_abytes = () => ($._crypto_aead_xchacha20poly1305_ietf_abytes = qr.aa)(), $._crypto_aead_xchacha20poly1305_ietf_messagebytes_max = () => ($._crypto_aead_xchacha20poly1305_ietf_messagebytes_max = qr.ba)(), $._crypto_aead_xchacha20poly1305_ietf_keygen = (Wr) => ($._crypto_aead_xchacha20poly1305_ietf_keygen = qr.ca)(Wr), $._crypto_auth_bytes = () => ($._crypto_auth_bytes = qr.da)(), $._crypto_auth_keybytes = () => ($._crypto_auth_keybytes = qr.ea)(), $._crypto_auth_primitive = () => ($._crypto_auth_primitive = qr.fa)(), $._crypto_auth = (Wr, ri, _i, Er, Di) => ($._crypto_auth = qr.ga)(Wr, ri, _i, Er, Di), $._crypto_auth_verify = (Wr, ri, _i, Er, Di) => ($._crypto_auth_verify = qr.ha)(Wr, ri, _i, Er, Di), $._crypto_auth_keygen = (Wr) => ($._crypto_auth_keygen = qr.ia)(Wr), $._crypto_auth_hmacsha256_bytes = () => ($._crypto_auth_hmacsha256_bytes = qr.ja)(), $._crypto_auth_hmacsha256_keybytes = () => ($._crypto_auth_hmacsha256_keybytes = qr.ka)(), $._crypto_auth_hmacsha256_statebytes = () => ($._crypto_auth_hmacsha256_statebytes = qr.la)(), $._crypto_auth_hmacsha256_keygen = (Wr) => ($._crypto_auth_hmacsha256_keygen = qr.ma)(Wr), $._crypto_auth_hmacsha256_init = (Wr, ri, _i) => ($._crypto_auth_hmacsha256_init = qr.na)(Wr, ri, _i), $._crypto_auth_hmacsha256_update = (Wr, ri, _i, Er) => ($._crypto_auth_hmacsha256_update = qr.oa)(Wr, ri, _i, Er), $._crypto_auth_hmacsha256_final = (Wr, ri) => ($._crypto_auth_hmacsha256_final = qr.pa)(Wr, ri), $._crypto_auth_hmacsha256 = (Wr, ri, _i, Er, Di) => ($._crypto_auth_hmacsha256 = qr.qa)(Wr, ri, _i, Er, Di), $._crypto_auth_hmacsha256_verify = (Wr, ri, _i, Er, Di) => ($._crypto_auth_hmacsha256_verify = qr.ra)(Wr, ri, _i, Er, Di), $._crypto_auth_hmacsha512_bytes = () => ($._crypto_auth_hmacsha512_bytes = qr.sa)(), $._crypto_auth_hmacsha512_keybytes = () => ($._crypto_auth_hmacsha512_keybytes = qr.ta)(), $._crypto_auth_hmacsha512_statebytes = () => ($._crypto_auth_hmacsha512_statebytes = qr.ua)(), $._crypto_auth_hmacsha512_keygen = (Wr) => ($._crypto_auth_hmacsha512_keygen = qr.va)(Wr), $._crypto_auth_hmacsha512_init = (Wr, ri, _i) => ($._crypto_auth_hmacsha512_init = qr.wa)(Wr, ri, _i), $._crypto_auth_hmacsha512_update = (Wr, ri, _i, Er) => ($._crypto_auth_hmacsha512_update = qr.xa)(Wr, ri, _i, Er), $._crypto_auth_hmacsha512_final = (Wr, ri) => ($._crypto_auth_hmacsha512_final = qr.ya)(Wr, ri), $._crypto_auth_hmacsha512 = (Wr, ri, _i, Er, Di) => ($._crypto_auth_hmacsha512 = qr.za)(Wr, ri, _i, Er, Di), $._crypto_auth_hmacsha512_verify = (Wr, ri, _i, Er, Di) => ($._crypto_auth_hmacsha512_verify = qr.Aa)(Wr, ri, _i, Er, Di), $._crypto_auth_hmacsha512256_bytes = () => ($._crypto_auth_hmacsha512256_bytes = qr.Ba)(), $._crypto_auth_hmacsha512256_keybytes = () => ($._crypto_auth_hmacsha512256_keybytes = qr.Ca)(), $._crypto_auth_hmacsha512256_statebytes = () => ($._crypto_auth_hmacsha512256_statebytes = qr.Da)(), $._crypto_auth_hmacsha512256_keygen = (Wr) => ($._crypto_auth_hmacsha512256_keygen = qr.Ea)(Wr), $._crypto_auth_hmacsha512256_init = (Wr, ri, _i) => ($._crypto_auth_hmacsha512256_init = qr.Fa)(Wr, ri, _i), $._crypto_auth_hmacsha512256_update = (Wr, ri, _i, Er) => ($._crypto_auth_hmacsha512256_update = qr.Ga)(Wr, ri, _i, Er), $._crypto_auth_hmacsha512256_final = (Wr, ri) => ($._crypto_auth_hmacsha512256_final = qr.Ha)(Wr, ri), $._crypto_auth_hmacsha512256 = (Wr, ri, _i, Er, Di) => ($._crypto_auth_hmacsha512256 = qr.Ia)(Wr, ri, _i, Er, Di), $._crypto_auth_hmacsha512256_verify = (Wr, ri, _i, Er, Di) => ($._crypto_auth_hmacsha512256_verify = qr.Ja)(Wr, ri, _i, Er, Di), $._crypto_box_seedbytes = () => ($._crypto_box_seedbytes = qr.Ka)(), $._crypto_box_publickeybytes = () => ($._crypto_box_publickeybytes = qr.La)(), $._crypto_box_secretkeybytes = () => ($._crypto_box_secretkeybytes = qr.Ma)(), $._crypto_box_beforenmbytes = () => ($._crypto_box_beforenmbytes = qr.Na)(), $._crypto_box_noncebytes = () => ($._crypto_box_noncebytes = qr.Oa)(), $._crypto_box_zerobytes = () => ($._crypto_box_zerobytes = qr.Pa)(), $._crypto_box_boxzerobytes = () => ($._crypto_box_boxzerobytes = qr.Qa)(), $._crypto_box_macbytes = () => ($._crypto_box_macbytes = qr.Ra)(), $._crypto_box_messagebytes_max = () => ($._crypto_box_messagebytes_max = qr.Sa)(), $._crypto_box_primitive = () => ($._crypto_box_primitive = qr.Ta)(), $._crypto_box_seed_keypair = (Wr, ri, _i) => ($._crypto_box_seed_keypair = qr.Ua)(Wr, ri, _i), $._crypto_box_keypair = (Wr, ri) => ($._crypto_box_keypair = qr.Va)(Wr, ri), $._crypto_box_beforenm = (Wr, ri, _i) => ($._crypto_box_beforenm = qr.Wa)(Wr, ri, _i), $._crypto_box_afternm = (Wr, ri, _i, Er, Di, _n) => ($._crypto_box_afternm = qr.Xa)(Wr, ri, _i, Er, Di, _n), $._crypto_box_open_afternm = (Wr, ri, _i, Er, Di, _n) => ($._crypto_box_open_afternm = qr.Ya)(Wr, ri, _i, Er, Di, _n), $._crypto_box = (Wr, ri, _i, Er, Di, _n, On) => ($._crypto_box = qr.Za)(Wr, ri, _i, Er, Di, _n, On), $._crypto_box_open = (Wr, ri, _i, Er, Di, _n, On) => ($._crypto_box_open = qr._a)(Wr, ri, _i, Er, Di, _n, On), $._crypto_box_detached_afternm = (Wr, ri, _i, Er, Di, _n, On) => ($._crypto_box_detached_afternm = qr.$a)(Wr, ri, _i, Er, Di, _n, On), $._crypto_box_detached = (Wr, ri, _i, Er, Di, _n, On, so) => ($._crypto_box_detached = qr.ab)(Wr, ri, _i, Er, Di, _n, On, so), $._crypto_box_easy_afternm = (Wr, ri, _i, Er, Di, _n) => ($._crypto_box_easy_afternm = qr.bb)(Wr, ri, _i, Er, Di, _n), $._crypto_box_easy = (Wr, ri, _i, Er, Di, _n, On) => ($._crypto_box_easy = qr.cb)(Wr, ri, _i, Er, Di, _n, On), $._crypto_box_open_detached_afternm = (Wr, ri, _i, Er, Di, _n, On) => ($._crypto_box_open_detached_afternm = qr.db)(Wr, ri, _i, Er, Di, _n, On), $._crypto_box_open_detached = (Wr, ri, _i, Er, Di, _n, On, so) => ($._crypto_box_open_detached = qr.eb)(Wr, ri, _i, Er, Di, _n, On, so), $._crypto_box_open_easy_afternm = (Wr, ri, _i, Er, Di, _n) => ($._crypto_box_open_easy_afternm = qr.fb)(Wr, ri, _i, Er, Di, _n), $._crypto_box_open_easy = (Wr, ri, _i, Er, Di, _n, On) => ($._crypto_box_open_easy = qr.gb)(Wr, ri, _i, Er, Di, _n, On), $._crypto_box_seal = (Wr, ri, _i, Er, Di) => ($._crypto_box_seal = qr.hb)(Wr, ri, _i, Er, Di), $._crypto_box_seal_open = (Wr, ri, _i, Er, Di, _n) => ($._crypto_box_seal_open = qr.ib)(Wr, ri, _i, Er, Di, _n), $._crypto_box_sealbytes = () => ($._crypto_box_sealbytes = qr.jb)(), $._crypto_box_curve25519xsalsa20poly1305_seed_keypair = (Wr, ri, _i) => ($._crypto_box_curve25519xsalsa20poly1305_seed_keypair = qr.kb)(Wr, ri, _i), $._crypto_box_curve25519xsalsa20poly1305_keypair = (Wr, ri) => ($._crypto_box_curve25519xsalsa20poly1305_keypair = qr.lb)(Wr, ri), $._crypto_box_curve25519xsalsa20poly1305_beforenm = (Wr, ri, _i) => ($._crypto_box_curve25519xsalsa20poly1305_beforenm = qr.mb)(Wr, ri, _i), $._crypto_box_curve25519xsalsa20poly1305_afternm = (Wr, ri, _i, Er, Di, _n) => ($._crypto_box_curve25519xsalsa20poly1305_afternm = qr.nb)(Wr, ri, _i, Er, Di, _n), $._crypto_box_curve25519xsalsa20poly1305_open_afternm = (Wr, ri, _i, Er, Di, _n) => ($._crypto_box_curve25519xsalsa20poly1305_open_afternm = qr.ob)(Wr, ri, _i, Er, Di, _n), $._crypto_box_curve25519xsalsa20poly1305 = (Wr, ri, _i, Er, Di, _n, On) => ($._crypto_box_curve25519xsalsa20poly1305 = qr.pb)(Wr, ri, _i, Er, Di, _n, On), $._crypto_box_curve25519xsalsa20poly1305_open = (Wr, ri, _i, Er, Di, _n, On) => ($._crypto_box_curve25519xsalsa20poly1305_open = qr.qb)(Wr, ri, _i, Er, Di, _n, On), $._crypto_box_curve25519xsalsa20poly1305_seedbytes = () => ($._crypto_box_curve25519xsalsa20poly1305_seedbytes = qr.rb)(), $._crypto_box_curve25519xsalsa20poly1305_publickeybytes = () => ($._crypto_box_curve25519xsalsa20poly1305_publickeybytes = qr.sb)(), $._crypto_box_curve25519xsalsa20poly1305_secretkeybytes = () => ($._crypto_box_curve25519xsalsa20poly1305_secretkeybytes = qr.tb)(), $._crypto_box_curve25519xsalsa20poly1305_beforenmbytes = () => ($._crypto_box_curve25519xsalsa20poly1305_beforenmbytes = qr.ub)(), $._crypto_box_curve25519xsalsa20poly1305_noncebytes = () => ($._crypto_box_curve25519xsalsa20poly1305_noncebytes = qr.vb)(), $._crypto_box_curve25519xsalsa20poly1305_zerobytes = () => ($._crypto_box_curve25519xsalsa20poly1305_zerobytes = qr.wb)(), $._crypto_box_curve25519xsalsa20poly1305_boxzerobytes = () => ($._crypto_box_curve25519xsalsa20poly1305_boxzerobytes = qr.xb)(), $._crypto_box_curve25519xsalsa20poly1305_macbytes = () => ($._crypto_box_curve25519xsalsa20poly1305_macbytes = qr.yb)(), $._crypto_box_curve25519xsalsa20poly1305_messagebytes_max = () => ($._crypto_box_curve25519xsalsa20poly1305_messagebytes_max = qr.zb)(), $._crypto_core_hchacha20 = (Wr, ri, _i, Er) => ($._crypto_core_hchacha20 = qr.Ab)(Wr, ri, _i, Er), $._crypto_core_hchacha20_outputbytes = () => ($._crypto_core_hchacha20_outputbytes = qr.Bb)(), $._crypto_core_hchacha20_inputbytes = () => ($._crypto_core_hchacha20_inputbytes = qr.Cb)(), $._crypto_core_hchacha20_keybytes = () => ($._crypto_core_hchacha20_keybytes = qr.Db)(), $._crypto_core_hchacha20_constbytes = () => ($._crypto_core_hchacha20_constbytes = qr.Eb)(), $._crypto_core_hsalsa20 = (Wr, ri, _i, Er) => ($._crypto_core_hsalsa20 = qr.Fb)(Wr, ri, _i, Er), $._crypto_core_hsalsa20_outputbytes = () => ($._crypto_core_hsalsa20_outputbytes = qr.Gb)(), $._crypto_core_hsalsa20_inputbytes = () => ($._crypto_core_hsalsa20_inputbytes = qr.Hb)(), $._crypto_core_hsalsa20_keybytes = () => ($._crypto_core_hsalsa20_keybytes = qr.Ib)(), $._crypto_core_hsalsa20_constbytes = () => ($._crypto_core_hsalsa20_constbytes = qr.Jb)(), $._crypto_core_salsa20 = (Wr, ri, _i, Er) => ($._crypto_core_salsa20 = qr.Kb)(Wr, ri, _i, Er), $._crypto_core_salsa20_outputbytes = () => ($._crypto_core_salsa20_outputbytes = qr.Lb)(), $._crypto_core_salsa20_inputbytes = () => ($._crypto_core_salsa20_inputbytes = qr.Mb)(), $._crypto_core_salsa20_keybytes = () => ($._crypto_core_salsa20_keybytes = qr.Nb)(), $._crypto_core_salsa20_constbytes = () => ($._crypto_core_salsa20_constbytes = qr.Ob)(), $._crypto_core_salsa2012 = (Wr, ri, _i, Er) => ($._crypto_core_salsa2012 = qr.Pb)(Wr, ri, _i, Er), $._crypto_core_salsa2012_outputbytes = () => ($._crypto_core_salsa2012_outputbytes = qr.Qb)(), $._crypto_core_salsa2012_inputbytes = () => ($._crypto_core_salsa2012_inputbytes = qr.Rb)(), $._crypto_core_salsa2012_keybytes = () => ($._crypto_core_salsa2012_keybytes = qr.Sb)(), $._crypto_core_salsa2012_constbytes = () => ($._crypto_core_salsa2012_constbytes = qr.Tb)(), $._crypto_core_salsa208 = (Wr, ri, _i, Er) => ($._crypto_core_salsa208 = qr.Ub)(Wr, ri, _i, Er), $._crypto_core_salsa208_outputbytes = () => ($._crypto_core_salsa208_outputbytes = qr.Vb)(), $._crypto_core_salsa208_inputbytes = () => ($._crypto_core_salsa208_inputbytes = qr.Wb)(), $._crypto_core_salsa208_keybytes = () => ($._crypto_core_salsa208_keybytes = qr.Xb)(), $._crypto_core_salsa208_constbytes = () => ($._crypto_core_salsa208_constbytes = qr.Yb)(), $._crypto_generichash_bytes_min = () => ($._crypto_generichash_bytes_min = qr.Zb)(), $._crypto_generichash_bytes_max = () => ($._crypto_generichash_bytes_max = qr._b)(), $._crypto_generichash_bytes = () => ($._crypto_generichash_bytes = qr.$b)(), $._crypto_generichash_keybytes_min = () => ($._crypto_generichash_keybytes_min = qr.ac)(), $._crypto_generichash_keybytes_max = () => ($._crypto_generichash_keybytes_max = qr.bc)(), $._crypto_generichash_keybytes = () => ($._crypto_generichash_keybytes = qr.cc)(), $._crypto_generichash_primitive = () => ($._crypto_generichash_primitive = qr.dc)(), $._crypto_generichash_statebytes = () => ($._crypto_generichash_statebytes = qr.ec)(), $._crypto_generichash = (Wr, ri, _i, Er, Di, _n, On) => ($._crypto_generichash = qr.fc)(Wr, ri, _i, Er, Di, _n, On), $._crypto_generichash_init = (Wr, ri, _i, Er) => ($._crypto_generichash_init = qr.gc)(Wr, ri, _i, Er), $._crypto_generichash_update = (Wr, ri, _i, Er) => ($._crypto_generichash_update = qr.hc)(Wr, ri, _i, Er), $._crypto_generichash_final = (Wr, ri, _i) => ($._crypto_generichash_final = qr.ic)(Wr, ri, _i), $._crypto_generichash_keygen = (Wr) => ($._crypto_generichash_keygen = qr.jc)(Wr), $._crypto_generichash_blake2b_bytes_min = () => ($._crypto_generichash_blake2b_bytes_min = qr.kc)(), $._crypto_generichash_blake2b_bytes_max = () => ($._crypto_generichash_blake2b_bytes_max = qr.lc)(), $._crypto_generichash_blake2b_bytes = () => ($._crypto_generichash_blake2b_bytes = qr.mc)(), $._crypto_generichash_blake2b_keybytes_min = () => ($._crypto_generichash_blake2b_keybytes_min = qr.nc)(), $._crypto_generichash_blake2b_keybytes_max = () => ($._crypto_generichash_blake2b_keybytes_max = qr.oc)(), $._crypto_generichash_blake2b_keybytes = () => ($._crypto_generichash_blake2b_keybytes = qr.pc)(), $._crypto_generichash_blake2b_saltbytes = () => ($._crypto_generichash_blake2b_saltbytes = qr.qc)(), $._crypto_generichash_blake2b_personalbytes = () => ($._crypto_generichash_blake2b_personalbytes = qr.rc)(), $._crypto_generichash_blake2b_statebytes = () => ($._crypto_generichash_blake2b_statebytes = qr.sc)(), $._crypto_generichash_blake2b_keygen = (Wr) => ($._crypto_generichash_blake2b_keygen = qr.tc)(Wr), $._crypto_generichash_blake2b = (Wr, ri, _i, Er, Di, _n, On) => ($._crypto_generichash_blake2b = qr.uc)(Wr, ri, _i, Er, Di, _n, On), $._crypto_generichash_blake2b_salt_personal = (Wr, ri, _i, Er, Di, _n, On, so, Do) => ($._crypto_generichash_blake2b_salt_personal = qr.vc)(Wr, ri, _i, Er, Di, _n, On, so, Do), $._crypto_generichash_blake2b_init = (Wr, ri, _i, Er) => ($._crypto_generichash_blake2b_init = qr.wc)(Wr, ri, _i, Er), $._crypto_generichash_blake2b_init_salt_personal = (Wr, ri, _i, Er, Di, _n) => ($._crypto_generichash_blake2b_init_salt_personal = qr.xc)(Wr, ri, _i, Er, Di, _n), $._crypto_generichash_blake2b_update = (Wr, ri, _i, Er) => ($._crypto_generichash_blake2b_update = qr.yc)(Wr, ri, _i, Er), $._crypto_generichash_blake2b_final = (Wr, ri, _i) => ($._crypto_generichash_blake2b_final = qr.zc)(Wr, ri, _i), $._crypto_hash_bytes = () => ($._crypto_hash_bytes = qr.Ac)(), $._crypto_hash = (Wr, ri, _i, Er) => ($._crypto_hash = qr.Bc)(Wr, ri, _i, Er), $._crypto_hash_primitive = () => ($._crypto_hash_primitive = qr.Cc)(), $._crypto_hash_sha256_bytes = () => ($._crypto_hash_sha256_bytes = qr.Dc)(), $._crypto_hash_sha256_statebytes = () => ($._crypto_hash_sha256_statebytes = qr.Ec)(), $._crypto_hash_sha256_init = (Wr) => ($._crypto_hash_sha256_init = qr.Fc)(Wr), $._crypto_hash_sha256_update = (Wr, ri, _i, Er) => ($._crypto_hash_sha256_update = qr.Gc)(Wr, ri, _i, Er), $._crypto_hash_sha256_final = (Wr, ri) => ($._crypto_hash_sha256_final = qr.Hc)(Wr, ri), $._crypto_hash_sha256 = (Wr, ri, _i, Er) => ($._crypto_hash_sha256 = qr.Ic)(Wr, ri, _i, Er), $._crypto_hash_sha512_bytes = () => ($._crypto_hash_sha512_bytes = qr.Jc)(), $._crypto_hash_sha512_statebytes = () => ($._crypto_hash_sha512_statebytes = qr.Kc)(), $._crypto_hash_sha512_init = (Wr) => ($._crypto_hash_sha512_init = qr.Lc)(Wr), $._crypto_hash_sha512_update = (Wr, ri, _i, Er) => ($._crypto_hash_sha512_update = qr.Mc)(Wr, ri, _i, Er), $._crypto_hash_sha512_final = (Wr, ri) => ($._crypto_hash_sha512_final = qr.Nc)(Wr, ri), $._crypto_hash_sha512 = (Wr, ri, _i, Er) => ($._crypto_hash_sha512 = qr.Oc)(Wr, ri, _i, Er), $._crypto_kdf_blake2b_bytes_min = () => ($._crypto_kdf_blake2b_bytes_min = qr.Pc)(), $._crypto_kdf_blake2b_bytes_max = () => ($._crypto_kdf_blake2b_bytes_max = qr.Qc)(), $._crypto_kdf_blake2b_contextbytes = () => ($._crypto_kdf_blake2b_contextbytes = qr.Rc)(), $._crypto_kdf_blake2b_keybytes = () => ($._crypto_kdf_blake2b_keybytes = qr.Sc)(), $._crypto_kdf_blake2b_derive_from_key = (Wr, ri, _i, Er, Di, _n) => ($._crypto_kdf_blake2b_derive_from_key = qr.Tc)(Wr, ri, _i, Er, Di, _n), $._crypto_kdf_primitive = () => ($._crypto_kdf_primitive = qr.Uc)(), $._crypto_kdf_bytes_min = () => ($._crypto_kdf_bytes_min = qr.Vc)(), $._crypto_kdf_bytes_max = () => ($._crypto_kdf_bytes_max = qr.Wc)(), $._crypto_kdf_contextbytes = () => ($._crypto_kdf_contextbytes = qr.Xc)(), $._crypto_kdf_keybytes = () => ($._crypto_kdf_keybytes = qr.Yc)(), $._crypto_kdf_derive_from_key = (Wr, ri, _i, Er, Di, _n) => ($._crypto_kdf_derive_from_key = qr.Zc)(Wr, ri, _i, Er, Di, _n), $._crypto_kdf_keygen = (Wr) => ($._crypto_kdf_keygen = qr._c)(Wr), $._crypto_kdf_hkdf_sha256_extract_init = (Wr, ri, _i) => ($._crypto_kdf_hkdf_sha256_extract_init = qr.$c)(Wr, ri, _i), $._crypto_kdf_hkdf_sha256_extract_update = (Wr, ri, _i) => ($._crypto_kdf_hkdf_sha256_extract_update = qr.ad)(Wr, ri, _i), $._crypto_kdf_hkdf_sha256_extract_final = (Wr, ri) => ($._crypto_kdf_hkdf_sha256_extract_final = qr.bd)(Wr, ri), $._crypto_kdf_hkdf_sha256_extract = (Wr, ri, _i, Er, Di) => ($._crypto_kdf_hkdf_sha256_extract = qr.cd)(Wr, ri, _i, Er, Di), $._crypto_kdf_hkdf_sha256_keygen = (Wr) => ($._crypto_kdf_hkdf_sha256_keygen = qr.dd)(Wr), $._crypto_kdf_hkdf_sha256_expand = (Wr, ri, _i, Er, Di) => ($._crypto_kdf_hkdf_sha256_expand = qr.ed)(Wr, ri, _i, Er, Di), $._crypto_kdf_hkdf_sha256_keybytes = () => ($._crypto_kdf_hkdf_sha256_keybytes = qr.fd)(), $._crypto_kdf_hkdf_sha256_bytes_min = () => ($._crypto_kdf_hkdf_sha256_bytes_min = qr.gd)(), $._crypto_kdf_hkdf_sha256_bytes_max = () => ($._crypto_kdf_hkdf_sha256_bytes_max = qr.hd)(), $._crypto_kdf_hkdf_sha256_statebytes = () => ($._crypto_kdf_hkdf_sha256_statebytes = qr.id)(), $._crypto_kdf_hkdf_sha512_extract_init = (Wr, ri, _i) => ($._crypto_kdf_hkdf_sha512_extract_init = qr.jd)(Wr, ri, _i), $._crypto_kdf_hkdf_sha512_extract_update = (Wr, ri, _i) => ($._crypto_kdf_hkdf_sha512_extract_update = qr.kd)(Wr, ri, _i), $._crypto_kdf_hkdf_sha512_extract_final = (Wr, ri) => ($._crypto_kdf_hkdf_sha512_extract_final = qr.ld)(Wr, ri), $._crypto_kdf_hkdf_sha512_extract = (Wr, ri, _i, Er, Di) => ($._crypto_kdf_hkdf_sha512_extract = qr.md)(Wr, ri, _i, Er, Di), $._crypto_kdf_hkdf_sha512_keygen = (Wr) => ($._crypto_kdf_hkdf_sha512_keygen = qr.nd)(Wr), $._crypto_kdf_hkdf_sha512_expand = (Wr, ri, _i, Er, Di) => ($._crypto_kdf_hkdf_sha512_expand = qr.od)(Wr, ri, _i, Er, Di), $._crypto_kdf_hkdf_sha512_keybytes = () => ($._crypto_kdf_hkdf_sha512_keybytes = qr.pd)(), $._crypto_kdf_hkdf_sha512_bytes_min = () => ($._crypto_kdf_hkdf_sha512_bytes_min = qr.qd)(), $._crypto_kdf_hkdf_sha512_bytes_max = () => ($._crypto_kdf_hkdf_sha512_bytes_max = qr.rd)(), $._crypto_kdf_hkdf_sha512_statebytes = () => ($._crypto_kdf_hkdf_sha512_statebytes = qr.sd)(), $._crypto_kx_seed_keypair = (Wr, ri, _i) => ($._crypto_kx_seed_keypair = qr.td)(Wr, ri, _i), $._crypto_kx_keypair = (Wr, ri) => ($._crypto_kx_keypair = qr.ud)(Wr, ri), $._crypto_kx_client_session_keys = (Wr, ri, _i, Er, Di) => ($._crypto_kx_client_session_keys = qr.vd)(Wr, ri, _i, Er, Di), $._crypto_kx_server_session_keys = (Wr, ri, _i, Er, Di) => ($._crypto_kx_server_session_keys = qr.wd)(Wr, ri, _i, Er, Di), $._crypto_kx_publickeybytes = () => ($._crypto_kx_publickeybytes = qr.xd)(), $._crypto_kx_secretkeybytes = () => ($._crypto_kx_secretkeybytes = qr.yd)(), $._crypto_kx_seedbytes = () => ($._crypto_kx_seedbytes = qr.zd)(), $._crypto_kx_sessionkeybytes = () => ($._crypto_kx_sessionkeybytes = qr.Ad)(), $._crypto_kx_primitive = () => ($._crypto_kx_primitive = qr.Bd)(), $._crypto_onetimeauth_statebytes = () => ($._crypto_onetimeauth_statebytes = qr.Cd)(), $._crypto_onetimeauth_bytes = () => ($._crypto_onetimeauth_bytes = qr.Dd)(), $._crypto_onetimeauth_keybytes = () => ($._crypto_onetimeauth_keybytes = qr.Ed)(), $._crypto_onetimeauth = (Wr, ri, _i, Er, Di) => ($._crypto_onetimeauth = qr.Fd)(Wr, ri, _i, Er, Di), $._crypto_onetimeauth_verify = (Wr, ri, _i, Er, Di) => ($._crypto_onetimeauth_verify = qr.Gd)(Wr, ri, _i, Er, Di), $._crypto_onetimeauth_init = (Wr, ri) => ($._crypto_onetimeauth_init = qr.Hd)(Wr, ri), $._crypto_onetimeauth_update = (Wr, ri, _i, Er) => ($._crypto_onetimeauth_update = qr.Id)(Wr, ri, _i, Er), $._crypto_onetimeauth_final = (Wr, ri) => ($._crypto_onetimeauth_final = qr.Jd)(Wr, ri), $._crypto_onetimeauth_primitive = () => ($._crypto_onetimeauth_primitive = qr.Kd)(), $._crypto_onetimeauth_keygen = (Wr) => ($._crypto_onetimeauth_keygen = qr.Ld)(Wr), $._crypto_onetimeauth_poly1305 = (Wr, ri, _i, Er, Di) => ($._crypto_onetimeauth_poly1305 = qr.Md)(Wr, ri, _i, Er, Di), $._crypto_onetimeauth_poly1305_verify = (Wr, ri, _i, Er, Di) => ($._crypto_onetimeauth_poly1305_verify = qr.Nd)(Wr, ri, _i, Er, Di), $._crypto_onetimeauth_poly1305_init = (Wr, ri) => ($._crypto_onetimeauth_poly1305_init = qr.Od)(Wr, ri), $._crypto_onetimeauth_poly1305_update = (Wr, ri, _i, Er) => ($._crypto_onetimeauth_poly1305_update = qr.Pd)(Wr, ri, _i, Er), $._crypto_onetimeauth_poly1305_final = (Wr, ri) => ($._crypto_onetimeauth_poly1305_final = qr.Qd)(Wr, ri), $._crypto_onetimeauth_poly1305_bytes = () => ($._crypto_onetimeauth_poly1305_bytes = qr.Rd)(), $._crypto_onetimeauth_poly1305_keybytes = () => ($._crypto_onetimeauth_poly1305_keybytes = qr.Sd)(), $._crypto_onetimeauth_poly1305_statebytes = () => ($._crypto_onetimeauth_poly1305_statebytes = qr.Td)(), $._crypto_onetimeauth_poly1305_keygen = (Wr) => ($._crypto_onetimeauth_poly1305_keygen = qr.Ud)(Wr), $._crypto_pwhash_argon2i_alg_argon2i13 = () => ($._crypto_pwhash_argon2i_alg_argon2i13 = qr.Vd)(), $._crypto_pwhash_argon2i_bytes_min = () => ($._crypto_pwhash_argon2i_bytes_min = qr.Wd)(), $._crypto_pwhash_argon2i_bytes_max = () => ($._crypto_pwhash_argon2i_bytes_max = qr.Xd)(), $._crypto_pwhash_argon2i_passwd_min = () => ($._crypto_pwhash_argon2i_passwd_min = qr.Yd)(), $._crypto_pwhash_argon2i_passwd_max = () => ($._crypto_pwhash_argon2i_passwd_max = qr.Zd)(), $._crypto_pwhash_argon2i_saltbytes = () => ($._crypto_pwhash_argon2i_saltbytes = qr._d)(), $._crypto_pwhash_argon2i_strbytes = () => ($._crypto_pwhash_argon2i_strbytes = qr.$d)(), $._crypto_pwhash_argon2i_strprefix = () => ($._crypto_pwhash_argon2i_strprefix = qr.ae)(), $._crypto_pwhash_argon2i_opslimit_min = () => ($._crypto_pwhash_argon2i_opslimit_min = qr.be)(), $._crypto_pwhash_argon2i_opslimit_max = () => ($._crypto_pwhash_argon2i_opslimit_max = qr.ce)(), $._crypto_pwhash_argon2i_memlimit_min = () => ($._crypto_pwhash_argon2i_memlimit_min = qr.de)(), $._crypto_pwhash_argon2i_memlimit_max = () => ($._crypto_pwhash_argon2i_memlimit_max = qr.ee)(), $._crypto_pwhash_argon2i_opslimit_interactive = () => ($._crypto_pwhash_argon2i_opslimit_interactive = qr.fe)(), $._crypto_pwhash_argon2i_memlimit_interactive = () => ($._crypto_pwhash_argon2i_memlimit_interactive = qr.ge)(), $._crypto_pwhash_argon2i_opslimit_moderate = () => ($._crypto_pwhash_argon2i_opslimit_moderate = qr.he)(), $._crypto_pwhash_argon2i_memlimit_moderate = () => ($._crypto_pwhash_argon2i_memlimit_moderate = qr.ie)(), $._crypto_pwhash_argon2i_opslimit_sensitive = () => ($._crypto_pwhash_argon2i_opslimit_sensitive = qr.je)(), $._crypto_pwhash_argon2i_memlimit_sensitive = () => ($._crypto_pwhash_argon2i_memlimit_sensitive = qr.ke)(), $._crypto_pwhash_argon2i = (Wr, ri, _i, Er, Di, _n, On, so, Do, gn, Gn) => ($._crypto_pwhash_argon2i = qr.le)(Wr, ri, _i, Er, Di, _n, On, so, Do, gn, Gn), $._crypto_pwhash_argon2i_str = (Wr, ri, _i, Er, Di, _n, On) => ($._crypto_pwhash_argon2i_str = qr.me)(Wr, ri, _i, Er, Di, _n, On), $._crypto_pwhash_argon2i_str_verify = (Wr, ri, _i, Er) => ($._crypto_pwhash_argon2i_str_verify = qr.ne)(Wr, ri, _i, Er), $._crypto_pwhash_argon2i_str_needs_rehash = (Wr, ri, _i, Er) => ($._crypto_pwhash_argon2i_str_needs_rehash = qr.oe)(Wr, ri, _i, Er), $._crypto_pwhash_argon2id_str_needs_rehash = (Wr, ri, _i, Er) => ($._crypto_pwhash_argon2id_str_needs_rehash = qr.pe)(Wr, ri, _i, Er), $._crypto_pwhash_argon2id_alg_argon2id13 = () => ($._crypto_pwhash_argon2id_alg_argon2id13 = qr.qe)(), $._crypto_pwhash_argon2id_bytes_min = () => ($._crypto_pwhash_argon2id_bytes_min = qr.re)(), $._crypto_pwhash_argon2id_bytes_max = () => ($._crypto_pwhash_argon2id_bytes_max = qr.se)(), $._crypto_pwhash_argon2id_passwd_min = () => ($._crypto_pwhash_argon2id_passwd_min = qr.te)(), $._crypto_pwhash_argon2id_passwd_max = () => ($._crypto_pwhash_argon2id_passwd_max = qr.ue)(), $._crypto_pwhash_argon2id_saltbytes = () => ($._crypto_pwhash_argon2id_saltbytes = qr.ve)(), $._crypto_pwhash_argon2id_strbytes = () => ($._crypto_pwhash_argon2id_strbytes = qr.we)(), $._crypto_pwhash_argon2id_strprefix = () => ($._crypto_pwhash_argon2id_strprefix = qr.xe)(), $._crypto_pwhash_argon2id_opslimit_min = () => ($._crypto_pwhash_argon2id_opslimit_min = qr.ye)(), $._crypto_pwhash_argon2id_opslimit_max = () => ($._crypto_pwhash_argon2id_opslimit_max = qr.ze)(), $._crypto_pwhash_argon2id_memlimit_min = () => ($._crypto_pwhash_argon2id_memlimit_min = qr.Ae)(), $._crypto_pwhash_argon2id_memlimit_max = () => ($._crypto_pwhash_argon2id_memlimit_max = qr.Be)(), $._crypto_pwhash_argon2id_opslimit_interactive = () => ($._crypto_pwhash_argon2id_opslimit_interactive = qr.Ce)(), $._crypto_pwhash_argon2id_memlimit_interactive = () => ($._crypto_pwhash_argon2id_memlimit_interactive = qr.De)(), $._crypto_pwhash_argon2id_opslimit_moderate = () => ($._crypto_pwhash_argon2id_opslimit_moderate = qr.Ee)(), $._crypto_pwhash_argon2id_memlimit_moderate = () => ($._crypto_pwhash_argon2id_memlimit_moderate = qr.Fe)(), $._crypto_pwhash_argon2id_opslimit_sensitive = () => ($._crypto_pwhash_argon2id_opslimit_sensitive = qr.Ge)(), $._crypto_pwhash_argon2id_memlimit_sensitive = () => ($._crypto_pwhash_argon2id_memlimit_sensitive = qr.He)(), $._crypto_pwhash_argon2id = (Wr, ri, _i, Er, Di, _n, On, so, Do, gn, Gn) => ($._crypto_pwhash_argon2id = qr.Ie)(Wr, ri, _i, Er, Di, _n, On, so, Do, gn, Gn), $._crypto_pwhash_argon2id_str = (Wr, ri, _i, Er, Di, _n, On) => ($._crypto_pwhash_argon2id_str = qr.Je)(Wr, ri, _i, Er, Di, _n, On), $._crypto_pwhash_argon2id_str_verify = (Wr, ri, _i, Er) => ($._crypto_pwhash_argon2id_str_verify = qr.Ke)(Wr, ri, _i, Er), $._crypto_pwhash_alg_argon2i13 = () => ($._crypto_pwhash_alg_argon2i13 = qr.Le)(), $._crypto_pwhash_alg_argon2id13 = () => ($._crypto_pwhash_alg_argon2id13 = qr.Me)(), $._crypto_pwhash_alg_default = () => ($._crypto_pwhash_alg_default = qr.Ne)(), $._crypto_pwhash_bytes_min = () => ($._crypto_pwhash_bytes_min = qr.Oe)(), $._crypto_pwhash_bytes_max = () => ($._crypto_pwhash_bytes_max = qr.Pe)(), $._crypto_pwhash_passwd_min = () => ($._crypto_pwhash_passwd_min = qr.Qe)(), $._crypto_pwhash_passwd_max = () => ($._crypto_pwhash_passwd_max = qr.Re)(), $._crypto_pwhash_saltbytes = () => ($._crypto_pwhash_saltbytes = qr.Se)(), $._crypto_pwhash_strbytes = () => ($._crypto_pwhash_strbytes = qr.Te)(), $._crypto_pwhash_strprefix = () => ($._crypto_pwhash_strprefix = qr.Ue)(), $._crypto_pwhash_opslimit_min = () => ($._crypto_pwhash_opslimit_min = qr.Ve)(), $._crypto_pwhash_opslimit_max = () => ($._crypto_pwhash_opslimit_max = qr.We)(), $._crypto_pwhash_memlimit_min = () => ($._crypto_pwhash_memlimit_min = qr.Xe)(), $._crypto_pwhash_memlimit_max = () => ($._crypto_pwhash_memlimit_max = qr.Ye)(), $._crypto_pwhash_opslimit_interactive = () => ($._crypto_pwhash_opslimit_interactive = qr.Ze)(), $._crypto_pwhash_memlimit_interactive = () => ($._crypto_pwhash_memlimit_interactive = qr._e)(), $._crypto_pwhash_opslimit_moderate = () => ($._crypto_pwhash_opslimit_moderate = qr.$e)(), $._crypto_pwhash_memlimit_moderate = () => ($._crypto_pwhash_memlimit_moderate = qr.af)(), $._crypto_pwhash_opslimit_sensitive = () => ($._crypto_pwhash_opslimit_sensitive = qr.bf)(), $._crypto_pwhash_memlimit_sensitive = () => ($._crypto_pwhash_memlimit_sensitive = qr.cf)(), $._crypto_pwhash = (Wr, ri, _i, Er, Di, _n, On, so, Do, gn, Gn) => ($._crypto_pwhash = qr.df)(Wr, ri, _i, Er, Di, _n, On, so, Do, gn, Gn), $._crypto_pwhash_str = (Wr, ri, _i, Er, Di, _n, On) => ($._crypto_pwhash_str = qr.ef)(Wr, ri, _i, Er, Di, _n, On), $._crypto_pwhash_str_alg = (Wr, ri, _i, Er, Di, _n, On, so) => ($._crypto_pwhash_str_alg = qr.ff)(Wr, ri, _i, Er, Di, _n, On, so), $._crypto_pwhash_str_verify = (Wr, ri, _i, Er) => ($._crypto_pwhash_str_verify = qr.gf)(Wr, ri, _i, Er), $._crypto_pwhash_str_needs_rehash = (Wr, ri, _i, Er) => ($._crypto_pwhash_str_needs_rehash = qr.hf)(Wr, ri, _i, Er), $._crypto_pwhash_primitive = () => ($._crypto_pwhash_primitive = qr.jf)(), $._crypto_scalarmult_primitive = () => ($._crypto_scalarmult_primitive = qr.kf)(), $._crypto_scalarmult_base = (Wr, ri) => ($._crypto_scalarmult_base = qr.lf)(Wr, ri), $._crypto_scalarmult = (Wr, ri, _i) => ($._crypto_scalarmult = qr.mf)(Wr, ri, _i), $._crypto_scalarmult_bytes = () => ($._crypto_scalarmult_bytes = qr.nf)(), $._crypto_scalarmult_scalarbytes = () => ($._crypto_scalarmult_scalarbytes = qr.of)(), $._crypto_scalarmult_curve25519 = (Wr, ri, _i) => ($._crypto_scalarmult_curve25519 = qr.pf)(Wr, ri, _i), $._crypto_scalarmult_curve25519_base = (Wr, ri) => ($._crypto_scalarmult_curve25519_base = qr.qf)(Wr, ri), $._crypto_scalarmult_curve25519_bytes = () => ($._crypto_scalarmult_curve25519_bytes = qr.rf)(), $._crypto_scalarmult_curve25519_scalarbytes = () => ($._crypto_scalarmult_curve25519_scalarbytes = qr.sf)(), $._crypto_secretbox_keybytes = () => ($._crypto_secretbox_keybytes = qr.tf)(), $._crypto_secretbox_noncebytes = () => ($._crypto_secretbox_noncebytes = qr.uf)(), $._crypto_secretbox_zerobytes = () => ($._crypto_secretbox_zerobytes = qr.vf)(), $._crypto_secretbox_boxzerobytes = () => ($._crypto_secretbox_boxzerobytes = qr.wf)(), $._crypto_secretbox_macbytes = () => ($._crypto_secretbox_macbytes = qr.xf)(), $._crypto_secretbox_messagebytes_max = () => ($._crypto_secretbox_messagebytes_max = qr.yf)(), $._crypto_secretbox_primitive = () => ($._crypto_secretbox_primitive = qr.zf)(), $._crypto_secretbox = (Wr, ri, _i, Er, Di, _n) => ($._crypto_secretbox = qr.Af)(Wr, ri, _i, Er, Di, _n), $._crypto_secretbox_open = (Wr, ri, _i, Er, Di, _n) => ($._crypto_secretbox_open = qr.Bf)(Wr, ri, _i, Er, Di, _n), $._crypto_secretbox_keygen = (Wr) => ($._crypto_secretbox_keygen = qr.Cf)(Wr), $._crypto_secretbox_detached = (Wr, ri, _i, Er, Di, _n, On) => ($._crypto_secretbox_detached = qr.Df)(Wr, ri, _i, Er, Di, _n, On), $._crypto_secretbox_easy = (Wr, ri, _i, Er, Di, _n) => ($._crypto_secretbox_easy = qr.Ef)(Wr, ri, _i, Er, Di, _n), $._crypto_secretbox_open_detached = (Wr, ri, _i, Er, Di, _n, On) => ($._crypto_secretbox_open_detached = qr.Ff)(Wr, ri, _i, Er, Di, _n, On), $._crypto_secretbox_open_easy = (Wr, ri, _i, Er, Di, _n) => ($._crypto_secretbox_open_easy = qr.Gf)(Wr, ri, _i, Er, Di, _n), $._crypto_secretbox_xsalsa20poly1305 = (Wr, ri, _i, Er, Di, _n) => ($._crypto_secretbox_xsalsa20poly1305 = qr.Hf)(Wr, ri, _i, Er, Di, _n), $._crypto_secretbox_xsalsa20poly1305_open = (Wr, ri, _i, Er, Di, _n) => ($._crypto_secretbox_xsalsa20poly1305_open = qr.If)(Wr, ri, _i, Er, Di, _n), $._crypto_secretbox_xsalsa20poly1305_keybytes = () => ($._crypto_secretbox_xsalsa20poly1305_keybytes = qr.Jf)(), $._crypto_secretbox_xsalsa20poly1305_noncebytes = () => ($._crypto_secretbox_xsalsa20poly1305_noncebytes = qr.Kf)(), $._crypto_secretbox_xsalsa20poly1305_zerobytes = () => ($._crypto_secretbox_xsalsa20poly1305_zerobytes = qr.Lf)(), $._crypto_secretbox_xsalsa20poly1305_boxzerobytes = () => ($._crypto_secretbox_xsalsa20poly1305_boxzerobytes = qr.Mf)(), $._crypto_secretbox_xsalsa20poly1305_macbytes = () => ($._crypto_secretbox_xsalsa20poly1305_macbytes = qr.Nf)(), $._crypto_secretbox_xsalsa20poly1305_messagebytes_max = () => ($._crypto_secretbox_xsalsa20poly1305_messagebytes_max = qr.Of)(), $._crypto_secretbox_xsalsa20poly1305_keygen = (Wr) => ($._crypto_secretbox_xsalsa20poly1305_keygen = qr.Pf)(Wr), $._crypto_secretstream_xchacha20poly1305_keygen = (Wr) => ($._crypto_secretstream_xchacha20poly1305_keygen = qr.Qf)(Wr), $._crypto_secretstream_xchacha20poly1305_init_push = (Wr, ri, _i) => ($._crypto_secretstream_xchacha20poly1305_init_push = qr.Rf)(Wr, ri, _i), $._crypto_secretstream_xchacha20poly1305_init_pull = (Wr, ri, _i) => ($._crypto_secretstream_xchacha20poly1305_init_pull = qr.Sf)(Wr, ri, _i), $._crypto_secretstream_xchacha20poly1305_rekey = (Wr) => ($._crypto_secretstream_xchacha20poly1305_rekey = qr.Tf)(Wr), $._crypto_secretstream_xchacha20poly1305_push = (Wr, ri, _i, Er, Di, _n, On, so, Do, gn) => ($._crypto_secretstream_xchacha20poly1305_push = qr.Uf)(Wr, ri, _i, Er, Di, _n, On, so, Do, gn), $._crypto_secretstream_xchacha20poly1305_pull = (Wr, ri, _i, Er, Di, _n, On, so, Do, gn) => ($._crypto_secretstream_xchacha20poly1305_pull = qr.Vf)(Wr, ri, _i, Er, Di, _n, On, so, Do, gn), $._crypto_secretstream_xchacha20poly1305_statebytes = () => ($._crypto_secretstream_xchacha20poly1305_statebytes = qr.Wf)(), $._crypto_secretstream_xchacha20poly1305_abytes = () => ($._crypto_secretstream_xchacha20poly1305_abytes = qr.Xf)(), $._crypto_secretstream_xchacha20poly1305_headerbytes = () => ($._crypto_secretstream_xchacha20poly1305_headerbytes = qr.Yf)(), $._crypto_secretstream_xchacha20poly1305_keybytes = () => ($._crypto_secretstream_xchacha20poly1305_keybytes = qr.Zf)(), $._crypto_secretstream_xchacha20poly1305_messagebytes_max = () => ($._crypto_secretstream_xchacha20poly1305_messagebytes_max = qr._f)(), $._crypto_secretstream_xchacha20poly1305_tag_message = () => ($._crypto_secretstream_xchacha20poly1305_tag_message = qr.$f)(), $._crypto_secretstream_xchacha20poly1305_tag_push = () => ($._crypto_secretstream_xchacha20poly1305_tag_push = qr.ag)(), $._crypto_secretstream_xchacha20poly1305_tag_rekey = () => ($._crypto_secretstream_xchacha20poly1305_tag_rekey = qr.bg)(), $._crypto_secretstream_xchacha20poly1305_tag_final = () => ($._crypto_secretstream_xchacha20poly1305_tag_final = qr.cg)(), $._crypto_shorthash_bytes = () => ($._crypto_shorthash_bytes = qr.dg)(), $._crypto_shorthash_keybytes = () => ($._crypto_shorthash_keybytes = qr.eg)(), $._crypto_shorthash_primitive = () => ($._crypto_shorthash_primitive = qr.fg)(), $._crypto_shorthash = (Wr, ri, _i, Er, Di) => ($._crypto_shorthash = qr.gg)(Wr, ri, _i, Er, Di), $._crypto_shorthash_keygen = (Wr) => ($._crypto_shorthash_keygen = qr.hg)(Wr), $._crypto_shorthash_siphash24_bytes = () => ($._crypto_shorthash_siphash24_bytes = qr.ig)(), $._crypto_shorthash_siphash24_keybytes = () => ($._crypto_shorthash_siphash24_keybytes = qr.jg)(), $._crypto_shorthash_siphash24 = (Wr, ri, _i, Er, Di) => ($._crypto_shorthash_siphash24 = qr.kg)(Wr, ri, _i, Er, Di), $._crypto_sign_statebytes = () => ($._crypto_sign_statebytes = qr.lg)(), $._crypto_sign_bytes = () => ($._crypto_sign_bytes = qr.mg)(), $._crypto_sign_seedbytes = () => ($._crypto_sign_seedbytes = qr.ng)(), $._crypto_sign_publickeybytes = () => ($._crypto_sign_publickeybytes = qr.og)(), $._crypto_sign_secretkeybytes = () => ($._crypto_sign_secretkeybytes = qr.pg)(), $._crypto_sign_messagebytes_max = () => ($._crypto_sign_messagebytes_max = qr.qg)(), $._crypto_sign_primitive = () => ($._crypto_sign_primitive = qr.rg)(), $._crypto_sign_seed_keypair = (Wr, ri, _i) => ($._crypto_sign_seed_keypair = qr.sg)(Wr, ri, _i), $._crypto_sign_keypair = (Wr, ri) => ($._crypto_sign_keypair = qr.tg)(Wr, ri), $._crypto_sign = (Wr, ri, _i, Er, Di, _n) => ($._crypto_sign = qr.ug)(Wr, ri, _i, Er, Di, _n), $._crypto_sign_open = (Wr, ri, _i, Er, Di, _n) => ($._crypto_sign_open = qr.vg)(Wr, ri, _i, Er, Di, _n), $._crypto_sign_detached = (Wr, ri, _i, Er, Di, _n) => ($._crypto_sign_detached = qr.wg)(Wr, ri, _i, Er, Di, _n), $._crypto_sign_verify_detached = (Wr, ri, _i, Er, Di) => ($._crypto_sign_verify_detached = qr.xg)(Wr, ri, _i, Er, Di), $._crypto_sign_init = (Wr) => ($._crypto_sign_init = qr.yg)(Wr), $._crypto_sign_update = (Wr, ri, _i, Er) => ($._crypto_sign_update = qr.zg)(Wr, ri, _i, Er), $._crypto_sign_final_create = (Wr, ri, _i, Er) => ($._crypto_sign_final_create = qr.Ag)(Wr, ri, _i, Er), $._crypto_sign_final_verify = (Wr, ri, _i) => ($._crypto_sign_final_verify = qr.Bg)(Wr, ri, _i), $._crypto_sign_ed25519ph_statebytes = () => ($._crypto_sign_ed25519ph_statebytes = qr.Cg)(), $._crypto_sign_ed25519_bytes = () => ($._crypto_sign_ed25519_bytes = qr.Dg)(), $._crypto_sign_ed25519_seedbytes = () => ($._crypto_sign_ed25519_seedbytes = qr.Eg)(), $._crypto_sign_ed25519_publickeybytes = () => ($._crypto_sign_ed25519_publickeybytes = qr.Fg)(), $._crypto_sign_ed25519_secretkeybytes = () => ($._crypto_sign_ed25519_secretkeybytes = qr.Gg)(), $._crypto_sign_ed25519_messagebytes_max = () => ($._crypto_sign_ed25519_messagebytes_max = qr.Hg)(), $._crypto_sign_ed25519_sk_to_seed = (Wr, ri) => ($._crypto_sign_ed25519_sk_to_seed = qr.Ig)(Wr, ri), $._crypto_sign_ed25519_sk_to_pk = (Wr, ri) => ($._crypto_sign_ed25519_sk_to_pk = qr.Jg)(Wr, ri), $._crypto_sign_ed25519ph_init = (Wr) => ($._crypto_sign_ed25519ph_init = qr.Kg)(Wr), $._crypto_sign_ed25519ph_update = (Wr, ri, _i, Er) => ($._crypto_sign_ed25519ph_update = qr.Lg)(Wr, ri, _i, Er), $._crypto_sign_ed25519ph_final_create = (Wr, ri, _i, Er) => ($._crypto_sign_ed25519ph_final_create = qr.Mg)(Wr, ri, _i, Er), $._crypto_sign_ed25519ph_final_verify = (Wr, ri, _i) => ($._crypto_sign_ed25519ph_final_verify = qr.Ng)(Wr, ri, _i), $._crypto_sign_ed25519_seed_keypair = (Wr, ri, _i) => ($._crypto_sign_ed25519_seed_keypair = qr.Og)(Wr, ri, _i), $._crypto_sign_ed25519_keypair = (Wr, ri) => ($._crypto_sign_ed25519_keypair = qr.Pg)(Wr, ri), $._crypto_sign_ed25519_pk_to_curve25519 = (Wr, ri) => ($._crypto_sign_ed25519_pk_to_curve25519 = qr.Qg)(Wr, ri), $._crypto_sign_ed25519_sk_to_curve25519 = (Wr, ri) => ($._crypto_sign_ed25519_sk_to_curve25519 = qr.Rg)(Wr, ri), $._crypto_sign_ed25519_verify_detached = (Wr, ri, _i, Er, Di) => ($._crypto_sign_ed25519_verify_detached = qr.Sg)(Wr, ri, _i, Er, Di), $._crypto_sign_ed25519_open = (Wr, ri, _i, Er, Di, _n) => ($._crypto_sign_ed25519_open = qr.Tg)(Wr, ri, _i, Er, Di, _n), $._crypto_sign_ed25519_detached = (Wr, ri, _i, Er, Di, _n) => ($._crypto_sign_ed25519_detached = qr.Ug)(Wr, ri, _i, Er, Di, _n), $._crypto_sign_ed25519 = (Wr, ri, _i, Er, Di, _n) => ($._crypto_sign_ed25519 = qr.Vg)(Wr, ri, _i, Er, Di, _n), $._crypto_stream_chacha20_keybytes = () => ($._crypto_stream_chacha20_keybytes = qr.Wg)(), $._crypto_stream_chacha20_noncebytes = () => ($._crypto_stream_chacha20_noncebytes = qr.Xg)(), $._crypto_stream_chacha20_messagebytes_max = () => ($._crypto_stream_chacha20_messagebytes_max = qr.Yg)(), $._crypto_stream_chacha20_ietf_keybytes = () => ($._crypto_stream_chacha20_ietf_keybytes = qr.Zg)(), $._crypto_stream_chacha20_ietf_noncebytes = () => ($._crypto_stream_chacha20_ietf_noncebytes = qr._g)(), $._crypto_stream_chacha20_ietf_messagebytes_max = () => ($._crypto_stream_chacha20_ietf_messagebytes_max = qr.$g)(), $._crypto_stream_chacha20 = (Wr, ri, _i, Er, Di) => ($._crypto_stream_chacha20 = qr.ah)(Wr, ri, _i, Er, Di), $._crypto_stream_chacha20_xor_ic = (Wr, ri, _i, Er, Di, _n, On, so) => ($._crypto_stream_chacha20_xor_ic = qr.bh)(Wr, ri, _i, Er, Di, _n, On, so), $._crypto_stream_chacha20_xor = (Wr, ri, _i, Er, Di, _n) => ($._crypto_stream_chacha20_xor = qr.ch)(Wr, ri, _i, Er, Di, _n), $._crypto_stream_chacha20_ietf = (Wr, ri, _i, Er, Di) => ($._crypto_stream_chacha20_ietf = qr.dh)(Wr, ri, _i, Er, Di), $._crypto_stream_chacha20_ietf_xor_ic = (Wr, ri, _i, Er, Di, _n, On) => ($._crypto_stream_chacha20_ietf_xor_ic = qr.eh)(Wr, ri, _i, Er, Di, _n, On), $._crypto_stream_chacha20_ietf_xor = (Wr, ri, _i, Er, Di, _n) => ($._crypto_stream_chacha20_ietf_xor = qr.fh)(Wr, ri, _i, Er, Di, _n), $._crypto_stream_chacha20_ietf_keygen = (Wr) => ($._crypto_stream_chacha20_ietf_keygen = qr.gh)(Wr), $._crypto_stream_chacha20_keygen = (Wr) => ($._crypto_stream_chacha20_keygen = qr.hh)(Wr), $._crypto_stream_keybytes = () => ($._crypto_stream_keybytes = qr.ih)(), $._crypto_stream_noncebytes = () => ($._crypto_stream_noncebytes = qr.jh)(), $._crypto_stream_messagebytes_max = () => ($._crypto_stream_messagebytes_max = qr.kh)(), $._crypto_stream_primitive = () => ($._crypto_stream_primitive = qr.lh)(), $._crypto_stream = (Wr, ri, _i, Er, Di) => ($._crypto_stream = qr.mh)(Wr, ri, _i, Er, Di), $._crypto_stream_xor = (Wr, ri, _i, Er, Di, _n) => ($._crypto_stream_xor = qr.nh)(Wr, ri, _i, Er, Di, _n), $._crypto_stream_keygen = (Wr) => ($._crypto_stream_keygen = qr.oh)(Wr), $._crypto_stream_salsa20_keybytes = () => ($._crypto_stream_salsa20_keybytes = qr.ph)(), $._crypto_stream_salsa20_noncebytes = () => ($._crypto_stream_salsa20_noncebytes = qr.qh)(), $._crypto_stream_salsa20_messagebytes_max = () => ($._crypto_stream_salsa20_messagebytes_max = qr.rh)(), $._crypto_stream_salsa20 = (Wr, ri, _i, Er, Di) => ($._crypto_stream_salsa20 = qr.sh)(Wr, ri, _i, Er, Di), $._crypto_stream_salsa20_xor_ic = (Wr, ri, _i, Er, Di, _n, On, so) => ($._crypto_stream_salsa20_xor_ic = qr.th)(Wr, ri, _i, Er, Di, _n, On, so), $._crypto_stream_salsa20_xor = (Wr, ri, _i, Er, Di, _n) => ($._crypto_stream_salsa20_xor = qr.uh)(Wr, ri, _i, Er, Di, _n), $._crypto_stream_salsa20_keygen = (Wr) => ($._crypto_stream_salsa20_keygen = qr.vh)(Wr), $._crypto_stream_xsalsa20 = (Wr, ri, _i, Er, Di) => ($._crypto_stream_xsalsa20 = qr.wh)(Wr, ri, _i, Er, Di), $._crypto_stream_xsalsa20_xor_ic = (Wr, ri, _i, Er, Di, _n, On, so) => ($._crypto_stream_xsalsa20_xor_ic = qr.xh)(Wr, ri, _i, Er, Di, _n, On, so), $._crypto_stream_xsalsa20_xor = (Wr, ri, _i, Er, Di, _n) => ($._crypto_stream_xsalsa20_xor = qr.yh)(Wr, ri, _i, Er, Di, _n), $._crypto_stream_xsalsa20_keybytes = () => ($._crypto_stream_xsalsa20_keybytes = qr.zh)(), $._crypto_stream_xsalsa20_noncebytes = () => ($._crypto_stream_xsalsa20_noncebytes = qr.Ah)(), $._crypto_stream_xsalsa20_messagebytes_max = () => ($._crypto_stream_xsalsa20_messagebytes_max = qr.Bh)(), $._crypto_stream_xsalsa20_keygen = (Wr) => ($._crypto_stream_xsalsa20_keygen = qr.Ch)(Wr), $._crypto_verify_16_bytes = () => ($._crypto_verify_16_bytes = qr.Dh)(), $._crypto_verify_32_bytes = () => ($._crypto_verify_32_bytes = qr.Eh)(), $._crypto_verify_64_bytes = () => ($._crypto_verify_64_bytes = qr.Fh)(), $._crypto_verify_16 = (Wr, ri) => ($._crypto_verify_16 = qr.Gh)(Wr, ri), $._crypto_verify_32 = (Wr, ri) => ($._crypto_verify_32 = qr.Hh)(Wr, ri), $._crypto_verify_64 = (Wr, ri) => ($._crypto_verify_64 = qr.Ih)(Wr, ri), $._randombytes_implementation_name = () => ($._randombytes_implementation_name = qr.Jh)(), $._randombytes_random = () => ($._randombytes_random = qr.Kh)(), $._randombytes_stir = () => ($._randombytes_stir = qr.Lh)(), $._randombytes_uniform = (Wr) => ($._randombytes_uniform = qr.Mh)(Wr), $._randombytes_buf = (Wr, ri) => ($._randombytes_buf = qr.Nh)(Wr, ri), $._randombytes_buf_deterministic = (Wr, ri, _i) => ($._randombytes_buf_deterministic = qr.Oh)(Wr, ri, _i), $._randombytes_seedbytes = () => ($._randombytes_seedbytes = qr.Ph)(), $._randombytes_close = () => ($._randombytes_close = qr.Qh)(), $._randombytes = (Wr, ri, _i) => ($._randombytes = qr.Rh)(Wr, ri, _i), $._sodium_bin2hex = (Wr, ri, _i, Er) => ($._sodium_bin2hex = qr.Sh)(Wr, ri, _i, Er), $._sodium_hex2bin = (Wr, ri, _i, Er, Di, _n, On) => ($._sodium_hex2bin = qr.Th)(Wr, ri, _i, Er, Di, _n, On), $._sodium_base64_encoded_len = (Wr, ri) => ($._sodium_base64_encoded_len = qr.Uh)(Wr, ri), $._sodium_bin2base64 = (Wr, ri, _i, Er, Di) => ($._sodium_bin2base64 = qr.Vh)(Wr, ri, _i, Er, Di), $._sodium_base642bin = (Wr, ri, _i, Er, Di, _n, On, so) => ($._sodium_base642bin = qr.Wh)(Wr, ri, _i, Er, Di, _n, On, so), $._sodium_init = () => ($._sodium_init = qr.Xh)(), $._sodium_pad = (Wr, ri, _i, Er, Di) => ($._sodium_pad = qr.Yh)(Wr, ri, _i, Er, Di), $._sodium_unpad = (Wr, ri, _i, Er) => ($._sodium_unpad = qr.Zh)(Wr, ri, _i, Er), $._sodium_version_string = () => ($._sodium_version_string = qr._h)(), $._sodium_library_version_major = () => ($._sodium_library_version_major = qr.$h)(), $._sodium_library_version_minor = () => ($._sodium_library_version_minor = qr.ai)(), $._sodium_library_minimal = () => ($._sodium_library_minimal = qr.bi)(), $._crypto_box_curve25519xchacha20poly1305_seed_keypair = (Wr, ri, _i) => ($._crypto_box_curve25519xchacha20poly1305_seed_keypair = qr.ci)(Wr, ri, _i), $._crypto_box_curve25519xchacha20poly1305_keypair = (Wr, ri) => ($._crypto_box_curve25519xchacha20poly1305_keypair = qr.di)(Wr, ri), $._crypto_box_curve25519xchacha20poly1305_beforenm = (Wr, ri, _i) => ($._crypto_box_curve25519xchacha20poly1305_beforenm = qr.ei)(Wr, ri, _i), $._crypto_box_curve25519xchacha20poly1305_detached_afternm = (Wr, ri, _i, Er, Di, _n, On) => ($._crypto_box_curve25519xchacha20poly1305_detached_afternm = qr.fi)(Wr, ri, _i, Er, Di, _n, On), $._crypto_box_curve25519xchacha20poly1305_detached = (Wr, ri, _i, Er, Di, _n, On, so) => ($._crypto_box_curve25519xchacha20poly1305_detached = qr.gi)(Wr, ri, _i, Er, Di, _n, On, so), $._crypto_box_curve25519xchacha20poly1305_easy_afternm = (Wr, ri, _i, Er, Di, _n) => ($._crypto_box_curve25519xchacha20poly1305_easy_afternm = qr.hi)(Wr, ri, _i, Er, Di, _n), $._crypto_box_curve25519xchacha20poly1305_easy = (Wr, ri, _i, Er, Di, _n, On) => ($._crypto_box_curve25519xchacha20poly1305_easy = qr.ii)(Wr, ri, _i, Er, Di, _n, On), $._crypto_box_curve25519xchacha20poly1305_open_detached_afternm = (Wr, ri, _i, Er, Di, _n, On) => ($._crypto_box_curve25519xchacha20poly1305_open_detached_afternm = qr.ji)(Wr, ri, _i, Er, Di, _n, On), $._crypto_box_curve25519xchacha20poly1305_open_detached = (Wr, ri, _i, Er, Di, _n, On, so) => ($._crypto_box_curve25519xchacha20poly1305_open_detached = qr.ki)(Wr, ri, _i, Er, Di, _n, On, so), $._crypto_box_curve25519xchacha20poly1305_open_easy_afternm = (Wr, ri, _i, Er, Di, _n) => ($._crypto_box_curve25519xchacha20poly1305_open_easy_afternm = qr.li)(Wr, ri, _i, Er, Di, _n), $._crypto_box_curve25519xchacha20poly1305_open_easy = (Wr, ri, _i, Er, Di, _n, On) => ($._crypto_box_curve25519xchacha20poly1305_open_easy = qr.mi)(Wr, ri, _i, Er, Di, _n, On), $._crypto_box_curve25519xchacha20poly1305_seedbytes = () => ($._crypto_box_curve25519xchacha20poly1305_seedbytes = qr.ni)(), $._crypto_box_curve25519xchacha20poly1305_publickeybytes = () => ($._crypto_box_curve25519xchacha20poly1305_publickeybytes = qr.oi)(), $._crypto_box_curve25519xchacha20poly1305_secretkeybytes = () => ($._crypto_box_curve25519xchacha20poly1305_secretkeybytes = qr.pi)(), $._crypto_box_curve25519xchacha20poly1305_beforenmbytes = () => ($._crypto_box_curve25519xchacha20poly1305_beforenmbytes = qr.qi)(), $._crypto_box_curve25519xchacha20poly1305_noncebytes = () => ($._crypto_box_curve25519xchacha20poly1305_noncebytes = qr.ri)(), $._crypto_box_curve25519xchacha20poly1305_macbytes = () => ($._crypto_box_curve25519xchacha20poly1305_macbytes = qr.si)(), $._crypto_box_curve25519xchacha20poly1305_messagebytes_max = () => ($._crypto_box_curve25519xchacha20poly1305_messagebytes_max = qr.ti)(), $._crypto_box_curve25519xchacha20poly1305_seal = (Wr, ri, _i, Er, Di) => ($._crypto_box_curve25519xchacha20poly1305_seal = qr.ui)(Wr, ri, _i, Er, Di), $._crypto_box_curve25519xchacha20poly1305_seal_open = (Wr, ri, _i, Er, Di, _n) => ($._crypto_box_curve25519xchacha20poly1305_seal_open = qr.vi)(Wr, ri, _i, Er, Di, _n), $._crypto_box_curve25519xchacha20poly1305_sealbytes = () => ($._crypto_box_curve25519xchacha20poly1305_sealbytes = qr.wi)(), $._crypto_core_ed25519_is_valid_point = (Wr) => ($._crypto_core_ed25519_is_valid_point = qr.xi)(Wr), $._crypto_core_ed25519_add = (Wr, ri, _i) => ($._crypto_core_ed25519_add = qr.yi)(Wr, ri, _i), $._crypto_core_ed25519_sub = (Wr, ri, _i) => ($._crypto_core_ed25519_sub = qr.zi)(Wr, ri, _i), $._crypto_core_ed25519_from_uniform = (Wr, ri) => ($._crypto_core_ed25519_from_uniform = qr.Ai)(Wr, ri), $._crypto_core_ed25519_random = (Wr) => ($._crypto_core_ed25519_random = qr.Bi)(Wr), $._crypto_core_ed25519_scalar_random = (Wr) => ($._crypto_core_ed25519_scalar_random = qr.Ci)(Wr), $._crypto_core_ed25519_scalar_invert = (Wr, ri) => ($._crypto_core_ed25519_scalar_invert = qr.Di)(Wr, ri), $._crypto_core_ed25519_scalar_negate = (Wr, ri) => ($._crypto_core_ed25519_scalar_negate = qr.Ei)(Wr, ri), $._crypto_core_ed25519_scalar_complement = (Wr, ri) => ($._crypto_core_ed25519_scalar_complement = qr.Fi)(Wr, ri), $._crypto_core_ed25519_scalar_add = (Wr, ri, _i) => ($._crypto_core_ed25519_scalar_add = qr.Gi)(Wr, ri, _i), $._crypto_core_ed25519_scalar_reduce = (Wr, ri) => ($._crypto_core_ed25519_scalar_reduce = qr.Hi)(Wr, ri), $._crypto_core_ed25519_scalar_sub = (Wr, ri, _i) => ($._crypto_core_ed25519_scalar_sub = qr.Ii)(Wr, ri, _i), $._crypto_core_ed25519_scalar_mul = (Wr, ri, _i) => ($._crypto_core_ed25519_scalar_mul = qr.Ji)(Wr, ri, _i), $._crypto_core_ed25519_bytes = () => ($._crypto_core_ed25519_bytes = qr.Ki)(), $._crypto_core_ed25519_nonreducedscalarbytes = () => ($._crypto_core_ed25519_nonreducedscalarbytes = qr.Li)(), $._crypto_core_ed25519_uniformbytes = () => ($._crypto_core_ed25519_uniformbytes = qr.Mi)(), $._crypto_core_ed25519_hashbytes = () => ($._crypto_core_ed25519_hashbytes = qr.Ni)(), $._crypto_core_ed25519_scalarbytes = () => ($._crypto_core_ed25519_scalarbytes = qr.Oi)(), $._crypto_core_ristretto255_is_valid_point = (Wr) => ($._crypto_core_ristretto255_is_valid_point = qr.Pi)(Wr), $._crypto_core_ristretto255_add = (Wr, ri, _i) => ($._crypto_core_ristretto255_add = qr.Qi)(Wr, ri, _i), $._crypto_core_ristretto255_sub = (Wr, ri, _i) => ($._crypto_core_ristretto255_sub = qr.Ri)(Wr, ri, _i), $._crypto_core_ristretto255_from_hash = (Wr, ri) => ($._crypto_core_ristretto255_from_hash = qr.Si)(Wr, ri), $._crypto_core_ristretto255_random = (Wr) => ($._crypto_core_ristretto255_random = qr.Ti)(Wr), $._crypto_core_ristretto255_scalar_random = (Wr) => ($._crypto_core_ristretto255_scalar_random = qr.Ui)(Wr), $._crypto_core_ristretto255_scalar_invert = (Wr, ri) => ($._crypto_core_ristretto255_scalar_invert = qr.Vi)(Wr, ri), $._crypto_core_ristretto255_scalar_negate = (Wr, ri) => ($._crypto_core_ristretto255_scalar_negate = qr.Wi)(Wr, ri), $._crypto_core_ristretto255_scalar_complement = (Wr, ri) => ($._crypto_core_ristretto255_scalar_complement = qr.Xi)(Wr, ri), $._crypto_core_ristretto255_scalar_add = (Wr, ri, _i) => ($._crypto_core_ristretto255_scalar_add = qr.Yi)(Wr, ri, _i), $._crypto_core_ristretto255_scalar_sub = (Wr, ri, _i) => ($._crypto_core_ristretto255_scalar_sub = qr.Zi)(Wr, ri, _i), $._crypto_core_ristretto255_scalar_mul = (Wr, ri, _i) => ($._crypto_core_ristretto255_scalar_mul = qr._i)(Wr, ri, _i), $._crypto_core_ristretto255_scalar_reduce = (Wr, ri) => ($._crypto_core_ristretto255_scalar_reduce = qr.$i)(Wr, ri), $._crypto_core_ristretto255_bytes = () => ($._crypto_core_ristretto255_bytes = qr.aj)(), $._crypto_core_ristretto255_nonreducedscalarbytes = () => ($._crypto_core_ristretto255_nonreducedscalarbytes = qr.bj)(), $._crypto_core_ristretto255_hashbytes = () => ($._crypto_core_ristretto255_hashbytes = qr.cj)(), $._crypto_core_ristretto255_scalarbytes = () => ($._crypto_core_ristretto255_scalarbytes = qr.dj)(), $._crypto_pwhash_scryptsalsa208sha256_ll = (Wr, ri, _i, Er, Di, _n, On, so, Do, gn) => ($._crypto_pwhash_scryptsalsa208sha256_ll = qr.ej)(Wr, ri, _i, Er, Di, _n, On, so, Do, gn), $._crypto_pwhash_scryptsalsa208sha256_bytes_min = () => ($._crypto_pwhash_scryptsalsa208sha256_bytes_min = qr.fj)(), $._crypto_pwhash_scryptsalsa208sha256_bytes_max = () => ($._crypto_pwhash_scryptsalsa208sha256_bytes_max = qr.gj)(), $._crypto_pwhash_scryptsalsa208sha256_passwd_min = () => ($._crypto_pwhash_scryptsalsa208sha256_passwd_min = qr.hj)(), $._crypto_pwhash_scryptsalsa208sha256_passwd_max = () => ($._crypto_pwhash_scryptsalsa208sha256_passwd_max = qr.ij)(), $._crypto_pwhash_scryptsalsa208sha256_saltbytes = () => ($._crypto_pwhash_scryptsalsa208sha256_saltbytes = qr.jj)(), $._crypto_pwhash_scryptsalsa208sha256_strbytes = () => ($._crypto_pwhash_scryptsalsa208sha256_strbytes = qr.kj)(), $._crypto_pwhash_scryptsalsa208sha256_strprefix = () => ($._crypto_pwhash_scryptsalsa208sha256_strprefix = qr.lj)(), $._crypto_pwhash_scryptsalsa208sha256_opslimit_min = () => ($._crypto_pwhash_scryptsalsa208sha256_opslimit_min = qr.mj)(), $._crypto_pwhash_scryptsalsa208sha256_opslimit_max = () => ($._crypto_pwhash_scryptsalsa208sha256_opslimit_max = qr.nj)(), $._crypto_pwhash_scryptsalsa208sha256_memlimit_min = () => ($._crypto_pwhash_scryptsalsa208sha256_memlimit_min = qr.oj)(), $._crypto_pwhash_scryptsalsa208sha256_memlimit_max = () => ($._crypto_pwhash_scryptsalsa208sha256_memlimit_max = qr.pj)(), $._crypto_pwhash_scryptsalsa208sha256_opslimit_interactive = () => ($._crypto_pwhash_scryptsalsa208sha256_opslimit_interactive = qr.qj)(), $._crypto_pwhash_scryptsalsa208sha256_memlimit_interactive = () => ($._crypto_pwhash_scryptsalsa208sha256_memlimit_interactive = qr.rj)(), $._crypto_pwhash_scryptsalsa208sha256_opslimit_sensitive = () => ($._crypto_pwhash_scryptsalsa208sha256_opslimit_sensitive = qr.sj)(), $._crypto_pwhash_scryptsalsa208sha256_memlimit_sensitive = () => ($._crypto_pwhash_scryptsalsa208sha256_memlimit_sensitive = qr.tj)(), $._crypto_pwhash_scryptsalsa208sha256 = (Wr, ri, _i, Er, Di, _n, On, so, Do, gn) => ($._crypto_pwhash_scryptsalsa208sha256 = qr.uj)(Wr, ri, _i, Er, Di, _n, On, so, Do, gn), $._crypto_pwhash_scryptsalsa208sha256_str = (Wr, ri, _i, Er, Di, _n, On) => ($._crypto_pwhash_scryptsalsa208sha256_str = qr.vj)(Wr, ri, _i, Er, Di, _n, On), $._crypto_pwhash_scryptsalsa208sha256_str_verify = (Wr, ri, _i, Er) => ($._crypto_pwhash_scryptsalsa208sha256_str_verify = qr.wj)(Wr, ri, _i, Er), $._crypto_pwhash_scryptsalsa208sha256_str_needs_rehash = (Wr, ri, _i, Er) => ($._crypto_pwhash_scryptsalsa208sha256_str_needs_rehash = qr.xj)(Wr, ri, _i, Er), $._crypto_scalarmult_ed25519 = (Wr, ri, _i) => ($._crypto_scalarmult_ed25519 = qr.yj)(Wr, ri, _i), $._crypto_scalarmult_ed25519_noclamp = (Wr, ri, _i) => ($._crypto_scalarmult_ed25519_noclamp = qr.zj)(Wr, ri, _i), $._crypto_scalarmult_ed25519_base = (Wr, ri) => ($._crypto_scalarmult_ed25519_base = qr.Aj)(Wr, ri), $._crypto_scalarmult_ed25519_base_noclamp = (Wr, ri) => ($._crypto_scalarmult_ed25519_base_noclamp = qr.Bj)(Wr, ri), $._crypto_scalarmult_ed25519_bytes = () => ($._crypto_scalarmult_ed25519_bytes = qr.Cj)(), $._crypto_scalarmult_ed25519_scalarbytes = () => ($._crypto_scalarmult_ed25519_scalarbytes = qr.Dj)(), $._crypto_scalarmult_ristretto255 = (Wr, ri, _i) => ($._crypto_scalarmult_ristretto255 = qr.Ej)(Wr, ri, _i), $._crypto_scalarmult_ristretto255_base = (Wr, ri) => ($._crypto_scalarmult_ristretto255_base = qr.Fj)(Wr, ri), $._crypto_scalarmult_ristretto255_bytes = () => ($._crypto_scalarmult_ristretto255_bytes = qr.Gj)(), $._crypto_scalarmult_ristretto255_scalarbytes = () => ($._crypto_scalarmult_ristretto255_scalarbytes = qr.Hj)(), $._crypto_secretbox_xchacha20poly1305_detached = (Wr, ri, _i, Er, Di, _n, On) => ($._crypto_secretbox_xchacha20poly1305_detached = qr.Ij)(Wr, ri, _i, Er, Di, _n, On), $._crypto_secretbox_xchacha20poly1305_easy = (Wr, ri, _i, Er, Di, _n) => ($._crypto_secretbox_xchacha20poly1305_easy = qr.Jj)(Wr, ri, _i, Er, Di, _n), $._crypto_secretbox_xchacha20poly1305_open_detached = (Wr, ri, _i, Er, Di, _n, On) => ($._crypto_secretbox_xchacha20poly1305_open_detached = qr.Kj)(Wr, ri, _i, Er, Di, _n, On), $._crypto_secretbox_xchacha20poly1305_open_easy = (Wr, ri, _i, Er, Di, _n) => ($._crypto_secretbox_xchacha20poly1305_open_easy = qr.Lj)(Wr, ri, _i, Er, Di, _n), $._crypto_secretbox_xchacha20poly1305_keybytes = () => ($._crypto_secretbox_xchacha20poly1305_keybytes = qr.Mj)(), $._crypto_secretbox_xchacha20poly1305_noncebytes = () => ($._crypto_secretbox_xchacha20poly1305_noncebytes = qr.Nj)(), $._crypto_secretbox_xchacha20poly1305_macbytes = () => ($._crypto_secretbox_xchacha20poly1305_macbytes = qr.Oj)(), $._crypto_secretbox_xchacha20poly1305_messagebytes_max = () => ($._crypto_secretbox_xchacha20poly1305_messagebytes_max = qr.Pj)(), $._crypto_shorthash_siphashx24_bytes = () => ($._crypto_shorthash_siphashx24_bytes = qr.Qj)(), $._crypto_shorthash_siphashx24_keybytes = () => ($._crypto_shorthash_siphashx24_keybytes = qr.Rj)(), $._crypto_shorthash_siphashx24 = (Wr, ri, _i, Er, Di) => ($._crypto_shorthash_siphashx24 = qr.Sj)(Wr, ri, _i, Er, Di), $._crypto_stream_salsa2012 = (Wr, ri, _i, Er, Di) => ($._crypto_stream_salsa2012 = qr.Tj)(Wr, ri, _i, Er, Di), $._crypto_stream_salsa2012_xor = (Wr, ri, _i, Er, Di, _n) => ($._crypto_stream_salsa2012_xor = qr.Uj)(Wr, ri, _i, Er, Di, _n), $._crypto_stream_salsa2012_keybytes = () => ($._crypto_stream_salsa2012_keybytes = qr.Vj)(), $._crypto_stream_salsa2012_noncebytes = () => ($._crypto_stream_salsa2012_noncebytes = qr.Wj)(), $._crypto_stream_salsa2012_messagebytes_max = () => ($._crypto_stream_salsa2012_messagebytes_max = qr.Xj)(), $._crypto_stream_salsa2012_keygen = (Wr) => ($._crypto_stream_salsa2012_keygen = qr.Yj)(Wr), $._crypto_stream_salsa208 = (Wr, ri, _i, Er, Di) => ($._crypto_stream_salsa208 = qr.Zj)(Wr, ri, _i, Er, Di), $._crypto_stream_salsa208_xor = (Wr, ri, _i, Er, Di, _n) => ($._crypto_stream_salsa208_xor = qr._j)(Wr, ri, _i, Er, Di, _n), $._crypto_stream_salsa208_keybytes = () => ($._crypto_stream_salsa208_keybytes = qr.$j)(), $._crypto_stream_salsa208_noncebytes = () => ($._crypto_stream_salsa208_noncebytes = qr.ak)(), $._crypto_stream_salsa208_messagebytes_max = () => ($._crypto_stream_salsa208_messagebytes_max = qr.bk)(), $._crypto_stream_salsa208_keygen = (Wr) => ($._crypto_stream_salsa208_keygen = qr.ck)(Wr), $._crypto_stream_xchacha20_keybytes = () => ($._crypto_stream_xchacha20_keybytes = qr.dk)(), $._crypto_stream_xchacha20_noncebytes = () => ($._crypto_stream_xchacha20_noncebytes = qr.ek)(), $._crypto_stream_xchacha20_messagebytes_max = () => ($._crypto_stream_xchacha20_messagebytes_max = qr.fk)(), $._crypto_stream_xchacha20 = (Wr, ri, _i, Er, Di) => ($._crypto_stream_xchacha20 = qr.gk)(Wr, ri, _i, Er, Di), $._crypto_stream_xchacha20_xor_ic = (Wr, ri, _i, Er, Di, _n, On, so) => ($._crypto_stream_xchacha20_xor_ic = qr.hk)(Wr, ri, _i, Er, Di, _n, On, so), $._crypto_stream_xchacha20_xor = (Wr, ri, _i, Er, Di, _n) => ($._crypto_stream_xchacha20_xor = qr.ik)(Wr, ri, _i, Er, Di, _n), $._crypto_stream_xchacha20_keygen = (Wr) => ($._crypto_stream_xchacha20_keygen = qr.jk)(Wr), $._malloc = (Wr) => ($._malloc = qr.kk)(Wr), $._free = (Wr) => ($._free = qr.lk)(Wr), $.setValue = function(Wr, ri, _i = "i8") {
            switch (_i.endsWith("*") && (_i = "*"), _i) {
              case "i1":
              case "i8":
                kr[Wr] = ri;
                break;
              case "i16":
                tr[Wr >> 1] = ri;
                break;
              case "i32":
                Fe[Wr >> 2] = ri;
                break;
              case "i64":
                Te("to do setValue(i64) use WASM_BIGINT");
              case "float":
                er[Wr >> 2] = ri;
                break;
              case "double":
                Ie[Wr >> 3] = ri;
                break;
              case "*":
                Sr[Wr >> 2] = ri;
                break;
              default:
                Te(`invalid type for setValue: ${_i}`);
            }
          }, $.getValue = function(Wr, ri = "i8") {
            switch (ri.endsWith("*") && (ri = "*"), ri) {
              case "i1":
              case "i8":
                return kr[Wr];
              case "i16":
                return tr[Wr >> 1];
              case "i32":
                return Fe[Wr >> 2];
              case "i64":
                Te("to do getValue(i64) use WASM_BIGINT");
              case "float":
                return er[Wr >> 2];
              case "double":
                return Ie[Wr >> 3];
              case "*":
                return Sr[Wr >> 2];
              default:
                Te(`invalid type for getValue: ${ri}`);
            }
          }, $.UTF8ToString = mn, vr = function Wr() {
            wi || Zi(), wi || (vr = Wr);
          }, $.preInit) for (typeof $.preInit == "function" && ($.preInit = [$.preInit]); $.preInit.length > 0; ) $.preInit.pop()();
          Zi();
        }).catch(function() {
          return F.useBackupModule();
        }), A;
      }
      typeof c.nodeName != "string" ? p(c) : u.libsodium = p(u.libsodium_mod || (u.commonJsStrict = {}));
    })(commonjsGlobal);
  }(libsodiumSumo, libsodiumSumo.exports)), libsodiumSumo.exports;
}
(function(n) {
  (function(c) {
    function u(a, A) {
      var b, F = "uint8array", le = A.ready.then(function() {
        function Ai() {
          if (b._sodium_init() !== 0) throw new Error("libsodium was not correctly initialized.");
          for (var Ki = ["crypto_aead_aegis128l_decrypt", "crypto_aead_aegis128l_decrypt_detached", "crypto_aead_aegis128l_encrypt", "crypto_aead_aegis128l_encrypt_detached", "crypto_aead_aegis128l_keygen", "crypto_aead_aegis256_decrypt", "crypto_aead_aegis256_decrypt_detached", "crypto_aead_aegis256_encrypt", "crypto_aead_aegis256_encrypt_detached", "crypto_aead_aegis256_keygen", "crypto_aead_chacha20poly1305_decrypt", "crypto_aead_chacha20poly1305_decrypt_detached", "crypto_aead_chacha20poly1305_encrypt", "crypto_aead_chacha20poly1305_encrypt_detached", "crypto_aead_chacha20poly1305_ietf_decrypt", "crypto_aead_chacha20poly1305_ietf_decrypt_detached", "crypto_aead_chacha20poly1305_ietf_encrypt", "crypto_aead_chacha20poly1305_ietf_encrypt_detached", "crypto_aead_chacha20poly1305_ietf_keygen", "crypto_aead_chacha20poly1305_keygen", "crypto_aead_xchacha20poly1305_ietf_decrypt", "crypto_aead_xchacha20poly1305_ietf_decrypt_detached", "crypto_aead_xchacha20poly1305_ietf_encrypt", "crypto_aead_xchacha20poly1305_ietf_encrypt_detached", "crypto_aead_xchacha20poly1305_ietf_keygen", "crypto_auth", "crypto_auth_hmacsha256", "crypto_auth_hmacsha256_final", "crypto_auth_hmacsha256_init", "crypto_auth_hmacsha256_keygen", "crypto_auth_hmacsha256_update", "crypto_auth_hmacsha256_verify", "crypto_auth_hmacsha512", "crypto_auth_hmacsha512256", "crypto_auth_hmacsha512256_final", "crypto_auth_hmacsha512256_init", "crypto_auth_hmacsha512256_keygen", "crypto_auth_hmacsha512256_update", "crypto_auth_hmacsha512256_verify", "crypto_auth_hmacsha512_final", "crypto_auth_hmacsha512_init", "crypto_auth_hmacsha512_keygen", "crypto_auth_hmacsha512_update", "crypto_auth_hmacsha512_verify", "crypto_auth_keygen", "crypto_auth_verify", "crypto_box_beforenm", "crypto_box_curve25519xchacha20poly1305_beforenm", "crypto_box_curve25519xchacha20poly1305_detached", "crypto_box_curve25519xchacha20poly1305_detached_afternm", "crypto_box_curve25519xchacha20poly1305_easy", "crypto_box_curve25519xchacha20poly1305_easy_afternm", "crypto_box_curve25519xchacha20poly1305_keypair", "crypto_box_curve25519xchacha20poly1305_open_detached", "crypto_box_curve25519xchacha20poly1305_open_detached_afternm", "crypto_box_curve25519xchacha20poly1305_open_easy", "crypto_box_curve25519xchacha20poly1305_open_easy_afternm", "crypto_box_curve25519xchacha20poly1305_seal", "crypto_box_curve25519xchacha20poly1305_seal_open", "crypto_box_curve25519xchacha20poly1305_seed_keypair", "crypto_box_detached", "crypto_box_easy", "crypto_box_easy_afternm", "crypto_box_keypair", "crypto_box_open_detached", "crypto_box_open_easy", "crypto_box_open_easy_afternm", "crypto_box_seal", "crypto_box_seal_open", "crypto_box_seed_keypair", "crypto_core_ed25519_add", "crypto_core_ed25519_from_hash", "crypto_core_ed25519_from_uniform", "crypto_core_ed25519_is_valid_point", "crypto_core_ed25519_random", "crypto_core_ed25519_scalar_add", "crypto_core_ed25519_scalar_complement", "crypto_core_ed25519_scalar_invert", "crypto_core_ed25519_scalar_mul", "crypto_core_ed25519_scalar_negate", "crypto_core_ed25519_scalar_random", "crypto_core_ed25519_scalar_reduce", "crypto_core_ed25519_scalar_sub", "crypto_core_ed25519_sub", "crypto_core_hchacha20", "crypto_core_hsalsa20", "crypto_core_ristretto255_add", "crypto_core_ristretto255_from_hash", "crypto_core_ristretto255_is_valid_point", "crypto_core_ristretto255_random", "crypto_core_ristretto255_scalar_add", "crypto_core_ristretto255_scalar_complement", "crypto_core_ristretto255_scalar_invert", "crypto_core_ristretto255_scalar_mul", "crypto_core_ristretto255_scalar_negate", "crypto_core_ristretto255_scalar_random", "crypto_core_ristretto255_scalar_reduce", "crypto_core_ristretto255_scalar_sub", "crypto_core_ristretto255_sub", "crypto_generichash", "crypto_generichash_blake2b_salt_personal", "crypto_generichash_final", "crypto_generichash_init", "crypto_generichash_keygen", "crypto_generichash_update", "crypto_hash", "crypto_hash_sha256", "crypto_hash_sha256_final", "crypto_hash_sha256_init", "crypto_hash_sha256_update", "crypto_hash_sha512", "crypto_hash_sha512_final", "crypto_hash_sha512_init", "crypto_hash_sha512_update", "crypto_kdf_derive_from_key", "crypto_kdf_keygen", "crypto_kx_client_session_keys", "crypto_kx_keypair", "crypto_kx_seed_keypair", "crypto_kx_server_session_keys", "crypto_onetimeauth", "crypto_onetimeauth_final", "crypto_onetimeauth_init", "crypto_onetimeauth_keygen", "crypto_onetimeauth_update", "crypto_onetimeauth_verify", "crypto_pwhash", "crypto_pwhash_scryptsalsa208sha256", "crypto_pwhash_scryptsalsa208sha256_ll", "crypto_pwhash_scryptsalsa208sha256_str", "crypto_pwhash_scryptsalsa208sha256_str_verify", "crypto_pwhash_str", "crypto_pwhash_str_needs_rehash", "crypto_pwhash_str_verify", "crypto_scalarmult", "crypto_scalarmult_base", "crypto_scalarmult_ed25519", "crypto_scalarmult_ed25519_base", "crypto_scalarmult_ed25519_base_noclamp", "crypto_scalarmult_ed25519_noclamp", "crypto_scalarmult_ristretto255", "crypto_scalarmult_ristretto255_base", "crypto_secretbox_detached", "crypto_secretbox_easy", "crypto_secretbox_keygen", "crypto_secretbox_open_detached", "crypto_secretbox_open_easy", "crypto_secretstream_xchacha20poly1305_init_pull", "crypto_secretstream_xchacha20poly1305_init_push", "crypto_secretstream_xchacha20poly1305_keygen", "crypto_secretstream_xchacha20poly1305_pull", "crypto_secretstream_xchacha20poly1305_push", "crypto_secretstream_xchacha20poly1305_rekey", "crypto_shorthash", "crypto_shorthash_keygen", "crypto_shorthash_siphashx24", "crypto_sign", "crypto_sign_detached", "crypto_sign_ed25519_pk_to_curve25519", "crypto_sign_ed25519_sk_to_curve25519", "crypto_sign_ed25519_sk_to_pk", "crypto_sign_ed25519_sk_to_seed", "crypto_sign_final_create", "crypto_sign_final_verify", "crypto_sign_init", "crypto_sign_keypair", "crypto_sign_open", "crypto_sign_seed_keypair", "crypto_sign_update", "crypto_sign_verify_detached", "crypto_stream_chacha20", "crypto_stream_chacha20_ietf_xor", "crypto_stream_chacha20_ietf_xor_ic", "crypto_stream_chacha20_keygen", "crypto_stream_chacha20_xor", "crypto_stream_chacha20_xor_ic", "crypto_stream_keygen", "crypto_stream_xchacha20_keygen", "crypto_stream_xchacha20_xor", "crypto_stream_xchacha20_xor_ic", "randombytes_buf", "randombytes_buf_deterministic", "randombytes_close", "randombytes_random", "randombytes_set_implementation", "randombytes_stir", "randombytes_uniform", "sodium_version_string"], Pn = [Sr, er, Ie, xe, rr, ar, yr, _r, Or, vr, Te, Cr, Hr, si, ui, Li, Qi, wi, Ji, mn, pi, ei, Vr, qr, Zi, Wr, ri, _i, Er, Di, _n, On, so, Do, gn, Gn, pn, hn, Rn, vo, Hi, di, Ui, ln, Un, Bo, co, To, xs, Fo, Zo, $s, rs, ls, na, os, fs, da, Bn, hi, Ii, Gi, kn, ho, eo, Ei, vs, vi, xi, Lr, dn, xn, oi, Yr, ji, Cn, Mn, B, o, m, d, v, he, we, Be, Me, fr, wr, dr, Dr, Rr, Qe, Fr, Gr, $r, ni, mi, Si, Oi, $i, zi, un, In, Ti, Sn, Kn, Vn, Xn, uo, yo, Io, xo, Mo, qi, Oo, Ho, Go, ns, ds, Ts, Ao, po, _o, Uo, ts, Lo, Wo, ps, Bs, Xs, js, ya, sa, va, oa, wa, Pa, Ta, jn, ta, Na, ba, Aa, zs, x2, Va, Se, ea, e, Je, N2, qs, df, zo, No, Oa, Mf, Ha, Cu, gi, wn, no, Co, Ko, jo, ss, Ms, Ws, ia, La, mf, kf, Cf, Nf, jf, E2, Xf, Zf, Ic, $a, gs, Wc, Uc, Gf, su, i2, tc, pc], oo = 0; oo < Pn.length; oo++) typeof b["_" + Ki[oo]] == "function" && (a[Ki[oo]] = Pn[oo]);
          var mo = ["SODIUM_LIBRARY_VERSION_MAJOR", "SODIUM_LIBRARY_VERSION_MINOR", "crypto_aead_aegis128l_ABYTES", "crypto_aead_aegis128l_KEYBYTES", "crypto_aead_aegis128l_MESSAGEBYTES_MAX", "crypto_aead_aegis128l_NPUBBYTES", "crypto_aead_aegis128l_NSECBYTES", "crypto_aead_aegis256_ABYTES", "crypto_aead_aegis256_KEYBYTES", "crypto_aead_aegis256_MESSAGEBYTES_MAX", "crypto_aead_aegis256_NPUBBYTES", "crypto_aead_aegis256_NSECBYTES", "crypto_aead_aes256gcm_ABYTES", "crypto_aead_aes256gcm_KEYBYTES", "crypto_aead_aes256gcm_MESSAGEBYTES_MAX", "crypto_aead_aes256gcm_NPUBBYTES", "crypto_aead_aes256gcm_NSECBYTES", "crypto_aead_chacha20poly1305_ABYTES", "crypto_aead_chacha20poly1305_IETF_ABYTES", "crypto_aead_chacha20poly1305_IETF_KEYBYTES", "crypto_aead_chacha20poly1305_IETF_MESSAGEBYTES_MAX", "crypto_aead_chacha20poly1305_IETF_NPUBBYTES", "crypto_aead_chacha20poly1305_IETF_NSECBYTES", "crypto_aead_chacha20poly1305_KEYBYTES", "crypto_aead_chacha20poly1305_MESSAGEBYTES_MAX", "crypto_aead_chacha20poly1305_NPUBBYTES", "crypto_aead_chacha20poly1305_NSECBYTES", "crypto_aead_chacha20poly1305_ietf_ABYTES", "crypto_aead_chacha20poly1305_ietf_KEYBYTES", "crypto_aead_chacha20poly1305_ietf_MESSAGEBYTES_MAX", "crypto_aead_chacha20poly1305_ietf_NPUBBYTES", "crypto_aead_chacha20poly1305_ietf_NSECBYTES", "crypto_aead_xchacha20poly1305_IETF_ABYTES", "crypto_aead_xchacha20poly1305_IETF_KEYBYTES", "crypto_aead_xchacha20poly1305_IETF_MESSAGEBYTES_MAX", "crypto_aead_xchacha20poly1305_IETF_NPUBBYTES", "crypto_aead_xchacha20poly1305_IETF_NSECBYTES", "crypto_aead_xchacha20poly1305_ietf_ABYTES", "crypto_aead_xchacha20poly1305_ietf_KEYBYTES", "crypto_aead_xchacha20poly1305_ietf_MESSAGEBYTES_MAX", "crypto_aead_xchacha20poly1305_ietf_NPUBBYTES", "crypto_aead_xchacha20poly1305_ietf_NSECBYTES", "crypto_auth_BYTES", "crypto_auth_KEYBYTES", "crypto_auth_hmacsha256_BYTES", "crypto_auth_hmacsha256_KEYBYTES", "crypto_auth_hmacsha512256_BYTES", "crypto_auth_hmacsha512256_KEYBYTES", "crypto_auth_hmacsha512_BYTES", "crypto_auth_hmacsha512_KEYBYTES", "crypto_box_BEFORENMBYTES", "crypto_box_MACBYTES", "crypto_box_MESSAGEBYTES_MAX", "crypto_box_NONCEBYTES", "crypto_box_PUBLICKEYBYTES", "crypto_box_SEALBYTES", "crypto_box_SECRETKEYBYTES", "crypto_box_SEEDBYTES", "crypto_box_curve25519xchacha20poly1305_BEFORENMBYTES", "crypto_box_curve25519xchacha20poly1305_MACBYTES", "crypto_box_curve25519xchacha20poly1305_MESSAGEBYTES_MAX", "crypto_box_curve25519xchacha20poly1305_NONCEBYTES", "crypto_box_curve25519xchacha20poly1305_PUBLICKEYBYTES", "crypto_box_curve25519xchacha20poly1305_SEALBYTES", "crypto_box_curve25519xchacha20poly1305_SECRETKEYBYTES", "crypto_box_curve25519xchacha20poly1305_SEEDBYTES", "crypto_box_curve25519xsalsa20poly1305_BEFORENMBYTES", "crypto_box_curve25519xsalsa20poly1305_MACBYTES", "crypto_box_curve25519xsalsa20poly1305_MESSAGEBYTES_MAX", "crypto_box_curve25519xsalsa20poly1305_NONCEBYTES", "crypto_box_curve25519xsalsa20poly1305_PUBLICKEYBYTES", "crypto_box_curve25519xsalsa20poly1305_SECRETKEYBYTES", "crypto_box_curve25519xsalsa20poly1305_SEEDBYTES", "crypto_core_ed25519_BYTES", "crypto_core_ed25519_HASHBYTES", "crypto_core_ed25519_NONREDUCEDSCALARBYTES", "crypto_core_ed25519_SCALARBYTES", "crypto_core_ed25519_UNIFORMBYTES", "crypto_core_hchacha20_CONSTBYTES", "crypto_core_hchacha20_INPUTBYTES", "crypto_core_hchacha20_KEYBYTES", "crypto_core_hchacha20_OUTPUTBYTES", "crypto_core_hsalsa20_CONSTBYTES", "crypto_core_hsalsa20_INPUTBYTES", "crypto_core_hsalsa20_KEYBYTES", "crypto_core_hsalsa20_OUTPUTBYTES", "crypto_core_ristretto255_BYTES", "crypto_core_ristretto255_HASHBYTES", "crypto_core_ristretto255_NONREDUCEDSCALARBYTES", "crypto_core_ristretto255_SCALARBYTES", "crypto_core_salsa2012_CONSTBYTES", "crypto_core_salsa2012_INPUTBYTES", "crypto_core_salsa2012_KEYBYTES", "crypto_core_salsa2012_OUTPUTBYTES", "crypto_core_salsa208_CONSTBYTES", "crypto_core_salsa208_INPUTBYTES", "crypto_core_salsa208_KEYBYTES", "crypto_core_salsa208_OUTPUTBYTES", "crypto_core_salsa20_CONSTBYTES", "crypto_core_salsa20_INPUTBYTES", "crypto_core_salsa20_KEYBYTES", "crypto_core_salsa20_OUTPUTBYTES", "crypto_generichash_BYTES", "crypto_generichash_BYTES_MAX", "crypto_generichash_BYTES_MIN", "crypto_generichash_KEYBYTES", "crypto_generichash_KEYBYTES_MAX", "crypto_generichash_KEYBYTES_MIN", "crypto_generichash_blake2b_BYTES", "crypto_generichash_blake2b_BYTES_MAX", "crypto_generichash_blake2b_BYTES_MIN", "crypto_generichash_blake2b_KEYBYTES", "crypto_generichash_blake2b_KEYBYTES_MAX", "crypto_generichash_blake2b_KEYBYTES_MIN", "crypto_generichash_blake2b_PERSONALBYTES", "crypto_generichash_blake2b_SALTBYTES", "crypto_hash_BYTES", "crypto_hash_sha256_BYTES", "crypto_hash_sha512_BYTES", "crypto_kdf_BYTES_MAX", "crypto_kdf_BYTES_MIN", "crypto_kdf_CONTEXTBYTES", "crypto_kdf_KEYBYTES", "crypto_kdf_blake2b_BYTES_MAX", "crypto_kdf_blake2b_BYTES_MIN", "crypto_kdf_blake2b_CONTEXTBYTES", "crypto_kdf_blake2b_KEYBYTES", "crypto_kdf_hkdf_sha256_BYTES_MAX", "crypto_kdf_hkdf_sha256_BYTES_MIN", "crypto_kdf_hkdf_sha256_KEYBYTES", "crypto_kdf_hkdf_sha512_BYTES_MAX", "crypto_kdf_hkdf_sha512_BYTES_MIN", "crypto_kdf_hkdf_sha512_KEYBYTES", "crypto_kx_PUBLICKEYBYTES", "crypto_kx_SECRETKEYBYTES", "crypto_kx_SEEDBYTES", "crypto_kx_SESSIONKEYBYTES", "crypto_onetimeauth_BYTES", "crypto_onetimeauth_KEYBYTES", "crypto_onetimeauth_poly1305_BYTES", "crypto_onetimeauth_poly1305_KEYBYTES", "crypto_pwhash_ALG_ARGON2I13", "crypto_pwhash_ALG_ARGON2ID13", "crypto_pwhash_ALG_DEFAULT", "crypto_pwhash_BYTES_MAX", "crypto_pwhash_BYTES_MIN", "crypto_pwhash_MEMLIMIT_INTERACTIVE", "crypto_pwhash_MEMLIMIT_MAX", "crypto_pwhash_MEMLIMIT_MIN", "crypto_pwhash_MEMLIMIT_MODERATE", "crypto_pwhash_MEMLIMIT_SENSITIVE", "crypto_pwhash_OPSLIMIT_INTERACTIVE", "crypto_pwhash_OPSLIMIT_MAX", "crypto_pwhash_OPSLIMIT_MIN", "crypto_pwhash_OPSLIMIT_MODERATE", "crypto_pwhash_OPSLIMIT_SENSITIVE", "crypto_pwhash_PASSWD_MAX", "crypto_pwhash_PASSWD_MIN", "crypto_pwhash_SALTBYTES", "crypto_pwhash_STRBYTES", "crypto_pwhash_argon2i_BYTES_MAX", "crypto_pwhash_argon2i_BYTES_MIN", "crypto_pwhash_argon2i_MEMLIMIT_INTERACTIVE", "crypto_pwhash_argon2i_MEMLIMIT_MAX", "crypto_pwhash_argon2i_MEMLIMIT_MIN", "crypto_pwhash_argon2i_MEMLIMIT_MODERATE", "crypto_pwhash_argon2i_MEMLIMIT_SENSITIVE", "crypto_pwhash_argon2i_OPSLIMIT_INTERACTIVE", "crypto_pwhash_argon2i_OPSLIMIT_MAX", "crypto_pwhash_argon2i_OPSLIMIT_MIN", "crypto_pwhash_argon2i_OPSLIMIT_MODERATE", "crypto_pwhash_argon2i_OPSLIMIT_SENSITIVE", "crypto_pwhash_argon2i_PASSWD_MAX", "crypto_pwhash_argon2i_PASSWD_MIN", "crypto_pwhash_argon2i_SALTBYTES", "crypto_pwhash_argon2i_STRBYTES", "crypto_pwhash_argon2id_BYTES_MAX", "crypto_pwhash_argon2id_BYTES_MIN", "crypto_pwhash_argon2id_MEMLIMIT_INTERACTIVE", "crypto_pwhash_argon2id_MEMLIMIT_MAX", "crypto_pwhash_argon2id_MEMLIMIT_MIN", "crypto_pwhash_argon2id_MEMLIMIT_MODERATE", "crypto_pwhash_argon2id_MEMLIMIT_SENSITIVE", "crypto_pwhash_argon2id_OPSLIMIT_INTERACTIVE", "crypto_pwhash_argon2id_OPSLIMIT_MAX", "crypto_pwhash_argon2id_OPSLIMIT_MIN", "crypto_pwhash_argon2id_OPSLIMIT_MODERATE", "crypto_pwhash_argon2id_OPSLIMIT_SENSITIVE", "crypto_pwhash_argon2id_PASSWD_MAX", "crypto_pwhash_argon2id_PASSWD_MIN", "crypto_pwhash_argon2id_SALTBYTES", "crypto_pwhash_argon2id_STRBYTES", "crypto_pwhash_scryptsalsa208sha256_BYTES_MAX", "crypto_pwhash_scryptsalsa208sha256_BYTES_MIN", "crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_INTERACTIVE", "crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_MAX", "crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_MIN", "crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_SENSITIVE", "crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_INTERACTIVE", "crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_MAX", "crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_MIN", "crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_SENSITIVE", "crypto_pwhash_scryptsalsa208sha256_PASSWD_MAX", "crypto_pwhash_scryptsalsa208sha256_PASSWD_MIN", "crypto_pwhash_scryptsalsa208sha256_SALTBYTES", "crypto_pwhash_scryptsalsa208sha256_STRBYTES", "crypto_scalarmult_BYTES", "crypto_scalarmult_SCALARBYTES", "crypto_scalarmult_curve25519_BYTES", "crypto_scalarmult_curve25519_SCALARBYTES", "crypto_scalarmult_ed25519_BYTES", "crypto_scalarmult_ed25519_SCALARBYTES", "crypto_scalarmult_ristretto255_BYTES", "crypto_scalarmult_ristretto255_SCALARBYTES", "crypto_secretbox_KEYBYTES", "crypto_secretbox_MACBYTES", "crypto_secretbox_MESSAGEBYTES_MAX", "crypto_secretbox_NONCEBYTES", "crypto_secretbox_xchacha20poly1305_KEYBYTES", "crypto_secretbox_xchacha20poly1305_MACBYTES", "crypto_secretbox_xchacha20poly1305_MESSAGEBYTES_MAX", "crypto_secretbox_xchacha20poly1305_NONCEBYTES", "crypto_secretbox_xsalsa20poly1305_KEYBYTES", "crypto_secretbox_xsalsa20poly1305_MACBYTES", "crypto_secretbox_xsalsa20poly1305_MESSAGEBYTES_MAX", "crypto_secretbox_xsalsa20poly1305_NONCEBYTES", "crypto_secretstream_xchacha20poly1305_ABYTES", "crypto_secretstream_xchacha20poly1305_HEADERBYTES", "crypto_secretstream_xchacha20poly1305_KEYBYTES", "crypto_secretstream_xchacha20poly1305_MESSAGEBYTES_MAX", "crypto_secretstream_xchacha20poly1305_TAG_FINAL", "crypto_secretstream_xchacha20poly1305_TAG_MESSAGE", "crypto_secretstream_xchacha20poly1305_TAG_PUSH", "crypto_secretstream_xchacha20poly1305_TAG_REKEY", "crypto_shorthash_BYTES", "crypto_shorthash_KEYBYTES", "crypto_shorthash_siphash24_BYTES", "crypto_shorthash_siphash24_KEYBYTES", "crypto_shorthash_siphashx24_BYTES", "crypto_shorthash_siphashx24_KEYBYTES", "crypto_sign_BYTES", "crypto_sign_MESSAGEBYTES_MAX", "crypto_sign_PUBLICKEYBYTES", "crypto_sign_SECRETKEYBYTES", "crypto_sign_SEEDBYTES", "crypto_sign_ed25519_BYTES", "crypto_sign_ed25519_MESSAGEBYTES_MAX", "crypto_sign_ed25519_PUBLICKEYBYTES", "crypto_sign_ed25519_SECRETKEYBYTES", "crypto_sign_ed25519_SEEDBYTES", "crypto_stream_KEYBYTES", "crypto_stream_MESSAGEBYTES_MAX", "crypto_stream_NONCEBYTES", "crypto_stream_chacha20_IETF_KEYBYTES", "crypto_stream_chacha20_IETF_MESSAGEBYTES_MAX", "crypto_stream_chacha20_IETF_NONCEBYTES", "crypto_stream_chacha20_KEYBYTES", "crypto_stream_chacha20_MESSAGEBYTES_MAX", "crypto_stream_chacha20_NONCEBYTES", "crypto_stream_chacha20_ietf_KEYBYTES", "crypto_stream_chacha20_ietf_MESSAGEBYTES_MAX", "crypto_stream_chacha20_ietf_NONCEBYTES", "crypto_stream_salsa2012_KEYBYTES", "crypto_stream_salsa2012_MESSAGEBYTES_MAX", "crypto_stream_salsa2012_NONCEBYTES", "crypto_stream_salsa208_KEYBYTES", "crypto_stream_salsa208_MESSAGEBYTES_MAX", "crypto_stream_salsa208_NONCEBYTES", "crypto_stream_salsa20_KEYBYTES", "crypto_stream_salsa20_MESSAGEBYTES_MAX", "crypto_stream_salsa20_NONCEBYTES", "crypto_stream_xchacha20_KEYBYTES", "crypto_stream_xchacha20_MESSAGEBYTES_MAX", "crypto_stream_xchacha20_NONCEBYTES", "crypto_stream_xsalsa20_KEYBYTES", "crypto_stream_xsalsa20_MESSAGEBYTES_MAX", "crypto_stream_xsalsa20_NONCEBYTES", "crypto_verify_16_BYTES", "crypto_verify_32_BYTES", "crypto_verify_64_BYTES"];
          for (oo = 0; oo < mo.length; oo++) typeof ($o = b["_" + mo[oo].toLowerCase()]) == "function" && (a[mo[oo]] = $o());
          var ko = ["SODIUM_VERSION_STRING", "crypto_pwhash_STRPREFIX", "crypto_pwhash_argon2i_STRPREFIX", "crypto_pwhash_argon2id_STRPREFIX", "crypto_pwhash_scryptsalsa208sha256_STRPREFIX"];
          for (oo = 0; oo < ko.length; oo++) {
            var $o;
            typeof ($o = b["_" + ko[oo].toLowerCase()]) == "function" && (a[ko[oo]] = b.UTF8ToString($o()));
          }
        }
        b = A;
        try {
          Ai();
          var Bi = new Uint8Array([98, 97, 108, 108, 115]), yi = a.randombytes_buf(a.crypto_secretbox_NONCEBYTES), ii = a.randombytes_buf(a.crypto_secretbox_KEYBYTES), ki = a.crypto_secretbox_easy(Bi, yi, ii), Vi = a.crypto_secretbox_open_easy(ki, yi, ii);
          if (a.memcmp(Bi, Vi)) return;
        } catch (Ki) {
          if (b.useBackupModule == null) throw new Error("Both wasm and asm failed to load" + Ki);
        }
        b.useBackupModule(), Ai();
      });
      function L(Ai) {
        if (typeof TextEncoder == "function") return new TextEncoder().encode(Ai);
        Ai = unescape(encodeURIComponent(Ai));
        for (var Bi = new Uint8Array(Ai.length), yi = 0, ii = Ai.length; yi < ii; yi++) Bi[yi] = Ai.charCodeAt(yi);
        return Bi;
      }
      function pe(Ai) {
        if (typeof TextDecoder == "function") return new TextDecoder("utf-8", { fatal: !0 }).decode(Ai);
        var Bi = 8192, yi = Math.ceil(Ai.length / Bi);
        if (yi <= 1) try {
          return decodeURIComponent(escape(String.fromCharCode.apply(null, Ai)));
        } catch {
          throw new TypeError("The encoded data was not valid.");
        }
        for (var ii = "", ki = 0, Vi = 0; Vi < yi; Vi++) {
          var Ki = Array.prototype.slice.call(Ai, Vi * Bi + ki, (Vi + 1) * Bi + ki);
          if (Ki.length != 0) {
            var Pn, oo = Ki.length, mo = 0;
            do {
              var ko = Ki[--oo];
              ko >= 240 ? (mo = 4, Pn = !0) : ko >= 224 ? (mo = 3, Pn = !0) : ko >= 192 ? (mo = 2, Pn = !0) : ko < 128 && (mo = 1, Pn = !0);
            } while (!Pn);
            for (var $o = mo - (Ki.length - oo), Jo = 0; Jo < $o; Jo++) ki--, Ki.pop();
            ii += pe(Ki);
          }
        }
        return ii;
      }
      function $(Ai) {
        Ai = Fe(null, Ai, "input");
        for (var Bi, yi, ii, ki = "", Vi = 0; Vi < Ai.length; Vi++) ii = 87 + (yi = 15 & Ai[Vi]) + (yi - 10 >> 8 & -39) << 8 | 87 + (Bi = Ai[Vi] >>> 4) + (Bi - 10 >> 8 & -39), ki += String.fromCharCode(255 & ii) + String.fromCharCode(ii >>> 8);
        return ki;
      }
      var Ee = { ORIGINAL: 1, ORIGINAL_NO_PADDING: 3, URLSAFE: 5, URLSAFE_NO_PADDING: 7 };
      function be(Ai) {
        if (Ai == null) return Ee.URLSAFE_NO_PADDING;
        if (Ai !== Ee.ORIGINAL && Ai !== Ee.ORIGINAL_NO_PADDING && Ai !== Ee.URLSAFE && Ai != Ee.URLSAFE_NO_PADDING) throw new Error("unsupported base64 variant");
        return Ai;
      }
      function He(Ai, Bi) {
        Bi = be(Bi), Ai = Fe(ii, Ai, "input");
        var yi, ii = [], ki = 0 | Math.floor(Ai.length / 3), Vi = Ai.length - 3 * ki, Ki = 4 * ki + (Vi !== 0 ? 2 & Bi ? 2 + (Vi >>> 1) : 4 : 0), Pn = new or(Ki + 1), oo = lr(Ai);
        return ii.push(oo), ii.push(Pn.address), b._sodium_bin2base64(Pn.address, Pn.length, oo, Ai.length, Bi) === 0 && kr(ii, "conversion failed"), Pn.length = Ki, yi = pe(Pn.to_Uint8Array()), xr(ii), yi;
      }
      function Pe(Ai, Bi) {
        var yi = Bi || F;
        if (!nr(yi)) throw new Error(yi + " output format is not available");
        if (Ai instanceof or) {
          if (yi === "uint8array") return Ai.to_Uint8Array();
          if (yi === "text") return pe(Ai.to_Uint8Array());
          if (yi === "hex") return $(Ai.to_Uint8Array());
          if (yi === "base64") return He(Ai.to_Uint8Array(), Ee.URLSAFE_NO_PADDING);
          throw new Error('What is output format "' + yi + '"?');
        }
        if (typeof Ai == "object") {
          for (var ii = Object.keys(Ai), ki = {}, Vi = 0; Vi < ii.length; Vi++) ki[ii[Vi]] = Pe(Ai[ii[Vi]], yi);
          return ki;
        }
        if (typeof Ai == "string") return Ai;
        throw new TypeError("Cannot format output");
      }
      function nr(Ai) {
        for (var Bi = ["uint8array", "text", "hex", "base64"], yi = 0; yi < Bi.length; yi++) if (Bi[yi] === Ai) return !0;
        return !1;
      }
      function ir(Ai) {
        if (Ai) {
          if (typeof Ai != "string") throw new TypeError("When defined, the output format must be a string");
          if (!nr(Ai)) throw new Error(Ai + " is not a supported output format");
        }
      }
      function or(Ai) {
        this.length = Ai, this.address = Ir(Ai);
      }
      function lr(Ai) {
        var Bi = Ir(Ai.length);
        return b.HEAPU8.set(Ai, Bi), Bi;
      }
      function Ir(Ai) {
        var Bi = b._malloc(Ai);
        if (Bi === 0) throw { message: "_malloc() failed", length: Ai };
        return Bi;
      }
      function xr(Ai) {
        if (Ai) for (var Bi = 0; Bi < Ai.length; Bi++) yi = Ai[Bi], b._free(yi);
        var yi;
      }
      function kr(Ai, Bi) {
        throw xr(Ai), new Error(Bi);
      }
      function Ce(Ai, Bi) {
        throw xr(Ai), new TypeError(Bi);
      }
      function tr(Ai, Bi, yi) {
        Bi == null && Ce(Ai, yi + " cannot be null or undefined");
      }
      function Fe(Ai, Bi, yi) {
        return tr(Ai, Bi, yi), Bi instanceof Uint8Array ? Bi : typeof Bi == "string" ? L(Bi) : void Ce(Ai, "unsupported input type for " + yi);
      }
      function Sr(Ai, Bi, yi, ii, ki, Vi) {
        var Ki = [];
        ir(Vi);
        var Pn = null;
        Ai != null && (Pn = lr(Ai = Fe(Ki, Ai, "secret_nonce")), Ai.length, Ki.push(Pn)), Bi = Fe(Ki, Bi, "ciphertext");
        var oo, mo = b._crypto_aead_aegis128l_abytes(), ko = Bi.length;
        ko < mo && Ce(Ki, "ciphertext is too short"), oo = lr(Bi), Ki.push(oo);
        var $o = null, Jo = 0;
        yi != null && ($o = lr(yi = Fe(Ki, yi, "additional_data")), Jo = yi.length, Ki.push($o)), ii = Fe(Ki, ii, "public_nonce");
        var hs, Ss = 0 | b._crypto_aead_aegis128l_npubbytes();
        ii.length !== Ss && Ce(Ki, "invalid public_nonce length"), hs = lr(ii), Ki.push(hs), ki = Fe(Ki, ki, "key");
        var Us, Zs = 0 | b._crypto_aead_aegis128l_keybytes();
        ki.length !== Zs && Ce(Ki, "invalid key length"), Us = lr(ki), Ki.push(Us);
        var Ks = new or(ko - b._crypto_aead_aegis128l_abytes() | 0), ha = Ks.address;
        if (Ki.push(ha), b._crypto_aead_aegis128l_decrypt(ha, null, Pn, oo, ko, 0, $o, Jo, 0, hs, Us) === 0) {
          var pa = Pe(Ks, Vi);
          return xr(Ki), pa;
        }
        kr(Ki, "ciphertext cannot be decrypted using that key");
      }
      function er(Ai, Bi, yi, ii, ki, Vi, Ki) {
        var Pn = [];
        ir(Ki);
        var oo = null;
        Ai != null && (oo = lr(Ai = Fe(Pn, Ai, "secret_nonce")), Ai.length, Pn.push(oo));
        var mo = lr(Bi = Fe(Pn, Bi, "ciphertext")), ko = Bi.length;
        Pn.push(mo), yi = Fe(Pn, yi, "mac");
        var $o, Jo = 0 | b._crypto_box_macbytes();
        yi.length !== Jo && Ce(Pn, "invalid mac length"), $o = lr(yi), Pn.push($o);
        var hs = null, Ss = 0;
        ii != null && (hs = lr(ii = Fe(Pn, ii, "additional_data")), Ss = ii.length, Pn.push(hs)), ki = Fe(Pn, ki, "public_nonce");
        var Us, Zs = 0 | b._crypto_aead_aegis128l_npubbytes();
        ki.length !== Zs && Ce(Pn, "invalid public_nonce length"), Us = lr(ki), Pn.push(Us), Vi = Fe(Pn, Vi, "key");
        var Ks, ha = 0 | b._crypto_aead_aegis128l_keybytes();
        Vi.length !== ha && Ce(Pn, "invalid key length"), Ks = lr(Vi), Pn.push(Ks);
        var pa = new or(0 | ko), bi = pa.address;
        if (Pn.push(bi), b._crypto_aead_aegis128l_decrypt_detached(bi, oo, mo, ko, 0, $o, hs, Ss, 0, Us, Ks) === 0) {
          var Ia = Pe(pa, Ki);
          return xr(Pn), Ia;
        }
        kr(Pn, "ciphertext cannot be decrypted using that key");
      }
      function Ie(Ai, Bi, yi, ii, ki, Vi) {
        var Ki = [];
        ir(Vi);
        var Pn = lr(Ai = Fe(Ki, Ai, "message")), oo = Ai.length;
        Ki.push(Pn);
        var mo = null, ko = 0;
        Bi != null && (mo = lr(Bi = Fe(Ki, Bi, "additional_data")), ko = Bi.length, Ki.push(mo));
        var $o = null;
        yi != null && ($o = lr(yi = Fe(Ki, yi, "secret_nonce")), yi.length, Ki.push($o)), ii = Fe(Ki, ii, "public_nonce");
        var Jo, hs = 0 | b._crypto_aead_aegis128l_npubbytes();
        ii.length !== hs && Ce(Ki, "invalid public_nonce length"), Jo = lr(ii), Ki.push(Jo), ki = Fe(Ki, ki, "key");
        var Ss, Us = 0 | b._crypto_aead_aegis128l_keybytes();
        ki.length !== Us && Ce(Ki, "invalid key length"), Ss = lr(ki), Ki.push(Ss);
        var Zs = new or(oo + b._crypto_aead_aegis128l_abytes() | 0), Ks = Zs.address;
        if (Ki.push(Ks), b._crypto_aead_aegis128l_encrypt(Ks, null, Pn, oo, 0, mo, ko, 0, $o, Jo, Ss) === 0) {
          var ha = Pe(Zs, Vi);
          return xr(Ki), ha;
        }
        kr(Ki, "invalid usage");
      }
      function xe(Ai, Bi, yi, ii, ki, Vi) {
        var Ki = [];
        ir(Vi);
        var Pn = lr(Ai = Fe(Ki, Ai, "message")), oo = Ai.length;
        Ki.push(Pn);
        var mo = null, ko = 0;
        Bi != null && (mo = lr(Bi = Fe(Ki, Bi, "additional_data")), ko = Bi.length, Ki.push(mo));
        var $o = null;
        yi != null && ($o = lr(yi = Fe(Ki, yi, "secret_nonce")), yi.length, Ki.push($o)), ii = Fe(Ki, ii, "public_nonce");
        var Jo, hs = 0 | b._crypto_aead_aegis128l_npubbytes();
        ii.length !== hs && Ce(Ki, "invalid public_nonce length"), Jo = lr(ii), Ki.push(Jo), ki = Fe(Ki, ki, "key");
        var Ss, Us = 0 | b._crypto_aead_aegis128l_keybytes();
        ki.length !== Us && Ce(Ki, "invalid key length"), Ss = lr(ki), Ki.push(Ss);
        var Zs = new or(0 | oo), Ks = Zs.address;
        Ki.push(Ks);
        var ha = new or(0 | b._crypto_aead_aegis128l_abytes()), pa = ha.address;
        if (Ki.push(pa), b._crypto_aead_aegis128l_encrypt_detached(Ks, pa, null, Pn, oo, 0, mo, ko, 0, $o, Jo, Ss) === 0) {
          var bi = Pe({ ciphertext: Zs, mac: ha }, Vi);
          return xr(Ki), bi;
        }
        kr(Ki, "invalid usage");
      }
      function rr(Ai) {
        var Bi = [];
        ir(Ai);
        var yi = new or(0 | b._crypto_aead_aegis128l_keybytes()), ii = yi.address;
        Bi.push(ii), b._crypto_aead_aegis128l_keygen(ii);
        var ki = Pe(yi, Ai);
        return xr(Bi), ki;
      }
      function ar(Ai, Bi, yi, ii, ki, Vi) {
        var Ki = [];
        ir(Vi);
        var Pn = null;
        Ai != null && (Pn = lr(Ai = Fe(Ki, Ai, "secret_nonce")), Ai.length, Ki.push(Pn)), Bi = Fe(Ki, Bi, "ciphertext");
        var oo, mo = b._crypto_aead_aegis256_abytes(), ko = Bi.length;
        ko < mo && Ce(Ki, "ciphertext is too short"), oo = lr(Bi), Ki.push(oo);
        var $o = null, Jo = 0;
        yi != null && ($o = lr(yi = Fe(Ki, yi, "additional_data")), Jo = yi.length, Ki.push($o)), ii = Fe(Ki, ii, "public_nonce");
        var hs, Ss = 0 | b._crypto_aead_aegis256_npubbytes();
        ii.length !== Ss && Ce(Ki, "invalid public_nonce length"), hs = lr(ii), Ki.push(hs), ki = Fe(Ki, ki, "key");
        var Us, Zs = 0 | b._crypto_aead_aegis256_keybytes();
        ki.length !== Zs && Ce(Ki, "invalid key length"), Us = lr(ki), Ki.push(Us);
        var Ks = new or(ko - b._crypto_aead_aegis256_abytes() | 0), ha = Ks.address;
        if (Ki.push(ha), b._crypto_aead_aegis256_decrypt(ha, null, Pn, oo, ko, 0, $o, Jo, 0, hs, Us) === 0) {
          var pa = Pe(Ks, Vi);
          return xr(Ki), pa;
        }
        kr(Ki, "ciphertext cannot be decrypted using that key");
      }
      function yr(Ai, Bi, yi, ii, ki, Vi, Ki) {
        var Pn = [];
        ir(Ki);
        var oo = null;
        Ai != null && (oo = lr(Ai = Fe(Pn, Ai, "secret_nonce")), Ai.length, Pn.push(oo));
        var mo = lr(Bi = Fe(Pn, Bi, "ciphertext")), ko = Bi.length;
        Pn.push(mo), yi = Fe(Pn, yi, "mac");
        var $o, Jo = 0 | b._crypto_box_macbytes();
        yi.length !== Jo && Ce(Pn, "invalid mac length"), $o = lr(yi), Pn.push($o);
        var hs = null, Ss = 0;
        ii != null && (hs = lr(ii = Fe(Pn, ii, "additional_data")), Ss = ii.length, Pn.push(hs)), ki = Fe(Pn, ki, "public_nonce");
        var Us, Zs = 0 | b._crypto_aead_aegis256_npubbytes();
        ki.length !== Zs && Ce(Pn, "invalid public_nonce length"), Us = lr(ki), Pn.push(Us), Vi = Fe(Pn, Vi, "key");
        var Ks, ha = 0 | b._crypto_aead_aegis256_keybytes();
        Vi.length !== ha && Ce(Pn, "invalid key length"), Ks = lr(Vi), Pn.push(Ks);
        var pa = new or(0 | ko), bi = pa.address;
        if (Pn.push(bi), b._crypto_aead_aegis256_decrypt_detached(bi, oo, mo, ko, 0, $o, hs, Ss, 0, Us, Ks) === 0) {
          var Ia = Pe(pa, Ki);
          return xr(Pn), Ia;
        }
        kr(Pn, "ciphertext cannot be decrypted using that key");
      }
      function _r(Ai, Bi, yi, ii, ki, Vi) {
        var Ki = [];
        ir(Vi);
        var Pn = lr(Ai = Fe(Ki, Ai, "message")), oo = Ai.length;
        Ki.push(Pn);
        var mo = null, ko = 0;
        Bi != null && (mo = lr(Bi = Fe(Ki, Bi, "additional_data")), ko = Bi.length, Ki.push(mo));
        var $o = null;
        yi != null && ($o = lr(yi = Fe(Ki, yi, "secret_nonce")), yi.length, Ki.push($o)), ii = Fe(Ki, ii, "public_nonce");
        var Jo, hs = 0 | b._crypto_aead_aegis256_npubbytes();
        ii.length !== hs && Ce(Ki, "invalid public_nonce length"), Jo = lr(ii), Ki.push(Jo), ki = Fe(Ki, ki, "key");
        var Ss, Us = 0 | b._crypto_aead_aegis256_keybytes();
        ki.length !== Us && Ce(Ki, "invalid key length"), Ss = lr(ki), Ki.push(Ss);
        var Zs = new or(oo + b._crypto_aead_aegis256_abytes() | 0), Ks = Zs.address;
        if (Ki.push(Ks), b._crypto_aead_aegis256_encrypt(Ks, null, Pn, oo, 0, mo, ko, 0, $o, Jo, Ss) === 0) {
          var ha = Pe(Zs, Vi);
          return xr(Ki), ha;
        }
        kr(Ki, "invalid usage");
      }
      function Or(Ai, Bi, yi, ii, ki, Vi) {
        var Ki = [];
        ir(Vi);
        var Pn = lr(Ai = Fe(Ki, Ai, "message")), oo = Ai.length;
        Ki.push(Pn);
        var mo = null, ko = 0;
        Bi != null && (mo = lr(Bi = Fe(Ki, Bi, "additional_data")), ko = Bi.length, Ki.push(mo));
        var $o = null;
        yi != null && ($o = lr(yi = Fe(Ki, yi, "secret_nonce")), yi.length, Ki.push($o)), ii = Fe(Ki, ii, "public_nonce");
        var Jo, hs = 0 | b._crypto_aead_aegis256_npubbytes();
        ii.length !== hs && Ce(Ki, "invalid public_nonce length"), Jo = lr(ii), Ki.push(Jo), ki = Fe(Ki, ki, "key");
        var Ss, Us = 0 | b._crypto_aead_aegis256_keybytes();
        ki.length !== Us && Ce(Ki, "invalid key length"), Ss = lr(ki), Ki.push(Ss);
        var Zs = new or(0 | oo), Ks = Zs.address;
        Ki.push(Ks);
        var ha = new or(0 | b._crypto_aead_aegis256_abytes()), pa = ha.address;
        if (Ki.push(pa), b._crypto_aead_aegis256_encrypt_detached(Ks, pa, null, Pn, oo, 0, mo, ko, 0, $o, Jo, Ss) === 0) {
          var bi = Pe({ ciphertext: Zs, mac: ha }, Vi);
          return xr(Ki), bi;
        }
        kr(Ki, "invalid usage");
      }
      function vr(Ai) {
        var Bi = [];
        ir(Ai);
        var yi = new or(0 | b._crypto_aead_aegis256_keybytes()), ii = yi.address;
        Bi.push(ii), b._crypto_aead_aegis256_keygen(ii);
        var ki = Pe(yi, Ai);
        return xr(Bi), ki;
      }
      function Te(Ai, Bi, yi, ii, ki, Vi) {
        var Ki = [];
        ir(Vi);
        var Pn = null;
        Ai != null && (Pn = lr(Ai = Fe(Ki, Ai, "secret_nonce")), Ai.length, Ki.push(Pn)), Bi = Fe(Ki, Bi, "ciphertext");
        var oo, mo = b._crypto_aead_chacha20poly1305_abytes(), ko = Bi.length;
        ko < mo && Ce(Ki, "ciphertext is too short"), oo = lr(Bi), Ki.push(oo);
        var $o = null, Jo = 0;
        yi != null && ($o = lr(yi = Fe(Ki, yi, "additional_data")), Jo = yi.length, Ki.push($o)), ii = Fe(Ki, ii, "public_nonce");
        var hs, Ss = 0 | b._crypto_aead_chacha20poly1305_npubbytes();
        ii.length !== Ss && Ce(Ki, "invalid public_nonce length"), hs = lr(ii), Ki.push(hs), ki = Fe(Ki, ki, "key");
        var Us, Zs = 0 | b._crypto_aead_chacha20poly1305_keybytes();
        ki.length !== Zs && Ce(Ki, "invalid key length"), Us = lr(ki), Ki.push(Us);
        var Ks = new or(ko - b._crypto_aead_chacha20poly1305_abytes() | 0), ha = Ks.address;
        if (Ki.push(ha), b._crypto_aead_chacha20poly1305_decrypt(ha, null, Pn, oo, ko, 0, $o, Jo, 0, hs, Us) === 0) {
          var pa = Pe(Ks, Vi);
          return xr(Ki), pa;
        }
        kr(Ki, "ciphertext cannot be decrypted using that key");
      }
      function Cr(Ai, Bi, yi, ii, ki, Vi, Ki) {
        var Pn = [];
        ir(Ki);
        var oo = null;
        Ai != null && (oo = lr(Ai = Fe(Pn, Ai, "secret_nonce")), Ai.length, Pn.push(oo));
        var mo = lr(Bi = Fe(Pn, Bi, "ciphertext")), ko = Bi.length;
        Pn.push(mo), yi = Fe(Pn, yi, "mac");
        var $o, Jo = 0 | b._crypto_box_macbytes();
        yi.length !== Jo && Ce(Pn, "invalid mac length"), $o = lr(yi), Pn.push($o);
        var hs = null, Ss = 0;
        ii != null && (hs = lr(ii = Fe(Pn, ii, "additional_data")), Ss = ii.length, Pn.push(hs)), ki = Fe(Pn, ki, "public_nonce");
        var Us, Zs = 0 | b._crypto_aead_chacha20poly1305_npubbytes();
        ki.length !== Zs && Ce(Pn, "invalid public_nonce length"), Us = lr(ki), Pn.push(Us), Vi = Fe(Pn, Vi, "key");
        var Ks, ha = 0 | b._crypto_aead_chacha20poly1305_keybytes();
        Vi.length !== ha && Ce(Pn, "invalid key length"), Ks = lr(Vi), Pn.push(Ks);
        var pa = new or(0 | ko), bi = pa.address;
        if (Pn.push(bi), b._crypto_aead_chacha20poly1305_decrypt_detached(bi, oo, mo, ko, 0, $o, hs, Ss, 0, Us, Ks) === 0) {
          var Ia = Pe(pa, Ki);
          return xr(Pn), Ia;
        }
        kr(Pn, "ciphertext cannot be decrypted using that key");
      }
      function Hr(Ai, Bi, yi, ii, ki, Vi) {
        var Ki = [];
        ir(Vi);
        var Pn = lr(Ai = Fe(Ki, Ai, "message")), oo = Ai.length;
        Ki.push(Pn);
        var mo = null, ko = 0;
        Bi != null && (mo = lr(Bi = Fe(Ki, Bi, "additional_data")), ko = Bi.length, Ki.push(mo));
        var $o = null;
        yi != null && ($o = lr(yi = Fe(Ki, yi, "secret_nonce")), yi.length, Ki.push($o)), ii = Fe(Ki, ii, "public_nonce");
        var Jo, hs = 0 | b._crypto_aead_chacha20poly1305_npubbytes();
        ii.length !== hs && Ce(Ki, "invalid public_nonce length"), Jo = lr(ii), Ki.push(Jo), ki = Fe(Ki, ki, "key");
        var Ss, Us = 0 | b._crypto_aead_chacha20poly1305_keybytes();
        ki.length !== Us && Ce(Ki, "invalid key length"), Ss = lr(ki), Ki.push(Ss);
        var Zs = new or(oo + b._crypto_aead_chacha20poly1305_abytes() | 0), Ks = Zs.address;
        if (Ki.push(Ks), b._crypto_aead_chacha20poly1305_encrypt(Ks, null, Pn, oo, 0, mo, ko, 0, $o, Jo, Ss) === 0) {
          var ha = Pe(Zs, Vi);
          return xr(Ki), ha;
        }
        kr(Ki, "invalid usage");
      }
      function si(Ai, Bi, yi, ii, ki, Vi) {
        var Ki = [];
        ir(Vi);
        var Pn = lr(Ai = Fe(Ki, Ai, "message")), oo = Ai.length;
        Ki.push(Pn);
        var mo = null, ko = 0;
        Bi != null && (mo = lr(Bi = Fe(Ki, Bi, "additional_data")), ko = Bi.length, Ki.push(mo));
        var $o = null;
        yi != null && ($o = lr(yi = Fe(Ki, yi, "secret_nonce")), yi.length, Ki.push($o)), ii = Fe(Ki, ii, "public_nonce");
        var Jo, hs = 0 | b._crypto_aead_chacha20poly1305_npubbytes();
        ii.length !== hs && Ce(Ki, "invalid public_nonce length"), Jo = lr(ii), Ki.push(Jo), ki = Fe(Ki, ki, "key");
        var Ss, Us = 0 | b._crypto_aead_chacha20poly1305_keybytes();
        ki.length !== Us && Ce(Ki, "invalid key length"), Ss = lr(ki), Ki.push(Ss);
        var Zs = new or(0 | oo), Ks = Zs.address;
        Ki.push(Ks);
        var ha = new or(0 | b._crypto_aead_chacha20poly1305_abytes()), pa = ha.address;
        if (Ki.push(pa), b._crypto_aead_chacha20poly1305_encrypt_detached(Ks, pa, null, Pn, oo, 0, mo, ko, 0, $o, Jo, Ss) === 0) {
          var bi = Pe({ ciphertext: Zs, mac: ha }, Vi);
          return xr(Ki), bi;
        }
        kr(Ki, "invalid usage");
      }
      function ui(Ai, Bi, yi, ii, ki, Vi) {
        var Ki = [];
        ir(Vi);
        var Pn = null;
        Ai != null && (Pn = lr(Ai = Fe(Ki, Ai, "secret_nonce")), Ai.length, Ki.push(Pn)), Bi = Fe(Ki, Bi, "ciphertext");
        var oo, mo = b._crypto_aead_chacha20poly1305_ietf_abytes(), ko = Bi.length;
        ko < mo && Ce(Ki, "ciphertext is too short"), oo = lr(Bi), Ki.push(oo);
        var $o = null, Jo = 0;
        yi != null && ($o = lr(yi = Fe(Ki, yi, "additional_data")), Jo = yi.length, Ki.push($o)), ii = Fe(Ki, ii, "public_nonce");
        var hs, Ss = 0 | b._crypto_aead_chacha20poly1305_ietf_npubbytes();
        ii.length !== Ss && Ce(Ki, "invalid public_nonce length"), hs = lr(ii), Ki.push(hs), ki = Fe(Ki, ki, "key");
        var Us, Zs = 0 | b._crypto_aead_chacha20poly1305_ietf_keybytes();
        ki.length !== Zs && Ce(Ki, "invalid key length"), Us = lr(ki), Ki.push(Us);
        var Ks = new or(ko - b._crypto_aead_chacha20poly1305_ietf_abytes() | 0), ha = Ks.address;
        if (Ki.push(ha), b._crypto_aead_chacha20poly1305_ietf_decrypt(ha, null, Pn, oo, ko, 0, $o, Jo, 0, hs, Us) === 0) {
          var pa = Pe(Ks, Vi);
          return xr(Ki), pa;
        }
        kr(Ki, "ciphertext cannot be decrypted using that key");
      }
      function Li(Ai, Bi, yi, ii, ki, Vi, Ki) {
        var Pn = [];
        ir(Ki);
        var oo = null;
        Ai != null && (oo = lr(Ai = Fe(Pn, Ai, "secret_nonce")), Ai.length, Pn.push(oo));
        var mo = lr(Bi = Fe(Pn, Bi, "ciphertext")), ko = Bi.length;
        Pn.push(mo), yi = Fe(Pn, yi, "mac");
        var $o, Jo = 0 | b._crypto_box_macbytes();
        yi.length !== Jo && Ce(Pn, "invalid mac length"), $o = lr(yi), Pn.push($o);
        var hs = null, Ss = 0;
        ii != null && (hs = lr(ii = Fe(Pn, ii, "additional_data")), Ss = ii.length, Pn.push(hs)), ki = Fe(Pn, ki, "public_nonce");
        var Us, Zs = 0 | b._crypto_aead_chacha20poly1305_ietf_npubbytes();
        ki.length !== Zs && Ce(Pn, "invalid public_nonce length"), Us = lr(ki), Pn.push(Us), Vi = Fe(Pn, Vi, "key");
        var Ks, ha = 0 | b._crypto_aead_chacha20poly1305_ietf_keybytes();
        Vi.length !== ha && Ce(Pn, "invalid key length"), Ks = lr(Vi), Pn.push(Ks);
        var pa = new or(0 | ko), bi = pa.address;
        if (Pn.push(bi), b._crypto_aead_chacha20poly1305_ietf_decrypt_detached(bi, oo, mo, ko, 0, $o, hs, Ss, 0, Us, Ks) === 0) {
          var Ia = Pe(pa, Ki);
          return xr(Pn), Ia;
        }
        kr(Pn, "ciphertext cannot be decrypted using that key");
      }
      function Qi(Ai, Bi, yi, ii, ki, Vi) {
        var Ki = [];
        ir(Vi);
        var Pn = lr(Ai = Fe(Ki, Ai, "message")), oo = Ai.length;
        Ki.push(Pn);
        var mo = null, ko = 0;
        Bi != null && (mo = lr(Bi = Fe(Ki, Bi, "additional_data")), ko = Bi.length, Ki.push(mo));
        var $o = null;
        yi != null && ($o = lr(yi = Fe(Ki, yi, "secret_nonce")), yi.length, Ki.push($o)), ii = Fe(Ki, ii, "public_nonce");
        var Jo, hs = 0 | b._crypto_aead_chacha20poly1305_ietf_npubbytes();
        ii.length !== hs && Ce(Ki, "invalid public_nonce length"), Jo = lr(ii), Ki.push(Jo), ki = Fe(Ki, ki, "key");
        var Ss, Us = 0 | b._crypto_aead_chacha20poly1305_ietf_keybytes();
        ki.length !== Us && Ce(Ki, "invalid key length"), Ss = lr(ki), Ki.push(Ss);
        var Zs = new or(oo + b._crypto_aead_chacha20poly1305_ietf_abytes() | 0), Ks = Zs.address;
        if (Ki.push(Ks), b._crypto_aead_chacha20poly1305_ietf_encrypt(Ks, null, Pn, oo, 0, mo, ko, 0, $o, Jo, Ss) === 0) {
          var ha = Pe(Zs, Vi);
          return xr(Ki), ha;
        }
        kr(Ki, "invalid usage");
      }
      function wi(Ai, Bi, yi, ii, ki, Vi) {
        var Ki = [];
        ir(Vi);
        var Pn = lr(Ai = Fe(Ki, Ai, "message")), oo = Ai.length;
        Ki.push(Pn);
        var mo = null, ko = 0;
        Bi != null && (mo = lr(Bi = Fe(Ki, Bi, "additional_data")), ko = Bi.length, Ki.push(mo));
        var $o = null;
        yi != null && ($o = lr(yi = Fe(Ki, yi, "secret_nonce")), yi.length, Ki.push($o)), ii = Fe(Ki, ii, "public_nonce");
        var Jo, hs = 0 | b._crypto_aead_chacha20poly1305_ietf_npubbytes();
        ii.length !== hs && Ce(Ki, "invalid public_nonce length"), Jo = lr(ii), Ki.push(Jo), ki = Fe(Ki, ki, "key");
        var Ss, Us = 0 | b._crypto_aead_chacha20poly1305_ietf_keybytes();
        ki.length !== Us && Ce(Ki, "invalid key length"), Ss = lr(ki), Ki.push(Ss);
        var Zs = new or(0 | oo), Ks = Zs.address;
        Ki.push(Ks);
        var ha = new or(0 | b._crypto_aead_chacha20poly1305_ietf_abytes()), pa = ha.address;
        if (Ki.push(pa), b._crypto_aead_chacha20poly1305_ietf_encrypt_detached(Ks, pa, null, Pn, oo, 0, mo, ko, 0, $o, Jo, Ss) === 0) {
          var bi = Pe({ ciphertext: Zs, mac: ha }, Vi);
          return xr(Ki), bi;
        }
        kr(Ki, "invalid usage");
      }
      function Ji(Ai) {
        var Bi = [];
        ir(Ai);
        var yi = new or(0 | b._crypto_aead_chacha20poly1305_ietf_keybytes()), ii = yi.address;
        Bi.push(ii), b._crypto_aead_chacha20poly1305_ietf_keygen(ii);
        var ki = Pe(yi, Ai);
        return xr(Bi), ki;
      }
      function mn(Ai) {
        var Bi = [];
        ir(Ai);
        var yi = new or(0 | b._crypto_aead_chacha20poly1305_keybytes()), ii = yi.address;
        Bi.push(ii), b._crypto_aead_chacha20poly1305_keygen(ii);
        var ki = Pe(yi, Ai);
        return xr(Bi), ki;
      }
      function pi(Ai, Bi, yi, ii, ki, Vi) {
        var Ki = [];
        ir(Vi);
        var Pn = null;
        Ai != null && (Pn = lr(Ai = Fe(Ki, Ai, "secret_nonce")), Ai.length, Ki.push(Pn)), Bi = Fe(Ki, Bi, "ciphertext");
        var oo, mo = b._crypto_aead_xchacha20poly1305_ietf_abytes(), ko = Bi.length;
        ko < mo && Ce(Ki, "ciphertext is too short"), oo = lr(Bi), Ki.push(oo);
        var $o = null, Jo = 0;
        yi != null && ($o = lr(yi = Fe(Ki, yi, "additional_data")), Jo = yi.length, Ki.push($o)), ii = Fe(Ki, ii, "public_nonce");
        var hs, Ss = 0 | b._crypto_aead_xchacha20poly1305_ietf_npubbytes();
        ii.length !== Ss && Ce(Ki, "invalid public_nonce length"), hs = lr(ii), Ki.push(hs), ki = Fe(Ki, ki, "key");
        var Us, Zs = 0 | b._crypto_aead_xchacha20poly1305_ietf_keybytes();
        ki.length !== Zs && Ce(Ki, "invalid key length"), Us = lr(ki), Ki.push(Us);
        var Ks = new or(ko - b._crypto_aead_xchacha20poly1305_ietf_abytes() | 0), ha = Ks.address;
        if (Ki.push(ha), b._crypto_aead_xchacha20poly1305_ietf_decrypt(ha, null, Pn, oo, ko, 0, $o, Jo, 0, hs, Us) === 0) {
          var pa = Pe(Ks, Vi);
          return xr(Ki), pa;
        }
        kr(Ki, "ciphertext cannot be decrypted using that key");
      }
      function ei(Ai, Bi, yi, ii, ki, Vi, Ki) {
        var Pn = [];
        ir(Ki);
        var oo = null;
        Ai != null && (oo = lr(Ai = Fe(Pn, Ai, "secret_nonce")), Ai.length, Pn.push(oo));
        var mo = lr(Bi = Fe(Pn, Bi, "ciphertext")), ko = Bi.length;
        Pn.push(mo), yi = Fe(Pn, yi, "mac");
        var $o, Jo = 0 | b._crypto_box_macbytes();
        yi.length !== Jo && Ce(Pn, "invalid mac length"), $o = lr(yi), Pn.push($o);
        var hs = null, Ss = 0;
        ii != null && (hs = lr(ii = Fe(Pn, ii, "additional_data")), Ss = ii.length, Pn.push(hs)), ki = Fe(Pn, ki, "public_nonce");
        var Us, Zs = 0 | b._crypto_aead_xchacha20poly1305_ietf_npubbytes();
        ki.length !== Zs && Ce(Pn, "invalid public_nonce length"), Us = lr(ki), Pn.push(Us), Vi = Fe(Pn, Vi, "key");
        var Ks, ha = 0 | b._crypto_aead_xchacha20poly1305_ietf_keybytes();
        Vi.length !== ha && Ce(Pn, "invalid key length"), Ks = lr(Vi), Pn.push(Ks);
        var pa = new or(0 | ko), bi = pa.address;
        if (Pn.push(bi), b._crypto_aead_xchacha20poly1305_ietf_decrypt_detached(bi, oo, mo, ko, 0, $o, hs, Ss, 0, Us, Ks) === 0) {
          var Ia = Pe(pa, Ki);
          return xr(Pn), Ia;
        }
        kr(Pn, "ciphertext cannot be decrypted using that key");
      }
      function Vr(Ai, Bi, yi, ii, ki, Vi) {
        var Ki = [];
        ir(Vi);
        var Pn = lr(Ai = Fe(Ki, Ai, "message")), oo = Ai.length;
        Ki.push(Pn);
        var mo = null, ko = 0;
        Bi != null && (mo = lr(Bi = Fe(Ki, Bi, "additional_data")), ko = Bi.length, Ki.push(mo));
        var $o = null;
        yi != null && ($o = lr(yi = Fe(Ki, yi, "secret_nonce")), yi.length, Ki.push($o)), ii = Fe(Ki, ii, "public_nonce");
        var Jo, hs = 0 | b._crypto_aead_xchacha20poly1305_ietf_npubbytes();
        ii.length !== hs && Ce(Ki, "invalid public_nonce length"), Jo = lr(ii), Ki.push(Jo), ki = Fe(Ki, ki, "key");
        var Ss, Us = 0 | b._crypto_aead_xchacha20poly1305_ietf_keybytes();
        ki.length !== Us && Ce(Ki, "invalid key length"), Ss = lr(ki), Ki.push(Ss);
        var Zs = new or(oo + b._crypto_aead_xchacha20poly1305_ietf_abytes() | 0), Ks = Zs.address;
        if (Ki.push(Ks), b._crypto_aead_xchacha20poly1305_ietf_encrypt(Ks, null, Pn, oo, 0, mo, ko, 0, $o, Jo, Ss) === 0) {
          var ha = Pe(Zs, Vi);
          return xr(Ki), ha;
        }
        kr(Ki, "invalid usage");
      }
      function qr(Ai, Bi, yi, ii, ki, Vi) {
        var Ki = [];
        ir(Vi);
        var Pn = lr(Ai = Fe(Ki, Ai, "message")), oo = Ai.length;
        Ki.push(Pn);
        var mo = null, ko = 0;
        Bi != null && (mo = lr(Bi = Fe(Ki, Bi, "additional_data")), ko = Bi.length, Ki.push(mo));
        var $o = null;
        yi != null && ($o = lr(yi = Fe(Ki, yi, "secret_nonce")), yi.length, Ki.push($o)), ii = Fe(Ki, ii, "public_nonce");
        var Jo, hs = 0 | b._crypto_aead_xchacha20poly1305_ietf_npubbytes();
        ii.length !== hs && Ce(Ki, "invalid public_nonce length"), Jo = lr(ii), Ki.push(Jo), ki = Fe(Ki, ki, "key");
        var Ss, Us = 0 | b._crypto_aead_xchacha20poly1305_ietf_keybytes();
        ki.length !== Us && Ce(Ki, "invalid key length"), Ss = lr(ki), Ki.push(Ss);
        var Zs = new or(0 | oo), Ks = Zs.address;
        Ki.push(Ks);
        var ha = new or(0 | b._crypto_aead_xchacha20poly1305_ietf_abytes()), pa = ha.address;
        if (Ki.push(pa), b._crypto_aead_xchacha20poly1305_ietf_encrypt_detached(Ks, pa, null, Pn, oo, 0, mo, ko, 0, $o, Jo, Ss) === 0) {
          var bi = Pe({ ciphertext: Zs, mac: ha }, Vi);
          return xr(Ki), bi;
        }
        kr(Ki, "invalid usage");
      }
      function Zi(Ai) {
        var Bi = [];
        ir(Ai);
        var yi = new or(0 | b._crypto_aead_xchacha20poly1305_ietf_keybytes()), ii = yi.address;
        Bi.push(ii), b._crypto_aead_xchacha20poly1305_ietf_keygen(ii);
        var ki = Pe(yi, Ai);
        return xr(Bi), ki;
      }
      function Wr(Ai, Bi, yi) {
        var ii = [];
        ir(yi);
        var ki = lr(Ai = Fe(ii, Ai, "message")), Vi = Ai.length;
        ii.push(ki), Bi = Fe(ii, Bi, "key");
        var Ki, Pn = 0 | b._crypto_auth_keybytes();
        Bi.length !== Pn && Ce(ii, "invalid key length"), Ki = lr(Bi), ii.push(Ki);
        var oo = new or(0 | b._crypto_auth_bytes()), mo = oo.address;
        if (ii.push(mo), !(0 | b._crypto_auth(mo, ki, Vi, 0, Ki))) {
          var ko = Pe(oo, yi);
          return xr(ii), ko;
        }
        kr(ii, "invalid usage");
      }
      function ri(Ai, Bi, yi) {
        var ii = [];
        ir(yi);
        var ki = lr(Ai = Fe(ii, Ai, "message")), Vi = Ai.length;
        ii.push(ki), Bi = Fe(ii, Bi, "key");
        var Ki, Pn = 0 | b._crypto_auth_hmacsha256_keybytes();
        Bi.length !== Pn && Ce(ii, "invalid key length"), Ki = lr(Bi), ii.push(Ki);
        var oo = new or(0 | b._crypto_auth_hmacsha256_bytes()), mo = oo.address;
        if (ii.push(mo), !(0 | b._crypto_auth_hmacsha256(mo, ki, Vi, 0, Ki))) {
          var ko = Pe(oo, yi);
          return xr(ii), ko;
        }
        kr(ii, "invalid usage");
      }
      function _i(Ai, Bi) {
        var yi = [];
        ir(Bi), tr(yi, Ai, "state_address");
        var ii = new or(0 | b._crypto_auth_hmacsha256_bytes()), ki = ii.address;
        if (yi.push(ki), !(0 | b._crypto_auth_hmacsha256_final(Ai, ki))) {
          var Vi = (b._free(Ai), Pe(ii, Bi));
          return xr(yi), Vi;
        }
        kr(yi, "invalid usage");
      }
      function Er(Ai, Bi) {
        var yi = [];
        ir(Bi);
        var ii = null, ki = 0;
        Ai != null && (ii = lr(Ai = Fe(yi, Ai, "key")), ki = Ai.length, yi.push(ii));
        var Vi = new or(208).address;
        if (!(0 | b._crypto_auth_hmacsha256_init(Vi, ii, ki))) {
          var Ki = Vi;
          return xr(yi), Ki;
        }
        kr(yi, "invalid usage");
      }
      function Di(Ai) {
        var Bi = [];
        ir(Ai);
        var yi = new or(0 | b._crypto_auth_hmacsha256_keybytes()), ii = yi.address;
        Bi.push(ii), b._crypto_auth_hmacsha256_keygen(ii);
        var ki = Pe(yi, Ai);
        return xr(Bi), ki;
      }
      function _n(Ai, Bi, yi) {
        var ii = [];
        ir(yi), tr(ii, Ai, "state_address");
        var ki = lr(Bi = Fe(ii, Bi, "message_chunk")), Vi = Bi.length;
        ii.push(ki), 0 | b._crypto_auth_hmacsha256_update(Ai, ki, Vi) && kr(ii, "invalid usage"), xr(ii);
      }
      function On(Ai, Bi, yi) {
        var ii = [];
        Ai = Fe(ii, Ai, "tag");
        var ki, Vi = 0 | b._crypto_auth_hmacsha256_bytes();
        Ai.length !== Vi && Ce(ii, "invalid tag length"), ki = lr(Ai), ii.push(ki);
        var Ki = lr(Bi = Fe(ii, Bi, "message")), Pn = Bi.length;
        ii.push(Ki), yi = Fe(ii, yi, "key");
        var oo, mo = 0 | b._crypto_auth_hmacsha256_keybytes();
        yi.length !== mo && Ce(ii, "invalid key length"), oo = lr(yi), ii.push(oo);
        var ko = !(0 | b._crypto_auth_hmacsha256_verify(ki, Ki, Pn, 0, oo));
        return xr(ii), ko;
      }
      function so(Ai, Bi, yi) {
        var ii = [];
        ir(yi);
        var ki = lr(Ai = Fe(ii, Ai, "message")), Vi = Ai.length;
        ii.push(ki), Bi = Fe(ii, Bi, "key");
        var Ki, Pn = 0 | b._crypto_auth_hmacsha512_keybytes();
        Bi.length !== Pn && Ce(ii, "invalid key length"), Ki = lr(Bi), ii.push(Ki);
        var oo = new or(0 | b._crypto_auth_hmacsha512_bytes()), mo = oo.address;
        if (ii.push(mo), !(0 | b._crypto_auth_hmacsha512(mo, ki, Vi, 0, Ki))) {
          var ko = Pe(oo, yi);
          return xr(ii), ko;
        }
        kr(ii, "invalid usage");
      }
      function Do(Ai, Bi, yi) {
        var ii = [];
        ir(yi);
        var ki = lr(Ai = Fe(ii, Ai, "message")), Vi = Ai.length;
        ii.push(ki), Bi = Fe(ii, Bi, "key");
        var Ki, Pn = 0 | b._crypto_auth_hmacsha512256_keybytes();
        Bi.length !== Pn && Ce(ii, "invalid key length"), Ki = lr(Bi), ii.push(Ki);
        var oo = new or(0 | b._crypto_auth_hmacsha512256_bytes()), mo = oo.address;
        if (ii.push(mo), !(0 | b._crypto_auth_hmacsha512256(mo, ki, Vi, 0, Ki))) {
          var ko = Pe(oo, yi);
          return xr(ii), ko;
        }
        kr(ii, "invalid usage");
      }
      function gn(Ai, Bi) {
        var yi = [];
        ir(Bi), tr(yi, Ai, "state_address");
        var ii = new or(0 | b._crypto_auth_hmacsha512256_bytes()), ki = ii.address;
        if (yi.push(ki), !(0 | b._crypto_auth_hmacsha512256_final(Ai, ki))) {
          var Vi = (b._free(Ai), Pe(ii, Bi));
          return xr(yi), Vi;
        }
        kr(yi, "invalid usage");
      }
      function Gn(Ai, Bi) {
        var yi = [];
        ir(Bi);
        var ii = null, ki = 0;
        Ai != null && (ii = lr(Ai = Fe(yi, Ai, "key")), ki = Ai.length, yi.push(ii));
        var Vi = new or(416).address;
        if (!(0 | b._crypto_auth_hmacsha512256_init(Vi, ii, ki))) {
          var Ki = Vi;
          return xr(yi), Ki;
        }
        kr(yi, "invalid usage");
      }
      function pn(Ai) {
        var Bi = [];
        ir(Ai);
        var yi = new or(0 | b._crypto_auth_hmacsha512256_keybytes()), ii = yi.address;
        Bi.push(ii), b._crypto_auth_hmacsha512256_keygen(ii);
        var ki = Pe(yi, Ai);
        return xr(Bi), ki;
      }
      function hn(Ai, Bi, yi) {
        var ii = [];
        ir(yi), tr(ii, Ai, "state_address");
        var ki = lr(Bi = Fe(ii, Bi, "message_chunk")), Vi = Bi.length;
        ii.push(ki), 0 | b._crypto_auth_hmacsha512256_update(Ai, ki, Vi) && kr(ii, "invalid usage"), xr(ii);
      }
      function Rn(Ai, Bi, yi) {
        var ii = [];
        Ai = Fe(ii, Ai, "tag");
        var ki, Vi = 0 | b._crypto_auth_hmacsha512256_bytes();
        Ai.length !== Vi && Ce(ii, "invalid tag length"), ki = lr(Ai), ii.push(ki);
        var Ki = lr(Bi = Fe(ii, Bi, "message")), Pn = Bi.length;
        ii.push(Ki), yi = Fe(ii, yi, "key");
        var oo, mo = 0 | b._crypto_auth_hmacsha512256_keybytes();
        yi.length !== mo && Ce(ii, "invalid key length"), oo = lr(yi), ii.push(oo);
        var ko = !(0 | b._crypto_auth_hmacsha512256_verify(ki, Ki, Pn, 0, oo));
        return xr(ii), ko;
      }
      function vo(Ai, Bi) {
        var yi = [];
        ir(Bi), tr(yi, Ai, "state_address");
        var ii = new or(0 | b._crypto_auth_hmacsha512_bytes()), ki = ii.address;
        if (yi.push(ki), !(0 | b._crypto_auth_hmacsha512_final(Ai, ki))) {
          var Vi = (b._free(Ai), Pe(ii, Bi));
          return xr(yi), Vi;
        }
        kr(yi, "invalid usage");
      }
      function Hi(Ai, Bi) {
        var yi = [];
        ir(Bi);
        var ii = null, ki = 0;
        Ai != null && (ii = lr(Ai = Fe(yi, Ai, "key")), ki = Ai.length, yi.push(ii));
        var Vi = new or(416).address;
        if (!(0 | b._crypto_auth_hmacsha512_init(Vi, ii, ki))) {
          var Ki = Vi;
          return xr(yi), Ki;
        }
        kr(yi, "invalid usage");
      }
      function di(Ai) {
        var Bi = [];
        ir(Ai);
        var yi = new or(0 | b._crypto_auth_hmacsha512_keybytes()), ii = yi.address;
        Bi.push(ii), b._crypto_auth_hmacsha512_keygen(ii);
        var ki = Pe(yi, Ai);
        return xr(Bi), ki;
      }
      function Ui(Ai, Bi, yi) {
        var ii = [];
        ir(yi), tr(ii, Ai, "state_address");
        var ki = lr(Bi = Fe(ii, Bi, "message_chunk")), Vi = Bi.length;
        ii.push(ki), 0 | b._crypto_auth_hmacsha512_update(Ai, ki, Vi) && kr(ii, "invalid usage"), xr(ii);
      }
      function ln(Ai, Bi, yi) {
        var ii = [];
        Ai = Fe(ii, Ai, "tag");
        var ki, Vi = 0 | b._crypto_auth_hmacsha512_bytes();
        Ai.length !== Vi && Ce(ii, "invalid tag length"), ki = lr(Ai), ii.push(ki);
        var Ki = lr(Bi = Fe(ii, Bi, "message")), Pn = Bi.length;
        ii.push(Ki), yi = Fe(ii, yi, "key");
        var oo, mo = 0 | b._crypto_auth_hmacsha512_keybytes();
        yi.length !== mo && Ce(ii, "invalid key length"), oo = lr(yi), ii.push(oo);
        var ko = !(0 | b._crypto_auth_hmacsha512_verify(ki, Ki, Pn, 0, oo));
        return xr(ii), ko;
      }
      function Un(Ai) {
        var Bi = [];
        ir(Ai);
        var yi = new or(0 | b._crypto_auth_keybytes()), ii = yi.address;
        Bi.push(ii), b._crypto_auth_keygen(ii);
        var ki = Pe(yi, Ai);
        return xr(Bi), ki;
      }
      function Bo(Ai, Bi, yi) {
        var ii = [];
        Ai = Fe(ii, Ai, "tag");
        var ki, Vi = 0 | b._crypto_auth_bytes();
        Ai.length !== Vi && Ce(ii, "invalid tag length"), ki = lr(Ai), ii.push(ki);
        var Ki = lr(Bi = Fe(ii, Bi, "message")), Pn = Bi.length;
        ii.push(Ki), yi = Fe(ii, yi, "key");
        var oo, mo = 0 | b._crypto_auth_keybytes();
        yi.length !== mo && Ce(ii, "invalid key length"), oo = lr(yi), ii.push(oo);
        var ko = !(0 | b._crypto_auth_verify(ki, Ki, Pn, 0, oo));
        return xr(ii), ko;
      }
      function co(Ai, Bi, yi) {
        var ii = [];
        ir(yi), Ai = Fe(ii, Ai, "publicKey");
        var ki, Vi = 0 | b._crypto_box_publickeybytes();
        Ai.length !== Vi && Ce(ii, "invalid publicKey length"), ki = lr(Ai), ii.push(ki), Bi = Fe(ii, Bi, "privateKey");
        var Ki, Pn = 0 | b._crypto_box_secretkeybytes();
        Bi.length !== Pn && Ce(ii, "invalid privateKey length"), Ki = lr(Bi), ii.push(Ki);
        var oo = new or(0 | b._crypto_box_beforenmbytes()), mo = oo.address;
        if (ii.push(mo), !(0 | b._crypto_box_beforenm(mo, ki, Ki))) {
          var ko = Pe(oo, yi);
          return xr(ii), ko;
        }
        kr(ii, "invalid usage");
      }
      function To(Ai, Bi, yi) {
        var ii = [];
        ir(yi), Ai = Fe(ii, Ai, "publicKey");
        var ki, Vi = 0 | b._crypto_box_curve25519xchacha20poly1305_publickeybytes();
        Ai.length !== Vi && Ce(ii, "invalid publicKey length"), ki = lr(Ai), ii.push(ki), Bi = Fe(ii, Bi, "privateKey");
        var Ki, Pn = 0 | b._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
        Bi.length !== Pn && Ce(ii, "invalid privateKey length"), Ki = lr(Bi), ii.push(Ki);
        var oo = new or(0 | b._crypto_box_curve25519xchacha20poly1305_beforenmbytes()), mo = oo.address;
        if (ii.push(mo), !(0 | b._crypto_box_curve25519xchacha20poly1305_beforenm(mo, ki, Ki))) {
          var ko = Pe(oo, yi);
          return xr(ii), ko;
        }
        kr(ii, "invalid usage");
      }
      function xs(Ai, Bi, yi, ii, ki) {
        var Vi = [];
        ir(ki);
        var Ki = lr(Ai = Fe(Vi, Ai, "message")), Pn = Ai.length;
        Vi.push(Ki), Bi = Fe(Vi, Bi, "nonce");
        var oo, mo = 0 | b._crypto_box_curve25519xchacha20poly1305_noncebytes();
        Bi.length !== mo && Ce(Vi, "invalid nonce length"), oo = lr(Bi), Vi.push(oo), yi = Fe(Vi, yi, "publicKey");
        var ko, $o = 0 | b._crypto_box_curve25519xchacha20poly1305_publickeybytes();
        yi.length !== $o && Ce(Vi, "invalid publicKey length"), ko = lr(yi), Vi.push(ko), ii = Fe(Vi, ii, "privateKey");
        var Jo, hs = 0 | b._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
        ii.length !== hs && Ce(Vi, "invalid privateKey length"), Jo = lr(ii), Vi.push(Jo);
        var Ss = new or(0 | Pn), Us = Ss.address;
        Vi.push(Us);
        var Zs = new or(0 | b._crypto_box_curve25519xchacha20poly1305_macbytes()), Ks = Zs.address;
        if (Vi.push(Ks), !(0 | b._crypto_box_curve25519xchacha20poly1305_detached(Us, Ks, Ki, Pn, 0, oo, ko, Jo))) {
          var ha = Pe({ ciphertext: Ss, mac: Zs }, ki);
          return xr(Vi), ha;
        }
        kr(Vi, "invalid usage");
      }
      function Fo(Ai, Bi, yi, ii) {
        var ki = [];
        ir(ii);
        var Vi = lr(Ai = Fe(ki, Ai, "message")), Ki = Ai.length;
        ki.push(Vi), Bi = Fe(ki, Bi, "nonce");
        var Pn, oo = 0 | b._crypto_box_curve25519xchacha20poly1305_noncebytes();
        Bi.length !== oo && Ce(ki, "invalid nonce length"), Pn = lr(Bi), ki.push(Pn), yi = Fe(ki, yi, "sharedKey");
        var mo, ko = 0 | b._crypto_box_curve25519xchacha20poly1305_beforenmbytes();
        yi.length !== ko && Ce(ki, "invalid sharedKey length"), mo = lr(yi), ki.push(mo);
        var $o = new or(0 | Ki), Jo = $o.address;
        ki.push(Jo);
        var hs = new or(0 | b._crypto_box_curve25519xchacha20poly1305_macbytes()), Ss = hs.address;
        if (ki.push(Ss), !(0 | b._crypto_box_curve25519xchacha20poly1305_detached_afternm(Jo, Ss, Vi, Ki, 0, Pn, mo))) {
          var Us = Pe({ ciphertext: $o, mac: hs }, ii);
          return xr(ki), Us;
        }
        kr(ki, "invalid usage");
      }
      function Zo(Ai, Bi, yi, ii, ki) {
        var Vi = [];
        ir(ki);
        var Ki = lr(Ai = Fe(Vi, Ai, "message")), Pn = Ai.length;
        Vi.push(Ki), Bi = Fe(Vi, Bi, "nonce");
        var oo, mo = 0 | b._crypto_box_curve25519xchacha20poly1305_noncebytes();
        Bi.length !== mo && Ce(Vi, "invalid nonce length"), oo = lr(Bi), Vi.push(oo), yi = Fe(Vi, yi, "publicKey");
        var ko, $o = 0 | b._crypto_box_curve25519xchacha20poly1305_publickeybytes();
        yi.length !== $o && Ce(Vi, "invalid publicKey length"), ko = lr(yi), Vi.push(ko), ii = Fe(Vi, ii, "privateKey");
        var Jo, hs = 0 | b._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
        ii.length !== hs && Ce(Vi, "invalid privateKey length"), Jo = lr(ii), Vi.push(Jo);
        var Ss = new or(Pn + b._crypto_box_curve25519xchacha20poly1305_macbytes() | 0), Us = Ss.address;
        if (Vi.push(Us), !(0 | b._crypto_box_curve25519xchacha20poly1305_easy(Us, Ki, Pn, 0, oo, ko, Jo))) {
          var Zs = Pe(Ss, ki);
          return xr(Vi), Zs;
        }
        kr(Vi, "invalid usage");
      }
      function $s(Ai, Bi, yi, ii) {
        var ki = [];
        ir(ii);
        var Vi = lr(Ai = Fe(ki, Ai, "message")), Ki = Ai.length;
        ki.push(Vi), Bi = Fe(ki, Bi, "nonce");
        var Pn, oo = 0 | b._crypto_box_curve25519xchacha20poly1305_noncebytes();
        Bi.length !== oo && Ce(ki, "invalid nonce length"), Pn = lr(Bi), ki.push(Pn), yi = Fe(ki, yi, "sharedKey");
        var mo, ko = 0 | b._crypto_box_curve25519xchacha20poly1305_beforenmbytes();
        yi.length !== ko && Ce(ki, "invalid sharedKey length"), mo = lr(yi), ki.push(mo);
        var $o = new or(Ki + b._crypto_box_curve25519xchacha20poly1305_macbytes() | 0), Jo = $o.address;
        if (ki.push(Jo), !(0 | b._crypto_box_curve25519xchacha20poly1305_easy_afternm(Jo, Vi, Ki, 0, Pn, mo))) {
          var hs = Pe($o, ii);
          return xr(ki), hs;
        }
        kr(ki, "invalid usage");
      }
      function rs(Ai) {
        var Bi = [];
        ir(Ai);
        var yi = new or(0 | b._crypto_box_curve25519xchacha20poly1305_publickeybytes()), ii = yi.address;
        Bi.push(ii);
        var ki = new or(0 | b._crypto_box_curve25519xchacha20poly1305_secretkeybytes()), Vi = ki.address;
        Bi.push(Vi), b._crypto_box_curve25519xchacha20poly1305_keypair(ii, Vi);
        var Ki = Pe({ publicKey: yi, privateKey: ki, keyType: "curve25519" }, Ai);
        return xr(Bi), Ki;
      }
      function ls(Ai, Bi, yi, ii, ki, Vi) {
        var Ki = [];
        ir(Vi);
        var Pn = lr(Ai = Fe(Ki, Ai, "ciphertext")), oo = Ai.length;
        Ki.push(Pn), Bi = Fe(Ki, Bi, "mac");
        var mo, ko = 0 | b._crypto_box_curve25519xchacha20poly1305_macbytes();
        Bi.length !== ko && Ce(Ki, "invalid mac length"), mo = lr(Bi), Ki.push(mo), yi = Fe(Ki, yi, "nonce");
        var $o, Jo = 0 | b._crypto_box_curve25519xchacha20poly1305_noncebytes();
        yi.length !== Jo && Ce(Ki, "invalid nonce length"), $o = lr(yi), Ki.push($o), ii = Fe(Ki, ii, "publicKey");
        var hs, Ss = 0 | b._crypto_box_curve25519xchacha20poly1305_publickeybytes();
        ii.length !== Ss && Ce(Ki, "invalid publicKey length"), hs = lr(ii), Ki.push(hs), ki = Fe(Ki, ki, "privateKey");
        var Us, Zs = 0 | b._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
        ki.length !== Zs && Ce(Ki, "invalid privateKey length"), Us = lr(ki), Ki.push(Us);
        var Ks = new or(0 | oo), ha = Ks.address;
        if (Ki.push(ha), !(0 | b._crypto_box_curve25519xchacha20poly1305_open_detached(ha, Pn, mo, oo, 0, $o, hs, Us))) {
          var pa = Pe(Ks, Vi);
          return xr(Ki), pa;
        }
        kr(Ki, "incorrect key pair for the given ciphertext");
      }
      function na(Ai, Bi, yi, ii, ki) {
        var Vi = [];
        ir(ki);
        var Ki = lr(Ai = Fe(Vi, Ai, "ciphertext")), Pn = Ai.length;
        Vi.push(Ki), Bi = Fe(Vi, Bi, "mac");
        var oo, mo = 0 | b._crypto_box_curve25519xchacha20poly1305_macbytes();
        Bi.length !== mo && Ce(Vi, "invalid mac length"), oo = lr(Bi), Vi.push(oo), yi = Fe(Vi, yi, "nonce");
        var ko, $o = 0 | b._crypto_box_curve25519xchacha20poly1305_noncebytes();
        yi.length !== $o && Ce(Vi, "invalid nonce length"), ko = lr(yi), Vi.push(ko), ii = Fe(Vi, ii, "sharedKey");
        var Jo, hs = 0 | b._crypto_box_curve25519xchacha20poly1305_beforenmbytes();
        ii.length !== hs && Ce(Vi, "invalid sharedKey length"), Jo = lr(ii), Vi.push(Jo);
        var Ss = new or(0 | Pn), Us = Ss.address;
        if (Vi.push(Us), !(0 | b._crypto_box_curve25519xchacha20poly1305_open_detached_afternm(Us, Ki, oo, Pn, 0, ko, Jo))) {
          var Zs = Pe(Ss, ki);
          return xr(Vi), Zs;
        }
        kr(Vi, "incorrect secret key for the given ciphertext");
      }
      function os(Ai, Bi, yi, ii, ki) {
        var Vi = [];
        ir(ki), Ai = Fe(Vi, Ai, "ciphertext");
        var Ki, Pn = b._crypto_box_curve25519xchacha20poly1305_macbytes(), oo = Ai.length;
        oo < Pn && Ce(Vi, "ciphertext is too short"), Ki = lr(Ai), Vi.push(Ki), Bi = Fe(Vi, Bi, "nonce");
        var mo, ko = 0 | b._crypto_box_curve25519xchacha20poly1305_noncebytes();
        Bi.length !== ko && Ce(Vi, "invalid nonce length"), mo = lr(Bi), Vi.push(mo), yi = Fe(Vi, yi, "publicKey");
        var $o, Jo = 0 | b._crypto_box_curve25519xchacha20poly1305_publickeybytes();
        yi.length !== Jo && Ce(Vi, "invalid publicKey length"), $o = lr(yi), Vi.push($o), ii = Fe(Vi, ii, "privateKey");
        var hs, Ss = 0 | b._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
        ii.length !== Ss && Ce(Vi, "invalid privateKey length"), hs = lr(ii), Vi.push(hs);
        var Us = new or(oo - b._crypto_box_curve25519xchacha20poly1305_macbytes() | 0), Zs = Us.address;
        if (Vi.push(Zs), !(0 | b._crypto_box_curve25519xchacha20poly1305_open_easy(Zs, Ki, oo, 0, mo, $o, hs))) {
          var Ks = Pe(Us, ki);
          return xr(Vi), Ks;
        }
        kr(Vi, "incorrect key pair for the given ciphertext");
      }
      function fs(Ai, Bi, yi, ii) {
        var ki = [];
        ir(ii);
        var Vi = lr(Ai = Fe(ki, Ai, "ciphertext")), Ki = Ai.length;
        ki.push(Vi), Bi = Fe(ki, Bi, "nonce");
        var Pn, oo = 0 | b._crypto_box_curve25519xchacha20poly1305_noncebytes();
        Bi.length !== oo && Ce(ki, "invalid nonce length"), Pn = lr(Bi), ki.push(Pn), yi = Fe(ki, yi, "sharedKey");
        var mo, ko = 0 | b._crypto_box_curve25519xchacha20poly1305_beforenmbytes();
        yi.length !== ko && Ce(ki, "invalid sharedKey length"), mo = lr(yi), ki.push(mo);
        var $o = new or(Ki - b._crypto_box_curve25519xchacha20poly1305_macbytes() | 0), Jo = $o.address;
        if (ki.push(Jo), !(0 | b._crypto_box_curve25519xchacha20poly1305_open_easy_afternm(Jo, Vi, Ki, 0, Pn, mo))) {
          var hs = Pe($o, ii);
          return xr(ki), hs;
        }
        kr(ki, "incorrect secret key for the given ciphertext");
      }
      function da(Ai, Bi, yi) {
        var ii = [];
        ir(yi);
        var ki = lr(Ai = Fe(ii, Ai, "message")), Vi = Ai.length;
        ii.push(ki), Bi = Fe(ii, Bi, "publicKey");
        var Ki, Pn = 0 | b._crypto_box_curve25519xchacha20poly1305_publickeybytes();
        Bi.length !== Pn && Ce(ii, "invalid publicKey length"), Ki = lr(Bi), ii.push(Ki);
        var oo = new or(Vi + b._crypto_box_curve25519xchacha20poly1305_sealbytes() | 0), mo = oo.address;
        ii.push(mo), b._crypto_box_curve25519xchacha20poly1305_seal(mo, ki, Vi, 0, Ki);
        var ko = Pe(oo, yi);
        return xr(ii), ko;
      }
      function Bn(Ai, Bi, yi, ii) {
        var ki = [];
        ir(ii), Ai = Fe(ki, Ai, "ciphertext");
        var Vi, Ki = b._crypto_box_curve25519xchacha20poly1305_sealbytes(), Pn = Ai.length;
        Pn < Ki && Ce(ki, "ciphertext is too short"), Vi = lr(Ai), ki.push(Vi), Bi = Fe(ki, Bi, "publicKey");
        var oo, mo = 0 | b._crypto_box_curve25519xchacha20poly1305_publickeybytes();
        Bi.length !== mo && Ce(ki, "invalid publicKey length"), oo = lr(Bi), ki.push(oo), yi = Fe(ki, yi, "secretKey");
        var ko, $o = 0 | b._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
        yi.length !== $o && Ce(ki, "invalid secretKey length"), ko = lr(yi), ki.push(ko);
        var Jo = new or(Pn - b._crypto_box_curve25519xchacha20poly1305_sealbytes() | 0), hs = Jo.address;
        ki.push(hs), b._crypto_box_curve25519xchacha20poly1305_seal_open(hs, Vi, Pn, 0, oo, ko);
        var Ss = Pe(Jo, ii);
        return xr(ki), Ss;
      }
      function hi(Ai, Bi) {
        var yi = [];
        ir(Bi), Ai = Fe(yi, Ai, "seed");
        var ii, ki = 0 | b._crypto_box_curve25519xchacha20poly1305_seedbytes();
        Ai.length !== ki && Ce(yi, "invalid seed length"), ii = lr(Ai), yi.push(ii);
        var Vi = new or(0 | b._crypto_box_curve25519xchacha20poly1305_publickeybytes()), Ki = Vi.address;
        yi.push(Ki);
        var Pn = new or(0 | b._crypto_box_curve25519xchacha20poly1305_secretkeybytes()), oo = Pn.address;
        if (yi.push(oo), !(0 | b._crypto_box_curve25519xchacha20poly1305_seed_keypair(Ki, oo, ii))) {
          var mo = { publicKey: Pe(Vi, Bi), privateKey: Pe(Pn, Bi), keyType: "x25519" };
          return xr(yi), mo;
        }
        kr(yi, "invalid usage");
      }
      function Ii(Ai, Bi, yi, ii, ki) {
        var Vi = [];
        ir(ki);
        var Ki = lr(Ai = Fe(Vi, Ai, "message")), Pn = Ai.length;
        Vi.push(Ki), Bi = Fe(Vi, Bi, "nonce");
        var oo, mo = 0 | b._crypto_box_noncebytes();
        Bi.length !== mo && Ce(Vi, "invalid nonce length"), oo = lr(Bi), Vi.push(oo), yi = Fe(Vi, yi, "publicKey");
        var ko, $o = 0 | b._crypto_box_publickeybytes();
        yi.length !== $o && Ce(Vi, "invalid publicKey length"), ko = lr(yi), Vi.push(ko), ii = Fe(Vi, ii, "privateKey");
        var Jo, hs = 0 | b._crypto_box_secretkeybytes();
        ii.length !== hs && Ce(Vi, "invalid privateKey length"), Jo = lr(ii), Vi.push(Jo);
        var Ss = new or(0 | Pn), Us = Ss.address;
        Vi.push(Us);
        var Zs = new or(0 | b._crypto_box_macbytes()), Ks = Zs.address;
        if (Vi.push(Ks), !(0 | b._crypto_box_detached(Us, Ks, Ki, Pn, 0, oo, ko, Jo))) {
          var ha = Pe({ ciphertext: Ss, mac: Zs }, ki);
          return xr(Vi), ha;
        }
        kr(Vi, "invalid usage");
      }
      function Gi(Ai, Bi, yi, ii, ki) {
        var Vi = [];
        ir(ki);
        var Ki = lr(Ai = Fe(Vi, Ai, "message")), Pn = Ai.length;
        Vi.push(Ki), Bi = Fe(Vi, Bi, "nonce");
        var oo, mo = 0 | b._crypto_box_noncebytes();
        Bi.length !== mo && Ce(Vi, "invalid nonce length"), oo = lr(Bi), Vi.push(oo), yi = Fe(Vi, yi, "publicKey");
        var ko, $o = 0 | b._crypto_box_publickeybytes();
        yi.length !== $o && Ce(Vi, "invalid publicKey length"), ko = lr(yi), Vi.push(ko), ii = Fe(Vi, ii, "privateKey");
        var Jo, hs = 0 | b._crypto_box_secretkeybytes();
        ii.length !== hs && Ce(Vi, "invalid privateKey length"), Jo = lr(ii), Vi.push(Jo);
        var Ss = new or(Pn + b._crypto_box_macbytes() | 0), Us = Ss.address;
        if (Vi.push(Us), !(0 | b._crypto_box_easy(Us, Ki, Pn, 0, oo, ko, Jo))) {
          var Zs = Pe(Ss, ki);
          return xr(Vi), Zs;
        }
        kr(Vi, "invalid usage");
      }
      function kn(Ai, Bi, yi, ii) {
        var ki = [];
        ir(ii);
        var Vi = lr(Ai = Fe(ki, Ai, "message")), Ki = Ai.length;
        ki.push(Vi), Bi = Fe(ki, Bi, "nonce");
        var Pn, oo = 0 | b._crypto_box_noncebytes();
        Bi.length !== oo && Ce(ki, "invalid nonce length"), Pn = lr(Bi), ki.push(Pn), yi = Fe(ki, yi, "sharedKey");
        var mo, ko = 0 | b._crypto_box_beforenmbytes();
        yi.length !== ko && Ce(ki, "invalid sharedKey length"), mo = lr(yi), ki.push(mo);
        var $o = new or(Ki + b._crypto_box_macbytes() | 0), Jo = $o.address;
        if (ki.push(Jo), !(0 | b._crypto_box_easy_afternm(Jo, Vi, Ki, 0, Pn, mo))) {
          var hs = Pe($o, ii);
          return xr(ki), hs;
        }
        kr(ki, "invalid usage");
      }
      function ho(Ai) {
        var Bi = [];
        ir(Ai);
        var yi = new or(0 | b._crypto_box_publickeybytes()), ii = yi.address;
        Bi.push(ii);
        var ki = new or(0 | b._crypto_box_secretkeybytes()), Vi = ki.address;
        if (Bi.push(Vi), !(0 | b._crypto_box_keypair(ii, Vi))) {
          var Ki = { publicKey: Pe(yi, Ai), privateKey: Pe(ki, Ai), keyType: "x25519" };
          return xr(Bi), Ki;
        }
        kr(Bi, "internal error");
      }
      function eo(Ai, Bi, yi, ii, ki, Vi) {
        var Ki = [];
        ir(Vi);
        var Pn = lr(Ai = Fe(Ki, Ai, "ciphertext")), oo = Ai.length;
        Ki.push(Pn), Bi = Fe(Ki, Bi, "mac");
        var mo, ko = 0 | b._crypto_box_macbytes();
        Bi.length !== ko && Ce(Ki, "invalid mac length"), mo = lr(Bi), Ki.push(mo), yi = Fe(Ki, yi, "nonce");
        var $o, Jo = 0 | b._crypto_box_noncebytes();
        yi.length !== Jo && Ce(Ki, "invalid nonce length"), $o = lr(yi), Ki.push($o), ii = Fe(Ki, ii, "publicKey");
        var hs, Ss = 0 | b._crypto_box_publickeybytes();
        ii.length !== Ss && Ce(Ki, "invalid publicKey length"), hs = lr(ii), Ki.push(hs), ki = Fe(Ki, ki, "privateKey");
        var Us, Zs = 0 | b._crypto_box_secretkeybytes();
        ki.length !== Zs && Ce(Ki, "invalid privateKey length"), Us = lr(ki), Ki.push(Us);
        var Ks = new or(0 | oo), ha = Ks.address;
        if (Ki.push(ha), !(0 | b._crypto_box_open_detached(ha, Pn, mo, oo, 0, $o, hs, Us))) {
          var pa = Pe(Ks, Vi);
          return xr(Ki), pa;
        }
        kr(Ki, "incorrect key pair for the given ciphertext");
      }
      function Ei(Ai, Bi, yi, ii, ki) {
        var Vi = [];
        ir(ki), Ai = Fe(Vi, Ai, "ciphertext");
        var Ki, Pn = b._crypto_box_macbytes(), oo = Ai.length;
        oo < Pn && Ce(Vi, "ciphertext is too short"), Ki = lr(Ai), Vi.push(Ki), Bi = Fe(Vi, Bi, "nonce");
        var mo, ko = 0 | b._crypto_box_noncebytes();
        Bi.length !== ko && Ce(Vi, "invalid nonce length"), mo = lr(Bi), Vi.push(mo), yi = Fe(Vi, yi, "publicKey");
        var $o, Jo = 0 | b._crypto_box_publickeybytes();
        yi.length !== Jo && Ce(Vi, "invalid publicKey length"), $o = lr(yi), Vi.push($o), ii = Fe(Vi, ii, "privateKey");
        var hs, Ss = 0 | b._crypto_box_secretkeybytes();
        ii.length !== Ss && Ce(Vi, "invalid privateKey length"), hs = lr(ii), Vi.push(hs);
        var Us = new or(oo - b._crypto_box_macbytes() | 0), Zs = Us.address;
        if (Vi.push(Zs), !(0 | b._crypto_box_open_easy(Zs, Ki, oo, 0, mo, $o, hs))) {
          var Ks = Pe(Us, ki);
          return xr(Vi), Ks;
        }
        kr(Vi, "incorrect key pair for the given ciphertext");
      }
      function vs(Ai, Bi, yi, ii) {
        var ki = [];
        ir(ii);
        var Vi = lr(Ai = Fe(ki, Ai, "ciphertext")), Ki = Ai.length;
        ki.push(Vi), Bi = Fe(ki, Bi, "nonce");
        var Pn, oo = 0 | b._crypto_box_noncebytes();
        Bi.length !== oo && Ce(ki, "invalid nonce length"), Pn = lr(Bi), ki.push(Pn), yi = Fe(ki, yi, "sharedKey");
        var mo, ko = 0 | b._crypto_box_beforenmbytes();
        yi.length !== ko && Ce(ki, "invalid sharedKey length"), mo = lr(yi), ki.push(mo);
        var $o = new or(Ki - b._crypto_box_macbytes() | 0), Jo = $o.address;
        if (ki.push(Jo), !(0 | b._crypto_box_open_easy_afternm(Jo, Vi, Ki, 0, Pn, mo))) {
          var hs = Pe($o, ii);
          return xr(ki), hs;
        }
        kr(ki, "incorrect secret key for the given ciphertext");
      }
      function vi(Ai, Bi, yi) {
        var ii = [];
        ir(yi);
        var ki = lr(Ai = Fe(ii, Ai, "message")), Vi = Ai.length;
        ii.push(ki), Bi = Fe(ii, Bi, "publicKey");
        var Ki, Pn = 0 | b._crypto_box_publickeybytes();
        Bi.length !== Pn && Ce(ii, "invalid publicKey length"), Ki = lr(Bi), ii.push(Ki);
        var oo = new or(Vi + b._crypto_box_sealbytes() | 0), mo = oo.address;
        if (ii.push(mo), !(0 | b._crypto_box_seal(mo, ki, Vi, 0, Ki))) {
          var ko = Pe(oo, yi);
          return xr(ii), ko;
        }
        kr(ii, "invalid usage");
      }
      function xi(Ai, Bi, yi, ii) {
        var ki = [];
        ir(ii), Ai = Fe(ki, Ai, "ciphertext");
        var Vi, Ki = b._crypto_box_sealbytes(), Pn = Ai.length;
        Pn < Ki && Ce(ki, "ciphertext is too short"), Vi = lr(Ai), ki.push(Vi), Bi = Fe(ki, Bi, "publicKey");
        var oo, mo = 0 | b._crypto_box_publickeybytes();
        Bi.length !== mo && Ce(ki, "invalid publicKey length"), oo = lr(Bi), ki.push(oo), yi = Fe(ki, yi, "privateKey");
        var ko, $o = 0 | b._crypto_box_secretkeybytes();
        yi.length !== $o && Ce(ki, "invalid privateKey length"), ko = lr(yi), ki.push(ko);
        var Jo = new or(Pn - b._crypto_box_sealbytes() | 0), hs = Jo.address;
        if (ki.push(hs), !(0 | b._crypto_box_seal_open(hs, Vi, Pn, 0, oo, ko))) {
          var Ss = Pe(Jo, ii);
          return xr(ki), Ss;
        }
        kr(ki, "incorrect key pair for the given ciphertext");
      }
      function Lr(Ai, Bi) {
        var yi = [];
        ir(Bi), Ai = Fe(yi, Ai, "seed");
        var ii, ki = 0 | b._crypto_box_seedbytes();
        Ai.length !== ki && Ce(yi, "invalid seed length"), ii = lr(Ai), yi.push(ii);
        var Vi = new or(0 | b._crypto_box_publickeybytes()), Ki = Vi.address;
        yi.push(Ki);
        var Pn = new or(0 | b._crypto_box_secretkeybytes()), oo = Pn.address;
        if (yi.push(oo), !(0 | b._crypto_box_seed_keypair(Ki, oo, ii))) {
          var mo = { publicKey: Pe(Vi, Bi), privateKey: Pe(Pn, Bi), keyType: "x25519" };
          return xr(yi), mo;
        }
        kr(yi, "invalid usage");
      }
      function dn(Ai, Bi, yi) {
        var ii = [];
        ir(yi), Ai = Fe(ii, Ai, "p");
        var ki, Vi = 0 | b._crypto_core_ed25519_bytes();
        Ai.length !== Vi && Ce(ii, "invalid p length"), ki = lr(Ai), ii.push(ki), Bi = Fe(ii, Bi, "q");
        var Ki, Pn = 0 | b._crypto_core_ed25519_bytes();
        Bi.length !== Pn && Ce(ii, "invalid q length"), Ki = lr(Bi), ii.push(Ki);
        var oo = new or(0 | b._crypto_core_ed25519_bytes()), mo = oo.address;
        if (ii.push(mo), !(0 | b._crypto_core_ed25519_add(mo, ki, Ki))) {
          var ko = Pe(oo, yi);
          return xr(ii), ko;
        }
        kr(ii, "input is an invalid element");
      }
      function xn(Ai, Bi) {
        var yi = [];
        ir(Bi);
        var ii = lr(Ai = Fe(yi, Ai, "r"));
        Ai.length, yi.push(ii);
        var ki = new or(0 | b._crypto_core_ed25519_bytes()), Vi = ki.address;
        if (yi.push(Vi), !(0 | b._crypto_core_ed25519_from_hash(Vi, ii))) {
          var Ki = Pe(ki, Bi);
          return xr(yi), Ki;
        }
        kr(yi, "invalid usage");
      }
      function oi(Ai, Bi) {
        var yi = [];
        ir(Bi);
        var ii = lr(Ai = Fe(yi, Ai, "r"));
        Ai.length, yi.push(ii);
        var ki = new or(0 | b._crypto_core_ed25519_bytes()), Vi = ki.address;
        if (yi.push(Vi), !(0 | b._crypto_core_ed25519_from_uniform(Vi, ii))) {
          var Ki = Pe(ki, Bi);
          return xr(yi), Ki;
        }
        kr(yi, "invalid usage");
      }
      function Yr(Ai, Bi) {
        var yi = [];
        ir(Bi), Ai = Fe(yi, Ai, "repr");
        var ii, ki = 0 | b._crypto_core_ed25519_bytes();
        Ai.length !== ki && Ce(yi, "invalid repr length"), ii = lr(Ai), yi.push(ii);
        var Vi = (0 | b._crypto_core_ed25519_is_valid_point(ii)) == 1;
        return xr(yi), Vi;
      }
      function ji(Ai) {
        var Bi = [];
        ir(Ai);
        var yi = new or(0 | b._crypto_core_ed25519_bytes()), ii = yi.address;
        Bi.push(ii), b._crypto_core_ed25519_random(ii);
        var ki = Pe(yi, Ai);
        return xr(Bi), ki;
      }
      function Cn(Ai, Bi, yi) {
        var ii = [];
        ir(yi), Ai = Fe(ii, Ai, "x");
        var ki, Vi = 0 | b._crypto_core_ed25519_scalarbytes();
        Ai.length !== Vi && Ce(ii, "invalid x length"), ki = lr(Ai), ii.push(ki), Bi = Fe(ii, Bi, "y");
        var Ki, Pn = 0 | b._crypto_core_ed25519_scalarbytes();
        Bi.length !== Pn && Ce(ii, "invalid y length"), Ki = lr(Bi), ii.push(Ki);
        var oo = new or(0 | b._crypto_core_ed25519_scalarbytes()), mo = oo.address;
        ii.push(mo), b._crypto_core_ed25519_scalar_add(mo, ki, Ki);
        var ko = Pe(oo, yi);
        return xr(ii), ko;
      }
      function Mn(Ai, Bi) {
        var yi = [];
        ir(Bi), Ai = Fe(yi, Ai, "s");
        var ii, ki = 0 | b._crypto_core_ed25519_scalarbytes();
        Ai.length !== ki && Ce(yi, "invalid s length"), ii = lr(Ai), yi.push(ii);
        var Vi = new or(0 | b._crypto_core_ed25519_scalarbytes()), Ki = Vi.address;
        yi.push(Ki), b._crypto_core_ed25519_scalar_complement(Ki, ii);
        var Pn = Pe(Vi, Bi);
        return xr(yi), Pn;
      }
      function B(Ai, Bi) {
        var yi = [];
        ir(Bi), Ai = Fe(yi, Ai, "s");
        var ii, ki = 0 | b._crypto_core_ed25519_scalarbytes();
        Ai.length !== ki && Ce(yi, "invalid s length"), ii = lr(Ai), yi.push(ii);
        var Vi = new or(0 | b._crypto_core_ed25519_scalarbytes()), Ki = Vi.address;
        if (yi.push(Ki), !(0 | b._crypto_core_ed25519_scalar_invert(Ki, ii))) {
          var Pn = Pe(Vi, Bi);
          return xr(yi), Pn;
        }
        kr(yi, "invalid reciprocate");
      }
      function o(Ai, Bi, yi) {
        var ii = [];
        ir(yi), Ai = Fe(ii, Ai, "x");
        var ki, Vi = 0 | b._crypto_core_ed25519_scalarbytes();
        Ai.length !== Vi && Ce(ii, "invalid x length"), ki = lr(Ai), ii.push(ki), Bi = Fe(ii, Bi, "y");
        var Ki, Pn = 0 | b._crypto_core_ed25519_scalarbytes();
        Bi.length !== Pn && Ce(ii, "invalid y length"), Ki = lr(Bi), ii.push(Ki);
        var oo = new or(0 | b._crypto_core_ed25519_scalarbytes()), mo = oo.address;
        ii.push(mo), b._crypto_core_ed25519_scalar_mul(mo, ki, Ki);
        var ko = Pe(oo, yi);
        return xr(ii), ko;
      }
      function m(Ai, Bi) {
        var yi = [];
        ir(Bi), Ai = Fe(yi, Ai, "s");
        var ii, ki = 0 | b._crypto_core_ed25519_scalarbytes();
        Ai.length !== ki && Ce(yi, "invalid s length"), ii = lr(Ai), yi.push(ii);
        var Vi = new or(0 | b._crypto_core_ed25519_scalarbytes()), Ki = Vi.address;
        yi.push(Ki), b._crypto_core_ed25519_scalar_negate(Ki, ii);
        var Pn = Pe(Vi, Bi);
        return xr(yi), Pn;
      }
      function d(Ai) {
        var Bi = [];
        ir(Ai);
        var yi = new or(0 | b._crypto_core_ed25519_scalarbytes()), ii = yi.address;
        Bi.push(ii), b._crypto_core_ed25519_scalar_random(ii);
        var ki = Pe(yi, Ai);
        return xr(Bi), ki;
      }
      function v(Ai, Bi) {
        var yi = [];
        ir(Bi), Ai = Fe(yi, Ai, "sample");
        var ii, ki = 0 | b._crypto_core_ed25519_nonreducedscalarbytes();
        Ai.length !== ki && Ce(yi, "invalid sample length"), ii = lr(Ai), yi.push(ii);
        var Vi = new or(0 | b._crypto_core_ed25519_scalarbytes()), Ki = Vi.address;
        yi.push(Ki), b._crypto_core_ed25519_scalar_reduce(Ki, ii);
        var Pn = Pe(Vi, Bi);
        return xr(yi), Pn;
      }
      function he(Ai, Bi, yi) {
        var ii = [];
        ir(yi), Ai = Fe(ii, Ai, "x");
        var ki, Vi = 0 | b._crypto_core_ed25519_scalarbytes();
        Ai.length !== Vi && Ce(ii, "invalid x length"), ki = lr(Ai), ii.push(ki), Bi = Fe(ii, Bi, "y");
        var Ki, Pn = 0 | b._crypto_core_ed25519_scalarbytes();
        Bi.length !== Pn && Ce(ii, "invalid y length"), Ki = lr(Bi), ii.push(Ki);
        var oo = new or(0 | b._crypto_core_ed25519_scalarbytes()), mo = oo.address;
        ii.push(mo), b._crypto_core_ed25519_scalar_sub(mo, ki, Ki);
        var ko = Pe(oo, yi);
        return xr(ii), ko;
      }
      function we(Ai, Bi, yi) {
        var ii = [];
        ir(yi), Ai = Fe(ii, Ai, "p");
        var ki, Vi = 0 | b._crypto_core_ed25519_bytes();
        Ai.length !== Vi && Ce(ii, "invalid p length"), ki = lr(Ai), ii.push(ki), Bi = Fe(ii, Bi, "q");
        var Ki, Pn = 0 | b._crypto_core_ed25519_bytes();
        Bi.length !== Pn && Ce(ii, "invalid q length"), Ki = lr(Bi), ii.push(Ki);
        var oo = new or(0 | b._crypto_core_ed25519_bytes()), mo = oo.address;
        if (ii.push(mo), !(0 | b._crypto_core_ed25519_sub(mo, ki, Ki))) {
          var ko = Pe(oo, yi);
          return xr(ii), ko;
        }
        kr(ii, "input is an invalid element");
      }
      function Be(Ai, Bi, yi, ii) {
        var ki = [];
        ir(ii), Ai = Fe(ki, Ai, "input");
        var Vi, Ki = 0 | b._crypto_core_hchacha20_inputbytes();
        Ai.length !== Ki && Ce(ki, "invalid input length"), Vi = lr(Ai), ki.push(Vi), Bi = Fe(ki, Bi, "privateKey");
        var Pn, oo = 0 | b._crypto_core_hchacha20_keybytes();
        Bi.length !== oo && Ce(ki, "invalid privateKey length"), Pn = lr(Bi), ki.push(Pn);
        var mo = null;
        yi != null && (mo = lr(yi = Fe(ki, yi, "constant")), yi.length, ki.push(mo));
        var ko = new or(0 | b._crypto_core_hchacha20_outputbytes()), $o = ko.address;
        if (ki.push($o), !(0 | b._crypto_core_hchacha20($o, Vi, Pn, mo))) {
          var Jo = Pe(ko, ii);
          return xr(ki), Jo;
        }
        kr(ki, "invalid usage");
      }
      function Me(Ai, Bi, yi, ii) {
        var ki = [];
        ir(ii), Ai = Fe(ki, Ai, "input");
        var Vi, Ki = 0 | b._crypto_core_hsalsa20_inputbytes();
        Ai.length !== Ki && Ce(ki, "invalid input length"), Vi = lr(Ai), ki.push(Vi), Bi = Fe(ki, Bi, "privateKey");
        var Pn, oo = 0 | b._crypto_core_hsalsa20_keybytes();
        Bi.length !== oo && Ce(ki, "invalid privateKey length"), Pn = lr(Bi), ki.push(Pn);
        var mo = null;
        yi != null && (mo = lr(yi = Fe(ki, yi, "constant")), yi.length, ki.push(mo));
        var ko = new or(0 | b._crypto_core_hsalsa20_outputbytes()), $o = ko.address;
        if (ki.push($o), !(0 | b._crypto_core_hsalsa20($o, Vi, Pn, mo))) {
          var Jo = Pe(ko, ii);
          return xr(ki), Jo;
        }
        kr(ki, "invalid usage");
      }
      function fr(Ai, Bi, yi) {
        var ii = [];
        ir(yi), Ai = Fe(ii, Ai, "p");
        var ki, Vi = 0 | b._crypto_core_ristretto255_bytes();
        Ai.length !== Vi && Ce(ii, "invalid p length"), ki = lr(Ai), ii.push(ki), Bi = Fe(ii, Bi, "q");
        var Ki, Pn = 0 | b._crypto_core_ristretto255_bytes();
        Bi.length !== Pn && Ce(ii, "invalid q length"), Ki = lr(Bi), ii.push(Ki);
        var oo = new or(0 | b._crypto_core_ristretto255_bytes()), mo = oo.address;
        if (ii.push(mo), !(0 | b._crypto_core_ristretto255_add(mo, ki, Ki))) {
          var ko = Pe(oo, yi);
          return xr(ii), ko;
        }
        kr(ii, "input is an invalid element");
      }
      function wr(Ai, Bi) {
        var yi = [];
        ir(Bi);
        var ii = lr(Ai = Fe(yi, Ai, "r"));
        Ai.length, yi.push(ii);
        var ki = new or(0 | b._crypto_core_ristretto255_bytes()), Vi = ki.address;
        if (yi.push(Vi), !(0 | b._crypto_core_ristretto255_from_hash(Vi, ii))) {
          var Ki = Pe(ki, Bi);
          return xr(yi), Ki;
        }
        kr(yi, "invalid usage");
      }
      function dr(Ai, Bi) {
        var yi = [];
        ir(Bi), Ai = Fe(yi, Ai, "repr");
        var ii, ki = 0 | b._crypto_core_ristretto255_bytes();
        Ai.length !== ki && Ce(yi, "invalid repr length"), ii = lr(Ai), yi.push(ii);
        var Vi = (0 | b._crypto_core_ristretto255_is_valid_point(ii)) == 1;
        return xr(yi), Vi;
      }
      function Dr(Ai) {
        var Bi = [];
        ir(Ai);
        var yi = new or(0 | b._crypto_core_ristretto255_bytes()), ii = yi.address;
        Bi.push(ii), b._crypto_core_ristretto255_random(ii);
        var ki = Pe(yi, Ai);
        return xr(Bi), ki;
      }
      function Rr(Ai, Bi, yi) {
        var ii = [];
        ir(yi), Ai = Fe(ii, Ai, "x");
        var ki, Vi = 0 | b._crypto_core_ristretto255_scalarbytes();
        Ai.length !== Vi && Ce(ii, "invalid x length"), ki = lr(Ai), ii.push(ki), Bi = Fe(ii, Bi, "y");
        var Ki, Pn = 0 | b._crypto_core_ristretto255_scalarbytes();
        Bi.length !== Pn && Ce(ii, "invalid y length"), Ki = lr(Bi), ii.push(Ki);
        var oo = new or(0 | b._crypto_core_ristretto255_scalarbytes()), mo = oo.address;
        ii.push(mo), b._crypto_core_ristretto255_scalar_add(mo, ki, Ki);
        var ko = Pe(oo, yi);
        return xr(ii), ko;
      }
      function Qe(Ai, Bi) {
        var yi = [];
        ir(Bi), Ai = Fe(yi, Ai, "s");
        var ii, ki = 0 | b._crypto_core_ristretto255_scalarbytes();
        Ai.length !== ki && Ce(yi, "invalid s length"), ii = lr(Ai), yi.push(ii);
        var Vi = new or(0 | b._crypto_core_ristretto255_scalarbytes()), Ki = Vi.address;
        yi.push(Ki), b._crypto_core_ristretto255_scalar_complement(Ki, ii);
        var Pn = Pe(Vi, Bi);
        return xr(yi), Pn;
      }
      function Fr(Ai, Bi) {
        var yi = [];
        ir(Bi), Ai = Fe(yi, Ai, "s");
        var ii, ki = 0 | b._crypto_core_ristretto255_scalarbytes();
        Ai.length !== ki && Ce(yi, "invalid s length"), ii = lr(Ai), yi.push(ii);
        var Vi = new or(0 | b._crypto_core_ristretto255_scalarbytes()), Ki = Vi.address;
        if (yi.push(Ki), !(0 | b._crypto_core_ristretto255_scalar_invert(Ki, ii))) {
          var Pn = Pe(Vi, Bi);
          return xr(yi), Pn;
        }
        kr(yi, "invalid reciprocate");
      }
      function Gr(Ai, Bi, yi) {
        var ii = [];
        ir(yi), Ai = Fe(ii, Ai, "x");
        var ki, Vi = 0 | b._crypto_core_ristretto255_scalarbytes();
        Ai.length !== Vi && Ce(ii, "invalid x length"), ki = lr(Ai), ii.push(ki), Bi = Fe(ii, Bi, "y");
        var Ki, Pn = 0 | b._crypto_core_ristretto255_scalarbytes();
        Bi.length !== Pn && Ce(ii, "invalid y length"), Ki = lr(Bi), ii.push(Ki);
        var oo = new or(0 | b._crypto_core_ristretto255_scalarbytes()), mo = oo.address;
        ii.push(mo), b._crypto_core_ristretto255_scalar_mul(mo, ki, Ki);
        var ko = Pe(oo, yi);
        return xr(ii), ko;
      }
      function $r(Ai, Bi) {
        var yi = [];
        ir(Bi), Ai = Fe(yi, Ai, "s");
        var ii, ki = 0 | b._crypto_core_ristretto255_scalarbytes();
        Ai.length !== ki && Ce(yi, "invalid s length"), ii = lr(Ai), yi.push(ii);
        var Vi = new or(0 | b._crypto_core_ristretto255_scalarbytes()), Ki = Vi.address;
        yi.push(Ki), b._crypto_core_ristretto255_scalar_negate(Ki, ii);
        var Pn = Pe(Vi, Bi);
        return xr(yi), Pn;
      }
      function ni(Ai) {
        var Bi = [];
        ir(Ai);
        var yi = new or(0 | b._crypto_core_ristretto255_scalarbytes()), ii = yi.address;
        Bi.push(ii), b._crypto_core_ristretto255_scalar_random(ii);
        var ki = Pe(yi, Ai);
        return xr(Bi), ki;
      }
      function mi(Ai, Bi) {
        var yi = [];
        ir(Bi), Ai = Fe(yi, Ai, "sample");
        var ii, ki = 0 | b._crypto_core_ristretto255_nonreducedscalarbytes();
        Ai.length !== ki && Ce(yi, "invalid sample length"), ii = lr(Ai), yi.push(ii);
        var Vi = new or(0 | b._crypto_core_ristretto255_scalarbytes()), Ki = Vi.address;
        yi.push(Ki), b._crypto_core_ristretto255_scalar_reduce(Ki, ii);
        var Pn = Pe(Vi, Bi);
        return xr(yi), Pn;
      }
      function Si(Ai, Bi, yi) {
        var ii = [];
        ir(yi), Ai = Fe(ii, Ai, "x");
        var ki, Vi = 0 | b._crypto_core_ristretto255_scalarbytes();
        Ai.length !== Vi && Ce(ii, "invalid x length"), ki = lr(Ai), ii.push(ki), Bi = Fe(ii, Bi, "y");
        var Ki, Pn = 0 | b._crypto_core_ristretto255_scalarbytes();
        Bi.length !== Pn && Ce(ii, "invalid y length"), Ki = lr(Bi), ii.push(Ki);
        var oo = new or(0 | b._crypto_core_ristretto255_scalarbytes()), mo = oo.address;
        ii.push(mo), b._crypto_core_ristretto255_scalar_sub(mo, ki, Ki);
        var ko = Pe(oo, yi);
        return xr(ii), ko;
      }
      function Oi(Ai, Bi, yi) {
        var ii = [];
        ir(yi), Ai = Fe(ii, Ai, "p");
        var ki, Vi = 0 | b._crypto_core_ristretto255_bytes();
        Ai.length !== Vi && Ce(ii, "invalid p length"), ki = lr(Ai), ii.push(ki), Bi = Fe(ii, Bi, "q");
        var Ki, Pn = 0 | b._crypto_core_ristretto255_bytes();
        Bi.length !== Pn && Ce(ii, "invalid q length"), Ki = lr(Bi), ii.push(Ki);
        var oo = new or(0 | b._crypto_core_ristretto255_bytes()), mo = oo.address;
        if (ii.push(mo), !(0 | b._crypto_core_ristretto255_sub(mo, ki, Ki))) {
          var ko = Pe(oo, yi);
          return xr(ii), ko;
        }
        kr(ii, "input is an invalid element");
      }
      function $i(Ai, Bi, yi, ii) {
        var ki = [];
        ir(ii), tr(ki, Ai, "hash_length"), (typeof Ai != "number" || (0 | Ai) !== Ai || Ai < 0) && Ce(ki, "hash_length must be an unsigned integer");
        var Vi = lr(Bi = Fe(ki, Bi, "message")), Ki = Bi.length;
        ki.push(Vi);
        var Pn = null, oo = 0;
        yi != null && (Pn = lr(yi = Fe(ki, yi, "key")), oo = yi.length, ki.push(Pn));
        var mo = new or(Ai |= 0), ko = mo.address;
        if (ki.push(ko), !(0 | b._crypto_generichash(ko, Ai, Vi, Ki, 0, Pn, oo))) {
          var $o = Pe(mo, ii);
          return xr(ki), $o;
        }
        kr(ki, "invalid usage");
      }
      function zi(Ai, Bi, yi, ii, ki) {
        var Vi = [];
        ir(ki), tr(Vi, Ai, "subkey_len"), (typeof Ai != "number" || (0 | Ai) !== Ai || Ai < 0) && Ce(Vi, "subkey_len must be an unsigned integer");
        var Ki = null, Pn = 0;
        Bi != null && (Ki = lr(Bi = Fe(Vi, Bi, "key")), Pn = Bi.length, Vi.push(Ki));
        var oo = null, mo = 0;
        yi != null && (yi = Fe(Vi, yi, "id"), mo = 0 | b._crypto_generichash_blake2b_saltbytes(), yi.length !== mo && Ce(Vi, "invalid id length"), oo = lr(yi), Vi.push(oo));
        var ko = null, $o = 0;
        ii != null && (ii = Fe(Vi, ii, "ctx"), $o = 0 | b._crypto_generichash_blake2b_personalbytes(), ii.length !== $o && Ce(Vi, "invalid ctx length"), ko = lr(ii), Vi.push(ko));
        var Jo = new or(0 | Ai), hs = Jo.address;
        if (Vi.push(hs), !(0 | b._crypto_generichash_blake2b_salt_personal(hs, Ai, null, 0, 0, Ki, Pn, oo, ko))) {
          var Ss = Pe(Jo, ki);
          return xr(Vi), Ss;
        }
        kr(Vi, "invalid usage");
      }
      function un(Ai, Bi, yi) {
        var ii = [];
        ir(yi), tr(ii, Ai, "state_address"), tr(ii, Bi, "hash_length"), (typeof Bi != "number" || (0 | Bi) !== Bi || Bi < 0) && Ce(ii, "hash_length must be an unsigned integer");
        var ki = new or(Bi |= 0), Vi = ki.address;
        if (ii.push(Vi), !(0 | b._crypto_generichash_final(Ai, Vi, Bi))) {
          var Ki = (b._free(Ai), Pe(ki, yi));
          return xr(ii), Ki;
        }
        kr(ii, "invalid usage");
      }
      function In(Ai, Bi, yi) {
        var ii = [];
        ir(yi);
        var ki = null, Vi = 0;
        Ai != null && (ki = lr(Ai = Fe(ii, Ai, "key")), Vi = Ai.length, ii.push(ki)), tr(ii, Bi, "hash_length"), (typeof Bi != "number" || (0 | Bi) !== Bi || Bi < 0) && Ce(ii, "hash_length must be an unsigned integer");
        var Ki = new or(357).address;
        if (!(0 | b._crypto_generichash_init(Ki, ki, Vi, Bi))) {
          var Pn = Ki;
          return xr(ii), Pn;
        }
        kr(ii, "invalid usage");
      }
      function Ti(Ai) {
        var Bi = [];
        ir(Ai);
        var yi = new or(0 | b._crypto_generichash_keybytes()), ii = yi.address;
        Bi.push(ii), b._crypto_generichash_keygen(ii);
        var ki = Pe(yi, Ai);
        return xr(Bi), ki;
      }
      function Sn(Ai, Bi, yi) {
        var ii = [];
        ir(yi), tr(ii, Ai, "state_address");
        var ki = lr(Bi = Fe(ii, Bi, "message_chunk")), Vi = Bi.length;
        ii.push(ki), 0 | b._crypto_generichash_update(Ai, ki, Vi) && kr(ii, "invalid usage"), xr(ii);
      }
      function Kn(Ai, Bi) {
        var yi = [];
        ir(Bi);
        var ii = lr(Ai = Fe(yi, Ai, "message")), ki = Ai.length;
        yi.push(ii);
        var Vi = new or(0 | b._crypto_hash_bytes()), Ki = Vi.address;
        if (yi.push(Ki), !(0 | b._crypto_hash(Ki, ii, ki, 0))) {
          var Pn = Pe(Vi, Bi);
          return xr(yi), Pn;
        }
        kr(yi, "invalid usage");
      }
      function Vn(Ai, Bi) {
        var yi = [];
        ir(Bi);
        var ii = lr(Ai = Fe(yi, Ai, "message")), ki = Ai.length;
        yi.push(ii);
        var Vi = new or(0 | b._crypto_hash_sha256_bytes()), Ki = Vi.address;
        if (yi.push(Ki), !(0 | b._crypto_hash_sha256(Ki, ii, ki, 0))) {
          var Pn = Pe(Vi, Bi);
          return xr(yi), Pn;
        }
        kr(yi, "invalid usage");
      }
      function Xn(Ai, Bi) {
        var yi = [];
        ir(Bi), tr(yi, Ai, "state_address");
        var ii = new or(0 | b._crypto_hash_sha256_bytes()), ki = ii.address;
        if (yi.push(ki), !(0 | b._crypto_hash_sha256_final(Ai, ki))) {
          var Vi = (b._free(Ai), Pe(ii, Bi));
          return xr(yi), Vi;
        }
        kr(yi, "invalid usage");
      }
      function uo(Ai) {
        var Bi = [];
        ir(Ai);
        var yi = new or(104).address;
        if (!(0 | b._crypto_hash_sha256_init(yi))) {
          var ii = yi;
          return xr(Bi), ii;
        }
        kr(Bi, "invalid usage");
      }
      function yo(Ai, Bi, yi) {
        var ii = [];
        ir(yi), tr(ii, Ai, "state_address");
        var ki = lr(Bi = Fe(ii, Bi, "message_chunk")), Vi = Bi.length;
        ii.push(ki), 0 | b._crypto_hash_sha256_update(Ai, ki, Vi) && kr(ii, "invalid usage"), xr(ii);
      }
      function Io(Ai, Bi) {
        var yi = [];
        ir(Bi);
        var ii = lr(Ai = Fe(yi, Ai, "message")), ki = Ai.length;
        yi.push(ii);
        var Vi = new or(0 | b._crypto_hash_sha512_bytes()), Ki = Vi.address;
        if (yi.push(Ki), !(0 | b._crypto_hash_sha512(Ki, ii, ki, 0))) {
          var Pn = Pe(Vi, Bi);
          return xr(yi), Pn;
        }
        kr(yi, "invalid usage");
      }
      function xo(Ai, Bi) {
        var yi = [];
        ir(Bi), tr(yi, Ai, "state_address");
        var ii = new or(0 | b._crypto_hash_sha512_bytes()), ki = ii.address;
        if (yi.push(ki), !(0 | b._crypto_hash_sha512_final(Ai, ki))) {
          var Vi = (b._free(Ai), Pe(ii, Bi));
          return xr(yi), Vi;
        }
        kr(yi, "invalid usage");
      }
      function Mo(Ai) {
        var Bi = [];
        ir(Ai);
        var yi = new or(208).address;
        if (!(0 | b._crypto_hash_sha512_init(yi))) {
          var ii = yi;
          return xr(Bi), ii;
        }
        kr(Bi, "invalid usage");
      }
      function qi(Ai, Bi, yi) {
        var ii = [];
        ir(yi), tr(ii, Ai, "state_address");
        var ki = lr(Bi = Fe(ii, Bi, "message_chunk")), Vi = Bi.length;
        ii.push(ki), 0 | b._crypto_hash_sha512_update(Ai, ki, Vi) && kr(ii, "invalid usage"), xr(ii);
      }
      function Oo(Ai, Bi, yi, ii, ki) {
        var Vi = [];
        ir(ki), tr(Vi, Ai, "subkey_len"), (typeof Ai != "number" || (0 | Ai) !== Ai || Ai < 0) && Ce(Vi, "subkey_len must be an unsigned integer"), tr(Vi, Bi, "subkey_id");
        var Ki, Pn = 0;
        if (typeof Bi == "bigint" && Bi >= BigInt(0)) {
          const Us = Bi >> BigInt(32);
          Us > BigInt(4294967295) && Ce(Vi, "subkey_id cannot be more than 64 bits"), Pn = Number(Us), Ki = Number(Bi & BigInt(4294967295));
        } else typeof Bi == "number" && (0 | Bi) === Bi && Bi >= 0 ? Ki = Bi : Ce(Vi, "subkey_id must be an unsigned integer or bigint");
        typeof yi != "string" && Ce(Vi, "ctx must be a string"), yi = L(yi + "\0"), mo != null && yi.length - 1 !== mo && Ce(Vi, "invalid ctx length");
        var oo = lr(yi), mo = yi.length - 1;
        Vi.push(oo), ii = Fe(Vi, ii, "key");
        var ko, $o = 0 | b._crypto_kdf_keybytes();
        ii.length !== $o && Ce(Vi, "invalid key length"), ko = lr(ii), Vi.push(ko);
        var Jo = new or(0 | Ai), hs = Jo.address;
        Vi.push(hs), b._crypto_kdf_derive_from_key(hs, Ai, Ki, Pn, oo, ko);
        var Ss = Pe(Jo, ki);
        return xr(Vi), Ss;
      }
      function Ho(Ai) {
        var Bi = [];
        ir(Ai);
        var yi = new or(0 | b._crypto_kdf_keybytes()), ii = yi.address;
        Bi.push(ii), b._crypto_kdf_keygen(ii);
        var ki = Pe(yi, Ai);
        return xr(Bi), ki;
      }
      function Go(Ai, Bi, yi, ii) {
        var ki = [];
        ir(ii), Ai = Fe(ki, Ai, "clientPublicKey");
        var Vi, Ki = 0 | b._crypto_kx_publickeybytes();
        Ai.length !== Ki && Ce(ki, "invalid clientPublicKey length"), Vi = lr(Ai), ki.push(Vi), Bi = Fe(ki, Bi, "clientSecretKey");
        var Pn, oo = 0 | b._crypto_kx_secretkeybytes();
        Bi.length !== oo && Ce(ki, "invalid clientSecretKey length"), Pn = lr(Bi), ki.push(Pn), yi = Fe(ki, yi, "serverPublicKey");
        var mo, ko = 0 | b._crypto_kx_publickeybytes();
        yi.length !== ko && Ce(ki, "invalid serverPublicKey length"), mo = lr(yi), ki.push(mo);
        var $o = new or(0 | b._crypto_kx_sessionkeybytes()), Jo = $o.address;
        ki.push(Jo);
        var hs = new or(0 | b._crypto_kx_sessionkeybytes()), Ss = hs.address;
        if (ki.push(Ss), !(0 | b._crypto_kx_client_session_keys(Jo, Ss, Vi, Pn, mo))) {
          var Us = Pe({ sharedRx: $o, sharedTx: hs }, ii);
          return xr(ki), Us;
        }
        kr(ki, "invalid usage");
      }
      function ns(Ai) {
        var Bi = [];
        ir(Ai);
        var yi = new or(0 | b._crypto_kx_publickeybytes()), ii = yi.address;
        Bi.push(ii);
        var ki = new or(0 | b._crypto_kx_secretkeybytes()), Vi = ki.address;
        if (Bi.push(Vi), !(0 | b._crypto_kx_keypair(ii, Vi))) {
          var Ki = { publicKey: Pe(yi, Ai), privateKey: Pe(ki, Ai), keyType: "x25519" };
          return xr(Bi), Ki;
        }
        kr(Bi, "internal error");
      }
      function ds(Ai, Bi) {
        var yi = [];
        ir(Bi), Ai = Fe(yi, Ai, "seed");
        var ii, ki = 0 | b._crypto_kx_seedbytes();
        Ai.length !== ki && Ce(yi, "invalid seed length"), ii = lr(Ai), yi.push(ii);
        var Vi = new or(0 | b._crypto_kx_publickeybytes()), Ki = Vi.address;
        yi.push(Ki);
        var Pn = new or(0 | b._crypto_kx_secretkeybytes()), oo = Pn.address;
        if (yi.push(oo), !(0 | b._crypto_kx_seed_keypair(Ki, oo, ii))) {
          var mo = { publicKey: Pe(Vi, Bi), privateKey: Pe(Pn, Bi), keyType: "x25519" };
          return xr(yi), mo;
        }
        kr(yi, "internal error");
      }
      function Ts(Ai, Bi, yi, ii) {
        var ki = [];
        ir(ii), Ai = Fe(ki, Ai, "serverPublicKey");
        var Vi, Ki = 0 | b._crypto_kx_publickeybytes();
        Ai.length !== Ki && Ce(ki, "invalid serverPublicKey length"), Vi = lr(Ai), ki.push(Vi), Bi = Fe(ki, Bi, "serverSecretKey");
        var Pn, oo = 0 | b._crypto_kx_secretkeybytes();
        Bi.length !== oo && Ce(ki, "invalid serverSecretKey length"), Pn = lr(Bi), ki.push(Pn), yi = Fe(ki, yi, "clientPublicKey");
        var mo, ko = 0 | b._crypto_kx_publickeybytes();
        yi.length !== ko && Ce(ki, "invalid clientPublicKey length"), mo = lr(yi), ki.push(mo);
        var $o = new or(0 | b._crypto_kx_sessionkeybytes()), Jo = $o.address;
        ki.push(Jo);
        var hs = new or(0 | b._crypto_kx_sessionkeybytes()), Ss = hs.address;
        if (ki.push(Ss), !(0 | b._crypto_kx_server_session_keys(Jo, Ss, Vi, Pn, mo))) {
          var Us = Pe({ sharedRx: $o, sharedTx: hs }, ii);
          return xr(ki), Us;
        }
        kr(ki, "invalid usage");
      }
      function Ao(Ai, Bi, yi) {
        var ii = [];
        ir(yi);
        var ki = lr(Ai = Fe(ii, Ai, "message")), Vi = Ai.length;
        ii.push(ki), Bi = Fe(ii, Bi, "key");
        var Ki, Pn = 0 | b._crypto_onetimeauth_keybytes();
        Bi.length !== Pn && Ce(ii, "invalid key length"), Ki = lr(Bi), ii.push(Ki);
        var oo = new or(0 | b._crypto_onetimeauth_bytes()), mo = oo.address;
        if (ii.push(mo), !(0 | b._crypto_onetimeauth(mo, ki, Vi, 0, Ki))) {
          var ko = Pe(oo, yi);
          return xr(ii), ko;
        }
        kr(ii, "invalid usage");
      }
      function po(Ai, Bi) {
        var yi = [];
        ir(Bi), tr(yi, Ai, "state_address");
        var ii = new or(0 | b._crypto_onetimeauth_bytes()), ki = ii.address;
        if (yi.push(ki), !(0 | b._crypto_onetimeauth_final(Ai, ki))) {
          var Vi = (b._free(Ai), Pe(ii, Bi));
          return xr(yi), Vi;
        }
        kr(yi, "invalid usage");
      }
      function _o(Ai, Bi) {
        var yi = [];
        ir(Bi);
        var ii = null;
        Ai != null && (ii = lr(Ai = Fe(yi, Ai, "key")), Ai.length, yi.push(ii));
        var ki = new or(144).address;
        if (!(0 | b._crypto_onetimeauth_init(ki, ii))) {
          var Vi = ki;
          return xr(yi), Vi;
        }
        kr(yi, "invalid usage");
      }
      function Uo(Ai) {
        var Bi = [];
        ir(Ai);
        var yi = new or(0 | b._crypto_onetimeauth_keybytes()), ii = yi.address;
        Bi.push(ii), b._crypto_onetimeauth_keygen(ii);
        var ki = Pe(yi, Ai);
        return xr(Bi), ki;
      }
      function ts(Ai, Bi, yi) {
        var ii = [];
        ir(yi), tr(ii, Ai, "state_address");
        var ki = lr(Bi = Fe(ii, Bi, "message_chunk")), Vi = Bi.length;
        ii.push(ki), 0 | b._crypto_onetimeauth_update(Ai, ki, Vi) && kr(ii, "invalid usage"), xr(ii);
      }
      function Lo(Ai, Bi, yi) {
        var ii = [];
        Ai = Fe(ii, Ai, "hash");
        var ki, Vi = 0 | b._crypto_onetimeauth_bytes();
        Ai.length !== Vi && Ce(ii, "invalid hash length"), ki = lr(Ai), ii.push(ki);
        var Ki = lr(Bi = Fe(ii, Bi, "message")), Pn = Bi.length;
        ii.push(Ki), yi = Fe(ii, yi, "key");
        var oo, mo = 0 | b._crypto_onetimeauth_keybytes();
        yi.length !== mo && Ce(ii, "invalid key length"), oo = lr(yi), ii.push(oo);
        var ko = !(0 | b._crypto_onetimeauth_verify(ki, Ki, Pn, 0, oo));
        return xr(ii), ko;
      }
      function Wo(Ai, Bi, yi, ii, ki, Vi, Ki) {
        var Pn = [];
        ir(Ki), tr(Pn, Ai, "keyLength"), (typeof Ai != "number" || (0 | Ai) !== Ai || Ai < 0) && Ce(Pn, "keyLength must be an unsigned integer");
        var oo = lr(Bi = Fe(Pn, Bi, "password")), mo = Bi.length;
        Pn.push(oo), yi = Fe(Pn, yi, "salt");
        var ko, $o = 0 | b._crypto_pwhash_saltbytes();
        yi.length !== $o && Ce(Pn, "invalid salt length"), ko = lr(yi), Pn.push(ko), tr(Pn, ii, "opsLimit"), (typeof ii != "number" || (0 | ii) !== ii || ii < 0) && Ce(Pn, "opsLimit must be an unsigned integer"), tr(Pn, ki, "memLimit"), (typeof ki != "number" || (0 | ki) !== ki || ki < 0) && Ce(Pn, "memLimit must be an unsigned integer"), tr(Pn, Vi, "algorithm"), (typeof Vi != "number" || (0 | Vi) !== Vi || Vi < 0) && Ce(Pn, "algorithm must be an unsigned integer");
        var Jo = new or(0 | Ai), hs = Jo.address;
        if (Pn.push(hs), !(0 | b._crypto_pwhash(hs, Ai, 0, oo, mo, 0, ko, ii, 0, ki, Vi))) {
          var Ss = Pe(Jo, Ki);
          return xr(Pn), Ss;
        }
        kr(Pn, "invalid usage");
      }
      function ps(Ai, Bi, yi, ii, ki, Vi) {
        var Ki = [];
        ir(Vi), tr(Ki, Ai, "keyLength"), (typeof Ai != "number" || (0 | Ai) !== Ai || Ai < 0) && Ce(Ki, "keyLength must be an unsigned integer");
        var Pn = lr(Bi = Fe(Ki, Bi, "password")), oo = Bi.length;
        Ki.push(Pn), yi = Fe(Ki, yi, "salt");
        var mo, ko = 0 | b._crypto_pwhash_scryptsalsa208sha256_saltbytes();
        yi.length !== ko && Ce(Ki, "invalid salt length"), mo = lr(yi), Ki.push(mo), tr(Ki, ii, "opsLimit"), (typeof ii != "number" || (0 | ii) !== ii || ii < 0) && Ce(Ki, "opsLimit must be an unsigned integer"), tr(Ki, ki, "memLimit"), (typeof ki != "number" || (0 | ki) !== ki || ki < 0) && Ce(Ki, "memLimit must be an unsigned integer");
        var $o = new or(0 | Ai), Jo = $o.address;
        if (Ki.push(Jo), !(0 | b._crypto_pwhash_scryptsalsa208sha256(Jo, Ai, 0, Pn, oo, 0, mo, ii, 0, ki))) {
          var hs = Pe($o, Vi);
          return xr(Ki), hs;
        }
        kr(Ki, "invalid usage");
      }
      function Bs(Ai, Bi, yi, ii, ki, Vi, Ki) {
        var Pn = [];
        ir(Ki);
        var oo = lr(Ai = Fe(Pn, Ai, "password")), mo = Ai.length;
        Pn.push(oo);
        var ko = lr(Bi = Fe(Pn, Bi, "salt")), $o = Bi.length;
        Pn.push(ko), tr(Pn, yi, "opsLimit"), (typeof yi != "number" || (0 | yi) !== yi || yi < 0) && Ce(Pn, "opsLimit must be an unsigned integer"), tr(Pn, ii, "r"), (typeof ii != "number" || (0 | ii) !== ii || ii < 0) && Ce(Pn, "r must be an unsigned integer"), tr(Pn, ki, "p"), (typeof ki != "number" || (0 | ki) !== ki || ki < 0) && Ce(Pn, "p must be an unsigned integer"), tr(Pn, Vi, "keyLength"), (typeof Vi != "number" || (0 | Vi) !== Vi || Vi < 0) && Ce(Pn, "keyLength must be an unsigned integer");
        var Jo = new or(0 | Vi), hs = Jo.address;
        if (Pn.push(hs), !(0 | b._crypto_pwhash_scryptsalsa208sha256_ll(oo, mo, ko, $o, yi, 0, ii, ki, hs, Vi))) {
          var Ss = Pe(Jo, Ki);
          return xr(Pn), Ss;
        }
        kr(Pn, "invalid usage");
      }
      function Xs(Ai, Bi, yi, ii) {
        var ki = [];
        ir(ii);
        var Vi = lr(Ai = Fe(ki, Ai, "password")), Ki = Ai.length;
        ki.push(Vi), tr(ki, Bi, "opsLimit"), (typeof Bi != "number" || (0 | Bi) !== Bi || Bi < 0) && Ce(ki, "opsLimit must be an unsigned integer"), tr(ki, yi, "memLimit"), (typeof yi != "number" || (0 | yi) !== yi || yi < 0) && Ce(ki, "memLimit must be an unsigned integer");
        var Pn = new or(0 | b._crypto_pwhash_scryptsalsa208sha256_strbytes()).address;
        if (ki.push(Pn), !(0 | b._crypto_pwhash_scryptsalsa208sha256_str(Pn, Vi, Ki, 0, Bi, 0, yi))) {
          var oo = b.UTF8ToString(Pn);
          return xr(ki), oo;
        }
        kr(ki, "invalid usage");
      }
      function js(Ai, Bi, yi) {
        var ii = [];
        ir(yi), typeof Ai != "string" && Ce(ii, "hashed_password must be a string"), Ai = L(Ai + "\0"), Vi != null && Ai.length - 1 !== Vi && Ce(ii, "invalid hashed_password length");
        var ki = lr(Ai), Vi = Ai.length - 1;
        ii.push(ki);
        var Ki = lr(Bi = Fe(ii, Bi, "password")), Pn = Bi.length;
        ii.push(Ki);
        var oo = !(0 | b._crypto_pwhash_scryptsalsa208sha256_str_verify(ki, Ki, Pn, 0));
        return xr(ii), oo;
      }
      function ya(Ai, Bi, yi, ii) {
        var ki = [];
        ir(ii);
        var Vi = lr(Ai = Fe(ki, Ai, "password")), Ki = Ai.length;
        ki.push(Vi), tr(ki, Bi, "opsLimit"), (typeof Bi != "number" || (0 | Bi) !== Bi || Bi < 0) && Ce(ki, "opsLimit must be an unsigned integer"), tr(ki, yi, "memLimit"), (typeof yi != "number" || (0 | yi) !== yi || yi < 0) && Ce(ki, "memLimit must be an unsigned integer");
        var Pn = new or(0 | b._crypto_pwhash_strbytes()).address;
        if (ki.push(Pn), !(0 | b._crypto_pwhash_str(Pn, Vi, Ki, 0, Bi, 0, yi))) {
          var oo = b.UTF8ToString(Pn);
          return xr(ki), oo;
        }
        kr(ki, "invalid usage");
      }
      function sa(Ai, Bi, yi, ii) {
        var ki = [];
        ir(ii), typeof Ai != "string" && Ce(ki, "hashed_password must be a string"), Ai = L(Ai + "\0"), Ki != null && Ai.length - 1 !== Ki && Ce(ki, "invalid hashed_password length");
        var Vi = lr(Ai), Ki = Ai.length - 1;
        ki.push(Vi), tr(ki, Bi, "opsLimit"), (typeof Bi != "number" || (0 | Bi) !== Bi || Bi < 0) && Ce(ki, "opsLimit must be an unsigned integer"), tr(ki, yi, "memLimit"), (typeof yi != "number" || (0 | yi) !== yi || yi < 0) && Ce(ki, "memLimit must be an unsigned integer");
        var Pn = !!(0 | b._crypto_pwhash_str_needs_rehash(Vi, Bi, 0, yi));
        return xr(ki), Pn;
      }
      function va(Ai, Bi, yi) {
        var ii = [];
        ir(yi), typeof Ai != "string" && Ce(ii, "hashed_password must be a string"), Ai = L(Ai + "\0"), Vi != null && Ai.length - 1 !== Vi && Ce(ii, "invalid hashed_password length");
        var ki = lr(Ai), Vi = Ai.length - 1;
        ii.push(ki);
        var Ki = lr(Bi = Fe(ii, Bi, "password")), Pn = Bi.length;
        ii.push(Ki);
        var oo = !(0 | b._crypto_pwhash_str_verify(ki, Ki, Pn, 0));
        return xr(ii), oo;
      }
      function oa(Ai, Bi, yi) {
        var ii = [];
        ir(yi), Ai = Fe(ii, Ai, "privateKey");
        var ki, Vi = 0 | b._crypto_scalarmult_scalarbytes();
        Ai.length !== Vi && Ce(ii, "invalid privateKey length"), ki = lr(Ai), ii.push(ki), Bi = Fe(ii, Bi, "publicKey");
        var Ki, Pn = 0 | b._crypto_scalarmult_bytes();
        Bi.length !== Pn && Ce(ii, "invalid publicKey length"), Ki = lr(Bi), ii.push(Ki);
        var oo = new or(0 | b._crypto_scalarmult_bytes()), mo = oo.address;
        if (ii.push(mo), !(0 | b._crypto_scalarmult(mo, ki, Ki))) {
          var ko = Pe(oo, yi);
          return xr(ii), ko;
        }
        kr(ii, "weak public key");
      }
      function wa(Ai, Bi) {
        var yi = [];
        ir(Bi), Ai = Fe(yi, Ai, "privateKey");
        var ii, ki = 0 | b._crypto_scalarmult_scalarbytes();
        Ai.length !== ki && Ce(yi, "invalid privateKey length"), ii = lr(Ai), yi.push(ii);
        var Vi = new or(0 | b._crypto_scalarmult_bytes()), Ki = Vi.address;
        if (yi.push(Ki), !(0 | b._crypto_scalarmult_base(Ki, ii))) {
          var Pn = Pe(Vi, Bi);
          return xr(yi), Pn;
        }
        kr(yi, "unknown error");
      }
      function Pa(Ai, Bi, yi) {
        var ii = [];
        ir(yi), Ai = Fe(ii, Ai, "n");
        var ki, Vi = 0 | b._crypto_scalarmult_ed25519_scalarbytes();
        Ai.length !== Vi && Ce(ii, "invalid n length"), ki = lr(Ai), ii.push(ki), Bi = Fe(ii, Bi, "p");
        var Ki, Pn = 0 | b._crypto_scalarmult_ed25519_bytes();
        Bi.length !== Pn && Ce(ii, "invalid p length"), Ki = lr(Bi), ii.push(Ki);
        var oo = new or(0 | b._crypto_scalarmult_ed25519_bytes()), mo = oo.address;
        if (ii.push(mo), !(0 | b._crypto_scalarmult_ed25519(mo, ki, Ki))) {
          var ko = Pe(oo, yi);
          return xr(ii), ko;
        }
        kr(ii, "invalid point or scalar is 0");
      }
      function Ta(Ai, Bi) {
        var yi = [];
        ir(Bi), Ai = Fe(yi, Ai, "scalar");
        var ii, ki = 0 | b._crypto_scalarmult_ed25519_scalarbytes();
        Ai.length !== ki && Ce(yi, "invalid scalar length"), ii = lr(Ai), yi.push(ii);
        var Vi = new or(0 | b._crypto_scalarmult_ed25519_bytes()), Ki = Vi.address;
        if (yi.push(Ki), !(0 | b._crypto_scalarmult_ed25519_base(Ki, ii))) {
          var Pn = Pe(Vi, Bi);
          return xr(yi), Pn;
        }
        kr(yi, "scalar is 0");
      }
      function jn(Ai, Bi) {
        var yi = [];
        ir(Bi), Ai = Fe(yi, Ai, "scalar");
        var ii, ki = 0 | b._crypto_scalarmult_ed25519_scalarbytes();
        Ai.length !== ki && Ce(yi, "invalid scalar length"), ii = lr(Ai), yi.push(ii);
        var Vi = new or(0 | b._crypto_scalarmult_ed25519_bytes()), Ki = Vi.address;
        if (yi.push(Ki), !(0 | b._crypto_scalarmult_ed25519_base_noclamp(Ki, ii))) {
          var Pn = Pe(Vi, Bi);
          return xr(yi), Pn;
        }
        kr(yi, "scalar is 0");
      }
      function ta(Ai, Bi, yi) {
        var ii = [];
        ir(yi), Ai = Fe(ii, Ai, "n");
        var ki, Vi = 0 | b._crypto_scalarmult_ed25519_scalarbytes();
        Ai.length !== Vi && Ce(ii, "invalid n length"), ki = lr(Ai), ii.push(ki), Bi = Fe(ii, Bi, "p");
        var Ki, Pn = 0 | b._crypto_scalarmult_ed25519_bytes();
        Bi.length !== Pn && Ce(ii, "invalid p length"), Ki = lr(Bi), ii.push(Ki);
        var oo = new or(0 | b._crypto_scalarmult_ed25519_bytes()), mo = oo.address;
        if (ii.push(mo), !(0 | b._crypto_scalarmult_ed25519_noclamp(mo, ki, Ki))) {
          var ko = Pe(oo, yi);
          return xr(ii), ko;
        }
        kr(ii, "invalid point or scalar is 0");
      }
      function Na(Ai, Bi, yi) {
        var ii = [];
        ir(yi), Ai = Fe(ii, Ai, "scalar");
        var ki, Vi = 0 | b._crypto_scalarmult_ristretto255_scalarbytes();
        Ai.length !== Vi && Ce(ii, "invalid scalar length"), ki = lr(Ai), ii.push(ki), Bi = Fe(ii, Bi, "element");
        var Ki, Pn = 0 | b._crypto_scalarmult_ristretto255_bytes();
        Bi.length !== Pn && Ce(ii, "invalid element length"), Ki = lr(Bi), ii.push(Ki);
        var oo = new or(0 | b._crypto_scalarmult_ristretto255_bytes()), mo = oo.address;
        if (ii.push(mo), !(0 | b._crypto_scalarmult_ristretto255(mo, ki, Ki))) {
          var ko = Pe(oo, yi);
          return xr(ii), ko;
        }
        kr(ii, "result is identity element");
      }
      function ba(Ai, Bi) {
        var yi = [];
        ir(Bi), Ai = Fe(yi, Ai, "scalar");
        var ii, ki = 0 | b._crypto_core_ristretto255_scalarbytes();
        Ai.length !== ki && Ce(yi, "invalid scalar length"), ii = lr(Ai), yi.push(ii);
        var Vi = new or(0 | b._crypto_core_ristretto255_bytes()), Ki = Vi.address;
        if (yi.push(Ki), !(0 | b._crypto_scalarmult_ristretto255_base(Ki, ii))) {
          var Pn = Pe(Vi, Bi);
          return xr(yi), Pn;
        }
        kr(yi, "scalar is 0");
      }
      function Aa(Ai, Bi, yi, ii) {
        var ki = [];
        ir(ii);
        var Vi = lr(Ai = Fe(ki, Ai, "message")), Ki = Ai.length;
        ki.push(Vi), Bi = Fe(ki, Bi, "nonce");
        var Pn, oo = 0 | b._crypto_secretbox_noncebytes();
        Bi.length !== oo && Ce(ki, "invalid nonce length"), Pn = lr(Bi), ki.push(Pn), yi = Fe(ki, yi, "key");
        var mo, ko = 0 | b._crypto_secretbox_keybytes();
        yi.length !== ko && Ce(ki, "invalid key length"), mo = lr(yi), ki.push(mo);
        var $o = new or(0 | Ki), Jo = $o.address;
        ki.push(Jo);
        var hs = new or(0 | b._crypto_secretbox_macbytes()), Ss = hs.address;
        if (ki.push(Ss), !(0 | b._crypto_secretbox_detached(Jo, Ss, Vi, Ki, 0, Pn, mo))) {
          var Us = Pe({ mac: hs, cipher: $o }, ii);
          return xr(ki), Us;
        }
        kr(ki, "invalid usage");
      }
      function zs(Ai, Bi, yi, ii) {
        var ki = [];
        ir(ii);
        var Vi = lr(Ai = Fe(ki, Ai, "message")), Ki = Ai.length;
        ki.push(Vi), Bi = Fe(ki, Bi, "nonce");
        var Pn, oo = 0 | b._crypto_secretbox_noncebytes();
        Bi.length !== oo && Ce(ki, "invalid nonce length"), Pn = lr(Bi), ki.push(Pn), yi = Fe(ki, yi, "key");
        var mo, ko = 0 | b._crypto_secretbox_keybytes();
        yi.length !== ko && Ce(ki, "invalid key length"), mo = lr(yi), ki.push(mo);
        var $o = new or(Ki + b._crypto_secretbox_macbytes() | 0), Jo = $o.address;
        if (ki.push(Jo), !(0 | b._crypto_secretbox_easy(Jo, Vi, Ki, 0, Pn, mo))) {
          var hs = Pe($o, ii);
          return xr(ki), hs;
        }
        kr(ki, "invalid usage");
      }
      function x2(Ai) {
        var Bi = [];
        ir(Ai);
        var yi = new or(0 | b._crypto_secretbox_keybytes()), ii = yi.address;
        Bi.push(ii), b._crypto_secretbox_keygen(ii);
        var ki = Pe(yi, Ai);
        return xr(Bi), ki;
      }
      function Va(Ai, Bi, yi, ii, ki) {
        var Vi = [];
        ir(ki);
        var Ki = lr(Ai = Fe(Vi, Ai, "ciphertext")), Pn = Ai.length;
        Vi.push(Ki), Bi = Fe(Vi, Bi, "mac");
        var oo, mo = 0 | b._crypto_secretbox_macbytes();
        Bi.length !== mo && Ce(Vi, "invalid mac length"), oo = lr(Bi), Vi.push(oo), yi = Fe(Vi, yi, "nonce");
        var ko, $o = 0 | b._crypto_secretbox_noncebytes();
        yi.length !== $o && Ce(Vi, "invalid nonce length"), ko = lr(yi), Vi.push(ko), ii = Fe(Vi, ii, "key");
        var Jo, hs = 0 | b._crypto_secretbox_keybytes();
        ii.length !== hs && Ce(Vi, "invalid key length"), Jo = lr(ii), Vi.push(Jo);
        var Ss = new or(0 | Pn), Us = Ss.address;
        if (Vi.push(Us), !(0 | b._crypto_secretbox_open_detached(Us, Ki, oo, Pn, 0, ko, Jo))) {
          var Zs = Pe(Ss, ki);
          return xr(Vi), Zs;
        }
        kr(Vi, "wrong secret key for the given ciphertext");
      }
      function Se(Ai, Bi, yi, ii) {
        var ki = [];
        ir(ii), Ai = Fe(ki, Ai, "ciphertext");
        var Vi, Ki = b._crypto_secretbox_macbytes(), Pn = Ai.length;
        Pn < Ki && Ce(ki, "ciphertext is too short"), Vi = lr(Ai), ki.push(Vi), Bi = Fe(ki, Bi, "nonce");
        var oo, mo = 0 | b._crypto_secretbox_noncebytes();
        Bi.length !== mo && Ce(ki, "invalid nonce length"), oo = lr(Bi), ki.push(oo), yi = Fe(ki, yi, "key");
        var ko, $o = 0 | b._crypto_secretbox_keybytes();
        yi.length !== $o && Ce(ki, "invalid key length"), ko = lr(yi), ki.push(ko);
        var Jo = new or(Pn - b._crypto_secretbox_macbytes() | 0), hs = Jo.address;
        if (ki.push(hs), !(0 | b._crypto_secretbox_open_easy(hs, Vi, Pn, 0, oo, ko))) {
          var Ss = Pe(Jo, ii);
          return xr(ki), Ss;
        }
        kr(ki, "wrong secret key for the given ciphertext");
      }
      function ea(Ai, Bi, yi) {
        var ii = [];
        ir(yi), Ai = Fe(ii, Ai, "header");
        var ki, Vi = 0 | b._crypto_secretstream_xchacha20poly1305_headerbytes();
        Ai.length !== Vi && Ce(ii, "invalid header length"), ki = lr(Ai), ii.push(ki), Bi = Fe(ii, Bi, "key");
        var Ki, Pn = 0 | b._crypto_secretstream_xchacha20poly1305_keybytes();
        Bi.length !== Pn && Ce(ii, "invalid key length"), Ki = lr(Bi), ii.push(Ki);
        var oo = new or(52).address;
        if (!(0 | b._crypto_secretstream_xchacha20poly1305_init_pull(oo, ki, Ki))) {
          var mo = oo;
          return xr(ii), mo;
        }
        kr(ii, "invalid usage");
      }
      function e(Ai, Bi) {
        var yi = [];
        ir(Bi), Ai = Fe(yi, Ai, "key");
        var ii, ki = 0 | b._crypto_secretstream_xchacha20poly1305_keybytes();
        Ai.length !== ki && Ce(yi, "invalid key length"), ii = lr(Ai), yi.push(ii);
        var Vi = new or(52).address, Ki = new or(0 | b._crypto_secretstream_xchacha20poly1305_headerbytes()), Pn = Ki.address;
        if (yi.push(Pn), !(0 | b._crypto_secretstream_xchacha20poly1305_init_push(Vi, Pn, ii))) {
          var oo = { state: Vi, header: Pe(Ki, Bi) };
          return xr(yi), oo;
        }
        kr(yi, "invalid usage");
      }
      function Je(Ai) {
        var Bi = [];
        ir(Ai);
        var yi = new or(0 | b._crypto_secretstream_xchacha20poly1305_keybytes()), ii = yi.address;
        Bi.push(ii), b._crypto_secretstream_xchacha20poly1305_keygen(ii);
        var ki = Pe(yi, Ai);
        return xr(Bi), ki;
      }
      function N2(Ai, Bi, yi, ii) {
        var ki = [];
        ir(ii), tr(ki, Ai, "state_address"), Bi = Fe(ki, Bi, "cipher");
        var Vi, Ki = b._crypto_secretstream_xchacha20poly1305_abytes(), Pn = Bi.length;
        Pn < Ki && Ce(ki, "cipher is too short"), Vi = lr(Bi), ki.push(Vi);
        var oo = null, mo = 0;
        yi != null && (oo = lr(yi = Fe(ki, yi, "ad")), mo = yi.length, ki.push(oo));
        var ko = new or(Pn - b._crypto_secretstream_xchacha20poly1305_abytes() | 0), $o = ko.address;
        ki.push($o);
        var Jo, hs = (Jo = Ir(1), ki.push(Jo), (hs = b._crypto_secretstream_xchacha20poly1305_pull(Ai, $o, 0, Jo, Vi, Pn, 0, oo, mo) === 0 && { tag: b.HEAPU8[Jo], message: ko }) && { message: Pe(hs.message, ii), tag: hs.tag });
        return xr(ki), hs;
      }
      function qs(Ai, Bi, yi, ii, ki) {
        var Vi = [];
        ir(ki), tr(Vi, Ai, "state_address");
        var Ki = lr(Bi = Fe(Vi, Bi, "message_chunk")), Pn = Bi.length;
        Vi.push(Ki);
        var oo = null, mo = 0;
        yi != null && (oo = lr(yi = Fe(Vi, yi, "ad")), mo = yi.length, Vi.push(oo)), tr(Vi, ii, "tag"), (typeof ii != "number" || (0 | ii) !== ii || ii < 0) && Ce(Vi, "tag must be an unsigned integer");
        var ko = new or(Pn + b._crypto_secretstream_xchacha20poly1305_abytes() | 0), $o = ko.address;
        if (Vi.push($o), !(0 | b._crypto_secretstream_xchacha20poly1305_push(Ai, $o, 0, Ki, Pn, 0, oo, mo, 0, ii))) {
          var Jo = Pe(ko, ki);
          return xr(Vi), Jo;
        }
        kr(Vi, "invalid usage");
      }
      function df(Ai, Bi) {
        var yi = [];
        return ir(Bi), tr(yi, Ai, "state_address"), b._crypto_secretstream_xchacha20poly1305_rekey(Ai), xr(yi), !0;
      }
      function zo(Ai, Bi, yi) {
        var ii = [];
        ir(yi);
        var ki = lr(Ai = Fe(ii, Ai, "message")), Vi = Ai.length;
        ii.push(ki), Bi = Fe(ii, Bi, "key");
        var Ki, Pn = 0 | b._crypto_shorthash_keybytes();
        Bi.length !== Pn && Ce(ii, "invalid key length"), Ki = lr(Bi), ii.push(Ki);
        var oo = new or(0 | b._crypto_shorthash_bytes()), mo = oo.address;
        if (ii.push(mo), !(0 | b._crypto_shorthash(mo, ki, Vi, 0, Ki))) {
          var ko = Pe(oo, yi);
          return xr(ii), ko;
        }
        kr(ii, "invalid usage");
      }
      function No(Ai) {
        var Bi = [];
        ir(Ai);
        var yi = new or(0 | b._crypto_shorthash_keybytes()), ii = yi.address;
        Bi.push(ii), b._crypto_shorthash_keygen(ii);
        var ki = Pe(yi, Ai);
        return xr(Bi), ki;
      }
      function Oa(Ai, Bi, yi) {
        var ii = [];
        ir(yi);
        var ki = lr(Ai = Fe(ii, Ai, "message")), Vi = Ai.length;
        ii.push(ki), Bi = Fe(ii, Bi, "key");
        var Ki, Pn = 0 | b._crypto_shorthash_siphashx24_keybytes();
        Bi.length !== Pn && Ce(ii, "invalid key length"), Ki = lr(Bi), ii.push(Ki);
        var oo = new or(0 | b._crypto_shorthash_siphashx24_bytes()), mo = oo.address;
        if (ii.push(mo), !(0 | b._crypto_shorthash_siphashx24(mo, ki, Vi, 0, Ki))) {
          var ko = Pe(oo, yi);
          return xr(ii), ko;
        }
        kr(ii, "invalid usage");
      }
      function Mf(Ai, Bi, yi) {
        var ii = [];
        ir(yi);
        var ki = lr(Ai = Fe(ii, Ai, "message")), Vi = Ai.length;
        ii.push(ki), Bi = Fe(ii, Bi, "privateKey");
        var Ki, Pn = 0 | b._crypto_sign_secretkeybytes();
        Bi.length !== Pn && Ce(ii, "invalid privateKey length"), Ki = lr(Bi), ii.push(Ki);
        var oo = new or(Ai.length + b._crypto_sign_bytes() | 0), mo = oo.address;
        if (ii.push(mo), !(0 | b._crypto_sign(mo, null, ki, Vi, 0, Ki))) {
          var ko = Pe(oo, yi);
          return xr(ii), ko;
        }
        kr(ii, "invalid usage");
      }
      function Ha(Ai, Bi, yi) {
        var ii = [];
        ir(yi);
        var ki = lr(Ai = Fe(ii, Ai, "message")), Vi = Ai.length;
        ii.push(ki), Bi = Fe(ii, Bi, "privateKey");
        var Ki, Pn = 0 | b._crypto_sign_secretkeybytes();
        Bi.length !== Pn && Ce(ii, "invalid privateKey length"), Ki = lr(Bi), ii.push(Ki);
        var oo = new or(0 | b._crypto_sign_bytes()), mo = oo.address;
        if (ii.push(mo), !(0 | b._crypto_sign_detached(mo, null, ki, Vi, 0, Ki))) {
          var ko = Pe(oo, yi);
          return xr(ii), ko;
        }
        kr(ii, "invalid usage");
      }
      function Cu(Ai, Bi) {
        var yi = [];
        ir(Bi), Ai = Fe(yi, Ai, "edPk");
        var ii, ki = 0 | b._crypto_sign_publickeybytes();
        Ai.length !== ki && Ce(yi, "invalid edPk length"), ii = lr(Ai), yi.push(ii);
        var Vi = new or(0 | b._crypto_scalarmult_scalarbytes()), Ki = Vi.address;
        if (yi.push(Ki), !(0 | b._crypto_sign_ed25519_pk_to_curve25519(Ki, ii))) {
          var Pn = Pe(Vi, Bi);
          return xr(yi), Pn;
        }
        kr(yi, "invalid key");
      }
      function gi(Ai, Bi) {
        var yi = [];
        ir(Bi), Ai = Fe(yi, Ai, "edSk");
        var ii, ki = 0 | b._crypto_sign_secretkeybytes();
        Ai.length !== ki && Ce(yi, "invalid edSk length"), ii = lr(Ai), yi.push(ii);
        var Vi = new or(0 | b._crypto_scalarmult_scalarbytes()), Ki = Vi.address;
        if (yi.push(Ki), !(0 | b._crypto_sign_ed25519_sk_to_curve25519(Ki, ii))) {
          var Pn = Pe(Vi, Bi);
          return xr(yi), Pn;
        }
        kr(yi, "invalid key");
      }
      function wn(Ai, Bi) {
        var yi = [];
        ir(Bi), Ai = Fe(yi, Ai, "privateKey");
        var ii, ki = 0 | b._crypto_sign_secretkeybytes();
        Ai.length !== ki && Ce(yi, "invalid privateKey length"), ii = lr(Ai), yi.push(ii);
        var Vi = new or(0 | b._crypto_sign_publickeybytes()), Ki = Vi.address;
        if (yi.push(Ki), !(0 | b._crypto_sign_ed25519_sk_to_pk(Ki, ii))) {
          var Pn = Pe(Vi, Bi);
          return xr(yi), Pn;
        }
        kr(yi, "invalid key");
      }
      function no(Ai, Bi) {
        var yi = [];
        ir(Bi), Ai = Fe(yi, Ai, "privateKey");
        var ii, ki = 0 | b._crypto_sign_secretkeybytes();
        Ai.length !== ki && Ce(yi, "invalid privateKey length"), ii = lr(Ai), yi.push(ii);
        var Vi = new or(0 | b._crypto_sign_seedbytes()), Ki = Vi.address;
        if (yi.push(Ki), !(0 | b._crypto_sign_ed25519_sk_to_seed(Ki, ii))) {
          var Pn = Pe(Vi, Bi);
          return xr(yi), Pn;
        }
        kr(yi, "invalid key");
      }
      function Co(Ai, Bi, yi) {
        var ii = [];
        ir(yi), tr(ii, Ai, "state_address"), Bi = Fe(ii, Bi, "privateKey");
        var ki, Vi = 0 | b._crypto_sign_secretkeybytes();
        Bi.length !== Vi && Ce(ii, "invalid privateKey length"), ki = lr(Bi), ii.push(ki);
        var Ki = new or(0 | b._crypto_sign_bytes()), Pn = Ki.address;
        if (ii.push(Pn), !(0 | b._crypto_sign_final_create(Ai, Pn, null, ki))) {
          var oo = (b._free(Ai), Pe(Ki, yi));
          return xr(ii), oo;
        }
        kr(ii, "invalid usage");
      }
      function Ko(Ai, Bi, yi, ii) {
        var ki = [];
        ir(ii), tr(ki, Ai, "state_address"), Bi = Fe(ki, Bi, "signature");
        var Vi, Ki = 0 | b._crypto_sign_bytes();
        Bi.length !== Ki && Ce(ki, "invalid signature length"), Vi = lr(Bi), ki.push(Vi), yi = Fe(ki, yi, "publicKey");
        var Pn, oo = 0 | b._crypto_sign_publickeybytes();
        yi.length !== oo && Ce(ki, "invalid publicKey length"), Pn = lr(yi), ki.push(Pn);
        var mo = !(0 | b._crypto_sign_final_verify(Ai, Vi, Pn));
        return xr(ki), mo;
      }
      function jo(Ai) {
        var Bi = [];
        ir(Ai);
        var yi = new or(208).address;
        if (!(0 | b._crypto_sign_init(yi))) {
          var ii = yi;
          return xr(Bi), ii;
        }
        kr(Bi, "internal error");
      }
      function ss(Ai) {
        var Bi = [];
        ir(Ai);
        var yi = new or(0 | b._crypto_sign_publickeybytes()), ii = yi.address;
        Bi.push(ii);
        var ki = new or(0 | b._crypto_sign_secretkeybytes()), Vi = ki.address;
        if (Bi.push(Vi), !(0 | b._crypto_sign_keypair(ii, Vi))) {
          var Ki = { publicKey: Pe(yi, Ai), privateKey: Pe(ki, Ai), keyType: "ed25519" };
          return xr(Bi), Ki;
        }
        kr(Bi, "internal error");
      }
      function Ms(Ai, Bi, yi) {
        var ii = [];
        ir(yi), Ai = Fe(ii, Ai, "signedMessage");
        var ki, Vi = b._crypto_sign_bytes(), Ki = Ai.length;
        Ki < Vi && Ce(ii, "signedMessage is too short"), ki = lr(Ai), ii.push(ki), Bi = Fe(ii, Bi, "publicKey");
        var Pn, oo = 0 | b._crypto_sign_publickeybytes();
        Bi.length !== oo && Ce(ii, "invalid publicKey length"), Pn = lr(Bi), ii.push(Pn);
        var mo = new or(Ki - b._crypto_sign_bytes() | 0), ko = mo.address;
        if (ii.push(ko), !(0 | b._crypto_sign_open(ko, null, ki, Ki, 0, Pn))) {
          var $o = Pe(mo, yi);
          return xr(ii), $o;
        }
        kr(ii, "incorrect signature for the given public key");
      }
      function Ws(Ai, Bi) {
        var yi = [];
        ir(Bi), Ai = Fe(yi, Ai, "seed");
        var ii, ki = 0 | b._crypto_sign_seedbytes();
        Ai.length !== ki && Ce(yi, "invalid seed length"), ii = lr(Ai), yi.push(ii);
        var Vi = new or(0 | b._crypto_sign_publickeybytes()), Ki = Vi.address;
        yi.push(Ki);
        var Pn = new or(0 | b._crypto_sign_secretkeybytes()), oo = Pn.address;
        if (yi.push(oo), !(0 | b._crypto_sign_seed_keypair(Ki, oo, ii))) {
          var mo = { publicKey: Pe(Vi, Bi), privateKey: Pe(Pn, Bi), keyType: "ed25519" };
          return xr(yi), mo;
        }
        kr(yi, "invalid usage");
      }
      function ia(Ai, Bi, yi) {
        var ii = [];
        ir(yi), tr(ii, Ai, "state_address");
        var ki = lr(Bi = Fe(ii, Bi, "message_chunk")), Vi = Bi.length;
        ii.push(ki), 0 | b._crypto_sign_update(Ai, ki, Vi, 0) && kr(ii, "invalid usage"), xr(ii);
      }
      function La(Ai, Bi, yi) {
        var ii = [];
        Ai = Fe(ii, Ai, "signature");
        var ki, Vi = 0 | b._crypto_sign_bytes();
        Ai.length !== Vi && Ce(ii, "invalid signature length"), ki = lr(Ai), ii.push(ki);
        var Ki = lr(Bi = Fe(ii, Bi, "message")), Pn = Bi.length;
        ii.push(Ki), yi = Fe(ii, yi, "publicKey");
        var oo, mo = 0 | b._crypto_sign_publickeybytes();
        yi.length !== mo && Ce(ii, "invalid publicKey length"), oo = lr(yi), ii.push(oo);
        var ko = !(0 | b._crypto_sign_verify_detached(ki, Ki, Pn, 0, oo));
        return xr(ii), ko;
      }
      function mf(Ai, Bi, yi, ii) {
        var ki = [];
        ir(ii), tr(ki, Ai, "outLength"), (typeof Ai != "number" || (0 | Ai) !== Ai || Ai < 0) && Ce(ki, "outLength must be an unsigned integer"), Bi = Fe(ki, Bi, "key");
        var Vi, Ki = 0 | b._crypto_stream_chacha20_keybytes();
        Bi.length !== Ki && Ce(ki, "invalid key length"), Vi = lr(Bi), ki.push(Vi), yi = Fe(ki, yi, "nonce");
        var Pn, oo = 0 | b._crypto_stream_chacha20_noncebytes();
        yi.length !== oo && Ce(ki, "invalid nonce length"), Pn = lr(yi), ki.push(Pn);
        var mo = new or(0 | Ai), ko = mo.address;
        ki.push(ko), b._crypto_stream_chacha20(ko, Ai, 0, Pn, Vi);
        var $o = Pe(mo, ii);
        return xr(ki), $o;
      }
      function kf(Ai, Bi, yi, ii) {
        var ki = [];
        ir(ii);
        var Vi = lr(Ai = Fe(ki, Ai, "input_message")), Ki = Ai.length;
        ki.push(Vi), Bi = Fe(ki, Bi, "nonce");
        var Pn, oo = 0 | b._crypto_stream_chacha20_ietf_noncebytes();
        Bi.length !== oo && Ce(ki, "invalid nonce length"), Pn = lr(Bi), ki.push(Pn), yi = Fe(ki, yi, "key");
        var mo, ko = 0 | b._crypto_stream_chacha20_ietf_keybytes();
        yi.length !== ko && Ce(ki, "invalid key length"), mo = lr(yi), ki.push(mo);
        var $o = new or(0 | Ki), Jo = $o.address;
        if (ki.push(Jo), b._crypto_stream_chacha20_ietf_xor(Jo, Vi, Ki, 0, Pn, mo) === 0) {
          var hs = Pe($o, ii);
          return xr(ki), hs;
        }
        kr(ki, "invalid usage");
      }
      function Cf(Ai, Bi, yi, ii, ki) {
        var Vi = [];
        ir(ki);
        var Ki = lr(Ai = Fe(Vi, Ai, "input_message")), Pn = Ai.length;
        Vi.push(Ki), Bi = Fe(Vi, Bi, "nonce");
        var oo, mo = 0 | b._crypto_stream_chacha20_ietf_noncebytes();
        Bi.length !== mo && Ce(Vi, "invalid nonce length"), oo = lr(Bi), Vi.push(oo), tr(Vi, yi, "nonce_increment"), (typeof yi != "number" || (0 | yi) !== yi || yi < 0) && Ce(Vi, "nonce_increment must be an unsigned integer"), ii = Fe(Vi, ii, "key");
        var ko, $o = 0 | b._crypto_stream_chacha20_ietf_keybytes();
        ii.length !== $o && Ce(Vi, "invalid key length"), ko = lr(ii), Vi.push(ko);
        var Jo = new or(0 | Pn), hs = Jo.address;
        if (Vi.push(hs), b._crypto_stream_chacha20_ietf_xor_ic(hs, Ki, Pn, 0, oo, yi, ko) === 0) {
          var Ss = Pe(Jo, ki);
          return xr(Vi), Ss;
        }
        kr(Vi, "invalid usage");
      }
      function Nf(Ai) {
        var Bi = [];
        ir(Ai);
        var yi = new or(0 | b._crypto_stream_chacha20_keybytes()), ii = yi.address;
        Bi.push(ii), b._crypto_stream_chacha20_keygen(ii);
        var ki = Pe(yi, Ai);
        return xr(Bi), ki;
      }
      function jf(Ai, Bi, yi, ii) {
        var ki = [];
        ir(ii);
        var Vi = lr(Ai = Fe(ki, Ai, "input_message")), Ki = Ai.length;
        ki.push(Vi), Bi = Fe(ki, Bi, "nonce");
        var Pn, oo = 0 | b._crypto_stream_chacha20_noncebytes();
        Bi.length !== oo && Ce(ki, "invalid nonce length"), Pn = lr(Bi), ki.push(Pn), yi = Fe(ki, yi, "key");
        var mo, ko = 0 | b._crypto_stream_chacha20_keybytes();
        yi.length !== ko && Ce(ki, "invalid key length"), mo = lr(yi), ki.push(mo);
        var $o = new or(0 | Ki), Jo = $o.address;
        if (ki.push(Jo), b._crypto_stream_chacha20_xor(Jo, Vi, Ki, 0, Pn, mo) === 0) {
          var hs = Pe($o, ii);
          return xr(ki), hs;
        }
        kr(ki, "invalid usage");
      }
      function E2(Ai, Bi, yi, ii, ki) {
        var Vi = [];
        ir(ki);
        var Ki = lr(Ai = Fe(Vi, Ai, "input_message")), Pn = Ai.length;
        Vi.push(Ki), Bi = Fe(Vi, Bi, "nonce");
        var oo, mo = 0 | b._crypto_stream_chacha20_noncebytes();
        Bi.length !== mo && Ce(Vi, "invalid nonce length"), oo = lr(Bi), Vi.push(oo), tr(Vi, yi, "nonce_increment"), (typeof yi != "number" || (0 | yi) !== yi || yi < 0) && Ce(Vi, "nonce_increment must be an unsigned integer"), ii = Fe(Vi, ii, "key");
        var ko, $o = 0 | b._crypto_stream_chacha20_keybytes();
        ii.length !== $o && Ce(Vi, "invalid key length"), ko = lr(ii), Vi.push(ko);
        var Jo = new or(0 | Pn), hs = Jo.address;
        if (Vi.push(hs), b._crypto_stream_chacha20_xor_ic(hs, Ki, Pn, 0, oo, yi, 0, ko) === 0) {
          var Ss = Pe(Jo, ki);
          return xr(Vi), Ss;
        }
        kr(Vi, "invalid usage");
      }
      function Xf(Ai) {
        var Bi = [];
        ir(Ai);
        var yi = new or(0 | b._crypto_stream_keybytes()), ii = yi.address;
        Bi.push(ii), b._crypto_stream_keygen(ii);
        var ki = Pe(yi, Ai);
        return xr(Bi), ki;
      }
      function Zf(Ai) {
        var Bi = [];
        ir(Ai);
        var yi = new or(0 | b._crypto_stream_xchacha20_keybytes()), ii = yi.address;
        Bi.push(ii), b._crypto_stream_xchacha20_keygen(ii);
        var ki = Pe(yi, Ai);
        return xr(Bi), ki;
      }
      function Ic(Ai, Bi, yi, ii) {
        var ki = [];
        ir(ii);
        var Vi = lr(Ai = Fe(ki, Ai, "input_message")), Ki = Ai.length;
        ki.push(Vi), Bi = Fe(ki, Bi, "nonce");
        var Pn, oo = 0 | b._crypto_stream_xchacha20_noncebytes();
        Bi.length !== oo && Ce(ki, "invalid nonce length"), Pn = lr(Bi), ki.push(Pn), yi = Fe(ki, yi, "key");
        var mo, ko = 0 | b._crypto_stream_xchacha20_keybytes();
        yi.length !== ko && Ce(ki, "invalid key length"), mo = lr(yi), ki.push(mo);
        var $o = new or(0 | Ki), Jo = $o.address;
        if (ki.push(Jo), b._crypto_stream_xchacha20_xor(Jo, Vi, Ki, 0, Pn, mo) === 0) {
          var hs = Pe($o, ii);
          return xr(ki), hs;
        }
        kr(ki, "invalid usage");
      }
      function $a(Ai, Bi, yi, ii, ki) {
        var Vi = [];
        ir(ki);
        var Ki = lr(Ai = Fe(Vi, Ai, "input_message")), Pn = Ai.length;
        Vi.push(Ki), Bi = Fe(Vi, Bi, "nonce");
        var oo, mo = 0 | b._crypto_stream_xchacha20_noncebytes();
        Bi.length !== mo && Ce(Vi, "invalid nonce length"), oo = lr(Bi), Vi.push(oo), tr(Vi, yi, "nonce_increment"), (typeof yi != "number" || (0 | yi) !== yi || yi < 0) && Ce(Vi, "nonce_increment must be an unsigned integer"), ii = Fe(Vi, ii, "key");
        var ko, $o = 0 | b._crypto_stream_xchacha20_keybytes();
        ii.length !== $o && Ce(Vi, "invalid key length"), ko = lr(ii), Vi.push(ko);
        var Jo = new or(0 | Pn), hs = Jo.address;
        if (Vi.push(hs), b._crypto_stream_xchacha20_xor_ic(hs, Ki, Pn, 0, oo, yi, 0, ko) === 0) {
          var Ss = Pe(Jo, ki);
          return xr(Vi), Ss;
        }
        kr(Vi, "invalid usage");
      }
      function gs(Ai, Bi) {
        var yi = [];
        ir(Bi), tr(yi, Ai, "length"), (typeof Ai != "number" || (0 | Ai) !== Ai || Ai < 0) && Ce(yi, "length must be an unsigned integer");
        var ii = new or(0 | Ai), ki = ii.address;
        yi.push(ki), b._randombytes_buf(ki, Ai);
        var Vi = Pe(ii, Bi);
        return xr(yi), Vi;
      }
      function Wc(Ai, Bi, yi) {
        var ii = [];
        ir(yi), tr(ii, Ai, "length"), (typeof Ai != "number" || (0 | Ai) !== Ai || Ai < 0) && Ce(ii, "length must be an unsigned integer"), Bi = Fe(ii, Bi, "seed");
        var ki, Vi = 0 | b._randombytes_seedbytes();
        Bi.length !== Vi && Ce(ii, "invalid seed length"), ki = lr(Bi), ii.push(ki);
        var Ki = new or(0 | Ai), Pn = Ki.address;
        ii.push(Pn), b._randombytes_buf_deterministic(Pn, Ai, ki);
        var oo = Pe(Ki, yi);
        return xr(ii), oo;
      }
      function Uc(Ai) {
        ir(Ai), b._randombytes_close();
      }
      function Gf(Ai) {
        ir(Ai);
        var Bi = b._randombytes_random() >>> 0;
        return xr([]), Bi;
      }
      function su(Ai, Bi) {
        var yi = [];
        ir(Bi);
        for (var ii = b._malloc(24), ki = 0; ki < 6; ki++) b.setValue(ii + 4 * ki, b.Runtime.addFunction(Ai[["implementation_name", "random", "stir", "uniform", "buf", "close"][ki]]), "i32");
        0 | b._randombytes_set_implementation(ii) && kr(yi, "unsupported implementation"), xr(yi);
      }
      function i2(Ai) {
        ir(Ai), b._randombytes_stir();
      }
      function tc(Ai, Bi) {
        var yi = [];
        ir(Bi), tr(yi, Ai, "upper_bound"), (typeof Ai != "number" || (0 | Ai) !== Ai || Ai < 0) && Ce(yi, "upper_bound must be an unsigned integer");
        var ii = b._randombytes_uniform(Ai) >>> 0;
        return xr(yi), ii;
      }
      function pc() {
        var Ai = b._sodium_version_string(), Bi = b.UTF8ToString(Ai);
        return xr([]), Bi;
      }
      return or.prototype.to_Uint8Array = function() {
        var Ai = new Uint8Array(this.length);
        return Ai.set(b.HEAPU8.subarray(this.address, this.address + this.length)), Ai;
      }, a.add = function(Ai, Bi) {
        if (!(Ai instanceof Uint8Array && Bi instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can added");
        var yi = Ai.length, ii = 0, ki = 0;
        if (Bi.length != Ai.length) throw new TypeError("Arguments must have the same length");
        for (ki = 0; ki < yi; ki++) ii >>= 8, ii += Ai[ki] + Bi[ki], Ai[ki] = 255 & ii;
      }, a.base64_variants = Ee, a.compare = function(Ai, Bi) {
        if (!(Ai instanceof Uint8Array && Bi instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can be compared");
        if (Ai.length !== Bi.length) throw new TypeError("Only instances of identical length can be compared");
        for (var yi = 0, ii = 1, ki = Ai.length; ki-- > 0; ) yi |= Bi[ki] - Ai[ki] >> 8 & ii, ii &= (Bi[ki] ^ Ai[ki]) - 1 >> 8;
        return yi + yi + ii - 1;
      }, a.from_base64 = function(Ai, Bi) {
        Bi = be(Bi);
        var yi, ii = [], ki = new or(3 * (Ai = Fe(ii, Ai, "input")).length / 4), Vi = lr(Ai), Ki = Ir(4), Pn = Ir(4);
        return ii.push(Vi), ii.push(ki.address), ii.push(ki.result_bin_len_p), ii.push(ki.b64_end_p), b._sodium_base642bin(ki.address, ki.length, Vi, Ai.length, 0, Ki, Pn, Bi) !== 0 && kr(ii, "invalid input"), b.getValue(Pn, "i32") - Vi !== Ai.length && kr(ii, "incomplete input"), ki.length = b.getValue(Ki, "i32"), yi = ki.to_Uint8Array(), xr(ii), yi;
      }, a.from_hex = function(Ai) {
        var Bi, yi = [], ii = new or((Ai = Fe(yi, Ai, "input")).length / 2), ki = lr(Ai), Vi = Ir(4);
        return yi.push(ki), yi.push(ii.address), yi.push(ii.hex_end_p), b._sodium_hex2bin(ii.address, ii.length, ki, Ai.length, 0, 0, Vi) !== 0 && kr(yi, "invalid input"), b.getValue(Vi, "i32") - ki !== Ai.length && kr(yi, "incomplete input"), Bi = ii.to_Uint8Array(), xr(yi), Bi;
      }, a.from_string = L, a.increment = function(Ai) {
        if (!(Ai instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can be incremented");
        for (var Bi = 256, yi = 0, ii = Ai.length; yi < ii; yi++) Bi >>= 8, Bi += Ai[yi], Ai[yi] = 255 & Bi;
      }, a.is_zero = function(Ai) {
        if (!(Ai instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can be checked");
        for (var Bi = 0, yi = 0, ii = Ai.length; yi < ii; yi++) Bi |= Ai[yi];
        return Bi === 0;
      }, a.libsodium = A, a.memcmp = function(Ai, Bi) {
        if (!(Ai instanceof Uint8Array && Bi instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can be compared");
        if (Ai.length !== Bi.length) throw new TypeError("Only instances of identical length can be compared");
        for (var yi = 0, ii = 0, ki = Ai.length; ii < ki; ii++) yi |= Ai[ii] ^ Bi[ii];
        return yi === 0;
      }, a.memzero = function(Ai) {
        if (!(Ai instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can be wiped");
        for (var Bi = 0, yi = Ai.length; Bi < yi; Bi++) Ai[Bi] = 0;
      }, a.output_formats = function() {
        return ["uint8array", "text", "hex", "base64"];
      }, a.pad = function(Ai, Bi) {
        if (!(Ai instanceof Uint8Array)) throw new TypeError("buffer must be a Uint8Array");
        if ((Bi |= 0) <= 0) throw new Error("block size must be > 0");
        var yi, ii = [], ki = Ir(4), Vi = 1, Ki = 0, Pn = 0 | Ai.length, oo = new or(Pn + Bi);
        ii.push(ki), ii.push(oo.address);
        for (var mo = oo.address, ko = oo.address + Pn + Bi; mo < ko; mo++) b.HEAPU8[mo] = Ai[Ki], Ki += Vi = 1 & ~((65535 & ((Pn -= Vi) >>> 48 | Pn >>> 32 | Pn >>> 16 | Pn)) - 1 >> 16);
        return b._sodium_pad(ki, oo.address, Ai.length, Bi, oo.length) !== 0 && kr(ii, "internal error"), oo.length = b.getValue(ki, "i32"), yi = oo.to_Uint8Array(), xr(ii), yi;
      }, a.unpad = function(Ai, Bi) {
        if (!(Ai instanceof Uint8Array)) throw new TypeError("buffer must be a Uint8Array");
        if ((Bi |= 0) <= 0) throw new Error("block size must be > 0");
        var yi = [], ii = lr(Ai), ki = Ir(4);
        return yi.push(ii), yi.push(ki), b._sodium_unpad(ki, ii, Ai.length, Bi) !== 0 && kr(yi, "unsupported/invalid padding"), Ai = (Ai = new Uint8Array(Ai)).subarray(0, b.getValue(ki, "i32")), xr(yi), Ai;
      }, a.ready = le, a.symbols = function() {
        return Object.keys(a).sort();
      }, a.to_base64 = He, a.to_hex = $, a.to_string = pe, a;
    }
    var p = typeof c.sodium == "object" && typeof c.sodium.onload == "function" ? c.sodium.onload : null;
    typeof n.nodeName != "string" ? u(n, requireLibsodiumSumo()) : c.sodium = u(c.commonJsStrict = {}, c.libsodium), p && c.sodium.ready.then(function() {
      p(c.sodium);
    });
  })(commonjsGlobal);
})(libsodiumWrappers);
var __importDefault$8 = commonjsGlobal && commonjsGlobal.__importDefault || function(n) {
  return n && n.__esModule ? n : { default: n };
};
Object.defineProperty(libsodium, "__esModule", { value: !0 });
libsodium.Xchacha20poly1305Ietf = libsodium.xchacha20NonceLength = libsodium.Ed25519 = libsodium.Ed25519Keypair = libsodium.Argon2id = libsodium.isArgon2idOptions = void 0;
const utils_1$1 = build$2, libsodium_wrappers_sumo_1 = __importDefault$8(libsodiumWrappers);
function isArgon2idOptions(n) {
  return !(!(0, utils_1$1.isNonNullObject)(n) || typeof n.outputLength != "number" || typeof n.opsLimit != "number" || typeof n.memLimitKib != "number");
}
libsodium.isArgon2idOptions = isArgon2idOptions;
class Argon2id {
  static async execute(c, u, p) {
    return await libsodium_wrappers_sumo_1.default.ready, libsodium_wrappers_sumo_1.default.crypto_pwhash(
      p.outputLength,
      c,
      u,
      // libsodium only supports 16 byte salts and will throw when you don't respect that
      p.opsLimit,
      p.memLimitKib * 1024,
      libsodium_wrappers_sumo_1.default.crypto_pwhash_ALG_ARGON2ID13
    );
  }
}
libsodium.Argon2id = Argon2id;
class Ed25519Keypair {
  // a libsodium privkey has the format `<ed25519 privkey> + <ed25519 pubkey>`
  static fromLibsodiumPrivkey(c) {
    if (c.length !== 64)
      throw new Error(`Unexpected key length ${c.length}. Must be 64.`);
    return new Ed25519Keypair(c.slice(0, 32), c.slice(32, 64));
  }
  constructor(c, u) {
    this.privkey = c, this.pubkey = u;
  }
  toLibsodiumPrivkey() {
    return new Uint8Array([...this.privkey, ...this.pubkey]);
  }
}
libsodium.Ed25519Keypair = Ed25519Keypair;
class Ed25519 {
  /**
   * Generates a keypair deterministically from a given 32 bytes seed.
   *
   * This seed equals the Ed25519 private key.
   * For implementation details see crypto_sign_seed_keypair in
   * https://download.libsodium.org/doc/public-key_cryptography/public-key_signatures.html
   * and diagram on https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
   */
  static async makeKeypair(c) {
    await libsodium_wrappers_sumo_1.default.ready;
    const u = libsodium_wrappers_sumo_1.default.crypto_sign_seed_keypair(c);
    return Ed25519Keypair.fromLibsodiumPrivkey(u.privateKey);
  }
  static async createSignature(c, u) {
    return await libsodium_wrappers_sumo_1.default.ready, libsodium_wrappers_sumo_1.default.crypto_sign_detached(c, u.toLibsodiumPrivkey());
  }
  static async verifySignature(c, u, p) {
    return await libsodium_wrappers_sumo_1.default.ready, libsodium_wrappers_sumo_1.default.crypto_sign_verify_detached(c, u, p);
  }
}
libsodium.Ed25519 = Ed25519;
libsodium.xchacha20NonceLength = 24;
class Xchacha20poly1305Ietf {
  static async encrypt(c, u, p) {
    return await libsodium_wrappers_sumo_1.default.ready, libsodium_wrappers_sumo_1.default.crypto_aead_xchacha20poly1305_ietf_encrypt(
      c,
      null,
      null,
      // secret nonce: unused and should be null (https://download.libsodium.org/doc/secret-key_cryptography/aead/chacha20-poly1305/xchacha20-poly1305_construction)
      p,
      u
    );
  }
  static async decrypt(c, u, p) {
    return await libsodium_wrappers_sumo_1.default.ready, libsodium_wrappers_sumo_1.default.crypto_aead_xchacha20poly1305_ietf_decrypt(
      null,
      // secret nonce: unused and should be null (https://download.libsodium.org/doc/secret-key_cryptography/aead/chacha20-poly1305/xchacha20-poly1305_construction)
      c,
      null,
      p,
      u
    );
  }
}
libsodium.Xchacha20poly1305Ietf = Xchacha20poly1305Ietf;
var random$3 = {};
Object.defineProperty(random$3, "__esModule", { value: !0 });
random$3.Random = void 0;
class Random {
  /**
   * Returns `count` cryptographically secure random bytes
   */
  static getBytes(c) {
    try {
      const u = typeof window == "object" ? window : self, p = typeof u.crypto < "u" ? u.crypto : u.msCrypto, a = new Uint8Array(c);
      return p.getRandomValues(a), a;
    } catch {
      try {
        const u = requireCryptoBrowserify();
        return new Uint8Array([...u.randomBytes(c)]);
      } catch {
        throw new Error("No secure random number generator found");
      }
    }
  }
}
random$3.Random = Random;
var ripemd = {};
Object.defineProperty(ripemd, "__esModule", { value: !0 });
ripemd.ripemd160 = ripemd.Ripemd160 = void 0;
const ripemd160_1$1 = ripemd160$6, utils_1 = utils$2;
class Ripemd160 {
  constructor(c) {
    this.blockSize = 512 / 8, this.impl = ripemd160_1$1.ripemd160.create(), c && this.update(c);
  }
  update(c) {
    return this.impl.update((0, utils_1.toRealUint8Array)(c)), this;
  }
  digest() {
    return this.impl.digest();
  }
}
ripemd.Ripemd160 = Ripemd160;
function ripemd160$2(n) {
  return new Ripemd160(n).digest();
}
ripemd.ripemd160 = ripemd160$2;
var secp256k1$4 = {}, secp256k1signature = {};
Object.defineProperty(secp256k1signature, "__esModule", { value: !0 });
secp256k1signature.ExtendedSecp256k1Signature = secp256k1signature.Secp256k1Signature = void 0;
function trimLeadingNullBytes(n) {
  let c = 0;
  for (const u of n)
    if (u === 0)
      c++;
    else
      break;
  return n.slice(c);
}
const derTagInteger = 2;
class Secp256k1Signature {
  /**
   * Takes the pair of integers (r, s) as 2x32 byte of binary data.
   *
   * Note: This is the format Cosmos SDK uses natively.
   *
   * @param data a 64 byte value containing integers r and s.
   */
  static fromFixedLength(c) {
    if (c.length !== 64)
      throw new Error(`Got invalid data length: ${c.length}. Expected 2x 32 bytes for the pair (r, s)`);
    return new Secp256k1Signature(trimLeadingNullBytes(c.slice(0, 32)), trimLeadingNullBytes(c.slice(32, 64)));
  }
  static fromDer(c) {
    let u = 0;
    if (c[u++] !== 48)
      throw new Error("Prefix 0x30 expected");
    const p = c[u++];
    if (c.length - u !== p)
      throw new Error("Data length mismatch detected");
    if (c[u++] !== derTagInteger)
      throw new Error("INTEGER tag expected");
    const A = c[u++];
    if (A >= 128)
      throw new Error("Decoding length values above 127 not supported");
    const b = c.slice(u, u + A);
    if (u += A, c[u++] !== derTagInteger)
      throw new Error("INTEGER tag expected");
    const le = c[u++];
    if (le >= 128)
      throw new Error("Decoding length values above 127 not supported");
    const L = c.slice(u, u + le);
    return u += le, new Secp256k1Signature(
      // r/s data can contain leading 0 bytes to express integers being non-negative in DER
      trimLeadingNullBytes(b),
      trimLeadingNullBytes(L)
    );
  }
  constructor(c, u) {
    if (c.length > 32 || c.length === 0 || c[0] === 0)
      throw new Error("Unsigned integer r must be encoded as unpadded big endian.");
    if (u.length > 32 || u.length === 0 || u[0] === 0)
      throw new Error("Unsigned integer s must be encoded as unpadded big endian.");
    this.data = {
      r: c,
      s: u
    };
  }
  r(c) {
    if (c === void 0)
      return this.data.r;
    {
      const u = c - this.data.r.length;
      if (u < 0)
        throw new Error("Length too small to hold parameter r");
      const p = new Uint8Array(u);
      return new Uint8Array([...p, ...this.data.r]);
    }
  }
  s(c) {
    if (c === void 0)
      return this.data.s;
    {
      const u = c - this.data.s.length;
      if (u < 0)
        throw new Error("Length too small to hold parameter s");
      const p = new Uint8Array(u);
      return new Uint8Array([...p, ...this.data.s]);
    }
  }
  toFixedLength() {
    return new Uint8Array([...this.r(32), ...this.s(32)]);
  }
  toDer() {
    const c = this.data.r[0] >= 128 ? new Uint8Array([0, ...this.data.r]) : this.data.r, u = this.data.s[0] >= 128 ? new Uint8Array([0, ...this.data.s]) : this.data.s, p = c.length, a = u.length, A = new Uint8Array([derTagInteger, p, ...c, derTagInteger, a, ...u]);
    return new Uint8Array([48, A.length, ...A]);
  }
}
secp256k1signature.Secp256k1Signature = Secp256k1Signature;
class ExtendedSecp256k1Signature extends Secp256k1Signature {
  /**
   * Decode extended signature from the simple fixed length encoding
   * described in toFixedLength().
   */
  static fromFixedLength(c) {
    if (c.length !== 65)
      throw new Error(`Got invalid data length ${c.length}. Expected 32 + 32 + 1`);
    return new ExtendedSecp256k1Signature(trimLeadingNullBytes(c.slice(0, 32)), trimLeadingNullBytes(c.slice(32, 64)), c[64]);
  }
  constructor(c, u, p) {
    if (super(c, u), !Number.isInteger(p))
      throw new Error("The recovery parameter must be an integer.");
    if (p < 0 || p > 4)
      throw new Error("The recovery parameter must be one of 0, 1, 2, 3.");
    this.recovery = p;
  }
  /**
   * A simple custom encoding that encodes the extended signature as
   * r (32 bytes) | s (32 bytes) | recovery param (1 byte)
   * where | denotes concatenation of bonary data.
   */
  toFixedLength() {
    return new Uint8Array([...this.r(32), ...this.s(32), this.recovery]);
  }
}
secp256k1signature.ExtendedSecp256k1Signature = ExtendedSecp256k1Signature;
var __importDefault$7 = commonjsGlobal && commonjsGlobal.__importDefault || function(n) {
  return n && n.__esModule ? n : { default: n };
};
Object.defineProperty(secp256k1$4, "__esModule", { value: !0 });
secp256k1$4.Secp256k1 = void 0;
const encoding_1 = build$3, bn_js_1$2 = __importDefault$7(bnExports$1), elliptic_1 = __importDefault$7(requireElliptic$2()), secp256k1signature_1 = secp256k1signature, secp256k1$3 = new elliptic_1.default.ec("secp256k1"), secp256k1N$2 = new bn_js_1$2.default("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", "hex");
class Secp256k1 {
  /**
   * Takes a 32 byte private key and returns a privkey/pubkey pair.
   *
   * The resulting pubkey is uncompressed. For the use in Cosmos it should
   * be compressed first using `Secp256k1.compressPubkey`.
   */
  static async makeKeypair(c) {
    if (c.length !== 32)
      throw new Error("input data is not a valid secp256k1 private key");
    const u = secp256k1$3.keyFromPrivate(c);
    if (u.validate().result !== !0)
      throw new Error("input data is not a valid secp256k1 private key");
    if (new bn_js_1$2.default(c).gte(secp256k1N$2))
      throw new Error("input data is not a valid secp256k1 private key");
    return {
      privkey: (0, encoding_1.fromHex)(u.getPrivate("hex")),
      // encodes uncompressed as
      // - 1-byte prefix "04"
      // - 32-byte x coordinate
      // - 32-byte y coordinate
      pubkey: Uint8Array.from(u.getPublic("array"))
    };
  }
  /**
   * Creates a signature that is
   * - deterministic (RFC 6979)
   * - lowS signature
   * - DER encoded
   */
  static async createSignature(c, u) {
    if (c.length === 0)
      throw new Error("Message hash must not be empty");
    if (c.length > 32)
      throw new Error("Message hash length must not exceed 32 bytes");
    const p = secp256k1$3.keyFromPrivate(u), { r: a, s: A, recoveryParam: b } = p.sign(c, { canonical: !0 });
    if (typeof b != "number")
      throw new Error("Recovery param missing");
    return new secp256k1signature_1.ExtendedSecp256k1Signature(Uint8Array.from(a.toArray()), Uint8Array.from(A.toArray()), b);
  }
  static async verifySignature(c, u, p) {
    if (u.length === 0)
      throw new Error("Message hash must not be empty");
    if (u.length > 32)
      throw new Error("Message hash length must not exceed 32 bytes");
    const a = secp256k1$3.keyFromPublic(p);
    try {
      return a.verify(u, c.toDer());
    } catch {
      return !1;
    }
  }
  static recoverPubkey(c, u) {
    const p = { r: (0, encoding_1.toHex)(c.r()), s: (0, encoding_1.toHex)(c.s()) }, a = secp256k1$3.recoverPubKey(u, p, c.recovery), A = secp256k1$3.keyFromPublic(a);
    return (0, encoding_1.fromHex)(A.getPublic(!1, "hex"));
  }
  /**
   * Takes a compressed or uncompressed pubkey and return a compressed one.
   *
   * This function is idempotent.
   */
  static compressPubkey(c) {
    switch (c.length) {
      case 33:
        return c;
      case 65:
        return Uint8Array.from(secp256k1$3.keyFromPublic(c).getPublic(!0, "array"));
      default:
        throw new Error("Invalid pubkey length");
    }
  }
  /**
   * Takes a compressed or uncompressed pubkey and returns an uncompressed one.
   *
   * This function is idempotent.
   */
  static uncompressPubkey(c) {
    switch (c.length) {
      case 33:
        return Uint8Array.from(secp256k1$3.keyFromPublic(c).getPublic(!1, "array"));
      case 65:
        return c;
      default:
        throw new Error("Invalid pubkey length");
    }
  }
  static trimRecoveryByte(c) {
    switch (c.length) {
      case 64:
        return c;
      case 65:
        return c.slice(0, 64);
      default:
        throw new Error("Invalid signature length");
    }
  }
}
secp256k1$4.Secp256k1 = Secp256k1;
var slip10 = {}, build$1 = {}, decimal$1 = {}, __importDefault$6 = commonjsGlobal && commonjsGlobal.__importDefault || function(n) {
  return n && n.__esModule ? n : { default: n };
};
Object.defineProperty(decimal$1, "__esModule", { value: !0 });
decimal$1.Decimal = void 0;
const bn_js_1$1 = __importDefault$6(bnExports$1), maxFractionalDigits = 100;
let Decimal$1 = class Pf {
  static fromUserInput(c, u) {
    Pf.verifyFractionalDigits(u);
    const p = c.match(/[^0-9.]/);
    if (p)
      throw new Error(`Invalid character at position ${p.index + 1}`);
    let a, A;
    if (c === "")
      a = "0", A = "";
    else if (c.search(/\./) === -1)
      a = c, A = "";
    else {
      const F = c.split(".");
      switch (F.length) {
        case 0:
        case 1:
          throw new Error("Fewer than two elements in split result. This must not happen here.");
        case 2:
          if (!F[1])
            throw new Error("Fractional part missing");
          a = F[0], A = F[1].replace(/0+$/, "");
          break;
        default:
          throw new Error("More than one separator found");
      }
    }
    if (A.length > u)
      throw new Error("Got more fractional digits than supported");
    const b = `${a}${A.padEnd(u, "0")}`;
    return new Pf(b, u);
  }
  static fromAtomics(c, u) {
    return Pf.verifyFractionalDigits(u), new Pf(c, u);
  }
  /**
   * Creates a Decimal with value 0.0 and the given number of fractial digits.
   *
   * Fractional digits are not relevant for the value but needed to be able
   * to perform arithmetic operations with other decimals.
   */
  static zero(c) {
    return Pf.verifyFractionalDigits(c), new Pf("0", c);
  }
  /**
   * Creates a Decimal with value 1.0 and the given number of fractial digits.
   *
   * Fractional digits are not relevant for the value but needed to be able
   * to perform arithmetic operations with other decimals.
   */
  static one(c) {
    return Pf.verifyFractionalDigits(c), new Pf("1" + "0".repeat(c), c);
  }
  static verifyFractionalDigits(c) {
    if (!Number.isInteger(c))
      throw new Error("Fractional digits is not an integer");
    if (c < 0)
      throw new Error("Fractional digits must not be negative");
    if (c > maxFractionalDigits)
      throw new Error(`Fractional digits must not exceed ${maxFractionalDigits}`);
  }
  static compare(c, u) {
    if (c.fractionalDigits !== u.fractionalDigits)
      throw new Error("Fractional digits do not match");
    return c.data.atomics.cmp(new bn_js_1$1.default(u.atomics));
  }
  get atomics() {
    return this.data.atomics.toString();
  }
  get fractionalDigits() {
    return this.data.fractionalDigits;
  }
  constructor(c, u) {
    if (!c.match(/^[0-9]+$/))
      throw new Error("Invalid string format. Only non-negative integers in decimal representation supported.");
    this.data = {
      atomics: new bn_js_1$1.default(c),
      fractionalDigits: u
    };
  }
  /** Creates a new instance with the same value */
  clone() {
    return new Pf(this.atomics, this.fractionalDigits);
  }
  /** Returns the greatest decimal <= this which has no fractional part (rounding down) */
  floor() {
    const c = new bn_js_1$1.default(10).pow(new bn_js_1$1.default(this.data.fractionalDigits)), u = this.data.atomics.div(c);
    return this.data.atomics.mod(c).isZero() ? this.clone() : Pf.fromAtomics(u.mul(c).toString(), this.fractionalDigits);
  }
  /** Returns the smallest decimal >= this which has no fractional part (rounding up) */
  ceil() {
    const c = new bn_js_1$1.default(10).pow(new bn_js_1$1.default(this.data.fractionalDigits)), u = this.data.atomics.div(c);
    return this.data.atomics.mod(c).isZero() ? this.clone() : Pf.fromAtomics(u.addn(1).mul(c).toString(), this.fractionalDigits);
  }
  toString() {
    const c = new bn_js_1$1.default(10).pow(new bn_js_1$1.default(this.data.fractionalDigits)), u = this.data.atomics.div(c), p = this.data.atomics.mod(c);
    if (p.isZero())
      return u.toString();
    {
      const A = p.toString().padStart(this.data.fractionalDigits, "0").replace(/0+$/, "");
      return `${u.toString()}.${A}`;
    }
  }
  /**
   * Returns an approximation as a float type. Only use this if no
   * exact calculation is required.
   */
  toFloatApproximation() {
    const c = Number(this.toString());
    if (Number.isNaN(c))
      throw new Error("Conversion to number failed");
    return c;
  }
  /**
   * a.plus(b) returns a+b.
   *
   * Both values need to have the same fractional digits.
   */
  plus(c) {
    if (this.fractionalDigits !== c.fractionalDigits)
      throw new Error("Fractional digits do not match");
    const u = this.data.atomics.add(new bn_js_1$1.default(c.atomics));
    return new Pf(u.toString(), this.fractionalDigits);
  }
  /**
   * a.minus(b) returns a-b.
   *
   * Both values need to have the same fractional digits.
   * The resulting difference needs to be non-negative.
   */
  minus(c) {
    if (this.fractionalDigits !== c.fractionalDigits)
      throw new Error("Fractional digits do not match");
    const u = this.data.atomics.sub(new bn_js_1$1.default(c.atomics));
    if (u.ltn(0))
      throw new Error("Difference must not be negative");
    return new Pf(u.toString(), this.fractionalDigits);
  }
  /**
   * a.multiply(b) returns a*b.
   *
   * We only allow multiplication by unsigned integers to avoid rounding errors.
   */
  multiply(c) {
    const u = this.data.atomics.mul(new bn_js_1$1.default(c.toString()));
    return new Pf(u.toString(), this.fractionalDigits);
  }
  equals(c) {
    return Pf.compare(this, c) === 0;
  }
  isLessThan(c) {
    return Pf.compare(this, c) < 0;
  }
  isLessThanOrEqual(c) {
    return Pf.compare(this, c) <= 0;
  }
  isGreaterThan(c) {
    return Pf.compare(this, c) > 0;
  }
  isGreaterThanOrEqual(c) {
    return Pf.compare(this, c) >= 0;
  }
};
decimal$1.Decimal = Decimal$1;
var integers = {}, __importDefault$5 = commonjsGlobal && commonjsGlobal.__importDefault || function(n) {
  return n && n.__esModule ? n : { default: n };
};
Object.defineProperty(integers, "__esModule", { value: !0 });
integers.Uint64 = integers.Uint53 = integers.Int53 = integers.Uint32 = void 0;
const bn_js_1 = __importDefault$5(bnExports$1), uint64MaxValue = new bn_js_1.default("18446744073709551615", 10, "be");
class Uint32 {
  /** @deprecated use Uint32.fromBytes */
  static fromBigEndianBytes(c) {
    return Uint32.fromBytes(c);
  }
  /**
   * Creates a Uint32 from a fixed length byte array.
   *
   * @param bytes a list of exactly 4 bytes
   * @param endianess defaults to big endian
   */
  static fromBytes(c, u = "be") {
    if (c.length !== 4)
      throw new Error("Invalid input length. Expected 4 bytes.");
    for (let a = 0; a < c.length; ++a)
      if (!Number.isInteger(c[a]) || c[a] > 255 || c[a] < 0)
        throw new Error("Invalid value in byte. Found: " + c[a]);
    const p = u === "be" ? c : Array.from(c).reverse();
    return new Uint32(p[0] * 2 ** 24 + p[1] * 2 ** 16 + p[2] * 2 ** 8 + p[3]);
  }
  static fromString(c) {
    if (!c.match(/^[0-9]+$/))
      throw new Error("Invalid string format");
    return new Uint32(Number.parseInt(c, 10));
  }
  constructor(c) {
    if (Number.isNaN(c))
      throw new Error("Input is not a number");
    if (!Number.isInteger(c))
      throw new Error("Input is not an integer");
    if (c < 0 || c > 4294967295)
      throw new Error("Input not in uint32 range: " + c.toString());
    this.data = c;
  }
  toBytesBigEndian() {
    return new Uint8Array([
      Math.floor(this.data / 2 ** 24) & 255,
      Math.floor(this.data / 2 ** 16) & 255,
      Math.floor(this.data / 2 ** 8) & 255,
      Math.floor(this.data / 2 ** 0) & 255
    ]);
  }
  toBytesLittleEndian() {
    return new Uint8Array([
      Math.floor(this.data / 2 ** 0) & 255,
      Math.floor(this.data / 2 ** 8) & 255,
      Math.floor(this.data / 2 ** 16) & 255,
      Math.floor(this.data / 2 ** 24) & 255
    ]);
  }
  toNumber() {
    return this.data;
  }
  toBigInt() {
    return BigInt(this.toNumber());
  }
  toString() {
    return this.data.toString();
  }
}
integers.Uint32 = Uint32;
class Int53 {
  static fromString(c) {
    if (!c.match(/^-?[0-9]+$/))
      throw new Error("Invalid string format");
    return new Int53(Number.parseInt(c, 10));
  }
  constructor(c) {
    if (Number.isNaN(c))
      throw new Error("Input is not a number");
    if (!Number.isInteger(c))
      throw new Error("Input is not an integer");
    if (c < Number.MIN_SAFE_INTEGER || c > Number.MAX_SAFE_INTEGER)
      throw new Error("Input not in int53 range: " + c.toString());
    this.data = c;
  }
  toNumber() {
    return this.data;
  }
  toBigInt() {
    return BigInt(this.toNumber());
  }
  toString() {
    return this.data.toString();
  }
}
integers.Int53 = Int53;
class Uint53 {
  static fromString(c) {
    const u = Int53.fromString(c);
    return new Uint53(u.toNumber());
  }
  constructor(c) {
    const u = new Int53(c);
    if (u.toNumber() < 0)
      throw new Error("Input is negative");
    this.data = u;
  }
  toNumber() {
    return this.data.toNumber();
  }
  toBigInt() {
    return BigInt(this.toNumber());
  }
  toString() {
    return this.data.toString();
  }
}
integers.Uint53 = Uint53;
class Uint64 {
  /** @deprecated use Uint64.fromBytes */
  static fromBytesBigEndian(c) {
    return Uint64.fromBytes(c);
  }
  /**
   * Creates a Uint64 from a fixed length byte array.
   *
   * @param bytes a list of exactly 8 bytes
   * @param endianess defaults to big endian
   */
  static fromBytes(c, u = "be") {
    if (c.length !== 8)
      throw new Error("Invalid input length. Expected 8 bytes.");
    for (let a = 0; a < c.length; ++a)
      if (!Number.isInteger(c[a]) || c[a] > 255 || c[a] < 0)
        throw new Error("Invalid value in byte. Found: " + c[a]);
    const p = u === "be" ? Array.from(c) : Array.from(c).reverse();
    return new Uint64(new bn_js_1.default(p));
  }
  static fromString(c) {
    if (!c.match(/^[0-9]+$/))
      throw new Error("Invalid string format");
    return new Uint64(new bn_js_1.default(c, 10, "be"));
  }
  static fromNumber(c) {
    if (Number.isNaN(c))
      throw new Error("Input is not a number");
    if (!Number.isInteger(c))
      throw new Error("Input is not an integer");
    let u;
    try {
      u = new bn_js_1.default(c);
    } catch {
      throw new Error("Input is not a safe integer");
    }
    return new Uint64(u);
  }
  constructor(c) {
    if (c.isNeg())
      throw new Error("Input is negative");
    if (c.gt(uint64MaxValue))
      throw new Error("Input exceeds uint64 range");
    this.data = c;
  }
  toBytesBigEndian() {
    return Uint8Array.from(this.data.toArray("be", 8));
  }
  toBytesLittleEndian() {
    return Uint8Array.from(this.data.toArray("le", 8));
  }
  toString() {
    return this.data.toString(10);
  }
  toBigInt() {
    return BigInt(this.toString());
  }
  toNumber() {
    return this.data.toNumber();
  }
}
integers.Uint64 = Uint64;
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.Uint64 = n.Uint53 = n.Uint32 = n.Int53 = n.Decimal = void 0;
  var c = decimal$1;
  Object.defineProperty(n, "Decimal", { enumerable: !0, get: function() {
    return c.Decimal;
  } });
  var u = integers;
  Object.defineProperty(n, "Int53", { enumerable: !0, get: function() {
    return u.Int53;
  } }), Object.defineProperty(n, "Uint32", { enumerable: !0, get: function() {
    return u.Uint32;
  } }), Object.defineProperty(n, "Uint53", { enumerable: !0, get: function() {
    return u.Uint53;
  } }), Object.defineProperty(n, "Uint64", { enumerable: !0, get: function() {
    return u.Uint64;
  } });
})(build$1);
(function(n) {
  var c = commonjsGlobal && commonjsGlobal.__importDefault || function(Pe) {
    return Pe && Pe.__esModule ? Pe : { default: Pe };
  };
  Object.defineProperty(n, "__esModule", { value: !0 }), n.stringToPath = n.pathToString = n.Slip10 = n.Slip10RawIndex = n.slip10CurveFromString = n.Slip10Curve = void 0;
  const u = build$3, p = build$1, a = c(bnExports$1), A = c(requireElliptic$2()), b = hmac, F = sha;
  var le;
  (function(Pe) {
    Pe.Secp256k1 = "Bitcoin seed", Pe.Ed25519 = "ed25519 seed";
  })(le = n.Slip10Curve || (n.Slip10Curve = {}));
  function L(Pe) {
    switch (Pe) {
      case le.Ed25519:
        return le.Ed25519;
      case le.Secp256k1:
        return le.Secp256k1;
      default:
        throw new Error(`Unknown curve string: '${Pe}'`);
    }
  }
  n.slip10CurveFromString = L;
  class pe extends p.Uint32 {
    static hardened(nr) {
      return new pe(nr + 2 ** 31);
    }
    static normal(nr) {
      return new pe(nr);
    }
    isHardened() {
      return this.data >= 2 ** 31;
    }
  }
  n.Slip10RawIndex = pe;
  const $ = new A.default.ec("secp256k1");
  class Ee {
    static derivePath(nr, ir, or) {
      let lr = this.master(nr, ir);
      for (const Ir of or)
        lr = this.child(nr, lr.privkey, lr.chainCode, Ir);
      return lr;
    }
    static master(nr, ir) {
      const or = new b.Hmac(F.Sha512, (0, u.toAscii)(nr)).update(ir).digest(), lr = or.slice(0, 32), Ir = or.slice(32, 64);
      return nr !== le.Ed25519 && (this.isZero(lr) || this.isGteN(nr, lr)) ? this.master(nr, or) : {
        chainCode: Ir,
        privkey: lr
      };
    }
    static child(nr, ir, or, lr) {
      let Ir;
      if (lr.isHardened()) {
        const xr = new Uint8Array([0, ...ir, ...lr.toBytesBigEndian()]);
        Ir = new b.Hmac(F.Sha512, or).update(xr).digest();
      } else {
        if (nr === le.Ed25519)
          throw new Error("Normal keys are not allowed with ed25519");
        {
          const xr = new Uint8Array([
            ...Ee.serializedPoint(nr, new a.default(ir)),
            ...lr.toBytesBigEndian()
          ]);
          Ir = new b.Hmac(F.Sha512, or).update(xr).digest();
        }
      }
      return this.childImpl(nr, ir, or, lr, Ir);
    }
    /**
     * Implementation of ser_P(point(k_par)) from BIP-0032
     *
     * @see https://github.com/bitcoin/bips/blob/master/bip-0032.mediawiki
     */
    static serializedPoint(nr, ir) {
      switch (nr) {
        case le.Secp256k1:
          return (0, u.fromHex)($.g.mul(ir).encodeCompressed("hex"));
        default:
          throw new Error("curve not supported");
      }
    }
    static childImpl(nr, ir, or, lr, Ir) {
      const xr = Ir.slice(0, 32), kr = Ir.slice(32, 64), Ce = kr;
      if (nr === le.Ed25519)
        return {
          chainCode: Ce,
          privkey: xr
        };
      const tr = this.n(nr), Fe = new a.default(xr).add(new a.default(ir)).mod(tr), Sr = Uint8Array.from(Fe.toArray("be", 32));
      if (this.isGteN(nr, xr) || this.isZero(Sr)) {
        const er = new b.Hmac(F.Sha512, or).update(new Uint8Array([1, ...kr, ...lr.toBytesBigEndian()])).digest();
        return this.childImpl(nr, ir, or, lr, er);
      }
      return {
        chainCode: Ce,
        privkey: Sr
      };
    }
    static isZero(nr) {
      return nr.every((ir) => ir === 0);
    }
    static isGteN(nr, ir) {
      return new a.default(ir).gte(this.n(nr));
    }
    static n(nr) {
      switch (nr) {
        case le.Secp256k1:
          return new a.default("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", 16);
        default:
          throw new Error("curve not supported");
      }
    }
  }
  n.Slip10 = Ee;
  function be(Pe) {
    return Pe.reduce((nr, ir) => {
      const or = ir.isHardened() ? `${ir.toNumber() - 2147483648}'` : ir.toString();
      return nr + "/" + or;
    }, "m");
  }
  n.pathToString = be;
  function He(Pe) {
    if (!Pe.startsWith("m"))
      throw new Error("Path string must start with 'm'");
    let nr = Pe.slice(1);
    const ir = new Array();
    for (; nr; ) {
      const or = nr.match(/^\/([0-9]+)('?)/);
      if (!or)
        throw new Error("Syntax error while reading path component");
      const [lr, Ir, xr] = or, kr = p.Uint53.fromString(Ir).toNumber();
      if (kr >= 2 ** 31)
        throw new Error("Component value too high. Must not exceed 2**31-1.");
      xr ? ir.push(pe.hardened(kr)) : ir.push(pe.normal(kr)), nr = nr.slice(lr.length);
    }
    return ir;
  }
  n.stringToPath = He;
})(slip10);
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.stringToPath = n.Slip10RawIndex = n.slip10CurveFromString = n.Slip10Curve = n.Slip10 = n.pathToString = n.sha512 = n.Sha512 = n.sha256 = n.Sha256 = n.Secp256k1Signature = n.ExtendedSecp256k1Signature = n.Secp256k1 = n.ripemd160 = n.Ripemd160 = n.Random = n.Xchacha20poly1305Ietf = n.xchacha20NonceLength = n.isArgon2idOptions = n.Ed25519Keypair = n.Ed25519 = n.Argon2id = n.keccak256 = n.Keccak256 = n.Hmac = n.EnglishMnemonic = n.Bip39 = void 0;
  var c = bip39;
  Object.defineProperty(n, "Bip39", { enumerable: !0, get: function() {
    return c.Bip39;
  } }), Object.defineProperty(n, "EnglishMnemonic", { enumerable: !0, get: function() {
    return c.EnglishMnemonic;
  } });
  var u = hmac;
  Object.defineProperty(n, "Hmac", { enumerable: !0, get: function() {
    return u.Hmac;
  } });
  var p = keccak;
  Object.defineProperty(n, "Keccak256", { enumerable: !0, get: function() {
    return p.Keccak256;
  } }), Object.defineProperty(n, "keccak256", { enumerable: !0, get: function() {
    return p.keccak256;
  } });
  var a = libsodium;
  Object.defineProperty(n, "Argon2id", { enumerable: !0, get: function() {
    return a.Argon2id;
  } }), Object.defineProperty(n, "Ed25519", { enumerable: !0, get: function() {
    return a.Ed25519;
  } }), Object.defineProperty(n, "Ed25519Keypair", { enumerable: !0, get: function() {
    return a.Ed25519Keypair;
  } }), Object.defineProperty(n, "isArgon2idOptions", { enumerable: !0, get: function() {
    return a.isArgon2idOptions;
  } }), Object.defineProperty(n, "xchacha20NonceLength", { enumerable: !0, get: function() {
    return a.xchacha20NonceLength;
  } }), Object.defineProperty(n, "Xchacha20poly1305Ietf", { enumerable: !0, get: function() {
    return a.Xchacha20poly1305Ietf;
  } });
  var A = random$3;
  Object.defineProperty(n, "Random", { enumerable: !0, get: function() {
    return A.Random;
  } });
  var b = ripemd;
  Object.defineProperty(n, "Ripemd160", { enumerable: !0, get: function() {
    return b.Ripemd160;
  } }), Object.defineProperty(n, "ripemd160", { enumerable: !0, get: function() {
    return b.ripemd160;
  } });
  var F = secp256k1$4;
  Object.defineProperty(n, "Secp256k1", { enumerable: !0, get: function() {
    return F.Secp256k1;
  } });
  var le = secp256k1signature;
  Object.defineProperty(n, "ExtendedSecp256k1Signature", { enumerable: !0, get: function() {
    return le.ExtendedSecp256k1Signature;
  } }), Object.defineProperty(n, "Secp256k1Signature", { enumerable: !0, get: function() {
    return le.Secp256k1Signature;
  } });
  var L = sha;
  Object.defineProperty(n, "Sha256", { enumerable: !0, get: function() {
    return L.Sha256;
  } }), Object.defineProperty(n, "sha256", { enumerable: !0, get: function() {
    return L.sha256;
  } }), Object.defineProperty(n, "Sha512", { enumerable: !0, get: function() {
    return L.Sha512;
  } }), Object.defineProperty(n, "sha512", { enumerable: !0, get: function() {
    return L.sha512;
  } });
  var pe = slip10;
  Object.defineProperty(n, "pathToString", { enumerable: !0, get: function() {
    return pe.pathToString;
  } }), Object.defineProperty(n, "Slip10", { enumerable: !0, get: function() {
    return pe.Slip10;
  } }), Object.defineProperty(n, "Slip10Curve", { enumerable: !0, get: function() {
    return pe.Slip10Curve;
  } }), Object.defineProperty(n, "slip10CurveFromString", { enumerable: !0, get: function() {
    return pe.slip10CurveFromString;
  } }), Object.defineProperty(n, "Slip10RawIndex", { enumerable: !0, get: function() {
    return pe.Slip10RawIndex;
  } }), Object.defineProperty(n, "stringToPath", { enumerable: !0, get: function() {
    return pe.stringToPath;
  } });
})(build$4);
var tx = {}, indexMinimal = {}, minimal$1 = {}, aspromise = asPromise;
function asPromise(n, c) {
  for (var u = new Array(arguments.length - 1), p = 0, a = 2, A = !0; a < arguments.length; )
    u[p++] = arguments[a++];
  return new Promise(function(F, le) {
    u[p] = function(pe) {
      if (A)
        if (A = !1, pe)
          le(pe);
        else {
          for (var $ = new Array(arguments.length - 1), Ee = 0; Ee < $.length; )
            $[Ee++] = arguments[Ee];
          F.apply(null, $);
        }
    };
    try {
      n.apply(c || null, u);
    } catch (L) {
      A && (A = !1, le(L));
    }
  });
}
var base64$2 = {};
(function(n) {
  var c = n;
  c.length = function(F) {
    var le = F.length;
    if (!le)
      return 0;
    for (var L = 0; --le % 4 > 1 && F.charAt(le) === "="; )
      ++L;
    return Math.ceil(F.length * 3) / 4 - L;
  };
  for (var u = new Array(64), p = new Array(123), a = 0; a < 64; )
    p[u[a] = a < 26 ? a + 65 : a < 52 ? a + 71 : a < 62 ? a - 4 : a - 59 | 43] = a++;
  c.encode = function(F, le, L) {
    for (var pe = null, $ = [], Ee = 0, be = 0, He; le < L; ) {
      var Pe = F[le++];
      switch (be) {
        case 0:
          $[Ee++] = u[Pe >> 2], He = (Pe & 3) << 4, be = 1;
          break;
        case 1:
          $[Ee++] = u[He | Pe >> 4], He = (Pe & 15) << 2, be = 2;
          break;
        case 2:
          $[Ee++] = u[He | Pe >> 6], $[Ee++] = u[Pe & 63], be = 0;
          break;
      }
      Ee > 8191 && ((pe || (pe = [])).push(String.fromCharCode.apply(String, $)), Ee = 0);
    }
    return be && ($[Ee++] = u[He], $[Ee++] = 61, be === 1 && ($[Ee++] = 61)), pe ? (Ee && pe.push(String.fromCharCode.apply(String, $.slice(0, Ee))), pe.join("")) : String.fromCharCode.apply(String, $.slice(0, Ee));
  };
  var A = "invalid encoding";
  c.decode = function(F, le, L) {
    for (var pe = L, $ = 0, Ee, be = 0; be < F.length; ) {
      var He = F.charCodeAt(be++);
      if (He === 61 && $ > 1)
        break;
      if ((He = p[He]) === void 0)
        throw Error(A);
      switch ($) {
        case 0:
          Ee = He, $ = 1;
          break;
        case 1:
          le[L++] = Ee << 2 | (He & 48) >> 4, Ee = He, $ = 2;
          break;
        case 2:
          le[L++] = (Ee & 15) << 4 | (He & 60) >> 2, Ee = He, $ = 3;
          break;
        case 3:
          le[L++] = (Ee & 3) << 6 | He, $ = 0;
          break;
      }
    }
    if ($ === 1)
      throw Error(A);
    return L - pe;
  }, c.test = function(F) {
    return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(F);
  };
})(base64$2);
var eventemitter = EventEmitter;
function EventEmitter() {
  this._listeners = {};
}
EventEmitter.prototype.on = function n(c, u, p) {
  return (this._listeners[c] || (this._listeners[c] = [])).push({
    fn: u,
    ctx: p || this
  }), this;
};
EventEmitter.prototype.off = function n(c, u) {
  if (c === void 0)
    this._listeners = {};
  else if (u === void 0)
    this._listeners[c] = [];
  else
    for (var p = this._listeners[c], a = 0; a < p.length; )
      p[a].fn === u ? p.splice(a, 1) : ++a;
  return this;
};
EventEmitter.prototype.emit = function n(c) {
  var u = this._listeners[c];
  if (u) {
    for (var p = [], a = 1; a < arguments.length; )
      p.push(arguments[a++]);
    for (a = 0; a < u.length; )
      u[a].fn.apply(u[a++].ctx, p);
  }
  return this;
};
var float = factory(factory);
function factory(n) {
  return typeof Float32Array < "u" ? function() {
    var c = new Float32Array([-0]), u = new Uint8Array(c.buffer), p = u[3] === 128;
    function a(le, L, pe) {
      c[0] = le, L[pe] = u[0], L[pe + 1] = u[1], L[pe + 2] = u[2], L[pe + 3] = u[3];
    }
    function A(le, L, pe) {
      c[0] = le, L[pe] = u[3], L[pe + 1] = u[2], L[pe + 2] = u[1], L[pe + 3] = u[0];
    }
    n.writeFloatLE = p ? a : A, n.writeFloatBE = p ? A : a;
    function b(le, L) {
      return u[0] = le[L], u[1] = le[L + 1], u[2] = le[L + 2], u[3] = le[L + 3], c[0];
    }
    function F(le, L) {
      return u[3] = le[L], u[2] = le[L + 1], u[1] = le[L + 2], u[0] = le[L + 3], c[0];
    }
    n.readFloatLE = p ? b : F, n.readFloatBE = p ? F : b;
  }() : function() {
    function c(p, a, A, b) {
      var F = a < 0 ? 1 : 0;
      if (F && (a = -a), a === 0)
        p(1 / a > 0 ? (
          /* positive */
          0
        ) : (
          /* negative 0 */
          2147483648
        ), A, b);
      else if (isNaN(a))
        p(2143289344, A, b);
      else if (a > 34028234663852886e22)
        p((F << 31 | 2139095040) >>> 0, A, b);
      else if (a < 11754943508222875e-54)
        p((F << 31 | Math.round(a / 1401298464324817e-60)) >>> 0, A, b);
      else {
        var le = Math.floor(Math.log(a) / Math.LN2), L = Math.round(a * Math.pow(2, -le) * 8388608) & 8388607;
        p((F << 31 | le + 127 << 23 | L) >>> 0, A, b);
      }
    }
    n.writeFloatLE = c.bind(null, writeUintLE), n.writeFloatBE = c.bind(null, writeUintBE);
    function u(p, a, A) {
      var b = p(a, A), F = (b >> 31) * 2 + 1, le = b >>> 23 & 255, L = b & 8388607;
      return le === 255 ? L ? NaN : F * (1 / 0) : le === 0 ? F * 1401298464324817e-60 * L : F * Math.pow(2, le - 150) * (L + 8388608);
    }
    n.readFloatLE = u.bind(null, readUintLE), n.readFloatBE = u.bind(null, readUintBE);
  }(), typeof Float64Array < "u" ? function() {
    var c = new Float64Array([-0]), u = new Uint8Array(c.buffer), p = u[7] === 128;
    function a(le, L, pe) {
      c[0] = le, L[pe] = u[0], L[pe + 1] = u[1], L[pe + 2] = u[2], L[pe + 3] = u[3], L[pe + 4] = u[4], L[pe + 5] = u[5], L[pe + 6] = u[6], L[pe + 7] = u[7];
    }
    function A(le, L, pe) {
      c[0] = le, L[pe] = u[7], L[pe + 1] = u[6], L[pe + 2] = u[5], L[pe + 3] = u[4], L[pe + 4] = u[3], L[pe + 5] = u[2], L[pe + 6] = u[1], L[pe + 7] = u[0];
    }
    n.writeDoubleLE = p ? a : A, n.writeDoubleBE = p ? A : a;
    function b(le, L) {
      return u[0] = le[L], u[1] = le[L + 1], u[2] = le[L + 2], u[3] = le[L + 3], u[4] = le[L + 4], u[5] = le[L + 5], u[6] = le[L + 6], u[7] = le[L + 7], c[0];
    }
    function F(le, L) {
      return u[7] = le[L], u[6] = le[L + 1], u[5] = le[L + 2], u[4] = le[L + 3], u[3] = le[L + 4], u[2] = le[L + 5], u[1] = le[L + 6], u[0] = le[L + 7], c[0];
    }
    n.readDoubleLE = p ? b : F, n.readDoubleBE = p ? F : b;
  }() : function() {
    function c(p, a, A, b, F, le) {
      var L = b < 0 ? 1 : 0;
      if (L && (b = -b), b === 0)
        p(0, F, le + a), p(1 / b > 0 ? (
          /* positive */
          0
        ) : (
          /* negative 0 */
          2147483648
        ), F, le + A);
      else if (isNaN(b))
        p(0, F, le + a), p(2146959360, F, le + A);
      else if (b > 17976931348623157e292)
        p(0, F, le + a), p((L << 31 | 2146435072) >>> 0, F, le + A);
      else {
        var pe;
        if (b < 22250738585072014e-324)
          pe = b / 5e-324, p(pe >>> 0, F, le + a), p((L << 31 | pe / 4294967296) >>> 0, F, le + A);
        else {
          var $ = Math.floor(Math.log(b) / Math.LN2);
          $ === 1024 && ($ = 1023), pe = b * Math.pow(2, -$), p(pe * 4503599627370496 >>> 0, F, le + a), p((L << 31 | $ + 1023 << 20 | pe * 1048576 & 1048575) >>> 0, F, le + A);
        }
      }
    }
    n.writeDoubleLE = c.bind(null, writeUintLE, 0, 4), n.writeDoubleBE = c.bind(null, writeUintBE, 4, 0);
    function u(p, a, A, b, F) {
      var le = p(b, F + a), L = p(b, F + A), pe = (L >> 31) * 2 + 1, $ = L >>> 20 & 2047, Ee = 4294967296 * (L & 1048575) + le;
      return $ === 2047 ? Ee ? NaN : pe * (1 / 0) : $ === 0 ? pe * 5e-324 * Ee : pe * Math.pow(2, $ - 1075) * (Ee + 4503599627370496);
    }
    n.readDoubleLE = u.bind(null, readUintLE, 0, 4), n.readDoubleBE = u.bind(null, readUintBE, 4, 0);
  }(), n;
}
function writeUintLE(n, c, u) {
  c[u] = n & 255, c[u + 1] = n >>> 8 & 255, c[u + 2] = n >>> 16 & 255, c[u + 3] = n >>> 24;
}
function writeUintBE(n, c, u) {
  c[u] = n >>> 24, c[u + 1] = n >>> 16 & 255, c[u + 2] = n >>> 8 & 255, c[u + 3] = n & 255;
}
function readUintLE(n, c) {
  return (n[c] | n[c + 1] << 8 | n[c + 2] << 16 | n[c + 3] << 24) >>> 0;
}
function readUintBE(n, c) {
  return (n[c] << 24 | n[c + 1] << 16 | n[c + 2] << 8 | n[c + 3]) >>> 0;
}
var inquire_1 = inquire;
function inquire(moduleName) {
  try {
    var mod = eval("quire".replace(/^/, "re"))(moduleName);
    if (mod && (mod.length || Object.keys(mod).length))
      return mod;
  } catch (n) {
  }
  return null;
}
var utf8$4 = {};
(function(n) {
  var c = n;
  c.length = function(p) {
    for (var a = 0, A = 0, b = 0; b < p.length; ++b)
      A = p.charCodeAt(b), A < 128 ? a += 1 : A < 2048 ? a += 2 : (A & 64512) === 55296 && (p.charCodeAt(b + 1) & 64512) === 56320 ? (++b, a += 4) : a += 3;
    return a;
  }, c.read = function(p, a, A) {
    var b = A - a;
    if (b < 1)
      return "";
    for (var F = null, le = [], L = 0, pe; a < A; )
      pe = p[a++], pe < 128 ? le[L++] = pe : pe > 191 && pe < 224 ? le[L++] = (pe & 31) << 6 | p[a++] & 63 : pe > 239 && pe < 365 ? (pe = ((pe & 7) << 18 | (p[a++] & 63) << 12 | (p[a++] & 63) << 6 | p[a++] & 63) - 65536, le[L++] = 55296 + (pe >> 10), le[L++] = 56320 + (pe & 1023)) : le[L++] = (pe & 15) << 12 | (p[a++] & 63) << 6 | p[a++] & 63, L > 8191 && ((F || (F = [])).push(String.fromCharCode.apply(String, le)), L = 0);
    return F ? (L && F.push(String.fromCharCode.apply(String, le.slice(0, L))), F.join("")) : String.fromCharCode.apply(String, le.slice(0, L));
  }, c.write = function(p, a, A) {
    for (var b = A, F, le, L = 0; L < p.length; ++L)
      F = p.charCodeAt(L), F < 128 ? a[A++] = F : F < 2048 ? (a[A++] = F >> 6 | 192, a[A++] = F & 63 | 128) : (F & 64512) === 55296 && ((le = p.charCodeAt(L + 1)) & 64512) === 56320 ? (F = 65536 + ((F & 1023) << 10) + (le & 1023), ++L, a[A++] = F >> 18 | 240, a[A++] = F >> 12 & 63 | 128, a[A++] = F >> 6 & 63 | 128, a[A++] = F & 63 | 128) : (a[A++] = F >> 12 | 224, a[A++] = F >> 6 & 63 | 128, a[A++] = F & 63 | 128);
    return A - b;
  };
})(utf8$4);
var pool_1 = pool;
function pool(n, c, u) {
  var p = u || 8192, a = p >>> 1, A = null, b = p;
  return function(le) {
    if (le < 1 || le > a)
      return n(le);
    b + le > p && (A = n(p), b = 0);
    var L = c.call(A, b, b += le);
    return b & 7 && (b = (b | 7) + 1), L;
  };
}
var longbits, hasRequiredLongbits;
function requireLongbits() {
  if (hasRequiredLongbits) return longbits;
  hasRequiredLongbits = 1, longbits = c;
  var n = requireMinimal();
  function c(A, b) {
    this.lo = A >>> 0, this.hi = b >>> 0;
  }
  var u = c.zero = new c(0, 0);
  u.toNumber = function() {
    return 0;
  }, u.zzEncode = u.zzDecode = function() {
    return this;
  }, u.length = function() {
    return 1;
  };
  var p = c.zeroHash = "\0\0\0\0\0\0\0\0";
  c.fromNumber = function(b) {
    if (b === 0)
      return u;
    var F = b < 0;
    F && (b = -b);
    var le = b >>> 0, L = (b - le) / 4294967296 >>> 0;
    return F && (L = ~L >>> 0, le = ~le >>> 0, ++le > 4294967295 && (le = 0, ++L > 4294967295 && (L = 0))), new c(le, L);
  }, c.from = function(b) {
    if (typeof b == "number")
      return c.fromNumber(b);
    if (n.isString(b))
      if (n.Long)
        b = n.Long.fromString(b);
      else
        return c.fromNumber(parseInt(b, 10));
    return b.low || b.high ? new c(b.low >>> 0, b.high >>> 0) : u;
  }, c.prototype.toNumber = function(b) {
    if (!b && this.hi >>> 31) {
      var F = ~this.lo + 1 >>> 0, le = ~this.hi >>> 0;
      return F || (le = le + 1 >>> 0), -(F + le * 4294967296);
    }
    return this.lo + this.hi * 4294967296;
  }, c.prototype.toLong = function(b) {
    return n.Long ? new n.Long(this.lo | 0, this.hi | 0, !!b) : { low: this.lo | 0, high: this.hi | 0, unsigned: !!b };
  };
  var a = String.prototype.charCodeAt;
  return c.fromHash = function(b) {
    return b === p ? u : new c(
      (a.call(b, 0) | a.call(b, 1) << 8 | a.call(b, 2) << 16 | a.call(b, 3) << 24) >>> 0,
      (a.call(b, 4) | a.call(b, 5) << 8 | a.call(b, 6) << 16 | a.call(b, 7) << 24) >>> 0
    );
  }, c.prototype.toHash = function() {
    return String.fromCharCode(
      this.lo & 255,
      this.lo >>> 8 & 255,
      this.lo >>> 16 & 255,
      this.lo >>> 24,
      this.hi & 255,
      this.hi >>> 8 & 255,
      this.hi >>> 16 & 255,
      this.hi >>> 24
    );
  }, c.prototype.zzEncode = function() {
    var b = this.hi >> 31;
    return this.hi = ((this.hi << 1 | this.lo >>> 31) ^ b) >>> 0, this.lo = (this.lo << 1 ^ b) >>> 0, this;
  }, c.prototype.zzDecode = function() {
    var b = -(this.lo & 1);
    return this.lo = ((this.lo >>> 1 | this.hi << 31) ^ b) >>> 0, this.hi = (this.hi >>> 1 ^ b) >>> 0, this;
  }, c.prototype.length = function() {
    var b = this.lo, F = (this.lo >>> 28 | this.hi << 4) >>> 0, le = this.hi >>> 24;
    return le === 0 ? F === 0 ? b < 16384 ? b < 128 ? 1 : 2 : b < 2097152 ? 3 : 4 : F < 16384 ? F < 128 ? 5 : 6 : F < 2097152 ? 7 : 8 : le < 128 ? 9 : 10;
  }, longbits;
}
var hasRequiredMinimal;
function requireMinimal() {
  return hasRequiredMinimal || (hasRequiredMinimal = 1, function(n) {
    var c = n;
    c.asPromise = aspromise, c.base64 = base64$2, c.EventEmitter = eventemitter, c.float = float, c.inquire = inquire_1, c.utf8 = utf8$4, c.pool = pool_1, c.LongBits = requireLongbits(), c.isNode = !!(typeof commonjsGlobal < "u" && commonjsGlobal && commonjsGlobal.process && commonjsGlobal.process.versions && commonjsGlobal.process.versions.node), c.global = c.isNode && commonjsGlobal || typeof window < "u" && window || typeof self < "u" && self || commonjsGlobal, c.emptyArray = Object.freeze ? Object.freeze([]) : (
      /* istanbul ignore next */
      []
    ), c.emptyObject = Object.freeze ? Object.freeze({}) : (
      /* istanbul ignore next */
      {}
    ), c.isInteger = Number.isInteger || /* istanbul ignore next */
    function(A) {
      return typeof A == "number" && isFinite(A) && Math.floor(A) === A;
    }, c.isString = function(A) {
      return typeof A == "string" || A instanceof String;
    }, c.isObject = function(A) {
      return A && typeof A == "object";
    }, c.isset = /**
     * Checks if a property on a message is considered to be present.
     * @param {Object} obj Plain object or message instance
     * @param {string} prop Property name
     * @returns {boolean} `true` if considered to be present, otherwise `false`
     */
    c.isSet = function(A, b) {
      var F = A[b];
      return F != null && A.hasOwnProperty(b) ? typeof F != "object" || (Array.isArray(F) ? F.length : Object.keys(F).length) > 0 : !1;
    }, c.Buffer = function() {
      try {
        var a = c.inquire("buffer").Buffer;
        return a.prototype.utf8Write ? a : (
          /* istanbul ignore next */
          null
        );
      } catch {
        return null;
      }
    }(), c._Buffer_from = null, c._Buffer_allocUnsafe = null, c.newBuffer = function(A) {
      return typeof A == "number" ? c.Buffer ? c._Buffer_allocUnsafe(A) : new c.Array(A) : c.Buffer ? c._Buffer_from(A) : typeof Uint8Array > "u" ? A : new Uint8Array(A);
    }, c.Array = typeof Uint8Array < "u" ? Uint8Array : Array, c.Long = /* istanbul ignore next */
    c.global.dcodeIO && /* istanbul ignore next */
    c.global.dcodeIO.Long || /* istanbul ignore next */
    c.global.Long || c.inquire("long"), c.key2Re = /^true|false|0|1$/, c.key32Re = /^-?(?:0|[1-9][0-9]*)$/, c.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/, c.longToHash = function(A) {
      return A ? c.LongBits.from(A).toHash() : c.LongBits.zeroHash;
    }, c.longFromHash = function(A, b) {
      var F = c.LongBits.fromHash(A);
      return c.Long ? c.Long.fromBits(F.lo, F.hi, b) : F.toNumber(!!b);
    };
    function u(a, A, b) {
      for (var F = Object.keys(A), le = 0; le < F.length; ++le)
        (a[F[le]] === void 0 || !b) && (a[F[le]] = A[F[le]]);
      return a;
    }
    c.merge = u, c.lcFirst = function(A) {
      return A.charAt(0).toLowerCase() + A.substring(1);
    };
    function p(a) {
      function A(b, F) {
        if (!(this instanceof A))
          return new A(b, F);
        Object.defineProperty(this, "message", { get: function() {
          return b;
        } }), Error.captureStackTrace ? Error.captureStackTrace(this, A) : Object.defineProperty(this, "stack", { value: new Error().stack || "" }), F && u(this, F);
      }
      return (A.prototype = Object.create(Error.prototype)).constructor = A, Object.defineProperty(A.prototype, "name", { get: function() {
        return a;
      } }), A.prototype.toString = function() {
        return this.name + ": " + this.message;
      }, A;
    }
    c.newError = p, c.ProtocolError = p("ProtocolError"), c.oneOfGetter = function(A) {
      for (var b = {}, F = 0; F < A.length; ++F)
        b[A[F]] = 1;
      return function() {
        for (var le = Object.keys(this), L = le.length - 1; L > -1; --L)
          if (b[le[L]] === 1 && this[le[L]] !== void 0 && this[le[L]] !== null)
            return le[L];
      };
    }, c.oneOfSetter = function(A) {
      return function(b) {
        for (var F = 0; F < A.length; ++F)
          A[F] !== b && delete this[A[F]];
      };
    }, c.toJSONOptions = {
      longs: String,
      enums: String,
      bytes: String,
      json: !0
    }, c._configure = function() {
      var a = c.Buffer;
      if (!a) {
        c._Buffer_from = c._Buffer_allocUnsafe = null;
        return;
      }
      c._Buffer_from = a.from !== Uint8Array.from && a.from || /* istanbul ignore next */
      function(b, F) {
        return new a(b, F);
      }, c._Buffer_allocUnsafe = a.allocUnsafe || /* istanbul ignore next */
      function(b) {
        return new a(b);
      };
    };
  }(minimal$1)), minimal$1;
}
var writer = Writer$1, util$6 = requireMinimal(), BufferWriter$2, LongBits$1 = util$6.LongBits, base64$1 = util$6.base64, utf8$3 = util$6.utf8;
function Op(n, c, u) {
  this.fn = n, this.len = c, this.next = void 0, this.val = u;
}
function noop() {
}
function State(n) {
  this.head = n.head, this.tail = n.tail, this.len = n.len, this.next = n.states;
}
function Writer$1() {
  this.len = 0, this.head = new Op(noop, 0, 0), this.tail = this.head, this.states = null;
}
var create$1 = function n() {
  return util$6.Buffer ? function() {
    return (Writer$1.create = function() {
      return new BufferWriter$2();
    })();
  } : function() {
    return new Writer$1();
  };
};
Writer$1.create = create$1();
Writer$1.alloc = function n(c) {
  return new util$6.Array(c);
};
util$6.Array !== Array && (Writer$1.alloc = util$6.pool(Writer$1.alloc, util$6.Array.prototype.subarray));
Writer$1.prototype._push = function n(c, u, p) {
  return this.tail = this.tail.next = new Op(c, u, p), this.len += u, this;
};
function writeByte(n, c, u) {
  c[u] = n & 255;
}
function writeVarint32(n, c, u) {
  for (; n > 127; )
    c[u++] = n & 127 | 128, n >>>= 7;
  c[u] = n;
}
function VarintOp(n, c) {
  this.len = n, this.next = void 0, this.val = c;
}
VarintOp.prototype = Object.create(Op.prototype);
VarintOp.prototype.fn = writeVarint32;
Writer$1.prototype.uint32 = function n(c) {
  return this.len += (this.tail = this.tail.next = new VarintOp(
    (c = c >>> 0) < 128 ? 1 : c < 16384 ? 2 : c < 2097152 ? 3 : c < 268435456 ? 4 : 5,
    c
  )).len, this;
};
Writer$1.prototype.int32 = function n(c) {
  return c < 0 ? this._push(writeVarint64, 10, LongBits$1.fromNumber(c)) : this.uint32(c);
};
Writer$1.prototype.sint32 = function n(c) {
  return this.uint32((c << 1 ^ c >> 31) >>> 0);
};
function writeVarint64(n, c, u) {
  for (; n.hi; )
    c[u++] = n.lo & 127 | 128, n.lo = (n.lo >>> 7 | n.hi << 25) >>> 0, n.hi >>>= 7;
  for (; n.lo > 127; )
    c[u++] = n.lo & 127 | 128, n.lo = n.lo >>> 7;
  c[u++] = n.lo;
}
Writer$1.prototype.uint64 = function n(c) {
  var u = LongBits$1.from(c);
  return this._push(writeVarint64, u.length(), u);
};
Writer$1.prototype.int64 = Writer$1.prototype.uint64;
Writer$1.prototype.sint64 = function n(c) {
  var u = LongBits$1.from(c).zzEncode();
  return this._push(writeVarint64, u.length(), u);
};
Writer$1.prototype.bool = function n(c) {
  return this._push(writeByte, 1, c ? 1 : 0);
};
function writeFixed32(n, c, u) {
  c[u] = n & 255, c[u + 1] = n >>> 8 & 255, c[u + 2] = n >>> 16 & 255, c[u + 3] = n >>> 24;
}
Writer$1.prototype.fixed32 = function n(c) {
  return this._push(writeFixed32, 4, c >>> 0);
};
Writer$1.prototype.sfixed32 = Writer$1.prototype.fixed32;
Writer$1.prototype.fixed64 = function n(c) {
  var u = LongBits$1.from(c);
  return this._push(writeFixed32, 4, u.lo)._push(writeFixed32, 4, u.hi);
};
Writer$1.prototype.sfixed64 = Writer$1.prototype.fixed64;
Writer$1.prototype.float = function n(c) {
  return this._push(util$6.float.writeFloatLE, 4, c);
};
Writer$1.prototype.double = function n(c) {
  return this._push(util$6.float.writeDoubleLE, 8, c);
};
var writeBytes = util$6.Array.prototype.set ? function n(c, u, p) {
  u.set(c, p);
} : function n(c, u, p) {
  for (var a = 0; a < c.length; ++a)
    u[p + a] = c[a];
};
Writer$1.prototype.bytes = function n(c) {
  var u = c.length >>> 0;
  if (!u)
    return this._push(writeByte, 1, 0);
  if (util$6.isString(c)) {
    var p = Writer$1.alloc(u = base64$1.length(c));
    base64$1.decode(c, p, 0), c = p;
  }
  return this.uint32(u)._push(writeBytes, u, c);
};
Writer$1.prototype.string = function n(c) {
  var u = utf8$3.length(c);
  return u ? this.uint32(u)._push(utf8$3.write, u, c) : this._push(writeByte, 1, 0);
};
Writer$1.prototype.fork = function n() {
  return this.states = new State(this), this.head = this.tail = new Op(noop, 0, 0), this.len = 0, this;
};
Writer$1.prototype.reset = function n() {
  return this.states ? (this.head = this.states.head, this.tail = this.states.tail, this.len = this.states.len, this.states = this.states.next) : (this.head = this.tail = new Op(noop, 0, 0), this.len = 0), this;
};
Writer$1.prototype.ldelim = function n() {
  var c = this.head, u = this.tail, p = this.len;
  return this.reset().uint32(p), p && (this.tail.next = c.next, this.tail = u, this.len += p), this;
};
Writer$1.prototype.finish = function n() {
  for (var c = this.head.next, u = this.constructor.alloc(this.len), p = 0; c; )
    c.fn(c.val, u, p), p += c.len, c = c.next;
  return u;
};
Writer$1._configure = function(n) {
  BufferWriter$2 = n, Writer$1.create = create$1(), BufferWriter$2._configure();
};
var writer_buffer = BufferWriter$1, Writer = writer;
(BufferWriter$1.prototype = Object.create(Writer.prototype)).constructor = BufferWriter$1;
var util$5 = requireMinimal();
function BufferWriter$1() {
  Writer.call(this);
}
BufferWriter$1._configure = function() {
  BufferWriter$1.alloc = util$5._Buffer_allocUnsafe, BufferWriter$1.writeBytesBuffer = util$5.Buffer && util$5.Buffer.prototype instanceof Uint8Array && util$5.Buffer.prototype.set.name === "set" ? function(c, u, p) {
    u.set(c, p);
  } : function(c, u, p) {
    if (c.copy)
      c.copy(u, p, 0, c.length);
    else for (var a = 0; a < c.length; )
      u[p++] = c[a++];
  };
};
BufferWriter$1.prototype.bytes = function n(c) {
  util$5.isString(c) && (c = util$5._Buffer_from(c, "base64"));
  var u = c.length >>> 0;
  return this.uint32(u), u && this._push(BufferWriter$1.writeBytesBuffer, u, c), this;
};
function writeStringBuffer(n, c, u) {
  n.length < 40 ? util$5.utf8.write(n, c, u) : c.utf8Write ? c.utf8Write(n, u) : c.write(n, u);
}
BufferWriter$1.prototype.string = function n(c) {
  var u = util$5.Buffer.byteLength(c);
  return this.uint32(u), u && this._push(writeStringBuffer, u, c), this;
};
BufferWriter$1._configure();
var reader = Reader$1, util$4 = requireMinimal(), BufferReader$2, LongBits = util$4.LongBits, utf8$2 = util$4.utf8;
function indexOutOfRange(n, c) {
  return RangeError("index out of range: " + n.pos + " + " + (c || 1) + " > " + n.len);
}
function Reader$1(n) {
  this.buf = n, this.pos = 0, this.len = n.length;
}
var create_array = typeof Uint8Array < "u" ? function n(c) {
  if (c instanceof Uint8Array || Array.isArray(c))
    return new Reader$1(c);
  throw Error("illegal buffer");
} : function n(c) {
  if (Array.isArray(c))
    return new Reader$1(c);
  throw Error("illegal buffer");
}, create = function n() {
  return util$4.Buffer ? function(u) {
    return (Reader$1.create = function(a) {
      return util$4.Buffer.isBuffer(a) ? new BufferReader$2(a) : create_array(a);
    })(u);
  } : create_array;
};
Reader$1.create = create();
Reader$1.prototype._slice = util$4.Array.prototype.subarray || /* istanbul ignore next */
util$4.Array.prototype.slice;
Reader$1.prototype.uint32 = /* @__PURE__ */ function n() {
  var c = 4294967295;
  return function() {
    if (c = (this.buf[this.pos] & 127) >>> 0, this.buf[this.pos++] < 128 || (c = (c | (this.buf[this.pos] & 127) << 7) >>> 0, this.buf[this.pos++] < 128) || (c = (c | (this.buf[this.pos] & 127) << 14) >>> 0, this.buf[this.pos++] < 128) || (c = (c | (this.buf[this.pos] & 127) << 21) >>> 0, this.buf[this.pos++] < 128) || (c = (c | (this.buf[this.pos] & 15) << 28) >>> 0, this.buf[this.pos++] < 128)) return c;
    if ((this.pos += 5) > this.len)
      throw this.pos = this.len, indexOutOfRange(this, 10);
    return c;
  };
}();
Reader$1.prototype.int32 = function n() {
  return this.uint32() | 0;
};
Reader$1.prototype.sint32 = function n() {
  var c = this.uint32();
  return c >>> 1 ^ -(c & 1) | 0;
};
function readLongVarint() {
  var n = new LongBits(0, 0), c = 0;
  if (this.len - this.pos > 4) {
    for (; c < 4; ++c)
      if (n.lo = (n.lo | (this.buf[this.pos] & 127) << c * 7) >>> 0, this.buf[this.pos++] < 128)
        return n;
    if (n.lo = (n.lo | (this.buf[this.pos] & 127) << 28) >>> 0, n.hi = (n.hi | (this.buf[this.pos] & 127) >> 4) >>> 0, this.buf[this.pos++] < 128)
      return n;
    c = 0;
  } else {
    for (; c < 3; ++c) {
      if (this.pos >= this.len)
        throw indexOutOfRange(this);
      if (n.lo = (n.lo | (this.buf[this.pos] & 127) << c * 7) >>> 0, this.buf[this.pos++] < 128)
        return n;
    }
    return n.lo = (n.lo | (this.buf[this.pos++] & 127) << c * 7) >>> 0, n;
  }
  if (this.len - this.pos > 4) {
    for (; c < 5; ++c)
      if (n.hi = (n.hi | (this.buf[this.pos] & 127) << c * 7 + 3) >>> 0, this.buf[this.pos++] < 128)
        return n;
  } else
    for (; c < 5; ++c) {
      if (this.pos >= this.len)
        throw indexOutOfRange(this);
      if (n.hi = (n.hi | (this.buf[this.pos] & 127) << c * 7 + 3) >>> 0, this.buf[this.pos++] < 128)
        return n;
    }
  throw Error("invalid varint encoding");
}
Reader$1.prototype.bool = function n() {
  return this.uint32() !== 0;
};
function readFixed32_end(n, c) {
  return (n[c - 4] | n[c - 3] << 8 | n[c - 2] << 16 | n[c - 1] << 24) >>> 0;
}
Reader$1.prototype.fixed32 = function n() {
  if (this.pos + 4 > this.len)
    throw indexOutOfRange(this, 4);
  return readFixed32_end(this.buf, this.pos += 4);
};
Reader$1.prototype.sfixed32 = function n() {
  if (this.pos + 4 > this.len)
    throw indexOutOfRange(this, 4);
  return readFixed32_end(this.buf, this.pos += 4) | 0;
};
function readFixed64() {
  if (this.pos + 8 > this.len)
    throw indexOutOfRange(this, 8);
  return new LongBits(readFixed32_end(this.buf, this.pos += 4), readFixed32_end(this.buf, this.pos += 4));
}
Reader$1.prototype.float = function n() {
  if (this.pos + 4 > this.len)
    throw indexOutOfRange(this, 4);
  var c = util$4.float.readFloatLE(this.buf, this.pos);
  return this.pos += 4, c;
};
Reader$1.prototype.double = function n() {
  if (this.pos + 8 > this.len)
    throw indexOutOfRange(this, 4);
  var c = util$4.float.readDoubleLE(this.buf, this.pos);
  return this.pos += 8, c;
};
Reader$1.prototype.bytes = function n() {
  var c = this.uint32(), u = this.pos, p = this.pos + c;
  if (p > this.len)
    throw indexOutOfRange(this, c);
  return this.pos += c, Array.isArray(this.buf) ? this.buf.slice(u, p) : u === p ? new this.buf.constructor(0) : this._slice.call(this.buf, u, p);
};
Reader$1.prototype.string = function n() {
  var c = this.bytes();
  return utf8$2.read(c, 0, c.length);
};
Reader$1.prototype.skip = function n(c) {
  if (typeof c == "number") {
    if (this.pos + c > this.len)
      throw indexOutOfRange(this, c);
    this.pos += c;
  } else
    do
      if (this.pos >= this.len)
        throw indexOutOfRange(this);
    while (this.buf[this.pos++] & 128);
  return this;
};
Reader$1.prototype.skipType = function(n) {
  switch (n) {
    case 0:
      this.skip();
      break;
    case 1:
      this.skip(8);
      break;
    case 2:
      this.skip(this.uint32());
      break;
    case 3:
      for (; (n = this.uint32() & 7) !== 4; )
        this.skipType(n);
      break;
    case 5:
      this.skip(4);
      break;
    default:
      throw Error("invalid wire type " + n + " at offset " + this.pos);
  }
  return this;
};
Reader$1._configure = function(n) {
  BufferReader$2 = n, Reader$1.create = create(), BufferReader$2._configure();
  var c = util$4.Long ? "toLong" : (
    /* istanbul ignore next */
    "toNumber"
  );
  util$4.merge(Reader$1.prototype, {
    int64: function() {
      return readLongVarint.call(this)[c](!1);
    },
    uint64: function() {
      return readLongVarint.call(this)[c](!0);
    },
    sint64: function() {
      return readLongVarint.call(this).zzDecode()[c](!1);
    },
    fixed64: function() {
      return readFixed64.call(this)[c](!0);
    },
    sfixed64: function() {
      return readFixed64.call(this)[c](!1);
    }
  });
};
var reader_buffer = BufferReader$1, Reader = reader;
(BufferReader$1.prototype = Object.create(Reader.prototype)).constructor = BufferReader$1;
var util$3 = requireMinimal();
function BufferReader$1(n) {
  Reader.call(this, n);
}
BufferReader$1._configure = function() {
  util$3.Buffer && (BufferReader$1.prototype._slice = util$3.Buffer.prototype.slice);
};
BufferReader$1.prototype.string = function n() {
  var c = this.uint32();
  return this.buf.utf8Slice ? this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + c, this.len)) : this.buf.toString("utf-8", this.pos, this.pos = Math.min(this.pos + c, this.len));
};
BufferReader$1._configure();
var rpc = {}, service = Service, util$2 = requireMinimal();
(Service.prototype = Object.create(util$2.EventEmitter.prototype)).constructor = Service;
function Service(n, c, u) {
  if (typeof n != "function")
    throw TypeError("rpcImpl must be a function");
  util$2.EventEmitter.call(this), this.rpcImpl = n, this.requestDelimited = !!c, this.responseDelimited = !!u;
}
Service.prototype.rpcCall = function n(c, u, p, a, A) {
  if (!a)
    throw TypeError("request must be specified");
  var b = this;
  if (!A)
    return util$2.asPromise(n, b, c, u, p, a);
  if (!b.rpcImpl) {
    setTimeout(function() {
      A(Error("already ended"));
    }, 0);
    return;
  }
  try {
    return b.rpcImpl(
      c,
      u[b.requestDelimited ? "encodeDelimited" : "encode"](a).finish(),
      function(le, L) {
        if (le)
          return b.emit("error", le, c), A(le);
        if (L === null) {
          b.end(
            /* endedByRPC */
            !0
          );
          return;
        }
        if (!(L instanceof p))
          try {
            L = p[b.responseDelimited ? "decodeDelimited" : "decode"](L);
          } catch (pe) {
            return b.emit("error", pe, c), A(pe);
          }
        return b.emit("data", L, c), A(null, L);
      }
    );
  } catch (F) {
    b.emit("error", F, c), setTimeout(function() {
      A(F);
    }, 0);
    return;
  }
};
Service.prototype.end = function n(c) {
  return this.rpcImpl && (c || this.rpcImpl(null, null, null), this.rpcImpl = null, this.emit("end").off()), this;
};
(function(n) {
  var c = n;
  c.Service = service;
})(rpc);
var roots = {};
(function(n) {
  var c = n;
  c.build = "minimal", c.Writer = writer, c.BufferWriter = writer_buffer, c.Reader = reader, c.BufferReader = reader_buffer, c.util = requireMinimal(), c.rpc = rpc, c.roots = roots, c.configure = u;
  function u() {
    c.util._configure(), c.Writer._configure(c.BufferWriter), c.Reader._configure(c.BufferReader);
  }
  u();
})(indexMinimal);
var minimal = indexMinimal, signing = {}, any = {}, __importDefault$4 = commonjsGlobal && commonjsGlobal.__importDefault || function(n) {
  return n && n.__esModule ? n : { default: n };
};
Object.defineProperty(any, "__esModule", { value: !0 });
any.Any = any.protobufPackage = void 0;
const long_1$2 = __importDefault$4(long), minimal_1$2 = __importDefault$4(minimal);
any.protobufPackage = "google.protobuf";
function createBaseAny() {
  return { typeUrl: "", value: new Uint8Array() };
}
any.Any = {
  encode(n, c = minimal_1$2.default.Writer.create()) {
    return n.typeUrl !== "" && c.uint32(10).string(n.typeUrl), n.value.length !== 0 && c.uint32(18).bytes(n.value), c;
  },
  decode(n, c) {
    const u = n instanceof minimal_1$2.default.Reader ? n : new minimal_1$2.default.Reader(n);
    let p = c === void 0 ? u.len : u.pos + c;
    const a = createBaseAny();
    for (; u.pos < p; ) {
      const A = u.uint32();
      switch (A >>> 3) {
        case 1:
          a.typeUrl = u.string();
          break;
        case 2:
          a.value = u.bytes();
          break;
        default:
          u.skipType(A & 7);
          break;
      }
    }
    return a;
  },
  fromJSON(n) {
    return {
      typeUrl: isSet$2(n.typeUrl) ? String(n.typeUrl) : "",
      value: isSet$2(n.value) ? bytesFromBase64$1(n.value) : new Uint8Array()
    };
  },
  toJSON(n) {
    const c = {};
    return n.typeUrl !== void 0 && (c.typeUrl = n.typeUrl), n.value !== void 0 && (c.value = base64FromBytes$1(n.value !== void 0 ? n.value : new Uint8Array())), c;
  },
  fromPartial(n) {
    var c, u;
    const p = createBaseAny();
    return p.typeUrl = (c = n.typeUrl) !== null && c !== void 0 ? c : "", p.value = (u = n.value) !== null && u !== void 0 ? u : new Uint8Array(), p;
  }
};
var globalThis$2 = (() => {
  if (typeof globalThis$2 < "u")
    return globalThis$2;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof commonjsGlobal < "u")
    return commonjsGlobal;
  throw "Unable to locate global object";
})();
const atob$2 = globalThis$2.atob || ((n) => globalThis$2.Buffer.from(n, "base64").toString("binary"));
function bytesFromBase64$1(n) {
  const c = atob$2(n), u = new Uint8Array(c.length);
  for (let p = 0; p < c.length; ++p)
    u[p] = c.charCodeAt(p);
  return u;
}
const btoa$1 = globalThis$2.btoa || ((n) => globalThis$2.Buffer.from(n, "binary").toString("base64"));
function base64FromBytes$1(n) {
  const c = [];
  for (const u of n)
    c.push(String.fromCharCode(u));
  return btoa$1(c.join(""));
}
minimal_1$2.default.util.Long !== long_1$2.default && (minimal_1$2.default.util.Long = long_1$2.default, minimal_1$2.default.configure());
function isSet$2(n) {
  return n != null;
}
var multisig$1 = {}, __importDefault$3 = commonjsGlobal && commonjsGlobal.__importDefault || function(n) {
  return n && n.__esModule ? n : { default: n };
};
Object.defineProperty(multisig$1, "__esModule", { value: !0 });
multisig$1.CompactBitArray = multisig$1.MultiSignature = multisig$1.protobufPackage = void 0;
const long_1$1 = __importDefault$3(long), minimal_1$1 = __importDefault$3(minimal);
multisig$1.protobufPackage = "cosmos.crypto.multisig.v1beta1";
function createBaseMultiSignature() {
  return { signatures: [] };
}
multisig$1.MultiSignature = {
  encode(n, c = minimal_1$1.default.Writer.create()) {
    for (const u of n.signatures)
      c.uint32(10).bytes(u);
    return c;
  },
  decode(n, c) {
    const u = n instanceof minimal_1$1.default.Reader ? n : new minimal_1$1.default.Reader(n);
    let p = c === void 0 ? u.len : u.pos + c;
    const a = createBaseMultiSignature();
    for (; u.pos < p; ) {
      const A = u.uint32();
      switch (A >>> 3) {
        case 1:
          a.signatures.push(u.bytes());
          break;
        default:
          u.skipType(A & 7);
          break;
      }
    }
    return a;
  },
  fromJSON(n) {
    return {
      signatures: Array.isArray(n == null ? void 0 : n.signatures) ? n.signatures.map((c) => bytesFromBase64(c)) : []
    };
  },
  toJSON(n) {
    const c = {};
    return n.signatures ? c.signatures = n.signatures.map((u) => base64FromBytes(u !== void 0 ? u : new Uint8Array())) : c.signatures = [], c;
  },
  fromPartial(n) {
    var c;
    const u = createBaseMultiSignature();
    return u.signatures = ((c = n.signatures) === null || c === void 0 ? void 0 : c.map((p) => p)) || [], u;
  }
};
function createBaseCompactBitArray() {
  return { extraBitsStored: 0, elems: new Uint8Array() };
}
multisig$1.CompactBitArray = {
  encode(n, c = minimal_1$1.default.Writer.create()) {
    return n.extraBitsStored !== 0 && c.uint32(8).uint32(n.extraBitsStored), n.elems.length !== 0 && c.uint32(18).bytes(n.elems), c;
  },
  decode(n, c) {
    const u = n instanceof minimal_1$1.default.Reader ? n : new minimal_1$1.default.Reader(n);
    let p = c === void 0 ? u.len : u.pos + c;
    const a = createBaseCompactBitArray();
    for (; u.pos < p; ) {
      const A = u.uint32();
      switch (A >>> 3) {
        case 1:
          a.extraBitsStored = u.uint32();
          break;
        case 2:
          a.elems = u.bytes();
          break;
        default:
          u.skipType(A & 7);
          break;
      }
    }
    return a;
  },
  fromJSON(n) {
    return {
      extraBitsStored: isSet$1(n.extraBitsStored) ? Number(n.extraBitsStored) : 0,
      elems: isSet$1(n.elems) ? bytesFromBase64(n.elems) : new Uint8Array()
    };
  },
  toJSON(n) {
    const c = {};
    return n.extraBitsStored !== void 0 && (c.extraBitsStored = Math.round(n.extraBitsStored)), n.elems !== void 0 && (c.elems = base64FromBytes(n.elems !== void 0 ? n.elems : new Uint8Array())), c;
  },
  fromPartial(n) {
    var c, u;
    const p = createBaseCompactBitArray();
    return p.extraBitsStored = (c = n.extraBitsStored) !== null && c !== void 0 ? c : 0, p.elems = (u = n.elems) !== null && u !== void 0 ? u : new Uint8Array(), p;
  }
};
var globalThis$1 = (() => {
  if (typeof globalThis$1 < "u")
    return globalThis$1;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof commonjsGlobal < "u")
    return commonjsGlobal;
  throw "Unable to locate global object";
})();
const atob$1 = globalThis$1.atob || ((n) => globalThis$1.Buffer.from(n, "base64").toString("binary"));
function bytesFromBase64(n) {
  const c = atob$1(n), u = new Uint8Array(c.length);
  for (let p = 0; p < c.length; ++p)
    u[p] = c.charCodeAt(p);
  return u;
}
const btoa = globalThis$1.btoa || ((n) => globalThis$1.Buffer.from(n, "binary").toString("base64"));
function base64FromBytes(n) {
  const c = [];
  for (const u of n)
    c.push(String.fromCharCode(u));
  return btoa(c.join(""));
}
minimal_1$1.default.util.Long !== long_1$1.default && (minimal_1$1.default.util.Long = long_1$1.default, minimal_1$1.default.configure());
function isSet$1(n) {
  return n != null;
}
(function(n) {
  var c = commonjsGlobal && commonjsGlobal.__importDefault || function(xr) {
    return xr && xr.__esModule ? xr : { default: xr };
  };
  Object.defineProperty(n, "__esModule", { value: !0 }), n.SignatureDescriptor_Data_Multi = n.SignatureDescriptor_Data_Single = n.SignatureDescriptor_Data = n.SignatureDescriptor = n.SignatureDescriptors = n.signModeToJSON = n.signModeFromJSON = n.SignMode = n.protobufPackage = void 0;
  const u = c(long), p = c(minimal), a = any, A = multisig$1;
  n.protobufPackage = "cosmos.tx.signing.v1beta1";
  var b;
  (function(xr) {
    xr[xr.SIGN_MODE_UNSPECIFIED = 0] = "SIGN_MODE_UNSPECIFIED", xr[xr.SIGN_MODE_DIRECT = 1] = "SIGN_MODE_DIRECT", xr[xr.SIGN_MODE_TEXTUAL = 2] = "SIGN_MODE_TEXTUAL", xr[xr.SIGN_MODE_DIRECT_AUX = 3] = "SIGN_MODE_DIRECT_AUX", xr[xr.SIGN_MODE_LEGACY_AMINO_JSON = 127] = "SIGN_MODE_LEGACY_AMINO_JSON", xr[xr.SIGN_MODE_EIP_191 = 191] = "SIGN_MODE_EIP_191", xr[xr.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(b = n.SignMode || (n.SignMode = {}));
  function F(xr) {
    switch (xr) {
      case 0:
      case "SIGN_MODE_UNSPECIFIED":
        return b.SIGN_MODE_UNSPECIFIED;
      case 1:
      case "SIGN_MODE_DIRECT":
        return b.SIGN_MODE_DIRECT;
      case 2:
      case "SIGN_MODE_TEXTUAL":
        return b.SIGN_MODE_TEXTUAL;
      case 3:
      case "SIGN_MODE_DIRECT_AUX":
        return b.SIGN_MODE_DIRECT_AUX;
      case 127:
      case "SIGN_MODE_LEGACY_AMINO_JSON":
        return b.SIGN_MODE_LEGACY_AMINO_JSON;
      case 191:
      case "SIGN_MODE_EIP_191":
        return b.SIGN_MODE_EIP_191;
      case -1:
      case "UNRECOGNIZED":
      default:
        return b.UNRECOGNIZED;
    }
  }
  n.signModeFromJSON = F;
  function le(xr) {
    switch (xr) {
      case b.SIGN_MODE_UNSPECIFIED:
        return "SIGN_MODE_UNSPECIFIED";
      case b.SIGN_MODE_DIRECT:
        return "SIGN_MODE_DIRECT";
      case b.SIGN_MODE_TEXTUAL:
        return "SIGN_MODE_TEXTUAL";
      case b.SIGN_MODE_DIRECT_AUX:
        return "SIGN_MODE_DIRECT_AUX";
      case b.SIGN_MODE_LEGACY_AMINO_JSON:
        return "SIGN_MODE_LEGACY_AMINO_JSON";
      case b.SIGN_MODE_EIP_191:
        return "SIGN_MODE_EIP_191";
      default:
        return "UNKNOWN";
    }
  }
  n.signModeToJSON = le;
  function L() {
    return { signatures: [] };
  }
  n.SignatureDescriptors = {
    encode(xr, kr = p.default.Writer.create()) {
      for (const Ce of xr.signatures)
        n.SignatureDescriptor.encode(Ce, kr.uint32(10).fork()).ldelim();
      return kr;
    },
    decode(xr, kr) {
      const Ce = xr instanceof p.default.Reader ? xr : new p.default.Reader(xr);
      let tr = kr === void 0 ? Ce.len : Ce.pos + kr;
      const Fe = L();
      for (; Ce.pos < tr; ) {
        const Sr = Ce.uint32();
        switch (Sr >>> 3) {
          case 1:
            Fe.signatures.push(n.SignatureDescriptor.decode(Ce, Ce.uint32()));
            break;
          default:
            Ce.skipType(Sr & 7);
            break;
        }
      }
      return Fe;
    },
    fromJSON(xr) {
      return {
        signatures: Array.isArray(xr == null ? void 0 : xr.signatures) ? xr.signatures.map((kr) => n.SignatureDescriptor.fromJSON(kr)) : []
      };
    },
    toJSON(xr) {
      const kr = {};
      return xr.signatures ? kr.signatures = xr.signatures.map((Ce) => Ce ? n.SignatureDescriptor.toJSON(Ce) : void 0) : kr.signatures = [], kr;
    },
    fromPartial(xr) {
      var kr;
      const Ce = L();
      return Ce.signatures = ((kr = xr.signatures) === null || kr === void 0 ? void 0 : kr.map((tr) => n.SignatureDescriptor.fromPartial(tr))) || [], Ce;
    }
  };
  function pe() {
    return { publicKey: void 0, data: void 0, sequence: "0" };
  }
  n.SignatureDescriptor = {
    encode(xr, kr = p.default.Writer.create()) {
      return xr.publicKey !== void 0 && a.Any.encode(xr.publicKey, kr.uint32(10).fork()).ldelim(), xr.data !== void 0 && n.SignatureDescriptor_Data.encode(xr.data, kr.uint32(18).fork()).ldelim(), xr.sequence !== "0" && kr.uint32(24).uint64(xr.sequence), kr;
    },
    decode(xr, kr) {
      const Ce = xr instanceof p.default.Reader ? xr : new p.default.Reader(xr);
      let tr = kr === void 0 ? Ce.len : Ce.pos + kr;
      const Fe = pe();
      for (; Ce.pos < tr; ) {
        const Sr = Ce.uint32();
        switch (Sr >>> 3) {
          case 1:
            Fe.publicKey = a.Any.decode(Ce, Ce.uint32());
            break;
          case 2:
            Fe.data = n.SignatureDescriptor_Data.decode(Ce, Ce.uint32());
            break;
          case 3:
            Fe.sequence = lr(Ce.uint64());
            break;
          default:
            Ce.skipType(Sr & 7);
            break;
        }
      }
      return Fe;
    },
    fromJSON(xr) {
      return {
        publicKey: Ir(xr.publicKey) ? a.Any.fromJSON(xr.publicKey) : void 0,
        data: Ir(xr.data) ? n.SignatureDescriptor_Data.fromJSON(xr.data) : void 0,
        sequence: Ir(xr.sequence) ? String(xr.sequence) : "0"
      };
    },
    toJSON(xr) {
      const kr = {};
      return xr.publicKey !== void 0 && (kr.publicKey = xr.publicKey ? a.Any.toJSON(xr.publicKey) : void 0), xr.data !== void 0 && (kr.data = xr.data ? n.SignatureDescriptor_Data.toJSON(xr.data) : void 0), xr.sequence !== void 0 && (kr.sequence = xr.sequence), kr;
    },
    fromPartial(xr) {
      var kr;
      const Ce = pe();
      return Ce.publicKey = xr.publicKey !== void 0 && xr.publicKey !== null ? a.Any.fromPartial(xr.publicKey) : void 0, Ce.data = xr.data !== void 0 && xr.data !== null ? n.SignatureDescriptor_Data.fromPartial(xr.data) : void 0, Ce.sequence = (kr = xr.sequence) !== null && kr !== void 0 ? kr : "0", Ce;
    }
  };
  function $() {
    return { single: void 0, multi: void 0 };
  }
  n.SignatureDescriptor_Data = {
    encode(xr, kr = p.default.Writer.create()) {
      return xr.single !== void 0 && n.SignatureDescriptor_Data_Single.encode(xr.single, kr.uint32(10).fork()).ldelim(), xr.multi !== void 0 && n.SignatureDescriptor_Data_Multi.encode(xr.multi, kr.uint32(18).fork()).ldelim(), kr;
    },
    decode(xr, kr) {
      const Ce = xr instanceof p.default.Reader ? xr : new p.default.Reader(xr);
      let tr = kr === void 0 ? Ce.len : Ce.pos + kr;
      const Fe = $();
      for (; Ce.pos < tr; ) {
        const Sr = Ce.uint32();
        switch (Sr >>> 3) {
          case 1:
            Fe.single = n.SignatureDescriptor_Data_Single.decode(Ce, Ce.uint32());
            break;
          case 2:
            Fe.multi = n.SignatureDescriptor_Data_Multi.decode(Ce, Ce.uint32());
            break;
          default:
            Ce.skipType(Sr & 7);
            break;
        }
      }
      return Fe;
    },
    fromJSON(xr) {
      return {
        single: Ir(xr.single) ? n.SignatureDescriptor_Data_Single.fromJSON(xr.single) : void 0,
        multi: Ir(xr.multi) ? n.SignatureDescriptor_Data_Multi.fromJSON(xr.multi) : void 0
      };
    },
    toJSON(xr) {
      const kr = {};
      return xr.single !== void 0 && (kr.single = xr.single ? n.SignatureDescriptor_Data_Single.toJSON(xr.single) : void 0), xr.multi !== void 0 && (kr.multi = xr.multi ? n.SignatureDescriptor_Data_Multi.toJSON(xr.multi) : void 0), kr;
    },
    fromPartial(xr) {
      const kr = $();
      return kr.single = xr.single !== void 0 && xr.single !== null ? n.SignatureDescriptor_Data_Single.fromPartial(xr.single) : void 0, kr.multi = xr.multi !== void 0 && xr.multi !== null ? n.SignatureDescriptor_Data_Multi.fromPartial(xr.multi) : void 0, kr;
    }
  };
  function Ee() {
    return { mode: 0, signature: new Uint8Array() };
  }
  n.SignatureDescriptor_Data_Single = {
    encode(xr, kr = p.default.Writer.create()) {
      return xr.mode !== 0 && kr.uint32(8).int32(xr.mode), xr.signature.length !== 0 && kr.uint32(18).bytes(xr.signature), kr;
    },
    decode(xr, kr) {
      const Ce = xr instanceof p.default.Reader ? xr : new p.default.Reader(xr);
      let tr = kr === void 0 ? Ce.len : Ce.pos + kr;
      const Fe = Ee();
      for (; Ce.pos < tr; ) {
        const Sr = Ce.uint32();
        switch (Sr >>> 3) {
          case 1:
            Fe.mode = Ce.int32();
            break;
          case 2:
            Fe.signature = Ce.bytes();
            break;
          default:
            Ce.skipType(Sr & 7);
            break;
        }
      }
      return Fe;
    },
    fromJSON(xr) {
      return {
        mode: Ir(xr.mode) ? F(xr.mode) : 0,
        signature: Ir(xr.signature) ? nr(xr.signature) : new Uint8Array()
      };
    },
    toJSON(xr) {
      const kr = {};
      return xr.mode !== void 0 && (kr.mode = le(xr.mode)), xr.signature !== void 0 && (kr.signature = or(xr.signature !== void 0 ? xr.signature : new Uint8Array())), kr;
    },
    fromPartial(xr) {
      var kr, Ce;
      const tr = Ee();
      return tr.mode = (kr = xr.mode) !== null && kr !== void 0 ? kr : 0, tr.signature = (Ce = xr.signature) !== null && Ce !== void 0 ? Ce : new Uint8Array(), tr;
    }
  };
  function be() {
    return { bitarray: void 0, signatures: [] };
  }
  n.SignatureDescriptor_Data_Multi = {
    encode(xr, kr = p.default.Writer.create()) {
      xr.bitarray !== void 0 && A.CompactBitArray.encode(xr.bitarray, kr.uint32(10).fork()).ldelim();
      for (const Ce of xr.signatures)
        n.SignatureDescriptor_Data.encode(Ce, kr.uint32(18).fork()).ldelim();
      return kr;
    },
    decode(xr, kr) {
      const Ce = xr instanceof p.default.Reader ? xr : new p.default.Reader(xr);
      let tr = kr === void 0 ? Ce.len : Ce.pos + kr;
      const Fe = be();
      for (; Ce.pos < tr; ) {
        const Sr = Ce.uint32();
        switch (Sr >>> 3) {
          case 1:
            Fe.bitarray = A.CompactBitArray.decode(Ce, Ce.uint32());
            break;
          case 2:
            Fe.signatures.push(n.SignatureDescriptor_Data.decode(Ce, Ce.uint32()));
            break;
          default:
            Ce.skipType(Sr & 7);
            break;
        }
      }
      return Fe;
    },
    fromJSON(xr) {
      return {
        bitarray: Ir(xr.bitarray) ? A.CompactBitArray.fromJSON(xr.bitarray) : void 0,
        signatures: Array.isArray(xr == null ? void 0 : xr.signatures) ? xr.signatures.map((kr) => n.SignatureDescriptor_Data.fromJSON(kr)) : []
      };
    },
    toJSON(xr) {
      const kr = {};
      return xr.bitarray !== void 0 && (kr.bitarray = xr.bitarray ? A.CompactBitArray.toJSON(xr.bitarray) : void 0), xr.signatures ? kr.signatures = xr.signatures.map((Ce) => Ce ? n.SignatureDescriptor_Data.toJSON(Ce) : void 0) : kr.signatures = [], kr;
    },
    fromPartial(xr) {
      var kr;
      const Ce = be();
      return Ce.bitarray = xr.bitarray !== void 0 && xr.bitarray !== null ? A.CompactBitArray.fromPartial(xr.bitarray) : void 0, Ce.signatures = ((kr = xr.signatures) === null || kr === void 0 ? void 0 : kr.map((tr) => n.SignatureDescriptor_Data.fromPartial(tr))) || [], Ce;
    }
  };
  var He = (() => {
    if (typeof He < "u")
      return He;
    if (typeof self < "u")
      return self;
    if (typeof window < "u")
      return window;
    if (typeof commonjsGlobal < "u")
      return commonjsGlobal;
    throw "Unable to locate global object";
  })();
  const Pe = He.atob || ((xr) => He.Buffer.from(xr, "base64").toString("binary"));
  function nr(xr) {
    const kr = Pe(xr), Ce = new Uint8Array(kr.length);
    for (let tr = 0; tr < kr.length; ++tr)
      Ce[tr] = kr.charCodeAt(tr);
    return Ce;
  }
  const ir = He.btoa || ((xr) => He.Buffer.from(xr, "binary").toString("base64"));
  function or(xr) {
    const kr = [];
    for (const Ce of xr)
      kr.push(String.fromCharCode(Ce));
    return ir(kr.join(""));
  }
  function lr(xr) {
    return xr.toString();
  }
  p.default.util.Long !== u.default && (p.default.util.Long = u.default, p.default.configure());
  function Ir(xr) {
    return xr != null;
  }
})(signing);
var coin = {}, __importDefault$2 = commonjsGlobal && commonjsGlobal.__importDefault || function(n) {
  return n && n.__esModule ? n : { default: n };
};
Object.defineProperty(coin, "__esModule", { value: !0 });
coin.DecProto = coin.IntProto = coin.DecCoin = coin.Coin = coin.protobufPackage = void 0;
const long_1 = __importDefault$2(long), minimal_1 = __importDefault$2(minimal);
coin.protobufPackage = "cosmos.base.v1beta1";
function createBaseCoin() {
  return { denom: "", amount: "" };
}
coin.Coin = {
  encode(n, c = minimal_1.default.Writer.create()) {
    return n.denom !== "" && c.uint32(10).string(n.denom), n.amount !== "" && c.uint32(18).string(n.amount), c;
  },
  decode(n, c) {
    const u = n instanceof minimal_1.default.Reader ? n : new minimal_1.default.Reader(n);
    let p = c === void 0 ? u.len : u.pos + c;
    const a = createBaseCoin();
    for (; u.pos < p; ) {
      const A = u.uint32();
      switch (A >>> 3) {
        case 1:
          a.denom = u.string();
          break;
        case 2:
          a.amount = u.string();
          break;
        default:
          u.skipType(A & 7);
          break;
      }
    }
    return a;
  },
  fromJSON(n) {
    return {
      denom: isSet(n.denom) ? String(n.denom) : "",
      amount: isSet(n.amount) ? String(n.amount) : ""
    };
  },
  toJSON(n) {
    const c = {};
    return n.denom !== void 0 && (c.denom = n.denom), n.amount !== void 0 && (c.amount = n.amount), c;
  },
  fromPartial(n) {
    var c, u;
    const p = createBaseCoin();
    return p.denom = (c = n.denom) !== null && c !== void 0 ? c : "", p.amount = (u = n.amount) !== null && u !== void 0 ? u : "", p;
  }
};
function createBaseDecCoin() {
  return { denom: "", amount: "" };
}
coin.DecCoin = {
  encode(n, c = minimal_1.default.Writer.create()) {
    return n.denom !== "" && c.uint32(10).string(n.denom), n.amount !== "" && c.uint32(18).string(n.amount), c;
  },
  decode(n, c) {
    const u = n instanceof minimal_1.default.Reader ? n : new minimal_1.default.Reader(n);
    let p = c === void 0 ? u.len : u.pos + c;
    const a = createBaseDecCoin();
    for (; u.pos < p; ) {
      const A = u.uint32();
      switch (A >>> 3) {
        case 1:
          a.denom = u.string();
          break;
        case 2:
          a.amount = u.string();
          break;
        default:
          u.skipType(A & 7);
          break;
      }
    }
    return a;
  },
  fromJSON(n) {
    return {
      denom: isSet(n.denom) ? String(n.denom) : "",
      amount: isSet(n.amount) ? String(n.amount) : ""
    };
  },
  toJSON(n) {
    const c = {};
    return n.denom !== void 0 && (c.denom = n.denom), n.amount !== void 0 && (c.amount = n.amount), c;
  },
  fromPartial(n) {
    var c, u;
    const p = createBaseDecCoin();
    return p.denom = (c = n.denom) !== null && c !== void 0 ? c : "", p.amount = (u = n.amount) !== null && u !== void 0 ? u : "", p;
  }
};
function createBaseIntProto() {
  return { int: "" };
}
coin.IntProto = {
  encode(n, c = minimal_1.default.Writer.create()) {
    return n.int !== "" && c.uint32(10).string(n.int), c;
  },
  decode(n, c) {
    const u = n instanceof minimal_1.default.Reader ? n : new minimal_1.default.Reader(n);
    let p = c === void 0 ? u.len : u.pos + c;
    const a = createBaseIntProto();
    for (; u.pos < p; ) {
      const A = u.uint32();
      switch (A >>> 3) {
        case 1:
          a.int = u.string();
          break;
        default:
          u.skipType(A & 7);
          break;
      }
    }
    return a;
  },
  fromJSON(n) {
    return {
      int: isSet(n.int) ? String(n.int) : ""
    };
  },
  toJSON(n) {
    const c = {};
    return n.int !== void 0 && (c.int = n.int), c;
  },
  fromPartial(n) {
    var c;
    const u = createBaseIntProto();
    return u.int = (c = n.int) !== null && c !== void 0 ? c : "", u;
  }
};
function createBaseDecProto() {
  return { dec: "" };
}
coin.DecProto = {
  encode(n, c = minimal_1.default.Writer.create()) {
    return n.dec !== "" && c.uint32(10).string(n.dec), c;
  },
  decode(n, c) {
    const u = n instanceof minimal_1.default.Reader ? n : new minimal_1.default.Reader(n);
    let p = c === void 0 ? u.len : u.pos + c;
    const a = createBaseDecProto();
    for (; u.pos < p; ) {
      const A = u.uint32();
      switch (A >>> 3) {
        case 1:
          a.dec = u.string();
          break;
        default:
          u.skipType(A & 7);
          break;
      }
    }
    return a;
  },
  fromJSON(n) {
    return {
      dec: isSet(n.dec) ? String(n.dec) : ""
    };
  },
  toJSON(n) {
    const c = {};
    return n.dec !== void 0 && (c.dec = n.dec), c;
  },
  fromPartial(n) {
    var c;
    const u = createBaseDecProto();
    return u.dec = (c = n.dec) !== null && c !== void 0 ? c : "", u;
  }
};
minimal_1.default.util.Long !== long_1.default && (minimal_1.default.util.Long = long_1.default, minimal_1.default.configure());
function isSet(n) {
  return n != null;
}
(function(n) {
  var c = commonjsGlobal && commonjsGlobal.__importDefault || function(er) {
    return er && er.__esModule ? er : { default: er };
  };
  Object.defineProperty(n, "__esModule", { value: !0 }), n.AuxSignerData = n.Fee = n.ModeInfo_Multi = n.ModeInfo_Single = n.ModeInfo = n.SignerInfo = n.AuthInfo = n.TxBody = n.SignDocDirectAux = n.SignDoc = n.TxRaw = n.Tx = n.protobufPackage = void 0;
  const u = c(long), p = c(minimal), a = signing, A = any, b = multisig$1, F = coin;
  n.protobufPackage = "cosmos.tx.v1beta1";
  function le() {
    return { body: void 0, authInfo: void 0, signatures: [] };
  }
  n.Tx = {
    encode(er, Ie = p.default.Writer.create()) {
      er.body !== void 0 && n.TxBody.encode(er.body, Ie.uint32(10).fork()).ldelim(), er.authInfo !== void 0 && n.AuthInfo.encode(er.authInfo, Ie.uint32(18).fork()).ldelim();
      for (const xe of er.signatures)
        Ie.uint32(26).bytes(xe);
      return Ie;
    },
    decode(er, Ie) {
      const xe = er instanceof p.default.Reader ? er : new p.default.Reader(er);
      let rr = Ie === void 0 ? xe.len : xe.pos + Ie;
      const ar = le();
      for (; xe.pos < rr; ) {
        const yr = xe.uint32();
        switch (yr >>> 3) {
          case 1:
            ar.body = n.TxBody.decode(xe, xe.uint32());
            break;
          case 2:
            ar.authInfo = n.AuthInfo.decode(xe, xe.uint32());
            break;
          case 3:
            ar.signatures.push(xe.bytes());
            break;
          default:
            xe.skipType(yr & 7);
            break;
        }
      }
      return ar;
    },
    fromJSON(er) {
      return {
        body: Sr(er.body) ? n.TxBody.fromJSON(er.body) : void 0,
        authInfo: Sr(er.authInfo) ? n.AuthInfo.fromJSON(er.authInfo) : void 0,
        signatures: Array.isArray(er == null ? void 0 : er.signatures) ? er.signatures.map((Ie) => kr(Ie)) : []
      };
    },
    toJSON(er) {
      const Ie = {};
      return er.body !== void 0 && (Ie.body = er.body ? n.TxBody.toJSON(er.body) : void 0), er.authInfo !== void 0 && (Ie.authInfo = er.authInfo ? n.AuthInfo.toJSON(er.authInfo) : void 0), er.signatures ? Ie.signatures = er.signatures.map((xe) => tr(xe !== void 0 ? xe : new Uint8Array())) : Ie.signatures = [], Ie;
    },
    fromPartial(er) {
      var Ie;
      const xe = le();
      return xe.body = er.body !== void 0 && er.body !== null ? n.TxBody.fromPartial(er.body) : void 0, xe.authInfo = er.authInfo !== void 0 && er.authInfo !== null ? n.AuthInfo.fromPartial(er.authInfo) : void 0, xe.signatures = ((Ie = er.signatures) === null || Ie === void 0 ? void 0 : Ie.map((rr) => rr)) || [], xe;
    }
  };
  function L() {
    return {
      bodyBytes: new Uint8Array(),
      authInfoBytes: new Uint8Array(),
      signatures: []
    };
  }
  n.TxRaw = {
    encode(er, Ie = p.default.Writer.create()) {
      er.bodyBytes.length !== 0 && Ie.uint32(10).bytes(er.bodyBytes), er.authInfoBytes.length !== 0 && Ie.uint32(18).bytes(er.authInfoBytes);
      for (const xe of er.signatures)
        Ie.uint32(26).bytes(xe);
      return Ie;
    },
    decode(er, Ie) {
      const xe = er instanceof p.default.Reader ? er : new p.default.Reader(er);
      let rr = Ie === void 0 ? xe.len : xe.pos + Ie;
      const ar = L();
      for (; xe.pos < rr; ) {
        const yr = xe.uint32();
        switch (yr >>> 3) {
          case 1:
            ar.bodyBytes = xe.bytes();
            break;
          case 2:
            ar.authInfoBytes = xe.bytes();
            break;
          case 3:
            ar.signatures.push(xe.bytes());
            break;
          default:
            xe.skipType(yr & 7);
            break;
        }
      }
      return ar;
    },
    fromJSON(er) {
      return {
        bodyBytes: Sr(er.bodyBytes) ? kr(er.bodyBytes) : new Uint8Array(),
        authInfoBytes: Sr(er.authInfoBytes) ? kr(er.authInfoBytes) : new Uint8Array(),
        signatures: Array.isArray(er == null ? void 0 : er.signatures) ? er.signatures.map((Ie) => kr(Ie)) : []
      };
    },
    toJSON(er) {
      const Ie = {};
      return er.bodyBytes !== void 0 && (Ie.bodyBytes = tr(er.bodyBytes !== void 0 ? er.bodyBytes : new Uint8Array())), er.authInfoBytes !== void 0 && (Ie.authInfoBytes = tr(er.authInfoBytes !== void 0 ? er.authInfoBytes : new Uint8Array())), er.signatures ? Ie.signatures = er.signatures.map((xe) => tr(xe !== void 0 ? xe : new Uint8Array())) : Ie.signatures = [], Ie;
    },
    fromPartial(er) {
      var Ie, xe, rr;
      const ar = L();
      return ar.bodyBytes = (Ie = er.bodyBytes) !== null && Ie !== void 0 ? Ie : new Uint8Array(), ar.authInfoBytes = (xe = er.authInfoBytes) !== null && xe !== void 0 ? xe : new Uint8Array(), ar.signatures = ((rr = er.signatures) === null || rr === void 0 ? void 0 : rr.map((yr) => yr)) || [], ar;
    }
  };
  function pe() {
    return {
      bodyBytes: new Uint8Array(),
      authInfoBytes: new Uint8Array(),
      chainId: "",
      accountNumber: "0"
    };
  }
  n.SignDoc = {
    encode(er, Ie = p.default.Writer.create()) {
      return er.bodyBytes.length !== 0 && Ie.uint32(10).bytes(er.bodyBytes), er.authInfoBytes.length !== 0 && Ie.uint32(18).bytes(er.authInfoBytes), er.chainId !== "" && Ie.uint32(26).string(er.chainId), er.accountNumber !== "0" && Ie.uint32(32).uint64(er.accountNumber), Ie;
    },
    decode(er, Ie) {
      const xe = er instanceof p.default.Reader ? er : new p.default.Reader(er);
      let rr = Ie === void 0 ? xe.len : xe.pos + Ie;
      const ar = pe();
      for (; xe.pos < rr; ) {
        const yr = xe.uint32();
        switch (yr >>> 3) {
          case 1:
            ar.bodyBytes = xe.bytes();
            break;
          case 2:
            ar.authInfoBytes = xe.bytes();
            break;
          case 3:
            ar.chainId = xe.string();
            break;
          case 4:
            ar.accountNumber = Fe(xe.uint64());
            break;
          default:
            xe.skipType(yr & 7);
            break;
        }
      }
      return ar;
    },
    fromJSON(er) {
      return {
        bodyBytes: Sr(er.bodyBytes) ? kr(er.bodyBytes) : new Uint8Array(),
        authInfoBytes: Sr(er.authInfoBytes) ? kr(er.authInfoBytes) : new Uint8Array(),
        chainId: Sr(er.chainId) ? String(er.chainId) : "",
        accountNumber: Sr(er.accountNumber) ? String(er.accountNumber) : "0"
      };
    },
    toJSON(er) {
      const Ie = {};
      return er.bodyBytes !== void 0 && (Ie.bodyBytes = tr(er.bodyBytes !== void 0 ? er.bodyBytes : new Uint8Array())), er.authInfoBytes !== void 0 && (Ie.authInfoBytes = tr(er.authInfoBytes !== void 0 ? er.authInfoBytes : new Uint8Array())), er.chainId !== void 0 && (Ie.chainId = er.chainId), er.accountNumber !== void 0 && (Ie.accountNumber = er.accountNumber), Ie;
    },
    fromPartial(er) {
      var Ie, xe, rr, ar;
      const yr = pe();
      return yr.bodyBytes = (Ie = er.bodyBytes) !== null && Ie !== void 0 ? Ie : new Uint8Array(), yr.authInfoBytes = (xe = er.authInfoBytes) !== null && xe !== void 0 ? xe : new Uint8Array(), yr.chainId = (rr = er.chainId) !== null && rr !== void 0 ? rr : "", yr.accountNumber = (ar = er.accountNumber) !== null && ar !== void 0 ? ar : "0", yr;
    }
  };
  function $() {
    return {
      bodyBytes: new Uint8Array(),
      publicKey: void 0,
      chainId: "",
      accountNumber: "0",
      sequence: "0"
    };
  }
  n.SignDocDirectAux = {
    encode(er, Ie = p.default.Writer.create()) {
      return er.bodyBytes.length !== 0 && Ie.uint32(10).bytes(er.bodyBytes), er.publicKey !== void 0 && A.Any.encode(er.publicKey, Ie.uint32(18).fork()).ldelim(), er.chainId !== "" && Ie.uint32(26).string(er.chainId), er.accountNumber !== "0" && Ie.uint32(32).uint64(er.accountNumber), er.sequence !== "0" && Ie.uint32(40).uint64(er.sequence), Ie;
    },
    decode(er, Ie) {
      const xe = er instanceof p.default.Reader ? er : new p.default.Reader(er);
      let rr = Ie === void 0 ? xe.len : xe.pos + Ie;
      const ar = $();
      for (; xe.pos < rr; ) {
        const yr = xe.uint32();
        switch (yr >>> 3) {
          case 1:
            ar.bodyBytes = xe.bytes();
            break;
          case 2:
            ar.publicKey = A.Any.decode(xe, xe.uint32());
            break;
          case 3:
            ar.chainId = xe.string();
            break;
          case 4:
            ar.accountNumber = Fe(xe.uint64());
            break;
          case 5:
            ar.sequence = Fe(xe.uint64());
            break;
          default:
            xe.skipType(yr & 7);
            break;
        }
      }
      return ar;
    },
    fromJSON(er) {
      return {
        bodyBytes: Sr(er.bodyBytes) ? kr(er.bodyBytes) : new Uint8Array(),
        publicKey: Sr(er.publicKey) ? A.Any.fromJSON(er.publicKey) : void 0,
        chainId: Sr(er.chainId) ? String(er.chainId) : "",
        accountNumber: Sr(er.accountNumber) ? String(er.accountNumber) : "0",
        sequence: Sr(er.sequence) ? String(er.sequence) : "0"
      };
    },
    toJSON(er) {
      const Ie = {};
      return er.bodyBytes !== void 0 && (Ie.bodyBytes = tr(er.bodyBytes !== void 0 ? er.bodyBytes : new Uint8Array())), er.publicKey !== void 0 && (Ie.publicKey = er.publicKey ? A.Any.toJSON(er.publicKey) : void 0), er.chainId !== void 0 && (Ie.chainId = er.chainId), er.accountNumber !== void 0 && (Ie.accountNumber = er.accountNumber), er.sequence !== void 0 && (Ie.sequence = er.sequence), Ie;
    },
    fromPartial(er) {
      var Ie, xe, rr, ar;
      const yr = $();
      return yr.bodyBytes = (Ie = er.bodyBytes) !== null && Ie !== void 0 ? Ie : new Uint8Array(), yr.publicKey = er.publicKey !== void 0 && er.publicKey !== null ? A.Any.fromPartial(er.publicKey) : void 0, yr.chainId = (xe = er.chainId) !== null && xe !== void 0 ? xe : "", yr.accountNumber = (rr = er.accountNumber) !== null && rr !== void 0 ? rr : "0", yr.sequence = (ar = er.sequence) !== null && ar !== void 0 ? ar : "0", yr;
    }
  };
  function Ee() {
    return {
      messages: [],
      memo: "",
      timeoutHeight: "0",
      extensionOptions: [],
      nonCriticalExtensionOptions: []
    };
  }
  n.TxBody = {
    encode(er, Ie = p.default.Writer.create()) {
      for (const xe of er.messages)
        A.Any.encode(xe, Ie.uint32(10).fork()).ldelim();
      er.memo !== "" && Ie.uint32(18).string(er.memo), er.timeoutHeight !== "0" && Ie.uint32(24).uint64(er.timeoutHeight);
      for (const xe of er.extensionOptions)
        A.Any.encode(xe, Ie.uint32(8186).fork()).ldelim();
      for (const xe of er.nonCriticalExtensionOptions)
        A.Any.encode(xe, Ie.uint32(16378).fork()).ldelim();
      return Ie;
    },
    decode(er, Ie) {
      const xe = er instanceof p.default.Reader ? er : new p.default.Reader(er);
      let rr = Ie === void 0 ? xe.len : xe.pos + Ie;
      const ar = Ee();
      for (; xe.pos < rr; ) {
        const yr = xe.uint32();
        switch (yr >>> 3) {
          case 1:
            ar.messages.push(A.Any.decode(xe, xe.uint32()));
            break;
          case 2:
            ar.memo = xe.string();
            break;
          case 3:
            ar.timeoutHeight = Fe(xe.uint64());
            break;
          case 1023:
            ar.extensionOptions.push(A.Any.decode(xe, xe.uint32()));
            break;
          case 2047:
            ar.nonCriticalExtensionOptions.push(A.Any.decode(xe, xe.uint32()));
            break;
          default:
            xe.skipType(yr & 7);
            break;
        }
      }
      return ar;
    },
    fromJSON(er) {
      return {
        messages: Array.isArray(er == null ? void 0 : er.messages) ? er.messages.map((Ie) => A.Any.fromJSON(Ie)) : [],
        memo: Sr(er.memo) ? String(er.memo) : "",
        timeoutHeight: Sr(er.timeoutHeight) ? String(er.timeoutHeight) : "0",
        extensionOptions: Array.isArray(er == null ? void 0 : er.extensionOptions) ? er.extensionOptions.map((Ie) => A.Any.fromJSON(Ie)) : [],
        nonCriticalExtensionOptions: Array.isArray(er == null ? void 0 : er.nonCriticalExtensionOptions) ? er.nonCriticalExtensionOptions.map((Ie) => A.Any.fromJSON(Ie)) : []
      };
    },
    toJSON(er) {
      const Ie = {};
      return er.messages ? Ie.messages = er.messages.map((xe) => xe ? A.Any.toJSON(xe) : void 0) : Ie.messages = [], er.memo !== void 0 && (Ie.memo = er.memo), er.timeoutHeight !== void 0 && (Ie.timeoutHeight = er.timeoutHeight), er.extensionOptions ? Ie.extensionOptions = er.extensionOptions.map((xe) => xe ? A.Any.toJSON(xe) : void 0) : Ie.extensionOptions = [], er.nonCriticalExtensionOptions ? Ie.nonCriticalExtensionOptions = er.nonCriticalExtensionOptions.map((xe) => xe ? A.Any.toJSON(xe) : void 0) : Ie.nonCriticalExtensionOptions = [], Ie;
    },
    fromPartial(er) {
      var Ie, xe, rr, ar, yr;
      const _r = Ee();
      return _r.messages = ((Ie = er.messages) === null || Ie === void 0 ? void 0 : Ie.map((Or) => A.Any.fromPartial(Or))) || [], _r.memo = (xe = er.memo) !== null && xe !== void 0 ? xe : "", _r.timeoutHeight = (rr = er.timeoutHeight) !== null && rr !== void 0 ? rr : "0", _r.extensionOptions = ((ar = er.extensionOptions) === null || ar === void 0 ? void 0 : ar.map((Or) => A.Any.fromPartial(Or))) || [], _r.nonCriticalExtensionOptions = ((yr = er.nonCriticalExtensionOptions) === null || yr === void 0 ? void 0 : yr.map((Or) => A.Any.fromPartial(Or))) || [], _r;
    }
  };
  function be() {
    return { signerInfos: [], fee: void 0 };
  }
  n.AuthInfo = {
    encode(er, Ie = p.default.Writer.create()) {
      for (const xe of er.signerInfos)
        n.SignerInfo.encode(xe, Ie.uint32(10).fork()).ldelim();
      return er.fee !== void 0 && n.Fee.encode(er.fee, Ie.uint32(18).fork()).ldelim(), Ie;
    },
    decode(er, Ie) {
      const xe = er instanceof p.default.Reader ? er : new p.default.Reader(er);
      let rr = Ie === void 0 ? xe.len : xe.pos + Ie;
      const ar = be();
      for (; xe.pos < rr; ) {
        const yr = xe.uint32();
        switch (yr >>> 3) {
          case 1:
            ar.signerInfos.push(n.SignerInfo.decode(xe, xe.uint32()));
            break;
          case 2:
            ar.fee = n.Fee.decode(xe, xe.uint32());
            break;
          default:
            xe.skipType(yr & 7);
            break;
        }
      }
      return ar;
    },
    fromJSON(er) {
      return {
        signerInfos: Array.isArray(er == null ? void 0 : er.signerInfos) ? er.signerInfos.map((Ie) => n.SignerInfo.fromJSON(Ie)) : [],
        fee: Sr(er.fee) ? n.Fee.fromJSON(er.fee) : void 0
      };
    },
    toJSON(er) {
      const Ie = {};
      return er.signerInfos ? Ie.signerInfos = er.signerInfos.map((xe) => xe ? n.SignerInfo.toJSON(xe) : void 0) : Ie.signerInfos = [], er.fee !== void 0 && (Ie.fee = er.fee ? n.Fee.toJSON(er.fee) : void 0), Ie;
    },
    fromPartial(er) {
      var Ie;
      const xe = be();
      return xe.signerInfos = ((Ie = er.signerInfos) === null || Ie === void 0 ? void 0 : Ie.map((rr) => n.SignerInfo.fromPartial(rr))) || [], xe.fee = er.fee !== void 0 && er.fee !== null ? n.Fee.fromPartial(er.fee) : void 0, xe;
    }
  };
  function He() {
    return { publicKey: void 0, modeInfo: void 0, sequence: "0" };
  }
  n.SignerInfo = {
    encode(er, Ie = p.default.Writer.create()) {
      return er.publicKey !== void 0 && A.Any.encode(er.publicKey, Ie.uint32(10).fork()).ldelim(), er.modeInfo !== void 0 && n.ModeInfo.encode(er.modeInfo, Ie.uint32(18).fork()).ldelim(), er.sequence !== "0" && Ie.uint32(24).uint64(er.sequence), Ie;
    },
    decode(er, Ie) {
      const xe = er instanceof p.default.Reader ? er : new p.default.Reader(er);
      let rr = Ie === void 0 ? xe.len : xe.pos + Ie;
      const ar = He();
      for (; xe.pos < rr; ) {
        const yr = xe.uint32();
        switch (yr >>> 3) {
          case 1:
            ar.publicKey = A.Any.decode(xe, xe.uint32());
            break;
          case 2:
            ar.modeInfo = n.ModeInfo.decode(xe, xe.uint32());
            break;
          case 3:
            ar.sequence = Fe(xe.uint64());
            break;
          default:
            xe.skipType(yr & 7);
            break;
        }
      }
      return ar;
    },
    fromJSON(er) {
      return {
        publicKey: Sr(er.publicKey) ? A.Any.fromJSON(er.publicKey) : void 0,
        modeInfo: Sr(er.modeInfo) ? n.ModeInfo.fromJSON(er.modeInfo) : void 0,
        sequence: Sr(er.sequence) ? String(er.sequence) : "0"
      };
    },
    toJSON(er) {
      const Ie = {};
      return er.publicKey !== void 0 && (Ie.publicKey = er.publicKey ? A.Any.toJSON(er.publicKey) : void 0), er.modeInfo !== void 0 && (Ie.modeInfo = er.modeInfo ? n.ModeInfo.toJSON(er.modeInfo) : void 0), er.sequence !== void 0 && (Ie.sequence = er.sequence), Ie;
    },
    fromPartial(er) {
      var Ie;
      const xe = He();
      return xe.publicKey = er.publicKey !== void 0 && er.publicKey !== null ? A.Any.fromPartial(er.publicKey) : void 0, xe.modeInfo = er.modeInfo !== void 0 && er.modeInfo !== null ? n.ModeInfo.fromPartial(er.modeInfo) : void 0, xe.sequence = (Ie = er.sequence) !== null && Ie !== void 0 ? Ie : "0", xe;
    }
  };
  function Pe() {
    return { single: void 0, multi: void 0 };
  }
  n.ModeInfo = {
    encode(er, Ie = p.default.Writer.create()) {
      return er.single !== void 0 && n.ModeInfo_Single.encode(er.single, Ie.uint32(10).fork()).ldelim(), er.multi !== void 0 && n.ModeInfo_Multi.encode(er.multi, Ie.uint32(18).fork()).ldelim(), Ie;
    },
    decode(er, Ie) {
      const xe = er instanceof p.default.Reader ? er : new p.default.Reader(er);
      let rr = Ie === void 0 ? xe.len : xe.pos + Ie;
      const ar = Pe();
      for (; xe.pos < rr; ) {
        const yr = xe.uint32();
        switch (yr >>> 3) {
          case 1:
            ar.single = n.ModeInfo_Single.decode(xe, xe.uint32());
            break;
          case 2:
            ar.multi = n.ModeInfo_Multi.decode(xe, xe.uint32());
            break;
          default:
            xe.skipType(yr & 7);
            break;
        }
      }
      return ar;
    },
    fromJSON(er) {
      return {
        single: Sr(er.single) ? n.ModeInfo_Single.fromJSON(er.single) : void 0,
        multi: Sr(er.multi) ? n.ModeInfo_Multi.fromJSON(er.multi) : void 0
      };
    },
    toJSON(er) {
      const Ie = {};
      return er.single !== void 0 && (Ie.single = er.single ? n.ModeInfo_Single.toJSON(er.single) : void 0), er.multi !== void 0 && (Ie.multi = er.multi ? n.ModeInfo_Multi.toJSON(er.multi) : void 0), Ie;
    },
    fromPartial(er) {
      const Ie = Pe();
      return Ie.single = er.single !== void 0 && er.single !== null ? n.ModeInfo_Single.fromPartial(er.single) : void 0, Ie.multi = er.multi !== void 0 && er.multi !== null ? n.ModeInfo_Multi.fromPartial(er.multi) : void 0, Ie;
    }
  };
  function nr() {
    return { mode: 0 };
  }
  n.ModeInfo_Single = {
    encode(er, Ie = p.default.Writer.create()) {
      return er.mode !== 0 && Ie.uint32(8).int32(er.mode), Ie;
    },
    decode(er, Ie) {
      const xe = er instanceof p.default.Reader ? er : new p.default.Reader(er);
      let rr = Ie === void 0 ? xe.len : xe.pos + Ie;
      const ar = nr();
      for (; xe.pos < rr; ) {
        const yr = xe.uint32();
        switch (yr >>> 3) {
          case 1:
            ar.mode = xe.int32();
            break;
          default:
            xe.skipType(yr & 7);
            break;
        }
      }
      return ar;
    },
    fromJSON(er) {
      return {
        mode: Sr(er.mode) ? (0, a.signModeFromJSON)(er.mode) : 0
      };
    },
    toJSON(er) {
      const Ie = {};
      return er.mode !== void 0 && (Ie.mode = (0, a.signModeToJSON)(er.mode)), Ie;
    },
    fromPartial(er) {
      var Ie;
      const xe = nr();
      return xe.mode = (Ie = er.mode) !== null && Ie !== void 0 ? Ie : 0, xe;
    }
  };
  function ir() {
    return { bitarray: void 0, modeInfos: [] };
  }
  n.ModeInfo_Multi = {
    encode(er, Ie = p.default.Writer.create()) {
      er.bitarray !== void 0 && b.CompactBitArray.encode(er.bitarray, Ie.uint32(10).fork()).ldelim();
      for (const xe of er.modeInfos)
        n.ModeInfo.encode(xe, Ie.uint32(18).fork()).ldelim();
      return Ie;
    },
    decode(er, Ie) {
      const xe = er instanceof p.default.Reader ? er : new p.default.Reader(er);
      let rr = Ie === void 0 ? xe.len : xe.pos + Ie;
      const ar = ir();
      for (; xe.pos < rr; ) {
        const yr = xe.uint32();
        switch (yr >>> 3) {
          case 1:
            ar.bitarray = b.CompactBitArray.decode(xe, xe.uint32());
            break;
          case 2:
            ar.modeInfos.push(n.ModeInfo.decode(xe, xe.uint32()));
            break;
          default:
            xe.skipType(yr & 7);
            break;
        }
      }
      return ar;
    },
    fromJSON(er) {
      return {
        bitarray: Sr(er.bitarray) ? b.CompactBitArray.fromJSON(er.bitarray) : void 0,
        modeInfos: Array.isArray(er == null ? void 0 : er.modeInfos) ? er.modeInfos.map((Ie) => n.ModeInfo.fromJSON(Ie)) : []
      };
    },
    toJSON(er) {
      const Ie = {};
      return er.bitarray !== void 0 && (Ie.bitarray = er.bitarray ? b.CompactBitArray.toJSON(er.bitarray) : void 0), er.modeInfos ? Ie.modeInfos = er.modeInfos.map((xe) => xe ? n.ModeInfo.toJSON(xe) : void 0) : Ie.modeInfos = [], Ie;
    },
    fromPartial(er) {
      var Ie;
      const xe = ir();
      return xe.bitarray = er.bitarray !== void 0 && er.bitarray !== null ? b.CompactBitArray.fromPartial(er.bitarray) : void 0, xe.modeInfos = ((Ie = er.modeInfos) === null || Ie === void 0 ? void 0 : Ie.map((rr) => n.ModeInfo.fromPartial(rr))) || [], xe;
    }
  };
  function or() {
    return { amount: [], gasLimit: "0", payer: "", granter: "" };
  }
  n.Fee = {
    encode(er, Ie = p.default.Writer.create()) {
      for (const xe of er.amount)
        F.Coin.encode(xe, Ie.uint32(10).fork()).ldelim();
      return er.gasLimit !== "0" && Ie.uint32(16).uint64(er.gasLimit), er.payer !== "" && Ie.uint32(26).string(er.payer), er.granter !== "" && Ie.uint32(34).string(er.granter), Ie;
    },
    decode(er, Ie) {
      const xe = er instanceof p.default.Reader ? er : new p.default.Reader(er);
      let rr = Ie === void 0 ? xe.len : xe.pos + Ie;
      const ar = or();
      for (; xe.pos < rr; ) {
        const yr = xe.uint32();
        switch (yr >>> 3) {
          case 1:
            ar.amount.push(F.Coin.decode(xe, xe.uint32()));
            break;
          case 2:
            ar.gasLimit = Fe(xe.uint64());
            break;
          case 3:
            ar.payer = xe.string();
            break;
          case 4:
            ar.granter = xe.string();
            break;
          default:
            xe.skipType(yr & 7);
            break;
        }
      }
      return ar;
    },
    fromJSON(er) {
      return {
        amount: Array.isArray(er == null ? void 0 : er.amount) ? er.amount.map((Ie) => F.Coin.fromJSON(Ie)) : [],
        gasLimit: Sr(er.gasLimit) ? String(er.gasLimit) : "0",
        payer: Sr(er.payer) ? String(er.payer) : "",
        granter: Sr(er.granter) ? String(er.granter) : ""
      };
    },
    toJSON(er) {
      const Ie = {};
      return er.amount ? Ie.amount = er.amount.map((xe) => xe ? F.Coin.toJSON(xe) : void 0) : Ie.amount = [], er.gasLimit !== void 0 && (Ie.gasLimit = er.gasLimit), er.payer !== void 0 && (Ie.payer = er.payer), er.granter !== void 0 && (Ie.granter = er.granter), Ie;
    },
    fromPartial(er) {
      var Ie, xe, rr, ar;
      const yr = or();
      return yr.amount = ((Ie = er.amount) === null || Ie === void 0 ? void 0 : Ie.map((_r) => F.Coin.fromPartial(_r))) || [], yr.gasLimit = (xe = er.gasLimit) !== null && xe !== void 0 ? xe : "0", yr.payer = (rr = er.payer) !== null && rr !== void 0 ? rr : "", yr.granter = (ar = er.granter) !== null && ar !== void 0 ? ar : "", yr;
    }
  };
  function lr() {
    return { address: "", signDoc: void 0, mode: 0, sig: new Uint8Array() };
  }
  n.AuxSignerData = {
    encode(er, Ie = p.default.Writer.create()) {
      return er.address !== "" && Ie.uint32(10).string(er.address), er.signDoc !== void 0 && n.SignDocDirectAux.encode(er.signDoc, Ie.uint32(18).fork()).ldelim(), er.mode !== 0 && Ie.uint32(24).int32(er.mode), er.sig.length !== 0 && Ie.uint32(34).bytes(er.sig), Ie;
    },
    decode(er, Ie) {
      const xe = er instanceof p.default.Reader ? er : new p.default.Reader(er);
      let rr = Ie === void 0 ? xe.len : xe.pos + Ie;
      const ar = lr();
      for (; xe.pos < rr; ) {
        const yr = xe.uint32();
        switch (yr >>> 3) {
          case 1:
            ar.address = xe.string();
            break;
          case 2:
            ar.signDoc = n.SignDocDirectAux.decode(xe, xe.uint32());
            break;
          case 3:
            ar.mode = xe.int32();
            break;
          case 4:
            ar.sig = xe.bytes();
            break;
          default:
            xe.skipType(yr & 7);
            break;
        }
      }
      return ar;
    },
    fromJSON(er) {
      return {
        address: Sr(er.address) ? String(er.address) : "",
        signDoc: Sr(er.signDoc) ? n.SignDocDirectAux.fromJSON(er.signDoc) : void 0,
        mode: Sr(er.mode) ? (0, a.signModeFromJSON)(er.mode) : 0,
        sig: Sr(er.sig) ? kr(er.sig) : new Uint8Array()
      };
    },
    toJSON(er) {
      const Ie = {};
      return er.address !== void 0 && (Ie.address = er.address), er.signDoc !== void 0 && (Ie.signDoc = er.signDoc ? n.SignDocDirectAux.toJSON(er.signDoc) : void 0), er.mode !== void 0 && (Ie.mode = (0, a.signModeToJSON)(er.mode)), er.sig !== void 0 && (Ie.sig = tr(er.sig !== void 0 ? er.sig : new Uint8Array())), Ie;
    },
    fromPartial(er) {
      var Ie, xe, rr;
      const ar = lr();
      return ar.address = (Ie = er.address) !== null && Ie !== void 0 ? Ie : "", ar.signDoc = er.signDoc !== void 0 && er.signDoc !== null ? n.SignDocDirectAux.fromPartial(er.signDoc) : void 0, ar.mode = (xe = er.mode) !== null && xe !== void 0 ? xe : 0, ar.sig = (rr = er.sig) !== null && rr !== void 0 ? rr : new Uint8Array(), ar;
    }
  };
  var Ir = (() => {
    if (typeof Ir < "u")
      return Ir;
    if (typeof self < "u")
      return self;
    if (typeof window < "u")
      return window;
    if (typeof commonjsGlobal < "u")
      return commonjsGlobal;
    throw "Unable to locate global object";
  })();
  const xr = Ir.atob || ((er) => Ir.Buffer.from(er, "base64").toString("binary"));
  function kr(er) {
    const Ie = xr(er), xe = new Uint8Array(Ie.length);
    for (let rr = 0; rr < Ie.length; ++rr)
      xe[rr] = Ie.charCodeAt(rr);
    return xe;
  }
  const Ce = Ir.btoa || ((er) => Ir.Buffer.from(er, "binary").toString("base64"));
  function tr(er) {
    const Ie = [];
    for (const xe of er)
      Ie.push(String.fromCharCode(xe));
    return Ce(Ie.join(""));
  }
  function Fe(er) {
    return er.toString();
  }
  p.default.util.Long !== u.default && (p.default.util.Long = u.default, p.default.configure());
  function Sr(er) {
    return er != null;
  }
})(tx);
var wasm$1 = null;
try {
  wasm$1 = new WebAssembly.Instance(
    new WebAssembly.Module(
      new Uint8Array([
        // \0asm
        0,
        97,
        115,
        109,
        // version 1
        1,
        0,
        0,
        0,
        // section "type"
        1,
        13,
        2,
        // 0, () => i32
        96,
        0,
        1,
        127,
        // 1, (i32, i32, i32, i32) => i32
        96,
        4,
        127,
        127,
        127,
        127,
        1,
        127,
        // section "function"
        3,
        7,
        6,
        // 0, type 0
        0,
        // 1, type 1
        1,
        // 2, type 1
        1,
        // 3, type 1
        1,
        // 4, type 1
        1,
        // 5, type 1
        1,
        // section "global"
        6,
        6,
        1,
        // 0, "high", mutable i32
        127,
        1,
        65,
        0,
        11,
        // section "export"
        7,
        50,
        6,
        // 0, "mul"
        3,
        109,
        117,
        108,
        0,
        1,
        // 1, "div_s"
        5,
        100,
        105,
        118,
        95,
        115,
        0,
        2,
        // 2, "div_u"
        5,
        100,
        105,
        118,
        95,
        117,
        0,
        3,
        // 3, "rem_s"
        5,
        114,
        101,
        109,
        95,
        115,
        0,
        4,
        // 4, "rem_u"
        5,
        114,
        101,
        109,
        95,
        117,
        0,
        5,
        // 5, "get_high"
        8,
        103,
        101,
        116,
        95,
        104,
        105,
        103,
        104,
        0,
        0,
        // section "code"
        10,
        191,
        1,
        6,
        // 0, "get_high"
        4,
        0,
        35,
        0,
        11,
        // 1, "mul"
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        126,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        // 2, "div_s"
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        127,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        // 3, "div_u"
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        128,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        // 4, "rem_s"
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        129,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        // 5, "rem_u"
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        130,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11
      ])
    ),
    {}
  ).exports;
} catch {
}
function Long(n, c, u) {
  this.low = n | 0, this.high = c | 0, this.unsigned = !!u;
}
Long.prototype.__isLong__;
Object.defineProperty(Long.prototype, "__isLong__", { value: !0 });
function isLong(n) {
  return (n && n.__isLong__) === !0;
}
function ctz32(n) {
  var c = Math.clz32(n & -n);
  return n ? 31 - c : c;
}
Long.isLong = isLong;
var INT_CACHE = {}, UINT_CACHE = {};
function fromInt(n, c) {
  var u, p, a;
  return c ? (n >>>= 0, (a = 0 <= n && n < 256) && (p = UINT_CACHE[n], p) ? p : (u = fromBits(n, 0, !0), a && (UINT_CACHE[n] = u), u)) : (n |= 0, (a = -128 <= n && n < 128) && (p = INT_CACHE[n], p) ? p : (u = fromBits(n, n < 0 ? -1 : 0, !1), a && (INT_CACHE[n] = u), u));
}
Long.fromInt = fromInt;
function fromNumber(n, c) {
  if (isNaN(n)) return c ? UZERO : ZERO;
  if (c) {
    if (n < 0) return UZERO;
    if (n >= TWO_PWR_64_DBL) return MAX_UNSIGNED_VALUE;
  } else {
    if (n <= -TWO_PWR_63_DBL) return MIN_VALUE;
    if (n + 1 >= TWO_PWR_63_DBL) return MAX_VALUE;
  }
  return n < 0 ? fromNumber(-n, c).neg() : fromBits(
    n % TWO_PWR_32_DBL | 0,
    n / TWO_PWR_32_DBL | 0,
    c
  );
}
Long.fromNumber = fromNumber;
function fromBits(n, c, u) {
  return new Long(n, c, u);
}
Long.fromBits = fromBits;
var pow_dbl = Math.pow;
function fromString(n, c, u) {
  if (n.length === 0) throw Error("empty string");
  if (typeof c == "number" ? (u = c, c = !1) : c = !!c, n === "NaN" || n === "Infinity" || n === "+Infinity" || n === "-Infinity")
    return c ? UZERO : ZERO;
  if (u = u || 10, u < 2 || 36 < u) throw RangeError("radix");
  var p;
  if ((p = n.indexOf("-")) > 0) throw Error("interior hyphen");
  if (p === 0)
    return fromString(n.substring(1), c, u).neg();
  for (var a = fromNumber(pow_dbl(u, 8)), A = ZERO, b = 0; b < n.length; b += 8) {
    var F = Math.min(8, n.length - b), le = parseInt(n.substring(b, b + F), u);
    if (F < 8) {
      var L = fromNumber(pow_dbl(u, F));
      A = A.mul(L).add(fromNumber(le));
    } else
      A = A.mul(a), A = A.add(fromNumber(le));
  }
  return A.unsigned = c, A;
}
Long.fromString = fromString;
function fromValue(n, c) {
  return typeof n == "number" ? fromNumber(n, c) : typeof n == "string" ? fromString(n, c) : fromBits(
    n.low,
    n.high,
    typeof c == "boolean" ? c : n.unsigned
  );
}
Long.fromValue = fromValue;
var TWO_PWR_16_DBL = 65536, TWO_PWR_24_DBL = 1 << 24, TWO_PWR_32_DBL = TWO_PWR_16_DBL * TWO_PWR_16_DBL, TWO_PWR_64_DBL = TWO_PWR_32_DBL * TWO_PWR_32_DBL, TWO_PWR_63_DBL = TWO_PWR_64_DBL / 2, TWO_PWR_24 = fromInt(TWO_PWR_24_DBL), ZERO = fromInt(0);
Long.ZERO = ZERO;
var UZERO = fromInt(0, !0);
Long.UZERO = UZERO;
var ONE = fromInt(1);
Long.ONE = ONE;
var UONE = fromInt(1, !0);
Long.UONE = UONE;
var NEG_ONE = fromInt(-1);
Long.NEG_ONE = NEG_ONE;
var MAX_VALUE = fromBits(-1, 2147483647, !1);
Long.MAX_VALUE = MAX_VALUE;
var MAX_UNSIGNED_VALUE = fromBits(-1, -1, !0);
Long.MAX_UNSIGNED_VALUE = MAX_UNSIGNED_VALUE;
var MIN_VALUE = fromBits(0, -2147483648, !1);
Long.MIN_VALUE = MIN_VALUE;
var LongPrototype = Long.prototype;
LongPrototype.toInt = function n() {
  return this.unsigned ? this.low >>> 0 : this.low;
};
LongPrototype.toNumber = function n() {
  return this.unsigned ? (this.high >>> 0) * TWO_PWR_32_DBL + (this.low >>> 0) : this.high * TWO_PWR_32_DBL + (this.low >>> 0);
};
LongPrototype.toString = function n(c) {
  if (c = c || 10, c < 2 || 36 < c) throw RangeError("radix");
  if (this.isZero()) return "0";
  if (this.isNegative())
    if (this.eq(MIN_VALUE)) {
      var u = fromNumber(c), p = this.div(u), a = p.mul(u).sub(this);
      return p.toString(c) + a.toInt().toString(c);
    } else return "-" + this.neg().toString(c);
  for (var A = fromNumber(pow_dbl(c, 6), this.unsigned), b = this, F = ""; ; ) {
    var le = b.div(A), L = b.sub(le.mul(A)).toInt() >>> 0, pe = L.toString(c);
    if (b = le, b.isZero()) return pe + F;
    for (; pe.length < 6; ) pe = "0" + pe;
    F = "" + pe + F;
  }
};
LongPrototype.getHighBits = function n() {
  return this.high;
};
LongPrototype.getHighBitsUnsigned = function n() {
  return this.high >>> 0;
};
LongPrototype.getLowBits = function n() {
  return this.low;
};
LongPrototype.getLowBitsUnsigned = function n() {
  return this.low >>> 0;
};
LongPrototype.getNumBitsAbs = function n() {
  if (this.isNegative())
    return this.eq(MIN_VALUE) ? 64 : this.neg().getNumBitsAbs();
  for (var c = this.high != 0 ? this.high : this.low, u = 31; u > 0 && !(c & 1 << u); u--) ;
  return this.high != 0 ? u + 33 : u + 1;
};
LongPrototype.isSafeInteger = function n() {
  var c = this.high >> 21;
  return c ? this.unsigned ? !1 : c === -1 && !(this.low === 0 && this.high === -2097152) : !0;
};
LongPrototype.isZero = function n() {
  return this.high === 0 && this.low === 0;
};
LongPrototype.eqz = LongPrototype.isZero;
LongPrototype.isNegative = function n() {
  return !this.unsigned && this.high < 0;
};
LongPrototype.isPositive = function n() {
  return this.unsigned || this.high >= 0;
};
LongPrototype.isOdd = function n() {
  return (this.low & 1) === 1;
};
LongPrototype.isEven = function n() {
  return (this.low & 1) === 0;
};
LongPrototype.equals = function n(c) {
  return isLong(c) || (c = fromValue(c)), this.unsigned !== c.unsigned && this.high >>> 31 === 1 && c.high >>> 31 === 1 ? !1 : this.high === c.high && this.low === c.low;
};
LongPrototype.eq = LongPrototype.equals;
LongPrototype.notEquals = function n(c) {
  return !this.eq(
    /* validates */
    c
  );
};
LongPrototype.neq = LongPrototype.notEquals;
LongPrototype.ne = LongPrototype.notEquals;
LongPrototype.lessThan = function n(c) {
  return this.comp(
    /* validates */
    c
  ) < 0;
};
LongPrototype.lt = LongPrototype.lessThan;
LongPrototype.lessThanOrEqual = function n(c) {
  return this.comp(
    /* validates */
    c
  ) <= 0;
};
LongPrototype.lte = LongPrototype.lessThanOrEqual;
LongPrototype.le = LongPrototype.lessThanOrEqual;
LongPrototype.greaterThan = function n(c) {
  return this.comp(
    /* validates */
    c
  ) > 0;
};
LongPrototype.gt = LongPrototype.greaterThan;
LongPrototype.greaterThanOrEqual = function n(c) {
  return this.comp(
    /* validates */
    c
  ) >= 0;
};
LongPrototype.gte = LongPrototype.greaterThanOrEqual;
LongPrototype.ge = LongPrototype.greaterThanOrEqual;
LongPrototype.compare = function n(c) {
  if (isLong(c) || (c = fromValue(c)), this.eq(c)) return 0;
  var u = this.isNegative(), p = c.isNegative();
  return u && !p ? -1 : !u && p ? 1 : this.unsigned ? c.high >>> 0 > this.high >>> 0 || c.high === this.high && c.low >>> 0 > this.low >>> 0 ? -1 : 1 : this.sub(c).isNegative() ? -1 : 1;
};
LongPrototype.comp = LongPrototype.compare;
LongPrototype.negate = function n() {
  return !this.unsigned && this.eq(MIN_VALUE) ? MIN_VALUE : this.not().add(ONE);
};
LongPrototype.neg = LongPrototype.negate;
LongPrototype.add = function n(c) {
  isLong(c) || (c = fromValue(c));
  var u = this.high >>> 16, p = this.high & 65535, a = this.low >>> 16, A = this.low & 65535, b = c.high >>> 16, F = c.high & 65535, le = c.low >>> 16, L = c.low & 65535, pe = 0, $ = 0, Ee = 0, be = 0;
  return be += A + L, Ee += be >>> 16, be &= 65535, Ee += a + le, $ += Ee >>> 16, Ee &= 65535, $ += p + F, pe += $ >>> 16, $ &= 65535, pe += u + b, pe &= 65535, fromBits(Ee << 16 | be, pe << 16 | $, this.unsigned);
};
LongPrototype.subtract = function n(c) {
  return isLong(c) || (c = fromValue(c)), this.add(c.neg());
};
LongPrototype.sub = LongPrototype.subtract;
LongPrototype.multiply = function n(c) {
  if (this.isZero()) return this;
  if (isLong(c) || (c = fromValue(c)), wasm$1) {
    var u = wasm$1.mul(this.low, this.high, c.low, c.high);
    return fromBits(u, wasm$1.get_high(), this.unsigned);
  }
  if (c.isZero()) return this.unsigned ? UZERO : ZERO;
  if (this.eq(MIN_VALUE)) return c.isOdd() ? MIN_VALUE : ZERO;
  if (c.eq(MIN_VALUE)) return this.isOdd() ? MIN_VALUE : ZERO;
  if (this.isNegative())
    return c.isNegative() ? this.neg().mul(c.neg()) : this.neg().mul(c).neg();
  if (c.isNegative()) return this.mul(c.neg()).neg();
  if (this.lt(TWO_PWR_24) && c.lt(TWO_PWR_24))
    return fromNumber(this.toNumber() * c.toNumber(), this.unsigned);
  var p = this.high >>> 16, a = this.high & 65535, A = this.low >>> 16, b = this.low & 65535, F = c.high >>> 16, le = c.high & 65535, L = c.low >>> 16, pe = c.low & 65535, $ = 0, Ee = 0, be = 0, He = 0;
  return He += b * pe, be += He >>> 16, He &= 65535, be += A * pe, Ee += be >>> 16, be &= 65535, be += b * L, Ee += be >>> 16, be &= 65535, Ee += a * pe, $ += Ee >>> 16, Ee &= 65535, Ee += A * L, $ += Ee >>> 16, Ee &= 65535, Ee += b * le, $ += Ee >>> 16, Ee &= 65535, $ += p * pe + a * L + A * le + b * F, $ &= 65535, fromBits(be << 16 | He, $ << 16 | Ee, this.unsigned);
};
LongPrototype.mul = LongPrototype.multiply;
LongPrototype.divide = function n(c) {
  if (isLong(c) || (c = fromValue(c)), c.isZero()) throw Error("division by zero");
  if (wasm$1) {
    if (!this.unsigned && this.high === -2147483648 && c.low === -1 && c.high === -1)
      return this;
    var u = (this.unsigned ? wasm$1.div_u : wasm$1.div_s)(
      this.low,
      this.high,
      c.low,
      c.high
    );
    return fromBits(u, wasm$1.get_high(), this.unsigned);
  }
  if (this.isZero()) return this.unsigned ? UZERO : ZERO;
  var p, a, A;
  if (this.unsigned) {
    if (c.unsigned || (c = c.toUnsigned()), c.gt(this)) return UZERO;
    if (c.gt(this.shru(1)))
      return UONE;
    A = UZERO;
  } else {
    if (this.eq(MIN_VALUE)) {
      if (c.eq(ONE) || c.eq(NEG_ONE))
        return MIN_VALUE;
      if (c.eq(MIN_VALUE)) return ONE;
      var b = this.shr(1);
      return p = b.div(c).shl(1), p.eq(ZERO) ? c.isNegative() ? ONE : NEG_ONE : (a = this.sub(c.mul(p)), A = p.add(a.div(c)), A);
    } else if (c.eq(MIN_VALUE)) return this.unsigned ? UZERO : ZERO;
    if (this.isNegative())
      return c.isNegative() ? this.neg().div(c.neg()) : this.neg().div(c).neg();
    if (c.isNegative()) return this.div(c.neg()).neg();
    A = ZERO;
  }
  for (a = this; a.gte(c); ) {
    p = Math.max(1, Math.floor(a.toNumber() / c.toNumber()));
    for (var F = Math.ceil(Math.log(p) / Math.LN2), le = F <= 48 ? 1 : pow_dbl(2, F - 48), L = fromNumber(p), pe = L.mul(c); pe.isNegative() || pe.gt(a); )
      p -= le, L = fromNumber(p, this.unsigned), pe = L.mul(c);
    L.isZero() && (L = ONE), A = A.add(L), a = a.sub(pe);
  }
  return A;
};
LongPrototype.div = LongPrototype.divide;
LongPrototype.modulo = function n(c) {
  if (isLong(c) || (c = fromValue(c)), wasm$1) {
    var u = (this.unsigned ? wasm$1.rem_u : wasm$1.rem_s)(
      this.low,
      this.high,
      c.low,
      c.high
    );
    return fromBits(u, wasm$1.get_high(), this.unsigned);
  }
  return this.sub(this.div(c).mul(c));
};
LongPrototype.mod = LongPrototype.modulo;
LongPrototype.rem = LongPrototype.modulo;
LongPrototype.not = function n() {
  return fromBits(~this.low, ~this.high, this.unsigned);
};
LongPrototype.countLeadingZeros = function n() {
  return this.high ? Math.clz32(this.high) : Math.clz32(this.low) + 32;
};
LongPrototype.clz = LongPrototype.countLeadingZeros;
LongPrototype.countTrailingZeros = function n() {
  return this.low ? ctz32(this.low) : ctz32(this.high) + 32;
};
LongPrototype.ctz = LongPrototype.countTrailingZeros;
LongPrototype.and = function n(c) {
  return isLong(c) || (c = fromValue(c)), fromBits(this.low & c.low, this.high & c.high, this.unsigned);
};
LongPrototype.or = function n(c) {
  return isLong(c) || (c = fromValue(c)), fromBits(this.low | c.low, this.high | c.high, this.unsigned);
};
LongPrototype.xor = function n(c) {
  return isLong(c) || (c = fromValue(c)), fromBits(this.low ^ c.low, this.high ^ c.high, this.unsigned);
};
LongPrototype.shiftLeft = function n(c) {
  return isLong(c) && (c = c.toInt()), (c &= 63) === 0 ? this : c < 32 ? fromBits(
    this.low << c,
    this.high << c | this.low >>> 32 - c,
    this.unsigned
  ) : fromBits(0, this.low << c - 32, this.unsigned);
};
LongPrototype.shl = LongPrototype.shiftLeft;
LongPrototype.shiftRight = function n(c) {
  return isLong(c) && (c = c.toInt()), (c &= 63) === 0 ? this : c < 32 ? fromBits(
    this.low >>> c | this.high << 32 - c,
    this.high >> c,
    this.unsigned
  ) : fromBits(
    this.high >> c - 32,
    this.high >= 0 ? 0 : -1,
    this.unsigned
  );
};
LongPrototype.shr = LongPrototype.shiftRight;
LongPrototype.shiftRightUnsigned = function n(c) {
  return isLong(c) && (c = c.toInt()), (c &= 63) === 0 ? this : c < 32 ? fromBits(
    this.low >>> c | this.high << 32 - c,
    this.high >>> c,
    this.unsigned
  ) : c === 32 ? fromBits(this.high, 0, this.unsigned) : fromBits(this.high >>> c - 32, 0, this.unsigned);
};
LongPrototype.shru = LongPrototype.shiftRightUnsigned;
LongPrototype.shr_u = LongPrototype.shiftRightUnsigned;
LongPrototype.rotateLeft = function n(c) {
  var u;
  return isLong(c) && (c = c.toInt()), (c &= 63) === 0 ? this : c === 32 ? fromBits(this.high, this.low, this.unsigned) : c < 32 ? (u = 32 - c, fromBits(
    this.low << c | this.high >>> u,
    this.high << c | this.low >>> u,
    this.unsigned
  )) : (c -= 32, u = 32 - c, fromBits(
    this.high << c | this.low >>> u,
    this.low << c | this.high >>> u,
    this.unsigned
  ));
};
LongPrototype.rotl = LongPrototype.rotateLeft;
LongPrototype.rotateRight = function n(c) {
  var u;
  return isLong(c) && (c = c.toInt()), (c &= 63) === 0 ? this : c === 32 ? fromBits(this.high, this.low, this.unsigned) : c < 32 ? (u = 32 - c, fromBits(
    this.high << u | this.low >>> c,
    this.low << u | this.high >>> c,
    this.unsigned
  )) : (c -= 32, u = 32 - c, fromBits(
    this.low << u | this.high >>> c,
    this.high << u | this.low >>> c,
    this.unsigned
  ));
};
LongPrototype.rotr = LongPrototype.rotateRight;
LongPrototype.toSigned = function n() {
  return this.unsigned ? fromBits(this.low, this.high, !1) : this;
};
LongPrototype.toUnsigned = function n() {
  return this.unsigned ? this : fromBits(this.low, this.high, !0);
};
LongPrototype.toBytes = function n(c) {
  return c ? this.toBytesLE() : this.toBytesBE();
};
LongPrototype.toBytesLE = function n() {
  var c = this.high, u = this.low;
  return [
    u & 255,
    u >>> 8 & 255,
    u >>> 16 & 255,
    u >>> 24,
    c & 255,
    c >>> 8 & 255,
    c >>> 16 & 255,
    c >>> 24
  ];
};
LongPrototype.toBytesBE = function n() {
  var c = this.high, u = this.low;
  return [
    c >>> 24,
    c >>> 16 & 255,
    c >>> 8 & 255,
    c & 255,
    u >>> 24,
    u >>> 16 & 255,
    u >>> 8 & 255,
    u & 255
  ];
};
Long.fromBytes = function n(c, u, p) {
  return p ? Long.fromBytesLE(c, u) : Long.fromBytesBE(c, u);
};
Long.fromBytesLE = function n(c, u) {
  return new Long(
    c[0] | c[1] << 8 | c[2] << 16 | c[3] << 24,
    c[4] | c[5] << 8 | c[6] << 16 | c[7] << 24,
    u
  );
};
Long.fromBytesBE = function n(c, u) {
  return new Long(
    c[4] << 24 | c[5] << 16 | c[6] << 8 | c[7],
    c[0] << 24 | c[1] << 16 | c[2] << 8 | c[3],
    u
  );
};
typeof BigInt == "function" && (Long.fromBigInt = function(c, u) {
  var p = Number(BigInt.asIntN(32, c)), a = Number(BigInt.asIntN(32, c >> BigInt(32)));
  return fromBits(p, a, u);
}, Long.fromValue = function(c, u) {
  return typeof c == "bigint" ? fromBigInt(c, u) : fromValue(c, u);
}, LongPrototype.toBigInt = function() {
  var c = BigInt(this.low >>> 0), u = BigInt(this.unsigned ? this.high >>> 0 : this.high);
  return u << BigInt(32) | c;
});
var classnames = { exports: {} };
(function(n) {
  (function() {
    var c = {}.hasOwnProperty;
    function u() {
      for (var A = "", b = 0; b < arguments.length; b++) {
        var F = arguments[b];
        F && (A = a(A, p(F)));
      }
      return A;
    }
    function p(A) {
      if (typeof A == "string" || typeof A == "number")
        return A;
      if (typeof A != "object")
        return "";
      if (Array.isArray(A))
        return u.apply(null, A);
      if (A.toString !== Object.prototype.toString && !A.toString.toString().includes("[native code]"))
        return A.toString();
      var b = "";
      for (var F in A)
        c.call(A, F) && A[F] && (b = a(b, F));
      return b;
    }
    function a(A, b) {
      return b ? A ? A + " " + b : A + b : A;
    }
    n.exports ? (u.default = u, n.exports = u) : window.classNames = u;
  })();
})(classnames);
var classnamesExports = classnames.exports;
const cA = /* @__PURE__ */ getDefaultExportFromCjs(classnamesExports);
var ue = Object.defineProperty, fe$1 = (n, c, u) => c in n ? ue(n, c, { enumerable: !0, configurable: !0, writable: !0, value: u }) : n[c] = u, iA = (n, c, u) => fe$1(n, typeof c != "symbol" ? c + "" : c, u);
const K = { BASE_URL: "/", DEV: !1, MODE: "production", PROD: !0, SSR: !1 };
let Le = 0;
function W(n, c) {
  const u = `atom${++Le}`, p = {
    toString() {
      return (K ? "production" : void 0) !== "production" && this.debugLabel ? u + ":" + this.debugLabel : u;
    }
  };
  return typeof n == "function" ? p.read = n : (p.init = n, p.read = We, p.write = ze), c && (p.write = c), p;
}
function We(n) {
  return n(this);
}
function ze(n, c, u) {
  return c(
    this,
    typeof u == "function" ? u(n(this)) : u
  );
}
const g2 = (n, c) => n.unstable_is ? n.unstable_is(c) : c === n, mA = (n) => "init" in n, yA = (n) => !!n.write, gA = /* @__PURE__ */ new WeakMap(), IA = (n) => {
  var c;
  return kA(n) && !((c = gA.get(n)) != null && c[1]);
}, Ke = (n, c) => {
  const u = gA.get(n);
  if (u)
    u[1] = !0, u[0].forEach((p) => p(c));
  else if ((K ? "production" : void 0) !== "production")
    throw new Error("[Bug] cancelable promise not found");
}, Ue = (n) => {
  if (gA.has(n))
    return;
  const c = [/* @__PURE__ */ new Set(), !1];
  gA.set(n, c);
  const u = () => {
    c[1] = !0;
  };
  n.then(u, u), n.onCancel = (p) => {
    c[0].add(p);
  };
}, kA = (n) => typeof (n == null ? void 0 : n.then) == "function", u2 = (n) => "v" in n || "e" in n, oA = (n) => {
  if ("e" in n)
    throw n.e;
  if ((K ? "production" : void 0) !== "production" && !("v" in n))
    throw new Error("[Bug] atom state is not initialized");
  return n.v;
}, F2 = (n, c, u) => {
  u.p.has(n) || (u.p.add(n), c.then(
    () => {
      u.p.delete(n);
    },
    () => {
      u.p.delete(n);
    }
  ));
}, f2 = (n, c, u, p, a) => {
  var A;
  if ((K ? "production" : void 0) !== "production" && p === c)
    throw new Error("[Bug] atom cannot depend on itself");
  u.d.set(p, a.n), IA(u.v) && F2(c, u.v, a), (A = a.m) == null || A.t.add(c), n && Xe(n, p, c);
}, j = () => [/* @__PURE__ */ new Map(), /* @__PURE__ */ new Map(), /* @__PURE__ */ new Set()], CA = (n, c, u) => {
  n[0].has(c) || n[0].set(c, /* @__PURE__ */ new Set()), n[1].set(c, u);
}, Xe = (n, c, u) => {
  const p = n[0].get(c);
  p && p.add(u);
}, Ge = (n, c) => n[0].get(c), w2 = (n, c) => {
  n[2].add(c);
}, Z = (n) => {
  for (; n[1].size || n[2].size; ) {
    n[0].clear();
    const c = new Set(n[1].values());
    n[1].clear();
    const u = new Set(n[2]);
    n[2].clear(), c.forEach((p) => {
      var a;
      return (a = p.m) == null ? void 0 : a.l.forEach((A) => A());
    }), u.forEach((p) => p());
  }
}, H2 = (n) => {
  let c;
  (K ? "production" : void 0) !== "production" && (c = /* @__PURE__ */ new Set());
  const u = (be, He, Pe) => {
    const nr = "v" in He, ir = He.v, or = IA(He.v) ? He.v : null;
    if (kA(Pe)) {
      Ue(Pe);
      for (const lr of He.d.keys())
        F2(
          be,
          Pe,
          n(lr, He)
        );
      He.v = Pe, delete He.e;
    } else
      He.v = Pe, delete He.e;
    (!nr || !Object.is(ir, He.v)) && (++He.n, or && Ke(or, Pe));
  }, p = (be, He, Pe, nr) => {
    var ir;
    if (u2(Pe) && (Pe.m && !(nr != null && nr.has(He)) || Array.from(Pe.d).every(
      ([Ce, tr]) => (
        // Recursively, read the atom state of the dependency, and
        // check if the atom epoch number is unchanged
        p(be, Ce, n(Ce, Pe), nr).n === tr
      )
    )))
      return Pe;
    Pe.d.clear();
    let or = !0;
    const lr = (Ce) => {
      if (g2(He, Ce)) {
        const Fe = n(Ce, Pe);
        if (!u2(Fe))
          if (mA(Ce))
            u(Ce, Fe, Ce.init);
          else
            throw new Error("no atom init");
        return oA(Fe);
      }
      const tr = p(
        be,
        Ce,
        n(Ce, Pe),
        nr
      );
      if (or)
        f2(be, He, Pe, Ce, tr);
      else {
        const Fe = j();
        f2(Fe, He, Pe, Ce, tr), L(Fe, He, Pe), Z(Fe);
      }
      return oA(tr);
    };
    let Ir, xr;
    const kr = {
      get signal() {
        return Ir || (Ir = new AbortController()), Ir.signal;
      },
      get setSelf() {
        return (K ? "production" : void 0) !== "production" && !yA(He) && console.warn("setSelf function cannot be used with read-only atom"), !xr && yA(He) && (xr = (...Ce) => {
          if ((K ? "production" : void 0) !== "production" && or && console.warn("setSelf function cannot be called in sync"), !or)
            return le(He, ...Ce);
        }), xr;
      }
    };
    try {
      const Ce = He.read(lr, kr);
      if (u(He, Pe, Ce), kA(Ce)) {
        (ir = Ce.onCancel) == null || ir.call(Ce, () => Ir == null ? void 0 : Ir.abort());
        const tr = () => {
          if (Pe.m) {
            const Fe = j();
            L(Fe, He, Pe), Z(Fe);
          }
        };
        Ce.then(tr, tr);
      }
      return Pe;
    } catch (Ce) {
      return delete Pe.v, Pe.e = Ce, ++Pe.n, Pe;
    } finally {
      or = !1;
    }
  }, a = (be) => oA(p(void 0, be, n(be))), A = (be, He, Pe) => {
    var nr, ir;
    const or = /* @__PURE__ */ new Map();
    for (const lr of ((nr = Pe.m) == null ? void 0 : nr.t) || [])
      or.set(lr, n(lr, Pe));
    for (const lr of Pe.p)
      or.set(
        lr,
        n(lr, Pe)
      );
    return (ir = Ge(be, He)) == null || ir.forEach((lr) => {
      or.set(lr, n(lr, Pe));
    }), or;
  }, b = (be, He, Pe) => {
    const nr = [], ir = /* @__PURE__ */ new Set(), or = (Ir, xr) => {
      if (!ir.has(Ir)) {
        ir.add(Ir);
        for (const [kr, Ce] of A(be, Ir, xr))
          Ir !== kr && or(kr, Ce);
        nr.push([Ir, xr, xr.n]);
      }
    };
    or(He, Pe);
    const lr = /* @__PURE__ */ new Set([He]);
    for (let Ir = nr.length - 1; Ir >= 0; --Ir) {
      const [xr, kr, Ce] = nr[Ir];
      let tr = !1;
      for (const Fe of kr.d.keys())
        if (Fe !== xr && lr.has(Fe)) {
          tr = !0;
          break;
        }
      tr && (p(be, xr, kr, ir), L(be, xr, kr), Ce !== kr.n && (CA(be, xr, kr), lr.add(xr))), ir.delete(xr);
    }
  }, F = (be, He, Pe, ...nr) => {
    const ir = (lr) => oA(p(be, lr, n(lr, Pe))), or = (lr, ...Ir) => {
      const xr = n(lr, Pe);
      let kr;
      if (g2(He, lr)) {
        if (!mA(lr))
          throw new Error("atom not writable");
        const Ce = "v" in xr, tr = xr.v, Fe = Ir[0];
        u(lr, xr, Fe), L(be, lr, xr), (!Ce || !Object.is(tr, xr.v)) && (CA(be, lr, xr), b(be, lr, xr));
      } else
        kr = F(be, lr, xr, ...Ir);
      return Z(be), kr;
    };
    return He.write(ir, or, ...nr);
  }, le = (be, ...He) => {
    const Pe = j(), nr = F(Pe, be, n(be), ...He);
    return Z(Pe), nr;
  }, L = (be, He, Pe) => {
    if (Pe.m && !IA(Pe.v)) {
      for (const nr of Pe.d.keys())
        Pe.m.d.has(nr) || (pe(be, nr, n(nr, Pe)).t.add(He), Pe.m.d.add(nr));
      for (const nr of Pe.m.d || [])
        if (!Pe.d.has(nr)) {
          Pe.m.d.delete(nr);
          const ir = $(be, nr, n(nr, Pe));
          ir == null || ir.t.delete(He);
        }
    }
  }, pe = (be, He, Pe) => {
    if (!Pe.m) {
      p(be, He, Pe);
      for (const nr of Pe.d.keys())
        pe(be, nr, n(nr, Pe)).t.add(He);
      if (Pe.m = {
        l: /* @__PURE__ */ new Set(),
        d: new Set(Pe.d.keys()),
        t: /* @__PURE__ */ new Set()
      }, (K ? "production" : void 0) !== "production" && c.add(He), yA(He) && He.onMount) {
        const nr = Pe.m, { onMount: ir } = He;
        w2(be, () => {
          const or = ir(
            (...lr) => F(be, He, Pe, ...lr)
          );
          or && (nr.u = or);
        });
      }
    }
    return Pe.m;
  }, $ = (be, He, Pe) => {
    if (Pe.m && !Pe.m.l.size && !Array.from(Pe.m.t).some(
      (nr) => {
        var ir;
        return (ir = n(nr, Pe).m) == null ? void 0 : ir.d.has(He);
      }
    )) {
      const nr = Pe.m.u;
      nr && w2(be, nr), delete Pe.m, (K ? "production" : void 0) !== "production" && c.delete(He);
      for (const ir of Pe.d.keys()) {
        const or = $(be, ir, n(ir, Pe));
        or == null || or.t.delete(He);
      }
      return;
    }
    return Pe.m;
  }, Ee = {
    get: a,
    set: le,
    sub: (be, He) => {
      const Pe = j(), nr = n(be), ir = pe(Pe, be, nr);
      Z(Pe);
      const or = ir.l;
      return or.add(He), () => {
        or.delete(He);
        const lr = j();
        $(lr, be, nr), Z(lr);
      };
    },
    unstable_derive: (be) => H2(...be(n))
  };
  return (K ? "production" : void 0) !== "production" && Object.assign(Ee, {
    // store dev methods (these are tentative and subject to change without notice)
    dev4_get_internal_weak_map: () => ({
      get: (be) => {
        const He = n(be);
        if (He.n !== 0)
          return He;
      }
    }),
    dev4_get_mounted_atoms: () => c,
    dev4_restore_atoms: (be) => {
      const He = j();
      for (const [Pe, nr] of be)
        if (mA(Pe)) {
          const ir = n(Pe), or = "v" in ir, lr = ir.v;
          u(Pe, ir, nr), L(He, Pe, ir), (!or || !Object.is(lr, ir.v)) && (CA(He, Pe, ir), b(He, Pe, ir));
        }
      Z(He);
    }
  }), Ee;
}, M2 = () => {
  const n = /* @__PURE__ */ new WeakMap();
  return H2((c) => {
    let u = n.get(c);
    return u || (u = { d: /* @__PURE__ */ new Map(), p: /* @__PURE__ */ new Set(), n: 0 }, n.set(c, u)), u;
  });
};
let nA;
const Ye = () => (nA || (nA = M2(), (K ? "production" : void 0) !== "production" && (globalThis.__JOTAI_DEFAULT_STORE__ || (globalThis.__JOTAI_DEFAULT_STORE__ = nA), globalThis.__JOTAI_DEFAULT_STORE__ !== nA && console.warn(
  "Detected multiple Jotai instances. It may cause unexpected behavior with the default store. https://github.com/pmndrs/jotai/discussions/2044"
))), nA), J2 = { BASE_URL: "/", DEV: !1, MODE: "production", PROD: !0, SSR: !1 }, Q2 = createContext(
  void 0
), T2 = (n) => useContext(Q2) || Ye(), Re = ({
  children: n,
  store: c
}) => {
  const u = useRef();
  return !c && !u.current && (u.current = M2()), createElement(
    Q2.Provider,
    {
      value: c || u.current
    },
    n
  );
}, L2 = (n) => typeof (n == null ? void 0 : n.then) == "function", Oe = (n) => {
  n.status = "pending", n.then(
    (c) => {
      n.status = "fulfilled", n.value = c;
    },
    (c) => {
      n.status = "rejected", n.reason = c;
    }
  );
}, Ze = De.use || ((n) => {
  if (n.status === "pending")
    throw n;
  if (n.status === "fulfilled")
    return n.value;
  throw n.status === "rejected" ? n.reason : (Oe(n), n);
}), vA = /* @__PURE__ */ new WeakMap(), Ve = (n) => {
  let c = vA.get(n);
  return c || (c = new Promise((u, p) => {
    let a = n;
    const A = (le) => (L) => {
      a === le && u(L);
    }, b = (le) => (L) => {
      a === le && p(L);
    }, F = (le) => {
      "onCancel" in le && typeof le.onCancel == "function" && le.onCancel((L) => {
        if ((J2 ? "production" : void 0) !== "production" && L === le)
          throw new Error("[Bug] p is not updated even after cancelation");
        L2(L) ? (vA.set(L, c), a = L, L.then(A(L), b(L)), F(L)) : u(L);
      });
    };
    n.then(A(n), b(n)), F(n);
  }), vA.set(n, c)), c;
};
function H(n, c) {
  const u = T2(), [[p, a, A], b] = useReducer(
    (le) => {
      const L = u.get(n);
      return Object.is(le[0], L) && le[1] === u && le[2] === n ? le : [L, u, n];
    },
    void 0,
    () => [u.get(n), u, n]
  );
  let F = p;
  if ((a !== u || A !== n) && (b(), F = u.get(n)), useEffect(() => {
    const le = u.sub(n, () => {
      b();
    });
    return b(), le;
  }, [u, n, void 0]), useDebugValue(F), L2(F)) {
    const le = Ve(F);
    return Ze(le);
  }
  return F;
}
function R(n, c) {
  const u = T2();
  return useCallback(
    (...p) => {
      if ((J2 ? "production" : void 0) !== "production" && !("write" in n))
        throw new Error("not writable atom");
      return u.set(n, ...p);
    },
    [u, n]
  );
}
function je(n, c) {
  return [
    H(n),
    // We do wrong type assertion here, which results in throwing an error.
    R(n)
  ];
}
var qe = Object.defineProperty, _e = (n, c, u) => c in n ? qe(n, c, { enumerable: !0, configurable: !0, writable: !0, value: u }) : n[c] = u, w = (n, c, u) => _e(n, typeof c != "symbol" ? c + "" : c, u), N$2;
(function(n) {
  n.MAINNET = "mainnet", n.TESTNET = "testnet", n.SIGNET = "signet";
})(N$2 || (N$2 = {}));
class W2 {
  constructor(c) {
    w(this, "chains"), w(this, "option"), this.chains = c.chains, this.option = c;
  }
  // If constructor or init throws an exception, the wallet will be considered not installed.
  // This method is used to handle asynchronous initialization
  init() {
    return Promise.resolve();
  }
}
function D(n) {
  return n != null && n.getWindow ? n.getWindow() : window;
}
let SA;
function $e(n) {
  SA = n;
}
let z2;
function At(n) {
  z2 = n;
}
const tA = (n) => {
  if (SA)
    return SA + "/";
  if (n === N$2.MAINNET)
    return "https://mempool.space/api/";
  if (n === N$2.TESTNET)
    return "https://mempool.space/testnet/api/";
  if (n === N$2.SIGNET)
    return "https://mempool.space/signet/api/";
};
function et(n) {
  const c = Object.keys(n);
  return c.length ? "?" + c.map((u) => encodeURIComponent(u) + "=" + (n[u] ? encodeURIComponent(n[u]) : "")).join("&") : "";
}
function tt(n, c) {
  return new URL(tA(n) + "address/" + c);
}
function h2(n) {
  return new URL(tA(n) + "tx");
}
function nt(n, c) {
  return new URL(tA(n) + "address/" + c + "/utxo");
}
function rt(n) {
  return new URL(tA(n) + "v1/fees/recommended");
}
function st(n) {
  return new URL(tA(n) + "blocks/tip/height");
}
async function it(n, c) {
  const u = await fetch(h2(n), {
    method: "POST",
    body: c
  });
  if (u.ok)
    return await u.text();
  try {
    const p = await u.text();
    alert(`Error: ${p} ${n} ${h2(n)}`);
    const a = p.split('"message":"')[1].split('"}')[0];
    throw p.includes("error") || p.includes("message") ? new Error(a) : new Error("Error broadcasting transaction. Please try again");
  } catch (p) {
    throw new Error((p == null ? void 0 : p.message) || p);
  }
}
async function ot(n, c) {
  const u = await fetch(tt(n, c));
  if (u.ok) {
    const p = await u.json();
    return p.chain_stats.funded_txo_sum - p.chain_stats.spent_txo_sum;
  } else {
    const p = await u.text();
    throw new Error(p);
  }
}
async function ct(n) {
  const c = await fetch(rt(n));
  if (c.ok)
    return await c.json();
  {
    const u = await c.text();
    throw new Error(u);
  }
}
async function at(n) {
  const c = await fetch(st(n)), u = await c.text();
  if (!c.ok)
    throw new Error(u);
  const p = Number(u);
  if (Number.isNaN(p))
    throw new Error("Invalid result returned");
  return p;
}
function dt(n, c) {
  return new URL(tA(n) + "v1/validate-address/" + c);
}
async function lt$4(n, c, u) {
  let p = null;
  try {
    p = await (await fetch(nt(n, c))).json();
  } catch ($) {
    throw new Error(($ == null ? void 0 : $.message) || $);
  }
  const a = p.filter(($) => $.status.confirmed).sort(($, Ee) => Ee.value - $.value);
  let A = a;
  if (u) {
    for (var b = 0, F = 0; F < a.length && (b += a[F].value, !(b > u)); ++F)
      ;
    if (b < u)
      return [];
    A = a.slice(0, F + 1);
  }
  const le = await (await fetch(dt(n, c))).json(), { isvalid: L, scriptPubKey: pe } = le;
  if (!L)
    throw new Error("Invalid address");
  return A.map(($) => ({
    txid: $.txid,
    vout: $.vout,
    value: $.value,
    scriptPubKey: pe
  }));
}
async function gt$5(n) {
  const c = await fetch(`${z2 || "https://apps-prod.unyx.tech/api"}/openapi/bitcoin/inscriptions${et(n)}`);
  if (c.ok)
    return (await c.json()).result;
  {
    const u = await c.text();
    throw new Error(u);
  }
}
let p2 = !1;
function o2() {
  p2 || (p2 = !0, src$j.initEccLib(dist$x));
}
class J extends W2 {
  constructor(c, u) {
    var p, a, A, b, F, le;
    super(c), w(this, "bitcoinNetworkProvider"), this.bitcoinNetworkProvider = u, o2(), $e((A = (a = (p = this.chains) == null ? void 0 : p[0]) == null ? void 0 : a.backendUrls) == null ? void 0 : A.mempoolUrl), At((le = (F = (b = this.chains) == null ? void 0 : b[0]) == null ? void 0 : F.backendUrls) == null ? void 0 : le.inscriptionUrl);
  }
  /**
   * Gets the address of the connected wallet.
   * @returns A promise that resolves to the address of the connected wallet.
   */
  async getAddress() {
    const c = await this.bitcoinNetworkProvider.getAccounts() || [];
    if (!(c != null && c[0]))
      throw new Error("Wallet not connected");
    return c[0];
  }
  /**
   * Gets the public key of the connected wallet.
   * @returns A promise that resolves to the public key of the connected wallet.
   */
  async getPublicKeyHex() {
    return await this.bitcoinNetworkProvider.getPublicKey();
  }
  /**
   * Signs the given PSBT in hex format.
   * @param psbtHex - The hex string of the unsigned PSBT to sign.
   * @param options - Optional parameters for signing the PSBT.
   * @returns A promise that resolves to the hex string of the signed PSBT.
   */
  async signPsbt(c, u) {
    return await this.bitcoinNetworkProvider.signPsbt(c, u);
  }
  /**
   * Signs multiple PSBTs in hex format.
   * @param psbtsHexes - The hex strings of the unsigned PSBTs to sign.
   * @param options - Optional parameters for signing the PSBTs.
   * @returns A promise that resolves to an array of hex strings, each representing a signed PSBT.
   */
  async signPsbts(c, u) {
    return await this.bitcoinNetworkProvider.signPsbts(c, u);
  }
  /**
   * Gets the network of the current account.
   * @returns A promise that resolves to the network of the current account.
   */
  async getNetwork() {
    return (await this.bitcoinNetworkProvider.getNetwork()).replace("livenet", "mainnet");
  }
  /**
   * Signs a message using BIP-322 simple.
   * @param message - The message to sign.
   * @returns A promise that resolves to the signed message.
   */
  async signMessageBIP322(c) {
    return await this.signMessage(c, "bip322-simple");
  }
  async signMessage(c, u = "ecdsa") {
    return await this.bitcoinNetworkProvider.signMessage(c, u);
  }
  /**
   * Registers an event listener for the specified event.
   * At the moment, only the "accountChanged" event is supported.
   * @param eventName - The name of the event to listen for.
   * @param callBack - The callback function to be executed when the event occurs.
   */
  on(c, u) {
    var p, a;
    (a = (p = this.bitcoinNetworkProvider) == null ? void 0 : p.on) == null || a.call(p, c, u);
  }
  off(c, u) {
    var p, a;
    (a = (p = this.bitcoinNetworkProvider) == null ? void 0 : p.off) == null || a.call(p, c, u);
  }
  async switchNetwork(c) {
    await this.bitcoinNetworkProvider.switchNetwork(c);
  }
  async sendBitcoin(c, u) {
    return await this.bitcoinNetworkProvider.sendBitcoin(c, Number(u));
  }
  /**
   * Retrieves the inscriptions for the connected wallet.
   * @returns A promise that resolves to an array of inscriptions.
   */
  async getInscriptions(c, u) {
    return await gt$5({
      address: await this.getAddress(),
      // @ts-ignore
      networkType: (await this.getNetwork()).toUpperCase(),
      cursor: c,
      size: u
    });
  }
  /**
   * Retrieves the network fees.
   * @returns A promise that resolves to the network fees.
   */
  async getNetworkFees() {
    return await ct(await this.getNetwork());
  }
  /**
   * Pushes a transaction to the network.
   * @param txHex - The hexadecimal representation of the transaction.
   * @returns A promise that resolves to a string representing the transaction ID.
   */
  async pushTx(c) {
    return await it(await this.getNetwork(), c);
  }
  /**
   * Retrieves the unspent transaction outputs (UTXOs) for a given address and amount.
   *
   * If the amount is provided, it will return UTXOs that cover the specified amount.
   * If the amount is not provided, it will return all available UTXOs for the address.
   *
   * @param address - The address to retrieve UTXOs for.
   * @param amount - Optional amount of funds required.
   * @returns A promise that resolves to an array of UTXOs.
   */
  async getUtxos(c, u) {
    return await lt$4(await this.getNetwork(), c, u);
  }
  /**
   * Retrieves the tip height of the BTC chain.
   * @returns A promise that resolves to the block height.
   */
  async getBTCTipHeight() {
    return await at(await this.getNetwork());
  }
  /**
   * Gets the balance for the connected wallet address.
   * By default, this method will return the mempool balance if not implemented by the child class.
   * @returns A promise that resolves to the balance of the wallet.
   */
  async getBalance() {
    return await ot(await this.getNetwork(), await this.getAddress());
  }
}
const K2 = "data:image/svg+xml,%3csvg%20width='28'%20height='28'%20viewBox='0%200%2028%2028'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3crect%20width='28'%20height='28'%20fill='url(%23pattern0_260_7740)'/%3e%3cdefs%3e%3cpattern%20id='pattern0_260_7740'%20patternContentUnits='objectBoundingBox'%20width='1'%20height='1'%3e%3cuse%20xlink:href='%23image0_260_7740'%20transform='scale(0.0208333)'/%3e%3c/pattern%3e%3cimage%20id='image0_260_7740'%20width='48'%20height='48'%20xlink:href='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAMKADAAQAAAABAAAAMAAAAADbN2wMAAACsUlEQVRoBe1avY7aQBBeW0aAAOGKhsaRgAYQLigoED9PEOUJcm9CHiV5goQngOvo8LU05xRQ0MQIEP/yzUQyuvPv+m5t2TqvtAIv45lvvtn1aDxwxGYMBgPxer1+hykfDgf5eDyKuq5LNqKBLaVSKRVsaoVCQU2n03/O5/PjbDZTPQ32er1RpVL5VywWdRCOxMzlcnqtVtMRm6MDwLrUbrfnKBwV4GYcmUxGR4ydTkeyOII/QKgiC95wxnDijQMYmjiAN5zAXdLtdn+gExxundVq9bxYLPA6NqNarWrlcvkLf7vdBsvlMjbADaDr9Vq8XC4PPDyevu73e2M9Np+bzYbAY77F73Y7KTaoTUAhP8kCrImmddtLWZaJKLqLTqdT23vNi6x0nU4nkWCCAAOuEw46JEXvAcBc9aAdlroQO29m5yPXXhHyo5tWF1MH/ABkJZs4wIrJ9+pJIvBe5ljd9zkioGkaK8IIS10ICjOx51AUhQyHQ1c5BNbv98loNHKVG4/HVLrQJtWgycSgyDPDosxkMvFM1yhDq89LjnkmBoOhj89xiEOn1YfBJAI+yApENIlAILT6UEqVyFAfTRmIScproAyNLtryNCkpXzNOWwa+vsfpO62u5BA7MRjWehKBsJh2spNEwImZsNapIsCyDGSpC0kSeJ5X4VOC6ThoS0qaMpClLuxkklarNQfkzMq8MHXV6/U5D72xJ0fqI/5DPp//y0MYFOgJRxyqFR40+giQ/xsd+Fkqldi9+LHaCmQFGnwEu/f/lWPLMsoNbgD55oxir9hos97ZiWuj+54H4EB8azabCuyru1NR+4L7vtFoKIDV+TUhhgbfeEVpS+EfT/APKJZtAwxzdixj9x4b4NhD3m63Esdx2FSW7GSDWgObKux1LZvNKoIg4PwFZablYfMCcyEt0t7W+RoAAAAASUVORK5CYII='/%3e%3c/defs%3e%3c/svg%3e";
let ut$1 = class extends J {
  constructor(c) {
    const u = D(c).okxwallet, p = u == null ? void 0 : u.bitcoin;
    if (!p)
      throw new Error("OKX Wallet extension not found");
    super(c, p), w(this, "okxWalletInfo"), w(this, "okxWallet"), w(this, "networkEnv", N$2.MAINNET), w(this, "getAddress", async () => await this.bitcoinNetworkProvider.getSelectedAddress()), w(this, "getNetwork", async () => {
      if (!this.networkEnv)
        throw new Error("Network not set");
      return this.networkEnv;
    }), w(this, "getPublicKeyHex", async () => {
      if (!this.okxWalletInfo)
        throw new Error("OKX Wallet not connected");
      return this.okxWalletInfo.publicKeyHex;
    }), w(this, "getBalance", async () => (await this.bitcoinNetworkProvider.getBalance()).confirmed), w(this, "pushTx", async (a) => await this.bitcoinNetworkProvider.pushTx(a)), this.okxWallet = u;
  }
  async connectWallet() {
    var c;
    try {
      await this.okxWallet.enable();
    } catch (A) {
      throw (c = A == null ? void 0 : A.message) != null && c.includes("rejected") ? new Error("Connection to OKX Wallet was rejected") : new Error(A == null ? void 0 : A.message);
    }
    let u = null;
    try {
      u = await this.bitcoinNetworkProvider.connect();
    } catch {
      throw new Error(`BTC ${this.networkEnv} is not enabled in OKX Wallet`);
    }
    const { address: p, compressedPublicKey: a } = u;
    if (a && p)
      return this.okxWalletInfo = {
        publicKeyHex: a,
        address: p
      }, this;
    throw new Error("Could not connect to OKX Wallet");
  }
  async switchNetwork(c) {
    switch (c) {
      case N$2.MAINNET:
        this.bitcoinNetworkProvider = this.okxWallet.bitcoin;
        break;
      case N$2.TESTNET:
        this.bitcoinNetworkProvider = this.okxWallet.bitcoinTestnet;
        break;
      case N$2.SIGNET:
        this.bitcoinNetworkProvider = this.okxWallet.bitcoinSignet;
        break;
      default:
        throw new Error("Unsupported network");
    }
    this.networkEnv = c, await this.connectWallet();
  }
  async sendBitcoin(c, u) {
    return await this.bitcoinNetworkProvider.sendBitcoin(
      c,
      // @ts-ignore
      BigInt(u)
    );
  }
  async getInscriptions(c, u) {
    return await this.bitcoinNetworkProvider.getInscriptions(c, u);
  }
  getWalletProviderIcon() {
    return Promise.resolve(xA.img);
  }
  getWalletProviderName() {
    return Promise.resolve(xA.name);
  }
};
const xA = {
  id: "bitcoin_okx",
  img: K2,
  name: "OKX",
  chainType: "bitcoin",
  connectProvider: ut$1,
  type: "extension"
}, U2 = "data:image/svg+xml,%3csvg%20width='42'%20height='42'%20viewBox='0%200%2042%2042'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_6_1029)'%3e%3cg%20clip-path='url(%23clip1_6_1029)'%3e%3cg%20clip-path='url(%23clip2_6_1029)'%3e%3cpath%20d='M28.0078%203.74221L36.5506%2012.201C37.2772%2012.9192%2037.6342%2013.6458%2037.6216%2014.3808C37.609%2015.1116%2037.2982%2015.7836%2036.685%2016.3884C36.0466%2017.0226%2035.3578%2017.346%2034.6186%2017.3586C33.8794%2017.3712%2033.1486%2017.0142%2032.4178%2016.296L23.6818%207.64401C22.6906%206.66121%2021.733%205.96401%2020.809%205.55661C19.8892%205.14921%2018.919%205.08621%2017.9026%205.36341C16.8862%205.64061%2015.7942%206.35881%2014.6266%207.51801C13.0138%209.11401%2012.2452%2010.6134%2012.325%2012.0162C12.4048%2013.419%2013.2028%2014.868%2014.7232%2016.3758L23.5306%2025.0992C24.2656%2025.8258%2024.6268%2026.5524%2024.6142%2027.2748C24.6016%2027.9972%2024.2866%2028.6692%2023.665%2029.2824C23.0434%2029.8956%2022.363%2030.219%2021.6154%2030.2442C20.872%2030.2694%2020.1328%2029.9166%2019.3978%2029.19L10.8634%2020.7312C9.4732%2019.3536%208.4694%2018.0516%207.852%2016.8252C7.2346%2015.5988%207.0036%2014.2086%207.1632%2012.6588C7.306%2011.3316%207.7344%2010.0464%208.44%208.79901C9.1498%207.55161%2010.162%206.27901%2011.4766%204.97281C13.0432%203.41881%2014.5384%202.23021%2015.9664%201.40281C17.3944%200.575413%2018.772%200.113413%2020.1034%200.0168127C21.4348%20-0.0797873%2022.7494%200.184813%2024.0514%200.810613C25.3492%201.43641%2026.668%202.41081%2028.012%203.74221H28.0078Z'%20fill='url(%23paint0_linear_6_1029)'/%3e%3cpath%20d='M14.6141%2037.8798L6.07132%2029.421C5.34472%2028.7028%204.98772%2027.9762%205.00032%2027.2412C5.01292%2026.5062%205.32372%2025.8384%205.93692%2025.2336C6.57532%2024.5994%207.26412%2024.276%208.00332%2024.2634C8.74252%2024.2508%209.47332%2024.6036%2010.2041%2025.326L18.9401%2033.978C19.9355%2034.9608%2020.8889%2035.658%2021.8129%2036.0654C22.7369%2036.4728%2023.7029%2036.5358%2024.7193%2036.2586C25.7357%2035.9814%2026.8277%2035.2632%2027.9953%2034.104C29.6081%2032.508%2030.3767%2031.0086%2030.2969%2029.6058C30.2171%2028.203%2029.4191%2026.7498%2027.8987%2025.2462L23.2073%2020.6388C22.4723%2019.9122%2022.1111%2019.1856%2022.1237%2018.4632C22.1363%2017.7408%2022.4513%2017.0688%2023.0729%2016.4556C23.6945%2015.8424%2024.3749%2015.519%2025.1225%2015.4938C25.8659%2015.4686%2026.6051%2015.8214%2027.3401%2016.548L31.7627%2020.8908C33.1529%2022.2684%2034.1567%2023.5704%2034.7741%2024.7968C35.3915%2026.0232%2035.6225%2027.4134%2035.4629%2028.9632C35.3201%2030.2904%2034.8917%2031.5756%2034.1861%2032.823C33.4763%2034.0704%2032.4641%2035.343%2031.1495%2036.6492C29.5829%2038.2032%2028.0877%2039.3918%2026.6597%2040.2192C25.2317%2041.0466%2023.8541%2041.5086%2022.5227%2041.6052C21.1913%2041.7018%2019.8767%2041.4372%2018.5747%2040.8114C17.2769%2040.1856%2015.9539%2039.2112%2014.6141%2037.8798Z'%20fill='url(%23paint1_linear_6_1029)'/%3e%3cpath%20d='M19.9401%2016.0524C21.6729%2016.0524%2023.0775%2014.6477%2023.0775%2012.915C23.0775%2011.1822%2021.6729%209.77759%2019.9401%209.77759C18.2074%209.77759%2016.8027%2011.1822%2016.8027%2012.915C16.8027%2014.6477%2018.2074%2016.0524%2019.9401%2016.0524Z'%20fill='url(%23paint2_radial_6_1029)'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3cdefs%3e%3clinearGradient%20id='paint0_linear_6_1029'%20x1='35.1508'%20y1='8.6366'%20x2='8.6783'%20y2='20.4003'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23070100'/%3e%3cstop%20offset='0.36'%20stop-color='%2377390D'/%3e%3cstop%20offset='0.67'%20stop-color='%23EA8101'/%3e%3cstop%20offset='1'%20stop-color='%23F4B852'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint1_linear_6_1029'%20x1='8.20796'%20y1='33.2636'%20x2='38.8824'%20y2='24.1302'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23070100'/%3e%3cstop%20offset='0.37'%20stop-color='%2377390D'/%3e%3cstop%20offset='0.67'%20stop-color='%23EA8101'/%3e%3cstop%20offset='1'%20stop-color='%23F4FB52'/%3e%3c/linearGradient%3e%3cradialGradient%20id='paint2_radial_6_1029'%20cx='0'%20cy='0'%20r='1'%20gradientUnits='userSpaceOnUse'%20gradientTransform='translate(19.9359%2012.9192)%20scale(3.1374)'%3e%3cstop%20stop-color='%23F4B852'/%3e%3cstop%20offset='0.33'%20stop-color='%23EA8101'/%3e%3cstop%20offset='0.64'%20stop-color='%2377390D'/%3e%3cstop%20offset='1'%20stop-color='%23070100'/%3e%3c/radialGradient%3e%3cclipPath%20id='clip0_6_1029'%3e%3crect%20width='42'%20height='42'%20fill='white'/%3e%3c/clipPath%3e%3cclipPath%20id='clip1_6_1029'%3e%3crect%20width='42'%20height='42'%20fill='white'/%3e%3c/clipPath%3e%3cclipPath%20id='clip2_6_1029'%3e%3crect%20width='42'%20height='42'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e";
class ft extends J {
  constructor(c) {
    const u = D(c).unisat_wallet;
    if (!u)
      throw new Error("UniSat Wallet extension not found");
    super(c, u), w(this, "connectWallet", async () => {
      const p = this.bitcoinNetworkProvider;
      try {
        const a = await p.requestAccounts(), A = await p.getPublicKey();
        if (!a || !A)
          throw new Error("Could not connect to unisat wallet");
        return this;
      } catch {
        throw new Error("Failed to connect to unisat wallet");
      }
    }), w(this, "getBalance", async () => (await this.bitcoinNetworkProvider.getBalance()).confirmed), w(this, "pushTx", async (p) => await this.bitcoinNetworkProvider.pushTx(p)), w(this, "signPsbt", async (p, a) => {
      const A = {
        curNetwork: await this.getNetwork(),
        curAddress: await this.getAddress(),
        curPublicKey: await this.getPublicKeyHex()
      };
      if (!A.curAddress)
        throw new Error("Unisat Wallet not connected");
      if (!p)
        throw new Error("psbt hex is required");
      try {
        const b = {
          ...this.getSignPsbtDefaultOptions(p, A),
          ...a
        };
        return await this.bitcoinNetworkProvider.signPsbt(
          p,
          // @ts-ignore
          b
        );
      } catch (b) {
        throw new Error((b == null ? void 0 : b.message) || b);
      }
    }), w(this, "signPsbts", async (p, a) => {
      const A = {
        curNetwork: await this.getNetwork(),
        curAddress: await this.getAddress(),
        curPublicKey: await this.getPublicKeyHex()
      };
      if (!A.curAddress)
        throw new Error("Unisat Wallet not connected");
      if (!p && !Array.isArray(p))
        throw new Error("psbts hexes are required");
      try {
        const b = p.map((le) => this.getSignPsbtDefaultOptions(le, A)), F = a == null ? void 0 : a.map((le, L) => ({
          ...b[L],
          ...le
        }));
        return await this.bitcoinNetworkProvider.signPsbts(
          p,
          // @ts-ignore
          F
        );
      } catch (b) {
        throw new Error((b == null ? void 0 : b.message) || b);
      }
    });
  }
  async switchNetwork(c) {
    return await this.bitcoinNetworkProvider.switchNetwork(c.replace("mainnet", "livenet"));
  }
  async getNetwork() {
    return (await this.bitcoinNetworkProvider.getNetwork()).replace("livenet", "mainnet").replace("unknown", "signet");
  }
  async sendBitcoin(c, u) {
    return await this.bitcoinNetworkProvider.sendBitcoin(c, u);
  }
  getSignPsbtDefaultOptions(c, u) {
    const p = [], a = src$j.Psbt.fromHex(c), { curNetwork: A, curPublicKey: b, curAddress: F } = u;
    return a.data.inputs.forEach((le, L) => {
      let pe = !1;
      if (le.witnessUtxo && le.witnessUtxo.script) {
        let $ = src$j.networks.bitcoin;
        (A === N$2.TESTNET || A === N$2.SIGNET) && ($ = src$j.networks.testnet);
        let Ee;
        try {
          Ee = src$j.address.fromOutputScript(le.witnessUtxo.script, $);
        } catch (be) {
          if (be instanceof Error && be.message.toLowerCase().includes("has no matching address"))
            Ee = src$j.address.fromOutputScript(le.witnessUtxo.script, $);
          else
            throw new Error(be);
        }
        (Ee.indexOf("tb1p") === 0 || Ee.indexOf("bc1p") === 0) && Ee === F && (pe = !0);
      }
      le.finalScriptSig || le.finalScriptWitness || p.push({
        index: L,
        publicKey: b,
        sighashTypes: void 0,
        useTweakedSigner: pe
      });
    }), {
      autoFinalized: !0,
      toSignInputs: p
    };
  }
  async getInscriptions(c, u) {
    return await this.bitcoinNetworkProvider.getInscriptions(c, u);
  }
  getWalletProviderName() {
    return Promise.resolve(EA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(EA.img);
  }
}
const EA = {
  id: "bitcoin_unisat",
  img: U2,
  name: "Unisat",
  chainType: "bitcoin",
  connectProvider: ft,
  type: "extension"
}, X2 = "data:image/png;base64,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", wt = "tomo_btc";
class ht extends J {
  constructor(c) {
    const u = D(c)[wt];
    if (!u)
      throw new Error("Tomo Wallet extension not found");
    super(c, u), w(this, "connectWallet", async () => {
      const p = "1.2.0";
      if (!this.bitcoinNetworkProvider)
        throw new Error("Tomo Wallet extension not found");
      if (this.bitcoinNetworkProvider.getVersion && await this.bitcoinNetworkProvider.getVersion() < p)
        throw new Error("Please update Tomo Wallet to the latest version");
      let a = null, A = null;
      try {
        if (a = await this.bitcoinNetworkProvider.connectWallet(), A = await this.bitcoinNetworkProvider.getPublicKey(), !a || a.length === 0 || !A)
          throw new Error("BTC is not enabled in Tomo Wallet");
      } catch {
        throw new Error("BTC is not enabled in Tomo Wallet");
      }
      return this;
    }), w(this, "getBalance", async () => await this.bitcoinNetworkProvider.getBalance()), w(this, "pushTx", async (p) => await this.bitcoinNetworkProvider.pushTx(p));
  }
  getWalletProviderName() {
    return Promise.resolve(NA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(NA.img);
  }
}
const NA = {
  id: "bitcoin_tomo",
  img: X2,
  name: "Tomo",
  chainType: "bitcoin",
  connectProvider: ht,
  type: "extension"
}, G2 = "data:image/png;base64,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", pt = {
  [N$2.MAINNET]: "livenet",
  [N$2.TESTNET]: "testnet",
  [N$2.SIGNET]: "signet"
}, mt = "bitkeep";
class yt extends J {
  constructor(c) {
    var u;
    const p = (
      // @ts-ignore
      (u = D(c)[mt]) == null ? void 0 : u.unisat
    );
    if (!p)
      throw new Error("Bitget Wallet extension not found");
    super(c, p), w(this, "connectWallet", async () => {
      var a;
      try {
        await this.bitcoinNetworkProvider.requestAccounts();
      } catch (F) {
        throw (a = F == null ? void 0 : F.message) != null && a.includes("rejected") ? new Error("Connection to Bitget Wallet was rejected") : new Error(F == null ? void 0 : F.message);
      }
      const A = await this.getAddress(), b = await this.getPublicKeyHex();
      if (!A || !b)
        throw new Error("Could not connect to Bitget Wallet");
      return this;
    }), w(this, "signPsbt", async (a, A) => {
      const b = {
        method: "signPsbt",
        params: {
          // @ts-ignore
          from: this.bitcoinNetworkProvider.selectedAddress,
          __internalFunc: "__signPsbt_babylon",
          psbtHex: a,
          options: A || {
            autoFinalized: !0
          }
        }
      }, F = await this.bitcoinNetworkProvider.request("dappsSign", b), le = src$j.Psbt.fromHex(F);
      return le.data.inputs.every((L) => L.finalScriptWitness || L.finalScriptSig) || le.finalizeAllInputs(), le.toHex();
    }), w(this, "signPsbts", async (a, A) => {
      if (!a && !Array.isArray(a))
        throw new Error("params error");
      const b = A || a.map((le) => ({
        autoFinalized: !0
      })), F = {
        method: "signPsbt",
        params: {
          // @ts-ignore
          from: this.bitcoinNetworkProvider.selectedAddress,
          __internalFunc: "__signPsbts_babylon",
          psbtHex: "_",
          psbtHexs: a,
          options: b
        }
      };
      try {
        let le = await this.bitcoinNetworkProvider.request("dappsSign", F);
        return le = le.split(","), le.map((L) => {
          const pe = src$j.Psbt.fromHex(L);
          return pe.data.inputs.every(($) => $.finalScriptWitness || $.finalScriptSig) || pe.finalizeAllInputs(), pe.toHex();
        });
      } catch (le) {
        throw new Error(le == null ? void 0 : le.message);
      }
    });
  }
  async switchNetwork(c) {
    return await this.bitcoinNetworkProvider.switchNetwork(pt[c]);
  }
  async getInscriptions(c, u) {
    var p, a;
    return await ((a = (p = this.bitcoinNetworkProvider) == null ? void 0 : p.getInscriptions) == null ? void 0 : a.call(p, c, u));
  }
  getWalletProviderName() {
    return Promise.resolve(DA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(DA.img);
  }
}
const DA = {
  id: "bitcoin_bitget",
  img: G2,
  name: "Bitget Wallet",
  chainType: "bitcoin",
  connectProvider: yt,
  type: "extension"
}, Y2 = "data:image/svg+xml,%3csvg%20width='128'%20height='128'%20viewBox='0%200%20128%20128'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_45922_88)'%3e%3cpath%20d='M127.61%2063.8049C127.61%20107.853%20107.853%20127.61%2063.8049%20127.61C19.7568%20127.61%200%20107.853%200%2063.8049C0%2019.7568%2019.7568%200%2063.8049%200C107.853%200%20127.61%2019.7568%20127.61%2063.8049Z'%20fill='%233BD23D'/%3e%3cpath%20d='M69.5699%2027.0557L51.8197%2027.0557L48.7056%2036.4719H58.5645L58.5645%2056.3063H69.5699V27.0557Z'%20fill='black'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M84.0486%2080.3111C84.0486%2091.4912%2074.9854%20100.554%2063.8053%20100.554C52.6253%20100.554%2043.5621%2091.4912%2043.5621%2080.3111C43.5621%2069.1311%2052.6253%2060.0678%2063.8053%2060.0678C74.9854%2060.0678%2084.0486%2069.1311%2084.0486%2080.3111ZM74.8584%2080.3111C74.8584%2086.4155%2069.9097%2091.3641%2063.8053%2091.3641C57.7008%2091.3641%2052.7522%2086.4155%2052.7522%2080.3111C52.7522%2074.2066%2057.7008%2069.258%2063.8053%2069.258C69.9097%2069.258%2074.8584%2074.2066%2074.8584%2080.3111Z'%20fill='black'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_45922_88'%3e%3crect%20width='128'%20height='128'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", Ct = "$onekey", vt = {
  [N$2.MAINNET]: "livenet",
  [N$2.TESTNET]: "testnet",
  [N$2.SIGNET]: "signet"
};
class Bt extends J {
  constructor(c) {
    var u;
    const p = (u = D(c)[Ct]) == null ? void 0 : u.btcwallet;
    if (!p)
      throw new Error("OneKey Wallet extension not found");
    super(c, p), w(this, "getBalance", async () => await this.getNetwork() === N$2.MAINNET ? await this.bitcoinNetworkProvider.getBalance() : await super.getBalance()), w(this, "pushTx", async (a) => await this.bitcoinNetworkProvider.pushTx(a));
  }
  async connectWallet() {
    return await this.bitcoinNetworkProvider.connectWallet();
  }
  async switchNetwork(c) {
    return await this.bitcoinNetworkProvider.switchNetwork(vt[c]);
  }
  getWalletProviderName() {
    return Promise.resolve(FA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(FA.img);
  }
}
const FA = {
  id: "bitcoin_onekey",
  img: Y2,
  name: "OneKey",
  chainType: "bitcoin",
  connectProvider: Bt,
  type: "extension"
};
N$2.MAINNET;
const uA = (n) => {
  switch (n) {
    case N$2.MAINNET:
      return src$j.networks.bitcoin;
    case N$2.TESTNET:
    case N$2.SIGNET:
      return src$j.networks.testnet;
    default:
      throw new Error("Unsupported network");
  }
}, bt = "data:image/svg+xml,%3csvg%20width='513'%20height='512'%20viewBox='0%200%20513%20512'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_893_2592)'%3e%3cmask%20id='mask0_893_2592'%20style='mask-type:luminance'%20maskUnits='userSpaceOnUse'%20x='0'%20y='0'%20width='513'%20height='512'%3e%3cpath%20d='M512.319%200H0.319336V512H512.319V0Z'%20fill='white'/%3e%3c/mask%3e%3cg%20mask='url(%23mask0_893_2592)'%3e%3cpath%20d='M256.319%20512C397.704%20512%20512.319%20397.385%20512.319%20256C512.319%20114.615%20397.704%200%20256.319%200C114.934%200%200.319336%20114.615%200.319336%20256C0.319336%20397.385%20114.934%20512%20256.319%20512Z'%20fill='url(%23paint0_linear_893_2592)'/%3e%3cpath%20d='M417.436%20158.291C428.084%20302.507%20335.382%20370.67%20252.277%20377.939C175.014%20384.696%20102.287%20337.221%2095.9067%20264.279C90.6436%20204.017%20127.889%20178.361%20157.152%20175.804C187.249%20173.165%20212.542%20193.921%20214.736%20219.052C216.849%20243.213%20201.773%20254.211%20191.288%20255.126C182.996%20255.853%20172.564%20250.819%20171.622%20240.01C170.814%20230.722%20174.341%20229.457%20173.479%20219.59C171.945%20202.024%20156.627%20199.978%20148.241%20200.705C138.092%20201.594%20119.678%20213.439%20122.262%20242.944C124.86%20272.705%20153.396%20296.221%20190.803%20292.95C231.171%20289.423%20259.276%20257.993%20261.39%20213.91C261.37%20211.575%20261.862%20209.264%20262.83%20207.139L262.843%20207.086C263.278%20206.162%20263.787%20205.275%20264.364%20204.434C265.226%20203.142%20266.33%20201.715%20267.756%20200.153C267.77%20200.113%20267.77%20200.113%20267.797%20200.113C268.833%20198.942%20270.085%20197.677%20271.498%20196.317C289.132%20179.68%20352.638%20140.443%20412.698%20152.867C413.968%20153.139%20415.115%20153.814%20415.969%20154.792C416.823%20155.77%20417.337%20156.997%20417.436%20158.291Z'%20fill='white'/%3e%3c/g%3e%3c/g%3e%3cdefs%3e%3clinearGradient%20id='paint0_linear_893_2592'%20x1='512.013'%20y1='86.519'%20x2='17.5951'%20y2='279.502'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%230CC5FF'/%3e%3cstop%20offset='1'%20stop-color='%23007FFF'/%3e%3c/linearGradient%3e%3cclipPath%20id='clip0_893_2592'%3e%3crect%20width='513'%20height='512'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", Pt = "bitcoin";
class It extends J {
  constructor(c) {
    var u;
    const p = (u = D(c)) == null ? void 0 : u[Pt];
    if (!p)
      throw new Error("imToken Wallet not found");
    super(c, p), w(this, "walletInfo"), w(this, "connectWallet", async () => {
      const a = (await this.bitcoinNetworkProvider.request({
        method: "btc_requestAccounts"
      }))[0], A = await this.bitcoinNetworkProvider.request({
        method: "btc_getPublicKey"
      });
      if (!a || !A)
        throw new Error("Could not connect to imToken Wallet");
      return this.walletInfo = {
        publicKeyHex: A,
        address: a
      }, this;
    }), w(this, "getAddress", async () => (await this.bitcoinNetworkProvider.request({
      method: "btc_requestAccounts"
    }))[0]), w(this, "getPublicKeyHex", async () => {
      if (!this.walletInfo)
        throw new Error("imToken Wallet not connected");
      return this.walletInfo.publicKeyHex;
    }), w(this, "signPsbt", async (a, A) => await this.bitcoinNetworkProvider.request({
      method: "btc_signPsbt",
      params: [a, A]
    })), w(this, "signPsbts", async (a, A) => {
      if (!a && !Array.isArray(a))
        throw new Error("params error");
      return await this.bitcoinNetworkProvider.request({
        method: "btc_signPsbts",
        params: [a, A]
      });
    }), w(this, "getNetwork", async () => await this.bitcoinNetworkProvider.request({
      method: "btc_getNetwork",
      params: []
    })), w(this, "on", (a, A) => {
      var b, F, le, L;
      return a === "accountChanged" ? (F = (b = this.bitcoinNetworkProvider) == null ? void 0 : b.on) == null ? void 0 : F.call(b, "accountsChanged", A) : (L = (le = this.bitcoinNetworkProvider) == null ? void 0 : le.on) == null ? void 0 : L.call(le, a, A);
    }), w(this, "off", (a, A) => {
      var b, F, le, L;
      return a === "accountChanged" ? (F = (b = this.bitcoinNetworkProvider) == null ? void 0 : b.off) == null ? void 0 : F.call(b, "accountsChanged", A) : (L = (le = this.bitcoinNetworkProvider) == null ? void 0 : le.off) == null ? void 0 : L.call(le, a, A);
    }), w(this, "getBalance", async () => {
      var a;
      return await this.getNetwork() === N$2.MAINNET ? await this.bitcoinNetworkProvider.request({
        method: "btc_getBalance",
        params: [(a = this.walletInfo) == null ? void 0 : a.address]
      }) : await super.getBalance();
    });
  }
  async signMessage(c, u = "ecdsa") {
    return await this.bitcoinNetworkProvider.request({
      method: "btc_signMessage",
      params: [c, u]
    });
  }
  async sendBitcoin(c, u) {
    try {
      const p = await this.getAddress(), a = await this.getUtxos(p);
      a.sort((be, He) => be.value - He.value);
      let A = 0;
      const b = [], F = (await this.getNetworkFees()).fastestFee;
      let le = 0;
      for (const be of a)
        if (b.push({
          hash: be.txid,
          index: be.vout,
          witnessUtxo: {
            script: Buffer$f.from(be.scriptPubKey, "hex"),
            value: be.value
          }
        }), A += be.value, le = (b.length * 180 + 2 * 34 + 10) * F, A >= u + le)
          break;
      if (A < u + le)
        throw new Error("1Insufficient funds for the transaction.");
      if (b.length === 0)
        throw new Error("No inputs available for the transaction.");
      const L = A - u - le, pe = new src$j.Psbt({ network: uA(await this.getNetwork()) });
      for (const be of b)
        pe.addInput(be);
      if (pe.addOutput({
        address: c,
        value: u
      }), L > 0) {
        const be = await this.getAddress();
        pe.addOutput({
          address: be,
          value: L
        });
      }
      const $ = await this.signPsbt(pe.toHex()), Ee = src$j.Psbt.fromHex($).extractTransaction();
      return await this.pushTx(Ee.toHex());
    } catch (p) {
      throw p;
    }
  }
  async switchNetwork(c) {
    throw new Error("Method not implemented.");
  }
  getWalletProviderName() {
    return Promise.resolve(HA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(HA.img);
  }
}
const HA = {
  id: "bitcoin_imtoken",
  img: bt,
  name: "imToken",
  chainType: "bitcoin",
  connectProvider: It,
  type: "injected"
};
class aA {
  /**
   * Compute the message hash as specified in the BIP-322.
   * The standard is specified in BIP-340 as:
   *      The function hashtag(x) where tag is a UTF-8 encoded tag name and x is a byte array returns the 32-byte hash SHA256(SHA256(tag) || SHA256(tag) || x).
   * @param message Message to be hashed
   * @returns Hashed message
   */
  static hashMessage(c) {
    const { sha256: u } = src$j.crypto, p = u(this.TAG);
    return u(Buffer$f.concat([p, p, Buffer$f.from(c)]));
  }
  /**
   * Build a to_spend transaction using simple signature in accordance to the BIP-322.
   * @param message Message to be signed using BIP-322
   * @param scriptPublicKey The script public key for the signing wallet
   * @returns Bitcoin transaction that correspond to the to_spend transaction
   */
  static buildToSpendTx(c, u) {
    const p = new src$j.Psbt();
    p.setVersion(0), p.setLocktime(0);
    const a = this.hashMessage(c), A = 0, b = 32, F = new Uint8Array([A, b]), le = new Uint8Array(F.length + a.length);
    return le.set(F), le.set(a, F.length), p.addInput({
      hash: "0".repeat(64),
      // vin[0].prevout.hash = 0000...000
      index: 4294967295,
      // vin[0].prevout.n = 0xFFFFFFFF
      sequence: 0,
      // vin[0].nSequence = 0
      finalScriptSig: Buffer$f.from(le),
      // vin[0].scriptSig = OP_0 PUSH32[ message_hash ]
      witnessScript: Buffer$f.from([])
      // vin[0].scriptWitness = []
    }), p.addOutput({
      value: 0,
      // vout[0].nValue = 0
      script: u
      // vout[0].scriptPubKey = message_challenge
    }), p.extractTransaction();
  }
  /**
   * Build a to_sign transaction using simple signature in accordance to the BIP-322.
   * @param toSpendTxId Transaction ID of the to_spend transaction as constructed by buildToSpendTx
   * @param witnessScript The script public key for the signing wallet, or the redeemScript for P2SH-P2WPKH address
   * @param isRedeemScript Set to true if the provided witnessScript is a redeemScript for P2SH-P2WPKH address, default to false
   * @param tapInternalKey Used to set the taproot internal public key of a taproot signing address when provided, default to undefined
   * @returns Ready-to-be-signed bitcoinjs.Psbt transaction
   */
  static buildToSignTx(c, u, p = !1, a) {
    const A = new src$j.Psbt();
    return A.setVersion(0), A.setLocktime(0), A.addInput({
      hash: c,
      // vin[0].prevout.hash = to_spend.txid
      index: 0,
      // vin[0].prevout.n = 0
      sequence: 0,
      // vin[0].nSequence = 0
      witnessUtxo: {
        script: u,
        value: 0
      }
    }), p && A.updateInput(0, {
      redeemScript: u
    }), a && A.updateInput(0, {
      tapInternalKey: a
    }), A.addOutput({
      value: 0,
      // vout[0].nValue = 0
      script: Buffer$f.from([106])
      // vout[0].scriptPubKey = OP_RETURN
    }), A;
  }
  /**
   * Encode witness stack in a signed BIP-322 PSBT into its base-64 encoded format.
   * @param signedPsbt Signed PSBT
   * @returns Base-64 encoded witness data
   */
  static encodeWitness(c) {
    const u = c.data.inputs[0].finalScriptWitness;
    if (!u)
      throw new Error("Cannot encode empty witness stack.");
    return u.toString("base64");
  }
}
w(aA, "TAG", Buffer$f.from("BIP0322-signed-message"));
const R2 = "data:image/svg+xml,%3csvg%20width='160'%20height='160'%20viewBox='0%200%20160%20160'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M30%2025H90L50%20110H20L30%2025Z'%20fill='black'/%3e%3cpath%20d='M130%20135L70%20135L110%2050L140%2050L130%20135Z'%20fill='%23F5870A'/%3e%3c/svg%3e", m2 = _.default ? _.default : _;
var y2;
const kt = (y2 = q) != null && y2.default ? q.default : q;
class St extends J {
  constructor(c) {
    super(c, {}), w(this, "keystoneWaleltInfo"), w(this, "viewSDK"), w(this, "dataSdk"), w(this, "networkEnv"), w(this, "connectWallet", async () => {
      const u = await (await this.viewSDK.getSdk()).read([SupportedResult.UR_CRYPTO_ACCOUNT], {
        title: "Sync Keystone with Babylon Staking App",
        description: "Please scan the QR code displayed on your Keystone, Currently only the first Taproot Address will be used",
        renderInitial: {
          walletMode: "btc",
          link: "",
          description: [
            "1. Turn on your Keystone 3 with Multi-Coin firmware or BTC only firmware.",
            '2. Click "Connect Software Wallet" and choose "Babylon" or "Sparrow" for connection.',
            '3. Press the "Sync Keystone" button and scan the QR Code displayed on your Keystone hardware wallet',
            "4. The first Taproot address will be used for staking."
          ]
        },
        URTypeErrorMessage: "The scanned QR code is not the sync code from the Keystone hardware wallet. Please verify the code and try again."
      });
      if (u.status === ReadStatus.canceled)
        throw new Error("Connection to Keystone was canceled");
      if (u.status !== ReadStatus.success)
        throw new Error("Error reading QR code, Please try again.");
      const p = this.dataSdk.parseAccount(u.result), a = 3, A = p.keys[a].extendedPublicKey;
      if (this.keystoneWaleltInfo = {
        mfp: p.masterFingerprint,
        extendedPublicKey: A,
        path: p.keys[a].path,
        address: void 0,
        publicKeyHex: void 0,
        scriptPubKeyHex: void 0
      }, !this.keystoneWaleltInfo.extendedPublicKey)
        throw new Error("Could not retrieve the extended public key");
      const b = await this.getNetwork();
      return await this.switchNetwork(b), this;
    }), w(this, "getAddress", async () => {
      var u, p;
      if ((u = this.keystoneWaleltInfo) != null && u.address)
        return (p = this.keystoneWaleltInfo) == null ? void 0 : p.address;
      throw new Error("Could not retrieve the address");
    }), w(this, "getPublicKeyHex", async () => {
      var u, p;
      if ((u = this.keystoneWaleltInfo) != null && u.publicKeyHex)
        return (p = this.keystoneWaleltInfo) == null ? void 0 : p.publicKeyHex;
      throw new Error("Could not retrieve the BTC public key");
    }), w(this, "signPsbt", async (u, p) => {
      var a, A;
      if (!((a = this.keystoneWaleltInfo) != null && a.address) || !((A = this.keystoneWaleltInfo) != null && A.publicKeyHex))
        throw new Error("Keystone Wallet not connected");
      if (!u)
        throw new Error("psbt hex is required");
      let b = src$j.Psbt.fromHex(u);
      b = this.enhancePsbt(b);
      const F = b.toHex();
      return (await this.sign(F)).toHex();
    }), w(this, "signPsbts", async (u, p) => {
      var a, A;
      if (!((a = this.keystoneWaleltInfo) != null && a.address) || !((A = this.keystoneWaleltInfo) != null && A.publicKeyHex))
        throw new Error("Keystone Wallet not connected");
      if (!u && !Array.isArray(u))
        throw new Error("psbts hexes are required");
      const b = [];
      for (const F of u) {
        const le = await this.signPsbt(F);
        b.push(le);
      }
      return b;
    }), w(this, "getNetwork", async () => {
      if (!this.networkEnv)
        throw new Error("Network not set");
      return this.networkEnv;
    }), w(this, "signMessageBIP322", async (u) => {
      const p = Buffer$f.from(this.keystoneWaleltInfo.scriptPubKeyHex, "hex"), a = aA.buildToSpendTx(u, p), A = toXOnly_1(Buffer$f.from(this.keystoneWaleltInfo.publicKeyHex, "hex"));
      let b = aA.buildToSignTx(a.getId(), p, !1, A);
      b.updateInput(0, {
        sighashType: src$j.Transaction.SIGHASH_ALL
      }), b = this.enhancePsbt(b);
      const F = await this.sign(b.toHex());
      return aA.encodeWitness(F);
    }), w(this, "signMessageECDSA", async (u) => {
      if (!this.keystoneWaleltInfo)
        throw new Error("Keystone Wallet not connected");
      const p = this.dataSdk.btc.generateSignRequest({
        requestId: "7afd5e09-9267-43fb-a02e-08c4a09417ec",
        signData: Buffer$f.from(u, "utf-8").toString("hex"),
        dataType: dist$w.KeystoneBitcoinSDK.DataType.message,
        accounts: [
          {
            path: `${this.keystoneWaleltInfo.path}/0/0`,
            xfp: `${this.keystoneWaleltInfo.mfp}`,
            address: this.keystoneWaleltInfo.address
          }
        ],
        origin: "babylon staking app"
      }), a = C2(SupportedResult.UR_BTC_SIGNATURE), A = await this.viewSDK.getSdk(), b = await a(A, p), F = this.dataSdk.btc.parseSignature(b);
      return Buffer$f.from(F.signature, "hex").toString("base64");
    }), w(this, "sign", async (u) => {
      if (!u)
        throw new Error("psbt hex is required");
      const p = this.dataSdk.btc.generatePSBT(Buffer$f.from(u, "hex")), a = C2(SupportedResult.UR_PSBT), A = await this.viewSDK.getSdk(), b = await a(A, p), F = this.dataSdk.btc.parsePSBT(b), le = src$j.Psbt.fromHex(F);
      return le.finalizeAllInputs(), le;
    }), w(this, "enhancePsbt", (u) => {
      var p, a, A, b;
      if (!((p = this.keystoneWaleltInfo) != null && p.scriptPubKeyHex) || !((a = this.keystoneWaleltInfo) != null && a.publicKeyHex) || !((A = this.keystoneWaleltInfo) != null && A.mfp) || !((b = this.keystoneWaleltInfo) != null && b.path))
        throw new Error("Keystone Wallet not connected");
      const F = {
        masterFingerprint: Buffer$f.from(this.keystoneWaleltInfo.mfp, "hex"),
        path: `${this.keystoneWaleltInfo.path}/0/0`,
        pubkey: Buffer$f.from(this.keystoneWaleltInfo.publicKeyHex, "hex")
      };
      return u.data.inputs.forEach((le) => {
        le.tapBip32Derivation = [
          {
            ...F,
            pubkey: toXOnly_1(F.pubkey),
            leafHashes: Et(le, F.pubkey)
          }
        ];
      }), u;
    }), w(this, "on", () => {
    }), w(this, "off", () => {
    }), o2(), m2.bootstrap(), this.viewSDK = m2, this.dataSdk = new kt({
      origin: ""
    }), this.networkEnv = N$2.MAINNET, this.keystoneWaleltInfo = {};
  }
  async signMessage(c, u = "ecdsa") {
    if (u === "bip322-simple")
      return await this.signMessageBIP322(c);
    if (u === "ecdsa")
      return await this.signMessageECDSA(c);
    throw new Error("Unsupported message signing type");
  }
  async switchNetwork(c) {
    this.networkEnv = c;
    const { address: u, pubkeyHex: p, scriptPubKeyHex: a } = xt(
      // @ts-ignore
      this.keystoneWaleltInfo.extendedPublicKey,
      "M/0/0",
      uA(c)
    );
    this.keystoneWaleltInfo.address = u, this.keystoneWaleltInfo.publicKeyHex = p, this.keystoneWaleltInfo.scriptPubKeyHex = a;
  }
  async sendBitcoin(c, u) {
    const p = await this.getAddress(), a = await this.getUtxos(p);
    a.sort((be, He) => be.value - He.value);
    let A = 0;
    const b = [], F = (await this.getNetworkFees()).fastestFee;
    let le = 0;
    for (const be of a)
      if (b.push({
        hash: be.txid,
        index: be.vout,
        witnessUtxo: {
          script: Buffer$f.from(be.scriptPubKey, "hex"),
          value: be.value
        }
      }), A += be.value, le = (b.length * 180 + 2 * 34 + 10) * F, A >= u + le)
        break;
    if (A < u + le)
      throw new Error("1Insufficient funds for the transaction.");
    if (b.length === 0)
      throw new Error("No inputs available for the transaction.");
    const L = A - u - le, pe = new src$j.Psbt({ network: uA(await this.getNetwork()) });
    for (const be of b)
      pe.addInput(be);
    if (pe.addOutput({
      address: c,
      value: u
    }), L > 0) {
      const be = await this.getAddress();
      pe.addOutput({
        address: be,
        value: L
      });
    }
    const $ = await this.signPsbt(pe.toHex()), Ee = src$j.Psbt.fromHex($).extractTransaction();
    return await this.pushTx(Ee.toHex());
  }
  getWalletProviderName() {
    return Promise.resolve(MA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(MA.img);
  }
}
const MA = {
  id: "bitcoin_keystone",
  img: R2,
  name: "Keystone",
  chainType: "bitcoin",
  connectProvider: St,
  type: "qrcode"
}, C2 = (n) => async (c, u) => {
  if (await c.play(u, {
    title: "Scan the QR Code",
    description: "Please scan the QR code with your Keystone device."
  }) !== PlayStatus.success)
    throw new Error("Could not generate the QR code, please try again.");
  const p = await c.read([n], {
    title: "Get the Signature from Keystone",
    description: "Please scan the QR code displayed on your Keystone",
    URTypeErrorMessage: "The scanned QR code can't be read. please verify and try again."
  });
  if (p.status !== ReadStatus.success)
    throw new Error("Could not extract the signature, please try again.");
  return p.result;
}, xt = (n, c, u) => {
  const p = HDKey.fromExtendedKey(n).derive(c), a = Buffer$f.from(p.publicKey), A = toXOnly_1(a), { address: b, output: F } = src$j.payments.p2tr({
    internalPubkey: A,
    network: u
  });
  return {
    address: b,
    pubkeyHex: a.toString("hex"),
    scriptPubKeyHex: F.toString("hex")
  };
}, Et = (n, c) => n.tapInternalKey && !n.tapLeafScript ? [] : (n.tapLeafScript || []).filter((u) => pubkeyInScript_1(c, u.script)).map((u) => {
  const p = bip341.tapleafHash({
    output: u.script,
    version: u.leafVersion
  });
  return Object.assign({ hash: p }, u);
}).map((u) => u.hash), Nt = "data:image/webp;base64,UklGRmIEAABXRUJQVlA4TFUEAAAvL8ALABrJ2ravUzK6old2S8PWbj2p7tYjobtjujvAE/r/flPkev7md13U9ydGPovuticEkgCAZaTM2raND+zevN33eeyZ5yza8byhjFU4jCTbtBUF8PX2XONdnGd8q/8MJEmSMdXlZnbxirRZ9FbIQAMd7bVXPQYda+Y2ufDvyzB0qE74a1f/7WjWNkHHmb5ODvRpUz+3+P5ccqAvQkeZuUMO+Paor1t8BEbDGTsEHaQdvjzy7eJvji9iHDrC9A2ywadbvpz85cWH1SgEb8Yu2eDDJZ8O/nTwh5M/Y7E3ArGt2cxdgqC1BDenuNvZneFWj6k4wykeEkFwpm+S9IMb3+vkef8j/dnkBrAizUJQ2+Zgd4irjV0Z7cntSSbJwDnS188NYfAXBZ4dAKdvhBXvdrHb2G5jGyK2JdfHmVYGzkSRP+3JFRHHxx1it+Lt/J2QAQRaKVOQgUulOTj1ZqWrJFnZ6ok3JstmTJIkp9rqBgMkTyCwShwD0YQMnCrN3qFWC13innh9lIkiUSh1CkTi1FI83lfd7bcSRkC0GUAhAFHSOCKVVu/QK+cEwASXvk+RxFEQAfg/Cce2YCHjs3IQWWr6/LQYmJEKiytaHFkgEp8UQ+2QmeKjnLfSMf+SwG8jvT9Y+OiKZ3ZvSARm6W+16elduVlFISCmTELwYca74ilqCMa8c/IdTN+Dzu/MvDfSft0ZD0+KDogxIZb8Zpse1tdtaiizspg0Bn4ODzLuy/r6N73fZR4S+PKSQTq/mjgbCAs4ou5V0wERpU4BysxkVcxGsVDRSRBmPqu60cVFI+FFE+NflwxCH3XZoF8mVg2kCtgj9qpyK1kUs1FYJFf2k1c5ImajGPp12RBIPpK+C42XjazoSemzRfVxwXrvlJitWZW+PrMsZZ1W5L8e3E+b5b6+qNrLx7aBvk8c34XaSwaWrVF5VDAgHOWaisVmNMm8XdqJItc1TAT3MmbMwLPKTQdWgES+s6LH6UnJsEZQ2grPqoZLWSdW9CMwZyoHAYSHwYOc0aG0exYY2H+SPAko/LFGGS1hfJhXQLQNsEkEd9PKGkajiKVtxwWQ/LPNtv8bZdDiMBV6kFNAFA4zQ1Na7I0ilLQtywQFROoUsODXGKRXYydgDv29rOR6wp20nGGj0Atf0jEYpgDZCXDillSB1VCrxpZhCt3dtETmIDcISQ3t+UdCChQ8vge5ozVEq5BmGLW5kxaIt9MCuCGoiVZ4Ou8agUuEhzfgFaPW19/EbMjL3EsEIxEeWEeLI9VEKpFkaJj8yj1JRaTclTkXCE4i3L+GZkeoiFAg4YP5VldknyFYiXD3HJpsUhKSQ8ghbckRCcgRFIRaHDq+h+Alwj0raLQbBW5aYcPR12Q3x/bQERLh3lXwkePm37F9dIxEuGseDfZZjs8t8Bxab7TPR7bRURLhgQ002KdWfBxutE9su+NyZBeNzmGD2ZE5b2ChYyVCpF4KAgA=";
class Dt extends J {
  constructor(c) {
    var u, p;
    const a = (p = (u = D(c)) == null ? void 0 : u.binancew3w) == null ? void 0 : p.bitcoin;
    if (!a)
      throw new Error("Binance Wallet not found");
    super(c, a), w(this, "connectWallet", async () => {
      const A = (await this.bitcoinNetworkProvider.requestAccounts())[0], b = await this.getPublicKeyHex();
      if (!A || !b)
        throw new Error("Could not connect to imToken Wallet");
      return this;
    }), w(this, "signPsbts", async (A) => {
      throw new Error('Method "signPsbts" not implemented.');
    }), w(this, "on", (A, b) => {
      var F, le, L, pe;
      return A === "accountChanged" ? (le = (F = this.bitcoinNetworkProvider) == null ? void 0 : F.on) == null ? void 0 : le.call(F, "accountsChanged", b) : (pe = (L = this.bitcoinNetworkProvider) == null ? void 0 : L.on) == null ? void 0 : pe.call(L, A, b);
    }), w(this, "off", (A, b) => {
      var F, le;
      return A === "accountChanged" ? (F = this.bitcoinNetworkProvider) == null ? void 0 : F.removeListener("accountsChanged", b) : (le = this.bitcoinNetworkProvider) == null ? void 0 : le.removeListener(A, b);
    }), w(this, "getBalance", async () => await this.bitcoinNetworkProvider.getBalance(await this.getAddress())), o2();
  }
  async sendBitcoin(c, u) {
    const p = await this.getAddress(), a = await this.getUtxos(p);
    a.sort((be, He) => be.value - He.value);
    let A = 0;
    const b = [], F = (await this.getNetworkFees()).fastestFee;
    let le = 0;
    for (const be of a)
      if (b.push({
        hash: be.txid,
        index: be.vout,
        witnessUtxo: {
          script: Buffer$f.from(be.scriptPubKey, "hex"),
          value: be.value
        }
      }), A += be.value, le = (b.length * 180 + 2 * 34 + 10) * F, A >= u + le)
        break;
    if (A < u + le)
      throw new Error("1Insufficient funds for the transaction.");
    if (b.length === 0)
      throw new Error("No inputs available for the transaction.");
    const L = A - u - le, pe = new src$j.Psbt({ network: uA(await this.getNetwork()) });
    for (const be of b)
      pe.addInput(be);
    if (pe.addOutput({
      address: c,
      value: u
    }), L > 0) {
      const be = await this.getAddress();
      pe.addOutput({
        address: be,
        value: L
      });
    }
    const $ = await this.signPsbt(pe.toHex()), Ee = src$j.Psbt.fromHex($).extractTransaction();
    return await this.pushTx(Ee.toHex());
  }
  async switchNetwork(c) {
    await this.bitcoinNetworkProvider.switchNetwork(
      // @ts-ignore
      c.replace("mainnet", "livenet")
    );
  }
  getWalletProviderName() {
    return Promise.resolve(JA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(JA.img);
  }
}
const JA = {
  id: "bitcoin_binance",
  img: Nt,
  name: "Binance",
  chainType: "bitcoin",
  connectProvider: Dt,
  type: "injected"
}, Ft = "https://cosmoshub.validator.network:443";
let z$1 = class extends W2 {
  constructor(c, u) {
    super(c), w(this, "provider"), w(this, "offlineSigner"), w(this, "clientPromise"), this.provider = u;
  }
  async connectWallet() {
    const c = await this.getNetwork();
    return await this.provider.enable(c), this.offlineSigner = this.provider.getOfflineSigner(c), await this.getAddress(), this;
  }
  initSigningStargateClient(c) {
    this.clientPromise = Promise.resolve(c);
  }
  /**
   * get @cosmjs/stargate SigningStargateClient
   */
  async getSigningStargateClient(c) {
    return this.clientPromise || (this.clientPromise = this.createSigningStargateClient(c)), await this.clientPromise;
  }
  async createSigningStargateClient(c) {
    var u, p, a;
    const A = ((a = (p = (u = this.chains) == null ? void 0 : u[0]) == null ? void 0 : p.backendUrls) == null ? void 0 : a.rpcUrl) || Ft;
    if (!this.offlineSigner)
      throw new Error("Offline signer is not initialized");
    return await SigningStargateClient.connectWithSigner(A, this.offlineSigner, c);
  }
  async getBalance(c) {
    const u = await this.getSigningStargateClient();
    return BigInt((await u.getBalance(await this.getAddress(), c)).amount);
  }
  /**
   * Gets the bech32Address of the connected wallet.
   * @returns A promise that resolves to the address of the connected wallet.
   */
  async getAddress() {
    const c = await this.getNetwork();
    return (await this.provider.getKey(c)).bech32Address;
  }
  /**
   * get the chainId of the connected wallet
   */
  async getNetwork() {
    var c, u;
    return (u = (c = this.chains) == null ? void 0 : c[0]) == null ? void 0 : u.network;
  }
  async signAmino(c, u, p) {
    const a = await this.getNetwork();
    if (a !== u.chain_id)
      throw new Error("Unmatched chain id with the offline signer");
    if (await this.getAddress() !== c)
      throw new Error("Unknown signer address");
    return await this.provider.signAmino(a, c, u, p);
  }
  async signArbitrary(c, u) {
    const p = await this.getNetwork();
    return await this.provider.signArbitrary(p, c, u);
  }
  async broadcastTx(c, u, p) {
    return await (await this.getSigningStargateClient()).broadcastTx(c, u, p);
  }
  async getPublicKeyHex() {
    const c = await this.getNetwork(), u = await this.provider.getKey(c);
    return Buffer$1$1.from(u.pubKey).toString("hex");
  }
  async getOfflineSigner() {
    const c = await this.getNetwork();
    return this.provider.getOfflineSigner(c);
  }
  /**
   * Registers an event listener for the specified event.
   * At the moment, only the "accountChanged" event is supported.
   * @param eventName - The name of the event to listen for.
   * @param callBack - The callback function to be executed when the event occurs.
   */
  on(c, u) {
  }
  /**
   * Unregisters an event listener for the specified event.
   * @param eventName - The name of the event to listen for.
   * @param callBack - The callback function to be executed when the event occurs.
   */
  off(c, u) {
  }
};
const O2 = "data:image/png;base64,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", Ht = "keplr";
class Mt extends z$1 {
  constructor(c) {
    const u = D(c)[Ht];
    if (!u)
      throw new Error("Keplr Wallet extension not found");
    super(c, u);
  }
  async init() {
    const c = await build$6.Keplr.getKeplr();
    if (!c)
      throw new Error("Keplr Wallet extension not found");
    this.provider = c;
  }
  getWalletProviderName() {
    return Promise.resolve(QA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(QA.img);
  }
  on(c, u) {
    c === "accountChanged" && window.addEventListener("keplr_keystorechange", u);
  }
  off(c, u) {
    c === "accountChanged" && window.removeEventListener("keplr_keystorechange", u);
  }
}
const QA = {
  id: "cosmos_keplr",
  img: O2,
  name: "Keplr",
  chainType: "cosmos",
  connectProvider: Mt,
  type: "extension"
};
class Jt extends z$1 {
  constructor(c) {
    var u;
    const p = (u = D(c).okxwallet) == null ? void 0 : u.keplr;
    if (!p)
      throw new Error("OKX Wallet extension not found");
    super(c, p);
  }
  getWalletProviderName() {
    return Promise.resolve(TA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(TA.img);
  }
  on(c, u) {
    c === "accountChanged" && window.addEventListener("okx_keystorechange", u);
  }
  off(c, u) {
    c === "accountChanged" && window.removeEventListener("okx_keystorechange", u);
  }
}
const TA = {
  id: "cosmos_okx",
  img: K2,
  name: "OKX",
  chainType: "cosmos",
  connectProvider: Jt,
  type: "extension"
}, Z2 = "data:image/x-icon;base64,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";
class Qt extends z$1 {
  constructor(c) {
    var u, p;
    const a = (p = (u = D(c).cosmostation) == null ? void 0 : u.providers) == null ? void 0 : p.keplr;
    if (!a)
      throw new Error("Cosmostation Wallet extension not found");
    super(c, a);
  }
  getWalletProviderName() {
    return Promise.resolve(LA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(LA.img);
  }
  on(c, u) {
    c === "accountChanged" && window.addEventListener("cosmostation_keystorechange", u);
  }
  off(c, u) {
    c === "accountChanged" && window.removeEventListener("cosmostation_keystorechange", u);
  }
}
const LA = {
  id: "cosmos_cosmostation",
  img: Z2,
  name: "Cosmostation",
  chainType: "cosmos",
  connectProvider: Qt,
  type: "extension"
}, V2 = "data:image/png;base64,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";
class Tt extends z$1 {
  constructor(c) {
    const u = D(c).leap;
    if (!u)
      throw new Error("OKX Wallet extension not found");
    super(c, u);
  }
  getWalletProviderName() {
    return Promise.resolve(WA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(WA.img);
  }
  on(c, u) {
    c === "accountChanged" && window.addEventListener("leap_keystorechange", u);
  }
  off(c, u) {
    c === "accountChanged" && window.removeEventListener("leap_keystorechange", u);
  }
}
const WA = {
  id: "cosmos_leap",
  img: V2,
  name: "Leap",
  chainType: "cosmos",
  connectProvider: Tt,
  type: "extension"
};
class Lt extends z$1 {
  constructor(c) {
    var u;
    const p = (u = D(c).$onekey) == null ? void 0 : u.cosmos;
    if (!p)
      throw new Error("OneKey Wallet extension not found");
    super(c, p);
  }
  getWalletProviderName() {
    return Promise.resolve(zA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(zA.img);
  }
  on(c, u) {
    c === "accountChanged" && window.addEventListener("keplr_keystorechange", u);
  }
  off(c, u) {
    c === "accountChanged" && window.removeEventListener("keplr_keystorechange", u);
  }
}
const zA = {
  id: "cosmos_onekey",
  img: Y2,
  name: "OneKey",
  chainType: "cosmos",
  connectProvider: Lt,
  type: "extension"
}, Wt = "data:image/svg+xml,%3csvg%20width='57'%20height='54'%20viewBox='0%200%2018%2017'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cmask%20id='mask0_2982_13847'%20maskUnits='userSpaceOnUse'%20x='0'%20y='0'%20width='18'%20height='17'%20style='mask-type:%20luminance;'%3e%3cpath%20d='M18%200H0V17H18V0Z'%20fill='white'%3e%3c/path%3e%3c/mask%3e%3cg%20mask='url(%23mask0_2982_13847)'%3e%3cpath%20d='M4.07466%205.38463C3.65195%206.2559%203.70642%207.22272%204.16617%207.79598C4.07015%207.05094%204.19885%206.29317%204.53441%205.62804C4.85575%204.95394%205.3666%204.39837%205.99864%204.03564H5.91802C5.20769%204.04247%204.47122%204.58616%204.07466%205.38463Z'%20fill='%23075CEE'%3e%3c/path%3e%3cpath%20d='M15.4461%209.60666C15.4701%208.54658%2015.0343%207.58886%2014.215%207.14754L13.6115%206.82451L9.68944%204.74984L8.15113%203.93317C7.6609%203.68664%207.10087%203.63723%206.57796%203.7944L4.33585%202.60693C3.33791%202.08144%202.02622%202.7002%201.40523%203.97184C0.784235%205.24349%201.08928%206.72669%202.07851%207.25218C2.09022%207.25958%202.10264%207.26567%202.11555%207.27038L4.32714%208.45331C4.51535%208.98189%204.88716%209.41716%205.36866%209.67263C5.37775%209.67657%205.38792%209.67657%205.39699%209.67263L11.4282%2012.8574C12.254%2013.2988%2013.252%2013.1008%2014.0429%2012.4434L14.86%2012.8756L16.2523%2010.0048L15.4352%209.59074L15.4461%209.60666Z'%20fill='%23075CEE'%3e%3c/path%3e%3cpath%20d='M2.49267%2012.1887L6.34935%2014.3316L3.89589%2016.9545C3.88034%2016.9745%203.85892%2016.9887%203.83493%2016.9949C3.81094%2017.001%203.78566%2016.9988%203.76298%2016.9886H3.75209L0.0653596%2015.014C0.0358593%2014.9971%200.0138623%2014.9689%200.00408632%2014.9353C-0.00568966%2014.9017%20-0.00246613%2014.8655%200.0130656%2014.8343C0.0185887%2014.823%200.0251569%2014.8124%200.0326759%2014.8025L2.49267%2012.1887ZM5.61288%208.87191C5.62844%208.85187%205.64983%208.83768%205.67384%208.83151C5.69783%208.82537%205.72311%208.82755%205.74579%208.83779H5.75669L9.44123%2010.7987C9.45644%2010.8064%209.46999%2010.8172%209.48106%2010.8306C9.4921%2010.8439%209.50045%2010.8595%209.50555%2010.8763C9.51065%2010.8931%209.51241%2010.9109%209.51071%2010.9284C9.50901%2010.946%209.50392%2010.963%209.4957%2010.9784L9.48045%2011.0035V11.0148L6.61954%2014.0654L2.75414%2011.9157L5.61288%208.87191ZM14.6902%2011.0103C15.0759%2010.2141%2015.7797%209.77958%2016.2699%2010.0366C16.7602%2010.2937%2016.8386%2011.149%2016.453%2011.943C16.0673%2012.7369%2015.3635%2013.1737%2014.8733%2012.9166C14.383%2012.6595%2014.3024%2011.7974%2014.6902%2011.0035V11.0103ZM5.91793%203.65794C6.14198%203.65435%206.36441%203.69846%206.5716%203.78761C6.39258%203.84141%206.21894%203.91302%206.05302%204.00145L5.99637%204.0333H5.91575C5.20542%204.0333%204.46895%204.58609%204.07239%205.38456C3.64968%206.25583%203.70415%207.22264%204.1639%207.79591C4.19667%208.01341%204.25071%208.22683%204.32514%208.43287C3.41653%207.86188%203.16596%206.45374%203.75862%205.21395C4.22709%204.24941%205.08994%203.65794%205.91793%203.65794ZM11.2584%203.07558L15.1129%205.23214L13.6117%206.82454L9.68962%204.74988L11.2584%203.07558ZM14.0976%200.0431891C14.1119%200.021571%2014.1328%200.00558169%2014.1569%20-0.00224709C14.181%20-0.0100758%2014.2069%20-0.00929676%2014.2305%20-3.31039e-05L17.9281%201.97682C17.9583%201.99296%2017.9815%202.02058%2017.9928%202.054C18.0042%202.08742%2018.0029%202.12411%2017.9891%202.15653C17.9836%202.16779%2017.977%202.17846%2017.9695%202.18838L15.3831%204.94324L11.5177%202.7935L14.0976%200.0431891Z'%20fill='%2388B2FB'%3e%3c/path%3e%3c/g%3e%3c/svg%3e";
class zt extends z$1 {
  constructor(c) {
    var u;
    const p = (u = D(c).station) == null ? void 0 : u.keplr;
    if (!p)
      throw new Error("Station Wallet extension not found");
    super(c, p);
  }
  getWalletProviderName() {
    return Promise.resolve(KA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(KA.img);
  }
}
const KA = {
  id: "cosmos_station",
  img: Wt,
  name: "Station",
  chainType: "cosmos",
  connectProvider: zt,
  type: "extension"
}, j2 = "data:image/svg+xml,%3csvg%20width='44'%20height='44'%20viewBox='0%200%2044%2044'%20fill='%233173FA'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M22.01376%200c11.54538.00706%2021.00722%208.90338%2021.91609%2020.21383a.30206.30206%200%2001-.2706.32468l-.03146.00154h-1.25892c-.1564%200-.28503-.11886-.3005-.27117l-.00156-.03089v-1.66267c0-.06673-.04868-.12209-.11247-.13249l-.02178-.00176h-1.57004c-.06672%200-.12208.04869-.13249.11248l-.00175.02177V20.238c0%20.1564-.11886.28503-.27118.3005l-.03088.00156h-.91826c-.1564%200-.28504-.11886-.3005-.27117l-.00156-.03089v-1.66267c0-.06673-.04869-.12209-.11248-.13249l-.02177-.00176h-1.57071c-.06673%200-.12209.04869-.1325.11248l-.00175.02177V20.238c0%20.1564-.11886.28503-.27118.3005l-.03088.00156H30.1207c-.53353-.00063-1.00676-.3427-1.17468-.84912-.96357-2.8991-3.69184-4.99305-6.91146-5.00714-1.94706-.01596-3.8196.74761-5.2003%202.12056s-2.1548%203.24115-2.1498%205.18827c-.00404%204.04424%203.2733%207.32394%207.31654%207.32394%203.23103%200%205.97272-2.09428%206.942-4.99942.16138-.49215.60957-.8311%201.1231-.85575l.05527-.00143h13.50507a.30206.30206%200%2001.30206.3269C43.01897%2035.10132%2033.54874%2044%2022%2044%209.84982%2044%200%2034.14615%200%2022.00034%200%209.85453%209.86795-.00738%2022.01376%200z'%3e%3c/path%3e%3c/svg%3e";
class Kt extends J {
  constructor(c) {
    const u = D(c).cactuslink;
    if (!u)
      throw new Error("Cactus Link Wallet extension not found");
    super(c, u), w(this, "signPsbt", async (p, a) => await this.bitcoinNetworkProvider.signPsbt(p, a || {
      autoFinalized: !0
    })), w(this, "signPsbts", async (p, a) => {
      const A = a || p.map((b) => ({
        autoFinalized: !0
      }));
      return await this.bitcoinNetworkProvider.signPsbts(p, A);
    }), w(this, "on", (p, a) => {
      var A, b, F, le;
      return p === "accountChanged" ? (b = (A = this.bitcoinNetworkProvider) == null ? void 0 : A.on) == null ? void 0 : b.call(A, "accountsChanged", a) : (le = (F = this.bitcoinNetworkProvider) == null ? void 0 : F.on) == null ? void 0 : le.call(F, p, a);
    }), w(this, "off", (p, a) => {
      var A, b, F, le;
      return p === "accountChanged" ? (b = (A = this.bitcoinNetworkProvider) == null ? void 0 : A.off) == null ? void 0 : b.call(A, "accountsChanged", a) : (le = (F = this.bitcoinNetworkProvider) == null ? void 0 : F.off) == null ? void 0 : le.call(F, p, a);
    });
  }
  async connectWallet() {
    var c;
    await this.getNetwork();
    try {
      await this.bitcoinNetworkProvider.requestAccounts();
    } catch (a) {
      throw (c = a == null ? void 0 : a.message) != null && c.includes("rejected") ? new Error("Connection to Cactus Link Wallet was rejected") : new Error(a == null ? void 0 : a.message);
    }
    const u = await this.getAddress(), p = await this.getPublicKeyHex();
    if (!u || !p)
      throw new Error("Could not connect to Cactus Link Wallet");
    return this;
  }
  getWalletProviderName() {
    return Promise.resolve(UA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(UA.img);
  }
}
const UA = {
  id: "bitcoin_cactuslink",
  img: j2,
  name: "Cactus Link",
  chainType: "bitcoin",
  connectProvider: Kt,
  type: "extension"
}, Ut = "leapBitcoin";
class Xt extends J {
  constructor(c) {
    var u;
    const p = (u = D(c)) == null ? void 0 : u[Ut];
    if (!p)
      throw new Error("Leap Wallet extension not found");
    super(c, p), w(this, "connectWallet", async () => {
      const a = (await this.bitcoinNetworkProvider.requestAccounts())[0], A = await this.getPublicKeyHex();
      if (!a || !A)
        throw new Error("Could not connect to Leap Wallet");
      return this;
    });
  }
  getWalletProviderIcon() {
    return Promise.resolve(XA.img);
  }
  getWalletProviderName() {
    return Promise.resolve(XA.name);
  }
}
const XA = {
  id: "bitcoin_leap",
  img: V2,
  name: "Leap",
  chainType: "bitcoin",
  connectProvider: Xt,
  type: "extension"
};
class Gt extends J {
  constructor(c) {
    var u;
    const p = (u = D(c).cosmostation) == null ? void 0 : u.bitcoin;
    if (!p)
      throw new Error("Cosmostation Wallet extension not found");
    super(c, p), w(this, "connectWallet", async () => {
      if (!this.bitcoinNetworkProvider)
        throw new Error("Cosmostation Wallet extension not found");
      let a = null, A = null;
      try {
        if (a = await this.bitcoinNetworkProvider.connectWallet(), A = await this.bitcoinNetworkProvider.getPublicKey(), !a || a.length === 0 || !A)
          throw new Error("BTC is not enabled in Cosmostation Wallet");
        return this;
      } catch {
        throw new Error("BTC is not enabled in Cosmostation Wallet");
      }
    }), w(this, "getBalance", async () => await this.bitcoinNetworkProvider.getBalance()), w(this, "pushTx", async (a) => await this.bitcoinNetworkProvider.pushTx(a)), w(this, "getNetwork", async () => await this.bitcoinNetworkProvider.getNetwork());
  }
  async switchNetwork(c) {
    return await this.bitcoinNetworkProvider.switchNetwork(c);
  }
  async getPublicKeyHex() {
    return await this.bitcoinNetworkProvider.getPublicKey();
  }
  getWalletProviderName() {
    return Promise.resolve(GA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(GA.img);
  }
}
const GA = {
  id: "bitcoin_cosmostation",
  img: Z2,
  name: "Cosmostation",
  chainType: "bitcoin",
  connectProvider: Gt,
  type: "extension"
};
class Yt extends z$1 {
  constructor(c) {
    var u;
    const p = (u = D(c).bitkeep) == null ? void 0 : u.keplr;
    if (!p)
      throw new Error("Bitget Wallet extension not found");
    super(c, p);
  }
  getWalletProviderName() {
    return Promise.resolve(YA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(YA.img);
  }
  on(c, u) {
    c === "accountChanged" && window.addEventListener("bitget_keystorechange", u);
  }
  off(c, u) {
    c === "accountChanged" && window.removeEventListener("bitget_keystorechange", u);
  }
}
const YA = {
  id: "cosmos_bitget",
  img: G2,
  name: "Bitget Wallet",
  chainType: "cosmos",
  connectProvider: Yt,
  type: "extension"
};
class Rt extends z$1 {
  constructor(c) {
    var u, p;
    const a = (p = (u = D(c)) == null ? void 0 : u.unisat_wallet) == null ? void 0 : p.keplr;
    if (!a)
      throw new Error("UniSat Wallet extension not found");
    super(c, a);
  }
  getWalletProviderName() {
    return Promise.resolve(RA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(RA.img);
  }
  on(c, u) {
    var p, a;
    if (c === "accountChanged") {
      const A = (p = D(this.option)) == null ? void 0 : p.unisat;
      (a = A == null ? void 0 : A.on) == null || a.call(A, "accountsChanged", u);
    }
  }
  off(c, u) {
    var p, a;
    if (c === "accountChanged") {
      const A = (p = D(this.option)) == null ? void 0 : p.unisat;
      (a = A == null ? void 0 : A.on) == null || a.call(A, "accountsChanged", u);
    }
  }
}
const RA = {
  id: "cosmos_unisat",
  img: U2,
  name: "Unisat",
  chainType: "cosmos",
  connectProvider: Rt,
  type: "extension"
}, Ot = "data:image/png;base64,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";
class Zt extends J {
  constructor(c) {
    var u;
    const p = D(c), a = (u = p == null ? void 0 : p.XverseProviders) == null ? void 0 : u.BitcoinProvider;
    if (!a)
      throw new Error("Xverse Wallet extension not found");
    super(c, a), w(this, "getConnectionInfo", async () => {
      var A;
      const b = await this.request("getAddresses", {
        purposes: ["ordinals"]
      });
      if (!((A = b.addresses) != null && A.length))
        throw new Error("Failed to connect to Xverse Wallet");
      return b.addresses[0];
    }), w(this, "connectWallet", async () => {
      var A;
      try {
        if (!(await this.request("wallet_getCurrentPermissions")).length)
          throw new Error("No permissions found.");
        return this;
      } catch {
        const b = await this.request("wallet_connect");
        if (!((A = b.addresses) != null && A.length) || !b.addresses.some((F) => F.purpose === "ordinals"))
          throw new Error("Failed to connect to Xverse Wallet");
        return this;
      }
    }), w(this, "getBalance", async () => (await this.request("getBalance", void 0)).confirmed), w(this, "signPsbt", async (A, b) => {
      if (!A)
        throw new Error("psbt hex is required");
      const F = {
        curNetwork: await this.getNetwork(),
        curAddress: await this.getAddress(),
        curPublicKey: await this.getPublicKeyHex()
      };
      if (!F.curAddress)
        throw new Error("Wallet not connected");
      try {
        const { psbtBase64: le, toSignInputs: L } = this.getSignPsbtDefaultOptions(A, F), pe = await this.request("signPsbt", {
          psbt: le,
          signInputs: L
        }), $ = src$j.Psbt.fromBase64(pe.psbt);
        return $.finalizeAllInputs(), $.toHex();
      } catch (le) {
        throw console.error("signPsbt error", le), le;
      }
    }), w(this, "signPsbts", async (A, b) => {
      if (!A && !Array.isArray(A))
        throw new Error("psbts hexes are required");
      const F = {
        curNetwork: await this.getNetwork(),
        curAddress: await this.getAddress(),
        curPublicKey: await this.getPublicKeyHex()
      };
      if (!F.curAddress)
        throw new Error("Unisat Wallet not connected");
      try {
        const le = A.map((L) => {
          const { psbtBase64: pe, toSignInputs: $ } = this.getSignPsbtDefaultOptions(L, F);
          return {
            psbtBase64: pe,
            signingIndexes: $
            // sigHash: btc.SignatureHash.SINGLE
          };
        });
        return await this.bitcoinNetworkProvider.signMultipleTransactions(lib$1.createUnsecuredToken({
          payload: {
            network: {
              type: F.curNetwork
            },
            message: "Sign Transaction",
            psbts: le
          }
        }));
      } catch (le) {
        throw console.error("signPsbts error", le), le;
      }
    });
  }
  // async requestAccounts() {
  //   await this.connectWallet()
  //   return await this.getAccounts()
  // }
  //
  // async getAccounts() {
  //   return [await this.getAddress()]
  // }
  // async getPublicKey() {
  //   return this.getPublicKeyHex()
  // }
  async request(c, u) {
    var p;
    const a = await this.bitcoinNetworkProvider.request(c, u || null);
    if (a.error)
      throw new Error((p = a.error) == null ? void 0 : p.message);
    if (a.result === void 0)
      throw new Error("Received unknown response from provider.");
    return a.result;
  }
  async getAddress() {
    return (await this.getConnectionInfo()).address;
  }
  async getPublicKeyHex() {
    const c = (await this.getConnectionInfo()).publicKey;
    return c.length === 64 ? "03" + c : c;
  }
  async switchNetwork(c) {
    throw new Error(`please use the Xverse wallet extension to switch networks: ${c}`);
  }
  async getNetwork() {
    const c = await this.getAddress();
    if (c.startsWith("bc1"))
      return N$2.MAINNET;
    if (c.startsWith("tb1"))
      return N$2.SIGNET;
    throw new Error("Unknown network");
  }
  async sendBitcoin(c, u) {
    const p = await this.request("sendTransfer", {
      recipients: [
        {
          address: c,
          amount: u
        }
      ]
    });
    return p == null ? void 0 : p.txid;
  }
  async signMessage(c, u = "ecdsa") {
    return (await this.request("signMessage", {
      address: await this.getAddress(),
      message: c,
      protocol: u === "bip322-simple" ? "BIP322" : "ECDSA"
    })).signature;
  }
  getSignPsbtDefaultOptions(c, u) {
    const p = src$j.Psbt.fromHex(c), { curNetwork: a, curPublicKey: A, curAddress: b } = u, F = {
      [b]: []
    };
    return p.data.inputs.forEach((le, L) => {
      if (le.witnessUtxo && le.witnessUtxo.script) {
        let pe = src$j.networks.bitcoin;
        (a === N$2.TESTNET || a === N$2.SIGNET) && (pe = src$j.networks.testnet);
        let $;
        try {
          $ = src$j.address.fromOutputScript(le.witnessUtxo.script, pe);
        } catch (Ee) {
          if (Ee instanceof Error && Ee.message.toLowerCase().includes("has no matching address"))
            $ = src$j.address.fromOutputScript(le.witnessUtxo.script, pe);
          else
            throw new Error(Ee);
        }
        $.indexOf("tb1p") === 0 || $.indexOf("bc1p");
      }
      le.finalScriptSig || le.finalScriptWitness || F[b].push(L);
    }), {
      psbtBase64: p.toBase64(),
      toSignInputs: F
    };
  }
  getWalletProviderName() {
    return Promise.resolve(OA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(OA.img);
  }
}
const OA = {
  id: "bitcoin_xverse",
  img: Ot,
  name: "Xverse",
  chainType: "bitcoin",
  connectProvider: Zt,
  type: "extension"
}, Vt = "bitcoin_keplr";
class jt extends J {
  constructor(c) {
    var u;
    const p = (u = D(c)) == null ? void 0 : u[Vt];
    if (!p)
      throw new Error("Keplr Wallet extension not found");
    super(c, p), w(this, "connectWallet", async () => {
      if (!this.bitcoinNetworkProvider)
        throw new Error("Keplr Wallet extension not found");
      let a = null, A = null;
      try {
        if (a = await this.bitcoinNetworkProvider.connectWallet(), A = await this.bitcoinNetworkProvider.getPublicKey(), !a || a.length === 0 || !A)
          throw new Error("BTC is not enabled in Keplr Wallet");
      } catch {
        throw new Error("BTC is not enabled in Keplr Wallet");
      }
      return this;
    }), w(this, "getBalance", async () => (await this.bitcoinNetworkProvider.getBalance()).confirmed), w(this, "pushTx", async (a) => await this.bitcoinNetworkProvider.pushTx(a));
  }
  async switchNetwork(c) {
    return await this.bitcoinNetworkProvider.switchNetwork(c.replace("mainnet", "livenet"));
  }
  async getNetwork() {
    return (await this.bitcoinNetworkProvider.getNetwork()).replace("livenet", "mainnet");
  }
  getWalletProviderName() {
    return Promise.resolve(ZA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(ZA.img);
  }
}
const ZA = {
  id: "bitcoin_keplr",
  img: O2,
  name: "Keplr",
  chainType: "bitcoin",
  connectProvider: jt,
  type: "extension"
};
var rA = {};
Object.defineProperty(rA, "__esModule", { value: !0 });
rA.bech32m = VA = rA.bech32 = void 0;
const fA = "qpzry9x8gf2tvdw0s3jn54khce6mua7l", q2 = {};
for (let n = 0; n < fA.length; n++) {
  const c = fA.charAt(n);
  q2[c] = n;
}
function AA(n) {
  const c = n >> 25;
  return (n & 33554431) << 5 ^ -(c >> 0 & 1) & 996825010 ^ -(c >> 1 & 1) & 642813549 ^ -(c >> 2 & 1) & 513874426 ^ -(c >> 3 & 1) & 1027748829 ^ -(c >> 4 & 1) & 705979059;
}
function v2(n) {
  let c = 1;
  for (let u = 0; u < n.length; ++u) {
    const p = n.charCodeAt(u);
    if (p < 33 || p > 126)
      return "Invalid prefix (" + n + ")";
    c = AA(c) ^ p >> 5;
  }
  c = AA(c);
  for (let u = 0; u < n.length; ++u) {
    const p = n.charCodeAt(u);
    c = AA(c) ^ p & 31;
  }
  return c;
}
function c2(n, c, u, p) {
  let a = 0, A = 0;
  const b = (1 << u) - 1, F = [];
  for (let le = 0; le < n.length; ++le)
    for (a = a << c | n[le], A += c; A >= u; )
      A -= u, F.push(a >> A & b);
  if (p)
    A > 0 && F.push(a << u - A & b);
  else {
    if (A >= c)
      return "Excess padding";
    if (a << u - A & b)
      return "Non-zero padding";
  }
  return F;
}
function qt(n) {
  return c2(n, 8, 5, !0);
}
function _t(n) {
  const c = c2(n, 5, 8, !1);
  if (Array.isArray(c))
    return c;
}
function $t(n) {
  const c = c2(n, 5, 8, !1);
  if (Array.isArray(c))
    return c;
  throw new Error(c);
}
function _2(n) {
  let c;
  n === "bech32" ? c = 1 : c = 734539939;
  function u(b, F, le) {
    if (le = le || 90, b.length + 7 + F.length > le)
      throw new TypeError("Exceeds length limit");
    b = b.toLowerCase();
    let L = v2(b);
    if (typeof L == "string")
      throw new Error(L);
    let pe = b + "1";
    for (let $ = 0; $ < F.length; ++$) {
      const Ee = F[$];
      if (Ee >> 5)
        throw new Error("Non 5-bit word");
      L = AA(L) ^ Ee, pe += fA.charAt(Ee);
    }
    for (let $ = 0; $ < 6; ++$)
      L = AA(L);
    L ^= c;
    for (let $ = 0; $ < 6; ++$) {
      const Ee = L >> (5 - $) * 5 & 31;
      pe += fA.charAt(Ee);
    }
    return pe;
  }
  function p(b, F) {
    if (F = F || 90, b.length < 8)
      return b + " too short";
    if (b.length > F)
      return "Exceeds length limit";
    const le = b.toLowerCase(), L = b.toUpperCase();
    if (b !== le && b !== L)
      return "Mixed-case string " + b;
    b = le;
    const pe = b.lastIndexOf("1");
    if (pe === -1)
      return "No separator character for " + b;
    if (pe === 0)
      return "Missing prefix for " + b;
    const $ = b.slice(0, pe), Ee = b.slice(pe + 1);
    if (Ee.length < 6)
      return "Data too short";
    let be = v2($);
    if (typeof be == "string")
      return be;
    const He = [];
    for (let Pe = 0; Pe < Ee.length; ++Pe) {
      const nr = Ee.charAt(Pe), ir = q2[nr];
      if (ir === void 0)
        return "Unknown character " + nr;
      be = AA(be) ^ ir, !(Pe + 6 >= Ee.length) && He.push(ir);
    }
    return be !== c ? "Invalid checksum for " + b : { prefix: $, words: He };
  }
  function a(b, F) {
    const le = p(b, F);
    if (typeof le == "object")
      return le;
  }
  function A(b, F) {
    const le = p(b, F);
    if (typeof le == "object")
      return le;
    throw new Error(le);
  }
  return {
    decodeUnsafe: a,
    decode: A,
    encode: u,
    toWords: qt,
    fromWordsUnsafe: _t,
    fromWords: $t
  };
}
var VA = rA.bech32 = _2("bech32");
rA.bech32m = _2("bech32m");
const A0 = _.default ? _.default : _;
var B2;
const e0 = (B2 = q) != null && B2.default ? q.default : q;
class t0 {
  constructor(c) {
    w(this, "viewSDK"), w(this, "dataSdk"), w(this, "account"), w(this, "publicKey"), w(this, "chains"), w(this, "xfp"), this.chains = c, this.viewSDK = A0, this.dataSdk = new e0({
      origin: ""
    });
  }
  async enable(c) {
    const u = Array.isArray(c) ? c[0] : c;
    if (!this.chains.find((F) => F.network === u))
      throw new Error(`ChainId ${u} not found`);
    const p = await (await this.viewSDK.getSdk()).read([SupportedResult.UR_CRYPTO_MULTI_ACCOUNTS], {
      title: "Sync Keystone with Babylon Staking App",
      description: "Please scan the QR code displayed on your Keystone",
      renderInitial: {
        walletMode: "cosmos",
        link: "",
        description: [
          "1. Version M-9.0 (Multi-Coin) or newer running on your Keystone Essential or Pro. ",
          '2. Click connect software wallet and use "Keplr" for connection.',
          '3. Press the "Sync Keystone" button and scan the QR Code displayed on your Keystone hardware wallet'
        ]
      },
      URTypeErrorMessage: "The scanned QR code can't be read. please verify and try again."
    }), a = this.dataSdk.parseMultiAccounts(p.result), A = a.keys.find((F) => F.chain === "ATOM");
    if (!A)
      throw new Error("Keystone does not support the Cosmos network.");
    const b = Buffer$f.from(A.publicKey, "hex");
    this.account = A, this.publicKey = b, this.xfp = a.masterFingerprint;
  }
  async getKey(c) {
    var u, p;
    if (!this.publicKey)
      throw new Error("Keystone Wallet not connected");
    const a = this.chains.find((F) => F.network === c);
    if (!a)
      throw new Error(`ChainId ${c} not found`);
    const A = (p = (u = a.modularData) == null ? void 0 : u.bech32Config) == null ? void 0 : p.bech32PrefixAccAddr;
    if (!A)
      throw new Error("chain.modularData.Bech32Config not specified");
    const b = VA.encode(A, VA.toWords(this.getRipemd160()));
    return {
      name: "Keystone",
      algo: "secp256k1",
      address: this.getRipemd160(),
      pubKey: new Uint8Array(this.publicKey),
      bech32Address: b,
      isNanoLedger: !1,
      isKeystone: !0
    };
  }
  getRipemd160() {
    if (!this.publicKey)
      throw new Error("Keystone Wallet not connected");
    const c = build$4.sha256(this.publicKey);
    return build$4.ripemd160(c);
  }
  getOfflineSigner(c, u) {
    return {
      getAccounts: async () => [await this.getKey(c)].map((p) => ({
        address: p.bech32Address,
        pubkey: p.pubKey,
        algo: p.algo
      })),
      signAmino: this.signAmino.bind(this, c),
      signDirect: async (p, a) => {
        var A, b;
        if (!this.publicKey)
          throw new Error("Keystone Wallet not connected");
        const F = {
          ...a,
          accountNumber: a.accountNumber.toString()
        }, le = {
          requestId: "7AFD5E09-9267-43FB-A02E-08C4A09417EC",
          signData: Buffer$f.from(i0(F)).toString("hex"),
          dataType: dist$w.KeystoneCosmosSDK.DataType.direct,
          accounts: [
            {
              path: (A = this.account) == null ? void 0 : A.path,
              xfp: this.xfp,
              address: (await this.getKey(c)).bech32Address
            }
          ]
        }, L = this.dataSdk.cosmos.generateSignRequest(le), pe = b2(SupportedResult.UR_COSMOS_SIGNATURE), $ = await this.viewSDK.getSdk(), Ee = await pe($, L), be = this.dataSdk.cosmos.parseSignature(Ee);
        if (be.publicKey !== ((b = this.publicKey) == null ? void 0 : b.toString("hex")))
          throw new Error("Public key mismatch");
        return {
          signed: {
            ...a,
            accountNumber: new Long(Number(a.accountNumber))
          },
          signature: P2(this.publicKey, Buffer$f.from(be.signature, "hex"))
        };
      }
    };
  }
  async signAmino(c, u, p, a) {
    var A;
    if (!this.publicKey)
      throw new Error("Keystone Wallet not connected");
    const b = Buffer$f.from(s0(p)).toString("hex"), F = this.dataSdk.cosmos.generateSignRequest({
      requestId: "7AFD5E09-9267-43FB-A02E-08C4A09417EC",
      signData: b,
      dataType: dist$w.KeystoneCosmosSDK.DataType.amino,
      accounts: [
        {
          path: this.account.path,
          xfp: this.xfp,
          address: (await this.getKey(c)).bech32Address
        }
      ]
    }), le = b2(SupportedResult.UR_COSMOS_SIGNATURE), L = await this.viewSDK.getSdk(), pe = await le(L, F), $ = this.dataSdk.cosmos.parseSignature(pe);
    if ($.publicKey !== ((A = this.publicKey) == null ? void 0 : A.toString("hex")))
      throw new Error("Public key mismatch");
    return {
      signed: p,
      signature: P2(this.publicKey, Buffer$f.from($.signature, "hex"))
    };
  }
  async signArbitrary(c, u, p) {
    throw new Error("signArbitrary not supported yet");
  }
  async sendTx(c, u, p) {
    throw new Error("sendTx not implemented");
  }
}
function jA(n) {
  if (typeof n != "object" || n === null)
    return n;
  if (Array.isArray(n))
    return n.map(jA);
  const c = Object.keys(n).sort(), u = {};
  return c.forEach((p) => {
    u[p] = jA(n[p]);
  }), u;
}
function n0(n) {
  return JSON.stringify(jA(n));
}
function r0(n) {
  return n.replace(/</g, "\\u003c").replace(/>/g, "\\u003e").replace(/&/g, "\\u0026");
}
function s0(n) {
  return Buffer$f.from(r0(n0(n)));
}
const b2 = (n) => async (c, u) => {
  if (await c.play(u, {
    title: "Scan the QR Code",
    description: "Please scan the QR code with your Keystone device."
  }) !== PlayStatus.success)
    throw new Error("Could not generate the QR code, please try again.");
  const p = await c.read([n], {
    title: "Get the Signature from Keystone",
    description: "Please scan the QR code displayed on your Keystone",
    URTypeErrorMessage: "The scanned QR code can't be read. please verify and try again."
  });
  if (p.status !== ReadStatus.success)
    throw new Error("Could not extract the signature, please try again.");
  return p.result;
};
function i0(n) {
  return "authInfoBytes" in n ? tx.SignDoc.encode(n).finish() : tx.SignDocDirectAux.encode(n).finish();
}
function P2(n, c) {
  if (c.length !== 64)
    throw new Error("Signature must be 64 bytes long. Cosmos SDK uses a 2x32 byte fixed length encoding for the secp256k1 signature integers r and s.");
  return {
    pub_key: o0(n),
    signature: Buffer$f.from(c).toString("base64")
  };
}
function o0(n) {
  if (n.length !== 33 || n[0] !== 2 && n[0] !== 3)
    throw new Error("Public key must be compressed secp256k1, i.e. 33 bytes starting with 0x02 or 0x03");
  return {
    type: "tendermint/PubKeySecp256k1",
    value: Buffer$f.from(n).toString("base64")
  };
}
class c0 extends z$1 {
  constructor(c) {
    const u = new t0(c.chains);
    super(c, u);
  }
  getWalletProviderName() {
    return Promise.resolve(qA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(qA.img);
  }
}
const qA = {
  id: "cosmos_keystone",
  img: R2,
  name: "Keystone",
  chainType: "cosmos",
  connectProvider: c0,
  type: "qrcode"
}, a0 = "tomo_cosmos";
class d0 extends z$1 {
  constructor(c) {
    const u = D(c)[a0];
    if (!u)
      throw new Error("Tomo Wallet extension not found");
    super(c, u);
  }
  getWalletProviderName() {
    return Promise.resolve(_A.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(_A.img);
  }
  on(c, u) {
    var p, a;
    (a = (p = D(this.option).tomo_btc) == null ? void 0 : p.on) == null || a.call(p, c, u);
  }
  off(c, u) {
    var p, a;
    (a = (p = D(this.option).tomo_btc) == null ? void 0 : p.off) == null || a.call(p, c, u);
  }
}
const _A = {
  id: "cosmos_tomo",
  img: X2,
  name: "Tomo",
  chainType: "cosmos",
  connectProvider: d0,
  type: "extension"
};
class l0 extends z$1 {
  constructor(c) {
    const u = D(c).cactuslink_cosmos;
    if (!u)
      throw new Error("CactusLink Wallet extension not found");
    super(c, u);
  }
  getWalletProviderName() {
    return Promise.resolve($A.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve($A.img);
  }
}
const $A = {
  id: "cosmos_cactuslink",
  img: j2,
  name: "Cactus Link",
  chainType: "cosmos",
  connectProvider: l0,
  type: "extension"
}, g0 = [
  xA,
  DA,
  EA,
  NA,
  FA,
  UA,
  HA,
  JA,
  MA,
  XA,
  GA,
  OA,
  ZA
], u0 = [
  QA,
  TA,
  YA,
  RA,
  _A,
  LA,
  WA,
  zA,
  KA,
  qA,
  $A
];
class f0 extends J {
  constructor(c) {
    var u;
    const p = (u = D(c)) == null ? void 0 : u.injectedTomo, a = p == null ? void 0 : p.bitcoin;
    if (!a)
      throw new Error("Injected Tomo Wallet not found");
    super(c, a), iA(this, "injectedTomo"), iA(this, "connectWallet", async () => {
      var A;
      const b = (await ((A = this.bitcoinNetworkProvider) == null ? void 0 : A.requestAccounts()))[0], F = await this.getPublicKeyHex();
      if (!b || !F)
        throw new Error("Could not connect to injected Wallet");
      return this;
    }), A2.img = p.info.logo, A2.name = p.info.name, this.injectedTomo = p;
  }
  getWalletProviderName() {
    var c, u;
    return Promise.resolve((u = (c = this.injectedTomo) == null ? void 0 : c.info) == null ? void 0 : u.name);
  }
  getWalletProviderIcon() {
    var c, u;
    return Promise.resolve((u = (c = this.injectedTomo) == null ? void 0 : c.info) == null ? void 0 : u.logo);
  }
}
class w0 extends z$1 {
  constructor(c) {
    var u;
    const p = (u = D(c)) == null ? void 0 : u.injectedTomo, a = p == null ? void 0 : p.cosmos;
    if (!a)
      throw new Error("Injected Tomo Wallet not found");
    super(c, a), iA(this, "injectedTomo"), e2.img = p.info.logo, e2.name = p.info.name, this.injectedTomo = p;
  }
  getWalletProviderName() {
    var c, u;
    return Promise.resolve((u = (c = this.injectedTomo) == null ? void 0 : c.info) == null ? void 0 : u.name);
  }
  getWalletProviderIcon() {
    var c, u;
    return Promise.resolve((u = (c = this.injectedTomo) == null ? void 0 : c.info) == null ? void 0 : u.logo);
  }
}
const A2 = {
  id: "bitcoin_tomo_auto",
  img: "",
  name: "Tomo Injected",
  chainType: "bitcoin",
  connectProvider: f0,
  type: "injected"
}, e2 = {
  id: "cosmos_tomo_auto",
  img: "",
  name: "Tomo Injected",
  chainType: "cosmos",
  connectProvider: w0,
  type: "injected"
}, $2 = [
  A2,
  e2,
  ...g0,
  ...u0
], h0 = $2.reduce((n, c) => (n[c.id] = c, n), {}), Ae = $2.map((n) => n.id);
function t2(n, c) {
  var u;
  return ((u = c.additionalWallets) == null ? void 0 : u.find((p) => p.id === n)) || h0[n];
}
function ee(n) {
  let c = (n.indexWallets || []).map((u) => t2(u, n)).filter((u) => !!u);
  return (!n.indexWallets || n.indexWallets === Ae) && n.additionalWallets && (c = [
    ...c.filter((u) => {
      var p;
      return (p = n.additionalWallets) == null ? void 0 : p.every((a) => a.id !== u.id);
    }),
    ...n.additionalWallets
  ]), c;
}
const p0 = "data:image/svg+xml,%3csvg%20width='32'%20height='32'%20viewBox='0%200%2032%2032'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='Token'%3e%3cpath%20id='Network%20Icon%20Background'%20d='M16%2032C24.8366%2032%2032%2024.8366%2032%2016C32%207.16344%2024.8366%200%2016%200C7.16344%200%200%207.16344%200%2016C0%2024.8366%207.16344%2032%2016%2032Z'%20fill='%23F7931A'/%3e%3cpath%20id='Vector'%20d='M23.3198%2014.1189C23.6398%2012.1016%2022.0122%2011.0169%2019.7884%2010.2932L20.51%207.55978L18.7489%207.14593L18.0457%209.80711C17.583%209.69739%2017.1081%209.59537%2016.6342%209.49335L17.3425%206.81484L15.5814%206.40002L14.8599%209.13243C14.4767%209.04966%2014.0996%208.96882%2013.7347%208.88219L13.7368%208.87353L11.3071%208.30087L10.8383%2010.0776C10.8383%2010.0776%2012.1459%2010.3605%2012.1184%2010.3778C12.8318%2010.5463%2012.9602%2010.9919%2012.9388%2011.3461L12.1173%2014.4596C12.1663%2014.4712%2012.2295%2014.4885%2012.3008%2014.5145L12.1143%2014.4712L10.9627%2018.833C10.875%2019.037%2010.6539%2019.3441%2010.1545%2019.2276C10.1728%2019.2517%208.87443%2018.9264%208.87443%2018.9264L8%2020.8301L10.2931%2021.37C10.7191%2021.4711%2011.1369%2021.577%2011.5476%2021.6761L10.819%2024.4403L12.579%2024.8541L13.3006%2022.1208C13.7816%2022.243%2014.2484%2022.3566%2014.705%2022.4643L13.9854%2025.1862L15.7465%2025.6L16.4752%2022.8416C19.4796%2023.3787%2021.7381%2023.1621%2022.6889%2020.5962C23.4553%2018.5308%2022.6512%2017.3383%2021.0705%2016.5616C22.2222%2016.3114%2023.0884%2015.5963%2023.3198%2014.1189ZM19.2942%2019.449C18.751%2021.5154%2015.0667%2020.398%2013.8723%2020.1179L14.8405%2016.4557C16.0349%2016.7377%2019.8639%2017.295%2019.2942%2019.449ZM19.8394%2014.0891C19.3431%2015.9687%2016.2775%2015.013%2015.2838%2014.7792L16.1603%2011.4587C17.154%2011.6926%2020.3571%2012.1286%2019.8394%2014.0891Z'%20fill='white'/%3e%3c/g%3e%3c/svg%3e", m0 = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M20%2040C31.0457%2040%2040%2031.0457%2040%2020C40%208.9543%2031.0457%200%2020%200C8.9543%200%200%208.9543%200%2020C0%2031.0457%208.9543%2040%2020%2040Z'%20fill='%23AE219E'/%3e%3cpath%20d='M29.1497%2017.6486C29.5497%2015.127%2027.5153%2013.7711%2024.7356%2012.8664L25.6375%209.4497L23.4361%208.93238L22.5571%2012.2589C21.9788%2012.1217%2021.3851%2011.9942%2020.7927%2011.8667L21.6781%208.51852L19.4768%208L18.5748%2011.4155C18.0958%2011.312%2017.6245%2011.211%2017.1684%2011.1027L17.171%2011.0919L14.1339%2010.3761L13.5479%2012.5969C13.5479%2012.5969%2015.1824%2012.9506%2015.148%2012.9723C16.0397%2013.1828%2016.2002%2013.7398%2016.1735%2014.1826L15.1467%2018.0745C15.2078%2018.0889%2015.2868%2018.1106%2015.376%2018.1431L15.1429%2018.0889L13.7033%2023.5412C13.5938%2023.7963%2013.3173%2024.1801%2012.6931%2024.0345C12.716%2024.0646%2011.093%2023.6579%2011.093%2023.6579L10%2026.0376L12.8663%2026.7125C13.3988%2026.8388%2013.9212%2026.9712%2014.4346%2027.0951L13.5237%2030.5503L15.7238%2031.0676L16.6257%2027.6509C17.227%2027.8037%2017.8105%2027.9457%2018.3812%2028.0804L17.4818%2031.4827L19.6831%2032L20.594%2028.552C24.3496%2029.2233%2027.1726%2028.9526%2028.3612%2025.7453C29.3192%2023.1635%2028.314%2021.6729%2026.3382%2020.702C27.7777%2020.3892%2028.8605%2019.4953%2029.1497%2017.6486V17.6486ZM24.1177%2024.3112C23.4387%2026.8942%2018.8334%2025.4974%2017.3404%2025.1473L18.5506%2020.5697C20.0437%2020.9222%2024.8298%2021.6187%2024.1177%2024.3112ZM24.7993%2017.6113C24.1788%2019.9609%2020.3469%2018.7663%2019.1048%2018.4739L20.2004%2014.3233C21.4424%2014.6157%2025.4464%2015.1607%2024.7993%2017.6113Z'%20fill='white'/%3e%3c/svg%3e", y0 = "data:image/svg+xml,%3csvg%20width='1024'%20height='1024'%20viewBox='0%200%201024%201024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='512'%20cy='512'%20r='512'%20fill='url(%23paint0_radial)'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M559.489%20834.999C575.149%20766.673%20586.037%20671.007%20588.667%20562.846L612.66%20563.429C610.005%20672.632%20599.01%20769.997%20582.883%20840.361C574.842%20875.446%20565.383%20904.46%20554.695%20924.986C549.359%20935.233%20543.415%20943.961%20536.702%20950.27C529.942%20956.624%20521.636%20961.2%20512%20961.2C500.94%20961.2%20491.681%20955.206%20484.372%20947.318C477.039%20939.402%20470.522%20928.41%20464.667%20915.38C452.92%20889.241%20442.683%20852.265%20434.371%20807.75L457.963%20803.345C466.127%20847.065%20475.94%20881.915%20486.558%20905.543C491.885%20917.397%20497.13%20925.774%20501.978%20931.006C506.851%20936.266%20510.194%20937.2%20512%20937.2C513.589%20937.2%20516.306%20936.503%20520.265%20932.783C524.27%20929.017%20528.739%20922.868%20533.408%20913.902C542.727%20896.005%20551.637%20869.259%20559.489%20834.999Z'%20fill='url(%23paint1_linear)'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M472.024%20159.599C457.662%20209.824%20446.256%20281.346%20440%20365.329L416.066%20363.546C422.388%20278.678%20433.97%20205.382%20448.949%20153.001C456.413%20126.9%20464.908%20105.31%20474.426%2089.9811C483.479%2075.4018%20495.808%2062.8003%20511.998%2062.8003C521.634%2062.8003%20529.94%2067.3757%20536.7%2073.7298C543.412%2080.0394%20549.357%2088.7673%20554.692%2099.0135C565.381%20119.54%20574.839%20148.554%20582.881%20183.639C599.008%20254.003%20610.003%20351.368%20612.657%20460.571L588.665%20461.154C586.035%20352.993%20575.147%20257.327%20559.487%20189.001C551.635%20154.741%20542.725%20127.995%20533.405%20110.098C528.737%20101.132%20524.268%2094.9826%20520.262%2091.2174C516.304%2087.4967%20513.586%2086.8003%20511.998%2086.8003C509.194%2086.8003%20503.102%2089.2971%20494.815%20102.642C486.994%20115.237%20479.231%20134.397%20472.024%20159.599Z'%20fill='url(%23paint2_linear)'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M440.002%20365.329C436.591%20411.12%20434.719%20460.503%20434.719%20512C434.719%20624.426%20443.64%20726.638%20457.963%20803.345L434.37%20807.75C419.716%20729.271%20410.719%20625.538%20410.719%20512C410.719%20459.931%20412.611%20409.952%20416.068%20363.546L440.002%20365.329Z'%20fill='url(%23paint3_linear)'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M428.801%20552.768C350.948%20505.24%20283.687%20457.047%20233.733%20414.458L218.162%20432.722C269.286%20476.307%20337.624%20525.225%20416.296%20573.252L428.801%20552.768Z'%20fill='url(%23paint4_linear)'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M767.494%20714.63C700.498%20694.032%20612.212%20655.633%20517.234%20603.835L505.743%20624.905C601.636%20677.202%20691.446%20716.357%20760.441%20737.57C794.843%20748.147%20824.697%20754.462%20847.816%20755.468C859.356%20755.97%20869.886%20755.186%20878.706%20752.527C887.588%20749.849%20895.703%20744.944%20900.521%20736.6C908.648%20722.523%20903.832%20705.465%20895.658%20690.267C887.059%20674.28%20872.482%20656.027%20853.448%20636.401C815.251%20597.014%20757.103%20550.07%20686.25%20501.935L672.763%20521.787C742.879%20569.422%20799.58%20615.329%20836.219%20653.109C854.604%20672.066%20867.443%20688.477%20874.521%20701.636C882.024%20715.585%20881.146%20722.158%20879.736%20724.6C878.942%20725.975%20876.98%20727.98%20871.779%20729.548C866.516%20731.135%20858.957%20731.93%20848.859%20731.491C828.702%20730.613%20801.087%20724.958%20767.494%20714.63Z'%20fill='url(%23paint5_linear)'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M550.142%20445.073C594.052%20470.424%20635.28%20496.323%20672.762%20521.787L686.249%20501.935C648.265%20476.13%20606.54%20449.922%20562.142%20424.288C457.09%20363.637%20356.566%20317.459%20278.943%20291.673C240.225%20278.812%20206.608%20270.82%20180.71%20268.863C167.793%20267.887%20156.102%20268.352%20146.399%20270.883C136.678%20273.419%20127.677%20278.403%20122.483%20287.4C116.91%20297.053%20117.522%20308.162%20120.767%20318.51C124.025%20328.902%20130.394%20340.143%20138.889%20351.844C155.934%20375.32%20183.256%20402.964%20218.161%20432.722L233.731%20414.459C199.44%20385.224%20173.744%20359%20158.31%20337.744C150.567%20327.079%20145.833%20318.237%20143.667%20311.33C141.488%20304.381%20142.358%20300.976%20143.267%20299.4C144.118%20297.927%20146.344%20295.701%20152.457%20294.106C158.588%20292.507%20167.34%20291.921%20178.901%20292.795C201.959%20294.537%20233.439%20301.847%20271.377%20314.45C347.064%20339.592%20446.084%20384.995%20550.142%20445.073Z'%20fill='url(%23paint6_linear)'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M520.48%20418.94C601.097%20375.105%20676.844%20340.946%20738.738%20319.198L730.782%20296.555C667.411%20318.822%20590.478%20353.561%20509.016%20397.855L520.48%20418.94Z'%20fill='url(%23paint7_linear)'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M208.476%20632.887C259.443%20585.405%20336.327%20528.414%20428.139%20472.245L415.614%20451.773C322.917%20508.484%20244.615%20566.418%20192.116%20615.326C165.939%20639.713%20145.692%20662.301%20133.359%20681.732C127.202%20691.432%20122.654%20700.906%20120.571%20709.841C118.473%20718.842%20118.68%20728.286%20123.48%20736.6C131.596%20750.657%20148.739%20755.021%20165.952%20755.552C184.057%20756.111%20207.098%20752.635%20233.547%20745.995C286.627%20732.669%20356.187%20705.881%20433.135%20668.71L422.696%20647.099C346.549%20683.883%20278.611%20709.937%20227.704%20722.717C202.16%20729.13%20181.585%20732.023%20166.692%20731.564C150.909%20731.077%20145.672%20727.037%20144.265%20724.6C143.473%20723.229%20142.72%20720.542%20143.945%20715.29C145.184%20709.973%20148.241%20703.07%20153.622%20694.593C164.363%20677.669%20182.919%20656.695%20208.476%20632.887Z'%20fill='url(%23paint8_linear)'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M551.138%20578.927C506.978%20604.423%20463.696%20627.293%20422.695%20647.099L433.135%20668.709C474.685%20648.638%20518.488%20625.491%20563.138%20599.711C668.19%20539.06%20758.443%20475.093%20819.586%20420.762C850.083%20393.662%20873.812%20368.545%20888.456%20347.094C895.76%20336.397%20901.203%20326.039%20903.862%20316.37C906.527%20306.684%20906.711%20296.397%20901.516%20287.4C896.007%20277.858%20886.239%20272.837%20875.802%20270.442C865.332%20268.039%20852.623%20267.871%20838.494%20269.285C810.15%20272.121%20773.234%20281.637%20730.78%20296.555L738.736%20319.197C780.427%20304.548%20815.286%20295.727%20840.884%20293.166C853.726%20291.881%20863.531%20292.25%20870.433%20293.834C877.369%20295.426%20879.832%20297.842%20880.732%20299.4C881.582%20300.873%20882.398%20303.914%20880.722%20310.005C879.041%20316.115%20875.173%20323.986%20868.635%20333.562C855.597%20352.659%20833.527%20376.267%20803.644%20402.821C744.026%20455.797%20655.196%20518.849%20551.138%20578.927Z'%20fill='url(%23paint9_linear)'/%3e%3ccircle%20cx='449.975'%20cy='804.495'%20r='31.3505'%20fill='white'/%3e%3ccircle%20r='31.3505'%20transform='matrix(0.5%20-0.866025%20-0.866025%20-0.5%20227.181%20419.466)'%20fill='white'/%3e%3ccircle%20r='31.3505'%20transform='matrix(0.5%200.866025%200.866025%20-0.5%20734.794%20312.039)'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M512.012%20457.433C542.156%20457.433%20566.592%20481.869%20566.592%20512.012C566.592%20542.156%20542.156%20566.592%20512.012%20566.592C481.869%20566.592%20457.433%20542.156%20457.433%20512.012C457.433%20481.869%20481.869%20457.433%20512.012%20457.433Z'%20fill='white'/%3e%3cdefs%3e%3cradialGradient%20id='paint0_radial'%20cx='0'%20cy='0'%20r='1'%20gradientUnits='userSpaceOnUse'%20gradientTransform='translate(512%20512)%20rotate(90)%20scale(512)'%3e%3cstop%20offset='0.0909055'%20stop-color='%237C7C7C'/%3e%3cstop%20offset='0.233848'%20stop-color='%233E3E3E'/%3e%3cstop%20offset='0.817221'/%3e%3c/radialGradient%3e%3clinearGradient%20id='paint1_linear'%20x1='523.515'%20y1='961.2'%20x2='639.469'%20y2='570.809'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0.377307'%20stop-color='white'%20stop-opacity='0.6'/%3e%3cstop%20offset='0.992239'%20stop-color='white'%20stop-opacity='0'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint2_linear'%20x1='514.362'%20y1='62.8003'%20x2='663.926'%20y2='441'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0.634963'%20stop-color='white'%20stop-opacity='0.81'/%3e%3cstop%20offset='1'%20stop-color='white'%20stop-opacity='0'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint3_linear'%20x1='457.499'%20y1='363.546'%20x2='457.499'%20y2='808.261'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='white'%20stop-opacity='0.81'/%3e%3cstop%20offset='0.646422'%20stop-color='white'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint4_linear'%20x1='234.384'%20y1='411.354'%20x2='430.501'%20y2='549.696'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='white'%20stop-opacity='0.6'/%3e%3cstop%20offset='1'%20stop-color='white'%20stop-opacity='0'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint5_linear'%20x1='923.391'%20y1='735.037'%20x2='488.534'%20y2='662.67'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0.60731'%20stop-color='white'%20stop-opacity='0.81'/%3e%3cstop%20offset='1'%20stop-color='white'%20stop-opacity='0'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint6_linear'%20x1='674.619'%20y1='497.805'%20x2='110.127'%20y2='288.499'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='white'%20stop-opacity='0.81'/%3e%3cstop%20offset='0.478389'%20stop-color='white'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint7_linear'%20x1='743.225'%20y1='320.878'%20x2='508.048'%20y2='430.154'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='white'%20stop-opacity='0.6'/%3e%3cstop%20offset='1'%20stop-color='white'%20stop-opacity='0'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint8_linear'%20x1='110.421'%20y1='738.194'%20x2='404.819'%20y2='431.181'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0.54518'%20stop-color='white'%20stop-opacity='0.81'/%3e%3cstop%20offset='1'%20stop-color='white'%20stop-opacity='0'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint9_linear'%20x1='913.606'%20y1='276.28'%20x2='438.264'%20y2='671.645'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0.518582'%20stop-color='white'/%3e%3cstop%20offset='1'%20stop-color='white'%20stop-opacity='0.81'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e", C0 = {
  id: 1,
  name: "Bitcoin",
  network: "mainnet",
  type: "bitcoin",
  logo: p0
}, v0 = {
  id: 2,
  name: "Bitcoin Signet",
  type: "bitcoin",
  network: "signet",
  logo: m0
}, B0 = {
  id: 1,
  name: "Cosmos",
  type: "cosmos",
  network: "cosmoshub-4",
  logo: y0
}, b0 = [C0, v0], P0 = [B0];
typeof window < "u" && (window.Buffer = Buffer$1$1);
const a2 = [];
function I0(n, c) {
  if (typeof window > "u")
    return W(c);
  const u = localStorage.getItem(n), p = W(u === "undefined" || u === null ? c : JSON.parse(u));
  return W((a) => a(p), (a, A, b) => {
    let F = b;
    return typeof b == "function" && (F = b(a(p))), localStorage.setItem(n, JSON.stringify(F)), A(p, F), F;
  });
}
const te = [
  // 'evm',
  "bitcoin",
  "cosmos"
  // 'solana',
  // 'ton',
  // 'tron'
], ne = {
  isConnected: !1,
  bitcoin: {
    connected: !1,
    chainType: "bitcoin"
  },
  cosmos: {
    connected: !1,
    chainType: "cosmos"
  }
  // btcAddressType: 'P2TR'
}, U = I0("tomo_wallet_state", ne), O = W({
  state: 0
}), I2 = W(a2), d2 = W([]);
W((n) => n(d2).findLast((c) => c.type === "page"));
const k0 = {
  bitcoinChains: b0,
  cosmosChains: P0,
  // @ts-ignore
  chainTypes: te,
  socialTypes: [],
  indexWallets: Ae,
  onlySocial: !1,
  useServerSettings: !1
}, X = W(k0);
W(void 0);
const n2 = W({
  open: !1,
  chainType: "bitcoin"
}), re$4 = W(a2), se = W({
  theme: "light"
});
function Y(n, c) {
  const u = useMemo(
    () => W(null, (p, a, ...A) => n(p, a, ...A)),
    [n]
  );
  return R(u);
}
function S0(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var r2 = { exports: {} };
(function(n, c) {
  Object.defineProperty(c, "__esModule", { value: !0 });
  function u(Ce) {
    return typeof Ce == "object" && !("toString" in Ce) ? Object.prototype.toString.call(Ce).slice(8, -1) : Ce;
  }
  var p = typeof process$1 == "object" && process$1.env.NODE_ENV === "production";
  function a(Ce, tr) {
    if (!Ce)
      throw p ? new Error("Invariant failed") : new Error(tr());
  }
  c.invariant = a;
  var A = Object.prototype.hasOwnProperty, b = Array.prototype.splice, F = Object.prototype.toString;
  function le(Ce) {
    return F.call(Ce).slice(8, -1);
  }
  var L = Object.assign || /* istanbul ignore next */
  function(Ce, tr) {
    return pe(tr).forEach(function(Fe) {
      A.call(tr, Fe) && (Ce[Fe] = tr[Fe]);
    }), Ce;
  }, pe = typeof Object.getOwnPropertySymbols == "function" ? function(Ce) {
    return Object.keys(Ce).concat(Object.getOwnPropertySymbols(Ce));
  } : function(Ce) {
    return Object.keys(Ce);
  };
  function $(Ce) {
    return Array.isArray(Ce) ? L(Ce.constructor(Ce.length), Ce) : le(Ce) === "Map" ? new Map(Ce) : le(Ce) === "Set" ? new Set(Ce) : Ce && typeof Ce == "object" ? L(Object.create(Object.getPrototypeOf(Ce)), Ce) : Ce;
  }
  var Ee = (
    /** @class */
    function() {
      function Ce() {
        this.commands = L({}, be), this.update = this.update.bind(this), this.update.extend = this.extend = this.extend.bind(this), this.update.isEquals = function(tr, Fe) {
          return tr === Fe;
        }, this.update.newContext = function() {
          return new Ce().update;
        };
      }
      return Object.defineProperty(Ce.prototype, "isEquals", {
        get: function() {
          return this.update.isEquals;
        },
        set: function(tr) {
          this.update.isEquals = tr;
        },
        enumerable: !0,
        configurable: !0
      }), Ce.prototype.extend = function(tr, Fe) {
        this.commands[tr] = Fe;
      }, Ce.prototype.update = function(tr, Fe) {
        var Sr = this, er = typeof Fe == "function" ? { $apply: Fe } : Fe;
        Array.isArray(tr) && Array.isArray(er) || a(!Array.isArray(er), function() {
          return "update(): You provided an invalid spec to update(). The spec may not contain an array except as the value of $set, $push, $unshift, $splice or any custom command allowing an array value.";
        }), a(typeof er == "object" && er !== null, function() {
          return "update(): You provided an invalid spec to update(). The spec and every included key path must be plain objects containing one of the " + ("following commands: " + Object.keys(Sr.commands).join(", ") + ".");
        });
        var Ie = tr;
        return pe(er).forEach(function(xe) {
          if (A.call(Sr.commands, xe)) {
            var rr = tr === Ie;
            Ie = Sr.commands[xe](er[xe], Ie, er, tr), rr && Sr.isEquals(Ie, tr) && (Ie = tr);
          } else {
            var ar = le(tr) === "Map" ? Sr.update(tr.get(xe), er[xe]) : Sr.update(tr[xe], er[xe]), yr = le(Ie) === "Map" ? Ie.get(xe) : Ie[xe];
            (!Sr.isEquals(ar, yr) || typeof ar > "u" && !A.call(tr, xe)) && (Ie === tr && (Ie = $(tr)), le(Ie) === "Map" ? Ie.set(xe, ar) : Ie[xe] = ar);
          }
        }), Ie;
      }, Ce;
    }()
  );
  c.Context = Ee;
  var be = {
    $push: function(Ce, tr, Fe) {
      return Pe(tr, Fe, "$push"), Ce.length ? tr.concat(Ce) : tr;
    },
    $unshift: function(Ce, tr, Fe) {
      return Pe(tr, Fe, "$unshift"), Ce.length ? Ce.concat(tr) : tr;
    },
    $splice: function(Ce, tr, Fe, Sr) {
      return ir(tr, Fe), Ce.forEach(function(er) {
        or(er), tr === Sr && er.length && (tr = $(Sr)), b.apply(tr, er);
      }), tr;
    },
    $set: function(Ce, tr, Fe) {
      return Ir(Fe), Ce;
    },
    $toggle: function(Ce, tr) {
      nr(Ce, "$toggle");
      var Fe = Ce.length ? $(tr) : tr;
      return Ce.forEach(function(Sr) {
        Fe[Sr] = !tr[Sr];
      }), Fe;
    },
    $unset: function(Ce, tr, Fe, Sr) {
      return nr(Ce, "$unset"), Ce.forEach(function(er) {
        Object.hasOwnProperty.call(tr, er) && (tr === Sr && (tr = $(Sr)), delete tr[er]);
      }), tr;
    },
    $add: function(Ce, tr, Fe, Sr) {
      return kr(tr, "$add"), nr(Ce, "$add"), le(tr) === "Map" ? Ce.forEach(function(er) {
        var Ie = er[0], xe = er[1];
        tr === Sr && tr.get(Ie) !== xe && (tr = $(Sr)), tr.set(Ie, xe);
      }) : Ce.forEach(function(er) {
        tr === Sr && !tr.has(er) && (tr = $(Sr)), tr.add(er);
      }), tr;
    },
    $remove: function(Ce, tr, Fe, Sr) {
      return kr(tr, "$remove"), nr(Ce, "$remove"), Ce.forEach(function(er) {
        tr === Sr && tr.has(er) && (tr = $(Sr)), tr.delete(er);
      }), tr;
    },
    $merge: function(Ce, tr, Fe, Sr) {
      return xr(tr, Ce), pe(Ce).forEach(function(er) {
        Ce[er] !== tr[er] && (tr === Sr && (tr = $(Sr)), tr[er] = Ce[er]);
      }), tr;
    },
    $apply: function(Ce, tr) {
      return lr(Ce), Ce(tr);
    }
  }, He = new Ee();
  c.isEquals = He.update.isEquals, c.extend = He.extend, c.default = He.update, c.default.default = n.exports = L(c.default, c);
  function Pe(Ce, tr, Fe) {
    a(Array.isArray(Ce), function() {
      return "update(): expected target of " + u(Fe) + " to be an array; got " + u(Ce) + ".";
    }), nr(tr[Fe], Fe);
  }
  function nr(Ce, tr) {
    a(Array.isArray(Ce), function() {
      return "update(): expected spec of " + u(tr) + " to be an array; got " + u(Ce) + ". Did you forget to wrap your parameter in an array?";
    });
  }
  function ir(Ce, tr) {
    a(Array.isArray(Ce), function() {
      return "Expected $splice target to be an array; got " + u(Ce);
    }), or(tr.$splice);
  }
  function or(Ce) {
    a(Array.isArray(Ce), function() {
      return "update(): expected spec of $splice to be an array of arrays; got " + u(Ce) + ". Did you forget to wrap your parameters in an array?";
    });
  }
  function lr(Ce) {
    a(typeof Ce == "function", function() {
      return "update(): expected spec of $apply to be a function; got " + u(Ce) + ".";
    });
  }
  function Ir(Ce) {
    a(Object.keys(Ce).length === 1, function() {
      return "Cannot have more than one key in an object with $set";
    });
  }
  function xr(Ce, tr) {
    a(tr && typeof tr == "object", function() {
      return "update(): $merge expects a spec of type 'object'; got " + u(tr);
    }), a(Ce && typeof Ce == "object", function() {
      return "update(): $merge expects a target of type 'object'; got " + u(Ce);
    });
  }
  function kr(Ce, tr) {
    var Fe = le(Ce);
    a(Fe === "Map" || Fe === "Set", function() {
      return "update(): " + u(tr) + " expects a target of type Set or Map; got " + u(Fe);
    });
  }
})(r2, r2.exports);
var x0 = r2.exports;
const V = /* @__PURE__ */ S0(x0), E0 = [
  {
    wallet: "cosmos_keplr",
    messageRegex: /There is no modular chain info for/
  },
  {
    wallet: "cosmos_leap",
    messageRegex: /Invalid chain id/
  },
  {
    wallet: "cosmos_cosmostation",
    messageRegex: /There is no chain info for/
  }
];
function N0(n, c) {
  return n[c + "Chains"];
}
function hA() {
  const n = R(U), c = R(O), u = Y(useCallback(async (b, F, le) => {
    const { chainType: L } = le, pe = await b(O)[`${L}Provider`].getAddress();
    n(($) => V($, {
      [L]: {
        address: {
          $set: pe
        }
      }
    }));
  }, [])), p = Y(useCallback(async (b, F, le, L = {}) => {
    var pe;
    const $ = b(O), Ee = b(X), be = b(U);
    try {
      const He = $[`${le}Provider`];
      if (!He)
        throw new Error(`Unsupported Chain: ${le}`);
      try {
        await He.connectWallet();
      } catch (ir) {
        if (le !== "cosmos" || // @ts-ignore
        !((pe = He == null ? void 0 : He.provider) != null && pe.experimentalSuggestChain))
          throw ir;
        const or = E0.find((Ir) => {
          var xr;
          return Ir.wallet === ((xr = be.cosmos) == null ? void 0 : xr.walletId);
        });
        if (!or || !or.messageRegex.test(ir.message || ""))
          throw ir;
        const lr = Ee.cosmosChains[0].modularData;
        if (!lr)
          throw ir;
        await He.provider.experimentalSuggestChain(lr), await He.connectWallet();
      }
      const Pe = await He.getNetwork();
      let nr = Ee[`${le}Chains`].find((ir) => ir.network === Pe);
      if (!nr) {
        const ir = N0(Ee, le);
        if (!(ir != null && ir.length))
          throw new Error("Unsupported network");
        nr = ir[0], await a(nr);
        return;
      }
      await u({ chainType: le }), n((ir) => V(ir, {
        [le]: {
          $merge: {
            network: Pe,
            chainId: nr.id
          }
        }
      }));
    } catch (He) {
      throw He;
    }
  }, [])), a = Y(useCallback(async (b, F, le) => {
    const L = b(O)[`${le.type}Provider`];
    if (!L || !L.switchNetwork)
      throw new Error(`switchNetwork error: ${le.type}`);
    await L.switchNetwork(le.network);
    const pe = await (L == null ? void 0 : L.getAddress()), $ = await (L == null ? void 0 : L.getNetwork());
    n((Ee) => V(Ee, {
      [le.type]: {
        $merge: {
          network: $,
          chainId: le.id,
          address: pe
        }
      }
    }));
  }, [])), A = Y(useCallback(async (b, F, le) => {
    const L = b(X), pe = {}, $ = t2(le, L);
    if (!$)
      throw new Error("Wallet does not exist");
    const Ee = pe[`${$.chainType}Provider`] = new $.connectProvider(
      // @ts-ignore
      {
        chains: L[`${$.chainType}Chains`],
        ...L.providerOptions
      }
    );
    return await Ee.init(), c((be) => ({
      ...be,
      ...pe
    })), Ee;
  }, []));
  return {
    initProvider: A,
    switchChainType: p,
    switchChain: a,
    reloadAddress: u,
    disconnect: Y(useCallback(async (b, F) => {
      const le = b(X);
      n(ie(ne, le));
    }, [])),
    connect: Y(useCallback(async (b, F, le) => {
      var L;
      const pe = b(X);
      for (const Ee of le) {
        const be = t2(Ee, pe);
        if (!be)
          throw new Error("Wallet does not exist");
        n((He) => V(He, {
          [be.chainType]: {
            $merge: {
              walletId: Ee
            }
          }
        })), await A(Ee), await p(be.chainType), n((He) => V(He, {
          [be.chainType]: {
            $merge: {
              connected: !0
            }
          }
        }));
      }
      const $ = b(U);
      (L = pe.chainTypes) != null && L.every((Ee) => $[Ee].connected) && n((Ee) => ({
        ...Ee,
        isConnected: !0
      }));
    }, []))
  };
}
const D0 = (n) => {
  if (window.ethereum) {
    let c = [];
    const u = (p) => {
      const a = [p.detail];
      c = c.concat(a), n(c || []);
    };
    window.addEventListener("eip6963:announceProvider", u), window.dispatchEvent(new Event("eip6963:requestProvider")), window.removeEventListener("eip6963:announceProvider", u);
  } else
    n([]);
};
function F0(n) {
  return n ? n == null ? void 0 : n.map((c) => c) : [];
}
function ie(n, c) {
  let u = n;
  return c.chainTypes.forEach((p) => {
    u[p] || (u = {
      ...u,
      [p]: {
        connected: !1,
        chainType: p
      }
    });
  }), u;
}
function H0(n) {
  const c = H(I2), u = hA(), p = R(I2);
  useEffect(() => {
    D0(p);
  }, []);
  const a = Y(useCallback(async (A, b) => {
    var F;
    const le = {
      ...A(X),
      ...n
    };
    te.forEach(($) => {
      le[`${$}Chains`] = F0(
        // @ts-ignore
        le[`${$}Chains`]
      );
    }), b(U, ($) => ie($, le)), b(X, le);
    const L = () => {
      b(U, ($) => {
        var Ee;
        return (Ee = le.chainTypes) == null || Ee.forEach((be) => {
          $ = V($, {
            [be]: {
              connected: {
                $set: !1
              }
            }
          });
        }), {
          ...$,
          isConnected: !1
        };
      });
    }, pe = A(U);
    if (pe.isConnected && le.autoReconnect !== !1)
      try {
        if ((F = le.chainTypes) != null && F.some((Ee) => !pe[Ee].connected))
          throw new Error("chain not connected");
        const $ = le.chainTypes;
        for (const Ee of $) {
          const be = pe[Ee].walletId;
          await u.initProvider(be), await u.switchChainType(Ee, {
            type: "init"
          });
        }
      } catch {
        b(U, ($) => ({
          ...$,
          isConnected: !1
        })), L();
      }
    else
      L();
    b(O, ($) => ({
      ...$,
      state: 1
    }));
  }, []));
  return useEffect(() => {
    c !== a2 && a();
  }, [c]), null;
}
function M0() {
  const n = H(O), c = hA(), u = H(U);
  useEffect(() => {
    var p, a;
    if (!u.bitcoin.connected)
      return;
    const A = async () => {
      await c.reloadAddress({ chainType: "bitcoin" });
    };
    return (a = (p = n.bitcoinProvider) == null ? void 0 : p.on) == null || a.call(p, "accountsChanged", A), () => {
      var b, F;
      (F = (b = n.bitcoinProvider) == null ? void 0 : b.off) == null || F.call(b, "accountsChanged", A);
    };
  }, [n.bitcoinProvider, u.bitcoin.connected]), useEffect(() => {
    var p, a;
    if (!u.cosmos.connected)
      return;
    const A = async () => {
      await c.reloadAddress({ chainType: "cosmos" });
    };
    return (a = (p = n.cosmosProvider) == null ? void 0 : p.on) == null || a.call(p, "accountChanged", A), () => {
      var b, F;
      (F = (b = n.cosmosProvider) == null ? void 0 : b.off) == null || F.call(b, "accountChanged", A);
    };
  }, [n.cosmosProvider, u.cosmos.connected]);
}
function J0(n) {
  return jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", ...n, children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.41425 6.00025L11.7072 1.70725C12.0982 1.31625 12.0982 0.68425 11.7072 0.29325C11.3162 -0.09775 10.6842 -0.09775 10.2933 0.29325L6.00025 4.58625L1.70725 0.29325C1.31625 -0.09775 0.68425 -0.09775 0.29325 0.29325C-0.09775 0.68425 -0.09775 1.31625 0.29325 1.70725L4.58625 6.00025L0.29325 10.2933C-0.09775 10.6842 -0.09775 11.3162 0.29325 11.7072C0.48825 11.9022 0.74425 12.0002 1.00025 12.0002C1.25625 12.0002 1.51225 11.9022 1.70725 11.7072L6.00025 7.41425L10.2933 11.7072C10.4882 11.9022 10.7443 12.0002 11.0002 12.0002C11.2562 12.0002 11.5122 11.9022 11.7072 11.7072C12.0982 11.3162 12.0982 10.6842 11.7072 10.2933L7.41425 6.00025Z", fill: "currentColor", fillOpacity: "0.4" }) });
}
function oe(n) {
  return jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", ...n, children: [jsx("g", { clipPath: "url(#clip0_1_1460)", children: jsx("path", { d: "M14.6672 7.33284C14.2985 7.33284 14.0001 7.63127 14.0001 8.00002C14.0001 11.3078 11.3079 14 8.00005 14C6.59849 14 5.2813 13.525 4.22661 12.6672H5.33442C5.70317 12.6672 6.00161 12.3688 6.00161 12C6.00161 11.6313 5.70317 11.3328 5.33442 11.3328H2.66724C2.66099 11.3328 2.65474 11.3344 2.64849 11.3344C2.62661 11.3344 2.60474 11.3375 2.58442 11.3406C2.56255 11.3438 2.54067 11.3453 2.5188 11.35C2.50005 11.3547 2.4813 11.361 2.46255 11.3672C2.43911 11.375 2.41724 11.3813 2.39536 11.3922C2.37974 11.4 2.36411 11.4094 2.34849 11.4172C2.32505 11.4297 2.30317 11.4422 2.2813 11.4578C2.27661 11.461 2.27192 11.4625 2.2688 11.4656C2.25786 11.4735 2.25005 11.4844 2.23911 11.4922C2.22036 11.5078 2.20161 11.525 2.18442 11.5422C2.17036 11.5578 2.15786 11.5735 2.1438 11.5906C2.12974 11.6078 2.11724 11.625 2.1063 11.6438C2.0938 11.6625 2.08442 11.6813 2.07505 11.7016C2.06567 11.7203 2.0563 11.7391 2.04849 11.7594C2.04067 11.7813 2.03442 11.8031 2.02817 11.825C2.02349 11.8438 2.01724 11.8625 2.01411 11.8828C2.00942 11.9078 2.00786 11.9344 2.0063 11.961C2.0063 11.9735 2.00317 11.986 2.00317 11.9985V14.6656C2.00317 15.0344 2.30161 15.3328 2.67036 15.3328C3.03911 15.3328 3.33755 15.0344 3.33755 14.6656V13.6594C4.63599 14.736 6.26724 15.3313 8.00474 15.3313C12.0485 15.3313 15.3376 12.0422 15.3376 7.99846C15.3329 7.63127 15.0344 7.33284 14.6672 7.33284ZM8.00005 2.00002C9.40161 2.00002 10.7188 2.47502 11.7735 3.33284H10.6657C10.2969 3.33284 9.99849 3.63127 9.99849 4.00002C9.99849 4.36877 10.2969 4.66721 10.6657 4.66721H13.3329C13.3391 4.66721 13.3438 4.66565 13.3501 4.66565C13.3735 4.66565 13.3954 4.66096 13.4188 4.6594C13.4391 4.65627 13.461 4.65471 13.4813 4.65002C13.5016 4.64534 13.5204 4.63752 13.5407 4.63127C13.5625 4.62346 13.5844 4.61721 13.6063 4.60784C13.6235 4.60002 13.6391 4.59065 13.6547 4.58127C13.6766 4.56877 13.7 4.55627 13.7204 4.54221C13.725 4.53909 13.7297 4.53752 13.7344 4.5344C13.7454 4.52502 13.7547 4.51565 13.7657 4.50627C13.7844 4.49065 13.8016 4.47502 13.8188 4.45784C13.8344 4.44221 13.8469 4.42502 13.8594 4.40784C13.8719 4.39065 13.886 4.37502 13.8969 4.35627C13.9094 4.33752 13.9188 4.31721 13.9282 4.2969C13.9376 4.27815 13.9469 4.2594 13.9532 4.24065C13.961 4.21877 13.9672 4.1969 13.9735 4.17502C13.9782 4.15627 13.9844 4.13752 13.9876 4.11877C13.9922 4.09221 13.9938 4.06565 13.9954 4.04065C13.9954 4.02815 13.9985 4.01721 13.9985 4.00315V1.33284C13.9985 0.964087 13.7001 0.665649 13.3313 0.665649C12.9626 0.665649 12.6641 0.964087 12.6641 1.33284V2.33909C11.3657 1.26252 9.73442 0.667212 7.99692 0.667212C3.9563 0.667212 0.667236 3.95627 0.667236 8.00002C0.667236 8.36877 0.965674 8.66721 1.33442 8.66721C1.70317 8.66721 2.00005 8.36877 2.00005 8.00002C2.00005 4.69221 4.69224 2.00002 8.00005 2.00002Z", fill: "currentColor" }) }), jsx("defs", { children: jsx("clipPath", { id: "clip0_1_1460", children: jsx("rect", { width: "16", height: "16", fill: "white" }) }) })] });
}
function Q0(n) {
  return jsx("svg", { viewBox: "64 64 896 896", focusable: "false", "data-icon": "check-circle", width: "1em", height: "1em", fill: "currentColor", "aria-hidden": "true", ...n, children: jsx("path", { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z" }) });
}
function T0(n) {
  return jsx("svg", { viewBox: "64 64 896 896", focusable: "false", "data-icon": "exclamation-circle", width: "1em", height: "1em", fill: "currentColor", "aria-hidden": "true", ...n, children: jsx("path", { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" }) });
}
function L0(n) {
  return jsx("svg", { fillRule: "evenodd", viewBox: "64 64 896 896", focusable: "false", "data-icon": "close-circle", width: "1em", height: "1em", fill: "currentColor", "aria-hidden": "true", ...n, children: jsx("path", { d: "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z" }) });
}
let W0 = 1;
function ce() {
  const n = R(d2), c = useContext(s2);
  return {
    open: (u, p) => {
      const { type: a = "page", showClose: A = !0, ...b } = p || {}, F = W0++, le = new Promise((L) => {
        n((pe) => [
          ...pe,
          {
            jsx: u,
            resolve: L,
            type: a,
            showClose: A,
            openPageId: a === "drawer" ? c.page.type === "drawer" ? c.page.openPageId : c.id : void 0,
            id: F,
            opt: b
          }
        ]);
      });
      return le._pageId = F, le;
    },
    close: (u, p) => {
      n((a) => {
        const A = a.find((b) => b.id === u);
        return A && A.resolve(p), a.filter((b) => b.id !== u);
      });
    }
  };
}
const s2 = createContext({ id: 0, page: {} }), k2 = {
  getNextState(n, c) {
    return (!n || typeof n == "boolean") && (n = 0), n + c;
  },
  createFn(n) {
    return async function(c) {
      if (typeof c == "boolean") {
        n(c ? 1 : -1);
        return;
      }
      n(1);
      let u;
      try {
        typeof c == "function" ? u = await c() : u = await c;
      } catch (p) {
        throw n(-1), p;
      }
      return n(-1), u;
    };
  }
};
function z0(n = !1) {
  const [c, u] = useState(n);
  return [
    !!c,
    k2.createFn((p) => {
      u((a) => k2.getNextState(a, p));
    })
  ];
}
function K0(n) {
  const c = ce();
  useEffect(() => {
    if (n) {
      const u = c.open(jsx(ae, {}), {
        type: "drawer",
        noBg: !0,
        full: !0,
        animate: !1
      });
      return () => {
        c.close(u._pageId);
      };
    }
  }, [n]);
}
function ae() {
  return jsx("div", { className: "tm-flex tm-h-full tm-w-full tm-items-center tm-justify-center", children: jsx("div", { className: "tm-flex tm-size-16 tm-items-center tm-justify-center tm-rounded-lg tm-bg-white dark:tm-bg-white-dark", children: jsx(oe, { className: "tm-size-7 tm-animate-spin tm-text-tc1 dark:tm-text-tc1-dark" }) }) });
}
const U0 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='38'%20height='16'%20viewBox='0%200%2038%2016'%20fill='none'%3e%3crect%20width='37.0683'%20height='16.0002'%20rx='1.11164'%20fill='%23666666'/%3e%3cpath%20d='M19.946%207.50648C19.5159%207.50648%2019.1206%207.40657%2018.7601%207.20674C18.4039%207.00692%2018.1194%206.72891%2017.9065%206.37271C17.698%206.01216%2017.5938%205.60817%2017.5938%205.16075C17.5938%204.71332%2017.698%204.31151%2017.9065%203.9553C18.1194%203.5991%2018.4039%203.32109%2018.7601%203.12127C19.1206%202.92144%2019.5159%202.82153%2019.946%202.82153C20.376%202.82153%2020.7692%202.92144%2021.1254%203.12127C21.4859%203.32109%2021.7683%203.5991%2021.9724%203.9553C22.181%204.31151%2022.2852%204.71332%2022.2852%205.16075C22.2852%205.60817%2022.181%206.01216%2021.9724%206.37271C21.7639%206.72891%2021.4816%207.00692%2021.1254%207.20674C20.7692%207.40657%2020.376%207.50648%2019.946%207.50648ZM19.946%206.48999C20.3109%206.48999%2020.6019%206.36836%2020.8191%206.1251C21.0407%205.88184%2021.1514%205.56039%2021.1514%205.16075C21.1514%204.75676%2021.0407%204.43531%2020.8191%204.19639C20.6019%203.95313%2020.3109%203.8315%2019.946%203.8315C19.5768%203.8315%2019.2814%203.95096%2019.0598%204.18988C18.8426%204.42879%2018.734%204.75242%2018.734%205.16075C18.734%205.56473%2018.8426%205.88836%2019.0598%206.13162C19.2814%206.37054%2019.5768%206.48999%2019.946%206.48999Z'%20fill='%23121212'/%3e%3cpath%20d='M16.9809%202.88672V7.46089H15.8667V4.71769L14.8437%207.46089H13.9445L12.915%204.71118V7.46089H11.8008V2.88672H13.117L14.4006%206.05345L15.6712%202.88672H16.9809Z'%20fill='%23121212'/%3e%3cpath%20d='M8.84248%207.50648C8.41243%207.50648%208.01713%207.40657%207.65658%207.20674C7.30038%207.00692%207.01585%206.72891%206.803%206.37271C6.59449%206.01216%206.49023%205.60817%206.49023%205.16075C6.49023%204.71332%206.59449%204.31151%206.803%203.9553C7.01585%203.5991%207.30038%203.32109%207.65658%203.12127C8.01713%202.92144%208.41243%202.82153%208.84248%202.82153C9.27253%202.82153%209.66566%202.92144%2010.0219%203.12127C10.3824%203.32109%2010.6648%203.5991%2010.8689%203.9553C11.0774%204.31151%2011.1817%204.71332%2011.1817%205.16075C11.1817%205.60817%2011.0774%206.01216%2010.8689%206.37271C10.6604%206.72891%2010.3781%207.00692%2010.0219%207.20674C9.66566%207.40657%209.27253%207.50648%208.84248%207.50648ZM8.84248%206.48999C9.20737%206.48999%209.49842%206.36836%209.71561%206.1251C9.93715%205.88184%2010.0479%205.56039%2010.0479%205.16075C10.0479%204.75676%209.93715%204.43531%209.71561%204.19639C9.49842%203.95313%209.20737%203.8315%208.84248%203.8315C8.47324%203.8315%208.17786%203.95096%207.95632%204.18988C7.73912%204.42879%207.63052%204.75242%207.63052%205.16075C7.63052%205.56473%207.73912%205.88836%207.95632%206.13162C8.17786%206.37054%208.47324%206.48999%208.84248%206.48999Z'%20fill='%23121212'/%3e%3cpath%20d='M6.12017%202.88672V3.7794H4.90821V7.46089H3.79399V3.7794H2.58203V2.88672H6.12017Z'%20fill='%23121212'/%3e%3cpath%20d='M34.4932%209.06519V9.95787H33.2813V13.6394H32.167V9.95787H30.9551V9.06519H34.4932Z'%20fill='%23121212'/%3e%3cpath%20d='M26.0508%2011.3458C26.0508%2010.894%2026.1485%2010.4922%2026.344%2010.1403C26.5395%209.78411%2026.811%209.50827%2027.1585%209.31279C27.5103%209.11297%2027.9078%209.01306%2028.3509%209.01306C28.8939%209.01306%2029.3587%209.15641%2029.7453%209.44311C30.1319%209.72981%2030.3904%2010.1208%2030.5207%2010.616H29.2957C29.2045%2010.4248%2029.0742%2010.2793%2028.9048%2010.1794C28.7397%2010.0795%2028.5507%2010.0295%2028.3379%2010.0295C27.9947%2010.0295%2027.7167%2010.149%2027.5038%2010.3879C27.291%2010.6268%2027.1846%2010.9461%2027.1846%2011.3458C27.1846%2011.7454%2027.291%2012.0647%2027.5038%2012.3036C27.7167%2012.5425%2027.9947%2012.662%2028.3379%2012.662C28.5507%2012.662%2028.7397%2012.612%2028.9048%2012.5121C29.0742%2012.4122%2029.2045%2012.2667%2029.2957%2012.0755H30.5207C30.3904%2012.5708%2030.1319%2012.9617%2029.7453%2013.2484C29.3587%2013.5308%2028.8939%2013.6719%2028.3509%2013.6719C27.9078%2013.6719%2027.5103%2013.5742%2027.1585%2013.3787C26.811%2013.1789%2026.5395%2012.9031%2026.344%2012.5512C26.1485%2012.1993%2026.0508%2011.7975%2026.0508%2011.3458Z'%20fill='%23121212'/%3e%3cpath%20d='M23.8291%209.95787V10.8831H25.3212V11.7432H23.8291V12.7467H25.5167V13.6394H22.7148V9.06519H25.5167V9.95787H23.8291Z'%20fill='%23121212'/%3e%3cpath%20d='M21.9064%2013.6394H20.7922L18.9287%2010.818V13.6394H17.8145V9.06519H18.9287L20.7922%2011.8996V9.06519H21.9064V13.6394Z'%20fill='%23121212'/%3e%3cpath%20d='M17.008%2013.6394H15.8938L14.0302%2010.818V13.6394H12.916V9.06519H14.0302L15.8938%2011.8996V9.06519H17.008V13.6394Z'%20fill='%23121212'/%3e%3cpath%20d='M9.95576%2013.6849C9.52571%2013.6849%209.13041%2013.585%208.76986%2013.3852C8.41366%2013.1854%208.12913%2012.9074%207.91628%2012.5512C7.70777%2012.1906%207.60352%2011.7866%207.60352%2011.3392C7.60352%2010.8918%207.70777%2010.49%207.91628%2010.1338C8.12913%209.77757%208.41366%209.49955%208.76986%209.29973C9.13041%209.09991%209.52571%209%209.95576%209C10.3858%209%2010.7789%209.09991%2011.1351%209.29973C11.4957%209.49955%2011.778%209.77757%2011.9822%2010.1338C12.1907%2010.49%2012.295%2010.8918%2012.295%2011.3392C12.295%2011.7866%2012.1907%2012.1906%2011.9822%2012.5512C11.7737%2012.9074%2011.4913%2013.1854%2011.1351%2013.3852C10.7789%2013.585%2010.3858%2013.6849%209.95576%2013.6849ZM9.95576%2012.6685C10.3207%2012.6685%2010.6117%2012.5468%2010.8289%2012.3036C11.0504%2012.0603%2011.1612%2011.7389%2011.1612%2011.3392C11.1612%2010.9352%2011.0504%2010.6138%2010.8289%2010.3749C10.6117%2010.1316%2010.3207%2010.01%209.95576%2010.01C9.58653%2010.01%209.29114%2010.1294%209.0696%2010.3683C8.8524%2010.6073%208.7438%2010.9309%208.7438%2011.3392C8.7438%2011.7432%208.8524%2012.0668%209.0696%2012.3101C9.29114%2012.549%209.58653%2012.6685%209.95576%2012.6685Z'%20fill='%23121212'/%3e%3cpath%20d='M2.64062%2011.3458C2.64062%2010.894%202.73836%2010.4922%202.93384%2010.1403C3.12932%209.78411%203.40082%209.50827%203.74833%209.31279C4.10019%209.11297%204.49766%209.01306%204.94074%209.01306C5.48374%209.01306%205.94854%209.15641%206.33515%209.44311C6.72176%209.72981%206.98022%2010.1208%207.11054%2010.616H5.88555C5.79433%2010.4248%205.66401%2010.2793%205.4946%2010.1794C5.32953%2010.0795%205.14056%2010.0295%204.92771%2010.0295C4.58454%2010.0295%204.30653%2010.149%204.09367%2010.3879C3.88082%2010.6268%203.77439%2010.9461%203.77439%2011.3458C3.77439%2011.7454%203.88082%2012.0647%204.09367%2012.3036C4.30653%2012.5425%204.58454%2012.662%204.92771%2012.662C5.14056%2012.662%205.32953%2012.612%205.4946%2012.5121C5.66401%2012.4122%205.79433%2012.2667%205.88555%2012.0755H7.11054C6.98022%2012.5708%206.72176%2012.9617%206.33515%2013.2484C5.94854%2013.5308%205.48374%2013.6719%204.94074%2013.6719C4.49766%2013.6719%204.10019%2013.5742%203.74833%2013.3787C3.40082%2013.1789%203.12932%2012.9031%202.93384%2012.5512C2.73836%2012.1993%202.64062%2011.7975%202.64062%2011.3458Z'%20fill='%23121212'/%3e%3c/svg%3e", X0 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='38'%20height='16'%20viewBox='0%200%2038%2016'%20fill='none'%3e%3crect%20width='37.0683'%20height='16.0002'%20rx='1.11164'%20fill='black'/%3e%3cpath%20d='M19.946%207.50648C19.5159%207.50648%2019.1206%207.40657%2018.7601%207.20674C18.4039%207.00692%2018.1194%206.72891%2017.9065%206.37271C17.698%206.01216%2017.5938%205.60817%2017.5938%205.16075C17.5938%204.71332%2017.698%204.31151%2017.9065%203.9553C18.1194%203.5991%2018.4039%203.32109%2018.7601%203.12127C19.1206%202.92144%2019.5159%202.82153%2019.946%202.82153C20.376%202.82153%2020.7692%202.92144%2021.1254%203.12127C21.4859%203.32109%2021.7683%203.5991%2021.9724%203.9553C22.181%204.31151%2022.2852%204.71332%2022.2852%205.16075C22.2852%205.60817%2022.181%206.01216%2021.9724%206.37271C21.7639%206.72891%2021.4816%207.00692%2021.1254%207.20674C20.7692%207.40657%2020.376%207.50648%2019.946%207.50648ZM19.946%206.48999C20.3109%206.48999%2020.6019%206.36836%2020.8191%206.1251C21.0407%205.88184%2021.1514%205.56039%2021.1514%205.16075C21.1514%204.75676%2021.0407%204.43531%2020.8191%204.19639C20.6019%203.95313%2020.3109%203.8315%2019.946%203.8315C19.5768%203.8315%2019.2814%203.95096%2019.0598%204.18988C18.8426%204.42879%2018.734%204.75242%2018.734%205.16075C18.734%205.56473%2018.8426%205.88836%2019.0598%206.13162C19.2814%206.37054%2019.5768%206.48999%2019.946%206.48999Z'%20fill='white'/%3e%3cpath%20d='M16.9809%202.88672V7.46089H15.8667V4.71769L14.8437%207.46089H13.9445L12.915%204.71118V7.46089H11.8008V2.88672H13.117L14.4006%206.05345L15.6712%202.88672H16.9809Z'%20fill='white'/%3e%3cpath%20d='M8.84248%207.50648C8.41243%207.50648%208.01713%207.40657%207.65658%207.20674C7.30038%207.00692%207.01585%206.72891%206.803%206.37271C6.59449%206.01216%206.49023%205.60817%206.49023%205.16075C6.49023%204.71332%206.59449%204.31151%206.803%203.9553C7.01585%203.5991%207.30038%203.32109%207.65658%203.12127C8.01713%202.92144%208.41243%202.82153%208.84248%202.82153C9.27253%202.82153%209.66566%202.92144%2010.0219%203.12127C10.3824%203.32109%2010.6648%203.5991%2010.8689%203.9553C11.0774%204.31151%2011.1817%204.71332%2011.1817%205.16075C11.1817%205.60817%2011.0774%206.01216%2010.8689%206.37271C10.6604%206.72891%2010.3781%207.00692%2010.0219%207.20674C9.66566%207.40657%209.27253%207.50648%208.84248%207.50648ZM8.84248%206.48999C9.20737%206.48999%209.49842%206.36836%209.71561%206.1251C9.93715%205.88184%2010.0479%205.56039%2010.0479%205.16075C10.0479%204.75676%209.93715%204.43531%209.71561%204.19639C9.49842%203.95313%209.20737%203.8315%208.84248%203.8315C8.47324%203.8315%208.17786%203.95096%207.95632%204.18988C7.73912%204.42879%207.63052%204.75242%207.63052%205.16075C7.63052%205.56473%207.73912%205.88836%207.95632%206.13162C8.17786%206.37054%208.47324%206.48999%208.84248%206.48999Z'%20fill='white'/%3e%3cpath%20d='M6.12017%202.88672V3.7794H4.90821V7.46089H3.79399V3.7794H2.58203V2.88672H6.12017Z'%20fill='white'/%3e%3cpath%20d='M34.4932%209.06519V9.95787H33.2813V13.6394H32.167V9.95787H30.9551V9.06519H34.4932Z'%20fill='white'/%3e%3cpath%20d='M26.0508%2011.3458C26.0508%2010.894%2026.1485%2010.4922%2026.344%2010.1403C26.5395%209.78411%2026.811%209.50827%2027.1585%209.31279C27.5103%209.11297%2027.9078%209.01306%2028.3509%209.01306C28.8939%209.01306%2029.3587%209.15641%2029.7453%209.44311C30.1319%209.72981%2030.3904%2010.1208%2030.5207%2010.616H29.2957C29.2045%2010.4248%2029.0742%2010.2793%2028.9048%2010.1794C28.7397%2010.0795%2028.5507%2010.0295%2028.3379%2010.0295C27.9947%2010.0295%2027.7167%2010.149%2027.5038%2010.3879C27.291%2010.6268%2027.1846%2010.9461%2027.1846%2011.3458C27.1846%2011.7454%2027.291%2012.0647%2027.5038%2012.3036C27.7167%2012.5425%2027.9947%2012.662%2028.3379%2012.662C28.5507%2012.662%2028.7397%2012.612%2028.9048%2012.5121C29.0742%2012.4122%2029.2045%2012.2667%2029.2957%2012.0755H30.5207C30.3904%2012.5708%2030.1319%2012.9617%2029.7453%2013.2484C29.3587%2013.5308%2028.8939%2013.6719%2028.3509%2013.6719C27.9078%2013.6719%2027.5103%2013.5742%2027.1585%2013.3787C26.811%2013.1789%2026.5395%2012.9031%2026.344%2012.5512C26.1485%2012.1993%2026.0508%2011.7975%2026.0508%2011.3458Z'%20fill='white'/%3e%3cpath%20d='M23.8291%209.95787V10.8831H25.3212V11.7432H23.8291V12.7467H25.5167V13.6394H22.7148V9.06519H25.5167V9.95787H23.8291Z'%20fill='white'/%3e%3cpath%20d='M21.9064%2013.6394H20.7922L18.9287%2010.818V13.6394H17.8145V9.06519H18.9287L20.7922%2011.8996V9.06519H21.9064V13.6394Z'%20fill='white'/%3e%3cpath%20d='M17.008%2013.6394H15.8938L14.0302%2010.818V13.6394H12.916V9.06519H14.0302L15.8938%2011.8996V9.06519H17.008V13.6394Z'%20fill='white'/%3e%3cpath%20d='M9.95576%2013.6849C9.52571%2013.6849%209.13041%2013.585%208.76986%2013.3852C8.41366%2013.1854%208.12913%2012.9074%207.91628%2012.5512C7.70777%2012.1906%207.60352%2011.7866%207.60352%2011.3392C7.60352%2010.8918%207.70777%2010.49%207.91628%2010.1338C8.12913%209.77757%208.41366%209.49955%208.76986%209.29973C9.13041%209.09991%209.52571%209%209.95576%209C10.3858%209%2010.7789%209.09991%2011.1351%209.29973C11.4957%209.49955%2011.778%209.77757%2011.9822%2010.1338C12.1907%2010.49%2012.295%2010.8918%2012.295%2011.3392C12.295%2011.7866%2012.1907%2012.1906%2011.9822%2012.5512C11.7737%2012.9074%2011.4913%2013.1854%2011.1351%2013.3852C10.7789%2013.585%2010.3858%2013.6849%209.95576%2013.6849ZM9.95576%2012.6685C10.3207%2012.6685%2010.6117%2012.5468%2010.8289%2012.3036C11.0504%2012.0603%2011.1612%2011.7389%2011.1612%2011.3392C11.1612%2010.9352%2011.0504%2010.6138%2010.8289%2010.3749C10.6117%2010.1316%2010.3207%2010.01%209.95576%2010.01C9.58653%2010.01%209.29114%2010.1294%209.0696%2010.3683C8.8524%2010.6073%208.7438%2010.9309%208.7438%2011.3392C8.7438%2011.7432%208.8524%2012.0668%209.0696%2012.3101C9.29114%2012.549%209.58653%2012.6685%209.95576%2012.6685Z'%20fill='white'/%3e%3cpath%20d='M2.64062%2011.3458C2.64062%2010.894%202.73836%2010.4922%202.93384%2010.1403C3.12932%209.78411%203.40082%209.50827%203.74833%209.31279C4.10019%209.11297%204.49766%209.01306%204.94074%209.01306C5.48374%209.01306%205.94854%209.15641%206.33515%209.44311C6.72176%209.72981%206.98022%2010.1208%207.11054%2010.616H5.88555C5.79433%2010.4248%205.66401%2010.2793%205.4946%2010.1794C5.32953%2010.0795%205.14056%2010.0295%204.92771%2010.0295C4.58454%2010.0295%204.30653%2010.149%204.09367%2010.3879C3.88082%2010.6268%203.77439%2010.9461%203.77439%2011.3458C3.77439%2011.7454%203.88082%2012.0647%204.09367%2012.3036C4.30653%2012.5425%204.58454%2012.662%204.92771%2012.662C5.14056%2012.662%205.32953%2012.612%205.4946%2012.5121C5.66401%2012.4122%205.79433%2012.2667%205.88555%2012.0755H7.11054C6.98022%2012.5708%206.72176%2012.9617%206.33515%2013.2484C5.94854%2013.5308%205.48374%2013.6719%204.94074%2013.6719C4.49766%2013.6719%204.10019%2013.5742%203.74833%2013.3787C3.40082%2013.1789%203.12932%2012.9031%202.93384%2012.5512C2.73836%2012.1993%202.64062%2011.7975%202.64062%2011.3458Z'%20fill='white'/%3e%3c/svg%3e";
function G0() {
  const { theme: n } = H(se);
  return jsxs("div", { className: "tm-flex tm-gap-2 tm-pb-2.5 tm-text-xs tm-text-tc4 dark:tm-text-tc4-dark", children: [jsx("div", { children: "Powered by" }), jsx("img", { alt: "tomo", src: n === "dark" ? U0 : X0 })] });
}
function Y0() {
  const n = H(re$4);
  return jsx("div", { className: "tm-pointer-events-none tm-absolute tm-bottom-20 tm-flex tm-w-full tm-flex-col tm-items-center tm-gap-4", children: [...n].reverse().map((c) => jsx(O0, { msg: c }, c.id)) });
}
const R0 = {
  success: jsx(Q0, { className: "tm-size-4 tm-text-success" }),
  error: jsx(L0, { className: "tm-size-4 tm-text-danger" }),
  warning: jsx(T0, { className: "tm-size-4 tm-text-warning" })
};
function O0({ msg: n }) {
  const [c, u] = useState(!0), p = de();
  return useEffect(() => {
    if (c) {
      const a = setTimeout(() => {
        p.remove(n.id);
      }, n.duration);
      return () => clearTimeout(a);
    }
  }, [c]), jsxs("div", { className: "tm-pointer-events-auto tm-flex tm-max-w-[80%] tm-items-center tm-gap-2 tm-overflow-hidden tm-rounded-lg tm-bg-white tm-px-4 tm-py-2 tm-text-sm dark:tm-bg-white-dark animate__animated animate__fadeInUp animate__faster", onMouseOver: () => {
    u(!1);
  }, onMouseLeave: () => {
    u(!0);
  }, style: {
    // boxShadow: '0px 0px 4px 0px rgba(213, 213, 213, 0.25)',
    boxShadow: "0 6px 16px 0 rgba(0, 0, 0, 0.08),0 3px 6px -4px rgba(0, 0, 0, 0.12),0 9px 28px 8px rgba(0, 0, 0, 0.05)"
  }, children: [R0[n.type || ""], jsx("div", { className: "tm-flex-1 tm-overflow-hidden", children: n.title })] }, n.id);
}
let Z0 = 1;
function de() {
  const n = R(re$4);
  return useMemo(() => ({
    remove: (c) => {
      n((u) => u.filter((p) => p.id !== c));
    },
    removeSameMsg: (c) => {
      n((u) => u.filter((p) => p.title !== c));
    },
    show: (c) => {
      n((u) => [...u, { type: "success", ...c, id: Z0++ }]);
    }
  }), []);
}
function V0() {
  const n = (p) => (a) => {
    typeof a == "string" ? a = {
      duration: 3e3,
      title: a,
      type: p
    } : a = { ...a, type: p }, c.show(a);
  }, c = de(), u = (p) => {
    typeof p == "string" && (p = {
      duration: 3e3,
      title: p
    }), c.show(p);
  };
  return u.success = n("success"), u.warning = n("warning"), u.error = n("error"), u;
}
function j0() {
  const n = navigator.userAgent;
  return /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(n) ? "tablet" : /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(n) ? "mobile" : "desktop";
}
function q0({ chainType: n }) {
  return jsx(An, { type: "connect", chainType: n });
}
function _0() {
  const n = hA(), c = H(X);
  return async (u) => {
    try {
      await new u.connectProvider({
        chains: [],
        ...c.providerOptions
      }).init();
    } catch {
      throw new Error("Wallet not installed");
    }
    await n.connect([u.id]);
  };
}
function Nn(n) {
  const c = H(X);
  return useMemo(() => ee(c).filter((u) => n ? u.chainType === n : !0), [c, n]);
}
function $0(n) {
  const c = H(X), [u, p] = useState(() => ee(c).map((b) => ({
    ...b,
    isInstall: !1
  }))), a = useMemo(() => {
    let b = !1;
    const F = j0() === "desktop";
    return u.filter((le) => {
      const L = n ? le.chainType === n : !0;
      if (L && le.type === "injected" && !F)
        if (le.isInstall)
          b = !0;
        else
          return !1;
      return L;
    }).filter((le) => F ? le.isInstall || le.type !== "injected" : le.isInstall || !b);
  }, [u, n]), A = async () => {
    u.filter((b) => n ? b.chainType === n : !0).forEach(async (b) => {
      if (!b.isInstall)
        try {
          await new b.connectProvider({
            chains: [],
            ...c.providerOptions
          }).init(), p((F) => V(F, {
            [F.findIndex((le) => b.id === le.id)]: {
              isInstall: { $set: !0 }
            }
          }));
        } catch {
        }
    });
  };
  return useEffect(() => {
    A();
  }, [c, n]), a;
}
function An(n) {
  const { chainType: c, type: u } = n, [p, a] = z0();
  K0(p);
  const A = _0(), b = V0(), F = $0(c) || [];
  return jsxs("div", { className: "tm-relative tm-flex tm-h-[700px] tm-w-[660px] tm-max-w-full tm-max-w-full tm-flex-col tm-justify-start tm-gap-5 tm-overflow-hidden tm-bg-white tm-pt-9 tm-text-tc1 dark:tm-bg-mbg-dark dark:tm-text-tc1-dark", children: [jsxs("div", { className: "tm-flex tm-flex-col tm-gap-5 tm-px-6 tm-pb-9", children: [jsx("div", { className: "tm-text-[24px]", children: "Select your wallet" }), jsxs("div", { children: ["Connect a ", jsx("span", { className: "tm-capitalize", children: c }), " Wallet"] })] }), jsx("div", { className: "tm-box-border tm-w-full tm-flex-1 tm-gap-5 tm-overflow-y-auto tm-pb-6 tm-pt-2", children: jsx("div", { className: "tm-grid tm-w-full tm-flex-1 tm-grid-cols-1 sm:tm-grid-cols-2 tm-gap-6 tm-px-6", children: F.map((le) => jsx(en, { wallet: le, onClick: () => {
    a(async () => {
      try {
        await A(le);
      } catch (L) {
        b.error((L == null ? void 0 : L.message) || "Failed");
      }
    });
  } }, `some-${le.id}`)) }) }), jsx("div", { className: "tm-bg-red tm-flex tm-flex-row tm-items-center tm-justify-center tm-text-center", children: jsx(G0, {}) })] });
}
function en({ wallet: n, ...c }) {
  const { onClick: u, checked: p } = c, a = () => {
    u && u();
  };
  return jsxs("div", { className: cA("tm-flex tm-h-[58px] tm-cursor-pointer tm-justify-between tm-rounded-lg tm-bg-white dark:tm-bg-[#282828] tm-px-2 hover:tm-bg-tc1/5 dark:hover:tm-bg-opacity-60 tm-border tm-border-[rgba(94,96,97,0.30)] tm-transition", {
    "tm-border tm-border-primary": p
  }), onClick: a, children: [jsxs("div", { className: "tm-flex tm-items-center tm-gap-3.5 ", children: [jsx("div", { className: "tm-size-[34px]", children: jsx("img", { src: n == null ? void 0 : n.img, alt: n == null ? void 0 : n.name, className: "tm-h-full tm-w-full tm-rounded-lg" }) }), jsx("div", { className: "tm-text-sm", children: n.name })] }), jsxs("div", { className: "tm-flex tm-items-center tm-gap-2", children: [n.type === "extension" && n.isInstall && jsx(BA, { children: "Installed" }), n.type === "qrcode" && jsx(BA, { children: "QR code" }), n.type === "injected" && jsx(BA, { children: "Injected" })] })] });
}
function BA({ children: n }) {
  return jsx("div", { className: "tm-rounded-full tm-bg-[#f6f7f3] tm-px-2.5 tm-py-1 tm-text-[10px] tm-text-[#666] dark:tm-bg-[#444] dark:tm-text-white", children: n });
}
function tn({ className: n, isModal: c, chainType: u }) {
  var p;
  const a = H(d2), A = ce(), b = a.filter((pe) => pe.type === "page").length, F = a.filter((pe) => pe.type === "page"), le = ((p = F[F.length - 1]) == null ? void 0 : p.id) || 0, L = a.filter((pe) => pe.type === "drawer");
  return jsxs("div", { className: cA("tomo-social tm-relative tm-flex tm-max-w-full tm-justify-start tm-overflow-hidden tm-rounded-3xl tm-bg-mbg dark:tm-bg-mbg-dark tm-text-tc1 dark:tm-text-tc1-dark", {
    "tm-rounded-b-none": c
  }, n), style: {
    filter: "drop-shadow(0px 2px 5px rgba(0, 0, 0, 0.20))"
  }, children: [jsxs("div", { className: "tm-flex tm-max-w-full", style: {
    transform: `translateX(-${b / (b + 1) * 100}%)`
  }, children: [jsx("div", { className: "tm-h-fit tm-max-w-full tm-overflow-hidden", children: jsx(nn, { chainType: u }) }), F.map((pe) => jsx("div", { className: "tm-relative tm-overflow-hidden", children: jsx(Suspense, { fallback: jsx(ae, {}), children: jsx(s2.Provider, { value: { id: pe.id, page: pe }, children: pe.jsx }) }) }, pe.id))] }), L.map((pe) => {
    var $, Ee, be, He;
    const Pe = le !== pe.openPageId;
    return jsx("div", { className: cA("tm-absolute tm-bottom-0 tm-left-0 tm-h-full tm-w-full tm-bg-tc1/70", {
      "tm-hidden": Pe,
      "animate__animated animate__fadeIn animate__faster": (($ = pe.opt) == null ? void 0 : $.animate) !== !1
    }), onClick: () => {
      var nr;
      ((nr = pe.opt) == null ? void 0 : nr.maskClosable) !== !1 && A.close(pe.id);
    }, children: jsx("div", { onClick: (nr) => {
      nr.stopPropagation();
    }, className: cA("tm-absolute tm-bottom-0 tm-left-0 tm-max-h-full tm-w-full tm-overflow-hidden", {
      "tm-bg-white dark:tm-bg-white-dark": !((Ee = pe.opt) != null && Ee.noBg),
      "tm-h-full": (be = pe.opt) == null ? void 0 : be.full,
      "animate__animated animate__fadeInUp animate__faster": ((He = pe.opt) == null ? void 0 : He.animate) !== !1
    }), children: jsx(s2.Provider, { value: { id: pe.id, page: pe }, children: pe.jsx }) }) }, pe.id);
  }), jsx(Y0, {})] });
}
function nn({ chainType: n }) {
  return H(O).state ? jsx(q0, { chainType: n }) : (
    // eslint-disable-next-line tailwindcss/no-custom-classname
    jsx("div", { className: "tm-flex tm-h-[700px] tm-w-[660px] tm-items-center tm-justify-center", children: jsx(oe, { className: "tm-size-6 tm-animate-spin tm-text-tc1 dark:tm-text-tc1-dark" }) })
  );
}
function rn() {
  const n = H(U), c = H(n2), u = sn(), { connected: p } = n[c.chainType] || { connected: !1 };
  return useEffect(() => {
    p && u.close({
      walletState: n
    });
  }, [p, c.open]), c.open ? createPortal(jsx("div", { className: "tomo-social tm-fixed tm-left-0 tm-top-0 tm-z-40 tm-box-border tm-flex tm-h-screen tm-w-screen tm-overflow-auto tm-bg-tc1/30  tm-font-poppins", onClick: () => {
    u.close(void 0);
  }, children: jsxs("div", {
    // className={'tm-relative tm-m-auto tm-overflow-hidden tm-rounded-3xl'}
    className: "tm-absolute sm:tm-relative sm:tm-m-auto sm:tm-w-auto tm-bottom-0 tm-left-0 tm-w-full tm-overflow-hidden tm-rounded-t-3xl sm:tm-rounded-b-3xl animate__animated animate__fadeInUp animate__faster sm:tm-animate-none",
    style: {
      filter: "drop-shadow(0px 4px 20px rgba(0, 0, 0, 0.30))",
      animationDuration: "0.3s"
    },
    onClick: (a) => a.stopPropagation(),
    children: [p ? null : jsx("div", { className: "tm-absolute tm-right-0 tm-top-3 tm-z-10 tm-cursor-pointer tm-p-4 tm-text-tc1 dark:tm-text-tc1-dark hover:tm-text-opacity-70", onClick: () => {
      u.close(void 0);
    }, children: jsx(J0, {}) }), jsx(tn, { isModal: !0, chainType: c.chainType })]
  }) }), document.body) : null;
}
function sn() {
  const n = R(n2);
  return {
    open: Y(useCallback((c, u, p) => {
      if (!c(U)[p].connected)
        return new Promise((a) => {
          n({ open: !0, resolve: a, chainType: p });
        });
    }, [])),
    close: Y(useCallback((c, u, p) => {
      var a;
      const A = c(n2);
      (a = A.resolve) == null || a.call(A, p), n((b) => ({ ...b, open: !1 }));
    }, []))
  };
}
const S2 = {
  rounded: "medium",
  theme: "light",
  primaryColor: "#121212"
}, bA = {
  rounded: {
    sizeList: [
      ["--tms-rounded", 4],
      ["--tms-rounded-md", 6],
      ["--tms-rounded-lg", 8],
      ["--tms-rounded-xl", 12],
      ["--tms-rounded-2xl", 16],
      ["--tms-rounded-3xl", 24],
      ["--tms-rounded-full", 9999]
    ],
    scale: {
      none: 0,
      small: 0.5,
      medium: 1,
      large: 2
    }
  }
};
function on(n) {
  const [c, u] = je(X), p = R(se), a = {
    ...S2,
    ...n.style
  }, A = n.uiOptions;
  useEffect(() => {
    u((b) => ({ ...b, uiOptions: A }));
  }, [JSON.stringify(A)]), useEffect(() => {
    bA.rounded.sizeList.forEach(([b, F]) => {
      let le = bA.rounded.scale[a == null ? void 0 : a.rounded];
      isNaN(le) && (le = bA.rounded.scale.medium), document.documentElement.style.setProperty(b, `${F * le}px`);
    });
  }, [a == null ? void 0 : a.rounded]), useEffect(() => {
    (a == null ? void 0 : a.theme) === "dark" ? document.documentElement.classList.add("tm-dark") : document.documentElement.classList.remove("tm-dark"), p({ theme: (a == null ? void 0 : a.theme) === "dark" ? "dark" : "light" });
  }, [a == null ? void 0 : a.theme]), useEffect(() => {
    const b = !(a != null && a.primaryColor) || (a == null ? void 0 : a.primaryColor.toLowerCase()) === S2.primaryColor;
    document.documentElement.style.setProperty("--tms-colors-primary-btn-text-dark", b ? "#121212" : "#ffffff"), document.documentElement.style.setProperty("--tms-colors-primary", cn(b ? "#121212" : a.primaryColor)), document.documentElement.style.setProperty("--tms-colors-primary-dark", b ? "#ffffffe9" : a.primaryColor);
  }, [a == null ? void 0 : a.primaryColor]);
}
function cn(n) {
  if (!/^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/.test(n))
    throw new Error("Invalid hex color format");
  n = n.replace(/^#/, "");
  let c = parseInt(n, 16), u = c >> 16 & 255, p = c >> 8 & 255, a = c & 255;
  return `${u} ${p} ${a}`;
}
function Dn({ children: n, ...c }) {
  return jsxs(Re, { children: [jsx(an, { otherProps: c }), jsx(rn, {}), n] });
}
function an({ otherProps: n }) {
  return H0(n), M0(), on(n), null;
}
function Fn() {
  return H(U);
}
function Hn() {
  return H(O);
}
function Jn() {
  const n = hA();
  return {
    switchChainType: n.switchChainType,
    disconnect: n.disconnect,
    switchChain: n.switchChain
  };
}
const ExternalWallets = ({ chainName: n, onError: c }) => {
  const u = _0(), p = $0(n), a = async (A) => {
    try {
      await u(A);
    } catch (b) {
      c == null || c(b);
    }
  };
  return /* @__PURE__ */ jsxs("div", { className: "pt-10 text-accent-primary", children: [
    /* @__PURE__ */ jsx(Text, { className: "mb-4", children: "More wallets with Tomo Connect" }),
    /* @__PURE__ */ jsx("div", { className: "grid grid-cols-3 md:grid-cols-7 gap-6 items-center justify-between border border-secondary-strokeLight rounded p-6", children: (p || []).map((A) => /* @__PURE__ */ jsxs(
      "button",
      {
        disabled: !A.isInstall,
        className: twJoin("flex flex-col items-center gap-2.5", A.isInstall ? "opacity-100" : "opacity-50"),
        onClick: () => a(A),
        children: [
          /* @__PURE__ */ jsx("img", { className: "h-10 w-10 object-contain", src: A.img, alt: A.name }),
          /* @__PURE__ */ jsx(Text, { className: "leading-none whitespace-nowrap", variant: "body2", children: A.name })
        ]
      },
      A.id
    )) })
  ] });
};
class Wallet {
  constructor({ id: c, origin: u, name: p, icon: a, docs: A, networks: b, provider: F, label: le }) {
    As(this, "id");
    As(this, "origin");
    As(this, "name");
    As(this, "icon");
    As(this, "docs");
    As(this, "networks");
    As(this, "provider", null);
    As(this, "_label");
    As(this, "account", null);
    this.id = c, this.origin = u, this.name = p, this.icon = a, this.docs = A, this.networks = b, this.provider = F, this._label = le;
  }
  get installed() {
    return !!this.provider;
  }
  get label() {
    return this._label ?? (this.installed ? "Installed" : "");
  }
  async connect() {
    if (!this.provider)
      throw Error("Provider not found");
    await this.provider.connectWallet();
    const [c, u] = await Promise.all([this.provider.getAddress(), this.provider.getPublicKeyHex()]);
    return this.account = { address: c, publicKeyHex: u }, this;
  }
  clone() {
    return new Wallet({
      id: this.id,
      origin: this.origin,
      name: this.name,
      icon: this.icon,
      docs: this.docs,
      networks: this.networks,
      provider: this.provider
    });
  }
}
let createNanoEvents = () => ({
  emit(n, ...c) {
    for (let u = this.events[n] || [], p = 0, a = u.length; p < a; p++)
      u[p](...c);
  },
  events: {},
  on(n, c) {
    var u;
    return ((u = this.events)[n] || (u[n] = [])).push(c), () => {
      var p;
      this.events[n] = (p = this.events[n]) == null ? void 0 : p.filter((a) => c !== a);
    };
  }
});
const ERROR_CODES = {
  // ===== General/Common Errors =====
  UNKNOWN_ERROR: "UNKNOWN_ERROR",
  // Fallback
  INVALID_PARAMS: "INVALID_PARAMS",
  // Validation error
  CONNECTION_FAILED: "CONNECTION_FAILED",
  // Connection error
  METHOD_NOT_IMPLEMENTED: "METHOD_NOT_IMPLEMENTED",
  // Unimplemented feature
  MAX_ITERATION_EXCEEDED: "MAX_ITERATION_EXCEEDED",
  // Exceeded allowed iterations
  // ===== Wallet Extension/Provider =====
  EXTENSION_NOT_FOUND: "EXTENSION_NOT_FOUND",
  // Extension missing
  EXTENSION_CONTEXT_INVALIDATED: "EXTENSION_CONTEXT_INVALIDATED",
  // Context invalidated
  CONNECTION_REJECTED: "CONNECTION_REJECTED",
  // User rejected
  CONNECTION_CANCELED: "CONNECTION_CANCELED",
  // User canceled
  CHAIN_ID_NOT_INITIALIZED: "CHAIN_ID_NOT_INITIALIZED",
  // Chain ID missing
  RPC_URL_NOT_INITIALIZED: "RPC_URL_NOT_INITIALIZED",
  // RPC URL missing
  FAILED_TO_ADD_CHAIN: "FAILED_TO_ADD_CHAIN",
  // Add chain failed
  FAILED_TO_GET_KEY: "FAILED_TO_GET_KEY",
  // Key fetch failed
  WALLET_INITIALIZATION_FAILED: "WALLET_INITIALIZATION_FAILED",
  // Wallet initialization failed
  WALLET_NOT_CONNECTED: "WALLET_NOT_CONNECTED",
  // Not connected
  INCOMPATIBLE_WALLET_VERSION: "INCOMPATIBLE_WALLET_VERSION",
  // Version mismatch
  NETWORK_NOT_ENABLED_IN_WALLET: "NETWORK_NOT_ENABLED_IN_WALLET",
  // Network not enabled
  // ===== Bitcoin/PSBT/Address =====
  INVALID_PUBLIC_KEY: "INVALID_PUBLIC_KEY",
  // Invalid public key
  ADDRESS_GENERATION_FAILED: "ADDRESS_GENERATION_FAILED",
  // Address generation failed
  UNSUPPORTED_NETWORK: "UNSUPPORTED_NETWORK",
  // Network unsupported
  INVALID_ADDRESS_PREFIX: "INVALID_ADDRESS_PREFIX",
  // Address prefix invalid
  MISSING_PSBT_HEX: "MISSING_PSBT_HEX",
  // PSBT hex missing
  PSBT_HEX_REQUIRED: "PSBT_HEX_REQUIRED",
  // PSBT hex required
  PSBTS_HEXES_REQUIRED: "PSBTS_HEXES_REQUIRED",
  // Multiple PSBT hexes required
  SIGNATURE_EXTRACT_ERROR: "SIGNATURE_EXTRACT_ERROR",
  // Signature extraction failed
  GENERATION_ERROR: "GENERATION_ERROR",
  // General generation error
  ADDRESS_NOT_FOUND: "ADDRESS_NOT_FOUND",
  // Address not found
  PUBLIC_KEY_NOT_FOUND: "PUBLIC_KEY_NOT_FOUND",
  // Public key not found
  EMPTY_WITNESS_STACK: "EMPTY_WITNESS_STACK",
  // Witness stack is empty
  // ===== QR/Hardware Wallet =====
  QR_READ_ERROR: "QR_READ_ERROR",
  // QR read failed
  QR_SCAN_ERROR: "QR_SCAN_ERROR",
  // QR scan failed
  // ===== Inscriptions/Network =====
  INSCRIPTIONS_UNSUPPORTED_NETWORK: "INSCRIPTIONS_UNSUPPORTED_NETWORK",
  // Inscriptions unsupported
  INSCRIPTION_FETCH_ERROR: "INSCRIPTION_FETCH_ERROR"
  // Inscription fetch failed
};
class WalletError extends Error {
  constructor({ code: u, message: p, wallet: a, version: A, chainId: b }, F) {
    super(p, F);
    As(this, "code");
    As(this, "wallet");
    As(this, "version");
    As(this, "chainId");
    this.code = u, this.wallet = a, this.version = A, this.chainId = b;
  }
}
class WalletConnector {
  constructor(c, u, p, a, A) {
    As(this, "_connectedWallet", null);
    As(this, "_ee", createNanoEvents());
    this.id = c, this.name = u, this.icon = p, this.wallets = a, this.config = A;
  }
  get connectedWallet() {
    return this._connectedWallet;
  }
  async connect(c) {
    try {
      const u = typeof c == "string" ? this.wallets.find((p) => p.id === c) : c;
      if (!u)
        throw new WalletError({
          code: ERROR_CODES.EXTENSION_NOT_FOUND,
          message: "Wallet not found"
        });
      return this._ee.emit("connecting", `Connecting ${u.name}`), await u.connect(), this._connectedWallet = u, this._ee.emit("connect", this._connectedWallet), this.connectedWallet;
    } catch (u) {
      return this._ee.emit("error", u), null;
    }
  }
  async disconnect() {
    this._connectedWallet && (this._ee.emit("disconnect", this._connectedWallet), this._connectedWallet = null);
  }
  clone() {
    return new WalletConnector(this.id, this.name, this.icon, this.wallets, this.config);
  }
  on(c, u) {
    return this._ee.on(c, u);
  }
}
var Network = /* @__PURE__ */ ((n) => (n.MAINNET = "mainnet", n.TESTNET = "testnet", n.SIGNET = "signet", n))(Network || {});
const defaultWalletGetter = (n) => (c) => c[n], createWallet = async ({ metadata: n, context: c, config: u }) => {
  const {
    id: p,
    wallet: a,
    name: A,
    icon: b,
    docs: F = "",
    networks: le = [],
    createProvider: L,
    label: pe
  } = n, $ = {
    id: p,
    name: "",
    icon: "",
    origin: null,
    provider: null,
    docs: F,
    networks: le,
    label: pe
  };
  if (a) {
    const Ee = typeof a == "string" ? defaultWalletGetter(a) : a;
    $.origin = await Ee(c, u) ?? null, $.provider = $.origin ? L($.origin, u) : null;
  } else
    $.origin = null, $.provider = L(null, u);
  return typeof A == "string" ? $.name = A ?? "" : $.name = $.origin ? await A($.origin, u) : "", typeof b == "string" ? $.icon = b ?? "" : $.icon = $.origin ? await b($.origin, u) : "", new Wallet($);
}, createExternalWallet = ({ id: n, name: c, icon: u, provider: p }) => new Wallet({
  id: n,
  origin: null,
  name: c,
  icon: u,
  docs: "",
  networks: [Network.MAINNET, Network.SIGNET],
  provider: p
}), createWalletConnector = async ({
  persistent: n,
  metadata: c,
  context: u,
  config: p,
  accountStorage: a,
  disabledWallets: A
}) => {
  const b = [], F = n ? a.get(c.chain) : void 0;
  for (const $ of c.wallets)
    A != null && A.includes($.id) || b.push(
      await createWallet({
        metadata: $,
        context: u,
        config: p
      })
    );
  const le = b.find(($) => $.id === "injectable" && $.installed), L = b.filter(
    ($) => $.name.toLowerCase() !== (le == null ? void 0 : le.name.toLowerCase()) || $.id === "injectable"
  ), pe = new WalletConnector(c.chain, c.name, c.icon, L, p);
  return F && b.some(($) => $.id === F) && await pe.connect(F), pe;
}, icon$1 = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'?%3e%3csvg%20id='Layer_1'%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%20800%20800'%3e%3cdefs%3e%3cstyle%3e.cls-1{fill:%23ce6533;fill-rule:evenodd;}%3c/style%3e%3c/defs%3e%3cpath%20class='cls-1'%20d='M66.5,198.56c-3.27-8.85-1.09-18.79,5.58-25.47l90.82-90.82c6.67-6.67,16.62-8.85,25.46-5.59l193.65,71.14c4.76,1.75,7.92,6.28,7.92,11.35v42.4c0,3.21-1.27,6.28-3.54,8.55l-47.14,47.13c-3.33,3.34-8.3,4.43-12.73,2.79l-52.02-19.18-57.16-21.09c-4.83-1.79-9.55,2.92-7.76,7.76l40.27,109.18c1.63,4.43,.55,9.4-2.79,12.73l-41.91,41.89c-4.72,4.72-4.72,12.38,0,17.1l42.13,42.13c3.34,3.34,4.43,8.31,2.79,12.73l-40.27,109.17c-1.79,4.84,2.92,9.55,7.76,7.76l109.18-40.28c4.43-1.63,9.4-.54,12.73,2.79l46.91,46.91c2.27,2.27,3.54,5.34,3.54,8.55v42.41c0,5.06-3.15,9.59-7.9,11.34l-193.42,71.36c-8.85,3.27-18.8,1.08-25.47-5.59l-90.83-90.83c-6.67-6.67-8.85-16.61-5.58-25.47l71.11-192.77c1.99-5.4,1.99-11.34,0-16.74L66.5,198.56Z'/%3e%3cpath%20class='cls-1'%20d='M733.5,601.44c3.27,8.85,1.09,18.79-5.58,25.47l-90.82,90.83c-6.67,6.67-16.61,8.85-25.46,5.59l-193.65-71.14c-4.76-1.75-7.92-6.28-7.92-11.35v-42.4c0-3.21,1.27-6.28,3.54-8.55l47.14-47.13c3.33-3.34,8.3-4.43,12.73-2.79l52.02,19.18,57.16,21.09c4.83,1.79,9.54-2.92,7.76-7.76l-40.27-109.18c-1.63-4.43-.55-9.4,2.79-12.73l41.91-41.89c4.72-4.72,4.72-12.38,0-17.1l-42.13-42.13c-3.34-3.34-4.43-8.31-2.79-12.73l40.27-109.17c1.79-4.84-2.92-9.55-7.76-7.76l-109.18,40.28c-4.43,1.63-9.4,.54-12.73-2.79l-46.91-46.91c-2.27-2.27-3.54-5.34-3.54-8.55v-42.41c0-5.06,3.15-9.59,7.9-11.34l193.42-71.36c8.85-3.27,18.79-1.08,25.47,5.59l90.82,90.83c6.68,6.67,8.86,16.61,5.59,25.47l-71.11,192.77c-2,5.4-2,11.34,0,16.74l71.34,193.37h0Z'/%3e%3c/svg%3e", metadata$c = {
  id: "injectable",
  name: (n) => {
    var c;
    return (c = n.getWalletProviderName) == null ? void 0 : c.call(n);
  },
  icon: (n) => {
    var c;
    return (c = n.getWalletProviderIcon) == null ? void 0 : c.call(n);
  },
  docs: "",
  wallet: "bbnwallet",
  createProvider: (n) => n,
  networks: [Network.MAINNET, Network.SIGNET],
  label: "Injectable"
}, logo$7 = "data:image/svg+xml,%3csvg%20width='42'%20height='42'%20viewBox='0%200%2042%2042'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_425_5107)'%3e%3cpath%20d='M32.4545%200H9.54545C4.27365%200%200%204.27365%200%209.54545V32.4545C0%2037.7264%204.27365%2042%209.54545%2042H32.4545C37.7264%2042%2042%2037.7264%2042%2032.4545V9.54545C42%204.27365%2037.7264%200%2032.4545%200Z'%20fill='url(%23paint0_linear_425_5107)'/%3e%3cpath%20d='M32.4545%200H9.54545C4.27365%200%200%204.27365%200%209.54545V32.4545C0%2037.7264%204.27365%2042%209.54545%2042H32.4545C37.7264%2042%2042%2037.7264%2042%2032.4545V9.54545C42%204.27365%2037.7264%200%2032.4545%200Z'%20fill='url(%23paint1_radial_425_5107)'/%3e%3cpath%20d='M32.4545%200H9.54545C4.27365%200%200%204.27365%200%209.54545V32.4545C0%2037.7264%204.27365%2042%209.54545%2042H32.4545C37.7264%2042%2042%2037.7264%2042%2032.4545V9.54545C42%204.27365%2037.7264%200%2032.4545%200Z'%20fill='url(%23paint2_radial_425_5107)'/%3e%3cpath%20d='M32.4545%200H9.54545C4.27365%200%200%204.27365%200%209.54545V32.4545C0%2037.7264%204.27365%2042%209.54545%2042H32.4545C37.7264%2042%2042%2037.7264%2042%2032.4545V9.54545C42%204.27365%2037.7264%200%2032.4545%200Z'%20fill='url(%23paint3_radial_425_5107)'/%3e%3cpath%20d='M17.2526%2032.2614V22.5192L26.7185%2032.2614H31.9849V32.0079L21.0964%2020.9122L31.1469%2010.3857V10.2614H25.8464L17.2526%2019.5635V10.2614H12.9849V32.2614H17.2526Z'%20fill='white'/%3e%3c/g%3e%3cdefs%3e%3clinearGradient%20id='paint0_linear_425_5107'%20x1='21'%20y1='0'%20x2='21'%20y2='42'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%231FD1FF'/%3e%3cstop%20offset='1'%20stop-color='%231BB8FF'/%3e%3c/linearGradient%3e%3cradialGradient%20id='paint1_radial_425_5107'%20cx='0'%20cy='0'%20r='1'%20gradientUnits='userSpaceOnUse'%20gradientTransform='translate(2.00623%2040.4086)%20rotate(-45.1556)%20scale(67.3547%2068.3624)'%3e%3cstop%20stop-color='%23232DE3'/%3e%3cstop%20offset='1'%20stop-color='%23232DE3'%20stop-opacity='0'/%3e%3c/radialGradient%3e%3cradialGradient%20id='paint2_radial_425_5107'%20cx='0'%20cy='0'%20r='1'%20gradientUnits='userSpaceOnUse'%20gradientTransform='translate(39.7379%2041.7602)%20rotate(-138.45)%20scale(42.1137%2064.2116)'%3e%3cstop%20stop-color='%238B4DFF'/%3e%3cstop%20offset='1'%20stop-color='%238B4DFF'%20stop-opacity='0'/%3e%3c/radialGradient%3e%3cradialGradient%20id='paint3_radial_425_5107'%20cx='0'%20cy='0'%20r='1'%20gradientUnits='userSpaceOnUse'%20gradientTransform='translate(20.6501%200.311498)%20rotate(90)%20scale(33.1135%2080.3423)'%3e%3cstop%20stop-color='%2324D5FF'/%3e%3cstop%20offset='1'%20stop-color='%231BB8FF'%20stop-opacity='0'/%3e%3c/radialGradient%3e%3cclipPath%20id='clip0_425_5107'%3e%3crect%20width='42'%20height='42'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", WALLET_PROVIDER_NAME$7 = "Keplr";
class KeplrProvider {
  constructor(c, u) {
    As(this, "walletInfo");
    As(this, "chainId");
    As(this, "rpc");
    As(this, "chainData");
    As(this, "on", (c, u) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$7
        });
      c === "accountChanged" && window.addEventListener("keplr_keystorechange", u);
    });
    As(this, "off", (c, u) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$7
        });
      c === "accountChanged" && window.removeEventListener("keplr_keystorechange", u);
    });
    if (this.keplr = c, !c)
      throw new WalletError({
        code: ERROR_CODES.EXTENSION_NOT_FOUND,
        message: "Keplr extension not found",
        wallet: WALLET_PROVIDER_NAME$7
      });
    this.chainId = u.chainId, this.rpc = u.rpc, this.chainData = u.chainData;
  }
  async connectWallet() {
    if (!this.chainId || !this.rpc || !this.keplr)
      throw new WalletError({
        code: ERROR_CODES.WALLET_INITIALIZATION_FAILED,
        message: `Keplr provider initialization failed: Missing ${this.chainId ? this.rpc ? "Keplr extension" : "RPC URL" : "Chain ID"}`,
        wallet: WALLET_PROVIDER_NAME$7
      });
    try {
      await this.keplr.enable(this.chainId);
    } catch (a) {
      if (a != null && a.message.includes(this.chainId))
        try {
          await this.keplr.experimentalSuggestChain(this.chainData), await this.keplr.enable(this.chainId);
        } catch {
          throw new WalletError({
            code: ERROR_CODES.FAILED_TO_ADD_CHAIN,
            message: "Failed to add BBN chain",
            wallet: WALLET_PROVIDER_NAME$7
          });
        }
      else
        throw a != null && a.message.includes("rejected") ? new WalletError({
          code: ERROR_CODES.CONNECTION_REJECTED,
          message: "Keplr wallet connection request rejected",
          wallet: WALLET_PROVIDER_NAME$7
        }) : a != null && a.message.includes("context invalidated") ? new WalletError({
          code: ERROR_CODES.EXTENSION_CONTEXT_INVALIDATED,
          message: "Keplr extension context invalidated",
          wallet: WALLET_PROVIDER_NAME$7
        }) : new WalletError({
          code: ERROR_CODES.CONNECTION_FAILED,
          message: (a == null ? void 0 : a.message) || "Failed to connect to Keplr",
          wallet: WALLET_PROVIDER_NAME$7
        });
    }
    const c = await this.keplr.getKey(this.chainId);
    if (!c)
      throw new WalletError({
        code: ERROR_CODES.WALLET_INITIALIZATION_FAILED,
        message: "Failed to get Keplr key",
        wallet: WALLET_PROVIDER_NAME$7
      });
    const { bech32Address: u, pubKey: p } = c;
    if (u && p)
      this.walletInfo = {
        publicKeyHex: Buffer$1$1.from(c.pubKey).toString("hex"),
        address: u
      };
    else
      throw new WalletError({
        code: ERROR_CODES.CONNECTION_FAILED,
        message: "Could not connect to Keplr",
        wallet: WALLET_PROVIDER_NAME$7
      });
  }
  async getAddress() {
    if (!this.walletInfo)
      throw new WalletError({
        code: ERROR_CODES.WALLET_NOT_CONNECTED,
        message: "Wallet not connected",
        wallet: WALLET_PROVIDER_NAME$7
      });
    return this.walletInfo.address;
  }
  async getPublicKeyHex() {
    if (!this.walletInfo)
      throw new WalletError({
        code: ERROR_CODES.WALLET_NOT_CONNECTED,
        message: "Wallet not connected",
        wallet: WALLET_PROVIDER_NAME$7
      });
    return this.walletInfo.publicKeyHex;
  }
  async getWalletProviderName() {
    return WALLET_PROVIDER_NAME$7;
  }
  async getWalletProviderIcon() {
    return logo$7;
  }
  async getOfflineSigner() {
    if (!this.keplr || !this.chainId)
      throw new WalletError({
        code: ERROR_CODES.WALLET_INITIALIZATION_FAILED,
        message: this.keplr ? "Chain ID is not initialized" : "Keplr extension not found",
        wallet: WALLET_PROVIDER_NAME$7
      });
    try {
      return this.keplr.getOfflineSigner(this.chainId);
    } catch {
      throw new WalletError({
        code: ERROR_CODES.WALLET_INITIALIZATION_FAILED,
        message: "Failed to get offline signer",
        wallet: WALLET_PROVIDER_NAME$7
      });
    }
  }
  async getOfflineSignerAuto() {
    if (!this.keplr || !this.chainId)
      throw new WalletError({
        code: ERROR_CODES.WALLET_INITIALIZATION_FAILED,
        message: this.keplr ? "Chain ID is not initialized" : "Keplr extension not found",
        wallet: WALLET_PROVIDER_NAME$7
      });
    try {
      return this.keplr.getOfflineSignerAuto(this.chainId);
    } catch {
      throw new WalletError({
        code: ERROR_CODES.UNKNOWN_ERROR,
        // Or a more specific one if available
        message: "Failed to get offline signer auto",
        wallet: WALLET_PROVIDER_NAME$7
      });
    }
  }
}
const metadata$b = {
  id: "keplr",
  name: WALLET_PROVIDER_NAME$7,
  icon: logo$7,
  docs: "https://www.keplr.app/",
  wallet: () => build$6.Keplr.getKeplr(),
  createProvider: (n, c) => new KeplrProvider(n, c),
  networks: [Network.MAINNET, Network.SIGNET]
}, logo$6 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='58'%20height='58'%3e%3cg%20fill='none'%20fill-rule='nonzero'%3e%3cpath%20fill='%2324A95A'%20stroke='%23138D3E'%20stroke-width='.039'%20d='M51.466%2036.118c0%204.001-2.44%206.816-6.403%208.631-3.963%201.816-9.446%202.631-15.522%202.631-6.077%200-11.595-.815-15.594-2.63-3.999-1.816-6.474-4.631-6.474-8.632%200-4.002%202.46-7.625%206.44-10.248%203.982-2.623%209.482-4.245%2015.556-4.245%206.075%200%2011.575%201.626%2015.556%204.25%203.981%202.625%206.441%206.248%206.441%2010.243Z'/%3e%3cpath%20fill='%2332DA6D'%20stroke='%23138D3E'%20stroke-width='.039'%20d='m35.608%2013.791.012.003.007-.009A7.686%207.686%200%200%201%2041.555%2011c4.236%200%207.675%203.421%207.675%207.634%200%201.385-.37%202.671-1.009%203.788l-.005.009.004.01a9.644%209.644%200%200%201%20.94%204.13c0%203.711-2.198%207.072-5.753%209.505-3.555%202.434-8.468%203.939-13.893%203.939-5.426%200-10.339-1.505-13.894-3.939-3.555-2.433-5.752-5.794-5.752-9.506%200-1.442.327-2.829.939-4.13l.004-.009-.005-.009a7.583%207.583%200%200%201-1.01-3.788c0-4.213%203.44-7.634%207.676-7.634a7.73%207.73%200%200%201%205.928%202.785l.007.01.012-.004a27.43%2027.43%200%200%201%206.095-.665c2.121%200%204.172.24%206.094.665Z'/%3e%3cpath%20fill='%23FFF'%20d='M16.845%2022.88c2.597%200%204.703-2.094%204.703-4.677%200-2.583-2.106-4.677-4.703-4.677-2.597%200-4.702%202.094-4.702%204.677%200%202.583%202.105%204.677%204.702%204.677ZM41.932%2022.88c2.597%200%204.702-2.094%204.702-4.677%200-2.583-2.105-4.677-4.702-4.677-2.598%200-4.703%202.094-4.703%204.677%200%202.583%202.105%204.677%204.703%204.677Z'/%3e%3cpath%20fill='%2332DA6D'%20stroke='%23138D3E'%20stroke-width='.039'%20d='M4.032%2044.13a.163.163%200%200%200%20.018-.008l-.002-.004-.004-.01-.017-.046-.066-.174a70.962%2070.962%200%200%201-1.02-2.947c-.6-1.87-1.295-4.301-1.669-6.54-.187-1.12-.293-2.192-.268-3.122.025-.93.181-1.716.52-2.266.337-.55.855-.865%201.608-.856.754.01%201.746.347%203.027%201.108%207.702%204.573%209.453%2012.176%209.866%2015.688.113.98-.676%201.85-1.676%201.85H2.308c-.794%200-1.084-1.037-.39-1.438l2.123-1.219.015-.008-.006-.016-.018.007ZM54.276%2044.123l.018.006a.481.481%200%200%201-.018-.006v-.001l.002-.003.003-.011.016-.045a44.607%2044.607%200%200%200%20.276-.83c.183-.56.433-1.356.705-2.291.543-1.871%201.17-4.302%201.507-6.541.169-1.12.265-2.192.242-3.122-.023-.93-.165-1.716-.47-2.267a1.677%201.677%200%200%200-.587-.637%201.587%201.587%200%200%200-.867-.218c-.681.01-1.577.346-2.736%201.107-6.946%204.573-8.541%2012.19-8.897%2015.69-.1.982.606%201.849%201.505%201.849h10.887c.352%200%20.596-.258.672-.569.077-.31-.014-.67-.326-.87l-1.932-1.241Zm0%200-.005.014.013.009%201.924%201.218-1.932-1.241Z'/%3e%3cpath%20fill='%23092511'%20d='M16.893%2021.02a2.805%202.805%200%201%200%200-5.61%202.805%202.805%200%200%200%200%205.61ZM41.98%2021.02a2.805%202.805%200%201%200%200-5.61%202.805%202.805%200%200%200%200%205.61ZM36.998%2029.488a7.536%207.536%200%200%201-10.976%206.042%207.534%207.534%200%200%201-4.037-7.334l7.507.646%207.506.646Z'/%3e%3c/g%3e%3c/svg%3e", WALLET_PROVIDER_NAME$6 = "Leap";
class LeapProvider {
  constructor(c, u) {
    As(this, "walletInfo");
    As(this, "chainId");
    As(this, "rpc");
    As(this, "chainData");
    As(this, "on", (c, u) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$6
        });
      c === "accountChanged" && window.addEventListener("leap_keystorechange", u);
    });
    As(this, "off", (c, u) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$6
        });
      c === "accountChanged" && window.removeEventListener("leap_keystorechange", u);
    });
    if (this.wallet = c, !c)
      throw new WalletError({
        code: ERROR_CODES.EXTENSION_NOT_FOUND,
        message: "Leap extension not found",
        wallet: WALLET_PROVIDER_NAME$6
      });
    this.chainId = u.chainId, this.rpc = u.rpc, this.chainData = u.chainData;
  }
  async connectWallet() {
    if (!this.chainId)
      throw new WalletError({
        code: ERROR_CODES.CHAIN_ID_NOT_INITIALIZED,
        message: "Chain ID is not initialized",
        wallet: WALLET_PROVIDER_NAME$6
      });
    if (!this.rpc)
      throw new WalletError({
        code: ERROR_CODES.RPC_URL_NOT_INITIALIZED,
        message: "RPC URL is not initialized",
        wallet: WALLET_PROVIDER_NAME$6
      });
    if (!this.wallet)
      throw new WalletError({
        code: ERROR_CODES.EXTENSION_NOT_FOUND,
        message: "Leap extension not found",
        wallet: WALLET_PROVIDER_NAME$6
      });
    try {
      await this.wallet.enable(this.chainId);
    } catch (a) {
      if (a != null && a.message.includes(this.chainId) || a != null && a.message.includes("chain id"))
        try {
          await this.wallet.experimentalSuggestChain(this.chainData), await this.wallet.enable(this.chainId);
        } catch {
          throw new WalletError({
            code: ERROR_CODES.FAILED_TO_ADD_CHAIN,
            message: "Failed to add BBN chain",
            wallet: WALLET_PROVIDER_NAME$6
          });
        }
      else
        throw a != null && a.message.includes("rejected") ? new WalletError({
          code: ERROR_CODES.CONNECTION_REJECTED,
          message: "Leap wallet connection request rejected",
          wallet: WALLET_PROVIDER_NAME$6
        }) : a != null && a.message.includes("context invalidated") ? new WalletError({
          code: ERROR_CODES.EXTENSION_CONTEXT_INVALIDATED,
          message: "Leap extension context invalidated",
          wallet: WALLET_PROVIDER_NAME$6
        }) : new WalletError({
          code: ERROR_CODES.CONNECTION_FAILED,
          message: (a == null ? void 0 : a.message) || "Failed to connect to Leap",
          wallet: WALLET_PROVIDER_NAME$6
        });
    }
    const c = await this.wallet.getKey(this.chainId);
    if (!c)
      throw new WalletError({
        code: ERROR_CODES.FAILED_TO_GET_KEY,
        message: "Failed to get Leap key",
        wallet: WALLET_PROVIDER_NAME$6
      });
    const { bech32Address: u, pubKey: p } = c;
    if (u && p)
      this.walletInfo = {
        publicKeyHex: Buffer$1$1.from(c.pubKey).toString("hex"),
        address: u
      };
    else
      throw new WalletError({
        code: ERROR_CODES.CONNECTION_FAILED,
        message: "Could not connect to Leap",
        wallet: WALLET_PROVIDER_NAME$6
      });
  }
  async getAddress() {
    if (!this.walletInfo)
      throw new WalletError({
        code: ERROR_CODES.WALLET_NOT_CONNECTED,
        message: "Wallet not connected",
        wallet: WALLET_PROVIDER_NAME$6
      });
    return this.walletInfo.address;
  }
  async getPublicKeyHex() {
    if (!this.walletInfo)
      throw new WalletError({
        code: ERROR_CODES.WALLET_NOT_CONNECTED,
        message: "Wallet not connected",
        wallet: WALLET_PROVIDER_NAME$6
      });
    return this.walletInfo.publicKeyHex;
  }
  async getWalletProviderName() {
    return WALLET_PROVIDER_NAME$6;
  }
  async getWalletProviderIcon() {
    return logo$6;
  }
  async getOfflineSigner() {
    if (!this.wallet)
      throw new WalletError({
        code: ERROR_CODES.EXTENSION_NOT_FOUND,
        message: "Leap extension not found",
        wallet: WALLET_PROVIDER_NAME$6
      });
    if (!this.chainId)
      throw new WalletError({
        code: ERROR_CODES.CHAIN_ID_NOT_INITIALIZED,
        message: "Chain ID is not initialized",
        wallet: WALLET_PROVIDER_NAME$6
      });
    try {
      return this.wallet.getOfflineSigner(this.chainId);
    } catch {
      throw new WalletError({
        code: ERROR_CODES.UNKNOWN_ERROR,
        message: "Failed to get offline signer",
        wallet: WALLET_PROVIDER_NAME$6
      });
    }
  }
  async getOfflineSignerAuto() {
    if (!this.wallet)
      throw new WalletError({
        code: ERROR_CODES.EXTENSION_NOT_FOUND,
        message: "Leap extension not found",
        wallet: WALLET_PROVIDER_NAME$6
      });
    if (!this.chainId)
      throw new WalletError({
        code: ERROR_CODES.CHAIN_ID_NOT_INITIALIZED,
        message: "Chain ID is not initialized",
        wallet: WALLET_PROVIDER_NAME$6
      });
    try {
      return this.wallet.getOfflineSignerAuto(this.chainId);
    } catch {
      throw new WalletError({
        code: ERROR_CODES.UNKNOWN_ERROR,
        message: "Failed to get offline signer auto",
        wallet: WALLET_PROVIDER_NAME$6
      });
    }
  }
}
const metadata$a = {
  id: "leap",
  name: WALLET_PROVIDER_NAME$6,
  icon: logo$6,
  docs: "https://www.leapwallet.io/",
  wallet: "leap",
  createProvider: (n, c) => new LeapProvider(n, c),
  networks: [Network.MAINNET, Network.SIGNET]
}, logo$5 = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'?%3e%3csvg%20width='225px'%20height='224px'%20viewBox='0%200%20225%20224'%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3ctitle%3eokx%3c/title%3e%3cg%20id='Page-1'%20stroke='none'%20strokeWidth='1'%20fill='none'%20fill-rule='evenodd'%3e%3cg%20id='okx'%20transform='translate(0.401000,%200.006000)'%20fill='%23000000'%20fill-rule='nonzero'%3e%3cpath%20d='M144.382,74.667%20L79.673,74.667%20C76.924,74.667%2074.695,76.895%2074.695,79.644%20L74.695,144.354%20C74.695,147.103%2076.924,149.332%2079.673,149.332%20L144.382,149.332%20C147.131,149.332%20149.36,147.103%20149.36,144.354%20L149.36,79.644%20C149.36,76.895%20147.131,74.667%20144.382,74.667%20Z'%20id='Path'%3e%3c/path%3e%3cpath%20d='M69.687,0%20L4.978,0%20C2.229,0%200,2.228%200,4.978%20L0,69.687%20C0,72.436%202.229,74.665%204.978,74.665%20L69.687,74.665%20C72.437,74.665%2074.665,72.436%2074.665,69.687%20L74.665,4.978%20C74.665,2.228%2072.437,0%2069.687,0%20Z'%20id='Path'%3e%3c/path%3e%3cpath%20d='M219.017,0%20L154.307,0%20C151.558,0%20149.329,2.228%20149.329,4.978%20L149.329,69.687%20C149.329,72.436%20151.558,74.665%20154.307,74.665%20L219.017,74.665%20C221.766,74.665%20223.994,72.436%20223.994,69.687%20L223.994,4.978%20C223.994,2.228%20221.766,0%20219.017,0%20Z'%20id='Path'%3e%3c/path%3e%3cpath%20d='M69.687,149.328%20L4.978,149.328%20C2.229,149.328%200,151.556%200,154.305%20L0,219.015%20C0,221.764%202.229,223.993%204.978,223.993%20L69.687,223.993%20C72.437,223.993%2074.665,221.764%2074.665,219.015%20L74.665,154.305%20C74.665,151.556%2072.437,149.328%2069.687,149.328%20Z'%20id='Path'%3e%3c/path%3e%3cpath%20d='M219.017,149.328%20L154.307,149.328%20C151.558,149.328%20149.329,151.556%20149.329,154.305%20L149.329,219.015%20C149.329,221.764%20151.558,223.993%20154.307,223.993%20L219.017,223.993%20C221.766,223.993%20223.994,221.764%20223.994,219.015%20L223.994,154.305%20C223.994,151.556%20221.766,149.328%20219.017,149.328%20Z'%20id='Path'%3e%3c/path%3e%3c/g%3e%3c/g%3e%3c/svg%3e", WALLET_PROVIDER_NAME$5 = "OKX";
class OKXBabylonProvider {
  constructor(c, u) {
    As(this, "walletInfo");
    As(this, "chainId");
    As(this, "rpc");
    As(this, "chainData");
    As(this, "on", (c, u) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$5
        });
      c === "accountChanged" && window.addEventListener("okx_keystorechange", u);
    });
    As(this, "off", (c, u) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$5
        });
      c === "accountChanged" && window.removeEventListener("okx_keystorechange", u);
    });
    if (this.wallet = c, !c || !c.keplr)
      throw new WalletError({
        code: ERROR_CODES.EXTENSION_NOT_FOUND,
        message: "OKX Wallet extension not found",
        wallet: WALLET_PROVIDER_NAME$5
      });
    this.chainId = u.chainId, this.rpc = u.rpc, this.chainData = u.chainData;
  }
  async connectWallet() {
    if (!this.chainId)
      throw new WalletError({
        code: ERROR_CODES.CHAIN_ID_NOT_INITIALIZED,
        message: "Chain ID is not initialized",
        wallet: WALLET_PROVIDER_NAME$5
      });
    if (!this.rpc)
      throw new WalletError({
        code: ERROR_CODES.RPC_URL_NOT_INITIALIZED,
        message: "RPC URL is not initialized",
        wallet: WALLET_PROVIDER_NAME$5
      });
    if (!this.wallet.keplr)
      throw new WalletError({
        code: ERROR_CODES.EXTENSION_NOT_FOUND,
        message: "OKX Wallet extension not found",
        wallet: WALLET_PROVIDER_NAME$5
      });
    const c = "3.54.12", u = await this.wallet.getVersion();
    if (u && u < c)
      throw new WalletError({
        code: ERROR_CODES.INCOMPATIBLE_WALLET_VERSION,
        message: `OKX Wallet version ${u} is not compatible. Please update to version ${c} or higher.`,
        wallet: WALLET_PROVIDER_NAME$5,
        version: u
      });
    try {
      await this.wallet.keplr.enable(this.chainId);
    } catch (b) {
      if (b != null && b.message.includes(this.chainId))
        try {
          await this.wallet.keplr.experimentalSuggestChain(this.chainData), await this.wallet.keplr.enable(this.chainId);
        } catch {
          throw new WalletError({
            code: ERROR_CODES.FAILED_TO_ADD_CHAIN,
            message: "Failed to add BBN chain",
            wallet: WALLET_PROVIDER_NAME$5
          });
        }
      else
        throw b != null && b.message.includes("rejected") ? new WalletError({
          code: ERROR_CODES.CONNECTION_REJECTED,
          message: "OKX Wallet connection request rejected",
          wallet: WALLET_PROVIDER_NAME$5
        }) : b != null && b.message.includes("context invalidated") ? new WalletError({
          code: ERROR_CODES.EXTENSION_CONTEXT_INVALIDATED,
          message: "OKX Wallet extension context invalidated",
          wallet: WALLET_PROVIDER_NAME$5
        }) : new WalletError({
          code: ERROR_CODES.CONNECTION_FAILED,
          message: (b == null ? void 0 : b.message) || "Failed to connect to OKX Wallet",
          wallet: WALLET_PROVIDER_NAME$5
        });
    }
    const p = await this.wallet.keplr.getKey(this.chainId);
    if (!p)
      throw new WalletError({
        code: ERROR_CODES.FAILED_TO_GET_KEY,
        message: "Failed to get OKX Wallet key",
        wallet: WALLET_PROVIDER_NAME$5
      });
    const { bech32Address: a, pubKey: A } = p;
    if (a && A)
      this.walletInfo = {
        publicKeyHex: Buffer$1$1.from(p.pubKey).toString("hex"),
        address: a
      };
    else
      throw new WalletError({
        code: ERROR_CODES.CONNECTION_FAILED,
        message: "Could not connect to OKX Wallet",
        wallet: WALLET_PROVIDER_NAME$5
      });
  }
  async getAddress() {
    if (!this.walletInfo)
      throw new WalletError({
        code: ERROR_CODES.WALLET_NOT_CONNECTED,
        message: "Wallet not connected",
        wallet: WALLET_PROVIDER_NAME$5
      });
    return this.walletInfo.address;
  }
  async getPublicKeyHex() {
    if (!this.walletInfo)
      throw new WalletError({
        code: ERROR_CODES.WALLET_NOT_CONNECTED,
        message: "Wallet not connected",
        wallet: WALLET_PROVIDER_NAME$5
      });
    return this.walletInfo.publicKeyHex;
  }
  async getWalletProviderName() {
    return WALLET_PROVIDER_NAME$5;
  }
  async getWalletProviderIcon() {
    return logo$5;
  }
  async getOfflineSigner() {
    if (!this.wallet.keplr)
      throw new WalletError({
        code: ERROR_CODES.EXTENSION_NOT_FOUND,
        message: "OKX Wallet extension not found",
        wallet: WALLET_PROVIDER_NAME$5
      });
    if (!this.chainId)
      throw new WalletError({
        code: ERROR_CODES.CHAIN_ID_NOT_INITIALIZED,
        message: "Chain ID is not initialized",
        wallet: WALLET_PROVIDER_NAME$5
      });
    try {
      return this.wallet.keplr.getOfflineSigner(this.chainId);
    } catch {
      throw new WalletError({
        code: ERROR_CODES.UNKNOWN_ERROR,
        message: "Failed to get offline signer",
        wallet: WALLET_PROVIDER_NAME$5
      });
    }
  }
  async getOfflineSignerAuto() {
    if (!this.wallet.keplr)
      throw new WalletError({
        code: ERROR_CODES.EXTENSION_NOT_FOUND,
        message: "OKX Wallet extension not found",
        wallet: WALLET_PROVIDER_NAME$5
      });
    if (!this.chainId)
      throw new WalletError({
        code: ERROR_CODES.CHAIN_ID_NOT_INITIALIZED,
        message: "Chain ID is not initialized",
        wallet: WALLET_PROVIDER_NAME$5
      });
    try {
      return this.wallet.keplr.getOfflineSignerAuto(this.chainId);
    } catch {
      throw new WalletError({
        code: ERROR_CODES.UNKNOWN_ERROR,
        message: "Failed to get offline signer auto",
        wallet: WALLET_PROVIDER_NAME$5
      });
    }
  }
  getVersion() {
    return this.wallet.getVersion();
  }
}
const metadata$9 = {
  id: "okx",
  name: WALLET_PROVIDER_NAME$5,
  icon: logo$5,
  docs: "https://www.okx.com/web3",
  wallet: "okxwallet",
  createProvider: (n, c) => new OKXBabylonProvider(n, c),
  networks: [Network.MAINNET, Network.SIGNET]
}, metadata$8 = {
  chain: "BBN",
  name: "Babylon Chain",
  icon: icon$1,
  wallets: [metadata$9, metadata$c, metadata$b, metadata$a]
}, icon = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='64'%20height='64'%3e%3cpath%20fill='%23f7931a'%20d='M63.04%2039.741c-4.275%2017.143-21.638%2027.576-38.783%2023.301C7.12%2058.768-3.313%2041.404.962%2024.262%205.234%207.117%2022.597-3.317%2039.737.957c17.144%204.274%2027.576%2021.64%2023.302%2038.784z'/%3e%3cpath%20fill='%23FFF'%20d='M46.11%2027.441c.636-4.258-2.606-6.547-7.039-8.074l1.438-5.768-3.51-.875-1.4%205.616c-.924-.23-1.872-.447-2.814-.662l1.41-5.653-3.509-.875-1.439%205.766c-.764-.174-1.514-.346-2.242-.527l.004-.018-4.842-1.209-.934%203.75s2.605.597%202.55.634c1.422.355%201.68%201.296%201.636%202.042l-1.638%206.571c.098.025.225.061.365.117l-.37-.092-2.297%209.205c-.174.432-.615%201.08-1.609.834.035.051-2.552-.637-2.552-.637l-1.743%204.019%204.57%201.139c.85.213%201.682.436%202.502.646l-1.453%205.834%203.507.875%201.44-5.772c.957.26%201.887.5%202.797.726l-1.434%205.745%203.511.875%201.453-5.823c5.987%201.133%2010.49.676%2012.384-4.739%201.527-4.36-.076-6.875-3.226-8.515%202.294-.529%204.022-2.038%204.483-5.155zM38.086%2038.69c-1.085%204.36-8.426%202.003-10.806%201.412l1.928-7.729c2.38.594%2010.012%201.77%208.878%206.317zm1.086-11.312c-.99%203.966-7.1%201.951-9.082%201.457l1.748-7.01c1.982.494%208.365%201.416%207.334%205.553z'/%3e%3c/svg%3e", metadata$7 = {
  id: "injectable",
  name: (n) => {
    var c;
    return (c = n.getWalletProviderName) == null ? void 0 : c.call(n);
  },
  icon: (n) => {
    var c;
    return (c = n.getWalletProviderIcon) == null ? void 0 : c.call(n);
  },
  docs: "",
  wallet: "btcwallet",
  createProvider: (n) => n,
  networks: [Network.MAINNET, Network.SIGNET],
  label: "Injectable"
}, logo$4 = "data:image/svg+xml,%3csvg%20width='160'%20height='160'%20viewBox='0%200%20160%20160'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M30%2025H90L50%20110H20L30%2025Z'%20fill='black'/%3e%3cpath%20d='M130%20135L70%20135L110%2050L140%2050L130%20135Z'%20fill='%23F5870A'/%3e%3c/svg%3e", byteToHex = [];
for (let n = 0; n < 256; ++n)
  byteToHex.push((n + 256).toString(16).slice(1));
function unsafeStringify(n, c = 0) {
  return (byteToHex[n[c + 0]] + byteToHex[n[c + 1]] + byteToHex[n[c + 2]] + byteToHex[n[c + 3]] + "-" + byteToHex[n[c + 4]] + byteToHex[n[c + 5]] + "-" + byteToHex[n[c + 6]] + byteToHex[n[c + 7]] + "-" + byteToHex[n[c + 8]] + byteToHex[n[c + 9]] + "-" + byteToHex[n[c + 10]] + byteToHex[n[c + 11]] + byteToHex[n[c + 12]] + byteToHex[n[c + 13]] + byteToHex[n[c + 14]] + byteToHex[n[c + 15]]).toLowerCase();
}
let getRandomValues$2;
const rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues$2) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    getRandomValues$2 = crypto.getRandomValues.bind(crypto);
  }
  return getRandomValues$2(rnds8);
}
const randomUUID = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), native = { randomUUID };
function v4(n, c, u) {
  var a;
  if (native.randomUUID && !c && !n)
    return native.randomUUID();
  n = n || {};
  const p = n.random ?? ((a = n.rng) == null ? void 0 : a.call(n)) ?? rng();
  if (p.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return p[6] = p[6] & 15 | 64, p[8] = p[8] & 63 | 128, unsafeStringify(p);
}
class BIP322 {
  /**
   * Compute the message hash as specified in the BIP-322.
   * The standard is specified in BIP-340 as:
   *      The function hashtag(x) where tag is a UTF-8 encoded tag name and x is a byte array returns the 32-byte hash SHA256(SHA256(tag) || SHA256(tag) || x).
   * @param message Message to be hashed
   * @returns Hashed message
   */
  static hashMessage(c) {
    const { sha256: u } = src$j.crypto, p = u(this.TAG);
    return u(Buffer$f.concat([p, p, Buffer$f.from(c)]));
  }
  /**
   * Build a to_spend transaction using simple signature in accordance to the BIP-322.
   * @param message Message to be signed using BIP-322
   * @param scriptPublicKey The script public key for the signing wallet
   * @returns Bitcoin transaction that correspond to the to_spend transaction
   */
  static buildToSpendTx(c, u) {
    const p = new src$j.Psbt();
    p.setVersion(0), p.setLocktime(0);
    const a = this.hashMessage(c), A = 0, b = 32, F = new Uint8Array([A, b]), le = new Uint8Array(F.length + a.length);
    return le.set(F), le.set(a, F.length), p.addInput({
      hash: "0".repeat(64),
      // vin[0].prevout.hash = 0000...000
      index: 4294967295,
      // vin[0].prevout.n = 0xFFFFFFFF
      sequence: 0,
      // vin[0].nSequence = 0
      finalScriptSig: Buffer$f.from(le),
      // vin[0].scriptSig = OP_0 PUSH32[ message_hash ]
      witnessScript: Buffer$f.from([])
      // vin[0].scriptWitness = []
    }), p.addOutput({
      value: 0,
      // vout[0].nValue = 0
      script: u
      // vout[0].scriptPubKey = message_challenge
    }), p.extractTransaction();
  }
  /**
   * Build a to_sign transaction using simple signature in accordance to the BIP-322.
   * @param toSpendTxId Transaction ID of the to_spend transaction as constructed by buildToSpendTx
   * @param witnessScript The script public key for the signing wallet, or the redeemScript for P2SH-P2WPKH address
   * @param isRedeemScript Set to true if the provided witnessScript is a redeemScript for P2SH-P2WPKH address, default to false
   * @param tapInternalKey Used to set the taproot internal public key of a taproot signing address when provided, default to undefined
   * @returns Ready-to-be-signed bitcoinjs.Psbt transaction
   */
  static buildToSignTx(c, u, p = !1, a) {
    const A = new src$j.Psbt();
    return A.setVersion(0), A.setLocktime(0), A.addInput({
      hash: c,
      // vin[0].prevout.hash = to_spend.txid
      index: 0,
      // vin[0].prevout.n = 0
      sequence: 0,
      // vin[0].nSequence = 0
      witnessUtxo: {
        script: u,
        value: 0
      }
    }), p && A.updateInput(0, {
      redeemScript: u
    }), a && A.updateInput(0, {
      tapInternalKey: a
    }), A.addOutput({
      value: 0,
      // vout[0].nValue = 0
      script: Buffer$f.from([106])
      // vout[0].scriptPubKey = OP_RETURN
    }), A;
  }
  /**
   * Encode witness stack in a signed BIP-322 PSBT into its base-64 encoded format.
   * @param signedPsbt Signed PSBT
   * @returns Base-64 encoded witness data
   */
  static encodeWitness(c) {
    const u = c.data.inputs[0].finalScriptWitness;
    if (!u)
      throw new WalletError({
        code: ERROR_CODES.EMPTY_WITNESS_STACK,
        message: "Cannot encode empty witness stack."
      });
    return u.toString("base64");
  }
}
// BIP322 message tag
As(BIP322, "TAG", Buffer$f.from("BIP0322-signed-message"));
const HEX_STRINGS = "0123456789abcdefABCDEF";
HEX_STRINGS.split("").map((n) => n.codePointAt(0));
Array(256).fill(!0).map((n, c) => {
  const u = String.fromCodePoint(c), p = HEX_STRINGS.indexOf(u);
  return p < 0 ? void 0 : p < 16 ? p : p - 6;
});
new TextEncoder();
new TextDecoder("ascii");
function compare$c(n, c) {
  const u = Math.min(n.length, c.length);
  for (let p = 0; p < u; ++p)
    if (n[p] !== c[p])
      return n[p] < c[p] ? -1 : 1;
  return n.length === c.length ? 0 : n.length > c.length ? 1 : -1;
}
const ERROR_BAD_PRIVATE = 0, ERROR_BAD_POINT = 1, ERROR_BAD_TWEAK = 2, ERROR_BAD_HASH = 3, ERROR_BAD_SIGNATURE = 4, ERROR_BAD_EXTRA_DATA = 5, ERROR_BAD_PARITY = 6, ERROR_BAD_RECOVERY_ID = 7, ERRORS_MESSAGES = {
  [ERROR_BAD_PRIVATE.toString()]: "Expected Private",
  [ERROR_BAD_POINT.toString()]: "Expected Point",
  [ERROR_BAD_TWEAK.toString()]: "Expected Tweak",
  [ERROR_BAD_HASH.toString()]: "Expected Hash",
  [ERROR_BAD_SIGNATURE.toString()]: "Expected Signature",
  [ERROR_BAD_EXTRA_DATA.toString()]: "Expected Extra Data (32 bytes)",
  [ERROR_BAD_PARITY.toString()]: "Expected Parity (1 | 0)",
  [ERROR_BAD_RECOVERY_ID.toString()]: "Bad Recovery Id"
};
function throwError(n) {
  const c = ERRORS_MESSAGES[n.toString()] || `Unknow error code: ${n}`;
  throw new TypeError(c);
}
const $_validate_error_js = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ERROR_BAD_EXTRA_DATA,
  ERROR_BAD_HASH,
  ERROR_BAD_PARITY,
  ERROR_BAD_POINT,
  ERROR_BAD_PRIVATE,
  ERROR_BAD_RECOVERY_ID,
  ERROR_BAD_SIGNATURE,
  ERROR_BAD_TWEAK,
  throwError
}, Symbol.toStringTag, { value: "Module" })), PRIVATE_KEY_SIZE = 32, PUBLIC_KEY_COMPRESSED_SIZE = 33, PUBLIC_KEY_UNCOMPRESSED_SIZE = 65, X_ONLY_PUBLIC_KEY_SIZE = 32, TWEAK_SIZE = 32, HASH_SIZE = 32, EXTRA_DATA_SIZE = 32, SIGNATURE_SIZE = 64, BN32_ZERO = new Uint8Array(32), BN32_N = new Uint8Array([
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  254,
  186,
  174,
  220,
  230,
  175,
  72,
  160,
  59,
  191,
  210,
  94,
  140,
  208,
  54,
  65,
  65
]), BN32_P_MINUS_N = new Uint8Array([
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1,
  69,
  81,
  35,
  25,
  80,
  183,
  95,
  196,
  64,
  45,
  161,
  114,
  47,
  201,
  186,
  238
]);
function isUint8Array(n) {
  return n instanceof Uint8Array;
}
function cmpBN32(n, c) {
  for (let u = 0; u < 32; ++u)
    if (n[u] !== c[u])
      return n[u] < c[u] ? -1 : 1;
  return 0;
}
function isZero(n) {
  return cmpBN32(n, BN32_ZERO) === 0;
}
function isPrivate$1(n) {
  return isUint8Array(n) && n.length === PRIVATE_KEY_SIZE && cmpBN32(n, BN32_ZERO) > 0 && cmpBN32(n, BN32_N) < 0;
}
function isPoint$2(n) {
  return isUint8Array(n) && (n.length === PUBLIC_KEY_COMPRESSED_SIZE || n.length === PUBLIC_KEY_UNCOMPRESSED_SIZE || n.length === X_ONLY_PUBLIC_KEY_SIZE);
}
function isXOnlyPoint$1(n) {
  return isUint8Array(n) && n.length === X_ONLY_PUBLIC_KEY_SIZE;
}
function isDERPoint(n) {
  return isUint8Array(n) && (n.length === PUBLIC_KEY_COMPRESSED_SIZE || n.length === PUBLIC_KEY_UNCOMPRESSED_SIZE);
}
function isPointCompressed$1(n) {
  return isUint8Array(n) && n.length === PUBLIC_KEY_COMPRESSED_SIZE;
}
function isTweak(n) {
  return isUint8Array(n) && n.length === TWEAK_SIZE && cmpBN32(n, BN32_N) < 0;
}
function isHash(n) {
  return isUint8Array(n) && n.length === HASH_SIZE;
}
function isExtraData(n) {
  return n === void 0 || isUint8Array(n) && n.length === EXTRA_DATA_SIZE;
}
function isSignature(n) {
  return isUint8Array(n) && n.length === 64 && cmpBN32(n.subarray(0, 32), BN32_N) < 0 && cmpBN32(n.subarray(32, 64), BN32_N) < 0;
}
function isSigrLessThanPMinusN(n) {
  return isUint8Array(n) && n.length === 64 && cmpBN32(n.subarray(0, 32), BN32_P_MINUS_N) < 0;
}
function validateParity(n) {
  n !== 0 && n !== 1 && throwError(ERROR_BAD_PARITY);
}
function validatePrivate(n) {
  isPrivate$1(n) || throwError(ERROR_BAD_PRIVATE);
}
function validatePoint(n) {
  isPoint$2(n) || throwError(ERROR_BAD_POINT);
}
function validateXOnlyPoint(n) {
  isXOnlyPoint$1(n) || throwError(ERROR_BAD_POINT);
}
function validateTweak(n) {
  isTweak(n) || throwError(ERROR_BAD_TWEAK);
}
function validateHash(n) {
  isHash(n) || throwError(ERROR_BAD_HASH);
}
function validateExtraData(n) {
  isExtraData(n) || throwError(ERROR_BAD_EXTRA_DATA);
}
function validateSignature(n) {
  isSignature(n) || throwError(ERROR_BAD_SIGNATURE);
}
function validateSignatureCustom(n) {
  n() || throwError(ERROR_BAD_SIGNATURE);
}
function validateSignatureNonzeroRS(n) {
  isZero(n.subarray(0, 32)) && throwError(ERROR_BAD_SIGNATURE), isZero(n.subarray(32, 64)) && throwError(ERROR_BAD_SIGNATURE);
}
function validateSigrPMinusN(n) {
  isSigrLessThanPMinusN(n) || throwError(ERROR_BAD_RECOVERY_ID);
}
function get4RandomBytes() {
  const n = new Uint8Array(4);
  if (typeof crypto > "u")
    throw new Error("The crypto object is unavailable. This may occur if your environment does not support the Web Cryptography API.");
  return crypto.getRandomValues(n), n;
}
function generateInt32() {
  const n = get4RandomBytes();
  return (n[0] << 3 * 8) + (n[1] << 2 * 8) + (n[2] << 1 * 8) + n[3];
}
const $_rand_js = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generateInt32
}, Symbol.toStringTag, { value: "Module" }));
var bufferView, base64ReverseLookup = new Uint8Array(
  123
  /*'z'+1*/
);
for (var i = 25; i >= 0; --i)
  base64ReverseLookup[48 + i] = 52 + i, base64ReverseLookup[65 + i] = i, base64ReverseLookup[97 + i] = 26 + i;
base64ReverseLookup[43] = 62;
base64ReverseLookup[47] = 63;
function base64DecodeToExistingUint8Array(n, c, u) {
  for (var p, a, A = 0, b = c, F = u.length, le = c + (F * 3 >> 2) - (u[F - 2] == "=") - (u[F - 1] == "="); A < F; A += 4)
    p = base64ReverseLookup[u.charCodeAt(A + 1)], a = base64ReverseLookup[u.charCodeAt(A + 2)], n[b++] = base64ReverseLookup[u.charCodeAt(A)] << 2 | p >> 4, b < le && (n[b++] = p << 4 | a >> 2), b < le && (n[b++] = a << 6 | base64ReverseLookup[u.charCodeAt(A + 3)]);
}
function initActiveSegments(n) {
  base64DecodeToExistingUint8Array(bufferView, 655360, "AQAAAAQAAAAEAAAAAgAAAAEAAAAEAAAABAAAAAM="), base64DecodeToExistingUint8Array(bufferView, 655716, "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"), base64DecodeToExistingUint8Array(bufferView, 689368, "BgAAAAAAAAAG"), base64DecodeToExistingUint8Array(bufferView, 689392, "BgAAAAAAAAByZXQASW52YWxpZCBmbGFncwBzZWxmIHRlc3QgZmFpbGVkAEZvciB0aGlzIHNhbXBsZSwgdGhpcyA2My1ieXRlIHN0cmluZyB3aWxsIGJlIHVzZWQgYXMgaW5wdXQgZGF0YQAoZmxhZ3MgJiBTRUNQMjU2SzFfRkxBR1NfVFlQRV9NQVNLKSA9PSBTRUNQMjU2SzFfRkxBR1NfVFlQRV9DT01QUkVTU0lPTgBzZWNrZXkgIT0gTlVMTAB4b25seV9wdWJrZXkgIT0gTlVMTABvdXRwdXRfcHVia2V5ICE9IE5VTEwAaW50ZXJuYWxfcHVia2V5ICE9IE5VTEwAb3V0cHV0ICE9IE5VTEwAaW5wdXQgIT0gTlVMTABwdWJub25jZXMgIT0gTlVMTABrZXlwYWlyICE9IE5VTEwAc2lnaW4gIT0gTlVMTABvdXRwdXRsZW4gIT0gTlVMTABzaWcgIT0gTlVMTABzaWduYXR1cmUgIT0gTlVMTABwdWJub25jZSAhPSBOVUxMAHJlY2lkICE9IE5VTEwAcHVibm9uY2VzW2ldICE9IE5VTEwAb3V0cHV0NjQgIT0gTlVMTABpbnB1dDY0ICE9IE5VTEwAc2lnNjQgIT0gTlVMTABzZWNrZXkzMiAhPSBOVUxMAHR3ZWFrZWRfcHVia2V5MzIgIT0gTlVMTABvdXRwdXQzMiAhPSBOVUxMAGlucHV0MzIgIT0gTlVMTAB0d2VhazMyICE9IE5VTEwAbXNnaGFzaDMyICE9IE5VTEwAcmVjaWQgPj0gMCAmJiByZWNpZCA8PSAzAG4gPj0gMQBtc2cgIT0gTlVMTCB8fCBtc2dsZW4gPT0gMABydXN0c2VjcDI1NmsxX3YwXzhfMV9lY211bHRfZ2VuX2NvbnRleHRfaXNfYnVpbHQoJmN0eC0+ZWNtdWx0X2dlbl9jdHgpACFydXN0c2VjcDI1NmsxX3YwXzhfMV9mZV9pc196ZXJvKCZnZS0+eCkAKm91dHB1dGxlbiA+PSAoKGZsYWdzICYgU0VDUDI1NksxX0ZMQUdTX0JJVF9DT01QUkVTU0lPTikgPyAzM3UgOiA2NXUpAAAAAAAABgAAAAAAAAAEAAAAAAAAAAE="), base64DecodeToExistingUint8Array(bufferView, 690288, "8Ip4y7ruCCsFKuBwjzL6HlDFxCGqdyul27QGoupr40JBQTbQjF7SP+6AIr2ac7sq6/////////8="), base64DecodeToExistingUint8Array(bufferView, 690353, "AQAAAAAAAMFOd6qZAPI0AAEAAAAAAACYF/gWW4ECAJ+VjeLcsg0A/JsCBwuHDgBcKQZaxboLANz5fma+eQAAuNQQ+4/QBwDEmUFVaIoEALQX/agIEQ4AwL9P2lVGDACjJnfaOkg="), base64DecodeToExistingUint8Array(bufferView, 690464, "L/z///7///8="), base64DecodeToExistingUint8Array(bufferView, 690497, "AQAAAAAAAM/K2i3i9scngA=="), base64DecodeToExistingUint8Array(bufferView, 690576, "w+S/Cql/VG8oiA4B1n5D5A=="), base64DecodeToExistingUint8Array(bufferView, 690608, "LFaxPajNZddtNHQHxQooiv7///////////////////8xsNtFmiCT6H/K6HEUiqo9FeuEkuSQbOjNa9SnIdKGMHF/xIqutHEVxgb1nawIEiLE5L8KqX9UbyiIDgHWfkPkcr0jG3yWAt94ZoEg6iIuElpkEogCHCal4DBcwEytY1NCSVAwMzQwL25vbmNl"), base64DecodeToExistingUint8Array(bufferView, 690752, "MIQK");
}
function wasm2js_trap() {
  throw new Error("abort");
}
function asmFunc(n) {
  var c = new ArrayBuffer(720896), u = new Int8Array(c), p = new Int16Array(c), a = new Int32Array(c), A = new Uint8Array(c), b = new Uint16Array(c), F = Math.imul, le = Math.clz32, L = n["./rand.js"], pe = L.generateInt32, $ = n["./validate_error.js"], Ee = $.throwError, be = 655360, He = 690820, Pe = 655584, nr = 690949, ir = 690885, or = 690917, lr = 690788, Ir = 655649, xr = 655681, kr = 690981, Ce = 691052, tr = 691056, Fe = 0;
  function Sr(B, o) {
    B = B | 0, o = o | 0;
    var m = 0, d = 0, v = 0;
    v = be - 128 | 0, be = v, B = a[B >> 2];
    e: {
      t: {
        r: {
          i: {
            if (m = a[o + 24 >> 2], !(m & 16)) {
              if (m & 32)
                break i;
              B = a[B >> 2], m = (B | 0) >= 0, B = er(m ? B : 0 - B | 0, m ? 0 : 0 - ((B >> 31) + ((B | 0) != 0) | 0) | 0, m, o);
              break r;
            }
            for (B = a[B >> 2], m = 0; d = B & 15, u[(m + v | 0) + 127 | 0] = d + (d >>> 0 < 10 ? 48 : 87), m = m - 1 | 0, d = B >>> 0 > 15, B = B >>> 4 | 0, !!d; )
              ;
            if (m + 128 >>> 0 >= 129)
              break t;
            B = Ie(o, 1, 2, (m + v | 0) + 128 | 0, 0 - m | 0);
            break r;
          }
          for (B = a[B >> 2], m = 0; d = B & 15, u[(m + v | 0) + 127 | 0] = d + (d >>> 0 < 10 ? 48 : 55), m = m - 1 | 0, d = B >>> 0 > 15, B = B >>> 4 | 0, !!d; )
            ;
          if (m + 128 >>> 0 >= 129)
            break e;
          B = Ie(o, 1, 2, (m + v | 0) + 128 | 0, 0 - m | 0);
        }
        return be = v + 128 | 0, B | 0;
      }
      wasm2js_trap();
    }
    wasm2js_trap();
  }
  function er(B, o, m, d) {
    var v = 0, he = 0, we = 0, Be = 0, Me = 0, fr = 0, wr = 0, dr = 0, Dr = 0, Rr = 0, Qe = 0, Fr = 0, Gr = 0;
    if (wr = be - 48 | 0, be = wr, Be = 39, !(!o & B >>> 0 < 1e4))
      for (; ; ) {
        Rr = (wr + 9 | 0) + Be | 0, Qe = Rr - 4 | 0, he = B, fr = 0, dr = 0;
        e: {
          t: {
            if (!o) {
              B = (he >>> 0) / 1e4 | 0;
              break t;
            }
            if (we = 51 - le(o) | 0, v = 0 - we | 0, Me = we & 63, B = Me & 31, Me >>> 0 >= 32 ? Me = o >>> B | 0 : (fr = o >>> B | 0, Me = ((1 << B) - 1 & o) << 32 - B | he >>> B), v = v & 63, B = v & 31, v >>> 0 >= 32 ? (v = he << B, B = 0) : (v = (1 << B) - 1 & he >>> 32 - B | o << B, B = he << B), we)
              for (; Fr = fr << 1 | Me >>> 31, Dr = Me << 1 | v >>> 31, Gr = 0 - (Fr + (Dr >>> 0 > 9999) | 0) >> 31, fr = Gr & 1e4, Me = Dr - fr | 0, fr = Fr - (fr >>> 0 > Dr >>> 0) | 0, v = v << 1 | B >>> 31, B = B << 1 | dr, dr = Gr & 1, we = we - 1 | 0, !!we; )
                ;
            Fe = v << 1 | B >>> 31, B = B << 1 | dr;
            break e;
          }
          Fe = 0;
        }
        if (Me = Fe, v = oi(B, Me, 55536, 0) + he | 0, fr = ((v & 65535) >>> 0) / 100 | 0, we = (fr << 1) + 655718 | 0, we = A[we | 0] | A[we + 1 | 0] << 8, u[Qe | 0] = we, u[Qe + 1 | 0] = we >>> 8, we = Rr - 2 | 0, v = ((F(fr, -100) + v & 65535) << 1) + 655718 | 0, v = A[v | 0] | A[v + 1 | 0] << 8, u[we | 0] = v, u[we + 1 | 0] = v >>> 8, Be = Be - 4 | 0, he = !o & he >>> 0 > 99999999 | (o | 0) != 0, o = Me, !he)
          break;
      }
    B >>> 0 > 99 && (Be = Be - 2 | 0, o = Be + (wr + 9 | 0) | 0, Me = B, B = ((B & 65535) >>> 0) / 100 | 0, he = ((Me + F(B, -100) & 65535) << 1) + 655718 | 0, he = A[he | 0] | A[he + 1 | 0] << 8, u[o | 0] = he, u[o + 1 | 0] = he >>> 8);
    e: {
      if (B >>> 0 >= 10) {
        Be = Be - 2 | 0, o = Be + (wr + 9 | 0) | 0, B = (B << 1) + 655718 | 0, B = A[B | 0] | A[B + 1 | 0] << 8, u[o | 0] = B, u[o + 1 | 0] = B >>> 8;
        break e;
      }
      Be = Be - 1 | 0, u[Be + (wr + 9 | 0) | 0] = B + 48;
    }
    return B = Ie(d, m, 0, (wr + 9 | 0) + Be | 0, 39 - Be | 0), be = wr + 48 | 0, B;
  }
  function Ie(B, o, m, d, v) {
    var he = 0, we = 0, Be = 0, Me = 0, fr = 0, wr = 0, dr = 0, Dr = 0;
    fr = 655716;
    e: {
      if (o) {
        he = a[B + 24 >> 2], o = he & 1, wr = o ? 43 : 1114112, we = o + v | 0;
        break e;
      }
      he = a[B + 24 >> 2], wr = 45, we = v + 1 | 0;
    }
    e: {
      if (!(he & 4)) {
        fr = 0;
        break e;
      }
      t: {
        if (!m || (Be = m & 3, !Be))
          break t;
        for (o = 655716; Me = Me + (u[o | 0] > -65) | 0, o = o + 1 | 0, Be = Be - 1 | 0, !!Be; )
          ;
      }
      we = we + Me | 0;
    }
    e: {
      t: {
        if (!a[B + 8 >> 2]) {
          if (o = 1, we = a[B >> 2], B = a[B + 4 >> 2], _i(we, B, wr, fr, m))
            break t;
          break e;
        }
        r: {
          i: {
            n: {
              o: {
                if (Be = a[B + 12 >> 2], Be >>> 0 > we >>> 0) {
                  if (he & 8)
                    break r;
                  switch (he = Be - we | 0, we = he, o = A[B + 32 | 0], o = (o | 0) == 3 ? 1 : o, o - 1 | 0) {
                    case 1:
                      break n;
                    case 0:
                      break o;
                    default:
                      break i;
                  }
                }
                if (o = 1, we = a[B >> 2], B = a[B + 4 >> 2], _i(we, B, wr, fr, m))
                  break t;
                break e;
              }
              we = 0, o = he;
              break i;
            }
            o = he >>> 1 | 0, we = he + 1 >>> 1 | 0;
          }
          o = o + 1 | 0, he = a[B + 4 >> 2], Me = a[B + 28 >> 2], Be = a[B >> 2];
          i: {
            for (; ; ) {
              if (o = o - 1 | 0, !o)
                break i;
              if (ji[a[he + 16 >> 2]](Be, Me) | 0)
                break;
            }
            return 1;
          }
          if (o = 1, (Me | 0) == 1114112 || _i(Be, he, wr, fr, m) || ji[a[he + 12 >> 2]](Be, d, v) | 0)
            break t;
          o = 0;
          i: {
            for (; ; ) {
              if (B = we, (B | 0) == (o | 0))
                break i;
              if (o = o + 1 | 0, !!(ji[a[he + 16 >> 2]](Be, Me) | 0))
                break;
            }
            B = o - 1 | 0;
          }
          o = B >>> 0 < we >>> 0;
          break t;
        }
        if (dr = a[B + 28 >> 2], a[B + 28 >> 2] = 48, Dr = A[B + 32 | 0], o = 1, u[B + 32 | 0] = 1, he = a[B >> 2], Me = a[B + 4 >> 2], _i(he, Me, wr, fr, m))
          break t;
        o = (Be - we | 0) + 1 | 0;
        r: {
          for (; ; ) {
            if (o = o - 1 | 0, !o)
              break r;
            if (ji[a[Me + 16 >> 2]](he, 48) | 0)
              break;
          }
          return 1;
        }
        if (o = 1, ji[a[Me + 12 >> 2]](he, d, v) | 0)
          break t;
        return u[B + 32 | 0] = Dr, a[B + 28 >> 2] = dr, 0;
      }
      return o;
    }
    return ji[a[B + 12 >> 2]](we, d, v) | 0;
  }
  function xe(B, o) {
    B = B | 0, o = o | 0;
    var m = 0, d = 0, v = 0;
    v = be - 128 | 0, be = v, B = a[B >> 2];
    e: {
      t: {
        r: {
          i: {
            if (m = a[o + 24 >> 2], !(m & 16)) {
              if (m & 32)
                break i;
              B = er(a[B >> 2], 0, 1, o);
              break r;
            }
            for (B = a[B >> 2], m = 0; d = B & 15, u[(m + v | 0) + 127 | 0] = d + (d >>> 0 < 10 ? 48 : 87), m = m - 1 | 0, d = B >>> 0 > 15, B = B >>> 4 | 0, !!d; )
              ;
            if (m + 128 >>> 0 >= 129)
              break t;
            B = Ie(o, 1, 2, (m + v | 0) + 128 | 0, 0 - m | 0);
            break r;
          }
          for (B = a[B >> 2], m = 0; d = B & 15, u[(m + v | 0) + 127 | 0] = d + (d >>> 0 < 10 ? 48 : 55), m = m - 1 | 0, d = B >>> 0 > 15, B = B >>> 4 | 0, !!d; )
            ;
          if (m + 128 >>> 0 >= 129)
            break e;
          B = Ie(o, 1, 2, (m + v | 0) + 128 | 0, 0 - m | 0);
        }
        return be = v + 128 | 0, B | 0;
      }
      wasm2js_trap();
    }
    wasm2js_trap();
  }
  function rr(B) {
  }
  function ar(B) {
    var o = 0, m = 0, d = 0, v = 0, he = 0;
    d = be - 32 | 0, be = d, o = B + 16 | 0, v = a[o + 4 >> 2], m = d + 8 | 0, he = m + 16 | 0, a[he >> 2] = a[o >> 2], a[he + 4 >> 2] = v, o = B + 8 | 0, v = a[o + 4 >> 2], m = m + 8 | 0, a[m >> 2] = a[o >> 2], a[m + 4 >> 2] = v, o = a[B + 4 >> 2], a[d + 8 >> 2] = a[B >> 2], a[d + 12 >> 2] = o, wasm2js_trap();
  }
  function yr() {
    var B = 0, o = 0, m = 0, d = 0, v = 0, he = 0, we = 0, Be = 0, Me = 0, fr = 0, wr = 0, dr = 0, Dr = 0, Rr = 0, Qe = 0, Fr = 0, Gr = 0, $r = 0, ni = 0, mi = 0, Si = 0, Oi = 0, $i = 0, zi = 0, un = 0, In = 0, Ti = 0, Sn = 0, Kn = 0, Vn = 0, Xn = 0, uo = 0, yo = 0, Io = 0, xo = 0, Mo = 0, qi = 0, Oo = 0, Ho = 0, Go = 0, ns = 0, ds = 0, Ts = 0, Ao = 0, po = 0, _o = 0, Uo = 0, ts = 0, Lo = 0, Wo = 0, ps = 0;
    Io = be - 32 | 0, be = Io;
    e: {
      if (A[690756]) {
        ts = a[172762];
        break e;
      }
      for (a[Io >> 2] = 192, a[Io + 4 >> 2] = 192, B = be - 144 | 0, be = B, a[B + 104 >> 2] = 0, a[B + 108 >> 2] = 0, a[B + 32 >> 2] = 528734635, a[B + 36 >> 2] = 1541459225, a[B + 24 >> 2] = 1359893119, a[B + 28 >> 2] = -1694144372, a[B + 16 >> 2] = 1013904242, a[B + 20 >> 2] = -1521486534, a[B + 8 >> 2] = 1779033703, a[B + 12 >> 2] = -1150833019, o = B + 8 | 0, Di(o, 689435, 63), _n(o, B + 112 | 0); v = A[(B + 112 | 0) + d | 0] - A[d + 690288 | 0] | 0, !!(!v && (o = (d | 0) != 31, d = d + 1 | 0, o)); )
        ;
      v && Er(689418, 0), a[163880] = 0, a[163881] = 0, a[163878] = 1, a[163879] = 0, o = a[172349], a[163892] = a[172348], a[163893] = o, o = a[172559], a[163890] = a[172558], a[163891] = o, o = a[172595], a[163858] = a[172594], a[163859] = o, o = a[172597], a[163860] = a[172596], a[163861] = o, o = a[172599], a[163862] = a[172598], a[163863] = o, o = a[172601], a[163864] = a[172600], a[163865] = o, o = a[172603], a[163866] = a[172602], a[163867] = o, a[163882] = 0, a[163883] = 0, a[163884] = 0, a[163885] = 0, a[163886] = 0, a[163887] = 0, a[163888] = 0, a[163876] = 629725529, a[163877] = 243653, a[163874] = 632307772, a[163875] = 3389866, a[163872] = 1459808328, a[163873] = 3272439, a[163870] = -1430362568, a[163871] = 3896727, a[163868] = 82779140, a[163869] = 3682156, a[163856] = 0, a[163857] = 0, a[163850] = 1, a[163851] = 0, a[163854] = 0, a[163855] = 0, a[163852] = 0, a[163853] = 0, a[163894] = 0, a[163848] = 1, be = B + 144 | 0, ts = 655392, Wo = 690756, ps = pe() | 0, a[Wo >> 2] = ps, Wo = 690760, ps = pe() | 0, a[Wo >> 2] = ps, Wo = 690764, ps = pe() | 0, a[Wo >> 2] = ps, Wo = 690768, ps = pe() | 0, a[Wo >> 2] = ps, Wo = 690772, ps = pe() | 0, a[Wo >> 2] = ps, Wo = 690776, ps = pe() | 0, a[Wo >> 2] = ps, Wo = 690780, ps = pe() | 0, a[Wo >> 2] = ps, Wo = 690784, ps = pe() | 0, a[Wo >> 2] = ps, Qe = be - 720 | 0, be = Qe, a[163848] && (B = A[690760] | A[690761] << 8 | (A[690762] << 16 | A[690763] << 24), Dr = Qe + 336 | 0, Rr = Dr + 32 | 0, a[Rr >> 2] = A[690756] | A[690757] << 8 | (A[690758] << 16 | A[690759] << 24), a[Rr + 4 >> 2] = B, B = A[690768] | A[690769] << 8 | (A[690770] << 16 | A[690771] << 24), wr = Dr + 40 | 0, a[wr >> 2] = A[690764] | A[690765] << 8 | (A[690766] << 16 | A[690767] << 24), a[wr + 4 >> 2] = B, B = A[690776] | A[690777] << 8 | (A[690778] << 16 | A[690779] << 24), Be = Qe + 384 | 0, a[Be >> 2] = A[690772] | A[690773] << 8 | (A[690774] << 16 | A[690775] << 24), a[Be + 4 >> 2] = B, B = A[690784] | A[690785] << 8 | (A[690786] << 16 | A[690787] << 24), Me = Qe + 392 | 0, a[Me >> 2] = A[690780] | A[690781] << 8 | (A[690782] << 16 | A[690783] << 24), a[Me + 4 >> 2] = B, v = a[163850], he = v << 8 & 16711680 | v << 24, m = v >>> 8 | 0, o = a[163851], d = (m | o << 24) & 65280, v = v >>> 24 | 0, he = he | (d | (v | o << 8) & 255), B = o, d = (m | (B & 255) << 24) & -16777216, d = d | (v | (B & 16777215) << 8) & 16711680, fr = Dr + 24 | 0, a[fr >> 2] = B >>> 8 & 65280 | B >>> 24 | d, a[fr + 4 >> 2] = he, v = a[163852], he = v << 8 & 16711680 | v << 24, o = a[163853], d = (o << 24 | v >>> 8) & 65280, he = he | (d | (o << 8 | v >>> 24) & 255), B = o, d = ((B & 255) << 24 | v >>> 8) & -16777216, d = d | ((B & 16777215) << 8 | v >>> 24) & 16711680, dr = Dr + 16 | 0, a[dr >> 2] = B >>> 8 & 65280 | B >>> 24 | d, a[dr + 4 >> 2] = he, v = a[163856], he = v << 8 & 16711680 | v << 24, o = a[163857], d = (o << 24 | v >>> 8) & 65280, he = he | (d | (o << 8 | v >>> 24) & 255), B = o, d = ((B & 255) << 24 | v >>> 8) & -16777216, d = d | ((B & 16777215) << 8 | v >>> 24) & 16711680, m = Qe, a[m + 336 >> 2] = B >>> 8 & 65280 | B >>> 24 | d, a[m + 340 >> 2] = he, v = a[163854], he = v << 8 & 16711680 | v << 24, o = a[163855], d = (o << 24 | v >>> 8) & 65280, he = he | (d | (o << 8 | v >>> 24) & 255), B = o, d = ((B & 255) << 24 | v >>> 8) & -16777216, d = d | ((B & 16777215) << 8 | v >>> 24) & 16711680, a[m + 344 >> 2] = B >>> 8 & 65280 | B >>> 24 | d, a[m + 348 >> 2] = he, Go = m + 408 | 0, Bo(Go, Dr, 64), a[Me >> 2] = 0, a[Me + 4 >> 2] = 0, a[Be >> 2] = 0, a[Be + 4 >> 2] = 0, a[wr >> 2] = 0, a[wr + 4 >> 2] = 0, a[Rr >> 2] = 0, a[Rr + 4 >> 2] = 0, a[fr >> 2] = 0, a[fr + 4 >> 2] = 0, a[dr >> 2] = 0, a[dr + 4 >> 2] = 0, a[m + 344 >> 2] = 0, a[m + 348 >> 2] = 0, a[m + 336 >> 2] = 0, a[m + 340 >> 2] = 0, xo = m + 480 | 0, co(Go, xo), o = A[m + 497 | 0], B = o >>> 24 | 0, d = A[m + 498 | 0] | o << 8, o = B, _o = xo + 16 | 0, v = A[_o | 0], B = v >>> 16 | 0, d = v << 16 | d, v = B | o, o = A[m + 495 | 0], B = o >>> 8 | 0, d = d | o << 24, dr = A[m + 492 | 0], v = A[m + 494 | 0] | (B | v) | A[m + 493 | 0] << 8 | (dr & 15) << 16, o = A[m + 484 | 0], B = o >>> 24 | 0, we = A[m + 485 | 0] | o << 8, o = B, he = A[m + 483 | 0], B = he >>> 16 | 0, we = he << 16 | we, he = B | o, o = A[m + 482 | 0], B = o >>> 8 | 0, Dr = o << 24 | we, Rr = A[m + 481 | 0] | (B | he) | A[m + 480 | 0] << 8, o = A[m + 491 | 0], B = o >>> 28 | 0, we = o << 4 | dr >>> 4, o = B, he = A[m + 490 | 0], B = he >>> 20 | 0, we = he << 12 | we, he = B | o, o = A[m + 489 | 0], B = o >>> 12 | 0, we = o << 20 | we, he = B | he, o = A[m + 488 | 0], B = o >>> 4 | 0, wr = o << 28 | we, Be = B | he | A[m + 487 | 0] << 4 | A[m + 486 | 0] << 12, Uo = xo + 24 | 0, o = A[Uo | 0], B = o >>> 28 | 0, Me = A[m + 505 | 0], we = o << 4 | Me >>> 4, o = B, he = A[m + 503 | 0], B = he >>> 20 | 0, we = he << 12 | we, he = B | o, o = A[m + 502 | 0], B = o >>> 12 | 0, we = o << 20 | we, he = B | he, o = A[m + 501 | 0], B = o >>> 4 | 0, fr = o << 28 | we, Si = B | he | A[m + 500 | 0] << 4 | A[m + 499 | 0] << 12, dr = Si, o = A[m + 510 | 0], B = o >>> 24 | 0, we = A[m + 511 | 0] | o << 8, o = B, he = A[m + 509 | 0], B = he >>> 16 | 0, we = he << 16 | we, he = B | o, o = A[m + 508 | 0], B = o >>> 8 | 0, Vn = m + 520 | 0, ns = Vn + 32 | 0, o = we | o << 24, Me = A[m + 507 | 0] | (B | he) | A[m + 506 | 0] << 8 | (Me & 15) << 16, B = !(Dr | (wr | (d | (o | fr))) | (Rr | (Be | (v | (Me | dr))))) | (d & fr & wr) == -1 & (v & dr & Be) == 1048575 & ((Dr | 0) == -1 & (Rr | 0) == 65535) & ((Me | 0) == 1048574 & o >>> 0 > 4294966318 | Me >>> 0 > 1048574), he = B - 1 | 0, dr = he & Dr, a[ns >> 2] = dr, we = Rr, Rr = 0 - !B | 0, we = we & Rr, a[ns + 4 >> 2] = we, ds = Vn + 24 | 0, zi = he & wr, a[ds >> 2] = zi, un = Be & Rr, a[ds + 4 >> 2] = un, Ts = Vn + 16 | 0, ni = d & he, a[Ts >> 2] = ni, Fr = v & Rr, a[Ts + 4 >> 2] = Fr, Ao = Vn + 8 | 0, Oi = he & fr, a[Ao >> 2] = Oi, Gr = Rr & Si, a[Ao + 4 >> 2] = Gr, he = o & he | B, a[m + 520 >> 2] = he, B = Me & Rr, Si = B, a[m + 524 >> 2] = B, Dr = m + 128 | 0, Xn = he << 1, In = B << 1 | he >>> 31, Lr(Dr, Xn, In, 0, 0, zi, un, 0, 0), Rr = m + 192 | 0, v = Oi << 1, d = Gr << 1 | Oi >>> 31, Lr(Rr, v, d, 0, 0, ni, Fr, 0, 0), Be = m + 320 | 0, Lr(Be, dr, we, 0, 0, dr, we, 0, 0), Me = m + 304 | 0, Lr(Me, a[m + 320 >> 2], a[m + 324 >> 2], 0, 0, 15632, 16, 0, 0), o = dr, B = we << 1 | o >>> 31, Mo = m + 80 | 0, po = o << 1, Ti = B, Lr(Mo, po, B, 0, 0, he, Si, 0, 0), qi = m + 176 | 0, Lr(qi, v, d, 0, 0, zi, un, 0, 0), Oo = m + 240 | 0, Lr(Oo, ni, Fr, 0, 0, ni, Fr, 0, 0), wr = m + 288 | 0, B = Be + 8 | 0, Lr(wr, a[B >> 2], a[B + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Lr(m, he, Si, 0, 0, he, Si, 0, 0), Lo = m + 160 | 0, Lr(Lo, po, Ti, 0, 0, Oi, Gr, 0, 0), uo = m + 208 | 0, Lr(uo, ni << 1, Fr << 1 | ni >>> 31, 0, 0, zi, un, 0, 0), Be = a[m + 132 >> 2], B = Be + a[m + 196 >> 2] | 0, he = a[m + 128 >> 2], v = a[m + 192 >> 2], o = he + v | 0, d = a[m + 304 >> 2], Si = o + d | 0, v = o >>> 0 < v >>> 0 ? B + 1 | 0 : B, B = v + a[m + 308 >> 2] | 0, d = d >>> 0 > Si >>> 0 ? B + 1 | 0 : B, fr = (v | 0) == (d | 0) & o >>> 0 > Si >>> 0 | d >>> 0 < v >>> 0, B = Me + 8 | 0, dr = a[B >> 2], we = a[B + 4 >> 2], he = (v | 0) == (Be | 0) & o >>> 0 < he >>> 0 | v >>> 0 < Be >>> 0, v = Rr + 8 | 0, o = a[v >> 2], B = Dr + 8 | 0, Me = o + a[B >> 2] | 0, B = a[B + 4 >> 2] + a[v + 4 >> 2] | 0, B = o >>> 0 > Me >>> 0 ? B + 1 | 0 : B, o = he + Me | 0, B = (o >>> 0 < Me >>> 0 ? B + 1 | 0 : B) + we | 0, v = o, o = o + dr | 0, B = v >>> 0 > o >>> 0 ? B + 1 | 0 : B, v = o, o = o + fr | 0, B = v >>> 0 > o >>> 0 ? B + 1 | 0 : B, Dr = d, dr = o << 12 | d >>> 20, v = B, he = B << 12 | o >>> 20, Ho = a[m + 176 >> 2], o = a[m + 240 >> 2], fr = Ho + o | 0, yo = a[m + 180 >> 2], B = yo + a[m + 244 >> 2] | 0, B = o >>> 0 > fr >>> 0 ? B + 1 | 0 : B, o = a[m + 80 >> 2], we = o + fr | 0, Be = B, B = B + a[m + 84 >> 2] | 0, B = o >>> 0 > we >>> 0 ? B + 1 | 0 : B, o = a[m + 288 >> 2], d = o + we | 0, Me = B, B = B + a[m + 292 >> 2] | 0, o = o >>> 0 > d >>> 0 ? B + 1 | 0 : B, B = o + he | 0, Sn = m + 16 | 0, dr = d + dr | 0, he = dr >>> 0 < d >>> 0 ? B + 1 | 0 : B, $i = (o | 0) == (he | 0) & d >>> 0 > dr >>> 0 | o >>> 0 > he >>> 0, Kn = (o | 0) == (Me | 0) & we >>> 0 > d >>> 0 | o >>> 0 < Me >>> 0, B = wr + 8 | 0, $r = a[B >> 2], mi = a[B + 4 >> 2], Rr = (Be | 0) == (Me | 0) & we >>> 0 < fr >>> 0 | Be >>> 0 > Me >>> 0, B = Mo + 8 | 0, wr = a[B >> 2], Me = a[B + 4 >> 2], we = (Be | 0) == (yo | 0) & fr >>> 0 < Ho >>> 0 | Be >>> 0 < yo >>> 0, d = Oo + 8 | 0, o = a[d >> 2], B = qi + 8 | 0, fr = o + a[B >> 2] | 0, B = a[B + 4 >> 2] + a[d + 4 >> 2] | 0, B = o >>> 0 > fr >>> 0 ? B + 1 | 0 : B, o = we + fr | 0, B = (o >>> 0 < fr >>> 0 ? B + 1 | 0 : B) + Me | 0, d = o, o = o + wr | 0, B = d >>> 0 > o >>> 0 ? B + 1 | 0 : B, d = o, o = o + Rr | 0, B = (d >>> 0 > o >>> 0 ? B + 1 | 0 : B) + mi | 0, d = o, o = o + $r | 0, B = d >>> 0 > o >>> 0 ? B + 1 | 0 : B, d = o + Kn | 0, B = d >>> 0 < o >>> 0 ? B + 1 | 0 : B, v = v >>> 20 | 0, o = d + v | 0, B = v >>> 0 > o >>> 0 ? B + 1 | 0 : B, v = o, o = o + $i | 0, B = v >>> 0 > o >>> 0 ? B + 1 | 0 : B, v = he, we = o << 12 | v >>> 20, d = B, fr = B << 12 | o >>> 20, $r = a[m + 164 >> 2], B = $r + a[m + 212 >> 2] | 0, wr = a[m + 160 >> 2], o = a[m + 208 >> 2], he = wr + o | 0, Me = he, we = he + we | 0, o = o >>> 0 > he >>> 0 ? B + 1 | 0 : B, B = o + fr | 0, Be = we << 4 & -16, he = we >>> 0 < he >>> 0 ? B + 1 | 0 : B, fr = (he << 4 | we >>> 28) & 16777215, Rr = v, Lr(Sn, Be | v >>> 16 & 15, fr, 0, 0, 977, 1, 0, 0), $i = a[m + 20 >> 2], B = $i + a[m + 4 >> 2] | 0, Kn = a[m + 16 >> 2], v = a[m >> 2], fr = Kn + v | 0, a[m + 560 >> 2] = fr, v = v >>> 0 > fr >>> 0 ? B + 1 | 0 : B, a[m + 564 >> 2] = v & 1048575, Mo = m + 112 | 0, Lr(Mo, Xn, In, 0, 0, Oi, Gr, 0, 0), qi = m + 224 | 0, Lr(qi, po, Ti, 0, 0, ni, Fr, 0, 0), Oo = m + 272 | 0, Lr(Oo, zi, un, 0, 0, zi, un, 0, 0), Ho = m - -64 | 0, mi = Ho, Be = (o | 0) == (he | 0) & we >>> 0 < Me >>> 0 | o >>> 0 > he >>> 0, Me = (o | 0) == ($r | 0) & Me >>> 0 < wr >>> 0 | o >>> 0 < $r >>> 0, we = uo + 8 | 0, o = a[we >> 2], B = Lo + 8 | 0, wr = o + a[B >> 2] | 0, B = a[B + 4 >> 2] + a[we + 4 >> 2] | 0, B = o >>> 0 > wr >>> 0 ? B + 1 | 0 : B, we = Me + wr | 0, B = we >>> 0 < wr >>> 0 ? B + 1 | 0 : B, d = d >>> 20 | 0, o = we + d | 0, B = d >>> 0 > o >>> 0 ? B + 1 | 0 : B, d = o, o = o + Be | 0, B = d >>> 0 > o >>> 0 ? B + 1 | 0 : B, Me = o << 12 | he >>> 20, we = B, he = B << 12 | o >>> 20, yo = a[m + 224 >> 2], o = a[m + 272 >> 2], $r = yo + o | 0, uo = a[m + 228 >> 2], B = uo + a[m + 276 >> 2] | 0, d = o >>> 0 > $r >>> 0 ? B + 1 | 0 : B, B = d + he | 0, wr = Me + $r | 0, B = wr >>> 0 < $r >>> 0 ? B + 1 | 0 : B, Me = B, Lr(mi, wr, B & 1048575, 0, 0, 15632, 16, 0, 0), fr = (v | 0) == ($i | 0) & fr >>> 0 < Kn >>> 0 | v >>> 0 < $i >>> 0, he = m + 8 | 0, o = a[he >> 2], B = Sn + 8 | 0, Be = o + a[B >> 2] | 0, B = a[B + 4 >> 2] + a[he + 4 >> 2] | 0, B = o >>> 0 > Be >>> 0 ? B + 1 | 0 : B, o = Be + fr | 0, B = o >>> 0 < Be >>> 0 ? B + 1 | 0 : B, Be = o << 12 | v >>> 20, he = B, fr = B << 12 | o >>> 20, $i = a[m + 64 >> 2], o = a[m + 112 >> 2], mi = $i + o | 0, Sn = a[m + 68 >> 2], B = Sn + a[m + 116 >> 2] | 0, v = o >>> 0 > mi >>> 0 ? B + 1 | 0 : B, B = v + fr | 0, Be = Be + mi | 0, B = Be >>> 0 < mi >>> 0 ? B + 1 | 0 : B, a[m + 568 >> 2] = Be, fr = B, a[m + 572 >> 2] = B & 1048575, Kn = m + 96 | 0, Lr(Kn, Xn, In, 0, 0, ni, Fr, 0, 0), Xn = m + 144 | 0, Lr(Xn, Oi, Gr, 0, 0, Oi, Gr, 0, 0), Oi = m + 256 | 0, Lr(Oi, po, Ti, 0, 0, zi, un, 0, 0), ni = m + 48 | 0, Fr = (d | 0) == (Me | 0) & wr >>> 0 < $r >>> 0 | d >>> 0 > Me >>> 0, wr = (d | 0) == (uo | 0) & $r >>> 0 < yo >>> 0 | d >>> 0 < uo >>> 0, d = Oo + 8 | 0, o = a[d >> 2], B = qi + 8 | 0, Gr = o + a[B >> 2] | 0, B = a[B + 4 >> 2] + a[d + 4 >> 2] | 0, B = o >>> 0 > Gr >>> 0 ? B + 1 | 0 : B, d = wr + Gr | 0, B = d >>> 0 < Gr >>> 0 ? B + 1 | 0 : B, we = we >>> 20 | 0, o = we + d | 0, B = we >>> 0 > o >>> 0 ? B + 1 | 0 : B, d = o, o = o + Fr | 0, B = d >>> 0 > o >>> 0 ? B + 1 | 0 : B, Gr = o << 12 | Me >>> 20, we = a[m + 256 >> 2], Me = Gr + we | 0, d = B, In = B << 12 | o >>> 20, B = In + a[m + 260 >> 2] | 0, wr = we >>> 0 > Me >>> 0 ? B + 1 | 0 : B, Lr(ni, Me, wr, 0, 0, 15632, 16, 0, 0), we = m, Be = (v | 0) == (fr | 0) & Be >>> 0 < mi >>> 0 | v >>> 0 > fr >>> 0, m = (v | 0) == (Sn | 0) & mi >>> 0 < $i >>> 0 | v >>> 0 < Sn >>> 0, v = Mo + 8 | 0, o = a[v >> 2], B = Ho + 8 | 0, Fr = o + a[B >> 2] | 0, B = a[B + 4 >> 2] + a[v + 4 >> 2] | 0, B = o >>> 0 > Fr >>> 0 ? B + 1 | 0 : B, v = m + Fr | 0, B = v >>> 0 < Fr >>> 0 ? B + 1 | 0 : B, he = he >>> 20 | 0, o = he + v | 0, B = he >>> 0 > o >>> 0 ? B + 1 | 0 : B, v = o, o = o + Be | 0, B = v >>> 0 > o >>> 0 ? B + 1 | 0 : B, m = o << 12 | fr >>> 20, v = B, he = B << 12 | o >>> 20, $r = a[we + 96 >> 2], o = a[we + 144 >> 2], Be = $r + o | 0, Ti = a[we + 100 >> 2], B = Ti + a[we + 148 >> 2] | 0, B = o >>> 0 > Be >>> 0 ? B + 1 | 0 : B, o = a[we + 48 >> 2], fr = o + Be | 0, Fr = B, B = B + a[we + 52 >> 2] | 0, o = o >>> 0 > fr >>> 0 ? B + 1 | 0 : B, B = o + he | 0, m = m + fr | 0, B = m >>> 0 < fr >>> 0 ? B + 1 | 0 : B, a[we + 576 >> 2] = m, he = B, a[we + 580 >> 2] = B & 1048575, mi = we + 32 | 0, Gr = (wr | 0) == (In | 0) & Me >>> 0 < Gr >>> 0 | wr >>> 0 < In >>> 0, B = Oi + 8 | 0, wr = a[B >> 2], B = a[B + 4 >> 2], d = d >>> 20 | 0, Me = d, d = d + wr | 0, B = Me >>> 0 > d >>> 0 ? B + 1 | 0 : B, Me = d, d = d + Gr | 0, B = Me >>> 0 > d >>> 0 ? B + 1 | 0 : B, Lr(mi, d, B, 0, 0, 64028672, 65536, 0, 0), d = we, Gr = (o | 0) == (he | 0) & m >>> 0 < fr >>> 0 | o >>> 0 > he >>> 0, wr = (o | 0) == (Fr | 0) & Be >>> 0 > fr >>> 0 | o >>> 0 < Fr >>> 0, B = ni + 8 | 0, Me = a[B >> 2], fr = a[B + 4 >> 2], m = (Fr | 0) == (Ti | 0) & Be >>> 0 < $r >>> 0 | Fr >>> 0 < Ti >>> 0, we = Xn + 8 | 0, o = a[we >> 2], B = Kn + 8 | 0, Be = o + a[B >> 2] | 0, B = a[B + 4 >> 2] + a[we + 4 >> 2] | 0, B = o >>> 0 > Be >>> 0 ? B + 1 | 0 : B, o = m + Be | 0, B = (o >>> 0 < Be >>> 0 ? B + 1 | 0 : B) + fr | 0, we = o, o = o + Me | 0, B = we >>> 0 > o >>> 0 ? B + 1 | 0 : B, we = o + wr | 0, B = we >>> 0 < o >>> 0 ? B + 1 | 0 : B, v = v >>> 20 | 0, o = we + v | 0, B = v >>> 0 > o >>> 0 ? B + 1 | 0 : B, v = o, o = o + Gr | 0, B = v >>> 0 > o >>> 0 ? B + 1 | 0 : B, fr = o << 12 | he >>> 20, v = B, he = B << 12 | o >>> 20, Be = a[d + 32 >> 2], o = Si & -2, we = Be + o | 0, wr = a[d + 36 >> 2], B = wr + (Dr & 1048575) | 0, m = o >>> 0 > we >>> 0 ? B + 1 | 0 : B, B = m + he | 0, he = we + fr | 0, B = he >>> 0 < we >>> 0 ? B + 1 | 0 : B, a[d + 584 >> 2] = he, o = B, a[d + 588 >> 2] = B & 1048575, Me = Rr & 65535, fr = (B | 0) == (m | 0) & we >>> 0 > he >>> 0 | B >>> 0 < m >>> 0, d = (m | 0) == (wr | 0) & we >>> 0 < Be >>> 0 | m >>> 0 < wr >>> 0, B = mi + 8 | 0, he = d + a[B >> 2] | 0, B = a[B + 4 >> 2], B = d >>> 0 > he >>> 0 ? B + 1 | 0 : B, v = v >>> 20 | 0, d = v, v = he + v | 0, B = d >>> 0 > v >>> 0 ? B + 1 | 0 : B, d = v, v = v + fr | 0, B = d >>> 0 > v >>> 0 ? B + 1 | 0 : B, o = v << 12 | o >>> 20, d = o + dr | 0, B = Me + (B << 12 | v >>> 20) | 0, a[Qe + 592 >> 2] = d, a[Qe + 596 >> 2] = o >>> 0 > d >>> 0 ? B + 1 | 0 : B, ni = Qe + 560 | 0, gn(655432, 655432, ni), gn(655472, 655472, ni), gn(655472, 655472, Vn), gn(655512, 655512, Vn), a[Ao >> 2] = 0, a[Ao + 4 >> 2] = 0, a[Ts >> 2] = 0, a[Ts + 4 >> 2] = 0, a[ds >> 2] = 0, a[ds + 4 >> 2] = 0, a[ns >> 2] = 0, a[ns + 4 >> 2] = 0, a[Qe + 520 >> 2] = 0, a[Qe + 524 >> 2] = 0, co(Go, xo), $r = Qe + 688 | 0, Rn($r, xo, 0), o = $r + 24 | 0, Be = a[o >> 2], v = $r + 16 | 0, wr = a[v >> 2], d = $r + 8 | 0, Dr = a[d >> 2], Rr = a[Qe + 688 >> 2], Me = Be | (wr | (Dr | Rr)), we = a[o + 4 >> 2], dr = a[v + 4 >> 2], fr = a[d + 4 >> 2], m = a[Qe + 692 >> 2], he = we | (dr | (fr | m)), B = Me | he ? -1 : 0, mi = B & Be, a[o >> 2] = mi, Gr = B & we, a[o + 4 >> 2] = Gr, Fr = B & wr, a[v >> 2] = Fr, Si = B & dr, a[v + 4 >> 2] = Si, Dr = B & Dr, a[d >> 2] = Dr, wr = B & fr, a[d + 4 >> 2] = wr, he = !(he | Me) | B & Rr, a[Qe + 688 >> 2] = he, we = B & m, a[Qe + 692 >> 2] = we, xi(Go, 68), a[Uo >> 2] = 0, a[Uo + 4 >> 2] = 0, a[_o >> 2] = 0, a[_o + 4 >> 2] = 0, a[Qe + 488 >> 2] = 0, a[Qe + 492 >> 2] = 0, a[Qe + 480 >> 2] = 0, a[Qe + 484 >> 2] = 0, xs(655392, ni, $r), B = Dr | Fr | mi | he | (wr | Si | Gr | we) ? -1 : 0, Be = he ^ -1, m = Be - 801750718 | 0, he = B, dr = we ^ -1, we = dr - ((Be >>> 0 < 801750718) + 1076732275 | 0) | 0, B = B & we, Me = B, fr = m & he, a[163850] = fr, a[163851] = B, wr = wr ^ -1, B = wr, Rr = Dr ^ -1, Dr = Rr + ((we | 0) == (dr | 0) & m >>> 0 < Be >>> 0 | we >>> 0 < dr >>> 0) | 0, m = Dr - 1354194885 | 0, dr = m & he, a[d >> 2] = dr, B = Dr >>> 0 < Rr >>> 0 ? B + 1 | 0 : B, Be = B - ((Dr >>> 0 < 1354194885) + 1162945305 | 0) | 0, we = Be & he, a[d + 4 >> 2] = we, a[163852] = dr, a[163853] = we, we = (B | 0) == (Be | 0) & m >>> 0 < Dr >>> 0 | B >>> 0 > Be >>> 0, dr = we + ((B | 0) == (wr | 0) & Dr >>> 0 < Rr >>> 0 | B >>> 0 < wr >>> 0) | 0, Rr = Fr ^ -1, Dr = Rr + dr | 0, wr = Si ^ -1, B = wr + (we >>> 0 > dr >>> 0) | 0, m = Dr - 2 | 0, dr = m & he, a[v >> 2] = dr, B = Dr >>> 0 < Rr >>> 0 ? B + 1 | 0 : B, Be = B - (Dr >>> 0 < 2) | 0, we = Be & he, a[v + 4 >> 2] = we, a[163854] = dr, a[163855] = we, we = (B | 0) == (Be | 0) & m >>> 0 < Dr >>> 0 | B >>> 0 > Be >>> 0, m = we + ((B | 0) == (wr | 0) & Dr >>> 0 < Rr >>> 0 | B >>> 0 < wr >>> 0) | 0, B = m >>> 0 < we >>> 0, dr = m - mi | 0, we = dr - 2 & he, a[o >> 2] = we, B = (B - ((m >>> 0 < mi >>> 0) + Gr | 0) | 0) - (dr >>> 0 < 2) & he, a[o + 4 >> 2] = B, a[163856] = we, a[163857] = B, a[Qe + 688 >> 2] = fr, a[Qe + 692 >> 2] = Me, dn(655432, ni, 128), a[o >> 2] = 0, a[o + 4 >> 2] = 0, a[v >> 2] = 0, a[v + 4 >> 2] = 0, a[d >> 2] = 0, a[d + 4 >> 2] = 0, a[Qe + 688 >> 2] = 0, a[Qe + 692 >> 2] = 0, xi(ni, 124)), be = Qe + 720 | 0, u[690757] = 0, u[690758] = 0, u[690759] = 0, u[690760] = 0, u[690761] = 0, u[690762] = 0, u[690763] = 0, u[690764] = 0, u[690756] = 1, u[690765] = 0, u[690766] = 0, u[690767] = 0, u[690768] = 0, u[690769] = 0, u[690770] = 0, u[690771] = 0, u[690772] = 0, u[690773] = 0, u[690774] = 0, u[690775] = 0, u[690776] = 0, u[690777] = 0, u[690778] = 0, u[690779] = 0, u[690780] = 0, u[690780] = 0, u[690781] = 0, u[690782] = 0, u[690783] = 0, u[690784] = 0, u[690785] = 0, u[690786] = 0, u[690787] = 0, a[Io + 4 >> 2] = 1, a[172762] = 655392;
    }
    return be = Io + 32 | 0, ts;
  }
  function _r() {
    yr();
  }
  function Or(B) {
    B = B | 0;
    var o = 0, m = 0;
    o = be + -64 | 0, be = o;
    e: {
      if ((B | 0) != 32) {
        m = o + 56 | 0, a[m >> 2] = 0, a[m + 4 >> 2] = 0, m = o + 48 | 0, a[m >> 2] = 0, a[m + 4 >> 2] = 0, m = o + 40 | 0, a[m >> 2] = 0, a[m + 4 >> 2] = 0, m = o + 32 | 0, a[m >> 2] = 0, a[m + 4 >> 2] = 0, m = o + 24 | 0, a[m >> 2] = 0, a[m + 4 >> 2] = 0, m = o + 16 | 0, a[m >> 2] = 0, a[m + 4 >> 2] = 0, m = o + 8 | 0, a[m >> 2] = 0, a[m + 4 >> 2] = 0, a[o >> 2] = 0, a[o + 4 >> 2] = 0, B = On(a[172688], o, 690820, B);
        break e;
      }
      B = o + 56 | 0, a[B >> 2] = 0, a[B + 4 >> 2] = 0, B = o + 48 | 0, a[B >> 2] = 0, a[B + 4 >> 2] = 0, B = o + 40 | 0, a[B >> 2] = 0, a[B + 4 >> 2] = 0, B = o + 32 | 0, a[B >> 2] = 0, a[B + 4 >> 2] = 0, B = o + 24 | 0, a[B >> 2] = 0, a[B + 4 >> 2] = 0, B = o + 16 | 0, a[B >> 2] = 0, a[B + 4 >> 2] = 0, B = o + 8 | 0, a[B >> 2] = 0, a[B + 4 >> 2] = 0, a[o >> 2] = 0, a[o + 4 >> 2] = 0, B = da(a[172688], o, 690820);
    }
    return be = o - -64 | 0, (B | 0) == 1 | 0;
  }
  function vr(B, o, m) {
    B = B | 0, o = o | 0, m = m | 0;
    var d = 0, v = 0, he = 0, we = 0, Be = 0, Me = 0, fr = 0, wr = 0, dr = 0, Dr = 0, Rr = 0, Qe = 0, Fr = 0, Gr = 0, $r = 0, ni = 0, mi = 0, Si = 0, Oi = 0, $i = 0, zi = 0, un = 0, In = 0, Ti = 0, Sn = 0;
    he = be - 272 | 0, be = he, d = he + 200 | 0, Ti = d + 56 | 0, a[Ti >> 2] = 0, a[Ti + 4 >> 2] = 0, fr = d + 48 | 0, a[fr >> 2] = 0, a[fr + 4 >> 2] = 0, Gr = d + 40 | 0, a[Gr >> 2] = 0, a[Gr + 4 >> 2] = 0, ni = d + 32 | 0, a[ni >> 2] = 0, a[ni + 4 >> 2] = 0, $r = d + 24 | 0, a[$r >> 2] = 0, a[$r + 4 >> 2] = 0, mi = d + 16 | 0, a[mi >> 2] = 0, a[mi + 4 >> 2] = 0, In = d + 8 | 0, a[In >> 2] = 0, a[In + 4 >> 2] = 0, a[he + 200 >> 2] = 0, a[he + 204 >> 2] = 0;
    e: {
      t: {
        if ((On(a[172688], d, 690820, B) | 0) == 1) {
          if (Si = he + 200 | 0, Qe = Si + 15 | 0, d = Qe, B = A[d + 4 | 0] | A[d + 5 | 0] << 8 | (A[d + 6 | 0] << 16 | A[d + 7 | 0] << 24), wr = he - -64 | 0, $i = wr + 8 | 0, a[$i >> 2] = A[d | 0] | A[d + 1 | 0] << 8 | (A[d + 2 | 0] << 16 | A[d + 3 | 0] << 24), a[$i + 4 >> 2] = B, Rr = Si + 23 | 0, d = Rr, B = A[d + 4 | 0] | A[d + 5 | 0] << 8 | (A[d + 6 | 0] << 16 | A[d + 7 | 0] << 24), zi = wr + 16 | 0, a[zi >> 2] = A[d | 0] | A[d + 1 | 0] << 8 | (A[d + 2 | 0] << 16 | A[d + 3 | 0] << 24), a[zi + 4 >> 2] = B, dr = Si + 31 | 0, d = dr, B = A[d + 4 | 0] | A[d + 5 | 0] << 8 | (A[d + 6 | 0] << 16 | A[d + 7 | 0] << 24), un = wr + 24 | 0, a[un >> 2] = A[d | 0] | A[d + 1 | 0] << 8 | (A[d + 2 | 0] << 16 | A[d + 3 | 0] << 24), a[un + 4 >> 2] = B, Dr = Si + 39 | 0, d = Dr, B = A[d + 4 | 0] | A[d + 5 | 0] << 8 | (A[d + 6 | 0] << 16 | A[d + 7 | 0] << 24), Sn = wr + 32 | 0, a[Sn >> 2] = A[d | 0] | A[d + 1 | 0] << 8 | (A[d + 2 | 0] << 16 | A[d + 3 | 0] << 24), a[Sn + 4 >> 2] = B, we = Si + 47 | 0, d = we, B = A[d + 4 | 0] | A[d + 5 | 0] << 8 | (A[d + 6 | 0] << 16 | A[d + 7 | 0] << 24), v = wr + 40 | 0, a[v >> 2] = A[d | 0] | A[d + 1 | 0] << 8 | (A[d + 2 | 0] << 16 | A[d + 3 | 0] << 24), a[v + 4 >> 2] = B, d = Si + 55 | 0, B = A[d + 4 | 0] | A[d + 5 | 0] << 8 | (A[d + 6 | 0] << 16 | A[d + 7 | 0] << 24), Be = wr + 48 | 0, a[Be >> 2] = A[d | 0] | A[d + 1 | 0] << 8 | (A[d + 2 | 0] << 16 | A[d + 3 | 0] << 24), a[Be + 4 >> 2] = B, Me = wr + 56 | 0, wr = Si + 63 | 0, u[Me | 0] = A[wr | 0], u[he + 2 | 0] = A[he + 202 | 0], p[he >> 1] = b[he + 200 >> 1], B = A[he + 211 | 0] | A[he + 212 | 0] << 8 | (A[he + 213 | 0] << 16 | A[he + 214 | 0] << 24), a[he + 64 >> 2] = A[he + 207 | 0] | A[he + 208 | 0] << 8 | (A[he + 209 | 0] << 16 | A[he + 210 | 0] << 24), a[he + 68 >> 2] = B, B = A[he + 203 | 0] | A[he + 204 | 0] << 8 | (A[he + 205 | 0] << 16 | A[he + 206 | 0] << 24), u[he + 63 | 0] = A[Me | 0], Fr = a[Be + 4 >> 2], Oi = he + 55 | 0, Me = a[Be >> 2], u[Oi | 0] = Me, u[Oi + 1 | 0] = Me >>> 8, u[Oi + 2 | 0] = Me >>> 16, u[Oi + 3 | 0] = Me >>> 24, u[Oi + 4 | 0] = Fr, u[Oi + 5 | 0] = Fr >>> 8, u[Oi + 6 | 0] = Fr >>> 16, u[Oi + 7 | 0] = Fr >>> 24, Be = a[v + 4 >> 2], Fr = he + 47 | 0, Me = a[v >> 2], u[Fr | 0] = Me, u[Fr + 1 | 0] = Me >>> 8, u[Fr + 2 | 0] = Me >>> 16, u[Fr + 3 | 0] = Me >>> 24, u[Fr + 4 | 0] = Be, u[Fr + 5 | 0] = Be >>> 8, u[Fr + 6 | 0] = Be >>> 16, u[Fr + 7 | 0] = Be >>> 24, Be = a[Sn + 4 >> 2], v = he + 39 | 0, Me = a[Sn >> 2], u[v | 0] = Me, u[v + 1 | 0] = Me >>> 8, u[v + 2 | 0] = Me >>> 16, u[v + 3 | 0] = Me >>> 24, u[v + 4 | 0] = Be, u[v + 5 | 0] = Be >>> 8, u[v + 6 | 0] = Be >>> 16, u[v + 7 | 0] = Be >>> 24, Be = a[un + 4 >> 2], v = he + 31 | 0, Me = a[un >> 2], u[v | 0] = Me, u[v + 1 | 0] = Me >>> 8, u[v + 2 | 0] = Me >>> 16, u[v + 3 | 0] = Me >>> 24, u[v + 4 | 0] = Be, u[v + 5 | 0] = Be >>> 8, u[v + 6 | 0] = Be >>> 16, u[v + 7 | 0] = Be >>> 24, Be = a[zi + 4 >> 2], v = he + 23 | 0, Me = a[zi >> 2], u[v | 0] = Me, u[v + 1 | 0] = Me >>> 8, u[v + 2 | 0] = Me >>> 16, u[v + 3 | 0] = Me >>> 24, u[v + 4 | 0] = Be, u[v + 5 | 0] = Be >>> 8, u[v + 6 | 0] = Be >>> 16, u[v + 7 | 0] = Be >>> 24, Be = a[$i + 4 >> 2], v = he + 15 | 0, Me = a[$i >> 2], u[v | 0] = Me, u[v + 1 | 0] = Me >>> 8, u[v + 2 | 0] = Me >>> 16, u[v + 3 | 0] = Me >>> 24, u[v + 4 | 0] = Be, u[v + 5 | 0] = Be >>> 8, u[v + 6 | 0] = Be >>> 16, u[v + 7 | 0] = Be >>> 24, u[he + 3 | 0] = B, u[he + 4 | 0] = B >>> 8, u[he + 5 | 0] = B >>> 16, u[he + 6 | 0] = B >>> 24, Me = a[he + 68 >> 2], B = a[he + 64 >> 2], u[he + 7 | 0] = B, u[he + 8 | 0] = B >>> 8, u[he + 9 | 0] = B >>> 16, u[he + 10 | 0] = B >>> 24, u[he + 11 | 0] = Me, u[he + 12 | 0] = Me >>> 8, u[he + 13 | 0] = Me >>> 16, u[he + 14 | 0] = Me >>> 24, a[Ti >> 2] = 0, a[Ti + 4 >> 2] = 0, a[fr >> 2] = 0, a[fr + 4 >> 2] = 0, a[Gr >> 2] = 0, a[Gr + 4 >> 2] = 0, a[ni >> 2] = 0, a[ni + 4 >> 2] = 0, a[$r >> 2] = 0, a[$r + 4 >> 2] = 0, a[mi >> 2] = 0, a[mi + 4 >> 2] = 0, a[In >> 2] = 0, a[In + 4 >> 2] = 0, a[he + 200 >> 2] = 0, a[he + 204 >> 2] = 0, Fr = 0, (On(a[172688], Si, 655584, o) | 0) == 1) {
            B = A[Qe + 4 | 0] | A[Qe + 5 | 0] << 8 | (A[Qe + 6 | 0] << 16 | A[Qe + 7 | 0] << 24), o = he + 128 | 0, Me = o + 8 | 0, a[Me >> 2] = A[Qe | 0] | A[Qe + 1 | 0] << 8 | (A[Qe + 2 | 0] << 16 | A[Qe + 3 | 0] << 24), a[Me + 4 >> 2] = B, B = A[Rr + 4 | 0] | A[Rr + 5 | 0] << 8 | (A[Rr + 6 | 0] << 16 | A[Rr + 7 | 0] << 24), Qe = o + 16 | 0, a[Qe >> 2] = A[Rr | 0] | A[Rr + 1 | 0] << 8 | (A[Rr + 2 | 0] << 16 | A[Rr + 3 | 0] << 24), a[Qe + 4 >> 2] = B, B = A[dr + 4 | 0] | A[dr + 5 | 0] << 8 | (A[dr + 6 | 0] << 16 | A[dr + 7 | 0] << 24), Rr = o + 24 | 0, a[Rr >> 2] = A[dr | 0] | A[dr + 1 | 0] << 8 | (A[dr + 2 | 0] << 16 | A[dr + 3 | 0] << 24), a[Rr + 4 >> 2] = B, B = A[Dr + 4 | 0] | A[Dr + 5 | 0] << 8 | (A[Dr + 6 | 0] << 16 | A[Dr + 7 | 0] << 24), dr = o + 32 | 0, a[dr >> 2] = A[Dr | 0] | A[Dr + 1 | 0] << 8 | (A[Dr + 2 | 0] << 16 | A[Dr + 3 | 0] << 24), a[dr + 4 >> 2] = B, B = A[we + 4 | 0] | A[we + 5 | 0] << 8 | (A[we + 6 | 0] << 16 | A[we + 7 | 0] << 24), Dr = o + 40 | 0, a[Dr >> 2] = A[we | 0] | A[we + 1 | 0] << 8 | (A[we + 2 | 0] << 16 | A[we + 3 | 0] << 24), a[Dr + 4 >> 2] = B, B = A[d + 4 | 0] | A[d + 5 | 0] << 8 | (A[d + 6 | 0] << 16 | A[d + 7 | 0] << 24), we = o + 48 | 0, a[we >> 2] = A[d | 0] | A[d + 1 | 0] << 8 | (A[d + 2 | 0] << 16 | A[d + 3 | 0] << 24), a[we + 4 >> 2] = B, o = o + 56 | 0, u[o | 0] = A[wr | 0], u[he + 66 | 0] = A[he + 202 | 0], p[he + 64 >> 1] = b[he + 200 >> 1], B = A[he + 211 | 0] | A[he + 212 | 0] << 8 | (A[he + 213 | 0] << 16 | A[he + 214 | 0] << 24), a[he + 128 >> 2] = A[he + 207 | 0] | A[he + 208 | 0] << 8 | (A[he + 209 | 0] << 16 | A[he + 210 | 0] << 24), a[he + 132 >> 2] = B, B = A[he + 203 | 0] | A[he + 204 | 0] << 8 | (A[he + 205 | 0] << 16 | A[he + 206 | 0] << 24), Be = he - -64 | 0, u[Be + 63 | 0] = A[o | 0], d = a[we + 4 >> 2], wr = Be + 55 | 0, o = a[we >> 2], u[wr | 0] = o, u[wr + 1 | 0] = o >>> 8, u[wr + 2 | 0] = o >>> 16, u[wr + 3 | 0] = o >>> 24, u[wr + 4 | 0] = d, u[wr + 5 | 0] = d >>> 8, u[wr + 6 | 0] = d >>> 16, u[wr + 7 | 0] = d >>> 24, d = a[Dr + 4 >> 2], we = Be + 47 | 0, o = a[Dr >> 2], u[we | 0] = o, u[we + 1 | 0] = o >>> 8, u[we + 2 | 0] = o >>> 16, u[we + 3 | 0] = o >>> 24, u[we + 4 | 0] = d, u[we + 5 | 0] = d >>> 8, u[we + 6 | 0] = d >>> 16, u[we + 7 | 0] = d >>> 24, d = a[dr + 4 >> 2], we = Be + 39 | 0, o = a[dr >> 2], u[we | 0] = o, u[we + 1 | 0] = o >>> 8, u[we + 2 | 0] = o >>> 16, u[we + 3 | 0] = o >>> 24, u[we + 4 | 0] = d, u[we + 5 | 0] = d >>> 8, u[we + 6 | 0] = d >>> 16, u[we + 7 | 0] = d >>> 24, d = a[Rr + 4 >> 2], we = Be + 31 | 0, o = a[Rr >> 2], u[we | 0] = o, u[we + 1 | 0] = o >>> 8, u[we + 2 | 0] = o >>> 16, u[we + 3 | 0] = o >>> 24, u[we + 4 | 0] = d, u[we + 5 | 0] = d >>> 8, u[we + 6 | 0] = d >>> 16, u[we + 7 | 0] = d >>> 24, d = a[Qe + 4 >> 2], we = Be + 23 | 0, o = a[Qe >> 2], u[we | 0] = o, u[we + 1 | 0] = o >>> 8, u[we + 2 | 0] = o >>> 16, u[we + 3 | 0] = o >>> 24, u[we + 4 | 0] = d, u[we + 5 | 0] = d >>> 8, u[we + 6 | 0] = d >>> 16, u[we + 7 | 0] = d >>> 24, d = a[Me + 4 >> 2], we = Be + 15 | 0, o = a[Me >> 2], u[we | 0] = o, u[we + 1 | 0] = o >>> 8, u[we + 2 | 0] = o >>> 16, u[we + 3 | 0] = o >>> 24, u[we + 4 | 0] = d, u[we + 5 | 0] = d >>> 8, u[we + 6 | 0] = d >>> 16, u[we + 7 | 0] = d >>> 24, u[he + 67 | 0] = B, u[he + 68 | 0] = B >>> 8, u[he + 69 | 0] = B >>> 16, u[he + 70 | 0] = B >>> 24, o = a[he + 132 >> 2], B = a[he + 128 >> 2], u[he + 71 | 0] = B, u[he + 72 | 0] = B >>> 8, u[he + 73 | 0] = B >>> 16, u[he + 74 | 0] = B >>> 24, u[he + 75 | 0] = o, u[he + 76 | 0] = o >>> 8, u[he + 77 | 0] = o >>> 16, u[he + 78 | 0] = o >>> 24, fr = he + 200 | 0, B = fr + 56 | 0, a[B >> 2] = 0, a[B + 4 >> 2] = 0, B = fr + 48 | 0, a[B >> 2] = 0, a[B + 4 >> 2] = 0, B = fr + 40 | 0, a[B >> 2] = 0, a[B + 4 >> 2] = 0, B = fr + 32 | 0, a[B >> 2] = 0, a[B + 4 >> 2] = 0, B = fr + 24 | 0, a[B >> 2] = 0, a[B + 4 >> 2] = 0, B = fr + 16 | 0, a[B >> 2] = 0, a[B + 4 >> 2] = 0, B = fr + 8 | 0, a[B >> 2] = 0, a[B + 4 >> 2] = 0, a[he + 200 >> 2] = 0, a[he + 204 >> 2] = 0, a[he + 196 >> 2] = Be, a[he + 192 >> 2] = he, Gr = a[172688], $r = he + 192 | 0, mi = 2, Be = be - 224 | 0, be = Be;
            r: {
              if (!fr) {
                ji[a[Gr + 168 >> 2]](689778, a[Gr + 172 >> 2]), B = 0;
                break r;
              }
              if (u[fr | 0] = 0, u[fr + 1 | 0] = 0, u[fr + 2 | 0] = 0, u[fr + 3 | 0] = 0, u[fr + 4 | 0] = 0, u[fr + 5 | 0] = 0, u[fr + 6 | 0] = 0, u[fr + 7 | 0] = 0, B = fr + 56 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, B = fr + 48 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, B = fr + 40 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, B = fr + 32 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, B = fr + 24 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, B = fr + 16 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, B = fr + 8 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, !$r) {
                ji[a[Gr + 168 >> 2]](689682, a[Gr + 172 >> 2]), B = 0;
                break r;
              }
              for (a[Be + 216 >> 2] = 1, xi(Be + 96 | 0, 120), In = Gr + 172 | 0; ; ) {
                if (v = a[$r >> 2], !v) {
                  ji[a[Gr + 168 >> 2]](689809, a[Gr + 172 >> 2]), B = 0;
                  break r;
                }
                if (a[Be + 88 >> 2] = 0, o = A[v + 60 | 0] | A[v + 61 | 0] << 8 | (A[v + 62 | 0] << 16 | A[v + 63 | 0] << 24), dr = o >>> 16 | 0, B = Be, d = A[v + 56 | 0] | A[v + 57 | 0] << 8 | (A[v + 58 | 0] << 16 | A[v + 59 | 0] << 24), a[B + 80 >> 2] = (o & 65535) << 16 | d >>> 16, a[B + 84 >> 2] = dr, we = A[v + 36 | 0] | A[v + 37 | 0] << 8 | (A[v + 38 | 0] << 16 | A[v + 39 | 0] << 24), a[B + 48 >> 2] = A[v + 32 | 0] | A[v + 33 | 0] << 8 | (A[v + 34 | 0] << 16 | A[v + 35 | 0] << 24), a[B + 52 >> 2] = we & 1048575, dr = d << 4 & 1048560, o = A[v + 52 | 0] | A[v + 53 | 0] << 8 | (A[v + 54 | 0] << 16 | A[v + 55 | 0] << 24), Me = o >>> 28 | 0, d = A[v + 48 | 0] | A[v + 49 | 0] << 8 | (A[v + 50 | 0] << 16 | A[v + 51 | 0] << 24), a[B + 72 >> 2] = (o & 268435455) << 4 | d >>> 28, a[B + 76 >> 2] = Me | dr, dr = o << 24 | d >>> 8, Rr = d << 24 & -16777216, d = A[v + 40 | 0] | A[v + 41 | 0] << 8 | (A[v + 42 | 0] << 16 | A[v + 43 | 0] << 24), o = A[v + 44 | 0] | A[v + 45 | 0] << 8 | (A[v + 46 | 0] << 16 | A[v + 47 | 0] << 24), a[B + 64 >> 2] = o >>> 8 | Rr, a[B + 68 >> 2] = dr & 1048575, ni = o << 12 | d >>> 20, a[B + 56 >> 2] = d << 12 & -4096 | we >>> 20, a[B + 60 >> 2] = ni & 1048575, d = A[v + 12 | 0] | A[v + 13 | 0] << 8 | (A[v + 14 | 0] << 16 | A[v + 15 | 0] << 24), wr = d, o = A[v + 8 | 0] | A[v + 9 | 0] << 8 | (A[v + 10 | 0] << 16 | A[v + 11 | 0] << 24), ni = d << 12 | o >>> 20, Dr = o << 12 & -4096, Qe = A[v | 0] | A[v + 1 | 0] << 8 | (A[v + 2 | 0] << 16 | A[v + 3 | 0] << 24), o = A[v + 4 | 0] | A[v + 5 | 0] << 8 | (A[v + 6 | 0] << 16 | A[v + 7 | 0] << 24), d = o, $i = d >>> 20 | Dr, a[B + 16 >> 2] = $i, zi = ni & 1048575, a[B + 20 >> 2] = zi, a[B + 8 >> 2] = Qe, un = d & 1048575, a[B + 12 >> 2] = un, o = A[v + 24 | 0] | A[v + 25 | 0] << 8 | (A[v + 26 | 0] << 16 | A[v + 27 | 0] << 24), Rr = o, d = A[v + 28 | 0] | A[v + 29 | 0] << 8 | (A[v + 30 | 0] << 16 | A[v + 31 | 0] << 24), we = (d & 65535) << 16 | o >>> 16, a[B + 40 >> 2] = we, Dr = d >>> 16 | 0, a[B + 44 >> 2] = Dr, o = A[v + 16 | 0] | A[v + 17 | 0] << 8 | (A[v + 18 | 0] << 16 | A[v + 19 | 0] << 24), d = A[v + 20 | 0] | A[v + 21 | 0] << 8 | (A[v + 22 | 0] << 16 | A[v + 23 | 0] << 24), Me = d << 24 | o >>> 8, v = o << 24 & -16777216 | wr >>> 8, a[B + 24 >> 2] = v, wr = Me & 1048575, a[B + 28 >> 2] = wr, dr = Rr << 4 & 1048560, o = (d & 268435455) << 4 | o >>> 28, a[B + 32 >> 2] = o, B = d >>> 28 | dr, a[Be + 36 >> 2] = B, Qe | $i | we | v | o | (zi | un | Dr | wr | B) || ji[a[Gr + 168 >> 2]](690116, a[In >> 2]), $r = $r + 4 | 0, B = Be + 96 | 0, ls(B, B, Be + 8 | 0), mi = mi - 1 | 0, !mi)
                  break;
              }
              if (B = 0, a[Be + 216 >> 2])
                break r;
              B = Be + 8 | 0, Fo(B, Be + 96 | 0), Gn(fr, B), B = 1;
            }
            if (be = Be + 224 | 0, !B)
              break e;
            if (a[he + 264 >> 2] = m, B = pn(a[172688], he + 264 | 0, he + 200 | 0, (m | 0) == 33 ? 258 : 2), a[he + 268 >> 2] = B, (B | 0) != 1)
              break t;
            Fr = 1;
            break e;
          }
          Ee(1);
          break e;
        }
        Ee(1);
        break e;
      }
      a[he + 136 >> 2] = 0, ar(he + 128 | 0), wasm2js_trap();
    }
    return be = he + 272 | 0, Fr | 0;
  }
  function Te(B, o) {
    B = B | 0, o = o | 0;
    var m = 0, d = 0, v = 0, he = 0, we = 0, Be = 0, Me = 0, fr = 0, wr = 0, dr = 0, Dr = 0, Rr = 0, Qe = 0, Fr = 0, Gr = 0, $r = 0, ni = 0, mi = 0, Si = 0;
    we = be - 208 | 0, be = we, m = we + 136 | 0, d = m + 56 | 0, a[d >> 2] = 0, a[d + 4 >> 2] = 0, d = m + 48 | 0, a[d >> 2] = 0, a[d + 4 >> 2] = 0, d = m + 40 | 0, a[d >> 2] = 0, a[d + 4 >> 2] = 0, d = m + 32 | 0, a[d >> 2] = 0, a[d + 4 >> 2] = 0, d = m + 24 | 0, a[d >> 2] = 0, a[d + 4 >> 2] = 0, d = m + 16 | 0, a[d >> 2] = 0, a[d + 4 >> 2] = 0, d = m + 8 | 0, a[d >> 2] = 0, a[d + 4 >> 2] = 0, a[we + 136 >> 2] = 0, a[we + 140 >> 2] = 0;
    e: {
      if ((On(a[172688], m, 690820, B) | 0) == 1) {
        fr = we + 136 | 0, m = fr + 15 | 0, B = A[m + 4 | 0] | A[m + 5 | 0] << 8 | (A[m + 6 | 0] << 16 | A[m + 7 | 0] << 24), d = we + 72 | 0, Rr = d + 8 | 0, a[Rr >> 2] = A[m | 0] | A[m + 1 | 0] << 8 | (A[m + 2 | 0] << 16 | A[m + 3 | 0] << 24), a[Rr + 4 >> 2] = B, m = fr + 23 | 0, B = A[m + 4 | 0] | A[m + 5 | 0] << 8 | (A[m + 6 | 0] << 16 | A[m + 7 | 0] << 24), dr = d + 16 | 0, a[dr >> 2] = A[m | 0] | A[m + 1 | 0] << 8 | (A[m + 2 | 0] << 16 | A[m + 3 | 0] << 24), a[dr + 4 >> 2] = B, m = fr + 31 | 0, B = A[m + 4 | 0] | A[m + 5 | 0] << 8 | (A[m + 6 | 0] << 16 | A[m + 7 | 0] << 24), Dr = d + 24 | 0, a[Dr >> 2] = A[m | 0] | A[m + 1 | 0] << 8 | (A[m + 2 | 0] << 16 | A[m + 3 | 0] << 24), a[Dr + 4 >> 2] = B, m = fr + 39 | 0, B = A[m + 4 | 0] | A[m + 5 | 0] << 8 | (A[m + 6 | 0] << 16 | A[m + 7 | 0] << 24), wr = d + 32 | 0, a[wr >> 2] = A[m | 0] | A[m + 1 | 0] << 8 | (A[m + 2 | 0] << 16 | A[m + 3 | 0] << 24), a[wr + 4 >> 2] = B, m = fr + 47 | 0, B = A[m + 4 | 0] | A[m + 5 | 0] << 8 | (A[m + 6 | 0] << 16 | A[m + 7 | 0] << 24), Be = d + 40 | 0, a[Be >> 2] = A[m | 0] | A[m + 1 | 0] << 8 | (A[m + 2 | 0] << 16 | A[m + 3 | 0] << 24), a[Be + 4 >> 2] = B, Me = fr + 55 | 0, B = A[Me + 4 | 0] | A[Me + 5 | 0] << 8 | (A[Me + 6 | 0] << 16 | A[Me + 7 | 0] << 24), m = d + 48 | 0, a[m >> 2] = A[Me | 0] | A[Me + 1 | 0] << 8 | (A[Me + 2 | 0] << 16 | A[Me + 3 | 0] << 24), a[m + 4 >> 2] = B, d = d + 56 | 0, u[d | 0] = A[fr + 63 | 0], u[we + 10 | 0] = A[we + 138 | 0], p[we + 8 >> 1] = b[we + 136 >> 1], B = A[we + 147 | 0] | A[we + 148 | 0] << 8 | (A[we + 149 | 0] << 16 | A[we + 150 | 0] << 24), a[we + 72 >> 2] = A[we + 143 | 0] | A[we + 144 | 0] << 8 | (A[we + 145 | 0] << 16 | A[we + 146 | 0] << 24), a[we + 76 >> 2] = B, fr = A[we + 139 | 0] | A[we + 140 | 0] << 8 | (A[we + 141 | 0] << 16 | A[we + 142 | 0] << 24), v = we + 8 | 0, u[v + 63 | 0] = A[d | 0], d = a[m + 4 >> 2], Me = v + 55 | 0, B = a[m >> 2], u[Me | 0] = B, u[Me + 1 | 0] = B >>> 8, u[Me + 2 | 0] = B >>> 16, u[Me + 3 | 0] = B >>> 24, u[Me + 4 | 0] = d, u[Me + 5 | 0] = d >>> 8, u[Me + 6 | 0] = d >>> 16, u[Me + 7 | 0] = d >>> 24, d = a[Be + 4 >> 2], m = v + 47 | 0, B = a[Be >> 2], u[m | 0] = B, u[m + 1 | 0] = B >>> 8, u[m + 2 | 0] = B >>> 16, u[m + 3 | 0] = B >>> 24, u[m + 4 | 0] = d, u[m + 5 | 0] = d >>> 8, u[m + 6 | 0] = d >>> 16, u[m + 7 | 0] = d >>> 24, d = a[wr + 4 >> 2], m = v + 39 | 0, B = a[wr >> 2], u[m | 0] = B, u[m + 1 | 0] = B >>> 8, u[m + 2 | 0] = B >>> 16, u[m + 3 | 0] = B >>> 24, u[m + 4 | 0] = d, u[m + 5 | 0] = d >>> 8, u[m + 6 | 0] = d >>> 16, u[m + 7 | 0] = d >>> 24, d = a[Dr + 4 >> 2], m = v + 31 | 0, B = a[Dr >> 2], u[m | 0] = B, u[m + 1 | 0] = B >>> 8, u[m + 2 | 0] = B >>> 16, u[m + 3 | 0] = B >>> 24, u[m + 4 | 0] = d, u[m + 5 | 0] = d >>> 8, u[m + 6 | 0] = d >>> 16, u[m + 7 | 0] = d >>> 24, d = a[dr + 4 >> 2], m = v + 23 | 0, B = a[dr >> 2], u[m | 0] = B, u[m + 1 | 0] = B >>> 8, u[m + 2 | 0] = B >>> 16, u[m + 3 | 0] = B >>> 24, u[m + 4 | 0] = d, u[m + 5 | 0] = d >>> 8, u[m + 6 | 0] = d >>> 16, u[m + 7 | 0] = d >>> 24, d = a[Rr + 4 >> 2], m = v + 15 | 0, B = a[Rr >> 2], u[m | 0] = B, u[m + 1 | 0] = B >>> 8, u[m + 2 | 0] = B >>> 16, u[m + 3 | 0] = B >>> 24, u[m + 4 | 0] = d, u[m + 5 | 0] = d >>> 8, u[m + 6 | 0] = d >>> 16, u[m + 7 | 0] = d >>> 24, u[we + 11 | 0] = fr, u[we + 12 | 0] = fr >>> 8, u[we + 13 | 0] = fr >>> 16, u[we + 14 | 0] = fr >>> 24, d = a[we + 76 >> 2], B = a[we + 72 >> 2], u[we + 15 | 0] = B, u[we + 16 | 0] = B >>> 8, u[we + 17 | 0] = B >>> 16, u[we + 18 | 0] = B >>> 24, u[we + 19 | 0] = d, u[we + 20 | 0] = d >>> 8, u[we + 21 | 0] = d >>> 16, u[we + 22 | 0] = d >>> 24, Qe = yr(), he = be - 288 | 0, be = he;
        t: {
          if (!v) {
            ji[a[Qe + 168 >> 2]](689638, a[Qe + 172 >> 2]);
            break t;
          }
          if (B = A[v + 60 | 0] | A[v + 61 | 0] << 8 | (A[v + 62 | 0] << 16 | A[v + 63 | 0] << 24), dr = B >>> 16 | 0, Be = he + 72 | 0, d = A[v + 56 | 0] | A[v + 57 | 0] << 8 | (A[v + 58 | 0] << 16 | A[v + 59 | 0] << 24), a[Be >> 2] = (B & 65535) << 16 | d >>> 16, a[Be + 4 >> 2] = dr, Be = d << 4 & 1048560, B = A[v + 52 | 0] | A[v + 53 | 0] << 8 | (A[v + 54 | 0] << 16 | A[v + 55 | 0] << 24), Me = B >>> 28 | 0, wr = he - -64 | 0, d = A[v + 48 | 0] | A[v + 49 | 0] << 8 | (A[v + 50 | 0] << 16 | A[v + 51 | 0] << 24), a[wr >> 2] = (B & 268435455) << 4 | d >>> 28, a[wr + 4 >> 2] = Be | Me, dr = B << 24 | d >>> 8, wr = d << 24 & -16777216, d = A[v + 40 | 0] | A[v + 41 | 0] << 8 | (A[v + 42 | 0] << 16 | A[v + 43 | 0] << 24), Dr = he + 56 | 0, B = A[v + 44 | 0] | A[v + 45 | 0] << 8 | (A[v + 46 | 0] << 16 | A[v + 47 | 0] << 24), a[Dr >> 2] = B >>> 8 | wr, a[Dr + 4 >> 2] = dr & 1048575, dr = B << 12 | d >>> 20, wr = d << 12 & -4096, m = A[v + 32 | 0] | A[v + 33 | 0] << 8 | (A[v + 34 | 0] << 16 | A[v + 35 | 0] << 24), B = A[v + 36 | 0] | A[v + 37 | 0] << 8 | (A[v + 38 | 0] << 16 | A[v + 39 | 0] << 24), Dr = he + 48 | 0, a[Dr >> 2] = B >>> 20 | wr, a[Dr + 4 >> 2] = dr & 1048575, a[he + 80 >> 2] = 0, a[he + 40 >> 2] = m, a[he + 44 >> 2] = B & 1048575, m = A[v + 12 | 0] | A[v + 13 | 0] << 8 | (A[v + 14 | 0] << 16 | A[v + 15 | 0] << 24), fr = m, d = A[v + 8 | 0] | A[v + 9 | 0] << 8 | (A[v + 10 | 0] << 16 | A[v + 11 | 0] << 24), dr = m << 12 | d >>> 20, wr = d << 12 & -4096, Rr = A[v | 0] | A[v + 1 | 0] << 8 | (A[v + 2 | 0] << 16 | A[v + 3 | 0] << 24), d = A[v + 4 | 0] | A[v + 5 | 0] << 8 | (A[v + 6 | 0] << 16 | A[v + 7 | 0] << 24), m = d, B = he, Fr = m >>> 20 | wr, a[B + 8 >> 2] = Fr, Gr = dr & 1048575, a[B + 12 >> 2] = Gr, a[B >> 2] = Rr, $r = m & 1048575, a[B + 4 >> 2] = $r, d = A[v + 24 | 0] | A[v + 25 | 0] << 8 | (A[v + 26 | 0] << 16 | A[v + 27 | 0] << 24), dr = d, m = A[v + 28 | 0] | A[v + 29 | 0] << 8 | (A[v + 30 | 0] << 16 | A[v + 31 | 0] << 24), Be = (m & 65535) << 16 | d >>> 16, a[B + 32 >> 2] = Be, wr = m >>> 16 | 0, a[B + 36 >> 2] = wr, d = A[v + 16 | 0] | A[v + 17 | 0] << 8 | (A[v + 18 | 0] << 16 | A[v + 19 | 0] << 24), m = A[v + 20 | 0] | A[v + 21 | 0] << 8 | (A[v + 22 | 0] << 16 | A[v + 23 | 0] << 24), Me = m << 24 | d >>> 8, ni = d << 24 & -16777216 | fr >>> 8, a[B + 16 >> 2] = ni, fr = Me & 1048575, a[B + 20 >> 2] = fr, Dr = dr << 4 & 1048560, d = (m & 268435455) << 4 | d >>> 28, a[B + 24 >> 2] = d, B = m >>> 28 | Dr, a[he + 28 >> 2] = B, !(Rr | Fr | Be | ni | d | (Gr | $r | wr | fr | B))) {
            ji[a[Qe + 168 >> 2]](690116, a[Qe + 172 >> 2]), B = v + 56 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, B = v + 48 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, B = v + 40 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, B = v + 32 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, B = v + 24 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, B = v + 16 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, B = v + 8 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0;
            break t;
          }
          if (u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, B = v + 56 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, B = v + 48 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, B = v + 40 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, B = v + 32 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, B = v + 24 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, B = v + 16 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, B = v + 8 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, a[he + 92 >> 2] = 0, Rn(he + 96 | 0, 690949, he + 92 | 0), a[he + 92 >> 2] || (m = he + 8 | 0, d = a[m + 4 >> 2], Be = he + 160 | 0, B = Be + 8 | 0, a[B >> 2] = a[m >> 2], a[B + 4 >> 2] = d, m = he + 16 | 0, d = a[m + 4 >> 2], B = Be + 16 | 0, a[B >> 2] = a[m >> 2], a[B + 4 >> 2] = d, m = he + 24 | 0, d = a[m + 4 >> 2], B = Be + 24 | 0, a[B >> 2] = a[m >> 2], a[B + 4 >> 2] = d, m = he + 32 | 0, d = a[m + 4 >> 2], B = Be + 32 | 0, a[B >> 2] = a[m >> 2], a[B + 4 >> 2] = d, m = he + 48 | 0, d = a[m + 4 >> 2], B = Be + 48 | 0, a[B >> 2] = a[m >> 2], a[B + 4 >> 2] = d, m = he + 56 | 0, d = a[m + 4 >> 2], B = Be + 56 | 0, a[B >> 2] = a[m >> 2], a[B + 4 >> 2] = d, m = he - -64 | 0, d = a[m + 4 >> 2], B = Be - -64 | 0, a[B >> 2] = a[m >> 2], a[B + 4 >> 2] = d, m = he + 72 | 0, d = a[m + 4 >> 2], B = Be + 72 | 0, a[B >> 2] = a[m >> 2], a[B + 4 >> 2] = d, a[he + 280 >> 2] = 0, B = a[he + 4 >> 2], a[he + 160 >> 2] = a[he >> 2], a[he + 164 >> 2] = B, B = a[he + 44 >> 2], a[he + 200 >> 2] = a[he + 40 >> 2], a[he + 204 >> 2] = B, B = he + 248 | 0, a[B >> 2] = 0, a[B + 4 >> 2] = 0, B = he + 256 | 0, a[B >> 2] = 0, a[B + 4 >> 2] = 0, B = he + 264 | 0, a[B >> 2] = 0, a[B + 4 >> 2] = 0, B = he + 272 | 0, a[B >> 2] = 0, a[B + 4 >> 2] = 0, d = he + 128 | 0, B = d + 16 | 0, a[B >> 2] = 0, a[B + 4 >> 2] = 0, B = d + 24 | 0, a[B >> 2] = 0, a[B + 4 >> 2] = 0, a[he + 240 >> 2] = 1, a[he + 244 >> 2] = 0, a[he + 136 >> 2] = 0, a[he + 140 >> 2] = 0, a[he + 128 >> 2] = 1, a[he + 132 >> 2] = 0, Ui(Be, Be, d, he + 96 | 0), a[he + 280 >> 2]))
            break t;
          Fo(he, he + 160 | 0), Gn(v, he), mi = 1;
        }
        if (be = he + 288 | 0, !mi || (a[we + 204 >> 2] = o, B = pn(a[172688], we + 204 | 0, we + 8 | 0, (o | 0) == 33 ? 258 : 2), a[we + 72 >> 2] = B, Si = 1, (B | 0) == 1))
          break e;
        a[we + 144 >> 2] = 0, ar(we + 136 | 0), wasm2js_trap();
      }
      Ee(1);
    }
    return be = we + 208 | 0, Si | 0;
  }
  function Cr() {
    var B = 0, o = 0, m = 0, d = 0, v = 0, he = 0, we = 0, Be = 0, Me = 0, fr = 0, wr = 0, dr = 0, Dr = 0, Rr = 0, Qe = 0, Fr = 0, Gr = 0, $r = 0, ni = 0, mi = 0;
    we = be - 208 | 0, be = we, m = we + 136 | 0, Gr = m + 56 | 0, a[Gr >> 2] = 0, a[Gr + 4 >> 2] = 0, $r = m + 48 | 0, a[$r >> 2] = 0, a[$r + 4 >> 2] = 0, Dr = m + 40 | 0, a[Dr >> 2] = 0, a[Dr + 4 >> 2] = 0, ni = m + 32 | 0, a[ni >> 2] = 0, a[ni + 4 >> 2] = 0, he = m + 24 | 0, a[he >> 2] = 0, a[he + 4 >> 2] = 0, Fr = m + 16 | 0, a[Fr >> 2] = 0, a[Fr + 4 >> 2] = 0, Qe = m + 8 | 0, a[Qe >> 2] = 0, a[Qe + 4 >> 2] = 0, a[we + 136 >> 2] = 0, a[we + 140 >> 2] = 0;
    e: {
      t: {
        if ((da(a[172688], m, 690885) | 0) == 1) {
          Me = we + 136 | 0, o = Me + 15 | 0, B = A[o + 4 | 0] | A[o + 5 | 0] << 8 | (A[o + 6 | 0] << 16 | A[o + 7 | 0] << 24), m = we + 72 | 0, mi = m + 8 | 0, a[mi >> 2] = A[o | 0] | A[o + 1 | 0] << 8 | (A[o + 2 | 0] << 16 | A[o + 3 | 0] << 24), a[mi + 4 >> 2] = B, o = Me + 23 | 0, B = A[o + 4 | 0] | A[o + 5 | 0] << 8 | (A[o + 6 | 0] << 16 | A[o + 7 | 0] << 24), wr = m + 16 | 0, a[wr >> 2] = A[o | 0] | A[o + 1 | 0] << 8 | (A[o + 2 | 0] << 16 | A[o + 3 | 0] << 24), a[wr + 4 >> 2] = B, o = Me + 31 | 0, B = A[o + 4 | 0] | A[o + 5 | 0] << 8 | (A[o + 6 | 0] << 16 | A[o + 7 | 0] << 24), dr = m + 24 | 0, a[dr >> 2] = A[o | 0] | A[o + 1 | 0] << 8 | (A[o + 2 | 0] << 16 | A[o + 3 | 0] << 24), a[dr + 4 >> 2] = B, o = Me + 39 | 0, B = A[o + 4 | 0] | A[o + 5 | 0] << 8 | (A[o + 6 | 0] << 16 | A[o + 7 | 0] << 24), fr = m + 32 | 0, a[fr >> 2] = A[o | 0] | A[o + 1 | 0] << 8 | (A[o + 2 | 0] << 16 | A[o + 3 | 0] << 24), a[fr + 4 >> 2] = B, o = Me + 47 | 0, B = A[o + 4 | 0] | A[o + 5 | 0] << 8 | (A[o + 6 | 0] << 16 | A[o + 7 | 0] << 24), v = m + 40 | 0, a[v >> 2] = A[o | 0] | A[o + 1 | 0] << 8 | (A[o + 2 | 0] << 16 | A[o + 3 | 0] << 24), a[v + 4 >> 2] = B, Be = Me + 55 | 0, B = A[Be + 4 | 0] | A[Be + 5 | 0] << 8 | (A[Be + 6 | 0] << 16 | A[Be + 7 | 0] << 24), o = m + 48 | 0, a[o >> 2] = A[Be | 0] | A[Be + 1 | 0] << 8 | (A[Be + 2 | 0] << 16 | A[Be + 3 | 0] << 24), a[o + 4 >> 2] = B, m = m + 56 | 0, u[m | 0] = A[Me + 63 | 0], u[we + 10 | 0] = A[we + 138 | 0], p[we + 8 >> 1] = b[we + 136 >> 1], B = A[we + 147 | 0] | A[we + 148 | 0] << 8 | (A[we + 149 | 0] << 16 | A[we + 150 | 0] << 24), a[we + 72 >> 2] = A[we + 143 | 0] | A[we + 144 | 0] << 8 | (A[we + 145 | 0] << 16 | A[we + 146 | 0] << 24), a[we + 76 >> 2] = B, B = A[we + 139 | 0] | A[we + 140 | 0] << 8 | (A[we + 141 | 0] << 16 | A[we + 142 | 0] << 24), d = we + 8 | 0, u[d + 63 | 0] = A[m | 0], Be = a[o + 4 >> 2], Rr = d + 55 | 0, m = a[o >> 2], u[Rr | 0] = m, u[Rr + 1 | 0] = m >>> 8, u[Rr + 2 | 0] = m >>> 16, u[Rr + 3 | 0] = m >>> 24, u[Rr + 4 | 0] = Be, u[Rr + 5 | 0] = Be >>> 8, u[Rr + 6 | 0] = Be >>> 16, u[Rr + 7 | 0] = Be >>> 24, o = a[v + 4 >> 2], Be = d + 47 | 0, m = a[v >> 2], u[Be | 0] = m, u[Be + 1 | 0] = m >>> 8, u[Be + 2 | 0] = m >>> 16, u[Be + 3 | 0] = m >>> 24, u[Be + 4 | 0] = o, u[Be + 5 | 0] = o >>> 8, u[Be + 6 | 0] = o >>> 16, u[Be + 7 | 0] = o >>> 24, o = a[fr + 4 >> 2], v = d + 39 | 0, m = a[fr >> 2], u[v | 0] = m, u[v + 1 | 0] = m >>> 8, u[v + 2 | 0] = m >>> 16, u[v + 3 | 0] = m >>> 24, u[v + 4 | 0] = o, u[v + 5 | 0] = o >>> 8, u[v + 6 | 0] = o >>> 16, u[v + 7 | 0] = o >>> 24, o = a[dr + 4 >> 2], v = d + 31 | 0, m = a[dr >> 2], u[v | 0] = m, u[v + 1 | 0] = m >>> 8, u[v + 2 | 0] = m >>> 16, u[v + 3 | 0] = m >>> 24, u[v + 4 | 0] = o, u[v + 5 | 0] = o >>> 8, u[v + 6 | 0] = o >>> 16, u[v + 7 | 0] = o >>> 24, o = a[wr + 4 >> 2], v = d + 23 | 0, m = a[wr >> 2], u[v | 0] = m, u[v + 1 | 0] = m >>> 8, u[v + 2 | 0] = m >>> 16, u[v + 3 | 0] = m >>> 24, u[v + 4 | 0] = o, u[v + 5 | 0] = o >>> 8, u[v + 6 | 0] = o >>> 16, u[v + 7 | 0] = o >>> 24, o = a[mi + 4 >> 2], v = d + 15 | 0, m = a[mi >> 2], u[v | 0] = m, u[v + 1 | 0] = m >>> 8, u[v + 2 | 0] = m >>> 16, u[v + 3 | 0] = m >>> 24, u[v + 4 | 0] = o, u[v + 5 | 0] = o >>> 8, u[v + 6 | 0] = o >>> 16, u[v + 7 | 0] = o >>> 24, u[we + 11 | 0] = B, u[we + 12 | 0] = B >>> 8, u[we + 13 | 0] = B >>> 16, u[we + 14 | 0] = B >>> 24, m = a[we + 76 >> 2], B = a[we + 72 >> 2], u[we + 15 | 0] = B, u[we + 16 | 0] = B >>> 8, u[we + 17 | 0] = B >>> 16, u[we + 18 | 0] = B >>> 24, u[we + 19 | 0] = m, u[we + 20 | 0] = m >>> 8, u[we + 21 | 0] = m >>> 16, u[we + 22 | 0] = m >>> 24, a[Gr >> 2] = 0, a[Gr + 4 >> 2] = 0, a[$r >> 2] = 0, a[$r + 4 >> 2] = 0, a[Dr >> 2] = 0, a[Dr + 4 >> 2] = 0, a[ni >> 2] = 0, a[ni + 4 >> 2] = 0, a[he >> 2] = 0, a[he + 4 >> 2] = 0, a[Fr >> 2] = 0, a[Fr + 4 >> 2] = 0, a[Qe >> 2] = 0, a[Qe + 4 >> 2] = 0, a[we + 136 >> 2] = 0, a[we + 140 >> 2] = 0, Dr = yr(), Rr = 0, he = be - 288 | 0, be = he;
          r: {
            if (!Me) {
              ji[a[Dr + 168 >> 2]](689607, a[Dr + 172 >> 2]);
              break r;
            }
            if (u[Me | 0] = 0, u[Me + 1 | 0] = 0, u[Me + 2 | 0] = 0, u[Me + 3 | 0] = 0, u[Me + 4 | 0] = 0, u[Me + 5 | 0] = 0, u[Me + 6 | 0] = 0, u[Me + 7 | 0] = 0, B = Me + 56 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, B = Me + 48 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, B = Me + 40 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, B = Me + 32 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, B = Me + 24 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, B = Me + 16 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, B = Me + 8 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, !d) {
              ji[a[Dr + 168 >> 2]](689629, a[Dr + 172 >> 2]);
              break r;
            }
            if (B = A[d + 60 | 0] | A[d + 61 | 0] << 8 | (A[d + 62 | 0] << 16 | A[d + 63 | 0] << 24), wr = B >>> 16 | 0, v = he + 72 | 0, m = A[d + 56 | 0] | A[d + 57 | 0] << 8 | (A[d + 58 | 0] << 16 | A[d + 59 | 0] << 24), a[v >> 2] = (B & 65535) << 16 | m >>> 16, a[v + 4 >> 2] = wr, v = m << 4 & 1048560, B = A[d + 52 | 0] | A[d + 53 | 0] << 8 | (A[d + 54 | 0] << 16 | A[d + 55 | 0] << 24), Fr = B >>> 28 | 0, fr = he - -64 | 0, m = A[d + 48 | 0] | A[d + 49 | 0] << 8 | (A[d + 50 | 0] << 16 | A[d + 51 | 0] << 24), a[fr >> 2] = (B & 268435455) << 4 | m >>> 28, a[fr + 4 >> 2] = v | Fr, wr = B << 24 | m >>> 8, fr = m << 24 & -16777216, m = A[d + 40 | 0] | A[d + 41 | 0] << 8 | (A[d + 42 | 0] << 16 | A[d + 43 | 0] << 24), dr = he + 56 | 0, B = A[d + 44 | 0] | A[d + 45 | 0] << 8 | (A[d + 46 | 0] << 16 | A[d + 47 | 0] << 24), a[dr >> 2] = B >>> 8 | fr, a[dr + 4 >> 2] = wr & 1048575, wr = B << 12 | m >>> 20, fr = m << 12 & -4096, o = A[d + 32 | 0] | A[d + 33 | 0] << 8 | (A[d + 34 | 0] << 16 | A[d + 35 | 0] << 24), B = A[d + 36 | 0] | A[d + 37 | 0] << 8 | (A[d + 38 | 0] << 16 | A[d + 39 | 0] << 24), dr = he + 48 | 0, a[dr >> 2] = B >>> 20 | fr, a[dr + 4 >> 2] = wr & 1048575, a[he + 80 >> 2] = 0, a[he + 40 >> 2] = o, a[he + 44 >> 2] = B & 1048575, o = A[d + 12 | 0] | A[d + 13 | 0] << 8 | (A[d + 14 | 0] << 16 | A[d + 15 | 0] << 24), Qe = o, m = A[d + 8 | 0] | A[d + 9 | 0] << 8 | (A[d + 10 | 0] << 16 | A[d + 11 | 0] << 24), wr = o << 12 | m >>> 20, fr = m << 12 & -4096, mi = A[d | 0] | A[d + 1 | 0] << 8 | (A[d + 2 | 0] << 16 | A[d + 3 | 0] << 24), m = A[d + 4 | 0] | A[d + 5 | 0] << 8 | (A[d + 6 | 0] << 16 | A[d + 7 | 0] << 24), o = m, B = he, Be = o >>> 20 | fr, a[B + 8 >> 2] = Be, Gr = wr & 1048575, a[B + 12 >> 2] = Gr, a[B >> 2] = mi, $r = o & 1048575, a[B + 4 >> 2] = $r, m = A[d + 24 | 0] | A[d + 25 | 0] << 8 | (A[d + 26 | 0] << 16 | A[d + 27 | 0] << 24), wr = m, o = A[d + 28 | 0] | A[d + 29 | 0] << 8 | (A[d + 30 | 0] << 16 | A[d + 31 | 0] << 24), v = (o & 65535) << 16 | m >>> 16, a[B + 32 >> 2] = v, fr = o >>> 16 | 0, a[B + 36 >> 2] = fr, m = A[d + 16 | 0] | A[d + 17 | 0] << 8 | (A[d + 18 | 0] << 16 | A[d + 19 | 0] << 24), o = A[d + 20 | 0] | A[d + 21 | 0] << 8 | (A[d + 22 | 0] << 16 | A[d + 23 | 0] << 24), Fr = o << 24 | m >>> 8, ni = m << 24 & -16777216 | Qe >>> 8, a[B + 16 >> 2] = ni, Qe = Fr & 1048575, a[B + 20 >> 2] = Qe, dr = wr << 4 & 1048560, m = (o & 268435455) << 4 | m >>> 28, a[B + 24 >> 2] = m, B = o >>> 28 | dr, a[he + 28 >> 2] = B, !(Be | mi | v | ni | m | (Gr | $r | fr | Qe | B))) {
              ji[a[Dr + 168 >> 2]](690116, a[Dr + 172 >> 2]);
              break r;
            }
            if (a[he + 92 >> 2] = 0, Rn(he + 96 | 0, 690949, he + 92 | 0), a[he + 92 >> 2] || (o = he + 8 | 0, m = a[o + 4 >> 2], v = he + 160 | 0, B = v + 8 | 0, a[B >> 2] = a[o >> 2], a[B + 4 >> 2] = m, o = he + 16 | 0, m = a[o + 4 >> 2], B = v + 16 | 0, a[B >> 2] = a[o >> 2], a[B + 4 >> 2] = m, o = he + 24 | 0, m = a[o + 4 >> 2], B = v + 24 | 0, a[B >> 2] = a[o >> 2], a[B + 4 >> 2] = m, o = he + 32 | 0, m = a[o + 4 >> 2], B = v + 32 | 0, a[B >> 2] = a[o >> 2], a[B + 4 >> 2] = m, o = he + 48 | 0, m = a[o + 4 >> 2], B = v + 48 | 0, a[B >> 2] = a[o >> 2], a[B + 4 >> 2] = m, o = he + 56 | 0, m = a[o + 4 >> 2], B = v + 56 | 0, a[B >> 2] = a[o >> 2], a[B + 4 >> 2] = m, o = he - -64 | 0, m = a[o + 4 >> 2], B = v - -64 | 0, a[B >> 2] = a[o >> 2], a[B + 4 >> 2] = m, o = he + 72 | 0, m = a[o + 4 >> 2], B = v + 72 | 0, a[B >> 2] = a[o >> 2], a[B + 4 >> 2] = m, a[he + 280 >> 2] = 0, B = a[he + 4 >> 2], a[he + 160 >> 2] = a[he >> 2], a[he + 164 >> 2] = B, B = a[he + 44 >> 2], a[he + 200 >> 2] = a[he + 40 >> 2], a[he + 204 >> 2] = B, B = he + 248 | 0, a[B >> 2] = 0, a[B + 4 >> 2] = 0, B = he + 256 | 0, a[B >> 2] = 0, a[B + 4 >> 2] = 0, B = he + 264 | 0, a[B >> 2] = 0, a[B + 4 >> 2] = 0, B = he + 272 | 0, a[B >> 2] = 0, a[B + 4 >> 2] = 0, m = he + 128 | 0, B = m + 16 | 0, a[B >> 2] = 0, a[B + 4 >> 2] = 0, B = m + 24 | 0, a[B >> 2] = 0, a[B + 4 >> 2] = 0, a[he + 240 >> 2] = 1, a[he + 244 >> 2] = 0, a[he + 136 >> 2] = 0, a[he + 140 >> 2] = 0, a[he + 128 >> 2] = 1, a[he + 132 >> 2] = 0, Ui(v, v, m, he + 96 | 0), a[he + 280 >> 2]))
              break r;
            Fo(he, he + 160 | 0), Gn(Me, he), Rr = 1;
          }
          if (be = he + 288 | 0, Rr) {
            if (a[we + 132 >> 2] = 0, B = hi(yr(), we + 8 | 0, we + 132 | 0, we + 136 | 0), a[we + 204 >> 2] = B, (B | 0) != 1 || (B = Bn(a[172688], we + 8 | 0), a[we + 204 >> 2] = B, (B | 0) != 1))
              break e;
            B = a[we + 132 >> 2];
            break t;
          }
          B = -1;
          break t;
        }
        Ee(1);
      }
      return be = we + 208 | 0, B | 0;
    }
    a[we + 80 >> 2] = 0, ar(we + 72 | 0), wasm2js_trap();
  }
  function Hr(B) {
    B = B | 0;
    var o = 0, m = 0, d = 0, v = 0, he = 0, we = 0, Be = 0, Me = 0, fr = 0, wr = 0, dr = 0, Dr = 0, Rr = 0, Qe = 0, Fr = 0, Gr = 0, $r = 0, ni = 0, mi = 0, Si = 0, Oi = 0, $i = 0, zi = 0, un = 0, In = 0, Ti = 0;
    d = be - 192 | 0, be = d, m = d + 128 | 0, fr = m + 56 | 0, a[fr >> 2] = 0, a[fr + 4 >> 2] = 0, wr = m + 48 | 0, a[wr >> 2] = 0, a[wr + 4 >> 2] = 0, Be = m + 40 | 0, a[Be >> 2] = 0, a[Be + 4 >> 2] = 0, Rr = m + 32 | 0, a[Rr >> 2] = 0, a[Rr + 4 >> 2] = 0, ni = m + 24 | 0, a[ni >> 2] = 0, a[ni + 4 >> 2] = 0, mi = m + 16 | 0, a[mi >> 2] = 0, a[mi + 4 >> 2] = 0, $r = m + 8 | 0, a[$r >> 2] = 0, a[$r + 4 >> 2] = 0, a[d + 128 >> 2] = 0, a[d + 132 >> 2] = 0;
    e: {
      if ((da(a[172688], m, 690885) | 0) == 1) {
        if (m = d + 128 | 0, o = m + 15 | 0, v = A[o + 4 | 0] | A[o + 5 | 0] << 8 | (A[o + 6 | 0] << 16 | A[o + 7 | 0] << 24), he = d - -64 | 0, dr = he + 8 | 0, a[dr >> 2] = A[o | 0] | A[o + 1 | 0] << 8 | (A[o + 2 | 0] << 16 | A[o + 3 | 0] << 24), a[dr + 4 >> 2] = v, o = m + 23 | 0, v = A[o + 4 | 0] | A[o + 5 | 0] << 8 | (A[o + 6 | 0] << 16 | A[o + 7 | 0] << 24), Qe = he + 16 | 0, a[Qe >> 2] = A[o | 0] | A[o + 1 | 0] << 8 | (A[o + 2 | 0] << 16 | A[o + 3 | 0] << 24), a[Qe + 4 >> 2] = v, o = m + 31 | 0, v = A[o + 4 | 0] | A[o + 5 | 0] << 8 | (A[o + 6 | 0] << 16 | A[o + 7 | 0] << 24), Dr = he + 24 | 0, a[Dr >> 2] = A[o | 0] | A[o + 1 | 0] << 8 | (A[o + 2 | 0] << 16 | A[o + 3 | 0] << 24), a[Dr + 4 >> 2] = v, o = m + 39 | 0, v = A[o + 4 | 0] | A[o + 5 | 0] << 8 | (A[o + 6 | 0] << 16 | A[o + 7 | 0] << 24), Fr = he + 32 | 0, a[Fr >> 2] = A[o | 0] | A[o + 1 | 0] << 8 | (A[o + 2 | 0] << 16 | A[o + 3 | 0] << 24), a[Fr + 4 >> 2] = v, o = m + 47 | 0, v = A[o + 4 | 0] | A[o + 5 | 0] << 8 | (A[o + 6 | 0] << 16 | A[o + 7 | 0] << 24), Gr = he + 40 | 0, a[Gr >> 2] = A[o | 0] | A[o + 1 | 0] << 8 | (A[o + 2 | 0] << 16 | A[o + 3 | 0] << 24), a[Gr + 4 >> 2] = v, o = m + 55 | 0, v = A[o + 4 | 0] | A[o + 5 | 0] << 8 | (A[o + 6 | 0] << 16 | A[o + 7 | 0] << 24), Me = he + 48 | 0, a[Me >> 2] = A[o | 0] | A[o + 1 | 0] << 8 | (A[o + 2 | 0] << 16 | A[o + 3 | 0] << 24), a[Me + 4 >> 2] = v, o = he + 56 | 0, u[o | 0] = A[m + 63 | 0], u[d + 2 | 0] = A[d + 130 | 0], p[d >> 1] = b[d + 128 >> 1], he = A[d + 139 | 0] | A[d + 140 | 0] << 8 | (A[d + 141 | 0] << 16 | A[d + 142 | 0] << 24), a[d + 64 >> 2] = A[d + 135 | 0] | A[d + 136 | 0] << 8 | (A[d + 137 | 0] << 16 | A[d + 138 | 0] << 24), a[d + 68 >> 2] = he, he = A[d + 131 | 0] | A[d + 132 | 0] << 8 | (A[d + 133 | 0] << 16 | A[d + 134 | 0] << 24), u[d + 63 | 0] = A[o | 0], v = a[Me + 4 >> 2], o = d + 55 | 0, Me = a[Me >> 2], u[o | 0] = Me, u[o + 1 | 0] = Me >>> 8, u[o + 2 | 0] = Me >>> 16, u[o + 3 | 0] = Me >>> 24, u[o + 4 | 0] = v, u[o + 5 | 0] = v >>> 8, u[o + 6 | 0] = v >>> 16, u[o + 7 | 0] = v >>> 24, v = a[Gr + 4 >> 2], o = d + 47 | 0, Gr = a[Gr >> 2], u[o | 0] = Gr, u[o + 1 | 0] = Gr >>> 8, u[o + 2 | 0] = Gr >>> 16, u[o + 3 | 0] = Gr >>> 24, u[o + 4 | 0] = v, u[o + 5 | 0] = v >>> 8, u[o + 6 | 0] = v >>> 16, u[o + 7 | 0] = v >>> 24, v = a[Fr + 4 >> 2], o = d + 39 | 0, Fr = a[Fr >> 2], u[o | 0] = Fr, u[o + 1 | 0] = Fr >>> 8, u[o + 2 | 0] = Fr >>> 16, u[o + 3 | 0] = Fr >>> 24, u[o + 4 | 0] = v, u[o + 5 | 0] = v >>> 8, u[o + 6 | 0] = v >>> 16, u[o + 7 | 0] = v >>> 24, v = a[Dr + 4 >> 2], o = d + 31 | 0, Dr = a[Dr >> 2], u[o | 0] = Dr, u[o + 1 | 0] = Dr >>> 8, u[o + 2 | 0] = Dr >>> 16, u[o + 3 | 0] = Dr >>> 24, u[o + 4 | 0] = v, u[o + 5 | 0] = v >>> 8, u[o + 6 | 0] = v >>> 16, u[o + 7 | 0] = v >>> 24, v = a[Qe + 4 >> 2], o = d + 23 | 0, Qe = a[Qe >> 2], u[o | 0] = Qe, u[o + 1 | 0] = Qe >>> 8, u[o + 2 | 0] = Qe >>> 16, u[o + 3 | 0] = Qe >>> 24, u[o + 4 | 0] = v, u[o + 5 | 0] = v >>> 8, u[o + 6 | 0] = v >>> 16, u[o + 7 | 0] = v >>> 24, v = a[dr + 4 >> 2], o = d + 15 | 0, dr = a[dr >> 2], u[o | 0] = dr, u[o + 1 | 0] = dr >>> 8, u[o + 2 | 0] = dr >>> 16, u[o + 3 | 0] = dr >>> 24, u[o + 4 | 0] = v, u[o + 5 | 0] = v >>> 8, u[o + 6 | 0] = v >>> 16, u[o + 7 | 0] = v >>> 24, u[d + 3 | 0] = he, u[d + 4 | 0] = he >>> 8, u[d + 5 | 0] = he >>> 16, u[d + 6 | 0] = he >>> 24, o = a[d + 68 >> 2], he = a[d + 64 >> 2], u[d + 7 | 0] = he, u[d + 8 | 0] = he >>> 8, u[d + 9 | 0] = he >>> 16, u[d + 10 | 0] = he >>> 24, u[d + 11 | 0] = o, u[d + 12 | 0] = o >>> 8, u[d + 13 | 0] = o >>> 16, u[d + 14 | 0] = o >>> 24, a[fr >> 2] = 0, a[fr + 4 >> 2] = 0, a[wr >> 2] = 0, a[wr + 4 >> 2] = 0, a[Be >> 2] = 0, a[Be + 4 >> 2] = 0, a[Rr >> 2] = 0, a[Rr + 4 >> 2] = 0, a[ni >> 2] = 0, a[ni + 4 >> 2] = 0, a[mi >> 2] = 0, a[mi + 4 >> 2] = 0, a[$r >> 2] = 0, a[$r + 4 >> 2] = 0, a[d + 128 >> 2] = 0, a[d + 132 >> 2] = 0, (da(a[172688], m, 690917) | 0) == 1) {
          $r = yr(), we = be - 288 | 0, be = we;
          t: {
            if (!d) {
              ji[a[$r + 168 >> 2]](689629, a[$r + 172 >> 2]);
              break t;
            }
            if (he = A[d + 60 | 0] | A[d + 61 | 0] << 8 | (A[d + 62 | 0] << 16 | A[d + 63 | 0] << 24), m = he >>> 16 | 0, v = we + 72 | 0, o = A[d + 56 | 0] | A[d + 57 | 0] << 8 | (A[d + 58 | 0] << 16 | A[d + 59 | 0] << 24), a[v >> 2] = (he & 65535) << 16 | o >>> 16, a[v + 4 >> 2] = m, fr = o << 4 & 1048560, he = A[d + 52 | 0] | A[d + 53 | 0] << 8 | (A[d + 54 | 0] << 16 | A[d + 55 | 0] << 24), m = he >>> 28 | 0, v = we - -64 | 0, o = A[d + 48 | 0] | A[d + 49 | 0] << 8 | (A[d + 50 | 0] << 16 | A[d + 51 | 0] << 24), a[v >> 2] = (he & 268435455) << 4 | o >>> 28, a[v + 4 >> 2] = m | fr, m = he << 24 | o >>> 8, fr = o << 24 & -16777216, o = A[d + 40 | 0] | A[d + 41 | 0] << 8 | (A[d + 42 | 0] << 16 | A[d + 43 | 0] << 24), v = we + 56 | 0, he = A[d + 44 | 0] | A[d + 45 | 0] << 8 | (A[d + 46 | 0] << 16 | A[d + 47 | 0] << 24), a[v >> 2] = he >>> 8 | fr, a[v + 4 >> 2] = m & 1048575, he = (he << 12 | o >>> 20) & 1048575, fr = A[d + 32 | 0] | A[d + 33 | 0] << 8 | (A[d + 34 | 0] << 16 | A[d + 35 | 0] << 24), v = we + 48 | 0, wr = A[d + 36 | 0] | A[d + 37 | 0] << 8 | (A[d + 38 | 0] << 16 | A[d + 39 | 0] << 24), a[v >> 2] = o << 12 & -4096 | wr >>> 20, a[v + 4 >> 2] = he, a[we + 40 >> 2] = fr, a[we + 44 >> 2] = wr & 1048575, m = A[d + 12 | 0] | A[d + 13 | 0] << 8 | (A[d + 14 | 0] << 16 | A[d + 15 | 0] << 24), v = m, he = A[d + 8 | 0] | A[d + 9 | 0] << 8 | (A[d + 10 | 0] << 16 | A[d + 11 | 0] << 24), m = m << 12 | he >>> 20, fr = he << 12 & -4096, he = A[d | 0] | A[d + 1 | 0] << 8 | (A[d + 2 | 0] << 16 | A[d + 3 | 0] << 24), o = we, Be = A[d + 4 | 0] | A[d + 5 | 0] << 8 | (A[d + 6 | 0] << 16 | A[d + 7 | 0] << 24), dr = Be >>> 20 | fr, a[o + 8 >> 2] = dr, Qe = m & 1048575, a[o + 12 >> 2] = Qe, fr = he, a[o >> 2] = he, Dr = Be & 1048575, a[o + 4 >> 2] = Dr, he = A[d + 28 | 0] | A[d + 29 | 0] << 8 | (A[d + 30 | 0] << 16 | A[d + 31 | 0] << 24), m = he >>> 16 | 0, wr = A[d + 24 | 0] | A[d + 25 | 0] << 8 | (A[d + 26 | 0] << 16 | A[d + 27 | 0] << 24), ni = (he & 65535) << 16 | wr >>> 16, a[o + 32 >> 2] = ni, Rr = m, a[o + 36 >> 2] = m, m = A[d + 20 | 0] | A[d + 21 | 0] << 8 | (A[d + 22 | 0] << 16 | A[d + 23 | 0] << 24), he = A[d + 16 | 0] | A[d + 17 | 0] << 8 | (A[d + 18 | 0] << 16 | A[d + 19 | 0] << 24), Gr = (m << 24 | he >>> 8) & 1048575, v = he << 24 & -16777216 | v >>> 8, a[o + 16 >> 2] = v, Fr = Gr, a[o + 20 >> 2] = Fr, wr = wr << 4 & 1048560, o = m, m = o >>> 28 | 0, o = (o & 268435455) << 4 | he >>> 28, a[we + 24 >> 2] = o, m = m | wr, a[we + 28 >> 2] = m, !(fr | dr | ni | v | o | (Qe | Dr | Rr | Fr | m))) {
              ji[a[$r + 168 >> 2]](690116, a[$r + 172 >> 2]);
              break t;
            }
            if (a[we + 92 >> 2] = 0, Rn(we + 96 | 0, 690949, we + 92 | 0), a[we + 92 >> 2] || (o = we + 8 | 0, he = a[o + 4 >> 2], m = we + 160 | 0, v = m + 8 | 0, a[v >> 2] = a[o >> 2], a[v + 4 >> 2] = he, o = we + 16 | 0, he = a[o + 4 >> 2], v = m + 16 | 0, a[v >> 2] = a[o >> 2], a[v + 4 >> 2] = he, o = we + 24 | 0, he = a[o + 4 >> 2], v = m + 24 | 0, a[v >> 2] = a[o >> 2], a[v + 4 >> 2] = he, o = we + 32 | 0, he = a[o + 4 >> 2], v = m + 32 | 0, a[v >> 2] = a[o >> 2], a[v + 4 >> 2] = he, o = we + 48 | 0, he = a[o + 4 >> 2], v = m + 48 | 0, a[v >> 2] = a[o >> 2], a[v + 4 >> 2] = he, o = we + 56 | 0, he = a[o + 4 >> 2], v = m + 56 | 0, a[v >> 2] = a[o >> 2], a[v + 4 >> 2] = he, o = we - -64 | 0, he = a[o + 4 >> 2], v = m - -64 | 0, a[v >> 2] = a[o >> 2], a[v + 4 >> 2] = he, o = we + 72 | 0, he = a[o + 4 >> 2], v = m + 72 | 0, a[v >> 2] = a[o >> 2], a[v + 4 >> 2] = he, a[we + 280 >> 2] = 0, o = a[we + 4 >> 2], a[we + 160 >> 2] = a[we >> 2], a[we + 164 >> 2] = o, o = a[we + 44 >> 2], a[we + 200 >> 2] = a[we + 40 >> 2], a[we + 204 >> 2] = o, o = we + 248 | 0, a[o >> 2] = 0, a[o + 4 >> 2] = 0, o = we + 256 | 0, a[o >> 2] = 0, a[o + 4 >> 2] = 0, o = we + 264 | 0, a[o >> 2] = 0, a[o + 4 >> 2] = 0, o = we + 272 | 0, a[o >> 2] = 0, a[o + 4 >> 2] = 0, o = we + 128 | 0, he = o + 16 | 0, a[he >> 2] = 0, a[he + 4 >> 2] = 0, he = o + 24 | 0, a[he >> 2] = 0, a[he + 4 >> 2] = 0, a[we + 240 >> 2] = 1, a[we + 244 >> 2] = 0, a[we + 136 >> 2] = 0, a[we + 140 >> 2] = 0, a[we + 128 >> 2] = 1, a[we + 132 >> 2] = 0, Ui(m, m, o, we + 96 | 0), a[we + 280 >> 2]) || (Fo(we, we + 160 | 0), he = a[we + 8 >> 2], v = a[we + 12 >> 2], fr = a[we + 4 >> 2], Be = a[we + 32 >> 2], wr = a[we + 36 >> 2], ni = wr, m = a[we >> 2], o = oi(wr >>> 16 | 0, 0, 977, 1), Fr = m + o | 0, m = fr + Fe | 0, Rr = o >>> 0 > Fr >>> 0 ? m + 1 | 0 : m, m = v, o = Rr >>> 20 | 0, v = o, o = o + he | 0, v = v >>> 0 > o >>> 0 ? m + 1 | 0 : m, $r = v & 1048575, mi = a[we + 24 >> 2], dr = a[we + 28 >> 2], m = a[we + 20 >> 2], he = v >>> 20 | 0, wr = he + a[we + 16 >> 2] | 0, fr = he >>> 0 > wr >>> 0 ? m + 1 | 0 : m, m = dr, he = fr >>> 20 | 0, Me = he, he = he + mi | 0, m = Me >>> 0 > he >>> 0 ? m + 1 | 0 : m, dr = m & 1048575, fr = fr & 1048575, mi = (o & wr & he) == -1 & (v & fr & m) == 1048575, v = m, m = ni & 65535, v = v >>> 20 | 0, Dr = v + Be | 0, m = v >>> 0 > Dr >>> 0 ? m + 1 | 0 : m, v = m, Qe = Rr & 1048575, mi & ((Dr | 0) == -1 & (m | 0) == 65535) & ((Qe | 0) == 1048574 & Fr >>> 0 > 4294966318 | Qe >>> 0 > 1048574) | m >>> 16 && (m = Qe + 1 | 0, Fr = Fr + 977 | 0, m = Fr >>> 0 < 977 ? m + 1 | 0 : m, Qe = m & 1048575, Be = m, m = $r, Be = Be >>> 20 | 0, o = o + Be | 0, m = Be >>> 0 > o >>> 0 ? m + 1 | 0 : m, $r = m & 1048575, Be = m, m = fr, Be = Be >>> 20 | 0, wr = Be + wr | 0, m = Be >>> 0 > wr >>> 0 ? m + 1 | 0 : m, fr = m & 1048575, Be = m, m = dr, Be = Be >>> 20 | 0, he = he + Be | 0, m = Be >>> 0 > he >>> 0 ? m + 1 | 0 : m, dr = m & 1048575, Be = m, m = v, v = Dr, Dr = (Be >>> 20 | 0) + Dr | 0, v = (v >>> 0 > Dr >>> 0 ? m + 1 | 0 : m) & 65535), a[we + 32 >> 2] = Dr, a[we + 36 >> 2] = v, a[we + 24 >> 2] = he, a[we + 28 >> 2] = dr, a[we + 16 >> 2] = wr, a[we + 20 >> 2] = fr, a[we + 8 >> 2] = o, a[we + 12 >> 2] = $r, a[we >> 2] = Fr, a[we + 4 >> 2] = Qe, ni = a[we + 48 >> 2], mi = a[we + 52 >> 2], Me = a[we + 44 >> 2], Be = a[we + 72 >> 2], Gr = a[we + 76 >> 2], zi = Gr, m = a[we + 40 >> 2], Rr = oi(Gr >>> 16 | 0, 0, 977, 1), Gr = m + Rr | 0, m = Me + Fe | 0, Oi = Rr >>> 0 > Gr >>> 0 ? m + 1 | 0 : m, m = mi, Rr = Oi >>> 20 | 0, ni = Rr + ni | 0, Me = Rr >>> 0 > ni >>> 0 ? m + 1 | 0 : m, un = Me & 1048575, $i = Be, In = zi & 65535, Rr = a[we + 64 >> 2], Si = a[we + 68 >> 2], m = a[we + 60 >> 2], Be = Me >>> 20 | 0, mi = Be + a[we + 56 >> 2] | 0, zi = Be >>> 0 > mi >>> 0 ? m + 1 | 0 : m, m = Si, Be = zi >>> 20 | 0, Si = Be, Be = Be + Rr | 0, Rr = Si >>> 0 > Be >>> 0 ? m + 1 | 0 : m, m = In, Si = Rr >>> 20 | 0, In = Si, Si = $i + Si | 0, m = In >>> 0 > Si >>> 0 ? m + 1 | 0 : m, $i = zi & 1048575, Oi = Oi & 1048575, (mi & ni & Be) == -1 & (Me & $i & Rr) == 1048575 & ((Si | 0) == -1 & (m | 0) == 65535) & ((Oi | 0) == 1048574 & Gr >>> 0 > 4294966318 | Oi >>> 0 > 1048574) | m >>> 16 && (m = Oi + 1 | 0, Gr = Gr + 977 | 0, m = Gr >>> 0 < 977 ? m + 1 | 0 : m, Oi = m & 1048575, Me = m, m = un, Me = Me >>> 20 | 0, ni = Me + ni | 0, m = Me >>> 0 > ni >>> 0 ? m + 1 | 0 : m, un = m & 1048575, Me = m, m = $i, Me = Me >>> 20 | 0, mi = Me + mi | 0, m = Me >>> 0 > mi >>> 0 ? m + 1 | 0 : m, $i = m & 1048575, Me = m, m = Rr, Me = Me >>> 20 | 0, Be = Be + Me | 0, Rr = Me >>> 0 > Be >>> 0 ? m + 1 | 0 : m), a[we + 56 >> 2] = mi, a[we + 60 >> 2] = $i, a[we + 48 >> 2] = ni, a[we + 52 >> 2] = un, a[we + 40 >> 2] = Gr, a[we + 44 >> 2] = Oi, a[we + 64 >> 2] = Be, a[we + 68 >> 2] = Rr & 1048575, A[690917] != (v >>> 8 & 255)) || A[690918] != (v & 255) || A[690919] != (((v & 16777215) << 8 | Dr >>> 24) & 255) || A[690920] != (((v & 65535) << 16 | Dr >>> 16) & 255) || A[690921] != (((v & 255) << 24 | Dr >>> 8) & 255) || A[690922] != (Dr & 255) || A[690923] != (dr >>> 12 | 0) || A[690924] != (dr >>> 4 & 255) || A[690925] != (((dr & 268435455) << 4 | he >>> 28) & 255) || A[690926] != (((dr & 1048575) << 12 | he >>> 20) & 255) || A[690927] != (((dr & 4095) << 20 | he >>> 12) & 255) || A[690928] != (((dr & 15) << 28 | he >>> 4) & 255) || A[690929] != ((he << 4 | fr >>> 16) & 255) || (m = fr, A[690930] != (m >>> 8 & 255)) || A[690931] != (m & 255) || A[690932] != (((fr & 16777215) << 8 | wr >>> 24) & 255) || A[690933] != (((fr & 65535) << 16 | wr >>> 16) & 255) || A[690934] != (((fr & 255) << 24 | wr >>> 8) & 255) || A[690935] != (wr & 255) || A[690936] != ($r >>> 12 | 0) || A[690937] != ($r >>> 4 & 255) || A[690938] != ((($r & 268435455) << 4 | o >>> 28) & 255) || A[690939] != ((($r & 1048575) << 12 | o >>> 20) & 255) || A[690940] != ((($r & 4095) << 20 | o >>> 12) & 255) || A[690941] != ((($r & 15) << 28 | o >>> 4) & 255) || A[690942] != ((o << 4 | Qe >>> 16) & 255) || (m = Qe, A[690943] != (m >>> 8 & 255)) || A[690944] != (m & 255) || A[690945] != (((Qe & 16777215) << 8 | Fr >>> 24) & 255) || A[690946] != (((Qe & 65535) << 16 | Fr >>> 16) & 255) || A[690947] != (((Qe & 255) << 24 | Fr >>> 8) & 255) || A[690948] != (Fr & 255))
              break t;
            Ti = (Gr & 1) == (B | 0);
          }
          be = we + 288 | 0;
          break e;
        }
        Ee(1);
        break e;
      }
      Ee(1);
    }
    return be = d + 192 | 0, Ti | 0;
  }
  function si(B, o) {
    B = B | 0, o = o | 0;
    var m = 0, d = 0, v = 0, he = 0, we = 0, Be = 0, Me = 0, fr = 0, wr = 0, dr = 0;
    d = be - 208 | 0, be = d, m = d + 136 | 0, he = m + 56 | 0, a[he >> 2] = 0, a[he + 4 >> 2] = 0, he = m + 48 | 0, a[he >> 2] = 0, a[he + 4 >> 2] = 0, he = m + 40 | 0, a[he >> 2] = 0, a[he + 4 >> 2] = 0, he = m + 32 | 0, a[he >> 2] = 0, a[he + 4 >> 2] = 0, he = m + 24 | 0, a[he >> 2] = 0, a[he + 4 >> 2] = 0, he = m + 16 | 0, a[he >> 2] = 0, a[he + 4 >> 2] = 0, he = m + 8 | 0, a[he >> 2] = 0, a[he + 4 >> 2] = 0, a[d + 136 >> 2] = 0, a[d + 140 >> 2] = 0;
    e: {
      if ((On(a[172688], m, 690820, B) | 0) == 1) {
        if (m = d + 136 | 0, B = m + 15 | 0, v = A[B + 4 | 0] | A[B + 5 | 0] << 8 | (A[B + 6 | 0] << 16 | A[B + 7 | 0] << 24), he = d + 72 | 0, we = he + 8 | 0, a[we >> 2] = A[B | 0] | A[B + 1 | 0] << 8 | (A[B + 2 | 0] << 16 | A[B + 3 | 0] << 24), a[we + 4 >> 2] = v, B = m + 23 | 0, v = A[B + 4 | 0] | A[B + 5 | 0] << 8 | (A[B + 6 | 0] << 16 | A[B + 7 | 0] << 24), Be = he + 16 | 0, a[Be >> 2] = A[B | 0] | A[B + 1 | 0] << 8 | (A[B + 2 | 0] << 16 | A[B + 3 | 0] << 24), a[Be + 4 >> 2] = v, B = m + 31 | 0, v = A[B + 4 | 0] | A[B + 5 | 0] << 8 | (A[B + 6 | 0] << 16 | A[B + 7 | 0] << 24), Me = he + 24 | 0, a[Me >> 2] = A[B | 0] | A[B + 1 | 0] << 8 | (A[B + 2 | 0] << 16 | A[B + 3 | 0] << 24), a[Me + 4 >> 2] = v, B = m + 39 | 0, v = A[B + 4 | 0] | A[B + 5 | 0] << 8 | (A[B + 6 | 0] << 16 | A[B + 7 | 0] << 24), fr = he + 32 | 0, a[fr >> 2] = A[B | 0] | A[B + 1 | 0] << 8 | (A[B + 2 | 0] << 16 | A[B + 3 | 0] << 24), a[fr + 4 >> 2] = v, B = m + 47 | 0, v = A[B + 4 | 0] | A[B + 5 | 0] << 8 | (A[B + 6 | 0] << 16 | A[B + 7 | 0] << 24), wr = he + 40 | 0, a[wr >> 2] = A[B | 0] | A[B + 1 | 0] << 8 | (A[B + 2 | 0] << 16 | A[B + 3 | 0] << 24), a[wr + 4 >> 2] = v, B = m + 55 | 0, v = A[B + 4 | 0] | A[B + 5 | 0] << 8 | (A[B + 6 | 0] << 16 | A[B + 7 | 0] << 24), dr = he + 48 | 0, a[dr >> 2] = A[B | 0] | A[B + 1 | 0] << 8 | (A[B + 2 | 0] << 16 | A[B + 3 | 0] << 24), a[dr + 4 >> 2] = v, v = he + 56 | 0, u[v | 0] = A[m + 63 | 0], u[d + 10 | 0] = A[d + 138 | 0], p[d + 8 >> 1] = b[d + 136 >> 1], B = A[d + 147 | 0] | A[d + 148 | 0] << 8 | (A[d + 149 | 0] << 16 | A[d + 150 | 0] << 24), a[d + 72 >> 2] = A[d + 143 | 0] | A[d + 144 | 0] << 8 | (A[d + 145 | 0] << 16 | A[d + 146 | 0] << 24), a[d + 76 >> 2] = B, he = A[d + 139 | 0] | A[d + 140 | 0] << 8 | (A[d + 141 | 0] << 16 | A[d + 142 | 0] << 24), B = d + 8 | 0, u[B + 63 | 0] = A[v | 0], v = a[dr + 4 >> 2], m = B + 55 | 0, dr = a[dr >> 2], u[m | 0] = dr, u[m + 1 | 0] = dr >>> 8, u[m + 2 | 0] = dr >>> 16, u[m + 3 | 0] = dr >>> 24, u[m + 4 | 0] = v, u[m + 5 | 0] = v >>> 8, u[m + 6 | 0] = v >>> 16, u[m + 7 | 0] = v >>> 24, v = a[wr + 4 >> 2], m = B + 47 | 0, wr = a[wr >> 2], u[m | 0] = wr, u[m + 1 | 0] = wr >>> 8, u[m + 2 | 0] = wr >>> 16, u[m + 3 | 0] = wr >>> 24, u[m + 4 | 0] = v, u[m + 5 | 0] = v >>> 8, u[m + 6 | 0] = v >>> 16, u[m + 7 | 0] = v >>> 24, v = a[fr + 4 >> 2], m = B + 39 | 0, fr = a[fr >> 2], u[m | 0] = fr, u[m + 1 | 0] = fr >>> 8, u[m + 2 | 0] = fr >>> 16, u[m + 3 | 0] = fr >>> 24, u[m + 4 | 0] = v, u[m + 5 | 0] = v >>> 8, u[m + 6 | 0] = v >>> 16, u[m + 7 | 0] = v >>> 24, v = a[Me + 4 >> 2], m = B + 31 | 0, Me = a[Me >> 2], u[m | 0] = Me, u[m + 1 | 0] = Me >>> 8, u[m + 2 | 0] = Me >>> 16, u[m + 3 | 0] = Me >>> 24, u[m + 4 | 0] = v, u[m + 5 | 0] = v >>> 8, u[m + 6 | 0] = v >>> 16, u[m + 7 | 0] = v >>> 24, v = a[Be + 4 >> 2], m = B + 23 | 0, Be = a[Be >> 2], u[m | 0] = Be, u[m + 1 | 0] = Be >>> 8, u[m + 2 | 0] = Be >>> 16, u[m + 3 | 0] = Be >>> 24, u[m + 4 | 0] = v, u[m + 5 | 0] = v >>> 8, u[m + 6 | 0] = v >>> 16, u[m + 7 | 0] = v >>> 24, v = a[we + 4 >> 2], m = B + 15 | 0, we = a[we >> 2], u[m | 0] = we, u[m + 1 | 0] = we >>> 8, u[m + 2 | 0] = we >>> 16, u[m + 3 | 0] = we >>> 24, u[m + 4 | 0] = v, u[m + 5 | 0] = v >>> 8, u[m + 6 | 0] = v >>> 16, u[m + 7 | 0] = v >>> 24, u[d + 11 | 0] = he, u[d + 12 | 0] = he >>> 8, u[d + 13 | 0] = he >>> 16, u[d + 14 | 0] = he >>> 24, m = a[d + 76 >> 2], he = a[d + 72 >> 2], u[d + 15 | 0] = he, u[d + 16 | 0] = he >>> 8, u[d + 17 | 0] = he >>> 16, u[d + 18 | 0] = he >>> 24, u[d + 19 | 0] = m, u[d + 20 | 0] = m >>> 8, u[d + 21 | 0] = m >>> 16, u[d + 22 | 0] = m >>> 24, a[d + 204 >> 2] = o, B = pn(a[172688], d + 204 | 0, B, (o | 0) == 33 ? 258 : 2), a[d + 72 >> 2] = B, (B | 0) == 1)
          break e;
        a[d + 144 >> 2] = 0, ar(d + 136 | 0), wasm2js_trap();
      }
      Ee(1);
    }
    be = d + 208 | 0;
  }
  function ui(B) {
    B = B | 0;
    var o = 0, m = 0, d = 0, v = 0, he = 0, we = 0, Be = 0, Me = 0, fr = 0, wr = 0, dr = 0, Dr = 0, Rr = 0, Qe = 0, Fr = 0, Gr = 0;
    m = be - 96 | 0, be = m, o = m + 56 | 0, a[o >> 2] = 0, a[o + 4 >> 2] = 0, o = m + 48 | 0, a[o >> 2] = 0, a[o + 4 >> 2] = 0, o = m + 40 | 0, a[o >> 2] = 0, a[o + 4 >> 2] = 0, o = m + 32 | 0, a[o >> 2] = 0, a[o + 4 >> 2] = 0, o = m + 24 | 0, a[o >> 2] = 0, a[o + 4 >> 2] = 0, o = m + 16 | 0, a[o >> 2] = 0, a[o + 4 >> 2] = 0, o = m + 8 | 0, a[o >> 2] = 0, a[o + 4 >> 2] = 0, a[m >> 2] = 0, a[m + 4 >> 2] = 0, v = yr(), d = be - 256 | 0, be = d;
    e: {
      if (!m) {
        ji[a[v + 168 >> 2]](689638, a[v + 172 >> 2]), o = 0;
        break e;
      }
      if (u[m | 0] = 0, u[m + 1 | 0] = 0, u[m + 2 | 0] = 0, u[m + 3 | 0] = 0, u[m + 4 | 0] = 0, u[m + 5 | 0] = 0, u[m + 6 | 0] = 0, u[m + 7 | 0] = 0, o = m + 56 | 0, u[o | 0] = 0, u[o + 1 | 0] = 0, u[o + 2 | 0] = 0, u[o + 3 | 0] = 0, u[o + 4 | 0] = 0, u[o + 5 | 0] = 0, u[o + 6 | 0] = 0, u[o + 7 | 0] = 0, o = m + 48 | 0, u[o | 0] = 0, u[o + 1 | 0] = 0, u[o + 2 | 0] = 0, u[o + 3 | 0] = 0, u[o + 4 | 0] = 0, u[o + 5 | 0] = 0, u[o + 6 | 0] = 0, u[o + 7 | 0] = 0, o = m + 40 | 0, u[o | 0] = 0, u[o + 1 | 0] = 0, u[o + 2 | 0] = 0, u[o + 3 | 0] = 0, u[o + 4 | 0] = 0, u[o + 5 | 0] = 0, u[o + 6 | 0] = 0, u[o + 7 | 0] = 0, o = m + 32 | 0, u[o | 0] = 0, u[o + 1 | 0] = 0, u[o + 2 | 0] = 0, u[o + 3 | 0] = 0, u[o + 4 | 0] = 0, u[o + 5 | 0] = 0, u[o + 6 | 0] = 0, u[o + 7 | 0] = 0, o = m + 24 | 0, u[o | 0] = 0, u[o + 1 | 0] = 0, u[o + 2 | 0] = 0, u[o + 3 | 0] = 0, u[o + 4 | 0] = 0, u[o + 5 | 0] = 0, u[o + 6 | 0] = 0, u[o + 7 | 0] = 0, o = m + 16 | 0, u[o | 0] = 0, u[o + 1 | 0] = 0, u[o + 2 | 0] = 0, u[o + 3 | 0] = 0, u[o + 4 | 0] = 0, u[o + 5 | 0] = 0, u[o + 6 | 0] = 0, u[o + 7 | 0] = 0, o = m + 8 | 0, u[o | 0] = 0, u[o + 1 | 0] = 0, u[o + 2 | 0] = 0, u[o + 3 | 0] = 0, u[o + 4 | 0] = 0, u[o + 5 | 0] = 0, u[o + 6 | 0] = 0, u[o + 7 | 0] = 0, !a[v >> 2]) {
        ji[a[v + 168 >> 2]](690045, a[v + 172 >> 2]), o = 0;
        break e;
      }
      Me = d + 8 | 0, we = d + 128 | 0, Rn(Me, 690788, we), fr = a[d + 32 >> 2], wr = a[d + 24 >> 2], he = a[d + 16 >> 2], dr = a[d + 8 >> 2], Dr = a[d + 36 >> 2], Rr = a[d + 28 >> 2], Qe = a[d + 20 >> 2], Fr = a[d + 12 >> 2], Be = a[d + 128 >> 2] | !(fr | (wr | (he | dr)) | (Dr | (Rr | (Qe | Fr)))), o = Be ? 0 : -1, a[d + 32 >> 2] = o & fr, a[d + 36 >> 2] = o & Dr, a[d + 24 >> 2] = o & wr, a[d + 28 >> 2] = o & Rr, a[d + 16 >> 2] = o & he, a[d + 20 >> 2] = o & Qe, he = (Be | 0) != 0, a[d + 8 >> 2] = he | o & dr, a[d + 12 >> 2] = o & Fr, xs(v, we, Me), o = d + 40 | 0, Fo(o, we), Gn(m, o), a[d + 128 >> 2] = he, o = a[d + 128 >> 2] - 1 | 0, u[m | 0] = o & A[m | 0], u[m + 1 | 0] = A[m + 1 | 0] & o, u[m + 2 | 0] = A[m + 2 | 0] & o, u[m + 3 | 0] = A[m + 3 | 0] & o, u[m + 4 | 0] = A[m + 4 | 0] & o, u[m + 5 | 0] = A[m + 5 | 0] & o, u[m + 6 | 0] = A[m + 6 | 0] & o, u[m + 7 | 0] = A[m + 7 | 0] & o, u[m + 8 | 0] = A[m + 8 | 0] & o, u[m + 9 | 0] = A[m + 9 | 0] & o, u[m + 10 | 0] = A[m + 10 | 0] & o, u[m + 11 | 0] = A[m + 11 | 0] & o, u[m + 12 | 0] = A[m + 12 | 0] & o, u[m + 13 | 0] = A[m + 13 | 0] & o, u[m + 14 | 0] = A[m + 14 | 0] & o, u[m + 15 | 0] = A[m + 15 | 0] & o, u[m + 16 | 0] = A[m + 16 | 0] & o, u[m + 17 | 0] = A[m + 17 | 0] & o, u[m + 18 | 0] = A[m + 18 | 0] & o, u[m + 19 | 0] = A[m + 19 | 0] & o, u[m + 20 | 0] = A[m + 20 | 0] & o, u[m + 21 | 0] = A[m + 21 | 0] & o, u[m + 22 | 0] = A[m + 22 | 0] & o, u[m + 23 | 0] = A[m + 23 | 0] & o, u[m + 24 | 0] = A[m + 24 | 0] & o, u[m + 25 | 0] = A[m + 25 | 0] & o, u[m + 26 | 0] = A[m + 26 | 0] & o, u[m + 27 | 0] = A[m + 27 | 0] & o, u[m + 28 | 0] = A[m + 28 | 0] & o, u[m + 29 | 0] = A[m + 29 | 0] & o, u[m + 30 | 0] = A[m + 30 | 0] & o, u[m + 31 | 0] = A[m + 31 | 0] & o, u[m + 32 | 0] = A[m + 32 | 0] & o, u[m + 33 | 0] = A[m + 33 | 0] & o, u[m + 34 | 0] = A[m + 34 | 0] & o, u[m + 35 | 0] = A[m + 35 | 0] & o, u[m + 36 | 0] = A[m + 36 | 0] & o, u[m + 37 | 0] = A[m + 37 | 0] & o, u[m + 38 | 0] = A[m + 38 | 0] & o, u[m + 39 | 0] = A[m + 39 | 0] & o, u[m + 40 | 0] = A[m + 40 | 0] & o, u[m + 41 | 0] = A[m + 41 | 0] & o, u[m + 42 | 0] = A[m + 42 | 0] & o, u[m + 43 | 0] = A[m + 43 | 0] & o, u[m + 44 | 0] = A[m + 44 | 0] & o, u[m + 45 | 0] = A[m + 45 | 0] & o, u[m + 46 | 0] = A[m + 46 | 0] & o, u[m + 47 | 0] = A[m + 47 | 0] & o, u[m + 48 | 0] = A[m + 48 | 0] & o, u[m + 49 | 0] = A[m + 49 | 0] & o, u[m + 50 | 0] = A[m + 50 | 0] & o, u[m + 51 | 0] = A[m + 51 | 0] & o, u[m + 52 | 0] = A[m + 52 | 0] & o, u[m + 53 | 0] = A[m + 53 | 0] & o, u[m + 54 | 0] = A[m + 54 | 0] & o, u[m + 55 | 0] = A[m + 55 | 0] & o, u[m + 56 | 0] = A[m + 56 | 0] & o, u[m + 57 | 0] = A[m + 57 | 0] & o, u[m + 58 | 0] = A[m + 58 | 0] & o, u[m + 59 | 0] = A[m + 59 | 0] & o, u[m + 60 | 0] = A[m + 60 | 0] & o, u[m + 61 | 0] = A[m + 61 | 0] & o, u[m + 62 | 0] = A[m + 62 | 0] & o, u[m + 63 | 0] = A[m + 63 | 0] & o, o = !Be;
    }
    be = d + 256 | 0;
    e: {
      if (o) {
        if (a[m + 64 >> 2] = B, B = pn(a[172688], m - -64 | 0, m, (B | 0) == 33 ? 258 : 2), a[m + 68 >> 2] = B, (B | 0) != 1)
          break e;
        Gr = 1;
      }
      return be = m + 96 | 0, Gr | 0;
    }
    a[m + 80 >> 2] = 0, ar(m + 72 | 0), wasm2js_trap();
  }
  function Li() {
    var B = 0, o = 0, m = 0, d = 0, v = 0, he = 0, we = 0, Be = 0, Me = 0, fr = 0, wr = 0, dr = 0, Dr = 0, Rr = 0, Qe = 0, Fr = 0, Gr = 0, $r = 0, ni = 0, mi = 0, Si = 0, Oi = 0, $i = 0, zi = 0, un = 0, In = 0, Ti = 0, Sn = 0;
    d = be - 304 | 0, be = d, m = d + 200 | 0, xi(m, 96);
    e: {
      t: {
        r: {
          if ((Ii(yr(), m) | 0) == 1) {
            u[d + 10 | 0] = A[d + 202 | 0], p[d + 8 >> 1] = b[d + 200 >> 1], m = A[d + 203 | 0] | A[d + 204 | 0] << 8 | (A[d + 205 | 0] << 16 | A[d + 206 | 0] << 24), B = d + 104 | 0, he = d + 200 | 0, dn(B, he | 7, 89), o = d + 8 | 0, dn(o | 7, B, 89), u[d + 11 | 0] = m, u[d + 12 | 0] = m >>> 8, u[d + 13 | 0] = m >>> 16, u[d + 14 | 0] = m >>> 24, m = d + 256 | 0, a[m >> 2] = 0, a[m + 4 >> 2] = 0, m = d + 248 | 0, a[m >> 2] = 0, a[m + 4 >> 2] = 0, m = d + 240 | 0, a[m >> 2] = 0, a[m + 4 >> 2] = 0, m = d + 232 | 0, a[m >> 2] = 0, a[m + 4 >> 2] = 0, m = d + 224 | 0, a[m >> 2] = 0, a[m + 4 >> 2] = 0, m = d + 216 | 0, a[m >> 2] = 0, a[m + 4 >> 2] = 0, m = d + 208 | 0, a[m >> 2] = 0, a[m + 4 >> 2] = 0, a[d + 200 >> 2] = 0, a[d + 204 >> 2] = 0, a[d + 196 >> 2] = 0, wr = yr(), Fr = d + 196 | 0, m = be - 96 | 0, be = m;
            i: {
              if (!he) {
                ji[a[wr + 168 >> 2]](689638, a[wr + 172 >> 2]), B = 0;
                break i;
              }
              if (u[he | 0] = 0, u[he + 1 | 0] = 0, u[he + 2 | 0] = 0, u[he + 3 | 0] = 0, u[he + 4 | 0] = 0, u[he + 5 | 0] = 0, u[he + 6 | 0] = 0, u[he + 7 | 0] = 0, B = he + 56 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, B = he + 48 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, B = he + 40 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, B = he + 32 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, B = he + 24 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, B = he + 16 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, B = he + 8 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, !o) {
                ji[a[wr + 168 >> 2]](689700, a[wr + 172 >> 2]), B = 0;
                break i;
              }
              if (dr = A[o + 92 | 0] | A[o + 93 | 0] << 8 | (A[o + 94 | 0] << 16 | A[o + 95 | 0] << 24), B = dr >>> 16 | 0, we = m + 80 | 0, Be = A[o + 88 | 0] | A[o + 89 | 0] << 8 | (A[o + 90 | 0] << 16 | A[o + 91 | 0] << 24), dr = (dr & 65535) << 16 | Be >>> 16, a[we >> 2] = dr, un = B, a[we + 4 >> 2] = B, fr = Be << 4 & 1048560, v = A[o + 84 | 0] | A[o + 85 | 0] << 8 | (A[o + 86 | 0] << 16 | A[o + 87 | 0] << 24), B = v >>> 28 | 0, we = m + 72 | 0, Be = A[o + 80 | 0] | A[o + 81 | 0] << 8 | (A[o + 82 | 0] << 16 | A[o + 83 | 0] << 24), Dr = (v & 268435455) << 4 | Be >>> 28, a[we >> 2] = Dr, Gr = B | fr, a[we + 4 >> 2] = Gr, B = v << 24 | Be >>> 8, Me = Be << 24 & -16777216, Be = A[o + 72 | 0] | A[o + 73 | 0] << 8 | (A[o + 74 | 0] << 16 | A[o + 75 | 0] << 24), fr = m + 8 | 0, we = fr + 56 | 0, v = A[o + 76 | 0] | A[o + 77 | 0] << 8 | (A[o + 78 | 0] << 16 | A[o + 79 | 0] << 24), Rr = v >>> 8 | Me, a[we >> 2] = Rr, $r = B & 1048575, a[we + 4 >> 2] = $r, B = Be, v = v << 12 | B >>> 20, Be = A[o + 64 | 0] | A[o + 65 | 0] << 8 | (A[o + 66 | 0] << 16 | A[o + 67 | 0] << 24), we = fr + 48 | 0, Me = A[o + 68 | 0] | A[o + 69 | 0] << 8 | (A[o + 70 | 0] << 16 | A[o + 71 | 0] << 24), Qe = B << 12 & -4096 | Me >>> 20, a[we >> 2] = Qe, ni = v & 1048575, a[we + 4 >> 2] = ni, a[m + 88 >> 2] = 0, a[m + 48 >> 2] = Be, mi = Me & 1048575, a[m + 52 >> 2] = mi, B = A[o + 44 | 0] | A[o + 45 | 0] << 8 | (A[o + 46 | 0] << 16 | A[o + 47 | 0] << 24), we = B, v = A[o + 40 | 0] | A[o + 41 | 0] << 8 | (A[o + 42 | 0] << 16 | A[o + 43 | 0] << 24), Me = (B << 12 | v >>> 20) & 1048575, B = A[o + 32 | 0] | A[o + 33 | 0] << 8 | (A[o + 34 | 0] << 16 | A[o + 35 | 0] << 24), fr = v << 12 & -4096, v = A[o + 36 | 0] | A[o + 37 | 0] << 8 | (A[o + 38 | 0] << 16 | A[o + 39 | 0] << 24), Si = fr | v >>> 20, a[m + 16 >> 2] = Si, In = Me, a[m + 20 >> 2] = Me, fr = B, a[m + 8 >> 2] = B, Oi = v & 1048575, a[m + 12 >> 2] = Oi, v = A[o + 60 | 0] | A[o + 61 | 0] << 8 | (A[o + 62 | 0] << 16 | A[o + 63 | 0] << 24), B = v >>> 16 | 0, Me = A[o + 56 | 0] | A[o + 57 | 0] << 8 | (A[o + 58 | 0] << 16 | A[o + 59 | 0] << 24), $i = (v & 65535) << 16 | Me >>> 16, a[m + 40 >> 2] = $i, Ti = B, a[m + 44 >> 2] = B, v = A[o + 48 | 0] | A[o + 49 | 0] << 8 | (A[o + 50 | 0] << 16 | A[o + 51 | 0] << 24), B = A[o + 52 | 0] | A[o + 53 | 0] << 8 | (A[o + 54 | 0] << 16 | A[o + 55 | 0] << 24), o = B, zi = (B << 24 | v >>> 8) & 1048575, we = v << 24 & -16777216 | we >>> 8, a[m + 24 >> 2] = we, a[m + 28 >> 2] = zi, Me = Me << 4 & 1048560, B = B >>> 28 | 0, v = (o & 268435455) << 4 | v >>> 28, a[m + 32 >> 2] = v, B = B | Me, a[m + 36 >> 2] = B, !(fr | Si | $i | we | v | (In | Oi | Ti | zi | B))) {
                ji[a[wr + 168 >> 2]](690116, a[wr + 172 >> 2]), B = 0;
                break i;
              }
              Be & 1 && (a[m + 80 >> 2] = -4 - dr, a[m + 84 >> 2] = 262143 - ((dr >>> 0 > 4294967292) + un | 0), a[m + 72 >> 2] = -4 - Dr, a[m + 76 >> 2] = 4194303 - ((Dr >>> 0 > 4294967292) + Gr | 0), a[m + 64 >> 2] = -4 - Rr, a[m + 68 >> 2] = 4194303 - ((Rr >>> 0 > 4294967292) + $r | 0), a[m + 56 >> 2] = -4 - Qe, a[m + 60 >> 2] = 4194303 - ((Qe >>> 0 > 4294967292) + ni | 0), a[m + 48 >> 2] = -3908 - Be, a[m + 52 >> 2] = 4194299 - ((Be >>> 0 > 4294963388) + mi | 0), Sn = 1), Fr && (a[Fr >> 2] = Sn), Gn(he, m + 8 | 0), B = 1;
            }
            if (be = m + 96 | 0, a[d + 300 >> 2] = B, (B | 0) == 1)
              break r;
            break e;
          }
          Ee(0);
          break t;
        }
        if (m = Bn(a[172688], d + 200 | 0), a[d + 300 >> 2] = m, B = 1, (m | 0) == 1)
          break t;
        break e;
      }
      return be = d + 304 | 0, B | 0;
    }
    a[d + 112 >> 2] = 0, ar(d + 104 | 0), wasm2js_trap();
  }
  function Qi(B) {
    B = B | 0;
    var o = 0, m = 0, d = 0, v = 0, he = 0, we = 0, Be = 0, Me = 0, fr = 0, wr = 0, dr = 0, Dr = 0, Rr = 0, Qe = 0, Fr = 0, Gr = 0;
    d = be - 272 | 0, be = d, o = d + 8 | 0, v = o + 56 | 0, a[v >> 2] = 0, a[v + 4 >> 2] = 0, m = o + 48 | 0, a[m >> 2] = 0, a[m + 4 >> 2] = 0, he = o + 40 | 0, a[he >> 2] = 0, a[he + 4 >> 2] = 0, we = o + 32 | 0, a[we >> 2] = 0, a[we + 4 >> 2] = 0, Be = o + 24 | 0, a[Be >> 2] = 0, a[Be + 4 >> 2] = 0, Me = o + 16 | 0, a[Me >> 2] = 0, a[Me + 4 >> 2] = 0, fr = o + 8 | 0, a[fr >> 2] = 0, a[fr + 4 >> 2] = 0, a[d + 8 >> 2] = 0, a[d + 12 >> 2] = 0, a[d + 76 >> 2] = 0, o = d + 208 | 0, wr = o + 56 | 0, a[wr >> 2] = 0, a[wr + 4 >> 2] = 0, dr = o + 48 | 0, a[dr >> 2] = 0, a[dr + 4 >> 2] = 0, Dr = o + 40 | 0, a[Dr >> 2] = 0, a[Dr + 4 >> 2] = 0, Rr = o + 32 | 0, a[Rr >> 2] = 0, a[Rr + 4 >> 2] = 0, Qe = o + 24 | 0, a[Qe >> 2] = 0, a[Qe + 4 >> 2] = 0, Fr = o + 16 | 0, a[Fr >> 2] = 0, a[Fr + 4 >> 2] = 0, Gr = o + 8 | 0, a[Gr >> 2] = 0, a[Gr + 4 >> 2] = 0, a[d + 208 >> 2] = 0, a[d + 212 >> 2] = 0;
    e: {
      t: {
        if ((On(a[172688], o, 690820, B) | 0) == 1) {
          if (o = d + 208 | 0, B = o + 15 | 0, m = A[B + 4 | 0] | A[B + 5 | 0] << 8 | (A[B + 6 | 0] << 16 | A[B + 7 | 0] << 24), v = d + 144 | 0, he = v + 8 | 0, a[he >> 2] = A[B | 0] | A[B + 1 | 0] << 8 | (A[B + 2 | 0] << 16 | A[B + 3 | 0] << 24), a[he + 4 >> 2] = m, B = o + 23 | 0, m = A[B + 4 | 0] | A[B + 5 | 0] << 8 | (A[B + 6 | 0] << 16 | A[B + 7 | 0] << 24), we = v + 16 | 0, a[we >> 2] = A[B | 0] | A[B + 1 | 0] << 8 | (A[B + 2 | 0] << 16 | A[B + 3 | 0] << 24), a[we + 4 >> 2] = m, B = o + 31 | 0, m = A[B + 4 | 0] | A[B + 5 | 0] << 8 | (A[B + 6 | 0] << 16 | A[B + 7 | 0] << 24), Be = v + 24 | 0, a[Be >> 2] = A[B | 0] | A[B + 1 | 0] << 8 | (A[B + 2 | 0] << 16 | A[B + 3 | 0] << 24), a[Be + 4 >> 2] = m, B = o + 39 | 0, m = A[B + 4 | 0] | A[B + 5 | 0] << 8 | (A[B + 6 | 0] << 16 | A[B + 7 | 0] << 24), Me = v + 32 | 0, a[Me >> 2] = A[B | 0] | A[B + 1 | 0] << 8 | (A[B + 2 | 0] << 16 | A[B + 3 | 0] << 24), a[Me + 4 >> 2] = m, B = o + 47 | 0, m = A[B + 4 | 0] | A[B + 5 | 0] << 8 | (A[B + 6 | 0] << 16 | A[B + 7 | 0] << 24), fr = v + 40 | 0, a[fr >> 2] = A[B | 0] | A[B + 1 | 0] << 8 | (A[B + 2 | 0] << 16 | A[B + 3 | 0] << 24), a[fr + 4 >> 2] = m, B = o + 55 | 0, m = A[B + 4 | 0] | A[B + 5 | 0] << 8 | (A[B + 6 | 0] << 16 | A[B + 7 | 0] << 24), wr = v + 48 | 0, a[wr >> 2] = A[B | 0] | A[B + 1 | 0] << 8 | (A[B + 2 | 0] << 16 | A[B + 3 | 0] << 24), a[wr + 4 >> 2] = m, m = v + 56 | 0, u[m | 0] = A[o + 63 | 0], u[d + 82 | 0] = A[d + 210 | 0], p[d + 80 >> 1] = b[d + 208 >> 1], B = A[d + 219 | 0] | A[d + 220 | 0] << 8 | (A[d + 221 | 0] << 16 | A[d + 222 | 0] << 24), a[d + 144 >> 2] = A[d + 215 | 0] | A[d + 216 | 0] << 8 | (A[d + 217 | 0] << 16 | A[d + 218 | 0] << 24), a[d + 148 >> 2] = B, v = A[d + 211 | 0] | A[d + 212 | 0] << 8 | (A[d + 213 | 0] << 16 | A[d + 214 | 0] << 24), B = d + 80 | 0, u[B + 63 | 0] = A[m | 0], m = a[wr + 4 >> 2], o = B + 55 | 0, wr = a[wr >> 2], u[o | 0] = wr, u[o + 1 | 0] = wr >>> 8, u[o + 2 | 0] = wr >>> 16, u[o + 3 | 0] = wr >>> 24, u[o + 4 | 0] = m, u[o + 5 | 0] = m >>> 8, u[o + 6 | 0] = m >>> 16, u[o + 7 | 0] = m >>> 24, m = a[fr + 4 >> 2], o = B + 47 | 0, fr = a[fr >> 2], u[o | 0] = fr, u[o + 1 | 0] = fr >>> 8, u[o + 2 | 0] = fr >>> 16, u[o + 3 | 0] = fr >>> 24, u[o + 4 | 0] = m, u[o + 5 | 0] = m >>> 8, u[o + 6 | 0] = m >>> 16, u[o + 7 | 0] = m >>> 24, m = a[Me + 4 >> 2], o = B + 39 | 0, Me = a[Me >> 2], u[o | 0] = Me, u[o + 1 | 0] = Me >>> 8, u[o + 2 | 0] = Me >>> 16, u[o + 3 | 0] = Me >>> 24, u[o + 4 | 0] = m, u[o + 5 | 0] = m >>> 8, u[o + 6 | 0] = m >>> 16, u[o + 7 | 0] = m >>> 24, m = a[Be + 4 >> 2], o = B + 31 | 0, Be = a[Be >> 2], u[o | 0] = Be, u[o + 1 | 0] = Be >>> 8, u[o + 2 | 0] = Be >>> 16, u[o + 3 | 0] = Be >>> 24, u[o + 4 | 0] = m, u[o + 5 | 0] = m >>> 8, u[o + 6 | 0] = m >>> 16, u[o + 7 | 0] = m >>> 24, m = a[we + 4 >> 2], o = B + 23 | 0, we = a[we >> 2], u[o | 0] = we, u[o + 1 | 0] = we >>> 8, u[o + 2 | 0] = we >>> 16, u[o + 3 | 0] = we >>> 24, u[o + 4 | 0] = m, u[o + 5 | 0] = m >>> 8, u[o + 6 | 0] = m >>> 16, u[o + 7 | 0] = m >>> 24, m = a[he + 4 >> 2], o = B + 15 | 0, he = a[he >> 2], u[o | 0] = he, u[o + 1 | 0] = he >>> 8, u[o + 2 | 0] = he >>> 16, u[o + 3 | 0] = he >>> 24, u[o + 4 | 0] = m, u[o + 5 | 0] = m >>> 8, u[o + 6 | 0] = m >>> 16, u[o + 7 | 0] = m >>> 24, u[d + 83 | 0] = v, u[d + 84 | 0] = v >>> 8, u[d + 85 | 0] = v >>> 16, u[d + 86 | 0] = v >>> 24, o = a[d + 148 >> 2], v = a[d + 144 >> 2], u[d + 87 | 0] = v, u[d + 88 | 0] = v >>> 8, u[d + 89 | 0] = v >>> 16, u[d + 90 | 0] = v >>> 24, u[d + 91 | 0] = o, u[d + 92 | 0] = o >>> 8, u[d + 93 | 0] = o >>> 16, u[d + 94 | 0] = o >>> 24, B = hi(yr(), d + 8 | 0, d + 76 | 0, B), a[d + 144 >> 2] = B, (B | 0) != 1)
            break e;
          B = d + 8 | 0, v = B + 8 | 0, m = a[v + 4 >> 2], o = d + 208 | 0, he = o + 8 | 0, a[he >> 2] = a[v >> 2], a[he + 4 >> 2] = m, v = B + 16 | 0, m = a[v + 4 >> 2], he = o + 16 | 0, a[he >> 2] = a[v >> 2], a[he + 4 >> 2] = m, v = B + 24 | 0, m = a[v + 4 >> 2], he = o + 24 | 0, a[he >> 2] = a[v >> 2], a[he + 4 >> 2] = m, v = B + 32 | 0, m = a[v + 4 >> 2], he = o + 32 | 0, a[he >> 2] = a[v >> 2], a[he + 4 >> 2] = m, v = B + 40 | 0, m = a[v + 4 >> 2], he = o + 40 | 0, a[he >> 2] = a[v >> 2], a[he + 4 >> 2] = m, v = B + 48 | 0, m = a[v + 4 >> 2], he = o + 48 | 0, a[he >> 2] = a[v >> 2], a[he + 4 >> 2] = m, B = B + 56 | 0, v = a[B + 4 >> 2], o = o + 56 | 0, a[o >> 2] = a[B >> 2], a[o + 4 >> 2] = v;
          break t;
        }
        Ee(1), B = a[v + 4 >> 2], a[wr >> 2] = a[v >> 2], a[wr + 4 >> 2] = B, B = a[m + 4 >> 2], a[dr >> 2] = a[m >> 2], a[dr + 4 >> 2] = B, B = a[he + 4 >> 2], a[Dr >> 2] = a[he >> 2], a[Dr + 4 >> 2] = B, B = a[we + 4 >> 2], a[Rr >> 2] = a[we >> 2], a[Rr + 4 >> 2] = B, B = a[Be + 4 >> 2], a[Qe >> 2] = a[Be >> 2], a[Qe + 4 >> 2] = B, B = a[Me + 4 >> 2], a[Fr >> 2] = a[Me >> 2], a[Fr + 4 >> 2] = B, B = a[fr + 4 >> 2], a[Gr >> 2] = a[fr >> 2], a[Gr + 4 >> 2] = B;
      }
      if (B = a[d + 12 >> 2], a[d + 208 >> 2] = a[d + 8 >> 2], a[d + 212 >> 2] = B, o = d + 208 | 0, v = o + 56 | 0, m = a[v + 4 >> 2], B = d + 80 | 0, he = B + 56 | 0, a[he >> 2] = a[v >> 2], a[he + 4 >> 2] = m, v = o + 48 | 0, m = a[v + 4 >> 2], he = B + 48 | 0, a[he >> 2] = a[v >> 2], a[he + 4 >> 2] = m, v = o + 40 | 0, m = a[v + 4 >> 2], he = B + 40 | 0, a[he >> 2] = a[v >> 2], a[he + 4 >> 2] = m, v = o + 32 | 0, m = a[v + 4 >> 2], he = B + 32 | 0, a[he >> 2] = a[v >> 2], a[he + 4 >> 2] = m, v = o + 24 | 0, m = a[v + 4 >> 2], he = B + 24 | 0, a[he >> 2] = a[v >> 2], a[he + 4 >> 2] = m, v = o + 16 | 0, m = a[v + 4 >> 2], he = B + 16 | 0, a[he >> 2] = a[v >> 2], a[he + 4 >> 2] = m, o = o + 8 | 0, v = a[o + 4 >> 2], m = B + 8 | 0, a[m >> 2] = a[o >> 2], a[m + 4 >> 2] = v, o = a[d + 212 >> 2], a[d + 80 >> 2] = a[d + 208 >> 2], a[d + 84 >> 2] = o, B = Bn(a[172688], B), a[d + 8 >> 2] = B, (B | 0) != 1)
        break e;
      return be = d + 272 | 0, 1;
    }
    a[d + 216 >> 2] = 0, ar(d + 208 | 0), wasm2js_trap();
  }
  function wi(B, o) {
    B = B | 0, o = o | 0;
    var m = 0, d = 0, v = 0, he = 0, we = 0, Be = 0, Me = 0, fr = 0, wr = 0, dr = 0, Dr = 0, Rr = 0, Qe = 0, Fr = 0, Gr = 0, $r = 0, ni = 0, mi = 0, Si = 0;
    he = be - 208 | 0, be = he, m = he + 136 | 0, v = m + 56 | 0, a[v >> 2] = 0, a[v + 4 >> 2] = 0, v = m + 48 | 0, a[v >> 2] = 0, a[v + 4 >> 2] = 0, v = m + 40 | 0, a[v >> 2] = 0, a[v + 4 >> 2] = 0, v = m + 32 | 0, a[v >> 2] = 0, a[v + 4 >> 2] = 0, v = m + 24 | 0, a[v >> 2] = 0, a[v + 4 >> 2] = 0, v = m + 16 | 0, a[v >> 2] = 0, a[v + 4 >> 2] = 0, v = m + 8 | 0, a[v >> 2] = 0, a[v + 4 >> 2] = 0, a[he + 136 >> 2] = 0, a[he + 140 >> 2] = 0;
    e: {
      if ((On(a[172688], m, 690820, B) | 0) == 1) {
        wr = he + 136 | 0, m = wr + 15 | 0, B = A[m + 4 | 0] | A[m + 5 | 0] << 8 | (A[m + 6 | 0] << 16 | A[m + 7 | 0] << 24), v = he + 72 | 0, Rr = v + 8 | 0, a[Rr >> 2] = A[m | 0] | A[m + 1 | 0] << 8 | (A[m + 2 | 0] << 16 | A[m + 3 | 0] << 24), a[Rr + 4 >> 2] = B, m = wr + 23 | 0, B = A[m + 4 | 0] | A[m + 5 | 0] << 8 | (A[m + 6 | 0] << 16 | A[m + 7 | 0] << 24), Dr = v + 16 | 0, a[Dr >> 2] = A[m | 0] | A[m + 1 | 0] << 8 | (A[m + 2 | 0] << 16 | A[m + 3 | 0] << 24), a[Dr + 4 >> 2] = B, m = wr + 31 | 0, B = A[m + 4 | 0] | A[m + 5 | 0] << 8 | (A[m + 6 | 0] << 16 | A[m + 7 | 0] << 24), fr = v + 24 | 0, a[fr >> 2] = A[m | 0] | A[m + 1 | 0] << 8 | (A[m + 2 | 0] << 16 | A[m + 3 | 0] << 24), a[fr + 4 >> 2] = B, m = wr + 39 | 0, B = A[m + 4 | 0] | A[m + 5 | 0] << 8 | (A[m + 6 | 0] << 16 | A[m + 7 | 0] << 24), Be = v + 32 | 0, a[Be >> 2] = A[m | 0] | A[m + 1 | 0] << 8 | (A[m + 2 | 0] << 16 | A[m + 3 | 0] << 24), a[Be + 4 >> 2] = B, m = wr + 47 | 0, B = A[m + 4 | 0] | A[m + 5 | 0] << 8 | (A[m + 6 | 0] << 16 | A[m + 7 | 0] << 24), dr = v + 40 | 0, a[dr >> 2] = A[m | 0] | A[m + 1 | 0] << 8 | (A[m + 2 | 0] << 16 | A[m + 3 | 0] << 24), a[dr + 4 >> 2] = B, Me = wr + 55 | 0, B = A[Me + 4 | 0] | A[Me + 5 | 0] << 8 | (A[Me + 6 | 0] << 16 | A[Me + 7 | 0] << 24), m = v + 48 | 0, a[m >> 2] = A[Me | 0] | A[Me + 1 | 0] << 8 | (A[Me + 2 | 0] << 16 | A[Me + 3 | 0] << 24), a[m + 4 >> 2] = B, v = v + 56 | 0, u[v | 0] = A[wr + 63 | 0], u[he + 10 | 0] = A[he + 138 | 0], p[he + 8 >> 1] = b[he + 136 >> 1], B = A[he + 147 | 0] | A[he + 148 | 0] << 8 | (A[he + 149 | 0] << 16 | A[he + 150 | 0] << 24), a[he + 72 >> 2] = A[he + 143 | 0] | A[he + 144 | 0] << 8 | (A[he + 145 | 0] << 16 | A[he + 146 | 0] << 24), a[he + 76 >> 2] = B, wr = A[he + 139 | 0] | A[he + 140 | 0] << 8 | (A[he + 141 | 0] << 16 | A[he + 142 | 0] << 24), d = he + 8 | 0, u[d + 63 | 0] = A[v | 0], v = a[m + 4 >> 2], Me = d + 55 | 0, B = a[m >> 2], u[Me | 0] = B, u[Me + 1 | 0] = B >>> 8, u[Me + 2 | 0] = B >>> 16, u[Me + 3 | 0] = B >>> 24, u[Me + 4 | 0] = v, u[Me + 5 | 0] = v >>> 8, u[Me + 6 | 0] = v >>> 16, u[Me + 7 | 0] = v >>> 24, v = a[dr + 4 >> 2], m = d + 47 | 0, B = a[dr >> 2], u[m | 0] = B, u[m + 1 | 0] = B >>> 8, u[m + 2 | 0] = B >>> 16, u[m + 3 | 0] = B >>> 24, u[m + 4 | 0] = v, u[m + 5 | 0] = v >>> 8, u[m + 6 | 0] = v >>> 16, u[m + 7 | 0] = v >>> 24, v = a[Be + 4 >> 2], m = d + 39 | 0, B = a[Be >> 2], u[m | 0] = B, u[m + 1 | 0] = B >>> 8, u[m + 2 | 0] = B >>> 16, u[m + 3 | 0] = B >>> 24, u[m + 4 | 0] = v, u[m + 5 | 0] = v >>> 8, u[m + 6 | 0] = v >>> 16, u[m + 7 | 0] = v >>> 24, v = a[fr + 4 >> 2], m = d + 31 | 0, B = a[fr >> 2], u[m | 0] = B, u[m + 1 | 0] = B >>> 8, u[m + 2 | 0] = B >>> 16, u[m + 3 | 0] = B >>> 24, u[m + 4 | 0] = v, u[m + 5 | 0] = v >>> 8, u[m + 6 | 0] = v >>> 16, u[m + 7 | 0] = v >>> 24, v = a[Dr + 4 >> 2], m = d + 23 | 0, B = a[Dr >> 2], u[m | 0] = B, u[m + 1 | 0] = B >>> 8, u[m + 2 | 0] = B >>> 16, u[m + 3 | 0] = B >>> 24, u[m + 4 | 0] = v, u[m + 5 | 0] = v >>> 8, u[m + 6 | 0] = v >>> 16, u[m + 7 | 0] = v >>> 24, v = a[Rr + 4 >> 2], m = d + 15 | 0, B = a[Rr >> 2], u[m | 0] = B, u[m + 1 | 0] = B >>> 8, u[m + 2 | 0] = B >>> 16, u[m + 3 | 0] = B >>> 24, u[m + 4 | 0] = v, u[m + 5 | 0] = v >>> 8, u[m + 6 | 0] = v >>> 16, u[m + 7 | 0] = v >>> 24, u[he + 11 | 0] = wr, u[he + 12 | 0] = wr >>> 8, u[he + 13 | 0] = wr >>> 16, u[he + 14 | 0] = wr >>> 24, v = a[he + 76 >> 2], B = a[he + 72 >> 2], u[he + 15 | 0] = B, u[he + 16 | 0] = B >>> 8, u[he + 17 | 0] = B >>> 16, u[he + 18 | 0] = B >>> 24, u[he + 19 | 0] = v, u[he + 20 | 0] = v >>> 8, u[he + 21 | 0] = v >>> 16, u[he + 22 | 0] = v >>> 24, Qe = yr(), we = be - 288 | 0, be = we, a[we + 4 >> 2] = 0;
        t: {
          if (!d) {
            ji[a[Qe + 168 >> 2]](689638, a[Qe + 172 >> 2]);
            break t;
          }
          if (Rn(we + 8 | 0, 690949, we + 4 | 0), a[we + 4 >> 2]) {
            u[d | 0] = 0, u[d + 1 | 0] = 0, u[d + 2 | 0] = 0, u[d + 3 | 0] = 0, u[d + 4 | 0] = 0, u[d + 5 | 0] = 0, u[d + 6 | 0] = 0, u[d + 7 | 0] = 0, B = d + 56 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, B = d + 48 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, B = d + 40 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, B = d + 32 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, B = d + 24 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, B = d + 16 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, B = d + 8 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0;
            break t;
          }
          if (B = A[d + 60 | 0] | A[d + 61 | 0] << 8 | (A[d + 62 | 0] << 16 | A[d + 63 | 0] << 24), Me = B >>> 16 | 0, dr = we + 112 | 0, v = A[d + 56 | 0] | A[d + 57 | 0] << 8 | (A[d + 58 | 0] << 16 | A[d + 59 | 0] << 24), a[dr >> 2] = (B & 65535) << 16 | v >>> 16, a[dr + 4 >> 2] = Me, dr = v << 4 & 1048560, B = A[d + 52 | 0] | A[d + 53 | 0] << 8 | (A[d + 54 | 0] << 16 | A[d + 55 | 0] << 24), Me = B >>> 28 | 0, Be = we + 104 | 0, v = A[d + 48 | 0] | A[d + 49 | 0] << 8 | (A[d + 50 | 0] << 16 | A[d + 51 | 0] << 24), a[Be >> 2] = (B & 268435455) << 4 | v >>> 28, a[Be + 4 >> 2] = Me | dr, Me = B << 24 | v >>> 8, Be = v << 24 & -16777216, v = A[d + 40 | 0] | A[d + 41 | 0] << 8 | (A[d + 42 | 0] << 16 | A[d + 43 | 0] << 24), fr = we + 40 | 0, Dr = fr + 56 | 0, B = A[d + 44 | 0] | A[d + 45 | 0] << 8 | (A[d + 46 | 0] << 16 | A[d + 47 | 0] << 24), a[Dr >> 2] = B >>> 8 | Be, a[Dr + 4 >> 2] = Me & 1048575, Dr = B << 12 | v >>> 20, Be = v << 12 & -4096, m = A[d + 32 | 0] | A[d + 33 | 0] << 8 | (A[d + 34 | 0] << 16 | A[d + 35 | 0] << 24), B = A[d + 36 | 0] | A[d + 37 | 0] << 8 | (A[d + 38 | 0] << 16 | A[d + 39 | 0] << 24), fr = fr + 48 | 0, a[fr >> 2] = B >>> 20 | Be, a[fr + 4 >> 2] = Dr & 1048575, a[we + 120 >> 2] = 0, a[we + 80 >> 2] = m, a[we + 84 >> 2] = B & 1048575, m = A[d + 12 | 0] | A[d + 13 | 0] << 8 | (A[d + 14 | 0] << 16 | A[d + 15 | 0] << 24), wr = m, v = A[d + 8 | 0] | A[d + 9 | 0] << 8 | (A[d + 10 | 0] << 16 | A[d + 11 | 0] << 24), Me = m << 12 | v >>> 20, Be = v << 12 & -4096, Rr = A[d | 0] | A[d + 1 | 0] << 8 | (A[d + 2 | 0] << 16 | A[d + 3 | 0] << 24), v = A[d + 4 | 0] | A[d + 5 | 0] << 8 | (A[d + 6 | 0] << 16 | A[d + 7 | 0] << 24), m = v, B = we, Fr = m >>> 20 | Be, a[B + 48 >> 2] = Fr, Gr = Me & 1048575, a[B + 52 >> 2] = Gr, a[B + 40 >> 2] = Rr, $r = m & 1048575, a[B + 44 >> 2] = $r, v = A[d + 24 | 0] | A[d + 25 | 0] << 8 | (A[d + 26 | 0] << 16 | A[d + 27 | 0] << 24), Dr = v, m = A[d + 28 | 0] | A[d + 29 | 0] << 8 | (A[d + 30 | 0] << 16 | A[d + 31 | 0] << 24), dr = (m & 65535) << 16 | v >>> 16, a[B + 72 >> 2] = dr, Be = m >>> 16 | 0, a[B + 76 >> 2] = Be, v = A[d + 16 | 0] | A[d + 17 | 0] << 8 | (A[d + 18 | 0] << 16 | A[d + 19 | 0] << 24), m = A[d + 20 | 0] | A[d + 21 | 0] << 8 | (A[d + 22 | 0] << 16 | A[d + 23 | 0] << 24), Me = m << 24 | v >>> 8, ni = v << 24 & -16777216 | wr >>> 8, a[B + 56 >> 2] = ni, wr = Me & 1048575, a[B + 60 >> 2] = wr, fr = Dr << 4 & 1048560, v = (m & 268435455) << 4 | v >>> 28, a[B + 64 >> 2] = v, B = m >>> 28 | fr, a[we + 68 >> 2] = B, !(Rr | Fr | dr | ni | v | (Gr | $r | Be | wr | B))) {
            ji[a[Qe + 168 >> 2]](690116, a[Qe + 172 >> 2]), B = d + 56 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, B = d + 48 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, B = d + 40 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, B = d + 32 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, B = d + 24 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, B = d + 16 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, B = d + 8 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, u[d | 0] = 0, u[d + 1 | 0] = 0, u[d + 2 | 0] = 0, u[d + 3 | 0] = 0, u[d + 4 | 0] = 0, u[d + 5 | 0] = 0, u[d + 6 | 0] = 0, u[d + 7 | 0] = 0;
            break t;
          }
          if (u[d | 0] = 0, u[d + 1 | 0] = 0, u[d + 2 | 0] = 0, u[d + 3 | 0] = 0, u[d + 4 | 0] = 0, u[d + 5 | 0] = 0, u[d + 6 | 0] = 0, u[d + 7 | 0] = 0, B = d + 56 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, B = d + 48 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, B = d + 40 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, B = d + 32 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, B = d + 24 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, B = d + 16 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, B = d + 8 | 0, u[B | 0] = 0, u[B + 1 | 0] = 0, u[B + 2 | 0] = 0, u[B + 3 | 0] = 0, u[B + 4 | 0] = 0, u[B + 5 | 0] = 0, u[B + 6 | 0] = 0, u[B + 7 | 0] = 0, !(a[we + 32 >> 2] | (a[we + 24 >> 2] | (a[we + 16 >> 2] | a[we + 8 >> 2])) | (a[we + 36 >> 2] | (a[we + 28 >> 2] | (a[we + 20 >> 2] | a[we + 12 >> 2])))))
            break t;
          dr = we + 256 | 0, B = dr + 24 | 0, a[B >> 2] = 0, a[B + 4 >> 2] = 0, B = dr + 16 | 0, a[B >> 2] = 0, a[B + 4 >> 2] = 0, B = dr + 8 | 0, a[B >> 2] = 0, a[B + 4 >> 2] = 0, Be = we + 40 | 0, m = Be + 8 | 0, v = a[m + 4 >> 2], fr = we + 128 | 0, B = fr + 8 | 0, a[B >> 2] = a[m >> 2], a[B + 4 >> 2] = v, m = Be + 16 | 0, v = a[m + 4 >> 2], B = fr + 16 | 0, a[B >> 2] = a[m >> 2], a[B + 4 >> 2] = v, m = Be + 24 | 0, v = a[m + 4 >> 2], B = fr + 24 | 0, a[B >> 2] = a[m >> 2], a[B + 4 >> 2] = v, m = Be + 32 | 0, v = a[m + 4 >> 2], B = fr + 32 | 0, a[B >> 2] = a[m >> 2], a[B + 4 >> 2] = v, m = Be + 48 | 0, v = a[m + 4 >> 2], B = fr + 48 | 0, a[B >> 2] = a[m >> 2], a[B + 4 >> 2] = v, m = Be + 56 | 0, v = a[m + 4 >> 2], B = fr + 56 | 0, a[B >> 2] = a[m >> 2], a[B + 4 >> 2] = v, m = Be - -64 | 0, v = a[m + 4 >> 2], B = fr - -64 | 0, a[B >> 2] = a[m >> 2], a[B + 4 >> 2] = v, m = Be + 72 | 0, v = a[m + 4 >> 2], B = fr + 72 | 0, a[B >> 2] = a[m >> 2], a[B + 4 >> 2] = v, a[we + 256 >> 2] = 0, a[we + 260 >> 2] = 0, a[we + 248 >> 2] = 0, B = a[we + 44 >> 2], a[we + 128 >> 2] = a[we + 40 >> 2], a[we + 132 >> 2] = B, B = a[we + 84 >> 2], a[we + 168 >> 2] = a[we + 80 >> 2], a[we + 172 >> 2] = B, B = we + 240 | 0, a[B >> 2] = 0, a[B + 4 >> 2] = 0, B = we + 232 | 0, a[B >> 2] = 0, a[B + 4 >> 2] = 0, B = we + 224 | 0, a[B >> 2] = 0, a[B + 4 >> 2] = 0, B = we + 216 | 0, a[B >> 2] = 0, a[B + 4 >> 2] = 0, a[we + 208 >> 2] = 1, a[we + 212 >> 2] = 0, Ui(fr, fr, we + 8 | 0, dr), Fo(Be, fr), Gn(d, Be), mi = 1;
        }
        if (be = we + 288 | 0, !mi || (a[he + 204 >> 2] = o, B = pn(a[172688], he + 204 | 0, he + 8 | 0, (o | 0) == 33 ? 258 : 2), a[he + 72 >> 2] = B, Si = 1, (B | 0) == 1))
          break e;
        a[he + 144 >> 2] = 0, ar(he + 136 | 0), wasm2js_trap();
      }
      Ee(1);
    }
    return be = he + 208 | 0, Si | 0;
  }
  function Ji() {
    return (rs() | 0) == 1 | 0;
  }
  function mn() {
    var B = 0, o = 0;
    if (B = be - 32 | 0, be = B, o = $s(a[172688], 690949), a[B + 4 >> 2] = o, (o | 0) == 1)
      return o = rs(), be = B + 32 | 0, (o | 0) == 1 | 0;
    a[B + 16 >> 2] = 0, ar(B + 8 | 0), wasm2js_trap();
  }
  function pi() {
    var B = 0, o = 0;
    if (B = be - 32 | 0, be = B, o = $s(a[172688], 690788), a[B + 4 >> 2] = o, (o | 0) == 1) {
      be = B + 32 | 0;
      return;
    }
    a[B + 16 >> 2] = 0, ar(B + 8 | 0), wasm2js_trap();
  }
  function ei(B) {
    B = B | 0;
    var o = 0, m = 0, d = 0, v = 0, he = 0, we = 0;
    d = be - 96 | 0, be = d, o = d + 56 | 0, a[o >> 2] = 0, a[o + 4 >> 2] = 0, o = d + 48 | 0, a[o >> 2] = 0, a[o + 4 >> 2] = 0, o = d + 40 | 0, a[o >> 2] = 0, a[o + 4 >> 2] = 0, o = d + 32 | 0, a[o >> 2] = 0, a[o + 4 >> 2] = 0, o = d + 24 | 0, a[o >> 2] = 0, a[o + 4 >> 2] = 0, o = d + 16 | 0, a[o >> 2] = 0, a[o + 4 >> 2] = 0, o = d + 8 | 0, a[o >> 2] = 0, a[o + 4 >> 2] = 0, a[d >> 2] = 0, a[d + 4 >> 2] = 0, m = yr(), he = a[172560], B = B ? 655681 : 0, o = be + -64 | 0, be = o;
    e: {
      if (!a[m >> 2]) {
        ji[a[m + 168 >> 2]](690045, a[m + 172 >> 2]), B = 0;
        break e;
      }
      if (!d) {
        ji[a[m + 168 >> 2]](689760, a[m + 172 >> 2]), B = 0;
        break e;
      }
      v = o + 32 | 0, B = To(m, v, o, 0, he, B), we = v + 24 | 0, he = a[we + 4 >> 2], m = d + 24 | 0, we = a[we >> 2], u[m | 0] = we, u[m + 1 | 0] = we >>> 8, u[m + 2 | 0] = we >>> 16, u[m + 3 | 0] = we >>> 24, u[m + 4 | 0] = he, u[m + 5 | 0] = he >>> 8, u[m + 6 | 0] = he >>> 16, u[m + 7 | 0] = he >>> 24, we = v + 16 | 0, he = a[we + 4 >> 2], m = d + 16 | 0, we = a[we >> 2], u[m | 0] = we, u[m + 1 | 0] = we >>> 8, u[m + 2 | 0] = we >>> 16, u[m + 3 | 0] = we >>> 24, u[m + 4 | 0] = he, u[m + 5 | 0] = he >>> 8, u[m + 6 | 0] = he >>> 16, u[m + 7 | 0] = he >>> 24, v = v + 8 | 0, he = a[v + 4 >> 2], m = d + 8 | 0, v = a[v >> 2], u[m | 0] = v, u[m + 1 | 0] = v >>> 8, u[m + 2 | 0] = v >>> 16, u[m + 3 | 0] = v >>> 24, u[m + 4 | 0] = he, u[m + 5 | 0] = he >>> 8, u[m + 6 | 0] = he >>> 16, u[m + 7 | 0] = he >>> 24, m = a[o + 36 >> 2], he = a[o + 32 >> 2], u[d | 0] = he, u[d + 1 | 0] = he >>> 8, u[d + 2 | 0] = he >>> 16, u[d + 3 | 0] = he >>> 24, u[d + 4 | 0] = m, u[d + 5 | 0] = m >>> 8, u[d + 6 | 0] = m >>> 16, u[d + 7 | 0] = m >>> 24, m = a[o + 4 >> 2], he = a[o >> 2], u[d + 32 | 0] = he, u[d + 33 | 0] = he >>> 8, u[d + 34 | 0] = he >>> 16, u[d + 35 | 0] = he >>> 24, u[d + 36 | 0] = m, u[d + 37 | 0] = m >>> 8, u[d + 38 | 0] = m >>> 16, u[d + 39 | 0] = m >>> 24, v = o + 8 | 0, he = a[v + 4 >> 2], m = d + 40 | 0, v = a[v >> 2], u[m | 0] = v, u[m + 1 | 0] = v >>> 8, u[m + 2 | 0] = v >>> 16, u[m + 3 | 0] = v >>> 24, u[m + 4 | 0] = he, u[m + 5 | 0] = he >>> 8, u[m + 6 | 0] = he >>> 16, u[m + 7 | 0] = he >>> 24, v = o + 16 | 0, he = a[v + 4 >> 2], m = d + 48 | 0, v = a[v >> 2], u[m | 0] = v, u[m + 1 | 0] = v >>> 8, u[m + 2 | 0] = v >>> 16, u[m + 3 | 0] = v >>> 24, u[m + 4 | 0] = he, u[m + 5 | 0] = he >>> 8, u[m + 6 | 0] = he >>> 16, u[m + 7 | 0] = he >>> 24, v = o + 24 | 0, he = a[v + 4 >> 2], m = d + 56 | 0, v = a[v >> 2], u[m | 0] = v, u[m + 1 | 0] = v >>> 8, u[m + 2 | 0] = v >>> 16, u[m + 3 | 0] = v >>> 24, u[m + 4 | 0] = he, u[m + 5 | 0] = he >>> 8, u[m + 6 | 0] = he >>> 16, u[m + 7 | 0] = he >>> 24;
    }
    be = o - -64 | 0, a[d + 68 >> 2] = B;
    e: {
      t: {
        if ((B | 0) == 1) {
          o = a[172688], B = be + -64 | 0, be = B;
          r: {
            if (!d) {
              ji[a[o + 168 >> 2]](689748, a[o + 172 >> 2]), o = 0;
              break r;
            }
            o = d + 24 | 0, he = A[o + 4 | 0] | A[o + 5 | 0] << 8 | (A[o + 6 | 0] << 16 | A[o + 7 | 0] << 24), m = B + 32 | 0, v = m + 24 | 0, a[v >> 2] = A[o | 0] | A[o + 1 | 0] << 8 | (A[o + 2 | 0] << 16 | A[o + 3 | 0] << 24), a[v + 4 >> 2] = he, o = d + 16 | 0, he = A[o + 4 | 0] | A[o + 5 | 0] << 8 | (A[o + 6 | 0] << 16 | A[o + 7 | 0] << 24), v = m + 16 | 0, a[v >> 2] = A[o | 0] | A[o + 1 | 0] << 8 | (A[o + 2 | 0] << 16 | A[o + 3 | 0] << 24), a[v + 4 >> 2] = he, o = d + 8 | 0, he = A[o + 4 | 0] | A[o + 5 | 0] << 8 | (A[o + 6 | 0] << 16 | A[o + 7 | 0] << 24), v = m + 8 | 0, a[v >> 2] = A[o | 0] | A[o + 1 | 0] << 8 | (A[o + 2 | 0] << 16 | A[o + 3 | 0] << 24), a[v + 4 >> 2] = he, o = d + 40 | 0, he = A[o + 4 | 0] | A[o + 5 | 0] << 8 | (A[o + 6 | 0] << 16 | A[o + 7 | 0] << 24), v = B + 8 | 0, a[v >> 2] = A[o | 0] | A[o + 1 | 0] << 8 | (A[o + 2 | 0] << 16 | A[o + 3 | 0] << 24), a[v + 4 >> 2] = he, o = d + 48 | 0, he = A[o + 4 | 0] | A[o + 5 | 0] << 8 | (A[o + 6 | 0] << 16 | A[o + 7 | 0] << 24), v = B + 16 | 0, a[v >> 2] = A[o | 0] | A[o + 1 | 0] << 8 | (A[o + 2 | 0] << 16 | A[o + 3 | 0] << 24), a[v + 4 >> 2] = he, o = d + 56 | 0, he = A[o + 4 | 0] | A[o + 5 | 0] << 8 | (A[o + 6 | 0] << 16 | A[o + 7 | 0] << 24), v = B + 24 | 0, a[v >> 2] = A[o | 0] | A[o + 1 | 0] << 8 | (A[o + 2 | 0] << 16 | A[o + 3 | 0] << 24), a[v + 4 >> 2] = he, o = A[d + 4 | 0] | A[d + 5 | 0] << 8 | (A[d + 6 | 0] << 16 | A[d + 7 | 0] << 24), a[B + 32 >> 2] = A[d | 0] | A[d + 1 | 0] << 8 | (A[d + 2 | 0] << 16 | A[d + 3 | 0] << 24), a[B + 36 >> 2] = o, o = A[d + 36 | 0] | A[d + 37 | 0] << 8 | (A[d + 38 | 0] << 16 | A[d + 39 | 0] << 24), a[B >> 2] = A[d + 32 | 0] | A[d + 33 | 0] << 8 | (A[d + 34 | 0] << 16 | A[d + 35 | 0] << 24), a[B + 4 >> 2] = o, vo(690981, m), vo(691013, B), o = 1;
          }
          if (be = B - -64 | 0, a[d + 68 >> 2] = o, (o | 0) == 1)
            break t;
          break e;
        }
        break e;
      }
      be = d + 96 | 0;
      return;
    }
    a[d + 80 >> 2] = 0, ar(d + 72 | 0), wasm2js_trap();
  }
  function Vr(B) {
    B = B | 0;
    var o = 0, m = 0, d = 0, v = 0, he = 0, we = 0, Be = 0, Me = 0, fr = 0, wr = 0, dr = 0, Dr = 0, Rr = 0, Qe = 0;
    Me = be - 112 | 0, be = Me, he = Me + 16 | 0, xi(he, 65), o = yr(), d = a[172560], B = B ? 655681 : 0, m = be - 80 | 0, be = m;
    e: {
      if (!a[o >> 2]) {
        ji[a[o + 168 >> 2]](690045, a[o + 172 >> 2]), B = 0;
        break e;
      }
      if (!he) {
        ji[a[o + 168 >> 2]](689760, a[o + 172 >> 2]), B = 0;
        break e;
      }
      v = m + 48 | 0, Be = m + 16 | 0, B = To(o, v, Be, m + 12 | 0, d, B), o = a[m + 52 >> 2], d = a[m + 48 >> 2], u[he | 0] = d, u[he + 1 | 0] = d >>> 8, u[he + 2 | 0] = d >>> 16, u[he + 3 | 0] = d >>> 24, u[he + 4 | 0] = o, u[he + 5 | 0] = o >>> 8, u[he + 6 | 0] = o >>> 16, u[he + 7 | 0] = o >>> 24, we = v + 8 | 0, d = a[we + 4 >> 2], o = he + 8 | 0, we = a[we >> 2], u[o | 0] = we, u[o + 1 | 0] = we >>> 8, u[o + 2 | 0] = we >>> 16, u[o + 3 | 0] = we >>> 24, u[o + 4 | 0] = d, u[o + 5 | 0] = d >>> 8, u[o + 6 | 0] = d >>> 16, u[o + 7 | 0] = d >>> 24, we = v + 16 | 0, d = a[we + 4 >> 2], o = he + 16 | 0, we = a[we >> 2], u[o | 0] = we, u[o + 1 | 0] = we >>> 8, u[o + 2 | 0] = we >>> 16, u[o + 3 | 0] = we >>> 24, u[o + 4 | 0] = d, u[o + 5 | 0] = d >>> 8, u[o + 6 | 0] = d >>> 16, u[o + 7 | 0] = d >>> 24, v = v + 24 | 0, d = a[v + 4 >> 2], o = he + 24 | 0, v = a[v >> 2], u[o | 0] = v, u[o + 1 | 0] = v >>> 8, u[o + 2 | 0] = v >>> 16, u[o + 3 | 0] = v >>> 24, u[o + 4 | 0] = d, u[o + 5 | 0] = d >>> 8, u[o + 6 | 0] = d >>> 16, u[o + 7 | 0] = d >>> 24, o = a[m + 20 >> 2], d = a[m + 16 >> 2], u[he + 32 | 0] = d, u[he + 33 | 0] = d >>> 8, u[he + 34 | 0] = d >>> 16, u[he + 35 | 0] = d >>> 24, u[he + 36 | 0] = o, u[he + 37 | 0] = o >>> 8, u[he + 38 | 0] = o >>> 16, u[he + 39 | 0] = o >>> 24, v = Be + 8 | 0, d = a[v + 4 >> 2], o = he + 40 | 0, v = a[v >> 2], u[o | 0] = v, u[o + 1 | 0] = v >>> 8, u[o + 2 | 0] = v >>> 16, u[o + 3 | 0] = v >>> 24, u[o + 4 | 0] = d, u[o + 5 | 0] = d >>> 8, u[o + 6 | 0] = d >>> 16, u[o + 7 | 0] = d >>> 24, v = Be + 16 | 0, d = a[v + 4 >> 2], o = he + 48 | 0, v = a[v >> 2], u[o | 0] = v, u[o + 1 | 0] = v >>> 8, u[o + 2 | 0] = v >>> 16, u[o + 3 | 0] = v >>> 24, u[o + 4 | 0] = d, u[o + 5 | 0] = d >>> 8, u[o + 6 | 0] = d >>> 16, u[o + 7 | 0] = d >>> 24, v = Be + 24 | 0, d = a[v + 4 >> 2], o = he + 56 | 0, v = a[v >> 2], u[o | 0] = v, u[o + 1 | 0] = v >>> 8, u[o + 2 | 0] = v >>> 16, u[o + 3 | 0] = v >>> 24, u[o + 4 | 0] = d, u[o + 5 | 0] = d >>> 8, u[o + 6 | 0] = d >>> 16, u[o + 7 | 0] = d >>> 24, u[he + 64 | 0] = a[m + 12 >> 2];
    }
    if (be = m + 80 | 0, a[Me + 84 >> 2] = B, (B | 0) == 1) {
      a[Me + 12 >> 2] = 0, m = a[172688], d = Me + 12 | 0, he = be + -64 | 0, be = he, B = Me + 16 | 0;
      e: {
        if (!B) {
          ji[a[m + 168 >> 2]](689748, a[m + 172 >> 2]);
          break e;
        }
        if (!d) {
          ji[a[m + 168 >> 2]](689795, a[m + 172 >> 2]);
          break e;
        }
        m = B + 24 | 0, v = A[m + 4 | 0] | A[m + 5 | 0] << 8 | (A[m + 6 | 0] << 16 | A[m + 7 | 0] << 24), o = he + 32 | 0, Be = o + 24 | 0, a[Be >> 2] = A[m | 0] | A[m + 1 | 0] << 8 | (A[m + 2 | 0] << 16 | A[m + 3 | 0] << 24), a[Be + 4 >> 2] = v, m = B + 16 | 0, v = A[m + 4 | 0] | A[m + 5 | 0] << 8 | (A[m + 6 | 0] << 16 | A[m + 7 | 0] << 24), Be = o + 16 | 0, a[Be >> 2] = A[m | 0] | A[m + 1 | 0] << 8 | (A[m + 2 | 0] << 16 | A[m + 3 | 0] << 24), a[Be + 4 >> 2] = v, m = B + 8 | 0, v = A[m + 4 | 0] | A[m + 5 | 0] << 8 | (A[m + 6 | 0] << 16 | A[m + 7 | 0] << 24), Be = o + 8 | 0, a[Be >> 2] = A[m | 0] | A[m + 1 | 0] << 8 | (A[m + 2 | 0] << 16 | A[m + 3 | 0] << 24), a[Be + 4 >> 2] = v, m = B + 56 | 0, v = A[m | 0] | A[m + 1 | 0] << 8 | (A[m + 2 | 0] << 16 | A[m + 3 | 0] << 24), Be = A[m + 4 | 0] | A[m + 5 | 0] << 8 | (A[m + 6 | 0] << 16 | A[m + 7 | 0] << 24), m = B + 48 | 0, we = A[m | 0] | A[m + 1 | 0] << 8 | (A[m + 2 | 0] << 16 | A[m + 3 | 0] << 24), fr = A[m + 4 | 0] | A[m + 5 | 0] << 8 | (A[m + 6 | 0] << 16 | A[m + 7 | 0] << 24), m = B + 40 | 0, wr = A[m | 0] | A[m + 1 | 0] << 8 | (A[m + 2 | 0] << 16 | A[m + 3 | 0] << 24), m = A[m + 4 | 0] | A[m + 5 | 0] << 8 | (A[m + 6 | 0] << 16 | A[m + 7 | 0] << 24), dr = A[B + 32 | 0] | A[B + 33 | 0] << 8 | (A[B + 34 | 0] << 16 | A[B + 35 | 0] << 24), Dr = A[B + 36 | 0] | A[B + 37 | 0] << 8 | (A[B + 38 | 0] << 16 | A[B + 39 | 0] << 24), Rr = A[B | 0] | A[B + 1 | 0] << 8 | (A[B + 2 | 0] << 16 | A[B + 3 | 0] << 24), Qe = A[B + 4 | 0] | A[B + 5 | 0] << 8 | (A[B + 6 | 0] << 16 | A[B + 7 | 0] << 24), a[d >> 2] = A[B + 64 | 0], B = he + 8 | 0, a[B >> 2] = wr, a[B + 4 >> 2] = m, B = he + 16 | 0, a[B >> 2] = we, a[B + 4 >> 2] = fr, B = he + 24 | 0, a[B >> 2] = v, a[B + 4 >> 2] = Be, a[he + 32 >> 2] = Rr, a[he + 36 >> 2] = Qe, a[he >> 2] = dr, a[he + 4 >> 2] = Dr, vo(690981, o), vo(691013, he);
      }
      return be = he - -64 | 0, be = Me + 112 | 0, a[Me + 12 >> 2];
    }
    a[Me + 96 >> 2] = 0, ar(Me + 88 | 0), wasm2js_trap();
  }
  function qr(B) {
    B = B | 0;
    var o = 0, m = 0, d = 0, v = 0, he = 0, we = 0, Be = 0, Me = 0, fr = 0, wr = 0, dr = 0, Dr = 0, Rr = 0, Qe = 0, Fr = 0, Gr = 0, $r = 0, ni = 0, mi = 0, Si = 0, Oi = 0, $i = 0, zi = 0, un = 0, In = 0, Ti = 0;
    m = be - 128 | 0, be = m, Be = xi(m, 96), m = Ii(yr(), Be), a[Be + 100 >> 2] = m;
    e: {
      t: {
        if ((m | 0) == 1) {
          Fr = yr(), Ti = B ? 655681 : 0, o = be - 640 | 0, be = o, B = o + 88 | 0, a[B >> 2] = 0, a[B + 4 >> 2] = 0, B = o + 80 | 0, a[B >> 2] = 0, a[B + 4 >> 2] = 0, a[o + 72 >> 2] = 0, a[o + 76 >> 2] = 0, a[o + 64 >> 2] = 0, a[o + 68 >> 2] = 0;
          r: {
            if (!a[Fr >> 2]) {
              ji[a[Fr + 168 >> 2]](690045, a[Fr + 172 >> 2]);
              break r;
            }
            if (!Be) {
              ji[a[Fr + 168 >> 2]](689700, a[Fr + 172 >> 2]);
              break r;
            }
            $r = o + 472 | 0, zi = be - 16 | 0, be = zi, ni = A[Be + 40 | 0] | A[Be + 41 | 0] << 8 | (A[Be + 42 | 0] << 16 | A[Be + 43 | 0] << 24), we = A[Be + 44 | 0] | A[Be + 45 | 0] << 8 | (A[Be + 46 | 0] << 16 | A[Be + 47 | 0] << 24), wr = A[Be + 48 | 0] | A[Be + 49 | 0] << 8 | (A[Be + 50 | 0] << 16 | A[Be + 51 | 0] << 24), he = A[Be + 52 | 0] | A[Be + 53 | 0] << 8 | (A[Be + 54 | 0] << 16 | A[Be + 55 | 0] << 24), mi = A[Be + 72 | 0] | A[Be + 73 | 0] << 8 | (A[Be + 74 | 0] << 16 | A[Be + 75 | 0] << 24), Dr = A[Be + 76 | 0] | A[Be + 77 | 0] << 8 | (A[Be + 78 | 0] << 16 | A[Be + 79 | 0] << 24), Me = A[Be + 80 | 0] | A[Be + 81 | 0] << 8 | (A[Be + 82 | 0] << 16 | A[Be + 83 | 0] << 24), d = A[Be + 84 | 0] | A[Be + 85 | 0] << 8 | (A[Be + 86 | 0] << 16 | A[Be + 87 | 0] << 24), Gr = A[Be + 32 | 0] | A[Be + 33 | 0] << 8 | (A[Be + 34 | 0] << 16 | A[Be + 35 | 0] << 24), Rr = A[Be + 36 | 0] | A[Be + 37 | 0] << 8 | (A[Be + 38 | 0] << 16 | A[Be + 39 | 0] << 24), dr = A[Be + 56 | 0] | A[Be + 57 | 0] << 8 | (A[Be + 58 | 0] << 16 | A[Be + 59 | 0] << 24), v = A[Be + 60 | 0] | A[Be + 61 | 0] << 8 | (A[Be + 62 | 0] << 16 | A[Be + 63 | 0] << 24), $i = A[Be + 64 | 0] | A[Be + 65 | 0] << 8 | (A[Be + 66 | 0] << 16 | A[Be + 67 | 0] << 24), Qe = A[Be + 68 | 0] | A[Be + 69 | 0] << 8 | (A[Be + 70 | 0] << 16 | A[Be + 71 | 0] << 24), fr = A[Be + 88 | 0] | A[Be + 89 | 0] << 8 | (A[Be + 90 | 0] << 16 | A[Be + 91 | 0] << 24), Si = A[Be + 92 | 0] | A[Be + 93 | 0] << 8 | (A[Be + 94 | 0] << 16 | A[Be + 95 | 0] << 24), m = o + 192 | 0, a[m + 80 >> 2] = 0, Oi = m + 72 | 0, a[Oi >> 2] = (Si & 65535) << 16 | fr >>> 16, a[Oi + 4 >> 2] = Si >>> 16, a[m + 40 >> 2] = $i, a[m + 44 >> 2] = Qe & 1048575, Oi = (v & 65535) << 16 | dr >>> 16, a[m + 32 >> 2] = Oi, $i = v >>> 16 | 0, a[m + 36 >> 2] = $i, a[m >> 2] = Gr, Si = Rr & 1048575, a[m + 4 >> 2] = Si, un = m - -64 | 0, a[un >> 2] = (d & 268435455) << 4 | Me >>> 28, a[un + 4 >> 2] = fr << 4 & 1048560 | d >>> 28, B = d << 24 | Me >>> 8, fr = m + 56 | 0, d = Dr, a[fr >> 2] = Me << 24 & -16777216 | d >>> 8, a[fr + 4 >> 2] = B & 1048575, B = d << 12, d = mi, Me = (B | d >>> 20) & 1048575, Dr = m + 48 | 0, a[Dr >> 2] = d << 12 & -4096 | Qe >>> 20, a[Dr + 4 >> 2] = Me, d = dr << 4 & 1048560, v = he, B = v >>> 28 | 0, he = (v & 268435455) << 4 | wr >>> 28, a[m + 24 >> 2] = he, d = B | d, a[m + 28 >> 2] = d, B = v << 24 | wr >>> 8, v = we, we = wr << 24 & -16777216 | v >>> 8, a[m + 16 >> 2] = we, wr = B & 1048575, a[m + 20 >> 2] = wr, B = v << 12, v = ni, Dr = (B | v >>> 20) & 1048575, v = v << 12 & -4096 | Rr >>> 20, a[m + 8 >> 2] = v, B = Dr, a[m + 12 >> 2] = B;
            i: {
              n: {
                if (!(v | Gr | Oi | we | he | (B | Si | $i | wr | d))) {
                  if (ji[a[Fr + 168 >> 2]](690116, a[Fr + 172 >> 2]), dn(m, 690376, 88), $r)
                    break n;
                  break i;
                }
                if (In = 1, !$r || (Rn($r, Be, zi + 12 | 0), !(a[zi + 12 >> 2] | !(a[$r + 24 >> 2] | (a[$r + 16 >> 2] | (a[$r + 8 >> 2] | a[$r >> 2])) | (a[$r + 28 >> 2] | (a[$r + 20 >> 2] | (a[$r + 12 >> 2] | a[$r + 4 >> 2])))))))
                  break i;
                ji[a[Fr + 168 >> 2]](689400, a[Fr + 172 >> 2]), dn(m, 690376, 88);
              }
              In = 0, B = a[172569], m = $r + 24 | 0, a[m >> 2] = a[172568], a[m + 4 >> 2] = B, B = a[172567], m = $r + 16 | 0, a[m >> 2] = a[172566], a[m + 4 >> 2] = B, B = a[172565], m = $r + 8 | 0, a[m >> 2] = a[172564], a[m + 4 >> 2] = B, B = a[172563], a[$r >> 2] = a[172562], a[$r + 4 >> 2] = B;
            }
            be = zi + 16 | 0;
            i: {
              if (!(u[o + 232 | 0] & 1)) {
                ni = a[o + 472 >> 2], Dr = a[o + 476 >> 2], Me = a[o + 480 >> 2], m = a[o + 484 >> 2], d = a[o + 488 >> 2], he = a[o + 492 >> 2], mi = a[o + 496 >> 2], wr = a[o + 500 >> 2];
                break i;
              }
              Rr = a[o + 496 >> 2], Qe = a[o + 488 >> 2], d = a[o + 480 >> 2], B = a[o + 472 >> 2], Gr = a[o + 500 >> 2], mi = a[o + 492 >> 2], he = a[o + 484 >> 2], m = a[o + 476 >> 2], we = Rr | (Qe | (d | B)) | (Gr | (mi | (he | m))) ? -1 : 0, B = B ^ -1, wr = B - 801750718 | 0, ni = we & wr, a[o + 472 >> 2] = ni, m = m ^ -1, v = m - ((B >>> 0 < 801750718) + 1076732275 | 0) | 0, Dr = v & we, a[o + 476 >> 2] = Dr, B = (m | 0) == (v | 0) & B >>> 0 > wr >>> 0 | m >>> 0 > v >>> 0, wr = d ^ -1, d = B + wr | 0, he = he ^ -1, B = he, fr = d - 1354194885 | 0, Me = fr & we, a[o + 480 >> 2] = Me, B = d >>> 0 < wr >>> 0 ? B + 1 | 0 : B, dr = B - ((d >>> 0 < 1354194885) + 1162945305 | 0) | 0, m = dr & we, a[o + 484 >> 2] = m, v = (B | 0) == (he | 0) & d >>> 0 < wr >>> 0 | B >>> 0 < he >>> 0, wr = (B | 0) == (dr | 0) & d >>> 0 > fr >>> 0 | B >>> 0 > dr >>> 0, d = v + wr | 0, B = d >>> 0 < wr >>> 0, dr = Qe ^ -1, wr = dr + d | 0, Qe = mi ^ -1, B = Qe + B | 0, fr = wr - 2 | 0, d = fr & we, a[o + 488 >> 2] = d, B = wr >>> 0 < dr >>> 0 ? B + 1 | 0 : B, mi = B - (wr >>> 0 < 2) | 0, he = mi & we, a[o + 492 >> 2] = he, v = (B | 0) == (Qe | 0) & wr >>> 0 < dr >>> 0 | B >>> 0 < Qe >>> 0, wr = (B | 0) == (mi | 0) & fr >>> 0 < wr >>> 0 | B >>> 0 > mi >>> 0, v = v + wr | 0, B = v >>> 0 < wr >>> 0, wr = v - Rr | 0, mi = wr - 2 & we, a[o + 496 >> 2] = mi, wr = (B - ((v >>> 0 < Rr >>> 0) + Gr | 0) | 0) - (wr >>> 0 < 2) & we, a[o + 500 >> 2] = wr;
            }
            u[o + 31 | 0] = ni, u[o + 30 | 0] = (Dr & 255) << 24 | ni >>> 8, u[o + 29 | 0] = (Dr & 65535) << 16 | ni >>> 16, u[o + 28 | 0] = (Dr & 16777215) << 8 | ni >>> 24, u[o + 27 | 0] = Dr, u[o + 26 | 0] = Dr >>> 8, u[o + 25 | 0] = Dr >>> 16, u[o + 24 | 0] = Dr >>> 24, u[o + 23 | 0] = Me, u[o + 22 | 0] = (m & 255) << 24 | Me >>> 8, u[o + 21 | 0] = (m & 65535) << 16 | Me >>> 16, u[o + 20 | 0] = (m & 16777215) << 8 | Me >>> 24, u[o + 19 | 0] = m, u[o + 18 | 0] = m >>> 8, u[o + 17 | 0] = m >>> 16, u[o + 16 | 0] = m >>> 24, u[o + 15 | 0] = d, u[o + 14 | 0] = (he & 255) << 24 | d >>> 8, u[o + 13 | 0] = (he & 65535) << 16 | d >>> 16, u[o + 12 | 0] = (he & 16777215) << 8 | d >>> 24, u[o + 11 | 0] = he, u[o + 10 | 0] = he >>> 8, u[o + 9 | 0] = he >>> 16, u[o + 8 | 0] = he >>> 24, u[o + 7 | 0] = mi, u[o + 6 | 0] = (wr & 255) << 24 | mi >>> 8, u[o + 5 | 0] = (wr & 65535) << 16 | mi >>> 16, u[o + 4 | 0] = (wr & 16777215) << 8 | mi >>> 24, u[o + 3 | 0] = wr, u[o + 2 | 0] = wr >>> 8, u[o + 1 | 0] = wr >>> 16, u[o | 0] = wr >>> 24, m = a[o + 228 >> 2], v = a[o + 224 >> 2], u[o + 37 | 0] = v, B = a[o + 212 >> 2], d = a[o + 208 >> 2], u[o + 50 | 0] = d, u[o + 36 | 0] = (m & 255) << 24 | v >>> 8, u[o + 35 | 0] = (m & 65535) << 16 | v >>> 16, u[o + 34 | 0] = (m & 16777215) << 8 | v >>> 24, u[o + 33 | 0] = m, u[o + 32 | 0] = m >>> 8, m = a[o + 220 >> 2], v = a[o + 216 >> 2], u[o + 43 | 0] = (m & 15) << 28 | v >>> 4, u[o + 42 | 0] = (m & 4095) << 20 | v >>> 12, u[o + 41 | 0] = (m & 1048575) << 12 | v >>> 20, u[o + 40 | 0] = (m & 268435455) << 4 | v >>> 28, u[o + 39 | 0] = m >>> 4, u[o + 38 | 0] = m >>> 12, u[o + 49 | 0] = (B & 255) << 24 | d >>> 8, u[o + 48 | 0] = (B & 65535) << 16 | d >>> 16, u[o + 47 | 0] = (B & 16777215) << 8 | d >>> 24, u[o + 46 | 0] = B, u[o + 45 | 0] = B >>> 8, u[o + 44 | 0] = B >>> 16 & 15 | v << 4, B = a[o + 196 >> 2], d = a[o + 192 >> 2], u[o + 63 | 0] = d, m = a[o + 204 >> 2], v = a[o + 200 >> 2], u[o + 56 | 0] = (m & 15) << 28 | v >>> 4, u[o + 55 | 0] = (m & 4095) << 20 | v >>> 12, u[o + 54 | 0] = (m & 1048575) << 12 | v >>> 20, u[o + 53 | 0] = (m & 268435455) << 4 | v >>> 28, u[o + 52 | 0] = m >>> 4, u[o + 51 | 0] = m >>> 12, u[o + 62 | 0] = (B & 255) << 24 | d >>> 8, u[o + 61 | 0] = (B & 65535) << 16 | d >>> 16, u[o + 60 | 0] = (B & 16777215) << 8 | d >>> 24, u[o + 59 | 0] = B, u[o + 58 | 0] = B >>> 8, u[o + 57 | 0] = B >>> 16 & 15 | v << 4, B = o - -64 | 0, m = Gi(B, 655649, 32, o, o + 32 | 0, 690736, 13, Ti), v = o + 408 | 0, Rn(v, B, 0), B = In & (m | 0) != 0, m = a[o + 432 >> 2], he = a[o + 424 >> 2], d = a[o + 416 >> 2], we = a[o + 408 >> 2], wr = a[o + 436 >> 2], Rr = a[o + 428 >> 2], Dr = a[o + 420 >> 2], Me = a[o + 412 >> 2], un = B & (m | (he | (d | we)) | (wr | (Rr | (Dr | Me)))) != 0, zi = !un, B = zi - 1 | 0, mi = B & m, a[o + 432 >> 2] = mi, m = 0 - !zi | 0, wr = m & wr, a[o + 436 >> 2] = wr, Si = B & he, a[o + 424 >> 2] = Si, $i = m & Rr, a[o + 428 >> 2] = $i, Oi = B & d, a[o + 416 >> 2] = Oi, $r = m & Dr, a[o + 420 >> 2] = $r, ni = B & we | zi, a[o + 408 >> 2] = ni, Dr = m & Me, a[o + 412 >> 2] = Dr, B = o + 280 | 0, xs(Fr, B, v), Fo(o + 104 | 0, B), B = o + 152 | 0, v = a[B >> 2], we = a[B + 4 >> 2], he = a[o + 148 >> 2], B = o + 176 | 0, Me = a[B >> 2], d = a[B + 4 >> 2], Qe = d, B = a[o + 144 >> 2], m = oi(d >>> 16 | 0, 0, 977, 1), d = B + m | 0, B = he + Fe | 0, fr = m >>> 0 > d >>> 0 ? B + 1 | 0 : B, B = we, m = fr >>> 20 | 0, he = m, m = m + v | 0, he = he >>> 0 > m >>> 0 ? B + 1 | 0 : B, Rr = he & 1048575, B = o + 168 | 0, Gr = a[B >> 2], Fr = a[B + 4 >> 2], B = o + 160 | 0, we = a[B >> 2], B = a[B + 4 >> 2], v = he >>> 20 | 0, dr = v, v = v + we | 0, dr = dr >>> 0 > v >>> 0 ? B + 1 | 0 : B, B = Fr, we = dr >>> 20 | 0, Fr = we, we = we + Gr | 0, B = Fr >>> 0 > we >>> 0 ? B + 1 | 0 : B, Gr = B & 1048575, dr = dr & 1048575, Fr = (m & v & we) == -1 & (he & dr & B) == 1048575, he = B, B = Qe & 65535, he = he >>> 20 | 0, Qe = he + Me | 0, B = he >>> 0 > Qe >>> 0 ? B + 1 | 0 : B, Me = B, he = fr & 1048575, Fr & ((Qe | 0) == -1 & (B | 0) == 65535) & ((he | 0) == 1048574 & d >>> 0 > 4294966318 | he >>> 0 > 1048574) | B >>> 16 && (B = he + 1 | 0, d = d + 977 | 0, B = d >>> 0 < 977 ? B + 1 | 0 : B, he = B & 1048575, fr = B, B = Rr, fr = fr >>> 20 | 0, m = m + fr | 0, B = fr >>> 0 > m >>> 0 ? B + 1 | 0 : B, Rr = B & 1048575, fr = B, B = dr, fr = fr >>> 20 | 0, v = v + fr | 0, B = fr >>> 0 > v >>> 0 ? B + 1 | 0 : B, dr = B & 1048575, fr = B, B = Gr, fr = fr >>> 20 | 0, we = we + fr | 0, B = fr >>> 0 > we >>> 0 ? B + 1 | 0 : B, Gr = B & 1048575, fr = B, B = Me, Me = Qe, Qe = (fr >>> 20 | 0) + Qe | 0, Me = (Me >>> 0 > Qe >>> 0 ? B + 1 | 0 : B) & 65535), a[o + 176 >> 2] = Qe, a[o + 180 >> 2] = Me, a[o + 168 >> 2] = we, a[o + 172 >> 2] = Gr, a[o + 160 >> 2] = v, a[o + 164 >> 2] = dr, a[o + 152 >> 2] = m, a[o + 156 >> 2] = Rr, a[o + 144 >> 2] = d, a[o + 148 >> 2] = he, d & 1 && (v = ni | Oi | Si | mi | (Dr | $r | $i | wr) ? -1 : 0, B = ni ^ -1, we = B - 801750718 | 0, ni = v & we, a[o + 408 >> 2] = ni, m = Dr ^ -1, d = m - ((B >>> 0 < 801750718) + 1076732275 | 0) | 0, Dr = d & v, a[o + 412 >> 2] = Dr, B = (m | 0) == (d | 0) & B >>> 0 > we >>> 0 | m >>> 0 > d >>> 0, we = Oi ^ -1, d = B + we | 0, he = $r ^ -1, B = he, Rr = d - 1354194885 | 0, Oi = Rr & v, a[o + 416 >> 2] = Oi, B = d >>> 0 < we >>> 0 ? B + 1 | 0 : B, Me = B - ((d >>> 0 < 1354194885) + 1162945305 | 0) | 0, $r = Me & v, a[o + 420 >> 2] = $r, m = (B | 0) == (he | 0) & d >>> 0 < we >>> 0 | B >>> 0 < he >>> 0, we = (B | 0) == (Me | 0) & d >>> 0 > Rr >>> 0 | B >>> 0 > Me >>> 0, d = m + we | 0, he = $i ^ -1, B = he + (d >>> 0 < we >>> 0) | 0, we = Si ^ -1, d = we + d | 0, Rr = d - 2 | 0, Si = Rr & v, a[o + 424 >> 2] = Si, B = d >>> 0 < we >>> 0 ? B + 1 | 0 : B, Me = B - (d >>> 0 < 2) | 0, $i = Me & v, a[o + 428 >> 2] = $i, m = (B | 0) == (he | 0) & d >>> 0 < we >>> 0 | B >>> 0 < he >>> 0, d = (B | 0) == (Me | 0) & d >>> 0 > Rr >>> 0 | B >>> 0 > Me >>> 0, m = m + d | 0, B = m >>> 0 < d >>> 0, d = m - mi | 0, we = d - 2 | 0, wr = (B - ((m >>> 0 < mi >>> 0) + wr | 0) | 0) - (d >>> 0 < 2) & v, mi = v & we, a[o + 432 >> 2] = mi, a[o + 436 >> 2] = wr), v = a[o + 112 >> 2], d = a[o + 116 >> 2], he = a[o + 108 >> 2], Qe = a[o + 136 >> 2], we = a[o + 140 >> 2], fr = we, B = a[o + 104 >> 2], m = oi(we >>> 16 | 0, 0, 977, 1), we = B + m | 0, B = he + Fe | 0, Gr = m >>> 0 > we >>> 0 ? B + 1 | 0 : B, B = d, m = Gr >>> 20 | 0, d = m + v | 0, Me = m >>> 0 > d >>> 0 ? B + 1 | 0 : B, he = Me & 1048575, Rr = a[o + 128 >> 2], Fr = a[o + 132 >> 2], B = a[o + 124 >> 2], m = Me >>> 20 | 0, v = m + a[o + 120 >> 2] | 0, dr = m >>> 0 > v >>> 0 ? B + 1 | 0 : B, B = Fr, m = dr >>> 20 | 0, Fr = m, m = m + Rr | 0, B = Fr >>> 0 > m >>> 0 ? B + 1 | 0 : B, Rr = B & 1048575, dr = dr & 1048575, Fr = (d & v & m) == -1 & (Me & dr & B) == 1048575, Me = B, B = fr & 65535, Me = Me >>> 20 | 0, Qe = Me + Qe | 0, B = Me >>> 0 > Qe >>> 0 ? B + 1 | 0 : B, Me = B, Gr = Gr & 1048575, Fr & ((Qe | 0) == -1 & (B | 0) == 65535) & ((Gr | 0) == 1048574 & we >>> 0 > 4294966318 | Gr >>> 0 > 1048574) | B >>> 16 && (B = Gr + 1 | 0, we = we + 977 | 0, B = we >>> 0 < 977 ? B + 1 | 0 : B, Gr = B & 1048575, fr = B, B = he, fr = fr >>> 20 | 0, d = d + fr | 0, B = fr >>> 0 > d >>> 0 ? B + 1 | 0 : B, he = B & 1048575, fr = B, B = dr, fr = fr >>> 20 | 0, v = v + fr | 0, B = fr >>> 0 > v >>> 0 ? B + 1 | 0 : B, dr = B & 1048575, fr = B, B = Rr, fr = fr >>> 20 | 0, m = m + fr | 0, B = fr >>> 0 > m >>> 0 ? B + 1 | 0 : B, Rr = B & 1048575, fr = B, B = Me, Me = Qe, Qe = (fr >>> 20 | 0) + Qe | 0, Me = (Me >>> 0 > Qe >>> 0 ? B + 1 | 0 : B) & 65535), a[o + 136 >> 2] = Qe, a[o + 140 >> 2] = Me, a[o + 128 >> 2] = m, a[o + 132 >> 2] = Rr, a[o + 120 >> 2] = v, a[o + 124 >> 2] = dr, a[o + 112 >> 2] = d, a[o + 116 >> 2] = he, a[o + 104 >> 2] = we, a[o + 108 >> 2] = Gr, hn(690981, o + 104 | 0), a[o + 600 >> 2] = 64, a[o + 604 >> 2] = 0, a[o + 528 >> 2] = -1862921884, a[o + 532 >> 2] = 870954602, a[o + 520 >> 2] = -1748470448, a[o + 524 >> 2] = 3983205, a[o + 512 >> 2] = 292000018, a[o + 516 >> 2] = -782074353, a[o + 504 >> 2] = -1662207471, a[o + 508 >> 2] = 596792193, B = o + 504 | 0, Di(B, 690981, 32), Di(B, o + 32 | 0, 32), Di(B, 655649, 32), m = B, B = o + 608 | 0, _n(m, B), fr = o + 440 | 0, Rn(fr, B, 0), Fr = o + 472 | 0, di(fr, fr, Fr), m = a[o + 440 >> 2], Me = m + ni | 0, B = Dr + a[o + 444 >> 2] | 0, he = m >>> 0 > Me >>> 0 ? B + 1 | 0 : B, d = (Dr | 0) == (he | 0) & Me >>> 0 < ni >>> 0 | he >>> 0 < Dr >>> 0, m = a[o + 448 >> 2], v = d + m | 0, B = a[o + 452 >> 2], m = m >>> 0 > v >>> 0 ? B + 1 | 0 : B, B = m + $r | 0, d = !m & d >>> 0 > v >>> 0, Dr = v + Oi | 0, we = Dr >>> 0 < Oi >>> 0 ? B + 1 | 0 : B, v = (m | 0) == (we | 0) & v >>> 0 > Dr >>> 0 | m >>> 0 > we >>> 0, m = d + v | 0, B = m >>> 0 < v >>> 0, dr = m, m = a[o + 456 >> 2], v = dr + m | 0, d = B, B = B + a[o + 460 >> 2] | 0, m = m >>> 0 > v >>> 0 ? B + 1 | 0 : B, B = m + $i | 0, Rr = v, Qe = v + Si | 0, B = Qe >>> 0 < Si >>> 0 ? B + 1 | 0 : B, ni = wr, dr = (m | 0) == (d | 0) & v >>> 0 < dr >>> 0 | m >>> 0 < d >>> 0, v = B, wr = Qe, d = (m | 0) == (B | 0) & wr >>> 0 < Rr >>> 0 | B >>> 0 < m >>> 0, m = dr + d | 0, B = m >>> 0 < d >>> 0, Gr = m, d = a[o + 464 >> 2], m = m + d | 0, Rr = B, B = B + a[o + 468 >> 2] | 0, d = m >>> 0 < d >>> 0 ? B + 1 | 0 : B, B = d + ni | 0, dr = m, m = m + mi | 0, ni = dr >>> 0 > m >>> 0 ? B + 1 | 0 : B, Qe = m, Gr = ((d | 0) == (ni | 0) & dr >>> 0 > m >>> 0 | d >>> 0 > ni >>> 0) + ((d | 0) == (Rr | 0) & dr >>> 0 < Gr >>> 0 | d >>> 0 < Rr >>> 0) | 0, d = (v | 0) == -1, Rr = d & wr >>> 0 < 4294967294 | (v | 0) != -1 | (m & ni) != -1, B = (we | 0) == -1162945306, dr = (Rr | (B & Dr >>> 0 < 2940772411 | we >>> 0 < 3132021990)) ^ -1, Rr = Gr + (dr & ((he | 0) == -1076732276 & Me >>> 0 > 3493216576 | he >>> 0 > 3218235020) | (dr & (B & Dr >>> 0 > 2940772411 | we >>> 0 > 3132021990) | (wr | 0) == -1 & d & (Rr ^ -1))) | 0, d = oi(Rr, 0, 801750719, 1076732275), dr = d + Me | 0, B = he + Fe | 0, a[o + 440 >> 2] = dr, B = d >>> 0 > dr >>> 0 ? B + 1 | 0 : B, a[o + 444 >> 2] = B, Me = (B | 0) == (he | 0) & Me >>> 0 > dr >>> 0 | B >>> 0 < he >>> 0, he = oi(Rr, 0, 1354194884, 1162945305), m = he + Dr | 0, B = we + Fe | 0, B = m >>> 0 < he >>> 0 ? B + 1 | 0 : B, he = m, m = B, Me = he + Me | 0, B = Me >>> 0 < he >>> 0 ? B + 1 | 0 : B, a[o + 448 >> 2] = Me, a[o + 452 >> 2] = B, d = (m | 0) == (we | 0) & he >>> 0 < Dr >>> 0 | m >>> 0 < we >>> 0, we = (B | 0) == (m | 0) & he >>> 0 > Me >>> 0 | B >>> 0 < m >>> 0, m = d + we | 0, he = m, we = m >>> 0 < we >>> 0, B = v, Dr = wr + Rr | 0, m = Dr >>> 0 < Rr >>> 0 ? B + 1 | 0 : B, B = m + we | 0, we = Dr, he = he + we | 0, B = we >>> 0 > he >>> 0 ? B + 1 | 0 : B, a[o + 456 >> 2] = he, a[o + 460 >> 2] = B, d = (m | 0) == (v | 0) & we >>> 0 < wr >>> 0 | m >>> 0 < v >>> 0, v = (B | 0) == (m | 0) & he >>> 0 < we >>> 0 | B >>> 0 < m >>> 0, m = d + v | 0, B = ni + (m >>> 0 < v >>> 0) | 0, m = m + Qe | 0, B = m >>> 0 < Qe >>> 0 ? B + 1 | 0 : B, a[o + 464 >> 2] = m, a[o + 468 >> 2] = B, vo(691013, fr), a[o + 504 >> 2] = zi, B = a[o + 504 >> 2] - 1 | 0, u[690981] = B & A[690981], u[690982] = A[690982] & B, u[690983] = A[690983] & B, u[690984] = A[690984] & B, u[690985] = A[690985] & B, u[690986] = A[690986] & B, u[690987] = A[690987] & B, u[690988] = A[690988] & B, u[690989] = A[690989] & B, u[690990] = A[690990] & B, u[690991] = A[690991] & B, u[690992] = A[690992] & B, u[690993] = A[690993] & B, u[690994] = A[690994] & B, u[690995] = A[690995] & B, u[690996] = A[690996] & B, u[690997] = A[690997] & B, u[690998] = A[690998] & B, u[690999] = A[690999] & B, u[691e3] = A[691e3] & B, u[691001] = A[691001] & B, u[691002] = A[691002] & B, u[691003] = A[691003] & B, u[691004] = A[691004] & B, u[691005] = A[691005] & B, u[691006] = A[691006] & B, u[691007] = A[691007] & B, u[691008] = A[691008] & B, u[691009] = A[691009] & B, u[691010] = A[691010] & B, u[691011] = A[691011] & B, u[691012] = A[691012] & B, u[691013] = A[691013] & B, u[691014] = A[691014] & B, u[691015] = A[691015] & B, u[691016] = A[691016] & B, u[691017] = A[691017] & B, u[691018] = A[691018] & B, u[691019] = A[691019] & B, u[691020] = A[691020] & B, u[691021] = A[691021] & B, u[691022] = A[691022] & B, u[691023] = A[691023] & B, u[691024] = A[691024] & B, u[691025] = A[691025] & B, u[691026] = A[691026] & B, u[691027] = A[691027] & B, u[691028] = A[691028] & B, u[691029] = A[691029] & B, u[691030] = A[691030] & B, u[691031] = A[691031] & B, u[691032] = A[691032] & B, u[691033] = A[691033] & B, u[691034] = A[691034] & B, u[691035] = A[691035] & B, u[691036] = A[691036] & B, u[691037] = A[691037] & B, u[691038] = A[691038] & B, u[691039] = A[691039] & B, u[691040] = A[691040] & B, u[691041] = A[691041] & B, u[691042] = A[691042] & B, u[691043] = A[691043] & B, u[691044] = A[691044] & B, B = o + 408 | 0, m = B + 24 | 0, a[m >> 2] = 0, a[m + 4 >> 2] = 0, m = B + 16 | 0, a[m >> 2] = 0, a[m + 4 >> 2] = 0, B = B + 8 | 0, a[B >> 2] = 0, a[B + 4 >> 2] = 0, a[o + 408 >> 2] = 0, a[o + 412 >> 2] = 0, B = Fr + 24 | 0, a[B >> 2] = 0, a[B + 4 >> 2] = 0, B = Fr + 16 | 0, a[B >> 2] = 0, a[B + 4 >> 2] = 0, B = Fr + 8 | 0, a[B >> 2] = 0, a[B + 4 >> 2] = 0, a[o + 472 >> 2] = 0, a[o + 476 >> 2] = 0, B = o + 24 | 0, a[B >> 2] = 0, a[B + 4 >> 2] = 0, B = o + 16 | 0, a[B >> 2] = 0, a[B + 4 >> 2] = 0, a[o + 8 >> 2] = 0, a[o + 12 >> 2] = 0, a[o >> 2] = 0, a[o + 4 >> 2] = 0;
          }
          if (be = o + 640 | 0, a[Be + 100 >> 2] = un, un)
            break t;
          break e;
        }
        break e;
      }
      be = Be + 128 | 0;
      return;
    }
    a[Be + 112 >> 2] = 0, ar(Be + 104 | 0), wasm2js_trap();
  }
  function Zi(B, o) {
    B = B | 0, o = o | 0;
    var m = 0, d = 0, v = 0, he = 0, we = 0, Be = 0, Me = 0, fr = 0, wr = 0, dr = 0, Dr = 0, Rr = 0, Qe = 0, Fr = 0, Gr = 0, $r = 0, ni = 0, mi = 0, Si = 0, Oi = 0, $i = 0, zi = 0, un = 0, In = 0, Ti = 0, Sn = 0, Kn = 0, Vn = 0, Xn = 0, uo = 0, yo = 0, Io = 0, xo = 0, Mo = 0, qi = 0, Oo = 0;
    he = be - 192 | 0, be = he, v = he + 128 | 0, we = v + 56 | 0, a[we >> 2] = 0, a[we + 4 >> 2] = 0, Be = v + 48 | 0, a[Be >> 2] = 0, a[Be + 4 >> 2] = 0, Me = v + 40 | 0, a[Me >> 2] = 0, a[Me + 4 >> 2] = 0, Dr = v + 32 | 0, a[Dr >> 2] = 0, a[Dr + 4 >> 2] = 0, fr = v + 24 | 0, a[fr >> 2] = 0, a[fr + 4 >> 2] = 0, dr = v + 16 | 0, a[dr >> 2] = 0, a[dr + 4 >> 2] = 0, $r = v + 8 | 0, a[$r >> 2] = 0, a[$r + 4 >> 2] = 0, a[he + 128 >> 2] = 0, a[he + 132 >> 2] = 0;
    e: {
      if ((On(a[172688], v, 690820, B) | 0) == 1) {
        v = he + 128 | 0, B = v + 15 | 0, m = A[B + 4 | 0] | A[B + 5 | 0] << 8 | (A[B + 6 | 0] << 16 | A[B + 7 | 0] << 24), d = he - -64 | 0, wr = d + 8 | 0, a[wr >> 2] = A[B | 0] | A[B + 1 | 0] << 8 | (A[B + 2 | 0] << 16 | A[B + 3 | 0] << 24), a[wr + 4 >> 2] = m, B = v + 23 | 0, m = A[B + 4 | 0] | A[B + 5 | 0] << 8 | (A[B + 6 | 0] << 16 | A[B + 7 | 0] << 24), Qe = d + 16 | 0, a[Qe >> 2] = A[B | 0] | A[B + 1 | 0] << 8 | (A[B + 2 | 0] << 16 | A[B + 3 | 0] << 24), a[Qe + 4 >> 2] = m, B = v + 31 | 0, m = A[B + 4 | 0] | A[B + 5 | 0] << 8 | (A[B + 6 | 0] << 16 | A[B + 7 | 0] << 24), Gr = d + 24 | 0, a[Gr >> 2] = A[B | 0] | A[B + 1 | 0] << 8 | (A[B + 2 | 0] << 16 | A[B + 3 | 0] << 24), a[Gr + 4 >> 2] = m, B = v + 39 | 0, m = A[B + 4 | 0] | A[B + 5 | 0] << 8 | (A[B + 6 | 0] << 16 | A[B + 7 | 0] << 24), Fr = d + 32 | 0, a[Fr >> 2] = A[B | 0] | A[B + 1 | 0] << 8 | (A[B + 2 | 0] << 16 | A[B + 3 | 0] << 24), a[Fr + 4 >> 2] = m, B = v + 47 | 0, m = A[B + 4 | 0] | A[B + 5 | 0] << 8 | (A[B + 6 | 0] << 16 | A[B + 7 | 0] << 24), Rr = d + 40 | 0, a[Rr >> 2] = A[B | 0] | A[B + 1 | 0] << 8 | (A[B + 2 | 0] << 16 | A[B + 3 | 0] << 24), a[Rr + 4 >> 2] = m, B = v + 55 | 0, m = A[B + 4 | 0] | A[B + 5 | 0] << 8 | (A[B + 6 | 0] << 16 | A[B + 7 | 0] << 24), ni = d + 48 | 0, a[ni >> 2] = A[B | 0] | A[B + 1 | 0] << 8 | (A[B + 2 | 0] << 16 | A[B + 3 | 0] << 24), a[ni + 4 >> 2] = m, d = d + 56 | 0, u[d | 0] = A[v + 63 | 0], u[he + 2 | 0] = A[he + 130 | 0], p[he >> 1] = b[he + 128 >> 1], B = A[he + 139 | 0] | A[he + 140 | 0] << 8 | (A[he + 141 | 0] << 16 | A[he + 142 | 0] << 24), a[he + 64 >> 2] = A[he + 135 | 0] | A[he + 136 | 0] << 8 | (A[he + 137 | 0] << 16 | A[he + 138 | 0] << 24), a[he + 68 >> 2] = B, B = A[he + 131 | 0] | A[he + 132 | 0] << 8 | (A[he + 133 | 0] << 16 | A[he + 134 | 0] << 24), u[he + 63 | 0] = A[d | 0], m = a[ni + 4 >> 2], d = he + 55 | 0, ni = a[ni >> 2], u[d | 0] = ni, u[d + 1 | 0] = ni >>> 8, u[d + 2 | 0] = ni >>> 16, u[d + 3 | 0] = ni >>> 24, u[d + 4 | 0] = m, u[d + 5 | 0] = m >>> 8, u[d + 6 | 0] = m >>> 16, u[d + 7 | 0] = m >>> 24, m = a[Rr + 4 >> 2], d = he + 47 | 0, Rr = a[Rr >> 2], u[d | 0] = Rr, u[d + 1 | 0] = Rr >>> 8, u[d + 2 | 0] = Rr >>> 16, u[d + 3 | 0] = Rr >>> 24, u[d + 4 | 0] = m, u[d + 5 | 0] = m >>> 8, u[d + 6 | 0] = m >>> 16, u[d + 7 | 0] = m >>> 24, m = a[Fr + 4 >> 2], d = he + 39 | 0, Fr = a[Fr >> 2], u[d | 0] = Fr, u[d + 1 | 0] = Fr >>> 8, u[d + 2 | 0] = Fr >>> 16, u[d + 3 | 0] = Fr >>> 24, u[d + 4 | 0] = m, u[d + 5 | 0] = m >>> 8, u[d + 6 | 0] = m >>> 16, u[d + 7 | 0] = m >>> 24, m = a[Gr + 4 >> 2], d = he + 31 | 0, Gr = a[Gr >> 2], u[d | 0] = Gr, u[d + 1 | 0] = Gr >>> 8, u[d + 2 | 0] = Gr >>> 16, u[d + 3 | 0] = Gr >>> 24, u[d + 4 | 0] = m, u[d + 5 | 0] = m >>> 8, u[d + 6 | 0] = m >>> 16, u[d + 7 | 0] = m >>> 24, m = a[Qe + 4 >> 2], d = he + 23 | 0, Qe = a[Qe >> 2], u[d | 0] = Qe, u[d + 1 | 0] = Qe >>> 8, u[d + 2 | 0] = Qe >>> 16, u[d + 3 | 0] = Qe >>> 24, u[d + 4 | 0] = m, u[d + 5 | 0] = m >>> 8, u[d + 6 | 0] = m >>> 16, u[d + 7 | 0] = m >>> 24, m = a[wr + 4 >> 2], d = he + 15 | 0, wr = a[wr >> 2], u[d | 0] = wr, u[d + 1 | 0] = wr >>> 8, u[d + 2 | 0] = wr >>> 16, u[d + 3 | 0] = wr >>> 24, u[d + 4 | 0] = m, u[d + 5 | 0] = m >>> 8, u[d + 6 | 0] = m >>> 16, u[d + 7 | 0] = m >>> 24, u[he + 3 | 0] = B, u[he + 4 | 0] = B >>> 8, u[he + 5 | 0] = B >>> 16, u[he + 6 | 0] = B >>> 24, B = a[he + 68 >> 2], d = a[he + 64 >> 2], u[he + 7 | 0] = d, u[he + 8 | 0] = d >>> 8, u[he + 9 | 0] = d >>> 16, u[he + 10 | 0] = d >>> 24, u[he + 11 | 0] = B, u[he + 12 | 0] = B >>> 8, u[he + 13 | 0] = B >>> 16, u[he + 14 | 0] = B >>> 24, a[we >> 2] = 0, a[we + 4 >> 2] = 0, a[Be >> 2] = 0, a[Be + 4 >> 2] = 0, a[Me >> 2] = 0, a[Me + 4 >> 2] = 0, a[Dr >> 2] = 0, a[Dr + 4 >> 2] = 0, a[fr >> 2] = 0, a[fr + 4 >> 2] = 0, a[dr >> 2] = 0, a[dr + 4 >> 2] = 0, a[$r >> 2] = 0, a[$r + 4 >> 2] = 0, a[he + 128 >> 2] = 0, a[he + 132 >> 2] = 0, d = 0, we = a[172688], m = 0, B = be - 80 | 0, be = B, a[B + 12 >> 2] = 0;
        t: {
          if (!v) {
            ji[a[we + 168 >> 2]](689748, a[we + 172 >> 2]);
            break t;
          }
          if (m = B + 12 | 0, Rn(B + 48 | 0, 690981, m), we = a[B + 12 >> 2], Rn(B + 16 | 0, 691013, m), !(we | a[B + 12 >> 2])) {
            m = a[B + 52 >> 2], we = a[B + 48 >> 2], u[v | 0] = we, u[v + 1 | 0] = we >>> 8, u[v + 2 | 0] = we >>> 16, u[v + 3 | 0] = we >>> 24, u[v + 4 | 0] = m, u[v + 5 | 0] = m >>> 8, u[v + 6 | 0] = m >>> 16, u[v + 7 | 0] = m >>> 24, m = a[B + 20 >> 2], we = a[B + 16 >> 2], u[v + 32 | 0] = we, u[v + 33 | 0] = we >>> 8, u[v + 34 | 0] = we >>> 16, u[v + 35 | 0] = we >>> 24, u[v + 36 | 0] = m, u[v + 37 | 0] = m >>> 8, u[v + 38 | 0] = m >>> 16, u[v + 39 | 0] = m >>> 24, Me = B + 48 | 0, Be = Me + 24 | 0, we = a[Be + 4 >> 2], m = v + 24 | 0, Be = a[Be >> 2], u[m | 0] = Be, u[m + 1 | 0] = Be >>> 8, u[m + 2 | 0] = Be >>> 16, u[m + 3 | 0] = Be >>> 24, u[m + 4 | 0] = we, u[m + 5 | 0] = we >>> 8, u[m + 6 | 0] = we >>> 16, u[m + 7 | 0] = we >>> 24, Be = Me + 16 | 0, we = a[Be + 4 >> 2], m = v + 16 | 0, Be = a[Be >> 2], u[m | 0] = Be, u[m + 1 | 0] = Be >>> 8, u[m + 2 | 0] = Be >>> 16, u[m + 3 | 0] = Be >>> 24, u[m + 4 | 0] = we, u[m + 5 | 0] = we >>> 8, u[m + 6 | 0] = we >>> 16, u[m + 7 | 0] = we >>> 24, Be = Me + 8 | 0, we = a[Be + 4 >> 2], m = v + 8 | 0, Be = a[Be >> 2], u[m | 0] = Be, u[m + 1 | 0] = Be >>> 8, u[m + 2 | 0] = Be >>> 16, u[m + 3 | 0] = Be >>> 24, u[m + 4 | 0] = we, u[m + 5 | 0] = we >>> 8, u[m + 6 | 0] = we >>> 16, u[m + 7 | 0] = we >>> 24, Me = B + 16 | 0, Be = Me + 8 | 0, we = a[Be + 4 >> 2], m = v + 40 | 0, Be = a[Be >> 2], u[m | 0] = Be, u[m + 1 | 0] = Be >>> 8, u[m + 2 | 0] = Be >>> 16, u[m + 3 | 0] = Be >>> 24, u[m + 4 | 0] = we, u[m + 5 | 0] = we >>> 8, u[m + 6 | 0] = we >>> 16, u[m + 7 | 0] = we >>> 24, Be = Me + 16 | 0, we = a[Be + 4 >> 2], m = v + 48 | 0, Be = a[Be >> 2], u[m | 0] = Be, u[m + 1 | 0] = Be >>> 8, u[m + 2 | 0] = Be >>> 16, u[m + 3 | 0] = Be >>> 24, u[m + 4 | 0] = we, u[m + 5 | 0] = we >>> 8, u[m + 6 | 0] = we >>> 16, u[m + 7 | 0] = we >>> 24, we = Me + 24 | 0, m = a[we + 4 >> 2], v = v + 56 | 0, we = a[we >> 2], u[v | 0] = we, u[v + 1 | 0] = we >>> 8, u[v + 2 | 0] = we >>> 16, u[v + 3 | 0] = we >>> 24, u[v + 4 | 0] = m, u[v + 5 | 0] = m >>> 8, u[v + 6 | 0] = m >>> 16, u[v + 7 | 0] = m >>> 24, m = 1;
            break t;
          }
          u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, m = v + 56 | 0, u[m | 0] = 0, u[m + 1 | 0] = 0, u[m + 2 | 0] = 0, u[m + 3 | 0] = 0, u[m + 4 | 0] = 0, u[m + 5 | 0] = 0, u[m + 6 | 0] = 0, u[m + 7 | 0] = 0, m = v + 48 | 0, u[m | 0] = 0, u[m + 1 | 0] = 0, u[m + 2 | 0] = 0, u[m + 3 | 0] = 0, u[m + 4 | 0] = 0, u[m + 5 | 0] = 0, u[m + 6 | 0] = 0, u[m + 7 | 0] = 0, m = v + 40 | 0, u[m | 0] = 0, u[m + 1 | 0] = 0, u[m + 2 | 0] = 0, u[m + 3 | 0] = 0, u[m + 4 | 0] = 0, u[m + 5 | 0] = 0, u[m + 6 | 0] = 0, u[m + 7 | 0] = 0, m = v + 32 | 0, u[m | 0] = 0, u[m + 1 | 0] = 0, u[m + 2 | 0] = 0, u[m + 3 | 0] = 0, u[m + 4 | 0] = 0, u[m + 5 | 0] = 0, u[m + 6 | 0] = 0, u[m + 7 | 0] = 0, m = v + 24 | 0, u[m | 0] = 0, u[m + 1 | 0] = 0, u[m + 2 | 0] = 0, u[m + 3 | 0] = 0, u[m + 4 | 0] = 0, u[m + 5 | 0] = 0, u[m + 6 | 0] = 0, u[m + 7 | 0] = 0, m = v + 16 | 0, u[m | 0] = 0, u[m + 1 | 0] = 0, u[m + 2 | 0] = 0, u[m + 3 | 0] = 0, u[m + 4 | 0] = 0, u[m + 5 | 0] = 0, u[m + 6 | 0] = 0, u[m + 7 | 0] = 0, v = v + 8 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, m = 0;
        }
        if (be = B + 80 | 0, !m) {
          Ee(4);
          break e;
        }
        if (!o)
          t: {
            if (B = a[172688], m = he + 128 | 0, !m) {
              ji[a[B + 168 >> 2]](689716, a[B + 172 >> 2]);
              break t;
            }
            o = A[m + 60 | 0] | A[m + 61 | 0] << 8 | (A[m + 62 | 0] << 16 | A[m + 63 | 0] << 24), Dr = o, o = o >>> 31 | 0, d = o ^ -1, fr = A[m + 44 | 0] | A[m + 45 | 0] << 8 | (A[m + 46 | 0] << 16 | A[m + 47 | 0] << 24), v = (fr | 0) == 1566010995, dr = A[m + 40 | 0] | A[m + 41 | 0] << 8 | (A[m + 42 | 0] << 16 | A[m + 43 | 0] << 24), wr = A[m + 48 | 0] | A[m + 49 | 0] << 8 | (A[m + 50 | 0] << 16 | A[m + 51 | 0] << 24), Qe = A[m + 52 | 0] | A[m + 53 | 0] << 8 | (A[m + 54 | 0] << 16 | A[m + 55 | 0] << 24), B = A[m + 56 | 0] | A[m + 57 | 0] << 8 | (A[m + 58 | 0] << 16 | A[m + 59 | 0] << 24), d = (d & (v & dr >>> 0 < 1470386205 | fr >>> 0 < 1566010995) | (d & (wr & Qe) != -1 | ((Dr | 0) == 2147483647 & (B | 0) != -1 | Dr >>> 0 < 2147483647))) ^ -1, $r = A[m + 36 | 0] | A[m + 37 | 0] << 8 | (A[m + 38 | 0] << 16 | A[m + 39 | 0] << 24), Gr = A[m + 32 | 0] | A[m + 33 | 0] << 8 | (A[m + 34 | 0] << 16 | A[m + 35 | 0] << 24), o = d & (($r | 0) == -538366138 & Gr >>> 0 > 1746608288 | $r >>> 0 > 3756601158) | (d & (v & dr >>> 0 > 1470386205 | fr >>> 0 > 1566010995) | o), m && (o && (o = Gr ^ -1, v = o - 801750718 | 0, Rr = v, d = $r ^ -1, Be = d - ((o >>> 0 < 801750718) + 1076732275 | 0) | 0, v = (d | 0) == (Be | 0) & o >>> 0 > v >>> 0 | d >>> 0 > Be >>> 0, Fr = dr ^ -1, o = v + Fr | 0, d = fr ^ -1, we = o >>> 0 < v >>> 0 ? d + 1 | 0 : d, v = o - 1354194885 | 0, ni = v, mi = wr ^ -1, d = (d | 0) == (we | 0) & o >>> 0 < Fr >>> 0 | d >>> 0 > we >>> 0, Fr = we - ((o >>> 0 < 1354194885) + 1162945305 | 0) | 0, v = (Fr | 0) == (we | 0) & o >>> 0 > v >>> 0 | we >>> 0 > Fr >>> 0, o = d + v | 0, Me = Qe ^ -1, d = Me + (o >>> 0 < v >>> 0) | 0, v = o + mi | 0, d = v >>> 0 < o >>> 0 ? d + 1 | 0 : d, we = v - 2 | 0, Si = we, o = dr | Gr | wr | B | (fr | $r | Qe | Dr) ? -1 : 0, Qe = (d | 0) == (Me | 0) & v >>> 0 < mi >>> 0 | d >>> 0 < Me >>> 0, Me = d - (v >>> 0 < 2) | 0, d = (Me | 0) == (d | 0) & v >>> 0 > we >>> 0 | d >>> 0 > Me >>> 0, v = Qe + d | 0, we = d >>> 0 > v >>> 0, d = B, fr = v - d | 0, B = fr - 2 & o, Dr = o & (we - ((d >>> 0 > v >>> 0) + Dr | 0) | 0) - (fr >>> 0 < 2), d = o, wr = d & Si, Qe = d & Me, Gr = d & Rr, $r = d & Be, dr = d & ni, fr = d & Fr), we = m + 8 | 0, Fr = A[we | 0] | A[we + 1 | 0] << 8 | (A[we + 2 | 0] << 16 | A[we + 3 | 0] << 24), d = A[we + 4 | 0] | A[we + 5 | 0] << 8 | (A[we + 6 | 0] << 16 | A[we + 7 | 0] << 24), Be = m + 16 | 0, Rr = A[Be | 0] | A[Be + 1 | 0] << 8 | (A[Be + 2 | 0] << 16 | A[Be + 3 | 0] << 24), o = A[Be + 4 | 0] | A[Be + 5 | 0] << 8 | (A[Be + 6 | 0] << 16 | A[Be + 7 | 0] << 24), ni = A[m | 0] | A[m + 1 | 0] << 8 | (A[m + 2 | 0] << 16 | A[m + 3 | 0] << 24), v = A[m + 4 | 0] | A[m + 5 | 0] << 8 | (A[m + 6 | 0] << 16 | A[m + 7 | 0] << 24), Me = m + 24 | 0, mi = A[Me + 4 | 0] | A[Me + 5 | 0] << 8 | (A[Me + 6 | 0] << 16 | A[Me + 7 | 0] << 24), Si = A[Me | 0] | A[Me + 1 | 0] << 8 | (A[Me + 2 | 0] << 16 | A[Me + 3 | 0] << 24), u[Me | 0] = Si, u[Me + 1 | 0] = Si >>> 8, u[Me + 2 | 0] = Si >>> 16, u[Me + 3 | 0] = Si >>> 24, u[Me + 4 | 0] = mi, u[Me + 5 | 0] = mi >>> 8, u[Me + 6 | 0] = mi >>> 16, u[Me + 7 | 0] = mi >>> 24, u[Be | 0] = Rr, u[Be + 1 | 0] = Rr >>> 8, u[Be + 2 | 0] = Rr >>> 16, u[Be + 3 | 0] = Rr >>> 24, u[Be + 4 | 0] = o, u[Be + 5 | 0] = o >>> 8, u[Be + 6 | 0] = o >>> 16, u[Be + 7 | 0] = o >>> 24, u[we | 0] = Fr, u[we + 1 | 0] = Fr >>> 8, u[we + 2 | 0] = Fr >>> 16, u[we + 3 | 0] = Fr >>> 24, u[we + 4 | 0] = d, u[we + 5 | 0] = d >>> 8, u[we + 6 | 0] = d >>> 16, u[we + 7 | 0] = d >>> 24, u[m | 0] = ni, u[m + 1 | 0] = ni >>> 8, u[m + 2 | 0] = ni >>> 16, u[m + 3 | 0] = ni >>> 24, u[m + 4 | 0] = v, u[m + 5 | 0] = v >>> 8, u[m + 6 | 0] = v >>> 16, u[m + 7 | 0] = v >>> 24, u[m + 56 | 0] = B, u[m + 57 | 0] = B >>> 8, u[m + 58 | 0] = B >>> 16, u[m + 59 | 0] = B >>> 24, u[m + 60 | 0] = Dr, u[m + 61 | 0] = Dr >>> 8, u[m + 62 | 0] = Dr >>> 16, u[m + 63 | 0] = Dr >>> 24, u[m + 48 | 0] = wr, u[m + 49 | 0] = wr >>> 8, u[m + 50 | 0] = wr >>> 16, u[m + 51 | 0] = wr >>> 24, u[m + 52 | 0] = Qe, u[m + 53 | 0] = Qe >>> 8, u[m + 54 | 0] = Qe >>> 16, u[m + 55 | 0] = Qe >>> 24, u[m + 40 | 0] = dr, u[m + 41 | 0] = dr >>> 8, u[m + 42 | 0] = dr >>> 16, u[m + 43 | 0] = dr >>> 24, u[m + 44 | 0] = fr, u[m + 45 | 0] = fr >>> 8, u[m + 46 | 0] = fr >>> 16, u[m + 47 | 0] = fr >>> 24, u[m + 32 | 0] = Gr, u[m + 33 | 0] = Gr >>> 8, u[m + 34 | 0] = Gr >>> 16, u[m + 35 | 0] = Gr >>> 24, u[m + 36 | 0] = $r, u[m + 37 | 0] = $r >>> 8, u[m + 38 | 0] = $r >>> 16, u[m + 39 | 0] = $r >>> 24);
          }
        Rr = yr(), B = 0, o = be - 464 | 0, be = o, d = he + 128 | 0;
        t: {
          if (!d) {
            ji[a[Rr + 168 >> 2]](689748, a[Rr + 172 >> 2]);
            break t;
          }
          if (!he) {
            ji[a[Rr + 168 >> 2]](689638, a[Rr + 172 >> 2]);
            break t;
          }
          if (Rn(o + 8 | 0, 655649, 0), v = d + 24 | 0, we = A[v + 4 | 0] | A[v + 5 | 0] << 8 | (A[v + 6 | 0] << 16 | A[v + 7 | 0] << 24), m = o + 40 | 0, Be = m + 24 | 0, a[Be >> 2] = A[v | 0] | A[v + 1 | 0] << 8 | (A[v + 2 | 0] << 16 | A[v + 3 | 0] << 24), a[Be + 4 >> 2] = we, v = d + 16 | 0, we = A[v + 4 | 0] | A[v + 5 | 0] << 8 | (A[v + 6 | 0] << 16 | A[v + 7 | 0] << 24), Be = m + 16 | 0, a[Be >> 2] = A[v | 0] | A[v + 1 | 0] << 8 | (A[v + 2 | 0] << 16 | A[v + 3 | 0] << 24), a[Be + 4 >> 2] = we, v = d + 8 | 0, we = A[v + 4 | 0] | A[v + 5 | 0] << 8 | (A[v + 6 | 0] << 16 | A[v + 7 | 0] << 24), m = m + 8 | 0, a[m >> 2] = A[v | 0] | A[v + 1 | 0] << 8 | (A[v + 2 | 0] << 16 | A[v + 3 | 0] << 24), a[m + 4 >> 2] = we, v = A[d + 4 | 0] | A[d + 5 | 0] << 8 | (A[d + 6 | 0] << 16 | A[d + 7 | 0] << 24), a[o + 40 >> 2] = A[d | 0] | A[d + 1 | 0] << 8 | (A[d + 2 | 0] << 16 | A[d + 3 | 0] << 24), a[o + 44 >> 2] = v, we = A[d + 36 | 0] | A[d + 37 | 0] << 8 | (A[d + 38 | 0] << 16 | A[d + 39 | 0] << 24), Oi = A[d + 32 | 0] | A[d + 33 | 0] << 8 | (A[d + 34 | 0] << 16 | A[d + 35 | 0] << 24), v = A[d + 60 | 0] | A[d + 61 | 0] << 8 | (A[d + 62 | 0] << 16 | A[d + 63 | 0] << 24), Me = v >>> 31 | 0, wr = Me ^ -1, m = A[d + 44 | 0] | A[d + 45 | 0] << 8 | (A[d + 46 | 0] << 16 | A[d + 47 | 0] << 24), dr = (m | 0) == 1566010995, Be = A[d + 40 | 0] | A[d + 41 | 0] << 8 | (A[d + 42 | 0] << 16 | A[d + 43 | 0] << 24), $r = A[d + 48 | 0] | A[d + 49 | 0] << 8 | (A[d + 50 | 0] << 16 | A[d + 51 | 0] << 24), fr = A[d + 52 | 0] | A[d + 53 | 0] << 8 | (A[d + 54 | 0] << 16 | A[d + 55 | 0] << 24), Dr = A[d + 56 | 0] | A[d + 57 | 0] << 8 | (A[d + 58 | 0] << 16 | A[d + 59 | 0] << 24), d = (wr & (dr & Be >>> 0 < 1470386205 | m >>> 0 < 1566010995) | (wr & ($r & fr) != -1 | ((v | 0) == 2147483647 & (Dr | 0) != -1 | v >>> 0 < 2147483647))) ^ -1, ((we | 0) == -538366138 & Oi >>> 0 > 1746608288 | we >>> 0 > 3756601158) & d | (d & (dr & Be >>> 0 > 1470386205 | m >>> 0 > 1566010995) | Me))
            break t;
          if (d = A[he + 12 | 0] | A[he + 13 | 0] << 8 | (A[he + 14 | 0] << 16 | A[he + 15 | 0] << 24), dr = d, Me = A[he + 8 | 0] | A[he + 9 | 0] << 8 | (A[he + 10 | 0] << 16 | A[he + 11 | 0] << 24), wr = (d << 12 | Me >>> 20) & 1048575, Qe = A[he + 4 | 0] | A[he + 5 | 0] << 8 | (A[he + 6 | 0] << 16 | A[he + 7 | 0] << 24), ni = Qe, $i = Me << 12 & -4096 | Qe >>> 20, zi = wr, Me = A[he + 16 | 0] | A[he + 17 | 0] << 8 | (A[he + 18 | 0] << 16 | A[he + 19 | 0] << 24), mi = Me, d = A[he + 20 | 0] | A[he + 21 | 0] << 8 | (A[he + 22 | 0] << 16 | A[he + 23 | 0] << 24), Fr = d, wr = (d << 24 | Me >>> 8) & 1048575, un = Me << 24 & -16777216 | dr >>> 8, In = wr, dr = A[he + 28 | 0] | A[he + 29 | 0] << 8 | (A[he + 30 | 0] << 16 | A[he + 31 | 0] << 24), d = dr >>> 16 | 0, Me = A[he + 24 | 0] | A[he + 25 | 0] << 8 | (A[he + 26 | 0] << 16 | A[he + 27 | 0] << 24), wr = (dr & 65535) << 16 | Me >>> 16, Qe = d, dr = Me << 4 & 1048560, Me = Fr, d = Me >>> 28 | 0, Ti = (Me & 268435455) << 4 | mi >>> 28, Sn = A[he | 0] | A[he + 1 | 0] << 8 | (A[he + 2 | 0] << 16 | A[he + 3 | 0] << 24), Kn = d | dr, Vn = ni & 1048575, !(Ti | (un | (wr | ($i | Sn))) | (Kn | (In | (Qe | (zi | Vn)))))) {
            ji[a[Rr + 168 >> 2]](690116, a[Rr + 172 >> 2]);
            break t;
          }
          if (dr = a[o + 64 >> 2], Gr = a[o + 56 >> 2], Xn = a[o + 48 >> 2], uo = a[o + 40 >> 2], Me = a[o + 68 >> 2], ni = a[o + 60 >> 2], Fr = a[o + 52 >> 2], Rr = a[o + 44 >> 2], !(dr | (Gr | (Xn | uo)) | (Me | (ni | (Fr | Rr)))) || !(Be | Oi | $r | Dr | (m | we | fr | v)) || (mi = A[he + 48 | 0] | A[he + 49 | 0] << 8 | (A[he + 50 | 0] << 16 | A[he + 51 | 0] << 24), Si = A[he + 52 | 0] | A[he + 53 | 0] << 8 | (A[he + 54 | 0] << 16 | A[he + 55 | 0] << 24), yo = A[he + 56 | 0] | A[he + 57 | 0] << 8 | (A[he + 58 | 0] << 16 | A[he + 59 | 0] << 24), xo = A[he + 60 | 0] | A[he + 61 | 0] << 8 | (A[he + 62 | 0] << 16 | A[he + 63 | 0] << 24), Mo = A[he + 40 | 0] | A[he + 41 | 0] << 8 | (A[he + 42 | 0] << 16 | A[he + 43 | 0] << 24), qi = A[he + 44 | 0] | A[he + 45 | 0] << 8 | (A[he + 46 | 0] << 16 | A[he + 47 | 0] << 24), Oo = A[he + 32 | 0] | A[he + 33 | 0] << 8 | (A[he + 34 | 0] << 16 | A[he + 35 | 0] << 24), Io = A[he + 36 | 0] | A[he + 37 | 0] << 8 | (A[he + 38 | 0] << 16 | A[he + 39 | 0] << 24), a[o + 232 >> 2] = v >>> 24, a[o + 236 >> 2] = 0, a[o + 200 >> 2] = Oi, a[o + 204 >> 2] = we & 1073741823, d = v << 6 | Dr >>> 26, v = fr, a[o + 224 >> 2] = Dr << 6 | v >>> 26, a[o + 228 >> 2] = d & 1073741823, d = v << 4 | $r >>> 28, a[o + 216 >> 2] = $r << 4 | m >>> 28, a[o + 220 >> 2] = d & 1073741823, m = m << 2 | Be >>> 30, a[o + 208 >> 2] = Be << 2 | we >>> 30, a[o + 212 >> 2] = m & 1073741823, Dr = o + 200 | 0, Hi(Dr, 690320), m = a[o + 232 >> 2] << 24, Be = a[o + 228 >> 2], d = Be >>> 6 | 0, we = a[o + 224 >> 2], a[o + 456 >> 2] = (Be & 63) << 26 | we >>> 6, a[o + 460 >> 2] = m | d, m = we << 26, Be = a[o + 220 >> 2], d = Be >>> 4 | 0, we = a[o + 216 >> 2], a[o + 448 >> 2] = (Be & 15) << 28 | we >>> 4, a[o + 452 >> 2] = m | d, m = we << 28, Be = a[o + 212 >> 2], d = Be >>> 2 | 0, we = a[o + 208 >> 2], a[o + 440 >> 2] = (Be & 3) << 30 | we >>> 2, a[o + 444 >> 2] = m | d, m = a[o + 204 >> 2], d = we << 30, a[o + 432 >> 2] = a[o + 200 >> 2], a[o + 436 >> 2] = m | d, we = o + 400 | 0, d = o + 432 | 0, di(we, d, o + 8 | 0), Be = o + 368 | 0, di(Be, d, o + 40 | 0), d = o + 288 | 0, a[d >> 2] = 0, a[d + 4 >> 2] = 0, v = xo, d = v >>> 16 | 0, m = o + 272 | 0, a[m >> 2] = (v & 65535) << 16 | yo >>> 16, a[m + 4 >> 2] = d, fr = yo << 4 & 1048560, v = Si, d = v >>> 28 | 0, m = o + 264 | 0, a[m >> 2] = (v & 268435455) << 4 | mi >>> 28, a[m + 4 >> 2] = d | fr, d = v << 24 | mi >>> 8, m = o + 256 | 0, v = qi, a[m >> 2] = mi << 24 & -16777216 | v >>> 8, a[m + 4 >> 2] = d & 1048575, d = v << 12, v = Mo, fr = (d | v >>> 20) & 1048575, m = o + 248 | 0, a[m >> 2] = v << 12 & -4096 | Io >>> 20, a[m + 4 >> 2] = fr, d = o + 296 | 0, a[d >> 2] = 0, a[d + 4 >> 2] = 0, d = o + 304 | 0, a[d >> 2] = 0, a[d + 4 >> 2] = 0, d = o + 312 | 0, a[d >> 2] = 0, a[d + 4 >> 2] = 0, a[o + 280 >> 2] = 1, a[o + 284 >> 2] = 0, a[o + 240 >> 2] = Oo, a[o + 244 >> 2] = Io & 1048575, a[o + 232 >> 2] = wr, a[o + 236 >> 2] = Qe, a[o + 224 >> 2] = Ti, a[o + 228 >> 2] = Kn, a[o + 216 >> 2] = un, a[o + 220 >> 2] = In, a[o + 208 >> 2] = $i, a[o + 212 >> 2] = zi, a[o + 200 >> 2] = Sn, a[o + 204 >> 2] = Vn, a[o + 320 >> 2] = 0, Ui(o + 72 | 0, Dr, Be, we), a[o + 192 >> 2]) || (B = Me, d = B >>> 16 | 0, a[o + 360 >> 2] = (B & 65535) << 16 | dr >>> 16, a[o + 364 >> 2] = d, v = uo, a[o + 328 >> 2] = v, Me = Rr & 1048575, a[o + 332 >> 2] = Me, m = B, B = ni, d = dr << 4 & 1048560 | B >>> 28, $r = d, wr = (B & 268435455) << 4 | Gr >>> 28, a[o + 352 >> 2] = wr, a[o + 356 >> 2] = d, d = B << 24 | Gr >>> 8, B = Fr, Dr = Gr << 24 & -16777216 | B >>> 8, a[o + 344 >> 2] = Dr, we = d & 1048575, a[o + 348 >> 2] = we, d = B << 12, B = Xn, Be = (d | B >>> 20) & 1048575, fr = B << 12 & -4096 | Rr >>> 20, a[o + 336 >> 2] = fr, a[o + 340 >> 2] = Be, B = 1, ln(o + 328 | 0, o + 72 | 0)))
            break t;
          if (m | !m & dr >>> 0 > 65535) {
            B = 0;
            break t;
          }
          if (wr | $r) {
            B = 0;
            break t;
          }
          if (we | !we & Dr >>> 0 > 21319971) {
            B = 0;
            break t;
          }
          r: {
            if (we | (Dr | 0) != 21319971)
              break r;
            if ((Be | 0) == 103691 & fr >>> 0 > 1979466754 | Be >>> 0 > 103691) {
              B = 0;
              break t;
            }
            if ((fr | 0) != 1979466754 | (Be | 0) != 103691)
              break r;
            if (B = 0, (Me | 0) == 893298 & v >>> 0 > 801749741 | Me >>> 0 > 893298)
              break t;
          }
          a[o + 360 >> 2] = -1, a[o + 364 >> 2] = 65535, a[o + 352 >> 2] = -1, a[o + 356 >> 2] = 1048575, d = we + 1048575 | 0, B = Dr - 21319972 | 0, d = B >>> 0 < 4273647324 ? d + 1 | 0 : d, a[o + 344 >> 2] = B, a[o + 348 >> 2] = d, d = Be + 944884 | 0, m = fr - 1979466755 | 0, d = m >>> 0 < 2315500541 ? d + 1 | 0 : d, a[o + 336 >> 2] = m, a[o + 340 >> 2] = d, we = Me + 155276 | 0, B = v - 801750719 | 0, we = B >>> 0 < 3493216577 ? we + 1 | 0 : we, a[o + 328 >> 2] = B, a[o + 332 >> 2] = we, B = (ln(o + 328 | 0, o + 72 | 0) | 0) != 0;
        }
        be = o + 464 | 0, d = B;
        break e;
      }
      Ee(1);
    }
    return be = he + 192 | 0, d | 0;
  }
  function Wr(B, o) {
    B = B | 0, o = o | 0;
    var m = 0, d = 0, v = 0, he = 0, we = 0, Be = 0, Me = 0, fr = 0, wr = 0, dr = 0, Dr = 0, Rr = 0, Qe = 0, Fr = 0, Gr = 0, $r = 0, ni = 0, mi = 0, Si = 0, Oi = 0, $i = 0, zi = 0, un = 0, In = 0;
    wr = be - 176 | 0, be = wr, Be = wr + 8 | 0, xi(Be, 65), m = a[172688], he = be - 80 | 0, be = he, a[he + 12 >> 2] = 0;
    e: {
      if (!Be) {
        ji[a[m + 168 >> 2]](689748, a[m + 172 >> 2]);
        break e;
      }
      if (o >>> 0 >= 4) {
        ji[a[m + 168 >> 2]](689986, a[m + 172 >> 2]);
        break e;
      }
      if (m = he + 12 | 0, Rn(he + 48 | 0, 690981, m), d = a[he + 12 >> 2], Rn(he + 16 | 0, 691013, m), !(d | a[he + 12 >> 2])) {
        m = a[he + 52 >> 2], d = a[he + 48 >> 2], u[Be | 0] = d, u[Be + 1 | 0] = d >>> 8, u[Be + 2 | 0] = d >>> 16, u[Be + 3 | 0] = d >>> 24, u[Be + 4 | 0] = m, u[Be + 5 | 0] = m >>> 8, u[Be + 6 | 0] = m >>> 16, u[Be + 7 | 0] = m >>> 24, m = a[he + 20 >> 2], d = a[he + 16 >> 2], u[Be + 32 | 0] = d, u[Be + 33 | 0] = d >>> 8, u[Be + 34 | 0] = d >>> 16, u[Be + 35 | 0] = d >>> 24, u[Be + 36 | 0] = m, u[Be + 37 | 0] = m >>> 8, u[Be + 38 | 0] = m >>> 16, u[Be + 39 | 0] = m >>> 24, u[Be + 64 | 0] = o, d = he + 48 | 0, o = d + 24 | 0, m = a[o + 4 >> 2], v = Be + 24 | 0, o = a[o >> 2], u[v | 0] = o, u[v + 1 | 0] = o >>> 8, u[v + 2 | 0] = o >>> 16, u[v + 3 | 0] = o >>> 24, u[v + 4 | 0] = m, u[v + 5 | 0] = m >>> 8, u[v + 6 | 0] = m >>> 16, u[v + 7 | 0] = m >>> 24, o = d + 16 | 0, m = a[o + 4 >> 2], v = Be + 16 | 0, o = a[o >> 2], u[v | 0] = o, u[v + 1 | 0] = o >>> 8, u[v + 2 | 0] = o >>> 16, u[v + 3 | 0] = o >>> 24, u[v + 4 | 0] = m, u[v + 5 | 0] = m >>> 8, u[v + 6 | 0] = m >>> 16, u[v + 7 | 0] = m >>> 24, o = d + 8 | 0, d = a[o + 4 >> 2], m = Be + 8 | 0, o = a[o >> 2], u[m | 0] = o, u[m + 1 | 0] = o >>> 8, u[m + 2 | 0] = o >>> 16, u[m + 3 | 0] = o >>> 24, u[m + 4 | 0] = d, u[m + 5 | 0] = d >>> 8, u[m + 6 | 0] = d >>> 16, u[m + 7 | 0] = d >>> 24, d = he + 16 | 0, o = d + 8 | 0, m = a[o + 4 >> 2], v = Be + 40 | 0, o = a[o >> 2], u[v | 0] = o, u[v + 1 | 0] = o >>> 8, u[v + 2 | 0] = o >>> 16, u[v + 3 | 0] = o >>> 24, u[v + 4 | 0] = m, u[v + 5 | 0] = m >>> 8, u[v + 6 | 0] = m >>> 16, u[v + 7 | 0] = m >>> 24, o = d + 16 | 0, m = a[o + 4 >> 2], v = Be + 48 | 0, o = a[o >> 2], u[v | 0] = o, u[v + 1 | 0] = o >>> 8, u[v + 2 | 0] = o >>> 16, u[v + 3 | 0] = o >>> 24, u[v + 4 | 0] = m, u[v + 5 | 0] = m >>> 8, u[v + 6 | 0] = m >>> 16, u[v + 7 | 0] = m >>> 24, o = d + 24 | 0, d = a[o + 4 >> 2], m = Be + 56 | 0, o = a[o >> 2], u[m | 0] = o, u[m + 1 | 0] = o >>> 8, u[m + 2 | 0] = o >>> 16, u[m + 3 | 0] = o >>> 24, u[m + 4 | 0] = d, u[m + 5 | 0] = d >>> 8, u[m + 6 | 0] = d >>> 16, u[m + 7 | 0] = d >>> 24, d = 1;
        break e;
      }
      d = 0, xi(Be, 65);
    }
    be = he + 80 | 0;
    e: {
      t: {
        if (!d) {
          Ee(4);
          break t;
        }
        o = wr + 136 | 0, a[o >> 2] = 0, a[o + 4 >> 2] = 0, o = wr + 128 | 0, a[o >> 2] = 0, a[o + 4 >> 2] = 0, o = wr + 120 | 0, a[o >> 2] = 0, a[o + 4 >> 2] = 0, o = wr + 112 | 0, a[o >> 2] = 0, a[o + 4 >> 2] = 0, o = wr + 104 | 0, a[o >> 2] = 0, a[o + 4 >> 2] = 0, o = wr + 96 | 0, a[o >> 2] = 0, a[o + 4 >> 2] = 0, o = wr + 88 | 0, a[o >> 2] = 0, a[o + 4 >> 2] = 0, a[wr + 80 >> 2] = 0, a[wr + 84 >> 2] = 0, m = yr(), Dr = wr + 80 | 0, d = be - 640 | 0, be = d, o = wr + 8 | 0;
        r: {
          i: {
            if (!o) {
              ji[a[m + 168 >> 2]](689760, a[m + 172 >> 2]);
              break i;
            }
            if (!Dr) {
              ji[a[m + 168 >> 2]](689638, a[m + 172 >> 2]);
              break i;
            }
            he = o + 40 | 0, v = A[he + 4 | 0] | A[he + 5 | 0] << 8 | (A[he + 6 | 0] << 16 | A[he + 7 | 0] << 24), m = d + 48 | 0, a[m >> 2] = A[he | 0] | A[he + 1 | 0] << 8 | (A[he + 2 | 0] << 16 | A[he + 3 | 0] << 24), a[m + 4 >> 2] = v, he = o + 48 | 0, v = A[he + 4 | 0] | A[he + 5 | 0] << 8 | (A[he + 6 | 0] << 16 | A[he + 7 | 0] << 24), m = d + 56 | 0, a[m >> 2] = A[he | 0] | A[he + 1 | 0] << 8 | (A[he + 2 | 0] << 16 | A[he + 3 | 0] << 24), a[m + 4 >> 2] = v, he = o + 56 | 0, v = A[he + 4 | 0] | A[he + 5 | 0] << 8 | (A[he + 6 | 0] << 16 | A[he + 7 | 0] << 24), m = d - -64 | 0, a[m >> 2] = A[he | 0] | A[he + 1 | 0] << 8 | (A[he + 2 | 0] << 16 | A[he + 3 | 0] << 24), a[m + 4 >> 2] = v, m = A[o + 36 | 0] | A[o + 37 | 0] << 8 | (A[o + 38 | 0] << 16 | A[o + 39 | 0] << 24), a[d + 40 >> 2] = A[o + 32 | 0] | A[o + 33 | 0] << 8 | (A[o + 34 | 0] << 16 | A[o + 35 | 0] << 24), a[d + 44 >> 2] = m, $r = A[o + 64 | 0], dr = A[o + 24 | 0] | A[o + 25 | 0] << 8 | (A[o + 26 | 0] << 16 | A[o + 27 | 0] << 24), m = A[o + 28 | 0] | A[o + 29 | 0] << 8 | (A[o + 30 | 0] << 16 | A[o + 31 | 0] << 24), Qe = A[o + 16 | 0] | A[o + 17 | 0] << 8 | (A[o + 18 | 0] << 16 | A[o + 19 | 0] << 24), Be = A[o + 20 | 0] | A[o + 21 | 0] << 8 | (A[o + 22 | 0] << 16 | A[o + 23 | 0] << 24), ni = A[o + 8 | 0] | A[o + 9 | 0] << 8 | (A[o + 10 | 0] << 16 | A[o + 11 | 0] << 24), he = A[o + 12 | 0] | A[o + 13 | 0] << 8 | (A[o + 14 | 0] << 16 | A[o + 15 | 0] << 24), mi = A[o | 0] | A[o + 1 | 0] << 8 | (A[o + 2 | 0] << 16 | A[o + 3 | 0] << 24), v = A[o + 4 | 0] | A[o + 5 | 0] << 8 | (A[o + 6 | 0] << 16 | A[o + 7 | 0] << 24), Rn(d + 8 | 0, 655649, 0);
            n: {
              if (!(dr | (Qe | (ni | mi)) | (m | (Be | (v | he)))) || !(a[d + 64 >> 2] | (a[d + 56 >> 2] | (a[d + 48 >> 2] | a[d + 40 >> 2])) | (a[d + 68 >> 2] | (a[d + 60 >> 2] | (a[d + 52 >> 2] | a[d + 44 >> 2])))))
                break n;
              if (o = d, a[o + 632 >> 2] = (m & 65535) << 16 | dr >>> 16, a[o + 636 >> 2] = m >>> 16, a[o + 600 >> 2] = mi, zi = v & 1048575, a[o + 604 >> 2] = zi, Fr = dr << 4, fr = Fr & 1044480, we = fr | (Fr & 4080 | Be >>> 28), un = we, Oi = (Be & 268435455) << 4 | Qe >>> 28, a[o + 624 >> 2] = Oi, a[o + 628 >> 2] = we, Fr = Be << 24 | Qe >>> 8, Si = Fr & 983040, Gr = Fr & 65280, Rr = Qe << 24 & -16777216 | he >>> 8, a[o + 616 >> 2] = Rr, $i = Si | (Gr | Fr & 255), a[o + 620 >> 2] = $i, we = he << 12 | ni >>> 20, Si = we & 1044480, Gr = we & 4080, o = ni << 12, Fr = o & -268435456, fr = we & 15, Me = o & 267386880, Me = Fr | (Me | (o & 1044480 | v >>> 20)), a[d + 608 >> 2] = Me, fr = Si | (fr | Gr), a[d + 612 >> 2] = fr, $r & 2) {
                if (m | !m & dr >>> 0 > 65535 || un | Oi || $i | !$i & Rr >>> 0 > 21319971)
                  break n;
                o: {
                  if ($i | (Rr | 0) != 21319971)
                    break o;
                  if ((fr | 0) == 103691 & Me >>> 0 > 1979466754 | fr >>> 0 > 103691)
                    break n;
                  if ((Me | 0) != 1979466754 | (fr | 0) != 103691)
                    break o;
                  if ((zi | 0) == 893298 & mi >>> 0 > 801749741 | zi >>> 0 > 893298)
                    break n;
                }
                a[d + 632 >> 2] = -1, a[d + 636 >> 2] = 65535, a[d + 624 >> 2] = -1, a[d + 628 >> 2] = 1048575, we = $i + 1048575 | 0, o = Rr - 21319972 | 0, we = o >>> 0 < 4273647324 ? we + 1 | 0 : we, a[d + 616 >> 2] = o, a[d + 620 >> 2] = we, o = fr + 944884 | 0, Me = Me - 1979466755 | 0, o = Me >>> 0 < 2315500541 ? o + 1 | 0 : o, a[d + 608 >> 2] = Me, a[d + 612 >> 2] = o, we = zi + 155276 | 0, o = mi - 801750719 | 0, we = o >>> 0 < 3493216577 ? we + 1 | 0 : we, a[d + 600 >> 2] = o, a[d + 604 >> 2] = we;
              }
              if (!Do(d + 512 | 0, d + 600 | 0, $r & 1) || (fr = d + 512 | 0, Me = fr + 8 | 0, we = a[Me + 4 >> 2], Rr = d + 384 | 0, o = Rr + 8 | 0, a[o >> 2] = a[Me >> 2], a[o + 4 >> 2] = we, Me = fr + 16 | 0, we = a[Me + 4 >> 2], o = Rr + 16 | 0, a[o >> 2] = a[Me >> 2], a[o + 4 >> 2] = we, Me = fr + 24 | 0, we = a[Me + 4 >> 2], o = Rr + 24 | 0, a[o >> 2] = a[Me >> 2], a[o + 4 >> 2] = we, Me = fr + 32 | 0, we = a[Me + 4 >> 2], o = Rr + 32 | 0, a[o >> 2] = a[Me >> 2], a[o + 4 >> 2] = we, Me = fr + 48 | 0, we = a[Me + 4 >> 2], o = Rr + 48 | 0, a[o >> 2] = a[Me >> 2], a[o + 4 >> 2] = we, Me = fr + 56 | 0, we = a[Me + 4 >> 2], o = Rr + 56 | 0, a[o >> 2] = a[Me >> 2], a[o + 4 >> 2] = we, Me = fr - -64 | 0, we = a[Me + 4 >> 2], o = Rr - -64 | 0, a[o >> 2] = a[Me >> 2], a[o + 4 >> 2] = we, Me = fr + 72 | 0, we = a[Me + 4 >> 2], o = Rr + 72 | 0, a[o >> 2] = a[Me >> 2], a[o + 4 >> 2] = we, a[d + 504 >> 2] = a[d + 592 >> 2], o = a[d + 516 >> 2], a[d + 384 >> 2] = a[d + 512 >> 2], a[d + 388 >> 2] = o, o = a[d + 556 >> 2], a[d + 424 >> 2] = a[d + 552 >> 2], a[d + 428 >> 2] = o, o = d + 472 | 0, a[o >> 2] = 0, a[o + 4 >> 2] = 0, o = d + 480 | 0, a[o >> 2] = 0, a[o + 4 >> 2] = 0, o = d + 488 | 0, a[o >> 2] = 0, a[o + 4 >> 2] = 0, o = d + 496 | 0, a[o >> 2] = 0, a[o + 4 >> 2] = 0, a[d + 464 >> 2] = 1, a[d + 468 >> 2] = 0, a[d + 104 >> 2] = m >>> 24, a[d + 108 >> 2] = 0, m = m << 6 | dr >>> 26, o = Be, a[d + 96 >> 2] = dr << 6 | o >>> 26, a[d + 100 >> 2] = m & 1073741823, Be = o << 4 | Qe >>> 28, m = d, o = he, a[m + 88 >> 2] = Qe << 4 | o >>> 28, a[m + 92 >> 2] = Be & 1073741823, a[m + 80 >> 2] = ni << 2 | v >>> 30, a[m + 84 >> 2] = (o << 2 | ni >>> 30) & 1073741823, a[m + 72 >> 2] = mi, a[m + 76 >> 2] = v & 1073741823, Fr = m + 72 | 0, Hi(Fr, 690320), Be = a[m + 104 >> 2] << 24, v = a[m + 100 >> 2], o = v >>> 6 | 0, he = a[m + 96 >> 2], a[m + 376 >> 2] = (v & 63) << 26 | he >>> 6, a[m + 380 >> 2] = o | Be, he = he << 26, o = a[m + 92 >> 2], we = o >>> 4 | 0, v = a[m + 88 >> 2], a[m + 368 >> 2] = (o & 15) << 28 | v >>> 4, a[m + 372 >> 2] = we | he, Be = v << 28, v = a[m + 84 >> 2], o = v >>> 2 | 0, he = a[m + 80 >> 2], a[m + 360 >> 2] = (v & 3) << 30 | he >>> 2, a[m + 364 >> 2] = o | Be, Be = a[m + 76 >> 2], we = he << 30, a[m + 352 >> 2] = a[m + 72 >> 2], a[m + 356 >> 2] = we | Be, fr = m + 320 | 0, Me = m + 352 | 0, di(fr, Me, m + 8 | 0), Oi = a[m + 344 >> 2], mi = a[m + 336 >> 2], dr = a[m + 328 >> 2], v = a[m + 320 >> 2], ni = a[m + 348 >> 2], Qe = a[m + 340 >> 2], we = a[m + 332 >> 2], Be = a[m + 324 >> 2], o = Oi | (mi | (dr | v)) | (ni | (Qe | (we | Be))) ? -1 : 0, Gr = v ^ -1, he = Gr - 801750718 | 0, a[m + 320 >> 2] = o & he, v = o, Be = Be ^ -1, o = Be - ((Gr >>> 0 < 801750718) + 1076732275 | 0) | 0, a[m + 324 >> 2] = v & o, o = (o | 0) == (Be | 0) & he >>> 0 < Gr >>> 0 | o >>> 0 < Be >>> 0, dr = dr ^ -1, $r = o + dr | 0, Si = we ^ -1, we = Si, we = o >>> 0 > $r >>> 0 ? we + 1 | 0 : we, o = $r - 1354194885 | 0, a[m + 328 >> 2] = o & v, Gr = we - (($r >>> 0 < 1354194885) + 1162945305 | 0) | 0, a[m + 332 >> 2] = Gr & v, Be = mi ^ -1, o = (we | 0) == (Gr | 0) & o >>> 0 < $r >>> 0 | we >>> 0 > Gr >>> 0, dr = o + ((we | 0) == (Si | 0) & dr >>> 0 > $r >>> 0 | we >>> 0 < Si >>> 0) | 0, Qe = Qe ^ -1, o = Qe + (o >>> 0 > dr >>> 0) | 0, we = Be + dr | 0, o = we >>> 0 < dr >>> 0 ? o + 1 | 0 : o, he = we - 2 | 0, a[m + 336 >> 2] = he & v, dr = o - (we >>> 0 < 2) | 0, a[m + 340 >> 2] = dr & v, un = (o | 0) == (Qe | 0) & we >>> 0 < Be >>> 0 | o >>> 0 < Qe >>> 0, o = (o | 0) == (dr | 0) & we >>> 0 > he >>> 0 | o >>> 0 > dr >>> 0, m = un + o | 0, we = o >>> 0 > m >>> 0, o = m - Oi | 0, a[d + 344 >> 2] = o - 2 & v, a[d + 348 >> 2] = (we - ((m >>> 0 < Oi >>> 0) + ni | 0) | 0) - (o >>> 0 < 2) & v, m = d + 288 | 0, di(m, Me, d + 40 | 0), o = d + 160 | 0, Ui(o, Rr, m, fr), fs(Fr, o), a[d + 280 >> 2]))
                break n;
              Gn(Dr, d + 72 | 0), o = 1;
              break r;
            }
            u[Dr | 0] = 0, u[Dr + 1 | 0] = 0, u[Dr + 2 | 0] = 0, u[Dr + 3 | 0] = 0, u[Dr + 4 | 0] = 0, u[Dr + 5 | 0] = 0, u[Dr + 6 | 0] = 0, u[Dr + 7 | 0] = 0, o = Dr + 56 | 0, u[o | 0] = 0, u[o + 1 | 0] = 0, u[o + 2 | 0] = 0, u[o + 3 | 0] = 0, u[o + 4 | 0] = 0, u[o + 5 | 0] = 0, u[o + 6 | 0] = 0, u[o + 7 | 0] = 0, o = Dr + 48 | 0, u[o | 0] = 0, u[o + 1 | 0] = 0, u[o + 2 | 0] = 0, u[o + 3 | 0] = 0, u[o + 4 | 0] = 0, u[o + 5 | 0] = 0, u[o + 6 | 0] = 0, u[o + 7 | 0] = 0, o = Dr + 40 | 0, u[o | 0] = 0, u[o + 1 | 0] = 0, u[o + 2 | 0] = 0, u[o + 3 | 0] = 0, u[o + 4 | 0] = 0, u[o + 5 | 0] = 0, u[o + 6 | 0] = 0, u[o + 7 | 0] = 0, o = Dr + 32 | 0, u[o | 0] = 0, u[o + 1 | 0] = 0, u[o + 2 | 0] = 0, u[o + 3 | 0] = 0, u[o + 4 | 0] = 0, u[o + 5 | 0] = 0, u[o + 6 | 0] = 0, u[o + 7 | 0] = 0, o = Dr + 24 | 0, u[o | 0] = 0, u[o + 1 | 0] = 0, u[o + 2 | 0] = 0, u[o + 3 | 0] = 0, u[o + 4 | 0] = 0, u[o + 5 | 0] = 0, u[o + 6 | 0] = 0, u[o + 7 | 0] = 0, o = Dr + 16 | 0, u[o | 0] = 0, u[o + 1 | 0] = 0, u[o + 2 | 0] = 0, u[o + 3 | 0] = 0, u[o + 4 | 0] = 0, u[o + 5 | 0] = 0, u[o + 6 | 0] = 0, u[o + 7 | 0] = 0, o = Dr + 8 | 0, u[o | 0] = 0, u[o + 1 | 0] = 0, u[o + 2 | 0] = 0, u[o + 3 | 0] = 0, u[o + 4 | 0] = 0, u[o + 5 | 0] = 0, u[o + 6 | 0] = 0, u[o + 7 | 0] = 0;
          }
          o = 0;
        }
        if (be = d + 640 | 0, !o)
          break t;
        if (a[wr + 144 >> 2] = B, B = pn(a[172688], wr + 144 | 0, wr + 80 | 0, (B | 0) == 33 ? 258 : 2), a[wr + 148 >> 2] = B, (B | 0) != 1)
          break e;
        In = 1;
      }
      return be = wr + 176 | 0, In | 0;
    }
    a[wr + 160 >> 2] = 0, ar(wr + 152 | 0), wasm2js_trap();
  }
  function ri() {
    var B = 0, o = 0, m = 0, d = 0, v = 0, he = 0, we = 0, Be = 0, Me = 0, fr = 0, wr = 0, dr = 0, Dr = 0, Rr = 0, Qe = 0, Fr = 0, Gr = 0, $r = 0, ni = 0, mi = 0, Si = 0, Oi = 0, $i = 0, zi = 0, un = 0, In = 0, Ti = 0, Sn = 0, Kn = 0, Vn = 0, Xn = 0, uo = 0, yo = 0, Io = 0, xo = 0;
    d = be - 192 | 0, be = d, B = d + 128 | 0, m = B + 56 | 0, a[m >> 2] = 0, a[m + 4 >> 2] = 0, m = B + 48 | 0, a[m >> 2] = 0, a[m + 4 >> 2] = 0, m = B + 40 | 0, a[m >> 2] = 0, a[m + 4 >> 2] = 0, m = B + 32 | 0, a[m >> 2] = 0, a[m + 4 >> 2] = 0, m = B + 24 | 0, a[m >> 2] = 0, a[m + 4 >> 2] = 0, m = B + 16 | 0, a[m >> 2] = 0, a[m + 4 >> 2] = 0, m = B + 8 | 0, a[m >> 2] = 0, a[m + 4 >> 2] = 0, a[d + 128 >> 2] = 0, a[d + 132 >> 2] = 0;
    e: {
      if ((da(a[172688], B, 690885) | 0) == 1) {
        m = d + 128 | 0, B = m + 15 | 0, we = A[B + 4 | 0] | A[B + 5 | 0] << 8 | (A[B + 6 | 0] << 16 | A[B + 7 | 0] << 24), v = d - -64 | 0, he = v + 8 | 0, a[he >> 2] = A[B | 0] | A[B + 1 | 0] << 8 | (A[B + 2 | 0] << 16 | A[B + 3 | 0] << 24), a[he + 4 >> 2] = we, B = m + 23 | 0, o = A[B + 4 | 0] | A[B + 5 | 0] << 8 | (A[B + 6 | 0] << 16 | A[B + 7 | 0] << 24), we = v + 16 | 0, a[we >> 2] = A[B | 0] | A[B + 1 | 0] << 8 | (A[B + 2 | 0] << 16 | A[B + 3 | 0] << 24), a[we + 4 >> 2] = o, B = m + 31 | 0, fr = A[B + 4 | 0] | A[B + 5 | 0] << 8 | (A[B + 6 | 0] << 16 | A[B + 7 | 0] << 24), o = v + 24 | 0, a[o >> 2] = A[B | 0] | A[B + 1 | 0] << 8 | (A[B + 2 | 0] << 16 | A[B + 3 | 0] << 24), a[o + 4 >> 2] = fr, B = m + 39 | 0, Be = A[B + 4 | 0] | A[B + 5 | 0] << 8 | (A[B + 6 | 0] << 16 | A[B + 7 | 0] << 24), fr = v + 32 | 0, a[fr >> 2] = A[B | 0] | A[B + 1 | 0] << 8 | (A[B + 2 | 0] << 16 | A[B + 3 | 0] << 24), a[fr + 4 >> 2] = Be, B = m + 47 | 0, dr = A[B + 4 | 0] | A[B + 5 | 0] << 8 | (A[B + 6 | 0] << 16 | A[B + 7 | 0] << 24), Be = v + 40 | 0, a[Be >> 2] = A[B | 0] | A[B + 1 | 0] << 8 | (A[B + 2 | 0] << 16 | A[B + 3 | 0] << 24), a[Be + 4 >> 2] = dr, B = m + 55 | 0, wr = A[B + 4 | 0] | A[B + 5 | 0] << 8 | (A[B + 6 | 0] << 16 | A[B + 7 | 0] << 24), dr = v + 48 | 0, a[dr >> 2] = A[B | 0] | A[B + 1 | 0] << 8 | (A[B + 2 | 0] << 16 | A[B + 3 | 0] << 24), a[dr + 4 >> 2] = wr, B = v + 56 | 0, u[B | 0] = A[m + 63 | 0], u[d + 2 | 0] = A[d + 130 | 0], p[d >> 1] = b[d + 128 >> 1], m = A[d + 139 | 0] | A[d + 140 | 0] << 8 | (A[d + 141 | 0] << 16 | A[d + 142 | 0] << 24), a[d + 64 >> 2] = A[d + 135 | 0] | A[d + 136 | 0] << 8 | (A[d + 137 | 0] << 16 | A[d + 138 | 0] << 24), a[d + 68 >> 2] = m, m = A[d + 131 | 0] | A[d + 132 | 0] << 8 | (A[d + 133 | 0] << 16 | A[d + 134 | 0] << 24), u[d + 63 | 0] = A[B | 0], v = a[dr + 4 >> 2], B = d + 55 | 0, dr = a[dr >> 2], u[B | 0] = dr, u[B + 1 | 0] = dr >>> 8, u[B + 2 | 0] = dr >>> 16, u[B + 3 | 0] = dr >>> 24, u[B + 4 | 0] = v, u[B + 5 | 0] = v >>> 8, u[B + 6 | 0] = v >>> 16, u[B + 7 | 0] = v >>> 24, v = a[Be + 4 >> 2], B = d + 47 | 0, Be = a[Be >> 2], u[B | 0] = Be, u[B + 1 | 0] = Be >>> 8, u[B + 2 | 0] = Be >>> 16, u[B + 3 | 0] = Be >>> 24, u[B + 4 | 0] = v, u[B + 5 | 0] = v >>> 8, u[B + 6 | 0] = v >>> 16, u[B + 7 | 0] = v >>> 24, v = a[fr + 4 >> 2], B = d + 39 | 0, fr = a[fr >> 2], u[B | 0] = fr, u[B + 1 | 0] = fr >>> 8, u[B + 2 | 0] = fr >>> 16, u[B + 3 | 0] = fr >>> 24, u[B + 4 | 0] = v, u[B + 5 | 0] = v >>> 8, u[B + 6 | 0] = v >>> 16, u[B + 7 | 0] = v >>> 24, v = a[o + 4 >> 2], B = d + 31 | 0, o = a[o >> 2], u[B | 0] = o, u[B + 1 | 0] = o >>> 8, u[B + 2 | 0] = o >>> 16, u[B + 3 | 0] = o >>> 24, u[B + 4 | 0] = v, u[B + 5 | 0] = v >>> 8, u[B + 6 | 0] = v >>> 16, u[B + 7 | 0] = v >>> 24, v = a[we + 4 >> 2], B = d + 23 | 0, we = a[we >> 2], u[B | 0] = we, u[B + 1 | 0] = we >>> 8, u[B + 2 | 0] = we >>> 16, u[B + 3 | 0] = we >>> 24, u[B + 4 | 0] = v, u[B + 5 | 0] = v >>> 8, u[B + 6 | 0] = v >>> 16, u[B + 7 | 0] = v >>> 24, v = a[he + 4 >> 2], B = d + 15 | 0, he = a[he >> 2], u[B | 0] = he, u[B + 1 | 0] = he >>> 8, u[B + 2 | 0] = he >>> 16, u[B + 3 | 0] = he >>> 24, u[B + 4 | 0] = v, u[B + 5 | 0] = v >>> 8, u[B + 6 | 0] = v >>> 16, u[B + 7 | 0] = v >>> 24, u[d + 3 | 0] = m, u[d + 4 | 0] = m >>> 8, u[d + 5 | 0] = m >>> 16, u[d + 6 | 0] = m >>> 24, B = a[d + 68 >> 2], m = a[d + 64 >> 2], u[d + 7 | 0] = m, u[d + 8 | 0] = m >>> 8, u[d + 9 | 0] = m >>> 16, u[d + 10 | 0] = m >>> 24, u[d + 11 | 0] = B, u[d + 12 | 0] = B >>> 8, u[d + 13 | 0] = B >>> 16, u[d + 14 | 0] = B >>> 24, Gr = yr(), o = be - 496 | 0, be = o;
        t: {
          if (!d) {
            ji[a[Gr + 168 >> 2]](689638, a[Gr + 172 >> 2]);
            break t;
          }
          if (!so(o + 136 | 0, 690981) || (Rn(o + 464 | 0, 691013, o + 12 | 0), a[o + 12 >> 2]))
            break t;
          if (m = A[d + 4 | 0] | A[d + 5 | 0] << 8 | (A[d + 6 | 0] << 16 | A[d + 7 | 0] << 24), we = m, wr = m >>> 20 | 0, he = wr, B = A[d + 12 | 0] | A[d + 13 | 0] << 8 | (A[d + 14 | 0] << 16 | A[d + 15 | 0] << 24), Dr = B, $i = A[d + 8 | 0] | A[d + 9 | 0] << 8 | (A[d + 10 | 0] << 16 | A[d + 11 | 0] << 24), m = $i, B = B << 12 | m >>> 20, $r = m << 12, zi = he | $r & -4096, dr = B, un = B & 1048575, In = Dr >>> 8 | 0, fr = In, B = A[d + 20 | 0] | A[d + 21 | 0] << 8 | (A[d + 22 | 0] << 16 | A[d + 23 | 0] << 24), Be = B, Si = A[d + 16 | 0] | A[d + 17 | 0] << 8 | (A[d + 18 | 0] << 16 | A[d + 19 | 0] << 24), m = Si, B = B << 24 | m >>> 8, Ti = fr | m << 24 & -16777216, m = B, Sn = B & 1048575, he = A[d + 28 | 0] | A[d + 29 | 0] << 8 | (A[d + 30 | 0] << 16 | A[d + 31 | 0] << 24), fr = he, Qe = A[d + 24 | 0] | A[d + 25 | 0] << 8 | (A[d + 26 | 0] << 16 | A[d + 27 | 0] << 24), ni = (he & 65535) << 16 | Qe >>> 16, Fr = he >>> 16 | 0, he = Be >>> 28 | 0, Me = (Be & 268435455) << 4 | Si >>> 28, mi = A[d | 0] | A[d + 1 | 0] << 8 | (A[d + 2 | 0] << 16 | A[d + 3 | 0] << 24), v = Qe, B = v << 4, Kn = he | B & 1048560, Rr = we & 1048575, !(Me | (Ti | (ni | (mi | zi))) | (Kn | (Sn | (Fr | (Rr | un)))))) {
            ji[a[Gr + 168 >> 2]](690116, a[Gr + 172 >> 2]);
            break t;
          }
          if (Qe = A[d + 56 | 0] | A[d + 57 | 0] << 8 | (A[d + 58 | 0] << 16 | A[d + 59 | 0] << 24), Gr = A[d + 60 | 0] | A[d + 61 | 0] << 8 | (A[d + 62 | 0] << 16 | A[d + 63 | 0] << 24), Oi = A[d + 48 | 0] | A[d + 49 | 0] << 8 | (A[d + 50 | 0] << 16 | A[d + 51 | 0] << 24), Xn = A[d + 52 | 0] | A[d + 53 | 0] << 8 | (A[d + 54 | 0] << 16 | A[d + 55 | 0] << 24), uo = A[d + 40 | 0] | A[d + 41 | 0] << 8 | (A[d + 42 | 0] << 16 | A[d + 43 | 0] << 24), yo = A[d + 44 | 0] | A[d + 45 | 0] << 8 | (A[d + 46 | 0] << 16 | A[d + 47 | 0] << 24), Io = A[d + 32 | 0] | A[d + 33 | 0] << 8 | (A[d + 34 | 0] << 16 | A[d + 35 | 0] << 24), Vn = A[d + 36 | 0] | A[d + 37 | 0] << 8 | (A[d + 38 | 0] << 16 | A[d + 39 | 0] << 24), u[o + 34 | 0] = In, u[o + 21 | 0] = ni, u[o + 38 | 0] = (dr & 1048575) << 12 | $r >>> 20, u[o + 37 | 0] = (dr & 268435455) << 4 | $r >>> 28, u[o + 36 | 0] = dr >>> 4, u[o + 35 | 0] = dr >>> 12, u[o + 30 | 0] = m, u[o + 29 | 0] = m >>> 8, u[o + 22 | 0] = B >>> 12, u[o + 47 | 0] = mi, u[o + 46 | 0] = (we & 255) << 24 | mi >>> 8, u[o + 45 | 0] = (we & 65535) << 16 | mi >>> 16, u[o + 44 | 0] = (we & 16777215) << 8 | mi >>> 24, u[o + 43 | 0] = we, u[o + 42 | 0] = we >>> 8, u[o + 41 | 0] = wr << 4 | Rr >>> 16, u[o + 40 | 0] = we >>> 24, u[o + 39 | 0] = $i, u[o + 33 | 0] = Dr >>> 16, u[o + 32 | 0] = Dr >>> 24, u[o + 31 | 0] = Si, B = Be, u[o + 27 | 0] = B, u[o + 26 | 0] = B >>> 8, u[o + 25 | 0] = B >>> 16, u[o + 24 | 0] = B >>> 24, u[o + 23 | 0] = v, B = fr, u[o + 20 | 0] = (B & 16777215) << 8 | v >>> 24, u[o + 19 | 0] = B, u[o + 18 | 0] = B >>> 8, u[o + 17 | 0] = B >>> 16, u[o + 16 | 0] = B >>> 24, u[o + 28 | 0] = m >>> 16 & 15 | Me << 4, a[o + 400 >> 2] = 64, a[o + 404 >> 2] = 0, a[o + 328 >> 2] = -1862921884, a[o + 332 >> 2] = 870954602, a[o + 320 >> 2] = -1748470448, a[o + 324 >> 2] = 3983205, a[o + 312 >> 2] = 292000018, a[o + 316 >> 2] = -782074353, a[o + 304 >> 2] = -1662207471, a[o + 308 >> 2] = 596792193, we = o + 304 | 0, Di(we, 690981, 32), Di(we, o + 16 | 0, 32), Di(we, 655649, 32), Be = o + 48 | 0, _n(we, Be), $r = o + 432 | 0, Rn($r, Be, 0), m = Gr, B = m >>> 16 | 0, fr = o + 176 | 0, v = fr + 72 | 0, a[v >> 2] = (m & 65535) << 16 | Qe >>> 16, a[v + 4 >> 2] = B, he = Qe << 4 & 1048560, m = Xn, B = m >>> 28 | 0, v = fr - -64 | 0, a[v >> 2] = (m & 268435455) << 4 | Oi >>> 28, a[v + 4 >> 2] = B | he, B = m << 24 | Oi >>> 8, v = fr + 56 | 0, m = yo, a[v >> 2] = Oi << 24 & -16777216 | m >>> 8, a[v + 4 >> 2] = B & 1048575, B = m << 12, m = uo, he = (B | m >>> 20) & 1048575, v = fr + 48 | 0, a[v >> 2] = m << 12 & -4096 | Vn >>> 20, a[v + 4 >> 2] = he, a[o + 296 >> 2] = 0, a[o + 256 >> 2] = 1, a[o + 260 >> 2] = 0, a[o + 216 >> 2] = Io, a[o + 220 >> 2] = Vn & 1048575, a[o + 208 >> 2] = ni, a[o + 212 >> 2] = Fr, a[o + 200 >> 2] = Me, a[o + 204 >> 2] = Kn, a[o + 192 >> 2] = Ti, a[o + 196 >> 2] = Sn, a[o + 184 >> 2] = zi, a[o + 188 >> 2] = un, a[o + 176 >> 2] = mi, a[o + 180 >> 2] = Rr, dr = a[o + 456 >> 2], Rr = a[o + 448 >> 2], Dr = a[o + 440 >> 2], B = a[o + 432 >> 2], ni = a[o + 460 >> 2], Qe = a[o + 452 >> 2], Me = a[o + 444 >> 2], m = a[o + 436 >> 2], v = dr | (Rr | (Dr | B)) | (ni | (Qe | (Me | m))) ? -1 : 0, B = B ^ -1, Fr = B - 801750718 | 0, a[o + 432 >> 2] = v & Fr, he = m ^ -1, wr = he - ((B >>> 0 < 801750718) + 1076732275 | 0) | 0, a[o + 436 >> 2] = wr & v, B = (he | 0) == (wr | 0) & B >>> 0 > Fr >>> 0 | he >>> 0 > wr >>> 0, wr = Dr ^ -1, he = B + wr | 0, Dr = Me ^ -1, B = Dr, Fr = he - 1354194885 | 0, a[o + 440 >> 2] = Fr & v, B = he >>> 0 < wr >>> 0 ? B + 1 | 0 : B, Me = B - ((he >>> 0 < 1354194885) + 1162945305 | 0) | 0, a[o + 444 >> 2] = Me & v, Gr = Rr ^ -1, m = (B | 0) == (Dr | 0) & he >>> 0 < wr >>> 0 | B >>> 0 < Dr >>> 0, wr = (B | 0) == (Me | 0) & he >>> 0 > Fr >>> 0 | B >>> 0 > Me >>> 0, he = m + wr | 0, Rr = Qe ^ -1, B = Rr + (he >>> 0 < wr >>> 0) | 0, m = he, he = he + Gr | 0, B = m >>> 0 > he >>> 0 ? B + 1 | 0 : B, Dr = he - 2 | 0, a[o + 448 >> 2] = Dr & v, wr = B - (he >>> 0 < 2) | 0, a[o + 452 >> 2] = wr & v, m = (B | 0) == (Rr | 0) & he >>> 0 < Gr >>> 0 | B >>> 0 < Rr >>> 0, he = (B | 0) == (wr | 0) & he >>> 0 > Dr >>> 0 | B >>> 0 > wr >>> 0, m = m + he | 0, B = m >>> 0 < he >>> 0, he = m - dr | 0, a[o + 456 >> 2] = he - 2 & v, a[o + 460 >> 2] = (B - ((m >>> 0 < dr >>> 0) + ni | 0) | 0) - (he >>> 0 < 2) & v, B = o + 288 | 0, a[B >> 2] = 0, a[B + 4 >> 2] = 0, B = o + 280 | 0, a[B >> 2] = 0, a[B + 4 >> 2] = 0, B = o + 272 | 0, a[B >> 2] = 0, a[B + 4 >> 2] = 0, B = o + 264 | 0, a[B >> 2] = 0, a[B + 4 >> 2] = 0, Ui(we, fr, $r, o + 464 | 0), fs(Be, we), a[o + 128 >> 2] || (he = a[o + 92 >> 2], v = o + 48 | 0, B = v + 72 | 0, Me = a[B >> 2], we = a[B + 4 >> 2], Rr = we, B = a[o + 88 >> 2], m = oi(we >>> 16 | 0, 0, 977, 1), fr = B + m | 0, B = he + Fe | 0, Be = m >>> 0 > fr >>> 0 ? B + 1 | 0 : B, B = v + 48 | 0, he = a[B >> 2], B = a[B + 4 >> 2], m = Be >>> 20 | 0, we = m, m = m + he | 0, we = we >>> 0 > m >>> 0 ? B + 1 | 0 : B, dr = we & 1048575, B = v - -64 | 0, wr = a[B >> 2], Qe = a[B + 4 >> 2], B = v + 56 | 0, he = a[B >> 2], B = a[B + 4 >> 2], v = we >>> 20 | 0, he = v + he | 0, Dr = v >>> 0 > he >>> 0 ? B + 1 | 0 : B, B = Qe, v = Dr >>> 20 | 0, Qe = v, v = v + wr | 0, B = Qe >>> 0 > v >>> 0 ? B + 1 | 0 : B, wr = B & 1048575, Dr = Dr & 1048575, Qe = (m & he & v) == -1 & (we & Dr & B) == 1048575, we = B, B = Rr & 65535, we = we >>> 20 | 0, Me = we + Me | 0, we = we >>> 0 > Me >>> 0 ? B + 1 | 0 : B, B = Be & 1048575, Rr = B, Be = Me, Qe & ((Be | 0) == -1 & (we | 0) == 65535) & ((B | 0) == 1048574 & fr >>> 0 > 4294966318 | B >>> 0 > 1048574) | we >>> 16 && (B = Rr + 1 | 0, fr = fr + 977 | 0, B = fr >>> 0 < 977 ? B + 1 | 0 : B, Rr = B & 1048575, Me = B, B = dr, Me = Me >>> 20 | 0, m = m + Me | 0, B = Me >>> 0 > m >>> 0 ? B + 1 | 0 : B, dr = B & 1048575, Me = B, B = Dr, Me = Me >>> 20 | 0, he = he + Me | 0, B = Me >>> 0 > he >>> 0 ? B + 1 | 0 : B, Dr = B & 1048575, Me = B, B = wr, Me = Me >>> 20 | 0, v = v + Me | 0, B = Me >>> 0 > v >>> 0 ? B + 1 | 0 : B, wr = B & 1048575, Me = B, B = we, we = Be, Be = (Me >>> 20 | 0) + Be | 0, we = (we >>> 0 > Be >>> 0 ? B + 1 | 0 : B) & 65535), a[o + 120 >> 2] = Be, a[o + 124 >> 2] = we, a[o + 112 >> 2] = v, a[o + 116 >> 2] = wr, a[o + 104 >> 2] = he, a[o + 108 >> 2] = Dr, a[o + 96 >> 2] = m, a[o + 100 >> 2] = dr, a[o + 88 >> 2] = fr, a[o + 92 >> 2] = Rr, fr & 1) || (B = a[o + 48 >> 2], m = a[o + 136 >> 2], v = B - m | 0, we = a[o + 52 >> 2] - (a[o + 140 >> 2] + (B >>> 0 < m >>> 0) | 0) | 0, B = a[o + 80 >> 2], he = a[o + 168 >> 2], m = (B - he | 0) - 4 | 0, B = (a[o + 84 >> 2] - (a[o + 172 >> 2] + (B >>> 0 < he >>> 0) | 0) | 0) + 262143 | 0, he = m >>> 0 < 4294967292 ? B + 1 | 0 : B, fr = oi(he >>> 16 | 0, 0, 977, 1), v = fr + v | 0, B = we + Fe | 0, B = (v >>> 0 < fr >>> 0 ? B + 1 | 0 : B) + 4194299 | 0, v = v - 3908 | 0, B = v >>> 0 < 4294963388 ? B + 1 | 0 : B, we = B & 1048575, Rr = we, Dr = v ^ 976, Qe = we ^ 1, ((Dr | 0) != -1 | (Qe | 0) != 1048575) & (v | we) != 0))
            break t;
          wr = m, ni = he & 65535, m = a[o + 72 >> 2], he = a[o + 160 >> 2], dr = m - he | 0, Me = a[o + 76 >> 2] - (a[o + 164 >> 2] + (m >>> 0 < he >>> 0) | 0) | 0, m = a[o + 64 >> 2], he = a[o + 152 >> 2], fr = m - he | 0, Be = a[o + 68 >> 2] - (a[o + 156 >> 2] + (m >>> 0 < he >>> 0) | 0) | 0, m = B >>> 20 | 0, $r = a[o + 144 >> 2], Fr = m - $r | 0, he = Fr + a[o + 56 >> 2] | 0, B = a[o + 60 >> 2] - (a[o + 148 >> 2] + (m >>> 0 < $r >>> 0) | 0) | 0, B = (he >>> 0 < Fr >>> 0 ? B + 1 | 0 : B) + 4194303 | 0, m = he - 4 | 0, he = m >>> 0 < 4294967292 ? B + 1 | 0 : B, B = Be, we = he >>> 20 | 0, Be = we, we = we + fr | 0, B = (Be >>> 0 > we >>> 0 ? B + 1 | 0 : B) + 4194303 | 0, we = we - 4 | 0, fr = we >>> 0 < 4294967292 ? B + 1 | 0 : B, B = Me, Be = fr >>> 20 | 0, Me = Be, Be = Be + dr | 0, B = (Me >>> 0 > Be >>> 0 ? B + 1 | 0 : B) + 4194303 | 0, Be = Be - 4 | 0, dr = Be >>> 0 < 4294967292 ? B + 1 | 0 : B, B = ni, Me = dr >>> 20 | 0, wr = Me + wr | 0, B = Me >>> 0 > wr >>> 0 ? B + 1 | 0 : B, (m & Dr & we & Be & wr) == -1 ? Me = (he & Qe & fr & dr & (B ^ 983040)) == 1048575 : Me = 0, Me ? (m = 0, B = 0) : (m = Be | (we | (m | v)) | wr, B = dr & 1048575 | (fr & 1048575 | (he & 1048575 | Rr)) | B), xo = !(B | m);
        }
        be = o + 496 | 0;
        break e;
      }
      Ee(1);
    }
    return be = d + 192 | 0, xo | 0;
  }
  function _i(B, o, m, d, v) {
    var he = 0;
    e: {
      t: {
        if ((m | 0) != 1114112 && (he = 1, ji[a[o + 16 >> 2]](B, m) | 0))
          break t;
        if (d)
          break e;
        he = 0;
      }
      return he;
    }
    return ji[a[o + 12 >> 2]](B, d, v) | 0;
  }
  function Er(B, o) {
    B = B | 0, o = o | 0;
    var m = 0;
    if (A[B | 0])
      for (o = B + 1 | 0, B = 0; m = B + o | 0, B = B + 1 | 0, !!A[m | 0]; )
        ;
    wasm2js_trap();
  }
  function Di(B, o, m) {
    var d = 0, v = 0, he = 0, we = 0, Be = 0, Me = 0, fr = 0, wr = 0, dr = 0, Dr = 0, Rr = 0, Qe = 0, Fr = 0, Gr = 0, $r = 0, ni = 0, mi = 0, Si = 0, Oi = 0, $i = 0, zi = 0, un = 0, In = 0, Ti = 0, Sn = 0, Kn = 0, Vn = 0, Xn = 0, uo = 0, yo = 0, Io = 0, xo = 0, Mo = 0, qi = 0, Oo = 0, Ho = 0, Go = 0, ns = 0, ds = 0, Ts = 0, Ao = 0, po = 0, _o = 0, Uo = 0, ts = 0, Lo = 0, Wo = 0, ps = 0, Bs = 0, Xs = 0, js = 0, ya = 0, sa = 0, va = 0, oa = 0, wa = 0, Pa = 0, Ta = 0, jn = 0, ta = 0, Na = 0, ba = 0, Aa = 0, zs = 0, x2 = 0, Va = 0, Se = 0, ea = 0, e = 0, Je = 0, N2 = 0, qs = 0, df = 0, zo = 0;
    if (d = a[B + 100 >> 2], v = a[B + 96 >> 2], Be = v + m | 0, d = Be >>> 0 < m >>> 0 ? d + 1 | 0 : d, a[B + 96 >> 2] = Be, a[B + 100 >> 2] = d, d = v & 63, jn = 64 - d | 0, jn >>> 0 <= m >>> 0)
      for (qs = B + 32 | 0; dn(d + qs | 0, o, jn), v = A[B + 67 | 0], d = A[B + 65 | 0] << 16 | A[B + 64 | 0] << 24, Ho = v | (d | A[B + 66 | 0] << 8), fr = A[B + 39 | 0], Be = A[B + 37 | 0] << 16 | A[B + 36 | 0] << 24, dr = fr | (Be | A[B + 38 | 0] << 8), $i = A[B + 59 | 0], zi = A[B + 57 | 0] << 16 | A[B + 56 | 0] << 24, Si = $i | (zi | A[B + 58 | 0] << 8), we = A[B + 51 | 0], $r = A[B + 49 | 0] << 16 | A[B + 48 | 0] << 24, Qe = we | ($r | A[B + 50 | 0] << 8), Dr = A[B + 43 | 0], wr = A[B + 41 | 0] << 16 | A[B + 40 | 0] << 24, Rr = Dr | (wr | A[B + 42 | 0] << 8), Pa = (v << 25 | Ho >>> 7) ^ (Ho << 14 | d >>> 18) ^ Ho >>> 3, Fr = A[B + 63 | 0], v = A[B + 61 | 0] << 16 | A[B + 60 | 0] << 24, Oi = Fr | (v | A[B + 62 | 0] << 8), mi = A[B + 71 | 0], Gr = A[B + 69 | 0] << 16 | A[B + 68 | 0] << 24, Ao = mi | (Gr | A[B + 70 | 0] << 8), d = A[B + 32 | 0] | A[B + 33 | 0] << 8 | (A[B + 34 | 0] << 16 | A[B + 35 | 0] << 24), Xs = d << 8 & 16711680 | d << 24 | (d >>> 8 & 65280 | d >>> 24), Me = Ao + (Xs + ((fr << 25 | dr >>> 7) ^ (dr << 14 | Be >>> 18) ^ dr >>> 3) | 0) | 0, Be = A[B + 89 | 0] << 16 | A[B + 88 | 0] << 24, d = Be | A[B + 90 | 0] << 8, un = A[B + 91 | 0], Ti = d | un, he = Me + ((Ti << 15 | Be >>> 17) ^ ((Ti << 13 | Be >>> 19) ^ d >>> 10)) | 0, js = ($i << 25 | Si >>> 7) ^ (Si << 14 | zi >>> 18) ^ Si >>> 3, $i = A[B + 55 | 0], zi = A[B + 53 | 0] << 16 | A[B + 52 | 0] << 24, ni = $i | (zi | A[B + 54 | 0] << 8), Io = A[B + 83 | 0], Kn = A[B + 81 | 0] << 16 | A[B + 80 | 0] << 24, po = Io | (Kn | A[B + 82 | 0] << 8), Me = (we << 25 | Qe >>> 7) ^ (Qe << 14 | $r >>> 18) ^ Qe >>> 3, In = A[B + 47 | 0], $r = A[B + 45 | 0] << 16 | A[B + 44 | 0] << 24, ya = In | ($r | A[B + 46 | 0] << 8), xo = A[B + 75 | 0], Mo = A[B + 73 | 0] << 16 | A[B + 72 | 0] << 24, _o = xo | (Mo | A[B + 74 | 0] << 8), qi = A[B + 95 | 0], fr = A[B + 93 | 0] << 16 | A[B + 92 | 0] << 24, d = fr | A[B + 94 | 0] << 8, Sn = qi | d, we = (_o + (((Dr << 25 | Rr >>> 7) ^ (Rr << 14 | wr >>> 18) ^ Rr >>> 3) + dr | 0) | 0) + ((Sn << 15 | fr >>> 17) ^ ((Sn << 13 | fr >>> 19) ^ d >>> 10)) | 0, wr = (po + (Me + ya | 0) | 0) + (Yr(we, 15) ^ Yr(we, 13) ^ we >>> 10) | 0, Dr = ((js + ni | 0) + Ti | 0) + (Yr(wr, 15) ^ Yr(wr, 13) ^ wr >>> 10) | 0, d = ((Pa + Oi | 0) + he | 0) + (Yr(Dr, 15) ^ Yr(Dr, 13) ^ Dr >>> 10) | 0, Se = (((mi << 25 | Ao >>> 7) ^ (Ao << 14 | Gr >>> 18) ^ Ao >>> 3) + Ho | 0) + we | 0, Pa = (((Fr << 25 | Oi >>> 7) ^ (Oi << 14 | v >>> 18) ^ Oi >>> 3) + Si | 0) + Sn | 0, js = (($i << 25 | ni >>> 7) ^ (ni << 14 | zi >>> 18) ^ ni >>> 3) + Qe | 0, $i = A[B + 87 | 0], zi = A[B + 85 | 0] << 16 | A[B + 84 | 0] << 24, Ta = $i | (zi | A[B + 86 | 0] << 8), Me = ((In << 25 | ya >>> 7) ^ (ya << 14 | $r >>> 18) ^ ya >>> 3) + Rr | 0, Oo = A[B + 79 | 0], $r = A[B + 77 | 0] << 16 | A[B + 76 | 0] << 24, Uo = Oo | ($r | A[B + 78 | 0] << 8), Fr = (Me + Uo | 0) + (Yr(he, 15) ^ Yr(he, 13) ^ he >>> 10) | 0, Gr = (js + Ta | 0) + (Yr(Fr, 15) ^ Yr(Fr, 13) ^ Fr >>> 10) | 0, mi = Pa + (Yr(Gr, 15) ^ Yr(Gr, 13) ^ Gr >>> 10) | 0, v = Se + (Yr(mi, 15) ^ Yr(mi, 13) ^ mi >>> 10) | 0, Vn = v + ((Yr(he, 25) ^ Yr(he, 14) ^ he >>> 3) + Sn | 0) | 0, Me = (((un << 25 | Ti >>> 7) ^ (Ti << 14 | Be >>> 18) ^ Ti >>> 3) + Ta | 0) + mi | 0, un = ((((xo << 25 | _o >>> 7) ^ (_o << 14 | Mo >>> 18) ^ _o >>> 3) + Ao | 0) + Fr | 0) + (Yr(d, 15) ^ Yr(d, 13) ^ d >>> 10) | 0, In = ((((Io << 25 | po >>> 7) ^ (po << 14 | Kn >>> 18) ^ po >>> 3) + Uo | 0) + Gr | 0) + (Yr(un, 15) ^ Yr(un, 13) ^ un >>> 10) | 0, Kn = Me + (Yr(In, 15) ^ Yr(In, 13) ^ In >>> 10) | 0, Be = Vn + (Yr(Kn, 15) ^ Yr(Kn, 13) ^ Kn >>> 10) | 0, Go = Be + ((Yr(d, 25) ^ Yr(d, 14) ^ d >>> 3) + mi | 0) | 0, Vn = ((Yr(Dr, 25) ^ Yr(Dr, 14) ^ Dr >>> 3) + Gr | 0) + Kn | 0, Xn = ((Yr(wr, 25) ^ Yr(wr, 14) ^ wr >>> 3) + Fr | 0) + In | 0, uo = ((Yr(we, 25) ^ Yr(we, 14) ^ we >>> 3) + he | 0) + un | 0, Io = ((((Oo << 25 | Uo >>> 7) ^ (Uo << 14 | $r >>> 18) ^ Uo >>> 3) + _o | 0) + wr | 0) + (Yr(v, 15) ^ Yr(v, 13) ^ v >>> 10) | 0, Mo = (((($i << 25 | Ta >>> 7) ^ (Ta << 14 | zi >>> 18) ^ Ta >>> 3) + po | 0) + Dr | 0) + (Yr(Io, 15) ^ Yr(Io, 13) ^ Io >>> 10) | 0, xo = ((((qi << 25 | Sn >>> 7) ^ (Sn << 14 | fr >>> 18) ^ Sn >>> 3) + Ti | 0) + d | 0) + (Yr(Mo, 15) ^ Yr(Mo, 13) ^ Mo >>> 10) | 0, qi = uo + (Yr(xo, 15) ^ Yr(xo, 13) ^ xo >>> 10) | 0, Oo = Xn + (Yr(qi, 15) ^ Yr(qi, 13) ^ qi >>> 10) | 0, Vn = Vn + (Yr(Oo, 15) ^ Yr(Oo, 13) ^ Oo >>> 10) | 0, fr = Go + (Yr(Vn, 15) ^ Yr(Vn, 13) ^ Vn >>> 10) | 0, zi = fr + ((Yr(xo, 25) ^ Yr(xo, 14) ^ xo >>> 3) + Kn | 0) | 0, $i = ((Yr(Mo, 25) ^ Yr(Mo, 14) ^ Mo >>> 3) + In | 0) + Vn | 0, $r = ((Yr(Io, 25) ^ Yr(Io, 14) ^ Io >>> 3) + un | 0) + Oo | 0, ns = ((Yr(v, 25) ^ Yr(v, 14) ^ v >>> 3) + d | 0) + qi | 0, uo = ((Yr(mi, 25) ^ Yr(mi, 14) ^ mi >>> 3) + Dr | 0) + xo | 0, Xn = ((Yr(Gr, 25) ^ Yr(Gr, 14) ^ Gr >>> 3) + wr | 0) + Mo | 0, Go = (((Yr(Fr, 25) ^ Yr(Fr, 14) ^ Fr >>> 3) + we | 0) + Io | 0) + (Yr(Be, 15) ^ Yr(Be, 13) ^ Be >>> 10) | 0, Xn = Xn + (Yr(Go, 15) ^ Yr(Go, 13) ^ Go >>> 10) | 0, uo = uo + (Yr(Xn, 15) ^ Yr(Xn, 13) ^ Xn >>> 10) | 0, ns = ns + (Yr(uo, 15) ^ Yr(uo, 13) ^ uo >>> 10) | 0, ts = $r + (Yr(ns, 15) ^ Yr(ns, 13) ^ ns >>> 10) | 0, Lo = $i + (Yr(ts, 15) ^ Yr(ts, 13) ^ ts >>> 10) | 0, zi = zi + (Yr(Lo, 15) ^ Yr(Lo, 13) ^ Lo >>> 10) | 0, $i = ((Yr(Be, 25) ^ Yr(Be, 14) ^ Be >>> 3) + xo | 0) + ns | 0, $r = ((Yr(Kn, 25) ^ Yr(Kn, 14) ^ Kn >>> 3) + Mo | 0) + uo | 0, ds = ((Yr(In, 25) ^ Yr(In, 14) ^ In >>> 3) + Io | 0) + Xn | 0, Wo = (((Yr(un, 25) ^ Yr(un, 14) ^ un >>> 3) + v | 0) + Go | 0) + (Yr(fr, 15) ^ Yr(fr, 13) ^ fr >>> 10) | 0, ds = ds + (Yr(Wo, 15) ^ Yr(Wo, 13) ^ Wo >>> 10) | 0, ps = $r + (Yr(ds, 15) ^ Yr(ds, 13) ^ ds >>> 10) | 0, $i = $i + (Yr(ps, 15) ^ Yr(ps, 13) ^ ps >>> 10) | 0, $r = $i + ((Yr(fr, 25) ^ Yr(fr, 14) ^ fr >>> 3) + uo | 0) | 0, yo = ((Yr(Vn, 25) ^ Yr(Vn, 14) ^ Vn >>> 3) + Xn | 0) + ps | 0, Ts = ((Yr(Oo, 25) ^ Yr(Oo, 14) ^ Oo >>> 3) + Go | 0) + ds | 0, Bs = (((Yr(qi, 25) ^ Yr(qi, 14) ^ qi >>> 3) + Be | 0) + Wo | 0) + (Yr(zi, 15) ^ Yr(zi, 13) ^ zi >>> 10) | 0, ta = Ts + (Yr(Bs, 15) ^ Yr(Bs, 13) ^ Bs >>> 10) | 0, Na = yo + (Yr(ta, 15) ^ Yr(ta, 13) ^ ta >>> 10) | 0, ba = $r + (Yr(Na, 15) ^ Yr(Na, 13) ^ Na >>> 10) | 0, $r = ba + ((Yr(zi, 25) ^ Yr(zi, 14) ^ zi >>> 3) + ps | 0) | 0, yo = ((Yr(Lo, 25) ^ Yr(Lo, 14) ^ Lo >>> 3) + ds | 0) + Na | 0, sa = ((Yr(ts, 25) ^ Yr(ts, 14) ^ ts >>> 3) + Wo | 0) + ta | 0, va = ((Yr(ns, 25) ^ Yr(ns, 14) ^ ns >>> 3) + fr | 0) + Bs | 0, oa = ((Yr(uo, 25) ^ Yr(uo, 14) ^ uo >>> 3) + Vn | 0) + zi | 0, wa = ((Yr(Xn, 25) ^ Yr(Xn, 14) ^ Xn >>> 3) + Oo | 0) + Lo | 0, Ts = (((Yr(Go, 25) ^ Yr(Go, 14) ^ Go >>> 3) + qi | 0) + ts | 0) + (Yr($i, 15) ^ Yr($i, 13) ^ $i >>> 10) | 0, wa = wa + (Yr(Ts, 15) ^ Yr(Ts, 13) ^ Ts >>> 10) | 0, oa = oa + (Yr(wa, 15) ^ Yr(wa, 13) ^ wa >>> 10) | 0, va = va + (Yr(oa, 15) ^ Yr(oa, 13) ^ oa >>> 10) | 0, sa = sa + (Yr(va, 15) ^ Yr(va, 13) ^ va >>> 10) | 0, ea = yo + (Yr(sa, 15) ^ Yr(sa, 13) ^ sa >>> 10) | 0, e = $r + (Yr(ea, 15) ^ Yr(ea, 13) ^ ea >>> 10) | 0, Se = a[B + 12 >> 2], Pa = a[B + 28 >> 2], yo = a[B + 16 >> 2], $r = Pa + (Yr(yo, 26) ^ Yr(yo, 21) ^ Yr(yo, 7)) | 0, Aa = a[B + 20 >> 2], Je = a[B + 24 >> 2], zs = (Xs + ($r + ((Aa ^ Je) & yo ^ Je) | 0) | 0) + 1116352408 | 0, $r = zs + Se | 0, Xs = a[B + 4 >> 2], Me = Rr + Aa | 0, N2 = a[B + 8 >> 2], x2 = (((Je + ($r & (yo ^ Aa) ^ Aa) | 0) + dr | 0) + (Yr($r, 26) ^ Yr($r, 21) ^ Yr($r, 7)) | 0) + 1899447441 | 0, Rr = N2 + x2 | 0, Va = ((Me + (Rr & ($r ^ yo) ^ yo) | 0) + (Yr(Rr, 26) ^ Yr(Rr, 21) ^ Yr(Rr, 7)) | 0) - 1245643825 | 0, dr = Xs + Va | 0, Me = Qe + $r | 0, js = (((yo + ya | 0) + (dr & (Rr ^ $r) ^ $r) | 0) + (Yr(dr, 26) ^ Yr(dr, 21) ^ Yr(dr, 7)) | 0) - 373957723 | 0, $r = a[B >> 2], Qe = js + $r | 0, ya = ((Me + (Qe & (dr ^ Rr) ^ Rr) | 0) + (Yr(Qe, 26) ^ Yr(Qe, 21) ^ Yr(Qe, 7)) | 0) + 961987163 | 0, Me = Rr + ni | 0, Rr = ((N2 & ($r | Xs) | $r & Xs) + (Yr($r, 30) ^ Yr($r, 19) ^ Yr($r, 10)) | 0) + zs | 0, ni = Rr + ya | 0, zs = ((Me + (ni & (dr ^ Qe) ^ dr) | 0) + (Yr(ni, 26) ^ Yr(ni, 21) ^ Yr(ni, 7)) | 0) + 1508970993 | 0, Me = dr + Si | 0, dr = (((Rr | $r) & Xs | Rr & $r) + (Yr(Rr, 30) ^ Yr(Rr, 19) ^ Yr(Rr, 10)) | 0) + x2 | 0, Si = dr + zs | 0, x2 = ((Me + (Si & (Qe ^ ni) ^ Qe) | 0) + (Yr(Si, 26) ^ Yr(Si, 21) ^ Yr(Si, 7)) | 0) - 1841331548 | 0, Me = Qe + Oi | 0, Qe = (((dr | Rr) & $r | dr & Rr) + (Yr(dr, 30) ^ Yr(dr, 19) ^ Yr(dr, 10)) | 0) + Va | 0, Oi = Qe + x2 | 0, Va = ((Me + (Oi & (ni ^ Si) ^ ni) | 0) + (Yr(Oi, 26) ^ Yr(Oi, 21) ^ Yr(Oi, 7)) | 0) - 1424204075 | 0, Me = ni + Ho | 0, Rr = (((dr | Qe) & Rr | dr & Qe) + (Yr(Qe, 30) ^ Yr(Qe, 19) ^ Yr(Qe, 10)) | 0) + js | 0, ni = Rr + Va | 0, Ho = ((Me + (ni & (Si ^ Oi) ^ Si) | 0) + (Yr(ni, 26) ^ Yr(ni, 21) ^ Yr(ni, 7)) | 0) - 670586216 | 0, Me = Si + Ao | 0, dr = (((Rr | Qe) & dr | Rr & Qe) + (Yr(Rr, 30) ^ Yr(Rr, 19) ^ Yr(Rr, 10)) | 0) + ya | 0, Si = dr + Ho | 0, Ao = ((Me + (Si & (ni ^ Oi) ^ Oi) | 0) + (Yr(Si, 26) ^ Yr(Si, 21) ^ Yr(Si, 7)) | 0) + 310598401 | 0, Me = Oi + _o | 0, Qe = (((dr | Rr) & Qe | dr & Rr) + (Yr(dr, 30) ^ Yr(dr, 19) ^ Yr(dr, 10)) | 0) + zs | 0, Oi = Qe + Ao | 0, _o = ((Me + (Oi & (ni ^ Si) ^ ni) | 0) + (Yr(Oi, 26) ^ Yr(Oi, 21) ^ Yr(Oi, 7)) | 0) + 607225278 | 0, Me = ni + Uo | 0, Rr = (((dr | Qe) & Rr | dr & Qe) + (Yr(Qe, 30) ^ Yr(Qe, 19) ^ Yr(Qe, 10)) | 0) + x2 | 0, ni = Rr + _o | 0, Uo = ((Me + (ni & (Si ^ Oi) ^ Si) | 0) + (Yr(ni, 26) ^ Yr(ni, 21) ^ Yr(ni, 7)) | 0) + 1426881987 | 0, Me = Si + po | 0, dr = (((Rr | Qe) & dr | Rr & Qe) + (Yr(Rr, 30) ^ Yr(Rr, 19) ^ Yr(Rr, 10)) | 0) + Va | 0, Si = dr + Uo | 0, po = ((Me + (Si & (ni ^ Oi) ^ Oi) | 0) + (Yr(Si, 26) ^ Yr(Si, 21) ^ Yr(Si, 7)) | 0) + 1925078388 | 0, Me = Oi + Ta | 0, Qe = (((dr | Rr) & Qe | dr & Rr) + (Yr(dr, 30) ^ Yr(dr, 19) ^ Yr(dr, 10)) | 0) + Ho | 0, Oi = Qe + po | 0, Ho = ((Me + (Oi & (ni ^ Si) ^ ni) | 0) + (Yr(Oi, 26) ^ Yr(Oi, 21) ^ Yr(Oi, 7)) | 0) - 2132889090 | 0, Me = ni + Ti | 0, Rr = (((dr | Qe) & Rr | dr & Qe) + (Yr(Qe, 30) ^ Yr(Qe, 19) ^ Yr(Qe, 10)) | 0) + Ao | 0, Ti = Rr + Ho | 0, ni = ((Me + (Ti & (Si ^ Oi) ^ Si) | 0) + (Yr(Ti, 26) ^ Yr(Ti, 21) ^ Yr(Ti, 7)) | 0) - 1680079193 | 0, Me = Si + Sn | 0, dr = (((Rr | Qe) & dr | Rr & Qe) + (Yr(Rr, 30) ^ Yr(Rr, 19) ^ Yr(Rr, 10)) | 0) + _o | 0, Sn = dr + ni | 0, Si = ((Me + (Sn & (Oi ^ Ti) ^ Oi) | 0) + (Yr(Sn, 26) ^ Yr(Sn, 21) ^ Yr(Sn, 7)) | 0) - 1046744716 | 0, Me = he + Oi | 0, he = (((dr | Rr) & Qe | dr & Rr) + (Yr(dr, 30) ^ Yr(dr, 19) ^ Yr(dr, 10)) | 0) + Uo | 0, Qe = he + Si | 0, Oi = ((Me + (Qe & (Ti ^ Sn) ^ Ti) | 0) + (Yr(Qe, 26) ^ Yr(Qe, 21) ^ Yr(Qe, 7)) | 0) - 459576895 | 0, Me = we + Ti | 0, we = (((he | dr) & Rr | he & dr) + (Yr(he, 30) ^ Yr(he, 19) ^ Yr(he, 10)) | 0) + po | 0, Rr = we + Oi | 0, Ti = ((Me + (Rr & (Qe ^ Sn) ^ Sn) | 0) + (Yr(Rr, 26) ^ Yr(Rr, 21) ^ Yr(Rr, 7)) | 0) - 272742522 | 0, Me = Fr + Sn | 0, Fr = (((he | we) & dr | he & we) + (Yr(we, 30) ^ Yr(we, 19) ^ Yr(we, 10)) | 0) + Ho | 0, dr = Fr + Ti | 0, Sn = ((Me + (dr & (Rr ^ Qe) ^ Qe) | 0) + (Yr(dr, 26) ^ Yr(dr, 21) ^ Yr(dr, 7)) | 0) + 264347078 | 0, Me = wr + Qe | 0, he = (((we | Fr) & he | we & Fr) + (Yr(Fr, 30) ^ Yr(Fr, 19) ^ Yr(Fr, 10)) | 0) + ni | 0, Qe = he + Sn | 0, ni = ((Me + (Qe & (dr ^ Rr) ^ Rr) | 0) + (Yr(Qe, 26) ^ Yr(Qe, 21) ^ Yr(Qe, 7)) | 0) + 604807628 | 0, Me = Rr + Gr | 0, we = (((he | Fr) & we | he & Fr) + (Yr(he, 30) ^ Yr(he, 19) ^ Yr(he, 10)) | 0) + Si | 0, Gr = we + ni | 0, Rr = ((Me + (Gr & (dr ^ Qe) ^ dr) | 0) + (Yr(Gr, 26) ^ Yr(Gr, 21) ^ Yr(Gr, 7)) | 0) + 770255983 | 0, Me = dr + Dr | 0, wr = (((he | we) & Fr | he & we) + (Yr(we, 30) ^ Yr(we, 19) ^ Yr(we, 10)) | 0) + Oi | 0, Dr = wr + Rr | 0, dr = ((Me + (Dr & (Qe ^ Gr) ^ Qe) | 0) + (Yr(Dr, 26) ^ Yr(Dr, 21) ^ Yr(Dr, 7)) | 0) + 1249150122 | 0, he = (((we | wr) & he | we & wr) + (Yr(wr, 30) ^ Yr(wr, 19) ^ Yr(wr, 10)) | 0) + Ti | 0, Fr = he + dr | 0, mi = (((Qe + mi | 0) + (Fr & (Dr ^ Gr) ^ Gr) | 0) + (Yr(Fr, 26) ^ Yr(Fr, 21) ^ Yr(Fr, 7)) | 0) + 1555081692 | 0, Me = d + Gr | 0, d = (((he | wr) & we | he & wr) + (Yr(he, 30) ^ Yr(he, 19) ^ Yr(he, 10)) | 0) + Sn | 0, we = d + mi | 0, Gr = ((Me + (we & (Dr ^ Fr) ^ Dr) | 0) + (Yr(we, 26) ^ Yr(we, 21) ^ Yr(we, 7)) | 0) + 1996064986 | 0, Me = v + Dr | 0, v = (((d | he) & wr | d & he) + (Yr(d, 30) ^ Yr(d, 19) ^ Yr(d, 10)) | 0) + ni | 0, wr = v + Gr | 0, Qe = ((Me + (wr & (we ^ Fr) ^ Fr) | 0) + (Yr(wr, 26) ^ Yr(wr, 21) ^ Yr(wr, 7)) | 0) - 1740746414 | 0, he = (((d | v) & he | d & v) + (Yr(v, 30) ^ Yr(v, 19) ^ Yr(v, 10)) | 0) + Rr | 0, Dr = he + Qe | 0, Fr = (((Fr + un | 0) + (Dr & (we ^ wr) ^ we) | 0) + (Yr(Dr, 26) ^ Yr(Dr, 21) ^ Yr(Dr, 7)) | 0) - 1473132947 | 0, Me = we + Io | 0, d = (((v | he) & d | v & he) + (Yr(he, 30) ^ Yr(he, 19) ^ Yr(he, 10)) | 0) + dr | 0, we = d + Fr | 0, un = ((Me + (we & (wr ^ Dr) ^ wr) | 0) + (Yr(we, 26) ^ Yr(we, 21) ^ Yr(we, 7)) | 0) - 1341970488 | 0, Me = wr + In | 0, v = (((d | he) & v | d & he) + (Yr(d, 30) ^ Yr(d, 19) ^ Yr(d, 10)) | 0) + mi | 0, wr = v + un | 0, mi = ((Me + (wr & (we ^ Dr) ^ Dr) | 0) + (Yr(wr, 26) ^ Yr(wr, 21) ^ Yr(wr, 7)) | 0) - 1084653625 | 0, Me = Dr + Mo | 0, he = (((d | v) & he | d & v) + (Yr(v, 30) ^ Yr(v, 19) ^ Yr(v, 10)) | 0) + Gr | 0, Dr = he + mi | 0, Gr = ((Me + (Dr & (we ^ wr) ^ we) | 0) + (Yr(Dr, 26) ^ Yr(Dr, 21) ^ Yr(Dr, 7)) | 0) - 958395405 | 0, Me = we + Kn | 0, d = (((v | he) & d | v & he) + (Yr(he, 30) ^ Yr(he, 19) ^ Yr(he, 10)) | 0) + Qe | 0, we = d + Gr | 0, In = ((Me + (we & (wr ^ Dr) ^ wr) | 0) + (Yr(we, 26) ^ Yr(we, 21) ^ Yr(we, 7)) | 0) - 710438585 | 0, Me = wr + xo | 0, v = (((d | he) & v | d & he) + (Yr(d, 30) ^ Yr(d, 19) ^ Yr(d, 10)) | 0) + Fr | 0, wr = v + In | 0, Fr = ((Me + (wr & (we ^ Dr) ^ Dr) | 0) + (Yr(wr, 26) ^ Yr(wr, 21) ^ Yr(wr, 7)) | 0) + 113926993 | 0, Me = Be + Dr | 0, Be = (((d | v) & he | d & v) + (Yr(v, 30) ^ Yr(v, 19) ^ Yr(v, 10)) | 0) + un | 0, he = Be + Fr | 0, Dr = ((Me + (he & (we ^ wr) ^ we) | 0) + (Yr(he, 26) ^ Yr(he, 21) ^ Yr(he, 7)) | 0) + 338241895 | 0, Me = we + qi | 0, d = (((v | Be) & d | v & Be) + (Yr(Be, 30) ^ Yr(Be, 19) ^ Yr(Be, 10)) | 0) + mi | 0, we = d + Dr | 0, mi = ((Me + (we & (he ^ wr) ^ wr) | 0) + (Yr(we, 26) ^ Yr(we, 21) ^ Yr(we, 7)) | 0) + 666307205 | 0, Me = wr + Go | 0, v = (((d | Be) & v | d & Be) + (Yr(d, 30) ^ Yr(d, 19) ^ Yr(d, 10)) | 0) + Gr | 0, wr = v + mi | 0, Gr = ((Me + (wr & (he ^ we) ^ he) | 0) + (Yr(wr, 26) ^ Yr(wr, 21) ^ Yr(wr, 7)) | 0) + 773529912 | 0, Me = he + Oo | 0, Be = (((d | v) & Be | d & v) + (Yr(v, 30) ^ Yr(v, 19) ^ Yr(v, 10)) | 0) + In | 0, he = Be + Gr | 0, un = ((Me + (he & (we ^ wr) ^ we) | 0) + (Yr(he, 26) ^ Yr(he, 21) ^ Yr(he, 7)) | 0) + 1294757372 | 0, Me = we + Xn | 0, d = (((v | Be) & d | v & Be) + (Yr(Be, 30) ^ Yr(Be, 19) ^ Yr(Be, 10)) | 0) + Fr | 0, we = d + un | 0, Fr = ((Me + (we & (he ^ wr) ^ wr) | 0) + (Yr(we, 26) ^ Yr(we, 21) ^ Yr(we, 7)) | 0) + 1396182291 | 0, Me = wr + Vn | 0, v = (((d | Be) & v | d & Be) + (Yr(d, 30) ^ Yr(d, 19) ^ Yr(d, 10)) | 0) + Dr | 0, wr = v + Fr | 0, Dr = ((Me + (wr & (he ^ we) ^ he) | 0) + (Yr(wr, 26) ^ Yr(wr, 21) ^ Yr(wr, 7)) | 0) + 1695183700 | 0, Me = he + uo | 0, Be = (((d | v) & Be | d & v) + (Yr(v, 30) ^ Yr(v, 19) ^ Yr(v, 10)) | 0) + mi | 0, he = Be + Dr | 0, mi = ((Me + (he & (we ^ wr) ^ we) | 0) + (Yr(he, 26) ^ Yr(he, 21) ^ Yr(he, 7)) | 0) + 1986661051 | 0, Me = we + fr | 0, d = (((v | Be) & d | v & Be) + (Yr(Be, 30) ^ Yr(Be, 19) ^ Yr(Be, 10)) | 0) + Gr | 0, fr = d + mi | 0, Gr = ((Me + (fr & (he ^ wr) ^ wr) | 0) + (Yr(fr, 26) ^ Yr(fr, 21) ^ Yr(fr, 7)) | 0) - 2117940946 | 0, v = (((d | Be) & v | d & Be) + (Yr(d, 30) ^ Yr(d, 19) ^ Yr(d, 10)) | 0) + un | 0, we = v + Gr | 0, wr = (((wr + ns | 0) + (we & (he ^ fr) ^ he) | 0) + (Yr(we, 26) ^ Yr(we, 21) ^ Yr(we, 7)) | 0) - 1838011259 | 0, Me = he + Wo | 0, Be = (((d | v) & Be | d & v) + (Yr(v, 30) ^ Yr(v, 19) ^ Yr(v, 10)) | 0) + Fr | 0, he = Be + wr | 0, Fr = ((Me + (he & (we ^ fr) ^ fr) | 0) + (Yr(he, 26) ^ Yr(he, 21) ^ Yr(he, 7)) | 0) - 1564481375 | 0, Me = fr + ts | 0, d = (((v | Be) & d | v & Be) + (Yr(Be, 30) ^ Yr(Be, 19) ^ Yr(Be, 10)) | 0) + Dr | 0, fr = d + Fr | 0, Dr = ((Me + (fr & (he ^ we) ^ we) | 0) + (Yr(fr, 26) ^ Yr(fr, 21) ^ Yr(fr, 7)) | 0) - 1474664885 | 0, Me = we + ds | 0, v = (((d | Be) & v | d & Be) + (Yr(d, 30) ^ Yr(d, 19) ^ Yr(d, 10)) | 0) + mi | 0, we = v + Dr | 0, mi = ((Me + (we & (he ^ fr) ^ he) | 0) + (Yr(we, 26) ^ Yr(we, 21) ^ Yr(we, 7)) | 0) - 1035236496 | 0, Me = he + Lo | 0, Be = (((d | v) & Be | d & v) + (Yr(v, 30) ^ Yr(v, 19) ^ Yr(v, 10)) | 0) + Gr | 0, he = Be + mi | 0, Gr = ((Me + (he & (we ^ fr) ^ fr) | 0) + (Yr(he, 26) ^ Yr(he, 21) ^ Yr(he, 7)) | 0) - 949202525 | 0, Me = fr + ps | 0, d = (((v | Be) & d | v & Be) + (Yr(Be, 30) ^ Yr(Be, 19) ^ Yr(Be, 10)) | 0) + wr | 0, fr = d + Gr | 0, wr = ((Me + (fr & (he ^ we) ^ we) | 0) + (Yr(fr, 26) ^ Yr(fr, 21) ^ Yr(fr, 7)) | 0) - 778901479 | 0, Me = we + zi | 0, v = (((d | Be) & v | d & Be) + (Yr(d, 30) ^ Yr(d, 19) ^ Yr(d, 10)) | 0) + Fr | 0, we = v + wr | 0, Fr = ((Me + (we & (he ^ fr) ^ he) | 0) + (Yr(we, 26) ^ Yr(we, 21) ^ Yr(we, 7)) | 0) - 694614492 | 0, Me = he + $i | 0, Be = (((d | v) & Be | d & v) + (Yr(v, 30) ^ Yr(v, 19) ^ Yr(v, 10)) | 0) + Dr | 0, he = Be + Fr | 0, Dr = ((Me + (he & (we ^ fr) ^ fr) | 0) + (Yr(he, 26) ^ Yr(he, 21) ^ Yr(he, 7)) | 0) - 200395387 | 0, Me = fr + Bs | 0, d = (((v | Be) & d | v & Be) + (Yr(Be, 30) ^ Yr(Be, 19) ^ Yr(Be, 10)) | 0) + mi | 0, fr = d + Dr | 0, mi = ((Me + (fr & (he ^ we) ^ we) | 0) + (Yr(fr, 26) ^ Yr(fr, 21) ^ Yr(fr, 7)) | 0) + 275423344 | 0, Me = we + Ts | 0, v = (((d | Be) & v | d & Be) + (Yr(d, 30) ^ Yr(d, 19) ^ Yr(d, 10)) | 0) + Gr | 0, we = v + mi | 0, Gr = ((Me + (we & (he ^ fr) ^ he) | 0) + (Yr(we, 26) ^ Yr(we, 21) ^ Yr(we, 7)) | 0) + 430227734 | 0, Me = he + ta | 0, Be = (((d | v) & Be | d & v) + (Yr(v, 30) ^ Yr(v, 19) ^ Yr(v, 10)) | 0) + wr | 0, he = Be + Gr | 0, wr = ((Me + (he & (we ^ fr) ^ fr) | 0) + (Yr(he, 26) ^ Yr(he, 21) ^ Yr(he, 7)) | 0) + 506948616 | 0, Me = fr + wa | 0, d = (((v | Be) & d | v & Be) + (Yr(Be, 30) ^ Yr(Be, 19) ^ Yr(Be, 10)) | 0) + Fr | 0, fr = d + wr | 0, un = ((Me + (fr & (he ^ we) ^ we) | 0) + (Yr(fr, 26) ^ Yr(fr, 21) ^ Yr(fr, 7)) | 0) + 659060556 | 0, Me = we + Na | 0, v = (((d | Be) & v | d & Be) + (Yr(d, 30) ^ Yr(d, 19) ^ Yr(d, 10)) | 0) + Dr | 0, we = v + un | 0, Dr = ((Me + (we & (he ^ fr) ^ he) | 0) + (Yr(we, 26) ^ Yr(we, 21) ^ Yr(we, 7)) | 0) + 883997877 | 0, Me = he + oa | 0, Be = (((d | v) & Be | d & v) + (Yr(v, 30) ^ Yr(v, 19) ^ Yr(v, 10)) | 0) + mi | 0, he = Be + Dr | 0, mi = ((Me + (he & (we ^ fr) ^ fr) | 0) + (Yr(he, 26) ^ Yr(he, 21) ^ Yr(he, 7)) | 0) + 958139571 | 0, Me = fr + ba | 0, d = (((v | Be) & d | v & Be) + (Yr(Be, 30) ^ Yr(Be, 19) ^ Yr(Be, 10)) | 0) + Gr | 0, fr = d + mi | 0, In = ((Me + (fr & (he ^ we) ^ we) | 0) + (Yr(fr, 26) ^ Yr(fr, 21) ^ Yr(fr, 7)) | 0) + 1322822218 | 0, Me = we + va | 0, v = (((d | Be) & v | d & Be) + (Yr(d, 30) ^ Yr(d, 19) ^ Yr(d, 10)) | 0) + wr | 0, we = v + In | 0, Kn = ((Me + (we & (he ^ fr) ^ he) | 0) + (Yr(we, 26) ^ Yr(we, 21) ^ Yr(we, 7)) | 0) + 1537002063 | 0, Fr = (((Yr(Wo, 25) ^ Yr(Wo, 14) ^ Wo >>> 3) + ns | 0) + Ts | 0) + (Yr(ba, 15) ^ Yr(ba, 13) ^ ba >>> 10) | 0, Me = Fr + he | 0, Be = (((d | v) & Be | d & v) + (Yr(v, 30) ^ Yr(v, 19) ^ Yr(v, 10)) | 0) + un | 0, he = Be + Kn | 0, un = ((Me + (he & (we ^ fr) ^ fr) | 0) + (Yr(he, 26) ^ Yr(he, 21) ^ Yr(he, 7)) | 0) + 1747873779 | 0, Me = fr + sa | 0, d = (((v | Be) & d | v & Be) + (Yr(Be, 30) ^ Yr(Be, 19) ^ Yr(Be, 10)) | 0) + Dr | 0, fr = d + un | 0, Dr = ((Me + (fr & (he ^ we) ^ we) | 0) + (Yr(fr, 26) ^ Yr(fr, 21) ^ Yr(fr, 7)) | 0) + 1955562222 | 0, Gr = ((Yr(ps, 25) ^ Yr(ps, 14) ^ ps >>> 3) + Lo | 0) + oa | 0, wr = (((Yr(ds, 25) ^ Yr(ds, 14) ^ ds >>> 3) + ts | 0) + wa | 0) + (Yr(Fr, 15) ^ Yr(Fr, 13) ^ Fr >>> 10) | 0, Gr = Gr + (Yr(wr, 15) ^ Yr(wr, 13) ^ wr >>> 10) | 0, Me = we + wr | 0, v = (((d | Be) & v | d & Be) + (Yr(d, 30) ^ Yr(d, 19) ^ Yr(d, 10)) | 0) + mi | 0, we = v + Dr | 0, mi = ((Me + (we & (he ^ fr) ^ he) | 0) + (Yr(we, 26) ^ Yr(we, 21) ^ Yr(we, 7)) | 0) + 2024104815 | 0, Me = he + ea | 0, Be = (((d | v) & Be | d & v) + (Yr(v, 30) ^ Yr(v, 19) ^ Yr(v, 10)) | 0) + In | 0, he = Be + mi | 0, In = ((Me + (he & (we ^ fr) ^ fr) | 0) + (Yr(he, 26) ^ Yr(he, 21) ^ Yr(he, 7)) | 0) - 2067236844 | 0, d = (((v | Be) & d | v & Be) + (Yr(Be, 30) ^ Yr(Be, 19) ^ Yr(Be, 10)) | 0) + Kn | 0, wr = d + In | 0, Kn = (((fr + Gr | 0) + (wr & (he ^ we) ^ we) | 0) + (Yr(wr, 26) ^ Yr(wr, 21) ^ Yr(wr, 7)) | 0) - 1933114872 | 0, Me = we + e | 0, v = (((d | Be) & v | d & Be) + (Yr(d, 30) ^ Yr(d, 19) ^ Yr(d, 10)) | 0) + un | 0, we = v + Kn | 0, un = ((Me + (we & (he ^ wr) ^ he) | 0) + (Yr(we, 26) ^ Yr(we, 21) ^ Yr(we, 7)) | 0) - 1866530822 | 0, Be = (((d | v) & Be | d & v) + (Yr(v, 30) ^ Yr(v, 19) ^ Yr(v, 10)) | 0) + Dr | 0, Dr = un + Be | 0, a[B + 28 >> 2] = Dr + Pa, fr = (((v | Be) & d | v & Be) + (Yr(Be, 30) ^ Yr(Be, 19) ^ Yr(Be, 10)) | 0) + mi | 0, d = ((v & (fr | Be) | Be & fr) + (Yr(fr, 30) ^ Yr(fr, 19) ^ Yr(fr, 10)) | 0) + In | 0, v = (((d | fr) & Be | d & fr) + (Yr(d, 30) ^ Yr(d, 19) ^ Yr(d, 10)) | 0) + Kn | 0, Be = (((v | d) & fr | d & v) + (Yr(v, 30) ^ Yr(v, 19) ^ Yr(v, 10)) | 0) + un | 0, a[B + 12 >> 2] = Be + Se, js = fr, Me = he, he = (((Yr($i, 25) ^ Yr($i, 14) ^ $i >>> 3) + zi | 0) + va | 0) + (Yr(Gr, 15) ^ Yr(Gr, 13) ^ Gr >>> 10) | 0, fr = (((Me + he | 0) + (Dr & (we ^ wr) ^ wr) | 0) + (Yr(Dr, 26) ^ Yr(Dr, 21) ^ Yr(Dr, 7)) | 0) - 1538233109 | 0, zi = js + fr | 0, a[B + 24 >> 2] = zi + Je, fr = (((v | Be) & d | v & Be) + (Yr(Be, 30) ^ Yr(Be, 19) ^ Yr(Be, 10)) | 0) + fr | 0, a[B + 8 >> 2] = fr + N2, Me = d, d = (((((($i + (Yr(Bs, 25) ^ Yr(Bs, 14) ^ Bs >>> 3) | 0) + Fr | 0) + (Yr(e, 15) ^ Yr(e, 13) ^ e >>> 10) | 0) + wr | 0) + (zi & (we ^ Dr) ^ we) | 0) + (Yr(zi, 26) ^ Yr(zi, 21) ^ Yr(zi, 7)) | 0) - 1090935817 | 0, $i = Me + d | 0, a[B + 20 >> 2] = $i + Aa, d = (((Be | fr) & v | Be & fr) + (Yr(fr, 30) ^ Yr(fr, 19) ^ Yr(fr, 10)) | 0) + d | 0, a[B + 4 >> 2] = d + Xs, Me = v + yo | 0, v = ((((((Bs + (Yr(Ts, 25) ^ Yr(Ts, 14) ^ Ts >>> 3) | 0) + sa | 0) + (Yr(he, 15) ^ Yr(he, 13) ^ he >>> 10) | 0) + we | 0) + ($i & (Dr ^ zi) ^ Dr) | 0) + (Yr($i, 26) ^ Yr($i, 21) ^ Yr($i, 7)) | 0) - 965641998 | 0, a[B + 16 >> 2] = Me + v, df = B, zo = (($r + ((d | fr) & Be | d & fr) | 0) + (Yr(d, 30) ^ Yr(d, 19) ^ Yr(d, 10)) | 0) + v | 0, a[df >> 2] = zo, o = o + jn | 0, m = m - jn | 0, jn = 64, d = 0, m >>> 0 > 63; )
        ;
    m && dn((B + d | 0) + 32 | 0, o, m);
  }
  function _n(B, o) {
    var m = 0, d = 0, v = 0;
    d = be - 16 | 0, be = d, m = a[B + 100 >> 2], v = a[B + 96 >> 2], u[d + 11 | 0] = (m & 536870911) << 3 | v >>> 29, u[d + 10 | 0] = m >>> 5, u[d + 9 | 0] = m >>> 13, u[d + 8 | 0] = m >>> 21, u[d + 15 | 0] = v << 3, u[d + 14 | 0] = v >>> 5, u[d + 13 | 0] = v >>> 13, u[d + 12 | 0] = v >>> 21, Di(B, 690512, (55 - v & 63) + 1 | 0), Di(B, d + 8 | 0, 8), m = a[B >> 2], m = m << 8 & 16711680 | m << 24 | (m >>> 8 & 65280 | m >>> 24), u[o | 0] = m, u[o + 1 | 0] = m >>> 8, u[o + 2 | 0] = m >>> 16, u[o + 3 | 0] = m >>> 24, a[B >> 2] = 0, m = a[B + 4 >> 2], m = m << 8 & 16711680 | m << 24 | (m >>> 8 & 65280 | m >>> 24), u[o + 4 | 0] = m, u[o + 5 | 0] = m >>> 8, u[o + 6 | 0] = m >>> 16, u[o + 7 | 0] = m >>> 24, a[B + 4 >> 2] = 0, m = a[B + 8 >> 2], m = m << 8 & 16711680 | m << 24 | (m >>> 8 & 65280 | m >>> 24), u[o + 8 | 0] = m, u[o + 9 | 0] = m >>> 8, u[o + 10 | 0] = m >>> 16, u[o + 11 | 0] = m >>> 24, a[B + 8 >> 2] = 0, m = a[B + 12 >> 2], m = m << 8 & 16711680 | m << 24 | (m >>> 8 & 65280 | m >>> 24), u[o + 12 | 0] = m, u[o + 13 | 0] = m >>> 8, u[o + 14 | 0] = m >>> 16, u[o + 15 | 0] = m >>> 24, a[B + 12 >> 2] = 0, m = a[B + 16 >> 2], m = m << 8 & 16711680 | m << 24 | (m >>> 8 & 65280 | m >>> 24), u[o + 16 | 0] = m, u[o + 17 | 0] = m >>> 8, u[o + 18 | 0] = m >>> 16, u[o + 19 | 0] = m >>> 24, a[B + 16 >> 2] = 0, m = a[B + 20 >> 2], m = m << 8 & 16711680 | m << 24 | (m >>> 8 & 65280 | m >>> 24), u[o + 20 | 0] = m, u[o + 21 | 0] = m >>> 8, u[o + 22 | 0] = m >>> 16, u[o + 23 | 0] = m >>> 24, a[B + 20 >> 2] = 0, m = a[B + 24 >> 2], m = m << 8 & 16711680 | m << 24 | (m >>> 8 & 65280 | m >>> 24), u[o + 24 | 0] = m, u[o + 25 | 0] = m >>> 8, u[o + 26 | 0] = m >>> 16, u[o + 27 | 0] = m >>> 24, a[B + 24 >> 2] = 0, m = a[B + 28 >> 2], m = m << 8 & 16711680 | m << 24 | (m >>> 8 & 65280 | m >>> 24), u[o + 28 | 0] = m, u[o + 29 | 0] = m >>> 8, u[o + 30 | 0] = m >>> 16, u[o + 31 | 0] = m >>> 24, a[B + 28 >> 2] = 0, be = d + 16 | 0;
  }
  function On(B, o, m, d) {
    var v = 0, he = 0, we = 0, Be = 0, Me = 0, fr = 0, wr = 0, dr = 0, Dr = 0, Rr = 0, Qe = 0, Fr = 0, Gr = 0, $r = 0, ni = 0, mi = 0, Si = 0, Oi = 0, $i = 0, zi = 0, un = 0, In = 0, Ti = 0, Sn = 0, Kn = 0, Vn = 0, Xn = 0, uo = 0, yo = 0, Io = 0, xo = 0, Mo = 0, qi = 0, Oo = 0, Ho = 0, Go = 0, ns = 0, ds = 0, Ts = 0, Ao = 0, po = 0, _o = 0, Uo = 0, ts = 0, Lo = 0, Wo = 0, ps = 0;
    we = be - 880 | 0, be = we;
    e: {
      if (!o) {
        ji[a[B + 168 >> 2]](689638, a[B + 172 >> 2]), B = 0;
        break e;
      }
      if (u[o | 0] = 0, u[o + 1 | 0] = 0, u[o + 2 | 0] = 0, u[o + 3 | 0] = 0, u[o + 4 | 0] = 0, u[o + 5 | 0] = 0, u[o + 6 | 0] = 0, u[o + 7 | 0] = 0, v = o + 56 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = o + 48 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = o + 40 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = o + 32 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = o + 24 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = o + 16 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = o + 8 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, !m) {
        ji[a[B + 168 >> 2]](689668, a[B + 172 >> 2]), B = 0;
        break e;
      }
      B = 0;
      t: {
        if ((d | 0) != 65) {
          if ((d | 0) != 33 || (A[m | 0] & 254) != 2)
            break e;
          if (!so(we + 840 | 0, m + 1 | 0)) {
            d = 0;
            break t;
          }
          d = (Do(we + 672 | 0, we + 840 | 0, A[m | 0] == 3) | 0) != 0;
          break t;
        }
        if (d = A[m | 0], d >>> 0 > 7 || !(1 << d & 208))
          break e;
        if (d = 0, !so(we + 800 | 0, m + 1 | 0) || !so(we + 760 | 0, m + 33 | 0) || (Be = we + 800 | 0, he = Be + 8 | 0, v = a[he + 4 >> 2], Me = we + 672 | 0, d = Me + 8 | 0, a[d >> 2] = a[he >> 2], a[d + 4 >> 2] = v, he = Be + 16 | 0, v = a[he + 4 >> 2], d = Me + 16 | 0, a[d >> 2] = a[he >> 2], a[d + 4 >> 2] = v, he = Be + 24 | 0, v = a[he + 4 >> 2], d = Me + 24 | 0, a[d >> 2] = a[he >> 2], a[d + 4 >> 2] = v, he = Be + 32 | 0, v = a[he + 4 >> 2], d = Me + 32 | 0, a[d >> 2] = a[he >> 2], a[d + 4 >> 2] = v, he = we + 760 | 0, v = he + 8 | 0, d = a[v + 4 >> 2], mi = we + 720 | 0, a[mi >> 2] = a[v >> 2], a[mi + 4 >> 2] = d, v = he + 16 | 0, d = a[v + 4 >> 2], Qe = we + 728 | 0, a[Qe >> 2] = a[v >> 2], a[Qe + 4 >> 2] = d, v = he + 24 | 0, d = a[v + 4 >> 2], Be = we + 736 | 0, a[Be >> 2] = a[v >> 2], a[Be + 4 >> 2] = d, v = he + 32 | 0, d = a[v + 4 >> 2], zi = we + 744 | 0, a[zi >> 2] = a[v >> 2], a[zi + 4 >> 2] = d, a[we + 752 >> 2] = 0, d = a[we + 804 >> 2], a[we + 672 >> 2] = a[we + 800 >> 2], a[we + 676 >> 2] = d, d = a[we + 764 >> 2], a[we + 712 >> 2] = a[we + 760 >> 2], a[we + 716 >> 2] = d, m = A[m | 0], (m & 254) == 6 && (d = 0, (u[we + 760 | 0] & 1) == ((m | 0) != 7 | 0))))
          break t;
        m = a[we + 716 >> 2], Kn = m, fr = a[we + 712 >> 2], d = fr, m = m << 1 | d >>> 31, Fr = we + 96 | 0, wr = a[Be >> 2], dr = a[Be + 4 >> 2], un = d << 1, Xn = m, Lr(Fr, wr, dr, 0, 0, un, m, 0, 0), m = a[mi + 4 >> 2], In = m, Ti = a[mi >> 2], v = Ti, m = m << 1 | v >>> 31, Dr = we + 160 | 0, Rr = a[Qe >> 2], Qe = a[Qe + 4 >> 2], v = v << 1, he = m, Lr(Dr, Rr, Qe, 0, 0, v, m, 0, 0), mi = we + 288 | 0, d = a[zi >> 2], m = a[zi + 4 >> 2], Lr(mi, d, m, 0, 0, d, m, 0, 0), Be = we + 272 | 0, Lr(Be, a[we + 288 >> 2], a[we + 292 >> 2], 0, 0, 15632, 16, 0, 0), m = m << 1 | d >>> 31, Io = we + 128 | 0, $r = d << 1, zi = m, Lr(Io, $r, m, 0, 0, fr, Kn, 0, 0), xo = we + 144 | 0, Lr(xo, wr, dr, 0, 0, v, he, 0, 0), Mo = we + 224 | 0, Lr(Mo, Rr, Qe, 0, 0, Rr, Qe, 0, 0), Gr = we + 256 | 0, m = mi + 8 | 0, Lr(Gr, a[m >> 2], a[m + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Ao = we + 112 | 0, Lr(Ao, fr, Kn, 0, 0, fr, Kn, 0, 0), uo = we + 192 | 0, Lr(uo, $r, zi, 0, 0, Ti, In, 0, 0), Ho = we + 240 | 0, Lr(Ho, wr, dr, 0, 0, Rr << 1, Qe << 1 | Rr >>> 31, 0, 0), Kn = a[we + 100 >> 2], m = Kn + a[we + 164 >> 2] | 0, Me = a[we + 96 >> 2], d = a[we + 160 >> 2], he = Me + d | 0, v = a[we + 272 >> 2], Go = he + v | 0, d = d >>> 0 > he >>> 0 ? m + 1 | 0 : m, m = d + a[we + 276 >> 2] | 0, v = v >>> 0 > Go >>> 0 ? m + 1 | 0 : m, fr = (d | 0) == (v | 0) & he >>> 0 > Go >>> 0 | d >>> 0 > v >>> 0, m = Be + 8 | 0, mi = a[m >> 2], Be = a[m + 4 >> 2], Me = (d | 0) == (Kn | 0) & he >>> 0 < Me >>> 0 | d >>> 0 < Kn >>> 0, he = Dr + 8 | 0, d = a[he >> 2], m = Fr + 8 | 0, Dr = d + a[m >> 2] | 0, m = a[m + 4 >> 2] + a[he + 4 >> 2] | 0, m = d >>> 0 > Dr >>> 0 ? m + 1 | 0 : m, d = Me + Dr | 0, m = (d >>> 0 < Dr >>> 0 ? m + 1 | 0 : m) + Be | 0, he = d, d = d + mi | 0, m = he >>> 0 > d >>> 0 ? m + 1 | 0 : m, he = d, d = d + fr | 0, m = he >>> 0 > d >>> 0 ? m + 1 | 0 : m, ns = v, mi = d << 12 | v >>> 20, he = m, Me = m << 12 | d >>> 20, Oi = a[we + 144 >> 2], d = a[we + 224 >> 2], Dr = Oi + d | 0, yo = a[we + 148 >> 2], m = yo + a[we + 228 >> 2] | 0, m = d >>> 0 > Dr >>> 0 ? m + 1 | 0 : m, d = a[we + 128 >> 2], fr = d + Dr | 0, Fr = m, m = m + a[we + 132 >> 2] | 0, m = d >>> 0 > fr >>> 0 ? m + 1 | 0 : m, d = a[we + 256 >> 2], Be = d + fr | 0, v = m, m = m + a[we + 260 >> 2] | 0, d = d >>> 0 > Be >>> 0 ? m + 1 | 0 : m, m = d + Me | 0, po = we + 32 | 0, Vn = po, mi = Be + mi | 0, Me = mi >>> 0 < Be >>> 0 ? m + 1 | 0 : m, Sn = (d | 0) == (Me | 0) & Be >>> 0 > mi >>> 0 | d >>> 0 > Me >>> 0, $i = (d | 0) == (v | 0) & Be >>> 0 < fr >>> 0 | d >>> 0 < v >>> 0, m = Gr + 8 | 0, ni = a[m >> 2], Si = a[m + 4 >> 2], Kn = (v | 0) == (Fr | 0) & fr >>> 0 < Dr >>> 0 | v >>> 0 < Fr >>> 0, m = Io + 8 | 0, Gr = a[m >> 2], fr = a[m + 4 >> 2], Be = (Fr | 0) == (yo | 0) & Dr >>> 0 < Oi >>> 0 | Fr >>> 0 < yo >>> 0, v = Mo + 8 | 0, d = a[v >> 2], m = xo + 8 | 0, Dr = d + a[m >> 2] | 0, m = a[m + 4 >> 2] + a[v + 4 >> 2] | 0, m = d >>> 0 > Dr >>> 0 ? m + 1 | 0 : m, d = Be + Dr | 0, m = (d >>> 0 < Dr >>> 0 ? m + 1 | 0 : m) + fr | 0, v = d, d = d + Gr | 0, m = v >>> 0 > d >>> 0 ? m + 1 | 0 : m, v = d, d = d + Kn | 0, m = (v >>> 0 > d >>> 0 ? m + 1 | 0 : m) + Si | 0, v = d, d = d + ni | 0, m = v >>> 0 > d >>> 0 ? m + 1 | 0 : m, v = d + $i | 0, m = v >>> 0 < d >>> 0 ? m + 1 | 0 : m, he = he >>> 20 | 0, d = v + he | 0, m = he >>> 0 > d >>> 0 ? m + 1 | 0 : m, he = d, d = d + Sn | 0, m = he >>> 0 > d >>> 0 ? m + 1 | 0 : m, v = Me, Be = d << 12 | v >>> 20, he = m, Me = m << 12 | d >>> 20, ni = a[we + 192 >> 2], d = a[we + 240 >> 2], fr = ni + d | 0, $i = a[we + 196 >> 2], m = $i + a[we + 244 >> 2] | 0, d = d >>> 0 > fr >>> 0 ? m + 1 | 0 : m, m = d + Me | 0, Be = Be + fr | 0, m = Be >>> 0 < fr >>> 0 ? m + 1 | 0 : m, Fr = Be << 4 & -16, Me = m, Dr = (m << 4 | Be >>> 28) & 16777215, Kn = v, Lr(Vn, Fr | v >>> 16 & 15, Dr, 0, 0, 977, 1, 0, 0), _o = we + 16 | 0, Lr(_o, Ti, In, 0, 0, un, Xn, 0, 0), Si = we + 208 | 0, Lr(Si, $r, zi, 0, 0, Rr, Qe, 0, 0), Gr = we + 320 | 0, Lr(Gr, wr, dr, 0, 0, wr, dr, 0, 0), Uo = we + 80 | 0, Fr = Uo, Dr = (d | 0) == (m | 0) & Be >>> 0 < fr >>> 0 | d >>> 0 > m >>> 0, Be = (d | 0) == ($i | 0) & fr >>> 0 < ni >>> 0 | d >>> 0 < $i >>> 0, v = Ho + 8 | 0, d = a[v >> 2], m = uo + 8 | 0, fr = d + a[m >> 2] | 0, m = a[m + 4 >> 2] + a[v + 4 >> 2] | 0, m = d >>> 0 > fr >>> 0 ? m + 1 | 0 : m, v = Be + fr | 0, m = v >>> 0 < fr >>> 0 ? m + 1 | 0 : m, he = he >>> 20 | 0, d = v + he | 0, m = he >>> 0 > d >>> 0 ? m + 1 | 0 : m, he = d, d = d + Dr | 0, m = he >>> 0 > d >>> 0 ? m + 1 | 0 : m, Me = d << 12 | Me >>> 20, v = m, fr = m << 12 | d >>> 20, ni = a[we + 212 >> 2], m = ni + a[we + 324 >> 2] | 0, Dr = a[we + 208 >> 2], d = a[we + 320 >> 2], he = Dr + d | 0, Be = he, Me = he + Me | 0, d = d >>> 0 > he >>> 0 ? m + 1 | 0 : m, m = d + fr | 0, he = he >>> 0 > Me >>> 0 ? m + 1 | 0 : m, Lr(Fr, Me, he & 1048575, 0, 0, 15632, 16, 0, 0), Lr(we, Rr, Qe, 0, 0, un, Xn, 0, 0), ts = we + 176 | 0, Lr(ts, Ti, In, 0, 0, Ti, In, 0, 0), fr = we + 304 | 0, Lr(fr, $r, zi, 0, 0, wr, dr, 0, 0), Lo = we - -64 | 0, dr = Lo, Qe = (d | 0) == (he | 0) & Be >>> 0 > Me >>> 0 | d >>> 0 > he >>> 0, Be = (d | 0) == (ni | 0) & Be >>> 0 < Dr >>> 0 | d >>> 0 < ni >>> 0, Me = Gr + 8 | 0, d = a[Me >> 2], m = Si + 8 | 0, wr = d + a[m >> 2] | 0, m = a[m + 4 >> 2] + a[Me + 4 >> 2] | 0, m = d >>> 0 > wr >>> 0 ? m + 1 | 0 : m, Me = Be + wr | 0, m = Me >>> 0 < wr >>> 0 ? m + 1 | 0 : m, v = v >>> 20 | 0, d = v + Me | 0, m = v >>> 0 > d >>> 0 ? m + 1 | 0 : m, v = d, d = d + Qe | 0, m = v >>> 0 > d >>> 0 ? m + 1 | 0 : m, Me = d << 12 | he >>> 20, he = a[we + 304 >> 2], Qe = Me + he | 0, v = m, d = m << 12 | d >>> 20, m = d + a[we + 308 >> 2] | 0, m = he >>> 0 > Qe >>> 0 ? m + 1 | 0 : m, Lr(dr, Qe, m, 0, 0, 15632, 16, 0, 0), Wo = we + 48 | 0, Be = Wo, Me = (m | 0) == (d | 0) & Me >>> 0 > Qe >>> 0 | m >>> 0 < d >>> 0, m = fr + 8 | 0, he = a[m >> 2], m = a[m + 4 >> 2], v = v >>> 20 | 0, d = v + he | 0, m = v >>> 0 > d >>> 0 ? m + 1 | 0 : m, he = d, d = d + Me | 0, m = he >>> 0 > d >>> 0 ? m + 1 | 0 : m, Lr(Be, d, m, 0, 0, 64028672, 65536, 0, 0), m = a[we + 676 >> 2], Rr = m, dr = a[we + 672 >> 2], d = dr, m = m << 1 | d >>> 31, fr = we + 432 | 0, Gr = a[we + 696 >> 2], Fr = a[we + 700 >> 2], Sn = d << 1, Vn = m, Lr(fr, Gr, Fr, 0, 0, Sn, m, 0, 0), m = a[we + 684 >> 2], Ts = m, ds = a[we + 680 >> 2], v = ds, m = m << 1 | v >>> 31, wr = we + 496 | 0, ni = a[we + 688 >> 2], $r = a[we + 692 >> 2], v = v << 1, he = m, Lr(wr, ni, $r, 0, 0, v, m, 0, 0), Qe = we + 624 | 0, d = a[we + 704 >> 2], m = a[we + 708 >> 2], Lr(Qe, d, m, 0, 0, d, m, 0, 0), Be = we + 608 | 0, Lr(Be, a[we + 624 >> 2], a[we + 628 >> 2], 0, 0, 15632, 16, 0, 0), m = m << 1 | d >>> 31, Ti = we + 464 | 0, Ho = d << 1, $i = m, Lr(Ti, Ho, m, 0, 0, dr, Rr, 0, 0), yo = we + 480 | 0, Lr(yo, Gr, Fr, 0, 0, v, he, 0, 0), Io = we + 560 | 0, Lr(Io, ni, $r, 0, 0, ni, $r, 0, 0), Dr = we + 592 | 0, m = Qe + 8 | 0, Lr(Dr, a[m >> 2], a[m + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), ps = we + 448 | 0, Lr(ps, dr, Rr, 0, 0, dr, Rr, 0, 0), qi = we + 528 | 0, Lr(qi, Ho, $i, 0, 0, ds, Ts, 0, 0), Oo = we + 576 | 0, Lr(Oo, Gr, Fr, 0, 0, ni << 1, $r << 1 | ni >>> 31, 0, 0), Rr = a[we + 436 >> 2], m = Rr + a[we + 500 >> 2] | 0, Me = a[we + 432 >> 2], d = a[we + 496 >> 2], v = Me + d | 0, he = a[we + 608 >> 2], Xn = v + he | 0, d = d >>> 0 > v >>> 0 ? m + 1 | 0 : m, m = d + a[we + 612 >> 2] | 0, he = he >>> 0 > Xn >>> 0 ? m + 1 | 0 : m, dr = (d | 0) == (he | 0) & v >>> 0 > Xn >>> 0 | d >>> 0 > he >>> 0, m = Be + 8 | 0, Qe = a[m >> 2], Be = a[m + 4 >> 2], Me = (d | 0) == (Rr | 0) & v >>> 0 < Me >>> 0 | d >>> 0 < Rr >>> 0, v = wr + 8 | 0, d = a[v >> 2], m = fr + 8 | 0, wr = d + a[m >> 2] | 0, m = a[m + 4 >> 2] + a[v + 4 >> 2] | 0, m = d >>> 0 > wr >>> 0 ? m + 1 | 0 : m, d = Me + wr | 0, m = (d >>> 0 < wr >>> 0 ? m + 1 | 0 : m) + Be | 0, v = d, d = d + Qe | 0, m = v >>> 0 > d >>> 0 ? m + 1 | 0 : m, v = d, d = d + dr | 0, m = v >>> 0 > d >>> 0 ? m + 1 | 0 : m, un = he, Qe = d << 12 | he >>> 20, v = m, Me = m << 12 | d >>> 20, xo = a[we + 480 >> 2], d = a[we + 560 >> 2], dr = xo + d | 0, In = a[we + 484 >> 2], m = In + a[we + 564 >> 2] | 0, m = d >>> 0 > dr >>> 0 ? m + 1 | 0 : m, d = a[we + 464 >> 2], Be = d + dr | 0, fr = m, m = m + a[we + 468 >> 2] | 0, m = d >>> 0 > Be >>> 0 ? m + 1 | 0 : m, d = a[we + 592 >> 2], he = d + Be | 0, wr = m, m = m + a[we + 596 >> 2] | 0, d = d >>> 0 > he >>> 0 ? m + 1 | 0 : m, m = d + Me | 0, Mo = we + 368 | 0, Qe = he + Qe | 0, Me = Qe >>> 0 < he >>> 0 ? m + 1 | 0 : m, uo = (d | 0) == (Me | 0) & he >>> 0 > Qe >>> 0 | d >>> 0 > Me >>> 0, Oi = (d | 0) == (wr | 0) & he >>> 0 < Be >>> 0 | d >>> 0 < wr >>> 0, m = Dr + 8 | 0, Si = a[m >> 2], zi = a[m + 4 >> 2], Rr = (fr | 0) == (wr | 0) & Be >>> 0 < dr >>> 0 | fr >>> 0 > wr >>> 0, m = Ti + 8 | 0, Dr = a[m >> 2], wr = a[m + 4 >> 2], Be = (fr | 0) == (In | 0) & dr >>> 0 < xo >>> 0 | fr >>> 0 < In >>> 0, he = Io + 8 | 0, d = a[he >> 2], m = yo + 8 | 0, dr = d + a[m >> 2] | 0, m = a[m + 4 >> 2] + a[he + 4 >> 2] | 0, m = d >>> 0 > dr >>> 0 ? m + 1 | 0 : m, d = Be + dr | 0, m = (d >>> 0 < dr >>> 0 ? m + 1 | 0 : m) + wr | 0, he = d, d = d + Dr | 0, m = he >>> 0 > d >>> 0 ? m + 1 | 0 : m, he = d, d = d + Rr | 0, m = (he >>> 0 > d >>> 0 ? m + 1 | 0 : m) + zi | 0, he = d, d = d + Si | 0, m = he >>> 0 > d >>> 0 ? m + 1 | 0 : m, he = d + Oi | 0, m = he >>> 0 < d >>> 0 ? m + 1 | 0 : m, v = v >>> 20 | 0, d = v + he | 0, m = v >>> 0 > d >>> 0 ? m + 1 | 0 : m, he = d, d = d + uo | 0, m = he >>> 0 > d >>> 0 ? m + 1 | 0 : m, v = Me, Be = d << 12 | v >>> 20, he = m, dr = m << 12 | d >>> 20, Oi = a[we + 532 >> 2], m = Oi + a[we + 580 >> 2] | 0, Rr = a[we + 528 >> 2], d = a[we + 576 >> 2], Me = Rr + d | 0, fr = Me, Be = Me + Be | 0, d = d >>> 0 > Me >>> 0 ? m + 1 | 0 : m, m = d + dr | 0, wr = Be << 4 & -16, Me = Be >>> 0 < Me >>> 0 ? m + 1 | 0 : m, dr = (Me << 4 | Be >>> 28) & 16777215, zi = v, Lr(Mo, wr | v >>> 16 & 15, dr, 0, 0, 977, 1, 0, 0), dr = a[we + 372 >> 2], m = dr + a[we + 452 >> 2] | 0, uo = a[we + 368 >> 2], v = a[we + 448 >> 2], wr = uo + v | 0, a[we + 840 >> 2] = wr, v = v >>> 0 > wr >>> 0 ? m + 1 | 0 : m, a[we + 844 >> 2] = v & 1048575, In = we + 352 | 0, Lr(In, ds, Ts, 0, 0, Sn, Vn, 0, 0), Ti = we + 544 | 0, Lr(Ti, Ho, $i, 0, 0, ni, $r, 0, 0), yo = we + 656 | 0, Lr(yo, Gr, Fr, 0, 0, Gr, Fr, 0, 0), Io = we + 416 | 0, Si = Io, Dr = (d | 0) == (Me | 0) & Be >>> 0 < fr >>> 0 | d >>> 0 > Me >>> 0, fr = (d | 0) == (Oi | 0) & fr >>> 0 < Rr >>> 0 | d >>> 0 < Oi >>> 0, Be = Oo + 8 | 0, d = a[Be >> 2], m = qi + 8 | 0, Rr = d + a[m >> 2] | 0, m = a[m + 4 >> 2] + a[Be + 4 >> 2] | 0, m = d >>> 0 > Rr >>> 0 ? m + 1 | 0 : m, Be = fr + Rr | 0, m = Be >>> 0 < Rr >>> 0 ? m + 1 | 0 : m, he = he >>> 20 | 0, d = he + Be | 0, m = he >>> 0 > d >>> 0 ? m + 1 | 0 : m, he = d, d = d + Dr | 0, m = he >>> 0 > d >>> 0 ? m + 1 | 0 : m, fr = d << 12 | Me >>> 20, Be = m, Me = m << 12 | d >>> 20, qi = a[we + 548 >> 2], m = qi + a[we + 660 >> 2] | 0, xo = a[we + 544 >> 2], he = a[we + 656 >> 2], d = xo + he | 0, Oi = d, Rr = d + fr | 0, he = d >>> 0 < he >>> 0 ? m + 1 | 0 : m, m = he + Me | 0, fr = Rr >>> 0 < d >>> 0 ? m + 1 | 0 : m, Lr(Si, Rr, fr & 1048575, 0, 0, 15632, 16, 0, 0), wr = (v | 0) == (dr | 0) & wr >>> 0 < uo >>> 0 | v >>> 0 < dr >>> 0, Me = ps + 8 | 0, d = a[Me >> 2], m = Mo + 8 | 0, Dr = d + a[m >> 2] | 0, m = a[m + 4 >> 2] + a[Me + 4 >> 2] | 0, m = d >>> 0 > Dr >>> 0 ? m + 1 | 0 : m, d = wr + Dr | 0, m = d >>> 0 < Dr >>> 0 ? m + 1 | 0 : m, Dr = d << 12 | v >>> 20, Me = m, wr = m << 12 | d >>> 20, Mo = a[we + 416 >> 2], d = a[we + 352 >> 2], Si = Mo + d | 0, Oo = a[we + 420 >> 2], m = Oo + a[we + 356 >> 2] | 0, v = d >>> 0 > Si >>> 0 ? m + 1 | 0 : m, m = v + wr | 0, Dr = Dr + Si | 0, m = Dr >>> 0 < Si >>> 0 ? m + 1 | 0 : m, a[we + 848 >> 2] = Dr, wr = m, a[we + 852 >> 2] = m & 1048575, uo = we + 336 | 0, Lr(uo, ni, $r, 0, 0, Sn, Vn, 0, 0), Vn = we + 512 | 0, Lr(Vn, ds, Ts, 0, 0, ds, Ts, 0, 0), Sn = we + 640 | 0, Lr(Sn, Ho, $i, 0, 0, Gr, Fr, 0, 0), ni = we + 400 | 0, Gr = ni, $r = (he | 0) == (fr | 0) & Rr >>> 0 < Oi >>> 0 | he >>> 0 > fr >>> 0, Rr = (he | 0) == (qi | 0) & Oi >>> 0 < xo >>> 0 | he >>> 0 < qi >>> 0, he = yo + 8 | 0, d = a[he >> 2], m = Ti + 8 | 0, Fr = d + a[m >> 2] | 0, m = a[m + 4 >> 2] + a[he + 4 >> 2] | 0, m = d >>> 0 > Fr >>> 0 ? m + 1 | 0 : m, he = Rr + Fr | 0, m = he >>> 0 < Fr >>> 0 ? m + 1 | 0 : m, Be = Be >>> 20 | 0, d = he + Be | 0, m = Be >>> 0 > d >>> 0 ? m + 1 | 0 : m, he = d, d = d + $r | 0, m = he >>> 0 > d >>> 0 ? m + 1 | 0 : m, Fr = d << 12 | fr >>> 20, Be = a[we + 640 >> 2], fr = Fr + Be | 0, he = m, Oi = m << 12 | d >>> 20, m = Oi + a[we + 644 >> 2] | 0, Rr = Be >>> 0 > fr >>> 0 ? m + 1 | 0 : m, Lr(Gr, fr, Rr, 0, 0, 15632, 16, 0, 0), Dr = (v | 0) == (wr | 0) & Dr >>> 0 < Si >>> 0 | v >>> 0 > wr >>> 0, dr = (v | 0) == (Oo | 0) & Si >>> 0 < Mo >>> 0 | v >>> 0 < Oo >>> 0, v = In + 8 | 0, d = a[v >> 2], m = Io + 8 | 0, $r = d + a[m >> 2] | 0, m = a[m + 4 >> 2] + a[v + 4 >> 2] | 0, m = d >>> 0 > $r >>> 0 ? m + 1 | 0 : m, v = dr + $r | 0, m = v >>> 0 < $r >>> 0 ? m + 1 | 0 : m, Me = Me >>> 20 | 0, d = v + Me | 0, m = Me >>> 0 > d >>> 0 ? m + 1 | 0 : m, v = d, d = d + Dr | 0, m = v >>> 0 > d >>> 0 ? m + 1 | 0 : m, dr = d << 12 | wr >>> 20, v = m, Me = m << 12 | d >>> 20, Si = a[we + 336 >> 2], d = a[we + 512 >> 2], Dr = Si + d | 0, $i = a[we + 340 >> 2], m = $i + a[we + 516 >> 2] | 0, m = d >>> 0 > Dr >>> 0 ? m + 1 | 0 : m, d = a[we + 400 >> 2], wr = d + Dr | 0, $r = m, m = m + a[we + 404 >> 2] | 0, d = d >>> 0 > wr >>> 0 ? m + 1 | 0 : m, m = d + Me | 0, dr = dr + wr | 0, m = dr >>> 0 < wr >>> 0 ? m + 1 | 0 : m, a[we + 856 >> 2] = dr, Me = m, a[we + 860 >> 2] = m & 1048575, Gr = we + 384 | 0, Fr = (Rr | 0) == (Oi | 0) & fr >>> 0 < Fr >>> 0 | Rr >>> 0 < Oi >>> 0, m = Sn + 8 | 0, Rr = a[m >> 2], m = a[m + 4 >> 2], he = he >>> 20 | 0, Be = he, he = he + Rr | 0, m = Be >>> 0 > he >>> 0 ? m + 1 | 0 : m, Be = he, he = he + Fr | 0, m = Be >>> 0 > he >>> 0 ? m + 1 | 0 : m, Lr(Gr, he, m, 0, 0, 64028672, 65536, 0, 0), Fr = (d | 0) == (Me | 0) & dr >>> 0 < wr >>> 0 | d >>> 0 > Me >>> 0, Rr = (d | 0) == ($r | 0) & wr >>> 0 < Dr >>> 0 | d >>> 0 < $r >>> 0, m = ni + 8 | 0, fr = a[m >> 2], wr = a[m + 4 >> 2], dr = ($r | 0) == ($i | 0) & Dr >>> 0 < Si >>> 0 | $r >>> 0 < $i >>> 0, Be = Vn + 8 | 0, d = a[Be >> 2], m = uo + 8 | 0, Dr = d + a[m >> 2] | 0, m = a[m + 4 >> 2] + a[Be + 4 >> 2] | 0, m = d >>> 0 > Dr >>> 0 ? m + 1 | 0 : m, d = dr + Dr | 0, m = (d >>> 0 < Dr >>> 0 ? m + 1 | 0 : m) + wr | 0, he = d, d = d + fr | 0, m = he >>> 0 > d >>> 0 ? m + 1 | 0 : m, Be = d + Rr | 0, m = Be >>> 0 < d >>> 0 ? m + 1 | 0 : m, v = v >>> 20 | 0, d = v + Be | 0, m = v >>> 0 > d >>> 0 ? m + 1 | 0 : m, he = d, d = d + Fr | 0, m = he >>> 0 > d >>> 0 ? m + 1 | 0 : m, Be = d << 12 | Me >>> 20, v = m, wr = m << 12 | d >>> 20, Dr = a[we + 384 >> 2], Me = Xn & -2, d = Dr + Me | 0, Rr = a[we + 388 >> 2], m = Rr + (un & 1048575) | 0, dr = d >>> 0 < Me >>> 0 ? m + 1 | 0 : m, m = dr + wr | 0, he = Be, Be = d, Me = he + d | 0, a[we + 864 >> 2] = Me, d = d >>> 0 > Me >>> 0 ? m + 1 | 0 : m, a[we + 868 >> 2] = d & 1048575, fr = zi & 65535, wr = (d | 0) == (dr | 0) & Be >>> 0 > Me >>> 0 | d >>> 0 < dr >>> 0, he = (dr | 0) == (Rr | 0) & Be >>> 0 < Dr >>> 0 | dr >>> 0 < Rr >>> 0, m = Gr + 8 | 0, Me = he + a[m >> 2] | 0, m = a[m + 4 >> 2], m = he >>> 0 > Me >>> 0 ? m + 1 | 0 : m, v = v >>> 20 | 0, he = v, v = v + Me | 0, m = he >>> 0 > v >>> 0 ? m + 1 | 0 : m, he = v, v = v + wr | 0, m = he >>> 0 > v >>> 0 ? m + 1 | 0 : m, d = v << 12 | d >>> 20, he = d + Qe | 0, m = fr + (m << 12 | v >>> 20) | 0, a[we + 872 >> 2] = he, a[we + 876 >> 2] = d >>> 0 > he >>> 0 ? m + 1 | 0 : m, m = Ao + 8 | 0, Be = a[m >> 2], Me = a[m + 4 >> 2], m = po + 8 | 0, yo = a[m >> 2], v = a[m + 4 >> 2], he = a[we + 112 >> 2], d = a[we + 116 >> 2], Rr = a[we + 32 >> 2], qi = a[we + 36 >> 2], m = _o + 8 | 0, Si = a[m >> 2], Gr = a[m + 4 >> 2], m = Uo + 8 | 0, Io = a[m >> 2], un = a[m + 4 >> 2], ni = a[we + 16 >> 2], Dr = a[we + 20 >> 2], xo = a[we + 80 >> 2], Oo = a[we + 84 >> 2], m = ts + 8 | 0, Fr = a[m >> 2], $r = a[m + 4 >> 2], m = we + 8 | 0, Mo = a[m >> 2], Xn = a[m + 4 >> 2], Oi = a[we + 176 >> 2], fr = a[we + 180 >> 2], Vn = a[we >> 2], In = a[we + 4 >> 2], m = Lo + 8 | 0, dr = a[m >> 2], Qe = a[m + 4 >> 2], Sn = a[we + 64 >> 2], wr = a[we + 68 >> 2], uo = a[we + 48 >> 2], Ti = a[we + 52 >> 2], m = Wo + 8 | 0, Ho = a[m >> 2], zi = a[m + 4 >> 2], m = we + 840 | 0, gn(m, m, we + 672 | 0), m = d + qi | 0, d = he + Rr | 0, he = d >>> 0 < he >>> 0 ? m + 1 | 0 : m, $i = d, d = (qi | 0) == (he | 0) & d >>> 0 < Rr >>> 0 | he >>> 0 < qi >>> 0, m = v + Me | 0, v = Be + yo | 0, m = v >>> 0 < yo >>> 0 ? m + 1 | 0 : m, d = d + v | 0, m = d >>> 0 < v >>> 0 ? m + 1 | 0 : m, Rr = he, Be = d << 12 | he >>> 20, v = m, Me = m << 12 | d >>> 20, m = Dr + Oo | 0, he = ni + xo | 0, d = he >>> 0 < ni >>> 0 ? m + 1 | 0 : m, m = d + Me | 0, ni = he + Be | 0, Me = ni >>> 0 < he >>> 0 ? m + 1 | 0 : m, Be = (d | 0) == (Me | 0) & he >>> 0 > ni >>> 0 | d >>> 0 > Me >>> 0, d = (d | 0) == (Oo | 0) & he >>> 0 < xo >>> 0 | d >>> 0 < Oo >>> 0, m = Gr + un | 0, he = Si + Io | 0, m = he >>> 0 < Io >>> 0 ? m + 1 | 0 : m, Si = he, he = d + he | 0, m = Si >>> 0 > he >>> 0 ? m + 1 | 0 : m, v = v >>> 20 | 0, d = v + he | 0, m = v >>> 0 > d >>> 0 ? m + 1 | 0 : m, he = d, d = d + Be | 0, m = he >>> 0 > d >>> 0 ? m + 1 | 0 : m, Dr = Me, un = d << 12 | Me >>> 20, he = m, Be = m << 12 | d >>> 20, m = fr + In | 0, d = Oi + Vn | 0, v = d >>> 0 < Oi >>> 0 ? m + 1 | 0 : m, m = wr + v | 0, wr = d, Me = d + Sn | 0, d = Me >>> 0 < Sn >>> 0 ? m + 1 | 0 : m, m = d + Be | 0, fr = Me, Be = Me + un | 0, Me = Me >>> 0 > Be >>> 0 ? m + 1 | 0 : m, Si = Be, un = (d | 0) == (Me | 0) & Be >>> 0 < fr >>> 0 | d >>> 0 > Me >>> 0, m = v, fr = (m | 0) == (d | 0) & fr >>> 0 < wr >>> 0 | m >>> 0 > d >>> 0, v = dr, d = Qe, Be = (m | 0) == (In | 0) & wr >>> 0 < Vn >>> 0 | m >>> 0 < In >>> 0, m = $r + Xn | 0, Qe = Fr + Mo | 0, m = Qe >>> 0 < Mo >>> 0 ? m + 1 | 0 : m, Be = Be + Qe | 0, m = (Be >>> 0 < Qe >>> 0 ? m + 1 | 0 : m) + d | 0, d = v + Be | 0, m = d >>> 0 < Be >>> 0 ? m + 1 | 0 : m, v = d + fr | 0, m = v >>> 0 < d >>> 0 ? m + 1 | 0 : m, he = he >>> 20 | 0, d = v + he | 0, m = he >>> 0 > d >>> 0 ? m + 1 | 0 : m, he = d, d = d + un | 0, m = he >>> 0 > d >>> 0 ? m + 1 | 0 : m, fr = Me, Me = d << 12 | Me >>> 20, v = m, he = m << 12 | d >>> 20, d = Go & -2, Gr = d + uo | 0, m = Ti + (ns & 1048575) | 0, d = d >>> 0 > Gr >>> 0 ? m + 1 | 0 : m, m = d + he | 0, he = Me + Gr | 0, m = he >>> 0 < Gr >>> 0 ? m + 1 | 0 : m, ns = he, Me = m, Oi = a[we + 864 >> 2], Vn = a[we + 868 >> 2], Sn = a[we + 856 >> 2], Xn = a[we + 860 >> 2], un = a[we + 848 >> 2], wr = a[we + 852 >> 2], Be = a[we + 844 >> 2], Qe = a[we + 872 >> 2], he = a[we + 876 >> 2], Go = he, m = a[we + 840 >> 2], he = oi(he >>> 16 | 0, 0, 977, 1), dr = m + he | 0, m = Be + Fe | 0, m = he >>> 0 > dr >>> 0 ? m + 1 | 0 : m, he = dr + 7 | 0, m = he >>> 0 < 7 ? m + 1 | 0 : m, Fr = he, Be = m, m = wr, he = Be >>> 20 | 0, wr = he, he = he + un | 0, m = wr >>> 0 > he >>> 0 ? m + 1 | 0 : m, $r = he, wr = m, m = Xn, he = wr >>> 20 | 0, dr = he, he = he + Sn | 0, m = dr >>> 0 > he >>> 0 ? m + 1 | 0 : m, Xn = he, dr = m, m = Vn, he = dr >>> 20 | 0, Vn = he, he = he + Oi | 0, m = Vn >>> 0 > he >>> 0 ? m + 1 | 0 : m, un = he, he = m, Sn = Fr - $i | 0, $i = (Be & 1048575) - ((Rr & 1048575) + (Fr >>> 0 < $i >>> 0) | 0) | 0, Go = Go & 65535, Fr = Kn & 65535, Rr = (d | 0) == (Me | 0) & Gr >>> 0 > ns >>> 0 | d >>> 0 > Me >>> 0, d = (d | 0) == (Ti | 0) & Gr >>> 0 < uo >>> 0 | d >>> 0 < Ti >>> 0, Be = d + Ho | 0, m = zi, m = d >>> 0 > Be >>> 0 ? m + 1 | 0 : m, v = v >>> 20 | 0, d = v + Be | 0, m = v >>> 0 > d >>> 0 ? m + 1 | 0 : m, v = d, d = d + Rr | 0, m = v >>> 0 > d >>> 0 ? m + 1 | 0 : m, v = d << 12 | Me >>> 20, Be = v + mi | 0, m = Fr + (m << 12 | d >>> 20) | 0, m = v >>> 0 > Be >>> 0 ? m + 1 | 0 : m, v = Qe - Be | 0, m = Go - ((Be >>> 0 > Qe >>> 0) + m | 0) | 0, Be = he >>> 20 | 0, d = v + Be | 0, m = (Be >>> 0 > d >>> 0 ? m + 1 | 0 : m) + 262143 | 0, d = d - 4 | 0, Qe = d >>> 0 < 4294967292 ? m + 1 | 0 : m, v = oi(Qe >>> 16 | 0, 0, 977, 1), Be = v + Sn | 0, m = $i + Fe | 0, m = (v >>> 0 > Be >>> 0 ? m + 1 | 0 : m) + 4194299 | 0, v = Be - 3908 | 0, m = v >>> 0 < 4294963388 ? m + 1 | 0 : m, Kn = v ^ 976, Be = m & 1048575, Gr = Be ^ 1, ((Kn | 0) != -1 | (Gr | 0) != 1048575) & (v | Be) != 0 ? d = 0 : (Fr = un - ns | 0, zi = (he & 1048575) - ((Me & 1048575) + (un >>> 0 < ns >>> 0) | 0) | 0, Rr = Xn - Si | 0, mi = (dr & 1048575) - ((fr & 1048575) + (Si >>> 0 > Xn >>> 0) | 0) | 0, v = m, m = (wr & 1048575) - ((Dr & 1048575) + ($r >>> 0 < ni >>> 0) | 0) | 0, v = v >>> 20 | 0, he = v, v = v + ($r - ni | 0) | 0, m = (he >>> 0 > v >>> 0 ? m + 1 | 0 : m) + 4194303 | 0, Be = v - 4 | 0, Me = Be >>> 0 < 4294967292 ? m + 1 | 0 : m, m = mi, v = Me >>> 20 | 0, he = v, v = v + Rr | 0, m = (he >>> 0 > v >>> 0 ? m + 1 | 0 : m) + 4194303 | 0, he = v - 4 | 0, v = he >>> 0 < 4294967292 ? m + 1 | 0 : m, m = zi, mi = v >>> 20 | 0, fr = mi, mi = Fr + mi | 0, m = (fr >>> 0 > mi >>> 0 ? m + 1 | 0 : m) + 4194303 | 0, mi = mi - 4 | 0, m = mi >>> 0 < 4294967292 ? m + 1 | 0 : m, Be = mi & (Be & Kn & he), Me = m & (Me & Gr & v), v = d, d = m, m = Qe & 65535, d = d >>> 20 | 0, he = d, d = d + v | 0, m = he >>> 0 > d >>> 0 ? m + 1 | 0 : m, d = (d & Be) == -1 & (Me & (m ^ 983040)) == 1048575);
      }
      if (!d)
        break e;
      Gn(o, we + 672 | 0), B = 1;
    }
    return be = we + 880 | 0, B;
  }
  function so(B, o) {
    var m = 0, d = 0, v = 0, he = 0, we = 0, Be = 0, Me = 0, fr = 0, wr = 0, dr = 0, Dr = 0, Rr = 0;
    return v = B, m = A[o + 30 | 0], B = m >>> 24 | 0, d = A[o + 31 | 0] | m << 8, m = B, he = A[o + 29 | 0], B = he >>> 16 | 0, he = he << 16 | d, d = B | m, m = A[o + 28 | 0], B = m >>> 8 | 0, m = m << 24 | he, B = A[o + 27 | 0] | (B | d) | A[o + 26 | 0] << 8 | (A[o + 25 | 0] & 15) << 16, he = B, Rr = m, a[v >> 2] = m, a[v + 4 >> 2] = B, m = A[o + 24 | 0], B = m >>> 28 | 0, we = m << 4 | A[o + 25 | 0] >>> 4, m = B, d = A[o + 23 | 0], B = d >>> 20 | 0, d = d << 12 | we, we = B | m, m = A[o + 22 | 0], B = m >>> 12 | 0, d = m << 20 | d, we = B | we, m = A[o + 21 | 0], B = m >>> 4 | 0, m = m << 28 | d, d = B | we | A[o + 20 | 0] << 4, B = A[o + 19 | 0] << 12, we = m, a[v + 8 >> 2] = m, wr = B | d, a[v + 12 >> 2] = wr, m = A[o + 17 | 0], B = m >>> 24 | 0, Me = A[o + 18 | 0] | m << 8, m = B, d = A[o + 16 | 0], B = d >>> 16 | 0, d = d << 16 | Me, Me = B | m, m = A[o + 15 | 0], B = m >>> 8 | 0, m = m << 24 | d, d = A[o + 14 | 0] | (B | Me) | A[o + 13 | 0] << 8, B = (A[o + 12 | 0] & 15) << 16, Me = m, a[v + 16 >> 2] = m, dr = B | d, a[v + 20 >> 2] = dr, m = A[o + 11 | 0], B = m >>> 28 | 0, Be = m << 4 | A[o + 12 | 0] >>> 4, m = B, d = A[o + 10 | 0], B = d >>> 20 | 0, d = d << 12 | Be, Be = B | m, m = A[o + 9 | 0], B = m >>> 12 | 0, d = m << 20 | d, Be = B | Be, m = A[o + 8 | 0], B = m >>> 4 | 0, m = m << 28 | d, d = B | Be | A[o + 7 | 0] << 4, B = A[o + 6 | 0] << 12, Be = m, a[v + 24 >> 2] = m, Dr = B | d, a[v + 28 >> 2] = Dr, m = A[o + 4 | 0], B = m >>> 24 | 0, fr = A[o + 5 | 0] | m << 8, m = B, d = A[o + 3 | 0], B = d >>> 16 | 0, d = d << 16 | fr, fr = B | m, m = A[o + 2 | 0], B = m >>> 8 | 0, m = m << 24 | d, d = A[o + 1 | 0] | (B | fr), B = A[o | 0] << 8, a[v + 32 >> 2] = m, B = B | d, a[v + 36 >> 2] = B, (we & Me & Be) != -1 | (wr & dr & Dr) != 1048575 | ((m | 0) != -1 | (B | 0) != 65535) | ((he | 0) == 1048574 & Rr >>> 0 < 4294966319 | he >>> 0 < 1048574);
  }
  function Do(B, o, m) {
    var d = 0, v = 0, he = 0, we = 0, Be = 0, Me = 0, fr = 0, wr = 0, dr = 0, Dr = 0, Rr = 0, Qe = 0, Fr = 0, Gr = 0, $r = 0, ni = 0, mi = 0, Si = 0, Oi = 0, $i = 0, zi = 0, un = 0, In = 0, Ti = 0, Sn = 0, Kn = 0, Vn = 0, Xn = 0, uo = 0, yo = 0, Io = 0, xo = 0, Mo = 0, qi = 0, Oo = 0, Ho = 0, Go = 0, ns = 0, ds = 0, Ts = 0, Ao = 0, po = 0;
    for (we = be - 7616 | 0, be = we, he = o + 32 | 0, v = a[he + 4 >> 2], d = B + 32 | 0, a[d >> 2] = a[he >> 2], a[d + 4 >> 2] = v, he = o + 24 | 0, v = a[he + 4 >> 2], d = B + 24 | 0, a[d >> 2] = a[he >> 2], a[d + 4 >> 2] = v, he = o + 16 | 0, v = a[he + 4 >> 2], d = B + 16 | 0, a[d >> 2] = a[he >> 2], a[d + 4 >> 2] = v, he = o + 8 | 0, v = a[he + 4 >> 2], d = B + 8 | 0, a[d >> 2] = a[he >> 2], a[d + 4 >> 2] = v, d = a[o + 4 >> 2], a[B >> 2] = a[o >> 2], a[B + 4 >> 2] = d, d = we + 7096 | 0, na(d, o), ds = we + 7056 | 0, gn(ds, o, d), a[B + 80 >> 2] = 0, d = a[we + 7060 >> 2], v = a[we + 7056 >> 2] + 7 | 0, o = v >>> 0 < 7 ? d + 1 | 0 : d, d = v, a[we + 7056 >> 2] = d, a[we + 7060 >> 2] = o, Rr = we + 6848 | 0, Oi = a[we + 7080 >> 2], $r = a[we + 7084 >> 2], Kn = d << 1, Be = d, $i = o << 1 | d >>> 31, Lr(Rr, Oi, $r, 0, 0, Kn, $i, 0, 0), d = a[we + 7068 >> 2], ns = d, Io = a[we + 7064 >> 2], he = Io, d = d << 1 | he >>> 31, Dr = we + 6880 | 0, un = a[we + 7072 >> 2], ni = a[we + 7076 >> 2], he = he << 1, Me = d, Lr(Dr, un, ni, 0, 0, he, d, 0, 0), fr = we + 7008 | 0, v = a[we + 7088 >> 2], d = a[we + 7092 >> 2], Lr(fr, v, d, 0, 0, v, d, 0, 0), wr = we + 6992 | 0, Lr(wr, a[we + 7008 >> 2], a[we + 7012 >> 2], 0, 0, 15632, 16, 0, 0), d = d << 1 | v >>> 31, uo = we + 6800 | 0, zi = v << 1, Si = d, Lr(uo, zi, d, 0, 0, Be, o, 0, 0), Oo = we + 6864 | 0, Lr(Oo, Oi, $r, 0, 0, he, Me, 0, 0), Xn = we + 6944 | 0, Lr(Xn, un, ni, 0, 0, un, ni, 0, 0), Qe = we + 6976 | 0, d = fr + 8 | 0, Lr(Qe, a[d >> 2], a[d + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Go = we + 6720 | 0, Lr(Go, Be, o, 0, 0, Be, o, 0, 0), Ho = we + 6912 | 0, Lr(Ho, zi, Si, 0, 0, Io, ns, 0, 0), Mo = we + 6960 | 0, Lr(Mo, Oi, $r, 0, 0, un << 1, ni << 1 | un >>> 31, 0, 0), Gr = a[we + 6852 >> 2], d = Gr + a[we + 6884 >> 2] | 0, Me = a[we + 6848 >> 2], v = a[we + 6880 >> 2], o = Me + v | 0, he = a[we + 6992 >> 2], Fr = o + he | 0, v = o >>> 0 < v >>> 0 ? d + 1 | 0 : d, d = v + a[we + 6996 >> 2] | 0, he = he >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, fr = (v | 0) == (he | 0) & o >>> 0 > Fr >>> 0 | v >>> 0 > he >>> 0, d = wr + 8 | 0, dr = a[d >> 2], Be = a[d + 4 >> 2], Me = (v | 0) == (Gr | 0) & o >>> 0 < Me >>> 0 | v >>> 0 < Gr >>> 0, d = Dr + 8 | 0, v = a[d >> 2], o = Rr + 8 | 0, wr = v + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 > wr >>> 0 ? d + 1 | 0 : d, o = Me + wr | 0, d = (o >>> 0 < wr >>> 0 ? d + 1 | 0 : d) + Be | 0, v = o, o = o + dr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + fr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Gr = he, dr = o << 12 | he >>> 20, v = d, Me = d << 12 | o >>> 20, yo = a[we + 6864 >> 2], o = a[we + 6944 >> 2], fr = yo + o | 0, xo = a[we + 6868 >> 2], d = xo + a[we + 6948 >> 2] | 0, d = o >>> 0 > fr >>> 0 ? d + 1 | 0 : d, o = a[we + 6800 >> 2], Be = o + fr | 0, Dr = d, d = d + a[we + 6804 >> 2] | 0, d = o >>> 0 > Be >>> 0 ? d + 1 | 0 : d, o = a[we + 6976 >> 2], he = o + Be | 0, wr = d, d = d + a[we + 6980 >> 2] | 0, o = o >>> 0 > he >>> 0 ? d + 1 | 0 : d, d = o + Me | 0, qi = we + 6736 | 0, Vn = qi, dr = he + dr | 0, Me = dr >>> 0 < he >>> 0 ? d + 1 | 0 : d, Sn = (o | 0) == (Me | 0) & he >>> 0 > dr >>> 0 | o >>> 0 > Me >>> 0, In = (o | 0) == (wr | 0) & he >>> 0 < Be >>> 0 | o >>> 0 < wr >>> 0, o = Qe + 8 | 0, mi = a[o >> 2], Ti = a[o + 4 >> 2], Rr = (wr | 0) == (Dr | 0) & Be >>> 0 < fr >>> 0 | wr >>> 0 < Dr >>> 0, o = uo + 8 | 0, Qe = a[o >> 2], wr = a[o + 4 >> 2], Be = (Dr | 0) == (xo | 0) & fr >>> 0 < yo >>> 0 | Dr >>> 0 < xo >>> 0, d = Xn + 8 | 0, he = a[d >> 2], o = Oo + 8 | 0, fr = he + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = he >>> 0 > fr >>> 0 ? d + 1 | 0 : d, o = Be + fr | 0, d = (o >>> 0 < fr >>> 0 ? d + 1 | 0 : d) + wr | 0, he = o, o = o + Qe | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, he = o, o = o + Rr | 0, d = (he >>> 0 > o >>> 0 ? d + 1 | 0 : d) + Ti | 0, he = o, o = o + mi | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, he = o + In | 0, d = he >>> 0 < o >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = v + he | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Sn | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = Me, Be = o << 12 | v >>> 20, he = d, Me = d << 12 | o >>> 20, Qe = a[we + 6912 >> 2], o = a[we + 6960 >> 2], wr = Qe + o | 0, mi = a[we + 6916 >> 2], d = mi + a[we + 6964 >> 2] | 0, o = o >>> 0 > wr >>> 0 ? d + 1 | 0 : d, d = o + Me | 0, Be = Be + wr | 0, d = Be >>> 0 < wr >>> 0 ? d + 1 | 0 : d, Dr = Be << 4 & -16, Me = d, fr = (d << 4 | Be >>> 28) & 16777215, Rr = v, Lr(Vn, Dr | v >>> 16 & 15, fr, 0, 0, 977, 1, 0, 0), Sn = a[we + 6740 >> 2], d = Sn + a[we + 6724 >> 2] | 0, In = a[we + 6736 >> 2], v = a[we + 6720 >> 2], fr = In + v | 0, a[we + 7576 >> 2] = fr, v = v >>> 0 > fr >>> 0 ? d + 1 | 0 : d, a[we + 7580 >> 2] = v & 1048575, uo = we + 6832 | 0, Lr(uo, Io, ns, 0, 0, Kn, $i, 0, 0), Oo = we + 6928 | 0, Lr(Oo, zi, Si, 0, 0, un, ni, 0, 0), Xn = we + 7040 | 0, Lr(Xn, Oi, $r, 0, 0, Oi, $r, 0, 0), yo = we + 6784 | 0, Ti = yo, Dr = (o | 0) == (Me | 0) & Be >>> 0 < wr >>> 0 | o >>> 0 > Me >>> 0, wr = (o | 0) == (mi | 0) & wr >>> 0 < Qe >>> 0 | o >>> 0 < mi >>> 0, d = Mo + 8 | 0, Be = a[d >> 2], o = Ho + 8 | 0, Qe = Be + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = Be >>> 0 > Qe >>> 0 ? d + 1 | 0 : d, Be = wr + Qe | 0, d = Be >>> 0 < Qe >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, o = he + Be | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, he = o, o = o + Dr | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, wr = o << 12 | Me >>> 20, Be = d, Me = d << 12 | o >>> 20, Mo = a[we + 6932 >> 2], d = Mo + a[we + 7044 >> 2] | 0, Vn = a[we + 6928 >> 2], he = a[we + 7040 >> 2], o = Vn + he | 0, mi = o, Qe = o + wr | 0, he = o >>> 0 < he >>> 0 ? d + 1 | 0 : d, d = he + Me | 0, wr = Qe >>> 0 < o >>> 0 ? d + 1 | 0 : d, Lr(Ti, Qe, wr & 1048575, 0, 0, 15632, 16, 0, 0), fr = (v | 0) == (Sn | 0) & fr >>> 0 < In >>> 0 | v >>> 0 < Sn >>> 0, d = Go + 8 | 0, Me = a[d >> 2], o = qi + 8 | 0, Dr = Me + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = Me >>> 0 > Dr >>> 0 ? d + 1 | 0 : d, o = fr + Dr | 0, d = o >>> 0 < Dr >>> 0 ? d + 1 | 0 : d, Dr = o << 12 | v >>> 20, Me = d, fr = d << 12 | o >>> 20, Sn = a[we + 6784 >> 2], o = a[we + 6832 >> 2], Ti = Sn + o | 0, qi = a[we + 6788 >> 2], d = qi + a[we + 6836 >> 2] | 0, v = o >>> 0 > Ti >>> 0 ? d + 1 | 0 : d, d = v + fr | 0, Dr = Dr + Ti | 0, d = Dr >>> 0 < Ti >>> 0 ? d + 1 | 0 : d, a[we + 7584 >> 2] = Dr, fr = d, a[we + 7588 >> 2] = d & 1048575, In = we + 6816 | 0, Lr(In, un, ni, 0, 0, Kn, $i, 0, 0), $i = we + 6896 | 0, Lr($i, Io, ns, 0, 0, Io, ns, 0, 0), Kn = we + 7024 | 0, Lr(Kn, zi, Si, 0, 0, Oi, $r, 0, 0), un = we + 6768 | 0, Oi = un, ni = (he | 0) == (wr | 0) & Qe >>> 0 < mi >>> 0 | he >>> 0 > wr >>> 0, Qe = (he | 0) == (Mo | 0) & mi >>> 0 < Vn >>> 0 | he >>> 0 < Mo >>> 0, d = Xn + 8 | 0, he = a[d >> 2], o = Oo + 8 | 0, $r = he + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = he >>> 0 > $r >>> 0 ? d + 1 | 0 : d, he = Qe + $r | 0, d = he >>> 0 < $r >>> 0 ? d + 1 | 0 : d, Be = Be >>> 20 | 0, o = he + Be | 0, d = Be >>> 0 > o >>> 0 ? d + 1 | 0 : d, he = o, o = o + ni | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, $r = o << 12 | wr >>> 20, Be = a[we + 7024 >> 2], wr = $r + Be | 0, he = d, mi = d << 12 | o >>> 20, d = mi + a[we + 7028 >> 2] | 0, Qe = Be >>> 0 > wr >>> 0 ? d + 1 | 0 : d, Lr(Oi, wr, Qe, 0, 0, 15632, 16, 0, 0), Dr = (v | 0) == (fr | 0) & Dr >>> 0 < Ti >>> 0 | v >>> 0 > fr >>> 0, Be = (v | 0) == (qi | 0) & Ti >>> 0 < Sn >>> 0 | v >>> 0 < qi >>> 0, d = uo + 8 | 0, v = a[d >> 2], o = yo + 8 | 0, ni = v + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 > ni >>> 0 ? d + 1 | 0 : d, v = Be + ni | 0, d = v >>> 0 < ni >>> 0 ? d + 1 | 0 : d, Me = Me >>> 20 | 0, o = v + Me | 0, d = Me >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Dr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Be = o << 12 | fr >>> 20, v = d, Me = d << 12 | o >>> 20, Ti = a[we + 6816 >> 2], o = a[we + 6896 >> 2], Dr = Ti + o | 0, Si = a[we + 6820 >> 2], d = Si + a[we + 6900 >> 2] | 0, d = o >>> 0 > Dr >>> 0 ? d + 1 | 0 : d, o = a[we + 6768 >> 2], fr = o + Dr | 0, ni = d, d = d + a[we + 6772 >> 2] | 0, o = o >>> 0 > fr >>> 0 ? d + 1 | 0 : d, d = o + Me | 0, Be = Be + fr | 0, d = Be >>> 0 < fr >>> 0 ? d + 1 | 0 : d, a[we + 7592 >> 2] = Be, Me = d, a[we + 7596 >> 2] = d & 1048575, Oi = we + 6752 | 0, $r = (Qe | 0) == (mi | 0) & wr >>> 0 < $r >>> 0 | Qe >>> 0 < mi >>> 0, d = Kn + 8 | 0, Qe = a[d >> 2], d = a[d + 4 >> 2], he = he >>> 20 | 0, wr = he, he = he + Qe | 0, d = wr >>> 0 > he >>> 0 ? d + 1 | 0 : d, wr = he, he = he + $r | 0, d = wr >>> 0 > he >>> 0 ? d + 1 | 0 : d, Lr(Oi, he, d, 0, 0, 64028672, 65536, 0, 0), $r = (o | 0) == (Me | 0) & Be >>> 0 < fr >>> 0 | o >>> 0 > Me >>> 0, Qe = (o | 0) == (ni | 0) & fr >>> 0 < Dr >>> 0 | o >>> 0 < ni >>> 0, o = un + 8 | 0, wr = a[o >> 2], fr = a[o + 4 >> 2], Be = (ni | 0) == (Si | 0) & Dr >>> 0 < Ti >>> 0 | ni >>> 0 < Si >>> 0, d = $i + 8 | 0, he = a[d >> 2], o = In + 8 | 0, Dr = he + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = he >>> 0 > Dr >>> 0 ? d + 1 | 0 : d, o = Be + Dr | 0, d = (o >>> 0 < Dr >>> 0 ? d + 1 | 0 : d) + fr | 0, he = o, o = o + wr | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, he = o + Qe | 0, d = he >>> 0 < o >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = v + he | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + $r | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, fr = o << 12 | Me >>> 20, v = d, he = d << 12 | o >>> 20, Dr = a[we + 6752 >> 2], o = Fr & -2, Me = Dr + o | 0, Qe = a[we + 6756 >> 2], d = Qe + (Gr & 1048575) | 0, Be = o >>> 0 > Me >>> 0 ? d + 1 | 0 : d, d = Be + he | 0, he = Me + fr | 0, d = he >>> 0 < Me >>> 0 ? d + 1 | 0 : d, a[we + 7600 >> 2] = he, o = d, a[we + 7604 >> 2] = d & 1048575, wr = Rr & 65535, fr = (d | 0) == (Be | 0) & he >>> 0 < Me >>> 0 | d >>> 0 < Be >>> 0, he = (Be | 0) == (Qe | 0) & Me >>> 0 < Dr >>> 0 | Be >>> 0 < Qe >>> 0, d = Oi + 8 | 0, Me = he + a[d >> 2] | 0, d = a[d + 4 >> 2], d = he >>> 0 > Me >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, he = v, v = v + Me | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + fr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, o = v << 12 | o >>> 20, he = o + dr | 0, d = wr + (d << 12 | v >>> 20) | 0, a[we + 7608 >> 2] = he, a[we + 7612 >> 2] = o >>> 0 > he >>> 0 ? d + 1 | 0 : d, ns = we + 7576 | 0, gn(ns, ns, ds), o = a[we + 7580 >> 2], Gr = o, Rr = a[we + 7576 >> 2], Be = Rr, d = o << 1 | Be >>> 31, Dr = we + 6448 | 0, un = a[we + 7600 >> 2], Ti = a[we + 7604 >> 2], mi = Be << 1, zi = d, Lr(Dr, un, Ti, 0, 0, mi, d, 0, 0), o = a[we + 7588 >> 2], po = o, Ao = a[we + 7584 >> 2], v = Ao, d = o << 1 | v >>> 31, wr = we + 6656 | 0, Kn = a[we + 7592 >> 2], Oi = a[we + 7596 >> 2], v = v << 1, he = d, Lr(wr, Kn, Oi, 0, 0, v, d, 0, 0), fr = we + 6608 | 0, Me = a[we + 7608 >> 2], o = a[we + 7612 >> 2], Lr(fr, Me, o, 0, 0, Me, o, 0, 0), dr = we + 6592 | 0, Lr(dr, a[we + 6608 >> 2], a[we + 6612 >> 2], 0, 0, 15632, 16, 0, 0), d = o << 1 | Me >>> 31, qi = we + 6560 | 0, Sn = Me << 1, $i = d, Lr(qi, Sn, d, 0, 0, Be, Gr, 0, 0), uo = we + 6464 | 0, Lr(uo, un, Ti, 0, 0, v, he, 0, 0), Oo = we + 6640 | 0, Lr(Oo, Kn, Oi, 0, 0, Kn, Oi, 0, 0), Qe = we + 6576 | 0, o = fr + 8 | 0, Lr(Qe, a[o >> 2], a[o + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Go = we + 6704 | 0, Lr(Go, Be, Gr, 0, 0, Be, Gr, 0, 0), Ho = we + 6544 | 0, Lr(Ho, Sn, d, 0, 0, Ao, po, 0, 0), Xn = we + 6480 | 0, Lr(Xn, un, Ti, 0, 0, Kn << 1, Oi << 1 | Kn >>> 31, 0, 0), Rr = a[we + 6452 >> 2], d = Rr + a[we + 6660 >> 2] | 0, Me = a[we + 6448 >> 2], v = a[we + 6656 >> 2], o = Me + v | 0, he = a[we + 6592 >> 2], $r = o + he | 0, v = o >>> 0 < v >>> 0 ? d + 1 | 0 : d, d = v + a[we + 6596 >> 2] | 0, he = he >>> 0 > $r >>> 0 ? d + 1 | 0 : d, fr = (v | 0) == (he | 0) & o >>> 0 > $r >>> 0 | v >>> 0 > he >>> 0, d = dr + 8 | 0, dr = a[d >> 2], Be = a[d + 4 >> 2], Me = (v | 0) == (Rr | 0) & o >>> 0 < Me >>> 0 | v >>> 0 < Rr >>> 0, d = wr + 8 | 0, v = a[d >> 2], o = Dr + 8 | 0, wr = v + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 > wr >>> 0 ? d + 1 | 0 : d, o = Me + wr | 0, d = (o >>> 0 < wr >>> 0 ? d + 1 | 0 : d) + Be | 0, v = o, o = o + dr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + fr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, ni = he, dr = o << 12 | he >>> 20, v = d, Me = d << 12 | o >>> 20, yo = a[we + 6464 >> 2], o = a[we + 6640 >> 2], fr = yo + o | 0, Mo = a[we + 6468 >> 2], d = Mo + a[we + 6644 >> 2] | 0, d = o >>> 0 > fr >>> 0 ? d + 1 | 0 : d, o = a[we + 6560 >> 2], Be = o + fr | 0, Dr = d, d = d + a[we + 6564 >> 2] | 0, d = o >>> 0 > Be >>> 0 ? d + 1 | 0 : d, o = a[we + 6576 >> 2], he = o + Be | 0, wr = d, d = d + a[we + 6580 >> 2] | 0, o = o >>> 0 > he >>> 0 ? d + 1 | 0 : d, d = o + Me | 0, Vn = we + 6384 | 0, dr = he + dr | 0, Me = dr >>> 0 < he >>> 0 ? d + 1 | 0 : d, In = (o | 0) == (Me | 0) & he >>> 0 > dr >>> 0 | o >>> 0 > Me >>> 0, Si = (o | 0) == (wr | 0) & he >>> 0 < Be >>> 0 | o >>> 0 < wr >>> 0, o = Qe + 8 | 0, Fr = a[o >> 2], Gr = a[o + 4 >> 2], Rr = (wr | 0) == (Dr | 0) & Be >>> 0 < fr >>> 0 | wr >>> 0 < Dr >>> 0, o = qi + 8 | 0, Qe = a[o >> 2], wr = a[o + 4 >> 2], Be = (Dr | 0) == (Mo | 0) & fr >>> 0 < yo >>> 0 | Dr >>> 0 < Mo >>> 0, d = Oo + 8 | 0, he = a[d >> 2], o = uo + 8 | 0, fr = he + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = he >>> 0 > fr >>> 0 ? d + 1 | 0 : d, o = Be + fr | 0, d = (o >>> 0 < fr >>> 0 ? d + 1 | 0 : d) + wr | 0, he = o, o = o + Qe | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, he = o, o = o + Rr | 0, d = (he >>> 0 > o >>> 0 ? d + 1 | 0 : d) + Gr | 0, he = o, o = o + Fr | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, he = o + Si | 0, d = he >>> 0 < o >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = v + he | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + In | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = Me, Be = o << 12 | v >>> 20, he = d, Me = d << 12 | o >>> 20, Qe = a[we + 6544 >> 2], o = a[we + 6480 >> 2], fr = Qe + o | 0, Rr = a[we + 6548 >> 2], d = Rr + a[we + 6484 >> 2] | 0, o = o >>> 0 > fr >>> 0 ? d + 1 | 0 : d, d = o + Me | 0, Be = Be + fr | 0, d = Be >>> 0 < fr >>> 0 ? d + 1 | 0 : d, Dr = Be << 4 & -16, Me = d, wr = (d << 4 | Be >>> 28) & 16777215, Fr = v, Lr(Vn, Dr | v >>> 16 & 15, wr, 0, 0, 977, 1, 0, 0), Mo = we + 6688 | 0, Lr(Mo, Ao, po, 0, 0, mi, zi, 0, 0), qi = we + 6528 | 0, Lr(qi, Sn, $i, 0, 0, Kn, Oi, 0, 0), uo = we + 6496 | 0, Lr(uo, un, Ti, 0, 0, un, Ti, 0, 0), Oo = we + 6432 | 0, Dr = Oo, wr = (o | 0) == (d | 0) & Be >>> 0 < fr >>> 0 | o >>> 0 > d >>> 0, Be = (o | 0) == (Rr | 0) & fr >>> 0 < Qe >>> 0 | o >>> 0 < Rr >>> 0, d = Xn + 8 | 0, v = a[d >> 2], o = Ho + 8 | 0, fr = v + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 > fr >>> 0 ? d + 1 | 0 : d, v = Be + fr | 0, d = v >>> 0 < fr >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, o = v + he | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + wr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Me = o << 12 | Me >>> 20, Be = d, v = d << 12 | o >>> 20, Xn = a[we + 6528 >> 2], o = a[we + 6496 >> 2], Si = Xn + o | 0, Io = a[we + 6532 >> 2], d = Io + a[we + 6500 >> 2] | 0, he = o >>> 0 > Si >>> 0 ? d + 1 | 0 : d, d = he + v | 0, Gr = Me + Si | 0, d = Gr >>> 0 < Si >>> 0 ? d + 1 | 0 : d, wr = d, Lr(Dr, Gr, d & 1048575, 0, 0, 15632, 16, 0, 0), Me = a[we + 6384 >> 2], o = a[we + 6704 >> 2], Rr = Me + o | 0, fr = a[we + 6388 >> 2], d = fr + a[we + 6708 >> 2] | 0, Ts = we + 7536 | 0, xo = Ts + 8 | 0, v = o >>> 0 > Rr >>> 0 ? d + 1 | 0 : d, fr = (fr | 0) == (v | 0) & Me >>> 0 > Rr >>> 0 | v >>> 0 < fr >>> 0, d = Go + 8 | 0, Me = a[d >> 2], o = Vn + 8 | 0, Dr = Me + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = Me >>> 0 > Dr >>> 0 ? d + 1 | 0 : d, o = fr + Dr | 0, d = o >>> 0 < Dr >>> 0 ? d + 1 | 0 : d, Qe = v, Dr = o << 12 | v >>> 20, Me = d, fr = d << 12 | o >>> 20, Ho = a[we + 6436 >> 2], d = Ho + a[we + 6692 >> 2] | 0, yo = a[we + 6432 >> 2], v = a[we + 6688 >> 2], o = yo + v | 0, In = o, Dr = o + Dr | 0, v = o >>> 0 < v >>> 0 ? d + 1 | 0 : d, d = v + fr | 0, a[xo >> 2] = Dr, fr = Dr >>> 0 < o >>> 0 ? d + 1 | 0 : d, a[xo + 4 >> 2] = fr & 1048575, Vn = we + 6624 | 0, Lr(Vn, Kn, Oi, 0, 0, mi, zi, 0, 0), zi = we + 6672 | 0, Lr(zi, Ao, po, 0, 0, Ao, po, 0, 0), mi = we + 6512 | 0, Lr(mi, Sn, $i, 0, 0, un, Ti, 0, 0), $i = we + 6416 | 0, Oi = (he | 0) == (wr | 0) & Gr >>> 0 < Si >>> 0 | he >>> 0 > wr >>> 0, Gr = (he | 0) == (Io | 0) & Si >>> 0 < Xn >>> 0 | he >>> 0 < Io >>> 0, d = uo + 8 | 0, he = a[d >> 2], o = qi + 8 | 0, un = he + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = he >>> 0 > un >>> 0 ? d + 1 | 0 : d, he = Gr + un | 0, d = he >>> 0 < un >>> 0 ? d + 1 | 0 : d, Be = Be >>> 20 | 0, o = he + Be | 0, d = Be >>> 0 > o >>> 0 ? d + 1 | 0 : d, he = o, o = o + Oi | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, Kn = o << 12 | wr >>> 20, Be = a[we + 6512 >> 2], wr = Kn + Be | 0, he = d, Xn = d << 12 | o >>> 20, d = Xn + a[we + 6516 >> 2] | 0, Gr = Be >>> 0 > wr >>> 0 ? d + 1 | 0 : d, Lr($i, wr, Gr, 0, 0, 15632, 16, 0, 0), Sn = Ts + 16 | 0, un = Sn, Dr = (v | 0) == (fr | 0) & Dr >>> 0 < In >>> 0 | v >>> 0 > fr >>> 0, Be = (v | 0) == (Ho | 0) & In >>> 0 < yo >>> 0 | v >>> 0 < Ho >>> 0, d = Mo + 8 | 0, v = a[d >> 2], o = Oo + 8 | 0, Oi = v + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 > Oi >>> 0 ? d + 1 | 0 : d, v = Be + Oi | 0, d = v >>> 0 < Oi >>> 0 ? d + 1 | 0 : d, Me = Me >>> 20 | 0, o = v + Me | 0, d = Me >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Dr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Be = o << 12 | fr >>> 20, v = d, Ti = d << 12 | o >>> 20, Si = a[we + 6624 >> 2], o = a[we + 6672 >> 2], fr = Si + o | 0, In = a[we + 6628 >> 2], d = In + a[we + 6676 >> 2] | 0, Oi = o >>> 0 > fr >>> 0 ? d + 1 | 0 : d, d = Oi + a[we + 6420 >> 2] | 0, o = a[we + 6416 >> 2], Me = o + fr | 0, Dr = Me, Be = Me + Be | 0, o = o >>> 0 > Me >>> 0 ? d + 1 | 0 : d, d = o + Ti | 0, a[un >> 2] = Be, Me = Be >>> 0 < Me >>> 0 ? d + 1 | 0 : d, a[un + 4 >> 2] = Me & 1048575, un = we + 6400 | 0, Ti = (Gr | 0) == (Xn | 0) & wr >>> 0 < Kn >>> 0 | Gr >>> 0 < Xn >>> 0, d = mi + 8 | 0, Gr = a[d >> 2], d = a[d + 4 >> 2], he = he >>> 20 | 0, wr = he, he = he + Gr | 0, d = wr >>> 0 > he >>> 0 ? d + 1 | 0 : d, Gr = he, he = he + Ti | 0, d = Gr >>> 0 > he >>> 0 ? d + 1 | 0 : d, Lr(un, he, d, 0, 0, 64028672, 65536, 0, 0), Kn = Ts + 24 | 0, Ti = (o | 0) == (Me | 0) & Be >>> 0 < Dr >>> 0 | o >>> 0 > Me >>> 0, Gr = (o | 0) == (Oi | 0) & fr >>> 0 > Dr >>> 0 | o >>> 0 < Oi >>> 0, o = $i + 8 | 0, Dr = a[o >> 2], wr = a[o + 4 >> 2], Be = (Oi | 0) == (In | 0) & fr >>> 0 < Si >>> 0 | Oi >>> 0 < In >>> 0, d = zi + 8 | 0, he = a[d >> 2], o = Vn + 8 | 0, fr = he + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = he >>> 0 > fr >>> 0 ? d + 1 | 0 : d, o = Be + fr | 0, d = (o >>> 0 < fr >>> 0 ? d + 1 | 0 : d) + wr | 0, he = o, o = o + Dr | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, he = o + Gr | 0, d = he >>> 0 < o >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = v + he | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Ti | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Me = o << 12 | Me >>> 20, v = d, fr = d << 12 | o >>> 20, Dr = a[we + 6400 >> 2], he = $r & -2, o = Dr + he | 0, $r = a[we + 6404 >> 2], d = $r + (ni & 1048575) | 0, Be = o >>> 0 < he >>> 0 ? d + 1 | 0 : d, d = Be + fr | 0, he = Me, Me = o, he = he + o | 0, a[Kn >> 2] = he, o = o >>> 0 > he >>> 0 ? d + 1 | 0 : d, a[Kn + 4 >> 2] = o & 1048575, ni = Ts + 32 | 0, Gr = ni, wr = Fr & 65535, fr = (o | 0) == (Be | 0) & he >>> 0 < Me >>> 0 | o >>> 0 < Be >>> 0, he = (Be | 0) == ($r | 0) & Me >>> 0 < Dr >>> 0 | Be >>> 0 < $r >>> 0, d = un + 8 | 0, Me = he + a[d >> 2] | 0, d = a[d + 4 >> 2], d = he >>> 0 > Me >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, he = v, v = v + Me | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + fr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, o = v << 12 | o >>> 20, he = o + dr | 0, d = wr + (d << 12 | v >>> 20) | 0, a[Gr >> 2] = he, a[Gr + 4 >> 2] = o >>> 0 > he >>> 0 ? d + 1 | 0 : d, a[we + 7536 >> 2] = Rr, a[we + 7540 >> 2] = Qe & 1048575, gn(Ts, Ts, ds), o = a[we + 7540 >> 2], $i = o, Si = a[we + 7536 >> 2], Be = Si, d = o << 1 | Be >>> 31, Fr = we + 6224 | 0, Dr = a[Kn >> 2], wr = a[Kn + 4 >> 2], Oi = Be << 1, Ti = d, Lr(Fr, Dr, wr, 0, 0, Oi, d, 0, 0), o = a[xo + 4 >> 2], ds = o, Io = a[xo >> 2], v = Io, d = o << 1 | v >>> 31, Gr = we + 6320 | 0, Rr = a[Sn >> 2], fr = a[Sn + 4 >> 2], v = v << 1, he = d, Lr(Gr, Rr, fr, 0, 0, v, d, 0, 0), Qe = we + 6208 | 0, Me = a[ni >> 2], o = a[ni + 4 >> 2], Lr(Qe, Me, o, 0, 0, Me, o, 0, 0), dr = we + 6192 | 0, Lr(dr, a[we + 6208 >> 2], a[we + 6212 >> 2], 0, 0, 15632, 16, 0, 0), d = o << 1 | Me >>> 31, Go = we + 6160 | 0, un = Me << 1, $r = d, Lr(Go, un, d, 0, 0, Be, $i, 0, 0), Ho = we + 6240 | 0, Lr(Ho, Dr, wr, 0, 0, v, he, 0, 0), Mo = we + 6304 | 0, Lr(Mo, Rr, fr, 0, 0, Rr, fr, 0, 0), Kn = we + 6176 | 0, o = Qe + 8 | 0, Lr(Kn, a[o >> 2], a[o + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), qi = we + 6368 | 0, Lr(qi, Be, $i, 0, 0, Be, $i, 0, 0), uo = we + 6144 | 0, Lr(uo, un, d, 0, 0, Io, ds, 0, 0), Oo = we + 6256 | 0, Lr(Oo, Dr, wr, 0, 0, Rr << 1, fr << 1 | Rr >>> 31, 0, 0), Si = a[we + 6228 >> 2], d = Si + a[we + 6324 >> 2] | 0, Me = a[we + 6224 >> 2], v = a[we + 6320 >> 2], o = Me + v | 0, he = a[we + 6192 >> 2], ni = o + he | 0, v = o >>> 0 < v >>> 0 ? d + 1 | 0 : d, d = v + a[we + 6196 >> 2] | 0, he = he >>> 0 > ni >>> 0 ? d + 1 | 0 : d, Qe = (v | 0) == (he | 0) & o >>> 0 > ni >>> 0 | v >>> 0 > he >>> 0, d = dr + 8 | 0, dr = a[d >> 2], Be = a[d + 4 >> 2], Me = (v | 0) == (Si | 0) & o >>> 0 < Me >>> 0 | v >>> 0 < Si >>> 0, d = Gr + 8 | 0, v = a[d >> 2], o = Fr + 8 | 0, Gr = v + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 > Gr >>> 0 ? d + 1 | 0 : d, o = Me + Gr | 0, d = (o >>> 0 < Gr >>> 0 ? d + 1 | 0 : d) + Be | 0, v = o, o = o + dr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Qe | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Fr = he, dr = o << 12 | he >>> 20, v = d, Me = d << 12 | o >>> 20, Xn = a[we + 6240 >> 2], o = a[we + 6304 >> 2], Qe = Xn + o | 0, xo = a[we + 6244 >> 2], d = xo + a[we + 6308 >> 2] | 0, d = o >>> 0 > Qe >>> 0 ? d + 1 | 0 : d, o = a[we + 6160 >> 2], Be = o + Qe | 0, Si = d, d = d + a[we + 6164 >> 2] | 0, d = o >>> 0 > Be >>> 0 ? d + 1 | 0 : d, o = a[we + 6176 >> 2], he = o + Be | 0, Gr = d, d = d + a[we + 6180 >> 2] | 0, o = o >>> 0 > he >>> 0 ? d + 1 | 0 : d, d = o + Me | 0, yo = we + 6128 | 0, Vn = yo, dr = he + dr | 0, Me = dr >>> 0 < he >>> 0 ? d + 1 | 0 : d, Sn = (o | 0) == (Me | 0) & he >>> 0 > dr >>> 0 | o >>> 0 > Me >>> 0, In = (o | 0) == (Gr | 0) & he >>> 0 < Be >>> 0 | o >>> 0 < Gr >>> 0, o = Kn + 8 | 0, zi = a[o >> 2], mi = a[o + 4 >> 2], $i = (Gr | 0) == (Si | 0) & Be >>> 0 < Qe >>> 0 | Gr >>> 0 < Si >>> 0, o = Go + 8 | 0, Kn = a[o >> 2], Gr = a[o + 4 >> 2], Be = (Si | 0) == (xo | 0) & Qe >>> 0 < Xn >>> 0 | Si >>> 0 < xo >>> 0, d = Mo + 8 | 0, he = a[d >> 2], o = Ho + 8 | 0, Qe = he + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = he >>> 0 > Qe >>> 0 ? d + 1 | 0 : d, o = Be + Qe | 0, d = (o >>> 0 < Qe >>> 0 ? d + 1 | 0 : d) + Gr | 0, he = o, o = o + Kn | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, he = o, o = o + $i | 0, d = (he >>> 0 > o >>> 0 ? d + 1 | 0 : d) + mi | 0, he = o, o = o + zi | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, he = o + In | 0, d = he >>> 0 < o >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = v + he | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Sn | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = Me, Be = o << 12 | v >>> 20, he = d, Gr = d << 12 | o >>> 20, zi = a[we + 6148 >> 2], d = zi + a[we + 6260 >> 2] | 0, mi = a[we + 6144 >> 2], o = a[we + 6256 >> 2], Me = mi + o | 0, Qe = Me, Be = Me + Be | 0, o = o >>> 0 > Me >>> 0 ? d + 1 | 0 : d, d = o + Gr | 0, Kn = Be << 4 & -16, Me = Be >>> 0 < Me >>> 0 ? d + 1 | 0 : d, Si = (Me << 4 | Be >>> 28) & 16777215, Gr = v, Lr(Vn, Kn | v >>> 16 & 15, Si, 0, 0, 977, 1, 0, 0), Vn = we + 6352 | 0, Lr(Vn, Io, ds, 0, 0, Oi, Ti, 0, 0), In = we + 6096 | 0, Lr(In, un, $r, 0, 0, Rr, fr, 0, 0), $i = we + 6272 | 0, Lr($i, Dr, wr, 0, 0, Dr, wr, 0, 0), Kn = we + 6080 | 0, Si = (o | 0) == (Me | 0) & Be >>> 0 < Qe >>> 0 | o >>> 0 > Me >>> 0, Be = (o | 0) == (zi | 0) & Qe >>> 0 < mi >>> 0 | o >>> 0 < zi >>> 0, d = Oo + 8 | 0, v = a[d >> 2], o = uo + 8 | 0, Qe = v + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 > Qe >>> 0 ? d + 1 | 0 : d, v = Be + Qe | 0, d = v >>> 0 < Qe >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, o = v + he | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Si | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Me = o << 12 | Me >>> 20, v = d, he = d << 12 | o >>> 20, Si = a[we + 6096 >> 2], o = a[we + 6272 >> 2], Be = Si + o | 0, Sn = a[we + 6100 >> 2], d = Sn + a[we + 6276 >> 2] | 0, o = o >>> 0 > Be >>> 0 ? d + 1 | 0 : d, d = o + he | 0, Me = Be + Me | 0, d = Me >>> 0 < Be >>> 0 ? d + 1 | 0 : d, he = d, Lr(Kn, Me, d & 1048575, 0, 0, 15632, 16, 0, 0), zi = we + 6288 | 0, Lr(zi, Rr, fr, 0, 0, Oi, Ti, 0, 0), mi = we + 6336 | 0, Lr(mi, Io, ds, 0, 0, Io, ds, 0, 0), Qe = we + 6032 | 0, Lr(Qe, un, $r, 0, 0, Dr, wr, 0, 0), Oi = we + 6016 | 0, wr = Oi, fr = (o | 0) == (d | 0) & Be >>> 0 > Me >>> 0 | o >>> 0 > d >>> 0, Be = (o | 0) == (Sn | 0) & Be >>> 0 < Si >>> 0 | o >>> 0 < Sn >>> 0, d = $i + 8 | 0, Me = a[d >> 2], o = In + 8 | 0, Dr = Me + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = Me >>> 0 > Dr >>> 0 ? d + 1 | 0 : d, Me = Be + Dr | 0, d = Me >>> 0 < Dr >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = v + Me | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + fr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Me = o << 12 | he >>> 20, he = a[we + 6032 >> 2], fr = Me + he | 0, v = d, o = d << 12 | o >>> 20, d = o + a[we + 6036 >> 2] | 0, d = he >>> 0 > fr >>> 0 ? d + 1 | 0 : d, Lr(wr, fr, d, 0, 0, 15632, 16, 0, 0), Sn = we + 5952 | 0, Be = Sn, Me = (o | 0) == (d | 0) & Me >>> 0 > fr >>> 0 | o >>> 0 > d >>> 0, o = Qe + 8 | 0, he = a[o >> 2], d = a[o + 4 >> 2], v = v >>> 20 | 0, o = v + he | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Me | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Lr(Be, o, d, 0, 0, 64028672, 65536, 0, 0), v = a[we + 6128 >> 2], o = a[we + 6368 >> 2], Be = v + o | 0, Me = a[we + 6132 >> 2], d = Me + a[we + 6372 >> 2] | 0, he = o >>> 0 > Be >>> 0 ? d + 1 | 0 : d, Me = (Me | 0) == (he | 0) & v >>> 0 > Be >>> 0 | he >>> 0 < Me >>> 0, d = qi + 8 | 0, v = a[d >> 2], o = yo + 8 | 0, fr = v + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 > fr >>> 0 ? d + 1 | 0 : d, o = Me + fr | 0, d = o >>> 0 < fr >>> 0 ? d + 1 | 0 : d, Rr = he, Me = o << 12 | he >>> 20, v = d, he = d << 12 | o >>> 20, wr = a[we + 6080 >> 2], o = a[we + 6352 >> 2], fr = wr + o | 0, Qe = a[we + 6084 >> 2], d = Qe + a[we + 6356 >> 2] | 0, o = o >>> 0 > fr >>> 0 ? d + 1 | 0 : d, d = o + he | 0, Me = Me + fr | 0, he = Me >>> 0 < fr >>> 0 ? d + 1 | 0 : d, Dr = (o | 0) == (he | 0) & Me >>> 0 < fr >>> 0 | o >>> 0 > he >>> 0, wr = (o | 0) == (Qe | 0) & fr >>> 0 < wr >>> 0 | o >>> 0 < Qe >>> 0, d = Vn + 8 | 0, fr = a[d >> 2], o = Kn + 8 | 0, Qe = fr + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = fr >>> 0 > Qe >>> 0 ? d + 1 | 0 : d, fr = wr + Qe | 0, d = fr >>> 0 < Qe >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = v + fr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Dr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Qe = he, fr = o << 12 | he >>> 20, v = d, he = d << 12 | o >>> 20, $i = a[we + 6288 >> 2], o = a[we + 6336 >> 2], Dr = $i + o | 0, Vn = a[we + 6292 >> 2], d = Vn + a[we + 6340 >> 2] | 0, d = o >>> 0 > Dr >>> 0 ? d + 1 | 0 : d, o = a[we + 6016 >> 2], wr = o + Dr | 0, $r = d, d = d + a[we + 6020 >> 2] | 0, o = o >>> 0 > wr >>> 0 ? d + 1 | 0 : d, d = o + he | 0, In = we + 5936 | 0, Kn = In, he = fr + wr | 0, fr = he >>> 0 < wr >>> 0 ? d + 1 | 0 : d, Si = (o | 0) == (fr | 0) & he >>> 0 < wr >>> 0 | o >>> 0 > fr >>> 0, un = (o | 0) == ($r | 0) & wr >>> 0 < Dr >>> 0 | o >>> 0 < $r >>> 0, o = Oi + 8 | 0, Ti = a[o >> 2], Oi = a[o + 4 >> 2], Dr = ($r | 0) == (Vn | 0) & Dr >>> 0 < $i >>> 0 | $r >>> 0 < Vn >>> 0, d = mi + 8 | 0, wr = a[d >> 2], o = zi + 8 | 0, $r = wr + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = wr >>> 0 > $r >>> 0 ? d + 1 | 0 : d, o = Dr + $r | 0, d = (o >>> 0 < $r >>> 0 ? d + 1 | 0 : d) + Oi | 0, Dr = o, o = o + Ti | 0, d = Dr >>> 0 > o >>> 0 ? d + 1 | 0 : d, wr = o + un | 0, d = wr >>> 0 < o >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = v + wr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Si | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, wr = fr, Dr = o << 12 | fr >>> 20, v = d, $r = d << 12 | o >>> 20, Vn = a[we + 5956 >> 2], d = Vn + (Fr & 1048575) | 0, $i = a[we + 5952 >> 2], o = ni & -2, fr = $i + o | 0, Fr = fr, Dr = fr + Dr | 0, o = o >>> 0 > fr >>> 0 ? d + 1 | 0 : d, d = o + $r | 0, fr = Dr >>> 0 < fr >>> 0 ? d + 1 | 0 : d, $r = fr & 1048575, d = Rr & 1048575, yo = d, Rr = Be, d = d << 1 | Be >>> 31, Ti = Be << 1, un = d, Lr(Kn, Dr, $r, 0, 0, Ti, d, 0, 0), d = Qe & 1048575, Io = d, zi = we + 5968 | 0, ni = wr & 1048575, Be = Me << 1, Kn = Me, wr = d << 1 | Me >>> 31, Lr(zi, he, ni, 0, 0, Be, wr, 0, 0), mi = we + 5872 | 0, Si = mi, Oi = Gr & 65535, Gr = (o | 0) == (fr | 0) & Dr >>> 0 < Fr >>> 0 | o >>> 0 > fr >>> 0, Qe = (o | 0) == (Vn | 0) & Fr >>> 0 < $i >>> 0 | o >>> 0 < Vn >>> 0, o = Sn + 8 | 0, Me = Qe + a[o >> 2] | 0, d = a[o + 4 >> 2], d = Me >>> 0 < Qe >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = v + Me | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Gr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Me = o << 12 | fr >>> 20, v = Me + dr | 0, d = Oi + (d << 12 | o >>> 20) | 0, d = v >>> 0 < Me >>> 0 ? d + 1 | 0 : d, Lr(Si, v, d, 0, 0, v, d, 0, 0), dr = we + 5856 | 0, Lr(dr, a[we + 5872 >> 2], a[we + 5876 >> 2], 0, 0, 15632, 16, 0, 0), o = v, d = d << 1 | o >>> 31, Go = we + 5824 | 0, Si = o << 1, Oi = d, Lr(Go, Si, d, 0, 0, Rr, yo, 0, 0), Ho = we + 5920 | 0, Lr(Ho, Dr, $r, 0, 0, Be, wr, 0, 0), Mo = we + 5984 | 0, Lr(Mo, he, ni, 0, 0, he, ni, 0, 0), $i = we + 5840 | 0, o = mi + 8 | 0, Lr($i, a[o >> 2], a[o + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), qi = we + 6112 | 0, Lr(qi, Rr, yo, 0, 0, Rr, yo, 0, 0), uo = we + 5808 | 0, Lr(uo, Si, d, 0, 0, Kn, Io, 0, 0), Oo = we + 5888 | 0, wr = $r, fr = ni, $r = he, Lr(Oo, Dr, wr, 0, 0, he << 1, fr << 1 | he >>> 31, 0, 0), Me = a[we + 5936 >> 2], v = a[we + 5968 >> 2], o = Me + v | 0, Rr = a[we + 5940 >> 2], d = Rr + a[we + 5972 >> 2] | 0, d = o >>> 0 < v >>> 0 ? d + 1 | 0 : d, v = a[we + 5856 >> 2], ni = v + o | 0, he = d, d = d + a[we + 5860 >> 2] | 0, v = v >>> 0 > ni >>> 0 ? d + 1 | 0 : d, Qe = (he | 0) == (v | 0) & o >>> 0 > ni >>> 0 | v >>> 0 < he >>> 0, d = dr + 8 | 0, dr = a[d >> 2], Be = a[d + 4 >> 2], Me = (he | 0) == (Rr | 0) & o >>> 0 < Me >>> 0 | he >>> 0 < Rr >>> 0, d = zi + 8 | 0, he = a[d >> 2], o = In + 8 | 0, Rr = he + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = he >>> 0 > Rr >>> 0 ? d + 1 | 0 : d, o = Me + Rr | 0, d = (o >>> 0 < Rr >>> 0 ? d + 1 | 0 : d) + Be | 0, he = o, o = o + dr | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, he = o, o = o + Qe | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, Fr = v, dr = o << 12 | v >>> 20, he = d, Me = d << 12 | o >>> 20, Xn = a[we + 5920 >> 2], o = a[we + 5984 >> 2], Rr = Xn + o | 0, xo = a[we + 5924 >> 2], d = xo + a[we + 5988 >> 2] | 0, d = o >>> 0 > Rr >>> 0 ? d + 1 | 0 : d, o = a[we + 5824 >> 2], Qe = o + Rr | 0, v = d, d = d + a[we + 5828 >> 2] | 0, d = o >>> 0 > Qe >>> 0 ? d + 1 | 0 : d, o = a[we + 5840 >> 2], Be = o + Qe | 0, Gr = d, d = d + a[we + 5844 >> 2] | 0, o = o >>> 0 > Be >>> 0 ? d + 1 | 0 : d, d = o + Me | 0, yo = we + 5712 | 0, Vn = yo, dr = Be + dr | 0, Me = dr >>> 0 < Be >>> 0 ? d + 1 | 0 : d, Sn = (o | 0) == (Me | 0) & Be >>> 0 > dr >>> 0 | o >>> 0 > Me >>> 0, In = (o | 0) == (Gr | 0) & Be >>> 0 < Qe >>> 0 | o >>> 0 < Gr >>> 0, o = $i + 8 | 0, zi = a[o >> 2], mi = a[o + 4 >> 2], $i = (v | 0) == (Gr | 0) & Rr >>> 0 > Qe >>> 0 | v >>> 0 > Gr >>> 0, o = Go + 8 | 0, Gr = a[o >> 2], Qe = a[o + 4 >> 2], Be = (v | 0) == (xo | 0) & Rr >>> 0 < Xn >>> 0 | v >>> 0 < xo >>> 0, d = Mo + 8 | 0, v = a[d >> 2], o = Ho + 8 | 0, Rr = v + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 > Rr >>> 0 ? d + 1 | 0 : d, o = Be + Rr | 0, d = (o >>> 0 < Rr >>> 0 ? d + 1 | 0 : d) + Qe | 0, v = o, o = o + Gr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + $i | 0, d = (v >>> 0 > o >>> 0 ? d + 1 | 0 : d) + mi | 0, v = o, o = o + zi | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o + In | 0, d = v >>> 0 < o >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, o = v + he | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Sn | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = Me, Be = o << 12 | v >>> 20, he = d, Me = d << 12 | o >>> 20, mi = a[we + 5808 >> 2], o = a[we + 5888 >> 2], Qe = mi + o | 0, zi = a[we + 5812 >> 2], d = zi + a[we + 5892 >> 2] | 0, o = o >>> 0 > Qe >>> 0 ? d + 1 | 0 : d, d = o + Me | 0, Be = Be + Qe | 0, d = Be >>> 0 < Qe >>> 0 ? d + 1 | 0 : d, $i = Be << 4 & -16, Me = d, Rr = (d << 4 | Be >>> 28) & 16777215, Gr = v, Lr(Vn, $i | v >>> 16 & 15, Rr, 0, 0, 977, 1, 0, 0), Vn = we + 6048 | 0, Lr(Vn, Kn, Io, 0, 0, Ti, un, 0, 0), Sn = we + 5792 | 0, Lr(Sn, Si, Oi, 0, 0, $r, fr, 0, 0), In = we + 5904 | 0, Lr(In, Dr, wr, 0, 0, Dr, wr, 0, 0), $i = we + 5776 | 0, Rr = (o | 0) == (d | 0) & Be >>> 0 < Qe >>> 0 | o >>> 0 > d >>> 0, Be = (o | 0) == (zi | 0) & Qe >>> 0 < mi >>> 0 | o >>> 0 < zi >>> 0, d = Oo + 8 | 0, v = a[d >> 2], o = uo + 8 | 0, Qe = v + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 > Qe >>> 0 ? d + 1 | 0 : d, v = Be + Qe | 0, d = v >>> 0 < Qe >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, o = v + he | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Rr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Me = o << 12 | Me >>> 20, v = d, he = d << 12 | o >>> 20, Rr = a[we + 5792 >> 2], o = a[we + 5904 >> 2], Be = Rr + o | 0, Xn = a[we + 5796 >> 2], d = Xn + a[we + 5908 >> 2] | 0, o = o >>> 0 > Be >>> 0 ? d + 1 | 0 : d, d = o + he | 0, Me = Be + Me | 0, d = Me >>> 0 < Be >>> 0 ? d + 1 | 0 : d, he = d, Lr($i, Me, d & 1048575, 0, 0, 15632, 16, 0, 0), zi = we + 6e3 | 0, Lr(zi, $r, fr, 0, 0, Ti, un, 0, 0), mi = we + 6064 | 0, Lr(mi, Kn, Io, 0, 0, Kn, Io, 0, 0), Qe = we + 5760 | 0, Lr(Qe, Dr, wr, 0, 0, Si, Oi, 0, 0), Oi = we + 5744 | 0, wr = Oi, fr = (o | 0) == (d | 0) & Be >>> 0 > Me >>> 0 | o >>> 0 > d >>> 0, Be = (o | 0) == (Xn | 0) & Be >>> 0 < Rr >>> 0 | o >>> 0 < Xn >>> 0, d = In + 8 | 0, Me = a[d >> 2], o = Sn + 8 | 0, Dr = Me + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = Me >>> 0 > Dr >>> 0 ? d + 1 | 0 : d, Me = Be + Dr | 0, d = Me >>> 0 < Dr >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = v + Me | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + fr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Me = o << 12 | he >>> 20, he = a[we + 5760 >> 2], fr = Me + he | 0, v = d, o = d << 12 | o >>> 20, d = o + a[we + 5764 >> 2] | 0, d = he >>> 0 > fr >>> 0 ? d + 1 | 0 : d, Lr(wr, fr, d, 0, 0, 15632, 16, 0, 0), Sn = we + 5728 | 0, Be = Sn, Me = (o | 0) == (d | 0) & Me >>> 0 > fr >>> 0 | o >>> 0 > d >>> 0, o = Qe + 8 | 0, he = a[o >> 2], d = a[o + 4 >> 2], v = v >>> 20 | 0, o = v + he | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Me | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Lr(Be, o, d, 0, 0, 64028672, 65536, 0, 0), v = a[we + 5712 >> 2], o = a[we + 6112 >> 2], Be = v + o | 0, Me = a[we + 5716 >> 2], d = Me + a[we + 6116 >> 2] | 0, he = o >>> 0 > Be >>> 0 ? d + 1 | 0 : d, Me = (Me | 0) == (he | 0) & v >>> 0 > Be >>> 0 | he >>> 0 < Me >>> 0, d = qi + 8 | 0, v = a[d >> 2], o = yo + 8 | 0, fr = v + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 > fr >>> 0 ? d + 1 | 0 : d, o = Me + fr | 0, d = o >>> 0 < fr >>> 0 ? d + 1 | 0 : d, Rr = he, Me = o << 12 | he >>> 20, v = d, he = d << 12 | o >>> 20, wr = a[we + 5776 >> 2], o = a[we + 6048 >> 2], fr = wr + o | 0, Qe = a[we + 5780 >> 2], d = Qe + a[we + 6052 >> 2] | 0, o = o >>> 0 > fr >>> 0 ? d + 1 | 0 : d, d = o + he | 0, Me = Me + fr | 0, he = Me >>> 0 < fr >>> 0 ? d + 1 | 0 : d, Dr = (o | 0) == (he | 0) & Me >>> 0 < fr >>> 0 | o >>> 0 > he >>> 0, wr = (o | 0) == (Qe | 0) & fr >>> 0 < wr >>> 0 | o >>> 0 < Qe >>> 0, d = Vn + 8 | 0, fr = a[d >> 2], o = $i + 8 | 0, Qe = fr + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = fr >>> 0 > Qe >>> 0 ? d + 1 | 0 : d, fr = wr + Qe | 0, d = fr >>> 0 < Qe >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = v + fr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Dr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Qe = he, fr = o << 12 | he >>> 20, v = d, he = d << 12 | o >>> 20, $i = a[we + 6e3 >> 2], o = a[we + 6064 >> 2], Dr = $i + o | 0, Vn = a[we + 6004 >> 2], d = Vn + a[we + 6068 >> 2] | 0, d = o >>> 0 > Dr >>> 0 ? d + 1 | 0 : d, o = a[we + 5744 >> 2], wr = o + Dr | 0, $r = d, d = d + a[we + 5748 >> 2] | 0, o = o >>> 0 > wr >>> 0 ? d + 1 | 0 : d, d = o + he | 0, In = we + 5632 | 0, Kn = In, he = fr + wr | 0, fr = he >>> 0 < wr >>> 0 ? d + 1 | 0 : d, Si = (o | 0) == (fr | 0) & he >>> 0 < wr >>> 0 | o >>> 0 > fr >>> 0, un = (o | 0) == ($r | 0) & wr >>> 0 < Dr >>> 0 | o >>> 0 < $r >>> 0, o = Oi + 8 | 0, Ti = a[o >> 2], Oi = a[o + 4 >> 2], Dr = ($r | 0) == (Vn | 0) & Dr >>> 0 < $i >>> 0 | $r >>> 0 < Vn >>> 0, d = mi + 8 | 0, wr = a[d >> 2], o = zi + 8 | 0, $r = wr + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = wr >>> 0 > $r >>> 0 ? d + 1 | 0 : d, o = Dr + $r | 0, d = (o >>> 0 < $r >>> 0 ? d + 1 | 0 : d) + Oi | 0, Dr = o, o = o + Ti | 0, d = Dr >>> 0 > o >>> 0 ? d + 1 | 0 : d, wr = o + un | 0, d = wr >>> 0 < o >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = v + wr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Si | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, wr = fr, Dr = o << 12 | fr >>> 20, v = d, $r = d << 12 | o >>> 20, Vn = a[we + 5732 >> 2], d = Vn + (Fr & 1048575) | 0, $i = a[we + 5728 >> 2], o = ni & -2, fr = $i + o | 0, Fr = fr, Dr = fr + Dr | 0, o = o >>> 0 > fr >>> 0 ? d + 1 | 0 : d, d = o + $r | 0, fr = Dr >>> 0 < fr >>> 0 ? d + 1 | 0 : d, Si = fr & 1048575, ni = Si, d = Rr & 1048575, yo = d, Rr = Be, d = d << 1 | Be >>> 31, Oi = Be << 1, Ti = d, Lr(Kn, Dr, ni, 0, 0, Oi, d, 0, 0), d = Qe & 1048575, Io = d, zi = we + 5584 | 0, ni = wr & 1048575, Be = Me << 1, Kn = Me, wr = d << 1 | Me >>> 31, Lr(zi, he, ni, 0, 0, Be, wr, 0, 0), mi = we + 5536 | 0, $r = Gr & 65535, Gr = (o | 0) == (fr | 0) & Dr >>> 0 < Fr >>> 0 | o >>> 0 > fr >>> 0, Qe = (o | 0) == (Vn | 0) & Fr >>> 0 < $i >>> 0 | o >>> 0 < Vn >>> 0, o = Sn + 8 | 0, Me = Qe + a[o >> 2] | 0, d = a[o + 4 >> 2], d = Me >>> 0 < Qe >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = v + Me | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Gr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Me = o << 12 | fr >>> 20, v = Me + dr | 0, d = $r + (d << 12 | o >>> 20) | 0, d = v >>> 0 < Me >>> 0 ? d + 1 | 0 : d, Lr(mi, v, d, 0, 0, v, d, 0, 0), dr = we + 5520 | 0, Lr(dr, a[we + 5536 >> 2], a[we + 5540 >> 2], 0, 0, 15632, 16, 0, 0), o = v, d = d << 1 | o >>> 31, Go = we + 5488 | 0, un = o << 1, $r = d, Lr(Go, un, d, 0, 0, Rr, yo, 0, 0), Ho = we + 5568 | 0, Lr(Ho, Dr, Si, 0, 0, Be, wr, 0, 0), Mo = we + 5680 | 0, Lr(Mo, he, ni, 0, 0, he, ni, 0, 0), $i = we + 5504 | 0, o = mi + 8 | 0, Lr($i, a[o >> 2], a[o + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), qi = we + 5648 | 0, Lr(qi, Rr, yo, 0, 0, Rr, yo, 0, 0), uo = we + 5472 | 0, Lr(uo, un, d, 0, 0, Kn, Io, 0, 0), Oo = we + 5552 | 0, Gr = Dr, Rr = Si, fr = ni, ni = he, Lr(Oo, Dr, Rr, 0, 0, he << 1, fr << 1 | he >>> 31, 0, 0), Me = a[we + 5632 >> 2], v = a[we + 5584 >> 2], o = Me + v | 0, Dr = a[we + 5636 >> 2], d = Dr + a[we + 5588 >> 2] | 0, d = o >>> 0 < v >>> 0 ? d + 1 | 0 : d, v = a[we + 5520 >> 2], Qe = v + o | 0, he = d, d = d + a[we + 5524 >> 2] | 0, v = v >>> 0 > Qe >>> 0 ? d + 1 | 0 : d, wr = (he | 0) == (v | 0) & o >>> 0 > Qe >>> 0 | v >>> 0 < he >>> 0, d = dr + 8 | 0, dr = a[d >> 2], Be = a[d + 4 >> 2], Me = (he | 0) == (Dr | 0) & o >>> 0 < Me >>> 0 | he >>> 0 < Dr >>> 0, d = zi + 8 | 0, he = a[d >> 2], o = In + 8 | 0, Dr = he + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = he >>> 0 > Dr >>> 0 ? d + 1 | 0 : d, o = Me + Dr | 0, d = (o >>> 0 < Dr >>> 0 ? d + 1 | 0 : d) + Be | 0, he = o, o = o + dr | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, he = o, o = o + wr | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, Dr = v, Be = o << 12 | v >>> 20, he = d, Me = d << 12 | o >>> 20, Xn = a[we + 5568 >> 2], o = a[we + 5680 >> 2], Fr = Xn + o | 0, xo = a[we + 5572 >> 2], d = xo + a[we + 5684 >> 2] | 0, d = o >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, o = a[we + 5488 >> 2], wr = o + Fr | 0, v = d, d = d + a[we + 5492 >> 2] | 0, d = o >>> 0 > wr >>> 0 ? d + 1 | 0 : d, o = a[we + 5504 >> 2], dr = o + wr | 0, Si = d, d = d + a[we + 5508 >> 2] | 0, o = o >>> 0 > dr >>> 0 ? d + 1 | 0 : d, d = o + Me | 0, yo = we + 5376 | 0, Vn = yo, Me = Be + dr | 0, Be = Me >>> 0 < dr >>> 0 ? d + 1 | 0 : d, Sn = (o | 0) == (Be | 0) & Me >>> 0 < dr >>> 0 | o >>> 0 > Be >>> 0, In = (o | 0) == (Si | 0) & wr >>> 0 > dr >>> 0 | o >>> 0 < Si >>> 0, o = $i + 8 | 0, zi = a[o >> 2], mi = a[o + 4 >> 2], $i = (v | 0) == (Si | 0) & wr >>> 0 < Fr >>> 0 | v >>> 0 > Si >>> 0, o = Go + 8 | 0, Si = a[o >> 2], wr = a[o + 4 >> 2], dr = (v | 0) == (xo | 0) & Fr >>> 0 < Xn >>> 0 | v >>> 0 < xo >>> 0, d = Mo + 8 | 0, v = a[d >> 2], o = Ho + 8 | 0, Fr = v + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, o = dr + Fr | 0, d = (o >>> 0 < Fr >>> 0 ? d + 1 | 0 : d) + wr | 0, v = o, o = o + Si | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + $i | 0, d = (v >>> 0 > o >>> 0 ? d + 1 | 0 : d) + mi | 0, v = o, o = o + zi | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o + In | 0, d = v >>> 0 < o >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, o = v + he | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Sn | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = Be, dr = o << 12 | v >>> 20, he = d, Be = d << 12 | o >>> 20, mi = a[we + 5472 >> 2], o = a[we + 5552 >> 2], Fr = mi + o | 0, Xn = a[we + 5476 >> 2], d = Xn + a[we + 5556 >> 2] | 0, o = o >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, d = o + Be | 0, dr = dr + Fr | 0, d = dr >>> 0 < Fr >>> 0 ? d + 1 | 0 : d, $i = dr << 4 & -16, Be = d, Si = (d << 4 | dr >>> 28) & 16777215, wr = v, Lr(Vn, $i | v >>> 16 & 15, Si, 0, 0, 977, 1, 0, 0), Vn = we + 5616 | 0, Lr(Vn, Kn, Io, 0, 0, Oi, Ti, 0, 0), Sn = we + 5456 | 0, Lr(Sn, un, $r, 0, 0, ni, fr, 0, 0), In = we + 5696 | 0, Lr(In, Gr, Rr, 0, 0, Gr, Rr, 0, 0), zi = we + 5440 | 0, $i = zi, Si = (o | 0) == (d | 0) & dr >>> 0 < Fr >>> 0 | o >>> 0 > d >>> 0, dr = (o | 0) == (Xn | 0) & Fr >>> 0 < mi >>> 0 | o >>> 0 < Xn >>> 0, d = Oo + 8 | 0, v = a[d >> 2], o = uo + 8 | 0, Fr = v + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, v = dr + Fr | 0, d = v >>> 0 < Fr >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, o = v + he | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Si | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Be = o << 12 | Be >>> 20, v = d, he = d << 12 | o >>> 20, Si = a[we + 5456 >> 2], o = a[we + 5696 >> 2], dr = Si + o | 0, Xn = a[we + 5460 >> 2], d = Xn + a[we + 5700 >> 2] | 0, o = o >>> 0 > dr >>> 0 ? d + 1 | 0 : d, d = o + he | 0, Be = Be + dr | 0, d = Be >>> 0 < dr >>> 0 ? d + 1 | 0 : d, he = d, Lr($i, Be, d & 1048575, 0, 0, 15632, 16, 0, 0), mi = we + 5600 | 0, Lr(mi, ni, fr, 0, 0, Oi, Ti, 0, 0), $i = we + 5664 | 0, Lr($i, Kn, Io, 0, 0, Kn, Io, 0, 0), Fr = we + 5424 | 0, Lr(Fr, Gr, Rr, 0, 0, un, $r, 0, 0), ni = we + 5408 | 0, Rr = ni, fr = (o | 0) == (d | 0) & Be >>> 0 < dr >>> 0 | o >>> 0 > d >>> 0, dr = (o | 0) == (Xn | 0) & dr >>> 0 < Si >>> 0 | o >>> 0 < Xn >>> 0, d = In + 8 | 0, Be = a[d >> 2], o = Sn + 8 | 0, Gr = Be + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = Be >>> 0 > Gr >>> 0 ? d + 1 | 0 : d, Be = dr + Gr | 0, d = Be >>> 0 < Gr >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = v + Be | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + fr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Be = o << 12 | he >>> 20, he = a[we + 5424 >> 2], fr = Be + he | 0, v = d, o = d << 12 | o >>> 20, d = o + a[we + 5428 >> 2] | 0, d = he >>> 0 > fr >>> 0 ? d + 1 | 0 : d, Lr(Rr, fr, d, 0, 0, 15632, 16, 0, 0), Si = we + 5392 | 0, dr = Si, Be = (o | 0) == (d | 0) & Be >>> 0 > fr >>> 0 | o >>> 0 > d >>> 0, o = Fr + 8 | 0, he = a[o >> 2], d = a[o + 4 >> 2], v = v >>> 20 | 0, o = v + he | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Be | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Lr(dr, o, d, 0, 0, 64028672, 65536, 0, 0), v = a[we + 5376 >> 2], o = a[we + 5648 >> 2], fr = v + o | 0, Be = a[we + 5380 >> 2], d = Be + a[we + 5652 >> 2] | 0, Xn = we + 7496 | 0, Sn = Xn + 8 | 0, Gr = Sn, he = o >>> 0 > fr >>> 0 ? d + 1 | 0 : d, Be = (Be | 0) == (he | 0) & v >>> 0 > fr >>> 0 | he >>> 0 < Be >>> 0, d = qi + 8 | 0, v = a[d >> 2], o = yo + 8 | 0, dr = v + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 > dr >>> 0 ? d + 1 | 0 : d, o = Be + dr | 0, d = o >>> 0 < dr >>> 0 ? d + 1 | 0 : d, dr = he, Be = o << 12 | he >>> 20, v = d, he = d << 12 | o >>> 20, Fr = a[we + 5440 >> 2], o = a[we + 5616 >> 2], Rr = Fr + o | 0, Oi = a[we + 5444 >> 2], d = Oi + a[we + 5620 >> 2] | 0, o = o >>> 0 > Rr >>> 0 ? d + 1 | 0 : d, d = o + he | 0, Be = Be + Rr | 0, d = Be >>> 0 < Rr >>> 0 ? d + 1 | 0 : d, a[Gr >> 2] = Be, he = d, a[Gr + 4 >> 2] = d & 1048575, In = Xn + 16 | 0, $r = In, Gr = (o | 0) == (d | 0) & Be >>> 0 < Rr >>> 0 | o >>> 0 > d >>> 0, Rr = (o | 0) == (Oi | 0) & Rr >>> 0 < Fr >>> 0 | o >>> 0 < Oi >>> 0, d = Vn + 8 | 0, Be = a[d >> 2], o = zi + 8 | 0, Fr = Be + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = Be >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, Be = Rr + Fr | 0, d = Be >>> 0 < Fr >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = v + Be | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Gr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Be = o << 12 | he >>> 20, v = d, he = d << 12 | o >>> 20, un = a[we + 5600 >> 2], o = a[we + 5664 >> 2], Gr = un + o | 0, zi = a[we + 5604 >> 2], d = zi + a[we + 5668 >> 2] | 0, d = o >>> 0 > Gr >>> 0 ? d + 1 | 0 : d, o = a[we + 5408 >> 2], Rr = o + Gr | 0, Fr = d, d = d + a[we + 5412 >> 2] | 0, o = o >>> 0 > Rr >>> 0 ? d + 1 | 0 : d, d = o + he | 0, Be = Be + Rr | 0, d = Be >>> 0 < Rr >>> 0 ? d + 1 | 0 : d, a[$r >> 2] = Be, he = d, a[$r + 4 >> 2] = d & 1048575, Kn = Xn + 24 | 0, Ti = (o | 0) == (d | 0) & Be >>> 0 < Rr >>> 0 | o >>> 0 > d >>> 0, Oi = (o | 0) == (Fr | 0) & Rr >>> 0 < Gr >>> 0 | o >>> 0 < Fr >>> 0, o = ni + 8 | 0, $r = a[o >> 2], ni = a[o + 4 >> 2], Rr = (Fr | 0) == (zi | 0) & Gr >>> 0 < un >>> 0 | Fr >>> 0 < zi >>> 0, d = $i + 8 | 0, Be = a[d >> 2], o = mi + 8 | 0, Gr = Be + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = Be >>> 0 > Gr >>> 0 ? d + 1 | 0 : d, o = Rr + Gr | 0, d = (o >>> 0 < Gr >>> 0 ? d + 1 | 0 : d) + ni | 0, Be = o, o = o + $r | 0, d = Be >>> 0 > o >>> 0 ? d + 1 | 0 : d, Be = o + Oi | 0, d = Be >>> 0 < o >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = v + Be | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Ti | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Rr = o << 12 | he >>> 20, v = d, Be = d << 12 | o >>> 20, Gr = a[we + 5392 >> 2], he = Qe & -2, o = Gr + he | 0, $r = a[we + 5396 >> 2], d = $r + (Dr & 1048575) | 0, Qe = o >>> 0 < he >>> 0 ? d + 1 | 0 : d, d = Qe + Be | 0, Dr = o, he = o + Rr | 0, a[Kn >> 2] = he, o = o >>> 0 > he >>> 0 ? d + 1 | 0 : d, a[Kn + 4 >> 2] = o & 1048575, ni = Xn + 32 | 0, Fr = ni, Be = Me, Rr = wr & 65535, wr = (o | 0) == (Qe | 0) & he >>> 0 < Dr >>> 0 | o >>> 0 < Qe >>> 0, he = (Qe | 0) == ($r | 0) & Dr >>> 0 < Gr >>> 0 | Qe >>> 0 < $r >>> 0, d = Si + 8 | 0, Me = he + a[d >> 2] | 0, d = a[d + 4 >> 2], d = he >>> 0 > Me >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, he = v, v = v + Me | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + wr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, o = v << 12 | o >>> 20, he = o + Be | 0, d = Rr + (d << 12 | v >>> 20) | 0, a[Fr >> 2] = he, a[Fr + 4 >> 2] = o >>> 0 > he >>> 0 ? d + 1 | 0 : d, a[we + 7496 >> 2] = fr, a[we + 7500 >> 2] = dr & 1048575, gn(Xn, Xn, Ts), o = a[we + 7500 >> 2], $i = o, Si = a[we + 7496 >> 2], Be = Si, d = o << 1 | Be >>> 31, Fr = we + 5216 | 0, Dr = a[Kn >> 2], wr = a[Kn + 4 >> 2], Oi = Be << 1, Ti = d, Lr(Fr, Dr, wr, 0, 0, Oi, d, 0, 0), o = a[Sn + 4 >> 2], ds = o, Io = a[Sn >> 2], v = Io, d = o << 1 | v >>> 31, Gr = we + 5312 | 0, Rr = a[In >> 2], fr = a[In + 4 >> 2], v = v << 1, he = d, Lr(Gr, Rr, fr, 0, 0, v, d, 0, 0), Qe = we + 5200 | 0, Me = a[ni >> 2], o = a[ni + 4 >> 2], Lr(Qe, Me, o, 0, 0, Me, o, 0, 0), dr = we + 5184 | 0, Lr(dr, a[we + 5200 >> 2], a[we + 5204 >> 2], 0, 0, 15632, 16, 0, 0), d = o << 1 | Me >>> 31, Go = we + 5152 | 0, un = Me << 1, $r = d, Lr(Go, un, d, 0, 0, Be, $i, 0, 0), Ho = we + 5232 | 0, Lr(Ho, Dr, wr, 0, 0, v, he, 0, 0), Mo = we + 5296 | 0, Lr(Mo, Rr, fr, 0, 0, Rr, fr, 0, 0), Kn = we + 5168 | 0, o = Qe + 8 | 0, Lr(Kn, a[o >> 2], a[o + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), qi = we + 5360 | 0, Lr(qi, Be, $i, 0, 0, Be, $i, 0, 0), uo = we + 5136 | 0, Lr(uo, un, d, 0, 0, Io, ds, 0, 0), Oo = we + 5248 | 0, Lr(Oo, Dr, wr, 0, 0, Rr << 1, fr << 1 | Rr >>> 31, 0, 0), Si = a[we + 5220 >> 2], d = Si + a[we + 5316 >> 2] | 0, Me = a[we + 5216 >> 2], v = a[we + 5312 >> 2], o = Me + v | 0, he = a[we + 5184 >> 2], ni = o + he | 0, v = o >>> 0 < v >>> 0 ? d + 1 | 0 : d, d = v + a[we + 5188 >> 2] | 0, he = he >>> 0 > ni >>> 0 ? d + 1 | 0 : d, Qe = (v | 0) == (he | 0) & o >>> 0 > ni >>> 0 | v >>> 0 > he >>> 0, d = dr + 8 | 0, dr = a[d >> 2], Be = a[d + 4 >> 2], Me = (v | 0) == (Si | 0) & o >>> 0 < Me >>> 0 | v >>> 0 < Si >>> 0, d = Gr + 8 | 0, v = a[d >> 2], o = Fr + 8 | 0, Gr = v + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 > Gr >>> 0 ? d + 1 | 0 : d, o = Me + Gr | 0, d = (o >>> 0 < Gr >>> 0 ? d + 1 | 0 : d) + Be | 0, v = o, o = o + dr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Qe | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Fr = he, dr = o << 12 | he >>> 20, v = d, Me = d << 12 | o >>> 20, Xn = a[we + 5232 >> 2], o = a[we + 5296 >> 2], Qe = Xn + o | 0, xo = a[we + 5236 >> 2], d = xo + a[we + 5300 >> 2] | 0, d = o >>> 0 > Qe >>> 0 ? d + 1 | 0 : d, o = a[we + 5152 >> 2], Be = o + Qe | 0, Si = d, d = d + a[we + 5156 >> 2] | 0, d = o >>> 0 > Be >>> 0 ? d + 1 | 0 : d, o = a[we + 5168 >> 2], he = o + Be | 0, Gr = d, d = d + a[we + 5172 >> 2] | 0, o = o >>> 0 > he >>> 0 ? d + 1 | 0 : d, d = o + Me | 0, yo = we + 5120 | 0, Vn = yo, dr = he + dr | 0, Me = dr >>> 0 < he >>> 0 ? d + 1 | 0 : d, Sn = (o | 0) == (Me | 0) & he >>> 0 > dr >>> 0 | o >>> 0 > Me >>> 0, In = (o | 0) == (Gr | 0) & he >>> 0 < Be >>> 0 | o >>> 0 < Gr >>> 0, o = Kn + 8 | 0, zi = a[o >> 2], mi = a[o + 4 >> 2], $i = (Gr | 0) == (Si | 0) & Be >>> 0 < Qe >>> 0 | Gr >>> 0 < Si >>> 0, o = Go + 8 | 0, Kn = a[o >> 2], Gr = a[o + 4 >> 2], Be = (Si | 0) == (xo | 0) & Qe >>> 0 < Xn >>> 0 | Si >>> 0 < xo >>> 0, d = Mo + 8 | 0, he = a[d >> 2], o = Ho + 8 | 0, Qe = he + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = he >>> 0 > Qe >>> 0 ? d + 1 | 0 : d, o = Be + Qe | 0, d = (o >>> 0 < Qe >>> 0 ? d + 1 | 0 : d) + Gr | 0, he = o, o = o + Kn | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, he = o, o = o + $i | 0, d = (he >>> 0 > o >>> 0 ? d + 1 | 0 : d) + mi | 0, he = o, o = o + zi | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, he = o + In | 0, d = he >>> 0 < o >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = v + he | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Sn | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = Me, Be = o << 12 | v >>> 20, he = d, Me = d << 12 | o >>> 20, mi = a[we + 5136 >> 2], o = a[we + 5248 >> 2], Qe = mi + o | 0, zi = a[we + 5140 >> 2], d = zi + a[we + 5252 >> 2] | 0, o = o >>> 0 > Qe >>> 0 ? d + 1 | 0 : d, d = o + Me | 0, Be = Be + Qe | 0, d = Be >>> 0 < Qe >>> 0 ? d + 1 | 0 : d, Kn = Be << 4 & -16, Me = d, Si = (d << 4 | Be >>> 28) & 16777215, Gr = v, Lr(Vn, Kn | v >>> 16 & 15, Si, 0, 0, 977, 1, 0, 0), Vn = we + 5344 | 0, Lr(Vn, Io, ds, 0, 0, Oi, Ti, 0, 0), In = we + 5088 | 0, Lr(In, un, $r, 0, 0, Rr, fr, 0, 0), $i = we + 5264 | 0, Lr($i, Dr, wr, 0, 0, Dr, wr, 0, 0), Kn = we + 5072 | 0, Si = (o | 0) == (d | 0) & Be >>> 0 < Qe >>> 0 | o >>> 0 > d >>> 0, Be = (o | 0) == (zi | 0) & Qe >>> 0 < mi >>> 0 | o >>> 0 < zi >>> 0, d = Oo + 8 | 0, v = a[d >> 2], o = uo + 8 | 0, Qe = v + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 > Qe >>> 0 ? d + 1 | 0 : d, v = Be + Qe | 0, d = v >>> 0 < Qe >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, o = v + he | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Si | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Me = o << 12 | Me >>> 20, v = d, he = d << 12 | o >>> 20, Si = a[we + 5088 >> 2], o = a[we + 5264 >> 2], Be = Si + o | 0, Sn = a[we + 5092 >> 2], d = Sn + a[we + 5268 >> 2] | 0, o = o >>> 0 > Be >>> 0 ? d + 1 | 0 : d, d = o + he | 0, Me = Be + Me | 0, d = Me >>> 0 < Be >>> 0 ? d + 1 | 0 : d, he = d, Lr(Kn, Me, d & 1048575, 0, 0, 15632, 16, 0, 0), zi = we + 5280 | 0, Lr(zi, Rr, fr, 0, 0, Oi, Ti, 0, 0), mi = we + 5328 | 0, Lr(mi, Io, ds, 0, 0, Io, ds, 0, 0), Qe = we + 5024 | 0, Lr(Qe, un, $r, 0, 0, Dr, wr, 0, 0), Oi = we + 5008 | 0, wr = Oi, fr = (o | 0) == (d | 0) & Be >>> 0 > Me >>> 0 | o >>> 0 > d >>> 0, Be = (o | 0) == (Sn | 0) & Be >>> 0 < Si >>> 0 | o >>> 0 < Sn >>> 0, d = $i + 8 | 0, Me = a[d >> 2], o = In + 8 | 0, Dr = Me + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = Me >>> 0 > Dr >>> 0 ? d + 1 | 0 : d, Me = Be + Dr | 0, d = Me >>> 0 < Dr >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = v + Me | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + fr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Me = o << 12 | he >>> 20, he = a[we + 5024 >> 2], fr = Me + he | 0, v = d, o = d << 12 | o >>> 20, d = o + a[we + 5028 >> 2] | 0, d = he >>> 0 > fr >>> 0 ? d + 1 | 0 : d, Lr(wr, fr, d, 0, 0, 15632, 16, 0, 0), Sn = we + 4944 | 0, Be = Sn, Me = (o | 0) == (d | 0) & Me >>> 0 > fr >>> 0 | o >>> 0 > d >>> 0, o = Qe + 8 | 0, he = a[o >> 2], d = a[o + 4 >> 2], v = v >>> 20 | 0, o = v + he | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Me | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Lr(Be, o, d, 0, 0, 64028672, 65536, 0, 0), v = a[we + 5120 >> 2], o = a[we + 5360 >> 2], Be = v + o | 0, Me = a[we + 5124 >> 2], d = Me + a[we + 5364 >> 2] | 0, he = o >>> 0 > Be >>> 0 ? d + 1 | 0 : d, Me = (Me | 0) == (he | 0) & v >>> 0 > Be >>> 0 | he >>> 0 < Me >>> 0, d = qi + 8 | 0, v = a[d >> 2], o = yo + 8 | 0, fr = v + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 > fr >>> 0 ? d + 1 | 0 : d, o = Me + fr | 0, d = o >>> 0 < fr >>> 0 ? d + 1 | 0 : d, Rr = he, Me = o << 12 | he >>> 20, v = d, he = d << 12 | o >>> 20, wr = a[we + 5072 >> 2], o = a[we + 5344 >> 2], fr = wr + o | 0, Qe = a[we + 5076 >> 2], d = Qe + a[we + 5348 >> 2] | 0, o = o >>> 0 > fr >>> 0 ? d + 1 | 0 : d, d = o + he | 0, Me = Me + fr | 0, he = Me >>> 0 < fr >>> 0 ? d + 1 | 0 : d, Dr = (o | 0) == (he | 0) & Me >>> 0 < fr >>> 0 | o >>> 0 > he >>> 0, wr = (o | 0) == (Qe | 0) & fr >>> 0 < wr >>> 0 | o >>> 0 < Qe >>> 0, d = Vn + 8 | 0, fr = a[d >> 2], o = Kn + 8 | 0, Qe = fr + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = fr >>> 0 > Qe >>> 0 ? d + 1 | 0 : d, fr = wr + Qe | 0, d = fr >>> 0 < Qe >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = v + fr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Dr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Qe = he, fr = o << 12 | he >>> 20, v = d, he = d << 12 | o >>> 20, $i = a[we + 5280 >> 2], o = a[we + 5328 >> 2], Dr = $i + o | 0, Vn = a[we + 5284 >> 2], d = Vn + a[we + 5332 >> 2] | 0, d = o >>> 0 > Dr >>> 0 ? d + 1 | 0 : d, o = a[we + 5008 >> 2], wr = o + Dr | 0, $r = d, d = d + a[we + 5012 >> 2] | 0, o = o >>> 0 > wr >>> 0 ? d + 1 | 0 : d, d = o + he | 0, In = we + 4928 | 0, Kn = In, he = fr + wr | 0, fr = he >>> 0 < wr >>> 0 ? d + 1 | 0 : d, Si = (o | 0) == (fr | 0) & he >>> 0 < wr >>> 0 | o >>> 0 > fr >>> 0, un = (o | 0) == ($r | 0) & wr >>> 0 < Dr >>> 0 | o >>> 0 < $r >>> 0, o = Oi + 8 | 0, Ti = a[o >> 2], Oi = a[o + 4 >> 2], Dr = ($r | 0) == (Vn | 0) & Dr >>> 0 < $i >>> 0 | $r >>> 0 < Vn >>> 0, d = mi + 8 | 0, wr = a[d >> 2], o = zi + 8 | 0, $r = wr + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = wr >>> 0 > $r >>> 0 ? d + 1 | 0 : d, o = Dr + $r | 0, d = (o >>> 0 < $r >>> 0 ? d + 1 | 0 : d) + Oi | 0, Dr = o, o = o + Ti | 0, d = Dr >>> 0 > o >>> 0 ? d + 1 | 0 : d, wr = o + un | 0, d = wr >>> 0 < o >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = v + wr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Si | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, wr = fr, Dr = o << 12 | fr >>> 20, v = d, $r = d << 12 | o >>> 20, Vn = a[we + 4948 >> 2], d = Vn + (Fr & 1048575) | 0, $i = a[we + 4944 >> 2], o = ni & -2, fr = $i + o | 0, Fr = fr, Dr = fr + Dr | 0, o = o >>> 0 > fr >>> 0 ? d + 1 | 0 : d, d = o + $r | 0, fr = Dr >>> 0 < fr >>> 0 ? d + 1 | 0 : d, $r = fr & 1048575, d = Rr & 1048575, yo = d, Rr = Be, d = d << 1 | Be >>> 31, Ti = Be << 1, un = d, Lr(Kn, Dr, $r, 0, 0, Ti, d, 0, 0), d = Qe & 1048575, Io = d, zi = we + 4960 | 0, ni = wr & 1048575, Be = Me << 1, Kn = Me, wr = d << 1 | Me >>> 31, Lr(zi, he, ni, 0, 0, Be, wr, 0, 0), mi = we + 4864 | 0, Si = mi, Oi = Gr & 65535, Gr = (o | 0) == (fr | 0) & Dr >>> 0 < Fr >>> 0 | o >>> 0 > fr >>> 0, Qe = (o | 0) == (Vn | 0) & Fr >>> 0 < $i >>> 0 | o >>> 0 < Vn >>> 0, o = Sn + 8 | 0, Me = Qe + a[o >> 2] | 0, d = a[o + 4 >> 2], d = Me >>> 0 < Qe >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = v + Me | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Gr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Me = o << 12 | fr >>> 20, v = Me + dr | 0, d = Oi + (d << 12 | o >>> 20) | 0, d = v >>> 0 < Me >>> 0 ? d + 1 | 0 : d, Lr(Si, v, d, 0, 0, v, d, 0, 0), dr = we + 4848 | 0, Lr(dr, a[we + 4864 >> 2], a[we + 4868 >> 2], 0, 0, 15632, 16, 0, 0), o = v, d = d << 1 | o >>> 31, Go = we + 4816 | 0, Si = o << 1, Oi = d, Lr(Go, Si, d, 0, 0, Rr, yo, 0, 0), Ho = we + 4912 | 0, Lr(Ho, Dr, $r, 0, 0, Be, wr, 0, 0), Mo = we + 4976 | 0, Lr(Mo, he, ni, 0, 0, he, ni, 0, 0), $i = we + 4832 | 0, o = mi + 8 | 0, Lr($i, a[o >> 2], a[o + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), qi = we + 5104 | 0, Lr(qi, Rr, yo, 0, 0, Rr, yo, 0, 0), uo = we + 4800 | 0, Lr(uo, Si, d, 0, 0, Kn, Io, 0, 0), Oo = we + 4880 | 0, wr = $r, fr = ni, $r = he, Lr(Oo, Dr, wr, 0, 0, he << 1, fr << 1 | he >>> 31, 0, 0), Me = a[we + 4928 >> 2], v = a[we + 4960 >> 2], o = Me + v | 0, Rr = a[we + 4932 >> 2], d = Rr + a[we + 4964 >> 2] | 0, d = o >>> 0 < v >>> 0 ? d + 1 | 0 : d, v = a[we + 4848 >> 2], ni = v + o | 0, he = d, d = d + a[we + 4852 >> 2] | 0, v = v >>> 0 > ni >>> 0 ? d + 1 | 0 : d, Qe = (he | 0) == (v | 0) & o >>> 0 > ni >>> 0 | v >>> 0 < he >>> 0, d = dr + 8 | 0, dr = a[d >> 2], Be = a[d + 4 >> 2], Me = (he | 0) == (Rr | 0) & o >>> 0 < Me >>> 0 | he >>> 0 < Rr >>> 0, d = zi + 8 | 0, he = a[d >> 2], o = In + 8 | 0, Rr = he + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = he >>> 0 > Rr >>> 0 ? d + 1 | 0 : d, o = Me + Rr | 0, d = (o >>> 0 < Rr >>> 0 ? d + 1 | 0 : d) + Be | 0, he = o, o = o + dr | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, he = o, o = o + Qe | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, Fr = v, dr = o << 12 | v >>> 20, he = d, Me = d << 12 | o >>> 20, Xn = a[we + 4912 >> 2], o = a[we + 4976 >> 2], Rr = Xn + o | 0, xo = a[we + 4916 >> 2], d = xo + a[we + 4980 >> 2] | 0, d = o >>> 0 > Rr >>> 0 ? d + 1 | 0 : d, o = a[we + 4816 >> 2], Qe = o + Rr | 0, v = d, d = d + a[we + 4820 >> 2] | 0, d = o >>> 0 > Qe >>> 0 ? d + 1 | 0 : d, o = a[we + 4832 >> 2], Be = o + Qe | 0, Gr = d, d = d + a[we + 4836 >> 2] | 0, o = o >>> 0 > Be >>> 0 ? d + 1 | 0 : d, d = o + Me | 0, yo = we + 4704 | 0, Vn = yo, dr = Be + dr | 0, Me = dr >>> 0 < Be >>> 0 ? d + 1 | 0 : d, Sn = (o | 0) == (Me | 0) & Be >>> 0 > dr >>> 0 | o >>> 0 > Me >>> 0, In = (o | 0) == (Gr | 0) & Be >>> 0 < Qe >>> 0 | o >>> 0 < Gr >>> 0, o = $i + 8 | 0, zi = a[o >> 2], mi = a[o + 4 >> 2], $i = (v | 0) == (Gr | 0) & Rr >>> 0 > Qe >>> 0 | v >>> 0 > Gr >>> 0, o = Go + 8 | 0, Gr = a[o >> 2], Qe = a[o + 4 >> 2], Be = (v | 0) == (xo | 0) & Rr >>> 0 < Xn >>> 0 | v >>> 0 < xo >>> 0, d = Mo + 8 | 0, v = a[d >> 2], o = Ho + 8 | 0, Rr = v + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 > Rr >>> 0 ? d + 1 | 0 : d, o = Be + Rr | 0, d = (o >>> 0 < Rr >>> 0 ? d + 1 | 0 : d) + Qe | 0, v = o, o = o + Gr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + $i | 0, d = (v >>> 0 > o >>> 0 ? d + 1 | 0 : d) + mi | 0, v = o, o = o + zi | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o + In | 0, d = v >>> 0 < o >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, o = v + he | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Sn | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = Me, Be = o << 12 | v >>> 20, he = d, Me = d << 12 | o >>> 20, mi = a[we + 4800 >> 2], o = a[we + 4880 >> 2], Qe = mi + o | 0, zi = a[we + 4804 >> 2], d = zi + a[we + 4884 >> 2] | 0, o = o >>> 0 > Qe >>> 0 ? d + 1 | 0 : d, d = o + Me | 0, Be = Be + Qe | 0, d = Be >>> 0 < Qe >>> 0 ? d + 1 | 0 : d, $i = Be << 4 & -16, Me = d, Rr = (d << 4 | Be >>> 28) & 16777215, Gr = v, Lr(Vn, $i | v >>> 16 & 15, Rr, 0, 0, 977, 1, 0, 0), Vn = we + 5040 | 0, Lr(Vn, Kn, Io, 0, 0, Ti, un, 0, 0), Sn = we + 4784 | 0, Lr(Sn, Si, Oi, 0, 0, $r, fr, 0, 0), In = we + 4896 | 0, Lr(In, Dr, wr, 0, 0, Dr, wr, 0, 0), $i = we + 4768 | 0, Rr = (o | 0) == (d | 0) & Be >>> 0 < Qe >>> 0 | o >>> 0 > d >>> 0, Be = (o | 0) == (zi | 0) & Qe >>> 0 < mi >>> 0 | o >>> 0 < zi >>> 0, d = Oo + 8 | 0, v = a[d >> 2], o = uo + 8 | 0, Qe = v + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 > Qe >>> 0 ? d + 1 | 0 : d, v = Be + Qe | 0, d = v >>> 0 < Qe >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, o = v + he | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Rr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Me = o << 12 | Me >>> 20, v = d, he = d << 12 | o >>> 20, Rr = a[we + 4784 >> 2], o = a[we + 4896 >> 2], Be = Rr + o | 0, Xn = a[we + 4788 >> 2], d = Xn + a[we + 4900 >> 2] | 0, o = o >>> 0 > Be >>> 0 ? d + 1 | 0 : d, d = o + he | 0, Me = Be + Me | 0, d = Me >>> 0 < Be >>> 0 ? d + 1 | 0 : d, he = d, Lr($i, Me, d & 1048575, 0, 0, 15632, 16, 0, 0), zi = we + 4992 | 0, Lr(zi, $r, fr, 0, 0, Ti, un, 0, 0), mi = we + 5056 | 0, Lr(mi, Kn, Io, 0, 0, Kn, Io, 0, 0), Qe = we + 4752 | 0, Lr(Qe, Dr, wr, 0, 0, Si, Oi, 0, 0), Oi = we + 4736 | 0, wr = Oi, fr = (o | 0) == (d | 0) & Be >>> 0 > Me >>> 0 | o >>> 0 > d >>> 0, Be = (o | 0) == (Xn | 0) & Be >>> 0 < Rr >>> 0 | o >>> 0 < Xn >>> 0, d = In + 8 | 0, Me = a[d >> 2], o = Sn + 8 | 0, Dr = Me + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = Me >>> 0 > Dr >>> 0 ? d + 1 | 0 : d, Me = Be + Dr | 0, d = Me >>> 0 < Dr >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = v + Me | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + fr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Me = o << 12 | he >>> 20, he = a[we + 4752 >> 2], fr = Me + he | 0, v = d, o = d << 12 | o >>> 20, d = o + a[we + 4756 >> 2] | 0, d = he >>> 0 > fr >>> 0 ? d + 1 | 0 : d, Lr(wr, fr, d, 0, 0, 15632, 16, 0, 0), Sn = we + 4720 | 0, Be = Sn, Me = (o | 0) == (d | 0) & Me >>> 0 > fr >>> 0 | o >>> 0 > d >>> 0, o = Qe + 8 | 0, he = a[o >> 2], d = a[o + 4 >> 2], v = v >>> 20 | 0, o = v + he | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Me | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Lr(Be, o, d, 0, 0, 64028672, 65536, 0, 0), v = a[we + 4704 >> 2], o = a[we + 5104 >> 2], Be = v + o | 0, Me = a[we + 4708 >> 2], d = Me + a[we + 5108 >> 2] | 0, he = o >>> 0 > Be >>> 0 ? d + 1 | 0 : d, Me = (Me | 0) == (he | 0) & v >>> 0 > Be >>> 0 | he >>> 0 < Me >>> 0, d = qi + 8 | 0, v = a[d >> 2], o = yo + 8 | 0, fr = v + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 > fr >>> 0 ? d + 1 | 0 : d, o = Me + fr | 0, d = o >>> 0 < fr >>> 0 ? d + 1 | 0 : d, Rr = he, Me = o << 12 | he >>> 20, v = d, Dr = d << 12 | o >>> 20, Qe = a[we + 4772 >> 2], d = Qe + a[we + 5044 >> 2] | 0, wr = a[we + 4768 >> 2], o = a[we + 5040 >> 2], he = wr + o | 0, fr = he, Me = he + Me | 0, o = o >>> 0 > he >>> 0 ? d + 1 | 0 : d, d = o + Dr | 0, he = Me >>> 0 < he >>> 0 ? d + 1 | 0 : d, Dr = (o | 0) == (he | 0) & Me >>> 0 < fr >>> 0 | o >>> 0 > he >>> 0, wr = (o | 0) == (Qe | 0) & fr >>> 0 < wr >>> 0 | o >>> 0 < Qe >>> 0, d = Vn + 8 | 0, fr = a[d >> 2], o = $i + 8 | 0, Qe = fr + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = fr >>> 0 > Qe >>> 0 ? d + 1 | 0 : d, fr = wr + Qe | 0, d = fr >>> 0 < Qe >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = v + fr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Dr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Qe = he, fr = o << 12 | he >>> 20, v = d, he = d << 12 | o >>> 20, $i = a[we + 4992 >> 2], o = a[we + 5056 >> 2], Dr = $i + o | 0, Vn = a[we + 4996 >> 2], d = Vn + a[we + 5060 >> 2] | 0, d = o >>> 0 > Dr >>> 0 ? d + 1 | 0 : d, o = a[we + 4736 >> 2], wr = o + Dr | 0, $r = d, d = d + a[we + 4740 >> 2] | 0, o = o >>> 0 > wr >>> 0 ? d + 1 | 0 : d, d = o + he | 0, In = we + 4624 | 0, Kn = In, he = fr + wr | 0, fr = he >>> 0 < wr >>> 0 ? d + 1 | 0 : d, Si = (o | 0) == (fr | 0) & he >>> 0 < wr >>> 0 | o >>> 0 > fr >>> 0, un = (o | 0) == ($r | 0) & wr >>> 0 < Dr >>> 0 | o >>> 0 < $r >>> 0, o = Oi + 8 | 0, Ti = a[o >> 2], Oi = a[o + 4 >> 2], Dr = ($r | 0) == (Vn | 0) & Dr >>> 0 < $i >>> 0 | $r >>> 0 < Vn >>> 0, d = mi + 8 | 0, wr = a[d >> 2], o = zi + 8 | 0, $r = wr + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = wr >>> 0 > $r >>> 0 ? d + 1 | 0 : d, o = Dr + $r | 0, d = (o >>> 0 < $r >>> 0 ? d + 1 | 0 : d) + Oi | 0, Dr = o, o = o + Ti | 0, d = Dr >>> 0 > o >>> 0 ? d + 1 | 0 : d, wr = o + un | 0, d = wr >>> 0 < o >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = v + wr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Si | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, wr = fr, $r = o << 12 | fr >>> 20, v = d, Dr = d << 12 | o >>> 20, Vn = a[we + 4724 >> 2], d = Vn + (Fr & 1048575) | 0, $i = a[we + 4720 >> 2], fr = ni & -2, o = $i + fr | 0, Fr = o, o = o >>> 0 < fr >>> 0 ? d + 1 | 0 : d, d = o + Dr | 0, Dr = Fr + $r | 0, fr = Dr >>> 0 < Fr >>> 0 ? d + 1 | 0 : d, Si = fr & 1048575, ni = Si, d = Rr & 1048575, yo = d, Rr = Be, d = d << 1 | Be >>> 31, Oi = Be << 1, Ti = d, Lr(Kn, Dr, ni, 0, 0, Oi, d, 0, 0), d = Qe & 1048575, Io = d, zi = we + 4576 | 0, ni = wr & 1048575, Be = Me << 1, Kn = Me, wr = d << 1 | Me >>> 31, Lr(zi, he, ni, 0, 0, Be, wr, 0, 0), mi = we + 4528 | 0, $r = Gr & 65535, Gr = (o | 0) == (fr | 0) & Dr >>> 0 < Fr >>> 0 | o >>> 0 > fr >>> 0, Qe = (o | 0) == (Vn | 0) & Fr >>> 0 < $i >>> 0 | o >>> 0 < Vn >>> 0, o = Sn + 8 | 0, Me = Qe + a[o >> 2] | 0, d = a[o + 4 >> 2], d = Me >>> 0 < Qe >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = v + Me | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Gr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Me = o << 12 | fr >>> 20, v = Me + dr | 0, d = $r + (d << 12 | o >>> 20) | 0, d = v >>> 0 < Me >>> 0 ? d + 1 | 0 : d, Lr(mi, v, d, 0, 0, v, d, 0, 0), dr = we + 4512 | 0, Lr(dr, a[we + 4528 >> 2], a[we + 4532 >> 2], 0, 0, 15632, 16, 0, 0), o = v, d = d << 1 | o >>> 31, Go = we + 4480 | 0, un = o << 1, $r = d, Lr(Go, un, d, 0, 0, Rr, yo, 0, 0), Ho = we + 4560 | 0, Lr(Ho, Dr, Si, 0, 0, Be, wr, 0, 0), Mo = we + 4672 | 0, Lr(Mo, he, ni, 0, 0, he, ni, 0, 0), $i = we + 4496 | 0, o = mi + 8 | 0, Lr($i, a[o >> 2], a[o + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), qi = we + 4640 | 0, Lr(qi, Rr, yo, 0, 0, Rr, yo, 0, 0), uo = we + 4464 | 0, Lr(uo, un, d, 0, 0, Kn, Io, 0, 0), Oo = we + 4544 | 0, Gr = Dr, Rr = Si, fr = ni, ni = he, Lr(Oo, Dr, Rr, 0, 0, he << 1, fr << 1 | he >>> 31, 0, 0), Me = a[we + 4624 >> 2], v = a[we + 4576 >> 2], o = Me + v | 0, Dr = a[we + 4628 >> 2], d = Dr + a[we + 4580 >> 2] | 0, d = o >>> 0 < v >>> 0 ? d + 1 | 0 : d, v = a[we + 4512 >> 2], Qe = v + o | 0, he = d, d = d + a[we + 4516 >> 2] | 0, v = v >>> 0 > Qe >>> 0 ? d + 1 | 0 : d, wr = (he | 0) == (v | 0) & o >>> 0 > Qe >>> 0 | v >>> 0 < he >>> 0, d = dr + 8 | 0, dr = a[d >> 2], Be = a[d + 4 >> 2], Me = (he | 0) == (Dr | 0) & o >>> 0 < Me >>> 0 | he >>> 0 < Dr >>> 0, d = zi + 8 | 0, he = a[d >> 2], o = In + 8 | 0, Dr = he + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = he >>> 0 > Dr >>> 0 ? d + 1 | 0 : d, o = Me + Dr | 0, d = (o >>> 0 < Dr >>> 0 ? d + 1 | 0 : d) + Be | 0, he = o, o = o + dr | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, he = o, o = o + wr | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, Dr = v, Be = o << 12 | v >>> 20, he = d, Me = d << 12 | o >>> 20, Xn = a[we + 4560 >> 2], o = a[we + 4672 >> 2], Fr = Xn + o | 0, xo = a[we + 4564 >> 2], d = xo + a[we + 4676 >> 2] | 0, d = o >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, o = a[we + 4480 >> 2], wr = o + Fr | 0, v = d, d = d + a[we + 4484 >> 2] | 0, d = o >>> 0 > wr >>> 0 ? d + 1 | 0 : d, o = a[we + 4496 >> 2], dr = o + wr | 0, Si = d, d = d + a[we + 4500 >> 2] | 0, o = o >>> 0 > dr >>> 0 ? d + 1 | 0 : d, d = o + Me | 0, yo = we + 4368 | 0, Vn = yo, Me = Be + dr | 0, Be = Me >>> 0 < dr >>> 0 ? d + 1 | 0 : d, Sn = (o | 0) == (Be | 0) & Me >>> 0 < dr >>> 0 | o >>> 0 > Be >>> 0, In = (o | 0) == (Si | 0) & wr >>> 0 > dr >>> 0 | o >>> 0 < Si >>> 0, o = $i + 8 | 0, zi = a[o >> 2], mi = a[o + 4 >> 2], $i = (v | 0) == (Si | 0) & wr >>> 0 < Fr >>> 0 | v >>> 0 > Si >>> 0, o = Go + 8 | 0, Si = a[o >> 2], wr = a[o + 4 >> 2], dr = (v | 0) == (xo | 0) & Fr >>> 0 < Xn >>> 0 | v >>> 0 < xo >>> 0, d = Mo + 8 | 0, v = a[d >> 2], o = Ho + 8 | 0, Fr = v + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, o = dr + Fr | 0, d = (o >>> 0 < Fr >>> 0 ? d + 1 | 0 : d) + wr | 0, v = o, o = o + Si | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + $i | 0, d = (v >>> 0 > o >>> 0 ? d + 1 | 0 : d) + mi | 0, v = o, o = o + zi | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o + In | 0, d = v >>> 0 < o >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, o = v + he | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Sn | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = Be, dr = o << 12 | v >>> 20, he = d, Be = d << 12 | o >>> 20, mi = a[we + 4464 >> 2], o = a[we + 4544 >> 2], Fr = mi + o | 0, Xn = a[we + 4468 >> 2], d = Xn + a[we + 4548 >> 2] | 0, o = o >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, d = o + Be | 0, dr = dr + Fr | 0, d = dr >>> 0 < Fr >>> 0 ? d + 1 | 0 : d, $i = dr << 4 & -16, Be = d, Si = (d << 4 | dr >>> 28) & 16777215, wr = v, Lr(Vn, $i | v >>> 16 & 15, Si, 0, 0, 977, 1, 0, 0), Vn = we + 4608 | 0, Lr(Vn, Kn, Io, 0, 0, Oi, Ti, 0, 0), Sn = we + 4448 | 0, Lr(Sn, un, $r, 0, 0, ni, fr, 0, 0), In = we + 4688 | 0, Lr(In, Gr, Rr, 0, 0, Gr, Rr, 0, 0), zi = we + 4432 | 0, $i = zi, Si = (o | 0) == (d | 0) & dr >>> 0 < Fr >>> 0 | o >>> 0 > d >>> 0, dr = (o | 0) == (Xn | 0) & Fr >>> 0 < mi >>> 0 | o >>> 0 < Xn >>> 0, d = Oo + 8 | 0, v = a[d >> 2], o = uo + 8 | 0, Fr = v + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, v = dr + Fr | 0, d = v >>> 0 < Fr >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, o = v + he | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Si | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Be = o << 12 | Be >>> 20, v = d, he = d << 12 | o >>> 20, Si = a[we + 4448 >> 2], o = a[we + 4688 >> 2], dr = Si + o | 0, Xn = a[we + 4452 >> 2], d = Xn + a[we + 4692 >> 2] | 0, o = o >>> 0 > dr >>> 0 ? d + 1 | 0 : d, d = o + he | 0, Be = Be + dr | 0, d = Be >>> 0 < dr >>> 0 ? d + 1 | 0 : d, he = d, Lr($i, Be, d & 1048575, 0, 0, 15632, 16, 0, 0), mi = we + 4592 | 0, Lr(mi, ni, fr, 0, 0, Oi, Ti, 0, 0), $i = we + 4656 | 0, Lr($i, Kn, Io, 0, 0, Kn, Io, 0, 0), Fr = we + 4416 | 0, Lr(Fr, Gr, Rr, 0, 0, un, $r, 0, 0), ni = we + 4400 | 0, Rr = ni, fr = (o | 0) == (d | 0) & Be >>> 0 < dr >>> 0 | o >>> 0 > d >>> 0, dr = (o | 0) == (Xn | 0) & dr >>> 0 < Si >>> 0 | o >>> 0 < Xn >>> 0, d = In + 8 | 0, Be = a[d >> 2], o = Sn + 8 | 0, Gr = Be + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = Be >>> 0 > Gr >>> 0 ? d + 1 | 0 : d, Be = dr + Gr | 0, d = Be >>> 0 < Gr >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = v + Be | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + fr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Be = o << 12 | he >>> 20, he = a[we + 4416 >> 2], fr = Be + he | 0, v = d, o = d << 12 | o >>> 20, d = o + a[we + 4420 >> 2] | 0, d = he >>> 0 > fr >>> 0 ? d + 1 | 0 : d, Lr(Rr, fr, d, 0, 0, 15632, 16, 0, 0), Si = we + 4384 | 0, dr = Si, Be = (o | 0) == (d | 0) & Be >>> 0 > fr >>> 0 | o >>> 0 > d >>> 0, o = Fr + 8 | 0, he = a[o >> 2], d = a[o + 4 >> 2], v = v >>> 20 | 0, o = v + he | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Be | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Lr(dr, o, d, 0, 0, 64028672, 65536, 0, 0), v = a[we + 4368 >> 2], o = a[we + 4640 >> 2], fr = v + o | 0, Be = a[we + 4372 >> 2], d = Be + a[we + 4644 >> 2] | 0, Xn = we + 7456 | 0, Sn = Xn + 8 | 0, $r = Sn, he = o >>> 0 > fr >>> 0 ? d + 1 | 0 : d, Be = (Be | 0) == (he | 0) & v >>> 0 > fr >>> 0 | he >>> 0 < Be >>> 0, d = qi + 8 | 0, v = a[d >> 2], o = yo + 8 | 0, dr = v + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 > dr >>> 0 ? d + 1 | 0 : d, o = Be + dr | 0, d = o >>> 0 < dr >>> 0 ? d + 1 | 0 : d, dr = he, Be = o << 12 | he >>> 20, v = d, Gr = d << 12 | o >>> 20, Oi = a[we + 4436 >> 2], d = Oi + a[we + 4612 >> 2] | 0, Fr = a[we + 4432 >> 2], o = a[we + 4608 >> 2], he = Fr + o | 0, Rr = he, Be = he + Be | 0, o = o >>> 0 > he >>> 0 ? d + 1 | 0 : d, d = o + Gr | 0, a[$r >> 2] = Be, he = Be >>> 0 < he >>> 0 ? d + 1 | 0 : d, a[$r + 4 >> 2] = he & 1048575, In = Xn + 16 | 0, $r = In, Gr = (o | 0) == (he | 0) & Be >>> 0 < Rr >>> 0 | o >>> 0 > he >>> 0, Rr = (o | 0) == (Oi | 0) & Rr >>> 0 < Fr >>> 0 | o >>> 0 < Oi >>> 0, d = Vn + 8 | 0, Be = a[d >> 2], o = zi + 8 | 0, Fr = Be + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = Be >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, Be = Rr + Fr | 0, d = Be >>> 0 < Fr >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = v + Be | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Gr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Be = o << 12 | he >>> 20, v = d, he = d << 12 | o >>> 20, un = a[we + 4592 >> 2], o = a[we + 4656 >> 2], Gr = un + o | 0, zi = a[we + 4596 >> 2], d = zi + a[we + 4660 >> 2] | 0, d = o >>> 0 > Gr >>> 0 ? d + 1 | 0 : d, o = a[we + 4400 >> 2], Rr = o + Gr | 0, Fr = d, d = d + a[we + 4404 >> 2] | 0, o = o >>> 0 > Rr >>> 0 ? d + 1 | 0 : d, d = o + he | 0, Be = Be + Rr | 0, d = Be >>> 0 < Rr >>> 0 ? d + 1 | 0 : d, a[$r >> 2] = Be, he = d, a[$r + 4 >> 2] = d & 1048575, Kn = Xn + 24 | 0, Ti = (o | 0) == (d | 0) & Be >>> 0 < Rr >>> 0 | o >>> 0 > d >>> 0, Oi = (o | 0) == (Fr | 0) & Rr >>> 0 < Gr >>> 0 | o >>> 0 < Fr >>> 0, o = ni + 8 | 0, $r = a[o >> 2], ni = a[o + 4 >> 2], Rr = (Fr | 0) == (zi | 0) & Gr >>> 0 < un >>> 0 | Fr >>> 0 < zi >>> 0, d = $i + 8 | 0, Be = a[d >> 2], o = mi + 8 | 0, Gr = Be + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = Be >>> 0 > Gr >>> 0 ? d + 1 | 0 : d, o = Rr + Gr | 0, d = (o >>> 0 < Gr >>> 0 ? d + 1 | 0 : d) + ni | 0, Be = o, o = o + $r | 0, d = Be >>> 0 > o >>> 0 ? d + 1 | 0 : d, Be = o + Oi | 0, d = Be >>> 0 < o >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = v + Be | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Ti | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Rr = o << 12 | he >>> 20, v = d, Be = d << 12 | o >>> 20, Gr = a[we + 4384 >> 2], he = Qe & -2, o = Gr + he | 0, $r = a[we + 4388 >> 2], d = $r + (Dr & 1048575) | 0, Qe = o >>> 0 < he >>> 0 ? d + 1 | 0 : d, d = Qe + Be | 0, Dr = o, he = o + Rr | 0, a[Kn >> 2] = he, o = o >>> 0 > he >>> 0 ? d + 1 | 0 : d, a[Kn + 4 >> 2] = o & 1048575, ni = Xn + 32 | 0, Fr = ni, Be = Me, Rr = wr & 65535, wr = (o | 0) == (Qe | 0) & he >>> 0 < Dr >>> 0 | o >>> 0 < Qe >>> 0, he = (Qe | 0) == ($r | 0) & Dr >>> 0 < Gr >>> 0 | Qe >>> 0 < $r >>> 0, d = Si + 8 | 0, Me = he + a[d >> 2] | 0, d = a[d + 4 >> 2], d = he >>> 0 > Me >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, he = v, v = v + Me | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + wr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, o = v << 12 | o >>> 20, he = o + Be | 0, d = Rr + (d << 12 | v >>> 20) | 0, a[Fr >> 2] = he, a[Fr + 4 >> 2] = o >>> 0 > he >>> 0 ? d + 1 | 0 : d, a[we + 7456 >> 2] = fr, a[we + 7460 >> 2] = dr & 1048575, gn(Xn, Xn, Ts), o = a[we + 7460 >> 2], $i = o, Si = a[we + 7456 >> 2], Be = Si, d = o << 1 | Be >>> 31, Fr = we + 4208 | 0, Dr = a[Kn >> 2], wr = a[Kn + 4 >> 2], Oi = Be << 1, Ti = d, Lr(Fr, Dr, wr, 0, 0, Oi, d, 0, 0), o = a[Sn + 4 >> 2], ds = o, Io = a[Sn >> 2], v = Io, d = o << 1 | v >>> 31, Gr = we + 4304 | 0, Rr = a[In >> 2], fr = a[In + 4 >> 2], v = v << 1, he = d, Lr(Gr, Rr, fr, 0, 0, v, d, 0, 0), Qe = we + 4192 | 0, Me = a[ni >> 2], o = a[ni + 4 >> 2], Lr(Qe, Me, o, 0, 0, Me, o, 0, 0), dr = we + 4176 | 0, Lr(dr, a[we + 4192 >> 2], a[we + 4196 >> 2], 0, 0, 15632, 16, 0, 0), d = o << 1 | Me >>> 31, Go = we + 4144 | 0, un = Me << 1, $r = d, Lr(Go, un, d, 0, 0, Be, $i, 0, 0), Ho = we + 4224 | 0, Lr(Ho, Dr, wr, 0, 0, v, he, 0, 0), Mo = we + 4288 | 0, Lr(Mo, Rr, fr, 0, 0, Rr, fr, 0, 0), Kn = we + 4160 | 0, o = Qe + 8 | 0, Lr(Kn, a[o >> 2], a[o + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), qi = we + 4352 | 0, Lr(qi, Be, $i, 0, 0, Be, $i, 0, 0), uo = we + 4128 | 0, Lr(uo, un, d, 0, 0, Io, ds, 0, 0), Oo = we + 4240 | 0, Lr(Oo, Dr, wr, 0, 0, Rr << 1, fr << 1 | Rr >>> 31, 0, 0), Si = a[we + 4212 >> 2], d = Si + a[we + 4308 >> 2] | 0, Me = a[we + 4208 >> 2], v = a[we + 4304 >> 2], o = Me + v | 0, he = a[we + 4176 >> 2], ni = o + he | 0, v = o >>> 0 < v >>> 0 ? d + 1 | 0 : d, d = v + a[we + 4180 >> 2] | 0, he = he >>> 0 > ni >>> 0 ? d + 1 | 0 : d, Qe = (v | 0) == (he | 0) & o >>> 0 > ni >>> 0 | v >>> 0 > he >>> 0, d = dr + 8 | 0, dr = a[d >> 2], Be = a[d + 4 >> 2], Me = (v | 0) == (Si | 0) & o >>> 0 < Me >>> 0 | v >>> 0 < Si >>> 0, d = Gr + 8 | 0, v = a[d >> 2], o = Fr + 8 | 0, Gr = v + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 > Gr >>> 0 ? d + 1 | 0 : d, o = Me + Gr | 0, d = (o >>> 0 < Gr >>> 0 ? d + 1 | 0 : d) + Be | 0, v = o, o = o + dr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Qe | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Fr = he, dr = o << 12 | he >>> 20, v = d, Me = d << 12 | o >>> 20, Xn = a[we + 4224 >> 2], o = a[we + 4288 >> 2], Qe = Xn + o | 0, xo = a[we + 4228 >> 2], d = xo + a[we + 4292 >> 2] | 0, d = o >>> 0 > Qe >>> 0 ? d + 1 | 0 : d, o = a[we + 4144 >> 2], Be = o + Qe | 0, Si = d, d = d + a[we + 4148 >> 2] | 0, d = o >>> 0 > Be >>> 0 ? d + 1 | 0 : d, o = a[we + 4160 >> 2], he = o + Be | 0, Gr = d, d = d + a[we + 4164 >> 2] | 0, o = o >>> 0 > he >>> 0 ? d + 1 | 0 : d, d = o + Me | 0, yo = we + 4112 | 0, Vn = yo, dr = he + dr | 0, Me = dr >>> 0 < he >>> 0 ? d + 1 | 0 : d, Sn = (o | 0) == (Me | 0) & he >>> 0 > dr >>> 0 | o >>> 0 > Me >>> 0, In = (o | 0) == (Gr | 0) & he >>> 0 < Be >>> 0 | o >>> 0 < Gr >>> 0, o = Kn + 8 | 0, zi = a[o >> 2], mi = a[o + 4 >> 2], $i = (Gr | 0) == (Si | 0) & Be >>> 0 < Qe >>> 0 | Gr >>> 0 < Si >>> 0, o = Go + 8 | 0, Kn = a[o >> 2], Gr = a[o + 4 >> 2], Be = (Si | 0) == (xo | 0) & Qe >>> 0 < Xn >>> 0 | Si >>> 0 < xo >>> 0, d = Mo + 8 | 0, he = a[d >> 2], o = Ho + 8 | 0, Qe = he + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = he >>> 0 > Qe >>> 0 ? d + 1 | 0 : d, o = Be + Qe | 0, d = (o >>> 0 < Qe >>> 0 ? d + 1 | 0 : d) + Gr | 0, he = o, o = o + Kn | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, he = o, o = o + $i | 0, d = (he >>> 0 > o >>> 0 ? d + 1 | 0 : d) + mi | 0, he = o, o = o + zi | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, he = o + In | 0, d = he >>> 0 < o >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = v + he | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Sn | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = Me, Be = o << 12 | v >>> 20, he = d, Me = d << 12 | o >>> 20, mi = a[we + 4128 >> 2], o = a[we + 4240 >> 2], Qe = mi + o | 0, zi = a[we + 4132 >> 2], d = zi + a[we + 4244 >> 2] | 0, o = o >>> 0 > Qe >>> 0 ? d + 1 | 0 : d, d = o + Me | 0, Be = Be + Qe | 0, d = Be >>> 0 < Qe >>> 0 ? d + 1 | 0 : d, Kn = Be << 4 & -16, Me = d, Si = (d << 4 | Be >>> 28) & 16777215, Gr = v, Lr(Vn, Kn | v >>> 16 & 15, Si, 0, 0, 977, 1, 0, 0), Vn = we + 4336 | 0, Lr(Vn, Io, ds, 0, 0, Oi, Ti, 0, 0), In = we + 4080 | 0, Lr(In, un, $r, 0, 0, Rr, fr, 0, 0), $i = we + 4256 | 0, Lr($i, Dr, wr, 0, 0, Dr, wr, 0, 0), Kn = we + 4064 | 0, Si = (o | 0) == (d | 0) & Be >>> 0 < Qe >>> 0 | o >>> 0 > d >>> 0, Be = (o | 0) == (zi | 0) & Qe >>> 0 < mi >>> 0 | o >>> 0 < zi >>> 0, d = Oo + 8 | 0, v = a[d >> 2], o = uo + 8 | 0, Qe = v + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 > Qe >>> 0 ? d + 1 | 0 : d, v = Be + Qe | 0, d = v >>> 0 < Qe >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, o = v + he | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Si | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Me = o << 12 | Me >>> 20, v = d, he = d << 12 | o >>> 20, Si = a[we + 4080 >> 2], o = a[we + 4256 >> 2], Be = Si + o | 0, Sn = a[we + 4084 >> 2], d = Sn + a[we + 4260 >> 2] | 0, o = o >>> 0 > Be >>> 0 ? d + 1 | 0 : d, d = o + he | 0, Me = Be + Me | 0, d = Me >>> 0 < Be >>> 0 ? d + 1 | 0 : d, he = d, Lr(Kn, Me, d & 1048575, 0, 0, 15632, 16, 0, 0), zi = we + 4272 | 0, Lr(zi, Rr, fr, 0, 0, Oi, Ti, 0, 0), mi = we + 4320 | 0, Lr(mi, Io, ds, 0, 0, Io, ds, 0, 0), Qe = we + 4016 | 0, Lr(Qe, un, $r, 0, 0, Dr, wr, 0, 0), Oi = we + 4e3 | 0, wr = Oi, fr = (o | 0) == (d | 0) & Be >>> 0 > Me >>> 0 | o >>> 0 > d >>> 0, Be = (o | 0) == (Sn | 0) & Be >>> 0 < Si >>> 0 | o >>> 0 < Sn >>> 0, d = $i + 8 | 0, Me = a[d >> 2], o = In + 8 | 0, Dr = Me + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = Me >>> 0 > Dr >>> 0 ? d + 1 | 0 : d, Me = Be + Dr | 0, d = Me >>> 0 < Dr >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = v + Me | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + fr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Me = o << 12 | he >>> 20, he = a[we + 4016 >> 2], fr = Me + he | 0, v = d, o = d << 12 | o >>> 20, d = o + a[we + 4020 >> 2] | 0, d = he >>> 0 > fr >>> 0 ? d + 1 | 0 : d, Lr(wr, fr, d, 0, 0, 15632, 16, 0, 0), Sn = we + 3936 | 0, Be = Sn, Me = (o | 0) == (d | 0) & Me >>> 0 > fr >>> 0 | o >>> 0 > d >>> 0, o = Qe + 8 | 0, he = a[o >> 2], d = a[o + 4 >> 2], v = v >>> 20 | 0, o = v + he | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Me | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Lr(Be, o, d, 0, 0, 64028672, 65536, 0, 0), v = a[we + 4112 >> 2], o = a[we + 4352 >> 2], Be = v + o | 0, Me = a[we + 4116 >> 2], d = Me + a[we + 4356 >> 2] | 0, he = o >>> 0 > Be >>> 0 ? d + 1 | 0 : d, Me = (Me | 0) == (he | 0) & v >>> 0 > Be >>> 0 | he >>> 0 < Me >>> 0, d = qi + 8 | 0, v = a[d >> 2], o = yo + 8 | 0, fr = v + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 > fr >>> 0 ? d + 1 | 0 : d, o = Me + fr | 0, d = o >>> 0 < fr >>> 0 ? d + 1 | 0 : d, Rr = he, Me = o << 12 | he >>> 20, v = d, he = d << 12 | o >>> 20, wr = a[we + 4064 >> 2], o = a[we + 4336 >> 2], fr = wr + o | 0, Qe = a[we + 4068 >> 2], d = Qe + a[we + 4340 >> 2] | 0, o = o >>> 0 > fr >>> 0 ? d + 1 | 0 : d, d = o + he | 0, Me = Me + fr | 0, he = Me >>> 0 < fr >>> 0 ? d + 1 | 0 : d, Dr = (o | 0) == (he | 0) & Me >>> 0 < fr >>> 0 | o >>> 0 > he >>> 0, wr = (o | 0) == (Qe | 0) & fr >>> 0 < wr >>> 0 | o >>> 0 < Qe >>> 0, d = Vn + 8 | 0, fr = a[d >> 2], o = Kn + 8 | 0, Qe = fr + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = fr >>> 0 > Qe >>> 0 ? d + 1 | 0 : d, fr = wr + Qe | 0, d = fr >>> 0 < Qe >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = v + fr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Dr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Qe = he, fr = o << 12 | he >>> 20, v = d, he = d << 12 | o >>> 20, $i = a[we + 4272 >> 2], o = a[we + 4320 >> 2], Dr = $i + o | 0, Vn = a[we + 4276 >> 2], d = Vn + a[we + 4324 >> 2] | 0, d = o >>> 0 > Dr >>> 0 ? d + 1 | 0 : d, o = a[we + 4e3 >> 2], wr = o + Dr | 0, $r = d, d = d + a[we + 4004 >> 2] | 0, o = o >>> 0 > wr >>> 0 ? d + 1 | 0 : d, d = o + he | 0, In = we + 3920 | 0, Kn = In, he = fr + wr | 0, fr = he >>> 0 < wr >>> 0 ? d + 1 | 0 : d, Si = (o | 0) == (fr | 0) & he >>> 0 < wr >>> 0 | o >>> 0 > fr >>> 0, un = (o | 0) == ($r | 0) & wr >>> 0 < Dr >>> 0 | o >>> 0 < $r >>> 0, o = Oi + 8 | 0, Ti = a[o >> 2], Oi = a[o + 4 >> 2], Dr = ($r | 0) == (Vn | 0) & Dr >>> 0 < $i >>> 0 | $r >>> 0 < Vn >>> 0, d = mi + 8 | 0, wr = a[d >> 2], o = zi + 8 | 0, $r = wr + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = wr >>> 0 > $r >>> 0 ? d + 1 | 0 : d, o = Dr + $r | 0, d = (o >>> 0 < $r >>> 0 ? d + 1 | 0 : d) + Oi | 0, Dr = o, o = o + Ti | 0, d = Dr >>> 0 > o >>> 0 ? d + 1 | 0 : d, wr = o + un | 0, d = wr >>> 0 < o >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = v + wr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Si | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, wr = fr, Dr = o << 12 | fr >>> 20, v = d, $r = d << 12 | o >>> 20, Vn = a[we + 3940 >> 2], d = Vn + (Fr & 1048575) | 0, $i = a[we + 3936 >> 2], o = ni & -2, fr = $i + o | 0, Fr = fr, Dr = fr + Dr | 0, o = o >>> 0 > fr >>> 0 ? d + 1 | 0 : d, d = o + $r | 0, fr = Dr >>> 0 < fr >>> 0 ? d + 1 | 0 : d, Si = fr & 1048575, ni = Si, d = Rr & 1048575, yo = d, Rr = Be, d = d << 1 | Be >>> 31, Oi = Be << 1, Ti = d, Lr(Kn, Dr, ni, 0, 0, Oi, d, 0, 0), d = Qe & 1048575, Io = d, zi = we + 3952 | 0, ni = wr & 1048575, Be = Me << 1, Kn = Me, wr = d << 1 | Me >>> 31, Lr(zi, he, ni, 0, 0, Be, wr, 0, 0), mi = we + 3856 | 0, $r = Gr & 65535, Gr = (o | 0) == (fr | 0) & Dr >>> 0 < Fr >>> 0 | o >>> 0 > fr >>> 0, Qe = (o | 0) == (Vn | 0) & Fr >>> 0 < $i >>> 0 | o >>> 0 < Vn >>> 0, o = Sn + 8 | 0, Me = Qe + a[o >> 2] | 0, d = a[o + 4 >> 2], d = Me >>> 0 < Qe >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = v + Me | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Gr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Me = o << 12 | fr >>> 20, v = Me + dr | 0, d = $r + (d << 12 | o >>> 20) | 0, d = v >>> 0 < Me >>> 0 ? d + 1 | 0 : d, Lr(mi, v, d, 0, 0, v, d, 0, 0), dr = we + 3840 | 0, Lr(dr, a[we + 3856 >> 2], a[we + 3860 >> 2], 0, 0, 15632, 16, 0, 0), o = v, d = d << 1 | o >>> 31, Go = we + 3808 | 0, un = o << 1, $r = d, Lr(Go, un, d, 0, 0, Rr, yo, 0, 0), Ho = we + 3904 | 0, Lr(Ho, Dr, Si, 0, 0, Be, wr, 0, 0), Mo = we + 3968 | 0, Lr(Mo, he, ni, 0, 0, he, ni, 0, 0), $i = we + 3824 | 0, o = mi + 8 | 0, Lr($i, a[o >> 2], a[o + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), qi = we + 4096 | 0, Lr(qi, Rr, yo, 0, 0, Rr, yo, 0, 0), uo = we + 3792 | 0, Lr(uo, un, d, 0, 0, Kn, Io, 0, 0), Oo = we + 3872 | 0, Gr = Dr, Rr = Si, fr = ni, ni = he, Lr(Oo, Dr, Rr, 0, 0, he << 1, fr << 1 | he >>> 31, 0, 0), Me = a[we + 3920 >> 2], v = a[we + 3952 >> 2], o = Me + v | 0, Dr = a[we + 3924 >> 2], d = Dr + a[we + 3956 >> 2] | 0, d = o >>> 0 < v >>> 0 ? d + 1 | 0 : d, v = a[we + 3840 >> 2], Qe = v + o | 0, he = d, d = d + a[we + 3844 >> 2] | 0, v = v >>> 0 > Qe >>> 0 ? d + 1 | 0 : d, wr = (he | 0) == (v | 0) & o >>> 0 > Qe >>> 0 | v >>> 0 < he >>> 0, d = dr + 8 | 0, dr = a[d >> 2], Be = a[d + 4 >> 2], Me = (he | 0) == (Dr | 0) & o >>> 0 < Me >>> 0 | he >>> 0 < Dr >>> 0, d = zi + 8 | 0, he = a[d >> 2], o = In + 8 | 0, Dr = he + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = he >>> 0 > Dr >>> 0 ? d + 1 | 0 : d, o = Me + Dr | 0, d = (o >>> 0 < Dr >>> 0 ? d + 1 | 0 : d) + Be | 0, he = o, o = o + dr | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, he = o, o = o + wr | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, Dr = v, Be = o << 12 | v >>> 20, he = d, Me = d << 12 | o >>> 20, Xn = a[we + 3904 >> 2], o = a[we + 3968 >> 2], Fr = Xn + o | 0, xo = a[we + 3908 >> 2], d = xo + a[we + 3972 >> 2] | 0, d = o >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, o = a[we + 3808 >> 2], wr = o + Fr | 0, v = d, d = d + a[we + 3812 >> 2] | 0, d = o >>> 0 > wr >>> 0 ? d + 1 | 0 : d, o = a[we + 3824 >> 2], dr = o + wr | 0, Si = d, d = d + a[we + 3828 >> 2] | 0, o = o >>> 0 > dr >>> 0 ? d + 1 | 0 : d, d = o + Me | 0, yo = we + 3696 | 0, Vn = yo, Me = Be + dr | 0, Be = Me >>> 0 < dr >>> 0 ? d + 1 | 0 : d, Sn = (o | 0) == (Be | 0) & Me >>> 0 < dr >>> 0 | o >>> 0 > Be >>> 0, In = (o | 0) == (Si | 0) & wr >>> 0 > dr >>> 0 | o >>> 0 < Si >>> 0, o = $i + 8 | 0, zi = a[o >> 2], mi = a[o + 4 >> 2], $i = (v | 0) == (Si | 0) & wr >>> 0 < Fr >>> 0 | v >>> 0 > Si >>> 0, o = Go + 8 | 0, Si = a[o >> 2], wr = a[o + 4 >> 2], dr = (v | 0) == (xo | 0) & Fr >>> 0 < Xn >>> 0 | v >>> 0 < xo >>> 0, d = Mo + 8 | 0, v = a[d >> 2], o = Ho + 8 | 0, Fr = v + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, o = dr + Fr | 0, d = (o >>> 0 < Fr >>> 0 ? d + 1 | 0 : d) + wr | 0, v = o, o = o + Si | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + $i | 0, d = (v >>> 0 > o >>> 0 ? d + 1 | 0 : d) + mi | 0, v = o, o = o + zi | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o + In | 0, d = v >>> 0 < o >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, o = v + he | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Sn | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = Be, dr = o << 12 | v >>> 20, he = d, Be = d << 12 | o >>> 20, mi = a[we + 3792 >> 2], o = a[we + 3872 >> 2], Fr = mi + o | 0, Xn = a[we + 3796 >> 2], d = Xn + a[we + 3876 >> 2] | 0, o = o >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, d = o + Be | 0, dr = dr + Fr | 0, d = dr >>> 0 < Fr >>> 0 ? d + 1 | 0 : d, $i = dr << 4 & -16, Be = d, Si = (d << 4 | dr >>> 28) & 16777215, wr = v, Lr(Vn, $i | v >>> 16 & 15, Si, 0, 0, 977, 1, 0, 0), Vn = we + 4032 | 0, Lr(Vn, Kn, Io, 0, 0, Oi, Ti, 0, 0), Sn = we + 3776 | 0, Lr(Sn, un, $r, 0, 0, ni, fr, 0, 0), In = we + 3888 | 0, Lr(In, Gr, Rr, 0, 0, Gr, Rr, 0, 0), zi = we + 3760 | 0, $i = zi, Si = (o | 0) == (d | 0) & dr >>> 0 < Fr >>> 0 | o >>> 0 > d >>> 0, dr = (o | 0) == (Xn | 0) & Fr >>> 0 < mi >>> 0 | o >>> 0 < Xn >>> 0, d = Oo + 8 | 0, v = a[d >> 2], o = uo + 8 | 0, Fr = v + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, v = dr + Fr | 0, d = v >>> 0 < Fr >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, o = v + he | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Si | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Be = o << 12 | Be >>> 20, v = d, he = d << 12 | o >>> 20, Si = a[we + 3776 >> 2], o = a[we + 3888 >> 2], dr = Si + o | 0, Xn = a[we + 3780 >> 2], d = Xn + a[we + 3892 >> 2] | 0, o = o >>> 0 > dr >>> 0 ? d + 1 | 0 : d, d = o + he | 0, Be = Be + dr | 0, d = Be >>> 0 < dr >>> 0 ? d + 1 | 0 : d, he = d, Lr($i, Be, d & 1048575, 0, 0, 15632, 16, 0, 0), mi = we + 3984 | 0, Lr(mi, ni, fr, 0, 0, Oi, Ti, 0, 0), $i = we + 4048 | 0, Lr($i, Kn, Io, 0, 0, Kn, Io, 0, 0), Fr = we + 3744 | 0, Lr(Fr, Gr, Rr, 0, 0, un, $r, 0, 0), ni = we + 3728 | 0, Rr = ni, fr = (o | 0) == (d | 0) & Be >>> 0 < dr >>> 0 | o >>> 0 > d >>> 0, dr = (o | 0) == (Xn | 0) & dr >>> 0 < Si >>> 0 | o >>> 0 < Xn >>> 0, d = In + 8 | 0, Be = a[d >> 2], o = Sn + 8 | 0, Gr = Be + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = Be >>> 0 > Gr >>> 0 ? d + 1 | 0 : d, Be = dr + Gr | 0, d = Be >>> 0 < Gr >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = v + Be | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + fr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Be = o << 12 | he >>> 20, he = a[we + 3744 >> 2], fr = Be + he | 0, v = d, o = d << 12 | o >>> 20, d = o + a[we + 3748 >> 2] | 0, d = he >>> 0 > fr >>> 0 ? d + 1 | 0 : d, Lr(Rr, fr, d, 0, 0, 15632, 16, 0, 0), Si = we + 3712 | 0, dr = Si, Be = (o | 0) == (d | 0) & Be >>> 0 > fr >>> 0 | o >>> 0 > d >>> 0, o = Fr + 8 | 0, he = a[o >> 2], d = a[o + 4 >> 2], v = v >>> 20 | 0, o = v + he | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Be | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Lr(dr, o, d, 0, 0, 64028672, 65536, 0, 0), v = a[we + 3696 >> 2], o = a[we + 4096 >> 2], fr = v + o | 0, Be = a[we + 3700 >> 2], d = Be + a[we + 4100 >> 2] | 0, Xn = we + 7416 | 0, Sn = Xn + 8 | 0, $r = Sn, he = o >>> 0 > fr >>> 0 ? d + 1 | 0 : d, Be = (Be | 0) == (he | 0) & v >>> 0 > fr >>> 0 | he >>> 0 < Be >>> 0, d = qi + 8 | 0, v = a[d >> 2], o = yo + 8 | 0, dr = v + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 > dr >>> 0 ? d + 1 | 0 : d, o = Be + dr | 0, d = o >>> 0 < dr >>> 0 ? d + 1 | 0 : d, dr = he, Be = o << 12 | he >>> 20, v = d, Gr = d << 12 | o >>> 20, Oi = a[we + 3764 >> 2], d = Oi + a[we + 4036 >> 2] | 0, Fr = a[we + 3760 >> 2], o = a[we + 4032 >> 2], he = Fr + o | 0, Rr = he, Be = he + Be | 0, o = o >>> 0 > he >>> 0 ? d + 1 | 0 : d, d = o + Gr | 0, a[$r >> 2] = Be, he = Be >>> 0 < he >>> 0 ? d + 1 | 0 : d, a[$r + 4 >> 2] = he & 1048575, In = Xn + 16 | 0, $r = In, Gr = (o | 0) == (he | 0) & Be >>> 0 < Rr >>> 0 | o >>> 0 > he >>> 0, Rr = (o | 0) == (Oi | 0) & Rr >>> 0 < Fr >>> 0 | o >>> 0 < Oi >>> 0, d = Vn + 8 | 0, Be = a[d >> 2], o = zi + 8 | 0, Fr = Be + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = Be >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, Be = Rr + Fr | 0, d = Be >>> 0 < Fr >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = v + Be | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Gr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Be = o << 12 | he >>> 20, v = d, he = d << 12 | o >>> 20, un = a[we + 3984 >> 2], o = a[we + 4048 >> 2], Gr = un + o | 0, zi = a[we + 3988 >> 2], d = zi + a[we + 4052 >> 2] | 0, d = o >>> 0 > Gr >>> 0 ? d + 1 | 0 : d, o = a[we + 3728 >> 2], Rr = o + Gr | 0, Fr = d, d = d + a[we + 3732 >> 2] | 0, o = o >>> 0 > Rr >>> 0 ? d + 1 | 0 : d, d = o + he | 0, Be = Be + Rr | 0, d = Be >>> 0 < Rr >>> 0 ? d + 1 | 0 : d, a[$r >> 2] = Be, he = d, a[$r + 4 >> 2] = d & 1048575, Kn = Xn + 24 | 0, Ti = (o | 0) == (d | 0) & Be >>> 0 < Rr >>> 0 | o >>> 0 > d >>> 0, Oi = (o | 0) == (Fr | 0) & Rr >>> 0 < Gr >>> 0 | o >>> 0 < Fr >>> 0, o = ni + 8 | 0, $r = a[o >> 2], ni = a[o + 4 >> 2], Rr = (Fr | 0) == (zi | 0) & Gr >>> 0 < un >>> 0 | Fr >>> 0 < zi >>> 0, d = $i + 8 | 0, Be = a[d >> 2], o = mi + 8 | 0, Gr = Be + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = Be >>> 0 > Gr >>> 0 ? d + 1 | 0 : d, o = Rr + Gr | 0, d = (o >>> 0 < Gr >>> 0 ? d + 1 | 0 : d) + ni | 0, Be = o, o = o + $r | 0, d = Be >>> 0 > o >>> 0 ? d + 1 | 0 : d, Be = o + Oi | 0, d = Be >>> 0 < o >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = v + Be | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Ti | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Rr = o << 12 | he >>> 20, v = d, Be = d << 12 | o >>> 20, Gr = a[we + 3712 >> 2], he = Qe & -2, o = Gr + he | 0, ni = a[we + 3716 >> 2], d = ni + (Dr & 1048575) | 0, Qe = o >>> 0 < he >>> 0 ? d + 1 | 0 : d, d = Qe + Be | 0, Dr = o, he = o + Rr | 0, a[Kn >> 2] = he, o = o >>> 0 > he >>> 0 ? d + 1 | 0 : d, a[Kn + 4 >> 2] = o & 1048575, Fr = Xn + 32 | 0, Be = Me, Rr = wr & 65535, wr = (o | 0) == (Qe | 0) & he >>> 0 < Dr >>> 0 | o >>> 0 < Qe >>> 0, he = (Qe | 0) == (ni | 0) & Dr >>> 0 < Gr >>> 0 | Qe >>> 0 < ni >>> 0, d = Si + 8 | 0, Me = he + a[d >> 2] | 0, d = a[d + 4 >> 2], d = he >>> 0 > Me >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, he = v, v = v + Me | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + wr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, o = v << 12 | o >>> 20, he = o + Be | 0, d = Rr + (d << 12 | v >>> 20) | 0, a[Fr >> 2] = he, a[Fr + 4 >> 2] = o >>> 0 > he >>> 0 ? d + 1 | 0 : d, a[we + 7416 >> 2] = fr, a[we + 7420 >> 2] = dr & 1048575, gn(Xn, Xn, ns), fr = a[Fr + 4 >> 2], d = we + 7376 | 0, o = d + 32 | 0, v = a[Fr >> 2], a[o >> 2] = v, a[o + 4 >> 2] = fr, wr = a[Kn + 4 >> 2], o = d + 24 | 0, dr = a[Kn >> 2], a[o >> 2] = dr, a[o + 4 >> 2] = wr, Rr = a[In + 4 >> 2], o = d + 16 | 0, Be = a[In >> 2], a[o >> 2] = Be, a[o + 4 >> 2] = Rr, Qe = a[Sn + 4 >> 2], o = d + 8 | 0, Me = a[Sn >> 2], a[o >> 2] = Me, a[o + 4 >> 2] = Qe, Dr = a[we + 7420 >> 2], he = a[we + 7416 >> 2], a[we + 7376 >> 2] = he, a[we + 7380 >> 2] = Dr, o = 11; Fr = he, d = Dr << 1 | he >>> 31, In = we + 3664 | 0, Si = he << 1, Kn = d, Lr(In, dr, wr, 0, 0, Si, d, 0, 0), mi = we + 3584 | 0, he = Me << 1, Gr = Qe, un = Me, Me = Qe << 1 | Me >>> 31, Lr(mi, Be, Rr, 0, 0, he, Me, 0, 0), $r = we + 3520 | 0, Lr($r, v, fr, 0, 0, v, fr, 0, 0), ni = we + 3504 | 0, Lr(ni, a[we + 3520 >> 2], a[we + 3524 >> 2], 0, 0, 15632, 16, 0, 0), d = fr << 1 | v >>> 31, Io = we + 3472 | 0, $i = v << 1, Ti = d, Lr(Io, $i, d, 0, 0, Fr, Dr, 0, 0), xo = we + 3632 | 0, Lr(xo, dr, wr, 0, 0, he, Me, 0, 0), Go = we + 3568 | 0, Lr(Go, Be, Rr, 0, 0, Be, Rr, 0, 0), zi = we + 3488 | 0, d = $r + 8 | 0, Lr(zi, a[d >> 2], a[d + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Ho = we + 3680 | 0, Lr(Ho, Fr, Dr, 0, 0, Fr, Dr, 0, 0), Mo = we + 3456 | 0, Lr(Mo, $i, Ti, 0, 0, un, Qe, 0, 0), qi = we + 3536 | 0, Dr = dr, Oi = Be, Lr(qi, dr, wr, 0, 0, Be << 1, Rr << 1 | Be >>> 31, 0, 0), Fr = a[we + 3668 >> 2], d = Fr + a[we + 3588 >> 2] | 0, Be = a[we + 3664 >> 2], he = a[we + 3584 >> 2], v = Be + he | 0, Me = a[we + 3504 >> 2], $r = v + Me | 0, he = v >>> 0 < he >>> 0 ? d + 1 | 0 : d, d = he + a[we + 3508 >> 2] | 0, Me = Me >>> 0 > $r >>> 0 ? d + 1 | 0 : d, Qe = (he | 0) == (Me | 0) & v >>> 0 > $r >>> 0 | he >>> 0 > Me >>> 0, d = ni + 8 | 0, fr = a[d >> 2], dr = a[d + 4 >> 2], Be = (he | 0) == (Fr | 0) & v >>> 0 < Be >>> 0 | he >>> 0 < Fr >>> 0, he = mi + 8 | 0, v = a[he >> 2], d = In + 8 | 0, Fr = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[he + 4 >> 2] | 0, d = v >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, v = Be + Fr | 0, d = (v >>> 0 < Fr >>> 0 ? d + 1 | 0 : d) + dr | 0, he = v, v = v + fr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + Qe | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, Qe = Me, fr = v << 12 | Me >>> 20, he = d, Be = d << 12 | v >>> 20, uo = a[we + 3632 >> 2], v = a[we + 3568 >> 2], Fr = uo + v | 0, ns = a[we + 3636 >> 2], d = ns + a[we + 3572 >> 2] | 0, d = v >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, v = a[we + 3472 >> 2], dr = v + Fr | 0, mi = d, d = d + a[we + 3476 >> 2] | 0, d = v >>> 0 > dr >>> 0 ? d + 1 | 0 : d, v = a[we + 3488 >> 2], Me = v + dr | 0, ni = d, d = d + a[we + 3492 >> 2] | 0, v = v >>> 0 > Me >>> 0 ? d + 1 | 0 : d, d = v + Be | 0, Oo = we + 3440 | 0, fr = Me + fr | 0, Be = fr >>> 0 < Me >>> 0 ? d + 1 | 0 : d, Xn = (v | 0) == (Be | 0) & Me >>> 0 > fr >>> 0 | v >>> 0 > Be >>> 0, yo = (v | 0) == (ni | 0) & Me >>> 0 < dr >>> 0 | v >>> 0 < ni >>> 0, d = zi + 8 | 0, Vn = a[d >> 2], Sn = a[d + 4 >> 2], In = (ni | 0) == (mi | 0) & dr >>> 0 < Fr >>> 0 | ni >>> 0 < mi >>> 0, d = Io + 8 | 0, zi = a[d >> 2], ni = a[d + 4 >> 2], dr = (mi | 0) == (ns | 0) & Fr >>> 0 < uo >>> 0 | mi >>> 0 < ns >>> 0, Me = Go + 8 | 0, v = a[Me >> 2], d = xo + 8 | 0, Fr = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[Me + 4 >> 2] | 0, d = v >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, v = dr + Fr | 0, d = (v >>> 0 < Fr >>> 0 ? d + 1 | 0 : d) + ni | 0, Me = v, v = v + zi | 0, d = Me >>> 0 > v >>> 0 ? d + 1 | 0 : d, Me = v, v = v + In | 0, d = (Me >>> 0 > v >>> 0 ? d + 1 | 0 : d) + Sn | 0, Me = v, v = v + Vn | 0, d = Me >>> 0 > v >>> 0 ? d + 1 | 0 : d, Me = v + yo | 0, d = Me >>> 0 < v >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, v = he + Me | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + Xn | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = Be, dr = v << 12 | he >>> 20, Me = d, ni = d << 12 | v >>> 20, uo = a[we + 3460 >> 2], d = uo + a[we + 3540 >> 2] | 0, In = a[we + 3456 >> 2], v = a[we + 3536 >> 2], Be = In + v | 0, Fr = Be, dr = Be + dr | 0, v = v >>> 0 > Be >>> 0 ? d + 1 | 0 : d, d = v + ni | 0, zi = dr << 4 & -16, Be = dr >>> 0 < Be >>> 0 ? d + 1 | 0 : d, mi = (Be << 4 | dr >>> 28) & 16777215, ni = he, Lr(Oo, zi | he >>> 16 & 15, mi, 0, 0, 977, 1, 0, 0), Xn = we + 3616 | 0, Lr(Xn, un, Gr, 0, 0, Si, Kn, 0, 0), yo = we + 3424 | 0, Lr(yo, $i, Ti, 0, 0, Oi, Rr, 0, 0), Vn = we + 3648 | 0, Lr(Vn, Dr, wr, 0, 0, Dr, wr, 0, 0), Sn = we + 3408 | 0, zi = Sn, mi = (v | 0) == (Be | 0) & dr >>> 0 < Fr >>> 0 | v >>> 0 > Be >>> 0, dr = (v | 0) == (uo | 0) & Fr >>> 0 < In >>> 0 | v >>> 0 < uo >>> 0, he = qi + 8 | 0, v = a[he >> 2], d = Mo + 8 | 0, Fr = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[he + 4 >> 2] | 0, d = v >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, he = dr + Fr | 0, d = he >>> 0 < Fr >>> 0 ? d + 1 | 0 : d, Me = Me >>> 20 | 0, v = he + Me | 0, d = Me >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + mi | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, Be = v << 12 | Be >>> 20, he = d, mi = d << 12 | v >>> 20, uo = a[we + 3428 >> 2], d = uo + a[we + 3652 >> 2] | 0, Fr = a[we + 3424 >> 2], v = a[we + 3648 >> 2], Me = Fr + v | 0, dr = Me, Be = Me + Be | 0, v = v >>> 0 > Me >>> 0 ? d + 1 | 0 : d, d = v + mi | 0, Me = Be >>> 0 < Me >>> 0 ? d + 1 | 0 : d, Lr(zi, Be, Me & 1048575, 0, 0, 15632, 16, 0, 0), In = we + 3552 | 0, Lr(In, Oi, Rr, 0, 0, Si, Kn, 0, 0), zi = we + 3600 | 0, Lr(zi, un, Gr, 0, 0, un, Gr, 0, 0), Rr = we + 3392 | 0, Lr(Rr, $i, Ti, 0, 0, Dr, wr, 0, 0), Ti = we + 3376 | 0, Dr = Ti, wr = (v | 0) == (Me | 0) & Be >>> 0 < dr >>> 0 | v >>> 0 > Me >>> 0, dr = (v | 0) == (uo | 0) & dr >>> 0 < Fr >>> 0 | v >>> 0 < uo >>> 0, Be = Vn + 8 | 0, v = a[Be >> 2], d = yo + 8 | 0, Gr = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[Be + 4 >> 2] | 0, d = v >>> 0 > Gr >>> 0 ? d + 1 | 0 : d, Be = dr + Gr | 0, d = Be >>> 0 < Gr >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, v = he + Be | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + wr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, Be = v << 12 | Me >>> 20, Me = a[we + 3392 >> 2], wr = Be + Me | 0, he = d, v = d << 12 | v >>> 20, d = v + a[we + 3396 >> 2] | 0, d = Me >>> 0 > wr >>> 0 ? d + 1 | 0 : d, Lr(Dr, wr, d, 0, 0, 15632, 16, 0, 0), mi = we + 3360 | 0, dr = mi, Be = (d | 0) == (v | 0) & Be >>> 0 > wr >>> 0 | d >>> 0 < v >>> 0, d = Rr + 8 | 0, Me = a[d >> 2], d = a[d + 4 >> 2], he = he >>> 20 | 0, v = he + Me | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + Be | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, Lr(dr, v, d, 0, 0, 64028672, 65536, 0, 0), he = a[we + 3440 >> 2], v = a[we + 3680 >> 2], Dr = he + v | 0, Be = a[we + 3444 >> 2], d = Be + a[we + 3684 >> 2] | 0, Me = v >>> 0 > Dr >>> 0 ? d + 1 | 0 : d, Be = (Be | 0) == (Me | 0) & he >>> 0 > Dr >>> 0 | Be >>> 0 > Me >>> 0, he = Ho + 8 | 0, v = a[he >> 2], d = Oo + 8 | 0, dr = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[he + 4 >> 2] | 0, d = v >>> 0 > dr >>> 0 ? d + 1 | 0 : d, v = Be + dr | 0, d = v >>> 0 < dr >>> 0 ? d + 1 | 0 : d, Fr = Me, Be = v << 12 | Me >>> 20, he = d, Me = d << 12 | v >>> 20, wr = a[we + 3408 >> 2], v = a[we + 3616 >> 2], dr = wr + v | 0, Gr = a[we + 3412 >> 2], d = Gr + a[we + 3620 >> 2] | 0, v = v >>> 0 > dr >>> 0 ? d + 1 | 0 : d, d = v + Me | 0, Me = Be + dr | 0, Be = Me >>> 0 < dr >>> 0 ? d + 1 | 0 : d, Rr = (v | 0) == (Be | 0) & Me >>> 0 < dr >>> 0 | v >>> 0 > Be >>> 0, wr = (v | 0) == (Gr | 0) & wr >>> 0 > dr >>> 0 | v >>> 0 < Gr >>> 0, dr = Xn + 8 | 0, v = a[dr >> 2], d = Sn + 8 | 0, Gr = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[dr + 4 >> 2] | 0, d = v >>> 0 > Gr >>> 0 ? d + 1 | 0 : d, dr = wr + Gr | 0, d = dr >>> 0 < Gr >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, v = he + dr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + Rr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, Gr = Be, dr = v << 12 | Be >>> 20, he = d, Be = d << 12 | v >>> 20, $i = a[we + 3552 >> 2], v = a[we + 3600 >> 2], Rr = $i + v | 0, Sn = a[we + 3556 >> 2], d = Sn + a[we + 3604 >> 2] | 0, d = v >>> 0 > Rr >>> 0 ? d + 1 | 0 : d, v = a[we + 3376 >> 2], wr = v + Rr | 0, Oi = d, d = d + a[we + 3380 >> 2] | 0, v = v >>> 0 > wr >>> 0 ? d + 1 | 0 : d, d = v + Be | 0, Be = wr + dr | 0, dr = Be >>> 0 < wr >>> 0 ? d + 1 | 0 : d, Kn = (v | 0) == (dr | 0) & Be >>> 0 < wr >>> 0 | v >>> 0 > dr >>> 0, Si = (v | 0) == (Oi | 0) & wr >>> 0 < Rr >>> 0 | v >>> 0 < Oi >>> 0, d = Ti + 8 | 0, un = a[d >> 2], Ti = a[d + 4 >> 2], Rr = (Oi | 0) == (Sn | 0) & Rr >>> 0 < $i >>> 0 | Oi >>> 0 < Sn >>> 0, wr = zi + 8 | 0, v = a[wr >> 2], d = In + 8 | 0, Oi = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[wr + 4 >> 2] | 0, d = v >>> 0 > Oi >>> 0 ? d + 1 | 0 : d, v = Rr + Oi | 0, d = (v >>> 0 < Oi >>> 0 ? d + 1 | 0 : d) + Ti | 0, Rr = v, v = v + un | 0, d = Rr >>> 0 > v >>> 0 ? d + 1 | 0 : d, wr = v + Si | 0, d = wr >>> 0 < v >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, v = he + wr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + Kn | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, Rr = dr, Oi = v << 12 | dr >>> 20, he = d, wr = d << 12 | v >>> 20, un = a[we + 3360 >> 2], dr = un + ($r & -2) | 0, Ti = a[we + 3364 >> 2], d = Ti + (Qe & 1048575) | 0, d = dr >>> 0 < un >>> 0 ? d + 1 | 0 : d, $r = dr, dr = dr + Oi | 0, v = d, d = d + wr | 0, Qe = fr, Oi = ni & 65535, wr = dr >>> 0 < $r >>> 0 ? d + 1 | 0 : d, ni = (v | 0) == (wr | 0) & dr >>> 0 < $r >>> 0 | v >>> 0 > wr >>> 0, v = (v | 0) == (Ti | 0) & $r >>> 0 < un >>> 0 | v >>> 0 < Ti >>> 0, d = mi + 8 | 0, fr = v + a[d >> 2] | 0, d = a[d + 4 >> 2], d = v >>> 0 > fr >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, v = he + fr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + ni | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, fr = v << 12 | wr >>> 20, he = fr + Qe | 0, d = Oi + (d << 12 | v >>> 20) | 0, v = he, fr = v >>> 0 < fr >>> 0 ? d + 1 | 0 : d, wr = wr & 1048575, Rr = Rr & 1048575, Qe = Gr & 1048575, he = Dr, Dr = Fr & 1048575, o = o - 1 | 0, !!o; )
      ;
    for (o = we + 7376 | 0, $r = o + 32 | 0, a[$r >> 2] = v, a[$r + 4 >> 2] = fr, ni = o + 24 | 0, a[ni >> 2] = dr, a[ni + 4 >> 2] = wr, Fr = o + 16 | 0, a[Fr >> 2] = Be, a[Fr + 4 >> 2] = Rr, Gr = o + 8 | 0, a[Gr >> 2] = Me, a[Gr + 4 >> 2] = Qe, a[we + 7376 >> 2] = he, a[we + 7380 >> 2] = Dr, gn(o, o, we + 7416 | 0), fr = a[$r + 4 >> 2], d = we + 7336 | 0, o = d + 32 | 0, v = a[$r >> 2], a[o >> 2] = v, a[o + 4 >> 2] = fr, wr = a[ni + 4 >> 2], o = d + 24 | 0, dr = a[ni >> 2], a[o >> 2] = dr, a[o + 4 >> 2] = wr, Rr = a[Fr + 4 >> 2], o = d + 16 | 0, Be = a[Fr >> 2], a[o >> 2] = Be, a[o + 4 >> 2] = Rr, Qe = a[Gr + 4 >> 2], o = d + 8 | 0, Me = a[Gr >> 2], a[o >> 2] = Me, a[o + 4 >> 2] = Qe, Dr = a[we + 7380 >> 2], he = a[we + 7376 >> 2], a[we + 7336 >> 2] = he, a[we + 7340 >> 2] = Dr, o = 22; Fr = he, d = Dr << 1 | he >>> 31, In = we + 3328 | 0, Si = he << 1, Kn = d, Lr(In, dr, wr, 0, 0, Si, d, 0, 0), mi = we + 3248 | 0, he = Me << 1, Gr = Qe, un = Me, Me = Qe << 1 | Me >>> 31, Lr(mi, Be, Rr, 0, 0, he, Me, 0, 0), $r = we + 3184 | 0, Lr($r, v, fr, 0, 0, v, fr, 0, 0), ni = we + 3168 | 0, Lr(ni, a[we + 3184 >> 2], a[we + 3188 >> 2], 0, 0, 15632, 16, 0, 0), d = fr << 1 | v >>> 31, Io = we + 3136 | 0, $i = v << 1, Ti = d, Lr(Io, $i, d, 0, 0, Fr, Dr, 0, 0), xo = we + 3296 | 0, Lr(xo, dr, wr, 0, 0, he, Me, 0, 0), Go = we + 3232 | 0, Lr(Go, Be, Rr, 0, 0, Be, Rr, 0, 0), zi = we + 3152 | 0, d = $r + 8 | 0, Lr(zi, a[d >> 2], a[d + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Ho = we + 3344 | 0, Lr(Ho, Fr, Dr, 0, 0, Fr, Dr, 0, 0), Mo = we + 3120 | 0, Lr(Mo, $i, Ti, 0, 0, un, Qe, 0, 0), qi = we + 3200 | 0, Dr = dr, Oi = Be, Lr(qi, dr, wr, 0, 0, Be << 1, Rr << 1 | Be >>> 31, 0, 0), Fr = a[we + 3332 >> 2], d = Fr + a[we + 3252 >> 2] | 0, Be = a[we + 3328 >> 2], he = a[we + 3248 >> 2], v = Be + he | 0, Me = a[we + 3168 >> 2], $r = v + Me | 0, he = v >>> 0 < he >>> 0 ? d + 1 | 0 : d, d = he + a[we + 3172 >> 2] | 0, Me = Me >>> 0 > $r >>> 0 ? d + 1 | 0 : d, Qe = (he | 0) == (Me | 0) & v >>> 0 > $r >>> 0 | he >>> 0 > Me >>> 0, d = ni + 8 | 0, fr = a[d >> 2], dr = a[d + 4 >> 2], Be = (he | 0) == (Fr | 0) & v >>> 0 < Be >>> 0 | he >>> 0 < Fr >>> 0, he = mi + 8 | 0, v = a[he >> 2], d = In + 8 | 0, Fr = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[he + 4 >> 2] | 0, d = v >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, v = Be + Fr | 0, d = (v >>> 0 < Fr >>> 0 ? d + 1 | 0 : d) + dr | 0, he = v, v = v + fr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + Qe | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, Qe = Me, dr = v << 12 | Me >>> 20, he = d, Be = d << 12 | v >>> 20, uo = a[we + 3296 >> 2], v = a[we + 3232 >> 2], Fr = uo + v | 0, ns = a[we + 3300 >> 2], d = ns + a[we + 3236 >> 2] | 0, d = v >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, v = a[we + 3136 >> 2], fr = v + Fr | 0, mi = d, d = d + a[we + 3140 >> 2] | 0, d = v >>> 0 > fr >>> 0 ? d + 1 | 0 : d, v = a[we + 3152 >> 2], Me = v + fr | 0, ni = d, d = d + a[we + 3156 >> 2] | 0, v = v >>> 0 > Me >>> 0 ? d + 1 | 0 : d, d = v + Be | 0, Oo = we + 3104 | 0, dr = Me + dr | 0, Be = dr >>> 0 < Me >>> 0 ? d + 1 | 0 : d, Xn = (v | 0) == (Be | 0) & Me >>> 0 > dr >>> 0 | v >>> 0 > Be >>> 0, yo = (v | 0) == (ni | 0) & Me >>> 0 < fr >>> 0 | v >>> 0 < ni >>> 0, d = zi + 8 | 0, Vn = a[d >> 2], Sn = a[d + 4 >> 2], In = (ni | 0) == (mi | 0) & fr >>> 0 < Fr >>> 0 | ni >>> 0 < mi >>> 0, d = Io + 8 | 0, zi = a[d >> 2], ni = a[d + 4 >> 2], fr = (mi | 0) == (ns | 0) & Fr >>> 0 < uo >>> 0 | mi >>> 0 < ns >>> 0, Me = Go + 8 | 0, v = a[Me >> 2], d = xo + 8 | 0, Fr = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[Me + 4 >> 2] | 0, d = v >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, v = fr + Fr | 0, d = (v >>> 0 < Fr >>> 0 ? d + 1 | 0 : d) + ni | 0, Me = v, v = v + zi | 0, d = Me >>> 0 > v >>> 0 ? d + 1 | 0 : d, Me = v, v = v + In | 0, d = (Me >>> 0 > v >>> 0 ? d + 1 | 0 : d) + Sn | 0, Me = v, v = v + Vn | 0, d = Me >>> 0 > v >>> 0 ? d + 1 | 0 : d, Me = v + yo | 0, d = Me >>> 0 < v >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, v = he + Me | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + Xn | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = Be, fr = v << 12 | he >>> 20, Me = d, ni = d << 12 | v >>> 20, uo = a[we + 3124 >> 2], d = uo + a[we + 3204 >> 2] | 0, In = a[we + 3120 >> 2], v = a[we + 3200 >> 2], Be = In + v | 0, Fr = Be, fr = Be + fr | 0, v = v >>> 0 > Be >>> 0 ? d + 1 | 0 : d, d = v + ni | 0, zi = fr << 4 & -16, Be = fr >>> 0 < Be >>> 0 ? d + 1 | 0 : d, mi = (Be << 4 | fr >>> 28) & 16777215, ni = he, Lr(Oo, zi | he >>> 16 & 15, mi, 0, 0, 977, 1, 0, 0), Xn = we + 3280 | 0, Lr(Xn, un, Gr, 0, 0, Si, Kn, 0, 0), yo = we + 3088 | 0, Lr(yo, $i, Ti, 0, 0, Oi, Rr, 0, 0), Vn = we + 3312 | 0, Lr(Vn, Dr, wr, 0, 0, Dr, wr, 0, 0), Sn = we + 3072 | 0, zi = Sn, mi = (v | 0) == (Be | 0) & fr >>> 0 < Fr >>> 0 | v >>> 0 > Be >>> 0, fr = (v | 0) == (uo | 0) & Fr >>> 0 < In >>> 0 | v >>> 0 < uo >>> 0, he = qi + 8 | 0, v = a[he >> 2], d = Mo + 8 | 0, Fr = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[he + 4 >> 2] | 0, d = v >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, he = fr + Fr | 0, d = he >>> 0 < Fr >>> 0 ? d + 1 | 0 : d, Me = Me >>> 20 | 0, v = he + Me | 0, d = Me >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + mi | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, Be = v << 12 | Be >>> 20, he = d, mi = d << 12 | v >>> 20, uo = a[we + 3092 >> 2], d = uo + a[we + 3316 >> 2] | 0, Fr = a[we + 3088 >> 2], v = a[we + 3312 >> 2], Me = Fr + v | 0, fr = Me, Be = Me + Be | 0, v = v >>> 0 > Me >>> 0 ? d + 1 | 0 : d, d = v + mi | 0, Me = Be >>> 0 < Me >>> 0 ? d + 1 | 0 : d, Lr(zi, Be, Me & 1048575, 0, 0, 15632, 16, 0, 0), In = we + 3216 | 0, Lr(In, Oi, Rr, 0, 0, Si, Kn, 0, 0), zi = we + 3264 | 0, Lr(zi, un, Gr, 0, 0, un, Gr, 0, 0), Rr = we + 3056 | 0, Lr(Rr, $i, Ti, 0, 0, Dr, wr, 0, 0), Ti = we + 3040 | 0, Dr = Ti, wr = (v | 0) == (Me | 0) & Be >>> 0 < fr >>> 0 | v >>> 0 > Me >>> 0, fr = (v | 0) == (uo | 0) & fr >>> 0 < Fr >>> 0 | v >>> 0 < uo >>> 0, Be = Vn + 8 | 0, v = a[Be >> 2], d = yo + 8 | 0, Gr = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[Be + 4 >> 2] | 0, d = v >>> 0 > Gr >>> 0 ? d + 1 | 0 : d, Be = fr + Gr | 0, d = Be >>> 0 < Gr >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, v = he + Be | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + wr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, Be = v << 12 | Me >>> 20, Me = a[we + 3056 >> 2], wr = Be + Me | 0, he = d, v = d << 12 | v >>> 20, d = v + a[we + 3060 >> 2] | 0, d = Me >>> 0 > wr >>> 0 ? d + 1 | 0 : d, Lr(Dr, wr, d, 0, 0, 15632, 16, 0, 0), mi = we + 3024 | 0, fr = mi, Be = (d | 0) == (v | 0) & Be >>> 0 > wr >>> 0 | d >>> 0 < v >>> 0, d = Rr + 8 | 0, Me = a[d >> 2], d = a[d + 4 >> 2], he = he >>> 20 | 0, v = he + Me | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + Be | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, Lr(fr, v, d, 0, 0, 64028672, 65536, 0, 0), he = a[we + 3104 >> 2], v = a[we + 3344 >> 2], Dr = he + v | 0, Be = a[we + 3108 >> 2], d = Be + a[we + 3348 >> 2] | 0, Me = v >>> 0 > Dr >>> 0 ? d + 1 | 0 : d, Be = (Be | 0) == (Me | 0) & he >>> 0 > Dr >>> 0 | Be >>> 0 > Me >>> 0, he = Ho + 8 | 0, v = a[he >> 2], d = Oo + 8 | 0, fr = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[he + 4 >> 2] | 0, d = v >>> 0 > fr >>> 0 ? d + 1 | 0 : d, v = Be + fr | 0, d = v >>> 0 < fr >>> 0 ? d + 1 | 0 : d, Fr = Me, fr = v << 12 | Me >>> 20, he = d, Be = d << 12 | v >>> 20, wr = a[we + 3072 >> 2], v = a[we + 3280 >> 2], Me = wr + v | 0, Gr = a[we + 3076 >> 2], d = Gr + a[we + 3284 >> 2] | 0, d = v >>> 0 > Me >>> 0 ? d + 1 | 0 : d, v = fr, fr = Me, Me = v + Me | 0, v = d, d = d + Be | 0, Be = Me >>> 0 < fr >>> 0 ? d + 1 | 0 : d, Rr = (v | 0) == (Be | 0) & Me >>> 0 < fr >>> 0 | v >>> 0 > Be >>> 0, wr = (v | 0) == (Gr | 0) & fr >>> 0 < wr >>> 0 | v >>> 0 < Gr >>> 0, fr = Xn + 8 | 0, v = a[fr >> 2], d = Sn + 8 | 0, Gr = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[fr + 4 >> 2] | 0, d = v >>> 0 > Gr >>> 0 ? d + 1 | 0 : d, fr = wr + Gr | 0, d = fr >>> 0 < Gr >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, v = he + fr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + Rr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, Gr = Be, fr = v << 12 | Be >>> 20, he = d, Be = d << 12 | v >>> 20, $i = a[we + 3216 >> 2], v = a[we + 3264 >> 2], Rr = $i + v | 0, Sn = a[we + 3220 >> 2], d = Sn + a[we + 3268 >> 2] | 0, d = v >>> 0 > Rr >>> 0 ? d + 1 | 0 : d, v = a[we + 3040 >> 2], wr = v + Rr | 0, Oi = d, d = d + a[we + 3044 >> 2] | 0, v = v >>> 0 > wr >>> 0 ? d + 1 | 0 : d, d = v + Be | 0, Be = fr + wr | 0, fr = Be >>> 0 < wr >>> 0 ? d + 1 | 0 : d, Kn = (v | 0) == (fr | 0) & Be >>> 0 < wr >>> 0 | v >>> 0 > fr >>> 0, Si = (v | 0) == (Oi | 0) & wr >>> 0 < Rr >>> 0 | v >>> 0 < Oi >>> 0, d = Ti + 8 | 0, un = a[d >> 2], Ti = a[d + 4 >> 2], Rr = (Oi | 0) == (Sn | 0) & Rr >>> 0 < $i >>> 0 | Oi >>> 0 < Sn >>> 0, wr = zi + 8 | 0, v = a[wr >> 2], d = In + 8 | 0, Oi = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[wr + 4 >> 2] | 0, d = v >>> 0 > Oi >>> 0 ? d + 1 | 0 : d, v = Rr + Oi | 0, d = (v >>> 0 < Oi >>> 0 ? d + 1 | 0 : d) + Ti | 0, Rr = v, v = v + un | 0, d = Rr >>> 0 > v >>> 0 ? d + 1 | 0 : d, wr = v + Si | 0, d = wr >>> 0 < v >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, v = he + wr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + Kn | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, Rr = fr, wr = v << 12 | fr >>> 20, he = d, fr = d << 12 | v >>> 20, un = a[we + 3024 >> 2], $r = un + ($r & -2) | 0, Ti = a[we + 3028 >> 2], d = Ti + (Qe & 1048575) | 0, v = $r >>> 0 < un >>> 0 ? d + 1 | 0 : d, d = v + fr | 0, Qe = dr, Oi = ni & 65535, wr = wr + $r | 0, fr = wr >>> 0 < $r >>> 0 ? d + 1 | 0 : d, dr = wr, ni = (v | 0) == (fr | 0) & wr >>> 0 < $r >>> 0 | v >>> 0 > fr >>> 0, v = (v | 0) == (Ti | 0) & $r >>> 0 < un >>> 0 | v >>> 0 < Ti >>> 0, d = mi + 8 | 0, wr = v + a[d >> 2] | 0, d = a[d + 4 >> 2], d = v >>> 0 > wr >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, v = he + wr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + ni | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = fr, wr = v << 12 | he >>> 20, fr = wr + Qe | 0, d = Oi + (d << 12 | v >>> 20) | 0, v = fr, fr = v >>> 0 < wr >>> 0 ? d + 1 | 0 : d, wr = he & 1048575, Rr = Rr & 1048575, Qe = Gr & 1048575, he = Dr, Dr = Fr & 1048575, o = o - 1 | 0, !!o; )
      ;
    for (o = we + 7336 | 0, $r = o + 32 | 0, a[$r >> 2] = v, a[$r + 4 >> 2] = fr, ni = o + 24 | 0, a[ni >> 2] = dr, a[ni + 4 >> 2] = wr, Fr = o + 16 | 0, a[Fr >> 2] = Be, a[Fr + 4 >> 2] = Rr, Gr = o + 8 | 0, a[Gr >> 2] = Me, a[Gr + 4 >> 2] = Qe, a[we + 7336 >> 2] = he, a[we + 7340 >> 2] = Dr, gn(o, o, we + 7376 | 0), fr = a[$r + 4 >> 2], d = we + 7296 | 0, o = d + 32 | 0, v = a[$r >> 2], a[o >> 2] = v, a[o + 4 >> 2] = fr, wr = a[ni + 4 >> 2], o = d + 24 | 0, dr = a[ni >> 2], a[o >> 2] = dr, a[o + 4 >> 2] = wr, Rr = a[Fr + 4 >> 2], o = d + 16 | 0, Be = a[Fr >> 2], a[o >> 2] = Be, a[o + 4 >> 2] = Rr, Qe = a[Gr + 4 >> 2], o = d + 8 | 0, Me = a[Gr >> 2], a[o >> 2] = Me, a[o + 4 >> 2] = Qe, Dr = a[we + 7340 >> 2], he = a[we + 7336 >> 2], a[we + 7296 >> 2] = he, a[we + 7300 >> 2] = Dr, o = 44; Fr = he, d = Dr << 1 | he >>> 31, In = we + 2992 | 0, Si = he << 1, Kn = d, Lr(In, dr, wr, 0, 0, Si, d, 0, 0), mi = we + 2912 | 0, he = Me << 1, Gr = Qe, un = Me, Me = Qe << 1 | Me >>> 31, Lr(mi, Be, Rr, 0, 0, he, Me, 0, 0), $r = we + 2848 | 0, Lr($r, v, fr, 0, 0, v, fr, 0, 0), ni = we + 2832 | 0, Lr(ni, a[we + 2848 >> 2], a[we + 2852 >> 2], 0, 0, 15632, 16, 0, 0), d = fr << 1 | v >>> 31, Io = we + 2800 | 0, $i = v << 1, Ti = d, Lr(Io, $i, d, 0, 0, Fr, Dr, 0, 0), xo = we + 2960 | 0, Lr(xo, dr, wr, 0, 0, he, Me, 0, 0), Go = we + 2896 | 0, Lr(Go, Be, Rr, 0, 0, Be, Rr, 0, 0), zi = we + 2816 | 0, d = $r + 8 | 0, Lr(zi, a[d >> 2], a[d + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Ho = we + 3008 | 0, Lr(Ho, Fr, Dr, 0, 0, Fr, Dr, 0, 0), Mo = we + 2784 | 0, Lr(Mo, $i, Ti, 0, 0, un, Qe, 0, 0), qi = we + 2864 | 0, Dr = dr, Oi = Be, Lr(qi, dr, wr, 0, 0, Be << 1, Rr << 1 | Be >>> 31, 0, 0), Fr = a[we + 2996 >> 2], d = Fr + a[we + 2916 >> 2] | 0, Be = a[we + 2992 >> 2], he = a[we + 2912 >> 2], v = Be + he | 0, Me = a[we + 2832 >> 2], $r = v + Me | 0, he = v >>> 0 < he >>> 0 ? d + 1 | 0 : d, d = he + a[we + 2836 >> 2] | 0, Me = Me >>> 0 > $r >>> 0 ? d + 1 | 0 : d, Qe = (he | 0) == (Me | 0) & v >>> 0 > $r >>> 0 | he >>> 0 > Me >>> 0, d = ni + 8 | 0, fr = a[d >> 2], dr = a[d + 4 >> 2], Be = (he | 0) == (Fr | 0) & v >>> 0 < Be >>> 0 | he >>> 0 < Fr >>> 0, he = mi + 8 | 0, v = a[he >> 2], d = In + 8 | 0, Fr = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[he + 4 >> 2] | 0, d = v >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, v = Be + Fr | 0, d = (v >>> 0 < Fr >>> 0 ? d + 1 | 0 : d) + dr | 0, he = v, v = v + fr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + Qe | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, Qe = Me, fr = v << 12 | Me >>> 20, he = d, Be = d << 12 | v >>> 20, uo = a[we + 2960 >> 2], v = a[we + 2896 >> 2], Fr = uo + v | 0, ns = a[we + 2964 >> 2], d = ns + a[we + 2900 >> 2] | 0, d = v >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, v = a[we + 2800 >> 2], dr = v + Fr | 0, mi = d, d = d + a[we + 2804 >> 2] | 0, d = v >>> 0 > dr >>> 0 ? d + 1 | 0 : d, v = a[we + 2816 >> 2], Me = v + dr | 0, ni = d, d = d + a[we + 2820 >> 2] | 0, v = v >>> 0 > Me >>> 0 ? d + 1 | 0 : d, d = v + Be | 0, Oo = we + 2768 | 0, fr = Me + fr | 0, Be = fr >>> 0 < Me >>> 0 ? d + 1 | 0 : d, Xn = (v | 0) == (Be | 0) & Me >>> 0 > fr >>> 0 | v >>> 0 > Be >>> 0, yo = (v | 0) == (ni | 0) & Me >>> 0 < dr >>> 0 | v >>> 0 < ni >>> 0, d = zi + 8 | 0, Vn = a[d >> 2], Sn = a[d + 4 >> 2], In = (ni | 0) == (mi | 0) & dr >>> 0 < Fr >>> 0 | ni >>> 0 < mi >>> 0, d = Io + 8 | 0, zi = a[d >> 2], ni = a[d + 4 >> 2], dr = (mi | 0) == (ns | 0) & Fr >>> 0 < uo >>> 0 | mi >>> 0 < ns >>> 0, Me = Go + 8 | 0, v = a[Me >> 2], d = xo + 8 | 0, Fr = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[Me + 4 >> 2] | 0, d = v >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, v = dr + Fr | 0, d = (v >>> 0 < Fr >>> 0 ? d + 1 | 0 : d) + ni | 0, Me = v, v = v + zi | 0, d = Me >>> 0 > v >>> 0 ? d + 1 | 0 : d, Me = v, v = v + In | 0, d = (Me >>> 0 > v >>> 0 ? d + 1 | 0 : d) + Sn | 0, Me = v, v = v + Vn | 0, d = Me >>> 0 > v >>> 0 ? d + 1 | 0 : d, Me = v + yo | 0, d = Me >>> 0 < v >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, v = he + Me | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + Xn | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = Be, dr = v << 12 | he >>> 20, Me = d, ni = d << 12 | v >>> 20, uo = a[we + 2788 >> 2], d = uo + a[we + 2868 >> 2] | 0, In = a[we + 2784 >> 2], v = a[we + 2864 >> 2], Be = In + v | 0, Fr = Be, dr = Be + dr | 0, v = v >>> 0 > Be >>> 0 ? d + 1 | 0 : d, d = v + ni | 0, zi = dr << 4 & -16, Be = dr >>> 0 < Be >>> 0 ? d + 1 | 0 : d, mi = (Be << 4 | dr >>> 28) & 16777215, ni = he, Lr(Oo, zi | he >>> 16 & 15, mi, 0, 0, 977, 1, 0, 0), Xn = we + 2944 | 0, Lr(Xn, un, Gr, 0, 0, Si, Kn, 0, 0), yo = we + 2752 | 0, Lr(yo, $i, Ti, 0, 0, Oi, Rr, 0, 0), Vn = we + 2976 | 0, Lr(Vn, Dr, wr, 0, 0, Dr, wr, 0, 0), Sn = we + 2736 | 0, zi = Sn, mi = (v | 0) == (Be | 0) & dr >>> 0 < Fr >>> 0 | v >>> 0 > Be >>> 0, dr = (v | 0) == (uo | 0) & Fr >>> 0 < In >>> 0 | v >>> 0 < uo >>> 0, he = qi + 8 | 0, v = a[he >> 2], d = Mo + 8 | 0, Fr = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[he + 4 >> 2] | 0, d = v >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, he = dr + Fr | 0, d = he >>> 0 < Fr >>> 0 ? d + 1 | 0 : d, Me = Me >>> 20 | 0, v = he + Me | 0, d = Me >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + mi | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, Be = v << 12 | Be >>> 20, he = d, mi = d << 12 | v >>> 20, uo = a[we + 2756 >> 2], d = uo + a[we + 2980 >> 2] | 0, Fr = a[we + 2752 >> 2], v = a[we + 2976 >> 2], Me = Fr + v | 0, dr = Me, Be = Me + Be | 0, v = v >>> 0 > Me >>> 0 ? d + 1 | 0 : d, d = v + mi | 0, Me = Be >>> 0 < Me >>> 0 ? d + 1 | 0 : d, Lr(zi, Be, Me & 1048575, 0, 0, 15632, 16, 0, 0), In = we + 2880 | 0, Lr(In, Oi, Rr, 0, 0, Si, Kn, 0, 0), zi = we + 2928 | 0, Lr(zi, un, Gr, 0, 0, un, Gr, 0, 0), Rr = we + 2720 | 0, Lr(Rr, $i, Ti, 0, 0, Dr, wr, 0, 0), Ti = we + 2704 | 0, Dr = Ti, wr = (v | 0) == (Me | 0) & Be >>> 0 < dr >>> 0 | v >>> 0 > Me >>> 0, dr = (v | 0) == (uo | 0) & dr >>> 0 < Fr >>> 0 | v >>> 0 < uo >>> 0, Be = Vn + 8 | 0, v = a[Be >> 2], d = yo + 8 | 0, Gr = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[Be + 4 >> 2] | 0, d = v >>> 0 > Gr >>> 0 ? d + 1 | 0 : d, Be = dr + Gr | 0, d = Be >>> 0 < Gr >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, v = he + Be | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + wr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, Be = v << 12 | Me >>> 20, Me = a[we + 2720 >> 2], wr = Be + Me | 0, he = d, v = d << 12 | v >>> 20, d = v + a[we + 2724 >> 2] | 0, d = Me >>> 0 > wr >>> 0 ? d + 1 | 0 : d, Lr(Dr, wr, d, 0, 0, 15632, 16, 0, 0), mi = we + 2688 | 0, dr = mi, Be = (d | 0) == (v | 0) & Be >>> 0 > wr >>> 0 | d >>> 0 < v >>> 0, d = Rr + 8 | 0, Me = a[d >> 2], d = a[d + 4 >> 2], he = he >>> 20 | 0, v = he + Me | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + Be | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, Lr(dr, v, d, 0, 0, 64028672, 65536, 0, 0), he = a[we + 2768 >> 2], v = a[we + 3008 >> 2], Dr = he + v | 0, Be = a[we + 2772 >> 2], d = Be + a[we + 3012 >> 2] | 0, Me = v >>> 0 > Dr >>> 0 ? d + 1 | 0 : d, Be = (Be | 0) == (Me | 0) & he >>> 0 > Dr >>> 0 | Be >>> 0 > Me >>> 0, he = Ho + 8 | 0, v = a[he >> 2], d = Oo + 8 | 0, dr = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[he + 4 >> 2] | 0, d = v >>> 0 > dr >>> 0 ? d + 1 | 0 : d, v = Be + dr | 0, d = v >>> 0 < dr >>> 0 ? d + 1 | 0 : d, Fr = Me, Be = v << 12 | Me >>> 20, he = d, Me = d << 12 | v >>> 20, wr = a[we + 2736 >> 2], v = a[we + 2944 >> 2], dr = wr + v | 0, Gr = a[we + 2740 >> 2], d = Gr + a[we + 2948 >> 2] | 0, v = v >>> 0 > dr >>> 0 ? d + 1 | 0 : d, d = v + Me | 0, Me = Be + dr | 0, Be = Me >>> 0 < dr >>> 0 ? d + 1 | 0 : d, Rr = (v | 0) == (Be | 0) & Me >>> 0 < dr >>> 0 | v >>> 0 > Be >>> 0, wr = (v | 0) == (Gr | 0) & wr >>> 0 > dr >>> 0 | v >>> 0 < Gr >>> 0, dr = Xn + 8 | 0, v = a[dr >> 2], d = Sn + 8 | 0, Gr = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[dr + 4 >> 2] | 0, d = v >>> 0 > Gr >>> 0 ? d + 1 | 0 : d, dr = wr + Gr | 0, d = dr >>> 0 < Gr >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, v = he + dr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + Rr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, Gr = Be, dr = v << 12 | Be >>> 20, he = d, Be = d << 12 | v >>> 20, $i = a[we + 2880 >> 2], v = a[we + 2928 >> 2], Rr = $i + v | 0, Sn = a[we + 2884 >> 2], d = Sn + a[we + 2932 >> 2] | 0, d = v >>> 0 > Rr >>> 0 ? d + 1 | 0 : d, v = a[we + 2704 >> 2], wr = v + Rr | 0, Oi = d, d = d + a[we + 2708 >> 2] | 0, v = v >>> 0 > wr >>> 0 ? d + 1 | 0 : d, d = v + Be | 0, Be = wr + dr | 0, dr = Be >>> 0 < wr >>> 0 ? d + 1 | 0 : d, Kn = (v | 0) == (dr | 0) & Be >>> 0 < wr >>> 0 | v >>> 0 > dr >>> 0, Si = (v | 0) == (Oi | 0) & wr >>> 0 < Rr >>> 0 | v >>> 0 < Oi >>> 0, d = Ti + 8 | 0, un = a[d >> 2], Ti = a[d + 4 >> 2], Rr = (Oi | 0) == (Sn | 0) & Rr >>> 0 < $i >>> 0 | Oi >>> 0 < Sn >>> 0, wr = zi + 8 | 0, v = a[wr >> 2], d = In + 8 | 0, Oi = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[wr + 4 >> 2] | 0, d = v >>> 0 > Oi >>> 0 ? d + 1 | 0 : d, v = Rr + Oi | 0, d = (v >>> 0 < Oi >>> 0 ? d + 1 | 0 : d) + Ti | 0, Rr = v, v = v + un | 0, d = Rr >>> 0 > v >>> 0 ? d + 1 | 0 : d, wr = v + Si | 0, d = wr >>> 0 < v >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, v = he + wr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + Kn | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, Rr = dr, Oi = v << 12 | dr >>> 20, he = d, wr = d << 12 | v >>> 20, un = a[we + 2688 >> 2], dr = un + ($r & -2) | 0, Ti = a[we + 2692 >> 2], d = Ti + (Qe & 1048575) | 0, d = dr >>> 0 < un >>> 0 ? d + 1 | 0 : d, $r = dr, dr = dr + Oi | 0, v = d, d = d + wr | 0, Qe = fr, Oi = ni & 65535, wr = dr >>> 0 < $r >>> 0 ? d + 1 | 0 : d, ni = (v | 0) == (wr | 0) & dr >>> 0 < $r >>> 0 | v >>> 0 > wr >>> 0, v = (v | 0) == (Ti | 0) & $r >>> 0 < un >>> 0 | v >>> 0 < Ti >>> 0, d = mi + 8 | 0, fr = v + a[d >> 2] | 0, d = a[d + 4 >> 2], d = v >>> 0 > fr >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, v = he + fr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + ni | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, fr = v << 12 | wr >>> 20, he = fr + Qe | 0, d = Oi + (d << 12 | v >>> 20) | 0, v = he, fr = v >>> 0 < fr >>> 0 ? d + 1 | 0 : d, wr = wr & 1048575, Rr = Rr & 1048575, Qe = Gr & 1048575, he = Dr, Dr = Fr & 1048575, o = o - 1 | 0, !!o; )
      ;
    for (o = we + 7296 | 0, $r = o + 32 | 0, a[$r >> 2] = v, a[$r + 4 >> 2] = fr, ni = o + 24 | 0, a[ni >> 2] = dr, a[ni + 4 >> 2] = wr, Fr = o + 16 | 0, a[Fr >> 2] = Be, a[Fr + 4 >> 2] = Rr, Gr = o + 8 | 0, a[Gr >> 2] = Me, a[Gr + 4 >> 2] = Qe, a[we + 7296 >> 2] = he, a[we + 7300 >> 2] = Dr, gn(o, o, we + 7336 | 0), fr = a[$r + 4 >> 2], d = we + 7256 | 0, o = d + 32 | 0, v = a[$r >> 2], a[o >> 2] = v, a[o + 4 >> 2] = fr, wr = a[ni + 4 >> 2], o = d + 24 | 0, dr = a[ni >> 2], a[o >> 2] = dr, a[o + 4 >> 2] = wr, Rr = a[Fr + 4 >> 2], o = d + 16 | 0, Be = a[Fr >> 2], a[o >> 2] = Be, a[o + 4 >> 2] = Rr, Qe = a[Gr + 4 >> 2], o = d + 8 | 0, Me = a[Gr >> 2], a[o >> 2] = Me, a[o + 4 >> 2] = Qe, Dr = a[we + 7300 >> 2], he = a[we + 7296 >> 2], a[we + 7256 >> 2] = he, a[we + 7260 >> 2] = Dr, o = 88; Fr = he, d = Dr << 1 | he >>> 31, In = we + 2656 | 0, Si = he << 1, Kn = d, Lr(In, dr, wr, 0, 0, Si, d, 0, 0), mi = we + 2576 | 0, he = Me << 1, Gr = Qe, un = Me, Me = Qe << 1 | Me >>> 31, Lr(mi, Be, Rr, 0, 0, he, Me, 0, 0), $r = we + 2512 | 0, Lr($r, v, fr, 0, 0, v, fr, 0, 0), ni = we + 2496 | 0, Lr(ni, a[we + 2512 >> 2], a[we + 2516 >> 2], 0, 0, 15632, 16, 0, 0), d = fr << 1 | v >>> 31, Io = we + 2464 | 0, $i = v << 1, Ti = d, Lr(Io, $i, d, 0, 0, Fr, Dr, 0, 0), xo = we + 2624 | 0, Lr(xo, dr, wr, 0, 0, he, Me, 0, 0), Go = we + 2560 | 0, Lr(Go, Be, Rr, 0, 0, Be, Rr, 0, 0), zi = we + 2480 | 0, d = $r + 8 | 0, Lr(zi, a[d >> 2], a[d + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Ho = we + 2672 | 0, Lr(Ho, Fr, Dr, 0, 0, Fr, Dr, 0, 0), Mo = we + 2448 | 0, Lr(Mo, $i, Ti, 0, 0, un, Qe, 0, 0), qi = we + 2528 | 0, Dr = dr, Oi = Be, Lr(qi, dr, wr, 0, 0, Be << 1, Rr << 1 | Be >>> 31, 0, 0), Fr = a[we + 2660 >> 2], d = Fr + a[we + 2580 >> 2] | 0, Be = a[we + 2656 >> 2], he = a[we + 2576 >> 2], v = Be + he | 0, Me = a[we + 2496 >> 2], $r = v + Me | 0, he = v >>> 0 < he >>> 0 ? d + 1 | 0 : d, d = he + a[we + 2500 >> 2] | 0, Me = Me >>> 0 > $r >>> 0 ? d + 1 | 0 : d, Qe = (he | 0) == (Me | 0) & v >>> 0 > $r >>> 0 | he >>> 0 > Me >>> 0, d = ni + 8 | 0, fr = a[d >> 2], dr = a[d + 4 >> 2], Be = (he | 0) == (Fr | 0) & v >>> 0 < Be >>> 0 | he >>> 0 < Fr >>> 0, he = mi + 8 | 0, v = a[he >> 2], d = In + 8 | 0, Fr = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[he + 4 >> 2] | 0, d = v >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, v = Be + Fr | 0, d = (v >>> 0 < Fr >>> 0 ? d + 1 | 0 : d) + dr | 0, he = v, v = v + fr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + Qe | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, Qe = Me, dr = v << 12 | Me >>> 20, he = d, Be = d << 12 | v >>> 20, uo = a[we + 2624 >> 2], v = a[we + 2560 >> 2], Fr = uo + v | 0, ns = a[we + 2628 >> 2], d = ns + a[we + 2564 >> 2] | 0, d = v >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, v = a[we + 2464 >> 2], fr = v + Fr | 0, mi = d, d = d + a[we + 2468 >> 2] | 0, d = v >>> 0 > fr >>> 0 ? d + 1 | 0 : d, v = a[we + 2480 >> 2], Me = v + fr | 0, ni = d, d = d + a[we + 2484 >> 2] | 0, v = v >>> 0 > Me >>> 0 ? d + 1 | 0 : d, d = v + Be | 0, Oo = we + 2432 | 0, dr = Me + dr | 0, Be = dr >>> 0 < Me >>> 0 ? d + 1 | 0 : d, Xn = (v | 0) == (Be | 0) & Me >>> 0 > dr >>> 0 | v >>> 0 > Be >>> 0, yo = (v | 0) == (ni | 0) & Me >>> 0 < fr >>> 0 | v >>> 0 < ni >>> 0, d = zi + 8 | 0, Vn = a[d >> 2], Sn = a[d + 4 >> 2], In = (ni | 0) == (mi | 0) & fr >>> 0 < Fr >>> 0 | ni >>> 0 < mi >>> 0, d = Io + 8 | 0, zi = a[d >> 2], ni = a[d + 4 >> 2], fr = (mi | 0) == (ns | 0) & Fr >>> 0 < uo >>> 0 | mi >>> 0 < ns >>> 0, Me = Go + 8 | 0, v = a[Me >> 2], d = xo + 8 | 0, Fr = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[Me + 4 >> 2] | 0, d = v >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, v = fr + Fr | 0, d = (v >>> 0 < Fr >>> 0 ? d + 1 | 0 : d) + ni | 0, Me = v, v = v + zi | 0, d = Me >>> 0 > v >>> 0 ? d + 1 | 0 : d, Me = v, v = v + In | 0, d = (Me >>> 0 > v >>> 0 ? d + 1 | 0 : d) + Sn | 0, Me = v, v = v + Vn | 0, d = Me >>> 0 > v >>> 0 ? d + 1 | 0 : d, Me = v + yo | 0, d = Me >>> 0 < v >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, v = he + Me | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + Xn | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = Be, fr = v << 12 | he >>> 20, Me = d, ni = d << 12 | v >>> 20, uo = a[we + 2452 >> 2], d = uo + a[we + 2532 >> 2] | 0, In = a[we + 2448 >> 2], v = a[we + 2528 >> 2], Be = In + v | 0, Fr = Be, fr = Be + fr | 0, v = v >>> 0 > Be >>> 0 ? d + 1 | 0 : d, d = v + ni | 0, zi = fr << 4 & -16, Be = fr >>> 0 < Be >>> 0 ? d + 1 | 0 : d, mi = (Be << 4 | fr >>> 28) & 16777215, ni = he, Lr(Oo, zi | he >>> 16 & 15, mi, 0, 0, 977, 1, 0, 0), Xn = we + 2608 | 0, Lr(Xn, un, Gr, 0, 0, Si, Kn, 0, 0), yo = we + 2416 | 0, Lr(yo, $i, Ti, 0, 0, Oi, Rr, 0, 0), Vn = we + 2640 | 0, Lr(Vn, Dr, wr, 0, 0, Dr, wr, 0, 0), Sn = we + 2400 | 0, zi = Sn, mi = (v | 0) == (Be | 0) & fr >>> 0 < Fr >>> 0 | v >>> 0 > Be >>> 0, fr = (v | 0) == (uo | 0) & Fr >>> 0 < In >>> 0 | v >>> 0 < uo >>> 0, he = qi + 8 | 0, v = a[he >> 2], d = Mo + 8 | 0, Fr = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[he + 4 >> 2] | 0, d = v >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, he = fr + Fr | 0, d = he >>> 0 < Fr >>> 0 ? d + 1 | 0 : d, Me = Me >>> 20 | 0, v = he + Me | 0, d = Me >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + mi | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, Be = v << 12 | Be >>> 20, he = d, mi = d << 12 | v >>> 20, uo = a[we + 2420 >> 2], d = uo + a[we + 2644 >> 2] | 0, Fr = a[we + 2416 >> 2], v = a[we + 2640 >> 2], Me = Fr + v | 0, fr = Me, Be = Me + Be | 0, v = v >>> 0 > Me >>> 0 ? d + 1 | 0 : d, d = v + mi | 0, Me = Be >>> 0 < Me >>> 0 ? d + 1 | 0 : d, Lr(zi, Be, Me & 1048575, 0, 0, 15632, 16, 0, 0), In = we + 2544 | 0, Lr(In, Oi, Rr, 0, 0, Si, Kn, 0, 0), zi = we + 2592 | 0, Lr(zi, un, Gr, 0, 0, un, Gr, 0, 0), Rr = we + 2384 | 0, Lr(Rr, $i, Ti, 0, 0, Dr, wr, 0, 0), Ti = we + 2368 | 0, Dr = Ti, wr = (v | 0) == (Me | 0) & Be >>> 0 < fr >>> 0 | v >>> 0 > Me >>> 0, fr = (v | 0) == (uo | 0) & fr >>> 0 < Fr >>> 0 | v >>> 0 < uo >>> 0, Be = Vn + 8 | 0, v = a[Be >> 2], d = yo + 8 | 0, Gr = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[Be + 4 >> 2] | 0, d = v >>> 0 > Gr >>> 0 ? d + 1 | 0 : d, Be = fr + Gr | 0, d = Be >>> 0 < Gr >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, v = he + Be | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + wr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, Be = v << 12 | Me >>> 20, Me = a[we + 2384 >> 2], wr = Be + Me | 0, he = d, v = d << 12 | v >>> 20, d = v + a[we + 2388 >> 2] | 0, d = Me >>> 0 > wr >>> 0 ? d + 1 | 0 : d, Lr(Dr, wr, d, 0, 0, 15632, 16, 0, 0), mi = we + 2352 | 0, fr = mi, Be = (d | 0) == (v | 0) & Be >>> 0 > wr >>> 0 | d >>> 0 < v >>> 0, d = Rr + 8 | 0, Me = a[d >> 2], d = a[d + 4 >> 2], he = he >>> 20 | 0, v = he + Me | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + Be | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, Lr(fr, v, d, 0, 0, 64028672, 65536, 0, 0), he = a[we + 2432 >> 2], v = a[we + 2672 >> 2], Dr = he + v | 0, Be = a[we + 2436 >> 2], d = Be + a[we + 2676 >> 2] | 0, Me = v >>> 0 > Dr >>> 0 ? d + 1 | 0 : d, Be = (Be | 0) == (Me | 0) & he >>> 0 > Dr >>> 0 | Be >>> 0 > Me >>> 0, he = Ho + 8 | 0, v = a[he >> 2], d = Oo + 8 | 0, fr = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[he + 4 >> 2] | 0, d = v >>> 0 > fr >>> 0 ? d + 1 | 0 : d, v = Be + fr | 0, d = v >>> 0 < fr >>> 0 ? d + 1 | 0 : d, Fr = Me, fr = v << 12 | Me >>> 20, he = d, Be = d << 12 | v >>> 20, wr = a[we + 2400 >> 2], v = a[we + 2608 >> 2], Me = wr + v | 0, Gr = a[we + 2404 >> 2], d = Gr + a[we + 2612 >> 2] | 0, d = v >>> 0 > Me >>> 0 ? d + 1 | 0 : d, v = fr, fr = Me, Me = v + Me | 0, v = d, d = d + Be | 0, Be = Me >>> 0 < fr >>> 0 ? d + 1 | 0 : d, Rr = (v | 0) == (Be | 0) & Me >>> 0 < fr >>> 0 | v >>> 0 > Be >>> 0, wr = (v | 0) == (Gr | 0) & fr >>> 0 < wr >>> 0 | v >>> 0 < Gr >>> 0, fr = Xn + 8 | 0, v = a[fr >> 2], d = Sn + 8 | 0, Gr = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[fr + 4 >> 2] | 0, d = v >>> 0 > Gr >>> 0 ? d + 1 | 0 : d, fr = wr + Gr | 0, d = fr >>> 0 < Gr >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, v = he + fr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + Rr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, Gr = Be, fr = v << 12 | Be >>> 20, he = d, Be = d << 12 | v >>> 20, $i = a[we + 2544 >> 2], v = a[we + 2592 >> 2], Rr = $i + v | 0, Sn = a[we + 2548 >> 2], d = Sn + a[we + 2596 >> 2] | 0, d = v >>> 0 > Rr >>> 0 ? d + 1 | 0 : d, v = a[we + 2368 >> 2], wr = v + Rr | 0, Oi = d, d = d + a[we + 2372 >> 2] | 0, v = v >>> 0 > wr >>> 0 ? d + 1 | 0 : d, d = v + Be | 0, Be = fr + wr | 0, fr = Be >>> 0 < wr >>> 0 ? d + 1 | 0 : d, Kn = (v | 0) == (fr | 0) & Be >>> 0 < wr >>> 0 | v >>> 0 > fr >>> 0, Si = (v | 0) == (Oi | 0) & wr >>> 0 < Rr >>> 0 | v >>> 0 < Oi >>> 0, d = Ti + 8 | 0, un = a[d >> 2], Ti = a[d + 4 >> 2], Rr = (Oi | 0) == (Sn | 0) & Rr >>> 0 < $i >>> 0 | Oi >>> 0 < Sn >>> 0, wr = zi + 8 | 0, v = a[wr >> 2], d = In + 8 | 0, Oi = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[wr + 4 >> 2] | 0, d = v >>> 0 > Oi >>> 0 ? d + 1 | 0 : d, v = Rr + Oi | 0, d = (v >>> 0 < Oi >>> 0 ? d + 1 | 0 : d) + Ti | 0, Rr = v, v = v + un | 0, d = Rr >>> 0 > v >>> 0 ? d + 1 | 0 : d, wr = v + Si | 0, d = wr >>> 0 < v >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, v = he + wr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + Kn | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, Rr = fr, wr = v << 12 | fr >>> 20, he = d, fr = d << 12 | v >>> 20, un = a[we + 2352 >> 2], $r = un + ($r & -2) | 0, Ti = a[we + 2356 >> 2], d = Ti + (Qe & 1048575) | 0, v = $r >>> 0 < un >>> 0 ? d + 1 | 0 : d, d = v + fr | 0, Qe = dr, Oi = ni & 65535, wr = wr + $r | 0, fr = wr >>> 0 < $r >>> 0 ? d + 1 | 0 : d, dr = wr, ni = (v | 0) == (fr | 0) & wr >>> 0 < $r >>> 0 | v >>> 0 > fr >>> 0, v = (v | 0) == (Ti | 0) & $r >>> 0 < un >>> 0 | v >>> 0 < Ti >>> 0, d = mi + 8 | 0, wr = v + a[d >> 2] | 0, d = a[d + 4 >> 2], d = v >>> 0 > wr >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, v = he + wr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + ni | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = fr, wr = v << 12 | he >>> 20, fr = wr + Qe | 0, d = Oi + (d << 12 | v >>> 20) | 0, v = fr, fr = v >>> 0 < wr >>> 0 ? d + 1 | 0 : d, wr = he & 1048575, Rr = Rr & 1048575, Qe = Gr & 1048575, he = Dr, Dr = Fr & 1048575, o = o - 1 | 0, !!o; )
      ;
    for (o = we + 7256 | 0, $r = o + 32 | 0, a[$r >> 2] = v, a[$r + 4 >> 2] = fr, ni = o + 24 | 0, a[ni >> 2] = dr, a[ni + 4 >> 2] = wr, Fr = o + 16 | 0, a[Fr >> 2] = Be, a[Fr + 4 >> 2] = Rr, Gr = o + 8 | 0, a[Gr >> 2] = Me, a[Gr + 4 >> 2] = Qe, a[we + 7256 >> 2] = he, a[we + 7260 >> 2] = Dr, gn(o, o, we + 7296 | 0), fr = a[$r + 4 >> 2], d = we + 7216 | 0, o = d + 32 | 0, v = a[$r >> 2], a[o >> 2] = v, a[o + 4 >> 2] = fr, wr = a[ni + 4 >> 2], o = d + 24 | 0, dr = a[ni >> 2], a[o >> 2] = dr, a[o + 4 >> 2] = wr, Rr = a[Fr + 4 >> 2], o = d + 16 | 0, Be = a[Fr >> 2], a[o >> 2] = Be, a[o + 4 >> 2] = Rr, Qe = a[Gr + 4 >> 2], o = d + 8 | 0, Me = a[Gr >> 2], a[o >> 2] = Me, a[o + 4 >> 2] = Qe, Dr = a[we + 7260 >> 2], he = a[we + 7256 >> 2], a[we + 7216 >> 2] = he, a[we + 7220 >> 2] = Dr, o = 44; Fr = he, d = Dr << 1 | he >>> 31, In = we + 2320 | 0, Si = he << 1, Kn = d, Lr(In, dr, wr, 0, 0, Si, d, 0, 0), mi = we + 2240 | 0, he = Me << 1, Gr = Qe, un = Me, Me = Qe << 1 | Me >>> 31, Lr(mi, Be, Rr, 0, 0, he, Me, 0, 0), $r = we + 2176 | 0, Lr($r, v, fr, 0, 0, v, fr, 0, 0), ni = we + 2160 | 0, Lr(ni, a[we + 2176 >> 2], a[we + 2180 >> 2], 0, 0, 15632, 16, 0, 0), d = fr << 1 | v >>> 31, Io = we + 2128 | 0, $i = v << 1, Ti = d, Lr(Io, $i, d, 0, 0, Fr, Dr, 0, 0), xo = we + 2288 | 0, Lr(xo, dr, wr, 0, 0, he, Me, 0, 0), Go = we + 2224 | 0, Lr(Go, Be, Rr, 0, 0, Be, Rr, 0, 0), zi = we + 2144 | 0, d = $r + 8 | 0, Lr(zi, a[d >> 2], a[d + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Ho = we + 2336 | 0, Lr(Ho, Fr, Dr, 0, 0, Fr, Dr, 0, 0), Mo = we + 2112 | 0, Lr(Mo, $i, Ti, 0, 0, un, Qe, 0, 0), qi = we + 2192 | 0, Dr = dr, Oi = Be, Lr(qi, dr, wr, 0, 0, Be << 1, Rr << 1 | Be >>> 31, 0, 0), Fr = a[we + 2324 >> 2], d = Fr + a[we + 2244 >> 2] | 0, Be = a[we + 2320 >> 2], he = a[we + 2240 >> 2], v = Be + he | 0, Me = a[we + 2160 >> 2], $r = v + Me | 0, he = v >>> 0 < he >>> 0 ? d + 1 | 0 : d, d = he + a[we + 2164 >> 2] | 0, Me = Me >>> 0 > $r >>> 0 ? d + 1 | 0 : d, Qe = (he | 0) == (Me | 0) & v >>> 0 > $r >>> 0 | he >>> 0 > Me >>> 0, d = ni + 8 | 0, fr = a[d >> 2], dr = a[d + 4 >> 2], Be = (he | 0) == (Fr | 0) & v >>> 0 < Be >>> 0 | he >>> 0 < Fr >>> 0, he = mi + 8 | 0, v = a[he >> 2], d = In + 8 | 0, Fr = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[he + 4 >> 2] | 0, d = v >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, v = Be + Fr | 0, d = (v >>> 0 < Fr >>> 0 ? d + 1 | 0 : d) + dr | 0, he = v, v = v + fr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + Qe | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, Qe = Me, fr = v << 12 | Me >>> 20, he = d, Be = d << 12 | v >>> 20, uo = a[we + 2288 >> 2], v = a[we + 2224 >> 2], Fr = uo + v | 0, ns = a[we + 2292 >> 2], d = ns + a[we + 2228 >> 2] | 0, d = v >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, v = a[we + 2128 >> 2], dr = v + Fr | 0, mi = d, d = d + a[we + 2132 >> 2] | 0, d = v >>> 0 > dr >>> 0 ? d + 1 | 0 : d, v = a[we + 2144 >> 2], Me = v + dr | 0, ni = d, d = d + a[we + 2148 >> 2] | 0, v = v >>> 0 > Me >>> 0 ? d + 1 | 0 : d, d = v + Be | 0, Oo = we + 2096 | 0, fr = Me + fr | 0, Be = fr >>> 0 < Me >>> 0 ? d + 1 | 0 : d, Xn = (v | 0) == (Be | 0) & Me >>> 0 > fr >>> 0 | v >>> 0 > Be >>> 0, yo = (v | 0) == (ni | 0) & Me >>> 0 < dr >>> 0 | v >>> 0 < ni >>> 0, d = zi + 8 | 0, Vn = a[d >> 2], Sn = a[d + 4 >> 2], In = (ni | 0) == (mi | 0) & dr >>> 0 < Fr >>> 0 | ni >>> 0 < mi >>> 0, d = Io + 8 | 0, zi = a[d >> 2], ni = a[d + 4 >> 2], dr = (mi | 0) == (ns | 0) & Fr >>> 0 < uo >>> 0 | mi >>> 0 < ns >>> 0, Me = Go + 8 | 0, v = a[Me >> 2], d = xo + 8 | 0, Fr = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[Me + 4 >> 2] | 0, d = v >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, v = dr + Fr | 0, d = (v >>> 0 < Fr >>> 0 ? d + 1 | 0 : d) + ni | 0, Me = v, v = v + zi | 0, d = Me >>> 0 > v >>> 0 ? d + 1 | 0 : d, Me = v, v = v + In | 0, d = (Me >>> 0 > v >>> 0 ? d + 1 | 0 : d) + Sn | 0, Me = v, v = v + Vn | 0, d = Me >>> 0 > v >>> 0 ? d + 1 | 0 : d, Me = v + yo | 0, d = Me >>> 0 < v >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, v = he + Me | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + Xn | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = Be, dr = v << 12 | he >>> 20, Me = d, ni = d << 12 | v >>> 20, uo = a[we + 2116 >> 2], d = uo + a[we + 2196 >> 2] | 0, In = a[we + 2112 >> 2], v = a[we + 2192 >> 2], Be = In + v | 0, Fr = Be, dr = Be + dr | 0, v = v >>> 0 > Be >>> 0 ? d + 1 | 0 : d, d = v + ni | 0, zi = dr << 4 & -16, Be = dr >>> 0 < Be >>> 0 ? d + 1 | 0 : d, mi = (Be << 4 | dr >>> 28) & 16777215, ni = he, Lr(Oo, zi | he >>> 16 & 15, mi, 0, 0, 977, 1, 0, 0), Xn = we + 2272 | 0, Lr(Xn, un, Gr, 0, 0, Si, Kn, 0, 0), yo = we + 2080 | 0, Lr(yo, $i, Ti, 0, 0, Oi, Rr, 0, 0), Vn = we + 2304 | 0, Lr(Vn, Dr, wr, 0, 0, Dr, wr, 0, 0), Sn = we + 2064 | 0, zi = Sn, mi = (v | 0) == (Be | 0) & dr >>> 0 < Fr >>> 0 | v >>> 0 > Be >>> 0, dr = (v | 0) == (uo | 0) & Fr >>> 0 < In >>> 0 | v >>> 0 < uo >>> 0, he = qi + 8 | 0, v = a[he >> 2], d = Mo + 8 | 0, Fr = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[he + 4 >> 2] | 0, d = v >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, he = dr + Fr | 0, d = he >>> 0 < Fr >>> 0 ? d + 1 | 0 : d, Me = Me >>> 20 | 0, v = he + Me | 0, d = Me >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + mi | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, Be = v << 12 | Be >>> 20, he = d, mi = d << 12 | v >>> 20, uo = a[we + 2084 >> 2], d = uo + a[we + 2308 >> 2] | 0, Fr = a[we + 2080 >> 2], v = a[we + 2304 >> 2], Me = Fr + v | 0, dr = Me, Be = Me + Be | 0, v = v >>> 0 > Me >>> 0 ? d + 1 | 0 : d, d = v + mi | 0, Me = Be >>> 0 < Me >>> 0 ? d + 1 | 0 : d, Lr(zi, Be, Me & 1048575, 0, 0, 15632, 16, 0, 0), In = we + 2208 | 0, Lr(In, Oi, Rr, 0, 0, Si, Kn, 0, 0), zi = we + 2256 | 0, Lr(zi, un, Gr, 0, 0, un, Gr, 0, 0), Rr = we + 2048 | 0, Lr(Rr, $i, Ti, 0, 0, Dr, wr, 0, 0), Ti = we + 2032 | 0, Dr = Ti, wr = (v | 0) == (Me | 0) & Be >>> 0 < dr >>> 0 | v >>> 0 > Me >>> 0, dr = (v | 0) == (uo | 0) & dr >>> 0 < Fr >>> 0 | v >>> 0 < uo >>> 0, Be = Vn + 8 | 0, v = a[Be >> 2], d = yo + 8 | 0, Gr = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[Be + 4 >> 2] | 0, d = v >>> 0 > Gr >>> 0 ? d + 1 | 0 : d, Be = dr + Gr | 0, d = Be >>> 0 < Gr >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, v = he + Be | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + wr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, Be = v << 12 | Me >>> 20, Me = a[we + 2048 >> 2], wr = Be + Me | 0, he = d, v = d << 12 | v >>> 20, d = v + a[we + 2052 >> 2] | 0, d = Me >>> 0 > wr >>> 0 ? d + 1 | 0 : d, Lr(Dr, wr, d, 0, 0, 15632, 16, 0, 0), mi = we + 2016 | 0, dr = mi, Be = (d | 0) == (v | 0) & Be >>> 0 > wr >>> 0 | d >>> 0 < v >>> 0, d = Rr + 8 | 0, Me = a[d >> 2], d = a[d + 4 >> 2], he = he >>> 20 | 0, v = he + Me | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + Be | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, Lr(dr, v, d, 0, 0, 64028672, 65536, 0, 0), he = a[we + 2096 >> 2], v = a[we + 2336 >> 2], Dr = he + v | 0, Be = a[we + 2100 >> 2], d = Be + a[we + 2340 >> 2] | 0, Me = v >>> 0 > Dr >>> 0 ? d + 1 | 0 : d, Be = (Be | 0) == (Me | 0) & he >>> 0 > Dr >>> 0 | Be >>> 0 > Me >>> 0, he = Ho + 8 | 0, v = a[he >> 2], d = Oo + 8 | 0, dr = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[he + 4 >> 2] | 0, d = v >>> 0 > dr >>> 0 ? d + 1 | 0 : d, v = Be + dr | 0, d = v >>> 0 < dr >>> 0 ? d + 1 | 0 : d, Fr = Me, Be = v << 12 | Me >>> 20, he = d, Me = d << 12 | v >>> 20, wr = a[we + 2064 >> 2], v = a[we + 2272 >> 2], dr = wr + v | 0, Gr = a[we + 2068 >> 2], d = Gr + a[we + 2276 >> 2] | 0, v = v >>> 0 > dr >>> 0 ? d + 1 | 0 : d, d = v + Me | 0, Me = Be + dr | 0, Be = Me >>> 0 < dr >>> 0 ? d + 1 | 0 : d, Rr = (v | 0) == (Be | 0) & Me >>> 0 < dr >>> 0 | v >>> 0 > Be >>> 0, wr = (v | 0) == (Gr | 0) & wr >>> 0 > dr >>> 0 | v >>> 0 < Gr >>> 0, dr = Xn + 8 | 0, v = a[dr >> 2], d = Sn + 8 | 0, Gr = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[dr + 4 >> 2] | 0, d = v >>> 0 > Gr >>> 0 ? d + 1 | 0 : d, dr = wr + Gr | 0, d = dr >>> 0 < Gr >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, v = he + dr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + Rr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, Gr = Be, dr = v << 12 | Be >>> 20, he = d, Be = d << 12 | v >>> 20, $i = a[we + 2208 >> 2], v = a[we + 2256 >> 2], Rr = $i + v | 0, Sn = a[we + 2212 >> 2], d = Sn + a[we + 2260 >> 2] | 0, d = v >>> 0 > Rr >>> 0 ? d + 1 | 0 : d, v = a[we + 2032 >> 2], wr = v + Rr | 0, Oi = d, d = d + a[we + 2036 >> 2] | 0, v = v >>> 0 > wr >>> 0 ? d + 1 | 0 : d, d = v + Be | 0, Be = wr + dr | 0, dr = Be >>> 0 < wr >>> 0 ? d + 1 | 0 : d, Kn = (v | 0) == (dr | 0) & Be >>> 0 < wr >>> 0 | v >>> 0 > dr >>> 0, Si = (v | 0) == (Oi | 0) & wr >>> 0 < Rr >>> 0 | v >>> 0 < Oi >>> 0, d = Ti + 8 | 0, un = a[d >> 2], Ti = a[d + 4 >> 2], Rr = (Oi | 0) == (Sn | 0) & Rr >>> 0 < $i >>> 0 | Oi >>> 0 < Sn >>> 0, wr = zi + 8 | 0, v = a[wr >> 2], d = In + 8 | 0, Oi = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[wr + 4 >> 2] | 0, d = v >>> 0 > Oi >>> 0 ? d + 1 | 0 : d, v = Rr + Oi | 0, d = (v >>> 0 < Oi >>> 0 ? d + 1 | 0 : d) + Ti | 0, Rr = v, v = v + un | 0, d = Rr >>> 0 > v >>> 0 ? d + 1 | 0 : d, wr = v + Si | 0, d = wr >>> 0 < v >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, v = he + wr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + Kn | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, Rr = dr, Oi = v << 12 | dr >>> 20, he = d, wr = d << 12 | v >>> 20, un = a[we + 2016 >> 2], dr = un + ($r & -2) | 0, Ti = a[we + 2020 >> 2], d = Ti + (Qe & 1048575) | 0, d = dr >>> 0 < un >>> 0 ? d + 1 | 0 : d, $r = dr, dr = dr + Oi | 0, v = d, d = d + wr | 0, Qe = fr, Oi = ni & 65535, wr = dr >>> 0 < $r >>> 0 ? d + 1 | 0 : d, ni = (v | 0) == (wr | 0) & dr >>> 0 < $r >>> 0 | v >>> 0 > wr >>> 0, v = (v | 0) == (Ti | 0) & $r >>> 0 < un >>> 0 | v >>> 0 < Ti >>> 0, d = mi + 8 | 0, fr = v + a[d >> 2] | 0, d = a[d + 4 >> 2], d = v >>> 0 > fr >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, v = he + fr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + ni | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, fr = v << 12 | wr >>> 20, he = fr + Qe | 0, d = Oi + (d << 12 | v >>> 20) | 0, v = he, fr = v >>> 0 < fr >>> 0 ? d + 1 | 0 : d, wr = wr & 1048575, Rr = Rr & 1048575, Qe = Gr & 1048575, he = Dr, Dr = Fr & 1048575, o = o - 1 | 0, !!o; )
      ;
    for (d = we + 7216 | 0, un = d + 32 | 0, a[un >> 2] = v, a[un + 4 >> 2] = fr, o = d + 24 | 0, a[o >> 2] = dr, a[o + 4 >> 2] = wr, fr = d + 16 | 0, a[fr >> 2] = Be, a[fr + 4 >> 2] = Rr, $r = d + 8 | 0, a[$r >> 2] = Me, a[$r + 4 >> 2] = Qe, a[we + 7216 >> 2] = he, a[we + 7220 >> 2] = Dr, gn(d, d, we + 7336 | 0), Dr = a[o >> 2], he = Dr, wr = a[o + 4 >> 2], v = wr, o = a[we + 7220 >> 2], Si = o, ni = a[we + 7216 >> 2], Be = ni, d = o << 1 | Be >>> 31, Fr = we + 1856 | 0, Oi = Be << 1, Ti = d, Lr(Fr, he, v, 0, 0, Oi, d, 0, 0), o = a[$r + 4 >> 2], ns = o, Io = a[$r >> 2], v = Io, d = o << 1 | v >>> 31, Gr = we + 1952 | 0, Rr = a[fr >> 2], fr = a[fr + 4 >> 2], v = v << 1, he = d, Lr(Gr, Rr, fr, 0, 0, v, d, 0, 0), Qe = we + 1840 | 0, Me = a[un >> 2], o = a[un + 4 >> 2], Lr(Qe, Me, o, 0, 0, Me, o, 0, 0), dr = we + 1824 | 0, Lr(dr, a[we + 1840 >> 2], a[we + 1844 >> 2], 0, 0, 15632, 16, 0, 0), d = o << 1 | Me >>> 31, Go = we + 1792 | 0, un = Me << 1, $r = d, Lr(Go, un, d, 0, 0, Be, Si, 0, 0), Ho = we + 1872 | 0, Lr(Ho, Dr, wr, 0, 0, v, he, 0, 0), Mo = we + 1936 | 0, Lr(Mo, Rr, fr, 0, 0, Rr, fr, 0, 0), Kn = we + 1808 | 0, o = Qe + 8 | 0, Lr(Kn, a[o >> 2], a[o + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), qi = we + 2e3 | 0, Lr(qi, Be, Si, 0, 0, Be, Si, 0, 0), uo = we + 1776 | 0, Lr(uo, un, d, 0, 0, Io, ns, 0, 0), Oo = we + 1888 | 0, Lr(Oo, Dr, wr, 0, 0, Rr << 1, fr << 1 | Rr >>> 31, 0, 0), Si = a[we + 1860 >> 2], d = Si + a[we + 1956 >> 2] | 0, Me = a[we + 1856 >> 2], v = a[we + 1952 >> 2], o = Me + v | 0, he = a[we + 1824 >> 2], ni = o + he | 0, v = o >>> 0 < v >>> 0 ? d + 1 | 0 : d, d = v + a[we + 1828 >> 2] | 0, he = he >>> 0 > ni >>> 0 ? d + 1 | 0 : d, Qe = (v | 0) == (he | 0) & o >>> 0 > ni >>> 0 | v >>> 0 > he >>> 0, d = dr + 8 | 0, dr = a[d >> 2], Be = a[d + 4 >> 2], Me = (v | 0) == (Si | 0) & o >>> 0 < Me >>> 0 | v >>> 0 < Si >>> 0, d = Gr + 8 | 0, v = a[d >> 2], o = Fr + 8 | 0, Gr = v + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 > Gr >>> 0 ? d + 1 | 0 : d, o = Me + Gr | 0, d = (o >>> 0 < Gr >>> 0 ? d + 1 | 0 : d) + Be | 0, v = o, o = o + dr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Qe | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Fr = he, dr = o << 12 | he >>> 20, v = d, Me = d << 12 | o >>> 20, Xn = a[we + 1872 >> 2], o = a[we + 1936 >> 2], Qe = Xn + o | 0, xo = a[we + 1876 >> 2], d = xo + a[we + 1940 >> 2] | 0, d = o >>> 0 > Qe >>> 0 ? d + 1 | 0 : d, o = a[we + 1792 >> 2], Be = o + Qe | 0, Si = d, d = d + a[we + 1796 >> 2] | 0, d = o >>> 0 > Be >>> 0 ? d + 1 | 0 : d, o = a[we + 1808 >> 2], he = o + Be | 0, Gr = d, d = d + a[we + 1812 >> 2] | 0, o = o >>> 0 > he >>> 0 ? d + 1 | 0 : d, d = o + Me | 0, yo = we + 1760 | 0, Vn = yo, dr = he + dr | 0, Me = dr >>> 0 < he >>> 0 ? d + 1 | 0 : d, Sn = (o | 0) == (Me | 0) & he >>> 0 > dr >>> 0 | o >>> 0 > Me >>> 0, In = (o | 0) == (Gr | 0) & he >>> 0 < Be >>> 0 | o >>> 0 < Gr >>> 0, o = Kn + 8 | 0, zi = a[o >> 2], mi = a[o + 4 >> 2], $i = (Gr | 0) == (Si | 0) & Be >>> 0 < Qe >>> 0 | Gr >>> 0 < Si >>> 0, o = Go + 8 | 0, Kn = a[o >> 2], Gr = a[o + 4 >> 2], Be = (Si | 0) == (xo | 0) & Qe >>> 0 < Xn >>> 0 | Si >>> 0 < xo >>> 0, d = Mo + 8 | 0, he = a[d >> 2], o = Ho + 8 | 0, Qe = he + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = he >>> 0 > Qe >>> 0 ? d + 1 | 0 : d, o = Be + Qe | 0, d = (o >>> 0 < Qe >>> 0 ? d + 1 | 0 : d) + Gr | 0, he = o, o = o + Kn | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, he = o, o = o + $i | 0, d = (he >>> 0 > o >>> 0 ? d + 1 | 0 : d) + mi | 0, he = o, o = o + zi | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, he = o + In | 0, d = he >>> 0 < o >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = v + he | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Sn | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = Me, Be = o << 12 | v >>> 20, he = d, Me = d << 12 | o >>> 20, mi = a[we + 1776 >> 2], o = a[we + 1888 >> 2], Qe = mi + o | 0, zi = a[we + 1780 >> 2], d = zi + a[we + 1892 >> 2] | 0, o = o >>> 0 > Qe >>> 0 ? d + 1 | 0 : d, d = o + Me | 0, Be = Be + Qe | 0, d = Be >>> 0 < Qe >>> 0 ? d + 1 | 0 : d, Kn = Be << 4 & -16, Me = d, Si = (d << 4 | Be >>> 28) & 16777215, Gr = v, Lr(Vn, Kn | v >>> 16 & 15, Si, 0, 0, 977, 1, 0, 0), Vn = we + 1984 | 0, Lr(Vn, Io, ns, 0, 0, Oi, Ti, 0, 0), In = we + 1728 | 0, Lr(In, un, $r, 0, 0, Rr, fr, 0, 0), $i = we + 1904 | 0, Lr($i, Dr, wr, 0, 0, Dr, wr, 0, 0), Kn = we + 1712 | 0, Si = (o | 0) == (d | 0) & Be >>> 0 < Qe >>> 0 | o >>> 0 > d >>> 0, Be = (o | 0) == (zi | 0) & Qe >>> 0 < mi >>> 0 | o >>> 0 < zi >>> 0, d = Oo + 8 | 0, v = a[d >> 2], o = uo + 8 | 0, Qe = v + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 > Qe >>> 0 ? d + 1 | 0 : d, v = Be + Qe | 0, d = v >>> 0 < Qe >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, o = v + he | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Si | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Me = o << 12 | Me >>> 20, v = d, Qe = d << 12 | o >>> 20, Sn = a[we + 1732 >> 2], d = Sn + a[we + 1908 >> 2] | 0, Si = a[we + 1728 >> 2], o = a[we + 1904 >> 2], he = Si + o | 0, Be = he, Me = he + Me | 0, o = o >>> 0 > he >>> 0 ? d + 1 | 0 : d, d = o + Qe | 0, he = he >>> 0 > Me >>> 0 ? d + 1 | 0 : d, Lr(Kn, Me, he & 1048575, 0, 0, 15632, 16, 0, 0), zi = we + 1920 | 0, Lr(zi, Rr, fr, 0, 0, Oi, Ti, 0, 0), mi = we + 1968 | 0, Lr(mi, Io, ns, 0, 0, Io, ns, 0, 0), Qe = we + 1664 | 0, Lr(Qe, un, $r, 0, 0, Dr, wr, 0, 0), Oi = we + 1648 | 0, wr = Oi, fr = (o | 0) == (he | 0) & Be >>> 0 > Me >>> 0 | o >>> 0 > he >>> 0, Be = (o | 0) == (Sn | 0) & Be >>> 0 < Si >>> 0 | o >>> 0 < Sn >>> 0, d = $i + 8 | 0, Me = a[d >> 2], o = In + 8 | 0, Dr = Me + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = Me >>> 0 > Dr >>> 0 ? d + 1 | 0 : d, Me = Be + Dr | 0, d = Me >>> 0 < Dr >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = v + Me | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + fr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Me = o << 12 | he >>> 20, he = a[we + 1664 >> 2], fr = Me + he | 0, v = d, o = d << 12 | o >>> 20, d = o + a[we + 1668 >> 2] | 0, d = he >>> 0 > fr >>> 0 ? d + 1 | 0 : d, Lr(wr, fr, d, 0, 0, 15632, 16, 0, 0), Sn = we + 1584 | 0, Be = Sn, Me = (o | 0) == (d | 0) & Me >>> 0 > fr >>> 0 | o >>> 0 > d >>> 0, o = Qe + 8 | 0, he = a[o >> 2], d = a[o + 4 >> 2], v = v >>> 20 | 0, o = v + he | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Me | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Lr(Be, o, d, 0, 0, 64028672, 65536, 0, 0), v = a[we + 1760 >> 2], o = a[we + 2e3 >> 2], Be = v + o | 0, Me = a[we + 1764 >> 2], d = Me + a[we + 2004 >> 2] | 0, he = o >>> 0 > Be >>> 0 ? d + 1 | 0 : d, Me = (Me | 0) == (he | 0) & v >>> 0 > Be >>> 0 | he >>> 0 < Me >>> 0, d = qi + 8 | 0, v = a[d >> 2], o = yo + 8 | 0, fr = v + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 > fr >>> 0 ? d + 1 | 0 : d, o = Me + fr | 0, d = o >>> 0 < fr >>> 0 ? d + 1 | 0 : d, Rr = he, Me = o << 12 | he >>> 20, v = d, Dr = d << 12 | o >>> 20, Qe = a[we + 1716 >> 2], d = Qe + a[we + 1988 >> 2] | 0, wr = a[we + 1712 >> 2], o = a[we + 1984 >> 2], he = wr + o | 0, fr = he, Me = he + Me | 0, o = o >>> 0 > he >>> 0 ? d + 1 | 0 : d, d = o + Dr | 0, he = Me >>> 0 < he >>> 0 ? d + 1 | 0 : d, Dr = (o | 0) == (he | 0) & Me >>> 0 < fr >>> 0 | o >>> 0 > he >>> 0, wr = (o | 0) == (Qe | 0) & fr >>> 0 < wr >>> 0 | o >>> 0 < Qe >>> 0, d = Vn + 8 | 0, fr = a[d >> 2], o = Kn + 8 | 0, Qe = fr + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = fr >>> 0 > Qe >>> 0 ? d + 1 | 0 : d, fr = wr + Qe | 0, d = fr >>> 0 < Qe >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = v + fr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Dr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Qe = he, fr = o << 12 | he >>> 20, v = d, he = d << 12 | o >>> 20, $i = a[we + 1920 >> 2], o = a[we + 1968 >> 2], Dr = $i + o | 0, Vn = a[we + 1924 >> 2], d = Vn + a[we + 1972 >> 2] | 0, d = o >>> 0 > Dr >>> 0 ? d + 1 | 0 : d, o = a[we + 1648 >> 2], wr = o + Dr | 0, $r = d, d = d + a[we + 1652 >> 2] | 0, o = o >>> 0 > wr >>> 0 ? d + 1 | 0 : d, d = o + he | 0, In = we + 1568 | 0, he = fr + wr | 0, fr = he >>> 0 < wr >>> 0 ? d + 1 | 0 : d, Si = (o | 0) == (fr | 0) & he >>> 0 < wr >>> 0 | o >>> 0 > fr >>> 0, un = (o | 0) == ($r | 0) & wr >>> 0 < Dr >>> 0 | o >>> 0 < $r >>> 0, o = Oi + 8 | 0, Ti = a[o >> 2], Oi = a[o + 4 >> 2], Dr = ($r | 0) == (Vn | 0) & Dr >>> 0 < $i >>> 0 | $r >>> 0 < Vn >>> 0, d = mi + 8 | 0, wr = a[d >> 2], o = zi + 8 | 0, $r = wr + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = wr >>> 0 > $r >>> 0 ? d + 1 | 0 : d, o = Dr + $r | 0, d = (o >>> 0 < $r >>> 0 ? d + 1 | 0 : d) + Oi | 0, Dr = o, o = o + Ti | 0, d = Dr >>> 0 > o >>> 0 ? d + 1 | 0 : d, wr = o + un | 0, d = wr >>> 0 < o >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = v + wr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Si | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, wr = fr, $r = o << 12 | fr >>> 20, v = d, Dr = d << 12 | o >>> 20, Vn = a[we + 1588 >> 2], d = Vn + (Fr & 1048575) | 0, $i = a[we + 1584 >> 2], fr = ni & -2, o = $i + fr | 0, Fr = o, o = o >>> 0 < fr >>> 0 ? d + 1 | 0 : d, d = o + Dr | 0, Dr = Fr + $r | 0, fr = Dr >>> 0 < Fr >>> 0 ? d + 1 | 0 : d, $r = fr & 1048575, d = Rr & 1048575, yo = d, Rr = Be, d = d << 1 | Be >>> 31, Ti = Be << 1, un = d, Lr(In, Dr, $r, 0, 0, Ti, d, 0, 0), d = Qe & 1048575, Io = d, zi = we + 1600 | 0, ni = wr & 1048575, Be = Me << 1, Kn = Me, wr = d << 1 | Me >>> 31, Lr(zi, he, ni, 0, 0, Be, wr, 0, 0), mi = we + 1504 | 0, Oi = Gr & 65535, Gr = (o | 0) == (fr | 0) & Dr >>> 0 < Fr >>> 0 | o >>> 0 > fr >>> 0, Qe = (o | 0) == (Vn | 0) & Fr >>> 0 < $i >>> 0 | o >>> 0 < Vn >>> 0, o = Sn + 8 | 0, Me = Qe + a[o >> 2] | 0, d = a[o + 4 >> 2], d = Me >>> 0 < Qe >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = v + Me | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Gr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Me = o << 12 | fr >>> 20, v = Me + dr | 0, d = Oi + (d << 12 | o >>> 20) | 0, d = v >>> 0 < Me >>> 0 ? d + 1 | 0 : d, Lr(mi, v, d, 0, 0, v, d, 0, 0), dr = we + 1488 | 0, Lr(dr, a[we + 1504 >> 2], a[we + 1508 >> 2], 0, 0, 15632, 16, 0, 0), o = v, d = d << 1 | o >>> 31, Go = we + 1456 | 0, Si = o << 1, Oi = d, Lr(Go, Si, d, 0, 0, Rr, yo, 0, 0), Ho = we + 1552 | 0, Lr(Ho, Dr, $r, 0, 0, Be, wr, 0, 0), Mo = we + 1616 | 0, Lr(Mo, he, ni, 0, 0, he, ni, 0, 0), $i = we + 1472 | 0, o = mi + 8 | 0, Lr($i, a[o >> 2], a[o + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), qi = we + 1744 | 0, Lr(qi, Rr, yo, 0, 0, Rr, yo, 0, 0), uo = we + 1440 | 0, Lr(uo, Si, d, 0, 0, Kn, Io, 0, 0), Oo = we + 1520 | 0, wr = $r, fr = ni, $r = he, Lr(Oo, Dr, wr, 0, 0, he << 1, fr << 1 | he >>> 31, 0, 0), Me = a[we + 1568 >> 2], v = a[we + 1600 >> 2], o = Me + v | 0, Rr = a[we + 1572 >> 2], d = Rr + a[we + 1604 >> 2] | 0, d = o >>> 0 < v >>> 0 ? d + 1 | 0 : d, v = a[we + 1488 >> 2], ni = v + o | 0, he = d, d = d + a[we + 1492 >> 2] | 0, v = v >>> 0 > ni >>> 0 ? d + 1 | 0 : d, Qe = (he | 0) == (v | 0) & o >>> 0 > ni >>> 0 | v >>> 0 < he >>> 0, d = dr + 8 | 0, dr = a[d >> 2], Be = a[d + 4 >> 2], Me = (he | 0) == (Rr | 0) & o >>> 0 < Me >>> 0 | he >>> 0 < Rr >>> 0, d = zi + 8 | 0, he = a[d >> 2], o = In + 8 | 0, Rr = he + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = he >>> 0 > Rr >>> 0 ? d + 1 | 0 : d, o = Me + Rr | 0, d = (o >>> 0 < Rr >>> 0 ? d + 1 | 0 : d) + Be | 0, he = o, o = o + dr | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, he = o, o = o + Qe | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, Fr = v, dr = o << 12 | v >>> 20, he = d, Me = d << 12 | o >>> 20, Xn = a[we + 1552 >> 2], o = a[we + 1616 >> 2], Rr = Xn + o | 0, xo = a[we + 1556 >> 2], d = xo + a[we + 1620 >> 2] | 0, d = o >>> 0 > Rr >>> 0 ? d + 1 | 0 : d, o = a[we + 1456 >> 2], Qe = o + Rr | 0, v = d, d = d + a[we + 1460 >> 2] | 0, d = o >>> 0 > Qe >>> 0 ? d + 1 | 0 : d, o = a[we + 1472 >> 2], Be = o + Qe | 0, Gr = d, d = d + a[we + 1476 >> 2] | 0, o = o >>> 0 > Be >>> 0 ? d + 1 | 0 : d, d = o + Me | 0, yo = we + 1344 | 0, Vn = yo, dr = Be + dr | 0, Me = dr >>> 0 < Be >>> 0 ? d + 1 | 0 : d, Sn = (o | 0) == (Me | 0) & Be >>> 0 > dr >>> 0 | o >>> 0 > Me >>> 0, In = (o | 0) == (Gr | 0) & Be >>> 0 < Qe >>> 0 | o >>> 0 < Gr >>> 0, o = $i + 8 | 0, zi = a[o >> 2], mi = a[o + 4 >> 2], $i = (v | 0) == (Gr | 0) & Rr >>> 0 > Qe >>> 0 | v >>> 0 > Gr >>> 0, o = Go + 8 | 0, Gr = a[o >> 2], Qe = a[o + 4 >> 2], Be = (v | 0) == (xo | 0) & Rr >>> 0 < Xn >>> 0 | v >>> 0 < xo >>> 0, d = Mo + 8 | 0, v = a[d >> 2], o = Ho + 8 | 0, Rr = v + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 > Rr >>> 0 ? d + 1 | 0 : d, o = Be + Rr | 0, d = (o >>> 0 < Rr >>> 0 ? d + 1 | 0 : d) + Qe | 0, v = o, o = o + Gr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + $i | 0, d = (v >>> 0 > o >>> 0 ? d + 1 | 0 : d) + mi | 0, v = o, o = o + zi | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o + In | 0, d = v >>> 0 < o >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, o = v + he | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Sn | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = Me, Be = o << 12 | v >>> 20, he = d, Me = d << 12 | o >>> 20, mi = a[we + 1440 >> 2], o = a[we + 1520 >> 2], Qe = mi + o | 0, zi = a[we + 1444 >> 2], d = zi + a[we + 1524 >> 2] | 0, o = o >>> 0 > Qe >>> 0 ? d + 1 | 0 : d, d = o + Me | 0, Be = Be + Qe | 0, d = Be >>> 0 < Qe >>> 0 ? d + 1 | 0 : d, $i = Be << 4 & -16, Me = d, Rr = (d << 4 | Be >>> 28) & 16777215, Gr = v, Lr(Vn, $i | v >>> 16 & 15, Rr, 0, 0, 977, 1, 0, 0), Vn = we + 1680 | 0, Lr(Vn, Kn, Io, 0, 0, Ti, un, 0, 0), Sn = we + 1424 | 0, Lr(Sn, Si, Oi, 0, 0, $r, fr, 0, 0), In = we + 1536 | 0, Lr(In, Dr, wr, 0, 0, Dr, wr, 0, 0), $i = we + 1408 | 0, Rr = (o | 0) == (d | 0) & Be >>> 0 < Qe >>> 0 | o >>> 0 > d >>> 0, Be = (o | 0) == (zi | 0) & Qe >>> 0 < mi >>> 0 | o >>> 0 < zi >>> 0, d = Oo + 8 | 0, v = a[d >> 2], o = uo + 8 | 0, Qe = v + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 > Qe >>> 0 ? d + 1 | 0 : d, v = Be + Qe | 0, d = v >>> 0 < Qe >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, o = v + he | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Rr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Me = o << 12 | Me >>> 20, v = d, he = d << 12 | o >>> 20, Rr = a[we + 1424 >> 2], o = a[we + 1536 >> 2], Be = Rr + o | 0, Xn = a[we + 1428 >> 2], d = Xn + a[we + 1540 >> 2] | 0, o = o >>> 0 > Be >>> 0 ? d + 1 | 0 : d, d = o + he | 0, Me = Be + Me | 0, d = Me >>> 0 < Be >>> 0 ? d + 1 | 0 : d, he = d, Lr($i, Me, d & 1048575, 0, 0, 15632, 16, 0, 0), zi = we + 1632 | 0, Lr(zi, $r, fr, 0, 0, Ti, un, 0, 0), mi = we + 1696 | 0, Lr(mi, Kn, Io, 0, 0, Kn, Io, 0, 0), Qe = we + 1392 | 0, Lr(Qe, Dr, wr, 0, 0, Si, Oi, 0, 0), Oi = we + 1376 | 0, wr = Oi, fr = (o | 0) == (d | 0) & Be >>> 0 > Me >>> 0 | o >>> 0 > d >>> 0, Be = (o | 0) == (Xn | 0) & Be >>> 0 < Rr >>> 0 | o >>> 0 < Xn >>> 0, d = In + 8 | 0, Me = a[d >> 2], o = Sn + 8 | 0, Dr = Me + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = Me >>> 0 > Dr >>> 0 ? d + 1 | 0 : d, Me = Be + Dr | 0, d = Me >>> 0 < Dr >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = v + Me | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + fr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Me = o << 12 | he >>> 20, he = a[we + 1392 >> 2], fr = Me + he | 0, v = d, o = d << 12 | o >>> 20, d = o + a[we + 1396 >> 2] | 0, d = he >>> 0 > fr >>> 0 ? d + 1 | 0 : d, Lr(wr, fr, d, 0, 0, 15632, 16, 0, 0), Sn = we + 1360 | 0, Be = Sn, Me = (o | 0) == (d | 0) & Me >>> 0 > fr >>> 0 | o >>> 0 > d >>> 0, o = Qe + 8 | 0, he = a[o >> 2], d = a[o + 4 >> 2], v = v >>> 20 | 0, o = v + he | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Me | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Lr(Be, o, d, 0, 0, 64028672, 65536, 0, 0), v = a[we + 1344 >> 2], o = a[we + 1744 >> 2], Be = v + o | 0, Me = a[we + 1348 >> 2], d = Me + a[we + 1748 >> 2] | 0, he = o >>> 0 > Be >>> 0 ? d + 1 | 0 : d, Me = (Me | 0) == (he | 0) & v >>> 0 > Be >>> 0 | he >>> 0 < Me >>> 0, d = qi + 8 | 0, v = a[d >> 2], o = yo + 8 | 0, fr = v + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 > fr >>> 0 ? d + 1 | 0 : d, o = Me + fr | 0, d = o >>> 0 < fr >>> 0 ? d + 1 | 0 : d, Rr = he, Me = o << 12 | he >>> 20, v = d, he = d << 12 | o >>> 20, wr = a[we + 1408 >> 2], o = a[we + 1680 >> 2], fr = wr + o | 0, Qe = a[we + 1412 >> 2], d = Qe + a[we + 1684 >> 2] | 0, o = o >>> 0 > fr >>> 0 ? d + 1 | 0 : d, d = o + he | 0, Me = Me + fr | 0, he = Me >>> 0 < fr >>> 0 ? d + 1 | 0 : d, Dr = (o | 0) == (he | 0) & Me >>> 0 < fr >>> 0 | o >>> 0 > he >>> 0, wr = (o | 0) == (Qe | 0) & fr >>> 0 < wr >>> 0 | o >>> 0 < Qe >>> 0, d = Vn + 8 | 0, fr = a[d >> 2], o = $i + 8 | 0, Qe = fr + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = fr >>> 0 > Qe >>> 0 ? d + 1 | 0 : d, fr = wr + Qe | 0, d = fr >>> 0 < Qe >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = v + fr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Dr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Qe = he, fr = o << 12 | he >>> 20, v = d, he = d << 12 | o >>> 20, $i = a[we + 1632 >> 2], o = a[we + 1696 >> 2], Dr = $i + o | 0, Vn = a[we + 1636 >> 2], d = Vn + a[we + 1700 >> 2] | 0, d = o >>> 0 > Dr >>> 0 ? d + 1 | 0 : d, o = a[we + 1376 >> 2], wr = o + Dr | 0, $r = d, d = d + a[we + 1380 >> 2] | 0, o = o >>> 0 > wr >>> 0 ? d + 1 | 0 : d, d = o + he | 0, In = we + 1264 | 0, he = fr + wr | 0, fr = he >>> 0 < wr >>> 0 ? d + 1 | 0 : d, Si = (o | 0) == (fr | 0) & he >>> 0 < wr >>> 0 | o >>> 0 > fr >>> 0, un = (o | 0) == ($r | 0) & wr >>> 0 < Dr >>> 0 | o >>> 0 < $r >>> 0, o = Oi + 8 | 0, Ti = a[o >> 2], Oi = a[o + 4 >> 2], Dr = ($r | 0) == (Vn | 0) & Dr >>> 0 < $i >>> 0 | $r >>> 0 < Vn >>> 0, d = mi + 8 | 0, wr = a[d >> 2], o = zi + 8 | 0, $r = wr + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = wr >>> 0 > $r >>> 0 ? d + 1 | 0 : d, o = Dr + $r | 0, d = (o >>> 0 < $r >>> 0 ? d + 1 | 0 : d) + Oi | 0, Dr = o, o = o + Ti | 0, d = Dr >>> 0 > o >>> 0 ? d + 1 | 0 : d, wr = o + un | 0, d = wr >>> 0 < o >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = v + wr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Si | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, wr = fr, Dr = o << 12 | fr >>> 20, v = d, $r = d << 12 | o >>> 20, Vn = a[we + 1364 >> 2], d = Vn + (Fr & 1048575) | 0, $i = a[we + 1360 >> 2], o = ni & -2, fr = $i + o | 0, Fr = fr, Dr = fr + Dr | 0, o = o >>> 0 > fr >>> 0 ? d + 1 | 0 : d, d = o + $r | 0, fr = Dr >>> 0 < fr >>> 0 ? d + 1 | 0 : d, Si = fr & 1048575, ni = Si, d = Rr & 1048575, yo = d, Rr = Be, d = d << 1 | Be >>> 31, Oi = Be << 1, Ti = d, Lr(In, Dr, ni, 0, 0, Oi, d, 0, 0), d = Qe & 1048575, Io = d, zi = we + 1216 | 0, ni = wr & 1048575, Be = Me << 1, Kn = Me, wr = d << 1 | Me >>> 31, Lr(zi, he, ni, 0, 0, Be, wr, 0, 0), mi = we + 1168 | 0, $r = Gr & 65535, Gr = (o | 0) == (fr | 0) & Dr >>> 0 < Fr >>> 0 | o >>> 0 > fr >>> 0, Qe = (o | 0) == (Vn | 0) & Fr >>> 0 < $i >>> 0 | o >>> 0 < Vn >>> 0, o = Sn + 8 | 0, Me = Qe + a[o >> 2] | 0, d = a[o + 4 >> 2], d = Me >>> 0 < Qe >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = v + Me | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Gr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Me = o << 12 | fr >>> 20, v = Me + dr | 0, d = $r + (d << 12 | o >>> 20) | 0, d = v >>> 0 < Me >>> 0 ? d + 1 | 0 : d, Lr(mi, v, d, 0, 0, v, d, 0, 0), dr = we + 1152 | 0, Lr(dr, a[we + 1168 >> 2], a[we + 1172 >> 2], 0, 0, 15632, 16, 0, 0), o = v, d = d << 1 | o >>> 31, Go = we + 1120 | 0, un = o << 1, $r = d, Lr(Go, un, d, 0, 0, Rr, yo, 0, 0), Ho = we + 1200 | 0, Lr(Ho, Dr, Si, 0, 0, Be, wr, 0, 0), Mo = we + 1312 | 0, Lr(Mo, he, ni, 0, 0, he, ni, 0, 0), $i = we + 1136 | 0, o = mi + 8 | 0, Lr($i, a[o >> 2], a[o + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), qi = we + 1280 | 0, Lr(qi, Rr, yo, 0, 0, Rr, yo, 0, 0), uo = we + 1104 | 0, Lr(uo, un, d, 0, 0, Kn, Io, 0, 0), Oo = we + 1184 | 0, Gr = Dr, Rr = Si, fr = ni, ni = he, Lr(Oo, Dr, Rr, 0, 0, he << 1, fr << 1 | he >>> 31, 0, 0), Me = a[we + 1264 >> 2], v = a[we + 1216 >> 2], o = Me + v | 0, Dr = a[we + 1268 >> 2], d = Dr + a[we + 1220 >> 2] | 0, d = o >>> 0 < v >>> 0 ? d + 1 | 0 : d, v = a[we + 1152 >> 2], Qe = v + o | 0, he = d, d = d + a[we + 1156 >> 2] | 0, v = v >>> 0 > Qe >>> 0 ? d + 1 | 0 : d, wr = (he | 0) == (v | 0) & o >>> 0 > Qe >>> 0 | v >>> 0 < he >>> 0, d = dr + 8 | 0, dr = a[d >> 2], Be = a[d + 4 >> 2], Me = (he | 0) == (Dr | 0) & o >>> 0 < Me >>> 0 | he >>> 0 < Dr >>> 0, d = zi + 8 | 0, he = a[d >> 2], o = In + 8 | 0, Dr = he + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = he >>> 0 > Dr >>> 0 ? d + 1 | 0 : d, o = Me + Dr | 0, d = (o >>> 0 < Dr >>> 0 ? d + 1 | 0 : d) + Be | 0, he = o, o = o + dr | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, he = o, o = o + wr | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, Dr = v, Be = o << 12 | v >>> 20, he = d, Me = d << 12 | o >>> 20, Xn = a[we + 1200 >> 2], o = a[we + 1312 >> 2], Fr = Xn + o | 0, xo = a[we + 1204 >> 2], d = xo + a[we + 1316 >> 2] | 0, d = o >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, o = a[we + 1120 >> 2], wr = o + Fr | 0, v = d, d = d + a[we + 1124 >> 2] | 0, d = o >>> 0 > wr >>> 0 ? d + 1 | 0 : d, o = a[we + 1136 >> 2], dr = o + wr | 0, Si = d, d = d + a[we + 1140 >> 2] | 0, o = o >>> 0 > dr >>> 0 ? d + 1 | 0 : d, d = o + Me | 0, yo = we + 1008 | 0, Vn = yo, Me = Be + dr | 0, Be = Me >>> 0 < dr >>> 0 ? d + 1 | 0 : d, Sn = (o | 0) == (Be | 0) & Me >>> 0 < dr >>> 0 | o >>> 0 > Be >>> 0, In = (o | 0) == (Si | 0) & wr >>> 0 > dr >>> 0 | o >>> 0 < Si >>> 0, o = $i + 8 | 0, zi = a[o >> 2], mi = a[o + 4 >> 2], $i = (v | 0) == (Si | 0) & wr >>> 0 < Fr >>> 0 | v >>> 0 > Si >>> 0, o = Go + 8 | 0, Si = a[o >> 2], wr = a[o + 4 >> 2], dr = (v | 0) == (xo | 0) & Fr >>> 0 < Xn >>> 0 | v >>> 0 < xo >>> 0, d = Mo + 8 | 0, v = a[d >> 2], o = Ho + 8 | 0, Fr = v + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, o = dr + Fr | 0, d = (o >>> 0 < Fr >>> 0 ? d + 1 | 0 : d) + wr | 0, v = o, o = o + Si | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + $i | 0, d = (v >>> 0 > o >>> 0 ? d + 1 | 0 : d) + mi | 0, v = o, o = o + zi | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o + In | 0, d = v >>> 0 < o >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, o = v + he | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Sn | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = Be, dr = o << 12 | v >>> 20, he = d, Be = d << 12 | o >>> 20, mi = a[we + 1104 >> 2], o = a[we + 1184 >> 2], Fr = mi + o | 0, Xn = a[we + 1108 >> 2], d = Xn + a[we + 1188 >> 2] | 0, o = o >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, d = o + Be | 0, dr = dr + Fr | 0, d = dr >>> 0 < Fr >>> 0 ? d + 1 | 0 : d, $i = dr << 4 & -16, Be = d, Si = (d << 4 | dr >>> 28) & 16777215, wr = v, Lr(Vn, $i | v >>> 16 & 15, Si, 0, 0, 977, 1, 0, 0), Vn = we + 1248 | 0, Lr(Vn, Kn, Io, 0, 0, Oi, Ti, 0, 0), Sn = we + 1088 | 0, Lr(Sn, un, $r, 0, 0, ni, fr, 0, 0), In = we + 1328 | 0, Lr(In, Gr, Rr, 0, 0, Gr, Rr, 0, 0), zi = we + 1072 | 0, $i = zi, Si = (o | 0) == (d | 0) & dr >>> 0 < Fr >>> 0 | o >>> 0 > d >>> 0, dr = (o | 0) == (Xn | 0) & Fr >>> 0 < mi >>> 0 | o >>> 0 < Xn >>> 0, d = Oo + 8 | 0, v = a[d >> 2], o = uo + 8 | 0, Fr = v + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, v = dr + Fr | 0, d = v >>> 0 < Fr >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, o = v + he | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Si | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Be = o << 12 | Be >>> 20, v = d, he = d << 12 | o >>> 20, Si = a[we + 1088 >> 2], o = a[we + 1328 >> 2], dr = Si + o | 0, Xn = a[we + 1092 >> 2], d = Xn + a[we + 1332 >> 2] | 0, o = o >>> 0 > dr >>> 0 ? d + 1 | 0 : d, d = o + he | 0, Be = Be + dr | 0, d = Be >>> 0 < dr >>> 0 ? d + 1 | 0 : d, he = d, Lr($i, Be, d & 1048575, 0, 0, 15632, 16, 0, 0), mi = we + 1232 | 0, Lr(mi, ni, fr, 0, 0, Oi, Ti, 0, 0), $i = we + 1296 | 0, Lr($i, Kn, Io, 0, 0, Kn, Io, 0, 0), Fr = we + 1056 | 0, Lr(Fr, Gr, Rr, 0, 0, un, $r, 0, 0), ni = we + 1040 | 0, Rr = ni, fr = (o | 0) == (d | 0) & Be >>> 0 < dr >>> 0 | o >>> 0 > d >>> 0, dr = (o | 0) == (Xn | 0) & dr >>> 0 < Si >>> 0 | o >>> 0 < Xn >>> 0, d = In + 8 | 0, Be = a[d >> 2], o = Sn + 8 | 0, Gr = Be + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = Be >>> 0 > Gr >>> 0 ? d + 1 | 0 : d, Be = dr + Gr | 0, d = Be >>> 0 < Gr >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = v + Be | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + fr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Be = o << 12 | he >>> 20, he = a[we + 1056 >> 2], fr = Be + he | 0, v = d, o = d << 12 | o >>> 20, d = o + a[we + 1060 >> 2] | 0, d = he >>> 0 > fr >>> 0 ? d + 1 | 0 : d, Lr(Rr, fr, d, 0, 0, 15632, 16, 0, 0), Si = we + 1024 | 0, dr = Si, Be = (o | 0) == (d | 0) & Be >>> 0 > fr >>> 0 | o >>> 0 > d >>> 0, o = Fr + 8 | 0, he = a[o >> 2], d = a[o + 4 >> 2], v = v >>> 20 | 0, o = v + he | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Be | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Lr(dr, o, d, 0, 0, 64028672, 65536, 0, 0), v = a[we + 1008 >> 2], o = a[we + 1280 >> 2], fr = v + o | 0, Be = a[we + 1012 >> 2], d = Be + a[we + 1284 >> 2] | 0, Xn = we + 7176 | 0, Sn = Xn + 8 | 0, Gr = Sn, he = o >>> 0 > fr >>> 0 ? d + 1 | 0 : d, Be = (Be | 0) == (he | 0) & v >>> 0 > fr >>> 0 | he >>> 0 < Be >>> 0, d = qi + 8 | 0, v = a[d >> 2], o = yo + 8 | 0, dr = v + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 > dr >>> 0 ? d + 1 | 0 : d, o = Be + dr | 0, d = o >>> 0 < dr >>> 0 ? d + 1 | 0 : d, dr = he, Be = o << 12 | he >>> 20, v = d, he = d << 12 | o >>> 20, Fr = a[we + 1072 >> 2], o = a[we + 1248 >> 2], Rr = Fr + o | 0, Oi = a[we + 1076 >> 2], d = Oi + a[we + 1252 >> 2] | 0, o = o >>> 0 > Rr >>> 0 ? d + 1 | 0 : d, d = o + he | 0, Be = Be + Rr | 0, d = Be >>> 0 < Rr >>> 0 ? d + 1 | 0 : d, a[Gr >> 2] = Be, he = d, a[Gr + 4 >> 2] = d & 1048575, In = Xn + 16 | 0, $r = In, Gr = (o | 0) == (d | 0) & Be >>> 0 < Rr >>> 0 | o >>> 0 > d >>> 0, Rr = (o | 0) == (Oi | 0) & Rr >>> 0 < Fr >>> 0 | o >>> 0 < Oi >>> 0, d = Vn + 8 | 0, Be = a[d >> 2], o = zi + 8 | 0, Fr = Be + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = Be >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, Be = Rr + Fr | 0, d = Be >>> 0 < Fr >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = v + Be | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Gr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Be = o << 12 | he >>> 20, v = d, he = d << 12 | o >>> 20, un = a[we + 1232 >> 2], o = a[we + 1296 >> 2], Gr = un + o | 0, zi = a[we + 1236 >> 2], d = zi + a[we + 1300 >> 2] | 0, d = o >>> 0 > Gr >>> 0 ? d + 1 | 0 : d, o = a[we + 1040 >> 2], Rr = o + Gr | 0, Fr = d, d = d + a[we + 1044 >> 2] | 0, o = o >>> 0 > Rr >>> 0 ? d + 1 | 0 : d, d = o + he | 0, Be = Be + Rr | 0, d = Be >>> 0 < Rr >>> 0 ? d + 1 | 0 : d, a[$r >> 2] = Be, he = d, a[$r + 4 >> 2] = d & 1048575, Kn = Xn + 24 | 0, Ti = (o | 0) == (d | 0) & Be >>> 0 < Rr >>> 0 | o >>> 0 > d >>> 0, Oi = (o | 0) == (Fr | 0) & Rr >>> 0 < Gr >>> 0 | o >>> 0 < Fr >>> 0, o = ni + 8 | 0, $r = a[o >> 2], ni = a[o + 4 >> 2], Rr = (Fr | 0) == (zi | 0) & Gr >>> 0 < un >>> 0 | Fr >>> 0 < zi >>> 0, d = $i + 8 | 0, Be = a[d >> 2], o = mi + 8 | 0, Gr = Be + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = Be >>> 0 > Gr >>> 0 ? d + 1 | 0 : d, o = Rr + Gr | 0, d = (o >>> 0 < Gr >>> 0 ? d + 1 | 0 : d) + ni | 0, Be = o, o = o + $r | 0, d = Be >>> 0 > o >>> 0 ? d + 1 | 0 : d, Be = o + Oi | 0, d = Be >>> 0 < o >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = v + Be | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Ti | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Rr = o << 12 | he >>> 20, v = d, Be = d << 12 | o >>> 20, Gr = a[we + 1024 >> 2], he = Qe & -2, o = Gr + he | 0, ni = a[we + 1028 >> 2], d = ni + (Dr & 1048575) | 0, Qe = o >>> 0 < he >>> 0 ? d + 1 | 0 : d, d = Qe + Be | 0, Dr = o, he = o + Rr | 0, d = o >>> 0 > he >>> 0 ? d + 1 | 0 : d, a[Kn >> 2] = he, o = d, a[Kn + 4 >> 2] = d & 1048575, Fr = Xn + 32 | 0, Be = Me, Rr = wr & 65535, wr = (d | 0) == (Qe | 0) & he >>> 0 < Dr >>> 0 | d >>> 0 < Qe >>> 0, he = (Qe | 0) == (ni | 0) & Dr >>> 0 < Gr >>> 0 | Qe >>> 0 < ni >>> 0, d = Si + 8 | 0, Me = he + a[d >> 2] | 0, d = a[d + 4 >> 2], d = he >>> 0 > Me >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, he = v, v = v + Me | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + wr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, o = v << 12 | o >>> 20, he = o + Be | 0, d = Rr + (d << 12 | v >>> 20) | 0, a[Fr >> 2] = he, a[Fr + 4 >> 2] = o >>> 0 > he >>> 0 ? d + 1 | 0 : d, a[we + 7176 >> 2] = fr, a[we + 7180 >> 2] = dr & 1048575, gn(Xn, Xn, we + 7536 | 0), fr = a[Fr + 4 >> 2], d = we + 7136 | 0, o = d + 32 | 0, v = a[Fr >> 2], a[o >> 2] = v, a[o + 4 >> 2] = fr, wr = a[Kn + 4 >> 2], o = d + 24 | 0, dr = a[Kn >> 2], a[o >> 2] = dr, a[o + 4 >> 2] = wr, Rr = a[In + 4 >> 2], o = d + 16 | 0, Be = a[In >> 2], a[o >> 2] = Be, a[o + 4 >> 2] = Rr, Qe = a[Sn + 4 >> 2], o = d + 8 | 0, Me = a[Sn >> 2], a[o >> 2] = Me, a[o + 4 >> 2] = Qe, Dr = a[we + 7180 >> 2], he = a[we + 7176 >> 2], a[we + 7136 >> 2] = he, a[we + 7140 >> 2] = Dr, o = 23; Fr = he, d = Dr << 1 | he >>> 31, In = we + 976 | 0, Si = he << 1, Kn = d, Lr(In, dr, wr, 0, 0, Si, d, 0, 0), mi = we + 896 | 0, he = Me << 1, Gr = Qe, un = Me, Me = Qe << 1 | Me >>> 31, Lr(mi, Be, Rr, 0, 0, he, Me, 0, 0), $r = we + 832 | 0, Lr($r, v, fr, 0, 0, v, fr, 0, 0), ni = we + 816 | 0, Lr(ni, a[we + 832 >> 2], a[we + 836 >> 2], 0, 0, 15632, 16, 0, 0), d = fr << 1 | v >>> 31, Io = we + 784 | 0, $i = v << 1, Ti = d, Lr(Io, $i, d, 0, 0, Fr, Dr, 0, 0), xo = we + 944 | 0, Lr(xo, dr, wr, 0, 0, he, Me, 0, 0), Go = we + 880 | 0, Lr(Go, Be, Rr, 0, 0, Be, Rr, 0, 0), zi = we + 800 | 0, d = $r + 8 | 0, Lr(zi, a[d >> 2], a[d + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Ho = we + 992 | 0, Lr(Ho, Fr, Dr, 0, 0, Fr, Dr, 0, 0), Mo = we + 768 | 0, Lr(Mo, $i, Ti, 0, 0, un, Qe, 0, 0), qi = we + 848 | 0, Dr = dr, Oi = Be, Lr(qi, dr, wr, 0, 0, Be << 1, Rr << 1 | Be >>> 31, 0, 0), Fr = a[we + 980 >> 2], d = Fr + a[we + 900 >> 2] | 0, Be = a[we + 976 >> 2], he = a[we + 896 >> 2], v = Be + he | 0, Me = a[we + 816 >> 2], $r = v + Me | 0, he = v >>> 0 < he >>> 0 ? d + 1 | 0 : d, d = he + a[we + 820 >> 2] | 0, Me = Me >>> 0 > $r >>> 0 ? d + 1 | 0 : d, Qe = (he | 0) == (Me | 0) & v >>> 0 > $r >>> 0 | he >>> 0 > Me >>> 0, d = ni + 8 | 0, fr = a[d >> 2], dr = a[d + 4 >> 2], Be = (he | 0) == (Fr | 0) & v >>> 0 < Be >>> 0 | he >>> 0 < Fr >>> 0, he = mi + 8 | 0, v = a[he >> 2], d = In + 8 | 0, Fr = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[he + 4 >> 2] | 0, d = v >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, v = Be + Fr | 0, d = (v >>> 0 < Fr >>> 0 ? d + 1 | 0 : d) + dr | 0, he = v, v = v + fr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + Qe | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, Qe = Me, dr = v << 12 | Me >>> 20, he = d, Be = d << 12 | v >>> 20, uo = a[we + 944 >> 2], v = a[we + 880 >> 2], Fr = uo + v | 0, ns = a[we + 948 >> 2], d = ns + a[we + 884 >> 2] | 0, d = v >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, v = a[we + 784 >> 2], fr = v + Fr | 0, mi = d, d = d + a[we + 788 >> 2] | 0, d = v >>> 0 > fr >>> 0 ? d + 1 | 0 : d, v = a[we + 800 >> 2], Me = v + fr | 0, ni = d, d = d + a[we + 804 >> 2] | 0, v = v >>> 0 > Me >>> 0 ? d + 1 | 0 : d, d = v + Be | 0, Oo = we + 752 | 0, dr = Me + dr | 0, Be = dr >>> 0 < Me >>> 0 ? d + 1 | 0 : d, Xn = (v | 0) == (Be | 0) & Me >>> 0 > dr >>> 0 | v >>> 0 > Be >>> 0, yo = (v | 0) == (ni | 0) & Me >>> 0 < fr >>> 0 | v >>> 0 < ni >>> 0, d = zi + 8 | 0, Vn = a[d >> 2], Sn = a[d + 4 >> 2], In = (ni | 0) == (mi | 0) & fr >>> 0 < Fr >>> 0 | ni >>> 0 < mi >>> 0, d = Io + 8 | 0, zi = a[d >> 2], ni = a[d + 4 >> 2], fr = (mi | 0) == (ns | 0) & Fr >>> 0 < uo >>> 0 | mi >>> 0 < ns >>> 0, Me = Go + 8 | 0, v = a[Me >> 2], d = xo + 8 | 0, Fr = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[Me + 4 >> 2] | 0, d = v >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, v = fr + Fr | 0, d = (v >>> 0 < Fr >>> 0 ? d + 1 | 0 : d) + ni | 0, Me = v, v = v + zi | 0, d = Me >>> 0 > v >>> 0 ? d + 1 | 0 : d, Me = v, v = v + In | 0, d = (Me >>> 0 > v >>> 0 ? d + 1 | 0 : d) + Sn | 0, Me = v, v = v + Vn | 0, d = Me >>> 0 > v >>> 0 ? d + 1 | 0 : d, Me = v + yo | 0, d = Me >>> 0 < v >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, v = he + Me | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + Xn | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = Be, fr = v << 12 | he >>> 20, Me = d, ni = d << 12 | v >>> 20, uo = a[we + 772 >> 2], d = uo + a[we + 852 >> 2] | 0, In = a[we + 768 >> 2], v = a[we + 848 >> 2], Be = In + v | 0, Fr = Be, fr = Be + fr | 0, v = v >>> 0 > Be >>> 0 ? d + 1 | 0 : d, d = v + ni | 0, zi = fr << 4 & -16, Be = fr >>> 0 < Be >>> 0 ? d + 1 | 0 : d, mi = (Be << 4 | fr >>> 28) & 16777215, ni = he, Lr(Oo, zi | he >>> 16 & 15, mi, 0, 0, 977, 1, 0, 0), Xn = we + 928 | 0, Lr(Xn, un, Gr, 0, 0, Si, Kn, 0, 0), yo = we + 736 | 0, Lr(yo, $i, Ti, 0, 0, Oi, Rr, 0, 0), Vn = we + 960 | 0, Lr(Vn, Dr, wr, 0, 0, Dr, wr, 0, 0), Sn = we + 720 | 0, zi = Sn, mi = (v | 0) == (Be | 0) & fr >>> 0 < Fr >>> 0 | v >>> 0 > Be >>> 0, fr = (v | 0) == (uo | 0) & Fr >>> 0 < In >>> 0 | v >>> 0 < uo >>> 0, he = qi + 8 | 0, v = a[he >> 2], d = Mo + 8 | 0, Fr = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[he + 4 >> 2] | 0, d = v >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, he = fr + Fr | 0, d = he >>> 0 < Fr >>> 0 ? d + 1 | 0 : d, Me = Me >>> 20 | 0, v = he + Me | 0, d = Me >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + mi | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, Be = v << 12 | Be >>> 20, he = d, Me = d << 12 | v >>> 20, Fr = a[we + 736 >> 2], v = a[we + 960 >> 2], fr = Fr + v | 0, mi = a[we + 740 >> 2], d = mi + a[we + 964 >> 2] | 0, v = v >>> 0 > fr >>> 0 ? d + 1 | 0 : d, d = v + Me | 0, Be = Be + fr | 0, d = Be >>> 0 < fr >>> 0 ? d + 1 | 0 : d, Me = d, Lr(zi, Be, d & 1048575, 0, 0, 15632, 16, 0, 0), In = we + 864 | 0, Lr(In, Oi, Rr, 0, 0, Si, Kn, 0, 0), zi = we + 912 | 0, Lr(zi, un, Gr, 0, 0, un, Gr, 0, 0), Rr = we + 704 | 0, Lr(Rr, $i, Ti, 0, 0, Dr, wr, 0, 0), Ti = we + 688 | 0, Dr = Ti, wr = (d | 0) == (v | 0) & Be >>> 0 < fr >>> 0 | d >>> 0 < v >>> 0, fr = (v | 0) == (mi | 0) & fr >>> 0 < Fr >>> 0 | v >>> 0 < mi >>> 0, Be = Vn + 8 | 0, v = a[Be >> 2], d = yo + 8 | 0, Gr = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[Be + 4 >> 2] | 0, d = v >>> 0 > Gr >>> 0 ? d + 1 | 0 : d, Be = fr + Gr | 0, d = Be >>> 0 < Gr >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, v = he + Be | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + wr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, Be = v << 12 | Me >>> 20, Me = a[we + 704 >> 2], wr = Be + Me | 0, he = d, v = d << 12 | v >>> 20, d = v + a[we + 708 >> 2] | 0, d = Me >>> 0 > wr >>> 0 ? d + 1 | 0 : d, Lr(Dr, wr, d, 0, 0, 15632, 16, 0, 0), mi = we + 672 | 0, fr = mi, Be = (d | 0) == (v | 0) & Be >>> 0 > wr >>> 0 | d >>> 0 < v >>> 0, d = Rr + 8 | 0, Me = a[d >> 2], d = a[d + 4 >> 2], he = he >>> 20 | 0, v = he + Me | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + Be | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, Lr(fr, v, d, 0, 0, 64028672, 65536, 0, 0), he = a[we + 752 >> 2], v = a[we + 992 >> 2], Dr = he + v | 0, Be = a[we + 756 >> 2], d = Be + a[we + 996 >> 2] | 0, Me = v >>> 0 > Dr >>> 0 ? d + 1 | 0 : d, Be = (Be | 0) == (Me | 0) & he >>> 0 > Dr >>> 0 | Be >>> 0 > Me >>> 0, he = Ho + 8 | 0, v = a[he >> 2], d = Oo + 8 | 0, fr = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[he + 4 >> 2] | 0, d = v >>> 0 > fr >>> 0 ? d + 1 | 0 : d, v = Be + fr | 0, d = v >>> 0 < fr >>> 0 ? d + 1 | 0 : d, Fr = Me, fr = v << 12 | Me >>> 20, he = d, Be = d << 12 | v >>> 20, wr = a[we + 720 >> 2], v = a[we + 928 >> 2], Me = wr + v | 0, Gr = a[we + 724 >> 2], d = Gr + a[we + 932 >> 2] | 0, d = v >>> 0 > Me >>> 0 ? d + 1 | 0 : d, v = fr, fr = Me, Me = v + Me | 0, v = d, d = d + Be | 0, Be = Me >>> 0 < fr >>> 0 ? d + 1 | 0 : d, Rr = (v | 0) == (Be | 0) & Me >>> 0 < fr >>> 0 | v >>> 0 > Be >>> 0, wr = (v | 0) == (Gr | 0) & fr >>> 0 < wr >>> 0 | v >>> 0 < Gr >>> 0, fr = Xn + 8 | 0, v = a[fr >> 2], d = Sn + 8 | 0, Gr = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[fr + 4 >> 2] | 0, d = v >>> 0 > Gr >>> 0 ? d + 1 | 0 : d, fr = wr + Gr | 0, d = fr >>> 0 < Gr >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, v = he + fr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + Rr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, Gr = Be, fr = v << 12 | Be >>> 20, he = d, Be = d << 12 | v >>> 20, $i = a[we + 864 >> 2], v = a[we + 912 >> 2], Rr = $i + v | 0, Sn = a[we + 868 >> 2], d = Sn + a[we + 916 >> 2] | 0, d = v >>> 0 > Rr >>> 0 ? d + 1 | 0 : d, v = a[we + 688 >> 2], wr = v + Rr | 0, Oi = d, d = d + a[we + 692 >> 2] | 0, v = v >>> 0 > wr >>> 0 ? d + 1 | 0 : d, d = v + Be | 0, Be = fr + wr | 0, fr = Be >>> 0 < wr >>> 0 ? d + 1 | 0 : d, Kn = (v | 0) == (fr | 0) & Be >>> 0 < wr >>> 0 | v >>> 0 > fr >>> 0, Si = (v | 0) == (Oi | 0) & wr >>> 0 < Rr >>> 0 | v >>> 0 < Oi >>> 0, d = Ti + 8 | 0, un = a[d >> 2], Ti = a[d + 4 >> 2], Rr = (Oi | 0) == (Sn | 0) & Rr >>> 0 < $i >>> 0 | Oi >>> 0 < Sn >>> 0, wr = zi + 8 | 0, v = a[wr >> 2], d = In + 8 | 0, Oi = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[wr + 4 >> 2] | 0, d = v >>> 0 > Oi >>> 0 ? d + 1 | 0 : d, v = Rr + Oi | 0, d = (v >>> 0 < Oi >>> 0 ? d + 1 | 0 : d) + Ti | 0, Rr = v, v = v + un | 0, d = Rr >>> 0 > v >>> 0 ? d + 1 | 0 : d, wr = v + Si | 0, d = wr >>> 0 < v >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, v = he + wr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + Kn | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, Rr = fr, wr = v << 12 | fr >>> 20, he = d, fr = d << 12 | v >>> 20, un = a[we + 672 >> 2], $r = un + ($r & -2) | 0, Ti = a[we + 676 >> 2], d = Ti + (Qe & 1048575) | 0, v = $r >>> 0 < un >>> 0 ? d + 1 | 0 : d, d = v + fr | 0, Qe = dr, Oi = ni & 65535, wr = wr + $r | 0, fr = wr >>> 0 < $r >>> 0 ? d + 1 | 0 : d, dr = wr, ni = (v | 0) == (fr | 0) & wr >>> 0 < $r >>> 0 | v >>> 0 > fr >>> 0, v = (v | 0) == (Ti | 0) & $r >>> 0 < un >>> 0 | v >>> 0 < Ti >>> 0, d = mi + 8 | 0, wr = v + a[d >> 2] | 0, d = a[d + 4 >> 2], d = v >>> 0 > wr >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, v = he + wr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + ni | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = fr, wr = v << 12 | he >>> 20, fr = wr + Qe | 0, d = Oi + (d << 12 | v >>> 20) | 0, v = fr, fr = v >>> 0 < wr >>> 0 ? d + 1 | 0 : d, wr = he & 1048575, Rr = Rr & 1048575, Qe = Gr & 1048575, he = Dr, Dr = Fr & 1048575, o = o - 1 | 0, !!o; )
      ;
    for (a[we + 7168 >> 2] = v, a[we + 7172 >> 2] = fr, a[we + 7160 >> 2] = dr, a[we + 7164 >> 2] = wr, a[we + 7152 >> 2] = Be, a[we + 7156 >> 2] = Rr, a[we + 7144 >> 2] = Me, a[we + 7148 >> 2] = Qe, a[we + 7136 >> 2] = he, a[we + 7140 >> 2] = Dr, o = we + 7136 | 0, gn(o, o, we + 7376 | 0), o = 6, v = a[we + 7168 >> 2], fr = a[we + 7172 >> 2], dr = a[we + 7160 >> 2], wr = a[we + 7164 >> 2], Be = a[we + 7152 >> 2], Rr = a[we + 7156 >> 2], Me = a[we + 7144 >> 2], Qe = a[we + 7148 >> 2], he = a[we + 7136 >> 2], Dr = a[we + 7140 >> 2]; Fr = he, d = Dr << 1 | he >>> 31, In = we + 640 | 0, Si = he << 1, Kn = d, Lr(In, dr, wr, 0, 0, Si, d, 0, 0), mi = we + 560 | 0, he = Me << 1, Gr = Qe, un = Me, Me = Qe << 1 | Me >>> 31, Lr(mi, Be, Rr, 0, 0, he, Me, 0, 0), $r = we + 496 | 0, Lr($r, v, fr, 0, 0, v, fr, 0, 0), ni = we + 480 | 0, Lr(ni, a[we + 496 >> 2], a[we + 500 >> 2], 0, 0, 15632, 16, 0, 0), d = fr << 1 | v >>> 31, Io = we + 448 | 0, $i = v << 1, Ti = d, Lr(Io, $i, d, 0, 0, Fr, Dr, 0, 0), xo = we + 608 | 0, Lr(xo, dr, wr, 0, 0, he, Me, 0, 0), Go = we + 544 | 0, Lr(Go, Be, Rr, 0, 0, Be, Rr, 0, 0), zi = we + 464 | 0, d = $r + 8 | 0, Lr(zi, a[d >> 2], a[d + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Ho = we + 656 | 0, Lr(Ho, Fr, Dr, 0, 0, Fr, Dr, 0, 0), Mo = we + 432 | 0, Lr(Mo, $i, Ti, 0, 0, un, Qe, 0, 0), qi = we + 512 | 0, Dr = dr, Oi = Be, Lr(qi, dr, wr, 0, 0, Be << 1, Rr << 1 | Be >>> 31, 0, 0), Fr = a[we + 644 >> 2], d = Fr + a[we + 564 >> 2] | 0, Be = a[we + 640 >> 2], he = a[we + 560 >> 2], v = Be + he | 0, Me = a[we + 480 >> 2], $r = v + Me | 0, he = v >>> 0 < he >>> 0 ? d + 1 | 0 : d, d = he + a[we + 484 >> 2] | 0, Me = Me >>> 0 > $r >>> 0 ? d + 1 | 0 : d, Qe = (he | 0) == (Me | 0) & v >>> 0 > $r >>> 0 | he >>> 0 > Me >>> 0, d = ni + 8 | 0, fr = a[d >> 2], dr = a[d + 4 >> 2], Be = (he | 0) == (Fr | 0) & v >>> 0 < Be >>> 0 | he >>> 0 < Fr >>> 0, he = mi + 8 | 0, v = a[he >> 2], d = In + 8 | 0, Fr = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[he + 4 >> 2] | 0, d = v >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, v = Be + Fr | 0, d = (v >>> 0 < Fr >>> 0 ? d + 1 | 0 : d) + dr | 0, he = v, v = v + fr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + Qe | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, Qe = Me, dr = v << 12 | Me >>> 20, he = d, Be = d << 12 | v >>> 20, uo = a[we + 608 >> 2], v = a[we + 544 >> 2], Fr = uo + v | 0, ns = a[we + 612 >> 2], d = ns + a[we + 548 >> 2] | 0, d = v >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, v = a[we + 448 >> 2], fr = v + Fr | 0, mi = d, d = d + a[we + 452 >> 2] | 0, d = v >>> 0 > fr >>> 0 ? d + 1 | 0 : d, v = a[we + 464 >> 2], Me = v + fr | 0, ni = d, d = d + a[we + 468 >> 2] | 0, v = v >>> 0 > Me >>> 0 ? d + 1 | 0 : d, d = v + Be | 0, Oo = we + 416 | 0, dr = Me + dr | 0, Be = dr >>> 0 < Me >>> 0 ? d + 1 | 0 : d, Xn = (v | 0) == (Be | 0) & Me >>> 0 > dr >>> 0 | v >>> 0 > Be >>> 0, yo = (v | 0) == (ni | 0) & Me >>> 0 < fr >>> 0 | v >>> 0 < ni >>> 0, d = zi + 8 | 0, Vn = a[d >> 2], Sn = a[d + 4 >> 2], In = (ni | 0) == (mi | 0) & fr >>> 0 < Fr >>> 0 | ni >>> 0 < mi >>> 0, d = Io + 8 | 0, zi = a[d >> 2], ni = a[d + 4 >> 2], fr = (mi | 0) == (ns | 0) & Fr >>> 0 < uo >>> 0 | mi >>> 0 < ns >>> 0, Me = Go + 8 | 0, v = a[Me >> 2], d = xo + 8 | 0, Fr = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[Me + 4 >> 2] | 0, d = v >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, v = fr + Fr | 0, d = (v >>> 0 < Fr >>> 0 ? d + 1 | 0 : d) + ni | 0, Me = v, v = v + zi | 0, d = Me >>> 0 > v >>> 0 ? d + 1 | 0 : d, Me = v, v = v + In | 0, d = (Me >>> 0 > v >>> 0 ? d + 1 | 0 : d) + Sn | 0, Me = v, v = v + Vn | 0, d = Me >>> 0 > v >>> 0 ? d + 1 | 0 : d, Me = v + yo | 0, d = Me >>> 0 < v >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, v = he + Me | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + Xn | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = Be, fr = v << 12 | he >>> 20, Me = d, Be = d << 12 | v >>> 20, In = a[we + 432 >> 2], v = a[we + 512 >> 2], Fr = In + v | 0, uo = a[we + 436 >> 2], d = uo + a[we + 516 >> 2] | 0, v = v >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, d = v + Be | 0, fr = fr + Fr | 0, d = fr >>> 0 < Fr >>> 0 ? d + 1 | 0 : d, zi = fr << 4 & -16, Be = d, mi = (d << 4 | fr >>> 28) & 16777215, ni = he, Lr(Oo, zi | he >>> 16 & 15, mi, 0, 0, 977, 1, 0, 0), Xn = we + 592 | 0, Lr(Xn, un, Gr, 0, 0, Si, Kn, 0, 0), yo = we + 400 | 0, Lr(yo, $i, Ti, 0, 0, Oi, Rr, 0, 0), Vn = we + 624 | 0, Lr(Vn, Dr, wr, 0, 0, Dr, wr, 0, 0), Sn = we + 384 | 0, zi = Sn, mi = (v | 0) == (d | 0) & fr >>> 0 < Fr >>> 0 | v >>> 0 > d >>> 0, fr = (v | 0) == (uo | 0) & Fr >>> 0 < In >>> 0 | v >>> 0 < uo >>> 0, he = qi + 8 | 0, v = a[he >> 2], d = Mo + 8 | 0, Fr = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[he + 4 >> 2] | 0, d = v >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, he = fr + Fr | 0, d = he >>> 0 < Fr >>> 0 ? d + 1 | 0 : d, Me = Me >>> 20 | 0, v = he + Me | 0, d = Me >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + mi | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, Be = v << 12 | Be >>> 20, he = d, mi = d << 12 | v >>> 20, uo = a[we + 404 >> 2], d = uo + a[we + 628 >> 2] | 0, Fr = a[we + 400 >> 2], v = a[we + 624 >> 2], Me = Fr + v | 0, fr = Me, Be = Me + Be | 0, v = v >>> 0 > Me >>> 0 ? d + 1 | 0 : d, d = v + mi | 0, Me = Be >>> 0 < Me >>> 0 ? d + 1 | 0 : d, Lr(zi, Be, Me & 1048575, 0, 0, 15632, 16, 0, 0), In = we + 528 | 0, Lr(In, Oi, Rr, 0, 0, Si, Kn, 0, 0), zi = we + 576 | 0, Lr(zi, un, Gr, 0, 0, un, Gr, 0, 0), Rr = we + 368 | 0, Lr(Rr, $i, Ti, 0, 0, Dr, wr, 0, 0), Ti = we + 352 | 0, Dr = Ti, wr = (v | 0) == (Me | 0) & Be >>> 0 < fr >>> 0 | v >>> 0 > Me >>> 0, fr = (v | 0) == (uo | 0) & fr >>> 0 < Fr >>> 0 | v >>> 0 < uo >>> 0, Be = Vn + 8 | 0, v = a[Be >> 2], d = yo + 8 | 0, Gr = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[Be + 4 >> 2] | 0, d = v >>> 0 > Gr >>> 0 ? d + 1 | 0 : d, Be = fr + Gr | 0, d = Be >>> 0 < Gr >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, v = he + Be | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + wr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, Be = v << 12 | Me >>> 20, Me = a[we + 368 >> 2], wr = Be + Me | 0, he = d, v = d << 12 | v >>> 20, d = v + a[we + 372 >> 2] | 0, d = Me >>> 0 > wr >>> 0 ? d + 1 | 0 : d, Lr(Dr, wr, d, 0, 0, 15632, 16, 0, 0), mi = we + 336 | 0, fr = mi, Be = (d | 0) == (v | 0) & Be >>> 0 > wr >>> 0 | d >>> 0 < v >>> 0, d = Rr + 8 | 0, Me = a[d >> 2], d = a[d + 4 >> 2], he = he >>> 20 | 0, v = he + Me | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + Be | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, Lr(fr, v, d, 0, 0, 64028672, 65536, 0, 0), he = a[we + 416 >> 2], v = a[we + 656 >> 2], Dr = he + v | 0, Be = a[we + 420 >> 2], d = Be + a[we + 660 >> 2] | 0, Me = v >>> 0 > Dr >>> 0 ? d + 1 | 0 : d, Be = (Be | 0) == (Me | 0) & he >>> 0 > Dr >>> 0 | Be >>> 0 > Me >>> 0, he = Ho + 8 | 0, v = a[he >> 2], d = Oo + 8 | 0, fr = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[he + 4 >> 2] | 0, d = v >>> 0 > fr >>> 0 ? d + 1 | 0 : d, v = Be + fr | 0, d = v >>> 0 < fr >>> 0 ? d + 1 | 0 : d, Fr = Me, fr = v << 12 | Me >>> 20, he = d, Be = d << 12 | v >>> 20, wr = a[we + 384 >> 2], v = a[we + 592 >> 2], Me = wr + v | 0, Gr = a[we + 388 >> 2], d = Gr + a[we + 596 >> 2] | 0, d = v >>> 0 > Me >>> 0 ? d + 1 | 0 : d, v = fr, fr = Me, Me = v + Me | 0, v = d, d = d + Be | 0, Be = Me >>> 0 < fr >>> 0 ? d + 1 | 0 : d, Rr = (v | 0) == (Be | 0) & Me >>> 0 < fr >>> 0 | v >>> 0 > Be >>> 0, wr = (v | 0) == (Gr | 0) & fr >>> 0 < wr >>> 0 | v >>> 0 < Gr >>> 0, fr = Xn + 8 | 0, v = a[fr >> 2], d = Sn + 8 | 0, Gr = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[fr + 4 >> 2] | 0, d = v >>> 0 > Gr >>> 0 ? d + 1 | 0 : d, fr = wr + Gr | 0, d = fr >>> 0 < Gr >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, v = he + fr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + Rr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, Gr = Be, fr = v << 12 | Be >>> 20, he = d, Be = d << 12 | v >>> 20, $i = a[we + 528 >> 2], v = a[we + 576 >> 2], Rr = $i + v | 0, Sn = a[we + 532 >> 2], d = Sn + a[we + 580 >> 2] | 0, d = v >>> 0 > Rr >>> 0 ? d + 1 | 0 : d, v = a[we + 352 >> 2], wr = v + Rr | 0, Oi = d, d = d + a[we + 356 >> 2] | 0, v = v >>> 0 > wr >>> 0 ? d + 1 | 0 : d, d = v + Be | 0, Be = fr + wr | 0, fr = Be >>> 0 < wr >>> 0 ? d + 1 | 0 : d, Kn = (v | 0) == (fr | 0) & Be >>> 0 < wr >>> 0 | v >>> 0 > fr >>> 0, Si = (v | 0) == (Oi | 0) & wr >>> 0 < Rr >>> 0 | v >>> 0 < Oi >>> 0, d = Ti + 8 | 0, un = a[d >> 2], Ti = a[d + 4 >> 2], Rr = (Oi | 0) == (Sn | 0) & Rr >>> 0 < $i >>> 0 | Oi >>> 0 < Sn >>> 0, wr = zi + 8 | 0, v = a[wr >> 2], d = In + 8 | 0, Oi = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[wr + 4 >> 2] | 0, d = v >>> 0 > Oi >>> 0 ? d + 1 | 0 : d, v = Rr + Oi | 0, d = (v >>> 0 < Oi >>> 0 ? d + 1 | 0 : d) + Ti | 0, Rr = v, v = v + un | 0, d = Rr >>> 0 > v >>> 0 ? d + 1 | 0 : d, wr = v + Si | 0, d = wr >>> 0 < v >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, v = he + wr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + Kn | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, Rr = fr, wr = v << 12 | fr >>> 20, he = d, fr = d << 12 | v >>> 20, un = a[we + 336 >> 2], $r = un + ($r & -2) | 0, Ti = a[we + 340 >> 2], d = Ti + (Qe & 1048575) | 0, v = $r >>> 0 < un >>> 0 ? d + 1 | 0 : d, d = v + fr | 0, Qe = dr, Oi = ni & 65535, wr = wr + $r | 0, fr = wr >>> 0 < $r >>> 0 ? d + 1 | 0 : d, dr = wr, ni = (v | 0) == (fr | 0) & wr >>> 0 < $r >>> 0 | v >>> 0 > fr >>> 0, v = (v | 0) == (Ti | 0) & $r >>> 0 < un >>> 0 | v >>> 0 < Ti >>> 0, d = mi + 8 | 0, wr = v + a[d >> 2] | 0, d = a[d + 4 >> 2], d = v >>> 0 > wr >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, v = he + wr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + ni | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = fr, wr = v << 12 | he >>> 20, fr = wr + Qe | 0, d = Oi + (d << 12 | v >>> 20) | 0, v = fr, fr = v >>> 0 < wr >>> 0 ? d + 1 | 0 : d, wr = he & 1048575, Rr = Rr & 1048575, Qe = Gr & 1048575, he = Dr, Dr = Fr & 1048575, o = o - 1 | 0, !!o; )
      ;
    a[we + 7168 >> 2] = v, a[we + 7172 >> 2] = fr, a[we + 7160 >> 2] = dr, a[we + 7164 >> 2] = wr, a[we + 7152 >> 2] = Be, a[we + 7156 >> 2] = Rr, a[we + 7144 >> 2] = Me, a[we + 7148 >> 2] = Qe, a[we + 7136 >> 2] = he, a[we + 7140 >> 2] = Dr, Go = we + 7136 | 0, gn(Go, Go, we + 7576 | 0), o = a[we + 7140 >> 2], Gr = o, Qe = a[we + 7136 >> 2], Be = Qe, d = o << 1 | Be >>> 31, Dr = we - -64 | 0, Oi = a[we + 7160 >> 2], $r = a[we + 7164 >> 2], Kn = Be << 1, $i = d, Lr(Dr, Oi, $r, 0, 0, Kn, d, 0, 0), o = a[we + 7148 >> 2], Io = o, xo = a[we + 7144 >> 2], v = xo, d = o << 1 | v >>> 31, wr = we + 272 | 0, un = a[we + 7152 >> 2], ni = a[we + 7156 >> 2], v = v << 1, he = d, Lr(wr, un, ni, 0, 0, v, d, 0, 0), fr = we + 224 | 0, Me = a[we + 7168 >> 2], o = a[we + 7172 >> 2], Lr(fr, Me, o, 0, 0, Me, o, 0, 0), dr = we + 208 | 0, Lr(dr, a[we + 224 >> 2], a[we + 228 >> 2], 0, 0, 15632, 16, 0, 0), d = o << 1 | Me >>> 31, Oo = we + 176 | 0, zi = Me << 1, Si = d, Lr(Oo, zi, d, 0, 0, Be, Gr, 0, 0), Xn = we + 80 | 0, Lr(Xn, Oi, $r, 0, 0, v, he, 0, 0), yo = we + 256 | 0, Lr(yo, un, ni, 0, 0, un, ni, 0, 0), Rr = we + 192 | 0, o = fr + 8 | 0, Lr(Rr, a[o >> 2], a[o + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Ho = we + 320 | 0, Lr(Ho, Be, Gr, 0, 0, Be, Gr, 0, 0), Mo = we + 160 | 0, Lr(Mo, zi, d, 0, 0, xo, Io, 0, 0), qi = we + 96 | 0, Lr(qi, Oi, $r, 0, 0, un << 1, ni << 1 | un >>> 31, 0, 0), Qe = a[we + 68 >> 2], d = Qe + a[we + 276 >> 2] | 0, Me = a[we + 64 >> 2], v = a[we + 272 >> 2], o = Me + v | 0, he = a[we + 208 >> 2], Fr = o + he | 0, v = o >>> 0 < v >>> 0 ? d + 1 | 0 : d, d = v + a[we + 212 >> 2] | 0, he = he >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, fr = (v | 0) == (he | 0) & o >>> 0 > Fr >>> 0 | v >>> 0 > he >>> 0, d = dr + 8 | 0, dr = a[d >> 2], Be = a[d + 4 >> 2], Me = (v | 0) == (Qe | 0) & o >>> 0 < Me >>> 0 | v >>> 0 < Qe >>> 0, d = wr + 8 | 0, v = a[d >> 2], o = Dr + 8 | 0, wr = v + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 > wr >>> 0 ? d + 1 | 0 : d, o = Me + wr | 0, d = (o >>> 0 < wr >>> 0 ? d + 1 | 0 : d) + Be | 0, v = o, o = o + dr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + fr | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Gr = he, Be = o << 12 | he >>> 20, v = d, Me = d << 12 | o >>> 20, Vn = a[we + 80 >> 2], o = a[we + 256 >> 2], wr = Vn + o | 0, uo = a[we + 84 >> 2], d = uo + a[we + 260 >> 2] | 0, d = o >>> 0 > wr >>> 0 ? d + 1 | 0 : d, o = a[we + 176 >> 2], fr = o + wr | 0, Qe = d, d = d + a[we + 180 >> 2] | 0, d = o >>> 0 > fr >>> 0 ? d + 1 | 0 : d, o = a[we + 192 >> 2], he = o + fr | 0, Dr = d, d = d + a[we + 196 >> 2] | 0, o = o >>> 0 > he >>> 0 ? d + 1 | 0 : d, d = o + Me | 0, Me = we, dr = he + Be | 0, Be = dr >>> 0 < he >>> 0 ? d + 1 | 0 : d, Sn = (o | 0) == (Be | 0) & he >>> 0 > dr >>> 0 | o >>> 0 > Be >>> 0, In = (o | 0) == (Dr | 0) & he >>> 0 < fr >>> 0 | o >>> 0 < Dr >>> 0, o = Rr + 8 | 0, mi = a[o >> 2], Ti = a[o + 4 >> 2], we = (Dr | 0) == (Qe | 0) & fr >>> 0 < wr >>> 0 | Dr >>> 0 < Qe >>> 0, o = Oo + 8 | 0, Rr = a[o >> 2], Dr = a[o + 4 >> 2], fr = (Qe | 0) == (uo | 0) & wr >>> 0 < Vn >>> 0 | Qe >>> 0 < uo >>> 0, d = yo + 8 | 0, he = a[d >> 2], o = Xn + 8 | 0, wr = he + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = he >>> 0 > wr >>> 0 ? d + 1 | 0 : d, o = fr + wr | 0, d = (o >>> 0 < wr >>> 0 ? d + 1 | 0 : d) + Dr | 0, he = o, o = o + Rr | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, he = o, o = o + we | 0, d = (he >>> 0 > o >>> 0 ? d + 1 | 0 : d) + Ti | 0, he = o, o = o + mi | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, he = o + In | 0, d = he >>> 0 < o >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = v + he | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Sn | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = Be, wr = o << 12 | v >>> 20, he = d, fr = d << 12 | o >>> 20, Rr = a[Me + 160 >> 2], o = a[Me + 96 >> 2], Be = Rr + o | 0, mi = a[Me + 164 >> 2], d = mi + a[Me + 100 >> 2] | 0, o = o >>> 0 > Be >>> 0 ? d + 1 | 0 : d, d = o + fr | 0, Dr = Be, Be = Be + wr | 0, Qe = Be << 4 & -16, fr = Be >>> 0 < Dr >>> 0 ? d + 1 | 0 : d, wr = (fr << 4 | Be >>> 28) & 16777215, we = v, Lr(Me, Qe | v >>> 16 & 15, wr, 0, 0, 977, 1, 0, 0), Sn = a[Me + 4 >> 2], d = Sn + a[Me + 324 >> 2] | 0, In = a[Me >> 2], v = a[Me + 320 >> 2], wr = In + v | 0, a[Me + 7136 >> 2] = wr, v = v >>> 0 > wr >>> 0 ? d + 1 | 0 : d, a[Me + 7140 >> 2] = v & 1048575, uo = Me + 304 | 0, Lr(uo, xo, Io, 0, 0, Kn, $i, 0, 0), Oo = Me + 144 | 0, Lr(Oo, zi, Si, 0, 0, un, ni, 0, 0), Xn = Me + 112 | 0, Lr(Xn, Oi, $r, 0, 0, Oi, $r, 0, 0), yo = Me + 48 | 0, Ti = yo, Qe = (o | 0) == (fr | 0) & Be >>> 0 < Dr >>> 0 | o >>> 0 > fr >>> 0, Dr = (o | 0) == (mi | 0) & Dr >>> 0 < Rr >>> 0 | o >>> 0 < mi >>> 0, d = qi + 8 | 0, Be = a[d >> 2], o = Mo + 8 | 0, Rr = Be + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = Be >>> 0 > Rr >>> 0 ? d + 1 | 0 : d, Be = Dr + Rr | 0, d = Be >>> 0 < Rr >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, o = he + Be | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, he = o, o = o + Qe | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, Dr = o << 12 | fr >>> 20, Be = d, fr = d << 12 | o >>> 20, Mo = a[Me + 148 >> 2], d = Mo + a[Me + 116 >> 2] | 0, Vn = a[Me + 144 >> 2], he = a[Me + 112 >> 2], o = Vn + he | 0, mi = o, Rr = o + Dr | 0, he = o >>> 0 < he >>> 0 ? d + 1 | 0 : d, d = he + fr | 0, Dr = Rr >>> 0 < o >>> 0 ? d + 1 | 0 : d, Lr(Ti, Rr, Dr & 1048575, 0, 0, 15632, 16, 0, 0), fr = Me, wr = (v | 0) == (Sn | 0) & wr >>> 0 < In >>> 0 | v >>> 0 < Sn >>> 0, d = Ho + 8 | 0, Me = a[d >> 2], o = fr + 8 | 0, Qe = Me + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = Me >>> 0 > Qe >>> 0 ? d + 1 | 0 : d, o = wr + Qe | 0, d = o >>> 0 < Qe >>> 0 ? d + 1 | 0 : d, Qe = o << 12 | v >>> 20, Me = d, wr = d << 12 | o >>> 20, Sn = a[fr + 48 >> 2], o = a[fr + 304 >> 2], Ti = Sn + o | 0, qi = a[fr + 52 >> 2], d = qi + a[fr + 308 >> 2] | 0, v = o >>> 0 > Ti >>> 0 ? d + 1 | 0 : d, d = v + wr | 0, Qe = Qe + Ti | 0, d = Qe >>> 0 < Ti >>> 0 ? d + 1 | 0 : d, a[fr + 7144 >> 2] = Qe, wr = d, a[fr + 7148 >> 2] = d & 1048575, In = fr + 240 | 0, Lr(In, un, ni, 0, 0, Kn, $i, 0, 0), $i = fr + 288 | 0, Lr($i, xo, Io, 0, 0, xo, Io, 0, 0), Kn = fr + 128 | 0, Lr(Kn, zi, Si, 0, 0, Oi, $r, 0, 0), un = fr + 32 | 0, Oi = un, ni = (he | 0) == (Dr | 0) & Rr >>> 0 < mi >>> 0 | he >>> 0 > Dr >>> 0, Rr = (he | 0) == (Mo | 0) & mi >>> 0 < Vn >>> 0 | he >>> 0 < Mo >>> 0, d = Xn + 8 | 0, he = a[d >> 2], o = Oo + 8 | 0, $r = he + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = he >>> 0 > $r >>> 0 ? d + 1 | 0 : d, he = Rr + $r | 0, d = he >>> 0 < $r >>> 0 ? d + 1 | 0 : d, Be = Be >>> 20 | 0, o = he + Be | 0, d = Be >>> 0 > o >>> 0 ? d + 1 | 0 : d, he = o, o = o + ni | 0, d = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, $r = o << 12 | Dr >>> 20, Be = a[fr + 128 >> 2], Dr = $r + Be | 0, he = d, mi = d << 12 | o >>> 20, d = mi + a[fr + 132 >> 2] | 0, Rr = Be >>> 0 > Dr >>> 0 ? d + 1 | 0 : d, Lr(Oi, Dr, Rr, 0, 0, 15632, 16, 0, 0), Be = fr, Qe = (v | 0) == (wr | 0) & Qe >>> 0 < Ti >>> 0 | v >>> 0 > wr >>> 0, fr = (v | 0) == (qi | 0) & Ti >>> 0 < Sn >>> 0 | v >>> 0 < qi >>> 0, d = uo + 8 | 0, v = a[d >> 2], o = yo + 8 | 0, ni = v + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 > ni >>> 0 ? d + 1 | 0 : d, v = fr + ni | 0, d = v >>> 0 < ni >>> 0 ? d + 1 | 0 : d, Me = Me >>> 20 | 0, o = v + Me | 0, d = Me >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Qe | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, fr = o << 12 | wr >>> 20, v = d, Me = d << 12 | o >>> 20, Ti = a[Be + 240 >> 2], o = a[Be + 288 >> 2], Qe = Ti + o | 0, Si = a[Be + 244 >> 2], d = Si + a[Be + 292 >> 2] | 0, d = o >>> 0 > Qe >>> 0 ? d + 1 | 0 : d, o = a[Be + 32 >> 2], wr = o + Qe | 0, ni = d, d = d + a[Be + 36 >> 2] | 0, o = o >>> 0 > wr >>> 0 ? d + 1 | 0 : d, d = o + Me | 0, fr = fr + wr | 0, d = fr >>> 0 < wr >>> 0 ? d + 1 | 0 : d, a[Be + 7152 >> 2] = fr, Me = d, a[Be + 7156 >> 2] = d & 1048575, Oi = Be + 16 | 0, $r = (Rr | 0) == (mi | 0) & Dr >>> 0 < $r >>> 0 | Rr >>> 0 < mi >>> 0, d = Kn + 8 | 0, Rr = a[d >> 2], d = a[d + 4 >> 2], he = he >>> 20 | 0, Dr = he, he = he + Rr | 0, d = Dr >>> 0 > he >>> 0 ? d + 1 | 0 : d, Dr = he, he = he + $r | 0, d = Dr >>> 0 > he >>> 0 ? d + 1 | 0 : d, Lr(Oi, he, d, 0, 0, 64028672, 65536, 0, 0), he = Be, $r = (o | 0) == (Me | 0) & fr >>> 0 < wr >>> 0 | o >>> 0 > Me >>> 0, Rr = (o | 0) == (ni | 0) & wr >>> 0 < Qe >>> 0 | o >>> 0 < ni >>> 0, o = un + 8 | 0, Dr = a[o >> 2], wr = a[o + 4 >> 2], fr = (ni | 0) == (Si | 0) & Qe >>> 0 < Ti >>> 0 | ni >>> 0 < Si >>> 0, d = $i + 8 | 0, Be = a[d >> 2], o = In + 8 | 0, Qe = Be + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = Be >>> 0 > Qe >>> 0 ? d + 1 | 0 : d, o = fr + Qe | 0, d = (o >>> 0 < Qe >>> 0 ? d + 1 | 0 : d) + wr | 0, Be = o, o = o + Dr | 0, d = Be >>> 0 > o >>> 0 ? d + 1 | 0 : d, Be = o + Rr | 0, d = Be >>> 0 < o >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = v + Be | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + $r | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, Be = o << 12 | Me >>> 20, v = d, wr = d << 12 | o >>> 20, Qe = a[he + 16 >> 2], Me = Fr & -2, o = Qe + Me | 0, Rr = a[he + 20 >> 2], d = Rr + (Gr & 1048575) | 0, fr = o >>> 0 < Me >>> 0 ? d + 1 | 0 : d, d = fr + wr | 0, Me = Be, Be = o, Me = Me + o | 0, a[he + 7160 >> 2] = Me, o = o >>> 0 > Me >>> 0 ? d + 1 | 0 : d, a[he + 7164 >> 2] = o & 1048575, Gr = he, Dr = we & 65535, wr = (o | 0) == (fr | 0) & Be >>> 0 > Me >>> 0 | o >>> 0 < fr >>> 0, he = (fr | 0) == (Rr | 0) & Be >>> 0 < Qe >>> 0 | fr >>> 0 < Rr >>> 0, d = Oi + 8 | 0, Me = he + a[d >> 2] | 0, d = a[d + 4 >> 2], d = he >>> 0 > Me >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, he = v, v = v + Me | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + wr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, o = v << 12 | o >>> 20, he = o + dr | 0, d = Dr + (d << 12 | v >>> 20) | 0, a[Gr + 7168 >> 2] = he, a[Gr + 7172 >> 2] = o >>> 0 > he >>> 0 ? d + 1 | 0 : d, o = B + 40 | 0, na(o, Go), na(Go, o), d = a[Gr + 7080 >> 2], o = a[Gr + 7160 >> 2], ni = d - o | 0, Fr = a[Gr + 7084 >> 2] - (a[Gr + 7164 >> 2] + (o >>> 0 > d >>> 0) | 0) | 0, d = a[Gr + 7072 >> 2], o = a[Gr + 7152 >> 2], we = d - o | 0, Rr = a[Gr + 7076 >> 2] - (a[Gr + 7156 >> 2] + (o >>> 0 > d >>> 0) | 0) | 0, d = a[Gr + 7064 >> 2], o = a[Gr + 7144 >> 2], fr = d - o | 0, dr = a[Gr + 7068 >> 2] - (a[Gr + 7148 >> 2] + (o >>> 0 > d >>> 0) | 0) | 0, d = a[Gr + 7056 >> 2], o = a[Gr + 7136 >> 2], Be = d - o | 0, he = a[Gr + 7060 >> 2] - (a[Gr + 7140 >> 2] + (o >>> 0 > d >>> 0) | 0) | 0, v = a[Gr + 7088 >> 2], d = a[Gr + 7168 >> 2], o = (v - d | 0) - 4 | 0, d = (a[Gr + 7092 >> 2] - (a[Gr + 7172 >> 2] + (d >>> 0 > v >>> 0) | 0) | 0) + 262143 | 0, Me = o >>> 0 < 4294967292 ? d + 1 | 0 : d, v = oi(Me >>> 16 | 0, 0, 977, 1), Be = v + Be | 0, d = he + Fe | 0, d = (v >>> 0 > Be >>> 0 ? d + 1 | 0 : d) + 4194299 | 0, v = Be - 3908 | 0, d = v >>> 0 < 4294963388 ? d + 1 | 0 : d, Qe = v, Dr = d, d = dr, v = Dr >>> 20 | 0, he = v, v = v + fr | 0, d = (he >>> 0 > v >>> 0 ? d + 1 | 0 : d) + 4194303 | 0, v = v - 4 | 0, d = v >>> 0 < 4294967292 ? d + 1 | 0 : d, wr = v, fr = d, d = Rr, v = fr >>> 20 | 0, he = v, v = v + we | 0, d = (he >>> 0 > v >>> 0 ? d + 1 | 0 : d) + 4194303 | 0, v = v - 4 | 0, d = v >>> 0 < 4294967292 ? d + 1 | 0 : d, dr = v, Be = d, d = Fr, v = Be >>> 20 | 0, he = v, v = v + ni | 0, d = (he >>> 0 > v >>> 0 ? d + 1 | 0 : d) + 4194303 | 0, he = v - 4 | 0, v = he >>> 0 < 4294967292 ? d + 1 | 0 : d, Rr = Me & 65535, Me = he, d = Rr, he = v >>> 20 | 0, Fr = he, he = o + he | 0, d = Fr >>> 0 > he >>> 0 ? d + 1 | 0 : d;
    e: {
      if (he | (Me | (wr | Qe | dr)) | (d | (fr | Dr | Be | v) & 1048575) && (o = 0, (wr & (Qe ^ 976) & dr & Me & he) != -1 ? d = 1 : d = (fr & (Dr ^ 1) & Be & v & (d ^ 983040)) != 1048575, d) || (o = B + 48 | 0, dr = a[o >> 2], Me = a[o + 4 >> 2], v = a[B + 44 >> 2], o = B + 72 | 0, wr = a[o >> 2], o = a[o + 4 >> 2], Fr = o, d = a[B + 40 >> 2], o = oi(o >>> 16 | 0, 0, 977, 1), Be = d + o | 0, d = v + Fe | 0, Rr = o >>> 0 > Be >>> 0 ? d + 1 | 0 : d, d = Me, o = Rr >>> 20 | 0, Me = o + dr | 0, o = o >>> 0 > Me >>> 0 ? d + 1 | 0 : d, Qe = o & 1048575, d = B - -64 | 0, Dr = a[d >> 2], fr = a[d + 4 >> 2], d = B + 56 | 0, he = a[d >> 2], d = a[d + 4 >> 2], dr = o >>> 20 | 0, v = he + dr | 0, dr = dr >>> 0 > v >>> 0 ? d + 1 | 0 : d, d = fr, he = dr >>> 20 | 0, fr = he, he = he + Dr | 0, d = fr >>> 0 > he >>> 0 ? d + 1 | 0 : d, Dr = d & 1048575, fr = dr & 1048575, we = (v & Me & he) == -1 & (o & fr & d) == 1048575, o = d, d = Fr & 65535, o = o >>> 20 | 0, dr = o + wr | 0, d = o >>> 0 > dr >>> 0 ? d + 1 | 0 : d, wr = d, Rr = Rr & 1048575, we & ((dr | 0) == -1 & (d | 0) == 65535) & ((Rr | 0) == 1048574 & Be >>> 0 > 4294966318 | Rr >>> 0 > 1048574) | d >>> 16 && (d = Rr + 1 | 0, Be = Be + 977 | 0, d = Be >>> 0 < 977 ? d + 1 | 0 : d, Rr = d & 1048575, o = d, d = Qe, o = o >>> 20 | 0, Me = o + Me | 0, d = o >>> 0 > Me >>> 0 ? d + 1 | 0 : d, Qe = d & 1048575, o = d, d = fr, o = o >>> 20 | 0, v = o + v | 0, d = o >>> 0 > v >>> 0 ? d + 1 | 0 : d, fr = d & 1048575, o = d, d = Dr, o = o >>> 20 | 0, he = o + he | 0, d = o >>> 0 > he >>> 0 ? d + 1 | 0 : d, Dr = d & 1048575, o = d, d = wr, Fr = dr, dr = (o >>> 20 | 0) + dr | 0, wr = (Fr >>> 0 > dr >>> 0 ? d + 1 | 0 : d) & 65535), a[B + 72 >> 2] = dr, a[B + 76 >> 2] = wr, a[B + 64 >> 2] = he, a[B + 68 >> 2] = Dr, a[B + 56 >> 2] = v, a[B + 60 >> 2] = fr, a[B + 48 >> 2] = Me, a[B + 52 >> 2] = Qe, a[B + 40 >> 2] = Be, a[B + 44 >> 2] = Rr, o = 1, (Be & 1) == (m | 0)))
        break e;
      a[B + 72 >> 2] = -4 - dr, a[B + 76 >> 2] = 262143 - ((dr >>> 0 > 4294967292) + wr | 0), a[B + 64 >> 2] = -4 - he, a[B + 68 >> 2] = 4194303 - ((he >>> 0 > 4294967292) + Dr | 0), a[B + 56 >> 2] = -4 - v, a[B + 60 >> 2] = 4194303 - ((v >>> 0 > 4294967292) + fr | 0), a[B + 48 >> 2] = -4 - Me, a[B + 52 >> 2] = 4194303 - ((Me >>> 0 > 4294967292) + Qe | 0), a[B + 40 >> 2] = -3908 - Be, a[B + 44 >> 2] = 4194299 - ((Be >>> 0 > 4294963388) + Rr | 0);
    }
    return be = Gr + 7616 | 0, o;
  }
  function gn(B, o, m) {
    var d = 0, v = 0, he = 0, we = 0, Be = 0, Me = 0, fr = 0, wr = 0, dr = 0, Dr = 0, Rr = 0, Qe = 0, Fr = 0, Gr = 0, $r = 0, ni = 0, mi = 0, Si = 0, Oi = 0, $i = 0, zi = 0, un = 0, In = 0, Ti = 0, Sn = 0, Kn = 0, Vn = 0, Xn = 0, uo = 0, yo = 0, Io = 0, xo = 0, Mo = 0, qi = 0, Oo = 0, Ho = 0, Go = 0, ns = 0, ds = 0, Ts = 0, Ao = 0, po = 0, _o = 0, Uo = 0, ts = 0, Lo = 0, Wo = 0, ps = 0, Bs = 0, Xs = 0, js = 0, ya = 0, sa = 0, va = 0, oa = 0, wa = 0, Pa = 0, Ta = 0, jn = 0, ta = 0, Na = 0, ba = 0;
    d = be - 496 | 0, be = d, mi = d - -64 | 0, uo = a[m + 24 >> 2], yo = a[m + 28 >> 2], Io = a[o >> 2], xo = a[o + 4 >> 2], Lr(mi, uo, yo, 0, 0, Io, xo, 0, 0), Oi = d + 208 | 0, Mo = a[m + 16 >> 2], qi = a[m + 20 >> 2], Oo = a[o + 8 >> 2], Ho = a[o + 12 >> 2], Lr(Oi, Mo, qi, 0, 0, Oo, Ho, 0, 0), Gr = d + 320 | 0, Go = a[m + 8 >> 2], ns = a[m + 12 >> 2], ds = a[o + 16 >> 2], Ts = a[o + 20 >> 2], Lr(Gr, Go, ns, 0, 0, ds, Ts, 0, 0), wr = d + 400 | 0, Ao = a[m >> 2], po = a[m + 4 >> 2], _o = a[o + 24 >> 2], Uo = a[o + 28 >> 2], Lr(wr, Ao, po, 0, 0, _o, Uo, 0, 0), v = d + 480 | 0, ts = a[m + 32 >> 2], Lo = a[m + 36 >> 2], Wo = a[o + 32 >> 2], un = a[o + 36 >> 2], Lr(v, ts, Lo, 0, 0, Wo, un, 0, 0), fr = d + 464 | 0, Lr(fr, a[d + 480 >> 2], a[d + 484 >> 2], 0, 0, 15632, 16, 0, 0), Si = d + 80 | 0, Lr(Si, ts, Lo, 0, 0, Io, xo, 0, 0), ps = d + 144 | 0, Lr(ps, uo, yo, 0, 0, Oo, Ho, 0, 0), Bs = d + 272 | 0, Lr(Bs, Mo, qi, 0, 0, ds, Ts, 0, 0), Xs = d + 368 | 0, Lr(Xs, Go, ns, 0, 0, _o, Uo, 0, 0), Ti = d + 432 | 0, Lr(Ti, Ao, po, 0, 0, Wo, un, 0, 0), Fr = d + 448 | 0, o = v + 8 | 0, Lr(Fr, a[o >> 2], a[o + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), js = d + 96 | 0, Lr(js, Ao, po, 0, 0, Io, xo, 0, 0), ya = d + 224 | 0, Lr(ya, ts, Lo, 0, 0, Oo, Ho, 0, 0), sa = d + 160 | 0, Lr(sa, uo, yo, 0, 0, ds, Ts, 0, 0), va = d + 288 | 0, Lr(va, Mo, qi, 0, 0, _o, Uo, 0, 0), Kn = d + 384 | 0, Lr(Kn, Go, ns, 0, 0, Wo, un, 0, 0), Qe = a[d + 208 >> 2], m = a[d + 64 >> 2], ni = Qe + m | 0, $r = a[d + 212 >> 2], o = $r + a[d + 68 >> 2] | 0, o = m >>> 0 > ni >>> 0 ? o + 1 | 0 : o, m = a[d + 320 >> 2], Me = m + ni | 0, v = o, o = o + a[d + 324 >> 2] | 0, Be = m >>> 0 > Me >>> 0 ? o + 1 | 0 : o, o = Be + a[d + 404 >> 2] | 0, m = a[d + 400 >> 2], we = m + Me | 0, he = a[d + 464 >> 2], oa = we + he | 0, m = m >>> 0 > we >>> 0 ? o + 1 | 0 : o, o = m + a[d + 468 >> 2] | 0, he = he >>> 0 > oa >>> 0 ? o + 1 | 0 : o, Dr = (m | 0) == (he | 0) & we >>> 0 > oa >>> 0 | m >>> 0 > he >>> 0, o = fr + 8 | 0, wa = a[o >> 2], Sn = a[o + 4 >> 2], dr = (m | 0) == (Be | 0) & Me >>> 0 > we >>> 0 | m >>> 0 < Be >>> 0, o = wr + 8 | 0, Rr = a[o >> 2], wr = a[o + 4 >> 2], fr = (v | 0) == (Be | 0) & Me >>> 0 < ni >>> 0 | v >>> 0 > Be >>> 0, o = Gr + 8 | 0, Be = a[o >> 2], Me = a[o + 4 >> 2], we = (v | 0) == ($r | 0) & Qe >>> 0 > ni >>> 0 | v >>> 0 < $r >>> 0, v = mi + 8 | 0, m = a[v >> 2], o = Oi + 8 | 0, ni = m + a[o >> 2] | 0, o = a[o + 4 >> 2] + a[v + 4 >> 2] | 0, o = m >>> 0 > ni >>> 0 ? o + 1 | 0 : o, m = we + ni | 0, o = (m >>> 0 < ni >>> 0 ? o + 1 | 0 : o) + Me | 0, v = m, m = m + Be | 0, o = v >>> 0 > m >>> 0 ? o + 1 | 0 : o, v = m, m = m + fr | 0, o = (v >>> 0 > m >>> 0 ? o + 1 | 0 : o) + wr | 0, v = m, m = m + Rr | 0, o = v >>> 0 > m >>> 0 ? o + 1 | 0 : o, v = m, m = m + dr | 0, o = (v >>> 0 > m >>> 0 ? o + 1 | 0 : o) + Sn | 0, v = m, m = m + wa | 0, o = v >>> 0 > m >>> 0 ? o + 1 | 0 : o, v = m, m = m + Dr | 0, o = v >>> 0 > m >>> 0 ? o + 1 | 0 : o, wa = he, ni = m << 12 | he >>> 20, v = o, we = o << 12 | m >>> 20, $i = a[d + 272 >> 2], m = a[d + 144 >> 2], wr = $i + m | 0, Vn = a[d + 276 >> 2], o = Vn + a[d + 148 >> 2] | 0, o = m >>> 0 > wr >>> 0 ? o + 1 | 0 : o, m = a[d + 368 >> 2], fr = m + wr | 0, Dr = o, o = o + a[d + 372 >> 2] | 0, o = m >>> 0 > fr >>> 0 ? o + 1 | 0 : o, m = a[d + 432 >> 2], Be = m + fr | 0, Sn = o, o = o + a[d + 436 >> 2] | 0, o = m >>> 0 > Be >>> 0 ? o + 1 | 0 : o, m = a[d + 80 >> 2], Me = m + Be | 0, dr = o, o = o + a[d + 84 >> 2] | 0, o = m >>> 0 > Me >>> 0 ? o + 1 | 0 : o, m = a[d + 448 >> 2], he = m + Me | 0, Rr = o, o = o + a[d + 452 >> 2] | 0, m = m >>> 0 > he >>> 0 ? o + 1 | 0 : o, o = m + we | 0, ni = he + ni | 0, we = ni >>> 0 < he >>> 0 ? o + 1 | 0 : o, In = (m | 0) == (we | 0) & he >>> 0 > ni >>> 0 | m >>> 0 > we >>> 0, zi = (m | 0) == (Rr | 0) & he >>> 0 < Me >>> 0 | m >>> 0 < Rr >>> 0, o = Fr + 8 | 0, $r = a[o >> 2], mi = a[o + 4 >> 2], Oi = (dr | 0) == (Rr | 0) & Me >>> 0 < Be >>> 0 | dr >>> 0 > Rr >>> 0, o = Si + 8 | 0, Gr = a[o >> 2], Si = a[o + 4 >> 2], Fr = (dr | 0) == (Sn | 0) & Be >>> 0 < fr >>> 0 | dr >>> 0 < Sn >>> 0, o = Ti + 8 | 0, Qe = a[o >> 2], dr = a[o + 4 >> 2], Rr = (Dr | 0) == (Sn | 0) & wr >>> 0 > fr >>> 0 | Dr >>> 0 > Sn >>> 0, o = Xs + 8 | 0, fr = a[o >> 2], Be = a[o + 4 >> 2], Me = (Dr | 0) == (Vn | 0) & wr >>> 0 < $i >>> 0 | Dr >>> 0 < Vn >>> 0, he = ps + 8 | 0, m = a[he >> 2], o = Bs + 8 | 0, wr = m + a[o >> 2] | 0, o = a[o + 4 >> 2] + a[he + 4 >> 2] | 0, o = m >>> 0 > wr >>> 0 ? o + 1 | 0 : o, m = Me + wr | 0, o = (m >>> 0 < wr >>> 0 ? o + 1 | 0 : o) + Be | 0, he = m, m = m + fr | 0, o = he >>> 0 > m >>> 0 ? o + 1 | 0 : o, he = m, m = m + Rr | 0, o = (he >>> 0 > m >>> 0 ? o + 1 | 0 : o) + dr | 0, he = m, m = m + Qe | 0, o = he >>> 0 > m >>> 0 ? o + 1 | 0 : o, he = m, m = m + Fr | 0, o = (he >>> 0 > m >>> 0 ? o + 1 | 0 : o) + Si | 0, he = m, m = m + Gr | 0, o = he >>> 0 > m >>> 0 ? o + 1 | 0 : o, he = m, m = m + Oi | 0, o = (he >>> 0 > m >>> 0 ? o + 1 | 0 : o) + mi | 0, he = m, m = m + $r | 0, o = he >>> 0 > m >>> 0 ? o + 1 | 0 : o, he = m + zi | 0, o = he >>> 0 < m >>> 0 ? o + 1 | 0 : o, v = v >>> 20 | 0, m = v + he | 0, o = v >>> 0 > m >>> 0 ? o + 1 | 0 : o, v = m, m = m + In | 0, o = v >>> 0 > m >>> 0 ? o + 1 | 0 : o, v = we, Me = m << 12 | v >>> 20, he = o, we = o << 12 | m >>> 20, zi = a[d + 288 >> 2], m = a[d + 160 >> 2], dr = zi + m | 0, $i = a[d + 292 >> 2], o = $i + a[d + 164 >> 2] | 0, o = m >>> 0 > dr >>> 0 ? o + 1 | 0 : o, m = a[d + 384 >> 2], Rr = m + dr | 0, Qe = o, o = o + a[d + 388 >> 2] | 0, o = m >>> 0 > Rr >>> 0 ? o + 1 | 0 : o, m = a[d + 224 >> 2], wr = m + Rr | 0, Dr = o, o = o + a[d + 228 >> 2] | 0, m = m >>> 0 > wr >>> 0 ? o + 1 | 0 : o, o = m + we | 0, Me = Me + wr | 0, o = Me >>> 0 < wr >>> 0 ? o + 1 | 0 : o, fr = Me << 4 & -16, we = o, Be = (o << 4 | Me >>> 28) & 16777215, Sn = v, Lr(d, fr | v >>> 16 & 15, Be, 0, 0, 977, 1, 0, 0), In = a[d + 4 >> 2], o = In + a[d + 100 >> 2] | 0, Be = B, $r = a[d >> 2], B = a[d + 96 >> 2], fr = $r + B | 0, a[Be >> 2] = fr, v = B >>> 0 > fr >>> 0 ? o + 1 | 0 : o, a[Be + 4 >> 2] = v & 1048575, jn = d + 112 | 0, Lr(jn, Go, ns, 0, 0, Io, xo, 0, 0), ta = d + 240 | 0, Lr(ta, Ao, po, 0, 0, Oo, Ho, 0, 0), Na = d + 336 | 0, Lr(Na, ts, Lo, 0, 0, ds, Ts, 0, 0), Xn = d + 176 | 0, Lr(Xn, uo, yo, 0, 0, _o, Uo, 0, 0), Ti = d + 304 | 0, Lr(Ti, Mo, qi, 0, 0, Wo, un, 0, 0), ba = d + 48 | 0, mi = ba, Oi = (m | 0) == (we | 0) & Me >>> 0 < wr >>> 0 | m >>> 0 > we >>> 0, Gr = (m | 0) == (Dr | 0) & wr >>> 0 < Rr >>> 0 | m >>> 0 < Dr >>> 0, B = ya + 8 | 0, Si = a[B >> 2], Fr = a[B + 4 >> 2], Dr = (Dr | 0) == (Qe | 0) & dr >>> 0 > Rr >>> 0 | Dr >>> 0 < Qe >>> 0, B = Kn + 8 | 0, Rr = a[B >> 2], wr = a[B + 4 >> 2], Me = (Qe | 0) == ($i | 0) & dr >>> 0 < zi >>> 0 | Qe >>> 0 < $i >>> 0, o = sa + 8 | 0, m = a[o >> 2], B = va + 8 | 0, dr = m + a[B >> 2] | 0, o = a[B + 4 >> 2] + a[o + 4 >> 2] | 0, o = m >>> 0 > dr >>> 0 ? o + 1 | 0 : o, B = Me + dr | 0, o = (B >>> 0 < dr >>> 0 ? o + 1 | 0 : o) + wr | 0, m = B, B = B + Rr | 0, o = m >>> 0 > B >>> 0 ? o + 1 | 0 : o, m = B, B = B + Dr | 0, o = (m >>> 0 > B >>> 0 ? o + 1 | 0 : o) + Fr | 0, m = B, B = B + Si | 0, o = m >>> 0 > B >>> 0 ? o + 1 | 0 : o, m = B + Gr | 0, o = m >>> 0 < B >>> 0 ? o + 1 | 0 : o, he = he >>> 20 | 0, B = m + he | 0, o = he >>> 0 > B >>> 0 ? o + 1 | 0 : o, m = B, B = B + Oi | 0, o = m >>> 0 > B >>> 0 ? o + 1 | 0 : o, he = B << 12 | we >>> 20, Me = o, m = o << 12 | B >>> 20, Kn = a[d + 304 >> 2], B = a[d + 176 >> 2], Qe = Kn + B | 0, Pa = a[d + 308 >> 2], o = Pa + a[d + 180 >> 2] | 0, o = B >>> 0 > Qe >>> 0 ? o + 1 | 0 : o, B = a[d + 336 >> 2], Dr = B + Qe | 0, Fr = o, o = o + a[d + 340 >> 2] | 0, we = B >>> 0 > Dr >>> 0 ? o + 1 | 0 : o, o = we + m | 0, dr = he + Dr | 0, o = dr >>> 0 < Dr >>> 0 ? o + 1 | 0 : o, wr = o, Lr(mi, dr, o & 1048575, 0, 0, 15632, 16, 0, 0), he = (v | 0) == (In | 0) & fr >>> 0 < $r >>> 0 | v >>> 0 < In >>> 0, o = js + 8 | 0, m = a[o >> 2], B = d + 8 | 0, fr = m + a[B >> 2] | 0, o = a[B + 4 >> 2] + a[o + 4 >> 2] | 0, o = m >>> 0 > fr >>> 0 ? o + 1 | 0 : o, B = he + fr | 0, o = B >>> 0 < fr >>> 0 ? o + 1 | 0 : o, Rr = B << 12 | v >>> 20, he = o, fr = o << 12 | B >>> 20, Vn = a[d + 240 >> 2], B = a[d + 112 >> 2], Gr = Vn + B | 0, Ta = a[d + 244 >> 2], o = Ta + a[d + 116 >> 2] | 0, zi = B >>> 0 > Gr >>> 0 ? o + 1 | 0 : o, o = zi + a[d + 52 >> 2] | 0, m = a[d + 48 >> 2], B = m + Gr | 0, Oi = B, Rr = B + Rr | 0, v = B >>> 0 < m >>> 0 ? o + 1 | 0 : o, o = v + fr | 0, a[Be + 8 >> 2] = Rr, fr = Rr >>> 0 < B >>> 0 ? o + 1 | 0 : o, a[Be + 12 >> 2] = fr & 1048575, ps = d + 128 | 0, Lr(ps, Mo, qi, 0, 0, Io, xo, 0, 0), Bs = d + 256 | 0, Lr(Bs, Go, ns, 0, 0, Oo, Ho, 0, 0), Xs = d + 352 | 0, Lr(Xs, Ao, po, 0, 0, ds, Ts, 0, 0), js = d + 416 | 0, Lr(js, ts, Lo, 0, 0, _o, Uo, 0, 0), ya = d + 192 | 0, Lr(ya, uo, yo, 0, 0, Wo, un, 0, 0), sa = d + 32 | 0, $i = sa, va = a[d + 416 >> 2], B = a[d + 192 >> 2], Si = va + B | 0, un = a[d + 420 >> 2], o = un + a[d + 196 >> 2] | 0, m = B >>> 0 > Si >>> 0 ? o + 1 | 0 : o, In = (we | 0) == (wr | 0) & dr >>> 0 < Dr >>> 0 | we >>> 0 > wr >>> 0, $r = (we | 0) == (Fr | 0) & Dr >>> 0 < Qe >>> 0 | we >>> 0 < Fr >>> 0, B = Na + 8 | 0, mi = a[B >> 2], Dr = a[B + 4 >> 2], dr = (Fr | 0) == (Pa | 0) & Qe >>> 0 < Kn >>> 0 | Fr >>> 0 < Pa >>> 0, o = Xn + 8 | 0, we = a[o >> 2], B = Ti + 8 | 0, Qe = we + a[B >> 2] | 0, o = a[B + 4 >> 2] + a[o + 4 >> 2] | 0, o = we >>> 0 > Qe >>> 0 ? o + 1 | 0 : o, B = dr + Qe | 0, o = (B >>> 0 < Qe >>> 0 ? o + 1 | 0 : o) + Dr | 0, we = B, B = B + mi | 0, o = we >>> 0 > B >>> 0 ? o + 1 | 0 : o, we = B + $r | 0, o = we >>> 0 < B >>> 0 ? o + 1 | 0 : o, Me = Me >>> 20 | 0, B = Me + we | 0, o = Me >>> 0 > B >>> 0 ? o + 1 | 0 : o, we = B, B = B + In | 0, o = we >>> 0 > B >>> 0 ? o + 1 | 0 : o, Me = B << 12 | wr >>> 20, wr = Me + Si | 0, we = o, o = m + (o << 12 | B >>> 20) | 0, Fr = Me >>> 0 > wr >>> 0 ? o + 1 | 0 : o, Lr($i, wr, Fr, 0, 0, 15632, 16, 0, 0), Me = Be, Ti = a[d + 256 >> 2], B = a[d + 128 >> 2], Qe = Ti + B | 0, Xn = a[d + 260 >> 2], o = Xn + a[d + 132 >> 2] | 0, o = B >>> 0 > Qe >>> 0 ? o + 1 | 0 : o, B = a[d + 352 >> 2], Dr = B + Qe | 0, $r = o, o = o + a[d + 356 >> 2] | 0, o = B >>> 0 > Dr >>> 0 ? o + 1 | 0 : o, B = a[d + 32 >> 2], dr = B + Dr | 0, mi = o, o = o + a[d + 36 >> 2] | 0, B = B >>> 0 > dr >>> 0 ? o + 1 | 0 : o, Kn = (v | 0) == (fr | 0) & Rr >>> 0 < Oi >>> 0 | v >>> 0 > fr >>> 0, $i = (v | 0) == (zi | 0) & Gr >>> 0 > Oi >>> 0 | v >>> 0 < zi >>> 0, o = ba + 8 | 0, In = a[o >> 2], Oi = a[o + 4 >> 2], Rr = (zi | 0) == (Ta | 0) & Gr >>> 0 < Vn >>> 0 | zi >>> 0 < Ta >>> 0, Be = jn + 8 | 0, v = a[Be >> 2], o = ta + 8 | 0, Gr = v + a[o >> 2] | 0, o = a[o + 4 >> 2] + a[Be + 4 >> 2] | 0, o = v >>> 0 > Gr >>> 0 ? o + 1 | 0 : o, v = Rr + Gr | 0, o = (v >>> 0 < Gr >>> 0 ? o + 1 | 0 : o) + Oi | 0, Be = v, v = v + In | 0, o = Be >>> 0 > v >>> 0 ? o + 1 | 0 : o, Be = v + $i | 0, o = Be >>> 0 < v >>> 0 ? o + 1 | 0 : o, he = he >>> 20 | 0, v = he + Be | 0, o = he >>> 0 > v >>> 0 ? o + 1 | 0 : o, he = v, v = v + Kn | 0, o = he >>> 0 > v >>> 0 ? o + 1 | 0 : o, Be = v << 12 | fr >>> 20, fr = Be + dr | 0, he = o, o = B + (o << 12 | v >>> 20) | 0, a[Me + 16 >> 2] = fr, Be = Be >>> 0 > fr >>> 0 ? o + 1 | 0 : o, a[Me + 20 >> 2] = Be & 1048575, Gr = d + 16 | 0, Rr = (m | 0) == (Fr | 0) & wr >>> 0 < Si >>> 0 | m >>> 0 > Fr >>> 0, wr = (m | 0) == (un | 0) & Si >>> 0 < va >>> 0 | m >>> 0 < un >>> 0, v = ya + 8 | 0, m = a[v >> 2], o = js + 8 | 0, Fr = m + a[o >> 2] | 0, o = a[o + 4 >> 2] + a[v + 4 >> 2] | 0, o = m >>> 0 > Fr >>> 0 ? o + 1 | 0 : o, v = wr + Fr | 0, o = v >>> 0 < Fr >>> 0 ? o + 1 | 0 : o, we = we >>> 20 | 0, m = v + we | 0, o = we >>> 0 > m >>> 0 ? o + 1 | 0 : o, v = m, m = m + Rr | 0, o = v >>> 0 > m >>> 0 ? o + 1 | 0 : o, Lr(Gr, m, o, 0, 0, 64028672, 65536, 0, 0), v = Me, Si = (B | 0) == (Be | 0) & fr >>> 0 < dr >>> 0 | B >>> 0 > Be >>> 0, Fr = (B | 0) == (mi | 0) & dr >>> 0 < Dr >>> 0 | B >>> 0 < mi >>> 0, B = sa + 8 | 0, dr = a[B >> 2], Rr = a[B + 4 >> 2], wr = ($r | 0) == (mi | 0) & Dr >>> 0 < Qe >>> 0 | $r >>> 0 > mi >>> 0, B = Xs + 8 | 0, fr = a[B >> 2], Me = a[B + 4 >> 2], we = ($r | 0) == (Xn | 0) & Qe >>> 0 < Ti >>> 0 | $r >>> 0 < Xn >>> 0, o = ps + 8 | 0, m = a[o >> 2], B = Bs + 8 | 0, Dr = m + a[B >> 2] | 0, o = a[B + 4 >> 2] + a[o + 4 >> 2] | 0, o = m >>> 0 > Dr >>> 0 ? o + 1 | 0 : o, B = we + Dr | 0, o = (B >>> 0 < Dr >>> 0 ? o + 1 | 0 : o) + Me | 0, m = B, B = B + fr | 0, o = m >>> 0 > B >>> 0 ? o + 1 | 0 : o, m = B, B = B + wr | 0, o = (m >>> 0 > B >>> 0 ? o + 1 | 0 : o) + Rr | 0, m = B, B = B + dr | 0, o = m >>> 0 > B >>> 0 ? o + 1 | 0 : o, m = B + Fr | 0, o = m >>> 0 < B >>> 0 ? o + 1 | 0 : o, he = he >>> 20 | 0, B = m + he | 0, o = he >>> 0 > B >>> 0 ? o + 1 | 0 : o, m = B, B = B + Si | 0, o = m >>> 0 > B >>> 0 ? o + 1 | 0 : o, he = B << 12 | Be >>> 20, m = o, we = o << 12 | B >>> 20, dr = a[d + 20 >> 2], o = dr + (wa & 1048575) | 0, Rr = a[d + 16 >> 2], B = oa + Rr | 0, Be = B >>> 0 < oa >>> 0 ? o + 1 | 0 : o, o = Be + we | 0, Me = B, he = B + he | 0, a[v + 24 >> 2] = he, B = B >>> 0 > he >>> 0 ? o + 1 | 0 : o, a[v + 28 >> 2] = B & 1048575, we = v, wr = Sn & 65535, fr = (B | 0) == (Be | 0) & he >>> 0 < Me >>> 0 | B >>> 0 < Be >>> 0, v = (Be | 0) == (dr | 0) & Me >>> 0 < Rr >>> 0 | Be >>> 0 < dr >>> 0, o = Gr + 8 | 0, he = v + a[o >> 2] | 0, o = a[o + 4 >> 2], o = v >>> 0 > he >>> 0 ? o + 1 | 0 : o, m = m >>> 20 | 0, v = m, m = m + he | 0, o = v >>> 0 > m >>> 0 ? o + 1 | 0 : o, v = m, m = m + fr | 0, o = v >>> 0 > m >>> 0 ? o + 1 | 0 : o, B = m << 12 | B >>> 20, v = B + ni | 0, o = wr + (o << 12 | m >>> 20) | 0, a[we + 32 >> 2] = v, a[we + 36 >> 2] = B >>> 0 > v >>> 0 ? o + 1 | 0 : o, be = d + 496 | 0;
  }
  function Gn(B, o) {
    var m = 0, d = 0, v = 0, he = 0, we = 0, Be = 0, Me = 0, fr = 0, wr = 0, dr = 0, Dr = 0, Rr = 0, Qe = 0, Fr = 0, Gr = 0, $r = 0, ni = 0, mi = 0, Si = 0, Oi = 0, $i = 0, zi = 0, un = 0, In = 0;
    d = o - -64 | 0, dr = a[d >> 2], Me = a[d + 4 >> 2], d = o + 56 | 0, we = a[d >> 2], $r = a[d + 4 >> 2], d = o + 48 | 0, ni = a[d >> 2], Dr = a[d + 4 >> 2], d = o + 72 | 0, Qe = a[d >> 2], he = a[d + 4 >> 2], Si = a[o + 40 >> 2], $i = a[o + 44 >> 2], mi = a[o + 24 >> 2], Rr = a[o + 28 >> 2], Be = a[o + 16 >> 2], Gr = a[o + 20 >> 2], m = a[o + 8 >> 2], fr = a[o + 12 >> 2], wr = a[o + 4 >> 2], Oi = a[o + 32 >> 2], v = a[o + 36 >> 2], un = v, o = a[o >> 2], d = oi(v >>> 16 | 0, 0, 977, 1), v = o + d | 0, o = wr + Fe | 0, wr = d >>> 0 > v >>> 0 ? o + 1 | 0 : o, o = fr, d = wr >>> 20 | 0, fr = d, d = m + d | 0, fr = fr >>> 0 > d >>> 0 ? o + 1 | 0 : o, o = Gr, m = fr >>> 20 | 0, Fr = m, m = m + Be | 0, Gr = Fr >>> 0 > m >>> 0 ? o + 1 | 0 : o, o = Rr, Be = Gr >>> 20 | 0, Rr = Be, Be = Be + mi | 0, mi = Rr >>> 0 > Be >>> 0 ? o + 1 | 0 : o, In = fr & 1048575, o = wr & 1048575, Fr = o, Rr = d, wr = m, zi = Gr & 1048575, m = (d & m & Be) == -1 & (zi & fr & mi) == 1048575, o = un & 65535, d = mi >>> 20 | 0, fr = d, d = d + Oi | 0, o = fr >>> 0 > d >>> 0 ? o + 1 | 0 : o, Oi = d, fr = o, d = oi(m & ((d | 0) == -1 & (o | 0) == 65535) & ((Fr | 0) == 1048574 & v >>> 0 > 4294966318 | Fr >>> 0 > 1048574) | o >>> 16, 0, 977, 1), v = d + v | 0, o = Fr + Fe | 0, m = d >>> 0 > v >>> 0 ? o + 1 | 0 : o, o = In, d = m >>> 20 | 0, Gr = d + Rr | 0, d = d >>> 0 > Gr >>> 0 ? o + 1 | 0 : o, u[B | 0] = v, u[B + 1 | 0] = v >>> 8, u[B + 2 | 0] = v >>> 16, u[B + 3 | 0] = v >>> 24, o = m & 1048575 | Gr << 20, u[B + 4 | 0] = o, u[B + 5 | 0] = o >>> 8, u[B + 6 | 0] = o >>> 16, u[B + 7 | 0] = o >>> 24, Rr = Qe, Fr = he & 65535, Qe = dr, dr = we, m = oi(he >>> 16 | 0, 0, 977, 1), v = m + Si | 0, o = $i + Fe | 0, Si = m >>> 0 > v >>> 0 ? o + 1 | 0 : o, o = Dr, m = Si >>> 20 | 0, he = m, m = m + ni | 0, we = he >>> 0 > m >>> 0 ? o + 1 | 0 : o, o = $r, he = we >>> 20 | 0, dr = he + dr | 0, Dr = he >>> 0 > dr >>> 0 ? o + 1 | 0 : o, o = Me, he = Dr >>> 20 | 0, Me = he, he = he + Qe | 0, $r = Me >>> 0 > he >>> 0 ? o + 1 | 0 : o, o = Fr, Me = $r >>> 20 | 0, Qe = Me, Me = Me + Rr | 0, o = Qe >>> 0 > Me >>> 0 ? o + 1 | 0 : o, ni = Me, Me = o, $i = we & 1048575, o = Si & 1048575, Fr = v, Qe = m, Rr = Dr & 1048575, v = oi((dr & m & he) == -1 & (Rr & we & $r) == 1048575 & ((ni | 0) == -1 & (Me | 0) == 65535) & ((o | 0) == 1048574 & v >>> 0 > 4294966318 | o >>> 0 > 1048574) | Me >>> 16, 0, 977, 1), m = Fr + v | 0, o = o + Fe | 0, we = m >>> 0 < v >>> 0 ? o + 1 | 0 : o, o = $i, v = we >>> 20 | 0, Dr = v + Qe | 0, v = v >>> 0 > Dr >>> 0 ? o + 1 | 0 : o, u[B + 32 | 0] = m, u[B + 33 | 0] = m >>> 8, u[B + 34 | 0] = m >>> 16, u[B + 35 | 0] = m >>> 24, o = we & 1048575 | Dr << 20, u[B + 36 | 0] = o, u[B + 37 | 0] = o >>> 8, u[B + 38 | 0] = o >>> 16, u[B + 39 | 0] = o >>> 24, we = (d & 4095) << 20 | Gr >>> 12, Qe = d >>> 12 & 255, o = zi, m = (d >>> 20 | 0) + wr | 0, d = m >>> 0 < wr >>> 0 ? o + 1 | 0 : o, wr = m, o = m << 8, m = B, u[m + 8 | 0] = we, u[m + 9 | 0] = we >>> 8, u[m + 10 | 0] = we >>> 16, u[m + 11 | 0] = we >>> 24, o = o | Qe, u[m + 12 | 0] = o, u[m + 13 | 0] = o >>> 8, u[m + 14 | 0] = o >>> 16, u[m + 15 | 0] = o >>> 24, we = (v & 4095) << 20 | Dr >>> 12, Dr = v >>> 12 & 255, o = Rr, m = (v >>> 20 | 0) + dr | 0, v = m >>> 0 < dr >>> 0 ? o + 1 | 0 : o, dr = m, o = m << 8, m = B, u[m + 40 | 0] = we, u[m + 41 | 0] = we >>> 8, u[m + 42 | 0] = we >>> 16, u[m + 43 | 0] = we >>> 24, o = o | Dr, u[m + 44 | 0] = o, u[m + 45 | 0] = o >>> 8, u[m + 46 | 0] = o >>> 16, u[m + 47 | 0] = o >>> 24, wr = ((d & 16777215) << 8 | wr >>> 24) & 268435455, o = mi & 1048575, d = d >>> 20 | 0, m = d + Be | 0, d = d >>> 0 > m >>> 0 ? o + 1 | 0 : o, o = d << 28 | m >>> 4, Be = m << 28, m = B, Be = Be | wr, u[m + 16 | 0] = Be, u[m + 17 | 0] = Be >>> 8, u[m + 18 | 0] = Be >>> 16, u[m + 19 | 0] = Be >>> 24, u[m + 20 | 0] = o, u[m + 21 | 0] = o >>> 8, u[m + 22 | 0] = o >>> 16, u[m + 23 | 0] = o >>> 24, Be = ((v & 16777215) << 8 | dr >>> 24) & 268435455, o = $r & 1048575, v = v >>> 20 | 0, m = v + he | 0, v = v >>> 0 > m >>> 0 ? o + 1 | 0 : o, o = v << 28 | m >>> 4, he = m << 28, m = B, he = he | Be, u[m + 48 | 0] = he, u[m + 49 | 0] = he >>> 8, u[m + 50 | 0] = he >>> 16, u[m + 51 | 0] = he >>> 24, u[m + 52 | 0] = o, u[m + 53 | 0] = o >>> 8, u[m + 54 | 0] = o >>> 16, u[m + 55 | 0] = o >>> 24, m = d >>> 4 & 65535, o = fr, d = (d >>> 20 | 0) + Oi | 0, o = (d >>> 0 < Oi >>> 0 ? o + 1 | 0 : o) << 16 | d >>> 16, he = d << 16, d = B, m = m | he, u[d + 24 | 0] = m, u[d + 25 | 0] = m >>> 8, u[d + 26 | 0] = m >>> 16, u[d + 27 | 0] = m >>> 24, u[d + 28 | 0] = o, u[d + 29 | 0] = o >>> 8, u[d + 30 | 0] = o >>> 16, u[d + 31 | 0] = o >>> 24, m = v >>> 4 & 65535, o = Me, d = (v >>> 20 | 0) + ni | 0, o = (d >>> 0 < ni >>> 0 ? o + 1 | 0 : o) << 16 | d >>> 16, d = d << 16 | m, u[B + 56 | 0] = d, u[B + 57 | 0] = d >>> 8, u[B + 58 | 0] = d >>> 16, u[B + 59 | 0] = d >>> 24, u[B + 60 | 0] = o, u[B + 61 | 0] = o >>> 8, u[B + 62 | 0] = o >>> 16, u[B + 63 | 0] = o >>> 24;
  }
  function pn(B, o, m, d) {
    var v = 0, he = 0, we = 0, Be = 0, Me = 0, fr = 0, wr = 0, dr = 0, Dr = 0, Rr = 0, Qe = 0, Fr = 0, Gr = 0, $r = 0, ni = 0, mi = 0, Si = 0, Oi = 0, $i = 0, zi = 0, un = 0, In = 0, Ti = 0, Sn = 0, Kn = 0, Vn = 0, Xn = 0;
    Me = be - 96 | 0, be = Me;
    e: {
      if (!o) {
        ji[a[B + 168 >> 2]](689730, a[B + 172 >> 2]);
        break e;
      }
      if (he = a[o >> 2], Ti = d & 256, he >>> 0 < (Ti ? 33 : 65) >>> 0) {
        ji[a[B + 168 >> 2]](690157, a[B + 172 >> 2]);
        break e;
      }
      if (a[o >> 2] = 0, $i = xi(690820, he), !m) {
        ji[a[B + 168 >> 2]](689638, a[B + 172 >> 2]);
        break e;
      }
      if ((d & 255) != 2) {
        ji[a[B + 168 >> 2]](689499, a[B + 172 >> 2]);
        break e;
      }
      if (a[Me + 88 >> 2] = 0, d = A[m + 12 | 0] | A[m + 13 | 0] << 8 | (A[m + 14 | 0] << 16 | A[m + 15 | 0] << 24), we = d, he = A[m + 8 | 0] | A[m + 9 | 0] << 8 | (A[m + 10 | 0] << 16 | A[m + 11 | 0] << 24), Be = (d << 12 | he >>> 20) & 1048575, fr = A[m + 4 | 0] | A[m + 5 | 0] << 8 | (A[m + 6 | 0] << 16 | A[m + 7 | 0] << 24), v = fr, he = he << 12 & -4096 | v >>> 20, Si = Be, Be = A[m + 16 | 0] | A[m + 17 | 0] << 8 | (A[m + 18 | 0] << 16 | A[m + 19 | 0] << 24), dr = Be, d = A[m + 20 | 0] | A[m + 21 | 0] << 8 | (A[m + 22 | 0] << 16 | A[m + 23 | 0] << 24), fr = d, Dr = (d << 24 | Be >>> 8) & 1048575, Gr = Be << 24 & -16777216 | we >>> 8, zi = Dr, wr = Dr, Be = A[m + 28 | 0] | A[m + 29 | 0] << 8 | (A[m + 30 | 0] << 16 | A[m + 31 | 0] << 24), d = Be >>> 16 | 0, we = A[m + 24 | 0] | A[m + 25 | 0] << 8 | (A[m + 26 | 0] << 16 | A[m + 27 | 0] << 24), Be = (Be & 65535) << 16 | we >>> 16, $r = A[m | 0] | A[m + 1 | 0] << 8 | (A[m + 2 | 0] << 16 | A[m + 3 | 0] << 24), Fr = Gr | (Be | ($r | he)), un = d, ni = v & 1048575, v = wr | (d | (ni | Si)), wr = we << 4 & 1048560, we = fr, d = we >>> 28 | 0, Dr = (we & 268435455) << 4 | dr >>> 28, fr = Fr | Dr, Fr = d | wr, !(fr | (v | Fr))) {
        ji[a[B + 168 >> 2]](690116, a[B + 172 >> 2]);
        break e;
      }
      we = A[m + 52 | 0] | A[m + 53 | 0] << 8 | (A[m + 54 | 0] << 16 | A[m + 55 | 0] << 24), d = we >>> 28 | 0, B = A[m + 48 | 0] | A[m + 49 | 0] << 8 | (A[m + 50 | 0] << 16 | A[m + 51 | 0] << 24), fr = (we & 268435455) << 4 | B >>> 28, dr = d, d = A[m + 56 | 0] | A[m + 57 | 0] << 8 | (A[m + 58 | 0] << 16 | A[m + 59 | 0] << 24), Sn = d, Rr = A[m + 60 | 0] | A[m + 61 | 0] << 8 | (A[m + 62 | 0] << 16 | A[m + 63 | 0] << 24), Kn = d << 4 & 1048560, v = A[m + 40 | 0] | A[m + 41 | 0] << 8 | (A[m + 42 | 0] << 16 | A[m + 43 | 0] << 24), wr = A[m + 44 | 0] | A[m + 45 | 0] << 8 | (A[m + 46 | 0] << 16 | A[m + 47 | 0] << 24), mi = wr >>> 8 | 0, d = we << 24 | B >>> 8, Vn = B << 24 & -16777216, Xn = d & 1048575, we = A[m + 32 | 0] | A[m + 33 | 0] << 8 | (A[m + 34 | 0] << 16 | A[m + 35 | 0] << 24), B = A[m + 36 | 0] | A[m + 37 | 0] << 8 | (A[m + 38 | 0] << 16 | A[m + 39 | 0] << 24), Qe = B, m = B >>> 20 | 0, B = v, d = wr << 12 | B >>> 20, wr = B << 12 & -4096, In = d & 1048575, Oi = Qe & 1048575;
      t: {
        if ((ni | 0) == 1048574 & $r >>> 0 < 4294966319 | ni >>> 0 < 1048574 || (he & Gr & Dr) != -1 | (Si & zi & Fr) != 1048575 || (Be | 0) != -1 | (un | 0) != 65535)
          break t;
        B = ni + 1 | 0, $r = $r + 977 | 0, B = $r >>> 0 < 977 ? B + 1 | 0 : B, ni = B & 1048575, v = B >>> 20 | 0, B = Si, he = v + he | 0, B = he >>> 0 < v >>> 0 ? B + 1 | 0 : B, Si = B & 1048575, d = zi, B = B >>> 20 | 0, Gr = B + Gr | 0, d = B >>> 0 > Gr >>> 0 ? d + 1 | 0 : d, zi = d & 1048575, v = d >>> 20 | 0, B = Fr, Dr = v + Dr | 0, B = Dr >>> 0 < v >>> 0 ? B + 1 | 0 : B, Fr = B & 1048575, v = B >>> 20 | 0, B = un, d = Be, Be = v + Be | 0, un = (d >>> 0 > Be >>> 0 ? B + 1 | 0 : B) & 65535;
      }
      v = fr, Qe = dr | Kn, dr = mi | Vn, mi = Xn, wr = m | wr, B = Rr, d = B >>> 16 | 0, fr = (B & 65535) << 16 | Sn >>> 16, Rr = d, m = Me, a[m + 40 >> 2] = Be, a[m + 44 >> 2] = un, a[m + 32 >> 2] = Dr, a[m + 36 >> 2] = Fr, a[m + 24 >> 2] = Gr, a[m + 28 >> 2] = zi, a[m + 16 >> 2] = he, a[m + 20 >> 2] = Si, a[m + 8 >> 2] = $r, a[m + 12 >> 2] = ni;
      t: {
        if ((Oi | 0) == 1048574 & we >>> 0 < 4294966319 | Oi >>> 0 < 1048574 || (wr & dr & v) != -1 | (In & mi & Qe) != 1048575 || (fr | 0) != -1 | (Rr | 0) != 65535)
          break t;
        d = Oi + 1 | 0, we = we + 977 | 0, d = we >>> 0 < 977 ? d + 1 | 0 : d, Oi = d & 1048575, B = In, d = d >>> 20 | 0, wr = d + wr | 0, B = d >>> 0 > wr >>> 0 ? B + 1 | 0 : B, In = B & 1048575, he = B >>> 20 | 0, d = mi, dr = he + dr | 0, d = dr >>> 0 < he >>> 0 ? d + 1 | 0 : d, mi = d & 1048575, he = d >>> 20 | 0, d = Qe, v = v + he | 0, d = v >>> 0 < he >>> 0 ? d + 1 | 0 : d, Qe = d & 1048575, B = Rr, Rr = fr, fr = (d >>> 20 | 0) + fr | 0, Rr = (Rr >>> 0 > fr >>> 0 ? B + 1 | 0 : B) & 65535;
      }
      a[m + 80 >> 2] = fr, a[Me + 84 >> 2] = Rr, a[Me + 72 >> 2] = v, a[Me + 76 >> 2] = Qe, a[Me + 64 >> 2] = dr, a[Me + 68 >> 2] = mi, a[Me + 56 >> 2] = wr, a[Me + 60 >> 2] = In, a[Me + 48 >> 2] = we, a[Me + 52 >> 2] = Oi, hn($i + 1 | 0, Me + 8 | 0);
      t: {
        if (Ti) {
          u[$i | 0] = we & 1 ? 3 : 2, B = 33;
          break t;
        }
        u[$i | 0] = 4, hn($i + 33 | 0, Me + 48 | 0), B = 65;
      }
      a[o >> 2] = B, Qe = 1;
    }
    return be = Me + 96 | 0, Qe;
  }
  function hn(B, o) {
    u[B | 0] = a[o + 36 >> 2] >>> 8, u[B + 1 | 0] = a[o + 36 >> 2], u[B + 2 | 0] = (a[o + 36 >> 2] & 16777215) << 8 | a[o + 32 >> 2] >>> 24, u[B + 3 | 0] = (a[o + 36 >> 2] & 65535) << 16 | a[o + 32 >> 2] >>> 16, u[B + 4 | 0] = (a[o + 36 >> 2] & 255) << 24 | a[o + 32 >> 2] >>> 8, u[B + 5 | 0] = a[o + 32 >> 2], u[B + 6 | 0] = a[o + 28 >> 2] >>> 12, u[B + 7 | 0] = a[o + 28 >> 2] >>> 4, u[B + 8 | 0] = (a[o + 28 >> 2] & 268435455) << 4 | a[o + 24 >> 2] >>> 28, u[B + 9 | 0] = (a[o + 28 >> 2] & 1048575) << 12 | a[o + 24 >> 2] >>> 20, u[B + 10 | 0] = (a[o + 28 >> 2] & 4095) << 20 | a[o + 24 >> 2] >>> 12, u[B + 11 | 0] = (a[o + 28 >> 2] & 15) << 28 | a[o + 24 >> 2] >>> 4, u[B + 12 | 0] = b[o + 22 >> 1] & 15 | a[o + 24 >> 2] << 4, u[B + 13 | 0] = a[o + 20 >> 2] >>> 8, u[B + 14 | 0] = a[o + 20 >> 2], u[B + 15 | 0] = (a[o + 20 >> 2] & 16777215) << 8 | a[o + 16 >> 2] >>> 24, u[B + 16 | 0] = (a[o + 20 >> 2] & 65535) << 16 | a[o + 16 >> 2] >>> 16, u[B + 17 | 0] = (a[o + 20 >> 2] & 255) << 24 | a[o + 16 >> 2] >>> 8, u[B + 18 | 0] = a[o + 16 >> 2], u[B + 19 | 0] = a[o + 12 >> 2] >>> 12, u[B + 20 | 0] = a[o + 12 >> 2] >>> 4, u[B + 21 | 0] = (a[o + 12 >> 2] & 268435455) << 4 | a[o + 8 >> 2] >>> 28, u[B + 22 | 0] = (a[o + 12 >> 2] & 1048575) << 12 | a[o + 8 >> 2] >>> 20, u[B + 23 | 0] = (a[o + 12 >> 2] & 4095) << 20 | a[o + 8 >> 2] >>> 12, u[B + 24 | 0] = (a[o + 12 >> 2] & 15) << 28 | a[o + 8 >> 2] >>> 4, u[B + 25 | 0] = b[o + 6 >> 1] & 15 | a[o + 8 >> 2] << 4, u[B + 26 | 0] = a[o + 4 >> 2] >>> 8, u[B + 27 | 0] = a[o + 4 >> 2], u[B + 28 | 0] = (a[o + 4 >> 2] & 16777215) << 8 | a[o >> 2] >>> 24, u[B + 29 | 0] = (a[o + 4 >> 2] & 65535) << 16 | a[o >> 2] >>> 16, u[B + 30 | 0] = (a[o + 4 >> 2] & 255) << 24 | a[o >> 2] >>> 8, u[B + 31 | 0] = a[o >> 2];
  }
  function Rn(B, o, m) {
    var d = 0, v = 0, he = 0, we = 0, Be = 0, Me = 0, fr = 0, wr = 0, dr = 0, Dr = 0, Rr = 0, Qe = 0, Fr = 0;
    we = B, d = o, o = A[d + 24 | 0] | A[d + 25 | 0] << 8 | (A[d + 26 | 0] << 16 | A[d + 27 | 0] << 24), he = o << 8 & 16711680, Dr = o << 24 | he, v = o >>> 8 | 0, B = A[d + 28 | 0] | A[d + 29 | 0] << 8 | (A[d + 30 | 0] << 16 | A[d + 31 | 0] << 24), he = (v | B << 24) & 65280, o = o >>> 24 | 0, he = Dr | (he | (o | B << 8) & 255), v = (o | (B & 16777215) << 8) & 16711680 | (v | (B & 255) << 24) & -16777216, Me = B >>> 8 & 65280 | B >>> 24 | v, a[we >> 2] = Me, a[we + 4 >> 2] = he, o = A[d + 16 | 0] | A[d + 17 | 0] << 8 | (A[d + 18 | 0] << 16 | A[d + 19 | 0] << 24), Be = o << 8 & 16711680 | o << 24, B = A[d + 20 | 0] | A[d + 21 | 0] << 8 | (A[d + 22 | 0] << 16 | A[d + 23 | 0] << 24), v = (B << 24 | o >>> 8) & 65280, Dr = Be | (v | (B << 8 | o >>> 24) & 255), v = ((B & 255) << 24 | o >>> 8) & -16777216, Be = v | ((B & 16777215) << 8 | o >>> 24) & 16711680, Fr = B >>> 8 & 65280 | B >>> 24 | Be, a[we + 8 >> 2] = Fr, fr = Dr, a[we + 12 >> 2] = fr, o = A[d + 8 | 0] | A[d + 9 | 0] << 8 | (A[d + 10 | 0] << 16 | A[d + 11 | 0] << 24), Be = o << 8 & 16711680, Rr = o << 24 | Be, B = A[d + 12 | 0] | A[d + 13 | 0] << 8 | (A[d + 14 | 0] << 16 | A[d + 15 | 0] << 24), Be = (B << 24 | o >>> 8) & 65280, Be = Rr | (Be | (B << 8 | o >>> 24) & 255), v = ((B & 255) << 24 | o >>> 8) & -16777216, v = v | ((B & 16777215) << 8 | o >>> 24) & 16711680, Qe = B >>> 8 & 65280 | B >>> 24 | v, a[we + 16 >> 2] = Qe, Rr = Be, a[we + 20 >> 2] = Be, B = A[d + 4 | 0] | A[d + 5 | 0] << 8 | (A[d + 6 | 0] << 16 | A[d + 7 | 0] << 24), o = A[d | 0] | A[d + 1 | 0] << 8 | (A[d + 2 | 0] << 16 | A[d + 3 | 0] << 24), Be = o << 8 & 16711680 | o << 24, Dr = Be | ((B << 8 | o >>> 24) & 255 | (B << 24 | o >>> 8) & 65280), d = ((B & 255) << 24 | o >>> 8) & -16777216, wr = d | ((B & 16777215) << 8 | o >>> 24) & 16711680, Be = B >>> 8 & 65280, o = B >>> 24 | 0, B = Dr, d = (Rr | 0) == -1, Be = o | Be | wr, o = d & Qe >>> 0 < 4294967294 | (Rr | 0) != -1 | (B & Be) != -1, v = (fr | 0) == -1162945306, B = (o | (v & Fr >>> 0 < 2940772411 | fr >>> 0 < 3132021990)) ^ -1, wr = B & ((he | 0) == -1076732276 & Me >>> 0 > 3493216576 | he >>> 0 > 3218235020) | (B & (v & Fr >>> 0 > 2940772411 | fr >>> 0 > 3132021990) | (Qe | 0) == -1 & d & (o ^ -1)), dr = oi(wr, 0, 801750719, 1076732275), v = Fe, d = v + he | 0, B = Me + dr | 0, d = B >>> 0 < dr >>> 0 ? d + 1 | 0 : d, a[we >> 2] = B, a[we + 4 >> 2] = d, o = we, d = (d | 0) == (v | 0) & B >>> 0 < dr >>> 0 | d >>> 0 < v >>> 0, dr = oi(wr, 0, 1354194884, 1162945305), he = Fe, Me = he + fr | 0, we = dr + Fr | 0, B = we >>> 0 < dr >>> 0 ? Me + 1 | 0 : Me, d = d + we | 0, v = d >>> 0 < we >>> 0 ? B + 1 | 0 : B, a[o + 8 >> 2] = d, a[o + 12 >> 2] = v, fr = (B | 0) == (he | 0) & we >>> 0 < dr >>> 0 | B >>> 0 < he >>> 0, B = (B | 0) == (v | 0) & d >>> 0 < we >>> 0 | B >>> 0 > v >>> 0, he = fr + B | 0, v = Rr, d = B >>> 0 > he >>> 0, we = wr + Qe | 0, B = we >>> 0 < Qe >>> 0 ? v + 1 | 0 : v, Me = d + B | 0, v = we, he = v + he | 0, Me = v >>> 0 > he >>> 0 ? Me + 1 | 0 : Me, a[o + 16 >> 2] = he, a[o + 20 >> 2] = Me, d = o, we = Be, o = !B & v >>> 0 < wr >>> 0, B = (B | 0) == (Me | 0) & v >>> 0 > he >>> 0 | B >>> 0 > Me >>> 0, he = o + B | 0, o = (B >>> 0 > he >>> 0) + Dr | 0, B = he + we | 0, o = B >>> 0 < he >>> 0 ? o + 1 | 0 : o, a[d + 24 >> 2] = B, a[d + 28 >> 2] = o, m && (a[m >> 2] = wr);
  }
  function vo(B, o) {
    u[B | 0] = A[o + 31 | 0], u[B + 1 | 0] = b[o + 30 >> 1], u[B + 2 | 0] = a[o + 28 >> 2] >>> 8, u[B + 3 | 0] = a[o + 28 >> 2], u[B + 4 | 0] = (a[o + 28 >> 2] & 16777215) << 8 | a[o + 24 >> 2] >>> 24, u[B + 5 | 0] = (a[o + 28 >> 2] & 65535) << 16 | a[o + 24 >> 2] >>> 16, u[B + 6 | 0] = (a[o + 28 >> 2] & 255) << 24 | a[o + 24 >> 2] >>> 8, u[B + 7 | 0] = a[o + 24 >> 2], u[B + 8 | 0] = A[o + 23 | 0], u[B + 9 | 0] = b[o + 22 >> 1], u[B + 10 | 0] = a[o + 20 >> 2] >>> 8, u[B + 11 | 0] = a[o + 20 >> 2], u[B + 12 | 0] = (a[o + 20 >> 2] & 16777215) << 8 | a[o + 16 >> 2] >>> 24, u[B + 13 | 0] = (a[o + 20 >> 2] & 65535) << 16 | a[o + 16 >> 2] >>> 16, u[B + 14 | 0] = (a[o + 20 >> 2] & 255) << 24 | a[o + 16 >> 2] >>> 8, u[B + 15 | 0] = a[o + 16 >> 2], u[B + 16 | 0] = A[o + 15 | 0], u[B + 17 | 0] = b[o + 14 >> 1], u[B + 18 | 0] = a[o + 12 >> 2] >>> 8, u[B + 19 | 0] = a[o + 12 >> 2], u[B + 20 | 0] = (a[o + 12 >> 2] & 16777215) << 8 | a[o + 8 >> 2] >>> 24, u[B + 21 | 0] = (a[o + 12 >> 2] & 65535) << 16 | a[o + 8 >> 2] >>> 16, u[B + 22 | 0] = (a[o + 12 >> 2] & 255) << 24 | a[o + 8 >> 2] >>> 8, u[B + 23 | 0] = a[o + 8 >> 2], u[B + 24 | 0] = A[o + 7 | 0], u[B + 25 | 0] = b[o + 6 >> 1], u[B + 26 | 0] = a[o + 4 >> 2] >>> 8, u[B + 27 | 0] = a[o + 4 >> 2], u[B + 28 | 0] = (a[o + 4 >> 2] & 16777215) << 8 | a[o >> 2] >>> 24, u[B + 29 | 0] = (a[o + 4 >> 2] & 65535) << 16 | a[o >> 2] >>> 16, u[B + 30 | 0] = (a[o + 4 >> 2] & 255) << 24 | a[o >> 2] >>> 8, u[B + 31 | 0] = a[o >> 2];
  }
  function Hi(B, o) {
    var m = 0, d = 0, v = 0, he = 0, we = 0, Be = 0, Me = 0, fr = 0, wr = 0, dr = 0, Dr = 0, Rr = 0, Qe = 0, Fr = 0, Gr = 0, $r = 0, ni = 0, mi = 0, Si = 0, Oi = 0, $i = 0, zi = 0, un = 0, In = 0, Ti = 0, Sn = 0, Kn = 0, Vn = 0, Xn = 0, uo = 0, yo = 0, Io = 0, xo = 0, Mo = 0, qi = 0, Oo = 0, Ho = 0, Go = 0, ns = 0, ds = 0, Ts = 0, Ao = 0, po = 0;
    for (we = be - 320 | 0, be = we, m = we + 280 | 0, d = m + 32 | 0, a[d >> 2] = 0, a[d + 4 >> 2] = 0, d = m + 24 | 0, a[d >> 2] = 0, a[d + 4 >> 2] = 0, d = m + 16 | 0, a[d >> 2] = 0, a[d + 4 >> 2] = 0, m = m + 8 | 0, a[m >> 2] = 0, a[m + 4 >> 2] = 0, a[we + 280 >> 2] = 0, a[we + 284 >> 2] = 0, m = we + 240 | 0, d = m + 32 | 0, a[d >> 2] = 0, a[d + 4 >> 2] = 0, d = m + 24 | 0, a[d >> 2] = 0, a[d + 4 >> 2] = 0, m = m + 16 | 0, a[m >> 2] = 0, a[m + 4 >> 2] = 0, a[we + 248 >> 2] = 0, a[we + 252 >> 2] = 0, a[we + 240 >> 2] = 1, a[we + 244 >> 2] = 0, d = o + 32 | 0, v = a[d + 4 >> 2], m = we + 200 | 0, he = m + 32 | 0, a[he >> 2] = a[d >> 2], a[he + 4 >> 2] = v, d = o + 24 | 0, v = a[d + 4 >> 2], he = m + 24 | 0, a[he >> 2] = a[d >> 2], a[he + 4 >> 2] = v, d = o + 16 | 0, v = a[d + 4 >> 2], he = m + 16 | 0, a[he >> 2] = a[d >> 2], a[he + 4 >> 2] = v, d = o + 8 | 0, v = a[d + 4 >> 2], m = m + 8 | 0, a[m >> 2] = a[d >> 2], a[m + 4 >> 2] = v, m = a[o + 4 >> 2], a[we + 200 >> 2] = a[o >> 2], a[we + 204 >> 2] = m, d = B + 32 | 0, v = a[d + 4 >> 2], m = we + 160 | 0, Xn = m + 32 | 0, a[Xn >> 2] = a[d >> 2], a[Xn + 4 >> 2] = v, d = B + 24 | 0, v = a[d + 4 >> 2], he = m + 24 | 0, a[he >> 2] = a[d >> 2], a[he + 4 >> 2] = v, d = B + 16 | 0, v = a[d + 4 >> 2], he = m + 16 | 0, a[he >> 2] = a[d >> 2], a[he + 4 >> 2] = v, d = B + 8 | 0, v = a[d + 4 >> 2], m = m + 8 | 0, a[m >> 2] = a[d >> 2], a[m + 4 >> 2] = v, m = a[B + 4 >> 2], a[we + 160 >> 2] = a[B >> 2], a[we + 164 >> 2] = m, un = 5, $i = -1, In = -1; ; ) {
      m = $i, Si = a[we + 160 >> 2], Gr = a[we + 164 >> 2], d = xn(Si, Gr | -1073741824), $i = m - d | 0, In = In - (Fe + (m >>> 0 < d >>> 0) | 0) | 0, m = d & 31, (d & 63) >>> 0 >= 32 ? (Me = 0, Qe = 1 << m) : (Me = 1 << m, Qe = Me - 1 & 1 >>> 32 - m), Kn = a[we + 200 >> 2], Ti = a[we + 204 >> 2], he = d;
      e: {
        if ((d | 0) == 62) {
          Be = 0, he = 0, Rr = 1, dr = 0, Oi = 0, ni = 0;
          break e;
        }
        for (d = he & 31, (he & 63) >>> 0 >= 32 ? (v = Gr >>> d | 0, d = 0) : (v = ((1 << d) - 1 & Gr) << 32 - d | Si >>> d, d = Gr >>> d | 0), Dr = 62 - he | 0, Rr = 1, dr = 0, Oi = 0, ni = 0, wr = Kn, fr = Ti, Be = 0, he = 0; ; ) {
          t: {
            if ((In | 0) < 0) {
              m = oi(v, d, v, d), $r = m - 2 | 0, zi = Fe - (m >>> 0 < 2) | 0, mi = 0 - wr | 0, m = 0 - (((wr | 0) != 0) + fr | 0) | 0, wr = oi($r, zi, oi(mi, m, v, d), Fe), In = 0 - ((($i | 0) != 0) + In | 0) | 0, $i = 0 - $i | 0, fr = $i + 1 | 0, Fr = 64 - ((fr | 0) > (Dr | 0) ? Dr : fr) | 0, fr = Fr & 31, (Fr & 63) >>> 0 >= 32 ? fr = -1 >>> fr | 0 : fr = (1 << fr) - 1 << 32 - fr | -1 >>> fr, uo = fr & wr & 63, Fr = 0 - Oi | 0, $r = 0 - (((Oi | 0) != 0) + ni | 0) | 0, zi = 0 - Me | 0, Io = 0 - (((Me | 0) != 0) + Qe | 0) | 0, wr = v, fr = d;
              break t;
            }
            Fr = (wr << 1) + 2 | 0, m = fr, $r = Fr & 8, Fr = $r + wr | 0, Fr = 0 - oi(Fr, Fr >>> 0 < $r >>> 0 ? m + 1 | 0 : m, v, d) | 0, m = $i + 1 | 0, $r = 64 - ((m | 0) > (Dr | 0) ? Dr : m) | 0, m = $r & 31, ($r & 63) >>> 0 >= 32 ? m = -1 >>> m | 0 : m = (1 << m) - 1 << 32 - m | -1 >>> m, uo = m & Fr & 15, zi = Be, Io = he, Fr = Rr, $r = dr, mi = v, m = d, Be = Me, he = Qe, Rr = Oi, dr = ni;
          }
          if (Me = $i, d = oi(wr, fr, uo, 0) + mi | 0, m = Fe + m | 0, v = d >>> 0 < mi >>> 0 ? m + 1 | 0 : m, m = Dr & 31, (Dr & 63) >>> 0 >= 32 ? (Qe = 0, m = -1 << m) : (Qe = -1 << m, m = Qe | (1 << m) - 1 & -1 >>> 32 - m), mi = xn(d | Qe, m | v), $i = Me - mi | 0, In = In - (Fe + (Me >>> 0 < mi >>> 0) | 0) | 0, Me = mi & 31, (mi & 63) >>> 0 >= 32 ? (Oi = 0, ni = Rr << Me) : (Oi = Rr << Me, ni = (1 << Me) - 1 & Rr >>> 32 - Me | dr << Me), Me = mi & 31, (mi & 63) >>> 0 >= 32 ? (m = Be << Me, Me = 0) : (m = (1 << Me) - 1 & Be >>> 32 - Me | he << Me, Me = Be << Me), Qe = m, Vn = mi & 31, (mi & 63) >>> 0 >= 32 ? (m = 0, v = v >>> Vn | 0) : (m = v >>> Vn | 0, v = ((1 << Vn) - 1 & v) << 32 - Vn | d >>> Vn), d = m, Rr = oi(Rr, dr, uo, 0) + Fr | 0, m = Fe + $r | 0, dr = Rr >>> 0 < Fr >>> 0 ? m + 1 | 0 : m, Be = oi(Be, he, uo, 0) + zi | 0, m = Fe + Io | 0, he = Be >>> 0 < zi >>> 0 ? m + 1 | 0 : m, Dr = Dr - mi | 0, !Dr)
            break;
        }
      }
      if (a[we + 152 >> 2] = Rr, a[we + 156 >> 2] = dr, a[we + 144 >> 2] = Be, a[we + 148 >> 2] = he, a[we + 136 >> 2] = Oi, a[we + 140 >> 2] = ni, a[we + 128 >> 2] = Me, a[we + 132 >> 2] = Qe, vi(we + 280 | 0, we + 240 | 0, we + 128 | 0, o), zi = Qe, m = Qe >> 31, Qe = m, wr = m, m = Ti >> 31, fr = we + 112 | 0, mi = Me, d = m, Lr(fr, Me, zi, wr, wr, Kn, Ti, m, m), Io = Oi, m = ni >> 31, Oi = m, Me = m, m = Gr >> 31, wr = we + 80 | 0, Vn = ni, v = m, Lr(wr, Io, ni, Me, Me, Si, Gr, m, m), m = he >> 31, Me = we + 96 | 0, uo = Be, Ts = he, qi = m, Lr(Me, Be, he, m, m, Kn, Ti, d, d), m = dr >> 31, Dr = we - -64 | 0, Kn = Rr, Ti = dr, Oo = m, Lr(Dr, Rr, dr, m, m, Si, Gr, v, v), Be = a[we + 80 >> 2], v = a[we + 112 >> 2], d = Be + v | 0, he = a[we + 84 >> 2], m = he + a[we + 116 >> 2] | 0, m = d >>> 0 < v >>> 0 ? m + 1 | 0 : m, v = d, d = m, he = (he | 0) == (m | 0) & v >>> 0 < Be >>> 0 | m >>> 0 < he >>> 0, m = fr + 8 | 0, Be = a[m >> 2], fr = wr + 8 | 0, v = Be + a[fr >> 2] | 0, m = a[fr + 4 >> 2] + a[m + 4 >> 2] | 0, m = v >>> 0 < Be >>> 0 ? m + 1 | 0 : m, Be = v, v = v + he | 0, he = Be >>> 0 > v >>> 0 ? m + 1 | 0 : m, Be = he << 2 | v >>> 30, v = v << 2 | d >>> 30, d = Be, dr = a[we + 64 >> 2], fr = a[we + 96 >> 2], Be = dr + fr | 0, wr = a[we + 68 >> 2], m = wr + a[we + 100 >> 2] | 0, m = Be >>> 0 < fr >>> 0 ? m + 1 | 0 : m, fr = Be, Be = m, wr = (wr | 0) == (m | 0) & fr >>> 0 < dr >>> 0 | m >>> 0 < wr >>> 0, m = Me + 8 | 0, dr = a[m >> 2], Me = Dr + 8 | 0, fr = dr + a[Me >> 2] | 0, m = a[Me + 4 >> 2] + a[m + 4 >> 2] | 0, m = fr >>> 0 < dr >>> 0 ? m + 1 | 0 : m, Me = fr, fr = wr + fr | 0, dr = Me >>> 0 > fr >>> 0 ? m + 1 | 0 : m, Me = dr << 2 | fr >>> 30, wr = fr << 2 | Be >>> 30, fr = Me, Ho = (un | 0) < 2, !Ho)
        for (m = he >> 31, he = he >> 30, Me = m, Fr = dr >> 30, $r = dr >> 31, Sn = un - 1 | 0, Dr = we + 160 | 0, dr = we + 200 | 0; Rr = dr + 8 | 0, Gr = a[Rr >> 2], m = a[Rr + 4 >> 2], Si = m, m = m >> 31, Be = m, Lr(we, Gr, Si, m, m, mi, zi, Qe, Qe), Go = we + 32 | 0, ni = Dr + 8 | 0, xo = a[ni >> 2], m = a[ni + 4 >> 2], yo = m, m = m >> 31, Lr(Go, xo, yo, m, m, Io, Vn, Oi, Oi), ns = we + 16 | 0, Lr(ns, Gr, Si, Be, Be, uo, Ts, qi, qi), ds = we + 48 | 0, Lr(ds, xo, yo, m, m, Kn, Ti, Oo, Oo), Be = a[we >> 2], Ao = Be, yo = a[we + 4 >> 2], m = yo + d | 0, Gr = v + Be | 0, v = Gr >>> 0 < v >>> 0 ? m + 1 | 0 : m, m = v + a[we + 36 >> 2] | 0, d = a[we + 32 >> 2], Be = d + Gr | 0, Si = Be, a[dr >> 2] = Be, d = d >>> 0 > Be >>> 0 ? m + 1 | 0 : m, a[dr + 4 >> 2] = d & 1073741823, Be = a[we + 16 >> 2], po = Be, Mo = a[we + 20 >> 2], m = Mo + fr | 0, dr = Be + wr | 0, wr = dr >>> 0 < wr >>> 0 ? m + 1 | 0 : m, m = wr + a[we + 52 >> 2] | 0, Be = a[we + 48 >> 2], fr = Be + dr | 0, xo = fr, a[Dr >> 2] = fr, Be = Be >>> 0 > fr >>> 0 ? m + 1 | 0 : m, a[Dr + 4 >> 2] = Be & 1073741823, fr = (d | 0) == (v | 0) & Gr >>> 0 > Si >>> 0 | d >>> 0 < v >>> 0, m = Go + 8 | 0, Dr = a[m >> 2], Si = a[m + 4 >> 2], Gr = (v | 0) == (yo | 0) & Gr >>> 0 < Ao >>> 0 | v >>> 0 < yo >>> 0, m = we + 8 | 0, v = a[m >> 2] + he | 0, m = a[m + 4 >> 2] + Me | 0, m = v >>> 0 < he >>> 0 ? m + 1 | 0 : m, Me = v, v = v + Gr | 0, m = (Me >>> 0 > v >>> 0 ? m + 1 | 0 : m) + Si | 0, Me = v, v = v + Dr | 0, m = Me >>> 0 > v >>> 0 ? m + 1 | 0 : m, Me = v, v = v + fr | 0, fr = Me >>> 0 > v >>> 0 ? m + 1 | 0 : m, m = fr >> 31, he = fr >> 30, Me = m, Dr = (Be | 0) == (wr | 0) & dr >>> 0 > xo >>> 0 | Be >>> 0 < wr >>> 0, m = ds + 8 | 0, Gr = a[m >> 2], Si = a[m + 4 >> 2], dr = (wr | 0) == (Mo | 0) & dr >>> 0 < po >>> 0 | wr >>> 0 < Mo >>> 0, m = ns + 8 | 0, wr = a[m >> 2] + Fr | 0, m = a[m + 4 >> 2] + $r | 0, m = wr >>> 0 < Fr >>> 0 ? m + 1 | 0 : m, $r = wr, wr = wr + dr | 0, m = ($r >>> 0 > wr >>> 0 ? m + 1 | 0 : m) + Si | 0, dr = wr, wr = wr + Gr | 0, m = dr >>> 0 > wr >>> 0 ? m + 1 | 0 : m, dr = wr, wr = wr + Dr | 0, dr = dr >>> 0 > wr >>> 0 ? m + 1 | 0 : m, m = dr >> 31, Fr = dr >> 30, $r = m, fr = fr << 2 | v >>> 30, v = v << 2 | d >>> 30, d = fr, dr = dr << 2 | wr >>> 30, wr = wr << 2 | Be >>> 30, fr = dr, dr = Rr, Dr = ni, Sn = Sn - 1 | 0, !!Sn; )
          ;
      Me = un - 1 | 0, m = Me << 3, he = m + (we + 160 | 0) | 0, a[he >> 2] = wr, a[he + 4 >> 2] = fr, m = (we + 200 | 0) + m | 0, a[m >> 2] = v, a[m + 4 >> 2] = d;
      e: {
        if (!(a[we + 164 >> 2] | a[we + 160 >> 2])) {
          if (Ho)
            break e;
          dr = Me & 3;
          t: {
            if (un - 2 >>> 0 < 3) {
              Be = 0, he = 0, m = 1;
              break t;
            }
            for (m = Me & -4, Sn = 0, Be = 0, he = 0, Dr = Xn; Qe = Dr - 8 | 0, Rr = Dr - 16 | 0, Oi = Dr - 24 | 0, Be = a[Dr >> 2] | (a[Qe >> 2] | (a[Rr >> 2] | (a[Oi >> 2] | Be))), he = a[Dr + 4 >> 2] | (a[Qe + 4 >> 2] | (a[Rr + 4 >> 2] | (a[Oi + 4 >> 2] | he))), Dr = Dr + 32 | 0, Sn = Sn + 4 | 0, (m | 0) != (Sn | 0); )
              ;
            m = Sn + 1 | 0;
          }
          if (dr)
            for (Dr = (we + 160 | 0) + (m << 3) | 0; Be = a[Dr >> 2] | Be, he = a[Dr + 4 >> 2] | he, Dr = Dr + 8 | 0, dr = dr - 1 | 0, !!dr; )
              ;
          if (!(he | Be))
            break e;
        }
        if (m = fr >> 31, he = m ^ wr, Be = m ^ fr, m = (un >> 31) - (un >>> 0 < 2) >> 31, he = m | he, Be = m | Be, m = d >> 31, he | m ^ v | (Be | m ^ d))
          continue;
        Be = (un << 3) - 16 | 0, m = Be + (we + 200 | 0) | 0, Qe = a[m + 4 >> 2], a[m >> 2] = a[m >> 2], a[m + 4 >> 2] = v << 30 | Qe, m = (we + 160 | 0) + Be | 0, he = a[m + 4 >> 2], a[m >> 2] = a[m >> 2], a[m + 4 >> 2] = wr << 30 | he, un = Me;
        continue;
      }
      break;
    }
    m = d >> 31, d = m, dr = we + 280 | 0, m = dr + 32 | 0, Me = a[m >> 2], m = a[m + 4 >> 2], Qe = m, m = m >> 31, v = m, fr = a[o >> 2], Rr = m & fr, he = Rr + a[we + 280 >> 2] | 0, wr = a[o + 4 >> 2], m = a[we + 284 >> 2] + (wr & m) | 0, m = he >>> 0 < Rr >>> 0 ? m + 1 | 0 : m, he = d ^ he, In = he - d | 0, he = (m ^ d) - ((d >>> 0 > he >>> 0) + d | 0) | 0, Be = B, Dr = fr, Oi = wr, B = a[o + 32 >> 2], Gr = B, fr = B & v, B = fr + Me | 0, Si = a[o + 36 >> 2], m = Qe + (Si & v) | 0, m = B >>> 0 < fr >>> 0 ? m + 1 | 0 : m, B = B ^ d, Rr = B - d | 0, $i = (m ^ d) - ((B >>> 0 < d >>> 0) + d | 0) | 0, B = a[o + 24 >> 2], Kn = B, wr = B & v, fr = dr + 24 | 0, B = wr + a[fr >> 2] | 0, Ti = a[o + 28 >> 2], m = a[fr + 4 >> 2] + (Ti & v) | 0, m = B >>> 0 < wr >>> 0 ? m + 1 | 0 : m, B = B ^ d, Qe = B - d | 0, $r = (m ^ d) - ((B >>> 0 < d >>> 0) + d | 0) | 0, B = a[o + 16 >> 2], un = B, Me = B & v, wr = dr + 16 | 0, B = Me + a[wr >> 2] | 0, mi = a[o + 20 >> 2], m = a[wr + 4 >> 2] + (mi & v) | 0, m = B >>> 0 < Me >>> 0 ? m + 1 | 0 : m, B = B ^ d, Me = B - d | 0, Fr = (m ^ d) - ((B >>> 0 < d >>> 0) + d | 0) | 0, zi = a[o + 8 >> 2], ni = zi & v, dr = dr + 8 | 0, B = ni + a[dr >> 2] | 0, Xn = a[o + 12 >> 2], m = a[dr + 4 >> 2] + (Xn & v) | 0, m = B >>> 0 < ni >>> 0 ? m + 1 | 0 : m, B = B ^ d, o = B - d | 0, m = ((m ^ d) - ((B >>> 0 < d >>> 0) + d | 0) | 0) + (he >> 31) | 0, B = he >> 30, v = B + o | 0, ni = B >>> 0 > v >>> 0 ? m + 1 | 0 : m, m = (ni >> 31) + Fr | 0, B = ni >> 30, Me = B + Me | 0, Fr = B >>> 0 > Me >>> 0 ? m + 1 | 0 : m, m = (Fr >> 31) + $r | 0, B = Fr >> 30, Qe = B + Qe | 0, $r = B >>> 0 > Qe >>> 0 ? m + 1 | 0 : m, m = ($r >> 31) + $i | 0, B = $r >> 30, Rr = B + Rr | 0, $i = B >>> 0 > Rr >>> 0 ? m + 1 | 0 : m, B = $i >> 31, m = (B & Oi) + (he & 1073741823) | 0, d = B, o = (d & Dr) + In | 0, B = o >>> 0 < In >>> 0 ? m + 1 | 0 : m, m = B & 1073741823, Dr = m, a[Be >> 2] = o, a[Be + 4 >> 2] = m, m = (d & Xn) + (ni & 1073741823) | 0, he = v, v = (d & zi) + v | 0, m = (B >> 31) + (he >>> 0 > v >>> 0 ? m + 1 | 0 : m) | 0, B = B >> 30, he = B, B = B + v | 0, m = he >>> 0 > B >>> 0 ? m + 1 | 0 : m, v = B, a[dr >> 2] = v, B = m, m = m & 1073741823, a[dr + 4 >> 2] = m, he = Be + 8 | 0, a[he >> 2] = v, a[he + 4 >> 2] = m, m = (d & mi) + (Fr & 1073741823) | 0, v = (d & un) + Me | 0, m = (B >> 31) + (v >>> 0 < Me >>> 0 ? m + 1 | 0 : m) | 0, B = B >> 30, Me = B, B = B + v | 0, m = Me >>> 0 > B >>> 0 ? m + 1 | 0 : m, v = B, a[wr >> 2] = v, B = m, m = m & 1073741823, a[wr + 4 >> 2] = m, he = Be + 16 | 0, a[he >> 2] = v, a[he + 4 >> 2] = m, m = (d & Ti) + ($r & 1073741823) | 0, v = (d & Kn) + Qe | 0, m = (B >> 31) + (v >>> 0 < Qe >>> 0 ? m + 1 | 0 : m) | 0, B = B >> 30, Me = B, B = B + v | 0, m = Me >>> 0 > B >>> 0 ? m + 1 | 0 : m, v = B, a[fr >> 2] = v, B = m, m = m & 1073741823, a[fr + 4 >> 2] = m, he = Be + 24 | 0, a[he >> 2] = v, a[he + 4 >> 2] = m, he = Be + 32 | 0, m = (d & Si) + $i | 0, d = (d & Gr) + Rr | 0, m = (B >> 31) + (d >>> 0 < Rr >>> 0 ? m + 1 | 0 : m) | 0, B = B >> 30, v = B, B = B + d | 0, m = v >>> 0 > B >>> 0 ? m + 1 | 0 : m, a[he >> 2] = B, a[he + 4 >> 2] = m, a[we + 280 >> 2] = o, a[we + 284 >> 2] = Dr, be = we + 320 | 0;
  }
  function di(B, o, m) {
    var d = 0, v = 0, he = 0, we = 0, Be = 0, Me = 0, fr = 0, wr = 0, dr = 0, Dr = 0, Rr = 0, Qe = 0, Fr = 0, Gr = 0, $r = 0, ni = 0, mi = 0, Si = 0, Oi = 0, $i = 0, zi = 0, un = 0, In = 0, Ti = 0, Sn = 0, Kn = 0, Vn = 0, Xn = 0, uo = 0;
    he = be - 288 | 0, be = he, vs(he + 224 | 0, o, m), d = he + 208 | 0, $i = a[he + 256 >> 2], $r = a[he + 260 >> 2], Lr(d, $i, $r, 0, 0, 801750719, 1076732275, 0, 0), ni = he + 176 | 0, Vn = a[he + 264 >> 2], un = a[he + 268 >> 2], Lr(ni, Vn, un, 0, 0, 801750719, 1076732275, 0, 0), dr = he + 192 | 0, Lr(dr, $i, $r, 0, 0, 1354194884, 1162945305, 0, 0), Oi = he + 144 | 0, Xn = a[he + 272 >> 2], Ti = a[he + 276 >> 2], Lr(Oi, Xn, Ti, 0, 0, 801750719, 1076732275, 0, 0), Gr = he + 160 | 0, Lr(Gr, Vn, un, 0, 0, 1354194884, 1162945305, 0, 0), Sn = he + 112 | 0, zi = a[he + 280 >> 2], Kn = a[he + 284 >> 2], Lr(Sn, zi, Kn, 0, 0, 801750719, 1076732275, 0, 0), In = he + 128 | 0, Lr(In, Xn, Ti, 0, 0, 1354194884, 1162945305, 0, 0), uo = he + 96 | 0, Lr(uo, zi, Kn, 0, 0, 1354194884, 1162945305, 0, 0), v = a[he + 224 >> 2], m = a[he + 208 >> 2], Rr = v + m | 0, Me = a[he + 228 >> 2], o = Me + a[he + 212 >> 2] | 0, mi = m >>> 0 > Rr >>> 0 ? o + 1 | 0 : o, v = (Me | 0) == (mi | 0) & v >>> 0 > Rr >>> 0 | Me >>> 0 > mi >>> 0, wr = a[he + 232 >> 2], o = d + 8 | 0, m = a[o >> 2], d = wr + m | 0, Dr = a[he + 236 >> 2], o = Dr + a[o + 4 >> 2] | 0, o = m >>> 0 > d >>> 0 ? o + 1 | 0 : o, m = d + v | 0, v = m >>> 0 < d >>> 0 ? o + 1 | 0 : o, o = v + a[he + 180 >> 2] | 0, Me = m, m = a[he + 176 >> 2], d = Me + m | 0, we = a[he + 192 >> 2], Qe = d + we | 0, m = m >>> 0 > d >>> 0 ? o + 1 | 0 : o, o = m + a[he + 196 >> 2] | 0, Fr = we >>> 0 > Qe >>> 0 ? o + 1 | 0 : o, fr = (m | 0) == (Fr | 0) & d >>> 0 > Qe >>> 0 | m >>> 0 > Fr >>> 0, Be = (m | 0) == (v | 0) & d >>> 0 < Me >>> 0 | m >>> 0 < v >>> 0, we = (v | 0) == (Dr | 0) & Me >>> 0 < wr >>> 0 | v >>> 0 < Dr >>> 0, m = a[he + 240 >> 2], Dr = m, d = dr + 8 | 0, v = a[d >> 2], o = ni + 8 | 0, wr = v + a[o >> 2] | 0, o = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, Si = a[he + 244 >> 2], o = Si + (v >>> 0 > wr >>> 0 ? o + 1 | 0 : o) | 0, m = m + wr | 0, o = m >>> 0 < wr >>> 0 ? o + 1 | 0 : o, d = m, m = m + we | 0, o = d >>> 0 > m >>> 0 ? o + 1 | 0 : o, d = m, m = m + Be | 0, o = d >>> 0 > m >>> 0 ? o + 1 | 0 : o, d = m, m = m + fr | 0, o = d >>> 0 > m >>> 0 ? o + 1 | 0 : o, fr = m, m = a[he + 144 >> 2], Be = fr + m | 0, d = o, o = o + a[he + 148 >> 2] | 0, o = m >>> 0 > Be >>> 0 ? o + 1 | 0 : o, m = a[he + 160 >> 2], we = m + Be | 0, v = o, o = o + a[he + 164 >> 2] | 0, m = m >>> 0 > we >>> 0 ? o + 1 | 0 : o, o = $r + m | 0, Me = we + $i | 0, $r = Me >>> 0 < $i >>> 0 ? o + 1 | 0 : o, ni = Me, dr = (m | 0) == ($r | 0) & Me >>> 0 < we >>> 0 | m >>> 0 > $r >>> 0, wr = (m | 0) == (v | 0) & we >>> 0 < Be >>> 0 | m >>> 0 < v >>> 0, Be = (d | 0) == (v | 0) & Be >>> 0 < fr >>> 0 | d >>> 0 > v >>> 0, we = (d | 0) == (Si | 0) & fr >>> 0 < Dr >>> 0 | d >>> 0 < Si >>> 0, m = a[he + 248 >> 2], Si = m, d = Gr + 8 | 0, v = a[d >> 2], o = Oi + 8 | 0, fr = v + a[o >> 2] | 0, o = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, $i = a[he + 252 >> 2], o = $i + (v >>> 0 > fr >>> 0 ? o + 1 | 0 : o) | 0, m = m + fr | 0, o = m >>> 0 < fr >>> 0 ? o + 1 | 0 : o, d = m, m = m + we | 0, o = d >>> 0 > m >>> 0 ? o + 1 | 0 : o, d = m, m = m + Be | 0, o = d >>> 0 > m >>> 0 ? o + 1 | 0 : o, d = m, m = m + wr | 0, o = d >>> 0 > m >>> 0 ? o + 1 | 0 : o, d = m, m = m + dr | 0, o = d >>> 0 > m >>> 0 ? o + 1 | 0 : o, fr = m, m = a[he + 112 >> 2], Be = fr + m | 0, d = o, o = o + a[he + 116 >> 2] | 0, o = m >>> 0 > Be >>> 0 ? o + 1 | 0 : o, m = a[he + 128 >> 2], we = m + Be | 0, v = o, o = o + a[he + 132 >> 2] | 0, m = m >>> 0 > we >>> 0 ? o + 1 | 0 : o, o = un + m | 0, un = he + 80 | 0, Gr = un, Me = we + Vn | 0, Oi = Me >>> 0 < Vn >>> 0 ? o + 1 | 0 : o, dr = Me, Dr = (m | 0) == (Oi | 0) & Me >>> 0 < we >>> 0 | m >>> 0 > Oi >>> 0, wr = (m | 0) == (v | 0) & we >>> 0 < Be >>> 0 | m >>> 0 < v >>> 0, we = (d | 0) == (v | 0) & Be >>> 0 < fr >>> 0 | d >>> 0 > v >>> 0, Me = (d | 0) == ($i | 0) & fr >>> 0 < Si >>> 0 | d >>> 0 < $i >>> 0, o = Sn + 8 | 0, d = a[o >> 2], v = a[o + 4 >> 2], Be = a[he + 96 >> 2], o = In + 8 | 0, m = a[o >> 2], Si = Be + m | 0, fr = a[he + 100 >> 2], o = fr + a[o + 4 >> 2] | 0, o = (m >>> 0 > Si >>> 0 ? o + 1 | 0 : o) + v | 0, m = d + Si | 0, o = m >>> 0 < Si >>> 0 ? o + 1 | 0 : o, d = m, m = m + Me | 0, o = d >>> 0 > m >>> 0 ? o + 1 | 0 : o, d = m, m = m + we | 0, o = d >>> 0 > m >>> 0 ? o + 1 | 0 : o, d = m, m = m + wr | 0, o = d >>> 0 > m >>> 0 ? o + 1 | 0 : o, v = m + Dr | 0, m = v >>> 0 < m >>> 0 ? o + 1 | 0 : o, o = Ti + m | 0, d = v, v = d + Xn | 0, o = v >>> 0 < Xn >>> 0 ? o + 1 | 0 : o, In = v, wr = o, Lr(Gr, v, o, 0, 0, 801750719, 1076732275, 0, 0), Ti = he + 48 | 0, we = Ti, Me = (o | 0) == (m | 0) & d >>> 0 > v >>> 0 | o >>> 0 < m >>> 0, v = (m | 0) == (fr | 0) & d >>> 0 < Be >>> 0 | m >>> 0 < fr >>> 0, o = uo + 8 | 0, m = a[o >> 2], d = m + zi | 0, o = Kn + a[o + 4 >> 2] | 0, o = m >>> 0 > d >>> 0 ? o + 1 | 0 : o, m = d + v | 0, o = m >>> 0 < d >>> 0 ? o + 1 | 0 : o, d = m, m = m + Me | 0, o = d >>> 0 > m >>> 0 ? o + 1 | 0 : o, Si = m, Gr = o, Lr(we, m, o, 0, 0, 801750719, 1076732275, 0, 0), $i = he - -64 | 0, Lr($i, In, wr, 0, 0, 1354194884, 1162945305, 0, 0), Sn = he + 32 | 0, Lr(Sn, m, o, 0, 0, 1354194884, 1162945305, 0, 0), m = a[he + 80 >> 2], Dr = m + Rr | 0, o = mi + a[he + 84 >> 2] | 0, Me = m >>> 0 > Dr >>> 0 ? o + 1 | 0 : o, v = (mi | 0) == (Me | 0) & Dr >>> 0 < Rr >>> 0 | Me >>> 0 < mi >>> 0, o = un + 8 | 0, m = a[o >> 2], d = m + Qe | 0, o = Fr + a[o + 4 >> 2] | 0, o = m >>> 0 > d >>> 0 ? o + 1 | 0 : o, m = d + v | 0, v = m >>> 0 < d >>> 0 ? o + 1 | 0 : o, o = v + a[he + 52 >> 2] | 0, Be = m, m = a[he + 48 >> 2], d = Be + m | 0, we = a[he + 64 >> 2], Rr = d + we | 0, m = m >>> 0 > d >>> 0 ? o + 1 | 0 : o, o = m + a[he + 68 >> 2] | 0, zi = (Gr | 0) == (Kn | 0) & Si >>> 0 < zi >>> 0 | Gr >>> 0 < Kn >>> 0, uo = zi ? 801750719 : 0, un = zi ? 1076732275 : 0, we = we >>> 0 > Rr >>> 0 ? o + 1 | 0 : o, mi = (m | 0) == (we | 0) & d >>> 0 > Rr >>> 0 | m >>> 0 > we >>> 0, fr = (m | 0) == (v | 0) & d >>> 0 < Be >>> 0 | m >>> 0 < v >>> 0, Be = (v | 0) == (Fr | 0) & Be >>> 0 < Qe >>> 0 | v >>> 0 < Fr >>> 0, o = Ti + 8 | 0, d = a[o >> 2], v = a[o + 4 >> 2], o = $i + 8 | 0, m = a[o >> 2], Qe = m + ni | 0, o = $r + a[o + 4 >> 2] | 0, o = (m >>> 0 > Qe >>> 0 ? o + 1 | 0 : o) + v | 0, m = d + Qe | 0, o = m >>> 0 < Qe >>> 0 ? o + 1 | 0 : o, d = m, m = m + Be | 0, o = d >>> 0 > m >>> 0 ? o + 1 | 0 : o, d = m, m = m + fr | 0, o = d >>> 0 > m >>> 0 ? o + 1 | 0 : o, d = m, m = m + mi | 0, d = d >>> 0 > m >>> 0 ? o + 1 | 0 : o, o = d + un | 0, Fr = m, m = m + uo | 0, o = Fr >>> 0 > m >>> 0 ? o + 1 | 0 : o, fr = m, m = a[he + 32 >> 2], Be = fr + m | 0, v = o, o = o + a[he + 36 >> 2] | 0, m = m >>> 0 > Be >>> 0 ? o + 1 | 0 : o, o = wr + m | 0, Qe = Be + In | 0, wr = Qe >>> 0 < In >>> 0 ? o + 1 | 0 : o, In = (m | 0) == (wr | 0) & Be >>> 0 > Qe >>> 0 | m >>> 0 > wr >>> 0, mi = (m | 0) == (v | 0) & Be >>> 0 < fr >>> 0 | m >>> 0 < v >>> 0, Be = (d | 0) == (v | 0) & fr >>> 0 < Fr >>> 0 | d >>> 0 > v >>> 0, v = (d | 0) == ($r | 0) & Fr >>> 0 < ni >>> 0 | d >>> 0 < $r >>> 0, o = Sn + 8 | 0, m = a[o >> 2], d = m + dr | 0, o = Oi + a[o + 4 >> 2] | 0, o = m >>> 0 > d >>> 0 ? o + 1 | 0 : o, m = d + v | 0, o = m >>> 0 < d >>> 0 ? o + 1 | 0 : o, d = m, m = m + Be | 0, o = d >>> 0 > m >>> 0 ? o + 1 | 0 : o, d = m, m = m + mi | 0, o = d >>> 0 > m >>> 0 ? o + 1 | 0 : o, d = m, m = m + In | 0, o = d >>> 0 > m >>> 0 ? o + 1 | 0 : o, Be = m, m = zi ? 1354194884 : 0, d = Be + m | 0, v = o, o = o + (zi ? 1162945305 : 0) | 0, m = m >>> 0 > d >>> 0 ? o + 1 | 0 : o, o = Gr + m | 0, $r = he + 16 | 0, ni = d + Si | 0, fr = ni >>> 0 < Si >>> 0 ? o + 1 | 0 : o, Fr = (m | 0) == (fr | 0) & d >>> 0 > ni >>> 0 | m >>> 0 > fr >>> 0, m = (m | 0) == (v | 0) & d >>> 0 < Be >>> 0 | m >>> 0 < v >>> 0, v = zi + ((v | 0) == (Oi | 0) & Be >>> 0 < dr >>> 0 | v >>> 0 < Oi >>> 0) | 0, o = zi >>> 0 > v >>> 0, m = m + v | 0, o = m >>> 0 < v >>> 0 ? o + 1 | 0 : o, dr = m + Fr | 0, o = dr >>> 0 < m >>> 0 ? o + 1 | 0 : o, Fr = o, Lr($r, dr, o, 0, 0, 801750719, 1076732275, 0, 0), Lr(he, dr, o, 0, 0, 1354194884, 1162945305, 0, 0), m = a[he + 16 >> 2], Gr = m, mi = a[he + 20 >> 2], o = mi + Me | 0, v = m + Dr | 0, Me = v >>> 0 < Dr >>> 0 ? o + 1 | 0 : o, m = a[he >> 2], Be = m, Oi = a[he + 4 >> 2], o = Oi + we | 0, d = m + Rr | 0, m = d >>> 0 < Rr >>> 0 ? o + 1 | 0 : o, we = d, d = (Me | 0) == (mi | 0) & v >>> 0 < Gr >>> 0 | Me >>> 0 < mi >>> 0, o = $r + 8 | 0, Rr = d + a[o >> 2] | 0, o = a[o + 4 >> 2], o = (d >>> 0 > Rr >>> 0 ? o + 1 | 0 : o) + m | 0, d = we + Rr | 0, Dr = d >>> 0 < Rr >>> 0 ? o + 1 | 0 : o, Rr = d, d = (m | 0) == (Dr | 0) & d >>> 0 < we >>> 0 | m >>> 0 > Dr >>> 0, m = (m | 0) == (Oi | 0) & we >>> 0 < Be >>> 0 | m >>> 0 < Oi >>> 0, o = he + 8 | 0, we = m + a[o >> 2] | 0, o = a[o + 4 >> 2], o = m >>> 0 > we >>> 0 ? o + 1 | 0 : o, Be = d + we | 0, we = Be >>> 0 < we >>> 0 ? o + 1 | 0 : o, o = wr + Fr | 0, d = dr + Qe | 0, m = d >>> 0 < Qe >>> 0 ? o + 1 | 0 : o, o = m + we | 0, Gr = (m | 0) == (Fr | 0) & d >>> 0 < dr >>> 0 | m >>> 0 < Fr >>> 0, wr = d, Be = d + Be | 0, d = Be >>> 0 < d >>> 0 ? o + 1 | 0 : o, o = wr, wr = Be, we = (m | 0) == (d | 0) & o >>> 0 > Be >>> 0 | m >>> 0 > d >>> 0, m = Gr + we | 0, we = m >>> 0 < we >>> 0, o = fr + we | 0, fr = m + ni | 0, o = fr >>> 0 < ni >>> 0 ? o + 1 | 0 : o, ni = (d | 0) == -1, Be = o, dr = ni & wr >>> 0 < 4294967294 | (d | 0) != -1 | (o & fr) != -1, Qe = (Dr | 0) == -1162945306, o = (dr | (Qe & Rr >>> 0 < 2940772411 | Dr >>> 0 < 3132021990)) ^ -1, dr = (o & ((Me | 0) == -1076732276 & v >>> 0 > 3493216576 | Me >>> 0 > 3218235020) | (o & (Qe & Rr >>> 0 > 2940772411 | Dr >>> 0 > 3132021990) | (wr | 0) == -1 & ni & (dr ^ -1))) + ((we | 0) == (Be | 0) & m >>> 0 > fr >>> 0 | we >>> 0 > Be >>> 0) | 0, m = oi(dr, 0, 801750719, 1076732275), we = m + v | 0, o = Me + Fe | 0, a[B >> 2] = we, o = m >>> 0 > we >>> 0 ? o + 1 | 0 : o, a[B + 4 >> 2] = o, m = B, Me = (o | 0) == (Me | 0) & v >>> 0 > we >>> 0 | o >>> 0 < Me >>> 0, B = oi(dr, 0, 1354194884, 1162945305), v = B + Rr | 0, o = Dr + Fe | 0, o = B >>> 0 > v >>> 0 ? o + 1 | 0 : o, B = o, Me = v + Me | 0, o = Me >>> 0 < v >>> 0 ? o + 1 | 0 : o, a[m + 8 >> 2] = Me, a[m + 12 >> 2] = o, Gr = (B | 0) == (Dr | 0) & v >>> 0 < Rr >>> 0 | B >>> 0 < Dr >>> 0, B = (B | 0) == (o | 0) & v >>> 0 > Me >>> 0 | B >>> 0 > o >>> 0, we = Gr + B | 0, Me = B >>> 0 > we >>> 0, o = d, v = wr + dr | 0, B = v >>> 0 < dr >>> 0 ? o + 1 | 0 : o, o = B + Me | 0, Me = v + we | 0, o = Me >>> 0 < v >>> 0 ? o + 1 | 0 : o, a[m + 16 >> 2] = Me, a[m + 20 >> 2] = o, d = (B | 0) == (d | 0) & v >>> 0 < wr >>> 0 | B >>> 0 < d >>> 0, B = (B | 0) == (o | 0) & v >>> 0 > Me >>> 0 | B >>> 0 > o >>> 0, v = d + B | 0, o = Be + (B >>> 0 > v >>> 0) | 0, B = v + fr | 0, o = B >>> 0 < fr >>> 0 ? o + 1 | 0 : o, a[m + 24 >> 2] = B, a[m + 28 >> 2] = o, be = he + 288 | 0;
  }
  function Ui(B, o, m, d) {
    var v = 0, he = 0, we = 0, Be = 0, Me = 0, fr = 0, wr = 0, dr = 0, Dr = 0, Rr = 0, Qe = 0, Fr = 0, Gr = 0, $r = 0, ni = 0, mi = 0, Si = 0, Oi = 0, $i = 0, zi = 0, un = 0, In = 0, Ti = 0, Sn = 0, Kn = 0, Vn = 0, Xn = 0, uo = 0, yo = 0, Io = 0, xo = 0, Mo = 0, qi = 0, Oo = 0, Ho = 0, Go = 0, ns = 0, ds = 0, Ts = 0, Ao = 0, po = 0, _o = 0, Uo = 0, ts = 0, Lo = 0, Wo = 0, ps = 0, Bs = 0, Xs = 0, js = 0, ya = 0, sa = 0, va = 0, oa = 0, wa = 0, Pa = 0, Ta = 0, jn = 0, ta = 0, Na = 0, ba = 0;
    wr = be - 3808 | 0, be = wr, v = wr + 3696 | 0, a[v >> 2] = 0, a[v + 4 >> 2] = 0, v = wr + 3704 | 0, a[v >> 2] = 0, a[v + 4 >> 2] = 0, v = wr + 3712 | 0, a[v >> 2] = 0, a[v + 4 >> 2] = 0, a[wr + 3688 >> 2] = 0, a[wr + 3692 >> 2] = 0, a[wr + 3680 >> 2] = 1, a[wr + 3684 >> 2] = 0;
    e: {
      if (!(!a[o + 120 >> 2] && a[m + 24 >> 2] | (a[m + 16 >> 2] | (a[m + 8 >> 2] | a[m >> 2])) | (a[m + 28 >> 2] | (a[m + 20 >> 2] | (a[m + 12 >> 2] | a[m + 4 >> 2]))))) {
        m = 0, o = 0;
        break e;
      }
      he = be - 128 | 0, be = he, Be = he - -64 | 0, vs(Be, m, 690640), a[he + 56 >> 2] = 0, a[he + 60 >> 2] = 0, Me = ((a[he + 108 >> 2] >>> 31 | 0) - 1 >>> 8 ^ -1) & 1, we = a[he + 112 >> 2], Rr = Me + we | 0, v = a[he + 116 >> 2], a[he + 32 >> 2] = Rr, v = we >>> 0 > Rr >>> 0 ? v + 1 | 0 : v, a[he + 36 >> 2] = v, Me = !v & Me >>> 0 > Rr >>> 0, we = a[he + 120 >> 2], Rr = Me + we | 0, v = a[he + 124 >> 2], a[he + 40 >> 2] = Rr, v = we >>> 0 > Rr >>> 0 ? v + 1 | 0 : v, a[he + 44 >> 2] = v, a[he + 48 >> 2] = !v & Me >>> 0 > Rr >>> 0, a[he + 52 >> 2] = 0, vs(Be, m, 690672), a[he + 24 >> 2] = 0, a[he + 28 >> 2] = 0, Me = ((a[he + 108 >> 2] >>> 31 | 0) - 1 >>> 8 ^ -1) & 1, we = a[he + 112 >> 2], Be = Me + we | 0, v = a[he + 116 >> 2], a[he >> 2] = Be, v = we >>> 0 > Be >>> 0 ? v + 1 | 0 : v, a[he + 4 >> 2] = v, we = !v & Be >>> 0 < Me >>> 0, ni = he, he = a[he + 120 >> 2], Me = we + he | 0, v = a[ni + 124 >> 2], a[ni + 8 >> 2] = Me, v = he >>> 0 > Me >>> 0 ? v + 1 | 0 : v, a[ni + 12 >> 2] = v, a[ni + 16 >> 2] = !v & we >>> 0 > Me >>> 0, a[ni + 20 >> 2] = 0, v = ni + 32 | 0, di(v, v, 690576), di(ni, ni, 690608), Me = a[ni >> 2], we = a[ni + 32 >> 2], he = Me + we | 0, Be = a[ni + 4 >> 2], v = Be + a[ni + 36 >> 2] | 0, mi = he >>> 0 < we >>> 0 ? v + 1 | 0 : v, Dr = he, Rr = (Be | 0) == (mi | 0) & he >>> 0 < Me >>> 0 | Be >>> 0 > mi >>> 0, he = a[ni + 40 >> 2], Me = Rr + he | 0, v = a[ni + 44 >> 2], Be = a[ni + 8 >> 2], we = Be + Me | 0, he = he >>> 0 > Me >>> 0 ? v + 1 | 0 : v, v = he + a[ni + 12 >> 2] | 0, fr = !he & Me >>> 0 < Rr >>> 0, $r = we >>> 0 < Be >>> 0 ? v + 1 | 0 : v, Gr = we, he = (he | 0) == ($r | 0) & Me >>> 0 > we >>> 0 | he >>> 0 > $r >>> 0, we = fr + he | 0, fr = he >>> 0 > we >>> 0, v = fr + a[ni + 52 >> 2] | 0, he = a[ni + 48 >> 2], Rr = he + we | 0, Be = a[ni + 16 >> 2], Me = Rr + Be | 0, he = he >>> 0 > Rr >>> 0 ? v + 1 | 0 : v, v = he + a[ni + 20 >> 2] | 0, we = (he | 0) == (fr | 0) & we >>> 0 > Rr >>> 0 | he >>> 0 < fr >>> 0, Be = Be >>> 0 > Me >>> 0 ? v + 1 | 0 : v, Si = Me, he = (he | 0) == (Be | 0) & Rr >>> 0 > Me >>> 0 | he >>> 0 > Be >>> 0, we = we + he | 0, Rr = he >>> 0 > we >>> 0, v = Rr + a[ni + 60 >> 2] | 0, he = a[ni + 56 >> 2], Me = he + we | 0, fr = a[ni + 24 >> 2], Qe = Me + fr | 0, he = he >>> 0 > Me >>> 0 ? v + 1 | 0 : v, v = he + a[ni + 28 >> 2] | 0, Fr = fr >>> 0 > Qe >>> 0 ? v + 1 | 0 : v, fr = ((he | 0) == (Rr | 0) & we >>> 0 > Me >>> 0 | he >>> 0 < Rr >>> 0) + ((he | 0) == (Fr | 0) & Me >>> 0 > Qe >>> 0 | he >>> 0 > Fr >>> 0) | 0, we = (Be | 0) == -1, he = we & Si >>> 0 < 4294967294 | (Be | 0) != -1 | (Qe & Fr) != -1, Me = ($r | 0) == -1162945306, v = (he | (Me & Gr >>> 0 < 2940772411 | $r >>> 0 < 3132021990)) ^ -1, zi = fr + (v & ((mi | 0) == -1076732276 & Dr >>> 0 > 3493216576 | mi >>> 0 > 3218235020) | (v & (Me & Gr >>> 0 > 2940772411 | $r >>> 0 > 3132021990) | (Si | 0) == -1 & we & (he ^ -1))) | 0, we = oi(zi, 0, 801750719, 1076732275), he = we + Dr | 0, v = mi + Fe | 0, fr = wr + 3720 | 0, a[fr >> 2] = he, Rr = he >>> 0 < we >>> 0 ? v + 1 | 0 : v, a[fr + 4 >> 2] = Rr, Me = fr, we = oi(zi, 0, 1354194884, 1162945305), dr = we + Gr | 0, v = $r + Fe | 0, he = (Rr | 0) == (mi | 0) & he >>> 0 < Dr >>> 0 | Rr >>> 0 < mi >>> 0, fr = dr + he | 0, v = we >>> 0 > dr >>> 0 ? v + 1 | 0 : v, we = v, a[Me + 8 >> 2] = fr, Dr = he >>> 0 > fr >>> 0 ? v + 1 | 0 : v, a[Me + 12 >> 2] = Dr, v = Be, Rr = Si + zi | 0, he = Rr >>> 0 < Si >>> 0 ? v + 1 | 0 : v, v = (we | 0) == ($r | 0) & dr >>> 0 < Gr >>> 0 | we >>> 0 < $r >>> 0, we = (we | 0) == (Dr | 0) & fr >>> 0 < dr >>> 0 | we >>> 0 > Dr >>> 0, fr = v + we | 0, v = (we >>> 0 > fr >>> 0) + he | 0, we = fr + Rr | 0, v = we >>> 0 < fr >>> 0 ? v + 1 | 0 : v, a[Me + 16 >> 2] = we, a[Me + 20 >> 2] = v, Gr = Me, Be = (he | 0) == (Be | 0) & Rr >>> 0 < Si >>> 0 | he >>> 0 < Be >>> 0, he = (v | 0) == (he | 0) & we >>> 0 < Rr >>> 0 | v >>> 0 < he >>> 0, we = Be + he | 0, v = Fr + (he >>> 0 > we >>> 0) | 0, he = we + Qe | 0, v = he >>> 0 < Qe >>> 0 ? v + 1 | 0 : v, a[Me + 24 >> 2] = he, a[Me + 28 >> 2] = v, Me = wr + 2560 | 0, di(Me, Gr, 690704), un = a[Me + 24 >> 2], Qe = a[Me + 16 >> 2], Rr = a[Me + 8 >> 2], he = a[Me >> 2], Dr = a[Me + 28 >> 2], fr = a[Me + 20 >> 2], dr = a[Me + 12 >> 2], Be = a[Me + 4 >> 2], v = un | (Qe | (Rr | he)) | (Dr | (fr | (dr | Be))) ? -1 : 0, Si = he ^ -1, we = Si - 801750718 | 0, zi = v & we, a[Me >> 2] = zi, he = v, Be = Be ^ -1, v = Be - ((Si >>> 0 < 801750718) + 1076732275 | 0) | 0, Fr = he & v, a[Me + 4 >> 2] = Fr, we = (v | 0) == (Be | 0) & we >>> 0 < Si >>> 0 | v >>> 0 < Be >>> 0, Rr = Rr ^ -1, mi = we + Rr | 0, Si = dr ^ -1, v = Si, Be = mi - 1354194885 | 0, $r = Be & he, a[Me + 8 >> 2] = $r, v = we >>> 0 > mi >>> 0 ? v + 1 | 0 : v, dr = v - ((mi >>> 0 < 1354194885) + 1162945305 | 0) | 0, we = dr & he, a[Me + 12 >> 2] = we, Be = (v | 0) == (dr | 0) & Be >>> 0 < mi >>> 0 | v >>> 0 > dr >>> 0, Rr = Be + ((v | 0) == (Si | 0) & Rr >>> 0 > mi >>> 0 | v >>> 0 < Si >>> 0) | 0, Si = Qe ^ -1, Xn = Si + Rr | 0, Qe = fr ^ -1, v = Qe + (Be >>> 0 > Rr >>> 0) | 0, v = Si >>> 0 > Xn >>> 0 ? v + 1 | 0 : v, dr = v - (Xn >>> 0 < 2) | 0, Rr = dr & he, mi = Rr, Be = Xn - 2 | 0, fr = Be & he, a[Me + 16 >> 2] = fr, a[Me + 20 >> 2] = Rr, Be = (v | 0) == (dr | 0) & Be >>> 0 < Xn >>> 0 | v >>> 0 > dr >>> 0, Rr = Be + ((v | 0) == (Qe | 0) & Si >>> 0 > Xn >>> 0 | v >>> 0 < Qe >>> 0) | 0, v = Be >>> 0 > Rr >>> 0, Be = Rr - un | 0, Xn = Be - 2 & he, a[Me + 24 >> 2] = Xn, dr = (v - ((Rr >>> 0 < un >>> 0) + Dr | 0) | 0) - (Be >>> 0 < 2) & he, a[Me + 28 >> 2] = dr, he = a[m >> 2], Be = he, Rr = a[m + 4 >> 2], v = Rr + Fr | 0, he = he + zi | 0, v = he >>> 0 < zi >>> 0 ? v + 1 | 0 : v, Fr = he, a[Me >> 2] = he, Si = v, a[Me + 4 >> 2] = v, v = we, Dr = (Rr | 0) == (Si | 0) & he >>> 0 < Be >>> 0 | Rr >>> 0 > Si >>> 0, he = Dr + $r | 0, we = he >>> 0 < $r >>> 0 ? v + 1 | 0 : v, v = we + a[m + 12 >> 2] | 0, Be = he, Rr = a[m + 8 >> 2], he = he + Rr | 0, Qe = he, a[Me + 8 >> 2] = he, $r = he >>> 0 < Rr >>> 0 ? v + 1 | 0 : v, a[Me + 12 >> 2] = $r, In = a[m + 16 >> 2], fr = In + fr | 0, un = a[m + 20 >> 2], v = un + mi | 0, he = fr >>> 0 < In >>> 0 ? v + 1 | 0 : v, v = !we & Be >>> 0 < Dr >>> 0, we = (we | 0) == ($r | 0) & Be >>> 0 > Qe >>> 0 | we >>> 0 > $r >>> 0, Be = v + we | 0, v = (we >>> 0 > Be >>> 0) + he | 0, we = Be + fr | 0, v = we >>> 0 < Be >>> 0 ? v + 1 | 0 : v, mi = we, a[Me + 16 >> 2] = we, Be = v, a[Me + 20 >> 2] = v, we = a[m + 24 >> 2], Dr = we, zi = a[m + 28 >> 2], v = zi + dr | 0, we = we + Xn | 0, m = we >>> 0 < Xn >>> 0 ? v + 1 | 0 : v, Rr = we, v = (he | 0) == (un | 0) & fr >>> 0 < In >>> 0 | he >>> 0 < un >>> 0, he = (he | 0) == (Be | 0) & fr >>> 0 > mi >>> 0 | he >>> 0 > Be >>> 0, fr = v + he | 0, v = (he >>> 0 > fr >>> 0) + m | 0, dr = we + fr | 0, v = dr >>> 0 < fr >>> 0 ? v + 1 | 0 : v, we = Me, fr = v, Rr = ((m | 0) == (zi | 0) & Dr >>> 0 > Rr >>> 0 | m >>> 0 < zi >>> 0) + ((m | 0) == (v | 0) & dr >>> 0 < Rr >>> 0 | m >>> 0 > v >>> 0) | 0, he = (Be | 0) == -1, v = he & mi >>> 0 < 4294967294 | (Be | 0) != -1 | (v & dr) != -1, Me = ($r | 0) == -1162945306, m = (v | (Me & Qe >>> 0 < 2940772411 | $r >>> 0 < 3132021990)) ^ -1, zi = Rr + (m & ((Si | 0) == -1076732276 & Fr >>> 0 > 3493216576 | Si >>> 0 > 3218235020) | (m & (Me & Qe >>> 0 > 2940772411 | $r >>> 0 > 3132021990) | (mi | 0) == -1 & he & (v ^ -1))) | 0, he = oi(zi, 0, 801750719, 1076732275), m = he + Fr | 0, v = Si + Fe | 0, a[we >> 2] = m, Me = m >>> 0 < he >>> 0 ? v + 1 | 0 : v, a[we + 4 >> 2] = Me, he = oi(zi, 0, 1354194884, 1162945305), Dr = he + Qe | 0, v = $r + Fe | 0, m = (Me | 0) == (Si | 0) & m >>> 0 < Fr >>> 0 | Me >>> 0 < Si >>> 0, Rr = Dr + m | 0, v = he >>> 0 > Dr >>> 0 ? v + 1 | 0 : v, he = v, a[we + 8 >> 2] = Rr, Fr = m >>> 0 > Rr >>> 0 ? v + 1 | 0 : v, a[we + 12 >> 2] = Fr, v = Be, Me = mi + zi | 0, m = Me >>> 0 < mi >>> 0 ? v + 1 | 0 : v, v = (he | 0) == ($r | 0) & Qe >>> 0 > Dr >>> 0 | he >>> 0 < $r >>> 0, he = (he | 0) == (Fr | 0) & Dr >>> 0 > Rr >>> 0 | he >>> 0 > Fr >>> 0, Rr = v + he | 0, v = (he >>> 0 > Rr >>> 0) + m | 0, he = Me + Rr | 0, v = he >>> 0 < Rr >>> 0 ? v + 1 | 0 : v, a[we + 16 >> 2] = he, a[we + 20 >> 2] = v, Be = (m | 0) == (Be | 0) & Me >>> 0 < mi >>> 0 | m >>> 0 < Be >>> 0, m = (m | 0) == (v | 0) & he >>> 0 < Me >>> 0 | m >>> 0 > v >>> 0, he = Be + m | 0, v = fr + (m >>> 0 > he >>> 0) | 0, m = he + dr | 0, v = m >>> 0 < dr >>> 0 ? v + 1 | 0 : v, a[we + 24 >> 2] = m, a[we + 28 >> 2] = v, be = ni + 128 | 0, Na = wr, ba = kn(wr + 496 | 0, we, 5), a[Na + 1528 >> 2] = ba, ta = kn(wr + 1012 | 0, Gr, 5), a[wr + 1532 >> 2] = ta, Xs = a[wr + 1528 >> 2], Go = wr + 3088 | 0, dn(Go, o, 128), m = wr + 1536 | 0, Uo = wr + 2240 | 0, Bs = wr + 3680 | 0, Dr = 0, Fr = 0, dr = 0, Be = 0, $r = be - 720 | 0, be = $r;
      t: {
        if (a[Go + 120 >> 2]) {
          a[$r + 672 >> 2] = 1, xi($r + 552 | 0, 120), Me = 0, we = 0;
          break t;
        }
        os($r + 552 | 0, Go), o = $r + 664 | 0, dr = a[o >> 2], Be = a[o + 4 >> 2], o = $r + 648 | 0, $i = a[o >> 2], Oi = a[o + 4 >> 2], o = $r + 640 | 0, Sn = a[o >> 2], Ti = a[o + 4 >> 2], Dr = a[$r + 632 >> 2], Fr = a[$r + 636 >> 2], o = $r + 656 | 0, Me = a[o >> 2], we = a[o + 4 >> 2];
      }
      for (yo = $r + 552 | 0, he = yo + 8 | 0, v = a[he + 4 >> 2], _o = $r + 336 | 0, o = _o + 8 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, he = yo + 16 | 0, v = a[he + 4 >> 2], o = _o + 16 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, he = yo + 24 | 0, v = a[he + 4 >> 2], o = _o + 24 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, he = yo + 32 | 0, v = a[he + 4 >> 2], o = _o + 32 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, he = yo + 48 | 0, v = a[he + 4 >> 2], o = _o + 48 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, he = yo + 56 | 0, v = a[he + 4 >> 2], o = _o + 56 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, he = yo - -64 | 0, v = a[he + 4 >> 2], o = _o - -64 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, he = yo + 72 | 0, v = a[he + 4 >> 2], o = _o + 72 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, a[$r + 416 >> 2] = 0, o = a[$r + 556 >> 2], a[$r + 336 >> 2] = a[$r + 552 >> 2], a[$r + 340 >> 2] = o, o = a[$r + 596 >> 2], a[$r + 376 >> 2] = a[$r + 592 >> 2], a[$r + 380 >> 2] = o, Vn = $r + 304 | 0, uo = Dr << 1, Mo = Fr << 1 | Dr >>> 31, Lr(Vn, Me, we, 0, 0, uo, Mo, 0, 0), Kn = $r + 224 | 0, he = $i, o = Oi, Rr = Sn << 1, fr = Ti << 1 | Sn >>> 31, Lr(Kn, he, o, 0, 0, Rr, fr, 0, 0), Qe = $r + 160 | 0, v = Be, Lr(Qe, dr, v, 0, 0, dr, v, 0, 0), Si = $r + 144 | 0, Lr(Si, a[$r + 160 >> 2], a[$r + 164 >> 2], 0, 0, 15632, 16, 0, 0), Be = dr, v = v << 1 | Be >>> 31, Ts = $r + 112 | 0, Ao = Be << 1, Xn = v, Lr(Ts, Ao, v, 0, 0, Dr, Fr, 0, 0), po = $r + 272 | 0, Lr(po, Me, we, 0, 0, Rr, fr, 0, 0), qi = $r + 208 | 0, Lr(qi, he, o, 0, 0, he, o, 0, 0), zi = $r + 128 | 0, v = Qe + 8 | 0, Lr(zi, a[v >> 2], a[v + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), ps = $r + 320 | 0, Lr(ps, Dr, Fr, 0, 0, Dr, Fr, 0, 0), ts = $r + 96 | 0, Lr(ts, Ao, Xn, 0, 0, Sn, Ti, 0, 0), mi = o, In = he, v = o << 1 | he >>> 31, Lo = $r + 176 | 0, $i = Me, Oi = we, Lr(Lo, Me, we, 0, 0, he << 1, v, 0, 0), fr = a[$r + 304 >> 2], he = a[$r + 224 >> 2], o = fr + he | 0, Io = a[$r + 308 >> 2], v = Io + a[$r + 228 >> 2] | 0, v = o >>> 0 < he >>> 0 ? v + 1 | 0 : v, he = a[$r + 144 >> 2], un = he + o | 0, we = v, v = v + a[$r + 148 >> 2] | 0, Rr = he >>> 0 > un >>> 0 ? v + 1 | 0 : v, ns = a[$r + 272 >> 2], he = a[$r + 208 >> 2], Qe = ns + he | 0, ds = a[$r + 276 >> 2], v = ds + a[$r + 212 >> 2] | 0, v = he >>> 0 > Qe >>> 0 ? v + 1 | 0 : v, he = a[$r + 112 >> 2], Gr = he + Qe | 0, Be = v, v = v + a[$r + 116 >> 2] | 0, v = he >>> 0 > Gr >>> 0 ? v + 1 | 0 : v, he = a[$r + 128 >> 2], Dr = he + Gr | 0, Me = v, v = v + a[$r + 132 >> 2] | 0, he = he >>> 0 > Dr >>> 0 ? v + 1 | 0 : v, ni = (we | 0) == (Rr | 0) & o >>> 0 > un >>> 0 | we >>> 0 > Rr >>> 0, v = Si + 8 | 0, dr = a[v >> 2], Fr = a[v + 4 >> 2], fr = (we | 0) == (Io | 0) & o >>> 0 < fr >>> 0 | we >>> 0 < Io >>> 0, v = Kn + 8 | 0, we = a[v >> 2], o = Vn + 8 | 0, Si = we + a[o >> 2] | 0, v = a[o + 4 >> 2] + a[v + 4 >> 2] | 0, v = we >>> 0 > Si >>> 0 ? v + 1 | 0 : v, o = fr + Si | 0, v = (o >>> 0 < Si >>> 0 ? v + 1 | 0 : v) + Fr | 0, we = o, o = o + dr | 0, v = we >>> 0 > o >>> 0 ? v + 1 | 0 : v, we = o, o = o + ni | 0, v = we >>> 0 > o >>> 0 ? v + 1 | 0 : v, Si = Rr, Rr = o << 12 | Rr >>> 20, Fr = Rr + Dr | 0, we = v, v = he + (v << 12 | o >>> 20) | 0, Rr = Fr >>> 0 < Rr >>> 0 ? v + 1 | 0 : v, Wo = $r + 80 | 0, Io = Wo, Oo = a[$r + 96 >> 2], o = a[$r + 176 >> 2], dr = Oo + o | 0, xo = a[$r + 100 >> 2], v = xo + a[$r + 180 >> 2] | 0, o = o >>> 0 > dr >>> 0 ? v + 1 | 0 : v, Vn = (he | 0) == (Rr | 0) & Dr >>> 0 > Fr >>> 0 | he >>> 0 > Rr >>> 0, Kn = (he | 0) == (Me | 0) & Dr >>> 0 < Gr >>> 0 | he >>> 0 < Me >>> 0, v = zi + 8 | 0, zi = a[v >> 2], ni = a[v + 4 >> 2], Gr = (Be | 0) == (Me | 0) & Qe >>> 0 > Gr >>> 0 | Be >>> 0 > Me >>> 0, v = Ts + 8 | 0, Dr = a[v >> 2], fr = a[v + 4 >> 2], Be = (Be | 0) == (ds | 0) & Qe >>> 0 < ns >>> 0 | Be >>> 0 < ds >>> 0, Me = qi + 8 | 0, he = a[Me >> 2], v = po + 8 | 0, Qe = he + a[v >> 2] | 0, v = a[v + 4 >> 2] + a[Me + 4 >> 2] | 0, v = he >>> 0 > Qe >>> 0 ? v + 1 | 0 : v, he = Be + Qe | 0, v = (he >>> 0 < Qe >>> 0 ? v + 1 | 0 : v) + fr | 0, Be = he, he = he + Dr | 0, v = Be >>> 0 > he >>> 0 ? v + 1 | 0 : v, Be = he, he = he + Gr | 0, v = (Be >>> 0 > he >>> 0 ? v + 1 | 0 : v) + ni | 0, Be = he, he = he + zi | 0, v = Be >>> 0 > he >>> 0 ? v + 1 | 0 : v, Me = he + Kn | 0, v = Me >>> 0 < he >>> 0 ? v + 1 | 0 : v, we = we >>> 20 | 0, he = we + Me | 0, v = we >>> 0 > he >>> 0 ? v + 1 | 0 : v, we = he, he = he + Vn | 0, we = we >>> 0 > he >>> 0 ? v + 1 | 0 : v, Me = we << 12 | he >>> 20, v = he << 12, he = Rr, Rr = v | he >>> 20, Be = Rr + dr | 0, v = o + Me | 0, Rr = Be >>> 0 < Rr >>> 0 ? v + 1 | 0 : v, Me = Be, v = Rr << 4 | Me >>> 28, fr = Me << 4 & -16, Be = v & 16777215, ni = he, Lr(Io, fr | he >>> 16 & 15, Be, 0, 0, 977, 1, 0, 0), fr = $r, Kn = a[fr + 80 >> 2], he = a[fr + 320 >> 2], Dr = Kn + he | 0, Ho = a[fr + 84 >> 2], v = Ho + a[fr + 324 >> 2] | 0, a[fr + 424 >> 2] = Dr, Be = he >>> 0 > Dr >>> 0 ? v + 1 | 0 : v, a[fr + 428 >> 2] = Be & 1048575, Ts = fr + 256 | 0, Lr(Ts, Sn, Ti, 0, 0, uo, Mo, 0, 0), po = fr - -64 | 0, Lr(po, Ao, Xn, 0, 0, In, mi, 0, 0), qi = fr + 288 | 0, Lr(qi, $i, Oi, 0, 0, $i, Oi, 0, 0), ns = fr + 48 | 0, $r = ns, Io = a[fr + 64 >> 2], he = a[fr + 288 >> 2], zi = Io + he | 0, ds = a[fr + 68 >> 2], v = ds + a[fr + 292 >> 2] | 0, he = he >>> 0 > zi >>> 0 ? v + 1 | 0 : v, Qe = zi, Gr = (o | 0) == (Rr | 0) & Me >>> 0 < dr >>> 0 | o >>> 0 > Rr >>> 0, dr = (o | 0) == (xo | 0) & dr >>> 0 < Oo >>> 0 | o >>> 0 < xo >>> 0, v = Lo + 8 | 0, Me = a[v >> 2], o = ts + 8 | 0, Vn = Me + a[o >> 2] | 0, v = a[o + 4 >> 2] + a[v + 4 >> 2] | 0, v = Me >>> 0 > Vn >>> 0 ? v + 1 | 0 : v, Me = dr + Vn | 0, v = Me >>> 0 < Vn >>> 0 ? v + 1 | 0 : v, we = we >>> 20 | 0, o = we + Me | 0, v = we >>> 0 > o >>> 0 ? v + 1 | 0 : v, we = o, o = o + Gr | 0, v = we >>> 0 > o >>> 0 ? v + 1 | 0 : v, we = o << 12 | Rr >>> 20, Qe = we + Qe | 0, Me = v, v = he + (v << 12 | o >>> 20) | 0, dr = we >>> 0 > Qe >>> 0 ? v + 1 | 0 : v, Lr($r, Qe, dr & 1048575, 0, 0, 15632, 16, 0, 0), Vn = a[fr + 48 >> 2], o = a[fr + 256 >> 2], $r = Vn + o | 0, Oo = a[fr + 52 >> 2], v = Oo + a[fr + 260 >> 2] | 0, o = o >>> 0 > $r >>> 0 ? v + 1 | 0 : v, Gr = $r, Dr = (Be | 0) == (Ho | 0) & Dr >>> 0 < Kn >>> 0 | Be >>> 0 < Ho >>> 0, Rr = ps + 8 | 0, we = a[Rr >> 2], v = Wo + 8 | 0, Kn = we + a[v >> 2] | 0, v = a[v + 4 >> 2] + a[Rr + 4 >> 2] | 0, v = we >>> 0 > Kn >>> 0 ? v + 1 | 0 : v, we = Dr + Kn | 0, v = we >>> 0 < Kn >>> 0 ? v + 1 | 0 : v, Be = we << 12 | Be >>> 20, Gr = Be + Gr | 0, Rr = v, v = o + (v << 12 | we >>> 20) | 0, a[fr + 432 >> 2] = Gr, Dr = Be >>> 0 > Gr >>> 0 ? v + 1 | 0 : v, a[fr + 436 >> 2] = Dr & 1048575, Kn = fr + 192 | 0, Lr(Kn, In, mi, 0, 0, uo, Mo, 0, 0), uo = fr + 240 | 0, Lr(uo, Sn, Ti, 0, 0, Sn, Ti, 0, 0), Sn = fr + 32 | 0, Lr(Sn, Ao, Xn, 0, 0, $i, Oi, 0, 0), In = fr + 16 | 0, mi = In, Qe = (he | 0) == (dr | 0) & Qe >>> 0 < zi >>> 0 | he >>> 0 > dr >>> 0, Be = (he | 0) == (ds | 0) & zi >>> 0 < Io >>> 0 | he >>> 0 < ds >>> 0, we = qi + 8 | 0, he = a[we >> 2], v = po + 8 | 0, Oi = he + a[v >> 2] | 0, v = a[v + 4 >> 2] + a[we + 4 >> 2] | 0, v = he >>> 0 > Oi >>> 0 ? v + 1 | 0 : v, we = Be + Oi | 0, v = we >>> 0 < Oi >>> 0 ? v + 1 | 0 : v, Me = Me >>> 20 | 0, he = we + Me | 0, v = Me >>> 0 > he >>> 0 ? v + 1 | 0 : v, we = he, he = he + Qe | 0, v = we >>> 0 > he >>> 0 ? v + 1 | 0 : v, zi = he << 12 | dr >>> 20, we = a[fr + 32 >> 2], dr = zi + we | 0, Be = v, Mo = v << 12 | he >>> 20, v = Mo + a[fr + 36 >> 2] | 0, Oi = we >>> 0 > dr >>> 0 ? v + 1 | 0 : v, Lr(mi, dr, Oi, 0, 0, 15632, 16, 0, 0), Ti = a[fr + 192 >> 2], he = a[fr + 240 >> 2], mi = Ti + he | 0, Xn = a[fr + 196 >> 2], v = Xn + a[fr + 244 >> 2] | 0, v = he >>> 0 > mi >>> 0 ? v + 1 | 0 : v, he = a[fr + 16 >> 2], Qe = he + mi | 0, Me = v, v = v + a[fr + 20 >> 2] | 0, he = he >>> 0 > Qe >>> 0 ? v + 1 | 0 : v, $i = (o | 0) == (Dr | 0) & Gr >>> 0 < $r >>> 0 | o >>> 0 > Dr >>> 0, Gr = (o | 0) == (Oo | 0) & $r >>> 0 < Vn >>> 0 | o >>> 0 < Oo >>> 0, v = Ts + 8 | 0, we = a[v >> 2], o = ns + 8 | 0, $r = we + a[o >> 2] | 0, v = a[o + 4 >> 2] + a[v + 4 >> 2] | 0, v = we >>> 0 > $r >>> 0 ? v + 1 | 0 : v, we = Gr + $r | 0, v = we >>> 0 < $r >>> 0 ? v + 1 | 0 : v, Rr = Rr >>> 20 | 0, o = we + Rr | 0, v = Rr >>> 0 > o >>> 0 ? v + 1 | 0 : v, we = o, o = o + $i | 0, v = we >>> 0 > o >>> 0 ? v + 1 | 0 : v, Rr = o << 12 | Dr >>> 20, Dr = Rr + Qe | 0, we = v, v = he + (v << 12 | o >>> 20) | 0, a[fr + 440 >> 2] = Dr, Rr = Dr >>> 0 < Rr >>> 0 ? v + 1 | 0 : v, a[fr + 444 >> 2] = Rr & 1048575, o = fr, Gr = (Oi | 0) == (Mo | 0) & dr >>> 0 < zi >>> 0 | Oi >>> 0 < Mo >>> 0, v = Sn + 8 | 0, dr = a[v >> 2], v = a[v + 4 >> 2], Be = Be >>> 20 | 0, fr = Be, Be = Be + dr | 0, v = fr >>> 0 > Be >>> 0 ? v + 1 | 0 : v, fr = Be, Be = Be + Gr | 0, v = fr >>> 0 > Be >>> 0 ? v + 1 | 0 : v, Lr(o, Be, v, 0, 0, 64028672, 65536, 0, 0), Be = o, Oi = a[o >> 2], o = un & -2, fr = Oi + o | 0, $i = a[Be + 4 >> 2], v = $i + (Si & 1048575) | 0, o = o >>> 0 > fr >>> 0 ? v + 1 | 0 : v, Si = (he | 0) == (Rr | 0) & Qe >>> 0 > Dr >>> 0 | he >>> 0 > Rr >>> 0, Qe = (he | 0) == (Me | 0) & Qe >>> 0 < mi >>> 0 | he >>> 0 < Me >>> 0, v = In + 8 | 0, Gr = a[v >> 2], dr = a[v + 4 >> 2], Dr = (Me | 0) == (Xn | 0) & mi >>> 0 < Ti >>> 0 | Me >>> 0 < Xn >>> 0, Me = uo + 8 | 0, he = a[Me >> 2], v = Kn + 8 | 0, mi = he + a[v >> 2] | 0, v = a[v + 4 >> 2] + a[Me + 4 >> 2] | 0, v = he >>> 0 > mi >>> 0 ? v + 1 | 0 : v, he = Dr + mi | 0, v = (he >>> 0 < mi >>> 0 ? v + 1 | 0 : v) + dr | 0, Me = he, he = he + Gr | 0, v = Me >>> 0 > he >>> 0 ? v + 1 | 0 : v, Me = he + Qe | 0, v = Me >>> 0 < he >>> 0 ? v + 1 | 0 : v, we = we >>> 20 | 0, he = we + Me | 0, v = we >>> 0 > he >>> 0 ? v + 1 | 0 : v, we = he, he = he + Si | 0, v = we >>> 0 > he >>> 0 ? v + 1 | 0 : v, Rr = he << 12 | Rr >>> 20, Me = Rr + fr | 0, we = v, v = o + (v << 12 | he >>> 20) | 0, a[Be + 448 >> 2] = Me, he = Me >>> 0 < Rr >>> 0 ? v + 1 | 0 : v, a[Be + 452 >> 2] = he & 1048575, dr = ni & 65535, Dr = (o | 0) == (he | 0) & fr >>> 0 > Me >>> 0 | o >>> 0 > he >>> 0, Rr = (o | 0) == ($i | 0) & fr >>> 0 < Oi >>> 0 | o >>> 0 < $i >>> 0, o = Be + 8 | 0, Me = Rr + a[o >> 2] | 0, v = a[o + 4 >> 2], v = Me >>> 0 < Rr >>> 0 ? v + 1 | 0 : v, we = we >>> 20 | 0, o = we + Me | 0, v = we >>> 0 > o >>> 0 ? v + 1 | 0 : v, we = o, o = o + Dr | 0, v = we >>> 0 > o >>> 0 ? v + 1 | 0 : v, he = o << 12 | he >>> 20, we = he + Fr | 0, v = dr + (v << 12 | o >>> 20) | 0, a[Be + 456 >> 2] = we, a[Be + 460 >> 2] = he >>> 0 > we >>> 0 ? v + 1 | 0 : v, o = Be + 680 | 0, mi = Be + 424 | 0, Rr = yo + 80 | 0, gn(o, mi, Rr), gn(m, Go, mi), gn(m + 40 | 0, Go + 40 | 0, o), he = a[Go + 120 >> 2], a[m + 80 >> 2] = he, v = m + 8 | 0, o = a[v + 4 >> 2], Si = mi + 8 | 0, a[Si >> 2] = a[v >> 2], a[Si + 4 >> 2] = o, v = m + 16 | 0, o = a[v + 4 >> 2], ni = mi + 16 | 0, a[ni >> 2] = a[v >> 2], a[ni + 4 >> 2] = o, v = m + 24 | 0, o = a[v + 4 >> 2], Qe = mi + 24 | 0, a[Qe >> 2] = a[v >> 2], a[Qe + 4 >> 2] = o, v = m + 32 | 0, o = a[v + 4 >> 2], Gr = mi + 32 | 0, a[Gr >> 2] = a[v >> 2], a[Gr + 4 >> 2] = o, v = m + 48 | 0, o = a[v + 4 >> 2], dr = mi + 48 | 0, a[dr >> 2] = a[v >> 2], a[dr + 4 >> 2] = o, v = m + 56 | 0, o = a[v + 4 >> 2], Dr = mi + 56 | 0, a[Dr >> 2] = a[v >> 2], a[Dr + 4 >> 2] = o, v = m - -64 | 0, o = a[v + 4 >> 2], Fr = mi - -64 | 0, a[Fr >> 2] = a[v >> 2], a[Fr + 4 >> 2] = o, v = m + 72 | 0, o = a[v + 4 >> 2], fr = mi + 72 | 0, a[fr >> 2] = a[v >> 2], a[fr + 4 >> 2] = o, a[Be + 544 >> 2] = he, o = a[m + 4 >> 2], a[Be + 424 >> 2] = a[m >> 2], a[Be + 428 >> 2] = o, o = a[m + 44 >> 2], a[Be + 464 >> 2] = a[m + 40 >> 2], a[Be + 468 >> 2] = o, he = Go + 112 | 0, v = a[he + 4 >> 2], o = mi + 112 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, he = Go + 104 | 0, v = a[he + 4 >> 2], o = mi + 104 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, he = Go + 96 | 0, v = a[he + 4 >> 2], o = mi + 96 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, he = Go + 88 | 0, v = a[he + 4 >> 2], o = mi + 88 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, Me = a[Go + 80 >> 2], we = a[Go + 84 >> 2], o = a[Be + 636 >> 2], a[Uo >> 2] = a[Be + 632 >> 2], a[Uo + 4 >> 2] = o, he = yo + 88 | 0, v = a[he + 4 >> 2], o = Uo + 8 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, he = yo + 96 | 0, v = a[he + 4 >> 2], o = Uo + 16 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, he = yo + 104 | 0, v = a[he + 4 >> 2], o = Uo + 24 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, he = yo + 112 | 0, v = a[he + 4 >> 2], o = Uo + 32 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, a[Be + 504 >> 2] = Me, a[Be + 508 >> 2] = we, Ei(mi, mi, _o, Uo + 40 | 0), a[m + 168 >> 2] = 0, o = a[Be + 428 >> 2], a[m + 88 >> 2] = a[Be + 424 >> 2], a[m + 92 >> 2] = o, v = a[Si + 4 >> 2], o = m + 96 | 0, a[o >> 2] = a[Si >> 2], a[o + 4 >> 2] = v, v = a[ni + 4 >> 2], o = m + 104 | 0, a[o >> 2] = a[ni >> 2], a[o + 4 >> 2] = v, v = a[Qe + 4 >> 2], o = m + 112 | 0, a[o >> 2] = a[Qe >> 2], a[o + 4 >> 2] = v, v = a[Gr + 4 >> 2], o = m + 120 | 0, a[o >> 2] = a[Gr >> 2], a[o + 4 >> 2] = v, v = a[Be + 468 >> 2], o = m + 128 | 0, a[o >> 2] = a[Be + 464 >> 2], a[o + 4 >> 2] = v, v = a[dr + 4 >> 2], o = m + 136 | 0, a[o >> 2] = a[dr >> 2], a[o + 4 >> 2] = v, v = a[Dr + 4 >> 2], o = m + 144 | 0, a[o >> 2] = a[Dr >> 2], a[o + 4 >> 2] = v, v = a[Fr + 4 >> 2], o = m + 152 | 0, a[o >> 2] = a[Fr >> 2], a[o + 4 >> 2] = v, v = a[fr + 4 >> 2], o = m + 160 | 0, a[o >> 2] = a[fr >> 2], a[o + 4 >> 2] = v, Ei(mi, mi, _o, Uo + 80 | 0), a[m + 256 >> 2] = 0, o = a[Be + 428 >> 2], a[m + 176 >> 2] = a[Be + 424 >> 2], a[m + 180 >> 2] = o, v = a[Si + 4 >> 2], o = m + 184 | 0, a[o >> 2] = a[Si >> 2], a[o + 4 >> 2] = v, v = a[ni + 4 >> 2], o = m + 192 | 0, a[o >> 2] = a[ni >> 2], a[o + 4 >> 2] = v, v = a[Qe + 4 >> 2], o = m + 200 | 0, a[o >> 2] = a[Qe >> 2], a[o + 4 >> 2] = v, v = a[Gr + 4 >> 2], o = m + 208 | 0, a[o >> 2] = a[Gr >> 2], a[o + 4 >> 2] = v, v = a[Be + 468 >> 2], o = m + 216 | 0, a[o >> 2] = a[Be + 464 >> 2], a[o + 4 >> 2] = v, v = a[dr + 4 >> 2], o = m + 224 | 0, a[o >> 2] = a[dr >> 2], a[o + 4 >> 2] = v, v = a[Dr + 4 >> 2], o = m + 232 | 0, a[o >> 2] = a[Dr >> 2], a[o + 4 >> 2] = v, v = a[Fr + 4 >> 2], o = m + 240 | 0, a[o >> 2] = a[Fr >> 2], a[o + 4 >> 2] = v, v = a[fr + 4 >> 2], o = m + 248 | 0, a[o >> 2] = a[fr >> 2], a[o + 4 >> 2] = v, Ei(mi, mi, _o, Uo + 120 | 0), a[m + 344 >> 2] = 0, o = a[Be + 428 >> 2], a[m + 264 >> 2] = a[Be + 424 >> 2], a[m + 268 >> 2] = o, v = a[Si + 4 >> 2], o = m + 272 | 0, a[o >> 2] = a[Si >> 2], a[o + 4 >> 2] = v, v = a[ni + 4 >> 2], o = m + 280 | 0, a[o >> 2] = a[ni >> 2], a[o + 4 >> 2] = v, v = a[Qe + 4 >> 2], o = m + 288 | 0, a[o >> 2] = a[Qe >> 2], a[o + 4 >> 2] = v, v = a[Gr + 4 >> 2], o = m + 296 | 0, a[o >> 2] = a[Gr >> 2], a[o + 4 >> 2] = v, v = a[Be + 468 >> 2], o = m + 304 | 0, a[o >> 2] = a[Be + 464 >> 2], a[o + 4 >> 2] = v, v = a[dr + 4 >> 2], o = m + 312 | 0, a[o >> 2] = a[dr >> 2], a[o + 4 >> 2] = v, v = a[Dr + 4 >> 2], o = m + 320 | 0, a[o >> 2] = a[Dr >> 2], a[o + 4 >> 2] = v, v = a[Fr + 4 >> 2], o = m + 328 | 0, a[o >> 2] = a[Fr >> 2], a[o + 4 >> 2] = v, v = a[fr + 4 >> 2], o = m + 336 | 0, a[o >> 2] = a[fr >> 2], a[o + 4 >> 2] = v, Ei(mi, mi, _o, Uo + 160 | 0), a[m + 432 >> 2] = 0, o = a[Be + 428 >> 2], a[m + 352 >> 2] = a[Be + 424 >> 2], a[m + 356 >> 2] = o, v = a[Si + 4 >> 2], o = m + 360 | 0, a[o >> 2] = a[Si >> 2], a[o + 4 >> 2] = v, v = a[ni + 4 >> 2], o = m + 368 | 0, a[o >> 2] = a[ni >> 2], a[o + 4 >> 2] = v, v = a[Qe + 4 >> 2], o = m + 376 | 0, a[o >> 2] = a[Qe >> 2], a[o + 4 >> 2] = v, v = a[Gr + 4 >> 2], o = m + 384 | 0, a[o >> 2] = a[Gr >> 2], a[o + 4 >> 2] = v, v = a[Be + 468 >> 2], o = m + 392 | 0, a[o >> 2] = a[Be + 464 >> 2], a[o + 4 >> 2] = v, v = a[dr + 4 >> 2], o = m + 400 | 0, a[o >> 2] = a[dr >> 2], a[o + 4 >> 2] = v, v = a[Dr + 4 >> 2], o = m + 408 | 0, a[o >> 2] = a[Dr >> 2], a[o + 4 >> 2] = v, v = a[Fr + 4 >> 2], o = m + 416 | 0, a[o >> 2] = a[Fr >> 2], a[o + 4 >> 2] = v, v = a[fr + 4 >> 2], o = m + 424 | 0, a[o >> 2] = a[fr >> 2], a[o + 4 >> 2] = v, Ei(mi, mi, _o, Uo + 200 | 0), a[m + 520 >> 2] = 0, o = a[Be + 428 >> 2], a[m + 440 >> 2] = a[Be + 424 >> 2], a[m + 444 >> 2] = o, v = a[Si + 4 >> 2], o = m + 448 | 0, a[o >> 2] = a[Si >> 2], a[o + 4 >> 2] = v, v = a[ni + 4 >> 2], o = m + 456 | 0, a[o >> 2] = a[ni >> 2], a[o + 4 >> 2] = v, v = a[Qe + 4 >> 2], o = m + 464 | 0, a[o >> 2] = a[Qe >> 2], a[o + 4 >> 2] = v, v = a[Gr + 4 >> 2], o = m + 472 | 0, a[o >> 2] = a[Gr >> 2], a[o + 4 >> 2] = v, v = a[Be + 468 >> 2], o = m + 480 | 0, a[o >> 2] = a[Be + 464 >> 2], a[o + 4 >> 2] = v, v = a[dr + 4 >> 2], o = m + 488 | 0, a[o >> 2] = a[dr >> 2], a[o + 4 >> 2] = v, v = a[Dr + 4 >> 2], o = m + 496 | 0, a[o >> 2] = a[Dr >> 2], a[o + 4 >> 2] = v, v = a[Fr + 4 >> 2], o = m + 504 | 0, a[o >> 2] = a[Fr >> 2], a[o + 4 >> 2] = v, v = a[fr + 4 >> 2], o = m + 512 | 0, a[o >> 2] = a[fr >> 2], a[o + 4 >> 2] = v, zi = Uo + 240 | 0, Ei(mi, mi, _o, zi), a[m + 608 >> 2] = 0, o = a[Be + 428 >> 2], a[m + 528 >> 2] = a[Be + 424 >> 2], a[m + 532 >> 2] = o, v = a[Si + 4 >> 2], o = m + 536 | 0, a[o >> 2] = a[Si >> 2], a[o + 4 >> 2] = v, v = a[ni + 4 >> 2], o = m + 544 | 0, a[o >> 2] = a[ni >> 2], a[o + 4 >> 2] = v, v = a[Qe + 4 >> 2], o = m + 552 | 0, a[o >> 2] = a[Qe >> 2], a[o + 4 >> 2] = v, v = a[Gr + 4 >> 2], o = m + 560 | 0, a[o >> 2] = a[Gr >> 2], a[o + 4 >> 2] = v, v = a[Be + 468 >> 2], o = m + 568 | 0, a[o >> 2] = a[Be + 464 >> 2], a[o + 4 >> 2] = v, v = a[dr + 4 >> 2], o = m + 576 | 0, a[o >> 2] = a[dr >> 2], a[o + 4 >> 2] = v, v = a[Dr + 4 >> 2], o = m + 584 | 0, a[o >> 2] = a[Dr >> 2], a[o + 4 >> 2] = v, v = a[Fr + 4 >> 2], o = m + 592 | 0, a[o >> 2] = a[Fr >> 2], a[o + 4 >> 2] = v, v = a[fr + 4 >> 2], o = m + 600 | 0, a[o >> 2] = a[fr >> 2], a[o + 4 >> 2] = v, we = Uo + 280 | 0, Ei(mi, mi, _o, we), a[m + 696 >> 2] = 0, o = a[Be + 428 >> 2], a[m + 616 >> 2] = a[Be + 424 >> 2], a[m + 620 >> 2] = o, v = a[Si + 4 >> 2], o = m + 624 | 0, a[o >> 2] = a[Si >> 2], a[o + 4 >> 2] = v, v = a[ni + 4 >> 2], o = m + 632 | 0, a[o >> 2] = a[ni >> 2], a[o + 4 >> 2] = v, v = a[Qe + 4 >> 2], o = m + 640 | 0, a[o >> 2] = a[Qe >> 2], a[o + 4 >> 2] = v, v = a[Gr + 4 >> 2], o = m + 648 | 0, a[o >> 2] = a[Gr >> 2], a[o + 4 >> 2] = v, v = a[Be + 468 >> 2], o = m + 656 | 0, a[o >> 2] = a[Be + 464 >> 2], a[o + 4 >> 2] = v, v = a[dr + 4 >> 2], o = m + 664 | 0, a[o >> 2] = a[dr >> 2], a[o + 4 >> 2] = v, v = a[Dr + 4 >> 2], o = m + 672 | 0, a[o >> 2] = a[Dr >> 2], a[o + 4 >> 2] = v, v = a[Fr + 4 >> 2], o = m + 680 | 0, a[o >> 2] = a[Fr >> 2], a[o + 4 >> 2] = v, v = a[fr + 4 >> 2], o = m + 688 | 0, a[o >> 2] = a[fr >> 2], a[o + 4 >> 2] = v, gn(Bs, mi + 80 | 0, Rr), be = Be + 720 | 0, dr = be - 928 | 0, be = dr, Me = m + 616 | 0, Be = Me + 72 | 0, he = a[Be >> 2], Rr = a[Me + 44 >> 2], v = a[Me + 40 >> 2], Fr = a[Be + 4 >> 2], o = oi(Fr >>> 16 | 0, 0, 977, 1), fr = v + o | 0, v = Rr + Fe | 0, a[Me + 40 >> 2] = fr, v = o >>> 0 > fr >>> 0 ? v + 1 | 0 : v, a[Me + 44 >> 2] = v & 1048575, Dr = Me + 48 | 0, fr = a[Dr >> 2], o = v, v = a[Dr + 4 >> 2], o = o >>> 20 | 0, Rr = o, o = o + fr | 0, v = Rr >>> 0 > o >>> 0 ? v + 1 | 0 : v, a[Dr >> 2] = o, a[Dr + 4 >> 2] = v & 1048575, Dr = Me + 56 | 0, fr = a[Dr >> 2], o = v, v = a[Dr + 4 >> 2], o = o >>> 20 | 0, Rr = o, o = o + fr | 0, v = Rr >>> 0 > o >>> 0 ? v + 1 | 0 : v, a[Dr >> 2] = o, a[Dr + 4 >> 2] = v & 1048575, fr = Me - -64 | 0, Rr = a[fr >> 2], o = v, v = a[fr + 4 >> 2], o = o >>> 20 | 0, Me = o, o = o + Rr | 0, v = Me >>> 0 > o >>> 0 ? v + 1 | 0 : v, a[fr >> 2] = o, a[fr + 4 >> 2] = v & 1048575, Me = Be, o = v, v = Fr & 65535, o = o >>> 20 | 0, Be = o, o = o + he | 0, v = Be >>> 0 > o >>> 0 ? v + 1 | 0 : v, a[Me >> 2] = o, a[Me + 4 >> 2] = v, he = we + 8 | 0, v = a[he + 4 >> 2], ds = dr + 808 | 0, o = ds + 8 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, he = we + 16 | 0, v = a[he + 4 >> 2], o = ds + 16 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, he = we + 24 | 0, v = a[he + 4 >> 2], o = ds + 24 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, he = we + 32 | 0, v = a[he + 4 >> 2], o = ds + 32 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, o = a[we + 4 >> 2], a[dr + 808 >> 2] = a[we >> 2], a[dr + 812 >> 2] = o, Bs = 6, xo = m + 528 | 0, he = xo + 8 | 0, v = a[he + 4 >> 2], Ho = dr + 680 | 0, o = Ho + 8 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, he = xo + 16 | 0, v = a[he + 4 >> 2], o = Ho + 16 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, he = xo + 24 | 0, v = a[he + 4 >> 2], o = Ho + 24 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, he = xo + 32 | 0, v = a[he + 4 >> 2], o = Ho + 32 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, he = xo + 48 | 0, v = a[he + 4 >> 2], o = Ho + 48 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, he = xo + 56 | 0, v = a[he + 4 >> 2], o = Ho + 56 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, he = xo - -64 | 0, v = a[he + 4 >> 2], o = Ho - -64 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, he = xo + 72 | 0, v = a[he + 4 >> 2], o = Ho + 72 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, o = a[xo + 4 >> 2], a[dr + 680 >> 2] = a[xo >> 2], a[dr + 684 >> 2] = o, o = a[xo + 44 >> 2], a[dr + 720 >> 2] = a[xo + 40 >> 2], a[dr + 724 >> 2] = o, Gr = a[dr + 840 >> 2], Be = a[dr + 844 >> 2], he = a[dr + 824 >> 2], Rr = a[dr + 828 >> 2], uo = a[dr + 816 >> 2], $r = a[dr + 820 >> 2], Me = a[dr + 832 >> 2], we = a[dr + 836 >> 2], Dr = a[dr + 808 >> 2], Fr = a[dr + 812 >> 2], a[dr + 800 >> 2] = 0, In = dr + 440 | 0, Mo = Dr << 1, Ao = Fr << 1 | Dr >>> 31, Lr(In, Me, we, 0, 0, Mo, Ao, 0, 0), un = dr + 504 | 0, o = Rr, Rr = uo << 1, fr = $r << 1 | uo >>> 31, Lr(un, he, o, 0, 0, Rr, fr, 0, 0), Si = dr + 632 | 0, v = Be, Lr(Si, Gr, v, 0, 0, Gr, v, 0, 0), ni = dr + 616 | 0, Lr(ni, a[dr + 632 >> 2], a[dr + 636 >> 2], 0, 0, 15632, 16, 0, 0), Be = Gr, v = v << 1 | Be >>> 31, Ts = dr + 472 | 0, Kn = Be << 1, Sn = v, Lr(Ts, Kn, v, 0, 0, Dr, Fr, 0, 0), po = dr + 488 | 0, Lr(po, Me, we, 0, 0, Rr, fr, 0, 0), qi = dr + 568 | 0, Lr(qi, he, o, 0, 0, he, o, 0, 0), Gr = dr + 600 | 0, v = Si + 8 | 0, Lr(Gr, a[v >> 2], a[v + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), ts = dr + 456 | 0, Lr(ts, Dr, Fr, 0, 0, Dr, Fr, 0, 0), Lo = dr + 536 | 0, Lr(Lo, Kn, Sn, 0, 0, uo, $r, 0, 0), Oi = o, Xn = he, v = o << 1 | he >>> 31, Wo = dr + 584 | 0, Ti = Me, $i = we, Lr(Wo, Me, we, 0, 0, he << 1, v, 0, 0), Me = a[dr + 440 >> 2], he = a[dr + 504 >> 2], o = Me + he | 0, Fr = a[dr + 444 >> 2], v = Fr + a[dr + 508 >> 2] | 0, v = o >>> 0 < he >>> 0 ? v + 1 | 0 : v, he = a[dr + 616 >> 2], mi = he + o | 0, we = v, v = v + a[dr + 620 >> 2] | 0, he = he >>> 0 > mi >>> 0 ? v + 1 | 0 : v, fr = (we | 0) == (he | 0) & o >>> 0 > mi >>> 0 | he >>> 0 < we >>> 0, v = ni + 8 | 0, Rr = a[v >> 2], Be = a[v + 4 >> 2], Me = (we | 0) == (Fr | 0) & o >>> 0 < Me >>> 0 | we >>> 0 < Fr >>> 0, v = un + 8 | 0, we = a[v >> 2], o = In + 8 | 0, Fr = we + a[o >> 2] | 0, v = a[o + 4 >> 2] + a[v + 4 >> 2] | 0, v = we >>> 0 > Fr >>> 0 ? v + 1 | 0 : v, o = Me + Fr | 0, v = (o >>> 0 < Fr >>> 0 ? v + 1 | 0 : v) + Be | 0, we = o, o = o + Rr | 0, v = we >>> 0 > o >>> 0 ? v + 1 | 0 : v, we = o, o = o + fr | 0, v = we >>> 0 > o >>> 0 ? v + 1 | 0 : v, Si = he, Rr = o << 12 | he >>> 20, Me = v, Be = v << 12 | o >>> 20, ns = a[dr + 488 >> 2], o = a[dr + 568 >> 2], Dr = ns + o | 0, Oo = a[dr + 492 >> 2], v = Oo + a[dr + 572 >> 2] | 0, v = o >>> 0 > Dr >>> 0 ? v + 1 | 0 : v, o = a[dr + 472 >> 2], Fr = o + Dr | 0, we = v, v = v + a[dr + 476 >> 2] | 0, v = o >>> 0 > Fr >>> 0 ? v + 1 | 0 : v, o = a[dr + 600 >> 2], fr = o + Fr | 0, he = v, v = v + a[dr + 604 >> 2] | 0, o = o >>> 0 > fr >>> 0 ? v + 1 | 0 : v, v = o + Be | 0, Io = dr + 376 | 0, Vn = Io, Rr = fr + Rr | 0, Be = Rr >>> 0 < fr >>> 0 ? v + 1 | 0 : v, In = (o | 0) == (Be | 0) & fr >>> 0 > Rr >>> 0 | o >>> 0 > Be >>> 0, un = (o | 0) == (he | 0) & fr >>> 0 < Fr >>> 0 | o >>> 0 < he >>> 0, o = Gr + 8 | 0, ni = a[o >> 2], Qe = a[o + 4 >> 2], Gr = (he | 0) == (we | 0) & Dr >>> 0 > Fr >>> 0 | he >>> 0 < we >>> 0, o = Ts + 8 | 0, Fr = a[o >> 2], fr = a[o + 4 >> 2], we = (we | 0) == (Oo | 0) & Dr >>> 0 < ns >>> 0 | we >>> 0 < Oo >>> 0, v = qi + 8 | 0, he = a[v >> 2], o = po + 8 | 0, Dr = he + a[o >> 2] | 0, v = a[o + 4 >> 2] + a[v + 4 >> 2] | 0, v = he >>> 0 > Dr >>> 0 ? v + 1 | 0 : v, o = we + Dr | 0, v = (o >>> 0 < Dr >>> 0 ? v + 1 | 0 : v) + fr | 0, he = o, o = o + Fr | 0, v = he >>> 0 > o >>> 0 ? v + 1 | 0 : v, he = o, o = o + Gr | 0, v = (he >>> 0 > o >>> 0 ? v + 1 | 0 : v) + Qe | 0, he = o, o = o + ni | 0, v = he >>> 0 > o >>> 0 ? v + 1 | 0 : v, he = o + un | 0, v = he >>> 0 < o >>> 0 ? v + 1 | 0 : v, we = Me >>> 20 | 0, o = he + we | 0, v = we >>> 0 > o >>> 0 ? v + 1 | 0 : v, he = o, o = o + In | 0, v = he >>> 0 > o >>> 0 ? v + 1 | 0 : v, he = Be, Be = o << 12 | he >>> 20, we = v, fr = v << 12 | o >>> 20, In = a[dr + 540 >> 2], v = In + a[dr + 588 >> 2] | 0, Qe = a[dr + 536 >> 2], o = a[dr + 584 >> 2], Me = Qe + o | 0, Dr = Me, Be = Me + Be | 0, o = o >>> 0 > Me >>> 0 ? v + 1 | 0 : v, v = o + fr | 0, Fr = Be << 4 & -16, Me = Be >>> 0 < Me >>> 0 ? v + 1 | 0 : v, fr = (Me << 4 | Be >>> 28) & 16777215, ni = he, Lr(Vn, Fr | he >>> 16 & 15, fr, 0, 0, 977, 1, 0, 0), fr = dr, Vn = a[fr + 376 >> 2], he = a[fr + 456 >> 2], Fr = Vn + he | 0, ps = a[fr + 380 >> 2], v = ps + a[fr + 460 >> 2] | 0, a[fr + 888 >> 2] = Fr, he = he >>> 0 > Fr >>> 0 ? v + 1 | 0 : v, a[fr + 892 >> 2] = he & 1048575, Oo = fr + 360 | 0, Lr(Oo, uo, $r, 0, 0, Mo, Ao, 0, 0), Ts = fr + 552 | 0, Lr(Ts, Kn, Sn, 0, 0, Xn, Oi, 0, 0), po = fr + 664 | 0, Lr(po, Ti, $i, 0, 0, Ti, $i, 0, 0), qi = fr + 424 | 0, un = qi, Gr = (o | 0) == (Me | 0) & Be >>> 0 < Dr >>> 0 | o >>> 0 > Me >>> 0, Dr = (o | 0) == (In | 0) & Qe >>> 0 > Dr >>> 0 | o >>> 0 < In >>> 0, v = Wo + 8 | 0, Be = a[v >> 2], o = Lo + 8 | 0, Qe = Be + a[o >> 2] | 0, v = a[o + 4 >> 2] + a[v + 4 >> 2] | 0, v = Be >>> 0 > Qe >>> 0 ? v + 1 | 0 : v, Be = Qe + Dr | 0, v = Be >>> 0 < Qe >>> 0 ? v + 1 | 0 : v, we = we >>> 20 | 0, o = we + Be | 0, v = we >>> 0 > o >>> 0 ? v + 1 | 0 : v, we = o, o = o + Gr | 0, v = we >>> 0 > o >>> 0 ? v + 1 | 0 : v, Dr = o << 12 | Me >>> 20, Be = v, we = v << 12 | o >>> 20, ns = a[fr + 552 >> 2], o = a[fr + 664 >> 2], In = ns + o | 0, Lo = a[fr + 556 >> 2], v = Lo + a[fr + 668 >> 2] | 0, Me = o >>> 0 > In >>> 0 ? v + 1 | 0 : v, v = Me + we | 0, Qe = Dr + In | 0, v = Qe >>> 0 < In >>> 0 ? v + 1 | 0 : v, Dr = v, Lr(un, Qe, v & 1048575, 0, 0, 15632, 16, 0, 0), Fr = (he | 0) == (ps | 0) & Fr >>> 0 < Vn >>> 0 | he >>> 0 < ps >>> 0, v = ts + 8 | 0, we = a[v >> 2], o = Io + 8 | 0, Gr = we + a[o >> 2] | 0, v = a[o + 4 >> 2] + a[v + 4 >> 2] | 0, v = we >>> 0 > Gr >>> 0 ? v + 1 | 0 : v, o = Fr + Gr | 0, v = o >>> 0 < Gr >>> 0 ? v + 1 | 0 : v, Gr = o << 12 | he >>> 20, we = v, Fr = v << 12 | o >>> 20, Io = a[fr + 424 >> 2], o = a[fr + 360 >> 2], un = Io + o | 0, Wo = a[fr + 428 >> 2], v = Wo + a[fr + 364 >> 2] | 0, he = o >>> 0 > un >>> 0 ? v + 1 | 0 : v, v = he + Fr | 0, Gr = Gr + un | 0, v = Gr >>> 0 < un >>> 0 ? v + 1 | 0 : v, a[fr + 896 >> 2] = Gr, Fr = v, a[fr + 900 >> 2] = v & 1048575, Vn = fr + 344 | 0, Lr(Vn, Xn, Oi, 0, 0, Mo, Ao, 0, 0), Mo = fr + 520 | 0, Lr(Mo, uo, $r, 0, 0, uo, $r, 0, 0), uo = fr + 648 | 0, Lr(uo, Kn, Sn, 0, 0, Ti, $i, 0, 0), Xn = fr + 408 | 0, Ti = Xn, Oi = (Me | 0) == (Dr | 0) & Qe >>> 0 < In >>> 0 | Me >>> 0 > Dr >>> 0, Qe = (Me | 0) == (Lo | 0) & In >>> 0 < ns >>> 0 | Me >>> 0 < Lo >>> 0, v = po + 8 | 0, Me = a[v >> 2], o = Ts + 8 | 0, $i = Me + a[o >> 2] | 0, v = a[o + 4 >> 2] + a[v + 4 >> 2] | 0, v = Me >>> 0 > $i >>> 0 ? v + 1 | 0 : v, Me = Qe + $i | 0, v = Me >>> 0 < $i >>> 0 ? v + 1 | 0 : v, Be = Be >>> 20 | 0, o = Be + Me | 0, v = Be >>> 0 > o >>> 0 ? v + 1 | 0 : v, Be = o, o = o + Oi | 0, v = Be >>> 0 > o >>> 0 ? v + 1 | 0 : v, $i = o << 12 | Dr >>> 20, Be = a[fr + 648 >> 2], Dr = $i + Be | 0, Me = v, In = v << 12 | o >>> 20, v = In + a[fr + 652 >> 2] | 0, Oi = Be >>> 0 > Dr >>> 0 ? v + 1 | 0 : v, Lr(Ti, Dr, Oi, 0, 0, 15632, 16, 0, 0), Be = fr, Gr = (he | 0) == (Fr | 0) & Gr >>> 0 < un >>> 0 | he >>> 0 > Fr >>> 0, fr = (he | 0) == (Wo | 0) & un >>> 0 < Io >>> 0 | he >>> 0 < Wo >>> 0, v = Oo + 8 | 0, he = a[v >> 2], o = qi + 8 | 0, Qe = he + a[o >> 2] | 0, v = a[o + 4 >> 2] + a[v + 4 >> 2] | 0, v = he >>> 0 > Qe >>> 0 ? v + 1 | 0 : v, he = fr + Qe | 0, v = he >>> 0 < Qe >>> 0 ? v + 1 | 0 : v, we = we >>> 20 | 0, o = he + we | 0, v = we >>> 0 > o >>> 0 ? v + 1 | 0 : v, he = o, o = o + Gr | 0, v = he >>> 0 > o >>> 0 ? v + 1 | 0 : v, Fr = o << 12 | Fr >>> 20, we = v, fr = v << 12 | o >>> 20, $r = a[Be + 344 >> 2], o = a[Be + 520 >> 2], Qe = $r + o | 0, un = a[Be + 348 >> 2], v = un + a[Be + 524 >> 2] | 0, v = o >>> 0 > Qe >>> 0 ? v + 1 | 0 : v, o = a[Be + 408 >> 2], Gr = o + Qe | 0, he = v, v = v + a[Be + 412 >> 2] | 0, o = o >>> 0 > Gr >>> 0 ? v + 1 | 0 : v, v = o + fr | 0, Fr = Fr + Gr | 0, v = Fr >>> 0 < Gr >>> 0 ? v + 1 | 0 : v, a[Be + 904 >> 2] = Fr, fr = v, a[Be + 908 >> 2] = v & 1048575, Ti = Be + 392 | 0, $i = (Oi | 0) == (In | 0) & Dr >>> 0 < $i >>> 0 | Oi >>> 0 < In >>> 0, v = uo + 8 | 0, Oi = a[v >> 2], v = a[v + 4 >> 2], Me = Me >>> 20 | 0, Dr = Me, Me = Me + Oi | 0, v = Dr >>> 0 > Me >>> 0 ? v + 1 | 0 : v, Dr = Me, Me = Me + $i | 0, v = Dr >>> 0 > Me >>> 0 ? v + 1 | 0 : v, Lr(Ti, Me, v, 0, 0, 64028672, 65536, 0, 0), Me = Be, Oi = (o | 0) == (fr | 0) & Fr >>> 0 < Gr >>> 0 | o >>> 0 > fr >>> 0, Gr = (o | 0) == (he | 0) & Qe >>> 0 > Gr >>> 0 | o >>> 0 < he >>> 0, o = Xn + 8 | 0, Dr = a[o >> 2], Fr = a[o + 4 >> 2], Be = (he | 0) == (un | 0) & Qe >>> 0 < $r >>> 0 | he >>> 0 < un >>> 0, v = Mo + 8 | 0, he = a[v >> 2], o = Vn + 8 | 0, Qe = he + a[o >> 2] | 0, v = a[o + 4 >> 2] + a[v + 4 >> 2] | 0, v = he >>> 0 > Qe >>> 0 ? v + 1 | 0 : v, o = Be + Qe | 0, v = (o >>> 0 < Qe >>> 0 ? v + 1 | 0 : v) + Fr | 0, he = o, o = o + Dr | 0, v = he >>> 0 > o >>> 0 ? v + 1 | 0 : v, he = o + Gr | 0, v = he >>> 0 < o >>> 0 ? v + 1 | 0 : v, we = we >>> 20 | 0, o = he + we | 0, v = we >>> 0 > o >>> 0 ? v + 1 | 0 : v, he = o, o = o + Oi | 0, v = he >>> 0 > o >>> 0 ? v + 1 | 0 : v, Be = o << 12 | fr >>> 20, we = v, Fr = v << 12 | o >>> 20, Gr = a[Me + 396 >> 2], v = Gr + (Si & 1048575) | 0, Dr = a[Me + 392 >> 2], he = mi & -2, o = Dr + he | 0, fr = o, Be = o + Be | 0, he = o >>> 0 < he >>> 0 ? v + 1 | 0 : v, v = he + Fr | 0, a[Me + 912 >> 2] = Be, o = o >>> 0 > Be >>> 0 ? v + 1 | 0 : v, a[Me + 916 >> 2] = o & 1048575, Fr = ni & 65535, Be = (o | 0) == (he | 0) & fr >>> 0 > Be >>> 0 | o >>> 0 < he >>> 0, he = (he | 0) == (Gr | 0) & fr >>> 0 < Dr >>> 0 | he >>> 0 < Gr >>> 0, v = Ti + 8 | 0, Me = he + a[v >> 2] | 0, v = a[v + 4 >> 2], v = he >>> 0 > Me >>> 0 ? v + 1 | 0 : v, we = we >>> 20 | 0, he = we + Me | 0, v = we >>> 0 > he >>> 0 ? v + 1 | 0 : v, we = he, he = he + Be | 0, v = we >>> 0 > he >>> 0 ? v + 1 | 0 : v, o = he << 12 | o >>> 20, we = o + Rr | 0, v = Fr + (v << 12 | he >>> 20) | 0, a[dr + 920 >> 2] = we, a[dr + 924 >> 2] = o >>> 0 > we >>> 0 ? v + 1 | 0 : v, v = dr + 848 | 0, o = dr + 888 | 0, gn(v, o, ds), gn(xo, Ho, o), Go = Ho + 40 | 0, gn(xo + 40 | 0, Go, v), a[xo + 80 >> 2] = 0, Mo = zi, yo = m + 440 | 0; ps = dr + 808 | 0, gn(ps, ps, Mo), he = yo + 32 | 0, v = a[he + 4 >> 2], xo = dr + 680 | 0, o = xo + 32 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, he = yo + 24 | 0, v = a[he + 4 >> 2], o = xo + 24 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, he = yo + 16 | 0, v = a[he + 4 >> 2], o = xo + 16 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, he = yo + 8 | 0, v = a[he + 4 >> 2], o = xo + 8 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, ts = yo + 40 | 0, o = a[ts + 4 >> 2], a[Go >> 2] = a[ts >> 2], a[Go + 4 >> 2] = o, he = yo + 48 | 0, v = a[he + 4 >> 2], o = Go + 8 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, he = yo + 56 | 0, v = a[he + 4 >> 2], o = Go + 16 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, he = yo - -64 | 0, v = a[he + 4 >> 2], o = Go + 24 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, he = yo + 72 | 0, v = a[he + 4 >> 2], o = Go + 32 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, o = a[yo + 4 >> 2], a[dr + 680 >> 2] = a[yo >> 2], a[dr + 684 >> 2] = o, a[dr + 800 >> 2] = 0, o = a[dr + 812 >> 2], ni = o, Qe = a[dr + 808 >> 2], Be = Qe, v = o << 1 | Be >>> 31, Dr = dr + 72 | 0, Ti = a[dr + 832 >> 2], $i = a[dr + 836 >> 2], In = Be << 1, Xn = v, Lr(Dr, Ti, $i, 0, 0, In, v, 0, 0), o = a[dr + 820 >> 2], Ho = o, ds = a[dr + 816 >> 2], he = ds, v = o << 1 | he >>> 31, Fr = dr + 280 | 0, zi = a[dr + 824 >> 2], Oi = a[dr + 828 >> 2], he = he << 1, we = v, Lr(Fr, zi, Oi, 0, 0, he, v, 0, 0), fr = dr + 232 | 0, Me = a[dr + 840 >> 2], o = a[dr + 844 >> 2], Lr(fr, Me, o, 0, 0, Me, o, 0, 0), Rr = dr + 216 | 0, Lr(Rr, a[dr + 232 >> 2], a[dr + 236 >> 2], 0, 0, 15632, 16, 0, 0), v = o << 1 | Me >>> 31, qi = dr + 184 | 0, uo = Me << 1, un = v, Lr(qi, uo, v, 0, 0, Be, ni, 0, 0), ns = dr + 88 | 0, Lr(ns, Ti, $i, 0, 0, he, we, 0, 0), Io = dr + 264 | 0, Lr(Io, zi, Oi, 0, 0, zi, Oi, 0, 0), Gr = dr + 200 | 0, o = fr + 8 | 0, Lr(Gr, a[o >> 2], a[o + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Wo = dr + 328 | 0, Lr(Wo, Be, ni, 0, 0, Be, ni, 0, 0), Oo = dr + 168 | 0, Lr(Oo, uo, v, 0, 0, ds, Ho, 0, 0), Ts = dr + 104 | 0, Lr(Ts, Ti, $i, 0, 0, zi << 1, Oi << 1 | zi >>> 31, 0, 0), Me = a[dr + 72 >> 2], he = a[dr + 280 >> 2], o = Me + he | 0, Qe = a[dr + 76 >> 2], v = Qe + a[dr + 284 >> 2] | 0, v = o >>> 0 < he >>> 0 ? v + 1 | 0 : v, he = a[dr + 216 >> 2], mi = he + o | 0, we = v, v = v + a[dr + 220 >> 2] | 0, he = he >>> 0 > mi >>> 0 ? v + 1 | 0 : v, fr = (we | 0) == (he | 0) & o >>> 0 > mi >>> 0 | he >>> 0 < we >>> 0, v = Rr + 8 | 0, Rr = a[v >> 2], Be = a[v + 4 >> 2], Me = (we | 0) == (Qe | 0) & o >>> 0 < Me >>> 0 | we >>> 0 < Qe >>> 0, v = Fr + 8 | 0, we = a[v >> 2], o = Dr + 8 | 0, Fr = we + a[o >> 2] | 0, v = a[o + 4 >> 2] + a[v + 4 >> 2] | 0, v = we >>> 0 > Fr >>> 0 ? v + 1 | 0 : v, o = Me + Fr | 0, v = (o >>> 0 < Fr >>> 0 ? v + 1 | 0 : v) + Be | 0, we = o, o = o + Rr | 0, v = we >>> 0 > o >>> 0 ? v + 1 | 0 : v, we = o, o = o + fr | 0, v = we >>> 0 > o >>> 0 ? v + 1 | 0 : v, Si = he, Rr = o << 12 | he >>> 20, Me = v, Be = v << 12 | o >>> 20, Vn = a[dr + 88 >> 2], o = a[dr + 264 >> 2], Dr = Vn + o | 0, po = a[dr + 92 >> 2], v = po + a[dr + 268 >> 2] | 0, v = o >>> 0 > Dr >>> 0 ? v + 1 | 0 : v, o = a[dr + 184 >> 2], Fr = o + Dr | 0, we = v, v = v + a[dr + 188 >> 2] | 0, v = o >>> 0 > Fr >>> 0 ? v + 1 | 0 : v, o = a[dr + 200 >> 2], fr = o + Fr | 0, he = v, v = v + a[dr + 204 >> 2] | 0, o = o >>> 0 > fr >>> 0 ? v + 1 | 0 : v, v = o + Be | 0, Kn = dr + 8 | 0, Rr = fr + Rr | 0, Be = Rr >>> 0 < fr >>> 0 ? v + 1 | 0 : v, Sn = (o | 0) == (Be | 0) & fr >>> 0 > Rr >>> 0 | o >>> 0 > Be >>> 0, $r = (o | 0) == (he | 0) & fr >>> 0 < Fr >>> 0 | o >>> 0 < he >>> 0, o = Gr + 8 | 0, ni = a[o >> 2], Qe = a[o + 4 >> 2], Gr = (he | 0) == (we | 0) & Dr >>> 0 > Fr >>> 0 | he >>> 0 < we >>> 0, o = qi + 8 | 0, Fr = a[o >> 2], fr = a[o + 4 >> 2], we = (we | 0) == (po | 0) & Dr >>> 0 < Vn >>> 0 | we >>> 0 < po >>> 0, v = Io + 8 | 0, he = a[v >> 2], o = ns + 8 | 0, Dr = he + a[o >> 2] | 0, v = a[o + 4 >> 2] + a[v + 4 >> 2] | 0, v = he >>> 0 > Dr >>> 0 ? v + 1 | 0 : v, o = we + Dr | 0, v = (o >>> 0 < Dr >>> 0 ? v + 1 | 0 : v) + fr | 0, he = o, o = o + Fr | 0, v = he >>> 0 > o >>> 0 ? v + 1 | 0 : v, he = o, o = o + Gr | 0, v = (he >>> 0 > o >>> 0 ? v + 1 | 0 : v) + Qe | 0, he = o, o = o + ni | 0, v = he >>> 0 > o >>> 0 ? v + 1 | 0 : v, he = o + $r | 0, v = he >>> 0 < o >>> 0 ? v + 1 | 0 : v, we = Me >>> 20 | 0, o = he + we | 0, v = we >>> 0 > o >>> 0 ? v + 1 | 0 : v, he = o, o = o + Sn | 0, v = he >>> 0 > o >>> 0 ? v + 1 | 0 : v, he = Be, Be = o << 12 | he >>> 20, we = v, fr = v << 12 | o >>> 20, Sn = a[dr + 172 >> 2], v = Sn + a[dr + 108 >> 2] | 0, Qe = a[dr + 168 >> 2], o = a[dr + 104 >> 2], Me = Qe + o | 0, Dr = Me, Be = Me + Be | 0, o = o >>> 0 > Me >>> 0 ? v + 1 | 0 : v, v = o + fr | 0, Fr = Be << 4 & -16, Me = Be >>> 0 < Me >>> 0 ? v + 1 | 0 : v, fr = (Me << 4 | Be >>> 28) & 16777215, ni = he, Lr(Kn, Fr | he >>> 16 & 15, fr, 0, 0, 977, 1, 0, 0), fr = dr, Ao = a[fr + 8 >> 2], he = a[fr + 328 >> 2], Fr = Ao + he | 0, Lo = a[fr + 12 >> 2], v = Lo + a[fr + 332 >> 2] | 0, a[fr + 888 >> 2] = Fr, he = he >>> 0 > Fr >>> 0 ? v + 1 | 0 : v, a[fr + 892 >> 2] = he & 1048575, po = fr + 312 | 0, Lr(po, ds, Ho, 0, 0, In, Xn, 0, 0), qi = fr + 152 | 0, Lr(qi, uo, un, 0, 0, zi, Oi, 0, 0), ns = fr + 120 | 0, Lr(ns, Ti, $i, 0, 0, Ti, $i, 0, 0), Io = fr + 56 | 0, $r = Io, Gr = (o | 0) == (Me | 0) & Be >>> 0 < Dr >>> 0 | o >>> 0 > Me >>> 0, Dr = (o | 0) == (Sn | 0) & Qe >>> 0 > Dr >>> 0 | o >>> 0 < Sn >>> 0, v = Ts + 8 | 0, Be = a[v >> 2], o = Oo + 8 | 0, Qe = Be + a[o >> 2] | 0, v = a[o + 4 >> 2] + a[v + 4 >> 2] | 0, v = Be >>> 0 > Qe >>> 0 ? v + 1 | 0 : v, Be = Qe + Dr | 0, v = Be >>> 0 < Qe >>> 0 ? v + 1 | 0 : v, we = we >>> 20 | 0, o = we + Be | 0, v = we >>> 0 > o >>> 0 ? v + 1 | 0 : v, we = o, o = o + Gr | 0, v = we >>> 0 > o >>> 0 ? v + 1 | 0 : v, Gr = o << 12 | Me >>> 20, Be = v, Dr = v << 12 | o >>> 20, Oo = a[fr + 156 >> 2], v = Oo + a[fr + 124 >> 2] | 0, Vn = a[fr + 152 >> 2], we = a[fr + 120 >> 2], o = Vn + we | 0, Sn = o, Qe = o + Gr | 0, Me = o >>> 0 < we >>> 0 ? v + 1 | 0 : v, v = Me + Dr | 0, Dr = Qe >>> 0 < o >>> 0 ? v + 1 | 0 : v, Lr($r, Qe, Dr & 1048575, 0, 0, 15632, 16, 0, 0), Fr = (he | 0) == (Lo | 0) & Fr >>> 0 < Ao >>> 0 | he >>> 0 < Lo >>> 0, v = Wo + 8 | 0, we = a[v >> 2], o = Kn + 8 | 0, Gr = we + a[o >> 2] | 0, v = a[o + 4 >> 2] + a[v + 4 >> 2] | 0, v = we >>> 0 > Gr >>> 0 ? v + 1 | 0 : v, o = Fr + Gr | 0, v = o >>> 0 < Gr >>> 0 ? v + 1 | 0 : v, Gr = o << 12 | he >>> 20, we = v, Fr = v << 12 | o >>> 20, Kn = a[fr + 56 >> 2], o = a[fr + 312 >> 2], $r = Kn + o | 0, Ts = a[fr + 60 >> 2], v = Ts + a[fr + 316 >> 2] | 0, he = o >>> 0 > $r >>> 0 ? v + 1 | 0 : v, v = he + Fr | 0, Gr = Gr + $r | 0, v = Gr >>> 0 < $r >>> 0 ? v + 1 | 0 : v, a[fr + 896 >> 2] = Gr, Fr = v, a[fr + 900 >> 2] = v & 1048575, Ao = fr + 248 | 0, Lr(Ao, zi, Oi, 0, 0, In, Xn, 0, 0), Xn = fr + 296 | 0, Lr(Xn, ds, Ho, 0, 0, ds, Ho, 0, 0), In = fr + 136 | 0, Lr(In, uo, un, 0, 0, Ti, $i, 0, 0), zi = fr + 40 | 0, Oi = (Me | 0) == (Dr | 0) & Qe >>> 0 < Sn >>> 0 | Me >>> 0 > Dr >>> 0, Qe = (Me | 0) == (Oo | 0) & Sn >>> 0 < Vn >>> 0 | Me >>> 0 < Oo >>> 0, v = ns + 8 | 0, Me = a[v >> 2], o = qi + 8 | 0, $i = Me + a[o >> 2] | 0, v = a[o + 4 >> 2] + a[v + 4 >> 2] | 0, v = Me >>> 0 > $i >>> 0 ? v + 1 | 0 : v, Me = Qe + $i | 0, v = Me >>> 0 < $i >>> 0 ? v + 1 | 0 : v, Be = Be >>> 20 | 0, o = Be + Me | 0, v = Be >>> 0 > o >>> 0 ? v + 1 | 0 : v, Be = o, o = o + Oi | 0, v = Be >>> 0 > o >>> 0 ? v + 1 | 0 : v, $i = o << 12 | Dr >>> 20, Be = a[fr + 136 >> 2], Dr = $i + Be | 0, Me = v, Sn = v << 12 | o >>> 20, v = Sn + a[fr + 140 >> 2] | 0, Oi = Be >>> 0 > Dr >>> 0 ? v + 1 | 0 : v, Lr(zi, Dr, Oi, 0, 0, 15632, 16, 0, 0), Be = fr, Gr = (he | 0) == (Fr | 0) & Gr >>> 0 < $r >>> 0 | he >>> 0 > Fr >>> 0, fr = (he | 0) == (Ts | 0) & $r >>> 0 < Kn >>> 0 | he >>> 0 < Ts >>> 0, v = po + 8 | 0, he = a[v >> 2], o = Io + 8 | 0, Qe = he + a[o >> 2] | 0, v = a[o + 4 >> 2] + a[v + 4 >> 2] | 0, v = he >>> 0 > Qe >>> 0 ? v + 1 | 0 : v, he = fr + Qe | 0, v = he >>> 0 < Qe >>> 0 ? v + 1 | 0 : v, we = we >>> 20 | 0, o = he + we | 0, v = we >>> 0 > o >>> 0 ? v + 1 | 0 : v, he = o, o = o + Gr | 0, v = he >>> 0 > o >>> 0 ? v + 1 | 0 : v, Fr = o << 12 | Fr >>> 20, we = v, fr = v << 12 | o >>> 20, $r = a[Be + 248 >> 2], o = a[Be + 296 >> 2], Qe = $r + o | 0, un = a[Be + 252 >> 2], v = un + a[Be + 300 >> 2] | 0, v = o >>> 0 > Qe >>> 0 ? v + 1 | 0 : v, o = a[Be + 40 >> 2], Gr = o + Qe | 0, he = v, v = v + a[Be + 44 >> 2] | 0, o = o >>> 0 > Gr >>> 0 ? v + 1 | 0 : v, v = o + fr | 0, Fr = Fr + Gr | 0, v = Fr >>> 0 < Gr >>> 0 ? v + 1 | 0 : v, a[Be + 904 >> 2] = Fr, fr = v, a[Be + 908 >> 2] = v & 1048575, Ti = Be + 24 | 0, $i = (Oi | 0) == (Sn | 0) & Dr >>> 0 < $i >>> 0 | Oi >>> 0 < Sn >>> 0, v = In + 8 | 0, Oi = a[v >> 2], v = a[v + 4 >> 2], Me = Me >>> 20 | 0, Dr = Me, Me = Me + Oi | 0, v = Dr >>> 0 > Me >>> 0 ? v + 1 | 0 : v, Dr = Me, Me = Me + $i | 0, v = Dr >>> 0 > Me >>> 0 ? v + 1 | 0 : v, Lr(Ti, Me, v, 0, 0, 64028672, 65536, 0, 0), Me = Be, Oi = (o | 0) == (fr | 0) & Fr >>> 0 < Gr >>> 0 | o >>> 0 > fr >>> 0, Gr = (o | 0) == (he | 0) & Qe >>> 0 > Gr >>> 0 | o >>> 0 < he >>> 0, o = zi + 8 | 0, Dr = a[o >> 2], Fr = a[o + 4 >> 2], Be = (he | 0) == (un | 0) & Qe >>> 0 < $r >>> 0 | he >>> 0 < un >>> 0, v = Xn + 8 | 0, he = a[v >> 2], o = Ao + 8 | 0, Qe = he + a[o >> 2] | 0, v = a[o + 4 >> 2] + a[v + 4 >> 2] | 0, v = he >>> 0 > Qe >>> 0 ? v + 1 | 0 : v, o = Be + Qe | 0, v = (o >>> 0 < Qe >>> 0 ? v + 1 | 0 : v) + Fr | 0, he = o, o = o + Dr | 0, v = he >>> 0 > o >>> 0 ? v + 1 | 0 : v, he = o + Gr | 0, v = he >>> 0 < o >>> 0 ? v + 1 | 0 : v, we = we >>> 20 | 0, o = he + we | 0, v = we >>> 0 > o >>> 0 ? v + 1 | 0 : v, he = o, o = o + Oi | 0, v = he >>> 0 > o >>> 0 ? v + 1 | 0 : v, Fr = o << 12 | fr >>> 20, we = v, Be = v << 12 | o >>> 20, Dr = a[Me + 24 >> 2], o = mi & -2, fr = Dr + o | 0, Gr = a[Me + 28 >> 2], v = Gr + (Si & 1048575) | 0, he = o >>> 0 > fr >>> 0 ? v + 1 | 0 : v, v = he + Be | 0, Be = fr + Fr | 0, v = Be >>> 0 < fr >>> 0 ? v + 1 | 0 : v, a[Me + 912 >> 2] = Be, o = v, a[Me + 916 >> 2] = v & 1048575, Fr = ni & 65535, Be = (v | 0) == (he | 0) & fr >>> 0 > Be >>> 0 | v >>> 0 < he >>> 0, he = (he | 0) == (Gr | 0) & fr >>> 0 < Dr >>> 0 | he >>> 0 < Gr >>> 0, v = Ti + 8 | 0, Me = he + a[v >> 2] | 0, v = a[v + 4 >> 2], v = he >>> 0 > Me >>> 0 ? v + 1 | 0 : v, we = we >>> 20 | 0, he = we + Me | 0, v = we >>> 0 > he >>> 0 ? v + 1 | 0 : v, we = he, he = he + Be | 0, v = we >>> 0 > he >>> 0 ? v + 1 | 0 : v, o = he << 12 | o >>> 20, we = o + Rr | 0, v = Fr + (v << 12 | he >>> 20) | 0, a[dr + 920 >> 2] = we, a[dr + 924 >> 2] = o >>> 0 > we >>> 0 ? v + 1 | 0 : v, v = dr + 848 | 0, o = dr + 888 | 0, gn(v, o, ps), gn(yo, xo, o), gn(ts, Go, v), a[yo + 80 >> 2] = 0, yo = yo - 88 | 0, Mo = Mo - 40 | 0, Bs = Bs - 1 | 0, !!Bs; )
        ;
      for (be = dr + 928 | 0, o = 0, yo = (Xs | 0) > 0 ? Xs : 0; ns = wr - -64 | 0, js = a[m >> 2], ya = a[m + 4 >> 2], Lr(ns, js, ya, 0, 0, -431719958, 28934, 0, 0), Io = wr + 416 | 0, v = m + 8 | 0, sa = a[v >> 2], va = a[v + 4 >> 2], Lr(Io, sa, va, 0, 0, -375590839, 799796, 0, 0), Vn = wr + 336 | 0, v = m + 16 | 0, oa = a[v >> 2], wa = a[v + 4 >> 2], Lr(Vn, oa, wa, 0, 0, 1486445587, 479535, 0, 0), Ti = wr + 256 | 0, v = m + 24 | 0, Pa = a[v >> 2], Ta = a[v + 4 >> 2], Lr(Ti, Pa, Ta, 0, 0, 1905590766, 617512, 0, 0), he = wr + 176 | 0, v = m + 32 | 0, jn = a[v >> 2], _o = a[v + 4 >> 2], Lr(he, jn, _o, 0, 0, 1781228924, 31465, 0, 0), mi = wr + 160 | 0, Lr(mi, a[wr + 176 >> 2] & -4, a[wr + 180 >> 2], 0, 0, 15632, 16, 0, 0), xo = wr + 80 | 0, Lr(xo, js, ya, 0, 0, 1781228924, 31465, 0, 0), Bs = wr + 432 | 0, Lr(Bs, sa, va, 0, 0, -431719958, 28934, 0, 0), ps = wr + 352 | 0, Lr(ps, oa, wa, 0, 0, -375590839, 799796, 0, 0), ts = wr + 272 | 0, Lr(ts, Pa, Ta, 0, 0, 1486445587, 479535, 0, 0), Lo = wr + 192 | 0, Lr(Lo, jn, _o, 0, 0, 1905590766, 617512, 0, 0), Kn = wr + 144 | 0, v = he + 8 | 0, Lr(Kn, a[v >> 2], a[v + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Ho = wr + 96 | 0, Lr(Ho, js, ya, 0, 0, 1905590766, 617512, 0, 0), ds = wr + 448 | 0, Lr(ds, sa, va, 0, 0, 1781228924, 31465, 0, 0), Wo = wr + 368 | 0, Lr(Wo, oa, wa, 0, 0, -431719958, 28934, 0, 0), Oo = wr + 288 | 0, Lr(Oo, Pa, Ta, 0, 0, -375590839, 799796, 0, 0), Ts = wr + 208 | 0, Lr(Ts, jn, _o, 0, 0, 1486445587, 479535, 0, 0), po = a[wr + 432 >> 2], he = a[wr + 80 >> 2], zi = po + he | 0, Xs = a[wr + 436 >> 2], v = Xs + a[wr + 84 >> 2] | 0, v = he >>> 0 > zi >>> 0 ? v + 1 | 0 : v, he = a[wr + 352 >> 2], $i = he + zi | 0, un = v, v = v + a[wr + 356 >> 2] | 0, v = he >>> 0 > $i >>> 0 ? v + 1 | 0 : v, he = a[wr + 272 >> 2], Oi = he + $i | 0, Dr = v, v = v + a[wr + 276 >> 2] | 0, v = he >>> 0 > Oi >>> 0 ? v + 1 | 0 : v, he = a[wr + 192 >> 2], Si = he + Oi | 0, Fr = v, v = v + a[wr + 196 >> 2] | 0, v = he >>> 0 > Si >>> 0 ? v + 1 | 0 : v, he = a[wr + 144 >> 2], ni = he + Si | 0, fr = v, v = v + a[wr + 148 >> 2] | 0, we = he >>> 0 > ni >>> 0 ? v + 1 | 0 : v, Ao = a[wr + 416 >> 2], he = a[wr + 64 >> 2], Qe = Ao + he | 0, qi = a[wr + 420 >> 2], v = qi + a[wr + 68 >> 2] | 0, v = he >>> 0 > Qe >>> 0 ? v + 1 | 0 : v, he = a[wr + 336 >> 2], Gr = he + Qe | 0, Be = v, v = v + a[wr + 340 >> 2] | 0, Me = he >>> 0 > Gr >>> 0 ? v + 1 | 0 : v, v = Me + a[wr + 260 >> 2] | 0, he = a[wr + 256 >> 2], dr = he + Gr | 0, Rr = a[wr + 160 >> 2], Xn = dr + Rr | 0, he = he >>> 0 > dr >>> 0 ? v + 1 | 0 : v, v = he + a[wr + 164 >> 2] | 0, Rr = Rr >>> 0 > Xn >>> 0 ? v + 1 | 0 : v, Mo = (he | 0) == (Rr | 0) & dr >>> 0 > Xn >>> 0 | he >>> 0 > Rr >>> 0, v = mi + 8 | 0, uo = a[v >> 2], Sn = a[v + 4 >> 2], In = (he | 0) == (Me | 0) & dr >>> 0 < Gr >>> 0 | he >>> 0 < Me >>> 0, v = Ti + 8 | 0, $r = a[v >> 2], Ti = a[v + 4 >> 2], mi = (Be | 0) == (Me | 0) & Qe >>> 0 > Gr >>> 0 | Be >>> 0 > Me >>> 0, v = Vn + 8 | 0, Gr = a[v >> 2], dr = a[v + 4 >> 2], Be = (Be | 0) == (qi | 0) & Qe >>> 0 < Ao >>> 0 | Be >>> 0 < qi >>> 0, Me = ns + 8 | 0, he = a[Me >> 2], v = Io + 8 | 0, Qe = he + a[v >> 2] | 0, v = a[v + 4 >> 2] + a[Me + 4 >> 2] | 0, v = he >>> 0 > Qe >>> 0 ? v + 1 | 0 : v, he = Be + Qe | 0, v = (he >>> 0 < Qe >>> 0 ? v + 1 | 0 : v) + dr | 0, Be = he, he = he + Gr | 0, v = Be >>> 0 > he >>> 0 ? v + 1 | 0 : v, Be = he, he = he + mi | 0, v = (Be >>> 0 > he >>> 0 ? v + 1 | 0 : v) + Ti | 0, Be = he, he = he + $r | 0, v = Be >>> 0 > he >>> 0 ? v + 1 | 0 : v, Be = he, he = he + In | 0, v = (Be >>> 0 > he >>> 0 ? v + 1 | 0 : v) + Sn | 0, Be = he, he = he + uo | 0, v = Be >>> 0 > he >>> 0 ? v + 1 | 0 : v, Be = he, he = he + Mo | 0, v = Be >>> 0 > he >>> 0 ? v + 1 | 0 : v, mi = Rr, Be = he << 12 | Rr >>> 20, dr = Be + ni | 0, Me = v, v = we + (v << 12 | he >>> 20) | 0, Gr = Be >>> 0 > dr >>> 0 ? v + 1 | 0 : v, qi = a[wr + 368 >> 2], he = a[wr + 448 >> 2], $r = qi + he | 0, Go = a[wr + 372 >> 2], v = Go + a[wr + 452 >> 2] | 0, v = he >>> 0 > $r >>> 0 ? v + 1 | 0 : v, he = a[wr + 288 >> 2], Ti = he + $r | 0, Rr = v, v = v + a[wr + 292 >> 2] | 0, v = he >>> 0 > Ti >>> 0 ? v + 1 | 0 : v, he = a[wr + 208 >> 2], Qe = he + Ti | 0, Be = v, v = v + a[wr + 212 >> 2] | 0, he = he >>> 0 > Qe >>> 0 ? v + 1 | 0 : v, ns = (we | 0) == (Gr | 0) & dr >>> 0 < ni >>> 0 | we >>> 0 > Gr >>> 0, Io = (we | 0) == (fr | 0) & ni >>> 0 < Si >>> 0 | we >>> 0 < fr >>> 0, v = Kn + 8 | 0, Vn = a[v >> 2], Kn = a[v + 4 >> 2], Ao = (fr | 0) == (Fr | 0) & Si >>> 0 < Oi >>> 0 | fr >>> 0 < Fr >>> 0, v = Lo + 8 | 0, Mo = a[v >> 2], uo = a[v + 4 >> 2], Sn = (Dr | 0) == (Fr | 0) & Oi >>> 0 < $i >>> 0 | Dr >>> 0 > Fr >>> 0, v = ts + 8 | 0, In = a[v >> 2], Oi = a[v + 4 >> 2], Si = (Dr | 0) == (un | 0) & $i >>> 0 < zi >>> 0 | Dr >>> 0 < un >>> 0, v = ps + 8 | 0, ni = a[v >> 2], Dr = a[v + 4 >> 2], Fr = (un | 0) == (Xs | 0) & zi >>> 0 < po >>> 0 | un >>> 0 < Xs >>> 0, fr = xo + 8 | 0, we = a[fr >> 2], v = Bs + 8 | 0, $i = we + a[v >> 2] | 0, v = a[v + 4 >> 2] + a[fr + 4 >> 2] | 0, v = we >>> 0 > $i >>> 0 ? v + 1 | 0 : v, we = Fr + $i | 0, v = (we >>> 0 < $i >>> 0 ? v + 1 | 0 : v) + Dr | 0, fr = we, we = we + ni | 0, v = fr >>> 0 > we >>> 0 ? v + 1 | 0 : v, fr = we, we = we + Si | 0, v = (fr >>> 0 > we >>> 0 ? v + 1 | 0 : v) + Oi | 0, fr = we, we = we + In | 0, v = fr >>> 0 > we >>> 0 ? v + 1 | 0 : v, fr = we, we = we + Sn | 0, v = (fr >>> 0 > we >>> 0 ? v + 1 | 0 : v) + uo | 0, fr = we, we = we + Mo | 0, v = fr >>> 0 > we >>> 0 ? v + 1 | 0 : v, fr = we, we = we + Ao | 0, v = (fr >>> 0 > we >>> 0 ? v + 1 | 0 : v) + Kn | 0, fr = we, we = we + Vn | 0, v = fr >>> 0 > we >>> 0 ? v + 1 | 0 : v, fr = we + Io | 0, v = fr >>> 0 < we >>> 0 ? v + 1 | 0 : v, Me = Me >>> 20 | 0, we = fr + Me | 0, v = Me >>> 0 > we >>> 0 ? v + 1 | 0 : v, Me = we, we = we + ns | 0, Me = Me >>> 0 > we >>> 0 ? v + 1 | 0 : v, fr = Me << 12 | we >>> 20, v = we << 12, we = Gr, Fr = v | we >>> 20, Gr = Fr + Qe | 0, v = he + fr | 0, Dr = Fr >>> 0 > Gr >>> 0 ? v + 1 | 0 : v, fr = Gr, v = Dr << 4 | fr >>> 28, Fr = fr << 4 & -16, fr = v & 16777215, Si = we, Lr(wr, Fr | we >>> 16 & 15, fr, 0, 0, 977, 1, 0, 0), Io = a[wr + 4 >> 2], v = Io + a[wr + 100 >> 2] | 0, Uo = (wr + 2240 | 0) + o | 0, fr = Uo, Vn = a[wr >> 2], we = a[wr + 96 >> 2], ni = Vn + we | 0, a[fr >> 2] = ni, Fr = we >>> 0 > ni >>> 0 ? v + 1 | 0 : v, a[fr + 4 >> 2] = Fr & 1048575, Bs = wr + 112 | 0, Lr(Bs, js, ya, 0, 0, 1486445587, 479535, 0, 0), ps = wr + 464 | 0, Lr(ps, sa, va, 0, 0, 1905590766, 617512, 0, 0), ts = wr + 384 | 0, Lr(ts, oa, wa, 0, 0, 1781228924, 31465, 0, 0), Kn = wr + 304 | 0, Lr(Kn, Pa, Ta, 0, 0, -431719958, 28934, 0, 0), Ao = wr + 224 | 0, Lr(Ao, jn, _o, 0, 0, -375590839, 799796, 0, 0), Lo = wr + 48 | 0, uo = Lo, Mo = a[wr + 304 >> 2], we = a[wr + 384 >> 2], $i = Mo + we | 0, Xs = a[wr + 308 >> 2], v = Xs + a[wr + 388 >> 2] | 0, v = we >>> 0 > $i >>> 0 ? v + 1 | 0 : v, we = a[wr + 224 >> 2], Oi = we + $i | 0, fr = v, v = v + a[wr + 228 >> 2] | 0, we = we >>> 0 > Oi >>> 0 ? v + 1 | 0 : v, Sn = (he | 0) == (Dr | 0) & Qe >>> 0 > Gr >>> 0 | he >>> 0 > Dr >>> 0, In = (he | 0) == (Be | 0) & Qe >>> 0 < Ti >>> 0 | he >>> 0 < Be >>> 0, v = Ts + 8 | 0, un = a[v >> 2], zi = a[v + 4 >> 2], Ti = (Be | 0) == (Rr | 0) & $r >>> 0 > Ti >>> 0 | Be >>> 0 < Rr >>> 0, v = Oo + 8 | 0, Qe = a[v >> 2], Gr = a[v + 4 >> 2], Rr = (Rr | 0) == (Go | 0) & $r >>> 0 < qi >>> 0 | Rr >>> 0 < Go >>> 0, Be = ds + 8 | 0, he = a[Be >> 2], v = Wo + 8 | 0, $r = he + a[v >> 2] | 0, v = a[v + 4 >> 2] + a[Be + 4 >> 2] | 0, v = he >>> 0 > $r >>> 0 ? v + 1 | 0 : v, he = Rr + $r | 0, v = (he >>> 0 < $r >>> 0 ? v + 1 | 0 : v) + Gr | 0, Be = he, he = he + Qe | 0, v = Be >>> 0 > he >>> 0 ? v + 1 | 0 : v, Be = he, he = he + Ti | 0, v = (Be >>> 0 > he >>> 0 ? v + 1 | 0 : v) + zi | 0, Be = he, he = he + un | 0, v = Be >>> 0 > he >>> 0 ? v + 1 | 0 : v, Be = he + In | 0, v = Be >>> 0 < he >>> 0 ? v + 1 | 0 : v, Me = Me >>> 20 | 0, he = Be + Me | 0, v = Me >>> 0 > he >>> 0 ? v + 1 | 0 : v, Be = he, he = he + Sn | 0, v = Be >>> 0 > he >>> 0 ? v + 1 | 0 : v, Me = he << 12 | Dr >>> 20, Qe = Me + Oi | 0, Rr = v, v = we + (v << 12 | he >>> 20) | 0, Gr = Me >>> 0 > Qe >>> 0 ? v + 1 | 0 : v, Lr(uo, Qe, Gr & 1048575, 0, 0, 15632, 16, 0, 0), $r = Uo + 8 | 0, Wo = a[wr + 464 >> 2], he = a[wr + 112 >> 2], In = Wo + he | 0, xo = a[wr + 468 >> 2], v = xo + a[wr + 116 >> 2] | 0, v = he >>> 0 > In >>> 0 ? v + 1 | 0 : v, he = a[wr + 48 >> 2], un = he + In | 0, Sn = v, v = v + a[wr + 52 >> 2] | 0, Me = he >>> 0 > un >>> 0 ? v + 1 | 0 : v, Dr = (Fr | 0) == (Io | 0) & ni >>> 0 < Vn >>> 0 | Fr >>> 0 < Io >>> 0, Be = Ho + 8 | 0, he = a[Be >> 2], v = wr + 8 | 0, ni = he + a[v >> 2] | 0, v = a[v + 4 >> 2] + a[Be + 4 >> 2] | 0, v = he >>> 0 > ni >>> 0 ? v + 1 | 0 : v, he = Dr + ni | 0, v = he >>> 0 < ni >>> 0 ? v + 1 | 0 : v, Fr = he << 12 | Fr >>> 20, ni = Fr + un | 0, Be = v, v = Me + (v << 12 | he >>> 20) | 0, a[$r >> 2] = ni, Dr = Fr >>> 0 > ni >>> 0 ? v + 1 | 0 : v, a[$r + 4 >> 2] = Dr & 1048575, Oo = wr + 128 | 0, Lr(Oo, js, ya, 0, 0, -375590839, 799796, 0, 0), Ts = wr + 480 | 0, Lr(Ts, sa, va, 0, 0, 1486445587, 479535, 0, 0), po = wr + 400 | 0, Lr(po, oa, wa, 0, 0, 1905590766, 617512, 0, 0), qi = wr + 320 | 0, Lr(qi, Pa, Ta, 0, 0, 1781228924, 31465, 0, 0), ns = wr + 240 | 0, Lr(ns, jn, _o, 0, 0, -431719958, 28934, 0, 0), Io = wr + 32 | 0, uo = Io, Vn = a[wr + 240 >> 2], he = a[wr + 320 >> 2], zi = Vn + he | 0, Ho = a[wr + 244 >> 2], v = Ho + a[wr + 324 >> 2] | 0, he = he >>> 0 > zi >>> 0 ? v + 1 | 0 : v, $r = (we | 0) == (Gr | 0) & Qe >>> 0 < Oi >>> 0 | we >>> 0 > Gr >>> 0, Ti = (we | 0) == (fr | 0) & Oi >>> 0 < $i >>> 0 | we >>> 0 < fr >>> 0, v = Ao + 8 | 0, Oi = a[v >> 2], Qe = a[v + 4 >> 2], Fr = (fr | 0) == (Xs | 0) & $i >>> 0 < Mo >>> 0 | fr >>> 0 < Xs >>> 0, fr = ts + 8 | 0, we = a[fr >> 2], v = Kn + 8 | 0, $i = we + a[v >> 2] | 0, v = a[v + 4 >> 2] + a[fr + 4 >> 2] | 0, v = we >>> 0 > $i >>> 0 ? v + 1 | 0 : v, we = Fr + $i | 0, v = (we >>> 0 < $i >>> 0 ? v + 1 | 0 : v) + Qe | 0, fr = we, we = we + Oi | 0, v = fr >>> 0 > we >>> 0 ? v + 1 | 0 : v, fr = we + Ti | 0, v = fr >>> 0 < we >>> 0 ? v + 1 | 0 : v, Rr = Rr >>> 20 | 0, we = fr + Rr | 0, v = Rr >>> 0 > we >>> 0 ? v + 1 | 0 : v, fr = we, we = we + $r | 0, v = fr >>> 0 > we >>> 0 ? v + 1 | 0 : v, Rr = we << 12 | Gr >>> 20, Qe = Rr + zi | 0, Fr = v, v = he + (v << 12 | we >>> 20) | 0, $r = Qe >>> 0 < Rr >>> 0 ? v + 1 | 0 : v, Lr(uo, Qe, $r, 0, 0, 15632, 16, 0, 0), ds = Uo + 16 | 0, Kn = a[wr + 480 >> 2], we = a[wr + 128 >> 2], Ti = Kn + we | 0, ts = a[wr + 484 >> 2], v = ts + a[wr + 132 >> 2] | 0, v = we >>> 0 > Ti >>> 0 ? v + 1 | 0 : v, we = a[wr + 400 >> 2], $i = we + Ti | 0, fr = v, v = v + a[wr + 404 >> 2] | 0, v = we >>> 0 > $i >>> 0 ? v + 1 | 0 : v, we = a[wr + 32 >> 2], Oi = we + $i | 0, Rr = v, v = v + a[wr + 36 >> 2] | 0, we = we >>> 0 > Oi >>> 0 ? v + 1 | 0 : v, Ao = (Me | 0) == (Dr | 0) & ni >>> 0 < un >>> 0 | Me >>> 0 > Dr >>> 0, Mo = (Me | 0) == (Sn | 0) & In >>> 0 > un >>> 0 | Me >>> 0 < Sn >>> 0, v = Lo + 8 | 0, uo = a[v >> 2], un = a[v + 4 >> 2], ni = (Sn | 0) == (xo | 0) & In >>> 0 < Wo >>> 0 | Sn >>> 0 < xo >>> 0, Gr = Bs + 8 | 0, Me = a[Gr >> 2], v = ps + 8 | 0, In = Me + a[v >> 2] | 0, v = a[v + 4 >> 2] + a[Gr + 4 >> 2] | 0, v = Me >>> 0 > In >>> 0 ? v + 1 | 0 : v, Me = ni + In | 0, v = (Me >>> 0 < In >>> 0 ? v + 1 | 0 : v) + un | 0, Gr = Me, Me = Me + uo | 0, v = Gr >>> 0 > Me >>> 0 ? v + 1 | 0 : v, Gr = Me + Mo | 0, v = Gr >>> 0 < Me >>> 0 ? v + 1 | 0 : v, Be = Be >>> 20 | 0, Me = Be + Gr | 0, v = Be >>> 0 > Me >>> 0 ? v + 1 | 0 : v, Be = Me, Me = Me + Ao | 0, v = Be >>> 0 > Me >>> 0 ? v + 1 | 0 : v, Dr = Me << 12 | Dr >>> 20, Gr = Dr + Oi | 0, Be = v, v = we + (v << 12 | Me >>> 20) | 0, a[ds >> 2] = Gr, Dr = Dr >>> 0 > Gr >>> 0 ? v + 1 | 0 : v, a[ds + 4 >> 2] = Dr & 1048575, In = wr + 16 | 0, un = In, ni = (he | 0) == ($r | 0) & Qe >>> 0 < zi >>> 0 | he >>> 0 > $r >>> 0, Qe = (he | 0) == (Ho | 0) & zi >>> 0 < Vn >>> 0 | he >>> 0 < Ho >>> 0, Me = qi + 8 | 0, he = a[Me >> 2], v = ns + 8 | 0, $r = he + a[v >> 2] | 0, v = a[v + 4 >> 2] + a[Me + 4 >> 2] | 0, v = he >>> 0 > $r >>> 0 ? v + 1 | 0 : v, Me = Qe + $r | 0, v = Me >>> 0 < $r >>> 0 ? v + 1 | 0 : v, Fr = Fr >>> 20 | 0, he = Me + Fr | 0, v = Fr >>> 0 > he >>> 0 ? v + 1 | 0 : v, Me = he, he = he + ni | 0, v = Me >>> 0 > he >>> 0 ? v + 1 | 0 : v, Lr(un, he, v, 0, 0, 64028672, 65536, 0, 0), uo = Uo + 24 | 0, Sn = a[wr + 20 >> 2], v = Sn + (mi & 1048575) | 0, un = a[wr + 16 >> 2], Me = Xn + un | 0, he = Me >>> 0 < Xn >>> 0 ? v + 1 | 0 : v, Fr = Me, zi = (we | 0) == (Dr | 0) & Gr >>> 0 < Oi >>> 0 | we >>> 0 > Dr >>> 0, $r = (we | 0) == (Rr | 0) & Oi >>> 0 < $i >>> 0 | we >>> 0 < Rr >>> 0, v = Io + 8 | 0, Oi = a[v >> 2], mi = a[v + 4 >> 2], ni = (fr | 0) == (Rr | 0) & $i >>> 0 < Ti >>> 0 | fr >>> 0 > Rr >>> 0, v = po + 8 | 0, Qe = a[v >> 2], Gr = a[v + 4 >> 2], Rr = (fr | 0) == (ts | 0) & Ti >>> 0 < Kn >>> 0 | fr >>> 0 < ts >>> 0, Me = Oo + 8 | 0, we = a[Me >> 2], v = Ts + 8 | 0, fr = we + a[v >> 2] | 0, v = a[v + 4 >> 2] + a[Me + 4 >> 2] | 0, v = we >>> 0 > fr >>> 0 ? v + 1 | 0 : v, we = fr + Rr | 0, v = (we >>> 0 < fr >>> 0 ? v + 1 | 0 : v) + Gr | 0, Me = we, we = we + Qe | 0, v = Me >>> 0 > we >>> 0 ? v + 1 | 0 : v, Me = we, we = we + ni | 0, v = (Me >>> 0 > we >>> 0 ? v + 1 | 0 : v) + mi | 0, Me = we, we = we + Oi | 0, v = Me >>> 0 > we >>> 0 ? v + 1 | 0 : v, Me = we + $r | 0, v = Me >>> 0 < we >>> 0 ? v + 1 | 0 : v, Be = Be >>> 20 | 0, we = Be + Me | 0, v = Be >>> 0 > we >>> 0 ? v + 1 | 0 : v, Be = we, we = we + zi | 0, v = Be >>> 0 > we >>> 0 ? v + 1 | 0 : v, Rr = we << 12 | Dr >>> 20, Be = Rr + Fr | 0, Me = v, v = he + (v << 12 | we >>> 20) | 0, a[uo >> 2] = Be, we = Be >>> 0 < Rr >>> 0 ? v + 1 | 0 : v, a[uo + 4 >> 2] = we & 1048575, Dr = Uo + 32 | 0, fr = Si & 65535, Rr = (he | 0) == (we | 0) & Be >>> 0 < Fr >>> 0 | he >>> 0 > we >>> 0, he = (he | 0) == (Sn | 0) & Fr >>> 0 < un >>> 0 | he >>> 0 < Sn >>> 0, v = In + 8 | 0, Be = he + a[v >> 2] | 0, v = a[v + 4 >> 2], v = he >>> 0 > Be >>> 0 ? v + 1 | 0 : v, Me = Me >>> 20 | 0, he = Be + Me | 0, v = Me >>> 0 > he >>> 0 ? v + 1 | 0 : v, Be = he, he = he + Rr | 0, v = Be >>> 0 > he >>> 0 ? v + 1 | 0 : v, we = he << 12 | we >>> 20, Me = we + dr | 0, v = fr + (v << 12 | he >>> 20) | 0, a[Dr >> 2] = Me, a[Dr + 4 >> 2] = we >>> 0 > Me >>> 0 ? v + 1 | 0 : v, m = m + 88 | 0, o = o + 40 | 0, (o | 0) != 320; )
        ;
      m = (yo | 0) < (ta | 0) ? ta : yo, o = 1;
    }
    e: {
      if (!d) {
        Dr = 0, Rr = 0;
        break e;
      }
      we = wr + 3648 | 0, v = we + 24 | 0, a[v >> 2] = 0, a[v + 4 >> 2] = 0, he = wr + 3616 | 0, v = he + 24 | 0, a[v >> 2] = 0, a[v + 4 >> 2] = 0, a[wr + 3664 >> 2] = 0, a[wr + 3668 >> 2] = 0, a[wr + 3632 >> 2] = 0, a[wr + 3636 >> 2] = 0, v = a[d + 4 >> 2], a[wr + 3648 >> 2] = a[d >> 2], a[wr + 3652 >> 2] = v, v = a[d + 12 >> 2], a[wr + 3656 >> 2] = a[d + 8 >> 2], a[wr + 3660 >> 2] = v, v = a[d + 20 >> 2], a[wr + 3616 >> 2] = a[d + 16 >> 2], a[wr + 3620 >> 2] = v, v = a[d + 28 >> 2], a[wr + 3624 >> 2] = a[d + 24 >> 2], a[wr + 3628 >> 2] = v, Dr = kn(wr + 3088 | 0, we, 4), Rr = kn(wr + 2560 | 0, he, 4), m = (m | 0) < (Dr | 0) ? Dr : m, m = (m | 0) < (Rr | 0) ? Rr : m;
    }
    a[B + 120 >> 2] = 1, Qe = xi(B, 120);
    e: {
      if ((m | 0) <= 0)
        break e;
      B = m - 1 | 0;
      t: {
        if (!o)
          for (B = B << 2, d = B + (wr + 3088 | 0) | 0, B = (wr + 2560 | 0) + B | 0, dr = 1; ; ) {
            r: {
              if (dr) {
                a[Qe + 120 >> 2] = 1, xi(Qe, 120);
                break r;
              }
              os(Qe, Qe);
            }
            r: {
              if ((m | 0) > (Dr | 0) || (v = a[d >> 2], !v))
                break r;
              o = wr + 3720 | 0, ho(o, 655920, v), eo(Qe, Qe, o, wr + 3680 | 0);
            }
            o = m - 1 | 0;
            r: {
              if ((m | 0) > (Rr | 0) || (v = a[B >> 2], !v))
                break r;
              m = wr + 3720 | 0, ho(m, 656176, v), eo(Qe, Qe, m, wr + 3680 | 0);
            }
            if ((o | 0) <= 0)
              break t;
            d = d - 4 | 0, B = B - 4 | 0, dr = a[Qe + 120 >> 2], m = o;
          }
        for (Gr = wr + 3760 | 0, d = ((m << 2) + wr | 0) + 1008 | 0, o = B << 2, B = o + (wr + 3088 | 0) | 0, dr = (wr + 2560 | 0) + o | 0, Be = a[wr + 1532 >> 2], Me = a[wr + 1528 >> 2], v = 1; ; ) {
          r: {
            if (v) {
              a[Qe + 120 >> 2] = 1, xi(Qe, 120);
              break r;
            }
            os(Qe, Qe);
          }
          r: {
            if ((m | 0) > (Me | 0) || (o = a[d - 516 >> 2], !o))
              break r;
            i: {
              if ((o | 0) <= 0) {
                dn(wr + 3720 | 0, (wr + 1536 | 0) + F((o ^ -1) / 2 | 0, 88) | 0, 88), o = a[wr + 3760 >> 2], v = -3908 - o | 0, o = 4194299 - (a[wr + 3764 >> 2] + (o >>> 0 > 4294963388) | 0) | 0, a[wr + 3760 >> 2] = v, a[wr + 3764 >> 2] = o, o = a[wr + 3768 >> 2], v = -4 - o | 0, o = 4194303 - (a[wr + 3772 >> 2] + (o >>> 0 > 4294967292) | 0) | 0, a[wr + 3768 >> 2] = v, a[wr + 3772 >> 2] = o, o = a[wr + 3776 >> 2], v = -4 - o | 0, o = 4194303 - (a[wr + 3780 >> 2] + (o >>> 0 > 4294967292) | 0) | 0, a[wr + 3776 >> 2] = v, a[wr + 3780 >> 2] = o, o = a[wr + 3784 >> 2], v = -4 - o | 0, o = 4194303 - (a[wr + 3788 >> 2] + (o >>> 0 > 4294967292) | 0) | 0, a[wr + 3784 >> 2] = v, a[wr + 3788 >> 2] = o, o = a[wr + 3792 >> 2], v = -4 - o | 0, o = 262143 - (a[wr + 3796 >> 2] + (o >>> 0 > 4294967292) | 0) | 0, a[wr + 3792 >> 2] = v, a[wr + 3796 >> 2] = o;
                break i;
              }
              dn(wr + 3720 | 0, (wr + 1536 | 0) + F(o - 1 >>> 1 | 0, 88) | 0, 88);
            }
            Ei(Qe, Qe, wr + 3720 | 0, 0);
          }
          r: {
            if ((m | 0) > (Be | 0) || (o = a[d >> 2], !o))
              break r;
            i: {
              if ((o | 0) <= 0) {
                we = (o ^ -1) / 2 | 0, fr = (wr + 1536 | 0) + F(we, 88) | 0, o = a[fr + 44 >> 2], a[Gr >> 2] = a[fr + 40 >> 2], a[Gr + 4 >> 2] = o, he = fr + 48 | 0, v = a[he + 4 >> 2], o = Gr + 8 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, he = fr + 56 | 0, v = a[he + 4 >> 2], o = Gr + 16 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, he = fr - -64 | 0, v = a[he + 4 >> 2], o = Gr + 24 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, he = fr + 72 | 0, v = a[he + 4 >> 2], o = Gr + 32 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, fr = (wr + 2240 | 0) + F(we, 40) | 0, he = fr + 8 | 0, v = a[he + 4 >> 2], we = wr + 3720 | 0, o = we + 8 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, he = fr + 16 | 0, v = a[he + 4 >> 2], o = we + 16 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, he = fr + 24 | 0, v = a[he + 4 >> 2], o = we + 24 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, he = fr + 32 | 0, v = a[he + 4 >> 2], o = we + 32 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, a[wr + 3800 >> 2] = 0, o = a[fr + 4 >> 2], a[wr + 3720 >> 2] = a[fr >> 2], a[wr + 3724 >> 2] = o, o = a[wr + 3760 >> 2], v = -3908 - o | 0, o = 4194299 - (a[wr + 3764 >> 2] + (o >>> 0 > 4294963388) | 0) | 0, a[wr + 3760 >> 2] = v, a[wr + 3764 >> 2] = o, o = a[wr + 3768 >> 2], v = -4 - o | 0, o = 4194303 - (a[wr + 3772 >> 2] + (o >>> 0 > 4294967292) | 0) | 0, a[wr + 3768 >> 2] = v, a[wr + 3772 >> 2] = o, o = a[wr + 3776 >> 2], v = -4 - o | 0, o = 4194303 - (a[wr + 3780 >> 2] + (o >>> 0 > 4294967292) | 0) | 0, a[wr + 3776 >> 2] = v, a[wr + 3780 >> 2] = o, o = a[wr + 3784 >> 2], v = -4 - o | 0, o = 4194303 - (a[wr + 3788 >> 2] + (o >>> 0 > 4294967292) | 0) | 0, a[wr + 3784 >> 2] = v, a[wr + 3788 >> 2] = o, o = a[wr + 3792 >> 2], v = -4 - o | 0, o = 262143 - (a[wr + 3796 >> 2] + (o >>> 0 > 4294967292) | 0) | 0, a[wr + 3792 >> 2] = v, a[wr + 3796 >> 2] = o;
                break i;
              }
              v = o - 1 >>> 1 | 0, Fr = (wr + 1536 | 0) + F(v, 88) | 0, o = a[Fr + 44 >> 2], a[Gr >> 2] = a[Fr + 40 >> 2], a[Gr + 4 >> 2] = o, fr = (wr + 2240 | 0) + F(v, 40) | 0, he = fr + 8 | 0, v = a[he + 4 >> 2], we = wr + 3720 | 0, o = we + 8 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, he = fr + 16 | 0, v = a[he + 4 >> 2], o = we + 16 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, he = fr + 24 | 0, v = a[he + 4 >> 2], o = we + 24 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, he = fr + 32 | 0, v = a[he + 4 >> 2], o = we + 32 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, he = Fr + 48 | 0, v = a[he + 4 >> 2], o = Gr + 8 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, he = Fr + 56 | 0, v = a[he + 4 >> 2], o = Gr + 16 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, he = Fr - -64 | 0, v = a[he + 4 >> 2], o = Gr + 24 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, he = Fr + 72 | 0, v = a[he + 4 >> 2], o = Gr + 32 | 0, a[o >> 2] = a[he >> 2], a[o + 4 >> 2] = v, a[wr + 3800 >> 2] = 0, o = a[fr + 4 >> 2], a[wr + 3720 >> 2] = a[fr >> 2], a[wr + 3724 >> 2] = o;
            }
            Ei(Qe, Qe, wr + 3720 | 0, 0);
          }
          r: {
            if ((m | 0) > (Dr | 0) || (v = a[B >> 2], !v))
              break r;
            o = wr + 3720 | 0, ho(o, 655920, v), eo(Qe, Qe, o, wr + 3680 | 0);
          }
          o = m - 1 | 0;
          r: {
            if ((m | 0) > (Rr | 0) || (v = a[dr >> 2], !v))
              break r;
            m = wr + 3720 | 0, ho(m, 656176, v), eo(Qe, Qe, m, wr + 3680 | 0);
          }
          if ((o | 0) <= 0)
            break t;
          B = B - 4 | 0, dr = dr - 4 | 0, d = d - 4 | 0, v = a[Qe + 120 >> 2], m = o;
        }
      }
      if (a[Qe + 120 >> 2])
        break e;
      B = Qe + 80 | 0, gn(B, B, wr + 3680 | 0);
    }
    be = wr + 3808 | 0;
  }
  function ln(B, o) {
    var m = 0, d = 0, v = 0, he = 0, we = 0, Be = 0, Me = 0, fr = 0, wr = 0, dr = 0, Dr = 0, Rr = 0, Qe = 0, Fr = 0, Gr = 0;
    Me = be - 48 | 0, be = Me, d = Me + 8 | 0, na(d, o + 80 | 0), gn(d, d, B), he = a[o + 24 >> 2], v = a[o + 28 >> 2], fr = a[o + 16 >> 2], we = a[o + 20 >> 2], d = a[o + 8 >> 2], dr = a[o + 12 >> 2], m = a[o >> 2], Be = a[o + 4 >> 2], Dr = a[o + 32 >> 2], o = a[o + 36 >> 2], Rr = o, B = m, m = oi(o >>> 16 | 0, 0, 977, 1), o = B + m | 0, B = Be + Fe | 0, B = o >>> 0 < m >>> 0 ? B + 1 | 0 : B, m = o, Be = B, B = dr, o = Be >>> 20 | 0, wr = o, o = o + d | 0, dr = wr >>> 0 > o >>> 0 ? B + 1 | 0 : B, B = we, d = dr >>> 20 | 0, fr = d + fr | 0, we = d >>> 0 > fr >>> 0 ? B + 1 | 0 : B, B = v, d = we >>> 20 | 0, he = d + he | 0, d = d >>> 0 > he >>> 0 ? B + 1 | 0 : B, B = a[Me + 8 >> 2], v = m - B | 0, Qe = (Be & 1048575) - (a[Me + 12 >> 2] + (B >>> 0 > m >>> 0) | 0) | 0, B = a[Me + 40 >> 2], Be = Dr - B | 0, B = (Rr & 65535) - (a[Me + 44 >> 2] + (B >>> 0 > Dr >>> 0) | 0) | 0, m = d >>> 20 | 0, wr = m, m = m + Be | 0, B = (wr >>> 0 > m >>> 0 ? B + 1 | 0 : B) + 262143 | 0, wr = v, m = m - 4 | 0, Dr = m >>> 0 < 4294967292 ? B + 1 | 0 : B, v = oi(Dr >>> 16 | 0, 0, 977, 1), Be = wr + v | 0, B = Qe + Fe | 0, B = (Be >>> 0 < v >>> 0 ? B + 1 | 0 : B) + 4194299 | 0, Be = Be - 3908 | 0, B = Be >>> 0 < 4294963388 ? B + 1 | 0 : B, v = B & 1048575, Fr = v, Rr = Be ^ 976, Qe = v ^ 1, be = Me + 48 | 0;
    e: {
      if (Be | v && (v = 0, (Rr | 0) != -1 | (Qe | 0) != 1048575))
        break e;
      v = m, Dr = Dr & 65535, m = a[Me + 32 >> 2], Gr = he - m | 0, wr = (d & 1048575) - (a[Me + 36 >> 2] + (m >>> 0 > he >>> 0) | 0) | 0, d = a[Me + 24 >> 2], he = fr - d | 0, fr = (we & 1048575) - (a[Me + 28 >> 2] + (d >>> 0 > fr >>> 0) | 0) | 0, d = B, B = dr & 1048575, d = d >>> 20 | 0, m = d, d = o + d | 0, B = m >>> 0 > d >>> 0 ? B + 1 | 0 : B, m = a[Me + 16 >> 2], o = (d - m | 0) - 4 | 0, B = (B - (a[Me + 20 >> 2] + (d >>> 0 < m >>> 0) | 0) | 0) + 4194303 | 0, d = o >>> 0 < 4294967292 ? B + 1 | 0 : B, B = fr, m = d >>> 20 | 0, we = m, m = m + he | 0, B = (we >>> 0 > m >>> 0 ? B + 1 | 0 : B) + 4194303 | 0, m = m - 4 | 0, fr = m >>> 0 < 4294967292 ? B + 1 | 0 : B, B = wr, he = fr >>> 20 | 0, we = he, he = he + Gr | 0, B = (we >>> 0 > he >>> 0 ? B + 1 | 0 : B) + 4194303 | 0, he = he - 4 | 0, dr = he >>> 0 < 4294967292 ? B + 1 | 0 : B, B = Dr, we = dr >>> 20 | 0, wr = we, we = v + we | 0, B = wr >>> 0 > we >>> 0 ? B + 1 | 0 : B, (o & Rr & m & he & we) == -1 ? v = (d & Qe & fr & dr & (B ^ 983040)) == 1048575 : v = 0, v ? (o = 0, B = 0) : (o = he | (m | (o | Be)) | we, B = dr & 1048575 | (fr & 1048575 | (d & 1048575 | Fr)) | B), v = !(B | o);
    }
    return v;
  }
  function Un(B, o, m, d, v, he) {
    B = B | 0, o = o | 0, m = m | 0, d = d | 0, v = v | 0, he = he | 0;
    var we = 0, Be = 0, Me = 0, fr = 0, wr = 0, dr = 0, Dr = 0;
    for (we = be - 224 | 0, be = we, Rn(we + 8 | 0, o, 0), o = m + 16 | 0, Be = A[o + 4 | 0] | A[o + 5 | 0] << 8 | (A[o + 6 | 0] << 16 | A[o + 7 | 0] << 24), Me = we + 112 | 0, fr = Me + 16 | 0, a[fr >> 2] = A[o | 0] | A[o + 1 | 0] << 8 | (A[o + 2 | 0] << 16 | A[o + 3 | 0] << 24), a[fr + 4 >> 2] = Be, o = m + 24 | 0, Be = A[o + 4 | 0] | A[o + 5 | 0] << 8 | (A[o + 6 | 0] << 16 | A[o + 7 | 0] << 24), Me = Me + 24 | 0, a[Me >> 2] = A[o | 0] | A[o + 1 | 0] << 8 | (A[o + 2 | 0] << 16 | A[o + 3 | 0] << 24), a[Me + 4 >> 2] = Be, o = A[m + 4 | 0] | A[m + 5 | 0] << 8 | (A[m + 6 | 0] << 16 | A[m + 7 | 0] << 24), a[we + 112 >> 2] = A[m | 0] | A[m + 1 | 0] << 8 | (A[m + 2 | 0] << 16 | A[m + 3 | 0] << 24), a[we + 116 >> 2] = o, o = m + 8 | 0, m = A[o + 4 | 0] | A[o + 5 | 0] << 8 | (A[o + 6 | 0] << 16 | A[o + 7 | 0] << 24), a[we + 120 >> 2] = A[o | 0] | A[o + 1 | 0] << 8 | (A[o + 2 | 0] << 16 | A[o + 3 | 0] << 24), a[we + 124 >> 2] = m, o = a[we + 12 >> 2], fr = a[we + 8 >> 2], u[we + 175 | 0] = fr, m = a[we + 20 >> 2], wr = a[we + 16 >> 2], u[we + 167 | 0] = wr, Be = a[we + 28 >> 2], dr = a[we + 24 >> 2], u[we + 159 | 0] = dr, Me = a[we + 36 >> 2], Dr = a[we + 32 >> 2], u[we + 151 | 0] = Dr, u[we + 174 | 0] = (o & 255) << 24 | fr >>> 8, u[we + 173 | 0] = (o & 65535) << 16 | fr >>> 16, u[we + 172 | 0] = (o & 16777215) << 8 | fr >>> 24, u[we + 171 | 0] = o, u[we + 170 | 0] = o >>> 8, u[we + 169 | 0] = o >>> 16, u[we + 168 | 0] = o >>> 24, u[we + 166 | 0] = (m & 255) << 24 | wr >>> 8, u[we + 165 | 0] = (m & 65535) << 16 | wr >>> 16, u[we + 164 | 0] = (m & 16777215) << 8 | wr >>> 24, u[we + 163 | 0] = m, u[we + 162 | 0] = m >>> 8, u[we + 161 | 0] = m >>> 16, u[we + 160 | 0] = m >>> 24, u[we + 158 | 0] = (Be & 255) << 24 | dr >>> 8, u[we + 157 | 0] = (Be & 65535) << 16 | dr >>> 16, u[we + 156 | 0] = (Be & 16777215) << 8 | dr >>> 24, u[we + 155 | 0] = Be, u[we + 154 | 0] = Be >>> 8, u[we + 153 | 0] = Be >>> 16, u[we + 152 | 0] = Be >>> 24, u[we + 150 | 0] = (Me & 255) << 24 | Dr >>> 8, u[we + 149 | 0] = (Me & 65535) << 16 | Dr >>> 16, u[we + 148 | 0] = (Me & 16777215) << 8 | Dr >>> 24, u[we + 147 | 0] = Me, u[we + 146 | 0] = Me >>> 8, u[we + 145 | 0] = Me >>> 16, u[we + 144 | 0] = Me >>> 24, v ? (o = v + 24 | 0, m = A[o + 4 | 0] | A[o + 5 | 0] << 8 | (A[o + 6 | 0] << 16 | A[o + 7 | 0] << 24), Be = we + 200 | 0, a[Be >> 2] = A[o | 0] | A[o + 1 | 0] << 8 | (A[o + 2 | 0] << 16 | A[o + 3 | 0] << 24), a[Be + 4 >> 2] = m, o = v + 16 | 0, m = A[o + 4 | 0] | A[o + 5 | 0] << 8 | (A[o + 6 | 0] << 16 | A[o + 7 | 0] << 24), Be = we + 192 | 0, a[Be >> 2] = A[o | 0] | A[o + 1 | 0] << 8 | (A[o + 2 | 0] << 16 | A[o + 3 | 0] << 24), a[Be + 4 >> 2] = m, o = v + 8 | 0, m = A[o + 4 | 0] | A[o + 5 | 0] << 8 | (A[o + 6 | 0] << 16 | A[o + 7 | 0] << 24), Be = we + 184 | 0, a[Be >> 2] = A[o | 0] | A[o + 1 | 0] << 8 | (A[o + 2 | 0] << 16 | A[o + 3 | 0] << 24), a[Be + 4 >> 2] = m, o = A[v + 4 | 0] | A[v + 5 | 0] << 8 | (A[v + 6 | 0] << 16 | A[v + 7 | 0] << 24), a[we + 176 >> 2] = A[v | 0] | A[v + 1 | 0] << 8 | (A[v + 2 | 0] << 16 | A[v + 3 | 0] << 24), a[we + 180 >> 2] = o, m = 96) : m = 64, d && (v = A[d + 4 | 0] | A[d + 5 | 0] << 8 | (A[d + 6 | 0] << 16 | A[d + 7 | 0] << 24), o = (we + 112 | 0) + m | 0, Be = A[d | 0] | A[d + 1 | 0] << 8 | (A[d + 2 | 0] << 16 | A[d + 3 | 0] << 24), u[o | 0] = Be, u[o + 1 | 0] = Be >>> 8, u[o + 2 | 0] = Be >>> 16, u[o + 3 | 0] = Be >>> 24, u[o + 4 | 0] = v, u[o + 5 | 0] = v >>> 8, u[o + 6 | 0] = v >>> 16, u[o + 7 | 0] = v >>> 24, d = d + 8 | 0, v = A[d + 4 | 0] | A[d + 5 | 0] << 8 | (A[d + 6 | 0] << 16 | A[d + 7 | 0] << 24), o = o + 8 | 0, d = A[d | 0] | A[d + 1 | 0] << 8 | (A[d + 2 | 0] << 16 | A[d + 3 | 0] << 24), u[o | 0] = d, u[o + 1 | 0] = d >>> 8, u[o + 2 | 0] = d >>> 16, u[o + 3 | 0] = d >>> 24, u[o + 4 | 0] = v, u[o + 5 | 0] = v >>> 8, u[o + 6 | 0] = v >>> 16, u[o + 7 | 0] = v >>> 24, m = m | 16), o = we + 112 | 0, Bo(we + 40 | 0, o, m), m = 0, xi(o, 112); co(we + 40 | 0, B), m = m + 1 | 0, he >>> 0 >= m >>> 0; )
      ;
    return be = we + 224 | 0, 1;
  }
  function Bo(B, o, m) {
    var d = 0, v = 0, he = 0, we = 0, Be = 0, Me = 0, fr = 0;
    for (d = be - 272 | 0, be = d, a[B >> 2] = 16843009, a[B + 4 >> 2] = 16843009, a[B + 32 >> 2] = 0, a[B + 36 >> 2] = 0, we = B + 24 | 0, a[we >> 2] = 16843009, a[we + 4 >> 2] = 16843009, we = B + 16 | 0, a[we >> 2] = 16843009, a[we + 4 >> 2] = 16843009, we = B + 8 | 0, a[we >> 2] = 16843009, a[we + 4 >> 2] = 16843009, we = B + 40 | 0, a[we >> 2] = 0, a[we + 4 >> 2] = 0, we = B + 48 | 0, a[we >> 2] = 0, a[we + 4 >> 2] = 0, we = B + 56 | 0, a[we >> 2] = 0, a[we + 4 >> 2] = 0, we = d + 128 | 0, a[we >> 2] = 528734635, a[we + 4 >> 2] = 1541459225, we = d + 120 | 0, a[we >> 2] = 1359893119, a[we + 4 >> 2] = -1694144372, we = d + 112 | 0, a[we >> 2] = 1013904242, a[we + 4 >> 2] = -1521486534, we = d + 200 | 0, a[we >> 2] = 0, a[we + 4 >> 2] = 0, we = d + 208 | 0, v = we + 56 | 0, a[v >> 2] = 0, a[v + 4 >> 2] = 0, v = we + 48 | 0, a[v >> 2] = 0, a[v + 4 >> 2] = 0, v = we + 40 | 0, a[v >> 2] = 0, a[v + 4 >> 2] = 0, v = we + 32 | 0, a[v >> 2] = 0, a[v + 4 >> 2] = 0, v = we + 24 | 0, a[v >> 2] = 0, a[v + 4 >> 2] = 0, we = we + 16 | 0, a[we >> 2] = 0, a[we + 4 >> 2] = 0, a[d + 104 >> 2] = 1779033703, a[d + 108 >> 2] = -1150833019, a[d + 216 >> 2] = 0, a[d + 220 >> 2] = 0, a[d + 208 >> 2] = 0, a[d + 212 >> 2] = 0, we = B + 32 | 0, Me = d + 104 | 0, v = 0; he = (d + 208 | 0) + v | 0, u[he | 0] = A[he | 0] ^ 92, Be = he + 1 | 0, u[Be | 0] = A[Be | 0] ^ 92, Be = he + 2 | 0, u[Be | 0] = A[Be | 0] ^ 92, he = he + 3 | 0, u[he | 0] = A[he | 0] ^ 92, v = v + 4 | 0, (v | 0) != 64; )
      ;
    for (Di(Me, d + 208 | 0, 64), a[d + 96 >> 2] = 0, a[d + 100 >> 2] = 0, a[d + 24 >> 2] = 528734635, a[d + 28 >> 2] = 1541459225, a[d + 16 >> 2] = 1359893119, a[d + 20 >> 2] = -1694144372, a[d + 8 >> 2] = 1013904242, a[d + 12 >> 2] = -1521486534, a[d >> 2] = 1779033703, a[d + 4 >> 2] = -1150833019, v = 0; he = (d + 208 | 0) + v | 0, u[he | 0] = A[he | 0] ^ 106, Be = he + 1 | 0, u[Be | 0] = A[Be | 0] ^ 106, Be = he + 2 | 0, u[Be | 0] = A[Be | 0] ^ 106, he = he + 3 | 0, u[he | 0] = A[he | 0] ^ 106, v = v + 4 | 0, (v | 0) != 64; )
      ;
    for (he = d + 208 | 0, Di(d, he, 64), Di(d, B, 32), Di(d, 690368, 1), Di(d, o, m), _n(d, he), Di(Me, he, 32), _n(Me, we), v = d + 248 | 0, a[v >> 2] = 0, a[v + 4 >> 2] = 0, v = d + 256 | 0, a[v >> 2] = 0, a[v + 4 >> 2] = 0, v = d + 264 | 0, a[v >> 2] = 0, a[v + 4 >> 2] = 0, v = we + 24 | 0, Be = A[v + 4 | 0] | A[v + 5 | 0] << 8 | (A[v + 6 | 0] << 16 | A[v + 7 | 0] << 24), fr = he + 24 | 0, a[fr >> 2] = A[v | 0] | A[v + 1 | 0] << 8 | (A[v + 2 | 0] << 16 | A[v + 3 | 0] << 24), a[fr + 4 >> 2] = Be, v = we + 16 | 0, Be = A[v + 4 | 0] | A[v + 5 | 0] << 8 | (A[v + 6 | 0] << 16 | A[v + 7 | 0] << 24), he = he + 16 | 0, a[he >> 2] = A[v | 0] | A[v + 1 | 0] << 8 | (A[v + 2 | 0] << 16 | A[v + 3 | 0] << 24), a[he + 4 >> 2] = Be, a[d + 200 >> 2] = 0, a[d + 204 >> 2] = 0, a[d + 128 >> 2] = 528734635, a[d + 132 >> 2] = 1541459225, a[d + 120 >> 2] = 1359893119, a[d + 124 >> 2] = -1694144372, a[d + 112 >> 2] = 1013904242, a[d + 116 >> 2] = -1521486534, a[d + 104 >> 2] = 1779033703, a[d + 108 >> 2] = -1150833019, a[d + 240 >> 2] = 0, a[d + 244 >> 2] = 0, v = we + 8 | 0, he = A[v + 4 | 0] | A[v + 5 | 0] << 8 | (A[v + 6 | 0] << 16 | A[v + 7 | 0] << 24), a[d + 216 >> 2] = A[v | 0] | A[v + 1 | 0] << 8 | (A[v + 2 | 0] << 16 | A[v + 3 | 0] << 24), a[d + 220 >> 2] = he, v = A[we + 4 | 0] | A[we + 5 | 0] << 8 | (A[we + 6 | 0] << 16 | A[we + 7 | 0] << 24), a[d + 208 >> 2] = A[we | 0] | A[we + 1 | 0] << 8 | (A[we + 2 | 0] << 16 | A[we + 3 | 0] << 24), a[d + 212 >> 2] = v, v = 0; he = (d + 208 | 0) + v | 0, u[he | 0] = A[he | 0] ^ 92, Be = he + 1 | 0, u[Be | 0] = A[Be | 0] ^ 92, Be = he + 2 | 0, u[Be | 0] = A[Be | 0] ^ 92, he = he + 3 | 0, u[he | 0] = A[he | 0] ^ 92, v = v + 4 | 0, (v | 0) != 64; )
      ;
    for (Di(Me, d + 208 | 0, 64), a[d + 96 >> 2] = 0, a[d + 100 >> 2] = 0, a[d + 24 >> 2] = 528734635, a[d + 28 >> 2] = 1541459225, a[d + 16 >> 2] = 1359893119, a[d + 20 >> 2] = -1694144372, a[d + 8 >> 2] = 1013904242, a[d + 12 >> 2] = -1521486534, a[d >> 2] = 1779033703, a[d + 4 >> 2] = -1150833019, v = 0; he = (d + 208 | 0) + v | 0, u[he | 0] = A[he | 0] ^ 106, Be = he + 1 | 0, u[Be | 0] = A[Be | 0] ^ 106, Be = he + 2 | 0, u[Be | 0] = A[Be | 0] ^ 106, he = he + 3 | 0, u[he | 0] = A[he | 0] ^ 106, v = v + 4 | 0, (v | 0) != 64; )
      ;
    for (he = d + 208 | 0, Di(d, he, 64), Di(d, B, 32), _n(d, he), Di(Me, he, 32), _n(Me, B), v = d + 248 | 0, a[v >> 2] = 0, a[v + 4 >> 2] = 0, v = d + 256 | 0, a[v >> 2] = 0, a[v + 4 >> 2] = 0, v = d + 264 | 0, a[v >> 2] = 0, a[v + 4 >> 2] = 0, v = we + 24 | 0, Be = A[v + 4 | 0] | A[v + 5 | 0] << 8 | (A[v + 6 | 0] << 16 | A[v + 7 | 0] << 24), fr = he + 24 | 0, a[fr >> 2] = A[v | 0] | A[v + 1 | 0] << 8 | (A[v + 2 | 0] << 16 | A[v + 3 | 0] << 24), a[fr + 4 >> 2] = Be, v = we + 16 | 0, Be = A[v + 4 | 0] | A[v + 5 | 0] << 8 | (A[v + 6 | 0] << 16 | A[v + 7 | 0] << 24), he = he + 16 | 0, a[he >> 2] = A[v | 0] | A[v + 1 | 0] << 8 | (A[v + 2 | 0] << 16 | A[v + 3 | 0] << 24), a[he + 4 >> 2] = Be, a[d + 200 >> 2] = 0, a[d + 204 >> 2] = 0, a[d + 128 >> 2] = 528734635, a[d + 132 >> 2] = 1541459225, a[d + 120 >> 2] = 1359893119, a[d + 124 >> 2] = -1694144372, a[d + 112 >> 2] = 1013904242, a[d + 116 >> 2] = -1521486534, a[d + 104 >> 2] = 1779033703, a[d + 108 >> 2] = -1150833019, a[d + 240 >> 2] = 0, a[d + 244 >> 2] = 0, v = we + 8 | 0, he = A[v + 4 | 0] | A[v + 5 | 0] << 8 | (A[v + 6 | 0] << 16 | A[v + 7 | 0] << 24), a[d + 216 >> 2] = A[v | 0] | A[v + 1 | 0] << 8 | (A[v + 2 | 0] << 16 | A[v + 3 | 0] << 24), a[d + 220 >> 2] = he, v = A[we + 4 | 0] | A[we + 5 | 0] << 8 | (A[we + 6 | 0] << 16 | A[we + 7 | 0] << 24), a[d + 208 >> 2] = A[we | 0] | A[we + 1 | 0] << 8 | (A[we + 2 | 0] << 16 | A[we + 3 | 0] << 24), a[d + 212 >> 2] = v, v = 0; he = (d + 208 | 0) + v | 0, u[he | 0] = A[he | 0] ^ 92, Be = he + 1 | 0, u[Be | 0] = A[Be | 0] ^ 92, Be = he + 2 | 0, u[Be | 0] = A[Be | 0] ^ 92, he = he + 3 | 0, u[he | 0] = A[he | 0] ^ 92, v = v + 4 | 0, (v | 0) != 64; )
      ;
    for (Di(Me, d + 208 | 0, 64), a[d + 96 >> 2] = 0, a[d + 100 >> 2] = 0, a[d + 24 >> 2] = 528734635, a[d + 28 >> 2] = 1541459225, a[d + 16 >> 2] = 1359893119, a[d + 20 >> 2] = -1694144372, a[d + 8 >> 2] = 1013904242, a[d + 12 >> 2] = -1521486534, a[d >> 2] = 1779033703, a[d + 4 >> 2] = -1150833019, v = 0; he = (d + 208 | 0) + v | 0, u[he | 0] = A[he | 0] ^ 106, Be = he + 1 | 0, u[Be | 0] = A[Be | 0] ^ 106, Be = he + 2 | 0, u[Be | 0] = A[Be | 0] ^ 106, he = he + 3 | 0, u[he | 0] = A[he | 0] ^ 106, v = v + 4 | 0, (v | 0) != 64; )
      ;
    for (v = d + 208 | 0, Di(d, v, 64), Di(d, B, 32), Di(d, 690369, 1), Di(d, o, m), _n(d, v), Di(Me, v, 32), _n(Me, we), o = d + 248 | 0, a[o >> 2] = 0, a[o + 4 >> 2] = 0, o = d + 256 | 0, a[o >> 2] = 0, a[o + 4 >> 2] = 0, o = d + 264 | 0, a[o >> 2] = 0, a[o + 4 >> 2] = 0, o = we + 24 | 0, m = A[o + 4 | 0] | A[o + 5 | 0] << 8 | (A[o + 6 | 0] << 16 | A[o + 7 | 0] << 24), he = v + 24 | 0, a[he >> 2] = A[o | 0] | A[o + 1 | 0] << 8 | (A[o + 2 | 0] << 16 | A[o + 3 | 0] << 24), a[he + 4 >> 2] = m, o = we + 16 | 0, m = A[o + 4 | 0] | A[o + 5 | 0] << 8 | (A[o + 6 | 0] << 16 | A[o + 7 | 0] << 24), v = v + 16 | 0, a[v >> 2] = A[o | 0] | A[o + 1 | 0] << 8 | (A[o + 2 | 0] << 16 | A[o + 3 | 0] << 24), a[v + 4 >> 2] = m, a[d + 200 >> 2] = 0, a[d + 204 >> 2] = 0, a[d + 128 >> 2] = 528734635, a[d + 132 >> 2] = 1541459225, a[d + 120 >> 2] = 1359893119, a[d + 124 >> 2] = -1694144372, a[d + 112 >> 2] = 1013904242, a[d + 116 >> 2] = -1521486534, a[d + 104 >> 2] = 1779033703, a[d + 108 >> 2] = -1150833019, a[d + 240 >> 2] = 0, a[d + 244 >> 2] = 0, o = we + 8 | 0, m = A[o + 4 | 0] | A[o + 5 | 0] << 8 | (A[o + 6 | 0] << 16 | A[o + 7 | 0] << 24), a[d + 216 >> 2] = A[o | 0] | A[o + 1 | 0] << 8 | (A[o + 2 | 0] << 16 | A[o + 3 | 0] << 24), a[d + 220 >> 2] = m, o = A[we + 4 | 0] | A[we + 5 | 0] << 8 | (A[we + 6 | 0] << 16 | A[we + 7 | 0] << 24), a[d + 208 >> 2] = A[we | 0] | A[we + 1 | 0] << 8 | (A[we + 2 | 0] << 16 | A[we + 3 | 0] << 24), a[d + 212 >> 2] = o, v = 0; o = (d + 208 | 0) + v | 0, u[o | 0] = A[o | 0] ^ 92, m = o + 1 | 0, u[m | 0] = A[m | 0] ^ 92, m = o + 2 | 0, u[m | 0] = A[m | 0] ^ 92, o = o + 3 | 0, u[o | 0] = A[o | 0] ^ 92, v = v + 4 | 0, (v | 0) != 64; )
      ;
    for (Di(Me, d + 208 | 0, 64), a[d + 96 >> 2] = 0, a[d + 100 >> 2] = 0, a[d + 24 >> 2] = 528734635, a[d + 28 >> 2] = 1541459225, a[d + 16 >> 2] = 1359893119, a[d + 20 >> 2] = -1694144372, a[d + 8 >> 2] = 1013904242, a[d + 12 >> 2] = -1521486534, a[d >> 2] = 1779033703, a[d + 4 >> 2] = -1150833019, v = 0; o = (d + 208 | 0) + v | 0, u[o | 0] = A[o | 0] ^ 106, m = o + 1 | 0, u[m | 0] = A[m | 0] ^ 106, m = o + 2 | 0, u[m | 0] = A[m | 0] ^ 106, o = o + 3 | 0, u[o | 0] = A[o | 0] ^ 106, v = v + 4 | 0, (v | 0) != 64; )
      ;
    o = d + 208 | 0, Di(d, o, 64), Di(d, B, 32), _n(d, o), Di(Me, o, 32), _n(Me, B), a[B + 64 >> 2] = 0, be = d + 272 | 0;
  }
  function co(B, o) {
    var m = 0, d = 0, v = 0, he = 0, we = 0, Be = 0, Me = 0;
    if (v = be - 272 | 0, be = v, a[B + 64 >> 2]) {
      for (m = v + 208 | 0, d = m + 40 | 0, a[d >> 2] = 0, a[d + 4 >> 2] = 0, d = m + 48 | 0, a[d >> 2] = 0, a[d + 4 >> 2] = 0, m = m + 56 | 0, a[m >> 2] = 0, a[m + 4 >> 2] = 0, m = v + 200 | 0, a[m >> 2] = 0, a[m + 4 >> 2] = 0, m = v + 128 | 0, a[m >> 2] = 528734635, a[m + 4 >> 2] = 1541459225, m = v + 120 | 0, a[m >> 2] = 1359893119, a[m + 4 >> 2] = -1694144372, m = v + 112 | 0, a[m >> 2] = 1013904242, a[m + 4 >> 2] = -1521486534, m = B + 56 | 0, d = A[m + 4 | 0] | A[m + 5 | 0] << 8 | (A[m + 6 | 0] << 16 | A[m + 7 | 0] << 24), we = v + 232 | 0, a[we >> 2] = A[m | 0] | A[m + 1 | 0] << 8 | (A[m + 2 | 0] << 16 | A[m + 3 | 0] << 24), a[we + 4 >> 2] = d, m = B + 48 | 0, d = A[m + 4 | 0] | A[m + 5 | 0] << 8 | (A[m + 6 | 0] << 16 | A[m + 7 | 0] << 24), we = v + 224 | 0, a[we >> 2] = A[m | 0] | A[m + 1 | 0] << 8 | (A[m + 2 | 0] << 16 | A[m + 3 | 0] << 24), a[we + 4 >> 2] = d, a[v + 104 >> 2] = 1779033703, a[v + 108 >> 2] = -1150833019, a[v + 240 >> 2] = 0, a[v + 244 >> 2] = 0, m = B + 40 | 0, d = A[m + 4 | 0] | A[m + 5 | 0] << 8 | (A[m + 6 | 0] << 16 | A[m + 7 | 0] << 24), a[v + 216 >> 2] = A[m | 0] | A[m + 1 | 0] << 8 | (A[m + 2 | 0] << 16 | A[m + 3 | 0] << 24), a[v + 220 >> 2] = d, m = A[B + 36 | 0] | A[B + 37 | 0] << 8 | (A[B + 38 | 0] << 16 | A[B + 39 | 0] << 24), a[v + 208 >> 2] = A[B + 32 | 0] | A[B + 33 | 0] << 8 | (A[B + 34 | 0] << 16 | A[B + 35 | 0] << 24), a[v + 212 >> 2] = m, m = B + 32 | 0, we = v + 104 | 0, d = 0; he = (v + 208 | 0) + d | 0, u[he | 0] = A[he | 0] ^ 92, Be = he + 1 | 0, u[Be | 0] = A[Be | 0] ^ 92, Be = he + 2 | 0, u[Be | 0] = A[Be | 0] ^ 92, he = he + 3 | 0, u[he | 0] = A[he | 0] ^ 92, d = d + 4 | 0, (d | 0) != 64; )
        ;
      for (Di(we, v + 208 | 0, 64), a[v + 96 >> 2] = 0, a[v + 100 >> 2] = 0, a[v + 24 >> 2] = 528734635, a[v + 28 >> 2] = 1541459225, a[v + 16 >> 2] = 1359893119, a[v + 20 >> 2] = -1694144372, a[v + 8 >> 2] = 1013904242, a[v + 12 >> 2] = -1521486534, a[v >> 2] = 1779033703, a[v + 4 >> 2] = -1150833019, d = 0; he = (v + 208 | 0) + d | 0, u[he | 0] = A[he | 0] ^ 106, Be = he + 1 | 0, u[Be | 0] = A[Be | 0] ^ 106, Be = he + 2 | 0, u[Be | 0] = A[Be | 0] ^ 106, he = he + 3 | 0, u[he | 0] = A[he | 0] ^ 106, d = d + 4 | 0, (d | 0) != 64; )
        ;
      for (he = v + 208 | 0, Di(v, he, 64), Di(v, B, 32), Di(v, 690370, 1), _n(v, he), Di(we, he, 32), _n(we, m), d = v + 248 | 0, a[d >> 2] = 0, a[d + 4 >> 2] = 0, d = v + 256 | 0, a[d >> 2] = 0, a[d + 4 >> 2] = 0, d = v + 264 | 0, a[d >> 2] = 0, a[d + 4 >> 2] = 0, d = m + 24 | 0, Be = A[d + 4 | 0] | A[d + 5 | 0] << 8 | (A[d + 6 | 0] << 16 | A[d + 7 | 0] << 24), Me = he + 24 | 0, a[Me >> 2] = A[d | 0] | A[d + 1 | 0] << 8 | (A[d + 2 | 0] << 16 | A[d + 3 | 0] << 24), a[Me + 4 >> 2] = Be, d = m + 16 | 0, Be = A[d + 4 | 0] | A[d + 5 | 0] << 8 | (A[d + 6 | 0] << 16 | A[d + 7 | 0] << 24), he = he + 16 | 0, a[he >> 2] = A[d | 0] | A[d + 1 | 0] << 8 | (A[d + 2 | 0] << 16 | A[d + 3 | 0] << 24), a[he + 4 >> 2] = Be, a[v + 200 >> 2] = 0, a[v + 204 >> 2] = 0, a[v + 128 >> 2] = 528734635, a[v + 132 >> 2] = 1541459225, a[v + 120 >> 2] = 1359893119, a[v + 124 >> 2] = -1694144372, a[v + 112 >> 2] = 1013904242, a[v + 116 >> 2] = -1521486534, a[v + 104 >> 2] = 1779033703, a[v + 108 >> 2] = -1150833019, a[v + 240 >> 2] = 0, a[v + 244 >> 2] = 0, d = m + 8 | 0, he = A[d + 4 | 0] | A[d + 5 | 0] << 8 | (A[d + 6 | 0] << 16 | A[d + 7 | 0] << 24), a[v + 216 >> 2] = A[d | 0] | A[d + 1 | 0] << 8 | (A[d + 2 | 0] << 16 | A[d + 3 | 0] << 24), a[v + 220 >> 2] = he, d = A[m + 4 | 0] | A[m + 5 | 0] << 8 | (A[m + 6 | 0] << 16 | A[m + 7 | 0] << 24), a[v + 208 >> 2] = A[m | 0] | A[m + 1 | 0] << 8 | (A[m + 2 | 0] << 16 | A[m + 3 | 0] << 24), a[v + 212 >> 2] = d, d = 0; m = (v + 208 | 0) + d | 0, u[m | 0] = A[m | 0] ^ 92, he = m + 1 | 0, u[he | 0] = A[he | 0] ^ 92, he = m + 2 | 0, u[he | 0] = A[he | 0] ^ 92, m = m + 3 | 0, u[m | 0] = A[m | 0] ^ 92, d = d + 4 | 0, (d | 0) != 64; )
        ;
      for (Di(we, v + 208 | 0, 64), a[v + 96 >> 2] = 0, a[v + 100 >> 2] = 0, a[v + 24 >> 2] = 528734635, a[v + 28 >> 2] = 1541459225, a[v + 16 >> 2] = 1359893119, a[v + 20 >> 2] = -1694144372, a[v + 8 >> 2] = 1013904242, a[v + 12 >> 2] = -1521486534, a[v >> 2] = 1779033703, a[v + 4 >> 2] = -1150833019, d = 0; m = (v + 208 | 0) + d | 0, u[m | 0] = A[m | 0] ^ 106, he = m + 1 | 0, u[he | 0] = A[he | 0] ^ 106, he = m + 2 | 0, u[he | 0] = A[he | 0] ^ 106, m = m + 3 | 0, u[m | 0] = A[m | 0] ^ 106, d = d + 4 | 0, (d | 0) != 64; )
        ;
      m = v + 208 | 0, Di(v, m, 64), Di(v, B, 32), _n(v, m), Di(we, m, 32), _n(we, B);
    }
    for (m = v + 208 | 0, d = m + 40 | 0, a[d >> 2] = 0, a[d + 4 >> 2] = 0, d = m + 48 | 0, a[d >> 2] = 0, a[d + 4 >> 2] = 0, m = m + 56 | 0, a[m >> 2] = 0, a[m + 4 >> 2] = 0, m = v + 200 | 0, a[m >> 2] = 0, a[m + 4 >> 2] = 0, m = v + 128 | 0, a[m >> 2] = 528734635, a[m + 4 >> 2] = 1541459225, m = v + 120 | 0, a[m >> 2] = 1359893119, a[m + 4 >> 2] = -1694144372, m = v + 112 | 0, a[m >> 2] = 1013904242, a[m + 4 >> 2] = -1521486534, m = B + 56 | 0, d = A[m + 4 | 0] | A[m + 5 | 0] << 8 | (A[m + 6 | 0] << 16 | A[m + 7 | 0] << 24), we = v + 232 | 0, a[we >> 2] = A[m | 0] | A[m + 1 | 0] << 8 | (A[m + 2 | 0] << 16 | A[m + 3 | 0] << 24), a[we + 4 >> 2] = d, m = B + 48 | 0, d = A[m + 4 | 0] | A[m + 5 | 0] << 8 | (A[m + 6 | 0] << 16 | A[m + 7 | 0] << 24), we = v + 224 | 0, a[we >> 2] = A[m | 0] | A[m + 1 | 0] << 8 | (A[m + 2 | 0] << 16 | A[m + 3 | 0] << 24), a[we + 4 >> 2] = d, a[v + 104 >> 2] = 1779033703, a[v + 108 >> 2] = -1150833019, a[v + 240 >> 2] = 0, a[v + 244 >> 2] = 0, m = B + 40 | 0, d = A[m + 4 | 0] | A[m + 5 | 0] << 8 | (A[m + 6 | 0] << 16 | A[m + 7 | 0] << 24), a[v + 216 >> 2] = A[m | 0] | A[m + 1 | 0] << 8 | (A[m + 2 | 0] << 16 | A[m + 3 | 0] << 24), a[v + 220 >> 2] = d, m = A[B + 36 | 0] | A[B + 37 | 0] << 8 | (A[B + 38 | 0] << 16 | A[B + 39 | 0] << 24), a[v + 208 >> 2] = A[B + 32 | 0] | A[B + 33 | 0] << 8 | (A[B + 34 | 0] << 16 | A[B + 35 | 0] << 24), a[v + 212 >> 2] = m, we = v + 104 | 0, d = 0; m = (v + 208 | 0) + d | 0, u[m | 0] = A[m | 0] ^ 92, he = m + 1 | 0, u[he | 0] = A[he | 0] ^ 92, he = m + 2 | 0, u[he | 0] = A[he | 0] ^ 92, m = m + 3 | 0, u[m | 0] = A[m | 0] ^ 92, d = d + 4 | 0, (d | 0) != 64; )
      ;
    for (Di(we, v + 208 | 0, 64), a[v + 96 >> 2] = 0, a[v + 100 >> 2] = 0, a[v + 24 >> 2] = 528734635, a[v + 28 >> 2] = 1541459225, a[v + 16 >> 2] = 1359893119, a[v + 20 >> 2] = -1694144372, a[v + 8 >> 2] = 1013904242, a[v + 12 >> 2] = -1521486534, a[v >> 2] = 1779033703, a[v + 4 >> 2] = -1150833019, d = 0; m = (v + 208 | 0) + d | 0, u[m | 0] = A[m | 0] ^ 106, he = m + 1 | 0, u[he | 0] = A[he | 0] ^ 106, he = m + 2 | 0, u[he | 0] = A[he | 0] ^ 106, m = m + 3 | 0, u[m | 0] = A[m | 0] ^ 106, d = d + 4 | 0, (d | 0) != 64; )
      ;
    m = v + 208 | 0, Di(v, m, 64), Di(v, B, 32), _n(v, m), Di(we, m, 32), _n(we, B), m = B + 24 | 0, we = A[m + 4 | 0] | A[m + 5 | 0] << 8 | (A[m + 6 | 0] << 16 | A[m + 7 | 0] << 24), d = o + 24 | 0, m = A[m | 0] | A[m + 1 | 0] << 8 | (A[m + 2 | 0] << 16 | A[m + 3 | 0] << 24), u[d | 0] = m, u[d + 1 | 0] = m >>> 8, u[d + 2 | 0] = m >>> 16, u[d + 3 | 0] = m >>> 24, u[d + 4 | 0] = we, u[d + 5 | 0] = we >>> 8, u[d + 6 | 0] = we >>> 16, u[d + 7 | 0] = we >>> 24, m = B + 16 | 0, we = A[m + 4 | 0] | A[m + 5 | 0] << 8 | (A[m + 6 | 0] << 16 | A[m + 7 | 0] << 24), d = o + 16 | 0, m = A[m | 0] | A[m + 1 | 0] << 8 | (A[m + 2 | 0] << 16 | A[m + 3 | 0] << 24), u[d | 0] = m, u[d + 1 | 0] = m >>> 8, u[d + 2 | 0] = m >>> 16, u[d + 3 | 0] = m >>> 24, u[d + 4 | 0] = we, u[d + 5 | 0] = we >>> 8, u[d + 6 | 0] = we >>> 16, u[d + 7 | 0] = we >>> 24, m = B + 8 | 0, we = A[m + 4 | 0] | A[m + 5 | 0] << 8 | (A[m + 6 | 0] << 16 | A[m + 7 | 0] << 24), d = o + 8 | 0, m = A[m | 0] | A[m + 1 | 0] << 8 | (A[m + 2 | 0] << 16 | A[m + 3 | 0] << 24), u[d | 0] = m, u[d + 1 | 0] = m >>> 8, u[d + 2 | 0] = m >>> 16, u[d + 3 | 0] = m >>> 24, u[d + 4 | 0] = we, u[d + 5 | 0] = we >>> 8, u[d + 6 | 0] = we >>> 16, u[d + 7 | 0] = we >>> 24, m = A[B + 4 | 0] | A[B + 5 | 0] << 8 | (A[B + 6 | 0] << 16 | A[B + 7 | 0] << 24), d = A[B | 0] | A[B + 1 | 0] << 8 | (A[B + 2 | 0] << 16 | A[B + 3 | 0] << 24), u[o | 0] = d, u[o + 1 | 0] = d >>> 8, u[o + 2 | 0] = d >>> 16, u[o + 3 | 0] = d >>> 24, u[o + 4 | 0] = m, u[o + 5 | 0] = m >>> 8, u[o + 6 | 0] = m >>> 16, u[o + 7 | 0] = m >>> 24, a[B + 64 >> 2] = 1, be = v + 272 | 0;
  }
  function To(B, o, m, d, v, he) {
    var we = 0, Be = 0, Me = 0, fr = 0, wr = 0, dr = 0, Dr = 0, Rr = 0, Qe = 0, Fr = 0, Gr = 0, $r = 0, ni = 0, mi = 0, Si = 0, Oi = 0, $i = 0, zi = 0, un = 0, In = 0, Ti = 0, Sn = 0, Kn = 0, Vn = 0, Xn = 0, uo = 0, yo = 0;
    dr = be - 464 | 0, be = dr, we = o + 24 | 0, a[we >> 2] = 0, a[we + 4 >> 2] = 0, we = o + 16 | 0, a[we >> 2] = 0, a[we + 4 >> 2] = 0, we = o + 8 | 0, a[we >> 2] = 0, a[we + 4 >> 2] = 0, a[o >> 2] = 0, a[o + 4 >> 2] = 0, we = m + 24 | 0, a[we >> 2] = 0, a[we + 4 >> 2] = 0, we = m + 16 | 0, a[we >> 2] = 0, a[we + 4 >> 2] = 0, we = m + 8 | 0, a[we >> 2] = 0, a[we + 4 >> 2] = 0, a[m >> 2] = 0, a[m + 4 >> 2] = 0, d && (a[d >> 2] = 0), Rn(dr + 96 | 0, 690788, dr + 256 | 0), Qe = a[dr + 120 >> 2], Rr = a[dr + 112 >> 2], wr = a[dr + 104 >> 2], Dr = a[dr + 96 >> 2], ni = a[dr + 124 >> 2], Gr = a[dr + 116 >> 2], Me = a[dr + 108 >> 2], Fr = a[dr + 100 >> 2], Be = a[dr + 256 >> 2] | !(Qe | (Rr | (wr | Dr)) | (ni | (Gr | (Me | Fr)))), we = Be ? 0 : -1, a[dr + 120 >> 2] = we & Qe, a[dr + 124 >> 2] = we & ni, a[dr + 112 >> 2] = we & Rr, a[dr + 116 >> 2] = we & Gr, a[dr + 104 >> 2] = we & wr, a[dr + 108 >> 2] = we & Me, a[dr + 96 >> 2] = we & Dr | (Be | 0) != 0, a[dr + 100 >> 2] = we & Fr, Rn(dr + 32 | 0, 655649, 0), uo = !Be, Kn = v || 4;
    e: {
      if (!(ji[Kn | 0](dr, 655649, 690788, 0, he, 0) | 0))
        break e;
      for (v = 1; ; ) {
        Vn = v, Rn(dr - -64 | 0, dr, dr + 256 | 0);
        t: {
          if (a[dr + 256 >> 2] | !(a[dr + 88 >> 2] | (a[dr + 80 >> 2] | (a[dr + 72 >> 2] | a[dr + 64 >> 2])) | (a[dr + 92 >> 2] | (a[dr + 84 >> 2] | (a[dr + 76 >> 2] | a[dr + 68 >> 2])))) || (a[dr + 132 >> 2] = 0, v = dr + 256 | 0, xs(B, v, dr - -64 | 0), Fo(dr + 168 | 0, v), we = dr, Gr = a[we + 232 >> 2], ni = a[we + 236 >> 2], Qe = a[we + 224 >> 2], Fr = a[we + 228 >> 2], wr = a[we + 216 >> 2], Me = a[we + 220 >> 2], fr = a[we + 212 >> 2], Dr = a[we + 240 >> 2], Rr = a[we + 244 >> 2], Si = Rr, v = a[we + 208 >> 2], Rr = oi(Rr >>> 16 | 0, 0, 977, 1), Be = v + Rr | 0, v = fr + Fe | 0, Rr = Be >>> 0 < Rr >>> 0 ? v + 1 | 0 : v, v = Me, fr = Rr >>> 20 | 0, $r = fr, fr = wr + fr | 0, Me = $r >>> 0 > fr >>> 0 ? v + 1 | 0 : v, v = Fr, wr = Me >>> 20 | 0, Fr = wr, wr = wr + Qe | 0, Qe = Fr >>> 0 > wr >>> 0 ? v + 1 | 0 : v, v = ni, Fr = Qe >>> 20 | 0, $r = Fr, Fr = Gr + Fr | 0, v = $r >>> 0 > Fr >>> 0 ? v + 1 | 0 : v, Oi = wr, Gr = v, Xn = Qe & 1048575, Qe = (Fr & (wr & fr)) == -1 & (v & (Xn & Me)) == 1048575, v = Si & 65535, wr = Gr >>> 20 | 0, $r = wr, wr = wr + Dr | 0, ni = $r >>> 0 > wr >>> 0 ? v + 1 | 0 : v, v = Rr & 1048575, $i = wr, wr = oi(Qe & ((wr | 0) == -1 & (ni | 0) == 65535) & ((v | 0) == 1048574 & Be >>> 0 > 4294966318 | v >>> 0 > 1048574) | ni >>> 16, 0, 977, 1) + Be | 0, v = Fe + v | 0, Sn = wr, a[we + 208 >> 2] = wr, Qe = Be >>> 0 > wr >>> 0 ? v + 1 | 0 : v, a[we + 212 >> 2] = Qe & 1048575, Si = a[we + 192 >> 2], $r = a[we + 196 >> 2], Rr = a[we + 184 >> 2], zi = a[we + 188 >> 2], Dr = a[we + 176 >> 2], mi = a[we + 180 >> 2], In = a[we + 172 >> 2], Ti = a[we + 200 >> 2], wr = a[we + 204 >> 2], yo = wr, v = a[we + 168 >> 2], Be = oi(wr >>> 16 | 0, 0, 977, 1), wr = v + Be | 0, v = In + Fe | 0, In = Be >>> 0 > wr >>> 0 ? v + 1 | 0 : v, v = mi, Be = In >>> 20 | 0, mi = Be, Be = Be + Dr | 0, mi = mi >>> 0 > Be >>> 0 ? v + 1 | 0 : v, v = zi, Dr = mi >>> 20 | 0, zi = Dr, Dr = Dr + Rr | 0, un = zi >>> 0 > Dr >>> 0 ? v + 1 | 0 : v, v = $r, Rr = un >>> 20 | 0, Si = Rr + Si | 0, v = Rr >>> 0 > Si >>> 0 ? v + 1 | 0 : v, Rr = mi & 1048575, zi = Dr, $r = v, un = un & 1048575, Dr = (Be & Dr & Si) == -1 & (v & (mi & un)) == 1048575, v = yo & 65535, we = $r >>> 20 | 0, mi = we, we = we + Ti | 0, mi = mi >>> 0 > we >>> 0 ? v + 1 | 0 : v, v = In & 1048575, Ti = we, we = oi(Dr & ((we | 0) == -1 & (mi | 0) == 65535) & ((v | 0) == 1048574 & wr >>> 0 > 4294966318 | v >>> 0 > 1048574) | mi >>> 16, 0, 977, 1) + wr | 0, v = Fe + v | 0, v = we >>> 0 < wr >>> 0 ? v + 1 | 0 : v, wr = we, we = v, v = Rr, Dr = we >>> 20 | 0, Rr = Dr, Dr = Be + Dr | 0, v = Rr >>> 0 > Dr >>> 0 ? v + 1 | 0 : v, a[dr + 176 >> 2] = Dr, Be = v, a[dr + 180 >> 2] = v & 1048575, v = Me & 1048575, Qe = Qe >>> 20 | 0, fr = fr + Qe | 0, v = Qe >>> 0 > fr >>> 0 ? v + 1 | 0 : v, a[dr + 216 >> 2] = fr, a[dr + 220 >> 2] = v & 1048575, fr = v, v = Xn, fr = (fr >>> 20 | 0) + Oi | 0, v = fr >>> 0 < Oi >>> 0 ? v + 1 | 0 : v, a[dr + 224 >> 2] = fr, Oi = v, a[dr + 228 >> 2] = v & 1048575, Me = dr, fr = Si, $r = $r & 1048575, v = un, Si = Be, Rr = (Be >>> 20 | 0) + zi | 0, Be = Rr >>> 0 < zi >>> 0 ? v + 1 | 0 : v, v = $r, Qe = Be >>> 20 | 0, $r = Qe, Qe = fr + Qe | 0, v = $r >>> 0 > Qe >>> 0 ? v + 1 | 0 : v, a[Me + 192 >> 2] = Qe, fr = v, a[Me + 196 >> 2] = v & 1048575, v = Gr & 1048575, Gr = Oi >>> 20 | 0, Fr = Gr + Fr | 0, v = Gr >>> 0 > Fr >>> 0 ? v + 1 | 0 : v, a[Me + 232 >> 2] = Fr, Fr = v, a[Me + 236 >> 2] = v & 1048575, v = mi, Gr = fr, $r = (fr >>> 20 | 0) + Ti | 0, v = $r >>> 0 < Ti >>> 0 ? v + 1 | 0 : v, a[Me + 200 >> 2] = $r, fr = v, a[Me + 204 >> 2] = v & 65535, v = ni, Fr = (Fr >>> 20 | 0) + $i | 0, v = Fr >>> 0 < $i >>> 0 ? v + 1 | 0 : v, a[Me + 240 >> 2] = Fr, a[Me + 244 >> 2] = v & 65535, Fr = Rr, a[Me + 184 >> 2] = Rr, v = Be & 1048575, a[Me + 188 >> 2] = v, a[Me + 168 >> 2] = wr, Rr = we & 1048575, a[Me + 172 >> 2] = Rr, u[Me + 415 | 0] = wr, u[Me + 414 | 0] = (we & 255) << 24 | wr >>> 8, u[Me + 413 | 0] = (we & 65535) << 16 | wr >>> 16, u[Me + 412 | 0] = (we & 16777215) << 8 | wr >>> 24, u[Me + 411 | 0] = we, u[Me + 410 | 0] = we >>> 8, we = Dr >>> 28 | 0, u[Me + 409 | 0] = Dr << 4 | Rr >>> 16, u[Me + 408 | 0] = (Si & 15) << 28 | Dr >>> 4, u[Me + 407 | 0] = (Si & 4095) << 20 | Dr >>> 12, u[Me + 406 | 0] = (Si & 1048575) << 12 | Dr >>> 20, u[Me + 405 | 0] = we | (Si & 268435455) << 4, u[Me + 404 | 0] = Si >>> 4, u[Me + 403 | 0] = Si >>> 12, u[Me + 402 | 0] = Fr, u[Me + 401 | 0] = (Be & 255) << 24 | Fr >>> 8, u[Me + 400 | 0] = (Be & 65535) << 16 | Fr >>> 16, u[Me + 399 | 0] = (Be & 16777215) << 8 | Fr >>> 24, u[Me + 398 | 0] = Be, u[Me + 397 | 0] = Be >>> 8, we = Qe >>> 28 | 0, u[Me + 396 | 0] = Qe << 4 | v >>> 16, u[Me + 395 | 0] = (Gr & 15) << 28 | Qe >>> 4, u[Me + 394 | 0] = (Gr & 4095) << 20 | Qe >>> 12, u[Me + 393 | 0] = (Gr & 1048575) << 12 | Qe >>> 20, u[Me + 392 | 0] = we | (Gr & 268435455) << 4, u[Me + 391 | 0] = Gr >>> 4, u[Me + 390 | 0] = Gr >>> 12, u[Me + 389 | 0] = $r, u[Me + 388 | 0] = (fr & 255) << 24 | $r >>> 8, u[Me + 387 | 0] = (fr & 65535) << 16 | $r >>> 16, u[Me + 386 | 0] = (fr & 16777215) << 8 | $r >>> 24, u[Me + 385 | 0] = fr, u[Me + 384 | 0] = fr >>> 8, Rn(o, Me + 384 | 0, Me + 132 | 0), d && (a[d >> 2] = Sn & 1 | a[Me + 132 >> 2] << 1), Oi = Me + 136 | 0, di(Oi, o, Me + 96 | 0), Be = a[Me + 32 >> 2], fr = a[Me + 136 >> 2], Fr = Be + fr | 0, we = a[Me + 36 >> 2], v = we + a[Me + 140 >> 2] | 0, wr = fr >>> 0 > Fr >>> 0 ? v + 1 | 0 : v, ni = (we | 0) == (wr | 0) & Be >>> 0 > Fr >>> 0 | we >>> 0 > wr >>> 0, Be = a[Me + 144 >> 2], we = ni + Be | 0, v = a[Me + 148 >> 2], v = we >>> 0 < Be >>> 0 ? v + 1 | 0 : v, fr = we, we = a[Me + 40 >> 2], Rr = fr + we | 0, Be = v, v = v + a[Me + 44 >> 2] | 0, Dr = we >>> 0 > Rr >>> 0 ? v + 1 | 0 : v, mi = a[Me + 48 >> 2], we = a[Me + 152 >> 2], Qe = mi + we | 0, Si = a[Me + 52 >> 2], v = Si + a[Me + 156 >> 2] | 0, we = we >>> 0 > Qe >>> 0 ? v + 1 | 0 : v, Gr = Qe, v = !Be & fr >>> 0 < ni >>> 0, fr = (Be | 0) == (Dr | 0) & fr >>> 0 > Rr >>> 0 | Be >>> 0 > Dr >>> 0, Be = v + fr | 0, v = (Be >>> 0 < fr >>> 0) + we | 0, Qe = Be + Qe | 0, fr = Qe >>> 0 < Be >>> 0 ? v + 1 | 0 : v, $i = a[Me + 56 >> 2], Be = a[Me + 160 >> 2], ni = $i + Be | 0, $r = a[Me + 60 >> 2], v = $r + a[Me + 164 >> 2] | 0, Be = Be >>> 0 > ni >>> 0 ? v + 1 | 0 : v, v = (we | 0) == (Si | 0) & Gr >>> 0 < mi >>> 0 | we >>> 0 < Si >>> 0, Gr = (we | 0) == (fr | 0) & Qe >>> 0 < Gr >>> 0 | we >>> 0 > fr >>> 0, we = v + Gr | 0, v = (we >>> 0 < Gr >>> 0) + Be | 0, Gr = we, we = we + ni | 0, v = Gr >>> 0 > we >>> 0 ? v + 1 | 0 : v, Gr = we, we = Me, Si = v, $r = ((Be | 0) == ($r | 0) & ni >>> 0 < $i >>> 0 | Be >>> 0 < $r >>> 0) + ((Be | 0) == (v | 0) & Gr >>> 0 < ni >>> 0 | v >>> 0 < Be >>> 0) | 0, Be = (fr | 0) == -1, Me = Be & Qe >>> 0 < 4294967294 | (fr | 0) != -1 | (Gr & v) != -1, v = (Dr | 0) == -1162945306, ni = (Me | (v & Rr >>> 0 < 2940772411 | Dr >>> 0 < 3132021990)) ^ -1, mi = $r + (ni & ((wr | 0) == -1076732276 & Fr >>> 0 > 3493216576 | wr >>> 0 > 3218235020) | (ni & (v & Rr >>> 0 > 2940772411 | Dr >>> 0 > 3132021990) | (Qe | 0) == -1 & Be & (Me ^ -1))) | 0, Me = oi(mi, 0, 801750719, 1076732275), Be = Me + Fr | 0, v = wr + Fe | 0, $r = Be, a[we + 136 >> 2] = Be, Me = Be >>> 0 < Me >>> 0 ? v + 1 | 0 : v, a[we + 140 >> 2] = Me, Be = we, we = oi(mi, 0, 1354194884, 1162945305), ni = we + Rr | 0, v = Dr + Fe | 0, Me = (Me | 0) == (wr | 0) & Fr >>> 0 > $r >>> 0 | Me >>> 0 < wr >>> 0, wr = ni + Me | 0, v = we >>> 0 > ni >>> 0 ? v + 1 | 0 : v, we = v, $r = wr, a[Be + 144 >> 2] = wr, Me = Me >>> 0 > wr >>> 0 ? v + 1 | 0 : v, a[Be + 148 >> 2] = Me, wr = Be, v = fr, Fr = Qe + mi | 0, Be = Fr >>> 0 < mi >>> 0 ? v + 1 | 0 : v, v = (we | 0) == (Dr | 0) & Rr >>> 0 > ni >>> 0 | we >>> 0 < Dr >>> 0, Dr = (we | 0) == (Me | 0) & ni >>> 0 > $r >>> 0 | we >>> 0 > Me >>> 0, we = v + Dr | 0, v = (we >>> 0 < Dr >>> 0) + Be | 0, $r = we, we = we + Fr | 0, v = $r >>> 0 > we >>> 0 ? v + 1 | 0 : v, a[wr + 152 >> 2] = we, a[wr + 156 >> 2] = v, fr = (Be | 0) == (fr | 0) & Qe >>> 0 > Fr >>> 0 | Be >>> 0 < fr >>> 0, Be = (v | 0) == (Be | 0) & we >>> 0 < Fr >>> 0 | v >>> 0 < Be >>> 0, we = fr + Be | 0, v = Si + (we >>> 0 < Be >>> 0) | 0, we = we + Gr | 0, v = we >>> 0 < Gr >>> 0 ? v + 1 | 0 : v, a[wr + 160 >> 2] = we, a[wr + 164 >> 2] = v, we = a[wr + 88 >> 2], Be = a[wr + 92 >> 2], a[wr + 456 >> 2] = Be >>> 24, a[wr + 460 >> 2] = 0, Be = Be << 6 | we >>> 26, fr = a[wr + 80 >> 2], Dr = a[wr + 84 >> 2], a[wr + 448 >> 2] = we << 6 | Dr >>> 26, a[wr + 452 >> 2] = Be & 1073741823, we = fr, Be = Dr << 4 | we >>> 28, fr = a[wr + 72 >> 2], Dr = a[wr + 76 >> 2], a[wr + 440 >> 2] = we << 4 | Dr >>> 28, a[wr + 444 >> 2] = Be & 1073741823, we = fr, Be = Dr << 2 | we >>> 30, fr = a[dr + 64 >> 2], wr = a[dr + 68 >> 2], a[dr + 432 >> 2] = we << 2 | wr >>> 30, a[dr + 436 >> 2] = Be & 1073741823, a[dr + 424 >> 2] = fr, a[dr + 428 >> 2] = wr & 1073741823, Zo(dr + 424 | 0, 690320), Be = a[dr + 456 >> 2] << 24, wr = a[dr + 452 >> 2], v = wr >>> 6 | 0, fr = a[dr + 448 >> 2], a[m + 24 >> 2] = (wr & 63) << 26 | fr >>> 6, a[m + 28 >> 2] = v | Be, Be = fr << 26, wr = a[dr + 444 >> 2], v = wr >>> 4 | 0, fr = a[dr + 440 >> 2], a[m + 16 >> 2] = (wr & 15) << 28 | fr >>> 4, a[m + 20 >> 2] = v | Be, Be = fr << 28, wr = a[dr + 436 >> 2], v = wr >>> 2 | 0, fr = a[dr + 432 >> 2], a[m + 8 >> 2] = (wr & 3) << 30 | fr >>> 2, a[m + 12 >> 2] = v | Be, Be = a[dr + 428 >> 2], v = fr << 30, a[m >> 2] = a[dr + 424 >> 2], a[m + 4 >> 2] = v | Be, di(m, m, Oi), v = a[m + 28 >> 2], ni = v, v = v >>> 31 | 0, we = v ^ -1, Me = a[m + 12 >> 2], fr = (Me | 0) == 1566010995, Rr = a[m + 8 >> 2], $r = a[m + 16 >> 2], mi = a[m + 20 >> 2], Si = a[m + 24 >> 2], we = (we & (fr & Rr >>> 0 < 1470386205 | Me >>> 0 < 1566010995) | (($r & mi) != -1 & we | ((ni | 0) == 2147483647 & (Si | 0) != -1 | ni >>> 0 < 2147483647))) ^ -1, Be = a[m + 4 >> 2], Dr = a[m >> 2], Gr = we & ((Be | 0) == -538366138 & Dr >>> 0 > 1746608288 | Be >>> 0 > 3756601158) | (we & (fr & Rr >>> 0 > 1470386205 | Me >>> 0 > 1566010995) | v), Fr = Gr ? -801750718 : 0, wr = Gr ? -1 : 0, fr = wr ^ Dr, we = Fr + fr | 0, Oi = Gr ? -1076732276 : 0, v = Oi + (Be ^ wr) | 0, Dr = $r | Si | Rr | Dr | (ni | mi | Me | Be) ? -1 : 0, zi = we & Dr, a[m >> 2] = zi, fr = we >>> 0 < fr >>> 0 ? v + 1 | 0 : v, Ti = Dr & fr, a[m + 4 >> 2] = Ti, Be = m, $i = Gr ? -1162945306 : 0, v = $i + (Me ^ wr) | 0, Qe = (fr | 0) == (Oi | 0) & we >>> 0 < Fr >>> 0 | fr >>> 0 < Oi >>> 0, Sn = Gr ? -1354194885 : 0, we = wr ^ Rr, Rr = Sn + we | 0, fr = Qe + Rr | 0, v = we >>> 0 > Rr >>> 0 ? v + 1 | 0 : v, we = v, Fr = fr, Oi = fr & Dr, a[Be + 8 >> 2] = Oi, Qe = fr >>> 0 < Qe >>> 0 ? v + 1 | 0 : v, In = Dr & Qe, a[Be + 12 >> 2] = In, fr = Be, un = Gr ? -2 : 0, Be = wr ^ $r, Me = un + Be | 0, $r = Gr ? -1 : 0, v = $r + (wr ^ mi) | 0, Be = Be >>> 0 > Me >>> 0 ? v + 1 | 0 : v, v = (we | 0) == ($i | 0) & Rr >>> 0 < Sn >>> 0 | we >>> 0 < $i >>> 0, Rr = (we | 0) == (Qe | 0) & Rr >>> 0 > Fr >>> 0 | we >>> 0 > Qe >>> 0, we = v + Rr | 0, v = (we >>> 0 < Rr >>> 0) + Be | 0, Fr = we, we = we + Me | 0, v = Fr >>> 0 > we >>> 0 ? v + 1 | 0 : v, Rr = we & Dr, a[fr + 16 >> 2] = Rr, Qe = v & Dr, a[fr + 20 >> 2] = Qe, fr = (Be | 0) == ($r | 0) & Me >>> 0 < un >>> 0 | Be >>> 0 < $r >>> 0, Be = (v | 0) == (Be | 0) & we >>> 0 < Me >>> 0 | v >>> 0 < Be >>> 0, we = fr + Be | 0, v = we >>> 0 < Be >>> 0, Be = wr ^ Si, fr = Be - Gr | 0, we = fr + we | 0, v = v + ((wr ^ ni) - (Be >>> 0 < Gr >>> 0) | 0) | 0, v = we >>> 0 < fr >>> 0 ? v + 1 | 0 : v, we = we & Dr, a[m + 24 >> 2] = we, v = v & Dr, a[m + 28 >> 2] = v, d && (a[d >> 2] = a[d >> 2] ^ Gr), !(Oi | zi | Rr | we | (In | Ti | Qe | v))) || !(a[o + 24 >> 2] | (a[o + 16 >> 2] | (a[o + 8 >> 2] | a[o >> 2])) | (a[o + 28 >> 2] | (a[o + 20 >> 2] | (a[o + 12 >> 2] | a[o + 4 >> 2])))))
            break t;
          fr = 1;
          break e;
        }
        if (v = Vn + 1 | 0, fr = 0, !(ji[Kn | 0](dr, 655649, 690788, 0, he, Vn) | 0))
          break;
      }
    }
    return we = fr & uo, he = !we, B = he - 1 | 0, v = 0 - !he | 0, Be = v & a[o + 4 >> 2], a[o >> 2] = B & a[o >> 2], a[o + 4 >> 2] = Be, Be = a[o + 12 >> 2] & v, a[o + 8 >> 2] = a[o + 8 >> 2] & B, a[o + 12 >> 2] = Be, Be = a[o + 20 >> 2] & v, a[o + 16 >> 2] = a[o + 16 >> 2] & B, a[o + 20 >> 2] = Be, Be = a[o + 28 >> 2] & v, a[o + 24 >> 2] = a[o + 24 >> 2] & B, a[o + 28 >> 2] = Be, o = a[m + 4 >> 2] & v, a[m >> 2] = a[m >> 2] & B, a[m + 4 >> 2] = o, o = a[m + 12 >> 2] & v, a[m + 8 >> 2] = a[m + 8 >> 2] & B, a[m + 12 >> 2] = o, o = a[m + 20 >> 2] & v, a[m + 16 >> 2] = a[m + 16 >> 2] & B, a[m + 20 >> 2] = o, o = a[m + 28 >> 2] & v, a[m + 24 >> 2] = a[m + 24 >> 2] & B, a[m + 28 >> 2] = o, d && (a[dr + 256 >> 2] = he, a[d >> 2] = a[d >> 2] & a[dr + 256 >> 2] - 1), be = dr + 464 | 0, we;
  }
  function xs(B, o, m) {
    var d = 0, v = 0, he = 0, we = 0, Be = 0, Me = 0, fr = 0, wr = 0, dr = 0, Dr = 0, Rr = 0, Qe = 0, Fr = 0, Gr = 0, $r = 0, ni = 0, mi = 0, Si = 0, Oi = 0, $i = 0, zi = 0, un = 0, In = 0, Ti = 0, Sn = 0, Kn = 0, Vn = 0, Xn = 0;
    for (he = be - 128 | 0, be = he, Ti = dn(o, B + 40 | 0, 128), we = a[B + 8 >> 2], fr = a[m >> 2], Si = we + fr | 0, o = a[B + 12 >> 2], d = o + a[m + 4 >> 2] | 0, Be = fr >>> 0 > Si >>> 0 ? d + 1 | 0 : d, Me = (o | 0) == (Be | 0) & we >>> 0 > Si >>> 0 | o >>> 0 > Be >>> 0, we = a[m + 8 >> 2], d = Me + we | 0, o = a[m + 12 >> 2], o = d >>> 0 < we >>> 0 ? o + 1 | 0 : o, we = d, d = B + 16 | 0, fr = a[d >> 2], mi = we + fr | 0, d = o + a[d + 4 >> 2] | 0, Me = !o & we >>> 0 < Me >>> 0, fr = fr >>> 0 > mi >>> 0 ? d + 1 | 0 : d, we = (o | 0) == (fr | 0) & we >>> 0 > mi >>> 0 | o >>> 0 > fr >>> 0, d = Me + we | 0, o = d >>> 0 < we >>> 0, Rr = d, d = a[m + 16 >> 2], Me = Rr + d | 0, we = o, o = o + a[m + 20 >> 2] | 0, d = d >>> 0 > Me >>> 0 ? o + 1 | 0 : o, o = B + 24 | 0, $r = a[o >> 2], dr = $r + Me | 0, o = d + a[o + 4 >> 2] | 0, Rr = (d | 0) == (we | 0) & Me >>> 0 < Rr >>> 0 | d >>> 0 < we >>> 0, we = dr >>> 0 < $r >>> 0 ? o + 1 | 0 : o, o = Me, Me = dr, dr = (d | 0) == (we | 0) & o >>> 0 > Me >>> 0 | d >>> 0 > we >>> 0, d = Rr + dr | 0, o = d >>> 0 < dr >>> 0, $r = d, Rr = a[m + 24 >> 2], dr = d + Rr | 0, d = o, o = o + a[m + 28 >> 2] | 0, o = dr >>> 0 < Rr >>> 0 ? o + 1 | 0 : o, B = B + 32 | 0, Rr = a[B >> 2], m = Rr + dr | 0, B = o + a[B + 4 >> 2] | 0, Oi = m >>> 0 < Rr >>> 0 ? B + 1 | 0 : B, Rr = m, $r = ((o | 0) == (d | 0) & dr >>> 0 < $r >>> 0 | o >>> 0 < d >>> 0) + ((o | 0) == (Oi | 0) & m >>> 0 < dr >>> 0 | o >>> 0 > Oi >>> 0) | 0, o = (we | 0) == -1, m = o & Me >>> 0 < 4294967294 | (we | 0) != -1 | (m & Oi) != -1, B = (fr | 0) == -1162945306, d = (m | (B & mi >>> 0 < 2940772411 | fr >>> 0 < 3132021990)) ^ -1, dr = $r + (d & ((Be | 0) == -1076732276 & Si >>> 0 > 3493216576 | Be >>> 0 > 3218235020) | (d & (B & mi >>> 0 > 2940772411 | fr >>> 0 > 3132021990) | (Me | 0) == -1 & o & (m ^ -1))) | 0, B = oi(dr, 0, 801750719, 1076732275), m = B + Si | 0, o = Be + Fe | 0, a[he + 8 >> 2] = m, o = B >>> 0 > m >>> 0 ? o + 1 | 0 : o, a[he + 12 >> 2] = o, B = he, Be = (o | 0) == (Be | 0) & m >>> 0 < Si >>> 0 | o >>> 0 < Be >>> 0, d = oi(dr, 0, 1354194884, 1162945305), m = d + mi | 0, o = fr + Fe | 0, o = m >>> 0 < d >>> 0 ? o + 1 | 0 : o, Be = m + Be | 0, d = Be >>> 0 < m >>> 0 ? o + 1 | 0 : o, a[B + 16 >> 2] = Be, a[B + 20 >> 2] = d, d = (o | 0) == (d | 0) & m >>> 0 > Be >>> 0 | o >>> 0 > d >>> 0, m = d + ((o | 0) == (fr | 0) & m >>> 0 < mi >>> 0 | o >>> 0 < fr >>> 0) | 0, o = m >>> 0 < d >>> 0, d = m, fr = o, o = we, Be = Me + dr | 0, m = Be >>> 0 < Me >>> 0 ? o + 1 | 0 : o, o = m + fr | 0, $r = d, d = Be, Be = $r + d | 0, a[B + 24 >> 2] = Be, o = d >>> 0 > Be >>> 0 ? o + 1 | 0 : o, a[B + 28 >> 2] = o, B = (m | 0) == (we | 0) & d >>> 0 < Me >>> 0 | m >>> 0 < we >>> 0, m = (o | 0) == (m | 0) & d >>> 0 > Be >>> 0 | o >>> 0 < m >>> 0, o = B + m | 0, d = Oi + (o >>> 0 < m >>> 0) | 0, B = o + Rr | 0, d = B >>> 0 < Rr >>> 0 ? d + 1 | 0 : d, a[he + 32 >> 2] = B, a[he + 36 >> 2] = d, m = 0, mi = 0, we = 0, Si = 0, dr = 0, Rr = 0, fr = 0, Be = 0, $r = 0, Me = 0, Oi = 0; a[he + 120 >> 2] = 0, o = (he + 8 | 0) + (Sn >>> 2 & 1073741816) | 0, B = a[o >> 2], d = a[o + 4 >> 2], v = Kn & 62, o = v & 31, v >>> 0 >= 32 ? B = d >>> o | 0 : B = ((1 << o) - 1 & d) << 32 - o | B >>> o, Dr = B & 3, Qe = (Dr | 0) == 1, v = $i + 656432 | 0, B = v + 248 | 0, o = v + 184 | 0, d = v + 120 | 0, wr = v + 56 | 0, Fr = (Dr | 0) == 2, Gr = (Dr | 0) == 3, m = Gr ? a[B >> 2] : Fr ? a[o >> 2] : Qe ? a[d >> 2] : Dr ? m : a[wr >> 2], o = Gr ? a[B + 4 >> 2] : Fr ? a[o + 4 >> 2] : Qe ? a[d + 4 >> 2] : Dr ? mi : a[wr + 4 >> 2], mi = o, B = o >>> 16 | 0, a[he + 112 >> 2] = (o & 65535) << 16 | m >>> 16, a[he + 116 >> 2] = B, B = v + 224 | 0, o = v + 160 | 0, d = v + 96 | 0, wr = v + 32 | 0, Vn = Gr ? a[B >> 2] : Fr ? a[o >> 2] : Qe ? a[d >> 2] : Dr ? Vn : a[wr >> 2], fr = Gr ? a[B + 4 >> 2] : Fr ? a[o + 4 >> 2] : Qe ? a[d + 4 >> 2] : Dr ? fr : a[wr + 4 >> 2], a[he + 80 >> 2] = Vn, a[he + 84 >> 2] = fr & 1048575, B = v + 216 | 0, o = v + 152 | 0, d = v + 88 | 0, wr = v + 24 | 0, Be = Gr ? a[B >> 2] : Fr ? a[o >> 2] : Qe ? a[d >> 2] : Dr ? Be : a[wr >> 2], B = Gr ? a[B + 4 >> 2] : Fr ? a[o + 4 >> 2] : Qe ? a[d + 4 >> 2] : Dr ? $r : a[wr + 4 >> 2], $r = B, d = B >>> 16 | 0, a[he + 72 >> 2] = (B & 65535) << 16 | Be >>> 16, a[he + 76 >> 2] = d, B = v + 192 | 0, o = v + 128 | 0, d = v - -64 | 0, Xn = Gr ? a[B >> 2] : Fr ? a[o >> 2] : Qe ? a[d >> 2] : Dr ? Xn : a[v >> 2], zi = Gr ? a[B + 4 >> 2] : Fr ? a[o + 4 >> 2] : Qe ? a[d + 4 >> 2] : Dr ? zi : a[v + 4 >> 2], a[he + 40 >> 2] = Xn, a[he + 44 >> 2] = zi & 1048575, d = m << 4 & 1048560, B = v + 240 | 0, o = v + 176 | 0, wr = v + 112 | 0, ni = v + 48 | 0, we = Gr ? a[B >> 2] : Fr ? a[o >> 2] : Qe ? a[wr >> 2] : Dr ? we : a[ni >> 2], o = Gr ? a[B + 4 >> 2] : Fr ? a[o + 4 >> 2] : Qe ? a[wr + 4 >> 2] : Dr ? Si : a[ni + 4 >> 2], Si = o, B = o >>> 28 | 0, a[he + 104 >> 2] = (o & 268435455) << 4 | we >>> 28, a[he + 108 >> 2] = B | d, d = v + 232 | 0, wr = v + 168 | 0, ni = v + 104 | 0, B = v + 40 | 0, dr = Gr ? a[d >> 2] : Fr ? a[wr >> 2] : Qe ? a[ni >> 2] : Dr ? dr : a[B >> 2], Rr = Gr ? a[d + 4 >> 2] : Fr ? a[wr + 4 >> 2] : Qe ? a[ni + 4 >> 2] : Dr ? Rr : a[B + 4 >> 2], a[he + 96 >> 2] = we << 24 & -16777216 | Rr >>> 8, a[he + 100 >> 2] = (o << 24 | we >>> 8) & 1048575, a[he + 88 >> 2] = dr << 12 & -4096 | fr >>> 20, a[he + 92 >> 2] = (Rr << 12 | dr >>> 20) & 1048575, B = v + 208 | 0, o = v + 144 | 0, wr = v + 80 | 0, ni = v + 16 | 0, Me = Gr ? a[B >> 2] : Fr ? a[o >> 2] : Qe ? a[wr >> 2] : Dr ? Me : a[ni >> 2], B = Gr ? a[B + 4 >> 2] : Fr ? a[o + 4 >> 2] : Qe ? a[wr + 4 >> 2] : Dr ? Oi : a[ni + 4 >> 2], Oi = B, o = B >>> 28 | 0, a[he + 64 >> 2] = (B & 268435455) << 4 | Me >>> 28, a[he + 68 >> 2] = o | Be << 4 & 1048560, o = Me << 24 & -16777216, B = v + 200 | 0, wr = v + 136 | 0, ni = v + 72 | 0, v = v + 8 | 0, un = Gr ? a[B >> 2] : Fr ? a[wr >> 2] : Qe ? a[ni >> 2] : Dr ? un : a[v >> 2], In = Gr ? a[B + 4 >> 2] : Fr ? a[wr + 4 >> 2] : Qe ? a[ni + 4 >> 2] : Dr ? In : a[v + 4 >> 2], a[he + 56 >> 2] = In >>> 8 | o, a[he + 60 >> 2] = (Oi << 24 | Me >>> 8) & 1048575, a[he + 48 >> 2] = un << 12 & -4096 | zi >>> 20, a[he + 52 >> 2] = (In << 12 | un >>> 20) & 1048575, ls(Ti, Ti, he + 40 | 0), Kn = Kn + 2 | 0, Sn = Sn + 1 | 0, $i = $i + 256 | 0, ($i | 0) != 32768; )
      ;
    be = he + 128 | 0;
  }
  function Fo(B, o) {
    var m = 0, d = 0, v = 0, he = 0, we = 0, Be = 0, Me = 0, fr = 0, wr = 0, dr = 0, Dr = 0, Rr = 0, Qe = 0, Fr = 0, Gr = 0, $r = 0, ni = 0, mi = 0, Si = 0, Oi = 0, $i = 0;
    we = be - 80 | 0, be = we, a[B + 80 >> 2] = a[o + 120 >> 2], Rr = o + 104 | 0, dr = a[Rr >> 2], Dr = a[Rr + 4 >> 2], Qe = o + 96 | 0, Be = a[Qe >> 2], wr = a[Qe + 4 >> 2], Fr = o + 88 | 0, he = a[Fr >> 2], Me = a[Fr + 4 >> 2], fr = a[o + 84 >> 2], Gr = o + 112 | 0, $r = a[Gr >> 2], v = a[Gr + 4 >> 2], Oi = v, m = a[o + 80 >> 2], d = oi(v >>> 16 | 0, 0, 977, 1), v = m + d | 0, m = fr + Fe | 0, fr = d >>> 0 > v >>> 0 ? m + 1 | 0 : m, m = Me, d = fr >>> 20 | 0, Me = d, d = d + he | 0, Me = Me >>> 0 > d >>> 0 ? m + 1 | 0 : m, m = wr, he = Me >>> 20 | 0, wr = he, he = he + Be | 0, wr = wr >>> 0 > he >>> 0 ? m + 1 | 0 : m, m = Dr, Be = wr >>> 20 | 0, Dr = Be, Be = Be + dr | 0, dr = Dr >>> 0 > Be >>> 0 ? m + 1 | 0 : m, $i = Me & 1048575, m = fr & 1048575, mi = v, ni = m, Dr = d, fr = he, Si = wr & 1048575, he = (d & he & Be) == -1 & (Si & Me & dr) == 1048575, m = Oi & 65535, d = dr >>> 20 | 0, v = d, d = d + $r | 0, m = v >>> 0 > d >>> 0 ? m + 1 | 0 : m, Me = d, v = m, he = oi(he & ((d | 0) == -1 & (m | 0) == 65535) & ((ni | 0) == 1048574 & mi >>> 0 > 4294966318 | ni >>> 0 > 1048574) | m >>> 16, 0, 977, 1), d = he + mi | 0, m = ni + Fe | 0, m = d >>> 0 < he >>> 0 ? m + 1 | 0 : m, he = d, $r = m, m = $i, d = $r >>> 20 | 0, wr = d + Dr | 0, d = d >>> 0 > wr >>> 0 ? m + 1 | 0 : m, a[we + 40 >> 2] = he, a[we + 44 >> 2] = wr << 20 & 1072693248 | $r & 1048575, m = Si, Dr = fr, he = d, fr = (d >>> 20 | 0) + fr | 0, d = Dr >>> 0 > fr >>> 0 ? m + 1 | 0 : m, $r = fr << 10 & 1073740800, m = he >>> 10 | 0, a[we + 48 >> 2] = (he & 1023) << 22 | wr >>> 10, a[we + 52 >> 2] = $r | m & 1023, m = dr & 1048575, he = d, d = d >>> 20 | 0, Be = d + Be | 0, d = d >>> 0 > Be >>> 0 ? m + 1 | 0 : m, a[we + 56 >> 2] = (he & 1048575) << 12 | fr >>> 20, a[we + 60 >> 2] = Be & 1073741823, m = v, v = (d >>> 20 | 0) + Me | 0, m = v >>> 0 < Me >>> 0 ? m + 1 | 0 : m, a[we + 72 >> 2] = m >>> 8 & 255, a[we + 76 >> 2] = 0, m = m << 22 | v >>> 10, a[we + 64 >> 2] = ((d & 1073741823) << 2 | Be >>> 30) & 4194303 | v << 22 & -4194304, a[we + 68 >> 2] = m & 1073741823, Me = we + 40 | 0, Zo(Me, 690464), d = a[we + 44 >> 2], v = d, a[o + 80 >> 2] = a[we + 40 >> 2], a[o + 84 >> 2] = d & 1048575, he = a[we + 72 >> 2] << 8, dr = a[we + 68 >> 2], m = dr >>> 22 | 0, Be = a[we + 64 >> 2], a[Gr >> 2] = (dr & 4194303) << 10 | Be >>> 22, a[Gr + 4 >> 2] = m | he, d = Be, m = dr << 30 | d >>> 2, Be = d << 30 & -1073741824, d = a[we + 56 >> 2], he = a[we + 60 >> 2], a[Rr >> 2] = he | Be, a[Rr + 4 >> 2] = m & 1048575, m = he << 20 | d >>> 12, Be = d << 20 & -1048576, d = a[we + 48 >> 2], he = a[we + 52 >> 2], a[Qe >> 2] = he >>> 10 | Be, a[Qe + 4 >> 2] = m & 1048575, he = (he << 10 | d >>> 22) & 1048575, a[Fr >> 2] = d << 10 & -1024 | v >>> 20, a[Fr + 4 >> 2] = he, m = o + 80 | 0, na(Me, m), gn(we, m, Me), gn(o, o, Me), m = o + 40 | 0, gn(m, m, we), a[Gr >> 2] = 0, a[Gr + 4 >> 2] = 0, a[Rr >> 2] = 0, a[Rr + 4 >> 2] = 0, a[Qe >> 2] = 0, a[Qe + 4 >> 2] = 0, a[Fr >> 2] = 0, a[Fr + 4 >> 2] = 0, a[o + 80 >> 2] = 1, a[o + 84 >> 2] = 0, m = a[o + 4 >> 2], a[B >> 2] = a[o >> 2], a[B + 4 >> 2] = m, m = o + 8 | 0, d = a[m + 4 >> 2], v = B + 8 | 0, a[v >> 2] = a[m >> 2], a[v + 4 >> 2] = d, m = o + 16 | 0, d = a[m + 4 >> 2], v = B + 16 | 0, a[v >> 2] = a[m >> 2], a[v + 4 >> 2] = d, m = o + 24 | 0, d = a[m + 4 >> 2], v = B + 24 | 0, a[v >> 2] = a[m >> 2], a[v + 4 >> 2] = d, m = o + 32 | 0, d = a[m + 4 >> 2], v = B + 32 | 0, a[v >> 2] = a[m >> 2], a[v + 4 >> 2] = d, m = a[o + 44 >> 2], a[B + 40 >> 2] = a[o + 40 >> 2], a[B + 44 >> 2] = m, m = o + 48 | 0, d = a[m + 4 >> 2], v = B + 48 | 0, a[v >> 2] = a[m >> 2], a[v + 4 >> 2] = d, m = o + 56 | 0, d = a[m + 4 >> 2], v = B + 56 | 0, a[v >> 2] = a[m >> 2], a[v + 4 >> 2] = d, m = o - -64 | 0, d = a[m + 4 >> 2], v = B - -64 | 0, a[v >> 2] = a[m >> 2], a[v + 4 >> 2] = d, o = o + 72 | 0, m = a[o + 4 >> 2], B = B + 72 | 0, a[B >> 2] = a[o >> 2], a[B + 4 >> 2] = m, be = we + 80 | 0;
  }
  function Zo(B, o) {
    var m = 0, d = 0, v = 0, he = 0, we = 0, Be = 0, Me = 0, fr = 0, wr = 0, dr = 0, Dr = 0, Rr = 0, Qe = 0, Fr = 0, Gr = 0, $r = 0, ni = 0, mi = 0, Si = 0, Oi = 0, $i = 0, zi = 0, un = 0, In = 0, Ti = 0, Sn = 0, Kn = 0, Vn = 0, Xn = 0, uo = 0, yo = 0, Io = 0, xo = 0, Mo = 0, qi = 0, Oo = 0, Ho = 0, Go = 0, ns = 0, ds = 0, Ts = 0, Ao = 0, po = 0, _o = 0;
    for (Be = be - 432 | 0, be = Be, d = Be + 392 | 0, m = d + 32 | 0, a[m >> 2] = 0, a[m + 4 >> 2] = 0, m = d + 24 | 0, a[m >> 2] = 0, a[m + 4 >> 2] = 0, m = d + 16 | 0, a[m >> 2] = 0, a[m + 4 >> 2] = 0, d = d + 8 | 0, a[d >> 2] = 0, a[d + 4 >> 2] = 0, a[Be + 392 >> 2] = 0, a[Be + 396 >> 2] = 0, d = Be + 352 | 0, m = d + 32 | 0, a[m >> 2] = 0, a[m + 4 >> 2] = 0, m = d + 24 | 0, a[m >> 2] = 0, a[m + 4 >> 2] = 0, d = d + 16 | 0, a[d >> 2] = 0, a[d + 4 >> 2] = 0, a[Be + 360 >> 2] = 0, a[Be + 364 >> 2] = 0, a[Be + 352 >> 2] = 1, a[Be + 356 >> 2] = 0, xo = B, ds = a[B + 32 >> 2], Ao = a[B + 36 >> 2], Si = a[B + 24 >> 2], Go = a[B + 28 >> 2], Ti = a[B + 16 >> 2], Vn = a[B + 20 >> 2], $i = a[B + 8 >> 2], Mo = a[B + 12 >> 2], d = a[B >> 2], fr = a[B + 4 >> 2], Ts = a[o + 32 >> 2], zi = a[o + 36 >> 2], Xn = a[o + 24 >> 2], uo = a[o + 28 >> 2], Sn = a[o + 16 >> 2], yo = a[o + 20 >> 2], un = a[o + 8 >> 2], Io = a[o + 12 >> 2], m = a[o >> 2], dr = a[o + 4 >> 2], po = -1, Oi = -1; ; ) {
      for (he = 8, v = 0, qi = 59, we = 0, Qe = 0, Me = d, B = fr, Dr = m, mi = dr, wr = 0, Fr = 0, Gr = 8, Rr = 0; ni = B, B = Me & 1, Kn = 0 - B | 0, Oo = 0 - B | 0, In = Oo, Ho = Oi, B = Oi >> 31, $r = B, B = B ^ Dr, Oi = B - $r & Kn, Me = Oi + Me | 0, B = ni + (In & ($r ^ mi) - ((B >>> 0 < $r >>> 0) + $r | 0)) | 0, ns = Me, Me = Me >>> 0 < Oi >>> 0 ? B + 1 | 0 : B, ni = $r & In, B = (Me & ni) + mi | 0, mi = Dr, Oi = $r & Kn, Dr = (Oi & ns) + Dr | 0, mi = mi >>> 0 > Dr >>> 0 ? B + 1 | 0 : B, B = we ^ $r, In = B - $r & Kn, Gr = In + Gr | 0, B = Rr + ((Qe ^ $r) - ((B >>> 0 < $r >>> 0) + $r | 0) & Oo) | 0, Rr = Gr >>> 0 < In >>> 0 ? B + 1 | 0 : B, B = (Rr & ni) + Qe | 0, Qe = we, we = (Gr & Oi) + we | 0, B = (Qe >>> 0 > we >>> 0 ? B + 1 | 0 : B) << 1 | we >>> 31, we = we << 1, Qe = B, In = Oi, B = he ^ $r, Oi = (B - $r & Kn) + wr | 0, B = ((v ^ $r) - ((B >>> 0 < $r >>> 0) + $r | 0) & Oo) + Fr | 0, Fr = wr >>> 0 > Oi >>> 0 ? B + 1 | 0 : B, B = (Fr & ni) + v | 0, v = he, wr = Oi, he = (In & wr) + he | 0, B = (v >>> 0 > he >>> 0 ? B + 1 | 0 : B) << 1 | he >>> 31, he = he << 1, v = B, B = In ^ po, po = B - 1 | 0, Oi = (ni ^ Ho) - !B | 0, B = Me >>> 1 | 0, Me = (Me & 1) << 31 | ns >>> 1, qi = qi - 1 | 0, !!qi; )
        ;
      if (a[Be + 344 >> 2] = Gr, a[Be + 348 >> 2] = Rr, a[Be + 336 >> 2] = wr, a[Be + 340 >> 2] = Fr, a[Be + 328 >> 2] = we, a[Be + 332 >> 2] = Qe, a[Be + 320 >> 2] = he, a[Be + 324 >> 2] = v, vi(Be + 392 | 0, Be + 352 | 0, Be + 320 | 0, o), B = dr >> 31, ns = Be + 304 | 0, Me = v >> 31, Dr = m, mi = B, Lr(ns, he, v, Me, Me, m, dr, B, B), B = fr >> 31, In = Be + 272 | 0, m = Qe >> 31, ni = d, $r = B, Lr(In, we, Qe, m, m, d, fr, B, B), B = Fr >> 31, Kn = Be + 288 | 0, Ho = wr, d = B, Lr(Kn, wr, Fr, B, B, Dr, dr, mi, mi), B = Rr >> 31, dr = Be + 256 | 0, wr = B, Lr(dr, Gr, Rr, B, B, ni, fr, $r, $r), B = Io >> 31, Dr = Be + 240 | 0, fr = B, Lr(Dr, he, v, Me, Me, un, Io, B, B), mi = Be + 208 | 0, ni = Mo, B = ni >> 31, Lr(mi, we, Qe, m, m, $i, ni, B, B), ni = Be + 224 | 0, Lr(ni, Ho, Fr, d, d, un, Io, fr, fr), $r = Be + 192 | 0, Lr($r, Gr, Rr, wr, wr, $i, Mo, B, B), B = yo >> 31, $i = Be + 176 | 0, fr = B, Lr($i, he, v, Me, Me, Sn, yo, B, B), Mo = Be + 144 | 0, B = Vn >> 31, Lr(Mo, we, Qe, m, m, Ti, Vn, B, B), Io = Be + 160 | 0, Lr(Io, Ho, Fr, d, d, Sn, yo, fr, fr), yo = Be + 128 | 0, Lr(yo, Gr, Rr, wr, wr, Ti, Vn, B, B), B = uo >> 31, Ti = Be + 112 | 0, fr = B, Lr(Ti, he, v, Me, Me, Xn, uo, B, B), Vn = Be + 80 | 0, un = Go, B = un >> 31, Lr(Vn, we, Qe, m, m, Si, un, B, B), Oo = Be + 96 | 0, Lr(Oo, Ho, Fr, d, d, Xn, uo, fr, fr), uo = Be - -64 | 0, Lr(uo, Gr, Rr, wr, wr, Si, un, B, B), B = zi >> 31, Si = Be + 48 | 0, fr = Me, Me = B, Lr(Si, he, v, fr, fr, Ts, zi, B, B), Go = Be + 16 | 0, v = Ao, B = v >> 31, Lr(Go, we, Qe, m, m, ds, v, B, B), qi = Be + 32 | 0, Lr(qi, Ho, Fr, d, d, Ts, zi, Me, Me), Lr(Be, Gr, Rr, wr, wr, ds, v, B, B), he = a[Be + 272 >> 2], m = a[Be + 304 >> 2], d = he + m | 0, Me = a[Be + 276 >> 2], B = Me + a[Be + 308 >> 2] | 0, B = m >>> 0 > d >>> 0 ? B + 1 | 0 : B, m = d, d = B, Me = (Me | 0) == (B | 0) & m >>> 0 < he >>> 0 | B >>> 0 < Me >>> 0, B = ns + 8 | 0, he = a[B >> 2], v = In + 8 | 0, m = he + a[v >> 2] | 0, B = a[v + 4 >> 2] + a[B + 4 >> 2] | 0, B = m >>> 0 < he >>> 0 ? B + 1 | 0 : B, Me = m + Me | 0, m = Me >>> 0 < m >>> 0 ? B + 1 | 0 : B, he = m << 2 | Me >>> 30, v = Me << 2 | d >>> 30, wr = a[Be + 208 >> 2], Me = a[Be + 240 >> 2], d = wr + Me | 0, we = a[Be + 212 >> 2], B = we + a[Be + 244 >> 2] | 0, Me = d >>> 0 < Me >>> 0 ? B + 1 | 0 : B, B = Me + he | 0, he = d, v = d + v | 0, d = d >>> 0 > v >>> 0 ? B + 1 | 0 : B, B = Me, Me = v, Qe = (d | 0) == (B | 0) & v >>> 0 < he >>> 0 | B >>> 0 > d >>> 0, v = (B | 0) == (we | 0) & he >>> 0 < wr >>> 0 | B >>> 0 < we >>> 0, B = Dr + 8 | 0, we = a[B >> 2], wr = mi + 8 | 0, he = we + a[wr >> 2] | 0, B = a[wr + 4 >> 2] + a[B + 4 >> 2] | 0, B = he >>> 0 < we >>> 0 ? B + 1 | 0 : B, we = he, he = v + he | 0, B = (m >> 31) + (we >>> 0 > he >>> 0 ? B + 1 | 0 : B) | 0, m = m >> 30, v = m, m = m + he | 0, B = v >>> 0 > m >>> 0 ? B + 1 | 0 : B, he = m + Qe | 0, m = he >>> 0 < m >>> 0 ? B + 1 | 0 : B, v = m << 2 | he >>> 30, Qe = d, wr = he << 2 | d >>> 30, Rr = a[Be + 144 >> 2], he = a[Be + 176 >> 2], d = Rr + he | 0, we = a[Be + 148 >> 2], B = we + a[Be + 180 >> 2] | 0, he = d >>> 0 < he >>> 0 ? B + 1 | 0 : B, B = he + v | 0, v = d, un = d + wr | 0, d = d >>> 0 > un >>> 0 ? B + 1 | 0 : B, wr = (he | 0) == (d | 0) & v >>> 0 > un >>> 0 | d >>> 0 < he >>> 0, v = (he | 0) == (we | 0) & v >>> 0 < Rr >>> 0 | he >>> 0 < we >>> 0, B = $i + 8 | 0, we = a[B >> 2], Fr = Mo + 8 | 0, he = we + a[Fr >> 2] | 0, B = a[Fr + 4 >> 2] + a[B + 4 >> 2] | 0, B = he >>> 0 < we >>> 0 ? B + 1 | 0 : B, we = he, he = v + he | 0, B = (m >> 31) + (we >>> 0 > he >>> 0 ? B + 1 | 0 : B) | 0, m = m >> 30, v = m, m = m + he | 0, B = v >>> 0 > m >>> 0 ? B + 1 | 0 : B, he = m + wr | 0, m = he >>> 0 < m >>> 0 ? B + 1 | 0 : B, v = m << 2 | he >>> 30, wr = d, Fr = he << 2 | d >>> 30, Gr = a[Be + 80 >> 2], he = a[Be + 112 >> 2], d = Gr + he | 0, we = a[Be + 84 >> 2], B = we + a[Be + 116 >> 2] | 0, he = d >>> 0 < he >>> 0 ? B + 1 | 0 : B, B = he + v | 0, v = d, Sn = d + Fr | 0, d = d >>> 0 > Sn >>> 0 ? B + 1 | 0 : B, Fr = (he | 0) == (d | 0) & v >>> 0 > Sn >>> 0 | d >>> 0 < he >>> 0, v = (he | 0) == (we | 0) & v >>> 0 < Gr >>> 0 | he >>> 0 < we >>> 0, B = Ti + 8 | 0, we = a[B >> 2], Rr = Vn + 8 | 0, he = we + a[Rr >> 2] | 0, B = a[Rr + 4 >> 2] + a[B + 4 >> 2] | 0, B = he >>> 0 < we >>> 0 ? B + 1 | 0 : B, we = he, he = v + he | 0, B = (m >> 31) + (we >>> 0 > he >>> 0 ? B + 1 | 0 : B) | 0, m = m >> 30, v = m, m = m + he | 0, B = v >>> 0 > m >>> 0 ? B + 1 | 0 : B, he = m + Fr | 0, m = he >>> 0 < m >>> 0 ? B + 1 | 0 : B, v = m << 2 | he >>> 30, Fr = d, Rr = he << 2 | d >>> 30, fr = a[Be + 16 >> 2], he = a[Be + 48 >> 2], d = fr + he | 0, we = a[Be + 20 >> 2], B = we + a[Be + 52 >> 2] | 0, he = d >>> 0 < he >>> 0 ? B + 1 | 0 : B, B = he + v | 0, v = d, Xn = d + Rr | 0, d = d >>> 0 > Xn >>> 0 ? B + 1 | 0 : B, Rr = (he | 0) == (d | 0) & v >>> 0 > Xn >>> 0 | d >>> 0 < he >>> 0, v = (he | 0) == (we | 0) & v >>> 0 < fr >>> 0 | he >>> 0 < we >>> 0, B = Si + 8 | 0, we = a[B >> 2], Gr = Go + 8 | 0, he = we + a[Gr >> 2] | 0, B = a[Gr + 4 >> 2] + a[B + 4 >> 2] | 0, B = he >>> 0 < we >>> 0 ? B + 1 | 0 : B, we = he, he = v + he | 0, B = (m >> 31) + (we >>> 0 > he >>> 0 ? B + 1 | 0 : B) | 0, m = m >> 30, v = m, m = m + he | 0, B = v >>> 0 > m >>> 0 ? B + 1 | 0 : B, v = m, m = m + Rr | 0, he = (v >>> 0 > m >>> 0 ? B + 1 | 0 : B) << 2 | m >>> 30, Rr = d, Ts = m << 2 | d >>> 30, zi = he, v = a[Be + 256 >> 2], m = a[Be + 288 >> 2], d = v + m | 0, he = a[Be + 260 >> 2], B = he + a[Be + 292 >> 2] | 0, B = m >>> 0 > d >>> 0 ? B + 1 | 0 : B, m = d, d = B, he = (he | 0) == (B | 0) & m >>> 0 < v >>> 0 | B >>> 0 < he >>> 0, B = Kn + 8 | 0, v = a[B >> 2], we = dr + 8 | 0, m = v + a[we >> 2] | 0, B = a[we + 4 >> 2] + a[B + 4 >> 2] | 0, B = m >>> 0 < v >>> 0 ? B + 1 | 0 : B, he = m + he | 0, m = he >>> 0 < m >>> 0 ? B + 1 | 0 : B, v = m << 2 | he >>> 30, we = he << 2 | d >>> 30, dr = a[Be + 192 >> 2], he = a[Be + 224 >> 2], d = dr + he | 0, Gr = a[Be + 196 >> 2], B = Gr + a[Be + 228 >> 2] | 0, he = d >>> 0 < he >>> 0 ? B + 1 | 0 : B, B = he + v | 0, v = d, we = d + we | 0, d = d >>> 0 > we >>> 0 ? B + 1 | 0 : B, B = he, he = we, fr = (d | 0) == (B | 0) & v >>> 0 > he >>> 0 | B >>> 0 > d >>> 0, we = (B | 0) == (Gr | 0) & v >>> 0 < dr >>> 0 | B >>> 0 < Gr >>> 0, B = ni + 8 | 0, Gr = a[B >> 2], dr = $r + 8 | 0, v = Gr + a[dr >> 2] | 0, B = a[dr + 4 >> 2] + a[B + 4 >> 2] | 0, B = v >>> 0 < Gr >>> 0 ? B + 1 | 0 : B, mi = v, v = v + we | 0, B = (m >> 31) + (mi >>> 0 > v >>> 0 ? B + 1 | 0 : B) | 0, m = m >> 30, we = m, m = m + v | 0, B = we >>> 0 > m >>> 0 ? B + 1 | 0 : B, v = m + fr | 0, m = v >>> 0 < m >>> 0 ? B + 1 | 0 : B, we = m << 2 | v >>> 30, Gr = d, dr = v << 2 | d >>> 30, Si = a[Be + 128 >> 2], v = a[Be + 160 >> 2], d = Si + v | 0, fr = a[Be + 132 >> 2], B = fr + a[Be + 164 >> 2] | 0, v = d >>> 0 < v >>> 0 ? B + 1 | 0 : B, B = v + we | 0, we = d, $i = d + dr | 0, d = d >>> 0 > $i >>> 0 ? B + 1 | 0 : B, dr = (v | 0) == (d | 0) & we >>> 0 > $i >>> 0 | d >>> 0 < v >>> 0, we = (v | 0) == (fr | 0) & we >>> 0 < Si >>> 0 | v >>> 0 < fr >>> 0, B = Io + 8 | 0, fr = a[B >> 2], Dr = yo + 8 | 0, v = fr + a[Dr >> 2] | 0, B = a[Dr + 4 >> 2] + a[B + 4 >> 2] | 0, B = v >>> 0 < fr >>> 0 ? B + 1 | 0 : B, fr = v, v = v + we | 0, B = (m >> 31) + (fr >>> 0 > v >>> 0 ? B + 1 | 0 : B) | 0, m = m >> 30, we = m, m = m + v | 0, B = we >>> 0 > m >>> 0 ? B + 1 | 0 : B, v = m + dr | 0, m = v >>> 0 < m >>> 0 ? B + 1 | 0 : B, we = m << 2 | v >>> 30, fr = d, Dr = v << 2 | d >>> 30, mi = a[Be + 64 >> 2], v = a[Be + 96 >> 2], d = mi + v | 0, dr = a[Be + 68 >> 2], B = dr + a[Be + 100 >> 2] | 0, v = d >>> 0 < v >>> 0 ? B + 1 | 0 : B, B = v + we | 0, we = d, Ti = d + Dr | 0, d = d >>> 0 > Ti >>> 0 ? B + 1 | 0 : B, Dr = (v | 0) == (d | 0) & we >>> 0 > Ti >>> 0 | d >>> 0 < v >>> 0, we = (v | 0) == (dr | 0) & we >>> 0 < mi >>> 0 | v >>> 0 < dr >>> 0, B = Oo + 8 | 0, dr = a[B >> 2], Si = uo + 8 | 0, v = dr + a[Si >> 2] | 0, B = a[Si + 4 >> 2] + a[B + 4 >> 2] | 0, B = v >>> 0 < dr >>> 0 ? B + 1 | 0 : B, mi = v, v = v + we | 0, B = (m >> 31) + (mi >>> 0 > v >>> 0 ? B + 1 | 0 : B) | 0, m = m >> 30, we = m, m = m + v | 0, B = we >>> 0 > m >>> 0 ? B + 1 | 0 : B, v = m + Dr | 0, m = v >>> 0 < m >>> 0 ? B + 1 | 0 : B, we = m << 2 | v >>> 30, dr = d, Si = v << 2 | d >>> 30, ni = a[Be >> 2], v = a[Be + 32 >> 2], d = ni + v | 0, Dr = a[Be + 4 >> 2], B = Dr + a[Be + 36 >> 2] | 0, v = d >>> 0 < v >>> 0 ? B + 1 | 0 : B, B = v + we | 0, we = d, Si = d + Si | 0, d = d >>> 0 > Si >>> 0 ? B + 1 | 0 : B, mi = (v | 0) == (d | 0) & we >>> 0 > Si >>> 0 | d >>> 0 < v >>> 0, we = (v | 0) == (Dr | 0) & we >>> 0 < ni >>> 0 | v >>> 0 < Dr >>> 0, B = qi + 8 | 0, Dr = a[B >> 2], ni = Be + 8 | 0, v = Dr + a[ni >> 2] | 0, B = a[ni + 4 >> 2] + a[B + 4 >> 2] | 0, B = v >>> 0 < Dr >>> 0 ? B + 1 | 0 : B, Dr = v, v = v + we | 0, B = (m >> 31) + (Dr >>> 0 > v >>> 0 ? B + 1 | 0 : B) | 0, m = m >> 30, we = m, m = m + v | 0, B = we >>> 0 > m >>> 0 ? B + 1 | 0 : B, v = m, m = m + mi | 0, v = (v >>> 0 > m >>> 0 ? B + 1 | 0 : B) << 2 | m >>> 30, ds = m << 2 | d >>> 30, Ao = v, Go = d & 1073741823, uo = Rr & 1073741823, Vn = dr & 1073741823, yo = Fr & 1073741823, Mo = fr & 1073741823, Io = wr & 1073741823, d = he, fr = Gr & 1073741823, m = Me, dr = Qe & 1073741823, _o = _o + 1 | 0, (_o | 0) == 10)
        break;
    }
    B = zi >> 31, d = B, Qe = Be + 392 | 0, Me = Qe + 32 | 0, Fr = a[Me >> 2], B = a[Me + 4 >> 2], fr = B, B = B >> 31, m = B, v = a[o >> 2], Rr = B & v, he = Rr + a[Be + 392 >> 2] | 0, we = a[o + 4 >> 2], B = a[Be + 396 >> 2] + (we & B) | 0, B = he >>> 0 < Rr >>> 0 ? B + 1 | 0 : B, he = d ^ he, Si = he - d | 0, he = (B ^ d) - ((d >>> 0 > he >>> 0) + d | 0) | 0, Rr = v, Gr = we, B = a[o + 32 >> 2], Ti = B, we = B & m, v = we + Fr | 0, $i = a[o + 36 >> 2], B = fr + ($i & m) | 0, B = v >>> 0 < we >>> 0 ? B + 1 | 0 : B, v = d ^ v, Fr = v - d | 0, Dr = (B ^ d) - ((d >>> 0 > v >>> 0) + d | 0) | 0, B = a[o + 24 >> 2], Xn = B, wr = B & m, v = Qe + 24 | 0, we = wr + a[v >> 2] | 0, Sn = a[o + 28 >> 2], B = a[v + 4 >> 2] + (Sn & m) | 0, B = we >>> 0 < wr >>> 0 ? B + 1 | 0 : B, we = d ^ we, dr = we - d | 0, un = (B ^ d) - ((d >>> 0 > we >>> 0) + d | 0) | 0, B = a[o + 16 >> 2], mi = B, fr = B & m, we = Qe + 16 | 0, wr = fr + a[we >> 2] | 0, Oi = a[o + 20 >> 2], B = a[we + 4 >> 2] + (Oi & m) | 0, B = fr >>> 0 > wr >>> 0 ? B + 1 | 0 : B, wr = d ^ wr, zi = wr - d | 0, wr = (B ^ d) - ((d >>> 0 > wr >>> 0) + d | 0) | 0, ni = a[o + 8 >> 2], fr = ni & m, B = Qe + 8 | 0, Qe = fr + a[B >> 2] | 0, $r = a[o + 12 >> 2], B = a[B + 4 >> 2] + ($r & m) | 0, o = d ^ Qe, m = o - d | 0, B = ((d ^ (fr >>> 0 > Qe >>> 0 ? B + 1 | 0 : B)) - ((o >>> 0 < d >>> 0) + d | 0) | 0) + (he >> 31) | 0, o = he >> 30, m = o + m | 0, fr = o >>> 0 > m >>> 0 ? B + 1 | 0 : B, B = (fr >> 31) + wr | 0, o = fr >> 30, Qe = o + zi | 0, zi = o >>> 0 > Qe >>> 0 ? B + 1 | 0 : B, B = (zi >> 31) + un | 0, o = zi >> 30, wr = o + dr | 0, dr = o >>> 0 > wr >>> 0 ? B + 1 | 0 : B, B = (dr >> 31) + Dr | 0, o = dr >> 30, Fr = o + Fr | 0, Dr = o >>> 0 > Fr >>> 0 ? B + 1 | 0 : B, o = Dr >> 31, B = (o & Gr) + (he & 1073741823) | 0, d = o, o = (d & Rr) + Si | 0, B = o >>> 0 < Si >>> 0 ? B + 1 | 0 : B, a[xo >> 2] = o, o = B, a[xo + 4 >> 2] = B & 1073741823, Rr = xo + 8 | 0, B = (d & $r) + (fr & 1073741823) | 0, he = m, m = (d & ni) + m | 0, B = (o >> 31) + (he >>> 0 > m >>> 0 ? B + 1 | 0 : B) | 0, o = o >> 30, he = o, o = o + m | 0, B = he >>> 0 > o >>> 0 ? B + 1 | 0 : B, a[Rr >> 2] = o, o = B, a[Rr + 4 >> 2] = B & 1073741823, B = (d & Oi) + (zi & 1073741823) | 0, m = (d & mi) + Qe | 0, B = (o >> 31) + (m >>> 0 < Qe >>> 0 ? B + 1 | 0 : B) | 0, o = o >> 30, he = o, o = o + m | 0, B = he >>> 0 > o >>> 0 ? B + 1 | 0 : B, m = o, a[we >> 2] = m, o = B, B = B & 1073741823, a[we + 4 >> 2] = B, he = xo + 16 | 0, a[he >> 2] = m, a[he + 4 >> 2] = B, B = (d & Sn) + (dr & 1073741823) | 0, m = (d & Xn) + wr | 0, B = (o >> 31) + (m >>> 0 < wr >>> 0 ? B + 1 | 0 : B) | 0, o = o >> 30, he = o, o = o + m | 0, B = he >>> 0 > o >>> 0 ? B + 1 | 0 : B, m = o, a[v >> 2] = m, o = B, B = B & 1073741823, a[v + 4 >> 2] = B, he = xo + 24 | 0, a[he >> 2] = m, a[he + 4 >> 2] = B, B = (d & $i) + Dr | 0, d = (d & Ti) + Fr | 0, B = (o >> 31) + (d >>> 0 < Fr >>> 0 ? B + 1 | 0 : B) | 0, o = o >> 30, m = o, o = o + d | 0, B = m >>> 0 > o >>> 0 ? B + 1 | 0 : B, a[Me >> 2] = o, a[Me + 4 >> 2] = B, d = xo + 32 | 0, a[d >> 2] = o, a[d + 4 >> 2] = B, be = Be + 432 | 0;
  }
  function $s(B, o) {
    var m = 0, d = 0, v = 0, he = 0, we = 0, Be = 0, Me = 0, fr = 0, wr = 0, dr = 0, Dr = 0, Rr = 0, Qe = 0, Fr = 0, Gr = 0;
    v = be - 48 | 0, be = v;
    e: {
      if (!o) {
        ji[a[B + 168 >> 2]](689571, a[B + 172 >> 2]), B = 0;
        break e;
      }
      Qe = v + 8 | 0, Rn(Qe, o, v + 44 | 0), Me = a[v + 32 >> 2], m = a[v + 24 >> 2], Be = a[v + 16 >> 2], d = a[v + 8 >> 2], dr = a[v + 36 >> 2], fr = a[v + 28 >> 2], he = a[v + 20 >> 2], we = a[v + 12 >> 2], Fr = a[v + 44 >> 2] | !(Me | (m | (Be | d)) | (dr | (fr | (he | we)))), B = Fr ? 0 : -1, Me = B & Me, Dr = B & m, wr = B & Be, d = B & d, dr = B & dr, Gr = B & fr, Rr = B & he, m = B & we, Be = Me | (Dr | (wr | d)) | (dr | (Gr | (Rr | m))) ? -1 : 0, d = d ^ -1, we = d - 801750718 | 0, a[v + 8 >> 2] = Be & we, m = m ^ -1, he = m - ((d >>> 0 < 801750718) + 1076732275 | 0) | 0, a[v + 12 >> 2] = he & Be, B = (m | 0) == (he | 0) & d >>> 0 > we >>> 0 | m >>> 0 > he >>> 0, he = wr ^ -1, d = B + he | 0, we = Rr ^ -1, m = we, Rr = d - 1354194885 | 0, a[v + 16 >> 2] = Rr & Be, m = d >>> 0 < he >>> 0 ? m + 1 | 0 : m, fr = m - ((d >>> 0 < 1354194885) + 1162945305 | 0) | 0, a[v + 20 >> 2] = fr & Be, Dr = Dr ^ -1, B = (m | 0) == (we | 0) & d >>> 0 < he >>> 0 | m >>> 0 < we >>> 0, he = (m | 0) == (fr | 0) & d >>> 0 > Rr >>> 0 | m >>> 0 > fr >>> 0, m = B + he | 0, wr = Gr ^ -1, d = wr + (m >>> 0 < he >>> 0) | 0, B = m, m = m + Dr | 0, d = B >>> 0 > m >>> 0 ? d + 1 | 0 : d, we = m - 2 | 0, a[v + 24 >> 2] = we & Be, he = d - (m >>> 0 < 2) | 0, a[v + 28 >> 2] = he & Be, B = (d | 0) == (wr | 0) & m >>> 0 < Dr >>> 0 | d >>> 0 < wr >>> 0, m = (d | 0) == (he | 0) & m >>> 0 > we >>> 0 | d >>> 0 > he >>> 0, B = B + m | 0, d = B >>> 0 < m >>> 0, m = B - Me | 0, a[v + 32 >> 2] = m - 2 & Be, a[v + 36 >> 2] = (d - ((B >>> 0 < Me >>> 0) + dr | 0) | 0) - (m >>> 0 < 2) & Be, vo(o, Qe), B = !Fr;
    }
    return be = v + 48 | 0, B;
  }
  function rs() {
    var B = 0, o = 0, m = 0, d = 0, v = 0, he = 0, we = 0, Be = 0, Me = 0, fr = 0, wr = 0, dr = 0, Dr = 0, Rr = 0, Qe = 0, Fr = 0, Gr = 0, $r = 0, ni = 0, mi = 0, Si = 0, Oi = 0, $i = 0, zi = 0, un = 0, In = 0, Ti = 0, Sn = 0, Kn = 0, Vn = 0;
    return v = be - 80 | 0, be = v, un = v + 8 | 0, B = v + 48 | 0, Rn(un, 690788, B), Vn = a[v + 48 >> 2], Si = a[v + 32 >> 2], In = a[v + 36 >> 2], Oi = a[v + 24 >> 2], Ti = a[v + 28 >> 2], $i = a[v + 8 >> 2], Sn = a[v + 12 >> 2], zi = a[v + 16 >> 2], Kn = a[v + 20 >> 2], a[v + 44 >> 2] = 0, Rn(B, 690949, v + 44 | 0), d = a[v + 52 >> 2], B = d + Sn | 0, m = a[v + 48 >> 2], ni = m + $i | 0, Fr = ni >>> 0 < $i >>> 0 ? B + 1 | 0 : B, he = a[v + 60 >> 2], B = he + Kn | 0, fr = B + 1 | 0, wr = B, B = a[v + 56 >> 2], o = B + zi | 0, we = o >>> 0 < zi >>> 0 ? fr : wr, he = (we | 0) == (he | 0) & B >>> 0 > o >>> 0 | we >>> 0 < he >>> 0, B = (d | 0) == (Fr | 0) & m >>> 0 > ni >>> 0 | d >>> 0 > Fr >>> 0, $r = B + o | 0, Rr = $r >>> 0 < B >>> 0 ? we + 1 | 0 : we, m = (Rr | 0) == (we | 0) & o >>> 0 > $r >>> 0 | we >>> 0 > Rr >>> 0, he = he + m | 0, o = a[v + 68 >> 2], B = o + Ti | 0, fr = B + 1 | 0, wr = B, B = a[v + 64 >> 2], we = B + Oi | 0, Be = we >>> 0 < Oi >>> 0 ? fr : wr, m = Be + (m >>> 0 > he >>> 0) | 0, Gr = we + he | 0, he = Gr >>> 0 < he >>> 0 ? m + 1 | 0 : m, d = (he | 0) == (Be | 0) & we >>> 0 > Gr >>> 0 | he >>> 0 < Be >>> 0, Me = d + ((o | 0) == (Be | 0) & B >>> 0 > we >>> 0 | o >>> 0 > Be >>> 0) | 0, B = he, we = (B | 0) == -1, Qe = a[v + 76 >> 2], m = Qe + In | 0, o = a[v + 72 >> 2], Dr = o + Si | 0, dr = Dr >>> 0 < Si >>> 0 ? m + 1 | 0 : m, m = dr + (d >>> 0 > Me >>> 0) | 0, fr = m + 1 | 0, wr = m, m = Me + Dr | 0, mi = m >>> 0 < Me >>> 0 ? fr : wr, d = we & Gr >>> 0 < 4294967294 | (B | 0) != -1 | (mi & m) != -1, Be = (Rr | 0) == -1162945306, Me = (d | (Be & $r >>> 0 < 2940772411 | Rr >>> 0 < 3132021990)) ^ -1, d = (((dr | 0) == (Qe | 0) & o >>> 0 > Dr >>> 0 | dr >>> 0 < Qe >>> 0) + ((dr | 0) == (mi | 0) & m >>> 0 < Dr >>> 0 | dr >>> 0 > mi >>> 0) | 0) + (Me & ((Fr | 0) == -1076732276 & ni >>> 0 > 3493216576 | Fr >>> 0 > 3218235020) | (Me & (Be & $r >>> 0 > 2940772411 | Rr >>> 0 > 3132021990) | (Gr | 0) == -1 & we & (d ^ -1))) | 0, Dr = d + Gr | 0, Dr >>> 0 < Gr >>> 0 && (B = B + 1 | 0), Be = oi(d, 0, 1354194884, 1162945305), we = Rr + Fe | 0, o = oi(d, 0, 801750719, 1076732275), fr = o + ni | 0, Qe = Be + $r | 0, d = Fr + Fe | 0, Me = o >>> 0 > fr >>> 0 ? d + 1 | 0 : d, d = (Me | 0) == (Fr | 0) & ni >>> 0 > fr >>> 0 | Me >>> 0 < Fr >>> 0, dr = Qe + d | 0, o = Be >>> 0 > Qe >>> 0 ? we + 1 | 0 : we, Be = d >>> 0 > dr >>> 0 ? o + 1 | 0 : o, d = (o | 0) == (Be | 0) & dr >>> 0 < Qe >>> 0 | o >>> 0 > Be >>> 0, o = d + ((o | 0) == (Rr | 0) & Qe >>> 0 < $r >>> 0 | o >>> 0 < Rr >>> 0) | 0, wr = (B | 0) == (he | 0) & Dr >>> 0 < Gr >>> 0 | B >>> 0 < he >>> 0, d = (o >>> 0 < d >>> 0) + B | 0, he = o, o = o + Dr | 0, we = he >>> 0 > o >>> 0 ? d + 1 | 0 : d, B = (we | 0) == (B | 0) & o >>> 0 < Dr >>> 0 | B >>> 0 > we >>> 0, he = wr + B | 0, B = mi + (B >>> 0 > he >>> 0) | 0, he = m + he | 0, d = he >>> 0 < m >>> 0 ? B + 1 | 0 : B, B = v, he | (dr | fr | o) | (d | (Be | Me | we)) ? wr = a[B + 44 >> 2] | (Vn | !(Si | (Oi | ($i | zi)) | (In | (Ti | (Sn | Kn))))) : wr = 1, v = !wr, m = 0 - v | 0, a[B + 32 >> 2] = he & m, a[B + 36 >> 2] = m & d, a[B + 24 >> 2] = o & m, a[B + 28 >> 2] = m & we, a[B + 16 >> 2] = m & dr, a[B + 20 >> 2] = m & Be, a[B + 8 >> 2] = m & fr, a[B + 12 >> 2] = m & Me, vo(690788, un), be = B + 80 | 0, v;
  }
  function ls(B, o, m) {
    var d = 0, v = 0, he = 0, we = 0, Be = 0, Me = 0, fr = 0, wr = 0, dr = 0, Dr = 0, Rr = 0, Qe = 0, Fr = 0, Gr = 0, $r = 0, ni = 0, mi = 0, Si = 0, Oi = 0, $i = 0, zi = 0, un = 0, In = 0, Ti = 0, Sn = 0, Kn = 0, Vn = 0, Xn = 0, uo = 0, yo = 0, Io = 0, xo = 0, Mo = 0, qi = 0, Oo = 0, Ho = 0, Go = 0, ns = 0, ds = 0, Ts = 0, Ao = 0, po = 0, _o = 0, Uo = 0, ts = 0, Lo = 0, Wo = 0, ps = 0, Bs = 0, Xs = 0, js = 0, ya = 0, sa = 0, va = 0, oa = 0, wa = 0, Pa = 0, Ta = 0, jn = 0, ta = 0, Na = 0, ba = 0, Aa = 0, zs = 0, x2 = 0, Va = 0, Se = 0, ea = 0, e = 0, Je = 0, N2 = 0, qs = 0, df = 0, zo = 0, No = 0, Oa = 0, Mf = 0;
    he = be - 1744 | 0, be = he, Fr = he + 1704 | 0, Se = o + 80 | 0, na(Fr, Se), Mo = he + 1664 | 0, Si = Mo + 8 | 0, we = Si, d = o + 8 | 0, Sn = a[d >> 2], mi = a[d + 4 >> 2], Be = a[o + 4 >> 2], d = o + 32 | 0, dr = a[d >> 2], fr = a[d + 4 >> 2], Me = fr, v = a[o >> 2], fr = oi(Me >>> 16 | 0, 0, 977, 1), v = v + fr | 0, d = Be + Fe | 0, Be = v >>> 0 < fr >>> 0 ? d + 1 | 0 : d, d = mi, fr = Be >>> 20 | 0, un = fr + Sn | 0, d = fr >>> 0 > un >>> 0 ? d + 1 | 0 : d, a[we >> 2] = un, e = d & 1048575, a[we + 4 >> 2] = e, Sn = Mo + 16 | 0, fr = Sn, we = o + 16 | 0, mi = a[we >> 2], Rr = a[we + 4 >> 2], we = d, d = Rr, we = we >>> 20 | 0, In = we + mi | 0, d = we >>> 0 > In >>> 0 ? d + 1 | 0 : d, a[fr >> 2] = In, Je = d & 1048575, a[fr + 4 >> 2] = Je, mi = Mo + 24 | 0, fr = mi, we = o + 24 | 0, Rr = a[we >> 2], ts = a[we + 4 >> 2], we = d, d = ts, we = we >>> 20 | 0, Kn = we + Rr | 0, d = we >>> 0 > Kn >>> 0 ? d + 1 | 0 : d, a[fr >> 2] = Kn, N2 = d & 1048575, a[fr + 4 >> 2] = N2, Rr = Mo + 32 | 0, fr = Rr, we = d, d = Me & 65535, we = we >>> 20 | 0, _o = we + dr | 0, d = we >>> 0 > _o >>> 0 ? d + 1 | 0 : d, a[fr >> 2] = _o, oa = d, a[fr + 4 >> 2] = d, ya = v, a[he + 1664 >> 2] = v, qs = Be & 1048575, a[he + 1668 >> 2] = qs, gn(he + 1624 | 0, m, Fr), d = o - -64 | 0, $i = a[d >> 2], Gr = a[d + 4 >> 2], d = o + 56 | 0, Oi = a[d >> 2], Io = a[d + 4 >> 2], d = o + 48 | 0, Ho = a[d >> 2], Ts = a[d + 4 >> 2], d = o + 72 | 0, po = a[d >> 2], ts = a[d + 4 >> 2], qi = a[o + 40 >> 2], Ti = a[o + 44 >> 2], d = he + 1584 | 0, gn(d, m + 40 | 0, Fr), gn(d, d, Se), xo = a[he + 1636 >> 2], d = xo + a[Si + 4 >> 2] | 0, Na = he + 1544 | 0, Aa = Na + 8 | 0, v = Aa, wa = a[he + 1632 >> 2], dr = a[Si >> 2], fr = wa + dr | 0, a[v >> 2] = fr, Fr = fr >>> 0 < dr >>> 0 ? d + 1 | 0 : d, a[v + 4 >> 2] = Fr, uo = a[he + 1644 >> 2], d = uo + a[Sn + 4 >> 2] | 0, zs = Na + 16 | 0, Be = zs, Pa = a[he + 1640 >> 2], v = a[Sn >> 2], dr = Pa + v | 0, a[Be >> 2] = dr, v = v >>> 0 > dr >>> 0 ? d + 1 | 0 : d, a[Be + 4 >> 2] = v, yo = a[he + 1652 >> 2], d = yo + a[mi + 4 >> 2] | 0, x2 = Na + 24 | 0, Si = x2, Go = a[he + 1648 >> 2], Be = a[mi >> 2], we = Go + Be | 0, a[Si >> 2] = we, Be = we >>> 0 < Be >>> 0 ? d + 1 | 0 : d, a[Si + 4 >> 2] = Be, Lo = a[he + 1660 >> 2], d = Lo + a[Rr + 4 >> 2] | 0, jn = Na + 32 | 0, Sn = jn, Oo = a[he + 1656 >> 2], mi = a[Rr >> 2], Si = Oo + mi | 0, a[Sn >> 2] = Si, Rr = mi >>> 0 > Si >>> 0 ? d + 1 | 0 : d, a[Sn + 4 >> 2] = Rr, Bs = a[he + 1628 >> 2], d = Bs + a[he + 1668 >> 2] | 0, Xn = a[he + 1624 >> 2], mi = a[he + 1664 >> 2], Sn = Xn + mi | 0, a[he + 1544 >> 2] = Sn, mi = mi >>> 0 > Sn >>> 0 ? d + 1 | 0 : d, a[he + 1548 >> 2] = mi, va = he + 1232 | 0, Dr = Sn << 1, wr = mi << 1 | Sn >>> 31, Lr(va, we, Be, 0, 0, Dr, wr, 0, 0), ns = he + 1312 | 0, zi = fr << 1, $r = Fr, Qe = fr, Fr = Fr << 1 | fr >>> 31, Lr(ns, dr, v, 0, 0, zi, Fr, 0, 0), ni = he + 1168 | 0, d = Rr, Lr(ni, Si, d, 0, 0, Si, d, 0, 0), Xs = he + 1152 | 0, Lr(Xs, a[he + 1168 >> 2], a[he + 1172 >> 2], 0, 0, 15632, 16, 0, 0), Ao = he + 1120 | 0, fr = Si << 1, Rr = d << 1 | Si >>> 31, Lr(Ao, fr, Rr, 0, 0, Sn, mi, 0, 0), Uo = he + 1216 | 0, Lr(Uo, we, Be, 0, 0, zi, Fr, 0, 0), js = he + 1328 | 0, Lr(js, dr, v, 0, 0, dr, v, 0, 0), Wo = he + 1136 | 0, d = ni + 8 | 0, Lr(Wo, a[d >> 2], a[d + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Ta = he + 1248 | 0, Lr(Ta, Sn, mi, 0, 0, Sn, mi, 0, 0), ps = he + 1104 | 0, Lr(ps, fr, Rr, 0, 0, Qe, $r, 0, 0), ds = v, Sn = dr, d = v << 1 | dr >>> 31, sa = he + 1200 | 0, zi = we, ni = Be, Lr(sa, we, Be, 0, 0, dr << 1, d, 0, 0), Fr = a[he + 1232 >> 2], v = a[he + 1312 >> 2], dr = Fr + v | 0, we = a[he + 1236 >> 2], d = we + a[he + 1316 >> 2] | 0, v = v >>> 0 > dr >>> 0 ? d + 1 | 0 : d, d = v + a[he + 1156 >> 2] | 0, Be = dr, Si = a[he + 1152 >> 2], dr = Be + Si | 0, Vn = dr, dr = dr >>> 0 < Si >>> 0 ? d + 1 | 0 : d, Si = (v | 0) == (dr | 0) & Be >>> 0 > Vn >>> 0 | v >>> 0 > dr >>> 0, d = Xs + 8 | 0, mi = a[d >> 2], Me = a[d + 4 >> 2], we = (v | 0) == (we | 0) & Be >>> 0 < Fr >>> 0 | v >>> 0 < we >>> 0, d = ns + 8 | 0, Fr = a[d >> 2], v = va + 8 | 0, Be = Fr + a[v >> 2] | 0, v = a[v + 4 >> 2] + a[d + 4 >> 2] | 0, d = Be >>> 0 < Fr >>> 0 ? v + 1 | 0 : v, v = we + Be | 0, d = (v >>> 0 < Be >>> 0 ? d + 1 | 0 : d) + Me | 0, we = v, v = v + mi | 0, d = we >>> 0 > v >>> 0 ? d + 1 | 0 : d, we = v, v = v + Si | 0, Be = we >>> 0 > v >>> 0 ? d + 1 | 0 : d, we = Be << 12 | v >>> 20, ns = dr, dr = v << 12 | dr >>> 20, va = we, ta = a[he + 1216 >> 2], we = a[he + 1328 >> 2], v = ta + we | 0, Xs = a[he + 1220 >> 2], d = Xs + a[he + 1332 >> 2] | 0, we = v >>> 0 < we >>> 0 ? d + 1 | 0 : d, Si = v, Fr = a[he + 1120 >> 2], d = v + Fr | 0, v = we + a[he + 1124 >> 2] | 0, Fr = d >>> 0 < Fr >>> 0 ? v + 1 | 0 : v, mi = d, Me = a[he + 1136 >> 2], v = d + Me | 0, d = Fr + a[he + 1140 >> 2] | 0, d = v >>> 0 < Me >>> 0 ? d + 1 | 0 : d, Me = v, v = d, d = d + va | 0, Va = he + 1088 | 0, va = Me + dr | 0, dr = va >>> 0 < Me >>> 0 ? d + 1 | 0 : d, ba = (v | 0) == (dr | 0) & Me >>> 0 > va >>> 0 | v >>> 0 > dr >>> 0, Me = (v | 0) == (Fr | 0) & Me >>> 0 < mi >>> 0 | v >>> 0 < Fr >>> 0, d = Wo + 8 | 0, Wo = a[d >> 2], ea = a[d + 4 >> 2], Fr = (we | 0) == (Fr | 0) & mi >>> 0 < Si >>> 0 | we >>> 0 > Fr >>> 0, d = Ao + 8 | 0, mi = a[d >> 2], Ao = a[d + 4 >> 2], Si = (we | 0) == (Xs | 0) & Si >>> 0 < ta >>> 0 | we >>> 0 < Xs >>> 0, d = js + 8 | 0, Xs = a[d >> 2], v = Uo + 8 | 0, we = Xs + a[v >> 2] | 0, v = a[v + 4 >> 2] + a[d + 4 >> 2] | 0, d = we >>> 0 < Xs >>> 0 ? v + 1 | 0 : v, v = we + Si | 0, d = (v >>> 0 < we >>> 0 ? d + 1 | 0 : d) + Ao | 0, we = v, v = v + mi | 0, d = we >>> 0 > v >>> 0 ? d + 1 | 0 : d, we = v, v = v + Fr | 0, d = (we >>> 0 > v >>> 0 ? d + 1 | 0 : d) + ea | 0, we = v + Wo | 0, v = we >>> 0 < v >>> 0 ? d + 1 | 0 : d, d = we + Me | 0, v = d >>> 0 < we >>> 0 ? v + 1 | 0 : v, we = d, d = v, Be = Be >>> 20 | 0, v = we + Be | 0, d = Be >>> 0 > v >>> 0 ? d + 1 | 0 : d, we = v, v = v + ba | 0, Be = we >>> 0 > v >>> 0 ? d + 1 | 0 : d, Fr = Be << 12 | v >>> 20, we = dr, v = v << 12 | we >>> 20, dr = Fr, Me = a[he + 1104 >> 2], Fr = a[he + 1200 >> 2], Si = Me + Fr | 0, mi = a[he + 1108 >> 2], d = mi + a[he + 1204 >> 2] | 0, Fr = Fr >>> 0 > Si >>> 0 ? d + 1 | 0 : d, d = v + Si | 0, v = dr + Fr | 0, dr = d >>> 0 < Si >>> 0 ? v + 1 | 0 : v, v = d, d = dr << 4 | d >>> 28, Ao = v << 4 & -16, Xs = we, Lr(Va, Ao | we >>> 16 & 15, d & 16777215, 0, 0, 977, 1, 0, 0), Ao = he + 1280 | 0, Lr(Ao, Qe, $r, 0, 0, Dr, wr, 0, 0), Uo = he + 1072 | 0, Lr(Uo, fr, Rr, 0, 0, Sn, ds, 0, 0), js = he + 1184 | 0, Lr(js, zi, ni, 0, 0, zi, ni, 0, 0), ba = he + 1056 | 0, Wo = ba, ta = (dr | 0) == (Fr | 0) & v >>> 0 < Si >>> 0 | dr >>> 0 < Fr >>> 0, we = (Fr | 0) == (mi | 0) & Me >>> 0 > Si >>> 0 | Fr >>> 0 < mi >>> 0, d = sa + 8 | 0, Fr = a[d >> 2], Si = ps + 8 | 0, v = Fr + a[Si >> 2] | 0, d = a[Si + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 < Fr >>> 0 ? d + 1 | 0 : d, Me = v, v = v + we | 0, d = Me >>> 0 > v >>> 0 ? d + 1 | 0 : d, Be = Be >>> 20 | 0, we = Be, Be = v + Be | 0, v = we >>> 0 > Be >>> 0 ? d + 1 | 0 : d, d = Be + ta | 0, v = d >>> 0 < Be >>> 0 ? v + 1 | 0 : v, we = v << 12 | d >>> 20, Be = d << 12 | dr >>> 20, Fr = we, mi = a[he + 1072 >> 2], we = a[he + 1184 >> 2], dr = mi + we | 0, Si = a[he + 1076 >> 2], d = Si + a[he + 1188 >> 2] | 0, d = we >>> 0 > dr >>> 0 ? d + 1 | 0 : d, we = dr, dr = d, d = d + Fr | 0, Be = we + Be | 0, d = Be >>> 0 < we >>> 0 ? d + 1 | 0 : d, Fr = Be, Be = d, Lr(Wo, Fr, d & 1048575, 0, 0, 15632, 16, 0, 0), Me = he + 1264 | 0, Lr(Me, Sn, ds, 0, 0, Dr, wr, 0, 0), wr = he + 1296 | 0, Lr(wr, Qe, $r, 0, 0, Qe, $r, 0, 0), Sn = he + 1040 | 0, Lr(Sn, fr, Rr, 0, 0, zi, ni, 0, 0), Dr = he + 1024 | 0, fr = Dr, Fr = (d | 0) == (dr | 0) & we >>> 0 > Fr >>> 0 | d >>> 0 < dr >>> 0, we = (dr | 0) == (Si | 0) & we >>> 0 < mi >>> 0 | dr >>> 0 < Si >>> 0, d = js + 8 | 0, Si = a[d >> 2], mi = Uo + 8 | 0, dr = Si + a[mi >> 2] | 0, d = a[mi + 4 >> 2] + a[d + 4 >> 2] | 0, d = dr >>> 0 < Si >>> 0 ? d + 1 | 0 : d, Rr = dr, dr = we + dr | 0, d = Rr >>> 0 > dr >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, we = v, v = v + dr | 0, d = we >>> 0 > v >>> 0 ? d + 1 | 0 : d, dr = v + Fr | 0, v = dr >>> 0 < v >>> 0 ? d + 1 | 0 : d, we = v << 12 | dr >>> 20, Fr = dr << 12 | Be >>> 20, Si = a[he + 1040 >> 2], dr = Fr + Si | 0, Be = we, d = we + a[he + 1044 >> 2] | 0, d = dr >>> 0 < Si >>> 0 ? d + 1 | 0 : d, Lr(fr, dr, d, 0, 0, 15632, 16, 0, 0), Qe = he + 1008 | 0, we = Qe, dr = (d | 0) == (Be | 0) & dr >>> 0 < Fr >>> 0 | d >>> 0 < Be >>> 0, d = Sn + 8 | 0, Be = a[d >> 2], d = a[d + 4 >> 2], v = v >>> 20 | 0, fr = v, v = v + Be | 0, d = fr >>> 0 > v >>> 0 ? d + 1 | 0 : d, Be = v, v = v + dr | 0, d = Be >>> 0 > v >>> 0 ? d + 1 | 0 : d, Lr(we, v, d, 0, 0, 64028672, 65536, 0, 0), Wo = a[he + 1608 >> 2], js = a[he + 1612 >> 2], ps = a[he + 1600 >> 2], ea = a[he + 1604 >> 2], ta = a[he + 1584 >> 2], df = a[he + 1588 >> 2], Sn = a[he + 1616 >> 2], mi = a[he + 1620 >> 2], sa = a[he + 1592 >> 2], zo = a[he + 1596 >> 2], a[he + 1416 >> 2] = -4 - Oo, a[he + 1420 >> 2] = 262143 - ((Oo >>> 0 > 4294967292) + Lo | 0), a[he + 1408 >> 2] = -4 - Go, a[he + 1412 >> 2] = 4194303 - ((Go >>> 0 > 4294967292) + yo | 0), a[he + 1400 >> 2] = -4 - Pa, a[he + 1404 >> 2] = 4194303 - ((Pa >>> 0 > 4294967292) + uo | 0), a[he + 1392 >> 2] = -4 - wa, a[he + 1396 >> 2] = 4194303 - ((wa >>> 0 > 4294967292) + xo | 0), a[he + 1384 >> 2] = -3908 - Xn, a[he + 1388 >> 2] = 4194299 - ((Xn >>> 0 > 4294963388) + Bs | 0), d = Ta + 8 | 0, $r = a[d >> 2], zi = a[d + 4 >> 2], d = Va + 8 | 0, Be = a[d >> 2], Go = a[d + 4 >> 2], dr = a[he + 1248 >> 2], d = a[he + 1252 >> 2], we = a[he + 1088 >> 2], v = a[he + 1092 >> 2], Fr = Ao + 8 | 0, Oo = a[Fr >> 2], Xn = a[Fr + 4 >> 2], Fr = ba + 8 | 0, fr = a[Fr >> 2], xo = a[Fr + 4 >> 2], Si = a[he + 1280 >> 2], uo = a[he + 1284 >> 2], Rr = a[he + 1056 >> 2], Fr = a[he + 1060 >> 2], wr = wr + 8 | 0, Ta = a[wr >> 2], Va = a[wr + 4 >> 2], Me = Me + 8 | 0, Bs = a[Me >> 2], ba = a[Me + 4 >> 2], Me = a[he + 1296 >> 2], No = a[he + 1300 >> 2], Ao = a[he + 1264 >> 2], yo = a[he + 1268 >> 2], wr = Dr + 8 | 0, ds = a[wr >> 2], wa = a[wr + 4 >> 2], wr = a[he + 1024 >> 2], Dr = a[he + 1028 >> 2], Uo = a[he + 1008 >> 2], Lo = a[he + 1012 >> 2], Qe = Qe + 8 | 0, Oa = a[Qe >> 2], Pa = a[Qe + 4 >> 2], Mf = he + 1384 | 0, gn(he + 1504 | 0, Mo, Mf), d = d + v | 0, ni = we + dr | 0, dr = ni >>> 0 < dr >>> 0 ? d + 1 | 0 : d, we = (v | 0) == (dr | 0) & we >>> 0 > ni >>> 0 | v >>> 0 > dr >>> 0, v = zi + Go | 0, d = Be, Be = Be + $r | 0, d = d >>> 0 > Be >>> 0 ? v + 1 | 0 : v, v = we + Be | 0, Be = v >>> 0 < Be >>> 0 ? d + 1 | 0 : d, d = Be << 12 | v >>> 20, Mo = dr, dr = v << 12 | dr >>> 20, Qe = d, d = Fr + uo | 0, we = Rr + Si | 0, v = we >>> 0 < Si >>> 0 ? d + 1 | 0 : d, d = v + Qe | 0, zi = we + dr | 0, dr = zi >>> 0 < we >>> 0 ? d + 1 | 0 : d, Si = (v | 0) == (dr | 0) & we >>> 0 > zi >>> 0 | v >>> 0 > dr >>> 0, Fr = (v | 0) == (Fr | 0) & we >>> 0 < Rr >>> 0 | v >>> 0 < Fr >>> 0, d = Xn + xo | 0, we = fr + Oo | 0, v = we >>> 0 < fr >>> 0 ? d + 1 | 0 : d, d = we + Fr | 0, v = d >>> 0 < we >>> 0 ? v + 1 | 0 : v, we = d, d = v, Be = Be >>> 20 | 0, v = we + Be | 0, d = Be >>> 0 > v >>> 0 ? d + 1 | 0 : d, we = v, v = v + Si | 0, Fr = we >>> 0 > v >>> 0 ? d + 1 | 0 : d, Be = Fr << 12 | v >>> 20, Go = dr, dr = v << 12 | dr >>> 20, d = yo + No | 0, Qe = Me + Ao | 0, fr = Qe >>> 0 < Me >>> 0 ? d + 1 | 0 : d, v = fr + Dr | 0, Dr = wr + Qe | 0, Si = Dr >>> 0 < wr >>> 0 ? v + 1 | 0 : v, d = Si + Be | 0, $r = dr + Dr | 0, dr = $r >>> 0 < Dr >>> 0 ? d + 1 | 0 : d, Be = Sn, we = mi, wr = po, po = ts & 65535, v = oi(ts >>> 16 | 0, 0, 977, 1), mi = v + qi | 0, d = Ti + Fe | 0, Oo = v >>> 0 > mi >>> 0 ? d + 1 | 0 : d, d = Ts, v = Oo >>> 20 | 0, Sn = v + Ho | 0, Xn = v >>> 0 > Sn >>> 0 ? d + 1 | 0 : d, d = Io, v = Xn >>> 20 | 0, Rr = v + Oi | 0, xo = v >>> 0 > Rr >>> 0 ? d + 1 | 0 : d, v = Gr, d = po, Me = xo >>> 20 | 0, Gr = Me, Me = Me + $i | 0, uo = Gr >>> 0 > Me >>> 0 ? v + 1 | 0 : v, v = uo >>> 20 | 0, ts = v + wr | 0, wr = v >>> 0 > ts >>> 0 ? d + 1 | 0 : d, d = wr + we | 0, we = Be + ts | 0, Be = we >>> 0 < ts >>> 0 ? d + 1 | 0 : d, Gr = a[he + 1528 >> 2], Oi = a[he + 1532 >> 2], $i = (dr | 0) == (Si | 0) & Dr >>> 0 > $r >>> 0 | dr >>> 0 < Si >>> 0, Si = (fr | 0) == (Si | 0) & Dr >>> 0 < Qe >>> 0 | fr >>> 0 > Si >>> 0, Dr = (fr | 0) == (yo | 0) & Qe >>> 0 < Ao >>> 0 | fr >>> 0 < yo >>> 0, d = ba + Va | 0, fr = Bs + Ta | 0, v = fr >>> 0 < Bs >>> 0 ? d + 1 | 0 : d, d = fr, fr = fr + Dr | 0, d = (d >>> 0 > fr >>> 0 ? v + 1 | 0 : v) + wa | 0, v = fr + ds | 0, d = v >>> 0 < fr >>> 0 ? d + 1 | 0 : d, fr = v, v = v + Si | 0, d = fr >>> 0 > v >>> 0 ? d + 1 | 0 : d, Fr = Fr >>> 20 | 0, v = v + Fr | 0, d = Fr >>> 0 > v >>> 0 ? d + 1 | 0 : d, fr = v, v = v + $i | 0, Fr = fr >>> 0 > v >>> 0 ? d + 1 | 0 : d, d = v, v = Fr << 12 | d >>> 20, $i = dr, dr = d << 12 | dr >>> 20, Dr = v, fr = Vn & -2, v = fr + Uo | 0, d = Lo + (ns & 1048575) | 0, fr = v >>> 0 < fr >>> 0 ? d + 1 | 0 : d, d = fr + Dr | 0, Si = v, Io = v + dr | 0, dr = v >>> 0 > Io >>> 0 ? d + 1 | 0 : d, d = Oi + (dr & 1048575) | 0, Dr = Gr + Io | 0, Qe = Dr >>> 0 < Io >>> 0 ? d + 1 | 0 : d, d = a[he + 1524 >> 2] + ($i & 1048575) | 0, v = $r, $r = a[he + 1520 >> 2] + $r | 0, $i = v >>> 0 > $r >>> 0 ? d + 1 | 0 : d, d = a[he + 1516 >> 2] + (Go & 1048575) | 0, v = zi, zi = a[he + 1512 >> 2] + zi | 0, Gr = v >>> 0 > zi >>> 0 ? d + 1 | 0 : d, v = a[he + 1508 >> 2] + (Mo & 1048575) | 0, d = ni, ni = a[he + 1504 >> 2] + ni | 0, Oi = d >>> 0 > ni >>> 0 ? v + 1 | 0 : v, d = a[he + 1540 >> 2] + (Xs & 65535) | 0, v = a[he + 1536 >> 2] + va | 0, d = v >>> 0 < va >>> 0 ? d + 1 | 0 : d, va = v, Ho = d, Io = (fr | 0) == (dr | 0) & Si >>> 0 > Io >>> 0 | fr >>> 0 > dr >>> 0, fr = (fr | 0) == (Lo | 0) & Si >>> 0 < Uo >>> 0 | fr >>> 0 < Lo >>> 0, v = fr + Oa | 0, d = Pa, d = v >>> 0 < fr >>> 0 ? d + 1 | 0 : d, Fr = Fr >>> 20 | 0, fr = Fr, Fr = v + Fr | 0, v = fr >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, d = Fr, Fr = Fr + Io | 0, d = (d >>> 0 > Fr >>> 0 ? v + 1 | 0 : v) << 12 | Fr >>> 20, v = Fr << 12 | dr >>> 20, dr = v + va | 0, d = d + Ho | 0, Fr = v >>> 0 > dr >>> 0 ? d + 1 | 0 : d, fr = oi(Fr >>> 16 | 0, 0, 977, 1), v = fr + ni | 0, d = Oi + Fe | 0, Io = v, Ho = v >>> 0 < fr >>> 0 ? d + 1 | 0 : d, d = Gr, v = Ho >>> 20 | 0, Ts = v + zi | 0, po = v >>> 0 > Ts >>> 0 ? d + 1 | 0 : d, v = $i, d = Qe, fr = po >>> 20 | 0, qi = fr + $r | 0, Ti = fr >>> 0 > qi >>> 0 ? v + 1 | 0 : v, v = Ti >>> 20 | 0, ds = v + Dr | 0, fr = v >>> 0 > ds >>> 0 ? d + 1 | 0 : d, d = Fr & 65535, v = fr >>> 20 | 0, Vn = v + dr | 0, ns = v >>> 0 > Vn >>> 0 ? d + 1 | 0 : d, Lo = ts << 1, Bs = wr << 1 | ts >>> 31, Ao = dr, Uo = Fr, ts = we, Ta = Be & 65535, v = js, js = uo & 1048575, d = v + js | 0, Xs = Me + Wo | 0, Fr = Xs >>> 0 < Wo >>> 0 ? d + 1 | 0 : d, Wo = xo & 1048575, d = Wo + ea | 0, wa = Rr + ps | 0, Si = wa >>> 0 < ps >>> 0 ? d + 1 | 0 : d, ps = Xn & 1048575, v = ps + zo | 0, we = Sn, Pa = we + sa | 0, Sn = Pa >>> 0 < sa >>> 0 ? v + 1 | 0 : v, sa = Oo & 1048575, d = sa + df | 0, wr = mi, mi = wr + ta | 0, dr = mi >>> 0 < ta >>> 0 ? d + 1 | 0 : d, va = Be, Be = oi(Be >>> 16 | 0, 0, 977, 1), v = Be + mi | 0, d = dr + Fe | 0, d = v >>> 0 < Be >>> 0 ? d + 1 | 0 : d, Be = v, Mo = d, d = Sn, v = Mo >>> 20 | 0, Go = v + Pa | 0, Oo = v >>> 0 > Go >>> 0 ? d + 1 | 0 : d, d = Si, v = Oo >>> 20 | 0, Xn = v + wa | 0, xo = v >>> 0 > Xn >>> 0 ? d + 1 | 0 : d, v = Fr, d = Ta, uo = xo >>> 20 | 0, yo = uo, uo = uo + Xs | 0, v = yo >>> 0 > uo >>> 0 ? v + 1 | 0 : v, yo = v >>> 20 | 0, Ta = yo, yo = yo + ts | 0, d = Ta >>> 0 > yo >>> 0 ? d + 1 | 0 : d, yo | (uo | (Be | Go | Xn)) | (d | (Mo | Oo | xo | v) & 1048575) ? (Go & (Be ^ 976) & Xn & uo & yo) == -1 ? v = (Oo & (Mo ^ 1) & xo & v & (d ^ 983040)) == 1048575 : v = 0 : v = 1, d = v, ds | (Io | Ts | qi) | Vn | ((po | Ho | Ti | fr) & 1048575 | ns) ? (Ts & (Io ^ 976) & qi & ds & Vn) == -1 ? v = (po & (Ho ^ 1) & Ti & fr & (ns ^ 983040)) == 1048575 : v = 0 : v = 1, Vn = d & v, a[he + 1376 >> 2] = Vn ? Lo : Ao, a[he + 1380 >> 2] = Vn ? Bs : Uo, a[he + 1368 >> 2] = Vn ? Me << 1 : Dr, a[he + 1372 >> 2] = Vn ? js << 1 | Me >>> 31 : Qe, a[he + 1360 >> 2] = Vn ? Rr << 1 : $r, a[he + 1364 >> 2] = Vn ? Wo << 1 | Rr >>> 31 : $i, a[he + 1352 >> 2] = Vn ? we << 1 : zi, a[he + 1356 >> 2] = Vn ? ps << 1 | we >>> 31 : Gr, a[he + 1344 >> 2] = Vn ? wr << 1 : ni, a[he + 1348 >> 2] = Vn ? sa << 1 | wr >>> 31 : Oi, d = a[he + 1420 >> 2] + oa | 0, v = a[he + 1416 >> 2] + _o | 0, d = v >>> 0 < _o >>> 0 ? d + 1 | 0 : d, Me = Vn ? v : ts, a[he + 1416 >> 2] = Me, wr = Vn ? d : va, a[he + 1420 >> 2] = wr, d = a[he + 1412 >> 2] + N2 | 0, v = a[he + 1408 >> 2] + Kn | 0, d = v >>> 0 < Kn >>> 0 ? d + 1 | 0 : d, ds = Vn ? v : Xs, a[he + 1408 >> 2] = ds, ns = Vn ? d : Fr, a[he + 1412 >> 2] = ns, d = a[he + 1404 >> 2] + Je | 0, v = a[he + 1400 >> 2] + In | 0, d = v >>> 0 < In >>> 0 ? d + 1 | 0 : d, Be = Vn ? v : wa, a[he + 1400 >> 2] = Be, we = Vn ? d : Si, a[he + 1404 >> 2] = we, d = a[he + 1396 >> 2] + e | 0, v = a[he + 1392 >> 2] + un | 0, d = v >>> 0 < un >>> 0 ? d + 1 | 0 : d, v = Vn ? v : Pa, a[he + 1392 >> 2] = v, fr = Vn ? d : Sn, a[he + 1396 >> 2] = fr, d = a[he + 1388 >> 2] + qs | 0, Rr = a[he + 1384 >> 2] + ya | 0, d = Rr >>> 0 < ya >>> 0 ? d + 1 | 0 : d, Rr = Vn ? Rr : mi, a[he + 1384 >> 2] = Rr, d = Vn ? d : dr, Dr = d, a[he + 1388 >> 2] = d, Qe = he + 896 | 0, In = Rr << 1, un = d << 1 | Rr >>> 31, Lr(Qe, In, un, 0, 0, ds, ns, 0, 0), Io = fr, Kn = v, v = fr << 1 | v >>> 31, $r = he + 944 | 0, fr = Kn << 1, Lr($r, fr, v, 0, 0, Be, we, 0, 0), $i = he + 832 | 0, Lr($i, Me, wr, 0, 0, Me, wr, 0, 0), zi = he + 816 | 0, Lr(zi, a[he + 832 >> 2], a[he + 836 >> 2], 0, 0, 15632, 16, 0, 0), ni = he + 784 | 0, Gr = Me << 1, _o = wr << 1 | Me >>> 31, Lr(ni, Gr, _o, 0, 0, Rr, d, 0, 0), Oi = he + 880 | 0, Lr(Oi, fr, v, 0, 0, ds, ns, 0, 0), qi = he + 928 | 0, Lr(qi, Be, we, 0, 0, Be, we, 0, 0), Ti = he + 800 | 0, d = $i + 8 | 0, Lr(Ti, a[d >> 2], a[d + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Go = he + 992 | 0, Lr(Go, Rr, Dr, 0, 0, Rr, Dr, 0, 0), Mo = he + 768 | 0, Lr(Mo, Gr, _o, 0, 0, Kn, Io, 0, 0), Ho = we, ya = Be, v = we << 1 | Be >>> 31, Oo = he + 864 | 0, Lr(Oo, Be << 1, v, 0, 0, ds, ns, 0, 0), Rr = a[he + 896 >> 2], Be = a[he + 944 >> 2], v = Rr + Be | 0, fr = a[he + 900 >> 2], d = fr + a[he + 948 >> 2] | 0, Be = v >>> 0 < Be >>> 0 ? d + 1 | 0 : d, d = Be + a[he + 820 >> 2] | 0, we = v, Me = a[he + 816 >> 2], v = v + Me | 0, Ts = v, v = v >>> 0 < Me >>> 0 ? d + 1 | 0 : d, Me = (Be | 0) == (v | 0) & we >>> 0 > Ts >>> 0 | v >>> 0 < Be >>> 0, d = zi + 8 | 0, wr = a[d >> 2], Dr = a[d + 4 >> 2], we = (Be | 0) == (fr | 0) & we >>> 0 < Rr >>> 0 | Be >>> 0 < fr >>> 0, d = $r + 8 | 0, fr = a[d >> 2], Rr = Qe + 8 | 0, Be = fr + a[Rr >> 2] | 0, d = a[Rr + 4 >> 2] + a[d + 4 >> 2] | 0, d = Be >>> 0 < fr >>> 0 ? d + 1 | 0 : d, fr = Be, Be = we + Be | 0, d = (fr >>> 0 > Be >>> 0 ? d + 1 | 0 : d) + Dr | 0, we = Be, Be = Be + wr | 0, d = we >>> 0 > Be >>> 0 ? d + 1 | 0 : d, we = Be, Be = Be + Me | 0, we = we >>> 0 > Be >>> 0 ? d + 1 | 0 : d, fr = we << 12 | Be >>> 20, po = v, Be = Be << 12 | v >>> 20, Rr = fr, $i = a[he + 880 >> 2], fr = a[he + 928 >> 2], d = $i + fr | 0, $r = a[he + 884 >> 2], v = $r + a[he + 932 >> 2] | 0, Me = d >>> 0 < fr >>> 0 ? v + 1 | 0 : v, wr = d, fr = a[he + 784 >> 2], v = d + fr | 0, d = Me + a[he + 788 >> 2] | 0, d = v >>> 0 < fr >>> 0 ? d + 1 | 0 : d, Dr = v, Qe = a[he + 800 >> 2], v = v + Qe | 0, fr = d, d = d + a[he + 804 >> 2] | 0, d = v >>> 0 < Qe >>> 0 ? d + 1 | 0 : d, Qe = v, v = d + Rr | 0, Xn = he + 752 | 0, zi = Xn, Rr = Be + Qe | 0, Be = Rr >>> 0 < Qe >>> 0 ? v + 1 | 0 : v, xo = (d | 0) == (Be | 0) & Rr >>> 0 < Qe >>> 0 | d >>> 0 > Be >>> 0, Qe = (d | 0) == (fr | 0) & Dr >>> 0 > Qe >>> 0 | d >>> 0 < fr >>> 0, d = Ti + 8 | 0, Ti = a[d >> 2], uo = a[d + 4 >> 2], fr = (Me | 0) == (fr | 0) & wr >>> 0 > Dr >>> 0 | Me >>> 0 > fr >>> 0, d = ni + 8 | 0, Dr = a[d >> 2], ni = a[d + 4 >> 2], Me = (Me | 0) == ($r | 0) & wr >>> 0 < $i >>> 0 | Me >>> 0 < $r >>> 0, d = qi + 8 | 0, wr = a[d >> 2], $r = Oi + 8 | 0, v = wr + a[$r >> 2] | 0, d = a[$r + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 < wr >>> 0 ? d + 1 | 0 : d, wr = v, v = v + Me | 0, d = (wr >>> 0 > v >>> 0 ? d + 1 | 0 : d) + ni | 0, Me = v, v = v + Dr | 0, d = Me >>> 0 > v >>> 0 ? d + 1 | 0 : d, fr = v + fr | 0, v = (fr >>> 0 < v >>> 0 ? d + 1 | 0 : d) + uo | 0, d = fr, fr = fr + Ti | 0, d = d >>> 0 > fr >>> 0 ? v + 1 | 0 : v, v = fr + Qe | 0, d = v >>> 0 < fr >>> 0 ? d + 1 | 0 : d, we = we >>> 20 | 0, v = v + we | 0, d = we >>> 0 > v >>> 0 ? d + 1 | 0 : d, we = v, v = v + xo | 0, we = we >>> 0 > v >>> 0 ? d + 1 | 0 : d, fr = we << 12 | v >>> 20, wr = v << 12 | Be >>> 20, d = fr, ni = a[he + 768 >> 2], fr = a[he + 864 >> 2], Me = ni + fr | 0, Qe = a[he + 772 >> 2], v = Qe + a[he + 868 >> 2] | 0, fr = Me >>> 0 < fr >>> 0 ? v + 1 | 0 : v, d = fr + d | 0, wr = Me + wr | 0, v = wr >>> 0 < Me >>> 0 ? d + 1 | 0 : d, Dr = wr, d = v << 4 | wr >>> 28, qi = Be, Lr(zi, Be >>> 16 & 15 | wr << 4 & -16, d & 16777215, 0, 0, 977, 1, 0, 0), $r = a[he + 756 >> 2], d = $r + a[he + 996 >> 2] | 0, Oi = a[he + 752 >> 2], Be = a[he + 992 >> 2], wr = Oi + Be | 0, $i = wr, a[he + 1464 >> 2] = wr, Be = Be >>> 0 > wr >>> 0 ? d + 1 | 0 : d, zi = Be & 1048575, a[he + 1468 >> 2] = zi, xo = he + 976 | 0, Lr(xo, In, un, 0, 0, Kn, Io, 0, 0), uo = he + 720 | 0, Lr(uo, Gr, _o, 0, 0, ya, Ho, 0, 0), yo = he + 848 | 0, Lr(yo, ds, ns, 0, 0, ds, ns, 0, 0), oa = he + 704 | 0, Dr = (v | 0) == (fr | 0) & Me >>> 0 > Dr >>> 0 | v >>> 0 < fr >>> 0, Me = (fr | 0) == (Qe | 0) & Me >>> 0 < ni >>> 0 | fr >>> 0 < Qe >>> 0, d = Oo + 8 | 0, Qe = a[d >> 2], ni = Mo + 8 | 0, fr = Qe + a[ni >> 2] | 0, d = a[ni + 4 >> 2] + a[d + 4 >> 2] | 0, d = fr >>> 0 < Qe >>> 0 ? d + 1 | 0 : d, Qe = fr, fr = Me + fr | 0, d = Qe >>> 0 > fr >>> 0 ? d + 1 | 0 : d, we = we >>> 20 | 0, Me = we, we = we + fr | 0, d = Me >>> 0 > we >>> 0 ? d + 1 | 0 : d, fr = we, we = we + Dr | 0, fr = fr >>> 0 > we >>> 0 ? d + 1 | 0 : d, Me = fr << 12 | we >>> 20, v = we << 12 | v >>> 20, we = Me, Oo = a[he + 720 >> 2], Me = a[he + 848 >> 2], ni = Oo + Me | 0, Mo = a[he + 724 >> 2], d = Mo + a[he + 852 >> 2] | 0, Me = Me >>> 0 > ni >>> 0 ? d + 1 | 0 : d, d = Me + we | 0, v = v + ni | 0, d = v >>> 0 < ni >>> 0 ? d + 1 | 0 : d, Ti = v, we = d, Lr(oa, v, d & 1048575, 0, 0, 15632, 16, 0, 0), wr = (Be | 0) == ($r | 0) & wr >>> 0 < Oi >>> 0 | Be >>> 0 < $r >>> 0, d = Go + 8 | 0, Dr = a[d >> 2], Qe = Xn + 8 | 0, v = Dr + a[Qe >> 2] | 0, d = a[Qe + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 < Dr >>> 0 ? d + 1 | 0 : d, Dr = v, v = v + wr | 0, wr = Dr >>> 0 > v >>> 0 ? d + 1 | 0 : d, Dr = wr << 12 | v >>> 20, Be = v << 12 | Be >>> 20, d = Dr, Xn = a[he + 704 >> 2], Dr = a[he + 976 >> 2], Oi = Xn + Dr | 0, Go = a[he + 708 >> 2], v = Go + a[he + 980 >> 2] | 0, Dr = Dr >>> 0 > Oi >>> 0 ? v + 1 | 0 : v, d = Dr + d | 0, v = Be + Oi | 0, d = v >>> 0 < Oi >>> 0 ? d + 1 | 0 : d, Qe = v, a[he + 1472 >> 2] = v, Be = d, $r = d & 1048575, a[he + 1476 >> 2] = $r, Lo = he + 912 | 0, Lr(Lo, In, un, 0, 0, ya, Ho, 0, 0), ya = he + 960 | 0, Lr(ya, Kn, Io, 0, 0, Kn, Io, 0, 0), Io = he + 656 | 0, Lr(Io, Gr, _o, 0, 0, ds, ns, 0, 0), _o = he + 640 | 0, Gr = _o, un = (we | 0) == (Me | 0) & ni >>> 0 > Ti >>> 0 | we >>> 0 < Me >>> 0, Me = (Me | 0) == (Mo | 0) & ni >>> 0 < Oo >>> 0 | Me >>> 0 < Mo >>> 0, d = yo + 8 | 0, ni = a[d >> 2], In = uo + 8 | 0, v = ni + a[In >> 2] | 0, d = a[In + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 < ni >>> 0 ? d + 1 | 0 : d, ni = v, v = v + Me | 0, d = ni >>> 0 > v >>> 0 ? d + 1 | 0 : d, Me = v, fr = fr >>> 20 | 0, v = fr, fr = Me + fr | 0, d = v >>> 0 > fr >>> 0 ? d + 1 | 0 : d, v = fr + un | 0, fr = v >>> 0 < fr >>> 0 ? d + 1 | 0 : d, d = fr << 12 | v >>> 20, Ho = v << 12 | we >>> 20, Me = a[he + 656 >> 2], we = Ho + Me | 0, In = d, d = d + a[he + 660 >> 2] | 0, un = we, ni = we >>> 0 < Me >>> 0 ? d + 1 | 0 : d, Lr(Gr, we, ni, 0, 0, 15632, 16, 0, 0), Gr = (Be | 0) == (Dr | 0) & Qe >>> 0 < Oi >>> 0 | Be >>> 0 < Dr >>> 0, we = (Dr | 0) == (Go | 0) & Oi >>> 0 < Xn >>> 0 | Dr >>> 0 < Go >>> 0, d = xo + 8 | 0, Me = a[d >> 2], Dr = oa + 8 | 0, v = Me + a[Dr >> 2] | 0, d = a[Dr + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 < Me >>> 0 ? d + 1 | 0 : d, Me = v, v = v + we | 0, d = Me >>> 0 > v >>> 0 ? d + 1 | 0 : d, we = v, Me = wr >>> 20 | 0, we = we + Me | 0, d = Me >>> 0 > we >>> 0 ? d + 1 | 0 : d, v = we + Gr | 0, we = v >>> 0 < we >>> 0 ? d + 1 | 0 : d, d = we << 12 | v >>> 20, Be = v << 12 | Be >>> 20, wr = d, Ti = a[he + 912 >> 2], Me = a[he + 960 >> 2], v = Ti + Me | 0, Kn = a[he + 916 >> 2], d = Kn + a[he + 964 >> 2] | 0, d = v >>> 0 < Me >>> 0 ? d + 1 | 0 : d, Oi = v, v = a[he + 640 >> 2], Gr = Oi + v | 0, Dr = d, d = d + a[he + 644 >> 2] | 0, v = v >>> 0 > Gr >>> 0 ? d + 1 | 0 : d, d = v + wr | 0, Me = Be + Gr | 0, d = Me >>> 0 < Gr >>> 0 ? d + 1 | 0 : d, a[he + 1480 >> 2] = Me, Be = d, wr = d & 1048575, a[he + 1484 >> 2] = wr, ds = he + 576 | 0, ni = (ni | 0) == (In | 0) & un >>> 0 < Ho >>> 0 | ni >>> 0 < In >>> 0, d = Io + 8 | 0, un = a[d >> 2], d = a[d + 4 >> 2], fr = fr >>> 20 | 0, In = fr, fr = fr + un | 0, d = In >>> 0 > fr >>> 0 ? d + 1 | 0 : d, un = fr, fr = fr + ni | 0, d = un >>> 0 > fr >>> 0 ? d + 1 | 0 : d, Lr(ds, fr, d, 0, 0, 64028672, 65536, 0, 0), ni = (v | 0) == (Be | 0) & Me >>> 0 < Gr >>> 0 | v >>> 0 > Be >>> 0, Gr = (v | 0) == (Dr | 0) & Gr >>> 0 < Oi >>> 0 | v >>> 0 < Dr >>> 0, d = _o + 8 | 0, un = a[d >> 2], In = a[d + 4 >> 2], Dr = (Dr | 0) == (Kn | 0) & Oi >>> 0 < Ti >>> 0 | Dr >>> 0 < Kn >>> 0, d = ya + 8 | 0, v = a[d >> 2], Oi = Lo + 8 | 0, fr = v + a[Oi >> 2] | 0, d = a[Oi + 4 >> 2] + a[d + 4 >> 2] | 0, v = v >>> 0 > fr >>> 0 ? d + 1 | 0 : d, d = fr, fr = fr + Dr | 0, d = (d >>> 0 > fr >>> 0 ? v + 1 | 0 : v) + In | 0, v = fr + un | 0, d = v >>> 0 < fr >>> 0 ? d + 1 | 0 : d, fr = v, v = v + Gr | 0, d = fr >>> 0 > v >>> 0 ? d + 1 | 0 : d, we = we >>> 20 | 0, v = we + v | 0, d = we >>> 0 > v >>> 0 ? d + 1 | 0 : d, we = v, v = v + ni | 0, we = we >>> 0 > v >>> 0 ? d + 1 | 0 : d, d = v, v = we << 12 | d >>> 20, Be = d << 12 | Be >>> 20, fr = v, ni = a[he + 576 >> 2], Gr = ni + (Ts & -2) | 0, Oi = a[he + 580 >> 2], d = Oi + (po & 1048575) | 0, v = Gr >>> 0 < ni >>> 0 ? d + 1 | 0 : d, d = v + fr | 0, Be = Be + Gr | 0, d = Be >>> 0 < Gr >>> 0 ? d + 1 | 0 : d, a[he + 1488 >> 2] = Be, fr = d, Dr = d & 1048575, a[he + 1492 >> 2] = Dr, un = qi & 65535, In = (d | 0) == (v | 0) & Be >>> 0 < Gr >>> 0 | d >>> 0 < v >>> 0, Gr = (v | 0) == (Oi | 0) & Gr >>> 0 < ni >>> 0 | v >>> 0 < Oi >>> 0, v = ds + 8 | 0, d = Gr + a[v >> 2] | 0, v = a[v + 4 >> 2], v = d >>> 0 < Gr >>> 0 ? v + 1 | 0 : v, Gr = d, d = v, we = we >>> 20 | 0, v = we + Gr | 0, d = we >>> 0 > v >>> 0 ? d + 1 | 0 : d, we = v, v = v + In | 0, d = un + ((we >>> 0 > v >>> 0 ? d + 1 | 0 : d) << 12 | v >>> 20) | 0, v = v << 12 | fr >>> 20, we = v + Rr | 0, a[he + 1496 >> 2] = we, v = v >>> 0 > we >>> 0 ? d + 1 | 0 : d, a[he + 1500 >> 2] = v, d = a[he + 1544 >> 2], fr = -5862 - d | 0, d = 6291449 - (a[he + 1548 >> 2] + (d >>> 0 > 4294961434) | 0) | 0, a[he + 1424 >> 2] = fr, a[he + 1428 >> 2] = d, d = a[Aa >> 2], fr = -6 - d | 0, d = 6291455 - (a[Aa + 4 >> 2] + (d >>> 0 > 4294967290) | 0) | 0, a[he + 1432 >> 2] = fr, a[he + 1436 >> 2] = d, d = a[zs >> 2], fr = -6 - d | 0, d = 6291455 - (a[zs + 4 >> 2] + (d >>> 0 > 4294967290) | 0) | 0, a[he + 1440 >> 2] = fr, a[he + 1444 >> 2] = d, d = a[x2 >> 2], fr = -6 - d | 0, d = 6291455 - (a[x2 + 4 >> 2] + (d >>> 0 > 4294967290) | 0) | 0, a[he + 1448 >> 2] = fr, a[he + 1452 >> 2] = d, d = a[jn >> 2], fr = -6 - d | 0, d = 393215 - (a[jn + 4 >> 2] + (d >>> 0 > 4294967290) | 0) | 0, a[he + 1456 >> 2] = fr, a[he + 1460 >> 2] = d, Gr = zi, d = Gr << 1 | $i >>> 31, ya = he + 528 | 0, fr = Dr, zi = $i << 1, Dr = d, Lr(ya, Be, fr, 0, 0, zi, d, 0, 0), Io = he + 592 | 0, Rr = Me, Me = wr, un = Qe << 1, Oi = $r, ni = $r << 1 | Qe >>> 31, Lr(Io, Rr, Me, 0, 0, un, ni, 0, 0), In = he + 496 | 0, Lr(In, we, v, 0, 0, we, v, 0, 0), Ho = he + 480 | 0, Lr(Ho, a[he + 496 >> 2], a[he + 500 >> 2], 0, 0, 15632, 16, 0, 0), Ts = he + 448 | 0, wr = we << 1, $r = v << 1 | we >>> 31, Lr(Ts, wr, $r, 0, 0, $i, Gr, 0, 0), po = he + 544 | 0, Lr(po, Be, fr, 0, 0, un, ni, 0, 0), qi = he + 608 | 0, Lr(qi, Rr, Me, 0, 0, Rr, Me, 0, 0), Ti = he + 464 | 0, d = In + 8 | 0, Lr(Ti, a[d >> 2], a[d + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), ds = he + 736 | 0, Lr(ds, $i, Gr, 0, 0, $i, Gr, 0, 0), ns = he + 432 | 0, Lr(ns, wr, $r, 0, 0, Qe, Oi, 0, 0), Mo = he + 512 | 0, un = Be, In = fr, Kn = Me, $i = Rr, Lr(Mo, Be, fr, 0, 0, Rr << 1, Me << 1 | Rr >>> 31, 0, 0), Rr = a[he + 528 >> 2], Be = a[he + 592 >> 2], v = Rr + Be | 0, fr = a[he + 532 >> 2], d = fr + a[he + 596 >> 2] | 0, d = v >>> 0 < Be >>> 0 ? d + 1 | 0 : d, we = v, Me = a[he + 480 >> 2], Be = v + Me | 0, v = d + a[he + 484 >> 2] | 0, _o = Be, Be = Be >>> 0 < Me >>> 0 ? v + 1 | 0 : v, Me = (d | 0) == (Be | 0) & we >>> 0 > _o >>> 0 | d >>> 0 > Be >>> 0, v = Ho + 8 | 0, Gr = a[v >> 2], ni = a[v + 4 >> 2], we = (d | 0) == (fr | 0) & we >>> 0 < Rr >>> 0 | d >>> 0 < fr >>> 0, d = Io + 8 | 0, fr = a[d >> 2], Rr = ya + 8 | 0, v = fr + a[Rr >> 2] | 0, d = a[Rr + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 < fr >>> 0 ? d + 1 | 0 : d, we = v + we | 0, v = (we >>> 0 < v >>> 0 ? d + 1 | 0 : d) + ni | 0, d = we, we = we + Gr | 0, d = d >>> 0 > we >>> 0 ? v + 1 | 0 : v, v = we + Me | 0, we = v >>> 0 < we >>> 0 ? d + 1 | 0 : d, d = we << 12 | v >>> 20, ya = Be, Io = v << 12 | Be >>> 20, Go = d, Oo = a[he + 544 >> 2], Be = a[he + 608 >> 2], v = Oo + Be | 0, Ho = a[he + 548 >> 2], d = Ho + a[he + 612 >> 2] | 0, d = v >>> 0 < Be >>> 0 ? d + 1 | 0 : d, Me = v, v = a[he + 448 >> 2], Be = Me + v | 0, Rr = d, d = d + a[he + 452 >> 2] | 0, d = v >>> 0 > Be >>> 0 ? d + 1 | 0 : d, Gr = Be, fr = a[he + 464 >> 2], Be = Be + fr | 0, v = d, d = d + a[he + 468 >> 2] | 0, fr = Be >>> 0 < fr >>> 0 ? d + 1 | 0 : d, d = fr + Go | 0, Go = he + 416 | 0, ni = Be, Io = Be + Io | 0, Be = Be >>> 0 > Io >>> 0 ? d + 1 | 0 : d, d = fr, fr = Io, Io = (Be | 0) == (d | 0) & ni >>> 0 > fr >>> 0 | d >>> 0 > Be >>> 0, ni = (d | 0) == (v | 0) & Gr >>> 0 > ni >>> 0 | d >>> 0 < v >>> 0, d = Ti + 8 | 0, Ti = a[d >> 2], Xn = a[d + 4 >> 2], Gr = (v | 0) == (Rr | 0) & Me >>> 0 > Gr >>> 0 | v >>> 0 < Rr >>> 0, d = Ts + 8 | 0, Ts = a[d >> 2], xo = a[d + 4 >> 2], Me = (Rr | 0) == (Ho | 0) & Me >>> 0 < Oo >>> 0 | Rr >>> 0 < Ho >>> 0, d = qi + 8 | 0, v = a[d >> 2], Ho = po + 8 | 0, Rr = v + a[Ho >> 2] | 0, d = a[Ho + 4 >> 2] + a[d + 4 >> 2] | 0, v = v >>> 0 > Rr >>> 0 ? d + 1 | 0 : d, d = Rr, Rr = Me + Rr | 0, d = (d >>> 0 > Rr >>> 0 ? v + 1 | 0 : v) + xo | 0, v = Rr + Ts | 0, d = v >>> 0 < Rr >>> 0 ? d + 1 | 0 : d, Me = v, v = v + Gr | 0, d = (Me >>> 0 > v >>> 0 ? d + 1 | 0 : d) + Xn | 0, Me = v, v = v + Ti | 0, d = Me >>> 0 > v >>> 0 ? d + 1 | 0 : d, Me = v, v = v + ni | 0, d = Me >>> 0 > v >>> 0 ? d + 1 | 0 : d, Rr = v, we = we >>> 20 | 0, v = we, we = we + Rr | 0, d = v >>> 0 > we >>> 0 ? d + 1 | 0 : d, v = we + Io | 0, we = v >>> 0 < we >>> 0 ? d + 1 | 0 : d, d = we << 12 | v >>> 20, Rr = Be, Be = v << 12 | Be >>> 20, Io = d, Ho = a[he + 432 >> 2], v = a[he + 512 >> 2], Me = Ho + v | 0, ni = a[he + 436 >> 2], d = ni + a[he + 516 >> 2] | 0, v = v >>> 0 > Me >>> 0 ? d + 1 | 0 : d, d = v + Io | 0, Gr = Be + Me | 0, d = Gr >>> 0 < Me >>> 0 ? d + 1 | 0 : d, Ts = Gr << 4 & -16, Io = Rr, Be = d, Lr(Go, Ts | Rr >>> 16 & 15, (d << 4 | Gr >>> 28) & 16777215, 0, 0, 977, 1, 0, 0), Oo = he + 672 | 0, Lr(Oo, Qe, Oi, 0, 0, zi, Dr, 0, 0), Ts = he + 400 | 0, Lr(Ts, wr, $r, 0, 0, $i, Kn, 0, 0), po = he + 560 | 0, Lr(po, un, In, 0, 0, un, In, 0, 0), oa = he + 384 | 0, qi = oa, Gr = (v | 0) == (d | 0) & Me >>> 0 > Gr >>> 0 | v >>> 0 > d >>> 0, Me = (v | 0) == (ni | 0) & Me >>> 0 < Ho >>> 0 | v >>> 0 < ni >>> 0, d = Mo + 8 | 0, v = a[d >> 2], ni = ns + 8 | 0, Rr = v + a[ni >> 2] | 0, d = a[ni + 4 >> 2] + a[d + 4 >> 2] | 0, v = v >>> 0 > Rr >>> 0 ? d + 1 | 0 : d, d = Me + Rr | 0, v = d >>> 0 < Rr >>> 0 ? v + 1 | 0 : v, Rr = d, d = v, we = we >>> 20 | 0, v = we + Rr | 0, d = we >>> 0 > v >>> 0 ? d + 1 | 0 : d, we = v, v = v + Gr | 0, we = we >>> 0 > v >>> 0 ? d + 1 | 0 : d, Rr = we << 12 | v >>> 20, Be = v << 12 | Be >>> 20, Me = Rr, ni = a[he + 400 >> 2], Rr = a[he + 560 >> 2], v = ni + Rr | 0, Gr = a[he + 404 >> 2], d = Gr + a[he + 564 >> 2] | 0, d = v >>> 0 < Rr >>> 0 ? d + 1 | 0 : d, Rr = v, v = d + Me | 0, Be = Be + Rr | 0, v = Be >>> 0 < Rr >>> 0 ? v + 1 | 0 : v, Me = Be, Be = v, Lr(qi, Me, v & 1048575, 0, 0, 15632, 16, 0, 0), ns = he + 624 | 0, Lr(ns, $i, Kn, 0, 0, zi, Dr, 0, 0), Mo = he + 688 | 0, Lr(Mo, Qe, Oi, 0, 0, Qe, Oi, 0, 0), Dr = he + 368 | 0, Lr(Dr, wr, $r, 0, 0, un, In, 0, 0), Lo = he + 352 | 0, wr = Lo, Me = (d | 0) == (v | 0) & Me >>> 0 < Rr >>> 0 | d >>> 0 > v >>> 0, Rr = (d | 0) == (Gr | 0) & Rr >>> 0 < ni >>> 0 | d >>> 0 < Gr >>> 0, d = po + 8 | 0, Qe = a[d >> 2], $r = Ts + 8 | 0, v = Qe + a[$r >> 2] | 0, d = a[$r + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 < Qe >>> 0 ? d + 1 | 0 : d, Qe = v, v = v + Rr | 0, d = Qe >>> 0 > v >>> 0 ? d + 1 | 0 : d, Rr = v, we = we >>> 20 | 0, v = we, we = we + Rr | 0, d = v >>> 0 > we >>> 0 ? d + 1 | 0 : d, v = we + Me | 0, we = v >>> 0 < we >>> 0 ? d + 1 | 0 : d, d = we << 12 | v >>> 20, Rr = v << 12 | Be >>> 20, Me = a[he + 368 >> 2], Be = Rr + Me | 0, v = d, d = d + a[he + 372 >> 2] | 0, d = Be >>> 0 < Me >>> 0 ? d + 1 | 0 : d, Lr(wr, Be, d, 0, 0, 15632, 16, 0, 0), ps = he + 336 | 0, Me = ps, Rr = (d | 0) == (v | 0) & Be >>> 0 < Rr >>> 0 | d >>> 0 < v >>> 0, d = Dr + 8 | 0, wr = a[d >> 2], d = a[d + 4 >> 2], Be = we >>> 20 | 0, v = Be + wr | 0, d = Be >>> 0 > v >>> 0 ? d + 1 | 0 : d, we = v, v = v + Rr | 0, d = we >>> 0 > v >>> 0 ? d + 1 | 0 : d, Lr(Me, v, d, 0, 0, 64028672, 65536, 0, 0), d = he + 1424 | 0, gn(d, d, he + 1464 | 0), d = a[he + 1348 >> 2], Gr = d, ni = a[he + 1344 >> 2], we = ni, d = d << 1 | we >>> 31, Oi = he - -64 | 0, v = a[he + 1368 >> 2], Be = a[he + 1372 >> 2], $r = we << 1, Qe = d, Lr(Oi, v, Be, 0, 0, $r, d, 0, 0), d = a[he + 1356 >> 2], po = d, qi = a[he + 1352 >> 2], Me = qi, d = d << 1 | Me >>> 31, Ts = he + 272 | 0, we = a[he + 1360 >> 2], Rr = a[he + 1364 >> 2], zi = Me << 1, wr = d, Lr(Ts, we, Rr, 0, 0, zi, d, 0, 0), un = he + 224 | 0, d = a[he + 1376 >> 2], Me = a[he + 1380 >> 2], Lr(un, d, Me, 0, 0, d, Me, 0, 0), Ti = he + 208 | 0, Lr(Ti, a[he + 224 >> 2], a[he + 228 >> 2], 0, 0, 15632, 16, 0, 0), Dr = Me << 1, Me = d, d = Dr | d >>> 31, Xn = he + 176 | 0, Dr = Me << 1, $i = d, Lr(Xn, Dr, d, 0, 0, ni, Gr, 0, 0), xo = he + 80 | 0, Lr(xo, v, Be, 0, 0, zi, wr, 0, 0), uo = he + 256 | 0, Lr(uo, we, Rr, 0, 0, we, Rr, 0, 0), yo = he + 192 | 0, d = un + 8 | 0, Lr(yo, a[d >> 2], a[d + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Bs = he + 320 | 0, Lr(Bs, ni, Gr, 0, 0, ni, Gr, 0, 0), Ao = he + 160 | 0, Lr(Ao, Dr, $i, 0, 0, qi, po, 0, 0), Uo = he + 96 | 0, un = v, In = Be, Kn = Rr, zi = we, Lr(Uo, v, Be, 0, 0, we << 1, Rr << 1 | we >>> 31, 0, 0), wr = a[he + 64 >> 2], Be = a[he + 272 >> 2], v = wr + Be | 0, Me = a[he + 68 >> 2], d = Me + a[he + 276 >> 2] | 0, d = v >>> 0 < Be >>> 0 ? d + 1 | 0 : d, we = v, v = a[he + 208 >> 2], Rr = we + v | 0, Be = d, d = d + a[he + 212 >> 2] | 0, v = v >>> 0 > Rr >>> 0 ? d + 1 | 0 : d, Ho = Rr, Rr = (Be | 0) == (v | 0) & Rr >>> 0 < we >>> 0 | v >>> 0 < Be >>> 0, d = Ti + 8 | 0, Gr = a[d >> 2], ni = a[d + 4 >> 2], we = (Be | 0) == (Me | 0) & we >>> 0 < wr >>> 0 | Be >>> 0 < Me >>> 0, d = Ts + 8 | 0, Me = a[d >> 2], wr = Oi + 8 | 0, Be = Me + a[wr >> 2] | 0, d = a[wr + 4 >> 2] + a[d + 4 >> 2] | 0, d = Be >>> 0 < Me >>> 0 ? d + 1 | 0 : d, Me = Be, Be = we + Be | 0, d = (Me >>> 0 > Be >>> 0 ? d + 1 | 0 : d) + ni | 0, we = Be, Be = Be + Gr | 0, d = we >>> 0 > Be >>> 0 ? d + 1 | 0 : d, we = Be, Be = Be + Rr | 0, we = we >>> 0 > Be >>> 0 ? d + 1 | 0 : d, Rr = we << 12 | Be >>> 20, Ts = v, Be = Be << 12 | v >>> 20, js = a[he + 80 >> 2], Me = a[he + 256 >> 2], v = js + Me | 0, Ti = a[he + 84 >> 2], d = Ti + a[he + 260 >> 2] | 0, d = v >>> 0 < Me >>> 0 ? d + 1 | 0 : d, Gr = v, wr = a[he + 176 >> 2], v = v + wr | 0, Me = d, d = d + a[he + 180 >> 2] | 0, d = v >>> 0 < wr >>> 0 ? d + 1 | 0 : d, ni = v, Oi = a[he + 192 >> 2], v = v + Oi | 0, wr = d, d = d + a[he + 196 >> 2] | 0, d = v >>> 0 < Oi >>> 0 ? d + 1 | 0 : d, Oi = v, v = d, d = d + Rr | 0, Rr = Be + Oi | 0, Be = Rr >>> 0 < Oi >>> 0 ? d + 1 | 0 : d, Wo = (v | 0) == (Be | 0) & Rr >>> 0 < Oi >>> 0 | v >>> 0 > Be >>> 0, Oi = (v | 0) == (wr | 0) & ni >>> 0 > Oi >>> 0 | v >>> 0 < wr >>> 0, d = yo + 8 | 0, yo = a[d >> 2], sa = a[d + 4 >> 2], wr = (Me | 0) == (wr | 0) & Gr >>> 0 > ni >>> 0 | Me >>> 0 > wr >>> 0, d = Xn + 8 | 0, ni = a[d >> 2], Xn = a[d + 4 >> 2], Me = (Me | 0) == (Ti | 0) & Gr >>> 0 < js >>> 0 | Me >>> 0 < Ti >>> 0, d = uo + 8 | 0, Gr = a[d >> 2], Ti = xo + 8 | 0, v = Gr + a[Ti >> 2] | 0, d = a[Ti + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 < Gr >>> 0 ? d + 1 | 0 : d, Gr = v, v = v + Me | 0, d = (Gr >>> 0 > v >>> 0 ? d + 1 | 0 : d) + Xn | 0, Me = v + ni | 0, v = Me >>> 0 < v >>> 0 ? d + 1 | 0 : d, d = Me, Me = Me + wr | 0, d = (d >>> 0 > Me >>> 0 ? v + 1 | 0 : v) + sa | 0, v = Me + yo | 0, d = v >>> 0 < Me >>> 0 ? d + 1 | 0 : d, Me = v, v = v + Oi | 0, d = Me >>> 0 > v >>> 0 ? d + 1 | 0 : d, we = we >>> 20 | 0, v = we + v | 0, d = we >>> 0 > v >>> 0 ? d + 1 | 0 : d, we = v, v = v + Wo | 0, we = we >>> 0 > v >>> 0 ? d + 1 | 0 : d, d = v, wr = we << 12 | d >>> 20, v = Be, Gr = d << 12 | v >>> 20, Ti = a[he + 160 >> 2], Me = a[he + 96 >> 2], Be = Ti + Me | 0, Oi = a[he + 164 >> 2], d = Oi + a[he + 100 >> 2] | 0, Me = Be >>> 0 < Me >>> 0 ? d + 1 | 0 : d, d = Me + wr | 0, wr = Be, Gr = Be + Gr | 0, d = Be >>> 0 > Gr >>> 0 ? d + 1 | 0 : d, Xn = Gr << 4 & -16, ni = v, Be = d, Lr(he, Xn | v >>> 16 & 15, (d << 4 | Gr >>> 28) & 16777215, 0, 0, 977, 1, 0, 0), uo = he + 304 | 0, Lr(uo, qi, po, 0, 0, $r, Qe, 0, 0), Xn = he + 144 | 0, Lr(Xn, Dr, $i, 0, 0, zi, Kn, 0, 0), xo = he + 112 | 0, Lr(xo, un, In, 0, 0, un, In, 0, 0), yo = he + 48 | 0, Gr = (d | 0) == (Me | 0) & wr >>> 0 > Gr >>> 0 | d >>> 0 < Me >>> 0, wr = (Me | 0) == (Oi | 0) & wr >>> 0 < Ti >>> 0 | Me >>> 0 < Oi >>> 0, d = Uo + 8 | 0, Oi = a[d >> 2], v = Ao + 8 | 0, Me = Oi + a[v >> 2] | 0, v = a[v + 4 >> 2] + a[d + 4 >> 2] | 0, d = Me >>> 0 < Oi >>> 0 ? v + 1 | 0 : v, v = Me + wr | 0, d = v >>> 0 < Me >>> 0 ? d + 1 | 0 : d, we = we >>> 20 | 0, v = v + we | 0, d = we >>> 0 > v >>> 0 ? d + 1 | 0 : d, we = v, v = v + Gr | 0, we = we >>> 0 > v >>> 0 ? d + 1 | 0 : d, Me = we << 12 | v >>> 20, Be = v << 12 | Be >>> 20, d = Me, Oi = a[he + 144 >> 2], wr = a[he + 112 >> 2], Me = Oi + wr | 0, Gr = a[he + 148 >> 2], v = Gr + a[he + 116 >> 2] | 0, v = Me >>> 0 < wr >>> 0 ? v + 1 | 0 : v, d = v + d | 0, Be = Be + Me | 0, d = Be >>> 0 < Me >>> 0 ? d + 1 | 0 : d, wr = Be, Be = d, Lr(yo, wr, d & 1048575, 0, 0, 15632, 16, 0, 0), Ti = he + 240 | 0, Lr(Ti, zi, Kn, 0, 0, $r, Qe, 0, 0), Ao = he + 288 | 0, Lr(Ao, qi, po, 0, 0, qi, po, 0, 0), Qe = he + 128 | 0, Lr(Qe, Dr, $i, 0, 0, un, In, 0, 0), qi = he + 32 | 0, Dr = qi, wr = (d | 0) == (v | 0) & Me >>> 0 > wr >>> 0 | d >>> 0 < v >>> 0, Me = (v | 0) == (Gr | 0) & Me >>> 0 < Oi >>> 0 | v >>> 0 < Gr >>> 0, d = xo + 8 | 0, $r = a[d >> 2], $i = Xn + 8 | 0, v = $r + a[$i >> 2] | 0, d = a[$i + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 < $r >>> 0 ? d + 1 | 0 : d, Gr = v, v = v + Me | 0, d = Gr >>> 0 > v >>> 0 ? d + 1 | 0 : d, we = we >>> 20 | 0, Me = we, we = v + we | 0, v = Me >>> 0 > we >>> 0 ? d + 1 | 0 : d, d = we + wr | 0, v = d >>> 0 < we >>> 0 ? v + 1 | 0 : v, Me = v << 12 | d >>> 20, wr = d << 12 | Be >>> 20, $r = a[he + 128 >> 2], Be = wr + $r | 0, we = Me, d = we + a[he + 132 >> 2] | 0, d = Be >>> 0 < $r >>> 0 ? d + 1 | 0 : d, Lr(Dr, Be, d, 0, 0, 15632, 16, 0, 0), Uo = he + 16 | 0, Me = Uo, we = (d | 0) == (we | 0) & Be >>> 0 < wr >>> 0 | d >>> 0 < we >>> 0, d = Qe + 8 | 0, Be = a[d >> 2], d = a[d + 4 >> 2], v = v >>> 20 | 0, Be = v + Be | 0, v = v >>> 0 > Be >>> 0 ? d + 1 | 0 : d, d = we + Be | 0, v = d >>> 0 < Be >>> 0 ? v + 1 | 0 : v, Lr(Me, d, v, 0, 0, 64028672, 65536, 0, 0), gn(B + 80 | 0, Se, Mf), Se = a[o + 120 >> 2], Be = B, B = a[he + 1424 >> 2], Gr = B, d = a[he + 1428 >> 2], Oi = d, we = B, Me = d, Qe = a[he >> 2], B = a[he + 320 >> 2], v = Qe + B | 0, Dr = a[he + 4 >> 2], d = Dr + a[he + 324 >> 2] | 0, B = B >>> 0 > v >>> 0 ? d + 1 | 0 : d, d = Me + (B & 1048575) | 0, we = v + we | 0, d = we >>> 0 < v >>> 0 ? d + 1 | 0 : d, a[Be >> 2] = we, Me = d, a[Be + 4 >> 2] = d, Xn = Be + 8 | 0, un = Xn, d = a[he + 1432 >> 2], $i = d, wr = a[he + 1436 >> 2], zi = wr, wr = (B | 0) == (Dr | 0) & v >>> 0 < Qe >>> 0 | B >>> 0 < Dr >>> 0, d = Bs + 8 | 0, Dr = a[d >> 2], Qe = he + 8 | 0, v = Dr + a[Qe >> 2] | 0, d = a[Qe + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 < Dr >>> 0 ? d + 1 | 0 : d, Dr = v, v = v + wr | 0, wr = Dr >>> 0 > v >>> 0 ? d + 1 | 0 : d, Dr = wr << 12 | v >>> 20, B = v << 12 | B >>> 20, v = Dr, Bs = a[he + 48 >> 2], Dr = a[he + 304 >> 2], Qe = Bs + Dr | 0, Kn = a[he + 52 >> 2], d = Kn + a[he + 308 >> 2] | 0, Dr = Dr >>> 0 > Qe >>> 0 ? d + 1 | 0 : d, v = Dr + v | 0, d = B + Qe | 0, B = d >>> 0 < Qe >>> 0 ? v + 1 | 0 : v, $r = d, v = $i + d | 0, d = zi + (B & 1048575) | 0, a[un >> 2] = v, d = v >>> 0 < $r >>> 0 ? d + 1 | 0 : d, a[un + 4 >> 2] = d, un = d << 1, d = v, v = un | d >>> 31, un = d << 1, d = v + zi | 0, v = $i + un | 0, d = v >>> 0 < un >>> 0 ? d + 1 | 0 : d, a[Aa >> 2] = v, a[Aa + 4 >> 2] = d, xo = Be + 16 | 0, d = a[he + 1440 >> 2], un = d, v = a[he + 1444 >> 2], In = v, $r = (B | 0) == (Dr | 0) & Qe >>> 0 > $r >>> 0 | B >>> 0 < Dr >>> 0, Dr = (Dr | 0) == (Kn | 0) & Qe >>> 0 < Bs >>> 0 | Dr >>> 0 < Kn >>> 0, d = uo + 8 | 0, Qe = a[d >> 2], $i = yo + 8 | 0, v = Qe + a[$i >> 2] | 0, d = a[$i + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 < Qe >>> 0 ? d + 1 | 0 : d, Qe = v, v = v + Dr | 0, d = Qe >>> 0 > v >>> 0 ? d + 1 | 0 : d, Dr = v, wr = wr >>> 20 | 0, v = wr, wr = wr + Dr | 0, d = v >>> 0 > wr >>> 0 ? d + 1 | 0 : d, v = wr + $r | 0, wr = v >>> 0 < wr >>> 0 ? d + 1 | 0 : d, d = wr << 12 | v >>> 20, Qe = v << 12 | B >>> 20, uo = d, yo = a[he + 240 >> 2], v = a[he + 288 >> 2], B = yo + v | 0, Kn = a[he + 244 >> 2], d = Kn + a[he + 292 >> 2] | 0, d = B >>> 0 < v >>> 0 ? d + 1 | 0 : d, $r = B, v = a[he + 32 >> 2], B = B + v | 0, Dr = d, d = d + a[he + 36 >> 2] | 0, v = B >>> 0 < v >>> 0 ? d + 1 | 0 : d, d = v + uo | 0, $i = B, Qe = B + Qe | 0, B = B >>> 0 > Qe >>> 0 ? d + 1 | 0 : d, d = In + (B & 1048575) | 0, zi = Qe, Qe = un + Qe | 0, a[xo >> 2] = Qe, d = Qe >>> 0 < zi >>> 0 ? d + 1 | 0 : d, a[xo + 4 >> 2] = d, d = (d << 1 | Qe >>> 31) + In | 0, Qe = Qe << 1, In = Qe, Qe = Qe + un | 0, d = In >>> 0 > Qe >>> 0 ? d + 1 | 0 : d, a[zs >> 2] = Qe, a[zs + 4 >> 2] = d, uo = Be + 24 | 0, d = a[he + 1448 >> 2], Qe = a[he + 1452 >> 2], un = d, In = Qe, Qe = (B | 0) == (v | 0) & $i >>> 0 > zi >>> 0 | B >>> 0 < v >>> 0, $i = (v | 0) == (Dr | 0) & $r >>> 0 > $i >>> 0 | v >>> 0 < Dr >>> 0, d = qi + 8 | 0, zi = a[d >> 2], qi = a[d + 4 >> 2], $r = (Dr | 0) == (Kn | 0) & $r >>> 0 < yo >>> 0 | Dr >>> 0 < Kn >>> 0, d = Ao + 8 | 0, v = a[d >> 2], Kn = Ti + 8 | 0, Dr = v + a[Kn >> 2] | 0, d = a[Kn + 4 >> 2] + a[d + 4 >> 2] | 0, v = v >>> 0 > Dr >>> 0 ? d + 1 | 0 : d, d = Dr, Dr = Dr + $r | 0, d = (d >>> 0 > Dr >>> 0 ? v + 1 | 0 : v) + qi | 0, v = Dr + zi | 0, d = v >>> 0 < Dr >>> 0 ? d + 1 | 0 : d, Dr = v, v = v + $i | 0, d = Dr >>> 0 > v >>> 0 ? d + 1 | 0 : d, wr = wr >>> 20 | 0, v = wr + v | 0, d = wr >>> 0 > v >>> 0 ? d + 1 | 0 : d, wr = v, v = v + Qe | 0, wr = wr >>> 0 > v >>> 0 ? d + 1 | 0 : d, d = v, v = wr << 12 | d >>> 20, $r = d << 12 | B >>> 20, qi = a[he + 16 >> 2], Dr = Ho & -2, B = qi + Dr | 0, Kn = a[he + 20 >> 2], d = Kn + (Ts & 1048575) | 0, Dr = B >>> 0 < Dr >>> 0 ? d + 1 | 0 : d, d = Dr + v | 0, Qe = B, $r = B + $r | 0, B = B >>> 0 > $r >>> 0 ? d + 1 | 0 : d, d = In + (B & 1048575) | 0, v = $r + un | 0, d = v >>> 0 < $r >>> 0 ? d + 1 | 0 : d, a[uo >> 2] = v, a[uo + 4 >> 2] = d, $i = v << 1, v = (d << 1 | v >>> 31) + In | 0, d = $i + un | 0, v = d >>> 0 < $i >>> 0 ? v + 1 | 0 : v, a[x2 >> 2] = d, a[x2 + 4 >> 2] = v, yo = Be + 32 | 0, In = yo, d = a[he + 1456 >> 2], v = a[he + 1460 >> 2], $i = d, zi = v, un = Rr, ni = ni & 65535, $r = (B | 0) == (Dr | 0) & Qe >>> 0 > $r >>> 0 | B >>> 0 < Dr >>> 0, Rr = (Dr | 0) == (Kn | 0) & Qe >>> 0 < qi >>> 0 | Dr >>> 0 < Kn >>> 0, d = Uo + 8 | 0, v = Rr + a[d >> 2] | 0, d = a[d + 4 >> 2], d = v >>> 0 < Rr >>> 0 ? d + 1 | 0 : d, wr = wr >>> 20 | 0, Rr = v + wr | 0, v = wr >>> 0 > Rr >>> 0 ? d + 1 | 0 : d, d = Rr, Rr = Rr + $r | 0, d = (d >>> 0 > Rr >>> 0 ? v + 1 | 0 : v) << 12 | Rr >>> 20, v = Rr << 12 | B >>> 20, B = v + un | 0, d = d + ni | 0, d = (B >>> 0 < v >>> 0 ? d + 1 | 0 : d) + zi | 0, v = B, B = B + $i | 0, d = v >>> 0 > B >>> 0 ? d + 1 | 0 : d, a[In >> 2] = B, a[In + 4 >> 2] = d, d = (d << 1 | B >>> 31) + zi | 0, B = B << 1, v = B, B = B + $i | 0, d = v >>> 0 > B >>> 0 ? d + 1 | 0 : d, a[jn >> 2] = B, a[jn + 4 >> 2] = d, Rr = he, d = (Me << 1 | we >>> 31) + Oi | 0, B = we << 1, v = B, B = B + Gr | 0, d = v >>> 0 > B >>> 0 ? d + 1 | 0 : d, a[he + 1544 >> 2] = B, a[he + 1548 >> 2] = d, B = ds + 8 | 0, Dr = a[B >> 2], ta = a[B + 4 >> 2], B = Go + 8 | 0, e = a[B >> 2], Je = a[B + 4 >> 2], B = a[he + 736 >> 2], d = a[he + 740 >> 2], Qe = a[he + 416 >> 2], we = a[he + 420 >> 2], v = Oo + 8 | 0, N2 = a[v >> 2], qs = a[v + 4 >> 2], v = oa + 8 | 0, $r = a[v >> 2], Ta = a[v + 4 >> 2], Ti = a[he + 672 >> 2], Va = a[he + 676 >> 2], ds = a[he + 384 >> 2], he = a[he + 388 >> 2], v = Mo + 8 | 0, ba = a[v >> 2], ea = a[v + 4 >> 2], v = ns + 8 | 0, Bs = a[v >> 2], df = a[v + 4 >> 2], Ao = a[Rr + 688 >> 2], zo = a[Rr + 692 >> 2], Uo = a[Rr + 624 >> 2], oa = a[Rr + 628 >> 2], v = Lo + 8 | 0, $i = a[v >> 2], zi = a[v + 4 >> 2], js = a[Rr + 352 >> 2], No = a[Rr + 356 >> 2], Wo = a[Rr + 336 >> 2], Lo = a[Rr + 340 >> 2], v = ps + 8 | 0, Oa = a[v >> 2], Gr = a[v + 4 >> 2], ns = Be + 104 | 0, ni = a[ns >> 2], Oi = a[ns + 4 >> 2], Mo = Be + 96 | 0, un = a[Mo >> 2], In = a[Mo + 4 >> 2], Go = Be + 88 | 0, Kn = a[Go >> 2], Ho = a[Go + 4 >> 2], Oo = Be + 112 | 0, Ts = a[Oo >> 2], Me = a[Oo + 4 >> 2], po = a[Be + 80 >> 2], qi = a[Be + 84 >> 2], gn(Na, Na, Rr + 1344 | 0), wr = a[Rr + 1544 >> 2], ps = a[Rr + 1548 >> 2], d = d + we | 0, v = B + Qe | 0, B = v >>> 0 < B >>> 0 ? d + 1 | 0 : d, sa = wr, d = v, wr = Vn ? mi : d, mi = sa + wr | 0, v = ps + (Vn ? dr : B & 1048575) | 0, Na = 8388599 - ((mi >>> 0 > 4294959480) + (wr >>> 0 > mi >>> 0 ? v + 1 | 0 : v) | 0) | 0, ps = -7816 - mi | 0, v = ps & 1, sa = 0 - v | 0, wr = 0 - v | 0, we = (B | 0) == (we | 0) & d >>> 0 < Qe >>> 0 | B >>> 0 < we >>> 0, d = ta + Je | 0, dr = Dr + e | 0, v = dr >>> 0 < Dr >>> 0 ? d + 1 | 0 : d, d = we + dr | 0, v = d >>> 0 < dr >>> 0 ? v + 1 | 0 : v, we = v << 12 | d >>> 20, B = d << 12 | B >>> 20, mi = we, d = he + Va | 0, we = Ti + ds | 0, dr = we >>> 0 < Ti >>> 0 ? d + 1 | 0 : d, d = dr + mi | 0, mi = B + we | 0, B = mi >>> 0 < we >>> 0 ? d + 1 | 0 : d, Ti = mi, mi = (dr | 0) == (B | 0) & mi >>> 0 < we >>> 0 | B >>> 0 < dr >>> 0, we = (he | 0) == (dr | 0) & we >>> 0 < ds >>> 0 | he >>> 0 > dr >>> 0, d = Ta + qs | 0, dr = $r + N2 | 0, d = dr >>> 0 < $r >>> 0 ? d + 1 | 0 : d, Dr = dr, dr = we + dr | 0, d = Dr >>> 0 > dr >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, dr = v + dr | 0, v = v >>> 0 > dr >>> 0 ? d + 1 | 0 : d, d = dr + mi | 0, we = d >>> 0 < dr >>> 0 ? v + 1 | 0 : v, dr = we << 12 | d >>> 20, ds = B, B = d << 12 | B >>> 20, d = oa + zo | 0, Dr = Ao + Uo | 0, v = Dr >>> 0 < Ao >>> 0 ? d + 1 | 0 : d, d = No + v | 0, he = Dr + js | 0, mi = he >>> 0 < js >>> 0 ? d + 1 | 0 : d, d = mi + dr | 0, Qe = B + he | 0, dr = Qe >>> 0 < he >>> 0 ? d + 1 | 0 : d, B = _o & -2, $r = B + Wo | 0, d = Lo + (ya & 1048575) | 0, B = B >>> 0 > $r >>> 0 ? d + 1 | 0 : d, _o = (dr | 0) == (mi | 0) & he >>> 0 > Qe >>> 0 | dr >>> 0 < mi >>> 0, he = (v | 0) == (mi | 0) & he >>> 0 < Dr >>> 0 | v >>> 0 > mi >>> 0, Dr = (v | 0) == (oa | 0) & Dr >>> 0 < Uo >>> 0 | v >>> 0 < oa >>> 0, v = ea + df | 0, mi = Bs + ba | 0, d = mi >>> 0 < Bs >>> 0 ? v + 1 | 0 : v, v = Dr + mi | 0, d = (v >>> 0 < mi >>> 0 ? d + 1 | 0 : d) + zi | 0, Dr = v, v = v + $i | 0, d = Dr >>> 0 > v >>> 0 ? d + 1 | 0 : d, Dr = v, v = v + he | 0, d = Dr >>> 0 > v >>> 0 ? d + 1 | 0 : d, we = we >>> 20 | 0, Dr = we, we = v + we | 0, v = Dr >>> 0 > we >>> 0 ? d + 1 | 0 : d, d = we + _o | 0, v = d >>> 0 < we >>> 0 ? v + 1 | 0 : v, we = d, d = B + (v << 12 | d >>> 20) | 0, Dr = dr, we = we << 12 | dr >>> 20, dr = we + $r | 0, mi = dr, dr = we >>> 0 > dr >>> 0 ? d + 1 | 0 : d, $i = Be + 72 | 0, we = wr, d = we >>> 16 | 0, he = (we & 65535) << 16 | sa >>> 16, wr = d, zi = a[jn >> 2], jn = a[jn + 4 >> 2], _o = Io & 65535, ya = (B | 0) == (dr | 0) & $r >>> 0 > mi >>> 0 | B >>> 0 > dr >>> 0, $r = (B | 0) == (Lo | 0) & $r >>> 0 < Wo >>> 0 | B >>> 0 < Lo >>> 0, B = Oa + $r | 0, d = Gr, d = B >>> 0 < $r >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, B = B + v | 0, v = v >>> 0 > B >>> 0 ? d + 1 | 0 : d, d = B, B = B + ya | 0, v = (d >>> 0 > B >>> 0 ? v + 1 | 0 : v) << 12 | B >>> 20, $r = dr, dr = B << 12 | dr >>> 20, B = dr + fr | 0, d = v + _o | 0, d = B >>> 0 < dr >>> 0 ? d + 1 | 0 : d, v = Vn ? ts : B, B = v + zi | 0, d = jn + (Vn ? va : d) | 0, d = (wr - ((B >>> 0 > he >>> 0) + (B >>> 0 < v >>> 0 ? d + 1 | 0 : d) | 0) | 0) + 524287 | 0, B = (he - B | 0) - 8 | 0, v = B >>> 0 < 4294967288 ? d + 1 | 0 : d, d = v >>> 1 | 0, he = (v & 1) << 31 | B >>> 1, a[$i >> 2] = he, fr = d, a[$i + 4 >> 2] = d, zi = Be - -64 | 0, wr = zi, ts = B << 19 & 524288, dr = (we & 4095) << 20 | sa >>> 12, B = we >>> 12 | 0, we = Vn ? Xs : mi, v = we + a[x2 >> 2] | 0, d = a[x2 + 4 >> 2] + (Vn ? Fr : $r & 1048575) | 0, d = (B - ((v >>> 0 > dr >>> 0) + (v >>> 0 < we >>> 0 ? d + 1 | 0 : d) | 0) | 0) + 8388607 | 0, we = (dr - v | 0) - 8 | 0, Fr = we >>> 0 < 4294967288 ? d + 1 | 0 : d, v = (Fr >>> 1 | 0) + ts | 0, mi = (Fr & 1) << 31 | we >>> 1, d = mi, v = d >>> 0 > d >>> 0 ? v + 1 | 0 : v, a[wr >> 2] = d, ts = v, a[wr + 4 >> 2] = v, $r = Be + 56 | 0, wr = $r, Gr = we << 19 & 524288, we = Vn ? wa : Qe, v = we + a[zs >> 2] | 0, d = a[zs + 4 >> 2] + (Vn ? Si : Dr & 1048575) | 0, d = (B - ((v >>> 0 > dr >>> 0) + (v >>> 0 < we >>> 0 ? d + 1 | 0 : d) | 0) | 0) + 8388607 | 0, v = (dr - v | 0) - 8 | 0, we = v >>> 0 < 4294967288 ? d + 1 | 0 : d, d = (we >>> 1 | 0) + Gr | 0, Fr = (we & 1) << 31 | v >>> 1, d = Fr >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, a[wr >> 2] = Fr, Si = d, a[wr + 4 >> 2] = d, Qe = Be + 48 | 0, Dr = v << 19 & 524288, we = dr, wr = B, d = Vn ? Pa : Ti, B = d + a[Aa >> 2] | 0, v = a[Aa + 4 >> 2] + (Vn ? Sn : ds & 1048575) | 0, d = (wr - ((B >>> 0 > we >>> 0) + (B >>> 0 < d >>> 0 ? v + 1 | 0 : v) | 0) | 0) + 8388607 | 0, B = (we - B | 0) - 8 | 0, dr = B >>> 0 < 4294967288 ? d + 1 | 0 : d, d = (dr >>> 1 | 0) + Dr | 0, Sn = (dr & 1) << 31 | B >>> 1, v = Sn, d = v >>> 0 > v >>> 0 ? d + 1 | 0 : d, a[Qe >> 2] = v, Dr = d, a[Qe + 4 >> 2] = d, dr = B << 19 & 524288, d = (wr & 1048574) + Na | 0, B = (we & -977) + ps | 0, d = B >>> 0 < ps >>> 0 ? d + 1 | 0 : d, B = (d & 1) << 31 | B >>> 1, d = (d >>> 1 | 0) + dr | 0, dr = B, d = B >>> 0 < B >>> 0 ? d + 1 | 0 : d, a[Be + 40 >> 2] = B, a[Be + 44 >> 2] = d, o = a[o + 120 >> 2], we = o >> 31, B = o - 1 | 0, Gr = B, v = 0 - (((o | 0) != 0) + we | 0) | 0, wr = we - !o | 0, we = v & a[m + 4 >> 2] | wr & a[Be + 4 >> 2], o = 0 - o | 0, a[Be >> 2] = o & a[m >> 2] | B & a[Be >> 2], a[Be + 4 >> 2] = we, we = a[m + 12 >> 2] & v | a[Xn + 4 >> 2] & wr, a[Xn >> 2] = a[m + 8 >> 2] & o | a[Xn >> 2] & B, a[Xn + 4 >> 2] = we, we = a[m + 20 >> 2] & v | a[xo + 4 >> 2] & wr, a[xo >> 2] = a[m + 16 >> 2] & o | a[xo >> 2] & B, a[xo + 4 >> 2] = we, we = a[m + 28 >> 2] & v | a[uo + 4 >> 2] & wr, a[uo >> 2] = a[m + 24 >> 2] & o | a[uo >> 2] & B, a[uo + 4 >> 2] = we, we = a[m + 36 >> 2] & v | a[yo + 4 >> 2] & wr, a[yo >> 2] = a[m + 32 >> 2] & o | a[yo >> 2] & B, a[yo + 4 >> 2] = we, d = a[m + 44 >> 2] & v | d & wr, a[Be + 40 >> 2] = a[m + 40 >> 2] & o | B & dr, a[Be + 44 >> 2] = d, d = m + 48 | 0, dr = a[d >> 2], d = a[d + 4 >> 2] & v | wr & Dr, a[Qe >> 2] = o & dr | B & Sn, a[Qe + 4 >> 2] = d, d = m + 56 | 0, dr = a[d >> 2], d = a[d + 4 >> 2] & v | wr & Si, a[$r >> 2] = o & dr | B & Fr, a[$r + 4 >> 2] = d, d = m - -64 | 0, dr = a[d >> 2], d = a[d + 4 >> 2] & v | wr & ts, a[zi >> 2] = o & dr | B & mi, a[zi + 4 >> 2] = d, m = m + 72 | 0, d = a[m >> 2], m = a[m + 4 >> 2] & v | fr & wr, a[$i >> 2] = o & d | B & he, a[$i + 4 >> 2] = m, m = wr & a[Be + 84 >> 2], a[Be + 80 >> 2] = a[Be + 80 >> 2] & B | o & 1, a[Be + 84 >> 2] = m, o = a[Go + 4 >> 2] & wr, a[Go >> 2] = a[Go >> 2] & B, a[Go + 4 >> 2] = o, o = a[Mo + 4 >> 2] & wr, a[Mo >> 2] = a[Mo >> 2] & B, a[Mo + 4 >> 2] = o, o = a[ns + 4 >> 2] & wr, a[ns >> 2] = a[ns >> 2] & B, a[ns + 4 >> 2] = o, mi = a[Oo >> 2], he = a[Oo + 4 >> 2], Si = Be, Dr = Me & 65535, o = oi(Me >>> 16 | 0, 0, 977, 1), B = o + po | 0, d = qi + Fe | 0, o = B >>> 0 < o >>> 0 ? d + 1 | 0 : d, m = o >>> 20 | 0, d = Ho, v = m, m = m + Kn | 0, dr = v >>> 0 > m >>> 0 ? d + 1 | 0 : d, d = In, v = dr >>> 20 | 0, Be = v + un | 0, we = v >>> 0 > Be >>> 0 ? d + 1 | 0 : d, d = Oi, v = we >>> 20 | 0, Fr = v + ni | 0, fr = v >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, v = Dr, Sn = fr >>> 20 | 0, d = Sn + Ts | 0, v = Sn >>> 0 > d >>> 0 ? v + 1 | 0 : v, d | (Fr | (B | m | Be)) | (v | (o | dr | we | fr) & 1048575) ? (m & (B ^ 976) & Be & Fr & d) == -1 ? B = (dr & (o ^ 1) & we & fr & (v ^ 983040)) == 1048575 : B = 0 : B = 1, a[Si + 120 >> 2] = B & (Se ^ -1), a[Oo >> 2] = Gr & mi, a[Oo + 4 >> 2] = he & wr, be = Rr + 1744 | 0;
  }
  function na(B, o) {
    var m = 0, d = 0, v = 0, he = 0, we = 0, Be = 0, Me = 0, fr = 0, wr = 0, dr = 0, Dr = 0, Rr = 0, Qe = 0, Fr = 0, Gr = 0, $r = 0, ni = 0, mi = 0, Si = 0, Oi = 0, $i = 0, zi = 0, un = 0, In = 0, Ti = 0, Sn = 0, Kn = 0, Vn = 0, Xn = 0, uo = 0, yo = 0, Io = 0, xo = 0, Mo = 0, qi = 0, Oo = 0;
    v = be - 336 | 0, be = v, m = a[o + 4 >> 2], mi = m, Fr = a[o >> 2], d = Fr, m = m << 1 | d >>> 31, wr = v - -64 | 0, Qe = a[o + 24 >> 2], Rr = a[o + 28 >> 2], In = d << 1, Vn = m, Lr(wr, Qe, Rr, 0, 0, In, m, 0, 0), m = a[o + 12 >> 2], Mo = m, Xn = a[o + 8 >> 2], d = Xn, m = m << 1 | d >>> 31, Me = v + 272 | 0, ni = a[o + 16 >> 2], Dr = a[o + 20 >> 2], d = d << 1, he = m, Lr(Me, ni, Dr, 0, 0, d, m, 0, 0), Be = v + 224 | 0, we = a[o + 32 >> 2], o = a[o + 36 >> 2], Lr(Be, we, o, 0, 0, we, o, 0, 0), fr = v + 208 | 0, Lr(fr, a[v + 224 >> 2], a[v + 228 >> 2], 0, 0, 15632, 16, 0, 0), m = o << 1 | we >>> 31, uo = v + 176 | 0, Oi = we << 1, yo = m, Lr(uo, Oi, m, 0, 0, Fr, mi, 0, 0), Io = v + 80 | 0, Lr(Io, Qe, Rr, 0, 0, d, he, 0, 0), xo = v + 256 | 0, Lr(xo, ni, Dr, 0, 0, ni, Dr, 0, 0), dr = v + 192 | 0, o = Be + 8 | 0, Lr(dr, a[o >> 2], a[o + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Oo = v + 320 | 0, Lr(Oo, Fr, mi, 0, 0, Fr, mi, 0, 0), Ti = v + 160 | 0, Lr(Ti, Oi, m, 0, 0, Xn, Mo, 0, 0), Sn = v + 96 | 0, Lr(Sn, Qe, Rr, 0, 0, ni << 1, Dr << 1 | ni >>> 31, 0, 0), Fr = a[v + 68 >> 2], m = Fr + a[v + 276 >> 2] | 0, we = a[v + 64 >> 2], o = a[v + 272 >> 2], d = we + o | 0, he = a[v + 208 >> 2], qi = d + he | 0, o = o >>> 0 > d >>> 0 ? m + 1 | 0 : m, m = o + a[v + 212 >> 2] | 0, he = he >>> 0 > qi >>> 0 ? m + 1 | 0 : m, Be = (o | 0) == (he | 0) & d >>> 0 > qi >>> 0 | o >>> 0 > he >>> 0, m = fr + 8 | 0, fr = a[m >> 2], zi = a[m + 4 >> 2], we = (o | 0) == (Fr | 0) & d >>> 0 < we >>> 0 | o >>> 0 < Fr >>> 0, m = Me + 8 | 0, d = a[m >> 2], o = wr + 8 | 0, Me = d + a[o >> 2] | 0, m = a[o + 4 >> 2] + a[m + 4 >> 2] | 0, m = d >>> 0 > Me >>> 0 ? m + 1 | 0 : m, o = we + Me | 0, m = (o >>> 0 < Me >>> 0 ? m + 1 | 0 : m) + zi | 0, d = o, o = o + fr | 0, m = d >>> 0 > o >>> 0 ? m + 1 | 0 : m, d = o, o = o + Be | 0, m = d >>> 0 > o >>> 0 ? m + 1 | 0 : m, mi = he, zi = o << 12 | he >>> 20, d = m, we = m << 12 | o >>> 20, Si = a[v + 80 >> 2], o = a[v + 256 >> 2], Be = Si + o | 0, Kn = a[v + 84 >> 2], m = Kn + a[v + 260 >> 2] | 0, m = o >>> 0 > Be >>> 0 ? m + 1 | 0 : m, o = a[v + 176 >> 2], fr = o + Be | 0, wr = m, m = m + a[v + 180 >> 2] | 0, m = o >>> 0 > fr >>> 0 ? m + 1 | 0 : m, o = a[v + 192 >> 2], he = o + fr | 0, Me = m, m = m + a[v + 196 >> 2] | 0, o = o >>> 0 > he >>> 0 ? m + 1 | 0 : m, m = o + we | 0, zi = he + zi | 0, we = zi >>> 0 < he >>> 0 ? m + 1 | 0 : m, $i = (o | 0) == (we | 0) & he >>> 0 > zi >>> 0 | o >>> 0 > we >>> 0, un = (o | 0) == (Me | 0) & he >>> 0 < fr >>> 0 | o >>> 0 < Me >>> 0, o = dr + 8 | 0, $r = a[o >> 2], Gr = a[o + 4 >> 2], Fr = (Me | 0) == (wr | 0) & Be >>> 0 > fr >>> 0 | Me >>> 0 < wr >>> 0, o = uo + 8 | 0, dr = a[o >> 2], Me = a[o + 4 >> 2], fr = (wr | 0) == (Kn | 0) & Be >>> 0 < Si >>> 0 | wr >>> 0 < Kn >>> 0, m = xo + 8 | 0, he = a[m >> 2], o = Io + 8 | 0, Be = he + a[o >> 2] | 0, m = a[o + 4 >> 2] + a[m + 4 >> 2] | 0, m = he >>> 0 > Be >>> 0 ? m + 1 | 0 : m, o = Be + fr | 0, m = (o >>> 0 < Be >>> 0 ? m + 1 | 0 : m) + Me | 0, he = o, o = o + dr | 0, m = he >>> 0 > o >>> 0 ? m + 1 | 0 : m, he = o, o = o + Fr | 0, m = (he >>> 0 > o >>> 0 ? m + 1 | 0 : m) + Gr | 0, he = o, o = o + $r | 0, m = he >>> 0 > o >>> 0 ? m + 1 | 0 : m, he = o + un | 0, m = he >>> 0 < o >>> 0 ? m + 1 | 0 : m, d = d >>> 20 | 0, o = d + he | 0, m = d >>> 0 > o >>> 0 ? m + 1 | 0 : m, d = o, o = o + $i | 0, m = d >>> 0 > o >>> 0 ? m + 1 | 0 : m, d = we, Be = o << 12 | d >>> 20, he = m, fr = m << 12 | o >>> 20, $r = a[v + 160 >> 2], o = a[v + 96 >> 2], we = $r + o | 0, Si = a[v + 164 >> 2], m = Si + a[v + 100 >> 2] | 0, o = o >>> 0 > we >>> 0 ? m + 1 | 0 : m, m = o + fr | 0, dr = we, we = we + Be | 0, Be = we << 4 & -16, Me = we >>> 0 < dr >>> 0 ? m + 1 | 0 : m, fr = (Me << 4 | we >>> 28) & 16777215, Fr = d, Lr(v, Be | d >>> 16 & 15, fr, 0, 0, 977, 1, 0, 0), $i = a[v + 4 >> 2], m = $i + a[v + 324 >> 2] | 0, fr = B, un = a[v >> 2], B = a[v + 320 >> 2], wr = un + B | 0, a[fr >> 2] = wr, Be = B >>> 0 > wr >>> 0 ? m + 1 | 0 : m, a[fr + 4 >> 2] = Be & 1048575, Kn = v + 304 | 0, Lr(Kn, Xn, Mo, 0, 0, In, Vn, 0, 0), uo = v + 144 | 0, Lr(uo, Oi, yo, 0, 0, ni, Dr, 0, 0), Io = v + 112 | 0, Lr(Io, Qe, Rr, 0, 0, Qe, Rr, 0, 0), xo = v + 48 | 0, Gr = xo, we = (o | 0) == (Me | 0) & we >>> 0 < dr >>> 0 | o >>> 0 > Me >>> 0, d = (o | 0) == (Si | 0) & dr >>> 0 < $r >>> 0 | o >>> 0 < Si >>> 0, m = Sn + 8 | 0, o = a[m >> 2], B = Ti + 8 | 0, dr = o + a[B >> 2] | 0, m = a[B + 4 >> 2] + a[m + 4 >> 2] | 0, m = o >>> 0 > dr >>> 0 ? m + 1 | 0 : m, o = d + dr | 0, m = o >>> 0 < dr >>> 0 ? m + 1 | 0 : m, d = he >>> 20 | 0, B = o + d | 0, m = d >>> 0 > B >>> 0 ? m + 1 | 0 : m, o = B, B = B + we | 0, m = o >>> 0 > B >>> 0 ? m + 1 | 0 : m, Me = B << 12 | Me >>> 20, we = m, he = m << 12 | B >>> 20, Ti = a[v + 148 >> 2], m = Ti + a[v + 116 >> 2] | 0, Si = a[v + 144 >> 2], o = a[v + 112 >> 2], B = Si + o | 0, $r = B, dr = B + Me | 0, d = B >>> 0 < o >>> 0 ? m + 1 | 0 : m, m = d + he | 0, Me = dr >>> 0 < B >>> 0 ? m + 1 | 0 : m, Lr(Gr, dr, Me & 1048575, 0, 0, 15632, 16, 0, 0), he = (Be | 0) == ($i | 0) & wr >>> 0 < un >>> 0 | Be >>> 0 < $i >>> 0, m = Oo + 8 | 0, o = a[m >> 2], B = v + 8 | 0, wr = o + a[B >> 2] | 0, m = a[B + 4 >> 2] + a[m + 4 >> 2] | 0, m = o >>> 0 > wr >>> 0 ? m + 1 | 0 : m, B = he + wr | 0, m = B >>> 0 < wr >>> 0 ? m + 1 | 0 : m, wr = B << 12 | Be >>> 20, he = m, Be = m << 12 | B >>> 20, $i = a[v + 48 >> 2], B = a[v + 304 >> 2], Gr = $i + B | 0, Sn = a[v + 52 >> 2], m = Sn + a[v + 308 >> 2] | 0, o = B >>> 0 > Gr >>> 0 ? m + 1 | 0 : m, m = o + Be | 0, wr = wr + Gr | 0, m = wr >>> 0 < Gr >>> 0 ? m + 1 | 0 : m, a[fr + 8 >> 2] = wr, Be = m, a[fr + 12 >> 2] = m & 1048575, un = v + 240 | 0, Lr(un, ni, Dr, 0, 0, In, Vn, 0, 0), Vn = v + 288 | 0, Lr(Vn, Xn, Mo, 0, 0, Xn, Mo, 0, 0), In = v + 128 | 0, Lr(In, Oi, yo, 0, 0, Qe, Rr, 0, 0), yo = v + 32 | 0, Rr = yo, Dr = (d | 0) == (Me | 0) & dr >>> 0 < $r >>> 0 | d >>> 0 > Me >>> 0, dr = (d | 0) == (Ti | 0) & $r >>> 0 < Si >>> 0 | d >>> 0 < Ti >>> 0, m = Io + 8 | 0, d = a[m >> 2], B = uo + 8 | 0, Qe = d + a[B >> 2] | 0, m = a[B + 4 >> 2] + a[m + 4 >> 2] | 0, m = d >>> 0 > Qe >>> 0 ? m + 1 | 0 : m, d = dr + Qe | 0, m = d >>> 0 < Qe >>> 0 ? m + 1 | 0 : m, we = we >>> 20 | 0, B = d + we | 0, m = we >>> 0 > B >>> 0 ? m + 1 | 0 : m, d = B, B = B + Dr | 0, m = d >>> 0 > B >>> 0 ? m + 1 | 0 : m, ni = B << 12 | Me >>> 20, we = a[v + 128 >> 2], Me = ni + we | 0, d = m, Oi = m << 12 | B >>> 20, m = Oi + a[v + 132 >> 2] | 0, dr = we >>> 0 > Me >>> 0 ? m + 1 | 0 : m, Lr(Rr, Me, dr, 0, 0, 15632, 16, 0, 0), we = fr, wr = (o | 0) == (Be | 0) & wr >>> 0 < Gr >>> 0 | o >>> 0 > Be >>> 0, fr = (o | 0) == (Sn | 0) & Gr >>> 0 < $i >>> 0 | o >>> 0 < Sn >>> 0, m = Kn + 8 | 0, o = a[m >> 2], B = xo + 8 | 0, Dr = o + a[B >> 2] | 0, m = a[B + 4 >> 2] + a[m + 4 >> 2] | 0, m = o >>> 0 > Dr >>> 0 ? m + 1 | 0 : m, o = fr + Dr | 0, m = o >>> 0 < Dr >>> 0 ? m + 1 | 0 : m, he = he >>> 20 | 0, B = o + he | 0, m = he >>> 0 > B >>> 0 ? m + 1 | 0 : m, o = B, B = B + wr | 0, m = o >>> 0 > B >>> 0 ? m + 1 | 0 : m, fr = B << 12 | Be >>> 20, o = m, Rr = m << 12 | B >>> 20, Gr = a[v + 240 >> 2], B = a[v + 288 >> 2], Be = Gr + B | 0, $r = a[v + 244 >> 2], m = $r + a[v + 292 >> 2] | 0, Dr = B >>> 0 > Be >>> 0 ? m + 1 | 0 : m, m = Dr + a[v + 36 >> 2] | 0, B = a[v + 32 >> 2], he = B + Be | 0, wr = he, fr = he + fr | 0, B = B >>> 0 > he >>> 0 ? m + 1 | 0 : m, m = B + Rr | 0, a[we + 16 >> 2] = fr, he = fr >>> 0 < he >>> 0 ? m + 1 | 0 : m, a[we + 20 >> 2] = he & 1048575, Qe = v + 16 | 0, Rr = (dr | 0) == (Oi | 0) & Me >>> 0 < ni >>> 0 | dr >>> 0 < Oi >>> 0, m = In + 8 | 0, dr = a[m >> 2], m = a[m + 4 >> 2], d = d >>> 20 | 0, Me = d, d = d + dr | 0, m = Me >>> 0 > d >>> 0 ? m + 1 | 0 : m, Me = d, d = d + Rr | 0, m = Me >>> 0 > d >>> 0 ? m + 1 | 0 : m, Lr(Qe, d, m, 0, 0, 64028672, 65536, 0, 0), d = we, Rr = (B | 0) == (he | 0) & fr >>> 0 < wr >>> 0 | B >>> 0 > he >>> 0, dr = (B | 0) == (Dr | 0) & Be >>> 0 > wr >>> 0 | B >>> 0 < Dr >>> 0, B = yo + 8 | 0, wr = a[B >> 2], Me = a[B + 4 >> 2], fr = (Dr | 0) == ($r | 0) & Be >>> 0 < Gr >>> 0 | Dr >>> 0 < $r >>> 0, m = Vn + 8 | 0, we = a[m >> 2], B = un + 8 | 0, Be = we + a[B >> 2] | 0, m = a[B + 4 >> 2] + a[m + 4 >> 2] | 0, m = Be >>> 0 < we >>> 0 ? m + 1 | 0 : m, B = Be + fr | 0, m = (B >>> 0 < Be >>> 0 ? m + 1 | 0 : m) + Me | 0, we = B, B = B + wr | 0, m = we >>> 0 > B >>> 0 ? m + 1 | 0 : m, we = B + dr | 0, m = we >>> 0 < B >>> 0 ? m + 1 | 0 : m, o = o >>> 20 | 0, B = o + we | 0, m = o >>> 0 > B >>> 0 ? m + 1 | 0 : m, o = B, B = B + Rr | 0, m = o >>> 0 > B >>> 0 ? m + 1 | 0 : m, we = B << 12 | he >>> 20, o = m, he = m << 12 | B >>> 20, dr = a[v + 16 >> 2], B = qi & -2, fr = dr + B | 0, m = mi & 1048575, mi = a[v + 20 >> 2], m = m + mi | 0, Be = B >>> 0 > fr >>> 0 ? m + 1 | 0 : m, m = Be + he | 0, he = we + fr | 0, m = he >>> 0 < fr >>> 0 ? m + 1 | 0 : m, a[d + 24 >> 2] = he, B = m, a[d + 28 >> 2] = m & 1048575, we = d, wr = Fr & 65535, Me = (m | 0) == (Be | 0) & he >>> 0 < fr >>> 0 | m >>> 0 < Be >>> 0, d = (Be | 0) == (mi | 0) & fr >>> 0 < dr >>> 0 | Be >>> 0 < mi >>> 0, m = Qe + 8 | 0, he = d + a[m >> 2] | 0, m = a[m + 4 >> 2], m = d >>> 0 > he >>> 0 ? m + 1 | 0 : m, o = o >>> 20 | 0, d = o, o = o + he | 0, m = d >>> 0 > o >>> 0 ? m + 1 | 0 : m, d = o, o = o + Me | 0, m = d >>> 0 > o >>> 0 ? m + 1 | 0 : m, B = o << 12 | B >>> 20, d = B + zi | 0, m = wr + (m << 12 | o >>> 20) | 0, a[we + 32 >> 2] = d, a[we + 36 >> 2] = B >>> 0 > d >>> 0 ? m + 1 | 0 : m, be = v + 336 | 0;
  }
  function os(B, o) {
    var m = 0, d = 0, v = 0, he = 0, we = 0, Be = 0, Me = 0, fr = 0, wr = 0, dr = 0, Dr = 0, Rr = 0, Qe = 0, Fr = 0, Gr = 0, $r = 0, ni = 0, mi = 0, Si = 0, Oi = 0, $i = 0, zi = 0, un = 0, In = 0, Ti = 0, Sn = 0, Kn = 0, Vn = 0, Xn = 0, uo = 0, yo = 0, Io = 0, xo = 0, Mo = 0, qi = 0, Oo = 0, Ho = 0, Go = 0, ns = 0, ds = 0, Ts = 0, Ao = 0, po = 0, _o = 0, Uo = 0, ts = 0, Lo = 0, Wo = 0, ps = 0, Bs = 0, Xs = 0, js = 0, ya = 0, sa = 0, va = 0, oa = 0, wa = 0, Pa = 0, Ta = 0;
    v = be - 464 | 0, be = v, a[B + 120 >> 2] = a[o + 120 >> 2], m = o + 40 | 0, gn(B + 80 | 0, o + 80 | 0, m), na(v + 384 | 0, m), Io = v + 424 | 0, na(Io, o), Fr = a[v + 388 >> 2], Gr = a[v + 384 >> 2], a[v + 344 >> 2] = -3908 - Gr, a[v + 348 >> 2] = 4194299 - ((Gr >>> 0 > 4294963388) + Fr | 0), Rr = a[v + 396 >> 2], mi = a[v + 392 >> 2], a[v + 352 >> 2] = -4 - mi, a[v + 356 >> 2] = 4194303 - ((mi >>> 0 > 4294967292) + Rr | 0), Oi = a[v + 404 >> 2], ni = a[v + 400 >> 2], a[v + 360 >> 2] = -4 - ni, a[v + 364 >> 2] = 4194303 - ((ni >>> 0 > 4294967292) + Oi | 0), wr = a[v + 412 >> 2], Be = a[v + 408 >> 2], a[v + 368 >> 2] = -4 - Be, a[v + 372 >> 2] = 4194303 - ((Be >>> 0 > 4294967292) + wr | 0), we = oi(a[v + 456 >> 2], a[v + 460 >> 2], 3, 0), he = Fe, Si = oi(a[v + 424 >> 2], a[v + 428 >> 2], 3, 0), fr = Fe, m = Si & 1, d = 0 - m | 0, Dr = d, dr = 0 - m | 0, m = (dr >>> 16 | 0) + he | 0, d = (dr & 65535) << 16 | d >>> 16, he = d + we | 0, m = d >>> 0 > he >>> 0 ? m + 1 | 0 : m, a[v + 456 >> 2] = (m & 1) << 31 | he >>> 1, a[v + 460 >> 2] = m >>> 1, Me = he << 19 & 524288, we = dr >>> 12 | 0, Dr = (dr & 4095) << 20 | Dr >>> 12, d = oi(a[v + 448 >> 2], a[v + 452 >> 2], 3, 0), he = Dr + d | 0, m = we + Fe | 0, d = d >>> 0 > he >>> 0 ? m + 1 | 0 : m, m = (d >>> 1 | 0) + Me | 0, dr = (d & 1) << 31 | he >>> 1, m = dr >>> 0 > dr >>> 0 ? m + 1 | 0 : m, a[v + 448 >> 2] = dr, a[v + 452 >> 2] = m, dr = he << 19 & 524288, he = oi(a[v + 440 >> 2], a[v + 444 >> 2], 3, 0) + Dr | 0, d = Fe + we | 0, d = he >>> 0 < Dr >>> 0 ? d + 1 | 0 : d, m = (d >>> 1 | 0) + dr | 0, Me = (d & 1) << 31 | he >>> 1, m = Me >>> 0 > Me >>> 0 ? m + 1 | 0 : m, a[v + 440 >> 2] = Me, a[v + 444 >> 2] = m, Me = he << 19 & 524288, d = oi(a[v + 432 >> 2], a[v + 436 >> 2], 3, 0), dr = d + Dr | 0, m = we + Fe | 0, he = d >>> 0 > dr >>> 0 ? m + 1 | 0 : m, m = (he >>> 1 | 0) + Me | 0, $i = (he & 1) << 31 | dr >>> 1, d = $i, m = d >>> 0 > d >>> 0 ? m + 1 | 0 : m, a[v + 432 >> 2] = d, a[v + 436 >> 2] = m, dr = dr << 19 & 524288, m = (we & 1048574) + fr | 0, he = (Dr & -977) + Si | 0, m = he >>> 0 < Si >>> 0 ? m + 1 | 0 : m, he = (m & 1) << 31 | he >>> 1, m = (m >>> 1 | 0) + dr | 0, d = he, m = d >>> 0 < d >>> 0 ? m + 1 | 0 : m, a[v + 424 >> 2] = d, a[v + 428 >> 2] = m, fr = a[v + 420 >> 2], Me = a[v + 416 >> 2], a[v + 376 >> 2] = -4 - Me, a[v + 380 >> 2] = 262143 - ((Me >>> 0 > 4294967292) + fr | 0), xo = v + 344 | 0, gn(xo, xo, o), na(B, Io), o = a[v + 376 >> 2], Bs = o, m = a[v + 380 >> 2], Xs = m, m = a[B + 36 >> 2] + (m << 1 | o >>> 31) | 0, o = o << 1, d = o, o = o + a[B + 32 >> 2] | 0, m = d >>> 0 > o >>> 0 ? m + 1 | 0 : m, Ho = o, a[B + 32 >> 2] = o, Vn = m, a[B + 36 >> 2] = m, we = B, he = a[B + 24 >> 2], B = a[v + 368 >> 2], js = B, o = a[v + 372 >> 2], ya = o, m = a[we + 28 >> 2] + (o << 1 | B >>> 31) | 0, B = B << 1, o = B, B = B + he | 0, m = o >>> 0 > B >>> 0 ? m + 1 | 0 : m, Go = B, a[we + 24 >> 2] = B, Mo = m, a[we + 28 >> 2] = m, B = a[v + 360 >> 2], sa = B, o = a[v + 364 >> 2], va = o, m = a[we + 20 >> 2] + (o << 1 | B >>> 31) | 0, B = B << 1, o = B, B = B + a[we + 16 >> 2] | 0, m = o >>> 0 > B >>> 0 ? m + 1 | 0 : m, ns = B, a[we + 16 >> 2] = B, qi = m, a[we + 20 >> 2] = m, B = a[v + 352 >> 2], oa = B, o = a[v + 356 >> 2], wa = o, d = a[we + 12 >> 2] + (o << 1 | B >>> 31) | 0, B = B << 1, o = B, B = B + a[we + 8 >> 2] | 0, d = o >>> 0 > B >>> 0 ? d + 1 | 0 : d, ds = B, a[we + 8 >> 2] = B, Si = d, a[we + 12 >> 2] = d, B = a[v + 344 >> 2], Pa = B, o = a[v + 348 >> 2], Ta = o, m = a[we + 4 >> 2] + (o << 1 | B >>> 31) | 0, B = B << 1, o = B, B = B + a[we >> 2] | 0, m = o >>> 0 > B >>> 0 ? m + 1 | 0 : m, Ts = B, a[we >> 2] = B, $i = m, a[we + 4 >> 2] = m, un = v + 104 | 0, dr = Be, he = wr, Sn = Gr << 1, In = Fr << 1 | Gr >>> 31, Lr(un, Be, he, 0, 0, Sn, In, 0, 0), $r = v + 168 | 0, o = ni, B = Oi, Dr = mi << 1, Be = Rr << 1 | mi >>> 31, Lr($r, o, B, 0, 0, Dr, Be, 0, 0), ni = v + 328 | 0, Lr(ni, Me, fr, 0, 0, Me, fr, 0, 0), Qe = v + 312 | 0, Lr(Qe, a[v + 328 >> 2], a[v + 332 >> 2], 0, 0, 15632, 16, 0, 0), d = Me, m = fr << 1 | d >>> 31, Ao = v + 136 | 0, Xn = d << 1, Oi = m, Lr(Ao, Xn, m, 0, 0, Gr, Fr, 0, 0), po = v + 152 | 0, Lr(po, dr, he, 0, 0, Dr, Be, 0, 0), _o = v + 232 | 0, Lr(_o, o, B, 0, 0, o, B, 0, 0), Ti = v + 296 | 0, m = ni + 8 | 0, Lr(Ti, a[m >> 2], a[m + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Uo = v + 120 | 0, Lr(Uo, Gr, Fr, 0, 0, Gr, Fr, 0, 0), ts = v + 200 | 0, Lr(ts, Xn, Oi, 0, 0, mi, Rr, 0, 0), Me = B, ni = o, m = B << 1 | o >>> 31, Lo = v + 248 | 0, wr = dr, fr = he, Lr(Lo, wr, he, 0, 0, o << 1, m, 0, 0), Fr = a[v + 108 >> 2], m = Fr + a[v + 172 >> 2] | 0, he = a[v + 104 >> 2], B = a[v + 168 >> 2], d = he + B | 0, o = a[v + 312 >> 2], Gr = d + o | 0, B = B >>> 0 > d >>> 0 ? m + 1 | 0 : m, m = B + a[v + 316 >> 2] | 0, o = o >>> 0 > Gr >>> 0 ? m + 1 | 0 : m, Be = (B | 0) == (o | 0) & d >>> 0 > Gr >>> 0 | B >>> 0 > o >>> 0, m = Qe + 8 | 0, Dr = a[m >> 2], dr = a[m + 4 >> 2], he = (B | 0) == (Fr | 0) & d >>> 0 < he >>> 0 | B >>> 0 < Fr >>> 0, m = $r + 8 | 0, d = a[m >> 2], B = un + 8 | 0, Fr = d + a[B >> 2] | 0, m = a[B + 4 >> 2] + a[m + 4 >> 2] | 0, m = d >>> 0 > Fr >>> 0 ? m + 1 | 0 : m, B = he + Fr | 0, m = (B >>> 0 < Fr >>> 0 ? m + 1 | 0 : m) + dr | 0, d = B, B = B + Dr | 0, d = d >>> 0 > B >>> 0 ? m + 1 | 0 : m, m = B, B = B + Be | 0, d = m >>> 0 > B >>> 0 ? d + 1 | 0 : d, Fr = o, dr = B << 12 | o >>> 20, o = d << 12 | B >>> 20, Wo = a[v + 152 >> 2], B = a[v + 232 >> 2], Be = Wo + B | 0, Oo = a[v + 156 >> 2], m = Oo + a[v + 236 >> 2] | 0, m = B >>> 0 > Be >>> 0 ? m + 1 | 0 : m, B = a[v + 136 >> 2], Dr = B + Be | 0, $r = m, m = m + a[v + 140 >> 2] | 0, m = B >>> 0 > Dr >>> 0 ? m + 1 | 0 : m, B = a[v + 296 >> 2], he = B + Dr | 0, Qe = m, m = m + a[v + 300 >> 2] | 0, B = B >>> 0 > he >>> 0 ? m + 1 | 0 : m, m = B + o | 0, ps = v + 40 | 0, dr = he + dr | 0, o = dr >>> 0 < he >>> 0 ? m + 1 | 0 : m, Kn = (B | 0) == (o | 0) & he >>> 0 > dr >>> 0 | B >>> 0 > o >>> 0, zi = (B | 0) == (Qe | 0) & he >>> 0 < Dr >>> 0 | B >>> 0 < Qe >>> 0, B = Ti + 8 | 0, uo = a[B >> 2], yo = a[B + 4 >> 2], un = (Qe | 0) == ($r | 0) & Be >>> 0 > Dr >>> 0 | Qe >>> 0 < $r >>> 0, B = Ao + 8 | 0, Ti = a[B >> 2], Qe = a[B + 4 >> 2], Dr = ($r | 0) == (Oo | 0) & Be >>> 0 < Wo >>> 0 | $r >>> 0 < Oo >>> 0, m = _o + 8 | 0, he = a[m >> 2], B = po + 8 | 0, Be = he + a[B >> 2] | 0, m = a[B + 4 >> 2] + a[m + 4 >> 2] | 0, m = he >>> 0 > Be >>> 0 ? m + 1 | 0 : m, B = Be + Dr | 0, m = (B >>> 0 < Be >>> 0 ? m + 1 | 0 : m) + Qe | 0, he = B, B = B + Ti | 0, m = he >>> 0 > B >>> 0 ? m + 1 | 0 : m, he = B, B = B + un | 0, m = (he >>> 0 > B >>> 0 ? m + 1 | 0 : m) + yo | 0, he = B, B = B + uo | 0, m = he >>> 0 > B >>> 0 ? m + 1 | 0 : m, he = B + zi | 0, m = he >>> 0 < B >>> 0 ? m + 1 | 0 : m, d = d >>> 20 | 0, B = d + he | 0, m = d >>> 0 > B >>> 0 ? m + 1 | 0 : m, d = B, B = B + Kn | 0, m = d >>> 0 > B >>> 0 ? m + 1 | 0 : m, Be = B << 12 | o >>> 20, d = m, Dr = m << 12 | B >>> 20, Kn = a[v + 204 >> 2], m = Kn + a[v + 252 >> 2] | 0, zi = a[v + 200 >> 2], B = a[v + 248 >> 2], he = zi + B | 0, Qe = he, Be = he + Be | 0, B = B >>> 0 > he >>> 0 ? m + 1 | 0 : m, m = B + Dr | 0, he = Be >>> 0 < he >>> 0 ? m + 1 | 0 : m, m = he << 4 | Be >>> 28, $r = Be << 4 & -16, Dr = o, Lr(ps, $r | o >>> 16 & 15, m & 16777215, 0, 0, 977, 1, 0, 0), uo = v + 24 | 0, Lr(uo, mi, Rr, 0, 0, Sn, In, 0, 0), yo = v + 216 | 0, Lr(yo, Xn, Oi, 0, 0, ni, Me, 0, 0), un = v + 280 | 0, Lr(un, wr, fr, 0, 0, wr, fr, 0, 0), Ti = v + 88 | 0, $r = (B | 0) == (he | 0) & Be >>> 0 < Qe >>> 0 | B >>> 0 > he >>> 0, Be = (B | 0) == (Kn | 0) & Qe >>> 0 < zi >>> 0 | B >>> 0 < Kn >>> 0, m = Lo + 8 | 0, o = a[m >> 2], B = ts + 8 | 0, Qe = o + a[B >> 2] | 0, m = a[B + 4 >> 2] + a[m + 4 >> 2] | 0, m = o >>> 0 > Qe >>> 0 ? m + 1 | 0 : m, B = d, o = Be + Qe | 0, m = o >>> 0 < Qe >>> 0 ? m + 1 | 0 : m, B = B >>> 20 | 0, d = B, B = B + o | 0, m = d >>> 0 > B >>> 0 ? m + 1 | 0 : m, o = B, B = B + $r | 0, o = o >>> 0 > B >>> 0 ? m + 1 | 0 : m, d = o << 12 | B >>> 20, Be = B << 12 | he >>> 20, he = d, $r = a[v + 216 >> 2], B = a[v + 280 >> 2], d = $r + B | 0, zi = a[v + 220 >> 2], m = zi + a[v + 284 >> 2] | 0, B = B >>> 0 > d >>> 0 ? m + 1 | 0 : m, m = B + he | 0, he = Be, Be = d, d = he + d | 0, he = d >>> 0 < Be >>> 0 ? m + 1 | 0 : m, Lr(Ti, d, he & 1048575, 0, 0, 15632, 16, 0, 0), Qe = v + 8 | 0, Lr(Qe, ni, Me, 0, 0, Sn, In, 0, 0), Sn = v + 184 | 0, Lr(Sn, mi, Rr, 0, 0, mi, Rr, 0, 0), Rr = v + 264 | 0, Lr(Rr, Xn, Oi, 0, 0, wr, fr, 0, 0), Oi = v + 72 | 0, fr = Oi, Me = (B | 0) == (he | 0) & d >>> 0 < Be >>> 0 | B >>> 0 > he >>> 0, Be = (B | 0) == (zi | 0) & Be >>> 0 < $r >>> 0 | B >>> 0 < zi >>> 0, d = un + 8 | 0, m = a[d >> 2], B = yo + 8 | 0, wr = m + a[B >> 2] | 0, d = a[B + 4 >> 2] + a[d + 4 >> 2] | 0, m = m >>> 0 > wr >>> 0 ? d + 1 | 0 : d, d = Be + wr | 0, m = d >>> 0 < wr >>> 0 ? m + 1 | 0 : m, o = o >>> 20 | 0, B = o + d | 0, m = o >>> 0 > B >>> 0 ? m + 1 | 0 : m, o = B, B = B + Me | 0, m = o >>> 0 > B >>> 0 ? m + 1 | 0 : m, Me = B << 12 | he >>> 20, he = a[v + 264 >> 2], wr = Me + he | 0, o = m, B = m << 12 | B >>> 20, d = B + a[v + 268 >> 2] | 0, d = he >>> 0 > wr >>> 0 ? d + 1 | 0 : d, Lr(fr, wr, d, 0, 0, 15632, 16, 0, 0), ni = v + 56 | 0, Be = ni, he = (B | 0) == (d | 0) & Me >>> 0 > wr >>> 0 | B >>> 0 > d >>> 0, B = Rr + 8 | 0, d = a[B >> 2], m = a[B + 4 >> 2], o = o >>> 20 | 0, B = o + d | 0, m = o >>> 0 > B >>> 0 ? m + 1 | 0 : m, o = B, B = B + he | 0, m = o >>> 0 > B >>> 0 ? m + 1 | 0 : m, Lr(Be, B, m, 0, 0, 64028672, 65536, 0, 0), B = v, d = Vn + Xs | 0, o = Ho + Bs | 0, d = o >>> 0 < Ho >>> 0 ? d + 1 | 0 : d, a[B + 376 >> 2] = o, a[B + 380 >> 2] = d, m = Mo + ya | 0, o = Go + js | 0, m = o >>> 0 < Go >>> 0 ? m + 1 | 0 : m, a[B + 368 >> 2] = o, a[B + 372 >> 2] = m, m = qi + va | 0, o = ns + sa | 0, m = o >>> 0 < ns >>> 0 ? m + 1 | 0 : m, a[B + 360 >> 2] = o, a[B + 364 >> 2] = m, m = Si + wa | 0, o = ds + oa | 0, m = o >>> 0 < ds >>> 0 ? m + 1 | 0 : m, a[B + 352 >> 2] = o, a[B + 356 >> 2] = m, Me = B, m = $i + Ta | 0, B = Ts + Pa | 0, m = B >>> 0 < Ts >>> 0 ? m + 1 | 0 : m, a[v + 344 >> 2] = B, a[v + 348 >> 2] = m, gn(we + 40 | 0, xo, Io), Be = we, we = a[we + 40 >> 2], m = a[Be + 44 >> 2], he = a[v + 40 >> 2], o = a[v + 120 >> 2], B = he + o | 0, fr = a[v + 44 >> 2], d = fr + a[v + 124 >> 2] | 0, o = B >>> 0 < o >>> 0 ? d + 1 | 0 : d, m = m + (o & 1048575) | 0, d = B + we | 0, m = d >>> 0 < B >>> 0 ? m + 1 | 0 : m, a[Be + 40 >> 2] = -5862 - d, a[Be + 44 >> 2] = 6291449 - ((d >>> 0 > 4294961434) + m | 0), m = Be + 48 | 0, Rr = m, wr = a[m >> 2], v = a[m + 4 >> 2], he = (o | 0) == (fr | 0) & B >>> 0 < he >>> 0 | o >>> 0 < fr >>> 0, m = Uo + 8 | 0, d = a[m >> 2], B = ps + 8 | 0, we = d + a[B >> 2] | 0, m = a[B + 4 >> 2] + a[m + 4 >> 2] | 0, d = d >>> 0 > we >>> 0 ? m + 1 | 0 : m, B = he + we | 0, d = B >>> 0 < we >>> 0 ? d + 1 | 0 : d, we = B << 12 | o >>> 20, he = d << 12 | B >>> 20, fr = a[Me + 88 >> 2], B = a[Me + 24 >> 2], o = fr + B | 0, Si = a[Me + 92 >> 2], m = Si + a[Me + 28 >> 2] | 0, m = B >>> 0 > o >>> 0 ? m + 1 | 0 : m, B = we, we = o, o = B + o | 0, B = m, m = m + he | 0, he = o >>> 0 < we >>> 0 ? m + 1 | 0 : m, m = v + (he & 1048575) | 0, wr = o + wr | 0, m = wr >>> 0 < o >>> 0 ? m + 1 | 0 : m, a[Rr >> 2] = -6 - wr, a[Rr + 4 >> 2] = 6291455 - ((wr >>> 0 > 4294967290) + m | 0), m = Be + 56 | 0, $i = m, Rr = a[m >> 2], wr = a[m + 4 >> 2], v = (B | 0) == (he | 0) & o >>> 0 < we >>> 0 | B >>> 0 > he >>> 0, we = (B | 0) == (Si | 0) & we >>> 0 < fr >>> 0 | B >>> 0 < Si >>> 0, m = uo + 8 | 0, o = a[m >> 2], B = Ti + 8 | 0, fr = o + a[B >> 2] | 0, m = a[B + 4 >> 2] + a[m + 4 >> 2] | 0, m = o >>> 0 > fr >>> 0 ? m + 1 | 0 : m, o = we + fr | 0, m = o >>> 0 < fr >>> 0 ? m + 1 | 0 : m, d = d >>> 20 | 0, B = o + d | 0, m = d >>> 0 > B >>> 0 ? m + 1 | 0 : m, o = B, B = B + v | 0, m = o >>> 0 > B >>> 0 ? m + 1 | 0 : m, he = B << 12 | he >>> 20, o = m, d = m << 12 | B >>> 20, Vn = a[Me + 8 >> 2], B = a[Me + 184 >> 2], v = Vn + B | 0, In = a[Me + 12 >> 2], m = In + a[Me + 188 >> 2] | 0, m = B >>> 0 > v >>> 0 ? m + 1 | 0 : m, B = a[Me + 72 >> 2], we = B + v | 0, fr = m, m = m + a[Me + 76 >> 2] | 0, B = B >>> 0 > we >>> 0 ? m + 1 | 0 : m, m = B + d | 0, he = he + we | 0, d = he >>> 0 < we >>> 0 ? m + 1 | 0 : m, m = wr + (d & 1048575) | 0, Rr = he + Rr | 0, m = Rr >>> 0 < he >>> 0 ? m + 1 | 0 : m, a[$i >> 2] = -6 - Rr, a[$i + 4 >> 2] = 6291455 - ((Rr >>> 0 > 4294967290) + m | 0), m = Be - -64 | 0, mi = m, Mo = a[m >> 2], qi = a[m + 4 >> 2], Si = (B | 0) == (d | 0) & he >>> 0 < we >>> 0 | B >>> 0 > d >>> 0, $i = (B | 0) == (fr | 0) & v >>> 0 > we >>> 0 | B >>> 0 < fr >>> 0, B = Oi + 8 | 0, Rr = a[B >> 2], wr = a[B + 4 >> 2], we = (fr | 0) == (In | 0) & v >>> 0 < Vn >>> 0 | fr >>> 0 < In >>> 0, m = Sn + 8 | 0, he = a[m >> 2], B = Qe + 8 | 0, v = he + a[B >> 2] | 0, m = a[B + 4 >> 2] + a[m + 4 >> 2] | 0, m = v >>> 0 < he >>> 0 ? m + 1 | 0 : m, B = v + we | 0, m = (B >>> 0 < v >>> 0 ? m + 1 | 0 : m) + wr | 0, he = B, B = B + Rr | 0, m = he >>> 0 > B >>> 0 ? m + 1 | 0 : m, he = B + $i | 0, m = he >>> 0 < B >>> 0 ? m + 1 | 0 : m, o = o >>> 20 | 0, B = o + he | 0, m = o >>> 0 > B >>> 0 ? m + 1 | 0 : m, o = B, B = B + Si | 0, m = o >>> 0 > B >>> 0 ? m + 1 | 0 : m, he = B << 12 | d >>> 20, o = m, v = m << 12 | B >>> 20, fr = a[Me + 56 >> 2], d = Gr & -2, B = fr + d | 0, wr = a[Me + 60 >> 2], m = wr + (Fr & 1048575) | 0, we = B >>> 0 < d >>> 0 ? m + 1 | 0 : m, m = we + v | 0, d = he, he = B, d = d + B | 0, B = d >>> 0 < B >>> 0 ? m + 1 | 0 : m, m = qi + (B & 1048575) | 0, v = d + Mo | 0, m = v >>> 0 < d >>> 0 ? m + 1 | 0 : m, a[mi >> 2] = -6 - v, a[mi + 4 >> 2] = 6291455 - ((v >>> 0 > 4294967290) + m | 0), m = Be + 72 | 0, Gr = m, Fr = a[m >> 2], Be = a[m + 4 >> 2], Dr = Dr & 65535, v = (B | 0) == (we | 0) & d >>> 0 < he >>> 0 | B >>> 0 < we >>> 0, d = (we | 0) == (wr | 0) & he >>> 0 < fr >>> 0 | we >>> 0 < wr >>> 0, m = ni + 8 | 0, he = d + a[m >> 2] | 0, m = a[m + 4 >> 2], m = d >>> 0 > he >>> 0 ? m + 1 | 0 : m, o = o >>> 20 | 0, d = o, o = o + he | 0, m = d >>> 0 > o >>> 0 ? m + 1 | 0 : m, d = o, o = o + v | 0, m = d >>> 0 > o >>> 0 ? m + 1 | 0 : m, B = o << 12 | B >>> 20, he = B + dr | 0, d = Dr + (m << 12 | o >>> 20) | 0, m = (B >>> 0 > he >>> 0 ? d + 1 | 0 : d) + Be | 0, B = he + Fr | 0, m = B >>> 0 < he >>> 0 ? m + 1 | 0 : m, a[Gr >> 2] = -6 - B, a[Gr + 4 >> 2] = 393215 - ((B >>> 0 > 4294967290) + m | 0), be = Me + 464 | 0;
  }
  function fs(B, o) {
    var m = 0, d = 0, v = 0, he = 0, we = 0, Be = 0, Me = 0, fr = 0, wr = 0, dr = 0, Dr = 0, Rr = 0, Qe = 0, Fr = 0, Gr = 0, $r = 0, ni = 0;
    Be = be - 80 | 0, be = Be;
    e: {
      if (a[o + 120 >> 2]) {
        a[B + 80 >> 2] = 1, xi(B, 80);
        break e;
      }
      dr = o + 88 | 0, v = a[dr >> 2], we = a[dr + 4 >> 2], he = a[o + 84 >> 2], d = o + 112 | 0, Qe = a[d >> 2], Me = a[d + 4 >> 2], Fr = Me, d = a[o + 80 >> 2], m = oi(Me >>> 16 | 0, 0, 977, 1), wr = d + m | 0, he = he + Fe | 0, d = we, fr = m >>> 0 > wr >>> 0 ? he + 1 | 0 : he, m = fr >>> 20 | 0, we = m, m = m + v | 0, we = we >>> 0 > m >>> 0 ? d + 1 | 0 : d, Gr = we & 1048575, he = o + 104 | 0, Rr = a[he >> 2], $r = a[he + 4 >> 2], he = o + 96 | 0, Me = a[he >> 2], v = a[he + 4 >> 2], he = we >>> 20 | 0, Me = he + Me | 0, v = he >>> 0 > Me >>> 0 ? v + 1 | 0 : v, d = $r, Dr = v, v = v >>> 20 | 0, he = v + Rr | 0, d = v >>> 0 > he >>> 0 ? d + 1 | 0 : d, Rr = d & 1048575, $r = o + 80 | 0, v = Me, Dr = Dr & 1048575, ni = (m & v & he) == -1 & (we & Dr & d) == 1048575, we = d >>> 20 | 0, d = Fr & 65535, Me = we + Qe | 0, we = Me >>> 0 < we >>> 0 ? d + 1 | 0 : d, d = fr & 1048575, Qe = d, ni & ((Me | 0) == -1 & (we | 0) == 65535) & ((d | 0) == 1048574 & wr >>> 0 > 4294966318 | d >>> 0 > 1048574) | we >>> 16 && (d = Qe + 1 | 0, wr = wr + 977 | 0, d = wr >>> 0 < 977 ? d + 1 | 0 : d, Qe = d & 1048575, fr = d, d = Gr, fr = fr >>> 20 | 0, m = m + fr | 0, d = fr >>> 0 > m >>> 0 ? d + 1 | 0 : d, Gr = d & 1048575, fr = v, Fr = d >>> 20 | 0, v = Dr, d = fr + Fr | 0, v = d >>> 0 < Fr >>> 0 ? v + 1 | 0 : v, Dr = v & 1048575, fr = v, v = d, d = Rr, fr = fr >>> 20 | 0, he = he + fr | 0, d = fr >>> 0 > he >>> 0 ? d + 1 | 0 : d, Rr = d & 1048575, fr = d, d = we, we = Me, Me = (fr >>> 20 | 0) + Me | 0, we = (we >>> 0 > Me >>> 0 ? d + 1 | 0 : d) & 65535), a[Be + 72 >> 2] = we >>> 8, a[Be + 76 >> 2] = 0, d = we << 22 | Me >>> 10, a[Be + 64 >> 2] = Me << 22 & -4194304 | ((Rr & 1073741823) << 2 | he >>> 30), a[Be + 68 >> 2] = d & 1073741823 | Rr >>> 30, a[Be + 56 >> 2] = (Dr & 1048575) << 12 | v >>> 20, a[Be + 60 >> 2] = he & 1073741823 | Dr >>> 20, v = v << 10 & 1073740800, a[Be + 48 >> 2] = (Gr & 1023) << 22 | m >>> 10, a[Be + 52 >> 2] = Gr >>> 10 | v, a[Be + 40 >> 2] = wr, a[Be + 44 >> 2] = Qe | m << 20 & 1072693248, wr = Be + 40 | 0, Hi(wr, 690464), he = a[Be + 44 >> 2], v = he, a[o + 80 >> 2] = a[Be + 40 >> 2], a[o + 84 >> 2] = v & 1048575, he = a[Be + 72 >> 2] << 8, Me = a[Be + 68 >> 2], d = Me >>> 22 | 0, we = a[Be + 64 >> 2], a[o + 112 >> 2] = (Me & 4194303) << 10 | we >>> 22, a[o + 116 >> 2] = d | he, m = we, d = Me << 30 | m >>> 2, we = m << 30 & -1073741824, m = a[Be + 56 >> 2], he = a[Be + 60 >> 2], a[o + 104 >> 2] = he | we, a[o + 108 >> 2] = d & 1048575, he = he << 20 | m >>> 12, we = m << 20 & -1048576, Me = he & 1048575, m = a[Be + 48 >> 2], he = a[Be + 52 >> 2], a[o + 96 >> 2] = he >>> 10 | we, a[o + 100 >> 2] = Me, d = he << 10 | m >>> 22, a[o + 88 >> 2] = m << 10 & -1024 | v >>> 20, a[o + 92 >> 2] = d & 1048575, na(wr, $r), gn(Be, $r, wr), gn(o, o, wr), m = o + 40 | 0, gn(m, m, Be), a[dr >> 2] = 0, a[dr + 4 >> 2] = 0, m = dr + 8 | 0, a[m >> 2] = 0, a[m + 4 >> 2] = 0, m = dr + 16 | 0, a[m >> 2] = 0, a[m + 4 >> 2] = 0, m = dr + 24 | 0, a[m >> 2] = 0, a[m + 4 >> 2] = 0, a[B + 80 >> 2] = 0, a[o + 80 >> 2] = 1, a[o + 84 >> 2] = 0, m = a[o + 4 >> 2], a[B >> 2] = a[o >> 2], a[B + 4 >> 2] = m, m = o + 8 | 0, he = a[m + 4 >> 2], v = B + 8 | 0, a[v >> 2] = a[m >> 2], a[v + 4 >> 2] = he, m = o + 16 | 0, he = a[m + 4 >> 2], v = B + 16 | 0, a[v >> 2] = a[m >> 2], a[v + 4 >> 2] = he, m = o + 24 | 0, he = a[m + 4 >> 2], v = B + 24 | 0, a[v >> 2] = a[m >> 2], a[v + 4 >> 2] = he, m = o + 32 | 0, he = a[m + 4 >> 2], v = B + 32 | 0, a[v >> 2] = a[m >> 2], a[v + 4 >> 2] = he, m = o + 72 | 0, he = a[m + 4 >> 2], v = B + 72 | 0, a[v >> 2] = a[m >> 2], a[v + 4 >> 2] = he, m = o - -64 | 0, he = a[m + 4 >> 2], v = B - -64 | 0, a[v >> 2] = a[m >> 2], a[v + 4 >> 2] = he, m = o + 56 | 0, he = a[m + 4 >> 2], v = B + 56 | 0, a[v >> 2] = a[m >> 2], a[v + 4 >> 2] = he, m = o + 48 | 0, he = a[m + 4 >> 2], v = B + 48 | 0, a[v >> 2] = a[m >> 2], a[v + 4 >> 2] = he, m = a[o + 44 >> 2], a[B + 40 >> 2] = a[o + 40 >> 2], a[B + 44 >> 2] = m;
    }
    be = Be + 80 | 0;
  }
  function da(B, o, m) {
    var d = 0, v = 0;
    v = be - 128 | 0, be = v;
    e: {
      if (!o) {
        ji[a[B + 168 >> 2]](689638, a[B + 172 >> 2]), B = 0;
        break e;
      }
      if (u[o | 0] = 0, u[o + 1 | 0] = 0, u[o + 2 | 0] = 0, u[o + 3 | 0] = 0, u[o + 4 | 0] = 0, u[o + 5 | 0] = 0, u[o + 6 | 0] = 0, u[o + 7 | 0] = 0, d = o + 56 | 0, u[d | 0] = 0, u[d + 1 | 0] = 0, u[d + 2 | 0] = 0, u[d + 3 | 0] = 0, u[d + 4 | 0] = 0, u[d + 5 | 0] = 0, u[d + 6 | 0] = 0, u[d + 7 | 0] = 0, d = o + 48 | 0, u[d | 0] = 0, u[d + 1 | 0] = 0, u[d + 2 | 0] = 0, u[d + 3 | 0] = 0, u[d + 4 | 0] = 0, u[d + 5 | 0] = 0, u[d + 6 | 0] = 0, u[d + 7 | 0] = 0, d = o + 40 | 0, u[d | 0] = 0, u[d + 1 | 0] = 0, u[d + 2 | 0] = 0, u[d + 3 | 0] = 0, u[d + 4 | 0] = 0, u[d + 5 | 0] = 0, u[d + 6 | 0] = 0, u[d + 7 | 0] = 0, d = o + 32 | 0, u[d | 0] = 0, u[d + 1 | 0] = 0, u[d + 2 | 0] = 0, u[d + 3 | 0] = 0, u[d + 4 | 0] = 0, u[d + 5 | 0] = 0, u[d + 6 | 0] = 0, u[d + 7 | 0] = 0, d = o + 24 | 0, u[d | 0] = 0, u[d + 1 | 0] = 0, u[d + 2 | 0] = 0, u[d + 3 | 0] = 0, u[d + 4 | 0] = 0, u[d + 5 | 0] = 0, u[d + 6 | 0] = 0, u[d + 7 | 0] = 0, d = o + 16 | 0, u[d | 0] = 0, u[d + 1 | 0] = 0, u[d + 2 | 0] = 0, u[d + 3 | 0] = 0, u[d + 4 | 0] = 0, u[d + 5 | 0] = 0, u[d + 6 | 0] = 0, u[d + 7 | 0] = 0, d = o + 8 | 0, u[d | 0] = 0, u[d + 1 | 0] = 0, u[d + 2 | 0] = 0, u[d + 3 | 0] = 0, u[d + 4 | 0] = 0, u[d + 5 | 0] = 0, u[d + 6 | 0] = 0, u[d + 7 | 0] = 0, !m) {
        ji[a[B + 168 >> 2]](689936, a[B + 172 >> 2]), B = 0;
        break e;
      }
      if (B = 0, !so(v, m) || (B = 0, !Do(v + 40 | 0, v, 0)))
        break e;
      Gn(o, v + 40 | 0), B = 1;
    }
    return be = v + 128 | 0, B;
  }
  function Bn(B, o) {
    var m = 0, d = 0, v = 0, he = 0, we = 0, Be = 0, Me = 0, fr = 0, wr = 0, dr = 0, Dr = 0, Rr = 0, Qe = 0, Fr = 0;
    d = be - 96 | 0, be = d, u[690885] = 0, u[690886] = 0, u[690887] = 0, u[690888] = 0, u[690889] = 0, u[690890] = 0, u[690891] = 0, u[690892] = 0, u[690909] = 0, u[690910] = 0, u[690911] = 0, u[690912] = 0, u[690913] = 0, u[690914] = 0, u[690915] = 0, u[690916] = 0, u[690901] = 0, u[690902] = 0, u[690903] = 0, u[690904] = 0, u[690905] = 0, u[690906] = 0, u[690907] = 0, u[690908] = 0, u[690893] = 0, u[690894] = 0, u[690895] = 0, u[690896] = 0, u[690897] = 0, u[690898] = 0, u[690899] = 0, u[690900] = 0;
    e: {
      if (!o) {
        ji[a[B + 168 >> 2]](689638, a[B + 172 >> 2]);
        break e;
      }
      if (he = A[o + 60 | 0] | A[o + 61 | 0] << 8 | (A[o + 62 | 0] << 16 | A[o + 63 | 0] << 24), Me = he >>> 16 | 0, v = d + 80 | 0, m = A[o + 56 | 0] | A[o + 57 | 0] << 8 | (A[o + 58 | 0] << 16 | A[o + 59 | 0] << 24), a[v >> 2] = (he & 65535) << 16 | m >>> 16, a[v + 4 >> 2] = Me, Be = m << 4 & 1048560, v = A[o + 52 | 0] | A[o + 53 | 0] << 8 | (A[o + 54 | 0] << 16 | A[o + 55 | 0] << 24), m = v >>> 28 | 0, we = d + 72 | 0, he = A[o + 48 | 0] | A[o + 49 | 0] << 8 | (A[o + 50 | 0] << 16 | A[o + 51 | 0] << 24), a[we >> 2] = (v & 268435455) << 4 | he >>> 28, a[we + 4 >> 2] = m | Be, m = he, Me = v << 24 | m >>> 8, he = A[o + 40 | 0] | A[o + 41 | 0] << 8 | (A[o + 42 | 0] << 16 | A[o + 43 | 0] << 24), Be = d - -64 | 0, v = A[o + 44 | 0] | A[o + 45 | 0] << 8 | (A[o + 46 | 0] << 16 | A[o + 47 | 0] << 24), a[Be >> 2] = m << 24 & -16777216 | v >>> 8, a[Be + 4 >> 2] = Me & 1048575, m = he, v = (v << 12 | m >>> 20) & 1048575, Be = A[o + 32 | 0] | A[o + 33 | 0] << 8 | (A[o + 34 | 0] << 16 | A[o + 35 | 0] << 24), we = d + 56 | 0, fr = A[o + 36 | 0] | A[o + 37 | 0] << 8 | (A[o + 38 | 0] << 16 | A[o + 39 | 0] << 24), a[we >> 2] = m << 12 & -4096 | fr >>> 20, a[we + 4 >> 2] = v, a[d + 88 >> 2] = 0, a[d + 48 >> 2] = Be, a[d + 52 >> 2] = fr & 1048575, he = A[o + 12 | 0] | A[o + 13 | 0] << 8 | (A[o + 14 | 0] << 16 | A[o + 15 | 0] << 24), m = A[o + 8 | 0] | A[o + 9 | 0] << 8 | (A[o + 10 | 0] << 16 | A[o + 11 | 0] << 24), Me = he << 12 | m >>> 20, v = m << 12 & -4096, m = A[o | 0] | A[o + 1 | 0] << 8 | (A[o + 2 | 0] << 16 | A[o + 3 | 0] << 24), fr = A[o + 4 | 0] | A[o + 5 | 0] << 8 | (A[o + 6 | 0] << 16 | A[o + 7 | 0] << 24), wr = fr >>> 20 | v, a[d + 16 >> 2] = wr, dr = Me & 1048575, a[d + 20 >> 2] = dr, v = m, a[d + 8 >> 2] = m, Dr = fr & 1048575, a[d + 12 >> 2] = Dr, we = A[o + 28 | 0] | A[o + 29 | 0] << 8 | (A[o + 30 | 0] << 16 | A[o + 31 | 0] << 24), m = we >>> 16 | 0, Be = A[o + 24 | 0] | A[o + 25 | 0] << 8 | (A[o + 26 | 0] << 16 | A[o + 27 | 0] << 24), fr = (we & 65535) << 16 | Be >>> 16, a[d + 40 >> 2] = fr, we = m, a[d + 44 >> 2] = m, m = A[o + 16 | 0] | A[o + 17 | 0] << 8 | (A[o + 18 | 0] << 16 | A[o + 19 | 0] << 24), Qe = m, Rr = A[o + 20 | 0] | A[o + 21 | 0] << 8 | (A[o + 22 | 0] << 16 | A[o + 23 | 0] << 24), o = m, m = Rr << 24 | o >>> 8, he = o << 24 & -16777216 | he >>> 8, a[d + 24 >> 2] = he, Me = m & 1048575, a[d + 28 >> 2] = Me, o = Rr, m = o >>> 28 | 0, o = (o & 268435455) << 4 | Qe >>> 28, a[d + 32 >> 2] = o, m = m | Be << 4 & 1048560, a[d + 36 >> 2] = m, !(v | wr | fr | he | o | (dr | Dr | we | Me | m))) {
        ji[a[B + 168 >> 2]](690116, a[B + 172 >> 2]);
        break e;
      }
      hn(690885, d + 8 | 0), Fr = 1;
    }
    return be = d + 96 | 0, Fr;
  }
  function hi(B, o, m, d) {
    var v = 0, he = 0, we = 0, Be = 0, Me = 0, fr = 0, wr = 0, dr = 0, Dr = 0, Rr = 0, Qe = 0, Fr = 0, Gr = 0, $r = 0, ni = 0, mi = 0, Si = 0, Oi = 0, $i = 0, zi = 0, un = 0, In = 0, Ti = 0, Sn = 0;
    v = be - 96 | 0, be = v;
    e: {
      if (!o) {
        ji[a[B + 168 >> 2]](689586, a[B + 172 >> 2]), B = 0;
        break e;
      }
      if (!d) {
        ji[a[B + 168 >> 2]](689638, a[B + 172 >> 2]), B = 0;
        break e;
      }
      if (dr = A[d + 60 | 0] | A[d + 61 | 0] << 8 | (A[d + 62 | 0] << 16 | A[d + 63 | 0] << 24), he = dr >>> 16 | 0, we = v + 80 | 0, Be = A[d + 56 | 0] | A[d + 57 | 0] << 8 | (A[d + 58 | 0] << 16 | A[d + 59 | 0] << 24), dr = (dr & 65535) << 16 | Be >>> 16, a[we >> 2] = dr, un = he, a[we + 4 >> 2] = he, wr = Be << 4 & 1048560, Me = A[d + 52 | 0] | A[d + 53 | 0] << 8 | (A[d + 54 | 0] << 16 | A[d + 55 | 0] << 24), he = Me >>> 28 | 0, we = v + 72 | 0, Be = A[d + 48 | 0] | A[d + 49 | 0] << 8 | (A[d + 50 | 0] << 16 | A[d + 51 | 0] << 24), Rr = (Me & 268435455) << 4 | Be >>> 28, a[we >> 2] = Rr, Gr = he | wr, a[we + 4 >> 2] = Gr, he = Me << 24 | Be >>> 8, wr = Be << 24 & -16777216, Be = A[d + 40 | 0] | A[d + 41 | 0] << 8 | (A[d + 42 | 0] << 16 | A[d + 43 | 0] << 24), we = v - -64 | 0, Me = A[d + 44 | 0] | A[d + 45 | 0] << 8 | (A[d + 46 | 0] << 16 | A[d + 47 | 0] << 24), Qe = Me >>> 8 | wr, a[we >> 2] = Qe, $r = he & 1048575, a[we + 4 >> 2] = $r, he = Be, wr = Me << 12 | he >>> 20, Be = A[d + 32 | 0] | A[d + 33 | 0] << 8 | (A[d + 34 | 0] << 16 | A[d + 35 | 0] << 24), we = v + 56 | 0, fr = A[d + 36 | 0] | A[d + 37 | 0] << 8 | (A[d + 38 | 0] << 16 | A[d + 39 | 0] << 24), Fr = he << 12 & -4096 | fr >>> 20, a[we >> 2] = Fr, ni = wr & 1048575, a[we + 4 >> 2] = ni, a[v + 88 >> 2] = 0, a[v + 48 >> 2] = Be, mi = fr & 1048575, a[v + 52 >> 2] = mi, he = A[d + 12 | 0] | A[d + 13 | 0] << 8 | (A[d + 14 | 0] << 16 | A[d + 15 | 0] << 24), we = he, Me = A[d + 8 | 0] | A[d + 9 | 0] << 8 | (A[d + 10 | 0] << 16 | A[d + 11 | 0] << 24), fr = (he << 12 | Me >>> 20) & 1048575, he = A[d | 0] | A[d + 1 | 0] << 8 | (A[d + 2 | 0] << 16 | A[d + 3 | 0] << 24), Dr = A[d + 4 | 0] | A[d + 5 | 0] << 8 | (A[d + 6 | 0] << 16 | A[d + 7 | 0] << 24), Si = Me << 12 & -4096 | Dr >>> 20, a[v + 16 >> 2] = Si, In = fr, a[v + 20 >> 2] = fr, Me = he, a[v + 8 >> 2] = he, Oi = Dr & 1048575, a[v + 12 >> 2] = Oi, fr = A[d + 28 | 0] | A[d + 29 | 0] << 8 | (A[d + 30 | 0] << 16 | A[d + 31 | 0] << 24), he = fr >>> 16 | 0, wr = A[d + 24 | 0] | A[d + 25 | 0] << 8 | (A[d + 26 | 0] << 16 | A[d + 27 | 0] << 24), Dr = (fr & 65535) << 16 | wr >>> 16, a[v + 40 >> 2] = Dr, fr = he, a[v + 44 >> 2] = he, he = A[d + 16 | 0] | A[d + 17 | 0] << 8 | (A[d + 18 | 0] << 16 | A[d + 19 | 0] << 24), Ti = he, $i = A[d + 20 | 0] | A[d + 21 | 0] << 8 | (A[d + 22 | 0] << 16 | A[d + 23 | 0] << 24), d = he, zi = ($i << 24 | d >>> 8) & 1048575, we = d << 24 & -16777216 | we >>> 8, a[v + 24 >> 2] = we, a[v + 28 >> 2] = zi, d = $i, he = d >>> 28 | 0, d = (d & 268435455) << 4 | Ti >>> 28, a[v + 32 >> 2] = d, he = he | wr << 4 & 1048560, a[v + 36 >> 2] = he, !(Me | Si | Dr | we | d | (In | Oi | fr | zi | he))) {
        ji[a[B + 168 >> 2]](690116, a[B + 172 >> 2]), B = 0;
        break e;
      }
      Be & 1 && (a[v + 80 >> 2] = -4 - dr, a[v + 84 >> 2] = 262143 - ((dr >>> 0 > 4294967292) + un | 0), a[v + 72 >> 2] = -4 - Rr, a[v + 76 >> 2] = 4194303 - ((Rr >>> 0 > 4294967292) + Gr | 0), a[v + 64 >> 2] = -4 - Qe, a[v + 68 >> 2] = 4194303 - ((Qe >>> 0 > 4294967292) + $r | 0), a[v + 56 >> 2] = -4 - Fr, a[v + 60 >> 2] = 4194303 - ((Fr >>> 0 > 4294967292) + ni | 0), a[v + 48 >> 2] = -3908 - Be, a[v + 52 >> 2] = 4194299 - ((Be >>> 0 > 4294963388) + mi | 0), Sn = 1), m && (a[m >> 2] = Sn), Gn(o, v + 8 | 0), B = 1;
    }
    return be = v + 96 | 0, B;
  }
  function Ii(B, o) {
    var m = 0, d = 0, v = 0, he = 0, we = 0, Be = 0, Me = 0, fr = 0, wr = 0, dr = 0, Dr = 0, Rr = 0, Qe = 0, Fr = 0;
    m = be - 256 | 0, be = m;
    e: {
      if (!o) {
        ji[a[B + 168 >> 2]](689700, a[B + 172 >> 2]);
        break e;
      }
      if (we = xi(o, 96), !a[B >> 2]) {
        ji[a[B + 168 >> 2]](690045, a[B + 172 >> 2]);
        break e;
      }
      for (d = m + 96 | 0, Be = m + 128 | 0, Rn(d, 690788, Be), fr = a[m + 120 >> 2], wr = a[m + 112 >> 2], v = a[m + 104 >> 2], dr = a[m + 96 >> 2], Dr = a[m + 124 >> 2], Rr = a[m + 116 >> 2], Qe = a[m + 108 >> 2], Fr = a[m + 100 >> 2], Me = a[m + 128 >> 2] | !(fr | (wr | (v | dr)) | (Dr | (Rr | (Qe | Fr)))), o = Me ? 0 : -1, a[m + 120 >> 2] = o & fr, a[m + 124 >> 2] = o & Dr, a[m + 112 >> 2] = o & wr, a[m + 116 >> 2] = o & Rr, a[m + 104 >> 2] = o & v, a[m + 108 >> 2] = o & Qe, v = (Me | 0) != 0, a[m + 96 >> 2] = v | o & dr, a[m + 100 >> 2] = o & Fr, xs(B, Be, d), B = m + 8 | 0, Fo(B, Be), vo(we, d), Gn(we + 32 | 0, B), a[m + 128 >> 2] = v, B = a[m + 128 >> 2] - 1 | 0; o = he + we | 0, u[o | 0] = A[o | 0] & B, d = o + 1 | 0, u[d | 0] = A[d | 0] & B, d = o + 2 | 0, u[d | 0] = A[d | 0] & B, d = o + 3 | 0, u[d | 0] = A[d | 0] & B, d = o + 4 | 0, u[d | 0] = A[d | 0] & B, o = o + 5 | 0, u[o | 0] = A[o | 0] & B, he = he + 6 | 0, (he | 0) != 96; )
        ;
      he = !Me;
    }
    return be = m + 256 | 0, he;
  }
  function Gi(B, o, m, d, v, he, we, Be) {
    B = B | 0, o = o | 0, m = m | 0, d = d | 0, v = v | 0, he = he | 0, we = we | 0, Be = Be | 0;
    var Me = 0, fr = 0;
    if (Me = be - 176 | 0, be = Me, he) {
      e: {
        if (!Be) {
          u[Me | 0] = A[d | 0] ^ 84, u[Me + 1 | 0] = A[d + 1 | 0] ^ 241, u[Me + 2 | 0] = A[d + 2 | 0] ^ 105, u[Me + 3 | 0] = A[d + 3 | 0] ^ 207, u[Me + 4 | 0] = A[d + 4 | 0] ^ 201, u[Me + 5 | 0] = A[d + 5 | 0] ^ 226, u[Me + 6 | 0] = A[d + 6 | 0] ^ 229, u[Me + 7 | 0] = A[d + 7 | 0] ^ 114, u[Me + 8 | 0] = A[d + 8 | 0] ^ 116, u[Me + 9 | 0] = A[d + 9 | 0] ^ 128, u[Me + 10 | 0] = A[d + 10 | 0] ^ 68, u[Me + 11 | 0] = A[d + 11 | 0] ^ 31, u[Me + 12 | 0] = A[d + 12 | 0] ^ 144, u[Me + 13 | 0] = A[d + 13 | 0] ^ 186, u[Me + 14 | 0] = A[d + 14 | 0] ^ 37, u[Me + 15 | 0] = A[d + 15 | 0] ^ 196, u[Me + 16 | 0] = A[d + 16 | 0] ^ 136, u[Me + 17 | 0] = A[d + 17 | 0] ^ 244, u[Me + 18 | 0] = A[d + 18 | 0] ^ 97, u[Me + 19 | 0] = A[d + 19 | 0] ^ 199, u[Me + 20 | 0] = A[d + 20 | 0] ^ 11, u[Me + 21 | 0] = A[d + 21 | 0] ^ 94, u[Me + 22 | 0] = A[d + 22 | 0] ^ 165, u[Me + 23 | 0] = A[d + 23 | 0] ^ 220, u[Me + 24 | 0] = A[d + 24 | 0] ^ 170, u[Me + 25 | 0] = A[d + 25 | 0] ^ 247, u[Me + 26 | 0] = A[d + 26 | 0] ^ 175, u[Me + 27 | 0] = A[d + 27 | 0] ^ 105, u[Me + 28 | 0] = A[d + 28 | 0] ^ 39, u[Me + 29 | 0] = A[d + 29 | 0] ^ 10, u[Me + 30 | 0] = A[d + 30 | 0] ^ 165, u[Me + 31 | 0] = A[d + 31 | 0] ^ 20;
          break e;
        }
        a[Me + 136 >> 2] = 64, a[Me + 140 >> 2] = 0, a[Me + 64 >> 2] = 1252796217, a[Me + 68 >> 2] = 614368522, a[Me + 56 >> 2] = 989586609, a[Me + 60 >> 2] = 1279582103, a[Me + 48 >> 2] = -904942663, a[Me + 52 >> 2] = 262346349, a[Me + 40 >> 2] = 618476057, a[Me + 44 >> 2] = 1320844912, fr = Me + 40 | 0, Di(fr, Be, 32), _n(fr, Me), u[Me | 0] = A[Me | 0] ^ A[d | 0], u[Me + 1 | 0] = A[Me + 1 | 0] ^ A[d + 1 | 0], u[Me + 2 | 0] = A[Me + 2 | 0] ^ A[d + 2 | 0], u[Me + 3 | 0] = A[Me + 3 | 0] ^ A[d + 3 | 0], u[Me + 4 | 0] = A[Me + 4 | 0] ^ A[d + 4 | 0], u[Me + 5 | 0] = A[Me + 5 | 0] ^ A[d + 5 | 0], u[Me + 6 | 0] = A[Me + 6 | 0] ^ A[d + 6 | 0], u[Me + 7 | 0] = A[Me + 7 | 0] ^ A[d + 7 | 0], u[Me + 8 | 0] = A[Me + 8 | 0] ^ A[d + 8 | 0], u[Me + 9 | 0] = A[Me + 9 | 0] ^ A[d + 9 | 0], u[Me + 10 | 0] = A[Me + 10 | 0] ^ A[d + 10 | 0], u[Me + 11 | 0] = A[Me + 11 | 0] ^ A[d + 11 | 0], u[Me + 12 | 0] = A[Me + 12 | 0] ^ A[d + 12 | 0], u[Me + 13 | 0] = A[Me + 13 | 0] ^ A[d + 13 | 0], u[Me + 14 | 0] = A[Me + 14 | 0] ^ A[d + 14 | 0], u[Me + 15 | 0] = A[Me + 15 | 0] ^ A[d + 15 | 0], u[Me + 16 | 0] = A[Me + 16 | 0] ^ A[d + 16 | 0], u[Me + 17 | 0] = A[Me + 17 | 0] ^ A[d + 17 | 0], u[Me + 18 | 0] = A[Me + 18 | 0] ^ A[d + 18 | 0], u[Me + 19 | 0] = A[Me + 19 | 0] ^ A[d + 19 | 0], u[Me + 20 | 0] = A[Me + 20 | 0] ^ A[d + 20 | 0], u[Me + 21 | 0] = A[Me + 21 | 0] ^ A[d + 21 | 0], u[Me + 22 | 0] = A[Me + 22 | 0] ^ A[d + 22 | 0], u[Me + 23 | 0] = A[Me + 23 | 0] ^ A[d + 23 | 0], u[Me + 24 | 0] = A[Me + 24 | 0] ^ A[d + 24 | 0], u[Me + 25 | 0] = A[Me + 25 | 0] ^ A[d + 25 | 0], u[Me + 26 | 0] = A[Me + 26 | 0] ^ A[d + 26 | 0], u[Me + 27 | 0] = A[Me + 27 | 0] ^ A[d + 27 | 0], u[Me + 28 | 0] = A[Me + 28 | 0] ^ A[d + 28 | 0], u[Me + 29 | 0] = A[Me + 29 | 0] ^ A[d + 29 | 0], u[Me + 30 | 0] = A[Me + 30 | 0] ^ A[d + 30 | 0], u[Me + 31 | 0] = A[Me + 31 | 0] ^ A[d + 31 | 0];
      }
      e: {
        if ((we | 0) == 13) {
          t: {
            if (A[he | 0] != 66 || A[he + 1 | 0] != 73 || A[he + 2 | 0] != 80 || A[he + 3 | 0] != 48 || A[he + 4 | 0] != 51 || A[he + 5 | 0] != 52 || A[he + 6 | 0] != 48 || A[he + 7 | 0] != 47 || A[he + 8 | 0] != 110 || A[he + 9 | 0] != 111 || A[he + 10 | 0] != 110 || A[he + 11 | 0] != 99 || A[he + 12 | 0] != 101)
              break t;
            a[Me + 136 >> 2] = 64, a[Me + 140 >> 2] = 0, a[Me + 64 >> 2] = 564305492, a[Me + 68 >> 2] = 1756396364, a[Me + 56 >> 2] = 1612804480, a[Me + 60 >> 2] = 1463125601, a[Me + 48 >> 2] = -1618098575, a[Me + 52 >> 2] = -2090698061, a[Me + 40 >> 2] = 1180785461, a[Me + 44 >> 2] = -188760073;
            break e;
          }
          a[Me + 136 >> 2] = 0, a[Me + 140 >> 2] = 0, a[Me + 64 >> 2] = 528734635, a[Me + 68 >> 2] = 1541459225, a[Me + 56 >> 2] = 1359893119, a[Me + 60 >> 2] = -1694144372, a[Me + 48 >> 2] = 1013904242, a[Me + 52 >> 2] = -1521486534, a[Me + 40 >> 2] = 1779033703, a[Me + 44 >> 2] = -1150833019, d = Me + 40 | 0, Di(d, he, 13), he = Me + 144 | 0, _n(d, he), a[Me + 136 >> 2] = 0, a[Me + 140 >> 2] = 0, a[Me + 64 >> 2] = 528734635, a[Me + 68 >> 2] = 1541459225, a[Me + 56 >> 2] = 1359893119, a[Me + 60 >> 2] = -1694144372, a[Me + 48 >> 2] = 1013904242, a[Me + 52 >> 2] = -1521486534, a[Me + 40 >> 2] = 1779033703, a[Me + 44 >> 2] = -1150833019, Di(d, he, 32), Di(d, he, 32);
          break e;
        }
        a[Me + 136 >> 2] = 0, a[Me + 140 >> 2] = 0, a[Me + 64 >> 2] = 528734635, a[Me + 68 >> 2] = 1541459225, a[Me + 56 >> 2] = 1359893119, a[Me + 60 >> 2] = -1694144372, a[Me + 48 >> 2] = 1013904242, a[Me + 52 >> 2] = -1521486534, a[Me + 40 >> 2] = 1779033703, a[Me + 44 >> 2] = -1150833019, d = Me + 40 | 0, Di(d, he, we), he = Me + 144 | 0, _n(d, he), a[Me + 136 >> 2] = 0, a[Me + 140 >> 2] = 0, a[Me + 64 >> 2] = 528734635, a[Me + 68 >> 2] = 1541459225, a[Me + 56 >> 2] = 1359893119, a[Me + 60 >> 2] = -1694144372, a[Me + 48 >> 2] = 1013904242, a[Me + 52 >> 2] = -1521486534, a[Me + 40 >> 2] = 1779033703, a[Me + 44 >> 2] = -1150833019, Di(d, he, 32), Di(d, he, 32);
      }
      d = Me + 40 | 0, Di(d, Me, 32), Di(d, v, 32), Di(d, o, m), _n(d, B), B = 1;
    } else
      B = 0;
    return be = Me + 176 | 0, B | 0;
  }
  function kn(B, o, m) {
    var d = 0, v = 0, he = 0, we = 0, Be = 0, Me = 0, fr = 0, wr = 0, dr = 0, Dr = 0, Rr = 0, Qe = 0;
    for (Be = be - 32 | 0, be = Be, Rr = xi(B, 516), B = o + 24 | 0, wr = a[B >> 2], B = a[B + 4 >> 2], v = Be + 24 | 0, a[v >> 2] = wr, a[v + 4 >> 2] = B, v = o + 16 | 0, d = a[v + 4 >> 2], he = Be + 16 | 0, a[he >> 2] = a[v >> 2], a[he + 4 >> 2] = d, v = o + 8 | 0, d = a[v + 4 >> 2], he = Be + 8 | 0, a[he >> 2] = a[v >> 2], a[he + 4 >> 2] = d, v = a[o + 4 >> 2], a[Be >> 2] = a[o >> 2], a[Be + 4 >> 2] = v, Me = 1, v = B, (B | 0) < 0 && (d = a[Be >> 2] ^ -1, he = d - 801750718 | 0, we = a[Be + 4 >> 2] ^ -1, o = we - ((d >>> 0 < 801750718) + 1076732275 | 0) | 0, a[Be >> 2] = he, a[Be + 4 >> 2] = o, o = (o | 0) == (we | 0) & d >>> 0 > he >>> 0 | o >>> 0 < we >>> 0, B = Be, he = a[B + 8 >> 2] ^ -1, o = o + he | 0, we = a[B + 12 >> 2] ^ -1, d = we, fr = o - 1354194885 | 0, a[B + 8 >> 2] = fr, d = o >>> 0 < he >>> 0 ? d + 1 | 0 : d, Me = d - ((o >>> 0 < 1354194885) + 1162945305 | 0) | 0, a[B + 12 >> 2] = Me, we = (d | 0) == (we | 0) & o >>> 0 < he >>> 0 | d >>> 0 < we >>> 0, he = (d | 0) == (Me | 0) & o >>> 0 > fr >>> 0 | d >>> 0 > Me >>> 0, o = we + he | 0, we = a[B + 20 >> 2] ^ -1, d = we + (o >>> 0 < he >>> 0) | 0, he = a[B + 16 >> 2] ^ -1, o = he + o | 0, fr = o - 2 | 0, a[B + 16 >> 2] = fr, d = o >>> 0 < he >>> 0 ? d + 1 | 0 : d, Me = d - (o >>> 0 < 2) | 0, a[B + 20 >> 2] = Me, B = (d | 0) == (we | 0) & o >>> 0 < he >>> 0 | d >>> 0 < we >>> 0, d = (d | 0) == (Me | 0) & o >>> 0 > fr >>> 0 | d >>> 0 > Me >>> 0, B = B + d | 0, o = B >>> 0 < d >>> 0, d = B - wr | 0, a[Be + 24 >> 2] = d - 2, a[Be + 28 >> 2] = (o - ((B >>> 0 < wr >>> 0) + v | 0) | 0) - (d >>> 0 < 2), Me = -1), Qe = m - 1 | 0, wr = -1, o = 0; ; ) {
      d = o >>> 6 | 0, Dr = d << 3, v = Dr + Be | 0, B = a[v >> 2], he = a[v + 4 >> 2], we = o & 63, v = we & 31, we >>> 0 >= 32 ? v = he >>> v | 0 : v = ((1 << v) - 1 & he) << 32 - v | B >>> v;
      e: {
        if ((dr | 0) == (v & 1)) {
          B = o + 1 | 0;
          break e;
        }
        B = 129 - o | 0, fr = (B | 0) < (m | 0) ? B : m, B = fr + o | 0, (d | 0) != (B - 1 >>> 6 | 0) && (d = (Be + Dr | 0) + 8 | 0, wr = a[d >> 2], d = 64 - we | 0, we = d & 31, v = ((d & 63) >>> 0 < 32 ? wr << we : 0) | v), d = fr & 31, v = dr + (v & (((fr & 63) >>> 0 < 32 ? -1 << d : 0) ^ -1)) | 0, dr = v >>> Qe & 1, a[Rr + (o << 2) >> 2] = F(v - (dr << m) | 0, Me), wr = o;
      }
      if (o = B, !((o | 0) < 129))
        break;
    }
    return be = Be + 32 | 0, wr + 1 | 0;
  }
  function ho(B, o, m) {
    var d = 0, v = 0, he = 0, we = 0, Be = 0, Me = 0, fr = 0, wr = 0, dr = 0, Dr = 0, Rr = 0, Qe = 0;
    e: {
      if ((m | 0) > 0) {
        d = o + ((m << 5) - 32 & -64) | 0, o = a[d >> 2], m = a[d + 4 >> 2] & 1048575, a[B >> 2] = o, a[B + 4 >> 2] = m, o = a[d + 8 >> 2], m = a[d + 12 >> 2] << 12 | o >>> 20, a[B + 8 >> 2] = o << 12 & -4096 | a[d + 4 >> 2] >>> 20, a[B + 12 >> 2] = m & 1048575, o = a[d + 16 >> 2], m = a[d + 20 >> 2] << 24 | o >>> 8, a[B + 16 >> 2] = o << 24 & -16777216 | a[d + 12 >> 2] >>> 8, a[B + 20 >> 2] = m & 1048575, v = a[d + 24 >> 2] << 4 & 1048560, m = a[d + 20 >> 2], o = m >>> 28 | 0, a[B + 24 >> 2] = (m & 268435455) << 4 | a[d + 16 >> 2] >>> 28, a[B + 28 >> 2] = o | v, o = a[d + 28 >> 2], m = o >>> 16 | 0, a[B + 32 >> 2] = (o & 65535) << 16 | a[d + 24 >> 2] >>> 16, a[B + 36 >> 2] = m, o = a[d + 36 >> 2] & 1048575, a[B + 40 >> 2] = a[d + 32 >> 2], a[B + 44 >> 2] = o, v = d + 40 | 0, o = a[v >> 2], m = a[v + 4 >> 2] << 12 | o >>> 20, he = B + 48 | 0, a[he >> 2] = o << 12 & -4096 | a[d + 36 >> 2] >>> 20, a[he + 4 >> 2] = m & 1048575, he = d + 48 | 0, o = a[he >> 2], m = a[he + 4 >> 2] << 24 | o >>> 8, we = B + 56 | 0, a[we >> 2] = o << 24 & -16777216 | a[v + 4 >> 2] >>> 8, a[we + 4 >> 2] = m & 1048575, d = d + 56 | 0, o = a[d >> 2], we = o << 4 & 1048560, m = a[he + 4 >> 2], o = m >>> 28 | 0, v = B - -64 | 0, a[v >> 2] = (m & 268435455) << 4 | a[he >> 2] >>> 28, a[v + 4 >> 2] = o | we, o = B + 72 | 0, v = a[d + 4 >> 2], a[o >> 2] = (v & 65535) << 16 | a[d >> 2] >>> 16, a[o + 4 >> 2] = v >>> 16;
        break e;
      }
      d = o + ((m ^ -1) / 2 << 6) | 0, o = a[d >> 2], m = a[d + 4 >> 2] & 1048575, a[B >> 2] = o, a[B + 4 >> 2] = m, o = a[d + 8 >> 2], m = a[d + 12 >> 2] << 12 | o >>> 20, a[B + 8 >> 2] = o << 12 & -4096 | a[d + 4 >> 2] >>> 20, a[B + 12 >> 2] = m & 1048575, o = a[d + 16 >> 2], m = a[d + 20 >> 2] << 24 | o >>> 8, a[B + 16 >> 2] = o << 24 & -16777216 | a[d + 12 >> 2] >>> 8, a[B + 20 >> 2] = m & 1048575, v = a[d + 24 >> 2] << 4 & 1048560, m = a[d + 20 >> 2], o = m >>> 28 | 0, a[B + 24 >> 2] = (m & 268435455) << 4 | a[d + 16 >> 2] >>> 28, a[B + 28 >> 2] = o | v, o = a[d + 28 >> 2], m = o >>> 16 | 0, a[B + 32 >> 2] = (o & 65535) << 16 | a[d + 24 >> 2] >>> 16, a[B + 36 >> 2] = m, we = a[d + 36 >> 2] & 1048575, fr = a[d + 32 >> 2], a[B + 40 >> 2] = fr, a[B + 44 >> 2] = we, v = d + 40 | 0, o = a[v >> 2], m = a[v + 4 >> 2] << 12 | o >>> 20, wr = B + 48 | 0, he = wr, dr = o << 12 & -4096 | a[d + 36 >> 2] >>> 20, a[he >> 2] = dr, Rr = m & 1048575, a[he + 4 >> 2] = Rr, he = d + 48 | 0, o = a[he >> 2], m = a[he + 4 >> 2] << 24 | o >>> 8, Be = B + 56 | 0, v = o << 24 & -16777216 | a[v + 4 >> 2] >>> 8, a[Be >> 2] = v, Qe = m & 1048575, a[Be + 4 >> 2] = Qe, d = d + 56 | 0, o = a[d >> 2], Dr = o << 4 & 1048560, m = a[he + 4 >> 2], o = m >>> 28 | 0, Me = B - -64 | 0, m = (m & 268435455) << 4 | a[he >> 2] >>> 28, a[Me >> 2] = m, he = o | Dr, a[Me + 4 >> 2] = he, Dr = a[d >> 2], o = a[d + 4 >> 2], a[Me >> 2] = -4 - m, a[Me + 4 >> 2] = 4194303 - ((m >>> 0 > 4294967292) + he | 0), a[Be >> 2] = -4 - v, a[Be + 4 >> 2] = 4194303 - ((v >>> 0 > 4294967292) + Qe | 0), a[wr >> 2] = -4 - dr, a[wr + 4 >> 2] = 4194303 - ((dr >>> 0 > 4294967292) + Rr | 0), a[B + 40 >> 2] = -3908 - fr, a[B + 44 >> 2] = 4194299 - ((fr >>> 0 > 4294963388) + we | 0), d = o >>> 16 | 0, m = B + 72 | 0, o = (o & 65535) << 16 | Dr >>> 16, a[m >> 2] = -4 - o, a[m + 4 >> 2] = 262143 - ((o >>> 0 > 4294967292) + d | 0);
    }
    a[B + 80 >> 2] = 0;
  }
  function eo(B, o, m, d) {
    var v = 0, he = 0, we = 0, Be = 0, Me = 0, fr = 0, wr = 0, dr = 0, Dr = 0, Rr = 0, Qe = 0, Fr = 0, Gr = 0, $r = 0, ni = 0, mi = 0, Si = 0, Oi = 0, $i = 0, zi = 0, un = 0, In = 0, Ti = 0, Sn = 0, Kn = 0, Vn = 0, Xn = 0, uo = 0, yo = 0, Io = 0, xo = 0, Mo = 0, qi = 0, Oo = 0, Ho = 0, Go = 0, ns = 0, ds = 0, Ts = 0, Ao = 0, po = 0, _o = 0, Uo = 0;
    we = be - 1120 | 0, be = we;
    e: {
      if (a[o + 120 >> 2]) {
        a[B + 120 >> 2] = a[m + 80 >> 2], v = we + 1080 | 0, na(v, d), o = we + 1040 | 0, gn(o, v, d), gn(B, m, v), gn(B + 40 | 0, m + 40 | 0, o), o = B + 88 | 0, a[o >> 2] = 0, a[o + 4 >> 2] = 0, a[B + 80 >> 2] = 1, a[B + 84 >> 2] = 0, o = B + 96 | 0, a[o >> 2] = 0, a[o + 4 >> 2] = 0, o = B + 104 | 0, a[o >> 2] = 0, a[o + 4 >> 2] = 0, B = B + 112 | 0, a[B >> 2] = 0, a[B + 4 >> 2] = 0;
        break e;
      }
      if (a[m + 80 >> 2]) {
        dn(B, o, 128);
        break e;
      }
      po = we + 1080 | 0, _o = o + 80 | 0, gn(po, _o, d), d = a[we + 1084 >> 2], Fr = d, Dr = a[we + 1080 >> 2], v = Dr, d = d << 1 | v >>> 31, Rr = we + 408 | 0, Oi = a[we + 1104 >> 2], mi = a[we + 1108 >> 2], $i = v << 1, Sn = d, Lr(Rr, Oi, mi, 0, 0, $i, d, 0, 0), d = a[we + 1092 >> 2], Ts = d, ds = a[we + 1088 >> 2], he = ds, d = d << 1 | he >>> 31, fr = we + 616 | 0, ni = a[we + 1096 >> 2], $r = a[we + 1100 >> 2], he = he << 1, Me = d, Lr(fr, ni, $r, 0, 0, he, d, 0, 0), Qe = we + 568 | 0, v = a[we + 1112 >> 2], d = a[we + 1116 >> 2], Lr(Qe, v, d, 0, 0, v, d, 0, 0), wr = we + 552 | 0, Lr(wr, a[we + 568 >> 2], a[we + 572 >> 2], 0, 0, 15632, 16, 0, 0), d = d << 1 | v >>> 31, Oo = we + 520 | 0, Kn = v << 1, Si = d, Lr(Oo, Kn, d, 0, 0, Dr, Fr, 0, 0), yo = we + 424 | 0, Lr(yo, Oi, mi, 0, 0, he, Me, 0, 0), Xn = we + 600 | 0, Lr(Xn, ni, $r, 0, 0, ni, $r, 0, 0), dr = we + 536 | 0, d = Qe + 8 | 0, Lr(dr, a[d >> 2], a[d + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Go = we + 664 | 0, Lr(Go, Dr, Fr, 0, 0, Dr, Fr, 0, 0), Ho = we + 504 | 0, Lr(Ho, Kn, Si, 0, 0, ds, Ts, 0, 0), Mo = we + 440 | 0, Lr(Mo, Oi, mi, 0, 0, ni << 1, $r << 1 | ni >>> 31, 0, 0), Fr = a[we + 412 >> 2], d = Fr + a[we + 620 >> 2] | 0, Be = a[we + 408 >> 2], he = a[we + 616 >> 2], v = Be + he | 0, Me = a[we + 552 >> 2], In = v + Me | 0, he = v >>> 0 < he >>> 0 ? d + 1 | 0 : d, d = he + a[we + 556 >> 2] | 0, Me = Me >>> 0 > In >>> 0 ? d + 1 | 0 : d, Dr = (he | 0) == (Me | 0) & v >>> 0 > In >>> 0 | he >>> 0 > Me >>> 0, d = wr + 8 | 0, Qe = a[d >> 2], wr = a[d + 4 >> 2], Be = (he | 0) == (Fr | 0) & v >>> 0 < Be >>> 0 | he >>> 0 < Fr >>> 0, he = fr + 8 | 0, v = a[he >> 2], d = Rr + 8 | 0, fr = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[he + 4 >> 2] | 0, d = v >>> 0 > fr >>> 0 ? d + 1 | 0 : d, v = Be + fr | 0, d = (v >>> 0 < fr >>> 0 ? d + 1 | 0 : d) + wr | 0, he = v, v = v + Qe | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + Dr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, Io = Me, Qe = v << 12 | Me >>> 20, he = d, Be = d << 12 | v >>> 20, Vn = a[we + 424 >> 2], v = a[we + 600 >> 2], Dr = Vn + v | 0, qi = a[we + 428 >> 2], d = qi + a[we + 604 >> 2] | 0, d = v >>> 0 > Dr >>> 0 ? d + 1 | 0 : d, v = a[we + 520 >> 2], wr = v + Dr | 0, Rr = d, d = d + a[we + 524 >> 2] | 0, d = v >>> 0 > wr >>> 0 ? d + 1 | 0 : d, v = a[we + 536 >> 2], Me = v + wr | 0, fr = d, d = d + a[we + 540 >> 2] | 0, v = v >>> 0 > Me >>> 0 ? d + 1 | 0 : d, d = v + Be | 0, xo = we + 344 | 0, uo = xo, Qe = Me + Qe | 0, Be = Qe >>> 0 < Me >>> 0 ? d + 1 | 0 : d, Ti = (v | 0) == (Be | 0) & Me >>> 0 > Qe >>> 0 | v >>> 0 > Be >>> 0, zi = (v | 0) == (fr | 0) & Me >>> 0 < wr >>> 0 | v >>> 0 < fr >>> 0, d = dr + 8 | 0, un = a[d >> 2], Gr = a[d + 4 >> 2], Fr = (fr | 0) == (Rr | 0) & Dr >>> 0 > wr >>> 0 | fr >>> 0 < Rr >>> 0, d = Oo + 8 | 0, dr = a[d >> 2], fr = a[d + 4 >> 2], wr = (Rr | 0) == (qi | 0) & Dr >>> 0 < Vn >>> 0 | Rr >>> 0 < qi >>> 0, Me = Xn + 8 | 0, v = a[Me >> 2], d = yo + 8 | 0, Dr = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[Me + 4 >> 2] | 0, d = v >>> 0 > Dr >>> 0 ? d + 1 | 0 : d, v = Dr + wr | 0, d = (v >>> 0 < Dr >>> 0 ? d + 1 | 0 : d) + fr | 0, Me = v, v = v + dr | 0, d = Me >>> 0 > v >>> 0 ? d + 1 | 0 : d, Me = v, v = v + Fr | 0, d = (Me >>> 0 > v >>> 0 ? d + 1 | 0 : d) + Gr | 0, Me = v, v = v + un | 0, d = Me >>> 0 > v >>> 0 ? d + 1 | 0 : d, Me = v + zi | 0, d = Me >>> 0 < v >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, v = he + Me | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + Ti | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = Be, wr = v << 12 | he >>> 20, Me = d, Be = d << 12 | v >>> 20, Fr = a[we + 504 >> 2], v = a[we + 440 >> 2], Rr = Fr + v | 0, zi = a[we + 508 >> 2], d = zi + a[we + 444 >> 2] | 0, v = v >>> 0 > Rr >>> 0 ? d + 1 | 0 : d, d = v + Be | 0, wr = wr + Rr | 0, d = wr >>> 0 < Rr >>> 0 ? d + 1 | 0 : d, fr = wr << 4 & -16, Be = d, Dr = (d << 4 | wr >>> 28) & 16777215, Gr = he, Lr(uo, fr | he >>> 16 & 15, Dr, 0, 0, 977, 1, 0, 0), he = o + 8 | 0, d = a[he + 4 >> 2], Dr = we + 1e3 | 0, Xn = Dr + 8 | 0, a[Xn >> 2] = a[he >> 2], a[Xn + 4 >> 2] = d, he = o + 16 | 0, d = a[he + 4 >> 2], Vn = Dr + 16 | 0, a[Vn >> 2] = a[he >> 2], a[Vn + 4 >> 2] = d, he = o + 24 | 0, d = a[he + 4 >> 2], uo = Dr + 24 | 0, a[uo >> 2] = a[he >> 2], a[uo + 4 >> 2] = d, he = o + 32 | 0, d = a[he + 4 >> 2], Ti = Dr + 32 | 0, a[Ti >> 2] = a[he >> 2], a[Ti + 4 >> 2] = d, d = a[o + 4 >> 2], a[we + 1e3 >> 2] = a[o >> 2], a[we + 1004 >> 2] = d, Ao = a[we + 348 >> 2], d = Ao + a[we + 668 >> 2] | 0, yo = a[we + 344 >> 2], he = a[we + 664 >> 2], fr = yo + he | 0, a[we + 1040 >> 2] = fr, he = he >>> 0 > fr >>> 0 ? d + 1 | 0 : d, a[we + 1044 >> 2] = he & 1048575, Uo = we + 648 | 0, Lr(Uo, ds, Ts, 0, 0, $i, Sn, 0, 0), ns = we + 488 | 0, Lr(ns, Kn, Si, 0, 0, ni, $r, 0, 0), qi = we + 456 | 0, Lr(qi, Oi, mi, 0, 0, Oi, mi, 0, 0), Oo = we + 392 | 0, un = Oo, dr = (v | 0) == (Be | 0) & wr >>> 0 < Rr >>> 0 | v >>> 0 > Be >>> 0, Rr = (v | 0) == (zi | 0) & Rr >>> 0 < Fr >>> 0 | v >>> 0 < zi >>> 0, wr = Mo + 8 | 0, v = a[wr >> 2], d = Ho + 8 | 0, Fr = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[wr + 4 >> 2] | 0, d = v >>> 0 > Fr >>> 0 ? d + 1 | 0 : d, wr = Rr + Fr | 0, d = wr >>> 0 < Fr >>> 0 ? d + 1 | 0 : d, Me = Me >>> 20 | 0, v = Me + wr | 0, d = Me >>> 0 > v >>> 0 ? d + 1 | 0 : d, Me = v, v = v + dr | 0, d = Me >>> 0 > v >>> 0 ? d + 1 | 0 : d, Rr = v << 12 | Be >>> 20, wr = d, Be = d << 12 | v >>> 20, Dr = a[we + 492 >> 2], d = Dr + a[we + 460 >> 2] | 0, Ho = a[we + 488 >> 2], Me = a[we + 456 >> 2], v = Ho + Me | 0, zi = v, Fr = v + Rr | 0, Me = v >>> 0 < Me >>> 0 ? d + 1 | 0 : d, d = Me + Be | 0, Rr = Fr >>> 0 < v >>> 0 ? d + 1 | 0 : d, Lr(un, Fr, Rr & 1048575, 0, 0, 15632, 16, 0, 0), fr = (he | 0) == (Ao | 0) & fr >>> 0 < yo >>> 0 | he >>> 0 < Ao >>> 0, Be = Go + 8 | 0, v = a[Be >> 2], d = xo + 8 | 0, dr = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[Be + 4 >> 2] | 0, d = v >>> 0 > dr >>> 0 ? d + 1 | 0 : d, v = fr + dr | 0, d = v >>> 0 < dr >>> 0 ? d + 1 | 0 : d, dr = v << 12 | he >>> 20, Be = d, fr = d << 12 | v >>> 20, Go = a[we + 396 >> 2], d = Go + a[we + 652 >> 2] | 0, Mo = a[we + 392 >> 2], he = a[we + 648 >> 2], v = Mo + he | 0, un = v, dr = v + dr | 0, he = v >>> 0 < he >>> 0 ? d + 1 | 0 : d, d = he + fr | 0, a[we + 1048 >> 2] = dr, fr = dr >>> 0 < v >>> 0 ? d + 1 | 0 : d, a[we + 1052 >> 2] = fr & 1048575, xo = we + 584 | 0, Lr(xo, ni, $r, 0, 0, $i, Sn, 0, 0), yo = we + 632 | 0, Lr(yo, ds, Ts, 0, 0, ds, Ts, 0, 0), Sn = we + 472 | 0, Lr(Sn, Kn, Si, 0, 0, Oi, mi, 0, 0), $i = we + 376 | 0, mi = $i, $r = (Me | 0) == (Rr | 0) & Fr >>> 0 < zi >>> 0 | Me >>> 0 > Rr >>> 0, Fr = (Me | 0) == (Dr | 0) & zi >>> 0 < Ho >>> 0 | Me >>> 0 < Dr >>> 0, Me = qi + 8 | 0, v = a[Me >> 2], d = ns + 8 | 0, Oi = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[Me + 4 >> 2] | 0, d = v >>> 0 > Oi >>> 0 ? d + 1 | 0 : d, Me = Fr + Oi | 0, d = Me >>> 0 < Oi >>> 0 ? d + 1 | 0 : d, wr = wr >>> 20 | 0, v = Me + wr | 0, d = wr >>> 0 > v >>> 0 ? d + 1 | 0 : d, Me = v, v = v + $r | 0, d = Me >>> 0 > v >>> 0 ? d + 1 | 0 : d, Si = v << 12 | Rr >>> 20, wr = a[we + 472 >> 2], Rr = Si + wr | 0, Me = d, zi = d << 12 | v >>> 20, d = zi + a[we + 476 >> 2] | 0, Fr = wr >>> 0 > Rr >>> 0 ? d + 1 | 0 : d, Lr(mi, Rr, Fr, 0, 0, 15632, 16, 0, 0), dr = (he | 0) == (fr | 0) & dr >>> 0 < un >>> 0 | he >>> 0 > fr >>> 0, Dr = (he | 0) == (Go | 0) & un >>> 0 < Mo >>> 0 | he >>> 0 < Go >>> 0, he = Uo + 8 | 0, v = a[he >> 2], d = Oo + 8 | 0, $r = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[he + 4 >> 2] | 0, d = v >>> 0 > $r >>> 0 ? d + 1 | 0 : d, he = Dr + $r | 0, d = he >>> 0 < $r >>> 0 ? d + 1 | 0 : d, Be = Be >>> 20 | 0, v = he + Be | 0, d = Be >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + dr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, Dr = v << 12 | fr >>> 20, he = d, mi = d << 12 | v >>> 20, ni = a[we + 584 >> 2], v = a[we + 632 >> 2], fr = ni + v | 0, un = a[we + 588 >> 2], d = un + a[we + 636 >> 2] | 0, $r = v >>> 0 > fr >>> 0 ? d + 1 | 0 : d, d = $r + a[we + 380 >> 2] | 0, v = a[we + 376 >> 2], Be = v + fr | 0, dr = Be, Dr = Be + Dr | 0, v = v >>> 0 > Be >>> 0 ? d + 1 | 0 : d, d = v + mi | 0, a[we + 1056 >> 2] = Dr, Be = Dr >>> 0 < Be >>> 0 ? d + 1 | 0 : d, a[we + 1060 >> 2] = Be & 1048575, Oi = we + 360 | 0, mi = (Fr | 0) == (zi | 0) & Rr >>> 0 < Si >>> 0 | Fr >>> 0 < zi >>> 0, d = Sn + 8 | 0, Fr = a[d >> 2], d = a[d + 4 >> 2], Me = Me >>> 20 | 0, wr = Me, Me = Me + Fr | 0, d = wr >>> 0 > Me >>> 0 ? d + 1 | 0 : d, wr = Me, Me = Me + mi | 0, d = wr >>> 0 > Me >>> 0 ? d + 1 | 0 : d, Lr(Oi, Me, d, 0, 0, 64028672, 65536, 0, 0), mi = (v | 0) == (Be | 0) & Dr >>> 0 < dr >>> 0 | v >>> 0 > Be >>> 0, Fr = (v | 0) == ($r | 0) & fr >>> 0 > dr >>> 0 | v >>> 0 < $r >>> 0, d = $i + 8 | 0, dr = a[d >> 2], Rr = a[d + 4 >> 2], Dr = ($r | 0) == (un | 0) & fr >>> 0 < ni >>> 0 | $r >>> 0 < un >>> 0, wr = yo + 8 | 0, v = a[wr >> 2], d = xo + 8 | 0, fr = v + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[wr + 4 >> 2] | 0, d = v >>> 0 > fr >>> 0 ? d + 1 | 0 : d, v = fr + Dr | 0, d = (v >>> 0 < fr >>> 0 ? d + 1 | 0 : d) + Rr | 0, Me = v, v = v + dr | 0, d = Me >>> 0 > v >>> 0 ? d + 1 | 0 : d, wr = v + Fr | 0, d = wr >>> 0 < v >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, v = he + wr | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v, v = v + mi | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, wr = v << 12 | Be >>> 20, he = d, fr = d << 12 | v >>> 20, dr = a[we + 360 >> 2], Be = In & -2, v = dr + Be | 0, Fr = a[we + 364 >> 2], d = Fr + (Io & 1048575) | 0, Dr = v >>> 0 < Be >>> 0 ? d + 1 | 0 : d, d = Dr + fr | 0, Me = wr, wr = v, Be = Me + v | 0, a[we + 1064 >> 2] = Be, v = v >>> 0 > Be >>> 0 ? d + 1 | 0 : d, a[we + 1068 >> 2] = v & 1048575, Rr = Gr & 65535, fr = (v | 0) == (Dr | 0) & Be >>> 0 < wr >>> 0 | v >>> 0 < Dr >>> 0, Be = (Dr | 0) == (Fr | 0) & wr >>> 0 < dr >>> 0 | Dr >>> 0 < Fr >>> 0, d = Oi + 8 | 0, wr = Be + a[d >> 2] | 0, d = a[d + 4 >> 2], d = Be >>> 0 > wr >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, Me = he, he = he + wr | 0, d = Me >>> 0 > he >>> 0 ? d + 1 | 0 : d, Me = he, he = he + fr | 0, d = Me >>> 0 > he >>> 0 ? d + 1 | 0 : d, v = he << 12 | v >>> 20, Be = v + Qe | 0, d = Rr + (d << 12 | he >>> 20) | 0, a[we + 1072 >> 2] = Be, a[we + 1076 >> 2] = v >>> 0 > Be >>> 0 ? d + 1 | 0 : d, Qe = Xn, fr = a[Qe >> 2], Dr = a[Qe + 4 >> 2], wr = a[we + 1004 >> 2], Be = a[Ti >> 2], v = a[Ti + 4 >> 2], dr = v, d = a[we + 1e3 >> 2], he = oi(v >>> 16 | 0, 0, 977, 1), v = d + he | 0, d = wr + Fe | 0, wr = v >>> 0 < he >>> 0 ? d + 1 | 0 : d, d = Dr, he = wr >>> 20 | 0, Me = he, he = he + fr | 0, d = Me >>> 0 > he >>> 0 ? d + 1 | 0 : d, Fr = he, a[Qe >> 2] = he, Xn = d & 1048575, a[Qe + 4 >> 2] = Xn, Qe = Vn, fr = a[Qe >> 2], he = d, d = a[Qe + 4 >> 2], he = he >>> 20 | 0, Me = he, he = he + fr | 0, d = Me >>> 0 > he >>> 0 ? d + 1 | 0 : d, Rr = he, a[Qe >> 2] = he, Vn = d & 1048575, a[Qe + 4 >> 2] = Vn, Qe = uo, fr = a[Qe >> 2], he = d, d = a[Qe + 4 >> 2], he = he >>> 20 | 0, Me = he, he = he + fr | 0, d = Me >>> 0 > he >>> 0 ? d + 1 | 0 : d, fr = he, a[Qe >> 2] = he, uo = d & 1048575, a[Qe + 4 >> 2] = uo, Qe = Ti, he = d, d = dr & 65535, he = he >>> 20 | 0, Me = he, he = he + Be | 0, d = Me >>> 0 > he >>> 0 ? d + 1 | 0 : d, Oi = he, a[Qe >> 2] = he, Io = d, a[Qe + 4 >> 2] = d, Qe = v, a[we + 1e3 >> 2] = v, Ti = wr & 1048575, a[we + 1004 >> 2] = Ti, Kn = we + 1040 | 0, gn(we + 960 | 0, m, Kn), $r = we + 920 | 0, In = $r + 8 | 0, d = o + 48 | 0, dr = a[d >> 2], Dr = a[d + 4 >> 2], wr = a[o + 44 >> 2], d = o + 72 | 0, Be = a[d >> 2], v = a[d + 4 >> 2], Gr = v, d = a[o + 40 >> 2], he = oi(v >>> 16 | 0, 0, 977, 1), v = d + he | 0, d = wr + Fe | 0, wr = v >>> 0 < he >>> 0 ? d + 1 | 0 : d, d = Dr, he = wr >>> 20 | 0, Me = he, he = he + dr | 0, d = Me >>> 0 > he >>> 0 ? d + 1 | 0 : d, Si = he, a[In >> 2] = he, zi = d & 1048575, a[In + 4 >> 2] = zi, In = $r + 16 | 0, he = o + 56 | 0, dr = a[he >> 2], Dr = a[he + 4 >> 2], he = d, d = Dr, he = he >>> 20 | 0, Me = he, he = he + dr | 0, d = Me >>> 0 > he >>> 0 ? d + 1 | 0 : d, ni = he, a[In >> 2] = he, un = d & 1048575, a[In + 4 >> 2] = un, In = $r + 24 | 0, he = o - -64 | 0, dr = a[he >> 2], Dr = a[he + 4 >> 2], he = d, d = Dr, he = he >>> 20 | 0, Me = he, he = he + dr | 0, d = Me >>> 0 > he >>> 0 ? d + 1 | 0 : d, mi = he, a[In >> 2] = he, Sn = d & 1048575, a[In + 4 >> 2] = Sn, dr = $r + 32 | 0, he = d, d = Gr & 65535, he = he >>> 20 | 0, Be = he + Be | 0, d = he >>> 0 > Be >>> 0 ? d + 1 | 0 : d, $r = Be, a[dr >> 2] = Be, he = d, a[dr + 4 >> 2] = d, In = v, a[we + 920 >> 2] = v, $i = wr & 1048575, a[we + 924 >> 2] = $i, d = we + 880 | 0, gn(d, m + 40 | 0, Kn), gn(d, d, po), v = we, m = a[v + 960 >> 2], Dr = (m - Qe | 0) - 3908 | 0, d = (a[v + 964 >> 2] - ((m >>> 0 < Qe >>> 0) + Ti | 0) | 0) + 4194299 | 0, a[v + 840 >> 2] = Dr, wr = Dr >>> 0 < 4294963388 ? d + 1 | 0 : d, a[v + 844 >> 2] = wr, m = a[v + 968 >> 2], dr = (m - Fr | 0) - 4 | 0, d = (a[v + 972 >> 2] - ((m >>> 0 < Fr >>> 0) + Xn | 0) | 0) + 4194303 | 0, a[v + 848 >> 2] = dr, Qe = dr >>> 0 < 4294967292 ? d + 1 | 0 : d, a[v + 852 >> 2] = Qe, m = a[v + 976 >> 2], Gr = (m - Rr | 0) - 4 | 0, d = (a[v + 980 >> 2] - ((m >>> 0 < Rr >>> 0) + Vn | 0) | 0) + 4194303 | 0, a[v + 856 >> 2] = Gr, Rr = Gr >>> 0 < 4294967292 ? d + 1 | 0 : d, a[v + 860 >> 2] = Rr, m = a[v + 984 >> 2], Fr = (m - fr | 0) - 4 | 0, d = (a[v + 988 >> 2] - ((m >>> 0 < fr >>> 0) + uo | 0) | 0) + 4194303 | 0, a[v + 864 >> 2] = Fr, fr = Fr >>> 0 < 4294967292 ? d + 1 | 0 : d, a[v + 868 >> 2] = fr, d = a[v + 992 >> 2], m = (d - Oi | 0) - 4 | 0, d = (a[v + 996 >> 2] - ((d >>> 0 < Oi >>> 0) + Io | 0) | 0) + 262143 | 0, a[v + 872 >> 2] = m, Be = m >>> 0 < 4294967292 ? d + 1 | 0 : d, a[v + 876 >> 2] = Be, d = a[v + 912 >> 2], Io = ($r - d | 0) - 4 | 0, d = (he - (a[v + 916 >> 2] + (d >>> 0 > $r >>> 0) | 0) | 0) + 262143 | 0, he = Io, a[v + 832 >> 2] = he, Me = he >>> 0 < 4294967292 ? d + 1 | 0 : d, a[v + 836 >> 2] = Me, d = a[v + 904 >> 2], Vn = (mi - d | 0) - 4 | 0, d = (Sn - (a[v + 908 >> 2] + (d >>> 0 > mi >>> 0) | 0) | 0) + 4194303 | 0, a[v + 824 >> 2] = Vn, Oi = Vn >>> 0 < 4294967292 ? d + 1 | 0 : d, a[v + 828 >> 2] = Oi, d = a[v + 896 >> 2], uo = (ni - d | 0) - 4 | 0, d = (un - (a[v + 900 >> 2] + (d >>> 0 > ni >>> 0) | 0) | 0) + 4194303 | 0, a[v + 816 >> 2] = uo, mi = uo >>> 0 < 4294967292 ? d + 1 | 0 : d, a[v + 820 >> 2] = mi, d = a[v + 888 >> 2], Ti = (Si - d | 0) - 4 | 0, d = (zi - (a[v + 892 >> 2] + (d >>> 0 > Si >>> 0) | 0) | 0) + 4194303 | 0, a[v + 808 >> 2] = Ti, $r = Ti >>> 0 < 4294967292 ? d + 1 | 0 : d, a[v + 812 >> 2] = $r, d = a[v + 880 >> 2], Kn = (In - d | 0) - 3908 | 0, d = ($i - (a[v + 884 >> 2] + (d >>> 0 > In >>> 0) | 0) | 0) + 4194299 | 0, a[v + 800 >> 2] = Kn, In = Kn >>> 0 < 4294963388 ? d + 1 | 0 : d, a[v + 804 >> 2] = In, v = oi(Be >>> 16 | 0, 0, 977, 1) + Dr | 0, d = Fe + wr | 0, d = v >>> 0 < Dr >>> 0 ? d + 1 | 0 : d, ni = d & 1048575, Mo = ni;
      t: {
        if (Io = v, xo = v ^ 976, yo = ni ^ 1, ((xo | 0) != -1 | (yo | 0) != 1048575) & (v | ni) != 0 || (Xn = Be & 65535, v = d, d = Qe, v = (v >>> 20 | 0) + dr | 0, d = v >>> 0 < dr >>> 0 ? d + 1 | 0 : d, zi = v, un = d, d = Rr, v = (un >>> 20 | 0) + Gr | 0, d = v >>> 0 < Gr >>> 0 ? d + 1 | 0 : d, Sn = v, $i = d, d = fr, v = ($i >>> 20 | 0) + Fr | 0, d = v >>> 0 < Fr >>> 0 ? d + 1 | 0 : d, Si = v, ni = d, d = Xn, v = ni >>> 20 | 0, Xn = v, v = m + v | 0, d = Xn >>> 0 > v >>> 0 ? d + 1 | 0 : d, v | (Si | (Sn | (zi | Io))) | (d | (ni & 1048575 | ($i & 1048575 | (un & 1048575 | Mo)))) && ((zi & xo & Sn & Si & v) != -1 ? d = 1 : d = (un & yo & $i & ni & (d ^ 983040)) != 1048575, d)))
          break t;
        m = oi(Me >>> 16 | 0, 0, 977, 1) + Kn | 0, d = Fe + In | 0, d = m >>> 0 < Kn >>> 0 ? d + 1 | 0 : d, Be = d & 1048575, Gr = Be;
        r: {
          if (v = m, Fr = v ^ 976, dr = Be ^ 1, ((Fr | 0) != -1 | (dr | 0) != 1048575) & (v | Be) != 0 || (Rr = Me & 65535, m = d, d = $r, m = (m >>> 20 | 0) + Ti | 0, d = m >>> 0 < Ti >>> 0 ? d + 1 | 0 : d, fr = m, Dr = d, d = mi, m = (Dr >>> 20 | 0) + uo | 0, d = m >>> 0 < uo >>> 0 ? d + 1 | 0 : d, Qe = m, wr = d, d = Oi, m = (wr >>> 20 | 0) + Vn | 0, d = m >>> 0 < Vn >>> 0 ? d + 1 | 0 : d, Be = m, Me = d, d = Rr, m = Me >>> 20 | 0, Rr = m, m = m + he | 0, d = Rr >>> 0 > m >>> 0 ? d + 1 | 0 : d, m | (Be | (Qe | (v | fr))) | (d | (Me & 1048575 | (wr & 1048575 | (Dr & 1048575 | Gr)))) && ((fr & Fr & Qe & Be & m) != -1 ? m = 1 : m = (Dr & dr & wr & Me & (d ^ 983040)) != 1048575, m)))
            break r;
          if (a[o + 120 >> 2]) {
            a[B + 120 >> 2] = 1, xi(B, 120);
            break e;
          }
          os(B, o);
          break e;
        }
        a[B + 120 >> 2] = 1, xi(B, 120);
        break e;
      }
      a[B + 120 >> 2] = 0, qi = we + 840 | 0, gn(B + 80 | 0, _o, qi), Sn = we + 312 | 0, Me = Fr, he = fr, mi = Dr << 1, fr = wr, Oi = fr << 1 | Dr >>> 31, Lr(Sn, Me, he, 0, 0, mi, Oi, 0, 0), Si = we + 232 | 0, v = Gr, o = Rr, wr = dr << 1, Fr = Qe, $r = dr, Qe = Qe << 1 | dr >>> 31, Lr(Si, v, o, 0, 0, wr, Qe, 0, 0), dr = we + 168 | 0, Lr(dr, m, Be, 0, 0, m, Be, 0, 0), Gr = we + 152 | 0, Lr(Gr, a[we + 168 >> 2], a[we + 172 >> 2], 0, 0, 15632, 16, 0, 0), d = Be << 1 | m >>> 31, Oo = we + 120 | 0, ni = m << 1, In = d, Lr(Oo, ni, d, 0, 0, Dr, fr, 0, 0), Ho = we + 280 | 0, Lr(Ho, Me, he, 0, 0, wr, Qe, 0, 0), Mo = we + 216 | 0, Lr(Mo, v, o, 0, 0, v, o, 0, 0), $i = we + 136 | 0, m = dr + 8 | 0, Lr($i, a[m >> 2], a[m + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), xo = we + 328 | 0, Lr(xo, Dr, fr, 0, 0, Dr, fr, 0, 0), yo = we + 104 | 0, Lr(yo, ni, d, 0, 0, $r, Fr, 0, 0), fr = o, Io = v, d = o << 1 | v >>> 31, Xn = we + 184 | 0, dr = Me, Rr = he, Lr(Xn, Me, he, 0, 0, v << 1, d, 0, 0), Qe = a[we + 316 >> 2], d = Qe + a[we + 236 >> 2] | 0, he = a[we + 312 >> 2], m = a[we + 232 >> 2], o = he + m | 0, v = a[we + 152 >> 2], Dr = o + v | 0, m = o >>> 0 < m >>> 0 ? d + 1 | 0 : d, d = m + a[we + 156 >> 2] | 0, v = v >>> 0 > Dr >>> 0 ? d + 1 | 0 : d, wr = (m | 0) == (v | 0) & o >>> 0 > Dr >>> 0 | m >>> 0 > v >>> 0, d = Gr + 8 | 0, Be = a[d >> 2], Me = a[d + 4 >> 2], he = (m | 0) == (Qe | 0) & o >>> 0 < he >>> 0 | m >>> 0 < Qe >>> 0, d = Si + 8 | 0, m = a[d >> 2], o = Sn + 8 | 0, Qe = m + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = m >>> 0 > Qe >>> 0 ? d + 1 | 0 : d, o = he + Qe | 0, d = (o >>> 0 < Qe >>> 0 ? d + 1 | 0 : d) + Me | 0, m = o, o = o + Be | 0, d = m >>> 0 > o >>> 0 ? d + 1 | 0 : d, m = o, o = o + wr | 0, d = m >>> 0 > o >>> 0 ? d + 1 | 0 : d, wr = v, Me = o << 12 | v >>> 20, m = d, he = d << 12 | o >>> 20, Vn = a[we + 280 >> 2], o = a[we + 216 >> 2], Qe = Vn + o | 0, ns = a[we + 284 >> 2], d = ns + a[we + 220 >> 2] | 0, d = o >>> 0 > Qe >>> 0 ? d + 1 | 0 : d, o = a[we + 120 >> 2], Be = o + Qe | 0, Si = d, d = d + a[we + 124 >> 2] | 0, d = o >>> 0 > Be >>> 0 ? d + 1 | 0 : d, o = a[we + 136 >> 2], v = o + Be | 0, Gr = d, d = d + a[we + 140 >> 2] | 0, o = o >>> 0 > v >>> 0 ? d + 1 | 0 : d, d = o + he | 0, uo = we + 88 | 0, he = v + Me | 0, Me = he >>> 0 < v >>> 0 ? d + 1 | 0 : d, Ti = (o | 0) == (Me | 0) & v >>> 0 > he >>> 0 | o >>> 0 > Me >>> 0, Kn = (o | 0) == (Gr | 0) & v >>> 0 < Be >>> 0 | o >>> 0 < Gr >>> 0, o = $i + 8 | 0, zi = a[o >> 2], un = a[o + 4 >> 2], Sn = (Gr | 0) == (Si | 0) & Be >>> 0 < Qe >>> 0 | Gr >>> 0 < Si >>> 0, o = Oo + 8 | 0, $i = a[o >> 2], Gr = a[o + 4 >> 2], Be = (Si | 0) == (ns | 0) & Qe >>> 0 < Vn >>> 0 | Si >>> 0 < ns >>> 0, d = Mo + 8 | 0, v = a[d >> 2], o = Ho + 8 | 0, Qe = v + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = v >>> 0 > Qe >>> 0 ? d + 1 | 0 : d, o = Be + Qe | 0, d = (o >>> 0 < Qe >>> 0 ? d + 1 | 0 : d) + Gr | 0, v = o, o = o + $i | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o, o = o + Sn | 0, d = (v >>> 0 > o >>> 0 ? d + 1 | 0 : d) + un | 0, v = o, o = o + zi | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, v = o + Kn | 0, d = v >>> 0 < o >>> 0 ? d + 1 | 0 : d, m = m >>> 20 | 0, o = m + v | 0, d = m >>> 0 > o >>> 0 ? d + 1 | 0 : d, m = o, o = o + Ti | 0, d = m >>> 0 > o >>> 0 ? d + 1 | 0 : d, m = Me, Be = o << 12 | m >>> 20, v = d, Me = d << 12 | o >>> 20, $i = a[we + 104 >> 2], o = a[we + 184 >> 2], Gr = $i + o | 0, Ti = a[we + 108 >> 2], d = Ti + a[we + 188 >> 2] | 0, o = o >>> 0 > Gr >>> 0 ? d + 1 | 0 : d, d = o + Me | 0, Be = Be + Gr | 0, d = Be >>> 0 < Gr >>> 0 ? d + 1 | 0 : d, Si = Be << 4 & -16, Qe = m, Me = d, Lr(uo, Si | m >>> 16 & 15, (d << 4 | Be >>> 28) & 16777215, 0, 0, 977, 1, 0, 0), Kn = we + 264 | 0, Lr(Kn, $r, Fr, 0, 0, mi, Oi, 0, 0), zi = we + 72 | 0, Lr(zi, ni, In, 0, 0, Io, fr, 0, 0), un = we + 296 | 0, Lr(un, dr, Rr, 0, 0, dr, Rr, 0, 0), Sn = we + 56 | 0, Si = (o | 0) == (d | 0) & Be >>> 0 < Gr >>> 0 | o >>> 0 > d >>> 0, Be = (o | 0) == (Ti | 0) & Gr >>> 0 < $i >>> 0 | o >>> 0 < Ti >>> 0, d = Xn + 8 | 0, m = a[d >> 2], o = yo + 8 | 0, Gr = m + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = m >>> 0 > Gr >>> 0 ? d + 1 | 0 : d, m = Be + Gr | 0, d = m >>> 0 < Gr >>> 0 ? d + 1 | 0 : d, v = v >>> 20 | 0, o = m + v | 0, d = v >>> 0 > o >>> 0 ? d + 1 | 0 : d, m = o, o = o + Si | 0, d = m >>> 0 > o >>> 0 ? d + 1 | 0 : d, Me = o << 12 | Me >>> 20, m = d, v = d << 12 | o >>> 20, $i = a[we + 72 >> 2], o = a[we + 296 >> 2], Be = $i + o | 0, Ti = a[we + 76 >> 2], d = Ti + a[we + 300 >> 2] | 0, o = o >>> 0 > Be >>> 0 ? d + 1 | 0 : d, d = o + v | 0, Me = Me + Be | 0, d = Me >>> 0 < Be >>> 0 ? d + 1 | 0 : d, v = d, Lr(Sn, Me, d & 1048575, 0, 0, 15632, 16, 0, 0), Si = we + 200 | 0, Lr(Si, Io, fr, 0, 0, mi, Oi, 0, 0), Oi = we + 248 | 0, Lr(Oi, $r, Fr, 0, 0, $r, Fr, 0, 0), Gr = we + 40 | 0, Lr(Gr, ni, In, 0, 0, dr, Rr, 0, 0), Fr = we + 24 | 0, Rr = Fr, fr = (o | 0) == (d | 0) & Me >>> 0 < Be >>> 0 | o >>> 0 > d >>> 0, Be = (o | 0) == (Ti | 0) & Be >>> 0 < $i >>> 0 | o >>> 0 < Ti >>> 0, d = un + 8 | 0, Me = a[d >> 2], o = zi + 8 | 0, dr = Me + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = Me >>> 0 > dr >>> 0 ? d + 1 | 0 : d, Me = Be + dr | 0, d = Me >>> 0 < dr >>> 0 ? d + 1 | 0 : d, m = m >>> 20 | 0, o = m + Me | 0, d = m >>> 0 > o >>> 0 ? d + 1 | 0 : d, m = o, o = o + fr | 0, d = m >>> 0 > o >>> 0 ? d + 1 | 0 : d, Me = o << 12 | v >>> 20, v = a[we + 40 >> 2], fr = Me + v | 0, m = d, o = d << 12 | o >>> 20, d = o + a[we + 44 >> 2] | 0, d = v >>> 0 > fr >>> 0 ? d + 1 | 0 : d, Lr(Rr, fr, d, 0, 0, 15632, 16, 0, 0), mi = we + 8 | 0, Be = mi, Me = (o | 0) == (d | 0) & Me >>> 0 > fr >>> 0 | o >>> 0 > d >>> 0, o = Gr + 8 | 0, v = a[o >> 2], d = a[o + 4 >> 2], m = m >>> 20 | 0, o = m + v | 0, d = m >>> 0 > o >>> 0 ? d + 1 | 0 : d, m = o, o = o + Me | 0, d = m >>> 0 > o >>> 0 ? d + 1 | 0 : d, Lr(Be, o, d, 0, 0, 64028672, 65536, 0, 0), fr = a[we + 92 >> 2], d = fr + a[we + 332 >> 2] | 0, Be = a[we + 88 >> 2], m = a[we + 328 >> 2], o = Be + m | 0, a[we + 760 >> 2] = -3908 - o, v = o >>> 0 < m >>> 0 ? d + 1 | 0 : d, a[we + 764 >> 2] = 4194299 - ((v & 1048575) + (o >>> 0 > 4294963388) | 0), Be = (v | 0) == (fr | 0) & o >>> 0 < Be >>> 0 | v >>> 0 < fr >>> 0, d = xo + 8 | 0, m = a[d >> 2], o = uo + 8 | 0, fr = m + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = m >>> 0 > fr >>> 0 ? d + 1 | 0 : d, o = Be + fr | 0, d = o >>> 0 < fr >>> 0 ? d + 1 | 0 : d, Be = o << 12 | v >>> 20, m = d, Rr = d << 12 | o >>> 20, Gr = a[we + 60 >> 2], d = Gr + a[we + 268 >> 2] | 0, dr = a[we + 56 >> 2], o = a[we + 264 >> 2], v = dr + o | 0, fr = v, Be = v + Be | 0, o = o >>> 0 > v >>> 0 ? d + 1 | 0 : d, d = o + Rr | 0, v = Be >>> 0 < v >>> 0 ? d + 1 | 0 : d, d = Be, a[we + 768 >> 2] = -4 - d, a[we + 772 >> 2] = 4194303 - ((v & 1048575) + (d >>> 0 > 4294967292) | 0), Rr = (o | 0) == (v | 0) & d >>> 0 < fr >>> 0 | o >>> 0 > v >>> 0, fr = (o | 0) == (Gr | 0) & fr >>> 0 < dr >>> 0 | o >>> 0 < Gr >>> 0, d = Kn + 8 | 0, Be = a[d >> 2], o = Sn + 8 | 0, dr = Be + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = Be >>> 0 > dr >>> 0 ? d + 1 | 0 : d, Be = fr + dr | 0, d = Be >>> 0 < dr >>> 0 ? d + 1 | 0 : d, m = m >>> 20 | 0, o = m + Be | 0, d = m >>> 0 > o >>> 0 ? d + 1 | 0 : d, m = o, o = o + Rr | 0, d = m >>> 0 > o >>> 0 ? d + 1 | 0 : d, Be = o << 12 | v >>> 20, m = d, v = d << 12 | o >>> 20, $r = a[we + 200 >> 2], o = a[we + 248 >> 2], Rr = $r + o | 0, ni = a[we + 204 >> 2], d = ni + a[we + 252 >> 2] | 0, d = o >>> 0 > Rr >>> 0 ? d + 1 | 0 : d, o = a[we + 24 >> 2], fr = o + Rr | 0, dr = d, d = d + a[we + 28 >> 2] | 0, o = o >>> 0 > fr >>> 0 ? d + 1 | 0 : d, d = o + v | 0, Be = Be + fr | 0, d = Be >>> 0 < fr >>> 0 ? d + 1 | 0 : d, a[we + 776 >> 2] = -4 - Be, v = d, a[we + 780 >> 2] = 4194303 - ((d & 1048575) + (Be >>> 0 > 4294967292) | 0), In = (o | 0) == (d | 0) & Be >>> 0 < fr >>> 0 | o >>> 0 > d >>> 0, Io = (o | 0) == (dr | 0) & fr >>> 0 < Rr >>> 0 | o >>> 0 < dr >>> 0, o = Fr + 8 | 0, Gr = a[o >> 2], Fr = a[o + 4 >> 2], fr = (dr | 0) == (ni | 0) & Rr >>> 0 < $r >>> 0 | dr >>> 0 < ni >>> 0, d = Oi + 8 | 0, Be = a[d >> 2], o = Si + 8 | 0, Rr = Be + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[d + 4 >> 2] | 0, d = Be >>> 0 > Rr >>> 0 ? d + 1 | 0 : d, o = fr + Rr | 0, d = (o >>> 0 < Rr >>> 0 ? d + 1 | 0 : d) + Fr | 0, Me = o, o = o + Gr | 0, d = Me >>> 0 > o >>> 0 ? d + 1 | 0 : d, Be = o + Io | 0, d = Be >>> 0 < o >>> 0 ? d + 1 | 0 : d, m = m >>> 20 | 0, o = m + Be | 0, d = m >>> 0 > o >>> 0 ? d + 1 | 0 : d, m = o, o = o + In | 0, d = m >>> 0 > o >>> 0 ? d + 1 | 0 : d, Be = o << 12 | v >>> 20, m = d, dr = d << 12 | o >>> 20, Fr = a[we + 12 >> 2], d = Fr + (wr & 1048575) | 0, Rr = a[we + 8 >> 2], v = Dr & -2, o = Rr + v | 0, Dr = o, Be = o + Be | 0, fr = o >>> 0 < v >>> 0 ? d + 1 | 0 : d, d = fr + dr | 0, a[we + 784 >> 2] = -4 - Be, o = Be >>> 0 < o >>> 0 ? d + 1 | 0 : d, a[we + 788 >> 2] = 4194303 - ((o & 1048575) + (Be >>> 0 > 4294967292) | 0), v = we, wr = he, Qe = Qe & 65535, Be = (o | 0) == (fr | 0) & Be >>> 0 < Dr >>> 0 | o >>> 0 < fr >>> 0, he = (fr | 0) == (Fr | 0) & Dr >>> 0 < Rr >>> 0 | fr >>> 0 < Fr >>> 0, d = mi + 8 | 0, Me = he + a[d >> 2] | 0, d = a[d + 4 >> 2], d = he >>> 0 > Me >>> 0 ? d + 1 | 0 : d, m = m >>> 20 | 0, he = m, m = m + Me | 0, d = he >>> 0 > m >>> 0 ? d + 1 | 0 : d, he = m, m = m + Be | 0, d = he >>> 0 > m >>> 0 ? d + 1 | 0 : d, o = m << 12 | o >>> 20, he = o + wr | 0, d = Qe + (d << 12 | m >>> 20) | 0, a[v + 792 >> 2] = -4 - he, a[v + 796 >> 2] = 262143 - ((he >>> 0 > 4294967292) + (o >>> 0 > he >>> 0 ? d + 1 | 0 : d) | 0), zi = v + 720 | 0, o = v + 760 | 0, gn(zi, o, qi), Sn = v + 680 | 0, gn(Sn, v + 1e3 | 0, o), $i = v + 800 | 0, na(B, $i), o = a[v + 752 >> 2], he = o + a[B + 32 >> 2] | 0, d = a[B + 36 >> 2] + a[v + 756 >> 2] | 0, m = o >>> 0 > he >>> 0 ? d + 1 | 0 : d, o = a[v + 712 >> 2], Si = o, d = a[v + 716 >> 2], ni = d, d = (d << 1 | o >>> 31) + m | 0, o = o << 1, m = o, o = o + he | 0, d = m >>> 0 > o >>> 0 ? d + 1 | 0 : d, dr = o, a[B + 32 >> 2] = o, Dr = d, a[B + 36 >> 2] = d, o = B, B = a[v + 744 >> 2], he = B + a[o + 24 >> 2] | 0, d = a[o + 28 >> 2] + a[v + 748 >> 2] | 0, m = B >>> 0 > he >>> 0 ? d + 1 | 0 : d, B = a[v + 704 >> 2], Oi = B, d = a[v + 708 >> 2], mi = d, d = (d << 1 | B >>> 31) + m | 0, B = B << 1, m = B, B = B + he | 0, d = m >>> 0 > B >>> 0 ? d + 1 | 0 : d, Rr = B, a[o + 24 >> 2] = B, Qe = d, a[o + 28 >> 2] = d, B = a[v + 736 >> 2], he = B + a[o + 16 >> 2] | 0, d = a[o + 20 >> 2] + a[v + 740 >> 2] | 0, m = B >>> 0 > he >>> 0 ? d + 1 | 0 : d, B = a[v + 696 >> 2], $r = B, d = a[v + 700 >> 2], In = d, d = (d << 1 | B >>> 31) + m | 0, B = B << 1, m = B, B = B + he | 0, d = m >>> 0 > B >>> 0 ? d + 1 | 0 : d, fr = B, a[o + 16 >> 2] = B, wr = d, a[o + 20 >> 2] = d, B = a[v + 728 >> 2], m = B + a[o + 8 >> 2] | 0, d = a[o + 12 >> 2] + a[v + 732 >> 2] | 0, B = B >>> 0 > m >>> 0 ? d + 1 | 0 : d, d = a[v + 692 >> 2], Io = d, un = a[v + 688 >> 2], he = un, d = (d << 1 | he >>> 31) + B | 0, he = he << 1, Be = m + he | 0, d = he >>> 0 > Be >>> 0 ? d + 1 | 0 : d, a[o + 8 >> 2] = Be, Me = d, a[o + 12 >> 2] = d, B = a[v + 720 >> 2], he = B + a[o >> 2] | 0, d = a[o + 4 >> 2] + a[v + 724 >> 2] | 0, m = B >>> 0 > he >>> 0 ? d + 1 | 0 : d, B = a[v + 680 >> 2], Gr = B, d = a[v + 684 >> 2], Fr = d, d = (d << 1 | B >>> 31) + m | 0, B = B << 1, m = B, B = B + he | 0, d = m >>> 0 > B >>> 0 ? d + 1 | 0 : d, he = B, a[o >> 2] = he, m = d, a[o + 4 >> 2] = d, d = Dr + ni | 0, v = dr + Si | 0, d = v >>> 0 < dr >>> 0 ? d + 1 | 0 : d, a[we + 712 >> 2] = v, a[we + 716 >> 2] = d, d = Qe + mi | 0, v = Rr + Oi | 0, d = v >>> 0 < Rr >>> 0 ? d + 1 | 0 : d, a[we + 704 >> 2] = v, a[we + 708 >> 2] = d, d = wr + In | 0, v = fr + $r | 0, d = v >>> 0 < fr >>> 0 ? d + 1 | 0 : d, a[we + 696 >> 2] = v, a[we + 700 >> 2] = d, d = Me + Io | 0, v = Be + un | 0, d = v >>> 0 < un >>> 0 ? d + 1 | 0 : d, a[we + 688 >> 2] = v, a[we + 692 >> 2] = d, d = m + Fr | 0, B = he + Gr | 0, d = B >>> 0 < he >>> 0 ? d + 1 | 0 : d, a[we + 680 >> 2] = B, a[we + 684 >> 2] = d, gn(o + 40 | 0, Sn, $i), gn(zi, zi, we + 920 | 0), d = a[o + 44 >> 2] + a[we + 724 >> 2] | 0, B = a[we + 720 >> 2], m = B + a[o + 40 >> 2] | 0, a[o + 40 >> 2] = m, a[o + 44 >> 2] = B >>> 0 > m >>> 0 ? d + 1 | 0 : d, d = o + 48 | 0, v = d, B = a[we + 728 >> 2], m = B + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[we + 732 >> 2] | 0, a[v >> 2] = m, a[v + 4 >> 2] = B >>> 0 > m >>> 0 ? d + 1 | 0 : d, d = o + 56 | 0, v = d, B = a[we + 736 >> 2], m = B + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[we + 740 >> 2] | 0, a[v >> 2] = m, a[v + 4 >> 2] = B >>> 0 > m >>> 0 ? d + 1 | 0 : d, d = o - -64 | 0, v = d, B = a[we + 744 >> 2], m = B + a[d >> 2] | 0, d = a[d + 4 >> 2] + a[we + 748 >> 2] | 0, a[v >> 2] = m, a[v + 4 >> 2] = B >>> 0 > m >>> 0 ? d + 1 | 0 : d, B = a[we + 752 >> 2], m = o + 72 | 0, o = B + a[m >> 2] | 0, d = a[m + 4 >> 2] + a[we + 756 >> 2] | 0, a[m >> 2] = o, a[m + 4 >> 2] = B >>> 0 > o >>> 0 ? d + 1 | 0 : d;
    }
    be = we + 1120 | 0;
  }
  function Ei(B, o, m, d) {
    var v = 0, he = 0, we = 0, Be = 0, Me = 0, fr = 0, wr = 0, dr = 0, Dr = 0, Rr = 0, Qe = 0, Fr = 0, Gr = 0, $r = 0, ni = 0, mi = 0, Si = 0, Oi = 0, $i = 0, zi = 0, un = 0, In = 0, Ti = 0, Sn = 0, Kn = 0, Vn = 0, Xn = 0, uo = 0, yo = 0, Io = 0, xo = 0, Mo = 0, qi = 0, Oo = 0;
    Me = be - 736 | 0, be = Me, v = a[m + 80 >> 2];
    e: {
      if (a[o + 120 >> 2]) {
        a[B + 120 >> 2] = v, o = a[m + 4 >> 2], a[B >> 2] = a[m >> 2], a[B + 4 >> 2] = o, o = m + 8 | 0, d = a[o + 4 >> 2], v = B + 8 | 0, a[v >> 2] = a[o >> 2], a[v + 4 >> 2] = d, o = m + 16 | 0, d = a[o + 4 >> 2], v = B + 16 | 0, a[v >> 2] = a[o >> 2], a[v + 4 >> 2] = d, o = m + 24 | 0, d = a[o + 4 >> 2], v = B + 24 | 0, a[v >> 2] = a[o >> 2], a[v + 4 >> 2] = d, o = m + 32 | 0, d = a[o + 4 >> 2], v = B + 32 | 0, a[v >> 2] = a[o >> 2], a[v + 4 >> 2] = d, o = a[m + 44 >> 2], a[B + 40 >> 2] = a[m + 40 >> 2], a[B + 44 >> 2] = o, o = m + 48 | 0, d = a[o + 4 >> 2], v = B + 48 | 0, a[v >> 2] = a[o >> 2], a[v + 4 >> 2] = d, o = m + 56 | 0, d = a[o + 4 >> 2], v = B + 56 | 0, a[v >> 2] = a[o >> 2], a[v + 4 >> 2] = d, o = m - -64 | 0, d = a[o + 4 >> 2], v = B - -64 | 0, a[v >> 2] = a[o >> 2], a[v + 4 >> 2] = d, o = m + 72 | 0, m = a[o + 4 >> 2], d = B + 72 | 0, a[d >> 2] = a[o >> 2], a[d + 4 >> 2] = m, o = B + 88 | 0, a[o >> 2] = 0, a[o + 4 >> 2] = 0, a[B + 80 >> 2] = 1, a[B + 84 >> 2] = 0, o = B + 96 | 0, a[o >> 2] = 0, a[o + 4 >> 2] = 0, o = B + 104 | 0, a[o >> 2] = 0, a[o + 4 >> 2] = 0, B = B + 112 | 0, a[B >> 2] = 0, a[B + 4 >> 2] = 0;
        break e;
      }
      if (v) {
        d && (a[d + 8 >> 2] = 0, a[d + 12 >> 2] = 0, a[d >> 2] = 1, a[d + 4 >> 2] = 0, m = d + 16 | 0, a[m >> 2] = 0, a[m + 4 >> 2] = 0, m = d + 24 | 0, a[m >> 2] = 0, a[m + 4 >> 2] = 0, m = d + 32 | 0, a[m >> 2] = 0, a[m + 4 >> 2] = 0), dn(B, o, 128);
        break e;
      }
      ni = Me + 696 | 0, Xn = o + 80 | 0, na(ni, Xn), Qe = Me + 656 | 0, wr = Qe + 8 | 0, v = o + 8 | 0, Be = a[v >> 2], Dr = a[v + 4 >> 2], we = a[o + 4 >> 2], v = o + 32 | 0, dr = a[v >> 2], fr = a[v + 4 >> 2], $r = fr, v = a[o >> 2], fr = oi(fr >>> 16 | 0, 0, 977, 1), he = v + fr | 0, v = we + Fe | 0, fr = he >>> 0 < fr >>> 0 ? v + 1 | 0 : v, v = Dr, we = fr >>> 20 | 0, Dr = we, we = we + Be | 0, v = Dr >>> 0 > we >>> 0 ? v + 1 | 0 : v, a[wr >> 2] = we, mi = v & 1048575, a[wr + 4 >> 2] = mi, Be = Qe + 16 | 0, wr = o + 16 | 0, Dr = a[wr >> 2], Fr = a[wr + 4 >> 2], wr = v, v = Fr, wr = wr >>> 20 | 0, Rr = wr, wr = wr + Dr | 0, v = Rr >>> 0 > wr >>> 0 ? v + 1 | 0 : v, a[Be >> 2] = wr, Kn = v & 1048575, a[Be + 4 >> 2] = Kn, Dr = Qe + 24 | 0, Be = o + 24 | 0, Fr = a[Be >> 2], Rr = a[Be + 4 >> 2], Be = v, v = Rr, Be = Be >>> 20 | 0, Rr = Be, Be = Be + Fr | 0, v = Rr >>> 0 > Be >>> 0 ? v + 1 | 0 : v, a[Dr >> 2] = Be, un = v & 1048575, a[Dr + 4 >> 2] = un, Dr = Qe + 32 | 0, Qe = v, v = $r & 65535, Qe = Qe >>> 20 | 0, $r = dr + Qe | 0, v = Qe >>> 0 > $r >>> 0 ? v + 1 | 0 : v, a[Dr >> 2] = $r, Oi = v, a[Dr + 4 >> 2] = v, dr = he, a[Me + 656 >> 2] = he, Si = fr & 1048575, a[Me + 660 >> 2] = Si, gn(Me + 616 | 0, m, ni), Fr = Me + 576 | 0, Dr = Fr + 8 | 0, v = o + 48 | 0, Gr = a[v >> 2], $i = a[v + 4 >> 2], Qe = a[o + 44 >> 2], v = o + 72 | 0, fr = a[v >> 2], Rr = a[v + 4 >> 2], zi = Rr, v = a[o + 40 >> 2], Rr = oi(Rr >>> 16 | 0, 0, 977, 1), he = v + Rr | 0, v = Qe + Fe | 0, Qe = he >>> 0 < Rr >>> 0 ? v + 1 | 0 : v, v = $i, Rr = Qe >>> 20 | 0, $i = Rr + Gr | 0, v = Rr >>> 0 > $i >>> 0 ? v + 1 | 0 : v, a[Dr >> 2] = $i, uo = v & 1048575, a[Dr + 4 >> 2] = uo, Rr = Fr + 16 | 0, Dr = o + 56 | 0, Gr = a[Dr >> 2], In = a[Dr + 4 >> 2], Dr = v, v = In, Dr = Dr >>> 20 | 0, In = Dr + Gr | 0, v = Dr >>> 0 > In >>> 0 ? v + 1 | 0 : v, a[Rr >> 2] = In, Sn = v & 1048575, a[Rr + 4 >> 2] = Sn, Rr = Fr + 24 | 0, Dr = o - -64 | 0, Gr = a[Dr >> 2], Ti = a[Dr + 4 >> 2], Dr = v, v = Ti, Dr = Dr >>> 20 | 0, Ti = Dr + Gr | 0, v = Dr >>> 0 > Ti >>> 0 ? v + 1 | 0 : v, a[Rr >> 2] = Ti, Vn = v & 1048575, a[Rr + 4 >> 2] = Vn, Fr = Fr + 32 | 0, Dr = v, v = zi & 65535, Dr = Dr >>> 20 | 0, Rr = fr + Dr | 0, v = Dr >>> 0 > Rr >>> 0 ? v + 1 | 0 : v, a[Fr >> 2] = Rr, Gr = v, a[Fr + 4 >> 2] = v, zi = he, a[Me + 576 >> 2] = he, yo = Qe & 1048575, a[Me + 580 >> 2] = yo, v = Me + 536 | 0, gn(v, m + 40 | 0, ni), gn(v, v, Xn), m = a[Me + 616 >> 2], fr = (m - dr | 0) - 3908 | 0, v = (a[Me + 620 >> 2] - ((m >>> 0 < dr >>> 0) + Si | 0) | 0) + 4194299 | 0, a[Me + 496 >> 2] = fr, Dr = fr >>> 0 < 4294963388 ? v + 1 | 0 : v, a[Me + 500 >> 2] = Dr, m = Me, v = a[m + 624 >> 2], dr = (v - we | 0) - 4 | 0, v = (a[m + 628 >> 2] - ((v >>> 0 < we >>> 0) + mi | 0) | 0) + 4194303 | 0, a[m + 504 >> 2] = dr, Qe = dr >>> 0 < 4294967292 ? v + 1 | 0 : v, a[m + 508 >> 2] = Qe, v = a[m + 632 >> 2], he = (v - wr | 0) - 4 | 0, v = (a[m + 636 >> 2] - ((v >>> 0 < wr >>> 0) + Kn | 0) | 0) + 4194303 | 0, a[m + 512 >> 2] = he, wr = he >>> 0 < 4294967292 ? v + 1 | 0 : v, a[m + 516 >> 2] = wr, v = a[m + 640 >> 2], we = (v - Be | 0) - 4 | 0, v = (a[m + 644 >> 2] - ((v >>> 0 < Be >>> 0) + un | 0) | 0) + 4194303 | 0, a[m + 520 >> 2] = we, Be = we >>> 0 < 4294967292 ? v + 1 | 0 : v, a[m + 524 >> 2] = Be, v = a[m + 648 >> 2], m = (v - $r | 0) - 4 | 0, v = (a[Me + 652 >> 2] - ((v >>> 0 < $r >>> 0) + Oi | 0) | 0) + 262143 | 0, a[Me + 528 >> 2] = m, $r = m >>> 0 < 4294967292 ? v + 1 | 0 : v, a[Me + 532 >> 2] = $r, v = a[Me + 568 >> 2], Oi = (Rr - v | 0) - 4 | 0, v = (Gr - (a[Me + 572 >> 2] + (v >>> 0 > Rr >>> 0) | 0) | 0) + 262143 | 0, a[Me + 488 >> 2] = Oi, Rr = Oi >>> 0 < 4294967292 ? v + 1 | 0 : v, a[Me + 492 >> 2] = Rr, v = a[Me + 560 >> 2], Gr = (Ti - v | 0) - 4 | 0, v = (Vn - (a[Me + 564 >> 2] + (v >>> 0 > Ti >>> 0) | 0) | 0) + 4194303 | 0, Ti = Gr, a[Me + 480 >> 2] = Gr, Vn = Gr >>> 0 < 4294967292 ? v + 1 | 0 : v, a[Me + 484 >> 2] = Vn, v = a[Me + 552 >> 2], Gr = (In - v | 0) - 4 | 0, v = (Sn - (a[Me + 556 >> 2] + (v >>> 0 > In >>> 0) | 0) | 0) + 4194303 | 0, In = Gr, a[Me + 472 >> 2] = Gr, Sn = Gr >>> 0 < 4294967292 ? v + 1 | 0 : v, a[Me + 476 >> 2] = Sn, v = a[Me + 544 >> 2], Gr = ($i - v | 0) - 4 | 0, v = (uo - (a[Me + 548 >> 2] + (v >>> 0 > $i >>> 0) | 0) | 0) + 4194303 | 0, a[Me + 464 >> 2] = Gr, uo = Gr >>> 0 < 4294967292 ? v + 1 | 0 : v, a[Me + 468 >> 2] = uo, v = a[Me + 536 >> 2], Fr = (zi - v | 0) - 3908 | 0, v = (yo - (a[Me + 540 >> 2] + (v >>> 0 > zi >>> 0) | 0) | 0) + 4194299 | 0, $i = Fr, a[Me + 456 >> 2] = Fr, yo = Fr >>> 0 < 4294963388 ? v + 1 | 0 : v, a[Me + 460 >> 2] = yo, Fr = oi($r >>> 16 | 0, 0, 977, 1) + fr | 0, v = Fe + Dr | 0, v = fr >>> 0 > Fr >>> 0 ? v + 1 | 0 : v, zi = v & 1048575, Io = zi;
      t: {
        if (xo = Fr, Mo = Fr ^ 976, qi = zi ^ 1, ((Mo | 0) != -1 | (qi | 0) != 1048575) & (Fr | zi) != 0 || (Si = $r & 65535, Fr = v, v = Qe, Fr = (Fr >>> 20 | 0) + dr | 0, zi = Fr >>> 0 < dr >>> 0 ? v + 1 | 0 : v, v = wr, ni = (zi >>> 20 | 0) + he | 0, mi = ni >>> 0 < he >>> 0 ? v + 1 | 0 : v, v = Be, Kn = (mi >>> 20 | 0) + we | 0, un = Kn >>> 0 < we >>> 0 ? v + 1 | 0 : v, v = Si, Si = un >>> 20 | 0, Oo = Si, Si = m + Si | 0, v = Oo >>> 0 > Si >>> 0 ? v + 1 | 0 : v, Si | (Kn | (ni | (Fr | xo))) | (v | (un & 1048575 | (mi & 1048575 | (zi & 1048575 | Io)))) && ((Fr & Mo & ni & Kn & Si) != -1 ? v = 1 : v = (zi & qi & mi & un & (v ^ 983040)) != 1048575, v)))
          break t;
        m = oi(Rr >>> 16 | 0, 0, 977, 1) + $i | 0, v = Fe + yo | 0, v = m >>> 0 < $i >>> 0 ? v + 1 | 0 : v, he = v & 1048575, Dr = he;
        r: {
          if (Qe = m, $r = m ^ 976, Fr = he ^ 1, (($r | 0) != -1 | (Fr | 0) != 1048575) & (m | he) != 0 || (Rr = Rr & 65535, m = v, v = uo, m = (m >>> 20 | 0) + Gr | 0, he = m >>> 0 < Gr >>> 0 ? v + 1 | 0 : v, v = Sn, we = (he >>> 20 | 0) + In | 0, dr = we >>> 0 < In >>> 0 ? v + 1 | 0 : v, v = Vn, wr = (dr >>> 20 | 0) + Ti | 0, Be = wr >>> 0 < Ti >>> 0 ? v + 1 | 0 : v, v = Rr, fr = Be >>> 20 | 0, Rr = fr, fr = fr + Oi | 0, v = Rr >>> 0 > fr >>> 0 ? v + 1 | 0 : v, fr | (wr | (we | (m | Qe))) | (v | (Be & 1048575 | (dr & 1048575 | (he & 1048575 | Dr)))) && ((m & $r & we & wr & fr) != -1 ? m = 1 : m = (he & Fr & dr & Be & (v ^ 983040)) != 1048575, m)))
            break r;
          if (a[o + 120 >> 2]) {
            if (a[B + 120 >> 2] = 1, xi(B, 120), !d)
              break e;
            a[d + 8 >> 2] = 0, a[d + 12 >> 2] = 0, a[d >> 2] = 1, a[d + 4 >> 2] = 0, B = d + 16 | 0, a[B >> 2] = 0, a[B + 4 >> 2] = 0, B = d + 24 | 0, a[B >> 2] = 0, a[B + 4 >> 2] = 0, B = d + 32 | 0, a[B >> 2] = 0, a[B + 4 >> 2] = 0;
            break e;
          }
          d && (m = o + 40 | 0, v = a[m >> 2], he = a[m + 4 >> 2], a[d >> 2] = v, a[d + 4 >> 2] = he, we = m + 8 | 0, dr = a[we >> 2], Qe = dr, wr = a[we + 4 >> 2], Dr = wr, we = d + 8 | 0, a[we >> 2] = dr, a[we + 4 >> 2] = wr, dr = m + 16 | 0, wr = a[dr >> 2], $r = wr, Be = a[dr + 4 >> 2], Fr = Be, dr = d + 16 | 0, a[dr >> 2] = wr, a[dr + 4 >> 2] = Be, wr = m + 24 | 0, Be = a[wr >> 2], Rr = Be, fr = a[wr + 4 >> 2], Oi = fr, wr = d + 24 | 0, a[wr >> 2] = Be, a[wr + 4 >> 2] = fr, m = m + 32 | 0, Be = a[m >> 2], m = a[m + 4 >> 2], fr = d + 32 | 0, a[fr >> 2] = Be, a[fr + 4 >> 2] = m, $i = oi(m >>> 16 | 0, 0, 977, 1), Gr = $i + v | 0, v = he + Fe | 0, a[d >> 2] = Gr, v = Gr >>> 0 < $i >>> 0 ? v + 1 | 0 : v, a[d + 4 >> 2] = v & 1048575, d = v, v = Dr, d = d >>> 20 | 0, he = d, d = d + Qe | 0, v = he >>> 0 > d >>> 0 ? v + 1 | 0 : v, a[we >> 2] = d, a[we + 4 >> 2] = v & 1048575, d = v, v = Fr, d = d >>> 20 | 0, he = d, d = d + $r | 0, v = he >>> 0 > d >>> 0 ? v + 1 | 0 : v, a[dr >> 2] = d, a[dr + 4 >> 2] = v & 1048575, d = v, v = Oi, d = d >>> 20 | 0, he = d, d = d + Rr | 0, v = he >>> 0 > d >>> 0 ? v + 1 | 0 : v, a[wr >> 2] = d, a[wr + 4 >> 2] = v & 1048575, d = m & 65535, m = v, v = d, m = m >>> 20 | 0, d = m, m = m + Be | 0, v = d >>> 0 > m >>> 0 ? v + 1 | 0 : v, a[fr >> 2] = m, a[fr + 4 >> 2] = v), os(B, o);
          break e;
        }
        d && (a[d >> 2] = 0, a[d + 4 >> 2] = 0, o = d + 32 | 0, a[o >> 2] = 0, a[o + 4 >> 2] = 0, o = d + 24 | 0, a[o >> 2] = 0, a[o + 4 >> 2] = 0, o = d + 16 | 0, a[o >> 2] = 0, a[o + 4 >> 2] = 0, o = d + 8 | 0, a[o >> 2] = 0, a[o + 4 >> 2] = 0), a[B + 120 >> 2] = 1, xi(B, 120);
        break e;
      }
      a[B + 120 >> 2] = 0, d && (o = a[Me + 500 >> 2], a[d >> 2] = a[Me + 496 >> 2], a[d + 4 >> 2] = o, o = Me + 496 | 0, v = o + 32 | 0, Fr = a[v + 4 >> 2], Rr = d + 32 | 0, a[Rr >> 2] = a[v >> 2], a[Rr + 4 >> 2] = Fr, v = o + 24 | 0, Fr = a[v + 4 >> 2], Rr = d + 24 | 0, a[Rr >> 2] = a[v >> 2], a[Rr + 4 >> 2] = Fr, v = o + 16 | 0, Fr = a[v + 4 >> 2], Rr = d + 16 | 0, a[Rr >> 2] = a[v >> 2], a[Rr + 4 >> 2] = Fr, o = o + 8 | 0, v = a[o + 4 >> 2], d = d + 8 | 0, a[d >> 2] = a[o >> 2], a[d + 4 >> 2] = v), Kn = Me + 496 | 0, gn(B + 80 | 0, Xn, Kn), zi = Me + 304 | 0, Fr = fr << 1, o = Dr, Dr = o << 1 | fr >>> 31, Lr(zi, we, Be, 0, 0, Fr, Dr, 0, 0), ni = Me + 224 | 0, d = dr << 1, Oi = Qe, Qe = dr, Rr = Oi << 1 | dr >>> 31, Lr(ni, he, wr, 0, 0, d, Rr, 0, 0), Gr = Me + 160 | 0, Lr(Gr, m, $r, 0, 0, m, $r, 0, 0), mi = Me + 144 | 0, Lr(mi, a[Me + 160 >> 2], a[Me + 164 >> 2], 0, 0, 15632, 16, 0, 0), un = Me + 112 | 0, dr = m << 1, $r = $r << 1 | m >>> 31, Lr(un, dr, $r, 0, 0, fr, o, 0, 0), Si = Me + 272 | 0, Lr(Si, we, Be, 0, 0, d, Rr, 0, 0), Vn = Me + 208 | 0, Lr(Vn, he, wr, 0, 0, he, wr, 0, 0), Sn = Me + 128 | 0, m = Gr + 8 | 0, Lr(Sn, a[m >> 2], a[m + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), uo = Me + 320 | 0, Lr(uo, fr, o, 0, 0, fr, o, 0, 0), yo = Me + 96 | 0, Lr(yo, dr, $r, 0, 0, Qe, Oi, 0, 0), xo = Me + 176 | 0, Gr = we, $i = Be, In = wr, wr = he, Lr(xo, we, Be, 0, 0, he << 1, In << 1 | he >>> 31, 0, 0), we = a[Me + 304 >> 2], m = a[Me + 224 >> 2], o = we + m | 0, he = a[Me + 308 >> 2], v = he + a[Me + 228 >> 2] | 0, m = o >>> 0 < m >>> 0 ? v + 1 | 0 : v, v = m + a[Me + 148 >> 2] | 0, d = o, Be = a[Me + 144 >> 2], o = o + Be | 0, Ti = o, o = o >>> 0 < Be >>> 0 ? v + 1 | 0 : v, Be = (m | 0) == (o | 0) & d >>> 0 > Ti >>> 0 | o >>> 0 < m >>> 0, v = mi + 8 | 0, fr = a[v >> 2], Rr = a[v + 4 >> 2], d = (m | 0) == (he | 0) & d >>> 0 < we >>> 0 | m >>> 0 < he >>> 0, v = ni + 8 | 0, he = a[v >> 2], we = zi + 8 | 0, m = he + a[we >> 2] | 0, v = a[we + 4 >> 2] + a[v + 4 >> 2] | 0, v = m >>> 0 < he >>> 0 ? v + 1 | 0 : v, he = m, m = m + d | 0, v = (he >>> 0 > m >>> 0 ? v + 1 | 0 : v) + Rr | 0, d = m, m = m + fr | 0, v = d >>> 0 > m >>> 0 ? v + 1 | 0 : v, d = m + Be | 0, m = d >>> 0 < m >>> 0 ? v + 1 | 0 : v, he = m << 12 | d >>> 20, zi = o, ni = d << 12 | o >>> 20, Xn = he, Io = a[Me + 272 >> 2], d = a[Me + 208 >> 2], o = Io + d | 0, mi = a[Me + 276 >> 2], v = mi + a[Me + 212 >> 2] | 0, v = o >>> 0 < d >>> 0 ? v + 1 | 0 : v, Be = o, d = a[Me + 112 >> 2], o = o + d | 0, he = v, v = v + a[Me + 116 >> 2] | 0, v = o >>> 0 < d >>> 0 ? v + 1 | 0 : v, fr = o, d = a[Me + 128 >> 2], o = o + d | 0, we = v, v = v + a[Me + 132 >> 2] | 0, d = o >>> 0 < d >>> 0 ? v + 1 | 0 : v, v = d + Xn | 0, Xn = Me + 80 | 0, Rr = o, ni = o + ni | 0, o = o >>> 0 > ni >>> 0 ? v + 1 | 0 : v, v = d, d = ni, ni = (o | 0) == (v | 0) & d >>> 0 < Rr >>> 0 | o >>> 0 < v >>> 0, Rr = (v | 0) == (we | 0) & fr >>> 0 > Rr >>> 0 | v >>> 0 < we >>> 0, v = Sn + 8 | 0, Sn = a[v >> 2], Mo = a[v + 4 >> 2], we = (he | 0) == (we | 0) & fr >>> 0 < Be >>> 0 | he >>> 0 > we >>> 0, v = un + 8 | 0, fr = a[v >> 2], un = a[v + 4 >> 2], Be = (he | 0) == (mi | 0) & Be >>> 0 < Io >>> 0 | he >>> 0 < mi >>> 0, v = Vn + 8 | 0, mi = a[v >> 2], Si = Si + 8 | 0, he = mi + a[Si >> 2] | 0, v = a[Si + 4 >> 2] + a[v + 4 >> 2] | 0, v = he >>> 0 < mi >>> 0 ? v + 1 | 0 : v, Si = he, he = he + Be | 0, v = (Si >>> 0 > he >>> 0 ? v + 1 | 0 : v) + un | 0, Be = he, he = he + fr | 0, v = Be >>> 0 > he >>> 0 ? v + 1 | 0 : v, Be = he, he = he + we | 0, v = (Be >>> 0 > he >>> 0 ? v + 1 | 0 : v) + Mo | 0, Be = he, he = he + Sn | 0, v = Be >>> 0 > he >>> 0 ? v + 1 | 0 : v, Be = he, he = he + Rr | 0, v = Be >>> 0 > he >>> 0 ? v + 1 | 0 : v, m = m >>> 20 | 0, Be = m, m = m + he | 0, v = Be >>> 0 > m >>> 0 ? v + 1 | 0 : v, he = m + ni | 0, m = he >>> 0 < m >>> 0 ? v + 1 | 0 : v, v = m << 12 | he >>> 20, Be = he << 12, he = o, fr = Be | o >>> 20, Rr = v, mi = a[Me + 96 >> 2], we = a[Me + 176 >> 2], o = mi + we | 0, ni = a[Me + 100 >> 2], v = ni + a[Me + 180 >> 2] | 0, we = o >>> 0 < we >>> 0 ? v + 1 | 0 : v, v = we + Rr | 0, Be = o, fr = o + fr | 0, v = o >>> 0 > fr >>> 0 ? v + 1 | 0 : v, un = fr << 4 & -16, Rr = he, o = v, Lr(Xn, un | he >>> 16 & 15, (v << 4 | fr >>> 28) & 16777215, 0, 0, 977, 1, 0, 0), un = Me + 256 | 0, Lr(un, Qe, Oi, 0, 0, Fr, Dr, 0, 0), Si = Me - -64 | 0, Lr(Si, dr, $r, 0, 0, wr, In, 0, 0), Vn = Me + 288 | 0, Lr(Vn, Gr, $i, 0, 0, Gr, $i, 0, 0), Sn = Me + 48 | 0, fr = (v | 0) == (we | 0) & fr >>> 0 < Be >>> 0 | v >>> 0 < we >>> 0, we = (we | 0) == (ni | 0) & Be >>> 0 < mi >>> 0 | we >>> 0 < ni >>> 0, v = xo + 8 | 0, Be = a[v >> 2], ni = yo + 8 | 0, he = Be + a[ni >> 2] | 0, v = a[ni + 4 >> 2] + a[v + 4 >> 2] | 0, v = he >>> 0 < Be >>> 0 ? v + 1 | 0 : v, Be = he, he = he + we | 0, v = Be >>> 0 > he >>> 0 ? v + 1 | 0 : v, m = m >>> 20 | 0, Be = m, m = m + he | 0, v = Be >>> 0 > m >>> 0 ? v + 1 | 0 : v, he = m + fr | 0, m = he >>> 0 < m >>> 0 ? v + 1 | 0 : v, we = m << 12 | he >>> 20, he = he << 12 | o >>> 20, Be = we, ni = a[Me + 64 >> 2], we = a[Me + 288 >> 2], o = ni + we | 0, fr = a[Me + 68 >> 2], v = fr + a[Me + 292 >> 2] | 0, v = o >>> 0 < we >>> 0 ? v + 1 | 0 : v, we = o, o = v, v = v + Be | 0, he = he + we | 0, v = he >>> 0 < we >>> 0 ? v + 1 | 0 : v, Be = he, he = v, Lr(Sn, Be, v & 1048575, 0, 0, 15632, 16, 0, 0), mi = Me + 192 | 0, Lr(mi, wr, In, 0, 0, Fr, Dr, 0, 0), Dr = Me + 240 | 0, Lr(Dr, Qe, Oi, 0, 0, Qe, Oi, 0, 0), wr = Me + 32 | 0, Lr(wr, dr, $r, 0, 0, Gr, $i, 0, 0), $r = Me + 16 | 0, dr = $r, Be = (o | 0) == (v | 0) & we >>> 0 > Be >>> 0 | o >>> 0 > v >>> 0, we = (o | 0) == (fr | 0) & we >>> 0 < ni >>> 0 | o >>> 0 < fr >>> 0, v = Vn + 8 | 0, fr = a[v >> 2], Qe = Si + 8 | 0, o = fr + a[Qe >> 2] | 0, v = a[Qe + 4 >> 2] + a[v + 4 >> 2] | 0, v = o >>> 0 < fr >>> 0 ? v + 1 | 0 : v, Qe = o, o = o + we | 0, v = Qe >>> 0 > o >>> 0 ? v + 1 | 0 : v, m = m >>> 20 | 0, o = o + m | 0, v = m >>> 0 > o >>> 0 ? v + 1 | 0 : v, m = o + Be | 0, o = m >>> 0 < o >>> 0 ? v + 1 | 0 : v, we = o << 12 | m >>> 20, Be = m << 12 | he >>> 20, fr = a[Me + 32 >> 2], m = Be + fr | 0, he = we, v = he + a[Me + 36 >> 2] | 0, v = m >>> 0 < fr >>> 0 ? v + 1 | 0 : v, Lr(dr, m, v, 0, 0, 15632, 16, 0, 0), m = (v | 0) == (he | 0) & m >>> 0 < Be >>> 0 | v >>> 0 < he >>> 0, v = wr + 8 | 0, he = a[v >> 2], v = a[v + 4 >> 2], o = o >>> 20 | 0, Be = o, o = o + he | 0, v = Be >>> 0 > o >>> 0 ? v + 1 | 0 : v, he = o, o = o + m | 0, v = he >>> 0 > o >>> 0 ? v + 1 | 0 : v, Lr(Me, o, v, 0, 0, 64028672, 65536, 0, 0), o = Me, dr = a[o + 80 >> 2], m = a[o + 320 >> 2], he = dr + m | 0, we = a[o + 84 >> 2], v = we + a[o + 324 >> 2] | 0, a[o + 416 >> 2] = -3908 - he, m = m >>> 0 > he >>> 0 ? v + 1 | 0 : v, a[o + 420 >> 2] = 4194299 - ((m & 1048575) + (he >>> 0 > 4294963388) | 0), we = (m | 0) == (we | 0) & he >>> 0 < dr >>> 0 | m >>> 0 < we >>> 0, v = uo + 8 | 0, dr = a[v >> 2], wr = Xn + 8 | 0, he = dr + a[wr >> 2] | 0, v = a[wr + 4 >> 2] + a[v + 4 >> 2] | 0, v = he >>> 0 < dr >>> 0 ? v + 1 | 0 : v, we = he + we | 0, he = we >>> 0 < he >>> 0 ? v + 1 | 0 : v, dr = he << 12 | we >>> 20, we = we << 12 | m >>> 20, wr = dr, fr = a[o + 48 >> 2], dr = a[o + 256 >> 2], m = fr + dr | 0, Be = a[o + 52 >> 2], v = Be + a[o + 260 >> 2] | 0, v = m >>> 0 < dr >>> 0 ? v + 1 | 0 : v, dr = m, m = v, v = v + wr | 0, we = we + dr | 0, v = we >>> 0 < dr >>> 0 ? v + 1 | 0 : v, wr = we, a[o + 424 >> 2] = -4 - we, we = v, a[o + 428 >> 2] = 4194303 - ((v & 1048575) + (wr >>> 0 > 4294967292) | 0), wr = (m | 0) == (v | 0) & wr >>> 0 < dr >>> 0 | m >>> 0 > v >>> 0, dr = (m | 0) == (Be | 0) & fr >>> 0 > dr >>> 0 | m >>> 0 < Be >>> 0, v = un + 8 | 0, Be = a[v >> 2], fr = Sn + 8 | 0, m = Be + a[fr >> 2] | 0, v = a[fr + 4 >> 2] + a[v + 4 >> 2] | 0, v = m >>> 0 < Be >>> 0 ? v + 1 | 0 : v, Be = m, m = m + dr | 0, v = Be >>> 0 > m >>> 0 ? v + 1 | 0 : v, he = he >>> 20 | 0, m = m + he | 0, v = he >>> 0 > m >>> 0 ? v + 1 | 0 : v, he = m + wr | 0, m = he >>> 0 < m >>> 0 ? v + 1 | 0 : v, dr = m << 12 | he >>> 20, fr = he << 12 | we >>> 20, Oi = a[o + 192 >> 2], he = a[o + 240 >> 2], we = Oi + he | 0, Qe = a[o + 196 >> 2], v = Qe + a[o + 244 >> 2] | 0, v = he >>> 0 > we >>> 0 ? v + 1 | 0 : v, Be = we, we = a[o + 16 >> 2], wr = Be + we | 0, he = v, v = v + a[o + 20 >> 2] | 0, we = we >>> 0 > wr >>> 0 ? v + 1 | 0 : v, v = we + dr | 0, dr = fr + wr | 0, v = dr >>> 0 < wr >>> 0 ? v + 1 | 0 : v, fr = dr, a[o + 432 >> 2] = -4 - fr, dr = v, a[o + 436 >> 2] = 4194303 - ((v & 1048575) + (fr >>> 0 > 4294967292) | 0), fr = (v | 0) == (we | 0) & fr >>> 0 < wr >>> 0 | v >>> 0 < we >>> 0, we = (he | 0) == (we | 0) & Be >>> 0 > wr >>> 0 | he >>> 0 > we >>> 0, v = $r + 8 | 0, wr = a[v >> 2], $r = a[v + 4 >> 2], Be = (he | 0) == (Qe | 0) & Be >>> 0 < Oi >>> 0 | he >>> 0 < Qe >>> 0, v = Dr + 8 | 0, Qe = a[v >> 2], Dr = mi + 8 | 0, he = Qe + a[Dr >> 2] | 0, v = a[Dr + 4 >> 2] + a[v + 4 >> 2] | 0, v = he >>> 0 < Qe >>> 0 ? v + 1 | 0 : v, Dr = he, he = he + Be | 0, v = (Dr >>> 0 > he >>> 0 ? v + 1 | 0 : v) + $r | 0, Be = he, he = he + wr | 0, v = Be >>> 0 > he >>> 0 ? v + 1 | 0 : v, Be = he, he = he + we | 0, v = Be >>> 0 > he >>> 0 ? v + 1 | 0 : v, m = m >>> 20 | 0, Be = m, m = m + he | 0, v = Be >>> 0 > m >>> 0 ? v + 1 | 0 : v, he = m + fr | 0, m = he >>> 0 < m >>> 0 ? v + 1 | 0 : v, we = m << 12 | he >>> 20, wr = he << 12 | dr >>> 20, Qe = a[o >> 2], he = Ti & -2, dr = Qe + he | 0, fr = a[o + 4 >> 2], v = fr + (zi & 1048575) | 0, he = he >>> 0 > dr >>> 0 ? v + 1 | 0 : v, v = he + we | 0, wr = wr + dr | 0, v = wr >>> 0 < dr >>> 0 ? v + 1 | 0 : v, a[o + 440 >> 2] = -4 - wr, we = v, a[o + 444 >> 2] = 4194303 - ((v & 1048575) + (wr >>> 0 > 4294967292) | 0), Be = d, Dr = Rr & 65535, wr = (v | 0) == (he | 0) & wr >>> 0 < dr >>> 0 | v >>> 0 < he >>> 0, he = (he | 0) == (fr | 0) & dr >>> 0 < Qe >>> 0 | he >>> 0 < fr >>> 0, v = o + 8 | 0, d = he + a[v >> 2] | 0, v = a[v + 4 >> 2], v = d >>> 0 < he >>> 0 ? v + 1 | 0 : v, m = m >>> 20 | 0, he = m, m = m + d | 0, v = he >>> 0 > m >>> 0 ? v + 1 | 0 : v, d = m, m = m + wr | 0, v = Dr + ((d >>> 0 > m >>> 0 ? v + 1 | 0 : v) << 12 | m >>> 20) | 0, he = m << 12 | we >>> 20, m = he + Be | 0, a[o + 448 >> 2] = -4 - m, a[o + 452 >> 2] = 262143 - ((m >>> 0 > 4294967292) + (m >>> 0 < he >>> 0 ? v + 1 | 0 : v) | 0), Fr = o + 376 | 0, m = o + 416 | 0, gn(Fr, m, Kn), Gr = o + 336 | 0, gn(Gr, o + 656 | 0, m), $i = o + 456 | 0, na(B, $i), d = a[o + 408 >> 2], m = d + a[B + 32 >> 2] | 0, v = a[B + 36 >> 2] + a[o + 412 >> 2] | 0, d = m >>> 0 < d >>> 0 ? v + 1 | 0 : v, v = a[o + 372 >> 2], In = v, Rr = a[o + 368 >> 2], he = Rr, v = (v << 1 | he >>> 31) + d | 0, he = he << 1, m = m + he | 0, v = he >>> 0 > m >>> 0 ? v + 1 | 0 : v, we = m, a[B + 32 >> 2] = m, dr = v, a[B + 36 >> 2] = v, d = a[o + 400 >> 2], m = d + a[B + 24 >> 2] | 0, v = a[B + 28 >> 2] + a[o + 404 >> 2] | 0, v = m >>> 0 < d >>> 0 ? v + 1 | 0 : v, d = m, he = v, m = a[o + 360 >> 2], Ti = m, v = a[o + 364 >> 2], zi = v, v = (v << 1 | m >>> 31) + he | 0, m = m << 1, he = m, m = m + d | 0, v = he >>> 0 > m >>> 0 ? v + 1 | 0 : v, a[B + 24 >> 2] = m, wr = v, a[B + 28 >> 2] = v, he = a[o + 392 >> 2], d = he + a[B + 16 >> 2] | 0, v = a[B + 20 >> 2] + a[o + 396 >> 2] | 0, v = d >>> 0 < he >>> 0 ? v + 1 | 0 : v, he = d, Be = v, d = a[o + 352 >> 2], ni = d, v = a[o + 356 >> 2], mi = v, v = (v << 1 | d >>> 31) + Be | 0, d = d << 1, Be = d, d = d + he | 0, v = Be >>> 0 > d >>> 0 ? v + 1 | 0 : v, a[B + 16 >> 2] = d, Be = v, a[B + 20 >> 2] = v, fr = a[o + 384 >> 2], he = fr + a[B + 8 >> 2] | 0, v = a[B + 12 >> 2] + a[o + 388 >> 2] | 0, fr = he >>> 0 < fr >>> 0 ? v + 1 | 0 : v, v = a[o + 348 >> 2], Kn = v, Oi = a[o + 344 >> 2], Qe = Oi, v = (v << 1 | Qe >>> 31) + fr | 0, Qe = Qe << 1, he = he + Qe | 0, v = Qe >>> 0 > he >>> 0 ? v + 1 | 0 : v, fr = he, a[B + 8 >> 2] = he, Qe = v, a[B + 12 >> 2] = v, Dr = a[o + 376 >> 2], he = Dr + a[B >> 2] | 0, v = a[B + 4 >> 2] + a[o + 380 >> 2] | 0, v = he >>> 0 < Dr >>> 0 ? v + 1 | 0 : v, Dr = he, $r = v, he = a[o + 336 >> 2], un = he, v = a[o + 340 >> 2], Si = v, v = (v << 1 | he >>> 31) + $r | 0, he = he << 1, $r = he, he = he + Dr | 0, v = $r >>> 0 > he >>> 0 ? v + 1 | 0 : v, a[B >> 2] = he, Dr = v, a[B + 4 >> 2] = v, v = dr + In | 0, we = we + Rr | 0, v = we >>> 0 < Rr >>> 0 ? v + 1 | 0 : v, a[o + 368 >> 2] = we, a[o + 372 >> 2] = v, v = wr + zi | 0, we = m, m = m + Ti | 0, v = we >>> 0 > m >>> 0 ? v + 1 | 0 : v, a[o + 360 >> 2] = m, a[o + 364 >> 2] = v, v = Be + mi | 0, m = d + ni | 0, v = m >>> 0 < d >>> 0 ? v + 1 | 0 : v, a[o + 352 >> 2] = m, a[o + 356 >> 2] = v, v = Qe + Kn | 0, m = fr + Oi | 0, v = m >>> 0 < Oi >>> 0 ? v + 1 | 0 : v, a[o + 344 >> 2] = m, a[o + 348 >> 2] = v, v = Dr + Si | 0, o = he + un | 0, v = o >>> 0 < he >>> 0 ? v + 1 | 0 : v, a[Me + 336 >> 2] = o, a[Me + 340 >> 2] = v, gn(B + 40 | 0, Gr, $i), gn(Fr, Fr, Me + 576 | 0), v = a[B + 44 >> 2] + a[Me + 380 >> 2] | 0, m = a[Me + 376 >> 2], o = m + a[B + 40 >> 2] | 0, a[B + 40 >> 2] = o, a[B + 44 >> 2] = o >>> 0 < m >>> 0 ? v + 1 | 0 : v, d = a[Me + 384 >> 2], o = B + 48 | 0, m = d + a[o >> 2] | 0, v = a[o + 4 >> 2] + a[Me + 388 >> 2] | 0, a[o >> 2] = m, a[o + 4 >> 2] = m >>> 0 < d >>> 0 ? v + 1 | 0 : v, d = a[Me + 392 >> 2], o = B + 56 | 0, m = d + a[o >> 2] | 0, v = a[o + 4 >> 2] + a[Me + 396 >> 2] | 0, a[o >> 2] = m, a[o + 4 >> 2] = m >>> 0 < d >>> 0 ? v + 1 | 0 : v, d = a[Me + 400 >> 2], o = B - -64 | 0, m = d + a[o >> 2] | 0, v = a[o + 4 >> 2] + a[Me + 404 >> 2] | 0, a[o >> 2] = m, a[o + 4 >> 2] = m >>> 0 < d >>> 0 ? v + 1 | 0 : v, m = a[Me + 408 >> 2], B = B + 72 | 0, o = m + a[B >> 2] | 0, v = a[B + 4 >> 2] + a[Me + 412 >> 2] | 0, a[B >> 2] = o, a[B + 4 >> 2] = o >>> 0 < m >>> 0 ? v + 1 | 0 : v;
    }
    be = Me + 736 | 0;
  }
  function vs(B, o, m) {
    var d = 0, v = 0, he = 0, we = 0, Be = 0, Me = 0, fr = 0, wr = 0, dr = 0, Dr = 0, Rr = 0, Qe = 0, Fr = 0, Gr = 0, $r = 0, ni = 0, mi = 0, Si = 0, Oi = 0, $i = 0, zi = 0, un = 0, In = 0, Ti = 0, Sn = 0, Kn = 0;
    we = be - 256 | 0, be = we, Me = we + 240 | 0, Lr(Me, a[m >> 2], a[m + 4 >> 2], 0, 0, a[o >> 2], a[o + 4 >> 2], 0, 0), d = a[we + 244 >> 2], a[B >> 2] = a[we + 240 >> 2], a[B + 4 >> 2] = d, wr = we + 208 | 0, Lr(wr, a[m + 8 >> 2], a[m + 12 >> 2], 0, 0, a[o >> 2], a[o + 4 >> 2], 0, 0), Be = we + 224 | 0, Lr(Be, a[m >> 2], a[m + 4 >> 2], 0, 0, a[o + 8 >> 2], a[o + 12 >> 2], 0, 0), Qe = B, v = a[we + 208 >> 2], B = Me + 8 | 0, d = a[B >> 2], Rr = v + d | 0, dr = a[we + 212 >> 2], B = dr + a[B + 4 >> 2] | 0, fr = d >>> 0 > Rr >>> 0 ? B + 1 | 0 : B, B = fr + a[we + 228 >> 2] | 0, d = a[we + 224 >> 2], Me = d + Rr | 0, a[Qe + 8 >> 2] = Me, he = d >>> 0 > Me >>> 0 ? B + 1 | 0 : B, a[Qe + 12 >> 2] = he, $r = we + 160 | 0, Lr($r, a[m + 16 >> 2], a[m + 20 >> 2], 0, 0, a[o >> 2], a[o + 4 >> 2], 0, 0), Si = we + 176 | 0, Lr(Si, a[m + 8 >> 2], a[m + 12 >> 2], 0, 0, a[o + 8 >> 2], a[o + 12 >> 2], 0, 0), ni = we + 192 | 0, Lr(ni, a[m >> 2], a[m + 4 >> 2], 0, 0, a[o + 16 >> 2], a[o + 20 >> 2], 0, 0), v = (fr | 0) == (dr | 0) & v >>> 0 > Rr >>> 0 | fr >>> 0 < dr >>> 0, B = wr + 8 | 0, d = v + a[B >> 2] | 0, B = a[B + 4 >> 2], v = d >>> 0 < v >>> 0 ? B + 1 | 0 : B, Me = (he | 0) == (fr | 0) & Me >>> 0 < Rr >>> 0 | he >>> 0 < fr >>> 0, B = Be + 8 | 0, he = Me + a[B >> 2] | 0, B = a[B + 4 >> 2], B = (he >>> 0 < Me >>> 0 ? B + 1 | 0 : B) + v | 0, Me = d + he | 0, B = Me >>> 0 < he >>> 0 ? B + 1 | 0 : B, dr = Me, Me = a[we + 160 >> 2], he = dr + Me | 0, Fr = B, B = B + a[we + 164 >> 2] | 0, B = he >>> 0 < Me >>> 0 ? B + 1 | 0 : B, Me = a[we + 176 >> 2], wr = Me + he | 0, Gr = B, B = B + a[we + 180 >> 2] | 0, Dr = Me >>> 0 > wr >>> 0 ? B + 1 | 0 : B, B = Dr + a[we + 196 >> 2] | 0, Me = a[we + 192 >> 2], fr = Me + wr | 0, a[Qe + 16 >> 2] = fr, Be = fr >>> 0 < Me >>> 0 ? B + 1 | 0 : B, a[Qe + 20 >> 2] = Be, In = we + 96 | 0, Lr(In, a[m + 24 >> 2], a[m + 28 >> 2], 0, 0, a[o >> 2], a[o + 4 >> 2], 0, 0), zi = we + 112 | 0, Lr(zi, a[m + 16 >> 2], a[m + 20 >> 2], 0, 0, a[o + 8 >> 2], a[o + 12 >> 2], 0, 0), un = we + 128 | 0, Lr(un, a[m + 8 >> 2], a[m + 12 >> 2], 0, 0, a[o + 16 >> 2], a[o + 20 >> 2], 0, 0), $i = we + 144 | 0, Lr($i, a[m >> 2], a[m + 4 >> 2], 0, 0, a[o + 24 >> 2], a[o + 28 >> 2], 0, 0), Me = (Fr | 0) == (Gr | 0) & he >>> 0 < dr >>> 0 | Fr >>> 0 > Gr >>> 0, B = $r + 8 | 0, Rr = Me + a[B >> 2] | 0, B = a[B + 4 >> 2], d = (v | 0) == (Fr | 0) & d >>> 0 > dr >>> 0 | v >>> 0 > Fr >>> 0, $r = Rr + d | 0, B = Me >>> 0 > Rr >>> 0 ? B + 1 | 0 : B, Me = B, v = d >>> 0 > $r >>> 0 ? B + 1 | 0 : B, dr = $r, d = (Dr | 0) == (Gr | 0) & he >>> 0 > wr >>> 0 | Dr >>> 0 < Gr >>> 0, B = Si + 8 | 0, he = d + a[B >> 2] | 0, B = a[B + 4 >> 2], B = (d >>> 0 > he >>> 0 ? B + 1 | 0 : B) + v | 0, Oi = he, he = he + dr | 0, d = Oi >>> 0 > he >>> 0 ? B + 1 | 0 : B, Si = he, dr = he, he = (Be | 0) == (Dr | 0) & fr >>> 0 < wr >>> 0 | Be >>> 0 < Dr >>> 0, B = ni + 8 | 0, fr = he + a[B >> 2] | 0, B = a[B + 4 >> 2], B = (he >>> 0 > fr >>> 0 ? B + 1 | 0 : B) + d | 0, he = fr + dr | 0, B = he >>> 0 < fr >>> 0 ? B + 1 | 0 : B, Fr = he, he = a[we + 96 >> 2], Gr = Fr + he | 0, ni = B, B = B + a[we + 100 >> 2] | 0, B = he >>> 0 > Gr >>> 0 ? B + 1 | 0 : B, he = a[we + 112 >> 2], Dr = he + Gr | 0, mi = B, B = B + a[we + 116 >> 2] | 0, B = he >>> 0 > Dr >>> 0 ? B + 1 | 0 : B, he = a[we + 128 >> 2], Be = he + Dr | 0, Oi = B, B = B + a[we + 132 >> 2] | 0, wr = he >>> 0 > Be >>> 0 ? B + 1 | 0 : B, B = wr + a[we + 148 >> 2] | 0, he = a[we + 144 >> 2], fr = he + Be | 0, a[Qe + 24 >> 2] = fr, B = he >>> 0 > fr >>> 0 ? B + 1 | 0 : B, a[Qe + 28 >> 2] = B, Ti = we + 48 | 0, Lr(Ti, a[m + 24 >> 2], a[m + 28 >> 2], 0, 0, a[o + 8 >> 2], a[o + 12 >> 2], 0, 0), Sn = we - -64 | 0, Lr(Sn, a[m + 16 >> 2], a[m + 20 >> 2], 0, 0, a[o + 16 >> 2], a[o + 20 >> 2], 0, 0), Kn = we + 80 | 0, Lr(Kn, a[m + 8 >> 2], a[m + 12 >> 2], 0, 0, a[o + 24 >> 2], a[o + 28 >> 2], 0, 0), fr = (B | 0) == (wr | 0) & Be >>> 0 > fr >>> 0 | B >>> 0 < wr >>> 0, B = $i + 8 | 0, he = fr + a[B >> 2] | 0, B = a[B + 4 >> 2], fr = he >>> 0 < fr >>> 0 ? B + 1 | 0 : B, Be = (wr | 0) == (Oi | 0) & Be >>> 0 < Dr >>> 0 | wr >>> 0 < Oi >>> 0, B = un + 8 | 0, dr = Be + a[B >> 2] | 0, B = a[B + 4 >> 2], wr = Be >>> 0 > dr >>> 0 ? B + 1 | 0 : B, Be = (d | 0) == (ni | 0) & Fr >>> 0 < Si >>> 0 | d >>> 0 > ni >>> 0, B = (d | 0) == (v | 0) & $r >>> 0 > Si >>> 0 | d >>> 0 < v >>> 0, d = (v | 0) == (Me | 0) & Rr >>> 0 > $r >>> 0 | v >>> 0 < Me >>> 0, v = B + d | 0, B = d >>> 0 > v >>> 0, Me = v + Be | 0, Rr = Me >>> 0 < v >>> 0 ? B + 1 | 0 : B, d = (ni | 0) == (mi | 0) & Fr >>> 0 > Gr >>> 0 | ni >>> 0 > mi >>> 0, B = In + 8 | 0, v = d + a[B >> 2] | 0, B = a[B + 4 >> 2], B = (d >>> 0 > v >>> 0 ? B + 1 | 0 : B) + Rr | 0, Be = v, v = v + Me | 0, d = Be >>> 0 > v >>> 0 ? B + 1 | 0 : B, ni = v, Be = v, v = (mi | 0) == (Oi | 0) & Dr >>> 0 < Gr >>> 0 | mi >>> 0 > Oi >>> 0, B = zi + 8 | 0, Dr = v + a[B >> 2] | 0, B = a[B + 4 >> 2], B = (v >>> 0 > Dr >>> 0 ? B + 1 | 0 : B) + d | 0, Be = Be + Dr | 0, v = Be >>> 0 < Dr >>> 0 ? B + 1 | 0 : B, B = v + wr | 0, Oi = Be, Gr = Be + dr | 0, $r = Be >>> 0 > Gr >>> 0 ? B + 1 | 0 : B, B = $r + fr | 0, Be = he + Gr | 0, B = Be >>> 0 < Gr >>> 0 ? B + 1 | 0 : B, Si = Be, Be = a[we + 48 >> 2], Fr = Si + Be | 0, $i = B, B = B + a[we + 52 >> 2] | 0, mi = Be >>> 0 > Fr >>> 0 ? B + 1 | 0 : B, B = mi + a[we + 68 >> 2] | 0, wr = a[we + 64 >> 2], Be = wr + Fr | 0, dr = a[we + 80 >> 2], Dr = Be + dr | 0, wr = Be >>> 0 < wr >>> 0 ? B + 1 | 0 : B, B = wr + a[we + 84 >> 2] | 0, a[Qe + 32 >> 2] = Dr, B = Dr >>> 0 < dr >>> 0 ? B + 1 | 0 : B, a[Qe + 36 >> 2] = B, zi = we + 16 | 0, Lr(zi, a[m + 24 >> 2], a[m + 28 >> 2], 0, 0, a[o + 16 >> 2], a[o + 20 >> 2], 0, 0), un = we + 32 | 0, Lr(un, a[m + 16 >> 2], a[m + 20 >> 2], 0, 0, a[o + 24 >> 2], a[o + 28 >> 2], 0, 0), dr = (B | 0) == (wr | 0) & Be >>> 0 > Dr >>> 0 | B >>> 0 < wr >>> 0, B = Kn + 8 | 0, Dr = dr + a[B >> 2] | 0, B = a[B + 4 >> 2], dr = Dr >>> 0 < dr >>> 0 ? B + 1 | 0 : B, Be = (wr | 0) == (mi | 0) & Be >>> 0 < Fr >>> 0 | wr >>> 0 < mi >>> 0, B = Sn + 8 | 0, wr = Be + a[B >> 2] | 0, B = a[B + 4 >> 2], Be = Be >>> 0 > wr >>> 0 ? B + 1 | 0 : B, fr = (fr | 0) == ($i | 0) & he >>> 0 > Si >>> 0 | fr >>> 0 > $i >>> 0, he = (v | 0) == ($r | 0) & Gr >>> 0 < Oi >>> 0 | v >>> 0 > $r >>> 0, B = (d | 0) == (v | 0) & ni >>> 0 > Oi >>> 0 | d >>> 0 > v >>> 0, d = (d | 0) == (Rr | 0) & Me >>> 0 > ni >>> 0 | d >>> 0 < Rr >>> 0, v = B + d | 0, B = d >>> 0 > v >>> 0, d = v + he | 0, B = d >>> 0 < v >>> 0 ? B + 1 | 0 : B, Me = d + fr | 0, he = Me >>> 0 < d >>> 0 ? B + 1 | 0 : B, d = (mi | 0) == ($i | 0) & Fr >>> 0 < Si >>> 0 | mi >>> 0 < $i >>> 0, B = Ti + 8 | 0, v = d + a[B >> 2] | 0, B = a[B + 4 >> 2], B = (d >>> 0 > v >>> 0 ? B + 1 | 0 : B) + he | 0, d = v + Me | 0, v = d >>> 0 < v >>> 0 ? B + 1 | 0 : B, B = v + Be | 0, Be = Dr, Gr = d, Rr = d + wr | 0, Dr = Rr, fr = Be + Dr | 0, d = d >>> 0 > Dr >>> 0 ? B + 1 | 0 : B, B = d + dr | 0, Rr = a[we + 16 >> 2], wr = Rr + fr | 0, Fr = fr >>> 0 < Dr >>> 0 ? B + 1 | 0 : B, B = Fr + a[we + 20 >> 2] | 0, dr = wr >>> 0 < Rr >>> 0 ? B + 1 | 0 : B, B = dr + a[we + 36 >> 2] | 0, Be = a[we + 32 >> 2], Rr = Be + wr | 0, a[Qe + 40 >> 2] = Rr, Be = Be >>> 0 > Rr >>> 0 ? B + 1 | 0 : B, a[Qe + 44 >> 2] = Be, Lr(we, a[m + 24 >> 2], a[m + 28 >> 2], 0, 0, a[o + 24 >> 2], a[o + 28 >> 2], 0, 0), m = Qe, o = (dr | 0) == (Fr | 0) & fr >>> 0 > wr >>> 0 | dr >>> 0 < Fr >>> 0, B = zi + 8 | 0, Qe = o + a[B >> 2] | 0, B = a[B + 4 >> 2], o = o >>> 0 > Qe >>> 0 ? B + 1 | 0 : B, fr = (d | 0) == (Fr | 0) & fr >>> 0 < Dr >>> 0 | d >>> 0 > Fr >>> 0, B = (d | 0) == (v | 0) & Dr >>> 0 < Gr >>> 0 | d >>> 0 < v >>> 0, d = (v | 0) == (he | 0) & Me >>> 0 > Gr >>> 0 | v >>> 0 < he >>> 0, v = B + d | 0, B = d >>> 0 > v >>> 0, Me = v + fr | 0, fr = Me >>> 0 < v >>> 0 ? B + 1 | 0 : B, B = fr + o | 0, o = Me + Qe | 0, d = o >>> 0 < Me >>> 0 ? B + 1 | 0 : B, he = o, v = o, o = (Be | 0) == (dr | 0) & wr >>> 0 > Rr >>> 0 | Be >>> 0 < dr >>> 0, B = un + 8 | 0, Qe = o + a[B >> 2] | 0, B = a[B + 4 >> 2], B = (o >>> 0 > Qe >>> 0 ? B + 1 | 0 : B) + d | 0, v = v + Qe | 0, o = v >>> 0 < Qe >>> 0 ? B + 1 | 0 : B, B = o + a[we + 4 >> 2] | 0, Qe = a[we >> 2], Rr = Qe + v | 0, a[m + 48 >> 2] = Rr, B = Qe >>> 0 > Rr >>> 0 ? B + 1 | 0 : B, a[m + 52 >> 2] = B, Qe = (B | 0) == (o | 0) & v >>> 0 > Rr >>> 0 | B >>> 0 < o >>> 0, v = (o | 0) == (d | 0) & v >>> 0 < he >>> 0 | o >>> 0 < d >>> 0, o = (d | 0) == (fr | 0) & he >>> 0 < Me >>> 0 | d >>> 0 < fr >>> 0, B = we + 8 | 0, d = o + a[B >> 2] | 0, B = a[B + 4 >> 2], B = o >>> 0 > d >>> 0 ? B + 1 | 0 : B, o = d + v | 0, B = o >>> 0 < d >>> 0 ? B + 1 | 0 : B, he = o, o = o + Qe | 0, B = he >>> 0 > o >>> 0 ? B + 1 | 0 : B, a[m + 56 >> 2] = o, a[m + 60 >> 2] = B, be = we + 256 | 0;
  }
  function vi(B, o, m, d) {
    var v = 0, he = 0, we = 0, Be = 0, Me = 0, fr = 0, wr = 0, dr = 0, Dr = 0, Rr = 0, Qe = 0, Fr = 0, Gr = 0, $r = 0, ni = 0, mi = 0, Si = 0, Oi = 0, $i = 0, zi = 0, un = 0, In = 0, Ti = 0, Sn = 0, Kn = 0, Vn = 0, Xn = 0, uo = 0, yo = 0, Io = 0, xo = 0, Mo = 0, qi = 0, Oo = 0, Ho = 0, Go = 0, ns = 0, ds = 0, Ts = 0, Ao = 0, po = 0, _o = 0, Uo = 0, ts = 0, Lo = 0, Wo = 0, ps = 0;
    Be = be - 480 | 0, be = Be, v = a[m + 4 >> 2], Xn = v, wr = v >> 31, v = a[B + 4 >> 2], Dr = v, v = v >> 31, Mo = Be + 352 | 0, Kn = a[m >> 2], we = a[B >> 2], he = v, Lr(Mo, Kn, Xn, wr, wr, we, Dr, v, v), v = a[m + 12 >> 2], uo = v, Rr = v >> 31, v = a[o + 4 >> 2], dr = v, v = v >> 31, Ho = Be + 384 | 0, Gr = a[m + 8 >> 2], Fr = a[o >> 2], fr = v, Lr(Ho, Gr, uo, Rr, Rr, Fr, dr, v, v), v = a[m + 20 >> 2], $r = v, v = v >> 31, qi = Be + 368 | 0, yo = a[m + 16 >> 2], zi = v, Lr(qi, yo, $r, v, v, we, Dr, he, he), Oo = a[m + 24 >> 2], m = a[m + 28 >> 2], ni = m, m = m >> 31, Io = Be + 400 | 0, Sn = m, Lr(Io, Oo, ni, m, m, Fr, dr, fr, fr), Ao = a[o + 32 >> 2], m = a[o + 36 >> 2], ps = m, m = m >> 31, fr = m, he = m & Gr, po = a[B + 32 >> 2], m = a[B + 36 >> 2], _o = m, m = m >> 31, v = he, Dr = m, he = m & Kn, m = v + he | 0, v = (Dr & Xn) + (fr & uo) | 0, he = m >>> 0 < he >>> 0 ? v + 1 | 0 : v, v = a[d + 40 >> 2], Me = v, Oi = a[Be + 388 >> 2], v = Oi + a[Be + 356 >> 2] | 0, un = a[d + 44 >> 2], $i = a[Be + 384 >> 2], we = a[Be + 352 >> 2], dr = $i + we | 0, we = we >>> 0 > dr >>> 0 ? v + 1 | 0 : v, In = oi(Me, un, dr, we), Fr = In + m | 0, v = he + Fe | 0, Vn = m - Fr | 0, m = he - (((Fr >>> 0 < In >>> 0 ? v + 1 | 0 : v) & 1073741823) + (m >>> 0 < Fr >>> 0) | 0) | 0, In = m, Qe = m >> 31, m = a[d + 4 >> 2], mi = m, m = m >> 31, Go = Be + 320 | 0, Si = a[d >> 2], Fr = m, Lr(Go, Vn, In, Qe, Qe, Si, mi, m, m), he = Dr & yo, m = he + (fr & Oo) | 0, v = (fr & ni) + (Dr & $r) | 0, he = m >>> 0 < he >>> 0 ? v + 1 | 0 : v, Ti = a[Be + 404 >> 2], v = Ti + a[Be + 372 >> 2] | 0, ns = a[Be + 400 >> 2], fr = a[Be + 368 >> 2], Dr = ns + fr | 0, fr = fr >>> 0 > Dr >>> 0 ? v + 1 | 0 : v, un = oi(Dr, fr, Me, un), Me = un + m | 0, v = he + Fe | 0, xo = m - Me | 0, m = he - (((Me >>> 0 < un >>> 0 ? v + 1 | 0 : v) & 1073741823) + (m >>> 0 < Me >>> 0) | 0) | 0, un = m, m = m >> 31, ds = Be + 336 | 0, Ts = m, Lr(ds, xo, un, m, m, Si, mi, Fr, Fr), m = a[B + 12 >> 2], Me = m, m = m >> 31, Uo = Be + 416 | 0, Fr = a[B + 8 >> 2], he = m, Lr(Uo, Kn, Xn, wr, wr, Fr, Me, m, m), m = a[o + 12 >> 2], mi = m, m = m >> 31, v = m, ts = Be + 448 | 0, Si = a[o + 8 >> 2], Lr(ts, Gr, uo, Rr, Rr, Si, mi, v, v), Lo = Be + 432 | 0, Lr(Lo, yo, $r, zi, zi, Fr, Me, he, he), Wo = Be + 464 | 0, Lr(Wo, Oo, ni, Sn, Sn, Si, mi, v, v), m = a[Be + 336 >> 2], Me = m, Fr = a[Be + 340 >> 2], v = Fr + fr | 0, m = m + Dr | 0, v = m >>> 0 < Dr >>> 0 ? v + 1 | 0 : v, he = m, m = v, Fr = (Fr | 0) == (v | 0) & he >>> 0 < Me >>> 0 | v >>> 0 < Fr >>> 0, v = ds + 8 | 0, Me = a[v >> 2], Si = a[v + 4 >> 2], fr = (fr | 0) == (Ti | 0) & Dr >>> 0 < ns >>> 0 | fr >>> 0 < Ti >>> 0, v = qi + 8 | 0, Dr = a[v >> 2], mi = Io + 8 | 0, he = Dr + a[mi >> 2] | 0, v = a[mi + 4 >> 2] + a[v + 4 >> 2] | 0, v = he >>> 0 < Dr >>> 0 ? v + 1 | 0 : v, Dr = he, he = he + fr | 0, v = (Dr >>> 0 > he >>> 0 ? v + 1 | 0 : v) + Si | 0, fr = he, he = he + Me | 0, v = fr >>> 0 > he >>> 0 ? v + 1 | 0 : v, fr = he + Fr | 0, he = fr >>> 0 < he >>> 0 ? v + 1 | 0 : v, Dr = he << 2 | fr >>> 30, Fr = fr << 2 | m >>> 30, mi = a[Be + 464 >> 2], m = a[Be + 432 >> 2], fr = mi + m | 0, Me = a[Be + 468 >> 2], v = Me + a[Be + 436 >> 2] | 0, m = m >>> 0 > fr >>> 0 ? v + 1 | 0 : v, v = m + Dr | 0, Dr = fr + Fr | 0, Fr = Dr >>> 0 < fr >>> 0 ? v + 1 | 0 : v, Si = (m | 0) == (Fr | 0) & fr >>> 0 > Dr >>> 0 | m >>> 0 > Fr >>> 0, fr = (m | 0) == (Me | 0) & fr >>> 0 < mi >>> 0 | m >>> 0 < Me >>> 0, v = Lo + 8 | 0, Me = a[v >> 2], mi = Wo + 8 | 0, m = Me + a[mi >> 2] | 0, v = a[mi + 4 >> 2] + a[v + 4 >> 2] | 0, v = m >>> 0 < Me >>> 0 ? v + 1 | 0 : v, Me = m, m = m + fr | 0, v = (he >> 31) + (Me >>> 0 > m >>> 0 ? v + 1 | 0 : v) | 0, he = he >> 30, m = m + he | 0, v = he >>> 0 > m >>> 0 ? v + 1 | 0 : v, fr = m + Si | 0, m = fr >>> 0 < m >>> 0 ? v + 1 | 0 : v, he = a[Be + 320 >> 2], mi = he, Si = a[Be + 324 >> 2], v = Si + we | 0, he = he + dr | 0, v = he >>> 0 < dr >>> 0 ? v + 1 | 0 : v, Me = he, he = v, Me = (Si | 0) == (v | 0) & Me >>> 0 < mi >>> 0 | v >>> 0 < Si >>> 0, v = Go + 8 | 0, Si = a[v >> 2], mi = a[v + 4 >> 2], dr = (we | 0) == (Oi | 0) & dr >>> 0 < $i >>> 0 | we >>> 0 < Oi >>> 0, v = Mo + 8 | 0, Oi = a[v >> 2], Ti = Ho + 8 | 0, we = Oi + a[Ti >> 2] | 0, v = a[Ti + 4 >> 2] + a[v + 4 >> 2] | 0, v = we >>> 0 < Oi >>> 0 ? v + 1 | 0 : v, $i = we, we = we + dr | 0, v = ($i >>> 0 > we >>> 0 ? v + 1 | 0 : v) + mi | 0, dr = we, we = we + Si | 0, v = dr >>> 0 > we >>> 0 ? v + 1 | 0 : v, dr = we + Me | 0, we = dr >>> 0 < we >>> 0 ? v + 1 | 0 : v, Me = we << 2 | dr >>> 30, dr = dr << 2 | he >>> 30, mi = a[Be + 448 >> 2], Oi = a[Be + 416 >> 2], he = mi + Oi | 0, Si = a[Be + 452 >> 2], v = Si + a[Be + 420 >> 2] | 0, v = he >>> 0 < Oi >>> 0 ? v + 1 | 0 : v, Oi = he, he = v, v = v + Me | 0, Me = dr + Oi | 0, dr = Me >>> 0 < Oi >>> 0 ? v + 1 | 0 : v, Ti = (he | 0) == (dr | 0) & Me >>> 0 < Oi >>> 0 | he >>> 0 > dr >>> 0, Oi = (he | 0) == (Si | 0) & mi >>> 0 > Oi >>> 0 | he >>> 0 < Si >>> 0, v = Uo + 8 | 0, Si = a[v >> 2], mi = ts + 8 | 0, he = Si + a[mi >> 2] | 0, v = a[mi + 4 >> 2] + a[v + 4 >> 2] | 0, v = he >>> 0 < Si >>> 0 ? v + 1 | 0 : v, mi = he, he = he + Oi | 0, v = (we >> 31) + (mi >>> 0 > he >>> 0 ? v + 1 | 0 : v) | 0, we = we >> 30, he = he + we | 0, v = we >>> 0 > he >>> 0 ? v + 1 | 0 : v, we = he + Ti | 0, he = we >>> 0 < he >>> 0 ? v + 1 | 0 : v, Oi = a[o + 24 >> 2], Si = a[o + 28 >> 2], mi = a[o + 16 >> 2], Ti = a[o + 20 >> 2], Mo = a[B + 24 >> 2], Ho = a[B + 28 >> 2], qi = a[B + 16 >> 2], Io = a[B + 20 >> 2], v = a[d + 8 >> 2], $i = a[d + 12 >> 2], v | $i && (ds = Be + 304 | 0, ns = v, v = $i >> 31, Lr(ds, Vn, In, Qe, Qe, ns, $i, v, v), Go = Be + 288 | 0, Lr(Go, xo, un, Ts, Ts, ns, $i, v, v), Qe = Fr, $i = Dr, Fr = a[Be + 288 >> 2], Dr = Dr + Fr | 0, v = Qe + a[Be + 292 >> 2] | 0, Fr = Dr >>> 0 < Fr >>> 0 ? v + 1 | 0 : v, Qe = (Qe | 0) == (Fr | 0) & Dr >>> 0 < $i >>> 0 | Qe >>> 0 > Fr >>> 0, v = Go + 8 | 0, $i = a[v >> 2], fr = $i + fr | 0, v = m + a[v + 4 >> 2] | 0, v = fr >>> 0 < $i >>> 0 ? v + 1 | 0 : v, m = fr, fr = fr + Qe | 0, m = m >>> 0 > fr >>> 0 ? v + 1 | 0 : v, Qe = dr, $i = Me, dr = a[Be + 304 >> 2], Me = Me + dr | 0, v = Qe + a[Be + 308 >> 2] | 0, dr = Me >>> 0 < dr >>> 0 ? v + 1 | 0 : v, Qe = (Qe | 0) == (dr | 0) & Me >>> 0 < $i >>> 0 | dr >>> 0 < Qe >>> 0, v = ds + 8 | 0, $i = a[v >> 2], we = $i + we | 0, v = he + a[v + 4 >> 2] | 0, v = we >>> 0 < $i >>> 0 ? v + 1 | 0 : v, he = we, we = we + Qe | 0, he = he >>> 0 > we >>> 0 ? v + 1 | 0 : v), a[B >> 2] = Me, a[B + 4 >> 2] = dr & 1073741823, a[o >> 2] = Dr, a[o + 4 >> 2] = Fr & 1073741823, v = Io >> 31, Me = v, $i = Be + 272 | 0, Qe = Kn, Lr($i, Qe, Xn, wr, wr, qi, Io, v, v), Ts = Be + 240 | 0, Kn = Gr, wr = Rr, Gr = Ti, v = Gr >> 31, Lr(Ts, Kn, uo, wr, wr, mi, Gr, v, v), Rr = Be + 256 | 0, Lr(Rr, yo, $r, zi, zi, qi, Io, Me, Me), Gr = Be + 224 | 0, Lr(Gr, Oo, ni, Sn, Sn, mi, Ti, v, v), zi = a[Be + 224 >> 2], Me = a[Be + 256 >> 2], Dr = zi + Me | 0, wr = a[Be + 228 >> 2], v = wr + a[Be + 260 >> 2] | 0, Me = Me >>> 0 > Dr >>> 0 ? v + 1 | 0 : v, zi = (wr | 0) == (Me | 0) & Dr >>> 0 < zi >>> 0 | Me >>> 0 < wr >>> 0, v = Rr + 8 | 0, Rr = a[v >> 2], Gr = Gr + 8 | 0, wr = Rr + a[Gr >> 2] | 0, v = a[Gr + 4 >> 2] + a[v + 4 >> 2] | 0, v = wr >>> 0 < Rr >>> 0 ? v + 1 | 0 : v, Rr = wr, wr = wr + zi | 0, v = (m >> 31) + (Rr >>> 0 > wr >>> 0 ? v + 1 | 0 : v) | 0, Gr = m >> 30, wr = wr + Gr | 0, v = Gr >>> 0 > wr >>> 0 ? v + 1 | 0 : v, Rr = wr, wr = v, v = m << 2 | fr >>> 30, m = fr << 2 | Fr >>> 30, fr = m + Dr | 0, v = v + Me | 0, m = m >>> 0 > fr >>> 0 ? v + 1 | 0 : v, Fr = (Me | 0) == (m | 0) & fr >>> 0 < Dr >>> 0 | m >>> 0 < Me >>> 0, Dr = Fr + Rr | 0, v = wr, Fr = Dr >>> 0 < Fr >>> 0 ? v + 1 | 0 : v, Gr = a[Be + 240 >> 2], wr = a[Be + 272 >> 2], Me = Gr + wr | 0, Rr = a[Be + 244 >> 2], v = Rr + a[Be + 276 >> 2] | 0, wr = Me >>> 0 < wr >>> 0 ? v + 1 | 0 : v, Gr = (Rr | 0) == (wr | 0) & Me >>> 0 < Gr >>> 0 | wr >>> 0 < Rr >>> 0, v = $i + 8 | 0, zi = a[v >> 2], Sn = Ts + 8 | 0, Rr = zi + a[Sn >> 2] | 0, v = a[Sn + 4 >> 2] + a[v + 4 >> 2] | 0, v = Rr >>> 0 < zi >>> 0 ? v + 1 | 0 : v, mi = Rr, Rr = Rr + Gr | 0, v = (he >> 31) + (mi >>> 0 > Rr >>> 0 ? v + 1 | 0 : v) | 0, zi = he >> 30, Rr = Rr + zi | 0, v = zi >>> 0 > Rr >>> 0 ? v + 1 | 0 : v, Gr = Rr, Rr = v, v = he << 2 | we >>> 30, he = we << 2 | dr >>> 30, we = he + Me | 0, v = v + wr | 0, he = he >>> 0 > we >>> 0 ? v + 1 | 0 : v, Me = (wr | 0) == (he | 0) & we >>> 0 < Me >>> 0 | he >>> 0 < wr >>> 0, dr = Me + Gr | 0, v = Rr, Me = Me >>> 0 > dr >>> 0 ? v + 1 | 0 : v, Rr = a[d + 16 >> 2], Gr = a[d + 20 >> 2], Rr | Gr && (v = Gr >> 31, zi = Be + 208 | 0, wr = v, v = In >> 31, Lr(zi, Rr, Gr, wr, wr, Vn, In, v, v), Sn = Be + 192 | 0, v = un >> 31, Lr(Sn, Rr, Gr, wr, wr, xo, un, v, v), wr = a[Be + 196 >> 2], v = wr + m | 0, m = fr, Rr = a[Be + 192 >> 2], fr = Rr + fr | 0, m = m >>> 0 > fr >>> 0 ? v + 1 | 0 : v, Rr = (wr | 0) == (m | 0) & fr >>> 0 < Rr >>> 0 | m >>> 0 < wr >>> 0, v = Sn + 8 | 0, wr = a[v >> 2] + Dr | 0, v = a[v + 4 >> 2] + Fr | 0, v = Dr >>> 0 > wr >>> 0 ? v + 1 | 0 : v, Dr = wr + Rr | 0, Fr = Dr >>> 0 < wr >>> 0 ? v + 1 | 0 : v, wr = a[Be + 212 >> 2], v = wr + he | 0, he = we, Rr = a[Be + 208 >> 2], we = Rr + we | 0, he = he >>> 0 > we >>> 0 ? v + 1 | 0 : v, Rr = (wr | 0) == (he | 0) & we >>> 0 < Rr >>> 0 | he >>> 0 < wr >>> 0, v = zi + 8 | 0, wr = a[v >> 2] + dr | 0, v = a[v + 4 >> 2] + Me | 0, v = dr >>> 0 > wr >>> 0 ? v + 1 | 0 : v, dr = wr + Rr | 0, Me = dr >>> 0 < wr >>> 0 ? v + 1 | 0 : v), a[B + 8 >> 2] = we, a[B + 12 >> 2] = he & 1073741823, a[o + 8 >> 2] = fr, a[o + 12 >> 2] = m & 1073741823, v = Xn >> 31, wr = v, v = Ho >> 31, qi = Be + 176 | 0, Gr = Qe, fr = v, Lr(qi, Qe, Xn, wr, wr, Mo, Ho, v, v), v = uo >> 31, Rr = v, v = Si >> 31, Io = Be + 144 | 0, we = v, Lr(Io, Kn, uo, Rr, Rr, Oi, Si, v, v), v = $r, zi = v, v = v >> 31, $i = Be + 160 | 0, Sn = v, Lr($i, yo, $r, v, v, Mo, Ho, fr, fr), v = ni, mi = v, v = v >> 31, Mo = Be + 128 | 0, Ti = v, Lr(Mo, Oo, ni, v, v, Oi, Si, we, we), ni = a[Be + 128 >> 2], fr = a[Be + 160 >> 2], we = ni + fr | 0, $r = a[Be + 132 >> 2], v = $r + a[Be + 164 >> 2] | 0, fr = we >>> 0 < fr >>> 0 ? v + 1 | 0 : v, Qe = Fr << 2 | Dr >>> 30, m = Dr << 2 | m >>> 30, Dr = m + we | 0, v = fr + Qe | 0, m = m >>> 0 > Dr >>> 0 ? v + 1 | 0 : v, v = fr, fr = Dr, Qe = (m | 0) == (v | 0) & we >>> 0 > fr >>> 0 | m >>> 0 < v >>> 0, Dr = (v | 0) == ($r | 0) & we >>> 0 < ni >>> 0 | v >>> 0 < $r >>> 0, v = $i + 8 | 0, $r = a[v >> 2], ni = Mo + 8 | 0, we = $r + a[ni >> 2] | 0, v = a[ni + 4 >> 2] + a[v + 4 >> 2] | 0, v = we >>> 0 < $r >>> 0 ? v + 1 | 0 : v, ni = we, we = we + Dr | 0, v = (Fr >> 31) + (ni >>> 0 > we >>> 0 ? v + 1 | 0 : v) | 0, Fr = Fr >> 30, we = we + Fr | 0, v = Fr >>> 0 > we >>> 0 ? v + 1 | 0 : v, Dr = we + Qe | 0, Fr = Dr >>> 0 < we >>> 0 ? v + 1 | 0 : v, Oi = a[Be + 144 >> 2], we = a[Be + 176 >> 2], Qe = Oi + we | 0, ni = a[Be + 148 >> 2], v = ni + a[Be + 180 >> 2] | 0, we = we >>> 0 > Qe >>> 0 ? v + 1 | 0 : v, $r = Me << 2 | dr >>> 30, he = dr << 2 | he >>> 30, dr = he + Qe | 0, v = we + $r | 0, he = he >>> 0 > dr >>> 0 ? v + 1 | 0 : v, v = we, we = dr, $r = (he | 0) == (v | 0) & Qe >>> 0 > we >>> 0 | v >>> 0 > he >>> 0, Qe = (v | 0) == (ni | 0) & Qe >>> 0 < Oi >>> 0 | v >>> 0 < ni >>> 0, v = qi + 8 | 0, ni = a[v >> 2], Oi = Io + 8 | 0, dr = ni + a[Oi >> 2] | 0, v = a[Oi + 4 >> 2] + a[v + 4 >> 2] | 0, v = dr >>> 0 < ni >>> 0 ? v + 1 | 0 : v, ni = dr, dr = dr + Qe | 0, v = (Me >> 31) + (ni >>> 0 > dr >>> 0 ? v + 1 | 0 : v) | 0, Me = Me >> 30, dr = Me + dr | 0, v = Me >>> 0 > dr >>> 0 ? v + 1 | 0 : v, Me = dr, dr = dr + $r | 0, Me = Me >>> 0 > dr >>> 0 ? v + 1 | 0 : v, $r = a[d + 24 >> 2], ni = a[d + 28 >> 2], $r | ni && (v = ni >> 31, Oi = Be + 112 | 0, Qe = v, v = In >> 31, Lr(Oi, $r, ni, Qe, Qe, Vn, In, v, v), Si = Be + 96 | 0, v = un >> 31, Lr(Si, $r, ni, Qe, Qe, xo, un, v, v), Qe = a[Be + 100 >> 2], v = Qe + m | 0, m = fr, $r = a[Be + 96 >> 2], fr = $r + fr | 0, m = m >>> 0 > fr >>> 0 ? v + 1 | 0 : v, $r = (Qe | 0) == (m | 0) & fr >>> 0 < $r >>> 0 | m >>> 0 < Qe >>> 0, v = Si + 8 | 0, Qe = a[v >> 2] + Dr | 0, v = a[v + 4 >> 2] + Fr | 0, v = Dr >>> 0 > Qe >>> 0 ? v + 1 | 0 : v, Dr = Qe + $r | 0, Fr = Dr >>> 0 < Qe >>> 0 ? v + 1 | 0 : v, Qe = a[Be + 116 >> 2], v = Qe + he | 0, he = we, $r = a[Be + 112 >> 2], we = $r + we | 0, he = he >>> 0 > we >>> 0 ? v + 1 | 0 : v, $r = (Qe | 0) == (he | 0) & we >>> 0 < $r >>> 0 | he >>> 0 < Qe >>> 0, v = Oi + 8 | 0, Qe = a[v >> 2] + dr | 0, v = a[v + 4 >> 2] + Me | 0, v = dr >>> 0 > Qe >>> 0 ? v + 1 | 0 : v, dr = Qe + $r | 0, Me = dr >>> 0 < Qe >>> 0 ? v + 1 | 0 : v), a[B + 16 >> 2] = we, a[B + 20 >> 2] = he & 1073741823, a[o + 16 >> 2] = fr, a[o + 20 >> 2] = m & 1073741823, v = _o >> 31, we = v, $r = Be + 80 | 0, ni = _o, Lr($r, Gr, Xn, wr, wr, po, ni, v, v), Xn = Be + 48 | 0, wr = Rr, Gr = ps, v = Gr >> 31, Lr(Xn, Kn, uo, wr, wr, Ao, Gr, v, v), Kn = Be - -64 | 0, Lr(Kn, yo, zi, Sn, Sn, po, ni, we, we), uo = Be + 32 | 0, Lr(uo, Oo, mi, Ti, Ti, Ao, Gr, v, v), fr = a[d + 32 >> 2], d = a[d + 36 >> 2], we = d, d = we >> 31, v = In >> 31, Lr(Be, fr, we, d, d, Vn, In, v, v), Gr = Be + 16 | 0, v = un >> 31, Lr(Gr, fr, we, d, d, xo, un, v, v), fr = B, ni = a[Be + 48 >> 2], B = a[Be + 80 >> 2], d = ni + B | 0, Rr = a[Be + 52 >> 2], v = Rr + a[Be + 84 >> 2] | 0, B = B >>> 0 > d >>> 0 ? v + 1 | 0 : v, In = d, he = dr << 2 | he >>> 30, d = d + he | 0, v = B + (Me << 2 | dr >>> 30) | 0, we = d >>> 0 < he >>> 0 ? v + 1 | 0 : v, v = we + a[Be + 4 >> 2] | 0, Vn = d, d = a[Be >> 2], he = Vn + d | 0, wr = he, a[fr + 24 >> 2] = he, d = d >>> 0 > he >>> 0 ? v + 1 | 0 : v, a[fr + 28 >> 2] = d & 1073741823, he = o, o = Dr << 2 | m >>> 30, Dr = Fr << 2 | Dr >>> 30, yo = a[Be + 32 >> 2], m = a[Be + 64 >> 2], dr = yo + m | 0, Qe = a[Be + 36 >> 2], v = Qe + a[Be + 68 >> 2] | 0, m = m >>> 0 > dr >>> 0 ? v + 1 | 0 : v, v = m + Dr | 0, o = o + dr | 0, Dr = o >>> 0 < dr >>> 0 ? v + 1 | 0 : v, v = Dr + a[Be + 20 >> 2] | 0, un = o, o = a[Be + 16 >> 2], xo = un + o | 0, a[he + 24 >> 2] = xo, o = o >>> 0 > xo >>> 0 ? v + 1 | 0 : v, a[he + 28 >> 2] = o & 1073741823, wr = (d | 0) == (we | 0) & wr >>> 0 < Vn >>> 0 | d >>> 0 < we >>> 0, v = Be + 8 | 0, Oo = a[v >> 2], zi = a[v + 4 >> 2], Vn = (B | 0) == (we | 0) & In >>> 0 > Vn >>> 0 | B >>> 0 > we >>> 0, we = (B | 0) == (Rr | 0) & ni >>> 0 > In >>> 0 | B >>> 0 < Rr >>> 0, v = $r + 8 | 0, In = a[v >> 2], Rr = Xn + 8 | 0, B = In + a[Rr >> 2] | 0, v = a[Rr + 4 >> 2] + a[v + 4 >> 2] | 0, v = B >>> 0 < In >>> 0 ? v + 1 | 0 : v, Rr = B, B = B + we | 0, v = (Me >> 31) + (Rr >>> 0 > B >>> 0 ? v + 1 | 0 : v) | 0, Me = Me >> 30, B = B + Me | 0, v = Me >>> 0 > B >>> 0 ? v + 1 | 0 : v, we = B, B = B + Vn | 0, v = (we >>> 0 > B >>> 0 ? v + 1 | 0 : v) + zi | 0, we = B, B = B + Oo | 0, v = we >>> 0 > B >>> 0 ? v + 1 | 0 : v, we = B, B = B + wr | 0, we = (we >>> 0 > B >>> 0 ? v + 1 | 0 : v) << 2 | B >>> 30, a[fr + 32 >> 2] = B << 2 | d >>> 30, a[fr + 36 >> 2] = we, fr = (o | 0) == (Dr | 0) & un >>> 0 > xo >>> 0 | o >>> 0 < Dr >>> 0, B = Gr + 8 | 0, we = a[B >> 2], Me = a[B + 4 >> 2], Dr = (m | 0) == (Dr | 0) & dr >>> 0 > un >>> 0 | m >>> 0 > Dr >>> 0, m = (m | 0) == (Qe | 0) & dr >>> 0 < yo >>> 0 | m >>> 0 < Qe >>> 0, d = Kn + 8 | 0, dr = a[d >> 2], v = uo + 8 | 0, B = dr + a[v >> 2] | 0, v = a[v + 4 >> 2] + a[d + 4 >> 2] | 0, v = B >>> 0 < dr >>> 0 ? v + 1 | 0 : v, d = B, B = B + m | 0, v = (Fr >> 31) + (d >>> 0 > B >>> 0 ? v + 1 | 0 : v) | 0, d = Fr >> 30, B = B + d | 0, v = d >>> 0 > B >>> 0 ? v + 1 | 0 : v, m = B, B = B + Dr | 0, v = (m >>> 0 > B >>> 0 ? v + 1 | 0 : v) + Me | 0, m = B, B = B + we | 0, v = m >>> 0 > B >>> 0 ? v + 1 | 0 : v, m = B, B = B + fr | 0, m = (m >>> 0 > B >>> 0 ? v + 1 | 0 : v) << 2 | B >>> 30, a[he + 32 >> 2] = B << 2 | o >>> 30, a[he + 36 >> 2] = m, be = Be + 480 | 0;
  }
  function xi(B, o) {
    var m = 0, d = 0, v = 0;
    m = o;
    e: {
      if (o >>> 0 <= 15) {
        o = B;
        break e;
      }
      if (d = 0 - B & 3, v = d + B | 0, d)
        for (o = B; u[o | 0] = 0, o = o + 1 | 0, v >>> 0 > o >>> 0; )
          ;
      if (m = m - d | 0, d = m & -4, o = d + v | 0, (d | 0) > 0)
        for (; a[v >> 2] = 0, v = v + 4 | 0, v >>> 0 < o >>> 0; )
          ;
      m = m & 3;
    }
    if (m)
      for (m = o + m | 0; u[o | 0] = 0, o = o + 1 | 0, m >>> 0 > o >>> 0; )
        ;
    return B;
  }
  function Lr(B, o, m, d, v, he, we, Be, Me) {
    var fr = 0, wr = 0, dr = 0, Dr = 0, Rr = 0, Qe = 0, Fr = 0;
    fr = oi(he, 0, o, 0), Dr = B, wr = Fe, Fr = o, o = oi(o, 0, we, 0), dr = Fe, Rr = oi(he, 0, m, 0), Qe = Fe, B = dr + Qe | 0, dr = o + Rr | 0, o = dr >>> 0 < Rr >>> 0 ? B + 1 | 0 : B, B = wr + dr | 0, B = 0 > fr >>> 0 ? B + 1 | 0 : B, a[Dr >> 2] = fr, a[Dr + 4 >> 2] = B, wr = (B | 0) == (wr | 0) & fr >>> 0 < fr >>> 0 | B >>> 0 < wr >>> 0, B = (o | 0) == (Qe | 0) & dr >>> 0 < Rr >>> 0 | o >>> 0 < Qe >>> 0, fr = o, o = o + oi(m, 0, we, 0) | 0, B = Fe + B | 0, B = o >>> 0 < fr >>> 0 ? B + 1 | 0 : B, fr = o, o = o + wr | 0, fr = fr >>> 0 > o >>> 0 ? B + 1 | 0 : B, B = oi(Fr, m, Be, Me), Be = Fe, d = oi(d, v, he, we), m = d + B | 0, B = Be + Fe | 0, B = (m >>> 0 < d >>> 0 ? B + 1 | 0 : B) + fr | 0, o = o + m | 0, B = o >>> 0 < m >>> 0 ? B + 1 | 0 : B, a[Dr + 8 >> 2] = o, a[Dr + 12 >> 2] = B;
  }
  function dn(B, o, m) {
    var d = 0, v = 0, he = 0, we = 0, Be = 0, Me = 0, fr = 0, wr = 0;
    we = m;
    e: {
      if (m >>> 0 <= 15) {
        m = B;
        break e;
      }
      if (he = 0 - B & 3, v = he + B | 0, he)
        for (m = B, d = o; u[m | 0] = A[d | 0], d = d + 1 | 0, m = m + 1 | 0, v >>> 0 > m >>> 0; )
          ;
      we = we - he | 0, Be = we & -4, m = Be + v | 0, he = o + he | 0, d = he & 3;
      t: {
        if (d) {
          if ((Be | 0) <= 0)
            break t;
          for (Me = he & -4, o = Me + 4 | 0, fr = d << 3, wr = 0 - fr & 24, d = a[Me >> 2]; Me = d >>> fr | 0, d = a[o >> 2], a[v >> 2] = Me | d << wr, o = o + 4 | 0, v = v + 4 | 0, v >>> 0 < m >>> 0; )
            ;
          break t;
        }
        if ((Be | 0) <= 0)
          break t;
        for (o = he; a[v >> 2] = a[o >> 2], o = o + 4 | 0, v = v + 4 | 0, v >>> 0 < m >>> 0; )
          ;
      }
      we = we & 3, o = he + Be | 0;
    }
    if (we)
      for (d = m + we | 0; u[m | 0] = A[o | 0], o = o + 1 | 0, m = m + 1 | 0, d >>> 0 > m >>> 0; )
        ;
    return B;
  }
  function xn(B, o) {
    var m = 0, d = 0;
    return B | o ? (m = o - 1 | 0, d = B - 1 | 0, m = (d | 0) != -1 ? m + 1 | 0 : m, d = B ^ d, B = le(o ^ m), (B | 0) == 32 && (B = le(d) + 32 | 0), Fe = 0 - (B >>> 0 > 63) | 0, 63 - B | 0) : (Fe = 0, 64);
  }
  function oi(B, o, m, d) {
    var v = 0, he = 0, we = 0, Be = 0, Me = 0, fr = 0;
    return v = m & 65535, he = B & 65535, we = F(v, he), Be = m >>> 16 | 0, fr = F(he, Be), Me = B >>> 16 | 0, he = F(v, Me) + (we >>> 16 | 0) | 0, v = fr + (he & 65535) | 0, Fe = (F(o, m) + F(Be, Me) | 0) + F(B, d) + (he >>> 16) + (v >>> 16) | 0, we & 65535 | v << 16;
  }
  function Yr(B, o) {
    var m = 0, d = 0;
    return m = o & 31, d = (-1 >>> m & B) << m, m = B, B = 0 - o & 31, d | (m & -1 << B) >>> B;
  }
  bufferView = A, initActiveSegments();
  var ji = [null, rr, Sr, xe, Un, Gi, Er];
  function Cn() {
    return c.byteLength / 65536 | 0;
  }
  function Mn(B) {
    B = B | 0;
    var o = Cn() | 0, m = o + B | 0;
    if (o < m && m < 65536) {
      var d = new ArrayBuffer(F(m, 65536)), v = new Int8Array(d);
      v.set(u), u = new Int8Array(d), p = new Int16Array(d), a = new Int32Array(d), A = new Uint8Array(d), b = new Uint16Array(d), c = d, bufferView = A;
    }
    return o;
  }
  return {
    memory: Object.create(Object.prototype, {
      grow: {
        value: Mn
      },
      buffer: {
        get: function() {
          return c;
        }
      }
    }),
    initializeContext: _r,
    isPoint: Or,
    PUBLIC_KEY_INPUT: {
      get value() {
        return He;
      },
      set value(B) {
        He = B;
      }
    },
    pointAdd: vr,
    PUBLIC_KEY_INPUT2: {
      get value() {
        return Pe;
      },
      set value(B) {
        Pe = B;
      }
    },
    pointAddScalar: Te,
    TWEAK_INPUT: {
      get value() {
        return nr;
      },
      set value(B) {
        nr = B;
      }
    },
    xOnlyPointAddTweak: Cr,
    X_ONLY_PUBLIC_KEY_INPUT: {
      get value() {
        return ir;
      },
      set value(B) {
        ir = B;
      }
    },
    xOnlyPointAddTweakCheck: Hr,
    X_ONLY_PUBLIC_KEY_INPUT2: {
      get value() {
        return or;
      },
      set value(B) {
        or = B;
      }
    },
    pointCompress: si,
    pointFromScalar: ui,
    PRIVATE_INPUT: {
      get value() {
        return lr;
      },
      set value(B) {
        lr = B;
      }
    },
    xOnlyPointFromScalar: Li,
    xOnlyPointFromPoint: Qi,
    pointMultiply: wi,
    privateAdd: Ji,
    privateSub: mn,
    privateNegate: pi,
    sign: ei,
    HASH_INPUT: {
      get value() {
        return Ir;
      },
      set value(B) {
        Ir = B;
      }
    },
    EXTRA_DATA_INPUT: {
      get value() {
        return xr;
      },
      set value(B) {
        xr = B;
      }
    },
    SIGNATURE_INPUT: {
      get value() {
        return kr;
      },
      set value(B) {
        kr = B;
      }
    },
    signRecoverable: Vr,
    signSchnorr: qr,
    verify: Zi,
    recover: Wr,
    verifySchnorr: ri,
    rustsecp256k1_v0_8_1_default_error_callback_fn: Er,
    rustsecp256k1_v0_8_1_default_illegal_callback_fn: Er,
    __data_end: {
      get value() {
        return Ce;
      },
      set value(B) {
        Ce = B;
      }
    },
    __heap_base: {
      get value() {
        return tr;
      },
      set value(B) {
        tr = B;
      }
    }
  };
}
var retasmFunc = asmFunc({
  "./rand.js": $_rand_js,
  "./validate_error.js": $_validate_error_js
}), memory = retasmFunc.memory, initializeContext = retasmFunc.initializeContext, isPoint$1 = retasmFunc.isPoint, PUBLIC_KEY_INPUT$1 = retasmFunc.PUBLIC_KEY_INPUT, pointAdd$1 = retasmFunc.pointAdd, PUBLIC_KEY_INPUT2$1 = retasmFunc.PUBLIC_KEY_INPUT2, pointAddScalar$1 = retasmFunc.pointAddScalar, TWEAK_INPUT$1 = retasmFunc.TWEAK_INPUT, xOnlyPointAddTweak$1 = retasmFunc.xOnlyPointAddTweak, X_ONLY_PUBLIC_KEY_INPUT$1 = retasmFunc.X_ONLY_PUBLIC_KEY_INPUT, xOnlyPointAddTweakCheck$1 = retasmFunc.xOnlyPointAddTweakCheck, X_ONLY_PUBLIC_KEY_INPUT2$1 = retasmFunc.X_ONLY_PUBLIC_KEY_INPUT2, pointCompress$1 = retasmFunc.pointCompress, pointFromScalar$1 = retasmFunc.pointFromScalar, PRIVATE_INPUT = retasmFunc.PRIVATE_INPUT, xOnlyPointFromScalar$1 = retasmFunc.xOnlyPointFromScalar, xOnlyPointFromPoint$1 = retasmFunc.xOnlyPointFromPoint, pointMultiply$1 = retasmFunc.pointMultiply, privateAdd$1 = retasmFunc.privateAdd, privateSub$1 = retasmFunc.privateSub, privateNegate$1 = retasmFunc.privateNegate, sign$2 = retasmFunc.sign, HASH_INPUT$1 = retasmFunc.HASH_INPUT, EXTRA_DATA_INPUT$1 = retasmFunc.EXTRA_DATA_INPUT, SIGNATURE_INPUT$1 = retasmFunc.SIGNATURE_INPUT, signRecoverable$1 = retasmFunc.signRecoverable, signSchnorr$2 = retasmFunc.signSchnorr, verify$2 = retasmFunc.verify, recover$1 = retasmFunc.recover, verifySchnorr$1 = retasmFunc.verifySchnorr, rustsecp256k1_v0_8_1_default_error_callback_fn = retasmFunc.rustsecp256k1_v0_8_1_default_error_callback_fn, rustsecp256k1_v0_8_1_default_illegal_callback_fn = retasmFunc.rustsecp256k1_v0_8_1_default_illegal_callback_fn, __data_end = retasmFunc.__data_end, __heap_base = retasmFunc.__heap_base;
const wasm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  EXTRA_DATA_INPUT: EXTRA_DATA_INPUT$1,
  HASH_INPUT: HASH_INPUT$1,
  PRIVATE_INPUT,
  PUBLIC_KEY_INPUT: PUBLIC_KEY_INPUT$1,
  PUBLIC_KEY_INPUT2: PUBLIC_KEY_INPUT2$1,
  SIGNATURE_INPUT: SIGNATURE_INPUT$1,
  TWEAK_INPUT: TWEAK_INPUT$1,
  X_ONLY_PUBLIC_KEY_INPUT: X_ONLY_PUBLIC_KEY_INPUT$1,
  X_ONLY_PUBLIC_KEY_INPUT2: X_ONLY_PUBLIC_KEY_INPUT2$1,
  __data_end,
  __heap_base,
  initializeContext,
  isPoint: isPoint$1,
  memory,
  pointAdd: pointAdd$1,
  pointAddScalar: pointAddScalar$1,
  pointCompress: pointCompress$1,
  pointFromScalar: pointFromScalar$1,
  pointMultiply: pointMultiply$1,
  privateAdd: privateAdd$1,
  privateNegate: privateNegate$1,
  privateSub: privateSub$1,
  recover: recover$1,
  rustsecp256k1_v0_8_1_default_error_callback_fn,
  rustsecp256k1_v0_8_1_default_illegal_callback_fn,
  sign: sign$2,
  signRecoverable: signRecoverable$1,
  signSchnorr: signSchnorr$2,
  verify: verify$2,
  verifySchnorr: verifySchnorr$1,
  xOnlyPointAddTweak: xOnlyPointAddTweak$1,
  xOnlyPointAddTweakCheck: xOnlyPointAddTweakCheck$1,
  xOnlyPointFromPoint: xOnlyPointFromPoint$1,
  xOnlyPointFromScalar: xOnlyPointFromScalar$1
}, Symbol.toStringTag, { value: "Module" })), WASM_BUFFER = new Uint8Array(wasm.memory.buffer), WASM_PRIVATE_KEY_PTR = wasm.PRIVATE_INPUT.value, WASM_PUBLIC_KEY_INPUT_PTR = wasm.PUBLIC_KEY_INPUT.value, WASM_PUBLIC_KEY_INPUT_PTR2 = wasm.PUBLIC_KEY_INPUT2.value, WASM_X_ONLY_PUBLIC_KEY_INPUT_PTR = wasm.X_ONLY_PUBLIC_KEY_INPUT.value, WASM_X_ONLY_PUBLIC_KEY_INPUT2_PTR = wasm.X_ONLY_PUBLIC_KEY_INPUT2.value, WASM_TWEAK_INPUT_PTR = wasm.TWEAK_INPUT.value, WASM_HASH_INPUT_PTR = wasm.HASH_INPUT.value, WASM_EXTRA_DATA_INPUT_PTR = wasm.EXTRA_DATA_INPUT.value, WASM_SIGNATURE_INPUT_PTR = wasm.SIGNATURE_INPUT.value, PRIVATE_KEY_INPUT = WASM_BUFFER.subarray(WASM_PRIVATE_KEY_PTR, WASM_PRIVATE_KEY_PTR + PRIVATE_KEY_SIZE), PUBLIC_KEY_INPUT = WASM_BUFFER.subarray(WASM_PUBLIC_KEY_INPUT_PTR, WASM_PUBLIC_KEY_INPUT_PTR + PUBLIC_KEY_UNCOMPRESSED_SIZE), PUBLIC_KEY_INPUT2 = WASM_BUFFER.subarray(WASM_PUBLIC_KEY_INPUT_PTR2, WASM_PUBLIC_KEY_INPUT_PTR2 + PUBLIC_KEY_UNCOMPRESSED_SIZE), X_ONLY_PUBLIC_KEY_INPUT = WASM_BUFFER.subarray(WASM_X_ONLY_PUBLIC_KEY_INPUT_PTR, WASM_X_ONLY_PUBLIC_KEY_INPUT_PTR + X_ONLY_PUBLIC_KEY_SIZE), X_ONLY_PUBLIC_KEY_INPUT2 = WASM_BUFFER.subarray(WASM_X_ONLY_PUBLIC_KEY_INPUT2_PTR, WASM_X_ONLY_PUBLIC_KEY_INPUT2_PTR + X_ONLY_PUBLIC_KEY_SIZE), TWEAK_INPUT = WASM_BUFFER.subarray(WASM_TWEAK_INPUT_PTR, WASM_TWEAK_INPUT_PTR + TWEAK_SIZE), HASH_INPUT = WASM_BUFFER.subarray(WASM_HASH_INPUT_PTR, WASM_HASH_INPUT_PTR + HASH_SIZE), EXTRA_DATA_INPUT = WASM_BUFFER.subarray(WASM_EXTRA_DATA_INPUT_PTR, WASM_EXTRA_DATA_INPUT_PTR + EXTRA_DATA_SIZE), SIGNATURE_INPUT = WASM_BUFFER.subarray(WASM_SIGNATURE_INPUT_PTR, WASM_SIGNATURE_INPUT_PTR + SIGNATURE_SIZE);
function assumeCompression(n, c) {
  return n === void 0 ? c !== void 0 ? c.length : PUBLIC_KEY_COMPRESSED_SIZE : n ? PUBLIC_KEY_COMPRESSED_SIZE : PUBLIC_KEY_UNCOMPRESSED_SIZE;
}
function _isPoint(n) {
  try {
    return PUBLIC_KEY_INPUT.set(n), wasm.isPoint(n.length) === 1;
  } finally {
    PUBLIC_KEY_INPUT.fill(0);
  }
}
function __initializeContext() {
  wasm.initializeContext();
}
function isPoint(n) {
  return isDERPoint(n) && _isPoint(n);
}
function isPointCompressed(n) {
  return isPointCompressed$1(n) && _isPoint(n);
}
function isXOnlyPoint(n) {
  return isXOnlyPoint$1(n) && _isPoint(n);
}
function isPrivate(n) {
  return isPrivate$1(n);
}
function pointAdd(n, c, u) {
  validatePoint(n), validatePoint(c);
  const p = assumeCompression(u, n);
  try {
    return PUBLIC_KEY_INPUT.set(n), PUBLIC_KEY_INPUT2.set(c), wasm.pointAdd(n.length, c.length, p) === 1 ? PUBLIC_KEY_INPUT.slice(0, p) : null;
  } finally {
    PUBLIC_KEY_INPUT.fill(0), PUBLIC_KEY_INPUT2.fill(0);
  }
}
function pointAddScalar(n, c, u) {
  validatePoint(n), validateTweak(c);
  const p = assumeCompression(u, n);
  try {
    return PUBLIC_KEY_INPUT.set(n), TWEAK_INPUT.set(c), wasm.pointAddScalar(n.length, p) === 1 ? PUBLIC_KEY_INPUT.slice(0, p) : null;
  } finally {
    PUBLIC_KEY_INPUT.fill(0), TWEAK_INPUT.fill(0);
  }
}
function pointCompress(n, c) {
  validatePoint(n);
  const u = assumeCompression(c, n);
  try {
    return PUBLIC_KEY_INPUT.set(n), wasm.pointCompress(n.length, u), PUBLIC_KEY_INPUT.slice(0, u);
  } finally {
    PUBLIC_KEY_INPUT.fill(0);
  }
}
function pointFromScalar(n, c) {
  validatePrivate(n);
  const u = assumeCompression(c);
  try {
    return PRIVATE_KEY_INPUT.set(n), wasm.pointFromScalar(u) === 1 ? PUBLIC_KEY_INPUT.slice(0, u) : null;
  } finally {
    PRIVATE_KEY_INPUT.fill(0), PUBLIC_KEY_INPUT.fill(0);
  }
}
function xOnlyPointFromScalar(n) {
  validatePrivate(n);
  try {
    return PRIVATE_KEY_INPUT.set(n), wasm.xOnlyPointFromScalar(), X_ONLY_PUBLIC_KEY_INPUT.slice(0, X_ONLY_PUBLIC_KEY_SIZE);
  } finally {
    PRIVATE_KEY_INPUT.fill(0), X_ONLY_PUBLIC_KEY_INPUT.fill(0);
  }
}
function xOnlyPointFromPoint(n) {
  validatePoint(n);
  try {
    return PUBLIC_KEY_INPUT.set(n), wasm.xOnlyPointFromPoint(n.length), X_ONLY_PUBLIC_KEY_INPUT.slice(0, X_ONLY_PUBLIC_KEY_SIZE);
  } finally {
    PUBLIC_KEY_INPUT.fill(0), X_ONLY_PUBLIC_KEY_INPUT.fill(0);
  }
}
function pointMultiply(n, c, u) {
  validatePoint(n), validateTweak(c);
  const p = assumeCompression(u, n);
  try {
    return PUBLIC_KEY_INPUT.set(n), TWEAK_INPUT.set(c), wasm.pointMultiply(n.length, p) === 1 ? PUBLIC_KEY_INPUT.slice(0, p) : null;
  } finally {
    PUBLIC_KEY_INPUT.fill(0), TWEAK_INPUT.fill(0);
  }
}
function privateAdd(n, c) {
  validatePrivate(n), validateTweak(c);
  try {
    return PRIVATE_KEY_INPUT.set(n), TWEAK_INPUT.set(c), wasm.privateAdd() === 1 ? PRIVATE_KEY_INPUT.slice(0, PRIVATE_KEY_SIZE) : null;
  } finally {
    PRIVATE_KEY_INPUT.fill(0), TWEAK_INPUT.fill(0);
  }
}
function privateSub(n, c) {
  if (validatePrivate(n), validateTweak(c), isZero(c))
    return new Uint8Array(n);
  try {
    return PRIVATE_KEY_INPUT.set(n), TWEAK_INPUT.set(c), wasm.privateSub() === 1 ? PRIVATE_KEY_INPUT.slice(0, PRIVATE_KEY_SIZE) : null;
  } finally {
    PRIVATE_KEY_INPUT.fill(0), TWEAK_INPUT.fill(0);
  }
}
function privateNegate(n) {
  validatePrivate(n);
  try {
    return PRIVATE_KEY_INPUT.set(n), wasm.privateNegate(), PRIVATE_KEY_INPUT.slice(0, PRIVATE_KEY_SIZE);
  } finally {
    PRIVATE_KEY_INPUT.fill(0);
  }
}
function xOnlyPointAddTweak(n, c) {
  validateXOnlyPoint(n), validateTweak(c);
  try {
    X_ONLY_PUBLIC_KEY_INPUT.set(n), TWEAK_INPUT.set(c);
    const u = wasm.xOnlyPointAddTweak();
    return u !== -1 ? {
      parity: u,
      xOnlyPubkey: X_ONLY_PUBLIC_KEY_INPUT.slice(0, X_ONLY_PUBLIC_KEY_SIZE)
    } : null;
  } finally {
    X_ONLY_PUBLIC_KEY_INPUT.fill(0), TWEAK_INPUT.fill(0);
  }
}
function xOnlyPointAddTweakCheck(n, c, u, p) {
  validateXOnlyPoint(n), validateXOnlyPoint(u), validateTweak(c);
  const a = p !== void 0;
  a && validateParity(p);
  try {
    if (X_ONLY_PUBLIC_KEY_INPUT.set(n), X_ONLY_PUBLIC_KEY_INPUT2.set(u), TWEAK_INPUT.set(c), a)
      return wasm.xOnlyPointAddTweakCheck(p) === 1;
    {
      wasm.xOnlyPointAddTweak();
      const A = X_ONLY_PUBLIC_KEY_INPUT.slice(0, X_ONLY_PUBLIC_KEY_SIZE);
      return compare$c(A, u) === 0;
    }
  } finally {
    X_ONLY_PUBLIC_KEY_INPUT.fill(0), X_ONLY_PUBLIC_KEY_INPUT2.fill(0), TWEAK_INPUT.fill(0);
  }
}
function sign$1(n, c, u) {
  validateHash(n), validatePrivate(c), validateExtraData(u);
  try {
    return HASH_INPUT.set(n), PRIVATE_KEY_INPUT.set(c), u !== void 0 && EXTRA_DATA_INPUT.set(u), wasm.sign(u === void 0 ? 0 : 1), SIGNATURE_INPUT.slice(0, SIGNATURE_SIZE);
  } finally {
    HASH_INPUT.fill(0), PRIVATE_KEY_INPUT.fill(0), u !== void 0 && EXTRA_DATA_INPUT.fill(0), SIGNATURE_INPUT.fill(0);
  }
}
function signRecoverable(n, c, u) {
  validateHash(n), validatePrivate(c), validateExtraData(u);
  try {
    HASH_INPUT.set(n), PRIVATE_KEY_INPUT.set(c), u !== void 0 && EXTRA_DATA_INPUT.set(u);
    const p = wasm.signRecoverable(u === void 0 ? 0 : 1);
    return {
      signature: SIGNATURE_INPUT.slice(0, SIGNATURE_SIZE),
      recoveryId: p
    };
  } finally {
    HASH_INPUT.fill(0), PRIVATE_KEY_INPUT.fill(0), u !== void 0 && EXTRA_DATA_INPUT.fill(0), SIGNATURE_INPUT.fill(0);
  }
}
function signSchnorr$1(n, c, u) {
  validateHash(n), validatePrivate(c), validateExtraData(u);
  try {
    return HASH_INPUT.set(n), PRIVATE_KEY_INPUT.set(c), u !== void 0 && EXTRA_DATA_INPUT.set(u), wasm.signSchnorr(u === void 0 ? 0 : 1), SIGNATURE_INPUT.slice(0, SIGNATURE_SIZE);
  } finally {
    HASH_INPUT.fill(0), PRIVATE_KEY_INPUT.fill(0), u !== void 0 && EXTRA_DATA_INPUT.fill(0), SIGNATURE_INPUT.fill(0);
  }
}
function verify$1(n, c, u, p = !1) {
  validateHash(n), validatePoint(c), validateSignature(u);
  try {
    return HASH_INPUT.set(n), PUBLIC_KEY_INPUT.set(c), SIGNATURE_INPUT.set(u), wasm.verify(c.length, p === !0 ? 1 : 0) === 1;
  } finally {
    HASH_INPUT.fill(0), PUBLIC_KEY_INPUT.fill(0), SIGNATURE_INPUT.fill(0);
  }
}
function recover(n, c, u, p = !1) {
  validateHash(n), validateSignature(c), validateSignatureNonzeroRS(c), u & 2 && validateSigrPMinusN(c), validateSignatureCustom(() => isXOnlyPoint(c.subarray(0, 32)));
  const a = assumeCompression(p);
  try {
    return HASH_INPUT.set(n), SIGNATURE_INPUT.set(c), wasm.recover(a, u) === 1 ? PUBLIC_KEY_INPUT.slice(0, a) : null;
  } finally {
    HASH_INPUT.fill(0), SIGNATURE_INPUT.fill(0), PUBLIC_KEY_INPUT.fill(0);
  }
}
function verifySchnorr(n, c, u) {
  validateHash(n), validateXOnlyPoint(c), validateSignature(u);
  try {
    return HASH_INPUT.set(n), X_ONLY_PUBLIC_KEY_INPUT.set(c), SIGNATURE_INPUT.set(u), wasm.verifySchnorr() === 1;
  } finally {
    HASH_INPUT.fill(0), X_ONLY_PUBLIC_KEY_INPUT.fill(0), SIGNATURE_INPUT.fill(0);
  }
}
const ecc$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  __initializeContext,
  isPoint,
  isPointCompressed,
  isPrivate,
  isXOnlyPoint,
  pointAdd,
  pointAddScalar,
  pointCompress,
  pointFromScalar,
  pointMultiply,
  privateAdd,
  privateNegate,
  privateSub,
  recover,
  sign: sign$1,
  signRecoverable,
  signSchnorr: signSchnorr$1,
  verify: verify$1,
  verifySchnorr,
  xOnlyPointAddTweak,
  xOnlyPointAddTweakCheck,
  xOnlyPointFromPoint,
  xOnlyPointFromScalar
}, Symbol.toStringTag, { value: "Module" })), initBTCCurve = () => {
  src$j.initEccLib(ecc$1);
}, COMPRESSED_PUBLIC_KEY_HEX_LENGTH = 66, NETWORKS = {
  [Network.MAINNET]: {
    name: "Mainnet",
    config: src$j.networks.bitcoin,
    addressPrefix: {
      common: "bc1",
      nativeSegWit: "bc1q",
      taproot: "bc1p"
    }
  },
  [Network.TESTNET]: {
    name: "Testnet",
    config: src$j.networks.testnet,
    addressPrefix: {
      common: "tb1",
      nativeSegWit: "tb1q",
      taproot: "tb1p"
    }
  },
  [Network.SIGNET]: {
    name: "Signet",
    config: src$j.networks.testnet,
    addressPrefix: {
      common: "tb1",
      nativeSegWit: "tb1q",
      taproot: "tb1p"
    }
  }
}, getTaprootAddress = (n, c) => {
  n.length == COMPRESSED_PUBLIC_KEY_HEX_LENGTH && (n = n.slice(2));
  const u = Buffer$f.from(n, "hex"), { address: p, output: a } = src$j.payments.p2tr({
    internalPubkey: toXOnly_1(u),
    network: NETWORKS[c].config
  });
  if (!p || !a)
    throw new WalletError({
      code: ERROR_CODES.ADDRESS_GENERATION_FAILED,
      message: "Failed to generate taproot address or script from public key"
    });
  return p;
}, getNativeSegwitAddress = (n, c) => {
  if (n.length !== COMPRESSED_PUBLIC_KEY_HEX_LENGTH)
    throw new WalletError({
      code: ERROR_CODES.INVALID_PUBLIC_KEY,
      message: "Invalid public key length for generating native segwit address"
    });
  const u = Buffer$f.from(n, "hex"), { address: p, output: a } = src$j.payments.p2wpkh({
    pubkey: u,
    network: NETWORKS[c].config
  });
  if (!p || !a)
    throw new WalletError({
      code: ERROR_CODES.ADDRESS_GENERATION_FAILED,
      message: "Failed to generate native segwit address or script from public key"
    });
  return p;
};
function validateAddressWithPK(n, c, u) {
  return n.startsWith(NETWORKS[u].addressPrefix.taproot) ? n === getTaprootAddress(c, u) : n.startsWith(NETWORKS[u].addressPrefix.nativeSegWit) ? n === getNativeSegwitAddress(c, u) : !1;
}
function validateAddress(n, c) {
  const { addressPrefix: u, name: p } = NETWORKS[n];
  if (!(n in NETWORKS))
    throw new WalletError({
      code: ERROR_CODES.UNSUPPORTED_NETWORK,
      message: `Unsupported network: ${n}. Please provide a valid network.`
    });
  if (!c.startsWith(u.common))
    throw new WalletError({
      code: ERROR_CODES.INVALID_ADDRESS_PREFIX,
      message: `Incorrect address prefix for ${p}. Expected address to start with '${u.common}'.`
    });
}
const toNetwork = (n) => NETWORKS[n].config, getPublicKeyFromXpub = (n, c, u) => {
  const a = HDKey.fromExtendedKey(n, u == null ? void 0 : u.bip32).derive(c);
  return Buffer$f.from(a.publicKey);
}, generateP2TRAddressFromXpub = (n, c, u) => {
  const p = getPublicKeyFromXpub(n, c), a = toXOnly_1(p);
  let A, b;
  try {
    const F = src$j.payments.p2tr({
      internalPubkey: a,
      network: u
    });
    A = F.address, b = F.output;
  } catch (F) {
    if (F instanceof Error && F.message.includes("ECC")) {
      initBTCCurve();
      const le = src$j.payments.p2tr({
        internalPubkey: a,
        network: u
      });
      A = le.address, b = le.output;
    } else
      throw F;
  }
  return {
    address: A,
    publicKeyHex: p.toString("hex"),
    scriptPubKeyHex: b.toString("hex")
  };
}, WALLET_PROVIDER_NAME$4 = "Keystone";
class KeystoneProvider {
  constructor(c, u) {
    As(this, "keystoneWalletInfo");
    As(this, "viewSDK");
    As(this, "dataSdk");
    As(this, "config");
    /**
     * Connects the staking app to the Keystone device and retrieves the necessary information.
     * @returns A Promise that resolves to the current instance of the class.
     * @throws An error if there is an issue reading the QR code or retrieving the extended public key.
     */
    As(this, "connectWallet", async () => {
      const u = await (await this.viewSDK.getSdk()).read([SupportedResult.UR_CRYPTO_ACCOUNT], {
        title: "Sync Keystone with Babylon Staking App",
        description: "Please scan the QR code displayed on your Keystone, Currently only the first Taproot Address will be used",
        renderInitial: {
          walletMode: "btc",
          link: "",
          description: [
            "1. Turn on your Keystone 3 with BTC only firmware.",
            '2. Click connect software wallet and use "Sparrow" for connection.',
            '3. Press the "Sync Keystone" button and scan the QR Code displayed on your Keystone hardware wallet',
            "4. The first Taproot address will be used for staking."
          ]
        },
        URTypeErrorMessage: "The scanned QR code is not the sync code from the Keystone hardware wallet. Please verify the code and try again."
      });
      if (u.status === ReadStatus.canceled)
        throw new WalletError({
          code: ERROR_CODES.CONNECTION_CANCELED,
          message: "Connection to Keystone was canceled",
          wallet: WALLET_PROVIDER_NAME$4
        });
      if (u.status !== ReadStatus.success)
        throw new WalletError({
          code: ERROR_CODES.QR_READ_ERROR,
          message: "Error reading QR code, Please try again.",
          wallet: WALLET_PROVIDER_NAME$4
        });
      const p = this.dataSdk.parseAccount(u.result), a = 3, A = p.keys[a].extendedPublicKey;
      if (this.keystoneWalletInfo = {
        mfp: p.masterFingerprint,
        extendedPublicKey: A,
        path: p.keys[a].path,
        address: void 0,
        publicKeyHex: void 0,
        scriptPubKeyHex: void 0
      }, !this.keystoneWalletInfo.extendedPublicKey)
        throw new WalletError({
          code: ERROR_CODES.EXTENSION_NOT_FOUND,
          message: "Could not retrieve the extended public key",
          wallet: WALLET_PROVIDER_NAME$4
        });
      const { address: b, publicKeyHex: F, scriptPubKeyHex: le } = generateP2TRAddressFromXpub(
        this.keystoneWalletInfo.extendedPublicKey,
        "M/0/0",
        toNetwork(this.config.network)
      );
      this.keystoneWalletInfo.address = b, this.keystoneWalletInfo.publicKeyHex = F, this.keystoneWalletInfo.scriptPubKeyHex = le;
    });
    As(this, "getAddress", async () => {
      var c;
      if (!((c = this.keystoneWalletInfo) != null && c.address))
        throw new WalletError({
          code: ERROR_CODES.ADDRESS_NOT_FOUND,
          message: "Could not retrieve the address",
          wallet: WALLET_PROVIDER_NAME$4
        });
      return this.keystoneWalletInfo.address;
    });
    As(this, "getPublicKeyHex", async () => {
      var c;
      if (!((c = this.keystoneWalletInfo) != null && c.publicKeyHex))
        throw new WalletError({
          code: ERROR_CODES.PUBLIC_KEY_NOT_FOUND,
          message: "Could not retrieve the BTC public key",
          wallet: WALLET_PROVIDER_NAME$4
        });
      return this.keystoneWalletInfo.publicKeyHex;
    });
    As(this, "signPsbt", async (c) => {
      var A, b;
      if (!((A = this.keystoneWalletInfo) != null && A.address) || !((b = this.keystoneWalletInfo) != null && b.publicKeyHex))
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Keystone Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$4
        });
      if (!c)
        throw new WalletError({
          code: ERROR_CODES.PSBT_HEX_REQUIRED,
          message: "psbt hex is required",
          wallet: WALLET_PROVIDER_NAME$4
        });
      let u = src$j.Psbt.fromHex(c);
      u = this.enhancePsbt(u);
      const p = u.toHex();
      return (await this.sign(p)).toHex();
    });
    As(this, "signPsbts", async (c) => {
      var p, a;
      if (!((p = this.keystoneWalletInfo) != null && p.address) || !((a = this.keystoneWalletInfo) != null && a.publicKeyHex))
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Keystone Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$4
        });
      if (!c && !Array.isArray(c))
        throw new WalletError({
          code: ERROR_CODES.PSBTS_HEXES_REQUIRED,
          message: "psbts hexes are required",
          wallet: WALLET_PROVIDER_NAME$4
        });
      const u = [];
      for (const A of c) {
        const b = await this.signPsbt(A);
        u.push(b);
      }
      return u;
    });
    As(this, "getNetwork", async () => this.config.network);
    As(this, "signMessage", async (c, u) => u === "bip322-simple" ? this.signMessageBIP322(c) : this.signMessageECDSA(c));
    /**
     * https://github.com/bitcoin/bips/blob/master/bip-0322.mediawiki
     * signMessageBIP322 signs a message using the BIP322 standard.
     * @param message
     * @returns signature
     */
    As(this, "signMessageBIP322", async (c) => {
      var F, le;
      if (!((F = this.keystoneWalletInfo) != null && F.scriptPubKeyHex) || !((le = this.keystoneWalletInfo) != null && le.publicKeyHex))
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Keystone Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$4
        });
      const u = Buffer$1$1.from(this.keystoneWalletInfo.scriptPubKeyHex, "hex"), p = BIP322.buildToSpendTx(c, u), a = toXOnly_1(Buffer$1$1.from(this.keystoneWalletInfo.publicKeyHex, "hex"));
      let A = BIP322.buildToSignTx(p.getId(), u, !1, a);
      A.updateInput(0, {
        sighashType: src$j.Transaction.SIGHASH_ALL
      }), A = this.enhancePsbt(A);
      const b = await this.sign(A.toHex());
      return BIP322.encodeWitness(b);
    });
    As(this, "signMessageECDSA", async (c) => {
      var F, le;
      if (!((F = this.keystoneWalletInfo) != null && F.address) || !((le = this.keystoneWalletInfo) != null && le.publicKeyHex))
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Keystone Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$4
        });
      const u = this.dataSdk.btc.generateSignRequest({
        requestId: v4(),
        signData: Buffer$1$1.from(c, "utf-8").toString("hex"),
        dataType: dist$w.KeystoneBitcoinSDK.DataType.message,
        accounts: [
          {
            path: `${this.keystoneWalletInfo.path}/0/0`,
            xfp: `${this.keystoneWalletInfo.mfp}`,
            address: this.keystoneWalletInfo.address
          }
        ],
        origin: "babylon staking app"
      }), p = composeQRProcess(SupportedResult.UR_BTC_SIGNATURE), a = await this.viewSDK.getSdk(), A = await p(a, u), b = this.dataSdk.btc.parseSignature(A);
      return Buffer$1$1.from(b.signature, "hex").toString("base64");
    });
    As(this, "getInscriptions", async () => {
      throw new WalletError({
        code: ERROR_CODES.METHOD_NOT_IMPLEMENTED,
        message: "Method not implemented.",
        wallet: WALLET_PROVIDER_NAME$4
      });
    });
    // Not implemented because of the Airgapped HW nature
    As(this, "on", () => {
    });
    As(this, "off", () => {
    });
    As(this, "getWalletProviderName", async () => WALLET_PROVIDER_NAME$4);
    As(this, "getWalletProviderIcon", async () => logo$4);
    /**
     * Sign the PSBT with the Keystone device.
     *
     * @param psbtHex - The PSBT in hex format.
     * @returns The signed PSBT in hex format.
     * */
    As(this, "sign", async (c) => {
      if (!c)
        throw new WalletError({
          code: ERROR_CODES.PSBT_HEX_REQUIRED,
          message: "psbt hex is required",
          wallet: WALLET_PROVIDER_NAME$4
        });
      const u = this.dataSdk.btc.generatePSBT(Buffer$1$1.from(c, "hex")), p = composeQRProcess(SupportedResult.UR_PSBT), a = await this.viewSDK.getSdk(), A = await p(a, u), b = this.dataSdk.btc.parsePSBT(A), F = src$j.Psbt.fromHex(b);
      return F.finalizeAllInputs(), F;
    });
    /**
     * Add the BIP32 derivation information for each input.
     * The Keystone device is stateless, so it needs to know which key to use to sign the PSBT.
     * Therefore, add the Taproot BIP32 derivation information to the PSBT.
     * https://github.com/bitcoin/bips/blob/master/bip-0174.mediawiki#Specification
     * @param psbt - The PSBT object.
     * @returns The PSBT object with the BIP32 derivation information added.
     */
    As(this, "enhancePsbt", (c) => {
      var p, a, A, b;
      if (!((p = this.keystoneWalletInfo) != null && p.scriptPubKeyHex) || !((a = this.keystoneWalletInfo) != null && a.publicKeyHex) || !((A = this.keystoneWalletInfo) != null && A.mfp) || !((b = this.keystoneWalletInfo) != null && b.path))
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Keystone Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$4
        });
      const u = {
        masterFingerprint: Buffer$1$1.from(this.keystoneWalletInfo.mfp, "hex"),
        path: `${this.keystoneWalletInfo.path}/0/0`,
        pubkey: Buffer$1$1.from(this.keystoneWalletInfo.publicKeyHex, "hex")
      };
      return c.data.inputs.forEach((F) => {
        F.tapBip32Derivation = [
          {
            ...u,
            pubkey: toXOnly_1(u.pubkey),
            leafHashes: calculateTapLeafHash(F, u.pubkey)
          }
        ];
      }), c;
    });
    this.config = u, viewSdk.bootstrap(), this.viewSDK = viewSdk, this.dataSdk = new dist$w.KeystoneSDK({
      origin: "babylon staking app"
    });
  }
}
const composeQRProcess = (n) => async (c, u) => {
  if (await c.play(u, {
    title: "Scan the QR Code",
    description: "Please scan the QR code with your Keystone device."
  }) !== PlayStatus.success)
    throw new WalletError({
      code: ERROR_CODES.QR_SCAN_ERROR,
      message: "Could not generate the QR code, please try again.",
      wallet: WALLET_PROVIDER_NAME$4
    });
  const a = await c.read([n], {
    title: "Get the Signature from Keystone",
    description: "Please scan the QR code displayed on your Keystone",
    URTypeErrorMessage: "The scanned QR code can't be read. please verify and try again."
  });
  if (a.status !== ReadStatus.success)
    throw new WalletError({
      code: ERROR_CODES.SIGNATURE_EXTRACT_ERROR,
      message: "Could not extract the signature, please try again.",
      wallet: WALLET_PROVIDER_NAME$4
    });
  return a.result;
}, calculateTapLeafHash = (n, c) => n.tapInternalKey && !n.tapLeafScript ? [] : (n.tapLeafScript || []).filter((p) => pubkeyInScript_1(c, p.script)).map((p) => {
  const a = bip341.tapleafHash({
    output: p.script,
    version: p.leafVersion
  });
  return Object.assign({ hash: a }, p);
}).map((p) => p.hash), metadata$6 = {
  id: "keystone",
  name: WALLET_PROVIDER_NAME$4,
  icon: logo$4,
  docs: "https://www.keyst.one/btc-only",
  createProvider: (n, c) => new KeystoneProvider(n, c),
  networks: [Network.MAINNET, Network.SIGNET],
  label: "Hardware wallet"
}, logo$3 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='157'%20height='157'%3e%3cpath%20fill='%23000'%20fill-rule='nonzero'%20d='M5%20106.655V143h55.308v-8.06h-47.25v-28.285H5Zm138.98%200v28.285H96.731v8.058h55.308v-36.343h-8.059Zm-83.592-55.31v55.308h36.343v-7.269H68.446V51.345h-8.058ZM5%2015v36.345h8.058V23.058h47.25V15H5Zm91.731%200v8.058h47.249v28.287h8.059V15H96.731Z'/%3e%3c/svg%3e", errorClasses = {}, deserializers = {}, addCustomErrorDeserializer = (n, c) => {
  deserializers[n] = c;
}, createCustomErrorClass = (n) => {
  class c extends Error {
    constructor(a, A, b) {
      super(a || n, b);
      As(this, "cause");
      if (Object.setPrototypeOf(this, c.prototype), this.name = n, A)
        for (const F in A)
          this[F] = A[F];
      if (b && isObject(b) && "cause" in b && !this.cause) {
        const F = b.cause;
        this.cause = F, "stack" in F && (this.stack = this.stack + `
CAUSE: ` + F.stack);
      }
    }
  }
  return errorClasses[n] = c, c;
};
function isObject(n) {
  return typeof n == "object";
}
createCustomErrorClass("AccountNameRequired");
createCustomErrorClass("AccountNotSupported");
createCustomErrorClass("AccountAwaitingSendPendingOperations");
createCustomErrorClass("AmountRequired");
createCustomErrorClass("BluetoothRequired");
createCustomErrorClass("BtcUnmatchedApp");
createCustomErrorClass("CantOpenDevice");
createCustomErrorClass("CashAddrNotSupported");
createCustomErrorClass("ClaimRewardsFeesWarning");
createCustomErrorClass("CurrencyNotSupported");
createCustomErrorClass("DeviceAppVerifyNotSupported");
createCustomErrorClass("DeviceGenuineSocketEarlyClose");
createCustomErrorClass("DeviceNotGenuine");
createCustomErrorClass("DeviceOnDashboardExpected");
createCustomErrorClass("DeviceOnDashboardUnexpected");
createCustomErrorClass("DeviceInOSUExpected");
createCustomErrorClass("DeviceHalted");
createCustomErrorClass("DeviceNameInvalid");
createCustomErrorClass("DeviceSocketFail");
createCustomErrorClass("DeviceSocketNoBulkStatus");
createCustomErrorClass("DeviceSocketNoBulkStatus");
createCustomErrorClass("UnresponsiveDeviceError");
const DisconnectedDevice = createCustomErrorClass("DisconnectedDevice"), DisconnectedDeviceDuringOperation = createCustomErrorClass("DisconnectedDeviceDuringOperation");
createCustomErrorClass("DeviceExtractOnboardingStateError");
createCustomErrorClass("DeviceOnboardingStatePollingError");
createCustomErrorClass("EnpointConfig");
createCustomErrorClass("EthAppPleaseEnableContractData");
createCustomErrorClass("FeeEstimationFailed");
createCustomErrorClass("FirmwareNotRecognized");
createCustomErrorClass("HardResetFail");
createCustomErrorClass("InvalidXRPTag");
createCustomErrorClass("InvalidAddress");
createCustomErrorClass("InvalidNonce");
createCustomErrorClass("InvalidAddressBecauseDestinationIsAlsoSource");
createCustomErrorClass("LatestMCUInstalledError");
createCustomErrorClass("LatestFirmwareVersionRequired");
createCustomErrorClass("UnknownMCU");
createCustomErrorClass("LedgerAPIError");
createCustomErrorClass("LedgerAPIErrorWithMessage");
createCustomErrorClass("LedgerAPINotAvailable");
createCustomErrorClass("ManagerAppAlreadyInstalled");
createCustomErrorClass("ManagerAppRelyOnBTC");
createCustomErrorClass("ManagerAppDepInstallRequired");
createCustomErrorClass("ManagerAppDepUninstallRequired");
createCustomErrorClass("ManagerDeviceLocked");
createCustomErrorClass("ManagerFirmwareNotEnoughSpace");
createCustomErrorClass("ManagerNotEnoughSpace");
createCustomErrorClass("ManagerUninstallBTCDep");
createCustomErrorClass("NetworkDown");
createCustomErrorClass("NetworkError");
createCustomErrorClass("NoAddressesFound");
createCustomErrorClass("NotEnoughBalance");
createCustomErrorClass("NotEnoughBalanceFees");
createCustomErrorClass("NotEnoughBalanceSwap");
createCustomErrorClass("NotEnoughBalanceToDelegate");
createCustomErrorClass("NotEnoughBalanceInParentAccount");
createCustomErrorClass("NotEnoughSpendableBalance");
createCustomErrorClass("NotEnoughBalanceBecauseDestinationNotCreated");
createCustomErrorClass("NoAccessToCamera");
createCustomErrorClass("NotEnoughGas");
createCustomErrorClass("NotEnoughGasSwap");
createCustomErrorClass("TronEmptyAccount");
createCustomErrorClass("MaybeKeepTronAccountAlive");
createCustomErrorClass("NotSupportedLegacyAddress");
createCustomErrorClass("GasLessThanEstimate");
createCustomErrorClass("PriorityFeeTooLow");
createCustomErrorClass("PriorityFeeTooHigh");
createCustomErrorClass("PriorityFeeHigherThanMaxFee");
createCustomErrorClass("MaxFeeTooLow");
createCustomErrorClass("PasswordsDontMatch");
createCustomErrorClass("PasswordIncorrect");
createCustomErrorClass("RecommendSubAccountsToEmpty");
createCustomErrorClass("RecommendUndelegation");
createCustomErrorClass("TimeoutTagged");
createCustomErrorClass("UnexpectedBootloader");
createCustomErrorClass("MCUNotGenuineToDashboard");
createCustomErrorClass("RecipientRequired");
createCustomErrorClass("UnavailableTezosOriginatedAccountReceive");
createCustomErrorClass("UnavailableTezosOriginatedAccountSend");
createCustomErrorClass("UpdateFetchFileFail");
createCustomErrorClass("UpdateIncorrectHash");
createCustomErrorClass("UpdateIncorrectSig");
createCustomErrorClass("UpdateYourApp");
createCustomErrorClass("UserRefusedDeviceNameChange");
createCustomErrorClass("UserRefusedAddress");
createCustomErrorClass("UserRefusedFirmwareUpdate");
createCustomErrorClass("UserRefusedAllowManager");
createCustomErrorClass("UserRefusedOnDevice");
createCustomErrorClass("PinNotSet");
createCustomErrorClass("ExpertModeRequired");
const TransportOpenUserCancelled = createCustomErrorClass("TransportOpenUserCancelled"), TransportInterfaceNotAvailable = createCustomErrorClass("TransportInterfaceNotAvailable"), TransportRaceCondition = createCustomErrorClass("TransportRaceCondition"), TransportWebUSBGestureRequired = createCustomErrorClass("TransportWebUSBGestureRequired");
createCustomErrorClass("TransactionHasBeenValidatedError");
createCustomErrorClass("TransportExchangeTimeoutError");
createCustomErrorClass("DeviceShouldStayInApp");
createCustomErrorClass("WebsocketConnectionError");
createCustomErrorClass("WebsocketConnectionFailed");
createCustomErrorClass("WrongDeviceForAccount");
createCustomErrorClass("WrongDeviceForAccountPayout");
createCustomErrorClass("WrongDeviceForAccountRefund");
createCustomErrorClass("WrongAppForCurrency");
createCustomErrorClass("ETHAddressNonEIP");
createCustomErrorClass("CantScanQRCode");
createCustomErrorClass("FeeNotLoaded");
createCustomErrorClass("FeeNotLoadedSwap");
createCustomErrorClass("FeeRequired");
createCustomErrorClass("FeeTooHigh");
createCustomErrorClass("PendingOperation");
createCustomErrorClass("SyncError");
createCustomErrorClass("PairingFailed");
createCustomErrorClass("PeerRemovedPairing");
createCustomErrorClass("GenuineCheckFailed");
createCustomErrorClass("LedgerAPI4xx");
createCustomErrorClass("LedgerAPI5xx");
createCustomErrorClass("FirmwareOrAppUpdateRequired");
createCustomErrorClass("ReplacementTransactionUnderpriced");
createCustomErrorClass("OpReturnSizeLimit");
createCustomErrorClass("DustLimit");
createCustomErrorClass("LanguageNotFound");
createCustomErrorClass("NoDBPathGiven");
createCustomErrorClass("DBWrongPassword");
createCustomErrorClass("DBNotReset");
createCustomErrorClass("SequenceNumberError");
createCustomErrorClass("DisabledTransactionBroadcastError");
var HwTransportErrorType;
(function(n) {
  n.Unknown = "Unknown", n.LocationServicesDisabled = "LocationServicesDisabled", n.LocationServicesUnauthorized = "LocationServicesUnauthorized", n.BluetoothScanStartFailed = "BluetoothScanStartFailed";
})(HwTransportErrorType || (HwTransportErrorType = {}));
class TransportError extends Error {
  constructor(u, p) {
    const a = "TransportError";
    super(u || a);
    As(this, "id");
    this.name = a, this.message = u, this.stack = new Error(u).stack, this.id = p;
  }
}
addCustomErrorDeserializer("TransportError", (n) => new TransportError(n.message, n.id));
const StatusCodes = {
  ACCESS_CONDITION_NOT_FULFILLED: 38916,
  ALGORITHM_NOT_SUPPORTED: 38020,
  CLA_NOT_SUPPORTED: 28160,
  CODE_BLOCKED: 38976,
  CODE_NOT_INITIALIZED: 38914,
  COMMAND_INCOMPATIBLE_FILE_STRUCTURE: 27009,
  CONDITIONS_OF_USE_NOT_SATISFIED: 27013,
  CONTRADICTION_INVALIDATION: 38928,
  CONTRADICTION_SECRET_CODE_STATUS: 38920,
  DEVICE_IN_RECOVERY_MODE: 26159,
  CUSTOM_IMAGE_EMPTY: 26158,
  FILE_ALREADY_EXISTS: 27273,
  FILE_NOT_FOUND: 37892,
  GP_AUTH_FAILED: 25344,
  HALTED: 28586,
  INCONSISTENT_FILE: 37896,
  INCORRECT_DATA: 27264,
  INCORRECT_LENGTH: 26368,
  INCORRECT_P1_P2: 27392,
  INS_NOT_SUPPORTED: 27904,
  DEVICE_NOT_ONBOARDED: 27911,
  DEVICE_NOT_ONBOARDED_2: 26129,
  INVALID_KCV: 38021,
  INVALID_OFFSET: 37890,
  LICENSING: 28482,
  LOCKED_DEVICE: 21781,
  MAX_VALUE_REACHED: 38992,
  MEMORY_PROBLEM: 37440,
  MISSING_CRITICAL_PARAMETER: 26624,
  NO_EF_SELECTED: 37888,
  NOT_ENOUGH_MEMORY_SPACE: 27268,
  OK: 36864,
  PIN_REMAINING_ATTEMPTS: 25536,
  REFERENCED_DATA_NOT_FOUND: 27272,
  SECURITY_STATUS_NOT_SATISFIED: 27010,
  TECHNICAL_PROBLEM: 28416,
  UNKNOWN_APDU: 27906,
  USER_REFUSED_ON_DEVICE: 21761,
  NOT_ENOUGH_SPACE: 20738,
  APP_NOT_FOUND_OR_INVALID_CONTEXT: 20771,
  INVALID_APP_NAME_LENGTH: 26378,
  GEN_AES_KEY_FAILED: 21529,
  INTERNAL_CRYPTO_OPERATION_FAILED: 21530,
  INTERNAL_COMPUTE_AES_CMAC_FAILED: 21531,
  ENCRYPT_APP_STORAGE_FAILED: 21532,
  INVALID_BACKUP_STATE: 26178,
  PIN_NOT_SET: 21762,
  INVALID_BACKUP_LENGTH: 26419,
  INVALID_RESTORE_STATE: 26179,
  INVALID_CHUNK_LENGTH: 26420,
  INVALID_BACKUP_HEADER: 26698,
  // Not documented:
  TRUSTCHAIN_WRONG_SEED: 45063
};
function getAltStatusMessage(n) {
  switch (n) {
    case 26368:
      return "Incorrect length";
    case 26624:
      return "Missing critical parameter";
    case 27010:
      return "Security not satisfied (dongle locked or have invalid access rights)";
    case 27013:
      return "Condition of use not satisfied (denied by the user?)";
    case 27264:
      return "Invalid data received";
    case 27392:
      return "Invalid parameter received";
    case 21781:
      return "Locked device";
  }
  if (28416 <= n && n <= 28671)
    return "Internal error, please report";
}
class TransportStatusError extends Error {
  /**
   * @param statusCode The error status code coming from a Transport implementation
   * @param options containing:
   *  - canBeMappedToChildError: enable the mapping of TransportStatusError to an error extending/inheriting from it
   *  . Ex: LockedDeviceError. Default to true.
   */
  constructor(u, { canBeMappedToChildError: p = !0 } = {}) {
    const a = Object.keys(StatusCodes).find((le) => StatusCodes[le] === u) || "UNKNOWN_ERROR", A = getAltStatusMessage(u) || a, b = u.toString(16), F = `Ledger device: ${A} (0x${b})`;
    super(F);
    As(this, "statusCode");
    As(this, "statusText");
    if (this.name = "TransportStatusError", this.statusCode = u, this.statusText = a, Object.setPrototypeOf(this, TransportStatusError.prototype), p && u === StatusCodes.LOCKED_DEVICE)
      return new LockedDeviceError(F);
  }
}
class LockedDeviceError extends TransportStatusError {
  constructor(c) {
    super(StatusCodes.LOCKED_DEVICE, { canBeMappedToChildError: !1 }), c && (this.message = c), this.name = "LockedDeviceError", Object.setPrototypeOf(this, LockedDeviceError.prototype);
  }
}
addCustomErrorDeserializer("TransportStatusError", (n) => new TransportStatusError(n.statusCode));
let id = 0;
const subscribers = [], log = (n, c, u) => {
  const p = {
    type: n,
    id: String(++id),
    date: /* @__PURE__ */ new Date()
  };
  c && (p.message = c), dispatch(p);
}, trace = ({ type: n, message: c, data: u, context: p }) => {
  const a = {
    type: n,
    id: String(++id),
    date: /* @__PURE__ */ new Date()
  };
  c && (a.message = c), u && (a.data = u), p && (a.context = p), dispatch(a);
};
class LocalTracer {
  constructor(c, u) {
    this.type = c, this.context = u;
  }
  trace(c, u) {
    trace({
      type: this.type,
      message: c,
      data: u,
      context: this.context
    });
  }
  getContext() {
    return this.context;
  }
  setContext(c) {
    this.context = c;
  }
  updateContext(c) {
    this.context = Object.assign(Object.assign({}, this.context), c);
  }
  getType() {
    return this.type;
  }
  setType(c) {
    this.type = c;
  }
  /**
   * Create a new instance of the LocalTracer with an updated `type`
   *
   * It does not mutate the calling instance, but returns a new LocalTracer,
   * following a simple builder pattern.
   */
  withType(c) {
    return new LocalTracer(c, this.context);
  }
  /**
   * Create a new instance of the LocalTracer with a new `context`
   *
   * It does not mutate the calling instance, but returns a new LocalTracer,
   * following a simple builder pattern.
   *
   * @param context A TraceContext, that can undefined to reset the context
   */
  withContext(c) {
    return new LocalTracer(this.type, c);
  }
  /**
   * Create a new instance of the LocalTracer with an updated `context`,
   * on which an additional context is merged with the existing one.
   *
   * It does not mutate the calling instance, but returns a new LocalTracer,
   * following a simple builder pattern.
   */
  withUpdatedContext(c) {
    return new LocalTracer(this.type, Object.assign(Object.assign({}, this.context), c));
  }
}
const listen = (n) => (subscribers.push(n), () => {
  const c = subscribers.indexOf(n);
  c !== -1 && (subscribers[c] = subscribers[subscribers.length - 1], subscribers.pop());
});
function dispatch(n) {
  for (let c = 0; c < subscribers.length; c++)
    try {
      subscribers[c](n);
    } catch (u) {
      console.error(u);
    }
}
typeof window < "u" && (window.__ledgerLogsListen = listen);
const DEFAULT_LOG_TYPE = "transport";
class Transport {
  constructor({ context: c, logType: u } = {}) {
    As(this, "exchangeTimeout", 3e4);
    As(this, "unresponsiveTimeout", 15e3);
    As(this, "deviceModel", null);
    As(this, "tracer");
    As(this, "_events", new EventEmitter$2());
    /**
     * Send data to the device using the higher level API.
     *
     * @param {number} cla - The instruction class for the command.
     * @param {number} ins - The instruction code for the command.
     * @param {number} p1 - The first parameter for the instruction.
     * @param {number} p2 - The second parameter for the instruction.
     * @param {Buffer} data - The data to be sent. Defaults to an empty buffer.
     * @param {Array<number>} statusList - A list of acceptable status codes for the response. Defaults to [StatusCodes.OK].
     * @param {Object} options - Contains optional options for the exchange function
     *  - abortTimeoutMs: stop the send after a given timeout. Another timeout exists
     *    to detect unresponsive device (see `unresponsiveTimeout`). This timeout aborts the exchange.
     * @returns {Promise<Buffer>} A promise that resolves with the response data from the device.
     */
    As(this, "send", async (c, u, p, a, A = Buffer$f.alloc(0), b = [StatusCodes.OK], { abortTimeoutMs: F } = {}) => {
      const le = this.tracer.withUpdatedContext({ function: "send" });
      if (A.length >= 256)
        throw le.trace("data.length exceeded 256 bytes limit", { dataLength: A.length }), new TransportError("data.length exceed 256 bytes limit. Got: " + A.length, "DataLengthTooBig");
      le.trace("Starting an exchange", { abortTimeoutMs: F });
      const L = await this.exchange(
        // The size of the data is added in 1 byte just before `data`
        Buffer$f.concat([Buffer$f.from([c, u, p, a]), Buffer$f.from([A.length]), A]),
        { abortTimeoutMs: F }
      );
      le.trace("Received response from exchange");
      const pe = L.readUInt16BE(L.length - 2);
      if (!b.some(($) => $ === pe))
        throw new TransportStatusError(pe);
      return L;
    });
    // Blocks other exchange to happen concurrently
    As(this, "exchangeBusyPromise");
    As(this, "_appAPIlock", null);
    this.tracer = new LocalTracer(u ?? DEFAULT_LOG_TYPE, c);
  }
  /**
   * Send data to the device using a low level API.
   * It's recommended to use the "send" method for a higher level API.
   * @param {Buffer} apdu - The data to send.
   * @param {Object} options - Contains optional options for the exchange function
   *  - abortTimeoutMs: stop the exchange after a given timeout. Another timeout exists
   *    to detect unresponsive device (see `unresponsiveTimeout`). This timeout aborts the exchange.
   * @returns {Promise<Buffer>} A promise that resolves with the response data from the device.
   */
  exchange(c, { abortTimeoutMs: u } = {}) {
    throw new Error("exchange not implemented");
  }
  /**
   * Send apdus in batch to the device using a low level API.
   * The default implementation is to call exchange for each apdu.
   * @param {Array<Buffer>} apdus - array of apdus to send.
   * @param {Observer<Buffer>} observer - an observer that will receive the response of each apdu.
   * @returns {Subscription} A Subscription object on which you can call ".unsubscribe()" to stop sending apdus.
   */
  exchangeBulk(c, u) {
    let p = !1;
    const a = () => {
      p = !0;
    };
    return (async () => {
      if (!p)
        for (const b of c) {
          const F = await this.exchange(b);
          if (p)
            return;
          const le = F.readUInt16BE(F.length - 2);
          if (le !== StatusCodes.OK)
            throw new TransportStatusError(le);
          u.next(F);
        }
    })().then(() => !p && u.complete(), (b) => !p && u.error(b)), { unsubscribe: a };
  }
  /**
   * Set the "scramble key" for the next data exchanges with the device.
   * Each app can have a different scramble key and it is set internally during instantiation.
   * @param {string} key - The scramble key to set.
   * deprecated This method is no longer needed for modern transports and should be migrated away from.
   * no @ before deprecated as it breaks documentationjs on version 14.0.2
   * https://github.com/documentationjs/documentation/issues/1596
   */
  setScrambleKey(c) {
  }
  /**
   * Close the connection with the device.
   *
   * Note: for certain transports (hw-transport-node-hid-singleton for ex), once the promise resolved,
   * the transport instance is actually still cached, and the device is disconnected only after a defined timeout.
   * But for the consumer of the Transport, this does not matter and it can consider the transport to be closed.
   *
   * @returns {Promise<void>} A promise that resolves when the transport is closed.
   */
  close() {
    return Promise.resolve();
  }
  /**
   * Listen for an event on the transport instance.
   * Transport implementations may have specific events. Common events include:
   * "disconnect" : triggered when the transport is disconnected.
   * @param {string} eventName - The name of the event to listen for.
   * @param {(...args: Array<any>) => any} cb - The callback function to be invoked when the event occurs.
   */
  on(c, u) {
    this._events.on(c, u);
  }
  /**
   * Stop listening to an event on an instance of transport.
   */
  off(c, u) {
    this._events.removeListener(c, u);
  }
  emit(c, ...u) {
    this._events.emit(c, ...u);
  }
  /**
   * Enable or not logs of the binary exchange
   */
  setDebugMode() {
    console.warn("setDebugMode is deprecated. use @ledgerhq/logs instead. No logs are emitted in this anymore.");
  }
  /**
   * Set a timeout (in milliseconds) for the exchange call. Only some transport might implement it. (e.g. U2F)
   */
  setExchangeTimeout(c) {
    this.exchangeTimeout = c;
  }
  /**
   * Define the delay before emitting "unresponsive" on an exchange that does not respond
   */
  setExchangeUnresponsiveTimeout(c) {
    this.unresponsiveTimeout = c;
  }
  /**
   * create() allows to open the first descriptor available or
   * throw if there is none or if timeout is reached.
   * This is a light helper, alternative to using listen() and open() (that you may need for any more advanced usecase)
   * @example
  TransportFoo.create().then(transport => ...)
   */
  static create(c = 3e3, u) {
    return new Promise((p, a) => {
      let A = !1;
      const b = this.listen({
        next: (le) => {
          A = !0, b && b.unsubscribe(), F && clearTimeout(F), this.open(le.descriptor, c).then(p, a);
        },
        error: (le) => {
          F && clearTimeout(F), a(le);
        },
        complete: () => {
          F && clearTimeout(F), A || a(new TransportError(this.ErrorMessage_NoDeviceFound, "NoDeviceFound"));
        }
      }), F = u ? setTimeout(() => {
        b.unsubscribe(), a(new TransportError(this.ErrorMessage_ListenTimeout, "ListenTimeout"));
      }, u) : null;
    });
  }
  /**
   * Wrapper to make an exchange "atomic" (blocking any other exchange)
   *
   * It also handles "unresponsiveness" by emitting "unresponsive" and "responsive" events.
   *
   * @param f The exchange job, using the transport to run
   * @returns a Promise resolving with the output of the given job
   */
  async exchangeAtomicImpl(c) {
    const u = this.tracer.withUpdatedContext({
      function: "exchangeAtomicImpl",
      unresponsiveTimeout: this.unresponsiveTimeout
    });
    if (this.exchangeBusyPromise)
      throw u.trace("Atomic exchange is already busy"), new TransportRaceCondition("An action was already pending on the Ledger device. Please deny or reconnect.");
    let p;
    const a = new Promise((F) => {
      p = F;
    });
    this.exchangeBusyPromise = a;
    let A = !1;
    const b = setTimeout(() => {
      u.trace('Timeout reached, emitting Transport event "unresponsive"', {
        unresponsiveTimeout: this.unresponsiveTimeout
      }), A = !0, this.emit("unresponsive");
    }, this.unresponsiveTimeout);
    try {
      const F = await c();
      return A && (u.trace("Device was unresponsive, emitting responsive"), this.emit("responsive")), F;
    } finally {
      u.trace("Finalize, clearing busy guard"), clearTimeout(b), p && p(), this.exchangeBusyPromise = null;
    }
  }
  decorateAppAPIMethods(c, u, p) {
    for (const a of u)
      c[a] = this.decorateAppAPIMethod(a, c[a], c, p);
  }
  decorateAppAPIMethod(c, u, p, a) {
    return async (...A) => {
      const { _appAPIlock: b } = this;
      if (b)
        return Promise.reject(new TransportError("Ledger Device is busy (lock " + b + ")", "TransportLocked"));
      try {
        return this._appAPIlock = c, this.setScrambleKey(a), await u.apply(p, A);
      } finally {
        this._appAPIlock = null;
      }
    };
  }
  /**
   * Sets the context used by the logging/tracing mechanism
   *
   * Useful when re-using (cached) the same Transport instance,
   * but with a new tracing context.
   *
   * @param context A TraceContext, that can undefined to reset the context
   */
  setTraceContext(c) {
    this.tracer = this.tracer.withContext(c);
  }
  /**
   * Updates the context used by the logging/tracing mechanism
   *
   * The update only overrides the key-value that are already defined in the current context.
   *
   * @param contextToAdd A TraceContext that will be added to the current context
   */
  updateTraceContext(c) {
    this.tracer.updateContext(c);
  }
  /**
   * Gets the tracing context of the transport instance
   */
  getTraceContext() {
    return this.tracer.getContext();
  }
}
/**
 * Check if the transport is supported on the current platform/browser.
 * @returns {Promise<boolean>} A promise that resolves with a boolean indicating support.
 */
As(Transport, "isSupported"), /**
 * List all available descriptors for the transport.
 * For a better granularity, checkout `listen()`.
 *
 * @returns {Promise<Array<any>>} A promise that resolves with an array of descriptors.
 * @example
 * TransportFoo.list().then(descriptors => ...)
 */
As(Transport, "list"), /**
 * Listen for device events for the transport. The method takes an observer of DescriptorEvent and returns a Subscription.
 * A DescriptorEvent is an object containing a "descriptor" and a "type" field. The "type" field can be "add" or "remove", and the "descriptor" field can be passed to the "open" method.
 * The "listen" method will first emit all currently connected devices and then will emit events as they occur, such as when a USB device is plugged in or a Bluetooth device becomes discoverable.
 * @param {Observer<DescriptorEvent<any>>} observer - An object with "next", "error", and "complete" functions, following the observer pattern.
 * @returns {Subscription} A Subscription object on which you can call ".unsubscribe()" to stop listening to descriptors.
 * @example
const sub = TransportFoo.listen({
next: e => {
  if (e.type==="add") {
    sub.unsubscribe();
    const transport = await TransportFoo.open(e.descriptor);
    ...
  }
},
error: error => {},
complete: () => {}
})
 */
As(Transport, "listen"), /**
 * Attempt to create a Transport instance with a specific descriptor.
 * @param {any} descriptor - The descriptor to open the transport with.
 * @param {number} timeout - An optional timeout for the transport connection.
 * @param {TraceContext} context Optional tracing/log context
 * @returns {Promise<Transport>} A promise that resolves with a Transport instance.
 * @example
TransportFoo.open(descriptor).then(transport => ...)
 */
As(Transport, "open"), As(Transport, "ErrorMessage_ListenTimeout", "No Ledger device found (timeout)"), As(Transport, "ErrorMessage_NoDeviceFound", "No Ledger device found");
const Tag = 5;
function asUInt16BE(n) {
  const c = Buffer$f.alloc(2);
  return c.writeUInt16BE(n, 0), c;
}
const initialAcc = {
  data: Buffer$f.alloc(0),
  dataLength: 0,
  sequence: 0
}, createHIDframing = (n, c) => ({
  /**
   * Frames/encodes an APDU message into HID USB packets/frames
   *
   * @param apdu The APDU message to send, in a Buffer containing [cla, ins, p1, p2, data length, data(if not empty)]
   * @returns an array of HID USB frames ready to be sent
   */
  makeBlocks(u) {
    let p = Buffer$f.concat([asUInt16BE(u.length), u]);
    const a = c - 5, A = Math.ceil(p.length / a);
    p = Buffer$f.concat([p, Buffer$f.alloc(A * a - p.length + 1).fill(0)]);
    const b = [];
    for (let F = 0; F < A; F++) {
      const le = Buffer$f.alloc(5);
      le.writeUInt16BE(n, 0), le.writeUInt8(Tag, 2), le.writeUInt16BE(F, 3);
      const L = p.slice(F * a, (F + 1) * a);
      b.push(Buffer$f.concat([le, L]));
    }
    return b;
  },
  /**
   * Reduces HID USB packets/frames to one response.
   *
   * @param acc The value resulting from (accumulating) the previous call of reduceResponse.
   *   On first call initialized to `initialAcc`. The accumulator enables handling multi-frames messages.
   * @param chunk Current chunk to reduce into accumulator
   * @returns An accumulator value updated with the current chunk
   */
  reduceResponse(u, p) {
    let { data: a, dataLength: A, sequence: b } = u || initialAcc;
    if (p.readUInt16BE(0) !== n)
      throw new TransportError("Invalid channel", "InvalidChannel");
    if (p.readUInt8(2) !== Tag)
      throw new TransportError("Invalid tag", "InvalidTag");
    if (p.readUInt16BE(3) !== b)
      throw new TransportError("Invalid sequence", "InvalidSequence");
    u || (A = p.readUInt16BE(5)), b++;
    const F = p.slice(u ? 5 : 7);
    return a = Buffer$f.concat([a, F]), a.length > A && (a = a.slice(0, A)), {
      data: a,
      dataLength: A,
      sequence: b
    };
  },
  /**
   * Returns the response message that has been reduced from the HID USB frames
   *
   * @param acc The accumulator
   * @returns A Buffer containing the cleaned response message, or null if no response message, or undefined if the
   *   accumulator is incorrect (message length is not valid)
   */
  getReducedResult(u) {
    if (u && u.dataLength === u.data.length)
      return u.data;
  }
});
var re$3 = { exports: {} };
const SEMVER_SPEC_VERSION = "2.0.0", MAX_LENGTH$1 = 256, MAX_SAFE_INTEGER$1 = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */
9007199254740991, MAX_SAFE_COMPONENT_LENGTH = 16, MAX_SAFE_BUILD_LENGTH = MAX_LENGTH$1 - 6, RELEASE_TYPES = [
  "major",
  "premajor",
  "minor",
  "preminor",
  "patch",
  "prepatch",
  "prerelease"
];
var constants$1 = {
  MAX_LENGTH: MAX_LENGTH$1,
  MAX_SAFE_COMPONENT_LENGTH,
  MAX_SAFE_BUILD_LENGTH,
  MAX_SAFE_INTEGER: MAX_SAFE_INTEGER$1,
  RELEASE_TYPES,
  SEMVER_SPEC_VERSION,
  FLAG_INCLUDE_PRERELEASE: 1,
  FLAG_LOOSE: 2
};
const debug$1 = typeof process$1 == "object" && process$1.env && process$1.env.NODE_DEBUG && /\bsemver\b/i.test(process$1.env.NODE_DEBUG) ? (...n) => console.error("SEMVER", ...n) : () => {
};
var debug_1 = debug$1;
(function(n, c) {
  const {
    MAX_SAFE_COMPONENT_LENGTH: u,
    MAX_SAFE_BUILD_LENGTH: p,
    MAX_LENGTH: a
  } = constants$1, A = debug_1;
  c = n.exports = {};
  const b = c.re = [], F = c.safeRe = [], le = c.src = [], L = c.t = {};
  let pe = 0;
  const $ = "[a-zA-Z0-9-]", Ee = [
    ["\\s", 1],
    ["\\d", a],
    [$, p]
  ], be = (Pe) => {
    for (const [nr, ir] of Ee)
      Pe = Pe.split(`${nr}*`).join(`${nr}{0,${ir}}`).split(`${nr}+`).join(`${nr}{1,${ir}}`);
    return Pe;
  }, He = (Pe, nr, ir) => {
    const or = be(nr), lr = pe++;
    A(Pe, lr, nr), L[Pe] = lr, le[lr] = nr, b[lr] = new RegExp(nr, ir ? "g" : void 0), F[lr] = new RegExp(or, ir ? "g" : void 0);
  };
  He("NUMERICIDENTIFIER", "0|[1-9]\\d*"), He("NUMERICIDENTIFIERLOOSE", "\\d+"), He("NONNUMERICIDENTIFIER", `\\d*[a-zA-Z-]${$}*`), He("MAINVERSION", `(${le[L.NUMERICIDENTIFIER]})\\.(${le[L.NUMERICIDENTIFIER]})\\.(${le[L.NUMERICIDENTIFIER]})`), He("MAINVERSIONLOOSE", `(${le[L.NUMERICIDENTIFIERLOOSE]})\\.(${le[L.NUMERICIDENTIFIERLOOSE]})\\.(${le[L.NUMERICIDENTIFIERLOOSE]})`), He("PRERELEASEIDENTIFIER", `(?:${le[L.NUMERICIDENTIFIER]}|${le[L.NONNUMERICIDENTIFIER]})`), He("PRERELEASEIDENTIFIERLOOSE", `(?:${le[L.NUMERICIDENTIFIERLOOSE]}|${le[L.NONNUMERICIDENTIFIER]})`), He("PRERELEASE", `(?:-(${le[L.PRERELEASEIDENTIFIER]}(?:\\.${le[L.PRERELEASEIDENTIFIER]})*))`), He("PRERELEASELOOSE", `(?:-?(${le[L.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${le[L.PRERELEASEIDENTIFIERLOOSE]})*))`), He("BUILDIDENTIFIER", `${$}+`), He("BUILD", `(?:\\+(${le[L.BUILDIDENTIFIER]}(?:\\.${le[L.BUILDIDENTIFIER]})*))`), He("FULLPLAIN", `v?${le[L.MAINVERSION]}${le[L.PRERELEASE]}?${le[L.BUILD]}?`), He("FULL", `^${le[L.FULLPLAIN]}$`), He("LOOSEPLAIN", `[v=\\s]*${le[L.MAINVERSIONLOOSE]}${le[L.PRERELEASELOOSE]}?${le[L.BUILD]}?`), He("LOOSE", `^${le[L.LOOSEPLAIN]}$`), He("GTLT", "((?:<|>)?=?)"), He("XRANGEIDENTIFIERLOOSE", `${le[L.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`), He("XRANGEIDENTIFIER", `${le[L.NUMERICIDENTIFIER]}|x|X|\\*`), He("XRANGEPLAIN", `[v=\\s]*(${le[L.XRANGEIDENTIFIER]})(?:\\.(${le[L.XRANGEIDENTIFIER]})(?:\\.(${le[L.XRANGEIDENTIFIER]})(?:${le[L.PRERELEASE]})?${le[L.BUILD]}?)?)?`), He("XRANGEPLAINLOOSE", `[v=\\s]*(${le[L.XRANGEIDENTIFIERLOOSE]})(?:\\.(${le[L.XRANGEIDENTIFIERLOOSE]})(?:\\.(${le[L.XRANGEIDENTIFIERLOOSE]})(?:${le[L.PRERELEASELOOSE]})?${le[L.BUILD]}?)?)?`), He("XRANGE", `^${le[L.GTLT]}\\s*${le[L.XRANGEPLAIN]}$`), He("XRANGELOOSE", `^${le[L.GTLT]}\\s*${le[L.XRANGEPLAINLOOSE]}$`), He("COERCEPLAIN", `(^|[^\\d])(\\d{1,${u}})(?:\\.(\\d{1,${u}}))?(?:\\.(\\d{1,${u}}))?`), He("COERCE", `${le[L.COERCEPLAIN]}(?:$|[^\\d])`), He("COERCEFULL", le[L.COERCEPLAIN] + `(?:${le[L.PRERELEASE]})?(?:${le[L.BUILD]})?(?:$|[^\\d])`), He("COERCERTL", le[L.COERCE], !0), He("COERCERTLFULL", le[L.COERCEFULL], !0), He("LONETILDE", "(?:~>?)"), He("TILDETRIM", `(\\s*)${le[L.LONETILDE]}\\s+`, !0), c.tildeTrimReplace = "$1~", He("TILDE", `^${le[L.LONETILDE]}${le[L.XRANGEPLAIN]}$`), He("TILDELOOSE", `^${le[L.LONETILDE]}${le[L.XRANGEPLAINLOOSE]}$`), He("LONECARET", "(?:\\^)"), He("CARETTRIM", `(\\s*)${le[L.LONECARET]}\\s+`, !0), c.caretTrimReplace = "$1^", He("CARET", `^${le[L.LONECARET]}${le[L.XRANGEPLAIN]}$`), He("CARETLOOSE", `^${le[L.LONECARET]}${le[L.XRANGEPLAINLOOSE]}$`), He("COMPARATORLOOSE", `^${le[L.GTLT]}\\s*(${le[L.LOOSEPLAIN]})$|^$`), He("COMPARATOR", `^${le[L.GTLT]}\\s*(${le[L.FULLPLAIN]})$|^$`), He("COMPARATORTRIM", `(\\s*)${le[L.GTLT]}\\s*(${le[L.LOOSEPLAIN]}|${le[L.XRANGEPLAIN]})`, !0), c.comparatorTrimReplace = "$1$2$3", He("HYPHENRANGE", `^\\s*(${le[L.XRANGEPLAIN]})\\s+-\\s+(${le[L.XRANGEPLAIN]})\\s*$`), He("HYPHENRANGELOOSE", `^\\s*(${le[L.XRANGEPLAINLOOSE]})\\s+-\\s+(${le[L.XRANGEPLAINLOOSE]})\\s*$`), He("STAR", "(<|>)?=?\\s*\\*"), He("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$"), He("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");
})(re$3, re$3.exports);
var reExports = re$3.exports;
const looseOption = Object.freeze({ loose: !0 }), emptyOpts = Object.freeze({}), parseOptions$1 = (n) => n ? typeof n != "object" ? looseOption : n : emptyOpts;
var parseOptions_1 = parseOptions$1;
const numeric = /^[0-9]+$/, compareIdentifiers$1 = (n, c) => {
  const u = numeric.test(n), p = numeric.test(c);
  return u && p && (n = +n, c = +c), n === c ? 0 : u && !p ? -1 : p && !u ? 1 : n < c ? -1 : 1;
}, rcompareIdentifiers = (n, c) => compareIdentifiers$1(c, n);
var identifiers$1 = {
  compareIdentifiers: compareIdentifiers$1,
  rcompareIdentifiers
};
const debug = debug_1, { MAX_LENGTH, MAX_SAFE_INTEGER } = constants$1, { safeRe: re$2, t: t$1 } = reExports, parseOptions = parseOptions_1, { compareIdentifiers } = identifiers$1;
let SemVer$d = class Vc {
  constructor(c, u) {
    if (u = parseOptions(u), c instanceof Vc) {
      if (c.loose === !!u.loose && c.includePrerelease === !!u.includePrerelease)
        return c;
      c = c.version;
    } else if (typeof c != "string")
      throw new TypeError(`Invalid version. Must be a string. Got type "${typeof c}".`);
    if (c.length > MAX_LENGTH)
      throw new TypeError(
        `version is longer than ${MAX_LENGTH} characters`
      );
    debug("SemVer", c, u), this.options = u, this.loose = !!u.loose, this.includePrerelease = !!u.includePrerelease;
    const p = c.trim().match(u.loose ? re$2[t$1.LOOSE] : re$2[t$1.FULL]);
    if (!p)
      throw new TypeError(`Invalid Version: ${c}`);
    if (this.raw = c, this.major = +p[1], this.minor = +p[2], this.patch = +p[3], this.major > MAX_SAFE_INTEGER || this.major < 0)
      throw new TypeError("Invalid major version");
    if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
      throw new TypeError("Invalid minor version");
    if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
      throw new TypeError("Invalid patch version");
    p[4] ? this.prerelease = p[4].split(".").map((a) => {
      if (/^[0-9]+$/.test(a)) {
        const A = +a;
        if (A >= 0 && A < MAX_SAFE_INTEGER)
          return A;
      }
      return a;
    }) : this.prerelease = [], this.build = p[5] ? p[5].split(".") : [], this.format();
  }
  format() {
    return this.version = `${this.major}.${this.minor}.${this.patch}`, this.prerelease.length && (this.version += `-${this.prerelease.join(".")}`), this.version;
  }
  toString() {
    return this.version;
  }
  compare(c) {
    if (debug("SemVer.compare", this.version, this.options, c), !(c instanceof Vc)) {
      if (typeof c == "string" && c === this.version)
        return 0;
      c = new Vc(c, this.options);
    }
    return c.version === this.version ? 0 : this.compareMain(c) || this.comparePre(c);
  }
  compareMain(c) {
    return c instanceof Vc || (c = new Vc(c, this.options)), compareIdentifiers(this.major, c.major) || compareIdentifiers(this.minor, c.minor) || compareIdentifiers(this.patch, c.patch);
  }
  comparePre(c) {
    if (c instanceof Vc || (c = new Vc(c, this.options)), this.prerelease.length && !c.prerelease.length)
      return -1;
    if (!this.prerelease.length && c.prerelease.length)
      return 1;
    if (!this.prerelease.length && !c.prerelease.length)
      return 0;
    let u = 0;
    do {
      const p = this.prerelease[u], a = c.prerelease[u];
      if (debug("prerelease compare", u, p, a), p === void 0 && a === void 0)
        return 0;
      if (a === void 0)
        return 1;
      if (p === void 0)
        return -1;
      if (p === a)
        continue;
      return compareIdentifiers(p, a);
    } while (++u);
  }
  compareBuild(c) {
    c instanceof Vc || (c = new Vc(c, this.options));
    let u = 0;
    do {
      const p = this.build[u], a = c.build[u];
      if (debug("build compare", u, p, a), p === void 0 && a === void 0)
        return 0;
      if (a === void 0)
        return 1;
      if (p === void 0)
        return -1;
      if (p === a)
        continue;
      return compareIdentifiers(p, a);
    } while (++u);
  }
  // preminor will bump the version up to the next minor release, and immediately
  // down to pre-release. premajor and prepatch work the same way.
  inc(c, u, p) {
    switch (c) {
      case "premajor":
        this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", u, p);
        break;
      case "preminor":
        this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", u, p);
        break;
      case "prepatch":
        this.prerelease.length = 0, this.inc("patch", u, p), this.inc("pre", u, p);
        break;
      case "prerelease":
        this.prerelease.length === 0 && this.inc("patch", u, p), this.inc("pre", u, p);
        break;
      case "major":
        (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) && this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
        break;
      case "minor":
        (this.patch !== 0 || this.prerelease.length === 0) && this.minor++, this.patch = 0, this.prerelease = [];
        break;
      case "patch":
        this.prerelease.length === 0 && this.patch++, this.prerelease = [];
        break;
      case "pre": {
        const a = Number(p) ? 1 : 0;
        if (!u && p === !1)
          throw new Error("invalid increment argument: identifier is empty");
        if (this.prerelease.length === 0)
          this.prerelease = [a];
        else {
          let A = this.prerelease.length;
          for (; --A >= 0; )
            typeof this.prerelease[A] == "number" && (this.prerelease[A]++, A = -2);
          if (A === -1) {
            if (u === this.prerelease.join(".") && p === !1)
              throw new Error("invalid increment argument: identifier already exists");
            this.prerelease.push(a);
          }
        }
        if (u) {
          let A = [u, a];
          p === !1 && (A = [u]), compareIdentifiers(this.prerelease[0], u) === 0 ? isNaN(this.prerelease[1]) && (this.prerelease = A) : this.prerelease = A;
        }
        break;
      }
      default:
        throw new Error(`invalid increment argument: ${c}`);
    }
    return this.raw = this.format(), this.build.length && (this.raw += `+${this.build.join(".")}`), this;
  }
};
var semver$2 = SemVer$d;
const SemVer$c = semver$2, parse$6 = (n, c, u = !1) => {
  if (n instanceof SemVer$c)
    return n;
  try {
    return new SemVer$c(n, c);
  } catch (p) {
    if (!u)
      return null;
    throw p;
  }
};
var parse_1 = parse$6;
const parse$5 = parse_1, valid$2 = (n, c) => {
  const u = parse$5(n, c);
  return u ? u.version : null;
};
var valid_1 = valid$2;
const parse$4 = parse_1, clean$2 = (n, c) => {
  const u = parse$4(n.trim().replace(/^[=v]+/, ""), c);
  return u ? u.version : null;
};
var clean_1 = clean$2;
const SemVer$b = semver$2, inc$1 = (n, c, u, p, a) => {
  typeof u == "string" && (a = p, p = u, u = void 0);
  try {
    return new SemVer$b(
      n instanceof SemVer$b ? n.version : n,
      u
    ).inc(c, p, a).version;
  } catch {
    return null;
  }
};
var inc_1 = inc$1;
const parse$3 = parse_1, diff$1 = (n, c) => {
  const u = parse$3(n, null, !0), p = parse$3(c, null, !0), a = u.compare(p);
  if (a === 0)
    return null;
  const A = a > 0, b = A ? u : p, F = A ? p : u, le = !!b.prerelease.length;
  if (!!F.prerelease.length && !le)
    return !F.patch && !F.minor ? "major" : b.patch ? "patch" : b.minor ? "minor" : "major";
  const pe = le ? "pre" : "";
  return u.major !== p.major ? pe + "major" : u.minor !== p.minor ? pe + "minor" : u.patch !== p.patch ? pe + "patch" : "prerelease";
};
var diff_1 = diff$1;
const SemVer$a = semver$2, major$1 = (n, c) => new SemVer$a(n, c).major;
var major_1 = major$1;
const SemVer$9 = semver$2, minor$1 = (n, c) => new SemVer$9(n, c).minor;
var minor_1 = minor$1;
const SemVer$8 = semver$2, patch$1 = (n, c) => new SemVer$8(n, c).patch;
var patch_1 = patch$1;
const parse$2 = parse_1, prerelease$1 = (n, c) => {
  const u = parse$2(n, c);
  return u && u.prerelease.length ? u.prerelease : null;
};
var prerelease_1 = prerelease$1;
const SemVer$7 = semver$2, compare$b = (n, c, u) => new SemVer$7(n, u).compare(new SemVer$7(c, u));
var compare_1 = compare$b;
const compare$a = compare_1, rcompare$1 = (n, c, u) => compare$a(c, n, u);
var rcompare_1 = rcompare$1;
const compare$9 = compare_1, compareLoose$1 = (n, c) => compare$9(n, c, !0);
var compareLoose_1 = compareLoose$1;
const SemVer$6 = semver$2, compareBuild$3 = (n, c, u) => {
  const p = new SemVer$6(n, u), a = new SemVer$6(c, u);
  return p.compare(a) || p.compareBuild(a);
};
var compareBuild_1 = compareBuild$3;
const compareBuild$2 = compareBuild_1, sort$1 = (n, c) => n.sort((u, p) => compareBuild$2(u, p, c));
var sort_1 = sort$1;
const compareBuild$1 = compareBuild_1, rsort$1 = (n, c) => n.sort((u, p) => compareBuild$1(p, u, c));
var rsort_1 = rsort$1;
const compare$8 = compare_1, gt$4 = (n, c, u) => compare$8(n, c, u) > 0;
var gt_1 = gt$4;
const compare$7 = compare_1, lt$3 = (n, c, u) => compare$7(n, c, u) < 0;
var lt_1 = lt$3;
const compare$6 = compare_1, eq$2 = (n, c, u) => compare$6(n, c, u) === 0;
var eq_1 = eq$2;
const compare$5 = compare_1, neq$2 = (n, c, u) => compare$5(n, c, u) !== 0;
var neq_1 = neq$2;
const compare$4 = compare_1, gte$3 = (n, c, u) => compare$4(n, c, u) >= 0;
var gte_1 = gte$3;
const compare$3 = compare_1, lte$3 = (n, c, u) => compare$3(n, c, u) <= 0;
var lte_1 = lte$3;
const eq$1 = eq_1, neq$1 = neq_1, gt$3 = gt_1, gte$2 = gte_1, lt$2 = lt_1, lte$2 = lte_1, cmp$1 = (n, c, u, p) => {
  switch (c) {
    case "===":
      return typeof n == "object" && (n = n.version), typeof u == "object" && (u = u.version), n === u;
    case "!==":
      return typeof n == "object" && (n = n.version), typeof u == "object" && (u = u.version), n !== u;
    case "":
    case "=":
    case "==":
      return eq$1(n, u, p);
    case "!=":
      return neq$1(n, u, p);
    case ">":
      return gt$3(n, u, p);
    case ">=":
      return gte$2(n, u, p);
    case "<":
      return lt$2(n, u, p);
    case "<=":
      return lte$2(n, u, p);
    default:
      throw new TypeError(`Invalid operator: ${c}`);
  }
};
var cmp_1 = cmp$1;
const SemVer$5 = semver$2, parse$1 = parse_1, { safeRe: re$1, t } = reExports, coerce$2 = (n, c) => {
  if (n instanceof SemVer$5)
    return n;
  if (typeof n == "number" && (n = String(n)), typeof n != "string")
    return null;
  c = c || {};
  let u = null;
  if (!c.rtl)
    u = n.match(c.includePrerelease ? re$1[t.COERCEFULL] : re$1[t.COERCE]);
  else {
    const le = c.includePrerelease ? re$1[t.COERCERTLFULL] : re$1[t.COERCERTL];
    let L;
    for (; (L = le.exec(n)) && (!u || u.index + u[0].length !== n.length); )
      (!u || L.index + L[0].length !== u.index + u[0].length) && (u = L), le.lastIndex = L.index + L[1].length + L[2].length;
    le.lastIndex = -1;
  }
  if (u === null)
    return null;
  const p = u[2], a = u[3] || "0", A = u[4] || "0", b = c.includePrerelease && u[5] ? `-${u[5]}` : "", F = c.includePrerelease && u[6] ? `+${u[6]}` : "";
  return parse$1(`${p}.${a}.${A}${b}${F}`, c);
};
var coerce_1 = coerce$2;
class LRUCache {
  constructor() {
    this.max = 1e3, this.map = /* @__PURE__ */ new Map();
  }
  get(c) {
    const u = this.map.get(c);
    if (u !== void 0)
      return this.map.delete(c), this.map.set(c, u), u;
  }
  delete(c) {
    return this.map.delete(c);
  }
  set(c, u) {
    if (!this.delete(c) && u !== void 0) {
      if (this.map.size >= this.max) {
        const a = this.map.keys().next().value;
        this.delete(a);
      }
      this.map.set(c, u);
    }
    return this;
  }
}
var lrucache = LRUCache, range, hasRequiredRange;
function requireRange() {
  if (hasRequiredRange) return range;
  hasRequiredRange = 1;
  const n = /\s+/g;
  class c {
    constructor(ar, yr) {
      if (yr = a(yr), ar instanceof c)
        return ar.loose === !!yr.loose && ar.includePrerelease === !!yr.includePrerelease ? ar : new c(ar.raw, yr);
      if (ar instanceof A)
        return this.raw = ar.value, this.set = [[ar]], this.formatted = void 0, this;
      if (this.options = yr, this.loose = !!yr.loose, this.includePrerelease = !!yr.includePrerelease, this.raw = ar.trim().replace(n, " "), this.set = this.raw.split("||").map((_r) => this.parseRange(_r.trim())).filter((_r) => _r.length), !this.set.length)
        throw new TypeError(`Invalid SemVer Range: ${this.raw}`);
      if (this.set.length > 1) {
        const _r = this.set[0];
        if (this.set = this.set.filter((Or) => !Pe(Or[0])), this.set.length === 0)
          this.set = [_r];
        else if (this.set.length > 1) {
          for (const Or of this.set)
            if (Or.length === 1 && nr(Or[0])) {
              this.set = [Or];
              break;
            }
        }
      }
      this.formatted = void 0;
    }
    get range() {
      if (this.formatted === void 0) {
        this.formatted = "";
        for (let ar = 0; ar < this.set.length; ar++) {
          ar > 0 && (this.formatted += "||");
          const yr = this.set[ar];
          for (let _r = 0; _r < yr.length; _r++)
            _r > 0 && (this.formatted += " "), this.formatted += yr[_r].toString().trim();
        }
      }
      return this.formatted;
    }
    format() {
      return this.range;
    }
    toString() {
      return this.range;
    }
    parseRange(ar) {
      const _r = ((this.options.includePrerelease && be) | (this.options.loose && He)) + ":" + ar, Or = p.get(_r);
      if (Or)
        return Or;
      const vr = this.options.loose, Te = vr ? le[L.HYPHENRANGELOOSE] : le[L.HYPHENRANGE];
      ar = ar.replace(Te, Ie(this.options.includePrerelease)), b("hyphen replace", ar), ar = ar.replace(le[L.COMPARATORTRIM], pe), b("comparator trim", ar), ar = ar.replace(le[L.TILDETRIM], $), b("tilde trim", ar), ar = ar.replace(le[L.CARETTRIM], Ee), b("caret trim", ar);
      let Cr = ar.split(" ").map((Li) => or(Li, this.options)).join(" ").split(/\s+/).map((Li) => er(Li, this.options));
      vr && (Cr = Cr.filter((Li) => (b("loose invalid filter", Li, this.options), !!Li.match(le[L.COMPARATORLOOSE])))), b("range list", Cr);
      const Hr = /* @__PURE__ */ new Map(), si = Cr.map((Li) => new A(Li, this.options));
      for (const Li of si) {
        if (Pe(Li))
          return [Li];
        Hr.set(Li.value, Li);
      }
      Hr.size > 1 && Hr.has("") && Hr.delete("");
      const ui = [...Hr.values()];
      return p.set(_r, ui), ui;
    }
    intersects(ar, yr) {
      if (!(ar instanceof c))
        throw new TypeError("a Range is required");
      return this.set.some((_r) => ir(_r, yr) && ar.set.some((Or) => ir(Or, yr) && _r.every((vr) => Or.every((Te) => vr.intersects(Te, yr)))));
    }
    // if ANY of the sets match ALL of its comparators, then pass
    test(ar) {
      if (!ar)
        return !1;
      if (typeof ar == "string")
        try {
          ar = new F(ar, this.options);
        } catch {
          return !1;
        }
      for (let yr = 0; yr < this.set.length; yr++)
        if (xe(this.set[yr], ar, this.options))
          return !0;
      return !1;
    }
  }
  range = c;
  const u = lrucache, p = new u(), a = parseOptions_1, A = requireComparator(), b = debug_1, F = semver$2, {
    safeRe: le,
    t: L,
    comparatorTrimReplace: pe,
    tildeTrimReplace: $,
    caretTrimReplace: Ee
  } = reExports, { FLAG_INCLUDE_PRERELEASE: be, FLAG_LOOSE: He } = constants$1, Pe = (rr) => rr.value === "<0.0.0-0", nr = (rr) => rr.value === "", ir = (rr, ar) => {
    let yr = !0;
    const _r = rr.slice();
    let Or = _r.pop();
    for (; yr && _r.length; )
      yr = _r.every((vr) => Or.intersects(vr, ar)), Or = _r.pop();
    return yr;
  }, or = (rr, ar) => (b("comp", rr, ar), rr = kr(rr, ar), b("caret", rr), rr = Ir(rr, ar), b("tildes", rr), rr = tr(rr, ar), b("xrange", rr), rr = Sr(rr, ar), b("stars", rr), rr), lr = (rr) => !rr || rr.toLowerCase() === "x" || rr === "*", Ir = (rr, ar) => rr.trim().split(/\s+/).map((yr) => xr(yr, ar)).join(" "), xr = (rr, ar) => {
    const yr = ar.loose ? le[L.TILDELOOSE] : le[L.TILDE];
    return rr.replace(yr, (_r, Or, vr, Te, Cr) => {
      b("tilde", rr, _r, Or, vr, Te, Cr);
      let Hr;
      return lr(Or) ? Hr = "" : lr(vr) ? Hr = `>=${Or}.0.0 <${+Or + 1}.0.0-0` : lr(Te) ? Hr = `>=${Or}.${vr}.0 <${Or}.${+vr + 1}.0-0` : Cr ? (b("replaceTilde pr", Cr), Hr = `>=${Or}.${vr}.${Te}-${Cr} <${Or}.${+vr + 1}.0-0`) : Hr = `>=${Or}.${vr}.${Te} <${Or}.${+vr + 1}.0-0`, b("tilde return", Hr), Hr;
    });
  }, kr = (rr, ar) => rr.trim().split(/\s+/).map((yr) => Ce(yr, ar)).join(" "), Ce = (rr, ar) => {
    b("caret", rr, ar);
    const yr = ar.loose ? le[L.CARETLOOSE] : le[L.CARET], _r = ar.includePrerelease ? "-0" : "";
    return rr.replace(yr, (Or, vr, Te, Cr, Hr) => {
      b("caret", rr, Or, vr, Te, Cr, Hr);
      let si;
      return lr(vr) ? si = "" : lr(Te) ? si = `>=${vr}.0.0${_r} <${+vr + 1}.0.0-0` : lr(Cr) ? vr === "0" ? si = `>=${vr}.${Te}.0${_r} <${vr}.${+Te + 1}.0-0` : si = `>=${vr}.${Te}.0${_r} <${+vr + 1}.0.0-0` : Hr ? (b("replaceCaret pr", Hr), vr === "0" ? Te === "0" ? si = `>=${vr}.${Te}.${Cr}-${Hr} <${vr}.${Te}.${+Cr + 1}-0` : si = `>=${vr}.${Te}.${Cr}-${Hr} <${vr}.${+Te + 1}.0-0` : si = `>=${vr}.${Te}.${Cr}-${Hr} <${+vr + 1}.0.0-0`) : (b("no pr"), vr === "0" ? Te === "0" ? si = `>=${vr}.${Te}.${Cr}${_r} <${vr}.${Te}.${+Cr + 1}-0` : si = `>=${vr}.${Te}.${Cr}${_r} <${vr}.${+Te + 1}.0-0` : si = `>=${vr}.${Te}.${Cr} <${+vr + 1}.0.0-0`), b("caret return", si), si;
    });
  }, tr = (rr, ar) => (b("replaceXRanges", rr, ar), rr.split(/\s+/).map((yr) => Fe(yr, ar)).join(" ")), Fe = (rr, ar) => {
    rr = rr.trim();
    const yr = ar.loose ? le[L.XRANGELOOSE] : le[L.XRANGE];
    return rr.replace(yr, (_r, Or, vr, Te, Cr, Hr) => {
      b("xRange", rr, _r, Or, vr, Te, Cr, Hr);
      const si = lr(vr), ui = si || lr(Te), Li = ui || lr(Cr), Qi = Li;
      return Or === "=" && Qi && (Or = ""), Hr = ar.includePrerelease ? "-0" : "", si ? Or === ">" || Or === "<" ? _r = "<0.0.0-0" : _r = "*" : Or && Qi ? (ui && (Te = 0), Cr = 0, Or === ">" ? (Or = ">=", ui ? (vr = +vr + 1, Te = 0, Cr = 0) : (Te = +Te + 1, Cr = 0)) : Or === "<=" && (Or = "<", ui ? vr = +vr + 1 : Te = +Te + 1), Or === "<" && (Hr = "-0"), _r = `${Or + vr}.${Te}.${Cr}${Hr}`) : ui ? _r = `>=${vr}.0.0${Hr} <${+vr + 1}.0.0-0` : Li && (_r = `>=${vr}.${Te}.0${Hr} <${vr}.${+Te + 1}.0-0`), b("xRange return", _r), _r;
    });
  }, Sr = (rr, ar) => (b("replaceStars", rr, ar), rr.trim().replace(le[L.STAR], "")), er = (rr, ar) => (b("replaceGTE0", rr, ar), rr.trim().replace(le[ar.includePrerelease ? L.GTE0PRE : L.GTE0], "")), Ie = (rr) => (ar, yr, _r, Or, vr, Te, Cr, Hr, si, ui, Li, Qi) => (lr(_r) ? yr = "" : lr(Or) ? yr = `>=${_r}.0.0${rr ? "-0" : ""}` : lr(vr) ? yr = `>=${_r}.${Or}.0${rr ? "-0" : ""}` : Te ? yr = `>=${yr}` : yr = `>=${yr}${rr ? "-0" : ""}`, lr(si) ? Hr = "" : lr(ui) ? Hr = `<${+si + 1}.0.0-0` : lr(Li) ? Hr = `<${si}.${+ui + 1}.0-0` : Qi ? Hr = `<=${si}.${ui}.${Li}-${Qi}` : rr ? Hr = `<${si}.${ui}.${+Li + 1}-0` : Hr = `<=${Hr}`, `${yr} ${Hr}`.trim()), xe = (rr, ar, yr) => {
    for (let _r = 0; _r < rr.length; _r++)
      if (!rr[_r].test(ar))
        return !1;
    if (ar.prerelease.length && !yr.includePrerelease) {
      for (let _r = 0; _r < rr.length; _r++)
        if (b(rr[_r].semver), rr[_r].semver !== A.ANY && rr[_r].semver.prerelease.length > 0) {
          const Or = rr[_r].semver;
          if (Or.major === ar.major && Or.minor === ar.minor && Or.patch === ar.patch)
            return !0;
        }
      return !1;
    }
    return !0;
  };
  return range;
}
var comparator, hasRequiredComparator;
function requireComparator() {
  if (hasRequiredComparator) return comparator;
  hasRequiredComparator = 1;
  const n = Symbol("SemVer ANY");
  class c {
    static get ANY() {
      return n;
    }
    constructor(pe, $) {
      if ($ = u($), pe instanceof c) {
        if (pe.loose === !!$.loose)
          return pe;
        pe = pe.value;
      }
      pe = pe.trim().split(/\s+/).join(" "), b("comparator", pe, $), this.options = $, this.loose = !!$.loose, this.parse(pe), this.semver === n ? this.value = "" : this.value = this.operator + this.semver.version, b("comp", this);
    }
    parse(pe) {
      const $ = this.options.loose ? p[a.COMPARATORLOOSE] : p[a.COMPARATOR], Ee = pe.match($);
      if (!Ee)
        throw new TypeError(`Invalid comparator: ${pe}`);
      this.operator = Ee[1] !== void 0 ? Ee[1] : "", this.operator === "=" && (this.operator = ""), Ee[2] ? this.semver = new F(Ee[2], this.options.loose) : this.semver = n;
    }
    toString() {
      return this.value;
    }
    test(pe) {
      if (b("Comparator.test", pe, this.options.loose), this.semver === n || pe === n)
        return !0;
      if (typeof pe == "string")
        try {
          pe = new F(pe, this.options);
        } catch {
          return !1;
        }
      return A(pe, this.operator, this.semver, this.options);
    }
    intersects(pe, $) {
      if (!(pe instanceof c))
        throw new TypeError("a Comparator is required");
      return this.operator === "" ? this.value === "" ? !0 : new le(pe.value, $).test(this.value) : pe.operator === "" ? pe.value === "" ? !0 : new le(this.value, $).test(pe.semver) : ($ = u($), $.includePrerelease && (this.value === "<0.0.0-0" || pe.value === "<0.0.0-0") || !$.includePrerelease && (this.value.startsWith("<0.0.0") || pe.value.startsWith("<0.0.0")) ? !1 : !!(this.operator.startsWith(">") && pe.operator.startsWith(">") || this.operator.startsWith("<") && pe.operator.startsWith("<") || this.semver.version === pe.semver.version && this.operator.includes("=") && pe.operator.includes("=") || A(this.semver, "<", pe.semver, $) && this.operator.startsWith(">") && pe.operator.startsWith("<") || A(this.semver, ">", pe.semver, $) && this.operator.startsWith("<") && pe.operator.startsWith(">")));
    }
  }
  comparator = c;
  const u = parseOptions_1, { safeRe: p, t: a } = reExports, A = cmp_1, b = debug_1, F = semver$2, le = requireRange();
  return comparator;
}
const Range$9 = requireRange(), satisfies$4 = (n, c, u) => {
  try {
    c = new Range$9(c, u);
  } catch {
    return !1;
  }
  return c.test(n);
};
var satisfies_1 = satisfies$4;
const Range$8 = requireRange(), toComparators$1 = (n, c) => new Range$8(n, c).set.map((u) => u.map((p) => p.value).join(" ").trim().split(" "));
var toComparators_1 = toComparators$1;
const SemVer$4 = semver$2, Range$7 = requireRange(), maxSatisfying$1 = (n, c, u) => {
  let p = null, a = null, A = null;
  try {
    A = new Range$7(c, u);
  } catch {
    return null;
  }
  return n.forEach((b) => {
    A.test(b) && (!p || a.compare(b) === -1) && (p = b, a = new SemVer$4(p, u));
  }), p;
};
var maxSatisfying_1 = maxSatisfying$1;
const SemVer$3 = semver$2, Range$6 = requireRange(), minSatisfying$1 = (n, c, u) => {
  let p = null, a = null, A = null;
  try {
    A = new Range$6(c, u);
  } catch {
    return null;
  }
  return n.forEach((b) => {
    A.test(b) && (!p || a.compare(b) === 1) && (p = b, a = new SemVer$3(p, u));
  }), p;
};
var minSatisfying_1 = minSatisfying$1;
const SemVer$2 = semver$2, Range$5 = requireRange(), gt$2 = gt_1, minVersion$1 = (n, c) => {
  n = new Range$5(n, c);
  let u = new SemVer$2("0.0.0");
  if (n.test(u) || (u = new SemVer$2("0.0.0-0"), n.test(u)))
    return u;
  u = null;
  for (let p = 0; p < n.set.length; ++p) {
    const a = n.set[p];
    let A = null;
    a.forEach((b) => {
      const F = new SemVer$2(b.semver.version);
      switch (b.operator) {
        case ">":
          F.prerelease.length === 0 ? F.patch++ : F.prerelease.push(0), F.raw = F.format();
        case "":
        case ">=":
          (!A || gt$2(F, A)) && (A = F);
          break;
        case "<":
        case "<=":
          break;
        default:
          throw new Error(`Unexpected operation: ${b.operator}`);
      }
    }), A && (!u || gt$2(u, A)) && (u = A);
  }
  return u && n.test(u) ? u : null;
};
var minVersion_1 = minVersion$1;
const Range$4 = requireRange(), validRange$1 = (n, c) => {
  try {
    return new Range$4(n, c).range || "*";
  } catch {
    return null;
  }
};
var valid$1 = validRange$1;
const SemVer$1 = semver$2, Comparator$2 = requireComparator(), { ANY: ANY$1 } = Comparator$2, Range$3 = requireRange(), satisfies$3 = satisfies_1, gt$1 = gt_1, lt$1 = lt_1, lte$1 = lte_1, gte$1 = gte_1, outside$3 = (n, c, u, p) => {
  n = new SemVer$1(n, p), c = new Range$3(c, p);
  let a, A, b, F, le;
  switch (u) {
    case ">":
      a = gt$1, A = lte$1, b = lt$1, F = ">", le = ">=";
      break;
    case "<":
      a = lt$1, A = gte$1, b = gt$1, F = "<", le = "<=";
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }
  if (satisfies$3(n, c, p))
    return !1;
  for (let L = 0; L < c.set.length; ++L) {
    const pe = c.set[L];
    let $ = null, Ee = null;
    if (pe.forEach((be) => {
      be.semver === ANY$1 && (be = new Comparator$2(">=0.0.0")), $ = $ || be, Ee = Ee || be, a(be.semver, $.semver, p) ? $ = be : b(be.semver, Ee.semver, p) && (Ee = be);
    }), $.operator === F || $.operator === le || (!Ee.operator || Ee.operator === F) && A(n, Ee.semver))
      return !1;
    if (Ee.operator === le && b(n, Ee.semver))
      return !1;
  }
  return !0;
};
var outside_1 = outside$3;
const outside$2 = outside_1, gtr$1 = (n, c, u) => outside$2(n, c, ">", u);
var gtr_1 = gtr$1;
const outside$1 = outside_1, ltr$1 = (n, c, u) => outside$1(n, c, "<", u);
var ltr_1 = ltr$1;
const Range$2 = requireRange(), intersects$1 = (n, c, u) => (n = new Range$2(n, u), c = new Range$2(c, u), n.intersects(c, u));
var intersects_1 = intersects$1;
const satisfies$2 = satisfies_1, compare$2 = compare_1;
var simplify = (n, c, u) => {
  const p = [];
  let a = null, A = null;
  const b = n.sort((pe, $) => compare$2(pe, $, u));
  for (const pe of b)
    satisfies$2(pe, c, u) ? (A = pe, a || (a = pe)) : (A && p.push([a, A]), A = null, a = null);
  a && p.push([a, null]);
  const F = [];
  for (const [pe, $] of p)
    pe === $ ? F.push(pe) : !$ && pe === b[0] ? F.push("*") : $ ? pe === b[0] ? F.push(`<=${$}`) : F.push(`${pe} - ${$}`) : F.push(`>=${pe}`);
  const le = F.join(" || "), L = typeof c.raw == "string" ? c.raw : String(c);
  return le.length < L.length ? le : c;
};
const Range$1 = requireRange(), Comparator$1 = requireComparator(), { ANY } = Comparator$1, satisfies$1 = satisfies_1, compare$1 = compare_1, subset$1 = (n, c, u = {}) => {
  if (n === c)
    return !0;
  n = new Range$1(n, u), c = new Range$1(c, u);
  let p = !1;
  e: for (const a of n.set) {
    for (const A of c.set) {
      const b = simpleSubset(a, A, u);
      if (p = p || b !== null, b)
        continue e;
    }
    if (p)
      return !1;
  }
  return !0;
}, minimumVersionWithPreRelease = [new Comparator$1(">=0.0.0-0")], minimumVersion = [new Comparator$1(">=0.0.0")], simpleSubset = (n, c, u) => {
  if (n === c)
    return !0;
  if (n.length === 1 && n[0].semver === ANY) {
    if (c.length === 1 && c[0].semver === ANY)
      return !0;
    u.includePrerelease ? n = minimumVersionWithPreRelease : n = minimumVersion;
  }
  if (c.length === 1 && c[0].semver === ANY) {
    if (u.includePrerelease)
      return !0;
    c = minimumVersion;
  }
  const p = /* @__PURE__ */ new Set();
  let a, A;
  for (const be of n)
    be.operator === ">" || be.operator === ">=" ? a = higherGT(a, be, u) : be.operator === "<" || be.operator === "<=" ? A = lowerLT(A, be, u) : p.add(be.semver);
  if (p.size > 1)
    return null;
  let b;
  if (a && A) {
    if (b = compare$1(a.semver, A.semver, u), b > 0)
      return null;
    if (b === 0 && (a.operator !== ">=" || A.operator !== "<="))
      return null;
  }
  for (const be of p) {
    if (a && !satisfies$1(be, String(a), u) || A && !satisfies$1(be, String(A), u))
      return null;
    for (const He of c)
      if (!satisfies$1(be, String(He), u))
        return !1;
    return !0;
  }
  let F, le, L, pe, $ = A && !u.includePrerelease && A.semver.prerelease.length ? A.semver : !1, Ee = a && !u.includePrerelease && a.semver.prerelease.length ? a.semver : !1;
  $ && $.prerelease.length === 1 && A.operator === "<" && $.prerelease[0] === 0 && ($ = !1);
  for (const be of c) {
    if (pe = pe || be.operator === ">" || be.operator === ">=", L = L || be.operator === "<" || be.operator === "<=", a) {
      if (Ee && be.semver.prerelease && be.semver.prerelease.length && be.semver.major === Ee.major && be.semver.minor === Ee.minor && be.semver.patch === Ee.patch && (Ee = !1), be.operator === ">" || be.operator === ">=") {
        if (F = higherGT(a, be, u), F === be && F !== a)
          return !1;
      } else if (a.operator === ">=" && !satisfies$1(a.semver, String(be), u))
        return !1;
    }
    if (A) {
      if ($ && be.semver.prerelease && be.semver.prerelease.length && be.semver.major === $.major && be.semver.minor === $.minor && be.semver.patch === $.patch && ($ = !1), be.operator === "<" || be.operator === "<=") {
        if (le = lowerLT(A, be, u), le === be && le !== A)
          return !1;
      } else if (A.operator === "<=" && !satisfies$1(A.semver, String(be), u))
        return !1;
    }
    if (!be.operator && (A || a) && b !== 0)
      return !1;
  }
  return !(a && L && !A && b !== 0 || A && pe && !a && b !== 0 || Ee || $);
}, higherGT = (n, c, u) => {
  if (!n)
    return c;
  const p = compare$1(n.semver, c.semver, u);
  return p > 0 ? n : p < 0 || c.operator === ">" && n.operator === ">=" ? c : n;
}, lowerLT = (n, c, u) => {
  if (!n)
    return c;
  const p = compare$1(n.semver, c.semver, u);
  return p < 0 ? n : p > 0 || c.operator === "<" && n.operator === "<=" ? c : n;
};
var subset_1 = subset$1;
const internalRe = reExports, constants = constants$1, SemVer = semver$2, identifiers = identifiers$1, parse = parse_1, valid = valid_1, clean$1 = clean_1, inc = inc_1, diff = diff_1, major = major_1, minor = minor_1, patch = patch_1, prerelease = prerelease_1, compare = compare_1, rcompare = rcompare_1, compareLoose = compareLoose_1, compareBuild = compareBuild_1, sort = sort_1, rsort = rsort_1, gt = gt_1, lt = lt_1, eq = eq_1, neq = neq_1, gte = gte_1, lte = lte_1, cmp = cmp_1, coerce$1 = coerce_1, Comparator = requireComparator(), Range = requireRange(), satisfies = satisfies_1, toComparators = toComparators_1, maxSatisfying = maxSatisfying_1, minSatisfying = minSatisfying_1, minVersion = minVersion_1, validRange = valid$1, outside = outside_1, gtr = gtr_1, ltr = ltr_1, intersects = intersects_1, simplifyRange = simplify, subset = subset_1;
var semver = {
  parse,
  valid,
  clean: clean$1,
  inc,
  diff,
  major,
  minor,
  patch,
  prerelease,
  compare,
  rcompare,
  compareLoose,
  compareBuild,
  sort,
  rsort,
  gt,
  lt,
  eq,
  neq,
  gte,
  lte,
  cmp,
  coerce: coerce$1,
  Comparator,
  Range,
  satisfies,
  toComparators,
  maxSatisfying,
  minSatisfying,
  minVersion,
  validRange,
  outside,
  gtr,
  ltr,
  intersects,
  simplifyRange,
  subset,
  SemVer,
  re: internalRe.re,
  src: internalRe.src,
  tokens: internalRe.t,
  SEMVER_SPEC_VERSION: constants.SEMVER_SPEC_VERSION,
  RELEASE_TYPES: constants.RELEASE_TYPES,
  compareIdentifiers: identifiers.compareIdentifiers,
  rcompareIdentifiers: identifiers.rcompareIdentifiers
};
const semver$1 = /* @__PURE__ */ getDefaultExportFromCjs(semver);
var DeviceModelId;
(function(n) {
  n.blue = "blue", n.nanoS = "nanoS", n.nanoSP = "nanoSP", n.nanoX = "nanoX", n.stax = "stax", n.europa = "europa";
})(DeviceModelId || (DeviceModelId = {}));
const devices = {
  [DeviceModelId.blue]: {
    id: DeviceModelId.blue,
    productName: "Ledger Blue",
    productIdMM: 0,
    legacyUsbProductId: 0,
    usbOnly: !0,
    memorySize: 480 * 1024,
    masks: [822083584, 822149120],
    getBlockSize: (n) => 4 * 1024
  },
  [DeviceModelId.nanoS]: {
    id: DeviceModelId.nanoS,
    productName: "Ledger Nano S",
    productIdMM: 16,
    legacyUsbProductId: 1,
    usbOnly: !0,
    memorySize: 320 * 1024,
    masks: [823132160],
    getBlockSize: (n) => semver$1.lt(semver$1.coerce(n) ?? "", "2.0.0") ? 4 * 1024 : 2 * 1024
  },
  [DeviceModelId.nanoX]: {
    id: DeviceModelId.nanoX,
    productName: "Ledger Nano X",
    productIdMM: 64,
    legacyUsbProductId: 4,
    usbOnly: !1,
    memorySize: 2 * 1024 * 1024,
    masks: [855638016],
    getBlockSize: (n) => 4 * 1024,
    bluetoothSpec: [
      {
        serviceUuid: "13d63400-2c97-0004-0000-4c6564676572",
        notifyUuid: "13d63400-2c97-0004-0001-4c6564676572",
        writeUuid: "13d63400-2c97-0004-0002-4c6564676572",
        writeCmdUuid: "13d63400-2c97-0004-0003-4c6564676572"
      }
    ]
  },
  [DeviceModelId.nanoSP]: {
    id: DeviceModelId.nanoSP,
    productName: "Ledger Nano S Plus",
    productIdMM: 80,
    legacyUsbProductId: 5,
    usbOnly: !0,
    memorySize: 1533 * 1024,
    masks: [856686592],
    getBlockSize: (n) => 32
  },
  [DeviceModelId.stax]: {
    id: DeviceModelId.stax,
    productName: "Ledger Stax",
    productIdMM: 96,
    legacyUsbProductId: 6,
    usbOnly: !1,
    memorySize: 1533 * 1024,
    masks: [857735168],
    getBlockSize: (n) => 32,
    bluetoothSpec: [
      {
        serviceUuid: "13d63400-2c97-6004-0000-4c6564676572",
        notifyUuid: "13d63400-2c97-6004-0001-4c6564676572",
        writeUuid: "13d63400-2c97-6004-0002-4c6564676572",
        writeCmdUuid: "13d63400-2c97-6004-0003-4c6564676572"
      }
    ]
  },
  [DeviceModelId.europa]: {
    id: DeviceModelId.europa,
    productName: "Ledger Flex",
    productIdMM: 112,
    legacyUsbProductId: 7,
    usbOnly: !1,
    memorySize: 1533 * 1024,
    masks: [858783744],
    getBlockSize: (n) => 32,
    bluetoothSpec: [
      {
        serviceUuid: "13d63400-2c97-3004-0000-4c6564676572",
        notifyUuid: "13d63400-2c97-3004-0001-4c6564676572",
        writeUuid: "13d63400-2c97-3004-0002-4c6564676572",
        writeCmdUuid: "13d63400-2c97-3004-0003-4c6564676572"
      }
    ]
  }
};
DeviceModelId.blue, DeviceModelId.nanoS, DeviceModelId.nanoSP, DeviceModelId.nanoX, DeviceModelId.stax, DeviceModelId.europa;
const devicesList = Object.values(devices), ledgerUSBVendorId = 11415, identifyUSBProductId = (n) => {
  const c = devicesList.find((a) => a.legacyUsbProductId === n);
  if (c)
    return c;
  const u = n >> 8;
  return devicesList.find((a) => a.productIdMM === u);
}, bluetoothServices = [], serviceUuidToInfos = {};
for (const n in devices) {
  const c = devices[n], { bluetoothSpec: u } = c;
  if (u)
    for (let p = 0; p < u.length; p++) {
      const a = u[p];
      bluetoothServices.push(a.serviceUuid), serviceUuidToInfos[a.serviceUuid] = serviceUuidToInfos[a.serviceUuid.replace(/-/g, "")] = {
        deviceModel: c,
        ...a
      };
    }
}
const ledgerDevices$1 = [
  {
    vendorId: ledgerUSBVendorId
  }
], isSupported$1 = () => Promise.resolve(!!(window.navigator && window.navigator.hid)), getHID = () => {
  const { hid: n } = navigator;
  if (!n)
    throw new TransportError("navigator.hid is not supported", "HIDNotSupported");
  return n;
};
async function requestLedgerDevices() {
  const n = await getHID().requestDevice({
    filters: ledgerDevices$1
  });
  return Array.isArray(n) ? n : [n];
}
async function getLedgerDevices$1() {
  return (await getHID().getDevices()).filter((c) => c.vendorId === ledgerUSBVendorId);
}
async function getFirstLedgerDevice$1() {
  const n = await getLedgerDevices$1();
  return n.length > 0 ? n[0] : (await requestLedgerDevices())[0];
}
const Iu = class Iu extends Transport {
  constructor(u) {
    super();
    As(this, "device");
    As(this, "deviceModel");
    As(this, "channel", Math.floor(Math.random() * 65535));
    As(this, "packetSize", 64);
    As(this, "inputs", []);
    As(this, "inputCallback");
    As(this, "read", () => this.inputs.length ? Promise.resolve(this.inputs.shift()) : new Promise((u) => {
      this.inputCallback = u;
    }));
    As(this, "onInputReport", (u) => {
      const p = Buffer$f.from(u.data.buffer);
      this.inputCallback ? (this.inputCallback(p), this.inputCallback = null) : this.inputs.push(p);
    });
    As(this, "_disconnectEmitted", !1);
    As(this, "_emitDisconnect", (u) => {
      this._disconnectEmitted || (this._disconnectEmitted = !0, this.emit("disconnect", u));
    });
    /**
     * Exchange with the device using APDU protocol.
     * @param apdu
     * @returns a promise of apdu response
     */
    As(this, "exchange", async (u) => await this.exchangeAtomicImpl(async () => {
      const { channel: a, packetSize: A } = this;
      log("apdu", "=> " + u.toString("hex"));
      const b = createHIDframing(a, A), F = b.makeBlocks(u);
      for (let pe = 0; pe < F.length; pe++)
        await this.device.sendReport(0, F[pe]);
      let le, L;
      for (; !(le = b.getReducedResult(L)); )
        try {
          const pe = await this.read();
          L = b.reduceResponse(L, pe);
        } catch (pe) {
          if (pe instanceof TransportError && pe.id === "InvalidChannel")
            continue;
          throw pe;
        }
      return log("apdu", "<= " + le.toString("hex")), le;
    }).catch((a) => {
      throw a && a.message && a.message.includes("write") ? (this._emitDisconnect(a), new DisconnectedDeviceDuringOperation(a.message)) : a;
    }));
    this.device = u, this.deviceModel = typeof u.productId == "number" ? identifyUSBProductId(u.productId) : void 0, u.addEventListener("inputreport", this.onInputReport);
  }
  /**
   * Similar to create() except it will always display the device permission (even if some devices are already accepted).
   */
  static async request() {
    const [u] = await requestLedgerDevices();
    return Iu.open(u);
  }
  /**
   * Similar to create() except it will never display the device permission (it returns a Promise<?Transport>, null if it fails to find a device).
   */
  static async openConnected() {
    const u = await getLedgerDevices$1();
    return u.length === 0 ? null : Iu.open(u[0]);
  }
  /**
   * Create a Ledger transport with a HIDDevice
   */
  static async open(u) {
    await u.open();
    const p = new Iu(u), a = (A) => {
      u === A.device && (getHID().removeEventListener("disconnect", a), p._emitDisconnect(new DisconnectedDevice()));
    };
    return getHID().addEventListener("disconnect", a), p;
  }
  /**
   * Release the transport device
   */
  async close() {
    await this.exchangeBusyPromise, this.device.removeEventListener("inputreport", this.onInputReport), await this.device.close();
  }
  setScrambleKey() {
  }
};
/**
 * Check if WebUSB transport is supported.
 */
As(Iu, "isSupported", isSupported$1), /**
 * List the WebUSB devices that was previously authorized by the user.
 */
As(Iu, "list", getLedgerDevices$1), /**
 * Actively listen to WebUSB devices and emit ONE device
 * that was either accepted before, if not it will trigger the native permission UI.
 *
 * Important: it must be called in the context of a UI click!
 */
As(Iu, "listen", (u) => {
  let p = !1;
  getFirstLedgerDevice$1().then((A) => {
    if (!A)
      u.error(new TransportOpenUserCancelled("Access denied to use Ledger device"));
    else if (!p) {
      const b = typeof A.productId == "number" ? identifyUSBProductId(A.productId) : void 0;
      u.next({
        type: "add",
        descriptor: A,
        deviceModel: b
      }), u.complete();
    }
  }, (A) => {
    u.error(new TransportOpenUserCancelled(A.message));
  });
  function a() {
    p = !0;
  }
  return {
    unsubscribe: a
  };
});
let TransportWebHID = Iu;
const ledgerDevices = [
  {
    vendorId: ledgerUSBVendorId
  }
];
async function requestLedgerDevice() {
  return await navigator.usb.requestDevice({
    filters: ledgerDevices
  });
}
async function getLedgerDevices() {
  return (await navigator.usb.getDevices()).filter((c) => c.vendorId === ledgerUSBVendorId);
}
async function getFirstLedgerDevice() {
  const n = await getLedgerDevices();
  return n.length > 0 ? n[0] : requestLedgerDevice();
}
const isSupported = () => Promise.resolve(!!navigator && !!navigator.usb && typeof navigator.usb.getDevices == "function"), configurationValue = 1, endpointNumber = 3, bu = class bu extends Transport {
  constructor(u, p) {
    super();
    As(this, "device");
    As(this, "deviceModel");
    As(this, "channel", Math.floor(Math.random() * 65535));
    As(this, "packetSize", 64);
    As(this, "interfaceNumber");
    As(this, "_disconnectEmitted", !1);
    As(this, "_emitDisconnect", (u) => {
      this._disconnectEmitted || (this._disconnectEmitted = !0, this.emit("disconnect", u));
    });
    this.device = u, this.interfaceNumber = p, this.deviceModel = identifyUSBProductId(u.productId);
  }
  /**
   * Similar to create() except it will always display the device permission (even if some devices are already accepted).
   */
  static async request() {
    const u = await requestLedgerDevice();
    return bu.open(u);
  }
  /**
   * Similar to create() except it will never display the device permission (it returns a Promise<?Transport>, null if it fails to find a device).
   */
  static async openConnected() {
    const u = await getLedgerDevices();
    return u.length === 0 ? null : bu.open(u[0]);
  }
  /**
   * Create a Ledger transport with a USBDevice
   */
  static async open(u) {
    await u.open(), u.configuration === null && await u.selectConfiguration(configurationValue), await gracefullyResetDevice(u);
    const p = u.configurations[0].interfaces.find(({ alternates: F }) => F.some((le) => le.interfaceClass === 255));
    if (!p)
      throw new TransportInterfaceNotAvailable("No WebUSB interface found for your Ledger device. Please upgrade firmware or contact techsupport.");
    const a = p.interfaceNumber;
    try {
      await u.claimInterface(a);
    } catch (F) {
      throw await u.close(), new TransportInterfaceNotAvailable(F.message);
    }
    const A = new bu(u, a), b = (F) => {
      u === F.device && (navigator.usb.removeEventListener("disconnect", b), A._emitDisconnect(new DisconnectedDevice()));
    };
    return navigator.usb.addEventListener("disconnect", b), A;
  }
  /**
   * Release the transport device
   */
  async close() {
    await this.exchangeBusyPromise, await this.device.releaseInterface(this.interfaceNumber), await gracefullyResetDevice(this.device), await this.device.close();
  }
  /**
   * Exchange with the device using APDU protocol.
   * @param apdu
   * @returns a promise of apdu response
   */
  async exchange(u) {
    return await this.exchangeAtomicImpl(async () => {
      const { channel: a, packetSize: A } = this;
      log("apdu", "=> " + u.toString("hex"));
      const b = createHIDframing(a, A), F = b.makeBlocks(u);
      for (let pe = 0; pe < F.length; pe++)
        await this.device.transferOut(endpointNumber, F[pe]);
      let le, L;
      for (; !(le = b.getReducedResult(L)); ) {
        const pe = await this.device.transferIn(endpointNumber, A), $ = Buffer$f.from(pe.data.buffer);
        L = b.reduceResponse(L, $);
      }
      return log("apdu", "<= " + le.toString("hex")), le;
    }).catch((a) => {
      throw a && a.message && a.message.includes("disconnected") ? (this._emitDisconnect(a), new DisconnectedDeviceDuringOperation(a.message)) : a;
    });
  }
  setScrambleKey() {
  }
};
/**
 * Check if WebUSB transport is supported.
 */
As(bu, "isSupported", isSupported), /**
 * List the WebUSB devices that was previously authorized by the user.
 */
As(bu, "list", getLedgerDevices), /**
 * Actively listen to WebUSB devices and emit ONE device
 * that was either accepted before, if not it will trigger the native permission UI.
 *
 * Important: it must be called in the context of a UI click!
 */
As(bu, "listen", (u) => {
  let p = !1;
  getFirstLedgerDevice().then((A) => {
    if (!p) {
      const b = identifyUSBProductId(A.productId);
      u.next({
        type: "add",
        descriptor: A,
        deviceModel: b
      }), u.complete();
    }
  }, (A) => {
    window.DOMException && A instanceof window.DOMException && A.code === 18 ? u.error(new TransportWebUSBGestureRequired(A.message)) : u.error(new TransportOpenUserCancelled(A.message));
  });
  function a() {
    p = !0;
  }
  return {
    unsubscribe: a
  };
});
let TransportWebUSB = bu;
async function gracefullyResetDevice(n) {
  try {
    await n.reset();
  } catch (c) {
    console.warn(c);
  }
}
const _0n$d = /* @__PURE__ */ BigInt(0), _1n$a = /* @__PURE__ */ BigInt(1);
function isBytes$7(n) {
  return n instanceof Uint8Array || ArrayBuffer.isView(n) && n.constructor.name === "Uint8Array";
}
function abytes$3(n) {
  if (!isBytes$7(n))
    throw new Error("Uint8Array expected");
}
function abool(n, c) {
  if (typeof c != "boolean")
    throw new Error(n + " boolean expected, got " + c);
}
function numberToHexUnpadded$1(n) {
  const c = n.toString(16);
  return c.length & 1 ? "0" + c : c;
}
function hexToNumber$1(n) {
  if (typeof n != "string")
    throw new Error("hex string expected, got " + typeof n);
  return n === "" ? _0n$d : BigInt("0x" + n);
}
const hasHexBuiltin$2 = (
  // @ts-ignore
  typeof Uint8Array.from([]).toHex == "function" && typeof Uint8Array.fromHex == "function"
), hexes$1 = /* @__PURE__ */ Array.from({ length: 256 }, (n, c) => c.toString(16).padStart(2, "0"));
function bytesToHex$3(n) {
  if (abytes$3(n), hasHexBuiltin$2)
    return n.toHex();
  let c = "";
  for (let u = 0; u < n.length; u++)
    c += hexes$1[n[u]];
  return c;
}
const asciis = { _0: 48, _9: 57, A: 65, F: 70, a: 97, f: 102 };
function asciiToBase16(n) {
  if (n >= asciis._0 && n <= asciis._9)
    return n - asciis._0;
  if (n >= asciis.A && n <= asciis.F)
    return n - (asciis.A - 10);
  if (n >= asciis.a && n <= asciis.f)
    return n - (asciis.a - 10);
}
function hexToBytes$3(n) {
  if (typeof n != "string")
    throw new Error("hex string expected, got " + typeof n);
  if (hasHexBuiltin$2)
    return Uint8Array.fromHex(n);
  const c = n.length, u = c / 2;
  if (c % 2)
    throw new Error("hex string expected, got unpadded hex of length " + c);
  const p = new Uint8Array(u);
  for (let a = 0, A = 0; a < u; a++, A += 2) {
    const b = asciiToBase16(n.charCodeAt(A)), F = asciiToBase16(n.charCodeAt(A + 1));
    if (b === void 0 || F === void 0) {
      const le = n[A] + n[A + 1];
      throw new Error('hex string expected, got non-hex character "' + le + '" at index ' + A);
    }
    p[a] = b * 16 + F;
  }
  return p;
}
function bytesToNumberBE$1(n) {
  return hexToNumber$1(bytesToHex$3(n));
}
function bytesToNumberLE$1(n) {
  return abytes$3(n), hexToNumber$1(bytesToHex$3(Uint8Array.from(n).reverse()));
}
function numberToBytesBE$1(n, c) {
  return hexToBytes$3(n.toString(16).padStart(c * 2, "0"));
}
function numberToBytesLE$1(n, c) {
  return numberToBytesBE$1(n, c).reverse();
}
function ensureBytes$1(n, c, u) {
  let p;
  if (typeof c == "string")
    try {
      p = hexToBytes$3(c);
    } catch (A) {
      throw new Error(n + " must be hex string or Uint8Array, cause: " + A);
    }
  else if (isBytes$7(c))
    p = Uint8Array.from(c);
  else
    throw new Error(n + " must be hex string or Uint8Array");
  const a = p.length;
  if (typeof u == "number" && a !== u)
    throw new Error(n + " of length " + u + " expected, got " + a);
  return p;
}
function concatBytes$4(...n) {
  let c = 0;
  for (let p = 0; p < n.length; p++) {
    const a = n[p];
    abytes$3(a), c += a.length;
  }
  const u = new Uint8Array(c);
  for (let p = 0, a = 0; p < n.length; p++) {
    const A = n[p];
    u.set(A, a), a += A.length;
  }
  return u;
}
const isPosBig = (n) => typeof n == "bigint" && _0n$d <= n;
function inRange(n, c, u) {
  return isPosBig(n) && isPosBig(c) && isPosBig(u) && c <= n && n < u;
}
function aInRange(n, c, u, p) {
  if (!inRange(c, u, p))
    throw new Error("expected valid " + n + ": " + u + " <= n < " + p + ", got " + c);
}
function bitLen$1(n) {
  let c;
  for (c = 0; n > _0n$d; n >>= _1n$a, c += 1)
    ;
  return c;
}
const bitMask$1 = (n) => (_1n$a << BigInt(n)) - _1n$a, u8n$1 = (n) => new Uint8Array(n), u8fr$1 = (n) => Uint8Array.from(n);
function createHmacDrbg$1(n, c, u) {
  if (typeof n != "number" || n < 2)
    throw new Error("hashLen must be a number");
  if (typeof c != "number" || c < 2)
    throw new Error("qByteLen must be a number");
  if (typeof u != "function")
    throw new Error("hmacFn must be a function");
  let p = u8n$1(n), a = u8n$1(n), A = 0;
  const b = () => {
    p.fill(1), a.fill(0), A = 0;
  }, F = (...$) => u(a, p, ...$), le = ($ = u8n$1(0)) => {
    a = F(u8fr$1([0]), $), p = F(), $.length !== 0 && (a = F(u8fr$1([1]), $), p = F());
  }, L = () => {
    if (A++ >= 1e3)
      throw new Error("drbg: tried 1000 values");
    let $ = 0;
    const Ee = [];
    for (; $ < c; ) {
      p = F();
      const be = p.slice();
      Ee.push(be), $ += p.length;
    }
    return concatBytes$4(...Ee);
  };
  return ($, Ee) => {
    b(), le($);
    let be;
    for (; !(be = Ee(L())); )
      le();
    return b(), be;
  };
}
const validatorFns$1 = {
  bigint: (n) => typeof n == "bigint",
  function: (n) => typeof n == "function",
  boolean: (n) => typeof n == "boolean",
  string: (n) => typeof n == "string",
  stringOrUint8Array: (n) => typeof n == "string" || isBytes$7(n),
  isSafeInteger: (n) => Number.isSafeInteger(n),
  array: (n) => Array.isArray(n),
  field: (n, c) => c.Fp.isValid(n),
  hash: (n) => typeof n == "function" && Number.isSafeInteger(n.outputLen)
};
function validateObject$1(n, c, u = {}) {
  const p = (a, A, b) => {
    const F = validatorFns$1[A];
    if (typeof F != "function")
      throw new Error("invalid validator function");
    const le = n[a];
    if (!(b && le === void 0) && !F(le, n))
      throw new Error("param " + String(a) + " is invalid. Expected " + A + ", got " + le);
  };
  for (const [a, A] of Object.entries(c))
    p(a, A, !1);
  for (const [a, A] of Object.entries(u))
    p(a, A, !0);
  return n;
}
function memoized(n) {
  const c = /* @__PURE__ */ new WeakMap();
  return (u, ...p) => {
    const a = c.get(u);
    if (a !== void 0)
      return a;
    const A = n(u, ...p);
    return c.set(u, A), A;
  };
}
const _0n$c = BigInt(0), _1n$9 = BigInt(1), _2n$6 = /* @__PURE__ */ BigInt(2), _3n$4 = /* @__PURE__ */ BigInt(3), _4n$4 = /* @__PURE__ */ BigInt(4), _5n$1 = /* @__PURE__ */ BigInt(5), _8n$1 = /* @__PURE__ */ BigInt(8);
function mod$1(n, c) {
  const u = n % c;
  return u >= _0n$c ? u : c + u;
}
function pow2$1(n, c, u) {
  let p = n;
  for (; c-- > _0n$c; )
    p *= p, p %= u;
  return p;
}
function invert$1(n, c) {
  if (n === _0n$c)
    throw new Error("invert: expected non-zero number");
  if (c <= _0n$c)
    throw new Error("invert: expected positive modulus, got " + c);
  let u = mod$1(n, c), p = c, a = _0n$c, A = _1n$9;
  for (; u !== _0n$c; ) {
    const F = p / u, le = p % u, L = a - A * F;
    p = u, u = le, a = A, A = L;
  }
  if (p !== _1n$9)
    throw new Error("invert: does not exist");
  return mod$1(a, c);
}
function sqrt3mod4(n, c) {
  const u = (n.ORDER + _1n$9) / _4n$4, p = n.pow(c, u);
  if (!n.eql(n.sqr(p), c))
    throw new Error("Cannot find square root");
  return p;
}
function sqrt5mod8(n, c) {
  const u = (n.ORDER - _5n$1) / _8n$1, p = n.mul(c, _2n$6), a = n.pow(p, u), A = n.mul(c, a), b = n.mul(n.mul(A, _2n$6), a), F = n.mul(A, n.sub(b, n.ONE));
  if (!n.eql(n.sqr(F), c))
    throw new Error("Cannot find square root");
  return F;
}
function tonelliShanks$1(n) {
  if (n < BigInt(3))
    throw new Error("sqrt is not defined for small field");
  let c = n - _1n$9, u = 0;
  for (; c % _2n$6 === _0n$c; )
    c /= _2n$6, u++;
  let p = _2n$6;
  const a = Field$2(n);
  for (; FpLegendre(a, p) === 1; )
    if (p++ > 1e3)
      throw new Error("Cannot find square root: probably non-prime P");
  if (u === 1)
    return sqrt3mod4;
  let A = a.pow(p, c);
  const b = (c + _1n$9) / _2n$6;
  return function(le, L) {
    if (le.is0(L))
      return L;
    if (FpLegendre(le, L) !== 1)
      throw new Error("Cannot find square root");
    let pe = u, $ = le.mul(le.ONE, A), Ee = le.pow(L, c), be = le.pow(L, b);
    for (; !le.eql(Ee, le.ONE); ) {
      if (le.is0(Ee))
        return le.ZERO;
      let He = 1, Pe = le.sqr(Ee);
      for (; !le.eql(Pe, le.ONE); )
        if (He++, Pe = le.sqr(Pe), He === pe)
          throw new Error("Cannot find square root");
      const nr = _1n$9 << BigInt(pe - He - 1), ir = le.pow($, nr);
      pe = He, $ = le.sqr(ir), Ee = le.mul(Ee, $), be = le.mul(be, ir);
    }
    return be;
  };
}
function FpSqrt$1(n) {
  return n % _4n$4 === _3n$4 ? sqrt3mod4 : n % _8n$1 === _5n$1 ? sqrt5mod8 : tonelliShanks$1(n);
}
const FIELD_FIELDS$1 = [
  "create",
  "isValid",
  "is0",
  "neg",
  "inv",
  "sqrt",
  "sqr",
  "eql",
  "add",
  "sub",
  "mul",
  "pow",
  "div",
  "addN",
  "subN",
  "mulN",
  "sqrN"
];
function validateField$1(n) {
  const c = {
    ORDER: "bigint",
    MASK: "bigint",
    BYTES: "isSafeInteger",
    BITS: "isSafeInteger"
  }, u = FIELD_FIELDS$1.reduce((p, a) => (p[a] = "function", p), c);
  return validateObject$1(n, u);
}
function FpPow$1(n, c, u) {
  if (u < _0n$c)
    throw new Error("invalid exponent, negatives unsupported");
  if (u === _0n$c)
    return n.ONE;
  if (u === _1n$9)
    return c;
  let p = n.ONE, a = c;
  for (; u > _0n$c; )
    u & _1n$9 && (p = n.mul(p, a)), a = n.sqr(a), u >>= _1n$9;
  return p;
}
function FpInvertBatch$1(n, c, u = !1) {
  const p = new Array(c.length).fill(u ? n.ZERO : void 0), a = c.reduce((b, F, le) => n.is0(F) ? b : (p[le] = b, n.mul(b, F)), n.ONE), A = n.inv(a);
  return c.reduceRight((b, F, le) => n.is0(F) ? b : (p[le] = n.mul(b, p[le]), n.mul(b, F)), A), p;
}
function FpLegendre(n, c) {
  const u = (n.ORDER - _1n$9) / _2n$6, p = n.pow(c, u), a = n.eql(p, n.ONE), A = n.eql(p, n.ZERO), b = n.eql(p, n.neg(n.ONE));
  if (!a && !A && !b)
    throw new Error("invalid Legendre symbol result");
  return a ? 1 : A ? 0 : -1;
}
function nLength$1(n, c) {
  c !== void 0 && utils$O.anumber(c);
  const u = c !== void 0 ? c : n.toString(2).length, p = Math.ceil(u / 8);
  return { nBitLength: u, nByteLength: p };
}
function Field$2(n, c, u = !1, p = {}) {
  if (n <= _0n$c)
    throw new Error("invalid field: expected ORDER > 0, got " + n);
  const { nBitLength: a, nByteLength: A } = nLength$1(n, c);
  if (A > 2048)
    throw new Error("invalid field: expected ORDER of <= 2048 bytes");
  let b;
  const F = Object.freeze({
    ORDER: n,
    isLE: u,
    BITS: a,
    BYTES: A,
    MASK: bitMask$1(a),
    ZERO: _0n$c,
    ONE: _1n$9,
    create: (le) => mod$1(le, n),
    isValid: (le) => {
      if (typeof le != "bigint")
        throw new Error("invalid field element: expected bigint, got " + typeof le);
      return _0n$c <= le && le < n;
    },
    is0: (le) => le === _0n$c,
    isOdd: (le) => (le & _1n$9) === _1n$9,
    neg: (le) => mod$1(-le, n),
    eql: (le, L) => le === L,
    sqr: (le) => mod$1(le * le, n),
    add: (le, L) => mod$1(le + L, n),
    sub: (le, L) => mod$1(le - L, n),
    mul: (le, L) => mod$1(le * L, n),
    pow: (le, L) => FpPow$1(F, le, L),
    div: (le, L) => mod$1(le * invert$1(L, n), n),
    // Same as above, but doesn't normalize
    sqrN: (le) => le * le,
    addN: (le, L) => le + L,
    subN: (le, L) => le - L,
    mulN: (le, L) => le * L,
    inv: (le) => invert$1(le, n),
    sqrt: p.sqrt || ((le) => (b || (b = FpSqrt$1(n)), b(F, le))),
    toBytes: (le) => u ? numberToBytesLE$1(le, A) : numberToBytesBE$1(le, A),
    fromBytes: (le) => {
      if (le.length !== A)
        throw new Error("Field.fromBytes: expected " + A + " bytes, got " + le.length);
      return u ? bytesToNumberLE$1(le) : bytesToNumberBE$1(le);
    },
    // TODO: we don't need it here, move out to separate fn
    invertBatch: (le) => FpInvertBatch$1(F, le),
    // We can't move this out because Fp6, Fp12 implement it
    // and it's unclear what to return in there.
    cmov: (le, L, pe) => pe ? L : le
  });
  return Object.freeze(F);
}
function getFieldBytesLength(n) {
  if (typeof n != "bigint")
    throw new Error("field order must be bigint");
  const c = n.toString(2).length;
  return Math.ceil(c / 8);
}
function getMinHashLength(n) {
  const c = getFieldBytesLength(n);
  return c + Math.ceil(c / 2);
}
function mapHashToField(n, c, u = !1) {
  const p = n.length, a = getFieldBytesLength(c), A = getMinHashLength(c);
  if (p < 16 || p < A || p > 1024)
    throw new Error("expected " + A + "-1024 bytes of input, got " + p);
  const b = u ? bytesToNumberLE$1(n) : bytesToNumberBE$1(n), F = mod$1(b, c - _1n$9) + _1n$9;
  return u ? numberToBytesLE$1(F, a) : numberToBytesBE$1(F, a);
}
const _0n$b = BigInt(0), _1n$8 = BigInt(1);
function constTimeNegate(n, c) {
  const u = c.negate();
  return n ? u : c;
}
function validateW(n, c) {
  if (!Number.isSafeInteger(n) || n <= 0 || n > c)
    throw new Error("invalid window size, expected [1.." + c + "], got W=" + n);
}
function calcWOpts(n, c) {
  validateW(n, c);
  const u = Math.ceil(c / n) + 1, p = 2 ** (n - 1), a = 2 ** n, A = bitMask$1(n), b = BigInt(n);
  return { windows: u, windowSize: p, mask: A, maxNumber: a, shiftBy: b };
}
function calcOffsets(n, c, u) {
  const { windowSize: p, mask: a, maxNumber: A, shiftBy: b } = u;
  let F = Number(n & a), le = n >> b;
  F > p && (F -= A, le += _1n$8);
  const L = c * p, pe = L + Math.abs(F) - 1, $ = F === 0, Ee = F < 0, be = c % 2 !== 0;
  return { nextN: le, offset: pe, isZero: $, isNeg: Ee, isNegF: be, offsetF: L };
}
function validateMSMPoints(n, c) {
  if (!Array.isArray(n))
    throw new Error("array expected");
  n.forEach((u, p) => {
    if (!(u instanceof c))
      throw new Error("invalid point at index " + p);
  });
}
function validateMSMScalars(n, c) {
  if (!Array.isArray(n))
    throw new Error("array of scalars expected");
  n.forEach((u, p) => {
    if (!c.isValid(u))
      throw new Error("invalid scalar at index " + p);
  });
}
const pointPrecomputes = /* @__PURE__ */ new WeakMap(), pointWindowSizes = /* @__PURE__ */ new WeakMap();
function getW(n) {
  return pointWindowSizes.get(n) || 1;
}
function wNAF$1(n, c) {
  return {
    constTimeNegate,
    hasPrecomputes(u) {
      return getW(u) !== 1;
    },
    // non-const time multiplication ladder
    unsafeLadder(u, p, a = n.ZERO) {
      let A = u;
      for (; p > _0n$b; )
        p & _1n$8 && (a = a.add(A)), A = A.double(), p >>= _1n$8;
      return a;
    },
    /**
     * Creates a wNAF precomputation window. Used for caching.
     * Default window size is set by `utils.precompute()` and is equal to 8.
     * Number of precomputed points depends on the curve size:
     * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
     * - 𝑊 is the window size
     * - 𝑛 is the bitlength of the curve order.
     * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
     * @param elm Point instance
     * @param W window size
     * @returns precomputed point tables flattened to a single array
     */
    precomputeWindow(u, p) {
      const { windows: a, windowSize: A } = calcWOpts(p, c), b = [];
      let F = u, le = F;
      for (let L = 0; L < a; L++) {
        le = F, b.push(le);
        for (let pe = 1; pe < A; pe++)
          le = le.add(F), b.push(le);
        F = le.double();
      }
      return b;
    },
    /**
     * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
     * @param W window size
     * @param precomputes precomputed tables
     * @param n scalar (we don't check here, but should be less than curve order)
     * @returns real and fake (for const-time) points
     */
    wNAF(u, p, a) {
      let A = n.ZERO, b = n.BASE;
      const F = calcWOpts(u, c);
      for (let le = 0; le < F.windows; le++) {
        const { nextN: L, offset: pe, isZero: $, isNeg: Ee, isNegF: be, offsetF: He } = calcOffsets(a, le, F);
        a = L, $ ? b = b.add(constTimeNegate(be, p[He])) : A = A.add(constTimeNegate(Ee, p[pe]));
      }
      return { p: A, f: b };
    },
    /**
     * Implements ec unsafe (non const-time) multiplication using precomputed tables and w-ary non-adjacent form.
     * @param W window size
     * @param precomputes precomputed tables
     * @param n scalar (we don't check here, but should be less than curve order)
     * @param acc accumulator point to add result of multiplication
     * @returns point
     */
    wNAFUnsafe(u, p, a, A = n.ZERO) {
      const b = calcWOpts(u, c);
      for (let F = 0; F < b.windows && a !== _0n$b; F++) {
        const { nextN: le, offset: L, isZero: pe, isNeg: $ } = calcOffsets(a, F, b);
        if (a = le, !pe) {
          const Ee = p[L];
          A = A.add($ ? Ee.negate() : Ee);
        }
      }
      return A;
    },
    getPrecomputes(u, p, a) {
      let A = pointPrecomputes.get(p);
      return A || (A = this.precomputeWindow(p, u), u !== 1 && pointPrecomputes.set(p, a(A))), A;
    },
    wNAFCached(u, p, a) {
      const A = getW(u);
      return this.wNAF(A, this.getPrecomputes(A, u, a), p);
    },
    wNAFCachedUnsafe(u, p, a, A) {
      const b = getW(u);
      return b === 1 ? this.unsafeLadder(u, p, A) : this.wNAFUnsafe(b, this.getPrecomputes(b, u, a), p, A);
    },
    // We calculate precomputes for elliptic curve point multiplication
    // using windowed method. This specifies window size and
    // stores precomputed values. Usually only base point would be precomputed.
    setWindowSize(u, p) {
      validateW(p, c), pointWindowSizes.set(u, p), pointPrecomputes.delete(u);
    }
  };
}
function pippenger(n, c, u, p) {
  validateMSMPoints(u, n), validateMSMScalars(p, c);
  const a = u.length, A = p.length;
  if (a !== A)
    throw new Error("arrays of points and scalars must have equal length");
  const b = n.ZERO, F = bitLen$1(BigInt(a));
  let le = 1;
  F > 12 ? le = F - 3 : F > 4 ? le = F - 2 : F > 0 && (le = 2);
  const L = bitMask$1(le), pe = new Array(Number(L) + 1).fill(b), $ = Math.floor((c.BITS - 1) / le) * le;
  let Ee = b;
  for (let be = $; be >= 0; be -= le) {
    pe.fill(b);
    for (let Pe = 0; Pe < A; Pe++) {
      const nr = p[Pe], ir = Number(nr >> BigInt(be) & L);
      pe[ir] = pe[ir].add(u[Pe]);
    }
    let He = b;
    for (let Pe = pe.length - 1, nr = b; Pe > 0; Pe--)
      nr = nr.add(pe[Pe]), He = He.add(nr);
    if (Ee = Ee.add(He), be !== 0)
      for (let Pe = 0; Pe < le; Pe++)
        Ee = Ee.double();
  }
  return Ee;
}
function validateBasic$1(n) {
  return validateField$1(n.Fp), validateObject$1(n, {
    n: "bigint",
    h: "bigint",
    Gx: "field",
    Gy: "field"
  }, {
    nBitLength: "isSafeInteger",
    nByteLength: "isSafeInteger"
  }), Object.freeze({
    ...nLength$1(n.n, n.nBitLength),
    ...n,
    p: n.Fp.ORDER
  });
}
function validateSigVerOpts(n) {
  n.lowS !== void 0 && abool("lowS", n.lowS), n.prehash !== void 0 && abool("prehash", n.prehash);
}
function validatePointOpts$1(n) {
  const c = validateBasic$1(n);
  validateObject$1(c, {
    a: "field",
    b: "field"
  }, {
    allowInfinityPoint: "boolean",
    allowedPrivateKeyLengths: "array",
    clearCofactor: "function",
    fromBytes: "function",
    isTorsionFree: "function",
    toBytes: "function",
    wrapPrivateKey: "boolean"
  });
  const { endo: u, Fp: p, a } = c;
  if (u) {
    if (!p.eql(a, p.ZERO))
      throw new Error("invalid endo: CURVE.a must be 0");
    if (typeof u != "object" || typeof u.beta != "bigint" || typeof u.splitScalar != "function")
      throw new Error('invalid endo: expected "beta": bigint and "splitScalar": function');
  }
  return Object.freeze({ ...c });
}
class DERErr extends Error {
  constructor(c = "") {
    super(c);
  }
}
const DER$1 = {
  // asn.1 DER encoding utils
  Err: DERErr,
  // Basic building block is TLV (Tag-Length-Value)
  _tlv: {
    encode: (n, c) => {
      const { Err: u } = DER$1;
      if (n < 0 || n > 256)
        throw new u("tlv.encode: wrong tag");
      if (c.length & 1)
        throw new u("tlv.encode: unpadded data");
      const p = c.length / 2, a = numberToHexUnpadded$1(p);
      if (a.length / 2 & 128)
        throw new u("tlv.encode: long form length too big");
      const A = p > 127 ? numberToHexUnpadded$1(a.length / 2 | 128) : "";
      return numberToHexUnpadded$1(n) + A + a + c;
    },
    // v - value, l - left bytes (unparsed)
    decode(n, c) {
      const { Err: u } = DER$1;
      let p = 0;
      if (n < 0 || n > 256)
        throw new u("tlv.encode: wrong tag");
      if (c.length < 2 || c[p++] !== n)
        throw new u("tlv.decode: wrong tlv");
      const a = c[p++], A = !!(a & 128);
      let b = 0;
      if (!A)
        b = a;
      else {
        const le = a & 127;
        if (!le)
          throw new u("tlv.decode(long): indefinite length not supported");
        if (le > 4)
          throw new u("tlv.decode(long): byte length is too big");
        const L = c.subarray(p, p + le);
        if (L.length !== le)
          throw new u("tlv.decode: length bytes not complete");
        if (L[0] === 0)
          throw new u("tlv.decode(long): zero leftmost byte");
        for (const pe of L)
          b = b << 8 | pe;
        if (p += le, b < 128)
          throw new u("tlv.decode(long): not minimal encoding");
      }
      const F = c.subarray(p, p + b);
      if (F.length !== b)
        throw new u("tlv.decode: wrong value length");
      return { v: F, l: c.subarray(p + b) };
    }
  },
  // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
  // since we always use positive integers here. It must always be empty:
  // - add zero byte if exists
  // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
  _int: {
    encode(n) {
      const { Err: c } = DER$1;
      if (n < _0n$a)
        throw new c("integer: negative integers are not allowed");
      let u = numberToHexUnpadded$1(n);
      if (Number.parseInt(u[0], 16) & 8 && (u = "00" + u), u.length & 1)
        throw new c("unexpected DER parsing assertion: unpadded hex");
      return u;
    },
    decode(n) {
      const { Err: c } = DER$1;
      if (n[0] & 128)
        throw new c("invalid signature integer: negative");
      if (n[0] === 0 && !(n[1] & 128))
        throw new c("invalid signature integer: unnecessary leading zero");
      return bytesToNumberBE$1(n);
    }
  },
  toSig(n) {
    const { Err: c, _int: u, _tlv: p } = DER$1, a = ensureBytes$1("signature", n), { v: A, l: b } = p.decode(48, a);
    if (b.length)
      throw new c("invalid signature: left bytes after parsing");
    const { v: F, l: le } = p.decode(2, A), { v: L, l: pe } = p.decode(2, le);
    if (pe.length)
      throw new c("invalid signature: left bytes after parsing");
    return { r: u.decode(F), s: u.decode(L) };
  },
  hexFromSig(n) {
    const { _tlv: c, _int: u } = DER$1, p = c.encode(2, u.encode(n.r)), a = c.encode(2, u.encode(n.s)), A = p + a;
    return c.encode(48, A);
  }
};
function numToSizedHex(n, c) {
  return bytesToHex$3(numberToBytesBE$1(n, c));
}
const _0n$a = BigInt(0), _1n$7 = BigInt(1);
BigInt(2);
const _3n$3 = BigInt(3), _4n$3 = BigInt(4);
function weierstrassPoints$1(n) {
  const c = validatePointOpts$1(n), { Fp: u } = c, p = Field$2(c.n, c.nBitLength), a = c.toBytes || ((lr, Ir, xr) => {
    const kr = Ir.toAffine();
    return concatBytes$4(Uint8Array.from([4]), u.toBytes(kr.x), u.toBytes(kr.y));
  }), A = c.fromBytes || ((lr) => {
    const Ir = lr.subarray(1), xr = u.fromBytes(Ir.subarray(0, u.BYTES)), kr = u.fromBytes(Ir.subarray(u.BYTES, 2 * u.BYTES));
    return { x: xr, y: kr };
  });
  function b(lr) {
    const { a: Ir, b: xr } = c, kr = u.sqr(lr), Ce = u.mul(kr, lr);
    return u.add(u.add(Ce, u.mul(lr, Ir)), xr);
  }
  function F(lr, Ir) {
    const xr = u.sqr(Ir), kr = b(lr);
    return u.eql(xr, kr);
  }
  if (!F(c.Gx, c.Gy))
    throw new Error("bad curve params: generator point");
  const le = u.mul(u.pow(c.a, _3n$3), _4n$3), L = u.mul(u.sqr(c.b), BigInt(27));
  if (u.is0(u.add(le, L)))
    throw new Error("bad curve params: a or b");
  function pe(lr) {
    return inRange(lr, _1n$7, c.n);
  }
  function $(lr) {
    const { allowedPrivateKeyLengths: Ir, nByteLength: xr, wrapPrivateKey: kr, n: Ce } = c;
    if (Ir && typeof lr != "bigint") {
      if (isBytes$7(lr) && (lr = bytesToHex$3(lr)), typeof lr != "string" || !Ir.includes(lr.length))
        throw new Error("invalid private key");
      lr = lr.padStart(xr * 2, "0");
    }
    let tr;
    try {
      tr = typeof lr == "bigint" ? lr : bytesToNumberBE$1(ensureBytes$1("private key", lr, xr));
    } catch {
      throw new Error("invalid private key, expected hex or " + xr + " bytes, got " + typeof lr);
    }
    return kr && (tr = mod$1(tr, Ce)), aInRange("private key", tr, _1n$7, Ce), tr;
  }
  function Ee(lr) {
    if (!(lr instanceof Pe))
      throw new Error("ProjectivePoint expected");
  }
  const be = memoized((lr, Ir) => {
    const { px: xr, py: kr, pz: Ce } = lr;
    if (u.eql(Ce, u.ONE))
      return { x: xr, y: kr };
    const tr = lr.is0();
    Ir == null && (Ir = tr ? u.ONE : u.inv(Ce));
    const Fe = u.mul(xr, Ir), Sr = u.mul(kr, Ir), er = u.mul(Ce, Ir);
    if (tr)
      return { x: u.ZERO, y: u.ZERO };
    if (!u.eql(er, u.ONE))
      throw new Error("invZ was invalid");
    return { x: Fe, y: Sr };
  }), He = memoized((lr) => {
    if (lr.is0()) {
      if (c.allowInfinityPoint && !u.is0(lr.py))
        return;
      throw new Error("bad point: ZERO");
    }
    const { x: Ir, y: xr } = lr.toAffine();
    if (!u.isValid(Ir) || !u.isValid(xr))
      throw new Error("bad point: x or y not FE");
    if (!F(Ir, xr))
      throw new Error("bad point: equation left != right");
    if (!lr.isTorsionFree())
      throw new Error("bad point: not in prime-order subgroup");
    return !0;
  });
  class Pe {
    constructor(Ir, xr, kr) {
      if (Ir == null || !u.isValid(Ir))
        throw new Error("x required");
      if (xr == null || !u.isValid(xr) || u.is0(xr))
        throw new Error("y required");
      if (kr == null || !u.isValid(kr))
        throw new Error("z required");
      this.px = Ir, this.py = xr, this.pz = kr, Object.freeze(this);
    }
    // Does not validate if the point is on-curve.
    // Use fromHex instead, or call assertValidity() later.
    static fromAffine(Ir) {
      const { x: xr, y: kr } = Ir || {};
      if (!Ir || !u.isValid(xr) || !u.isValid(kr))
        throw new Error("invalid affine point");
      if (Ir instanceof Pe)
        throw new Error("projective point not allowed");
      const Ce = (tr) => u.eql(tr, u.ZERO);
      return Ce(xr) && Ce(kr) ? Pe.ZERO : new Pe(xr, kr, u.ONE);
    }
    get x() {
      return this.toAffine().x;
    }
    get y() {
      return this.toAffine().y;
    }
    /**
     * Takes a bunch of Projective Points but executes only one
     * inversion on all of them. Inversion is very slow operation,
     * so this improves performance massively.
     * Optimization: converts a list of projective points to a list of identical points with Z=1.
     */
    static normalizeZ(Ir) {
      const xr = FpInvertBatch$1(u, Ir.map((kr) => kr.pz));
      return Ir.map((kr, Ce) => kr.toAffine(xr[Ce])).map(Pe.fromAffine);
    }
    /**
     * Converts hash string or Uint8Array to Point.
     * @param hex short/long ECDSA hex
     */
    static fromHex(Ir) {
      const xr = Pe.fromAffine(A(ensureBytes$1("pointHex", Ir)));
      return xr.assertValidity(), xr;
    }
    // Multiplies generator point by privateKey.
    static fromPrivateKey(Ir) {
      return Pe.BASE.multiply($(Ir));
    }
    // Multiscalar Multiplication
    static msm(Ir, xr) {
      return pippenger(Pe, p, Ir, xr);
    }
    // "Private method", don't use it directly
    _setWindowSize(Ir) {
      or.setWindowSize(this, Ir);
    }
    // A point on curve is valid if it conforms to equation.
    assertValidity() {
      He(this);
    }
    hasEvenY() {
      const { y: Ir } = this.toAffine();
      if (u.isOdd)
        return !u.isOdd(Ir);
      throw new Error("Field doesn't support isOdd");
    }
    /**
     * Compare one point to another.
     */
    equals(Ir) {
      Ee(Ir);
      const { px: xr, py: kr, pz: Ce } = this, { px: tr, py: Fe, pz: Sr } = Ir, er = u.eql(u.mul(xr, Sr), u.mul(tr, Ce)), Ie = u.eql(u.mul(kr, Sr), u.mul(Fe, Ce));
      return er && Ie;
    }
    /**
     * Flips point to one corresponding to (x, -y) in Affine coordinates.
     */
    negate() {
      return new Pe(this.px, u.neg(this.py), this.pz);
    }
    // Renes-Costello-Batina exception-free doubling formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 3
    // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
    double() {
      const { a: Ir, b: xr } = c, kr = u.mul(xr, _3n$3), { px: Ce, py: tr, pz: Fe } = this;
      let Sr = u.ZERO, er = u.ZERO, Ie = u.ZERO, xe = u.mul(Ce, Ce), rr = u.mul(tr, tr), ar = u.mul(Fe, Fe), yr = u.mul(Ce, tr);
      return yr = u.add(yr, yr), Ie = u.mul(Ce, Fe), Ie = u.add(Ie, Ie), Sr = u.mul(Ir, Ie), er = u.mul(kr, ar), er = u.add(Sr, er), Sr = u.sub(rr, er), er = u.add(rr, er), er = u.mul(Sr, er), Sr = u.mul(yr, Sr), Ie = u.mul(kr, Ie), ar = u.mul(Ir, ar), yr = u.sub(xe, ar), yr = u.mul(Ir, yr), yr = u.add(yr, Ie), Ie = u.add(xe, xe), xe = u.add(Ie, xe), xe = u.add(xe, ar), xe = u.mul(xe, yr), er = u.add(er, xe), ar = u.mul(tr, Fe), ar = u.add(ar, ar), xe = u.mul(ar, yr), Sr = u.sub(Sr, xe), Ie = u.mul(ar, rr), Ie = u.add(Ie, Ie), Ie = u.add(Ie, Ie), new Pe(Sr, er, Ie);
    }
    // Renes-Costello-Batina exception-free addition formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 1
    // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
    add(Ir) {
      Ee(Ir);
      const { px: xr, py: kr, pz: Ce } = this, { px: tr, py: Fe, pz: Sr } = Ir;
      let er = u.ZERO, Ie = u.ZERO, xe = u.ZERO;
      const rr = c.a, ar = u.mul(c.b, _3n$3);
      let yr = u.mul(xr, tr), _r = u.mul(kr, Fe), Or = u.mul(Ce, Sr), vr = u.add(xr, kr), Te = u.add(tr, Fe);
      vr = u.mul(vr, Te), Te = u.add(yr, _r), vr = u.sub(vr, Te), Te = u.add(xr, Ce);
      let Cr = u.add(tr, Sr);
      return Te = u.mul(Te, Cr), Cr = u.add(yr, Or), Te = u.sub(Te, Cr), Cr = u.add(kr, Ce), er = u.add(Fe, Sr), Cr = u.mul(Cr, er), er = u.add(_r, Or), Cr = u.sub(Cr, er), xe = u.mul(rr, Te), er = u.mul(ar, Or), xe = u.add(er, xe), er = u.sub(_r, xe), xe = u.add(_r, xe), Ie = u.mul(er, xe), _r = u.add(yr, yr), _r = u.add(_r, yr), Or = u.mul(rr, Or), Te = u.mul(ar, Te), _r = u.add(_r, Or), Or = u.sub(yr, Or), Or = u.mul(rr, Or), Te = u.add(Te, Or), yr = u.mul(_r, Te), Ie = u.add(Ie, yr), yr = u.mul(Cr, Te), er = u.mul(vr, er), er = u.sub(er, yr), yr = u.mul(vr, _r), xe = u.mul(Cr, xe), xe = u.add(xe, yr), new Pe(er, Ie, xe);
    }
    subtract(Ir) {
      return this.add(Ir.negate());
    }
    is0() {
      return this.equals(Pe.ZERO);
    }
    wNAF(Ir) {
      return or.wNAFCached(this, Ir, Pe.normalizeZ);
    }
    /**
     * Non-constant-time multiplication. Uses double-and-add algorithm.
     * It's faster, but should only be used when you don't care about
     * an exposed private key e.g. sig verification, which works over *public* keys.
     */
    multiplyUnsafe(Ir) {
      const { endo: xr, n: kr } = c;
      aInRange("scalar", Ir, _0n$a, kr);
      const Ce = Pe.ZERO;
      if (Ir === _0n$a)
        return Ce;
      if (this.is0() || Ir === _1n$7)
        return this;
      if (!xr || or.hasPrecomputes(this))
        return or.wNAFCachedUnsafe(this, Ir, Pe.normalizeZ);
      let { k1neg: tr, k1: Fe, k2neg: Sr, k2: er } = xr.splitScalar(Ir), Ie = Ce, xe = Ce, rr = this;
      for (; Fe > _0n$a || er > _0n$a; )
        Fe & _1n$7 && (Ie = Ie.add(rr)), er & _1n$7 && (xe = xe.add(rr)), rr = rr.double(), Fe >>= _1n$7, er >>= _1n$7;
      return tr && (Ie = Ie.negate()), Sr && (xe = xe.negate()), xe = new Pe(u.mul(xe.px, xr.beta), xe.py, xe.pz), Ie.add(xe);
    }
    /**
     * Constant time multiplication.
     * Uses wNAF method. Windowed method may be 10% faster,
     * but takes 2x longer to generate and consumes 2x memory.
     * Uses precomputes when available.
     * Uses endomorphism for Koblitz curves.
     * @param scalar by which the point would be multiplied
     * @returns New point
     */
    multiply(Ir) {
      const { endo: xr, n: kr } = c;
      aInRange("scalar", Ir, _1n$7, kr);
      let Ce, tr;
      if (xr) {
        const { k1neg: Fe, k1: Sr, k2neg: er, k2: Ie } = xr.splitScalar(Ir);
        let { p: xe, f: rr } = this.wNAF(Sr), { p: ar, f: yr } = this.wNAF(Ie);
        xe = or.constTimeNegate(Fe, xe), ar = or.constTimeNegate(er, ar), ar = new Pe(u.mul(ar.px, xr.beta), ar.py, ar.pz), Ce = xe.add(ar), tr = rr.add(yr);
      } else {
        const { p: Fe, f: Sr } = this.wNAF(Ir);
        Ce = Fe, tr = Sr;
      }
      return Pe.normalizeZ([Ce, tr])[0];
    }
    /**
     * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
     * Not using Strauss-Shamir trick: precomputation tables are faster.
     * The trick could be useful if both P and Q are not G (not in our case).
     * @returns non-zero affine point
     */
    multiplyAndAddUnsafe(Ir, xr, kr) {
      const Ce = Pe.BASE, tr = (Sr, er) => er === _0n$a || er === _1n$7 || !Sr.equals(Ce) ? Sr.multiplyUnsafe(er) : Sr.multiply(er), Fe = tr(this, xr).add(tr(Ir, kr));
      return Fe.is0() ? void 0 : Fe;
    }
    // Converts Projective point to affine (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    // (x, y, z) ∋ (x=x/z, y=y/z)
    toAffine(Ir) {
      return be(this, Ir);
    }
    isTorsionFree() {
      const { h: Ir, isTorsionFree: xr } = c;
      if (Ir === _1n$7)
        return !0;
      if (xr)
        return xr(Pe, this);
      throw new Error("isTorsionFree() has not been declared for the elliptic curve");
    }
    clearCofactor() {
      const { h: Ir, clearCofactor: xr } = c;
      return Ir === _1n$7 ? this : xr ? xr(Pe, this) : this.multiplyUnsafe(c.h);
    }
    toRawBytes(Ir = !0) {
      return abool("isCompressed", Ir), this.assertValidity(), a(Pe, this, Ir);
    }
    toHex(Ir = !0) {
      return abool("isCompressed", Ir), bytesToHex$3(this.toRawBytes(Ir));
    }
  }
  Pe.BASE = new Pe(c.Gx, c.Gy, u.ONE), Pe.ZERO = new Pe(u.ZERO, u.ONE, u.ZERO);
  const { endo: nr, nBitLength: ir } = c, or = wNAF$1(Pe, nr ? Math.ceil(ir / 2) : ir);
  return {
    CURVE: c,
    ProjectivePoint: Pe,
    normPrivateKeyToScalar: $,
    weierstrassEquation: b,
    isWithinCurveOrder: pe
  };
}
function validateOpts$2(n) {
  const c = validateBasic$1(n);
  return validateObject$1(c, {
    hash: "hash",
    hmac: "function",
    randomBytes: "function"
  }, {
    bits2int: "function",
    bits2int_modN: "function",
    lowS: "boolean"
  }), Object.freeze({ lowS: !0, ...c });
}
function weierstrass$1(n) {
  const c = validateOpts$2(n), { Fp: u, n: p, nByteLength: a, nBitLength: A } = c, b = u.BYTES + 1, F = 2 * u.BYTES + 1;
  function le(ar) {
    return mod$1(ar, p);
  }
  function L(ar) {
    return invert$1(ar, p);
  }
  const { ProjectivePoint: pe, normPrivateKeyToScalar: $, weierstrassEquation: Ee, isWithinCurveOrder: be } = weierstrassPoints$1({
    ...c,
    toBytes(ar, yr, _r) {
      const Or = yr.toAffine(), vr = u.toBytes(Or.x), Te = concatBytes$4;
      return abool("isCompressed", _r), _r ? Te(Uint8Array.from([yr.hasEvenY() ? 2 : 3]), vr) : Te(Uint8Array.from([4]), vr, u.toBytes(Or.y));
    },
    fromBytes(ar) {
      const yr = ar.length, _r = ar[0], Or = ar.subarray(1);
      if (yr === b && (_r === 2 || _r === 3)) {
        const vr = bytesToNumberBE$1(Or);
        if (!inRange(vr, _1n$7, u.ORDER))
          throw new Error("Point is not on curve");
        const Te = Ee(vr);
        let Cr;
        try {
          Cr = u.sqrt(Te);
        } catch (ui) {
          const Li = ui instanceof Error ? ": " + ui.message : "";
          throw new Error("Point is not on curve" + Li);
        }
        const Hr = (Cr & _1n$7) === _1n$7;
        return (_r & 1) === 1 !== Hr && (Cr = u.neg(Cr)), { x: vr, y: Cr };
      } else if (yr === F && _r === 4) {
        const vr = u.fromBytes(Or.subarray(0, u.BYTES)), Te = u.fromBytes(Or.subarray(u.BYTES, 2 * u.BYTES));
        return { x: vr, y: Te };
      } else {
        const vr = b, Te = F;
        throw new Error("invalid Point, expected length of " + vr + ", or uncompressed " + Te + ", got " + yr);
      }
    }
  });
  function He(ar) {
    const yr = p >> _1n$7;
    return ar > yr;
  }
  function Pe(ar) {
    return He(ar) ? le(-ar) : ar;
  }
  const nr = (ar, yr, _r) => bytesToNumberBE$1(ar.slice(yr, _r));
  class ir {
    constructor(yr, _r, Or) {
      aInRange("r", yr, _1n$7, p), aInRange("s", _r, _1n$7, p), this.r = yr, this.s = _r, Or != null && (this.recovery = Or), Object.freeze(this);
    }
    // pair (bytes of r, bytes of s)
    static fromCompact(yr) {
      const _r = a;
      return yr = ensureBytes$1("compactSignature", yr, _r * 2), new ir(nr(yr, 0, _r), nr(yr, _r, 2 * _r));
    }
    // DER encoded ECDSA signature
    // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
    static fromDER(yr) {
      const { r: _r, s: Or } = DER$1.toSig(ensureBytes$1("DER", yr));
      return new ir(_r, Or);
    }
    /**
     * @todo remove
     * @deprecated
     */
    assertValidity() {
    }
    addRecoveryBit(yr) {
      return new ir(this.r, this.s, yr);
    }
    recoverPublicKey(yr) {
      const { r: _r, s: Or, recovery: vr } = this, Te = Ce(ensureBytes$1("msgHash", yr));
      if (vr == null || ![0, 1, 2, 3].includes(vr))
        throw new Error("recovery id invalid");
      const Cr = vr === 2 || vr === 3 ? _r + c.n : _r;
      if (Cr >= u.ORDER)
        throw new Error("recovery id 2 or 3 invalid");
      const Hr = vr & 1 ? "03" : "02", si = pe.fromHex(Hr + numToSizedHex(Cr, u.BYTES)), ui = L(Cr), Li = le(-Te * ui), Qi = le(Or * ui), wi = pe.BASE.multiplyAndAddUnsafe(si, Li, Qi);
      if (!wi)
        throw new Error("point at infinify");
      return wi.assertValidity(), wi;
    }
    // Signatures should be low-s, to prevent malleability.
    hasHighS() {
      return He(this.s);
    }
    normalizeS() {
      return this.hasHighS() ? new ir(this.r, le(-this.s), this.recovery) : this;
    }
    // DER-encoded
    toDERRawBytes() {
      return hexToBytes$3(this.toDERHex());
    }
    toDERHex() {
      return DER$1.hexFromSig(this);
    }
    // padded bytes of r, then padded bytes of s
    toCompactRawBytes() {
      return hexToBytes$3(this.toCompactHex());
    }
    toCompactHex() {
      const yr = a;
      return numToSizedHex(this.r, yr) + numToSizedHex(this.s, yr);
    }
  }
  const or = {
    isValidPrivateKey(ar) {
      try {
        return $(ar), !0;
      } catch {
        return !1;
      }
    },
    normPrivateKeyToScalar: $,
    /**
     * Produces cryptographically secure private key from random of size
     * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
     */
    randomPrivateKey: () => {
      const ar = getMinHashLength(c.n);
      return mapHashToField(c.randomBytes(ar), c.n);
    },
    /**
     * Creates precompute table for an arbitrary EC point. Makes point "cached".
     * Allows to massively speed-up `point.multiply(scalar)`.
     * @returns cached point
     * @example
     * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
     * fast.multiply(privKey); // much faster ECDH now
     */
    precompute(ar = 8, yr = pe.BASE) {
      return yr._setWindowSize(ar), yr.multiply(BigInt(3)), yr;
    }
  };
  function lr(ar, yr = !0) {
    return pe.fromPrivateKey(ar).toRawBytes(yr);
  }
  function Ir(ar) {
    if (typeof ar == "bigint")
      return !1;
    if (ar instanceof pe)
      return !0;
    const _r = ensureBytes$1("key", ar).length, Or = u.BYTES, vr = Or + 1, Te = 2 * Or + 1;
    if (!(c.allowedPrivateKeyLengths || a === vr))
      return _r === vr || _r === Te;
  }
  function xr(ar, yr, _r = !0) {
    if (Ir(ar) === !0)
      throw new Error("first arg must be private key");
    if (Ir(yr) === !1)
      throw new Error("second arg must be public key");
    return pe.fromHex(yr).multiply($(ar)).toRawBytes(_r);
  }
  const kr = c.bits2int || function(ar) {
    if (ar.length > 8192)
      throw new Error("input is too large");
    const yr = bytesToNumberBE$1(ar), _r = ar.length * 8 - A;
    return _r > 0 ? yr >> BigInt(_r) : yr;
  }, Ce = c.bits2int_modN || function(ar) {
    return le(kr(ar));
  }, tr = bitMask$1(A);
  function Fe(ar) {
    return aInRange("num < 2^" + A, ar, _0n$a, tr), numberToBytesBE$1(ar, a);
  }
  function Sr(ar, yr, _r = er) {
    if (["recovered", "canonical"].some((mn) => mn in _r))
      throw new Error("sign() legacy options not supported");
    const { hash: Or, randomBytes: vr } = c;
    let { lowS: Te, prehash: Cr, extraEntropy: Hr } = _r;
    Te == null && (Te = !0), ar = ensureBytes$1("msgHash", ar), validateSigVerOpts(_r), Cr && (ar = ensureBytes$1("prehashed msgHash", Or(ar)));
    const si = Ce(ar), ui = $(yr), Li = [Fe(ui), Fe(si)];
    if (Hr != null && Hr !== !1) {
      const mn = Hr === !0 ? vr(u.BYTES) : Hr;
      Li.push(ensureBytes$1("extraEntropy", mn));
    }
    const Qi = concatBytes$4(...Li), wi = si;
    function Ji(mn) {
      const pi = kr(mn);
      if (!be(pi))
        return;
      const ei = L(pi), Vr = pe.BASE.multiply(pi).toAffine(), qr = le(Vr.x);
      if (qr === _0n$a)
        return;
      const Zi = le(ei * le(wi + qr * ui));
      if (Zi === _0n$a)
        return;
      let Wr = (Vr.x === qr ? 0 : 2) | Number(Vr.y & _1n$7), ri = Zi;
      return Te && He(Zi) && (ri = Pe(Zi), Wr ^= 1), new ir(qr, ri, Wr);
    }
    return { seed: Qi, k2sig: Ji };
  }
  const er = { lowS: c.lowS, prehash: !1 }, Ie = { lowS: c.lowS, prehash: !1 };
  function xe(ar, yr, _r = er) {
    const { seed: Or, k2sig: vr } = Sr(ar, yr, _r), Te = c;
    return createHmacDrbg$1(Te.hash.outputLen, Te.nByteLength, Te.hmac)(Or, vr);
  }
  pe.BASE._setWindowSize(8);
  function rr(ar, yr, _r, Or = Ie) {
    var Wr;
    const vr = ar;
    yr = ensureBytes$1("msgHash", yr), _r = ensureBytes$1("publicKey", _r);
    const { lowS: Te, prehash: Cr, format: Hr } = Or;
    if (validateSigVerOpts(Or), "strict" in Or)
      throw new Error("options.strict was renamed to lowS");
    if (Hr !== void 0 && Hr !== "compact" && Hr !== "der")
      throw new Error("format must be compact or der");
    const si = typeof vr == "string" || isBytes$7(vr), ui = !si && !Hr && typeof vr == "object" && vr !== null && typeof vr.r == "bigint" && typeof vr.s == "bigint";
    if (!si && !ui)
      throw new Error("invalid signature, expected Uint8Array, hex string or Signature instance");
    let Li, Qi;
    try {
      if (ui && (Li = new ir(vr.r, vr.s)), si) {
        try {
          Hr !== "compact" && (Li = ir.fromDER(vr));
        } catch (ri) {
          if (!(ri instanceof DER$1.Err))
            throw ri;
        }
        !Li && Hr !== "der" && (Li = ir.fromCompact(vr));
      }
      Qi = pe.fromHex(_r);
    } catch {
      return !1;
    }
    if (!Li || Te && Li.hasHighS())
      return !1;
    Cr && (yr = c.hash(yr));
    const { r: wi, s: Ji } = Li, mn = Ce(yr), pi = L(Ji), ei = le(mn * pi), Vr = le(wi * pi), qr = (Wr = pe.BASE.multiplyAndAddUnsafe(Qi, ei, Vr)) == null ? void 0 : Wr.toAffine();
    return qr ? le(qr.x) === wi : !1;
  }
  return {
    CURVE: c,
    getPublicKey: lr,
    getSharedSecret: xr,
    sign: xe,
    verify: rr,
    ProjectivePoint: pe,
    Signature: ir,
    utils: or
  };
}
function getHash$1(n) {
  return {
    hash: n,
    hmac: (c, ...u) => hmac$6.hmac(n, c, utils$O.concatBytes(...u)),
    randomBytes: utils$O.randomBytes
  };
}
function createCurve$1(n, c) {
  const u = (p) => weierstrass$1({ ...n, ...getHash$1(p) });
  return { ...u(c), create: u };
}
const secp256k1P$1 = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"), secp256k1N$1 = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), _0n$9 = BigInt(0), _1n$6 = BigInt(1), _2n$5 = BigInt(2), divNearest$1 = (n, c) => (n + c / _2n$5) / c;
function sqrtMod$1(n) {
  const c = secp256k1P$1, u = BigInt(3), p = BigInt(6), a = BigInt(11), A = BigInt(22), b = BigInt(23), F = BigInt(44), le = BigInt(88), L = n * n * n % c, pe = L * L * n % c, $ = pow2$1(pe, u, c) * pe % c, Ee = pow2$1($, u, c) * pe % c, be = pow2$1(Ee, _2n$5, c) * L % c, He = pow2$1(be, a, c) * be % c, Pe = pow2$1(He, A, c) * He % c, nr = pow2$1(Pe, F, c) * Pe % c, ir = pow2$1(nr, le, c) * nr % c, or = pow2$1(ir, F, c) * Pe % c, lr = pow2$1(or, u, c) * pe % c, Ir = pow2$1(lr, b, c) * He % c, xr = pow2$1(Ir, p, c) * L % c, kr = pow2$1(xr, _2n$5, c);
  if (!Fpk1.eql(Fpk1.sqr(kr), n))
    throw new Error("Cannot find square root");
  return kr;
}
const Fpk1 = Field$2(secp256k1P$1, void 0, void 0, { sqrt: sqrtMod$1 }), secp256k1$2 = createCurve$1({
  a: _0n$9,
  b: BigInt(7),
  Fp: Fpk1,
  n: secp256k1N$1,
  Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
  Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
  h: BigInt(1),
  lowS: !0,
  // Allow only low-S signatures by default in sign() and verify()
  endo: {
    // Endomorphism, see above
    beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
    splitScalar: (n) => {
      const c = secp256k1N$1, u = BigInt("0x3086d221a7d46bcde86c90e49284eb15"), p = -_1n$6 * BigInt("0xe4437ed6010e88286f547fa90abfe4c3"), a = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), A = u, b = BigInt("0x100000000000000000000000000000000"), F = divNearest$1(A * n, c), le = divNearest$1(-p * n, c);
      let L = mod$1(n - F * u - le * a, c), pe = mod$1(-F * p - le * A, c);
      const $ = L > b, Ee = pe > b;
      if ($ && (L = c - L), Ee && (pe = c - pe), L > b || pe > b)
        throw new Error("splitScalar: Endomorphism failed, k=" + n);
      return { k1neg: $, k1: L, k2neg: Ee, k2: pe };
    }
  }
}, sha256$f), TAGGED_HASH_PREFIXES$1 = {};
function taggedHash$2(n, ...c) {
  let u = TAGGED_HASH_PREFIXES$1[n];
  if (u === void 0) {
    const p = sha256$f(Uint8Array.from(n, (a) => a.charCodeAt(0)));
    u = concatBytes$4(p, p), TAGGED_HASH_PREFIXES$1[n] = u;
  }
  return sha256$f(concatBytes$4(u, ...c));
}
const pointToBytes$1 = (n) => n.toRawBytes(!0).slice(1), numTo32b$1 = (n) => numberToBytesBE$1(n, 32), modP = (n) => mod$1(n, secp256k1P$1), modN$2 = (n) => mod$1(n, secp256k1N$1), Point$3 = secp256k1$2.ProjectivePoint, GmulAdd$1 = (n, c, u) => Point$3.BASE.multiplyAndAddUnsafe(n, c, u);
function schnorrGetExtPubKey$1(n) {
  let c = secp256k1$2.utils.normPrivateKeyToScalar(n), u = Point$3.fromPrivateKey(c);
  return { scalar: u.hasEvenY() ? c : modN$2(-c), bytes: pointToBytes$1(u) };
}
function lift_x$1(n) {
  aInRange("x", n, _1n$6, secp256k1P$1);
  const c = modP(n * n), u = modP(c * n + BigInt(7));
  let p = sqrtMod$1(u);
  p % _2n$5 !== _0n$9 && (p = modP(-p));
  const a = new Point$3(n, p, _1n$6);
  return a.assertValidity(), a;
}
const num = bytesToNumberBE$1;
function challenge$1(...n) {
  return modN$2(num(taggedHash$2("BIP0340/challenge", ...n)));
}
function schnorrGetPublicKey$1(n) {
  return schnorrGetExtPubKey$1(n).bytes;
}
function schnorrSign$1(n, c, u = utils$O.randomBytes(32)) {
  const p = ensureBytes$1("message", n), { bytes: a, scalar: A } = schnorrGetExtPubKey$1(c), b = ensureBytes$1("auxRand", u, 32), F = numTo32b$1(A ^ num(taggedHash$2("BIP0340/aux", b))), le = taggedHash$2("BIP0340/nonce", F, a, p), L = modN$2(num(le));
  if (L === _0n$9)
    throw new Error("sign failed: k is zero");
  const { bytes: pe, scalar: $ } = schnorrGetExtPubKey$1(L), Ee = challenge$1(pe, a, p), be = new Uint8Array(64);
  if (be.set(pe, 0), be.set(numTo32b$1(modN$2($ + Ee * A)), 32), !schnorrVerify$1(be, p, a))
    throw new Error("sign: Invalid signature produced");
  return be;
}
function schnorrVerify$1(n, c, u) {
  const p = ensureBytes$1("signature", n, 64), a = ensureBytes$1("message", c), A = ensureBytes$1("publicKey", u, 32);
  try {
    const b = lift_x$1(num(A)), F = num(p.subarray(0, 32));
    if (!inRange(F, _1n$6, secp256k1P$1))
      return !1;
    const le = num(p.subarray(32, 64));
    if (!inRange(le, _1n$6, secp256k1N$1))
      return !1;
    const L = challenge$1(numTo32b$1(F), pointToBytes$1(b), a), pe = GmulAdd$1(b, le, modN$2(-L));
    return !(!pe || !pe.hasEvenY() || pe.toAffine().x !== F);
  } catch {
    return !1;
  }
}
const schnorr$1 = {
  getPublicKey: schnorrGetPublicKey$1,
  sign: schnorrSign$1,
  verify: schnorrVerify$1,
  utils: {
    randomPrivateKey: secp256k1$2.utils.randomPrivateKey,
    lift_x: lift_x$1,
    pointToBytes: pointToBytes$1,
    numberToBytesBE: numberToBytesBE$1,
    bytesToNumberBE: bytesToNumberBE$1,
    taggedHash: taggedHash$2,
    mod: mod$1
  }
};
function isBytes$6(n) {
  return n instanceof Uint8Array || ArrayBuffer.isView(n) && n.constructor.name === "Uint8Array";
}
function abytes$2(n, ...c) {
  if (!isBytes$6(n))
    throw new Error("Uint8Array expected");
  if (c.length > 0 && !c.includes(n.length))
    throw new Error("Uint8Array expected of length " + c + ", got length=" + n.length);
}
function aexists(n, c = !0) {
  if (n.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (c && n.finished)
    throw new Error("Hash#digest() has already been called");
}
function aoutput(n, c) {
  abytes$2(n);
  const u = c.outputLen;
  if (n.length < u)
    throw new Error("digestInto() expects output buffer of length at least " + u);
}
function clean(...n) {
  for (let c = 0; c < n.length; c++)
    n[c].fill(0);
}
function createView$5(n) {
  return new DataView(n.buffer, n.byteOffset, n.byteLength);
}
function rotr$4(n, c) {
  return n << 32 - c | n >>> c;
}
function rotl$1(n, c) {
  return n << c | n >>> 32 - c >>> 0;
}
function utf8ToBytes$5(n) {
  if (typeof n != "string")
    throw new Error("string expected");
  return new Uint8Array(new TextEncoder().encode(n));
}
function toBytes$6(n) {
  return typeof n == "string" && (n = utf8ToBytes$5(n)), abytes$2(n), n;
}
let Hash$4 = class {
};
function createHasher$1(n) {
  const c = (p) => n().update(toBytes$6(p)).digest(), u = n();
  return c.outputLen = u.outputLen, c.blockLen = u.blockLen, c.create = () => n(), c;
}
function setBigUint64$4(n, c, u, p) {
  if (typeof n.setBigUint64 == "function")
    return n.setBigUint64(c, u, p);
  const a = BigInt(32), A = BigInt(4294967295), b = Number(u >> a & A), F = Number(u & A), le = p ? 4 : 0, L = p ? 0 : 4;
  n.setUint32(c + le, b, p), n.setUint32(c + L, F, p);
}
function Chi$4(n, c, u) {
  return n & c ^ ~n & u;
}
function Maj$4(n, c, u) {
  return n & c ^ n & u ^ c & u;
}
class HashMD extends Hash$4 {
  constructor(c, u, p, a) {
    super(), this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.blockLen = c, this.outputLen = u, this.padOffset = p, this.isLE = a, this.buffer = new Uint8Array(c), this.view = createView$5(this.buffer);
  }
  update(c) {
    aexists(this), c = toBytes$6(c), abytes$2(c);
    const { view: u, buffer: p, blockLen: a } = this, A = c.length;
    for (let b = 0; b < A; ) {
      const F = Math.min(a - this.pos, A - b);
      if (F === a) {
        const le = createView$5(c);
        for (; a <= A - b; b += a)
          this.process(le, b);
        continue;
      }
      p.set(c.subarray(b, b + F), this.pos), this.pos += F, b += F, this.pos === a && (this.process(u, 0), this.pos = 0);
    }
    return this.length += c.length, this.roundClean(), this;
  }
  digestInto(c) {
    aexists(this), aoutput(c, this), this.finished = !0;
    const { buffer: u, view: p, blockLen: a, isLE: A } = this;
    let { pos: b } = this;
    u[b++] = 128, clean(this.buffer.subarray(b)), this.padOffset > a - b && (this.process(p, 0), b = 0);
    for (let $ = b; $ < a; $++)
      u[$] = 0;
    setBigUint64$4(p, a - 8, BigInt(this.length * 8), A), this.process(p, 0);
    const F = createView$5(c), le = this.outputLen;
    if (le % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const L = le / 4, pe = this.get();
    if (L > pe.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let $ = 0; $ < L; $++)
      F.setUint32(4 * $, pe[$], A);
  }
  digest() {
    const { buffer: c, outputLen: u } = this;
    this.digestInto(c);
    const p = c.slice(0, u);
    return this.destroy(), p;
  }
  _cloneInto(c) {
    c || (c = new this.constructor()), c.set(...this.get());
    const { blockLen: u, buffer: p, length: a, finished: A, destroyed: b, pos: F } = this;
    return c.destroyed = b, c.finished = A, c.length = a, c.pos = F, a % u && c.buffer.set(p), c;
  }
  clone() {
    return this._cloneInto();
  }
}
const SHA256_IV = /* @__PURE__ */ Uint32Array.from([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), Rho160 = /* @__PURE__ */ Uint8Array.from([
  7,
  4,
  13,
  1,
  10,
  6,
  15,
  3,
  12,
  0,
  9,
  5,
  2,
  14,
  11,
  8
]), Id160 = Uint8Array.from(new Array(16).fill(0).map((n, c) => c)), Pi160 = Id160.map((n) => (9 * n + 5) % 16), idxLR = /* @__PURE__ */ (() => {
  const u = [[Id160], [Pi160]];
  for (let p = 0; p < 4; p++)
    for (let a of u)
      a.push(a[p].map((A) => Rho160[A]));
  return u;
})(), idxL$1 = idxLR[0], idxR$1 = idxLR[1], shifts160 = /* @__PURE__ */ [
  [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8],
  [12, 13, 11, 15, 6, 9, 9, 7, 12, 15, 11, 13, 7, 8, 7, 7],
  [13, 15, 14, 11, 7, 7, 6, 8, 13, 14, 13, 12, 5, 5, 6, 9],
  [14, 11, 12, 14, 8, 6, 5, 5, 15, 12, 15, 14, 9, 9, 8, 6],
  [15, 12, 13, 13, 9, 5, 8, 6, 14, 11, 12, 11, 8, 6, 5, 5]
].map((n) => Uint8Array.from(n)), shiftsL160 = /* @__PURE__ */ idxL$1.map((n, c) => n.map((u) => shifts160[c][u])), shiftsR160 = /* @__PURE__ */ idxR$1.map((n, c) => n.map((u) => shifts160[c][u])), Kl160 = /* @__PURE__ */ Uint32Array.from([
  0,
  1518500249,
  1859775393,
  2400959708,
  2840853838
]), Kr160 = /* @__PURE__ */ Uint32Array.from([
  1352829926,
  1548603684,
  1836072691,
  2053994217,
  0
]);
function ripemd_f(n, c, u, p) {
  return n === 0 ? c ^ u ^ p : n === 1 ? c & u | ~c & p : n === 2 ? (c | ~u) ^ p : n === 3 ? c & p | u & ~p : c ^ (u | ~p);
}
const BUF_160 = /* @__PURE__ */ new Uint32Array(16);
let RIPEMD160$1 = class extends HashMD {
  constructor() {
    super(64, 20, 8, !0), this.h0 = 1732584193, this.h1 = -271733879, this.h2 = -1732584194, this.h3 = 271733878, this.h4 = -1009589776;
  }
  get() {
    const { h0: c, h1: u, h2: p, h3: a, h4: A } = this;
    return [c, u, p, a, A];
  }
  set(c, u, p, a, A) {
    this.h0 = c | 0, this.h1 = u | 0, this.h2 = p | 0, this.h3 = a | 0, this.h4 = A | 0;
  }
  process(c, u) {
    for (let be = 0; be < 16; be++, u += 4)
      BUF_160[be] = c.getUint32(u, !0);
    let p = this.h0 | 0, a = p, A = this.h1 | 0, b = A, F = this.h2 | 0, le = F, L = this.h3 | 0, pe = L, $ = this.h4 | 0, Ee = $;
    for (let be = 0; be < 5; be++) {
      const He = 4 - be, Pe = Kl160[be], nr = Kr160[be], ir = idxL$1[be], or = idxR$1[be], lr = shiftsL160[be], Ir = shiftsR160[be];
      for (let xr = 0; xr < 16; xr++) {
        const kr = rotl$1(p + ripemd_f(be, A, F, L) + BUF_160[ir[xr]] + Pe, lr[xr]) + $ | 0;
        p = $, $ = L, L = rotl$1(F, 10) | 0, F = A, A = kr;
      }
      for (let xr = 0; xr < 16; xr++) {
        const kr = rotl$1(a + ripemd_f(He, b, le, pe) + BUF_160[or[xr]] + nr, Ir[xr]) + Ee | 0;
        a = Ee, Ee = pe, pe = rotl$1(le, 10) | 0, le = b, b = kr;
      }
    }
    this.set(this.h1 + F + pe | 0, this.h2 + L + Ee | 0, this.h3 + $ + a | 0, this.h4 + p + b | 0, this.h0 + A + le | 0);
  }
  roundClean() {
    clean(BUF_160);
  }
  destroy() {
    this.destroyed = !0, clean(this.buffer), this.set(0, 0, 0, 0, 0);
  }
};
const ripemd160$1 = /* @__PURE__ */ createHasher$1(() => new RIPEMD160$1()), SHA256_K$4 = /* @__PURE__ */ Uint32Array.from([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), SHA256_W$4 = /* @__PURE__ */ new Uint32Array(64);
let SHA256$4 = class extends HashMD {
  constructor(c = 32) {
    super(64, c, 8, !1), this.A = SHA256_IV[0] | 0, this.B = SHA256_IV[1] | 0, this.C = SHA256_IV[2] | 0, this.D = SHA256_IV[3] | 0, this.E = SHA256_IV[4] | 0, this.F = SHA256_IV[5] | 0, this.G = SHA256_IV[6] | 0, this.H = SHA256_IV[7] | 0;
  }
  get() {
    const { A: c, B: u, C: p, D: a, E: A, F: b, G: F, H: le } = this;
    return [c, u, p, a, A, b, F, le];
  }
  // prettier-ignore
  set(c, u, p, a, A, b, F, le) {
    this.A = c | 0, this.B = u | 0, this.C = p | 0, this.D = a | 0, this.E = A | 0, this.F = b | 0, this.G = F | 0, this.H = le | 0;
  }
  process(c, u) {
    for (let $ = 0; $ < 16; $++, u += 4)
      SHA256_W$4[$] = c.getUint32(u, !1);
    for (let $ = 16; $ < 64; $++) {
      const Ee = SHA256_W$4[$ - 15], be = SHA256_W$4[$ - 2], He = rotr$4(Ee, 7) ^ rotr$4(Ee, 18) ^ Ee >>> 3, Pe = rotr$4(be, 17) ^ rotr$4(be, 19) ^ be >>> 10;
      SHA256_W$4[$] = Pe + SHA256_W$4[$ - 7] + He + SHA256_W$4[$ - 16] | 0;
    }
    let { A: p, B: a, C: A, D: b, E: F, F: le, G: L, H: pe } = this;
    for (let $ = 0; $ < 64; $++) {
      const Ee = rotr$4(F, 6) ^ rotr$4(F, 11) ^ rotr$4(F, 25), be = pe + Ee + Chi$4(F, le, L) + SHA256_K$4[$] + SHA256_W$4[$] | 0, Pe = (rotr$4(p, 2) ^ rotr$4(p, 13) ^ rotr$4(p, 22)) + Maj$4(p, a, A) | 0;
      pe = L, L = le, le = F, F = b + be | 0, b = A, A = a, a = p, p = be + Pe | 0;
    }
    p = p + this.A | 0, a = a + this.B | 0, A = A + this.C | 0, b = b + this.D | 0, F = F + this.E | 0, le = le + this.F | 0, L = L + this.G | 0, pe = pe + this.H | 0, this.set(p, a, A, b, F, le, L, pe);
  }
  roundClean() {
    clean(SHA256_W$4);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), clean(this.buffer);
  }
};
const sha256$5 = /* @__PURE__ */ createHasher$1(() => new SHA256$4());
function isBytes$5(n) {
  return n instanceof Uint8Array || ArrayBuffer.isView(n) && n.constructor.name === "Uint8Array";
}
function abytes$1(n, ...c) {
  if (!isBytes$5(n))
    throw new Error("Uint8Array expected");
  if (c.length > 0 && !c.includes(n.length))
    throw new Error("Uint8Array expected of length " + c + ", got length=" + n.length);
}
function isArrayOf$1(n, c) {
  return Array.isArray(c) ? c.length === 0 ? !0 : n ? c.every((u) => typeof u == "string") : c.every((u) => Number.isSafeInteger(u)) : !1;
}
function afn$1(n) {
  if (typeof n != "function")
    throw new Error("function expected");
  return !0;
}
function astr$1(n, c) {
  if (typeof c != "string")
    throw new Error(`${n}: string expected`);
  return !0;
}
function anumber$1(n) {
  if (!Number.isSafeInteger(n))
    throw new Error(`invalid integer: ${n}`);
}
function aArr$1(n) {
  if (!Array.isArray(n))
    throw new Error("array expected");
}
function astrArr$1(n, c) {
  if (!isArrayOf$1(!0, c))
    throw new Error(`${n}: array of strings expected`);
}
function anumArr$1(n, c) {
  if (!isArrayOf$1(!1, c))
    throw new Error(`${n}: array of numbers expected`);
}
// @__NO_SIDE_EFFECTS__
function chain$1(...n) {
  const c = (A) => A, u = (A, b) => (F) => A(b(F)), p = n.map((A) => A.encode).reduceRight(u, c), a = n.map((A) => A.decode).reduce(u, c);
  return { encode: p, decode: a };
}
// @__NO_SIDE_EFFECTS__
function alphabet$1(n) {
  const c = typeof n == "string" ? n.split("") : n, u = c.length;
  astrArr$1("alphabet", c);
  const p = new Map(c.map((a, A) => [a, A]));
  return {
    encode: (a) => (aArr$1(a), a.map((A) => {
      if (!Number.isSafeInteger(A) || A < 0 || A >= u)
        throw new Error(`alphabet.encode: digit index outside alphabet "${A}". Allowed: ${n}`);
      return c[A];
    })),
    decode: (a) => (aArr$1(a), a.map((A) => {
      astr$1("alphabet.decode", A);
      const b = p.get(A);
      if (b === void 0)
        throw new Error(`Unknown letter: "${A}". Allowed: ${n}`);
      return b;
    }))
  };
}
// @__NO_SIDE_EFFECTS__
function join$1(n = "") {
  return astr$1("join", n), {
    encode: (c) => (astrArr$1("join.decode", c), c.join(n)),
    decode: (c) => (astr$1("join.decode", c), c.split(n))
  };
}
// @__NO_SIDE_EFFECTS__
function normalize$1(n) {
  return afn$1(n), { encode: (c) => c, decode: (c) => n(c) };
}
const gcd$1 = (n, c) => c === 0 ? n : gcd$1(c, n % c), radix2carry$1 = /* @__NO_SIDE_EFFECTS__ */ (n, c) => n + (c - gcd$1(n, c)), powers$1 = /* @__PURE__ */ (() => {
  let n = [];
  for (let c = 0; c < 40; c++)
    n.push(2 ** c);
  return n;
})();
function convertRadix2$1(n, c, u, p) {
  if (aArr$1(n), c <= 0 || c > 32)
    throw new Error(`convertRadix2: wrong from=${c}`);
  if (u <= 0 || u > 32)
    throw new Error(`convertRadix2: wrong to=${u}`);
  if (/* @__PURE__ */ radix2carry$1(c, u) > 32)
    throw new Error(`convertRadix2: carry overflow from=${c} to=${u} carryBits=${/* @__PURE__ */ radix2carry$1(c, u)}`);
  let a = 0, A = 0;
  const b = powers$1[c], F = powers$1[u] - 1, le = [];
  for (const L of n) {
    if (anumber$1(L), L >= b)
      throw new Error(`convertRadix2: invalid data word=${L} from=${c}`);
    if (a = a << c | L, A + c > 32)
      throw new Error(`convertRadix2: carry overflow pos=${A} from=${c}`);
    for (A += c; A >= u; A -= u)
      le.push((a >> A - u & F) >>> 0);
    const pe = powers$1[A];
    if (pe === void 0)
      throw new Error("invalid carry");
    a &= pe - 1;
  }
  if (a = a << u - A & F, !p && A >= c)
    throw new Error("Excess padding");
  if (!p && a > 0)
    throw new Error(`Non-zero padding: ${a}`);
  return p && A > 0 && le.push(a >>> 0), le;
}
// @__NO_SIDE_EFFECTS__
function radix2$1(n, c = !1) {
  if (anumber$1(n), n <= 0 || n > 32)
    throw new Error("radix2: bits should be in (0..32]");
  if (/* @__PURE__ */ radix2carry$1(8, n) > 32 || /* @__PURE__ */ radix2carry$1(n, 8) > 32)
    throw new Error("radix2: carry overflow");
  return {
    encode: (u) => {
      if (!isBytes$5(u))
        throw new Error("radix2.encode input should be Uint8Array");
      return convertRadix2$1(Array.from(u), 8, n, !c);
    },
    decode: (u) => (anumArr$1("radix2.decode", u), Uint8Array.from(convertRadix2$1(u, n, 8, c)))
  };
}
const utf8$1 = {
  encode: (n) => new TextDecoder().decode(n),
  decode: (n) => new TextEncoder().encode(n)
}, hasHexBuiltin$1 = typeof Uint8Array.from([]).toHex == "function" && typeof Uint8Array.fromHex == "function", hexBuiltin$1 = {
  encode(n) {
    return abytes$1(n), n.toHex();
  },
  decode(n) {
    return astr$1("hex", n), Uint8Array.fromHex(n);
  }
}, hex$2 = hasHexBuiltin$1 ? hexBuiltin$1 : /* @__PURE__ */ chain$1(/* @__PURE__ */ radix2$1(4), /* @__PURE__ */ alphabet$1("0123456789abcdef"), /* @__PURE__ */ join$1(""), /* @__PURE__ */ normalize$1((n) => {
  if (typeof n != "string" || n.length % 2 !== 0)
    throw new TypeError(`hex.decode: expected string, got ${typeof n} with length ${n.length}`);
  return n.toLowerCase();
})), EMPTY = /* @__PURE__ */ new Uint8Array(), NULL = /* @__PURE__ */ new Uint8Array([0]);
function equalBytes$2(n, c) {
  if (n.length !== c.length)
    return !1;
  for (let u = 0; u < n.length; u++)
    if (n[u] !== c[u])
      return !1;
  return !0;
}
function isBytes$4(n) {
  return n instanceof Uint8Array || ArrayBuffer.isView(n) && n.constructor.name === "Uint8Array";
}
function concatBytes$3(...n) {
  let c = 0;
  for (let p = 0; p < n.length; p++) {
    const a = n[p];
    if (!isBytes$4(a))
      throw new Error("Uint8Array expected");
    c += a.length;
  }
  const u = new Uint8Array(c);
  for (let p = 0, a = 0; p < n.length; p++) {
    const A = n[p];
    u.set(A, a), a += A.length;
  }
  return u;
}
const createView$4 = (n) => new DataView(n.buffer, n.byteOffset, n.byteLength);
function isPlainObject(n) {
  return Object.prototype.toString.call(n) === "[object Object]";
}
function isNum$1(n) {
  return Number.isSafeInteger(n);
}
const utils$1 = {
  equalBytes: equalBytes$2,
  isBytes: isBytes$4,
  isCoder,
  checkBounds: checkBounds$2,
  concatBytes: concatBytes$3,
  createView: createView$4,
  isPlainObject
}, lengthCoder = (n) => {
  if (n !== null && typeof n != "string" && !isCoder(n) && !isBytes$4(n) && !isNum$1(n))
    throw new Error(`lengthCoder: expected null | number | Uint8Array | CoderType, got ${n} (${typeof n})`);
  return {
    encodeStream(c, u) {
      if (n === null)
        return;
      if (isCoder(n))
        return n.encodeStream(c, u);
      let p;
      if (typeof n == "number" ? p = n : typeof n == "string" && (p = Path.resolve(c.stack, n)), typeof p == "bigint" && (p = Number(p)), p === void 0 || p !== u)
        throw c.err(`Wrong length: ${p} len=${n} exp=${u} (${typeof u})`);
    },
    decodeStream(c) {
      let u;
      if (isCoder(n) ? u = Number(n.decodeStream(c)) : typeof n == "number" ? u = n : typeof n == "string" && (u = Path.resolve(c.stack, n)), typeof u == "bigint" && (u = Number(u)), typeof u != "number")
        throw c.err(`Wrong length: ${u}`);
      return u;
    }
  };
}, Bitset = {
  BITS: 32,
  FULL_MASK: -1 >>> 0,
  // 1<<32 will overflow
  len: (n) => Math.ceil(n / 32),
  create: (n) => new Uint32Array(Bitset.len(n)),
  clean: (n) => n.fill(0),
  debug: (n) => Array.from(n).map((c) => (c >>> 0).toString(2).padStart(32, "0")),
  checkLen: (n, c) => {
    if (Bitset.len(c) !== n.length)
      throw new Error(`wrong length=${n.length}. Expected: ${Bitset.len(c)}`);
  },
  chunkLen: (n, c, u) => {
    if (c < 0)
      throw new Error(`wrong pos=${c}`);
    if (c + u > n)
      throw new Error(`wrong range=${c}/${u} of ${n}`);
  },
  set: (n, c, u, p = !0) => !p && n[c] & u ? !1 : (n[c] |= u, !0),
  pos: (n, c) => ({
    chunk: Math.floor((n + c) / 32),
    mask: 1 << 32 - (n + c) % 32 - 1
  }),
  indices: (n, c, u = !1) => {
    Bitset.checkLen(n, c);
    const { FULL_MASK: p, BITS: a } = Bitset, A = a - c % a, b = A ? p >>> A << A : p, F = [];
    for (let le = 0; le < n.length; le++) {
      let L = n[le];
      if (u && (L = ~L), le === n.length - 1 && (L &= b), L !== 0)
        for (let pe = 0; pe < a; pe++) {
          const $ = 1 << a - pe - 1;
          L & $ && F.push(le * a + pe);
        }
    }
    return F;
  },
  range: (n) => {
    const c = [];
    let u;
    for (const p of n)
      u === void 0 || p !== u.pos + u.length ? c.push(u = { pos: p, length: 1 }) : u.length += 1;
    return c;
  },
  rangeDebug: (n, c, u = !1) => `[${Bitset.range(Bitset.indices(n, c, u)).map((p) => `(${p.pos}/${p.length})`).join(", ")}]`,
  setRange: (n, c, u, p, a = !0) => {
    Bitset.chunkLen(c, u, p);
    const { FULL_MASK: A, BITS: b } = Bitset, F = u % b ? Math.floor(u / b) : void 0, le = u + p, L = le % b ? Math.floor(le / b) : void 0;
    if (F !== void 0 && F === L)
      return Bitset.set(n, F, A >>> b - p << b - p - u, a);
    if (F !== void 0 && !Bitset.set(n, F, A >>> u % b, a))
      return !1;
    const pe = F !== void 0 ? F + 1 : u / b, $ = L !== void 0 ? L : le / b;
    for (let Ee = pe; Ee < $; Ee++)
      if (!Bitset.set(n, Ee, A, a))
        return !1;
    return !(L !== void 0 && F !== L && !Bitset.set(n, L, A << b - le % b, a));
  }
}, Path = {
  /**
   * Internal method for handling stack of paths (debug, errors, dynamic fields via path)
   * This is looks ugly (callback), but allows us to force stack cleaning by construction (.pop always after function).
   * Also, this makes impossible:
   * - pushing field when stack is empty
   * - pushing field inside of field (real bug)
   * NOTE: we don't want to do '.pop' on error!
   */
  pushObj: (n, c, u) => {
    const p = { obj: c };
    n.push(p), u((a, A) => {
      p.field = a, A(), p.field = void 0;
    }), n.pop();
  },
  path: (n) => {
    const c = [];
    for (const u of n)
      u.field !== void 0 && c.push(u.field);
    return c.join("/");
  },
  err: (n, c, u) => {
    const p = new Error(`${n}(${Path.path(c)}): ${typeof u == "string" ? u : u.message}`);
    return u instanceof Error && u.stack && (p.stack = u.stack), p;
  },
  resolve: (n, c) => {
    const u = c.split("/"), p = n.map((b) => b.obj);
    let a = 0;
    for (; a < u.length && u[a] === ".."; a++)
      p.pop();
    let A = p.pop();
    for (; a < u.length; a++) {
      if (!A || A[u[a]] === void 0)
        return;
      A = A[u[a]];
    }
    return A;
  }
};
class _Reader {
  constructor(c, u = {}, p = [], a = void 0, A = 0) {
    this.pos = 0, this.bitBuf = 0, this.bitPos = 0, this.data = c, this.opts = u, this.stack = p, this.parent = a, this.parentOffset = A, this.view = createView$4(c);
  }
  /** Internal method for pointers. */
  _enablePointers() {
    if (this.parent)
      return this.parent._enablePointers();
    this.bs || (this.bs = Bitset.create(this.data.length), Bitset.setRange(this.bs, this.data.length, 0, this.pos, this.opts.allowMultipleReads));
  }
  markBytesBS(c, u) {
    return this.parent ? this.parent.markBytesBS(this.parentOffset + c, u) : !u || !this.bs ? !0 : Bitset.setRange(this.bs, this.data.length, c, u, !1);
  }
  markBytes(c) {
    const u = this.pos;
    this.pos += c;
    const p = this.markBytesBS(u, c);
    if (!this.opts.allowMultipleReads && !p)
      throw this.err(`multiple read pos=${this.pos} len=${c}`);
    return p;
  }
  pushObj(c, u) {
    return Path.pushObj(this.stack, c, u);
  }
  readView(c, u) {
    if (!Number.isFinite(c))
      throw this.err(`readView: wrong length=${c}`);
    if (this.pos + c > this.data.length)
      throw this.err("readView: Unexpected end of buffer");
    const p = u(this.view, this.pos);
    return this.markBytes(c), p;
  }
  // read bytes by absolute offset
  absBytes(c) {
    if (c > this.data.length)
      throw new Error("Unexpected end of buffer");
    return this.data.subarray(c);
  }
  finish() {
    if (!this.opts.allowUnreadBytes) {
      if (this.bitPos)
        throw this.err(`${this.bitPos} bits left after unpack: ${hex$2.encode(this.data.slice(this.pos))}`);
      if (this.bs && !this.parent) {
        const c = Bitset.indices(this.bs, this.data.length, !0);
        if (c.length) {
          const u = Bitset.range(c).map(({ pos: p, length: a }) => `(${p}/${a})[${hex$2.encode(this.data.subarray(p, p + a))}]`).join(", ");
          throw this.err(`unread byte ranges: ${u} (total=${this.data.length})`);
        } else
          return;
      }
      if (!this.isEnd())
        throw this.err(`${this.leftBytes} bytes ${this.bitPos} bits left after unpack: ${hex$2.encode(this.data.slice(this.pos))}`);
    }
  }
  // User methods
  err(c) {
    return Path.err("Reader", this.stack, c);
  }
  offsetReader(c) {
    if (c > this.data.length)
      throw this.err("offsetReader: Unexpected end of buffer");
    return new _Reader(this.absBytes(c), this.opts, this.stack, this, c);
  }
  bytes(c, u = !1) {
    if (this.bitPos)
      throw this.err("readBytes: bitPos not empty");
    if (!Number.isFinite(c))
      throw this.err(`readBytes: wrong length=${c}`);
    if (this.pos + c > this.data.length)
      throw this.err("readBytes: Unexpected end of buffer");
    const p = this.data.subarray(this.pos, this.pos + c);
    return u || this.markBytes(c), p;
  }
  byte(c = !1) {
    if (this.bitPos)
      throw this.err("readByte: bitPos not empty");
    if (this.pos + 1 > this.data.length)
      throw this.err("readBytes: Unexpected end of buffer");
    const u = this.data[this.pos];
    return c || this.markBytes(1), u;
  }
  get leftBytes() {
    return this.data.length - this.pos;
  }
  get totalBytes() {
    return this.data.length;
  }
  isEnd() {
    return this.pos >= this.data.length && !this.bitPos;
  }
  // bits are read in BE mode (left to right): (0b1000_0000).readBits(1) == 1
  bits(c) {
    if (c > 32)
      throw this.err("BitReader: cannot read more than 32 bits in single call");
    let u = 0;
    for (; c; ) {
      this.bitPos || (this.bitBuf = this.byte(), this.bitPos = 8);
      const p = Math.min(c, this.bitPos);
      this.bitPos -= p, u = u << p | this.bitBuf >> this.bitPos & 2 ** p - 1, this.bitBuf &= 2 ** this.bitPos - 1, c -= p;
    }
    return u >>> 0;
  }
  find(c, u = this.pos) {
    if (!isBytes$4(c))
      throw this.err(`find: needle is not bytes! ${c}`);
    if (this.bitPos)
      throw this.err("findByte: bitPos not empty");
    if (!c.length)
      throw this.err("find: needle is empty");
    for (let p = u; (p = this.data.indexOf(c[0], p)) !== -1; p++) {
      if (p === -1 || this.data.length - p < c.length)
        return;
      if (equalBytes$2(c, this.data.subarray(p, p + c.length)))
        return p;
    }
  }
}
class _Writer {
  constructor(c = []) {
    this.pos = 0, this.buffers = [], this.ptrs = [], this.bitBuf = 0, this.bitPos = 0, this.viewBuf = new Uint8Array(8), this.finished = !1, this.stack = c, this.view = createView$4(this.viewBuf);
  }
  pushObj(c, u) {
    return Path.pushObj(this.stack, c, u);
  }
  writeView(c, u) {
    if (this.finished)
      throw this.err("buffer: finished");
    if (!isNum$1(c) || c > 8)
      throw new Error(`wrong writeView length=${c}`);
    u(this.view), this.bytes(this.viewBuf.slice(0, c)), this.viewBuf.fill(0);
  }
  // User methods
  err(c) {
    if (this.finished)
      throw this.err("buffer: finished");
    return Path.err("Reader", this.stack, c);
  }
  bytes(c) {
    if (this.finished)
      throw this.err("buffer: finished");
    if (this.bitPos)
      throw this.err("writeBytes: ends with non-empty bit buffer");
    this.buffers.push(c), this.pos += c.length;
  }
  byte(c) {
    if (this.finished)
      throw this.err("buffer: finished");
    if (this.bitPos)
      throw this.err("writeByte: ends with non-empty bit buffer");
    this.buffers.push(new Uint8Array([c])), this.pos++;
  }
  finish(c = !0) {
    if (this.finished)
      throw this.err("buffer: finished");
    if (this.bitPos)
      throw this.err("buffer: ends with non-empty bit buffer");
    const u = this.buffers.concat(this.ptrs.map((A) => A.buffer)), p = u.map((A) => A.length).reduce((A, b) => A + b, 0), a = new Uint8Array(p);
    for (let A = 0, b = 0; A < u.length; A++) {
      const F = u[A];
      a.set(F, b), b += F.length;
    }
    for (let A = this.pos, b = 0; b < this.ptrs.length; b++) {
      const F = this.ptrs[b];
      a.set(F.ptr.encode(A), F.pos), A += F.buffer.length;
    }
    if (c) {
      this.buffers = [];
      for (const A of this.ptrs)
        A.buffer.fill(0);
      this.ptrs = [], this.finished = !0, this.bitBuf = 0;
    }
    return a;
  }
  bits(c, u) {
    if (u > 32)
      throw this.err("writeBits: cannot write more than 32 bits in single call");
    if (c >= 2 ** u)
      throw this.err(`writeBits: value (${c}) >= 2**bits (${u})`);
    for (; u; ) {
      const p = Math.min(u, 8 - this.bitPos);
      this.bitBuf = this.bitBuf << p | c >> u - p, this.bitPos += p, u -= p, c &= 2 ** u - 1, this.bitPos === 8 && (this.bitPos = 0, this.buffers.push(new Uint8Array([this.bitBuf])), this.pos++);
    }
  }
}
const swapEndianness = (n) => Uint8Array.from(n).reverse();
function checkBounds$2(n, c, u) {
  if (u) {
    const p = 2n ** (c - 1n);
    if (n < -p || n >= p)
      throw new Error(`value out of signed bounds. Expected ${-p} <= ${n} < ${p}`);
  } else if (0n > n || n >= 2n ** c)
    throw new Error(`value out of unsigned bounds. Expected 0 <= ${n} < ${2n ** c}`);
}
function _wrap(n) {
  return {
    // NOTE: we cannot export validate here, since it is likely mistake.
    encodeStream: n.encodeStream,
    decodeStream: n.decodeStream,
    size: n.size,
    encode: (c) => {
      const u = new _Writer();
      return n.encodeStream(u, c), u.finish();
    },
    decode: (c, u = {}) => {
      const p = new _Reader(c, u), a = n.decodeStream(p);
      return p.finish(), a;
    }
  };
}
function validate(n, c) {
  if (!isCoder(n))
    throw new Error(`validate: invalid inner value ${n}`);
  if (typeof c != "function")
    throw new Error("validate: fn should be function");
  return _wrap({
    size: n.size,
    encodeStream: (u, p) => {
      let a;
      try {
        a = c(p);
      } catch (A) {
        throw u.err(A);
      }
      n.encodeStream(u, a);
    },
    decodeStream: (u) => {
      const p = n.decodeStream(u);
      try {
        return c(p);
      } catch (a) {
        throw u.err(a);
      }
    }
  });
}
const wrap = (n) => {
  const c = _wrap(n);
  return n.validate ? validate(c, n.validate) : c;
}, isBaseCoder = (n) => isPlainObject(n) && typeof n.decode == "function" && typeof n.encode == "function";
function isCoder(n) {
  return isPlainObject(n) && isBaseCoder(n) && typeof n.encodeStream == "function" && typeof n.decodeStream == "function" && (n.size === void 0 || isNum$1(n.size));
}
function dict() {
  return {
    encode: (n) => {
      if (!Array.isArray(n))
        throw new Error("array expected");
      const c = {};
      for (const u of n) {
        if (!Array.isArray(u) || u.length !== 2)
          throw new Error("array of two elements expected");
        const p = u[0], a = u[1];
        if (c[p] !== void 0)
          throw new Error(`key(${p}) appears twice in struct`);
        c[p] = a;
      }
      return c;
    },
    decode: (n) => {
      if (!isPlainObject(n))
        throw new Error(`expected plain object, got ${n}`);
      return Object.entries(n);
    }
  };
}
const numberBigint = {
  encode: (n) => {
    if (typeof n != "bigint")
      throw new Error(`expected bigint, got ${typeof n}`);
    if (n > BigInt(Number.MAX_SAFE_INTEGER))
      throw new Error(`element bigger than MAX_SAFE_INTEGER=${n}`);
    return Number(n);
  },
  decode: (n) => {
    if (!isNum$1(n))
      throw new Error("element is not a safe integer");
    return BigInt(n);
  }
};
function tsEnum(n) {
  if (!isPlainObject(n))
    throw new Error("plain object expected");
  return {
    encode: (c) => {
      if (!isNum$1(c) || !(c in n))
        throw new Error(`wrong value ${c}`);
      return n[c];
    },
    decode: (c) => {
      if (typeof c != "string")
        throw new Error(`wrong value ${typeof c}`);
      return n[c];
    }
  };
}
function decimal(n, c = !1) {
  if (!isNum$1(n))
    throw new Error(`decimal/precision: wrong value ${n}`);
  if (typeof c != "boolean")
    throw new Error(`decimal/round: expected boolean, got ${typeof c}`);
  const u = 10n ** BigInt(n);
  return {
    encode: (p) => {
      if (typeof p != "bigint")
        throw new Error(`expected bigint, got ${typeof p}`);
      let a = (p < 0n ? -p : p).toString(10), A = a.length - n;
      A < 0 && (a = a.padStart(a.length - A, "0"), A = 0);
      let b = a.length - 1;
      for (; b >= A && a[b] === "0"; b--)
        ;
      let F = a.slice(0, A), le = a.slice(A, b + 1);
      return F || (F = "0"), p < 0n && (F = "-" + F), le ? `${F}.${le}` : F;
    },
    decode: (p) => {
      if (typeof p != "string")
        throw new Error(`expected string, got ${typeof p}`);
      if (p === "-0")
        throw new Error("negative zero is not allowed");
      let a = !1;
      if (p.startsWith("-") && (a = !0, p = p.slice(1)), !/^(0|[1-9]\d*)(\.\d+)?$/.test(p))
        throw new Error(`wrong string value=${p}`);
      let A = p.indexOf(".");
      A = A === -1 ? p.length : A;
      const b = p.slice(0, A), F = p.slice(A + 1).replace(/0+$/, ""), le = BigInt(b) * u;
      if (!c && F.length > n)
        throw new Error(`fractional part cannot be represented with this precision (num=${p}, prec=${n})`);
      const L = Math.min(F.length, n), pe = BigInt(F.slice(0, L)) * 10n ** BigInt(n - L), $ = le + pe;
      return a ? -$ : $;
    }
  };
}
function match(n) {
  if (!Array.isArray(n))
    throw new Error(`expected array, got ${typeof n}`);
  for (const c of n)
    if (!isBaseCoder(c))
      throw new Error(`wrong base coder ${c}`);
  return {
    encode: (c) => {
      for (const u of n) {
        const p = u.encode(c);
        if (p !== void 0)
          return p;
      }
      throw new Error(`match/encode: cannot find match in ${c}`);
    },
    decode: (c) => {
      for (const u of n) {
        const p = u.decode(c);
        if (p !== void 0)
          return p;
      }
      throw new Error(`match/decode: cannot find match in ${c}`);
    }
  };
}
const reverse = (n) => {
  if (!isBaseCoder(n))
    throw new Error("BaseCoder expected");
  return { encode: n.decode, decode: n.encode };
}, coders = { dict, numberBigint, tsEnum, decimal, match, reverse }, bigint = (n, c = !1, u = !1, p = !0) => {
  if (!isNum$1(n))
    throw new Error(`bigint/size: wrong value ${n}`);
  if (typeof c != "boolean")
    throw new Error(`bigint/le: expected boolean, got ${typeof c}`);
  if (typeof u != "boolean")
    throw new Error(`bigint/signed: expected boolean, got ${typeof u}`);
  if (typeof p != "boolean")
    throw new Error(`bigint/sized: expected boolean, got ${typeof p}`);
  const a = BigInt(n), A = 2n ** (8n * a - 1n);
  return wrap({
    size: p ? n : void 0,
    encodeStream: (b, F) => {
      u && F < 0 && (F = F | A);
      const le = [];
      for (let pe = 0; pe < n; pe++)
        le.push(Number(F & 255n)), F >>= 8n;
      let L = new Uint8Array(le).reverse();
      if (!p) {
        let pe = 0;
        for (pe = 0; pe < L.length && L[pe] === 0; pe++)
          ;
        L = L.subarray(pe);
      }
      b.bytes(c ? L.reverse() : L);
    },
    decodeStream: (b) => {
      const F = b.bytes(p ? n : Math.min(n, b.leftBytes)), le = c ? F : swapEndianness(F);
      let L = 0n;
      for (let pe = 0; pe < le.length; pe++)
        L |= BigInt(le[pe]) << 8n * BigInt(pe);
      return u && L & A && (L = (L ^ A) - A), L;
    },
    validate: (b) => {
      if (typeof b != "bigint")
        throw new Error(`bigint: invalid value: ${b}`);
      return checkBounds$2(b, 8n * a, !!u), b;
    }
  });
}, U256BE = /* @__PURE__ */ bigint(32, !1), U64LE = /* @__PURE__ */ bigint(8, !0), I64LE = /* @__PURE__ */ bigint(8, !0, !0), view = (n, c) => wrap({
  size: n,
  encodeStream: (u, p) => u.writeView(n, (a) => c.write(a, p)),
  decodeStream: (u) => u.readView(n, c.read),
  validate: (u) => {
    if (typeof u != "number")
      throw new Error(`viewCoder: expected number, got ${typeof u}`);
    return c.validate && c.validate(u), u;
  }
}), intView = (n, c, u) => {
  const p = n * 8, a = 2 ** (p - 1), A = (le) => {
    if (!isNum$1(le))
      throw new Error(`sintView: value is not safe integer: ${le}`);
    if (le < -a || le >= a)
      throw new Error(`sintView: value out of bounds. Expected ${-a} <= ${le} < ${a}`);
  }, b = 2 ** p, F = (le) => {
    if (!isNum$1(le))
      throw new Error(`uintView: value is not safe integer: ${le}`);
    if (0 > le || le >= b)
      throw new Error(`uintView: value out of bounds. Expected 0 <= ${le} < ${b}`);
  };
  return view(n, {
    write: u.write,
    read: u.read,
    validate: c ? A : F
  });
}, U32LE = /* @__PURE__ */ intView(4, !1, {
  read: (n, c) => n.getUint32(c, !0),
  write: (n, c) => n.setUint32(0, c, !0)
}), U32BE = /* @__PURE__ */ intView(4, !1, {
  read: (n, c) => n.getUint32(c, !1),
  write: (n, c) => n.setUint32(0, c, !1)
}), I32LE = /* @__PURE__ */ intView(4, !0, {
  read: (n, c) => n.getInt32(c, !0),
  write: (n, c) => n.setInt32(0, c, !0)
}), U16LE = /* @__PURE__ */ intView(2, !1, {
  read: (n, c) => n.getUint16(c, !0),
  write: (n, c) => n.setUint16(0, c, !0)
}), U8 = /* @__PURE__ */ intView(1, !1, {
  read: (n, c) => n.getUint8(c),
  write: (n, c) => n.setUint8(0, c)
}), createBytes = (n, c = !1) => {
  if (typeof c != "boolean")
    throw new Error(`bytes/le: expected boolean, got ${typeof c}`);
  const u = lengthCoder(n), p = isBytes$4(n);
  return wrap({
    size: typeof n == "number" ? n : void 0,
    encodeStream: (a, A) => {
      p || u.encodeStream(a, A.length), a.bytes(c ? swapEndianness(A) : A), p && a.bytes(n);
    },
    decodeStream: (a) => {
      let A;
      if (p) {
        const b = a.find(n);
        if (!b)
          throw a.err("bytes: cannot find terminator");
        A = a.bytes(b - a.pos), a.bytes(n.length);
      } else
        A = a.bytes(n === null ? a.leftBytes : u.decodeStream(a));
      return c ? swapEndianness(A) : A;
    },
    validate: (a) => {
      if (!isBytes$4(a))
        throw new Error(`bytes: invalid value ${a}`);
      return a;
    }
  });
};
function prefix(n, c) {
  if (!isCoder(c))
    throw new Error(`prefix: invalid inner value ${c}`);
  return apply(createBytes(n), reverse(c));
}
const string = (n, c = !1) => validate(apply(createBytes(n, c), utf8$1), (u) => {
  if (typeof u != "string")
    throw new Error(`expected string, got ${typeof u}`);
  return u;
}), createHex = (n, c = { isLE: !1, with0x: !1 }) => {
  let u = apply(createBytes(n, c.isLE), hex$2);
  const p = c.with0x;
  if (typeof p != "boolean")
    throw new Error(`hex/with0x: expected boolean, got ${typeof p}`);
  return p && (u = apply(u, {
    encode: (a) => `0x${a}`,
    decode: (a) => {
      if (!a.startsWith("0x"))
        throw new Error("hex(with0x=true).encode input should start with 0x");
      return a.slice(2);
    }
  })), u;
};
function apply(n, c) {
  if (!isCoder(n))
    throw new Error(`apply: invalid inner value ${n}`);
  if (!isBaseCoder(c))
    throw new Error(`apply: invalid base value ${n}`);
  return wrap({
    size: n.size,
    encodeStream: (u, p) => {
      let a;
      try {
        a = c.decode(p);
      } catch (A) {
        throw u.err("" + A);
      }
      return n.encodeStream(u, a);
    },
    decodeStream: (u) => {
      const p = n.decodeStream(u);
      try {
        return c.encode(p);
      } catch (a) {
        throw u.err("" + a);
      }
    }
  });
}
const flag = (n, c = !1) => {
  if (!isBytes$4(n))
    throw new Error(`flag/flagValue: expected Uint8Array, got ${typeof n}`);
  if (typeof c != "boolean")
    throw new Error(`flag/xor: expected boolean, got ${typeof c}`);
  return wrap({
    size: n.length,
    encodeStream: (u, p) => {
      !!p !== c && u.bytes(n);
    },
    decodeStream: (u) => {
      let p = u.leftBytes >= n.length;
      return p && (p = equalBytes$2(u.bytes(n.length, !0), n), p && u.bytes(n.length)), p !== c;
    },
    validate: (u) => {
      if (u !== void 0 && typeof u != "boolean")
        throw new Error(`flag: expected boolean value or undefined, got ${typeof u}`);
      return u;
    }
  });
};
function flagged(n, c, u) {
  if (!isCoder(c))
    throw new Error(`flagged: invalid inner value ${c}`);
  return wrap({
    encodeStream: (p, a) => {
      Path.resolve(p.stack, n) && c.encodeStream(p, a);
    },
    decodeStream: (p) => {
      let a = !1;
      if (a = !!Path.resolve(p.stack, n), a)
        return c.decodeStream(p);
    }
  });
}
function magic(n, c, u = !0) {
  if (!isCoder(n))
    throw new Error(`magic: invalid inner value ${n}`);
  if (typeof u != "boolean")
    throw new Error(`magic: expected boolean, got ${typeof u}`);
  return wrap({
    size: n.size,
    encodeStream: (p, a) => n.encodeStream(p, c),
    decodeStream: (p) => {
      const a = n.decodeStream(p);
      if (u && typeof a != "object" && a !== c || isBytes$4(c) && !equalBytes$2(c, a))
        throw p.err(`magic: invalid value: ${a} !== ${c}`);
    },
    validate: (p) => {
      if (p !== void 0)
        throw new Error(`magic: wrong value=${typeof p}`);
      return p;
    }
  });
}
function sizeof(n) {
  let c = 0;
  for (const u of n) {
    if (u.size === void 0)
      return;
    if (!isNum$1(u.size))
      throw new Error(`sizeof: wrong element size=${c}`);
    c += u.size;
  }
  return c;
}
function struct(n) {
  if (!isPlainObject(n))
    throw new Error(`struct: expected plain object, got ${n}`);
  for (const c in n)
    if (!isCoder(n[c]))
      throw new Error(`struct: field ${c} is not CoderType`);
  return wrap({
    size: sizeof(Object.values(n)),
    encodeStream: (c, u) => {
      c.pushObj(u, (p) => {
        for (const a in n)
          p(a, () => n[a].encodeStream(c, u[a]));
      });
    },
    decodeStream: (c) => {
      const u = {};
      return c.pushObj(u, (p) => {
        for (const a in n)
          p(a, () => u[a] = n[a].decodeStream(c));
      }), u;
    },
    validate: (c) => {
      if (typeof c != "object" || c === null)
        throw new Error(`struct: invalid value ${c}`);
      return c;
    }
  });
}
function tuple(n) {
  if (!Array.isArray(n))
    throw new Error(`Packed.Tuple: got ${typeof n} instead of array`);
  for (let c = 0; c < n.length; c++)
    if (!isCoder(n[c]))
      throw new Error(`tuple: field ${c} is not CoderType`);
  return wrap({
    size: sizeof(n),
    encodeStream: (c, u) => {
      if (!Array.isArray(u))
        throw c.err(`tuple: invalid value ${u}`);
      c.pushObj(u, (p) => {
        for (let a = 0; a < n.length; a++)
          p(`${a}`, () => n[a].encodeStream(c, u[a]));
      });
    },
    decodeStream: (c) => {
      const u = [];
      return c.pushObj(u, (p) => {
        for (let a = 0; a < n.length; a++)
          p(`${a}`, () => u.push(n[a].decodeStream(c)));
      }), u;
    },
    validate: (c) => {
      if (!Array.isArray(c))
        throw new Error(`tuple: invalid value ${c}`);
      if (c.length !== n.length)
        throw new Error(`tuple: wrong length=${c.length}, expected ${n.length}`);
      return c;
    }
  });
}
function array(n, c) {
  if (!isCoder(c))
    throw new Error(`array: invalid inner value ${c}`);
  const u = lengthCoder(typeof n == "string" ? `../${n}` : n);
  return wrap({
    size: typeof n == "number" && c.size ? n * c.size : void 0,
    encodeStream: (p, a) => {
      const A = p;
      A.pushObj(a, (b) => {
        isBytes$4(n) || u.encodeStream(p, a.length);
        for (let F = 0; F < a.length; F++)
          b(`${F}`, () => {
            const le = a[F], L = p.pos;
            if (c.encodeStream(p, le), isBytes$4(n)) {
              if (n.length > A.pos - L)
                return;
              const pe = A.finish(!1).subarray(L, A.pos);
              if (equalBytes$2(pe.subarray(0, n.length), n))
                throw A.err(`array: inner element encoding same as separator. elm=${le} data=${pe}`);
            }
          });
      }), isBytes$4(n) && p.bytes(n);
    },
    decodeStream: (p) => {
      const a = [];
      return p.pushObj(a, (A) => {
        if (n === null)
          for (let b = 0; !p.isEnd() && (A(`${b}`, () => a.push(c.decodeStream(p))), !(c.size && p.leftBytes < c.size)); b++)
            ;
        else if (isBytes$4(n))
          for (let b = 0; ; b++) {
            if (equalBytes$2(p.bytes(n.length, !0), n)) {
              p.bytes(n.length);
              break;
            }
            A(`${b}`, () => a.push(c.decodeStream(p)));
          }
        else {
          let b;
          A("arrayLen", () => b = u.decodeStream(p));
          for (let F = 0; F < b; F++)
            A(`${F}`, () => a.push(c.decodeStream(p)));
        }
      }), a;
    },
    validate: (p) => {
      if (!Array.isArray(p))
        throw new Error(`array: invalid value ${p}`);
      return p;
    }
  });
}
const Point$1 = secp256k1$2.ProjectivePoint, CURVE_ORDER$1 = secp256k1$2.CURVE.n, isBytes$3 = utils$1.isBytes, concatBytes$2 = utils$1.concatBytes, equalBytes$1 = utils$1.equalBytes, hash160$2 = (n) => ripemd160$1(sha256$5(n)), sha256x2$1 = (...n) => sha256$5(sha256$5(concatBytes$2(...n))), randomPrivateKeyBytes = schnorr$1.utils.randomPrivateKey, pubSchnorr = schnorr$1.getPublicKey, pubECDSA = secp256k1$2.getPublicKey, hasLowR = (n) => n.r < CURVE_ORDER$1 / 2n;
function signECDSA(n, c, u = !1) {
  let p = secp256k1$2.sign(n, c);
  if (u && !hasLowR(p)) {
    const a = new Uint8Array(32);
    let A = 0;
    for (; !hasLowR(p); )
      if (a.set(U32LE.encode(A++)), p = secp256k1$2.sign(n, c, { extraEntropy: a }), A > 4294967295)
        throw new Error("lowR counter overflow: report the error");
  }
  return p.toDERRawBytes();
}
const signSchnorr = schnorr$1.sign, tagSchnorr = schnorr$1.utils.taggedHash;
var PubT;
(function(n) {
  n[n.ecdsa = 0] = "ecdsa", n[n.schnorr = 1] = "schnorr";
})(PubT || (PubT = {}));
function validatePubkey(n, c) {
  const u = n.length;
  if (c === PubT.ecdsa) {
    if (u === 32)
      throw new Error("Expected non-Schnorr key");
    return Point$1.fromHex(n), n;
  } else if (c === PubT.schnorr) {
    if (u !== 32)
      throw new Error("Expected 32-byte Schnorr key");
    return schnorr$1.utils.lift_x(schnorr$1.utils.bytesToNumberBE(n)), n;
  } else
    throw new Error("Unknown key type");
}
function tapTweak(n, c) {
  const u = schnorr$1.utils, p = u.taggedHash("TapTweak", n, c), a = u.bytesToNumberBE(p);
  if (a >= CURVE_ORDER$1)
    throw new Error("tweak higher than curve order");
  return a;
}
function taprootTweakPrivKey(n, c = Uint8Array.of()) {
  const u = schnorr$1.utils, p = u.bytesToNumberBE(n), a = Point$1.fromPrivateKey(p), A = a.hasEvenY() ? p : u.mod(-p, CURVE_ORDER$1), b = u.pointToBytes(a), F = tapTweak(b, c);
  return u.numberToBytesBE(u.mod(A + F, CURVE_ORDER$1), 32);
}
function taprootTweakPubkey(n, c) {
  const u = schnorr$1.utils, p = tapTweak(n, c), A = u.lift_x(u.bytesToNumberBE(n)).add(Point$1.fromPrivateKey(p)), b = A.hasEvenY() ? 0 : 1;
  return [u.pointToBytes(A), b];
}
const TAPROOT_UNSPENDABLE_KEY = sha256$5(Point$1.BASE.toRawBytes(!1)), NETWORK = {
  bech32: "bc",
  pubKeyHash: 0,
  scriptHash: 5,
  wif: 128
}, TEST_NETWORK = {
  bech32: "tb",
  pubKeyHash: 111,
  scriptHash: 196,
  wif: 239
};
function compareBytes(n, c) {
  if (!isBytes$3(n) || !isBytes$3(c))
    throw new Error(`cmp: wrong type a=${typeof n} b=${typeof c}`);
  const u = Math.min(n.length, c.length);
  for (let p = 0; p < u; p++)
    if (n[p] != c[p])
      return Math.sign(n[p] - c[p]);
  return Math.sign(n.length - c.length);
}
function isBytes$2(n) {
  return n instanceof Uint8Array || ArrayBuffer.isView(n) && n.constructor.name === "Uint8Array";
}
function abytes(n, ...c) {
  if (!isBytes$2(n))
    throw new Error("Uint8Array expected");
  if (c.length > 0 && !c.includes(n.length))
    throw new Error("Uint8Array expected of length " + c + ", got length=" + n.length);
}
function isArrayOf(n, c) {
  return Array.isArray(c) ? c.length === 0 ? !0 : n ? c.every((u) => typeof u == "string") : c.every((u) => Number.isSafeInteger(u)) : !1;
}
function afn(n) {
  if (typeof n != "function")
    throw new Error("function expected");
  return !0;
}
function astr(n, c) {
  if (typeof c != "string")
    throw new Error(`${n}: string expected`);
  return !0;
}
function anumber(n) {
  if (!Number.isSafeInteger(n))
    throw new Error(`invalid integer: ${n}`);
}
function aArr(n) {
  if (!Array.isArray(n))
    throw new Error("array expected");
}
function astrArr(n, c) {
  if (!isArrayOf(!0, c))
    throw new Error(`${n}: array of strings expected`);
}
function anumArr(n, c) {
  if (!isArrayOf(!1, c))
    throw new Error(`${n}: array of numbers expected`);
}
// @__NO_SIDE_EFFECTS__
function chain(...n) {
  const c = (A) => A, u = (A, b) => (F) => A(b(F)), p = n.map((A) => A.encode).reduceRight(u, c), a = n.map((A) => A.decode).reduce(u, c);
  return { encode: p, decode: a };
}
// @__NO_SIDE_EFFECTS__
function alphabet(n) {
  const c = typeof n == "string" ? n.split("") : n, u = c.length;
  astrArr("alphabet", c);
  const p = new Map(c.map((a, A) => [a, A]));
  return {
    encode: (a) => (aArr(a), a.map((A) => {
      if (!Number.isSafeInteger(A) || A < 0 || A >= u)
        throw new Error(`alphabet.encode: digit index outside alphabet "${A}". Allowed: ${n}`);
      return c[A];
    })),
    decode: (a) => (aArr(a), a.map((A) => {
      astr("alphabet.decode", A);
      const b = p.get(A);
      if (b === void 0)
        throw new Error(`Unknown letter: "${A}". Allowed: ${n}`);
      return b;
    }))
  };
}
// @__NO_SIDE_EFFECTS__
function join(n = "") {
  return astr("join", n), {
    encode: (c) => (astrArr("join.decode", c), c.join(n)),
    decode: (c) => (astr("join.decode", c), c.split(n))
  };
}
// @__NO_SIDE_EFFECTS__
function normalize(n) {
  return afn(n), { encode: (c) => c, decode: (c) => n(c) };
}
function convertRadix(n, c, u) {
  if (c < 2)
    throw new Error(`convertRadix: invalid from=${c}, base cannot be less than 2`);
  if (u < 2)
    throw new Error(`convertRadix: invalid to=${u}, base cannot be less than 2`);
  if (aArr(n), !n.length)
    return [];
  let p = 0;
  const a = [], A = Array.from(n, (F) => {
    if (anumber(F), F < 0 || F >= c)
      throw new Error(`invalid integer: ${F}`);
    return F;
  }), b = A.length;
  for (; ; ) {
    let F = 0, le = !0;
    for (let L = p; L < b; L++) {
      const pe = A[L], $ = c * F, Ee = $ + pe;
      if (!Number.isSafeInteger(Ee) || $ / c !== F || Ee - pe !== $)
        throw new Error("convertRadix: carry overflow");
      const be = Ee / u;
      F = Ee % u;
      const He = Math.floor(be);
      if (A[L] = He, !Number.isSafeInteger(He) || He * u + F !== Ee)
        throw new Error("convertRadix: carry overflow");
      if (le)
        He ? le = !1 : p = L;
      else continue;
    }
    if (a.push(F), le)
      break;
  }
  for (let F = 0; F < n.length - 1 && n[F] === 0; F++)
    a.push(0);
  return a.reverse();
}
const gcd = (n, c) => c === 0 ? n : gcd(c, n % c), radix2carry = /* @__NO_SIDE_EFFECTS__ */ (n, c) => n + (c - gcd(n, c)), powers = /* @__PURE__ */ (() => {
  let n = [];
  for (let c = 0; c < 40; c++)
    n.push(2 ** c);
  return n;
})();
function convertRadix2(n, c, u, p) {
  if (aArr(n), c <= 0 || c > 32)
    throw new Error(`convertRadix2: wrong from=${c}`);
  if (u <= 0 || u > 32)
    throw new Error(`convertRadix2: wrong to=${u}`);
  if (/* @__PURE__ */ radix2carry(c, u) > 32)
    throw new Error(`convertRadix2: carry overflow from=${c} to=${u} carryBits=${/* @__PURE__ */ radix2carry(c, u)}`);
  let a = 0, A = 0;
  const b = powers[c], F = powers[u] - 1, le = [];
  for (const L of n) {
    if (anumber(L), L >= b)
      throw new Error(`convertRadix2: invalid data word=${L} from=${c}`);
    if (a = a << c | L, A + c > 32)
      throw new Error(`convertRadix2: carry overflow pos=${A} from=${c}`);
    for (A += c; A >= u; A -= u)
      le.push((a >> A - u & F) >>> 0);
    const pe = powers[A];
    if (pe === void 0)
      throw new Error("invalid carry");
    a &= pe - 1;
  }
  if (a = a << u - A & F, !p && A >= c)
    throw new Error("Excess padding");
  if (!p && a > 0)
    throw new Error(`Non-zero padding: ${a}`);
  return p && A > 0 && le.push(a >>> 0), le;
}
// @__NO_SIDE_EFFECTS__
function radix(n) {
  anumber(n);
  const c = 2 ** 8;
  return {
    encode: (u) => {
      if (!isBytes$2(u))
        throw new Error("radix.encode input should be Uint8Array");
      return convertRadix(Array.from(u), c, n);
    },
    decode: (u) => (anumArr("radix.decode", u), Uint8Array.from(convertRadix(u, n, c)))
  };
}
// @__NO_SIDE_EFFECTS__
function radix2(n, c = !1) {
  if (anumber(n), n <= 0 || n > 32)
    throw new Error("radix2: bits should be in (0..32]");
  if (/* @__PURE__ */ radix2carry(8, n) > 32 || /* @__PURE__ */ radix2carry(n, 8) > 32)
    throw new Error("radix2: carry overflow");
  return {
    encode: (u) => {
      if (!isBytes$2(u))
        throw new Error("radix2.encode input should be Uint8Array");
      return convertRadix2(Array.from(u), 8, n, !c);
    },
    decode: (u) => (anumArr("radix2.decode", u), Uint8Array.from(convertRadix2(u, n, 8, c)))
  };
}
function unsafeWrapper(n) {
  return afn(n), function(...c) {
    try {
      return n.apply(null, c);
    } catch {
    }
  };
}
function checksum$1(n, c) {
  return anumber(n), afn(c), {
    encode(u) {
      if (!isBytes$2(u))
        throw new Error("checksum.encode: input should be Uint8Array");
      const p = c(u).slice(0, n), a = new Uint8Array(u.length + n);
      return a.set(u), a.set(p, u.length), a;
    },
    decode(u) {
      if (!isBytes$2(u))
        throw new Error("checksum.decode: input should be Uint8Array");
      const p = u.slice(0, -n), a = u.slice(-n), A = c(p).slice(0, n);
      for (let b = 0; b < n; b++)
        if (A[b] !== a[b])
          throw new Error("Invalid checksum");
      return p;
    }
  };
}
const genBase58 = /* @__NO_SIDE_EFFECTS__ */ (n) => /* @__PURE__ */ chain(/* @__PURE__ */ radix(58), /* @__PURE__ */ alphabet(n), /* @__PURE__ */ join("")), base58$1 = /* @__PURE__ */ genBase58("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"), createBase58check = (n) => /* @__PURE__ */ chain(checksum$1(4, (c) => n(n(c))), base58$1), BECH_ALPHABET = /* @__PURE__ */ chain(/* @__PURE__ */ alphabet("qpzry9x8gf2tvdw0s3jn54khce6mua7l"), /* @__PURE__ */ join("")), POLYMOD_GENERATORS = [996825010, 642813549, 513874426, 1027748829, 705979059];
function bech32Polymod(n) {
  const c = n >> 25;
  let u = (n & 33554431) << 5;
  for (let p = 0; p < POLYMOD_GENERATORS.length; p++)
    (c >> p & 1) === 1 && (u ^= POLYMOD_GENERATORS[p]);
  return u;
}
function bechChecksum(n, c, u = 1) {
  const p = n.length;
  let a = 1;
  for (let A = 0; A < p; A++) {
    const b = n.charCodeAt(A);
    if (b < 33 || b > 126)
      throw new Error(`Invalid prefix (${n})`);
    a = bech32Polymod(a) ^ b >> 5;
  }
  a = bech32Polymod(a);
  for (let A = 0; A < p; A++)
    a = bech32Polymod(a) ^ n.charCodeAt(A) & 31;
  for (let A of c)
    a = bech32Polymod(a) ^ A;
  for (let A = 0; A < 6; A++)
    a = bech32Polymod(a);
  return a ^= u, BECH_ALPHABET.encode(convertRadix2([a % powers[30]], 30, 5, !1));
}
// @__NO_SIDE_EFFECTS__
function genBech32(n) {
  const c = n === "bech32" ? 1 : 734539939, u = /* @__PURE__ */ radix2(5), p = u.decode, a = u.encode, A = unsafeWrapper(p);
  function b($, Ee, be = 90) {
    astr("bech32.encode prefix", $), isBytes$2(Ee) && (Ee = Array.from(Ee)), anumArr("bech32.encode", Ee);
    const He = $.length;
    if (He === 0)
      throw new TypeError(`Invalid prefix length ${He}`);
    const Pe = He + 7 + Ee.length;
    if (be !== !1 && Pe > be)
      throw new TypeError(`Length ${Pe} exceeds limit ${be}`);
    const nr = $.toLowerCase(), ir = bechChecksum(nr, Ee, c);
    return `${nr}1${BECH_ALPHABET.encode(Ee)}${ir}`;
  }
  function F($, Ee = 90) {
    astr("bech32.decode input", $);
    const be = $.length;
    if (be < 8 || Ee !== !1 && be > Ee)
      throw new TypeError(`invalid string length: ${be} (${$}). Expected (8..${Ee})`);
    const He = $.toLowerCase();
    if ($ !== He && $ !== $.toUpperCase())
      throw new Error("String must be lowercase or uppercase");
    const Pe = He.lastIndexOf("1");
    if (Pe === 0 || Pe === -1)
      throw new Error('Letter "1" must be present between prefix and data only');
    const nr = He.slice(0, Pe), ir = He.slice(Pe + 1);
    if (ir.length < 6)
      throw new Error("Data must be at least 6 characters long");
    const or = BECH_ALPHABET.decode(ir).slice(0, -6), lr = bechChecksum(nr, or, c);
    if (!ir.endsWith(lr))
      throw new Error(`Invalid checksum in ${$}: expected "${lr}"`);
    return { prefix: nr, words: or };
  }
  const le = unsafeWrapper(F);
  function L($) {
    const { prefix: Ee, words: be } = F($, !1);
    return { prefix: Ee, words: be, bytes: p(be) };
  }
  function pe($, Ee) {
    return b($, a(Ee));
  }
  return {
    encode: b,
    decode: F,
    encodeFromBytes: pe,
    decodeToBytes: L,
    decodeUnsafe: le,
    fromWords: p,
    fromWordsUnsafe: A,
    toWords: a
  };
}
const bech32$2 = /* @__PURE__ */ genBech32("bech32"), bech32m = /* @__PURE__ */ genBech32("bech32m"), hasHexBuiltin = typeof Uint8Array.from([]).toHex == "function" && typeof Uint8Array.fromHex == "function", hexBuiltin = {
  encode(n) {
    return abytes(n), n.toHex();
  },
  decode(n) {
    return astr("hex", n), Uint8Array.fromHex(n);
  }
}, hex$1 = hasHexBuiltin ? hexBuiltin : /* @__PURE__ */ chain(/* @__PURE__ */ radix2(4), /* @__PURE__ */ alphabet("0123456789abcdef"), /* @__PURE__ */ join(""), /* @__PURE__ */ normalize((n) => {
  if (typeof n != "string" || n.length % 2 !== 0)
    throw new TypeError(`hex.decode: expected string, got ${typeof n} with length ${n.length}`);
  return n.toLowerCase();
})), MAX_SCRIPT_BYTE_LENGTH = 520;
var OP;
(function(n) {
  n[n.OP_0 = 0] = "OP_0", n[n.PUSHDATA1 = 76] = "PUSHDATA1", n[n.PUSHDATA2 = 77] = "PUSHDATA2", n[n.PUSHDATA4 = 78] = "PUSHDATA4", n[n["1NEGATE"] = 79] = "1NEGATE", n[n.RESERVED = 80] = "RESERVED", n[n.OP_1 = 81] = "OP_1", n[n.OP_2 = 82] = "OP_2", n[n.OP_3 = 83] = "OP_3", n[n.OP_4 = 84] = "OP_4", n[n.OP_5 = 85] = "OP_5", n[n.OP_6 = 86] = "OP_6", n[n.OP_7 = 87] = "OP_7", n[n.OP_8 = 88] = "OP_8", n[n.OP_9 = 89] = "OP_9", n[n.OP_10 = 90] = "OP_10", n[n.OP_11 = 91] = "OP_11", n[n.OP_12 = 92] = "OP_12", n[n.OP_13 = 93] = "OP_13", n[n.OP_14 = 94] = "OP_14", n[n.OP_15 = 95] = "OP_15", n[n.OP_16 = 96] = "OP_16", n[n.NOP = 97] = "NOP", n[n.VER = 98] = "VER", n[n.IF = 99] = "IF", n[n.NOTIF = 100] = "NOTIF", n[n.VERIF = 101] = "VERIF", n[n.VERNOTIF = 102] = "VERNOTIF", n[n.ELSE = 103] = "ELSE", n[n.ENDIF = 104] = "ENDIF", n[n.VERIFY = 105] = "VERIFY", n[n.RETURN = 106] = "RETURN", n[n.TOALTSTACK = 107] = "TOALTSTACK", n[n.FROMALTSTACK = 108] = "FROMALTSTACK", n[n["2DROP"] = 109] = "2DROP", n[n["2DUP"] = 110] = "2DUP", n[n["3DUP"] = 111] = "3DUP", n[n["2OVER"] = 112] = "2OVER", n[n["2ROT"] = 113] = "2ROT", n[n["2SWAP"] = 114] = "2SWAP", n[n.IFDUP = 115] = "IFDUP", n[n.DEPTH = 116] = "DEPTH", n[n.DROP = 117] = "DROP", n[n.DUP = 118] = "DUP", n[n.NIP = 119] = "NIP", n[n.OVER = 120] = "OVER", n[n.PICK = 121] = "PICK", n[n.ROLL = 122] = "ROLL", n[n.ROT = 123] = "ROT", n[n.SWAP = 124] = "SWAP", n[n.TUCK = 125] = "TUCK", n[n.CAT = 126] = "CAT", n[n.SUBSTR = 127] = "SUBSTR", n[n.LEFT = 128] = "LEFT", n[n.RIGHT = 129] = "RIGHT", n[n.SIZE = 130] = "SIZE", n[n.INVERT = 131] = "INVERT", n[n.AND = 132] = "AND", n[n.OR = 133] = "OR", n[n.XOR = 134] = "XOR", n[n.EQUAL = 135] = "EQUAL", n[n.EQUALVERIFY = 136] = "EQUALVERIFY", n[n.RESERVED1 = 137] = "RESERVED1", n[n.RESERVED2 = 138] = "RESERVED2", n[n["1ADD"] = 139] = "1ADD", n[n["1SUB"] = 140] = "1SUB", n[n["2MUL"] = 141] = "2MUL", n[n["2DIV"] = 142] = "2DIV", n[n.NEGATE = 143] = "NEGATE", n[n.ABS = 144] = "ABS", n[n.NOT = 145] = "NOT", n[n["0NOTEQUAL"] = 146] = "0NOTEQUAL", n[n.ADD = 147] = "ADD", n[n.SUB = 148] = "SUB", n[n.MUL = 149] = "MUL", n[n.DIV = 150] = "DIV", n[n.MOD = 151] = "MOD", n[n.LSHIFT = 152] = "LSHIFT", n[n.RSHIFT = 153] = "RSHIFT", n[n.BOOLAND = 154] = "BOOLAND", n[n.BOOLOR = 155] = "BOOLOR", n[n.NUMEQUAL = 156] = "NUMEQUAL", n[n.NUMEQUALVERIFY = 157] = "NUMEQUALVERIFY", n[n.NUMNOTEQUAL = 158] = "NUMNOTEQUAL", n[n.LESSTHAN = 159] = "LESSTHAN", n[n.GREATERTHAN = 160] = "GREATERTHAN", n[n.LESSTHANOREQUAL = 161] = "LESSTHANOREQUAL", n[n.GREATERTHANOREQUAL = 162] = "GREATERTHANOREQUAL", n[n.MIN = 163] = "MIN", n[n.MAX = 164] = "MAX", n[n.WITHIN = 165] = "WITHIN", n[n.RIPEMD160 = 166] = "RIPEMD160", n[n.SHA1 = 167] = "SHA1", n[n.SHA256 = 168] = "SHA256", n[n.HASH160 = 169] = "HASH160", n[n.HASH256 = 170] = "HASH256", n[n.CODESEPARATOR = 171] = "CODESEPARATOR", n[n.CHECKSIG = 172] = "CHECKSIG", n[n.CHECKSIGVERIFY = 173] = "CHECKSIGVERIFY", n[n.CHECKMULTISIG = 174] = "CHECKMULTISIG", n[n.CHECKMULTISIGVERIFY = 175] = "CHECKMULTISIGVERIFY", n[n.NOP1 = 176] = "NOP1", n[n.CHECKLOCKTIMEVERIFY = 177] = "CHECKLOCKTIMEVERIFY", n[n.CHECKSEQUENCEVERIFY = 178] = "CHECKSEQUENCEVERIFY", n[n.NOP4 = 179] = "NOP4", n[n.NOP5 = 180] = "NOP5", n[n.NOP6 = 181] = "NOP6", n[n.NOP7 = 182] = "NOP7", n[n.NOP8 = 183] = "NOP8", n[n.NOP9 = 184] = "NOP9", n[n.NOP10 = 185] = "NOP10", n[n.CHECKSIGADD = 186] = "CHECKSIGADD", n[n.INVALID = 255] = "INVALID";
})(OP || (OP = {}));
function ScriptNum(n = 6, c = !1) {
  return wrap({
    encodeStream: (u, p) => {
      if (p === 0n)
        return;
      const a = p < 0, A = BigInt(p), b = [];
      for (let F = a ? -A : A; F; F >>= 8n)
        b.push(Number(F & 0xffn));
      b[b.length - 1] >= 128 ? b.push(a ? 128 : 0) : a && (b[b.length - 1] |= 128), u.bytes(new Uint8Array(b));
    },
    decodeStream: (u) => {
      const p = u.leftBytes;
      if (p > n)
        throw new Error(`ScriptNum: number (${p}) bigger than limit=${n}`);
      if (p === 0)
        return 0n;
      if (c) {
        const b = u.bytes(p, !0);
        if (!(b[b.length - 1] & 127) && (p <= 1 || !(b[b.length - 2] & 128)))
          throw new Error("Non-minimally encoded ScriptNum");
      }
      let a = 0, A = 0n;
      for (let b = 0; b < p; ++b)
        a = u.byte(), A |= BigInt(a) << 8n * BigInt(b);
      return a >= 128 && (A &= 2n ** BigInt(p * 8) - 1n >> 1n, A = -A), A;
    }
  });
}
function OpToNum(n, c = 4, u = !0) {
  if (typeof n == "number")
    return n;
  if (isBytes$3(n))
    try {
      const p = ScriptNum(c, u).decode(n);
      return p > Number.MAX_SAFE_INTEGER ? void 0 : Number(p);
    } catch {
      return;
    }
}
const Script$1 = wrap({
  encodeStream: (n, c) => {
    for (let u of c) {
      if (typeof u == "string") {
        if (OP[u] === void 0)
          throw new Error(`Unknown opcode=${u}`);
        n.byte(OP[u]);
        continue;
      } else if (typeof u == "number") {
        if (u === 0) {
          n.byte(0);
          continue;
        } else if (1 <= u && u <= 16) {
          n.byte(OP.OP_1 - 1 + u);
          continue;
        }
      }
      if (typeof u == "number" && (u = ScriptNum().encode(BigInt(u))), !isBytes$3(u))
        throw new Error(`Wrong Script OP=${u} (${typeof u})`);
      const p = u.length;
      p < OP.PUSHDATA1 ? n.byte(p) : p <= 255 ? (n.byte(OP.PUSHDATA1), n.byte(p)) : p <= 65535 ? (n.byte(OP.PUSHDATA2), n.bytes(U16LE.encode(p))) : (n.byte(OP.PUSHDATA4), n.bytes(U32LE.encode(p))), n.bytes(u);
    }
  },
  decodeStream: (n) => {
    const c = [];
    for (; !n.isEnd(); ) {
      const u = n.byte();
      if (OP.OP_0 < u && u <= OP.PUSHDATA4) {
        let p;
        if (u < OP.PUSHDATA1)
          p = u;
        else if (u === OP.PUSHDATA1)
          p = U8.decodeStream(n);
        else if (u === OP.PUSHDATA2)
          p = U16LE.decodeStream(n);
        else if (u === OP.PUSHDATA4)
          p = U32LE.decodeStream(n);
        else
          throw new Error("Should be not possible");
        c.push(n.bytes(p));
      } else if (u === 0)
        c.push(0);
      else if (OP.OP_1 <= u && u <= OP.OP_16)
        c.push(u - (OP.OP_1 - 1));
      else {
        const p = OP[u];
        if (p === void 0)
          throw new Error(`Unknown opcode=${u.toString(16)}`);
        c.push(p);
      }
    }
    return c;
  }
}), CSLimits = {
  253: [253, 2, 253n, 65535n],
  254: [254, 4, 65536n, 4294967295n],
  255: [255, 8, 4294967296n, 18446744073709551615n]
}, CompactSize = wrap({
  encodeStream: (n, c) => {
    if (typeof c == "number" && (c = BigInt(c)), 0n <= c && c <= 252n)
      return n.byte(Number(c));
    for (const [u, p, a, A] of Object.values(CSLimits))
      if (!(a > c || c > A)) {
        n.byte(u);
        for (let b = 0; b < p; b++)
          n.byte(Number(c >> 8n * BigInt(b) & 0xffn));
        return;
      }
    throw n.err(`VarInt too big: ${c}`);
  },
  decodeStream: (n) => {
    const c = n.byte();
    if (c <= 252)
      return BigInt(c);
    const [u, p, a] = CSLimits[c];
    let A = 0n;
    for (let b = 0; b < p; b++)
      A |= BigInt(n.byte()) << 8n * BigInt(b);
    if (A < a)
      throw n.err(`Wrong CompactSize(${8 * p})`);
    return A;
  }
}), CompactSizeLen = apply(CompactSize, coders.numberBigint), VarBytes = createBytes(CompactSize), RawWitness = array(CompactSizeLen, VarBytes), BTCArray = (n) => array(CompactSize, n), RawInput = struct({
  txid: createBytes(32, !0),
  // hash(prev_tx),
  index: U32LE,
  // output number of previous tx
  finalScriptSig: VarBytes,
  // btc merges input and output script, executes it. If ok = tx passes
  sequence: U32LE
  // ?
}), RawOutput = struct({ amount: U64LE, script: VarBytes }), _RawTx = struct({
  version: I32LE,
  segwitFlag: flag(new Uint8Array([0, 1])),
  inputs: BTCArray(RawInput),
  outputs: BTCArray(RawOutput),
  witnesses: flagged("segwitFlag", array("inputs/length", RawWitness)),
  // < 500000000	Block number at which this transaction is unlocked
  // >= 500000000	UNIX timestamp at which this transaction is unlocked
  // Handled as part of PSBTv2
  lockTime: U32LE
});
function validateRawTx(n) {
  if (n.segwitFlag && n.witnesses && !n.witnesses.length)
    throw new Error("Segwit flag with empty witnesses array");
  return n;
}
const RawTx = validate(_RawTx, validateRawTx), RawOldTx = struct({
  version: I32LE,
  inputs: BTCArray(RawInput),
  outputs: BTCArray(RawOutput),
  lockTime: U32LE
}), PubKeyECDSA = validate(createBytes(null), (n) => validatePubkey(n, PubT.ecdsa)), PubKeySchnorr = validate(createBytes(32), (n) => validatePubkey(n, PubT.schnorr)), SignatureSchnorr = validate(createBytes(null), (n) => {
  if (n.length !== 64 && n.length !== 65)
    throw new Error("Schnorr signature should be 64 or 65 bytes long");
  return n;
}), BIP32Der = struct({
  fingerprint: U32BE,
  path: array(null, U32LE)
}), TaprootBIP32Der = struct({
  hashes: array(CompactSizeLen, createBytes(32)),
  der: BIP32Der
}), GlobalXPUB = createBytes(78), tapScriptSigKey = struct({ pubKey: PubKeySchnorr, leafHash: createBytes(32) }), _TaprootControlBlock = struct({
  version: U8,
  // With parity :(
  internalKey: createBytes(32),
  merklePath: array(null, createBytes(32))
}), TaprootControlBlock = validate(_TaprootControlBlock, (n) => {
  if (n.merklePath.length > 128)
    throw new Error("TaprootControlBlock: merklePath should be of length 0..128 (inclusive)");
  return n;
}), tapTree = array(null, struct({
  depth: U8,
  version: U8,
  script: VarBytes
})), BytesInf = createBytes(null), Bytes20 = createBytes(20), Bytes32 = createBytes(32), PSBTGlobal = {
  unsignedTx: [0, !1, RawOldTx, [0], [0], !1],
  xpub: [1, GlobalXPUB, BIP32Der, [], [0, 2], !1],
  txVersion: [2, !1, U32LE, [2], [2], !1],
  fallbackLocktime: [3, !1, U32LE, [], [2], !1],
  inputCount: [4, !1, CompactSizeLen, [2], [2], !1],
  outputCount: [5, !1, CompactSizeLen, [2], [2], !1],
  txModifiable: [6, !1, U8, [], [2], !1],
  // TODO: bitfield
  version: [251, !1, U32LE, [], [0, 2], !1],
  proprietary: [252, BytesInf, BytesInf, [], [0, 2], !1]
}, PSBTInput = {
  nonWitnessUtxo: [0, !1, RawTx, [], [0, 2], !1],
  witnessUtxo: [1, !1, RawOutput, [], [0, 2], !1],
  partialSig: [2, PubKeyECDSA, BytesInf, [], [0, 2], !1],
  sighashType: [3, !1, U32LE, [], [0, 2], !1],
  redeemScript: [4, !1, BytesInf, [], [0, 2], !1],
  witnessScript: [5, !1, BytesInf, [], [0, 2], !1],
  bip32Derivation: [6, PubKeyECDSA, BIP32Der, [], [0, 2], !1],
  finalScriptSig: [7, !1, BytesInf, [], [0, 2], !1],
  finalScriptWitness: [8, !1, RawWitness, [], [0, 2], !1],
  porCommitment: [9, !1, BytesInf, [], [0, 2], !1],
  ripemd160: [10, Bytes20, BytesInf, [], [0, 2], !1],
  sha256: [11, Bytes32, BytesInf, [], [0, 2], !1],
  hash160: [12, Bytes20, BytesInf, [], [0, 2], !1],
  hash256: [13, Bytes32, BytesInf, [], [0, 2], !1],
  txid: [14, !1, Bytes32, [2], [2], !0],
  index: [15, !1, U32LE, [2], [2], !0],
  sequence: [16, !1, U32LE, [], [2], !0],
  requiredTimeLocktime: [17, !1, U32LE, [], [2], !1],
  requiredHeightLocktime: [18, !1, U32LE, [], [2], !1],
  tapKeySig: [19, !1, SignatureSchnorr, [], [0, 2], !1],
  tapScriptSig: [20, tapScriptSigKey, SignatureSchnorr, [], [0, 2], !1],
  tapLeafScript: [21, TaprootControlBlock, BytesInf, [], [0, 2], !1],
  tapBip32Derivation: [22, Bytes32, TaprootBIP32Der, [], [0, 2], !1],
  tapInternalKey: [23, !1, PubKeySchnorr, [], [0, 2], !1],
  tapMerkleRoot: [24, !1, Bytes32, [], [0, 2], !1],
  proprietary: [252, BytesInf, BytesInf, [], [0, 2], !1]
}, PSBTInputFinalKeys = [
  "txid",
  "sequence",
  "index",
  "witnessUtxo",
  "nonWitnessUtxo",
  "finalScriptSig",
  "finalScriptWitness",
  "unknown"
], PSBTInputUnsignedKeys = [
  "partialSig",
  "finalScriptSig",
  "finalScriptWitness",
  "tapKeySig",
  "tapScriptSig"
], PSBTOutput = {
  redeemScript: [0, !1, BytesInf, [], [0, 2], !1],
  witnessScript: [1, !1, BytesInf, [], [0, 2], !1],
  bip32Derivation: [2, PubKeyECDSA, BIP32Der, [], [0, 2], !1],
  amount: [3, !1, I64LE, [2], [2], !0],
  script: [4, !1, BytesInf, [2], [2], !0],
  tapInternalKey: [5, !1, PubKeySchnorr, [], [0, 2], !1],
  tapTree: [6, !1, tapTree, [], [0, 2], !1],
  tapBip32Derivation: [7, PubKeySchnorr, TaprootBIP32Der, [], [0, 2], !1],
  proprietary: [252, BytesInf, BytesInf, [], [0, 2], !1]
}, PSBTOutputUnsignedKeys = [], PSBTKeyPair = array(NULL, struct({
  //  <key> := <keylen> <keytype> <keydata> WHERE keylen = len(keytype)+len(keydata)
  key: prefix(CompactSizeLen, struct({ type: CompactSizeLen, key: createBytes(null) })),
  //  <value> := <valuelen> <valuedata>
  value: createBytes(CompactSizeLen)
}));
function PSBTKeyInfo(n) {
  const [c, u, p, a, A, b] = n;
  return { type: c, kc: u, vc: p, reqInc: a, allowInc: A, silentIgnore: b };
}
struct({ type: CompactSizeLen, key: createBytes(null) });
function PSBTKeyMap(n) {
  const c = {};
  for (const u in n) {
    const [p, a, A] = n[u];
    c[p] = [u, a, A];
  }
  return wrap({
    encodeStream: (u, p) => {
      let a = [];
      for (const A in n) {
        const b = p[A];
        if (b === void 0)
          continue;
        const [F, le, L] = n[A];
        if (!le)
          a.push({ key: { type: F, key: EMPTY }, value: L.encode(b) });
        else {
          const pe = b.map(([$, Ee]) => [
            le.encode($),
            L.encode(Ee)
          ]);
          pe.sort(($, Ee) => compareBytes($[0], Ee[0]));
          for (const [$, Ee] of pe)
            a.push({ key: { key: $, type: F }, value: Ee });
        }
      }
      if (p.unknown) {
        p.unknown.sort((A, b) => compareBytes(A[0].key, b[0].key));
        for (const [A, b] of p.unknown)
          a.push({ key: A, value: b });
      }
      PSBTKeyPair.encodeStream(u, a);
    },
    decodeStream: (u) => {
      const p = PSBTKeyPair.decodeStream(u), a = {}, A = {};
      for (const b of p) {
        let F = "unknown", le = b.key.key, L = b.value;
        if (c[b.key.type]) {
          const [pe, $, Ee] = c[b.key.type];
          if (F = pe, !$ && le.length)
            throw new Error(`PSBT: Non-empty key for ${F} (key=${hex$1.encode(le)} value=${hex$1.encode(L)}`);
          if (le = $ ? $.decode(le) : void 0, L = Ee.decode(L), !$) {
            if (a[F])
              throw new Error(`PSBT: Same keys: ${F} (key=${le} value=${L})`);
            a[F] = L, A[F] = !0;
            continue;
          }
        } else
          le = { type: b.key.type, key: b.key.key };
        if (A[F])
          throw new Error(`PSBT: Key type with empty key and no key=${F} val=${L}`);
        a[F] || (a[F] = []), a[F].push([le, L]);
      }
      return a;
    }
  });
}
const PSBTInputCoder = validate(PSBTKeyMap(PSBTInput), (n) => {
  if (n.finalScriptWitness && !n.finalScriptWitness.length)
    throw new Error("validateInput: empty finalScriptWitness");
  if (n.partialSig && !n.partialSig.length)
    throw new Error("Empty partialSig");
  if (n.partialSig)
    for (const [c] of n.partialSig)
      validatePubkey(c, PubT.ecdsa);
  if (n.bip32Derivation)
    for (const [c] of n.bip32Derivation)
      validatePubkey(c, PubT.ecdsa);
  if (n.requiredTimeLocktime !== void 0 && n.requiredTimeLocktime < 5e8)
    throw new Error(`validateInput: wrong timeLocktime=${n.requiredTimeLocktime}`);
  if (n.requiredHeightLocktime !== void 0 && (n.requiredHeightLocktime <= 0 || n.requiredHeightLocktime >= 5e8))
    throw new Error(`validateInput: wrong heighLocktime=${n.requiredHeightLocktime}`);
  if (n.tapLeafScript)
    for (const [c, u] of n.tapLeafScript) {
      if ((c.version & 254) !== u[u.length - 1])
        throw new Error("validateInput: tapLeafScript version mimatch");
      if (u[u.length - 1] & 1)
        throw new Error("validateInput: tapLeafScript version has parity bit!");
    }
  return n;
}), PSBTOutputCoder = validate(PSBTKeyMap(PSBTOutput), (n) => {
  if (n.bip32Derivation)
    for (const [c] of n.bip32Derivation)
      validatePubkey(c, PubT.ecdsa);
  return n;
}), PSBTGlobalCoder = validate(PSBTKeyMap(PSBTGlobal), (n) => {
  if ((n.version || 0) === 0) {
    if (!n.unsignedTx)
      throw new Error("PSBTv0: missing unsignedTx");
    for (const u of n.unsignedTx.inputs)
      if (u.finalScriptSig && u.finalScriptSig.length)
        throw new Error("PSBTv0: input scriptSig found in unsignedTx");
  }
  return n;
}), _RawPSBTV0 = struct({
  magic: magic(string(new Uint8Array([255])), "psbt"),
  global: PSBTGlobalCoder,
  inputs: array("global/unsignedTx/inputs/length", PSBTInputCoder),
  outputs: array(null, PSBTOutputCoder)
}), _RawPSBTV2 = struct({
  magic: magic(string(new Uint8Array([255])), "psbt"),
  global: PSBTGlobalCoder,
  inputs: array("global/inputCount", PSBTInputCoder),
  outputs: array("global/outputCount", PSBTOutputCoder)
}), _DebugPSBT = struct({
  magic: magic(string(new Uint8Array([255])), "psbt"),
  items: array(null, apply(array(NULL, tuple([createHex(CompactSizeLen), createBytes(CompactSize)])), coders.dict()))
});
function validatePSBTFields(n, c, u) {
  for (const p in u) {
    if (p === "unknown" || !c[p])
      continue;
    const { allowInc: a } = PSBTKeyInfo(c[p]);
    if (!a.includes(n))
      throw new Error(`PSBTv${n}: field ${p} is not allowed`);
  }
  for (const p in c) {
    const { reqInc: a } = PSBTKeyInfo(c[p]);
    if (a.includes(n) && u[p] === void 0)
      throw new Error(`PSBTv${n}: missing required field ${p}`);
  }
}
function cleanPSBTFields(n, c, u) {
  const p = {};
  for (const a in u) {
    const A = a;
    if (A !== "unknown") {
      if (!c[A])
        continue;
      const { allowInc: b, silentIgnore: F } = PSBTKeyInfo(c[A]);
      if (!b.includes(n)) {
        if (F)
          continue;
        throw new Error(`Failed to serialize in PSBTv${n}: ${A} but versions allows inclusion=${b}`);
      }
    }
    p[A] = u[A];
  }
  return p;
}
function validatePSBT(n) {
  const c = n && n.global && n.global.version || 0;
  validatePSBTFields(c, PSBTGlobal, n.global);
  for (const b of n.inputs)
    validatePSBTFields(c, PSBTInput, b);
  for (const b of n.outputs)
    validatePSBTFields(c, PSBTOutput, b);
  const u = c ? n.global.inputCount : n.global.unsignedTx.inputs.length;
  if (n.inputs.length < u)
    throw new Error("Not enough inputs");
  const p = n.inputs.slice(u);
  if (p.length > 1 || p.length && Object.keys(p[0]).length)
    throw new Error(`Unexpected inputs left in tx=${p}`);
  const a = c ? n.global.outputCount : n.global.unsignedTx.outputs.length;
  if (n.outputs.length < a)
    throw new Error("Not outputs inputs");
  const A = n.outputs.slice(a);
  if (A.length > 1 || A.length && Object.keys(A[0]).length)
    throw new Error(`Unexpected outputs left in tx=${A}`);
  return n;
}
function mergeKeyMap(n, c, u, p, a) {
  const A = { ...u, ...c };
  for (const b in n) {
    const F = b, [le, L, pe] = n[F], $ = p && !p.includes(b);
    if (c[b] === void 0 && b in c) {
      if ($)
        throw new Error(`Cannot remove signed field=${b}`);
      delete A[b];
    } else if (L) {
      const Ee = u && u[b] ? u[b] : [];
      let be = c[F];
      if (be) {
        if (!Array.isArray(be))
          throw new Error(`keyMap(${b}): KV pairs should be [k, v][]`);
        be = be.map((nr) => {
          if (nr.length !== 2)
            throw new Error(`keyMap(${b}): KV pairs should be [k, v][]`);
          return [
            typeof nr[0] == "string" ? L.decode(hex$1.decode(nr[0])) : nr[0],
            typeof nr[1] == "string" ? pe.decode(hex$1.decode(nr[1])) : nr[1]
          ];
        });
        const He = {}, Pe = (nr, ir, or) => {
          if (He[nr] === void 0) {
            He[nr] = [ir, or];
            return;
          }
          const lr = hex$1.encode(pe.encode(He[nr][1])), Ir = hex$1.encode(pe.encode(or));
          if (lr !== Ir)
            throw new Error(`keyMap(${F}): same key=${nr} oldVal=${lr} newVal=${Ir}`);
        };
        for (const [nr, ir] of Ee) {
          const or = hex$1.encode(L.encode(nr));
          Pe(or, nr, ir);
        }
        for (const [nr, ir] of be) {
          const or = hex$1.encode(L.encode(nr));
          if (ir === void 0) {
            if ($)
              throw new Error(`Cannot remove signed field=${F}/${nr}`);
            delete He[or];
          } else
            Pe(or, nr, ir);
        }
        A[F] = Object.values(He);
      }
    } else if (typeof A[b] == "string")
      A[b] = pe.decode(hex$1.decode(A[b]));
    else if ($ && b in c && u && u[b] !== void 0 && !equalBytes$1(pe.encode(c[b]), pe.encode(u[b])))
      throw new Error(`Cannot change signed field=${b}`);
  }
  for (const b in A)
    if (!n[b]) {
      if (a && b === "unknown")
        continue;
      delete A[b];
    }
  return A;
}
const RawPSBTV0 = validate(_RawPSBTV0, validatePSBT), RawPSBTV2 = validate(_RawPSBTV2, validatePSBT), OutP2A = {
  encode(n) {
    if (!(n.length !== 2 || n[0] !== 1 || !isBytes$3(n[1]) || hex$1.encode(n[1]) !== "4e73"))
      return { type: "p2a", script: Script$1.encode(n) };
  },
  decode: (n) => {
    if (n.type === "p2a")
      return [1, hex$1.decode("4e73")];
  }
};
function isValidPubkey(n, c) {
  try {
    return validatePubkey(n, c), !0;
  } catch {
    return !1;
  }
}
const OutPK = {
  encode(n) {
    if (!(n.length !== 2 || !isBytes$3(n[0]) || !isValidPubkey(n[0], PubT.ecdsa) || n[1] !== "CHECKSIG"))
      return { type: "pk", pubkey: n[0] };
  },
  decode: (n) => n.type === "pk" ? [n.pubkey, "CHECKSIG"] : void 0
}, OutPKH = {
  encode(n) {
    if (!(n.length !== 5 || n[0] !== "DUP" || n[1] !== "HASH160" || !isBytes$3(n[2])) && !(n[3] !== "EQUALVERIFY" || n[4] !== "CHECKSIG"))
      return { type: "pkh", hash: n[2] };
  },
  decode: (n) => n.type === "pkh" ? ["DUP", "HASH160", n.hash, "EQUALVERIFY", "CHECKSIG"] : void 0
}, OutSH = {
  encode(n) {
    if (!(n.length !== 3 || n[0] !== "HASH160" || !isBytes$3(n[1]) || n[2] !== "EQUAL"))
      return { type: "sh", hash: n[1] };
  },
  decode: (n) => n.type === "sh" ? ["HASH160", n.hash, "EQUAL"] : void 0
}, OutWSH = {
  encode(n) {
    if (!(n.length !== 2 || n[0] !== 0 || !isBytes$3(n[1])) && n[1].length === 32)
      return { type: "wsh", hash: n[1] };
  },
  decode: (n) => n.type === "wsh" ? [0, n.hash] : void 0
}, OutWPKH = {
  encode(n) {
    if (!(n.length !== 2 || n[0] !== 0 || !isBytes$3(n[1])) && n[1].length === 20)
      return { type: "wpkh", hash: n[1] };
  },
  decode: (n) => n.type === "wpkh" ? [0, n.hash] : void 0
}, OutMS = {
  encode(n) {
    const c = n.length - 1;
    if (n[c] !== "CHECKMULTISIG")
      return;
    const u = n[0], p = n[c - 1];
    if (typeof u != "number" || typeof p != "number")
      return;
    const a = n.slice(1, -2);
    if (p === a.length) {
      for (const A of a)
        if (!isBytes$3(A))
          return;
      return { type: "ms", m: u, pubkeys: a };
    }
  },
  // checkmultisig(n, ..pubkeys, m)
  decode: (n) => n.type === "ms" ? [n.m, ...n.pubkeys, n.pubkeys.length, "CHECKMULTISIG"] : void 0
}, OutTR = {
  encode(n) {
    if (!(n.length !== 2 || n[0] !== 1 || !isBytes$3(n[1])))
      return { type: "tr", pubkey: n[1] };
  },
  decode: (n) => n.type === "tr" ? [1, n.pubkey] : void 0
}, OutTRNS = {
  encode(n) {
    const c = n.length - 1;
    if (n[c] !== "CHECKSIG")
      return;
    const u = [];
    for (let p = 0; p < c; p++) {
      const a = n[p];
      if (p & 1) {
        if (a !== "CHECKSIGVERIFY" || p === c - 1)
          return;
        continue;
      }
      if (!isBytes$3(a))
        return;
      u.push(a);
    }
    return { type: "tr_ns", pubkeys: u };
  },
  decode: (n) => {
    if (n.type !== "tr_ns")
      return;
    const c = [];
    for (let u = 0; u < n.pubkeys.length - 1; u++)
      c.push(n.pubkeys[u], "CHECKSIGVERIFY");
    return c.push(n.pubkeys[n.pubkeys.length - 1], "CHECKSIG"), c;
  }
}, OutTRMS = {
  encode(n) {
    const c = n.length - 1;
    if (n[c] !== "NUMEQUAL" || n[1] !== "CHECKSIG")
      return;
    const u = [], p = OpToNum(n[c - 1]);
    if (typeof p == "number") {
      for (let a = 0; a < c - 1; a++) {
        const A = n[a];
        if (a & 1) {
          if (A !== (a === 1 ? "CHECKSIG" : "CHECKSIGADD"))
            throw new Error("OutScript.encode/tr_ms: wrong element");
          continue;
        }
        if (!isBytes$3(A))
          throw new Error("OutScript.encode/tr_ms: wrong key element");
        u.push(A);
      }
      return { type: "tr_ms", pubkeys: u, m: p };
    }
  },
  decode: (n) => {
    if (n.type !== "tr_ms")
      return;
    const c = [n.pubkeys[0], "CHECKSIG"];
    for (let u = 1; u < n.pubkeys.length; u++)
      c.push(n.pubkeys[u], "CHECKSIGADD");
    return c.push(n.m, "NUMEQUAL"), c;
  }
}, OutUnknown = {
  encode(n) {
    return { type: "unknown", script: Script$1.encode(n) };
  },
  decode: (n) => n.type === "unknown" ? Script$1.decode(n.script) : void 0
}, OutScripts = [
  OutP2A,
  OutPK,
  OutPKH,
  OutSH,
  OutWSH,
  OutWPKH,
  OutMS,
  OutTR,
  OutTRNS,
  OutTRMS,
  OutUnknown
], _OutScript = apply(Script$1, coders.match(OutScripts)), OutScript = validate(_OutScript, (n) => {
  if (n.type === "pk" && !isValidPubkey(n.pubkey, PubT.ecdsa))
    throw new Error("OutScript/pk: wrong key");
  if ((n.type === "pkh" || n.type === "sh" || n.type === "wpkh") && (!isBytes$3(n.hash) || n.hash.length !== 20))
    throw new Error(`OutScript/${n.type}: wrong hash`);
  if (n.type === "wsh" && (!isBytes$3(n.hash) || n.hash.length !== 32))
    throw new Error("OutScript/wsh: wrong hash");
  if (n.type === "tr" && (!isBytes$3(n.pubkey) || !isValidPubkey(n.pubkey, PubT.schnorr)))
    throw new Error("OutScript/tr: wrong taproot public key");
  if ((n.type === "ms" || n.type === "tr_ns" || n.type === "tr_ms") && !Array.isArray(n.pubkeys))
    throw new Error("OutScript/multisig: wrong pubkeys array");
  if (n.type === "ms") {
    const c = n.pubkeys.length;
    for (const u of n.pubkeys)
      if (!isValidPubkey(u, PubT.ecdsa))
        throw new Error("OutScript/multisig: wrong pubkey");
    if (n.m <= 0 || c > 16 || n.m > c)
      throw new Error("OutScript/multisig: invalid params");
  }
  if (n.type === "tr_ns" || n.type === "tr_ms") {
    for (const c of n.pubkeys)
      if (!isValidPubkey(c, PubT.schnorr))
        throw new Error(`OutScript/${n.type}: wrong pubkey`);
  }
  if (n.type === "tr_ms") {
    const c = n.pubkeys.length;
    if (n.m <= 0 || c > 999 || n.m > c)
      throw new Error("OutScript/tr_ms: invalid params");
  }
  return n;
});
function checkWSH(n, c) {
  if (!equalBytes$1(n.hash, sha256$5(c)))
    throw new Error("checkScript: wsh wrong witnessScript hash");
  const u = OutScript.decode(c);
  if (u.type === "tr" || u.type === "tr_ns" || u.type === "tr_ms")
    throw new Error(`checkScript: P2${u.type} cannot be wrapped in P2SH`);
  if (u.type === "wpkh" || u.type === "sh")
    throw new Error(`checkScript: P2${u.type} cannot be wrapped in P2WSH`);
}
function checkScript(n, c, u) {
  if (n) {
    const p = OutScript.decode(n);
    if (p.type === "tr_ns" || p.type === "tr_ms" || p.type === "ms" || p.type == "pk")
      throw new Error(`checkScript: non-wrapped ${p.type}`);
    if (p.type === "sh" && c) {
      if (!equalBytes$1(p.hash, hash160$2(c)))
        throw new Error("checkScript: sh wrong redeemScript hash");
      const a = OutScript.decode(c);
      if (a.type === "tr" || a.type === "tr_ns" || a.type === "tr_ms")
        throw new Error(`checkScript: P2${a.type} cannot be wrapped in P2SH`);
      if (a.type === "sh")
        throw new Error("checkScript: P2SH cannot be wrapped in P2SH");
    }
    p.type === "wsh" && u && checkWSH(p, u);
  }
  if (c) {
    const p = OutScript.decode(c);
    p.type === "wsh" && u && checkWSH(p, u);
  }
}
function uniqPubkey(n) {
  const c = {};
  for (const u of n) {
    const p = hex$1.encode(u);
    if (c[p])
      throw new Error(`Multisig: non-uniq pubkey: ${n.map(hex$1.encode)}`);
    c[p] = !0;
  }
}
const p2pk$1 = (n, c = NETWORK) => {
  if (!isValidPubkey(n, PubT.ecdsa))
    throw new Error("P2PK: invalid publicKey");
  return { type: "pk", script: OutScript.encode({ type: "pk", pubkey: n }) };
}, p2pkh$1 = (n, c = NETWORK) => {
  if (!isValidPubkey(n, PubT.ecdsa))
    throw new Error("P2PKH: invalid publicKey");
  const u = hash160$2(n);
  return {
    type: "pkh",
    script: OutScript.encode({ type: "pkh", hash: u }),
    address: Address$1(c).encode({ type: "pkh", hash: u }),
    hash: u
  };
}, p2sh$1 = (n, c = NETWORK) => {
  const u = n.script;
  if (!isBytes$3(u))
    throw new Error(`Wrong script: ${typeof n.script}, expected Uint8Array`);
  const p = hash160$2(u), a = OutScript.encode({ type: "sh", hash: p });
  return checkScript(a, u, n.witnessScript), n.witnessScript ? {
    type: "sh",
    redeemScript: u,
    script: OutScript.encode({ type: "sh", hash: p }),
    address: Address$1(c).encode({ type: "sh", hash: p }),
    hash: p,
    witnessScript: n.witnessScript
  } : {
    type: "sh",
    redeemScript: u,
    script: OutScript.encode({ type: "sh", hash: p }),
    address: Address$1(c).encode({ type: "sh", hash: p }),
    hash: p
  };
}, p2wsh$1 = (n, c = NETWORK) => {
  const u = n.script;
  if (!isBytes$3(u))
    throw new Error(`Wrong script: ${typeof u}, expected Uint8Array`);
  const p = sha256$5(u), a = OutScript.encode({ type: "wsh", hash: p });
  return checkScript(a, void 0, u), {
    type: "wsh",
    witnessScript: u,
    script: OutScript.encode({ type: "wsh", hash: p }),
    address: Address$1(c).encode({ type: "wsh", hash: p }),
    hash: p
  };
}, p2wpkh$1 = (n, c = NETWORK) => {
  if (!isValidPubkey(n, PubT.ecdsa))
    throw new Error("P2WPKH: invalid publicKey");
  if (n.length === 65)
    throw new Error("P2WPKH: uncompressed public key");
  const u = hash160$2(n);
  return {
    type: "wpkh",
    script: OutScript.encode({ type: "wpkh", hash: u }),
    address: Address$1(c).encode({ type: "wpkh", hash: u }),
    hash: u
  };
}, p2ms = (n, c, u = !1) => (u || uniqPubkey(c), {
  type: "ms",
  script: OutScript.encode({ type: "ms", pubkeys: c, m: n })
});
function checkTaprootScript(n, c, u = !1, p) {
  const a = OutScript.decode(n);
  if (a.type === "unknown") {
    if (p) {
      const F = apply(Script$1, coders.match(p)).decode(n);
      if (F !== void 0) {
        if (typeof F.type != "string" || !F.type.startsWith("tr_"))
          throw new Error(`P2TR: invalid custom type=${F.type}`);
        return;
      }
    }
    if (u)
      return;
  }
  if (!["tr_ns", "tr_ms"].includes(a.type))
    throw new Error(`P2TR: invalid leaf script=${a.type}`);
  const A = a;
  if (!u && A.pubkeys)
    for (const b of A.pubkeys) {
      if (equalBytes$1(b, TAPROOT_UNSPENDABLE_KEY))
        throw new Error("Unspendable taproot key in leaf script");
      if (equalBytes$1(b, c))
        throw new Error("Using P2TR with leaf script with same key as internal key is not supported");
    }
}
function taprootListToTree(n) {
  const c = Array.from(n);
  for (; c.length >= 2; ) {
    c.sort((b, F) => (F.weight || 1) - (b.weight || 1));
    const p = c.pop(), a = c.pop(), A = ((a == null ? void 0 : a.weight) || 1) + ((p == null ? void 0 : p.weight) || 1);
    c.push({
      weight: A,
      // Unwrap children array
      // TODO: Very hard to remove any here
      childs: [(a == null ? void 0 : a.childs) || a, (p == null ? void 0 : p.childs) || p]
    });
  }
  const u = c[0];
  return (u == null ? void 0 : u.childs) || u;
}
function taprootAddPath(n, c = []) {
  if (!n)
    throw new Error("taprootAddPath: empty tree");
  if (n.type === "leaf")
    return { ...n, path: c };
  if (n.type !== "branch")
    throw new Error(`taprootAddPath: wrong type=${n}`);
  return {
    ...n,
    path: c,
    // Left element has right hash in path and otherwise
    left: taprootAddPath(n.left, [n.right.hash, ...c]),
    right: taprootAddPath(n.right, [n.left.hash, ...c])
  };
}
function taprootWalkTree(n) {
  if (!n)
    throw new Error("taprootAddPath: empty tree");
  if (n.type === "leaf")
    return [n];
  if (n.type !== "branch")
    throw new Error(`taprootWalkTree: wrong type=${n}`);
  return [...taprootWalkTree(n.left), ...taprootWalkTree(n.right)];
}
function taprootHashTree(n, c, u = !1, p) {
  if (!n)
    throw new Error("taprootHashTree: empty tree");
  if (Array.isArray(n) && n.length === 1 && (n = n[0]), !Array.isArray(n)) {
    const { leafVersion: le, script: L } = n;
    if (n.tapLeafScript || n.tapMerkleRoot && !equalBytes$1(n.tapMerkleRoot, EMPTY))
      throw new Error("P2TR: tapRoot leafScript cannot have tree");
    const pe = typeof L == "string" ? hex$1.decode(L) : L;
    if (!isBytes$3(pe))
      throw new Error(`checkScript: wrong script type=${pe}`);
    return checkTaprootScript(pe, c, u, p), {
      type: "leaf",
      version: le,
      script: pe,
      hash: tapLeafHash(pe, le)
    };
  }
  if (n.length !== 2 && (n = taprootListToTree(n)), n.length !== 2)
    throw new Error("hashTree: non binary tree!");
  const a = taprootHashTree(n[0], c, u, p), A = taprootHashTree(n[1], c, u, p);
  let [b, F] = [a.hash, A.hash];
  return compareBytes(F, b) === -1 && ([b, F] = [F, b]), { type: "branch", left: a, right: A, hash: tagSchnorr("TapBranch", b, F) };
}
const TAP_LEAF_VERSION = 192, tapLeafHash = (n, c = TAP_LEAF_VERSION) => tagSchnorr("TapLeaf", new Uint8Array([c]), VarBytes.encode(n));
function p2tr$1(n, c, u = NETWORK, p = !1, a) {
  if (!n && !c)
    throw new Error("p2tr: should have pubKey or scriptTree (or both)");
  const A = typeof n == "string" ? hex$1.decode(n) : n || TAPROOT_UNSPENDABLE_KEY;
  if (!isValidPubkey(A, PubT.schnorr))
    throw new Error("p2tr: non-schnorr pubkey");
  if (c) {
    let b = taprootAddPath(taprootHashTree(c, A, p, a));
    const F = b.hash, [le, L] = taprootTweakPubkey(A, F), pe = taprootWalkTree(b).map(($) => ({
      ...$,
      controlBlock: TaprootControlBlock.encode({
        version: ($.version || TAP_LEAF_VERSION) + L,
        internalKey: A,
        merklePath: $.path
      })
    }));
    return {
      type: "tr",
      script: OutScript.encode({ type: "tr", pubkey: le }),
      address: Address$1(u).encode({ type: "tr", pubkey: le }),
      // For tests
      tweakedPubkey: le,
      // PSBT stuff
      tapInternalKey: A,
      leaves: pe,
      tapLeafScript: pe.map(($) => [
        TaprootControlBlock.decode($.controlBlock),
        concatBytes$2($.script, new Uint8Array([$.version || TAP_LEAF_VERSION]))
      ]),
      tapMerkleRoot: F
    };
  } else {
    const b = taprootTweakPubkey(A, EMPTY)[0];
    return {
      type: "tr",
      script: OutScript.encode({ type: "tr", pubkey: b }),
      address: Address$1(u).encode({ type: "tr", pubkey: b }),
      // For tests
      tweakedPubkey: b,
      // PSBT stuff
      tapInternalKey: A
    };
  }
}
function combinations(n, c) {
  const u = [];
  if (!Array.isArray(c))
    throw new Error("combinations: lst arg should be array");
  const p = c.length;
  if (n > p)
    throw new Error("combinations: m > lst.length, no combinations possible");
  const a = Array.from({ length: n }, (b, F) => F), A = a.length - 1;
  e: for (; ; ) {
    u.push(a.map((F) => c[F])), a[A] += 1;
    let b = A;
    for (; b >= 0 && a[b] > p - n + b; b--) {
      if (a[b] = 0, b === 0)
        break e;
      a[b - 1] += 1;
    }
    for (b += 1; b < a.length; b++)
      a[b] = a[b - 1] + 1;
  }
  return u;
}
const p2tr_ns = (n, c, u = !1) => (u || uniqPubkey(c), combinations(n, c).map((p) => ({
  type: "tr_ns",
  script: OutScript.encode({ type: "tr_ns", pubkeys: p })
}))), p2tr_pk = (n) => p2tr_ns(1, [n], void 0)[0];
function p2tr_ms(n, c, u = !1) {
  return u || uniqPubkey(c), {
    type: "tr_ms",
    script: OutScript.encode({ type: "tr_ms", pubkeys: c, m: n })
  };
}
function getAddress(n, c, u = NETWORK) {
  if (n === "tr")
    return p2tr$1(pubSchnorr(c), void 0, u).address;
  const p = pubECDSA(c);
  if (n === "pkh")
    return p2pkh$1(p, u).address;
  if (n === "wpkh")
    return p2wpkh$1(p, u).address;
  throw new Error(`getAddress: unknown type=${n}`);
}
const _sortPubkeys = (n) => Array.from(n).sort(compareBytes);
function multisig(n, c, u = !1, p = !1, a = NETWORK) {
  const A = p2ms(n, u ? _sortPubkeys(c) : c);
  return p ? p2wsh$1(A, a) : p2sh$1(A, a);
}
function sortedMultisig(n, c, u = !1, p = NETWORK) {
  return multisig(n, c, !0, u, p);
}
const base58check = createBase58check(sha256$5);
function validateWitness(n, c) {
  if (c.length < 2 || c.length > 40)
    throw new Error("Witness: invalid length");
  if (n > 16)
    throw new Error("Witness: invalid version");
  if (n === 0 && !(c.length === 20 || c.length === 32))
    throw new Error("Witness: invalid length for version");
}
function programToWitness(n, c, u = NETWORK) {
  validateWitness(n, c);
  const p = n === 0 ? bech32$2 : bech32m;
  return p.encode(u.bech32, [n].concat(p.toWords(c)));
}
function formatKey(n, c) {
  return base58check.encode(concatBytes$2(Uint8Array.from(c), n));
}
function WIF(n = NETWORK) {
  return {
    encode(c) {
      const u = concatBytes$2(c, new Uint8Array([1]));
      return formatKey(u.subarray(0, 33), [n.wif]);
    },
    decode(c) {
      let u = base58check.decode(c);
      if (u[0] !== n.wif)
        throw new Error("Wrong WIF prefix");
      if (u = u.subarray(1), u.length !== 33)
        throw new Error("Wrong WIF length");
      if (u[32] !== 1)
        throw new Error("Wrong WIF postfix");
      return u.subarray(0, -1);
    }
  };
}
function Address$1(n = NETWORK) {
  return {
    encode(c) {
      const { type: u } = c;
      if (u === "wpkh")
        return programToWitness(0, c.hash, n);
      if (u === "wsh")
        return programToWitness(0, c.hash, n);
      if (u === "tr")
        return programToWitness(1, c.pubkey, n);
      if (u === "pkh")
        return formatKey(c.hash, [n.pubKeyHash]);
      if (u === "sh")
        return formatKey(c.hash, [n.scriptHash]);
      throw new Error(`Unknown address type=${u}`);
    },
    decode(c) {
      if (c.length < 14 || c.length > 74)
        throw new Error("Invalid address length");
      if (n.bech32 && c.toLowerCase().startsWith(`${n.bech32}1`)) {
        let p;
        try {
          if (p = bech32$2.decode(c), p.words[0] !== 0)
            throw new Error(`bech32: wrong version=${p.words[0]}`);
        } catch {
          if (p = bech32m.decode(c), p.words[0] === 0)
            throw new Error(`bech32m: wrong version=${p.words[0]}`);
        }
        if (p.prefix !== n.bech32)
          throw new Error(`wrong bech32 prefix=${p.prefix}`);
        const [a, ...A] = p.words, b = bech32$2.fromWords(A);
        if (validateWitness(a, b), a === 0 && b.length === 32)
          return { type: "wsh", hash: b };
        if (a === 0 && b.length === 20)
          return { type: "wpkh", hash: b };
        if (a === 1 && b.length === 32)
          return { type: "tr", pubkey: b };
        throw new Error("Unknown witness program");
      }
      const u = base58check.decode(c);
      if (u.length !== 21)
        throw new Error("Invalid base58 address");
      if (u[0] === n.pubKeyHash)
        return { type: "pkh", hash: u.slice(1) };
      if (u[0] === n.scriptHash)
        return {
          type: "sh",
          hash: u.slice(1)
        };
      throw new Error(`Invalid address prefix=${u[0]}`);
    }
  };
}
const EMPTY32 = new Uint8Array(32), EMPTY_OUTPUT = {
  amount: 0xffffffffffffffffn,
  script: EMPTY
}, toVsize = (n) => Math.ceil(n / 4), PRECISION = 8, DEFAULT_VERSION$2 = 2, DEFAULT_LOCKTIME = 0, DEFAULT_SEQUENCE = 4294967295, Decimal = coders.decimal(PRECISION), def = (n, c) => n === void 0 ? c : n;
function cloneDeep(n) {
  if (Array.isArray(n))
    return n.map((c) => cloneDeep(c));
  if (isBytes$3(n))
    return Uint8Array.from(n);
  if (["number", "bigint", "boolean", "string", "undefined"].includes(typeof n))
    return n;
  if (n === null)
    return n;
  if (typeof n == "object")
    return Object.fromEntries(Object.entries(n).map(([c, u]) => [c, cloneDeep(u)]));
  throw new Error(`cloneDeep: unknown type=${n} (${typeof n})`);
}
var SignatureHash;
(function(n) {
  n[n.DEFAULT = 0] = "DEFAULT", n[n.ALL = 1] = "ALL", n[n.NONE = 2] = "NONE", n[n.SINGLE = 3] = "SINGLE", n[n.ANYONECANPAY = 128] = "ANYONECANPAY";
})(SignatureHash || (SignatureHash = {}));
var SigHash;
(function(n) {
  n[n.DEFAULT = 0] = "DEFAULT", n[n.ALL = 1] = "ALL", n[n.NONE = 2] = "NONE", n[n.SINGLE = 3] = "SINGLE", n[n.DEFAULT_ANYONECANPAY = 128] = "DEFAULT_ANYONECANPAY", n[n.ALL_ANYONECANPAY = 129] = "ALL_ANYONECANPAY", n[n.NONE_ANYONECANPAY = 130] = "NONE_ANYONECANPAY", n[n.SINGLE_ANYONECANPAY = 131] = "SINGLE_ANYONECANPAY";
})(SigHash || (SigHash = {}));
function getTaprootKeys(n, c, u, p = EMPTY) {
  return equalBytes$1(u, c) && (n = taprootTweakPrivKey(n, p), c = pubSchnorr(n)), { privKey: n, pubKey: c };
}
function outputBeforeSign(n) {
  if (n.script === void 0 || n.amount === void 0)
    throw new Error("Transaction/output: script and amount required");
  return { script: n.script, amount: n.amount };
}
function inputBeforeSign(n) {
  if (n.txid === void 0 || n.index === void 0)
    throw new Error("Transaction/input: txid and index required");
  return {
    txid: n.txid,
    index: n.index,
    sequence: def(n.sequence, DEFAULT_SEQUENCE),
    finalScriptSig: def(n.finalScriptSig, EMPTY)
  };
}
function cleanFinalInput(n) {
  for (const c in n) {
    const u = c;
    PSBTInputFinalKeys.includes(u) || delete n[u];
  }
}
const TxHashIdx = struct({ txid: createBytes(32, !0), index: U32LE });
function validateSigHash(n) {
  if (typeof n != "number" || typeof SigHash[n] != "string")
    throw new Error(`Invalid SigHash=${n}`);
  return n;
}
function unpackSighash(n) {
  const c = n & 31;
  return {
    isAny: !!(n & SignatureHash.ANYONECANPAY),
    isNone: c === SignatureHash.NONE,
    isSingle: c === SignatureHash.SINGLE
  };
}
function validateOpts$1(n) {
  if (n !== void 0 && {}.toString.call(n) !== "[object Object]")
    throw new Error(`Wrong object type for transaction options: ${n}`);
  const c = {
    ...n,
    // Defaults
    version: def(n.version, DEFAULT_VERSION$2),
    lockTime: def(n.lockTime, 0),
    PSBTVersion: def(n.PSBTVersion, 0)
  };
  if (typeof c.allowUnknowInput < "u" && (n.allowUnknownInputs = c.allowUnknowInput), typeof c.allowUnknowOutput < "u" && (n.allowUnknownOutputs = c.allowUnknowOutput), typeof c.lockTime != "number")
    throw new Error("Transaction lock time should be number");
  if (U32LE.encode(c.lockTime), c.PSBTVersion !== 0 && c.PSBTVersion !== 2)
    throw new Error(`Unknown PSBT version ${c.PSBTVersion}`);
  for (const u of [
    "allowUnknownVersion",
    "allowUnknownOutputs",
    "allowUnknownInputs",
    "disableScriptCheck",
    "bip174jsCompat",
    "allowLegacyWitnessUtxo",
    "lowR"
  ]) {
    const p = c[u];
    if (p !== void 0 && typeof p != "boolean")
      throw new Error(`Transation options wrong type: ${u}=${p} (${typeof p})`);
  }
  if (c.allowUnknownVersion ? typeof c.version == "number" : ![-1, 0, 1, 2, 3].includes(c.version))
    throw new Error(`Unknown version: ${c.version}`);
  if (c.customScripts !== void 0) {
    const u = c.customScripts;
    if (!Array.isArray(u))
      throw new Error(`wrong custom scripts type (expected array): customScripts=${u} (${typeof u})`);
    for (const p of u) {
      if (typeof p.encode != "function" || typeof p.decode != "function")
        throw new Error(`wrong script=${p} (${typeof p})`);
      if (p.finalizeTaproot !== void 0 && typeof p.finalizeTaproot != "function")
        throw new Error(`wrong script=${p} (${typeof p})`);
    }
  }
  return Object.freeze(c);
}
function validateInput(n) {
  if (n.nonWitnessUtxo && n.index !== void 0) {
    const c = n.nonWitnessUtxo.outputs.length - 1;
    if (n.index > c)
      throw new Error(`validateInput: index(${n.index}) not in nonWitnessUtxo`);
    const u = n.nonWitnessUtxo.outputs[n.index];
    if (n.witnessUtxo && (!equalBytes$1(n.witnessUtxo.script, u.script) || n.witnessUtxo.amount !== u.amount))
      throw new Error("validateInput: witnessUtxo different from nonWitnessUtxo");
    if (n.txid) {
      if (n.nonWitnessUtxo.outputs.length - 1 < n.index)
        throw new Error("nonWitnessUtxo: incorect output index");
      const a = Transaction$1.fromRaw(RawTx.encode(n.nonWitnessUtxo), {
        allowUnknownOutputs: !0,
        disableScriptCheck: !0,
        allowUnknownInputs: !0
      }), A = hex$1.encode(n.txid);
      if (a.isFinal && a.id !== A)
        throw new Error(`nonWitnessUtxo: wrong txid, exp=${A} got=${a.id}`);
    }
  }
  return n;
}
function getPrevOut(n) {
  if (n.nonWitnessUtxo) {
    if (n.index === void 0)
      throw new Error("Unknown input index");
    return n.nonWitnessUtxo.outputs[n.index];
  } else {
    if (n.witnessUtxo)
      return n.witnessUtxo;
    throw new Error("Cannot find previous output info");
  }
}
function normalizeInput(n, c, u, p = !1, a = !1) {
  let { nonWitnessUtxo: A, txid: b } = n;
  typeof A == "string" && (A = hex$1.decode(A)), isBytes$3(A) && (A = RawTx.decode(A)), !("nonWitnessUtxo" in n) && A === void 0 && (A = c == null ? void 0 : c.nonWitnessUtxo), typeof b == "string" && (b = hex$1.decode(b)), b === void 0 && (b = c == null ? void 0 : c.txid);
  let F = { ...c, ...n, nonWitnessUtxo: A, txid: b };
  !("nonWitnessUtxo" in n) && F.nonWitnessUtxo === void 0 && delete F.nonWitnessUtxo, F.sequence === void 0 && (F.sequence = DEFAULT_SEQUENCE), F.tapMerkleRoot === null && delete F.tapMerkleRoot, F = mergeKeyMap(PSBTInput, F, c, u, a), PSBTInputCoder.encode(F);
  let le;
  return F.nonWitnessUtxo && F.index !== void 0 ? le = F.nonWitnessUtxo.outputs[F.index] : F.witnessUtxo && (le = F.witnessUtxo), le && !p && checkScript(le && le.script, F.redeemScript, F.witnessScript), F;
}
function getInputType(n, c = !1) {
  let u = "legacy", p = SignatureHash.ALL;
  const a = getPrevOut(n), A = OutScript.decode(a.script);
  let b = A.type, F = A;
  const le = [A];
  if (A.type === "tr")
    return p = SignatureHash.DEFAULT, {
      txType: "taproot",
      type: "tr",
      last: A,
      lastScript: a.script,
      defaultSighash: p,
      sighash: n.sighashType || p
    };
  {
    if ((A.type === "wpkh" || A.type === "wsh") && (u = "segwit"), A.type === "sh") {
      if (!n.redeemScript)
        throw new Error("inputType: sh without redeemScript");
      let Ee = OutScript.decode(n.redeemScript);
      (Ee.type === "wpkh" || Ee.type === "wsh") && (u = "segwit"), le.push(Ee), F = Ee, b += `-${Ee.type}`;
    }
    if (F.type === "wsh") {
      if (!n.witnessScript)
        throw new Error("inputType: wsh without witnessScript");
      let Ee = OutScript.decode(n.witnessScript);
      Ee.type === "wsh" && (u = "segwit"), le.push(Ee), F = Ee, b += `-${Ee.type}`;
    }
    const L = le[le.length - 1];
    if (L.type === "sh" || L.type === "wsh")
      throw new Error("inputType: sh/wsh cannot be terminal type");
    const pe = OutScript.encode(L), $ = {
      type: b,
      txType: u,
      last: L,
      lastScript: pe,
      defaultSighash: p,
      sighash: n.sighashType || p
    };
    if (u === "legacy" && !c && !n.nonWitnessUtxo)
      throw new Error("Transaction/sign: legacy input without nonWitnessUtxo, can result in attack that forces paying higher fees. Pass allowLegacyWitnessUtxo=true, if you sure");
    return $;
  }
}
let Transaction$1 = class c1 {
  constructor(c = {}) {
    this.global = {}, this.inputs = [], this.outputs = [];
    const u = this.opts = validateOpts$1(c);
    u.lockTime !== DEFAULT_LOCKTIME && (this.global.fallbackLocktime = u.lockTime), this.global.txVersion = u.version;
  }
  // Import
  static fromRaw(c, u = {}) {
    const p = RawTx.decode(c), a = new c1({ ...u, version: p.version, lockTime: p.lockTime });
    for (const A of p.outputs)
      a.addOutput(A);
    if (a.outputs = p.outputs, a.inputs = p.inputs, p.witnesses)
      for (let A = 0; A < p.witnesses.length; A++)
        a.inputs[A].finalScriptWitness = p.witnesses[A];
    return a;
  }
  // PSBT
  static fromPSBT(c, u = {}) {
    let p;
    try {
      p = RawPSBTV0.decode(c);
    } catch ($) {
      try {
        p = RawPSBTV2.decode(c);
      } catch {
        throw $;
      }
    }
    const a = p.global.version || 0;
    if (a !== 0 && a !== 2)
      throw new Error(`Wrong PSBT version=${a}`);
    const A = p.global.unsignedTx, b = a === 0 ? A == null ? void 0 : A.version : p.global.txVersion, F = a === 0 ? A == null ? void 0 : A.lockTime : p.global.fallbackLocktime, le = new c1({ ...u, version: b, lockTime: F, PSBTVersion: a }), L = a === 0 ? A == null ? void 0 : A.inputs.length : p.global.inputCount;
    le.inputs = p.inputs.slice(0, L).map(($, Ee) => {
      var be;
      return validateInput({
        finalScriptSig: EMPTY,
        ...(be = p.global.unsignedTx) == null ? void 0 : be.inputs[Ee],
        ...$
      });
    });
    const pe = a === 0 ? A == null ? void 0 : A.outputs.length : p.global.outputCount;
    return le.outputs = p.outputs.slice(0, pe).map(($, Ee) => {
      var be;
      return {
        ...$,
        ...(be = p.global.unsignedTx) == null ? void 0 : be.outputs[Ee]
      };
    }), le.global = { ...p.global, txVersion: b }, F !== DEFAULT_LOCKTIME && (le.global.fallbackLocktime = F), le;
  }
  toPSBT(c = this.opts.PSBTVersion) {
    if (c !== 0 && c !== 2)
      throw new Error(`Wrong PSBT version=${c}`);
    const u = this.inputs.map((A) => validateInput(cleanPSBTFields(c, PSBTInput, A)));
    for (const A of u)
      A.partialSig && !A.partialSig.length && delete A.partialSig, A.finalScriptSig && !A.finalScriptSig.length && delete A.finalScriptSig, A.finalScriptWitness && !A.finalScriptWitness.length && delete A.finalScriptWitness;
    const p = this.outputs.map((A) => cleanPSBTFields(c, PSBTOutput, A)), a = { ...this.global };
    return c === 0 ? (a.unsignedTx = RawOldTx.decode(RawOldTx.encode({
      version: this.version,
      lockTime: this.lockTime,
      inputs: this.inputs.map(inputBeforeSign).map((A) => ({
        ...A,
        finalScriptSig: EMPTY
      })),
      outputs: this.outputs.map(outputBeforeSign)
    })), delete a.fallbackLocktime, delete a.txVersion) : (a.version = c, a.txVersion = this.version, a.inputCount = this.inputs.length, a.outputCount = this.outputs.length, a.fallbackLocktime && a.fallbackLocktime === DEFAULT_LOCKTIME && delete a.fallbackLocktime), this.opts.bip174jsCompat && (u.length || u.push({}), p.length || p.push({})), (c === 0 ? RawPSBTV0 : RawPSBTV2).encode({
      global: a,
      inputs: u,
      outputs: p
    });
  }
  // BIP370 lockTime (https://github.com/bitcoin/bips/blob/master/bip-0370.mediawiki#determining-lock-time)
  get lockTime() {
    let c = DEFAULT_LOCKTIME, u = 0, p = DEFAULT_LOCKTIME, a = 0;
    for (const A of this.inputs)
      A.requiredHeightLocktime && (c = Math.max(c, A.requiredHeightLocktime), u++), A.requiredTimeLocktime && (p = Math.max(p, A.requiredTimeLocktime), a++);
    return u && u >= a ? c : p !== DEFAULT_LOCKTIME ? p : this.global.fallbackLocktime || DEFAULT_LOCKTIME;
  }
  get version() {
    if (this.global.txVersion === void 0)
      throw new Error("No global.txVersion");
    return this.global.txVersion;
  }
  inputStatus(c) {
    this.checkInputIdx(c);
    const u = this.inputs[c];
    return u.finalScriptSig && u.finalScriptSig.length || u.finalScriptWitness && u.finalScriptWitness.length ? "finalized" : u.tapKeySig || u.tapScriptSig && u.tapScriptSig.length || u.partialSig && u.partialSig.length ? "signed" : "unsigned";
  }
  // Cannot replace unpackSighash, tests rely on very generic implemenetation with signing inputs outside of range
  // We will lose some vectors -> smaller test coverage of preimages (very important!)
  inputSighash(c) {
    this.checkInputIdx(c);
    const u = this.inputs[c].sighashType, p = u === void 0 ? SignatureHash.DEFAULT : u, a = p === SignatureHash.DEFAULT ? SignatureHash.ALL : p & 3;
    return { sigInputs: p & SignatureHash.ANYONECANPAY, sigOutputs: a };
  }
  // Very nice for debug purposes, but slow. If there is too much inputs/outputs to add, will be quadratic.
  // Some cache will be nice, but there chance to have bugs with cache invalidation
  signStatus() {
    let c = !0, u = !0, p = [], a = [];
    for (let A = 0; A < this.inputs.length; A++) {
      if (this.inputStatus(A) === "unsigned")
        continue;
      const { sigInputs: F, sigOutputs: le } = this.inputSighash(A);
      if (F === SignatureHash.ANYONECANPAY ? p.push(A) : c = !1, le === SignatureHash.ALL)
        u = !1;
      else if (le === SignatureHash.SINGLE)
        a.push(A);
      else if (le !== SignatureHash.NONE) throw new Error(`Wrong signature hash output type: ${le}`);
    }
    return { addInput: c, addOutput: u, inputs: p, outputs: a };
  }
  get isFinal() {
    for (let c = 0; c < this.inputs.length; c++)
      if (this.inputStatus(c) !== "finalized")
        return !1;
    return !0;
  }
  // Info utils
  get hasWitnesses() {
    let c = !1;
    for (const u of this.inputs)
      u.finalScriptWitness && u.finalScriptWitness.length && (c = !0);
    return c;
  }
  // https://en.bitcoin.it/wiki/Weight_units
  get weight() {
    if (!this.isFinal)
      throw new Error("Transaction is not finalized");
    let c = 32;
    const u = this.outputs.map(outputBeforeSign);
    c += 4 * CompactSizeLen.encode(this.outputs.length).length;
    for (const p of u)
      c += 32 + 4 * VarBytes.encode(p.script).length;
    this.hasWitnesses && (c += 2), c += 4 * CompactSizeLen.encode(this.inputs.length).length;
    for (const p of this.inputs)
      c += 160 + 4 * VarBytes.encode(p.finalScriptSig || EMPTY).length, this.hasWitnesses && p.finalScriptWitness && (c += RawWitness.encode(p.finalScriptWitness).length);
    return c;
  }
  get vsize() {
    return toVsize(this.weight);
  }
  toBytes(c = !1, u = !1) {
    return RawTx.encode({
      version: this.version,
      lockTime: this.lockTime,
      inputs: this.inputs.map(inputBeforeSign).map((p) => ({
        ...p,
        finalScriptSig: c && p.finalScriptSig || EMPTY
      })),
      outputs: this.outputs.map(outputBeforeSign),
      witnesses: this.inputs.map((p) => p.finalScriptWitness || []),
      segwitFlag: u && this.hasWitnesses
    });
  }
  get unsignedTx() {
    return this.toBytes(!1, !1);
  }
  get hex() {
    return hex$1.encode(this.toBytes(!0, this.hasWitnesses));
  }
  get hash() {
    if (!this.isFinal)
      throw new Error("Transaction is not finalized");
    return hex$1.encode(sha256x2$1(this.toBytes(!0)));
  }
  get id() {
    if (!this.isFinal)
      throw new Error("Transaction is not finalized");
    return hex$1.encode(sha256x2$1(this.toBytes(!0)).reverse());
  }
  // Input stuff
  checkInputIdx(c) {
    if (!Number.isSafeInteger(c) || 0 > c || c >= this.inputs.length)
      throw new Error(`Wrong input index=${c}`);
  }
  getInput(c) {
    return this.checkInputIdx(c), cloneDeep(this.inputs[c]);
  }
  get inputsLength() {
    return this.inputs.length;
  }
  // Modification
  addInput(c, u = !1) {
    if (!u && !this.signStatus().addInput)
      throw new Error("Tx has signed inputs, cannot add new one");
    return this.inputs.push(normalizeInput(c, void 0, void 0, this.opts.disableScriptCheck)), this.inputs.length - 1;
  }
  updateInput(c, u, p = !1) {
    this.checkInputIdx(c);
    let a;
    if (!p) {
      const A = this.signStatus();
      (!A.addInput || A.inputs.includes(c)) && (a = PSBTInputUnsignedKeys);
    }
    this.inputs[c] = normalizeInput(u, this.inputs[c], a, this.opts.disableScriptCheck, this.opts.allowUnknown);
  }
  // Output stuff
  checkOutputIdx(c) {
    if (!Number.isSafeInteger(c) || 0 > c || c >= this.outputs.length)
      throw new Error(`Wrong output index=${c}`);
  }
  getOutput(c) {
    return this.checkOutputIdx(c), cloneDeep(this.outputs[c]);
  }
  getOutputAddress(c, u = NETWORK) {
    const p = this.getOutput(c);
    if (p.script)
      return Address$1(u).encode(OutScript.decode(p.script));
  }
  get outputsLength() {
    return this.outputs.length;
  }
  normalizeOutput(c, u, p) {
    let { amount: a, script: A } = c;
    if (a === void 0 && (a = u == null ? void 0 : u.amount), typeof a != "bigint")
      throw new Error(`Wrong amount type, should be of type bigint in sats, but got ${a} of type ${typeof a}`);
    typeof A == "string" && (A = hex$1.decode(A)), A === void 0 && (A = u == null ? void 0 : u.script);
    let b = { ...u, ...c, amount: a, script: A };
    if (b.amount === void 0 && delete b.amount, b = mergeKeyMap(PSBTOutput, b, u, p, this.opts.allowUnknown), PSBTOutputCoder.encode(b), b.script && !this.opts.allowUnknownOutputs && OutScript.decode(b.script).type === "unknown")
      throw new Error("Transaction/output: unknown output script type, there is a chance that input is unspendable. Pass allowUnknownOutputs=true, if you sure");
    return this.opts.disableScriptCheck || checkScript(b.script, b.redeemScript, b.witnessScript), b;
  }
  addOutput(c, u = !1) {
    if (!u && !this.signStatus().addOutput)
      throw new Error("Tx has signed outputs, cannot add new one");
    return this.outputs.push(this.normalizeOutput(c)), this.outputs.length - 1;
  }
  updateOutput(c, u, p = !1) {
    this.checkOutputIdx(c);
    let a;
    if (!p) {
      const A = this.signStatus();
      (!A.addOutput || A.outputs.includes(c)) && (a = PSBTOutputUnsignedKeys);
    }
    this.outputs[c] = this.normalizeOutput(u, this.outputs[c], a);
  }
  addOutputAddress(c, u, p = NETWORK) {
    return this.addOutput({ script: OutScript.encode(Address$1(p).decode(c)), amount: u });
  }
  // Utils
  get fee() {
    let c = 0n;
    for (const p of this.inputs) {
      const a = getPrevOut(p);
      if (!a)
        throw new Error("Empty input amount");
      c += a.amount;
    }
    const u = this.outputs.map(outputBeforeSign);
    for (const p of u)
      c -= p.amount;
    return c;
  }
  // Signing
  // Based on https://github.com/bitcoin/bitcoin/blob/5871b5b5ab57a0caf9b7514eb162c491c83281d5/test/functional/test_framework/script.py#L624
  // There is optimization opportunity to re-use hashes for multiple inputs for witness v0/v1,
  // but we are trying to be less complicated for audit purpose for now.
  preimageLegacy(c, u, p) {
    const { isAny: a, isNone: A, isSingle: b } = unpackSighash(p);
    if (c < 0 || !Number.isSafeInteger(c))
      throw new Error(`Invalid input idx=${c}`);
    if (b && c >= this.outputs.length || c >= this.inputs.length)
      return U256BE.encode(1n);
    u = Script$1.encode(Script$1.decode(u).filter((pe) => pe !== "CODESEPARATOR"));
    let F = this.inputs.map(inputBeforeSign).map((pe, $) => ({
      ...pe,
      finalScriptSig: $ === c ? u : EMPTY
    }));
    a ? F = [F[c]] : (A || b) && (F = F.map((pe, $) => ({
      ...pe,
      sequence: $ === c ? pe.sequence : 0
    })));
    let le = this.outputs.map(outputBeforeSign);
    A ? le = [] : b && (le = le.slice(0, c).fill(EMPTY_OUTPUT).concat([le[c]]));
    const L = RawTx.encode({
      lockTime: this.lockTime,
      version: this.version,
      segwitFlag: !1,
      inputs: F,
      outputs: le
    });
    return sha256x2$1(L, I32LE.encode(p));
  }
  preimageWitnessV0(c, u, p, a) {
    const { isAny: A, isNone: b, isSingle: F } = unpackSighash(p);
    let le = EMPTY32, L = EMPTY32, pe = EMPTY32;
    const $ = this.inputs.map(inputBeforeSign), Ee = this.outputs.map(outputBeforeSign);
    A || (le = sha256x2$1(...$.map(TxHashIdx.encode))), !A && !F && !b && (L = sha256x2$1(...$.map((He) => U32LE.encode(He.sequence)))), !F && !b ? pe = sha256x2$1(...Ee.map(RawOutput.encode)) : F && c < Ee.length && (pe = sha256x2$1(RawOutput.encode(Ee[c])));
    const be = $[c];
    return sha256x2$1(I32LE.encode(this.version), le, L, createBytes(32, !0).encode(be.txid), U32LE.encode(be.index), VarBytes.encode(u), U64LE.encode(a), U32LE.encode(be.sequence), pe, U32LE.encode(this.lockTime), U32LE.encode(p));
  }
  preimageWitnessV1(c, u, p, a, A = -1, b, F = 192, le) {
    if (!Array.isArray(a) || this.inputs.length !== a.length)
      throw new Error(`Invalid amounts array=${a}`);
    if (!Array.isArray(u) || this.inputs.length !== u.length)
      throw new Error(`Invalid prevOutScript array=${u}`);
    const L = [
      U8.encode(0),
      U8.encode(p),
      // U8 sigHash
      I32LE.encode(this.version),
      U32LE.encode(this.lockTime)
    ], pe = p === SignatureHash.DEFAULT ? SignatureHash.ALL : p & 3, $ = p & SignatureHash.ANYONECANPAY, Ee = this.inputs.map(inputBeforeSign), be = this.outputs.map(outputBeforeSign);
    $ !== SignatureHash.ANYONECANPAY && L.push(...[
      Ee.map(TxHashIdx.encode),
      a.map(U64LE.encode),
      u.map(VarBytes.encode),
      Ee.map((Pe) => U32LE.encode(Pe.sequence))
    ].map((Pe) => sha256$5(concatBytes$2(...Pe)))), pe === SignatureHash.ALL && L.push(sha256$5(concatBytes$2(...be.map(RawOutput.encode))));
    const He = (le ? 1 : 0) | (b ? 2 : 0);
    if (L.push(new Uint8Array([He])), $ === SignatureHash.ANYONECANPAY) {
      const Pe = Ee[c];
      L.push(TxHashIdx.encode(Pe), U64LE.encode(a[c]), VarBytes.encode(u[c]), U32LE.encode(Pe.sequence));
    } else
      L.push(U32LE.encode(c));
    return He & 1 && L.push(sha256$5(VarBytes.encode(le || EMPTY))), pe === SignatureHash.SINGLE && L.push(c < be.length ? sha256$5(RawOutput.encode(be[c])) : EMPTY32), b && L.push(tapLeafHash(b, F), U8.encode(0), I32LE.encode(A)), tagSchnorr("TapSighash", ...L);
  }
  // Signer can be privateKey OR instance of bip32 HD stuff
  signIdx(c, u, p, a) {
    this.checkInputIdx(u);
    const A = this.inputs[u], b = getInputType(A, this.opts.allowLegacyWitnessUtxo);
    if (!isBytes$3(c)) {
      if (!A.bip32Derivation || !A.bip32Derivation.length)
        throw new Error("bip32Derivation: empty");
      const pe = A.bip32Derivation.filter((Ee) => Ee[1].fingerprint == c.fingerprint).map(([Ee, { path: be }]) => {
        let He = c;
        for (const Pe of be)
          He = He.deriveChild(Pe);
        if (!equalBytes$1(He.publicKey, Ee))
          throw new Error("bip32Derivation: wrong pubKey");
        if (!He.privateKey)
          throw new Error("bip32Derivation: no privateKey");
        return He;
      });
      if (!pe.length)
        throw new Error(`bip32Derivation: no items with fingerprint=${c.fingerprint}`);
      let $ = !1;
      for (const Ee of pe)
        this.signIdx(Ee.privateKey, u) && ($ = !0);
      return $;
    }
    p ? p.forEach(validateSigHash) : p = [b.defaultSighash];
    const F = b.sighash;
    if (!p.includes(F))
      throw new Error(`Input with not allowed sigHash=${F}. Allowed: ${p.join(", ")}`);
    const { sigOutputs: le } = this.inputSighash(u);
    if (le === SignatureHash.SINGLE && u >= this.outputs.length)
      throw new Error(`Input with sighash SINGLE, but there is no output with corresponding index=${u}`);
    const L = getPrevOut(A);
    if (b.txType === "taproot") {
      const pe = this.inputs.map(getPrevOut), $ = pe.map((nr) => nr.script), Ee = pe.map((nr) => nr.amount);
      let be = !1, He = pubSchnorr(c), Pe = A.tapMerkleRoot || EMPTY;
      if (A.tapInternalKey) {
        const { pubKey: nr, privKey: ir } = getTaprootKeys(c, He, A.tapInternalKey, Pe), [or, lr] = taprootTweakPubkey(A.tapInternalKey, Pe);
        if (equalBytes$1(or, nr)) {
          const Ir = this.preimageWitnessV1(u, $, F, Ee), xr = concatBytes$2(signSchnorr(Ir, ir, a), F !== SignatureHash.DEFAULT ? new Uint8Array([F]) : EMPTY);
          this.updateInput(u, { tapKeySig: xr }, !0), be = !0;
        }
      }
      if (A.tapLeafScript) {
        A.tapScriptSig = A.tapScriptSig || [];
        for (const [nr, ir] of A.tapLeafScript) {
          const or = ir.subarray(0, -1), lr = Script$1.decode(or), Ir = ir[ir.length - 1], xr = tapLeafHash(or, Ir);
          if (lr.findIndex((Fe) => isBytes$3(Fe) && equalBytes$1(Fe, He)) === -1)
            continue;
          const Ce = this.preimageWitnessV1(u, $, F, Ee, void 0, or, Ir), tr = concatBytes$2(signSchnorr(Ce, c, a), F !== SignatureHash.DEFAULT ? new Uint8Array([F]) : EMPTY);
          this.updateInput(u, { tapScriptSig: [[{ pubKey: He, leafHash: xr }, tr]] }, !0), be = !0;
        }
      }
      if (!be)
        throw new Error("No taproot scripts signed");
      return !0;
    } else {
      const pe = pubECDSA(c);
      let $ = !1;
      const Ee = hash160$2(pe);
      for (const Pe of Script$1.decode(b.lastScript))
        isBytes$3(Pe) && (equalBytes$1(Pe, pe) || equalBytes$1(Pe, Ee)) && ($ = !0);
      if (!$)
        throw new Error(`Input script doesn't have pubKey: ${b.lastScript}`);
      let be;
      if (b.txType === "legacy")
        be = this.preimageLegacy(u, b.lastScript, F);
      else if (b.txType === "segwit") {
        let Pe = b.lastScript;
        b.last.type === "wpkh" && (Pe = OutScript.encode({ type: "pkh", hash: b.last.hash })), be = this.preimageWitnessV0(u, Pe, F, L.amount);
      } else
        throw new Error(`Transaction/sign: unknown tx type: ${b.txType}`);
      const He = signECDSA(be, c, this.opts.lowR);
      this.updateInput(u, {
        partialSig: [[pe, concatBytes$2(He, new Uint8Array([F]))]]
      }, !0);
    }
    return !0;
  }
  // This is bad API. Will work if user creates and signs tx, but if
  // there is some complex workflow with exchanging PSBT and signing them,
  // then it is better to validate which output user signs. How could a better API look like?
  // Example: user adds input, sends to another party, then signs received input (mixer etc),
  // another user can add different input for same key and user will sign it.
  // Even worse: another user can add bip32 derivation, and spend money from different address.
  // Better api: signIdx
  sign(c, u, p) {
    let a = 0;
    for (let A = 0; A < this.inputs.length; A++)
      try {
        this.signIdx(c, A, u, p) && a++;
      } catch {
      }
    if (!a)
      throw new Error("No inputs signed");
    return a;
  }
  finalizeIdx(c) {
    if (this.checkInputIdx(c), this.fee < 0n)
      throw new Error("Outputs spends more than inputs amount");
    const u = this.inputs[c], p = getInputType(u, this.opts.allowLegacyWitnessUtxo);
    if (p.txType === "taproot") {
      if (u.tapKeySig)
        u.finalScriptWitness = [u.tapKeySig];
      else if (u.tapLeafScript && u.tapScriptSig) {
        const le = u.tapLeafScript.sort((L, pe) => TaprootControlBlock.encode(L[0]).length - TaprootControlBlock.encode(pe[0]).length);
        for (const [L, pe] of le) {
          const $ = pe.slice(0, -1), Ee = pe[pe.length - 1], be = OutScript.decode($), He = tapLeafHash($, Ee), Pe = u.tapScriptSig.filter((ir) => equalBytes$1(ir[0].leafHash, He));
          let nr = [];
          if (be.type === "tr_ms") {
            const ir = be.m, or = be.pubkeys;
            let lr = 0;
            for (const Ir of or) {
              const xr = Pe.findIndex((kr) => equalBytes$1(kr[0].pubKey, Ir));
              if (lr === ir || xr === -1) {
                nr.push(EMPTY);
                continue;
              }
              nr.push(Pe[xr][1]), lr++;
            }
            if (lr !== ir)
              continue;
          } else if (be.type === "tr_ns") {
            for (const ir of be.pubkeys) {
              const or = Pe.findIndex((lr) => equalBytes$1(lr[0].pubKey, ir));
              or !== -1 && nr.push(Pe[or][1]);
            }
            if (nr.length !== be.pubkeys.length)
              continue;
          } else if (be.type === "unknown" && this.opts.allowUnknownInputs) {
            const ir = Script$1.decode($);
            if (nr = Pe.map(([{ pubKey: or }, lr]) => {
              const Ir = ir.findIndex((xr) => isBytes$3(xr) && equalBytes$1(xr, or));
              if (Ir === -1)
                throw new Error("finalize/taproot: cannot find position of pubkey in script");
              return { signature: lr, pos: Ir };
            }).sort((or, lr) => or.pos - lr.pos).map((or) => or.signature), !nr.length)
              continue;
          } else {
            const ir = this.opts.customScripts;
            if (ir)
              for (const or of ir) {
                if (!or.finalizeTaproot)
                  continue;
                const lr = Script$1.decode($), Ir = or.encode(lr);
                if (Ir === void 0)
                  continue;
                const xr = or.finalizeTaproot($, Ir, Pe);
                if (xr) {
                  u.finalScriptWitness = xr.concat(TaprootControlBlock.encode(L)), u.finalScriptSig = EMPTY, cleanFinalInput(u);
                  return;
                }
              }
            throw new Error("Finalize: Unknown tapLeafScript");
          }
          u.finalScriptWitness = nr.reverse().concat([$, TaprootControlBlock.encode(L)]);
          break;
        }
        if (!u.finalScriptWitness)
          throw new Error("finalize/taproot: empty witness");
      } else
        throw new Error("finalize/taproot: unknown input");
      u.finalScriptSig = EMPTY, cleanFinalInput(u);
      return;
    }
    if (!u.partialSig || !u.partialSig.length)
      throw new Error("Not enough partial sign");
    let a = EMPTY, A = [];
    if (p.last.type === "ms") {
      const le = p.last.m, L = p.last.pubkeys;
      let pe = [];
      for (const $ of L) {
        const Ee = u.partialSig.find((be) => equalBytes$1($, be[0]));
        Ee && pe.push(Ee[1]);
      }
      if (pe = pe.slice(0, le), pe.length !== le)
        throw new Error(`Multisig: wrong signatures count, m=${le} n=${L.length} signatures=${pe.length}`);
      a = Script$1.encode([0, ...pe]);
    } else if (p.last.type === "pk")
      a = Script$1.encode([u.partialSig[0][1]]);
    else if (p.last.type === "pkh")
      a = Script$1.encode([u.partialSig[0][1], u.partialSig[0][0]]);
    else if (p.last.type === "wpkh")
      a = EMPTY, A = [u.partialSig[0][1], u.partialSig[0][0]];
    else if (p.last.type === "unknown" && !this.opts.allowUnknownInputs)
      throw new Error("Unknown inputs not allowed");
    let b, F;
    if (p.type.includes("wsh-") && (a.length && p.lastScript.length && (A = Script$1.decode(a).map((le) => {
      if (le === 0)
        return EMPTY;
      if (isBytes$3(le))
        return le;
      throw new Error(`Wrong witness op=${le}`);
    })), A = A.concat(p.lastScript)), p.txType === "segwit" && (F = A), p.type.startsWith("sh-wsh-") ? b = Script$1.encode([Script$1.encode([0, sha256$5(p.lastScript)])]) : p.type.startsWith("sh-") ? b = Script$1.encode([...Script$1.decode(a), p.lastScript]) : p.type.startsWith("wsh-") || p.txType !== "segwit" && (b = a), !b && !F)
      throw new Error("Unknown error finalizing input");
    b && (u.finalScriptSig = b), F && (u.finalScriptWitness = F), cleanFinalInput(u);
  }
  finalize() {
    for (let c = 0; c < this.inputs.length; c++)
      this.finalizeIdx(c);
  }
  extract() {
    if (!this.isFinal)
      throw new Error("Transaction has unfinalized inputs");
    if (!this.outputs.length)
      throw new Error("Transaction has no outputs");
    if (this.fee < 0n)
      throw new Error("Outputs spends more than inputs amount");
    return this.toBytes(!0, !0);
  }
  combine(c) {
    for (const a of ["PSBTVersion", "version", "lockTime"])
      if (this.opts[a] !== c.opts[a])
        throw new Error(`Transaction/combine: different ${a} this=${this.opts[a]} other=${c.opts[a]}`);
    for (const a of ["inputs", "outputs"])
      if (this[a].length !== c[a].length)
        throw new Error(`Transaction/combine: different ${a} length this=${this[a].length} other=${c[a].length}`);
    const u = this.global.unsignedTx ? RawOldTx.encode(this.global.unsignedTx) : EMPTY, p = c.global.unsignedTx ? RawOldTx.encode(c.global.unsignedTx) : EMPTY;
    if (!equalBytes$1(u, p))
      throw new Error("Transaction/combine: different unsigned tx");
    this.global = mergeKeyMap(PSBTGlobal, this.global, c.global, void 0, this.opts.allowUnknown);
    for (let a = 0; a < this.inputs.length; a++)
      this.updateInput(a, c.inputs[a], !0);
    for (let a = 0; a < this.outputs.length; a++)
      this.updateOutput(a, c.outputs[a], !0);
    return this;
  }
  clone() {
    return c1.fromPSBT(this.toPSBT(this.opts.PSBTVersion), this.opts);
  }
};
function PSBTCombine(n) {
  if (!n || !Array.isArray(n) || !n.length)
    throw new Error("PSBTCombine: wrong PSBT list");
  const c = Transaction$1.fromPSBT(n[0]);
  for (let u = 1; u < n.length; u++)
    c.combine(Transaction$1.fromPSBT(n[u]));
  return c.toPSBT();
}
const HARDENED_OFFSET = 2147483648;
function bip32Path$1(n) {
  const c = [];
  if (!/^[mM]'?/.test(n))
    throw new Error('Path must start with "m" or "M"');
  if (/^[mM]'?$/.test(n))
    return c;
  const u = n.replace(/^[mM]'?\//, "").split("/");
  for (const p of u) {
    const a = /^(\d+)('?)$/.exec(p);
    if (!a || a.length !== 3)
      throw new Error(`Invalid child index: ${p}`);
    let A = +a[1];
    if (!Number.isSafeInteger(A) || A >= HARDENED_OFFSET)
      throw new Error("Invalid index");
    a[2] === "'" && (A += HARDENED_OFFSET), c.push(A);
  }
  return c;
}
const encodeTapBlock = (n) => TaprootControlBlock.encode(n);
function iterLeafs(n, c, u) {
  if (!n || !n.length)
    throw new Error("no leafs");
  const p = () => new Uint8Array(c), a = n.sort((A, b) => encodeTapBlock(A[0]).length - encodeTapBlock(b[0]).length);
  for (const [A, b] of a) {
    const F = b.slice(0, -1), le = b[b.length - 1], L = OutScript.decode(F);
    let pe = [];
    if (L.type === "tr_ms") {
      const $ = L.m, Ee = L.pubkeys.length - $;
      for (let be = 0; be < $; be++)
        pe.push(p());
      for (let be = 0; be < Ee; be++)
        pe.push(EMPTY);
    } else if (L.type === "tr_ns")
      for (const $ of L.pubkeys)
        pe.push(p());
    else {
      if (!u)
        throw new Error("Finalize: Unknown tapLeafScript");
      const $ = tapLeafHash(F, le);
      for (const Ee of u) {
        if (!Ee.finalizeTaproot)
          continue;
        const be = Script$1.decode(F), He = Ee.encode(be);
        if (He === void 0)
          continue;
        const Pe = be.filter((ir) => {
          if (!isBytes$3(ir))
            return !1;
          try {
            return validatePubkey(ir, PubT.schnorr), !0;
          } catch {
            return !1;
          }
        }), nr = Ee.finalizeTaproot(F, He, Pe.map((ir) => [{ pubKey: ir, leafHash: $ }, p()]));
        if (nr)
          return nr.concat(encodeTapBlock(A));
      }
    }
    return pe.reverse().concat([F, encodeTapBlock(A)]);
  }
  throw new Error("there was no witness");
}
function estimateInput(n, c, u) {
  let p = EMPTY, a;
  if (n.txType === "taproot") {
    const F = n.sighash !== SignatureHash.DEFAULT ? 65 : 64;
    if (c.tapInternalKey && !equalBytes$1(c.tapInternalKey, TAPROOT_UNSPENDABLE_KEY))
      a = [new Uint8Array(F)];
    else if (c.tapLeafScript)
      a = iterLeafs(c.tapLeafScript, F, u.customScripts);
    else
      throw new Error("estimateInput/taproot: unknown input");
  } else {
    const F = () => new Uint8Array(72), le = () => new Uint8Array(33);
    let L = EMPTY, pe = [];
    const $ = n.last.type;
    if ($ === "ms") {
      const Ee = n.last.m, be = [0];
      for (let He = 0; He < Ee; He++)
        be.push(F());
      L = Script$1.encode(be);
    } else if ($ === "pk")
      L = Script$1.encode([F()]);
    else if ($ === "pkh")
      L = Script$1.encode([F(), le()]);
    else if ($ === "wpkh")
      L = EMPTY, pe = [F(), le()];
    else if ($ === "unknown" && !u.allowUnknownInputs)
      throw new Error("Unknown inputs are not allowed");
    n.type.includes("wsh-") && (L.length && n.lastScript.length && (pe = Script$1.decode(L).map((Ee) => {
      if (Ee === 0)
        return EMPTY;
      if (isBytes$3(Ee))
        return Ee;
      throw new Error(`Wrong witness op=${Ee}`);
    })), pe = pe.concat(n.lastScript)), n.txType === "segwit" && (a = pe), n.type.startsWith("sh-wsh-") ? p = Script$1.encode([Script$1.encode([0, new Uint8Array(sha256$5.outputLen)])]) : n.type.startsWith("sh-") ? p = Script$1.encode([...Script$1.decode(L), n.lastScript]) : n.type.startsWith("wsh-") || n.txType !== "segwit" && (p = L);
  }
  let A = 160 + 4 * VarBytes.encode(p).length, b = !1;
  return a && (A += RawWitness.encode(a).length, b = !0), { weight: A, hasWitnesses: b };
}
const _cmpBig = (n, c) => {
  const u = n - c;
  return u < 0n ? -1 : u > 0n ? 1 : 0;
};
function getScript(n, c = {}, u = NETWORK) {
  let p;
  if ("script" in n && isBytes$3(n.script) && (p = n.script), "address" in n) {
    if (typeof n.address != "string")
      throw new Error(`Estimator: wrong output address=${n.address}`);
    p = OutScript.encode(Address$1(u).decode(n.address));
  }
  if (!p)
    throw new Error("Estimator: wrong output script");
  if (typeof n.amount != "bigint")
    throw new Error(`Estimator: wrong output amount=${n.amount}, should be of type bigint but got ${typeof n.amount}.`);
  if (p && !c.allowUnknownOutputs && OutScript.decode(p).type === "unknown")
    throw new Error("Estimator: unknown output script type, there is a chance that input is unspendable. Pass allowUnknownOutputs=true, if you sure");
  return c.disableScriptCheck || checkScript(p), p;
}
class _Estimator {
  constructor(c, u, p) {
    if (this.requiredIndices = [], this.outputs = u, this.opts = p, typeof p.feePerByte != "bigint")
      throw new Error(`Estimator: wrong feePerByte=${p.feePerByte}, should be of type bigint but got ${typeof p.feePerByte}.`);
    const b = p.dust === void 0 ? BigInt(148 + 34) : p.dust;
    if (typeof b != "bigint")
      throw new Error(`Estimator: wrong dust=${p.dust}, should be of type bigint but got ${typeof p.dust}.`);
    const F = p.dustRelayFeeRate === void 0 ? 3n : p.dustRelayFeeRate;
    if (typeof F != "bigint")
      throw new Error(`Estimator: wrong dustRelayFeeRate=${p.dustRelayFeeRate}, should be of type bigint but got ${typeof p.dustRelayFeeRate}.`);
    if (this.dust = b * F, p.requiredInputs !== void 0 && !Array.isArray(p.requiredInputs))
      throw new Error(`Estimator: wrong required inputs=${p.requiredInputs}`);
    const le = p.network || NETWORK;
    let L = 0n, pe = 32;
    for (const He of u) {
      const Pe = getScript(He, p, p.network);
      pe += 32 + 4 * VarBytes.encode(Pe).length, L += He.amount;
    }
    if (typeof p.changeAddress != "string")
      throw new Error(`Estimator: wrong change address=${p.changeAddress}`);
    let $ = pe + 32 + 4 * VarBytes.encode(OutScript.encode(Address$1(le).decode(p.changeAddress))).length;
    pe += 4 * CompactSizeLen.encode(u.length).length, $ += 4 * CompactSizeLen.encode(u.length + 1).length, this.baseWeight = pe, this.changeWeight = $, this.amount = L;
    const Ee = Array.from(c);
    if (p.requiredInputs)
      for (let He = 0; He < p.requiredInputs.length; He++)
        this.requiredIndices.push(Ee.push(p.requiredInputs[He]) - 1);
    const be = /* @__PURE__ */ new Set();
    this.normalizedInputs = Ee.map((He) => {
      const Pe = normalizeInput(He, void 0, void 0, p.disableScriptCheck, p.allowUnknown);
      inputBeforeSign(Pe);
      const nr = `${hex$1.encode(Pe.txid)}:${Pe.index}`;
      if (!p.allowSameUtxo && be.has(nr))
        throw new Error(`Estimator: same input passed multiple times: ${nr}`);
      be.add(nr);
      const ir = getInputType(Pe, p.allowLegacyWitnessUtxo), or = getPrevOut(Pe), lr = estimateInput(ir, Pe, this.opts), Ir = or.amount - p.feePerByte * BigInt(toVsize(lr.weight));
      return { inputType: ir, normalized: Pe, amount: or.amount, value: Ir, estimate: lr };
    });
  }
  checkInputIdx(c) {
    if (!Number.isSafeInteger(c) || 0 > c || c >= this.normalizedInputs.length)
      throw new Error(`Wrong input index=${c}`);
    return c;
  }
  sortIndices(c) {
    return c.slice().sort((u, p) => {
      const a = this.normalizedInputs[this.checkInputIdx(u)], A = this.normalizedInputs[this.checkInputIdx(p)], b = compareBytes(a.normalized.txid, A.normalized.txid);
      return b !== 0 ? b : a.normalized.index - A.normalized.index;
    });
  }
  sortOutputs(c) {
    const u = c.map((a) => getScript(a, this.opts, this.opts.network));
    return c.map((a, A) => A).sort((a, A) => {
      const b = c[a].amount, F = c[A].amount, le = _cmpBig(b, F);
      return le !== 0 ? le : compareBytes(u[a], u[A]);
    });
  }
  getSatoshi(c) {
    return this.opts.feePerByte * BigInt(toVsize(c));
  }
  // Sort by value instead of amount
  get biggest() {
    return this.normalizedInputs.map((c, u) => u).sort((c, u) => _cmpBig(this.normalizedInputs[u].value, this.normalizedInputs[c].value));
  }
  get smallest() {
    return this.biggest.reverse();
  }
  // These assume that UTXO array has historical order.
  // Otherwise, we have no way to know which tx is oldest
  // Explorers usually give UTXO in this order.
  get oldest() {
    return this.normalizedInputs.map((c, u) => u);
  }
  get newest() {
    return this.oldest.reverse();
  }
  // exact - like blackjack from coinselect.
  // exact(biggest) will select one big utxo which is closer to targetValue+dust, if possible.
  // If not, it will accumulate largest utxo until value is close to targetValue+dust.
  accumulate(c, u = !1, p = !0, a = !1) {
    let A = this.opts.alwaysChange ? this.changeWeight : this.baseWeight, b = !1, F = 0, le = 0n;
    const L = this.amount, pe = /* @__PURE__ */ new Set();
    let $;
    for (const Ee of this.requiredIndices) {
      if (this.checkInputIdx(Ee), pe.has(Ee))
        throw new Error("required input encountered multiple times");
      const { estimate: be, amount: He } = this.normalizedInputs[Ee];
      let Pe = A + be.weight;
      !b && be.hasWitnesses && (Pe += 2);
      const nr = Pe + 4 * CompactSizeLen.encode(F).length;
      if ($ = this.getSatoshi(nr), A = Pe, be.hasWitnesses && (b = !0), F++, le += He, pe.add(Ee), !a && L + $ <= le && F >= this.requiredIndices.length)
        return { indices: Array.from(pe), fee: $, weight: nr, total: le };
    }
    for (const Ee of c) {
      if (this.checkInputIdx(Ee), pe.has(Ee))
        continue;
      const { estimate: be, amount: He, value: Pe } = this.normalizedInputs[Ee];
      let nr = A + be.weight;
      !b && be.hasWitnesses && (nr += 2);
      const ir = nr + 4 * CompactSizeLen.encode(F).length;
      if ($ = this.getSatoshi(ir), !(u && He + le > L + $ + this.dust) && !(p && Pe <= 0n) && (A = nr, be.hasWitnesses && (b = !0), F++, le += He, pe.add(Ee), !a && L + $ <= le))
        return { indices: Array.from(pe), fee: $, weight: ir, total: le };
    }
    if (a) {
      const Ee = A + 4 * CompactSizeLen.encode(F).length;
      return { indices: Array.from(pe), fee: $, weight: Ee, total: le };
    }
  }
  // Works like coinselect default method
  default() {
    const { biggest: c } = this, u = this.accumulate(c, !0, !1);
    return u || this.accumulate(c);
  }
  select(c) {
    if (c === "all")
      return this.accumulate(this.normalizedInputs.map((p, a) => a), !1, !0, !0);
    if (c === "default")
      return this.default();
    const u = {
      Oldest: () => this.oldest,
      Newest: () => this.newest,
      Smallest: () => this.smallest,
      Biggest: () => this.biggest
    };
    if (c.startsWith("exact")) {
      const [p, a] = c.slice(5).split("/");
      if (!u[p])
        throw new Error(`Estimator.select: wrong strategy=${c}`);
      c = a;
      const A = this.accumulate(u[p](), !0, !0);
      if (A)
        return A;
    }
    if (c.startsWith("accum")) {
      const p = c.slice(5);
      if (!u[p])
        throw new Error(`Estimator.select: wrong strategy=${c}`);
      return this.accumulate(u[p]());
    }
    throw new Error(`Estimator.select: wrong strategy=${c}`);
  }
  result(c) {
    const u = this.select(c);
    if (!u)
      return;
    const { indices: p, weight: a, total: A } = u;
    let b = this.opts.alwaysChange;
    const F = this.opts.alwaysChange ? a : a + (this.changeWeight - this.baseWeight), le = this.getSatoshi(F);
    let L = u.fee;
    const pe = A - this.amount - le;
    pe > this.dust && (b = !0);
    let $ = p, Ee = Array.from(this.outputs);
    if (b) {
      if (L = le, pe < 0n)
        throw new Error(`Estimator.result: negative change=${pe}`);
      Ee.push({ address: this.opts.changeAddress, amount: pe });
    }
    this.opts.bip69 && ($ = this.sortIndices($), Ee = this.sortOutputs(Ee).map((Pe) => Ee[Pe]));
    const be = {
      inputs: $.map((Pe) => this.normalizedInputs[Pe].normalized),
      outputs: Ee,
      fee: L,
      weight: this.opts.alwaysChange ? u.weight : F,
      change: !!b
    };
    let He;
    if (this.opts.createTx) {
      const { inputs: Pe, outputs: nr } = be;
      He = new Transaction$1(this.opts);
      for (const ir of Pe)
        He.addInput(ir);
      for (const ir of nr)
        He.addOutput({ ...ir, script: getScript(ir, this.opts, this.opts.network) });
    }
    return Object.assign(be, { tx: He });
  }
}
function selectUTXO(n, c, u, p) {
  const a = { createTx: !0, bip69: !0, ...p };
  return new _Estimator(n, c, a).result(u);
}
const utils = {
  isBytes: isBytes$3,
  concatBytes: concatBytes$2,
  compareBytes,
  pubSchnorr,
  randomPrivateKeyBytes,
  taprootTweakPubkey
}, esm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Address: Address$1,
  CompactSize,
  DEFAULT_SEQUENCE,
  Decimal,
  MAX_SCRIPT_BYTE_LENGTH,
  NETWORK,
  get OP() {
    return OP;
  },
  OutScript,
  PSBTCombine,
  RawTx,
  RawWitness,
  Script: Script$1,
  ScriptNum,
  get SigHash() {
    return SigHash;
  },
  TAPROOT_UNSPENDABLE_KEY,
  TEST_NETWORK,
  TaprootControlBlock,
  Transaction: Transaction$1,
  WIF,
  _DebugPSBT,
  _Estimator,
  _cmpBig,
  _sortPubkeys,
  bip32Path: bip32Path$1,
  combinations,
  getAddress,
  getInputType,
  multisig,
  p2ms,
  p2pk: p2pk$1,
  p2pkh: p2pkh$1,
  p2sh: p2sh$1,
  p2tr: p2tr$1,
  p2tr_ms,
  p2tr_ns,
  p2tr_pk,
  p2wpkh: p2wpkh$1,
  p2wsh: p2wsh$1,
  selectUTXO,
  sortedMultisig,
  taprootListToTree,
  utils
}, Symbol.toStringTag, { value: "Module" }));
var main$2 = {}, appClient$1 = {}, dist$1 = {}, descriptors$1 = {}, src$2 = {}, bip32$2 = {}, crypto$4 = {};
Object.defineProperty(crypto$4, "__esModule", { value: !0 });
crypto$4.hmacSHA512 = crypto$4.hash160 = void 0;
const hmac_1 = hmac$6, ripemd160_1 = ripemd160$6, sha256_1$1 = sha256$g, sha512_1 = sha512$2;
function hash160$1(n) {
  const c = (0, sha256_1$1.sha256)(Uint8Array.from(n));
  return Buffer$f.from((0, ripemd160_1.ripemd160)(c));
}
crypto$4.hash160 = hash160$1;
function hmacSHA512(n, c) {
  return Buffer$f.from((0, hmac_1.hmac)(sha512_1.sha512, n, c));
}
crypto$4.hmacSHA512 = hmacSHA512;
var testecc$1 = {};
Object.defineProperty(testecc$1, "__esModule", { value: !0 });
testecc$1.testEcc = void 0;
const h$1 = (n) => Buffer$f.from(n, "hex");
function testEcc$1(n) {
  if (assert$6(n.isPoint(h$1("0279be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798"))), assert$6(!n.isPoint(h$1("030000000000000000000000000000000000000000000000000000000000000005"))), assert$6(n.isPrivate(h$1("79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798"))), assert$6(n.isPrivate(h$1("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140"))), assert$6(!n.isPrivate(h$1("0000000000000000000000000000000000000000000000000000000000000000"))), assert$6(!n.isPrivate(h$1("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"))), assert$6(!n.isPrivate(h$1("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364142"))), assert$6(Buffer$f.from(n.pointFromScalar(h$1("b1121e4088a66a28f5b6b0f5844943ecd9f610196d7bb83b25214b60452c09af"))).equals(h$1("02b07ba9dca9523b7ef4bd97703d43d20399eb698e194704791a25ce77a400df99"))), n.xOnlyPointAddTweak) {
    assert$6(n.xOnlyPointAddTweak(h$1("79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798"), h$1("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140")) === null);
    let c = n.xOnlyPointAddTweak(h$1("1617d38ed8d8657da4d4761e8057bc396ea9e4b9d29776d4be096016dbd2509b"), h$1("a8397a935f0dfceba6ba9618f6451ef4d80637abf4e6af2669fbc9de6a8fd2ac"));
    assert$6(Buffer$f.from(c.xOnlyPubkey).equals(h$1("e478f99dab91052ab39a33ea35fd5e6e4933f4d28023cd597c9a1f6760346adf")) && c.parity === 1), c = n.xOnlyPointAddTweak(h$1("2c0b7cf95324a07d05398b240174dc0c2be444d96b159aa6c7f7b1e668680991"), h$1("823c3cd2142744b075a87eade7e1b8678ba308d566226a0056ca2b7a76f86b47"));
  }
  assert$6(Buffer$f.from(n.pointAddScalar(h$1("0379be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798"), h$1("0000000000000000000000000000000000000000000000000000000000000003"))).equals(h$1("02c6047f9441ed7d6d3045406e95c07cd85c778e4b8cef3ca7abac09b95c709ee5"))), assert$6(Buffer$f.from(n.privateAdd(h$1("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd036413e"), h$1("0000000000000000000000000000000000000000000000000000000000000002"))).equals(h$1("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140"))), n.privateNegate && (assert$6(Buffer$f.from(n.privateNegate(h$1("0000000000000000000000000000000000000000000000000000000000000001"))).equals(h$1("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140"))), assert$6(Buffer$f.from(n.privateNegate(h$1("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd036413e"))).equals(h$1("0000000000000000000000000000000000000000000000000000000000000003"))), assert$6(Buffer$f.from(n.privateNegate(h$1("b1121e4088a66a28f5b6b0f5844943ecd9f610196d7bb83b25214b60452c09af"))).equals(h$1("4eede1bf775995d70a494f0a7bb6bc11e0b8cccd41cce8009ab1132c8b0a3792")))), assert$6(Buffer$f.from(n.sign(h$1("5e9f0a0d593efdcf78ac923bc3313e4e7d408d574354ee2b3288c0da9fbba6ed"), h$1("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140"))).equals(h$1("54c4a33c6423d689378f160a7ff8b61330444abb58fb470f96ea16d99d4a2fed07082304410efa6b2943111b6a4e0aaa7b7db55a07e9861d1fb3cb1f421044a5"))), assert$6(n.verify(h$1("5e9f0a0d593efdcf78ac923bc3313e4e7d408d574354ee2b3288c0da9fbba6ed"), h$1("0379be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798"), h$1("54c4a33c6423d689378f160a7ff8b61330444abb58fb470f96ea16d99d4a2fed07082304410efa6b2943111b6a4e0aaa7b7db55a07e9861d1fb3cb1f421044a5"))), n.signSchnorr && assert$6(Buffer$f.from(n.signSchnorr(h$1("7e2d58d8b3bcdf1abadec7829054f90dda9805aab56c77333024b9d0a508b75c"), h$1("c90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b14e5c9"), h$1("c87aa53824b4d7ae2eb035a2b5bbbccc080e76cdc6d1692c4b0b62d798e6d906"))).equals(h$1("5831aaeed7b44bb74e5eab94ba9d4294c49bcf2a60728d8b4c200f50dd313c1bab745879a5ad954a72c45a91c3a51d3c7adea98d82f8481e0e1e03674a6f3fb7"))), n.verifySchnorr && assert$6(n.verifySchnorr(h$1("7e2d58d8b3bcdf1abadec7829054f90dda9805aab56c77333024b9d0a508b75c"), h$1("dd308afec5777e13121fa72b9cc1b7cc0139715309b086c960e18fd969774eb8"), h$1("5831aaeed7b44bb74e5eab94ba9d4294c49bcf2a60728d8b4c200f50dd313c1bab745879a5ad954a72c45a91c3a51d3c7adea98d82f8481e0e1e03674a6f3fb7")));
}
testecc$1.testEcc = testEcc$1;
function assert$6(n) {
  if (!n)
    throw new Error("ecc library invalid");
}
const require$$3 = /* @__PURE__ */ getAugmentedNamespace(esm$1);
var _Buffer = safeBufferExports.Buffer;
function base$1(n) {
  if (n.length >= 255)
    throw new TypeError("Alphabet too long");
  for (var c = new Uint8Array(256), u = 0; u < c.length; u++)
    c[u] = 255;
  for (var p = 0; p < n.length; p++) {
    var a = n.charAt(p), A = a.charCodeAt(0);
    if (c[A] !== 255)
      throw new TypeError(a + " is ambiguous");
    c[A] = p;
  }
  var b = n.length, F = n.charAt(0), le = Math.log(b) / Math.log(256), L = Math.log(256) / Math.log(b);
  function pe(be) {
    if ((Array.isArray(be) || be instanceof Uint8Array) && (be = _Buffer.from(be)), !_Buffer.isBuffer(be))
      throw new TypeError("Expected Buffer");
    if (be.length === 0)
      return "";
    for (var He = 0, Pe = 0, nr = 0, ir = be.length; nr !== ir && be[nr] === 0; )
      nr++, He++;
    for (var or = (ir - nr) * L + 1 >>> 0, lr = new Uint8Array(or); nr !== ir; ) {
      for (var Ir = be[nr], xr = 0, kr = or - 1; (Ir !== 0 || xr < Pe) && kr !== -1; kr--, xr++)
        Ir += 256 * lr[kr] >>> 0, lr[kr] = Ir % b >>> 0, Ir = Ir / b >>> 0;
      if (Ir !== 0)
        throw new Error("Non-zero carry");
      Pe = xr, nr++;
    }
    for (var Ce = or - Pe; Ce !== or && lr[Ce] === 0; )
      Ce++;
    for (var tr = F.repeat(He); Ce < or; ++Ce)
      tr += n.charAt(lr[Ce]);
    return tr;
  }
  function $(be) {
    if (typeof be != "string")
      throw new TypeError("Expected String");
    if (be.length === 0)
      return _Buffer.alloc(0);
    for (var He = 0, Pe = 0, nr = 0; be[He] === F; )
      Pe++, He++;
    for (var ir = (be.length - He) * le + 1 >>> 0, or = new Uint8Array(ir); He < be.length; ) {
      var lr = be.charCodeAt(He);
      if (lr > 255)
        return;
      var Ir = c[lr];
      if (Ir === 255)
        return;
      for (var xr = 0, kr = ir - 1; (Ir !== 0 || xr < nr) && kr !== -1; kr--, xr++)
        Ir += b * or[kr] >>> 0, or[kr] = Ir % 256 >>> 0, Ir = Ir / 256 >>> 0;
      if (Ir !== 0)
        throw new Error("Non-zero carry");
      nr = xr, He++;
    }
    for (var Ce = ir - nr; Ce !== ir && or[Ce] === 0; )
      Ce++;
    var tr = _Buffer.allocUnsafe(Pe + (ir - Ce));
    tr.fill(0, 0, Pe);
    for (var Fe = Pe; Ce !== ir; )
      tr[Fe++] = or[Ce++];
    return tr;
  }
  function Ee(be) {
    var He = $(be);
    if (He)
      return He;
    throw new Error("Non-base" + b + " character");
  }
  return {
    encode: pe,
    decodeUnsafe: $,
    decode: Ee
  };
}
var src$1 = base$1, basex = src$1, ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz", bs58 = basex(ALPHABET), base58 = bs58, Buffer = safeBufferExports.Buffer, base = function(n) {
  function c(A) {
    var b = n(A);
    return base58.encode(Buffer.concat([
      A,
      b
    ], A.length + 4));
  }
  function u(A) {
    var b = A.slice(0, -4), F = A.slice(-4), le = n(b);
    if (!(F[0] ^ le[0] | F[1] ^ le[1] | F[2] ^ le[2] | F[3] ^ le[3]))
      return b;
  }
  function p(A) {
    var b = base58.decodeUnsafe(A);
    if (b)
      return u(b);
  }
  function a(A) {
    var b = base58.decode(A), F = u(b);
    if (!F) throw new Error("Invalid checksum");
    return F;
  }
  return {
    encode: c,
    decode: a,
    decodeUnsafe: p
  };
}, createHash = browser$a, bs58checkBase = base;
function sha256x2(n) {
  var c = createHash("sha256").update(n).digest();
  return createHash("sha256").update(c).digest();
}
var bs58check$2 = bs58checkBase(sha256x2), bs58check$1 = bs58check$2;
function decodeRaw(n, c) {
  if (c !== void 0 && n[0] !== c) throw new Error("Invalid network version");
  if (n.length === 33)
    return {
      version: n[0],
      privateKey: n.slice(1, 33),
      compressed: !1
    };
  if (n.length !== 34) throw new Error("Invalid WIF length");
  if (n[33] !== 1) throw new Error("Invalid compression flag");
  return {
    version: n[0],
    privateKey: n.slice(1, 33),
    compressed: !0
  };
}
function encodeRaw(n, c, u) {
  var p = new Buffer$f(u ? 34 : 33);
  return p.writeUInt8(n, 0), c.copy(p, 1), u && (p[33] = 1), p;
}
function decode$8(n, c) {
  return decodeRaw(bs58check$1.decode(n), c);
}
function encode$8(n, c, u) {
  return typeof n == "number" ? bs58check$1.encode(encodeRaw(n, c, u)) : bs58check$1.encode(
    encodeRaw(
      n.version,
      n.privateKey,
      n.compressed
    )
  );
}
var wif$2 = {
  decode: decode$8,
  decodeRaw,
  encode: encode$8,
  encodeRaw
};
Object.defineProperty(bip32$2, "__esModule", { value: !0 });
bip32$2.BIP32Factory = void 0;
const crypto$3 = crypto$4, testecc_1$1 = testecc$1, base_1 = require$$3, sha256_1 = sha256$g, typeforce = typeforce_1, wif$1 = wif$2, _bs58check = (0, base_1.base58check)(sha256_1.sha256), bs58check = {
  encode: (n) => _bs58check.encode(Uint8Array.from(n)),
  decode: (n) => Buffer$f.from(_bs58check.decode(n))
};
function BIP32Factory(n) {
  (0, testecc_1$1.testEcc)(n);
  const c = typeforce.BufferN(32), u = typeforce.compile({
    wif: typeforce.UInt8,
    bip32: {
      public: typeforce.UInt32,
      private: typeforce.UInt32
    }
  }), p = {
    messagePrefix: `Bitcoin Signed Message:
`,
    bech32: "bc",
    bip32: {
      public: 76067358,
      private: 76066276
    },
    pubKeyHash: 0,
    scriptHash: 5,
    wif: 128
  }, a = 2147483648, A = Math.pow(2, 31) - 1;
  function b(ir) {
    return typeforce.String(ir) && ir.match(/^(m\/)?(\d+'?\/)*\d+'?$/) !== null;
  }
  function F(ir) {
    return typeforce.UInt32(ir) && ir <= A;
  }
  function le(ir) {
    return ir.length === 32 ? ir : ir.slice(1, 33);
  }
  class L {
    constructor(or, lr) {
      this.__D = or, this.__Q = lr, this.lowR = !1;
    }
    get publicKey() {
      return this.__Q === void 0 && (this.__Q = Buffer$f.from(n.pointFromScalar(this.__D, !0))), this.__Q;
    }
    get privateKey() {
      return this.__D;
    }
    sign(or, lr) {
      if (!this.privateKey)
        throw new Error("Missing private key");
      if (lr === void 0 && (lr = this.lowR), lr === !1)
        return Buffer$f.from(n.sign(or, this.privateKey));
      {
        let Ir = Buffer$f.from(n.sign(or, this.privateKey));
        const xr = Buffer$f.alloc(32, 0);
        let kr = 0;
        for (; Ir[0] > 127; )
          kr++, xr.writeUIntLE(kr, 0, 6), Ir = Buffer$f.from(n.sign(or, this.privateKey, xr));
        return Ir;
      }
    }
    signSchnorr(or) {
      if (!this.privateKey)
        throw new Error("Missing private key");
      if (!n.signSchnorr)
        throw new Error("signSchnorr not supported by ecc library");
      return Buffer$f.from(n.signSchnorr(or, this.privateKey));
    }
    verify(or, lr) {
      return n.verify(or, this.publicKey, lr);
    }
    verifySchnorr(or, lr) {
      if (!n.verifySchnorr)
        throw new Error("verifySchnorr not supported by ecc library");
      return n.verifySchnorr(or, this.publicKey.subarray(1, 33), lr);
    }
  }
  class pe extends L {
    constructor(or, lr, Ir, xr, kr = 0, Ce = 0, tr = 0) {
      super(or, lr), this.chainCode = Ir, this.network = xr, this.__DEPTH = kr, this.__INDEX = Ce, this.__PARENT_FINGERPRINT = tr, typeforce(u, xr);
    }
    get depth() {
      return this.__DEPTH;
    }
    get index() {
      return this.__INDEX;
    }
    get parentFingerprint() {
      return this.__PARENT_FINGERPRINT;
    }
    get identifier() {
      return crypto$3.hash160(this.publicKey);
    }
    get fingerprint() {
      return this.identifier.slice(0, 4);
    }
    get compressed() {
      return !0;
    }
    // Private === not neutered
    // Public === neutered
    isNeutered() {
      return this.__D === void 0;
    }
    neutered() {
      return Pe(this.publicKey, this.chainCode, this.network, this.depth, this.index, this.parentFingerprint);
    }
    toBase58() {
      const or = this.network, lr = this.isNeutered() ? or.bip32.public : or.bip32.private, Ir = Buffer$f.allocUnsafe(78);
      return Ir.writeUInt32BE(lr, 0), Ir.writeUInt8(this.depth, 4), Ir.writeUInt32BE(this.parentFingerprint, 5), Ir.writeUInt32BE(this.index, 9), this.chainCode.copy(Ir, 13), this.isNeutered() ? this.publicKey.copy(Ir, 45) : (Ir.writeUInt8(0, 45), this.privateKey.copy(Ir, 46)), bs58check.encode(Ir);
    }
    toWIF() {
      if (!this.privateKey)
        throw new TypeError("Missing private key");
      return wif$1.encode(this.network.wif, this.privateKey, !0);
    }
    // https://github.com/bitcoin/bips/blob/master/bip-0032.mediawiki#child-key-derivation-ckd-functions
    derive(or) {
      typeforce(typeforce.UInt32, or);
      const lr = or >= a, Ir = Buffer$f.allocUnsafe(37);
      if (lr) {
        if (this.isNeutered())
          throw new TypeError("Missing private key for hardened child key");
        Ir[0] = 0, this.privateKey.copy(Ir, 1), Ir.writeUInt32BE(or, 33);
      } else
        this.publicKey.copy(Ir, 0), Ir.writeUInt32BE(or, 33);
      const xr = crypto$3.hmacSHA512(this.chainCode, Ir), kr = xr.slice(0, 32), Ce = xr.slice(32);
      if (!n.isPrivate(kr))
        return this.derive(or + 1);
      let tr;
      if (this.isNeutered()) {
        const Fe = Buffer$f.from(n.pointAddScalar(this.publicKey, kr, !0));
        if (Fe === null)
          return this.derive(or + 1);
        tr = Pe(Fe, Ce, this.network, this.depth + 1, or, this.fingerprint.readUInt32BE(0));
      } else {
        const Fe = Buffer$f.from(n.privateAdd(this.privateKey, kr));
        if (Fe == null)
          return this.derive(or + 1);
        tr = be(Fe, Ce, this.network, this.depth + 1, or, this.fingerprint.readUInt32BE(0));
      }
      return tr;
    }
    deriveHardened(or) {
      return typeforce(F, or), this.derive(or + a);
    }
    derivePath(or) {
      typeforce(b, or);
      let lr = or.split("/");
      if (lr[0] === "m") {
        if (this.parentFingerprint)
          throw new TypeError("Expected master, got child");
        lr = lr.slice(1);
      }
      return lr.reduce((Ir, xr) => {
        let kr;
        return xr.slice(-1) === "'" ? (kr = parseInt(xr.slice(0, -1), 10), Ir.deriveHardened(kr)) : (kr = parseInt(xr, 10), Ir.derive(kr));
      }, this);
    }
    tweak(or) {
      return this.privateKey ? this.tweakFromPrivateKey(or) : this.tweakFromPublicKey(or);
    }
    tweakFromPublicKey(or) {
      const lr = le(this.publicKey);
      if (!n.xOnlyPointAddTweak)
        throw new Error("xOnlyPointAddTweak not supported by ecc library");
      const Ir = n.xOnlyPointAddTweak(lr, or);
      if (!Ir || Ir.xOnlyPubkey === null)
        throw new Error("Cannot tweak public key!");
      const xr = Buffer$f.from([
        Ir.parity === 0 ? 2 : 3
      ]), kr = Buffer$f.concat([
        xr,
        Ir.xOnlyPubkey
      ]);
      return new L(void 0, kr);
    }
    tweakFromPrivateKey(or) {
      const lr = this.publicKey[0] === 3 || this.publicKey[0] === 4 && (this.publicKey[64] & 1) === 1, Ir = (() => {
        if (lr) {
          if (n.privateNegate)
            return n.privateNegate(this.privateKey);
          throw new Error("privateNegate not supported by ecc library");
        } else return this.privateKey;
      })(), xr = n.privateAdd(Ir, or);
      if (!xr)
        throw new Error("Invalid tweaked private key!");
      return new L(Buffer$f.from(xr), void 0);
    }
  }
  function $(ir, or) {
    const lr = bs58check.decode(ir);
    if (lr.length !== 78)
      throw new TypeError("Invalid buffer length");
    or = or || p;
    const Ir = lr.readUInt32BE(0);
    if (Ir !== or.bip32.private && Ir !== or.bip32.public)
      throw new TypeError("Invalid network version");
    const xr = lr[4], kr = lr.readUInt32BE(5);
    if (xr === 0 && kr !== 0)
      throw new TypeError("Invalid parent fingerprint");
    const Ce = lr.readUInt32BE(9);
    if (xr === 0 && Ce !== 0)
      throw new TypeError("Invalid index");
    const tr = lr.slice(13, 45);
    let Fe;
    if (Ir === or.bip32.private) {
      if (lr.readUInt8(45) !== 0)
        throw new TypeError("Invalid private key");
      const Sr = lr.slice(46, 78);
      Fe = be(Sr, tr, or, xr, Ce, kr);
    } else {
      const Sr = lr.slice(45, 78);
      Fe = Pe(Sr, tr, or, xr, Ce, kr);
    }
    return Fe;
  }
  function Ee(ir, or, lr) {
    return be(ir, or, lr);
  }
  function be(ir, or, lr, Ir, xr, kr) {
    if (typeforce({
      privateKey: c,
      chainCode: c
    }, { privateKey: ir, chainCode: or }), lr = lr || p, !n.isPrivate(ir))
      throw new TypeError("Private key not in range [1, n)");
    return new pe(ir, void 0, or, lr, Ir, xr, kr);
  }
  function He(ir, or, lr) {
    return Pe(ir, or, lr);
  }
  function Pe(ir, or, lr, Ir, xr, kr) {
    if (typeforce({
      publicKey: typeforce.BufferN(33),
      chainCode: c
    }, { publicKey: ir, chainCode: or }), lr = lr || p, !n.isPoint(ir))
      throw new TypeError("Point is not on the curve");
    return new pe(void 0, ir, or, lr, Ir, xr, kr);
  }
  function nr(ir, or) {
    if (typeforce(typeforce.Buffer, ir), ir.length < 16)
      throw new TypeError("Seed should be at least 128 bits");
    if (ir.length > 64)
      throw new TypeError("Seed should be at most 512 bits");
    or = or || p;
    const lr = crypto$3.hmacSHA512(Buffer$f.from("Bitcoin seed", "utf8"), ir), Ir = lr.slice(0, 32), xr = lr.slice(32);
    return Ee(Ir, xr, or);
  }
  return {
    fromSeed: nr,
    fromBase58: $,
    fromPublicKey: He,
    fromPrivateKey: Ee
  };
}
bip32$2.BIP32Factory = BIP32Factory;
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.BIP32Factory = n.default = void 0;
  var c = bip32$2;
  Object.defineProperty(n, "default", { enumerable: !0, get: function() {
    return c.BIP32Factory;
  } }), Object.defineProperty(n, "BIP32Factory", { enumerable: !0, get: function() {
    return c.BIP32Factory;
  } });
})(src$2);
var src = {}, ecpair = {}, networks$1 = {};
Object.defineProperty(networks$1, "__esModule", { value: !0 });
networks$1.testnet = networks$1.bitcoin = void 0;
networks$1.bitcoin = {
  messagePrefix: `Bitcoin Signed Message:
`,
  bech32: "bc",
  bip32: {
    public: 76067358,
    private: 76066276
  },
  pubKeyHash: 0,
  scriptHash: 5,
  wif: 128
};
networks$1.testnet = {
  messagePrefix: `Bitcoin Signed Message:
`,
  bech32: "tb",
  bip32: {
    public: 70617039,
    private: 70615956
  },
  pubKeyHash: 111,
  scriptHash: 196,
  wif: 239
};
var types$2 = {};
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.maybe = n.Boolean = n.Array = n.Buffer256bit = n.Network = n.typeforce = void 0, n.typeforce = typeforce_1, n.Network = n.typeforce.compile({
    messagePrefix: n.typeforce.oneOf(
      n.typeforce.Buffer,
      n.typeforce.String
    ),
    bip32: {
      public: n.typeforce.UInt32,
      private: n.typeforce.UInt32
    },
    pubKeyHash: n.typeforce.UInt8,
    scriptHash: n.typeforce.UInt8,
    wif: n.typeforce.UInt8
  }), n.Buffer256bit = n.typeforce.BufferN(32), n.Array = n.typeforce.Array, n.Boolean = n.typeforce.Boolean, n.maybe = n.typeforce.maybe;
})(types$2);
var testecc = {};
Object.defineProperty(testecc, "__esModule", { value: !0 });
testecc.testEcc = void 0;
const h = (n) => Buffer$f.from(n, "hex");
function testEcc(n) {
  assert$5(
    n.isPoint(
      h("0279be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798")
    )
  ), assert$5(
    !n.isPoint(
      h("030000000000000000000000000000000000000000000000000000000000000005")
    )
  ), assert$5(
    n.isPrivate(
      h("79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798")
    )
  ), assert$5(
    n.isPrivate(
      h("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140")
    )
  ), assert$5(
    !n.isPrivate(
      h("0000000000000000000000000000000000000000000000000000000000000000")
    )
  ), assert$5(
    !n.isPrivate(
      h("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141")
    )
  ), assert$5(
    !n.isPrivate(
      h("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364142")
    )
  ), assert$5(
    Buffer$f.from(
      n.privateAdd(
        h("0000000000000000000000000000000000000000000000000000000000000001"),
        h("0000000000000000000000000000000000000000000000000000000000000000")
      )
    ).equals(
      h("0000000000000000000000000000000000000000000000000000000000000001")
    )
  ), assert$5(
    n.privateAdd(
      h("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd036413e"),
      h("0000000000000000000000000000000000000000000000000000000000000003")
    ) === null
  ), assert$5(
    Buffer$f.from(
      n.privateAdd(
        h("e211078564db65c3ce7704f08262b1f38f1ef412ad15b5ac2d76657a63b2c500"),
        h("b51fbb69051255d1becbd683de5848242a89c229348dd72896a87ada94ae8665")
      )
    ).equals(
      h("9730c2ee69edbb958d42db7460bafa18fef9d955325aec99044c81c8282b0a24")
    )
  ), assert$5(
    Buffer$f.from(
      n.privateNegate(
        h("0000000000000000000000000000000000000000000000000000000000000001")
      )
    ).equals(
      h("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140")
    )
  ), assert$5(
    Buffer$f.from(
      n.privateNegate(
        h("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd036413e")
      )
    ).equals(
      h("0000000000000000000000000000000000000000000000000000000000000003")
    )
  ), assert$5(
    Buffer$f.from(
      n.privateNegate(
        h("b1121e4088a66a28f5b6b0f5844943ecd9f610196d7bb83b25214b60452c09af")
      )
    ).equals(
      h("4eede1bf775995d70a494f0a7bb6bc11e0b8cccd41cce8009ab1132c8b0a3792")
    )
  ), assert$5(
    Buffer$f.from(
      n.pointCompress(
        h(
          "0479be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8"
        ),
        !0
      )
    ).equals(
      h("0279be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798")
    )
  ), assert$5(
    Buffer$f.from(
      n.pointCompress(
        h(
          "0479be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8"
        ),
        !1
      )
    ).equals(
      h(
        "0479be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8"
      )
    )
  ), assert$5(
    Buffer$f.from(
      n.pointCompress(
        h("0279be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798"),
        !0
      )
    ).equals(
      h("0279be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798")
    )
  ), assert$5(
    Buffer$f.from(
      n.pointCompress(
        h("0279be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798"),
        !1
      )
    ).equals(
      h(
        "0479be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8"
      )
    )
  ), assert$5(
    Buffer$f.from(
      n.pointFromScalar(
        h("b1121e4088a66a28f5b6b0f5844943ecd9f610196d7bb83b25214b60452c09af")
      )
    ).equals(
      h("02b07ba9dca9523b7ef4bd97703d43d20399eb698e194704791a25ce77a400df99")
    )
  ), assert$5(
    n.xOnlyPointAddTweak(
      h("79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798"),
      h("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140")
    ) === null
  );
  let c = n.xOnlyPointAddTweak(
    h("1617d38ed8d8657da4d4761e8057bc396ea9e4b9d29776d4be096016dbd2509b"),
    h("a8397a935f0dfceba6ba9618f6451ef4d80637abf4e6af2669fbc9de6a8fd2ac")
  );
  assert$5(
    Buffer$f.from(c.xOnlyPubkey).equals(
      h("e478f99dab91052ab39a33ea35fd5e6e4933f4d28023cd597c9a1f6760346adf")
    ) && c.parity === 1
  ), c = n.xOnlyPointAddTweak(
    h("2c0b7cf95324a07d05398b240174dc0c2be444d96b159aa6c7f7b1e668680991"),
    h("823c3cd2142744b075a87eade7e1b8678ba308d566226a0056ca2b7a76f86b47")
  ), assert$5(
    Buffer$f.from(c.xOnlyPubkey).equals(
      h("9534f8dc8c6deda2dc007655981c78b49c5d96c778fbf363462a11ec9dfd948c")
    ) && c.parity === 0
  ), assert$5(
    Buffer$f.from(
      n.sign(
        h("5e9f0a0d593efdcf78ac923bc3313e4e7d408d574354ee2b3288c0da9fbba6ed"),
        h("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140")
      )
    ).equals(
      h(
        "54c4a33c6423d689378f160a7ff8b61330444abb58fb470f96ea16d99d4a2fed07082304410efa6b2943111b6a4e0aaa7b7db55a07e9861d1fb3cb1f421044a5"
      )
    )
  ), assert$5(
    n.verify(
      h("5e9f0a0d593efdcf78ac923bc3313e4e7d408d574354ee2b3288c0da9fbba6ed"),
      h("0379be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798"),
      h(
        "54c4a33c6423d689378f160a7ff8b61330444abb58fb470f96ea16d99d4a2fed07082304410efa6b2943111b6a4e0aaa7b7db55a07e9861d1fb3cb1f421044a5"
      )
    )
  ), n.signSchnorr && assert$5(
    Buffer$f.from(
      n.signSchnorr(
        h("7e2d58d8b3bcdf1abadec7829054f90dda9805aab56c77333024b9d0a508b75c"),
        h("c90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b14e5c9"),
        h("c87aa53824b4d7ae2eb035a2b5bbbccc080e76cdc6d1692c4b0b62d798e6d906")
      )
    ).equals(
      h(
        "5831aaeed7b44bb74e5eab94ba9d4294c49bcf2a60728d8b4c200f50dd313c1bab745879a5ad954a72c45a91c3a51d3c7adea98d82f8481e0e1e03674a6f3fb7"
      )
    )
  ), n.verifySchnorr && assert$5(
    n.verifySchnorr(
      h("7e2d58d8b3bcdf1abadec7829054f90dda9805aab56c77333024b9d0a508b75c"),
      h("dd308afec5777e13121fa72b9cc1b7cc0139715309b086c960e18fd969774eb8"),
      h(
        "5831aaeed7b44bb74e5eab94ba9d4294c49bcf2a60728d8b4c200f50dd313c1bab745879a5ad954a72c45a91c3a51d3c7adea98d82f8481e0e1e03674a6f3fb7"
      )
    )
  );
}
testecc.testEcc = testEcc;
function assert$5(n) {
  if (!n) throw new Error("ecc library invalid");
}
Object.defineProperty(ecpair, "__esModule", { value: !0 });
ecpair.ECPairFactory = ecpair.networks = void 0;
const networks = networks$1;
ecpair.networks = networks;
const types$1 = types$2, randomBytes$1 = requireBrowser$9(), wif = wif$2, testecc_1 = testecc, isOptions = types$1.typeforce.maybe(
  types$1.typeforce.compile({
    compressed: types$1.maybe(types$1.Boolean),
    network: types$1.maybe(types$1.Network)
  })
), toXOnly = (n) => n.length === 32 ? n : n.slice(1, 33);
function ECPairFactory(n) {
  (0, testecc_1.testEcc)(n);
  function c(F) {
    return n.isPoint(F);
  }
  function u(F, le) {
    if (types$1.typeforce(types$1.Buffer256bit, F), !n.isPrivate(F))
      throw new TypeError("Private key not in range [1, n)");
    return types$1.typeforce(isOptions, le), new b(F, void 0, le);
  }
  function p(F, le) {
    return types$1.typeforce(n.isPoint, F), types$1.typeforce(isOptions, le), new b(void 0, F, le);
  }
  function a(F, le) {
    const L = wif.decode(F), pe = L.version;
    if (types$1.Array(le)) {
      if (le = le.filter(($) => pe === $.wif).pop(), !le) throw new Error("Unknown network version");
    } else if (le = le || networks.bitcoin, pe !== le.wif) throw new Error("Invalid network version");
    return u(L.privateKey, {
      compressed: L.compressed,
      network: le
    });
  }
  function A(F) {
    types$1.typeforce(isOptions, F), F === void 0 && (F = {});
    const le = F.rng || randomBytes$1;
    let L;
    do
      L = le(32), types$1.typeforce(types$1.Buffer256bit, L);
    while (!n.isPrivate(L));
    return u(L, F);
  }
  class b {
    constructor(le, L, pe) {
      As(this, "__D");
      As(this, "__Q");
      As(this, "compressed");
      As(this, "network");
      As(this, "lowR");
      this.__D = le, this.__Q = L, this.lowR = !1, pe === void 0 && (pe = {}), this.compressed = pe.compressed === void 0 ? !0 : pe.compressed, this.network = pe.network || networks.bitcoin, L !== void 0 && (this.__Q = Buffer$f.from(n.pointCompress(L, this.compressed)));
    }
    get privateKey() {
      return this.__D;
    }
    get publicKey() {
      if (!this.__Q) {
        const le = n.pointFromScalar(this.__D, this.compressed);
        this.__Q = Buffer$f.from(le);
      }
      return this.__Q;
    }
    toWIF() {
      if (!this.__D) throw new Error("Missing private key");
      return wif.encode(this.network.wif, this.__D, this.compressed);
    }
    tweak(le) {
      return this.privateKey ? this.tweakFromPrivateKey(le) : this.tweakFromPublicKey(le);
    }
    sign(le, L) {
      if (!this.__D) throw new Error("Missing private key");
      if (L === void 0 && (L = this.lowR), L === !1)
        return Buffer$f.from(n.sign(le, this.__D));
      {
        let pe = n.sign(le, this.__D);
        const $ = Buffer$f.alloc(32, 0);
        let Ee = 0;
        for (; pe[0] > 127; )
          Ee++, $.writeUIntLE(Ee, 0, 6), pe = n.sign(le, this.__D, $);
        return Buffer$f.from(pe);
      }
    }
    signSchnorr(le) {
      if (!this.privateKey) throw new Error("Missing private key");
      if (!n.signSchnorr)
        throw new Error("signSchnorr not supported by ecc library");
      return Buffer$f.from(n.signSchnorr(le, this.privateKey));
    }
    verify(le, L) {
      return n.verify(le, this.publicKey, L);
    }
    verifySchnorr(le, L) {
      if (!n.verifySchnorr)
        throw new Error("verifySchnorr not supported by ecc library");
      return n.verifySchnorr(le, this.publicKey.subarray(1, 33), L);
    }
    tweakFromPublicKey(le) {
      const L = toXOnly(this.publicKey), pe = n.xOnlyPointAddTweak(L, le);
      if (!pe || pe.xOnlyPubkey === null)
        throw new Error("Cannot tweak public key!");
      const $ = Buffer$f.from([
        pe.parity === 0 ? 2 : 3
      ]);
      return p(
        Buffer$f.concat([$, pe.xOnlyPubkey]),
        { network: this.network, compressed: this.compressed }
      );
    }
    tweakFromPrivateKey(le) {
      const pe = this.publicKey[0] === 3 || this.publicKey[0] === 4 && (this.publicKey[64] & 1) === 1 ? n.privateNegate(this.privateKey) : this.privateKey, $ = n.privateAdd(pe, le);
      if (!$) throw new Error("Invalid tweaked private key!");
      return u(Buffer$f.from($), {
        network: this.network,
        compressed: this.compressed
      });
    }
  }
  return {
    isPoint: c,
    fromPrivateKey: u,
    fromPublicKey: p,
    fromWIF: a,
    makeRandom: A
  };
}
ecpair.ECPairFactory = ECPairFactory;
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.networks = n.ECPairFactory = n.default = void 0;
  var c = ecpair;
  Object.defineProperty(n, "default", {
    enumerable: !0,
    get: function() {
      return c.ECPairFactory;
    }
  }), Object.defineProperty(n, "ECPairFactory", {
    enumerable: !0,
    get: function() {
      return c.ECPairFactory;
    }
  }), Object.defineProperty(n, "networks", {
    enumerable: !0,
    get: function() {
      return c.networks;
    }
  });
})(src);
var psbt$1 = {}, __createBinding$8 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(n, c, u, p) {
  p === void 0 && (p = u);
  var a = Object.getOwnPropertyDescriptor(c, u);
  (!a || ("get" in a ? !c.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
    return c[u];
  } }), Object.defineProperty(n, p, a);
} : function(n, c, u, p) {
  p === void 0 && (p = u), n[p] = c[u];
}), __setModuleDefault$8 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(n, c) {
  Object.defineProperty(n, "default", { enumerable: !0, value: c });
} : function(n, c) {
  n.default = c;
}), __importStar$8 = commonjsGlobal && commonjsGlobal.__importStar || function(n) {
  if (n && n.__esModule) return n;
  var c = {};
  if (n != null) for (var u in n) u !== "default" && Object.prototype.hasOwnProperty.call(n, u) && __createBinding$8(c, n, u);
  return __setModuleDefault$8(c, n), c;
};
Object.defineProperty(psbt$1, "__esModule", { value: !0 });
psbt$1.updatePsbt = psbt$1.finalScriptsFuncFactory = void 0;
const bitcoinjs_lib_1$a = src$j, varuint = __importStar$8(varint$3);
function reverseBuffer(n) {
  if (n.length < 1)
    return n;
  let c = n.length - 1, u = 0;
  for (let p = 0; p < n.length / 2; p++)
    u = n[p], n[p] = n[c], n[c] = u, c--;
  return n;
}
function witnessStackToScriptWitness(n) {
  let c = Buffer$f.allocUnsafe(0);
  function u(b) {
    c = Buffer$f.concat([c, Buffer$f.from(b)]);
  }
  function p(b) {
    const F = c.length, le = varuint.encodingLength(b);
    c = Buffer$f.concat([c, Buffer$f.allocUnsafe(le)]), varuint.encode(b, c, F);
  }
  function a(b) {
    p(b.length), u(b);
  }
  function A(b) {
    p(b.length), b.forEach(a);
  }
  return A(n), c;
}
function finalScriptsFuncFactory(n, c) {
  return (p, a, A, b, F, le) => {
    let L, pe;
    if (b && !F) {
      const $ = bitcoinjs_lib_1$a.payments.p2wsh({
        redeem: { input: n, output: A },
        network: c
      });
      if (!$.witness)
        throw new Error("Error: p2wsh failed producing a witness");
      L = witnessStackToScriptWitness($.witness);
    } else if (b && F) {
      const $ = bitcoinjs_lib_1$a.payments.p2sh({
        redeem: bitcoinjs_lib_1$a.payments.p2wsh({
          redeem: { input: n, output: A },
          network: c
        }),
        network: c
      });
      if (!$.witness)
        throw new Error("Error: p2sh-p2wsh failed producing a witness");
      L = witnessStackToScriptWitness($.witness), pe = $.input;
    } else
      pe = bitcoinjs_lib_1$a.payments.p2sh({
        redeem: { input: n, output: A },
        network: c
      }).input;
    return {
      finalScriptWitness: L,
      finalScriptSig: pe
    };
  };
}
psbt$1.finalScriptsFuncFactory = finalScriptsFuncFactory;
function updatePsbt({ psbt: n, vout: c, txHex: u, txId: p, value: a, sequence: A, locktime: b, keysInfo: F, scriptPubKey: le, isSegwit: L, witnessScript: pe, redeemScript: $ }) {
  var He;
  if (!L && u === void 0)
    throw new Error("Error: txHex is mandatory for Non-Segwit inputs");
  if (L && u === void 0 && (p === void 0 || a === void 0))
    throw new Error("Error: pass txHex or txId+value for Segwit inputs");
  if (u !== void 0) {
    const Pe = bitcoinjs_lib_1$a.Transaction.fromHex(u), nr = (He = Pe == null ? void 0 : Pe.outs) == null ? void 0 : He[c];
    if (!nr)
      throw new Error(`Error: tx ${u} does not have vout ${c}`);
    const ir = nr.script;
    if (!ir)
      throw new Error(`Error: could not extract outputScript for txHex ${u} and vout ${c}`);
    if (Buffer$f.compare(ir, le) !== 0)
      throw new Error(`Error: txHex ${u} for vout ${c} does not correspond to scriptPubKey ${le}`);
    if (p !== void 0) {
      if (Pe.getId() !== p)
        throw new Error(`Error: txId for ${u} and vout ${c} does not correspond to ${p}`);
    } else
      p = Pe.getId();
    if (a !== void 0) {
      if (nr.value !== a)
        throw new Error(`Error: value for ${u} and vout ${c} does not correspond to ${a}`);
    } else
      a = nr.value;
  }
  if (p === void 0 || !a)
    throw new Error("Error: txHex+vout required. Alternatively, but ONLY for Segwit inputs, txId+value can also be passed.");
  if (b) {
    if (n.locktime && n.locktime !== b)
      throw new Error(`Error: transaction locktime was already set with a different value: ${b} != ${n.locktime}`);
    if (A === void 0)
      A = 4294967294;
    else if (A > 4294967294)
      throw new Error(`Error: incompatible sequence: ${A} and locktime: ${b}`);
    n.setLocktime(b);
  }
  const Ee = {
    hash: reverseBuffer(Buffer$f.from(p, "hex")),
    index: c
  };
  u !== void 0 && (Ee.nonWitnessUtxo = bitcoinjs_lib_1$a.Transaction.fromHex(u).toBuffer());
  const be = F.filter((Pe) => Pe.pubkey && Pe.masterFingerprint && Pe.path).map((Pe) => {
    const nr = Pe.pubkey;
    if (!nr)
      throw new Error(`key ${Pe.keyExpression} missing pubkey`);
    return {
      masterFingerprint: Pe.masterFingerprint,
      pubkey: nr,
      path: Pe.path
    };
  });
  return be.length && (Ee.bip32Derivation = be), L && u !== void 0 && (Ee.witnessUtxo = { script: le, value: a }), A !== void 0 && (Ee.sequence = A), pe && (Ee.witnessScript = pe), $ && (Ee.redeemScript = $), n.addInput(Ee), n.data.inputs.length - 1;
}
psbt$1.updatePsbt = updatePsbt;
var checksum = {};
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.DescriptorChecksum = n.CHECKSUM_CHARSET = void 0;
  const c = (p, a) => {
    const A = p >> 35n;
    return p = (p & 0x7ffffffffn) << 5n ^ a, A & 1n && (p ^= 0xf5dee51989n), A & 2n && (p ^= 0xa9fdca3312n), A & 4n && (p ^= 0x1bab10e32dn), A & 8n && (p ^= 0x3706b1677an), A & 16n && (p ^= 0x644d626ffdn), p;
  };
  n.CHECKSUM_CHARSET = "qpzry9x8gf2tvdw0s3jn54khce6mua7l";
  const u = (p) => {
    const a = "0123456789()[],'/*abcdefgh@:$%{}IJKLMNOPQRSTUVWXYZ&+-.;<=>?!^_|~ijklmnopqrstuvwxyzABCDEFGH`#\"\\ ";
    let A = 1n, b = 0n, F = 0n;
    for (const L of p) {
      const pe = BigInt(a.indexOf(L));
      if (pe === -1n)
        return "";
      A = c(A, pe & 31n), b = b * 3n + (pe >> 5n), ++F === 3n && (A = c(A, b), b = 0n, F = 0n);
    }
    F > 0n && (A = c(A, b));
    for (let L = 0; L < 8; ++L)
      A = c(A, 0n);
    A ^= 1n;
    let le = "";
    for (let L = 0; L < 8; ++L) {
      const pe = A >> 5n * (7n - BigInt(L)) & 31n;
      if (pe < 0 || pe > Number.MAX_SAFE_INTEGER)
        throw new Error(`Error: could not compute checksum, invalid index ${pe}`);
      le += n.CHECKSUM_CHARSET[Number(pe)];
    }
    return le;
  };
  n.DescriptorChecksum = u;
})(checksum);
var keyExpressions = {}, ledger = {}, re = {};
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.reWshMiniscriptAnchored = n.reShWshMiniscriptAnchored = n.reShMiniscriptAnchored = n.reShWpkhAnchored = n.reWpkhAnchored = n.rePkhAnchored = n.reAddrAnchored = n.rePkAnchored = n.anchorStartAndEnd = n.reKeyExp = n.reXprvKey = n.reXpubKey = n.rePath = n.reXprv = n.reXpub = n.reWIF = n.rePubKey = n.reChecksum = n.reOrigin = n.reMasterFingerprint = n.reOriginPath = void 0;
  const c = checksum, u = String.raw`(['hH])`, p = String.raw`(\d+${u}?)`, a = String.raw`(${p}\/)`;
  n.reOriginPath = String.raw`(\/${a}*${p})`, n.reMasterFingerprint = String.raw`[0-9a-fA-F]{8}`, n.reOrigin = String.raw`(\[${n.reMasterFingerprint}(${n.reOriginPath})?\])`, n.reChecksum = String.raw`(#[${c.CHECKSUM_CHARSET}]{8})`;
  const A = String.raw`((02|03)[0-9a-fA-F]{64})`, b = String.raw`(04[0-9a-fA-F]{128})`;
  n.rePubKey = String.raw`(${A}|${b})`, n.reWIF = String.raw`([5KLc9][1-9A-HJ-NP-Za-km-z]{50,51})`, n.reXpub = String.raw`([xXtT]pub[1-9A-HJ-NP-Za-km-z]{79,108})`, n.reXprv = String.raw`([xXtT]prv[1-9A-HJ-NP-Za-km-z]{79,108})`;
  const F = String.raw`(\*(${u})?)`;
  n.rePath = String.raw`(\/(${a})*(${F}|${p}))`, n.reXpubKey = String.raw`(${n.reXpub})(${n.rePath})?`, n.reXprvKey = String.raw`(${n.reXprv})(${n.rePath})?`;
  const le = String.raw`(${n.reXpubKey}|${n.reXprvKey}|${n.rePubKey}|${n.reWIF})`;
  n.reKeyExp = String.raw`(${n.reOrigin})?(${le})`;
  const L = String.raw`pk\((.*?)\)`, pe = String.raw`addr\((.*?)\)`, $ = String.raw`pkh\(${n.reKeyExp}\)`, Ee = String.raw`wpkh\(${n.reKeyExp}\)`, be = String.raw`sh\(wpkh\(${n.reKeyExp}\)\)`, He = String.raw`(.*?)`, Pe = (Ir) => String.raw`sh\(${Ir}\)`, nr = (Ir) => String.raw`wsh\(${Ir}\)`, ir = (Ir) => Pe(nr(Ir)), or = (Ir) => String.raw`^${Ir}$`;
  n.anchorStartAndEnd = or;
  const lr = (Ir) => String.raw`${Ir}(${n.reChecksum})?`;
  n.rePkAnchored = (0, n.anchorStartAndEnd)(lr(L)), n.reAddrAnchored = (0, n.anchorStartAndEnd)(lr(pe)), n.rePkhAnchored = (0, n.anchorStartAndEnd)(lr($)), n.reWpkhAnchored = (0, n.anchorStartAndEnd)(lr(Ee)), n.reShWpkhAnchored = (0, n.anchorStartAndEnd)(lr(be)), n.reShMiniscriptAnchored = (0, n.anchorStartAndEnd)(lr(Pe(He))), n.reShWshMiniscriptAnchored = (0, n.anchorStartAndEnd)(lr(ir(He))), n.reWshMiniscriptAnchored = (0, n.anchorStartAndEnd)(lr(nr(He)));
})(re);
var main$1 = {}, appClient = {}, bip32$1 = {};
const HARDENED = 2147483648;
var BIPPath = function(n) {
  if (!Array.isArray(n))
    throw new Error("Input must be an Array");
  if (n.length === 0)
    throw new Error("Path must contain at least one level");
  for (var c = 0; c < n.length; c++)
    if (typeof n[c] != "number")
      throw new Error("Path element is not a number");
  this.path = n;
};
BIPPath.validatePathArray = function(n) {
  try {
    return BIPPath.fromPathArray(n), !0;
  } catch {
    return !1;
  }
};
BIPPath.validateString = function(n, c) {
  try {
    return BIPPath.fromString(n, c), !0;
  } catch {
    return !1;
  }
};
BIPPath.fromPathArray = function(n) {
  return new BIPPath(n);
};
BIPPath.fromString = function(n, c) {
  if (/^m\//i.test(n))
    n = n.slice(2);
  else if (c)
    throw new Error("Root element is required");
  for (var u = n.split("/"), p = new Array(u.length), a = 0; a < u.length; a++) {
    var A = /(\d+)([hH\']?)/.exec(u[a]);
    if (A === null)
      throw new Error("Invalid input");
    if (p[a] = parseInt(A[1], 10), p[a] >= HARDENED)
      throw new Error("Invalid child index");
    if (A[2] === "h" || A[2] === "H" || A[2] === "'")
      p[a] += HARDENED;
    else if (A[2].length != 0)
      throw new Error("Invalid modifier");
  }
  return new BIPPath(p);
};
BIPPath.prototype.toPathArray = function() {
  return this.path;
};
BIPPath.prototype.toString = function(n, c) {
  for (var u = new Array(this.path.length), p = 0; p < this.path.length; p++) {
    var a = this.path[p];
    a & HARDENED ? u[p] = (a & ~HARDENED) + (c ? "h" : "'") : u[p] = a;
  }
  return (n ? "" : "m/") + u.join("/");
};
BIPPath.prototype.inspect = function() {
  return "BIPPath <" + this.toString() + ">";
};
var bip32Path = BIPPath, hasRequiredBip32;
function requireBip32() {
  if (hasRequiredBip32) return bip32$1;
  hasRequiredBip32 = 1;
  var n = commonjsGlobal && commonjsGlobal.__importDefault || function(pe) {
    return pe && pe.__esModule ? pe : { default: pe };
  };
  Object.defineProperty(bip32$1, "__esModule", { value: !0 }), bip32$1.hardenedPathOf = bip32$1.getXpubComponents = bip32$1.pubkeyFromXpub = bip32$1.pathStringToArray = bip32$1.pathArrayToString = bip32$1.bip32asBuffer = bip32$1.pathElementsToBuffer = void 0;
  const c = n(bip32Path), u = n(bs58check$k);
  function p(pe) {
    const $ = Buffer$f.alloc(1 + pe.length * 4);
    return $[0] = pe.length, pe.forEach((Ee, be) => {
      $.writeUInt32BE(Ee, 1 + 4 * be);
    }), $;
  }
  bip32$1.pathElementsToBuffer = p;
  function a(pe) {
    const $ = pe ? b(pe) : [];
    return p($);
  }
  bip32$1.bip32asBuffer = a;
  function A(pe) {
    return pe.length == 0 ? "m" : c.default.fromPathArray(pe).toString();
  }
  bip32$1.pathArrayToString = A;
  function b(pe) {
    return pe == "m" || pe == "" ? [] : c.default.fromString(pe).toPathArray();
  }
  bip32$1.pathStringToArray = b;
  function F(pe) {
    const $ = u.default.decode(pe);
    return $.slice($.length - 33);
  }
  bip32$1.pubkeyFromXpub = F;
  function le(pe) {
    const $ = u.default.decode(pe);
    return {
      chaincode: $.slice(13, 45),
      pubkey: $.slice($.length - 33),
      version: $.readUInt32BE(0)
    };
  }
  bip32$1.getXpubComponents = le;
  function L(pe) {
    for (let $ = pe.length - 1; $ >= 0; $--)
      if (pe[$] >= 2147483648)
        return pe.slice(0, $ + 1);
    return [];
  }
  return bip32$1.hardenedPathOf = L, bip32$1;
}
var clientCommands$1 = {}, buffertools$1 = {}, varint$1 = {}, hasRequiredVarint;
function requireVarint() {
  if (hasRequiredVarint) return varint$1;
  hasRequiredVarint = 1, Object.defineProperty(varint$1, "__esModule", { value: !0 }), varint$1.createVarint = varint$1.parseVarint = varint$1.sanitizeBigintToNumber = void 0;
  function n(b, F, le, L) {
    for (let pe = 0; pe < F; pe++) {
      if (le[pe + L] == null)
        throw Error("Buffer too small");
      le[pe + L] = Number(b % BigInt(256)), b = b >> BigInt(8);
    }
  }
  function c(b, F, le) {
    let L = BigInt(0);
    for (let pe = 0; pe < le; pe++) {
      if (b[pe + F] == null)
        throw Error("Buffer too small");
      L += BigInt(b[pe + F]) << BigInt(pe * 8);
    }
    return L;
  }
  function u(b) {
    if (b < 0)
      throw RangeError("Negative bigint is not a valid varint");
    if (b > Number.MAX_SAFE_INTEGER)
      throw RangeError("Too large for a Number");
    return Number(b);
  }
  varint$1.sanitizeBigintToNumber = u;
  function p(b) {
    if (typeof b == "number" && (b = u(b)), b < BigInt(0))
      throw new RangeError("Negative numbers are not supported");
    if (b >= BigInt(1) << BigInt(64))
      throw new RangeError("Too large for a Bitcoin-style varint");
    return b < BigInt(253) ? 1 : b <= BigInt(65535) ? 3 : b <= BigInt(4294967295) ? 5 : 9;
  }
  function a(b, F) {
    if (F < 0)
      throw RangeError("Negative offset is invalid");
    if (b[F] == null)
      throw Error("Buffer too small");
    if (b[F] < 253)
      return [BigInt(b[F]), 1];
    {
      let le;
      return b[F] === 253 ? le = 2 : b[F] === 254 ? le = 4 : le = 8, [c(b, F + 1, le), le + 1];
    }
  }
  varint$1.parseVarint = a;
  function A(b) {
    typeof b == "number" && (b = u(b));
    const F = p(b);
    b = BigInt(b);
    const le = Buffer$f.alloc(F);
    return F == 1 ? le[0] = Number(b) : (F == 3 ? le[0] = 253 : F === 5 ? le[0] = 254 : le[0] = 255, n(b, F - 1, le, 1)), le;
  }
  return varint$1.createVarint = A, varint$1;
}
var hasRequiredBuffertools;
function requireBuffertools() {
  if (hasRequiredBuffertools) return buffertools$1;
  hasRequiredBuffertools = 1, Object.defineProperty(buffertools$1, "__esModule", { value: !0 }), buffertools$1.BufferReader = buffertools$1.BufferWriter = buffertools$1.unsafeFrom64bitLE = buffertools$1.unsafeTo64bitLE = void 0;
  const n = requireVarint();
  function c(A) {
    if (A > Number.MAX_SAFE_INTEGER)
      throw new Error("Can't convert numbers > MAX_SAFE_INT");
    const b = Buffer$f.alloc(8, 0);
    for (let F = 0; F < b.length; F++) {
      const le = A & 255;
      b[F] = le, A = (A - le) / 256;
    }
    return b;
  }
  buffertools$1.unsafeTo64bitLE = c;
  function u(A) {
    let b = 0;
    if (A.length != 8)
      throw new Error("Expected Bufffer of lenght 8");
    if (A[7] != 0)
      throw new Error("Can't encode numbers > MAX_SAFE_INT");
    if (A[6] > 31)
      throw new Error("Can't encode numbers > MAX_SAFE_INT");
    for (let F = A.length - 1; F >= 0; F--)
      b = b * 256 + A[F];
    return b;
  }
  buffertools$1.unsafeFrom64bitLE = u;
  class p {
    constructor() {
      this.bufs = [];
    }
    write(b, F) {
      const le = Buffer$f.alloc(b);
      F(le), this.bufs.push(le);
    }
    writeUInt8(b) {
      this.write(1, (F) => F.writeUInt8(b, 0));
    }
    writeInt32(b) {
      this.write(4, (F) => F.writeInt32LE(b, 0));
    }
    writeUInt32(b) {
      this.write(4, (F) => F.writeUInt32LE(b, 0));
    }
    writeUInt64(b) {
      const F = c(b);
      this.writeSlice(F);
    }
    writeVarInt(b) {
      this.bufs.push((0, n.createVarint)(b));
    }
    writeSlice(b) {
      this.bufs.push(Buffer$f.from(b));
    }
    writeVarSlice(b) {
      this.writeVarInt(b.length), this.writeSlice(b);
    }
    buffer() {
      return Buffer$f.concat(this.bufs);
    }
  }
  buffertools$1.BufferWriter = p;
  class a {
    constructor(b, F = 0) {
      this.buffer = b, this.offset = F;
    }
    available() {
      return this.buffer.length - this.offset;
    }
    readUInt8() {
      const b = this.buffer.readUInt8(this.offset);
      return this.offset++, b;
    }
    readInt32() {
      const b = this.buffer.readInt32LE(this.offset);
      return this.offset += 4, b;
    }
    readUInt32() {
      const b = this.buffer.readUInt32LE(this.offset);
      return this.offset += 4, b;
    }
    readUInt64() {
      const b = this.readSlice(8);
      return u(b);
    }
    readVarInt() {
      const [b, F] = (0, n.parseVarint)(this.buffer, this.offset);
      return this.offset += F, b;
    }
    readSlice(b) {
      if (this.buffer.length < this.offset + b)
        throw new Error("Cannot read slice out of bounds");
      const F = this.buffer.slice(this.offset, this.offset + b);
      return this.offset += b, F;
    }
    readVarSlice() {
      const b = (0, n.sanitizeBigintToNumber)(this.readVarInt());
      return this.readSlice(b);
    }
    readVector() {
      const b = this.readVarInt(), F = [];
      for (let le = 0; le < b; le++)
        F.push(this.readVarSlice());
      return F;
    }
  }
  return buffertools$1.BufferReader = a, buffertools$1;
}
var merkle$1 = {}, hasRequiredMerkle;
function requireMerkle() {
  if (hasRequiredMerkle) return merkle$1;
  hasRequiredMerkle = 1, Object.defineProperty(merkle$1, "__esModule", { value: !0 }), merkle$1.hashLeaf = merkle$1.Merkle = void 0;
  const n = src$j;
  class c {
    constructor(L, pe = n.crypto.sha256) {
      this.leaves = L, this.h = pe;
      const $ = this.calculateRoot(L);
      this.rootNode = $.root, this.leafNodes = $.leaves;
    }
    getRoot() {
      return this.rootNode.hash;
    }
    size() {
      return this.leaves.length;
    }
    getLeaves() {
      return this.leaves;
    }
    getLeafHash(L) {
      return this.leafNodes[L].hash;
    }
    getProof(L) {
      if (L >= this.leaves.length)
        throw Error("Index out of bounds");
      return A(this.leafNodes[L]);
    }
    calculateRoot(L) {
      const pe = L.length;
      if (pe == 0)
        return {
          root: new a(void 0, void 0, Buffer$f.alloc(32, 0)),
          leaves: []
        };
      if (pe == 1) {
        const or = new a(void 0, void 0, L[0]);
        return { root: or, leaves: [or] };
      }
      const $ = b(pe), Ee = this.calculateRoot(L.slice(0, $)), be = this.calculateRoot(L.slice($)), He = Ee.root, Pe = be.root, nr = this.hashNode(He.hash, Pe.hash), ir = new a(He, Pe, nr);
      return He.parent = ir, Pe.parent = ir, { root: ir, leaves: Ee.leaves.concat(be.leaves) };
    }
    hashNode(L, pe) {
      return this.h(Buffer$f.concat([Buffer$f.from([1]), L, pe]));
    }
  }
  merkle$1.Merkle = c;
  function u(le, L = n.crypto.sha256) {
    return p(Buffer$f.from([0]), le, L);
  }
  merkle$1.hashLeaf = u;
  function p(le, L, pe) {
    return pe(Buffer$f.concat([le, L]));
  }
  class a {
    constructor(L, pe, $) {
      this.leftChild = L, this.rightChild = pe, this.hash = $;
    }
    isLeaf() {
      return this.leftChild == null;
    }
  }
  function A(le) {
    if (!le.parent)
      return [];
    if (le.parent.leftChild == le) {
      if (!le.parent.rightChild)
        throw new Error("Expected right child to exist");
      return [le.parent.rightChild.hash, ...A(le.parent)];
    } else {
      if (!le.parent.leftChild)
        throw new Error("Expected left child to exist");
      return [le.parent.leftChild.hash, ...A(le.parent)];
    }
  }
  function b(le) {
    if (le < 2)
      throw Error("Expected n >= 2");
    return F(le) ? le / 2 : 1 << Math.floor(Math.log2(le));
  }
  function F(le) {
    return (le & le - 1) == 0;
  }
  return merkle$1;
}
var hasRequiredClientCommands;
function requireClientCommands() {
  if (hasRequiredClientCommands) return clientCommands$1;
  hasRequiredClientCommands = 1, Object.defineProperty(clientCommands$1, "__esModule", { value: !0 }), clientCommands$1.ClientCommandInterpreter = clientCommands$1.GetMoreElementsCommand = clientCommands$1.GetMerkleLeafIndexCommand = clientCommands$1.GetMerkleLeafProofCommand = clientCommands$1.GetPreimageCommand = clientCommands$1.YieldCommand = void 0;
  const n = src$j, c = requireBuffertools(), u = requireMerkle(), p = requireVarint();
  var a;
  (function(Ee) {
    Ee[Ee.YIELD = 16] = "YIELD", Ee[Ee.GET_PREIMAGE = 64] = "GET_PREIMAGE", Ee[Ee.GET_MERKLE_LEAF_PROOF = 65] = "GET_MERKLE_LEAF_PROOF", Ee[Ee.GET_MERKLE_LEAF_INDEX = 66] = "GET_MERKLE_LEAF_INDEX", Ee[Ee.GET_MORE_ELEMENTS = 160] = "GET_MORE_ELEMENTS";
  })(a || (a = {}));
  class A {
  }
  class b extends A {
    constructor(be, He) {
      super(), this.progressCallback = He, this.code = a.YIELD, this.results = be;
    }
    execute(be) {
      return this.results.push(Buffer$f.from(be.subarray(1))), this.progressCallback && this.progressCallback(), Buffer$f.from("");
    }
  }
  clientCommands$1.YieldCommand = b;
  class F extends A {
    constructor(be, He) {
      super(), this.code = a.GET_PREIMAGE, this.known_preimages = be, this.queue = He;
    }
    execute(be) {
      const He = Buffer$f.from(be.subarray(1));
      if (He.length != 33)
        throw new Error("Invalid request, unexpected trailing data");
      if (He[0] != 0)
        throw new Error("Unsupported request, the first byte should be 0");
      const Pe = Buffer$f.alloc(32);
      for (let or = 0; or < 32; or++)
        Pe[or] = He[1 + or];
      const nr = Pe.toString("hex"), ir = this.known_preimages.get(nr);
      if (ir != null) {
        const or = (0, p.createVarint)(ir.length), lr = 255 - or.length - 1, Ir = Math.min(lr, ir.length);
        if (Ir < ir.length)
          for (let xr = Ir; xr < ir.length; xr++)
            this.queue.push(Buffer$f.from([ir[xr]]));
        return Buffer$f.concat([
          or,
          Buffer$f.from([Ir]),
          Buffer$f.from(ir.subarray(0, Ir))
        ]);
      }
      throw Error(`Requested unknown preimage for: ${nr}`);
    }
  }
  clientCommands$1.GetPreimageCommand = F;
  class le extends A {
    constructor(be, He) {
      super(), this.code = a.GET_MERKLE_LEAF_PROOF, this.known_trees = be, this.queue = He;
    }
    execute(be) {
      const He = Buffer$f.from(be.subarray(1));
      if (He.length < 34)
        throw new Error("Invalid request, expected at least 34 bytes");
      const Pe = new c.BufferReader(He), ir = Pe.readSlice(32).toString("hex");
      let or, lr;
      try {
        or = (0, p.sanitizeBigintToNumber)(Pe.readVarInt()), lr = (0, p.sanitizeBigintToNumber)(Pe.readVarInt());
      } catch {
        throw new Error("Invalid request, couldn't parse tree_size or leaf_index");
      }
      const Ir = this.known_trees.get(ir);
      if (!Ir)
        throw Error(`Requested Merkle leaf proof for unknown tree: ${ir}`);
      if (lr >= or || Ir.size() != or)
        throw Error("Invalid index or tree size.");
      if (this.queue.length != 0)
        throw Error("This command should not execute when the queue is not empty.");
      const xr = Ir.getProof(lr), kr = Math.min(Math.floor(221 / 32), xr.length), Ce = xr.length - kr;
      return Ce > 0 && this.queue.push(...xr.slice(-Ce)), Buffer$f.concat([
        Ir.getLeafHash(lr),
        Buffer$f.from([xr.length]),
        Buffer$f.from([kr]),
        ...xr.slice(0, kr)
      ]);
    }
  }
  clientCommands$1.GetMerkleLeafProofCommand = le;
  class L extends A {
    constructor(be) {
      super(), this.code = a.GET_MERKLE_LEAF_INDEX, this.known_trees = be;
    }
    execute(be) {
      const He = Buffer$f.from(be.subarray(1));
      if (He.length != 64)
        throw new Error("Invalid request, unexpected trailing data");
      const Pe = Buffer$f.alloc(32);
      for (let kr = 0; kr < 32; kr++)
        Pe[kr] = He.readUInt8(kr);
      const nr = Pe.toString("hex"), ir = Buffer$f.alloc(32);
      for (let kr = 0; kr < 32; kr++)
        ir[kr] = He.readUInt8(32 + kr);
      const or = ir.toString("hex"), lr = this.known_trees.get(nr);
      if (!lr)
        throw Error(`Requested Merkle leaf index for unknown root: ${nr}`);
      let Ir = 0, xr = 0;
      for (let kr = 0; kr < lr.size(); kr++)
        if (lr.getLeafHash(kr).toString("hex") == or) {
          xr = 1, Ir = kr;
          break;
        }
      return Buffer$f.concat([Buffer$f.from([xr]), (0, p.createVarint)(Ir)]);
    }
  }
  clientCommands$1.GetMerkleLeafIndexCommand = L;
  class pe extends A {
    constructor(be) {
      super(), this.code = a.GET_MORE_ELEMENTS, this.queue = be;
    }
    execute(be) {
      if (be.length != 1)
        throw new Error("Invalid request, unexpected trailing data");
      if (this.queue.length === 0)
        throw new Error("No elements to get");
      const He = this.queue[0].length;
      if (this.queue.some((or) => or.length != He))
        throw new Error("The queue contains elements with different byte length, which is not expected");
      const Pe = Math.floor(253 / He), nr = Math.min(Pe, this.queue.length), ir = this.queue.splice(0, nr);
      return Buffer$f.concat([
        Buffer$f.from([nr]),
        Buffer$f.from([He]),
        ...ir
      ]);
    }
  }
  clientCommands$1.GetMoreElementsCommand = pe;
  class $ {
    constructor(be) {
      this.roots = /* @__PURE__ */ new Map(), this.preimages = /* @__PURE__ */ new Map(), this.yielded = [], this.queue = [], this.commands = /* @__PURE__ */ new Map();
      const He = [
        new b(this.yielded, be),
        new F(this.preimages, this.queue),
        new L(this.roots),
        new le(this.roots, this.queue),
        new pe(this.queue)
      ];
      for (const Pe of He) {
        if (this.commands.has(Pe.code))
          throw new Error(`Multiple commands with code ${Pe.code}`);
        this.commands.set(Pe.code, Pe);
      }
    }
    getYielded() {
      return this.yielded;
    }
    addKnownPreimage(be) {
      this.preimages.set(n.crypto.sha256(be).toString("hex"), be);
    }
    addKnownList(be) {
      for (const Pe of be) {
        const nr = Buffer$f.concat([Buffer$f.from([0]), Pe]);
        this.addKnownPreimage(nr);
      }
      const He = new u.Merkle(be.map((Pe) => (0, u.hashLeaf)(Pe)));
      this.roots.set(He.getRoot().toString("hex"), He);
    }
    addKnownMapping(be) {
      this.addKnownList(be.keys), this.addKnownList(be.values);
    }
    addKnownWalletPolicy(be) {
      this.addKnownPreimage(be.serialize()), this.addKnownList(be.keys.map((He) => Buffer$f.from(He, "ascii"))), this.addKnownPreimage(Buffer$f.from(be.descriptorTemplate));
    }
    execute(be) {
      if (be.length == 0)
        throw new Error("Unexpected empty command");
      const He = be[0], Pe = this.commands.get(He);
      if (!Pe)
        throw new Error(`Unexpected command code ${He}`);
      return Pe.execute(be);
    }
  }
  return clientCommands$1.ClientCommandInterpreter = $, clientCommands$1;
}
var merkelizedPsbt$1 = {}, merkleMap$1 = {}, hasRequiredMerkleMap;
function requireMerkleMap() {
  if (hasRequiredMerkleMap) return merkleMap$1;
  hasRequiredMerkleMap = 1, Object.defineProperty(merkleMap$1, "__esModule", { value: !0 }), merkleMap$1.MerkleMap = void 0;
  const n = requireMerkle(), c = requireVarint();
  class u {
    /**
     * @param keys Sorted list of (unhashed) keys
     * @param values values, in corresponding order as the keys, and of equal length
     */
    constructor(a, A) {
      if (a.length != A.length)
        throw new Error("keys and values should have the same length");
      for (let b = 0; b < a.length - 1; b++)
        if (a[b].toString("hex") >= a[b + 1].toString("hex"))
          throw new Error("keys must be in strictly increasing order");
      this.keys = a, this.keysTree = new n.Merkle(a.map((b) => (0, n.hashLeaf)(b))), this.values = A, this.valuesTree = new n.Merkle(A.map((b) => (0, n.hashLeaf)(b)));
    }
    commitment() {
      return Buffer$f.concat([
        (0, c.createVarint)(this.keys.length),
        this.keysTree.getRoot(),
        this.valuesTree.getRoot()
      ]);
    }
  }
  return merkleMap$1.MerkleMap = u, merkleMap$1;
}
var psbtv2$1 = {}, hasRequiredPsbtv2;
function requirePsbtv2() {
  return hasRequiredPsbtv2 || (hasRequiredPsbtv2 = 1, function(n) {
    var c = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(tr, Fe, Sr, er) {
      er === void 0 && (er = Sr);
      var Ie = Object.getOwnPropertyDescriptor(Fe, Sr);
      (!Ie || ("get" in Ie ? !Fe.__esModule : Ie.writable || Ie.configurable)) && (Ie = { enumerable: !0, get: function() {
        return Fe[Sr];
      } }), Object.defineProperty(tr, er, Ie);
    } : function(tr, Fe, Sr, er) {
      er === void 0 && (er = Sr), tr[er] = Fe[Sr];
    }), u = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(tr, Fe) {
      Object.defineProperty(tr, "default", { enumerable: !0, value: Fe });
    } : function(tr, Fe) {
      tr.default = Fe;
    }), p = commonjsGlobal && commonjsGlobal.__importStar || function(tr) {
      if (tr && tr.__esModule) return tr;
      var Fe = {};
      if (tr != null) for (var Sr in tr) Sr !== "default" && Object.prototype.hasOwnProperty.call(tr, Sr) && c(Fe, tr, Sr);
      return u(Fe, tr), Fe;
    };
    Object.defineProperty(n, "__esModule", { value: !0 }), n.PsbtV2 = n.NoSuchEntry = n.psbtOut = n.psbtIn = n.psbtGlobal = void 0;
    const a = p(src$j), A = requireBuffertools(), b = requireVarint();
    var F;
    (function(tr) {
      tr[tr.UNSIGNED_TX = 0] = "UNSIGNED_TX", tr[tr.XPUB = 1] = "XPUB", tr[tr.TX_VERSION = 2] = "TX_VERSION", tr[tr.FALLBACK_LOCKTIME = 3] = "FALLBACK_LOCKTIME", tr[tr.INPUT_COUNT = 4] = "INPUT_COUNT", tr[tr.OUTPUT_COUNT = 5] = "OUTPUT_COUNT", tr[tr.TX_MODIFIABLE = 6] = "TX_MODIFIABLE", tr[tr.VERSION = 251] = "VERSION";
    })(F = n.psbtGlobal || (n.psbtGlobal = {}));
    var le;
    (function(tr) {
      tr[tr.NON_WITNESS_UTXO = 0] = "NON_WITNESS_UTXO", tr[tr.WITNESS_UTXO = 1] = "WITNESS_UTXO", tr[tr.PARTIAL_SIG = 2] = "PARTIAL_SIG", tr[tr.SIGHASH_TYPE = 3] = "SIGHASH_TYPE", tr[tr.REDEEM_SCRIPT = 4] = "REDEEM_SCRIPT", tr[tr.WITNESS_SCRIPT = 5] = "WITNESS_SCRIPT", tr[tr.BIP32_DERIVATION = 6] = "BIP32_DERIVATION", tr[tr.FINAL_SCRIPTSIG = 7] = "FINAL_SCRIPTSIG", tr[tr.FINAL_SCRIPTWITNESS = 8] = "FINAL_SCRIPTWITNESS", tr[tr.PREVIOUS_TXID = 14] = "PREVIOUS_TXID", tr[tr.OUTPUT_INDEX = 15] = "OUTPUT_INDEX", tr[tr.SEQUENCE = 16] = "SEQUENCE", tr[tr.TAP_KEY_SIG = 19] = "TAP_KEY_SIG", tr[tr.TAP_BIP32_DERIVATION = 22] = "TAP_BIP32_DERIVATION";
    })(le = n.psbtIn || (n.psbtIn = {}));
    var L;
    (function(tr) {
      tr[tr.REDEEM_SCRIPT = 0] = "REDEEM_SCRIPT", tr[tr.WITNESS_SCRIPT = 1] = "WITNESS_SCRIPT", tr[tr.BIP_32_DERIVATION = 2] = "BIP_32_DERIVATION", tr[tr.AMOUNT = 3] = "AMOUNT", tr[tr.SCRIPT = 4] = "SCRIPT", tr[tr.TAP_BIP32_DERIVATION = 7] = "TAP_BIP32_DERIVATION";
    })(L = n.psbtOut || (n.psbtOut = {}));
    const pe = Buffer$f.from([112, 115, 98, 116, 255]);
    class $ extends Error {
    }
    n.NoSuchEntry = $;
    class Ee {
      constructor() {
        this.globalMap = /* @__PURE__ */ new Map(), this.inputMaps = [], this.outputMaps = [];
      }
      setGlobalTxVersion(Fe) {
        this.setGlobal(F.TX_VERSION, Ir(Fe));
      }
      getGlobalTxVersion() {
        return this.getGlobal(F.TX_VERSION).readUInt32LE(0);
      }
      setGlobalFallbackLocktime(Fe) {
        this.setGlobal(F.FALLBACK_LOCKTIME, Ir(Fe));
      }
      getGlobalFallbackLocktime() {
        var Fe;
        return (Fe = this.getGlobalOptional(F.FALLBACK_LOCKTIME)) === null || Fe === void 0 ? void 0 : Fe.readUInt32LE(0);
      }
      setGlobalInputCount(Fe) {
        this.setGlobal(F.INPUT_COUNT, kr(Fe));
      }
      getGlobalInputCount() {
        return Ce(this.getGlobal(F.INPUT_COUNT));
      }
      setGlobalOutputCount(Fe) {
        this.setGlobal(F.OUTPUT_COUNT, kr(Fe));
      }
      getGlobalOutputCount() {
        return Ce(this.getGlobal(F.OUTPUT_COUNT));
      }
      setGlobalTxModifiable(Fe) {
        this.setGlobal(F.TX_MODIFIABLE, Fe);
      }
      getGlobalTxModifiable() {
        return this.getGlobalOptional(F.TX_MODIFIABLE);
      }
      setGlobalPsbtVersion(Fe) {
        this.setGlobal(F.VERSION, Ir(Fe));
      }
      getGlobalPsbtVersion() {
        return this.getGlobal(F.VERSION).readUInt32LE(0);
      }
      setInputNonWitnessUtxo(Fe, Sr) {
        this.setInput(Fe, le.NON_WITNESS_UTXO, or(), Sr);
      }
      getInputNonWitnessUtxo(Fe) {
        return this.getInputOptional(Fe, le.NON_WITNESS_UTXO, or());
      }
      setInputWitnessUtxo(Fe, Sr, er) {
        const Ie = new A.BufferWriter();
        Ie.writeSlice(xr(Sr)), Ie.writeVarSlice(er), this.setInput(Fe, le.WITNESS_UTXO, or(), Ie.buffer());
      }
      getInputWitnessUtxo(Fe) {
        const Sr = this.getInputOptional(Fe, le.WITNESS_UTXO, or());
        if (!Sr)
          return;
        const er = new A.BufferReader(Sr);
        return {
          amount: (0, A.unsafeFrom64bitLE)(er.readSlice(8)),
          scriptPubKey: er.readVarSlice()
        };
      }
      setInputPartialSig(Fe, Sr, er) {
        this.setInput(Fe, le.PARTIAL_SIG, Sr, er);
      }
      getInputPartialSig(Fe, Sr) {
        return this.getInputOptional(Fe, le.PARTIAL_SIG, Sr);
      }
      setInputSighashType(Fe, Sr) {
        this.setInput(Fe, le.SIGHASH_TYPE, or(), Ir(Sr));
      }
      getInputSighashType(Fe) {
        const Sr = this.getInputOptional(Fe, le.SIGHASH_TYPE, or());
        if (Sr)
          return Sr.readUInt32LE(0);
      }
      setInputRedeemScript(Fe, Sr) {
        this.setInput(Fe, le.REDEEM_SCRIPT, or(), Sr);
      }
      getInputRedeemScript(Fe) {
        return this.getInputOptional(Fe, le.REDEEM_SCRIPT, or());
      }
      setInputWitnessScript(Fe, Sr) {
        this.setInput(Fe, le.WITNESS_SCRIPT, or(), Sr);
      }
      getInputWitnessScript(Fe) {
        return this.getInputOptional(Fe, le.WITNESS_SCRIPT, or());
      }
      setInputBip32Derivation(Fe, Sr, er, Ie) {
        if (Sr.length != 33)
          throw new Error("Invalid pubkey length: " + Sr.length);
        this.setInput(Fe, le.BIP32_DERIVATION, Sr, this.encodeBip32Derivation(er, Ie));
      }
      getInputBip32Derivation(Fe, Sr) {
        const er = this.getInputOptional(Fe, le.BIP32_DERIVATION, Sr);
        if (er)
          return this.decodeBip32Derivation(er);
      }
      setInputFinalScriptsig(Fe, Sr) {
        this.setInput(Fe, le.FINAL_SCRIPTSIG, or(), Sr);
      }
      getInputFinalScriptsig(Fe) {
        return this.getInputOptional(Fe, le.FINAL_SCRIPTSIG, or());
      }
      setInputFinalScriptwitness(Fe, Sr) {
        this.setInput(Fe, le.FINAL_SCRIPTWITNESS, or(), Sr);
      }
      getInputFinalScriptwitness(Fe) {
        return this.getInput(Fe, le.FINAL_SCRIPTWITNESS, or());
      }
      setInputPreviousTxId(Fe, Sr) {
        this.setInput(Fe, le.PREVIOUS_TXID, or(), Sr);
      }
      getInputPreviousTxid(Fe) {
        return this.getInput(Fe, le.PREVIOUS_TXID, or());
      }
      setInputOutputIndex(Fe, Sr) {
        this.setInput(Fe, le.OUTPUT_INDEX, or(), Ir(Sr));
      }
      getInputOutputIndex(Fe) {
        return this.getInput(Fe, le.OUTPUT_INDEX, or()).readUInt32LE(0);
      }
      setInputSequence(Fe, Sr) {
        this.setInput(Fe, le.SEQUENCE, or(), Ir(Sr));
      }
      getInputSequence(Fe) {
        var Sr, er;
        return (er = (Sr = this.getInputOptional(Fe, le.SEQUENCE, or())) === null || Sr === void 0 ? void 0 : Sr.readUInt32LE(0)) !== null && er !== void 0 ? er : 4294967295;
      }
      setInputTapKeySig(Fe, Sr) {
        this.setInput(Fe, le.TAP_KEY_SIG, or(), Sr);
      }
      getInputTapKeySig(Fe) {
        return this.getInputOptional(Fe, le.TAP_KEY_SIG, or());
      }
      setInputTapBip32Derivation(Fe, Sr, er, Ie, xe) {
        if (Sr.length != 32)
          throw new Error("Invalid pubkey length: " + Sr.length);
        const rr = this.encodeTapBip32Derivation(er, Ie, xe);
        this.setInput(Fe, le.TAP_BIP32_DERIVATION, Sr, rr);
      }
      getInputTapBip32Derivation(Fe, Sr) {
        const er = this.getInput(Fe, le.TAP_BIP32_DERIVATION, Sr);
        return this.decodeTapBip32Derivation(er);
      }
      getInputKeyDatas(Fe, Sr) {
        return this.getKeyDatas(this.inputMaps[Fe], Sr);
      }
      setOutputRedeemScript(Fe, Sr) {
        this.setOutput(Fe, L.REDEEM_SCRIPT, or(), Sr);
      }
      getOutputRedeemScript(Fe) {
        return this.getOutput(Fe, L.REDEEM_SCRIPT, or());
      }
      setOutputBip32Derivation(Fe, Sr, er, Ie) {
        this.setOutput(Fe, L.BIP_32_DERIVATION, Sr, this.encodeBip32Derivation(er, Ie));
      }
      getOutputBip32Derivation(Fe, Sr) {
        const er = this.getOutput(Fe, L.BIP_32_DERIVATION, Sr);
        return this.decodeBip32Derivation(er);
      }
      setOutputAmount(Fe, Sr) {
        this.setOutput(Fe, L.AMOUNT, or(), xr(Sr));
      }
      getOutputAmount(Fe) {
        const Sr = this.getOutput(Fe, L.AMOUNT, or());
        return (0, A.unsafeFrom64bitLE)(Sr);
      }
      setOutputScript(Fe, Sr) {
        this.setOutput(Fe, L.SCRIPT, or(), Sr);
      }
      getOutputScript(Fe) {
        return this.getOutput(Fe, L.SCRIPT, or());
      }
      setOutputTapBip32Derivation(Fe, Sr, er, Ie, xe) {
        const rr = this.encodeTapBip32Derivation(er, Ie, xe);
        this.setOutput(Fe, L.TAP_BIP32_DERIVATION, Sr, rr);
      }
      getOutputTapBip32Derivation(Fe, Sr) {
        const er = this.getOutput(Fe, L.TAP_BIP32_DERIVATION, Sr);
        return this.decodeTapBip32Derivation(er);
      }
      deleteInputEntries(Fe, Sr) {
        this.inputMaps[Fe].forEach((Ie, xe, rr) => {
          this.isKeyType(xe, Sr) && rr.delete(xe);
        });
      }
      copy(Fe) {
        this.copyMap(this.globalMap, Fe.globalMap), this.copyMaps(this.inputMaps, Fe.inputMaps), this.copyMaps(this.outputMaps, Fe.outputMaps);
      }
      copyMaps(Fe, Sr) {
        Fe.forEach((er, Ie) => {
          const xe = /* @__PURE__ */ new Map();
          this.copyMap(er, xe), Sr[Ie] = xe;
        });
      }
      copyMap(Fe, Sr) {
        Fe.forEach((er, Ie) => Sr.set(Ie, Buffer$f.from(er)));
      }
      serialize() {
        const Fe = new A.BufferWriter();
        return Fe.writeSlice(Buffer$f.from([112, 115, 98, 116, 255])), ir(Fe, this.globalMap), this.inputMaps.forEach((Sr) => {
          ir(Fe, Sr);
        }), this.outputMaps.forEach((Sr) => {
          ir(Fe, Sr);
        }), Fe.buffer();
      }
      deserialize(Fe) {
        const Sr = new A.BufferReader(Fe);
        if (!Sr.readSlice(5).equals(pe))
          throw new Error("Invalid magic bytes");
        for (; this.readKeyPair(this.globalMap, Sr); )
          ;
        let er;
        try {
          er = this.getGlobalPsbtVersion();
        } catch {
          er = 0;
        }
        if (er !== 0 && er !== 2)
          throw new Error("Only PSBTs of version 0 or 2 are supported");
        let Ie, xe;
        if (er == 0) {
          const rr = this.getGlobal(F.UNSIGNED_TX), ar = a.Transaction.fromBuffer(rr);
          Ie = ar.ins.length, xe = ar.outs.length;
        } else
          Ie = this.getGlobalInputCount(), xe = this.getGlobalOutputCount();
        for (let rr = 0; rr < Ie; rr++)
          for (this.inputMaps[rr] = /* @__PURE__ */ new Map(); this.readKeyPair(this.inputMaps[rr], Sr); )
            ;
        for (let rr = 0; rr < xe; rr++)
          for (this.outputMaps[rr] = /* @__PURE__ */ new Map(); this.readKeyPair(this.outputMaps[rr], Sr); )
            ;
        this.normalizeToV2();
      }
      normalizeToV2() {
        var Fe;
        const Sr = (Fe = this.getGlobalOptional(F.VERSION)) === null || Fe === void 0 ? void 0 : Fe.readInt32LE(0);
        if (Sr === 2)
          return;
        if (Sr !== void 0)
          throw new Error("Invalid or unsupported value for PSBT_GLOBAL_VERSION");
        const er = this.getGlobal(F.UNSIGNED_TX), Ie = a.Transaction.fromBuffer(er);
        this.setGlobalPsbtVersion(2), this.setGlobalTxVersion(Ie.version), this.setGlobalFallbackLocktime(Ie.locktime), this.setGlobalInputCount(Ie.ins.length), this.setGlobalOutputCount(Ie.outs.length);
        for (let xe = 0; xe < Ie.ins.length; xe++)
          this.setInputPreviousTxId(xe, Ie.ins[xe].hash), this.setInputOutputIndex(xe, Ie.ins[xe].index), this.setInputSequence(xe, Ie.ins[xe].sequence);
        for (let xe = 0; xe < Ie.outs.length; xe++)
          this.setOutputAmount(xe, Ie.outs[xe].value), this.setOutputScript(xe, Ie.outs[xe].script);
        this.globalMap.delete(F.UNSIGNED_TX.toString(16).padStart(2, "0"));
      }
      /**
       * Imports a BitcoinJS (bitcoinjs-lib) Psbt object.
       * https://github.com/bitcoinjs/bitcoinjs-lib/blob/master/ts_src/psbt.ts
       *
       * Prepares the fields required for signing a Psbt on a Ledger
       * device. It should be used exclusively before calling
       * `appClient.signPsbt()` and not as a general Psbt conversion method.
       *
       * Note: This method supports all the policies that the Ledger is able to
       * sign, with the exception of taproot: tr(@0).
       */
      fromBitcoinJS(Fe) {
        function Sr(er) {
          let Ie;
          try {
            a.payments.p2tr({ output: er.witnessUtxo.script }), Ie = !0;
          } catch {
            Ie = !1;
          }
          return er && !!(er.tapInternalKey || er.tapMerkleRoot || er.tapLeafScript && er.tapLeafScript.length || er.tapBip32Derivation && er.tapBip32Derivation.length || Ie);
        }
        return this.setGlobalPsbtVersion(2), this.setGlobalTxVersion(Fe.version), this.setGlobalInputCount(Fe.data.inputs.length), this.setGlobalOutputCount(Fe.txOutputs.length), Fe.locktime !== void 0 && this.setGlobalFallbackLocktime(Fe.locktime), Fe.data.inputs.forEach((er, Ie) => {
          if (Sr(er))
            throw new Error("Taproot inputs not supported");
          this.setInputPreviousTxId(Ie, Fe.txInputs[Ie].hash), Fe.txInputs[Ie].sequence !== void 0 && this.setInputSequence(Ie, Fe.txInputs[Ie].sequence), this.setInputOutputIndex(Ie, Fe.txInputs[Ie].index), er.sighashType !== void 0 && this.setInputSighashType(Ie, er.sighashType), er.nonWitnessUtxo && this.setInputNonWitnessUtxo(Ie, er.nonWitnessUtxo), er.witnessUtxo && this.setInputWitnessUtxo(Ie, er.witnessUtxo.value, er.witnessUtxo.script), er.witnessScript && this.setInputWitnessScript(Ie, er.witnessScript), er.redeemScript && this.setInputRedeemScript(Ie, er.redeemScript), Fe.data.inputs[Ie].bip32Derivation.forEach((xe) => {
            if (!/^m\//i.test(xe.path))
              throw new Error("Invalid input bip32 derivation");
            const rr = xe.path.replace(/m\//i, "").split("/").map((ar) => ar.match(/['h]/i) ? parseInt(ar) + 2147483648 : Number(ar));
            this.setInputBip32Derivation(Ie, xe.pubkey, xe.masterFingerprint, rr);
          });
        }), Fe.txOutputs.forEach((er, Ie) => {
          this.setOutputAmount(Ie, er.value), this.setOutputScript(Ie, er.script);
        }), this;
      }
      readKeyPair(Fe, Sr) {
        const er = (0, b.sanitizeBigintToNumber)(Sr.readVarInt());
        if (er == 0)
          return !1;
        const Ie = Sr.readUInt8(), xe = Sr.readSlice(er - 1), rr = Sr.readVarSlice();
        return lr(Fe, Ie, xe, rr), !0;
      }
      getKeyDatas(Fe, Sr) {
        const er = [];
        return Fe.forEach((Ie, xe) => {
          this.isKeyType(xe, [Sr]) && er.push(Buffer$f.from(xe.substring(2), "hex"));
        }), er;
      }
      isKeyType(Fe, Sr) {
        const er = Buffer$f.from(Fe.substring(0, 2), "hex").readUInt8(0);
        return Sr.some((Ie) => Ie == er);
      }
      setGlobal(Fe, Sr) {
        const er = new He(Fe, Buffer$f.from([]));
        this.globalMap.set(er.toString(), Sr);
      }
      getGlobal(Fe) {
        return be(this.globalMap, Fe, or(), !1);
      }
      getGlobalOptional(Fe) {
        return be(this.globalMap, Fe, or(), !0);
      }
      setInput(Fe, Sr, er, Ie) {
        lr(this.getMap(Fe, this.inputMaps), Sr, er, Ie);
      }
      getInput(Fe, Sr, er) {
        return be(this.inputMaps[Fe], Sr, er, !1);
      }
      getInputOptional(Fe, Sr, er) {
        return be(this.inputMaps[Fe], Sr, er, !0);
      }
      setOutput(Fe, Sr, er, Ie) {
        lr(this.getMap(Fe, this.outputMaps), Sr, er, Ie);
      }
      getOutput(Fe, Sr, er) {
        return be(this.outputMaps[Fe], Sr, er, !1);
      }
      getMap(Fe, Sr) {
        return Sr[Fe] ? Sr[Fe] : Sr[Fe] = /* @__PURE__ */ new Map();
      }
      encodeBip32Derivation(Fe, Sr) {
        const er = new A.BufferWriter();
        return this.writeBip32Derivation(er, Fe, Sr), er.buffer();
      }
      decodeBip32Derivation(Fe) {
        const Sr = new A.BufferReader(Fe);
        return this.readBip32Derivation(Sr);
      }
      writeBip32Derivation(Fe, Sr, er) {
        Fe.writeSlice(Sr), er.forEach((Ie) => {
          Fe.writeUInt32(Ie);
        });
      }
      readBip32Derivation(Fe) {
        const Sr = Fe.readSlice(4), er = [];
        for (; Fe.offset < Fe.buffer.length; )
          er.push(Fe.readUInt32());
        return { masterFingerprint: Sr, path: er };
      }
      encodeTapBip32Derivation(Fe, Sr, er) {
        const Ie = new A.BufferWriter();
        return Ie.writeVarInt(Fe.length), Fe.forEach((xe) => {
          Ie.writeSlice(xe);
        }), this.writeBip32Derivation(Ie, Sr, er), Ie.buffer();
      }
      decodeTapBip32Derivation(Fe) {
        const Sr = new A.BufferReader(Fe), er = (0, b.sanitizeBigintToNumber)(Sr.readVarInt()), Ie = [];
        for (let rr = 0; rr < er; rr++)
          Ie.push(Sr.readSlice(32));
        const xe = this.readBip32Derivation(Sr);
        return Object.assign({ hashes: Ie }, xe);
      }
    }
    n.PsbtV2 = Ee;
    function be(tr, Fe, Sr, er) {
      if (!tr)
        throw Error("No such map");
      const Ie = new He(Fe, Sr), xe = tr.get(Ie.toString());
      if (!xe) {
        if (er)
          return;
        throw new $(Ie.toString());
      }
      return Buffer$f.from(xe);
    }
    class He {
      constructor(Fe, Sr) {
        this.keyType = Fe, this.keyData = Sr;
      }
      toString() {
        const Fe = new A.BufferWriter();
        return this.toBuffer(Fe), Fe.buffer().toString("hex");
      }
      serialize(Fe) {
        Fe.writeVarInt(1 + this.keyData.length), this.toBuffer(Fe);
      }
      toBuffer(Fe) {
        Fe.writeUInt8(this.keyType), Fe.writeSlice(this.keyData);
      }
    }
    class Pe {
      constructor(Fe, Sr) {
        this.key = Fe, this.value = Sr;
      }
      serialize(Fe) {
        this.key.serialize(Fe), Fe.writeVarSlice(this.value);
      }
    }
    function nr(tr) {
      return new He(tr.readUInt8(0), tr.slice(1));
    }
    function ir(tr, Fe) {
      for (let [Sr, er] of [...Fe].sort(([Ie], [xe]) => Ie.localeCompare(xe)))
        new Pe(nr(Buffer$f.from(Sr, "hex")), er).serialize(tr);
      tr.writeUInt8(0);
    }
    function or() {
      return Buffer$f.from([]);
    }
    function lr(tr, Fe, Sr, er) {
      const Ie = new He(Fe, Sr);
      tr.set(Ie.toString(), er);
    }
    function Ir(tr) {
      const Fe = Buffer$f.alloc(4);
      return Fe.writeUInt32LE(tr, 0), Fe;
    }
    function xr(tr) {
      return (0, A.unsafeTo64bitLE)(tr);
    }
    function kr(tr) {
      const Fe = new A.BufferWriter();
      return Fe.writeVarInt(tr), Fe.buffer();
    }
    function Ce(tr) {
      return (0, b.sanitizeBigintToNumber)(new A.BufferReader(tr).readVarInt());
    }
  }(psbtv2$1)), psbtv2$1;
}
var hasRequiredMerkelizedPsbt;
function requireMerkelizedPsbt() {
  if (hasRequiredMerkelizedPsbt) return merkelizedPsbt$1;
  hasRequiredMerkelizedPsbt = 1, Object.defineProperty(merkelizedPsbt$1, "__esModule", { value: !0 }), merkelizedPsbt$1.MerkelizedPsbt = void 0;
  const n = requireMerkleMap(), c = requirePsbtv2();
  class u extends c.PsbtV2 {
    constructor(a) {
      super(), this.inputMerkleMaps = [], this.outputMerkleMaps = [], a.copy(this), this.globalMerkleMap = u.createMerkleMap(this.globalMap);
      for (let A = 0; A < this.getGlobalInputCount(); A++)
        this.inputMerkleMaps.push(u.createMerkleMap(this.inputMaps[A]));
      this.inputMapCommitments = [...this.inputMerkleMaps.values()].map((A) => A.commitment());
      for (let A = 0; A < this.getGlobalOutputCount(); A++)
        this.outputMerkleMaps.push(u.createMerkleMap(this.outputMaps[A]));
      this.outputMapCommitments = [...this.outputMerkleMaps.values()].map((A) => A.commitment());
    }
    // These public functions are for MerkelizedPsbt.
    getGlobalSize() {
      return this.globalMap.size;
    }
    getGlobalKeysValuesRoot() {
      return this.globalMerkleMap.commitment();
    }
    static createMerkleMap(a) {
      const A = [...a.keys()].sort(), b = A.map((le) => {
        const L = a.get(le);
        if (!L)
          throw new Error("No value for key " + le);
        return L;
      }), F = A.map((le) => Buffer$f.from(le, "hex"));
      return new n.MerkleMap(F, b);
    }
  }
  return merkelizedPsbt$1.MerkelizedPsbt = u, merkelizedPsbt$1;
}
var hasRequiredAppClient;
function requireAppClient() {
  if (hasRequiredAppClient) return appClient;
  hasRequiredAppClient = 1, Object.defineProperty(appClient, "__esModule", { value: !0 }), appClient.AppClient = appClient.PartialSignature = void 0;
  const n = requireBip32(), c = requireClientCommands(), u = requireMerkelizedPsbt(), p = requireMerkle(), a = requirePsbtv2(), A = requireVarint(), b = 225, F = 248, le = 1;
  var L;
  (function(Pe) {
    Pe[Pe.GET_PUBKEY = 0] = "GET_PUBKEY", Pe[Pe.REGISTER_WALLET = 2] = "REGISTER_WALLET", Pe[Pe.GET_WALLET_ADDRESS = 3] = "GET_WALLET_ADDRESS", Pe[Pe.SIGN_PSBT = 4] = "SIGN_PSBT", Pe[Pe.GET_MASTER_FINGERPRINT = 5] = "GET_MASTER_FINGERPRINT", Pe[Pe.SIGN_MESSAGE = 16] = "SIGN_MESSAGE";
  })(L || (L = {}));
  var pe;
  (function(Pe) {
    Pe[Pe.CONTINUE_INTERRUPTED = 1] = "CONTINUE_INTERRUPTED";
  })(pe || (pe = {}));
  class $ {
    constructor(nr, ir, or) {
      this.pubkey = nr, this.signature = ir, this.tapleafHash = or;
    }
  }
  appClient.PartialSignature = $;
  function Ee(Pe, nr) {
    if (Pe.length == 64)
      return new $(Pe.slice(0, 32), nr, Pe.slice(32, 64));
    if (Pe.length == 32 || Pe.length == 33)
      return new $(Pe, nr);
    throw new Error(`Invalid length for pubkeyAugm: ${Pe.length} bytes.`);
  }
  function be(Pe) {
    return (Pe.match(/[asctdvjnlu]+:/g) || []).some((ir) => ir.includes("a"));
  }
  class He {
    constructor(nr) {
      this.transport = nr;
    }
    async makeRequest(nr, ir, or) {
      let lr = await this.transport.send(b, nr, 0, le, ir, [36864, 57344]);
      for (; lr.readUInt16BE(lr.length - 2) === 57344; ) {
        if (!or)
          throw new Error("Unexpected SW_INTERRUPTED_EXECUTION");
        const Ir = lr.slice(0, -2), xr = or.execute(Ir);
        lr = await this.transport.send(F, pe.CONTINUE_INTERRUPTED, 0, 0, xr, [36864, 57344]);
      }
      return lr.slice(0, -2);
    }
    /**
     * Returns an object containing the currently running app's name, version and the device status flags.
     *
     * @returns an object with app name, version and device status flags.
     */
    async getAppAndVersion() {
      const nr = await this.transport.send(176, 1, 0, 0);
      let ir = 0;
      if (nr[ir++] !== 1)
        throw new Error("Unexpected response");
      const lr = nr[ir++], Ir = nr.slice(ir, ir += lr).toString("ascii"), xr = nr[ir++], kr = nr.slice(ir, ir += xr).toString("ascii"), Ce = nr[ir++], tr = nr.slice(ir, ir += Ce);
      return {
        name: Ir,
        version: kr,
        flags: tr
      };
    }
    /**
     * Requests the BIP-32 extended pubkey to the hardware wallet.
     * If `display` is `false`, only standard paths will be accepted; an error is returned if an unusual path is
     * requested.
     * If `display` is `true`, the requested path is shown on screen for user verification; unusual paths can be
     * requested, and a warning is shown to the user in that case.
     *
     * @param path the requested BIP-32 path as a string
     * @param display `false` to silently retrieve a pubkey for a standard path, `true` to display the path on screen
     * @returns the base58-encoded serialized extended pubkey (xpub)
     */
    async getExtendedPubkey(nr, ir = !1) {
      const or = (0, n.pathStringToArray)(nr);
      if (or.length > 6)
        throw new Error("Path too long. At most 6 levels allowed.");
      return (await this.makeRequest(L.GET_PUBKEY, Buffer$f.concat([
        Buffer$f.from(ir ? [1] : [0]),
        (0, n.pathElementsToBuffer)(or)
      ]))).toString("ascii");
    }
    /**
     * Registers a `WalletPolicy`, after interactive verification from the user.
     * On success, after user's approval, this function returns the id (which is the same that can be computed with
     * `walletPolicy.getid()`), followed by the 32-byte hmac. The client should store the hmac to use it for future
     * requests to `getWalletAddress` or `signPsbt` using this `WalletPolicy`.
     *
     * @param walletPolicy the `WalletPolicy` to register
     * @returns a pair of two 32-byte arrays: the id of the Wallet Policy, followed by the policy hmac
     */
    async registerWallet(nr) {
      await this.validatePolicy(nr);
      const ir = new c.ClientCommandInterpreter();
      ir.addKnownWalletPolicy(nr);
      const or = nr.serialize(), lr = await this.makeRequest(L.REGISTER_WALLET, Buffer$f.concat([
        (0, A.createVarint)(or.length),
        or
      ]), ir);
      if (lr.length != 64)
        throw Error(`Invalid response length. Expected 64 bytes, got ${lr.length}`);
      return [lr.subarray(0, 32), lr.subarray(32)];
    }
    /**
     * Returns the address of `walletPolicy` for the given `change` and `addressIndex`.
     *
     * @param walletPolicy the `WalletPolicy` to use
     * @param walletHMAC the 32-byte hmac returned during wallet registration for a registered policy; otherwise
     * `null` for a standard policy
     * @param change `0` for a normal receive address, `1` for a change address
     * @param addressIndex the address index to retrieve
     * @param display `True` to show the address on screen, `False` to retrieve it silently
     * @returns the address, as an ascii string.
     */
    async getWalletAddress(nr, ir, or, lr, Ir) {
      if (or !== 0 && or !== 1)
        throw new Error("Change can only be 0 or 1");
      if (lr < 0 || !Number.isInteger(lr))
        throw new Error("Invalid address index");
      if (ir != null && ir.length != 32)
        throw new Error("Invalid HMAC length");
      await this.validatePolicy(nr);
      const xr = new c.ClientCommandInterpreter();
      xr.addKnownWalletPolicy(nr);
      const kr = Buffer$f.alloc(4);
      return kr.writeUInt32BE(lr, 0), (await this.makeRequest(L.GET_WALLET_ADDRESS, Buffer$f.concat([
        Buffer$f.from(Ir ? [1] : [0]),
        nr.getId(),
        ir || Buffer$f.alloc(32, 0),
        Buffer$f.from([or]),
        kr
      ]), xr)).toString("ascii");
    }
    /**
     * Signs a psbt using a (standard or registered) `WalletPolicy`. This is an interactive command, as user validation
     * is necessary using the device's secure screen.
     * On success, a map of input indexes and signatures is returned.
     * @param psbt a base64-encoded string, or a psbt in a binary Buffer. Using the `PsbtV2` type is deprecated.
     * @param walletPolicy the `WalletPolicy` to use for signing
     * @param walletHMAC the 32-byte hmac obtained during wallet policy registration, or `null` for a standard policy
     * @param progressCallback optionally, a callback that will be called every time a signature is produced during
     * the signing process. The callback does not receive any argument, but can be used to track progress.
     * @returns an array of of tuples with 2 elements containing:
     *    - the index of the input being signed;
     *    - an instance of PartialSignature
     */
    async signPsbt(nr, ir, or, lr) {
      if (await this.validatePolicy(ir), typeof nr == "string" && (nr = Buffer$f.from(nr, "base64")), Buffer$f.isBuffer(nr)) {
        const Sr = new a.PsbtV2();
        Sr.deserialize(nr), nr = Sr;
      }
      const Ir = new u.MerkelizedPsbt(nr);
      if (or != null && or.length != 32)
        throw new Error("Invalid HMAC length");
      const xr = new c.ClientCommandInterpreter(lr);
      xr.addKnownWalletPolicy(ir), xr.addKnownMapping(Ir.globalMerkleMap);
      for (const Sr of Ir.inputMerkleMaps)
        xr.addKnownMapping(Sr);
      for (const Sr of Ir.outputMerkleMaps)
        xr.addKnownMapping(Sr);
      xr.addKnownList(Ir.inputMapCommitments);
      const kr = new p.Merkle(Ir.inputMapCommitments.map((Sr) => (0, p.hashLeaf)(Sr))).getRoot();
      xr.addKnownList(Ir.outputMapCommitments);
      const Ce = new p.Merkle(Ir.outputMapCommitments.map((Sr) => (0, p.hashLeaf)(Sr))).getRoot();
      await this.makeRequest(L.SIGN_PSBT, Buffer$f.concat([
        Ir.getGlobalKeysValuesRoot(),
        (0, A.createVarint)(Ir.getGlobalInputCount()),
        kr,
        (0, A.createVarint)(Ir.getGlobalOutputCount()),
        Ce,
        ir.getId(),
        or || Buffer$f.alloc(32, 0)
      ]), xr);
      const tr = xr.getYielded(), Fe = [];
      for (const Sr of tr) {
        const [er, Ie] = (0, A.parseVarint)(Sr, 0), xe = Sr[Ie], rr = Sr.subarray(Ie + 1, Ie + 1 + xe), ar = Sr.subarray(Ie + 1 + xe), yr = Ee(rr, ar);
        Fe.push([Number(er), yr]);
      }
      return Fe;
    }
    /**
     * Returns the fingerprint of the master public key, as per BIP-32 standard.
     * @returns the master key fingerprint as a string of 8 hexadecimal digits.
     */
    async getMasterFingerprint() {
      return (await this.makeRequest(L.GET_MASTER_FINGERPRINT, Buffer$f.from([]))).toString("hex");
    }
    /**
     * Signs a message using the legacy Bitcoin Message Signing standard. The signed message is
     * the double-sha256 hash of the concatenation of:
     * - "\x18Bitcoin Signed Message:\n";
     * - the length of `message`, encoded as a Bitcoin-style variable length integer;
     * - `message`.
     *
     * @param message the serialized message to sign
     * @param path the BIP-32 path of the key used to sign the message
     * @returns base64-encoded signature of the message.
     */
    async signMessage(nr, ir) {
      const or = (0, n.pathStringToArray)(ir), lr = new c.ClientCommandInterpreter(), Ir = Math.ceil(nr.length / 64), xr = [];
      for (let tr = 0; tr < Ir; tr++)
        xr.push(nr.subarray(64 * tr, 64 * tr + 64));
      lr.addKnownList(xr);
      const kr = new p.Merkle(xr.map((tr) => (0, p.hashLeaf)(tr))).getRoot();
      return (await this.makeRequest(L.SIGN_MESSAGE, Buffer$f.concat([
        (0, n.pathElementsToBuffer)(or),
        (0, A.createVarint)(nr.length),
        kr
      ]), lr)).toString("base64");
    }
    /* Performs any additional checks on the policy before using it.*/
    async validatePolicy(nr) {
      if (be(nr.descriptorTemplate)) {
        const ir = await this.getAppAndVersion();
        if (["2.1.0", "2.1.1"].includes(ir.version))
          throw new Error("Please update your Ledger Bitcoin app.");
      }
    }
  }
  return appClient.AppClient = He, appClient.default = He, appClient;
}
var policy$1 = {}, hasRequiredPolicy;
function requirePolicy() {
  if (hasRequiredPolicy) return policy$1;
  hasRequiredPolicy = 1, Object.defineProperty(policy$1, "__esModule", { value: !0 }), policy$1.DefaultWalletPolicy = policy$1.WalletPolicy = void 0;
  const n = src$j, c = requireBuffertools(), u = requireMerkle(), p = 2;
  class a {
    /**
     * Creates and instance of a wallet policy.
     * @param name an ascii string, up to 16 bytes long; it must be an empty string for default wallet policies
     * @param descriptorTemplate the wallet policy template
     * @param keys and array of the keys, with the key derivation information
     */
    constructor(F, le, L) {
      this.name = F, this.descriptorTemplate = le, this.keys = L;
    }
    /**
     * Returns the unique 32-bytes id of this wallet policy.
     */
    getId() {
      return n.crypto.sha256(this.serialize());
    }
    /**
     * Serializes the wallet policy for transmission via the hardware wallet protocol.
     * @returns the serialized wallet policy
     */
    serialize() {
      const F = this.keys.map((pe) => Buffer$f.from(pe, "ascii")), le = new u.Merkle(F.map((pe) => (0, u.hashLeaf)(pe))), L = new c.BufferWriter();
      return L.writeUInt8(p), L.writeVarSlice(Buffer$f.from(this.name, "ascii")), L.writeVarInt(this.descriptorTemplate.length), L.writeSlice(n.crypto.sha256(Buffer$f.from(this.descriptorTemplate))), L.writeVarInt(this.keys.length), L.writeSlice(le.getRoot()), L.buffer();
    }
  }
  policy$1.WalletPolicy = a;
  class A extends a {
    constructor(F, le) {
      super("", F, [le]);
    }
  }
  return policy$1.DefaultWalletPolicy = A, policy$1;
}
var hasRequiredMain$1;
function requireMain$1() {
  return hasRequiredMain$1 || (hasRequiredMain$1 = 1, function(n) {
    var c = commonjsGlobal && commonjsGlobal.__importDefault || function(A) {
      return A && A.__esModule ? A : { default: A };
    };
    Object.defineProperty(n, "__esModule", { value: !0 }), n.WalletPolicy = n.DefaultWalletPolicy = n.PsbtV2 = n.AppClient = void 0;
    const u = c(requireAppClient());
    n.AppClient = u.default;
    const p = requirePolicy();
    Object.defineProperty(n, "DefaultWalletPolicy", { enumerable: !0, get: function() {
      return p.DefaultWalletPolicy;
    } }), Object.defineProperty(n, "WalletPolicy", { enumerable: !0, get: function() {
      return p.WalletPolicy;
    } });
    const a = requirePsbtv2();
    Object.defineProperty(n, "PsbtV2", { enumerable: !0, get: function() {
      return a.PsbtV2;
    } }), n.default = u.default;
  }(main$1)), main$1;
}
Object.defineProperty(ledger, "__esModule", { value: !0 });
ledger.ledgerPolicyFromState = ledger.comparePolicies = ledger.ledgerPolicyFromStandard = ledger.registerLedgerWallet = ledger.descriptorToLedgerFormat = ledger.getLedgerXpub = ledger.getLedgerMasterFingerPrint = ledger.assertLedgerApp = ledger.importAndValidateLedgerBitcoin = void 0;
const bitcoinjs_lib_1$9 = src$j, re_1 = re;
async function importAndValidateLedgerBitcoin(n) {
  let c;
  try {
    c = requireMain$1();
  } catch {
    throw new Error('Could not import "ledger-bitcoin". This is a peer dependency and needs to be installed explicitly. Please run "npm install ledger-bitcoin" to use Ledger Hardware Wallet functionality.');
  }
  const { AppClient: u } = c;
  if (n !== void 0 && !(n instanceof u))
    throw new Error("Error: invalid AppClient instance");
  return c;
}
ledger.importAndValidateLedgerBitcoin = importAndValidateLedgerBitcoin;
async function ledgerAppInfo(n) {
  const c = await n.send(176, 1, 0, 0);
  let u = 0;
  const p = c[u++], a = c[u++], A = c.slice(u, u += a).toString("ascii"), b = c[u++], F = c.slice(u, u += b).toString("ascii"), le = c[u++], L = c.slice(u, u += le);
  return { name: A, version: F, flags: L, format: p };
}
async function assertLedgerApp({ transport: n, name: c, minVersion: u }) {
  const { name: p, version: a } = await ledgerAppInfo(n);
  if (p !== c)
    throw new Error(`Open the ${c} app and try again`);
  {
    const [A, b, F] = u.split(".").map(Number), [le, L, pe] = a.split(".").map(Number);
    if (A === void 0 || b === void 0 || F === void 0)
      throw new Error("Pass a minVersion using semver notation: major.minor.patch");
    if (le < A || le === A && L < b || le === A && L === b && pe < F)
      throw new Error(`Error: please upgrade ${c} to version ${u}`);
  }
}
ledger.assertLedgerApp = assertLedgerApp;
function isLedgerStandard({ ledgerTemplate: n, keyRoots: c, network: u = bitcoinjs_lib_1$9.networks.bitcoin }) {
  var a, A;
  if (c.length !== 1)
    return !1;
  const p = (A = (a = c[0]) == null ? void 0 : a.match(re_1.reOriginPath)) == null ? void 0 : A[1];
  return !p || p[5] !== (u === bitcoinjs_lib_1$9.networks.bitcoin ? "0" : "1") ? !1 : !!(n === "pkh(@0/**)" && p.match(/^\/44'\/[01]'\/(\d+)'$/) || n === "wpkh(@0/**)" && p.match(/^\/84'\/[01]'\/(\d+)'$/) || n === "sh(wpkh(@0/**))" && p.match(/^\/49'\/[01]'\/(\d+)'$/) || n === "tr(@0/**)" && p.match(/^\/86'\/[01]'\/(\d+)'$/));
}
async function getLedgerMasterFingerPrint({ ledgerClient: n, ledgerState: c }) {
  const { AppClient: u } = await importAndValidateLedgerBitcoin(n);
  if (!(n instanceof u))
    throw new Error("Error: pass a valid ledgerClient");
  let p = c.masterFingerprint;
  return p || (p = Buffer$f.from(await n.getMasterFingerprint(), "hex"), c.masterFingerprint = p), p;
}
ledger.getLedgerMasterFingerPrint = getLedgerMasterFingerPrint;
async function getLedgerXpub({ originPath: n, ledgerClient: c, ledgerState: u }) {
  const { AppClient: p } = await importAndValidateLedgerBitcoin(c);
  if (!(c instanceof p))
    throw new Error("Error: pass a valid ledgerClient");
  u.xpubs || (u.xpubs = {});
  let a = u.xpubs[n];
  if (!a) {
    try {
      a = await c.getExtendedPubkey(`m${n}`, !1);
    } catch {
      a = await c.getExtendedPubkey(`m${n}`, !0);
    }
    if (typeof a != "string")
      throw new Error("Error: ledgerClient did not return a valid xpub");
    u.xpubs[n] = a;
  }
  return a;
}
ledger.getLedgerXpub = getLedgerXpub;
async function descriptorToLedgerFormat({ descriptor: n, ledgerClient: c, ledgerState: u }) {
  const p = n.expand().expandedExpression, a = n.expand().expansionMap;
  if (!p || !a)
    throw new Error("Error: invalid descriptor");
  const A = await getLedgerMasterFingerPrint({
    ledgerClient: c,
    ledgerState: u
  }), b = Object.keys(a).sort(), F = b.filter((Pe) => {
    var ir;
    const nr = (ir = a[Pe]) == null ? void 0 : ir.masterFingerprint;
    return nr && Buffer$f.compare(nr, A) === 0;
  });
  if (F.length === 0)
    return null;
  if (F.length > 1)
    throw new Error(`Error: descriptor ${p} does not contain exactly 1 ledger key`);
  const le = F[0], L = a[le].masterFingerprint, pe = a[le].originPath, $ = a[le].keyPath, Ee = a[le].bip32;
  if (!L || !pe || !$ || !Ee)
    throw new Error(`Error: Ledger key expression must have a valid masterFingerprint: ${L}, originPath: ${pe}, keyPath: ${$} and a valid bip32 node`);
  if (!/^\/[01]\/\d+$/.test($))
    throw new Error("Error: key paths must be /<1;0>/index, where change is 1 or 0 and index >= 0");
  const be = [];
  let He = p;
  return b.forEach((Pe) => {
    var ir, or, lr;
    if (Pe !== le) {
      const Ir = a[Pe];
      if (!Ir.bip32)
        throw new Error("Error: ledger only allows xpub-type key expressions");
      if (Ir.originPath && Ir.originPath !== pe)
        throw new Error(`Error: all originPaths must be the same for Ledger being able to sign. On the other hand, you can leave the origin info empty for external keys: ${Ir.originPath} !== ${pe}`);
      if (Ir.keyPath !== $)
        throw new Error(`Error: all keyPaths must be the same for Ledger being able to sign: ${Ir.keyPath} !== ${$}`);
    }
    He = He.replaceAll(Pe, `@${be.length}/**`);
    const nr = a[Pe];
    nr.masterFingerprint && nr.originPath ? be.push(`[${(ir = nr.masterFingerprint) == null ? void 0 : ir.toString("hex")}${nr.originPath}]${(or = nr == null ? void 0 : nr.bip32) == null ? void 0 : or.neutered().toBase58()}`) : be.push(`${(lr = nr == null ? void 0 : nr.bip32) == null ? void 0 : lr.neutered().toBase58()}`);
  }), { ledgerTemplate: He, keyRoots: be };
}
ledger.descriptorToLedgerFormat = descriptorToLedgerFormat;
async function registerLedgerWallet({ descriptor: n, ledgerClient: c, ledgerState: u, policyName: p }) {
  const { WalletPolicy: a, AppClient: A } = await importAndValidateLedgerBitcoin(c);
  if (!(c instanceof A))
    throw new Error("Error: pass a valid ledgerClient");
  const b = await descriptorToLedgerFormat({
    descriptor: n,
    ledgerClient: c,
    ledgerState: u
  });
  if (await ledgerPolicyFromStandard({ descriptor: n, ledgerClient: c, ledgerState: u }))
    return;
  if (!b)
    throw new Error("Error: descriptor does not have a ledger input");
  const { ledgerTemplate: F, keyRoots: le } = b;
  u.policies || (u.policies = []);
  let L, pe;
  const $ = await ledgerPolicyFromState({
    descriptor: n,
    ledgerClient: c,
    ledgerState: u
  });
  if ($) {
    if ($.policyName !== p)
      throw new Error(`Error: policy was already registered with a different name: ${$.policyName}`);
  } else {
    L = new a(p, F, le);
    let Ee;
    [Ee, pe] = await c.registerWallet(L);
    const be = {
      policyName: p,
      ledgerTemplate: F,
      keyRoots: le,
      policyId: Ee,
      policyHmac: pe
    };
    u.policies.push(be);
  }
}
ledger.registerLedgerWallet = registerLedgerWallet;
async function ledgerPolicyFromStandard({ descriptor: n, ledgerClient: c, ledgerState: u }) {
  const p = await descriptorToLedgerFormat({
    descriptor: n,
    ledgerClient: c,
    ledgerState: u
  });
  if (!p)
    throw new Error("Error: descriptor does not have a ledger input");
  const { ledgerTemplate: a, keyRoots: A } = p;
  return isLedgerStandard({
    ledgerTemplate: a,
    keyRoots: A,
    network: n.getNetwork()
  }) ? { ledgerTemplate: a, keyRoots: A } : null;
}
ledger.ledgerPolicyFromStandard = ledgerPolicyFromStandard;
function compareKeyRoots(n, c) {
  if (n.length !== c.length)
    return !1;
  for (let u = 0; u < n.length; u++)
    if (n[u] !== c[u])
      return !1;
  return !0;
}
function comparePolicies(n, c) {
  return compareKeyRoots(n.keyRoots, c.keyRoots) && n.ledgerTemplate === c.ledgerTemplate;
}
ledger.comparePolicies = comparePolicies;
async function ledgerPolicyFromState({ descriptor: n, ledgerClient: c, ledgerState: u }) {
  const p = await descriptorToLedgerFormat({
    descriptor: n,
    ledgerClient: c,
    ledgerState: u
  });
  if (!p)
    throw new Error("Error: descriptor does not have a ledger input");
  const { ledgerTemplate: a, keyRoots: A } = p;
  u.policies || (u.policies = []);
  const b = u.policies.filter((F) => comparePolicies(F, { ledgerTemplate: a, keyRoots: A }));
  if (b.length > 1)
    throw new Error("Error: duplicated policy");
  return b.length === 1 ? b[0] : null;
}
ledger.ledgerPolicyFromState = ledgerPolicyFromState;
var __createBinding$7 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(n, c, u, p) {
  p === void 0 && (p = u);
  var a = Object.getOwnPropertyDescriptor(c, u);
  (!a || ("get" in a ? !c.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
    return c[u];
  } }), Object.defineProperty(n, p, a);
} : function(n, c, u, p) {
  p === void 0 && (p = u), n[p] = c[u];
}), __setModuleDefault$7 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(n, c) {
  Object.defineProperty(n, "default", { enumerable: !0, value: c });
} : function(n, c) {
  n.default = c;
}), __importStar$7 = commonjsGlobal && commonjsGlobal.__importStar || function(n) {
  if (n && n.__esModule) return n;
  var c = {};
  if (n != null) for (var u in n) u !== "default" && Object.prototype.hasOwnProperty.call(n, u) && __createBinding$7(c, n, u);
  return __setModuleDefault$7(c, n), c;
};
Object.defineProperty(keyExpressions, "__esModule", { value: !0 });
keyExpressions.keyExpressionBIP32 = keyExpressions.keyExpressionLedger = keyExpressions.parseKeyExpression = void 0;
const bitcoinjs_lib_1$8 = src$j, ledger_1$1 = ledger, RE$2 = __importStar$7(re), derivePath = (n, c) => {
  if (typeof c != "string")
    throw new Error(`Error: invalid derivation path ${c}`);
  const u = c.replaceAll("H", "'").replaceAll("h", "'").slice(1), p = u.split("/");
  for (const a of p) {
    const A = a.endsWith("'") ? a.slice(0, -1) : a;
    if (!Number.isInteger(Number(A)) || Number(A) >= 2147483648)
      throw new Error("Error: BIP 32 path element overflow");
  }
  return n.derivePath(u);
};
function parseKeyExpression({ keyExpression: n, isSegwit: c, ECPair: u, BIP32: p, network: a = bitcoinjs_lib_1$8.networks.bitcoin }) {
  var xr, kr, Ce, tr;
  let A, b, F, le, L, pe, $;
  const Ee = n.indexOf("*") !== -1, be = n.match(RE$2.reKeyExp);
  if (be === null || be[0] !== n)
    throw new Error(`Error: expected a keyExpression but got ${n}`);
  const He = RegExp(String.raw`^(${RE$2.reOrigin})?`), Pe = n.match(He);
  if (Pe) {
    const Fe = Pe[0].replace(/[[\]]/g, ""), Sr = String.raw`^(${RE$2.reMasterFingerprint})`, er = Fe.match(Sr), Ie = er ? er[0] : "";
    if (L = Fe.replace(Ie, ""), Ie.length > 0) {
      if (Ie.length !== 8)
        throw new Error(`Error: masterFingerprint ${Ie} invalid for keyExpression: ${n}`);
      le = Buffer$f.from(Ie, "hex");
    }
  }
  const nr = n.replace(He, "");
  let ir, or, lr, Ir;
  if ((ir = nr.match(RE$2.anchorStartAndEnd(RE$2.rePubKey))) !== null) {
    if (A = Buffer$f.from(ir[0], "hex"), b = u.fromPublicKey(A, { network: a }), !u.isPoint(A) || !(A.length === 33 || A.length === 65))
      throw new Error("Error: invalid pubkey");
    if (typeof c == "boolean" && c && A.length !== 33)
      throw new Error("Error: invalid pubkey");
  } else if ((or = nr.match(RE$2.anchorStartAndEnd(RE$2.reWIF))) !== null)
    b = u.fromWIF(or[0], a), A = b.publicKey;
  else if ((lr = nr.match(RE$2.anchorStartAndEnd(RE$2.reXpubKey))) !== null) {
    const Fe = lr[0], Sr = (xr = Fe.match(RE$2.reXpub)) == null ? void 0 : xr[0];
    if (!Sr)
      throw new Error("Error: xpub could not be matched");
    if (F = p.fromBase58(Sr, a), Fe.match(RE$2.rePath) !== null) {
      if (pe = (kr = Fe.match(RE$2.rePath)) == null ? void 0 : kr[0], !pe)
        throw new Error("Error: could not extract a path");
      Ee || (A = derivePath(F, pe).publicKey);
    } else
      A = F.publicKey;
  } else if ((Ir = nr.match(RE$2.anchorStartAndEnd(RE$2.reXprvKey))) !== null) {
    const Fe = Ir[0], Sr = (Ce = Fe.match(RE$2.reXprv)) == null ? void 0 : Ce[0];
    if (!Sr)
      throw new Error("Error: xprv could not be matched");
    if (F = p.fromBase58(Sr, a), Fe.match(RE$2.rePath) !== null) {
      if (pe = (tr = Fe.match(RE$2.rePath)) == null ? void 0 : tr[0], !pe)
        throw new Error("Error: could not extract a path");
      Ee || (A = derivePath(F, pe).publicKey);
    } else
      A = F.publicKey;
  } else
    throw new Error(`Error: could not get pubkey for keyExpression ${n}`);
  return (L || pe) && ($ = `m${L ?? ""}${pe ?? ""}`), {
    keyExpression: n,
    ...A !== void 0 ? { pubkey: A } : {},
    ...b !== void 0 ? { ecpair: b } : {},
    ...F !== void 0 ? { bip32: F } : {},
    ...le !== void 0 ? { masterFingerprint: le } : {},
    ...L !== void 0 && L !== "" ? { originPath: L } : {},
    ...pe !== void 0 && pe !== "" ? { keyPath: pe } : {},
    ...$ !== void 0 ? { path: $ } : {}
  };
}
keyExpressions.parseKeyExpression = parseKeyExpression;
function assertChangeIndexKeyPath({ change: n, index: c, keyPath: u }) {
  if (!(n === void 0 && c === void 0 || n !== void 0 && c !== void 0))
    throw new Error("Error: Pass change and index or neither");
  if (n !== void 0 == (u !== void 0))
    throw new Error("Error: Pass either change and index or a keyPath");
}
async function keyExpressionLedger({ ledgerClient: n, ledgerState: c, originPath: u, keyPath: p, change: a, index: A }) {
  assertChangeIndexKeyPath({ change: a, index: A, keyPath: p });
  const F = `[${(await (0, ledger_1$1.getLedgerMasterFingerPrint)({
    ledgerClient: n,
    ledgerState: c
  })).toString("hex")}${u}]`, le = await (0, ledger_1$1.getLedgerXpub)({ originPath: u, ledgerClient: n, ledgerState: c }), L = `${F}${le}`;
  return p !== void 0 ? `${L}${p}` : `${L}/${a}/${A}`;
}
keyExpressions.keyExpressionLedger = keyExpressionLedger;
function keyExpressionBIP32({ masterNode: n, originPath: c, keyPath: u, change: p, index: a, isPublic: A = !0 }) {
  assertChangeIndexKeyPath({ change: p, index: a, keyPath: u });
  const F = `[${n.fingerprint.toString("hex")}${c}]`, le = A ? n.derivePath(`m${c}`).neutered().toBase58().toString() : n.derivePath(`m${c}`).toBase58().toString(), L = `${F}${le}`;
  return u !== void 0 ? `${L}${u}` : `${L}/${p}/${a}`;
}
keyExpressions.keyExpressionBIP32 = keyExpressionBIP32;
var miniscript = {}, dist = {};
const SEQUENCE_FINAL = 4294967295, SEQUENCE_LOCKTIME_DISABLE_FLAG = 1 << 31, SEQUENCE_LOCKTIME_GRANULARITY = 9, SEQUENCE_LOCKTIME_MASK = 65535, SEQUENCE_LOCKTIME_TYPE_FLAG = 1 << 22, BLOCKS_MAX = SEQUENCE_LOCKTIME_MASK, SECONDS_MOD = 1 << SEQUENCE_LOCKTIME_GRANULARITY, SECONDS_MAX = SEQUENCE_LOCKTIME_MASK << SEQUENCE_LOCKTIME_GRANULARITY;
function decode$7(n) {
  return n & SEQUENCE_LOCKTIME_DISABLE_FLAG ? {} : n & SEQUENCE_LOCKTIME_TYPE_FLAG ? {
    seconds: (n & SEQUENCE_LOCKTIME_MASK) << SEQUENCE_LOCKTIME_GRANULARITY
  } : {
    blocks: n & SEQUENCE_LOCKTIME_MASK
  };
}
function encode$7({ blocks: n, seconds: c }) {
  if (n !== void 0 && c !== void 0) throw new TypeError("Cannot encode blocks AND seconds");
  if (n === void 0 && c === void 0) return SEQUENCE_FINAL;
  if (c !== void 0) {
    if (!Number.isFinite(c)) throw new TypeError("Expected Number seconds");
    if (c > SECONDS_MAX) throw new TypeError("Expected Number seconds <= " + SECONDS_MAX);
    if (c % SECONDS_MOD !== 0) throw new TypeError("Expected Number seconds as a multiple of " + SECONDS_MOD);
    return SEQUENCE_LOCKTIME_TYPE_FLAG | c >> SEQUENCE_LOCKTIME_GRANULARITY;
  }
  if (!Number.isFinite(n)) throw new TypeError("Expected Number blocks");
  if (n > SEQUENCE_LOCKTIME_MASK) throw new TypeError("Expected Number blocks <= " + BLOCKS_MAX);
  return n;
}
var bip68$1 = { decode: decode$7, encode: encode$7 }, bip68 = bip68$1;
const ABSOLUTE = "ABSOLUTE", RELATIVE = "RELATIVE";
function maxLock(n, c, u) {
  if (typeof n > "u" && typeof c > "u")
    return;
  if (typeof u > "u")
    throw new Error("lockType must be specified");
  if (u !== ABSOLUTE && u !== RELATIVE)
    throw new Error('lockType must be either "ABSOLUTE" or "RELATIVE"');
  function p(a) {
    return !!(!isNaN(a) && !isNaN(parseFloat(a)) && Number.isInteger(Number(a)));
  }
  if (typeof n < "u") {
    if (p(n) === !1)
      throw new Error("nSequence/nLockTime must be an integer: " + n);
    if (n = Number(n), u === RELATIVE && !bip68.decode(n).hasOwnProperty("seconds") && !bip68.decode(n).hasOwnProperty("blocks"))
      throw new Error("Invalid bip68 encoded a value: " + n);
  }
  if (typeof c < "u") {
    if (p(c) === !1)
      throw new Error("nSequence/nLockTime must be an integer: " + c);
    if (c = Number(c), u === RELATIVE && !bip68.decode(c).hasOwnProperty("seconds") && !bip68.decode(c).hasOwnProperty("blocks"))
      throw new Error("Invalid bip68 encoded b value: " + c);
  }
  if (typeof n < "u" && typeof c < "u") {
    if (u === ABSOLUTE) {
      if (n < 5e8 && c >= 5e8 || n >= 5e8 && c < 5e8)
        throw new Error(
          "nLockTime values must be either below 500000000 or both above or equal 500000000"
        );
    } else {
      const a = bip68.decode(n), A = bip68.decode(c);
      if (a.hasOwnProperty("seconds") !== A.hasOwnProperty("seconds"))
        throw new Error(
          "a and b must both be either represent seconds or block height"
        );
    }
    return Math.max(n, c);
  }
  if (typeof n < "u") return n;
  if (typeof c < "u") return c;
}
function combine(n, c) {
  const u = /d?sat\(([^\(]*)\)/, p = n.match(u);
  if (p && p.length) {
    const a = [], A = p[0], b = n.split(A)[0], F = n.slice(A.length + b.length), le = p[1], L = A[0] === "d" ? "dsats" : "sats";
    if (typeof c[le] != "object")
      throw new Error(
        `satisfactionsMap does not provide sats/dsats solutions for argument ${le}, evaluating: ${n}`
      );
    const pe = c[le][L] || [];
    for (const $ of pe)
      if (F.match(u)) {
        const Ee = combine(F, c);
        for (const be of Ee)
          a.push({
            nSequence: maxLock(
              $.nSequence,
              be.nSequence,
              RELATIVE
            ),
            nLockTime: maxLock(
              $.nLockTime,
              be.nLockTime,
              ABSOLUTE
            ),
            asm: `${b}${$.asm}${be.asm}`
          });
      } else
        a.push({
          ...$,
          asm: `${b}${$.asm}${F}`
        });
    return a;
  }
  throw new Error("Invalid solutionTemplate: " + n);
}
const satisfactionsMaker = {
  0: () => ({
    dsats: [{ asm: "" }]
  }),
  1: () => ({
    sats: [{ asm: "" }]
  }),
  pk_k: (n) => ({
    dsats: [{ asm: "0" }],
    sats: [{ asm: `<sig(${n})>` }]
  }),
  pk_h: (n) => ({
    dsats: [{ asm: `0 <${n}>` }],
    sats: [{ asm: `<sig(${n})> <${n}>` }]
  }),
  older: (n) => ({
    sats: [{ asm: "", nSequence: n }]
  }),
  after: (n) => ({
    sats: [{ asm: "", nLockTime: n }]
  }),
  sha256: (n) => ({
    sats: [{ asm: `<sha256_preimage(${n})>` }],
    dsats: [{ asm: "<random_preimage()>" }]
  }),
  ripemd160: (n) => ({
    sats: [{ asm: `<ripemd160_preimage(${n})>` }],
    dsats: [{ asm: "<random_preimage()>" }]
  }),
  hash256: (n) => ({
    sats: [{ asm: `<hash256_preimage(${n})>` }],
    dsats: [{ asm: "<random_preimage()>" }]
  }),
  hash160: (n) => ({
    sats: [{ asm: `<hash160_preimage(${n})>` }],
    dsats: [{ asm: "<random_preimage()>" }]
  }),
  andor: (n, c, u) => ({
    dsats: [
      ...combine("dsat(Z) dsat(X)", { X: n, Y: c, Z: u }),
      ...combine("dsat(Y) sat(X)", { X: n, Y: c, Z: u })
    ],
    sats: [
      ...combine("sat(Y) sat(X)", { X: n, Y: c, Z: u }),
      ...combine("sat(Z) dsat(X)", { X: n, Y: c, Z: u })
    ]
  }),
  and_v: (n, c) => ({
    dsats: [...combine("dsat(Y) sat(X)", { X: n, Y: c })],
    sats: [...combine("sat(Y) sat(X)", { X: n, Y: c })]
  }),
  and_b: (n, c) => ({
    dsats: [
      ...combine("dsat(Y) dsat(X)", { X: n, Y: c }),
      //https://bitcoin.sipa.be/miniscript/
      //The non-canonical options for and_b, or_b, and thresh are always
      //overcomplete (reason 3), so instead use DONTUSE there
      ...combine("sat(Y) dsat(X)", { X: n, Y: c }),
      ...combine("dsat(Y) sat(X)", { X: n, Y: c })
    ],
    sats: [...combine("sat(Y) sat(X)", { Y: c, X: n })]
  }),
  or_b: (n, c) => ({
    dsats: [...combine("dsat(Z) dsat(X)", { X: n, Z: c })],
    sats: [
      ...combine("dsat(Z) sat(X)", { X: n, Z: c }),
      ...combine("sat(Z) dsat(X)", { X: n, Z: c }),
      //https://bitcoin.sipa.be/miniscript/
      //The non-canonical options for and_b, or_b, and thresh are always
      //overcomplete (reason 3), so instead use DONTUSE there
      ...combine("sat(Z) sat(X)", { X: n, Z: c })
    ]
  }),
  or_c: (n, c) => ({
    sats: [
      ...combine("sat(X)", { X: n, Z: c }),
      ...combine("sat(Z) dsat(X)", { X: n, Z: c })
    ]
  }),
  or_d: (n, c) => ({
    dsats: [...combine("dsat(Z) dsat(X)", { X: n, Z: c })],
    sats: [
      ...combine("sat(X)", { X: n, Z: c }),
      ...combine("sat(Z) dsat(X)", { X: n, Z: c })
    ]
  }),
  or_i: (n, c) => ({
    dsats: [
      ...combine("dsat(X) 1", { X: n, Z: c }),
      ...combine("dsat(Z) 0", { X: n, Z: c })
    ],
    sats: [...combine("sat(X) 1", { X: n, Z: c }), ...combine("sat(Z) 0", { X: n, Z: c })]
  }),
  /*
   * This is not entirely trivial from the docs
   * (https://bitcoin.sipa.be/miniscript/),
   *  but solution templates for thresh must be written in reverse order.
   *  For example the first dsat, which is "All dsats", corresponds to:
   *  "<DSAT_N> <DSAT_N-1> ... <DSAT_1>" (note the reverse order in N)
   *  While this is not entirely trivial by reading the document
   *  it can be deduced by analyzing the script:
   *  thresh(k,X1,...,Xn)	[X1] [X2] ADD ... [Xn] ADD ... <k> EQUAL
   */
  thresh: (n, ...c) => {
    if (Number.isInteger(Number(n)) && Number(n) > 0) n = Number(n);
    else throw new Error(`k must be positive number: ${n}`);
    const u = {}, p = c.length;
    c.map((le, L) => {
      u[L] = le;
    });
    const a = [], A = [];
    a.push(
      ...combine(
        Object.keys(u).map((le) => `dsat(${le})`).reverse().join(" "),
        u
      )
    );
    const b = [], F = [];
    for (let le = 1; le < 1 << p; le++) {
      const L = [];
      let pe = 0;
      for (let $ = 0; $ < p; $++)
        le & 1 << $ && pe++, L.push(le & 1 << $ ? `sat(${$})` : `dsat(${$})`);
      pe !== n ? b.push(L.reverse().join(" ")) : F.push(L.reverse().join(" "));
    }
    for (const le of b)
      a.push(...combine(le, u));
    for (const le of F)
      A.push(...combine(le, u));
    return { dsats: a, sats: A };
  },
  multi: (n, ...c) => {
    if (Number.isInteger(Number(n)) && Number(n) > 0) n = Number(n);
    else throw new Error(`k must be positive number: ${n}`);
    if (typeof n != "number") throw new Error("k must be a number:" + n);
    if (n === 0) throw new Error("k cannot be 0");
    const u = [{ asm: "0 ".repeat(n + 1).trim() }];
    function p(F, le) {
      if (le === 0)
        return [[]];
      const L = [];
      for (let pe = 0; pe < F.length; pe++) {
        const $ = F.slice(pe + 1);
        p($, le - 1).forEach((be) => {
          L.push([F[pe], ...be]);
        });
      }
      return L;
    }
    const a = [];
    p(c, n).forEach((F) => {
      let le = "0";
      F.forEach((L) => {
        le += ` <sig(${L})>`;
      }), a.push(le);
    });
    let A = "0";
    for (let F = 0; F < n; F++)
      A += ` <sig(${c[F]})>`;
    return { sats: a.map((F) => ({ asm: F })), dsats: u };
  },
  a: (n) => ({
    dsats: [...combine("dsat(X)", { X: n })],
    sats: [...combine("sat(X)", { X: n })]
  }),
  s: (n) => ({
    dsats: [...combine("dsat(X)", { X: n })],
    sats: [...combine("sat(X)", { X: n })]
  }),
  c: (n) => ({
    dsats: [...combine("dsat(X)", { X: n })],
    sats: [...combine("sat(X)", { X: n })]
  }),
  d: (n) => ({
    dsats: [{ asm: "0" }],
    sats: [...combine("sat(X) 1", { X: n })]
  }),
  v: (n) => ({
    sats: [...combine("sat(X)", { X: n })]
  }),
  /**
     * j:X corresponds to SIZE 0NOTEQUAL IF [X] ENDIF
     *
     * By definition, this: "dsat(X) X" produces a zero.
     *
     *
     * A dsat needs to make this "dsat(X) X" return zero.
  
     * The easiest dsat for j:X is using 0:
     * 0 SIZE 0NOTEQUAL IF [X] ENDIF
     * 0 0 0NOTEQUAL IF [X] ENDIF
     * 0 0 IF [X] ENDIF
     * 0
  
     * Now let's do the case where dsat(X) finishes with a 0: "... 0"
     * ... 0 SIZE 0NOTEQUAL IF [X] ENDIF
     * ... 0 0 0NOTEQUAL IF [X] ENDIF
     * ... 0 0 IF [X] ENDIF 
     * ... 0
     * DSAT(X)
     * The final expression is "DSAT(X)".
     * It should have either been "0" or "DSAT(X) X"
     * Thus, this is not a valid dsat.
  
     * Now let's do the case where dsat(X) is this: "... <nonzero>"
     * ... <nonzero> SIZE 0NOTEQUAL IF [X] ENDIF
     * ... <nonzero> <length_is_nonzero> 0NOTEQUAL IF [X] ENDIF
     * ... <nonzero> 1 IF [X] ENDIF
     * ... <nonzero> [X]
     * DSAT(X) [X]
  
     * DSAT(X) X is a good dsat
     */
  j: (n) => {
    const c = [];
    c.push({ asm: "0" });
    const u = n.dsats.filter(
      //The top stack corresponds to the last element pushed to the stack,
      //that is, the last element in the produced witness
      (p) => p.asm.trim().split(" ").pop() !== "0"
    );
    return c.push(...u), { dsats: c, sats: [...combine("sat(X)", { X: n })] };
  },
  n: (n) => ({
    dsats: [...combine("dsat(X)", { X: n })],
    sats: [...combine("sat(X)", { X: n })]
  })
};
function createCommonjsModule(n, c) {
  return c = { exports: {} }, n(c, c.exports), c.exports;
}
var bindings = createCommonjsModule(function(n, c) {
  var u = (() => {
    var p = typeof document < "u" && document.currentScript ? document.currentScript.src : void 0;
    return function(a = {}) {
      var A = a, b, F;
      A.ready = new Promise((Ao, po) => {
        b = Ao, F = po;
      });
      var le = Object.assign({}, A), L = "./this.program", pe = "";
      function $(Ao) {
        return A.locateFile ? A.locateFile(Ao, pe) : pe + Ao;
      }
      typeof document < "u" && document.currentScript && (pe = document.currentScript.src), p && (pe = p), pe.indexOf("blob:") !== 0 ? pe = pe.substr(0, pe.replace(/[?#].*/, "").lastIndexOf("/") + 1) : pe = "", A.print || console.log.bind(console);
      var Ee = A.printErr || console.error.bind(console);
      Object.assign(A, le), le = null, A.arguments && A.arguments, A.thisProgram && (L = A.thisProgram), A.quit && A.quit;
      var be;
      A.wasmBinary && (be = A.wasmBinary), A.noExitRuntime;
      var He = { Memory: function(Ao) {
        this.buffer = new ArrayBuffer(Ao.initial * 65536);
      }, Module: function(Ao) {
      }, Instance: function(Ao, po) {
        this.exports = // EMSCRIPTEN_START_ASM
        function(Uo) {
          function ts(Aa) {
            return Aa.set = function(zs, x2) {
              this[zs] = x2;
            }, Aa.get = function(zs) {
              return this[zs];
            }, Aa;
          }
          for (var Lo, Wo = new Uint8Array(123), ps = 25; ps >= 0; --ps)
            Wo[48 + ps] = 52 + ps, Wo[65 + ps] = ps, Wo[97 + ps] = 26 + ps;
          Wo[43] = 62, Wo[47] = 63;
          function Bs(Aa, zs, x2) {
            for (var Va, Se, ea = 0, e = zs, Je = x2.length, N2 = zs + (Je * 3 >> 2) - (x2[Je - 2] == "=") - (x2[Je - 1] == "="); ea < Je; ea += 4)
              Va = Wo[x2.charCodeAt(ea + 1)], Se = Wo[x2.charCodeAt(ea + 2)], Aa[e++] = Wo[x2.charCodeAt(ea)] << 2 | Va >> 4, e < N2 && (Aa[e++] = Va << 4 | Se >> 2), e < N2 && (Aa[e++] = Se << 6 | Wo[x2.charCodeAt(ea + 3)]);
          }
          function Xs(Aa) {
            Bs(Lo, 1024, "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"), Bs(Lo, 5584, "////////////////////////////////////////////////////////////////AAECAwQFBgcICf////////8KCwwNDg///////////////////////////////////woLDA0OD/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////4QAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADEDwAAgw8AAFcPAADcDwAAtw0AAFQQAACtDwAAdA8AAGUPAABNDwAAQg8AABMPAAALDwAA+w4AALIQAADZDwAAoA8AAGcPAABkDwAATA8AAEEPAADFCwAAfAsAAB8NAAAlDQAAOg0AAC4NAABeDQAAQw0AADUKAADvCwAA0gwAAOAMAAC8CwAArAsAAKQLAACLCwAA/woAANsLAACbCwAA8AwAALQLAACUCwAAzAsAAIMLAADKDAAAWQwAAPgKAADTCwAAwgwAADMLAABKCwAAKwsAAA4LAABMDQAA7goAAKUNAABUCwAAWgsAAGgMAAA/CgAAtw8AAHYPAADKDQAA3w0AADYMAADmCgAAVA0AADoLAAAHCwAAgAwAAMMNAADYDQAALwwAAN8KAACeDQAAIQsAABcLAACsDQAAcgsAALYMAABOCgAAcQwAAA4MAAAaDAAAjQwAAKAMAAD5CwAA0goAAAAMAABzEAAA0Q8AADcPAABoEAAALA8AAGELAAD+DAAAYAoAAAoNAAByCgAArw8AAIkKAACgCgAATw8AAEQPAAAVDwAADQ8AAP0OAAC2DgAArBAAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAI0NAAAEXwAABF8AAARfAAAEXwAABF8AAARfAAAEXwAABF8AAARfAAAEXwAAFF8AACRfAAA0XwAARF8AAFRfAABkXwAAdF8AAIRfAACUXwAApF8AAMRfAAC0XwAA1F8AAORfAAAEXwAABF8="), Bs(Lo, 6976, "MDEyMzQ1Njc4OWFiY2RlZgAAAAAAAAAAJAEAACUBAAAmAQAAJwEAACgBAAAAAAAAGQAKABkZGQAAAAAFAAAAAAAACQAAAAALAAAAAAAAAAAZABEKGRkZAwoHAAEACQsYAAAJBgsAAAsABhkAAAAZGRk="), Bs(Lo, 7105, "DgAAAAAAAAAAGQAKDRkZGQANAAACAAkOAAAACQAOAAAO"), Bs(Lo, 7163, "DA=="), Bs(Lo, 7175, "EwAAAAATAAAAAAkMAAAAAAAMAAAM"), Bs(Lo, 7221, "EA=="), Bs(Lo, 7233, "DwAAAAQPAAAAAAkQAAAAAAAQAAAQ"), Bs(Lo, 7279, "Eg=="), Bs(Lo, 7291, "EQAAAAARAAAAAAkSAAAAAAASAAASAAAaAAAAGhoa"), Bs(Lo, 7346, "GgAAABoaGgAAAAAAAAk="), Bs(Lo, 7395, "FA=="), Bs(Lo, 7407, "FwAAAAAXAAAAAAkUAAAAAAAUAAAU"), Bs(Lo, 7453, "Fg=="), Bs(Lo, 7465, "FQAAAAAVAAAAAAkWAAAAAAAWAAAWAAAwMTIzNDU2Nzg5QUJDREVGAAAAAAIAAAADAAAABQAAAAcAAAALAAAADQAAABEAAAATAAAAFwAAAB0AAAAfAAAAJQAAACkAAAArAAAALwAAADUAAAA7AAAAPQAAAEMAAABHAAAASQAAAE8AAABTAAAAWQAAAGEAAABlAAAAZwAAAGsAAABtAAAAcQAAAH8AAACDAAAAiQAAAIsAAACVAAAAlwAAAJ0AAACjAAAApwAAAK0AAACzAAAAtQAAAL8AAADBAAAAxQAAAMcAAADTAAAAAQAAAAsAAAANAAAAEQAAABMAAAAXAAAAHQAAAB8AAAAlAAAAKQAAACsAAAAvAAAANQAAADsAAAA9AAAAQwAAAEcAAABJAAAATwAAAFMAAABZAAAAYQAAAGUAAABnAAAAawAAAG0AAABxAAAAeQAAAH8AAACDAAAAiQAAAIsAAACPAAAAlQAAAJcAAACdAAAAowAAAKcAAACpAAAArQAAALMAAAC1AAAAuwAAAL8AAADBAAAAxQAAAMcAAADRAAAAAAAAALwfAAApAQAAKgEAACsBAAAsAQAALQEAAC4BAAAvAQAAMAEAADEBAAAyAQAAMwEAADQBAAA1AQAANgEAAAAAAABQIAAANwEAADgBAAArAQAALAEAADkBAAA6AQAALwEAADABAAAxAQAAOwEAADMBAAA8AQAANQEAAD0BAABOU3QzX18yOWJhc2ljX2lvc0ljTlNfMTFjaGFyX3RyYWl0c0ljRUVFRQAAACRZAABQHwAAXCEAAE5TdDNfXzIxNWJhc2ljX3N0cmVhbWJ1ZkljTlNfMTFjaGFyX3RyYWl0c0ljRUVFRQAAAADkWAAAiB8AAE5TdDNfXzIxM2Jhc2ljX29zdHJlYW1JY05TXzExY2hhcl90cmFpdHNJY0VFRUUAAABXAADEHwAAAAAAAAEAAAB8HwAAA/T//05TdDNfXzIxNWJhc2ljX3N0cmluZ2J1ZkljTlNfMTFjaGFyX3RyYWl0c0ljRUVOU185YWxsb2NhdG9ySWNFRUVFAAAAJFkAAAwgAAC8HwAAOAAAAAAAAAD0IAAAPgEAAD8BAADI////yP////QgAABAAQAAQQEAADgAAAAAAAAA9B8AAEIBAABDAQAAyP///8j////0HwAARAEAAEUBAABOU3QzX18yMTliYXNpY19vc3RyaW5nc3RyZWFtSWNOU18xMWNoYXJfdHJhaXRzSWNFRU5TXzlhbGxvY2F0b3JJY0VFRUUAAAAkWQAArCAAAPQfAAAAAAAArCEAAEYBAABHAQAASAEAAEkBAABKAQAASwEAAEwBAAAAAAAAgCEAALEAAABNAQAATgEAAAAAAABcIQAATwEAAFABAABOU3QzX18yOGlvc19iYXNlRQAAAORYAABIIQAATlN0M19fMjhpb3NfYmFzZTdmYWlsdXJlRQAAACRZAABkIQAAlFUAAE5TdDNfXzIxOV9faW9zdHJlYW1fY2F0ZWdvcnlFAAAAJFkAAIwhAADkVQ=="), Bs(Lo, 8640, "/////////////////////////////////////////////////////////////////wABAgMEBQYHCAn/////////CgsMDQ4PEBESExQVFhcYGRobHB0eHyAhIiP///////8KCwwNDg8QERITFBUWFxgZGhscHR4fICEiI/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8AAQIEBwMGBQAAAAAAAADRdJ4AV529KoBwUg///z4nCgAAAGQAAADoAwAAECcAAKCGAQBAQg8AgJaYAADh9QUYAAAANQAAAHEAAABr////zvv//5K///8AAAAAAAAAAN4SBJUAAAAA////////////////"), Bs(Lo, 9024, "TENfQ1RZUEUAAAAATENfTlVNRVJJQwAATENfVElNRQAAAAAATENfQ09MTEFURQAATENfTU9ORVRBUlkATENfTUVTU0FHRVMAICMAABQAAABDLlVURi04"), Bs(Lo, 9652, "AQAAAAIAAAADAAAABAAAAAUAAAAGAAAABwAAAAgAAAAJAAAACgAAAAsAAAAMAAAADQAAAA4AAAAPAAAAEAAAABEAAAASAAAAEwAAABQAAAAVAAAAFgAAABcAAAAYAAAAGQAAABoAAAAbAAAAHAAAAB0AAAAeAAAAHwAAACAAAAAhAAAAIgAAACMAAAAkAAAAJQAAACYAAAAnAAAAKAAAACkAAAAqAAAAKwAAACwAAAAtAAAALgAAAC8AAAAwAAAAMQAAADIAAAAzAAAANAAAADUAAAA2AAAANwAAADgAAAA5AAAAOgAAADsAAAA8AAAAPQAAAD4AAAA/AAAAQAAAAGEAAABiAAAAYwAAAGQAAABlAAAAZgAAAGcAAABoAAAAaQAAAGoAAABrAAAAbAAAAG0AAABuAAAAbwAAAHAAAABxAAAAcgAAAHMAAAB0AAAAdQAAAHYAAAB3AAAAeAAAAHkAAAB6AAAAWwAAAFwAAABdAAAAXgAAAF8AAABgAAAAYQAAAGIAAABjAAAAZAAAAGUAAABmAAAAZwAAAGgAAABpAAAAagAAAGsAAABsAAAAbQAAAG4AAABvAAAAcAAAAHEAAAByAAAAcwAAAHQAAAB1AAAAdgAAAHcAAAB4AAAAeQAAAHoAAAB7AAAAfAAAAH0AAAB+AAAAfw=="), Bs(Lo, 11188, "AQAAAAIAAAADAAAABAAAAAUAAAAGAAAABwAAAAgAAAAJAAAACgAAAAsAAAAMAAAADQAAAA4AAAAPAAAAEAAAABEAAAASAAAAEwAAABQAAAAVAAAAFgAAABcAAAAYAAAAGQAAABoAAAAbAAAAHAAAAB0AAAAeAAAAHwAAACAAAAAhAAAAIgAAACMAAAAkAAAAJQAAACYAAAAnAAAAKAAAACkAAAAqAAAAKwAAACwAAAAtAAAALgAAAC8AAAAwAAAAMQAAADIAAAAzAAAANAAAADUAAAA2AAAANwAAADgAAAA5AAAAOgAAADsAAAA8AAAAPQAAAD4AAAA/AAAAQAAAAEEAAABCAAAAQwAAAEQAAABFAAAARgAAAEcAAABIAAAASQAAAEoAAABLAAAATAAAAE0AAABOAAAATwAAAFAAAABRAAAAUgAAAFMAAABUAAAAVQAAAFYAAABXAAAAWAAAAFkAAABaAAAAWwAAAFwAAABdAAAAXgAAAF8AAABgAAAAQQAAAEIAAABDAAAARAAAAEUAAABGAAAARwAAAEgAAABJAAAASgAAAEsAAABMAAAATQAAAE4AAABPAAAAUAAAAFEAAABSAAAAUwAAAFQAAABVAAAAVgAAAFcAAABYAAAAWQAAAFoAAAB7AAAAfAAAAH0AAAB+AAAAfw=="), Bs(Lo, 12208, "AgAAwAMAAMAEAADABQAAwAYAAMAHAADACAAAwAkAAMAKAADACwAAwAwAAMANAADADgAAwA8AAMAQAADAEQAAwBIAAMATAADAFAAAwBUAAMAWAADAFwAAwBgAAMAZAADAGgAAwBsAAMAcAADAHQAAwB4AAMAfAADAAAAAswEAAMMCAADDAwAAwwQAAMMFAADDBgAAwwcAAMMIAADDCQAAwwoAAMMLAADDDAAAww0AANMOAADDDwAAwwAADLsBAAzDAgAMwwMADMMEAAzbAAAAADAxMjM0NTY3ODlhYmNkZWZBQkNERUZ4WCstcFBpSW5OACVJOiVNOiVTICVwJUg6JU0="), Bs(Lo, 12480, "JQAAAG0AAAAvAAAAJQAAAGQAAAAvAAAAJQAAAHkAAAAlAAAAWQAAAC0AAAAlAAAAbQAAAC0AAAAlAAAAZAAAACUAAABJAAAAOgAAACUAAABNAAAAOgAAACUAAABTAAAAIAAAACUAAABwAAAAAAAAACUAAABIAAAAOgAAACUAAABN"), Bs(Lo, 12624, "JQAAAEgAAAA6AAAAJQAAAE0AAAA6AAAAJQAAAFMAAAAAAAAAxDoAAFEBAABSAQAAUwEAAAAAAAAkOwAAVAEAAFUBAABTAQAAVgEAAFcBAABYAQAAWQEAAFoBAABbAQAAXAEAAF0B"), Bs(Lo, 12736, "BAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABQIAAAUAAAAFAAAABQAAAAUAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAADAgAAggAAAIIAAACCAAAAggAAAIIAAACCAAAAggAAAIIAAACCAAAAggAAAIIAAACCAAAAggAAAIIAAACCAAAAQgEAAEIBAABCAQAAQgEAAEIBAABCAQAAQgEAAEIBAABCAQAAQgEAAIIAAACCAAAAggAAAIIAAACCAAAAggAAAIIAAAAqAQAAKgEAACoBAAAqAQAAKgEAACoBAAAqAAAAKgAAACoAAAAqAAAAKgAAACoAAAAqAAAAKgAAACoAAAAqAAAAKgAAACoAAAAqAAAAKgAAACoAAAAqAAAAKgAAACoAAAAqAAAAKgAAAIIAAACCAAAAggAAAIIAAACCAAAAggAAADIBAAAyAQAAMgEAADIBAAAyAQAAMgEAADIAAAAyAAAAMgAAADIAAAAyAAAAMgAAADIAAAAyAAAAMgAAADIAAAAyAAAAMgAAADIAAAAyAAAAMgAAADIAAAAyAAAAMgAAADIAAAAyAAAAggAAAIIAAACCAAAAggAAAAQ="), Bs(Lo, 13764, "jDoAAF4BAABfAQAAUwEAAGABAABhAQAAYgEAAGMBAABkAQAAZQEAAGYBAAAAAAAAXDsAAGcBAABoAQAAUwEAAGkBAABqAQAAawEAAGwBAABtAQAAAAAAAIA7AABuAQAAbwEAAFMBAABwAQAAcQEAAHIBAABzAQAAdAEAAHQAAAByAAAAdQAAAGUAAAAAAAAAZgAAAGEAAABsAAAAcwAAAGUAAAAAAAAAJQAAAG0AAAAvAAAAJQAAAGQAAAAvAAAAJQAAAHkAAAAAAAAAJQAAAEgAAAA6AAAAJQAAAE0AAAA6AAAAJQAAAFMAAAAAAAAAJQAAAGEAAAAgAAAAJQAAAGIAAAAgAAAAJQAAAGQAAAAgAAAAJQAAAEgAAAA6AAAAJQAAAE0AAAA6AAAAJQAAAFMAAAAgAAAAJQAAAFkAAAAAAAAAJQAAAEkAAAA6AAAAJQAAAE0AAAA6AAAAJQAAAFMAAAAgAAAAJQAAAHA="), Bs(Lo, 14140, "ZDcAAHUBAAB2AQAAUwEAAE5TdDNfXzI2bG9jYWxlNWZhY2V0RQAAACRZAABMNwAA3FUAAAAAAADkNwAAdQEAAHcBAABTAQAAeAEAAHkBAAB6AQAAewEAAHwBAAB9AQAAfgEAAH8BAACAAQAAgQEAAIIBAACDAQAATlN0M19fMjVjdHlwZUl3RUUATlN0M19fMjEwY3R5cGVfYmFzZUUAAORYAADGNwAAAFcAALQ3AAAAAAAAAgAAAGQ3AAACAAAA3DcAAAIAAAAAAAAAeDgAAHUBAACEAQAAUwEAAIUBAACGAQAAhwEAAIgBAACJAQAAigEAAIsBAABOU3QzX18yN2NvZGVjdnRJY2MxMV9fbWJzdGF0ZV90RUUATlN0M19fMjEyY29kZWN2dF9iYXNlRQAAAADkWAAAVjgAAABXAAA0OAAAAAAAAAIAAABkNwAAAgAAAHA4AAACAAAAAAAAAOw4AAB1AQAAjAEAAFMBAACNAQAAjgEAAI8BAACQAQAAkQEAAJIBAACTAQAATlN0M19fMjdjb2RlY3Z0SURzYzExX19tYnN0YXRlX3RFRQAAAFcAAMg4AAAAAAAAAgAAAGQ3AAACAAAAcDgAAAIAAAAAAAAAYDkAAHUBAACUAQAAUwEAAJUBAACWAQAAlwEAAJgBAACZAQAAmgEAAJsBAABOU3QzX18yN2NvZGVjdnRJRHNEdTExX19tYnN0YXRlX3RFRQAAVwAAPDkAAAAAAAACAAAAZDcAAAIAAABwOAAAAgAAAAAAAADUOQAAdQEAAJwBAABTAQAAnQEAAJ4BAACfAQAAoAEAAKEBAACiAQAAowEAAE5TdDNfXzI3Y29kZWN2dElEaWMxMV9fbWJzdGF0ZV90RUUAAABXAACwOQAAAAAAAAIAAABkNwAAAgAAAHA4AAACAAAAAAAAAEg6AAB1AQAApAEAAFMBAAClAQAApgEAAKcBAACoAQAAqQEAAKoBAACrAQAATlN0M19fMjdjb2RlY3Z0SURpRHUxMV9fbWJzdGF0ZV90RUUAAFcAACQ6AAAAAAAAAgAAAGQ3AAACAAAAcDgAAAIAAABOU3QzX18yN2NvZGVjdnRJd2MxMV9fbWJzdGF0ZV90RUUAAAAAVwAAaDoAAAAAAAACAAAAZDcAAAIAAABwOAAAAgAAAE5TdDNfXzI2bG9jYWxlNV9faW1wRQAAACRZAACsOgAAZDcAAE5TdDNfXzI3Y29sbGF0ZUljRUUAJFkAANA6AABkNwAATlN0M19fMjdjb2xsYXRlSXdFRQAkWQAA8DoAAGQ3AABOU3QzX18yNWN0eXBlSWNFRQAAAABXAAAQOwAAAAAAAAIAAABkNwAAAgAAANw3AAACAAAATlN0M19fMjhudW1wdW5jdEljRUUAAAAAJFkAAEQ7AABkNwAATlN0M19fMjhudW1wdW5jdEl3RUUAAAAAJFkAAGg7AABkNwAAAAAAAOQ6AACsAQAArQEAAFMBAACuAQAArwEAALABAAAAAAAABDsAALEBAACyAQAAUwEAALMBAAC0AQAAtQEAAAAAAACgPAAAdQEAALYBAABTAQAAtwEAALgBAAC5AQAAugEAALsBAAC8AQAAvQEAAL4BAAC/AQAAwAEAAMEBAABOU3QzX18yN251bV9nZXRJY05TXzE5aXN0cmVhbWJ1Zl9pdGVyYXRvckljTlNfMTFjaGFyX3RyYWl0c0ljRUVFRUVFAE5TdDNfXzI5X19udW1fZ2V0SWNFRQBOU3QzX18yMTRfX251bV9nZXRfYmFzZUUAAORYAABmPAAAAFcAAFA8AAAAAAAAAQAAAIA8AAAAAAAAAFcAAAw8AAAAAAAAAgAAAGQ3AAACAAAAiDw="), Bs(Lo, 15556, "dD0AAHUBAADCAQAAUwEAAMMBAADEAQAAxQEAAMYBAADHAQAAyAEAAMkBAADKAQAAywEAAMwBAADNAQAATlN0M19fMjdudW1fZ2V0SXdOU18xOWlzdHJlYW1idWZfaXRlcmF0b3JJd05TXzExY2hhcl90cmFpdHNJd0VFRUVFRQBOU3QzX18yOV9fbnVtX2dldEl3RUUAAAAAVwAARD0AAAAAAAABAAAAgDwAAAAAAAAAVwAAAD0AAAAAAAACAAAAZDcAAAIAAABcPQ=="), Bs(Lo, 15768, "XD4AAHUBAADOAQAAUwEAAM8BAADQAQAA0QEAANIBAADTAQAA1AEAANUBAADWAQAATlN0M19fMjdudW1fcHV0SWNOU18xOW9zdHJlYW1idWZfaXRlcmF0b3JJY05TXzExY2hhcl90cmFpdHNJY0VFRUVFRQBOU3QzX18yOV9fbnVtX3B1dEljRUUATlN0M19fMjE0X19udW1fcHV0X2Jhc2VFAADkWAAAIj4AAABXAAAMPgAAAAAAAAEAAAA8PgAAAAAAAABXAADIPQAAAAAAAAIAAABkNwAAAgAAAEQ+"), Bs(Lo, 16e3, "JD8AAHUBAADXAQAAUwEAANgBAADZAQAA2gEAANsBAADcAQAA3QEAAN4BAADfAQAATlN0M19fMjdudW1fcHV0SXdOU18xOW9zdHJlYW1idWZfaXRlcmF0b3JJd05TXzExY2hhcl90cmFpdHNJd0VFRUVFRQBOU3QzX18yOV9fbnVtX3B1dEl3RUUAAAAAVwAA9D4AAAAAAAABAAAAPD4AAAAAAAAAVwAAsD4AAAAAAAACAAAAZDcAAAIAAAAMPw=="), Bs(Lo, 16200, "JEAAAOABAADhAQAAUwEAAOIBAADjAQAA5AEAAOUBAADmAQAA5wEAAOgBAAD4////JEAAAOkBAADqAQAA6wEAAOwBAADtAQAA7gEAAO8BAABOU3QzX18yOHRpbWVfZ2V0SWNOU18xOWlzdHJlYW1idWZfaXRlcmF0b3JJY05TXzExY2hhcl90cmFpdHNJY0VFRUVFRQBOU3QzX18yOXRpbWVfYmFzZUUA5FgAAN0/AABOU3QzX18yMjBfX3RpbWVfZ2V0X2Nfc3RvcmFnZUljRUUAAADkWAAA+D8AAABXAACYPwAAAAAAAAMAAABkNwAAAgAAAPA/AAACAAAAHEAAAAAIAAAAAAAAEEEAAPABAADxAQAAUwEAAPIBAADzAQAA9AEAAPUBAAD2AQAA9wEAAPgBAAD4////EEEAAPkBAAD6AQAA+wEAAPwBAAD9AQAA/gEAAP8BAABOU3QzX18yOHRpbWVfZ2V0SXdOU18xOWlzdHJlYW1idWZfaXRlcmF0b3JJd05TXzExY2hhcl90cmFpdHNJd0VFRUVFRQBOU3QzX18yMjBfX3RpbWVfZ2V0X2Nfc3RvcmFnZUl3RUUAAORYAADlQAAAAFcAAKBAAAAAAAAAAwAAAGQ3AAACAAAA8D8AAAIAAAAIQQAAAAgAAAAAAAC0QQAAAAIAAAECAABTAQAAAgIAAE5TdDNfXzI4dGltZV9wdXRJY05TXzE5b3N0cmVhbWJ1Zl9pdGVyYXRvckljTlNfMTFjaGFyX3RyYWl0c0ljRUVFRUVFAE5TdDNfXzIxMF9fdGltZV9wdXRFAAAA5FgAAJVBAAAAVwAAUEEAAAAAAAACAAAAZDcAAAIAAACsQQAAAAgAAAAAAAA0QgAAAwIAAAQCAABTAQAABQIAAE5TdDNfXzI4dGltZV9wdXRJd05TXzE5b3N0cmVhbWJ1Zl9pdGVyYXRvckl3TlNfMTFjaGFyX3RyYWl0c0l3RUVFRUVFAAAAAABXAADsQQAAAAAAAAIAAABkNwAAAgAAAKxBAAAACAAAAAAAAMhCAAB1AQAABgIAAFMBAAAHAgAACAIAAAkCAAAKAgAACwIAAAwCAAANAgAADgIAAA8CAABOU3QzX18yMTBtb25leXB1bmN0SWNMYjBFRUUATlN0M19fMjEwbW9uZXlfYmFzZUUAAAAA5FgAAKhCAAAAVwAAjEIAAAAAAAACAAAAZDcAAAIAAADAQgAAAgAAAAAAAAA8QwAAdQEAABACAABTAQAAEQIAABICAAATAgAAFAIAABUCAAAWAgAAFwIAABgCAAAZAgAATlN0M19fMjEwbW9uZXlwdW5jdEljTGIxRUVFAABXAAAgQwAAAAAAAAIAAABkNwAAAgAAAMBCAAACAAAAAAAAALBDAAB1AQAAGgIAAFMBAAAbAgAAHAIAAB0CAAAeAgAAHwIAACACAAAhAgAAIgIAACMCAABOU3QzX18yMTBtb25leXB1bmN0SXdMYjBFRUUAAFcAAJRDAAAAAAAAAgAAAGQ3AAACAAAAwEIAAAIAAAAAAAAAJEQAAHUBAAAkAgAAUwEAACUCAAAmAgAAJwIAACgCAAApAgAAKgIAACsCAAAsAgAALQIAAE5TdDNfXzIxMG1vbmV5cHVuY3RJd0xiMUVFRQAAVwAACEQAAAAAAAACAAAAZDcAAAIAAADAQgAAAgAAAAAAAADIRAAAdQEAAC4CAABTAQAALwIAADACAABOU3QzX18yOW1vbmV5X2dldEljTlNfMTlpc3RyZWFtYnVmX2l0ZXJhdG9ySWNOU18xMWNoYXJfdHJhaXRzSWNFRUVFRUUATlN0M19fMjExX19tb25leV9nZXRJY0VFAADkWAAApkQAAABXAABgRAAAAAAAAAIAAABkNwAAAgAAAMBE"), Bs(Lo, 17644, "bEUAAHUBAAAxAgAAUwEAADICAAAzAgAATlN0M19fMjltb25leV9nZXRJd05TXzE5aXN0cmVhbWJ1Zl9pdGVyYXRvckl3TlNfMTFjaGFyX3RyYWl0c0l3RUVFRUVFAE5TdDNfXzIxMV9fbW9uZXlfZ2V0SXdFRQAA5FgAAEpFAAAAVwAABEUAAAAAAAACAAAAZDcAAAIAAABkRQ=="), Bs(Lo, 17808, "EEYAAHUBAAA0AgAAUwEAADUCAAA2AgAATlN0M19fMjltb25leV9wdXRJY05TXzE5b3N0cmVhbWJ1Zl9pdGVyYXRvckljTlNfMTFjaGFyX3RyYWl0c0ljRUVFRUVFAE5TdDNfXzIxMV9fbW9uZXlfcHV0SWNFRQAA5FgAAO5FAAAAVwAAqEUAAAAAAAACAAAAZDcAAAIAAAAIRg=="), Bs(Lo, 17972, "tEYAAHUBAAA3AgAAUwEAADgCAAA5AgAATlN0M19fMjltb25leV9wdXRJd05TXzE5b3N0cmVhbWJ1Zl9pdGVyYXRvckl3TlNfMTFjaGFyX3RyYWl0c0l3RUVFRUVFAE5TdDNfXzIxMV9fbW9uZXlfcHV0SXdFRQAA5FgAAJJGAAAAVwAATEYAAAAAAAACAAAAZDcAAAIAAACsRg=="), Bs(Lo, 18136, "LEcAAHUBAAA6AgAAUwEAADsCAAA8AgAAPQIAAE5TdDNfXzI4bWVzc2FnZXNJY0VFAE5TdDNfXzIxM21lc3NhZ2VzX2Jhc2VFAAAAAORYAAAJRwAAAFcAAPRGAAAAAAAAAgAAAGQ3AAACAAAAJEcAAAIAAAAAAAAAhEcAAHUBAAA+AgAAUwEAAD8CAABAAgAAQQIAAE5TdDNfXzI4bWVzc2FnZXNJd0VFAAAAAABXAABsRwAAAAAAAAIAAABkNwAAAgAAACRHAAACAAAAUwAAAHUAAABuAAAAZAAAAGEAAAB5AAAAAAAAAE0AAABvAAAAbgAAAGQAAABhAAAAeQAAAAAAAABUAAAAdQAAAGUAAABzAAAAZAAAAGEAAAB5AAAAAAAAAFcAAABlAAAAZAAAAG4AAABlAAAAcwAAAGQAAABhAAAAeQAAAAAAAABUAAAAaAAAAHUAAAByAAAAcwAAAGQAAABhAAAAeQAAAAAAAABGAAAAcgAAAGkAAABkAAAAYQAAAHkAAAAAAAAAUwAAAGEAAAB0AAAAdQAAAHIAAABkAAAAYQAAAHkAAAAAAAAAUwAAAHUAAABuAAAAAAAAAE0AAABvAAAAbgAAAAAAAABUAAAAdQAAAGUAAAAAAAAAVwAAAGUAAABkAAAAAAAAAFQAAABoAAAAdQAAAAAAAABGAAAAcgAAAGkAAAAAAAAAUwAAAGEAAAB0AAAAAAAAAEoAAABhAAAAbgAAAHUAAABhAAAAcgAAAHkAAAAAAAAARgAAAGUAAABiAAAAcgAAAHUAAABhAAAAcgAAAHkAAAAAAAAATQAAAGEAAAByAAAAYwAAAGgAAAAAAAAAQQAAAHAAAAByAAAAaQAAAGwAAAAAAAAATQAAAGEAAAB5AAAAAAAAAEoAAAB1AAAAbgAAAGUAAAAAAAAASgAAAHUAAABsAAAAeQAAAAAAAABBAAAAdQAAAGcAAAB1AAAAcwAAAHQAAAAAAAAAUwAAAGUAAABwAAAAdAAAAGUAAABtAAAAYgAAAGUAAAByAAAAAAAAAE8AAABjAAAAdAAAAG8AAABiAAAAZQAAAHIAAAAAAAAATgAAAG8AAAB2AAAAZQAAAG0AAABiAAAAZQAAAHIAAAAAAAAARAAAAGUAAABjAAAAZQAAAG0AAABiAAAAZQAAAHIAAAAAAAAASgAAAGEAAABuAAAAAAAAAEYAAABlAAAAYgAAAAAAAABNAAAAYQAAAHIAAAAAAAAAQQAAAHAAAAByAAAAAAAAAEoAAAB1AAAAbgAAAAAAAABKAAAAdQAAAGwAAAAAAAAAQQAAAHUAAABnAAAAAAAAAFMAAABlAAAAcAAAAAAAAABPAAAAYwAAAHQAAAAAAAAATgAAAG8AAAB2AAAAAAAAAEQAAABlAAAAYwAAAAAAAABBAAAATQAAAAAAAABQAAAATQ=="), Bs(Lo, 19228, "HEAAAOkBAADqAQAA6wEAAOwBAADtAQAA7gEAAO8BAAAAAAAACEEAAPkBAAD6AQAA+wEAAPwBAAD9AQAA/gEAAP8BAABOU3QzX18yMTRfX3NoYXJlZF9jb3VudEU="), Bs(Lo, 19348, "iCM="), Bs(Lo, 19372, "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"), Bs(Lo, 21298, "pQJbAPABtQWMBSUBgwYdA5QE/wDHAzEDCwa8AY8BfwPKBCsA2gavAEIDTgPcAQ4EFQChBg0BlAILAjgGZAK8Av8CXQPnBAsHzwLLBe8F2wXhAh4GRQKFAIICbANvBPEA8wMYBdkA2gNMBlQCewGdA70EAABRABUCuwCzA20A/wGFBC8F+QQ4AGUBRgGfALcGqAFzAlMB"), Bs(Lo, 21496, "IQQAAAAAAAAAAC8C"), Bs(Lo, 21528, "NQRHBFYE"), Bs(Lo, 21550, "oAQ="), Bs(Lo, 21570, "RgVgBW4FYQYAAM8BAAAAAAAAAADJBukG+QYeBzkHSQdeBw=="), Bs(Lo, 21620, "CgAAAGQAAADoAwAAECcAAKCGAQBAQg8AgJaYAADh9QUAypo7AAAAAAAAAAAwMDAxMDIwMzA0MDUwNjA3MDgwOTEwMTExMjEzMTQxNTE2MTcxODE5MjAyMTIyMjMyNDI1MjYyNzI4MjkzMDMxMzIzMzM0MzUzNjM3MzgzOTQwNDE0MjQzNDQ0NTQ2NDc0ODQ5NTA1MTUyNTM1NDU1NTY1NzU4NTk2MDYxNjI2MzY0NjU2NjY3Njg2OTcwNzE3MjczNzQ3NTc2Nzc3ODc5ODA4MTgyODM4NDg1ODY4Nzg4ODk5MDkxOTI5Mzk0OTU5Njk3OTg5OQAAAACUVQAAQgIAAEMCAABOAQAATlN0M19fMjEyc3lzdGVtX2Vycm9yRQAAJFkAAHxVAACIWAAATlN0M19fMjE0ZXJyb3JfY2F0ZWdvcnlFAAAAAORYAACgVQAATlN0M19fMjEyX19kb19tZXNzYWdlRQAA5FgAAGBLAAAkWQAAxFUAALxVAAAAAAAA3FUAAEQCAABFAgAARgIAAE4xMF9fY3h4YWJpdjExNl9fc2hpbV90eXBlX2luZm9FAAAAACRZAAAEVgAAFFkAAE4xMF9fY3h4YWJpdjExN19fY2xhc3NfdHlwZV9pbmZvRQAAACRZAAA0VgAAKFYAAE4xMF9fY3h4YWJpdjExN19fcGJhc2VfdHlwZV9pbmZvRQAAACRZAABkVgAAKFYAAE4xMF9fY3h4YWJpdjExOV9fcG9pbnRlcl90eXBlX2luZm9FACRZAACUVgAAiFYAAE4xMF9fY3h4YWJpdjEyMF9fc2lfY2xhc3NfdHlwZV9pbmZvRQAAAAAkWQAAxFYAAFhWAAAAAAAASFcAAEgCAABJAgAASgIAAEsCAABMAgAATQIAAE4CAABPAgAATjEwX19jeHhhYml2MTIxX192bWlfY2xhc3NfdHlwZV9pbmZvRQAAACRZAAAgVwAAWFYAAAAAAACwVwAABQAAAFACAABRAgAAAAAAALxXAAAFAAAAUgIAAFMCAABTdDlleGNlcHRpb24AU3QyMGJhZF9hcnJheV9uZXdfbGVuZ3RoAFN0OWJhZF9hbGxvYwAAJFkAAKJXAABQWQAAJFkAAIlXAACwVwAAAAAAAABYAAAHAAAAVAIAAFUCAAAAAAAAiFgAAFwAAABWAgAATgEAAFN0MTFsb2dpY19lcnJvcgAkWQAA8FcAAFBZAAAAAAAANFgAAAcAAABXAgAAVQIAAFN0MTJsZW5ndGhfZXJyb3IAAAAAJFkAACBYAAAAWAAAAAAAAGhYAAAHAAAAWAIAAFUCAABTdDEyb3V0X29mX3JhbmdlAAAAACRZAABUWAAAAFgAAFN0MTNydW50aW1lX2Vycm9yAAAAJFkAAHRYAABQWQAAAAAAALxYAABcAAAAWQIAAE4BAABTdDE0b3ZlcmZsb3dfZXJyb3IAACRZAACoWAAAiFgAAAAAAABYWQAArQAAAFoCAABbAgAAAAAAAFhWAABIAgAAXAIAAEoCAABLAgAATAIAAF0CAABeAgAAXwIAAFN0OXR5cGVfaW5mbwAAAADkWAAABFkAAAAAAADsVgAASAIAAGACAABKAgAASwIAAEwCAABhAgAAYgIAAGMCAABTdDhiYWRfY2FzdADkWAAAfFcAACRZAABEWQAAUFkAAAAAAABQWQAABQAAAGQCAABlAg=="), Bs(Lo, 22904, "0GoBAAghAABHAg==");
          }
          var js = new ArrayBuffer(16), ya = new Int32Array(js), sa = new Float32Array(js), va = new Float64Array(js);
          function oa(Aa) {
            return ya[Aa];
          }
          function wa(Aa, zs) {
            ya[Aa] = zs;
          }
          function Pa() {
            return va[0];
          }
          function Ta(Aa) {
            va[0] = Aa;
          }
          function jn() {
            throw new Error("abort");
          }
          function ta() {
            return sa[2];
          }
          function Na(Aa) {
            sa[2] = Aa;
          }
          function ba(Aa) {
            var zs = Aa.a, x2 = zs.a, Va = x2.buffer, Se = new Int8Array(Va), ea = new Int16Array(Va), e = new Int32Array(Va), Je = new Uint8Array(Va), N2 = new Uint16Array(Va), qs = new Uint32Array(Va), df = new Float32Array(Va), zo = new Float64Array(Va), No = Math.imul, Oa = Math.fround, Mf = Math.abs, Ha = Math.clz32, Cu = Math.ceil, gi = zs.b, wn = zs.c, no = zs.d, Co = zs.e, Ko = zs.f, jo = zs.g, ss = zs.h, Ms = zs.i, Ws = zs.j, ia = zs.k, La = zs.l, mf = zs.m, kf = zs.n, Cf = zs.o, Nf = zs.p, jf = zs.q, E2 = zs.r, Xf = zs.s, Zf = zs.t, Ic = zs.u, $a = zs.v, gs = zs.w, Wc = zs.x, Uc = zs.y, Gf = zs.z, su = zs.A, i2 = zs.B, tc = zs.C, pc = zs.D, Ai = zs.E, Bi = zs.F, yi = zs.G, ii = zs.H, ki = zs.I, Vi = zs.J, Ki = zs.K, Pn = zs.L, oo = zs.M, mo = zs.N, ko = zs.O, $o = zs.P, Jo = zs.Q, hs = zs.R, Ss = zs.S, Us = zs.T, Zs = zs.U, Ks = zs.V, ha = zs.W, pa = zs.X, bi = 92880, Ia = 0, Ci = 0;
            function Wh(l, y) {
              l = l | 0, y = y | 0;
              var I = 0, C = 0, Q = 0, S = 0, me = 0, ke = 0, Ar = 0, br = 0, Qr = 0, Ur = 0, Xr = 0;
              Q = bi - 352 | 0, bi = Q, e[Q + 328 >> 2] = 0, e[Q + 320 >> 2] = 0, e[Q + 324 >> 2] = 0, e[5996] = 0, e[Q + 316 >> 2] = 0, e[Q + 308 >> 2] = 0, e[Q + 312 >> 2] = 0, S = no(3, 24) | 0, C = e[5996], e[5996] = 0;
              e: {
                t: {
                  r: {
                    if ((C | 0) != 1) {
                      e[S + 8 >> 2] = -1, e[S + 12 >> 2] = -1, e[S >> 2] = 0, e[S + 16 >> 2] = -1, e[S + 20 >> 2] = -1, I = S + 24 | 0, e[Q + 328 >> 2] = I, e[Q + 320 >> 2] = S, Xr = Q + 296 | 0;
                      i: {
                        n: {
                          o: {
                            a: {
                              s: {
                                A: {
                                  u: {
                                    h: {
                                      c: {
                                        for (; ; ) {
                                          C = I - 24 | 0, me = e[C + 20 >> 2], e[Xr >> 2] = e[C + 16 >> 2], e[Xr + 4 >> 2] = me, me = e[C + 12 >> 2], e[Q + 288 >> 2] = e[C + 8 >> 2], e[Q + 292 >> 2] = me, ke = e[C + 4 >> 2], me = e[C >> 2], e[Q + 280 >> 2] = me, e[Q + 284 >> 2] = ke, e[Q + 324 >> 2] = C, Ur = 18;
                                          f: {
                                            p: {
                                              d: {
                                                g: {
                                                  v: {
                                                    _: {
                                                      R: {
                                                        k: {
                                                          S: {
                                                            E: {
                                                              w: {
                                                                I: {
                                                                  l: {
                                                                    T:
                                                                      switch (me | 0) {
                                                                        case 0:
                                                                          I = e[y + 4 >> 2];
                                                                          m: {
                                                                            if ((I | 0) < 2) {
                                                                              S = -1;
                                                                              break m;
                                                                            }
                                                                            for (me = e[y >> 2], S = 1; ; ) {
                                                                              if (ke = Je[S + me | 0], (ke | 0) == 58) {
                                                                                Ur = 0;
                                                                                C: {
                                                                                  D: {
                                                                                    b: {
                                                                                      B: {
                                                                                        for (; ; ) {
                                                                                          y: {
                                                                                            x:
                                                                                              switch (Je[e[y >> 2] + Ur | 0] - 97 | 0) {
                                                                                                case 0:
                                                                                                  if (C = e[Q + 324 >> 2], ke = e[Q + 328 >> 2], C >>> 0 < ke >>> 0) {
                                                                                                    e[C + 8 >> 2] = -1, e[C + 12 >> 2] = -1, e[C >> 2] = 3, e[C + 16 >> 2] = -1, e[C + 20 >> 2] = -1, e[Q + 324 >> 2] = C + 24;
                                                                                                    break y;
                                                                                                  }
                                                                                                  P: {
                                                                                                    M: {
                                                                                                      N: {
                                                                                                        me = e[Q + 320 >> 2], br = (C - me | 0) / 24 | 0, I = br + 1 | 0;
                                                                                                        O: {
                                                                                                          if (I >>> 0 >= 178956971) {
                                                                                                            if (e[5996] = 0, jo(142), l = e[5996], e[5996] = 0, (l | 0) == 1)
                                                                                                              break O;
                                                                                                            break e;
                                                                                                          }
                                                                                                          if (ke = (ke - me | 0) / 24 | 0, Ar = ke << 1, ke = ke >>> 0 >= 89478485 ? 178956970 : I >>> 0 < Ar >>> 0 ? Ar : I, !ke) {
                                                                                                            Ar = 0;
                                                                                                            break M;
                                                                                                          }
                                                                                                          if (ke >>> 0 < 178956971)
                                                                                                            break N;
                                                                                                          if (e[5996] = 0, jo(35), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                                                            break e;
                                                                                                        }
                                                                                                        y = gi() | 0;
                                                                                                        break t;
                                                                                                      }
                                                                                                      if (e[5996] = 0, Ar = no(3, No(ke, 24) | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                                                                        break P;
                                                                                                    }
                                                                                                    if (I = No(br, 24) + Ar | 0, e[I + 8 >> 2] = -1, e[I + 12 >> 2] = -1, e[I >> 2] = 3, e[I + 16 >> 2] = -1, e[I + 20 >> 2] = -1, br = I + 24 | 0, (C | 0) != (me | 0)) {
                                                                                                      for (; C = C - 24 | 0, Qr = e[C + 4 >> 2], I = I - 24 | 0, e[I >> 2] = e[C >> 2], e[I + 4 >> 2] = Qr, Qr = e[C + 20 >> 2], e[I + 16 >> 2] = e[C + 16 >> 2], e[I + 20 >> 2] = Qr, Qr = e[C + 12 >> 2], e[I + 8 >> 2] = e[C + 8 >> 2], e[I + 12 >> 2] = Qr, (C | 0) != (me | 0); )
                                                                                                        ;
                                                                                                      C = me;
                                                                                                    }
                                                                                                    if (e[Q + 328 >> 2] = No(ke, 24) + Ar, e[Q + 324 >> 2] = br, e[Q + 320 >> 2] = I, !C)
                                                                                                      break y;
                                                                                                    Tr(C);
                                                                                                    break y;
                                                                                                  }
                                                                                                  y = gi() | 0;
                                                                                                  break t;
                                                                                                case 18:
                                                                                                  if (C = e[Q + 324 >> 2], ke = e[Q + 328 >> 2], C >>> 0 < ke >>> 0) {
                                                                                                    e[C + 8 >> 2] = -1, e[C + 12 >> 2] = -1, e[C >> 2] = 2, e[C + 16 >> 2] = -1, e[C + 20 >> 2] = -1, e[Q + 324 >> 2] = C + 24;
                                                                                                    break y;
                                                                                                  }
                                                                                                  P: {
                                                                                                    M: {
                                                                                                      N: {
                                                                                                        me = e[Q + 320 >> 2], br = (C - me | 0) / 24 | 0, I = br + 1 | 0;
                                                                                                        O: {
                                                                                                          if (I >>> 0 >= 178956971) {
                                                                                                            e[5996] = 0, jo(142);
                                                                                                            break O;
                                                                                                          }
                                                                                                          if (ke = (ke - me | 0) / 24 | 0, Ar = ke << 1, ke = ke >>> 0 >= 89478485 ? 178956970 : I >>> 0 < Ar >>> 0 ? Ar : I, !ke) {
                                                                                                            Ar = 0;
                                                                                                            break M;
                                                                                                          }
                                                                                                          if (ke >>> 0 < 178956971)
                                                                                                            break N;
                                                                                                          e[5996] = 0, jo(35);
                                                                                                        }
                                                                                                        if (l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                                                          break e;
                                                                                                        y = gi() | 0;
                                                                                                        break t;
                                                                                                      }
                                                                                                      if (e[5996] = 0, Ar = no(3, No(ke, 24) | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                                                                        break P;
                                                                                                    }
                                                                                                    if (I = No(br, 24) + Ar | 0, e[I + 8 >> 2] = -1, e[I + 12 >> 2] = -1, e[I >> 2] = 2, e[I + 16 >> 2] = -1, e[I + 20 >> 2] = -1, br = I + 24 | 0, (C | 0) != (me | 0)) {
                                                                                                      for (; C = C - 24 | 0, Qr = e[C + 4 >> 2], I = I - 24 | 0, e[I >> 2] = e[C >> 2], e[I + 4 >> 2] = Qr, Qr = e[C + 20 >> 2], e[I + 16 >> 2] = e[C + 16 >> 2], e[I + 20 >> 2] = Qr, Qr = e[C + 12 >> 2], e[I + 8 >> 2] = e[C + 8 >> 2], e[I + 12 >> 2] = Qr, (C | 0) != (me | 0); )
                                                                                                        ;
                                                                                                      C = me;
                                                                                                    }
                                                                                                    if (e[Q + 328 >> 2] = No(ke, 24) + Ar, e[Q + 324 >> 2] = br, e[Q + 320 >> 2] = I, !C)
                                                                                                      break y;
                                                                                                    Tr(C);
                                                                                                    break y;
                                                                                                  }
                                                                                                  y = gi() | 0;
                                                                                                  break t;
                                                                                                case 2:
                                                                                                  if (C = e[Q + 324 >> 2], ke = e[Q + 328 >> 2], C >>> 0 < ke >>> 0) {
                                                                                                    e[C + 8 >> 2] = -1, e[C + 12 >> 2] = -1, e[C >> 2] = 4, e[C + 16 >> 2] = -1, e[C + 20 >> 2] = -1, e[Q + 324 >> 2] = C + 24;
                                                                                                    break y;
                                                                                                  }
                                                                                                  P: {
                                                                                                    M: {
                                                                                                      N: {
                                                                                                        me = e[Q + 320 >> 2], br = (C - me | 0) / 24 | 0, I = br + 1 | 0;
                                                                                                        O: {
                                                                                                          if (I >>> 0 >= 178956971) {
                                                                                                            e[5996] = 0, jo(142);
                                                                                                            break O;
                                                                                                          }
                                                                                                          if (ke = (ke - me | 0) / 24 | 0, Ar = ke << 1, ke = ke >>> 0 >= 89478485 ? 178956970 : I >>> 0 < Ar >>> 0 ? Ar : I, !ke) {
                                                                                                            Ar = 0;
                                                                                                            break M;
                                                                                                          }
                                                                                                          if (ke >>> 0 < 178956971)
                                                                                                            break N;
                                                                                                          e[5996] = 0, jo(35);
                                                                                                        }
                                                                                                        if (l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                                                          break e;
                                                                                                        y = gi() | 0;
                                                                                                        break t;
                                                                                                      }
                                                                                                      if (e[5996] = 0, Ar = no(3, No(ke, 24) | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                                                                        break P;
                                                                                                    }
                                                                                                    if (I = No(br, 24) + Ar | 0, e[I + 8 >> 2] = -1, e[I + 12 >> 2] = -1, e[I >> 2] = 4, e[I + 16 >> 2] = -1, e[I + 20 >> 2] = -1, br = I + 24 | 0, (C | 0) != (me | 0)) {
                                                                                                      for (; C = C - 24 | 0, Qr = e[C + 4 >> 2], I = I - 24 | 0, e[I >> 2] = e[C >> 2], e[I + 4 >> 2] = Qr, Qr = e[C + 20 >> 2], e[I + 16 >> 2] = e[C + 16 >> 2], e[I + 20 >> 2] = Qr, Qr = e[C + 12 >> 2], e[I + 8 >> 2] = e[C + 8 >> 2], e[I + 12 >> 2] = Qr, (C | 0) != (me | 0); )
                                                                                                        ;
                                                                                                      C = me;
                                                                                                    }
                                                                                                    if (e[Q + 328 >> 2] = No(ke, 24) + Ar, e[Q + 324 >> 2] = br, e[Q + 320 >> 2] = I, !C)
                                                                                                      break y;
                                                                                                    Tr(C);
                                                                                                    break y;
                                                                                                  }
                                                                                                  y = gi() | 0;
                                                                                                  break t;
                                                                                                case 3:
                                                                                                  if (C = e[Q + 324 >> 2], ke = e[Q + 328 >> 2], C >>> 0 < ke >>> 0) {
                                                                                                    e[C + 8 >> 2] = -1, e[C + 12 >> 2] = -1, e[C >> 2] = 5, e[C + 16 >> 2] = -1, e[C + 20 >> 2] = -1, e[Q + 324 >> 2] = C + 24;
                                                                                                    break y;
                                                                                                  }
                                                                                                  P: {
                                                                                                    M: {
                                                                                                      N: {
                                                                                                        me = e[Q + 320 >> 2], br = (C - me | 0) / 24 | 0, I = br + 1 | 0;
                                                                                                        O: {
                                                                                                          if (I >>> 0 >= 178956971) {
                                                                                                            e[5996] = 0, jo(142);
                                                                                                            break O;
                                                                                                          }
                                                                                                          if (ke = (ke - me | 0) / 24 | 0, Ar = ke << 1, ke = ke >>> 0 >= 89478485 ? 178956970 : I >>> 0 < Ar >>> 0 ? Ar : I, !ke) {
                                                                                                            Ar = 0;
                                                                                                            break M;
                                                                                                          }
                                                                                                          if (ke >>> 0 < 178956971)
                                                                                                            break N;
                                                                                                          e[5996] = 0, jo(35);
                                                                                                        }
                                                                                                        if (l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                                                          break e;
                                                                                                        y = gi() | 0;
                                                                                                        break t;
                                                                                                      }
                                                                                                      if (e[5996] = 0, Ar = no(3, No(ke, 24) | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                                                                        break P;
                                                                                                    }
                                                                                                    if (I = No(br, 24) + Ar | 0, e[I + 8 >> 2] = -1, e[I + 12 >> 2] = -1, e[I >> 2] = 5, e[I + 16 >> 2] = -1, e[I + 20 >> 2] = -1, br = I + 24 | 0, (C | 0) != (me | 0)) {
                                                                                                      for (; C = C - 24 | 0, Qr = e[C + 4 >> 2], I = I - 24 | 0, e[I >> 2] = e[C >> 2], e[I + 4 >> 2] = Qr, Qr = e[C + 20 >> 2], e[I + 16 >> 2] = e[C + 16 >> 2], e[I + 20 >> 2] = Qr, Qr = e[C + 12 >> 2], e[I + 8 >> 2] = e[C + 8 >> 2], e[I + 12 >> 2] = Qr, (C | 0) != (me | 0); )
                                                                                                        ;
                                                                                                      C = me;
                                                                                                    }
                                                                                                    if (e[Q + 328 >> 2] = No(ke, 24) + Ar, e[Q + 324 >> 2] = br, e[Q + 320 >> 2] = I, !C)
                                                                                                      break y;
                                                                                                    Tr(C);
                                                                                                    break y;
                                                                                                  }
                                                                                                  y = gi() | 0;
                                                                                                  break t;
                                                                                                case 9:
                                                                                                  if (C = e[Q + 324 >> 2], ke = e[Q + 328 >> 2], C >>> 0 < ke >>> 0) {
                                                                                                    e[C + 8 >> 2] = -1, e[C + 12 >> 2] = -1, e[C >> 2] = 7, e[C + 16 >> 2] = -1, e[C + 20 >> 2] = -1, e[Q + 324 >> 2] = C + 24;
                                                                                                    break y;
                                                                                                  }
                                                                                                  P: {
                                                                                                    M: {
                                                                                                      N: {
                                                                                                        me = e[Q + 320 >> 2], br = (C - me | 0) / 24 | 0, I = br + 1 | 0;
                                                                                                        O: {
                                                                                                          if (I >>> 0 >= 178956971) {
                                                                                                            e[5996] = 0, jo(142);
                                                                                                            break O;
                                                                                                          }
                                                                                                          if (ke = (ke - me | 0) / 24 | 0, Ar = ke << 1, ke = ke >>> 0 >= 89478485 ? 178956970 : I >>> 0 < Ar >>> 0 ? Ar : I, !ke) {
                                                                                                            Ar = 0;
                                                                                                            break M;
                                                                                                          }
                                                                                                          if (ke >>> 0 < 178956971)
                                                                                                            break N;
                                                                                                          e[5996] = 0, jo(35);
                                                                                                        }
                                                                                                        if (l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                                                          break e;
                                                                                                        y = gi() | 0;
                                                                                                        break t;
                                                                                                      }
                                                                                                      if (e[5996] = 0, Ar = no(3, No(ke, 24) | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                                                                        break P;
                                                                                                    }
                                                                                                    if (I = No(br, 24) + Ar | 0, e[I + 8 >> 2] = -1, e[I + 12 >> 2] = -1, e[I >> 2] = 7, e[I + 16 >> 2] = -1, e[I + 20 >> 2] = -1, br = I + 24 | 0, (C | 0) != (me | 0)) {
                                                                                                      for (; C = C - 24 | 0, Qr = e[C + 4 >> 2], I = I - 24 | 0, e[I >> 2] = e[C >> 2], e[I + 4 >> 2] = Qr, Qr = e[C + 20 >> 2], e[I + 16 >> 2] = e[C + 16 >> 2], e[I + 20 >> 2] = Qr, Qr = e[C + 12 >> 2], e[I + 8 >> 2] = e[C + 8 >> 2], e[I + 12 >> 2] = Qr, (C | 0) != (me | 0); )
                                                                                                        ;
                                                                                                      C = me;
                                                                                                    }
                                                                                                    if (e[Q + 328 >> 2] = No(ke, 24) + Ar, e[Q + 324 >> 2] = br, e[Q + 320 >> 2] = I, !C)
                                                                                                      break y;
                                                                                                    Tr(C);
                                                                                                    break y;
                                                                                                  }
                                                                                                  y = gi() | 0;
                                                                                                  break t;
                                                                                                case 13:
                                                                                                  if (C = e[Q + 324 >> 2], ke = e[Q + 328 >> 2], C >>> 0 < ke >>> 0) {
                                                                                                    e[C + 8 >> 2] = -1, e[C + 12 >> 2] = -1, e[C >> 2] = 8, e[C + 16 >> 2] = -1, e[C + 20 >> 2] = -1, e[Q + 324 >> 2] = C + 24;
                                                                                                    break y;
                                                                                                  }
                                                                                                  P: {
                                                                                                    M: {
                                                                                                      N: {
                                                                                                        me = e[Q + 320 >> 2], br = (C - me | 0) / 24 | 0, I = br + 1 | 0;
                                                                                                        O: {
                                                                                                          if (I >>> 0 >= 178956971) {
                                                                                                            e[5996] = 0, jo(142);
                                                                                                            break O;
                                                                                                          }
                                                                                                          if (ke = (ke - me | 0) / 24 | 0, Ar = ke << 1, ke = ke >>> 0 >= 89478485 ? 178956970 : I >>> 0 < Ar >>> 0 ? Ar : I, !ke) {
                                                                                                            Ar = 0;
                                                                                                            break M;
                                                                                                          }
                                                                                                          if (ke >>> 0 < 178956971)
                                                                                                            break N;
                                                                                                          e[5996] = 0, jo(35);
                                                                                                        }
                                                                                                        if (l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                                                          break e;
                                                                                                        y = gi() | 0;
                                                                                                        break t;
                                                                                                      }
                                                                                                      if (e[5996] = 0, Ar = no(3, No(ke, 24) | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                                                                        break P;
                                                                                                    }
                                                                                                    if (I = No(br, 24) + Ar | 0, e[I + 8 >> 2] = -1, e[I + 12 >> 2] = -1, e[I >> 2] = 8, e[I + 16 >> 2] = -1, e[I + 20 >> 2] = -1, br = I + 24 | 0, (C | 0) != (me | 0)) {
                                                                                                      for (; C = C - 24 | 0, Qr = e[C + 4 >> 2], I = I - 24 | 0, e[I >> 2] = e[C >> 2], e[I + 4 >> 2] = Qr, Qr = e[C + 20 >> 2], e[I + 16 >> 2] = e[C + 16 >> 2], e[I + 20 >> 2] = Qr, Qr = e[C + 12 >> 2], e[I + 8 >> 2] = e[C + 8 >> 2], e[I + 12 >> 2] = Qr, (C | 0) != (me | 0); )
                                                                                                        ;
                                                                                                      C = me;
                                                                                                    }
                                                                                                    if (e[Q + 328 >> 2] = No(ke, 24) + Ar, e[Q + 324 >> 2] = br, e[Q + 320 >> 2] = I, !C)
                                                                                                      break y;
                                                                                                    Tr(C);
                                                                                                    break y;
                                                                                                  }
                                                                                                  y = gi() | 0;
                                                                                                  break t;
                                                                                                case 21:
                                                                                                  if (C = e[Q + 324 >> 2], ke = e[Q + 328 >> 2], C >>> 0 < ke >>> 0) {
                                                                                                    e[C + 8 >> 2] = -1, e[C + 12 >> 2] = -1, e[C >> 2] = 6, e[C + 16 >> 2] = -1, e[C + 20 >> 2] = -1, e[Q + 324 >> 2] = C + 24;
                                                                                                    break y;
                                                                                                  }
                                                                                                  P: {
                                                                                                    M: {
                                                                                                      N: {
                                                                                                        me = e[Q + 320 >> 2], br = (C - me | 0) / 24 | 0, I = br + 1 | 0;
                                                                                                        O: {
                                                                                                          if (I >>> 0 >= 178956971) {
                                                                                                            e[5996] = 0, jo(142);
                                                                                                            break O;
                                                                                                          }
                                                                                                          if (ke = (ke - me | 0) / 24 | 0, Ar = ke << 1, ke = ke >>> 0 >= 89478485 ? 178956970 : I >>> 0 < Ar >>> 0 ? Ar : I, !ke) {
                                                                                                            Ar = 0;
                                                                                                            break M;
                                                                                                          }
                                                                                                          if (ke >>> 0 < 178956971)
                                                                                                            break N;
                                                                                                          e[5996] = 0, jo(35);
                                                                                                        }
                                                                                                        if (l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                                                          break e;
                                                                                                        y = gi() | 0;
                                                                                                        break t;
                                                                                                      }
                                                                                                      if (e[5996] = 0, Ar = no(3, No(ke, 24) | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                                                                        break P;
                                                                                                    }
                                                                                                    if (I = No(br, 24) + Ar | 0, e[I + 8 >> 2] = -1, e[I + 12 >> 2] = -1, e[I >> 2] = 6, e[I + 16 >> 2] = -1, e[I + 20 >> 2] = -1, br = I + 24 | 0, (C | 0) != (me | 0)) {
                                                                                                      for (; C = C - 24 | 0, Qr = e[C + 4 >> 2], I = I - 24 | 0, e[I >> 2] = e[C >> 2], e[I + 4 >> 2] = Qr, Qr = e[C + 20 >> 2], e[I + 16 >> 2] = e[C + 16 >> 2], e[I + 20 >> 2] = Qr, Qr = e[C + 12 >> 2], e[I + 8 >> 2] = e[C + 8 >> 2], e[I + 12 >> 2] = Qr, (C | 0) != (me | 0); )
                                                                                                        ;
                                                                                                      C = me;
                                                                                                    }
                                                                                                    if (e[Q + 328 >> 2] = No(ke, 24) + Ar, e[Q + 324 >> 2] = br, e[Q + 320 >> 2] = I, !C)
                                                                                                      break y;
                                                                                                    Tr(C);
                                                                                                    break y;
                                                                                                  }
                                                                                                  y = gi() | 0;
                                                                                                  break t;
                                                                                                case 20:
                                                                                                  if (C = e[Q + 324 >> 2], ke = e[Q + 328 >> 2], C >>> 0 < ke >>> 0) {
                                                                                                    e[C + 8 >> 2] = -1, e[C + 12 >> 2] = -1, e[C >> 2] = 9, e[C + 16 >> 2] = -1, e[C + 20 >> 2] = -1, e[Q + 324 >> 2] = C + 24;
                                                                                                    break y;
                                                                                                  }
                                                                                                  P: {
                                                                                                    M: {
                                                                                                      N: {
                                                                                                        me = e[Q + 320 >> 2], br = (C - me | 0) / 24 | 0, I = br + 1 | 0;
                                                                                                        O: {
                                                                                                          if (I >>> 0 >= 178956971) {
                                                                                                            e[5996] = 0, jo(142);
                                                                                                            break O;
                                                                                                          }
                                                                                                          if (ke = (ke - me | 0) / 24 | 0, Ar = ke << 1, ke = ke >>> 0 >= 89478485 ? 178956970 : I >>> 0 < Ar >>> 0 ? Ar : I, !ke) {
                                                                                                            Ar = 0;
                                                                                                            break M;
                                                                                                          }
                                                                                                          if (ke >>> 0 < 178956971)
                                                                                                            break N;
                                                                                                          e[5996] = 0, jo(35);
                                                                                                        }
                                                                                                        if (l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                                                          break e;
                                                                                                        y = gi() | 0;
                                                                                                        break t;
                                                                                                      }
                                                                                                      if (e[5996] = 0, Ar = no(3, No(ke, 24) | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                                                                        break P;
                                                                                                    }
                                                                                                    if (I = No(br, 24) + Ar | 0, e[I + 8 >> 2] = -1, e[I + 12 >> 2] = -1, e[I >> 2] = 9, e[I + 16 >> 2] = -1, e[I + 20 >> 2] = -1, br = I + 24 | 0, (C | 0) != (me | 0)) {
                                                                                                      for (; C = C - 24 | 0, Qr = e[C + 4 >> 2], I = I - 24 | 0, e[I >> 2] = e[C >> 2], e[I + 4 >> 2] = Qr, Qr = e[C + 20 >> 2], e[I + 16 >> 2] = e[C + 16 >> 2], e[I + 20 >> 2] = Qr, Qr = e[C + 12 >> 2], e[I + 8 >> 2] = e[C + 8 >> 2], e[I + 12 >> 2] = Qr, (C | 0) != (me | 0); )
                                                                                                        ;
                                                                                                      C = me;
                                                                                                    }
                                                                                                    if (e[Q + 328 >> 2] = No(ke, 24) + Ar, e[Q + 324 >> 2] = br, e[Q + 320 >> 2] = I, !C)
                                                                                                      break y;
                                                                                                    Tr(C);
                                                                                                    break y;
                                                                                                  }
                                                                                                  y = gi() | 0;
                                                                                                  break t;
                                                                                                case 19:
                                                                                                  if (C = e[Q + 324 >> 2], ke = e[Q + 328 >> 2], C >>> 0 < ke >>> 0) {
                                                                                                    e[C + 8 >> 2] = -1, e[C + 12 >> 2] = -1, e[C >> 2] = 10, e[C + 16 >> 2] = -1, e[C + 20 >> 2] = -1, e[Q + 324 >> 2] = C + 24;
                                                                                                    break y;
                                                                                                  }
                                                                                                  P: {
                                                                                                    M: {
                                                                                                      N: {
                                                                                                        me = e[Q + 320 >> 2], br = (C - me | 0) / 24 | 0, I = br + 1 | 0;
                                                                                                        O: {
                                                                                                          if (I >>> 0 >= 178956971) {
                                                                                                            e[5996] = 0, jo(142);
                                                                                                            break O;
                                                                                                          }
                                                                                                          if (ke = (ke - me | 0) / 24 | 0, Ar = ke << 1, ke = ke >>> 0 >= 89478485 ? 178956970 : I >>> 0 < Ar >>> 0 ? Ar : I, !ke) {
                                                                                                            Ar = 0;
                                                                                                            break M;
                                                                                                          }
                                                                                                          if (ke >>> 0 < 178956971)
                                                                                                            break N;
                                                                                                          e[5996] = 0, jo(35);
                                                                                                        }
                                                                                                        if (l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                                                          break e;
                                                                                                        y = gi() | 0;
                                                                                                        break t;
                                                                                                      }
                                                                                                      if (e[5996] = 0, Ar = no(3, No(ke, 24) | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                                                                        break P;
                                                                                                    }
                                                                                                    if (I = No(br, 24) + Ar | 0, e[I + 8 >> 2] = -1, e[I + 12 >> 2] = -1, e[I >> 2] = 10, e[I + 16 >> 2] = -1, e[I + 20 >> 2] = -1, br = I + 24 | 0, (C | 0) != (me | 0)) {
                                                                                                      for (; C = C - 24 | 0, Qr = e[C + 4 >> 2], I = I - 24 | 0, e[I >> 2] = e[C >> 2], e[I + 4 >> 2] = Qr, Qr = e[C + 20 >> 2], e[I + 16 >> 2] = e[C + 16 >> 2], e[I + 20 >> 2] = Qr, Qr = e[C + 12 >> 2], e[I + 8 >> 2] = e[C + 8 >> 2], e[I + 12 >> 2] = Qr, (C | 0) != (me | 0); )
                                                                                                        ;
                                                                                                      C = me;
                                                                                                    }
                                                                                                    if (e[Q + 328 >> 2] = No(ke, 24) + Ar, e[Q + 324 >> 2] = br, e[Q + 320 >> 2] = I, !C)
                                                                                                      break y;
                                                                                                    Tr(C);
                                                                                                    break y;
                                                                                                  }
                                                                                                  y = gi() | 0;
                                                                                                  break t;
                                                                                                case 11:
                                                                                                  break x;
                                                                                                default:
                                                                                                  break C;
                                                                                              }
                                                                                            if (e[5996] = 0, C = no(3, 104) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                                                              break B;
                                                                                            if (e[C >> 2] = 7e3, e[C + 4 >> 2] = 0, e[C + 8 >> 2] = 0, e[5996] = 0, me = Ko(143, C + 12 | 0, 0, 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1) {
                                                                                              y = gi() | 0, Tr(C);
                                                                                              break t;
                                                                                            }
                                                                                            e[Q + 244 >> 2] = C, e[Q + 240 >> 2] = me, I = e[Q + 312 >> 2];
                                                                                            x: {
                                                                                              if (I >>> 0 < qs[Q + 316 >> 2]) {
                                                                                                e[I + 4 >> 2] = C, e[I >> 2] = me, e[Q + 312 >> 2] = I + 8;
                                                                                                break x;
                                                                                              }
                                                                                              if (e[5996] = 0, Co(144, Q + 308 | 0, Q + 240 | 0), C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                                                break b;
                                                                                              if (C = e[Q + 244 >> 2], !C || (I = e[C + 4 >> 2], e[C + 4 >> 2] = I - 1, I))
                                                                                                break x;
                                                                                              Yn[e[e[C >> 2] + 8 >> 2]](C), Ls(C);
                                                                                            }
                                                                                            if (C = e[Q + 324 >> 2], ke = e[Q + 328 >> 2], C >>> 0 < ke >>> 0) {
                                                                                              e[C + 8 >> 2] = -1, e[C + 12 >> 2] = -1, e[C >> 2] = 18, e[C + 16 >> 2] = -1, e[C + 20 >> 2] = -1, e[Q + 324 >> 2] = C + 24;
                                                                                              break y;
                                                                                            }
                                                                                            x: {
                                                                                              P: {
                                                                                                me = e[Q + 320 >> 2], br = (C - me | 0) / 24 | 0, I = br + 1 | 0;
                                                                                                M: {
                                                                                                  if (I >>> 0 >= 178956971) {
                                                                                                    e[5996] = 0, jo(142);
                                                                                                    break M;
                                                                                                  }
                                                                                                  if (ke = (ke - me | 0) / 24 | 0, Ar = ke << 1, ke = ke >>> 0 >= 89478485 ? 178956970 : I >>> 0 < Ar >>> 0 ? Ar : I, !ke) {
                                                                                                    Ar = 0;
                                                                                                    break x;
                                                                                                  }
                                                                                                  if (ke >>> 0 < 178956971)
                                                                                                    break P;
                                                                                                  e[5996] = 0, jo(35);
                                                                                                }
                                                                                                if (l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                                                  break e;
                                                                                                y = gi() | 0;
                                                                                                break t;
                                                                                              }
                                                                                              if (e[5996] = 0, Ar = no(3, No(ke, 24) | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                                                                break D;
                                                                                            }
                                                                                            if (I = No(br, 24) + Ar | 0, e[I + 8 >> 2] = -1, e[I + 12 >> 2] = -1, e[I >> 2] = 18, e[I + 16 >> 2] = -1, e[I + 20 >> 2] = -1, br = I + 24 | 0, (C | 0) != (me | 0)) {
                                                                                              for (; C = C - 24 | 0, Qr = e[C + 4 >> 2], I = I - 24 | 0, e[I >> 2] = e[C >> 2], e[I + 4 >> 2] = Qr, Qr = e[C + 20 >> 2], e[I + 16 >> 2] = e[C + 16 >> 2], e[I + 20 >> 2] = Qr, Qr = e[C + 12 >> 2], e[I + 8 >> 2] = e[C + 8 >> 2], e[I + 12 >> 2] = Qr, (C | 0) != (me | 0); )
                                                                                                ;
                                                                                              C = me;
                                                                                            }
                                                                                            if (e[Q + 328 >> 2] = No(ke, 24) + Ar, e[Q + 324 >> 2] = br, e[Q + 320 >> 2] = I, !C)
                                                                                              break y;
                                                                                            Tr(C);
                                                                                          }
                                                                                          if (Ur = Ur + 1 | 0, (Ur | 0) == (S | 0))
                                                                                            break;
                                                                                        }
                                                                                        C = e[Q + 324 >> 2];
                                                                                        break m;
                                                                                      }
                                                                                      y = gi() | 0;
                                                                                      break t;
                                                                                    }
                                                                                    y = gi() | 0, l2(Q + 240 | 0);
                                                                                    break t;
                                                                                  }
                                                                                  y = gi() | 0;
                                                                                  break t;
                                                                                }
                                                                                e[l >> 2] = 0, e[l + 4 >> 2] = 0;
                                                                                break c;
                                                                              }
                                                                              if ((ke - 97 & 255) >>> 0 > 25) {
                                                                                S = -1;
                                                                                break m;
                                                                              }
                                                                              if (S = S + 1 | 0, !((I | 0) > (S | 0)))
                                                                                break;
                                                                            }
                                                                            S = -1;
                                                                          }
                                                                          m: {
                                                                            ke = e[Q + 328 >> 2];
                                                                            C: {
                                                                              if (ke >>> 0 > C >>> 0) {
                                                                                e[C + 8 >> 2] = -1, e[C + 12 >> 2] = -1, e[C >> 2] = 1, e[C + 16 >> 2] = -1, e[C + 20 >> 2] = -1, e[Q + 324 >> 2] = C + 24;
                                                                                break C;
                                                                              }
                                                                              D: {
                                                                                b: {
                                                                                  me = e[Q + 320 >> 2], Ur = (C - me | 0) / 24 | 0, I = Ur + 1 | 0;
                                                                                  B: {
                                                                                    if (I >>> 0 >= 178956971) {
                                                                                      e[5996] = 0, jo(142);
                                                                                      break B;
                                                                                    }
                                                                                    if (ke = (ke - me | 0) / 24 | 0, Ar = ke << 1, ke = ke >>> 0 >= 89478485 ? 178956970 : I >>> 0 < Ar >>> 0 ? Ar : I, !ke) {
                                                                                      Ar = 0;
                                                                                      break D;
                                                                                    }
                                                                                    if (ke >>> 0 < 178956971)
                                                                                      break b;
                                                                                    e[5996] = 0, jo(35);
                                                                                  }
                                                                                  if (l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                                    break e;
                                                                                  y = gi() | 0;
                                                                                  break t;
                                                                                }
                                                                                if (e[5996] = 0, Ar = no(3, No(ke, 24) | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                                                  break m;
                                                                              }
                                                                              if (I = No(Ur, 24) + Ar | 0, e[I + 8 >> 2] = -1, e[I + 12 >> 2] = -1, e[I >> 2] = 1, e[I + 16 >> 2] = -1, e[I + 20 >> 2] = -1, Ur = I + 24 | 0, (C | 0) != (me | 0)) {
                                                                                for (; C = C - 24 | 0, br = e[C + 4 >> 2], I = I - 24 | 0, e[I >> 2] = e[C >> 2], e[I + 4 >> 2] = br, br = e[C + 20 >> 2], e[I + 16 >> 2] = e[C + 16 >> 2], e[I + 20 >> 2] = br, br = e[C + 12 >> 2], e[I + 8 >> 2] = e[C + 8 >> 2], e[I + 12 >> 2] = br, (C | 0) != (me | 0); )
                                                                                  ;
                                                                                C = me;
                                                                              }
                                                                              if (e[Q + 328 >> 2] = No(ke, 24) + Ar, e[Q + 324 >> 2] = Ur, e[Q + 320 >> 2] = I, !C)
                                                                                break C;
                                                                              Tr(C);
                                                                            }
                                                                            C = S + 1 | 0, e[y + 4 >> 2] = e[y + 4 >> 2] - C, e[y >> 2] = C + e[y >> 2];
                                                                            break f;
                                                                          }
                                                                          y = gi() | 0;
                                                                          break t;
                                                                        case 21:
                                                                          m: {
                                                                            if (C = e[y + 4 >> 2], C && (I = e[y >> 2], Je[I | 0] == 41))
                                                                              break m;
                                                                            e[l >> 2] = 0, e[l + 4 >> 2] = 0;
                                                                            break c;
                                                                          }
                                                                          e[y + 4 >> 2] = C - 1, e[y >> 2] = I + 1;
                                                                          break f;
                                                                        case 20:
                                                                          m: {
                                                                            if (C = e[y + 4 >> 2], C && (I = e[y >> 2], Je[I | 0] == 44))
                                                                              break m;
                                                                            e[l >> 2] = 0, e[l + 4 >> 2] = 0;
                                                                            break c;
                                                                          }
                                                                          e[y + 4 >> 2] = C - 1, e[y >> 2] = I + 1;
                                                                          break f;
                                                                        case 19:
                                                                          if (me = e[y + 4 >> 2], !me) {
                                                                            e[l >> 2] = 0, e[l + 4 >> 2] = 0;
                                                                            break c;
                                                                          }
                                                                          m: {
                                                                            C: {
                                                                              D: {
                                                                                b: {
                                                                                  B: {
                                                                                    y:
                                                                                      switch (ke = e[y >> 2], Je[ke | 0] - 41 | 0) {
                                                                                        case 0:
                                                                                          break B;
                                                                                        case 3:
                                                                                          break y;
                                                                                        default:
                                                                                          break b;
                                                                                      }
                                                                                    e[y + 4 >> 2] = me - 1, e[y >> 2] = ke + 1, me = e[Q + 292 >> 2], ke = e[Q + 288 >> 2] + 1 | 0, me = ke ? me : me + 1 | 0;
                                                                                    y: {
                                                                                      x: {
                                                                                        Ar = e[Q + 328 >> 2];
                                                                                        P: {
                                                                                          if (Ar >>> 0 > C >>> 0) {
                                                                                            e[C >> 2] = 19, e[C + 8 >> 2] = ke, e[C + 12 >> 2] = me, S = e[Q + 300 >> 2], e[C + 16 >> 2] = e[Q + 296 >> 2], e[C + 20 >> 2] = S, e[Q + 324 >> 2] = I;
                                                                                            break P;
                                                                                          }
                                                                                          M: {
                                                                                            N: {
                                                                                              Ur = (C - S | 0) / 24 | 0, I = Ur + 1 | 0;
                                                                                              O: {
                                                                                                if (I >>> 0 >= 178956971) {
                                                                                                  e[5996] = 0, jo(142);
                                                                                                  break O;
                                                                                                }
                                                                                                if (Ar = (Ar - S | 0) / 24 | 0, br = Ar << 1, I = Ar >>> 0 >= 89478485 ? 178956970 : I >>> 0 < br >>> 0 ? br : I, !I) {
                                                                                                  Ar = 0;
                                                                                                  break M;
                                                                                                }
                                                                                                if (I >>> 0 < 178956971)
                                                                                                  break N;
                                                                                                e[5996] = 0, jo(35);
                                                                                              }
                                                                                              if (l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                                                break e;
                                                                                              y = gi() | 0;
                                                                                              break t;
                                                                                            }
                                                                                            if (e[5996] = 0, Ar = no(3, No(I, 24) | 0) | 0, br = e[5996], e[5996] = 0, (br | 0) == 1)
                                                                                              break x;
                                                                                          }
                                                                                          Ur = No(Ur, 24) + Ar | 0, e[Ur + 8 >> 2] = ke, e[Ur + 12 >> 2] = me, e[Ur >> 2] = 19, me = e[Q + 300 >> 2], e[Ur + 16 >> 2] = e[Q + 296 >> 2], e[Ur + 20 >> 2] = me, Ar = No(I, 24) + Ar | 0, I = Ur + 24 | 0;
                                                                                          M: {
                                                                                            if ((C | 0) == (S | 0)) {
                                                                                              e[Q + 328 >> 2] = Ar, e[Q + 324 >> 2] = I, e[Q + 320 >> 2] = Ur;
                                                                                              break M;
                                                                                            }
                                                                                            for (; C = C - 24 | 0, ke = e[C + 4 >> 2], Ur = Ur - 24 | 0, me = Ur, e[me >> 2] = e[C >> 2], e[me + 4 >> 2] = ke, me = e[C + 20 >> 2], e[Ur + 16 >> 2] = e[C + 16 >> 2], e[Ur + 20 >> 2] = me, me = e[C + 12 >> 2], e[Ur + 8 >> 2] = e[C + 8 >> 2], e[Ur + 12 >> 2] = me, (C | 0) != (S | 0); )
                                                                                              ;
                                                                                            if (e[Q + 328 >> 2] = Ar, e[Q + 324 >> 2] = I, e[Q + 320 >> 2] = Ur, !S)
                                                                                              break P;
                                                                                          }
                                                                                          Tr(S), Ar = e[Q + 328 >> 2], I = e[Q + 324 >> 2];
                                                                                        }
                                                                                        if (I >>> 0 < Ar >>> 0) {
                                                                                          e[I + 8 >> 2] = -1, e[I + 12 >> 2] = -1, e[I >> 2] = 0, e[I + 16 >> 2] = -1, e[I + 20 >> 2] = -1, e[Q + 324 >> 2] = I + 24;
                                                                                          break f;
                                                                                        }
                                                                                        P: {
                                                                                          M: {
                                                                                            S = e[Q + 320 >> 2], ke = (I - S | 0) / 24 | 0, C = ke + 1 | 0;
                                                                                            N: {
                                                                                              if (C >>> 0 >= 178956971) {
                                                                                                e[5996] = 0, jo(142);
                                                                                                break N;
                                                                                              }
                                                                                              if (me = (Ar - S | 0) / 24 | 0, Ar = me << 1, me = me >>> 0 >= 89478485 ? 178956970 : C >>> 0 < Ar >>> 0 ? Ar : C, !me) {
                                                                                                Ar = 0;
                                                                                                break P;
                                                                                              }
                                                                                              if (me >>> 0 < 178956971)
                                                                                                break M;
                                                                                              e[5996] = 0, jo(35);
                                                                                            }
                                                                                            if (l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                                              break e;
                                                                                            y = gi() | 0;
                                                                                            break t;
                                                                                          }
                                                                                          if (e[5996] = 0, Ar = no(3, No(me, 24) | 0) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                                            break y;
                                                                                        }
                                                                                        if (C = No(ke, 24) + Ar | 0, e[C + 8 >> 2] = -1, e[C + 12 >> 2] = -1, e[C >> 2] = 0, e[C + 16 >> 2] = -1, e[C + 20 >> 2] = -1, ke = C + 24 | 0, (I | 0) != (S | 0)) {
                                                                                          for (; I = I - 24 | 0, Ur = e[I + 4 >> 2], C = C - 24 | 0, e[C >> 2] = e[I >> 2], e[C + 4 >> 2] = Ur, Ur = e[I + 20 >> 2], e[C + 16 >> 2] = e[I + 16 >> 2], e[C + 20 >> 2] = Ur, Ur = e[I + 12 >> 2], e[C + 8 >> 2] = e[I + 8 >> 2], e[C + 12 >> 2] = Ur, (I | 0) != (S | 0); )
                                                                                            ;
                                                                                          I = S;
                                                                                        }
                                                                                        if (e[Q + 328 >> 2] = No(me, 24) + Ar, e[Q + 324 >> 2] = ke, e[Q + 320 >> 2] = C, !I)
                                                                                          break f;
                                                                                        Tr(I);
                                                                                        break f;
                                                                                      }
                                                                                      y = gi() | 0;
                                                                                      break t;
                                                                                    }
                                                                                    y = gi() | 0;
                                                                                    break t;
                                                                                  }
                                                                                  if (C = e[Q + 288 >> 2], I = e[Q + 292 >> 2], S = e[Q + 300 >> 2], C >>> 0 < qs[Q + 296 >> 2] & (I | 0) <= (S | 0) | (I | 0) < (S | 0)) {
                                                                                    e[l >> 2] = 0, e[l + 4 >> 2] = 0;
                                                                                    break c;
                                                                                  }
                                                                                  if (e[y + 4 >> 2] = me - 1, e[y >> 2] = ke + 1, e[Q + 340 >> 2] = 0, e[Q + 332 >> 2] = 0, e[Q + 336 >> 2] = 0, !C & (I | 0) <= 0 | (I | 0) < 0)
                                                                                    break C;
                                                                                  for (S = 0, I = 0, C = e[Q + 312 >> 2]; ; ) {
                                                                                    B: {
                                                                                      me = C - 8 | 0, ke = e[Q + 336 >> 2];
                                                                                      y: {
                                                                                        if (ke >>> 0 < qs[Q + 340 >> 2]) {
                                                                                          e[ke >> 2] = e[me >> 2], Ar = C - 4 | 0, e[ke + 4 >> 2] = e[Ar >> 2], e[me >> 2] = 0, e[Ar >> 2] = 0, e[Q + 336 >> 2] = ke + 8;
                                                                                          break y;
                                                                                        }
                                                                                        if (e[5996] = 0, Co(144, Q + 332 | 0, me | 0), C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                                          break B;
                                                                                        if (C = e[Q + 312 >> 2], me = e[C - 4 >> 2], !me || (ke = e[me + 4 >> 2], e[me + 4 >> 2] = ke - 1, ke))
                                                                                          break y;
                                                                                        Yn[e[e[me >> 2] + 8 >> 2]](me), Ls(me);
                                                                                      }
                                                                                      if (C = C - 8 | 0, e[Q + 312 >> 2] = C, S = S + 1 | 0, I = S ? I : I + 1 | 0, me = e[Q + 292 >> 2], qs[Q + 288 >> 2] > S >>> 0 & (me | 0) >= (I | 0) | (I | 0) < (me | 0))
                                                                                        continue;
                                                                                      break D;
                                                                                    }
                                                                                    break;
                                                                                  }
                                                                                  y = gi() | 0;
                                                                                  break m;
                                                                                }
                                                                                e[l >> 2] = 0, e[l + 4 >> 2] = 0;
                                                                                break c;
                                                                              }
                                                                              if (C = e[Q + 332 >> 2], S = e[Q + 336 >> 2], (C | 0) == (S | 0) || (I = S - 8 | 0, I >>> 0 <= C >>> 0))
                                                                                break C;
                                                                              for (; me = e[C >> 2], e[C >> 2] = e[I >> 2], e[I >> 2] = me, me = e[C + 4 >> 2], S = S - 4 | 0, e[C + 4 >> 2] = e[S >> 2], e[S >> 2] = me, S = I, C = C + 8 | 0, I = I - 8 | 0, C >>> 0 < I >>> 0; )
                                                                                ;
                                                                            }
                                                                            e[5996] = 0, S = no(3, 104) | 0, C = e[5996], e[5996] = 0;
                                                                            C: {
                                                                              D: {
                                                                                if ((C | 0) != 1) {
                                                                                  if (e[S >> 2] = 7e3, e[S + 4 >> 2] = 0, e[S + 8 >> 2] = 0, e[5996] = 0, e[Q + 240 >> 2] = e[Q + 332 >> 2], C = e[Q + 336 >> 2], I = e[Q + 340 >> 2], e[Q + 340 >> 2] = 0, e[Q + 244 >> 2] = C, e[Q + 248 >> 2] = I, e[Q + 332 >> 2] = 0, e[Q + 336 >> 2] = 0, ke = mf(64, S + 12 | 0, 24, Q + 240 | 0, e[Q + 296 >> 2]) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                                    break C;
                                                                                  if (I = e[Q + 240 >> 2], I) {
                                                                                    if (C = e[Q + 244 >> 2], (I | 0) != (C | 0)) {
                                                                                      for (; ; ) {
                                                                                        C = C - 8 | 0, me = e[C + 4 >> 2];
                                                                                        b: {
                                                                                          if (!me || (Ar = e[me + 4 >> 2], e[me + 4 >> 2] = Ar - 1, Ar))
                                                                                            break b;
                                                                                          Yn[e[e[me >> 2] + 8 >> 2]](me), Ls(me);
                                                                                        }
                                                                                        if ((I | 0) == (C | 0))
                                                                                          break;
                                                                                      }
                                                                                      I = e[Q + 240 >> 2];
                                                                                    }
                                                                                    Tr(I);
                                                                                  }
                                                                                  e[Q + 348 >> 2] = S, e[Q + 344 >> 2] = ke, C = e[Q + 312 >> 2];
                                                                                  b: {
                                                                                    if (C >>> 0 < qs[Q + 316 >> 2]) {
                                                                                      e[C + 4 >> 2] = S, e[C >> 2] = ke, e[Q + 312 >> 2] = C + 8;
                                                                                      break b;
                                                                                    }
                                                                                    if (e[5996] = 0, Co(144, Q + 308 | 0, Q + 344 | 0), C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                                      break D;
                                                                                    if (C = e[Q + 348 >> 2], !C || (I = e[C + 4 >> 2], e[C + 4 >> 2] = I - 1, I))
                                                                                      break b;
                                                                                    Yn[e[e[C >> 2] + 8 >> 2]](C), Ls(C);
                                                                                  }
                                                                                  if (I = e[Q + 332 >> 2], !I)
                                                                                    break f;
                                                                                  if (C = e[Q + 336 >> 2], (I | 0) != (C | 0)) {
                                                                                    for (; ; ) {
                                                                                      C = C - 8 | 0, S = e[C + 4 >> 2];
                                                                                      b: {
                                                                                        if (!S || (me = e[S + 4 >> 2], e[S + 4 >> 2] = me - 1, me))
                                                                                          break b;
                                                                                        Yn[e[e[S >> 2] + 8 >> 2]](S), Ls(S);
                                                                                      }
                                                                                      if ((I | 0) == (C | 0))
                                                                                        break;
                                                                                    }
                                                                                    I = e[Q + 332 >> 2];
                                                                                  }
                                                                                  Tr(I);
                                                                                  break f;
                                                                                }
                                                                                y = gi() | 0;
                                                                                break m;
                                                                              }
                                                                              y = gi() | 0, l2(Q + 344 | 0);
                                                                              break m;
                                                                            }
                                                                            y = gi() | 0, Za(Q + 240 | 0), Tr(S);
                                                                          }
                                                                          Za(Q + 332 | 0);
                                                                          break t;
                                                                        case 14:
                                                                          I = e[Q + 312 >> 2], C = I - 8 | 0, e[Q + 332 >> 2] = e[C >> 2], e[Q + 336 >> 2] = e[C + 4 >> 2], e[C >> 2] = 0, e[C + 4 >> 2] = 0, C = I - 16 | 0, e[Q + 344 >> 2] = e[C >> 2], e[Q + 348 >> 2] = e[C + 4 >> 2], e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[Q + 312 >> 2] = C, e[5996] = 0, S = Q + 240 | 0, ia(145, S | 0, I - 24 | 0, Q + 344 | 0, Q + 332 | 0), C = e[5996], e[5996] = 0;
                                                                          m: {
                                                                            C: {
                                                                              D: {
                                                                                if ((C | 0) != 1) {
                                                                                  if (e[5996] = 0, C = no(3, 104) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                                                    break D;
                                                                                  if (e[5996] = 0, I = Ko(146, C | 0, 23, S | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1) {
                                                                                    y = gi() | 0, Tr(C);
                                                                                    break C;
                                                                                  }
                                                                                  S = e[Q + 312 >> 2] - 8 | 0, e[S >> 2] = I + 12, C = e[S + 4 >> 2], e[S + 4 >> 2] = I;
                                                                                  b: {
                                                                                    if (!C || (I = e[C + 4 >> 2], e[C + 4 >> 2] = I - 1, I))
                                                                                      break b;
                                                                                    Yn[e[e[C >> 2] + 8 >> 2]](C), Ls(C);
                                                                                  }
                                                                                  if (S = e[Q + 240 >> 2], S) {
                                                                                    if (C = e[Q + 244 >> 2], I = S, (C | 0) != (I | 0)) {
                                                                                      for (; ; ) {
                                                                                        C = C - 8 | 0, I = e[C + 4 >> 2];
                                                                                        b: {
                                                                                          if (!I || (me = e[I + 4 >> 2], e[I + 4 >> 2] = me - 1, me))
                                                                                            break b;
                                                                                          Yn[e[e[I >> 2] + 8 >> 2]](I), Ls(I);
                                                                                        }
                                                                                        if ((C | 0) == (S | 0))
                                                                                          break;
                                                                                      }
                                                                                      I = e[Q + 240 >> 2];
                                                                                    }
                                                                                    e[Q + 244 >> 2] = S, Tr(I);
                                                                                  }
                                                                                  C = e[Q + 348 >> 2];
                                                                                  b: {
                                                                                    if (!C || (I = e[C + 4 >> 2], e[C + 4 >> 2] = I - 1, I))
                                                                                      break b;
                                                                                    Yn[e[e[C >> 2] + 8 >> 2]](C), Ls(C);
                                                                                  }
                                                                                  if (C = e[Q + 336 >> 2], !C || (I = e[C + 4 >> 2], e[C + 4 >> 2] = I - 1, I))
                                                                                    break f;
                                                                                  Yn[e[e[C >> 2] + 8 >> 2]](C), Ls(C);
                                                                                  break f;
                                                                                }
                                                                                y = gi() | 0;
                                                                                break m;
                                                                              }
                                                                              y = gi() | 0;
                                                                            }
                                                                            Za(Q + 240 | 0);
                                                                          }
                                                                          l2(Q + 344 | 0), l2(Q + 332 | 0);
                                                                          break t;
                                                                        case 18:
                                                                          Ur = 22;
                                                                          break l;
                                                                        case 17:
                                                                          Ur = 21;
                                                                          break l;
                                                                        case 16:
                                                                          Ur = 20;
                                                                          break l;
                                                                        case 15:
                                                                          Ur = 19;
                                                                          break l;
                                                                        case 1:
                                                                          break p;
                                                                        case 3:
                                                                          break d;
                                                                        case 2:
                                                                          break g;
                                                                        case 4:
                                                                          break v;
                                                                        case 5:
                                                                          break _;
                                                                        case 7:
                                                                          break R;
                                                                        case 8:
                                                                          break k;
                                                                        case 6:
                                                                          break S;
                                                                        case 9:
                                                                          break E;
                                                                        case 10:
                                                                          break w;
                                                                        case 11:
                                                                          break I;
                                                                        case 13:
                                                                          break l;
                                                                        case 12:
                                                                          break T;
                                                                        default:
                                                                          break f;
                                                                      }
                                                                    Ur = 17;
                                                                  }
                                                                  S = e[Q + 312 >> 2], I = S - 8 | 0, e[Q + 344 >> 2] = e[I >> 2], e[Q + 348 >> 2] = e[I + 4 >> 2], e[I >> 2] = 0, e[I + 4 >> 2] = 0, e[Q + 312 >> 2] = I, e[5996] = 0, e[Q + 340 >> 2] = 0, e[Q + 332 >> 2] = 0, e[Q + 336 >> 2] = 0, C = no(3, 16) | 0, me = e[5996], e[5996] = 0;
                                                                  l: {
                                                                    if ((me | 0) == 1) {
                                                                      y = gi() | 0;
                                                                      break l;
                                                                    }
                                                                    if (e[Q + 332 >> 2] = C, me = C + 16 | 0, e[Q + 340 >> 2] = me, S = S - 16 | 0, e[C >> 2] = e[S >> 2], e[C + 4 >> 2] = e[S + 4 >> 2], e[S >> 2] = 0, e[S + 4 >> 2] = 0, e[C + 8 >> 2] = e[Q + 344 >> 2], e[C + 12 >> 2] = e[Q + 348 >> 2], e[Q + 336 >> 2] = me, e[Q + 344 >> 2] = 0, e[Q + 348 >> 2] = 0, e[5996] = 0, S = no(3, 104) | 0, ke = e[5996], e[5996] = 0, (ke | 0) != 1) {
                                                                      if (e[S >> 2] = 7e3, e[S + 4 >> 2] = 0, e[S + 8 >> 2] = 0, e[Q + 244 >> 2] = me, e[Q + 240 >> 2] = C, e[Q + 332 >> 2] = 0, e[Q + 336 >> 2] = 0, e[5996] = 0, C = e[Q + 340 >> 2], e[Q + 340 >> 2] = 0, e[Q + 248 >> 2] = C, me = mf(64, S + 12 | 0, Ur | 0, Q + 240 | 0, 0) | 0, C = e[5996], e[5996] = 0, (C | 0) != 1) {
                                                                        if (Ur = e[Q + 240 >> 2], Ur) {
                                                                          if (C = e[Q + 244 >> 2], (Ur | 0) != (C | 0)) {
                                                                            for (; ; ) {
                                                                              C = C - 8 | 0, I = e[C + 4 >> 2];
                                                                              T: {
                                                                                if (!I || (ke = e[I + 4 >> 2], e[I + 4 >> 2] = ke - 1, ke))
                                                                                  break T;
                                                                                Yn[e[e[I >> 2] + 8 >> 2]](I), Ls(I);
                                                                              }
                                                                              if ((C | 0) == (Ur | 0))
                                                                                break;
                                                                            }
                                                                            Ur = e[Q + 240 >> 2], I = e[Q + 312 >> 2];
                                                                          }
                                                                          Tr(Ur);
                                                                        }
                                                                        I = I - 8 | 0, e[I >> 2] = me, C = e[I + 4 >> 2], e[I + 4 >> 2] = S;
                                                                        T: {
                                                                          if (!C || (I = e[C + 4 >> 2], e[C + 4 >> 2] = I - 1, I))
                                                                            break T;
                                                                          Yn[e[e[C >> 2] + 8 >> 2]](C), Ls(C);
                                                                        }
                                                                        if (I = e[Q + 332 >> 2], I) {
                                                                          if (C = e[Q + 336 >> 2], (I | 0) != (C | 0)) {
                                                                            for (; ; ) {
                                                                              C = C - 8 | 0, S = e[C + 4 >> 2];
                                                                              T: {
                                                                                if (!S || (me = e[S + 4 >> 2], e[S + 4 >> 2] = me - 1, me))
                                                                                  break T;
                                                                                Yn[e[e[S >> 2] + 8 >> 2]](S), Ls(S);
                                                                              }
                                                                              if ((I | 0) == (C | 0))
                                                                                break;
                                                                            }
                                                                            I = e[Q + 332 >> 2];
                                                                          }
                                                                          Tr(I);
                                                                        }
                                                                        if (C = e[Q + 348 >> 2], !C || (I = e[C + 4 >> 2], e[C + 4 >> 2] = I - 1, I))
                                                                          break f;
                                                                        Yn[e[e[C >> 2] + 8 >> 2]](C), Ls(C);
                                                                        break f;
                                                                      }
                                                                      y = gi() | 0, Za(Q + 240 | 0), Tr(S);
                                                                      break l;
                                                                    }
                                                                    y = gi() | 0;
                                                                  }
                                                                  Za(Q + 332 | 0), l2(Q + 344 | 0);
                                                                  break t;
                                                                }
                                                                I = e[Q + 312 >> 2], C = I - 8 | 0, e[Q + 332 >> 2] = e[C >> 2], e[Q + 336 >> 2] = e[C + 4 >> 2], e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[Q + 312 >> 2] = C, e[5996] = 0, C = no(3, 104) | 0, S = e[5996], e[5996] = 0;
                                                                I: {
                                                                  l: {
                                                                    T: {
                                                                      m: {
                                                                        C: {
                                                                          if ((S | 0) != 1) {
                                                                            if (e[C >> 2] = 7e3, e[C + 4 >> 2] = 0, e[C + 8 >> 2] = 0, e[5996] = 0, S = Ko(143, C + 12 | 0, 0, 0) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1) {
                                                                              y = gi() | 0, Tr(C);
                                                                              break I;
                                                                            }
                                                                            if (e[Q + 348 >> 2] = C, e[Q + 344 >> 2] = S, e[5996] = 0, S = Q + 240 | 0, ia(145, S | 0, I - 16 | 0, Q + 332 | 0, Q + 344 | 0), C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                              break C;
                                                                            if (e[5996] = 0, C = no(3, 104) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                                              break m;
                                                                            if (e[5996] = 0, I = Ko(146, C | 0, 23, S | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1) {
                                                                              y = gi() | 0, Tr(C);
                                                                              break T;
                                                                            }
                                                                            S = e[Q + 312 >> 2] - 8 | 0, e[S >> 2] = I + 12, C = e[S + 4 >> 2], e[S + 4 >> 2] = I;
                                                                            D: {
                                                                              if (!C || (I = e[C + 4 >> 2], e[C + 4 >> 2] = I - 1, I))
                                                                                break D;
                                                                              Yn[e[e[C >> 2] + 8 >> 2]](C), Ls(C);
                                                                            }
                                                                            if (S = e[Q + 240 >> 2], S) {
                                                                              if (C = e[Q + 244 >> 2], I = S, (C | 0) != (I | 0)) {
                                                                                for (; ; ) {
                                                                                  C = C - 8 | 0, I = e[C + 4 >> 2];
                                                                                  D: {
                                                                                    if (!I || (me = e[I + 4 >> 2], e[I + 4 >> 2] = me - 1, me))
                                                                                      break D;
                                                                                    Yn[e[e[I >> 2] + 8 >> 2]](I), Ls(I);
                                                                                  }
                                                                                  if ((C | 0) == (S | 0))
                                                                                    break;
                                                                                }
                                                                                I = e[Q + 240 >> 2];
                                                                              }
                                                                              e[Q + 244 >> 2] = S, Tr(I);
                                                                            }
                                                                            C = e[Q + 348 >> 2];
                                                                            D: {
                                                                              if (!C || (I = e[C + 4 >> 2], e[C + 4 >> 2] = I - 1, I))
                                                                                break D;
                                                                              Yn[e[e[C >> 2] + 8 >> 2]](C), Ls(C);
                                                                            }
                                                                            if (C = e[Q + 336 >> 2], !C || (I = e[C + 4 >> 2], e[C + 4 >> 2] = I - 1, I))
                                                                              break f;
                                                                            Yn[e[e[C >> 2] + 8 >> 2]](C), Ls(C);
                                                                            break f;
                                                                          }
                                                                          y = gi() | 0;
                                                                          break I;
                                                                        }
                                                                        y = gi() | 0;
                                                                        break l;
                                                                      }
                                                                      y = gi() | 0;
                                                                    }
                                                                    Za(Q + 240 | 0);
                                                                  }
                                                                  l2(Q + 344 | 0);
                                                                }
                                                                l2(Q + 332 | 0);
                                                                break t;
                                                              }
                                                              e[5996] = 0, I = e[Q + 312 >> 2], C = no(3, 104) | 0, S = e[5996], e[5996] = 0;
                                                              w: {
                                                                I: {
                                                                  if ((S | 0) != 1) {
                                                                    if (e[C >> 2] = 7e3, e[C + 4 >> 2] = 0, e[C + 8 >> 2] = 0, e[5996] = 0, S = Ko(143, C + 12 | 0, 1, 0) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1) {
                                                                      y = gi() | 0, Tr(C);
                                                                      break t;
                                                                    }
                                                                    if (e[Q + 336 >> 2] = C, e[Q + 332 >> 2] = S, e[Q + 248 >> 2] = 0, e[Q + 240 >> 2] = 0, e[Q + 244 >> 2] = 0, e[5996] = 0, C = no(3, 16) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1) {
                                                                      y = gi() | 0;
                                                                      break w;
                                                                    }
                                                                    if (e[Q + 240 >> 2] = C, me = C + 16 | 0, e[Q + 248 >> 2] = me, S = I - 8 | 0, e[C >> 2] = e[S >> 2], I = I - 4 | 0, e[C + 4 >> 2] = e[I >> 2], e[S >> 2] = 0, e[I >> 2] = 0, e[C + 8 >> 2] = e[Q + 332 >> 2], e[C + 12 >> 2] = e[Q + 336 >> 2], e[Q + 244 >> 2] = me, e[Q + 332 >> 2] = 0, e[Q + 336 >> 2] = 0, e[5996] = 0, C = no(3, 104) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                                      break I;
                                                                    if (e[5996] = 0, me = Ko(146, C | 0, 17, Q + 240 | 0) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1) {
                                                                      y = gi() | 0, Tr(C);
                                                                      break w;
                                                                    }
                                                                    e[S >> 2] = me + 12, C = e[I >> 2], e[I >> 2] = me;
                                                                    l: {
                                                                      if (!C || (I = e[C + 4 >> 2], e[C + 4 >> 2] = I - 1, I))
                                                                        break l;
                                                                      Yn[e[e[C >> 2] + 8 >> 2]](C), Ls(C);
                                                                    }
                                                                    if (S = e[Q + 240 >> 2], S) {
                                                                      if (C = e[Q + 244 >> 2], I = S, (C | 0) != (I | 0)) {
                                                                        for (; ; ) {
                                                                          C = C - 8 | 0, I = e[C + 4 >> 2];
                                                                          l: {
                                                                            if (!I || (me = e[I + 4 >> 2], e[I + 4 >> 2] = me - 1, me))
                                                                              break l;
                                                                            Yn[e[e[I >> 2] + 8 >> 2]](I), Ls(I);
                                                                          }
                                                                          if ((C | 0) == (S | 0))
                                                                            break;
                                                                        }
                                                                        I = e[Q + 240 >> 2];
                                                                      }
                                                                      e[Q + 244 >> 2] = S, Tr(I);
                                                                    }
                                                                    if (C = e[Q + 336 >> 2], !C || (I = e[C + 4 >> 2], e[C + 4 >> 2] = I - 1, I))
                                                                      break f;
                                                                    Yn[e[e[C >> 2] + 8 >> 2]](C), Ls(C);
                                                                    break f;
                                                                  }
                                                                  y = gi() | 0;
                                                                  break t;
                                                                }
                                                                y = gi() | 0;
                                                              }
                                                              Za(Q + 240 | 0), l2(Q + 332 | 0);
                                                              break t;
                                                            }
                                                            e[5996] = 0, I = e[Q + 312 >> 2], C = no(3, 104) | 0, S = e[5996], e[5996] = 0;
                                                            E: {
                                                              w: {
                                                                if ((S | 0) != 1) {
                                                                  if (e[C >> 2] = 7e3, e[C + 4 >> 2] = 0, e[C + 8 >> 2] = 0, e[5996] = 0, S = Ko(143, C + 12 | 0, 0, 0) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1) {
                                                                    y = gi() | 0, Tr(C);
                                                                    break t;
                                                                  }
                                                                  if (e[Q + 336 >> 2] = C, e[Q + 332 >> 2] = S, e[Q + 248 >> 2] = 0, e[Q + 240 >> 2] = 0, e[Q + 244 >> 2] = 0, e[5996] = 0, C = no(3, 16) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1) {
                                                                    y = gi() | 0;
                                                                    break E;
                                                                  }
                                                                  if (e[Q + 240 >> 2] = C, me = C + 16 | 0, e[Q + 248 >> 2] = me, S = I - 8 | 0, e[C >> 2] = e[S >> 2], I = I - 4 | 0, e[C + 4 >> 2] = e[I >> 2], e[S >> 2] = 0, e[I >> 2] = 0, e[C + 8 >> 2] = e[Q + 332 >> 2], e[C + 12 >> 2] = e[Q + 336 >> 2], e[Q + 244 >> 2] = me, e[Q + 332 >> 2] = 0, e[Q + 336 >> 2] = 0, e[5996] = 0, C = no(3, 104) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                                    break w;
                                                                  if (e[5996] = 0, me = Ko(146, C | 0, 22, Q + 240 | 0) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1) {
                                                                    y = gi() | 0, Tr(C);
                                                                    break E;
                                                                  }
                                                                  e[S >> 2] = me + 12, C = e[I >> 2], e[I >> 2] = me;
                                                                  I: {
                                                                    if (!C || (I = e[C + 4 >> 2], e[C + 4 >> 2] = I - 1, I))
                                                                      break I;
                                                                    Yn[e[e[C >> 2] + 8 >> 2]](C), Ls(C);
                                                                  }
                                                                  if (S = e[Q + 240 >> 2], S) {
                                                                    if (C = e[Q + 244 >> 2], I = S, (C | 0) != (I | 0)) {
                                                                      for (; ; ) {
                                                                        C = C - 8 | 0, I = e[C + 4 >> 2];
                                                                        I: {
                                                                          if (!I || (me = e[I + 4 >> 2], e[I + 4 >> 2] = me - 1, me))
                                                                            break I;
                                                                          Yn[e[e[I >> 2] + 8 >> 2]](I), Ls(I);
                                                                        }
                                                                        if ((C | 0) == (S | 0))
                                                                          break;
                                                                      }
                                                                      I = e[Q + 240 >> 2];
                                                                    }
                                                                    e[Q + 244 >> 2] = S, Tr(I);
                                                                  }
                                                                  if (C = e[Q + 336 >> 2], !C || (I = e[C + 4 >> 2], e[C + 4 >> 2] = I - 1, I))
                                                                    break f;
                                                                  Yn[e[e[C >> 2] + 8 >> 2]](C), Ls(C);
                                                                  break f;
                                                                }
                                                                y = gi() | 0;
                                                                break t;
                                                              }
                                                              y = gi() | 0;
                                                            }
                                                            Za(Q + 240 | 0), l2(Q + 332 | 0);
                                                            break t;
                                                          }
                                                          e[Q + 248 >> 2] = 0, e[Q + 240 >> 2] = 0, e[Q + 244 >> 2] = 0, e[5996] = 0, C = e[Q + 312 >> 2], I = no(3, 8) | 0, S = e[5996], e[5996] = 0;
                                                          S: {
                                                            if ((S | 0) != 1) {
                                                              if (e[Q + 240 >> 2] = I, S = I + 8 | 0, e[Q + 248 >> 2] = S, C = C - 8 | 0, e[I >> 2] = e[C >> 2], e[I + 4 >> 2] = e[C + 4 >> 2], e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[5996] = 0, e[Q + 244 >> 2] = S, I = no(3, 104) | 0, S = e[5996], e[5996] = 0, (S | 0) != 1) {
                                                                if (e[5996] = 0, S = Ko(146, I | 0, 14, Q + 240 | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1) {
                                                                  y = gi() | 0, Tr(I);
                                                                  break S;
                                                                }
                                                                e[C >> 2] = S + 12, I = e[C + 4 >> 2], e[C + 4 >> 2] = S;
                                                                E: {
                                                                  if (!I || (C = e[I + 4 >> 2], e[I + 4 >> 2] = C - 1, C))
                                                                    break E;
                                                                  Yn[e[e[I >> 2] + 8 >> 2]](I), Ls(I);
                                                                }
                                                                if (I = e[Q + 240 >> 2], !I)
                                                                  break f;
                                                                if (C = e[Q + 244 >> 2], (I | 0) != (C | 0)) {
                                                                  for (; ; ) {
                                                                    C = C - 8 | 0, S = e[C + 4 >> 2];
                                                                    E: {
                                                                      if (!S || (me = e[S + 4 >> 2], e[S + 4 >> 2] = me - 1, me))
                                                                        break E;
                                                                      Yn[e[e[S >> 2] + 8 >> 2]](S), Ls(S);
                                                                    }
                                                                    if ((I | 0) == (C | 0))
                                                                      break;
                                                                  }
                                                                  I = e[Q + 240 >> 2];
                                                                }
                                                                Tr(I);
                                                                break f;
                                                              }
                                                              y = gi() | 0;
                                                              break S;
                                                            }
                                                            y = gi() | 0;
                                                          }
                                                          Za(Q + 240 | 0);
                                                          break t;
                                                        }
                                                        e[Q + 248 >> 2] = 0, e[Q + 240 >> 2] = 0, e[Q + 244 >> 2] = 0, e[5996] = 0, C = e[Q + 312 >> 2], I = no(3, 8) | 0, S = e[5996], e[5996] = 0;
                                                        k: {
                                                          if ((S | 0) != 1) {
                                                            if (e[Q + 240 >> 2] = I, S = I + 8 | 0, e[Q + 248 >> 2] = S, C = C - 8 | 0, e[I >> 2] = e[C >> 2], e[I + 4 >> 2] = e[C + 4 >> 2], e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[5996] = 0, e[Q + 244 >> 2] = S, I = no(3, 104) | 0, S = e[5996], e[5996] = 0, (S | 0) != 1) {
                                                              if (e[5996] = 0, S = Ko(146, I | 0, 16, Q + 240 | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1) {
                                                                y = gi() | 0, Tr(I);
                                                                break k;
                                                              }
                                                              e[C >> 2] = S + 12, I = e[C + 4 >> 2], e[C + 4 >> 2] = S;
                                                              S: {
                                                                if (!I || (C = e[I + 4 >> 2], e[I + 4 >> 2] = C - 1, C))
                                                                  break S;
                                                                Yn[e[e[I >> 2] + 8 >> 2]](I), Ls(I);
                                                              }
                                                              if (I = e[Q + 240 >> 2], !I)
                                                                break f;
                                                              if (C = e[Q + 244 >> 2], (I | 0) != (C | 0)) {
                                                                for (; ; ) {
                                                                  C = C - 8 | 0, S = e[C + 4 >> 2];
                                                                  S: {
                                                                    if (!S || (me = e[S + 4 >> 2], e[S + 4 >> 2] = me - 1, me))
                                                                      break S;
                                                                    Yn[e[e[S >> 2] + 8 >> 2]](S), Ls(S);
                                                                  }
                                                                  if ((I | 0) == (C | 0))
                                                                    break;
                                                                }
                                                                I = e[Q + 240 >> 2];
                                                              }
                                                              Tr(I);
                                                              break f;
                                                            }
                                                            y = gi() | 0;
                                                            break k;
                                                          }
                                                          y = gi() | 0;
                                                        }
                                                        Za(Q + 240 | 0);
                                                        break t;
                                                      }
                                                      e[Q + 248 >> 2] = 0, e[Q + 240 >> 2] = 0, e[Q + 244 >> 2] = 0, e[5996] = 0, C = e[Q + 312 >> 2], I = no(3, 8) | 0, S = e[5996], e[5996] = 0;
                                                      R: {
                                                        if ((S | 0) != 1) {
                                                          if (e[Q + 240 >> 2] = I, S = I + 8 | 0, e[Q + 248 >> 2] = S, C = C - 8 | 0, e[I >> 2] = e[C >> 2], e[I + 4 >> 2] = e[C + 4 >> 2], e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[5996] = 0, e[Q + 244 >> 2] = S, I = no(3, 104) | 0, S = e[5996], e[5996] = 0, (S | 0) != 1) {
                                                            if (e[5996] = 0, S = Ko(146, I | 0, 15, Q + 240 | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1) {
                                                              y = gi() | 0, Tr(I);
                                                              break R;
                                                            }
                                                            e[C >> 2] = S + 12, I = e[C + 4 >> 2], e[C + 4 >> 2] = S;
                                                            k: {
                                                              if (!I || (C = e[I + 4 >> 2], e[I + 4 >> 2] = C - 1, C))
                                                                break k;
                                                              Yn[e[e[I >> 2] + 8 >> 2]](I), Ls(I);
                                                            }
                                                            if (I = e[Q + 240 >> 2], !I)
                                                              break f;
                                                            if (C = e[Q + 244 >> 2], (I | 0) != (C | 0)) {
                                                              for (; ; ) {
                                                                C = C - 8 | 0, S = e[C + 4 >> 2];
                                                                k: {
                                                                  if (!S || (me = e[S + 4 >> 2], e[S + 4 >> 2] = me - 1, me))
                                                                    break k;
                                                                  Yn[e[e[S >> 2] + 8 >> 2]](S), Ls(S);
                                                                }
                                                                if ((I | 0) == (C | 0))
                                                                  break;
                                                              }
                                                              I = e[Q + 240 >> 2];
                                                            }
                                                            Tr(I);
                                                            break f;
                                                          }
                                                          y = gi() | 0;
                                                          break R;
                                                        }
                                                        y = gi() | 0;
                                                      }
                                                      Za(Q + 240 | 0);
                                                      break t;
                                                    }
                                                    e[Q + 248 >> 2] = 0, e[Q + 240 >> 2] = 0, e[Q + 244 >> 2] = 0, e[5996] = 0, C = e[Q + 312 >> 2], I = no(3, 8) | 0, S = e[5996], e[5996] = 0;
                                                    _: {
                                                      if ((S | 0) != 1) {
                                                        if (e[Q + 240 >> 2] = I, S = I + 8 | 0, e[Q + 248 >> 2] = S, C = C - 8 | 0, e[I >> 2] = e[C >> 2], e[I + 4 >> 2] = e[C + 4 >> 2], e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[5996] = 0, e[Q + 244 >> 2] = S, I = no(3, 104) | 0, S = e[5996], e[5996] = 0, (S | 0) != 1) {
                                                          if (e[5996] = 0, S = Ko(146, I | 0, 13, Q + 240 | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1) {
                                                            y = gi() | 0, Tr(I);
                                                            break _;
                                                          }
                                                          e[C >> 2] = S + 12, I = e[C + 4 >> 2], e[C + 4 >> 2] = S;
                                                          R: {
                                                            if (!I || (C = e[I + 4 >> 2], e[I + 4 >> 2] = C - 1, C))
                                                              break R;
                                                            Yn[e[e[I >> 2] + 8 >> 2]](I), Ls(I);
                                                          }
                                                          if (I = e[Q + 240 >> 2], !I)
                                                            break f;
                                                          if (C = e[Q + 244 >> 2], (I | 0) != (C | 0)) {
                                                            for (; ; ) {
                                                              C = C - 8 | 0, S = e[C + 4 >> 2];
                                                              R: {
                                                                if (!S || (me = e[S + 4 >> 2], e[S + 4 >> 2] = me - 1, me))
                                                                  break R;
                                                                Yn[e[e[S >> 2] + 8 >> 2]](S), Ls(S);
                                                              }
                                                              if ((I | 0) == (C | 0))
                                                                break;
                                                            }
                                                            I = e[Q + 240 >> 2];
                                                          }
                                                          Tr(I);
                                                          break f;
                                                        }
                                                        y = gi() | 0;
                                                        break _;
                                                      }
                                                      y = gi() | 0;
                                                    }
                                                    Za(Q + 240 | 0);
                                                    break t;
                                                  }
                                                  e[Q + 248 >> 2] = 0, e[Q + 240 >> 2] = 0, e[Q + 244 >> 2] = 0, e[5996] = 0, C = e[Q + 312 >> 2], I = no(3, 8) | 0, S = e[5996], e[5996] = 0;
                                                  v: {
                                                    if ((S | 0) != 1) {
                                                      if (e[Q + 240 >> 2] = I, S = I + 8 | 0, e[Q + 248 >> 2] = S, C = C - 8 | 0, e[I >> 2] = e[C >> 2], e[I + 4 >> 2] = e[C + 4 >> 2], e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[5996] = 0, e[Q + 244 >> 2] = S, I = no(3, 104) | 0, S = e[5996], e[5996] = 0, (S | 0) != 1) {
                                                        if (e[5996] = 0, S = Ko(146, I | 0, 12, Q + 240 | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1) {
                                                          y = gi() | 0, Tr(I);
                                                          break v;
                                                        }
                                                        e[C >> 2] = S + 12, I = e[C + 4 >> 2], e[C + 4 >> 2] = S;
                                                        _: {
                                                          if (!I || (C = e[I + 4 >> 2], e[I + 4 >> 2] = C - 1, C))
                                                            break _;
                                                          Yn[e[e[I >> 2] + 8 >> 2]](I), Ls(I);
                                                        }
                                                        if (I = e[Q + 240 >> 2], !I)
                                                          break f;
                                                        if (C = e[Q + 244 >> 2], (I | 0) != (C | 0)) {
                                                          for (; ; ) {
                                                            C = C - 8 | 0, S = e[C + 4 >> 2];
                                                            _: {
                                                              if (!S || (me = e[S + 4 >> 2], e[S + 4 >> 2] = me - 1, me))
                                                                break _;
                                                              Yn[e[e[S >> 2] + 8 >> 2]](S), Ls(S);
                                                            }
                                                            if ((I | 0) == (C | 0))
                                                              break;
                                                          }
                                                          I = e[Q + 240 >> 2];
                                                        }
                                                        Tr(I);
                                                        break f;
                                                      }
                                                      y = gi() | 0;
                                                      break v;
                                                    }
                                                    y = gi() | 0;
                                                  }
                                                  Za(Q + 240 | 0);
                                                  break t;
                                                }
                                                e[Q + 248 >> 2] = 0, e[Q + 240 >> 2] = 0, e[Q + 244 >> 2] = 0, e[5996] = 0, C = e[Q + 312 >> 2], I = no(3, 8) | 0, S = e[5996], e[5996] = 0;
                                                g: {
                                                  if ((S | 0) != 1) {
                                                    if (e[Q + 240 >> 2] = I, S = I + 8 | 0, e[Q + 248 >> 2] = S, C = C - 8 | 0, e[I >> 2] = e[C >> 2], e[I + 4 >> 2] = e[C + 4 >> 2], e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[5996] = 0, e[Q + 244 >> 2] = S, I = no(3, 104) | 0, S = e[5996], e[5996] = 0, (S | 0) != 1) {
                                                      if (e[5996] = 0, S = Ko(146, I | 0, 11, Q + 240 | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1) {
                                                        y = gi() | 0, Tr(I);
                                                        break g;
                                                      }
                                                      e[C >> 2] = S + 12, I = e[C + 4 >> 2], e[C + 4 >> 2] = S;
                                                      v: {
                                                        if (!I || (C = e[I + 4 >> 2], e[I + 4 >> 2] = C - 1, C))
                                                          break v;
                                                        Yn[e[e[I >> 2] + 8 >> 2]](I), Ls(I);
                                                      }
                                                      if (I = e[Q + 240 >> 2], !I)
                                                        break f;
                                                      if (C = e[Q + 244 >> 2], (I | 0) != (C | 0)) {
                                                        for (; ; ) {
                                                          C = C - 8 | 0, S = e[C + 4 >> 2];
                                                          v: {
                                                            if (!S || (me = e[S + 4 >> 2], e[S + 4 >> 2] = me - 1, me))
                                                              break v;
                                                            Yn[e[e[S >> 2] + 8 >> 2]](S), Ls(S);
                                                          }
                                                          if ((I | 0) == (C | 0))
                                                            break;
                                                        }
                                                        I = e[Q + 240 >> 2];
                                                      }
                                                      Tr(I);
                                                      break f;
                                                    }
                                                    y = gi() | 0;
                                                    break g;
                                                  }
                                                  y = gi() | 0;
                                                }
                                                Za(Q + 240 | 0);
                                                break t;
                                              }
                                              e[Q + 248 >> 2] = 0, e[Q + 240 >> 2] = 0, e[Q + 244 >> 2] = 0, e[5996] = 0, C = e[Q + 312 >> 2], I = no(3, 8) | 0, S = e[5996], e[5996] = 0;
                                              d: {
                                                if ((S | 0) != 1) {
                                                  if (e[Q + 240 >> 2] = I, S = I + 8 | 0, e[Q + 248 >> 2] = S, C = C - 8 | 0, e[I >> 2] = e[C >> 2], e[I + 4 >> 2] = e[C + 4 >> 2], e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[5996] = 0, e[Q + 244 >> 2] = S, I = no(3, 104) | 0, S = e[5996], e[5996] = 0, (S | 0) != 1) {
                                                    if (e[5996] = 0, S = Ko(146, I | 0, 10, Q + 240 | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1) {
                                                      y = gi() | 0, Tr(I);
                                                      break d;
                                                    }
                                                    e[C >> 2] = S + 12, I = e[C + 4 >> 2], e[C + 4 >> 2] = S;
                                                    g: {
                                                      if (!I || (C = e[I + 4 >> 2], e[I + 4 >> 2] = C - 1, C))
                                                        break g;
                                                      Yn[e[e[I >> 2] + 8 >> 2]](I), Ls(I);
                                                    }
                                                    if (I = e[Q + 240 >> 2], !I)
                                                      break f;
                                                    if (C = e[Q + 244 >> 2], (I | 0) != (C | 0)) {
                                                      for (; ; ) {
                                                        C = C - 8 | 0, S = e[C + 4 >> 2];
                                                        g: {
                                                          if (!S || (me = e[S + 4 >> 2], e[S + 4 >> 2] = me - 1, me))
                                                            break g;
                                                          Yn[e[e[S >> 2] + 8 >> 2]](S), Ls(S);
                                                        }
                                                        if ((I | 0) == (C | 0))
                                                          break;
                                                      }
                                                      I = e[Q + 240 >> 2];
                                                    }
                                                    Tr(I);
                                                    break f;
                                                  }
                                                  y = gi() | 0;
                                                  break d;
                                                }
                                                y = gi() | 0;
                                              }
                                              Za(Q + 240 | 0);
                                              break t;
                                            }
                                            ea[Q + 240 >> 1] = 48, Se[Q + 251 | 0] = 1;
                                            p: {
                                              d: {
                                                g: {
                                                  v: {
                                                    if (C = e[y + 4 >> 2], !C) {
                                                      Se[Q + 251 | 0] = 3, Se[Q + 243 | 0] = 0, ea[Q + 240 >> 1] = Je[5279] | Je[5280] << 8, Se[Q + 242 | 0] = Je[5281];
                                                      break v;
                                                    }
                                                    if (I = e[y >> 2], Je[Q + 240 | 0] == Je[I | 0]) {
                                                      e[y + 4 >> 2] = C - 1, e[y >> 2] = I + 1, e[5996] = 0, C = no(3, 104) | 0, I = e[5996], e[5996] = 0;
                                                      _: {
                                                        if ((I | 0) != 1) {
                                                          if (e[C >> 2] = 7e3, e[C + 4 >> 2] = 0, e[C + 8 >> 2] = 0, e[5996] = 0, S = Ko(143, C + 12 | 0, 0, 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1) {
                                                            y = gi() | 0, Tr(C);
                                                            break t;
                                                          }
                                                          if (e[Q + 244 >> 2] = C, e[Q + 240 >> 2] = S, I = e[Q + 312 >> 2], I >>> 0 < qs[Q + 316 >> 2]) {
                                                            e[I + 4 >> 2] = C, e[I >> 2] = S, e[Q + 312 >> 2] = I + 8;
                                                            break f;
                                                          }
                                                          if (e[5996] = 0, Co(144, Q + 308 | 0, Q + 240 | 0), C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                            break _;
                                                          if (C = e[Q + 244 >> 2], !C || (I = e[C + 4 >> 2], e[C + 4 >> 2] = I - 1, I))
                                                            break f;
                                                          Yn[e[e[C >> 2] + 8 >> 2]](C), Ls(C);
                                                          break f;
                                                        }
                                                        y = gi() | 0;
                                                        break t;
                                                      }
                                                      y = gi() | 0, l2(Q + 240 | 0);
                                                      break t;
                                                    }
                                                    if (Se[Q + 251 | 0] = 1, ea[Q + 240 >> 1] = 49, I = e[y >> 2], Je[I | 0] == 49) {
                                                      e[y + 4 >> 2] = C - 1, e[y >> 2] = I + 1, e[5996] = 0, C = no(3, 104) | 0, I = e[5996], e[5996] = 0;
                                                      _: {
                                                        if ((I | 0) != 1) {
                                                          if (e[C >> 2] = 7e3, e[C + 4 >> 2] = 0, e[C + 8 >> 2] = 0, e[5996] = 0, S = Ko(143, C + 12 | 0, 1, 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1) {
                                                            y = gi() | 0, Tr(C);
                                                            break t;
                                                          }
                                                          if (e[Q + 244 >> 2] = C, e[Q + 240 >> 2] = S, I = e[Q + 312 >> 2], I >>> 0 < qs[Q + 316 >> 2]) {
                                                            e[I + 4 >> 2] = C, e[I >> 2] = S, e[Q + 312 >> 2] = I + 8;
                                                            break f;
                                                          }
                                                          if (e[5996] = 0, Co(144, Q + 308 | 0, Q + 240 | 0), C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                            break _;
                                                          if (C = e[Q + 244 >> 2], !C || (I = e[C + 4 >> 2], e[C + 4 >> 2] = I - 1, I))
                                                            break f;
                                                          Yn[e[e[C >> 2] + 8 >> 2]](C), Ls(C);
                                                          break f;
                                                        }
                                                        y = gi() | 0;
                                                        break t;
                                                      }
                                                      y = gi() | 0, l2(Q + 240 | 0);
                                                      break t;
                                                    }
                                                    if (Se[Q + 243 | 0] = 0, ea[Q + 240 >> 1] = Je[5279] | Je[5280] << 8, Se[Q + 242 | 0] = Je[5281], Se[Q + 251 | 0] = 3, C >>> 0 < 3)
                                                      break v;
                                                    _: {
                                                      R: {
                                                        k: {
                                                          S: {
                                                            E: {
                                                              w: {
                                                                I: {
                                                                  l: {
                                                                    T: {
                                                                      m: {
                                                                        C: {
                                                                          D: {
                                                                            b: {
                                                                              if (I = e[y >> 2], !(Je[Q + 240 | 0] != Je[I | 0] | Je[Q + 241 | 0] != Je[I + 1 | 0] | Je[Q + 242 | 0] != Je[I + 2 | 0])) {
                                                                                if (me = C - 3 | 0, e[y + 4 >> 2] = me, e[y >> 2] = I + 3, (me | 0) <= 0)
                                                                                  break _;
                                                                                for (S = e[y >> 2], I = e[y >> 2], C = 0; ; ) {
                                                                                  if (Je[I + C | 0] != 41) {
                                                                                    if (C = C + 1 | 0, (me | 0) != (C | 0))
                                                                                      continue;
                                                                                    break _;
                                                                                  }
                                                                                  break;
                                                                                }
                                                                                if (C - 18 >>> 0 < 4294967279)
                                                                                  break _;
                                                                                B: {
                                                                                  if (C >>> 0 <= 10) {
                                                                                    Se[Q + 251 | 0] = C, I = Q + 240 | 0;
                                                                                    break B;
                                                                                  }
                                                                                  if (e[5996] = 0, me = (C | 15) + 1 | 0, I = no(3, me | 0) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                                                                                    break b;
                                                                                  e[Q + 240 >> 2] = I, e[Q + 244 >> 2] = C, e[Q + 248 >> 2] = me | -2147483648;
                                                                                }
                                                                                if (Se[Sa(I, S, C) + C | 0] = 0, e[Q + 272 >> 2] = e[Q + 244 >> 2], I = Je[Q + 247 | 0] | Je[Q + 248 | 0] << 8 | (Je[Q + 249 | 0] << 16 | Je[Q + 250 | 0] << 24), Se[Q + 275 | 0] = I, Se[Q + 276 | 0] = I >>> 8, Se[Q + 277 | 0] = I >>> 16, Se[Q + 278 | 0] = I >>> 24, e[5996] = 0, S = e[Q + 240 >> 2], me = Se[Q + 251 | 0], e[Q + 340 >> 2] = 0, e[Q + 332 >> 2] = 0, e[Q + 336 >> 2] = 0, I = no(3, 12) | 0, ke = e[5996], e[5996] = 0, (ke | 0) != 1) {
                                                                                  e[Q + 332 >> 2] = I, ke = I + 12 | 0, e[Q + 340 >> 2] = ke, e[I >> 2] = S, e[I + 4 >> 2] = e[Q + 272 >> 2], S = Je[Q + 275 | 0] | Je[Q + 276 | 0] << 8 | (Je[Q + 277 | 0] << 16 | Je[Q + 278 | 0] << 24), Se[I + 7 | 0] = S, Se[I + 8 | 0] = S >>> 8, Se[I + 9 | 0] = S >>> 16, Se[I + 10 | 0] = S >>> 24, Se[I + 11 | 0] = me, Se[Q + 275 | 0] = 0, Se[Q + 276 | 0] = 0, Se[Q + 277 | 0] = 0, Se[Q + 278 | 0] = 0, e[Q + 272 >> 2] = 0, e[Q + 336 >> 2] = ke, e[5996] = 0, I = no(3, 104) | 0, S = e[5996], e[5996] = 0;
                                                                                  B: {
                                                                                    y: {
                                                                                      if ((S | 0) != 1) {
                                                                                        if (e[5996] = 0, S = Ko(147, I | 0, 2, Q + 332 | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1) {
                                                                                          y = gi() | 0, Tr(I);
                                                                                          break R;
                                                                                        }
                                                                                        if (e[Q + 248 >> 2] = 0, e[Q + 240 >> 2] = 0, e[Q + 244 >> 2] = 0, e[5996] = 0, e[Q + 268 >> 2] = S, me = S + 12 | 0, e[Q + 264 >> 2] = me, I = no(3, 8) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                                                                                          break D;
                                                                                        if (e[Q + 240 >> 2] = I, ke = I + 8 | 0, e[Q + 248 >> 2] = ke, e[I + 4 >> 2] = S, e[I >> 2] = me, e[Q + 244 >> 2] = ke, e[Q + 264 >> 2] = 0, e[Q + 268 >> 2] = 0, e[5996] = 0, S = no(3, 104) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                                                          break y;
                                                                                        if (e[5996] = 0, I = Ko(146, S | 0, 12, Q + 240 | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1) {
                                                                                          y = gi() | 0, Tr(S);
                                                                                          break k;
                                                                                        }
                                                                                        e[Q + 348 >> 2] = I, me = I + 12 | 0, e[Q + 344 >> 2] = me, S = e[Q + 312 >> 2];
                                                                                        x: {
                                                                                          if (S >>> 0 < qs[Q + 316 >> 2]) {
                                                                                            e[S + 4 >> 2] = I, e[S >> 2] = me, e[Q + 312 >> 2] = S + 8, e[Q + 344 >> 2] = 0, e[Q + 348 >> 2] = 0;
                                                                                            break x;
                                                                                          }
                                                                                          if (e[5996] = 0, Co(144, Q + 308 | 0, Q + 344 | 0), I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                                                            break B;
                                                                                          if (I = e[Q + 348 >> 2], !I || (S = e[I + 4 >> 2], e[I + 4 >> 2] = S - 1, S))
                                                                                            break x;
                                                                                          Yn[e[e[I >> 2] + 8 >> 2]](I), Ls(I);
                                                                                        }
                                                                                        if (me = e[Q + 240 >> 2], me) {
                                                                                          if (I = e[Q + 244 >> 2], S = me, (I | 0) != (S | 0)) {
                                                                                            for (; ; ) {
                                                                                              I = I - 8 | 0, S = e[I + 4 >> 2];
                                                                                              x: {
                                                                                                if (!S || (ke = e[S + 4 >> 2], e[S + 4 >> 2] = ke - 1, ke))
                                                                                                  break x;
                                                                                                Yn[e[e[S >> 2] + 8 >> 2]](S), Ls(S);
                                                                                              }
                                                                                              if ((I | 0) == (me | 0))
                                                                                                break;
                                                                                            }
                                                                                            S = e[Q + 240 >> 2];
                                                                                          }
                                                                                          e[Q + 244 >> 2] = me, Tr(S);
                                                                                        }
                                                                                        I = e[Q + 268 >> 2];
                                                                                        x: {
                                                                                          if (!I || (S = e[I + 4 >> 2], e[I + 4 >> 2] = S - 1, S))
                                                                                            break x;
                                                                                          Yn[e[e[I >> 2] + 8 >> 2]](I), Ls(I);
                                                                                        }
                                                                                        if (me = e[Q + 332 >> 2], me) {
                                                                                          if (S = e[Q + 336 >> 2], (me | 0) != (S | 0))
                                                                                            for (; I = S - 12 | 0, Se[S - 1 | 0] < 0 && Tr(e[I >> 2]), S = I, (I | 0) != (me | 0); )
                                                                                              ;
                                                                                          e[Q + 336 >> 2] = me, Tr(me);
                                                                                        }
                                                                                        C = C + 1 | 0, e[y + 4 >> 2] = e[y + 4 >> 2] - C, e[y >> 2] = C + e[y >> 2];
                                                                                        break f;
                                                                                      }
                                                                                      y = gi() | 0;
                                                                                      break R;
                                                                                    }
                                                                                    y = gi() | 0;
                                                                                    break k;
                                                                                  }
                                                                                  y = gi() | 0, l2(Q + 344 | 0);
                                                                                  break k;
                                                                                }
                                                                                if (y = gi() | 0, hf(Q + 332 | 0), (me | 0) >= 0)
                                                                                  break t;
                                                                                Tr(S);
                                                                                break t;
                                                                              }
                                                                              if (Se[Q + 244 | 0] = 0, e[Q + 240 >> 2] = 677931888, Se[Q + 251 | 0] = 4, C >>> 0 < 4)
                                                                                break g;
                                                                              if (I = e[y >> 2], !(Je[Q + 240 | 0] != Je[I | 0] | Je[Q + 241 | 0] != Je[I + 1 | 0] | (Je[Q + 242 | 0] != Je[I + 2 | 0] | Je[Q + 243 | 0] != Je[I + 3 | 0]))) {
                                                                                if (me = C - 4 | 0, e[y + 4 >> 2] = me, e[y >> 2] = I + 4, (me | 0) <= 0)
                                                                                  break S;
                                                                                for (S = e[y >> 2], I = e[y >> 2], C = 0; ; ) {
                                                                                  if (Je[I + C | 0] != 41) {
                                                                                    if (C = C + 1 | 0, (me | 0) != (C | 0))
                                                                                      continue;
                                                                                    break S;
                                                                                  }
                                                                                  break;
                                                                                }
                                                                                if (C - 18 >>> 0 < 4294967279)
                                                                                  break S;
                                                                                B: {
                                                                                  if (C >>> 0 <= 10) {
                                                                                    Se[Q + 251 | 0] = C, I = Q + 240 | 0;
                                                                                    break B;
                                                                                  }
                                                                                  if (e[5996] = 0, me = (C | 15) + 1 | 0, I = no(3, me | 0) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                                                                                    break C;
                                                                                  e[Q + 240 >> 2] = I, e[Q + 244 >> 2] = C, e[Q + 248 >> 2] = me | -2147483648;
                                                                                }
                                                                                if (Se[Sa(I, S, C) + C | 0] = 0, e[Q + 272 >> 2] = e[Q + 244 >> 2], I = Je[Q + 247 | 0] | Je[Q + 248 | 0] << 8 | (Je[Q + 249 | 0] << 16 | Je[Q + 250 | 0] << 24), Se[Q + 275 | 0] = I, Se[Q + 276 | 0] = I >>> 8, Se[Q + 277 | 0] = I >>> 16, Se[Q + 278 | 0] = I >>> 24, e[5996] = 0, S = e[Q + 240 >> 2], me = Se[Q + 251 | 0], e[Q + 340 >> 2] = 0, e[Q + 332 >> 2] = 0, e[Q + 336 >> 2] = 0, I = no(3, 12) | 0, ke = e[5996], e[5996] = 0, (ke | 0) != 1) {
                                                                                  e[Q + 332 >> 2] = I, ke = I + 12 | 0, e[Q + 340 >> 2] = ke, e[I >> 2] = S, e[I + 4 >> 2] = e[Q + 272 >> 2], S = Je[Q + 275 | 0] | Je[Q + 276 | 0] << 8 | (Je[Q + 277 | 0] << 16 | Je[Q + 278 | 0] << 24), Se[I + 7 | 0] = S, Se[I + 8 | 0] = S >>> 8, Se[I + 9 | 0] = S >>> 16, Se[I + 10 | 0] = S >>> 24, Se[I + 11 | 0] = me, Se[Q + 275 | 0] = 0, Se[Q + 276 | 0] = 0, Se[Q + 277 | 0] = 0, Se[Q + 278 | 0] = 0, e[Q + 272 >> 2] = 0, e[Q + 336 >> 2] = ke, e[5996] = 0, I = no(3, 104) | 0, S = e[5996], e[5996] = 0;
                                                                                  B: {
                                                                                    y: {
                                                                                      if ((S | 0) != 1) {
                                                                                        if (e[5996] = 0, S = Ko(147, I | 0, 3, Q + 332 | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1) {
                                                                                          y = gi() | 0, Tr(I);
                                                                                          break E;
                                                                                        }
                                                                                        if (e[Q + 248 >> 2] = 0, e[Q + 240 >> 2] = 0, e[Q + 244 >> 2] = 0, e[5996] = 0, e[Q + 268 >> 2] = S, me = S + 12 | 0, e[Q + 264 >> 2] = me, I = no(3, 8) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                                                                                          break m;
                                                                                        if (e[Q + 240 >> 2] = I, ke = I + 8 | 0, e[Q + 248 >> 2] = ke, e[I + 4 >> 2] = S, e[I >> 2] = me, e[Q + 244 >> 2] = ke, e[Q + 264 >> 2] = 0, e[Q + 268 >> 2] = 0, e[5996] = 0, S = no(3, 104) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                                                          break y;
                                                                                        if (e[5996] = 0, I = Ko(146, S | 0, 12, Q + 240 | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1) {
                                                                                          y = gi() | 0, Tr(S);
                                                                                          break w;
                                                                                        }
                                                                                        e[Q + 348 >> 2] = I, me = I + 12 | 0, e[Q + 344 >> 2] = me, S = e[Q + 312 >> 2];
                                                                                        x: {
                                                                                          if (S >>> 0 < qs[Q + 316 >> 2]) {
                                                                                            e[S + 4 >> 2] = I, e[S >> 2] = me, e[Q + 312 >> 2] = S + 8, e[Q + 344 >> 2] = 0, e[Q + 348 >> 2] = 0;
                                                                                            break x;
                                                                                          }
                                                                                          if (e[5996] = 0, Co(144, Q + 308 | 0, Q + 344 | 0), I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                                                            break B;
                                                                                          if (I = e[Q + 348 >> 2], !I || (S = e[I + 4 >> 2], e[I + 4 >> 2] = S - 1, S))
                                                                                            break x;
                                                                                          Yn[e[e[I >> 2] + 8 >> 2]](I), Ls(I);
                                                                                        }
                                                                                        if (me = e[Q + 240 >> 2], me) {
                                                                                          if (I = e[Q + 244 >> 2], S = me, (I | 0) != (S | 0)) {
                                                                                            for (; ; ) {
                                                                                              I = I - 8 | 0, S = e[I + 4 >> 2];
                                                                                              x: {
                                                                                                if (!S || (ke = e[S + 4 >> 2], e[S + 4 >> 2] = ke - 1, ke))
                                                                                                  break x;
                                                                                                Yn[e[e[S >> 2] + 8 >> 2]](S), Ls(S);
                                                                                              }
                                                                                              if ((I | 0) == (me | 0))
                                                                                                break;
                                                                                            }
                                                                                            S = e[Q + 240 >> 2];
                                                                                          }
                                                                                          e[Q + 244 >> 2] = me, Tr(S);
                                                                                        }
                                                                                        I = e[Q + 268 >> 2];
                                                                                        x: {
                                                                                          if (!I || (S = e[I + 4 >> 2], e[I + 4 >> 2] = S - 1, S))
                                                                                            break x;
                                                                                          Yn[e[e[I >> 2] + 8 >> 2]](I), Ls(I);
                                                                                        }
                                                                                        if (me = e[Q + 332 >> 2], me) {
                                                                                          if (S = e[Q + 336 >> 2], (me | 0) != (S | 0))
                                                                                            for (; I = S - 12 | 0, Se[S - 1 | 0] < 0 && Tr(e[I >> 2]), S = I, (I | 0) != (me | 0); )
                                                                                              ;
                                                                                          e[Q + 336 >> 2] = me, Tr(me);
                                                                                        }
                                                                                        C = C + 1 | 0, e[y + 4 >> 2] = e[y + 4 >> 2] - C, e[y >> 2] = C + e[y >> 2];
                                                                                        break f;
                                                                                      }
                                                                                      y = gi() | 0;
                                                                                      break E;
                                                                                    }
                                                                                    y = gi() | 0;
                                                                                    break w;
                                                                                  }
                                                                                  y = gi() | 0, l2(Q + 344 | 0);
                                                                                  break w;
                                                                                }
                                                                                if (y = gi() | 0, hf(Q + 332 | 0), (me | 0) >= 0)
                                                                                  break t;
                                                                                Tr(S);
                                                                                break t;
                                                                              }
                                                                              if (Se[Q + 245 | 0] = 0, Se[Q + 244 | 0] = Je[5287], e[Q + 240 >> 2] = Je[5283] | Je[5284] << 8 | (Je[5285] << 16 | Je[5286] << 24), Se[Q + 251 | 0] = 5, C >>> 0 < 5)
                                                                                break d;
                                                                              B: {
                                                                                if (I = e[y >> 2], Je[Q + 240 | 0] != Je[I | 0] | Je[Q + 241 | 0] != Je[I + 1 | 0] | (Je[Q + 242 | 0] != Je[I + 2 | 0] | Je[Q + 243 | 0] != Je[I + 3 | 0]) || Je[Q + 244 | 0] != Je[I + 4 | 0])
                                                                                  break B;
                                                                                if (me = C - 5 | 0, e[y + 4 >> 2] = me, e[y >> 2] = I + 5, (me | 0) <= 0)
                                                                                  break I;
                                                                                for (S = e[y >> 2], I = e[y >> 2], C = 0; ; ) {
                                                                                  if (Je[I + C | 0] != 41) {
                                                                                    if (C = C + 1 | 0, (me | 0) != (C | 0))
                                                                                      continue;
                                                                                    break I;
                                                                                  }
                                                                                  break;
                                                                                }
                                                                                if (C - 18 >>> 0 < 4294967279)
                                                                                  break I;
                                                                                y: {
                                                                                  if (C >>> 0 <= 10) {
                                                                                    Se[Q + 251 | 0] = C, I = Q + 240 | 0;
                                                                                    break y;
                                                                                  }
                                                                                  if (e[5996] = 0, me = (C | 15) + 1 | 0, I = no(3, me | 0) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                                                                                    break T;
                                                                                  e[Q + 240 >> 2] = I, e[Q + 244 >> 2] = C, e[Q + 248 >> 2] = me | -2147483648;
                                                                                }
                                                                                if (Se[Sa(I, S, C) + C | 0] = 0, e[Q + 344 >> 2] = e[Q + 244 >> 2], I = Je[Q + 247 | 0] | Je[Q + 248 | 0] << 8 | (Je[Q + 249 | 0] << 16 | Je[Q + 250 | 0] << 24), Se[Q + 347 | 0] = I, Se[Q + 348 | 0] = I >>> 8, Se[Q + 349 | 0] = I >>> 16, Se[Q + 350 | 0] = I >>> 24, e[5996] = 0, S = e[Q + 240 >> 2], me = Se[Q + 251 | 0], e[Q + 248 >> 2] = 0, e[Q + 240 >> 2] = 0, e[Q + 244 >> 2] = 0, I = no(3, 12) | 0, ke = e[5996], e[5996] = 0, (ke | 0) != 1) {
                                                                                  e[Q + 240 >> 2] = I, ke = I + 12 | 0, e[Q + 248 >> 2] = ke, e[I >> 2] = S, e[I + 4 >> 2] = e[Q + 344 >> 2], S = Je[Q + 347 | 0] | Je[Q + 348 | 0] << 8 | (Je[Q + 349 | 0] << 16 | Je[Q + 350 | 0] << 24), Se[I + 7 | 0] = S, Se[I + 8 | 0] = S >>> 8, Se[I + 9 | 0] = S >>> 16, Se[I + 10 | 0] = S >>> 24, Se[I + 11 | 0] = me, Se[Q + 347 | 0] = 0, Se[Q + 348 | 0] = 0, Se[Q + 349 | 0] = 0, Se[Q + 350 | 0] = 0, e[Q + 344 >> 2] = 0, e[Q + 244 >> 2] = ke, e[5996] = 0, S = no(3, 104) | 0, I = e[5996], e[5996] = 0;
                                                                                  y: {
                                                                                    x: {
                                                                                      if ((I | 0) != 1) {
                                                                                        if (e[5996] = 0, I = Ko(147, S | 0, 2, Q + 240 | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1) {
                                                                                          y = gi() | 0, Tr(S);
                                                                                          break y;
                                                                                        }
                                                                                        e[Q + 336 >> 2] = I, me = I + 12 | 0, e[Q + 332 >> 2] = me, S = e[Q + 312 >> 2];
                                                                                        P: {
                                                                                          if (S >>> 0 < qs[Q + 316 >> 2]) {
                                                                                            e[S + 4 >> 2] = I, e[S >> 2] = me, e[Q + 312 >> 2] = S + 8, e[Q + 332 >> 2] = 0, e[Q + 336 >> 2] = 0;
                                                                                            break P;
                                                                                          }
                                                                                          if (e[5996] = 0, Co(144, Q + 308 | 0, Q + 332 | 0), I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                                                            break x;
                                                                                          if (I = e[Q + 336 >> 2], !I || (S = e[I + 4 >> 2], e[I + 4 >> 2] = S - 1, S))
                                                                                            break P;
                                                                                          Yn[e[e[I >> 2] + 8 >> 2]](I), Ls(I);
                                                                                        }
                                                                                        if (me = e[Q + 240 >> 2], me) {
                                                                                          if (S = e[Q + 244 >> 2], (me | 0) != (S | 0))
                                                                                            for (; I = S - 12 | 0, Se[S - 1 | 0] < 0 && Tr(e[I >> 2]), S = I, (I | 0) != (me | 0); )
                                                                                              ;
                                                                                          e[Q + 244 >> 2] = me, Tr(me);
                                                                                        }
                                                                                        C = C + 1 | 0, e[y + 4 >> 2] = e[y + 4 >> 2] - C, e[y >> 2] = C + e[y >> 2];
                                                                                        break f;
                                                                                      }
                                                                                      y = gi() | 0;
                                                                                      break y;
                                                                                    }
                                                                                    y = gi() | 0, l2(Q + 332 | 0);
                                                                                  }
                                                                                  hf(Q + 240 | 0);
                                                                                  break t;
                                                                                }
                                                                                if (y = gi() | 0, hf(Q + 240 | 0), (me | 0) >= 0)
                                                                                  break t;
                                                                                Tr(S);
                                                                                break t;
                                                                              }
                                                                              if (Se[Q + 245 | 0] = 0, Se[Q + 244 | 0] = Je[5319], Se[Q + 251 | 0] = 5, S = Je[5315] | Je[5316] << 8 | (Je[5317] << 16 | Je[5318] << 24), e[Q + 240 >> 2] = S, I = e[y >> 2], Je[I | 0] != (S & 255) | Je[Q + 241 | 0] != Je[I + 1 | 0] | (Je[Q + 242 | 0] != Je[I + 2 | 0] | Je[Q + 243 | 0] != Je[I + 3 | 0]) || Je[Q + 244 | 0] != Je[I + 4 | 0])
                                                                                break p;
                                                                              if (e[y + 4 >> 2] = C - 5, e[y >> 2] = I + 5, C = e[y >> 2], I = e[y + 4 >> 2], e[5996] = 0, S = Q + 240 | 0, hs(148, S | 0, C | 0, I | 0), C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                                break l;
                                                                              B: {
                                                                                y: {
                                                                                  x: {
                                                                                    P: {
                                                                                      M: {
                                                                                        if (Je[Q + 256 | 0]) {
                                                                                          if (e[5996] = 0, C = Q + 332 | 0, Co(149, C | 0, S | 0), I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                                                            break M;
                                                                                          if (e[5996] = 0, I = Q + 344 | 0, Ms(150, I | 0, 3, C | 0), S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                            break P;
                                                                                          if (e[5996] = 0, Co(151, Q + 308 | 0, I | 0), S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                            break x;
                                                                                          if (l2(I), hf(C), C = e[Q + 252 >> 2] + 1 | 0, e[y + 4 >> 2] = e[y + 4 >> 2] - C, e[y >> 2] = C + e[y >> 2], !Je[Q + 256 | 0] | Se[Q + 251 | 0] >= 0)
                                                                                            break f;
                                                                                          Tr(e[Q + 240 >> 2]);
                                                                                          break f;
                                                                                        }
                                                                                        e[l >> 2] = 0, e[l + 4 >> 2] = 0;
                                                                                        break c;
                                                                                      }
                                                                                      y = gi() | 0;
                                                                                      break B;
                                                                                    }
                                                                                    y = gi() | 0;
                                                                                    break y;
                                                                                  }
                                                                                  y = gi() | 0, l2(Q + 344 | 0);
                                                                                }
                                                                                hf(Q + 332 | 0);
                                                                              }
                                                                              if (!Je[Q + 256 | 0] | Se[Q + 251 | 0] >= 0)
                                                                                break t;
                                                                              Tr(e[Q + 240 >> 2]);
                                                                              break t;
                                                                            }
                                                                            y = gi() | 0;
                                                                            break t;
                                                                          }
                                                                          y = gi() | 0;
                                                                          break k;
                                                                        }
                                                                        y = gi() | 0;
                                                                        break t;
                                                                      }
                                                                      y = gi() | 0;
                                                                      break w;
                                                                    }
                                                                    y = gi() | 0;
                                                                    break t;
                                                                  }
                                                                  y = gi() | 0;
                                                                  break t;
                                                                }
                                                                e[l >> 2] = 0, e[l + 4 >> 2] = 0;
                                                                break c;
                                                              }
                                                              Za(Q + 240 | 0), l2(Q + 264 | 0);
                                                            }
                                                            hf(Q + 332 | 0);
                                                            break t;
                                                          }
                                                          e[l >> 2] = 0, e[l + 4 >> 2] = 0;
                                                          break c;
                                                        }
                                                        Za(Q + 240 | 0), l2(Q + 264 | 0);
                                                      }
                                                      hf(Q + 332 | 0);
                                                      break t;
                                                    }
                                                    e[l >> 2] = 0, e[l + 4 >> 2] = 0;
                                                    break c;
                                                  }
                                                  Se[Q + 244 | 0] = 0, e[Q + 240 >> 2] = 677931888, Se[Q + 251 | 0] = 4;
                                                }
                                                Se[Q + 245 | 0] = 0, Se[Q + 244 | 0] = Je[5287], Se[Q + 251 | 0] = 5, e[Q + 240 >> 2] = Je[5283] | Je[5284] << 8 | (Je[5285] << 16 | Je[5286] << 24);
                                              }
                                              Se[Q + 245 | 0] = 0, Se[Q + 244 | 0] = Je[5319], Se[Q + 251 | 0] = 5, e[Q + 240 >> 2] = Je[5315] | Je[5316] << 8 | (Je[5317] << 16 | Je[5318] << 24);
                                            }
                                            e[5996] = 0, C = wn(30, Q + 228 | 0, 5355) | 0, I = e[5996], e[5996] = 0;
                                            p: {
                                              d: {
                                                g: {
                                                  if ((I | 0) != 1) {
                                                    if (I = Uf(C, y), Se[Q + 239 | 0] < 0 && Tr(e[C >> 2]), !I)
                                                      break p;
                                                    if (C = e[y >> 2], I = e[y + 4 >> 2], e[5996] = 0, i1(Q + 240 | 0, C, I, 32), C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                      break g;
                                                    if (Je[Q + 256 | 0])
                                                      break d;
                                                    e[l >> 2] = 0, e[l + 4 >> 2] = 0;
                                                    break c;
                                                  }
                                                  y = gi() | 0;
                                                  break t;
                                                }
                                                y = gi() | 0;
                                                break t;
                                              }
                                              e[5996] = 0, C = Q + 332 | 0, Ms(153, C | 0, 6, Q + 240 | 0), I = e[5996], e[5996] = 0;
                                              d: {
                                                g: {
                                                  if ((I | 0) != 1) {
                                                    if (e[5996] = 0, Co(151, Q + 308 | 0, C | 0), I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                      break g;
                                                    if (l2(C), C = e[Q + 252 >> 2] + 1 | 0, e[y + 4 >> 2] = e[y + 4 >> 2] - C, e[y >> 2] = C + e[y >> 2], !Je[Q + 256 | 0] || (C = e[Q + 240 >> 2], !C))
                                                      break f;
                                                    Tr(C);
                                                    break f;
                                                  }
                                                  y = gi() | 0;
                                                  break d;
                                                }
                                                y = gi() | 0, l2(Q + 332 | 0);
                                              }
                                              if (!Je[Q + 256 | 0] || (l = e[Q + 240 >> 2], !l))
                                                break t;
                                              Tr(l);
                                              break t;
                                            }
                                            e[5996] = 0, C = wn(30, Q + 216 | 0, 5372) | 0, I = e[5996], e[5996] = 0;
                                            p: {
                                              d: {
                                                g: {
                                                  if ((I | 0) != 1) {
                                                    if (I = Uf(C, y), Se[Q + 227 | 0] < 0 && Tr(e[C >> 2]), !I)
                                                      break p;
                                                    if (C = e[y >> 2], I = e[y + 4 >> 2], e[5996] = 0, i1(Q + 240 | 0, C, I, 20), C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                      break g;
                                                    if (Je[Q + 256 | 0])
                                                      break d;
                                                    e[l >> 2] = 0, e[l + 4 >> 2] = 0;
                                                    break c;
                                                  }
                                                  y = gi() | 0;
                                                  break t;
                                                }
                                                y = gi() | 0;
                                                break t;
                                              }
                                              e[5996] = 0, C = Q + 332 | 0, Ms(153, C | 0, 8, Q + 240 | 0), I = e[5996], e[5996] = 0;
                                              d: {
                                                g: {
                                                  if ((I | 0) != 1) {
                                                    if (e[5996] = 0, Co(151, Q + 308 | 0, C | 0), I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                      break g;
                                                    if (l2(C), C = e[Q + 252 >> 2] + 1 | 0, e[y + 4 >> 2] = e[y + 4 >> 2] - C, e[y >> 2] = C + e[y >> 2], !Je[Q + 256 | 0] || (C = e[Q + 240 >> 2], !C))
                                                      break f;
                                                    Tr(C);
                                                    break f;
                                                  }
                                                  y = gi() | 0;
                                                  break d;
                                                }
                                                y = gi() | 0, l2(Q + 332 | 0);
                                              }
                                              if (!Je[Q + 256 | 0] || (l = e[Q + 240 >> 2], !l))
                                                break t;
                                              Tr(l);
                                              break t;
                                            }
                                            e[5996] = 0, C = wn(30, Q + 204 | 0, 5346) | 0, I = e[5996], e[5996] = 0;
                                            p: {
                                              d: {
                                                g: {
                                                  if ((I | 0) != 1) {
                                                    if (I = Uf(C, y), Se[Q + 215 | 0] < 0 && Tr(e[C >> 2]), !I)
                                                      break p;
                                                    if (C = e[y >> 2], I = e[y + 4 >> 2], e[5996] = 0, i1(Q + 240 | 0, C, I, 32), C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                      break g;
                                                    if (Je[Q + 256 | 0])
                                                      break d;
                                                    e[l >> 2] = 0, e[l + 4 >> 2] = 0;
                                                    break c;
                                                  }
                                                  y = gi() | 0;
                                                  break t;
                                                }
                                                y = gi() | 0;
                                                break t;
                                              }
                                              e[5996] = 0, C = Q + 332 | 0, Ms(153, C | 0, 7, Q + 240 | 0), I = e[5996], e[5996] = 0;
                                              d: {
                                                g: {
                                                  if ((I | 0) != 1) {
                                                    if (e[5996] = 0, Co(151, Q + 308 | 0, C | 0), I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                      break g;
                                                    if (l2(C), C = e[Q + 252 >> 2] + 1 | 0, e[y + 4 >> 2] = e[y + 4 >> 2] - C, e[y >> 2] = C + e[y >> 2], !Je[Q + 256 | 0] || (C = e[Q + 240 >> 2], !C))
                                                      break f;
                                                    Tr(C);
                                                    break f;
                                                  }
                                                  y = gi() | 0;
                                                  break d;
                                                }
                                                y = gi() | 0, l2(Q + 332 | 0);
                                              }
                                              if (!Je[Q + 256 | 0] || (l = e[Q + 240 >> 2], !l))
                                                break t;
                                              Tr(l);
                                              break t;
                                            }
                                            e[5996] = 0, C = wn(30, Q + 192 | 0, 5363) | 0, I = e[5996], e[5996] = 0;
                                            p: {
                                              d: {
                                                g: {
                                                  if ((I | 0) != 1) {
                                                    if (I = Uf(C, y), Se[Q + 203 | 0] < 0 && Tr(e[C >> 2]), !I)
                                                      break p;
                                                    if (C = e[y >> 2], I = e[y + 4 >> 2], e[5996] = 0, i1(Q + 240 | 0, C, I, 20), C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                      break g;
                                                    if (Je[Q + 256 | 0])
                                                      break d;
                                                    e[l >> 2] = 0, e[l + 4 >> 2] = 0;
                                                    break c;
                                                  }
                                                  y = gi() | 0;
                                                  break t;
                                                }
                                                y = gi() | 0;
                                                break t;
                                              }
                                              e[5996] = 0, C = Q + 332 | 0, Ms(153, C | 0, 9, Q + 240 | 0), I = e[5996], e[5996] = 0;
                                              d: {
                                                g: {
                                                  if ((I | 0) != 1) {
                                                    if (e[5996] = 0, Co(151, Q + 308 | 0, C | 0), I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                      break g;
                                                    if (l2(C), C = e[Q + 252 >> 2] + 1 | 0, e[y + 4 >> 2] = e[y + 4 >> 2] - C, e[y >> 2] = C + e[y >> 2], !Je[Q + 256 | 0] || (C = e[Q + 240 >> 2], !C))
                                                      break f;
                                                    Tr(C);
                                                    break f;
                                                  }
                                                  y = gi() | 0;
                                                  break d;
                                                }
                                                y = gi() | 0, l2(Q + 332 | 0);
                                              }
                                              if (!Je[Q + 256 | 0] || (l = e[Q + 240 >> 2], !l))
                                                break t;
                                              Tr(l);
                                              break t;
                                            }
                                            e[5996] = 0, C = wn(30, Q + 180 | 0, 5258) | 0, I = e[5996], e[5996] = 0;
                                            p: {
                                              d: {
                                                g: {
                                                  v: {
                                                    _: {
                                                      if ((I | 0) != 1) {
                                                        if (I = Uf(C, y), Se[Q + 191 | 0] < 0 && Tr(e[C >> 2]), !I)
                                                          break v;
                                                        S = e[y + 4 >> 2];
                                                        R: {
                                                          if ((S | 0) <= 0)
                                                            break R;
                                                          for (I = e[y >> 2], C = 0; ; ) {
                                                            if (me = I + C | 0, Je[me | 0] != 41) {
                                                              if (C = C + 1 | 0, (S | 0) != (C | 0))
                                                                continue;
                                                              break R;
                                                            }
                                                            break;
                                                          }
                                                          if (C)
                                                            break _;
                                                        }
                                                        e[l >> 2] = 0, e[l + 4 >> 2] = 0;
                                                        break c;
                                                      }
                                                      y = gi() | 0;
                                                      break t;
                                                    }
                                                    if (e[5996] = 0, I = Ko(154, Q + 168 | 0, I | 0, me | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                      break d;
                                                    if (S = Ea(I, Q + 240 | 0), Se[Q + 179 | 0] < 0 && Tr(e[I >> 2]), !S || (S = e[Q + 244 >> 2], me = S, I = e[Q + 240 >> 2], ke = I - -2147483648 | 0, S = S - (I >>> 0 < 2147483648) | 0, (S | 0) == -1 & ke >>> 0 < 2147483649 | (S | 0) != -1))
                                                      break g;
                                                    e[5996] = 0, S = Q + 332 | 0, Bp(S, 5, I, me), I = e[5996], e[5996] = 0;
                                                    _: {
                                                      if ((I | 0) != 1) {
                                                        if (e[5996] = 0, Co(151, Q + 308 | 0, S | 0), I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                          break _;
                                                        l2(S), C = C + 1 | 0, e[y + 4 >> 2] = e[y + 4 >> 2] - C, e[y >> 2] = C + e[y >> 2];
                                                        break f;
                                                      }
                                                      y = gi() | 0;
                                                      break t;
                                                    }
                                                    y = gi() | 0, l2(Q + 332 | 0);
                                                    break t;
                                                  }
                                                  e[5996] = 0, C = wn(30, Q + 156 | 0, 5265) | 0, I = e[5996], e[5996] = 0;
                                                  v: {
                                                    _: {
                                                      R: {
                                                        k: {
                                                          if ((I | 0) != 1) {
                                                            if (I = Uf(C, y), Se[Q + 167 | 0] < 0 && Tr(e[C >> 2]), !I)
                                                              break R;
                                                            S = e[y + 4 >> 2];
                                                            S: {
                                                              if ((S | 0) <= 0)
                                                                break S;
                                                              for (I = e[y >> 2], C = 0; ; ) {
                                                                if (me = I + C | 0, Je[me | 0] != 41) {
                                                                  if (C = C + 1 | 0, (S | 0) != (C | 0))
                                                                    continue;
                                                                  break S;
                                                                }
                                                                break;
                                                              }
                                                              if (C)
                                                                break k;
                                                            }
                                                            e[l >> 2] = 0, e[l + 4 >> 2] = 0;
                                                            break c;
                                                          }
                                                          y = gi() | 0;
                                                          break t;
                                                        }
                                                        if (e[5996] = 0, I = Ko(154, Q + 144 | 0, I | 0, me | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                          break v;
                                                        if (S = Ea(I, Q + 240 | 0), Se[Q + 155 | 0] < 0 && Tr(e[I >> 2]), !S || (S = e[Q + 244 >> 2], me = S, I = e[Q + 240 >> 2], ke = I - -2147483648 | 0, S = S - (I >>> 0 < 2147483648) | 0, (S | 0) == -1 & ke >>> 0 < 2147483649 | (S | 0) != -1))
                                                          break _;
                                                        e[5996] = 0, S = Q + 332 | 0, Bp(S, 4, I, me), I = e[5996], e[5996] = 0;
                                                        k: {
                                                          if ((I | 0) != 1) {
                                                            if (e[5996] = 0, Co(151, Q + 308 | 0, S | 0), I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                              break k;
                                                            l2(S), C = C + 1 | 0, e[y + 4 >> 2] = e[y + 4 >> 2] - C, e[y >> 2] = C + e[y >> 2];
                                                            break f;
                                                          }
                                                          y = gi() | 0;
                                                          break t;
                                                        }
                                                        y = gi() | 0, l2(Q + 332 | 0);
                                                        break t;
                                                      }
                                                      e[5996] = 0, C = wn(30, Q + 132 | 0, 5289) | 0, I = e[5996], e[5996] = 0;
                                                      R: {
                                                        if ((I | 0) != 1) {
                                                          if (I = Uf(C, y), Se[Q + 143 | 0] < 0 && Tr(e[C >> 2]), !I)
                                                            break p;
                                                          S = e[y + 4 >> 2];
                                                          k: {
                                                            if ((S | 0) <= 0)
                                                              break k;
                                                            for (I = e[y >> 2], C = 0; ; ) {
                                                              if (me = I + C | 0, ke = Je[me | 0], (ke | 0) != 44) {
                                                                if ((ke | 0) == 41)
                                                                  break k;
                                                                if (C = C + 1 | 0, (S | 0) > (C | 0))
                                                                  continue;
                                                                break k;
                                                              }
                                                              break;
                                                            }
                                                            if (C)
                                                              break R;
                                                          }
                                                          e[l >> 2] = 0, e[l + 4 >> 2] = 0;
                                                          break c;
                                                        }
                                                        y = gi() | 0;
                                                        break t;
                                                      }
                                                      e[5996] = 0, I = Ko(154, Q + 120 | 0, I | 0, me | 0) | 0, S = e[5996], e[5996] = 0;
                                                      R: {
                                                        if ((S | 0) != 1) {
                                                          if (S = Ea(I, Xr), Se[Q + 131 | 0] < 0 && Tr(e[I >> 2]), S)
                                                            break R;
                                                          e[l >> 2] = 0, e[l + 4 >> 2] = 0;
                                                          break c;
                                                        }
                                                        y = gi() | 0;
                                                        break t;
                                                      }
                                                      C = C + 1 | 0, Ur = e[y + 4 >> 2] - C | 0, e[y + 4 >> 2] = Ur, S = C + e[y >> 2] | 0, e[y >> 2] = S, e[Q + 340 >> 2] = 0, e[Q + 332 >> 2] = 0, e[Q + 336 >> 2] = 0;
                                                      R: {
                                                        k: {
                                                          S: {
                                                            E: {
                                                              w: {
                                                                I: {
                                                                  for (; ; ) {
                                                                    if (C = 0, me = (Ur | 0) <= 0, me)
                                                                      break E;
                                                                    l: {
                                                                      for (; ; ) {
                                                                        if (I = Je[C + S | 0], (I | 0) == 44) {
                                                                          I = C;
                                                                          break l;
                                                                        }
                                                                        if (!((I | 0) != 41 && (C = C + 1 | 0, (Ur | 0) > (C | 0))))
                                                                          break;
                                                                      }
                                                                      if (I = 0, me)
                                                                        break E;
                                                                      for (; ; ) {
                                                                        if (Je[I + S | 0] == 41) {
                                                                          C = -1;
                                                                          break l;
                                                                        }
                                                                        if (I = I + 1 | 0, (Ur | 0) == (I | 0))
                                                                          break;
                                                                      }
                                                                      break E;
                                                                    }
                                                                    if ((I | 0) <= 0)
                                                                      break E;
                                                                    if (e[5996] = 0, Ms(156, Q + 240 | 0, S | 0, I + S | 0), S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                      break R;
                                                                    if (!Je[Q + 252 | 0])
                                                                      break E;
                                                                    S = e[Q + 336 >> 2];
                                                                    l: {
                                                                      if (S >>> 0 < qs[Q + 340 >> 2]) {
                                                                        me = e[Q + 244 >> 2], e[S >> 2] = e[Q + 240 >> 2], e[S + 4 >> 2] = me, e[S + 8 >> 2] = e[Q + 248 >> 2], e[Q + 248 >> 2] = 0, e[Q + 240 >> 2] = 0, e[Q + 244 >> 2] = 0, e[Q + 336 >> 2] = S + 12, Ur = 1, me = 0;
                                                                        break l;
                                                                      }
                                                                      if (e[5996] = 0, Co(157, Q + 332 | 0, Q + 240 | 0), S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                        break I;
                                                                      Ur = Je[Q + 252 | 0], me = Je[Q + 251 | 0];
                                                                    }
                                                                    if (I = I + 1 | 0, e[y + 4 >> 2] = e[y + 4 >> 2] - I, S = I + e[y >> 2] | 0, e[y >> 2] = S, !(Ur & 255) | me << 24 >> 24 >= 0 || (Tr(e[Q + 240 >> 2]), S = e[y >> 2]), (C | 0) != -1) {
                                                                      Ur = e[y + 4 >> 2];
                                                                      continue;
                                                                    }
                                                                    break;
                                                                  }
                                                                  if (C = e[Q + 336 >> 2], I = e[Q + 332 >> 2], S = (C - I | 0) / 12 | 0, (I | 0) != (C | 0) & S >>> 0 < 21)
                                                                    break w;
                                                                  break E;
                                                                }
                                                                if (y = gi() | 0, !Je[Q + 252 | 0] | Se[Q + 251 | 0] >= 0)
                                                                  break r;
                                                                Tr(e[Q + 240 >> 2]);
                                                                break r;
                                                              }
                                                              if (C = e[Q + 296 >> 2], I = e[Q + 300 >> 2], !((!!C & (I | 0) >= 0 | (I | 0) > 0) & (!I & C >>> 0 <= S >>> 0)))
                                                                break E;
                                                              if (e[5996] = 0, S = Q + 240 | 0, me = Q + 332 | 0, ko(158, S | 0, 25, me | 0, C | 0, I | 0), C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                break S;
                                                              if (e[5996] = 0, Co(151, Q + 308 | 0, S | 0), C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                break k;
                                                              l2(S), hf(me);
                                                              break f;
                                                            }
                                                            e[l >> 2] = 0, e[l + 4 >> 2] = 0, hf(Q + 332 | 0);
                                                            break c;
                                                          }
                                                          y = gi() | 0;
                                                          break r;
                                                        }
                                                        y = gi() | 0, l2(Q + 240 | 0);
                                                        break r;
                                                      }
                                                      y = gi() | 0;
                                                      break r;
                                                    }
                                                    e[l >> 2] = 0, e[l + 4 >> 2] = 0;
                                                    break c;
                                                  }
                                                  y = gi() | 0;
                                                  break t;
                                                }
                                                e[l >> 2] = 0, e[l + 4 >> 2] = 0;
                                                break c;
                                              }
                                              y = gi() | 0;
                                              break t;
                                            }
                                            e[5996] = 0, C = wn(30, Q + 108 | 0, 5302) | 0, I = e[5996], e[5996] = 0;
                                            p: {
                                              d: {
                                                if ((I | 0) != 1) {
                                                  if (I = Uf(C, y), Se[Q + 119 | 0] < 0 && Tr(e[C >> 2]), !I)
                                                    break p;
                                                  S = e[y + 4 >> 2];
                                                  g: {
                                                    if ((S | 0) <= 0)
                                                      break g;
                                                    for (I = e[y >> 2], C = 0; ; ) {
                                                      if (me = I + C | 0, ke = Je[me | 0], (ke | 0) != 44) {
                                                        if ((ke | 0) == 41)
                                                          break g;
                                                        if (C = C + 1 | 0, (S | 0) > (C | 0))
                                                          continue;
                                                        break g;
                                                      }
                                                      break;
                                                    }
                                                    if (C)
                                                      break d;
                                                  }
                                                  e[l >> 2] = 0, e[l + 4 >> 2] = 0;
                                                  break c;
                                                }
                                                y = gi() | 0;
                                                break t;
                                              }
                                              e[5996] = 0, I = Ko(154, Q + 96 | 0, I | 0, me | 0) | 0, S = e[5996], e[5996] = 0;
                                              d: {
                                                if ((S | 0) != 1) {
                                                  if (S = Ea(I, Xr), Se[Q + 107 | 0] < 0 && Tr(e[I >> 2]), S)
                                                    break d;
                                                  e[l >> 2] = 0, e[l + 4 >> 2] = 0;
                                                  break c;
                                                }
                                                y = gi() | 0;
                                                break t;
                                              }
                                              if (I = e[Q + 300 >> 2], !e[Q + 296 >> 2] & (I | 0) <= 0 | (I | 0) < 0) {
                                                e[l >> 2] = 0, e[l + 4 >> 2] = 0;
                                                break c;
                                              }
                                              if (C = C + 1 | 0, e[y + 4 >> 2] = e[y + 4 >> 2] - C, e[y >> 2] = C + e[y >> 2], e[5996] = 0, C = Q + 320 | 0, ia(159, C | 0, 19, 1, Xr | 0), I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                break h;
                                              if (e[5996] = 0, ia(160, C | 0, 0, -1, -1), C = e[5996], e[5996] = 0, (C | 0) != 1)
                                                break f;
                                              y = gi() | 0;
                                              break t;
                                            }
                                            e[5996] = 0, C = wn(30, Q + 84 | 0, 5251) | 0, I = e[5996], e[5996] = 0;
                                            p: {
                                              d: {
                                                g: {
                                                  v: {
                                                    _: {
                                                      R: {
                                                        k: {
                                                          if ((I | 0) != 1) {
                                                            if (I = Uf(C, y), Se[Q + 95 | 0] < 0 && Tr(e[C >> 2]), !I)
                                                              break p;
                                                            if (e[5996] = 0, C = Q + 320 | 0, ia(160, C | 0, 14, -1, -1), I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                              break k;
                                                            if (e[5996] = 0, ia(160, C | 0, 21, -1, -1), I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                              break R;
                                                            if (e[5996] = 0, ia(160, C | 0, 0, -1, -1), I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                              break _;
                                                            if (e[5996] = 0, ia(160, C | 0, 20, -1, -1), I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                              break v;
                                                            if (e[5996] = 0, ia(160, C | 0, 0, -1, -1), I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                              break g;
                                                            if (e[5996] = 0, ia(160, C | 0, 20, -1, -1), I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                              break d;
                                                            if (e[5996] = 0, ia(160, C | 0, 0, -1, -1), C = e[5996], e[5996] = 0, (C | 0) != 1)
                                                              break f;
                                                            y = gi() | 0;
                                                            break t;
                                                          }
                                                          y = gi() | 0;
                                                          break t;
                                                        }
                                                        y = gi() | 0;
                                                        break t;
                                                      }
                                                      y = gi() | 0;
                                                      break t;
                                                    }
                                                    y = gi() | 0;
                                                    break t;
                                                  }
                                                  y = gi() | 0;
                                                  break t;
                                                }
                                                y = gi() | 0;
                                                break t;
                                              }
                                              y = gi() | 0;
                                              break t;
                                            }
                                            if (e[5996] = 0, C = wn(30, Q + 72 | 0, 5272) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                              break u;
                                            I = Uf(C, y), Se[Q + 83 | 0] < 0 && Tr(e[C >> 2]);
                                            p: {
                                              if (I) {
                                                if (e[5996] = 0, ia(160, Q + 320 | 0, 11, -1, -1), C = e[5996], e[5996] = 0, (C | 0) != 1)
                                                  break p;
                                                y = gi() | 0;
                                                break t;
                                              }
                                              if (e[5996] = 0, C = wn(30, Q + 60 | 0, 5339) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                break A;
                                              if (I = Uf(C, y), Se[Q + 71 | 0] < 0 && Tr(e[C >> 2]), I) {
                                                if (e[5996] = 0, ia(160, Q + 320 | 0, 13, -1, -1), C = e[5996], e[5996] = 0, (C | 0) != 1)
                                                  break p;
                                                y = gi() | 0;
                                                break t;
                                              }
                                              if (e[5996] = 0, C = wn(30, Q + 48 | 0, 5244) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                break s;
                                              if (I = Uf(C, y), Se[Q + 59 | 0] < 0 && Tr(e[C >> 2]), I) {
                                                if (e[5996] = 0, ia(160, Q + 320 | 0, 12, -1, -1), C = e[5996], e[5996] = 0, (C | 0) != 1)
                                                  break p;
                                                y = gi() | 0;
                                                break t;
                                              }
                                              if (e[5996] = 0, C = wn(30, Q + 36 | 0, 5333) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                break a;
                                              if (I = Uf(C, y), Se[Q + 47 | 0] < 0 && Tr(e[C >> 2]), I) {
                                                if (e[5996] = 0, ia(160, Q + 320 | 0, 15, -1, -1), C = e[5996], e[5996] = 0, (C | 0) != 1)
                                                  break p;
                                                y = gi() | 0;
                                                break t;
                                              }
                                              if (e[5996] = 0, C = wn(30, Q + 24 | 0, 5327) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                break o;
                                              if (I = Uf(C, y), Se[Q + 35 | 0] < 0 && Tr(e[C >> 2]), I) {
                                                if (e[5996] = 0, ia(160, Q + 320 | 0, 16, -1, -1), C = e[5996], e[5996] = 0, (C | 0) != 1)
                                                  break p;
                                                y = gi() | 0;
                                                break t;
                                              }
                                              if (e[5996] = 0, C = wn(30, Q + 12 | 0, 5321) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                break n;
                                              if (I = Uf(C, y), Se[Q + 23 | 0] < 0 && Tr(e[C >> 2]), I) {
                                                if (e[5996] = 0, ia(160, Q + 320 | 0, 17, -1, -1), C = e[5996], e[5996] = 0, (C | 0) != 1)
                                                  break p;
                                                y = gi() | 0;
                                                break t;
                                              }
                                              if (e[5996] = 0, C = wn(30, Q | 0, 5296) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                break i;
                                              if (I = Uf(C, y), Se[Q + 11 | 0] < 0 && Tr(e[C >> 2]), I) {
                                                if (e[5996] = 0, ia(160, Q + 320 | 0, 18, -1, -1), C = e[5996], e[5996] = 0, (C | 0) != 1)
                                                  break p;
                                                y = gi() | 0;
                                                break t;
                                              }
                                              e[l >> 2] = 0, e[l + 4 >> 2] = 0;
                                              break c;
                                            }
                                            e[5996] = 0, C = Q + 320 | 0, ia(160, C | 0, 21, -1, -1), I = e[5996], e[5996] = 0;
                                            p: {
                                              d: {
                                                if ((I | 0) != 1) {
                                                  if (e[5996] = 0, ia(160, C | 0, 0, -1, -1), I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                    break d;
                                                  if (e[5996] = 0, ia(160, C | 0, 20, -1, -1), I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                    break p;
                                                  if (e[5996] = 0, ia(160, C | 0, 0, -1, -1), C = e[5996], e[5996] = 0, (C | 0) != 1)
                                                    break f;
                                                  y = gi() | 0;
                                                  break t;
                                                }
                                                y = gi() | 0;
                                                break t;
                                              }
                                              y = gi() | 0;
                                              break t;
                                            }
                                            y = gi() | 0;
                                            break t;
                                          }
                                          if (I = e[Q + 324 >> 2], S = e[Q + 320 >> 2], (I | 0) == (S | 0))
                                            break;
                                        }
                                        if (C = e[Q + 308 >> 2], (e[Q + 312 >> 2] - C | 0) != 8) {
                                          if (e[5996] = 0, ia(44, 4122, 2210, 1561, 2344), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                            break e;
                                          y = gi() | 0;
                                          break t;
                                        }
                                        if (e[y + 4 >> 2]) {
                                          e[l >> 2] = 0, e[l + 4 >> 2] = 0;
                                          break c;
                                        }
                                        e[l >> 2] = e[C >> 2], e[l + 4 >> 2] = e[C + 4 >> 2], e[C >> 2] = 0, e[C + 4 >> 2] = 0;
                                      }
                                      if (l = e[Q + 308 >> 2], l) {
                                        if (C = e[Q + 312 >> 2], (l | 0) != (C | 0)) {
                                          for (; ; ) {
                                            C = C - 8 | 0, y = e[C + 4 >> 2];
                                            c: {
                                              if (!y || (I = e[y + 4 >> 2], e[y + 4 >> 2] = I - 1, I))
                                                break c;
                                              Yn[e[e[y >> 2] + 8 >> 2]](y), Ls(y);
                                            }
                                            if ((l | 0) == (C | 0))
                                              break;
                                          }
                                          l = e[Q + 308 >> 2];
                                        }
                                        Tr(l);
                                      }
                                      l = e[Q + 320 >> 2], l && (e[Q + 324 >> 2] = l, Tr(l)), bi = Q + 352 | 0;
                                      return;
                                    }
                                    y = gi() | 0;
                                    break t;
                                  }
                                  y = gi() | 0;
                                  break t;
                                }
                                y = gi() | 0;
                                break t;
                              }
                              y = gi() | 0;
                              break t;
                            }
                            y = gi() | 0;
                            break t;
                          }
                          y = gi() | 0;
                          break t;
                        }
                        y = gi() | 0;
                        break t;
                      }
                      y = gi() | 0;
                      break t;
                    }
                    y = gi() | 0;
                    break t;
                  }
                  hf(Q + 332 | 0);
                }
                Za(Q + 308 | 0), l = e[Q + 320 >> 2], l && (e[Q + 324 >> 2] = l, Tr(l)), ss(y | 0), jn();
              }
              jn();
            }
            function Jh(l, y, I, C, Q) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0;
              var S = 0, me = 0, ke = 0, Ar = 0, br = 0, Qr = 0;
              S = bi - 128 | 0, bi = S, Se[S + 127 | 0] = y, me = S + 116 | 0, Sa(me, y ? 3764 : 5575, y), Se[y | me] = 0;
              e: {
                t: {
                  r: {
                    i: {
                      n: {
                        o: {
                          a: {
                            s: {
                              A: {
                                u: {
                                  h: {
                                    c: {
                                      f: {
                                        p: {
                                          d: {
                                            g: {
                                              v: {
                                                _: {
                                                  R: {
                                                    k: {
                                                      S: {
                                                        E: {
                                                          w: {
                                                            I: {
                                                              l: {
                                                                T: {
                                                                  m: {
                                                                    C: {
                                                                      D: {
                                                                        b:
                                                                          switch (e[I >> 2]) {
                                                                            case 10:
                                                                              if (e[5996] = 0, y = Ko(99, C | 0, 0, 2553) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                                                break S;
                                                                              C = e[y >> 2], e[S + 96 >> 2] = e[y + 4 >> 2], I = Je[y + 7 | 0] | Je[y + 8 | 0] << 8 | (Je[y + 9 | 0] << 16 | Je[y + 10 | 0] << 24), Se[S + 99 | 0] = I, Se[S + 100 | 0] = I >>> 8, Se[S + 101 | 0] = I >>> 16, Se[S + 102 | 0] = I >>> 24, e[y >> 2] = 0, e[y + 4 >> 2] = 0, I = Je[y + 11 | 0], e[y + 8 >> 2] = 0, e[l >> 2] = C, e[l + 4 >> 2] = e[S + 96 >> 2], y = Je[S + 99 | 0] | Je[S + 100 | 0] << 8 | (Je[S + 101 | 0] << 16 | Je[S + 102 | 0] << 24), Se[l + 7 | 0] = y, Se[l + 8 | 0] = y >>> 8, Se[l + 9 | 0] = y >>> 16, Se[l + 10 | 0] = y >>> 24, Se[l + 12 | 0] = 1, Se[l + 11 | 0] = I;
                                                                              break t;
                                                                            case 11:
                                                                              if (e[5996] = 0, y = Ko(99, C | 0, 0, 1681) | 0, I = e[5996], e[5996] = 0, (I | 0) != 1) {
                                                                                C = e[y >> 2], e[S + 96 >> 2] = e[y + 4 >> 2], I = Je[y + 7 | 0] | Je[y + 8 | 0] << 8 | (Je[y + 9 | 0] << 16 | Je[y + 10 | 0] << 24), Se[S + 99 | 0] = I, Se[S + 100 | 0] = I >>> 8, Se[S + 101 | 0] = I >>> 16, Se[S + 102 | 0] = I >>> 24, e[y >> 2] = 0, e[y + 4 >> 2] = 0, I = Je[y + 11 | 0], e[y + 8 >> 2] = 0, e[l >> 2] = C, e[l + 4 >> 2] = e[S + 96 >> 2], y = Je[S + 99 | 0] | Je[S + 100 | 0] << 8 | (Je[S + 101 | 0] << 16 | Je[S + 102 | 0] << 24), Se[l + 7 | 0] = y, Se[l + 8 | 0] = y >>> 8, Se[l + 9 | 0] = y >>> 16, Se[l + 10 | 0] = y >>> 24, Se[l + 12 | 0] = 1, Se[l + 11 | 0] = I;
                                                                                break t;
                                                                              }
                                                                              l = gi() | 0;
                                                                              break e;
                                                                            case 12:
                                                                              B: {
                                                                                y: {
                                                                                  x:
                                                                                    switch (y = e[e[I + 32 >> 2] >> 2], e[y >> 2] - 2 | 0) {
                                                                                      case 1:
                                                                                        break y;
                                                                                      case 0:
                                                                                        break x;
                                                                                      default:
                                                                                        break B;
                                                                                    }
                                                                                  if (y = e[y + 8 >> 2], Se[y + 11 | 0] >= 0) {
                                                                                    e[S + 104 >> 2] = e[y + 8 >> 2], I = e[y + 4 >> 2], e[S + 96 >> 2] = e[y >> 2], e[S + 100 >> 2] = I;
                                                                                    break r;
                                                                                  }
                                                                                  if (I = e[y + 4 >> 2], y = e[y >> 2], e[5996] = 0, Ms(40, S + 96 | 0, y | 0, I | 0), y = e[5996], e[5996] = 0, (y | 0) != 1)
                                                                                    break r;
                                                                                  l = gi() | 0;
                                                                                  break e;
                                                                                }
                                                                                if (y = e[y + 8 >> 2], Se[y + 11 | 0] >= 0) {
                                                                                  e[S + 104 >> 2] = e[y + 8 >> 2], I = e[y + 4 >> 2], e[S + 96 >> 2] = e[y >> 2], e[S + 100 >> 2] = I;
                                                                                  break i;
                                                                                }
                                                                                if (I = e[y + 4 >> 2], y = e[y >> 2], e[5996] = 0, Ms(40, S + 96 | 0, y | 0, I | 0), y = e[5996], e[5996] = 0, (y | 0) != 1)
                                                                                  break i;
                                                                                l = gi() | 0;
                                                                                break e;
                                                                              }
                                                                              if (e[5996] = 0, y = Ko(99, C | 0, 0, 2541) | 0, I = e[5996], e[5996] = 0, (I | 0) != 1) {
                                                                                C = e[y >> 2], e[S + 96 >> 2] = e[y + 4 >> 2], I = Je[y + 7 | 0] | Je[y + 8 | 0] << 8 | (Je[y + 9 | 0] << 16 | Je[y + 10 | 0] << 24), Se[S + 99 | 0] = I, Se[S + 100 | 0] = I >>> 8, Se[S + 101 | 0] = I >>> 16, Se[S + 102 | 0] = I >>> 24, e[y >> 2] = 0, e[y + 4 >> 2] = 0, I = Je[y + 11 | 0], e[y + 8 >> 2] = 0, e[l >> 2] = C, e[l + 4 >> 2] = e[S + 96 >> 2], y = Je[S + 99 | 0] | Je[S + 100 | 0] << 8 | (Je[S + 101 | 0] << 16 | Je[S + 102 | 0] << 24), Se[l + 7 | 0] = y, Se[l + 8 | 0] = y >>> 8, Se[l + 9 | 0] = y >>> 16, Se[l + 10 | 0] = y >>> 24, Se[l + 12 | 0] = 1, Se[l + 11 | 0] = I;
                                                                                break t;
                                                                              }
                                                                              l = gi() | 0;
                                                                              break e;
                                                                            case 13:
                                                                              if (e[5996] = 0, y = Ko(99, C | 0, 0, 2522) | 0, I = e[5996], e[5996] = 0, (I | 0) != 1) {
                                                                                C = e[y >> 2], e[S + 96 >> 2] = e[y + 4 >> 2], I = Je[y + 7 | 0] | Je[y + 8 | 0] << 8 | (Je[y + 9 | 0] << 16 | Je[y + 10 | 0] << 24), Se[S + 99 | 0] = I, Se[S + 100 | 0] = I >>> 8, Se[S + 101 | 0] = I >>> 16, Se[S + 102 | 0] = I >>> 24, e[y >> 2] = 0, e[y + 4 >> 2] = 0, I = Je[y + 11 | 0], e[y + 8 >> 2] = 0, e[l >> 2] = C, e[l + 4 >> 2] = e[S + 96 >> 2], y = Je[S + 99 | 0] | Je[S + 100 | 0] << 8 | (Je[S + 101 | 0] << 16 | Je[S + 102 | 0] << 24), Se[l + 7 | 0] = y, Se[l + 8 | 0] = y >>> 8, Se[l + 9 | 0] = y >>> 16, Se[l + 10 | 0] = y >>> 24, Se[l + 12 | 0] = 1, Se[l + 11 | 0] = I;
                                                                                break t;
                                                                              }
                                                                              l = gi() | 0;
                                                                              break e;
                                                                            case 14:
                                                                              if (e[5996] = 0, y = Ko(99, C | 0, 0, 1271) | 0, I = e[5996], e[5996] = 0, (I | 0) != 1) {
                                                                                C = e[y >> 2], e[S + 96 >> 2] = e[y + 4 >> 2], I = Je[y + 7 | 0] | Je[y + 8 | 0] << 8 | (Je[y + 9 | 0] << 16 | Je[y + 10 | 0] << 24), Se[S + 99 | 0] = I, Se[S + 100 | 0] = I >>> 8, Se[S + 101 | 0] = I >>> 16, Se[S + 102 | 0] = I >>> 24, e[y >> 2] = 0, e[y + 4 >> 2] = 0, I = Je[y + 11 | 0], e[y + 8 >> 2] = 0, e[l >> 2] = C, e[l + 4 >> 2] = e[S + 96 >> 2], y = Je[S + 99 | 0] | Je[S + 100 | 0] << 8 | (Je[S + 101 | 0] << 16 | Je[S + 102 | 0] << 24), Se[l + 7 | 0] = y, Se[l + 8 | 0] = y >>> 8, Se[l + 9 | 0] = y >>> 16, Se[l + 10 | 0] = y >>> 24, Se[l + 12 | 0] = 1, Se[l + 11 | 0] = I;
                                                                                break t;
                                                                              }
                                                                              l = gi() | 0;
                                                                              break e;
                                                                            case 15:
                                                                              if (e[5996] = 0, y = Ko(99, C | 0, 0, 2170) | 0, I = e[5996], e[5996] = 0, (I | 0) != 1) {
                                                                                C = e[y >> 2], e[S + 96 >> 2] = e[y + 4 >> 2], I = Je[y + 7 | 0] | Je[y + 8 | 0] << 8 | (Je[y + 9 | 0] << 16 | Je[y + 10 | 0] << 24), Se[S + 99 | 0] = I, Se[S + 100 | 0] = I >>> 8, Se[S + 101 | 0] = I >>> 16, Se[S + 102 | 0] = I >>> 24, e[y >> 2] = 0, e[y + 4 >> 2] = 0, I = Je[y + 11 | 0], e[y + 8 >> 2] = 0, e[l >> 2] = C, e[l + 4 >> 2] = e[S + 96 >> 2], y = Je[S + 99 | 0] | Je[S + 100 | 0] << 8 | (Je[S + 101 | 0] << 16 | Je[S + 102 | 0] << 24), Se[l + 7 | 0] = y, Se[l + 8 | 0] = y >>> 8, Se[l + 9 | 0] = y >>> 16, Se[l + 10 | 0] = y >>> 24, Se[l + 12 | 0] = 1, Se[l + 11 | 0] = I;
                                                                                break t;
                                                                              }
                                                                              l = gi() | 0;
                                                                              break e;
                                                                            case 16:
                                                                              if (e[5996] = 0, y = Ko(99, C | 0, 0, 2029) | 0, I = e[5996], e[5996] = 0, (I | 0) != 1) {
                                                                                C = e[y >> 2], e[S + 96 >> 2] = e[y + 4 >> 2], I = Je[y + 7 | 0] | Je[y + 8 | 0] << 8 | (Je[y + 9 | 0] << 16 | Je[y + 10 | 0] << 24), Se[S + 99 | 0] = I, Se[S + 100 | 0] = I >>> 8, Se[S + 101 | 0] = I >>> 16, Se[S + 102 | 0] = I >>> 24, e[y >> 2] = 0, e[y + 4 >> 2] = 0, I = Je[y + 11 | 0], e[y + 8 >> 2] = 0, e[l >> 2] = C, e[l + 4 >> 2] = e[S + 96 >> 2], y = Je[S + 99 | 0] | Je[S + 100 | 0] << 8 | (Je[S + 101 | 0] << 16 | Je[S + 102 | 0] << 24), Se[l + 7 | 0] = y, Se[l + 8 | 0] = y >>> 8, Se[l + 9 | 0] = y >>> 16, Se[l + 10 | 0] = y >>> 24, Se[l + 12 | 0] = 1, Se[l + 11 | 0] = I;
                                                                                break t;
                                                                              }
                                                                              l = gi() | 0;
                                                                              break e;
                                                                            case 17:
                                                                              if (e[e[e[I + 32 >> 2] + 8 >> 2] >> 2] != 1)
                                                                                break D;
                                                                              if (e[5996] = 0, y = Ko(99, C | 0, 0, 1392) | 0, I = e[5996], e[5996] = 0, (I | 0) != 1) {
                                                                                C = e[y >> 2], e[S + 96 >> 2] = e[y + 4 >> 2], I = Je[y + 7 | 0] | Je[y + 8 | 0] << 8 | (Je[y + 9 | 0] << 16 | Je[y + 10 | 0] << 24), Se[S + 99 | 0] = I, Se[S + 100 | 0] = I >>> 8, Se[S + 101 | 0] = I >>> 16, Se[S + 102 | 0] = I >>> 24, e[y >> 2] = 0, e[y + 4 >> 2] = 0, I = Je[y + 11 | 0], e[y + 8 >> 2] = 0, e[l >> 2] = C, e[l + 4 >> 2] = e[S + 96 >> 2], y = Je[S + 99 | 0] | Je[S + 100 | 0] << 8 | (Je[S + 101 | 0] << 16 | Je[S + 102 | 0] << 24), Se[l + 7 | 0] = y, Se[l + 8 | 0] = y >>> 8, Se[l + 9 | 0] = y >>> 16, Se[l + 10 | 0] = y >>> 24, Se[l + 12 | 0] = 1, Se[l + 11 | 0] = I;
                                                                                break t;
                                                                              }
                                                                              l = gi() | 0;
                                                                              break e;
                                                                            case 22:
                                                                              if (y = e[I + 32 >> 2], !e[e[y >> 2] >> 2]) {
                                                                                if (e[5996] = 0, y = Ko(99, C + 12 | 0, 0, 2096) | 0, I = e[5996], e[5996] = 0, (I | 0) != 1) {
                                                                                  Q = e[y >> 2], I = Je[C + 19 | 0] | Je[C + 20 | 0] << 8 | (Je[C + 21 | 0] << 16 | Je[C + 22 | 0] << 24), Se[S + 99 | 0] = I, Se[S + 100 | 0] = I >>> 8, Se[S + 101 | 0] = I >>> 16, Se[S + 102 | 0] = I >>> 24, e[S + 96 >> 2] = e[C + 16 >> 2], I = Je[C + 23 | 0], e[y + 8 >> 2] = 0, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[l >> 2] = Q, e[l + 4 >> 2] = e[S + 96 >> 2], y = Je[S + 99 | 0] | Je[S + 100 | 0] << 8 | (Je[S + 101 | 0] << 16 | Je[S + 102 | 0] << 24), Se[l + 7 | 0] = y, Se[l + 8 | 0] = y >>> 8, Se[l + 9 | 0] = y >>> 16, Se[l + 10 | 0] = y >>> 24, Se[l + 12 | 0] = 1, Se[l + 11 | 0] = I;
                                                                                  break t;
                                                                                }
                                                                                l = gi() | 0;
                                                                                break e;
                                                                              }
                                                                              if (e[e[y + 8 >> 2] >> 2])
                                                                                break I;
                                                                              if (e[5996] = 0, y = Ko(99, C | 0, 0, 1295) | 0, I = e[5996], e[5996] = 0, (I | 0) != 1) {
                                                                                C = e[y >> 2], e[S + 96 >> 2] = e[y + 4 >> 2], I = Je[y + 7 | 0] | Je[y + 8 | 0] << 8 | (Je[y + 9 | 0] << 16 | Je[y + 10 | 0] << 24), Se[S + 99 | 0] = I, Se[S + 100 | 0] = I >>> 8, Se[S + 101 | 0] = I >>> 16, Se[S + 102 | 0] = I >>> 24, e[y >> 2] = 0, e[y + 4 >> 2] = 0, I = Je[y + 11 | 0], e[y + 8 >> 2] = 0, e[l >> 2] = C, e[l + 4 >> 2] = e[S + 96 >> 2], y = Je[S + 99 | 0] | Je[S + 100 | 0] << 8 | (Je[S + 101 | 0] << 16 | Je[S + 102 | 0] << 24), Se[l + 7 | 0] = y, Se[l + 8 | 0] = y >>> 8, Se[l + 9 | 0] = y >>> 16, Se[l + 10 | 0] = y >>> 24, Se[l + 12 | 0] = 1, Se[l + 11 | 0] = I;
                                                                                break t;
                                                                              }
                                                                              l = gi() | 0;
                                                                              break e;
                                                                            case 2:
                                                                              if (y = e[I + 8 >> 2], Se[y + 11 | 0] >= 0) {
                                                                                e[S + 104 >> 2] = e[y + 8 >> 2], I = e[y + 4 >> 2], e[S + 96 >> 2] = e[y >> 2], e[S + 100 >> 2] = I;
                                                                                break n;
                                                                              }
                                                                              if (I = e[y + 4 >> 2], y = e[y >> 2], e[5996] = 0, Ms(40, S + 96 | 0, y | 0, I | 0), y = e[5996], e[5996] = 0, (y | 0) != 1)
                                                                                break n;
                                                                              l = gi() | 0;
                                                                              break e;
                                                                            case 3:
                                                                              if (y = e[I + 8 >> 2], Se[y + 11 | 0] >= 0) {
                                                                                e[S + 104 >> 2] = e[y + 8 >> 2], I = e[y + 4 >> 2], e[S + 96 >> 2] = e[y >> 2], e[S + 100 >> 2] = I;
                                                                                break o;
                                                                              }
                                                                              if (I = e[y + 4 >> 2], y = e[y >> 2], e[5996] = 0, Ms(40, S + 96 | 0, y | 0, I | 0), y = e[5996], e[5996] = 0, (y | 0) != 1)
                                                                                break o;
                                                                              l = gi() | 0;
                                                                              break e;
                                                                            case 5:
                                                                              e[5996] = 0, y = wn(97, S + 116 | 0, 5258) | 0, C = e[5996], e[5996] = 0;
                                                                              B: {
                                                                                y: {
                                                                                  x: {
                                                                                    P: {
                                                                                      M: {
                                                                                        if ((C | 0) != 1) {
                                                                                          if (e[S + 88 >> 2] = e[y + 8 >> 2], C = e[y + 4 >> 2], e[S + 80 >> 2] = e[y >> 2], e[S + 84 >> 2] = C, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, e[5996] = 0, y = S - -64 | 0, Co(119, y | 0, I + 4 | 0), I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                                                            break M;
                                                                                          if (e[5996] = 0, C = y, y = Je[S + 75 | 0], I = y << 24 >> 24 < 0, I = Ko(100, S + 80 | 0, (I ? e[S + 64 >> 2] : C) | 0, (I ? e[S + 68 >> 2] : y) | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                            break P;
                                                                                          if (e[S + 104 >> 2] = e[I + 8 >> 2], y = e[I + 4 >> 2], e[S + 96 >> 2] = e[I >> 2], e[S + 100 >> 2] = y, e[I >> 2] = 0, e[I + 4 >> 2] = 0, e[I + 8 >> 2] = 0, e[5996] = 0, y = wn(97, S + 96 | 0, 5242) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                                            break x;
                                                                                          if (Q = e[y >> 2], e[S + 48 >> 2] = e[y + 4 >> 2], C = Je[y + 7 | 0] | Je[y + 8 | 0] << 8 | (Je[y + 9 | 0] << 16 | Je[y + 10 | 0] << 24), Se[S + 51 | 0] = C, Se[S + 52 | 0] = C >>> 8, Se[S + 53 | 0] = C >>> 16, Se[S + 54 | 0] = C >>> 24, e[y >> 2] = 0, e[y + 4 >> 2] = 0, C = Je[y + 11 | 0], e[y + 8 >> 2] = 0, e[l >> 2] = Q, e[l + 4 >> 2] = e[S + 48 >> 2], y = Je[S + 51 | 0] | Je[S + 52 | 0] << 8 | (Je[S + 53 | 0] << 16 | Je[S + 54 | 0] << 24), Se[l + 7 | 0] = y, Se[l + 8 | 0] = y >>> 8, Se[l + 9 | 0] = y >>> 16, Se[l + 10 | 0] = y >>> 24, Se[l + 12 | 0] = 1, Se[l + 11 | 0] = C, Se[S + 75 | 0] < 0 && Tr(e[S + 64 >> 2]), Se[I + 11 | 0] >= 0)
                                                                                            break t;
                                                                                          Tr(e[I >> 2]);
                                                                                          break t;
                                                                                        }
                                                                                        l = gi() | 0;
                                                                                        break e;
                                                                                      }
                                                                                      l = gi() | 0;
                                                                                      break B;
                                                                                    }
                                                                                    l = gi() | 0;
                                                                                    break y;
                                                                                  }
                                                                                  if (l = gi() | 0, Se[S + 107 | 0] >= 0)
                                                                                    break y;
                                                                                  Tr(e[S + 96 >> 2]);
                                                                                }
                                                                                if (Se[S + 75 | 0] >= 0)
                                                                                  break B;
                                                                                Tr(e[S + 64 >> 2]);
                                                                              }
                                                                              if (Se[S + 91 | 0] >= 0)
                                                                                break e;
                                                                              Tr(e[S + 80 >> 2]);
                                                                              break e;
                                                                            case 4:
                                                                              e[5996] = 0, y = wn(97, S + 116 | 0, 5265) | 0, C = e[5996], e[5996] = 0;
                                                                              B: {
                                                                                y: {
                                                                                  x: {
                                                                                    P: {
                                                                                      M: {
                                                                                        if ((C | 0) != 1) {
                                                                                          if (e[S + 88 >> 2] = e[y + 8 >> 2], C = e[y + 4 >> 2], e[S + 80 >> 2] = e[y >> 2], e[S + 84 >> 2] = C, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, e[5996] = 0, y = S - -64 | 0, Co(119, y | 0, I + 4 | 0), I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                                                            break M;
                                                                                          if (e[5996] = 0, C = y, y = Je[S + 75 | 0], I = y << 24 >> 24 < 0, I = Ko(100, S + 80 | 0, (I ? e[S + 64 >> 2] : C) | 0, (I ? e[S + 68 >> 2] : y) | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                            break P;
                                                                                          if (e[S + 104 >> 2] = e[I + 8 >> 2], y = e[I + 4 >> 2], e[S + 96 >> 2] = e[I >> 2], e[S + 100 >> 2] = y, e[I >> 2] = 0, e[I + 4 >> 2] = 0, e[I + 8 >> 2] = 0, e[5996] = 0, y = wn(97, S + 96 | 0, 5242) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                                            break x;
                                                                                          if (Q = e[y >> 2], e[S + 48 >> 2] = e[y + 4 >> 2], C = Je[y + 7 | 0] | Je[y + 8 | 0] << 8 | (Je[y + 9 | 0] << 16 | Je[y + 10 | 0] << 24), Se[S + 51 | 0] = C, Se[S + 52 | 0] = C >>> 8, Se[S + 53 | 0] = C >>> 16, Se[S + 54 | 0] = C >>> 24, e[y >> 2] = 0, e[y + 4 >> 2] = 0, C = Je[y + 11 | 0], e[y + 8 >> 2] = 0, e[l >> 2] = Q, e[l + 4 >> 2] = e[S + 48 >> 2], y = Je[S + 51 | 0] | Je[S + 52 | 0] << 8 | (Je[S + 53 | 0] << 16 | Je[S + 54 | 0] << 24), Se[l + 7 | 0] = y, Se[l + 8 | 0] = y >>> 8, Se[l + 9 | 0] = y >>> 16, Se[l + 10 | 0] = y >>> 24, Se[l + 12 | 0] = 1, Se[l + 11 | 0] = C, Se[S + 75 | 0] < 0 && Tr(e[S + 64 >> 2]), Se[I + 11 | 0] >= 0)
                                                                                            break t;
                                                                                          Tr(e[I >> 2]);
                                                                                          break t;
                                                                                        }
                                                                                        l = gi() | 0;
                                                                                        break e;
                                                                                      }
                                                                                      l = gi() | 0;
                                                                                      break B;
                                                                                    }
                                                                                    l = gi() | 0;
                                                                                    break y;
                                                                                  }
                                                                                  if (l = gi() | 0, Se[S + 107 | 0] >= 0)
                                                                                    break y;
                                                                                  Tr(e[S + 96 >> 2]);
                                                                                }
                                                                                if (Se[S + 75 | 0] >= 0)
                                                                                  break B;
                                                                                Tr(e[S + 64 >> 2]);
                                                                              }
                                                                              if (Se[S + 91 | 0] >= 0)
                                                                                break e;
                                                                              Tr(e[S + 80 >> 2]);
                                                                              break e;
                                                                            case 7:
                                                                              e[5996] = 0, y = wn(97, S + 116 | 0, 5346) | 0, C = e[5996], e[5996] = 0;
                                                                              B: {
                                                                                y: {
                                                                                  x: {
                                                                                    if ((C | 0) != 1) {
                                                                                      if (e[S + 88 >> 2] = e[y + 8 >> 2], C = e[y + 4 >> 2], e[S + 80 >> 2] = e[y >> 2], e[S + 84 >> 2] = C, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, C = e[I + 24 >> 2], y = e[I + 20 >> 2], e[S + 72 >> 2] = 0, e[S + 64 >> 2] = 0, e[S + 68 >> 2] = 0, e[5996] = 0, I = C - y | 0, Co(101, S - -64 | 0, I << 1), Q = e[5996], e[5996] = 0, (Q | 0) == 1)
                                                                                        break s;
                                                                                      P: {
                                                                                        if (y >>> 0 < C >>> 0)
                                                                                          for (C = y + I | 0; ; ) {
                                                                                            if (I = Je[y | 0], e[5996] = 0, Q = S - -64 | 0, Co(98, Q | 0, Se[(I >>> 4 | 0) + 6976 | 0]), me = e[5996], e[5996] = 0, (me | 0) == 1 || (e[5996] = 0, Co(98, Q | 0, Se[(I & 15) + 6976 | 0]), I = e[5996], e[5996] = 0, (I | 0) == 1))
                                                                                              break P;
                                                                                            if (y = y + 1 | 0, (C | 0) == (y | 0))
                                                                                              break;
                                                                                          }
                                                                                        if (e[5996] = 0, y = Je[S + 75 | 0], I = y << 24 >> 24 < 0, I = Ko(100, S + 80 | 0, (I ? e[S + 64 >> 2] : S - -64 | 0) | 0, (I ? e[S + 68 >> 2] : y) | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                          break x;
                                                                                        if (e[S + 104 >> 2] = e[I + 8 >> 2], y = e[I + 4 >> 2], e[S + 96 >> 2] = e[I >> 2], e[S + 100 >> 2] = y, e[I >> 2] = 0, e[I + 4 >> 2] = 0, e[I + 8 >> 2] = 0, e[5996] = 0, y = wn(97, S + 96 | 0, 5242) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                                          break y;
                                                                                        if (Q = e[y >> 2], e[S + 48 >> 2] = e[y + 4 >> 2], C = Je[y + 7 | 0] | Je[y + 8 | 0] << 8 | (Je[y + 9 | 0] << 16 | Je[y + 10 | 0] << 24), Se[S + 51 | 0] = C, Se[S + 52 | 0] = C >>> 8, Se[S + 53 | 0] = C >>> 16, Se[S + 54 | 0] = C >>> 24, e[y >> 2] = 0, e[y + 4 >> 2] = 0, C = Je[y + 11 | 0], e[y + 8 >> 2] = 0, e[l >> 2] = Q, e[l + 4 >> 2] = e[S + 48 >> 2], y = Je[S + 51 | 0] | Je[S + 52 | 0] << 8 | (Je[S + 53 | 0] << 16 | Je[S + 54 | 0] << 24), Se[l + 7 | 0] = y, Se[l + 8 | 0] = y >>> 8, Se[l + 9 | 0] = y >>> 16, Se[l + 10 | 0] = y >>> 24, Se[l + 12 | 0] = 1, Se[l + 11 | 0] = C, Se[S + 75 | 0] < 0 && Tr(e[S + 64 >> 2]), Se[I + 11 | 0] >= 0)
                                                                                          break t;
                                                                                        Tr(e[I >> 2]);
                                                                                        break t;
                                                                                      }
                                                                                      break s;
                                                                                    }
                                                                                    l = gi() | 0;
                                                                                    break e;
                                                                                  }
                                                                                  l = gi() | 0;
                                                                                  break B;
                                                                                }
                                                                                if (l = gi() | 0, Se[S + 107 | 0] >= 0)
                                                                                  break B;
                                                                                Tr(e[S + 96 >> 2]);
                                                                              }
                                                                              break a;
                                                                            case 9:
                                                                              e[5996] = 0, y = wn(97, S + 116 | 0, 5363) | 0, C = e[5996], e[5996] = 0;
                                                                              B: {
                                                                                y: {
                                                                                  x: {
                                                                                    if ((C | 0) != 1) {
                                                                                      if (e[S + 88 >> 2] = e[y + 8 >> 2], C = e[y + 4 >> 2], e[S + 80 >> 2] = e[y >> 2], e[S + 84 >> 2] = C, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, C = e[I + 24 >> 2], y = e[I + 20 >> 2], e[S + 72 >> 2] = 0, e[S + 64 >> 2] = 0, e[S + 68 >> 2] = 0, e[5996] = 0, I = C - y | 0, Co(101, S - -64 | 0, I << 1), Q = e[5996], e[5996] = 0, (Q | 0) == 1)
                                                                                        break u;
                                                                                      P: {
                                                                                        if (y >>> 0 < C >>> 0)
                                                                                          for (C = y + I | 0; ; ) {
                                                                                            if (I = Je[y | 0], e[5996] = 0, Q = S - -64 | 0, Co(98, Q | 0, Se[(I >>> 4 | 0) + 6976 | 0]), me = e[5996], e[5996] = 0, (me | 0) == 1 || (e[5996] = 0, Co(98, Q | 0, Se[(I & 15) + 6976 | 0]), I = e[5996], e[5996] = 0, (I | 0) == 1))
                                                                                              break P;
                                                                                            if (y = y + 1 | 0, (C | 0) == (y | 0))
                                                                                              break;
                                                                                          }
                                                                                        if (e[5996] = 0, y = Je[S + 75 | 0], I = y << 24 >> 24 < 0, I = Ko(100, S + 80 | 0, (I ? e[S + 64 >> 2] : S - -64 | 0) | 0, (I ? e[S + 68 >> 2] : y) | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                          break x;
                                                                                        if (e[S + 104 >> 2] = e[I + 8 >> 2], y = e[I + 4 >> 2], e[S + 96 >> 2] = e[I >> 2], e[S + 100 >> 2] = y, e[I >> 2] = 0, e[I + 4 >> 2] = 0, e[I + 8 >> 2] = 0, e[5996] = 0, y = wn(97, S + 96 | 0, 5242) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                                          break y;
                                                                                        if (Q = e[y >> 2], e[S + 48 >> 2] = e[y + 4 >> 2], C = Je[y + 7 | 0] | Je[y + 8 | 0] << 8 | (Je[y + 9 | 0] << 16 | Je[y + 10 | 0] << 24), Se[S + 51 | 0] = C, Se[S + 52 | 0] = C >>> 8, Se[S + 53 | 0] = C >>> 16, Se[S + 54 | 0] = C >>> 24, e[y >> 2] = 0, e[y + 4 >> 2] = 0, C = Je[y + 11 | 0], e[y + 8 >> 2] = 0, e[l >> 2] = Q, e[l + 4 >> 2] = e[S + 48 >> 2], y = Je[S + 51 | 0] | Je[S + 52 | 0] << 8 | (Je[S + 53 | 0] << 16 | Je[S + 54 | 0] << 24), Se[l + 7 | 0] = y, Se[l + 8 | 0] = y >>> 8, Se[l + 9 | 0] = y >>> 16, Se[l + 10 | 0] = y >>> 24, Se[l + 12 | 0] = 1, Se[l + 11 | 0] = C, Se[S + 75 | 0] < 0 && Tr(e[S + 64 >> 2]), Se[I + 11 | 0] >= 0)
                                                                                          break t;
                                                                                        Tr(e[I >> 2]);
                                                                                        break t;
                                                                                      }
                                                                                      break u;
                                                                                    }
                                                                                    l = gi() | 0;
                                                                                    break e;
                                                                                  }
                                                                                  l = gi() | 0;
                                                                                  break B;
                                                                                }
                                                                                if (l = gi() | 0, Se[S + 107 | 0] >= 0)
                                                                                  break B;
                                                                                Tr(e[S + 96 >> 2]);
                                                                              }
                                                                              break A;
                                                                            case 6:
                                                                              e[5996] = 0, y = wn(97, S + 116 | 0, 5355) | 0, C = e[5996], e[5996] = 0;
                                                                              B: {
                                                                                y: {
                                                                                  x: {
                                                                                    if ((C | 0) != 1) {
                                                                                      if (e[S + 88 >> 2] = e[y + 8 >> 2], C = e[y + 4 >> 2], e[S + 80 >> 2] = e[y >> 2], e[S + 84 >> 2] = C, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, C = e[I + 24 >> 2], y = e[I + 20 >> 2], e[S + 72 >> 2] = 0, e[S + 64 >> 2] = 0, e[S + 68 >> 2] = 0, e[5996] = 0, I = C - y | 0, Co(101, S - -64 | 0, I << 1), Q = e[5996], e[5996] = 0, (Q | 0) == 1)
                                                                                        break c;
                                                                                      P: {
                                                                                        if (y >>> 0 < C >>> 0)
                                                                                          for (C = y + I | 0; ; ) {
                                                                                            if (I = Je[y | 0], e[5996] = 0, Q = S - -64 | 0, Co(98, Q | 0, Se[(I >>> 4 | 0) + 6976 | 0]), me = e[5996], e[5996] = 0, (me | 0) == 1 || (e[5996] = 0, Co(98, Q | 0, Se[(I & 15) + 6976 | 0]), I = e[5996], e[5996] = 0, (I | 0) == 1))
                                                                                              break P;
                                                                                            if (y = y + 1 | 0, (C | 0) == (y | 0))
                                                                                              break;
                                                                                          }
                                                                                        if (e[5996] = 0, y = Je[S + 75 | 0], I = y << 24 >> 24 < 0, I = Ko(100, S + 80 | 0, (I ? e[S + 64 >> 2] : S - -64 | 0) | 0, (I ? e[S + 68 >> 2] : y) | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                          break x;
                                                                                        if (e[S + 104 >> 2] = e[I + 8 >> 2], y = e[I + 4 >> 2], e[S + 96 >> 2] = e[I >> 2], e[S + 100 >> 2] = y, e[I >> 2] = 0, e[I + 4 >> 2] = 0, e[I + 8 >> 2] = 0, e[5996] = 0, y = wn(97, S + 96 | 0, 5242) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                                          break y;
                                                                                        if (Q = e[y >> 2], e[S + 48 >> 2] = e[y + 4 >> 2], C = Je[y + 7 | 0] | Je[y + 8 | 0] << 8 | (Je[y + 9 | 0] << 16 | Je[y + 10 | 0] << 24), Se[S + 51 | 0] = C, Se[S + 52 | 0] = C >>> 8, Se[S + 53 | 0] = C >>> 16, Se[S + 54 | 0] = C >>> 24, e[y >> 2] = 0, e[y + 4 >> 2] = 0, C = Je[y + 11 | 0], e[y + 8 >> 2] = 0, e[l >> 2] = Q, e[l + 4 >> 2] = e[S + 48 >> 2], y = Je[S + 51 | 0] | Je[S + 52 | 0] << 8 | (Je[S + 53 | 0] << 16 | Je[S + 54 | 0] << 24), Se[l + 7 | 0] = y, Se[l + 8 | 0] = y >>> 8, Se[l + 9 | 0] = y >>> 16, Se[l + 10 | 0] = y >>> 24, Se[l + 12 | 0] = 1, Se[l + 11 | 0] = C, Se[S + 75 | 0] < 0 && Tr(e[S + 64 >> 2]), Se[I + 11 | 0] >= 0)
                                                                                          break t;
                                                                                        Tr(e[I >> 2]);
                                                                                        break t;
                                                                                      }
                                                                                      break c;
                                                                                    }
                                                                                    l = gi() | 0;
                                                                                    break e;
                                                                                  }
                                                                                  l = gi() | 0;
                                                                                  break B;
                                                                                }
                                                                                if (l = gi() | 0, Se[S + 107 | 0] >= 0)
                                                                                  break B;
                                                                                Tr(e[S + 96 >> 2]);
                                                                              }
                                                                              break h;
                                                                            case 8:
                                                                              e[5996] = 0, y = wn(97, S + 116 | 0, 5372) | 0, C = e[5996], e[5996] = 0;
                                                                              B: {
                                                                                y: {
                                                                                  x: {
                                                                                    if ((C | 0) != 1) {
                                                                                      if (e[S + 88 >> 2] = e[y + 8 >> 2], C = e[y + 4 >> 2], e[S + 80 >> 2] = e[y >> 2], e[S + 84 >> 2] = C, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, C = e[I + 24 >> 2], y = e[I + 20 >> 2], e[S + 72 >> 2] = 0, e[S + 64 >> 2] = 0, e[S + 68 >> 2] = 0, e[5996] = 0, I = C - y | 0, Co(101, S - -64 | 0, I << 1), Q = e[5996], e[5996] = 0, (Q | 0) == 1)
                                                                                        break p;
                                                                                      P: {
                                                                                        if (y >>> 0 < C >>> 0)
                                                                                          for (C = y + I | 0; ; ) {
                                                                                            if (I = Je[y | 0], e[5996] = 0, Q = S - -64 | 0, Co(98, Q | 0, Se[(I >>> 4 | 0) + 6976 | 0]), me = e[5996], e[5996] = 0, (me | 0) == 1 || (e[5996] = 0, Co(98, Q | 0, Se[(I & 15) + 6976 | 0]), I = e[5996], e[5996] = 0, (I | 0) == 1))
                                                                                              break P;
                                                                                            if (y = y + 1 | 0, (C | 0) == (y | 0))
                                                                                              break;
                                                                                          }
                                                                                        if (e[5996] = 0, y = Je[S + 75 | 0], I = y << 24 >> 24 < 0, I = Ko(100, S + 80 | 0, (I ? e[S + 64 >> 2] : S - -64 | 0) | 0, (I ? e[S + 68 >> 2] : y) | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                          break x;
                                                                                        if (e[S + 104 >> 2] = e[I + 8 >> 2], y = e[I + 4 >> 2], e[S + 96 >> 2] = e[I >> 2], e[S + 100 >> 2] = y, e[I >> 2] = 0, e[I + 4 >> 2] = 0, e[I + 8 >> 2] = 0, e[5996] = 0, y = wn(97, S + 96 | 0, 5242) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                                          break y;
                                                                                        if (Q = e[y >> 2], e[S + 48 >> 2] = e[y + 4 >> 2], C = Je[y + 7 | 0] | Je[y + 8 | 0] << 8 | (Je[y + 9 | 0] << 16 | Je[y + 10 | 0] << 24), Se[S + 51 | 0] = C, Se[S + 52 | 0] = C >>> 8, Se[S + 53 | 0] = C >>> 16, Se[S + 54 | 0] = C >>> 24, e[y >> 2] = 0, e[y + 4 >> 2] = 0, C = Je[y + 11 | 0], e[y + 8 >> 2] = 0, e[l >> 2] = Q, e[l + 4 >> 2] = e[S + 48 >> 2], y = Je[S + 51 | 0] | Je[S + 52 | 0] << 8 | (Je[S + 53 | 0] << 16 | Je[S + 54 | 0] << 24), Se[l + 7 | 0] = y, Se[l + 8 | 0] = y >>> 8, Se[l + 9 | 0] = y >>> 16, Se[l + 10 | 0] = y >>> 24, Se[l + 12 | 0] = 1, Se[l + 11 | 0] = C, Se[S + 75 | 0] < 0 && Tr(e[S + 64 >> 2]), Se[I + 11 | 0] >= 0)
                                                                                          break t;
                                                                                        Tr(e[I >> 2]);
                                                                                        break t;
                                                                                      }
                                                                                      break p;
                                                                                    }
                                                                                    l = gi() | 0;
                                                                                    break e;
                                                                                  }
                                                                                  l = gi() | 0;
                                                                                  break B;
                                                                                }
                                                                                if (l = gi() | 0, Se[S + 107 | 0] >= 0)
                                                                                  break B;
                                                                                Tr(e[S + 96 >> 2]);
                                                                              }
                                                                              break f;
                                                                            case 1:
                                                                              if (e[5996] = 0, y = wn(97, S + 116 | 0, 4180) | 0, I = e[5996], e[5996] = 0, (I | 0) != 1) {
                                                                                C = e[y >> 2], e[S + 96 >> 2] = e[y + 4 >> 2], I = Je[y + 7 | 0] | Je[y + 8 | 0] << 8 | (Je[y + 9 | 0] << 16 | Je[y + 10 | 0] << 24), Se[S + 99 | 0] = I, Se[S + 100 | 0] = I >>> 8, Se[S + 101 | 0] = I >>> 16, Se[S + 102 | 0] = I >>> 24, I = Je[S + 127 | 0], e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, e[l >> 2] = C, e[l + 4 >> 2] = e[S + 96 >> 2], y = Je[S + 99 | 0] | Je[S + 100 | 0] << 8 | (Je[S + 101 | 0] << 16 | Je[S + 102 | 0] << 24), Se[l + 7 | 0] = y, Se[l + 8 | 0] = y >>> 8, Se[l + 9 | 0] = y >>> 16, Se[l + 10 | 0] = y >>> 24, Se[l + 12 | 0] = 1, Se[l + 11 | 0] = I;
                                                                                break t;
                                                                              }
                                                                              l = gi() | 0;
                                                                              break e;
                                                                            case 24:
                                                                              break R;
                                                                            case 25:
                                                                              break E;
                                                                            case 23:
                                                                              break w;
                                                                            case 20:
                                                                              break l;
                                                                            case 21:
                                                                              break T;
                                                                            case 19:
                                                                              break m;
                                                                            case 18:
                                                                              break C;
                                                                            case 0:
                                                                              break b;
                                                                            default:
                                                                              break k;
                                                                          }
                                                                        if (e[5996] = 0, y = wn(97, S + 116 | 0, 4350) | 0, I = e[5996], e[5996] = 0, (I | 0) != 1) {
                                                                          C = e[y >> 2], e[S + 96 >> 2] = e[y + 4 >> 2], I = Je[y + 7 | 0] | Je[y + 8 | 0] << 8 | (Je[y + 9 | 0] << 16 | Je[y + 10 | 0] << 24), Se[S + 99 | 0] = I, Se[S + 100 | 0] = I >>> 8, Se[S + 101 | 0] = I >>> 16, Se[S + 102 | 0] = I >>> 24, I = Je[S + 127 | 0], e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, e[l >> 2] = C, e[l + 4 >> 2] = e[S + 96 >> 2], y = Je[S + 99 | 0] | Je[S + 100 | 0] << 8 | (Je[S + 101 | 0] << 16 | Je[S + 102 | 0] << 24), Se[l + 7 | 0] = y, Se[l + 8 | 0] = y >>> 8, Se[l + 9 | 0] = y >>> 16, Se[l + 10 | 0] = y >>> 24, Se[l + 12 | 0] = 1, Se[l + 11 | 0] = I;
                                                                          break t;
                                                                        }
                                                                        l = gi() | 0;
                                                                        break e;
                                                                      }
                                                                      e[5996] = 0, y = wn(97, S + 116 | 0, 5244) | 0, I = e[5996], e[5996] = 0;
                                                                      D: {
                                                                        b: {
                                                                          B: {
                                                                            y: {
                                                                              x: {
                                                                                P: {
                                                                                  M: {
                                                                                    if ((I | 0) != 1) {
                                                                                      if (e[S + 56 >> 2] = e[y + 8 >> 2], I = e[y + 4 >> 2], e[S + 48 >> 2] = e[y >> 2], e[S + 52 >> 2] = I, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, I = e[C >> 2], Q = e[C + 4 >> 2], y = Je[C + 11 | 0], e[5996] = 0, ke = I, I = y << 24 >> 24 < 0, I = Ko(100, S + 48 | 0, (I ? ke : C) | 0, (I ? Q : y) | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                        break M;
                                                                                      if (e[S + 72 >> 2] = e[I + 8 >> 2], y = e[I + 4 >> 2], e[S + 64 >> 2] = e[I >> 2], e[S + 68 >> 2] = y, e[I >> 2] = 0, e[I + 4 >> 2] = 0, e[I + 8 >> 2] = 0, e[5996] = 0, Q = wn(97, S - -64 | 0, 4354) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                        break P;
                                                                                      if (e[S + 88 >> 2] = e[Q + 8 >> 2], y = e[Q + 4 >> 2], e[S + 80 >> 2] = e[Q >> 2], e[S + 84 >> 2] = y, e[Q >> 2] = 0, e[Q + 4 >> 2] = 0, e[Q + 8 >> 2] = 0, me = e[C + 16 >> 2], ke = e[C + 12 >> 2], y = Je[C + 23 | 0], e[5996] = 0, Ar = C + 12 | 0, C = y << 24 >> 24 < 0, C = Ko(100, S + 80 | 0, (C ? ke : Ar) | 0, (C ? me : y) | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                        break x;
                                                                                      if (e[S + 104 >> 2] = e[C + 8 >> 2], y = e[C + 4 >> 2], e[S + 96 >> 2] = e[C >> 2], e[S + 100 >> 2] = y, e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[C + 8 >> 2] = 0, e[5996] = 0, y = wn(97, S + 96 | 0, 5242) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                                                        break y;
                                                                                      if (ke = e[y >> 2], e[S + 24 >> 2] = e[y + 4 >> 2], me = Je[y + 7 | 0] | Je[y + 8 | 0] << 8 | (Je[y + 9 | 0] << 16 | Je[y + 10 | 0] << 24), Se[S + 27 | 0] = me, Se[S + 28 | 0] = me >>> 8, Se[S + 29 | 0] = me >>> 16, Se[S + 30 | 0] = me >>> 24, e[y >> 2] = 0, e[y + 4 >> 2] = 0, me = Je[y + 11 | 0], e[y + 8 >> 2] = 0, e[l >> 2] = ke, e[l + 4 >> 2] = e[S + 24 >> 2], y = Je[S + 27 | 0] | Je[S + 28 | 0] << 8 | (Je[S + 29 | 0] << 16 | Je[S + 30 | 0] << 24), Se[l + 7 | 0] = y, Se[l + 8 | 0] = y >>> 8, Se[l + 9 | 0] = y >>> 16, Se[l + 10 | 0] = y >>> 24, Se[l + 12 | 0] = 1, Se[l + 11 | 0] = me, Se[C + 11 | 0] < 0 && Tr(e[C >> 2]), Se[Q + 11 | 0] < 0 && Tr(e[Q >> 2]), Se[I + 11 | 0] >= 0)
                                                                                        break t;
                                                                                      Tr(e[I >> 2]);
                                                                                      break t;
                                                                                    }
                                                                                    l = gi() | 0;
                                                                                    break e;
                                                                                  }
                                                                                  l = gi() | 0;
                                                                                  break D;
                                                                                }
                                                                                l = gi() | 0;
                                                                                break b;
                                                                              }
                                                                              l = gi() | 0;
                                                                              break B;
                                                                            }
                                                                            if (l = gi() | 0, Se[S + 107 | 0] >= 0)
                                                                              break B;
                                                                            Tr(e[S + 96 >> 2]);
                                                                          }
                                                                          if (Se[S + 91 | 0] >= 0)
                                                                            break b;
                                                                          Tr(e[S + 80 >> 2]);
                                                                        }
                                                                        if (Se[S + 75 | 0] >= 0)
                                                                          break D;
                                                                        Tr(e[S + 64 >> 2]);
                                                                      }
                                                                      if (Se[S + 59 | 0] >= 0)
                                                                        break e;
                                                                      Tr(e[S + 48 >> 2]);
                                                                      break e;
                                                                    }
                                                                    e[5996] = 0, y = wn(97, S + 116 | 0, 5339) | 0, I = e[5996], e[5996] = 0;
                                                                    C: {
                                                                      D: {
                                                                        b: {
                                                                          B: {
                                                                            y: {
                                                                              x: {
                                                                                P: {
                                                                                  if ((I | 0) != 1) {
                                                                                    if (e[S + 56 >> 2] = e[y + 8 >> 2], I = e[y + 4 >> 2], e[S + 48 >> 2] = e[y >> 2], e[S + 52 >> 2] = I, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, I = e[C >> 2], Q = e[C + 4 >> 2], y = Je[C + 11 | 0], e[5996] = 0, ke = I, I = y << 24 >> 24 < 0, I = Ko(100, S + 48 | 0, (I ? ke : C) | 0, (I ? Q : y) | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                      break P;
                                                                                    if (e[S + 72 >> 2] = e[I + 8 >> 2], y = e[I + 4 >> 2], e[S + 64 >> 2] = e[I >> 2], e[S + 68 >> 2] = y, e[I >> 2] = 0, e[I + 4 >> 2] = 0, e[I + 8 >> 2] = 0, e[5996] = 0, Q = wn(97, S - -64 | 0, 4354) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                      break x;
                                                                                    if (e[S + 88 >> 2] = e[Q + 8 >> 2], y = e[Q + 4 >> 2], e[S + 80 >> 2] = e[Q >> 2], e[S + 84 >> 2] = y, e[Q >> 2] = 0, e[Q + 4 >> 2] = 0, e[Q + 8 >> 2] = 0, me = e[C + 16 >> 2], ke = e[C + 12 >> 2], y = Je[C + 23 | 0], e[5996] = 0, Ar = C + 12 | 0, C = y << 24 >> 24 < 0, C = Ko(100, S + 80 | 0, (C ? ke : Ar) | 0, (C ? me : y) | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                      break y;
                                                                                    if (e[S + 104 >> 2] = e[C + 8 >> 2], y = e[C + 4 >> 2], e[S + 96 >> 2] = e[C >> 2], e[S + 100 >> 2] = y, e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[C + 8 >> 2] = 0, e[5996] = 0, y = wn(97, S + 96 | 0, 5242) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                                                      break B;
                                                                                    if (ke = e[y >> 2], e[S + 24 >> 2] = e[y + 4 >> 2], me = Je[y + 7 | 0] | Je[y + 8 | 0] << 8 | (Je[y + 9 | 0] << 16 | Je[y + 10 | 0] << 24), Se[S + 27 | 0] = me, Se[S + 28 | 0] = me >>> 8, Se[S + 29 | 0] = me >>> 16, Se[S + 30 | 0] = me >>> 24, e[y >> 2] = 0, e[y + 4 >> 2] = 0, me = Je[y + 11 | 0], e[y + 8 >> 2] = 0, e[l >> 2] = ke, e[l + 4 >> 2] = e[S + 24 >> 2], y = Je[S + 27 | 0] | Je[S + 28 | 0] << 8 | (Je[S + 29 | 0] << 16 | Je[S + 30 | 0] << 24), Se[l + 7 | 0] = y, Se[l + 8 | 0] = y >>> 8, Se[l + 9 | 0] = y >>> 16, Se[l + 10 | 0] = y >>> 24, Se[l + 12 | 0] = 1, Se[l + 11 | 0] = me, Se[C + 11 | 0] < 0 && Tr(e[C >> 2]), Se[Q + 11 | 0] < 0 && Tr(e[Q >> 2]), Se[I + 11 | 0] >= 0)
                                                                                      break t;
                                                                                    Tr(e[I >> 2]);
                                                                                    break t;
                                                                                  }
                                                                                  l = gi() | 0;
                                                                                  break e;
                                                                                }
                                                                                l = gi() | 0;
                                                                                break C;
                                                                              }
                                                                              l = gi() | 0;
                                                                              break D;
                                                                            }
                                                                            l = gi() | 0;
                                                                            break b;
                                                                          }
                                                                          if (l = gi() | 0, Se[S + 107 | 0] >= 0)
                                                                            break b;
                                                                          Tr(e[S + 96 >> 2]);
                                                                        }
                                                                        if (Se[S + 91 | 0] >= 0)
                                                                          break D;
                                                                        Tr(e[S + 80 >> 2]);
                                                                      }
                                                                      if (Se[S + 75 | 0] >= 0)
                                                                        break C;
                                                                      Tr(e[S + 64 >> 2]);
                                                                    }
                                                                    if (Se[S + 59 | 0] >= 0)
                                                                      break e;
                                                                    Tr(e[S + 48 >> 2]);
                                                                    break e;
                                                                  }
                                                                  e[5996] = 0, y = wn(97, S + 116 | 0, 5333) | 0, I = e[5996], e[5996] = 0;
                                                                  m: {
                                                                    C: {
                                                                      D: {
                                                                        b: {
                                                                          B: {
                                                                            y: {
                                                                              x: {
                                                                                if ((I | 0) != 1) {
                                                                                  if (e[S + 56 >> 2] = e[y + 8 >> 2], I = e[y + 4 >> 2], e[S + 48 >> 2] = e[y >> 2], e[S + 52 >> 2] = I, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, I = e[C >> 2], Q = e[C + 4 >> 2], y = Je[C + 11 | 0], e[5996] = 0, ke = I, I = y << 24 >> 24 < 0, I = Ko(100, S + 48 | 0, (I ? ke : C) | 0, (I ? Q : y) | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                    break x;
                                                                                  if (e[S + 72 >> 2] = e[I + 8 >> 2], y = e[I + 4 >> 2], e[S + 64 >> 2] = e[I >> 2], e[S + 68 >> 2] = y, e[I >> 2] = 0, e[I + 4 >> 2] = 0, e[I + 8 >> 2] = 0, e[5996] = 0, Q = wn(97, S - -64 | 0, 4354) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                    break y;
                                                                                  if (e[S + 88 >> 2] = e[Q + 8 >> 2], y = e[Q + 4 >> 2], e[S + 80 >> 2] = e[Q >> 2], e[S + 84 >> 2] = y, e[Q >> 2] = 0, e[Q + 4 >> 2] = 0, e[Q + 8 >> 2] = 0, me = e[C + 16 >> 2], ke = e[C + 12 >> 2], y = Je[C + 23 | 0], e[5996] = 0, Ar = C + 12 | 0, C = y << 24 >> 24 < 0, C = Ko(100, S + 80 | 0, (C ? ke : Ar) | 0, (C ? me : y) | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                    break B;
                                                                                  if (e[S + 104 >> 2] = e[C + 8 >> 2], y = e[C + 4 >> 2], e[S + 96 >> 2] = e[C >> 2], e[S + 100 >> 2] = y, e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[C + 8 >> 2] = 0, e[5996] = 0, y = wn(97, S + 96 | 0, 5242) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                                                    break b;
                                                                                  if (ke = e[y >> 2], e[S + 24 >> 2] = e[y + 4 >> 2], me = Je[y + 7 | 0] | Je[y + 8 | 0] << 8 | (Je[y + 9 | 0] << 16 | Je[y + 10 | 0] << 24), Se[S + 27 | 0] = me, Se[S + 28 | 0] = me >>> 8, Se[S + 29 | 0] = me >>> 16, Se[S + 30 | 0] = me >>> 24, e[y >> 2] = 0, e[y + 4 >> 2] = 0, me = Je[y + 11 | 0], e[y + 8 >> 2] = 0, e[l >> 2] = ke, e[l + 4 >> 2] = e[S + 24 >> 2], y = Je[S + 27 | 0] | Je[S + 28 | 0] << 8 | (Je[S + 29 | 0] << 16 | Je[S + 30 | 0] << 24), Se[l + 7 | 0] = y, Se[l + 8 | 0] = y >>> 8, Se[l + 9 | 0] = y >>> 16, Se[l + 10 | 0] = y >>> 24, Se[l + 12 | 0] = 1, Se[l + 11 | 0] = me, Se[C + 11 | 0] < 0 && Tr(e[C >> 2]), Se[Q + 11 | 0] < 0 && Tr(e[Q >> 2]), Se[I + 11 | 0] >= 0)
                                                                                    break t;
                                                                                  Tr(e[I >> 2]);
                                                                                  break t;
                                                                                }
                                                                                l = gi() | 0;
                                                                                break e;
                                                                              }
                                                                              l = gi() | 0;
                                                                              break m;
                                                                            }
                                                                            l = gi() | 0;
                                                                            break C;
                                                                          }
                                                                          l = gi() | 0;
                                                                          break D;
                                                                        }
                                                                        if (l = gi() | 0, Se[S + 107 | 0] >= 0)
                                                                          break D;
                                                                        Tr(e[S + 96 >> 2]);
                                                                      }
                                                                      if (Se[S + 91 | 0] >= 0)
                                                                        break C;
                                                                      Tr(e[S + 80 >> 2]);
                                                                    }
                                                                    if (Se[S + 75 | 0] >= 0)
                                                                      break m;
                                                                    Tr(e[S + 64 >> 2]);
                                                                  }
                                                                  if (Se[S + 59 | 0] >= 0)
                                                                    break e;
                                                                  Tr(e[S + 48 >> 2]);
                                                                  break e;
                                                                }
                                                                e[5996] = 0, y = wn(97, S + 116 | 0, 5321) | 0, I = e[5996], e[5996] = 0;
                                                                T: {
                                                                  m: {
                                                                    C: {
                                                                      D: {
                                                                        b: {
                                                                          B: {
                                                                            y: {
                                                                              if ((I | 0) != 1) {
                                                                                if (e[S + 56 >> 2] = e[y + 8 >> 2], I = e[y + 4 >> 2], e[S + 48 >> 2] = e[y >> 2], e[S + 52 >> 2] = I, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, I = e[C >> 2], Q = e[C + 4 >> 2], y = Je[C + 11 | 0], e[5996] = 0, ke = I, I = y << 24 >> 24 < 0, I = Ko(100, S + 48 | 0, (I ? ke : C) | 0, (I ? Q : y) | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                  break y;
                                                                                if (e[S + 72 >> 2] = e[I + 8 >> 2], y = e[I + 4 >> 2], e[S + 64 >> 2] = e[I >> 2], e[S + 68 >> 2] = y, e[I >> 2] = 0, e[I + 4 >> 2] = 0, e[I + 8 >> 2] = 0, e[5996] = 0, Q = wn(97, S - -64 | 0, 4354) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                  break B;
                                                                                if (e[S + 88 >> 2] = e[Q + 8 >> 2], y = e[Q + 4 >> 2], e[S + 80 >> 2] = e[Q >> 2], e[S + 84 >> 2] = y, e[Q >> 2] = 0, e[Q + 4 >> 2] = 0, e[Q + 8 >> 2] = 0, me = e[C + 16 >> 2], ke = e[C + 12 >> 2], y = Je[C + 23 | 0], e[5996] = 0, Ar = C + 12 | 0, C = y << 24 >> 24 < 0, C = Ko(100, S + 80 | 0, (C ? ke : Ar) | 0, (C ? me : y) | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                  break b;
                                                                                if (e[S + 104 >> 2] = e[C + 8 >> 2], y = e[C + 4 >> 2], e[S + 96 >> 2] = e[C >> 2], e[S + 100 >> 2] = y, e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[C + 8 >> 2] = 0, e[5996] = 0, y = wn(97, S + 96 | 0, 5242) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                                                  break D;
                                                                                if (ke = e[y >> 2], e[S + 24 >> 2] = e[y + 4 >> 2], me = Je[y + 7 | 0] | Je[y + 8 | 0] << 8 | (Je[y + 9 | 0] << 16 | Je[y + 10 | 0] << 24), Se[S + 27 | 0] = me, Se[S + 28 | 0] = me >>> 8, Se[S + 29 | 0] = me >>> 16, Se[S + 30 | 0] = me >>> 24, e[y >> 2] = 0, e[y + 4 >> 2] = 0, me = Je[y + 11 | 0], e[y + 8 >> 2] = 0, e[l >> 2] = ke, e[l + 4 >> 2] = e[S + 24 >> 2], y = Je[S + 27 | 0] | Je[S + 28 | 0] << 8 | (Je[S + 29 | 0] << 16 | Je[S + 30 | 0] << 24), Se[l + 7 | 0] = y, Se[l + 8 | 0] = y >>> 8, Se[l + 9 | 0] = y >>> 16, Se[l + 10 | 0] = y >>> 24, Se[l + 12 | 0] = 1, Se[l + 11 | 0] = me, Se[C + 11 | 0] < 0 && Tr(e[C >> 2]), Se[Q + 11 | 0] < 0 && Tr(e[Q >> 2]), Se[I + 11 | 0] >= 0)
                                                                                  break t;
                                                                                Tr(e[I >> 2]);
                                                                                break t;
                                                                              }
                                                                              l = gi() | 0;
                                                                              break e;
                                                                            }
                                                                            l = gi() | 0;
                                                                            break T;
                                                                          }
                                                                          l = gi() | 0;
                                                                          break m;
                                                                        }
                                                                        l = gi() | 0;
                                                                        break C;
                                                                      }
                                                                      if (l = gi() | 0, Se[S + 107 | 0] >= 0)
                                                                        break C;
                                                                      Tr(e[S + 96 >> 2]);
                                                                    }
                                                                    if (Se[S + 91 | 0] >= 0)
                                                                      break m;
                                                                    Tr(e[S + 80 >> 2]);
                                                                  }
                                                                  if (Se[S + 75 | 0] >= 0)
                                                                    break T;
                                                                  Tr(e[S + 64 >> 2]);
                                                                }
                                                                if (Se[S + 59 | 0] >= 0)
                                                                  break e;
                                                                Tr(e[S + 48 >> 2]);
                                                                break e;
                                                              }
                                                              e[5996] = 0, y = wn(97, S + 116 | 0, 5327) | 0, I = e[5996], e[5996] = 0;
                                                              l: {
                                                                T: {
                                                                  m: {
                                                                    C: {
                                                                      D: {
                                                                        b: {
                                                                          B: {
                                                                            if ((I | 0) != 1) {
                                                                              if (e[S + 56 >> 2] = e[y + 8 >> 2], I = e[y + 4 >> 2], e[S + 48 >> 2] = e[y >> 2], e[S + 52 >> 2] = I, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, I = e[C >> 2], Q = e[C + 4 >> 2], y = Je[C + 11 | 0], e[5996] = 0, ke = I, I = y << 24 >> 24 < 0, I = Ko(100, S + 48 | 0, (I ? ke : C) | 0, (I ? Q : y) | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                break B;
                                                                              if (e[S + 72 >> 2] = e[I + 8 >> 2], y = e[I + 4 >> 2], e[S + 64 >> 2] = e[I >> 2], e[S + 68 >> 2] = y, e[I >> 2] = 0, e[I + 4 >> 2] = 0, e[I + 8 >> 2] = 0, e[5996] = 0, Q = wn(97, S - -64 | 0, 4354) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                break b;
                                                                              if (e[S + 88 >> 2] = e[Q + 8 >> 2], y = e[Q + 4 >> 2], e[S + 80 >> 2] = e[Q >> 2], e[S + 84 >> 2] = y, e[Q >> 2] = 0, e[Q + 4 >> 2] = 0, e[Q + 8 >> 2] = 0, me = e[C + 16 >> 2], ke = e[C + 12 >> 2], y = Je[C + 23 | 0], e[5996] = 0, Ar = C + 12 | 0, C = y << 24 >> 24 < 0, C = Ko(100, S + 80 | 0, (C ? ke : Ar) | 0, (C ? me : y) | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                break D;
                                                                              if (e[S + 104 >> 2] = e[C + 8 >> 2], y = e[C + 4 >> 2], e[S + 96 >> 2] = e[C >> 2], e[S + 100 >> 2] = y, e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[C + 8 >> 2] = 0, e[5996] = 0, y = wn(97, S + 96 | 0, 5242) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                                                break C;
                                                                              if (ke = e[y >> 2], e[S + 24 >> 2] = e[y + 4 >> 2], me = Je[y + 7 | 0] | Je[y + 8 | 0] << 8 | (Je[y + 9 | 0] << 16 | Je[y + 10 | 0] << 24), Se[S + 27 | 0] = me, Se[S + 28 | 0] = me >>> 8, Se[S + 29 | 0] = me >>> 16, Se[S + 30 | 0] = me >>> 24, e[y >> 2] = 0, e[y + 4 >> 2] = 0, me = Je[y + 11 | 0], e[y + 8 >> 2] = 0, e[l >> 2] = ke, e[l + 4 >> 2] = e[S + 24 >> 2], y = Je[S + 27 | 0] | Je[S + 28 | 0] << 8 | (Je[S + 29 | 0] << 16 | Je[S + 30 | 0] << 24), Se[l + 7 | 0] = y, Se[l + 8 | 0] = y >>> 8, Se[l + 9 | 0] = y >>> 16, Se[l + 10 | 0] = y >>> 24, Se[l + 12 | 0] = 1, Se[l + 11 | 0] = me, Se[C + 11 | 0] < 0 && Tr(e[C >> 2]), Se[Q + 11 | 0] < 0 && Tr(e[Q >> 2]), Se[I + 11 | 0] >= 0)
                                                                                break t;
                                                                              Tr(e[I >> 2]);
                                                                              break t;
                                                                            }
                                                                            l = gi() | 0;
                                                                            break e;
                                                                          }
                                                                          l = gi() | 0;
                                                                          break l;
                                                                        }
                                                                        l = gi() | 0;
                                                                        break T;
                                                                      }
                                                                      l = gi() | 0;
                                                                      break m;
                                                                    }
                                                                    if (l = gi() | 0, Se[S + 107 | 0] >= 0)
                                                                      break m;
                                                                    Tr(e[S + 96 >> 2]);
                                                                  }
                                                                  if (Se[S + 91 | 0] >= 0)
                                                                    break T;
                                                                  Tr(e[S + 80 >> 2]);
                                                                }
                                                                if (Se[S + 75 | 0] >= 0)
                                                                  break l;
                                                                Tr(e[S + 64 >> 2]);
                                                              }
                                                              if (Se[S + 59 | 0] >= 0)
                                                                break e;
                                                              Tr(e[S + 48 >> 2]);
                                                              break e;
                                                            }
                                                            e[5996] = 0, y = wn(97, S + 116 | 0, 5296) | 0, I = e[5996], e[5996] = 0;
                                                            I: {
                                                              l: {
                                                                T: {
                                                                  m: {
                                                                    C: {
                                                                      D: {
                                                                        b: {
                                                                          if ((I | 0) != 1) {
                                                                            if (e[S + 56 >> 2] = e[y + 8 >> 2], I = e[y + 4 >> 2], e[S + 48 >> 2] = e[y >> 2], e[S + 52 >> 2] = I, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, I = e[C >> 2], Q = e[C + 4 >> 2], y = Je[C + 11 | 0], e[5996] = 0, ke = I, I = y << 24 >> 24 < 0, I = Ko(100, S + 48 | 0, (I ? ke : C) | 0, (I ? Q : y) | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                              break b;
                                                                            if (e[S + 72 >> 2] = e[I + 8 >> 2], y = e[I + 4 >> 2], e[S + 64 >> 2] = e[I >> 2], e[S + 68 >> 2] = y, e[I >> 2] = 0, e[I + 4 >> 2] = 0, e[I + 8 >> 2] = 0, e[5996] = 0, Q = wn(97, S - -64 | 0, 4354) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                              break D;
                                                                            if (e[S + 88 >> 2] = e[Q + 8 >> 2], y = e[Q + 4 >> 2], e[S + 80 >> 2] = e[Q >> 2], e[S + 84 >> 2] = y, e[Q >> 2] = 0, e[Q + 4 >> 2] = 0, e[Q + 8 >> 2] = 0, me = e[C + 16 >> 2], ke = e[C + 12 >> 2], y = Je[C + 23 | 0], e[5996] = 0, Ar = C + 12 | 0, C = y << 24 >> 24 < 0, C = Ko(100, S + 80 | 0, (C ? ke : Ar) | 0, (C ? me : y) | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                              break C;
                                                                            if (e[S + 104 >> 2] = e[C + 8 >> 2], y = e[C + 4 >> 2], e[S + 96 >> 2] = e[C >> 2], e[S + 100 >> 2] = y, e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[C + 8 >> 2] = 0, e[5996] = 0, y = wn(97, S + 96 | 0, 5242) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                                              break m;
                                                                            if (ke = e[y >> 2], e[S + 24 >> 2] = e[y + 4 >> 2], me = Je[y + 7 | 0] | Je[y + 8 | 0] << 8 | (Je[y + 9 | 0] << 16 | Je[y + 10 | 0] << 24), Se[S + 27 | 0] = me, Se[S + 28 | 0] = me >>> 8, Se[S + 29 | 0] = me >>> 16, Se[S + 30 | 0] = me >>> 24, e[y >> 2] = 0, e[y + 4 >> 2] = 0, me = Je[y + 11 | 0], e[y + 8 >> 2] = 0, e[l >> 2] = ke, e[l + 4 >> 2] = e[S + 24 >> 2], y = Je[S + 27 | 0] | Je[S + 28 | 0] << 8 | (Je[S + 29 | 0] << 16 | Je[S + 30 | 0] << 24), Se[l + 7 | 0] = y, Se[l + 8 | 0] = y >>> 8, Se[l + 9 | 0] = y >>> 16, Se[l + 10 | 0] = y >>> 24, Se[l + 12 | 0] = 1, Se[l + 11 | 0] = me, Se[C + 11 | 0] < 0 && Tr(e[C >> 2]), Se[Q + 11 | 0] < 0 && Tr(e[Q >> 2]), Se[I + 11 | 0] >= 0)
                                                                              break t;
                                                                            Tr(e[I >> 2]);
                                                                            break t;
                                                                          }
                                                                          l = gi() | 0;
                                                                          break e;
                                                                        }
                                                                        l = gi() | 0;
                                                                        break I;
                                                                      }
                                                                      l = gi() | 0;
                                                                      break l;
                                                                    }
                                                                    l = gi() | 0;
                                                                    break T;
                                                                  }
                                                                  if (l = gi() | 0, Se[S + 107 | 0] >= 0)
                                                                    break T;
                                                                  Tr(e[S + 96 >> 2]);
                                                                }
                                                                if (Se[S + 91 | 0] >= 0)
                                                                  break l;
                                                                Tr(e[S + 80 >> 2]);
                                                              }
                                                              if (Se[S + 75 | 0] >= 0)
                                                                break I;
                                                              Tr(e[S + 64 >> 2]);
                                                            }
                                                            if (Se[S + 59 | 0] >= 0)
                                                              break e;
                                                            Tr(e[S + 48 >> 2]);
                                                            break e;
                                                          }
                                                          if (!e[e[e[I + 32 >> 2] + 16 >> 2] >> 2]) {
                                                            e[5996] = 0, y = wn(97, S + 116 | 0, 5272) | 0, I = e[5996], e[5996] = 0;
                                                            w: {
                                                              I: {
                                                                l: {
                                                                  T: {
                                                                    m: {
                                                                      C: {
                                                                        D: {
                                                                          if ((I | 0) != 1) {
                                                                            if (e[S + 56 >> 2] = e[y + 8 >> 2], I = e[y + 4 >> 2], e[S + 48 >> 2] = e[y >> 2], e[S + 52 >> 2] = I, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, I = e[C >> 2], Q = e[C + 4 >> 2], y = Je[C + 11 | 0], e[5996] = 0, ke = I, I = y << 24 >> 24 < 0, I = Ko(100, S + 48 | 0, (I ? ke : C) | 0, (I ? Q : y) | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                              break D;
                                                                            if (e[S + 72 >> 2] = e[I + 8 >> 2], y = e[I + 4 >> 2], e[S + 64 >> 2] = e[I >> 2], e[S + 68 >> 2] = y, e[I >> 2] = 0, e[I + 4 >> 2] = 0, e[I + 8 >> 2] = 0, e[5996] = 0, Q = wn(97, S - -64 | 0, 4354) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                              break C;
                                                                            if (e[S + 88 >> 2] = e[Q + 8 >> 2], y = e[Q + 4 >> 2], e[S + 80 >> 2] = e[Q >> 2], e[S + 84 >> 2] = y, e[Q >> 2] = 0, e[Q + 4 >> 2] = 0, e[Q + 8 >> 2] = 0, me = e[C + 16 >> 2], ke = e[C + 12 >> 2], y = Je[C + 23 | 0], e[5996] = 0, Ar = C + 12 | 0, C = y << 24 >> 24 < 0, C = Ko(100, S + 80 | 0, (C ? ke : Ar) | 0, (C ? me : y) | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                              break m;
                                                                            if (e[S + 104 >> 2] = e[C + 8 >> 2], y = e[C + 4 >> 2], e[S + 96 >> 2] = e[C >> 2], e[S + 100 >> 2] = y, e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[C + 8 >> 2] = 0, e[5996] = 0, y = wn(97, S + 96 | 0, 5242) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                                              break T;
                                                                            if (ke = e[y >> 2], e[S + 24 >> 2] = e[y + 4 >> 2], me = Je[y + 7 | 0] | Je[y + 8 | 0] << 8 | (Je[y + 9 | 0] << 16 | Je[y + 10 | 0] << 24), Se[S + 27 | 0] = me, Se[S + 28 | 0] = me >>> 8, Se[S + 29 | 0] = me >>> 16, Se[S + 30 | 0] = me >>> 24, e[y >> 2] = 0, e[y + 4 >> 2] = 0, me = Je[y + 11 | 0], e[y + 8 >> 2] = 0, e[l >> 2] = ke, e[l + 4 >> 2] = e[S + 24 >> 2], y = Je[S + 27 | 0] | Je[S + 28 | 0] << 8 | (Je[S + 29 | 0] << 16 | Je[S + 30 | 0] << 24), Se[l + 7 | 0] = y, Se[l + 8 | 0] = y >>> 8, Se[l + 9 | 0] = y >>> 16, Se[l + 10 | 0] = y >>> 24, Se[l + 12 | 0] = 1, Se[l + 11 | 0] = me, Se[C + 11 | 0] < 0 && Tr(e[C >> 2]), Se[Q + 11 | 0] < 0 && Tr(e[Q >> 2]), Se[I + 11 | 0] >= 0)
                                                                              break t;
                                                                            Tr(e[I >> 2]);
                                                                            break t;
                                                                          }
                                                                          l = gi() | 0;
                                                                          break e;
                                                                        }
                                                                        l = gi() | 0;
                                                                        break w;
                                                                      }
                                                                      l = gi() | 0;
                                                                      break I;
                                                                    }
                                                                    l = gi() | 0;
                                                                    break l;
                                                                  }
                                                                  if (l = gi() | 0, Se[S + 107 | 0] >= 0)
                                                                    break l;
                                                                  Tr(e[S + 96 >> 2]);
                                                                }
                                                                if (Se[S + 91 | 0] >= 0)
                                                                  break I;
                                                                Tr(e[S + 80 >> 2]);
                                                              }
                                                              if (Se[S + 75 | 0] >= 0)
                                                                break w;
                                                              Tr(e[S + 64 >> 2]);
                                                            }
                                                            if (Se[S + 59 | 0] >= 0)
                                                              break e;
                                                            Tr(e[S + 48 >> 2]);
                                                            break e;
                                                          }
                                                          e[5996] = 0, y = wn(97, S + 116 | 0, 5251) | 0, I = e[5996], e[5996] = 0;
                                                          w: {
                                                            I: {
                                                              l: {
                                                                T: {
                                                                  m: {
                                                                    C: {
                                                                      D: {
                                                                        b: {
                                                                          B: {
                                                                            y: {
                                                                              x: {
                                                                                if ((I | 0) != 1) {
                                                                                  if (e[S + 16 >> 2] = e[y + 8 >> 2], I = e[y + 4 >> 2], e[S + 8 >> 2] = e[y >> 2], e[S + 12 >> 2] = I, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, I = e[C >> 2], Q = e[C + 4 >> 2], y = Je[C + 11 | 0], e[5996] = 0, ke = I, I = y << 24 >> 24 < 0, I = Ko(100, S + 8 | 0, (I ? ke : C) | 0, (I ? Q : y) | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                    break x;
                                                                                  if (e[S + 32 >> 2] = e[I + 8 >> 2], y = e[I + 4 >> 2], e[S + 24 >> 2] = e[I >> 2], e[S + 28 >> 2] = y, e[I >> 2] = 0, e[I + 4 >> 2] = 0, e[I + 8 >> 2] = 0, e[5996] = 0, Q = wn(97, S + 24 | 0, 4354) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                    break y;
                                                                                  if (e[S + 56 >> 2] = e[Q + 8 >> 2], y = e[Q + 4 >> 2], e[S + 48 >> 2] = e[Q >> 2], e[S + 52 >> 2] = y, e[Q >> 2] = 0, e[Q + 4 >> 2] = 0, e[Q + 8 >> 2] = 0, me = e[C + 16 >> 2], ke = e[C + 12 >> 2], y = Je[C + 23 | 0], e[5996] = 0, Ar = ke, ke = y << 24 >> 24 < 0, me = Ko(100, S + 48 | 0, (ke ? Ar : C + 12 | 0) | 0, (ke ? me : y) | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                    break B;
                                                                                  if (e[S + 72 >> 2] = e[me + 8 >> 2], y = e[me + 4 >> 2], e[S + 64 >> 2] = e[me >> 2], e[S + 68 >> 2] = y, e[me >> 2] = 0, e[me + 4 >> 2] = 0, e[me + 8 >> 2] = 0, e[5996] = 0, ke = wn(97, S - -64 | 0, 4354) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                    break b;
                                                                                  if (e[S + 88 >> 2] = e[ke + 8 >> 2], y = e[ke + 4 >> 2], e[S + 80 >> 2] = e[ke >> 2], e[S + 84 >> 2] = y, e[ke >> 2] = 0, e[ke + 4 >> 2] = 0, e[ke + 8 >> 2] = 0, Ar = e[C + 28 >> 2], br = e[C + 24 >> 2], y = Je[C + 35 | 0], e[5996] = 0, Qr = C + 24 | 0, C = y << 24 >> 24 < 0, C = Ko(100, S + 80 | 0, (C ? br : Qr) | 0, (C ? Ar : y) | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                    break D;
                                                                                  if (e[S + 104 >> 2] = e[C + 8 >> 2], y = e[C + 4 >> 2], e[S + 96 >> 2] = e[C >> 2], e[S + 100 >> 2] = y, e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[C + 8 >> 2] = 0, e[5996] = 0, y = wn(97, S + 96 | 0, 5242) | 0, Ar = e[5996], e[5996] = 0, (Ar | 0) == 1)
                                                                                    break C;
                                                                                  if (br = e[y >> 2], e[S + 40 >> 2] = e[y + 4 >> 2], Ar = Je[y + 7 | 0] | Je[y + 8 | 0] << 8 | (Je[y + 9 | 0] << 16 | Je[y + 10 | 0] << 24), Se[S + 43 | 0] = Ar, Se[S + 44 | 0] = Ar >>> 8, Se[S + 45 | 0] = Ar >>> 16, Se[S + 46 | 0] = Ar >>> 24, e[y >> 2] = 0, e[y + 4 >> 2] = 0, Ar = Je[y + 11 | 0], e[y + 8 >> 2] = 0, e[l >> 2] = br, e[l + 4 >> 2] = e[S + 40 >> 2], y = Je[S + 43 | 0] | Je[S + 44 | 0] << 8 | (Je[S + 45 | 0] << 16 | Je[S + 46 | 0] << 24), Se[l + 7 | 0] = y, Se[l + 8 | 0] = y >>> 8, Se[l + 9 | 0] = y >>> 16, Se[l + 10 | 0] = y >>> 24, Se[l + 12 | 0] = 1, Se[l + 11 | 0] = Ar, Se[C + 11 | 0] < 0 && Tr(e[C >> 2]), Se[ke + 11 | 0] < 0 && Tr(e[ke >> 2]), Se[me + 11 | 0] < 0 && Tr(e[me >> 2]), Se[Q + 11 | 0] < 0 && Tr(e[Q >> 2]), Se[I + 11 | 0] >= 0)
                                                                                    break t;
                                                                                  Tr(e[I >> 2]);
                                                                                  break t;
                                                                                }
                                                                                l = gi() | 0;
                                                                                break e;
                                                                              }
                                                                              l = gi() | 0;
                                                                              break w;
                                                                            }
                                                                            l = gi() | 0;
                                                                            break I;
                                                                          }
                                                                          l = gi() | 0;
                                                                          break l;
                                                                        }
                                                                        l = gi() | 0;
                                                                        break T;
                                                                      }
                                                                      l = gi() | 0;
                                                                      break m;
                                                                    }
                                                                    if (l = gi() | 0, Se[S + 107 | 0] >= 0)
                                                                      break m;
                                                                    Tr(e[S + 96 >> 2]);
                                                                  }
                                                                  if (Se[S + 91 | 0] >= 0)
                                                                    break T;
                                                                  Tr(e[S + 80 >> 2]);
                                                                }
                                                                if (Se[S + 75 | 0] >= 0)
                                                                  break l;
                                                                Tr(e[S + 64 >> 2]);
                                                              }
                                                              if (Se[S + 59 | 0] >= 0)
                                                                break I;
                                                              Tr(e[S + 48 >> 2]);
                                                            }
                                                            if (Se[S + 35 | 0] >= 0)
                                                              break w;
                                                            Tr(e[S + 24 >> 2]);
                                                          }
                                                          if (Se[S + 19 | 0] >= 0)
                                                            break e;
                                                          Tr(e[S + 8 >> 2]);
                                                          break e;
                                                        }
                                                        if (e[5996] = 0, y = wn(97, S + 116 | 0, 5289) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                          break d;
                                                        if (e[S + 72 >> 2] = e[y + 8 >> 2], C = e[y + 4 >> 2], e[S + 64 >> 2] = e[y >> 2], e[S + 68 >> 2] = C, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, e[5996] = 0, y = S + 96 | 0, Co(119, y | 0, I + 4 | 0), C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                          break v;
                                                        if (e[5996] = 0, Q = y, y = Je[S + 107 | 0], C = y << 24 >> 24 < 0, y = Ko(100, S - -64 | 0, (C ? e[S + 96 >> 2] : Q) | 0, (C ? e[S + 100 >> 2] : y) | 0) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                          break _;
                                                        e[S + 88 >> 2] = e[y + 8 >> 2], C = e[y + 4 >> 2], e[S + 80 >> 2] = e[y >> 2], e[S + 84 >> 2] = C, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0;
                                                        E: {
                                                          if (Se[S + 107 | 0] >= 0 || (Tr(e[S + 96 >> 2]), Se[y + 11 | 0] >= 0))
                                                            break E;
                                                          Tr(e[y >> 2]);
                                                        }
                                                        E: {
                                                          w: {
                                                            I: {
                                                              l: {
                                                                T: {
                                                                  if (y = e[I + 8 >> 2], C = e[I + 12 >> 2], (y | 0) != (C | 0))
                                                                    for (; ; ) {
                                                                      m: {
                                                                        if (Se[y + 11 | 0] >= 0) {
                                                                          e[S + 104 >> 2] = e[y + 8 >> 2], I = e[y + 4 >> 2], e[S + 96 >> 2] = e[y >> 2], e[S + 100 >> 2] = I;
                                                                          break m;
                                                                        }
                                                                        if (I = e[y + 4 >> 2], Q = e[y >> 2], e[5996] = 0, Ms(40, S + 96 | 0, Q | 0, I | 0), I = e[5996], e[5996] = 0, (I | 0) != 1)
                                                                          break m;
                                                                        l = gi() | 0;
                                                                        break w;
                                                                      }
                                                                      if (e[5996] = 0, Se[S + 108 | 0] = 1, I = Ko(99, S + 96 | 0, 0, 4354) | 0, Q = e[5996], e[5996] = 0, (Q | 0) == 1)
                                                                        break T;
                                                                      if (e[S + 56 >> 2] = e[I + 8 >> 2], Q = e[I + 4 >> 2], e[S + 48 >> 2] = e[I >> 2], e[S + 52 >> 2] = Q, e[I >> 2] = 0, e[I + 4 >> 2] = 0, e[I + 8 >> 2] = 0, e[5996] = 0, Q = Je[S + 59 | 0], me = Q << 24 >> 24 < 0, Ko(100, S + 80 | 0, (me ? e[S + 48 >> 2] : S + 48 | 0) | 0, (me ? e[S + 52 >> 2] : Q) | 0) | 0, Q = e[5996], e[5996] = 0, (Q | 0) == 1)
                                                                        break l;
                                                                      if (Se[S + 59 | 0] < 0 && Tr(e[S + 48 >> 2]), !Je[S + 108 | 0] | Se[S + 107 | 0] >= 0 || Tr(e[I >> 2]), y = y + 12 | 0, (C | 0) == (y | 0))
                                                                        break;
                                                                    }
                                                                  if (e[5996] = 0, y = wn(97, S + 80 | 0, 5242) | 0, I = e[5996], e[5996] = 0, (I | 0) != 1)
                                                                    break E;
                                                                  l = gi() | 0;
                                                                  break w;
                                                                }
                                                                l = gi() | 0;
                                                                break I;
                                                              }
                                                              if (l = gi() | 0, Se[S + 59 | 0] >= 0)
                                                                break I;
                                                              Tr(e[S + 48 >> 2]);
                                                            }
                                                            if (!Je[S + 108 | 0] | Se[S + 107 | 0] >= 0)
                                                              break w;
                                                            Tr(e[S + 96 >> 2]);
                                                          }
                                                          if (Se[S + 91 | 0] >= 0)
                                                            break e;
                                                          Tr(e[S + 80 >> 2]);
                                                          break e;
                                                        }
                                                        C = e[y >> 2], e[S + 48 >> 2] = e[y + 4 >> 2], I = Je[y + 7 | 0] | Je[y + 8 | 0] << 8 | (Je[y + 9 | 0] << 16 | Je[y + 10 | 0] << 24), Se[S + 51 | 0] = I, Se[S + 52 | 0] = I >>> 8, Se[S + 53 | 0] = I >>> 16, Se[S + 54 | 0] = I >>> 24, e[y >> 2] = 0, e[y + 4 >> 2] = 0, I = Je[y + 11 | 0], e[y + 8 >> 2] = 0, e[l >> 2] = C, e[l + 4 >> 2] = e[S + 48 >> 2], y = Je[S + 51 | 0] | Je[S + 52 | 0] << 8 | (Je[S + 53 | 0] << 16 | Je[S + 54 | 0] << 24), Se[l + 7 | 0] = y, Se[l + 8 | 0] = y >>> 8, Se[l + 9 | 0] = y >>> 16, Se[l + 10 | 0] = y >>> 24, Se[l + 12 | 0] = 1, Se[l + 11 | 0] = I;
                                                        break t;
                                                      }
                                                      l = gi() | 0;
                                                      break e;
                                                    }
                                                    if (e[5996] = 0, ia(44, 2350, 2210, 725, 5107), l = e[5996], e[5996] = 0, (l | 0) == 1) {
                                                      l = gi() | 0;
                                                      break e;
                                                    }
                                                    jn();
                                                  }
                                                  e[5996] = 0, y = wn(97, S + 116 | 0, 5302) | 0, me = e[5996], e[5996] = 0;
                                                  R: {
                                                    k: {
                                                      S: {
                                                        E: {
                                                          w: {
                                                            I: {
                                                              l: {
                                                                if ((me | 0) != 1) {
                                                                  if (e[S + 88 >> 2] = e[y + 8 >> 2], me = e[y + 4 >> 2], e[S + 80 >> 2] = e[y >> 2], e[S + 84 >> 2] = me, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, e[5996] = 0, y = S - -64 | 0, Co(119, y | 0, I + 4 | 0), I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                                    break l;
                                                                  if (e[5996] = 0, ke = y, y = Je[S + 75 | 0], I = y << 24 >> 24 < 0, y = Ko(100, S + 80 | 0, (I ? e[S + 64 >> 2] : ke) | 0, (I ? e[S + 68 >> 2] : y) | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                                    break I;
                                                                  e[S + 104 >> 2] = e[y + 8 >> 2], I = e[y + 4 >> 2], e[S + 96 >> 2] = e[y >> 2], e[S + 100 >> 2] = I, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0;
                                                                  T: {
                                                                    if (Se[S + 75 | 0] >= 0 || (Tr(e[S + 64 >> 2]), Se[y + 11 | 0] >= 0))
                                                                      break T;
                                                                    Tr(e[y >> 2]);
                                                                  }
                                                                  if (Q)
                                                                    for (I = No(Q, 12) + C | 0; ; ) {
                                                                      if (e[5996] = 0, y = Ko(99, C | 0, 0, 4354) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                        break E;
                                                                      if (e[S + 72 >> 2] = e[y + 8 >> 2], C = e[y + 4 >> 2], e[S + 64 >> 2] = e[y >> 2], e[S + 68 >> 2] = C, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, e[5996] = 0, C = Je[S + 75 | 0], Q = C << 24 >> 24 < 0, Ko(100, S + 96 | 0, (Q ? e[S + 64 >> 2] : S - -64 | 0) | 0, (Q ? e[S + 68 >> 2] : C) | 0) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                        break S;
                                                                      if (Se[S + 75 | 0] < 0 && Tr(e[S + 64 >> 2]), C = y + 12 | 0, (I | 0) == (C | 0))
                                                                        break;
                                                                    }
                                                                  if (e[5996] = 0, y = wn(97, S + 96 | 0, 5242) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                                    break k;
                                                                  C = e[y >> 2], e[S + 64 >> 2] = e[y + 4 >> 2], I = Je[y + 7 | 0] | Je[y + 8 | 0] << 8 | (Je[y + 9 | 0] << 16 | Je[y + 10 | 0] << 24), Se[S + 67 | 0] = I, Se[S + 68 | 0] = I >>> 8, Se[S + 69 | 0] = I >>> 16, Se[S + 70 | 0] = I >>> 24, e[y >> 2] = 0, e[y + 4 >> 2] = 0, I = Je[y + 11 | 0], e[y + 8 >> 2] = 0, e[l >> 2] = C, e[l + 4 >> 2] = e[S + 64 >> 2], y = Je[S + 67 | 0] | Je[S + 68 | 0] << 8 | (Je[S + 69 | 0] << 16 | Je[S + 70 | 0] << 24), Se[l + 7 | 0] = y, Se[l + 8 | 0] = y >>> 8, Se[l + 9 | 0] = y >>> 16, Se[l + 10 | 0] = y >>> 24, Se[l + 12 | 0] = 1, Se[l + 11 | 0] = I;
                                                                  break t;
                                                                }
                                                                l = gi() | 0;
                                                                break e;
                                                              }
                                                              l = gi() | 0;
                                                              break w;
                                                            }
                                                            if (l = gi() | 0, Se[S + 75 | 0] >= 0)
                                                              break w;
                                                            Tr(e[S + 64 >> 2]);
                                                          }
                                                          if (Se[S + 91 | 0] >= 0)
                                                            break e;
                                                          Tr(e[S + 80 >> 2]);
                                                          break e;
                                                        }
                                                        l = gi() | 0;
                                                        break R;
                                                      }
                                                      if (l = gi() | 0, Se[S + 75 | 0] >= 0)
                                                        break R;
                                                      Tr(e[S + 64 >> 2]);
                                                      break R;
                                                    }
                                                    l = gi() | 0;
                                                  }
                                                  if (Se[S + 107 | 0] >= 0)
                                                    break e;
                                                  Tr(e[S + 96 >> 2]);
                                                  break e;
                                                }
                                                if (l = gi() | 0, Se[S + 107 | 0] >= 0)
                                                  break g;
                                                Tr(e[S + 96 >> 2]);
                                                break g;
                                              }
                                              l = gi() | 0;
                                            }
                                            if (Se[S + 75 | 0] >= 0)
                                              break e;
                                            Tr(e[S + 64 >> 2]);
                                            break e;
                                          }
                                          l = gi() | 0;
                                          break e;
                                        }
                                        l = gi() | 0;
                                      }
                                      if (Se[S + 75 | 0] < 0 && Tr(e[S + 64 >> 2]), Se[S + 91 | 0] >= 0)
                                        break e;
                                      Tr(e[S + 80 >> 2]);
                                      break e;
                                    }
                                    l = gi() | 0;
                                  }
                                  if (Se[S + 75 | 0] < 0 && Tr(e[S + 64 >> 2]), Se[S + 91 | 0] >= 0)
                                    break e;
                                  Tr(e[S + 80 >> 2]);
                                  break e;
                                }
                                l = gi() | 0;
                              }
                              if (Se[S + 75 | 0] < 0 && Tr(e[S + 64 >> 2]), Se[S + 91 | 0] >= 0)
                                break e;
                              Tr(e[S + 80 >> 2]);
                              break e;
                            }
                            l = gi() | 0;
                          }
                          if (Se[S + 75 | 0] < 0 && Tr(e[S + 64 >> 2]), Se[S + 91 | 0] >= 0)
                            break e;
                          Tr(e[S + 80 >> 2]);
                          break e;
                        }
                        e[5996] = 0, Se[S + 108 | 0] = 1, y = wn(97, S + 116 | 0, 5315) | 0, I = e[5996], e[5996] = 0;
                        o: {
                          a: {
                            s: {
                              A: {
                                if ((I | 0) != 1) {
                                  if (e[S + 72 >> 2] = e[y + 8 >> 2], I = e[y + 4 >> 2], e[S + 64 >> 2] = e[y >> 2], e[S + 68 >> 2] = I, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, e[5996] = 0, y = Je[S + 107 | 0], I = y << 24 >> 24 < 0, I = Ko(100, S - -64 | 0, (I ? e[S + 96 >> 2] : S + 96 | 0) | 0, (I ? e[S + 100 >> 2] : y) | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                    break A;
                                  if (e[S + 88 >> 2] = e[I + 8 >> 2], y = e[I + 4 >> 2], e[S + 80 >> 2] = e[I >> 2], e[S + 84 >> 2] = y, e[I >> 2] = 0, e[I + 4 >> 2] = 0, e[I + 8 >> 2] = 0, e[5996] = 0, y = wn(97, S + 80 | 0, 5242) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                    break s;
                                  if (Q = e[y >> 2], e[S + 48 >> 2] = e[y + 4 >> 2], C = Je[y + 7 | 0] | Je[y + 8 | 0] << 8 | (Je[y + 9 | 0] << 16 | Je[y + 10 | 0] << 24), Se[S + 51 | 0] = C, Se[S + 52 | 0] = C >>> 8, Se[S + 53 | 0] = C >>> 16, Se[S + 54 | 0] = C >>> 24, e[y >> 2] = 0, e[y + 4 >> 2] = 0, C = Je[y + 11 | 0], e[y + 8 >> 2] = 0, e[l >> 2] = Q, e[l + 4 >> 2] = e[S + 48 >> 2], y = Je[S + 51 | 0] | Je[S + 52 | 0] << 8 | (Je[S + 53 | 0] << 16 | Je[S + 54 | 0] << 24), Se[l + 7 | 0] = y, Se[l + 8 | 0] = y >>> 8, Se[l + 9 | 0] = y >>> 16, Se[l + 10 | 0] = y >>> 24, Se[l + 12 | 0] = 1, Se[l + 11 | 0] = C, Se[I + 11 | 0] < 0 && Tr(e[I >> 2]), !Je[S + 108 | 0] | Se[S + 107 | 0] >= 0)
                                    break t;
                                  Tr(e[S + 96 >> 2]);
                                  break t;
                                }
                                l = gi() | 0;
                                break o;
                              }
                              l = gi() | 0;
                              break a;
                            }
                            if (l = gi() | 0, Se[S + 91 | 0] >= 0)
                              break a;
                            Tr(e[S + 80 >> 2]);
                          }
                          if (Se[S + 75 | 0] >= 0)
                            break o;
                          Tr(e[S + 64 >> 2]);
                        }
                        if (!Je[S + 108 | 0] | Se[S + 107 | 0] >= 0)
                          break e;
                        Tr(e[S + 96 >> 2]);
                        break e;
                      }
                      e[5996] = 0, Se[S + 108 | 0] = 1, y = wn(97, S + 116 | 0, 5283) | 0, I = e[5996], e[5996] = 0;
                      n: {
                        o: {
                          a: {
                            s: {
                              if ((I | 0) != 1) {
                                if (e[S + 72 >> 2] = e[y + 8 >> 2], I = e[y + 4 >> 2], e[S + 64 >> 2] = e[y >> 2], e[S + 68 >> 2] = I, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, e[5996] = 0, y = Je[S + 107 | 0], I = y << 24 >> 24 < 0, I = Ko(100, S - -64 | 0, (I ? e[S + 96 >> 2] : S + 96 | 0) | 0, (I ? e[S + 100 >> 2] : y) | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                  break s;
                                if (e[S + 88 >> 2] = e[I + 8 >> 2], y = e[I + 4 >> 2], e[S + 80 >> 2] = e[I >> 2], e[S + 84 >> 2] = y, e[I >> 2] = 0, e[I + 4 >> 2] = 0, e[I + 8 >> 2] = 0, e[5996] = 0, y = wn(97, S + 80 | 0, 5242) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                  break a;
                                if (Q = e[y >> 2], e[S + 48 >> 2] = e[y + 4 >> 2], C = Je[y + 7 | 0] | Je[y + 8 | 0] << 8 | (Je[y + 9 | 0] << 16 | Je[y + 10 | 0] << 24), Se[S + 51 | 0] = C, Se[S + 52 | 0] = C >>> 8, Se[S + 53 | 0] = C >>> 16, Se[S + 54 | 0] = C >>> 24, e[y >> 2] = 0, e[y + 4 >> 2] = 0, C = Je[y + 11 | 0], e[y + 8 >> 2] = 0, e[l >> 2] = Q, e[l + 4 >> 2] = e[S + 48 >> 2], y = Je[S + 51 | 0] | Je[S + 52 | 0] << 8 | (Je[S + 53 | 0] << 16 | Je[S + 54 | 0] << 24), Se[l + 7 | 0] = y, Se[l + 8 | 0] = y >>> 8, Se[l + 9 | 0] = y >>> 16, Se[l + 10 | 0] = y >>> 24, Se[l + 12 | 0] = 1, Se[l + 11 | 0] = C, Se[I + 11 | 0] < 0 && Tr(e[I >> 2]), !Je[S + 108 | 0] | Se[S + 107 | 0] >= 0)
                                  break t;
                                Tr(e[S + 96 >> 2]);
                                break t;
                              }
                              l = gi() | 0;
                              break n;
                            }
                            l = gi() | 0;
                            break o;
                          }
                          if (l = gi() | 0, Se[S + 91 | 0] >= 0)
                            break o;
                          Tr(e[S + 80 >> 2]);
                        }
                        if (Se[S + 75 | 0] >= 0)
                          break n;
                        Tr(e[S + 64 >> 2]);
                      }
                      if (!Je[S + 108 | 0] | Se[S + 107 | 0] >= 0)
                        break e;
                      Tr(e[S + 96 >> 2]);
                      break e;
                    }
                    e[5996] = 0, Se[S + 108 | 0] = 1, y = wn(97, S + 116 | 0, 5310) | 0, I = e[5996], e[5996] = 0;
                    i: {
                      n: {
                        o: {
                          a: {
                            if ((I | 0) != 1) {
                              if (e[S + 72 >> 2] = e[y + 8 >> 2], I = e[y + 4 >> 2], e[S + 64 >> 2] = e[y >> 2], e[S + 68 >> 2] = I, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, e[5996] = 0, y = Je[S + 107 | 0], I = y << 24 >> 24 < 0, I = Ko(100, S - -64 | 0, (I ? e[S + 96 >> 2] : S + 96 | 0) | 0, (I ? e[S + 100 >> 2] : y) | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                break a;
                              if (e[S + 88 >> 2] = e[I + 8 >> 2], y = e[I + 4 >> 2], e[S + 80 >> 2] = e[I >> 2], e[S + 84 >> 2] = y, e[I >> 2] = 0, e[I + 4 >> 2] = 0, e[I + 8 >> 2] = 0, e[5996] = 0, y = wn(97, S + 80 | 0, 5242) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                break o;
                              if (Q = e[y >> 2], e[S + 48 >> 2] = e[y + 4 >> 2], C = Je[y + 7 | 0] | Je[y + 8 | 0] << 8 | (Je[y + 9 | 0] << 16 | Je[y + 10 | 0] << 24), Se[S + 51 | 0] = C, Se[S + 52 | 0] = C >>> 8, Se[S + 53 | 0] = C >>> 16, Se[S + 54 | 0] = C >>> 24, e[y >> 2] = 0, e[y + 4 >> 2] = 0, C = Je[y + 11 | 0], e[y + 8 >> 2] = 0, e[l >> 2] = Q, e[l + 4 >> 2] = e[S + 48 >> 2], y = Je[S + 51 | 0] | Je[S + 52 | 0] << 8 | (Je[S + 53 | 0] << 16 | Je[S + 54 | 0] << 24), Se[l + 7 | 0] = y, Se[l + 8 | 0] = y >>> 8, Se[l + 9 | 0] = y >>> 16, Se[l + 10 | 0] = y >>> 24, Se[l + 12 | 0] = 1, Se[l + 11 | 0] = C, Se[I + 11 | 0] < 0 && Tr(e[I >> 2]), !Je[S + 108 | 0] | Se[S + 107 | 0] >= 0)
                                break t;
                              Tr(e[S + 96 >> 2]);
                              break t;
                            }
                            l = gi() | 0;
                            break i;
                          }
                          l = gi() | 0;
                          break n;
                        }
                        if (l = gi() | 0, Se[S + 91 | 0] >= 0)
                          break n;
                        Tr(e[S + 80 >> 2]);
                      }
                      if (Se[S + 75 | 0] >= 0)
                        break i;
                      Tr(e[S + 64 >> 2]);
                    }
                    if (!Je[S + 108 | 0] | Se[S + 107 | 0] >= 0)
                      break e;
                    Tr(e[S + 96 >> 2]);
                    break e;
                  }
                  e[5996] = 0, Se[S + 108 | 0] = 1, y = wn(97, S + 116 | 0, 5279) | 0, I = e[5996], e[5996] = 0;
                  r: {
                    i: {
                      n: {
                        o: {
                          if ((I | 0) != 1) {
                            if (e[S + 72 >> 2] = e[y + 8 >> 2], I = e[y + 4 >> 2], e[S + 64 >> 2] = e[y >> 2], e[S + 68 >> 2] = I, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, e[5996] = 0, y = Je[S + 107 | 0], I = y << 24 >> 24 < 0, I = Ko(100, S - -64 | 0, (I ? e[S + 96 >> 2] : S + 96 | 0) | 0, (I ? e[S + 100 >> 2] : y) | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                              break o;
                            if (e[S + 88 >> 2] = e[I + 8 >> 2], y = e[I + 4 >> 2], e[S + 80 >> 2] = e[I >> 2], e[S + 84 >> 2] = y, e[I >> 2] = 0, e[I + 4 >> 2] = 0, e[I + 8 >> 2] = 0, e[5996] = 0, y = wn(97, S + 80 | 0, 5242) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                              break n;
                            if (Q = e[y >> 2], e[S + 48 >> 2] = e[y + 4 >> 2], C = Je[y + 7 | 0] | Je[y + 8 | 0] << 8 | (Je[y + 9 | 0] << 16 | Je[y + 10 | 0] << 24), Se[S + 51 | 0] = C, Se[S + 52 | 0] = C >>> 8, Se[S + 53 | 0] = C >>> 16, Se[S + 54 | 0] = C >>> 24, e[y >> 2] = 0, e[y + 4 >> 2] = 0, C = Je[y + 11 | 0], e[y + 8 >> 2] = 0, e[l >> 2] = Q, e[l + 4 >> 2] = e[S + 48 >> 2], y = Je[S + 51 | 0] | Je[S + 52 | 0] << 8 | (Je[S + 53 | 0] << 16 | Je[S + 54 | 0] << 24), Se[l + 7 | 0] = y, Se[l + 8 | 0] = y >>> 8, Se[l + 9 | 0] = y >>> 16, Se[l + 10 | 0] = y >>> 24, Se[l + 12 | 0] = 1, Se[l + 11 | 0] = C, Se[I + 11 | 0] < 0 && Tr(e[I >> 2]), !Je[S + 108 | 0] | Se[S + 107 | 0] >= 0)
                              break t;
                            Tr(e[S + 96 >> 2]);
                            break t;
                          }
                          l = gi() | 0;
                          break r;
                        }
                        l = gi() | 0;
                        break i;
                      }
                      if (l = gi() | 0, Se[S + 91 | 0] >= 0)
                        break i;
                      Tr(e[S + 80 >> 2]);
                    }
                    if (Se[S + 75 | 0] >= 0)
                      break r;
                    Tr(e[S + 64 >> 2]);
                  }
                  if (!Je[S + 108 | 0] | Se[S + 107 | 0] >= 0)
                    break e;
                  Tr(e[S + 96 >> 2]);
                  break e;
                }
                Se[S + 127 | 0] < 0 && Tr(e[S + 116 >> 2]), bi = S + 128 | 0;
                return;
              }
              Se[S + 127 | 0] < 0 && Tr(e[S + 116 >> 2]), ss(l | 0), jn();
            }
            function zh(l, y, I, C, Q) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0;
              var S = 0, me = 0, ke = 0, Ar = 0, br = 0, Qr = 0, Ur = 0, Xr = 0, Ri = 0, yn = 0, En = 0;
              ke = bi - 112 | 0, bi = ke;
              e: {
                t: {
                  r: {
                    i: {
                      n: {
                        o: {
                          a: {
                            s: {
                              A: {
                                u:
                                  switch (e[I >> 2]) {
                                    case 2:
                                      if (S = e[I + 8 >> 2], I = ga(4), e[ke + 48 >> 2] = I, y = I + 4 | 0, e[ke + 56 >> 2] = y, Se[I | 0] = 2, Se[I + 1 | 0] = 80, Se[I + 2 | 0] = 75, Se[I + 3 | 0] = 98, e[ke + 52 >> 2] = y, e[5996] = 0, Se[ke + 16 | 0] = 0, C = ke + 48 | 0, Ms(126, C | 0, 29, ke + 16 | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                        break r;
                                      if (Q = e[ke + 48 >> 2], I = Je[S + 11 | 0], y = I << 24 >> 24 < 0, ve(Q + 4 | 0, y ? e[S >> 2] : S, y ? e[S + 4 >> 2] : I), Se[l + 24 | 0] = 0, Se[l + 25 | 0] = 0, Se[l + 26 | 0] = 0, Se[l + 27 | 0] = 0, Se[l + 28 | 0] = 0, Se[l + 29 | 0] = 0, Se[l + 30 | 0] = 0, Se[l + 31 | 0] = 0, Se[l + 16 | 0] = 0, Se[l + 17 | 0] = 0, Se[l + 18 | 0] = 0, Se[l + 19 | 0] = 0, Se[l + 20 | 0] = 0, Se[l + 21 | 0] = 0, Se[l + 22 | 0] = 0, Se[l + 23 | 0] = 0, Se[l + 8 | 0] = 0, Se[l + 9 | 0] = 0, Se[l + 10 | 0] = 0, Se[l + 11 | 0] = 0, Se[l + 12 | 0] = 0, Se[l + 13 | 0] = 0, Se[l + 14 | 0] = 0, Se[l + 15 | 0] = 0, Se[l | 0] = 0, Se[l + 1 | 0] = 0, Se[l + 2 | 0] = 0, Se[l + 3 | 0] = 0, Se[l + 4 | 0] = 0, Se[l + 5 | 0] = 0, Se[l + 6 | 0] = 0, Se[l + 7 | 0] = 0, e[5996] = 0, wn(19, l | 0, C | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1) {
                                        if (me = gi() | 0, (Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24)) >>> 0 >= 29 && (Tr(Je[l + 8 | 0] | Je[l + 9 | 0] << 8 | (Je[l + 10 | 0] << 16 | Je[l + 11 | 0] << 24)), Se[l + 8 | 0] = 0, Se[l + 9 | 0] = 0, Se[l + 10 | 0] = 0, Se[l + 11 | 0] = 0), !Q)
                                          break e;
                                        Tr(Q);
                                        break e;
                                      }
                                      if (!Q)
                                        break i;
                                      Tr(Q);
                                      break i;
                                    case 3:
                                      if (C = e[I + 8 >> 2], I = ga(3), e[ke + 48 >> 2] = I, y = I + 3 | 0, e[ke + 56 >> 2] = y, Se[I + 2 | 0] = 104, Se[I | 0] = 80, Se[I + 1 | 0] = 75, e[ke + 52 >> 2] = y, e[5996] = 0, Se[ke + 16 | 0] = 0, Ms(126, ke + 48 | 0, 17, ke + 16 | 0), y = e[5996], e[5996] = 0, (y | 0) == 1) {
                                        if (me = gi() | 0, l = e[ke + 48 >> 2], !l)
                                          break e;
                                        Tr(l);
                                        break e;
                                      }
                                      if (S = e[ke + 48 >> 2], I = Je[C + 11 | 0], y = I << 24 >> 24 < 0, ve(S + 3 | 0, y ? e[C >> 2] : C, y ? e[C + 4 >> 2] : I), Se[l + 5 | 0] = 0, Se[l + 6 | 0] = 0, Se[l + 7 | 0] = 0, Se[l + 8 | 0] = 0, Se[l + 9 | 0] = 0, Se[l + 10 | 0] = 0, Se[l + 11 | 0] = 0, Se[l + 12 | 0] = 0, Se[l + 28 | 0] = 0, Se[l + 29 | 0] = 0, Se[l + 30 | 0] = 0, Se[l + 31 | 0] = 0, Se[l + 21 | 0] = 0, Se[l + 22 | 0] = 0, Se[l + 23 | 0] = 0, Se[l + 24 | 0] = 0, Se[l + 25 | 0] = 0, Se[l + 26 | 0] = 0, Se[l + 27 | 0] = 0, Se[l + 28 | 0] = 0, Se[l + 13 | 0] = 0, Se[l + 14 | 0] = 0, Se[l + 15 | 0] = 0, Se[l + 16 | 0] = 0, Se[l + 17 | 0] = 0, Se[l + 18 | 0] = 0, Se[l + 19 | 0] = 0, Se[l + 20 | 0] = 0, Se[l | 0] = 2, Se[l + 1 | 0] = 0, Se[l + 2 | 0] = 0, Se[l + 3 | 0] = 0, Se[l + 4 | 0] = 118, Se[l + 5 | 0] = 169, e[5996] = 0, Ar = wn(19, l | 0, ke + 48 | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) != 1)
                                        h: {
                                          if (me = Je[Ar | 0] | Je[Ar + 1 | 0] << 8 | (Je[Ar + 2 | 0] << 16 | Je[Ar + 3 | 0] << 24), Q = me - 29 | 0, I = me >>> 0 < 29 ? me : Q, y = I + 1 | 0, C = l + 4 | 0, y >>> 0 > (me >>> 0 <= 28 ? 28 : Je[C | 0] | Je[C + 1 | 0] << 8 | (Je[C + 2 | 0] << 16 | Je[C + 3 | 0] << 24)) >>> 0) {
                                            if (e[5996] = 0, Co(124, Ar | 0, y + (y >>> 1 | 0) | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                              break h;
                                            me = Je[Ar | 0] | Je[Ar + 1 | 0] << 8 | (Je[Ar + 2 | 0] << 16 | Je[Ar + 3 | 0] << 24), Q = me - 29 | 0;
                                          }
                                          if (y = Je[l + 8 | 0] | Je[l + 9 | 0] << 8 | (Je[l + 10 | 0] << 16 | Je[l + 11 | 0] << 24), l = me >>> 0 < 29, y = I + (l ? C : y) | 0, ve(y + 1 | 0, y, (l ? me : Q) - I | 0), l = (Je[Ar | 0] | Je[Ar + 1 | 0] << 8 | (Je[Ar + 2 | 0] << 16 | Je[Ar + 3 | 0] << 24)) + 1 | 0, Se[Ar | 0] = l, Se[Ar + 1 | 0] = l >>> 8, Se[Ar + 2 | 0] = l >>> 16, Se[Ar + 3 | 0] = l >>> 24, Se[y | 0] = 136, !S)
                                            break i;
                                          Tr(S);
                                          break i;
                                        }
                                      if (me = gi() | 0, (Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24)) >>> 0 >= 29 && (Tr(Je[l + 8 | 0] | Je[l + 9 | 0] << 8 | (Je[l + 10 | 0] << 16 | Je[l + 11 | 0] << 24)), Se[l + 8 | 0] = 0, Se[l + 9 | 0] = 0, Se[l + 10 | 0] = 0, Se[l + 11 | 0] = 0), !S)
                                        break e;
                                      Tr(S);
                                      break e;
                                    case 4:
                                      if (Se[l | 0] = 0, Se[l + 1 | 0] = 0, Se[l + 2 | 0] = 0, Se[l + 3 | 0] = 0, Se[l + 4 | 0] = 0, Se[l + 5 | 0] = 0, Se[l + 6 | 0] = 0, Se[l + 7 | 0] = 0, Se[l + 24 | 0] = 0, Se[l + 25 | 0] = 0, Se[l + 26 | 0] = 0, Se[l + 27 | 0] = 0, Se[l + 28 | 0] = 0, Se[l + 29 | 0] = 0, Se[l + 30 | 0] = 0, Se[l + 31 | 0] = 0, Se[l + 16 | 0] = 0, Se[l + 17 | 0] = 0, Se[l + 18 | 0] = 0, Se[l + 19 | 0] = 0, Se[l + 20 | 0] = 0, Se[l + 21 | 0] = 0, Se[l + 22 | 0] = 0, Se[l + 23 | 0] = 0, Se[l + 8 | 0] = 0, Se[l + 9 | 0] = 0, Se[l + 10 | 0] = 0, Se[l + 11 | 0] = 0, Se[l + 12 | 0] = 0, Se[l + 13 | 0] = 0, Se[l + 14 | 0] = 0, Se[l + 15 | 0] = 0, y = e[I + 4 >> 2], e[5996] = 0, Q = gu(l, y, 0), y = e[5996], e[5996] = 0, (y | 0) != 1)
                                        h: {
                                          if (S = Je[Q | 0] | Je[Q + 1 | 0] << 8 | (Je[Q + 2 | 0] << 16 | Je[Q + 3 | 0] << 24), y = S - 29 | 0, C = S >>> 0 < 29 ? S : y, I = C + 1 | 0, I >>> 0 > (S >>> 0 <= 28 ? 28 : Je[Q + 4 | 0] | Je[Q + 5 | 0] << 8 | (Je[Q + 6 | 0] << 16 | Je[Q + 7 | 0] << 24)) >>> 0) {
                                            if (e[5996] = 0, Co(124, Q | 0, I + (I >>> 1 | 0) | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                              break h;
                                            S = Je[Q | 0] | Je[Q + 1 | 0] << 8 | (Je[Q + 2 | 0] << 16 | Je[Q + 3 | 0] << 24), y = S - 29 | 0;
                                          }
                                          l = S >>> 0 < 29, I = C + (l ? Q + 4 | 0 : Je[Q + 8 | 0] | Je[Q + 9 | 0] << 8 | (Je[Q + 10 | 0] << 16 | Je[Q + 11 | 0] << 24)) | 0, ve(I + 1 | 0, I, (l ? S : y) - C | 0), l = (Je[Q | 0] | Je[Q + 1 | 0] << 8 | (Je[Q + 2 | 0] << 16 | Je[Q + 3 | 0] << 24)) + 1 | 0, Se[Q | 0] = l, Se[Q + 1 | 0] = l >>> 8, Se[Q + 2 | 0] = l >>> 16, Se[Q + 3 | 0] = l >>> 24, Se[I | 0] = 178;
                                          break i;
                                        }
                                      break t;
                                    case 5:
                                      if (Se[l | 0] = 0, Se[l + 1 | 0] = 0, Se[l + 2 | 0] = 0, Se[l + 3 | 0] = 0, Se[l + 4 | 0] = 0, Se[l + 5 | 0] = 0, Se[l + 6 | 0] = 0, Se[l + 7 | 0] = 0, Se[l + 24 | 0] = 0, Se[l + 25 | 0] = 0, Se[l + 26 | 0] = 0, Se[l + 27 | 0] = 0, Se[l + 28 | 0] = 0, Se[l + 29 | 0] = 0, Se[l + 30 | 0] = 0, Se[l + 31 | 0] = 0, Se[l + 16 | 0] = 0, Se[l + 17 | 0] = 0, Se[l + 18 | 0] = 0, Se[l + 19 | 0] = 0, Se[l + 20 | 0] = 0, Se[l + 21 | 0] = 0, Se[l + 22 | 0] = 0, Se[l + 23 | 0] = 0, Se[l + 8 | 0] = 0, Se[l + 9 | 0] = 0, Se[l + 10 | 0] = 0, Se[l + 11 | 0] = 0, Se[l + 12 | 0] = 0, Se[l + 13 | 0] = 0, Se[l + 14 | 0] = 0, Se[l + 15 | 0] = 0, y = e[I + 4 >> 2], e[5996] = 0, Q = gu(l, y, 0), y = e[5996], e[5996] = 0, (y | 0) != 1)
                                        h: {
                                          if (S = Je[Q | 0] | Je[Q + 1 | 0] << 8 | (Je[Q + 2 | 0] << 16 | Je[Q + 3 | 0] << 24), y = S - 29 | 0, C = S >>> 0 < 29 ? S : y, I = C + 1 | 0, I >>> 0 > (S >>> 0 <= 28 ? 28 : Je[Q + 4 | 0] | Je[Q + 5 | 0] << 8 | (Je[Q + 6 | 0] << 16 | Je[Q + 7 | 0] << 24)) >>> 0) {
                                            if (e[5996] = 0, Co(124, Q | 0, I + (I >>> 1 | 0) | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                              break h;
                                            S = Je[Q | 0] | Je[Q + 1 | 0] << 8 | (Je[Q + 2 | 0] << 16 | Je[Q + 3 | 0] << 24), y = S - 29 | 0;
                                          }
                                          l = S >>> 0 < 29, I = C + (l ? Q + 4 | 0 : Je[Q + 8 | 0] | Je[Q + 9 | 0] << 8 | (Je[Q + 10 | 0] << 16 | Je[Q + 11 | 0] << 24)) | 0, ve(I + 1 | 0, I, (l ? S : y) - C | 0), l = (Je[Q | 0] | Je[Q + 1 | 0] << 8 | (Je[Q + 2 | 0] << 16 | Je[Q + 3 | 0] << 24)) + 1 | 0, Se[Q | 0] = l, Se[Q + 1 | 0] = l >>> 8, Se[Q + 2 | 0] = l >>> 16, Se[Q + 3 | 0] = l >>> 24, Se[I | 0] = 177;
                                          break i;
                                        }
                                      break t;
                                    case 8:
                                      e[ke + 48 >> 2] = 32, e[ke + 16 >> 2] = 136, e[ke + 80 >> 2] = 166, e[ke + 4 >> 2] = y ? 136 : 135, uu(l, ke + 48 | 0, ke + 16 | 0, ke + 80 | 0, I + 20 | 0, ke + 4 | 0);
                                      break i;
                                    case 7:
                                      e[ke + 48 >> 2] = 32, e[ke + 16 >> 2] = 136, e[ke + 80 >> 2] = 170, e[ke + 4 >> 2] = y ? 136 : 135, uu(l, ke + 48 | 0, ke + 16 | 0, ke + 80 | 0, I + 20 | 0, ke + 4 | 0);
                                      break i;
                                    case 9:
                                      e[ke + 48 >> 2] = 32, e[ke + 16 >> 2] = 136, e[ke + 80 >> 2] = 169, e[ke + 4 >> 2] = y ? 136 : 135, uu(l, ke + 48 | 0, ke + 16 | 0, ke + 80 | 0, I + 20 | 0, ke + 4 | 0);
                                      break i;
                                    case 10:
                                      Se[l + 5 | 0] = 0, Se[l + 6 | 0] = 0, Se[l + 7 | 0] = 0, Se[l + 8 | 0] = 0, Se[l + 9 | 0] = 0, Se[l + 10 | 0] = 0, Se[l + 11 | 0] = 0, Se[l + 12 | 0] = 0, Se[l + 4 | 0] = 107, Se[l | 0] = 1, Se[l + 1 | 0] = 0, Se[l + 2 | 0] = 0, Se[l + 3 | 0] = 0, Se[l + 28 | 0] = 0, Se[l + 29 | 0] = 0, Se[l + 30 | 0] = 0, Se[l + 31 | 0] = 0, Se[l + 21 | 0] = 0, Se[l + 22 | 0] = 0, Se[l + 23 | 0] = 0, Se[l + 24 | 0] = 0, Se[l + 25 | 0] = 0, Se[l + 26 | 0] = 0, Se[l + 27 | 0] = 0, Se[l + 28 | 0] = 0, Se[l + 13 | 0] = 0, Se[l + 14 | 0] = 0, Se[l + 15 | 0] = 0, Se[l + 16 | 0] = 0, Se[l + 17 | 0] = 0, Se[l + 18 | 0] = 0, Se[l + 19 | 0] = 0, Se[l + 20 | 0] = 0, I = Je[C + 8 | 0] | Je[C + 9 | 0] << 8 | (Je[C + 10 | 0] << 16 | Je[C + 11 | 0] << 24), Q = -28, S = 1, y = Je[C | 0] | Je[C + 1 | 0] << 8 | (Je[C + 2 | 0] << 16 | Je[C + 3 | 0] << 24), Ur = y >>> 0 < 29;
                                      h: {
                                        if (br = Ur ? y : y - 29 | 0, y = br + 1 | 0, y >>> 0 >= 29) {
                                          if (e[5996] = 0, Co(124, l | 0, y + (y >>> 1 | 0) | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                            break h;
                                          Ri = Je[l + 8 | 0] | Je[l + 9 | 0] << 8 | (Je[l + 10 | 0] << 16 | Je[l + 11 | 0] << 24), S = Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24), Q = S - 29 | 0;
                                        }
                                        Ar = l + 4 | 0, y = S >>> 0 < 29, me = (y ? Ar : Ri) + 1 | 0, ve(br + me | 0, me, (y ? S : Q) - 1 | 0), y = br + (Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24)) | 0, Se[l | 0] = y, Se[l + 1 | 0] = y >>> 8, Se[l + 2 | 0] = y >>> 16, Se[l + 3 | 0] = y >>> 24;
                                        c: {
                                          if (!br)
                                            break c;
                                          y = Ur ? C + 4 | 0 : I, I = br & 7;
                                          f: {
                                            if (!I) {
                                              S = y;
                                              break f;
                                            }
                                            for (C = 0, S = y; Se[me | 0] = Je[S | 0], S = S + 1 | 0, me = me + 1 | 0, C = C + 1 | 0, (I | 0) != (C | 0); )
                                              ;
                                          }
                                          if (br >>> 0 < 8)
                                            break c;
                                          for (y = y + br | 0; Se[me | 0] = Je[S | 0], Se[me + 1 | 0] = Je[S + 1 | 0], Se[me + 2 | 0] = Je[S + 2 | 0], Se[me + 3 | 0] = Je[S + 3 | 0], Se[me + 4 | 0] = Je[S + 4 | 0], Se[me + 5 | 0] = Je[S + 5 | 0], Se[me + 6 | 0] = Je[S + 6 | 0], Se[me + 7 | 0] = Je[S + 7 | 0], me = me + 8 | 0, S = S + 8 | 0, (y | 0) != (S | 0); )
                                            ;
                                        }
                                        if (me = Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24), Ri = me - 29 | 0, C = me >>> 0 < 29 ? me : Ri, y = C + 1 | 0, y >>> 0 > (me >>> 0 <= 28 ? 28 : Je[l + 4 | 0] | Je[l + 5 | 0] << 8 | (Je[l + 6 | 0] << 16 | Je[l + 7 | 0] << 24)) >>> 0) {
                                          if (e[5996] = 0, Co(124, l | 0, y + (y >>> 1 | 0) | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                            break h;
                                          me = Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24), Ri = me - 29 | 0;
                                        }
                                        y = me >>> 0 < 29, I = C + (y ? Ar : Je[l + 8 | 0] | Je[l + 9 | 0] << 8 | (Je[l + 10 | 0] << 16 | Je[l + 11 | 0] << 24)) | 0, ve(I + 1 | 0, I, (y ? me : Ri) - C | 0), y = (Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24)) + 1 | 0, Se[l | 0] = y, Se[l + 1 | 0] = y >>> 8, Se[l + 2 | 0] = y >>> 16, Se[l + 3 | 0] = y >>> 24, Se[I | 0] = 108;
                                        break i;
                                      }
                                      break t;
                                    case 11:
                                      Se[l + 5 | 0] = 0, Se[l + 6 | 0] = 0, Se[l + 7 | 0] = 0, Se[l + 8 | 0] = 0, Se[l + 9 | 0] = 0, Se[l + 10 | 0] = 0, Se[l + 11 | 0] = 0, Se[l + 12 | 0] = 0, Se[l + 4 | 0] = 124, Se[l | 0] = 1, Se[l + 1 | 0] = 0, Se[l + 2 | 0] = 0, Se[l + 3 | 0] = 0, Se[l + 28 | 0] = 0, Se[l + 29 | 0] = 0, Se[l + 30 | 0] = 0, Se[l + 31 | 0] = 0, Se[l + 21 | 0] = 0, Se[l + 22 | 0] = 0, Se[l + 23 | 0] = 0, Se[l + 24 | 0] = 0, Se[l + 25 | 0] = 0, Se[l + 26 | 0] = 0, Se[l + 27 | 0] = 0, Se[l + 28 | 0] = 0, Se[l + 13 | 0] = 0, Se[l + 14 | 0] = 0, Se[l + 15 | 0] = 0, Se[l + 16 | 0] = 0, Se[l + 17 | 0] = 0, Se[l + 18 | 0] = 0, Se[l + 19 | 0] = 0, Se[l + 20 | 0] = 0, I = Je[C + 8 | 0] | Je[C + 9 | 0] << 8 | (Je[C + 10 | 0] << 16 | Je[C + 11 | 0] << 24), Q = -28, S = 1, y = Je[C | 0] | Je[C + 1 | 0] << 8 | (Je[C + 2 | 0] << 16 | Je[C + 3 | 0] << 24), Ar = y >>> 0 < 29;
                                      h: {
                                        if (Ur = Ar ? y : y - 29 | 0, y = Ur + 1 | 0, y >>> 0 >= 29) {
                                          if (e[5996] = 0, Co(124, l | 0, y + (y >>> 1 | 0) | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                            break h;
                                          Ri = Je[l + 8 | 0] | Je[l + 9 | 0] << 8 | (Je[l + 10 | 0] << 16 | Je[l + 11 | 0] << 24), S = Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24), Q = S - 29 | 0;
                                        }
                                        if (y = S >>> 0 < 29, me = (y ? l + 4 | 0 : Ri) + 1 | 0, ve(Ur + me | 0, me, (y ? S : Q) - 1 | 0), y = Ur + (Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24)) | 0, Se[l | 0] = y, Se[l + 1 | 0] = y >>> 8, Se[l + 2 | 0] = y >>> 16, Se[l + 3 | 0] = y >>> 24, !Ur)
                                          break i;
                                        l = Ar ? C + 4 | 0 : I, y = Ur & 7;
                                        c: {
                                          if (!y) {
                                            S = l;
                                            break c;
                                          }
                                          for (C = 0, S = l; Se[me | 0] = Je[S | 0], S = S + 1 | 0, me = me + 1 | 0, C = C + 1 | 0, (y | 0) != (C | 0); )
                                            ;
                                        }
                                        if (Ur >>> 0 < 8)
                                          break i;
                                        for (l = l + Ur | 0; Se[me | 0] = Je[S | 0], Se[me + 1 | 0] = Je[S + 1 | 0], Se[me + 2 | 0] = Je[S + 2 | 0], Se[me + 3 | 0] = Je[S + 3 | 0], Se[me + 4 | 0] = Je[S + 4 | 0], Se[me + 5 | 0] = Je[S + 5 | 0], Se[me + 6 | 0] = Je[S + 6 | 0], Se[me + 7 | 0] = Je[S + 7 | 0], me = me + 8 | 0, S = S + 8 | 0, (l | 0) != (S | 0); )
                                          ;
                                        break i;
                                      }
                                      break t;
                                    case 12:
                                      e[ke + 48 >> 2] = y ? 173 : 172, Zu(l, C, ke + 48 | 0);
                                      break i;
                                    case 13:
                                      Se[l + 5 | 0] = 0, Se[l + 6 | 0] = 0, Se[l + 7 | 0] = 0, Se[l + 8 | 0] = 0, Se[l + 9 | 0] = 0, Se[l + 10 | 0] = 0, Se[l + 11 | 0] = 0, Se[l + 12 | 0] = 0, Se[l | 0] = 2, Se[l + 1 | 0] = 0, Se[l + 2 | 0] = 0, Se[l + 3 | 0] = 0, Se[l + 4 | 0] = 118, Se[l + 28 | 0] = 0, Se[l + 29 | 0] = 0, Se[l + 30 | 0] = 0, Se[l + 31 | 0] = 0, Se[l + 21 | 0] = 0, Se[l + 22 | 0] = 0, Se[l + 23 | 0] = 0, Se[l + 24 | 0] = 0, Se[l + 25 | 0] = 0, Se[l + 26 | 0] = 0, Se[l + 27 | 0] = 0, Se[l + 28 | 0] = 0, Se[l + 13 | 0] = 0, Se[l + 14 | 0] = 0, Se[l + 15 | 0] = 0, Se[l + 16 | 0] = 0, Se[l + 17 | 0] = 0, Se[l + 18 | 0] = 0, Se[l + 19 | 0] = 0, Se[l + 20 | 0] = 0, Se[l + 5 | 0] = 99, I = Je[C + 8 | 0] | Je[C + 9 | 0] << 8 | (Je[C + 10 | 0] << 16 | Je[C + 11 | 0] << 24), Q = -27, S = 2, y = Je[C | 0] | Je[C + 1 | 0] << 8 | (Je[C + 2 | 0] << 16 | Je[C + 3 | 0] << 24), Ur = y >>> 0 < 29;
                                      h: {
                                        if (br = Ur ? y : y - 29 | 0, y = br + 2 | 0, y >>> 0 >= 29) {
                                          if (e[5996] = 0, Co(124, l | 0, y + (y >>> 1 | 0) | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                            break h;
                                          Ri = Je[l + 8 | 0] | Je[l + 9 | 0] << 8 | (Je[l + 10 | 0] << 16 | Je[l + 11 | 0] << 24), S = Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24), Q = S - 29 | 0;
                                        }
                                        Ar = l + 4 | 0, y = S >>> 0 < 29, me = (y ? Ar : Ri) + 2 | 0, ve(br + me | 0, me, (y ? S : Q) - 2 | 0), y = br + (Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24)) | 0, Se[l | 0] = y, Se[l + 1 | 0] = y >>> 8, Se[l + 2 | 0] = y >>> 16, Se[l + 3 | 0] = y >>> 24;
                                        c: {
                                          if (!br)
                                            break c;
                                          y = Ur ? C + 4 | 0 : I, I = br & 7;
                                          f: {
                                            if (!I) {
                                              S = y;
                                              break f;
                                            }
                                            for (C = 0, S = y; Se[me | 0] = Je[S | 0], S = S + 1 | 0, me = me + 1 | 0, C = C + 1 | 0, (I | 0) != (C | 0); )
                                              ;
                                          }
                                          if (br >>> 0 < 8)
                                            break c;
                                          for (y = y + br | 0; Se[me | 0] = Je[S | 0], Se[me + 1 | 0] = Je[S + 1 | 0], Se[me + 2 | 0] = Je[S + 2 | 0], Se[me + 3 | 0] = Je[S + 3 | 0], Se[me + 4 | 0] = Je[S + 4 | 0], Se[me + 5 | 0] = Je[S + 5 | 0], Se[me + 6 | 0] = Je[S + 6 | 0], Se[me + 7 | 0] = Je[S + 7 | 0], me = me + 8 | 0, S = S + 8 | 0, (y | 0) != (S | 0); )
                                            ;
                                        }
                                        if (me = Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24), Ri = me - 29 | 0, C = me >>> 0 < 29 ? me : Ri, y = C + 1 | 0, y >>> 0 > (me >>> 0 <= 28 ? 28 : Je[l + 4 | 0] | Je[l + 5 | 0] << 8 | (Je[l + 6 | 0] << 16 | Je[l + 7 | 0] << 24)) >>> 0) {
                                          if (e[5996] = 0, Co(124, l | 0, y + (y >>> 1 | 0) | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                            break h;
                                          me = Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24), Ri = me - 29 | 0;
                                        }
                                        y = me >>> 0 < 29, I = C + (y ? Ar : Je[l + 8 | 0] | Je[l + 9 | 0] << 8 | (Je[l + 10 | 0] << 16 | Je[l + 11 | 0] << 24)) | 0, ve(I + 1 | 0, I, (y ? me : Ri) - C | 0), y = (Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24)) + 1 | 0, Se[l | 0] = y, Se[l + 1 | 0] = y >>> 8, Se[l + 2 | 0] = y >>> 16, Se[l + 3 | 0] = y >>> 24, Se[I | 0] = 104;
                                        break i;
                                      }
                                      break t;
                                    case 14:
                                      if (y = e[e[e[I + 32 >> 2] >> 2] + 80 >> 2], !(Mr(1239, 1) & (y ^ -1))) {
                                        e[ke + 48 >> 2] = 105, Zu(l, C, ke + 48 | 0);
                                        break i;
                                      }
                                      Se[l | 0] = 0, Se[l + 1 | 0] = 0, Se[l + 2 | 0] = 0, Se[l + 3 | 0] = 0, Se[l + 4 | 0] = 0, Se[l + 5 | 0] = 0, Se[l + 6 | 0] = 0, Se[l + 7 | 0] = 0, Se[l + 24 | 0] = 0, Se[l + 25 | 0] = 0, Se[l + 26 | 0] = 0, Se[l + 27 | 0] = 0, Se[l + 28 | 0] = 0, Se[l + 29 | 0] = 0, Se[l + 30 | 0] = 0, Se[l + 31 | 0] = 0, Se[l + 16 | 0] = 0, Se[l + 17 | 0] = 0, Se[l + 18 | 0] = 0, Se[l + 19 | 0] = 0, Se[l + 20 | 0] = 0, Se[l + 21 | 0] = 0, Se[l + 22 | 0] = 0, Se[l + 23 | 0] = 0, Se[l + 8 | 0] = 0, Se[l + 9 | 0] = 0, Se[l + 10 | 0] = 0, Se[l + 11 | 0] = 0, Se[l + 12 | 0] = 0, Se[l + 13 | 0] = 0, Se[l + 14 | 0] = 0, Se[l + 15 | 0] = 0, e[ke + 72 >> 2] = Je[l + 28 | 0] | Je[l + 29 | 0] << 8 | (Je[l + 30 | 0] << 16 | Je[l + 31 | 0] << 24), y = Je[l + 24 | 0] | Je[l + 25 | 0] << 8 | (Je[l + 26 | 0] << 16 | Je[l + 27 | 0] << 24), I = ke - -64 | 0, e[I >> 2] = Je[l + 20 | 0] | Je[l + 21 | 0] << 8 | (Je[l + 22 | 0] << 16 | Je[l + 23 | 0] << 24), e[I + 4 >> 2] = y, y = Je[l + 16 | 0] | Je[l + 17 | 0] << 8 | (Je[l + 18 | 0] << 16 | Je[l + 19 | 0] << 24), e[ke + 56 >> 2] = Je[l + 12 | 0] | Je[l + 13 | 0] << 8 | (Je[l + 14 | 0] << 16 | Je[l + 15 | 0] << 24), e[ke + 60 >> 2] = y, y = Je[l + 8 | 0] | Je[l + 9 | 0] << 8 | (Je[l + 10 | 0] << 16 | Je[l + 11 | 0] << 24), e[ke + 48 >> 2] = Je[l + 4 | 0] | Je[l + 5 | 0] << 8 | (Je[l + 6 | 0] << 16 | Je[l + 7 | 0] << 24), e[ke + 52 >> 2] = y, y = Je[C + 28 | 0] | Je[C + 29 | 0] << 8 | (Je[C + 30 | 0] << 16 | Je[C + 31 | 0] << 24), Se[l + 28 | 0] = y, Se[l + 29 | 0] = y >>> 8, Se[l + 30 | 0] = y >>> 16, Se[l + 31 | 0] = y >>> 24, Q = Je[C + 24 | 0] | Je[C + 25 | 0] << 8 | (Je[C + 26 | 0] << 16 | Je[C + 27 | 0] << 24), y = Je[C + 20 | 0] | Je[C + 21 | 0] << 8 | (Je[C + 22 | 0] << 16 | Je[C + 23 | 0] << 24), Se[l + 20 | 0] = y, Se[l + 21 | 0] = y >>> 8, Se[l + 22 | 0] = y >>> 16, Se[l + 23 | 0] = y >>> 24, Se[l + 24 | 0] = Q, Se[l + 25 | 0] = Q >>> 8, Se[l + 26 | 0] = Q >>> 16, Se[l + 27 | 0] = Q >>> 24, Q = Je[C + 16 | 0] | Je[C + 17 | 0] << 8 | (Je[C + 18 | 0] << 16 | Je[C + 19 | 0] << 24), y = Je[C + 12 | 0] | Je[C + 13 | 0] << 8 | (Je[C + 14 | 0] << 16 | Je[C + 15 | 0] << 24), Se[l + 12 | 0] = y, Se[l + 13 | 0] = y >>> 8, Se[l + 14 | 0] = y >>> 16, Se[l + 15 | 0] = y >>> 24, Se[l + 16 | 0] = Q, Se[l + 17 | 0] = Q >>> 8, Se[l + 18 | 0] = Q >>> 16, Se[l + 19 | 0] = Q >>> 24, Q = Je[C + 8 | 0] | Je[C + 9 | 0] << 8 | (Je[C + 10 | 0] << 16 | Je[C + 11 | 0] << 24), y = Je[C + 4 | 0] | Je[C + 5 | 0] << 8 | (Je[C + 6 | 0] << 16 | Je[C + 7 | 0] << 24), Se[l + 4 | 0] = y, Se[l + 5 | 0] = y >>> 8, Se[l + 6 | 0] = y >>> 16, Se[l + 7 | 0] = y >>> 24, Se[l + 8 | 0] = Q, Se[l + 9 | 0] = Q >>> 8, Se[l + 10 | 0] = Q >>> 16, Se[l + 11 | 0] = Q >>> 24, y = e[ke + 72 >> 2], Se[C + 28 | 0] = y, Se[C + 29 | 0] = y >>> 8, Se[C + 30 | 0] = y >>> 16, Se[C + 31 | 0] = y >>> 24, Q = e[I + 4 >> 2], y = e[I >> 2], Se[C + 20 | 0] = y, Se[C + 21 | 0] = y >>> 8, Se[C + 22 | 0] = y >>> 16, Se[C + 23 | 0] = y >>> 24, Se[C + 24 | 0] = Q, Se[C + 25 | 0] = Q >>> 8, Se[C + 26 | 0] = Q >>> 16, Se[C + 27 | 0] = Q >>> 24, I = e[ke + 60 >> 2], y = e[ke + 56 >> 2], Se[C + 12 | 0] = y, Se[C + 13 | 0] = y >>> 8, Se[C + 14 | 0] = y >>> 16, Se[C + 15 | 0] = y >>> 24, Se[C + 16 | 0] = I, Se[C + 17 | 0] = I >>> 8, Se[C + 18 | 0] = I >>> 16, Se[C + 19 | 0] = I >>> 24, I = e[ke + 52 >> 2], y = e[ke + 48 >> 2], Se[C + 4 | 0] = y, Se[C + 5 | 0] = y >>> 8, Se[C + 6 | 0] = y >>> 16, Se[C + 7 | 0] = y >>> 24, Se[C + 8 | 0] = I, Se[C + 9 | 0] = I >>> 8, Se[C + 10 | 0] = I >>> 16, Se[C + 11 | 0] = I >>> 24, e[l >> 2] = e[C >> 2], e[C >> 2] = 0;
                                      break i;
                                    case 15:
                                      if (Se[l | 0] = 0, Se[l + 1 | 0] = 0, Se[l + 2 | 0] = 0, Se[l + 3 | 0] = 0, Se[l + 4 | 0] = 0, Se[l + 5 | 0] = 0, Se[l + 6 | 0] = 0, Se[l + 7 | 0] = 0, Se[l + 24 | 0] = 0, Se[l + 25 | 0] = 0, Se[l + 26 | 0] = 0, Se[l + 27 | 0] = 0, Se[l + 28 | 0] = 0, Se[l + 29 | 0] = 0, Se[l + 30 | 0] = 0, Se[l + 31 | 0] = 0, Se[l + 16 | 0] = 0, Se[l + 17 | 0] = 0, Se[l + 18 | 0] = 0, Se[l + 19 | 0] = 0, Se[l + 20 | 0] = 0, Se[l + 21 | 0] = 0, Se[l + 22 | 0] = 0, Se[l + 23 | 0] = 0, Se[l + 8 | 0] = 0, Se[l + 9 | 0] = 0, Se[l + 10 | 0] = 0, Se[l + 11 | 0] = 0, Se[l + 12 | 0] = 0, Se[l + 13 | 0] = 0, Se[l + 14 | 0] = 0, Se[l + 15 | 0] = 0, e[5996] = 0, I = wn(127, l | 0, 130) | 0, y = e[5996], e[5996] = 0, (y | 0) != 1)
                                        h: {
                                          if (e[5996] = 0, I = wn(127, I | 0, 146) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1 || (e[5996] = 0, Qr = wn(127, I | 0, 99) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1))
                                            break h;
                                          if (Q = Je[C + 8 | 0] | Je[C + 9 | 0] << 8 | (Je[C + 10 | 0] << 16 | Je[C + 11 | 0] << 24), I = Je[C | 0] | Je[C + 1 | 0] << 8 | (Je[C + 2 | 0] << 16 | Je[C + 3 | 0] << 24), Ur = I >>> 0 < 29, S = Je[Qr | 0] | Je[Qr + 1 | 0] << 8 | (Je[Qr + 2 | 0] << 16 | Je[Qr + 3 | 0] << 24), y = S - 29 | 0, br = Ur ? I : I - 29 | 0, Ar = S >>> 0 < 29 ? S : y, I = br + Ar | 0, I >>> 0 > (S >>> 0 <= 28 ? 28 : Je[Qr + 4 | 0] | Je[Qr + 5 | 0] << 8 | (Je[Qr + 6 | 0] << 16 | Je[Qr + 7 | 0] << 24)) >>> 0) {
                                            if (e[5996] = 0, Co(124, Qr | 0, I + (I >>> 1 | 0) | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                              break h;
                                            S = Je[Qr | 0] | Je[Qr + 1 | 0] << 8 | (Je[Qr + 2 | 0] << 16 | Je[Qr + 3 | 0] << 24), y = S - 29 | 0;
                                          }
                                          I = S >>> 0 < 29, me = Ar + (I ? Qr + 4 | 0 : Je[Qr + 8 | 0] | Je[Qr + 9 | 0] << 8 | (Je[Qr + 10 | 0] << 16 | Je[Qr + 11 | 0] << 24)) | 0, ve(br + me | 0, me, (I ? S : y) - Ar | 0), y = br + (Je[Qr | 0] | Je[Qr + 1 | 0] << 8 | (Je[Qr + 2 | 0] << 16 | Je[Qr + 3 | 0] << 24)) | 0, Se[Qr | 0] = y, Se[Qr + 1 | 0] = y >>> 8, Se[Qr + 2 | 0] = y >>> 16, Se[Qr + 3 | 0] = y >>> 24;
                                          c: {
                                            if (!br)
                                              break c;
                                            y = Ur ? C + 4 | 0 : Q, I = br & 7;
                                            f: {
                                              if (!I) {
                                                S = y;
                                                break f;
                                              }
                                              for (C = 0, S = y; Se[me | 0] = Je[S | 0], S = S + 1 | 0, me = me + 1 | 0, C = C + 1 | 0, (I | 0) != (C | 0); )
                                                ;
                                            }
                                            if (br >>> 0 < 8)
                                              break c;
                                            for (y = y + br | 0; Se[me | 0] = Je[S | 0], Se[me + 1 | 0] = Je[S + 1 | 0], Se[me + 2 | 0] = Je[S + 2 | 0], Se[me + 3 | 0] = Je[S + 3 | 0], Se[me + 4 | 0] = Je[S + 4 | 0], Se[me + 5 | 0] = Je[S + 5 | 0], Se[me + 6 | 0] = Je[S + 6 | 0], Se[me + 7 | 0] = Je[S + 7 | 0], me = me + 8 | 0, S = S + 8 | 0, (y | 0) != (S | 0); )
                                              ;
                                          }
                                          if (e[5996] = 0, wn(127, Qr | 0, 104) | 0, y = e[5996], e[5996] = 0, (y | 0) != 1)
                                            break i;
                                        }
                                      break t;
                                    case 16:
                                      e[ke + 48 >> 2] = 146, Zu(l, C, ke + 48 | 0);
                                      break i;
                                    case 1:
                                      Se[l + 5 | 0] = 0, Se[l + 6 | 0] = 0, Se[l + 7 | 0] = 0, Se[l + 8 | 0] = 0, Se[l + 9 | 0] = 0, Se[l + 10 | 0] = 0, Se[l + 11 | 0] = 0, Se[l + 12 | 0] = 0, Se[l + 4 | 0] = 81, Se[l | 0] = 1, Se[l + 1 | 0] = 0, Se[l + 2 | 0] = 0, Se[l + 3 | 0] = 0, Se[l + 28 | 0] = 0, Se[l + 29 | 0] = 0, Se[l + 30 | 0] = 0, Se[l + 31 | 0] = 0, Se[l + 21 | 0] = 0, Se[l + 22 | 0] = 0, Se[l + 23 | 0] = 0, Se[l + 24 | 0] = 0, Se[l + 25 | 0] = 0, Se[l + 26 | 0] = 0, Se[l + 27 | 0] = 0, Se[l + 28 | 0] = 0, Se[l + 13 | 0] = 0, Se[l + 14 | 0] = 0, Se[l + 15 | 0] = 0, Se[l + 16 | 0] = 0, Se[l + 17 | 0] = 0, Se[l + 18 | 0] = 0, Se[l + 19 | 0] = 0, Se[l + 20 | 0] = 0;
                                      break i;
                                    case 0:
                                      Se[l + 5 | 0] = 0, Se[l + 6 | 0] = 0, Se[l + 7 | 0] = 0, Se[l + 8 | 0] = 0, Se[l + 9 | 0] = 0, Se[l + 10 | 0] = 0, Se[l + 11 | 0] = 0, Se[l + 12 | 0] = 0, Se[l + 4 | 0] = 0, Se[l | 0] = 1, Se[l + 1 | 0] = 0, Se[l + 2 | 0] = 0, Se[l + 3 | 0] = 0, Se[l + 28 | 0] = 0, Se[l + 29 | 0] = 0, Se[l + 30 | 0] = 0, Se[l + 31 | 0] = 0, Se[l + 21 | 0] = 0, Se[l + 22 | 0] = 0, Se[l + 23 | 0] = 0, Se[l + 24 | 0] = 0, Se[l + 25 | 0] = 0, Se[l + 26 | 0] = 0, Se[l + 27 | 0] = 0, Se[l + 28 | 0] = 0, Se[l + 13 | 0] = 0, Se[l + 14 | 0] = 0, Se[l + 15 | 0] = 0, Se[l + 16 | 0] = 0, Se[l + 17 | 0] = 0, Se[l + 18 | 0] = 0, Se[l + 19 | 0] = 0, Se[l + 20 | 0] = 0;
                                      break i;
                                    case 17:
                                      Se[l | 0] = 0, Se[l + 1 | 0] = 0, Se[l + 2 | 0] = 0, Se[l + 3 | 0] = 0, Se[l + 4 | 0] = 0, Se[l + 5 | 0] = 0, Se[l + 6 | 0] = 0, Se[l + 7 | 0] = 0, Se[l + 24 | 0] = 0, Se[l + 25 | 0] = 0, Se[l + 26 | 0] = 0, Se[l + 27 | 0] = 0, Se[l + 28 | 0] = 0, Se[l + 29 | 0] = 0, Se[l + 30 | 0] = 0, Se[l + 31 | 0] = 0, Se[l + 16 | 0] = 0, Se[l + 17 | 0] = 0, Se[l + 18 | 0] = 0, Se[l + 19 | 0] = 0, Se[l + 20 | 0] = 0, Se[l + 21 | 0] = 0, Se[l + 22 | 0] = 0, Se[l + 23 | 0] = 0, Se[l + 8 | 0] = 0, Se[l + 9 | 0] = 0, Se[l + 10 | 0] = 0, Se[l + 11 | 0] = 0, Se[l + 12 | 0] = 0, Se[l + 13 | 0] = 0, Se[l + 14 | 0] = 0, Se[l + 15 | 0] = 0, I = Je[C + 8 | 0] | Je[C + 9 | 0] << 8 | (Je[C + 10 | 0] << 16 | Je[C + 11 | 0] << 24), Ri = -29, y = 0, Ar = Je[C | 0] | Je[C + 1 | 0] << 8 | (Je[C + 2 | 0] << 16 | Je[C + 3 | 0] << 24), Q = Ar >>> 0 < 29;
                                      h: {
                                        if (Ur = Q ? Ar : Ar - 29 | 0, Ur >>> 0 >= 29) {
                                          if (e[5996] = 0, Co(124, l | 0, Ur + (Ur >>> 1 | 0) | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                            break h;
                                          S = Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24), Ri = S - 29 | 0, y = Je[l + 8 | 0] | Je[l + 9 | 0] << 8 | (Je[l + 10 | 0] << 16 | Je[l + 11 | 0] << 24);
                                        }
                                        Ar = l + 4 | 0, Qr = y, y = S >>> 0 < 29, me = y ? Ar : Qr, ve(Ur + me | 0, me, y ? S : Ri), y = Ur + (Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24)) | 0, Se[l | 0] = y, Se[l + 1 | 0] = y >>> 8, Se[l + 2 | 0] = y >>> 16, Se[l + 3 | 0] = y >>> 24;
                                        c: {
                                          if (!Ur)
                                            break c;
                                          y = Q ? C + 4 | 0 : I, I = Ur & 7;
                                          f: {
                                            if (!I) {
                                              S = y;
                                              break f;
                                            }
                                            for (Ri = 0, S = y; Se[me | 0] = Je[S | 0], S = S + 1 | 0, me = me + 1 | 0, Ri = Ri + 1 | 0, (I | 0) != (Ri | 0); )
                                              ;
                                          }
                                          if (Ur >>> 0 < 8)
                                            break c;
                                          for (y = y + Ur | 0; Se[me | 0] = Je[S | 0], Se[me + 1 | 0] = Je[S + 1 | 0], Se[me + 2 | 0] = Je[S + 2 | 0], Se[me + 3 | 0] = Je[S + 3 | 0], Se[me + 4 | 0] = Je[S + 4 | 0], Se[me + 5 | 0] = Je[S + 5 | 0], Se[me + 6 | 0] = Je[S + 6 | 0], Se[me + 7 | 0] = Je[S + 7 | 0], me = me + 8 | 0, S = S + 8 | 0, (y | 0) != (S | 0); )
                                            ;
                                        }
                                        if (I = Je[C + 40 | 0] | Je[C + 41 | 0] << 8 | (Je[C + 42 | 0] << 16 | Je[C + 43 | 0] << 24), y = Je[C + 32 | 0] | Je[C + 33 | 0] << 8 | (Je[C + 34 | 0] << 16 | Je[C + 35 | 0] << 24), br = y >>> 0 < 29, S = Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24), Q = S - 29 | 0, Qr = br ? y : y - 29 | 0, Ur = S >>> 0 < 29 ? S : Q, y = Qr + Ur | 0, y >>> 0 > (S >>> 0 <= 28 ? 28 : Je[l + 4 | 0] | Je[l + 5 | 0] << 8 | (Je[l + 6 | 0] << 16 | Je[l + 7 | 0] << 24)) >>> 0) {
                                          if (e[5996] = 0, Co(124, l | 0, y + (y >>> 1 | 0) | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                            break h;
                                          S = Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24), Q = S - 29 | 0;
                                        }
                                        if (y = S >>> 0 < 29, me = Ur + (y ? Ar : Je[l + 8 | 0] | Je[l + 9 | 0] << 8 | (Je[l + 10 | 0] << 16 | Je[l + 11 | 0] << 24)) | 0, ve(Qr + me | 0, me, (y ? S : Q) - Ur | 0), y = Qr + (Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24)) | 0, Se[l | 0] = y, Se[l + 1 | 0] = y >>> 8, Se[l + 2 | 0] = y >>> 16, Se[l + 3 | 0] = y >>> 24, !Qr)
                                          break i;
                                        l = br ? C + 36 | 0 : I, y = Qr & 7;
                                        c: {
                                          if (!y) {
                                            S = l;
                                            break c;
                                          }
                                          for (C = 0, S = l; Se[me | 0] = Je[S | 0], S = S + 1 | 0, me = me + 1 | 0, C = C + 1 | 0, (y | 0) != (C | 0); )
                                            ;
                                        }
                                        if (Qr >>> 0 < 8)
                                          break i;
                                        for (l = l + Qr | 0; Se[me | 0] = Je[S | 0], Se[me + 1 | 0] = Je[S + 1 | 0], Se[me + 2 | 0] = Je[S + 2 | 0], Se[me + 3 | 0] = Je[S + 3 | 0], Se[me + 4 | 0] = Je[S + 4 | 0], Se[me + 5 | 0] = Je[S + 5 | 0], Se[me + 6 | 0] = Je[S + 6 | 0], Se[me + 7 | 0] = Je[S + 7 | 0], me = me + 8 | 0, S = S + 8 | 0, (l | 0) != (S | 0); )
                                          ;
                                        break i;
                                      }
                                      break t;
                                    case 18:
                                      e[ke + 48 >> 2] = 154, $u(l, C, C + 32 | 0, ke + 48 | 0);
                                      break i;
                                    case 19:
                                      e[ke + 48 >> 2] = 155, $u(l, C, C + 32 | 0, ke + 48 | 0);
                                      break i;
                                    case 21:
                                      Se[l | 0] = 0, Se[l + 1 | 0] = 0, Se[l + 2 | 0] = 0, Se[l + 3 | 0] = 0, Se[l + 4 | 0] = 0, Se[l + 5 | 0] = 0, Se[l + 6 | 0] = 0, Se[l + 7 | 0] = 0, Se[l + 24 | 0] = 0, Se[l + 25 | 0] = 0, Se[l + 26 | 0] = 0, Se[l + 27 | 0] = 0, Se[l + 28 | 0] = 0, Se[l + 29 | 0] = 0, Se[l + 30 | 0] = 0, Se[l + 31 | 0] = 0, Se[l + 16 | 0] = 0, Se[l + 17 | 0] = 0, Se[l + 18 | 0] = 0, Se[l + 19 | 0] = 0, Se[l + 20 | 0] = 0, Se[l + 21 | 0] = 0, Se[l + 22 | 0] = 0, Se[l + 23 | 0] = 0, Se[l + 8 | 0] = 0, Se[l + 9 | 0] = 0, Se[l + 10 | 0] = 0, Se[l + 11 | 0] = 0, Se[l + 12 | 0] = 0, Se[l + 13 | 0] = 0, Se[l + 14 | 0] = 0, Se[l + 15 | 0] = 0, I = Je[C + 8 | 0] | Je[C + 9 | 0] << 8 | (Je[C + 10 | 0] << 16 | Je[C + 11 | 0] << 24), Ri = -29, y = 0, Ar = Je[C | 0] | Je[C + 1 | 0] << 8 | (Je[C + 2 | 0] << 16 | Je[C + 3 | 0] << 24), Q = Ar >>> 0 < 29, Ar = Q ? Ar : Ar - 29 | 0;
                                      h: {
                                        if (Ar >>> 0 >= 29) {
                                          if (e[5996] = 0, Co(124, l | 0, Ar + (Ar >>> 1 | 0) | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                            break h;
                                          S = Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24), Ri = S - 29 | 0, y = Je[l + 8 | 0] | Je[l + 9 | 0] << 8 | (Je[l + 10 | 0] << 16 | Je[l + 11 | 0] << 24);
                                        }
                                        br = l + 4 | 0, Qr = y, y = S >>> 0 < 29, me = y ? br : Qr, ve(Ar + me | 0, me, y ? S : Ri), y = Ar + (Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24)) | 0, Se[l | 0] = y, Se[l + 1 | 0] = y >>> 8, Se[l + 2 | 0] = y >>> 16, Se[l + 3 | 0] = y >>> 24;
                                        c: {
                                          if (!Ar)
                                            break c;
                                          y = Q ? C + 4 | 0 : I, I = Ar & 7;
                                          f: {
                                            if (!I) {
                                              S = y;
                                              break f;
                                            }
                                            for (Ri = 0, S = y; Se[me | 0] = Je[S | 0], S = S + 1 | 0, me = me + 1 | 0, Ri = Ri + 1 | 0, (I | 0) != (Ri | 0); )
                                              ;
                                          }
                                          if (Ar >>> 0 < 8)
                                            break c;
                                          for (y = y + Ar | 0; Se[me | 0] = Je[S | 0], Se[me + 1 | 0] = Je[S + 1 | 0], Se[me + 2 | 0] = Je[S + 2 | 0], Se[me + 3 | 0] = Je[S + 3 | 0], Se[me + 4 | 0] = Je[S + 4 | 0], Se[me + 5 | 0] = Je[S + 5 | 0], Se[me + 6 | 0] = Je[S + 6 | 0], Se[me + 7 | 0] = Je[S + 7 | 0], me = me + 8 | 0, S = S + 8 | 0, (y | 0) != (S | 0); )
                                            ;
                                        }
                                        if (e[5996] = 0, I = wn(127, l | 0, 115) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1 || (e[5996] = 0, Xr = wn(127, I | 0, 100) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1))
                                          break h;
                                        if (Q = Je[C + 40 | 0] | Je[C + 41 | 0] << 8 | (Je[C + 42 | 0] << 16 | Je[C + 43 | 0] << 24), I = Je[C + 32 | 0] | Je[C + 33 | 0] << 8 | (Je[C + 34 | 0] << 16 | Je[C + 35 | 0] << 24), Ur = I >>> 0 < 29, S = Je[Xr | 0] | Je[Xr + 1 | 0] << 8 | (Je[Xr + 2 | 0] << 16 | Je[Xr + 3 | 0] << 24), y = S - 29 | 0, Qr = Ur ? I : I - 29 | 0, Ar = S >>> 0 < 29 ? S : y, I = Qr + Ar | 0, I >>> 0 > (S >>> 0 <= 28 ? 28 : Je[br | 0] | Je[br + 1 | 0] << 8 | (Je[br + 2 | 0] << 16 | Je[br + 3 | 0] << 24)) >>> 0) {
                                          if (e[5996] = 0, Co(124, Xr | 0, I + (I >>> 1 | 0) | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                            break h;
                                          S = Je[Xr | 0] | Je[Xr + 1 | 0] << 8 | (Je[Xr + 2 | 0] << 16 | Je[Xr + 3 | 0] << 24), y = S - 29 | 0;
                                        }
                                        I = S >>> 0 < 29, me = Ar + (I ? br : Je[l + 8 | 0] | Je[l + 9 | 0] << 8 | (Je[l + 10 | 0] << 16 | Je[l + 11 | 0] << 24)) | 0, ve(Qr + me | 0, me, (I ? S : y) - Ar | 0), y = Qr + (Je[Xr | 0] | Je[Xr + 1 | 0] << 8 | (Je[Xr + 2 | 0] << 16 | Je[Xr + 3 | 0] << 24)) | 0, Se[Xr | 0] = y, Se[Xr + 1 | 0] = y >>> 8, Se[Xr + 2 | 0] = y >>> 16, Se[Xr + 3 | 0] = y >>> 24;
                                        c: {
                                          if (!Qr)
                                            break c;
                                          y = Ur ? C + 36 | 0 : Q, I = Qr & 7;
                                          f: {
                                            if (!I) {
                                              S = y;
                                              break f;
                                            }
                                            for (C = 0, S = y; Se[me | 0] = Je[S | 0], S = S + 1 | 0, me = me + 1 | 0, C = C + 1 | 0, (I | 0) != (C | 0); )
                                              ;
                                          }
                                          if (Qr >>> 0 < 8)
                                            break c;
                                          for (y = y + Qr | 0; Se[me | 0] = Je[S | 0], Se[me + 1 | 0] = Je[S + 1 | 0], Se[me + 2 | 0] = Je[S + 2 | 0], Se[me + 3 | 0] = Je[S + 3 | 0], Se[me + 4 | 0] = Je[S + 4 | 0], Se[me + 5 | 0] = Je[S + 5 | 0], Se[me + 6 | 0] = Je[S + 6 | 0], Se[me + 7 | 0] = Je[S + 7 | 0], me = me + 8 | 0, S = S + 8 | 0, (y | 0) != (S | 0); )
                                            ;
                                        }
                                        if (e[5996] = 0, wn(127, Xr | 0, 104) | 0, y = e[5996], e[5996] = 0, (y | 0) != 1)
                                          break i;
                                      }
                                      break t;
                                    case 20:
                                      Se[l | 0] = 0, Se[l + 1 | 0] = 0, Se[l + 2 | 0] = 0, Se[l + 3 | 0] = 0, Se[l + 4 | 0] = 0, Se[l + 5 | 0] = 0, Se[l + 6 | 0] = 0, Se[l + 7 | 0] = 0, Se[l + 24 | 0] = 0, Se[l + 25 | 0] = 0, Se[l + 26 | 0] = 0, Se[l + 27 | 0] = 0, Se[l + 28 | 0] = 0, Se[l + 29 | 0] = 0, Se[l + 30 | 0] = 0, Se[l + 31 | 0] = 0, Se[l + 16 | 0] = 0, Se[l + 17 | 0] = 0, Se[l + 18 | 0] = 0, Se[l + 19 | 0] = 0, Se[l + 20 | 0] = 0, Se[l + 21 | 0] = 0, Se[l + 22 | 0] = 0, Se[l + 23 | 0] = 0, Se[l + 8 | 0] = 0, Se[l + 9 | 0] = 0, Se[l + 10 | 0] = 0, Se[l + 11 | 0] = 0, Se[l + 12 | 0] = 0, Se[l + 13 | 0] = 0, Se[l + 14 | 0] = 0, Se[l + 15 | 0] = 0, I = Je[C + 8 | 0] | Je[C + 9 | 0] << 8 | (Je[C + 10 | 0] << 16 | Je[C + 11 | 0] << 24), Ri = -29, y = 0, Ar = Je[C | 0] | Je[C + 1 | 0] << 8 | (Je[C + 2 | 0] << 16 | Je[C + 3 | 0] << 24), Q = Ar >>> 0 < 29, Ar = Q ? Ar : Ar - 29 | 0;
                                      h: {
                                        if (Ar >>> 0 >= 29) {
                                          if (e[5996] = 0, Co(124, l | 0, Ar + (Ar >>> 1 | 0) | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                            break h;
                                          S = Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24), Ri = S - 29 | 0, y = Je[l + 8 | 0] | Je[l + 9 | 0] << 8 | (Je[l + 10 | 0] << 16 | Je[l + 11 | 0] << 24);
                                        }
                                        br = l + 4 | 0, Qr = y, y = S >>> 0 < 29, me = y ? br : Qr, ve(Ar + me | 0, me, y ? S : Ri), y = Ar + (Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24)) | 0, Se[l | 0] = y, Se[l + 1 | 0] = y >>> 8, Se[l + 2 | 0] = y >>> 16, Se[l + 3 | 0] = y >>> 24;
                                        c: {
                                          if (!Ar)
                                            break c;
                                          y = Q ? C + 4 | 0 : I, I = Ar & 7;
                                          f: {
                                            if (!I) {
                                              S = y;
                                              break f;
                                            }
                                            for (Ri = 0, S = y; Se[me | 0] = Je[S | 0], S = S + 1 | 0, me = me + 1 | 0, Ri = Ri + 1 | 0, (I | 0) != (Ri | 0); )
                                              ;
                                          }
                                          if (Ar >>> 0 < 8)
                                            break c;
                                          for (y = y + Ar | 0; Se[me | 0] = Je[S | 0], Se[me + 1 | 0] = Je[S + 1 | 0], Se[me + 2 | 0] = Je[S + 2 | 0], Se[me + 3 | 0] = Je[S + 3 | 0], Se[me + 4 | 0] = Je[S + 4 | 0], Se[me + 5 | 0] = Je[S + 5 | 0], Se[me + 6 | 0] = Je[S + 6 | 0], Se[me + 7 | 0] = Je[S + 7 | 0], me = me + 8 | 0, S = S + 8 | 0, (y | 0) != (S | 0); )
                                            ;
                                        }
                                        if (e[5996] = 0, Xr = wn(127, l | 0, 100) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                          break h;
                                        if (Q = Je[C + 40 | 0] | Je[C + 41 | 0] << 8 | (Je[C + 42 | 0] << 16 | Je[C + 43 | 0] << 24), I = Je[C + 32 | 0] | Je[C + 33 | 0] << 8 | (Je[C + 34 | 0] << 16 | Je[C + 35 | 0] << 24), Ur = I >>> 0 < 29, S = Je[Xr | 0] | Je[Xr + 1 | 0] << 8 | (Je[Xr + 2 | 0] << 16 | Je[Xr + 3 | 0] << 24), y = S - 29 | 0, Qr = Ur ? I : I - 29 | 0, Ar = S >>> 0 < 29 ? S : y, I = Qr + Ar | 0, I >>> 0 > (S >>> 0 <= 28 ? 28 : Je[br | 0] | Je[br + 1 | 0] << 8 | (Je[br + 2 | 0] << 16 | Je[br + 3 | 0] << 24)) >>> 0) {
                                          if (e[5996] = 0, Co(124, Xr | 0, I + (I >>> 1 | 0) | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                            break h;
                                          S = Je[Xr | 0] | Je[Xr + 1 | 0] << 8 | (Je[Xr + 2 | 0] << 16 | Je[Xr + 3 | 0] << 24), y = S - 29 | 0;
                                        }
                                        I = S >>> 0 < 29, me = Ar + (I ? br : Je[l + 8 | 0] | Je[l + 9 | 0] << 8 | (Je[l + 10 | 0] << 16 | Je[l + 11 | 0] << 24)) | 0, ve(Qr + me | 0, me, (I ? S : y) - Ar | 0), y = Qr + (Je[Xr | 0] | Je[Xr + 1 | 0] << 8 | (Je[Xr + 2 | 0] << 16 | Je[Xr + 3 | 0] << 24)) | 0, Se[Xr | 0] = y, Se[Xr + 1 | 0] = y >>> 8, Se[Xr + 2 | 0] = y >>> 16, Se[Xr + 3 | 0] = y >>> 24;
                                        c: {
                                          if (!Qr)
                                            break c;
                                          y = Ur ? C + 36 | 0 : Q, I = Qr & 7;
                                          f: {
                                            if (!I) {
                                              S = y;
                                              break f;
                                            }
                                            for (C = 0, S = y; Se[me | 0] = Je[S | 0], S = S + 1 | 0, me = me + 1 | 0, C = C + 1 | 0, (I | 0) != (C | 0); )
                                              ;
                                          }
                                          if (Qr >>> 0 < 8)
                                            break c;
                                          for (y = y + Qr | 0; Se[me | 0] = Je[S | 0], Se[me + 1 | 0] = Je[S + 1 | 0], Se[me + 2 | 0] = Je[S + 2 | 0], Se[me + 3 | 0] = Je[S + 3 | 0], Se[me + 4 | 0] = Je[S + 4 | 0], Se[me + 5 | 0] = Je[S + 5 | 0], Se[me + 6 | 0] = Je[S + 6 | 0], Se[me + 7 | 0] = Je[S + 7 | 0], me = me + 8 | 0, S = S + 8 | 0, (y | 0) != (S | 0); )
                                            ;
                                        }
                                        if (e[5996] = 0, wn(127, Xr | 0, 104) | 0, y = e[5996], e[5996] = 0, (y | 0) != 1)
                                          break i;
                                      }
                                      break t;
                                    case 22:
                                      if (Se[l | 0] = 0, Se[l + 1 | 0] = 0, Se[l + 2 | 0] = 0, Se[l + 3 | 0] = 0, Se[l + 4 | 0] = 0, Se[l + 5 | 0] = 0, Se[l + 6 | 0] = 0, Se[l + 7 | 0] = 0, Se[l + 24 | 0] = 0, Se[l + 25 | 0] = 0, Se[l + 26 | 0] = 0, Se[l + 27 | 0] = 0, Se[l + 28 | 0] = 0, Se[l + 29 | 0] = 0, Se[l + 30 | 0] = 0, Se[l + 31 | 0] = 0, Se[l + 16 | 0] = 0, Se[l + 17 | 0] = 0, Se[l + 18 | 0] = 0, Se[l + 19 | 0] = 0, Se[l + 20 | 0] = 0, Se[l + 21 | 0] = 0, Se[l + 22 | 0] = 0, Se[l + 23 | 0] = 0, Se[l + 8 | 0] = 0, Se[l + 9 | 0] = 0, Se[l + 10 | 0] = 0, Se[l + 11 | 0] = 0, Se[l + 12 | 0] = 0, Se[l + 13 | 0] = 0, Se[l + 14 | 0] = 0, Se[l + 15 | 0] = 0, e[5996] = 0, Qr = wn(127, l | 0, 99) | 0, y = e[5996], e[5996] = 0, (y | 0) != 1)
                                        h: {
                                          if (Q = Je[C + 8 | 0] | Je[C + 9 | 0] << 8 | (Je[C + 10 | 0] << 16 | Je[C + 11 | 0] << 24), I = Je[C | 0] | Je[C + 1 | 0] << 8 | (Je[C + 2 | 0] << 16 | Je[C + 3 | 0] << 24), Ur = I >>> 0 < 29, S = Je[Qr | 0] | Je[Qr + 1 | 0] << 8 | (Je[Qr + 2 | 0] << 16 | Je[Qr + 3 | 0] << 24), y = S - 29 | 0, br = Ur ? I : I - 29 | 0, Ar = S >>> 0 < 29 ? S : y, I = br + Ar | 0, I >>> 0 > (S >>> 0 <= 28 ? 28 : Je[Qr + 4 | 0] | Je[Qr + 5 | 0] << 8 | (Je[Qr + 6 | 0] << 16 | Je[Qr + 7 | 0] << 24)) >>> 0) {
                                            if (e[5996] = 0, Co(124, Qr | 0, I + (I >>> 1 | 0) | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                              break h;
                                            S = Je[Qr | 0] | Je[Qr + 1 | 0] << 8 | (Je[Qr + 2 | 0] << 16 | Je[Qr + 3 | 0] << 24), y = S - 29 | 0;
                                          }
                                          I = S >>> 0 < 29, me = Ar + (I ? Qr + 4 | 0 : Je[Qr + 8 | 0] | Je[Qr + 9 | 0] << 8 | (Je[Qr + 10 | 0] << 16 | Je[Qr + 11 | 0] << 24)) | 0, ve(br + me | 0, me, (I ? S : y) - Ar | 0), y = br + (Je[Qr | 0] | Je[Qr + 1 | 0] << 8 | (Je[Qr + 2 | 0] << 16 | Je[Qr + 3 | 0] << 24)) | 0, Se[Qr | 0] = y, Se[Qr + 1 | 0] = y >>> 8, Se[Qr + 2 | 0] = y >>> 16, Se[Qr + 3 | 0] = y >>> 24;
                                          c: {
                                            if (!br)
                                              break c;
                                            y = Ur ? C + 4 | 0 : Q, I = br & 7;
                                            f: {
                                              if (!I) {
                                                S = y;
                                                break f;
                                              }
                                              for (S = y; Se[me | 0] = Je[S | 0], S = S + 1 | 0, me = me + 1 | 0, Ri = Ri + 1 | 0, (I | 0) != (Ri | 0); )
                                                ;
                                            }
                                            if (br >>> 0 < 8)
                                              break c;
                                            for (y = y + br | 0; Se[me | 0] = Je[S | 0], Se[me + 1 | 0] = Je[S + 1 | 0], Se[me + 2 | 0] = Je[S + 2 | 0], Se[me + 3 | 0] = Je[S + 3 | 0], Se[me + 4 | 0] = Je[S + 4 | 0], Se[me + 5 | 0] = Je[S + 5 | 0], Se[me + 6 | 0] = Je[S + 6 | 0], Se[me + 7 | 0] = Je[S + 7 | 0], me = me + 8 | 0, S = S + 8 | 0, (y | 0) != (S | 0); )
                                              ;
                                          }
                                          if (e[5996] = 0, Qr = wn(127, Qr | 0, 103) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                            break h;
                                          if (Q = Je[C + 40 | 0] | Je[C + 41 | 0] << 8 | (Je[C + 42 | 0] << 16 | Je[C + 43 | 0] << 24), I = Je[C + 32 | 0] | Je[C + 33 | 0] << 8 | (Je[C + 34 | 0] << 16 | Je[C + 35 | 0] << 24), Ur = I >>> 0 < 29, S = Je[Qr | 0] | Je[Qr + 1 | 0] << 8 | (Je[Qr + 2 | 0] << 16 | Je[Qr + 3 | 0] << 24), y = S - 29 | 0, br = Ur ? I : I - 29 | 0, Ar = S >>> 0 < 29 ? S : y, I = br + Ar | 0, I >>> 0 > (S >>> 0 <= 28 ? 28 : Je[Qr + 4 | 0] | Je[Qr + 5 | 0] << 8 | (Je[Qr + 6 | 0] << 16 | Je[Qr + 7 | 0] << 24)) >>> 0) {
                                            if (e[5996] = 0, Co(124, Qr | 0, I + (I >>> 1 | 0) | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                              break h;
                                            S = Je[Qr | 0] | Je[Qr + 1 | 0] << 8 | (Je[Qr + 2 | 0] << 16 | Je[Qr + 3 | 0] << 24), y = S - 29 | 0;
                                          }
                                          I = S >>> 0 < 29, me = Ar + (I ? Qr + 4 | 0 : Je[Qr + 8 | 0] | Je[Qr + 9 | 0] << 8 | (Je[Qr + 10 | 0] << 16 | Je[Qr + 11 | 0] << 24)) | 0, ve(br + me | 0, me, (I ? S : y) - Ar | 0), y = br + (Je[Qr | 0] | Je[Qr + 1 | 0] << 8 | (Je[Qr + 2 | 0] << 16 | Je[Qr + 3 | 0] << 24)) | 0, Se[Qr | 0] = y, Se[Qr + 1 | 0] = y >>> 8, Se[Qr + 2 | 0] = y >>> 16, Se[Qr + 3 | 0] = y >>> 24;
                                          c: {
                                            if (!br)
                                              break c;
                                            y = Ur ? C + 36 | 0 : Q, I = br & 7;
                                            f: {
                                              if (!I) {
                                                S = y;
                                                break f;
                                              }
                                              for (C = 0, S = y; Se[me | 0] = Je[S | 0], S = S + 1 | 0, me = me + 1 | 0, C = C + 1 | 0, (I | 0) != (C | 0); )
                                                ;
                                            }
                                            if (br >>> 0 < 8)
                                              break c;
                                            for (y = y + br | 0; Se[me | 0] = Je[S | 0], Se[me + 1 | 0] = Je[S + 1 | 0], Se[me + 2 | 0] = Je[S + 2 | 0], Se[me + 3 | 0] = Je[S + 3 | 0], Se[me + 4 | 0] = Je[S + 4 | 0], Se[me + 5 | 0] = Je[S + 5 | 0], Se[me + 6 | 0] = Je[S + 6 | 0], Se[me + 7 | 0] = Je[S + 7 | 0], me = me + 8 | 0, S = S + 8 | 0, (y | 0) != (S | 0); )
                                              ;
                                          }
                                          if (e[5996] = 0, wn(127, Qr | 0, 104) | 0, y = e[5996], e[5996] = 0, (y | 0) != 1)
                                            break i;
                                        }
                                      break t;
                                    case 23:
                                      Se[l | 0] = 0, Se[l + 1 | 0] = 0, Se[l + 2 | 0] = 0, Se[l + 3 | 0] = 0, Se[l + 4 | 0] = 0, Se[l + 5 | 0] = 0, Se[l + 6 | 0] = 0, Se[l + 7 | 0] = 0, Se[l + 24 | 0] = 0, Se[l + 25 | 0] = 0, Se[l + 26 | 0] = 0, Se[l + 27 | 0] = 0, Se[l + 28 | 0] = 0, Se[l + 29 | 0] = 0, Se[l + 30 | 0] = 0, Se[l + 31 | 0] = 0, Se[l + 16 | 0] = 0, Se[l + 17 | 0] = 0, Se[l + 18 | 0] = 0, Se[l + 19 | 0] = 0, Se[l + 20 | 0] = 0, Se[l + 21 | 0] = 0, Se[l + 22 | 0] = 0, Se[l + 23 | 0] = 0, Se[l + 8 | 0] = 0, Se[l + 9 | 0] = 0, Se[l + 10 | 0] = 0, Se[l + 11 | 0] = 0, Se[l + 12 | 0] = 0, Se[l + 13 | 0] = 0, Se[l + 14 | 0] = 0, Se[l + 15 | 0] = 0, I = Je[C + 8 | 0] | Je[C + 9 | 0] << 8 | (Je[C + 10 | 0] << 16 | Je[C + 11 | 0] << 24), Ri = -29, y = 0, Ar = Je[C | 0] | Je[C + 1 | 0] << 8 | (Je[C + 2 | 0] << 16 | Je[C + 3 | 0] << 24), Q = Ar >>> 0 < 29, Ar = Q ? Ar : Ar - 29 | 0;
                                      h: {
                                        if (Ar >>> 0 >= 29) {
                                          if (e[5996] = 0, Co(124, l | 0, Ar + (Ar >>> 1 | 0) | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                            break h;
                                          S = Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24), Ri = S - 29 | 0, y = Je[l + 8 | 0] | Je[l + 9 | 0] << 8 | (Je[l + 10 | 0] << 16 | Je[l + 11 | 0] << 24);
                                        }
                                        Qr = l + 4 | 0, Xr = y, y = S >>> 0 < 29, me = y ? Qr : Xr, ve(Ar + me | 0, me, y ? S : Ri), y = Ar + (Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24)) | 0, Se[l | 0] = y, Se[l + 1 | 0] = y >>> 8, Se[l + 2 | 0] = y >>> 16, Se[l + 3 | 0] = y >>> 24;
                                        c: {
                                          if (!Ar)
                                            break c;
                                          y = Q ? C + 4 | 0 : I, I = Ar & 7;
                                          f: {
                                            if (!I) {
                                              S = y;
                                              break f;
                                            }
                                            for (Ri = 0, S = y; Se[me | 0] = Je[S | 0], S = S + 1 | 0, me = me + 1 | 0, Ri = Ri + 1 | 0, (I | 0) != (Ri | 0); )
                                              ;
                                          }
                                          if (Ar >>> 0 < 8)
                                            break c;
                                          for (y = y + Ar | 0; Se[me | 0] = Je[S | 0], Se[me + 1 | 0] = Je[S + 1 | 0], Se[me + 2 | 0] = Je[S + 2 | 0], Se[me + 3 | 0] = Je[S + 3 | 0], Se[me + 4 | 0] = Je[S + 4 | 0], Se[me + 5 | 0] = Je[S + 5 | 0], Se[me + 6 | 0] = Je[S + 6 | 0], Se[me + 7 | 0] = Je[S + 7 | 0], me = me + 8 | 0, S = S + 8 | 0, (y | 0) != (S | 0); )
                                            ;
                                        }
                                        if (e[5996] = 0, Xr = wn(127, l | 0, 100) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                          break h;
                                        if (Q = Je[C + 72 | 0] | Je[C + 73 | 0] << 8 | (Je[C + 74 | 0] << 16 | Je[C + 75 | 0] << 24), I = Je[C + 64 | 0] | Je[C + 65 | 0] << 8 | (Je[C + 66 | 0] << 16 | Je[C + 67 | 0] << 24), Ur = I >>> 0 < 29, S = Je[Xr | 0] | Je[Xr + 1 | 0] << 8 | (Je[Xr + 2 | 0] << 16 | Je[Xr + 3 | 0] << 24), y = S - 29 | 0, br = Ur ? I : I - 29 | 0, Ar = S >>> 0 < 29 ? S : y, I = br + Ar | 0, I >>> 0 > (S >>> 0 <= 28 ? 28 : Je[Qr | 0] | Je[Qr + 1 | 0] << 8 | (Je[Qr + 2 | 0] << 16 | Je[Qr + 3 | 0] << 24)) >>> 0) {
                                          if (e[5996] = 0, Co(124, Xr | 0, I + (I >>> 1 | 0) | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                            break h;
                                          S = Je[Xr | 0] | Je[Xr + 1 | 0] << 8 | (Je[Xr + 2 | 0] << 16 | Je[Xr + 3 | 0] << 24), y = S - 29 | 0;
                                        }
                                        I = S >>> 0 < 29, me = Ar + (I ? Qr : Je[l + 8 | 0] | Je[l + 9 | 0] << 8 | (Je[l + 10 | 0] << 16 | Je[l + 11 | 0] << 24)) | 0, ve(br + me | 0, me, (I ? S : y) - Ar | 0), y = br + (Je[Xr | 0] | Je[Xr + 1 | 0] << 8 | (Je[Xr + 2 | 0] << 16 | Je[Xr + 3 | 0] << 24)) | 0, Se[Xr | 0] = y, Se[Xr + 1 | 0] = y >>> 8, Se[Xr + 2 | 0] = y >>> 16, Se[Xr + 3 | 0] = y >>> 24;
                                        c: {
                                          if (!br)
                                            break c;
                                          y = Ur ? C + 68 | 0 : Q, I = br & 7;
                                          f: {
                                            if (!I) {
                                              S = y;
                                              break f;
                                            }
                                            for (Ri = 0, S = y; Se[me | 0] = Je[S | 0], S = S + 1 | 0, me = me + 1 | 0, Ri = Ri + 1 | 0, (I | 0) != (Ri | 0); )
                                              ;
                                          }
                                          if (br >>> 0 < 8)
                                            break c;
                                          for (y = y + br | 0; Se[me | 0] = Je[S | 0], Se[me + 1 | 0] = Je[S + 1 | 0], Se[me + 2 | 0] = Je[S + 2 | 0], Se[me + 3 | 0] = Je[S + 3 | 0], Se[me + 4 | 0] = Je[S + 4 | 0], Se[me + 5 | 0] = Je[S + 5 | 0], Se[me + 6 | 0] = Je[S + 6 | 0], Se[me + 7 | 0] = Je[S + 7 | 0], me = me + 8 | 0, S = S + 8 | 0, (y | 0) != (S | 0); )
                                            ;
                                        }
                                        if (e[5996] = 0, Xr = wn(127, Xr | 0, 103) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                          break h;
                                        if (Q = Je[C + 40 | 0] | Je[C + 41 | 0] << 8 | (Je[C + 42 | 0] << 16 | Je[C + 43 | 0] << 24), I = Je[C + 32 | 0] | Je[C + 33 | 0] << 8 | (Je[C + 34 | 0] << 16 | Je[C + 35 | 0] << 24), Ur = I >>> 0 < 29, S = Je[Xr | 0] | Je[Xr + 1 | 0] << 8 | (Je[Xr + 2 | 0] << 16 | Je[Xr + 3 | 0] << 24), y = S - 29 | 0, br = Ur ? I : I - 29 | 0, Ar = S >>> 0 < 29 ? S : y, I = br + Ar | 0, I >>> 0 > (S >>> 0 <= 28 ? 28 : Je[Qr | 0] | Je[Qr + 1 | 0] << 8 | (Je[Qr + 2 | 0] << 16 | Je[Qr + 3 | 0] << 24)) >>> 0) {
                                          if (e[5996] = 0, Co(124, Xr | 0, I + (I >>> 1 | 0) | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                            break h;
                                          S = Je[Xr | 0] | Je[Xr + 1 | 0] << 8 | (Je[Xr + 2 | 0] << 16 | Je[Xr + 3 | 0] << 24), y = S - 29 | 0;
                                        }
                                        I = S >>> 0 < 29, me = Ar + (I ? Qr : Je[l + 8 | 0] | Je[l + 9 | 0] << 8 | (Je[l + 10 | 0] << 16 | Je[l + 11 | 0] << 24)) | 0, ve(br + me | 0, me, (I ? S : y) - Ar | 0), y = br + (Je[Xr | 0] | Je[Xr + 1 | 0] << 8 | (Je[Xr + 2 | 0] << 16 | Je[Xr + 3 | 0] << 24)) | 0, Se[Xr | 0] = y, Se[Xr + 1 | 0] = y >>> 8, Se[Xr + 2 | 0] = y >>> 16, Se[Xr + 3 | 0] = y >>> 24;
                                        c: {
                                          if (!br)
                                            break c;
                                          y = Ur ? C + 36 | 0 : Q, I = br & 7;
                                          f: {
                                            if (!I) {
                                              S = y;
                                              break f;
                                            }
                                            for (C = 0, S = y; Se[me | 0] = Je[S | 0], S = S + 1 | 0, me = me + 1 | 0, C = C + 1 | 0, (I | 0) != (C | 0); )
                                              ;
                                          }
                                          if (br >>> 0 < 8)
                                            break c;
                                          for (y = y + br | 0; Se[me | 0] = Je[S | 0], Se[me + 1 | 0] = Je[S + 1 | 0], Se[me + 2 | 0] = Je[S + 2 | 0], Se[me + 3 | 0] = Je[S + 3 | 0], Se[me + 4 | 0] = Je[S + 4 | 0], Se[me + 5 | 0] = Je[S + 5 | 0], Se[me + 6 | 0] = Je[S + 6 | 0], Se[me + 7 | 0] = Je[S + 7 | 0], me = me + 8 | 0, S = S + 8 | 0, (y | 0) != (S | 0); )
                                            ;
                                        }
                                        if (e[5996] = 0, wn(127, Xr | 0, 104) | 0, y = e[5996], e[5996] = 0, (y | 0) != 1)
                                          break i;
                                      }
                                      break t;
                                    case 25:
                                      if (e[ke + 72 >> 2] = 0, e[ke + 76 >> 2] = 0, C = ke - -64 | 0, e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[ke + 56 >> 2] = 0, e[ke + 60 >> 2] = 0, e[ke + 48 >> 2] = 0, e[ke + 52 >> 2] = 0, C = e[I + 4 >> 2], e[5996] = 0, yn = gu(ke + 48 | 0, C, 0), C = e[5996], e[5996] = 0, (C | 0) == 1) {
                                        if (me = gi() | 0, qs[ke + 48 >> 2] < 29)
                                          break e;
                                        Tr(e[ke + 56 >> 2]);
                                        break e;
                                      }
                                      if (Q = e[I + 8 >> 2], Xr = e[I + 12 >> 2], (Q | 0) == (Xr | 0)) {
                                        I = Q;
                                        break a;
                                      }
                                      for (Ur = yn + 4 | 0, Ar = ke + 20 | 0; ; ) {
                                        h: {
                                          if (e[5996] = 0, S = no(3, 4) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                            break h;
                                          if (e[ke + 4 >> 2] = S, C = S + 4 | 0, e[ke + 12 >> 2] = C, Se[S | 0] = 2, Se[S + 1 | 0] = 80, Se[S + 2 | 0] = 75, Se[S + 3 | 0] = 98, e[ke + 8 >> 2] = C, e[5996] = 0, Se[ke + 80 | 0] = 0, Ms(126, ke + 4 | 0, 29, ke + 80 | 0), C = e[5996], e[5996] = 0, (C | 0) == 1) {
                                            if (me = gi() | 0, l = e[ke + 4 >> 2], !l)
                                              break o;
                                            Tr(l);
                                            break o;
                                          }
                                          if (C = 0, br = Je[Q + 11 | 0], S = br << 24 >> 24 < 0, ve(e[ke + 4 >> 2] + 4 | 0, S ? e[Q >> 2] : Q, S ? e[Q + 4 >> 2] : br), e[ke + 40 >> 2] = 0, e[ke + 44 >> 2] = 0, e[ke + 32 >> 2] = 0, e[ke + 36 >> 2] = 0, e[ke + 24 >> 2] = 0, e[ke + 28 >> 2] = 0, e[ke + 16 >> 2] = 0, e[ke + 20 >> 2] = 0, Ri = -29, br = e[yn + 8 >> 2], S = 0, En = e[yn >> 2], Qr = En >>> 0 < 29, En = Qr ? En : En - 29 | 0, En >>> 0 >= 29) {
                                            if (e[5996] = 0, Co(124, ke + 16 | 0, En + (En >>> 1 | 0) | 0), C = e[5996], e[5996] = 0, (C | 0) == 1)
                                              break A;
                                            S = e[ke + 16 >> 2], Ri = S - 29 | 0, me = e[ke + 24 >> 2];
                                          } else
                                            me = C;
                                          C = S >>> 0 < 29, me = C ? Ar : me, ve(me + En | 0, me, C ? S : Ri), e[ke + 16 >> 2] = En + e[ke + 16 >> 2];
                                          c: {
                                            if (!En)
                                              break c;
                                            if (C = 0, Qr = Qr ? Ur : br, S = Qr, br = En & 7, br)
                                              for (; Se[me | 0] = Je[S | 0], S = S + 1 | 0, me = me + 1 | 0, C = C + 1 | 0, (br | 0) != (C | 0); )
                                                ;
                                            if (En >>> 0 < 8)
                                              break c;
                                            for (C = Qr + En | 0; Se[me | 0] = Je[S | 0], Se[me + 1 | 0] = Je[S + 1 | 0], Se[me + 2 | 0] = Je[S + 2 | 0], Se[me + 3 | 0] = Je[S + 3 | 0], Se[me + 4 | 0] = Je[S + 4 | 0], Se[me + 5 | 0] = Je[S + 5 | 0], Se[me + 6 | 0] = Je[S + 6 | 0], Se[me + 7 | 0] = Je[S + 7 | 0], me = me + 8 | 0, S = S + 8 | 0, (C | 0) != (S | 0); )
                                              ;
                                          }
                                          if (e[5996] = 0, S = wn(19, ke + 16 | 0, ke + 4 | 0) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                            break A;
                                          if (e[ke + 104 >> 2] = Je[Ur + 24 | 0] | Je[Ur + 25 | 0] << 8 | (Je[Ur + 26 | 0] << 16 | Je[Ur + 27 | 0] << 24), C = Je[Ur + 20 | 0] | Je[Ur + 21 | 0] << 8 | (Je[Ur + 22 | 0] << 16 | Je[Ur + 23 | 0] << 24), e[ke + 96 >> 2] = Je[Ur + 16 | 0] | Je[Ur + 17 | 0] << 8 | (Je[Ur + 18 | 0] << 16 | Je[Ur + 19 | 0] << 24), e[ke + 100 >> 2] = C, C = Je[Ur + 12 | 0] | Je[Ur + 13 | 0] << 8 | (Je[Ur + 14 | 0] << 16 | Je[Ur + 15 | 0] << 24), e[ke + 88 >> 2] = Je[Ur + 8 | 0] | Je[Ur + 9 | 0] << 8 | (Je[Ur + 10 | 0] << 16 | Je[Ur + 11 | 0] << 24), e[ke + 92 >> 2] = C, C = Je[Ur + 4 | 0] | Je[Ur + 5 | 0] << 8 | (Je[Ur + 6 | 0] << 16 | Je[Ur + 7 | 0] << 24), e[ke + 80 >> 2] = Je[Ur | 0] | Je[Ur + 1 | 0] << 8 | (Je[Ur + 2 | 0] << 16 | Je[Ur + 3 | 0] << 24), e[ke + 84 >> 2] = C, e[Ur + 24 >> 2] = e[Ar + 24 >> 2], C = e[Ar + 20 >> 2], e[Ur + 16 >> 2] = e[Ar + 16 >> 2], e[Ur + 20 >> 2] = C, C = e[Ar + 12 >> 2], e[Ur + 8 >> 2] = e[Ar + 8 >> 2], e[Ur + 12 >> 2] = C, C = e[Ar + 4 >> 2], e[Ur >> 2] = e[Ar >> 2], e[Ur + 4 >> 2] = C, C = e[ke + 104 >> 2], Se[Ar + 24 | 0] = C, Se[Ar + 25 | 0] = C >>> 8, Se[Ar + 26 | 0] = C >>> 16, Se[Ar + 27 | 0] = C >>> 24, br = e[ke + 100 >> 2], C = e[ke + 96 >> 2], Se[Ar + 16 | 0] = C, Se[Ar + 17 | 0] = C >>> 8, Se[Ar + 18 | 0] = C >>> 16, Se[Ar + 19 | 0] = C >>> 24, Se[Ar + 20 | 0] = br, Se[Ar + 21 | 0] = br >>> 8, Se[Ar + 22 | 0] = br >>> 16, Se[Ar + 23 | 0] = br >>> 24, br = e[ke + 92 >> 2], C = e[ke + 88 >> 2], Se[Ar + 8 | 0] = C, Se[Ar + 9 | 0] = C >>> 8, Se[Ar + 10 | 0] = C >>> 16, Se[Ar + 11 | 0] = C >>> 24, Se[Ar + 12 | 0] = br, Se[Ar + 13 | 0] = br >>> 8, Se[Ar + 14 | 0] = br >>> 16, Se[Ar + 15 | 0] = br >>> 24, br = e[ke + 84 >> 2], C = e[ke + 80 >> 2], Se[Ar | 0] = C, Se[Ar + 1 | 0] = C >>> 8, Se[Ar + 2 | 0] = C >>> 16, Se[Ar + 3 | 0] = C >>> 24, Se[Ar + 4 | 0] = br, Se[Ar + 5 | 0] = br >>> 8, Se[Ar + 6 | 0] = br >>> 16, Se[Ar + 7 | 0] = br >>> 24, C = e[yn >> 2], e[yn >> 2] = e[S >> 2], e[S >> 2] = C, C >>> 0 >= 29 && (Tr(e[ke + 24 >> 2]), e[ke + 24 >> 2] = 0), C = e[ke + 4 >> 2], C && Tr(C), Q = Q + 12 | 0, (Xr | 0) != (Q | 0))
                                            continue;
                                          break s;
                                        }
                                        break;
                                      }
                                      me = gi() | 0;
                                      break o;
                                    case 24:
                                      e[ke + 72 >> 2] = 0, e[ke + 76 >> 2] = 0, S = ke - -64 | 0, e[S >> 2] = 0, e[S + 4 >> 2] = 0, e[ke + 56 >> 2] = 0, e[ke + 60 >> 2] = 0, e[ke + 48 >> 2] = 0, e[ke + 52 >> 2] = 0, Ri = e[ke + 76 >> 2], e[ke + 40 >> 2] = Ri, Qr = e[ke + 72 >> 2], S = e[ke + 68 >> 2], Xr = S, e[ke + 32 >> 2] = S, e[ke + 36 >> 2] = Qr, br = e[ke + 64 >> 2], Ar = e[ke + 60 >> 2], e[ke + 24 >> 2] = Ar, e[ke + 28 >> 2] = br, Ur = e[ke + 56 >> 2], S = e[ke + 52 >> 2], e[ke + 16 >> 2] = S, e[ke + 20 >> 2] = Ur, e[ke + 76 >> 2] = Je[C + 28 | 0] | Je[C + 29 | 0] << 8 | (Je[C + 30 | 0] << 16 | Je[C + 31 | 0] << 24), yn = Je[C + 24 | 0] | Je[C + 25 | 0] << 8 | (Je[C + 26 | 0] << 16 | Je[C + 27 | 0] << 24), e[ke + 68 >> 2] = Je[C + 20 | 0] | Je[C + 21 | 0] << 8 | (Je[C + 22 | 0] << 16 | Je[C + 23 | 0] << 24), e[ke + 72 >> 2] = yn, yn = Je[C + 16 | 0] | Je[C + 17 | 0] << 8 | (Je[C + 18 | 0] << 16 | Je[C + 19 | 0] << 24), e[ke + 60 >> 2] = Je[C + 12 | 0] | Je[C + 13 | 0] << 8 | (Je[C + 14 | 0] << 16 | Je[C + 15 | 0] << 24), e[ke + 64 >> 2] = yn, yn = Je[C + 8 | 0] | Je[C + 9 | 0] << 8 | (Je[C + 10 | 0] << 16 | Je[C + 11 | 0] << 24), e[ke + 52 >> 2] = Je[C + 4 | 0] | Je[C + 5 | 0] << 8 | (Je[C + 6 | 0] << 16 | Je[C + 7 | 0] << 24), e[ke + 56 >> 2] = yn, Se[C + 28 | 0] = Ri, Se[C + 29 | 0] = Ri >>> 8, Se[C + 30 | 0] = Ri >>> 16, Se[C + 31 | 0] = Ri >>> 24, Se[C + 20 | 0] = Xr, Se[C + 21 | 0] = Xr >>> 8, Se[C + 22 | 0] = Xr >>> 16, Se[C + 23 | 0] = Xr >>> 24, Se[C + 24 | 0] = Qr, Se[C + 25 | 0] = Qr >>> 8, Se[C + 26 | 0] = Qr >>> 16, Se[C + 27 | 0] = Qr >>> 24, Se[C + 12 | 0] = Ar, Se[C + 13 | 0] = Ar >>> 8, Se[C + 14 | 0] = Ar >>> 16, Se[C + 15 | 0] = Ar >>> 24, Se[C + 16 | 0] = br, Se[C + 17 | 0] = br >>> 8, Se[C + 18 | 0] = br >>> 16, Se[C + 19 | 0] = br >>> 24, Se[C + 4 | 0] = S, Se[C + 5 | 0] = S >>> 8, Se[C + 6 | 0] = S >>> 16, Se[C + 7 | 0] = S >>> 24, Se[C + 8 | 0] = Ur, Se[C + 9 | 0] = Ur >>> 8, Se[C + 10 | 0] = Ur >>> 16, Se[C + 11 | 0] = Ur >>> 24, me = e[C >> 2], e[ke + 48 >> 2] = me, e[C >> 2] = 0, br = ke + 48 | 4;
                                      h: {
                                        c: {
                                          if (Q >>> 0 >= 2) {
                                            for (Ri = 1; ; ) {
                                              if (e[5996] = 0, e[ke + 4 >> 2] = 147, ia(128, ke + 16 | 0, ke + 48 | 0, (Ri << 5) + C | 0, ke + 4 | 0), S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                break c;
                                              if (e[ke + 104 >> 2] = Je[br + 24 | 0] | Je[br + 25 | 0] << 8 | (Je[br + 26 | 0] << 16 | Je[br + 27 | 0] << 24), S = Je[br + 20 | 0] | Je[br + 21 | 0] << 8 | (Je[br + 22 | 0] << 16 | Je[br + 23 | 0] << 24), e[ke + 96 >> 2] = Je[br + 16 | 0] | Je[br + 17 | 0] << 8 | (Je[br + 18 | 0] << 16 | Je[br + 19 | 0] << 24), e[ke + 100 >> 2] = S, S = Je[br + 12 | 0] | Je[br + 13 | 0] << 8 | (Je[br + 14 | 0] << 16 | Je[br + 15 | 0] << 24), e[ke + 88 >> 2] = Je[br + 8 | 0] | Je[br + 9 | 0] << 8 | (Je[br + 10 | 0] << 16 | Je[br + 11 | 0] << 24), e[ke + 92 >> 2] = S, S = Je[br + 4 | 0] | Je[br + 5 | 0] << 8 | (Je[br + 6 | 0] << 16 | Je[br + 7 | 0] << 24), e[ke + 80 >> 2] = Je[br | 0] | Je[br + 1 | 0] << 8 | (Je[br + 2 | 0] << 16 | Je[br + 3 | 0] << 24), e[ke + 84 >> 2] = S, e[br + 24 >> 2] = e[ke + 44 >> 2], S = e[ke + 40 >> 2], e[br + 16 >> 2] = e[ke + 36 >> 2], e[br + 20 >> 2] = S, S = e[ke + 32 >> 2], e[br + 8 >> 2] = e[ke + 28 >> 2], e[br + 12 >> 2] = S, S = e[ke + 24 >> 2], e[br >> 2] = e[ke + 20 >> 2], e[br + 4 >> 2] = S, S = e[ke + 104 >> 2], Se[ke + 44 | 0] = S, Se[ke + 45 | 0] = S >>> 8, Se[ke + 46 | 0] = S >>> 16, Se[ke + 47 | 0] = S >>> 24, Ar = e[ke + 100 >> 2], S = e[ke + 96 >> 2], Se[ke + 36 | 0] = S, Se[ke + 37 | 0] = S >>> 8, Se[ke + 38 | 0] = S >>> 16, Se[ke + 39 | 0] = S >>> 24, Se[ke + 40 | 0] = Ar, Se[ke + 41 | 0] = Ar >>> 8, Se[ke + 42 | 0] = Ar >>> 16, Se[ke + 43 | 0] = Ar >>> 24, Ar = e[ke + 92 >> 2], S = e[ke + 88 >> 2], Se[ke + 28 | 0] = S, Se[ke + 29 | 0] = S >>> 8, Se[ke + 30 | 0] = S >>> 16, Se[ke + 31 | 0] = S >>> 24, Se[ke + 32 | 0] = Ar, Se[ke + 33 | 0] = Ar >>> 8, Se[ke + 34 | 0] = Ar >>> 16, Se[ke + 35 | 0] = Ar >>> 24, Ar = e[ke + 84 >> 2], S = e[ke + 80 >> 2], Se[ke + 20 | 0] = S, Se[ke + 21 | 0] = S >>> 8, Se[ke + 22 | 0] = S >>> 16, Se[ke + 23 | 0] = S >>> 24, Se[ke + 24 | 0] = Ar, Se[ke + 25 | 0] = Ar >>> 8, Se[ke + 26 | 0] = Ar >>> 16, Se[ke + 27 | 0] = Ar >>> 24, S = e[ke + 48 >> 2], e[ke + 48 >> 2] = e[ke + 16 >> 2], e[ke + 16 >> 2] = S, S >>> 0 >= 29 && Tr(e[ke + 24 >> 2]), Ri = Ri + 1 | 0, (Ri | 0) == (Q | 0))
                                                break;
                                            }
                                            me = e[ke + 48 >> 2];
                                          }
                                          Se[l | 0] = 0, Se[l + 1 | 0] = 0, Se[l + 2 | 0] = 0, Se[l + 3 | 0] = 0, Se[l + 4 | 0] = 0, Se[l + 5 | 0] = 0, Se[l + 6 | 0] = 0, Se[l + 7 | 0] = 0, Se[l + 24 | 0] = 0, Se[l + 25 | 0] = 0, Se[l + 26 | 0] = 0, Se[l + 27 | 0] = 0, Se[l + 28 | 0] = 0, Se[l + 29 | 0] = 0, Se[l + 30 | 0] = 0, Se[l + 31 | 0] = 0, Se[l + 16 | 0] = 0, Se[l + 17 | 0] = 0, Se[l + 18 | 0] = 0, Se[l + 19 | 0] = 0, Se[l + 20 | 0] = 0, Se[l + 21 | 0] = 0, Se[l + 22 | 0] = 0, Se[l + 23 | 0] = 0, Se[l + 8 | 0] = 0, Se[l + 9 | 0] = 0, Se[l + 10 | 0] = 0, Se[l + 11 | 0] = 0, Se[l + 12 | 0] = 0, Se[l + 13 | 0] = 0, Se[l + 14 | 0] = 0, Se[l + 15 | 0] = 0, Ri = -29, Ar = e[ke + 56 >> 2], C = 0;
                                          f: {
                                            Qr = l + 4 | 0, S = me >>> 0 < 29, Ur = S ? me : me - 29 | 0;
                                            p: {
                                              if (Ur >>> 0 >= 29) {
                                                if (e[5996] = 0, Co(124, l | 0, Ur + (Ur >>> 1 | 0) | 0), C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                  break p;
                                                C = Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24), Ri = C - 29 | 0, En = Je[l + 8 | 0] | Je[l + 9 | 0] << 8 | (Je[l + 10 | 0] << 16 | Je[l + 11 | 0] << 24);
                                              }
                                              Q = C >>> 0 < 29, me = Q ? Qr : En, ve(me + Ur | 0, me, Q ? C : Ri), C = Ur + (Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24)) | 0, Se[l | 0] = C, Se[l + 1 | 0] = C >>> 8, Se[l + 2 | 0] = C >>> 16, Se[l + 3 | 0] = C >>> 24;
                                              d: {
                                                if (!Ur)
                                                  break d;
                                                Q = S ? br : Ar, Ar = Ur & 7;
                                                g: {
                                                  if (!Ar) {
                                                    S = Q;
                                                    break g;
                                                  }
                                                  for (C = 0, S = Q; Se[me | 0] = Je[S | 0], S = S + 1 | 0, me = me + 1 | 0, C = C + 1 | 0, (Ar | 0) != (C | 0); )
                                                    ;
                                                }
                                                if (Ur >>> 0 < 8)
                                                  break d;
                                                for (C = Q + Ur | 0; Se[me | 0] = Je[S | 0], Se[me + 1 | 0] = Je[S + 1 | 0], Se[me + 2 | 0] = Je[S + 2 | 0], Se[me + 3 | 0] = Je[S + 3 | 0], Se[me + 4 | 0] = Je[S + 4 | 0], Se[me + 5 | 0] = Je[S + 5 | 0], Se[me + 6 | 0] = Je[S + 6 | 0], Se[me + 7 | 0] = Je[S + 7 | 0], me = me + 8 | 0, S = S + 8 | 0, (C | 0) != (S | 0); )
                                                  ;
                                              }
                                              if (I = e[I + 4 >> 2], e[5996] = 0, C = gu(l, I, 0), I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                break p;
                                              if (e[5996] = 0, wn(127, C | 0, (y ? 136 : 135) | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) != 1)
                                                break f;
                                            }
                                            if (me = gi() | 0, (Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24)) >>> 0 < 29)
                                              break h;
                                            Tr(Je[l + 8 | 0] | Je[l + 9 | 0] << 8 | (Je[l + 10 | 0] << 16 | Je[l + 11 | 0] << 24)), Se[l + 8 | 0] = 0, Se[l + 9 | 0] = 0, Se[l + 10 | 0] = 0, Se[l + 11 | 0] = 0;
                                            break h;
                                          }
                                          if (qs[ke + 48 >> 2] < 29)
                                            break i;
                                          Tr(e[ke + 56 >> 2]);
                                          break i;
                                        }
                                        me = gi() | 0;
                                      }
                                      if (qs[ke + 48 >> 2] < 29)
                                        break e;
                                      Tr(e[ke + 56 >> 2]);
                                      break e;
                                    default:
                                      Nf(2350, 2210, 624, 5107), jn();
                                    case 6:
                                      break u;
                                  }
                                e[ke + 48 >> 2] = 32, e[ke + 16 >> 2] = 136, e[ke + 80 >> 2] = 168, e[ke + 4 >> 2] = y ? 136 : 135, uu(l, ke + 48 | 0, ke + 16 | 0, ke + 80 | 0, I + 20 | 0, ke + 4 | 0);
                                break i;
                              }
                              if (me = gi() | 0, qs[ke + 16 >> 2] >= 29 && (Tr(e[ke + 24 >> 2]), e[ke + 24 >> 2] = 0), l = e[ke + 4 >> 2], !l)
                                break o;
                              Tr(l);
                              break o;
                            }
                            Q = e[I + 8 >> 2], I = e[I + 12 >> 2];
                          }
                          Se[l | 0] = 0, Se[l + 1 | 0] = 0, Se[l + 2 | 0] = 0, Se[l + 3 | 0] = 0, Se[l + 4 | 0] = 0, Se[l + 5 | 0] = 0, Se[l + 6 | 0] = 0, Se[l + 7 | 0] = 0, Se[l + 24 | 0] = 0, Se[l + 25 | 0] = 0, Se[l + 26 | 0] = 0, Se[l + 27 | 0] = 0, Se[l + 28 | 0] = 0, Se[l + 29 | 0] = 0, Se[l + 30 | 0] = 0, Se[l + 31 | 0] = 0, Se[l + 16 | 0] = 0, Se[l + 17 | 0] = 0, Se[l + 18 | 0] = 0, Se[l + 19 | 0] = 0, Se[l + 20 | 0] = 0, Se[l + 21 | 0] = 0, Se[l + 22 | 0] = 0, Se[l + 23 | 0] = 0, Se[l + 8 | 0] = 0, Se[l + 9 | 0] = 0, Se[l + 10 | 0] = 0, Se[l + 11 | 0] = 0, Se[l + 12 | 0] = 0, Se[l + 13 | 0] = 0, Se[l + 14 | 0] = 0, Se[l + 15 | 0] = 0, Ur = e[yn + 8 >> 2], C = -29, Ar = (I - Q | 0) / 12 | 0, Ri = 0, S = 0, I = e[yn >> 2], Q = I >>> 0 < 29, br = Q ? I : I - 29 | 0;
                          a: {
                            if (br >>> 0 >= 29) {
                              if (e[5996] = 0, Co(124, l | 0, br + (br >>> 1 | 0) | 0), I = e[5996], e[5996] = 0, (I | 0) == 1)
                                break a;
                              Ri = Je[l + 8 | 0] | Je[l + 9 | 0] << 8 | (Je[l + 10 | 0] << 16 | Je[l + 11 | 0] << 24), S = Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24), C = S - 29 | 0;
                            }
                            I = S >>> 0 < 29, me = I ? l + 4 | 0 : Ri, ve(br + me | 0, me, I ? S : C), I = br + (Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24)) | 0, Se[l | 0] = I, Se[l + 1 | 0] = I >>> 8, Se[l + 2 | 0] = I >>> 16, Se[l + 3 | 0] = I >>> 24;
                            s: {
                              if (!br)
                                break s;
                              I = Q ? yn + 4 | 0 : Ur, Q = br & 7;
                              A: {
                                if (!Q) {
                                  S = I;
                                  break A;
                                }
                                for (C = 0, S = I; Se[me | 0] = Je[S | 0], S = S + 1 | 0, me = me + 1 | 0, C = C + 1 | 0, (Q | 0) != (C | 0); )
                                  ;
                              }
                              if (br >>> 0 < 8)
                                break s;
                              for (I = I + br | 0; Se[me | 0] = Je[S | 0], Se[me + 1 | 0] = Je[S + 1 | 0], Se[me + 2 | 0] = Je[S + 2 | 0], Se[me + 3 | 0] = Je[S + 3 | 0], Se[me + 4 | 0] = Je[S + 4 | 0], Se[me + 5 | 0] = Je[S + 5 | 0], Se[me + 6 | 0] = Je[S + 6 | 0], Se[me + 7 | 0] = Je[S + 7 | 0], me = me + 8 | 0, S = S + 8 | 0, (I | 0) != (S | 0); )
                                ;
                            }
                            if (e[5996] = 0, C = gu(l, Ar, 0), I = e[5996], e[5996] = 0, (I | 0) == 1)
                              break a;
                            if (e[5996] = 0, wn(127, C | 0, (y ? 175 : 174) | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) != 1)
                              break n;
                          }
                          if (me = gi() | 0, (Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24)) >>> 0 < 29)
                            break o;
                          Tr(Je[l + 8 | 0] | Je[l + 9 | 0] << 8 | (Je[l + 10 | 0] << 16 | Je[l + 11 | 0] << 24)), Se[l + 8 | 0] = 0, Se[l + 9 | 0] = 0, Se[l + 10 | 0] = 0, Se[l + 11 | 0] = 0;
                        }
                        if (qs[yn >> 2] < 29)
                          break e;
                        Tr(e[yn + 8 >> 2]);
                        break e;
                      }
                      if (qs[yn >> 2] < 29)
                        break i;
                      Tr(e[yn + 8 >> 2]);
                    }
                    bi = ke + 112 | 0;
                    return;
                  }
                  if (me = gi() | 0, l = e[ke + 48 >> 2], !l)
                    break e;
                  Tr(l);
                  break e;
                }
                if (me = gi() | 0, (Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24)) >>> 0 < 29)
                  break e;
                Tr(Je[l + 8 | 0] | Je[l + 9 | 0] << 8 | (Je[l + 10 | 0] << 16 | Je[l + 11 | 0] << 24)), Se[l + 8 | 0] = 0, Se[l + 9 | 0] = 0, Se[l + 10 | 0] = 0, Se[l + 11 | 0] = 0;
              }
              ss(me | 0), jn();
            }
            function Xh(l, y) {
              l = l | 0, y = y | 0;
              var I = 0, C = 0, Q = 0, S = 0, me = 0, ke = 0, Ar = 0, br = 0;
              I = bi - 496 | 0, bi = I;
              e: {
                t: {
                  r: {
                    i: {
                      n: {
                        o: {
                          a: {
                            s: {
                              A: {
                                u: {
                                  h: {
                                    c: {
                                      f: {
                                        p: {
                                          d: {
                                            g: {
                                              v: {
                                                _: {
                                                  R: {
                                                    k: {
                                                      S: {
                                                        E: {
                                                          w: {
                                                            I: {
                                                              l: {
                                                                T: {
                                                                  m: {
                                                                    C: {
                                                                      D: {
                                                                        b: {
                                                                          B: {
                                                                            y: {
                                                                              x: {
                                                                                P: {
                                                                                  M: {
                                                                                    N: {
                                                                                      O: {
                                                                                        U: {
                                                                                          F: {
                                                                                            Q: {
                                                                                              L: {
                                                                                                q: {
                                                                                                  H: {
                                                                                                    $: {
                                                                                                      K: {
                                                                                                        G: {
                                                                                                          Y: {
                                                                                                            j: {
                                                                                                              J: {
                                                                                                                W: {
                                                                                                                  V:
                                                                                                                    switch (Q = e[y >> 2], e[Q >> 2] - 1 | 0) {
                                                                                                                      case 23:
                                                                                                                        break T;
                                                                                                                      case 22:
                                                                                                                        break m;
                                                                                                                      case 21:
                                                                                                                        break C;
                                                                                                                      case 20:
                                                                                                                        break D;
                                                                                                                      case 19:
                                                                                                                        break b;
                                                                                                                      case 18:
                                                                                                                        break B;
                                                                                                                      case 17:
                                                                                                                        break y;
                                                                                                                      case 16:
                                                                                                                        break x;
                                                                                                                      case 14:
                                                                                                                        break P;
                                                                                                                      case 15:
                                                                                                                        break M;
                                                                                                                      case 13:
                                                                                                                        break N;
                                                                                                                      case 12:
                                                                                                                        break O;
                                                                                                                      case 11:
                                                                                                                        break U;
                                                                                                                      case 10:
                                                                                                                        break F;
                                                                                                                      case 9:
                                                                                                                        break Q;
                                                                                                                      case 0:
                                                                                                                        break L;
                                                                                                                      case 8:
                                                                                                                        break H;
                                                                                                                      case 6:
                                                                                                                        break $;
                                                                                                                      case 7:
                                                                                                                        break K;
                                                                                                                      case 5:
                                                                                                                        break G;
                                                                                                                      case 3:
                                                                                                                        break Y;
                                                                                                                      case 4:
                                                                                                                        break j;
                                                                                                                      case 24:
                                                                                                                        break J;
                                                                                                                      case 2:
                                                                                                                        break W;
                                                                                                                      case 1:
                                                                                                                        break V;
                                                                                                                      default:
                                                                                                                        break q;
                                                                                                                    }
                                                                                                                  Q = e[Q + 8 >> 2];
                                                                                                                  V: {
                                                                                                                    if (Se[Q + 11 | 0] >= 0) {
                                                                                                                      e[I + 456 >> 2] = e[Q + 8 >> 2], C = e[Q + 4 >> 2], e[I + 448 >> 2] = e[Q >> 2], e[I + 452 >> 2] = C;
                                                                                                                      break V;
                                                                                                                    }
                                                                                                                    Yl(I + 448 | 0, e[Q >> 2], e[Q + 4 >> 2]);
                                                                                                                  }
                                                                                                                  e[5996] = 0, Se[I + 460 | 0] = 1, Q = Ko(99, I + 448 | 0, 0, 5283) | 0, C = e[5996], e[5996] = 0;
                                                                                                                  V: {
                                                                                                                    z: {
                                                                                                                      X: {
                                                                                                                        Z: {
                                                                                                                          if ((C | 0) != 1) {
                                                                                                                            if (e[I + 472 >> 2] = e[Q + 8 >> 2], C = e[Q + 4 >> 2], e[I + 464 >> 2] = e[Q >> 2], e[I + 468 >> 2] = C, e[Q >> 2] = 0, e[Q + 4 >> 2] = 0, e[Q + 8 >> 2] = 0, e[5996] = 0, C = wn(97, I + 464 | 0, 5242) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                                                              break Z;
                                                                                                                            if (e[I + 488 >> 2] = e[C + 8 >> 2], S = e[C + 4 >> 2], e[I + 480 >> 2] = e[C >> 2], e[I + 484 >> 2] = S, e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[C + 8 >> 2] = 0, e[5996] = 0, Ms(161, l | 0, y | 0, I + 480 | 0), l = e[5996], e[5996] = 0, (l | 0) == 1)
                                                                                                                              break X;
                                                                                                                            if (Se[I + 491 | 0] < 0 && Tr(e[I + 480 >> 2]), Se[C + 11 | 0] < 0 && Tr(e[C >> 2]), !Je[I + 460 | 0] | Se[Q + 11 | 0] >= 0)
                                                                                                                              break l;
                                                                                                                            Tr(e[Q >> 2]);
                                                                                                                            break l;
                                                                                                                          }
                                                                                                                          y = gi() | 0;
                                                                                                                          break V;
                                                                                                                        }
                                                                                                                        y = gi() | 0;
                                                                                                                        break z;
                                                                                                                      }
                                                                                                                      if (y = gi() | 0, Se[I + 491 | 0] >= 0)
                                                                                                                        break z;
                                                                                                                      Tr(e[I + 480 >> 2]);
                                                                                                                    }
                                                                                                                    if (Se[I + 475 | 0] >= 0)
                                                                                                                      break V;
                                                                                                                    Tr(e[I + 464 >> 2]);
                                                                                                                  }
                                                                                                                  break r;
                                                                                                                }
                                                                                                                Q = e[Q + 8 >> 2];
                                                                                                                W: {
                                                                                                                  if (Se[Q + 11 | 0] >= 0) {
                                                                                                                    e[I + 456 >> 2] = e[Q + 8 >> 2], C = e[Q + 4 >> 2], e[I + 448 >> 2] = e[Q >> 2], e[I + 452 >> 2] = C;
                                                                                                                    break W;
                                                                                                                  }
                                                                                                                  Yl(I + 448 | 0, e[Q >> 2], e[Q + 4 >> 2]);
                                                                                                                }
                                                                                                                e[5996] = 0, Se[I + 460 | 0] = 1, Q = Ko(99, I + 448 | 0, 0, 5315) | 0, C = e[5996], e[5996] = 0;
                                                                                                                W: {
                                                                                                                  V: {
                                                                                                                    z: {
                                                                                                                      X: {
                                                                                                                        if ((C | 0) != 1) {
                                                                                                                          if (e[I + 472 >> 2] = e[Q + 8 >> 2], C = e[Q + 4 >> 2], e[I + 464 >> 2] = e[Q >> 2], e[I + 468 >> 2] = C, e[Q >> 2] = 0, e[Q + 4 >> 2] = 0, e[Q + 8 >> 2] = 0, e[5996] = 0, C = wn(97, I + 464 | 0, 5242) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                                                            break X;
                                                                                                                          if (e[I + 440 >> 2] = e[C + 8 >> 2], S = e[C + 4 >> 2], e[I + 432 >> 2] = e[C >> 2], e[I + 436 >> 2] = S, e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[C + 8 >> 2] = 0, e[5996] = 0, Ms(161, l | 0, y | 0, I + 432 | 0), l = e[5996], e[5996] = 0, (l | 0) == 1)
                                                                                                                            break z;
                                                                                                                          if (Se[I + 443 | 0] < 0 && Tr(e[I + 432 >> 2]), Se[C + 11 | 0] < 0 && Tr(e[C >> 2]), !Je[I + 460 | 0] | Se[Q + 11 | 0] >= 0)
                                                                                                                            break l;
                                                                                                                          Tr(e[Q >> 2]);
                                                                                                                          break l;
                                                                                                                        }
                                                                                                                        y = gi() | 0;
                                                                                                                        break W;
                                                                                                                      }
                                                                                                                      y = gi() | 0;
                                                                                                                      break V;
                                                                                                                    }
                                                                                                                    if (y = gi() | 0, Se[I + 443 | 0] >= 0)
                                                                                                                      break V;
                                                                                                                    Tr(e[I + 432 >> 2]);
                                                                                                                  }
                                                                                                                  if (Se[I + 475 | 0] >= 0)
                                                                                                                    break W;
                                                                                                                  Tr(e[I + 464 >> 2]);
                                                                                                                }
                                                                                                                break r;
                                                                                                              }
                                                                                                              C = I + 384 | 0, $f(C, e[Q + 4 >> 2]), e[5996] = 0, Q = Ko(99, C | 0, 0, 5289) | 0, C = e[5996], e[5996] = 0;
                                                                                                              J: {
                                                                                                                W: {
                                                                                                                  V: {
                                                                                                                    z: {
                                                                                                                      X: {
                                                                                                                        Z: {
                                                                                                                          ee: {
                                                                                                                            te: {
                                                                                                                              re: {
                                                                                                                                ie: {
                                                                                                                                  if ((C | 0) != 1) {
                                                                                                                                    if (e[I + 408 >> 2] = e[Q + 8 >> 2], C = e[Q + 4 >> 2], e[I + 400 >> 2] = e[Q >> 2], e[I + 404 >> 2] = C, e[Q >> 2] = 0, e[Q + 4 >> 2] = 0, e[Q + 8 >> 2] = 0, e[5996] = 0, C = wn(97, I + 400 | 0, 5417) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                                                                      break ie;
                                                                                                                                    if (e[I + 472 >> 2] = e[C + 8 >> 2], S = e[C + 4 >> 2], e[I + 464 >> 2] = e[C >> 2], e[I + 468 >> 2] = S, e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[C + 8 >> 2] = 0, S = e[y >> 2], me = e[S + 12 >> 2], S = e[S + 8 >> 2], e[5996] = 0, ke = I + 368 | 0, Co(115, ke | 0, (me - S | 0) / 12 | 0), S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                                                                      break re;
                                                                                                                                    if (e[5996] = 0, S = Je[I + 379 | 0], me = S << 24 >> 24 < 0, S = Ko(100, I + 464 | 0, (me ? e[I + 368 >> 2] : ke) | 0, (me ? e[I + 372 >> 2] : S) | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                                                                                                      break te;
                                                                                                                                    if (e[I + 456 >> 2] = e[S + 8 >> 2], me = e[S + 4 >> 2], e[I + 448 >> 2] = e[S >> 2], e[I + 452 >> 2] = me, e[S >> 2] = 0, e[S + 4 >> 2] = 0, e[S + 8 >> 2] = 0, e[5996] = 0, me = wn(97, I + 448 | 0, 5242) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                                                                                                                                      break ee;
                                                                                                                                    if (e[I + 424 >> 2] = e[me + 8 >> 2], ke = e[me + 4 >> 2], e[I + 416 >> 2] = e[me >> 2], e[I + 420 >> 2] = ke, e[me >> 2] = 0, e[me + 4 >> 2] = 0, e[me + 8 >> 2] = 0, e[5996] = 0, Ms(161, l | 0, y | 0, I + 416 | 0), l = e[5996], e[5996] = 0, (l | 0) == 1)
                                                                                                                                      break Z;
                                                                                                                                    if (Se[I + 427 | 0] < 0 && Tr(e[I + 416 >> 2]), Se[me + 11 | 0] < 0 && Tr(e[me >> 2]), Se[I + 379 | 0] < 0 && Tr(e[I + 368 >> 2]), Se[S + 11 | 0] < 0 && Tr(e[S >> 2]), Se[C + 11 | 0] < 0 && Tr(e[C >> 2]), Se[Q + 11 | 0] >= 0)
                                                                                                                                      break l;
                                                                                                                                    Tr(e[Q >> 2]);
                                                                                                                                    break l;
                                                                                                                                  }
                                                                                                                                  y = gi() | 0;
                                                                                                                                  break J;
                                                                                                                                }
                                                                                                                                y = gi() | 0;
                                                                                                                                break W;
                                                                                                                              }
                                                                                                                              y = gi() | 0;
                                                                                                                              break V;
                                                                                                                            }
                                                                                                                            y = gi() | 0;
                                                                                                                            break z;
                                                                                                                          }
                                                                                                                          y = gi() | 0;
                                                                                                                          break X;
                                                                                                                        }
                                                                                                                        if (y = gi() | 0, Se[I + 427 | 0] >= 0)
                                                                                                                          break X;
                                                                                                                        Tr(e[I + 416 >> 2]);
                                                                                                                      }
                                                                                                                      if (Se[I + 459 | 0] >= 0)
                                                                                                                        break z;
                                                                                                                      Tr(e[I + 448 >> 2]);
                                                                                                                    }
                                                                                                                    if (Se[I + 379 | 0] >= 0)
                                                                                                                      break V;
                                                                                                                    Tr(e[I + 368 >> 2]);
                                                                                                                  }
                                                                                                                  if (Se[I + 475 | 0] >= 0)
                                                                                                                    break W;
                                                                                                                  Tr(e[I + 464 >> 2]);
                                                                                                                }
                                                                                                                if (Se[I + 411 | 0] >= 0)
                                                                                                                  break J;
                                                                                                                Tr(e[I + 400 >> 2]);
                                                                                                              }
                                                                                                              if (Se[I + 395 | 0] >= 0)
                                                                                                                break e;
                                                                                                              Tr(e[I + 384 >> 2]);
                                                                                                              break e;
                                                                                                            }
                                                                                                            C = I + 464 | 0, $f(C, e[Q + 4 >> 2]), e[5996] = 0, Q = Ko(99, C | 0, 0, 5258) | 0, C = e[5996], e[5996] = 0;
                                                                                                            j: {
                                                                                                              J: {
                                                                                                                W: {
                                                                                                                  V: {
                                                                                                                    if ((C | 0) != 1) {
                                                                                                                      if (e[I + 456 >> 2] = e[Q + 8 >> 2], C = e[Q + 4 >> 2], e[I + 448 >> 2] = e[Q >> 2], e[I + 452 >> 2] = C, e[Q >> 2] = 0, e[Q + 4 >> 2] = 0, e[Q + 8 >> 2] = 0, e[5996] = 0, C = wn(97, I + 448 | 0, 5242) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                                                        break V;
                                                                                                                      if (e[I + 360 >> 2] = e[C + 8 >> 2], S = e[C + 4 >> 2], e[I + 352 >> 2] = e[C >> 2], e[I + 356 >> 2] = S, e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[C + 8 >> 2] = 0, e[5996] = 0, Ms(161, l | 0, y | 0, I + 352 | 0), l = e[5996], e[5996] = 0, (l | 0) == 1)
                                                                                                                        break W;
                                                                                                                      if (Se[I + 363 | 0] < 0 && Tr(e[I + 352 >> 2]), Se[C + 11 | 0] < 0 && Tr(e[C >> 2]), Se[Q + 11 | 0] >= 0)
                                                                                                                        break l;
                                                                                                                      Tr(e[Q >> 2]);
                                                                                                                      break l;
                                                                                                                    }
                                                                                                                    y = gi() | 0;
                                                                                                                    break j;
                                                                                                                  }
                                                                                                                  y = gi() | 0;
                                                                                                                  break J;
                                                                                                                }
                                                                                                                if (y = gi() | 0, Se[I + 363 | 0] >= 0)
                                                                                                                  break J;
                                                                                                                Tr(e[I + 352 >> 2]);
                                                                                                              }
                                                                                                              if (Se[I + 459 | 0] >= 0)
                                                                                                                break j;
                                                                                                              Tr(e[I + 448 >> 2]);
                                                                                                            }
                                                                                                            break t;
                                                                                                          }
                                                                                                          C = I + 464 | 0, $f(C, e[Q + 4 >> 2]), e[5996] = 0, Q = Ko(99, C | 0, 0, 5265) | 0, C = e[5996], e[5996] = 0;
                                                                                                          Y: {
                                                                                                            j: {
                                                                                                              J: {
                                                                                                                W: {
                                                                                                                  if ((C | 0) != 1) {
                                                                                                                    if (e[I + 456 >> 2] = e[Q + 8 >> 2], C = e[Q + 4 >> 2], e[I + 448 >> 2] = e[Q >> 2], e[I + 452 >> 2] = C, e[Q >> 2] = 0, e[Q + 4 >> 2] = 0, e[Q + 8 >> 2] = 0, e[5996] = 0, C = wn(97, I + 448 | 0, 5242) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                                                      break W;
                                                                                                                    if (e[I + 344 >> 2] = e[C + 8 >> 2], S = e[C + 4 >> 2], e[I + 336 >> 2] = e[C >> 2], e[I + 340 >> 2] = S, e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[C + 8 >> 2] = 0, e[5996] = 0, Ms(161, l | 0, y | 0, I + 336 | 0), l = e[5996], e[5996] = 0, (l | 0) == 1)
                                                                                                                      break J;
                                                                                                                    if (Se[I + 347 | 0] < 0 && Tr(e[I + 336 >> 2]), Se[C + 11 | 0] < 0 && Tr(e[C >> 2]), Se[Q + 11 | 0] >= 0)
                                                                                                                      break l;
                                                                                                                    Tr(e[Q >> 2]);
                                                                                                                    break l;
                                                                                                                  }
                                                                                                                  y = gi() | 0;
                                                                                                                  break Y;
                                                                                                                }
                                                                                                                y = gi() | 0;
                                                                                                                break j;
                                                                                                              }
                                                                                                              if (y = gi() | 0, Se[I + 347 | 0] >= 0)
                                                                                                                break j;
                                                                                                              Tr(e[I + 336 >> 2]);
                                                                                                            }
                                                                                                            if (Se[I + 459 | 0] >= 0)
                                                                                                              break Y;
                                                                                                            Tr(e[I + 448 >> 2]);
                                                                                                          }
                                                                                                          break t;
                                                                                                        }
                                                                                                        if (Se[I + 328 | 0] = 0, e[I + 320 >> 2] = 845244531, e[I + 324 >> 2] = 690501173, Se[I + 331 | 0] = 8, e[5996] = 0, Ms(161, l | 0, y | 0, I + 320 | 0), l = e[5996], e[5996] = 0, (l | 0) != 1) {
                                                                                                          if (Se[I + 331 | 0] >= 0)
                                                                                                            break l;
                                                                                                          Tr(e[I + 320 >> 2]);
                                                                                                          break l;
                                                                                                        }
                                                                                                        if (y = gi() | 0, Se[I + 331 | 0] >= 0)
                                                                                                          break e;
                                                                                                        Tr(e[I + 320 >> 2]);
                                                                                                        break e;
                                                                                                      }
                                                                                                      if (Q = ga(16), e[I + 308 >> 2] = Q, e[I + 312 >> 2] = 11, e[I + 316 >> 2] = -2147483632, C = Je[5239] | Je[5240] << 8 | (Je[5241] << 16 | Je[5242] << 24), Se[Q + 7 | 0] = C, Se[Q + 8 | 0] = C >>> 8, Se[Q + 9 | 0] = C >>> 16, Se[Q + 10 | 0] = C >>> 24, C = Je[5236] | Je[5237] << 8 | (Je[5238] << 16 | Je[5239] << 24), S = Je[5232] | Je[5233] << 8 | (Je[5234] << 16 | Je[5235] << 24), Se[Q | 0] = S, Se[Q + 1 | 0] = S >>> 8, Se[Q + 2 | 0] = S >>> 16, Se[Q + 3 | 0] = S >>> 24, Se[Q + 4 | 0] = C, Se[Q + 5 | 0] = C >>> 8, Se[Q + 6 | 0] = C >>> 16, Se[Q + 7 | 0] = C >>> 24, Se[Q + 11 | 0] = 0, e[5996] = 0, Ms(161, l | 0, y | 0, I + 308 | 0), l = e[5996], e[5996] = 0, (l | 0) != 1) {
                                                                                                        if (Se[I + 319 | 0] >= 0)
                                                                                                          break l;
                                                                                                        Tr(e[I + 308 >> 2]);
                                                                                                        break l;
                                                                                                      }
                                                                                                      if (y = gi() | 0, Se[I + 319 | 0] >= 0)
                                                                                                        break e;
                                                                                                      Tr(e[I + 308 >> 2]);
                                                                                                      break e;
                                                                                                    }
                                                                                                    if (Se[I + 304 | 0] = Je[5220], Se[I + 307 | 0] = 9, Se[I + 305 | 0] = 0, e[5996] = 0, Q = Je[5216] | Je[5217] << 8 | (Je[5218] << 16 | Je[5219] << 24), e[I + 296 >> 2] = Je[5212] | Je[5213] << 8 | (Je[5214] << 16 | Je[5215] << 24), e[I + 300 >> 2] = Q, Ms(161, l | 0, y | 0, I + 296 | 0), l = e[5996], e[5996] = 0, (l | 0) != 1) {
                                                                                                      if (Se[I + 307 | 0] >= 0)
                                                                                                        break l;
                                                                                                      Tr(e[I + 296 >> 2]);
                                                                                                      break l;
                                                                                                    }
                                                                                                    if (y = gi() | 0, Se[I + 307 | 0] >= 0)
                                                                                                      break e;
                                                                                                    Tr(e[I + 296 >> 2]);
                                                                                                    break e;
                                                                                                  }
                                                                                                  if (Se[I + 288 | 0] = Je[5230], Se[I + 291 | 0] = 9, Se[I + 289 | 0] = 0, e[5996] = 0, Q = Je[5226] | Je[5227] << 8 | (Je[5228] << 16 | Je[5229] << 24), e[I + 280 >> 2] = Je[5222] | Je[5223] << 8 | (Je[5224] << 16 | Je[5225] << 24), e[I + 284 >> 2] = Q, Ms(161, l | 0, y | 0, I + 280 | 0), l = e[5996], e[5996] = 0, (l | 0) != 1) {
                                                                                                    if (Se[I + 291 | 0] >= 0)
                                                                                                      break l;
                                                                                                    Tr(e[I + 280 >> 2]);
                                                                                                    break l;
                                                                                                  }
                                                                                                  if (y = gi() | 0, Se[I + 291 | 0] >= 0)
                                                                                                    break e;
                                                                                                  Tr(e[I + 280 >> 2]);
                                                                                                  break e;
                                                                                                }
                                                                                                if (Se[I + 272 | 0] = Je[2354], Se[I + 279 | 0] = 5, Se[I + 273 | 0] = 0, e[5996] = 0, e[I + 268 >> 2] = Je[2350] | Je[2351] << 8 | (Je[2352] << 16 | Je[2353] << 24), Ms(161, l | 0, y | 0, I + 268 | 0), l = e[5996], e[5996] = 0, (l | 0) != 1) {
                                                                                                  if (Se[I + 279 | 0] >= 0)
                                                                                                    break l;
                                                                                                  Tr(e[I + 268 >> 2]);
                                                                                                  break l;
                                                                                                }
                                                                                                if (y = gi() | 0, Se[I + 279 | 0] >= 0)
                                                                                                  break e;
                                                                                                Tr(e[I + 268 >> 2]);
                                                                                                break e;
                                                                                              }
                                                                                              if (Se[I + 260 | 0] = 0, e[I + 256 >> 2] = 1702195828, Se[I + 267 | 0] = 4, e[5996] = 0, Ms(161, l | 0, y | 0, I + 256 | 0), l = e[5996], e[5996] = 0, (l | 0) != 1) {
                                                                                                if (Se[I + 267 | 0] >= 0)
                                                                                                  break l;
                                                                                                Tr(e[I + 256 >> 2]);
                                                                                                break l;
                                                                                              }
                                                                                              if (y = gi() | 0, Se[I + 267 | 0] >= 0)
                                                                                                break e;
                                                                                              Tr(e[I + 256 >> 2]);
                                                                                              break e;
                                                                                            }
                                                                                            Se[I + 255 | 0] = 2, Se[I + 246 | 0] = 0, ea[I + 244 >> 1] = 14945, e[5996] = 0, Q = I + 464 | 0, Ms(161, Q | 0, y | 0, I + 244 | 0), C = e[5996], e[5996] = 0;
                                                                                            Q: {
                                                                                              L: {
                                                                                                q: {
                                                                                                  H: {
                                                                                                    $: {
                                                                                                      K: {
                                                                                                        if ((C | 0) != 1) {
                                                                                                          if (e[5996] = 0, Q = wn(97, Q | 0, 5574) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                                                            break K;
                                                                                                          if (e[I + 456 >> 2] = e[Q + 8 >> 2], C = e[Q + 4 >> 2], e[I + 448 >> 2] = e[Q >> 2], e[I + 452 >> 2] = C, e[Q >> 2] = 0, e[Q + 4 >> 2] = 0, e[Q + 8 >> 2] = 0, y = e[e[y >> 2] + 32 >> 2], e[5996] = 0, C = I + 400 | 0, Co(141, C | 0, y | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                                            break $;
                                                                                                          if (e[5996] = 0, S = C, y = Je[I + 411 | 0], C = y << 24 >> 24 < 0, y = Ko(100, I + 448 | 0, (C ? e[I + 400 >> 2] : S) | 0, (C ? e[I + 404 >> 2] : y) | 0) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                                                            break H;
                                                                                                          C = e[y + 4 >> 2], e[l >> 2] = e[y >> 2], e[l + 4 >> 2] = C, e[l + 8 >> 2] = e[y + 8 >> 2], e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0;
                                                                                                          G: {
                                                                                                            if (Se[I + 411 | 0] >= 0 || (Tr(e[I + 400 >> 2]), Se[y + 11 | 0] >= 0))
                                                                                                              break G;
                                                                                                            Tr(e[y >> 2]);
                                                                                                          }
                                                                                                          if (Se[Q + 11 | 0] < 0 && Tr(e[Q >> 2]), Se[I + 255 | 0] >= 0)
                                                                                                            break l;
                                                                                                          Tr(e[I + 244 >> 2]);
                                                                                                          break l;
                                                                                                        }
                                                                                                        y = gi() | 0;
                                                                                                        break Q;
                                                                                                      }
                                                                                                      y = gi() | 0;
                                                                                                      break L;
                                                                                                    }
                                                                                                    y = gi() | 0;
                                                                                                    break q;
                                                                                                  }
                                                                                                  if (y = gi() | 0, Se[I + 411 | 0] >= 0)
                                                                                                    break q;
                                                                                                  Tr(e[I + 400 >> 2]);
                                                                                                }
                                                                                                if (Se[I + 459 | 0] >= 0)
                                                                                                  break L;
                                                                                                Tr(e[I + 448 >> 2]);
                                                                                              }
                                                                                              if (Se[I + 475 | 0] >= 0)
                                                                                                break Q;
                                                                                              Tr(e[I + 464 >> 2]);
                                                                                            }
                                                                                            if (Se[I + 255 | 0] >= 0)
                                                                                              break e;
                                                                                            Tr(e[I + 244 >> 2]);
                                                                                            break e;
                                                                                          }
                                                                                          Se[I + 243 | 0] = 2, Se[I + 234 | 0] = 0, ea[I + 232 >> 1] = 14963, e[5996] = 0, Q = I + 464 | 0, Ms(161, Q | 0, y | 0, I + 232 | 0), C = e[5996], e[5996] = 0;
                                                                                          F: {
                                                                                            Q: {
                                                                                              L: {
                                                                                                q: {
                                                                                                  H: {
                                                                                                    $: {
                                                                                                      if ((C | 0) != 1) {
                                                                                                        if (e[5996] = 0, Q = wn(97, Q | 0, 5574) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                                                          break $;
                                                                                                        if (e[I + 456 >> 2] = e[Q + 8 >> 2], C = e[Q + 4 >> 2], e[I + 448 >> 2] = e[Q >> 2], e[I + 452 >> 2] = C, e[Q >> 2] = 0, e[Q + 4 >> 2] = 0, e[Q + 8 >> 2] = 0, y = e[e[y >> 2] + 32 >> 2], e[5996] = 0, C = I + 400 | 0, Co(141, C | 0, y | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                                          break H;
                                                                                                        if (e[5996] = 0, S = C, y = Je[I + 411 | 0], C = y << 24 >> 24 < 0, y = Ko(100, I + 448 | 0, (C ? e[I + 400 >> 2] : S) | 0, (C ? e[I + 404 >> 2] : y) | 0) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                                                          break q;
                                                                                                        C = e[y + 4 >> 2], e[l >> 2] = e[y >> 2], e[l + 4 >> 2] = C, e[l + 8 >> 2] = e[y + 8 >> 2], e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0;
                                                                                                        K: {
                                                                                                          if (Se[I + 411 | 0] >= 0 || (Tr(e[I + 400 >> 2]), Se[y + 11 | 0] >= 0))
                                                                                                            break K;
                                                                                                          Tr(e[y >> 2]);
                                                                                                        }
                                                                                                        if (Se[Q + 11 | 0] < 0 && Tr(e[Q >> 2]), Se[I + 243 | 0] >= 0)
                                                                                                          break l;
                                                                                                        Tr(e[I + 232 >> 2]);
                                                                                                        break l;
                                                                                                      }
                                                                                                      y = gi() | 0;
                                                                                                      break F;
                                                                                                    }
                                                                                                    y = gi() | 0;
                                                                                                    break Q;
                                                                                                  }
                                                                                                  y = gi() | 0;
                                                                                                  break L;
                                                                                                }
                                                                                                if (y = gi() | 0, Se[I + 411 | 0] >= 0)
                                                                                                  break L;
                                                                                                Tr(e[I + 400 >> 2]);
                                                                                              }
                                                                                              if (Se[I + 459 | 0] >= 0)
                                                                                                break Q;
                                                                                              Tr(e[I + 448 >> 2]);
                                                                                            }
                                                                                            if (Se[I + 475 | 0] >= 0)
                                                                                              break F;
                                                                                            Tr(e[I + 464 >> 2]);
                                                                                          }
                                                                                          if (Se[I + 243 | 0] >= 0)
                                                                                            break e;
                                                                                          Tr(e[I + 232 >> 2]);
                                                                                          break e;
                                                                                        }
                                                                                        Se[I + 231 | 0] = 2, Se[I + 222 | 0] = 0, ea[I + 220 >> 1] = 14947, e[5996] = 0, Q = I + 464 | 0, Ms(161, Q | 0, y | 0, I + 220 | 0), C = e[5996], e[5996] = 0;
                                                                                        U: {
                                                                                          F: {
                                                                                            Q: {
                                                                                              L: {
                                                                                                q: {
                                                                                                  H: {
                                                                                                    if ((C | 0) != 1) {
                                                                                                      if (e[5996] = 0, Q = wn(97, Q | 0, 5574) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                                                        break H;
                                                                                                      if (e[I + 456 >> 2] = e[Q + 8 >> 2], C = e[Q + 4 >> 2], e[I + 448 >> 2] = e[Q >> 2], e[I + 452 >> 2] = C, e[Q >> 2] = 0, e[Q + 4 >> 2] = 0, e[Q + 8 >> 2] = 0, y = e[e[y >> 2] + 32 >> 2], e[5996] = 0, C = I + 400 | 0, Co(141, C | 0, y | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                                        break q;
                                                                                                      if (e[5996] = 0, S = C, y = Je[I + 411 | 0], C = y << 24 >> 24 < 0, y = Ko(100, I + 448 | 0, (C ? e[I + 400 >> 2] : S) | 0, (C ? e[I + 404 >> 2] : y) | 0) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                                                        break L;
                                                                                                      C = e[y + 4 >> 2], e[l >> 2] = e[y >> 2], e[l + 4 >> 2] = C, e[l + 8 >> 2] = e[y + 8 >> 2], e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0;
                                                                                                      $: {
                                                                                                        if (Se[I + 411 | 0] >= 0 || (Tr(e[I + 400 >> 2]), Se[y + 11 | 0] >= 0))
                                                                                                          break $;
                                                                                                        Tr(e[y >> 2]);
                                                                                                      }
                                                                                                      if (Se[Q + 11 | 0] < 0 && Tr(e[Q >> 2]), Se[I + 231 | 0] >= 0)
                                                                                                        break l;
                                                                                                      Tr(e[I + 220 >> 2]);
                                                                                                      break l;
                                                                                                    }
                                                                                                    y = gi() | 0;
                                                                                                    break U;
                                                                                                  }
                                                                                                  y = gi() | 0;
                                                                                                  break F;
                                                                                                }
                                                                                                y = gi() | 0;
                                                                                                break Q;
                                                                                              }
                                                                                              if (y = gi() | 0, Se[I + 411 | 0] >= 0)
                                                                                                break Q;
                                                                                              Tr(e[I + 400 >> 2]);
                                                                                            }
                                                                                            if (Se[I + 459 | 0] >= 0)
                                                                                              break F;
                                                                                            Tr(e[I + 448 >> 2]);
                                                                                          }
                                                                                          if (Se[I + 475 | 0] >= 0)
                                                                                            break U;
                                                                                          Tr(e[I + 464 >> 2]);
                                                                                        }
                                                                                        if (Se[I + 231 | 0] >= 0)
                                                                                          break e;
                                                                                        Tr(e[I + 220 >> 2]);
                                                                                        break e;
                                                                                      }
                                                                                      Se[I + 219 | 0] = 2, Se[I + 210 | 0] = 0, ea[I + 208 >> 1] = 14948, e[5996] = 0, Q = I + 464 | 0, Ms(161, Q | 0, y | 0, I + 208 | 0), C = e[5996], e[5996] = 0;
                                                                                      O: {
                                                                                        U: {
                                                                                          F: {
                                                                                            Q: {
                                                                                              L: {
                                                                                                q: {
                                                                                                  if ((C | 0) != 1) {
                                                                                                    if (e[5996] = 0, Q = wn(97, Q | 0, 5574) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                                                      break q;
                                                                                                    if (e[I + 456 >> 2] = e[Q + 8 >> 2], C = e[Q + 4 >> 2], e[I + 448 >> 2] = e[Q >> 2], e[I + 452 >> 2] = C, e[Q >> 2] = 0, e[Q + 4 >> 2] = 0, e[Q + 8 >> 2] = 0, y = e[e[y >> 2] + 32 >> 2], e[5996] = 0, C = I + 400 | 0, Co(141, C | 0, y | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                                      break L;
                                                                                                    if (e[5996] = 0, S = C, y = Je[I + 411 | 0], C = y << 24 >> 24 < 0, y = Ko(100, I + 448 | 0, (C ? e[I + 400 >> 2] : S) | 0, (C ? e[I + 404 >> 2] : y) | 0) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                                                      break Q;
                                                                                                    C = e[y + 4 >> 2], e[l >> 2] = e[y >> 2], e[l + 4 >> 2] = C, e[l + 8 >> 2] = e[y + 8 >> 2], e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0;
                                                                                                    H: {
                                                                                                      if (Se[I + 411 | 0] >= 0 || (Tr(e[I + 400 >> 2]), Se[y + 11 | 0] >= 0))
                                                                                                        break H;
                                                                                                      Tr(e[y >> 2]);
                                                                                                    }
                                                                                                    if (Se[Q + 11 | 0] < 0 && Tr(e[Q >> 2]), Se[I + 219 | 0] >= 0)
                                                                                                      break l;
                                                                                                    Tr(e[I + 208 >> 2]);
                                                                                                    break l;
                                                                                                  }
                                                                                                  y = gi() | 0;
                                                                                                  break O;
                                                                                                }
                                                                                                y = gi() | 0;
                                                                                                break U;
                                                                                              }
                                                                                              y = gi() | 0;
                                                                                              break F;
                                                                                            }
                                                                                            if (y = gi() | 0, Se[I + 411 | 0] >= 0)
                                                                                              break F;
                                                                                            Tr(e[I + 400 >> 2]);
                                                                                          }
                                                                                          if (Se[I + 459 | 0] >= 0)
                                                                                            break U;
                                                                                          Tr(e[I + 448 >> 2]);
                                                                                        }
                                                                                        if (Se[I + 475 | 0] >= 0)
                                                                                          break O;
                                                                                        Tr(e[I + 464 >> 2]);
                                                                                      }
                                                                                      if (Se[I + 219 | 0] >= 0)
                                                                                        break e;
                                                                                      Tr(e[I + 208 >> 2]);
                                                                                      break e;
                                                                                    }
                                                                                    Se[I + 207 | 0] = 2, Se[I + 198 | 0] = 0, ea[I + 196 >> 1] = 14966, e[5996] = 0, Q = I + 464 | 0, Ms(161, Q | 0, y | 0, I + 196 | 0), C = e[5996], e[5996] = 0;
                                                                                    N: {
                                                                                      O: {
                                                                                        U: {
                                                                                          F: {
                                                                                            Q: {
                                                                                              L: {
                                                                                                if ((C | 0) != 1) {
                                                                                                  if (e[5996] = 0, Q = wn(97, Q | 0, 5574) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                                                    break L;
                                                                                                  if (e[I + 456 >> 2] = e[Q + 8 >> 2], C = e[Q + 4 >> 2], e[I + 448 >> 2] = e[Q >> 2], e[I + 452 >> 2] = C, e[Q >> 2] = 0, e[Q + 4 >> 2] = 0, e[Q + 8 >> 2] = 0, y = e[e[y >> 2] + 32 >> 2], e[5996] = 0, C = I + 400 | 0, Co(141, C | 0, y | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                                    break Q;
                                                                                                  if (e[5996] = 0, S = C, y = Je[I + 411 | 0], C = y << 24 >> 24 < 0, y = Ko(100, I + 448 | 0, (C ? e[I + 400 >> 2] : S) | 0, (C ? e[I + 404 >> 2] : y) | 0) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                                                    break F;
                                                                                                  C = e[y + 4 >> 2], e[l >> 2] = e[y >> 2], e[l + 4 >> 2] = C, e[l + 8 >> 2] = e[y + 8 >> 2], e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0;
                                                                                                  q: {
                                                                                                    if (Se[I + 411 | 0] >= 0 || (Tr(e[I + 400 >> 2]), Se[y + 11 | 0] >= 0))
                                                                                                      break q;
                                                                                                    Tr(e[y >> 2]);
                                                                                                  }
                                                                                                  if (Se[Q + 11 | 0] < 0 && Tr(e[Q >> 2]), Se[I + 207 | 0] >= 0)
                                                                                                    break l;
                                                                                                  Tr(e[I + 196 >> 2]);
                                                                                                  break l;
                                                                                                }
                                                                                                y = gi() | 0;
                                                                                                break N;
                                                                                              }
                                                                                              y = gi() | 0;
                                                                                              break O;
                                                                                            }
                                                                                            y = gi() | 0;
                                                                                            break U;
                                                                                          }
                                                                                          if (y = gi() | 0, Se[I + 411 | 0] >= 0)
                                                                                            break U;
                                                                                          Tr(e[I + 400 >> 2]);
                                                                                        }
                                                                                        if (Se[I + 459 | 0] >= 0)
                                                                                          break O;
                                                                                        Tr(e[I + 448 >> 2]);
                                                                                      }
                                                                                      if (Se[I + 475 | 0] >= 0)
                                                                                        break N;
                                                                                      Tr(e[I + 464 >> 2]);
                                                                                    }
                                                                                    if (Se[I + 207 | 0] >= 0)
                                                                                      break e;
                                                                                    Tr(e[I + 196 >> 2]);
                                                                                    break e;
                                                                                  }
                                                                                  Se[I + 195 | 0] = 2, Se[I + 186 | 0] = 0, ea[I + 184 >> 1] = 14958, e[5996] = 0, Q = I + 464 | 0, Ms(161, Q | 0, y | 0, I + 184 | 0), C = e[5996], e[5996] = 0;
                                                                                  M: {
                                                                                    N: {
                                                                                      O: {
                                                                                        U: {
                                                                                          F: {
                                                                                            Q: {
                                                                                              if ((C | 0) != 1) {
                                                                                                if (e[5996] = 0, Q = wn(97, Q | 0, 5574) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                                                  break Q;
                                                                                                if (e[I + 456 >> 2] = e[Q + 8 >> 2], C = e[Q + 4 >> 2], e[I + 448 >> 2] = e[Q >> 2], e[I + 452 >> 2] = C, e[Q >> 2] = 0, e[Q + 4 >> 2] = 0, e[Q + 8 >> 2] = 0, y = e[e[y >> 2] + 32 >> 2], e[5996] = 0, C = I + 400 | 0, Co(141, C | 0, y | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                                  break F;
                                                                                                if (e[5996] = 0, S = C, y = Je[I + 411 | 0], C = y << 24 >> 24 < 0, y = Ko(100, I + 448 | 0, (C ? e[I + 400 >> 2] : S) | 0, (C ? e[I + 404 >> 2] : y) | 0) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                                                  break U;
                                                                                                C = e[y + 4 >> 2], e[l >> 2] = e[y >> 2], e[l + 4 >> 2] = C, e[l + 8 >> 2] = e[y + 8 >> 2], e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0;
                                                                                                L: {
                                                                                                  if (Se[I + 411 | 0] >= 0 || (Tr(e[I + 400 >> 2]), Se[y + 11 | 0] >= 0))
                                                                                                    break L;
                                                                                                  Tr(e[y >> 2]);
                                                                                                }
                                                                                                if (Se[Q + 11 | 0] < 0 && Tr(e[Q >> 2]), Se[I + 195 | 0] >= 0)
                                                                                                  break l;
                                                                                                Tr(e[I + 184 >> 2]);
                                                                                                break l;
                                                                                              }
                                                                                              y = gi() | 0;
                                                                                              break M;
                                                                                            }
                                                                                            y = gi() | 0;
                                                                                            break N;
                                                                                          }
                                                                                          y = gi() | 0;
                                                                                          break O;
                                                                                        }
                                                                                        if (y = gi() | 0, Se[I + 411 | 0] >= 0)
                                                                                          break O;
                                                                                        Tr(e[I + 400 >> 2]);
                                                                                      }
                                                                                      if (Se[I + 459 | 0] >= 0)
                                                                                        break N;
                                                                                      Tr(e[I + 448 >> 2]);
                                                                                    }
                                                                                    if (Se[I + 475 | 0] >= 0)
                                                                                      break M;
                                                                                    Tr(e[I + 464 >> 2]);
                                                                                  }
                                                                                  if (Se[I + 195 | 0] >= 0)
                                                                                    break e;
                                                                                  Tr(e[I + 184 >> 2]);
                                                                                  break e;
                                                                                }
                                                                                Se[I + 183 | 0] = 2, Se[I + 174 | 0] = 0, ea[I + 172 >> 1] = 14954, e[5996] = 0, Q = I + 464 | 0, Ms(161, Q | 0, y | 0, I + 172 | 0), C = e[5996], e[5996] = 0;
                                                                                P: {
                                                                                  M: {
                                                                                    N: {
                                                                                      O: {
                                                                                        U: {
                                                                                          F: {
                                                                                            if ((C | 0) != 1) {
                                                                                              if (e[5996] = 0, Q = wn(97, Q | 0, 5574) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                                                break F;
                                                                                              if (e[I + 456 >> 2] = e[Q + 8 >> 2], C = e[Q + 4 >> 2], e[I + 448 >> 2] = e[Q >> 2], e[I + 452 >> 2] = C, e[Q >> 2] = 0, e[Q + 4 >> 2] = 0, e[Q + 8 >> 2] = 0, y = e[e[y >> 2] + 32 >> 2], e[5996] = 0, C = I + 400 | 0, Co(141, C | 0, y | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                                break U;
                                                                                              if (e[5996] = 0, S = C, y = Je[I + 411 | 0], C = y << 24 >> 24 < 0, y = Ko(100, I + 448 | 0, (C ? e[I + 400 >> 2] : S) | 0, (C ? e[I + 404 >> 2] : y) | 0) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                                                break O;
                                                                                              C = e[y + 4 >> 2], e[l >> 2] = e[y >> 2], e[l + 4 >> 2] = C, e[l + 8 >> 2] = e[y + 8 >> 2], e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0;
                                                                                              Q: {
                                                                                                if (Se[I + 411 | 0] >= 0 || (Tr(e[I + 400 >> 2]), Se[y + 11 | 0] >= 0))
                                                                                                  break Q;
                                                                                                Tr(e[y >> 2]);
                                                                                              }
                                                                                              if (Se[Q + 11 | 0] < 0 && Tr(e[Q >> 2]), Se[I + 183 | 0] >= 0)
                                                                                                break l;
                                                                                              Tr(e[I + 172 >> 2]);
                                                                                              break l;
                                                                                            }
                                                                                            y = gi() | 0;
                                                                                            break P;
                                                                                          }
                                                                                          y = gi() | 0;
                                                                                          break M;
                                                                                        }
                                                                                        y = gi() | 0;
                                                                                        break N;
                                                                                      }
                                                                                      if (y = gi() | 0, Se[I + 411 | 0] >= 0)
                                                                                        break N;
                                                                                      Tr(e[I + 400 >> 2]);
                                                                                    }
                                                                                    if (Se[I + 459 | 0] >= 0)
                                                                                      break M;
                                                                                    Tr(e[I + 448 >> 2]);
                                                                                  }
                                                                                  if (Se[I + 475 | 0] >= 0)
                                                                                    break P;
                                                                                  Tr(e[I + 464 >> 2]);
                                                                                }
                                                                                if (Se[I + 183 | 0] >= 0)
                                                                                  break e;
                                                                                Tr(e[I + 172 >> 2]);
                                                                                break e;
                                                                              }
                                                                              Se[I + 164 | 0] = Je[1271], Se[I + 171 | 0] = 5, Se[I + 165 | 0] = 0, e[5996] = 0, e[I + 160 >> 2] = Je[1267] | Je[1268] << 8 | (Je[1269] << 16 | Je[1270] << 24), Q = I + 368 | 0, Ms(161, Q | 0, y | 0, I + 160 | 0), C = e[5996], e[5996] = 0;
                                                                              x: {
                                                                                P: {
                                                                                  M: {
                                                                                    N: {
                                                                                      O: {
                                                                                        U: {
                                                                                          F: {
                                                                                            Q: {
                                                                                              L: {
                                                                                                q: {
                                                                                                  H: {
                                                                                                    $: {
                                                                                                      K: {
                                                                                                        G: {
                                                                                                          if ((C | 0) != 1) {
                                                                                                            if (e[5996] = 0, Q = wn(97, Q | 0, 3673) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                                                              break G;
                                                                                                            if (e[I + 392 >> 2] = e[Q + 8 >> 2], C = e[Q + 4 >> 2], e[I + 384 >> 2] = e[Q >> 2], e[I + 388 >> 2] = C, e[Q >> 2] = 0, e[Q + 4 >> 2] = 0, e[Q + 8 >> 2] = 0, C = e[e[y >> 2] + 32 >> 2], e[5996] = 0, S = I + 144 | 0, Co(141, S | 0, C | 0), C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                                                              break K;
                                                                                                            if (e[5996] = 0, me = S, C = Je[I + 155 | 0], S = C << 24 >> 24 < 0, C = Ko(100, I + 384 | 0, (S ? e[I + 144 >> 2] : me) | 0, (S ? e[I + 148 >> 2] : C) | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                                              break $;
                                                                                                            if (e[I + 408 >> 2] = e[C + 8 >> 2], S = e[C + 4 >> 2], e[I + 400 >> 2] = e[C >> 2], e[I + 404 >> 2] = S, e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[C + 8 >> 2] = 0, e[5996] = 0, S = wn(97, I + 400 | 0, 3613) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                                                                              break H;
                                                                                                            if (e[I + 472 >> 2] = e[S + 8 >> 2], me = e[S + 4 >> 2], e[I + 464 >> 2] = e[S >> 2], e[I + 468 >> 2] = me, e[S >> 2] = 0, e[S + 4 >> 2] = 0, e[S + 8 >> 2] = 0, y = e[e[y >> 2] + 32 >> 2], e[5996] = 0, me = I + 128 | 0, Co(141, me | 0, y + 8 | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                                              break q;
                                                                                                            if (e[5996] = 0, ke = me, y = Je[I + 139 | 0], me = y << 24 >> 24 < 0, me = Ko(100, I + 464 | 0, (me ? e[I + 128 >> 2] : ke) | 0, (me ? e[I + 132 >> 2] : y) | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                                              break L;
                                                                                                            if (e[I + 456 >> 2] = e[me + 8 >> 2], y = e[me + 4 >> 2], e[I + 448 >> 2] = e[me >> 2], e[I + 452 >> 2] = y, e[me >> 2] = 0, e[me + 4 >> 2] = 0, e[me + 8 >> 2] = 0, e[5996] = 0, y = wn(97, I + 448 | 0, 3570) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                                                                                                              break Q;
                                                                                                            if (ke = e[y + 4 >> 2], e[l >> 2] = e[y >> 2], e[l + 4 >> 2] = ke, e[l + 8 >> 2] = e[y + 8 >> 2], e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, Se[I + 139 | 0] < 0 && Tr(e[I + 128 >> 2]), Se[me + 11 | 0] < 0 && Tr(e[me >> 2]), Se[S + 11 | 0] < 0 && Tr(e[S >> 2]), Se[I + 155 | 0] < 0 && Tr(e[I + 144 >> 2]), Se[C + 11 | 0] < 0 && Tr(e[C >> 2]), Se[Q + 11 | 0] < 0 && Tr(e[Q >> 2]), Se[I + 171 | 0] >= 0)
                                                                                                              break l;
                                                                                                            Tr(e[I + 160 >> 2]);
                                                                                                            break l;
                                                                                                          }
                                                                                                          y = gi() | 0;
                                                                                                          break x;
                                                                                                        }
                                                                                                        y = gi() | 0;
                                                                                                        break P;
                                                                                                      }
                                                                                                      y = gi() | 0;
                                                                                                      break M;
                                                                                                    }
                                                                                                    y = gi() | 0;
                                                                                                    break N;
                                                                                                  }
                                                                                                  y = gi() | 0;
                                                                                                  break O;
                                                                                                }
                                                                                                y = gi() | 0;
                                                                                                break U;
                                                                                              }
                                                                                              y = gi() | 0;
                                                                                              break F;
                                                                                            }
                                                                                            if (y = gi() | 0, Se[I + 459 | 0] >= 0)
                                                                                              break F;
                                                                                            Tr(e[I + 448 >> 2]);
                                                                                          }
                                                                                          if (Se[I + 139 | 0] >= 0)
                                                                                            break U;
                                                                                          Tr(e[I + 128 >> 2]);
                                                                                        }
                                                                                        if (Se[I + 475 | 0] >= 0)
                                                                                          break O;
                                                                                        Tr(e[I + 464 >> 2]);
                                                                                      }
                                                                                      if (Se[I + 411 | 0] >= 0)
                                                                                        break N;
                                                                                      Tr(e[I + 400 >> 2]);
                                                                                    }
                                                                                    if (Se[I + 155 | 0] >= 0)
                                                                                      break M;
                                                                                    Tr(e[I + 144 >> 2]);
                                                                                  }
                                                                                  if (Se[I + 395 | 0] >= 0)
                                                                                    break P;
                                                                                  Tr(e[I + 384 >> 2]);
                                                                                }
                                                                                if (Se[I + 379 | 0] >= 0)
                                                                                  break x;
                                                                                Tr(e[I + 368 >> 2]);
                                                                              }
                                                                              if (Se[I + 171 | 0] >= 0)
                                                                                break e;
                                                                              Tr(e[I + 160 >> 2]);
                                                                              break e;
                                                                            }
                                                                            Se[I + 120 | 0] = Je[2551], Se[I + 127 | 0] = 5, Se[I + 121 | 0] = 0, e[5996] = 0, e[I + 116 >> 2] = Je[2547] | Je[2548] << 8 | (Je[2549] << 16 | Je[2550] << 24), Q = I + 368 | 0, Ms(161, Q | 0, y | 0, I + 116 | 0), C = e[5996], e[5996] = 0;
                                                                            y: {
                                                                              x: {
                                                                                P: {
                                                                                  M: {
                                                                                    N: {
                                                                                      O: {
                                                                                        U: {
                                                                                          F: {
                                                                                            Q: {
                                                                                              L: {
                                                                                                q: {
                                                                                                  H: {
                                                                                                    $: {
                                                                                                      K: {
                                                                                                        if ((C | 0) != 1) {
                                                                                                          if (e[5996] = 0, Q = wn(97, Q | 0, 3673) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                                                            break K;
                                                                                                          if (e[I + 392 >> 2] = e[Q + 8 >> 2], C = e[Q + 4 >> 2], e[I + 384 >> 2] = e[Q >> 2], e[I + 388 >> 2] = C, e[Q >> 2] = 0, e[Q + 4 >> 2] = 0, e[Q + 8 >> 2] = 0, C = e[e[y >> 2] + 32 >> 2], e[5996] = 0, S = I + 144 | 0, Co(141, S | 0, C | 0), C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                                                            break $;
                                                                                                          if (e[5996] = 0, me = S, C = Je[I + 155 | 0], S = C << 24 >> 24 < 0, C = Ko(100, I + 384 | 0, (S ? e[I + 144 >> 2] : me) | 0, (S ? e[I + 148 >> 2] : C) | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                                            break H;
                                                                                                          if (e[I + 408 >> 2] = e[C + 8 >> 2], S = e[C + 4 >> 2], e[I + 400 >> 2] = e[C >> 2], e[I + 404 >> 2] = S, e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[C + 8 >> 2] = 0, e[5996] = 0, S = wn(97, I + 400 | 0, 3613) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                                                                            break q;
                                                                                                          if (e[I + 472 >> 2] = e[S + 8 >> 2], me = e[S + 4 >> 2], e[I + 464 >> 2] = e[S >> 2], e[I + 468 >> 2] = me, e[S >> 2] = 0, e[S + 4 >> 2] = 0, e[S + 8 >> 2] = 0, y = e[e[y >> 2] + 32 >> 2], e[5996] = 0, me = I + 128 | 0, Co(141, me | 0, y + 8 | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                                            break L;
                                                                                                          if (e[5996] = 0, ke = me, y = Je[I + 139 | 0], me = y << 24 >> 24 < 0, me = Ko(100, I + 464 | 0, (me ? e[I + 128 >> 2] : ke) | 0, (me ? e[I + 132 >> 2] : y) | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                                            break Q;
                                                                                                          if (e[I + 456 >> 2] = e[me + 8 >> 2], y = e[me + 4 >> 2], e[I + 448 >> 2] = e[me >> 2], e[I + 452 >> 2] = y, e[me >> 2] = 0, e[me + 4 >> 2] = 0, e[me + 8 >> 2] = 0, e[5996] = 0, y = wn(97, I + 448 | 0, 3570) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                                                                                                            break F;
                                                                                                          if (ke = e[y + 4 >> 2], e[l >> 2] = e[y >> 2], e[l + 4 >> 2] = ke, e[l + 8 >> 2] = e[y + 8 >> 2], e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, Se[I + 139 | 0] < 0 && Tr(e[I + 128 >> 2]), Se[me + 11 | 0] < 0 && Tr(e[me >> 2]), Se[S + 11 | 0] < 0 && Tr(e[S >> 2]), Se[I + 155 | 0] < 0 && Tr(e[I + 144 >> 2]), Se[C + 11 | 0] < 0 && Tr(e[C >> 2]), Se[Q + 11 | 0] < 0 && Tr(e[Q >> 2]), Se[I + 127 | 0] >= 0)
                                                                                                            break l;
                                                                                                          Tr(e[I + 116 >> 2]);
                                                                                                          break l;
                                                                                                        }
                                                                                                        y = gi() | 0;
                                                                                                        break y;
                                                                                                      }
                                                                                                      y = gi() | 0;
                                                                                                      break x;
                                                                                                    }
                                                                                                    y = gi() | 0;
                                                                                                    break P;
                                                                                                  }
                                                                                                  y = gi() | 0;
                                                                                                  break M;
                                                                                                }
                                                                                                y = gi() | 0;
                                                                                                break N;
                                                                                              }
                                                                                              y = gi() | 0;
                                                                                              break O;
                                                                                            }
                                                                                            y = gi() | 0;
                                                                                            break U;
                                                                                          }
                                                                                          if (y = gi() | 0, Se[I + 459 | 0] >= 0)
                                                                                            break U;
                                                                                          Tr(e[I + 448 >> 2]);
                                                                                        }
                                                                                        if (Se[I + 139 | 0] >= 0)
                                                                                          break O;
                                                                                        Tr(e[I + 128 >> 2]);
                                                                                      }
                                                                                      if (Se[I + 475 | 0] >= 0)
                                                                                        break N;
                                                                                      Tr(e[I + 464 >> 2]);
                                                                                    }
                                                                                    if (Se[I + 411 | 0] >= 0)
                                                                                      break M;
                                                                                    Tr(e[I + 400 >> 2]);
                                                                                  }
                                                                                  if (Se[I + 155 | 0] >= 0)
                                                                                    break P;
                                                                                  Tr(e[I + 144 >> 2]);
                                                                                }
                                                                                if (Se[I + 395 | 0] >= 0)
                                                                                  break x;
                                                                                Tr(e[I + 384 >> 2]);
                                                                              }
                                                                              if (Se[I + 379 | 0] >= 0)
                                                                                break y;
                                                                              Tr(e[I + 368 >> 2]);
                                                                            }
                                                                            if (Se[I + 127 | 0] >= 0)
                                                                              break e;
                                                                            Tr(e[I + 116 >> 2]);
                                                                            break e;
                                                                          }
                                                                          Se[I + 115 | 0] = 4, Se[I + 108 | 0] = 0, e[I + 104 >> 2] = 1650422383, e[5996] = 0, Q = I + 368 | 0, Ms(161, Q | 0, y | 0, I + 104 | 0), C = e[5996], e[5996] = 0;
                                                                          B: {
                                                                            y: {
                                                                              x: {
                                                                                P: {
                                                                                  M: {
                                                                                    N: {
                                                                                      O: {
                                                                                        U: {
                                                                                          F: {
                                                                                            Q: {
                                                                                              L: {
                                                                                                q: {
                                                                                                  H: {
                                                                                                    $: {
                                                                                                      if ((C | 0) != 1) {
                                                                                                        if (e[5996] = 0, Q = wn(97, Q | 0, 3673) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                                                          break $;
                                                                                                        if (e[I + 392 >> 2] = e[Q + 8 >> 2], C = e[Q + 4 >> 2], e[I + 384 >> 2] = e[Q >> 2], e[I + 388 >> 2] = C, e[Q >> 2] = 0, e[Q + 4 >> 2] = 0, e[Q + 8 >> 2] = 0, C = e[e[y >> 2] + 32 >> 2], e[5996] = 0, S = I + 144 | 0, Co(141, S | 0, C | 0), C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                                                          break H;
                                                                                                        if (e[5996] = 0, me = S, C = Je[I + 155 | 0], S = C << 24 >> 24 < 0, C = Ko(100, I + 384 | 0, (S ? e[I + 144 >> 2] : me) | 0, (S ? e[I + 148 >> 2] : C) | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                                          break q;
                                                                                                        if (e[I + 408 >> 2] = e[C + 8 >> 2], S = e[C + 4 >> 2], e[I + 400 >> 2] = e[C >> 2], e[I + 404 >> 2] = S, e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[C + 8 >> 2] = 0, e[5996] = 0, S = wn(97, I + 400 | 0, 3613) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                                                                          break L;
                                                                                                        if (e[I + 472 >> 2] = e[S + 8 >> 2], me = e[S + 4 >> 2], e[I + 464 >> 2] = e[S >> 2], e[I + 468 >> 2] = me, e[S >> 2] = 0, e[S + 4 >> 2] = 0, e[S + 8 >> 2] = 0, y = e[e[y >> 2] + 32 >> 2], e[5996] = 0, me = I + 128 | 0, Co(141, me | 0, y + 8 | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                                          break Q;
                                                                                                        if (e[5996] = 0, ke = me, y = Je[I + 139 | 0], me = y << 24 >> 24 < 0, me = Ko(100, I + 464 | 0, (me ? e[I + 128 >> 2] : ke) | 0, (me ? e[I + 132 >> 2] : y) | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                                          break F;
                                                                                                        if (e[I + 456 >> 2] = e[me + 8 >> 2], y = e[me + 4 >> 2], e[I + 448 >> 2] = e[me >> 2], e[I + 452 >> 2] = y, e[me >> 2] = 0, e[me + 4 >> 2] = 0, e[me + 8 >> 2] = 0, e[5996] = 0, y = wn(97, I + 448 | 0, 3570) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                                                                                                          break U;
                                                                                                        if (ke = e[y + 4 >> 2], e[l >> 2] = e[y >> 2], e[l + 4 >> 2] = ke, e[l + 8 >> 2] = e[y + 8 >> 2], e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, Se[I + 139 | 0] < 0 && Tr(e[I + 128 >> 2]), Se[me + 11 | 0] < 0 && Tr(e[me >> 2]), Se[S + 11 | 0] < 0 && Tr(e[S >> 2]), Se[I + 155 | 0] < 0 && Tr(e[I + 144 >> 2]), Se[C + 11 | 0] < 0 && Tr(e[C >> 2]), Se[Q + 11 | 0] < 0 && Tr(e[Q >> 2]), Se[I + 115 | 0] >= 0)
                                                                                                          break l;
                                                                                                        Tr(e[I + 104 >> 2]);
                                                                                                        break l;
                                                                                                      }
                                                                                                      y = gi() | 0;
                                                                                                      break B;
                                                                                                    }
                                                                                                    y = gi() | 0;
                                                                                                    break y;
                                                                                                  }
                                                                                                  y = gi() | 0;
                                                                                                  break x;
                                                                                                }
                                                                                                y = gi() | 0;
                                                                                                break P;
                                                                                              }
                                                                                              y = gi() | 0;
                                                                                              break M;
                                                                                            }
                                                                                            y = gi() | 0;
                                                                                            break N;
                                                                                          }
                                                                                          y = gi() | 0;
                                                                                          break O;
                                                                                        }
                                                                                        if (y = gi() | 0, Se[I + 459 | 0] >= 0)
                                                                                          break O;
                                                                                        Tr(e[I + 448 >> 2]);
                                                                                      }
                                                                                      if (Se[I + 139 | 0] >= 0)
                                                                                        break N;
                                                                                      Tr(e[I + 128 >> 2]);
                                                                                    }
                                                                                    if (Se[I + 475 | 0] >= 0)
                                                                                      break M;
                                                                                    Tr(e[I + 464 >> 2]);
                                                                                  }
                                                                                  if (Se[I + 411 | 0] >= 0)
                                                                                    break P;
                                                                                  Tr(e[I + 400 >> 2]);
                                                                                }
                                                                                if (Se[I + 155 | 0] >= 0)
                                                                                  break x;
                                                                                Tr(e[I + 144 >> 2]);
                                                                              }
                                                                              if (Se[I + 395 | 0] >= 0)
                                                                                break y;
                                                                              Tr(e[I + 384 >> 2]);
                                                                            }
                                                                            if (Se[I + 379 | 0] >= 0)
                                                                              break B;
                                                                            Tr(e[I + 368 >> 2]);
                                                                          }
                                                                          if (Se[I + 115 | 0] >= 0)
                                                                            break e;
                                                                          Tr(e[I + 104 >> 2]);
                                                                          break e;
                                                                        }
                                                                        Se[I + 103 | 0] = 4, Se[I + 96 | 0] = 0, e[I + 92 >> 2] = 1667199599, e[5996] = 0, Q = I + 368 | 0, Ms(161, Q | 0, y | 0, I + 92 | 0), C = e[5996], e[5996] = 0;
                                                                        b: {
                                                                          B: {
                                                                            y: {
                                                                              x: {
                                                                                P: {
                                                                                  M: {
                                                                                    N: {
                                                                                      O: {
                                                                                        U: {
                                                                                          F: {
                                                                                            Q: {
                                                                                              L: {
                                                                                                q: {
                                                                                                  H: {
                                                                                                    if ((C | 0) != 1) {
                                                                                                      if (e[5996] = 0, Q = wn(97, Q | 0, 3673) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                                                        break H;
                                                                                                      if (e[I + 392 >> 2] = e[Q + 8 >> 2], C = e[Q + 4 >> 2], e[I + 384 >> 2] = e[Q >> 2], e[I + 388 >> 2] = C, e[Q >> 2] = 0, e[Q + 4 >> 2] = 0, e[Q + 8 >> 2] = 0, C = e[e[y >> 2] + 32 >> 2], e[5996] = 0, S = I + 144 | 0, Co(141, S | 0, C | 0), C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                                                        break q;
                                                                                                      if (e[5996] = 0, me = S, C = Je[I + 155 | 0], S = C << 24 >> 24 < 0, C = Ko(100, I + 384 | 0, (S ? e[I + 144 >> 2] : me) | 0, (S ? e[I + 148 >> 2] : C) | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                                        break L;
                                                                                                      if (e[I + 408 >> 2] = e[C + 8 >> 2], S = e[C + 4 >> 2], e[I + 400 >> 2] = e[C >> 2], e[I + 404 >> 2] = S, e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[C + 8 >> 2] = 0, e[5996] = 0, S = wn(97, I + 400 | 0, 3613) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                                                                        break Q;
                                                                                                      if (e[I + 472 >> 2] = e[S + 8 >> 2], me = e[S + 4 >> 2], e[I + 464 >> 2] = e[S >> 2], e[I + 468 >> 2] = me, e[S >> 2] = 0, e[S + 4 >> 2] = 0, e[S + 8 >> 2] = 0, y = e[e[y >> 2] + 32 >> 2], e[5996] = 0, me = I + 128 | 0, Co(141, me | 0, y + 8 | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                                        break F;
                                                                                                      if (e[5996] = 0, ke = me, y = Je[I + 139 | 0], me = y << 24 >> 24 < 0, me = Ko(100, I + 464 | 0, (me ? e[I + 128 >> 2] : ke) | 0, (me ? e[I + 132 >> 2] : y) | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                                        break U;
                                                                                                      if (e[I + 456 >> 2] = e[me + 8 >> 2], y = e[me + 4 >> 2], e[I + 448 >> 2] = e[me >> 2], e[I + 452 >> 2] = y, e[me >> 2] = 0, e[me + 4 >> 2] = 0, e[me + 8 >> 2] = 0, e[5996] = 0, y = wn(97, I + 448 | 0, 3570) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                                                                                                        break O;
                                                                                                      if (ke = e[y + 4 >> 2], e[l >> 2] = e[y >> 2], e[l + 4 >> 2] = ke, e[l + 8 >> 2] = e[y + 8 >> 2], e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, Se[I + 139 | 0] < 0 && Tr(e[I + 128 >> 2]), Se[me + 11 | 0] < 0 && Tr(e[me >> 2]), Se[S + 11 | 0] < 0 && Tr(e[S >> 2]), Se[I + 155 | 0] < 0 && Tr(e[I + 144 >> 2]), Se[C + 11 | 0] < 0 && Tr(e[C >> 2]), Se[Q + 11 | 0] < 0 && Tr(e[Q >> 2]), Se[I + 103 | 0] >= 0)
                                                                                                        break l;
                                                                                                      Tr(e[I + 92 >> 2]);
                                                                                                      break l;
                                                                                                    }
                                                                                                    y = gi() | 0;
                                                                                                    break b;
                                                                                                  }
                                                                                                  y = gi() | 0;
                                                                                                  break B;
                                                                                                }
                                                                                                y = gi() | 0;
                                                                                                break y;
                                                                                              }
                                                                                              y = gi() | 0;
                                                                                              break x;
                                                                                            }
                                                                                            y = gi() | 0;
                                                                                            break P;
                                                                                          }
                                                                                          y = gi() | 0;
                                                                                          break M;
                                                                                        }
                                                                                        y = gi() | 0;
                                                                                        break N;
                                                                                      }
                                                                                      if (y = gi() | 0, Se[I + 459 | 0] >= 0)
                                                                                        break N;
                                                                                      Tr(e[I + 448 >> 2]);
                                                                                    }
                                                                                    if (Se[I + 139 | 0] >= 0)
                                                                                      break M;
                                                                                    Tr(e[I + 128 >> 2]);
                                                                                  }
                                                                                  if (Se[I + 475 | 0] >= 0)
                                                                                    break P;
                                                                                  Tr(e[I + 464 >> 2]);
                                                                                }
                                                                                if (Se[I + 411 | 0] >= 0)
                                                                                  break x;
                                                                                Tr(e[I + 400 >> 2]);
                                                                              }
                                                                              if (Se[I + 155 | 0] >= 0)
                                                                                break y;
                                                                              Tr(e[I + 144 >> 2]);
                                                                            }
                                                                            if (Se[I + 395 | 0] >= 0)
                                                                              break B;
                                                                            Tr(e[I + 384 >> 2]);
                                                                          }
                                                                          if (Se[I + 379 | 0] >= 0)
                                                                            break b;
                                                                          Tr(e[I + 368 >> 2]);
                                                                        }
                                                                        if (Se[I + 103 | 0] >= 0)
                                                                          break e;
                                                                        Tr(e[I + 92 >> 2]);
                                                                        break e;
                                                                      }
                                                                      Se[I + 91 | 0] = 4, Se[I + 84 | 0] = 0, e[I + 80 >> 2] = 1683976815, e[5996] = 0, Q = I + 368 | 0, Ms(161, Q | 0, y | 0, I + 80 | 0), C = e[5996], e[5996] = 0;
                                                                      D: {
                                                                        b: {
                                                                          B: {
                                                                            y: {
                                                                              x: {
                                                                                P: {
                                                                                  M: {
                                                                                    N: {
                                                                                      O: {
                                                                                        U: {
                                                                                          F: {
                                                                                            Q: {
                                                                                              L: {
                                                                                                q: {
                                                                                                  if ((C | 0) != 1) {
                                                                                                    if (e[5996] = 0, Q = wn(97, Q | 0, 3673) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                                                      break q;
                                                                                                    if (e[I + 392 >> 2] = e[Q + 8 >> 2], C = e[Q + 4 >> 2], e[I + 384 >> 2] = e[Q >> 2], e[I + 388 >> 2] = C, e[Q >> 2] = 0, e[Q + 4 >> 2] = 0, e[Q + 8 >> 2] = 0, C = e[e[y >> 2] + 32 >> 2], e[5996] = 0, S = I + 144 | 0, Co(141, S | 0, C | 0), C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                                                      break L;
                                                                                                    if (e[5996] = 0, me = S, C = Je[I + 155 | 0], S = C << 24 >> 24 < 0, C = Ko(100, I + 384 | 0, (S ? e[I + 144 >> 2] : me) | 0, (S ? e[I + 148 >> 2] : C) | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                                      break Q;
                                                                                                    if (e[I + 408 >> 2] = e[C + 8 >> 2], S = e[C + 4 >> 2], e[I + 400 >> 2] = e[C >> 2], e[I + 404 >> 2] = S, e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[C + 8 >> 2] = 0, e[5996] = 0, S = wn(97, I + 400 | 0, 3613) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                                                                      break F;
                                                                                                    if (e[I + 472 >> 2] = e[S + 8 >> 2], me = e[S + 4 >> 2], e[I + 464 >> 2] = e[S >> 2], e[I + 468 >> 2] = me, e[S >> 2] = 0, e[S + 4 >> 2] = 0, e[S + 8 >> 2] = 0, y = e[e[y >> 2] + 32 >> 2], e[5996] = 0, me = I + 128 | 0, Co(141, me | 0, y + 8 | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                                      break U;
                                                                                                    if (e[5996] = 0, ke = me, y = Je[I + 139 | 0], me = y << 24 >> 24 < 0, me = Ko(100, I + 464 | 0, (me ? e[I + 128 >> 2] : ke) | 0, (me ? e[I + 132 >> 2] : y) | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                                      break O;
                                                                                                    if (e[I + 456 >> 2] = e[me + 8 >> 2], y = e[me + 4 >> 2], e[I + 448 >> 2] = e[me >> 2], e[I + 452 >> 2] = y, e[me >> 2] = 0, e[me + 4 >> 2] = 0, e[me + 8 >> 2] = 0, e[5996] = 0, y = wn(97, I + 448 | 0, 3570) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                                                                                                      break N;
                                                                                                    if (ke = e[y + 4 >> 2], e[l >> 2] = e[y >> 2], e[l + 4 >> 2] = ke, e[l + 8 >> 2] = e[y + 8 >> 2], e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, Se[I + 139 | 0] < 0 && Tr(e[I + 128 >> 2]), Se[me + 11 | 0] < 0 && Tr(e[me >> 2]), Se[S + 11 | 0] < 0 && Tr(e[S >> 2]), Se[I + 155 | 0] < 0 && Tr(e[I + 144 >> 2]), Se[C + 11 | 0] < 0 && Tr(e[C >> 2]), Se[Q + 11 | 0] < 0 && Tr(e[Q >> 2]), Se[I + 91 | 0] >= 0)
                                                                                                      break l;
                                                                                                    Tr(e[I + 80 >> 2]);
                                                                                                    break l;
                                                                                                  }
                                                                                                  y = gi() | 0;
                                                                                                  break D;
                                                                                                }
                                                                                                y = gi() | 0;
                                                                                                break b;
                                                                                              }
                                                                                              y = gi() | 0;
                                                                                              break B;
                                                                                            }
                                                                                            y = gi() | 0;
                                                                                            break y;
                                                                                          }
                                                                                          y = gi() | 0;
                                                                                          break x;
                                                                                        }
                                                                                        y = gi() | 0;
                                                                                        break P;
                                                                                      }
                                                                                      y = gi() | 0;
                                                                                      break M;
                                                                                    }
                                                                                    if (y = gi() | 0, Se[I + 459 | 0] >= 0)
                                                                                      break M;
                                                                                    Tr(e[I + 448 >> 2]);
                                                                                  }
                                                                                  if (Se[I + 139 | 0] >= 0)
                                                                                    break P;
                                                                                  Tr(e[I + 128 >> 2]);
                                                                                }
                                                                                if (Se[I + 475 | 0] >= 0)
                                                                                  break x;
                                                                                Tr(e[I + 464 >> 2]);
                                                                              }
                                                                              if (Se[I + 411 | 0] >= 0)
                                                                                break y;
                                                                              Tr(e[I + 400 >> 2]);
                                                                            }
                                                                            if (Se[I + 155 | 0] >= 0)
                                                                              break B;
                                                                            Tr(e[I + 144 >> 2]);
                                                                          }
                                                                          if (Se[I + 395 | 0] >= 0)
                                                                            break b;
                                                                          Tr(e[I + 384 >> 2]);
                                                                        }
                                                                        if (Se[I + 379 | 0] >= 0)
                                                                          break D;
                                                                        Tr(e[I + 368 >> 2]);
                                                                      }
                                                                      if (Se[I + 91 | 0] >= 0)
                                                                        break e;
                                                                      Tr(e[I + 80 >> 2]);
                                                                      break e;
                                                                    }
                                                                    Se[I + 79 | 0] = 4, Se[I + 72 | 0] = 0, e[I + 68 >> 2] = 1767862895, e[5996] = 0, Q = I + 368 | 0, Ms(161, Q | 0, y | 0, I + 68 | 0), C = e[5996], e[5996] = 0;
                                                                    C: {
                                                                      D: {
                                                                        b: {
                                                                          B: {
                                                                            y: {
                                                                              x: {
                                                                                P: {
                                                                                  M: {
                                                                                    N: {
                                                                                      O: {
                                                                                        U: {
                                                                                          F: {
                                                                                            Q: {
                                                                                              L: {
                                                                                                if ((C | 0) != 1) {
                                                                                                  if (e[5996] = 0, Q = wn(97, Q | 0, 3673) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                                                    break L;
                                                                                                  if (e[I + 392 >> 2] = e[Q + 8 >> 2], C = e[Q + 4 >> 2], e[I + 384 >> 2] = e[Q >> 2], e[I + 388 >> 2] = C, e[Q >> 2] = 0, e[Q + 4 >> 2] = 0, e[Q + 8 >> 2] = 0, C = e[e[y >> 2] + 32 >> 2], e[5996] = 0, S = I + 144 | 0, Co(141, S | 0, C | 0), C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                                                    break Q;
                                                                                                  if (e[5996] = 0, me = S, C = Je[I + 155 | 0], S = C << 24 >> 24 < 0, C = Ko(100, I + 384 | 0, (S ? e[I + 144 >> 2] : me) | 0, (S ? e[I + 148 >> 2] : C) | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                                    break F;
                                                                                                  if (e[I + 408 >> 2] = e[C + 8 >> 2], S = e[C + 4 >> 2], e[I + 400 >> 2] = e[C >> 2], e[I + 404 >> 2] = S, e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[C + 8 >> 2] = 0, e[5996] = 0, S = wn(97, I + 400 | 0, 3613) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                                                                    break U;
                                                                                                  if (e[I + 472 >> 2] = e[S + 8 >> 2], me = e[S + 4 >> 2], e[I + 464 >> 2] = e[S >> 2], e[I + 468 >> 2] = me, e[S >> 2] = 0, e[S + 4 >> 2] = 0, e[S + 8 >> 2] = 0, y = e[e[y >> 2] + 32 >> 2], e[5996] = 0, me = I + 128 | 0, Co(141, me | 0, y + 8 | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                                    break O;
                                                                                                  if (e[5996] = 0, ke = me, y = Je[I + 139 | 0], me = y << 24 >> 24 < 0, me = Ko(100, I + 464 | 0, (me ? e[I + 128 >> 2] : ke) | 0, (me ? e[I + 132 >> 2] : y) | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                                    break N;
                                                                                                  if (e[I + 456 >> 2] = e[me + 8 >> 2], y = e[me + 4 >> 2], e[I + 448 >> 2] = e[me >> 2], e[I + 452 >> 2] = y, e[me >> 2] = 0, e[me + 4 >> 2] = 0, e[me + 8 >> 2] = 0, e[5996] = 0, y = wn(97, I + 448 | 0, 3570) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                                                                                                    break M;
                                                                                                  if (ke = e[y + 4 >> 2], e[l >> 2] = e[y >> 2], e[l + 4 >> 2] = ke, e[l + 8 >> 2] = e[y + 8 >> 2], e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, Se[I + 139 | 0] < 0 && Tr(e[I + 128 >> 2]), Se[me + 11 | 0] < 0 && Tr(e[me >> 2]), Se[S + 11 | 0] < 0 && Tr(e[S >> 2]), Se[I + 155 | 0] < 0 && Tr(e[I + 144 >> 2]), Se[C + 11 | 0] < 0 && Tr(e[C >> 2]), Se[Q + 11 | 0] < 0 && Tr(e[Q >> 2]), Se[I + 79 | 0] >= 0)
                                                                                                    break l;
                                                                                                  Tr(e[I + 68 >> 2]);
                                                                                                  break l;
                                                                                                }
                                                                                                y = gi() | 0;
                                                                                                break C;
                                                                                              }
                                                                                              y = gi() | 0;
                                                                                              break D;
                                                                                            }
                                                                                            y = gi() | 0;
                                                                                            break b;
                                                                                          }
                                                                                          y = gi() | 0;
                                                                                          break B;
                                                                                        }
                                                                                        y = gi() | 0;
                                                                                        break y;
                                                                                      }
                                                                                      y = gi() | 0;
                                                                                      break x;
                                                                                    }
                                                                                    y = gi() | 0;
                                                                                    break P;
                                                                                  }
                                                                                  if (y = gi() | 0, Se[I + 459 | 0] >= 0)
                                                                                    break P;
                                                                                  Tr(e[I + 448 >> 2]);
                                                                                }
                                                                                if (Se[I + 139 | 0] >= 0)
                                                                                  break x;
                                                                                Tr(e[I + 128 >> 2]);
                                                                              }
                                                                              if (Se[I + 475 | 0] >= 0)
                                                                                break y;
                                                                              Tr(e[I + 464 >> 2]);
                                                                            }
                                                                            if (Se[I + 411 | 0] >= 0)
                                                                              break B;
                                                                            Tr(e[I + 400 >> 2]);
                                                                          }
                                                                          if (Se[I + 155 | 0] >= 0)
                                                                            break b;
                                                                          Tr(e[I + 144 >> 2]);
                                                                        }
                                                                        if (Se[I + 395 | 0] >= 0)
                                                                          break D;
                                                                        Tr(e[I + 384 >> 2]);
                                                                      }
                                                                      if (Se[I + 379 | 0] >= 0)
                                                                        break C;
                                                                      Tr(e[I + 368 >> 2]);
                                                                    }
                                                                    if (Se[I + 79 | 0] >= 0)
                                                                      break e;
                                                                    Tr(e[I + 68 >> 2]);
                                                                    break e;
                                                                  }
                                                                  ea[I - -64 >> 1] = Je[2600] | Je[2601] << 8, ea[I + 66 >> 1] = 2560, e[5996] = 0, Q = Je[2596] | Je[2597] << 8 | (Je[2598] << 16 | Je[2599] << 24), e[I + 56 >> 2] = Je[2592] | Je[2593] << 8 | (Je[2594] << 16 | Je[2595] << 24), e[I + 60 >> 2] = Q, Q = I + 128 | 0, Ms(161, Q | 0, y | 0, I + 56 | 0), C = e[5996], e[5996] = 0;
                                                                  m: {
                                                                    C: {
                                                                      D: {
                                                                        b: {
                                                                          B: {
                                                                            y: {
                                                                              x: {
                                                                                P: {
                                                                                  M: {
                                                                                    N: {
                                                                                      O: {
                                                                                        U: {
                                                                                          F: {
                                                                                            Q: {
                                                                                              L: {
                                                                                                q: {
                                                                                                  H: {
                                                                                                    $: {
                                                                                                      K: {
                                                                                                        G: {
                                                                                                          if ((C | 0) != 1) {
                                                                                                            if (e[5996] = 0, Q = wn(97, Q | 0, 3623) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                                                              break G;
                                                                                                            if (e[I + 152 >> 2] = e[Q + 8 >> 2], C = e[Q + 4 >> 2], e[I + 144 >> 2] = e[Q >> 2], e[I + 148 >> 2] = C, e[Q >> 2] = 0, e[Q + 4 >> 2] = 0, e[Q + 8 >> 2] = 0, C = e[e[y >> 2] + 32 >> 2], e[5996] = 0, S = I + 40 | 0, Co(141, S | 0, C | 0), C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                                                              break K;
                                                                                                            if (e[5996] = 0, me = S, C = Je[I + 51 | 0], S = C << 24 >> 24 < 0, C = Ko(100, I + 144 | 0, (S ? e[I + 40 >> 2] : me) | 0, (S ? e[I + 44 >> 2] : C) | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                                              break $;
                                                                                                            if (e[I + 376 >> 2] = e[C + 8 >> 2], S = e[C + 4 >> 2], e[I + 368 >> 2] = e[C >> 2], e[I + 372 >> 2] = S, e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[C + 8 >> 2] = 0, e[5996] = 0, S = wn(97, I + 368 | 0, 3613) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                                                                              break H;
                                                                                                            if (e[I + 392 >> 2] = e[S + 8 >> 2], me = e[S + 4 >> 2], e[I + 384 >> 2] = e[S >> 2], e[I + 388 >> 2] = me, e[S >> 2] = 0, e[S + 4 >> 2] = 0, e[S + 8 >> 2] = 0, me = e[e[y >> 2] + 32 >> 2], e[5996] = 0, ke = I + 28 | 0, Co(141, ke | 0, me + 8 | 0), me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                                                                              break q;
                                                                                                            if (e[5996] = 0, Ar = ke, me = Je[I + 39 | 0], ke = me << 24 >> 24 < 0, me = Ko(100, I + 384 | 0, (ke ? e[I + 28 >> 2] : Ar) | 0, (ke ? e[I + 32 >> 2] : me) | 0) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                                                                                                              break L;
                                                                                                            if (e[I + 408 >> 2] = e[me + 8 >> 2], ke = e[me + 4 >> 2], e[I + 400 >> 2] = e[me >> 2], e[I + 404 >> 2] = ke, e[me >> 2] = 0, e[me + 4 >> 2] = 0, e[me + 8 >> 2] = 0, e[5996] = 0, ke = wn(97, I + 400 | 0, 3603) | 0, Ar = e[5996], e[5996] = 0, (Ar | 0) == 1)
                                                                                                              break Q;
                                                                                                            if (e[I + 472 >> 2] = e[ke + 8 >> 2], Ar = e[ke + 4 >> 2], e[I + 464 >> 2] = e[ke >> 2], e[I + 468 >> 2] = Ar, e[ke >> 2] = 0, e[ke + 4 >> 2] = 0, e[ke + 8 >> 2] = 0, y = e[e[y >> 2] + 32 >> 2], e[5996] = 0, Ar = I + 16 | 0, Co(141, Ar | 0, y + 16 | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                                              break F;
                                                                                                            if (e[5996] = 0, br = Ar, y = Je[I + 27 | 0], Ar = y << 24 >> 24 < 0, Ar = Ko(100, I + 464 | 0, (Ar ? e[I + 16 >> 2] : br) | 0, (Ar ? e[I + 20 >> 2] : y) | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                                              break U;
                                                                                                            if (e[I + 456 >> 2] = e[Ar + 8 >> 2], y = e[Ar + 4 >> 2], e[I + 448 >> 2] = e[Ar >> 2], e[I + 452 >> 2] = y, e[Ar >> 2] = 0, e[Ar + 4 >> 2] = 0, e[Ar + 8 >> 2] = 0, e[5996] = 0, y = wn(97, I + 448 | 0, 3570) | 0, br = e[5996], e[5996] = 0, (br | 0) == 1)
                                                                                                              break O;
                                                                                                            if (br = e[y + 4 >> 2], e[l >> 2] = e[y >> 2], e[l + 4 >> 2] = br, e[l + 8 >> 2] = e[y + 8 >> 2], e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, Se[I + 27 | 0] < 0 && Tr(e[I + 16 >> 2]), Se[Ar + 11 | 0] < 0 && Tr(e[Ar >> 2]), Se[ke + 11 | 0] < 0 && Tr(e[ke >> 2]), Se[I + 39 | 0] < 0 && Tr(e[I + 28 >> 2]), Se[me + 11 | 0] < 0 && Tr(e[me >> 2]), Se[S + 11 | 0] < 0 && Tr(e[S >> 2]), Se[I + 51 | 0] < 0 && Tr(e[I + 40 >> 2]), Se[C + 11 | 0] < 0 && Tr(e[C >> 2]), Se[Q + 11 | 0] < 0 && Tr(e[Q >> 2]), Se[I + 67 | 0] >= 0)
                                                                                                              break l;
                                                                                                            Tr(e[I + 56 >> 2]);
                                                                                                            break l;
                                                                                                          }
                                                                                                          y = gi() | 0;
                                                                                                          break m;
                                                                                                        }
                                                                                                        y = gi() | 0;
                                                                                                        break C;
                                                                                                      }
                                                                                                      y = gi() | 0;
                                                                                                      break D;
                                                                                                    }
                                                                                                    y = gi() | 0;
                                                                                                    break b;
                                                                                                  }
                                                                                                  y = gi() | 0;
                                                                                                  break B;
                                                                                                }
                                                                                                y = gi() | 0;
                                                                                                break y;
                                                                                              }
                                                                                              y = gi() | 0;
                                                                                              break x;
                                                                                            }
                                                                                            y = gi() | 0;
                                                                                            break P;
                                                                                          }
                                                                                          y = gi() | 0;
                                                                                          break M;
                                                                                        }
                                                                                        y = gi() | 0;
                                                                                        break N;
                                                                                      }
                                                                                      if (y = gi() | 0, Se[I + 459 | 0] >= 0)
                                                                                        break N;
                                                                                      Tr(e[I + 448 >> 2]);
                                                                                    }
                                                                                    if (Se[I + 27 | 0] >= 0)
                                                                                      break M;
                                                                                    Tr(e[I + 16 >> 2]);
                                                                                  }
                                                                                  if (Se[I + 475 | 0] >= 0)
                                                                                    break P;
                                                                                  Tr(e[I + 464 >> 2]);
                                                                                }
                                                                                if (Se[I + 411 | 0] >= 0)
                                                                                  break x;
                                                                                Tr(e[I + 400 >> 2]);
                                                                              }
                                                                              if (Se[I + 39 | 0] >= 0)
                                                                                break y;
                                                                              Tr(e[I + 28 >> 2]);
                                                                            }
                                                                            if (Se[I + 395 | 0] >= 0)
                                                                              break B;
                                                                            Tr(e[I + 384 >> 2]);
                                                                          }
                                                                          if (Se[I + 379 | 0] >= 0)
                                                                            break b;
                                                                          Tr(e[I + 368 >> 2]);
                                                                        }
                                                                        if (Se[I + 51 | 0] >= 0)
                                                                          break D;
                                                                        Tr(e[I + 40 >> 2]);
                                                                      }
                                                                      if (Se[I + 155 | 0] >= 0)
                                                                        break C;
                                                                      Tr(e[I + 144 >> 2]);
                                                                    }
                                                                    if (Se[I + 139 | 0] >= 0)
                                                                      break m;
                                                                    Tr(e[I + 128 >> 2]);
                                                                  }
                                                                  if (Se[I + 67 | 0] >= 0)
                                                                    break e;
                                                                  Tr(e[I + 56 >> 2]);
                                                                  break e;
                                                                }
                                                                if (C = I + 144 | 0, $f(C, e[Q + 4 >> 2]), e[5996] = 0, Q = Ko(99, C | 0, 0, 5302) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                  break I;
                                                                if (e[I + 376 >> 2] = e[Q + 8 >> 2], C = e[Q + 4 >> 2], e[I + 368 >> 2] = e[Q >> 2], e[I + 372 >> 2] = C, e[Q >> 2] = 0, e[Q + 4 >> 2] = 0, e[Q + 8 >> 2] = 0, e[5996] = 0, C = wn(97, I + 368 | 0, 5417) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                  break w;
                                                                if (e[I + 392 >> 2] = e[C + 8 >> 2], S = e[C + 4 >> 2], e[I + 384 >> 2] = e[C >> 2], e[I + 388 >> 2] = S, e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[C + 8 >> 2] = 0, S = e[y >> 2], me = e[S + 36 >> 2], S = e[S + 32 >> 2], e[5996] = 0, ke = I + 128 | 0, Co(115, ke | 0, me - S >> 3), S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                  break E;
                                                                if (e[5996] = 0, S = Je[I + 139 | 0], me = S << 24 >> 24 < 0, S = Ko(100, I + 384 | 0, (me ? e[I + 128 >> 2] : ke) | 0, (me ? e[I + 132 >> 2] : S) | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                                  break S;
                                                                if (e[I + 408 >> 2] = e[S + 8 >> 2], me = e[S + 4 >> 2], e[I + 400 >> 2] = e[S >> 2], e[I + 404 >> 2] = me, e[S >> 2] = 0, e[S + 4 >> 2] = 0, e[S + 8 >> 2] = 0, e[5996] = 0, me = wn(97, I + 400 | 0, 5242) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                                                                  break k;
                                                                if (e[I + 8 >> 2] = e[me + 8 >> 2], ke = e[me + 4 >> 2], e[I >> 2] = e[me >> 2], e[I + 4 >> 2] = ke, e[me >> 2] = 0, e[me + 4 >> 2] = 0, e[me + 8 >> 2] = 0, e[5996] = 0, ke = I + 464 | 0, Ms(161, ke | 0, y | 0, I | 0), Ar = e[5996], e[5996] = 0, (Ar | 0) == 1)
                                                                  break R;
                                                                if (e[5996] = 0, ke = wn(97, ke | 0, 3726) | 0, Ar = e[5996], e[5996] = 0, (Ar | 0) == 1)
                                                                  break _;
                                                                if (e[I + 456 >> 2] = e[ke + 8 >> 2], Ar = e[ke + 4 >> 2], e[I + 448 >> 2] = e[ke >> 2], e[I + 452 >> 2] = Ar, e[ke >> 2] = 0, e[ke + 4 >> 2] = 0, e[ke + 8 >> 2] = 0, Se[I + 11 | 0] < 0 && Tr(e[I >> 2]), Se[me + 11 | 0] < 0 && Tr(e[me >> 2]), Se[I + 139 | 0] < 0 && Tr(e[I + 128 >> 2]), Se[S + 11 | 0] < 0 && Tr(e[S >> 2]), Se[C + 11 | 0] < 0 && Tr(e[C >> 2]), Se[Q + 11 | 0] < 0 && Tr(e[Q >> 2]), y = e[y >> 2], C = e[y + 32 >> 2], S = e[y + 36 >> 2], (C | 0) != (S | 0))
                                                                  for (; ; ) {
                                                                    if (e[5996] = 0, y = I + 28 | 0, Co(141, y | 0, C | 0), Q = e[5996], e[5996] = 0, (Q | 0) == 1)
                                                                      break h;
                                                                    if (e[5996] = 0, y = Ko(99, y | 0, 0, 3708) | 0, Q = e[5996], e[5996] = 0, (Q | 0) == 1)
                                                                      break u;
                                                                    if (e[I + 48 >> 2] = e[y + 8 >> 2], Q = e[y + 4 >> 2], e[I + 40 >> 2] = e[y >> 2], e[I + 44 >> 2] = Q, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, e[5996] = 0, Q = wn(97, I + 40 | 0, 3713) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                                      break A;
                                                                    if (e[I + 136 >> 2] = e[Q + 8 >> 2], me = e[Q + 4 >> 2], e[I + 128 >> 2] = e[Q >> 2], e[I + 132 >> 2] = me, e[Q >> 2] = 0, e[Q + 4 >> 2] = 0, e[Q + 8 >> 2] = 0, e[5996] = 0, me = Je[I + 139 | 0], ke = me << 24 >> 24 < 0, Ko(100, I + 448 | 0, (ke ? e[I + 128 >> 2] : I + 128 | 0) | 0, (ke ? e[I + 132 >> 2] : me) | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                                      break s;
                                                                    if (Se[I + 139 | 0] < 0 && Tr(e[I + 128 >> 2]), Se[I + 51 | 0] < 0 && Tr(e[Q >> 2]), Se[I + 39 | 0] < 0 && Tr(e[y >> 2]), C = C + 8 | 0, (S | 0) == (C | 0))
                                                                      break;
                                                                  }
                                                                if (e[5996] = 0, y = wn(97, I + 448 | 0, 3575) | 0, Q = e[5996], e[5996] = 0, (Q | 0) == 1)
                                                                  break n;
                                                                Q = e[y + 4 >> 2], e[l >> 2] = e[y >> 2], e[l + 4 >> 2] = Q, e[l + 8 >> 2] = e[y + 8 >> 2], e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0;
                                                              }
                                                              bi = I + 496 | 0;
                                                              return;
                                                            }
                                                            y = gi() | 0;
                                                            break c;
                                                          }
                                                          y = gi() | 0;
                                                          break f;
                                                        }
                                                        y = gi() | 0;
                                                        break p;
                                                      }
                                                      y = gi() | 0;
                                                      break d;
                                                    }
                                                    y = gi() | 0;
                                                    break g;
                                                  }
                                                  y = gi() | 0;
                                                  break v;
                                                }
                                                if (y = gi() | 0, Se[I + 475 | 0] >= 0)
                                                  break v;
                                                Tr(e[I + 464 >> 2]);
                                              }
                                              if (Se[I + 11 | 0] >= 0)
                                                break g;
                                              Tr(e[I >> 2]);
                                            }
                                            if (Se[I + 411 | 0] >= 0)
                                              break d;
                                            Tr(e[I + 400 >> 2]);
                                          }
                                          if (Se[I + 139 | 0] >= 0)
                                            break p;
                                          Tr(e[I + 128 >> 2]);
                                        }
                                        if (Se[I + 395 | 0] >= 0)
                                          break f;
                                        Tr(e[I + 384 >> 2]);
                                      }
                                      if (Se[I + 379 | 0] >= 0)
                                        break c;
                                      Tr(e[I + 368 >> 2]);
                                    }
                                    if (Se[I + 155 | 0] >= 0)
                                      break e;
                                    Tr(e[I + 144 >> 2]);
                                    break e;
                                  }
                                  y = gi() | 0;
                                  break i;
                                }
                                y = gi() | 0;
                                break o;
                              }
                              y = gi() | 0;
                              break a;
                            }
                            if (y = gi() | 0, Se[I + 139 | 0] >= 0)
                              break a;
                            Tr(e[I + 128 >> 2]);
                          }
                          if (Se[I + 51 | 0] >= 0)
                            break o;
                          Tr(e[I + 40 >> 2]);
                        }
                        if (Se[I + 39 | 0] >= 0)
                          break i;
                        Tr(e[I + 28 >> 2]);
                        break i;
                      }
                      y = gi() | 0;
                    }
                    if (Se[I + 459 | 0] >= 0)
                      break e;
                    Tr(e[I + 448 >> 2]);
                    break e;
                  }
                  if (!Je[I + 460 | 0] | Se[I + 459 | 0] >= 0)
                    break e;
                  Tr(e[I + 448 >> 2]);
                  break e;
                }
                if (Se[I + 475 | 0] >= 0)
                  break e;
                Tr(e[I + 464 >> 2]);
              }
              ss(y | 0), jn();
            }
            function wh(l, y, I) {
              l = l | 0, y = y | 0, I = I | 0;
              var C = 0, Q = 0, S = 0, me = 0, ke = 0, Ar = 0, br = 0, Qr = 0, Ur = 0, Xr = 0, Ri = 0, yn = 0, En = 0, Wn = 0;
              ke = bi - 48 | 0, bi = ke, e[ke + 24 >> 2] = 0, e[ke + 16 >> 2] = 0, e[ke + 20 >> 2] = 0;
              e: {
                t: {
                  r: {
                    i: {
                      n: {
                        o: {
                          a: {
                            s: {
                              A: {
                                u: {
                                  h: {
                                    c: {
                                      f: {
                                        p: {
                                          d: {
                                            g: {
                                              v: {
                                                _: {
                                                  R: {
                                                    k: {
                                                      S: {
                                                        E:
                                                          switch (e[l >> 2]) {
                                                            case 1:
                                                              if (e[5996] = 0, y = no(3, 56) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                break i;
                                                              if (e[5996] = 0, l = wn(32, ke + 28 | 0, l + 28 | 0) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                break S;
                                                              if (e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, e[y >> 2] = 2, e[y + 12 >> 2] = 0, e[y + 16 >> 2] = e[l >> 2], e[y + 20 >> 2] = e[l + 4 >> 2], e[y + 24 >> 2] = e[l + 8 >> 2], e[l + 8 >> 2] = 0, e[l >> 2] = 0, e[l + 4 >> 2] = 0, e[y + 44 >> 2] = 0, e[y + 36 >> 2] = 0, e[y + 40 >> 2] = 0, e[y + 28 >> 2] = 0, e[y + 32 >> 2] = 0, e[5996] = 0, Co(33, I | 0, y | 0), l = e[5996], e[5996] = 0, (l | 0) == 1)
                                                                break i;
                                                              if (C = e[ke + 20 >> 2], S = e[ke + 24 >> 2], C >>> 0 < S >>> 0) {
                                                                e[C >> 2] = y, e[ke + 20 >> 2] = C + 4;
                                                                break d;
                                                              }
                                                              if (l = e[ke + 16 >> 2], Q = C - l >> 2, me = Q + 1 | 0, me >>> 0 >= 1073741824) {
                                                                if (e[5996] = 0, jo(34), l = e[5996], e[5996] = 0, (l | 0) == 1)
                                                                  break i;
                                                                break e;
                                                              }
                                                              if (S = S - l | 0, Ar = S >> 1, me = S >>> 0 >= 2147483644 ? 1073741823 : me >>> 0 < Ar >>> 0 ? Ar : me, me) {
                                                                if (me >>> 0 >= 1073741824) {
                                                                  if (e[5996] = 0, jo(35), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                    break e;
                                                                  break i;
                                                                }
                                                                if (e[5996] = 0, br = no(3, me << 2) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                  break i;
                                                              }
                                                              if (Q = (Q << 2) + br | 0, e[Q >> 2] = y, S = Q + 4 | 0, (l | 0) != (C | 0)) {
                                                                for (; Q = Q - 4 | 0, C = C - 4 | 0, e[Q >> 2] = e[C >> 2], (l | 0) != (C | 0); )
                                                                  ;
                                                                C = e[ke + 16 >> 2];
                                                              }
                                                              if (e[ke + 24 >> 2] = (me << 2) + br, e[ke + 20 >> 2] = S, e[ke + 16 >> 2] = Q, !C)
                                                                break p;
                                                              Tr(C);
                                                              break d;
                                                            case 2:
                                                              if (l = e[l + 52 >> 2], e[5996] = 0, y = no(3, 56) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1 || (e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, e[y >> 2] = 4, e[y + 40 >> 2] = l, e[y + 44 >> 2] = 0, e[y + 12 >> 2] = 0, e[y + 16 >> 2] = 0, e[y + 20 >> 2] = 0, e[y + 24 >> 2] = 0, e[y + 28 >> 2] = 0, e[y + 32 >> 2] = 0, e[y + 36 >> 2] = 0, e[5996] = 0, Co(33, I | 0, y | 0), l = e[5996], e[5996] = 0, (l | 0) == 1))
                                                                break n;
                                                              if (C = e[ke + 20 >> 2], S = e[ke + 24 >> 2], C >>> 0 < S >>> 0) {
                                                                e[C >> 2] = y, e[ke + 20 >> 2] = C + 4;
                                                                break d;
                                                              }
                                                              if (l = e[ke + 16 >> 2], Q = C - l >> 2, me = Q + 1 | 0, me >>> 0 >= 1073741824) {
                                                                if (e[5996] = 0, jo(34), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                  break e;
                                                                break n;
                                                              }
                                                              if (S = S - l | 0, Ar = S >> 1, me = S >>> 0 >= 2147483644 ? 1073741823 : me >>> 0 < Ar >>> 0 ? Ar : me, me) {
                                                                if (me >>> 0 >= 1073741824) {
                                                                  if (e[5996] = 0, jo(35), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                    break e;
                                                                  break n;
                                                                }
                                                                if (e[5996] = 0, br = no(3, me << 2) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                  break n;
                                                              }
                                                              if (Q = (Q << 2) + br | 0, e[Q >> 2] = y, S = Q + 4 | 0, (l | 0) != (C | 0)) {
                                                                for (; Q = Q - 4 | 0, C = C - 4 | 0, e[Q >> 2] = e[C >> 2], (l | 0) != (C | 0); )
                                                                  ;
                                                                C = e[ke + 16 >> 2];
                                                              }
                                                              if (e[ke + 24 >> 2] = (me << 2) + br, e[ke + 20 >> 2] = S, e[ke + 16 >> 2] = Q, !C)
                                                                break p;
                                                              Tr(C);
                                                              break d;
                                                            case 3:
                                                              if (l = e[l + 52 >> 2], e[5996] = 0, y = no(3, 56) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1 || (e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, e[y >> 2] = 5, e[y + 40 >> 2] = l, e[y + 44 >> 2] = 0, e[y + 12 >> 2] = 0, e[y + 16 >> 2] = 0, e[y + 20 >> 2] = 0, e[y + 24 >> 2] = 0, e[y + 28 >> 2] = 0, e[y + 32 >> 2] = 0, e[y + 36 >> 2] = 0, e[5996] = 0, Co(33, I | 0, y | 0), l = e[5996], e[5996] = 0, (l | 0) == 1))
                                                                break o;
                                                              if (C = e[ke + 20 >> 2], S = e[ke + 24 >> 2], C >>> 0 < S >>> 0) {
                                                                e[C >> 2] = y, e[ke + 20 >> 2] = C + 4;
                                                                break d;
                                                              }
                                                              if (l = e[ke + 16 >> 2], Q = C - l >> 2, me = Q + 1 | 0, me >>> 0 >= 1073741824) {
                                                                if (e[5996] = 0, jo(34), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                  break e;
                                                                break o;
                                                              }
                                                              if (S = S - l | 0, Ar = S >> 1, me = S >>> 0 >= 2147483644 ? 1073741823 : me >>> 0 < Ar >>> 0 ? Ar : me, me) {
                                                                if (me >>> 0 >= 1073741824) {
                                                                  if (e[5996] = 0, jo(35), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                    break e;
                                                                  break o;
                                                                }
                                                                if (e[5996] = 0, br = no(3, me << 2) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                  break o;
                                                              }
                                                              if (Q = (Q << 2) + br | 0, e[Q >> 2] = y, S = Q + 4 | 0, (l | 0) != (C | 0)) {
                                                                for (; Q = Q - 4 | 0, C = C - 4 | 0, e[Q >> 2] = e[C >> 2], (l | 0) != (C | 0); )
                                                                  ;
                                                                C = e[ke + 16 >> 2];
                                                              }
                                                              if (e[ke + 24 >> 2] = (me << 2) + br, e[ke + 20 >> 2] = S, e[ke + 16 >> 2] = Q, !C)
                                                                break p;
                                                              Tr(C);
                                                              break d;
                                                            case 5:
                                                              if (y = e[l + 20 >> 2], l = e[l + 16 >> 2], e[5996] = 0, me = mf(36, I | 0, 7, l | 0, y | 0) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1)
                                                                break a;
                                                              if (C = e[ke + 20 >> 2], S = e[ke + 24 >> 2], C >>> 0 < S >>> 0) {
                                                                e[C >> 2] = me, e[ke + 20 >> 2] = C + 4;
                                                                break d;
                                                              }
                                                              if (l = e[ke + 16 >> 2], Q = C - l >> 2, y = Q + 1 | 0, y >>> 0 >= 1073741824) {
                                                                if (e[5996] = 0, jo(34), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                  break e;
                                                                break a;
                                                              }
                                                              if (S = S - l | 0, Ar = S >> 1, y = S >>> 0 >= 2147483644 ? 1073741823 : y >>> 0 < Ar >>> 0 ? Ar : y, y) {
                                                                if (y >>> 0 >= 1073741824) {
                                                                  if (e[5996] = 0, jo(35), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                    break e;
                                                                  break a;
                                                                }
                                                                if (e[5996] = 0, br = no(3, y << 2) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                  break a;
                                                              }
                                                              if (Q = (Q << 2) + br | 0, e[Q >> 2] = me, S = Q + 4 | 0, (l | 0) != (C | 0)) {
                                                                for (; Q = Q - 4 | 0, C = C - 4 | 0, e[Q >> 2] = e[C >> 2], (l | 0) != (C | 0); )
                                                                  ;
                                                                C = e[ke + 16 >> 2];
                                                              }
                                                              if (e[ke + 24 >> 2] = (y << 2) + br, e[ke + 20 >> 2] = S, e[ke + 16 >> 2] = Q, !C)
                                                                break p;
                                                              Tr(C);
                                                              break d;
                                                            case 4:
                                                              if (y = e[l + 20 >> 2], l = e[l + 16 >> 2], e[5996] = 0, me = mf(36, I | 0, 6, l | 0, y | 0) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1)
                                                                break s;
                                                              if (C = e[ke + 20 >> 2], S = e[ke + 24 >> 2], C >>> 0 < S >>> 0) {
                                                                e[C >> 2] = me, e[ke + 20 >> 2] = C + 4;
                                                                break d;
                                                              }
                                                              if (l = e[ke + 16 >> 2], Q = C - l >> 2, y = Q + 1 | 0, y >>> 0 >= 1073741824) {
                                                                if (e[5996] = 0, jo(34), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                  break e;
                                                                break s;
                                                              }
                                                              if (S = S - l | 0, Ar = S >> 1, y = S >>> 0 >= 2147483644 ? 1073741823 : y >>> 0 < Ar >>> 0 ? Ar : y, y) {
                                                                if (y >>> 0 >= 1073741824) {
                                                                  if (e[5996] = 0, jo(35), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                    break e;
                                                                  break s;
                                                                }
                                                                if (e[5996] = 0, br = no(3, y << 2) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                  break s;
                                                              }
                                                              if (Q = (Q << 2) + br | 0, e[Q >> 2] = me, S = Q + 4 | 0, (l | 0) != (C | 0)) {
                                                                for (; Q = Q - 4 | 0, C = C - 4 | 0, e[Q >> 2] = e[C >> 2], (l | 0) != (C | 0); )
                                                                  ;
                                                                C = e[ke + 16 >> 2];
                                                              }
                                                              if (e[ke + 24 >> 2] = (y << 2) + br, e[ke + 20 >> 2] = S, e[ke + 16 >> 2] = Q, !C)
                                                                break p;
                                                              Tr(C);
                                                              break d;
                                                            case 7:
                                                              if (y = e[l + 20 >> 2], l = e[l + 16 >> 2], e[5996] = 0, me = mf(36, I | 0, 8, l | 0, y | 0) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1)
                                                                break A;
                                                              if (C = e[ke + 20 >> 2], S = e[ke + 24 >> 2], C >>> 0 < S >>> 0) {
                                                                e[C >> 2] = me, e[ke + 20 >> 2] = C + 4;
                                                                break d;
                                                              }
                                                              if (l = e[ke + 16 >> 2], Q = C - l >> 2, y = Q + 1 | 0, y >>> 0 >= 1073741824) {
                                                                if (e[5996] = 0, jo(34), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                  break e;
                                                                break A;
                                                              }
                                                              if (S = S - l | 0, Ar = S >> 1, y = S >>> 0 >= 2147483644 ? 1073741823 : y >>> 0 < Ar >>> 0 ? Ar : y, y) {
                                                                if (y >>> 0 >= 1073741824) {
                                                                  if (e[5996] = 0, jo(35), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                    break e;
                                                                  break A;
                                                                }
                                                                if (e[5996] = 0, br = no(3, y << 2) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                  break A;
                                                              }
                                                              if (Q = (Q << 2) + br | 0, e[Q >> 2] = me, S = Q + 4 | 0, (l | 0) != (C | 0)) {
                                                                for (; Q = Q - 4 | 0, C = C - 4 | 0, e[Q >> 2] = e[C >> 2], (l | 0) != (C | 0); )
                                                                  ;
                                                                C = e[ke + 16 >> 2];
                                                              }
                                                              if (e[ke + 24 >> 2] = (y << 2) + br, e[ke + 20 >> 2] = S, e[ke + 16 >> 2] = Q, !C)
                                                                break p;
                                                              Tr(C);
                                                              break d;
                                                            case 6:
                                                              if (y = e[l + 20 >> 2], l = e[l + 16 >> 2], e[5996] = 0, me = mf(36, I | 0, 9, l | 0, y | 0) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1)
                                                                break u;
                                                              if (C = e[ke + 20 >> 2], S = e[ke + 24 >> 2], C >>> 0 < S >>> 0) {
                                                                e[C >> 2] = me, e[ke + 20 >> 2] = C + 4;
                                                                break d;
                                                              }
                                                              if (l = e[ke + 16 >> 2], Q = C - l >> 2, y = Q + 1 | 0, y >>> 0 >= 1073741824) {
                                                                if (e[5996] = 0, jo(34), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                  break e;
                                                                break u;
                                                              }
                                                              if (S = S - l | 0, Ar = S >> 1, y = S >>> 0 >= 2147483644 ? 1073741823 : y >>> 0 < Ar >>> 0 ? Ar : y, y) {
                                                                if (y >>> 0 >= 1073741824) {
                                                                  if (e[5996] = 0, jo(35), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                    break e;
                                                                  break u;
                                                                }
                                                                if (e[5996] = 0, br = no(3, y << 2) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                  break u;
                                                              }
                                                              if (Q = (Q << 2) + br | 0, e[Q >> 2] = me, S = Q + 4 | 0, (l | 0) != (C | 0)) {
                                                                for (; Q = Q - 4 | 0, C = C - 4 | 0, e[Q >> 2] = e[C >> 2], (l | 0) != (C | 0); )
                                                                  ;
                                                                C = e[ke + 16 >> 2];
                                                              }
                                                              if (e[ke + 24 >> 2] = (y << 2) + br, e[ke + 20 >> 2] = S, e[ke + 16 >> 2] = Q, !C)
                                                                break p;
                                                              Tr(C);
                                                              break d;
                                                            case 8:
                                                              if (C = e[l + 4 >> 2], (e[l + 8 >> 2] - C | 0) != 112)
                                                                break f;
                                                              e[5996] = 0, me = Ko(37, C | 0, y | 0, I | 0) | 0, C = e[5996], e[5996] = 0;
                                                              w: {
                                                                I: {
                                                                  l: {
                                                                    T: {
                                                                      m: {
                                                                        C: {
                                                                          D: {
                                                                            if ((C | 0) != 1) {
                                                                              if (l = e[l + 4 >> 2], e[5996] = 0, S = Ko(37, l + 56 | 0, y | 0, I | 0) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1)
                                                                                break D;
                                                                              if (!me | !S)
                                                                                break f;
                                                                              if (e[5996] = 0, l = no(3, 8) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                break T;
                                                                              if (e[l + 4 >> 2] = S, e[l >> 2] = me, e[5996] = 0, y = no(3, 56) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                                break l;
                                                                              if (e[y + 16 >> 2] = 0, e[y + 20 >> 2] = 0, e[y + 4 >> 2] = l, e[y >> 2] = 10, l = l + 8 | 0, e[y + 12 >> 2] = l, e[y + 8 >> 2] = l, e[y + 24 >> 2] = 0, e[y + 28 >> 2] = 0, e[y + 32 >> 2] = 0, e[y + 36 >> 2] = 0, e[y + 40 >> 2] = 0, e[y + 44 >> 2] = 0, e[5996] = 0, Co(33, I | 0, y | 0), l = e[5996], e[5996] = 0, (l | 0) == 1)
                                                                                break h;
                                                                              if (Q = e[ke + 20 >> 2], C = e[ke + 24 >> 2], Q >>> 0 >= C >>> 0)
                                                                                break C;
                                                                              e[Q >> 2] = y, e[ke + 20 >> 2] = Q + 4;
                                                                              break m;
                                                                            }
                                                                            I = gi() | 0;
                                                                            break r;
                                                                          }
                                                                          I = gi() | 0;
                                                                          break r;
                                                                        }
                                                                        if (Ar = e[ke + 16 >> 2], Qr = Q - Ar >> 2, l = Qr + 1 | 0, l >>> 0 >= 1073741824) {
                                                                          if (e[5996] = 0, jo(34), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                            break e;
                                                                          break h;
                                                                        }
                                                                        C = C - Ar | 0, br = C >> 1, br = C >>> 0 >= 2147483644 ? 1073741823 : l >>> 0 < br >>> 0 ? br : l;
                                                                        C: {
                                                                          if (!br) {
                                                                            l = 0;
                                                                            break C;
                                                                          }
                                                                          if (br >>> 0 >= 1073741824) {
                                                                            if (e[5996] = 0, jo(35), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                              break e;
                                                                            break h;
                                                                          }
                                                                          if (e[5996] = 0, l = no(3, br << 2) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                            break h;
                                                                        }
                                                                        if (C = (Qr << 2) + l | 0, e[C >> 2] = y, y = C + 4 | 0, (Q | 0) != (Ar | 0)) {
                                                                          for (; C = C - 4 | 0, Q = Q - 4 | 0, e[C >> 2] = e[Q >> 2], (Q | 0) != (Ar | 0); )
                                                                            ;
                                                                          Q = e[ke + 16 >> 2];
                                                                        }
                                                                        if (e[ke + 24 >> 2] = (br << 2) + l, e[ke + 20 >> 2] = y, e[ke + 16 >> 2] = C, !Q)
                                                                          break m;
                                                                        Tr(Q);
                                                                      }
                                                                      if (e[5996] = 0, y = no(3, 12) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1)
                                                                        break I;
                                                                      if (e[y + 4 >> 2] = S, e[y >> 2] = me, e[y + 8 >> 2] = e[6079], e[5996] = 0, l = no(3, 56) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                        break w;
                                                                      if (e[l + 16 >> 2] = 0, e[l + 20 >> 2] = 0, e[l + 4 >> 2] = y, e[l >> 2] = 12, e[l + 48 >> 2] = 0, e[l + 52 >> 2] = 1072693248, y = y + 12 | 0, e[l + 12 >> 2] = y, e[l + 8 >> 2] = y, e[l + 24 >> 2] = 0, e[l + 28 >> 2] = 0, e[l + 32 >> 2] = 0, e[l + 36 >> 2] = 0, e[l + 40 >> 2] = 0, e[l + 44 >> 2] = 0, e[5996] = 0, Co(33, I | 0, l | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                        break c;
                                                                      if (C = e[ke + 20 >> 2], S = e[ke + 24 >> 2], C >>> 0 < S >>> 0) {
                                                                        e[C >> 2] = l, e[ke + 20 >> 2] = C + 4;
                                                                        break d;
                                                                      }
                                                                      if (y = e[ke + 16 >> 2], Q = C - y >> 2, me = Q + 1 | 0, me >>> 0 >= 1073741824) {
                                                                        if (e[5996] = 0, jo(34), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                          break e;
                                                                        break c;
                                                                      }
                                                                      S = S - y | 0, Ar = S >> 1, me = S >>> 0 >= 2147483644 ? 1073741823 : me >>> 0 < Ar >>> 0 ? Ar : me;
                                                                      m: {
                                                                        if (!me) {
                                                                          br = 0;
                                                                          break m;
                                                                        }
                                                                        if (me >>> 0 >= 1073741824) {
                                                                          if (e[5996] = 0, jo(35), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                            break e;
                                                                          break c;
                                                                        }
                                                                        if (e[5996] = 0, br = no(3, me << 2) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                          break c;
                                                                      }
                                                                      if (Q = (Q << 2) + br | 0, e[Q >> 2] = l, S = Q + 4 | 0, (y | 0) != (C | 0)) {
                                                                        for (; Q = Q - 4 | 0, C = C - 4 | 0, e[Q >> 2] = e[C >> 2], (y | 0) != (C | 0); )
                                                                          ;
                                                                        C = e[ke + 16 >> 2];
                                                                      }
                                                                      if (e[ke + 24 >> 2] = (me << 2) + br, e[ke + 20 >> 2] = S, e[ke + 16 >> 2] = Q, !C)
                                                                        break p;
                                                                      Tr(C);
                                                                      break d;
                                                                    }
                                                                    I = gi() | 0;
                                                                    break r;
                                                                  }
                                                                  I = gi() | 0, Tr(l);
                                                                  break r;
                                                                }
                                                                I = gi() | 0;
                                                                break r;
                                                              }
                                                              I = gi() | 0, Tr(y);
                                                              break r;
                                                            case 9:
                                                              if (C = e[l + 4 >> 2], (e[l + 8 >> 2] - C | 0) != 112 || (me = e[l + 40 >> 2], S = e[me + 4 >> 2], Ar = e[me >> 2], br = Ar + S | 0, S >>> 0 > br >>> 0))
                                                                break f;
                                                              e[5996] = 0, me = Ko(37, C | 0, y | 0, I | 0) | 0, C = e[5996], e[5996] = 0;
                                                              w: {
                                                                I: {
                                                                  if ((C | 0) != 1) {
                                                                    if (C = e[l + 4 >> 2], e[5996] = 0, S = Ko(37, C + 56 | 0, y | 0, I | 0) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                      break I;
                                                                    if (!me | !S)
                                                                      break f;
                                                                    if (yn = +(Ar >>> 0) / +(br >>> 0), Q = e[l + 4 >> 2], e[Q >> 2] != 8)
                                                                      break g;
                                                                    if (C = e[Q + 4 >> 2], (e[Q + 8 >> 2] - C | 0) == 112)
                                                                      break w;
                                                                    break g;
                                                                  }
                                                                  I = gi() | 0;
                                                                  break r;
                                                                }
                                                                I = gi() | 0;
                                                                break r;
                                                              }
                                                              e[5996] = 0, Ar = Ko(37, C | 0, y | 0, I | 0) | 0, C = e[5996], e[5996] = 0;
                                                              w: {
                                                                I: {
                                                                  l: {
                                                                    if ((C | 0) != 1) {
                                                                      if (C = e[e[l + 4 >> 2] + 4 >> 2], e[5996] = 0, br = Ko(37, C + 56 | 0, y | 0, I | 0) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                        break l;
                                                                      if (Q = 0, !Ar | !br)
                                                                        break f;
                                                                      if (e[5996] = 0, C = no(3, 12) | 0, Q = e[5996], e[5996] = 0, (Q | 0) == 1)
                                                                        break I;
                                                                      if (e[ke + 28 >> 2] = C, Q = C + 12 | 0, e[ke + 36 >> 2] = Q, e[C + 8 >> 2] = S, e[C + 4 >> 2] = br, e[C >> 2] = Ar, e[5996] = 0, e[ke + 32 >> 2] = Q, C = tc(38, I | 0, 12, ke + 28 | 0, +yn) | 0, Q = e[5996], e[5996] = 0, (Q | 0) == 1 || (e[5996] = 0, Co(39, ke + 16 | 0, C | 0), C = e[5996], e[5996] = 0, (C | 0) == 1))
                                                                        break w;
                                                                      C = e[ke + 28 >> 2], C && Tr(C), Q = e[l + 4 >> 2];
                                                                      break g;
                                                                    }
                                                                    I = gi() | 0;
                                                                    break r;
                                                                  }
                                                                  I = gi() | 0;
                                                                  break r;
                                                                }
                                                                I = gi() | 0;
                                                                break r;
                                                              }
                                                              if (I = gi() | 0, l = e[ke + 28 >> 2], !l)
                                                                break r;
                                                              Tr(l);
                                                              break r;
                                                            case 0:
                                                              break f;
                                                            case 10:
                                                              break E;
                                                            default:
                                                              break d;
                                                          }
                                                        if (me = e[l + 4 >> 2], Ur = e[l + 8 >> 2], (me | 0) == (Ur | 0))
                                                          break R;
                                                        for (; ; ) {
                                                          E: {
                                                            if (e[5996] = 0, C = Ko(37, me | 0, y | 0, I | 0) | 0, Ar = e[5996], e[5996] = 0, (Ar | 0) == 1)
                                                              break E;
                                                            w: {
                                                              if (Q >>> 0 < br >>> 0) {
                                                                e[Q >> 2] = C, Q = Q + 4 | 0;
                                                                break w;
                                                              }
                                                              if (Ri = Q - S >> 2, Ar = Ri + 1 | 0, Ar >>> 0 >= 1073741824) {
                                                                if (e[5996] = 0, jo(34), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                  break e;
                                                                break _;
                                                              }
                                                              br = br - S | 0, Qr = br >> 1, Qr = br >>> 0 >= 2147483644 ? 1073741823 : Ar >>> 0 < Qr >>> 0 ? Qr : Ar;
                                                              I: {
                                                                if (!Qr) {
                                                                  br = 0;
                                                                  break I;
                                                                }
                                                                if (Qr >>> 0 >= 1073741824) {
                                                                  if (e[5996] = 0, jo(35), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                    break e;
                                                                  break _;
                                                                }
                                                                if (e[5996] = 0, br = no(3, Qr << 2) | 0, Ar = e[5996], e[5996] = 0, (Ar | 0) == 1)
                                                                  break E;
                                                              }
                                                              if (Ar = (Ri << 2) + br | 0, e[Ar >> 2] = C, C = Ar, (Q | 0) != (S | 0))
                                                                for (; C = C - 4 | 0, Q = Q - 4 | 0, e[C >> 2] = e[Q >> 2], (Q | 0) != (S | 0); )
                                                                  ;
                                                              br = (Qr << 2) + br | 0, Q = Ar + 4 | 0, S && Tr(S), S = C;
                                                            }
                                                            if (me = me + 56 | 0, (Ur | 0) != (me | 0))
                                                              continue;
                                                            break k;
                                                          }
                                                          break;
                                                        }
                                                        I = gi() | 0;
                                                        break v;
                                                      }
                                                      I = gi() | 0, Tr(y);
                                                      break r;
                                                    }
                                                    if ((Q | 0) == (S | 0)) {
                                                      S = Q;
                                                      break R;
                                                    }
                                                    for (C = S; ; ) {
                                                      if (e[C >> 2]) {
                                                        if (C = C + 4 | 0, (Q | 0) != (C | 0))
                                                          continue;
                                                        break R;
                                                      }
                                                      break;
                                                    }
                                                    if (Q = 0, !S)
                                                      break f;
                                                    Tr(S);
                                                    break f;
                                                  }
                                                  R: {
                                                    k: {
                                                      Ri = e[l + 8 >> 2], Ar = e[l + 4 >> 2];
                                                      S: {
                                                        if ((Ri - Ar | 0) / 56 >>> 0 > 20)
                                                          break S;
                                                        E: {
                                                          w: {
                                                            if ((Ar | 0) != (Ri | 0)) {
                                                              for (C = Ar; ; ) {
                                                                if (e[C >> 2] != 1)
                                                                  break S;
                                                                if (C = C + 56 | 0, (Ri | 0) == (C | 0))
                                                                  break;
                                                              }
                                                              break w;
                                                            }
                                                            e[ke + 12 >> 2] = 0, e[ke + 4 >> 2] = 0, e[ke + 8 >> 2] = 0;
                                                            break E;
                                                          }
                                                          for (e[ke + 12 >> 2] = 0, e[ke + 4 >> 2] = 0, e[ke + 8 >> 2] = 0, Wn = ke + 12 | 0; ; ) {
                                                            y = e[Ar + 28 >> 2];
                                                            w: {
                                                              I: {
                                                                if (C = e[ke + 8 >> 2], (C | 0) != e[ke + 12 >> 2]) {
                                                                  if (Se[y + 11 | 0] >= 0) {
                                                                    me = e[y + 4 >> 2], e[C >> 2] = e[y >> 2], e[C + 4 >> 2] = me, e[C + 8 >> 2] = e[y + 8 >> 2];
                                                                    break I;
                                                                  }
                                                                  if (me = e[y + 4 >> 2], y = e[y >> 2], e[5996] = 0, Ms(40, C | 0, y | 0, me | 0), y = e[5996], e[5996] = 0, (y | 0) != 1)
                                                                    break I;
                                                                  I = gi() | 0, e[ke + 8 >> 2] = C;
                                                                  break R;
                                                                }
                                                                l: {
                                                                  T: {
                                                                    m: {
                                                                      C: {
                                                                        me = e[ke + 4 >> 2], Qr = (C - me | 0) / 12 | 0, Ur = Qr + 1 | 0;
                                                                        D: {
                                                                          if (Ur >>> 0 >= 357913942) {
                                                                            e[5996] = 0, jo(41);
                                                                            break D;
                                                                          }
                                                                          if (e[ke + 44 >> 2] = Wn, Xr = Qr << 1, Xr = Qr >>> 0 >= 178956970 ? 357913941 : Ur >>> 0 < Xr >>> 0 ? Xr : Ur, !Xr) {
                                                                            Ur = 0;
                                                                            break m;
                                                                          }
                                                                          if (Xr >>> 0 < 357913942)
                                                                            break C;
                                                                          e[5996] = 0, jo(35);
                                                                        }
                                                                        if (l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                          break e;
                                                                        I = gi() | 0;
                                                                        break R;
                                                                      }
                                                                      if (e[5996] = 0, Ur = no(3, No(Xr, 12) | 0) | 0, En = e[5996], e[5996] = 0, (En | 0) == 1)
                                                                        break T;
                                                                    }
                                                                    e[ke + 28 >> 2] = Ur, Qr = No(Qr, 12) + Ur | 0, e[ke + 36 >> 2] = Qr, Ur = No(Xr, 12) + Ur | 0, e[ke + 40 >> 2] = Ur, e[ke + 32 >> 2] = Qr;
                                                                    m: {
                                                                      if (Se[y + 11 | 0] >= 0) {
                                                                        Xr = e[y + 4 >> 2], e[Qr >> 2] = e[y >> 2], e[Qr + 4 >> 2] = Xr, e[Qr + 8 >> 2] = e[y + 8 >> 2];
                                                                        break m;
                                                                      }
                                                                      if (C = e[y + 4 >> 2], y = e[y >> 2], e[5996] = 0, Ms(40, Qr | 0, y | 0, C | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                        break l;
                                                                      me = e[ke + 4 >> 2], C = e[ke + 8 >> 2];
                                                                    }
                                                                    if (Xr = Qr + 12 | 0, (C | 0) == (me | 0))
                                                                      y = me;
                                                                    else {
                                                                      for (; C = C - 12 | 0, En = e[C + 4 >> 2], Qr = Qr - 12 | 0, y = Qr, e[y >> 2] = e[C >> 2], e[y + 4 >> 2] = En, e[y + 8 >> 2] = e[C + 8 >> 2], e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[C + 8 >> 2] = 0, (C | 0) != (me | 0); )
                                                                        ;
                                                                      me = e[ke + 8 >> 2], y = e[ke + 4 >> 2];
                                                                    }
                                                                    if (e[ke + 32 >> 2] = y, e[ke + 4 >> 2] = Qr, e[ke + 8 >> 2] = Xr, C = e[ke + 12 >> 2], e[ke + 12 >> 2] = Ur, e[ke + 40 >> 2] = C, e[ke + 28 >> 2] = y, (y | 0) != (me | 0)) {
                                                                      for (; C = me - 12 | 0, e[ke + 36 >> 2] = C, Se[me - 1 | 0] < 0 && Tr(e[C >> 2]), me = C, (C | 0) != (y | 0); )
                                                                        ;
                                                                      me = y;
                                                                    }
                                                                    if (!me)
                                                                      break w;
                                                                    Tr(me);
                                                                    break w;
                                                                  }
                                                                  I = gi() | 0;
                                                                  break R;
                                                                }
                                                                if (I = gi() | 0, l = e[ke + 36 >> 2], C = e[ke + 32 >> 2], (l | 0) != (C | 0))
                                                                  for (; y = l - 12 | 0, e[ke + 36 >> 2] = y, Se[l - 1 | 0] >= 0 ? l = y : (Tr(e[y >> 2]), l = e[ke + 36 >> 2]), (C | 0) != (l | 0); )
                                                                    ;
                                                                l = e[ke + 28 >> 2], l && Tr(l);
                                                                break R;
                                                              }
                                                              e[ke + 8 >> 2] = C + 12;
                                                            }
                                                            if (Ar = Ar + 56 | 0, (Ri | 0) == (Ar | 0))
                                                              break;
                                                          }
                                                        }
                                                        if (y = e[l + 52 >> 2], e[5996] = 0, Ar = no(3, 56) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1 || (C = e[ke + 12 >> 2], e[ke + 12 >> 2] = 0, me = e[ke + 4 >> 2], Qr = e[ke + 8 >> 2], e[ke + 4 >> 2] = 0, e[ke + 8 >> 2] = 0, e[Ar + 4 >> 2] = 0, e[Ar + 8 >> 2] = 0, e[Ar >> 2] = 3, e[Ar + 12 >> 2] = 0, e[Ar + 40 >> 2] = y, e[Ar + 44 >> 2] = 0, e[Ar + 36 >> 2] = 0, e[Ar + 28 >> 2] = 0, e[Ar + 32 >> 2] = 0, e[Ar + 24 >> 2] = C, e[Ar + 16 >> 2] = me, e[Ar + 20 >> 2] = Qr, e[5996] = 0, Co(33, I | 0, Ar | 0), y = e[5996], e[5996] = 0, (y | 0) == 1))
                                                          break k;
                                                        C = e[ke + 20 >> 2], Qr = e[ke + 24 >> 2];
                                                        E: {
                                                          if (C >>> 0 < Qr >>> 0) {
                                                            e[C >> 2] = Ar, e[ke + 20 >> 2] = C + 4;
                                                            break E;
                                                          }
                                                          if (y = e[ke + 16 >> 2], Ri = C - y >> 2, me = Ri + 1 | 0, me >>> 0 >= 1073741824) {
                                                            if (e[5996] = 0, jo(34), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                              break e;
                                                            break k;
                                                          }
                                                          Qr = Qr - y | 0, Ur = Qr >> 1, Qr = Qr >>> 0 >= 2147483644 ? 1073741823 : me >>> 0 < Ur >>> 0 ? Ur : me;
                                                          w: {
                                                            if (!Qr) {
                                                              Ur = 0;
                                                              break w;
                                                            }
                                                            if (Qr >>> 0 >= 1073741824) {
                                                              if (e[5996] = 0, jo(35), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                break e;
                                                              break k;
                                                            }
                                                            if (e[5996] = 0, Ur = no(3, Qr << 2) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                              break k;
                                                          }
                                                          if (me = (Ri << 2) + Ur | 0, e[me >> 2] = Ar, Ar = me + 4 | 0, (y | 0) != (C | 0)) {
                                                            for (; me = me - 4 | 0, C = C - 4 | 0, e[me >> 2] = e[C >> 2], (y | 0) != (C | 0); )
                                                              ;
                                                            C = e[ke + 16 >> 2];
                                                          }
                                                          if (e[ke + 24 >> 2] = (Qr << 2) + Ur, e[ke + 20 >> 2] = Ar, e[ke + 16 >> 2] = me, !C)
                                                            break E;
                                                          Tr(C);
                                                        }
                                                        if (y = e[ke + 4 >> 2], !y)
                                                          break S;
                                                        if (C = y, me = e[ke + 8 >> 2], (C | 0) != (me | 0)) {
                                                          for (; C = me - 12 | 0, Se[me - 1 | 0] < 0 && Tr(e[C >> 2]), me = C, (C | 0) != (y | 0); )
                                                            ;
                                                          C = e[ke + 4 >> 2];
                                                        }
                                                        e[ke + 8 >> 2] = y, Tr(C);
                                                      }
                                                      y = e[l + 52 >> 2];
                                                      S: {
                                                        if ((y | 0) != 1 & (y | 0) != ((e[l + 8 >> 2] - e[l + 4 >> 2] | 0) / 56 | 0))
                                                          break S;
                                                        E: {
                                                          w: {
                                                            I: {
                                                              l: {
                                                                T: {
                                                                  m: {
                                                                    if (y = Q - S | 0, y >>> 0 >= 5)
                                                                      for (; ; ) {
                                                                        if (Qr = e[l + 52 >> 2], e[5996] = 0, Ar = no(3, 8) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                          break m;
                                                                        if (C = Q - 8 | 0, e[Ar >> 2] = e[C >> 2], Q = Q - 4 | 0, e[Ar + 4 >> 2] = e[Q >> 2], e[5996] = 0, me = no(3, 56) | 0, Ur = e[5996], e[5996] = 0, (Ur | 0) == 1)
                                                                          break T;
                                                                        if (e[me + 16 >> 2] = 0, e[me + 20 >> 2] = 0, e[me + 4 >> 2] = Ar, e[me >> 2] = (Qr | 0) == 1 ? 11 : 10, Ar = Ar + 8 | 0, e[me + 12 >> 2] = Ar, e[me + 8 >> 2] = Ar, e[me + 24 >> 2] = 0, e[me + 28 >> 2] = 0, e[me + 32 >> 2] = 0, e[me + 36 >> 2] = 0, e[me + 40 >> 2] = 0, e[me + 44 >> 2] = 0, zo[me + 48 >> 3] = 1 / +(y >> 2 >>> 0), e[5996] = 0, Co(33, I | 0, me | 0), y = e[5996], e[5996] = 0, (y | 0) == 1) {
                                                                          I = gi() | 0;
                                                                          break v;
                                                                        }
                                                                        if (e[5996] = 0, Ar = no(3, 4) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                          break l;
                                                                        if (e[Ar >> 2] = me, e[5996] = 0, y = no(3, 56) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                                          break w;
                                                                        if (e[y + 16 >> 2] = 0, e[y + 20 >> 2] = 0, e[y + 4 >> 2] = Ar, e[y >> 2] = 21, me = Ar + 4 | 0, e[y + 12 >> 2] = me, e[y + 8 >> 2] = me, e[y + 24 >> 2] = 0, e[y + 28 >> 2] = 0, e[y + 32 >> 2] = 0, e[y + 36 >> 2] = 0, e[y + 40 >> 2] = 0, e[y + 44 >> 2] = 0, e[5996] = 0, Co(33, I | 0, y | 0), me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                                          break I;
                                                                        C: {
                                                                          if (C >>> 0 < br >>> 0) {
                                                                            e[C >> 2] = y;
                                                                            break C;
                                                                          }
                                                                          D: {
                                                                            b: {
                                                                              Ar = C - S >> 2, me = Ar + 1 | 0;
                                                                              B: {
                                                                                if (me >>> 0 >= 1073741824) {
                                                                                  e[5996] = 0, jo(34);
                                                                                  break B;
                                                                                }
                                                                                if (Q = br - S | 0, br = Q >> 1, Q = Q >>> 0 >= 2147483644 ? 1073741823 : me >>> 0 < br >>> 0 ? br : me, !Q) {
                                                                                  br = 0;
                                                                                  break D;
                                                                                }
                                                                                if (Q >>> 0 < 1073741824)
                                                                                  break b;
                                                                                e[5996] = 0, jo(35);
                                                                              }
                                                                              if (l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                                break e;
                                                                              I = gi() | 0;
                                                                              break v;
                                                                            }
                                                                            if (e[5996] = 0, br = no(3, Q << 2) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                                              break I;
                                                                          }
                                                                          me = (Ar << 2) + br | 0, e[me >> 2] = y, br = (Q << 2) + br | 0, Q = me + 4 | 0;
                                                                          D: {
                                                                            if ((C | 0) != (S | 0)) {
                                                                              for (; me = me - 4 | 0, C = C - 4 | 0, e[me >> 2] = e[C >> 2], (C | 0) != (S | 0); )
                                                                                ;
                                                                              if (!S)
                                                                                break D;
                                                                            }
                                                                            Tr(S);
                                                                          }
                                                                          S = me;
                                                                        }
                                                                        if (y = Q - S | 0, !(y >>> 0 > 4))
                                                                          break;
                                                                      }
                                                                    if (br = e[S >> 2], C = e[ke + 20 >> 2], (C | 0) == e[ke + 24 >> 2])
                                                                      break E;
                                                                    e[C >> 2] = br, e[ke + 20 >> 2] = C + 4;
                                                                    break S;
                                                                  }
                                                                  I = gi() | 0;
                                                                  break v;
                                                                }
                                                                I = gi() | 0, Tr(Ar);
                                                                break v;
                                                              }
                                                              I = gi() | 0;
                                                              break v;
                                                            }
                                                            I = gi() | 0;
                                                            break v;
                                                          }
                                                          I = gi() | 0, Tr(Ar);
                                                          break v;
                                                        }
                                                        if (Qr = e[ke + 16 >> 2], y = C - Qr | 0, Ur = y >> 2, me = Ur + 1 | 0, me >>> 0 >= 1073741824) {
                                                          if (e[5996] = 0, jo(34), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                            break e;
                                                          break _;
                                                        }
                                                        Ar = y >> 1, y = y >>> 0 >= 2147483644 ? 1073741823 : me >>> 0 < Ar >>> 0 ? Ar : me;
                                                        E: {
                                                          if (!y) {
                                                            Ar = 0;
                                                            break E;
                                                          }
                                                          if (y >>> 0 >= 1073741824) {
                                                            if (e[5996] = 0, jo(35), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                              break e;
                                                            break _;
                                                          }
                                                          if (e[5996] = 0, Ar = no(3, y << 2) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                            break _;
                                                        }
                                                        if (me = (Ur << 2) + Ar | 0, e[me >> 2] = br, br = me + 4 | 0, (C | 0) != (Qr | 0)) {
                                                          for (; me = me - 4 | 0, C = C - 4 | 0, e[me >> 2] = e[C >> 2], (C | 0) != (Qr | 0); )
                                                            ;
                                                          C = e[ke + 16 >> 2];
                                                        }
                                                        if (e[ke + 24 >> 2] = (y << 2) + Ar, e[ke + 20 >> 2] = br, e[ke + 16 >> 2] = me, !C)
                                                          break S;
                                                        Tr(C);
                                                      }
                                                      br = e[l + 52 >> 2], y = 0, e[5996] = 0, l = no(3, 56) | 0, C = e[5996], e[5996] = 0;
                                                      S: {
                                                        E: {
                                                          if ((C | 0) == 1)
                                                            break E;
                                                          if (me = Q - S | 0, Qr = me >> 2, Ar = 0, C = 0, (Q | 0) != (S | 0)) {
                                                            if ((me | 0) < 0) {
                                                              if (e[5996] = 0, jo(34), y = e[5996], e[5996] = 0, (y | 0) != 1)
                                                                break e;
                                                              break S;
                                                            }
                                                            if (e[5996] = 0, C = no(3, me | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                              break S;
                                                            me = (me - 4 & -4) + 4 | 0, Q = Sa(C, S, me), y = Q + (Qr << 2) | 0, Ar = Q + me | 0;
                                                          }
                                                          if (e[l + 16 >> 2] = 0, e[l + 20 >> 2] = 0, e[l + 4 >> 2] = C, e[l >> 2] = 13, zo[l + 48 >> 3] = +(br >>> 0) / +(Qr >>> 0), e[l + 12 >> 2] = y, e[l + 8 >> 2] = Ar, e[l + 24 >> 2] = 0, e[l + 28 >> 2] = 0, e[l + 32 >> 2] = 0, e[l + 36 >> 2] = 0, e[l + 40 >> 2] = br, e[l + 44 >> 2] = 0, e[5996] = 0, Co(33, I | 0, l | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                            break E;
                                                          Q = e[ke + 20 >> 2], C = e[ke + 24 >> 2];
                                                          w: {
                                                            if (Q >>> 0 < C >>> 0) {
                                                              e[Q >> 2] = l, e[ke + 20 >> 2] = Q + 4;
                                                              break w;
                                                            }
                                                            if (me = e[ke + 16 >> 2], br = Q - me >> 2, y = br + 1 | 0, y >>> 0 >= 1073741824) {
                                                              if (e[5996] = 0, jo(34), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                break e;
                                                              break E;
                                                            }
                                                            C = C - me | 0, Ar = C >> 1, Ar = C >>> 0 >= 2147483644 ? 1073741823 : y >>> 0 < Ar >>> 0 ? Ar : y;
                                                            I: {
                                                              if (!Ar) {
                                                                y = 0;
                                                                break I;
                                                              }
                                                              if (Ar >>> 0 >= 1073741824) {
                                                                if (e[5996] = 0, jo(35), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                  break e;
                                                                break E;
                                                              }
                                                              if (e[5996] = 0, y = no(3, Ar << 2) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                break E;
                                                            }
                                                            if (C = (br << 2) + y | 0, e[C >> 2] = l, l = C + 4 | 0, (Q | 0) != (me | 0)) {
                                                              for (; C = C - 4 | 0, Q = Q - 4 | 0, e[C >> 2] = e[Q >> 2], (Q | 0) != (me | 0); )
                                                                ;
                                                              Q = e[ke + 16 >> 2];
                                                            }
                                                            if (e[ke + 24 >> 2] = (Ar << 2) + y, e[ke + 20 >> 2] = l, e[ke + 16 >> 2] = C, !Q)
                                                              break w;
                                                            Tr(Q);
                                                          }
                                                          if (!S)
                                                            break d;
                                                          Tr(S);
                                                          break d;
                                                        }
                                                        I = gi() | 0;
                                                        break v;
                                                      }
                                                      I = gi() | 0, Tr(l);
                                                      break v;
                                                    }
                                                    I = gi() | 0;
                                                  }
                                                  hf(ke + 4 | 0);
                                                  break v;
                                                }
                                                I = gi() | 0;
                                              }
                                              if (!S)
                                                break r;
                                              Tr(S);
                                              break r;
                                            }
                                            g: {
                                              v: {
                                                _: {
                                                  R: {
                                                    k: {
                                                      S: {
                                                        E: {
                                                          w: {
                                                            I: {
                                                              if (e[Q + 56 >> 2] != 8 || (C = e[Q + 60 >> 2], (e[Q - -64 >> 2] - C | 0) != 112))
                                                                break I;
                                                              if (e[5996] = 0, C = Ko(37, C | 0, y | 0, I | 0) | 0, Q = e[5996], e[5996] = 0, (Q | 0) == 1)
                                                                break w;
                                                              if (l = e[e[l + 4 >> 2] + 60 >> 2], e[5996] = 0, y = Ko(37, l + 56 | 0, y | 0, I | 0) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1)
                                                                break E;
                                                              if (Q = 0, !C | !y)
                                                                break f;
                                                              if (e[5996] = 0, l = no(3, 12) | 0, Q = e[5996], e[5996] = 0, (Q | 0) == 1)
                                                                break S;
                                                              if (e[ke + 28 >> 2] = l, Q = l + 12 | 0, e[ke + 36 >> 2] = Q, e[l + 8 >> 2] = me, e[l + 4 >> 2] = y, e[l >> 2] = C, e[5996] = 0, e[ke + 32 >> 2] = Q, l = ha(42, I | 0, ke + 28 | 0, +(1 - yn)) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1 || (e[5996] = 0, Co(39, ke + 16 | 0, l | 0), l = e[5996], e[5996] = 0, (l | 0) == 1))
                                                                break k;
                                                              if (l = e[ke + 28 >> 2], !l)
                                                                break I;
                                                              Tr(l);
                                                            }
                                                            if (e[5996] = 0, l = no(3, 12) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                              break R;
                                                            if (e[ke + 28 >> 2] = l, y = l + 12 | 0, e[ke + 36 >> 2] = y, e[l >> 2] = me, C = e[6080], e[l + 8 >> 2] = S, e[l + 4 >> 2] = C, e[5996] = 0, e[ke + 32 >> 2] = y, l = tc(38, I | 0, 12, ke + 28 | 0, +yn) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1 || (e[5996] = 0, Co(39, ke + 16 | 0, l | 0), l = e[5996], e[5996] = 0, (l | 0) == 1))
                                                              break _;
                                                            if (l = e[ke + 28 >> 2], l && Tr(l), e[5996] = 0, l = no(3, 8) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                              break v;
                                                            if (e[ke + 28 >> 2] = l, y = l + 8 | 0, e[ke + 36 >> 2] = y, e[l + 4 >> 2] = S, e[l >> 2] = me, e[5996] = 0, e[ke + 32 >> 2] = y, l = tc(38, I | 0, 11, ke + 28 | 0, +yn) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1 || (e[5996] = 0, Co(39, ke + 16 | 0, l | 0), l = e[5996], e[5996] = 0, (l | 0) == 1))
                                                              break g;
                                                            if (l = e[ke + 28 >> 2], !l)
                                                              break d;
                                                            Tr(l);
                                                            break d;
                                                          }
                                                          I = gi() | 0;
                                                          break r;
                                                        }
                                                        I = gi() | 0;
                                                        break r;
                                                      }
                                                      I = gi() | 0;
                                                      break r;
                                                    }
                                                    if (I = gi() | 0, l = e[ke + 28 >> 2], !l)
                                                      break r;
                                                    Tr(l);
                                                    break r;
                                                  }
                                                  I = gi() | 0;
                                                  break r;
                                                }
                                                if (I = gi() | 0, l = e[ke + 28 >> 2], !l)
                                                  break r;
                                                Tr(l);
                                                break r;
                                              }
                                              I = gi() | 0;
                                              break r;
                                            }
                                            if (I = gi() | 0, l = e[ke + 28 >> 2], !l)
                                              break r;
                                            Tr(l);
                                            break r;
                                          }
                                          S = e[ke + 20 >> 2], Q = e[ke + 16 >> 2];
                                        }
                                        p: {
                                          d: {
                                            g: {
                                              v: {
                                                if ((S - Q | 0) == 4)
                                                  break v;
                                                if (y = e[ke + 24 >> 2], e[ke + 24 >> 2] = 0, e[ke + 16 >> 2] = 0, e[ke + 20 >> 2] = 0, e[5996] = 0, l = no(3, 56) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                  break g;
                                                if (e[l + 16 >> 2] = 0, e[l + 20 >> 2] = 0, e[l + 4 >> 2] = Q, e[l >> 2] = 20, e[l + 12 >> 2] = y, e[l + 8 >> 2] = S, e[l + 24 >> 2] = 0, e[l + 28 >> 2] = 0, e[l + 32 >> 2] = 0, e[l + 36 >> 2] = 0, e[l + 40 >> 2] = 0, e[l + 44 >> 2] = 0, e[5996] = 0, Co(33, I | 0, l | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                  break p;
                                                if (Q = e[ke + 20 >> 2], me = e[ke + 24 >> 2], Q >>> 0 < me >>> 0) {
                                                  e[Q >> 2] = l, e[ke + 20 >> 2] = Q + 4;
                                                  break v;
                                                }
                                                if (y = e[ke + 16 >> 2], S = Q - y >> 2, C = S + 1 | 0, C >>> 0 >= 1073741824) {
                                                  if (e[5996] = 0, jo(34), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                    break e;
                                                  break p;
                                                }
                                                me = me - y | 0, Ar = me >> 1, me = me >>> 0 >= 2147483644 ? 1073741823 : C >>> 0 < Ar >>> 0 ? Ar : C;
                                                _: {
                                                  if (!me) {
                                                    br = 0;
                                                    break _;
                                                  }
                                                  if (me >>> 0 >= 1073741824) {
                                                    if (e[5996] = 0, jo(35), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                      break e;
                                                    break p;
                                                  }
                                                  if (e[5996] = 0, br = no(3, me << 2) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                    break p;
                                                }
                                                if (C = (S << 2) + br | 0, e[C >> 2] = l, l = C + 4 | 0, (y | 0) != (Q | 0)) {
                                                  for (; C = C - 4 | 0, Q = Q - 4 | 0, e[C >> 2] = e[Q >> 2], (y | 0) != (Q | 0); )
                                                    ;
                                                  Q = e[ke + 16 >> 2];
                                                }
                                                if (e[ke + 24 >> 2] = (me << 2) + br, e[ke + 20 >> 2] = l, e[ke + 16 >> 2] = C, !Q)
                                                  break v;
                                                Tr(Q);
                                              }
                                              if (e[5996] = 0, Q = no(3, 56) | 0, l = e[5996], e[5996] = 0, (l | 0) != 1 && (l = e[ke + 24 >> 2], e[ke + 24 >> 2] = 0, y = e[ke + 16 >> 2], C = e[ke + 20 >> 2], e[ke + 16 >> 2] = 0, e[ke + 20 >> 2] = 0, e[Q + 16 >> 2] = 0, e[Q + 20 >> 2] = 0, e[Q + 12 >> 2] = l, e[Q + 4 >> 2] = y, e[Q + 8 >> 2] = C, e[Q >> 2] = 21, e[Q + 24 >> 2] = 0, e[Q + 28 >> 2] = 0, e[Q + 32 >> 2] = 0, e[Q + 36 >> 2] = 0, e[Q + 40 >> 2] = 0, e[Q + 44 >> 2] = 0, e[5996] = 0, Co(33, I | 0, Q | 0), l = e[5996], e[5996] = 0, (l | 0) != 1))
                                                break d;
                                              I = gi() | 0;
                                              break r;
                                            }
                                            if (I = gi() | 0, !Q)
                                              break t;
                                            Tr(Q);
                                            break r;
                                          }
                                          if (e[5996] = 0, y = no(3, 4) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) {
                                            I = gi() | 0;
                                            break r;
                                          }
                                          e[y >> 2] = Q, e[5996] = 0, l = no(3, 56) | 0, C = e[5996], e[5996] = 0;
                                          d: {
                                            g: {
                                              v: {
                                                _: {
                                                  R: {
                                                    k: {
                                                      S: {
                                                        E: {
                                                          w: {
                                                            I: {
                                                              l: {
                                                                T: {
                                                                  m: {
                                                                    C: {
                                                                      D: {
                                                                        if ((C | 0) != 1) {
                                                                          if (e[l + 16 >> 2] = 0, e[l + 20 >> 2] = 0, e[l + 4 >> 2] = y, e[l >> 2] = 15, y = y + 4 | 0, e[l + 12 >> 2] = y, e[l + 8 >> 2] = y, e[l + 24 >> 2] = 0, e[l + 28 >> 2] = 0, e[l + 32 >> 2] = 0, e[l + 36 >> 2] = 0, e[l + 40 >> 2] = 0, e[l + 44 >> 2] = 0, e[5996] = 0, Co(33, I | 0, l | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                            break d;
                                                                          C = e[Q + 8 >> 2], S = e[Q + 12 >> 2];
                                                                          b: {
                                                                            if (C >>> 0 < S >>> 0) {
                                                                              e[C >> 2] = l, e[Q + 8 >> 2] = C + 4;
                                                                              break b;
                                                                            }
                                                                            if (me = e[Q + 4 >> 2], br = C - me >> 2, y = br + 1 | 0, y >>> 0 >= 1073741824) {
                                                                              if (e[5996] = 0, jo(34), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                                break e;
                                                                              break d;
                                                                            }
                                                                            S = S - me | 0, Ar = S >> 1, Ar = S >>> 0 >= 2147483644 ? 1073741823 : y >>> 0 < Ar >>> 0 ? Ar : y;
                                                                            B: {
                                                                              if (!Ar) {
                                                                                y = 0;
                                                                                break B;
                                                                              }
                                                                              if (Ar >>> 0 >= 1073741824) {
                                                                                if (e[5996] = 0, jo(35), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                                  break e;
                                                                                break d;
                                                                              }
                                                                              if (e[5996] = 0, y = no(3, Ar << 2) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                break d;
                                                                            }
                                                                            if (S = (br << 2) + y | 0, e[S >> 2] = l, l = S + 4 | 0, (C | 0) != (me | 0)) {
                                                                              for (; S = S - 4 | 0, C = C - 4 | 0, e[S >> 2] = e[C >> 2], (C | 0) != (me | 0); )
                                                                                ;
                                                                              C = e[Q + 4 >> 2];
                                                                            }
                                                                            if (e[Q + 12 >> 2] = (Ar << 2) + y, e[Q + 8 >> 2] = l, e[Q + 4 >> 2] = S, !C)
                                                                              break b;
                                                                            Tr(C);
                                                                          }
                                                                          if (e[5996] = 0, y = no(3, 4) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) {
                                                                            I = gi() | 0;
                                                                            break r;
                                                                          }
                                                                          if (e[y >> 2] = Q, e[5996] = 0, l = no(3, 56) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                            break D;
                                                                          if (e[l + 16 >> 2] = 0, e[l + 20 >> 2] = 0, e[l + 4 >> 2] = y, e[l >> 2] = 17, y = y + 4 | 0, e[l + 12 >> 2] = y, e[l + 8 >> 2] = y, e[l + 24 >> 2] = 0, e[l + 28 >> 2] = 0, e[l + 32 >> 2] = 0, e[l + 36 >> 2] = 0, e[l + 40 >> 2] = 0, e[l + 44 >> 2] = 0, e[5996] = 0, Co(33, I | 0, l | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                            break g;
                                                                          C = e[Q + 8 >> 2], S = e[Q + 12 >> 2];
                                                                          b: {
                                                                            if (C >>> 0 < S >>> 0) {
                                                                              e[C >> 2] = l, e[Q + 8 >> 2] = C + 4;
                                                                              break b;
                                                                            }
                                                                            if (me = e[Q + 4 >> 2], br = C - me >> 2, y = br + 1 | 0, y >>> 0 >= 1073741824) {
                                                                              if (e[5996] = 0, jo(34), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                                break e;
                                                                              break g;
                                                                            }
                                                                            S = S - me | 0, Ar = S >> 1, Ar = S >>> 0 >= 2147483644 ? 1073741823 : y >>> 0 < Ar >>> 0 ? Ar : y;
                                                                            B: {
                                                                              if (!Ar) {
                                                                                y = 0;
                                                                                break B;
                                                                              }
                                                                              if (Ar >>> 0 >= 1073741824) {
                                                                                if (e[5996] = 0, jo(35), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                                  break e;
                                                                                break g;
                                                                              }
                                                                              if (e[5996] = 0, y = no(3, Ar << 2) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                break g;
                                                                            }
                                                                            if (S = (br << 2) + y | 0, e[S >> 2] = l, l = S + 4 | 0, (C | 0) != (me | 0)) {
                                                                              for (; S = S - 4 | 0, C = C - 4 | 0, e[S >> 2] = e[C >> 2], (C | 0) != (me | 0); )
                                                                                ;
                                                                              C = e[Q + 4 >> 2];
                                                                            }
                                                                            if (e[Q + 12 >> 2] = (Ar << 2) + y, e[Q + 8 >> 2] = l, e[Q + 4 >> 2] = S, !C)
                                                                              break b;
                                                                            Tr(C);
                                                                          }
                                                                          if (e[5996] = 0, l = e[6080], y = no(3, 8) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1) {
                                                                            I = gi() | 0;
                                                                            break r;
                                                                          }
                                                                          if (e[y + 4 >> 2] = l, e[y >> 2] = Q, e[5996] = 0, l = no(3, 56) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                            break C;
                                                                          if (e[l + 16 >> 2] = 0, e[l + 20 >> 2] = 0, e[l + 4 >> 2] = y, e[l >> 2] = 10, y = y + 8 | 0, e[l + 12 >> 2] = y, e[l + 8 >> 2] = y, e[l + 24 >> 2] = 0, e[l + 28 >> 2] = 0, e[l + 32 >> 2] = 0, e[l + 36 >> 2] = 0, e[l + 40 >> 2] = 0, e[l + 44 >> 2] = 0, e[5996] = 0, Co(33, I | 0, l | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                            break v;
                                                                          C = e[Q + 8 >> 2], S = e[Q + 12 >> 2];
                                                                          b: {
                                                                            if (C >>> 0 < S >>> 0) {
                                                                              e[C >> 2] = l, e[Q + 8 >> 2] = C + 4;
                                                                              break b;
                                                                            }
                                                                            if (me = e[Q + 4 >> 2], br = C - me >> 2, y = br + 1 | 0, y >>> 0 >= 1073741824) {
                                                                              if (e[5996] = 0, jo(34), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                                break e;
                                                                              break v;
                                                                            }
                                                                            S = S - me | 0, Ar = S >> 1, Ar = S >>> 0 >= 2147483644 ? 1073741823 : y >>> 0 < Ar >>> 0 ? Ar : y;
                                                                            B: {
                                                                              if (!Ar) {
                                                                                y = 0;
                                                                                break B;
                                                                              }
                                                                              if (Ar >>> 0 >= 1073741824) {
                                                                                if (e[5996] = 0, jo(35), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                                  break e;
                                                                                break v;
                                                                              }
                                                                              if (e[5996] = 0, y = no(3, Ar << 2) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                break v;
                                                                            }
                                                                            if (S = (br << 2) + y | 0, e[S >> 2] = l, l = S + 4 | 0, (C | 0) != (me | 0)) {
                                                                              for (; S = S - 4 | 0, C = C - 4 | 0, e[S >> 2] = e[C >> 2], (C | 0) != (me | 0); )
                                                                                ;
                                                                              C = e[Q + 4 >> 2];
                                                                            }
                                                                            if (e[Q + 12 >> 2] = (Ar << 2) + y, e[Q + 8 >> 2] = l, e[Q + 4 >> 2] = S, !C)
                                                                              break b;
                                                                            Tr(C);
                                                                          }
                                                                          if (e[5996] = 0, y = no(3, 4) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) {
                                                                            I = gi() | 0;
                                                                            break r;
                                                                          }
                                                                          if (e[y >> 2] = Q, e[5996] = 0, l = no(3, 56) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                            break m;
                                                                          if (e[l + 16 >> 2] = 0, e[l + 20 >> 2] = 0, e[l + 4 >> 2] = y, e[l >> 2] = 19, y = y + 4 | 0, e[l + 12 >> 2] = y, e[l + 8 >> 2] = y, e[l + 24 >> 2] = 0, e[l + 28 >> 2] = 0, e[l + 32 >> 2] = 0, e[l + 36 >> 2] = 0, e[l + 40 >> 2] = 0, e[l + 44 >> 2] = 0, e[5996] = 0, Co(33, I | 0, l | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                            break _;
                                                                          C = e[Q + 8 >> 2], S = e[Q + 12 >> 2];
                                                                          b: {
                                                                            if (C >>> 0 < S >>> 0) {
                                                                              e[C >> 2] = l, e[Q + 8 >> 2] = C + 4;
                                                                              break b;
                                                                            }
                                                                            if (me = e[Q + 4 >> 2], br = C - me >> 2, y = br + 1 | 0, y >>> 0 >= 1073741824) {
                                                                              if (e[5996] = 0, jo(34), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                                break e;
                                                                              break _;
                                                                            }
                                                                            S = S - me | 0, Ar = S >> 1, Ar = S >>> 0 >= 2147483644 ? 1073741823 : y >>> 0 < Ar >>> 0 ? Ar : y;
                                                                            B: {
                                                                              if (!Ar) {
                                                                                y = 0;
                                                                                break B;
                                                                              }
                                                                              if (Ar >>> 0 >= 1073741824) {
                                                                                if (e[5996] = 0, jo(35), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                                  break e;
                                                                                break _;
                                                                              }
                                                                              if (e[5996] = 0, y = no(3, Ar << 2) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                break _;
                                                                            }
                                                                            if (S = (br << 2) + y | 0, e[S >> 2] = l, l = S + 4 | 0, (C | 0) != (me | 0)) {
                                                                              for (; S = S - 4 | 0, C = C - 4 | 0, e[S >> 2] = e[C >> 2], (C | 0) != (me | 0); )
                                                                                ;
                                                                              C = e[Q + 4 >> 2];
                                                                            }
                                                                            if (e[Q + 12 >> 2] = (Ar << 2) + y, e[Q + 8 >> 2] = l, e[Q + 4 >> 2] = S, !C)
                                                                              break b;
                                                                            Tr(C);
                                                                          }
                                                                          if (e[5996] = 0, y = no(3, 4) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) {
                                                                            I = gi() | 0;
                                                                            break r;
                                                                          }
                                                                          if (e[y >> 2] = Q, e[5996] = 0, l = no(3, 56) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                            break T;
                                                                          if (e[l + 16 >> 2] = 0, e[l + 20 >> 2] = 0, e[l + 4 >> 2] = y, e[l >> 2] = 16, y = y + 4 | 0, e[l + 12 >> 2] = y, e[l + 8 >> 2] = y, e[l + 24 >> 2] = 0, e[l + 28 >> 2] = 0, e[l + 32 >> 2] = 0, e[l + 36 >> 2] = 0, e[l + 40 >> 2] = 0, e[l + 44 >> 2] = 0, e[5996] = 0, Co(33, I | 0, l | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                            break R;
                                                                          C = e[Q + 8 >> 2], S = e[Q + 12 >> 2];
                                                                          b: {
                                                                            if (C >>> 0 < S >>> 0) {
                                                                              e[C >> 2] = l, e[Q + 8 >> 2] = C + 4;
                                                                              break b;
                                                                            }
                                                                            if (me = e[Q + 4 >> 2], br = C - me >> 2, y = br + 1 | 0, y >>> 0 >= 1073741824) {
                                                                              if (e[5996] = 0, jo(34), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                                break e;
                                                                              break R;
                                                                            }
                                                                            S = S - me | 0, Ar = S >> 1, Ar = S >>> 0 >= 2147483644 ? 1073741823 : y >>> 0 < Ar >>> 0 ? Ar : y;
                                                                            B: {
                                                                              if (!Ar) {
                                                                                y = 0;
                                                                                break B;
                                                                              }
                                                                              if (Ar >>> 0 >= 1073741824) {
                                                                                if (e[5996] = 0, jo(35), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                                  break e;
                                                                                break R;
                                                                              }
                                                                              if (e[5996] = 0, y = no(3, Ar << 2) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                break R;
                                                                            }
                                                                            if (S = (br << 2) + y | 0, e[S >> 2] = l, l = S + 4 | 0, (C | 0) != (me | 0)) {
                                                                              for (; S = S - 4 | 0, C = C - 4 | 0, e[S >> 2] = e[C >> 2], (C | 0) != (me | 0); )
                                                                                ;
                                                                              C = e[Q + 4 >> 2];
                                                                            }
                                                                            if (e[Q + 12 >> 2] = (Ar << 2) + y, e[Q + 8 >> 2] = l, e[Q + 4 >> 2] = S, !C)
                                                                              break b;
                                                                            Tr(C);
                                                                          }
                                                                          if (e[5996] = 0, y = no(3, 4) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) {
                                                                            I = gi() | 0;
                                                                            break r;
                                                                          }
                                                                          if (e[y >> 2] = Q, e[5996] = 0, l = no(3, 56) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                            break l;
                                                                          if (e[l + 16 >> 2] = 0, e[l + 20 >> 2] = 0, e[l + 4 >> 2] = y, e[l >> 2] = 18, y = y + 4 | 0, e[l + 12 >> 2] = y, e[l + 8 >> 2] = y, e[l + 24 >> 2] = 0, e[l + 28 >> 2] = 0, e[l + 32 >> 2] = 0, e[l + 36 >> 2] = 0, e[l + 40 >> 2] = 0, e[l + 44 >> 2] = 0, e[5996] = 0, Co(33, I | 0, l | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                            break k;
                                                                          C = e[Q + 8 >> 2], S = e[Q + 12 >> 2];
                                                                          b: {
                                                                            if (C >>> 0 < S >>> 0) {
                                                                              e[C >> 2] = l, e[Q + 8 >> 2] = C + 4;
                                                                              break b;
                                                                            }
                                                                            if (me = e[Q + 4 >> 2], br = C - me >> 2, y = br + 1 | 0, y >>> 0 >= 1073741824) {
                                                                              if (e[5996] = 0, jo(34), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                                break e;
                                                                              break k;
                                                                            }
                                                                            S = S - me | 0, Ar = S >> 1, Ar = S >>> 0 >= 2147483644 ? 1073741823 : y >>> 0 < Ar >>> 0 ? Ar : y;
                                                                            B: {
                                                                              if (!Ar) {
                                                                                y = 0;
                                                                                break B;
                                                                              }
                                                                              if (Ar >>> 0 >= 1073741824) {
                                                                                if (e[5996] = 0, jo(35), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                                  break e;
                                                                                break k;
                                                                              }
                                                                              if (e[5996] = 0, y = no(3, Ar << 2) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                break k;
                                                                            }
                                                                            if (S = (br << 2) + y | 0, e[S >> 2] = l, l = S + 4 | 0, (C | 0) != (me | 0)) {
                                                                              for (; S = S - 4 | 0, C = C - 4 | 0, e[S >> 2] = e[C >> 2], (C | 0) != (me | 0); )
                                                                                ;
                                                                              C = e[Q + 4 >> 2];
                                                                            }
                                                                            if (e[Q + 12 >> 2] = (Ar << 2) + y, e[Q + 8 >> 2] = l, e[Q + 4 >> 2] = S, !C)
                                                                              break b;
                                                                            Tr(C);
                                                                          }
                                                                          if (e[5996] = 0, l = e[6079], y = no(3, 8) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1) {
                                                                            I = gi() | 0;
                                                                            break r;
                                                                          }
                                                                          if (e[y + 4 >> 2] = l, e[y >> 2] = Q, e[5996] = 0, l = no(3, 56) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                            break I;
                                                                          if (e[l + 16 >> 2] = 0, e[l + 20 >> 2] = 0, e[l + 4 >> 2] = y, e[l >> 2] = 11, e[l + 48 >> 2] = 0, e[l + 52 >> 2] = 1072693248, y = y + 8 | 0, e[l + 12 >> 2] = y, e[l + 8 >> 2] = y, e[l + 24 >> 2] = 0, e[l + 28 >> 2] = 0, e[l + 32 >> 2] = 0, e[l + 36 >> 2] = 0, e[l + 40 >> 2] = 0, e[l + 44 >> 2] = 0, e[5996] = 0, Co(33, I | 0, l | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                            break S;
                                                                          C = e[Q + 8 >> 2], S = e[Q + 12 >> 2];
                                                                          b: {
                                                                            if (C >>> 0 < S >>> 0) {
                                                                              e[C >> 2] = l, e[Q + 8 >> 2] = C + 4;
                                                                              break b;
                                                                            }
                                                                            if (me = e[Q + 4 >> 2], br = C - me >> 2, y = br + 1 | 0, y >>> 0 >= 1073741824) {
                                                                              if (e[5996] = 0, jo(34), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                                break e;
                                                                              break S;
                                                                            }
                                                                            S = S - me | 0, Ar = S >> 1, Ar = S >>> 0 >= 2147483644 ? 1073741823 : y >>> 0 < Ar >>> 0 ? Ar : y;
                                                                            B: {
                                                                              if (!Ar) {
                                                                                y = 0;
                                                                                break B;
                                                                              }
                                                                              if (Ar >>> 0 >= 1073741824) {
                                                                                if (e[5996] = 0, jo(35), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                                  break e;
                                                                                break S;
                                                                              }
                                                                              if (e[5996] = 0, y = no(3, Ar << 2) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                break S;
                                                                            }
                                                                            if (S = (br << 2) + y | 0, e[S >> 2] = l, l = S + 4 | 0, (C | 0) != (me | 0)) {
                                                                              for (; S = S - 4 | 0, C = C - 4 | 0, e[S >> 2] = e[C >> 2], (C | 0) != (me | 0); )
                                                                                ;
                                                                              C = e[Q + 4 >> 2];
                                                                            }
                                                                            if (e[Q + 12 >> 2] = (Ar << 2) + y, e[Q + 8 >> 2] = l, e[Q + 4 >> 2] = S, !C)
                                                                              break b;
                                                                            Tr(C);
                                                                          }
                                                                          if (e[5996] = 0, y = no(3, 4) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) {
                                                                            I = gi() | 0;
                                                                            break r;
                                                                          }
                                                                          if (e[y >> 2] = Q, e[5996] = 0, l = no(3, 56) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                            break w;
                                                                          if (e[l + 16 >> 2] = 0, e[l + 20 >> 2] = 0, e[l + 4 >> 2] = y, e[l >> 2] = 14, y = y + 4 | 0, e[l + 12 >> 2] = y, e[l + 8 >> 2] = y, e[l + 24 >> 2] = 0, e[l + 28 >> 2] = 0, e[l + 32 >> 2] = 0, e[l + 36 >> 2] = 0, e[l + 40 >> 2] = 0, e[l + 44 >> 2] = 0, e[5996] = 0, Co(33, I | 0, l | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                            break E;
                                                                          if (C = e[Q + 8 >> 2], me = e[Q + 12 >> 2], C >>> 0 < me >>> 0) {
                                                                            e[C >> 2] = l, e[Q + 8 >> 2] = C + 4;
                                                                            break f;
                                                                          }
                                                                          if (y = e[Q + 4 >> 2], S = C - y >> 2, I = S + 1 | 0, I >>> 0 >= 1073741824) {
                                                                            if (e[5996] = 0, jo(34), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                              break e;
                                                                            break E;
                                                                          }
                                                                          me = me - y | 0, Ar = me >> 1, I = me >>> 0 >= 2147483644 ? 1073741823 : I >>> 0 < Ar >>> 0 ? Ar : I;
                                                                          b: {
                                                                            if (!I) {
                                                                              br = 0;
                                                                              break b;
                                                                            }
                                                                            if (I >>> 0 >= 1073741824) {
                                                                              if (e[5996] = 0, jo(35), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                                break e;
                                                                              break E;
                                                                            }
                                                                            if (e[5996] = 0, br = no(3, I << 2) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                                              break E;
                                                                          }
                                                                          if (S = (S << 2) + br | 0, e[S >> 2] = l, l = S + 4 | 0, (y | 0) != (C | 0)) {
                                                                            for (; S = S - 4 | 0, C = C - 4 | 0, e[S >> 2] = e[C >> 2], (y | 0) != (C | 0); )
                                                                              ;
                                                                            C = e[Q + 4 >> 2];
                                                                          }
                                                                          if (e[Q + 12 >> 2] = (I << 2) + br, e[Q + 8 >> 2] = l, e[Q + 4 >> 2] = S, !C)
                                                                            break f;
                                                                          Tr(C);
                                                                          break f;
                                                                        }
                                                                        I = gi() | 0, Tr(y);
                                                                        break r;
                                                                      }
                                                                      I = gi() | 0, Tr(y);
                                                                      break r;
                                                                    }
                                                                    I = gi() | 0, Tr(y);
                                                                    break r;
                                                                  }
                                                                  I = gi() | 0, Tr(y);
                                                                  break r;
                                                                }
                                                                I = gi() | 0, Tr(y);
                                                                break r;
                                                              }
                                                              I = gi() | 0, Tr(y);
                                                              break r;
                                                            }
                                                            I = gi() | 0, Tr(y);
                                                            break r;
                                                          }
                                                          I = gi() | 0, Tr(y);
                                                          break r;
                                                        }
                                                        I = gi() | 0;
                                                        break r;
                                                      }
                                                      I = gi() | 0;
                                                      break r;
                                                    }
                                                    I = gi() | 0;
                                                    break r;
                                                  }
                                                  I = gi() | 0;
                                                  break r;
                                                }
                                                I = gi() | 0;
                                                break r;
                                              }
                                              I = gi() | 0;
                                              break r;
                                            }
                                            I = gi() | 0;
                                            break r;
                                          }
                                          I = gi() | 0;
                                          break r;
                                        }
                                        I = gi() | 0;
                                        break r;
                                      }
                                      return l = e[ke + 16 >> 2], l && (e[ke + 20 >> 2] = l, Tr(l)), bi = ke + 48 | 0, Q | 0;
                                    }
                                    I = gi() | 0;
                                    break r;
                                  }
                                  I = gi() | 0;
                                  break r;
                                }
                                I = gi() | 0;
                                break r;
                              }
                              I = gi() | 0;
                              break r;
                            }
                            I = gi() | 0;
                            break r;
                          }
                          I = gi() | 0;
                          break r;
                        }
                        I = gi() | 0;
                        break r;
                      }
                      I = gi() | 0;
                      break r;
                    }
                    I = gi() | 0;
                  }
                  if (l = e[ke + 16 >> 2], !l)
                    break t;
                  e[ke + 20 >> 2] = l, Tr(l);
                }
                ss(I | 0), jn();
              }
              jn();
            }
            function Zh(l) {
              l = l | 0;
              var y = 0, I = 0, C = 0, Q = 0, S = 0, me = 0, ke = 0, Ar = 0, br = 0, Qr = 0, Ur = 0, Xr = 0, Ri = 0, yn = 0, En = 0, Wn = 0, lo = 0, Ro = 0, Xo = 0, bs = 0, Os = 0, Gs = 0, aa = 0, Ma = 0;
              e: {
                t: {
                  r: {
                    if (e[l >> 2] != 24 || (I = e[l + 32 >> 2], me = e[l + 36 >> 2], (I | 0) == (me | 0)))
                      break r;
                    for (; ; ) {
                      br = e[e[I >> 2] + 80 >> 2];
                      i: {
                        if (S >>> 0 > Ar >>> 0) {
                          e[Ar >> 2] = br, Ar = Ar + 4 | 0;
                          break i;
                        }
                        if (ke = Ar - y >> 2, C = ke + 1 | 0, C >>> 0 >= 1073741824) {
                          if (e[5996] = 0, jo(94), l = e[5996], e[5996] = 0, (l | 0) == 1)
                            break t;
                          break e;
                        }
                        Q = S - y | 0, S = Q >> 1, S = Q >>> 0 >= 2147483644 ? 1073741823 : C >>> 0 < S >>> 0 ? S : C;
                        n: {
                          if (!S) {
                            Q = 0;
                            break n;
                          }
                          if (S >>> 0 >= 1073741824) {
                            if (e[5996] = 0, jo(35), l = e[5996], e[5996] = 0, (l | 0) != 1)
                              break e;
                            break t;
                          }
                          if (e[5996] = 0, Q = no(3, S << 2) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                            break t;
                        }
                        if (C = (ke << 2) + Q | 0, e[C >> 2] = br, Os = C, (y | 0) != (Ar | 0))
                          for (; Os = Os - 4 | 0, Ar = Ar - 4 | 0, e[Os >> 2] = e[Ar >> 2], (y | 0) != (Ar | 0); )
                            ;
                        S = (S << 2) + Q | 0, Ar = C + 4 | 0, y && Tr(y), y = Os;
                      }
                      if (I = I + 8 | 0, (me | 0) == (I | 0))
                        break;
                    }
                  }
                  br = e[l + 36 >> 2], S = e[l + 32 >> 2], I = br - S | 0;
                  r: {
                    if ((S | 0) == (br | 0)) {
                      C = 0, ke = 0;
                      break r;
                    }
                    if (ke = e[e[S >> 2] + 80 >> 2], I >>> 0 < 9) {
                      C = 0;
                      break r;
                    }
                    if (C = e[e[S + 8 >> 2] + 80 >> 2], I >>> 0 < 17)
                      break r;
                    Xr = e[e[S + 16 >> 2] + 80 >> 2];
                  }
                  Ro = I >> 3, Qr = e[l + 24 >> 2], yn = e[l + 20 >> 2], Q = Qr - yn | 0, bs = e[l + 12 >> 2], Gs = e[l + 8 >> 2], aa = bs - Gs | 0, me = (aa | 0) / 12 | 0, Ri = e[l + 4 >> 2];
                  r: {
                    i: {
                      n: {
                        o: {
                          a: {
                            s: {
                              A: {
                                u: {
                                  h: {
                                    c: {
                                      f: {
                                        p: {
                                          d: {
                                            g: {
                                              v:
                                                switch (y = e[l >> 2], l = y & -2, l - 6 | 0) {
                                                  case 2:
                                                    break g;
                                                  case 0:
                                                    break v;
                                                  default:
                                                    break d;
                                                }
                                              if ((Q | 0) == 32)
                                                break p;
                                              Q = 2369, l = 39, me = 3984;
                                              break i;
                                            }
                                            if ((Q | 0) == 20)
                                              break p;
                                            Q = 2369, l = 41, me = 4224;
                                            break i;
                                          }
                                          if (Q = 2369, (Qr | 0) != (yn | 0)) {
                                            l = 43, me = 4337;
                                            break i;
                                          }
                                          if ((l | 0) != 4)
                                            break p;
                                          if ((Ri | 0) > 0)
                                            break f;
                                          l = 47, me = 3134;
                                          break i;
                                        }
                                        p:
                                          switch (y - 24 | 0) {
                                            case 1:
                                              if (me >>> 0 > Ri - 1 >>> 0)
                                                break c;
                                              Q = 2369, l = 49, me = 1397;
                                              break i;
                                            case 0:
                                              if (Ro >>> 0 > Ri - 1 >>> 0)
                                                break u;
                                              Q = 2369, l = 51, me = 1654;
                                              break i;
                                            default:
                                              break p;
                                          }
                                        if (Q = 2369, Ri) {
                                          l = 53, me = 4330;
                                          break i;
                                        }
                                        if (y - 17 >>> 0 > 5)
                                          break f;
                                        if ((I | 0) == 16)
                                          break h;
                                        l = 58, me = 4003;
                                        break i;
                                      }
                                      if (y - 10 >>> 0 >= 7) {
                                        if ((y | 0) != 23)
                                          break c;
                                        if ((I | 0) == 24)
                                          break u;
                                        l = 60, me = 3946;
                                        break i;
                                      }
                                      if ((I | 0) == 8)
                                        break u;
                                      l = 64, me = 4090;
                                      break i;
                                    }
                                    if ((y | 0) == 24 | (S | 0) == (br | 0))
                                      break h;
                                    Q = 2369, l = 66, me = 4311;
                                    break i;
                                  }
                                  if ((l | 0) == 2) {
                                    if ((aa | 0) == 12)
                                      break A;
                                    Q = 2369, l = 70, me = 4063;
                                    break i;
                                  }
                                  if ((y | 0) != 25)
                                    break u;
                                  if (me - 1 >>> 0 < 20)
                                    break s;
                                  Q = 2369, l = 72, me = 4240;
                                  break i;
                                }
                                if ((bs | 0) == (Gs | 0))
                                  break A;
                                Q = 2369, l = 74, me = 4299;
                                break i;
                              }
                              I = 10, S = 2108, Q = 2369, l = 247, me = 2350;
                              A:
                                switch (y | 0) {
                                  case 3:
                                    I = 9, S = 2119;
                                    break a;
                                  case 4:
                                    if (e[5996] = 0, l = wn(54, 2295, 1) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1 || (e[5996] = 0, y = wn(54, 2278, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1) || (e[5996] = 0, I = wn(54, 2129, 6) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1))
                                      break r;
                                    y = I | (Ri & 4194304 ? l : y);
                                    break n;
                                  case 5:
                                    if (e[5996] = 0, l = wn(54, 2174, 1) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1 || (e[5996] = 0, y = wn(54, 2170, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1) || (e[5996] = 0, I = wn(54, 2129, 6) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1))
                                      break r;
                                    y = I | ((Ri >>> 0 < 5e8 ? y : 0) | (Ri >>> 0 > 499999999 ? l : 0));
                                    break n;
                                  case 6:
                                  case 7:
                                  case 8:
                                  case 9:
                                    I = 7, S = 2153;
                                    break a;
                                  case 1:
                                    I = 7, S = 2136;
                                    break a;
                                  case 0:
                                    I = 9, S = 2098;
                                    break a;
                                  case 10:
                                    if (e[5996] = 0, l = wn(54, 2777, 1) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1 || (e[5996] = 0, y = wn(54, 3557, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1) || (e[5996] = 0, I = wn(54, 2161, 5) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1) || (e[5996] = 0, C = wn(54, 1600, 6) | 0, Q = e[5996], e[5996] = 0, (Q | 0) == 1) || (e[5996] = 0, Q = wn(54, 1239, 1) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1))
                                      break r;
                                    y = (I | C) & ke | (Q | (y & (ke ^ -1) ? 0 : l));
                                    break n;
                                  case 11:
                                    if (e[5996] = 0, l = wn(54, 2777, 1) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1 || (e[5996] = 0, y = wn(54, 1958, 2) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1) || (e[5996] = 0, I = wn(54, 2161, 5) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1) || (e[5996] = 0, C = wn(54, 1197, 7) | 0, Q = e[5996], e[5996] = 0, (Q | 0) == 1))
                                      break r;
                                    y = (I | C) & ke | (y & (ke ^ -1) ? 0 : l);
                                    break n;
                                  case 12:
                                    if (e[5996] = 0, l = wn(54, 3557, 1) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1 || (e[5996] = 0, y = wn(54, 3310, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1) || (e[5996] = 0, I = wn(54, 2161, 5) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1) || (e[5996] = 0, C = wn(54, 2035, 6) | 0, Q = e[5996], e[5996] = 0, (Q | 0) == 1) || (e[5996] = 0, Q = wn(54, 1419, 2) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1))
                                      break r;
                                    y = (I | C) & ke | (Q | (y & (ke ^ -1) ? 0 : l));
                                    break n;
                                  case 13:
                                    if (e[5996] = 0, y = wn(54, 3557, 1) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1 || (e[5996] = 0, I = wn(54, 1028, 2) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, l = wn(54, 1959, 1) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1) || (e[5996] = 0, C = wn(54, 1029, 1) | 0, Q = e[5996], e[5996] = 0, (Q | 0) == 1) || (e[5996] = 0, Q = wn(54, 2451, 1) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1) || (e[5996] = 0, S = wn(54, 2315, 1) | 0, br = e[5996], e[5996] = 0, (br | 0) == 1) || (e[5996] = 0, br = wn(54, 2161, 5) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1) || (e[5996] = 0, me = wn(54, 1640, 2) | 0, Ar = e[5996], e[5996] = 0, (Ar | 0) == 1) || (e[5996] = 0, Ar = wn(54, 1208, 3) | 0, Ri = e[5996], e[5996] = 0, (Ri | 0) == 1))
                                      break r;
                                    Qr = l, l = ke ^ -1, y = (me | br) & ke | (Ar | ((l & C ? 0 : Qr) | (l & I ? 0 : y) | (l & S ? 0 : Q)));
                                    break n;
                                  case 14:
                                    if (e[5996] = 0, l = wn(54, 2796, 1) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1 || (e[5996] = 0, y = wn(54, 3557, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1) || (e[5996] = 0, I = wn(54, 2161, 5) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1) || (e[5996] = 0, C = wn(54, 1486, 5) | 0, Q = e[5996], e[5996] = 0, (Q | 0) == 1) || (e[5996] = 0, Q = wn(54, 1205, 2) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1))
                                      break r;
                                    y = (I | C) & ke | (Q | (y & (ke ^ -1) ? 0 : l));
                                    break n;
                                  case 15:
                                    if (e[5996] = 0, l = wn(54, 3557, 1) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1 || (e[5996] = 0, y = wn(54, 2028, 2) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1) || (e[5996] = 0, I = wn(54, 2451, 1) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1) || (e[5996] = 0, C = wn(54, 2315, 1) | 0, Q = e[5996], e[5996] = 0, (Q | 0) == 1) || (e[5996] = 0, Q = wn(54, 2161, 5) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1) || (e[5996] = 0, S = wn(54, 1430, 4) | 0, br = e[5996], e[5996] = 0, (br | 0) == 1) || (e[5996] = 0, br = wn(54, 1208, 3) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1))
                                      break r;
                                    me = I, I = ke ^ -1, y = (Q | S) & ke | (br | ((I & C ? 0 : me) | (y & I ? 0 : l)));
                                    break n;
                                  case 16:
                                    if (e[5996] = 0, l = wn(54, 2161, 5) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1 || (e[5996] = 0, y = wn(54, 1607, 9) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1) || (e[5996] = 0, I = wn(54, 1149, 2) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1))
                                      break r;
                                    y = I | (l | y) & ke;
                                    break n;
                                  case 17:
                                    if (e[5996] = 0, br = wn(54, 3540, 3) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1 || (e[5996] = 0, me = wn(54, 2796, 1) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, Ar = wn(54, 2029, 1) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, Ri = wn(54, 2029, 1) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, Xr = wn(54, 1029, 1) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, Ro = wn(54, 1959, 1) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, Qr = wn(54, 1029, 1) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, yn = wn(54, 1024, 3) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, bs = wn(54, 1681, 1) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, l = wn(54, 2315, 1) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1) || (e[5996] = 0, y = wn(54, 2315, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1))
                                      break r;
                                    Q = ke ^ -1, S = C ^ -1;
                                    u: {
                                      if (S & y) {
                                        if (I = 0, e[5996] = 0, y = wn(54, 1681, 1) | 0, Gs = e[5996], e[5996] = 0, (Gs | 0) == 1)
                                          break r;
                                        if (y & Q)
                                          break u;
                                      }
                                      I = l;
                                    }
                                    if (e[5996] = 0, Gs = wn(54, 1149, 2) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1 || (e[5996] = 0, aa = wn(54, 2167, 4) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, l = wn(54, 2165, 1) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1) || (e[5996] = 0, Wn = wn(54, 2165, 1) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1))
                                      break r;
                                    y = 0, En = C & ke;
                                    u: {
                                      if (Wn & (En ^ -1))
                                        break u;
                                      if (e[5996] = 0, y = wn(54, 2295, 1) | 0, Wn = e[5996], e[5996] = 0, (Wn | 0) == 1)
                                        break r;
                                      if (!(y & Q)) {
                                        if (y = 0, e[5996] = 0, Wn = wn(54, 2278, 1) | 0, lo = e[5996], e[5996] = 0, (lo | 0) == 1)
                                          break r;
                                        if (!(S & Wn))
                                          break u;
                                      }
                                      if (e[5996] = 0, y = wn(54, 2278, 1) | 0, Wn = e[5996], e[5996] = 0, (Wn | 0) == 1)
                                        break r;
                                      if (!(y & Q)) {
                                        if (y = 0, e[5996] = 0, Wn = wn(54, 2295, 1) | 0, lo = e[5996], e[5996] = 0, (lo | 0) == 1)
                                          break r;
                                        if (!(S & Wn))
                                          break u;
                                      }
                                      if (e[5996] = 0, y = wn(54, 2174, 1) | 0, Wn = e[5996], e[5996] = 0, (Wn | 0) == 1)
                                        break r;
                                      if (!(y & Q)) {
                                        if (y = 0, e[5996] = 0, Wn = wn(54, 2170, 1) | 0, lo = e[5996], e[5996] = 0, (lo | 0) == 1)
                                          break r;
                                        if (!(S & Wn))
                                          break u;
                                      }
                                      if (e[5996] = 0, y = wn(54, 2170, 1) | 0, Wn = e[5996], e[5996] = 0, (Wn | 0) == 1)
                                        break r;
                                      if (!(y & Q)) {
                                        if (y = 0, e[5996] = 0, Wn = wn(54, 2174, 1) | 0, lo = e[5996], e[5996] = 0, (lo | 0) == 1)
                                          break r;
                                        if (!(S & Wn))
                                          break u;
                                      }
                                      y = l;
                                    }
                                    l = C | ke, y = C & Gs | (yn & En | (ke & Ar | (Q & me ? 0 : C & br) | (Q & Xr ? 0 : C & Ri)) | (Qr & (l ^ -1) ? 0 : l & Ro) | l & bs | I) | l & aa | y;
                                    break n;
                                  case 18:
                                    if (e[5996] = 0, Ar = wn(54, 3557, 1) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1 || (e[5996] = 0, Ri = wn(54, 2777, 1) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, Xr = wn(54, 1959, 1) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, Ro = wn(54, 1029, 1) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, Qr = wn(54, 2029, 1) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, yn = wn(54, 2029, 1) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, bs = wn(54, 1029, 1) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, Gs = wn(54, 2451, 1) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, aa = wn(54, 1681, 1) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, Wn = wn(54, 2031, 3) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, l = wn(54, 2315, 1) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1) || (e[5996] = 0, Q = wn(54, 2315, 1) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1))
                                      break r;
                                    y = C ^ -1, I = ke ^ -1, S = C & ke, me = S ^ -1;
                                    u: {
                                      h: {
                                        if (!(me & Q))
                                          break h;
                                        if (e[5996] = 0, Q = wn(54, 2297, 2) | 0, br = e[5996], e[5996] = 0, (br | 0) == 1)
                                          break r;
                                        if (!(I & Q))
                                          break h;
                                        if (br = 0, e[5996] = 0, Q = wn(54, 2297, 2) | 0, En = e[5996], e[5996] = 0, (En | 0) == 1)
                                          break r;
                                        if (y & Q)
                                          break u;
                                      }
                                      br = l;
                                    }
                                    if (e[5996] = 0, En = wn(54, 1681, 1) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1 || (e[5996] = 0, lo = wn(54, 1149, 2) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, Ma = wn(54, 2167, 4) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, l = wn(54, 2165, 1) | 0, Q = e[5996], e[5996] = 0, (Q | 0) == 1) || (Q = 0, e[5996] = 0, Ur = wn(54, 2165, 1) | 0, Xo = e[5996], e[5996] = 0, (Xo | 0) == 1))
                                      break r;
                                    u: {
                                      if (me & Ur)
                                        break u;
                                      if (e[5996] = 0, Q = wn(54, 2295, 1) | 0, Ur = e[5996], e[5996] = 0, (Ur | 0) == 1)
                                        break r;
                                      if (!(I & Q)) {
                                        if (Q = 0, e[5996] = 0, Ur = wn(54, 2278, 1) | 0, Xo = e[5996], e[5996] = 0, (Xo | 0) == 1)
                                          break r;
                                        if (!(y & Ur))
                                          break u;
                                      }
                                      if (e[5996] = 0, Q = wn(54, 2278, 1) | 0, Ur = e[5996], e[5996] = 0, (Ur | 0) == 1)
                                        break r;
                                      if (!(I & Q)) {
                                        if (Q = 0, e[5996] = 0, Ur = wn(54, 2295, 1) | 0, Xo = e[5996], e[5996] = 0, (Xo | 0) == 1)
                                          break r;
                                        if (!(y & Ur))
                                          break u;
                                      }
                                      if (e[5996] = 0, Q = wn(54, 2174, 1) | 0, Ur = e[5996], e[5996] = 0, (Ur | 0) == 1)
                                        break r;
                                      if (!(I & Q)) {
                                        if (Q = 0, e[5996] = 0, Ur = wn(54, 2170, 1) | 0, Xo = e[5996], e[5996] = 0, (Xo | 0) == 1)
                                          break r;
                                        if (!(y & Ur))
                                          break u;
                                      }
                                      if (e[5996] = 0, Q = wn(54, 2170, 1) | 0, Ur = e[5996], e[5996] = 0, (Ur | 0) == 1)
                                        break r;
                                      if (!(I & Q)) {
                                        if (Q = 0, e[5996] = 0, Ur = wn(54, 2174, 1) | 0, Xo = e[5996], e[5996] = 0, (Xo | 0) == 1)
                                          break r;
                                        if (!(y & Ur))
                                          break u;
                                      }
                                      Q = l;
                                    }
                                    l = C | ke, y = lo | (S & Wn | (ke & Qr | (y & Ri ? 0 : ke & Ar) | (Ro & (l ^ -1) ? 0 : l & Xr) | (I & bs ? 0 : C & yn)) | (me & aa ? 0 : S & Gs) | br | l & En) | l & Ma | Q;
                                    break n;
                                  case 19:
                                    if (e[5996] = 0, l = wn(54, 3557, 1) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1 || (e[5996] = 0, y = wn(54, 2504, 2) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1))
                                      break r;
                                    if (I = 0, !((ke ^ -1) & y)) {
                                      if (e[5996] = 0, y = wn(54, 2501, 2) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                        break r;
                                      I = y & (C ^ -1) ? 0 : l;
                                    }
                                    if (e[5996] = 0, Q = wn(54, 1959, 1) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1 || (e[5996] = 0, br = wn(54, 1029, 1) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, me = wn(54, 2049, 1) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) || (S = 0, e[5996] = 0, y = wn(54, 1681, 1) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1))
                                      break r;
                                    if (l = C & ke, Qr = y, y = C | ke, C = y ^ -1, !(Qr & C)) {
                                      if (e[5996] = 0, S = wn(54, 2451, 1) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                                        break r;
                                      S = S & (l ^ -1) ? 0 : l & me;
                                    }
                                    if (e[5996] = 0, me = wn(54, 2340, 3) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1 || (e[5996] = 0, ke = wn(54, 1148, 3) | 0, Ar = e[5996], e[5996] = 0, (Ar | 0) == 1) || (e[5996] = 0, Ar = wn(54, 2167, 4) | 0, Ri = e[5996], e[5996] = 0, (Ri | 0) == 1) || (e[5996] = 0, Ri = wn(54, 2165, 1) | 0, Xr = e[5996], e[5996] = 0, (Xr | 0) == 1))
                                      break r;
                                    y = l & Ri | (y & Ar | (ke | (l & me | ((C & br ? 0 : y & Q) | I | S))));
                                    break n;
                                  case 21:
                                    if (e[5996] = 0, Q = wn(54, 3557, 1) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1 || (e[5996] = 0, S = wn(54, 1293, 3) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, br = wn(54, 1959, 1) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, me = wn(54, 1029, 1) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, l = wn(54, 2049, 1) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1) || (e[5996] = 0, I = wn(54, 2451, 1) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1))
                                      break r;
                                    y = C & ke, Ar = ke ^ -1;
                                    u: {
                                      if (Ar & I) {
                                        l = C | ke, I = 0;
                                        break u;
                                      }
                                      if (e[5996] = 0, I = wn(54, 1681, 1) | 0, Ri = e[5996], e[5996] = 0, (Ri | 0) == 1)
                                        break r;
                                      Qr = l & y, l = C | ke, I = I & (l ^ -1) ? 0 : Qr;
                                    }
                                    if (e[5996] = 0, Ri = wn(54, 1650, 3) | 0, Xr = e[5996], e[5996] = 0, (Xr | 0) == 1 || (e[5996] = 0, Xr = wn(54, 2468, 3) | 0, Ro = e[5996], e[5996] = 0, (Ro | 0) == 1) || (e[5996] = 0, Ro = wn(54, 1239, 1) | 0, Qr = e[5996], e[5996] = 0, (Qr | 0) == 1) || (e[5996] = 0, Qr = wn(54, 2167, 4) | 0, yn = e[5996], e[5996] = 0, (yn | 0) == 1) || (e[5996] = 0, yn = wn(54, 2165, 1) | 0, bs = e[5996], e[5996] = 0, (bs | 0) == 1))
                                      break r;
                                    y = y & yn | (l & Qr | (Ro | (C & Xr | (y & Ri | (I | ((me & (C ^ -1) ? 0 : ke & br) | (S & Ar ? 0 : C & Q)))))));
                                    break n;
                                  case 20:
                                    if (e[5996] = 0, Q = wn(54, 2796, 1) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1 || (e[5996] = 0, S = wn(54, 1293, 3) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, br = wn(54, 1959, 1) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, me = wn(54, 1029, 1) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, l = wn(54, 2049, 1) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1) || (e[5996] = 0, I = wn(54, 2451, 1) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1))
                                      break r;
                                    y = C & ke, Ar = ke ^ -1;
                                    u: {
                                      if (Ar & I) {
                                        l = C | ke, I = 0;
                                        break u;
                                      }
                                      if (e[5996] = 0, I = wn(54, 1681, 1) | 0, Ri = e[5996], e[5996] = 0, (Ri | 0) == 1)
                                        break r;
                                      Qr = l & y, l = C | ke, I = I & (l ^ -1) ? 0 : Qr;
                                    }
                                    if (e[5996] = 0, Ri = wn(54, 1394, 2) | 0, Xr = e[5996], e[5996] = 0, (Xr | 0) == 1 || (e[5996] = 0, Xr = wn(54, 1205, 2) | 0, Ro = e[5996], e[5996] = 0, (Ro | 0) == 1) || (e[5996] = 0, Ro = wn(54, 2167, 4) | 0, Qr = e[5996], e[5996] = 0, (Qr | 0) == 1) || (e[5996] = 0, Qr = wn(54, 2165, 1) | 0, yn = e[5996], e[5996] = 0, (yn | 0) == 1))
                                      break r;
                                    y = y & Qr | (l & Ro | (Xr | (y & Ri | (I | ((me & (C ^ -1) ? 0 : ke & br) | (S & Ar ? 0 : C & Q))))));
                                    break n;
                                  case 22:
                                    if (e[5996] = 0, Q = wn(54, 1643, 6) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1 || (e[5996] = 0, y = wn(54, 1959, 1) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, S = wn(54, 1029, 1) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, br = wn(54, 2451, 1) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, me = wn(54, 2315, 1) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, Ar = wn(54, 2049, 1) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, Ri = wn(54, 1681, 1) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, Xr = wn(54, 2522, 1) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, Ro = wn(54, 1239, 1) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, Qr = wn(54, 2167, 4) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, yn = wn(54, 2165, 1) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1))
                                      break r;
                                    l = C | ke, I = l ^ -1, Ur = y, y = C & ke, y = l & Qr | (Ro | (l & Xr | ((S & (y ^ -1) ? 0 : Ur) | y & Q | (I & me ? 0 : l & br))) | (I & Ri ? 0 : y & Ar)) | y & yn;
                                    break n;
                                  case 24:
                                    break o;
                                  case 2:
                                    break a;
                                  case 25:
                                    break s;
                                  case 23:
                                    break A;
                                  default:
                                    break i;
                                }
                              if (e[5996] = 0, Ro = wn(54, 2779, 3) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1 || (e[5996] = 0, Qr = wn(54, 1293, 3) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, yn = wn(54, 1029, 1) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, bs = wn(54, 1959, 1) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, Gs = wn(54, 1029, 1) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, aa = wn(54, 1295, 1) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, l = wn(54, 2315, 1) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1) || (e[5996] = 0, y = wn(54, 1681, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1))
                                break r;
                              I = ke ^ -1;
                              A: {
                                if (I & y) {
                                  if (Q = 0, e[5996] = 0, y = wn(54, 2315, 1) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                    break r;
                                  if ((C ^ -1) & y)
                                    break A;
                                }
                                Q = l & Xr;
                              }
                              if (e[5996] = 0, Wn = wn(54, 2522, 1) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1 || (e[5996] = 0, l = wn(54, 2451, 1) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1) || (e[5996] = 0, y = wn(54, 1681, 1) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1))
                                break r;
                              A: {
                                if (y & I) {
                                  if (br = 0, e[5996] = 0, y = wn(54, 2315, 1) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                    break r;
                                  if ((C ^ -1) & y)
                                    break A;
                                }
                                br = l & ke & Xr;
                              }
                              if (e[5996] = 0, l = wn(54, 2049, 1) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1 || (e[5996] = 0, y = wn(54, 2451, 1) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1))
                                break r;
                              Ri = C & ke & Xr;
                              A: {
                                if (y & I) {
                                  me = C | ke, Ar = Xr | me, l = 0;
                                  break A;
                                }
                                if (e[5996] = 0, y = wn(54, 1681, 1) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                  break r;
                                me = C | ke, Ar = Xr | me, l = y & (Ar ^ -1) ? 0 : l & Ri;
                              }
                              if (e[5996] = 0, En = wn(54, 1681, 1) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1 || (e[5996] = 0, lo = wn(54, 1239, 1) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1) || (e[5996] = 0, Ma = wn(54, 2167, 4) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1) || (e[5996] = 0, y = wn(54, 2165, 1) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1) || (S = 0, e[5996] = 0, Ur = wn(54, 2165, 1) | 0, Xo = e[5996], e[5996] = 0, (Xo | 0) == 1))
                                break r;
                              A: {
                                if (Ur & (Ri ^ -1))
                                  break A;
                                if (e[5996] = 0, S = wn(54, 2295, 1) | 0, Ur = e[5996], e[5996] = 0, (Ur | 0) == 1)
                                  break r;
                                if (!(I & S)) {
                                  if (S = 0, e[5996] = 0, Ur = wn(54, 2278, 1) | 0, Xo = e[5996], e[5996] = 0, (Xo | 0) == 1)
                                    break r;
                                  if (!((C ^ -1) & Ur))
                                    break A;
                                }
                                if (e[5996] = 0, S = wn(54, 2278, 1) | 0, Ur = e[5996], e[5996] = 0, (Ur | 0) == 1)
                                  break r;
                                if (!(I & S)) {
                                  if (S = 0, e[5996] = 0, Ur = wn(54, 2295, 1) | 0, Xo = e[5996], e[5996] = 0, (Xo | 0) == 1)
                                    break r;
                                  if (!((C ^ -1) & Ur))
                                    break A;
                                }
                                if (e[5996] = 0, S = wn(54, 2174, 1) | 0, Ur = e[5996], e[5996] = 0, (Ur | 0) == 1)
                                  break r;
                                if (!(I & S)) {
                                  if (S = 0, e[5996] = 0, Ur = wn(54, 2170, 1) | 0, Xo = e[5996], e[5996] = 0, (Xo | 0) == 1)
                                    break r;
                                  if (!((C ^ -1) & Ur))
                                    break A;
                                }
                                if (e[5996] = 0, S = wn(54, 2170, 1) | 0, Ur = e[5996], e[5996] = 0, (Ur | 0) == 1)
                                  break r;
                                if (!(I & S)) {
                                  if (S = 0, e[5996] = 0, Ur = wn(54, 2174, 1) | 0, Xo = e[5996], e[5996] = 0, (Xo | 0) == 1)
                                    break r;
                                  if (!((C ^ -1) & Ur))
                                    break A;
                                }
                                S = y;
                              }
                              y = C & Xr, C = y | ke, y = Ar & Ma | (me & En & Xr | (lo | (l | (Xr & Wn | (y & aa | (Ri & yn | (I & Qr ? 0 : y & Ro)) | (Gs & (C ^ -1) ? 0 : C & bs) | Q) | br)))) | S;
                              break n;
                            }
                            I = 8, S = 2144;
                          }
                          if (e[5996] = 0, y = wn(54, S | 0, I | 0) | 0, l = e[5996], e[5996] = 0, (l | 0) != 1)
                            break n;
                          break r;
                        }
                        if (S = 0, e[5996] = 0, br = 1, I = wn(54, 2165, 1) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1)
                          break r;
                        o: {
                          if ((Ar | 0) == (Os | 0)) {
                            l = 1, ke = 0;
                            break o;
                          }
                          if (Q = e[Os >> 2], y = 0, e[5996] = 0, l = wn(54, 1293, 3) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                            break r;
                          if (C = Q ^ -1, C & l)
                            break n;
                          if (e[5996] = 0, me = wn(54, 2451, 1) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1 || (e[5996] = 0, ke = wn(54, 2049, 1) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, Xr = wn(54, 1681, 1) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, l = wn(54, 1029, 1) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1))
                            break r;
                          if (l & C) {
                            if (e[5996] = 0, l = wn(54, 1959, 1) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                              break r;
                            S = l & C ? 2 : 1;
                          }
                          if (e[5996] = 0, Qr = wn(54, 2167, 4) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1 || (e[5996] = 0, l = wn(54, 2165, 1) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1) || (e[5996] = 0, br = wn(54, 2165, 1) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1))
                            break r;
                          y = 0;
                          a: {
                            if (br & (I & Q ^ -1))
                              break a;
                            s: {
                              if (Ri >>> 0 < 2)
                                break s;
                              if (e[5996] = 0, y = wn(54, 2295, 1) | 0, br = e[5996], e[5996] = 0, (br | 0) == 1)
                                break r;
                              if (br = I ^ -1, !(br & y)) {
                                if (y = 0, e[5996] = 0, yn = wn(54, 2278, 1) | 0, bs = e[5996], e[5996] = 0, (bs | 0) == 1)
                                  break r;
                                if (!(C & yn))
                                  break a;
                              }
                              if (e[5996] = 0, y = wn(54, 2278, 1) | 0, yn = e[5996], e[5996] = 0, (yn | 0) == 1)
                                break r;
                              if (!(y & br)) {
                                if (y = 0, e[5996] = 0, yn = wn(54, 2295, 1) | 0, bs = e[5996], e[5996] = 0, (bs | 0) == 1)
                                  break r;
                                if (!(C & yn))
                                  break a;
                              }
                              if (e[5996] = 0, y = wn(54, 2174, 1) | 0, yn = e[5996], e[5996] = 0, (yn | 0) == 1)
                                break r;
                              if (!(y & br)) {
                                if (y = 0, e[5996] = 0, yn = wn(54, 2170, 1) | 0, bs = e[5996], e[5996] = 0, (bs | 0) == 1)
                                  break r;
                                if (!(C & yn))
                                  break a;
                              }
                              if (e[5996] = 0, y = wn(54, 2170, 1) | 0, yn = e[5996], e[5996] = 0, (yn | 0) == 1)
                                break r;
                              if (y & br)
                                break s;
                              if (y = 0, e[5996] = 0, br = wn(54, 2174, 1) | 0, yn = e[5996], e[5996] = 0, (yn | 0) == 1)
                                break r;
                              if (!(C & br))
                                break a;
                            }
                            y = l;
                          }
                          if (l = !(C & me), br = !(C & ke), ke = !(C & Xr), I = Qr & (I | Q) | y, y = Ar - Os | 0, y >>> 0 < 5)
                            break o;
                          for (y = y >> 2, yn = y >>> 0 <= 2 ? 2 : y, Q = 1; ; ) {
                            if (Xr = e[(Q << 2) + Os >> 2], e[5996] = 0, y = wn(54, 1289, 3) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                              break t;
                            if (Ar = Xr ^ -1, Ar & y) {
                              y = 0;
                              break n;
                            }
                            if (e[5996] = 0, bs = wn(54, 2451, 1) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1 || (e[5996] = 0, Gs = wn(54, 2049, 1) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1) || (e[5996] = 0, aa = wn(54, 1681, 1) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1) || (e[5996] = 0, y = wn(54, 1029, 1) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1))
                              break t;
                            if (y & Ar) {
                              if (e[5996] = 0, y = wn(54, 1959, 1) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                break t;
                              y = y & Ar ? 2 : 1;
                            } else
                              y = 0;
                            if (e[5996] = 0, Wn = wn(54, 2167, 4) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1 || (e[5996] = 0, me = wn(54, 2165, 1) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1) || (e[5996] = 0, Qr = wn(54, 2165, 1) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1))
                              break t;
                            C = 0;
                            a: {
                              if (Qr & (I & Xr ^ -1))
                                break a;
                              s: {
                                if (Ri >>> 0 < 2)
                                  break s;
                                if (e[5996] = 0, Qr = wn(54, 2295, 1) | 0, En = e[5996], e[5996] = 0, (En | 0) == 1)
                                  break t;
                                if (Ur = Qr, Qr = I ^ -1, !(Ur & Qr)) {
                                  if (e[5996] = 0, En = wn(54, 2278, 1) | 0, lo = e[5996], e[5996] = 0, (lo | 0) == 1)
                                    break t;
                                  if (!(Ar & En))
                                    break a;
                                }
                                if (e[5996] = 0, En = wn(54, 2278, 1) | 0, lo = e[5996], e[5996] = 0, (lo | 0) == 1)
                                  break t;
                                if (!(Qr & En)) {
                                  if (e[5996] = 0, En = wn(54, 2295, 1) | 0, lo = e[5996], e[5996] = 0, (lo | 0) == 1)
                                    break t;
                                  if (!(Ar & En))
                                    break a;
                                }
                                if (e[5996] = 0, En = wn(54, 2174, 1) | 0, lo = e[5996], e[5996] = 0, (lo | 0) == 1)
                                  break t;
                                if (!(Qr & En)) {
                                  if (e[5996] = 0, En = wn(54, 2170, 1) | 0, lo = e[5996], e[5996] = 0, (lo | 0) == 1)
                                    break t;
                                  if (!(Ar & En))
                                    break a;
                                }
                                if (e[5996] = 0, En = wn(54, 2170, 1) | 0, lo = e[5996], e[5996] = 0, (lo | 0) == 1)
                                  break t;
                                if (Qr & En)
                                  break s;
                                if (e[5996] = 0, Qr = wn(54, 2174, 1) | 0, En = e[5996], e[5996] = 0, (En | 0) == 1)
                                  break t;
                                if (!(Ar & Qr))
                                  break a;
                              }
                              C = me;
                            }
                            if (l = !(Ar & bs) & l, br = !(Ar & Gs) & br, ke = !(Ar & aa) + ke | 0, S = y + S | 0, I = Wn & (I | Xr) | C, Q = Q + 1 | 0, (yn | 0) == (Q | 0))
                              break;
                          }
                        }
                        if (e[5996] = 0, y = wn(54, 1293, 3) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1 || (e[5996] = 0, C = wn(54, 1029, 1) | 0, Q = e[5996], e[5996] = 0, (Q | 0) == 1) || (e[5996] = 0, Q = wn(54, 1959, 1) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1) || (e[5996] = 0, me = wn(54, 2451, 1) | 0, Ar = e[5996], e[5996] = 0, (Ar | 0) == 1) || (e[5996] = 0, Ar = wn(54, 2049, 1) | 0, Xr = e[5996], e[5996] = 0, (Xr | 0) == 1) || (e[5996] = 0, Xr = wn(54, 1681, 1) | 0, Qr = e[5996], e[5996] = 0, (Qr | 0) == 1))
                          break r;
                        y = y | I | (S ? 0 : C) | ((S | 0) == 1 ? Q : 0) | (l && (ke | 0) == (Ro | 0) ? me : 0), I = l & br ? Ar : 0, l = Ro - Ri | 0, y = y | (l >>> 0 <= ke >>> 0 ? I : 0) | (l + 1 >>> 0 <= ke >>> 0 ? Xr : 0);
                      }
                      if (e[5996] = 0, I = wn(54, 3310, 1) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1 || (e[5996] = 0, C = wn(54, 2796, 1) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, S = wn(54, 3557, 1) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, br = wn(54, 2777, 1) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1))
                        break r;
                      Q = 2356, l = 19, me = 4075;
                      n: {
                        o:
                          switch (Qr = C, C = y ^ -1, I = ((!(Qr & C) + !(I & C) | 0) + !(C & S) | 0) + !(C & br) | 0, I | 0) {
                            case 0:
                              break n;
                            case 1:
                              break o;
                            default:
                              break i;
                          }
                        if (e[5996] = 0, l = wn(54, 1029, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                          break r;
                        o: {
                          if (l & C)
                            break o;
                          if (e[5996] = 0, l = wn(54, 1959, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                            break r;
                          if (l & C)
                            break o;
                          l = 20, me = 4494;
                          break i;
                        }
                        if (e[5996] = 0, l = wn(54, 2029, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                          break r;
                        o: {
                          if (l & C)
                            break o;
                          if (e[5996] = 0, l = wn(54, 1029, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                            break r;
                          if (l & C)
                            break o;
                          l = 21, me = 4356;
                          break i;
                        }
                        if (e[5996] = 0, l = wn(54, 2029, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                          break r;
                        o: {
                          if (l & C)
                            break o;
                          if (e[5996] = 0, l = wn(54, 2777, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                            break r;
                          if (l & C)
                            break o;
                          l = 22, me = 4771;
                          break i;
                        }
                        if (e[5996] = 0, l = wn(54, 2796, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                          break r;
                        o: {
                          if (l & C)
                            break o;
                          if (e[5996] = 0, l = wn(54, 2522, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                            break r;
                          if (l & C)
                            break o;
                          l = 23, me = 4702;
                          break i;
                        }
                        if (e[5996] = 0, l = wn(54, 3310, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                          break r;
                        o: {
                          if (l & C)
                            break o;
                          if (e[5996] = 0, l = wn(54, 1295, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                            break r;
                          if (!(l & C))
                            break o;
                          l = 24, me = 4426;
                          break i;
                        }
                        if (e[5996] = 0, l = wn(54, 2796, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                          break r;
                        o: {
                          if (l & C)
                            break o;
                          if (e[5996] = 0, l = wn(54, 1295, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                            break r;
                          if (l & C)
                            break o;
                          l = 25, me = 4391;
                          break i;
                        }
                        if (e[5996] = 0, l = wn(54, 2451, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                          break r;
                        o: {
                          if (l & C)
                            break o;
                          if (e[5996] = 0, l = wn(54, 2315, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                            break r;
                          if (l & C)
                            break o;
                          l = 26, me = 4563;
                          break i;
                        }
                        if (e[5996] = 0, l = wn(54, 2451, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                          break r;
                        o: {
                          if (l & C)
                            break o;
                          if (e[5996] = 0, l = wn(54, 2522, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                            break r;
                          if (!(l & C))
                            break o;
                          l = 27, me = 4737;
                          break i;
                        }
                        if (e[5996] = 0, l = wn(54, 2796, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                          break r;
                        o: {
                          if (l & C)
                            break o;
                          if (e[5996] = 0, l = wn(54, 2451, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                            break r;
                          if (l & C)
                            break o;
                          l = 28, me = 4667;
                          break i;
                        }
                        if (e[5996] = 0, l = wn(54, 2522, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                          break r;
                        o: {
                          if (l & C)
                            break o;
                          if (e[5996] = 0, l = wn(54, 2315, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                            break r;
                          if (l & C)
                            break o;
                          l = 29, me = 4598;
                          break i;
                        }
                        if (e[5996] = 0, l = wn(54, 2796, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                          break r;
                        o: {
                          if (l & C)
                            break o;
                          if (e[5996] = 0, l = wn(54, 2315, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                            break r;
                          if (!(l & C))
                            break o;
                          l = 30, me = 4633;
                          break i;
                        }
                        if (e[5996] = 0, l = wn(54, 3310, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                          break r;
                        o: {
                          if (l & C)
                            break o;
                          if (e[5996] = 0, l = wn(54, 1681, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                            break r;
                          if (!(l & C))
                            break o;
                          l = 31, me = 4460;
                          break i;
                        }
                        if (e[5996] = 0, l = wn(54, 1029, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                          break r;
                        if (l & C) {
                          I = y;
                          break n;
                        }
                        if (e[5996] = 0, l = wn(54, 2049, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                          break r;
                        if (I = y, !(l & C))
                          break n;
                        l = 32, me = 4529;
                        break i;
                      }
                      return Os && Tr(Os), I | 0;
                    }
                    if (e[5996] = 0, ia(44, me | 0, 1859, l | 0, Q | 0), l = e[5996], e[5996] = 0, (l | 0) != 1)
                      break e;
                  }
                }
                l = gi() | 0, Os && Tr(Os), ss(l | 0), jn();
              }
              jn();
            }
            function Ih(l, y, I, C, Q, S, me, ke, Ar, br, Qr) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0, me = me | 0, ke = ke | 0, Ar = Ar | 0, br = br | 0, Qr = Qr | 0;
              var Ur = 0, Xr = 0, Ri = 0, yn = 0, En = 0, Wn = 0, lo = 0, Ro = 0, Xo = 0, bs = 0, Os = 0;
              Ur = bi - 304 | 0, bi = Ur;
              e: {
                t: {
                  r: {
                    i: {
                      n: {
                        o: {
                          a: {
                            s: {
                              A: {
                                u: {
                                  h: {
                                    c: {
                                      f: {
                                        p: {
                                          d: {
                                            g: {
                                              v: {
                                                _: {
                                                  R: {
                                                    if (Xr = Jf(l), Xr >>> 0 >= 2147483632) {
                                                      if (e[5996] = 0, jo(2), l = e[5996], e[5996] = 0, (l | 0) == 1)
                                                        break R;
                                                      break e;
                                                    }
                                                    k: {
                                                      if (Xr >>> 0 <= 10) {
                                                        Se[Ur + 155 | 0] = Xr, Ri = Ur + 144 | 0;
                                                        break k;
                                                      }
                                                      if (e[5996] = 0, yn = (Xr | 15) + 1 | 0, Ri = no(3, yn | 0) | 0, En = e[5996], e[5996] = 0, (En | 0) == 1)
                                                        break R;
                                                      e[Ur + 144 >> 2] = Ri, e[Ur + 148 >> 2] = Xr, e[Ur + 152 >> 2] = yn | -2147483648;
                                                    }
                                                    Se[Sa(Ri, l, Xr) + Xr | 0] = 0, Wn = e[Ur + 144 >> 2], l = Je[Ur + 155 | 0], lo = l << 24 >> 24, Xr = (lo | 0) < 0, En = Xr ? Wn : Ur + 144 | 0, Ro = Xr ? e[Ur + 148 >> 2] : l, Xr = En + Ro | 0, Ri = -1;
                                                    k: {
                                                      for (; ; ) {
                                                        if ((Xr | 0) == (En | 0))
                                                          break k;
                                                        if (Xr = Xr - 1 | 0, yn = Je[Xr | 0], Os = yn >>> 0 <= 63, l = yn & 31, (yn & 63) >>> 0 >= 32 ? (yn = 1 << l, Xo = 0) : (Xo = 1 << l, yn = Xo - 1 & 1 >>> 32 - l), l = Xo & 9728, !(Os & (yn & 1 | (l | 0) != 0)))
                                                          break;
                                                      }
                                                      Ri = Xr - En | 0;
                                                    }
                                                    if (l = Ri + 1 | 0, l >>> 0 > Ro >>> 0) {
                                                      if (e[5996] = 0, jo(108), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                        break e;
                                                      Xr = Ws(22864) | 0, l = Ia;
                                                      break f;
                                                    }
                                                    k: {
                                                      if ((lo | 0) < 0) {
                                                        e[Ur + 148 >> 2] = l;
                                                        break k;
                                                      }
                                                      Se[Ur + 155 | 0] = l, Wn = Ur + 144 | 0;
                                                    }
                                                    Se[l + Wn | 0] = 0, e[Ur + 12 >> 2] = 0, e[Ur + 16 >> 2] = 0;
                                                    k: {
                                                      if (Se[Ur + 155 | 0] >= 0) {
                                                        e[Ur + 120 >> 2] = e[Ur + 152 >> 2], l = e[Ur + 148 >> 2], e[Ur + 112 >> 2] = e[Ur + 144 >> 2], e[Ur + 116 >> 2] = l;
                                                        break k;
                                                      }
                                                      if (e[5996] = 0, Ms(40, Ur + 112 | 0, e[Ur + 144 >> 2], e[Ur + 148 >> 2]), l = e[5996], e[5996] = 0, (l | 0) == 1)
                                                        break _;
                                                    }
                                                    if (e[5996] = 0, Xr = Ur + 128 | 0, Co(109, Xr | 0, Ur + 112 | 0), l = e[5996], e[5996] = 0, (l | 0) == 1)
                                                      break v;
                                                    Ri = Se[Ur + 139 | 0], l = (Ri | 0) < 0, e[Ur + 180 >> 2] = l ? e[Ur + 132 >> 2] : Ri & 255, e[Ur + 176 >> 2] = l ? e[Ur + 128 >> 2] : Xr, e[5996] = 0, Co(29, Ur + 248 | 0, Ur + 176 | 0), l = e[5996], e[5996] = 0;
                                                    k: {
                                                      S: {
                                                        E: {
                                                          w: {
                                                            if ((l | 0) != 1) {
                                                              if (!e[Ur + 180 >> 2])
                                                                break w;
                                                              e[Ur + 240 >> 2] = 0, e[Ur + 244 >> 2] = 0, e[Ur + 232 >> 2] = 0, e[Ur + 236 >> 2] = 0, e[Ur + 224 >> 2] = 0, e[Ur + 228 >> 2] = 0, e[Ur + 216 >> 2] = 0, e[Ur + 220 >> 2] = 0, e[Ur + 208 >> 2] = 0, e[Ur + 212 >> 2] = 0, e[Ur + 200 >> 2] = 0, e[Ur + 204 >> 2] = 0, e[Ur + 192 >> 2] = 0, e[Ur + 196 >> 2] = 0;
                                                              break E;
                                                            }
                                                            if (Xr = Ks(22528, 22864) | 0, l = Ia, (l | 0) != (su(22528) | 0))
                                                              break k;
                                                            if (Zf(Xr | 0) | 0, e[Ur + 240 >> 2] = 0, e[Ur + 244 >> 2] = 0, e[Ur + 232 >> 2] = 0, e[Ur + 236 >> 2] = 0, e[Ur + 224 >> 2] = 0, e[Ur + 228 >> 2] = 0, e[Ur + 216 >> 2] = 0, e[Ur + 220 >> 2] = 0, e[Ur + 208 >> 2] = 0, e[Ur + 212 >> 2] = 0, e[Ur + 200 >> 2] = 0, e[Ur + 204 >> 2] = 0, e[Ur + 192 >> 2] = 0, e[Ur + 196 >> 2] = 0, e[5996] = 0, jo(110), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                              break S;
                                                            Xr = Ws(22864) | 0, l = Ia;
                                                            break k;
                                                          }
                                                          l = e[Ur + 260 >> 2], Xr = e[Ur + 264 >> 2], e[Ur + 260 >> 2] = 0, e[Ur + 264 >> 2] = 0, e[Ur + 204 >> 2] = l, e[Ur + 208 >> 2] = Xr, l = e[Ur + 268 >> 2], Xr = e[Ur + 272 >> 2], e[Ur + 268 >> 2] = 0, e[Ur + 272 >> 2] = 0, e[Ur + 212 >> 2] = l, e[Ur + 216 >> 2] = Xr, e[Ur + 228 >> 2] = e[Ur + 284 >> 2], l = e[Ur + 288 >> 2], e[Ur + 284 >> 2] = 0, e[Ur + 288 >> 2] = 0, e[Ur + 192 >> 2] = e[Ur + 248 >> 2], Xr = e[Ur + 252 >> 2], Ri = e[Ur + 256 >> 2], e[Ur + 252 >> 2] = 0, e[Ur + 256 >> 2] = 0, e[Ur + 196 >> 2] = Xr, e[Ur + 200 >> 2] = Ri, Xr = e[Ur + 280 >> 2], e[Ur + 220 >> 2] = e[Ur + 276 >> 2], e[Ur + 224 >> 2] = Xr, e[Ur + 276 >> 2] = 0, e[Ur + 280 >> 2] = 0, e[Ur + 232 >> 2] = l, e[Ur + 236 >> 2] = e[Ur + 292 >> 2], e[Ur + 292 >> 2] = 0, l = e[Ur + 296 >> 2], e[Ur + 296 >> 2] = 0, e[Ur + 240 >> 2] = l, e[Ur + 244 >> 2] = e[Ur + 300 >> 2];
                                                        }
                                                        ff(Ur + 248 | 0);
                                                      }
                                                      if (!e[Ur + 192 >> 2]) {
                                                        Ri = 0;
                                                        break d;
                                                      }
                                                      e[Ur + 184 >> 2] = 0, e[Ur + 176 >> 2] = 0, e[Ur + 180 >> 2] = 0, e[Ur + 256 >> 2] = 0, e[Ur + 260 >> 2] = 0, e[5996] = 0, e[Ur + 248 >> 2] = 0, e[Ur + 252 >> 2] = 0, e[Ur + 264 >> 2] = 1065353216, yn = Ko(111, Ur + 192 | 0, Ur + 248 | 0, Ur + 176 | 0) | 0, l = e[5996], e[5996] = 0;
                                                      S: {
                                                        if ((l | 0) != 1) {
                                                          if (Xr = e[Ur + 256 >> 2], Xr)
                                                            for (; l = e[Xr >> 2], Tr(Xr), Xr = l, !!l; )
                                                              ;
                                                          l = e[Ur + 248 >> 2], Ri = 0, e[Ur + 248 >> 2] = 0, l && Tr(l);
                                                          E: {
                                                            w: {
                                                              if (yn) {
                                                                if (e[Ur + 252 >> 2] = 0, e[Ur + 256 >> 2] = 0, e[5996] = 0, e[Ur + 248 >> 2] = Ur + 252, l = Ic(50, yn | 0, 1, 0, Ur + 248 | 0) | 0, Xr = e[5996], e[5996] = 0, (Xr | 0) == 1)
                                                                  break w;
                                                                e[5996] = 0, Xr = wn(54, 1639, 3) | 0, Ri = e[5996], e[5996] = 0;
                                                                I: {
                                                                  l: {
                                                                    T: {
                                                                      m: {
                                                                        if ((Ri | 0) == 1 || (Ri = e[l >> 2], l = e[l + 4 >> 2], e[5996] = 0, Xf(51, Ur + 160 | 0, Ri | 0, l | 0, Xr | 0, 0), l = e[5996], e[5996] = 0, (l | 0) == 1))
                                                                          break m;
                                                                        if (Xr = e[Ur + 164 >> 2], Ri = e[Ur + 160 >> 2], yn = Xr - Ri | 0, (yn | 0) != 32)
                                                                          break T;
                                                                        Xr = e[Ri >> 2], En = e[Ri + 4 >> 2], e[Ri >> 2] = 0, e[Ri + 4 >> 2] = 0, l = e[Ur + 16 >> 2], e[Ur + 12 >> 2] = Xr, e[Ur + 16 >> 2] = En;
                                                                        C: {
                                                                          if (!l || (Xr = e[l + 4 >> 2], e[l + 4 >> 2] = Xr - 1, Xr))
                                                                            break C;
                                                                          Yn[e[e[l >> 2] + 8 >> 2]](l), Ls(l);
                                                                        }
                                                                        Ri = e[Ur + 160 >> 2], bs = zo[Ri + 8 >> 3], Xr = e[Ur + 164 >> 2];
                                                                        break l;
                                                                      }
                                                                      Xr = Ws(22864) | 0;
                                                                      break E;
                                                                    }
                                                                    if (!Ri)
                                                                      break I;
                                                                  }
                                                                  if ((Xr | 0) != (Ri | 0)) {
                                                                    for (; ; ) {
                                                                      Xr = Xr - 32 | 0, l = e[Xr + 4 >> 2];
                                                                      l: {
                                                                        if (!l || (En = e[l + 4 >> 2], e[l + 4 >> 2] = En - 1, En))
                                                                          break l;
                                                                        Yn[e[e[l >> 2] + 8 >> 2]](l), Ls(l);
                                                                      }
                                                                      if ((Xr | 0) == (Ri | 0))
                                                                        break;
                                                                    }
                                                                    Xr = e[Ur + 160 >> 2];
                                                                  }
                                                                  e[Ur + 164 >> 2] = Ri, Tr(Xr);
                                                                }
                                                                Vl(e[Ur + 252 >> 2]), Ri = (yn | 0) == 32;
                                                              }
                                                              if (l = e[Ur + 176 >> 2], !l)
                                                                break d;
                                                              if (Xr = e[Ur + 180 >> 2], (l | 0) != (Xr | 0)) {
                                                                for (; Xr = Xr - 4 | 0, Wl(Xr), (l | 0) != (Xr | 0); )
                                                                  ;
                                                                l = e[Ur + 176 >> 2];
                                                              }
                                                              Tr(l);
                                                              break d;
                                                            }
                                                            Xr = Ws(22864) | 0;
                                                          }
                                                          l = Ia, Vl(e[Ur + 252 >> 2]);
                                                          break S;
                                                        }
                                                        if (Xr = Ws(22864) | 0, l = Ia, ke = e[Ur + 256 >> 2], ke)
                                                          for (; Ar = e[ke >> 2], Tr(ke), ke = Ar, !!ke; )
                                                            ;
                                                        ke = e[Ur + 248 >> 2], e[Ur + 248 >> 2] = 0, ke && Tr(ke);
                                                      }
                                                      if (ke = e[Ur + 176 >> 2], ke) {
                                                        if (br = e[Ur + 180 >> 2], Ar = ke, (br | 0) != (ke | 0)) {
                                                          for (; br = br - 4 | 0, Wl(br), (ke | 0) != (br | 0); )
                                                            ;
                                                          Ar = e[Ur + 176 >> 2];
                                                        }
                                                        e[Ur + 180 >> 2] = ke, Tr(Ar);
                                                      }
                                                      ff(Ur + 192 | 0);
                                                    }
                                                    if (Se[Ur + 139 | 0] >= 0)
                                                      break g;
                                                    Tr(e[Ur + 128 >> 2]);
                                                    break g;
                                                  }
                                                  Xr = Ws(22864) | 0, l = Ia;
                                                  break c;
                                                }
                                                Xr = Ws(22864) | 0, l = Ia;
                                                break p;
                                              }
                                              Xr = Ws(22864) | 0, l = Ia;
                                            }
                                            if (Se[Ur + 123 | 0] >= 0)
                                              break p;
                                            Tr(e[Ur + 112 >> 2]);
                                            break p;
                                          }
                                          ff(Ur + 192 | 0), Se[Ur + 139 | 0] < 0 && Tr(e[Ur + 128 >> 2]), Se[Ur + 123 | 0] < 0 && Tr(e[Ur + 112 >> 2]);
                                          d: {
                                            g: {
                                              v: {
                                                _: {
                                                  R: {
                                                    k: {
                                                      S: {
                                                        E: {
                                                          if (!Ri) {
                                                            e[5996] = 0, l = no(3, 16) | 0, ke = e[5996], e[5996] = 0;
                                                            w: {
                                                              I: {
                                                                if ((ke | 0) != 1) {
                                                                  if (Se[l + 15 | 0] = 0, ke = Je[2587] | Je[2588] << 8 | (Je[2589] << 16 | Je[2590] << 24), Ar = Je[2583] | Je[2584] << 8 | (Je[2585] << 16 | Je[2586] << 24), Se[l + 7 | 0] = Ar, Se[l + 8 | 0] = Ar >>> 8, Se[l + 9 | 0] = Ar >>> 16, Se[l + 10 | 0] = Ar >>> 24, Se[l + 11 | 0] = ke, Se[l + 12 | 0] = ke >>> 8, Se[l + 13 | 0] = ke >>> 16, Se[l + 14 | 0] = ke >>> 24, ke = Je[2580] | Je[2581] << 8 | (Je[2582] << 16 | Je[2583] << 24), Ar = Je[2576] | Je[2577] << 8 | (Je[2578] << 16 | Je[2579] << 24), Se[l | 0] = Ar, Se[l + 1 | 0] = Ar >>> 8, Se[l + 2 | 0] = Ar >>> 16, Se[l + 3 | 0] = Ar >>> 24, Se[l + 4 | 0] = ke, Se[l + 5 | 0] = ke >>> 8, Se[l + 6 | 0] = ke >>> 16, Se[l + 7 | 0] = ke >>> 24, ke = ((I | 0) >= 16 ? 16 : I) - 1 | 0, Se[Sa(y, l, ke) + ke | 0] = 0, Tr(l), e[5996] = 0, Qr = no(3, 16) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1)
                                                                    break I;
                                                                  if (Se[Qr + 15 | 0] = 0, ke = Je[2587] | Je[2588] << 8 | (Je[2589] << 16 | Je[2590] << 24), Ar = ke, l = Je[2583] | Je[2584] << 8 | (Je[2585] << 16 | Je[2586] << 24), Se[Qr + 7 | 0] = l, Ri = l >>> 8 | 0, Se[Qr + 8 | 0] = Ri, yn = l >>> 16 | 0, Se[Qr + 9 | 0] = yn, En = l >>> 24 | 0, Se[Qr + 10 | 0] = En, Se[Qr + 11 | 0] = ke, Se[Qr + 12 | 0] = ke >>> 8, Se[Qr + 13 | 0] = ke >>> 16, Se[Qr + 14 | 0] = ke >>> 24, br = Je[2580] | Je[2581] << 8 | (Je[2582] << 16 | Je[2583] << 24), ke = Je[2576] | Je[2577] << 8 | (Je[2578] << 16 | Je[2579] << 24), Se[Qr | 0] = ke, Se[Qr + 1 | 0] = ke >>> 8, Se[Qr + 2 | 0] = ke >>> 16, Se[Qr + 3 | 0] = ke >>> 24, Se[Qr + 4 | 0] = br, Se[Qr + 5 | 0] = br >>> 8, Se[Qr + 6 | 0] = br >>> 16, Se[Qr + 7 | 0] = br >>> 24, Xr = ((Q | 0) >= 16 ? 16 : Q) - 1 | 0, Se[Sa(C, Qr, Xr) + Xr | 0] = 0, Tr(Qr), e[5996] = 0, Qr = no(3, 16) | 0, Xr = e[5996], e[5996] = 0, (Xr | 0) == 1)
                                                                    break w;
                                                                  Se[Qr + 15 | 0] = 0, Se[Qr + 7 | 0] = l, Se[Qr + 8 | 0] = Ri, Se[Qr + 9 | 0] = yn, Se[Qr + 10 | 0] = En, l = Ar, Se[Qr + 11 | 0] = l, Se[Qr + 12 | 0] = l >>> 8, Se[Qr + 13 | 0] = l >>> 16, Se[Qr + 14 | 0] = l >>> 24, Se[Qr | 0] = ke, Se[Qr + 1 | 0] = ke >>> 8, Se[Qr + 2 | 0] = ke >>> 16, Se[Qr + 3 | 0] = ke >>> 24, l = br, Se[Qr + 4 | 0] = l, Se[Qr + 5 | 0] = l >>> 8, Se[Qr + 6 | 0] = l >>> 16, Se[Qr + 7 | 0] = l >>> 24, l = ((me | 0) >= 16 ? 16 : me) - 1 | 0, Se[Sa(S, Qr, l) + l | 0] = 0, Tr(Qr);
                                                                  break E;
                                                                }
                                                                Xr = Ws(22864) | 0, l = Ia;
                                                                break p;
                                                              }
                                                              Xr = Ws(22864) | 0, l = Ia;
                                                              break p;
                                                            }
                                                            Xr = Ws(22864) | 0, l = Ia;
                                                            break p;
                                                          }
                                                          if (e[5996] = 0, l = e[Ur + 12 >> 2], e[Ur + 200 >> 2] = 0, e[Ur + 192 >> 2] = 0, e[Ur + 196 >> 2] = 0, En = no(3, 12) | 0, Xr = e[5996], e[5996] = 0, (Xr | 0) == 1)
                                                            break d;
                                                          Se[En + 8 | 0] = 0, e[En + 4 >> 2] = 0, e[En >> 2] = l, Xr = En + 12 | 0, Xo = Xr;
                                                          w: {
                                                            I: {
                                                              l: {
                                                                for (; ; ) {
                                                                  T: {
                                                                    lo = Xr - 12 | 0, yn = e[lo + 4 >> 2], l = e[lo >> 2], Ri = e[l + 32 >> 2], Ro = e[l + 36 >> 2] - Ri >> 3;
                                                                    m: {
                                                                      if (Ro >>> 0 > yn >>> 0) {
                                                                        Ro = 1, e[lo + 4 >> 2] = yn + 1, l = e[l >> 2];
                                                                        C: {
                                                                          if (l - 10 >>> 0 < 7)
                                                                            break C;
                                                                          D:
                                                                            switch (l - 17 | 0) {
                                                                              case 0:
                                                                                Ro = e[e[Ri + 8 >> 2] >> 2] == 1;
                                                                                break C;
                                                                              case 5:
                                                                                if (!e[e[Ri >> 2] >> 2])
                                                                                  break C;
                                                                                Ro = !e[e[Ri + 8 >> 2] >> 2];
                                                                                break C;
                                                                              default:
                                                                                break D;
                                                                            }
                                                                          Ro = 0;
                                                                        }
                                                                        if (l = e[Ri + (yn << 3) >> 2], Xr >>> 0 < Xo >>> 0) {
                                                                          Se[Xr + 8 | 0] = Ro, e[Xr + 4 >> 2] = 0, e[Xr >> 2] = l, Xr = Xr + 12 | 0;
                                                                          break m;
                                                                        }
                                                                        C: {
                                                                          lo = (Xr - En | 0) / 12 | 0, Ri = lo + 1 | 0;
                                                                          D: {
                                                                            if (Ri >>> 0 >= 357913942) {
                                                                              e[5996] = 0, jo(112);
                                                                              break D;
                                                                            }
                                                                            if (yn = (Xo - En | 0) / 12 | 0, Wn = yn << 1, Ri = yn >>> 0 >= 178956970 ? 357913941 : Ri >>> 0 < Wn >>> 0 ? Wn : Ri, Ri >>> 0 < 357913942)
                                                                              break C;
                                                                            e[5996] = 0, jo(35);
                                                                          }
                                                                          if (l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                            break e;
                                                                          Xr = Ws(22864) | 0;
                                                                          break v;
                                                                        }
                                                                        if (e[5996] = 0, Wn = No(Ri, 12), yn = no(3, Wn | 0) | 0, Ri = e[5996], e[5996] = 0, (Ri | 0) == 1)
                                                                          break _;
                                                                        if (Ri = yn + No(lo, 12) | 0, Se[Ri + 8 | 0] = Ro, e[Ri + 4 >> 2] = 0, e[Ri >> 2] = l, l = Ri, (Xr | 0) != (En | 0))
                                                                          for (; Xr = Xr - 12 | 0, lo = e[Xr + 4 >> 2], l = l - 12 | 0, e[l >> 2] = e[Xr >> 2], e[l + 4 >> 2] = lo, e[l + 8 >> 2] = e[Xr + 8 >> 2], (Xr | 0) != (En | 0); )
                                                                            ;
                                                                        Xo = yn + Wn | 0, Xr = Ri + 12 | 0, En && Tr(En), En = l;
                                                                        break m;
                                                                      }
                                                                      if (Wn = e[Ur + 192 >> 2], Ri = (e[Ur + 196 >> 2] - Wn | 0) / 12 | 0, Ri >>> 0 < Ro >>> 0) {
                                                                        if (e[5996] = 0, ia(44, 5135, 2210, 439, 2439), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                          break e;
                                                                        Xr = Ws(22864) | 0;
                                                                        break v;
                                                                      }
                                                                      Xr = Je[Xr - 4 | 0], e[5996] = 0, Xf(113, Ur + 248 | 0, Xr | 0, l | 0, (No(Ri, 12) + Wn | 0) + No(Ro, -12) | 0, Ro | 0), Xr = e[5996], e[5996] = 0;
                                                                      C: {
                                                                        if ((Xr | 0) != 1) {
                                                                          if (Je[Ur + 260 | 0])
                                                                            break C;
                                                                          Ro = 0;
                                                                          break w;
                                                                        }
                                                                        Xr = Ws(22864) | 0;
                                                                        break v;
                                                                      }
                                                                      Ri = e[Ur + 196 >> 2], Xr = e[l + 36 >> 2] - e[l + 32 >> 2] >> 3, l = e[Ur + 192 >> 2], yn = ((Ri + No(Xr, -12) | 0) - l | 0) / 12 | 0;
                                                                      C: {
                                                                        if (!No(Xr, -12)) {
                                                                          Xr = Ri;
                                                                          break C;
                                                                        }
                                                                        if (yn = l + No(yn, 12) | 0, l = yn, Xr = l + No((No(Xr, 12) | 0) / 12 | 0, 12) | 0, (Ri | 0) != (Xr | 0)) {
                                                                          for (; Se[l + 11 | 0] < 0 && Tr(e[l >> 2]), Wn = e[Xr + 4 >> 2], e[l >> 2] = e[Xr >> 2], e[l + 4 >> 2] = Wn, e[l + 8 >> 2] = e[Xr + 8 >> 2], Se[Xr + 11 | 0] = 0, Se[Xr | 0] = 0, l = l + 12 | 0, Xr = Xr + 12 | 0, (Ri | 0) != (Xr | 0); )
                                                                            ;
                                                                          Ri = e[Ur + 196 >> 2];
                                                                        }
                                                                        if (Xr = yn + No((l - yn | 0) / 12 | 0, 12) | 0, (Ri | 0) != (Xr | 0))
                                                                          for (; l = Ri - 12 | 0, Se[Ri - 1 | 0] < 0 && Tr(e[l >> 2]), Ri = l, (l | 0) != (Xr | 0); )
                                                                            ;
                                                                        e[Ur + 196 >> 2] = Xr;
                                                                      }
                                                                      yn = e[Ur + 200 >> 2];
                                                                      C: {
                                                                        if (yn >>> 0 > Xr >>> 0) {
                                                                          l = e[Ur + 252 >> 2], e[Xr >> 2] = e[Ur + 248 >> 2], e[Xr + 4 >> 2] = l, e[Xr + 8 >> 2] = e[Ur + 256 >> 2], e[Ur + 256 >> 2] = 0, e[Ur + 248 >> 2] = 0, e[Ur + 252 >> 2] = 0, e[Ur + 196 >> 2] = Xr + 12;
                                                                          break C;
                                                                        }
                                                                        D: {
                                                                          b: {
                                                                            Ri = e[Ur + 192 >> 2], Ro = (Xr - Ri | 0) / 12 | 0, l = Ro + 1 | 0;
                                                                            B: {
                                                                              if (l >>> 0 >= 357913942) {
                                                                                e[5996] = 0, jo(41);
                                                                                break B;
                                                                              }
                                                                              if (yn = (yn - Ri | 0) / 12 | 0, Wn = yn << 1, Wn = yn >>> 0 >= 178956970 ? 357913941 : l >>> 0 < Wn >>> 0 ? Wn : l, !Wn) {
                                                                                yn = 0;
                                                                                break D;
                                                                              }
                                                                              if (Wn >>> 0 < 357913942)
                                                                                break b;
                                                                              e[5996] = 0, jo(35);
                                                                            }
                                                                            if (l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                              break e;
                                                                            Xr = Ws(22864) | 0;
                                                                            break l;
                                                                          }
                                                                          if (e[5996] = 0, yn = no(3, No(Wn, 12) | 0) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1)
                                                                            break T;
                                                                        }
                                                                        l = No(Ro, 12) + yn | 0, Ro = e[Ur + 252 >> 2], e[l >> 2] = e[Ur + 248 >> 2], e[l + 4 >> 2] = Ro, e[l + 8 >> 2] = e[Ur + 256 >> 2], e[Ur + 256 >> 2] = 0, e[Ur + 248 >> 2] = 0, e[Ur + 252 >> 2] = 0, yn = No(Wn, 12) + yn | 0, Wn = l + 12 | 0;
                                                                        D: {
                                                                          if ((Xr | 0) == (Ri | 0)) {
                                                                            e[Ur + 200 >> 2] = yn, e[Ur + 196 >> 2] = Wn, e[Ur + 192 >> 2] = l;
                                                                            break D;
                                                                          }
                                                                          for (; Xr = Xr - 12 | 0, Ro = e[Xr + 4 >> 2], l = l - 12 | 0, e[l >> 2] = e[Xr >> 2], e[l + 4 >> 2] = Ro, e[l + 8 >> 2] = e[Xr + 8 >> 2], e[Xr >> 2] = 0, e[Xr + 4 >> 2] = 0, e[Xr + 8 >> 2] = 0, (Xr | 0) != (Ri | 0); )
                                                                            ;
                                                                          if (e[Ur + 200 >> 2] = yn, Ri = e[Ur + 196 >> 2], e[Ur + 196 >> 2] = Wn, Xr = e[Ur + 192 >> 2], e[Ur + 192 >> 2] = l, (Xr | 0) == (Ri | 0))
                                                                            break D;
                                                                          for (; l = Ri - 12 | 0, Se[Ri - 1 | 0] < 0 && Tr(e[l >> 2]), Ri = l, (l | 0) != (Xr | 0); )
                                                                            ;
                                                                        }
                                                                        if (!Xr)
                                                                          break C;
                                                                        Tr(Xr);
                                                                      }
                                                                      !Je[Ur + 260 | 0] | Se[Ur + 259 | 0] >= 0 || Tr(e[Ur + 248 >> 2]), Xr = lo;
                                                                    }
                                                                    if ((Xr | 0) != (En | 0))
                                                                      continue;
                                                                    break I;
                                                                  }
                                                                  break;
                                                                }
                                                                Xr = Ws(22864) | 0;
                                                              }
                                                              if (l = Ia, !Je[Ur + 260 | 0] | Se[Ur + 259 | 0] >= 0)
                                                                break g;
                                                              Tr(e[Ur + 248 >> 2]);
                                                              break g;
                                                            }
                                                            if (l = e[Ur + 192 >> 2], (e[Ur + 196 >> 2] - l | 0) != 12) {
                                                              if (e[5996] = 0, ia(44, 4102, 2210, 450, 2439), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                break e;
                                                              Xr = Ws(22864) | 0;
                                                              break v;
                                                            }
                                                            Ro = e[l >> 2], e[Ur + 160 >> 2] = e[l + 4 >> 2], Xr = Je[l + 7 | 0] | Je[l + 8 | 0] << 8 | (Je[l + 9 | 0] << 16 | Je[l + 10 | 0] << 24), Se[Ur + 163 | 0] = Xr, Se[Ur + 164 | 0] = Xr >>> 8, Se[Ur + 165 | 0] = Xr >>> 16, Se[Ur + 166 | 0] = Xr >>> 24, e[l >> 2] = 0, e[l + 4 >> 2] = 0, Wn = Je[l + 11 | 0], e[l + 8 >> 2] = 0;
                                                          }
                                                          if (Ri = e[Ur + 192 >> 2], Ri) {
                                                            if (l = e[Ur + 196 >> 2], Xr = Ri, (l | 0) != (Xr | 0)) {
                                                              for (; Xr = l - 12 | 0, Se[l - 1 | 0] < 0 && Tr(e[Xr >> 2]), l = Xr, (Ri | 0) != (l | 0); )
                                                                ;
                                                              Xr = e[Ur + 192 >> 2];
                                                            }
                                                            e[Ur + 196 >> 2] = Ri, Tr(Xr);
                                                          }
                                                          En && Tr(En), l = Je[Ur + 163 | 0] | Je[Ur + 164 | 0] << 8 | (Je[Ur + 165 | 0] << 16 | Je[Ur + 166 | 0] << 24), Se[Ur + 103 | 0] = l, Se[Ur + 104 | 0] = l >>> 8, Se[Ur + 105 | 0] = l >>> 16, Se[Ur + 106 | 0] = l >>> 24, e[Ur + 100 >> 2] = e[Ur + 160 >> 2], e[Ur + 96 >> 2] = Ro, e[Ur + 160 >> 2] = 0, Se[Ur + 163 | 0] = 0, Se[Ur + 164 | 0] = 0, Se[Ur + 165 | 0] = 0, Se[Ur + 166 | 0] = 0, Se[Ur + 107 | 0] = Wn;
                                                          w: {
                                                            I: {
                                                              l: {
                                                                T: {
                                                                  m: {
                                                                    C: {
                                                                      D: {
                                                                        b: {
                                                                          B: {
                                                                            y: {
                                                                              x: {
                                                                                P: {
                                                                                  M: {
                                                                                    N: {
                                                                                      O: {
                                                                                        U: {
                                                                                          F: {
                                                                                            Q: {
                                                                                              L: {
                                                                                                q: {
                                                                                                  H: {
                                                                                                    $: {
                                                                                                      En = e[Ur + 100 >> 2], l = Wn << 24 >> 24 < 0, Xr = l ? En : Wn & 255;
                                                                                                      K: {
                                                                                                        if ((Xr | 0) < 72)
                                                                                                          break K;
                                                                                                        for (yn = l ? Ro : Ur + 96 | 0, Ri = yn + Xr | 0; ; ) {
                                                                                                          for (l = yn; ; ) {
                                                                                                            if (l = Hs(l, 115, Xr - 71 | 0), !l)
                                                                                                              break K;
                                                                                                            if (Wf(l, 5034, 72)) {
                                                                                                              if (l = l + 1 | 0, Xr = Ri - l | 0, (Xr | 0) >= 72)
                                                                                                                continue;
                                                                                                              break K;
                                                                                                            }
                                                                                                            break;
                                                                                                          }
                                                                                                          if ((l | 0) == (Ri | 0) || (l = l - yn | 0, (l | 0) == -1))
                                                                                                            break K;
                                                                                                          if (e[5996] = 0, Xr = Ur + 96 | 0, ia(114, Xr | 0, l | 0, 72, 4824), l = e[5996], e[5996] = 0, (l | 0) == 1)
                                                                                                            break $;
                                                                                                          if (Ro = e[Ur + 96 >> 2], Ri = Xr, l = Je[Ur + 107 | 0], Wn = l << 24 >> 24, Xr = (Wn | 0) < 0, yn = Xr ? Ro : Ri, En = e[Ur + 100 >> 2], Xr = Xr ? En : l, Ri = yn + Xr | 0, !((Xr | 0) > 71))
                                                                                                            break;
                                                                                                        }
                                                                                                      }
                                                                                                      K: {
                                                                                                        l = Wn << 24 >> 24, Xr = (l | 0) < 0 ? En : Wn & 255;
                                                                                                        G: {
                                                                                                          if ((Xr | 0) < 73)
                                                                                                            break G;
                                                                                                          for (yn = (l | 0) < 0 ? Ro : Ur + 96 | 0, Ri = yn + Xr | 0; ; ) {
                                                                                                            for (l = yn; ; ) {
                                                                                                              if (l = Hs(l, 104, Xr - 72 | 0), !l)
                                                                                                                break G;
                                                                                                              if (Wf(l, 4960, 73)) {
                                                                                                                if (l = l + 1 | 0, Xr = Ri - l | 0, (Xr | 0) >= 73)
                                                                                                                  continue;
                                                                                                                break G;
                                                                                                              }
                                                                                                              break;
                                                                                                            }
                                                                                                            if ((l | 0) == (Ri | 0) || (l = l - yn | 0, (l | 0) == -1))
                                                                                                              break G;
                                                                                                            if (e[5996] = 0, Xr = Ur + 96 | 0, ia(114, Xr | 0, l | 0, 73, 4813), l = e[5996], e[5996] = 0, (l | 0) == 1)
                                                                                                              break K;
                                                                                                            if (Ro = e[Ur + 96 >> 2], Ri = Xr, l = Je[Ur + 107 | 0], Wn = l << 24 >> 24, Xr = (Wn | 0) < 0, yn = Xr ? Ro : Ri, En = e[Ur + 100 >> 2], Xr = Xr ? En : l, Ri = yn + Xr | 0, !((Xr | 0) > 72))
                                                                                                              break;
                                                                                                          }
                                                                                                        }
                                                                                                        G: {
                                                                                                          l = Wn << 24 >> 24 < 0, Xr = l ? En : Wn & 255;
                                                                                                          Y: {
                                                                                                            if ((Xr | 0) < 51)
                                                                                                              break Y;
                                                                                                            for (yn = l ? Ro : Ur + 96 | 0, Ri = yn + Xr | 0; ; ) {
                                                                                                              for (l = yn; ; ) {
                                                                                                                if (l = Hs(l, 114, Xr - 50 | 0), !l)
                                                                                                                  break Y;
                                                                                                                if (Wf(l, 4908, 51)) {
                                                                                                                  if (l = l + 1 | 0, Xr = Ri - l | 0, (Xr | 0) >= 51)
                                                                                                                    continue;
                                                                                                                  break Y;
                                                                                                                }
                                                                                                                break;
                                                                                                              }
                                                                                                              if ((l | 0) == (Ri | 0) || (l = l - yn | 0, (l | 0) == -1))
                                                                                                                break Y;
                                                                                                              if (e[5996] = 0, Xr = Ur + 96 | 0, ia(114, Xr | 0, l | 0, 51, 4845), l = e[5996], e[5996] = 0, (l | 0) == 1)
                                                                                                                break G;
                                                                                                              if (Ro = e[Ur + 96 >> 2], Ri = Xr, l = Je[Ur + 107 | 0], Wn = l << 24 >> 24, Xr = (Wn | 0) < 0, yn = Xr ? Ro : Ri, En = e[Ur + 100 >> 2], Xr = Xr ? En : l, Ri = yn + Xr | 0, !((Xr | 0) > 50))
                                                                                                                break;
                                                                                                            }
                                                                                                          }
                                                                                                          Y: {
                                                                                                            l = Wn << 24 >> 24, Xr = (l | 0) < 0 ? En : Wn & 255;
                                                                                                            j: {
                                                                                                              if ((Xr | 0) < 49)
                                                                                                                break j;
                                                                                                              for (En = (l | 0) < 0 ? Ro : Ur + 96 | 0, Ri = En + Xr | 0; ; ) {
                                                                                                                for (l = En; ; ) {
                                                                                                                  if (l = Hs(l, 104, Xr - 48 | 0), !l)
                                                                                                                    break j;
                                                                                                                  if (Wf(l, 4858, 49)) {
                                                                                                                    if (l = l + 1 | 0, Xr = Ri - l | 0, (Xr | 0) >= 49)
                                                                                                                      continue;
                                                                                                                    break j;
                                                                                                                  }
                                                                                                                  break;
                                                                                                                }
                                                                                                                if ((l | 0) == (Ri | 0) || (l = l - En | 0, (l | 0) == -1))
                                                                                                                  break j;
                                                                                                                if (e[5996] = 0, Xr = Ur + 96 | 0, ia(114, Xr | 0, l | 0, 49, 4834), l = e[5996], e[5996] = 0, (l | 0) == 1)
                                                                                                                  break Y;
                                                                                                                if (Ri = Xr, l = Je[Ur + 107 | 0], Xr = l << 24 >> 24 < 0, En = Xr ? e[Ur + 96 >> 2] : Ri, Xr = Xr ? e[Ur + 100 >> 2] : l, Ri = En + Xr | 0, !((Xr | 0) > 48))
                                                                                                                  break;
                                                                                                              }
                                                                                                            }
                                                                                                            e[Ur + 184 >> 2] = e[Ur + 104 >> 2], e[Ur + 104 >> 2] = 0, Xr = e[Ur + 100 >> 2], l = e[Ur + 96 >> 2], e[Ur + 176 >> 2] = l, e[Ur + 180 >> 2] = Xr, e[Ur + 96 >> 2] = 0, e[Ur + 100 >> 2] = 0, Xr = Je[Ur + 187 | 0], Ri = Xr << 24 >> 24, yn = (Ri | 0) < 0, En = yn ? l : Ur + 176 | 0, Xr = yn ? e[Ur + 180 >> 2] : Xr, yn = I - 1 | 0, Xr = (Xr | 0) < (yn | 0) ? Xr : yn, Se[Sa(y, En, Xr) + Xr | 0] = 0;
                                                                                                            j: {
                                                                                                              if ((Ri | 0) >= 0 || (Tr(l), Se[Ur + 107 | 0] >= 0))
                                                                                                                break j;
                                                                                                              Tr(e[Ur + 96 >> 2]);
                                                                                                            }
                                                                                                            if (l = e[e[Ur + 12 >> 2] + 84 >> 2], e[5996] = 0, Xr = Ur + 36 | 0, Co(115, Xr | 0, l | 0), l = e[5996], e[5996] = 0, (l | 0) == 1)
                                                                                                              break q;
                                                                                                            if (e[5996] = 0, l = Ko(99, Xr | 0, 0, 5442) | 0, Xr = e[5996], e[5996] = 0, (Xr | 0) == 1)
                                                                                                              break L;
                                                                                                            if (e[Ur + 56 >> 2] = e[l + 8 >> 2], Xr = e[l + 4 >> 2], e[Ur + 48 >> 2] = e[l >> 2], e[Ur + 52 >> 2] = Xr, e[l >> 2] = 0, e[l + 4 >> 2] = 0, e[l + 8 >> 2] = 0, e[5996] = 0, Xr = wn(97, Ur + 48 | 0, 5422) | 0, Ri = e[5996], e[5996] = 0, (Ri | 0) == 1)
                                                                                                              break Q;
                                                                                                            if (e[Ur + 72 >> 2] = e[Xr + 8 >> 2], Ri = e[Xr + 4 >> 2], e[Ur + 64 >> 2] = e[Xr >> 2], e[Ur + 68 >> 2] = Ri, e[Xr >> 2] = 0, e[Xr + 4 >> 2] = 0, e[Xr + 8 >> 2] = 0, e[5996] = 0, Ri = Ur + 248 | 0, ii(116, Ri | 0, +bs), yn = e[5996], e[5996] = 0, (yn | 0) == 1)
                                                                                                              break F;
                                                                                                            if (e[5996] = 0, En = Ri, Ri = Je[Ur + 259 | 0], yn = Ri << 24 >> 24 < 0, Ri = Ko(100, Ur - -64 | 0, (yn ? e[Ur + 248 >> 2] : En) | 0, (yn ? e[Ur + 252 >> 2] : Ri) | 0) | 0, yn = e[5996], e[5996] = 0, (yn | 0) == 1)
                                                                                                              break U;
                                                                                                            if (e[Ur + 88 >> 2] = e[Ri + 8 >> 2], yn = e[Ri + 4 >> 2], e[Ur + 80 >> 2] = e[Ri >> 2], e[Ur + 84 >> 2] = yn, e[Ri >> 2] = 0, e[Ri + 4 >> 2] = 0, e[Ri + 8 >> 2] = 0, e[5996] = 0, yn = wn(97, Ur + 80 | 0, 5504) | 0, En = e[5996], e[5996] = 0, (En | 0) == 1)
                                                                                                              break O;
                                                                                                            if (e[Ur + 136 >> 2] = e[yn + 8 >> 2], En = e[yn + 4 >> 2], e[Ur + 128 >> 2] = e[yn >> 2], e[Ur + 132 >> 2] = En, e[yn >> 2] = 0, e[yn + 4 >> 2] = 0, e[yn + 8 >> 2] = 0, En = e[e[Ur + 12 >> 2] + 84 >> 2], e[5996] = 0, lo = Ur + 192 | 0, ii(116, lo | 0, +(bs + +(En >>> 0))), En = e[5996], e[5996] = 0, (En | 0) == 1)
                                                                                                              break N;
                                                                                                            if (e[5996] = 0, Xo = lo, En = Je[Ur + 203 | 0], lo = En << 24 >> 24 < 0, En = Ko(100, Ur + 128 | 0, (lo ? e[Ur + 192 >> 2] : Xo) | 0, (lo ? e[Ur + 196 >> 2] : En) | 0) | 0, lo = e[5996], e[5996] = 0, (lo | 0) == 1)
                                                                                                              break M;
                                                                                                            if (e[Ur + 168 >> 2] = e[En + 8 >> 2], lo = e[En + 4 >> 2], e[Ur + 160 >> 2] = e[En >> 2], e[Ur + 164 >> 2] = lo, e[En >> 2] = 0, e[En + 4 >> 2] = 0, e[En + 8 >> 2] = 0, e[5996] = 0, lo = wn(97, Ur + 160 | 0, 3567) | 0, Wn = e[5996], e[5996] = 0, (Wn | 0) == 1)
                                                                                                              break P;
                                                                                                            if (e[Ur + 184 >> 2] = e[lo + 8 >> 2], Wn = e[lo + 4 >> 2], e[Ur + 176 >> 2] = e[lo >> 2], e[Ur + 180 >> 2] = Wn, e[lo >> 2] = 0, e[lo + 4 >> 2] = 0, e[lo + 8 >> 2] = 0, Se[Ur + 203 | 0] < 0 && Tr(e[Ur + 192 >> 2]), Se[En + 11 | 0] < 0 && Tr(e[En >> 2]), Se[yn + 11 | 0] < 0 && Tr(e[yn >> 2]), Se[Ur + 259 | 0] < 0 && Tr(e[Ur + 248 >> 2]), Se[Ri + 11 | 0] < 0 && Tr(e[Ri >> 2]), Se[Xr + 11 | 0] < 0 && Tr(e[Xr >> 2]), Se[l + 11 | 0] < 0 && Tr(e[l >> 2]), Ri = e[Ur + 176 >> 2], l = Je[Ur + 187 | 0], yn = l << 24 >> 24, Xr = (yn | 0) < 0, En = Xr ? Ri : Ur + 176 | 0, l = Xr ? e[Ur + 180 >> 2] : l, Xr = Q - 1 | 0, l = (l | 0) < (Xr | 0) ? l : Xr, Se[Sa(C, En, l) + l | 0] = 0, e[5996] = 0, Xr = Ur + 248 | 0, Co(117, Xr | 0, e[Ur + 12 >> 2]), l = e[5996], e[5996] = 0, (l | 0) == 1)
                                                                                                              break T;
                                                                                                            if (e[Ur + 220 >> 2] = e[Ur + 276 >> 2], l = e[Ur + 272 >> 2], e[Ur + 212 >> 2] = e[Ur + 268 >> 2], e[Ur + 216 >> 2] = l, l = e[Ur + 264 >> 2], e[Ur + 204 >> 2] = e[Ur + 260 >> 2], e[Ur + 208 >> 2] = l, l = e[Ur + 256 >> 2], e[Ur + 196 >> 2] = e[Ur + 252 >> 2], e[Ur + 200 >> 2] = l, l = e[Ur + 248 >> 2], e[Ur + 192 >> 2] = l, e[5996] = 0, En = l >>> 0 < 29, lo = En ? Ur + 196 | 0 : e[Ur + 200 >> 2], e[Ur + 248 >> 2] = lo, Wn = Ur + 24 | 0, ia(102, Wn | 0, Xr | 0, lo + (En ? l : l - 29 | 0) | 0, 0), l = e[5996], e[5996] = 0, (l | 0) == 1)
                                                                                                              break l;
                                                                                                            if (l = e[Ur + 24 >> 2], Xr = Je[Ur + 35 | 0], En = Xr << 24 >> 24, lo = (En | 0) < 0, Xo = lo ? l : Wn, Xr = lo ? e[Ur + 28 >> 2] : Xr, lo = me - 1 | 0, Xr = (Xr | 0) < (lo | 0) ? Xr : lo, Se[Sa(S, Xo, Xr) + Xr | 0] = 0, (En | 0) < 0 && Tr(l), qs[Ur + 192 >> 2] >= 29 && Tr(e[Ur + 200 >> 2]), l = e[Ur + 12 >> 2], Xr = e[l + 80 >> 2], !Xr | qs[l + 84 >> 2] > 3600 | (e[l + 52 >> 2] + e[l + 44 >> 2] >>> 0 > 201 | qs[l + 68 >> 2] > 100))
                                                                                                              break I;
                                                                                                            if (e[5996] = 0, En = wn(54, 2049, 1) | 0, lo = e[5996], e[5996] = 0, (lo | 0) == 1)
                                                                                                              break S;
                                                                                                            if ((Xr ^ -1) & En)
                                                                                                              break I;
                                                                                                            if (Xr = e[l + 80 >> 2], e[5996] = 0, En = wn(54, 2165, 1) | 0, lo = e[5996], e[5996] = 0, (lo | 0) == 1)
                                                                                                              break S;
                                                                                                            if (Je[l + 88 | 0] | (Xr ^ -1) & En)
                                                                                                              break I;
                                                                                                            Se[Ur + 252 | 0] = 0, e[Ur + 248 >> 2] = 1702195828, Se[Ur + 259 | 0] = 4, l = ((Qr | 0) >= 5 ? 5 : Qr) - 1 | 0, Se[Sa(br, Ur + 248 | 0, l) + l | 0] = 0;
                                                                                                            break w;
                                                                                                          }
                                                                                                          Xr = Ws(22864) | 0;
                                                                                                          break H;
                                                                                                        }
                                                                                                        Xr = Ws(22864) | 0;
                                                                                                        break H;
                                                                                                      }
                                                                                                      Xr = Ws(22864) | 0;
                                                                                                      break H;
                                                                                                    }
                                                                                                    Xr = Ws(22864) | 0;
                                                                                                  }
                                                                                                  if (l = Ia, Se[Ur + 107 | 0] >= 0)
                                                                                                    break p;
                                                                                                  Tr(e[Ur + 96 >> 2]);
                                                                                                  break p;
                                                                                                }
                                                                                                Xr = Ws(22864) | 0, l = Ia;
                                                                                                break p;
                                                                                              }
                                                                                              Xr = Ws(22864) | 0, l = Ia;
                                                                                              break m;
                                                                                            }
                                                                                            Xr = Ws(22864) | 0, l = Ia;
                                                                                            break C;
                                                                                          }
                                                                                          Xr = Ws(22864) | 0, l = Ia;
                                                                                          break D;
                                                                                        }
                                                                                        Xr = Ws(22864) | 0, l = Ia;
                                                                                        break b;
                                                                                      }
                                                                                      Xr = Ws(22864) | 0, l = Ia;
                                                                                      break B;
                                                                                    }
                                                                                    Xr = Ws(22864) | 0, l = Ia;
                                                                                    break y;
                                                                                  }
                                                                                  Xr = Ws(22864) | 0, l = Ia;
                                                                                  break x;
                                                                                }
                                                                                if (Xr = Ws(22864) | 0, l = Ia, Se[Ur + 171 | 0] >= 0)
                                                                                  break x;
                                                                                Tr(e[Ur + 160 >> 2]);
                                                                              }
                                                                              if (Se[Ur + 203 | 0] >= 0)
                                                                                break y;
                                                                              Tr(e[Ur + 192 >> 2]);
                                                                            }
                                                                            if (Se[Ur + 139 | 0] >= 0)
                                                                              break B;
                                                                            Tr(e[Ur + 128 >> 2]);
                                                                          }
                                                                          if (Se[Ur + 91 | 0] >= 0)
                                                                            break b;
                                                                          Tr(e[Ur + 80 >> 2]);
                                                                        }
                                                                        if (Se[Ur + 259 | 0] >= 0)
                                                                          break D;
                                                                        Tr(e[Ur + 248 >> 2]);
                                                                      }
                                                                      if (Se[Ur + 75 | 0] >= 0)
                                                                        break C;
                                                                      Tr(e[Ur + 64 >> 2]);
                                                                    }
                                                                    if (Se[Ur + 59 | 0] >= 0)
                                                                      break m;
                                                                    Tr(e[Ur + 48 >> 2]);
                                                                  }
                                                                  if (Se[Ur + 47 | 0] >= 0)
                                                                    break p;
                                                                  Tr(e[Ur + 36 >> 2]);
                                                                  break p;
                                                                }
                                                                Xr = Ws(22864) | 0;
                                                                break k;
                                                              }
                                                              if (Xr = Ws(22864) | 0, l = Ia, qs[Ur + 192 >> 2] < 29)
                                                                break R;
                                                              Tr(e[Ur + 200 >> 2]);
                                                              break R;
                                                            }
                                                            Se[Ur + 252 | 0] = Je[2354], Se[Ur + 259 | 0] = 5, Se[Ur + 253 | 0] = 0, e[Ur + 248 >> 2] = Je[2350] | Je[2351] << 8 | (Je[2352] << 16 | Je[2353] << 24), l = ((Qr | 0) >= 6 ? 6 : Qr) - 1 | 0, Se[Sa(br, Ur + 248 | 0, l) + l | 0] = 0;
                                                          }
                                                          if (e[5996] = 0, l = no(118, e[Ur + 12 >> 2]) | 0, br = e[5996], e[5996] = 0, (br | 0) == 1)
                                                            break S;
                                                          w: {
                                                            if (l) {
                                                              Se[Ur + 252 | 0] = 0, e[Ur + 248 >> 2] = 1702195828, Se[Ur + 259 | 0] = 4, l = ((Ar | 0) >= 5 ? 5 : Ar) - 1 | 0, Se[Sa(ke, Ur + 248 | 0, l) + l | 0] = 0;
                                                              break w;
                                                            }
                                                            Se[Ur + 252 | 0] = Je[2354], Se[Ur + 259 | 0] = 5, Se[Ur + 253 | 0] = 0, e[Ur + 248 >> 2] = Je[2350] | Je[2351] << 8 | (Je[2352] << 16 | Je[2353] << 24), l = ((Ar | 0) >= 6 ? 6 : Ar) - 1 | 0, Se[Sa(ke, Ur + 248 | 0, l) + l | 0] = 0;
                                                          }
                                                          if ((yn | 0) >= 0)
                                                            break E;
                                                          Tr(Ri);
                                                        }
                                                        l = e[Ur + 16 >> 2];
                                                        E: {
                                                          if (!l || (y = e[l + 4 >> 2], e[l + 4 >> 2] = y - 1, y))
                                                            break E;
                                                          Yn[e[e[l >> 2] + 8 >> 2]](l), Ls(l);
                                                        }
                                                        if (Se[Ur + 155 | 0] >= 0)
                                                          break h;
                                                        Tr(e[Ur + 144 >> 2]);
                                                        break h;
                                                      }
                                                      Xr = Ws(22864) | 0;
                                                    }
                                                    l = Ia;
                                                  }
                                                  if ((yn | 0) >= 0)
                                                    break p;
                                                  Tr(Ri);
                                                  break p;
                                                }
                                                Xr = Ws(22864) | 0;
                                              }
                                              l = Ia;
                                            }
                                            if (hf(Ur + 192 | 0), !En)
                                              break p;
                                            Tr(En);
                                            break p;
                                          }
                                          Xr = Ws(22864) | 0, l = Ia, hf(Ur + 192 | 0);
                                        }
                                        l2(Ur + 12 | 0);
                                      }
                                      if (Se[Ur + 155 | 0] >= 0)
                                        break c;
                                      Tr(e[Ur + 144 >> 2]);
                                    }
                                    if ((su(22864) | 0) != (l | 0))
                                      break r;
                                    if (l = Zf(Xr | 0) | 0, l = Yn[e[e[l >> 2] + 8 >> 2]](l) | 0, e[5996] = 0, Ar = wn(30, Ur + 24 | 0, l | 0) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1)
                                      break u;
                                    if (e[5996] = 0, l = Ko(99, Ar | 0, 0, 5474) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                                      break A;
                                    if (e[Ur + 152 >> 2] = e[l + 8 >> 2], ke = e[l + 4 >> 2], e[Ur + 144 >> 2] = e[l >> 2], e[Ur + 148 >> 2] = ke, e[l >> 2] = 0, e[l + 4 >> 2] = 0, e[l + 8 >> 2] = 0, e[5996] = 0, ke = wn(97, Ur + 144 | 0, 2611) | 0, br = e[5996], e[5996] = 0, (br | 0) == 1)
                                      break s;
                                    e[Ur + 184 >> 2] = e[ke + 8 >> 2], Ar = e[ke + 4 >> 2], e[Ur + 176 >> 2] = e[ke >> 2], e[Ur + 180 >> 2] = Ar, e[ke >> 2] = 0, e[ke + 4 >> 2] = 0, e[ke + 8 >> 2] = 0, Xr = y, y = e[Ur + 176 >> 2], Ar = Je[Ur + 187 | 0], br = Ar << 24 >> 24, Qr = (br | 0) < 0, Ar = Qr ? e[Ur + 180 >> 2] : Ar, I = I - 1 | 0, I = (I | 0) > (Ar | 0) ? Ar : I, Se[Sa(Xr, Qr ? y : Ur + 176 | 0, I) + I | 0] = 0;
                                    c: {
                                      if ((br | 0) >= 0 || (Tr(y), Se[ke + 11 | 0] >= 0))
                                        break c;
                                      Tr(e[ke >> 2]);
                                    }
                                    if (Se[l + 11 | 0] < 0 && Tr(e[l >> 2]), e[5996] = 0, l = wn(30, Ur + 176 | 0, 5575) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                      break o;
                                    if (Ar = C, y = e[l >> 2], I = Je[l + 11 | 0], C = I << 24 >> 24, ke = (C | 0) < 0, br = ke ? y : l, l = ke ? e[l + 4 >> 2] : I, I = Q - 1 | 0, l = (l | 0) < (I | 0) ? l : I, Se[Sa(Ar, br, l) + l | 0] = 0, (C | 0) < 0 && Tr(y), e[5996] = 0, l = wn(30, Ur + 12 | 0, 5575) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                      break n;
                                    y = e[l >> 2], I = Je[l + 11 | 0], C = I << 24 >> 24, Q = (C | 0) < 0, ke = Q ? y : l, l = Q ? e[l + 4 >> 2] : I, I = me - 1 | 0, l = (l | 0) < (I | 0) ? l : I, Se[Sa(S, ke, l) + l | 0] = 0, (C | 0) < 0 && Tr(y), $a();
                                  }
                                  bi = Ur + 304 | 0;
                                  return;
                                }
                                Xr = gi() | 0;
                                break i;
                              }
                              Xr = gi() | 0;
                              break a;
                            }
                            if (Xr = gi() | 0, Se[Ur + 155 | 0] >= 0)
                              break a;
                            Tr(e[Ur + 144 >> 2]);
                          }
                          if (Se[Ar + 11 | 0] >= 0)
                            break i;
                          Tr(e[Ar >> 2]);
                          break i;
                        }
                        Xr = gi() | 0;
                        break i;
                      }
                      Xr = gi() | 0;
                    }
                    if (e[5996] = 0, jo(110), l = e[5996], e[5996] = 0, (l | 0) == 1)
                      break t;
                  }
                  ss(Xr | 0), jn();
                }
                Ws(0) | 0, _c(), jn();
              }
              jn();
            }
            function Qc(l, y, I) {
              l = l | 0, y = y | 0, I = I | 0;
              var C = 0, Q = 0, S = 0, me = 0, ke = 0, Ar = 0, br = 0, Qr = 0, Ur = 0, Xr = 0, Ri = 0, yn = 0, En = 0, Wn = 0, lo = 0, Ro = 0, Xo = 0, bs = 0, Os = 0;
              S = bi - 144 | 0, bi = S, Ur = zo[y + 24 >> 3], Xr = zo[y + 16 >> 3];
              e: {
                t: {
                  r: {
                    i: {
                      n: {
                        o: {
                          a: {
                            s: {
                              A: {
                                u: {
                                  h: {
                                    c: {
                                      f: {
                                        p: {
                                          d: {
                                            g: {
                                              v: {
                                                _: {
                                                  R: {
                                                    k: {
                                                      S: {
                                                        E: {
                                                          w: {
                                                            I: {
                                                              l: {
                                                                T: {
                                                                  m: {
                                                                    C:
                                                                      switch (Q = e[l >> 2], Q | 0) {
                                                                        case 9:
                                                                          break u;
                                                                        case 8:
                                                                          break h;
                                                                        case 2:
                                                                          break c;
                                                                        case 3:
                                                                          break f;
                                                                        case 14:
                                                                          break p;
                                                                        case 15:
                                                                          break d;
                                                                        case 16:
                                                                          break g;
                                                                        case 19:
                                                                          break v;
                                                                        case 18:
                                                                          break _;
                                                                        case 17:
                                                                          break R;
                                                                        case 10:
                                                                          break k;
                                                                        case 11:
                                                                          break S;
                                                                        case 12:
                                                                          break E;
                                                                        case 13:
                                                                          break w;
                                                                        case 0:
                                                                          break I;
                                                                        case 4:
                                                                        case 5:
                                                                          break l;
                                                                        case 1:
                                                                          break T;
                                                                        case 21:
                                                                          break m;
                                                                        case 20:
                                                                          break C;
                                                                        case 6:
                                                                          break s;
                                                                        case 7:
                                                                          break A;
                                                                        default:
                                                                          break a;
                                                                      }
                                                                    if (C = e[l + 4 >> 2], l = e[l + 8 >> 2], (C | 0) == (l | 0))
                                                                      break a;
                                                                    for (; Qc(e[C >> 2], y, I), C = C + 4 | 0, (l | 0) != (C | 0); )
                                                                      ;
                                                                    break a;
                                                                  }
                                                                  if (l = Dh(l, Xr, Ur, I), C = e[l >> 2], I = e[l + 4 >> 2], (C | 0) == (I | 0))
                                                                    break a;
                                                                  for (; e[S + 56 >> 2] = e[C >> 2], l = e[C + 4 >> 2], e[S + 60 >> 2] = l, l && (e[l + 4 >> 2] = e[l + 4 >> 2] + 1), l = e[S + 60 >> 2], e[S >> 2] = e[S + 56 >> 2], e[S + 4 >> 2] = l, Rc(y, C + 8 | 0, S), C = C + 32 | 0, (I | 0) != (C | 0); )
                                                                    ;
                                                                  break a;
                                                                }
                                                                gc(y, I, 1, l + 4 | 0, 0, 0);
                                                                break a;
                                                              }
                                                              if (Ri = (Q | 0) == 4 ? 4 : 5, bc(S + 56 | 0, Ri, Xr, Ur, 0, 0), e[5996] = 0, C = no(46, Ri | 0) | 0, Q = e[5996], e[5996] = 0, (Q | 0) == 1)
                                                                break o;
                                                              if (e[S + 88 >> 2] = 0, e[S + 80 >> 2] = 0, e[S + 84 >> 2] = 0, Se[S + 136 | 0] = 0, e[S + 132 >> 2] = S + 80, Q = e[C + 4 >> 2], ke = e[C >> 2], Qr = Q - ke | 0, me = (Qr | 0) / 12 | 0, (Q | 0) != (ke | 0)) {
                                                                l: {
                                                                  T: {
                                                                    m: {
                                                                      if (me >>> 0 >= 357913942) {
                                                                        if (e[5996] = 0, jo(47), l = e[5996], e[5996] = 0, (l | 0) == 1)
                                                                          break m;
                                                                        break i;
                                                                      }
                                                                      if (e[5996] = 0, Q = no(3, Qr | 0) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                                                                        break m;
                                                                      if (e[S + 84 >> 2] = Q, e[S + 80 >> 2] = Q, e[S + 88 >> 2] = Q + No(me, 12), me = e[C + 4 >> 2], C = e[C >> 2], e[5996] = 0, C = mf(48, S + 88 | 0, C | 0, me | 0, Q | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) != 1)
                                                                        break l;
                                                                      C = gi() | 0, e[S + 84 >> 2] = Q;
                                                                      break T;
                                                                    }
                                                                    C = gi() | 0;
                                                                  }
                                                                  lh(S + 132 | 0);
                                                                  break r;
                                                                }
                                                                e[S + 84 >> 2] = C;
                                                              }
                                                              if (e[S + 140 >> 2] = 0, e[S + 132 >> 2] = 0, e[S + 136 >> 2] = 0, Q = e[l + 8 >> 2], C = e[l + 4 >> 2], e[5996] = 0, Co(49, S + 132 | 0, Q - C >> 2), Q = e[5996], e[5996] = 0, (Q | 0) != 1) {
                                                                if (C = e[S + 84 >> 2], Q = e[S + 80 >> 2], (C | 0) != (Q | 0))
                                                                  for (bs = l + 40 | 0, C = Q; ; ) {
                                                                    e[S + 128 >> 2] = 0, e[S + 120 >> 2] = 0, e[S + 124 >> 2] = 0;
                                                                    l: {
                                                                      T: {
                                                                        m: {
                                                                          C: {
                                                                            if (me = e[l + 8 >> 2], Q = e[l + 4 >> 2], Wn = No(Ro, 12), C = Wn + C | 0, me - Q >> 2 == e[C + 4 >> 2] - e[C >> 2] >> 3) {
                                                                              if (ke = 0, yn = 1, br = 0, (Q | 0) != (me | 0))
                                                                                break C;
                                                                              break m;
                                                                            }
                                                                            if (e[5996] = 0, ia(44, 5170, 1900, 642, 2497), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                              break i;
                                                                            C = gi() | 0;
                                                                            break T;
                                                                          }
                                                                          C: {
                                                                            D: {
                                                                              for (; ; ) {
                                                                                b: {
                                                                                  if (C = br << 3, Ur = zo[C + e[S + 68 >> 2] >> 3], Xr = zo[C + e[S + 56 >> 2] >> 3], Q = e[(br << 2) + Q >> 2], e[5996] = 0, Q = Ic(50, Q | 0, +Xr, +Ur, I | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                                                    break b;
                                                                                  if (C = C + e[Wn + e[S + 80 >> 2] >> 2] | 0, me = e[C >> 2], C = e[C + 4 >> 2], Qr = e[Q + 4 >> 2], Q = e[Q >> 2], e[5996] = 0, Xf(51, S + 100 | 0, Q | 0, Qr | 0, me | 0, C | 0), Q = e[5996], e[5996] = 0, (Q | 0) == 1)
                                                                                    break D;
                                                                                  me = e[S + 128 >> 2];
                                                                                  B: {
                                                                                    if (me >>> 0 > ke >>> 0) {
                                                                                      e[ke + 8 >> 2] = 0, e[ke >> 2] = 0, e[ke + 4 >> 2] = 0, e[ke >> 2] = e[S + 100 >> 2], e[ke + 4 >> 2] = e[S + 104 >> 2], e[ke + 8 >> 2] = e[S + 108 >> 2], e[S + 124 >> 2] = ke + 12;
                                                                                      break B;
                                                                                    }
                                                                                    y: {
                                                                                      Q = e[S + 120 >> 2], Qr = (ke - Q | 0) / 12 | 0, C = Qr + 1 | 0;
                                                                                      x: {
                                                                                        if (C >>> 0 >= 357913942) {
                                                                                          e[5996] = 0, jo(52);
                                                                                          break x;
                                                                                        }
                                                                                        if (me = (me - Q | 0) / 12 | 0, Ar = me << 1, C = me >>> 0 >= 178956970 ? 357913941 : C >>> 0 < Ar >>> 0 ? Ar : C, C >>> 0 < 357913942)
                                                                                          break y;
                                                                                        e[5996] = 0, jo(35);
                                                                                      }
                                                                                      if (l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                                        break i;
                                                                                      break C;
                                                                                    }
                                                                                    if (e[5996] = 0, Ar = No(C, 12), me = no(3, Ar | 0) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                                      break C;
                                                                                    C = me + No(Qr, 12) | 0, e[C >> 2] = e[S + 100 >> 2], e[C + 4 >> 2] = e[S + 104 >> 2], e[C + 8 >> 2] = e[S + 108 >> 2], e[S + 108 >> 2] = 0, e[S + 100 >> 2] = 0, e[S + 104 >> 2] = 0, me = me + Ar | 0, Qr = C + 12 | 0;
                                                                                    y: {
                                                                                      if ((Q | 0) == (ke | 0)) {
                                                                                        e[S + 128 >> 2] = me, e[S + 124 >> 2] = Qr, e[S + 120 >> 2] = C;
                                                                                        break y;
                                                                                      }
                                                                                      for (; C = C - 12 | 0, ke = ke - 12 | 0, e[C >> 2] = e[ke >> 2], e[C + 4 >> 2] = e[ke + 4 >> 2], e[C + 8 >> 2] = e[ke + 8 >> 2], e[ke + 8 >> 2] = 0, e[ke >> 2] = 0, e[ke + 4 >> 2] = 0, (Q | 0) != (ke | 0); )
                                                                                        ;
                                                                                      if (e[S + 128 >> 2] = me, Q = e[S + 124 >> 2], e[S + 124 >> 2] = Qr, ke = e[S + 120 >> 2], e[S + 120 >> 2] = C, (Q | 0) == (ke | 0))
                                                                                        break y;
                                                                                      for (; ; ) {
                                                                                        if (Ar = Q - 12 | 0, Qr = e[Ar >> 2], Qr) {
                                                                                          if (lo = Q - 8 | 0, C = e[lo >> 2], me = Qr, (C | 0) != (me | 0)) {
                                                                                            for (; ; ) {
                                                                                              C = C - 32 | 0, Q = e[C + 4 >> 2];
                                                                                              x: {
                                                                                                if (!Q || (me = e[Q + 4 >> 2], e[Q + 4 >> 2] = me - 1, me))
                                                                                                  break x;
                                                                                                Yn[e[e[Q >> 2] + 8 >> 2]](Q), Ls(Q);
                                                                                              }
                                                                                              if ((C | 0) == (Qr | 0))
                                                                                                break;
                                                                                            }
                                                                                            me = e[Ar >> 2];
                                                                                          }
                                                                                          e[lo >> 2] = Qr, Tr(me);
                                                                                        }
                                                                                        if (Q = Ar, (ke | 0) == (Q | 0))
                                                                                          break;
                                                                                      }
                                                                                    }
                                                                                    if (ke && Tr(ke), me = e[S + 100 >> 2], !me)
                                                                                      break B;
                                                                                    if (Q = me, C = e[S + 104 >> 2], (Q | 0) != (C | 0)) {
                                                                                      for (; ; ) {
                                                                                        C = C - 32 | 0, Q = e[C + 4 >> 2];
                                                                                        y: {
                                                                                          if (!Q || (ke = e[Q + 4 >> 2], e[Q + 4 >> 2] = ke - 1, ke))
                                                                                            break y;
                                                                                          Yn[e[e[Q >> 2] + 8 >> 2]](Q), Ls(Q);
                                                                                        }
                                                                                        if ((C | 0) == (me | 0))
                                                                                          break;
                                                                                      }
                                                                                      Q = e[S + 100 >> 2];
                                                                                    }
                                                                                    e[S + 104 >> 2] = me, Tr(Q);
                                                                                  }
                                                                                  if (ke = e[S + 124 >> 2], Q = ke - 12 | 0, yn = No(e[Q + 4 >> 2] - e[Q >> 2] >> 5, yn), br = br + 1 | 0, Q = e[l + 4 >> 2], br >>> 0 < e[l + 8 >> 2] - Q >> 2 >>> 0)
                                                                                    continue;
                                                                                  break m;
                                                                                }
                                                                                break;
                                                                              }
                                                                              C = gi() | 0;
                                                                              break T;
                                                                            }
                                                                            C = gi() | 0;
                                                                            break T;
                                                                          }
                                                                          C = gi() | 0, Pc(S + 100 | 0);
                                                                          break T;
                                                                        }
                                                                        for (ke = 0, Qr = e[S + 132 >> 2]; ; ) {
                                                                          if ((ke | 0) == (yn | 0))
                                                                            break l;
                                                                          if (e[l + 8 >> 2] != e[l + 4 >> 2])
                                                                            for (C = 0, me = e[S + 120 >> 2], Q = ke; Ar = No(C, 12), br = Ar + me | 0, me = e[br >> 2], e[Qr + (C << 2) >> 2] = me + ((Q >>> 0) % (e[br + 4 >> 2] - me >> 5 >>> 0) << 5), br = Q, me = e[S + 120 >> 2], Q = Ar + me | 0, Q = (br >>> 0) / (e[Q + 4 >> 2] - e[Q >> 2] >> 5 >>> 0) | 0, C = C + 1 | 0, C >>> 0 < e[l + 8 >> 2] - e[l + 4 >> 2] >> 2 >>> 0; )
                                                                              ;
                                                                          if (e[5996] = 0, ki(53, y | 0, Ri | 0, S + 132 | 0, 0, bs | 0), Q = e[5996], e[5996] = 0, ke = ke + 1 | 0, (Q | 0) == 1)
                                                                            break;
                                                                        }
                                                                        C = gi() | 0;
                                                                      }
                                                                      qc(S + 120 | 0);
                                                                      break n;
                                                                    }
                                                                    if (me = e[S + 120 >> 2], me) {
                                                                      if (C = e[S + 124 >> 2], (me | 0) != (C | 0)) {
                                                                        for (; ; ) {
                                                                          if (Qr = C - 12 | 0, ke = e[Qr >> 2], ke) {
                                                                            if (Q = ke, Ar = C - 8 | 0, C = e[Ar >> 2], (Q | 0) != (C | 0)) {
                                                                              for (; ; ) {
                                                                                C = C - 32 | 0, Q = e[C + 4 >> 2];
                                                                                l: {
                                                                                  if (!Q || (br = e[Q + 4 >> 2], e[Q + 4 >> 2] = br - 1, br))
                                                                                    break l;
                                                                                  Yn[e[e[Q >> 2] + 8 >> 2]](Q), Ls(Q);
                                                                                }
                                                                                if ((C | 0) == (ke | 0))
                                                                                  break;
                                                                              }
                                                                              Q = e[Qr >> 2];
                                                                            }
                                                                            e[Ar >> 2] = ke, Tr(Q);
                                                                          }
                                                                          if (C = Qr, (me | 0) == (C | 0))
                                                                            break;
                                                                        }
                                                                        me = e[S + 120 >> 2];
                                                                      }
                                                                      Tr(me);
                                                                    }
                                                                    if (Ro = Ro + 1 | 0, C = e[S + 80 >> 2], !(Ro >>> 0 < (e[S + 84 >> 2] - C | 0) / 12 >>> 0))
                                                                      break;
                                                                  }
                                                                if (l = e[S + 132 >> 2], l && (Tr(l), C = e[S + 80 >> 2]), C) {
                                                                  if (Q = C, me = e[S + 84 >> 2], (Q | 0) != (me | 0)) {
                                                                    for (; l = me - 12 | 0, y = e[l >> 2], y && (e[me - 8 >> 2] = y, Tr(y)), me = l, (l | 0) != (C | 0); )
                                                                      ;
                                                                    Q = e[S + 80 >> 2];
                                                                  }
                                                                  e[S + 84 >> 2] = C, Tr(Q);
                                                                }
                                                                if (l = e[S + 68 >> 2], l && (e[S + 72 >> 2] = l, Tr(l)), l = e[S + 56 >> 2], !l)
                                                                  break a;
                                                                e[S + 60 >> 2] = l, Tr(l);
                                                                break a;
                                                              }
                                                              C = gi() | 0;
                                                              break n;
                                                            }
                                                            gc(y, I, 0, l + 4 | 0, 0, 0);
                                                            break a;
                                                          }
                                                          bc(S + 56 | 0, 24, Xr, Ur, zo[l + 48 >> 3], e[l + 8 >> 2] - e[l + 4 >> 2] >> 2), e[S + 88 >> 2] = 0, e[S + 80 >> 2] = 0, e[S + 84 >> 2] = 0, e[S + 140 >> 2] = 0, e[S + 132 >> 2] = 0, e[S + 136 >> 2] = 0;
                                                          w: {
                                                            I: {
                                                              l: {
                                                                T: {
                                                                  m: {
                                                                    C: {
                                                                      D: {
                                                                        b: {
                                                                          B: {
                                                                            me = e[l + 4 >> 2];
                                                                            y: {
                                                                              if ((me | 0) == e[l + 8 >> 2]) {
                                                                                Qr = -1, Q = me, C = 0;
                                                                                break y;
                                                                              }
                                                                              Ur = -1, Q = me, Qr = -1;
                                                                              x: {
                                                                                for (; ; ) {
                                                                                  if (C = ke << 3, Xr = zo[C + e[S + 68 >> 2] >> 3], En = zo[C + e[S + 56 >> 2] >> 3], Q = e[(ke << 2) + Q >> 2], e[5996] = 0, Q = Ic(50, Q | 0, +En, +Xr, I | 0) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                                    break B;
                                                                                  e[5996] = 0, C = wn(54, 1283, 5) | 0, me = e[5996], e[5996] = 0;
                                                                                  P: {
                                                                                    M: {
                                                                                      N: {
                                                                                        O: {
                                                                                          U: {
                                                                                            if ((me | 0) == 1 || (me = e[Q >> 2], Ar = e[Q + 4 >> 2], e[5996] = 0, Xf(51, S + 120 | 0, me | 0, Ar | 0, C | 0, 0), C = e[5996], e[5996] = 0, (C | 0) == 1))
                                                                                              break U;
                                                                                            switch (Ar = 1, me = e[S + 120 >> 2], e[S + 124 >> 2] - me >> 5) {
                                                                                              case 0:
                                                                                                break M;
                                                                                              case 1:
                                                                                                break N;
                                                                                              default:
                                                                                                break O;
                                                                                            }
                                                                                          }
                                                                                          C = gi() | 0;
                                                                                          break w;
                                                                                        }
                                                                                        if (e[5996] = 0, ia(44, 4164, 1900, 807, 2386), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                                          break i;
                                                                                        C = gi() | 0;
                                                                                        break I;
                                                                                      }
                                                                                      if (e[5996] = 0, Co(55, S + 80 | 0, me | 0), C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                                        break b;
                                                                                      if (e[5996] = 0, C = wn(54, 1277, 5) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1 || (me = e[Q >> 2], Q = e[Q + 4 >> 2], e[5996] = 0, Xf(51, S + 100 | 0, me | 0, Q | 0, C | 0, 0), Q = e[5996], e[5996] = 0, (Q | 0) == 1))
                                                                                        break P;
                                                                                      N: {
                                                                                        O: {
                                                                                          U:
                                                                                            switch (Q = e[S + 100 >> 2], e[S + 104 >> 2] - Q >> 5) {
                                                                                              case 0:
                                                                                                break N;
                                                                                              case 1:
                                                                                                break O;
                                                                                              default:
                                                                                                break U;
                                                                                            }
                                                                                          if (e[5996] = 0, ia(44, 4146, 1900, 811, 2386), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                                            break i;
                                                                                          break l;
                                                                                        }
                                                                                        if (e[5996] = 0, Co(55, S + 132 | 0, Q | 0), Q = e[5996], e[5996] = 0, (Q | 0) == 1)
                                                                                          break l;
                                                                                        if (Ar = 0, Xr = zo[e[S + 136 >> 2] - 8 >> 3] - zo[e[S + 84 >> 2] - 8 >> 3], !(Xr > Ur))
                                                                                          break N;
                                                                                        Qr = ke, Ur = Xr;
                                                                                      }
                                                                                      if (me = e[S + 100 >> 2], me) {
                                                                                        if (Q = me, C = e[S + 104 >> 2], (Q | 0) != (C | 0)) {
                                                                                          for (; ; ) {
                                                                                            C = C - 32 | 0, Q = e[C + 4 >> 2];
                                                                                            N: {
                                                                                              if (!Q || (br = e[Q + 4 >> 2], e[Q + 4 >> 2] = br - 1, br))
                                                                                                break N;
                                                                                              Yn[e[e[Q >> 2] + 8 >> 2]](Q), Ls(Q);
                                                                                            }
                                                                                            if ((C | 0) == (me | 0))
                                                                                              break;
                                                                                          }
                                                                                          Q = e[S + 100 >> 2];
                                                                                        }
                                                                                        e[S + 104 >> 2] = me, Tr(Q);
                                                                                      }
                                                                                      me = e[S + 120 >> 2];
                                                                                    }
                                                                                    if (me) {
                                                                                      if (Q = me, C = e[S + 124 >> 2], (Q | 0) != (C | 0)) {
                                                                                        for (; ; ) {
                                                                                          C = C - 32 | 0, Q = e[C + 4 >> 2];
                                                                                          M: {
                                                                                            if (!Q || (br = e[Q + 4 >> 2], e[Q + 4 >> 2] = br - 1, br))
                                                                                              break M;
                                                                                            Yn[e[e[Q >> 2] + 8 >> 2]](Q), Ls(Q);
                                                                                          }
                                                                                          if ((C | 0) == (me | 0))
                                                                                            break;
                                                                                        }
                                                                                        Q = e[S + 120 >> 2];
                                                                                      }
                                                                                      e[S + 124 >> 2] = me, Tr(Q);
                                                                                    }
                                                                                    if (Ar)
                                                                                      break T;
                                                                                    if (ke = ke + 1 | 0, me = e[l + 8 >> 2], Q = e[l + 4 >> 2], ke >>> 0 >= me - Q >> 2 >>> 0)
                                                                                      break x;
                                                                                    continue;
                                                                                  }
                                                                                  break;
                                                                                }
                                                                                C = gi() | 0;
                                                                                break I;
                                                                              }
                                                                              C = e[S + 80 >> 2];
                                                                            }
                                                                            if (e[5996] = 0, I = no(3, 4) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                                                                              break D;
                                                                            if (e[I >> 2] = C + (Qr << 5), C = I + 4 | 0, e[S + 128 >> 2] = C, e[S + 124 >> 2] = C, e[S + 120 >> 2] = I, (Q | 0) != (me | 0))
                                                                              for (ke = 0; ; ) {
                                                                                y: {
                                                                                  if ((ke | 0) == (Qr | 0))
                                                                                    break y;
                                                                                  if (I = e[S + 132 >> 2] + (ke << 5) | 0, Ar = e[S + 128 >> 2], Ar >>> 0 > C >>> 0) {
                                                                                    e[C >> 2] = I, C = C + 4 | 0, e[S + 124 >> 2] = C;
                                                                                    break y;
                                                                                  }
                                                                                  x: {
                                                                                    P: {
                                                                                      me = e[S + 120 >> 2], yn = C - me >> 2, Q = yn + 1 | 0;
                                                                                      M: {
                                                                                        if (Q >>> 0 >= 1073741824) {
                                                                                          e[5996] = 0, jo(56);
                                                                                          break M;
                                                                                        }
                                                                                        if (Ar = Ar - me | 0, br = Ar >> 1, Ar = Ar >>> 0 >= 2147483644 ? 1073741823 : Q >>> 0 < br >>> 0 ? br : Q, !Ar) {
                                                                                          br = 0;
                                                                                          break x;
                                                                                        }
                                                                                        if (Ar >>> 0 < 1073741824)
                                                                                          break P;
                                                                                        e[5996] = 0, jo(35);
                                                                                      }
                                                                                      if (l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                                        break i;
                                                                                      C = gi() | 0;
                                                                                      break m;
                                                                                    }
                                                                                    if (e[5996] = 0, br = no(3, Ar << 2) | 0, Q = e[5996], e[5996] = 0, (Q | 0) == 1)
                                                                                      break C;
                                                                                  }
                                                                                  if (Q = (yn << 2) + br | 0, e[Q >> 2] = I, I = Q + 4 | 0, (C | 0) != (me | 0)) {
                                                                                    for (; Q = Q - 4 | 0, C = C - 4 | 0, e[Q >> 2] = e[C >> 2], (C | 0) != (me | 0); )
                                                                                      ;
                                                                                    C = e[S + 120 >> 2];
                                                                                  }
                                                                                  e[S + 128 >> 2] = (Ar << 2) + br, e[S + 124 >> 2] = I, e[S + 120 >> 2] = Q, C && Tr(C), C = I;
                                                                                }
                                                                                if (ke = ke + 1 | 0, !(ke >>> 0 < e[l + 8 >> 2] - e[l + 4 >> 2] >> 2 >>> 0))
                                                                                  break;
                                                                              }
                                                                            if (Ur = zo[l + 48 >> 3], e[5996] = 0, ki(53, y | 0, 24, S + 120 | 0, +Ur, l + 40 | 0), l = e[5996], e[5996] = 0, (l | 0) != 1) {
                                                                              if (l = e[S + 120 >> 2], !l)
                                                                                break T;
                                                                              Tr(l);
                                                                              break T;
                                                                            }
                                                                            C = gi() | 0, me = e[S + 120 >> 2];
                                                                            break m;
                                                                          }
                                                                          C = gi() | 0;
                                                                          break w;
                                                                        }
                                                                        C = gi() | 0;
                                                                        break I;
                                                                      }
                                                                      C = gi() | 0;
                                                                      break w;
                                                                    }
                                                                    C = gi() | 0;
                                                                  }
                                                                  if (!me)
                                                                    break w;
                                                                  Tr(me);
                                                                  break w;
                                                                }
                                                                if (l = e[S + 132 >> 2], l) {
                                                                  if (C = e[S + 136 >> 2], (l | 0) != (C | 0)) {
                                                                    for (; ; ) {
                                                                      C = C - 32 | 0, y = e[C + 4 >> 2];
                                                                      T: {
                                                                        if (!y || (I = e[y + 4 >> 2], e[y + 4 >> 2] = I - 1, I))
                                                                          break T;
                                                                        Yn[e[e[y >> 2] + 8 >> 2]](y), Ls(y);
                                                                      }
                                                                      if ((l | 0) == (C | 0))
                                                                        break;
                                                                    }
                                                                    l = e[S + 132 >> 2];
                                                                  }
                                                                  Tr(l);
                                                                }
                                                                if (l = e[S + 80 >> 2], l) {
                                                                  if (C = e[S + 84 >> 2], (l | 0) != (C | 0)) {
                                                                    for (; ; ) {
                                                                      C = C - 32 | 0, y = e[C + 4 >> 2];
                                                                      T: {
                                                                        if (!y || (I = e[y + 4 >> 2], e[y + 4 >> 2] = I - 1, I))
                                                                          break T;
                                                                        Yn[e[e[y >> 2] + 8 >> 2]](y), Ls(y);
                                                                      }
                                                                      if ((l | 0) == (C | 0))
                                                                        break;
                                                                    }
                                                                    l = e[S + 80 >> 2];
                                                                  }
                                                                  Tr(l);
                                                                }
                                                                if (l = e[S + 68 >> 2], l && (e[S + 72 >> 2] = l, Tr(l)), l = e[S + 56 >> 2], !l)
                                                                  break a;
                                                                e[S + 60 >> 2] = l, Tr(l);
                                                                break a;
                                                              }
                                                              C = gi() | 0, Pc(S + 100 | 0);
                                                            }
                                                            Pc(S + 120 | 0);
                                                          }
                                                          Pc(S + 132 | 0), Pc(S + 80 | 0);
                                                          break r;
                                                        }
                                                        Q = e[l + 4 >> 2], C = e[Q + 4 >> 2], me = e[Q >> 2], ke = e[Q + 8 >> 2], Q = ga(12), e[S + 56 >> 2] = Q, Qr = Q + 12 | 0, e[S + 64 >> 2] = Qr, e[Q + 8 >> 2] = ke, e[Q + 4 >> 2] = me, e[Q >> 2] = C, e[S + 60 >> 2] = Qr, Ur = zo[l + 48 >> 3], e[5996] = 0, kf(57, y | 0, I | 0, 23, l + 4 | 0, +Ur, 0), l = e[5996], e[5996] = 0;
                                                        E: {
                                                          if ((l | 0) == 1 || (e[5996] = 0, kf(57, y | 0, I | 0, 23, S + 56 | 0, +Ur, 0), l = e[5996], e[5996] = 0, (l | 0) == 1))
                                                            break E;
                                                          Tr(Q);
                                                          break a;
                                                        }
                                                        break e;
                                                      }
                                                      Q = e[l + 4 >> 2], C = e[Q >> 2], me = e[Q + 4 >> 2], Q = ga(8), e[S + 56 >> 2] = Q, ke = Q + 8 | 0, e[S + 64 >> 2] = ke, e[Q >> 2] = u1(C, me, 32), e[Q + 4 >> 2] = Ci, e[S + 60 >> 2] = ke, C = l + 4 | 0, Xr = zo[l + 48 >> 3], En = 1 - Xr;
                                                      S: {
                                                        if (Ur == 0 && (e[5996] = 0, kf(57, y | 0, I | 0, 20, C | 0, +Xr, 0), l = e[5996], e[5996] = 0, (l | 0) == 1 || (e[5996] = 0, kf(57, y | 0, I | 0, 20, S + 56 | 0, +En, 0), l = e[5996], e[5996] = 0, (l | 0) == 1)) || (e[5996] = 0, kf(57, y | 0, I | 0, 19, C | 0, +Xr, 0), l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, l = S + 56 | 0, kf(57, y | 0, I | 0, 19, l | 0, +En, 0), me = e[5996], e[5996] = 0, (me | 0) == 1) || (e[5996] = 0, kf(57, y | 0, I | 0, 21, C | 0, +Xr, 0), me = e[5996], e[5996] = 0, (me | 0) == 1) || (e[5996] = 0, kf(57, y | 0, I | 0, 21, l | 0, +En, 0), me = e[5996], e[5996] = 0, (me | 0) == 1) || (e[5996] = 0, kf(57, y | 0, I | 0, 22, C | 0, +Xr, 0), me = e[5996], e[5996] = 0, (me | 0) == 1) || (e[5996] = 0, kf(57, y | 0, I | 0, 22, l | 0, +En, 0), me = e[5996], e[5996] = 0, (me | 0) == 1) || (e[5996] = 0, kf(57, y | 0, I | 0, 22, C | 0, +Xr, 1), C = e[5996], e[5996] = 0, (C | 0) == 1) || (e[5996] = 0, kf(57, y | 0, I | 0, 22, l | 0, +En, 1), l = e[5996], e[5996] = 0, (l | 0) == 1))
                                                          break S;
                                                        Tr(Q);
                                                        break a;
                                                      }
                                                      break e;
                                                    }
                                                    Q = e[l + 4 >> 2], C = e[Q >> 2], me = e[Q + 4 >> 2], Q = ga(8), e[S + 56 >> 2] = Q, ke = Q + 8 | 0, e[S + 64 >> 2] = ke, e[Q >> 2] = u1(C, me, 32), e[Q + 4 >> 2] = Ci, e[S + 60 >> 2] = ke, l = l + 4 | 0;
                                                    k: {
                                                      if (Ur == 0 && (e[5996] = 0, kf(57, y | 0, I | 0, 17, l | 0, 0, 0), C = e[5996], e[5996] = 0, (C | 0) == 1 || (e[5996] = 0, kf(57, y | 0, I | 0, 17, S + 56 | 0, 0, 0), C = e[5996], e[5996] = 0, (C | 0) == 1)) || (e[5996] = 0, kf(57, y | 0, I | 0, 18, l | 0, 0, 0), l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, kf(57, y | 0, I | 0, 18, S + 56 | 0, 0, 0), l = e[5996], e[5996] = 0, (l | 0) == 1))
                                                        break k;
                                                      Tr(Q);
                                                      break a;
                                                    }
                                                    break e;
                                                  }
                                                  gc(y, I, 14, l + 4 | 0, 0, 0);
                                                  break a;
                                                }
                                                gc(y, I, 15, l + 4 | 0, 0, 0);
                                                break a;
                                              }
                                              gc(y, I, 16, l + 4 | 0, 0, 0);
                                              break a;
                                            }
                                            gc(y, I, 13, l + 4 | 0, 0, 0);
                                            break a;
                                          }
                                          gc(y, I, 12, l + 4 | 0, 0, 0);
                                          break a;
                                        }
                                        l = l + 4 | 0, gc(y, I, 10, l, 0, 0), gc(y, I, 11, l, 0, 0);
                                        break a;
                                      }
                                      Q = e[l + 40 >> 2], Qr = e[l + 44 >> 2], Je[24588] || (e[6145] = 0, e[6146] = 0, e[6143] = 0, e[6144] = 0, e[6141] = 0, e[6142] = 0, Se[24588] = 1), Ri = nh(S + 56 | 0), e[5996] = 0, C = no(46, 25) | 0, me = e[5996], e[5996] = 0;
                                      f: {
                                        p: {
                                          if ((me | 0) != 1) {
                                            if (e[S + 52 >> 2] = 0, e[S + 44 >> 2] = 0, e[S + 48 >> 2] = 0, Se[S + 84 | 0] = 0, e[S + 80 >> 2] = S + 44, me = e[C + 4 >> 2], Ar = e[C >> 2], br = me - Ar | 0, ke = (br | 0) / 12 | 0, (me | 0) != (Ar | 0)) {
                                              if (ke >>> 0 >= 357913942) {
                                                if (e[5996] = 0, jo(47), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                  break i;
                                                break p;
                                              }
                                              if (e[5996] = 0, me = no(3, br | 0) | 0, Ar = e[5996], e[5996] = 0, (Ar | 0) == 1)
                                                break p;
                                              if (e[S + 48 >> 2] = me, e[S + 44 >> 2] = me, e[S + 52 >> 2] = me + No(ke, 12), ke = e[C + 4 >> 2], C = e[C >> 2], e[5996] = 0, C = mf(48, S + 52 | 0, C | 0, ke | 0, me | 0) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1) {
                                                C = gi() | 0, e[S + 48 >> 2] = me;
                                                break f;
                                              }
                                              e[S + 48 >> 2] = C;
                                            }
                                            e[S + 40 >> 2] = 0, e[S + 32 >> 2] = 0, e[S + 36 >> 2] = 0, C = e[l + 8 >> 2], me = e[l + 4 >> 2], e[5996] = 0, Co(49, S + 32 | 0, C - me >> 2), C = e[5996], e[5996] = 0;
                                            d: {
                                              if ((C | 0) != 1) {
                                                g: {
                                                  v: {
                                                    if (C = e[S + 48 >> 2], me = e[S + 44 >> 2], (C | 0) != (me | 0))
                                                      for (bs = l + 16 | 0, Ur = +(Q >>> 0) + +(Qr | 0) * 4294967296, Xr = Ur + 1, Ur = Ur * 73 + 1, C = me; ; ) {
                                                        if (e[S + 28 >> 2] = 0, e[S + 20 >> 2] = 0, e[S + 24 >> 2] = 0, me = e[l + 8 >> 2], Q = e[l + 4 >> 2], Wn = No(Ro, 12), C = Wn + C | 0, me - Q >> 2 != e[C + 4 >> 2] - e[C >> 2] >> 3)
                                                          break v;
                                                        ke = 0, yn = 1, br = 0;
                                                        _: {
                                                          if ((Q | 0) != (me | 0)) {
                                                            R: {
                                                              k: {
                                                                S: {
                                                                  for (; ; ) {
                                                                    if (C = br << 3, En = zo[C + e[Ri + 12 >> 2] >> 3], Os = zo[C + e[Ri >> 2] >> 3], Q = e[(br << 2) + Q >> 2], e[5996] = 0, Q = Ic(50, Q | 0, +Os, +En, I | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                                      break k;
                                                                    if (C = C + e[Wn + e[S + 44 >> 2] >> 2] | 0, me = e[C >> 2], C = e[C + 4 >> 2], Qr = e[Q + 4 >> 2], Q = e[Q >> 2], e[5996] = 0, Xf(51, S + 80 | 0, Q | 0, Qr | 0, me | 0, C | 0), Q = e[5996], e[5996] = 0, (Q | 0) != 1) {
                                                                      me = e[S + 28 >> 2];
                                                                      E: {
                                                                        if (me >>> 0 > ke >>> 0) {
                                                                          e[ke + 8 >> 2] = 0, e[ke >> 2] = 0, e[ke + 4 >> 2] = 0, e[ke >> 2] = e[S + 80 >> 2], e[ke + 4 >> 2] = e[S + 84 >> 2], e[ke + 8 >> 2] = e[S + 88 >> 2], e[S + 24 >> 2] = ke + 12;
                                                                          break E;
                                                                        }
                                                                        w: {
                                                                          Q = e[S + 20 >> 2], Qr = (ke - Q | 0) / 12 | 0, C = Qr + 1 | 0;
                                                                          I: {
                                                                            if (C >>> 0 >= 357913942) {
                                                                              e[5996] = 0, jo(52);
                                                                              break I;
                                                                            }
                                                                            if (me = (me - Q | 0) / 12 | 0, Ar = me << 1, C = me >>> 0 >= 178956970 ? 357913941 : C >>> 0 < Ar >>> 0 ? Ar : C, C >>> 0 < 357913942)
                                                                              break w;
                                                                            e[5996] = 0, jo(35);
                                                                          }
                                                                          if (l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                            break i;
                                                                          break S;
                                                                        }
                                                                        if (e[5996] = 0, Ar = No(C, 12), me = no(3, Ar | 0) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                          break S;
                                                                        C = me + No(Qr, 12) | 0, e[C >> 2] = e[S + 80 >> 2], e[C + 4 >> 2] = e[S + 84 >> 2], e[C + 8 >> 2] = e[S + 88 >> 2], e[S + 88 >> 2] = 0, e[S + 80 >> 2] = 0, e[S + 84 >> 2] = 0, me = me + Ar | 0, Qr = C + 12 | 0;
                                                                        w: {
                                                                          if ((Q | 0) == (ke | 0)) {
                                                                            e[S + 28 >> 2] = me, e[S + 24 >> 2] = Qr, e[S + 20 >> 2] = C;
                                                                            break w;
                                                                          }
                                                                          for (; C = C - 12 | 0, ke = ke - 12 | 0, e[C >> 2] = e[ke >> 2], e[C + 4 >> 2] = e[ke + 4 >> 2], e[C + 8 >> 2] = e[ke + 8 >> 2], e[ke + 8 >> 2] = 0, e[ke >> 2] = 0, e[ke + 4 >> 2] = 0, (Q | 0) != (ke | 0); )
                                                                            ;
                                                                          if (e[S + 28 >> 2] = me, Q = e[S + 24 >> 2], e[S + 24 >> 2] = Qr, ke = e[S + 20 >> 2], e[S + 20 >> 2] = C, (Q | 0) == (ke | 0))
                                                                            break w;
                                                                          for (; ; ) {
                                                                            if (Ar = Q - 12 | 0, Qr = e[Ar >> 2], Qr) {
                                                                              if (lo = Q - 8 | 0, C = e[lo >> 2], me = Qr, (C | 0) != (me | 0)) {
                                                                                for (; ; ) {
                                                                                  C = C - 32 | 0, Q = e[C + 4 >> 2];
                                                                                  I: {
                                                                                    if (!Q || (me = e[Q + 4 >> 2], e[Q + 4 >> 2] = me - 1, me))
                                                                                      break I;
                                                                                    Yn[e[e[Q >> 2] + 8 >> 2]](Q), Ls(Q);
                                                                                  }
                                                                                  if ((C | 0) == (Qr | 0))
                                                                                    break;
                                                                                }
                                                                                me = e[Ar >> 2];
                                                                              }
                                                                              e[lo >> 2] = Qr, Tr(me);
                                                                            }
                                                                            if (Q = Ar, (ke | 0) == (Q | 0))
                                                                              break;
                                                                          }
                                                                        }
                                                                        if (ke && Tr(ke), me = e[S + 80 >> 2], !me)
                                                                          break E;
                                                                        if (Q = me, C = e[S + 84 >> 2], (Q | 0) != (C | 0)) {
                                                                          for (; ; ) {
                                                                            C = C - 32 | 0, Q = e[C + 4 >> 2];
                                                                            w: {
                                                                              if (!Q || (ke = e[Q + 4 >> 2], e[Q + 4 >> 2] = ke - 1, ke))
                                                                                break w;
                                                                              Yn[e[e[Q >> 2] + 8 >> 2]](Q), Ls(Q);
                                                                            }
                                                                            if ((C | 0) == (me | 0))
                                                                              break;
                                                                          }
                                                                          Q = e[S + 80 >> 2];
                                                                        }
                                                                        e[S + 84 >> 2] = me, Tr(Q);
                                                                      }
                                                                      if (ke = e[S + 24 >> 2], Q = ke - 12 | 0, yn = No(e[Q + 4 >> 2] - e[Q >> 2] >> 5, yn), br = br + 1 | 0, Q = e[l + 4 >> 2], br >>> 0 >= e[l + 8 >> 2] - Q >> 2 >>> 0)
                                                                        break R;
                                                                      continue;
                                                                    }
                                                                    break;
                                                                  }
                                                                  C = gi() | 0;
                                                                  break g;
                                                                }
                                                                C = gi() | 0, Pc(S + 80 | 0);
                                                                break g;
                                                              }
                                                              C = gi() | 0;
                                                              break g;
                                                            }
                                                            if (!yn)
                                                              break _;
                                                          }
                                                          Qr = 0;
                                                          R: {
                                                            k: {
                                                              S: {
                                                                E: {
                                                                  for (; ; ) {
                                                                    if (ke = e[S + 32 >> 2], e[l + 8 >> 2] != e[l + 4 >> 2])
                                                                      for (C = 0, me = e[S + 20 >> 2], Q = Qr; Ar = No(C, 12), br = Ar + me | 0, me = e[br >> 2], e[(C << 2) + ke >> 2] = me + ((Q >>> 0) % (e[br + 4 >> 2] - me >> 5 >>> 0) << 5), br = Q, me = e[S + 20 >> 2], Q = Ar + me | 0, Q = (br >>> 0) / (e[Q + 4 >> 2] - e[Q >> 2] >> 5 >>> 0) | 0, C = C + 1 | 0, C >>> 0 < e[l + 8 >> 2] - e[l + 4 >> 2] >> 2 >>> 0; )
                                                                        ;
                                                                    e[S + 108 >> 2] = 0, e[S + 100 >> 2] = 0, e[S + 104 >> 2] = 0;
                                                                    w: {
                                                                      I: {
                                                                        if (Wn = e[S + 36 >> 2], (Wn | 0) != (ke | 0))
                                                                          for (; ; ) {
                                                                            Ar = e[ke >> 2], C = e[S + 104 >> 2];
                                                                            l: {
                                                                              if ((C | 0) != e[S + 108 >> 2]) {
                                                                                e[C >> 2] = e[Ar >> 2], Q = e[Ar + 4 >> 2], e[C + 4 >> 2] = Q, Q && (e[Q + 4 >> 2] = e[Q + 4 >> 2] + 1), e[S + 104 >> 2] = C + 8;
                                                                                break l;
                                                                              }
                                                                              T: {
                                                                                me = e[S + 100 >> 2], Q = C - me | 0, lo = Q >> 3, br = lo + 1 | 0;
                                                                                m: {
                                                                                  if (br >>> 0 >= 536870912) {
                                                                                    e[5996] = 0, jo(59);
                                                                                    break m;
                                                                                  }
                                                                                  if (Xo = Q >> 2, Q = Q >>> 0 >= 2147483640 ? 536870911 : br >>> 0 < Xo >>> 0 ? Xo : br, Q >>> 0 < 536870912)
                                                                                    break T;
                                                                                  e[5996] = 0, jo(35);
                                                                                }
                                                                                if (l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                                  break i;
                                                                                C = gi() | 0;
                                                                                break R;
                                                                              }
                                                                              if (e[5996] = 0, Xo = Q << 3, br = no(3, Xo | 0) | 0, Q = e[5996], e[5996] = 0, (Q | 0) == 1)
                                                                                break I;
                                                                              Q = br + (lo << 3) | 0, e[Q >> 2] = e[Ar >> 2], Ar = e[Ar + 4 >> 2], e[Q + 4 >> 2] = Ar, Ar && (e[Ar + 4 >> 2] = e[Ar + 4 >> 2] + 1, C = e[S + 104 >> 2]), Ar = br + Xo | 0, br = Q + 8 | 0;
                                                                              T: {
                                                                                if ((C | 0) == (me | 0)) {
                                                                                  e[S + 108 >> 2] = Ar, e[S + 104 >> 2] = br, e[S + 100 >> 2] = Q;
                                                                                  break T;
                                                                                }
                                                                                for (; Q = Q - 8 | 0, C = C - 8 | 0, e[Q >> 2] = e[C >> 2], e[Q + 4 >> 2] = e[C + 4 >> 2], e[C >> 2] = 0, e[C + 4 >> 2] = 0, (C | 0) != (me | 0); )
                                                                                  ;
                                                                                if (e[S + 108 >> 2] = Ar, C = e[S + 104 >> 2], e[S + 104 >> 2] = br, me = e[S + 100 >> 2], e[S + 100 >> 2] = Q, (C | 0) == (me | 0))
                                                                                  break T;
                                                                                for (; ; ) {
                                                                                  C = C - 8 | 0, Q = e[C + 4 >> 2];
                                                                                  m: {
                                                                                    if (!Q || (Ar = e[Q + 4 >> 2], e[Q + 4 >> 2] = Ar - 1, Ar))
                                                                                      break m;
                                                                                    Yn[e[e[Q >> 2] + 8 >> 2]](Q), Ls(Q);
                                                                                  }
                                                                                  if ((C | 0) == (me | 0))
                                                                                    break;
                                                                                }
                                                                              }
                                                                              if (!me)
                                                                                break l;
                                                                              Tr(me);
                                                                            }
                                                                            if (ke = ke + 4 | 0, (Wn | 0) == (ke | 0))
                                                                              break;
                                                                          }
                                                                        if (zo[S + 88 >> 3] = Xr, zo[S + 80 >> 3] = Ur, e[5996] = 0, ke = no(3, 104) | 0, Q = e[5996], e[5996] = 0, (Q | 0) != 1)
                                                                          break w;
                                                                        break k;
                                                                      }
                                                                      C = gi() | 0;
                                                                      break R;
                                                                    }
                                                                    if (e[ke >> 2] = 7e3, e[ke + 4 >> 2] = 0, e[ke + 8 >> 2] = 0, e[5996] = 0, e[S + 132 >> 2] = e[S + 100 >> 2], Q = e[S + 104 >> 2], C = e[S + 108 >> 2], e[S + 108 >> 2] = 0, e[S + 136 >> 2] = Q, e[S + 140 >> 2] = C, e[S + 100 >> 2] = 0, e[S + 104 >> 2] = 0, Ar = wn(32, S + 120 | 0, bs | 0) | 0, Q = e[5996], e[5996] = 0, (Q | 0) != 1) {
                                                                      if (Q = e[l + 40 >> 2], e[5996] = 0, br = i2(60, ke + 12 | 0, 25, S + 132 | 0, Ar | 0, Q | 0) | 0, Q = e[5996], e[5996] = 0, (Q | 0) == 1)
                                                                        break E;
                                                                      if (me = e[Ar >> 2], me) {
                                                                        if (Q = e[S + 124 >> 2], C = me, (Q | 0) != (C | 0)) {
                                                                          for (; C = Q - 12 | 0, Se[Q - 1 | 0] < 0 && Tr(e[C >> 2]), Q = C, (Q | 0) != (me | 0); )
                                                                            ;
                                                                          C = e[Ar >> 2];
                                                                        }
                                                                        e[S + 124 >> 2] = me, Tr(C);
                                                                      }
                                                                      if (Q = e[S + 132 >> 2], Q) {
                                                                        if (C = e[S + 136 >> 2], (Q | 0) != (C | 0)) {
                                                                          for (; ; ) {
                                                                            C = C - 8 | 0, me = e[C + 4 >> 2];
                                                                            w: {
                                                                              if (!me || (Ar = e[me + 4 >> 2], e[me + 4 >> 2] = Ar - 1, Ar))
                                                                                break w;
                                                                              Yn[e[e[me >> 2] + 8 >> 2]](me), Ls(me);
                                                                            }
                                                                            if ((C | 0) == (Q | 0))
                                                                              break;
                                                                          }
                                                                          Q = e[S + 132 >> 2];
                                                                        }
                                                                        Tr(Q);
                                                                      }
                                                                      if (e[S + 116 >> 2] = ke, e[S + 112 >> 2] = br, e[5996] = 0, Q = e[S + 116 >> 2], e[S + 8 >> 2] = e[S + 112 >> 2], e[S + 12 >> 2] = Q, Ms(61, y | 0, S + 80 | 0, S + 8 | 0), Q = e[5996], e[5996] = 0, (Q | 0) == 1)
                                                                        break k;
                                                                      if (Q = e[S + 100 >> 2], Q) {
                                                                        if (C = e[S + 104 >> 2], (Q | 0) != (C | 0)) {
                                                                          for (; ; ) {
                                                                            C = C - 8 | 0, me = e[C + 4 >> 2];
                                                                            w: {
                                                                              if (!me || (ke = e[me + 4 >> 2], e[me + 4 >> 2] = ke - 1, ke))
                                                                                break w;
                                                                              Yn[e[e[me >> 2] + 8 >> 2]](me), Ls(me);
                                                                            }
                                                                            if ((C | 0) == (Q | 0))
                                                                              break;
                                                                          }
                                                                          Q = e[S + 100 >> 2];
                                                                        }
                                                                        Tr(Q);
                                                                      }
                                                                      if (Qr = Qr + 1 | 0, (yn | 0) != (Qr | 0))
                                                                        continue;
                                                                      break _;
                                                                    }
                                                                    break;
                                                                  }
                                                                  C = gi() | 0;
                                                                  break S;
                                                                }
                                                                C = gi() | 0, hf(Ar);
                                                              }
                                                              Za(S + 132 | 0), Tr(ke);
                                                              break R;
                                                            }
                                                            C = gi() | 0;
                                                          }
                                                          Za(S + 100 | 0);
                                                          break g;
                                                        }
                                                        if (me = e[S + 20 >> 2], me) {
                                                          if (C = e[S + 24 >> 2], (me | 0) != (C | 0)) {
                                                            for (; ; ) {
                                                              if (Qr = C - 12 | 0, ke = e[Qr >> 2], ke) {
                                                                if (Q = ke, Ar = C - 8 | 0, C = e[Ar >> 2], (Q | 0) != (C | 0)) {
                                                                  for (; ; ) {
                                                                    C = C - 32 | 0, Q = e[C + 4 >> 2];
                                                                    _: {
                                                                      if (!Q || (br = e[Q + 4 >> 2], e[Q + 4 >> 2] = br - 1, br))
                                                                        break _;
                                                                      Yn[e[e[Q >> 2] + 8 >> 2]](Q), Ls(Q);
                                                                    }
                                                                    if ((C | 0) == (ke | 0))
                                                                      break;
                                                                  }
                                                                  Q = e[Qr >> 2];
                                                                }
                                                                e[Ar >> 2] = ke, Tr(Q);
                                                              }
                                                              if (C = Qr, (me | 0) == (C | 0))
                                                                break;
                                                            }
                                                            me = e[S + 20 >> 2];
                                                          }
                                                          Tr(me);
                                                        }
                                                        if (Ro = Ro + 1 | 0, C = e[S + 44 >> 2], !(Ro >>> 0 < (e[S + 48 >> 2] - C | 0) / 12 >>> 0))
                                                          break;
                                                      }
                                                    if (l = e[S + 32 >> 2], l && (Tr(l), C = e[S + 44 >> 2]), C) {
                                                      if (Q = C, me = e[S + 48 >> 2], (Q | 0) != (me | 0)) {
                                                        for (; l = me - 12 | 0, y = e[l >> 2], y && (e[me - 8 >> 2] = y, Tr(y)), me = l, (l | 0) != (C | 0); )
                                                          ;
                                                        Q = e[S + 44 >> 2];
                                                      }
                                                      e[S + 48 >> 2] = C, Tr(Q);
                                                    }
                                                    if (l = e[Ri + 12 >> 2], l && (e[Ri + 16 >> 2] = l, Tr(l)), l = e[Ri >> 2], !l)
                                                      break a;
                                                    e[Ri + 4 >> 2] = l, Tr(l);
                                                    break a;
                                                  }
                                                  if (e[5996] = 0, ia(44, 5170, 1900, 642, 2497), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                    break i;
                                                  C = gi() | 0;
                                                }
                                                qc(S + 20 | 0);
                                                break d;
                                              }
                                              C = gi() | 0;
                                            }
                                            l = e[S + 32 >> 2], l && Tr(l), Hh(S + 44 | 0);
                                            break t;
                                          }
                                          l = gi() | 0, ph(Ri), ss(l | 0), jn();
                                        }
                                        C = gi() | 0;
                                      }
                                      lh(S + 80 | 0);
                                      break t;
                                    }
                                    Q = l + 4 | 0, l = l + 16 | 0, Bh(y, I, 2, Q, l), Bh(y, I, 3, Q, l);
                                    break a;
                                  }
                                  Eu(y, I, 6, l + 4 | 0, l + 28 | 0);
                                  break a;
                                }
                                Eu(y, I, 8, l + 4 | 0, l + 28 | 0);
                                break a;
                              }
                              Eu(y, I, 7, l + 4 | 0, l + 28 | 0);
                              break a;
                            }
                            Eu(y, I, 9, l + 4 | 0, l + 28 | 0);
                          }
                          bi = S + 144 | 0;
                          return;
                        }
                        C = gi() | 0;
                        break r;
                      }
                      l = e[S + 132 >> 2], l && Tr(l), Hh(S + 80 | 0);
                      break r;
                    }
                    jn();
                  }
                  ph(S + 56 | 0), ss(C | 0), jn();
                }
                ph(Ri), ss(C | 0), jn();
              }
              l = gi() | 0, Tr(Q), ss(l | 0), jn();
            }
            function bh(l, y, I, C) {
              var Q = 0, S = 0, me = 0, ke = 0, Ar = 0, br = 0, Qr = 0, Ur = 0, Xr = 0, Ri = 0, yn = 0, En = 0, Wn = 0, lo = 0, Ro = 0, Xo = 0, bs = 0, Os = 0, Gs = 0, aa = 0, Ma = 0, rf = 0, af = 0, lf = 0, wf = 0, Rf = 0, zf = 0;
              Wn = bi - 48 | 0, bi = Wn;
              e: {
                if (I >>> 0 <= 2) {
                  for (I = I << 2, rf = e[I + 8972 >> 2], af = e[I + 8960 >> 2]; ; ) {
                    I = e[y + 4 >> 2];
                    t: {
                      if ((I | 0) != e[y + 104 >> 2]) {
                        e[y + 4 >> 2] = I + 1, I = Je[I | 0];
                        break t;
                      }
                      I = Fa(y);
                    }
                    if (!((I | 0) == 32 | I - 9 >>> 0 < 5))
                      break;
                  }
                  Xo = 1;
                  t: {
                    r:
                      switch (I - 43 | 0) {
                        case 0:
                        case 2:
                          break r;
                        default:
                          break t;
                      }
                    if (Xo = (I | 0) == 45 ? -1 : 1, I = e[y + 4 >> 2], (I | 0) != e[y + 104 >> 2]) {
                      e[y + 4 >> 2] = I + 1, I = Je[I | 0];
                      break t;
                    }
                    I = Fa(y);
                  }
                  t: {
                    r: {
                      for (; ; ) {
                        if (Se[me + 1031 | 0] == (I | 32)) {
                          i: {
                            if (me >>> 0 > 6)
                              break i;
                            if (I = e[y + 4 >> 2], (I | 0) != e[y + 104 >> 2]) {
                              e[y + 4 >> 2] = I + 1, I = Je[I | 0];
                              break i;
                            }
                            I = Fa(y);
                          }
                          if (me = me + 1 | 0, (me | 0) != 8)
                            continue;
                          break r;
                        }
                        break;
                      }
                      if ((me | 0) != 3) {
                        if (Xr = (me | 0) == 8, Xr)
                          break r;
                        if (!C | me >>> 0 < 4)
                          break t;
                        if (Xr)
                          break r;
                      }
                      if (I = e[y + 116 >> 2], (I | 0) > 0 | (I | 0) >= 0 && (e[y + 4 >> 2] = e[y + 4 >> 2] - 1), !C | me >>> 0 < 4)
                        break r;
                      for (I = (I | 0) < 0; I || (e[y + 4 >> 2] = e[y + 4 >> 2] - 1), me = me - 1 | 0, me >>> 0 > 3; )
                        ;
                    }
                    Ur = bi - 16 | 0, bi = Ur, ke = (Na(Oa(Oa(Xo | 0) * Oa(1 / 0))), oa(2)), y = ke & 2147483647;
                    r: {
                      if (y - 8388608 >>> 0 <= 2130706431) {
                        I = y, y = y >>> 7 | 0, I = I << 25, C = y + 1065353216 | 0;
                        break r;
                      }
                      if (I = ke << 25, C = ke >>> 7 | 2147418112, y >>> 0 >= 2139095040 || (I = 0, C = 0, !y))
                        break r;
                      I = y, y = Ha(y), Es(Ur, I, 0, 0, 0, y + 81 | 0), br = e[Ur >> 2], Ar = e[Ur + 4 >> 2], I = e[Ur + 8 >> 2], C = e[Ur + 12 >> 2] ^ 65536 | 16265 - y << 16;
                    }
                    e[Wn >> 2] = br, e[Wn + 4 >> 2] = Ar, e[Wn + 8 >> 2] = I, e[Wn + 12 >> 2] = ke & -2147483648 | C, bi = Ur + 16 | 0, br = e[Wn + 8 >> 2], Ar = e[Wn + 12 >> 2], ke = e[Wn >> 2], Qr = e[Wn + 4 >> 2];
                    break e;
                  }
                  t: {
                    r: {
                      i: {
                        if (me)
                          break i;
                        for (me = 0; ; ) {
                          if (Se[me + 2020 | 0] != (I | 32))
                            break i;
                          n: {
                            if (me >>> 0 > 1)
                              break n;
                            if (I = e[y + 4 >> 2], (I | 0) != e[y + 104 >> 2]) {
                              e[y + 4 >> 2] = I + 1, I = Je[I | 0];
                              break n;
                            }
                            I = Fa(y);
                          }
                          if (me = me + 1 | 0, (me | 0) == 3)
                            break;
                        }
                        break r;
                      }
                      i:
                        switch (me | 0) {
                          case 0:
                            n: {
                              if ((I | 0) != 48)
                                break n;
                              me = e[y + 4 >> 2];
                              o: {
                                if ((me | 0) != e[y + 104 >> 2]) {
                                  e[y + 4 >> 2] = me + 1, me = Je[me | 0];
                                  break o;
                                }
                                me = Fa(y);
                              }
                              if ((me & -33) == 88) {
                                Xr = 0, S = bi - 432 | 0, bi = S, I = e[y + 4 >> 2];
                                o: {
                                  if ((I | 0) != e[y + 104 >> 2]) {
                                    e[y + 4 >> 2] = I + 1, me = Je[I | 0];
                                    break o;
                                  }
                                  me = Fa(y);
                                }
                                o: {
                                  a: {
                                    for (; ; ) {
                                      if ((me | 0) != 48)
                                        s: {
                                          if ((me | 0) != 46)
                                            break o;
                                          if (I = e[y + 4 >> 2], (I | 0) == e[y + 104 >> 2])
                                            break s;
                                          e[y + 4 >> 2] = I + 1, me = Je[I | 0];
                                          break a;
                                        }
                                      else {
                                        I = e[y + 4 >> 2], (I | 0) != e[y + 104 >> 2] ? (Q = 1, e[y + 4 >> 2] = I + 1, me = Je[I | 0]) : (Q = 1, me = Fa(y));
                                        continue;
                                      }
                                      break;
                                    }
                                    me = Fa(y);
                                  }
                                  if (En = 1, (me | 0) != 48)
                                    break o;
                                  for (; ; ) {
                                    I = lo, lo = I - 1 | 0, Ro = Ro - !I | 0, I = e[y + 4 >> 2];
                                    a: {
                                      if ((I | 0) != e[y + 104 >> 2]) {
                                        e[y + 4 >> 2] = I + 1, me = Je[I | 0];
                                        break a;
                                      }
                                      me = Fa(y);
                                    }
                                    if ((me | 0) != 48)
                                      break;
                                  }
                                  Q = 1;
                                }
                                Qr = 1073676288;
                                o: {
                                  for (; ; ) {
                                    a: {
                                      I = me | 32;
                                      s: {
                                        A: {
                                          if (wf = me - 48 | 0, wf >>> 0 < 10)
                                            break A;
                                          if (Rf = (me | 0) != 46, Rf & I - 97 >>> 0 > 5)
                                            break o;
                                          if (Rf)
                                            break A;
                                          if (En)
                                            break a;
                                          En = 1, lo = br, Ro = Ar;
                                          break s;
                                        }
                                        I = (me | 0) > 57 ? I - 87 | 0 : wf;
                                        A: {
                                          if ((Ar | 0) <= 0 & br >>> 0 <= 7 | (Ar | 0) < 0) {
                                            Xr = I + (Xr << 4) | 0;
                                            break A;
                                          }
                                          if (!Ar & br >>> 0 <= 28) {
                                            cc(S + 48 | 0, I), Xa(S + 32 | 0, aa, Ma, ke, Qr, 0, 0, 0, 1073414144), aa = e[S + 32 >> 2], Ma = e[S + 36 >> 2], ke = e[S + 40 >> 2], Qr = e[S + 44 >> 2], Xa(S + 16 | 0, e[S + 48 >> 2], e[S + 52 >> 2], e[S + 56 >> 2], e[S + 60 >> 2], aa, Ma, ke, Qr), Ef(S, e[S + 16 >> 2], e[S + 20 >> 2], e[S + 24 >> 2], e[S + 28 >> 2], Ur, yn, Os, Gs), Os = e[S + 8 >> 2], Gs = e[S + 12 >> 2], Ur = e[S >> 2], yn = e[S + 4 >> 2];
                                            break A;
                                          }
                                          if (lf | !I)
                                            break A;
                                          Xa(S + 80 | 0, aa, Ma, ke, Qr, 0, 0, 0, 1073610752), Ef(S - -64 | 0, e[S + 80 >> 2], e[S + 84 >> 2], e[S + 88 >> 2], e[S + 92 >> 2], Ur, yn, Os, Gs), Os = e[S + 72 >> 2], Gs = e[S + 76 >> 2], lf = 1, Ur = e[S + 64 >> 2], yn = e[S + 68 >> 2];
                                        }
                                        br = br + 1 | 0, Ar = br ? Ar : Ar + 1 | 0, Q = 1;
                                      }
                                      I = e[y + 4 >> 2], (I | 0) != e[y + 104 >> 2] ? (e[y + 4 >> 2] = I + 1, me = Je[I | 0]) : me = Fa(y);
                                      continue;
                                    }
                                    break;
                                  }
                                  me = 46;
                                }
                                o: {
                                  if (!Q) {
                                    I = e[y + 116 >> 2];
                                    a: {
                                      s: {
                                        if ((I | 0) > 0 | (I | 0) >= 0) {
                                          if (I = e[y + 4 >> 2], e[y + 4 >> 2] = I - 1, !C)
                                            break s;
                                          if (e[y + 4 >> 2] = I - 2, !En)
                                            break a;
                                          e[y + 4 >> 2] = I - 3;
                                          break a;
                                        }
                                        if (C)
                                          break a;
                                      }
                                      Mc(y, 0, 0);
                                    }
                                    ys(S + 96 | 0, +(Xo | 0) * 0), Ur = e[S + 96 >> 2], yn = e[S + 100 >> 2], I = e[S + 108 >> 2], y = e[S + 104 >> 2];
                                    break o;
                                  }
                                  if ((Ar | 0) <= 0 & br >>> 0 <= 7 | (Ar | 0) < 0)
                                    for (ke = br, Qr = Ar; Xr = Xr << 4, ke = ke + 1 | 0, Qr = ke ? Qr : Qr + 1 | 0, !!((ke | 0) != 8 | Qr); )
                                      ;
                                  a: {
                                    s: {
                                      A: {
                                        if ((me & -33) == 80) {
                                          if (ke = Da(y, C), I = Ci, Qr = I, ke | (I | 0) != -2147483648)
                                            break a;
                                          if (C) {
                                            if (I = e[y + 116 >> 2], (I | 0) > 0 | (I | 0) >= 0)
                                              break A;
                                            break s;
                                          }
                                          Ur = 0, yn = 0, Mc(y, 0, 0), I = 0, y = 0;
                                          break o;
                                        }
                                        if (ke = 0, Qr = 0, e[y + 116 >> 2] < 0)
                                          break a;
                                      }
                                      e[y + 4 >> 2] = e[y + 4 >> 2] - 1;
                                    }
                                    ke = 0, Qr = 0;
                                  }
                                  if (!Xr) {
                                    ys(S + 112 | 0, +(Xo | 0) * 0), Ur = e[S + 112 >> 2], yn = e[S + 116 >> 2], I = e[S + 124 >> 2], y = e[S + 120 >> 2];
                                    break o;
                                  }
                                  if (y = En ? lo : br, Ar = (En ? Ro : Ar) << 2 | y >>> 30, I = ke + (y << 2) | 0, y = Ar + Qr | 0, br = I - 32 | 0, Ar = (I >>> 0 < ke >>> 0 ? y + 1 | 0 : y) - (I >>> 0 < 32) | 0, y = Ar, br >>> 0 > 0 - rf >>> 0 & (y | 0) >= 0 | (y | 0) > 0) {
                                    e[5732] = 68, cc(S + 160 | 0, Xo), Xa(S + 144 | 0, e[S + 160 >> 2], e[S + 164 >> 2], e[S + 168 >> 2], e[S + 172 >> 2], -1, -1, -1, 2147418111), Xa(S + 128 | 0, e[S + 144 >> 2], e[S + 148 >> 2], e[S + 152 >> 2], e[S + 156 >> 2], -1, -1, -1, 2147418111), Ur = e[S + 128 >> 2], yn = e[S + 132 >> 2], I = e[S + 140 >> 2], y = e[S + 136 >> 2];
                                    break o;
                                  }
                                  if (y = rf - 226 | 0, I = y >> 31, (Ar | 0) >= (I | 0) & y >>> 0 <= br >>> 0 | (I | 0) < (Ar | 0)) {
                                    if ((Xr | 0) >= 0)
                                      for (; Ef(S + 416 | 0, Ur, yn, Os, Gs, 0, 0, 0, -1073807360), y = gf(Ur, yn, Os, Gs, 1073610752), I = (y | 0) >= 0, y = I, Ef(S + 400 | 0, Ur, yn, Os, Gs, y ? e[S + 416 >> 2] : Ur, y ? e[S + 420 >> 2] : yn, y ? e[S + 424 >> 2] : Os, y ? e[S + 428 >> 2] : Gs), y = br, br = y - 1 | 0, Ar = Ar - !y | 0, Os = e[S + 408 >> 2], Gs = e[S + 412 >> 2], Ur = e[S + 400 >> 2], yn = e[S + 404 >> 2], Xr = I | Xr << 1, (Xr | 0) >= 0; )
                                        ;
                                    y = Ar - ((rf >> 31) + (br >>> 0 < rf >>> 0) | 0) | 0, I = (br - rf | 0) + 32 | 0, y = I >>> 0 < 32 ? y + 1 | 0 : y, I = I >>> 0 < af >>> 0 & (y | 0) <= 0 | (y | 0) < 0 ? (I | 0) > 0 ? I : 0 : af;
                                    a: {
                                      if ((I | 0) >= 113) {
                                        cc(S + 384 | 0, Xo), lo = e[S + 392 >> 2], Ro = e[S + 396 >> 2], aa = e[S + 384 >> 2], Ma = e[S + 388 >> 2], ke = 0, y = 0;
                                        break a;
                                      }
                                      ys(S + 352 | 0, l1(144 - I | 0)), cc(S + 336 | 0, Xo), aa = e[S + 336 >> 2], Ma = e[S + 340 >> 2], lo = e[S + 344 >> 2], Ro = e[S + 348 >> 2], Ld(S + 368 | 0, e[S + 352 >> 2], e[S + 356 >> 2], e[S + 360 >> 2], e[S + 364 >> 2], aa, Ma, lo, Ro), Ri = e[S + 376 >> 2], bs = e[S + 380 >> 2], ke = e[S + 372 >> 2], y = e[S + 368 >> 2];
                                    }
                                    C = !(Xr & 1) & ((So(Ur, yn, Os, Gs, 0, 0, 0, 0) | 0) != 0 & (I | 0) < 32), hh(S + 320 | 0, C + Xr | 0), Xa(S + 304 | 0, aa, Ma, lo, Ro, e[S + 320 >> 2], e[S + 324 >> 2], e[S + 328 >> 2], e[S + 332 >> 2]), I = y, Ef(S + 272 | 0, e[S + 304 >> 2], e[S + 308 >> 2], e[S + 312 >> 2], e[S + 316 >> 2], y, ke, Ri, bs), y = C, Xa(S + 288 | 0, aa, Ma, lo, Ro, y ? 0 : Ur, y ? 0 : yn, y ? 0 : Os, y ? 0 : Gs), Ef(S + 256 | 0, e[S + 288 >> 2], e[S + 292 >> 2], e[S + 296 >> 2], e[S + 300 >> 2], e[S + 272 >> 2], e[S + 276 >> 2], e[S + 280 >> 2], e[S + 284 >> 2]), m1(S + 240 | 0, e[S + 256 >> 2], e[S + 260 >> 2], e[S + 264 >> 2], e[S + 268 >> 2], I, ke, Ri, bs), y = e[S + 240 >> 2], C = e[S + 244 >> 2], I = e[S + 248 >> 2], ke = e[S + 252 >> 2], So(y, C, I, ke, 0, 0, 0, 0) || (e[5732] = 68), Nr(S + 224 | 0, y, C, I, ke, br), Ur = e[S + 224 >> 2], yn = e[S + 228 >> 2], I = e[S + 236 >> 2], y = e[S + 232 >> 2];
                                    break o;
                                  }
                                  e[5732] = 68, cc(S + 208 | 0, Xo), Xa(S + 192 | 0, e[S + 208 >> 2], e[S + 212 >> 2], e[S + 216 >> 2], e[S + 220 >> 2], 0, 0, 0, 65536), Xa(S + 176 | 0, e[S + 192 >> 2], e[S + 196 >> 2], e[S + 200 >> 2], e[S + 204 >> 2], 0, 0, 0, 65536), Ur = e[S + 176 >> 2], yn = e[S + 180 >> 2], I = e[S + 188 >> 2], y = e[S + 184 >> 2];
                                }
                                e[Wn + 16 >> 2] = Ur, e[Wn + 20 >> 2] = yn, e[Wn + 24 >> 2] = y, e[Wn + 28 >> 2] = I, bi = S + 432 | 0, br = e[Wn + 24 >> 2], Ar = e[Wn + 28 >> 2], ke = e[Wn + 16 >> 2], Qr = e[Wn + 20 >> 2];
                                break e;
                              }
                              if (e[y + 116 >> 2] < 0)
                                break n;
                              e[y + 4 >> 2] = e[y + 4 >> 2] - 1;
                            }
                            me = y, Xr = I, S = C, C = 0, Q = bi - 8976 | 0, bi = Q, Rf = 0 - rf | 0, wf = Rf - af | 0;
                            n: {
                              o: {
                                for (; ; ) {
                                  if ((Xr | 0) != 48)
                                    a: {
                                      if ((Xr | 0) != 46)
                                        break n;
                                      if (y = e[me + 4 >> 2], (y | 0) == e[me + 104 >> 2])
                                        break a;
                                      e[me + 4 >> 2] = y + 1, Xr = Je[y | 0];
                                      break o;
                                    }
                                  else {
                                    y = e[me + 4 >> 2], (y | 0) != e[me + 104 >> 2] ? (e[me + 4 >> 2] = y + 1, Xr = Je[y | 0]) : Xr = Fa(me), C = 1;
                                    continue;
                                  }
                                  break;
                                }
                                Xr = Fa(me);
                              }
                              if (lf = 1, (Xr | 0) != 48)
                                break n;
                              for (; ; ) {
                                y = br, br = y - 1 | 0, Ar = Ar - !y | 0, y = e[me + 4 >> 2];
                                o: {
                                  if ((y | 0) != e[me + 104 >> 2]) {
                                    e[me + 4 >> 2] = y + 1, Xr = Je[y | 0];
                                    break o;
                                  }
                                  Xr = Fa(me);
                                }
                                if ((Xr | 0) != 48)
                                  break;
                              }
                              C = 1;
                            }
                            e[Q + 784 >> 2] = 0;
                            n: {
                              o: {
                                y = (Xr | 0) == 46, I = Xr - 48 | 0;
                                a: {
                                  s: {
                                    A: {
                                      if (y | I >>> 0 <= 9)
                                        for (; ; ) {
                                          u: {
                                            if (y & 1) {
                                              if (!lf) {
                                                br = ke, Ar = Qr, lf = 1;
                                                break u;
                                              }
                                              y = !C;
                                              break A;
                                            }
                                            if (ke = ke + 1 | 0, Qr = ke ? Qr : Qr + 1 | 0, (En | 0) <= 2044) {
                                              bs = (Xr | 0) == 48 ? bs : ke, y = (Q + 784 | 0) + (En << 2) | 0, Ri && (I = (No(e[y >> 2], 10) + Xr | 0) - 48 | 0), e[y >> 2] = I, C = 1, I = Ri + 1 | 0, y = (I | 0) == 9, Ri = y ? 0 : I, En = y + En | 0;
                                              break u;
                                            }
                                            if ((Xr | 0) == 48)
                                              break u;
                                            e[Q + 8960 >> 2] = e[Q + 8960 >> 2] | 1, bs = 18396;
                                          }
                                          y = e[me + 4 >> 2];
                                          u: {
                                            if ((y | 0) != e[me + 104 >> 2]) {
                                              e[me + 4 >> 2] = y + 1, Xr = Je[y | 0];
                                              break u;
                                            }
                                            Xr = Fa(me);
                                          }
                                          if (y = (Xr | 0) == 46, I = Xr - 48 | 0, !(y | I >>> 0 < 10))
                                            break;
                                        }
                                      if (br = lf ? br : ke, Ar = lf ? Ar : Qr, !(!C | (Xr & -33) != 69)) {
                                        Ur = Da(me, S), y = Ci, yn = y;
                                        u: {
                                          if (Ur | (y | 0) != -2147483648)
                                            break u;
                                          if (!S)
                                            break a;
                                          if (Ur = 0, yn = 0, e[me + 116 >> 2] < 0)
                                            break u;
                                          e[me + 4 >> 2] = e[me + 4 >> 2] - 1;
                                        }
                                        Ar = Ar + yn | 0, br = br + Ur | 0, Ar = br >>> 0 < Ur >>> 0 ? Ar + 1 | 0 : Ar;
                                        break o;
                                      }
                                      if (y = !C, (Xr | 0) < 0)
                                        break s;
                                    }
                                    if (e[me + 116 >> 2] < 0)
                                      break s;
                                    e[me + 4 >> 2] = e[me + 4 >> 2] - 1;
                                  }
                                  if (!y)
                                    break o;
                                  e[5732] = 28;
                                }
                                ke = 0, Qr = 0, Mc(me, 0, 0), I = 0, y = 0;
                                break n;
                              }
                              if (y = e[Q + 784 >> 2], !y) {
                                ys(Q, +(Xo | 0) * 0), ke = e[Q >> 2], Qr = e[Q + 4 >> 2], I = e[Q + 12 >> 2], y = e[Q + 8 >> 2];
                                break n;
                              }
                              if (!(ke >>> 0 > 9 & (Qr | 0) >= 0 | (Qr | 0) > 0 | ((ke | 0) != (br | 0) | (Ar | 0) != (Qr | 0)) | (y >>> af | 0 ? (af | 0) <= 30 : 0))) {
                                cc(Q + 48 | 0, Xo), hh(Q + 32 | 0, y), Xa(Q + 16 | 0, e[Q + 48 >> 2], e[Q + 52 >> 2], e[Q + 56 >> 2], e[Q + 60 >> 2], e[Q + 32 >> 2], e[Q + 36 >> 2], e[Q + 40 >> 2], e[Q + 44 >> 2]), ke = e[Q + 16 >> 2], Qr = e[Q + 20 >> 2], I = e[Q + 28 >> 2], y = e[Q + 24 >> 2];
                                break n;
                              }
                              if (br >>> 0 > Rf >>> 1 >>> 0 & (Ar | 0) >= 0 | (Ar | 0) > 0) {
                                e[5732] = 68, cc(Q + 96 | 0, Xo), Xa(Q + 80 | 0, e[Q + 96 >> 2], e[Q + 100 >> 2], e[Q + 104 >> 2], e[Q + 108 >> 2], -1, -1, -1, 2147418111), Xa(Q - -64 | 0, e[Q + 80 >> 2], e[Q + 84 >> 2], e[Q + 88 >> 2], e[Q + 92 >> 2], -1, -1, -1, 2147418111), ke = e[Q + 64 >> 2], Qr = e[Q + 68 >> 2], I = e[Q + 76 >> 2], y = e[Q + 72 >> 2];
                                break n;
                              }
                              if (y = rf - 226 | 0, I = br >>> 0 < y >>> 0, y = y >> 31, I & (Ar | 0) <= (y | 0) | (y | 0) > (Ar | 0)) {
                                e[5732] = 68, cc(Q + 144 | 0, Xo), Xa(Q + 128 | 0, e[Q + 144 >> 2], e[Q + 148 >> 2], e[Q + 152 >> 2], e[Q + 156 >> 2], 0, 0, 0, 65536), Xa(Q + 112 | 0, e[Q + 128 >> 2], e[Q + 132 >> 2], e[Q + 136 >> 2], e[Q + 140 >> 2], 0, 0, 0, 65536), ke = e[Q + 112 >> 2], Qr = e[Q + 116 >> 2], I = e[Q + 124 >> 2], y = e[Q + 120 >> 2];
                                break n;
                              }
                              if (Ri) {
                                if ((Ri | 0) <= 8) {
                                  for (y = (Q + 784 | 0) + (En << 2) | 0, me = e[y >> 2]; me = No(me, 10), Ri = Ri + 1 | 0, (Ri | 0) != 9; )
                                    ;
                                  e[y >> 2] = me;
                                }
                                En = En + 1 | 0;
                              }
                              Ri = br;
                              o: {
                                if ((br | 0) < (bs | 0) | (bs | 0) >= 9 | (br | 0) > 17)
                                  break o;
                                if ((br | 0) == 9) {
                                  cc(Q + 192 | 0, Xo), hh(Q + 176 | 0, e[Q + 784 >> 2]), Xa(Q + 160 | 0, e[Q + 192 >> 2], e[Q + 196 >> 2], e[Q + 200 >> 2], e[Q + 204 >> 2], e[Q + 176 >> 2], e[Q + 180 >> 2], e[Q + 184 >> 2], e[Q + 188 >> 2]), ke = e[Q + 160 >> 2], Qr = e[Q + 164 >> 2], I = e[Q + 172 >> 2], y = e[Q + 168 >> 2];
                                  break n;
                                }
                                if ((Ri | 0) <= 8) {
                                  cc(Q + 272 | 0, Xo), hh(Q + 256 | 0, e[Q + 784 >> 2]), Xa(Q + 240 | 0, e[Q + 272 >> 2], e[Q + 276 >> 2], e[Q + 280 >> 2], e[Q + 284 >> 2], e[Q + 256 >> 2], e[Q + 260 >> 2], e[Q + 264 >> 2], e[Q + 268 >> 2]), cc(Q + 224 | 0, e[(0 - Ri << 2) + 8960 >> 2]), _h(Q + 208 | 0, e[Q + 240 >> 2], e[Q + 244 >> 2], e[Q + 248 >> 2], e[Q + 252 >> 2], e[Q + 224 >> 2], e[Q + 228 >> 2], e[Q + 232 >> 2], e[Q + 236 >> 2]), ke = e[Q + 208 >> 2], Qr = e[Q + 212 >> 2], I = e[Q + 220 >> 2], y = e[Q + 216 >> 2];
                                  break n;
                                }
                                if (y = (No(Ri, -3) + af | 0) + 27 | 0, I = e[Q + 784 >> 2], I >>> y | 0 && (y | 0) <= 30)
                                  break o;
                                cc(Q + 352 | 0, Xo), hh(Q + 336 | 0, I), Xa(Q + 320 | 0, e[Q + 352 >> 2], e[Q + 356 >> 2], e[Q + 360 >> 2], e[Q + 364 >> 2], e[Q + 336 >> 2], e[Q + 340 >> 2], e[Q + 344 >> 2], e[Q + 348 >> 2]), cc(Q + 304 | 0, e[(Ri << 2) + 8888 >> 2]), Xa(Q + 288 | 0, e[Q + 320 >> 2], e[Q + 324 >> 2], e[Q + 328 >> 2], e[Q + 332 >> 2], e[Q + 304 >> 2], e[Q + 308 >> 2], e[Q + 312 >> 2], e[Q + 316 >> 2]), ke = e[Q + 288 >> 2], Qr = e[Q + 292 >> 2], I = e[Q + 300 >> 2], y = e[Q + 296 >> 2];
                                break n;
                              }
                              for (; y = En, En = y - 1 | 0, !e[(Q + 784 | 0) + (En << 2) >> 2]; )
                                ;
                              bs = 0, C = (Ri | 0) % 9 | 0;
                              o: {
                                if (!C) {
                                  I = 0;
                                  break o;
                                }
                                I = 0, C = (Ri | 0) < 0 ? C + 9 | 0 : C;
                                a: {
                                  if (!y) {
                                    y = 0;
                                    break a;
                                  }
                                  for (br = e[(0 - C << 2) + 8960 >> 2], Ur = 1e9 / (br | 0) | 0, Xr = 0, me = 0; ke = Xr, Ar = Q + 784 | 0, Qr = Ar + (me << 2) | 0, Xr = e[Qr >> 2], En = (Xr >>> 0) / (br >>> 0) | 0, ke = ke + En | 0, e[Qr >> 2] = ke, ke = !ke & (I | 0) == (me | 0), I = ke ? I + 1 & 2047 : I, Ri = ke ? Ri - 9 | 0 : Ri, Xr = No(Ur, Xr - No(br, En) | 0), me = me + 1 | 0, (me | 0) != (y | 0); )
                                    ;
                                  if (!Xr)
                                    break a;
                                  e[Ar + (y << 2) >> 2] = Xr, y = y + 1 | 0;
                                }
                                Ri = (Ri - C | 0) + 9 | 0;
                              }
                              for (; ; ) {
                                me = (Q + 784 | 0) + (I << 2) | 0;
                                o: {
                                  for (; ; ) {
                                    a: {
                                      if ((Ri | 0) < 36)
                                        break a;
                                      if ((Ri | 0) != 36)
                                        break o;
                                      if (qs[me >> 2] <= 10384592)
                                        break a;
                                      Ri = 36;
                                      break o;
                                    }
                                    for (En = y + 2047 | 0, C = 0; ke = y, Ur = En & 2047, Xr = (Q + 784 | 0) + (Ur << 2) | 0, y = e[Xr >> 2], Qr = y >>> 3 | 0, br = C, C = y << 29, br = br + C | 0, y = Qr, Ar = C >>> 0 > br >>> 0 ? y + 1 | 0 : y, !Ar & br >>> 0 < 1000000001 ? C = 0 : (C = wc(br, Ar, 1e9), y = Ua(C, Ci, -1e9, -1), br = y + br | 0), e[Xr >> 2] = br, y = (I | 0) == (Ur | 0) || br ? ke : Ur, br = ke - 1 & 2047, y = (br | 0) != (Ur | 0) ? ke : y, En = Ur - 1 | 0, (I | 0) != (Ur | 0); )
                                      ;
                                    if (bs = bs - 29 | 0, y = ke, !!C)
                                      break;
                                  }
                                  I = I - 1 & 2047, (I | 0) == (y | 0) && (me = (y + 2046 & 2047) << 2, y = Q + 784 | 0, ke = me + y | 0, e[ke >> 2] = e[ke >> 2] | e[y + (br << 2) >> 2], y = br), Ri = Ri + 9 | 0, e[(Q + 784 | 0) + (I << 2) >> 2] = C;
                                  continue;
                                }
                                break;
                              }
                              o: {
                                a: for (; ; ) {
                                  for (br = y + 1 & 2047, Ur = (Q + 784 | 0) + ((y - 1 & 2047) << 2) | 0; ; ) {
                                    ke = (Ri | 0) > 45 ? 9 : 1;
                                    s: {
                                      for (; ; ) {
                                        C = I, me = 0;
                                        A: {
                                          for (; ; ) {
                                            u: {
                                              if (I = C + me & 2047, (I | 0) == (y | 0) || (I = e[(Q + 784 | 0) + (I << 2) >> 2], Ar = e[(me << 2) + 8912 >> 2], I >>> 0 < Ar >>> 0))
                                                break u;
                                              if (I >>> 0 > Ar >>> 0)
                                                break A;
                                              if (me = me + 1 | 0, (me | 0) != 4)
                                                continue;
                                            }
                                            break;
                                          }
                                          if ((Ri | 0) != 36)
                                            break A;
                                          for (me = 0, br = 0, Ar = 0, ke = 0, Qr = 0; I = C + me & 2047, (I | 0) == (y | 0) && (y = y + 1 & 2047, e[(Q + (y << 2) | 0) + 780 >> 2] = 0), hh(Q + 768 | 0, e[(Q + 784 | 0) + (I << 2) >> 2]), Xa(Q + 752 | 0, br, Ar, ke, Qr, 0, 0, 1342177280, 1075633366), Ef(Q + 736 | 0, e[Q + 752 >> 2], e[Q + 756 >> 2], e[Q + 760 >> 2], e[Q + 764 >> 2], e[Q + 768 >> 2], e[Q + 772 >> 2], e[Q + 776 >> 2], e[Q + 780 >> 2]), ke = e[Q + 744 >> 2], Qr = e[Q + 748 >> 2], br = e[Q + 736 >> 2], Ar = e[Q + 740 >> 2], me = me + 1 | 0, (me | 0) != 4; )
                                            ;
                                          if (cc(Q + 720 | 0, Xo), Xa(Q + 704 | 0, br, Ar, ke, Qr, e[Q + 720 >> 2], e[Q + 724 >> 2], e[Q + 728 >> 2], e[Q + 732 >> 2]), ke = e[Q + 712 >> 2], Qr = e[Q + 716 >> 2], br = 0, Ar = 0, Ur = e[Q + 704 >> 2], yn = e[Q + 708 >> 2], En = bs + 113 | 0, me = En - rf | 0, Xr = (me | 0) < (af | 0), I = Xr ? (me | 0) > 0 ? me : 0 : af, (I | 0) <= 112)
                                            break s;
                                          break o;
                                        }
                                        if (bs = ke + bs | 0, I = y, (y | 0) != (C | 0))
                                          break;
                                      }
                                      for (Qr = 1e9 >>> ke | 0, Xr = -1 << ke ^ -1, me = 0, I = C; Ar = me, En = Q + 784 | 0, me = En + (C << 2) | 0, S = e[me >> 2], Ar = Ar + (S >>> ke | 0) | 0, e[me >> 2] = Ar, Ar = !Ar & (I | 0) == (C | 0), I = Ar ? I + 1 & 2047 : I, Ri = Ar ? Ri - 9 | 0 : Ri, me = No(Qr, S & Xr), C = C + 1 & 2047, (C | 0) != (y | 0); )
                                        ;
                                      if (!me)
                                        continue;
                                      if ((I | 0) != (br | 0)) {
                                        e[En + (y << 2) >> 2] = me, y = br;
                                        continue a;
                                      }
                                      e[Ur >> 2] = e[Ur >> 2] | 1;
                                      continue;
                                    }
                                    break;
                                  }
                                  break;
                                }
                                ys(Q + 656 | 0, l1(225 - I | 0)), Ld(Q + 688 | 0, e[Q + 656 >> 2], e[Q + 660 >> 2], e[Q + 664 >> 2], e[Q + 668 >> 2], Ur, yn, ke, Qr), aa = e[Q + 696 >> 2], Ma = e[Q + 700 >> 2], Os = e[Q + 688 >> 2], Gs = e[Q + 692 >> 2], ys(Q + 640 | 0, l1(113 - I | 0)), xh(Q + 672 | 0, Ur, yn, ke, Qr, e[Q + 640 >> 2], e[Q + 644 >> 2], e[Q + 648 >> 2], e[Q + 652 >> 2]), br = e[Q + 672 >> 2], Ar = e[Q + 676 >> 2], lo = e[Q + 680 >> 2], Ro = e[Q + 684 >> 2], m1(Q + 624 | 0, Ur, yn, ke, Qr, br, Ar, lo, Ro), Ef(Q + 608 | 0, Os, Gs, aa, Ma, e[Q + 624 >> 2], e[Q + 628 >> 2], e[Q + 632 >> 2], e[Q + 636 >> 2]), ke = e[Q + 616 >> 2], Qr = e[Q + 620 >> 2], Ur = e[Q + 608 >> 2], yn = e[Q + 612 >> 2];
                              }
                              Ri = C + 4 & 2047;
                              o: {
                                if ((Ri | 0) == (y | 0))
                                  break o;
                                Ri = e[(Q + 784 | 0) + (Ri << 2) >> 2];
                                a: {
                                  if (Ri >>> 0 <= 499999999) {
                                    if (!Ri & (C + 5 & 2047) == (y | 0))
                                      break a;
                                    ys(Q + 496 | 0, +(Xo | 0) * 0.25), Ef(Q + 480 | 0, br, Ar, lo, Ro, e[Q + 496 >> 2], e[Q + 500 >> 2], e[Q + 504 >> 2], e[Q + 508 >> 2]), lo = e[Q + 488 >> 2], Ro = e[Q + 492 >> 2], br = e[Q + 480 >> 2], Ar = e[Q + 484 >> 2];
                                    break a;
                                  }
                                  if ((Ri | 0) != 5e8) {
                                    ys(Q + 592 | 0, +(Xo | 0) * 0.75), Ef(Q + 576 | 0, br, Ar, lo, Ro, e[Q + 592 >> 2], e[Q + 596 >> 2], e[Q + 600 >> 2], e[Q + 604 >> 2]), lo = e[Q + 584 >> 2], Ro = e[Q + 588 >> 2], br = e[Q + 576 >> 2], Ar = e[Q + 580 >> 2];
                                    break a;
                                  }
                                  if (zf = +(Xo | 0), (C + 5 & 2047) == (y | 0)) {
                                    ys(Q + 528 | 0, zf * 0.5), Ef(Q + 512 | 0, br, Ar, lo, Ro, e[Q + 528 >> 2], e[Q + 532 >> 2], e[Q + 536 >> 2], e[Q + 540 >> 2]), lo = e[Q + 520 >> 2], Ro = e[Q + 524 >> 2], br = e[Q + 512 >> 2], Ar = e[Q + 516 >> 2];
                                    break a;
                                  }
                                  ys(Q + 560 | 0, zf * 0.75), Ef(Q + 544 | 0, br, Ar, lo, Ro, e[Q + 560 >> 2], e[Q + 564 >> 2], e[Q + 568 >> 2], e[Q + 572 >> 2]), lo = e[Q + 552 >> 2], Ro = e[Q + 556 >> 2], br = e[Q + 544 >> 2], Ar = e[Q + 548 >> 2];
                                }
                                if ((I | 0) > 111 || (xh(Q + 464 | 0, br, Ar, lo, Ro, 0, 0, 0, 1073676288), So(e[Q + 464 >> 2], e[Q + 468 >> 2], e[Q + 472 >> 2], e[Q + 476 >> 2], 0, 0, 0, 0)))
                                  break o;
                                Ef(Q + 448 | 0, br, Ar, lo, Ro, 0, 0, 0, 1073676288), lo = e[Q + 456 >> 2], Ro = e[Q + 460 >> 2], br = e[Q + 448 >> 2], Ar = e[Q + 452 >> 2];
                              }
                              Ef(Q + 432 | 0, Ur, yn, ke, Qr, br, Ar, lo, Ro), m1(Q + 416 | 0, e[Q + 432 >> 2], e[Q + 436 >> 2], e[Q + 440 >> 2], e[Q + 444 >> 2], Os, Gs, aa, Ma), ke = e[Q + 424 >> 2], Qr = e[Q + 428 >> 2], Ur = e[Q + 416 >> 2], yn = e[Q + 420 >> 2];
                              o: {
                                if ((wf - 2 | 0) >= (En & 2147483647) || (e[Q + 408 >> 2] = ke, e[Q + 412 >> 2] = Qr & 2147483647, e[Q + 400 >> 2] = Ur, e[Q + 404 >> 2] = yn, Xa(Q + 384 | 0, Ur, yn, ke, Qr, 0, 0, 0, 1073610752), C = gf(e[Q + 400 >> 2], e[Q + 404 >> 2], e[Q + 408 >> 2], e[Q + 412 >> 2], 1081081856), y = (C | 0) >= 0, ke = y ? e[Q + 392 >> 2] : ke, Qr = y ? e[Q + 396 >> 2] : Qr, Ur = y ? e[Q + 384 >> 2] : Ur, yn = y ? e[Q + 388 >> 2] : yn, bs = y + bs | 0, !(Xr & ((I | 0) != (me | 0) | (C | 0) < 0) & (So(br, Ar, lo, Ro, 0, 0, 0, 0) | 0) != 0) & (bs + 110 | 0) <= (wf | 0)))
                                  break o;
                                e[5732] = 68;
                              }
                              Nr(Q + 368 | 0, Ur, yn, ke, Qr, bs), ke = e[Q + 368 >> 2], Qr = e[Q + 372 >> 2], I = e[Q + 380 >> 2], y = e[Q + 376 >> 2];
                            }
                            e[Wn + 40 >> 2] = y, e[Wn + 44 >> 2] = I, e[Wn + 32 >> 2] = ke, e[Wn + 36 >> 2] = Qr, bi = Q + 8976 | 0, br = e[Wn + 40 >> 2], Ar = e[Wn + 44 >> 2], ke = e[Wn + 32 >> 2], Qr = e[Wn + 36 >> 2];
                            break e;
                          case 3:
                            break r;
                          default:
                            break i;
                        }
                      I = e[y + 116 >> 2], (I | 0) > 0 | (I | 0) >= 0 && (e[y + 4 >> 2] = e[y + 4 >> 2] - 1);
                      break t;
                    }
                    r: {
                      I = e[y + 4 >> 2];
                      i: {
                        if ((I | 0) != e[y + 104 >> 2]) {
                          e[y + 4 >> 2] = I + 1, I = Je[I | 0];
                          break i;
                        }
                        I = Fa(y);
                      }
                      if ((I | 0) == 40) {
                        me = 1;
                        break r;
                      }
                      if (Ar = 2147450880, e[y + 116 >> 2] < 0)
                        break e;
                      e[y + 4 >> 2] = e[y + 4 >> 2] - 1;
                      break e;
                    }
                    for (; ; ) {
                      r: {
                        I = e[y + 4 >> 2];
                        i: {
                          if ((I | 0) != e[y + 104 >> 2]) {
                            e[y + 4 >> 2] = I + 1, I = Je[I | 0];
                            break i;
                          }
                          I = Fa(y);
                        }
                        if (!(I - 48 >>> 0 < 10 | I - 65 >>> 0 < 26 | (I | 0) == 95) && I - 97 >>> 0 >= 26)
                          break r;
                        me = me + 1 | 0;
                        continue;
                      }
                      break;
                    }
                    if (Ar = 2147450880, (I | 0) == 41)
                      break e;
                    I = e[y + 116 >> 2], (I | 0) > 0 | (I | 0) >= 0 && (e[y + 4 >> 2] = e[y + 4 >> 2] - 1);
                    r: {
                      if (C) {
                        if (me)
                          break r;
                        break e;
                      }
                      break t;
                    }
                    for (; (I | 0) > 0 | (I | 0) >= 0 && (e[y + 4 >> 2] = e[y + 4 >> 2] - 1), me = me - 1 | 0, !!me; )
                      ;
                    break e;
                  }
                  e[5732] = 28, Mc(y, 0, 0);
                }
                Ar = 0;
              }
              e[l >> 2] = ke, e[l + 4 >> 2] = Qr, e[l + 8 >> 2] = br, e[l + 12 >> 2] = Ar, bi = Wn + 48 | 0;
            }
            function Ku(l, y) {
              l = l | 0, y = y | 0;
              var I = 0, C = 0, Q = 0, S = 0, me = 0, ke = 0, Ar = 0, br = 0;
              I = bi - 112 | 0, bi = I, S = e[y >> 2], Q = S, Ar = e[y + 4 >> 2];
              e: {
                if (!Ar)
                  break e;
                for (C = S + Ar | 0; ; ) {
                  me = Je[Q | 0];
                  t: {
                    if (!((me | 0) != 123 & (me | 0) != 40)) {
                      ke = ke + 1 | 0;
                      break t;
                    }
                    if (ke) {
                      if ((me | 0) != 125 & (me | 0) != 41)
                        break t;
                      ke = ke - 1 | 0;
                      break t;
                    }
                    ke = 0;
                    r:
                      switch (me - 41 | 0) {
                        case 0:
                        case 3:
                          break e;
                        case 1:
                        case 2:
                          break t;
                        default:
                          break r;
                      }
                    if ((me | 0) == 125)
                      break e;
                  }
                  if (Q = Q + 1 | 0, (C | 0) == (Q | 0))
                    break;
                }
                Q = C;
              }
              e[I + 104 >> 2] = S, C = Q - S | 0, e[I + 108 >> 2] = C, e[y + 4 >> 2] = Ar - C, e[y >> 2] = Q, Se[I + 18 | 0] = 0, ea[I + 16 >> 1] = 27504, Se[I + 27 | 0] = 2;
              e: {
                t: {
                  r: {
                    i: {
                      n: {
                        o: {
                          a: {
                            s: {
                              if (Je[S + 2 | 0] != 40 | C >>> 0 < 4 | (Je[(C + S | 0) - 1 | 0] != 41 | Je[I + 16 | 0] != Je[S | 0]) || Je[I + 17 | 0] != Je[S + 1 | 0])
                                break s;
                              if (y = C - 4 | 0, e[I + 108 >> 2] = y, C = S + 3 | 0, e[I + 104 >> 2] = C, !(!y | (y | 0) > 17)) {
                                if (y >>> 0 >= 2147483632)
                                  break i;
                                A: {
                                  if (y >>> 0 <= 10) {
                                    Se[I + 27 | 0] = y, ke = I + 16 | 0;
                                    break A;
                                  }
                                  Q = (y | 15) + 1 | 0, ke = ga(Q), e[I + 24 >> 2] = Q | -2147483648, e[I + 16 >> 2] = ke, e[I + 20 >> 2] = y;
                                }
                                if (Se[Sa(ke, C, y) + y | 0] = 0, e[I + 88 >> 2] = e[I + 20 >> 2], y = Je[I + 23 | 0] | Je[I + 24 | 0] << 8 | (Je[I + 25 | 0] << 16 | Je[I + 26 | 0] << 24), Se[I + 91 | 0] = y, Se[I + 92 | 0] = y >>> 8, Se[I + 93 | 0] = y >>> 16, Se[I + 94 | 0] = y >>> 24, e[5996] = 0, C = e[I + 16 >> 2], S = Se[I + 27 | 0], e[I + 24 >> 2] = 0, e[I + 16 >> 2] = 0, e[I + 20 >> 2] = 0, y = no(3, 12) | 0, Q = e[5996], e[5996] = 0, (Q | 0) != 1) {
                                  e[y >> 2] = C, e[y + 4 >> 2] = e[I + 88 >> 2], C = Je[I + 91 | 0] | Je[I + 92 | 0] << 8 | (Je[I + 93 | 0] << 16 | Je[I + 94 | 0] << 24), Se[y + 7 | 0] = C, Se[y + 8 | 0] = C >>> 8, Se[y + 9 | 0] = C >>> 16, Se[y + 10 | 0] = C >>> 24, Se[y + 11 | 0] = S, e[l + 4 >> 2] = 0, e[l + 8 >> 2] = 0, e[l >> 2] = 1, e[l + 12 >> 2] = 0, e[l + 16 >> 2] = 0, e[l + 20 >> 2] = 0, e[l + 24 >> 2] = 0, e[l + 40 >> 2] = 0, e[l + 44 >> 2] = 0, C = y + 12 | 0, e[l + 36 >> 2] = C, e[l + 32 >> 2] = C, e[l + 28 >> 2] = y, e[l + 48 >> 2] = 0, e[l + 52 >> 2] = 0;
                                  break n;
                                }
                                if (Q = gi() | 0, hf(I + 16 | 0), (S | 0) >= 0)
                                  break a;
                                Tr(C), ss(Q | 0), jn();
                              }
                              e[l >> 2] = 0, e[l + 4 >> 2] = 0, e[l + 48 >> 2] = 0, e[l + 52 >> 2] = 0, e[l + 40 >> 2] = 0, e[l + 44 >> 2] = 0, e[l + 32 >> 2] = 0, e[l + 36 >> 2] = 0, e[l + 24 >> 2] = 0, e[l + 28 >> 2] = 0, e[l + 16 >> 2] = 0, e[l + 20 >> 2] = 0, e[l + 8 >> 2] = 0, e[l + 12 >> 2] = 0;
                              break n;
                            }
                            Se[I + 21 | 0] = 0, Se[I + 20 | 0] = Je[1777], Se[I + 27 | 0] = 5, e[I + 16 >> 2] = Je[1773] | Je[1774] << 8 | (Je[1775] << 16 | Je[1776] << 24);
                            s: {
                              if (y = C >>> 0 < 7, y | Je[S + 5 | 0] != 40 | (Je[(C + S | 0) - 1 | 0] != 41 | Je[I + 16 | 0] != Je[S | 0]) || Je[I + 17 | 0] != Je[S + 1 | 0] | Je[I + 18 | 0] != Je[S + 2 | 0] | (Je[I + 19 | 0] != Je[S + 3 | 0] | Je[I + 20 | 0] != Je[S + 4 | 0]))
                                break s;
                              if (me = C - 7 | 0, e[I + 108 >> 2] = me, C = S + 6 | 0, e[I + 104 >> 2] = C, me >>> 0 >= 2147483632)
                                break i;
                              A: {
                                u: {
                                  if (me >>> 0 >= 11) {
                                    y = (me | 15) + 1 | 0, Q = ga(y), e[I + 24 >> 2] = y | -2147483648, e[I + 16 >> 2] = Q, e[I + 20 >> 2] = me;
                                    break u;
                                  }
                                  if (Se[I + 27 | 0] = me, Q = I + 16 | 0, !me)
                                    break A;
                                }
                                S = me - 1 | 0, Ar = me & 7;
                                u: {
                                  if (!Ar) {
                                    y = C;
                                    break u;
                                  }
                                  for (ke = 0, y = C; Se[Q | 0] = Je[y | 0], Q = Q + 1 | 0, y = y + 1 | 0, ke = ke + 1 | 0, (Ar | 0) != (ke | 0); )
                                    ;
                                }
                                if (S >>> 0 < 7)
                                  break A;
                                for (C = C + me | 0; Se[Q | 0] = Je[y | 0], Se[Q + 1 | 0] = Je[y + 1 | 0], Se[Q + 2 | 0] = Je[y + 2 | 0], Se[Q + 3 | 0] = Je[y + 3 | 0], Se[Q + 4 | 0] = Je[y + 4 | 0], Se[Q + 5 | 0] = Je[y + 5 | 0], Se[Q + 6 | 0] = Je[y + 6 | 0], Se[Q + 7 | 0] = Je[y + 7 | 0], Q = Q + 8 | 0, y = y + 8 | 0, (C | 0) != (y | 0); )
                                  ;
                              }
                              if (Se[Q | 0] = 0, y = la(I + 16 | 0, I + 88 | 0), Se[I + 27 | 0] < 0 && Tr(e[I + 16 >> 2]), !y) {
                                e[l >> 2] = 0, e[l + 4 >> 2] = 0, e[l + 48 >> 2] = 0, e[l + 52 >> 2] = 0, e[l + 40 >> 2] = 0, e[l + 44 >> 2] = 0, e[l + 32 >> 2] = 0, e[l + 36 >> 2] = 0, e[l + 24 >> 2] = 0, e[l + 28 >> 2] = 0, e[l + 16 >> 2] = 0, e[l + 20 >> 2] = 0, e[l + 8 >> 2] = 0, e[l + 12 >> 2] = 0;
                                break n;
                              }
                              if (y = e[I + 88 >> 2], C = y - 1 | 0, e[I + 92 >> 2] == (!y | 0) & C >>> 0 <= 2147483646) {
                                e[l + 4 >> 2] = 0, e[l + 8 >> 2] = 0, e[l >> 2] = 3, e[l + 52 >> 2] = y, e[l + 12 >> 2] = 0, e[l + 16 >> 2] = 0, e[l + 20 >> 2] = 0, e[l + 24 >> 2] = 0, e[l + 28 >> 2] = 0, e[l + 32 >> 2] = 0, e[l + 36 >> 2] = 0, e[l + 40 >> 2] = 0, e[l + 44 >> 2] = 0, e[l + 48 >> 2] = 0;
                                break n;
                              }
                              e[l >> 2] = 0, e[l + 4 >> 2] = 0, e[l + 48 >> 2] = 0, e[l + 52 >> 2] = 0, e[l + 40 >> 2] = 0, e[l + 44 >> 2] = 0, e[l + 32 >> 2] = 0, e[l + 36 >> 2] = 0, e[l + 24 >> 2] = 0, e[l + 28 >> 2] = 0, e[l + 16 >> 2] = 0, e[l + 20 >> 2] = 0, e[l + 8 >> 2] = 0, e[l + 12 >> 2] = 0;
                              break n;
                            }
                            Se[I + 21 | 0] = 0, Se[I + 20 | 0] = Je[1783], Se[I + 27 | 0] = 5, e[I + 16 >> 2] = Je[1779] | Je[1780] << 8 | (Je[1781] << 16 | Je[1782] << 24);
                            s: {
                              if (Je[S + 5 | 0] != 40 | y | (Je[(C + S | 0) - 1 | 0] != 41 | Je[I + 16 | 0] != Je[S | 0]) || Je[I + 17 | 0] != Je[S + 1 | 0] | Je[I + 18 | 0] != Je[S + 2 | 0] | (Je[I + 19 | 0] != Je[S + 3 | 0] | Je[I + 20 | 0] != Je[S + 4 | 0]))
                                break s;
                              if (me = C - 7 | 0, e[I + 108 >> 2] = me, C = S + 6 | 0, e[I + 104 >> 2] = C, me >>> 0 >= 2147483632)
                                break i;
                              A: {
                                u: {
                                  if (me >>> 0 >= 11) {
                                    y = (me | 15) + 1 | 0, Q = ga(y), e[I + 24 >> 2] = y | -2147483648, e[I + 16 >> 2] = Q, e[I + 20 >> 2] = me;
                                    break u;
                                  }
                                  if (Se[I + 27 | 0] = me, Q = I + 16 | 0, !me)
                                    break A;
                                }
                                S = me - 1 | 0, Ar = me & 7;
                                u: {
                                  if (!Ar) {
                                    y = C;
                                    break u;
                                  }
                                  for (ke = 0, y = C; Se[Q | 0] = Je[y | 0], Q = Q + 1 | 0, y = y + 1 | 0, ke = ke + 1 | 0, (Ar | 0) != (ke | 0); )
                                    ;
                                }
                                if (S >>> 0 < 7)
                                  break A;
                                for (C = C + me | 0; Se[Q | 0] = Je[y | 0], Se[Q + 1 | 0] = Je[y + 1 | 0], Se[Q + 2 | 0] = Je[y + 2 | 0], Se[Q + 3 | 0] = Je[y + 3 | 0], Se[Q + 4 | 0] = Je[y + 4 | 0], Se[Q + 5 | 0] = Je[y + 5 | 0], Se[Q + 6 | 0] = Je[y + 6 | 0], Se[Q + 7 | 0] = Je[y + 7 | 0], Q = Q + 8 | 0, y = y + 8 | 0, (C | 0) != (y | 0); )
                                  ;
                              }
                              if (Se[Q | 0] = 0, y = la(I + 16 | 0, I + 88 | 0), Se[I + 27 | 0] < 0 && Tr(e[I + 16 >> 2]), !y) {
                                e[l >> 2] = 0, e[l + 4 >> 2] = 0, e[l + 48 >> 2] = 0, e[l + 52 >> 2] = 0, e[l + 40 >> 2] = 0, e[l + 44 >> 2] = 0, e[l + 32 >> 2] = 0, e[l + 36 >> 2] = 0, e[l + 24 >> 2] = 0, e[l + 28 >> 2] = 0, e[l + 16 >> 2] = 0, e[l + 20 >> 2] = 0, e[l + 8 >> 2] = 0, e[l + 12 >> 2] = 0;
                                break n;
                              }
                              if (y = e[I + 88 >> 2], C = y - 1 | 0, e[I + 92 >> 2] == (!y | 0) & C >>> 0 <= 2147483646) {
                                e[l + 4 >> 2] = 0, e[l + 8 >> 2] = 0, e[l >> 2] = 2, e[l + 52 >> 2] = y, e[l + 12 >> 2] = 0, e[l + 16 >> 2] = 0, e[l + 20 >> 2] = 0, e[l + 24 >> 2] = 0, e[l + 28 >> 2] = 0, e[l + 32 >> 2] = 0, e[l + 36 >> 2] = 0, e[l + 40 >> 2] = 0, e[l + 44 >> 2] = 0, e[l + 48 >> 2] = 0;
                                break n;
                              }
                              e[l >> 2] = 0, e[l + 4 >> 2] = 0, e[l + 48 >> 2] = 0, e[l + 52 >> 2] = 0, e[l + 40 >> 2] = 0, e[l + 44 >> 2] = 0, e[l + 32 >> 2] = 0, e[l + 36 >> 2] = 0, e[l + 24 >> 2] = 0, e[l + 28 >> 2] = 0, e[l + 16 >> 2] = 0, e[l + 20 >> 2] = 0, e[l + 8 >> 2] = 0, e[l + 12 >> 2] = 0;
                              break n;
                            }
                            Se[I + 22 | 0] = 0, ea[I + 20 >> 1] = Je[3881] | Je[3882] << 8, Se[I + 27 | 0] = 6, e[I + 16 >> 2] = Je[3877] | Je[3878] << 8 | (Je[3879] << 16 | Je[3880] << 24);
                            s: {
                              if (Je[S + 6 | 0] != 40 | C >>> 0 < 8 | (Je[(C + S | 0) - 1 | 0] != 41 | Je[I + 16 | 0] != Je[S | 0]) || Je[I + 17 | 0] != Je[S + 1 | 0] | Je[I + 18 | 0] != Je[S + 2 | 0] | (Je[I + 19 | 0] != Je[S + 3 | 0] | Je[I + 20 | 0] != Je[S + 4 | 0]) || Je[I + 21 | 0] != Je[S + 5 | 0])
                                break s;
                              if (y = C - 8 | 0, e[I + 108 >> 2] = y, C = S + 7 | 0, e[I + 104 >> 2] = C, cs(I + 16 | 0, C, y, 32), y = e[I + 20 >> 2], C = e[I + 16 >> 2], (y | 0) != (C | 0)) {
                                e[l + 4 >> 2] = 0, e[l + 8 >> 2] = 0, e[l >> 2] = 7, e[l + 16 >> 2] = C, e[l + 12 >> 2] = 0, e[l + 20 >> 2] = y, y = e[I + 24 >> 2], e[l + 28 >> 2] = 0, e[l + 32 >> 2] = 0, e[l + 24 >> 2] = y, e[l + 36 >> 2] = 0, e[l + 40 >> 2] = 0, e[l + 44 >> 2] = 0, e[l + 48 >> 2] = 0, e[l + 52 >> 2] = 0;
                                break n;
                              }
                              if (e[l >> 2] = 0, e[l + 4 >> 2] = 0, e[l + 48 >> 2] = 0, e[l + 52 >> 2] = 0, e[l + 40 >> 2] = 0, e[l + 44 >> 2] = 0, e[l + 32 >> 2] = 0, e[l + 36 >> 2] = 0, e[l + 24 >> 2] = 0, e[l + 28 >> 2] = 0, e[l + 16 >> 2] = 0, e[l + 20 >> 2] = 0, e[l + 8 >> 2] = 0, e[l + 12 >> 2] = 0, !y)
                                break n;
                              Tr(y);
                              break n;
                            }
                            Se[I + 25 | 0] = 0, Se[I + 24 | 0] = Je[4198], Se[I + 27 | 0] = 9, y = Je[4194] | Je[4195] << 8 | (Je[4196] << 16 | Je[4197] << 24), e[I + 16 >> 2] = Je[4190] | Je[4191] << 8 | (Je[4192] << 16 | Je[4193] << 24), e[I + 20 >> 2] = y;
                            s: {
                              if (Je[S + 9 | 0] != 40 | C >>> 0 < 11 | (Je[(C + S | 0) - 1 | 0] != 41 | Je[I + 16 | 0] != Je[S | 0]) || Je[I + 17 | 0] != Je[S + 1 | 0] | Je[I + 18 | 0] != Je[S + 2 | 0] | (Je[I + 19 | 0] != Je[S + 3 | 0] | Je[I + 20 | 0] != Je[S + 4 | 0]) || Je[I + 21 | 0] != Je[S + 5 | 0] | Je[I + 22 | 0] != Je[S + 6 | 0] | (Je[I + 23 | 0] != Je[S + 7 | 0] | Je[I + 24 | 0] != Je[S + 8 | 0]))
                                break s;
                              if (y = C - 11 | 0, e[I + 108 >> 2] = y, C = S + 10 | 0, e[I + 104 >> 2] = C, cs(I + 16 | 0, C, y, 20), y = e[I + 20 >> 2], C = e[I + 16 >> 2], (y | 0) != (C | 0)) {
                                e[l + 4 >> 2] = 0, e[l + 8 >> 2] = 0, e[l >> 2] = 6, e[l + 16 >> 2] = C, e[l + 12 >> 2] = 0, e[l + 20 >> 2] = y, y = e[I + 24 >> 2], e[l + 28 >> 2] = 0, e[l + 32 >> 2] = 0, e[l + 24 >> 2] = y, e[l + 36 >> 2] = 0, e[l + 40 >> 2] = 0, e[l + 44 >> 2] = 0, e[l + 48 >> 2] = 0, e[l + 52 >> 2] = 0;
                                break n;
                              }
                              if (e[l >> 2] = 0, e[l + 4 >> 2] = 0, e[l + 48 >> 2] = 0, e[l + 52 >> 2] = 0, e[l + 40 >> 2] = 0, e[l + 44 >> 2] = 0, e[l + 32 >> 2] = 0, e[l + 36 >> 2] = 0, e[l + 24 >> 2] = 0, e[l + 28 >> 2] = 0, e[l + 16 >> 2] = 0, e[l + 20 >> 2] = 0, e[l + 8 >> 2] = 0, e[l + 12 >> 2] = 0, !y)
                                break n;
                              Tr(y);
                              break n;
                            }
                            Se[I + 27 | 0] = 7, Se[I + 23 | 0] = 0, e[I + 16 >> 2] = Je[3869] | Je[3870] << 8 | (Je[3871] << 16 | Je[3872] << 24), y = Je[3872] | Je[3873] << 8 | (Je[3874] << 16 | Je[3875] << 24), Se[I + 19 | 0] = y, Se[I + 20 | 0] = y >>> 8, Se[I + 21 | 0] = y >>> 16, Se[I + 22 | 0] = y >>> 24;
                            s: {
                              if (Je[S + 7 | 0] != 40 | C >>> 0 < 9 | (Je[(C + S | 0) - 1 | 0] != 41 | Je[I + 16 | 0] != Je[S | 0]) || Je[I + 17 | 0] != Je[S + 1 | 0] | Je[I + 18 | 0] != Je[S + 2 | 0] | (Je[I + 19 | 0] != Je[S + 3 | 0] | Je[I + 20 | 0] != Je[S + 4 | 0]) || Je[I + 21 | 0] != Je[S + 5 | 0] | Je[I + 22 | 0] != Je[S + 6 | 0])
                                break s;
                              if (y = C - 9 | 0, e[I + 108 >> 2] = y, C = S + 8 | 0, e[I + 104 >> 2] = C, cs(I + 16 | 0, C, y, 32), y = e[I + 20 >> 2], C = e[I + 16 >> 2], (y | 0) != (C | 0)) {
                                e[l + 4 >> 2] = 0, e[l + 8 >> 2] = 0, e[l >> 2] = 5, e[l + 16 >> 2] = C, e[l + 12 >> 2] = 0, e[l + 20 >> 2] = y, y = e[I + 24 >> 2], e[l + 28 >> 2] = 0, e[l + 32 >> 2] = 0, e[l + 24 >> 2] = y, e[l + 36 >> 2] = 0, e[l + 40 >> 2] = 0, e[l + 44 >> 2] = 0, e[l + 48 >> 2] = 0, e[l + 52 >> 2] = 0;
                                break n;
                              }
                              if (e[l >> 2] = 0, e[l + 4 >> 2] = 0, e[l + 48 >> 2] = 0, e[l + 52 >> 2] = 0, e[l + 40 >> 2] = 0, e[l + 44 >> 2] = 0, e[l + 32 >> 2] = 0, e[l + 36 >> 2] = 0, e[l + 24 >> 2] = 0, e[l + 28 >> 2] = 0, e[l + 16 >> 2] = 0, e[l + 20 >> 2] = 0, e[l + 8 >> 2] = 0, e[l + 12 >> 2] = 0, !y)
                                break n;
                              Tr(y);
                              break n;
                            }
                            if (y = Ac(I + 16 | 0, 4182), C = $l(y, I + 104 | 0), Se[y + 11 | 0] < 0 && Tr(e[y >> 2]), C) {
                              if (cs(I + 16 | 0, e[I + 104 >> 2], e[I + 108 >> 2], 20), y = e[I + 20 >> 2], C = e[I + 16 >> 2], (y | 0) != (C | 0)) {
                                e[l + 4 >> 2] = 0, e[l + 8 >> 2] = 0, e[l >> 2] = 4, e[l + 16 >> 2] = C, e[l + 12 >> 2] = 0, e[l + 20 >> 2] = y, y = e[I + 24 >> 2], e[l + 28 >> 2] = 0, e[l + 32 >> 2] = 0, e[l + 24 >> 2] = y, e[l + 36 >> 2] = 0, e[l + 40 >> 2] = 0, e[l + 44 >> 2] = 0, e[l + 48 >> 2] = 0, e[l + 52 >> 2] = 0;
                                break n;
                              }
                              if (e[l >> 2] = 0, e[l + 4 >> 2] = 0, e[l + 48 >> 2] = 0, e[l + 52 >> 2] = 0, e[l + 40 >> 2] = 0, e[l + 44 >> 2] = 0, e[l + 32 >> 2] = 0, e[l + 36 >> 2] = 0, e[l + 24 >> 2] = 0, e[l + 28 >> 2] = 0, e[l + 16 >> 2] = 0, e[l + 20 >> 2] = 0, e[l + 8 >> 2] = 0, e[l + 12 >> 2] = 0, !y)
                                break n;
                              Tr(y);
                              break n;
                            }
                            if (y = Ac(I + 16 | 0, 1743), C = $l(y, I + 104 | 0), Se[y + 11 | 0] < 0 && Tr(e[y >> 2]), C) {
                              if (e[I + 96 >> 2] = 0, e[I + 88 >> 2] = 0, e[I + 92 >> 2] = 0, e[I + 84 >> 2] = 0, e[I + 76 >> 2] = 0, e[I + 80 >> 2] = 0, e[5996] = 0, y = I + 16 | 0, Ms(26, y | 0, I + 104 | 0, I + 8 | 0), C = e[5996], e[5996] = 0, (C | 0) != 1) {
                                e[5996] = 0, Co(27, I + 88 | 0, y | 0), C = e[5996], e[5996] = 0;
                                s: {
                                  A: {
                                    if ((C | 0) != 1) {
                                      if (ff(y), y = e[I + 92 >> 2], e[y - 56 >> 2])
                                        break A;
                                      e[l >> 2] = 0, e[l + 4 >> 2] = 0, e[l + 48 >> 2] = 0, e[l + 52 >> 2] = 0, e[l + 40 >> 2] = 0, e[l + 44 >> 2] = 0, e[l + 32 >> 2] = 0, e[l + 36 >> 2] = 0, e[l + 24 >> 2] = 0, e[l + 28 >> 2] = 0, e[l + 16 >> 2] = 0, e[l + 20 >> 2] = 0, e[l + 8 >> 2] = 0, e[l + 12 >> 2] = 0;
                                      break s;
                                    }
                                    Q = gi() | 0, ff(I + 16 | 0);
                                    break t;
                                  }
                                  if (e[5996] = 0, Co(28, I + 76 | 0, e[I + 8 >> 2]), C = e[5996], e[5996] = 0, (C | 0) == 1)
                                    break r;
                                  A: {
                                    u: {
                                      if (!e[I + 108 >> 2])
                                        break u;
                                      h: {
                                        c: {
                                          for (; ; ) {
                                            if (ea[I + 16 >> 1] = 44, Se[I + 27 | 0] = 1, y = I + 16 | 0, C = I + 104 | 0, !Uf(y, C))
                                              break A;
                                            if (e[5996] = 0, Ms(26, y | 0, C | 0, I + 8 | 0), C = e[5996], e[5996] = 0, (C | 0) == 1)
                                              break c;
                                            if (e[5996] = 0, Co(27, I + 88 | 0, y | 0), C = e[5996], e[5996] = 0, (C | 0) == 1)
                                              break h;
                                            if (ff(y), y = e[I + 92 >> 2], !e[y - 56 >> 2])
                                              break A;
                                            if (e[5996] = 0, Co(28, I + 76 | 0, e[I + 8 >> 2]), C = e[5996], e[5996] = 0, (C | 0) != 1) {
                                              if (!e[I + 108 >> 2])
                                                break u;
                                              continue;
                                            }
                                            break;
                                          }
                                          Q = gi() | 0;
                                          break t;
                                        }
                                        Q = gi() | 0;
                                        break t;
                                      }
                                      Q = gi() | 0, ff(I + 16 | 0);
                                      break t;
                                    }
                                    e[l >> 2] = 9, C = e[I + 88 >> 2], e[l + 8 >> 2] = y, e[l + 4 >> 2] = C, e[l + 12 >> 2] = e[I + 96 >> 2], e[I + 96 >> 2] = 0, e[I + 88 >> 2] = 0, e[I + 92 >> 2] = 0, e[l + 32 >> 2] = 0, e[l + 36 >> 2] = 0, e[l + 24 >> 2] = 0, e[l + 28 >> 2] = 0, e[l + 16 >> 2] = 0, e[l + 20 >> 2] = 0, e[l + 40 >> 2] = e[I + 76 >> 2], e[l + 44 >> 2] = e[I + 80 >> 2], y = e[I + 84 >> 2], e[l + 52 >> 2] = 0, e[l + 48 >> 2] = y;
                                    break s;
                                  }
                                  if (y = e[I + 76 >> 2], e[l >> 2] = 0, e[l + 4 >> 2] = 0, e[l + 48 >> 2] = 0, e[l + 52 >> 2] = 0, e[l + 40 >> 2] = 0, e[l + 44 >> 2] = 0, e[l + 32 >> 2] = 0, e[l + 36 >> 2] = 0, e[l + 24 >> 2] = 0, e[l + 28 >> 2] = 0, e[l + 16 >> 2] = 0, e[l + 20 >> 2] = 0, e[l + 8 >> 2] = 0, e[l + 12 >> 2] = 0, !y)
                                    break s;
                                  Tr(y);
                                }
                                Gh(I + 88 | 0);
                                break n;
                              }
                              Q = gi() | 0;
                              break t;
                            }
                            if (y = Ac(I + 16 | 0, 2464), C = $l(y, I + 104 | 0), Se[y + 11 | 0] < 0 && Tr(e[y >> 2]), C) {
                              e[I + 96 >> 2] = 0, e[I + 88 >> 2] = 0, e[I + 92 >> 2] = 0, e[5996] = 0, y = I + 16 | 0, Co(29, y | 0, I + 104 | 0), C = e[5996], e[5996] = 0;
                              s: {
                                if ((C | 0) != 1) {
                                  e[5996] = 0, Co(27, I + 88 | 0, y | 0), C = e[5996], e[5996] = 0;
                                  A: {
                                    u: {
                                      h: {
                                        if ((C | 0) != 1) {
                                          if (ff(y), Q = e[I + 92 >> 2], e[Q - 56 >> 2]) {
                                            if (!e[I + 108 >> 2])
                                              break u;
                                            break h;
                                          }
                                          e[l >> 2] = 0, e[l + 4 >> 2] = 0, e[l + 48 >> 2] = 0, e[l + 52 >> 2] = 0, e[l + 40 >> 2] = 0, e[l + 44 >> 2] = 0, e[l + 32 >> 2] = 0, e[l + 36 >> 2] = 0, e[l + 24 >> 2] = 0, e[l + 28 >> 2] = 0, e[l + 16 >> 2] = 0, e[l + 20 >> 2] = 0, e[l + 8 >> 2] = 0, e[l + 12 >> 2] = 0;
                                          break A;
                                        }
                                        Q = gi() | 0, ff(I + 16 | 0);
                                        break s;
                                      }
                                      h: {
                                        c: {
                                          for (; ; ) {
                                            e[5996] = 0, y = wn(30, I + 76 | 0, 4354) | 0, C = e[5996], e[5996] = 0;
                                            f: {
                                              if ((C | 0) != 1) {
                                                if (C = Uf(y, I + 104 | 0), Se[I + 87 | 0] < 0 && Tr(e[y >> 2]), C)
                                                  break f;
                                                e[l >> 2] = 0, e[l + 4 >> 2] = 0, e[l + 48 >> 2] = 0, e[l + 52 >> 2] = 0, e[l + 40 >> 2] = 0, e[l + 44 >> 2] = 0, e[l + 32 >> 2] = 0, e[l + 36 >> 2] = 0, e[l + 24 >> 2] = 0, e[l + 28 >> 2] = 0, e[l + 16 >> 2] = 0, e[l + 20 >> 2] = 0, e[l + 8 >> 2] = 0, e[l + 12 >> 2] = 0;
                                                break A;
                                              }
                                              Q = gi() | 0;
                                              break s;
                                            }
                                            if (e[5996] = 0, y = I + 16 | 0, Co(29, y | 0, I + 104 | 0), C = e[5996], e[5996] = 0, (C | 0) == 1)
                                              break c;
                                            if (e[5996] = 0, Co(27, I + 88 | 0, y | 0), C = e[5996], e[5996] = 0, (C | 0) == 1)
                                              break h;
                                            if (ff(y), Q = e[I + 92 >> 2], e[Q - 56 >> 2]) {
                                              if (!e[I + 108 >> 2])
                                                break u;
                                              continue;
                                            }
                                            break;
                                          }
                                          e[l >> 2] = 0, e[l + 4 >> 2] = 0, e[l + 48 >> 2] = 0, e[l + 52 >> 2] = 0, e[l + 40 >> 2] = 0, e[l + 44 >> 2] = 0, e[l + 32 >> 2] = 0, e[l + 36 >> 2] = 0, e[l + 24 >> 2] = 0, e[l + 28 >> 2] = 0, e[l + 16 >> 2] = 0, e[l + 20 >> 2] = 0, e[l + 8 >> 2] = 0, e[l + 12 >> 2] = 0;
                                          break A;
                                        }
                                        Q = gi() | 0;
                                        break s;
                                      }
                                      Q = gi() | 0, ff(I + 16 | 0);
                                      break s;
                                    }
                                    e[l >> 2] = 8, y = e[I + 88 >> 2], e[l + 8 >> 2] = Q, e[l + 4 >> 2] = y, e[l + 12 >> 2] = e[I + 96 >> 2], e[I + 96 >> 2] = 0, e[I + 88 >> 2] = 0, e[I + 92 >> 2] = 0, e[l + 48 >> 2] = 0, e[l + 52 >> 2] = 0, e[l + 40 >> 2] = 0, e[l + 44 >> 2] = 0, e[l + 32 >> 2] = 0, e[l + 36 >> 2] = 0, e[l + 24 >> 2] = 0, e[l + 28 >> 2] = 0, e[l + 16 >> 2] = 0, e[l + 20 >> 2] = 0;
                                  }
                                  Gh(I + 88 | 0);
                                  break n;
                                }
                                Q = gi() | 0;
                              }
                              break e;
                            }
                            if (y = Ac(I + 16 | 0, 2197), C = $l(y, I + 104 | 0), Se[y + 11 | 0] < 0 && Tr(e[y >> 2]), !C)
                              break o;
                            Q = 0, ke = e[I + 104 >> 2], y = ke, me = e[I + 108 >> 2];
                            s: {
                              if (!me)
                                break s;
                              for (C = y + me | 0; ; ) {
                                S = Je[y | 0];
                                A: {
                                  if (!((S | 0) != 123 & (S | 0) != 40)) {
                                    Q = Q + 1 | 0;
                                    break A;
                                  }
                                  if (Q) {
                                    if ((S | 0) != 125 & (S | 0) != 41)
                                      break A;
                                    Q = Q - 1 | 0;
                                    break A;
                                  }
                                  Q = 0;
                                  u:
                                    switch (S - 41 | 0) {
                                      case 0:
                                      case 3:
                                        break s;
                                      case 1:
                                      case 2:
                                        break A;
                                      default:
                                        break u;
                                    }
                                  if ((S | 0) == 125)
                                    break s;
                                }
                                if (y = y + 1 | 0, (C | 0) == (y | 0))
                                  break;
                              }
                              y = C;
                            }
                            e[I + 8 >> 2] = ke, C = y - ke | 0, e[I + 12 >> 2] = C, e[I + 108 >> 2] = me - C, e[I + 104 >> 2] = y, y = e[I + 8 >> 2], C = as(I + 16 | 0, y, y + e[I + 12 >> 2] | 0), S = I + 4 | 0, y = 0, Q = bi - 16 | 0, bi = Q, me = Je[C + 11 | 0], ke = me << 24 >> 24, ke = (ke | 0) < 0, me = ke ? e[C + 4 >> 2] : me;
                            s: {
                              if (!me || (ke = ke ? e[C >> 2] : C, Ar = Je[ke | 0], br = Ar - 9 & 255, br >>> 0 < 24 & (8388639 >>> br & 1)) || (br = Je[(me + ke | 0) - 1 | 0] - 9 | 0, (br & 255) >>> 0 < 24 & (8388639 >>> br & 1)) || (Ar | 0) == 45 | (Jf(ke) | 0) != (me | 0) || (e[Q + 12 >> 2] = 0, e[5732] = 0, ke = wA(Se[C + 11 | 0] < 0 ? e[C >> 2] : C, Q + 12 | 0, 10, -1, 0), S && (e[S >> 2] = ke), S = e[Q + 12 >> 2], !S | Je[S | 0]))
                                break s;
                              y = !e[5732];
                            }
                            if (bi = Q + 16 | 0, Se[C + 11 | 0] < 0 && Tr(e[C >> 2]), !y) {
                              e[l >> 2] = 0, e[l + 4 >> 2] = 0, e[l + 48 >> 2] = 0, e[l + 52 >> 2] = 0, e[l + 40 >> 2] = 0, e[l + 44 >> 2] = 0, e[l + 32 >> 2] = 0, e[l + 36 >> 2] = 0, e[l + 24 >> 2] = 0, e[l + 28 >> 2] = 0, e[l + 16 >> 2] = 0, e[l + 20 >> 2] = 0, e[l + 8 >> 2] = 0, e[l + 12 >> 2] = 0;
                              break n;
                            }
                            if (!e[I + 4 >> 2]) {
                              e[l >> 2] = 0, e[l + 4 >> 2] = 0, e[l + 48 >> 2] = 0, e[l + 52 >> 2] = 0, e[l + 40 >> 2] = 0, e[l + 44 >> 2] = 0, e[l + 32 >> 2] = 0, e[l + 36 >> 2] = 0, e[l + 24 >> 2] = 0, e[l + 28 >> 2] = 0, e[l + 16 >> 2] = 0, e[l + 20 >> 2] = 0, e[l + 8 >> 2] = 0, e[l + 12 >> 2] = 0;
                              break n;
                            }
                            y = 0, e[I + 96 >> 2] = 0, e[I + 88 >> 2] = 0, e[I + 92 >> 2] = 0, Q = 0;
                            s: {
                              A: {
                                u: {
                                  if (e[I + 108 >> 2]) {
                                    h: {
                                      c: {
                                        f: {
                                          for (; ; ) {
                                            if (e[5996] = 0, y = wn(30, I + 76 | 0, 4354) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                              break A;
                                            if (C = Uf(y, I + 104 | 0), Se[I + 87 | 0] < 0 && Tr(e[y >> 2]), !C) {
                                              e[l >> 2] = 0, e[l + 4 >> 2] = 0, e[l + 48 >> 2] = 0, e[l + 52 >> 2] = 0, e[l + 40 >> 2] = 0, e[l + 44 >> 2] = 0, e[l + 32 >> 2] = 0, e[l + 36 >> 2] = 0, e[l + 24 >> 2] = 0, e[l + 28 >> 2] = 0, e[l + 16 >> 2] = 0, e[l + 20 >> 2] = 0, e[l + 8 >> 2] = 0, e[l + 12 >> 2] = 0;
                                              break u;
                                            }
                                            if (e[5996] = 0, y = I + 16 | 0, Co(29, y | 0, I + 104 | 0), C = e[5996], e[5996] = 0, (C | 0) == 1)
                                              break f;
                                            if (e[5996] = 0, Co(27, I + 88 | 0, y | 0), C = e[5996], e[5996] = 0, (C | 0) == 1)
                                              break c;
                                            if (ff(y), Q = e[I + 92 >> 2], e[Q - 56 >> 2]) {
                                              if (!e[I + 108 >> 2])
                                                break h;
                                              continue;
                                            }
                                            break;
                                          }
                                          e[l >> 2] = 0, e[l + 4 >> 2] = 0, e[l + 48 >> 2] = 0, e[l + 52 >> 2] = 0, e[l + 40 >> 2] = 0, e[l + 44 >> 2] = 0, e[l + 32 >> 2] = 0, e[l + 36 >> 2] = 0, e[l + 24 >> 2] = 0, e[l + 28 >> 2] = 0, e[l + 16 >> 2] = 0, e[l + 20 >> 2] = 0, e[l + 8 >> 2] = 0, e[l + 12 >> 2] = 0;
                                          break u;
                                        }
                                        Q = gi() | 0;
                                        break s;
                                      }
                                      Q = gi() | 0, ff(I + 16 | 0);
                                      break s;
                                    }
                                    y = e[I + 88 >> 2];
                                  }
                                  h: {
                                    if (C = (Q - y | 0) / 56 | 0, C >>> 0 <= 100 && (S = C, C = e[I + 4 >> 2], S >>> 0 >= C >>> 0))
                                      break h;
                                    e[l >> 2] = 0, e[l + 4 >> 2] = 0, e[l + 48 >> 2] = 0, e[l + 52 >> 2] = 0, e[l + 40 >> 2] = 0, e[l + 44 >> 2] = 0, e[l + 32 >> 2] = 0, e[l + 36 >> 2] = 0, e[l + 24 >> 2] = 0, e[l + 28 >> 2] = 0, e[l + 16 >> 2] = 0, e[l + 20 >> 2] = 0, e[l + 8 >> 2] = 0, e[l + 12 >> 2] = 0;
                                    break u;
                                  }
                                  e[l + 4 >> 2] = y, e[l >> 2] = 10, e[l + 8 >> 2] = Q, e[l + 12 >> 2] = e[I + 96 >> 2], e[I + 96 >> 2] = 0, e[I + 88 >> 2] = 0, e[I + 92 >> 2] = 0, e[l + 48 >> 2] = 0, e[l + 40 >> 2] = 0, e[l + 44 >> 2] = 0, e[l + 32 >> 2] = 0, e[l + 36 >> 2] = 0, e[l + 24 >> 2] = 0, e[l + 28 >> 2] = 0, e[l + 16 >> 2] = 0, e[l + 20 >> 2] = 0, e[l + 52 >> 2] = C;
                                }
                                Gh(I + 88 | 0);
                                break n;
                              }
                              Q = gi() | 0;
                            }
                            Gh(I + 88 | 0);
                          }
                          ss(Q | 0), jn();
                        }
                        e[l >> 2] = 0, e[l + 4 >> 2] = 0, e[l + 48 >> 2] = 0, e[l + 52 >> 2] = 0, e[l + 40 >> 2] = 0, e[l + 44 >> 2] = 0, e[l + 32 >> 2] = 0, e[l + 36 >> 2] = 0, e[l + 24 >> 2] = 0, e[l + 28 >> 2] = 0, e[l + 16 >> 2] = 0, e[l + 20 >> 2] = 0, e[l + 8 >> 2] = 0, e[l + 12 >> 2] = 0;
                      }
                      bi = I + 112 | 0;
                      return;
                    }
                    xf(), jn();
                  }
                  Q = gi() | 0;
                }
                l = e[I + 76 >> 2], l && Tr(l);
              }
              Gh(I + 88 | 0), ss(Q | 0), jn();
            }
            function sc(l, y, I, C) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0;
              var Q = 0, S = 0, me = 0, ke = 0, Ar = 0, br = 0, Qr = 0, Ur = 0, Xr = 0, Ri = 0, yn = 0, En = 0, Wn = 0, lo = 0;
              S = bi - 160 | 0, bi = S, e[S + 152 >> 2] = 0, e[S + 144 >> 2] = 0, e[S + 148 >> 2] = 0, yn = C + 1 | 0, Ur = 1;
              e: {
                t: {
                  r: {
                    i: {
                      n: {
                        o: {
                          a: {
                            s: {
                              A: {
                                u: {
                                  for (; ; ) {
                                    if (Q = Je[y | 0] | Je[y + 1 | 0] << 8 | (Je[y + 2 | 0] << 16 | Je[y + 3 | 0] << 24), (Q | 0) == (I | 0))
                                      break u;
                                    h: {
                                      c: {
                                        f: {
                                          p: {
                                            d: {
                                              g: {
                                                v: {
                                                  _: {
                                                    R: {
                                                      k: {
                                                        S: {
                                                          E: {
                                                            w: {
                                                              I: {
                                                                l: {
                                                                  T: {
                                                                    m: {
                                                                      if ((I - Q | 0) <= 0 | I >>> 0 <= Q >>> 0)
                                                                        break m;
                                                                      ke = Q + 1 | 0, me = 0, Qr = Je[Q | 0];
                                                                      C: {
                                                                        if (Qr >>> 0 > 78) {
                                                                          Ar = 0;
                                                                          break C;
                                                                        }
                                                                        Ar = Qr;
                                                                        D: {
                                                                          if (Ar >>> 0 < 76)
                                                                            break D;
                                                                          b:
                                                                            switch (Ar - 76 | 0) {
                                                                              case 0:
                                                                                if ((I - ke | 0) <= 0)
                                                                                  break m;
                                                                                ke = Q + 2 | 0, Ar = Je[Q + 1 | 0];
                                                                                break D;
                                                                              case 1:
                                                                                if ((I - ke | 0) < 2)
                                                                                  break m;
                                                                                ke = Q + 3 | 0, Ar = Je[Q + 1 | 0] | Je[Q + 2 | 0] << 8;
                                                                                break D;
                                                                              default:
                                                                                break b;
                                                                            }
                                                                          if ((I - ke | 0) < 4)
                                                                            break m;
                                                                          ke = Q + 5 | 0, Ar = Je[Q + 1 | 0] | Je[Q + 2 | 0] << 8 | (Je[Q + 3 | 0] << 16 | Je[Q + 4 | 0] << 24);
                                                                        }
                                                                        if (me = I - ke | 0, (me | 0) < 0 || (Q = Ar, me >>> 0 < Q >>> 0))
                                                                          break m;
                                                                        D: {
                                                                          if (!Q) {
                                                                            Ar = 0, me = 0;
                                                                            break D;
                                                                          }
                                                                          if ((Q | 0) < 0) {
                                                                            if (e[5996] = 0, jo(8), l = e[5996], e[5996] = 0, (l | 0) == 1)
                                                                              break T;
                                                                            break e;
                                                                          }
                                                                          if (e[5996] = 0, Ar = no(3, Q | 0) | 0, br = e[5996], e[5996] = 0, me = 0, (br | 0) == 1)
                                                                            break o;
                                                                          me = Sa(Ar, ke, Q) + Q | 0;
                                                                        }
                                                                        ke = Q + ke | 0;
                                                                      }
                                                                      if (Q = 3, Qr - 103 >>> 0 < 2)
                                                                        break h;
                                                                      if (Se[y | 0] = ke, Se[y + 1 | 0] = ke >>> 8, Se[y + 2 | 0] = ke >>> 16, Se[y + 3 | 0] = ke >>> 24, !Ur)
                                                                        break l;
                                                                      if (Q = 0, (C | 0) <= 0)
                                                                        break I;
                                                                      for (; ; ) {
                                                                        if (e[5996] = 0, wn(97, S + 144 | 0, 5573) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                                                                          break w;
                                                                        if (Q = Q + 1 | 0, (Q | 0) == (C | 0))
                                                                          break;
                                                                      }
                                                                      break I;
                                                                    }
                                                                    if (y = Je[S + 155 | 0], C = y << 24 >> 24, Ar = (C | 0) < 0 ? e[S + 148 >> 2] : y, I = Ar + 8 | 0, I >>> 0 >= 2147483632) {
                                                                      if (e[5996] = 0, jo(2), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                        break e;
                                                                      Q = gi() | 0;
                                                                      break i;
                                                                    }
                                                                    m: {
                                                                      if (I >>> 0 <= 10) {
                                                                        e[l + 8 >> 2] = 0, e[l >> 2] = 0, e[l + 4 >> 2] = 0, Se[l + 11 | 0] = I;
                                                                        break m;
                                                                      }
                                                                      if (e[5996] = 0, Q = (I | 15) + 1 | 0, y = no(3, Q | 0) | 0, ke = e[5996], e[5996] = 0, me = 0, (ke | 0) == 1)
                                                                        break o;
                                                                      e[l + 4 >> 2] = I, e[l >> 2] = y, e[l + 8 >> 2] = Q | -2147483648, l = y;
                                                                    }
                                                                    l = ve(l, (C | 0) < 0 ? e[S + 144 >> 2] : S + 144 | 0, Ar) + Ar | 0, Se[l + 8 | 0] = 0, Se[l | 0] = 32, Se[l + 1 | 0] = 91, Se[l + 2 | 0] = 101, Se[l + 3 | 0] = 114, Se[l + 4 | 0] = 114, Se[l + 5 | 0] = 111, Se[l + 6 | 0] = 114, Se[l + 7 | 0] = 93;
                                                                    break r;
                                                                  }
                                                                  Q = gi() | 0;
                                                                  break i;
                                                                }
                                                                if (e[5996] = 0, Co(98, S + 144 | 0, 32), Q = e[5996], e[5996] = 0, (Q | 0) == 1)
                                                                  break a;
                                                                Q = Je[S + 155 | 0], En = (Q << 24 >> 24 < 0 ? e[S + 148 >> 2] : Q) - 1 | 0;
                                                              }
                                                              I: {
                                                                l: {
                                                                  T: {
                                                                    m: {
                                                                      C:
                                                                        switch (Xr = me - Ar | 0, Xr | 0) {
                                                                          case 0:
                                                                            break I;
                                                                          case 33:
                                                                            break T;
                                                                          case 32:
                                                                            break m;
                                                                          case 20:
                                                                            break C;
                                                                          default:
                                                                            break l;
                                                                        }
                                                                      if (e[5996] = 0, br = no(3, 20) | 0, Q = e[5996], e[5996] = 0, (Q | 0) == 1) {
                                                                        Q = gi() | 0;
                                                                        break s;
                                                                      }
                                                                      if (Q = br, Se[Q | 0] = 153, Se[Q + 1 | 0] = 153, Se[Q + 2 | 0] = 153, Se[Q + 3 | 0] = 153, Se[Q + 4 | 0] = 153, Se[Q + 5 | 0] = 153, Se[Q + 6 | 0] = 153, Se[Q + 7 | 0] = 153, Se[Q + 16 | 0] = 153, Se[Q + 17 | 0] = 153, Se[Q + 18 | 0] = 153, Se[Q + 19 | 0] = 153, Se[Q + 8 | 0] = 153, Se[Q + 9 | 0] = 153, Se[Q + 10 | 0] = 153, Se[Q + 11 | 0] = 153, Se[Q + 12 | 0] = 153, Se[Q + 13 | 0] = 153, Se[Q + 14 | 0] = 153, Se[Q + 15 | 0] = 153, ke = Ar, (me | 0) == (ke | 0))
                                                                        break g;
                                                                      for (; ; ) {
                                                                        if (Je[ke | 0] == Je[Q | 0]) {
                                                                          if (Q = Q + 1 | 0, ke = ke + 1 | 0, (me | 0) != (ke | 0))
                                                                            continue;
                                                                          break g;
                                                                        }
                                                                        break;
                                                                      }
                                                                      if (Tr(br), !(Je[Ar | 0] != 80 | Je[Ar + 1 | 0] != 75 | Je[Ar + 2 | 0] != 104)) {
                                                                        C: {
                                                                          D: {
                                                                            for (; ; ) {
                                                                              if (Q = me - 1 | 0, !Je[Q | 0]) {
                                                                                if (me = Q, (Q | 0) != (Ar | 0))
                                                                                  continue;
                                                                                break D;
                                                                              }
                                                                              break;
                                                                            }
                                                                            if (me = (me - Ar | 0) - 3 | 0, me >>> 0 < 2147483632)
                                                                              break C;
                                                                          }
                                                                          if (e[5996] = 0, jo(2), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                            break e;
                                                                          Q = gi() | 0;
                                                                          break s;
                                                                        }
                                                                        C: {
                                                                          D: {
                                                                            b: {
                                                                              B: {
                                                                                y: {
                                                                                  x: {
                                                                                    P: {
                                                                                      if (me >>> 0 <= 10) {
                                                                                        Se[S + 111 | 0] = me, ke = S + 100 | 0;
                                                                                        break P;
                                                                                      }
                                                                                      if (e[5996] = 0, Q = (me | 15) + 1 | 0, ke = no(3, Q | 0) | 0, br = e[5996], e[5996] = 0, (br | 0) == 1)
                                                                                        break x;
                                                                                      e[S + 100 >> 2] = ke, e[S + 104 >> 2] = me, e[S + 108 >> 2] = Q | -2147483648;
                                                                                    }
                                                                                    if (Se[ve(ke, Ar + 3 | 0, me) + me | 0] = 0, e[5996] = 0, me = Ko(99, S + 100 | 0, 0, 5383) | 0, Q = e[5996], e[5996] = 0, (Q | 0) == 1)
                                                                                      break y;
                                                                                    if (e[S + 120 >> 2] = e[me + 8 >> 2], Q = e[me + 4 >> 2], e[S + 112 >> 2] = e[me >> 2], e[S + 116 >> 2] = Q, e[me >> 2] = 0, e[me + 4 >> 2] = 0, e[me + 8 >> 2] = 0, e[5996] = 0, Q = wn(97, S + 112 | 0, 3723) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                                                                                      break B;
                                                                                    if (e[S + 136 >> 2] = e[Q + 8 >> 2], ke = e[Q + 4 >> 2], e[S + 128 >> 2] = e[Q >> 2], e[S + 132 >> 2] = ke, e[Q >> 2] = 0, e[Q + 4 >> 2] = 0, e[Q + 8 >> 2] = 0, e[5996] = 0, ke = Je[S + 139 | 0], br = ke << 24 >> 24 < 0, Ko(100, S + 144 | 0, (br ? e[S + 128 >> 2] : S + 128 | 0) | 0, (br ? e[S + 132 >> 2] : ke) | 0) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                                                                                      break b;
                                                                                    if (Se[S + 139 | 0] < 0 && Tr(e[S + 128 >> 2]), Se[S + 123 | 0] < 0 && Tr(e[Q >> 2]), Se[S + 111 | 0] < 0 && Tr(e[me >> 2]), !Ur)
                                                                                      break f;
                                                                                    break c;
                                                                                  }
                                                                                  Q = gi() | 0;
                                                                                  break s;
                                                                                }
                                                                                Q = gi() | 0;
                                                                                break C;
                                                                              }
                                                                              Q = gi() | 0;
                                                                              break D;
                                                                            }
                                                                            if (Q = gi() | 0, Se[S + 139 | 0] >= 0)
                                                                              break D;
                                                                            Tr(e[S + 128 >> 2]);
                                                                          }
                                                                          if (Se[S + 123 | 0] >= 0)
                                                                            break C;
                                                                          Tr(e[S + 112 >> 2]);
                                                                        }
                                                                        if (Se[S + 111 | 0] >= 0)
                                                                          break s;
                                                                        Tr(e[S + 100 >> 2]);
                                                                        break s;
                                                                      }
                                                                      if (e[S + 80 >> 2] = 0, e[5996] = 0, e[S + 72 >> 2] = 0, e[S + 76 >> 2] = 0, Co(101, S + 72 | 0, 40), Q = e[5996], e[5996] = 0, (Q | 0) == 1)
                                                                        break _;
                                                                      if (me >>> 0 > Ar >>> 0)
                                                                        for (ke = Ar + 20 | 0, Q = Ar; ; ) {
                                                                          if (me = Je[Q | 0], e[5996] = 0, br = S + 72 | 0, Co(98, br | 0, Se[(me >>> 4 | 0) + 6976 | 0]), Qr = e[5996], e[5996] = 0, (Qr | 0) == 1 || (e[5996] = 0, Co(98, br | 0, Se[(me & 15) + 6976 | 0]), me = e[5996], e[5996] = 0, (me | 0) == 1))
                                                                            break _;
                                                                          if (Q = Q + 1 | 0, (ke | 0) == (Q | 0))
                                                                            break;
                                                                        }
                                                                      e[5996] = 0, me = Ko(99, S + 72 | 0, 0, 3762) | 0, Q = e[5996], e[5996] = 0;
                                                                      C: {
                                                                        D: {
                                                                          b: {
                                                                            B: {
                                                                              if ((Q | 0) != 1) {
                                                                                if (e[S + 96 >> 2] = e[me + 8 >> 2], Q = e[me + 4 >> 2], e[S + 88 >> 2] = e[me >> 2], e[S + 92 >> 2] = Q, e[me >> 2] = 0, e[me + 4 >> 2] = 0, e[me + 8 >> 2] = 0, e[5996] = 0, Q = wn(97, S + 88 | 0, 3760) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                                                                                  break B;
                                                                                if (e[S + 136 >> 2] = e[Q + 8 >> 2], ke = e[Q + 4 >> 2], e[S + 128 >> 2] = e[Q >> 2], e[S + 132 >> 2] = ke, e[Q >> 2] = 0, e[Q + 4 >> 2] = 0, e[Q + 8 >> 2] = 0, e[5996] = 0, ke = Je[S + 139 | 0], br = ke << 24 >> 24 < 0, Ko(100, S + 144 | 0, (br ? e[S + 128 >> 2] : S + 128 | 0) | 0, (br ? e[S + 132 >> 2] : ke) | 0) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                                                                                  break b;
                                                                                if (Se[S + 139 | 0] < 0 && Tr(e[S + 128 >> 2]), Se[S + 99 | 0] < 0 && Tr(e[Q >> 2]), Se[S + 83 | 0] < 0 && Tr(e[me >> 2]), !Ur)
                                                                                  break f;
                                                                                break c;
                                                                              }
                                                                              Q = gi() | 0;
                                                                              break C;
                                                                            }
                                                                            Q = gi() | 0;
                                                                            break D;
                                                                          }
                                                                          if (Q = gi() | 0, Se[S + 139 | 0] >= 0)
                                                                            break D;
                                                                          Tr(e[S + 128 >> 2]);
                                                                        }
                                                                        if (Se[S + 99 | 0] >= 0)
                                                                          break C;
                                                                        Tr(e[S + 88 >> 2]);
                                                                      }
                                                                      break v;
                                                                    }
                                                                    if (e[5996] = 0, br = no(3, 32) | 0, Q = e[5996], e[5996] = 0, (Q | 0) == 1) {
                                                                      Q = gi() | 0;
                                                                      break s;
                                                                    }
                                                                    if (Q = br, Se[Q | 0] = 136, Se[Q + 1 | 0] = 136, Se[Q + 2 | 0] = 136, Se[Q + 3 | 0] = 136, Se[Q + 4 | 0] = 136, Se[Q + 5 | 0] = 136, Se[Q + 6 | 0] = 136, Se[Q + 7 | 0] = 136, Se[Q + 24 | 0] = 136, Se[Q + 25 | 0] = 136, Se[Q + 26 | 0] = 136, Se[Q + 27 | 0] = 136, Se[Q + 28 | 0] = 136, Se[Q + 29 | 0] = 136, Se[Q + 30 | 0] = 136, Se[Q + 31 | 0] = 136, Se[Q + 16 | 0] = 136, Se[Q + 17 | 0] = 136, Se[Q + 18 | 0] = 136, Se[Q + 19 | 0] = 136, Se[Q + 20 | 0] = 136, Se[Q + 21 | 0] = 136, Se[Q + 22 | 0] = 136, Se[Q + 23 | 0] = 136, Se[Q + 8 | 0] = 136, Se[Q + 9 | 0] = 136, Se[Q + 10 | 0] = 136, Se[Q + 11 | 0] = 136, Se[Q + 12 | 0] = 136, Se[Q + 13 | 0] = 136, Se[Q + 14 | 0] = 136, Se[Q + 15 | 0] = 136, ke = Ar, (me | 0) == (ke | 0))
                                                                      break g;
                                                                    for (; Wn = Je[ke | 0], lo = Je[Q | 0], (Wn | 0) == (lo | 0) && (Q = Q + 1 | 0, ke = ke + 1 | 0, (me | 0) != (ke | 0)); )
                                                                      ;
                                                                    if (Tr(br), (Wn | 0) == (lo | 0))
                                                                      break d;
                                                                    if (!Xr)
                                                                      break I;
                                                                    if ((Xr | 0) != 33)
                                                                      break l;
                                                                  }
                                                                  if (Je[Ar | 0] != 2 | Je[Ar + 1 | 0] != 80 | (Je[Ar + 2 | 0] != 75 | Je[Ar + 3 | 0] != 98))
                                                                    break l;
                                                                  T: {
                                                                    if ((me | 0) != (Ar | 0)) {
                                                                      m: {
                                                                        for (; ; ) {
                                                                          if (Q = me - 1 | 0, !Je[Q | 0]) {
                                                                            if (me = Q, (Q | 0) != (Ar | 0))
                                                                              continue;
                                                                            break m;
                                                                          }
                                                                          break;
                                                                        }
                                                                        if (me = (me - Ar | 0) - 4 | 0, me >>> 0 < 2147483632)
                                                                          break T;
                                                                      }
                                                                      me = Ar;
                                                                    }
                                                                    if (e[5996] = 0, jo(2), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                      break e;
                                                                    Q = gi() | 0;
                                                                    break n;
                                                                  }
                                                                  T: {
                                                                    m: {
                                                                      C: {
                                                                        D: {
                                                                          b: {
                                                                            B: {
                                                                              y: {
                                                                                if (me >>> 0 <= 10) {
                                                                                  Se[S + 55 | 0] = me, ke = S + 44 | 0;
                                                                                  break y;
                                                                                }
                                                                                if (e[5996] = 0, Q = (me | 15) + 1 | 0, ke = no(3, Q | 0) | 0, br = e[5996], e[5996] = 0, (br | 0) == 1)
                                                                                  break B;
                                                                                e[S + 44 >> 2] = ke, e[S + 48 >> 2] = me, e[S + 52 >> 2] = Q | -2147483648;
                                                                              }
                                                                              if (Se[ve(ke, Ar + 4 | 0, me) + me | 0] = 0, e[5996] = 0, me = Ko(99, S + 44 | 0, 0, 3762) | 0, Q = e[5996], e[5996] = 0, (Q | 0) == 1)
                                                                                break b;
                                                                              if (e[S - -64 >> 2] = e[me + 8 >> 2], Q = e[me + 4 >> 2], e[S + 56 >> 2] = e[me >> 2], e[S + 60 >> 2] = Q, e[me >> 2] = 0, e[me + 4 >> 2] = 0, e[me + 8 >> 2] = 0, e[5996] = 0, Q = wn(97, S + 56 | 0, 3760) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                                                                                break D;
                                                                              if (e[S + 136 >> 2] = e[Q + 8 >> 2], ke = e[Q + 4 >> 2], e[S + 128 >> 2] = e[Q >> 2], e[S + 132 >> 2] = ke, e[Q >> 2] = 0, e[Q + 4 >> 2] = 0, e[Q + 8 >> 2] = 0, e[5996] = 0, ke = Je[S + 139 | 0], br = ke << 24 >> 24 < 0, Ko(100, S + 144 | 0, (br ? e[S + 128 >> 2] : S + 128 | 0) | 0, (br ? e[S + 132 >> 2] : ke) | 0) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                                                                                break C;
                                                                              if (Se[S + 139 | 0] < 0 && Tr(e[S + 128 >> 2]), Se[S + 67 | 0] < 0 && Tr(e[Q >> 2]), Se[S + 55 | 0] < 0 && Tr(e[me >> 2]), Ur)
                                                                                break c;
                                                                              break f;
                                                                            }
                                                                            Q = gi() | 0;
                                                                            break s;
                                                                          }
                                                                          Q = gi() | 0;
                                                                          break T;
                                                                        }
                                                                        Q = gi() | 0;
                                                                        break m;
                                                                      }
                                                                      if (Q = gi() | 0, Se[S + 139 | 0] >= 0)
                                                                        break m;
                                                                      Tr(e[S + 128 >> 2]);
                                                                    }
                                                                    if (Se[S + 67 | 0] >= 0)
                                                                      break T;
                                                                    Tr(e[S + 56 >> 2]);
                                                                  }
                                                                  if (Se[S + 55 | 0] >= 0)
                                                                    break s;
                                                                  Tr(e[S + 44 >> 2]);
                                                                  break s;
                                                                }
                                                                if (e[S + 24 >> 2] = 0, e[5996] = 0, e[S + 16 >> 2] = 0, e[S + 20 >> 2] = 0, Co(101, S + 16 | 0, Xr << 1), Q = e[5996], e[5996] = 0, (Q | 0) == 1)
                                                                  break k;
                                                                if (me >>> 0 > Ar >>> 0)
                                                                  for (ke = Ar + Xr | 0, Q = Ar; ; ) {
                                                                    if (me = Je[Q | 0], e[5996] = 0, br = S + 16 | 0, Co(98, br | 0, Se[(me >>> 4 | 0) + 6976 | 0]), Qr = e[5996], e[5996] = 0, (Qr | 0) == 1 || (e[5996] = 0, Co(98, br | 0, Se[(me & 15) + 6976 | 0]), me = e[5996], e[5996] = 0, (me | 0) == 1))
                                                                      break k;
                                                                    if (Q = Q + 1 | 0, (ke | 0) == (Q | 0))
                                                                      break;
                                                                  }
                                                                e[5996] = 0, me = Ko(99, S + 16 | 0, 0, 3762) | 0, Q = e[5996], e[5996] = 0;
                                                                l: {
                                                                  T: {
                                                                    m: {
                                                                      C: {
                                                                        if ((Q | 0) != 1) {
                                                                          if (e[S + 40 >> 2] = e[me + 8 >> 2], Q = e[me + 4 >> 2], e[S + 32 >> 2] = e[me >> 2], e[S + 36 >> 2] = Q, e[me >> 2] = 0, e[me + 4 >> 2] = 0, e[me + 8 >> 2] = 0, e[5996] = 0, Q = wn(97, S + 32 | 0, 3760) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                                                                            break C;
                                                                          if (e[S + 136 >> 2] = e[Q + 8 >> 2], ke = e[Q + 4 >> 2], e[S + 128 >> 2] = e[Q >> 2], e[S + 132 >> 2] = ke, e[Q >> 2] = 0, e[Q + 4 >> 2] = 0, e[Q + 8 >> 2] = 0, e[5996] = 0, ke = Je[S + 139 | 0], br = ke << 24 >> 24 < 0, Ko(100, S + 144 | 0, (br ? e[S + 128 >> 2] : S + 128 | 0) | 0, (br ? e[S + 132 >> 2] : ke) | 0) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                                                                            break m;
                                                                          if (Se[S + 139 | 0] < 0 && Tr(e[S + 128 >> 2]), Se[S + 43 | 0] < 0 && Tr(e[Q >> 2]), Se[S + 27 | 0] < 0 && Tr(e[me >> 2]), !Ur)
                                                                            break f;
                                                                          break c;
                                                                        }
                                                                        Q = gi() | 0;
                                                                        break l;
                                                                      }
                                                                      Q = gi() | 0;
                                                                      break T;
                                                                    }
                                                                    if (Q = gi() | 0, Se[S + 139 | 0] >= 0)
                                                                      break T;
                                                                    Tr(e[S + 128 >> 2]);
                                                                  }
                                                                  if (Se[S + 43 | 0] >= 0)
                                                                    break l;
                                                                  Tr(e[S + 32 >> 2]);
                                                                }
                                                                break R;
                                                              }
                                                              if (Q = e[(Qr << 2) + 5840 >> 2], me = Jf(Q), me >>> 0 >= 2147483632) {
                                                                if (e[5996] = 0, jo(2), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                  break e;
                                                                Q = gi() | 0;
                                                                break s;
                                                              }
                                                              I: {
                                                                l: {
                                                                  T: {
                                                                    m: {
                                                                      C: {
                                                                        D: {
                                                                          b: {
                                                                            B: {
                                                                              y: {
                                                                                x: {
                                                                                  P: {
                                                                                    M: {
                                                                                      N: {
                                                                                        O: {
                                                                                          U: {
                                                                                            F: {
                                                                                              Q: {
                                                                                                L: {
                                                                                                  q: {
                                                                                                    if (me >>> 0 <= 10) {
                                                                                                      Se[S + 139 | 0] = me, ke = S + 128 | 0;
                                                                                                      break q;
                                                                                                    }
                                                                                                    if (e[5996] = 0, br = (me | 15) + 1 | 0, ke = no(3, br | 0) | 0, Xr = e[5996], e[5996] = 0, (Xr | 0) == 1)
                                                                                                      break L;
                                                                                                    e[S + 128 >> 2] = ke, e[S + 132 >> 2] = me, e[S + 136 >> 2] = br | -2147483648;
                                                                                                  }
                                                                                                  if (Se[ve(ke, Q, me) + me | 0] = 0, e[5996] = 0, me = Je[S + 139 | 0], Q = me << 24 >> 24 < 0, me = Ko(100, S + 144 | 0, (Q ? e[S + 128 >> 2] : S + 128 | 0) | 0, (Q ? e[S + 132 >> 2] : me) | 0) | 0, Q = e[5996], e[5996] = 0, (Q | 0) == 1)
                                                                                                    break Q;
                                                                                                  if (Se[S + 139 | 0] < 0 && Tr(e[S + 128 >> 2]), Qr - 99 >>> 0 > 1)
                                                                                                    break p;
                                                                                                  if (e[5996] = 0, Co(98, me | 0, 10), Q = e[5996], e[5996] = 0, (Q | 0) == 1)
                                                                                                    break a;
                                                                                                  if (e[5996] = 0, Q = S + 128 | 0, ia(102, Q | 0, y | 0, I | 0, yn | 0), ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                                                                                                    break F;
                                                                                                  if (e[5996] = 0, br = me, ke = Q, me = Je[S + 139 | 0], Q = me << 24 >> 24 < 0, br = Ko(100, br | 0, (Q ? e[S + 128 >> 2] : ke) | 0, (Q ? e[S + 132 >> 2] : me) | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                                                                    break U;
                                                                                                  if (Se[S + 139 | 0] < 0 && Tr(e[S + 128 >> 2]), ke = Je[y | 0] | Je[y + 1 | 0] << 8 | (Je[y + 2 | 0] << 16 | Je[y + 3 | 0] << 24), (ke | 0) == (I | 0))
                                                                                                    break C;
                                                                                                  if (Je[ke | 0] != 103)
                                                                                                    break N;
                                                                                                  if (Q = 0, (C | 0) > 0) {
                                                                                                    for (; ; ) {
                                                                                                      if (e[5996] = 0, wn(97, br | 0, 5573) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                                                                        break E;
                                                                                                      if (Q = Q + 1 | 0, (Q | 0) == (C | 0))
                                                                                                        break;
                                                                                                    }
                                                                                                    ke = Je[y | 0] | Je[y + 1 | 0] << 8 | (Je[y + 2 | 0] << 16 | Je[y + 3 | 0] << 24);
                                                                                                  }
                                                                                                  if (me = ke + 1 | 0, Se[y | 0] = me, Se[y + 1 | 0] = me >>> 8, Se[y + 2 | 0] = me >>> 16, Se[y + 3 | 0] = me >>> 24, Q = e[(Je[ke | 0] << 2) + 5840 >> 2], me = Jf(Q), me >>> 0 < 2147483632)
                                                                                                    break O;
                                                                                                  if (e[5996] = 0, jo(2), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                                                    break e;
                                                                                                  Q = gi() | 0;
                                                                                                  break s;
                                                                                                }
                                                                                                Q = gi() | 0;
                                                                                                break s;
                                                                                              }
                                                                                              if (Q = gi() | 0, Se[S + 139 | 0] >= 0)
                                                                                                break s;
                                                                                              Tr(e[S + 128 >> 2]);
                                                                                              break s;
                                                                                            }
                                                                                            Q = gi() | 0;
                                                                                            break s;
                                                                                          }
                                                                                          if (Q = gi() | 0, Se[S + 139 | 0] >= 0)
                                                                                            break s;
                                                                                          Tr(e[S + 128 >> 2]);
                                                                                          break s;
                                                                                        }
                                                                                        O: {
                                                                                          if (me >>> 0 <= 10) {
                                                                                            Se[S + 11 | 0] = me, ke = S;
                                                                                            break O;
                                                                                          }
                                                                                          if (e[5996] = 0, Qr = (me | 15) + 1 | 0, ke = no(3, Qr | 0) | 0, Ur = e[5996], e[5996] = 0, (Ur | 0) == 1)
                                                                                            break M;
                                                                                          e[S >> 2] = ke, e[S + 4 >> 2] = me, e[S + 8 >> 2] = Qr | -2147483648;
                                                                                        }
                                                                                        if (Se[ve(ke, Q, me) + me | 0] = 0, e[5996] = 0, Co(98, S | 0, 10), me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                                                          break P;
                                                                                        if (e[S + 136 >> 2] = e[S + 8 >> 2], e[S + 8 >> 2] = 0, Q = e[S + 4 >> 2], me = e[S >> 2], e[S + 128 >> 2] = me, e[S + 132 >> 2] = Q, e[S >> 2] = 0, e[S + 4 >> 2] = 0, e[5996] = 0, ke = me, me = Se[S + 139 | 0], Q = (me | 0) < 0, me = Ko(100, br | 0, (Q ? ke : S + 128 | 0) | 0, (Q ? e[S + 132 >> 2] : me & 255) | 0) | 0, Q = e[5996], e[5996] = 0, (Q | 0) == 1)
                                                                                          break x;
                                                                                        if (Se[S + 139 | 0] < 0 && Tr(e[S + 128 >> 2]), Se[S + 11 | 0] < 0 && Tr(e[S >> 2]), e[5996] = 0, Q = S + 128 | 0, ia(102, Q | 0, y | 0, I | 0, yn | 0), ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                                                                                          break B;
                                                                                        if (e[5996] = 0, Qr = me, ke = Q, me = Je[S + 139 | 0], Q = me << 24 >> 24 < 0, Ko(100, Qr | 0, (Q ? e[S + 128 >> 2] : ke) | 0, (Q ? e[S + 132 >> 2] : me) | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                                                          break b;
                                                                                        Se[S + 139 | 0] < 0 && Tr(e[S + 128 >> 2]), ke = Je[y | 0] | Je[y + 1 | 0] << 8 | (Je[y + 2 | 0] << 16 | Je[y + 3 | 0] << 24);
                                                                                      }
                                                                                      if ((I | 0) == (ke | 0) | Je[ke | 0] != 104)
                                                                                        break C;
                                                                                      if (Q = 0, (C | 0) > 0) {
                                                                                        for (; ; ) {
                                                                                          if (e[5996] = 0, wn(97, br | 0, 5573) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                                                            break S;
                                                                                          if (Q = Q + 1 | 0, (Q | 0) == (C | 0))
                                                                                            break;
                                                                                        }
                                                                                        ke = Je[y | 0] | Je[y + 1 | 0] << 8 | (Je[y + 2 | 0] << 16 | Je[y + 3 | 0] << 24);
                                                                                      }
                                                                                      if (me = ke + 1 | 0, Se[y | 0] = me, Se[y + 1 | 0] = me >>> 8, Se[y + 2 | 0] = me >>> 16, Se[y + 3 | 0] = me >>> 24, Q = e[(Je[ke | 0] << 2) + 5840 >> 2], me = Jf(Q), me >>> 0 < 2147483632)
                                                                                        break D;
                                                                                      if (e[5996] = 0, jo(2), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                                        break e;
                                                                                      Q = gi() | 0;
                                                                                      break s;
                                                                                    }
                                                                                    Q = gi() | 0;
                                                                                    break s;
                                                                                  }
                                                                                  Q = gi() | 0;
                                                                                  break y;
                                                                                }
                                                                                if (Q = gi() | 0, Se[S + 139 | 0] >= 0)
                                                                                  break y;
                                                                                Tr(e[S + 128 >> 2]);
                                                                              }
                                                                              if (Se[S + 11 | 0] >= 0)
                                                                                break s;
                                                                              Tr(e[S >> 2]);
                                                                              break s;
                                                                            }
                                                                            Q = gi() | 0;
                                                                            break s;
                                                                          }
                                                                          if (Q = gi() | 0, Se[S + 139 | 0] >= 0)
                                                                            break s;
                                                                          Tr(e[S + 128 >> 2]);
                                                                          break s;
                                                                        }
                                                                        D: {
                                                                          if (me >>> 0 <= 10) {
                                                                            Se[S + 11 | 0] = me, ke = S;
                                                                            break D;
                                                                          }
                                                                          if (e[5996] = 0, Qr = (me | 15) + 1 | 0, ke = no(3, Qr | 0) | 0, Ur = e[5996], e[5996] = 0, (Ur | 0) == 1)
                                                                            break m;
                                                                          e[S >> 2] = ke, e[S + 4 >> 2] = me, e[S + 8 >> 2] = Qr | -2147483648;
                                                                        }
                                                                        if (Se[ve(ke, Q, me) + me | 0] = 0, e[5996] = 0, Co(98, S | 0, 10), me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                                          break T;
                                                                        if (e[S + 136 >> 2] = e[S + 8 >> 2], e[S + 8 >> 2] = 0, Q = e[S + 4 >> 2], me = e[S >> 2], e[S + 128 >> 2] = me, e[S + 132 >> 2] = Q, e[S >> 2] = 0, e[S + 4 >> 2] = 0, e[5996] = 0, ke = me, me = Se[S + 139 | 0], Q = (me | 0) < 0, Ko(100, br | 0, (Q ? ke : S + 128 | 0) | 0, (Q ? e[S + 132 >> 2] : me & 255) | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                                          break l;
                                                                        if (Se[S + 139 | 0] < 0 && Tr(e[S + 128 >> 2]), Se[S + 11 | 0] >= 0)
                                                                          break C;
                                                                        Tr(e[S >> 2]);
                                                                      }
                                                                      me = Je[S + 155 | 0], Ri = me << 24 >> 24 < 0 ? e[S + 148 >> 2] : me;
                                                                      break c;
                                                                    }
                                                                    Q = gi() | 0;
                                                                    break s;
                                                                  }
                                                                  Q = gi() | 0;
                                                                  break I;
                                                                }
                                                                if (Q = gi() | 0, Se[S + 139 | 0] >= 0)
                                                                  break I;
                                                                Tr(e[S + 128 >> 2]);
                                                              }
                                                              if (Se[S + 11 | 0] >= 0)
                                                                break s;
                                                              Tr(e[S >> 2]);
                                                              break s;
                                                            }
                                                            Q = gi() | 0;
                                                            break s;
                                                          }
                                                          Q = gi() | 0;
                                                          break s;
                                                        }
                                                        Q = gi() | 0;
                                                        break s;
                                                      }
                                                      Q = gi() | 0;
                                                    }
                                                    if (Se[S + 27 | 0] >= 0)
                                                      break s;
                                                    Tr(e[S + 16 >> 2]);
                                                    break s;
                                                  }
                                                  Q = gi() | 0;
                                                }
                                                if (Se[S + 83 | 0] >= 0)
                                                  break s;
                                                Tr(e[S + 72 >> 2]);
                                                break s;
                                              }
                                              Tr(br);
                                            }
                                            if (e[5996] = 0, wn(97, S + 144 | 0, 3719) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                              break a;
                                          }
                                          if (Ur)
                                            break c;
                                        }
                                        if (Q = Je[S + 155 | 0], me = Q << 24 >> 24, ke = (me | 0) < 0, (ke ? e[S + 148 >> 2] : Q) - Ri >>> 0 < 81 || (Q = 0, Se[(ke ? e[S + 144 >> 2] : S + 144 | 0) + En | 0] = 10, Ri = En + 1 | 0, (C | 0) <= 0))
                                          break c;
                                        for (; ; ) {
                                          if (e[5996] = 0, Ko(99, S + 144 | 0, Ri | 0, 5573) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                            break A;
                                          if (Q = Q + 1 | 0, (Q | 0) == (C | 0))
                                            break;
                                        }
                                      }
                                      me = Je[S + 155 | 0], Ur = ((me << 24 >> 24 < 0 ? e[S + 148 >> 2] : me) | 0) == (Ri | 0), Q = 0;
                                    }
                                    if (Ar && Tr(Ar), !!Q)
                                      break;
                                  }
                                  if ((Q | 0) != 3)
                                    break r;
                                }
                                u: {
                                  if (!Ur && (e[5996] = 0, Co(98, S + 144 | 0, 10), y = e[5996], e[5996] = 0, (y | 0) == 1))
                                    break u;
                                  y = e[S + 148 >> 2], e[l >> 2] = e[S + 144 >> 2], e[l + 4 >> 2] = y, e[l + 8 >> 2] = e[S + 152 >> 2];
                                  break t;
                                }
                                Q = gi() | 0;
                                break i;
                              }
                              Q = gi() | 0;
                            }
                            me = Ar;
                            break n;
                          }
                          me = Ar;
                        }
                        Q = gi() | 0;
                      }
                      if (!me)
                        break i;
                      Tr(me);
                    }
                    Se[S + 155 | 0] < 0 && Tr(e[S + 144 >> 2]), ss(Q | 0), jn();
                  }
                  if (Se[S + 155 | 0] >= 0)
                    break t;
                  Tr(e[S + 144 >> 2]);
                }
                bi = S + 160 | 0;
                return;
              }
              jn();
            }
            function el() {
              for (var l = 0, y = 0, I = 0, C = 0, Q = 0, S = 0, me = 0; y = l << 4, I = y + 22944 | 0, e[y + 22948 >> 2] = I, e[y + 22952 >> 2] = I, l = l + 1 | 0, (l | 0) != 64; )
                ;
              ih(48), l = bi - 16 | 0, bi = l;
              e: {
                if (Ki(l + 12 | 0, l + 8 | 0) | 0 || (y = vf((e[l + 12 >> 2] << 2) + 4 | 0), e[6181] = y, !y) || (y = vf(e[l + 8 >> 2]), y && (I = e[6181], e[I + (e[l + 12 >> 2] << 2) >> 2] = 0, !(Vi(I | 0, y | 0) | 0))))
                  break e;
                e[6181] = 0;
              }
              bi = l + 16 | 0, l = ga(64), e[5998] = l, e[5999] = 62, e[6e3] = -2147483584, y = Je[3832] | Je[3833] << 8 | (Je[3834] << 16 | Je[3835] << 24), I = Je[3828] | Je[3829] << 8 | (Je[3830] << 16 | Je[3831] << 24), Se[l + 54 | 0] = I, Se[l + 55 | 0] = I >>> 8, Se[l + 56 | 0] = I >>> 16, Se[l + 57 | 0] = I >>> 24, Se[l + 58 | 0] = y, Se[l + 59 | 0] = y >>> 8, Se[l + 60 | 0] = y >>> 16, Se[l + 61 | 0] = y >>> 24, y = Je[3826] | Je[3827] << 8 | (Je[3828] << 16 | Je[3829] << 24), I = Je[3822] | Je[3823] << 8 | (Je[3824] << 16 | Je[3825] << 24), Se[l + 48 | 0] = I, Se[l + 49 | 0] = I >>> 8, Se[l + 50 | 0] = I >>> 16, Se[l + 51 | 0] = I >>> 24, Se[l + 52 | 0] = y, Se[l + 53 | 0] = y >>> 8, Se[l + 54 | 0] = y >>> 16, Se[l + 55 | 0] = y >>> 24, y = Je[3818] | Je[3819] << 8 | (Je[3820] << 16 | Je[3821] << 24), I = Je[3814] | Je[3815] << 8 | (Je[3816] << 16 | Je[3817] << 24), Se[l + 40 | 0] = I, Se[l + 41 | 0] = I >>> 8, Se[l + 42 | 0] = I >>> 16, Se[l + 43 | 0] = I >>> 24, Se[l + 44 | 0] = y, Se[l + 45 | 0] = y >>> 8, Se[l + 46 | 0] = y >>> 16, Se[l + 47 | 0] = y >>> 24, y = Je[3810] | Je[3811] << 8 | (Je[3812] << 16 | Je[3813] << 24), I = Je[3806] | Je[3807] << 8 | (Je[3808] << 16 | Je[3809] << 24), Se[l + 32 | 0] = I, Se[l + 33 | 0] = I >>> 8, Se[l + 34 | 0] = I >>> 16, Se[l + 35 | 0] = I >>> 24, Se[l + 36 | 0] = y, Se[l + 37 | 0] = y >>> 8, Se[l + 38 | 0] = y >>> 16, Se[l + 39 | 0] = y >>> 24, y = Je[3802] | Je[3803] << 8 | (Je[3804] << 16 | Je[3805] << 24), I = Je[3798] | Je[3799] << 8 | (Je[3800] << 16 | Je[3801] << 24), Se[l + 24 | 0] = I, Se[l + 25 | 0] = I >>> 8, Se[l + 26 | 0] = I >>> 16, Se[l + 27 | 0] = I >>> 24, Se[l + 28 | 0] = y, Se[l + 29 | 0] = y >>> 8, Se[l + 30 | 0] = y >>> 16, Se[l + 31 | 0] = y >>> 24, y = Je[3794] | Je[3795] << 8 | (Je[3796] << 16 | Je[3797] << 24), I = Je[3790] | Je[3791] << 8 | (Je[3792] << 16 | Je[3793] << 24), Se[l + 16 | 0] = I, Se[l + 17 | 0] = I >>> 8, Se[l + 18 | 0] = I >>> 16, Se[l + 19 | 0] = I >>> 24, Se[l + 20 | 0] = y, Se[l + 21 | 0] = y >>> 8, Se[l + 22 | 0] = y >>> 16, Se[l + 23 | 0] = y >>> 24, y = Je[3786] | Je[3787] << 8 | (Je[3788] << 16 | Je[3789] << 24), I = Je[3782] | Je[3783] << 8 | (Je[3784] << 16 | Je[3785] << 24), Se[l + 8 | 0] = I, Se[l + 9 | 0] = I >>> 8, Se[l + 10 | 0] = I >>> 16, Se[l + 11 | 0] = I >>> 24, Se[l + 12 | 0] = y, Se[l + 13 | 0] = y >>> 8, Se[l + 14 | 0] = y >>> 16, Se[l + 15 | 0] = y >>> 24, y = Je[3778] | Je[3779] << 8 | (Je[3780] << 16 | Je[3781] << 24), I = Je[3774] | Je[3775] << 8 | (Je[3776] << 16 | Je[3777] << 24), Se[l | 0] = I, Se[l + 1 | 0] = I >>> 8, Se[l + 2 | 0] = I >>> 16, Se[l + 3 | 0] = I >>> 24, Se[l + 4 | 0] = y, Se[l + 5 | 0] = y >>> 8, Se[l + 6 | 0] = y >>> 16, Se[l + 7 | 0] = y >>> 24, Se[l + 62 | 0] = 0, l = Je[24003], y = l << 24 >> 24;
              e: {
                t: {
                  if (C = (y | 0) < 0 ? e[5999] : l, l = C + 12 | 0, l >>> 0 < 2147483632) {
                    r: {
                      if (l >>> 0 <= 10) {
                        e[6004] = 0, e[6005] = 0, e[6006] = 0, Se[24027] = l, I = 24016;
                        break r;
                      }
                      Q = (l | 15) + 1 | 0, I = ga(Q), e[6005] = l, e[6004] = I, e[6006] = Q | -2147483648;
                    }
                    l = I, I = (y | 0) >= 0 ? 23992 : e[5998], l = ve(l, I, C) + C | 0, Se[l + 12 | 0] = 0, y = Je[5207] | Je[5208] << 8 | (Je[5209] << 16 | Je[5210] << 24), Se[l + 8 | 0] = y, Se[l + 9 | 0] = y >>> 8, Se[l + 10 | 0] = y >>> 16, Se[l + 11 | 0] = y >>> 24, y = Je[5203] | Je[5204] << 8 | (Je[5205] << 16 | Je[5206] << 24), Q = Je[5199] | Je[5200] << 8 | (Je[5201] << 16 | Je[5202] << 24), Se[l | 0] = Q, Se[l + 1 | 0] = Q >>> 8, Se[l + 2 | 0] = Q >>> 16, Se[l + 3 | 0] = Q >>> 24, Se[l + 4 | 0] = y, Se[l + 5 | 0] = y >>> 8, Se[l + 6 | 0] = y >>> 16, Se[l + 7 | 0] = y >>> 24;
                    r: {
                      l = C + 8 | 0;
                      i: {
                        if (l >>> 0 >= 2147483632) {
                          if (e[5996] = 0, jo(2), y = e[5996], e[5996] = 0, l = 24028, (y | 0) == 1)
                            break i;
                          break t;
                        }
                        n: {
                          if (l >>> 0 <= 10) {
                            e[6007] = 0, e[6008] = 0, e[6009] = 0, Se[24039] = l, y = 24028;
                            break n;
                          }
                          if (e[5996] = 0, Q = (l | 15) + 1 | 0, y = no(3, Q | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1) {
                            l = 24028;
                            break i;
                          }
                          e[6008] = l, e[6007] = y, e[6009] = Q | -2147483648;
                        }
                        if (l = ve(y, I, C) + C | 0, Se[l + 8 | 0] = 0, Se[l | 0] = 32, Se[l + 1 | 0] = 46, Se[l + 2 | 0] = 44, Se[l + 3 | 0] = 59, Se[l + 4 | 0] = 45, Se[l + 5 | 0] = 95, Se[l + 6 | 0] = 63, Se[l + 7 | 0] = 64, l = C + 3 | 0, l >>> 0 >= 2147483632) {
                          if (e[5996] = 0, jo(2), y = e[5996], e[5996] = 0, l = 24040, (y | 0) != 1)
                            break t;
                          break i;
                        }
                        n: {
                          if (l >>> 0 <= 10) {
                            e[6010] = 0, e[6011] = 0, e[6012] = 0, Se[24051] = l, y = 24040;
                            break n;
                          }
                          if (e[5996] = 0, Q = (l | 15) + 1 | 0, y = no(3, Q | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1) {
                            l = 24040;
                            break i;
                          }
                          e[6011] = l, e[6010] = y, e[6012] = Q | -2147483648;
                        }
                        if (l = ve(y, I, C) + C | 0, Se[l + 3 | 0] = 0, Se[l + 2 | 0] = Je[2557], y = Je[2555] | Je[2556] << 8, Se[l | 0] = y, Se[l + 1 | 0] = y >>> 8, l = C + 23 | 0, l >>> 0 >= 2147483632) {
                          if (e[5996] = 0, jo(2), y = e[5996], e[5996] = 0, l = 24052, (y | 0) != 1)
                            break t;
                          break i;
                        }
                        if (e[5996] = 0, Q = (l | 15) + 1 | 0, y = no(3, Q | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) != 1)
                          break r;
                        l = 24052;
                      }
                      for (I = gi() | 0; y = l - 12 | 0, Se[l - 1 | 0] < 0 && Tr(e[y >> 2]), l = y, (l | 0) != 24016; )
                        ;
                      ss(I | 0), jn();
                    }
                    e[6014] = l, e[6013] = y, e[6015] = Q | -2147483648, l = ve(y, I, C) + C | 0, Se[l + 23 | 0] = 0, y = Je[5412] | Je[5413] << 8 | (Je[5414] << 16 | Je[5415] << 24), I = Je[5408] | Je[5409] << 8 | (Je[5410] << 16 | Je[5411] << 24), Se[l + 15 | 0] = I, Se[l + 16 | 0] = I >>> 8, Se[l + 17 | 0] = I >>> 16, Se[l + 18 | 0] = I >>> 24, Se[l + 19 | 0] = y, Se[l + 20 | 0] = y >>> 8, Se[l + 21 | 0] = y >>> 16, Se[l + 22 | 0] = y >>> 24, y = Je[5405] | Je[5406] << 8 | (Je[5407] << 16 | Je[5408] << 24), I = Je[5401] | Je[5402] << 8 | (Je[5403] << 16 | Je[5404] << 24), Se[l + 8 | 0] = I, Se[l + 9 | 0] = I >>> 8, Se[l + 10 | 0] = I >>> 16, Se[l + 11 | 0] = I >>> 24, Se[l + 12 | 0] = y, Se[l + 13 | 0] = y >>> 8, Se[l + 14 | 0] = y >>> 16, Se[l + 15 | 0] = y >>> 24, y = Je[5397] | Je[5398] << 8 | (Je[5399] << 16 | Je[5400] << 24), I = Je[5393] | Je[5394] << 8 | (Je[5395] << 16 | Je[5396] << 24), Se[l | 0] = I, Se[l + 1 | 0] = I >>> 8, Se[l + 2 | 0] = I >>> 16, Se[l + 3 | 0] = I >>> 24, Se[l + 4 | 0] = y, Se[l + 5 | 0] = y >>> 8, Se[l + 6 | 0] = y >>> 16, Se[l + 7 | 0] = y >>> 24;
                    break e;
                  }
                  xf(), jn();
                }
                jn();
              }
              C = bi - 48 | 0, bi = C, e[C + 20 >> 2] = 0, e[C + 12 >> 2] = 0, e[C + 16 >> 2] = 0, e[5996] = 0, wn(9, 24064, C + 12 | 0) | 0, l = e[5996], e[5996] = 0;
              e: {
                t: {
                  r: {
                    i: {
                      n: {
                        o: {
                          a: {
                            s: {
                              A: {
                                u: {
                                  if ((l | 0) != 1) {
                                    if (l = e[C + 12 >> 2], l && Tr(l), l = ga(32), e[C + 36 >> 2] = l, y = l + 32 | 0, e[C + 44 >> 2] = y, Se[l + 24 | 0] = 0, Se[l + 25 | 0] = 0, Se[l + 26 | 0] = 0, Se[l + 27 | 0] = 0, Se[l + 28 | 0] = 0, Se[l + 29 | 0] = 0, Se[l + 30 | 0] = 0, Se[l + 31 | 0] = 0, Se[l + 16 | 0] = 0, Se[l + 17 | 0] = 0, Se[l + 18 | 0] = 0, Se[l + 19 | 0] = 0, Se[l + 20 | 0] = 0, Se[l + 21 | 0] = 0, Se[l + 22 | 0] = 0, Se[l + 23 | 0] = 0, Se[l + 8 | 0] = 0, Se[l + 9 | 0] = 0, Se[l + 10 | 0] = 0, Se[l + 11 | 0] = 0, Se[l + 12 | 0] = 0, Se[l + 13 | 0] = 0, Se[l + 14 | 0] = 0, Se[l + 15 | 0] = 0, Se[l | 0] = 0, Se[l + 1 | 0] = 0, Se[l + 2 | 0] = 0, Se[l + 3 | 0] = 0, Se[l + 4 | 0] = 0, Se[l + 5 | 0] = 0, Se[l + 6 | 0] = 0, Se[l + 7 | 0] = 0, e[5996] = 0, e[C + 40 >> 2] = y, S = wn(9, C + 12 | 0, C + 36 | 0) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1)
                                      break n;
                                    if (Se[S + 5 | 0] = 1, e[6024] = e[S + 8 >> 2], l = e[S + 4 >> 2], e[6022] = e[S >> 2], e[6023] = l, e[6025] = 0, e[6026] = 0, e[6027] = 0, I = e[S + 16 >> 2], y = e[S + 12 >> 2], l = I - y | 0, Q = (l | 0) / 12 | 0, (y | 0) == (I | 0))
                                      break o;
                                    if (Q >>> 0 < 357913942)
                                      break u;
                                    if (e[5996] = 0, jo(11), l = e[5996], e[5996] = 0, (l | 0) == 1)
                                      break A;
                                    jn();
                                  }
                                  if (Q = gi() | 0, l = e[C + 12 >> 2], !l)
                                    break e;
                                  Tr(l);
                                  break e;
                                }
                                if (e[5996] = 0, l = no(3, l | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                  break A;
                                if (e[6026] = l, e[6025] = l, e[6027] = l + No(Q, 12), e[5996] = 0, y = mf(12, 24108, y | 0, I | 0, l | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) != 1)
                                  break a;
                                Q = gi() | 0, e[6026] = l;
                                break s;
                              }
                              Q = gi() | 0;
                            }
                            if (I = e[6025], I) {
                              if (l = e[6026], y = I, (l | 0) != (y | 0)) {
                                for (; y = l - 12 | 0, me = e[y >> 2], me && (e[l - 8 >> 2] = me, Tr(me)), l = y, (I | 0) != (l | 0); )
                                  ;
                                y = e[6025];
                              }
                              e[6026] = I, Tr(y);
                            }
                            if (I = e[S + 12 >> 2], !I)
                              break t;
                            if (l = e[S + 16 >> 2], y = I, (l | 0) != (y | 0)) {
                              for (; y = l - 12 | 0, me = e[y >> 2], me && (e[l - 8 >> 2] = me, Tr(me)), l = y, (I | 0) != (l | 0); )
                                ;
                              y = e[S + 12 >> 2];
                            }
                            e[S + 16 >> 2] = I, Tr(y);
                            break t;
                          }
                          e[6026] = y, I = e[S + 12 >> 2];
                        }
                        if (I) {
                          if (l = e[S + 16 >> 2], y = I, (l | 0) != (y | 0)) {
                            for (; y = l - 12 | 0, Q = e[y >> 2], Q && (e[l - 8 >> 2] = Q, Tr(Q)), l = y, (I | 0) != (l | 0); )
                              ;
                            y = e[S + 12 >> 2];
                          }
                          e[S + 16 >> 2] = I, Tr(y);
                        }
                        if (l = e[C + 36 >> 2], l && Tr(l), l = ga(1), e[C + 36 >> 2] = l, y = l + 1 | 0, e[C + 44 >> 2] = y, Se[l | 0] = 1, e[5996] = 0, e[C + 40 >> 2] = y, wn(9, 24112, C + 36 | 0) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1)
                          break i;
                        l = e[C + 36 >> 2], l && Tr(l), e[6036] = 0, e[6037] = 0, e[6034] = 1, e[6038] = 0, e[6039] = 0, Se[24142] = 0, ea[12070] = 0, e[6044] = 0, e[6045] = 0, e[6042] = -1, e[6043] = 0, Se[24163] = 0, Se[24164] = 0, Se[24165] = 0, Se[24166] = 0, e[6040] = 0, bi = C + 48 | 0;
                        break r;
                      }
                      Q = gi() | 0;
                      break t;
                    }
                    Q = gi() | 0;
                    break t;
                  }
                  C = bi - 48 | 0, bi = C, e[C + 20 >> 2] = 0, e[C + 12 >> 2] = 0, e[C + 16 >> 2] = 0, e[5996] = 0, wn(9, 24184, C + 12 | 0) | 0, l = e[5996], e[5996] = 0;
                  r: {
                    i: {
                      n: {
                        o: {
                          a: {
                            s: {
                              A: {
                                u: {
                                  h: {
                                    c: {
                                      if ((l | 0) != 1) {
                                        if (l = e[C + 12 >> 2], l && Tr(l), l = ga(32), e[C + 36 >> 2] = l, y = l + 32 | 0, e[C + 44 >> 2] = y, Se[l + 24 | 0] = 0, Se[l + 25 | 0] = 0, Se[l + 26 | 0] = 0, Se[l + 27 | 0] = 0, Se[l + 28 | 0] = 0, Se[l + 29 | 0] = 0, Se[l + 30 | 0] = 0, Se[l + 31 | 0] = 0, Se[l + 16 | 0] = 0, Se[l + 17 | 0] = 0, Se[l + 18 | 0] = 0, Se[l + 19 | 0] = 0, Se[l + 20 | 0] = 0, Se[l + 21 | 0] = 0, Se[l + 22 | 0] = 0, Se[l + 23 | 0] = 0, Se[l + 8 | 0] = 0, Se[l + 9 | 0] = 0, Se[l + 10 | 0] = 0, Se[l + 11 | 0] = 0, Se[l + 12 | 0] = 0, Se[l + 13 | 0] = 0, Se[l + 14 | 0] = 0, Se[l + 15 | 0] = 0, Se[l | 0] = 0, Se[l + 1 | 0] = 0, Se[l + 2 | 0] = 0, Se[l + 3 | 0] = 0, Se[l + 4 | 0] = 0, Se[l + 5 | 0] = 0, Se[l + 6 | 0] = 0, Se[l + 7 | 0] = 0, e[5996] = 0, e[C + 40 >> 2] = y, S = wn(9, C + 12 | 0, C + 36 | 0) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1)
                                          break a;
                                        if (Se[S + 5 | 0] = 1, e[6054] = e[S + 8 >> 2], l = e[S + 4 >> 2], e[6052] = e[S >> 2], e[6053] = l, e[6055] = 0, e[6056] = 0, e[6057] = 0, I = e[S + 16 >> 2], y = e[S + 12 >> 2], l = I - y | 0, Q = (l | 0) / 12 | 0, (y | 0) == (I | 0))
                                          break s;
                                        if (Q >>> 0 < 357913942)
                                          break c;
                                        if (e[5996] = 0, jo(11), l = e[5996], e[5996] = 0, (l | 0) == 1)
                                          break h;
                                        jn();
                                      }
                                      if (Q = gi() | 0, l = e[C + 12 >> 2], !l)
                                        break e;
                                      Tr(l);
                                      break e;
                                    }
                                    if (e[5996] = 0, l = no(3, l | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                      break h;
                                    if (e[6056] = l, e[6055] = l, e[6057] = l + No(Q, 12), e[5996] = 0, y = mf(12, 24228, y | 0, I | 0, l | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) != 1)
                                      break A;
                                    Q = gi() | 0, e[6056] = l;
                                    break u;
                                  }
                                  Q = gi() | 0;
                                }
                                if (I = e[6055], I) {
                                  if (l = I, y = e[6056], (l | 0) != (y | 0)) {
                                    for (; l = y - 12 | 0, me = e[l >> 2], me && (e[y - 8 >> 2] = me, Tr(me)), y = l, (l | 0) != (I | 0); )
                                      ;
                                    l = e[6055];
                                  }
                                  e[6056] = I, Tr(l);
                                }
                                if (I = e[S + 12 >> 2], !I)
                                  break t;
                                if (l = I, y = e[S + 16 >> 2], (l | 0) != (y | 0)) {
                                  for (; l = y - 12 | 0, me = e[l >> 2], me && (e[y - 8 >> 2] = me, Tr(me)), y = l, (l | 0) != (I | 0); )
                                    ;
                                  l = e[S + 12 >> 2];
                                }
                                e[S + 16 >> 2] = I, Tr(l);
                                break t;
                              }
                              e[6056] = y, I = e[S + 12 >> 2];
                            }
                            if (I) {
                              if (l = I, y = e[S + 16 >> 2], (l | 0) != (y | 0)) {
                                for (; l = y - 12 | 0, Q = e[l >> 2], Q && (e[y - 8 >> 2] = Q, Tr(Q)), y = l, (l | 0) != (I | 0); )
                                  ;
                                l = e[S + 12 >> 2];
                              }
                              e[S + 16 >> 2] = I, Tr(l);
                            }
                            if (l = e[C + 36 >> 2], l && Tr(l), l = ga(1), e[C + 36 >> 2] = l, y = l + 1 | 0, e[C + 44 >> 2] = y, Se[l | 0] = 1, e[5996] = 0, e[C + 40 >> 2] = y, wn(9, 24232, C + 36 | 0) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1)
                              break o;
                            if (l = e[C + 36 >> 2], l && Tr(l), e[6066] = 0, e[6067] = 0, e[6064] = 1, e[6068] = 0, e[6069] = 0, Se[24262] = 0, ea[12130] = 0, e[6074] = 0, e[6075] = 0, e[6072] = -1, e[6073] = 0, Se[24283] = 0, Se[24284] = 0, Se[24285] = 0, Se[24286] = 0, e[6070] = 0, e[6076] = 0, e[6077] = 0, e[6078] = 0, y = ga(56), e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 40 >> 2] = 0, e[y + 44 >> 2] = 0, e[y + 32 >> 2] = 0, e[y + 36 >> 2] = 0, e[y + 24 >> 2] = 0, e[y + 28 >> 2] = 0, e[y + 16 >> 2] = 0, e[y + 20 >> 2] = 0, e[y + 8 >> 2] = 0, e[y + 12 >> 2] = 0, vn(24304, y), l = ga(4), e[l >> 2] = y, e[5996] = 0, y = no(3, 56) | 0, I = e[5996], e[5996] = 0, (I | 0) != 1)
                              break n;
                            break i;
                          }
                          Q = gi() | 0;
                          break t;
                        }
                        Q = gi() | 0;
                        break t;
                      }
                      if (e[y + 16 >> 2] = 0, e[y + 20 >> 2] = 0, e[y + 4 >> 2] = l, e[y >> 2] = 21, l = l + 4 | 0, e[y + 12 >> 2] = l, e[y + 8 >> 2] = l, e[y + 24 >> 2] = 0, e[y + 28 >> 2] = 0, e[y + 32 >> 2] = 0, e[y + 36 >> 2] = 0, e[y + 40 >> 2] = 0, e[y + 44 >> 2] = 0, vn(24304, y), e[6079] = y, y = ga(56), e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, e[y >> 2] = 1, e[y + 12 >> 2] = 0, e[y + 16 >> 2] = 0, e[y + 20 >> 2] = 0, e[y + 24 >> 2] = 0, e[y + 28 >> 2] = 0, e[y + 32 >> 2] = 0, e[y + 36 >> 2] = 0, e[y + 40 >> 2] = 0, e[y + 44 >> 2] = 0, vn(24304, y), l = ga(4), e[l >> 2] = y, e[5996] = 0, y = no(3, 56) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                        break i;
                      e[y + 16 >> 2] = 0, e[y + 20 >> 2] = 0, e[y + 4 >> 2] = l, e[y >> 2] = 21, l = l + 4 | 0, e[y + 12 >> 2] = l, e[y + 8 >> 2] = l, e[y + 24 >> 2] = 0, e[y + 28 >> 2] = 0, e[y + 32 >> 2] = 0, e[y + 36 >> 2] = 0, e[y + 40 >> 2] = 0, e[y + 44 >> 2] = 0, vn(24304, y), e[6080] = y, bi = C + 48 | 0;
                      break r;
                    }
                    y = gi() | 0, Tr(l), ss(y | 0), jn();
                  }
                  C = bi - 48 | 0, bi = C, e[C + 20 >> 2] = 0, e[C + 12 >> 2] = 0, e[C + 16 >> 2] = 0, e[5996] = 0, wn(9, 24592, C + 12 | 0) | 0, l = e[5996], e[5996] = 0;
                  r: {
                    i: {
                      n: {
                        o: {
                          a: {
                            s: {
                              A: {
                                u: {
                                  if ((l | 0) != 1) {
                                    if (l = e[C + 12 >> 2], l && Tr(l), l = ga(32), e[C + 36 >> 2] = l, y = l + 32 | 0, e[C + 44 >> 2] = y, Se[l + 24 | 0] = 0, Se[l + 25 | 0] = 0, Se[l + 26 | 0] = 0, Se[l + 27 | 0] = 0, Se[l + 28 | 0] = 0, Se[l + 29 | 0] = 0, Se[l + 30 | 0] = 0, Se[l + 31 | 0] = 0, Se[l + 16 | 0] = 0, Se[l + 17 | 0] = 0, Se[l + 18 | 0] = 0, Se[l + 19 | 0] = 0, Se[l + 20 | 0] = 0, Se[l + 21 | 0] = 0, Se[l + 22 | 0] = 0, Se[l + 23 | 0] = 0, Se[l + 8 | 0] = 0, Se[l + 9 | 0] = 0, Se[l + 10 | 0] = 0, Se[l + 11 | 0] = 0, Se[l + 12 | 0] = 0, Se[l + 13 | 0] = 0, Se[l + 14 | 0] = 0, Se[l + 15 | 0] = 0, Se[l | 0] = 0, Se[l + 1 | 0] = 0, Se[l + 2 | 0] = 0, Se[l + 3 | 0] = 0, Se[l + 4 | 0] = 0, Se[l + 5 | 0] = 0, Se[l + 6 | 0] = 0, Se[l + 7 | 0] = 0, e[5996] = 0, e[C + 40 >> 2] = y, S = wn(9, C + 12 | 0, C + 36 | 0) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1)
                                      break n;
                                    if (Se[S + 5 | 0] = 1, e[6156] = e[S + 8 >> 2], l = e[S + 4 >> 2], e[6154] = e[S >> 2], e[6155] = l, e[6157] = 0, e[6158] = 0, e[6159] = 0, I = e[S + 16 >> 2], y = e[S + 12 >> 2], l = I - y | 0, Q = (l | 0) / 12 | 0, (y | 0) == (I | 0))
                                      break o;
                                    if (Q >>> 0 < 357913942)
                                      break u;
                                    if (e[5996] = 0, jo(11), l = e[5996], e[5996] = 0, (l | 0) == 1)
                                      break A;
                                    jn();
                                  }
                                  if (Q = gi() | 0, l = e[C + 12 >> 2], !l)
                                    break e;
                                  Tr(l);
                                  break e;
                                }
                                if (e[5996] = 0, l = no(3, l | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                  break A;
                                if (e[6158] = l, e[6157] = l, e[6159] = l + No(Q, 12), e[5996] = 0, y = mf(12, 24636, y | 0, I | 0, l | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) != 1)
                                  break a;
                                Q = gi() | 0, e[6158] = l;
                                break s;
                              }
                              Q = gi() | 0;
                            }
                            if (I = e[6157], I) {
                              if (l = e[6158], y = I, (l | 0) != (y | 0)) {
                                for (; y = l - 12 | 0, me = e[y >> 2], me && (e[l - 8 >> 2] = me, Tr(me)), l = y, (I | 0) != (l | 0); )
                                  ;
                                y = e[6157];
                              }
                              e[6158] = I, Tr(y);
                            }
                            if (I = e[S + 12 >> 2], !I)
                              break t;
                            if (l = e[S + 16 >> 2], y = I, (l | 0) != (y | 0)) {
                              for (; y = l - 12 | 0, me = e[y >> 2], me && (e[l - 8 >> 2] = me, Tr(me)), l = y, (I | 0) != (l | 0); )
                                ;
                              y = e[S + 12 >> 2];
                            }
                            e[S + 16 >> 2] = I, Tr(y);
                            break t;
                          }
                          e[6158] = y, I = e[S + 12 >> 2];
                        }
                        if (I) {
                          if (l = e[S + 16 >> 2], y = I, (l | 0) != (y | 0)) {
                            for (; y = l - 12 | 0, Q = e[y >> 2], Q && (e[l - 8 >> 2] = Q, Tr(Q)), l = y, (I | 0) != (l | 0); )
                              ;
                            y = e[S + 12 >> 2];
                          }
                          e[S + 16 >> 2] = I, Tr(y);
                        }
                        if (l = e[C + 36 >> 2], l && Tr(l), l = ga(1), e[C + 36 >> 2] = l, y = l + 1 | 0, e[C + 44 >> 2] = y, Se[l | 0] = 1, e[5996] = 0, e[C + 40 >> 2] = y, wn(9, 24640, C + 36 | 0) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1)
                          break i;
                        l = e[C + 36 >> 2], l && Tr(l), e[6168] = 0, e[6169] = 0, e[6166] = 1, e[6170] = 0, e[6171] = 0, Se[24670] = 0, ea[12334] = 0, e[6176] = 0, e[6177] = 0, e[6174] = -1, e[6175] = 0, Se[24691] = 0, Se[24692] = 0, Se[24693] = 0, Se[24694] = 0, e[6172] = 0, bi = C + 48 | 0;
                        break r;
                      }
                      Q = gi() | 0;
                      break t;
                    }
                    Q = gi() | 0;
                    break t;
                  }
                  e[6178] = 24816;
                  return;
                }
                if (l = e[C + 36 >> 2], !l)
                  break e;
                Tr(l);
              }
              ss(Q | 0), jn();
            }
            function ju(l, y) {
              l = l | 0, y = y | 0;
              var I = 0, C = 0, Q = 0, S = 0, me = 0, ke = 0, Ar = 0, br = 0, Qr = 0, Ur = 0, Xr = 0, Ri = 0, yn = 0, En = 0, Wn = 0, lo = 0;
              me = bi - 96 | 0, bi = me, e[me + 36 >> 2] = 0, e[me + 28 >> 2] = 0, e[me + 32 >> 2] = 0, e[5996] = 0, Qr = no(3, 12) | 0, I = e[5996], e[5996] = 0;
              e: {
                if ((I | 0) != 1) {
                  lo = me + 36 | 0, Se[Qr + 8 | 0] = 0, e[Qr + 4 >> 2] = 0, e[Qr >> 2] = y, S = Qr + 12 | 0, Wn = S;
                  t: {
                    for (; ; ) {
                      Ar = S - 12 | 0, I = Ar, br = e[I + 4 >> 2], Ri = e[I >> 2], C = e[Ri + 32 >> 2];
                      r: {
                        i: {
                          n: {
                            if (ke = e[Ri + 36 >> 2] - C >> 3, ke >>> 0 > br >>> 0) {
                              y = 1, e[I + 4 >> 2] = br + 1, Q = Je[S - 4 | 0];
                              o: {
                                a: {
                                  s:
                                    switch (I = e[Ri >> 2], I - 11 | 0) {
                                      case 0:
                                        break a;
                                      case 3:
                                        break o;
                                      default:
                                        break s;
                                    }
                                  if (y = 0, (br | 0) != 1 | (I | 0) != 17)
                                    break o;
                                }
                                y = (Q | 0) != 0;
                              }
                              if (br = e[C + (br << 3) >> 2], S >>> 0 < Wn >>> 0) {
                                Se[S + 8 | 0] = y, e[S + 4 >> 2] = 0, e[S >> 2] = br, S = S + 12 | 0;
                                break r;
                              }
                              o: {
                                C = (S - Qr | 0) / 12 | 0, Ar = C + 1 | 0;
                                a: {
                                  if (Ar >>> 0 >= 357913942) {
                                    if (e[5996] = 0, jo(121), l = e[5996], e[5996] = 0, (l | 0) == 1)
                                      break a;
                                    break e;
                                  }
                                  if (Q = (Wn - Qr | 0) / 12 | 0, I = Q << 1, I = Q >>> 0 >= 178956970 ? 357913941 : I >>> 0 > Ar >>> 0 ? I : Ar, I >>> 0 < 357913942)
                                    break o;
                                  if (e[5996] = 0, jo(35), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                    break e;
                                }
                                Ur = gi() | 0;
                                break t;
                              }
                              if (e[5996] = 0, Ar = No(I, 12), ke = no(3, Ar | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                break n;
                              if (I = ke + No(C, 12) | 0, Se[I + 8 | 0] = y, e[I + 4 >> 2] = 0, e[I >> 2] = br, y = I, (S | 0) != (Qr | 0))
                                for (; S = S - 12 | 0, C = S, Q = e[C + 4 >> 2], y = y - 12 | 0, e[y >> 2] = e[C >> 2], e[y + 4 >> 2] = Q, e[y + 8 >> 2] = e[C + 8 >> 2], (C | 0) != (Qr | 0); )
                                  ;
                              Wn = ke + Ar | 0, S = I + 12 | 0, Qr && Tr(Qr), Qr = y;
                              break r;
                            }
                            if (Q = e[me + 28 >> 2], I = e[me + 32 >> 2] - Q >> 5, I >>> 0 < ke >>> 0) {
                              if (e[5996] = 0, ia(44, 5135, 2210, 439, 2439), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                break e;
                              Ur = gi() | 0;
                              break t;
                            }
                            if (y = Je[S - 4 | 0], e[5996] = 0, Xf(122, me + 40 | 0, y | 0, Ri | 0, (Q + (I << 5) | 0) - (ke << 5) | 0, ke | 0), y = e[5996], e[5996] = 0, (y | 0) == 1) {
                              Ur = gi() | 0;
                              break t;
                            }
                            y = e[me + 64 >> 2], e[me + 16 >> 2] = e[me + 60 >> 2], e[me + 20 >> 2] = y, e[me + 24 >> 2] = e[me + 68 >> 2], y = e[me + 56 >> 2], e[me + 8 >> 2] = e[me + 52 >> 2], e[me + 12 >> 2] = y, yn = e[me + 48 >> 2], Xr = e[me + 44 >> 2], br = e[me + 40 >> 2], y = e[me + 32 >> 2], Q = e[Ri + 36 >> 2], I = e[Ri + 32 >> 2];
                            o: {
                              if ((Q | 0) == (I | 0)) {
                                I = y;
                                break o;
                              }
                              if (Q = Q - I << 2, I = y - Q | 0, S = I + (Q & -32) | 0, (S | 0) != (y | 0))
                                for (; C = me - -64 | 0, e[C >> 2] = Je[I + 28 | 0] | Je[I + 29 | 0] << 8 | (Je[I + 30 | 0] << 16 | Je[I + 31 | 0] << 24), Q = Je[I + 24 | 0] | Je[I + 25 | 0] << 8 | (Je[I + 26 | 0] << 16 | Je[I + 27 | 0] << 24), e[me + 56 >> 2] = Je[I + 20 | 0] | Je[I + 21 | 0] << 8 | (Je[I + 22 | 0] << 16 | Je[I + 23 | 0] << 24), e[me + 60 >> 2] = Q, Q = Je[I + 16 | 0] | Je[I + 17 | 0] << 8 | (Je[I + 18 | 0] << 16 | Je[I + 19 | 0] << 24), e[me + 48 >> 2] = Je[I + 12 | 0] | Je[I + 13 | 0] << 8 | (Je[I + 14 | 0] << 16 | Je[I + 15 | 0] << 24), e[me + 52 >> 2] = Q, Q = Je[I + 8 | 0] | Je[I + 9 | 0] << 8 | (Je[I + 10 | 0] << 16 | Je[I + 11 | 0] << 24), e[me + 40 >> 2] = Je[I + 4 | 0] | Je[I + 5 | 0] << 8 | (Je[I + 6 | 0] << 16 | Je[I + 7 | 0] << 24), e[me + 44 >> 2] = Q, Q = Je[S + 28 | 0] | Je[S + 29 | 0] << 8 | (Je[S + 30 | 0] << 16 | Je[S + 31 | 0] << 24), Se[I + 28 | 0] = Q, Se[I + 29 | 0] = Q >>> 8, Se[I + 30 | 0] = Q >>> 16, Se[I + 31 | 0] = Q >>> 24, ke = Je[S + 24 | 0] | Je[S + 25 | 0] << 8 | (Je[S + 26 | 0] << 16 | Je[S + 27 | 0] << 24), Q = Je[S + 20 | 0] | Je[S + 21 | 0] << 8 | (Je[S + 22 | 0] << 16 | Je[S + 23 | 0] << 24), Se[I + 20 | 0] = Q, Se[I + 21 | 0] = Q >>> 8, Se[I + 22 | 0] = Q >>> 16, Se[I + 23 | 0] = Q >>> 24, Se[I + 24 | 0] = ke, Se[I + 25 | 0] = ke >>> 8, Se[I + 26 | 0] = ke >>> 16, Se[I + 27 | 0] = ke >>> 24, ke = Je[S + 16 | 0] | Je[S + 17 | 0] << 8 | (Je[S + 18 | 0] << 16 | Je[S + 19 | 0] << 24), Q = Je[S + 12 | 0] | Je[S + 13 | 0] << 8 | (Je[S + 14 | 0] << 16 | Je[S + 15 | 0] << 24), Se[I + 12 | 0] = Q, Se[I + 13 | 0] = Q >>> 8, Se[I + 14 | 0] = Q >>> 16, Se[I + 15 | 0] = Q >>> 24, Se[I + 16 | 0] = ke, Se[I + 17 | 0] = ke >>> 8, Se[I + 18 | 0] = ke >>> 16, Se[I + 19 | 0] = ke >>> 24, ke = Je[S + 8 | 0] | Je[S + 9 | 0] << 8 | (Je[S + 10 | 0] << 16 | Je[S + 11 | 0] << 24), Q = Je[S + 4 | 0] | Je[S + 5 | 0] << 8 | (Je[S + 6 | 0] << 16 | Je[S + 7 | 0] << 24), Se[I + 4 | 0] = Q, Se[I + 5 | 0] = Q >>> 8, Se[I + 6 | 0] = Q >>> 16, Se[I + 7 | 0] = Q >>> 24, Se[I + 8 | 0] = ke, Se[I + 9 | 0] = ke >>> 8, Se[I + 10 | 0] = ke >>> 16, Se[I + 11 | 0] = ke >>> 24, Q = e[C >> 2], Se[S + 28 | 0] = Q, Se[S + 29 | 0] = Q >>> 8, Se[S + 30 | 0] = Q >>> 16, Se[S + 31 | 0] = Q >>> 24, C = e[me + 60 >> 2], Q = e[me + 56 >> 2], Se[S + 20 | 0] = Q, Se[S + 21 | 0] = Q >>> 8, Se[S + 22 | 0] = Q >>> 16, Se[S + 23 | 0] = Q >>> 24, Se[S + 24 | 0] = C, Se[S + 25 | 0] = C >>> 8, Se[S + 26 | 0] = C >>> 16, Se[S + 27 | 0] = C >>> 24, C = e[me + 52 >> 2], Q = e[me + 48 >> 2], Se[S + 12 | 0] = Q, Se[S + 13 | 0] = Q >>> 8, Se[S + 14 | 0] = Q >>> 16, Se[S + 15 | 0] = Q >>> 24, Se[S + 16 | 0] = C, Se[S + 17 | 0] = C >>> 8, Se[S + 18 | 0] = C >>> 16, Se[S + 19 | 0] = C >>> 24, C = e[me + 44 >> 2], Q = e[me + 40 >> 2], Se[S + 4 | 0] = Q, Se[S + 5 | 0] = Q >>> 8, Se[S + 6 | 0] = Q >>> 16, Se[S + 7 | 0] = Q >>> 24, Se[S + 8 | 0] = C, Se[S + 9 | 0] = C >>> 8, Se[S + 10 | 0] = C >>> 16, Se[S + 11 | 0] = C >>> 24, Q = e[I >> 2], e[I >> 2] = e[S >> 2], e[S >> 2] = Q, I = I + 32 | 0, S = S + 32 | 0, (S | 0) != (y | 0); )
                                  ;
                              if ((y | 0) != (I | 0))
                                for (; Q = y - 32 | 0, (Je[Q | 0] | Je[Q + 1 | 0] << 8 | (Je[Q + 2 | 0] << 16 | Je[Q + 3 | 0] << 24)) >>> 0 >= 29 && (y = y - 24 | 0, Tr(Je[y | 0] | Je[y + 1 | 0] << 8 | (Je[y + 2 | 0] << 16 | Je[y + 3 | 0] << 24)), Se[y | 0] = 0, Se[y + 1 | 0] = 0, Se[y + 2 | 0] = 0, Se[y + 3 | 0] = 0), y = Q, (I | 0) != (y | 0); )
                                  ;
                              e[me + 32 >> 2] = I;
                            }
                            if (S = e[me + 36 >> 2], S >>> 0 > I >>> 0) {
                              Se[I + 4 | 0] = 0, Se[I + 5 | 0] = 0, Se[I + 6 | 0] = 0, Se[I + 7 | 0] = 0, Se[I + 8 | 0] = 0, Se[I + 9 | 0] = 0, Se[I + 10 | 0] = 0, Se[I + 11 | 0] = 0, Se[I + 28 | 0] = 0, Se[I + 29 | 0] = 0, Se[I + 30 | 0] = 0, Se[I + 31 | 0] = 0, Se[I + 20 | 0] = 0, Se[I + 21 | 0] = 0, Se[I + 22 | 0] = 0, Se[I + 23 | 0] = 0, Se[I + 24 | 0] = 0, Se[I + 25 | 0] = 0, Se[I + 26 | 0] = 0, Se[I + 27 | 0] = 0, Se[I + 12 | 0] = 0, Se[I + 13 | 0] = 0, Se[I + 14 | 0] = 0, Se[I + 15 | 0] = 0, Se[I + 16 | 0] = 0, Se[I + 17 | 0] = 0, Se[I + 18 | 0] = 0, Se[I + 19 | 0] = 0, Se[I + 8 | 0] = yn, Se[I + 9 | 0] = yn >>> 8, Se[I + 10 | 0] = yn >>> 16, Se[I + 11 | 0] = yn >>> 24, Se[I + 4 | 0] = Xr, Se[I + 5 | 0] = Xr >>> 8, Se[I + 6 | 0] = Xr >>> 16, Se[I + 7 | 0] = Xr >>> 24, Q = e[me + 12 >> 2], y = e[me + 8 >> 2], Se[I + 12 | 0] = y, Se[I + 13 | 0] = y >>> 8, Se[I + 14 | 0] = y >>> 16, Se[I + 15 | 0] = y >>> 24, Se[I + 16 | 0] = Q, Se[I + 17 | 0] = Q >>> 8, Se[I + 18 | 0] = Q >>> 16, Se[I + 19 | 0] = Q >>> 24, Q = e[me + 20 >> 2], y = e[me + 16 >> 2], Se[I + 20 | 0] = y, Se[I + 21 | 0] = y >>> 8, Se[I + 22 | 0] = y >>> 16, Se[I + 23 | 0] = y >>> 24, Se[I + 24 | 0] = Q, Se[I + 25 | 0] = Q >>> 8, Se[I + 26 | 0] = Q >>> 16, Se[I + 27 | 0] = Q >>> 24, y = e[me + 24 >> 2], Se[I + 28 | 0] = y, Se[I + 29 | 0] = y >>> 8, Se[I + 30 | 0] = y >>> 16, Se[I + 31 | 0] = y >>> 24, e[I >> 2] = br, e[me + 32 >> 2] = I + 32;
                              break i;
                            }
                            o: {
                              a: {
                                s: {
                                  En = e[me + 28 >> 2], C = I - En >> 5, ke = C + 1 | 0;
                                  A: {
                                    if (ke >>> 0 >= 134217728) {
                                      e[5996] = 0, jo(123);
                                      break A;
                                    }
                                    if (e[me + 92 >> 2] = lo, Q = S - En | 0, y = Q >> 4, ke = Q >>> 0 >= 2147483616 ? 134217727 : y >>> 0 > ke >>> 0 ? y : ke, !ke) {
                                      y = 0;
                                      break a;
                                    }
                                    if (ke >>> 0 < 134217728)
                                      break s;
                                    e[5996] = 0, jo(35);
                                  }
                                  if (l = e[5996], e[5996] = 0, (l | 0) != 1)
                                    break e;
                                  break o;
                                }
                                if (e[5996] = 0, y = no(3, ke << 5) | 0, Q = e[5996], e[5996] = 0, (Q | 0) == 1)
                                  break o;
                              }
                              e[me + 76 >> 2] = y, Ur = (ke << 5) + y | 0, e[me + 88 >> 2] = Ur, ke = (C << 5) + y | 0, e[me + 80 >> 2] = ke, C = ke, Se[C + 24 | 0] = 0, Se[C + 25 | 0] = 0, Se[C + 26 | 0] = 0, Se[C + 27 | 0] = 0, Se[C + 28 | 0] = 0, Se[C + 29 | 0] = 0, Se[C + 30 | 0] = 0, Se[C + 31 | 0] = 0, Se[C + 16 | 0] = 0, Se[C + 17 | 0] = 0, Se[C + 18 | 0] = 0, Se[C + 19 | 0] = 0, Se[C + 20 | 0] = 0, Se[C + 21 | 0] = 0, Se[C + 22 | 0] = 0, Se[C + 23 | 0] = 0, Se[C + 8 | 0] = 0, Se[C + 9 | 0] = 0, Se[C + 10 | 0] = 0, Se[C + 11 | 0] = 0, Se[C + 12 | 0] = 0, Se[C + 13 | 0] = 0, Se[C + 14 | 0] = 0, Se[C + 15 | 0] = 0, Se[C | 0] = 0, Se[C + 1 | 0] = 0, Se[C + 2 | 0] = 0, Se[C + 3 | 0] = 0, Se[C + 4 | 0] = 0, Se[C + 5 | 0] = 0, Se[C + 6 | 0] = 0, Se[C + 7 | 0] = 0, e[me + 56 >> 2] = Je[C + 28 | 0] | Je[C + 29 | 0] << 8 | (Je[C + 30 | 0] << 16 | Je[C + 31 | 0] << 24), y = Je[C + 24 | 0] | Je[C + 25 | 0] << 8 | (Je[C + 26 | 0] << 16 | Je[C + 27 | 0] << 24), e[me + 48 >> 2] = Je[C + 20 | 0] | Je[C + 21 | 0] << 8 | (Je[C + 22 | 0] << 16 | Je[C + 23 | 0] << 24), e[me + 52 >> 2] = y, y = Je[C + 16 | 0] | Je[C + 17 | 0] << 8 | (Je[C + 18 | 0] << 16 | Je[C + 19 | 0] << 24), e[me + 40 >> 2] = Je[C + 12 | 0] | Je[C + 13 | 0] << 8 | (Je[C + 14 | 0] << 16 | Je[C + 15 | 0] << 24), e[me + 44 >> 2] = y, Se[C + 8 | 0] = yn, Se[C + 9 | 0] = yn >>> 8, Se[C + 10 | 0] = yn >>> 16, Se[C + 11 | 0] = yn >>> 24, Se[C + 4 | 0] = Xr, Se[C + 5 | 0] = Xr >>> 8, Se[C + 6 | 0] = Xr >>> 16, Se[C + 7 | 0] = Xr >>> 24, y = e[me + 24 >> 2], Se[C + 28 | 0] = y, Se[C + 29 | 0] = y >>> 8, Se[C + 30 | 0] = y >>> 16, Se[C + 31 | 0] = y >>> 24, Q = e[me + 20 >> 2], y = e[me + 16 >> 2], Se[C + 20 | 0] = y, Se[C + 21 | 0] = y >>> 8, Se[C + 22 | 0] = y >>> 16, Se[C + 23 | 0] = y >>> 24, Se[C + 24 | 0] = Q, Se[C + 25 | 0] = Q >>> 8, Se[C + 26 | 0] = Q >>> 16, Se[C + 27 | 0] = Q >>> 24, Q = e[me + 12 >> 2], y = e[me + 8 >> 2], Se[C + 12 | 0] = y, Se[C + 13 | 0] = y >>> 8, Se[C + 14 | 0] = y >>> 16, Se[C + 15 | 0] = y >>> 24, Se[C + 16 | 0] = Q, Se[C + 17 | 0] = Q >>> 8, Se[C + 18 | 0] = Q >>> 16, Se[C + 19 | 0] = Q >>> 24, y = e[me + 52 >> 2], e[me + 16 >> 2] = e[me + 48 >> 2], e[me + 20 >> 2] = y, e[me + 24 >> 2] = e[me + 56 >> 2], y = e[me + 44 >> 2], e[me + 8 >> 2] = e[me + 40 >> 2], e[me + 12 >> 2] = y, e[C >> 2] = br, y = C + 32 | 0, e[me + 84 >> 2] = y;
                              a: {
                                if ((I | 0) == (En | 0))
                                  Q = I;
                                else {
                                  for (; ; ) {
                                    if (y = C, C = C - 32 | 0, Se[C | 0] = 0, Se[C + 1 | 0] = 0, Se[C + 2 | 0] = 0, Se[C + 3 | 0] = 0, Se[C + 4 | 0] = 0, Se[C + 5 | 0] = 0, Se[C + 6 | 0] = 0, Se[C + 7 | 0] = 0, Se[C + 24 | 0] = 0, Se[C + 25 | 0] = 0, Se[C + 26 | 0] = 0, Se[C + 27 | 0] = 0, Se[C + 28 | 0] = 0, Se[C + 29 | 0] = 0, Se[C + 30 | 0] = 0, Se[C + 31 | 0] = 0, Se[C + 16 | 0] = 0, Se[C + 17 | 0] = 0, Se[C + 18 | 0] = 0, Se[C + 19 | 0] = 0, Se[C + 20 | 0] = 0, Se[C + 21 | 0] = 0, Se[C + 22 | 0] = 0, Se[C + 23 | 0] = 0, Se[C + 8 | 0] = 0, Se[C + 9 | 0] = 0, Se[C + 10 | 0] = 0, Se[C + 11 | 0] = 0, Se[C + 12 | 0] = 0, Se[C + 13 | 0] = 0, Se[C + 14 | 0] = 0, Se[C + 15 | 0] = 0, Q = I, I = I - 32 | 0, S = Je[I | 0] | Je[I + 1 | 0] << 8 | (Je[I + 2 | 0] << 16 | Je[I + 3 | 0] << 24), e[5996] = 0, br = S >>> 0 < 29 ? S : S - 29 | 0, Co(124, C | 0, br | 0), S = e[5996], e[5996] = 0, (S | 0) == 1)
                                      break a;
                                    Xr = br + (Je[C | 0] | Je[C + 1 | 0] << 8 | (Je[C + 2 | 0] << 16 | Je[C + 3 | 0] << 24)) | 0, Se[C | 0] = Xr, Se[C + 1 | 0] = Xr >>> 8, Se[C + 2 | 0] = Xr >>> 16, Se[C + 3 | 0] = Xr >>> 24, S = Je[I | 0] | Je[I + 1 | 0] << 8 | (Je[I + 2 | 0] << 16 | Je[I + 3 | 0] << 24), br = S >>> 0 < 29, Ri = br ? S : S - 29 | 0;
                                    s: {
                                      if (!Ri)
                                        break s;
                                      if (S = y - 28 | 0, y = y - 24 | 0, S = Xr >>> 0 < 29 ? S : Je[y | 0] | Je[y + 1 | 0] << 8 | (Je[y + 2 | 0] << 16 | Je[y + 3 | 0] << 24), Ur = 0, y = Q - 24 | 0, br = br ? Q - 28 | 0 : Je[y | 0] | Je[y + 1 | 0] << 8 | (Je[y + 2 | 0] << 16 | Je[y + 3 | 0] << 24), y = br, Q = Ri & 7, Q)
                                        for (; Se[S | 0] = Je[y | 0], y = y + 1 | 0, S = S + 1 | 0, Ur = Ur + 1 | 0, (Q | 0) != (Ur | 0); )
                                          ;
                                      if (Ri >>> 0 < 8)
                                        break s;
                                      for (Q = br + Ri | 0; Se[S | 0] = Je[y | 0], Se[S + 1 | 0] = Je[y + 1 | 0], Se[S + 2 | 0] = Je[y + 2 | 0], Se[S + 3 | 0] = Je[y + 3 | 0], Se[S + 4 | 0] = Je[y + 4 | 0], Se[S + 5 | 0] = Je[y + 5 | 0], Se[S + 6 | 0] = Je[y + 6 | 0], Se[S + 7 | 0] = Je[y + 7 | 0], S = S + 8 | 0, y = y + 8 | 0, (Q | 0) != (y | 0); )
                                        ;
                                    }
                                    if ((I | 0) == (En | 0))
                                      break;
                                  }
                                  Ur = e[me + 88 >> 2], S = e[me + 36 >> 2], y = e[me + 84 >> 2], I = e[me + 32 >> 2], Q = e[me + 28 >> 2];
                                }
                                if (e[me + 80 >> 2] = Q, e[me + 28 >> 2] = C, e[me + 32 >> 2] = y, e[me + 36 >> 2] = Ur, e[me + 88 >> 2] = S, e[me + 76 >> 2] = Q, e[me + 84 >> 2] = I, (I | 0) != (Q | 0)) {
                                  for (; y = I - 32 | 0, e[me + 84 >> 2] = y, (Je[y | 0] | Je[y + 1 | 0] << 8 | (Je[y + 2 | 0] << 16 | Je[y + 3 | 0] << 24)) >>> 0 >= 29 && (y = I - 24 | 0, Tr(Je[y | 0] | Je[y + 1 | 0] << 8 | (Je[y + 2 | 0] << 16 | Je[y + 3 | 0] << 24)), Se[y | 0] = 0, Se[y + 1 | 0] = 0, Se[y + 2 | 0] = 0, Se[y + 3 | 0] = 0, y = e[me + 84 >> 2]), I = y, (Q | 0) != (I | 0); )
                                    ;
                                  I = e[me + 76 >> 2];
                                }
                                if (!I)
                                  break i;
                                Tr(I), S = Ar;
                                break r;
                              }
                              if (Ur = gi() | 0, (y | 0) != (ke | 0))
                                for (; (Je[y | 0] | Je[y + 1 | 0] << 8 | (Je[y + 2 | 0] << 16 | Je[y + 3 | 0] << 24)) >>> 0 >= 29 && (Tr(Je[y + 8 | 0] | Je[y + 9 | 0] << 8 | (Je[y + 10 | 0] << 16 | Je[y + 11 | 0] << 24)), Se[y + 8 | 0] = 0, Se[y + 9 | 0] = 0, Se[y + 10 | 0] = 0, Se[y + 11 | 0] = 0), y = y + 32 | 0, (ke | 0) != (y | 0); )
                                  ;
                              if (y = e[me + 84 >> 2], I = e[me + 80 >> 2], (y | 0) != (I | 0))
                                for (; l = y - 32 | 0, e[me + 84 >> 2] = l, (Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24)) >>> 0 >= 29 && (l = y - 24 | 0, Tr(Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24)), Se[l | 0] = 0, Se[l + 1 | 0] = 0, Se[l + 2 | 0] = 0, Se[l + 3 | 0] = 0, l = e[me + 84 >> 2]), y = l, (I | 0) != (y | 0); )
                                  ;
                              l = e[me + 76 >> 2], l && Tr(l);
                              break t;
                            }
                            if (Ur = gi() | 0, br >>> 0 < 29)
                              break t;
                            Tr(yn);
                            break t;
                          }
                          Ur = gi() | 0;
                          break t;
                        }
                        S = Ar;
                      }
                      if ((S | 0) == (Qr | 0))
                        break;
                    }
                    if (y = e[me + 32 >> 2], I = e[me + 28 >> 2], (y - I | 0) != 32) {
                      if (e[5996] = 0, ia(44, 4102, 2210, 450, 2439), l = e[5996], e[5996] = 0, (l | 0) != 1)
                        break e;
                      Ur = gi() | 0;
                      break t;
                    }
                    if (Se[l | 0] = 0, Se[l + 1 | 0] = 0, Se[l + 2 | 0] = 0, Se[l + 3 | 0] = 0, Se[l + 4 | 0] = 0, Se[l + 5 | 0] = 0, Se[l + 6 | 0] = 0, Se[l + 7 | 0] = 0, Se[l + 24 | 0] = 0, Se[l + 25 | 0] = 0, Se[l + 26 | 0] = 0, Se[l + 27 | 0] = 0, Se[l + 28 | 0] = 0, Se[l + 29 | 0] = 0, Se[l + 30 | 0] = 0, Se[l + 31 | 0] = 0, Se[l + 16 | 0] = 0, Se[l + 17 | 0] = 0, Se[l + 18 | 0] = 0, Se[l + 19 | 0] = 0, Se[l + 20 | 0] = 0, Se[l + 21 | 0] = 0, Se[l + 22 | 0] = 0, Se[l + 23 | 0] = 0, Se[l + 8 | 0] = 0, Se[l + 9 | 0] = 0, Se[l + 10 | 0] = 0, Se[l + 11 | 0] = 0, Se[l + 12 | 0] = 0, Se[l + 13 | 0] = 0, Se[l + 14 | 0] = 0, Se[l + 15 | 0] = 0, Ar = me - -64 | 0, e[Ar >> 2] = Je[l + 28 | 0] | Je[l + 29 | 0] << 8 | (Je[l + 30 | 0] << 16 | Je[l + 31 | 0] << 24), Q = Je[l + 24 | 0] | Je[l + 25 | 0] << 8 | (Je[l + 26 | 0] << 16 | Je[l + 27 | 0] << 24), e[me + 56 >> 2] = Je[l + 20 | 0] | Je[l + 21 | 0] << 8 | (Je[l + 22 | 0] << 16 | Je[l + 23 | 0] << 24), e[me + 60 >> 2] = Q, Q = Je[l + 16 | 0] | Je[l + 17 | 0] << 8 | (Je[l + 18 | 0] << 16 | Je[l + 19 | 0] << 24), e[me + 48 >> 2] = Je[l + 12 | 0] | Je[l + 13 | 0] << 8 | (Je[l + 14 | 0] << 16 | Je[l + 15 | 0] << 24), e[me + 52 >> 2] = Q, Q = Je[l + 8 | 0] | Je[l + 9 | 0] << 8 | (Je[l + 10 | 0] << 16 | Je[l + 11 | 0] << 24), e[me + 40 >> 2] = Je[l + 4 | 0] | Je[l + 5 | 0] << 8 | (Je[l + 6 | 0] << 16 | Je[l + 7 | 0] << 24), e[me + 44 >> 2] = Q, Q = Je[I + 28 | 0] | Je[I + 29 | 0] << 8 | (Je[I + 30 | 0] << 16 | Je[I + 31 | 0] << 24), Se[l + 28 | 0] = Q, Se[l + 29 | 0] = Q >>> 8, Se[l + 30 | 0] = Q >>> 16, Se[l + 31 | 0] = Q >>> 24, C = Je[I + 24 | 0] | Je[I + 25 | 0] << 8 | (Je[I + 26 | 0] << 16 | Je[I + 27 | 0] << 24), Q = Je[I + 20 | 0] | Je[I + 21 | 0] << 8 | (Je[I + 22 | 0] << 16 | Je[I + 23 | 0] << 24), Se[l + 20 | 0] = Q, Se[l + 21 | 0] = Q >>> 8, Se[l + 22 | 0] = Q >>> 16, Se[l + 23 | 0] = Q >>> 24, Se[l + 24 | 0] = C, Se[l + 25 | 0] = C >>> 8, Se[l + 26 | 0] = C >>> 16, Se[l + 27 | 0] = C >>> 24, C = Je[I + 16 | 0] | Je[I + 17 | 0] << 8 | (Je[I + 18 | 0] << 16 | Je[I + 19 | 0] << 24), Q = Je[I + 12 | 0] | Je[I + 13 | 0] << 8 | (Je[I + 14 | 0] << 16 | Je[I + 15 | 0] << 24), Se[l + 12 | 0] = Q, Se[l + 13 | 0] = Q >>> 8, Se[l + 14 | 0] = Q >>> 16, Se[l + 15 | 0] = Q >>> 24, Se[l + 16 | 0] = C, Se[l + 17 | 0] = C >>> 8, Se[l + 18 | 0] = C >>> 16, Se[l + 19 | 0] = C >>> 24, C = Je[I + 8 | 0] | Je[I + 9 | 0] << 8 | (Je[I + 10 | 0] << 16 | Je[I + 11 | 0] << 24), Q = Je[I + 4 | 0] | Je[I + 5 | 0] << 8 | (Je[I + 6 | 0] << 16 | Je[I + 7 | 0] << 24), Se[l + 4 | 0] = Q, Se[l + 5 | 0] = Q >>> 8, Se[l + 6 | 0] = Q >>> 16, Se[l + 7 | 0] = Q >>> 24, Se[l + 8 | 0] = C, Se[l + 9 | 0] = C >>> 8, Se[l + 10 | 0] = C >>> 16, Se[l + 11 | 0] = C >>> 24, Q = e[Ar >> 2], Se[I + 28 | 0] = Q, Se[I + 29 | 0] = Q >>> 8, Se[I + 30 | 0] = Q >>> 16, Se[I + 31 | 0] = Q >>> 24, Ar = e[me + 60 >> 2], Q = e[me + 56 >> 2], Se[I + 20 | 0] = Q, Se[I + 21 | 0] = Q >>> 8, Se[I + 22 | 0] = Q >>> 16, Se[I + 23 | 0] = Q >>> 24, Se[I + 24 | 0] = Ar, Se[I + 25 | 0] = Ar >>> 8, Se[I + 26 | 0] = Ar >>> 16, Se[I + 27 | 0] = Ar >>> 24, Ar = e[me + 52 >> 2], Q = e[me + 48 >> 2], Se[I + 12 | 0] = Q, Se[I + 13 | 0] = Q >>> 8, Se[I + 14 | 0] = Q >>> 16, Se[I + 15 | 0] = Q >>> 24, Se[I + 16 | 0] = Ar, Se[I + 17 | 0] = Ar >>> 8, Se[I + 18 | 0] = Ar >>> 16, Se[I + 19 | 0] = Ar >>> 24, Ar = e[me + 44 >> 2], Q = e[me + 40 >> 2], Se[I + 4 | 0] = Q, Se[I + 5 | 0] = Q >>> 8, Se[I + 6 | 0] = Q >>> 16, Se[I + 7 | 0] = Q >>> 24, Se[I + 8 | 0] = Ar, Se[I + 9 | 0] = Ar >>> 8, Se[I + 10 | 0] = Ar >>> 16, Se[I + 11 | 0] = Ar >>> 24, e[l >> 2] = e[I >> 2], e[I >> 2] = 0, Se[l + 32 | 0] = 1, (y | 0) != (I | 0)) {
                      for (; l = y - 32 | 0, (Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24)) >>> 0 >= 29 && (y = y - 24 | 0, Tr(Je[y | 0] | Je[y + 1 | 0] << 8 | (Je[y + 2 | 0] << 16 | Je[y + 3 | 0] << 24)), Se[y | 0] = 0, Se[y + 1 | 0] = 0, Se[y + 2 | 0] = 0, Se[y + 3 | 0] = 0), y = l, (I | 0) != (y | 0); )
                        ;
                      y = e[me + 28 >> 2];
                    }
                    e[me + 32 >> 2] = I, Tr(y), Qr && Tr(Qr), bi = me + 96 | 0;
                    return;
                  }
                  td(me + 28 | 0), Qr && Tr(Qr), ss(Ur | 0), jn();
                }
                l = gi() | 0, td(me + 28 | 0), ss(l | 0), jn();
              }
              jn();
            }
            function tl(l, y, I) {
              l = l | 0, y = y | 0, I = I | 0;
              var C = 0, Q = 0, S = 0, me = 0, ke = 0, Ar = 0, br = 0, Qr = 0, Ur = 0, Xr = 0, Ri = 0, yn = 0, En = 0, Wn = 0, lo = 0, Ro = 0, Xo = 0, bs = 0, Os = 0, Gs = 0, aa = 0, Ma = 0, rf = 0, af = 0, lf = 0, wf = 0;
              me = bi - 48 | 0, bi = me, e[me + 32 >> 2] = 0, e[me + 24 >> 2] = 0, e[me + 28 >> 2] = 0, e[5996] = 0, yn = no(3, 12) | 0, C = e[5996], e[5996] = 0;
              e: {
                if ((C | 0) != 1) {
                  e[yn + 4 >> 2] = 0, e[yn >> 2] = y, lo = me + 40 | 0, aa = me + 12 | 0, Ma = yn + 12 | 0, S = Ma;
                  t: {
                    r: {
                      i: {
                        for (; ; ) {
                          n: {
                            wf = S - 12 | 0, y = wf, C = e[y + 4 >> 2];
                            o: {
                              a: {
                                s: {
                                  A: {
                                    u: {
                                      if (Ro = e[y >> 2], Ri = e[Ro + 36 >> 2], rf = e[Ro + 32 >> 2], af = Ri - rf >> 3, C >>> 0 < af >>> 0) {
                                        if (e[y + 4 >> 2] = C + 1, Ar = e[(C << 3) + rf >> 2], S >>> 0 < Ma >>> 0) {
                                          e[S + 4 >> 2] = 0, e[S >> 2] = Ar, S = S + 12 | 0;
                                          break o;
                                        }
                                        h: {
                                          Q = (S - yn | 0) / 12 | 0, ke = Q + 1 | 0;
                                          c: {
                                            if (ke >>> 0 >= 357913942) {
                                              if (e[5996] = 0, jo(95), l = e[5996], e[5996] = 0, (l | 0) == 1)
                                                break c;
                                              break e;
                                            }
                                            if (C = (Ma - yn | 0) / 12 | 0, y = C << 1, y = C >>> 0 >= 178956970 ? 357913941 : y >>> 0 > ke >>> 0 ? y : ke, y >>> 0 < 357913942)
                                              break h;
                                            if (e[5996] = 0, jo(35), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                              break e;
                                          }
                                          y = gi() | 0;
                                          break t;
                                        }
                                        if (e[5996] = 0, ke = No(y, 12), br = no(3, ke | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                          break u;
                                        if (C = br + No(Q, 12) | 0, e[C + 4 >> 2] = 0, e[C >> 2] = Ar, y = C, (S | 0) != (yn | 0))
                                          for (; S = S - 12 | 0, Q = e[S + 4 >> 2], y = y - 12 | 0, e[y >> 2] = e[S >> 2], e[y + 4 >> 2] = Q, e[y + 8 >> 2] = e[S + 8 >> 2], (S | 0) != (yn | 0); )
                                            ;
                                        Ma = ke + br | 0, S = C + 12 | 0, yn && Tr(yn), yn = y;
                                        break o;
                                      }
                                      if (Qr = e[me + 24 >> 2], br = (e[me + 28 >> 2] - Qr | 0) / 12 | 0, br >>> 0 < af >>> 0) {
                                        if (e[5996] = 0, ia(44, 5135, 2210, 439, 2439), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                          break e;
                                        y = gi() | 0;
                                        break t;
                                      }
                                      if (Je[Ro + 88 | 0] && e[I >> 2] != (Ro | 0))
                                        break s;
                                      if (lf = e[Ro + 12 >> 2], Ur = e[Ro + 8 >> 2], e[me + 36 >> 2] = lo, e[me + 40 >> 2] = 0, e[me + 44 >> 2] = 0, Os = (lf - Ur | 0) / 12 | 0, Xr = 0, y = lo, Q = 0, (Ur | 0) == (lf | 0))
                                        break A;
                                      for (; ; ) {
                                        h: {
                                          c: {
                                            f: {
                                              p: {
                                                S = lo;
                                                d: {
                                                  if ((S | 0) == (y | 0))
                                                    break d;
                                                  C = S, y = Q;
                                                  g: {
                                                    if (Q) {
                                                      for (; ; )
                                                        if (S = y, y = e[y + 4 >> 2], !y)
                                                          break g;
                                                    }
                                                    for (; S = e[C + 8 >> 2], y = e[S >> 2] == (C | 0), C = S, !!y; )
                                                      ;
                                                  }
                                                  Gs = e[Ur >> 2], En = Je[Ur + 11 | 0], ke = En << 24 >> 24, Xo = (ke | 0) < 0, y = Je[S + 27 | 0], bs = y << 24 >> 24 < 0;
                                                  g: {
                                                    if (C = e[Ur + 4 >> 2], Wn = Xo ? C : En, Ar = bs ? e[S + 20 >> 2] : y, y = Ar >>> 0 > Wn >>> 0 ? Wn : Ar, y && (y = Wf(bs ? e[S + 16 >> 2] : S + 16 | 0, Xo ? Gs : Ur, y), y))
                                                      break g;
                                                    if (Ar >>> 0 < Wn >>> 0)
                                                      break d;
                                                    break p;
                                                  }
                                                  if ((y | 0) >= 0)
                                                    break p;
                                                }
                                                y = Q ? S : lo, Ar = Q ? S + 4 | 0 : lo;
                                                break f;
                                              }
                                              if (y = lo, Ar = y, !Q)
                                                break f;
                                              for (y = (ke | 0) >= 0, Xo = y ? Ur : Gs, Gs = y ? En : C, C = Q; ; ) {
                                                y = C, S = Je[C + 27 | 0], bs = S << 24 >> 24 < 0, En = bs ? e[C + 20 >> 2] : S, Wn = En >>> 0 < Gs >>> 0;
                                                p: {
                                                  d: {
                                                    g: {
                                                      v: {
                                                        ke = Wn ? En : Gs;
                                                        _: {
                                                          if (ke) {
                                                            if (S = bs ? e[C + 16 >> 2] : C + 16 | 0, C = Wf(Xo, S, ke), !C) {
                                                              if (En >>> 0 > Gs >>> 0)
                                                                break _;
                                                              break v;
                                                            }
                                                            if ((C | 0) >= 0)
                                                              break v;
                                                            break _;
                                                          }
                                                          if (En >>> 0 <= Gs >>> 0)
                                                            break g;
                                                        }
                                                        if (Ar = y, C = e[y >> 2], C)
                                                          continue;
                                                        break c;
                                                      }
                                                      if (C = Wf(S, Xo, ke), C)
                                                        break d;
                                                    }
                                                    if (!Wn)
                                                      break f;
                                                    break p;
                                                  }
                                                  if ((C | 0) >= 0)
                                                    break f;
                                                }
                                                if (Ar = y + 4 | 0, C = e[y + 4 >> 2], !C)
                                                  break;
                                              }
                                              break c;
                                            }
                                            if (e[Ar >> 2])
                                              break h;
                                          }
                                          e[5996] = 0, S = no(3, 28) | 0, C = e[5996], e[5996] = 0;
                                          c: {
                                            if ((C | 0) != 1) {
                                              if (ke = S + 16 | 0, Se[Ur + 11 | 0] >= 0) {
                                                C = e[Ur + 4 >> 2], e[ke >> 2] = e[Ur >> 2], e[ke + 4 >> 2] = C, e[ke + 8 >> 2] = e[Ur + 8 >> 2];
                                                break c;
                                              }
                                              if (Q = e[Ur + 4 >> 2], C = e[Ur >> 2], e[5996] = 0, Ms(40, ke | 0, C | 0, Q | 0), C = e[5996], e[5996] = 0, (C | 0) != 1)
                                                break c;
                                              y = gi() | 0, Tr(S), Kf(e[me + 40 >> 2]);
                                              break t;
                                            }
                                            y = gi() | 0, Kf(Q);
                                            break t;
                                          }
                                          e[S + 8 >> 2] = y, e[S >> 2] = 0, e[S + 4 >> 2] = 0, e[Ar >> 2] = S, y = e[e[me + 36 >> 2] >> 2], y && (e[me + 36 >> 2] = y, S = e[Ar >> 2]), Pu(e[me + 40 >> 2], S), Xr = e[me + 44 >> 2] + 1 | 0, e[me + 44 >> 2] = Xr;
                                        }
                                        if (Ur = Ur + 12 | 0, (lf | 0) == (Ur | 0))
                                          break A;
                                        y = e[me + 36 >> 2], Q = e[me + 40 >> 2];
                                      }
                                    }
                                    y = gi() | 0;
                                    break t;
                                  }
                                  A: {
                                    u: {
                                      if ((Xr | 0) != (Os | 0))
                                        break u;
                                      if ((Ri | 0) != (rf | 0))
                                        for (Xo = Qr + No(br, 12) | 0, Xr = Xo + No(af, -12) | 0; ; ) {
                                          if (C = e[Xr + 8 >> 2], C >>> 0 > Os >>> 0 && (y = e[me + 36 >> 2], e[me + 36 >> 2] = e[Xr >> 2], e[Xr >> 2] = y, y = e[me + 40 >> 2], e[me + 40 >> 2] = e[Xr + 4 >> 2], e[Xr + 4 >> 2] = y, y = e[me + 44 >> 2], e[me + 44 >> 2] = C, e[Xr + 8 >> 2] = y, e[(e[me + 44 >> 2] ? e[me + 40 >> 2] + 8 | 0 : me + 36 | 0) >> 2] = lo, e[(y ? e[Xr + 4 >> 2] + 8 | 0 : Xr) >> 2] = Xr + 4), Os = C + Os | 0, br = e[Xr >> 2], bs = Xr + 4 | 0, (br | 0) != (bs | 0))
                                            for (; ; ) {
                                              ke = 0, C = e[me + 40 >> 2];
                                              h: {
                                                if (!C) {
                                                  S = lo, Ur = S;
                                                  break h;
                                                }
                                                for (Q = Je[br + 27 | 0], y = Q << 24 >> 24 >= 0, Ri = y ? br + 16 | 0 : e[br + 16 >> 2], En = y ? Q : e[br + 20 >> 2], Ur = lo; ; ) {
                                                  S = C, y = Je[C + 27 | 0], Qr = y << 24 >> 24 < 0, Wn = Qr ? e[C + 20 >> 2] : y, Ar = Wn >>> 0 < En >>> 0;
                                                  c: {
                                                    f: {
                                                      p: {
                                                        d: {
                                                          Q = Ar ? Wn : En;
                                                          g: {
                                                            if (Q) {
                                                              if (C = Qr ? e[C + 16 >> 2] : C + 16 | 0, y = Wf(Ri, C, Q), !y) {
                                                                if (En >>> 0 < Wn >>> 0)
                                                                  break g;
                                                                break d;
                                                              }
                                                              if ((y | 0) >= 0)
                                                                break d;
                                                              break g;
                                                            }
                                                            if (En >>> 0 >= Wn >>> 0)
                                                              break p;
                                                          }
                                                          if (Ur = S, C = e[S >> 2], C)
                                                            continue;
                                                          break h;
                                                        }
                                                        if (y = Wf(C, Ri, Q), y)
                                                          break f;
                                                      }
                                                      if (Ar)
                                                        break c;
                                                      ke = S;
                                                      break h;
                                                    }
                                                    if ((y | 0) < 0)
                                                      break c;
                                                    ke = S;
                                                    break h;
                                                  }
                                                  if (Ur = S + 4 | 0, C = e[S + 4 >> 2], !C)
                                                    break;
                                                }
                                              }
                                              Q = br, Ar = e[Q + 4 >> 2], C = Ar;
                                              h: {
                                                if (C) {
                                                  for (; ; )
                                                    if (y = C, C = e[C >> 2], !C)
                                                      break h;
                                                }
                                                for (; y = e[Q + 8 >> 2], C = e[y >> 2] != (Q | 0), Q = y, !!C; )
                                                  ;
                                              }
                                              if (!ke) {
                                                Q = br;
                                                h: {
                                                  if (Ar) {
                                                    for (; ; )
                                                      if (C = Ar, Ar = e[C >> 2], !Ar)
                                                        break h;
                                                  }
                                                  for (; C = e[Q + 8 >> 2], ke = e[C >> 2] != (Q | 0), Q = C, !!ke; )
                                                    ;
                                                }
                                                e[Xr >> 2] == (br | 0) && (e[Xr >> 2] = C), e[Xr + 8 >> 2] = e[Xr + 8 >> 2] - 1, Ar = e[Xr + 4 >> 2];
                                                h: {
                                                  c: {
                                                    if (Q = br, ke = e[Q >> 2], ke) {
                                                      if (C = e[Q + 4 >> 2], !C)
                                                        break c;
                                                      for (; Q = C, C = e[C >> 2], !!C; )
                                                        ;
                                                    }
                                                    if (ke = e[Q + 4 >> 2], ke)
                                                      break c;
                                                    ke = 0, Qr = 1;
                                                    break h;
                                                  }
                                                  e[ke + 8 >> 2] = e[Q + 8 >> 2], Qr = 0;
                                                }
                                                Ri = e[Q + 8 >> 2], C = e[Ri >> 2];
                                                h: {
                                                  if ((Q | 0) == (C | 0)) {
                                                    if (e[Ri >> 2] = ke, (Q | 0) == (Ar | 0)) {
                                                      C = 0, Ar = ke;
                                                      break h;
                                                    }
                                                    C = e[Ri + 4 >> 2];
                                                    break h;
                                                  }
                                                  e[Ri + 4 >> 2] = ke;
                                                }
                                                En = !Je[Q + 12 | 0], (Q | 0) != (br | 0) && (Ri = e[br + 8 >> 2], e[Q + 8 >> 2] = Ri, e[Ri + ((e[e[br + 8 >> 2] >> 2] != (br | 0)) << 2) >> 2] = Q, Ri = e[br >> 2], e[Q >> 2] = Ri, e[Ri + 8 >> 2] = Q, Ri = e[br + 4 >> 2], e[Q + 4 >> 2] = Ri, Ri && (e[Ri + 8 >> 2] = Q), Se[Q + 12 | 0] = Je[br + 12 | 0], Ar = (Ar | 0) == (br | 0) ? Q : Ar);
                                                h: {
                                                  if (En | !Ar)
                                                    break h;
                                                  if (!Qr) {
                                                    Se[ke + 12 | 0] = 1;
                                                    break h;
                                                  }
                                                  c: {
                                                    f: {
                                                      for (; ; ) {
                                                        p: {
                                                          Q = Je[C + 12 | 0], Qr = e[C + 8 >> 2];
                                                          d: {
                                                            if (e[Qr >> 2] != (C | 0)) {
                                                              Q || (Se[C + 12 | 0] = 1, Se[Qr + 12 | 0] = 0, ke = e[Qr + 4 >> 2], Q = e[ke >> 2], e[Qr + 4 >> 2] = Q, Q && (e[Q + 8 >> 2] = Qr), e[ke + 8 >> 2] = e[Qr + 8 >> 2], Q = e[Qr + 8 >> 2], e[(((Qr | 0) != e[Q >> 2]) << 2) + Q >> 2] = ke, e[ke >> 2] = Qr, e[Qr + 8 >> 2] = ke, Q = C, C = e[C >> 2], Ar = (C | 0) == (Ar | 0) ? Q : Ar, C = e[C + 4 >> 2]), Q = e[C >> 2];
                                                              g: {
                                                                if (!(!Je[Q + 12 | 0] && Q)) {
                                                                  if (ke = e[C + 4 >> 2], !(!ke | Je[ke + 12 | 0])) {
                                                                    Q = C;
                                                                    break g;
                                                                  }
                                                                  if (Se[C + 12 | 0] = 0, C = e[C + 8 >> 2], (Ar | 0) == (C | 0)) {
                                                                    Se[Ar + 12 | 0] = 1;
                                                                    break h;
                                                                  }
                                                                  if (Je[C + 12 | 0])
                                                                    break d;
                                                                  Se[C + 12 | 0] = 1;
                                                                  break h;
                                                                }
                                                                if (ke = e[C + 4 >> 2], !(!ke | Je[ke + 12 | 0])) {
                                                                  Q = C;
                                                                  break g;
                                                                }
                                                                Se[Q + 12 | 0] = 1, Se[C + 12 | 0] = 0, ke = e[Q + 4 >> 2], e[C >> 2] = ke, ke && (e[ke + 8 >> 2] = C), e[Q + 8 >> 2] = e[C + 8 >> 2], ke = e[C + 8 >> 2], e[((e[ke >> 2] != (C | 0)) << 2) + ke >> 2] = Q, e[Q + 4 >> 2] = C, e[C + 8 >> 2] = Q, ke = C;
                                                              }
                                                              Ar = e[Q + 8 >> 2], Se[Q + 12 | 0] = Je[Ar + 12 | 0], Se[Ar + 12 | 0] = 1, Se[ke + 12 | 0] = 1, Q = e[Ar + 4 >> 2], C = e[Q >> 2], e[Ar + 4 >> 2] = C, C && (e[C + 8 >> 2] = Ar), e[Q + 8 >> 2] = e[Ar + 8 >> 2], C = e[Ar + 8 >> 2], e[(((Ar | 0) != e[C >> 2]) << 2) + C >> 2] = Q, e[Q >> 2] = Ar, e[Ar + 8 >> 2] = Q;
                                                              break h;
                                                            }
                                                            if (Q || (Se[C + 12 | 0] = 1, Se[Qr + 12 | 0] = 0, Q = e[C + 4 >> 2], e[Qr >> 2] = Q, Q && (e[Q + 8 >> 2] = Qr), e[C + 8 >> 2] = e[Qr + 8 >> 2], Q = e[Qr + 8 >> 2], e[(((Qr | 0) != e[Q >> 2]) << 2) + Q >> 2] = C, e[C + 4 >> 2] = Qr, e[Qr + 8 >> 2] = C, Ar = (Ar | 0) == (Qr | 0) ? C : Ar, C = e[Qr >> 2]), ke = e[C >> 2], !(!ke | Je[ke + 12 | 0])) {
                                                              Q = C;
                                                              break c;
                                                            }
                                                            if (Q = e[C + 4 >> 2], !Je[Q + 12 | 0] && Q)
                                                              break f;
                                                            if (Se[C + 12 | 0] = 0, C = e[C + 8 >> 2], !Je[C + 12 | 0] | (C | 0) == (Ar | 0))
                                                              break p;
                                                          }
                                                          Q = C, C = e[C + 8 >> 2], C = e[(((Q | 0) == e[C >> 2]) << 2) + C >> 2];
                                                          continue;
                                                        }
                                                        break;
                                                      }
                                                      Se[C + 12 | 0] = 1;
                                                      break h;
                                                    }
                                                    if (!(Je[ke + 12 | 0] | !ke)) {
                                                      Q = C;
                                                      break c;
                                                    }
                                                    Se[Q + 12 | 0] = 1, Se[C + 12 | 0] = 0, ke = e[Q >> 2], e[C + 4 >> 2] = ke, ke && (e[ke + 8 >> 2] = C), e[Q + 8 >> 2] = e[C + 8 >> 2], ke = e[C + 8 >> 2], e[((e[ke >> 2] != (C | 0)) << 2) + ke >> 2] = Q, e[Q >> 2] = C, e[C + 8 >> 2] = Q, ke = C;
                                                  }
                                                  Ar = e[Q + 8 >> 2], Se[Q + 12 | 0] = Je[Ar + 12 | 0], Se[Ar + 12 | 0] = 1, Se[ke + 12 | 0] = 1, Q = e[Ar >> 2], C = e[Q + 4 >> 2], e[Ar >> 2] = C, C && (e[C + 8 >> 2] = Ar), e[Q + 8 >> 2] = e[Ar + 8 >> 2], C = e[Ar + 8 >> 2], e[(((Ar | 0) != e[C >> 2]) << 2) + C >> 2] = Q, e[Q + 4 >> 2] = Ar, e[Ar + 8 >> 2] = Q;
                                                }
                                                e[br + 8 >> 2] = S, e[br >> 2] = 0, e[br + 4 >> 2] = 0, e[Ur >> 2] = br, C = e[e[me + 36 >> 2] >> 2], C && (e[me + 36 >> 2] = C, br = e[Ur >> 2]), Pu(e[me + 40 >> 2], br), e[me + 44 >> 2] = e[me + 44 >> 2] + 1;
                                              }
                                              if (br = y, (y | 0) == (bs | 0))
                                                break;
                                            }
                                          if (e[me + 44 >> 2] != (Os | 0))
                                            break u;
                                          if (Xr = Xr + 12 | 0, (Xo | 0) == (Xr | 0))
                                            break;
                                        }
                                      e[me + 8 >> 2] = e[me + 36 >> 2], e[me + 16 >> 2] = Os, y = e[me + 40 >> 2], e[me + 12 >> 2] = y;
                                      h: {
                                        if (!Os) {
                                          e[me + 8 >> 2] = aa;
                                          break h;
                                        }
                                        e[y + 8 >> 2] = aa, e[me + 40 >> 2] = 0, e[me + 44 >> 2] = 0, e[me + 36 >> 2] = lo;
                                      }
                                      y = 1;
                                      break A;
                                    }
                                    Se[me + 8 | 0] = 0, y = 0;
                                  }
                                  if (Se[me + 20 | 0] = y, Kf(e[me + 40 >> 2]), Je[me + 20 | 0])
                                    break a;
                                }
                                Se[l + 12 | 0] = 0, Se[l | 0] = 0;
                                break r;
                              }
                              C = e[me + 28 >> 2], ke = e[Ro + 36 >> 2] - e[Ro + 32 >> 2] >> 3, Q = e[me + 24 >> 2], y = ((C + No(ke, -12) | 0) - Q | 0) / 12 | 0;
                              a: {
                                if (!No(ke, -12)) {
                                  S = C;
                                  break a;
                                }
                                if (Ar = Q + No(y, 12) | 0, S = Ar, y = S + No((No(ke, 12) | 0) / 12 | 0, 12) | 0, (C | 0) != (y | 0)) {
                                  for (; ; ) {
                                    Kf(e[S + 4 >> 2]), e[S >> 2] = e[y >> 2], ke = e[y + 4 >> 2], e[S + 4 >> 2] = ke, Q = e[y + 8 >> 2], e[S + 8 >> 2] = Q, br = S + 4 | 0;
                                    s: {
                                      if (!Q) {
                                        e[S >> 2] = br;
                                        break s;
                                      }
                                      e[ke + 8 >> 2] = br, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, e[y >> 2] = y + 4;
                                    }
                                    if (S = S + 12 | 0, y = y + 12 | 0, (C | 0) == (y | 0))
                                      break;
                                  }
                                  C = e[me + 28 >> 2];
                                }
                                if (S = Ar + No((S - Ar | 0) / 12 | 0, 12) | 0, (S | 0) != (C | 0))
                                  for (; C = C - 12 | 0, Kf(e[C + 4 >> 2]), (C | 0) != (S | 0); )
                                    ;
                                e[me + 28 >> 2] = S;
                              }
                              y = e[me + 32 >> 2];
                              a: {
                                if (y >>> 0 > S >>> 0) {
                                  e[S >> 2] = e[me + 8 >> 2], C = e[me + 12 >> 2], e[S + 4 >> 2] = C, y = e[me + 16 >> 2], e[S + 8 >> 2] = y, Q = S + 4 | 0;
                                  s: {
                                    if (!y) {
                                      e[S >> 2] = Q;
                                      break s;
                                    }
                                    e[C + 8 >> 2] = Q, e[me + 12 >> 2] = 0, e[me + 16 >> 2] = 0, e[me + 8 >> 2] = aa;
                                  }
                                  e[me + 28 >> 2] = S + 12;
                                  break a;
                                }
                                s: {
                                  A: {
                                    Qr = e[me + 24 >> 2], ke = (S - Qr | 0) / 12 | 0, Q = ke + 1 | 0;
                                    u: {
                                      if (Q >>> 0 >= 357913942) {
                                        e[5996] = 0, jo(96);
                                        break u;
                                      }
                                      if (C = (y - Qr | 0) / 12 | 0, y = C << 1, C = C >>> 0 >= 178956970 ? 357913941 : y >>> 0 > Q >>> 0 ? y : Q, !C) {
                                        Q = 0;
                                        break s;
                                      }
                                      if (C >>> 0 < 357913942)
                                        break A;
                                      e[5996] = 0, jo(35);
                                    }
                                    if (l = e[5996], e[5996] = 0, (l | 0) != 1)
                                      break e;
                                    break n;
                                  }
                                  if (e[5996] = 0, Q = no(3, No(C, 12) | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                    break n;
                                }
                                y = No(ke, 12) + Q | 0, e[y >> 2] = e[me + 8 >> 2], br = e[me + 12 >> 2], e[y + 4 >> 2] = br, ke = e[me + 16 >> 2], e[y + 8 >> 2] = ke, C = No(C, 12), Ar = y + 4 | 0;
                                s: {
                                  if (!ke) {
                                    e[y >> 2] = Ar;
                                    break s;
                                  }
                                  e[br + 8 >> 2] = Ar, e[me + 12 >> 2] = 0, e[me + 16 >> 2] = 0, e[me + 8 >> 2] = aa;
                                }
                                Ur = C + Q | 0, Ar = y + 12 | 0;
                                s: {
                                  if ((S | 0) == (Qr | 0)) {
                                    e[me + 32 >> 2] = Ur, e[me + 28 >> 2] = Ar, e[me + 24 >> 2] = y;
                                    break s;
                                  }
                                  for (; ; ) {
                                    y = y - 12 | 0, S = S - 12 | 0, e[y >> 2] = e[S >> 2], br = y + 4 | 0, ke = S + 4 | 0, Q = e[ke >> 2], e[br >> 2] = Q, C = e[S + 8 >> 2], e[y + 8 >> 2] = C;
                                    A: {
                                      if (!C) {
                                        e[y >> 2] = br;
                                        break A;
                                      }
                                      e[Q + 8 >> 2] = br, e[S >> 2] = ke, e[S + 4 >> 2] = 0, e[S + 8 >> 2] = 0;
                                    }
                                    if ((S | 0) == (Qr | 0))
                                      break;
                                  }
                                  if (e[me + 32 >> 2] = Ur, C = e[me + 28 >> 2], e[me + 28 >> 2] = Ar, S = e[me + 24 >> 2], e[me + 24 >> 2] = y, (C | 0) == (S | 0))
                                    break s;
                                  for (; C = C - 12 | 0, Kf(e[C + 4 >> 2]), (C | 0) != (S | 0); )
                                    ;
                                }
                                if (!S)
                                  break a;
                                Tr(S);
                              }
                              Je[me + 20 | 0] && Kf(e[me + 12 >> 2]), S = wf;
                            }
                            if ((S | 0) != (yn | 0))
                              continue;
                            break i;
                          }
                          break;
                        }
                        if (y = gi() | 0, !Je[me + 20 | 0])
                          break t;
                        Kf(e[me + 12 >> 2]);
                        break t;
                      }
                      if (Q = e[me + 24 >> 2], (e[me + 28 >> 2] - Q | 0) != 12) {
                        if (e[5996] = 0, ia(44, 4102, 2210, 450, 2439), l = e[5996], e[5996] = 0, (l | 0) != 1)
                          break e;
                        y = gi() | 0;
                        break t;
                      }
                      e[l >> 2] = e[Q >> 2], I = e[Q + 4 >> 2], e[l + 4 >> 2] = I, y = e[Q + 8 >> 2], e[l + 8 >> 2] = y, C = l + 4 | 0;
                      i: {
                        if (!y) {
                          e[l >> 2] = C;
                          break i;
                        }
                        e[I + 8 >> 2] = C, e[Q + 4 >> 2] = 0, e[Q + 8 >> 2] = 0, e[Q >> 2] = Q + 4;
                      }
                      Se[l + 12 | 0] = 1;
                    }
                    if (l = e[me + 24 >> 2], l) {
                      if (S = e[me + 28 >> 2], (l | 0) != (S | 0))
                        for (; S = S - 12 | 0, Kf(e[S + 4 >> 2]), (l | 0) != (S | 0); )
                          ;
                      Tr(l);
                    }
                    yn && Tr(yn), bi = me + 48 | 0;
                    return;
                  }
                  wd(me + 24 | 0), yn && Tr(yn), ss(y | 0), jn();
                }
                l = gi() | 0, wd(me + 24 | 0), ss(l | 0), jn();
              }
              jn();
            }
            function Eh(l, y, I) {
              var C = 0, Q = 0, S = 0, me = 0, ke = 0, Ar = 0, br = 0, Qr = 0, Ur = 0, Xr = 0, Ri = 0, yn = 0, En = 0, Wn = 0, lo = 0, Ro = 0, Xo = 0, bs = 0, Os = 0, Gs = 0, aa = 0;
              Q = bi - 144 | 0, bi = Q, C = jr(Q, 0, 144), e[C + 76 >> 2] = -1, e[C + 44 >> 2] = l, e[C + 32 >> 2] = 178, e[C + 84 >> 2] = l, Ro = I, l = 0, br = bi - 304 | 0, bi = br;
              e: {
                t: {
                  r: {
                    i: {
                      if (e[C + 4 >> 2] || (sd(C), e[C + 4 >> 2]))
                        break i;
                      break r;
                    }
                    if (ke = Je[y | 0], !ke)
                      break e;
                    i: {
                      n: {
                        o: {
                          a: {
                            for (; ; ) {
                              s: {
                                I = ke & 255;
                                A: {
                                  if ((I | 0) == 32 | I - 9 >>> 0 < 5) {
                                    for (; ke = y, y = y + 1 | 0, I = Je[ke + 1 | 0], !!((I | 0) == 32 | I - 9 >>> 0 < 5); )
                                      ;
                                    for (Mc(C, 0, 0); ; ) {
                                      y = e[C + 4 >> 2];
                                      u: {
                                        if ((y | 0) != e[C + 104 >> 2]) {
                                          e[C + 4 >> 2] = y + 1, y = Je[y | 0];
                                          break u;
                                        }
                                        y = Fa(C);
                                      }
                                      if (!((y | 0) == 32 | y - 9 >>> 0 < 5))
                                        break;
                                    }
                                    y = e[C + 4 >> 2], I = e[C + 116 >> 2], (I | 0) > 0 | (I | 0) >= 0 && (y = y - 1 | 0, e[C + 4 >> 2] = y), y = y - e[C + 44 >> 2] | 0, Q = y, Ar = yn + e[C + 124 >> 2] | 0, I = y >> 31, y = Xr + e[C + 120 >> 2] | 0, Ar = I + (y >>> 0 < Xr >>> 0 ? Ar + 1 | 0 : Ar) | 0, Xr = y + Q | 0, yn = Xr >>> 0 < y >>> 0 ? Ar + 1 | 0 : Ar;
                                    break A;
                                  }
                                  u: {
                                    h: {
                                      c: {
                                        if ((I | 0) == 37) {
                                          if (I = Je[y + 1 | 0], (I | 0) == 42)
                                            break c;
                                          if ((I | 0) != 37)
                                            break h;
                                        }
                                        Mc(C, 0, 0);
                                        f: {
                                          if (Je[y | 0] == 37) {
                                            for (; ; ) {
                                              I = e[C + 4 >> 2];
                                              p: {
                                                if ((I | 0) != e[C + 104 >> 2]) {
                                                  e[C + 4 >> 2] = I + 1, ke = Je[I | 0];
                                                  break p;
                                                }
                                                ke = Fa(C);
                                              }
                                              if (!((ke | 0) == 32 | ke - 9 >>> 0 < 5))
                                                break;
                                            }
                                            y = y + 1 | 0;
                                            break f;
                                          }
                                          if (I = e[C + 4 >> 2], (I | 0) != e[C + 104 >> 2]) {
                                            e[C + 4 >> 2] = I + 1, ke = Je[I | 0];
                                            break f;
                                          }
                                          ke = Fa(C);
                                        }
                                        if (Je[y | 0] != (ke | 0)) {
                                          if (y = e[C + 116 >> 2], (y | 0) > 0 | (y | 0) >= 0 && (e[C + 4 >> 2] = e[C + 4 >> 2] - 1), (ke | 0) >= 0 || (me = 0, Xo))
                                            break e;
                                          break r;
                                        }
                                        I = e[C + 4 >> 2] - e[C + 44 >> 2] | 0, ke = I, S = yn + e[C + 124 >> 2] | 0, Q = I >> 31, I = Xr + e[C + 120 >> 2] | 0, me = Q + (I >>> 0 < Xr >>> 0 ? S + 1 | 0 : S) | 0, Xr = I + ke | 0, yn = Xr >>> 0 < I >>> 0 ? me + 1 | 0 : me, ke = y;
                                        break A;
                                      }
                                      Ur = 0, y = y + 2 | 0;
                                      break u;
                                    }
                                    if (Q = I - 48 | 0, !(Je[y + 2 | 0] != 36 | Q >>> 0 >= 10)) {
                                      I = bi - 16 | 0, e[I + 12 >> 2] = Ro, S = I, I = (Q >>> 0 > 1 ? (Q << 2) - 4 | 0 : 0) + Ro | 0, e[S + 8 >> 2] = I + 4, Ur = e[I >> 2], y = y + 3 | 0;
                                      break u;
                                    }
                                    Ur = e[Ro >> 2], Ro = Ro + 4 | 0, y = y + 1 | 0;
                                  }
                                  for (I = 0; ; ) {
                                    if (S = Je[y | 0], S - 48 >>> 0 < 10) {
                                      y = y + 1 | 0, I = (No(I, 10) + S | 0) - 48 | 0;
                                      continue;
                                    }
                                    break;
                                  }
                                  lo = 0, (S | 0) == 109 && (En = 0, lo = (Ur | 0) != 0, S = Je[y + 1 | 0], y = y + 1 | 0, l = 0), ke = y + 1 | 0, Qr = 3, me = lo;
                                  u: {
                                    h:
                                      switch ((S & 255) - 65 | 0) {
                                        case 39:
                                          Q = y + 2 | 0, y = Je[y + 1 | 0] == 104, ke = y ? Q : ke, Qr = y ? -2 : -1;
                                          break u;
                                        case 43:
                                          Q = y + 2 | 0, y = Je[y + 1 | 0] == 108, ke = y ? Q : ke, Qr = y ? 3 : 1;
                                          break u;
                                        case 51:
                                        case 57:
                                          Qr = 1;
                                          break u;
                                        case 11:
                                          Qr = 2;
                                          break u;
                                        case 41:
                                          break u;
                                        case 0:
                                        case 2:
                                        case 4:
                                        case 5:
                                        case 6:
                                        case 18:
                                        case 23:
                                        case 26:
                                        case 32:
                                        case 34:
                                        case 35:
                                        case 36:
                                        case 37:
                                        case 38:
                                        case 40:
                                        case 45:
                                        case 46:
                                        case 47:
                                        case 50:
                                        case 52:
                                        case 55:
                                          break h;
                                        default:
                                          break i;
                                      }
                                    Qr = 0, ke = y;
                                  }
                                  Q = Je[ke | 0], y = (Q & 47) == 3, bs = y ? 1 : Qr, Wn = y ? Q | 32 : Q;
                                  u: {
                                    if ((Wn | 0) == 91)
                                      break u;
                                    h: {
                                      if ((Wn | 0) != 110) {
                                        if ((Wn | 0) != 99)
                                          break h;
                                        I = (I | 0) <= 1 ? 1 : I;
                                        break u;
                                      }
                                      gd(Ur, bs, Xr, yn);
                                      break A;
                                    }
                                    for (Mc(C, 0, 0); ; ) {
                                      y = e[C + 4 >> 2];
                                      h: {
                                        if ((y | 0) != e[C + 104 >> 2]) {
                                          e[C + 4 >> 2] = y + 1, y = Je[y | 0];
                                          break h;
                                        }
                                        y = Fa(C);
                                      }
                                      if (!((y | 0) == 32 | y - 9 >>> 0 < 5))
                                        break;
                                    }
                                    y = e[C + 4 >> 2], Q = e[C + 116 >> 2], (Q | 0) > 0 | (Q | 0) >= 0 && (y = y - 1 | 0, e[C + 4 >> 2] = y), y = y - e[C + 44 >> 2] | 0, S = y, Ar = yn + e[C + 124 >> 2] | 0, Q = y >> 31, y = Xr + e[C + 120 >> 2] | 0, yn = Q + (y >>> 0 < Xr >>> 0 ? Ar + 1 | 0 : Ar) | 0, Xr = y + S | 0, yn = Xr >>> 0 < y >>> 0 ? yn + 1 | 0 : yn;
                                  }
                                  Ar = I, Ri = I >> 31, Mc(C, I, Ri), y = e[C + 4 >> 2];
                                  u: {
                                    if ((y | 0) != e[C + 104 >> 2]) {
                                      e[C + 4 >> 2] = y + 1;
                                      break u;
                                    }
                                    if ((Fa(C) | 0) < 0)
                                      break n;
                                  }
                                  y = e[C + 116 >> 2], (y | 0) > 0 | (y | 0) >= 0 && (e[C + 4 >> 2] = e[C + 4 >> 2] - 1), y = 16;
                                  u: {
                                    h: {
                                      c: {
                                        f: {
                                          p:
                                            switch (Wn - 88 | 0) {
                                              default:
                                                if (y = Wn - 65 | 0, y >>> 0 > 6 | !(1 << y & 113))
                                                  break u;
                                              case 9:
                                              case 13:
                                              case 14:
                                              case 15:
                                                if (bh(br + 8 | 0, C, bs, 0), I = e[C + 4 >> 2] - e[C + 44 >> 2] | 0, e[C + 120 >> 2] != (0 - I | 0) | e[C + 124 >> 2] != (0 - ((I >> 31) + ((I | 0) != 0) | 0) | 0))
                                                  break c;
                                                break o;
                                              case 3:
                                              case 11:
                                              case 27:
                                                if ((Wn | 16) == 115) {
                                                  if (jr(br + 32 | 0, -1, 257), Se[br + 32 | 0] = 0, (Wn | 0) != 115)
                                                    break h;
                                                  Se[br + 65 | 0] = 0, Se[br + 46 | 0] = 0, ea[br + 42 >> 1] = 0, ea[br + 44 >> 1] = 0;
                                                  break h;
                                                }
                                                S = Je[ke + 1 | 0], Q = (S | 0) == 94, jr(br + 32 | 0, Q, 257), Se[br + 32 | 0] = 0, y = Q ? ke + 2 | 0 : ke + 1 | 0;
                                                d: {
                                                  g: {
                                                    v: {
                                                      if (Q = Je[(Q ? 2 : 1) + ke | 0], (Q | 0) != 45) {
                                                        if ((Q | 0) == 93)
                                                          break v;
                                                        Qr = (S | 0) != 94;
                                                        break d;
                                                      }
                                                      Qr = (S | 0) != 94, Se[br + 78 | 0] = Qr;
                                                      break g;
                                                    }
                                                    Qr = (S | 0) != 94, Se[br + 126 | 0] = Qr;
                                                  }
                                                  y = y + 1 | 0;
                                                }
                                                for (ke = y; ; ) {
                                                  S = Je[ke | 0];
                                                  d: {
                                                    if ((S | 0) != 45) {
                                                      if (!S)
                                                        break n;
                                                      if ((S | 0) == 93)
                                                        break h;
                                                      break d;
                                                    }
                                                    if (S = 45, me = Je[ke + 1 | 0], !me | (me | 0) == 93)
                                                      break d;
                                                    Q = ke + 1 | 0, y = Je[ke - 1 | 0];
                                                    g: {
                                                      if (me >>> 0 <= y >>> 0) {
                                                        S = me;
                                                        break g;
                                                      }
                                                      for (; y = y + 1 | 0, Se[y + (br + 32 | 0) | 0] = Qr, S = Je[Q | 0], S >>> 0 > y >>> 0; )
                                                        ;
                                                    }
                                                    ke = Q;
                                                  }
                                                  Se[(S + br | 0) + 33 | 0] = Qr, ke = ke + 1 | 0;
                                                }
                                              case 23:
                                                y = 8;
                                                break f;
                                              case 12:
                                              case 29:
                                                y = 10;
                                                break f;
                                              case 1:
                                              case 2:
                                              case 4:
                                              case 5:
                                              case 6:
                                              case 7:
                                              case 8:
                                              case 10:
                                              case 16:
                                              case 18:
                                              case 19:
                                              case 20:
                                              case 21:
                                              case 22:
                                              case 25:
                                              case 26:
                                              case 28:
                                              case 30:
                                              case 31:
                                                break u;
                                              case 0:
                                              case 24:
                                              case 32:
                                                break f;
                                              case 17:
                                                break p;
                                            }
                                          y = 0;
                                        }
                                        Q = 0, Ar = 0, S = 0, me = 0, Gs = 0, Os = bi - 16 | 0, bi = Os;
                                        f: {
                                          if ((y | 0) == 1) {
                                            e[5732] = 28;
                                            break f;
                                          }
                                          for (; ; ) {
                                            I = e[C + 4 >> 2];
                                            p: {
                                              if ((I | 0) != e[C + 104 >> 2]) {
                                                e[C + 4 >> 2] = I + 1, I = Je[I | 0];
                                                break p;
                                              }
                                              I = Fa(C);
                                            }
                                            if (!((I | 0) == 32 | I - 9 >>> 0 < 5))
                                              break;
                                          }
                                          p: {
                                            d:
                                              switch (I - 43 | 0) {
                                                case 0:
                                                case 2:
                                                  break d;
                                                default:
                                                  break p;
                                              }
                                            if (Gs = (I | 0) == 45 ? -1 : 0, I = e[C + 4 >> 2], (I | 0) != e[C + 104 >> 2]) {
                                              e[C + 4 >> 2] = I + 1, I = Je[I | 0];
                                              break p;
                                            }
                                            I = Fa(C);
                                          }
                                          p: {
                                            d: {
                                              g: {
                                                v: {
                                                  if (!((y | 0) != 0 & (y | 0) != 16 | (I | 0) != 48)) {
                                                    I = e[C + 4 >> 2];
                                                    _: {
                                                      if ((I | 0) != e[C + 104 >> 2]) {
                                                        e[C + 4 >> 2] = I + 1, I = Je[I | 0];
                                                        break _;
                                                      }
                                                      I = Fa(C);
                                                    }
                                                    if ((I & -33) == 88) {
                                                      y = 16, I = e[C + 4 >> 2];
                                                      _: {
                                                        if ((I | 0) != e[C + 104 >> 2]) {
                                                          e[C + 4 >> 2] = I + 1, I = Je[I | 0];
                                                          break _;
                                                        }
                                                        I = Fa(C);
                                                      }
                                                      if (Je[I + 8641 | 0] < 16)
                                                        break g;
                                                      y = e[C + 116 >> 2], (y | 0) > 0 | (y | 0) >= 0 && (e[C + 4 >> 2] = e[C + 4 >> 2] - 1), Mc(C, 0, 0);
                                                      break f;
                                                    }
                                                    if (y)
                                                      break v;
                                                    y = 8;
                                                    break g;
                                                  }
                                                  if (y = y || 10, y >>> 0 > Je[I + 8641 | 0])
                                                    break v;
                                                  y = e[C + 116 >> 2], (y | 0) > 0 | (y | 0) >= 0 && (e[C + 4 >> 2] = e[C + 4 >> 2] - 1), Mc(C, 0, 0), e[5732] = 28;
                                                  break f;
                                                }
                                                if ((y | 0) != 10)
                                                  break g;
                                                if (S = I - 48 | 0, S >>> 0 <= 9) {
                                                  for (I = 0; ; ) {
                                                    I = No(I, 10) + S | 0, me = I >>> 0 < 429496729, Q = e[C + 4 >> 2];
                                                    v: {
                                                      if ((Q | 0) != e[C + 104 >> 2]) {
                                                        e[C + 4 >> 2] = Q + 1, y = Je[Q | 0];
                                                        break v;
                                                      }
                                                      y = Fa(C);
                                                    }
                                                    if (S = y - 48 | 0, !(me & S >>> 0 <= 9))
                                                      break;
                                                  }
                                                  Q = I;
                                                }
                                                if (S >>> 0 > 9)
                                                  break p;
                                                for (y = Ua(Q, 0, 10, 0), me = Ci; ; ) {
                                                  Q = y + S | 0, Ar = Q >>> 0 < S >>> 0 ? me + 1 | 0 : me, y = (Ar | 0) == 429496729 & Q >>> 0 < 2576980378 | Ar >>> 0 < 429496729, I = e[C + 4 >> 2];
                                                  v: {
                                                    if ((I | 0) != e[C + 104 >> 2]) {
                                                      e[C + 4 >> 2] = I + 1, I = Je[I | 0];
                                                      break v;
                                                    }
                                                    I = Fa(C);
                                                  }
                                                  if (Qr = I - 48 | 0, !(y & Qr >>> 0 <= 9)) {
                                                    if (y = 10, Qr >>> 0 <= 9)
                                                      break d;
                                                    break p;
                                                  }
                                                  if (y = Ua(Q, Ar, 10, 0), me = Ci, S = Qr, !((me | 0) == -1 & (S ^ -1) >>> 0 >= y >>> 0 | (me | 0) != -1))
                                                    break;
                                                }
                                                y = 10;
                                                break d;
                                              }
                                              if (y - 1 & y) {
                                                if (me = Je[I + 8641 | 0], me >>> 0 < y >>> 0) {
                                                  for (; ; ) {
                                                    S = No(y, S) + me | 0, Q = S >>> 0 < 119304647, I = e[C + 4 >> 2];
                                                    g: {
                                                      if ((I | 0) != e[C + 104 >> 2]) {
                                                        e[C + 4 >> 2] = I + 1, I = Je[I | 0];
                                                        break g;
                                                      }
                                                      I = Fa(C);
                                                    }
                                                    if (me = Je[I + 8641 | 0], !(Q & me >>> 0 < y >>> 0))
                                                      break;
                                                  }
                                                  Q = S;
                                                }
                                                if (y >>> 0 <= me >>> 0)
                                                  break d;
                                                for (Ri = y; ; ) {
                                                  if (S = Ua(Q, Ar, Ri, 0), Qr = Ci, me = me & 255, (Qr | 0) == -1 & (me ^ -1) >>> 0 < S >>> 0)
                                                    break d;
                                                  Ar = Qr, Q = S + me | 0, Ar = Q >>> 0 < me >>> 0 ? Ar + 1 | 0 : Ar, I = e[C + 4 >> 2];
                                                  g: {
                                                    if ((I | 0) != e[C + 104 >> 2]) {
                                                      e[C + 4 >> 2] = I + 1, I = Je[I | 0];
                                                      break g;
                                                    }
                                                    I = Fa(C);
                                                  }
                                                  if (me = Je[I + 8641 | 0], y >>> 0 <= me >>> 0)
                                                    break d;
                                                  if (Ja(Os, Ri, 0, 0, 0, Q, Ar, 0, 0), !!(e[Os + 8 >> 2] | e[Os + 12 >> 2]))
                                                    break;
                                                }
                                                break d;
                                              }
                                              if (Qr = Se[(No(y, 23) >>> 5 & 7) + 8897 | 0], S = Je[I + 8641 | 0], S >>> 0 < y >>> 0) {
                                                for (; ; ) {
                                                  me = me << Qr | S, Q = me >>> 0 < 134217728, I = e[C + 4 >> 2];
                                                  g: {
                                                    if ((I | 0) != e[C + 104 >> 2]) {
                                                      e[C + 4 >> 2] = I + 1, I = Je[I | 0];
                                                      break g;
                                                    }
                                                    I = Fa(C);
                                                  }
                                                  if (S = Je[I + 8641 | 0], !(Q & S >>> 0 < y >>> 0))
                                                    break;
                                                }
                                                Q = me;
                                              }
                                              if (y >>> 0 <= S >>> 0 || (Ri = Qr & 31, (Qr & 63) >>> 0 >= 32 ? (me = 0, Ri = -1 >>> Ri | 0) : (me = -1 >>> Ri | 0, Ri = me | (1 << Ri) - 1 << 32 - Ri), !me & Q >>> 0 > Ri >>> 0))
                                                break d;
                                              for (; ; ) {
                                                aa = S & 255, I = Q, S = Qr & 31, (Qr & 63) >>> 0 >= 32 ? (Ar = I << S, I = 0) : (Ar = (1 << S) - 1 & I >>> 32 - S | Ar << S, I = I << S), Q = aa | I, I = e[C + 4 >> 2];
                                                g: {
                                                  if ((I | 0) != e[C + 104 >> 2]) {
                                                    e[C + 4 >> 2] = I + 1, I = Je[I | 0];
                                                    break g;
                                                  }
                                                  I = Fa(C);
                                                }
                                                if (S = Je[I + 8641 | 0], y >>> 0 <= S >>> 0)
                                                  break d;
                                                if (!((me | 0) == (Ar | 0) & Q >>> 0 <= Ri >>> 0 | me >>> 0 > Ar >>> 0))
                                                  break;
                                              }
                                            }
                                            if (Je[I + 8641 | 0] >= y >>> 0)
                                              break p;
                                            for (; ; ) {
                                              I = e[C + 4 >> 2];
                                              d: {
                                                if ((I | 0) != e[C + 104 >> 2]) {
                                                  e[C + 4 >> 2] = I + 1, I = Je[I | 0];
                                                  break d;
                                                }
                                                I = Fa(C);
                                              }
                                              if (!(Je[I + 8641 | 0] < y >>> 0))
                                                break;
                                            }
                                            e[5732] = 68, Q = -1, Ar = -1, Gs = 0;
                                          }
                                          y = e[C + 116 >> 2], (y | 0) > 0 | (y | 0) >= 0 && (e[C + 4 >> 2] = e[C + 4 >> 2] - 1), y = Gs, S = y ^ Q, Q = S - y | 0, I = y >> 31, Ar = (I ^ Ar) - ((y >>> 0 > S >>> 0) + I | 0) | 0;
                                        }
                                        if (bi = Os + 16 | 0, I = e[C + 4 >> 2] - e[C + 44 >> 2] | 0, e[C + 120 >> 2] == (0 - I | 0) & e[C + 124 >> 2] == (0 - ((I >> 31) + ((I | 0) != 0) | 0) | 0))
                                          break o;
                                        if (!(!Ur | (Wn | 0) != 112)) {
                                          e[Ur >> 2] = Q;
                                          break u;
                                        }
                                        gd(Ur, bs, Q, Ar);
                                        break u;
                                      }
                                      if (!Ur)
                                        break u;
                                      I = e[br + 16 >> 2], S = e[br + 20 >> 2], y = e[br + 8 >> 2], Q = e[br + 12 >> 2];
                                      c:
                                        switch (bs | 0) {
                                          case 0:
                                            df[Ur >> 2] = Lh(y, Q, I, S);
                                            break u;
                                          case 1:
                                            zo[Ur >> 3] = th(y, Q, I, S);
                                            break u;
                                          case 2:
                                            break c;
                                          default:
                                            break u;
                                        }
                                      e[Ur >> 2] = y, e[Ur + 4 >> 2] = Q, e[Ur + 8 >> 2] = I, e[Ur + 12 >> 2] = S;
                                      break u;
                                    }
                                    Qr = (Wn | 0) != 99, I = Qr ? 31 : I + 1 | 0;
                                    h: {
                                      if ((bs | 0) == 1) {
                                        if (S = Ur, lo && (S = vf(I << 2), !S))
                                          break a;
                                        for (e[br + 296 >> 2] = 0, e[br + 300 >> 2] = 0, y = 0; ; ) {
                                          l = S;
                                          c: {
                                            for (; ; ) {
                                              Q = e[C + 4 >> 2];
                                              f: {
                                                if ((Q | 0) != e[C + 104 >> 2]) {
                                                  e[C + 4 >> 2] = Q + 1, Q = Je[Q | 0];
                                                  break f;
                                                }
                                                Q = Fa(C);
                                              }
                                              if (!Je[(Q + br | 0) + 33 | 0])
                                                break c;
                                              if (Se[br + 27 | 0] = Q, Q = fo(br + 28 | 0, br + 27 | 0, 1, br + 296 | 0), (Q | 0) != -2) {
                                                if (En = 0, (Q | 0) == -1)
                                                  break n;
                                                if (l && (e[(y << 2) + l >> 2] = e[br + 28 >> 2], y = y + 1 | 0), !(!lo | (y | 0) != (I | 0)))
                                                  break;
                                              }
                                            }
                                            if (me = 1, y = I, I = y << 1 | 1, S = Xc(l, I << 2), S)
                                              continue;
                                            break i;
                                          }
                                          break;
                                        }
                                        if (En = 0, I = l, br + 296 | 0 && e[br + 296 >> 2])
                                          break n;
                                        break h;
                                      }
                                      if (lo) {
                                        if (y = 0, S = vf(I), !S)
                                          break a;
                                        for (; ; ) {
                                          for (l = S; ; ) {
                                            Q = e[C + 4 >> 2];
                                            c: {
                                              if ((Q | 0) != e[C + 104 >> 2]) {
                                                e[C + 4 >> 2] = Q + 1, Q = Je[Q | 0];
                                                break c;
                                              }
                                              Q = Fa(C);
                                            }
                                            if (!Je[(Q + br | 0) + 33 | 0]) {
                                              I = 0, En = l;
                                              break h;
                                            }
                                            if (Se[l + y | 0] = Q, y = y + 1 | 0, (I | 0) == (y | 0))
                                              break;
                                          }
                                          if (me = 1, y = I, I = y << 1 | 1, S = Xc(l, I), !S)
                                            break;
                                        }
                                        En = l, l = 0;
                                        break i;
                                      }
                                      if (y = 0, Ur)
                                        for (; ; ) {
                                          l = e[C + 4 >> 2];
                                          c: {
                                            if ((l | 0) != e[C + 104 >> 2]) {
                                              e[C + 4 >> 2] = l + 1, l = Je[l | 0];
                                              break c;
                                            }
                                            l = Fa(C);
                                          }
                                          if (Je[(l + br | 0) + 33 | 0]) {
                                            Se[y + Ur | 0] = l, y = y + 1 | 0;
                                            continue;
                                          } else {
                                            I = 0, l = Ur, En = l;
                                            break h;
                                          }
                                        }
                                      for (; ; ) {
                                        l = e[C + 4 >> 2];
                                        c: {
                                          if ((l | 0) != e[C + 104 >> 2]) {
                                            e[C + 4 >> 2] = l + 1, l = Je[l | 0];
                                            break c;
                                          }
                                          l = Fa(C);
                                        }
                                        if (!Je[(l + br | 0) + 33 | 0])
                                          break;
                                      }
                                      l = 0, En = 0, I = 0;
                                    }
                                    if (S = e[C + 4 >> 2], Q = e[C + 116 >> 2], (Q | 0) > 0 | (Q | 0) >= 0 && (S = S - 1 | 0, e[C + 4 >> 2] = S), Q = S - e[C + 44 >> 2] | 0, S = Q + e[C + 120 >> 2] | 0, me = e[C + 124 >> 2] + (Q >> 31) | 0, me = S >>> 0 < Q >>> 0 ? me + 1 | 0 : me, !(me | S) | !(Qr | (S | 0) == (Ar | 0) & (me | 0) == (Ri | 0)))
                                      break s;
                                    lo && (e[Ur >> 2] = l);
                                    h: {
                                      if ((Wn | 0) == 99)
                                        break h;
                                      if (I && (e[(y << 2) + I >> 2] = 0), !En) {
                                        En = 0;
                                        break h;
                                      }
                                      Se[y + En | 0] = 0;
                                    }
                                    l = I;
                                  }
                                  y = e[C + 4 >> 2] - e[C + 44 >> 2] | 0, Q = y, S = yn + e[C + 124 >> 2] | 0, I = y >> 31, y = Xr + e[C + 120 >> 2] | 0, Ar = I + (y >>> 0 < Xr >>> 0 ? S + 1 | 0 : S) | 0, Xr = y + Q | 0, yn = Xr >>> 0 < y >>> 0 ? Ar + 1 | 0 : Ar, Xo = ((Ur | 0) != 0) + Xo | 0;
                                }
                                if (y = ke + 1 | 0, ke = Je[ke + 1 | 0], ke)
                                  continue;
                                break e;
                              }
                              break;
                            }
                            l = I;
                            break o;
                          }
                          me = 1, En = 0, l = 0;
                          break i;
                        }
                        me = lo;
                        break t;
                      }
                      me = lo;
                    }
                    if (Xo)
                      break t;
                  }
                  Xo = -1;
                }
                if (!me)
                  break e;
                Tr(En), Tr(l);
              }
              return bi = br + 304 | 0, bi = C + 144 | 0, Xo;
            }
            function rl(l) {
              l = l | 0;
              var y = 0, I = 0, C = 0, Q = 0, S = 0, me = 0;
              C = bi - 320 | 0, bi = C;
              e: {
                t: {
                  r: {
                    i: {
                      n: {
                        o: {
                          a: {
                            s: {
                              A: {
                                u: {
                                  h: {
                                    c: {
                                      f: {
                                        p: {
                                          d: {
                                            g: {
                                              v: {
                                                _: {
                                                  R: {
                                                    k: {
                                                      S: {
                                                        E: {
                                                          w: {
                                                            if (!Je[24336]) {
                                                              if (e[C + 208 >> 2] = 0, e[C + 200 >> 2] = 0, e[C + 204 >> 2] = 0, e[5996] = 0, Ko(66, 24324, C + 200 | 0, 1) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                break w;
                                                              y = e[C + 200 >> 2], y && (e[C + 204 >> 2] = y, Tr(y)), Se[24336] = 1;
                                                            }
                                                            if (!Je[24352]) {
                                                              if (e[5996] = 0, y = C + 200 | 0, Ms(68, y | 0, 1598, 8), I = e[5996], e[5996] = 0, (I | 0) == 1 || (e[5996] = 0, y = Ko(69, C + 308 | 0, y | 0, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1))
                                                                break r;
                                                              if (e[5996] = 0, Ko(66, 24340, y | 0, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                                break E;
                                                              I = e[y >> 2], I && (e[y + 4 >> 2] = I, Tr(I)), Se[24352] = 1;
                                                            }
                                                            if (!Je[24368]) {
                                                              if (e[5996] = 0, y = C + 200 | 0, Ms(68, y | 0, 1194, 10), I = e[5996], e[5996] = 0, (I | 0) == 1 || (e[5996] = 0, y = Ko(69, C + 296 | 0, y | 0, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1))
                                                                break r;
                                                              if (e[5996] = 0, Ko(66, 24356, y | 0, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                                break S;
                                                              I = e[y >> 2], I && (e[y + 4 >> 2] = I, Tr(I)), Se[24368] = 1;
                                                            }
                                                            if (!Je[24384]) {
                                                              if (e[5996] = 0, y = C + 200 | 0, Ms(68, y | 0, 2432, 6), I = e[5996], e[5996] = 0, (I | 0) == 1 || (e[5996] = 0, y = Ko(69, C + 284 | 0, y | 0, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1))
                                                                break r;
                                                              if (e[5996] = 0, Ko(66, 24372, y | 0, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                                break k;
                                                              I = e[y >> 2], I && (e[y + 4 >> 2] = I, Tr(I)), Se[24384] = 1;
                                                            }
                                                            if (!Je[24400]) {
                                                              if (e[5996] = 0, y = C + 200 | 0, Ms(68, y | 0, 1492, 6), I = e[5996], e[5996] = 0, (I | 0) == 1 || (e[5996] = 0, y = Ko(69, C + 272 | 0, y | 0, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1))
                                                                break r;
                                                              if (e[5996] = 0, Ko(66, 24388, y | 0, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                                break R;
                                                              I = e[y >> 2], I && (e[y + 4 >> 2] = I, Tr(I)), Se[24400] = 1;
                                                            }
                                                            if (!Je[24416]) {
                                                              if (e[5996] = 0, y = C + 200 | 0, Ms(68, y | 0, 1152, 8), I = e[5996], e[5996] = 0, (I | 0) == 1 || (e[5996] = 0, y = Ko(69, C + 260 | 0, y | 0, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1))
                                                                break r;
                                                              if (e[5996] = 0, Ko(66, 24404, y | 0, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                                break _;
                                                              I = e[y >> 2], I && (e[y + 4 >> 2] = I, Tr(I)), Se[24416] = 1;
                                                            }
                                                            if (!Je[24432]) {
                                                              if (e[5996] = 0, y = C + 200 | 0, Ms(68, y | 0, 1526, 8), I = e[5996], e[5996] = 0, (I | 0) == 1 || (e[5996] = 0, y = Ko(69, C + 248 | 0, y | 0, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1))
                                                                break r;
                                                              if (e[5996] = 0, Ko(66, 24420, y | 0, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                                break v;
                                                              I = e[y >> 2], I && (e[y + 4 >> 2] = I, Tr(I)), Se[24432] = 1;
                                                            }
                                                            if (!Je[24448]) {
                                                              if (e[5996] = 0, y = C + 200 | 0, Ms(68, y | 0, 1628, 10), I = e[5996], e[5996] = 0, (I | 0) == 1 || (e[5996] = 0, y = Ko(69, C + 236 | 0, y | 0, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1))
                                                                break r;
                                                              if (e[5996] = 0, Ko(66, 24436, y | 0, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                                break g;
                                                              I = e[y >> 2], I && (e[y + 4 >> 2] = I, Tr(I)), Se[24448] = 1;
                                                            }
                                                            if (!Je[24464]) {
                                                              if (e[5996] = 0, y = C + 116 | 0, Ms(68, y | 0, 1435, 7), I = e[5996], e[5996] = 0, (I | 0) == 1 || (e[5996] = 0, Ms(68, C + 124 | 0, 1183, 10), I = e[5996], e[5996] = 0, (I | 0) == 1) || (e[5996] = 0, I = Ko(69, C + 200 | 0, y | 0, 2) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1))
                                                                break r;
                                                              if (e[5996] = 0, Q = C + 80 | 0, Ms(68, Q | 0, 1478, 7), S = e[5996], e[5996] = 0, y = I + 12 | 0, (S | 0) == 1 || (e[5996] = 0, Ms(68, C + 88 | 0, 1172, 10), S = e[5996], e[5996] = 0, (S | 0) == 1) || (e[5996] = 0, S = Ko(69, y | 0, Q | 0, 2) | 0, Q = e[5996], e[5996] = 0, (Q | 0) == 1) || (e[5996] = 0, Q = C + 56 | 0, Ms(68, Q | 0, 1435, 7), me = e[5996], e[5996] = 0, y = I + 24 | 0, (me | 0) == 1) || (e[5996] = 0, Ms(68, C - -64 | 0, 1161, 10), me = e[5996], e[5996] = 0, (me | 0) == 1) || (e[5996] = 0, me = Ko(69, y | 0, Q | 0, 2) | 0, Q = e[5996], e[5996] = 0, (Q | 0) == 1))
                                                                break p;
                                                              if (e[5996] = 0, Ko(66, 24452, I | 0, 3) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                break d;
                                                              y = e[me >> 2], y && (e[I + 28 >> 2] = y, Tr(y)), y = e[S >> 2], y && (e[I + 16 >> 2] = y, Tr(y)), y = e[I >> 2], y && (e[I + 4 >> 2] = y, Tr(y)), Se[24464] = 1;
                                                            }
                                                            if (!Je[24480]) {
                                                              if (e[5996] = 0, y = C + 116 | 0, Ms(68, y | 0, 1628, 10), I = e[5996], e[5996] = 0, (I | 0) == 1 || (e[5996] = 0, Ms(68, C + 124 | 0, 1617, 10), I = e[5996], e[5996] = 0, (I | 0) == 1) || (e[5996] = 0, y = Ko(69, C + 188 | 0, y | 0, 2) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1))
                                                                break r;
                                                              if (e[5996] = 0, Ko(66, 24468, y | 0, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                                break f;
                                                              I = e[y >> 2], I && (e[y + 4 >> 2] = I, Tr(I)), Se[24480] = 1;
                                                            }
                                                            if (!Je[24496]) {
                                                              if (e[5996] = 0, y = C + 116 | 0, Ms(68, y | 0, 1462, 8), I = e[5996], e[5996] = 0, (I | 0) == 1 || (e[5996] = 0, Ms(68, C + 124 | 0, 1453, 8), I = e[5996], e[5996] = 0, (I | 0) == 1) || (e[5996] = 0, y = Ko(69, C + 176 | 0, y | 0, 2) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1))
                                                                break r;
                                                              if (e[5996] = 0, Ko(66, 24484, y | 0, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                                break c;
                                                              I = e[y >> 2], I && (e[y + 4 >> 2] = I, Tr(I)), Se[24496] = 1;
                                                            }
                                                            if (!Je[24512]) {
                                                              if (e[5996] = 0, y = C + 116 | 0, Ms(68, y | 0, 1443, 9), I = e[5996], e[5996] = 0, (I | 0) == 1 || (e[5996] = 0, Ms(68, C + 124 | 0, 1587, 10), I = e[5996], e[5996] = 0, (I | 0) == 1) || (e[5996] = 0, y = Ko(69, C + 164 | 0, y | 0, 2) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1))
                                                                break r;
                                                              if (e[5996] = 0, Ko(66, 24500, y | 0, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                                break h;
                                                              I = e[y >> 2], I && (e[y + 4 >> 2] = I, Tr(I)), Se[24512] = 1;
                                                            }
                                                            if (!Je[24528]) {
                                                              if (e[5996] = 0, y = C + 116 | 0, Ms(68, y | 0, 1443, 9), I = e[5996], e[5996] = 0, (I | 0) == 1 || (e[5996] = 0, Ms(68, C + 124 | 0, 1471, 6), I = e[5996], e[5996] = 0, (I | 0) == 1) || (e[5996] = 0, y = Ko(69, C + 152 | 0, y | 0, 2) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1))
                                                                break r;
                                                              if (e[5996] = 0, Ko(66, 24516, y | 0, 1) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                                break u;
                                                              I = e[y >> 2], I && (e[y + 4 >> 2] = I, Tr(I)), Se[24528] = 1;
                                                            }
                                                            if (!Je[24544]) {
                                                              if (e[5996] = 0, y = C + 80 | 0, Ms(68, y | 0, 1535, 9), I = e[5996], e[5996] = 0, (I | 0) == 1 || (e[5996] = 0, Ms(68, C + 88 | 0, 1535, 9), I = e[5996], e[5996] = 0, (I | 0) == 1) || (e[5996] = 0, I = Ko(69, C + 116 | 0, y | 0, 2) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1))
                                                                break r;
                                                              if (e[5996] = 0, Q = C + 56 | 0, Ms(68, Q | 0, 1555, 9), S = e[5996], e[5996] = 0, y = I + 12 | 0, (S | 0) == 1 || (e[5996] = 0, Ms(68, C - -64 | 0, 1555, 9), S = e[5996], e[5996] = 0, (S | 0) == 1) || (e[5996] = 0, S = Ko(69, y | 0, Q | 0, 2) | 0, Q = e[5996], e[5996] = 0, (Q | 0) == 1) || (e[5996] = 0, Q = C + 32 | 0, Ms(68, Q | 0, 1545, 9), me = e[5996], e[5996] = 0, y = I + 24 | 0, (me | 0) == 1) || (e[5996] = 0, Ms(68, C + 40 | 0, 1545, 9), me = e[5996], e[5996] = 0, (me | 0) == 1) || (e[5996] = 0, me = Ko(69, y | 0, Q | 0, 2) | 0, Q = e[5996], e[5996] = 0, (Q | 0) == 1))
                                                                break s;
                                                              if (e[5996] = 0, Ko(66, 24532, I | 0, 3) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                break A;
                                                              y = e[me >> 2], y && (e[I + 28 >> 2] = y, Tr(y)), y = e[S >> 2], y && (e[I + 16 >> 2] = y, Tr(y)), y = e[I >> 2], y && (e[I + 4 >> 2] = y, Tr(y)), Se[24544] = 1;
                                                            }
                                                            if (!Je[24560]) {
                                                              if (e[5996] = 0, y = C + 56 | 0, Ms(68, y | 0, 1443, 9), I = e[5996], e[5996] = 0, (I | 0) == 1 || (e[5996] = 0, Ms(68, C - -64 | 0, 1517, 8), I = e[5996], e[5996] = 0, (I | 0) == 1) || (e[5996] = 0, Ms(68, C + 72 | 0, 1587, 10), I = e[5996], e[5996] = 0, (I | 0) == 1) || (e[5996] = 0, I = Ko(69, C + 80 | 0, y | 0, 3) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1))
                                                                break r;
                                                              if (e[5996] = 0, Q = C + 32 | 0, Ms(68, Q | 0, 1443, 9), S = e[5996], e[5996] = 0, y = I + 12 | 0, (S | 0) == 1 || (e[5996] = 0, Ms(68, C + 40 | 0, 1508, 8), S = e[5996], e[5996] = 0, (S | 0) == 1) || (e[5996] = 0, Ms(68, C + 48 | 0, 1576, 10), S = e[5996], e[5996] = 0, (S | 0) == 1) || (e[5996] = 0, S = Ko(69, y | 0, Q | 0, 3) | 0, Q = e[5996], e[5996] = 0, (Q | 0) == 1) || (e[5996] = 0, Q = C + 8 | 0, Ms(68, Q | 0, 1443, 9), me = e[5996], e[5996] = 0, y = I + 24 | 0, (me | 0) == 1) || (e[5996] = 0, Ms(68, C + 16 | 0, 1499, 8), me = e[5996], e[5996] = 0, (me | 0) == 1) || (e[5996] = 0, Ms(68, C + 24 | 0, 1565, 10), me = e[5996], e[5996] = 0, (me | 0) == 1) || (e[5996] = 0, me = Ko(69, y | 0, Q | 0, 3) | 0, Q = e[5996], e[5996] = 0, (Q | 0) == 1))
                                                                break o;
                                                              if (e[5996] = 0, Ko(66, 24548, I | 0, 3) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                break a;
                                                              y = e[me >> 2], y && (e[I + 28 >> 2] = y, Tr(y)), y = e[S >> 2], y && (e[I + 16 >> 2] = y, Tr(y)), y = e[I >> 2], y && (e[I + 4 >> 2] = y, Tr(y)), Se[24560] = 1;
                                                            }
                                                            if (!(50331647 >>> l & 1))
                                                              break n;
                                                            return bi = C + 320 | 0, e[(l << 2) + 6864 >> 2];
                                                          }
                                                          if (Q = gi() | 0, l = e[C + 200 >> 2], !l)
                                                            break i;
                                                          e[C + 204 >> 2] = l, Tr(l);
                                                          break i;
                                                        }
                                                        if (Q = gi() | 0, l = e[y >> 2], !l)
                                                          break i;
                                                        break t;
                                                      }
                                                      if (Q = gi() | 0, l = e[y >> 2], !l)
                                                        break i;
                                                      break t;
                                                    }
                                                    if (Q = gi() | 0, l = e[y >> 2], !l)
                                                      break i;
                                                    break t;
                                                  }
                                                  if (Q = gi() | 0, l = e[y >> 2], !l)
                                                    break i;
                                                  break t;
                                                }
                                                if (Q = gi() | 0, l = e[y >> 2], !l)
                                                  break i;
                                                break t;
                                              }
                                              if (Q = gi() | 0, l = e[y >> 2], !l)
                                                break i;
                                              break t;
                                            }
                                            if (Q = gi() | 0, l = e[y >> 2], !l)
                                              break i;
                                            break t;
                                          }
                                          if (Q = gi() | 0, l = e[me >> 2], l && (e[I + 28 >> 2] = l, Tr(l)), l = e[S >> 2], l && (e[I + 16 >> 2] = l, Tr(l)), l = e[I >> 2], !l)
                                            break i;
                                          break e;
                                        }
                                        for (Q = gi() | 0; l = y - 12 | 0, C = e[l >> 2], C && (e[y - 8 >> 2] = C, Tr(C)), y = l, (y | 0) != (I | 0); )
                                          ;
                                        break i;
                                      }
                                      if (Q = gi() | 0, l = e[y >> 2], !l)
                                        break i;
                                      break t;
                                    }
                                    if (Q = gi() | 0, l = e[y >> 2], !l)
                                      break i;
                                    break t;
                                  }
                                  if (Q = gi() | 0, l = e[y >> 2], !l)
                                    break i;
                                  break t;
                                }
                                if (Q = gi() | 0, l = e[y >> 2], !l)
                                  break i;
                                break t;
                              }
                              if (Q = gi() | 0, l = e[me >> 2], l && (e[I + 28 >> 2] = l, Tr(l)), l = e[S >> 2], l && (e[I + 16 >> 2] = l, Tr(l)), l = e[I >> 2], !l)
                                break i;
                              break e;
                            }
                            for (Q = gi() | 0; l = y - 12 | 0, C = e[l >> 2], C && (e[y - 8 >> 2] = C, Tr(C)), y = l, (y | 0) != (I | 0); )
                              ;
                            break i;
                          }
                          if (Q = gi() | 0, l = e[me >> 2], l && (e[I + 28 >> 2] = l, Tr(l)), l = e[S >> 2], l && (e[I + 16 >> 2] = l, Tr(l)), l = e[I >> 2], !l)
                            break i;
                          break e;
                        }
                        for (Q = gi() | 0; l = y - 12 | 0, C = e[l >> 2], C && (e[y - 8 >> 2] = C, Tr(C)), y = l, (y | 0) != (I | 0); )
                          ;
                        break i;
                      }
                      Nf(2350, 1900, 622, 1759), jn();
                    }
                    ss(Q | 0), jn();
                  }
                  ss(gi() | 0), jn();
                }
                e[y + 4 >> 2] = l, Tr(l), ss(Q | 0), jn();
              }
              e[I + 4 >> 2] = l, Tr(l), ss(Q | 0), jn();
            }
            function Eu(l, y, I, C, Q) {
              var S = 0, me = 0, ke = 0, Ar = 0, br = 0, Qr = 0, Ur = 0, Xr = 0, Ri = 0, yn = 0, En = 0, Wn = 0, lo = 0, Ro = 0, Xo = 0, bs = 0, Os = 0, Gs = 0;
              ke = bi - 144 | 0, bi = ke, bc(ke + 56 | 0, I, zo[l + 16 >> 3], zo[l + 24 >> 3], 0, 0), e[5996] = 0, S = no(46, I | 0) | 0, me = e[5996], e[5996] = 0;
              e: {
                t: {
                  r: {
                    if ((me | 0) != 1) {
                      if (e[ke + 52 >> 2] = 0, e[ke + 44 >> 2] = 0, e[ke + 48 >> 2] = 0, Se[ke + 128 | 0] = 0, e[ke + 124 >> 2] = ke + 44, me = e[S + 4 >> 2], br = e[S >> 2], Qr = me - br | 0, Ar = (Qr | 0) / 12 | 0, (me | 0) != (br | 0)) {
                        i: {
                          n: {
                            o: {
                              if (Ar >>> 0 >= 357913942) {
                                if (e[5996] = 0, jo(47), l = e[5996], e[5996] = 0, (l | 0) == 1)
                                  break o;
                                break e;
                              }
                              if (e[5996] = 0, me = no(3, Qr | 0) | 0, br = e[5996], e[5996] = 0, (br | 0) == 1)
                                break o;
                              if (e[ke + 48 >> 2] = me, e[ke + 44 >> 2] = me, e[ke + 52 >> 2] = me + No(Ar, 12), Ar = e[S + 4 >> 2], S = e[S >> 2], e[5996] = 0, S = mf(48, ke + 52 | 0, S | 0, Ar | 0, me | 0) | 0, Ar = e[5996], e[5996] = 0, (Ar | 0) != 1)
                                break i;
                              S = gi() | 0, e[ke + 48 >> 2] = me;
                              break n;
                            }
                            S = gi() | 0;
                          }
                          lh(ke + 124 | 0);
                          break r;
                        }
                        e[ke + 48 >> 2] = S;
                      }
                      e[ke + 40 >> 2] = 0, e[ke + 32 >> 2] = 0, e[ke + 36 >> 2] = 0, S = e[C + 4 >> 2], me = e[C >> 2], e[5996] = 0, Co(49, ke + 32 | 0, S - me >> 2), S = e[5996], e[5996] = 0;
                      i: {
                        if ((S | 0) != 1) {
                          if (S = e[ke + 48 >> 2], me = e[ke + 44 >> 2], (S | 0) == (me | 0))
                            break t;
                          S = me;
                          n: {
                            for (; ; ) {
                              o: {
                                if (e[ke + 28 >> 2] = 0, e[ke + 20 >> 2] = 0, e[ke + 24 >> 2] = 0, Ar = e[C + 4 >> 2], me = e[C >> 2], Ri = No(Ro, 12), S = Ri + S | 0, Ar - me >> 2 != e[S + 4 >> 2] - e[S >> 2] >> 3)
                                  break o;
                                br = 0, lo = 1, Qr = 0;
                                a: {
                                  if ((me | 0) != (Ar | 0)) {
                                    s: {
                                      A: {
                                        u: {
                                          for (; ; ) {
                                            if (S = Qr << 3, Os = zo[S + e[ke + 68 >> 2] >> 3], Gs = zo[S + e[ke + 56 >> 2] >> 3], me = e[(Qr << 2) + me >> 2], e[5996] = 0, me = Ic(50, me | 0, +Gs, +Os, y | 0) | 0, Ar = e[5996], e[5996] = 0, (Ar | 0) == 1)
                                              break A;
                                            if (S = S + e[Ri + e[ke + 44 >> 2] >> 2] | 0, Ar = e[S >> 2], S = e[S + 4 >> 2], Xr = e[me + 4 >> 2], me = e[me >> 2], e[5996] = 0, Xf(51, ke + 124 | 0, me | 0, Xr | 0, Ar | 0, S | 0), S = e[5996], e[5996] = 0, (S | 0) != 1) {
                                              Ar = e[ke + 28 >> 2];
                                              h: {
                                                if (Ar >>> 0 > br >>> 0) {
                                                  e[br + 8 >> 2] = 0, e[br >> 2] = 0, e[br + 4 >> 2] = 0, e[br >> 2] = e[ke + 124 >> 2], e[br + 4 >> 2] = e[ke + 128 >> 2], e[br + 8 >> 2] = e[ke + 132 >> 2], e[ke + 24 >> 2] = br + 12;
                                                  break h;
                                                }
                                                c: {
                                                  me = e[ke + 20 >> 2], Xr = (br - me | 0) / 12 | 0, S = Xr + 1 | 0;
                                                  f: {
                                                    if (S >>> 0 >= 357913942) {
                                                      e[5996] = 0, jo(52);
                                                      break f;
                                                    }
                                                    if (Ar = (Ar - me | 0) / 12 | 0, Ur = Ar << 1, S = Ar >>> 0 >= 178956970 ? 357913941 : S >>> 0 < Ur >>> 0 ? Ur : S, S >>> 0 < 357913942)
                                                      break c;
                                                    e[5996] = 0, jo(35);
                                                  }
                                                  if (l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                    break e;
                                                  break u;
                                                }
                                                if (e[5996] = 0, Ur = No(S, 12), Ar = no(3, Ur | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                  break u;
                                                S = Ar + No(Xr, 12) | 0, e[S >> 2] = e[ke + 124 >> 2], e[S + 4 >> 2] = e[ke + 128 >> 2], e[S + 8 >> 2] = e[ke + 132 >> 2], e[ke + 132 >> 2] = 0, e[ke + 124 >> 2] = 0, e[ke + 128 >> 2] = 0, Ar = Ar + Ur | 0, Xr = S + 12 | 0;
                                                c: {
                                                  if ((me | 0) == (br | 0)) {
                                                    e[ke + 28 >> 2] = Ar, e[ke + 24 >> 2] = Xr, e[ke + 20 >> 2] = S;
                                                    break c;
                                                  }
                                                  for (; S = S - 12 | 0, br = br - 12 | 0, e[S >> 2] = e[br >> 2], e[S + 4 >> 2] = e[br + 4 >> 2], e[S + 8 >> 2] = e[br + 8 >> 2], e[br + 8 >> 2] = 0, e[br >> 2] = 0, e[br + 4 >> 2] = 0, (me | 0) != (br | 0); )
                                                    ;
                                                  if (e[ke + 28 >> 2] = Ar, me = e[ke + 24 >> 2], e[ke + 24 >> 2] = Xr, br = e[ke + 20 >> 2], e[ke + 20 >> 2] = S, (me | 0) == (br | 0))
                                                    break c;
                                                  for (; ; ) {
                                                    if (Ur = me - 12 | 0, Xr = e[Ur >> 2], Xr) {
                                                      if (yn = me - 8 | 0, S = e[yn >> 2], Ar = Xr, (S | 0) != (Ar | 0)) {
                                                        for (; ; ) {
                                                          S = S - 32 | 0, me = e[S + 4 >> 2];
                                                          f: {
                                                            if (!me || (Ar = e[me + 4 >> 2], e[me + 4 >> 2] = Ar - 1, Ar))
                                                              break f;
                                                            Yn[e[e[me >> 2] + 8 >> 2]](me), Ls(me);
                                                          }
                                                          if ((S | 0) == (Xr | 0))
                                                            break;
                                                        }
                                                        Ar = e[Ur >> 2];
                                                      }
                                                      e[yn >> 2] = Xr, Tr(Ar);
                                                    }
                                                    if (me = Ur, (br | 0) == (me | 0))
                                                      break;
                                                  }
                                                }
                                                if (br && Tr(br), Ar = e[ke + 124 >> 2], !Ar)
                                                  break h;
                                                if (S = e[ke + 128 >> 2], me = Ar, (S | 0) != (me | 0)) {
                                                  for (; ; ) {
                                                    S = S - 32 | 0, me = e[S + 4 >> 2];
                                                    c: {
                                                      if (!me || (br = e[me + 4 >> 2], e[me + 4 >> 2] = br - 1, br))
                                                        break c;
                                                      Yn[e[e[me >> 2] + 8 >> 2]](me), Ls(me);
                                                    }
                                                    if ((S | 0) == (Ar | 0))
                                                      break;
                                                  }
                                                  me = e[ke + 124 >> 2];
                                                }
                                                e[ke + 128 >> 2] = Ar, Tr(me);
                                              }
                                              if (br = e[ke + 24 >> 2], S = br - 12 | 0, lo = No(e[S + 4 >> 2] - e[S >> 2] >> 5, lo), Qr = Qr + 1 | 0, me = e[C >> 2], Qr >>> 0 >= e[C + 4 >> 2] - me >> 2 >>> 0)
                                                break s;
                                              continue;
                                            }
                                            break;
                                          }
                                          S = gi() | 0;
                                          break n;
                                        }
                                        S = gi() | 0, Pc(ke + 124 | 0);
                                        break n;
                                      }
                                      S = gi() | 0;
                                      break n;
                                    }
                                    if (!lo)
                                      break a;
                                  }
                                  Xr = 0;
                                  s: {
                                    A: {
                                      u: {
                                        h: {
                                          for (; ; ) {
                                            if (br = e[ke + 32 >> 2], e[C + 4 >> 2] != e[C >> 2])
                                              for (S = 0, Ar = e[ke + 20 >> 2], me = Xr; Qr = No(S, 12), Ur = Qr + Ar | 0, Ar = e[Ur >> 2], e[(S << 2) + br >> 2] = Ar + ((me >>> 0) % (e[Ur + 4 >> 2] - Ar >> 5 >>> 0) << 5), Ur = me, Ar = e[ke + 20 >> 2], me = Qr + Ar | 0, me = (Ur >>> 0) / (e[me + 4 >> 2] - e[me >> 2] >> 5 >>> 0) | 0, S = S + 1 | 0, S >>> 0 < e[C + 4 >> 2] - e[C >> 2] >> 2 >>> 0; )
                                                ;
                                            if (e[ke + 108 >> 2] = 0, e[ke + 100 >> 2] = 0, e[ke + 104 >> 2] = 0, S = br, Ri = e[ke + 36 >> 2], (S | 0) != (Ri | 0)) {
                                              c: {
                                                for (; ; ) {
                                                  f: {
                                                    Qr = e[br >> 2], S = e[ke + 104 >> 2];
                                                    p: {
                                                      if ((S | 0) != e[ke + 108 >> 2]) {
                                                        e[S >> 2] = e[Qr >> 2], me = e[Qr + 4 >> 2], e[S + 4 >> 2] = me, me && (e[me + 4 >> 2] = e[me + 4 >> 2] + 1), e[ke + 104 >> 2] = S + 8;
                                                        break p;
                                                      }
                                                      d: {
                                                        Ar = e[ke + 100 >> 2], me = S - Ar | 0, yn = me >> 3, Ur = yn + 1 | 0;
                                                        g: {
                                                          if (Ur >>> 0 >= 536870912) {
                                                            e[5996] = 0, jo(59);
                                                            break g;
                                                          }
                                                          if (En = me >> 2, me = me >>> 0 >= 2147483640 ? 536870911 : Ur >>> 0 < En >>> 0 ? En : Ur, me >>> 0 < 536870912)
                                                            break d;
                                                          e[5996] = 0, jo(35);
                                                        }
                                                        if (l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                          break e;
                                                        S = gi() | 0;
                                                        break s;
                                                      }
                                                      if (e[5996] = 0, En = me << 3, Ur = no(3, En | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                        break f;
                                                      me = Ur + (yn << 3) | 0, e[me >> 2] = e[Qr >> 2], Qr = e[Qr + 4 >> 2], e[me + 4 >> 2] = Qr, Qr && (e[Qr + 4 >> 2] = e[Qr + 4 >> 2] + 1, S = e[ke + 104 >> 2]), Qr = Ur + En | 0, Ur = me + 8 | 0;
                                                      d: {
                                                        if ((S | 0) == (Ar | 0)) {
                                                          e[ke + 108 >> 2] = Qr, e[ke + 104 >> 2] = Ur, e[ke + 100 >> 2] = me;
                                                          break d;
                                                        }
                                                        for (; me = me - 8 | 0, S = S - 8 | 0, e[me >> 2] = e[S >> 2], e[me + 4 >> 2] = e[S + 4 >> 2], e[S >> 2] = 0, e[S + 4 >> 2] = 0, (S | 0) != (Ar | 0); )
                                                          ;
                                                        if (e[ke + 108 >> 2] = Qr, S = e[ke + 104 >> 2], e[ke + 104 >> 2] = Ur, Ar = e[ke + 100 >> 2], e[ke + 100 >> 2] = me, (S | 0) == (Ar | 0))
                                                          break d;
                                                        for (; ; ) {
                                                          S = S - 8 | 0, me = e[S + 4 >> 2];
                                                          g: {
                                                            if (!me || (Qr = e[me + 4 >> 2], e[me + 4 >> 2] = Qr - 1, Qr))
                                                              break g;
                                                            Yn[e[e[me >> 2] + 8 >> 2]](me), Ls(me);
                                                          }
                                                          if ((S | 0) == (Ar | 0))
                                                            break;
                                                        }
                                                      }
                                                      if (!Ar)
                                                        break p;
                                                      Tr(Ar);
                                                    }
                                                    if (br = br + 4 | 0, (Ri | 0) != (br | 0))
                                                      continue;
                                                    break c;
                                                  }
                                                  break;
                                                }
                                                S = gi() | 0;
                                                break s;
                                              }
                                              br = e[ke + 36 >> 2], S = e[ke + 32 >> 2];
                                            }
                                            if (e[5996] = 0, Gf(63, ke + 80 | 0, I | 0, S | 0, br | 0, 0), S = e[5996], e[5996] = 0, (S | 0) == 1 || (e[5996] = 0, br = no(3, 104) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1))
                                              break A;
                                            e[br >> 2] = 7e3, e[br + 4 >> 2] = 0, e[br + 8 >> 2] = 0, En = e[ke + 100 >> 2], e[ke + 112 >> 2] = En, Wn = e[ke + 104 >> 2], e[ke + 116 >> 2] = Wn, Ur = e[ke + 108 >> 2], S = 0, e[ke + 108 >> 2] = 0, e[ke + 120 >> 2] = Ur, e[ke + 100 >> 2] = 0, e[ke + 104 >> 2] = 0, me = e[Q >> 2], Ri = e[Q + 4 >> 2];
                                            c: {
                                              if ((me | 0) == (Ri | 0)) {
                                                Qr = 0, Ar = 0;
                                                break c;
                                              }
                                              if (yn = Ri - me | 0, (yn | 0) < 0) {
                                                if (e[5996] = 0, jo(8), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                  break e;
                                                S = gi() | 0;
                                                break u;
                                              }
                                              if (e[5996] = 0, Qr = no(3, yn | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                break h;
                                              if (Xo = Ri + (me ^ -1) | 0, Ar = 0, S = Qr, bs = yn & 7, bs)
                                                for (; Se[S | 0] = Je[me | 0], S = S + 1 | 0, me = me + 1 | 0, Ar = Ar + 1 | 0, (bs | 0) != (Ar | 0); )
                                                  ;
                                              if (Ar = Qr + yn | 0, Xo >>> 0 < 7)
                                                break c;
                                              for (; Se[S | 0] = Je[me | 0], Se[S + 1 | 0] = Je[me + 1 | 0], Se[S + 2 | 0] = Je[me + 2 | 0], Se[S + 3 | 0] = Je[me + 3 | 0], Se[S + 4 | 0] = Je[me + 4 | 0], Se[S + 5 | 0] = Je[me + 5 | 0], Se[S + 6 | 0] = Je[me + 6 | 0], Se[S + 7 | 0] = Je[me + 7 | 0], S = S + 8 | 0, me = me + 8 | 0, (Ri | 0) != (me | 0); )
                                                ;
                                              Ur = e[ke + 120 >> 2], Wn = e[ke + 116 >> 2], En = e[ke + 112 >> 2];
                                            }
                                            e[br + 12 >> 2] = I, e[br + 16 >> 2] = 0, e[br + 20 >> 2] = 0, e[br + 24 >> 2] = 0, e[br + 28 >> 2] = 0, e[br + 52 >> 2] = Ur, e[br + 48 >> 2] = Wn, yn = br + 44 | 0, e[yn >> 2] = En, e[br + 40 >> 2] = Ar, e[br + 36 >> 2] = S, e[br + 32 >> 2] = Qr, e[ke + 120 >> 2] = 0, e[ke + 112 >> 2] = 0, e[ke + 116 >> 2] = 0, e[5996] = 0, Ar = br + 12 | 0, Co(86, br + 56 | 0, Ar | 0), S = e[5996], e[5996] = 0;
                                            c: {
                                              if ((S | 0) == 1 || (e[5996] = 0, Co(87, br + 76 | 0, Ar | 0), S = e[5996], e[5996] = 0, (S | 0) == 1) || (e[5996] = 0, S = no(88, Ar | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1))
                                                break c;
                                              if (e[br + 92 >> 2] = S, me = 0, Ur = 0, Qr = e[br + 44 >> 2], S = Qr, Ri = e[br + 48 >> 2], (S | 0) != (Ri | 0)) {
                                                for (; me = e[e[S >> 2] + 84 >> 2] + me | 0, S = S + 8 | 0, (Ri | 0) != (S | 0); )
                                                  ;
                                                Ur = e[e[Qr >> 2] + 80 >> 2];
                                              }
                                              if (S = e[br + 16 >> 2], En = e[br + 12 >> 2], Wn = e[br + 20 >> 2], Xo = e[br + 24 >> 2], e[5996] = 0, S = Cf(89, En | 0, Ur | 0, me | 0, S | 0, Ri - Qr >> 3, (Xo - Wn | 0) / 12 | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1 || (e[br + 96 >> 2] = S, e[5996] = 0, e[ke + 140 >> 2] = Ar, Ms(90, ke + 124 | 0, Ar | 0, ke + 140 | 0), S = e[5996], e[5996] = 0, (S | 0) == 1))
                                                break c;
                                              if (S = Je[ke + 136 | 0], S && Kf(e[ke + 128 >> 2]), Se[br + 100 | 0] = S ^ 1, e[ke + 128 >> 2] = br, e[ke + 124 >> 2] = Ar, e[5996] = 0, S = e[ke + 128 >> 2], e[ke + 8 >> 2] = e[ke + 124 >> 2], e[ke + 12 >> 2] = S, Ms(61, l | 0, ke + 80 | 0, ke + 8 | 0), S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                break A;
                                              if (me = e[ke + 100 >> 2], me) {
                                                if (S = e[ke + 104 >> 2], (me | 0) != (S | 0)) {
                                                  for (; ; ) {
                                                    S = S - 8 | 0, Ar = e[S + 4 >> 2];
                                                    f: {
                                                      if (!Ar || (br = e[Ar + 4 >> 2], e[Ar + 4 >> 2] = br - 1, br))
                                                        break f;
                                                      Yn[e[e[Ar >> 2] + 8 >> 2]](Ar), Ls(Ar);
                                                    }
                                                    if ((S | 0) == (me | 0))
                                                      break;
                                                  }
                                                  me = e[ke + 100 >> 2];
                                                }
                                                Tr(me);
                                              }
                                              if (Xr = Xr + 1 | 0, (lo | 0) != (Xr | 0))
                                                continue;
                                              break a;
                                            }
                                            break;
                                          }
                                          S = gi() | 0, Za(yn), l = e[br + 32 >> 2], l && (e[br + 36 >> 2] = l, Tr(l)), hf(br + 20 | 0);
                                          break u;
                                        }
                                        S = gi() | 0;
                                      }
                                      Za(ke + 112 | 0), Tr(br);
                                      break s;
                                    }
                                    S = gi() | 0;
                                  }
                                  Za(ke + 100 | 0);
                                  break n;
                                }
                                if (Ar = e[ke + 20 >> 2], Ar) {
                                  if (S = e[ke + 24 >> 2], (Ar | 0) != (S | 0)) {
                                    for (; ; ) {
                                      if (Qr = S - 12 | 0, br = e[Qr >> 2], br) {
                                        if (Xr = S - 8 | 0, S = e[Xr >> 2], me = br, (S | 0) != (me | 0)) {
                                          for (; ; ) {
                                            S = S - 32 | 0, me = e[S + 4 >> 2];
                                            a: {
                                              if (!me || (Ur = e[me + 4 >> 2], e[me + 4 >> 2] = Ur - 1, Ur))
                                                break a;
                                              Yn[e[e[me >> 2] + 8 >> 2]](me), Ls(me);
                                            }
                                            if ((S | 0) == (br | 0))
                                              break;
                                          }
                                          me = e[Qr >> 2];
                                        }
                                        e[Xr >> 2] = br, Tr(me);
                                      }
                                      if (S = Qr, (Ar | 0) == (S | 0))
                                        break;
                                    }
                                    Ar = e[ke + 20 >> 2];
                                  }
                                  Tr(Ar);
                                }
                                if (Ro = Ro + 1 | 0, S = e[ke + 44 >> 2], Ro >>> 0 < (e[ke + 48 >> 2] - S | 0) / 12 >>> 0)
                                  continue;
                                break t;
                              }
                              break;
                            }
                            if (e[5996] = 0, ia(44, 5170, 1900, 642, 2497), l = e[5996], e[5996] = 0, (l | 0) != 1)
                              break e;
                            S = gi() | 0;
                          }
                          qc(ke + 20 | 0);
                          break i;
                        }
                        S = gi() | 0;
                      }
                      l = e[ke + 32 >> 2], l && Tr(l), Hh(ke + 44 | 0);
                      break r;
                    }
                    S = gi() | 0;
                  }
                  ph(ke + 56 | 0), ss(S | 0), jn();
                }
                if (l = e[ke + 32 >> 2], l && (Tr(l), S = e[ke + 44 >> 2]), S) {
                  if (me = S, Ar = e[ke + 48 >> 2], (Ar | 0) != (S | 0)) {
                    for (; l = Ar - 12 | 0, y = e[l >> 2], y && (e[Ar - 8 >> 2] = y, Tr(y)), Ar = l, (Ar | 0) != (S | 0); )
                      ;
                    me = e[ke + 44 >> 2];
                  }
                  e[ke + 48 >> 2] = S, Tr(me);
                }
                l = e[ke + 68 >> 2], l && (e[ke + 72 >> 2] = l, Tr(l)), l = e[ke + 56 >> 2], l && (e[ke + 60 >> 2] = l, Tr(l)), bi = ke + 144 | 0;
                return;
              }
              jn();
            }
            function il(l, y, I, C, Q, S, me, ke, Ar) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0, me = me | 0, ke = ke | 0, Ar = Ar | 0;
              var br = 0, Qr = 0, Ur = 0, Xr = 0, Ri = 0, yn = 0, En = 0, Wn = 0, lo = 0, Ro = 0;
              br = bi - 208 | 0, bi = br;
              e: {
                t: {
                  r: {
                    i: {
                      n: {
                        o: {
                          a: {
                            s: {
                              A: {
                                u: {
                                  h: {
                                    c: {
                                      f: {
                                        p: {
                                          d: {
                                            g: {
                                              v: {
                                                _: {
                                                  R: {
                                                    k: {
                                                      S: {
                                                        E: {
                                                          w: {
                                                            I: {
                                                              l: {
                                                                T: {
                                                                  if (Qr = Jf(l), Qr >>> 0 >= 2147483632) {
                                                                    if (e[5996] = 0, jo(2), l = e[5996], e[5996] = 0, (l | 0) == 1)
                                                                      break T;
                                                                    break e;
                                                                  }
                                                                  m: {
                                                                    if (Qr >>> 0 <= 10) {
                                                                      Se[br + 171 | 0] = Qr, Ri = br + 160 | 0;
                                                                      break m;
                                                                    }
                                                                    if (e[5996] = 0, Xr = (Qr | 15) + 1 | 0, Ri = no(3, Xr | 0) | 0, Ur = e[5996], e[5996] = 0, (Ur | 0) == 1)
                                                                      break T;
                                                                    e[br + 160 >> 2] = Ri, e[br + 164 >> 2] = Qr, e[br + 168 >> 2] = Xr | -2147483648;
                                                                  }
                                                                  Se[Sa(Ri, l, Qr) + Qr | 0] = 0, Ur = e[br + 160 >> 2], l = Je[br + 171 | 0], En = l << 24 >> 24, Qr = (En | 0) < 0, yn = Qr ? Ur : br + 160 | 0, lo = Qr ? e[br + 164 >> 2] : l, Qr = yn + lo | 0, Ri = -1;
                                                                  m: {
                                                                    for (; ; ) {
                                                                      if ((Qr | 0) == (yn | 0))
                                                                        break m;
                                                                      if (Qr = Qr - 1 | 0, Xr = Je[Qr | 0], Ro = Xr >>> 0 <= 63, l = Xr & 31, (Xr & 63) >>> 0 >= 32 ? (Xr = 1 << l, l = 0) : (Wn = 1 << l, Xr = Wn - 1 & 1 >>> 32 - l, l = Wn), l = l & 9728, !(Ro & (Xr & 1 | (l | 0) != 0)))
                                                                        break;
                                                                    }
                                                                    Ri = Qr - yn | 0;
                                                                  }
                                                                  if (l = Ri + 1 | 0, l >>> 0 > lo >>> 0) {
                                                                    if (e[5996] = 0, jo(108), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                                      break e;
                                                                    Qr = Ws(22864) | 0, l = Ia;
                                                                    break c;
                                                                  }
                                                                  m: {
                                                                    if ((En | 0) < 0) {
                                                                      e[br + 164 >> 2] = l;
                                                                      break m;
                                                                    }
                                                                    Se[br + 171 | 0] = l, Ur = br + 160 | 0;
                                                                  }
                                                                  Se[l + Ur | 0] = 0, e[br + 152 >> 2] = 0, e[br + 156 >> 2] = 0;
                                                                  m: {
                                                                    if (Se[br + 171 | 0] >= 0) {
                                                                      e[br + 144 >> 2] = e[br + 168 >> 2], l = e[br + 164 >> 2], e[br + 136 >> 2] = e[br + 160 >> 2], e[br + 140 >> 2] = l;
                                                                      break m;
                                                                    }
                                                                    if (e[5996] = 0, Ms(40, br + 136 | 0, e[br + 160 >> 2], e[br + 164 >> 2]), l = e[5996], e[5996] = 0, (l | 0) == 1)
                                                                      break l;
                                                                  }
                                                                  if (e[5996] = 0, l = br + 172 | 0, Co(109, l | 0, br + 136 | 0), Qr = e[5996], e[5996] = 0, (Qr | 0) == 1)
                                                                    break I;
                                                                  if (Xr = l, l = Se[br + 183 | 0], Qr = (l | 0) < 0, e[br + 104 >> 2] = Qr ? e[br + 172 >> 2] : Xr, e[br + 108 >> 2] = Qr ? e[br + 176 >> 2] : l & 255, e[5996] = 0, l = e[br + 108 >> 2], e[br + 8 >> 2] = e[br + 104 >> 2], e[br + 12 >> 2] = l, Co(140, br + 16 | 0, br + 8 | 0), l = e[5996], e[5996] = 0, (l | 0) == 1)
                                                                    break w;
                                                                  l = e[br + 20 >> 2], e[br + 156 >> 2] = l, Qr = e[br + 16 >> 2], e[br + 152 >> 2] = Qr, Se[br + 183 | 0] < 0 && Tr(e[br + 172 >> 2]), Se[br + 147 | 0] < 0 && Tr(e[br + 136 >> 2]);
                                                                  m: {
                                                                    if (!Qr || (Ri = e[Qr + 80 >> 2], !Ri | qs[Qr + 84 >> 2] > 3600))
                                                                      break m;
                                                                    if (e[5996] = 0, Xr = wn(54, 3557, 1) | 0, Ur = e[5996], e[5996] = 0, (Ur | 0) == 1)
                                                                      break S;
                                                                    if (!((Ri ^ -1) & Xr))
                                                                      break _;
                                                                  }
                                                                  if (e[5996] = 0, S = no(3, 32) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                                    break k;
                                                                  if (Se[S + 16 | 0] = 0, me = Je[2571] | Je[2572] << 8 | (Je[2573] << 16 | Je[2574] << 24), ke = Je[2567] | Je[2568] << 8 | (Je[2569] << 16 | Je[2570] << 24), Se[S + 8 | 0] = ke, Se[S + 9 | 0] = ke >>> 8, Se[S + 10 | 0] = ke >>> 16, Se[S + 11 | 0] = ke >>> 24, Se[S + 12 | 0] = me, Se[S + 13 | 0] = me >>> 8, Se[S + 14 | 0] = me >>> 16, Se[S + 15 | 0] = me >>> 24, me = Je[2563] | Je[2564] << 8 | (Je[2565] << 16 | Je[2566] << 24), ke = Je[2559] | Je[2560] << 8 | (Je[2561] << 16 | Je[2562] << 24), Se[S | 0] = ke, Se[S + 1 | 0] = ke >>> 8, Se[S + 2 | 0] = ke >>> 16, Se[S + 3 | 0] = ke >>> 24, Se[S + 4 | 0] = me, Se[S + 5 | 0] = me >>> 8, Se[S + 6 | 0] = me >>> 16, Se[S + 7 | 0] = me >>> 24, me = ((I | 0) >= 17 ? 17 : I) - 1 | 0, Se[Sa(y, S, me) + me | 0] = 0, Tr(S), e[5996] = 0, S = no(3, 32) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                                    break R;
                                                                  Se[S + 16 | 0] = 0, I = Je[2571] | Je[2572] << 8 | (Je[2573] << 16 | Je[2574] << 24), y = S, S = Je[2567] | Je[2568] << 8 | (Je[2569] << 16 | Je[2570] << 24), Se[y + 8 | 0] = S, Se[y + 9 | 0] = S >>> 8, Se[y + 10 | 0] = S >>> 16, Se[y + 11 | 0] = S >>> 24, Se[y + 12 | 0] = I, Se[y + 13 | 0] = I >>> 8, Se[y + 14 | 0] = I >>> 16, Se[y + 15 | 0] = I >>> 24, I = Je[2563] | Je[2564] << 8 | (Je[2565] << 16 | Je[2566] << 24), S = Je[2559] | Je[2560] << 8 | (Je[2561] << 16 | Je[2562] << 24), Se[y | 0] = S, Se[y + 1 | 0] = S >>> 8, Se[y + 2 | 0] = S >>> 16, Se[y + 3 | 0] = S >>> 24, Se[y + 4 | 0] = I, Se[y + 5 | 0] = I >>> 8, Se[y + 6 | 0] = I >>> 16, Se[y + 7 | 0] = I >>> 24, I = ((Q | 0) >= 17 ? 17 : Q) - 1 | 0, Se[Sa(C, y, I) + I | 0] = 0, Tr(y);
                                                                  break v;
                                                                }
                                                                Qr = Ws(22864) | 0, l = Ia;
                                                                break h;
                                                              }
                                                              Qr = Ws(22864) | 0, l = Ia;
                                                              break f;
                                                            }
                                                            Qr = Ws(22864) | 0, l = Ia;
                                                            break E;
                                                          }
                                                          if (Qr = Ws(22864) | 0, l = Ia, Se[br + 183 | 0] >= 0)
                                                            break E;
                                                          Tr(e[br + 172 >> 2]);
                                                        }
                                                        if (Se[br + 147 | 0] >= 0)
                                                          break f;
                                                        Tr(e[br + 136 >> 2]);
                                                        break f;
                                                      }
                                                      Qr = Ws(22864) | 0, l = Ia;
                                                      break f;
                                                    }
                                                    Qr = Ws(22864) | 0, l = Ia;
                                                    break f;
                                                  }
                                                  Qr = Ws(22864) | 0, l = Ia;
                                                  break f;
                                                }
                                                l = e[Qr + 84 >> 2], e[5996] = 0, Ri = br + 60 | 0, Co(115, Ri | 0, l | 0), l = e[5996], e[5996] = 0;
                                                _: {
                                                  R: {
                                                    k: {
                                                      S: {
                                                        E: {
                                                          w: {
                                                            I: {
                                                              l: {
                                                                T: {
                                                                  m: {
                                                                    C: {
                                                                      D: {
                                                                        b: {
                                                                          if ((l | 0) != 1) {
                                                                            if (e[5996] = 0, l = Ko(99, Ri | 0, 0, 5546) | 0, Ri = e[5996], e[5996] = 0, (Ri | 0) == 1)
                                                                              break b;
                                                                            if (e[br + 80 >> 2] = e[l + 8 >> 2], Ri = e[l + 4 >> 2], e[br + 72 >> 2] = e[l >> 2], e[br + 76 >> 2] = Ri, e[l >> 2] = 0, e[l + 4 >> 2] = 0, e[l + 8 >> 2] = 0, e[5996] = 0, Ri = wn(97, br + 72 | 0, 3581) | 0, Xr = e[5996], e[5996] = 0, (Xr | 0) == 1)
                                                                              break D;
                                                                            if (e[br + 96 >> 2] = e[Ri + 8 >> 2], Xr = e[Ri + 4 >> 2], e[br + 88 >> 2] = e[Ri >> 2], e[br + 92 >> 2] = Xr, e[Ri >> 2] = 0, e[Ri + 4 >> 2] = 0, e[Ri + 8 >> 2] = 0, e[5996] = 0, Xr = br + 172 | 0, Co(141, Xr | 0, br + 152 | 0), Ur = e[5996], e[5996] = 0, (Ur | 0) == 1)
                                                                              break C;
                                                                            if (e[5996] = 0, Wn = Xr, Xr = Je[br + 183 | 0], Ur = Xr << 24 >> 24 < 0, Xr = Ko(100, br + 88 | 0, (Ur ? e[br + 172 >> 2] : Wn) | 0, (Ur ? e[br + 176 >> 2] : Xr) | 0) | 0, Ur = e[5996], e[5996] = 0, (Ur | 0) == 1)
                                                                              break m;
                                                                            if (e[br + 112 >> 2] = e[Xr + 8 >> 2], Ur = e[Xr + 4 >> 2], e[br + 104 >> 2] = e[Xr >> 2], e[br + 108 >> 2] = Ur, e[Xr >> 2] = 0, e[Xr + 4 >> 2] = 0, e[Xr + 8 >> 2] = 0, e[5996] = 0, Ur = wn(97, br + 104 | 0, 3570) | 0, yn = e[5996], e[5996] = 0, (yn | 0) == 1)
                                                                              break T;
                                                                            if (e[br + 128 >> 2] = e[Ur + 8 >> 2], yn = e[Ur + 4 >> 2], e[br + 120 >> 2] = e[Ur >> 2], e[br + 124 >> 2] = yn, e[Ur >> 2] = 0, e[Ur + 4 >> 2] = 0, e[Ur + 8 >> 2] = 0, Se[br + 183 | 0] < 0 && Tr(e[br + 172 >> 2]), Se[Xr + 11 | 0] < 0 && Tr(e[Xr >> 2]), Se[Ri + 11 | 0] < 0 && Tr(e[Ri >> 2]), Se[l + 11 | 0] < 0 && Tr(e[l >> 2]), Ri = e[br + 120 >> 2], l = Je[br + 131 | 0], Xr = l << 24 >> 24, Ur = (Xr | 0) < 0, Wn = Ur ? Ri : br + 120 | 0, l = Ur ? e[br + 124 >> 2] : l, Ur = I - 1 | 0, l = (l | 0) < (Ur | 0) ? l : Ur, Se[Sa(y, Wn, l) + l | 0] = 0, e[5996] = 0, Ur = br + 172 | 0, Co(117, Ur | 0, Qr | 0), l = e[5996], e[5996] = 0, (l | 0) == 1)
                                                                              break S;
                                                                            if (e[br + 44 >> 2] = e[br + 200 >> 2], l = e[br + 196 >> 2], e[br + 36 >> 2] = e[br + 192 >> 2], e[br + 40 >> 2] = l, l = e[br + 188 >> 2], e[br + 28 >> 2] = e[br + 184 >> 2], e[br + 32 >> 2] = l, l = e[br + 180 >> 2], e[br + 20 >> 2] = e[br + 176 >> 2], e[br + 24 >> 2] = l, l = e[br + 172 >> 2], e[br + 16 >> 2] = l, e[5996] = 0, yn = l >>> 0 < 29, En = yn ? br + 20 | 0 : e[br + 24 >> 2], e[br + 172 >> 2] = En, lo = br + 48 | 0, ia(102, lo | 0, Ur | 0, En + (yn ? l : l - 29 | 0) | 0, 0), l = e[5996], e[5996] = 0, (l | 0) == 1)
                                                                              break k;
                                                                            if (l = e[br + 48 >> 2], Ur = Je[br + 59 | 0], yn = Ur << 24 >> 24, En = (yn | 0) < 0, Wn = En ? l : lo, Ur = En ? e[br + 52 >> 2] : Ur, En = Q - 1 | 0, Ur = (Ur | 0) < (En | 0) ? Ur : En, Se[Sa(C, Wn, Ur) + Ur | 0] = 0, (yn | 0) < 0 && Tr(l), qs[br + 16 >> 2] >= 29 && (Tr(e[br + 24 >> 2]), Qr = e[br + 152 >> 2]), l = e[Qr + 80 >> 2], !l | qs[Qr + 84 >> 2] > 3600 | (e[Qr + 52 >> 2] + e[Qr + 44 >> 2] >>> 0 > 201 | qs[Qr + 68 >> 2] > 100))
                                                                              break R;
                                                                            if (e[5996] = 0, Ur = wn(54, 2049, 1) | 0, yn = e[5996], e[5996] = 0, (yn | 0) == 1)
                                                                              break g;
                                                                            if ((l ^ -1) & Ur)
                                                                              break R;
                                                                            if (l = e[Qr + 80 >> 2], e[5996] = 0, Ur = wn(54, 2165, 1) | 0, yn = e[5996], e[5996] = 0, (yn | 0) == 1)
                                                                              break g;
                                                                            if (Je[Qr + 88 | 0] | (l ^ -1) & Ur)
                                                                              break R;
                                                                            Se[br + 176 | 0] = 0, e[br + 172 >> 2] = 1702195828, Se[br + 183 | 0] = 4, l = ((Ar | 0) >= 5 ? 5 : Ar) - 1 | 0, Se[Sa(ke, br + 172 | 0, l) + l | 0] = 0;
                                                                            break _;
                                                                          }
                                                                          Qr = Ws(22864) | 0, l = Ia;
                                                                          break f;
                                                                        }
                                                                        Qr = Ws(22864) | 0, l = Ia;
                                                                        break E;
                                                                      }
                                                                      Qr = Ws(22864) | 0, l = Ia;
                                                                      break w;
                                                                    }
                                                                    Qr = Ws(22864) | 0, l = Ia;
                                                                    break I;
                                                                  }
                                                                  Qr = Ws(22864) | 0, l = Ia;
                                                                  break l;
                                                                }
                                                                if (Qr = Ws(22864) | 0, l = Ia, Se[br + 115 | 0] >= 0)
                                                                  break l;
                                                                Tr(e[br + 104 >> 2]);
                                                              }
                                                              if (Se[br + 183 | 0] >= 0)
                                                                break I;
                                                              Tr(e[br + 172 >> 2]);
                                                            }
                                                            if (Se[br + 99 | 0] >= 0)
                                                              break w;
                                                            Tr(e[br + 88 >> 2]);
                                                          }
                                                          if (Se[br + 83 | 0] >= 0)
                                                            break E;
                                                          Tr(e[br + 72 >> 2]);
                                                        }
                                                        if (Se[br + 71 | 0] >= 0)
                                                          break f;
                                                        Tr(e[br + 60 >> 2]);
                                                        break f;
                                                      }
                                                      Qr = Ws(22864) | 0;
                                                      break d;
                                                    }
                                                    if (Qr = Ws(22864) | 0, l = Ia, qs[br + 16 >> 2] < 29)
                                                      break p;
                                                    Tr(e[br + 24 >> 2]);
                                                    break p;
                                                  }
                                                  Se[br + 176 | 0] = Je[2354], Se[br + 183 | 0] = 5, Se[br + 177 | 0] = 0, e[br + 172 >> 2] = Je[2350] | Je[2351] << 8 | (Je[2352] << 16 | Je[2353] << 24), l = ((Ar | 0) >= 6 ? 6 : Ar) - 1 | 0, Se[Sa(ke, br + 172 | 0, l) + l | 0] = 0;
                                                }
                                                if (e[5996] = 0, l = no(118, Qr | 0) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                                                  break g;
                                                _: {
                                                  if (l) {
                                                    Se[br + 176 | 0] = 0, e[br + 172 >> 2] = 1702195828, Se[br + 183 | 0] = 4, l = ((me | 0) >= 5 ? 5 : me) - 1 | 0, Se[Sa(S, br + 172 | 0, l) + l | 0] = 0;
                                                    break _;
                                                  }
                                                  Se[br + 176 | 0] = Je[2354], Se[br + 183 | 0] = 5, Se[br + 177 | 0] = 0, e[br + 172 >> 2] = Je[2350] | Je[2351] << 8 | (Je[2352] << 16 | Je[2353] << 24), l = ((me | 0) >= 6 ? 6 : me) - 1 | 0, Se[Sa(S, br + 172 | 0, l) + l | 0] = 0;
                                                }
                                                (Xr | 0) < 0 && Tr(Ri), l = e[br + 156 >> 2];
                                              }
                                              v: {
                                                if (!l || (y = e[l + 4 >> 2], e[l + 4 >> 2] = y - 1, y))
                                                  break v;
                                                Yn[e[e[l >> 2] + 8 >> 2]](l), Ls(l);
                                              }
                                              if (Se[br + 171 | 0] >= 0)
                                                break u;
                                              Tr(e[br + 160 >> 2]);
                                              break u;
                                            }
                                            Qr = Ws(22864) | 0;
                                          }
                                          l = Ia;
                                        }
                                        if ((Xr | 0) >= 0)
                                          break f;
                                        Tr(Ri);
                                      }
                                      l2(br + 152 | 0);
                                    }
                                    if (Se[br + 171 | 0] >= 0)
                                      break h;
                                    Tr(e[br + 160 >> 2]);
                                  }
                                  if ((su(22864) | 0) != (l | 0))
                                    break r;
                                  if (l = Zf(Qr | 0) | 0, l = Yn[e[e[l >> 2] + 8 >> 2]](l) | 0, e[5996] = 0, me = wn(30, br + 120 | 0, l | 0) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1)
                                    break A;
                                  if (e[5996] = 0, l = Ko(99, me | 0, 0, 5474) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                    break s;
                                  if (e[br + 168 >> 2] = e[l + 8 >> 2], S = e[l + 4 >> 2], e[br + 160 >> 2] = e[l >> 2], e[br + 164 >> 2] = S, e[l >> 2] = 0, e[l + 4 >> 2] = 0, e[l + 8 >> 2] = 0, e[5996] = 0, S = wn(97, br + 160 | 0, 2611) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                                    break a;
                                  e[br + 24 >> 2] = e[S + 8 >> 2], me = e[S + 4 >> 2], e[br + 16 >> 2] = e[S >> 2], e[br + 20 >> 2] = me, e[S >> 2] = 0, e[S + 4 >> 2] = 0, e[S + 8 >> 2] = 0, Qr = y, y = e[br + 16 >> 2], me = Je[br + 27 | 0], ke = me << 24 >> 24, Ar = (ke | 0) < 0, me = Ar ? e[br + 20 >> 2] : me, I = I - 1 | 0, I = (I | 0) > (me | 0) ? me : I, Se[Sa(Qr, Ar ? y : br + 16 | 0, I) + I | 0] = 0;
                                  h: {
                                    if ((ke | 0) >= 0 || (Tr(y), Se[S + 11 | 0] >= 0))
                                      break h;
                                    Tr(e[S >> 2]);
                                  }
                                  if (Se[l + 11 | 0] < 0 && Tr(e[l >> 2]), e[5996] = 0, l = wn(30, br + 16 | 0, 5575) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                    break n;
                                  me = C, y = e[l >> 2], I = Je[l + 11 | 0], C = I << 24 >> 24, S = (C | 0) < 0, ke = S ? y : l, l = S ? e[l + 4 >> 2] : I, I = Q - 1 | 0, l = (l | 0) < (I | 0) ? l : I, Se[Sa(me, ke, l) + l | 0] = 0, (C | 0) < 0 && Tr(y), $a();
                                }
                                bi = br + 208 | 0;
                                return;
                              }
                              Qr = gi() | 0;
                              break i;
                            }
                            Qr = gi() | 0;
                            break o;
                          }
                          if (Qr = gi() | 0, Se[br + 171 | 0] >= 0)
                            break o;
                          Tr(e[br + 160 >> 2]);
                        }
                        if (Se[me + 11 | 0] >= 0)
                          break i;
                        Tr(e[me >> 2]);
                        break i;
                      }
                      Qr = gi() | 0;
                    }
                    if (e[5996] = 0, jo(110), l = e[5996], e[5996] = 0, (l | 0) == 1)
                      break t;
                  }
                  ss(Qr | 0), jn();
                }
                Ws(0) | 0, _c(), jn();
              }
              jn();
            }
            function Bh(l, y, I, C, Q) {
              var S = 0, me = 0, ke = 0, Ar = 0, br = 0, Qr = 0, Ur = 0, Xr = 0, Ri = 0, yn = 0, En = 0, Wn = 0, lo = 0, Ro = 0, Xo = 0, bs = 0;
              ke = bi - 160 | 0, bi = ke, bc(ke + 48 | 0, I, zo[l + 16 >> 3], zo[l + 24 >> 3], 0, 0), e[5996] = 0, me = no(46, I | 0) | 0, S = e[5996], e[5996] = 0;
              e: {
                t: {
                  r: {
                    if ((S | 0) != 1) {
                      if (e[ke + 44 >> 2] = 0, e[ke + 36 >> 2] = 0, e[ke + 40 >> 2] = 0, Se[ke + 140 | 0] = 0, e[ke + 136 >> 2] = ke + 36, S = e[me + 4 >> 2], br = e[me >> 2], Xr = S - br | 0, Ar = (Xr | 0) / 12 | 0, (S | 0) != (br | 0)) {
                        i: {
                          n: {
                            o: {
                              if (Ar >>> 0 >= 357913942) {
                                if (e[5996] = 0, jo(47), l = e[5996], e[5996] = 0, (l | 0) == 1)
                                  break o;
                                break e;
                              }
                              if (e[5996] = 0, S = no(3, Xr | 0) | 0, br = e[5996], e[5996] = 0, (br | 0) == 1)
                                break o;
                              if (e[ke + 40 >> 2] = S, e[ke + 36 >> 2] = S, e[ke + 44 >> 2] = S + No(Ar, 12), Ar = e[me + 4 >> 2], me = e[me >> 2], e[5996] = 0, me = mf(48, ke + 44 | 0, me | 0, Ar | 0, S | 0) | 0, Ar = e[5996], e[5996] = 0, (Ar | 0) != 1)
                                break i;
                              me = gi() | 0, e[ke + 40 >> 2] = S;
                              break n;
                            }
                            me = gi() | 0;
                          }
                          lh(ke + 136 | 0);
                          break r;
                        }
                        e[ke + 40 >> 2] = me;
                      }
                      e[ke + 32 >> 2] = 0, e[ke + 24 >> 2] = 0, e[ke + 28 >> 2] = 0, S = e[C + 4 >> 2], me = e[C >> 2], e[5996] = 0, Co(49, ke + 24 | 0, S - me >> 2), S = e[5996], e[5996] = 0;
                      i: {
                        if ((S | 0) != 1) {
                          if (me = e[ke + 40 >> 2], S = e[ke + 36 >> 2], (me | 0) == (S | 0))
                            break t;
                          Ro = ke + 112 | 0, me = S;
                          n: {
                            for (; ; ) {
                              o: {
                                if (e[ke + 20 >> 2] = 0, e[ke + 12 >> 2] = 0, e[ke + 16 >> 2] = 0, Ar = e[C + 4 >> 2], S = e[C >> 2], Ri = No(lo, 12), me = Ri + me | 0, Ar - S >> 2 != e[me + 4 >> 2] - e[me >> 2] >> 3)
                                  break o;
                                br = 0, yn = 1, Ur = 0;
                                a: {
                                  if ((S | 0) != (Ar | 0)) {
                                    s: {
                                      A: {
                                        u: {
                                          for (; ; ) {
                                            if (me = Ur << 3, Xo = zo[me + e[ke + 60 >> 2] >> 3], bs = zo[me + e[ke + 48 >> 2] >> 3], S = e[(Ur << 2) + S >> 2], e[5996] = 0, S = Ic(50, S | 0, +bs, +Xo, y | 0) | 0, Ar = e[5996], e[5996] = 0, (Ar | 0) == 1)
                                              break A;
                                            if (me = me + e[Ri + e[ke + 36 >> 2] >> 2] | 0, Ar = e[me >> 2], me = e[me + 4 >> 2], Xr = e[S + 4 >> 2], S = e[S >> 2], e[5996] = 0, Xf(51, ke + 136 | 0, S | 0, Xr | 0, Ar | 0, me | 0), S = e[5996], e[5996] = 0, (S | 0) != 1) {
                                              Ar = e[ke + 20 >> 2];
                                              h: {
                                                if (Ar >>> 0 > br >>> 0) {
                                                  e[br + 8 >> 2] = 0, e[br >> 2] = 0, e[br + 4 >> 2] = 0, e[br >> 2] = e[ke + 136 >> 2], e[br + 4 >> 2] = e[ke + 140 >> 2], e[br + 8 >> 2] = e[ke + 144 >> 2], e[ke + 16 >> 2] = br + 12;
                                                  break h;
                                                }
                                                c: {
                                                  S = e[ke + 12 >> 2], Xr = (br - S | 0) / 12 | 0, me = Xr + 1 | 0;
                                                  f: {
                                                    if (me >>> 0 >= 357913942) {
                                                      e[5996] = 0, jo(52);
                                                      break f;
                                                    }
                                                    if (Ar = (Ar - S | 0) / 12 | 0, Qr = Ar << 1, me = Ar >>> 0 >= 178956970 ? 357913941 : me >>> 0 < Qr >>> 0 ? Qr : me, me >>> 0 < 357913942)
                                                      break c;
                                                    e[5996] = 0, jo(35);
                                                  }
                                                  if (l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                    break e;
                                                  break u;
                                                }
                                                if (e[5996] = 0, Qr = No(me, 12), Ar = no(3, Qr | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                  break u;
                                                me = Ar + No(Xr, 12) | 0, e[me >> 2] = e[ke + 136 >> 2], e[me + 4 >> 2] = e[ke + 140 >> 2], e[me + 8 >> 2] = e[ke + 144 >> 2], e[ke + 144 >> 2] = 0, e[ke + 136 >> 2] = 0, e[ke + 140 >> 2] = 0, Ar = Ar + Qr | 0, Xr = me + 12 | 0;
                                                c: {
                                                  if ((S | 0) == (br | 0)) {
                                                    e[ke + 20 >> 2] = Ar, e[ke + 16 >> 2] = Xr, e[ke + 12 >> 2] = me;
                                                    break c;
                                                  }
                                                  for (; me = me - 12 | 0, br = br - 12 | 0, e[me >> 2] = e[br >> 2], e[me + 4 >> 2] = e[br + 4 >> 2], e[me + 8 >> 2] = e[br + 8 >> 2], e[br + 8 >> 2] = 0, e[br >> 2] = 0, e[br + 4 >> 2] = 0, (S | 0) != (br | 0); )
                                                    ;
                                                  if (e[ke + 20 >> 2] = Ar, S = e[ke + 16 >> 2], e[ke + 16 >> 2] = Xr, br = e[ke + 12 >> 2], e[ke + 12 >> 2] = me, (S | 0) == (br | 0))
                                                    break c;
                                                  for (; ; ) {
                                                    if (Qr = S - 12 | 0, Xr = e[Qr >> 2], Xr) {
                                                      if (En = S - 8 | 0, me = e[En >> 2], Ar = Xr, (me | 0) != (Ar | 0)) {
                                                        for (; ; ) {
                                                          me = me - 32 | 0, S = e[me + 4 >> 2];
                                                          f: {
                                                            if (!S || (Ar = e[S + 4 >> 2], e[S + 4 >> 2] = Ar - 1, Ar))
                                                              break f;
                                                            Yn[e[e[S >> 2] + 8 >> 2]](S), Ls(S);
                                                          }
                                                          if ((me | 0) == (Xr | 0))
                                                            break;
                                                        }
                                                        Ar = e[Qr >> 2];
                                                      }
                                                      e[En >> 2] = Xr, Tr(Ar);
                                                    }
                                                    if (S = Qr, (br | 0) == (S | 0))
                                                      break;
                                                  }
                                                }
                                                if (br && Tr(br), Ar = e[ke + 136 >> 2], !Ar)
                                                  break h;
                                                if (S = Ar, me = e[ke + 140 >> 2], (S | 0) != (me | 0)) {
                                                  for (; ; ) {
                                                    me = me - 32 | 0, S = e[me + 4 >> 2];
                                                    c: {
                                                      if (!S || (br = e[S + 4 >> 2], e[S + 4 >> 2] = br - 1, br))
                                                        break c;
                                                      Yn[e[e[S >> 2] + 8 >> 2]](S), Ls(S);
                                                    }
                                                    if ((me | 0) == (Ar | 0))
                                                      break;
                                                  }
                                                  S = e[ke + 136 >> 2];
                                                }
                                                e[ke + 140 >> 2] = Ar, Tr(S);
                                              }
                                              if (br = e[ke + 16 >> 2], S = br - 12 | 0, yn = No(e[S + 4 >> 2] - e[S >> 2] >> 5, yn), Ur = Ur + 1 | 0, S = e[C >> 2], Ur >>> 0 >= e[C + 4 >> 2] - S >> 2 >>> 0)
                                                break s;
                                              continue;
                                            }
                                            break;
                                          }
                                          me = gi() | 0;
                                          break n;
                                        }
                                        me = gi() | 0, Pc(ke + 136 | 0);
                                        break n;
                                      }
                                      me = gi() | 0;
                                      break n;
                                    }
                                    if (!yn)
                                      break a;
                                  }
                                  Xr = 0;
                                  s: {
                                    A: {
                                      u: {
                                        h: {
                                          c: {
                                            f: {
                                              for (; ; ) {
                                                if (br = e[ke + 24 >> 2], e[C + 4 >> 2] != e[C >> 2])
                                                  for (me = 0, Ar = e[ke + 12 >> 2], S = Xr; Qr = No(me, 12), Ur = Qr + Ar | 0, Ar = e[Ur >> 2], e[(me << 2) + br >> 2] = Ar + ((S >>> 0) % (e[Ur + 4 >> 2] - Ar >> 5 >>> 0) << 5), Ur = S, Ar = e[ke + 12 >> 2], S = Qr + Ar | 0, S = (Ur >>> 0) / (e[S + 4 >> 2] - e[S >> 2] >> 5 >>> 0) | 0, me = me + 1 | 0, me >>> 0 < e[C + 4 >> 2] - e[C >> 2] >> 2 >>> 0; )
                                                    ;
                                                if (e[ke + 100 >> 2] = 0, e[ke + 92 >> 2] = 0, e[ke + 96 >> 2] = 0, me = br, Ri = e[ke + 28 >> 2], (me | 0) != (Ri | 0)) {
                                                  p: {
                                                    for (; ; ) {
                                                      d: {
                                                        Qr = e[br >> 2], me = e[ke + 96 >> 2];
                                                        g: {
                                                          if ((me | 0) != e[ke + 100 >> 2]) {
                                                            e[me >> 2] = e[Qr >> 2], S = e[Qr + 4 >> 2], e[me + 4 >> 2] = S, S && (e[S + 4 >> 2] = e[S + 4 >> 2] + 1), e[ke + 96 >> 2] = me + 8;
                                                            break g;
                                                          }
                                                          v: {
                                                            Ar = e[ke + 92 >> 2], S = me - Ar | 0, En = S >> 3, Ur = En + 1 | 0;
                                                            _: {
                                                              if (Ur >>> 0 >= 536870912) {
                                                                e[5996] = 0, jo(59);
                                                                break _;
                                                              }
                                                              if (Wn = S >> 2, S = S >>> 0 >= 2147483640 ? 536870911 : Ur >>> 0 < Wn >>> 0 ? Wn : Ur, S >>> 0 < 536870912)
                                                                break v;
                                                              e[5996] = 0, jo(35);
                                                            }
                                                            if (l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                              break e;
                                                            me = gi() | 0;
                                                            break s;
                                                          }
                                                          if (e[5996] = 0, Wn = S << 3, Ur = no(3, Wn | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                            break d;
                                                          S = Ur + (En << 3) | 0, e[S >> 2] = e[Qr >> 2], Qr = e[Qr + 4 >> 2], e[S + 4 >> 2] = Qr, Qr && (e[Qr + 4 >> 2] = e[Qr + 4 >> 2] + 1, me = e[ke + 96 >> 2]), Qr = Ur + Wn | 0, Ur = S + 8 | 0;
                                                          v: {
                                                            if ((me | 0) == (Ar | 0)) {
                                                              e[ke + 100 >> 2] = Qr, e[ke + 96 >> 2] = Ur, e[ke + 92 >> 2] = S;
                                                              break v;
                                                            }
                                                            for (; S = S - 8 | 0, me = me - 8 | 0, e[S >> 2] = e[me >> 2], e[S + 4 >> 2] = e[me + 4 >> 2], e[me >> 2] = 0, e[me + 4 >> 2] = 0, (me | 0) != (Ar | 0); )
                                                              ;
                                                            if (e[ke + 100 >> 2] = Qr, me = e[ke + 96 >> 2], e[ke + 96 >> 2] = Ur, Ar = e[ke + 92 >> 2], e[ke + 92 >> 2] = S, (me | 0) == (Ar | 0))
                                                              break v;
                                                            for (; ; ) {
                                                              me = me - 8 | 0, S = e[me + 4 >> 2];
                                                              _: {
                                                                if (!S || (Qr = e[S + 4 >> 2], e[S + 4 >> 2] = Qr - 1, Qr))
                                                                  break _;
                                                                Yn[e[e[S >> 2] + 8 >> 2]](S), Ls(S);
                                                              }
                                                              if ((me | 0) == (Ar | 0))
                                                                break;
                                                            }
                                                          }
                                                          if (!Ar)
                                                            break g;
                                                          Tr(Ar);
                                                        }
                                                        if (br = br + 4 | 0, (Ri | 0) != (br | 0))
                                                          continue;
                                                        break p;
                                                      }
                                                      break;
                                                    }
                                                    me = gi() | 0;
                                                    break s;
                                                  }
                                                  br = e[ke + 28 >> 2], me = e[ke + 24 >> 2];
                                                }
                                                if (e[5996] = 0, Gf(63, ke + 72 | 0, I | 0, me | 0, br | 0, 0), S = e[5996], e[5996] = 0, (S | 0) == 1 || (e[5996] = 0, br = no(3, 104) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1))
                                                  break c;
                                                e[br >> 2] = 7e3, e[br + 4 >> 2] = 0, e[br + 8 >> 2] = 0, e[ke + 112 >> 2] = 0, e[ke + 104 >> 2] = 0, e[ke + 108 >> 2] = 0, e[ke + 116 >> 2] = e[ke + 92 >> 2], S = e[ke + 100 >> 2], me = e[ke + 96 >> 2], e[ke + 100 >> 2] = 0, e[ke + 120 >> 2] = me, e[ke + 124 >> 2] = S, e[ke + 92 >> 2] = 0, e[ke + 96 >> 2] = 0, Se[ke + 132 | 0] = 0, e[ke + 128 >> 2] = ke + 104, Qr = e[Q + 4 >> 2], me = e[Q >> 2], Ar = Qr - me | 0, S = (Ar | 0) / 12 | 0;
                                                p: {
                                                  if ((me | 0) != (Qr | 0)) {
                                                    if (S >>> 0 >= 357913942) {
                                                      if (e[5996] = 0, jo(41), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                        break e;
                                                      me = gi() | 0;
                                                      break u;
                                                    }
                                                    if (e[5996] = 0, Ar = no(3, Ar | 0) | 0, Ur = e[5996], e[5996] = 0, (Ur | 0) == 1)
                                                      break p;
                                                    for (e[ke + 108 >> 2] = Ar, e[ke + 104 >> 2] = Ar, e[ke + 112 >> 2] = Ar + No(S, 12), e[ke + 156 >> 2] = Ar, e[ke + 152 >> 2] = Ar, Se[ke + 148 | 0] = 0, e[ke + 136 >> 2] = Ro, e[ke + 144 >> 2] = ke + 156, e[ke + 140 >> 2] = ke + 152, S = Ar; ; ) {
                                                      d: {
                                                        if (Se[me + 11 | 0] >= 0) {
                                                          Ur = e[me + 4 >> 2], e[S >> 2] = e[me >> 2], e[S + 4 >> 2] = Ur, e[S + 8 >> 2] = e[me + 8 >> 2];
                                                          break d;
                                                        }
                                                        if (Ur = e[me + 4 >> 2], Ri = e[me >> 2], e[5996] = 0, Ms(40, S | 0, Ri | 0, Ur | 0), S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                          break h;
                                                        S = e[ke + 156 >> 2];
                                                      }
                                                      if (S = S + 12 | 0, e[ke + 156 >> 2] = S, me = me + 12 | 0, (Qr | 0) == (me | 0))
                                                        break;
                                                    }
                                                    e[ke + 108 >> 2] = S;
                                                  }
                                                  if (e[5996] = 0, Qr = i2(60, br + 12 | 0, I | 0, ke + 116 | 0, ke + 104 | 0, 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                    break f;
                                                  if (Ar = e[ke + 104 >> 2], Ar) {
                                                    if (S = e[ke + 108 >> 2], me = Ar, (S | 0) != (me | 0)) {
                                                      for (; me = S - 12 | 0, Se[S - 1 | 0] < 0 && Tr(e[me >> 2]), S = me, (Ar | 0) != (S | 0); )
                                                        ;
                                                      me = e[ke + 104 >> 2];
                                                    }
                                                    e[ke + 108 >> 2] = Ar, Tr(me);
                                                  }
                                                  if (S = e[ke + 116 >> 2], S) {
                                                    if (me = e[ke + 120 >> 2], (S | 0) != (me | 0)) {
                                                      for (; ; ) {
                                                        me = me - 8 | 0, Ar = e[me + 4 >> 2];
                                                        d: {
                                                          if (!Ar || (Ur = e[Ar + 4 >> 2], e[Ar + 4 >> 2] = Ur - 1, Ur))
                                                            break d;
                                                          Yn[e[e[Ar >> 2] + 8 >> 2]](Ar), Ls(Ar);
                                                        }
                                                        if ((S | 0) == (me | 0))
                                                          break;
                                                      }
                                                      S = e[ke + 116 >> 2];
                                                    }
                                                    Tr(S);
                                                  }
                                                  if (e[ke + 140 >> 2] = br, e[ke + 136 >> 2] = Qr, e[5996] = 0, S = e[ke + 140 >> 2], e[ke >> 2] = e[ke + 136 >> 2], e[ke + 4 >> 2] = S, Ms(61, l | 0, ke + 72 | 0, ke | 0), S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                    break c;
                                                  if (S = e[ke + 92 >> 2], S) {
                                                    if (me = e[ke + 96 >> 2], (S | 0) != (me | 0)) {
                                                      for (; ; ) {
                                                        me = me - 8 | 0, Ar = e[me + 4 >> 2];
                                                        d: {
                                                          if (!Ar || (br = e[Ar + 4 >> 2], e[Ar + 4 >> 2] = br - 1, br))
                                                            break d;
                                                          Yn[e[e[Ar >> 2] + 8 >> 2]](Ar), Ls(Ar);
                                                        }
                                                        if ((S | 0) == (me | 0))
                                                          break;
                                                      }
                                                      S = e[ke + 92 >> 2];
                                                    }
                                                    Tr(S);
                                                  }
                                                  if (Xr = Xr + 1 | 0, (yn | 0) != (Xr | 0))
                                                    continue;
                                                  break a;
                                                }
                                                break;
                                              }
                                              me = gi() | 0;
                                              break u;
                                            }
                                            me = gi() | 0, hf(ke + 104 | 0);
                                            break A;
                                          }
                                          me = gi() | 0;
                                          break s;
                                        }
                                        me = gi() | 0, pd(ke + 136 | 0), e[ke + 108 >> 2] = Ar;
                                      }
                                      fd(ke + 128 | 0);
                                    }
                                    Za(ke + 116 | 0), Tr(br);
                                  }
                                  Za(ke + 92 | 0);
                                  break n;
                                }
                                if (Ar = e[ke + 12 >> 2], Ar) {
                                  if (me = e[ke + 16 >> 2], (Ar | 0) != (me | 0)) {
                                    for (; ; ) {
                                      if (Xr = me - 12 | 0, br = e[Xr >> 2], br) {
                                        if (S = br, Qr = me - 8 | 0, me = e[Qr >> 2], (S | 0) != (me | 0)) {
                                          for (; ; ) {
                                            me = me - 32 | 0, S = e[me + 4 >> 2];
                                            a: {
                                              if (!S || (yn = e[S + 4 >> 2], e[S + 4 >> 2] = yn - 1, yn))
                                                break a;
                                              Yn[e[e[S >> 2] + 8 >> 2]](S), Ls(S);
                                            }
                                            if ((me | 0) == (br | 0))
                                              break;
                                          }
                                          S = e[Xr >> 2];
                                        }
                                        e[Qr >> 2] = br, Tr(S);
                                      }
                                      if (me = Xr, (Ar | 0) == (me | 0))
                                        break;
                                    }
                                    Ar = e[ke + 12 >> 2];
                                  }
                                  Tr(Ar);
                                }
                                if (lo = lo + 1 | 0, me = e[ke + 36 >> 2], lo >>> 0 < (e[ke + 40 >> 2] - me | 0) / 12 >>> 0)
                                  continue;
                                break t;
                              }
                              break;
                            }
                            if (e[5996] = 0, ia(44, 5170, 1900, 642, 2497), l = e[5996], e[5996] = 0, (l | 0) != 1)
                              break e;
                            me = gi() | 0;
                          }
                          qc(ke + 12 | 0);
                          break i;
                        }
                        me = gi() | 0;
                      }
                      l = e[ke + 24 >> 2], l && Tr(l), Hh(ke + 36 | 0);
                      break r;
                    }
                    me = gi() | 0;
                  }
                  ph(ke + 48 | 0), ss(me | 0), jn();
                }
                if (l = e[ke + 24 >> 2], l && (Tr(l), me = e[ke + 36 >> 2]), me) {
                  if (S = me, Ar = e[ke + 40 >> 2], (S | 0) != (Ar | 0)) {
                    for (; l = Ar - 12 | 0, y = e[l >> 2], y && (e[Ar - 8 >> 2] = y, Tr(y)), Ar = l, (Ar | 0) != (me | 0); )
                      ;
                    S = e[ke + 36 >> 2];
                  }
                  e[ke + 40 >> 2] = me, Tr(S);
                }
                l = e[ke + 60 >> 2], l && (e[ke - -64 >> 2] = l, Tr(l)), l = e[ke + 48 >> 2], l && (e[ke + 52 >> 2] = l, Tr(l)), bi = ke + 160 | 0;
                return;
              }
              jn();
            }
            function _h(l, y, I, C, Q, S, me, ke, Ar) {
              var br = 0, Qr = 0, Ur = 0, Xr = 0, Ri = 0, yn = 0, En = 0, Wn = 0, lo = 0, Ro = 0, Xo = 0, bs = 0, Os = 0, Gs = 0, aa = 0, Ma = 0, rf = 0, af = 0, lf = 0, wf = 0, Rf = 0, zf = 0, xc = 0, Oc = 0, Yc = 0, ou = 0, mu = 0, vu = 0, wu = 0, Lu = 0, qu = 0, Hu = 0;
              Qr = bi - 336 | 0, bi = Qr, Xr = ke, Ri = Ar & 65535, yn = C, En = Q & 65535, Xo = (Q ^ Ar) & -2147483648, lo = Ar >>> 16 & 32767, Ro = Q >>> 16 & 32767;
              e: {
                t: {
                  if (lo - 32767 >>> 0 > 4294934529 & Ro - 32767 >>> 0 >= 4294934530)
                    break t;
                  if (br = Q & 2147483647, !(!C & (br | 0) == 2147418112 ? !(y | I) : br >>> 0 < 2147418112)) {
                    Wn = C, Xo = Q | 32768;
                    break e;
                  }
                  if (Q = Ar & 2147483647, !(!ke & (Q | 0) == 2147418112 ? !(S | me) : Q >>> 0 < 2147418112)) {
                    Wn = ke, Xo = Ar | 32768, y = S, I = me;
                    break e;
                  }
                  if (!(y | C | (br ^ 2147418112 | I))) {
                    if (!(S | ke | (Q ^ 2147418112 | me))) {
                      y = 0, I = 0, Xo = 2147450880;
                      break e;
                    }
                    Xo = Xo | 2147418112, y = 0, I = 0;
                    break e;
                  }
                  if (!(S | ke | (Q ^ 2147418112 | me))) {
                    y = 0, I = 0;
                    break e;
                  }
                  if (!(y | C | (I | br))) {
                    y = !(S | ke | (Q | me)), Wn = y ? 0 : Wn, Xo = y ? 2147450880 : Xo, y = 0, I = 0;
                    break e;
                  }
                  if (!(S | ke | (Q | me))) {
                    Xo = Xo | 2147418112, y = 0, I = 0;
                    break e;
                  }
                  if ((br | 0) == 65535 | br >>> 0 < 65535 && (C = !(yn | En), Ar = C, br = C ? y : yn, C = C << 6, Ar = Ha(Ar ? I : En), C = C + ((Ar | 0) == 32 ? Ha(br) + 32 | 0 : Ar) | 0, Es(Qr + 320 | 0, y, I, yn, En, C - 15 | 0), bs = 16 - C | 0, yn = e[Qr + 328 >> 2], En = e[Qr + 332 >> 2], I = e[Qr + 324 >> 2], y = e[Qr + 320 >> 2]), Q >>> 0 > 65535)
                    break t;
                  C = !(Ri | Xr), ke = C, Ar = C ? S : Xr, C = C << 6, ke = Ha(ke ? me : Ri), C = C + ((ke | 0) == 32 ? Ha(Ar) + 32 | 0 : ke) | 0, Es(Qr + 304 | 0, S, me, Xr, Ri, C - 15 | 0), bs = (C + bs | 0) - 16 | 0, Xr = e[Qr + 312 >> 2], Ri = e[Qr + 316 >> 2], S = e[Qr + 304 >> 2], me = e[Qr + 308 >> 2];
                }
                Q = Ri | 65536, rf = Q, af = Xr, C = Xr, br = Q << 15 | C >>> 17, Q = C << 15 | me >>> 17, C = Q, Ar = 0 - C | 0, ke = br, br = 1963258675 - (br + ((C | 0) != 0) | 0) | 0, Ja(Qr + 288 | 0, C, ke, 0, 0, Ar, br, 0, 0), C = e[Qr + 296 >> 2], Ja(Qr + 272 | 0, 0 - C | 0, 0 - (e[Qr + 300 >> 2] + ((C | 0) != 0) | 0) | 0, 0, 0, Ar, br, 0, 0), C = e[Qr + 280 >> 2], Ar = C << 1 | e[Qr + 276 >> 2] >>> 31, C = e[Qr + 284 >> 2] << 1 | C >>> 31, Ja(Qr + 256 | 0, Ar, C, 0, 0, Q, ke, 0, 0), br = e[Qr + 264 >> 2], Ja(Qr + 240 | 0, Ar, C, 0, 0, 0 - br | 0, 0 - (e[Qr + 268 >> 2] + ((br | 0) != 0) | 0) | 0, 0, 0), Ar = e[Qr + 248 >> 2], br = Ar << 1 | e[Qr + 244 >> 2] >>> 31, C = e[Qr + 252 >> 2] << 1 | Ar >>> 31, Ja(Qr + 224 | 0, br, C, 0, 0, Q, ke, 0, 0), Ar = e[Qr + 232 >> 2], Ja(Qr + 208 | 0, br, C, 0, 0, 0 - Ar | 0, 0 - (e[Qr + 236 >> 2] + ((Ar | 0) != 0) | 0) | 0, 0, 0), C = e[Qr + 216 >> 2], Ar = C << 1 | e[Qr + 212 >> 2] >>> 31, C = e[Qr + 220 >> 2] << 1 | C >>> 31, Ja(Qr + 192 | 0, Ar, C, 0, 0, Q, ke, 0, 0), br = e[Qr + 200 >> 2], Ja(Qr + 176 | 0, Ar, C, 0, 0, 0 - br | 0, 0 - (e[Qr + 204 >> 2] + ((br | 0) != 0) | 0) | 0, 0, 0), Ar = Q, Q = e[Qr + 184 >> 2], C = ke, Xr = Q << 1 | e[Qr + 180 >> 2] >>> 31, ke = Xr - 1 | 0, Q = (e[Qr + 188 >> 2] << 1 | Q >>> 31) - !Xr | 0, Ja(Qr + 160 | 0, Ar, C, 0, 0, ke, Q, 0, 0), C = ke, Ja(Qr + 144 | 0, S << 15, me << 15 | S >>> 17, 0, 0, C, Q, 0, 0), Gs = Qr + 112 | 0, aa = e[Qr + 168 >> 2], ke = e[Qr + 172 >> 2], Xr = e[Qr + 160 >> 2], Ar = e[Qr + 152 >> 2], Ur = Xr + Ar | 0, Ri = e[Qr + 164 >> 2], br = Ri + e[Qr + 156 >> 2] | 0, br = Ar >>> 0 > Ur >>> 0 ? br + 1 | 0 : br, Ar = br, br = (Ri | 0) == (br | 0) & Ur >>> 0 < Xr >>> 0 | br >>> 0 < Ri >>> 0, Ri = br + aa | 0, br = br >>> 0 > Ri >>> 0 ? ke + 1 | 0 : ke, Xr = !Ar & Ur >>> 0 > 1 | (Ar | 0) != 0, ke = Ri + Xr | 0, br = Xr >>> 0 > ke >>> 0 ? br + 1 | 0 : br, Ja(Gs, C, Q, 0, 0, 0 - ke | 0, 0 - (((ke | 0) != 0) + br | 0) | 0, 0, 0), Ja(Qr + 128 | 0, 1 - Ur | 0, 0 - ((Ur >>> 0 > 1) + Ar | 0) | 0, 0, 0, C, Q, 0, 0), ou = (Ro - lo | 0) + bs | 0, Q = e[Qr + 116 >> 2], Gs = Q, C = e[Qr + 112 >> 2], br = Q << 1 | C >>> 31, Ar = C << 1, Ri = br, C = br, ke = e[Qr + 140 >> 2], Ma = ke, Q = e[Qr + 136 >> 2], br = ke << 1 | Q >>> 31, Ur = Q << 1 | e[Qr + 132 >> 2] >>> 31, ke = Ur + Ar | 0, C = C + br | 0, C = ke >>> 0 < Ur >>> 0 ? C + 1 | 0 : C, Q = C, C = C - (ke >>> 0 < 13927) | 0, Os = C, aa = C, Ur = 0, br = En | 65536, mu = br, vu = yn, C = yn, br = br << 1 | C >>> 31, Lu = C << 1, qu = br, zf = br, C = Ua(Os, Ur, br, 0), br = Ci, lf = C, wf = br, bs = y << 1, C = I << 1 | y >>> 31, lo = C, br = 0, Ro = br, Xr = ke - 13927 | 0, Os = (Q | 0) == (Os | 0) & Xr >>> 0 < ke >>> 0 | Q >>> 0 > Os >>> 0, Q = (Q | 0) == (Ri | 0) & ke >>> 0 < Ar >>> 0 | Q >>> 0 < Ri >>> 0, C = e[Qr + 120 >> 2], ke = e[Qr + 124 >> 2] << 1 | C >>> 31, C = C << 1 | Gs >>> 31, Ur = Ma >>> 31 | 0, C = Ur + C | 0, br = ke, br = C >>> 0 < Ur >>> 0 ? br + 1 | 0 : br, ke = C, C = C + Q | 0, br = ke >>> 0 > C >>> 0 ? br + 1 | 0 : br, Q = C, C = C + Os | 0, Ur = Q >>> 0 > C >>> 0 ? br + 1 | 0 : br, Q = C - 1 | 0, Rf = Ur - !C | 0, Ma = 0, Ar = Ua(lo, Ro, Rf, Ma), C = Ar + lf | 0, ke = Ci + wf | 0, ke = C >>> 0 < Ar >>> 0 ? ke + 1 | 0 : ke, Ri = (wf | 0) == (ke | 0) & C >>> 0 < lf >>> 0 | ke >>> 0 < wf >>> 0, lf = Q, wu = I >>> 31 | 0, Oc = wu | yn << 1, Os = 0, Q = Ua(Q, 0, Oc, Os), yn = Q + C | 0, br = Ci + ke | 0, Ur = 0, br = Q >>> 0 > yn >>> 0 ? br + 1 | 0 : br, En = br, C = (br | 0) == (ke | 0) & C >>> 0 > yn >>> 0 | ke >>> 0 > br >>> 0, Q = C, C = C + Ri | 0, Ur = Q >>> 0 > C >>> 0 ? 1 : Ur, Q = Ua(zf, Ro, Rf, Ma), C = Q + C | 0, br = Ci + Ur | 0, Ri = C, C = C >>> 0 < Q >>> 0 ? br + 1 | 0 : br, Q = Ua(zf, Ro, lf, Os), Ur = Ci, ke = Q, Q = Ua(Oc, Os, Rf, Ma), Ar = ke + Q | 0, br = Ci + Ur | 0, br = Q >>> 0 > Ar >>> 0 ? br + 1 | 0 : br, Q = br, br = (Ur | 0) == (br | 0) & ke >>> 0 > Ar >>> 0 | br >>> 0 < Ur >>> 0, Ur = Ri + Q | 0, C = C + br | 0, C = Ur >>> 0 < Q >>> 0 ? C + 1 | 0 : C, Ri = Ur, Ur = C, Q = 0, C = Q + yn | 0, br = Ar + En | 0, br = C >>> 0 < Q >>> 0 ? br + 1 | 0 : br, Q = br, ke = (br | 0) == (En | 0) & C >>> 0 < yn >>> 0 | br >>> 0 < En >>> 0, br = Ur, Ar = ke, ke = ke + Ri | 0, br = Ar >>> 0 > ke >>> 0 ? br + 1 | 0 : br, xc = ke, Ur = br, Gs = C, yn = C, wf = Xr, C = Ua(Xr, 0, Oc, Os), Ar = Ci, ke = C, Xr = Ua(aa, Wn, lo, Wn), C = C + Xr | 0, br = Ci + Ar | 0, br = C >>> 0 < Xr >>> 0 ? br + 1 | 0 : br, Xr = (Ar | 0) == (br | 0) & C >>> 0 < ke >>> 0 | Ar >>> 0 > br >>> 0, ke = br, Yc = bs & -2, Ar = Ua(lf, Os, Yc, 0), En = Ar + C | 0, br = Ci + br | 0, br = Ar >>> 0 > En >>> 0 ? br + 1 | 0 : br, Ar = br, C = (br | 0) == (ke | 0) & C >>> 0 > En >>> 0 | ke >>> 0 > br >>> 0, ke = 0, br = C + Xr | 0, C = (br >>> 0 < C >>> 0 ? 1 : ke) + Q | 0, Ri = br + yn | 0, C = Ri >>> 0 < br >>> 0 ? C + 1 | 0 : C, br = Ur, yn = C, C = (C | 0) == (Q | 0) & Ri >>> 0 < Gs >>> 0 | C >>> 0 < Q >>> 0, Q = C, C = C + xc | 0, br = Q >>> 0 > C >>> 0 ? br + 1 | 0 : br, Hu = C, Gs = br, C = Ua(zf, Ro, wf, Wn), xc = Ci, zf = C, Q = Ua(Rf, Ma, Yc, Wn), C = C + Q | 0, br = Ci + xc | 0, br = C >>> 0 < Q >>> 0 ? br + 1 | 0 : br, Xr = C, Ur = Ua(aa, Wn, Oc, Os), Q = C + Ur | 0, ke = br, C = br + Ci | 0, C = Q >>> 0 < Ur >>> 0 ? C + 1 | 0 : C, Ro = Q, br = Ua(lo, Wn, lf, Os), Q = Q + br | 0, Ur = Ci + C | 0, Ur = Q >>> 0 < br >>> 0 ? Ur + 1 | 0 : Ur, Rf = (C | 0) == (Ur | 0) & Q >>> 0 < Ro >>> 0 | C >>> 0 > Ur >>> 0, br = (ke | 0) == (xc | 0) & Xr >>> 0 < zf >>> 0 | ke >>> 0 < xc >>> 0, C = (C | 0) == (ke | 0) & Xr >>> 0 > Ro >>> 0 | C >>> 0 < ke >>> 0, C = C + br | 0, C = C + Rf | 0, ke = Ur, Ro = ke + Ri | 0, br = (C | Ma) + yn | 0, br = ke >>> 0 > Ro >>> 0 ? br + 1 | 0 : br, Xr = br, C = (yn | 0) == (br | 0) & Ri >>> 0 > Ro >>> 0 | br >>> 0 < yn >>> 0, br = Gs, ke = C, C = C + Hu | 0, br = ke >>> 0 > C >>> 0 ? br + 1 | 0 : br, Ma = C, yn = br, C = Ua(aa, Wn, Yc, Wn), aa = Ci, Ri = C, ke = Ua(lo, Wn, wf, Wn), C = C + ke | 0, br = Ci + aa | 0, br = C >>> 0 < ke >>> 0 ? br + 1 | 0 : br, Gs = 0, ke = (br | 0) == (aa | 0) & C >>> 0 < Ri >>> 0 | br >>> 0 < aa >>> 0, Ri = br, C = br + En | 0, br = (ke | Gs) + Ar | 0, br = C >>> 0 < Ri >>> 0 ? br + 1 | 0 : br, Ar = (Ar | 0) == (br | 0) & C >>> 0 < En >>> 0 | Ar >>> 0 > br >>> 0, ke = br, br = Q, En = 0, Q = En + C | 0, Ur = ke + br | 0, br = 0, Ur = Q >>> 0 < En >>> 0 ? Ur + 1 | 0 : Ur, C = (ke | 0) == (Ur | 0) & C >>> 0 > Q >>> 0 | ke >>> 0 > Ur >>> 0, Q = C, C = C + Ar | 0, br = (Q >>> 0 > C >>> 0 ? 1 : br) + Xr | 0, Ur = yn, Q = C, C = C + Ro | 0, br = Q >>> 0 > C >>> 0 ? br + 1 | 0 : br, Q = br, ke = (Xr | 0) == (br | 0) & C >>> 0 < Ro >>> 0 | br >>> 0 < Xr >>> 0, Ar = ke, ke = ke + Ma | 0, Ur = Ar >>> 0 > ke >>> 0 ? Ur + 1 | 0 : Ur, Ar = Ur;
                t: {
                  if ((Ur | 0) == 131071 | Ur >>> 0 < 131071) {
                    vu = Lu | wu, mu = Os | qu, Ja(Qr + 80 | 0, C, br, ke, Ur, S, me, af, rf), Ur = e[Qr + 84 >> 2], Ri = Ur, br = y << 17, Xr = 0, En = e[Qr + 88 >> 2], I = Xr - En | 0, y = e[Qr + 80 >> 2], Ur = (Ur | y) != 0, yn = I - Ur | 0, En = (br - (e[Qr + 92 >> 2] + (Xr >>> 0 < En >>> 0) | 0) | 0) - (I >>> 0 < Ur >>> 0) | 0, Xr = 0 - y | 0, Ri = 0 - (((y | 0) != 0) + Ri | 0) | 0, y = ou + 16382 | 0;
                    break t;
                  }
                  C = (Q & 1) << 31 | C >>> 1, Q = ke << 31 | Q >>> 1, ke = (Ar & 1) << 31 | ke >>> 1, Ar = Ar >>> 1 | 0, Ja(Qr + 96 | 0, C, Q, ke, Ar, S, me, af, rf), yn = e[Qr + 100 >> 2], lo = yn, Ri = 0, bs = e[Qr + 104 >> 2], Xr = Ri - bs | 0, Ur = e[Qr + 96 >> 2], En = (yn | Ur) != 0, yn = Xr - En | 0, En = ((y << 16) - (e[Qr + 108 >> 2] + (Ri >>> 0 < bs >>> 0) | 0) | 0) - (Xr >>> 0 < En >>> 0) | 0, Xr = 0 - Ur | 0, Ri = 0 - (((Ur | 0) != 0) + lo | 0) | 0, bs = y, lo = I, y = ou + 16383 | 0;
                }
                if ((y | 0) >= 32767) {
                  Xo = Xo | 2147418112, y = 0, I = 0;
                  break e;
                }
                t: {
                  if ((y | 0) > 0) {
                    Ur = En << 1 | yn >>> 31, yn = yn << 1 | Ri >>> 31, En = Ur, bs = ke, lo = Ar & 65535 | y << 16, Ur = Ri << 1 | Xr >>> 31, Ar = Xr << 1;
                    break t;
                  }
                  if ((y | 0) <= -113) {
                    y = 0, I = 0;
                    break e;
                  }
                  fn(Qr - -64 | 0, C, Q, ke, Ar, 1 - y | 0), Es(Qr + 48 | 0, bs, lo, vu, mu, y + 112 | 0), C = e[Qr + 64 >> 2], Q = e[Qr + 68 >> 2], bs = e[Qr + 72 >> 2], lo = e[Qr + 76 >> 2], Ja(Qr + 32 | 0, S, me, af, rf, C, Q, bs, lo), y = e[Qr + 40 >> 2], I = e[Qr + 56 >> 2], Ur = e[Qr + 36 >> 2], yn = y << 1 | Ur >>> 31, Xr = I - yn | 0, En = e[Qr + 60 >> 2] - ((e[Qr + 44 >> 2] << 1 | y >>> 31) + (I >>> 0 < yn >>> 0) | 0) | 0, y = e[Qr + 32 >> 2], ke = Ur << 1 | y >>> 31, br = y << 1, Ar = e[Qr + 52 >> 2], I = e[Qr + 48 >> 2], y = (ke | 0) == (Ar | 0) & br >>> 0 > I >>> 0 | ke >>> 0 > Ar >>> 0, yn = Xr - y | 0, En = En - (y >>> 0 > Xr >>> 0) | 0, Ur = Ar - ((I >>> 0 < br >>> 0) + ke | 0) | 0, Ar = I - br | 0;
                }
                y = Ar, Ja(Qr + 16 | 0, S, me, af, rf, 3, 0, 0, 0), Ja(Qr, S, me, af, rf, 5, 0, 0, 0), I = 0, ke = Ur + I | 0, br = C & 1, y = y + br | 0, ke = Ar >>> 0 > y >>> 0 ? ke + 1 | 0 : ke, Ar = y, me = (ke | 0) == (me | 0) & S >>> 0 < Ar >>> 0 | me >>> 0 < ke >>> 0, Ur = En, y = (I | 0) == (ke | 0) & Ar >>> 0 < br >>> 0 | I >>> 0 > ke >>> 0, S = y + yn | 0, Ur = y >>> 0 > S >>> 0 ? Ur + 1 | 0 : Ur, br = Q, y = (Ur | 0) == (rf | 0), y = y & (S | 0) == (af | 0) ? me : y & S >>> 0 > af >>> 0 | Ur >>> 0 > rf >>> 0, I = y, y = y + C | 0, br = I >>> 0 > y >>> 0 ? br + 1 | 0 : br, I = br, C = (Q | 0) == (br | 0) & y >>> 0 < C >>> 0 | Q >>> 0 > br >>> 0, br = lo, Q = C, C = C + bs | 0, br = Q >>> 0 > C >>> 0 ? br + 1 | 0 : br, me = C, Q = e[Qr + 20 >> 2], Ri = (Q | 0) == (ke | 0) & qs[Qr + 16 >> 2] < Ar >>> 0 | Q >>> 0 < ke >>> 0, Q = e[Qr + 28 >> 2], C = e[Qr + 24 >> 2], Q = br >>> 0 < 2147418112 & ((C | 0) == (S | 0) & (Q | 0) == (Ur | 0) ? Ri : (Q | 0) == (Ur | 0) & C >>> 0 < S >>> 0 | Q >>> 0 < Ur >>> 0), C = I, Ri = Q, Q = y + Q | 0, C = Ri >>> 0 > Q >>> 0 ? C + 1 | 0 : C, y = (I | 0) == (C | 0) & y >>> 0 > Q >>> 0 | I >>> 0 > C >>> 0, I = y, y = y + me | 0, br = I >>> 0 > y >>> 0 ? br + 1 | 0 : br, me = y, I = e[Qr + 4 >> 2], ke = (I | 0) == (ke | 0) & qs[Qr >> 2] < Ar >>> 0 | I >>> 0 < ke >>> 0, I = e[Qr + 12 >> 2], y = e[Qr + 8 >> 2], y = br >>> 0 < 2147418112 & ((y | 0) == (S | 0) & (I | 0) == (Ur | 0) ? ke : (I | 0) == (Ur | 0) & y >>> 0 < S >>> 0 | I >>> 0 < Ur >>> 0), I = y, y = y + Q | 0, Ur = I >>> 0 > y >>> 0 ? C + 1 | 0 : C, I = Ur, Q = (C | 0) == (Ur | 0) & y >>> 0 < Q >>> 0 | C >>> 0 > Ur >>> 0, C = br, S = Q, Q = Q + me | 0, C = S >>> 0 > Q >>> 0 ? C + 1 | 0 : C, Wn = Q | Wn, Xo = C | Xo;
              }
              e[l >> 2] = y, e[l + 4 >> 2] = I, e[l + 8 >> 2] = Wn, e[l + 12 >> 2] = Xo, bi = Qr + 336 | 0;
            }
            function gc(l, y, I, C, Q, S) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = +Q, S = S | 0;
              var me = 0, ke = 0, Ar = 0, br = 0, Qr = 0, Ur = 0, Xr = 0, Ri = 0, yn = 0, En = 0, Wn = 0, lo = 0, Ro = 0, Xo = 0;
              ke = bi - 128 | 0, bi = ke, bc(ke + 56 | 0, I, zo[l + 16 >> 3], zo[l + 24 >> 3], Q, S), e[5996] = 0, S = no(46, I | 0) | 0, me = e[5996], e[5996] = 0;
              e: {
                t: {
                  r: {
                    if ((me | 0) != 1) {
                      if (e[ke + 52 >> 2] = 0, e[ke + 44 >> 2] = 0, e[ke + 48 >> 2] = 0, Se[ke + 84 | 0] = 0, e[ke + 80 >> 2] = ke + 44, me = e[S + 4 >> 2], br = e[S >> 2], Ur = me - br | 0, Ar = (Ur | 0) / 12 | 0, (me | 0) != (br | 0)) {
                        i: {
                          n: {
                            o: {
                              if (Ar >>> 0 >= 357913942) {
                                if (e[5996] = 0, jo(47), l = e[5996], e[5996] = 0, (l | 0) == 1)
                                  break o;
                                break e;
                              }
                              if (e[5996] = 0, me = no(3, Ur | 0) | 0, br = e[5996], e[5996] = 0, (br | 0) == 1)
                                break o;
                              if (e[ke + 48 >> 2] = me, e[ke + 44 >> 2] = me, e[ke + 52 >> 2] = me + No(Ar, 12), Ar = e[S + 4 >> 2], S = e[S >> 2], e[5996] = 0, S = mf(48, ke + 52 | 0, S | 0, Ar | 0, me | 0) | 0, Ar = e[5996], e[5996] = 0, (Ar | 0) != 1)
                                break i;
                              S = gi() | 0, e[ke + 48 >> 2] = me;
                              break n;
                            }
                            S = gi() | 0;
                          }
                          lh(ke + 80 | 0);
                          break r;
                        }
                        e[ke + 48 >> 2] = S;
                      }
                      e[ke + 40 >> 2] = 0, e[ke + 32 >> 2] = 0, e[ke + 36 >> 2] = 0, S = e[C + 4 >> 2], me = e[C >> 2], e[5996] = 0, Co(49, ke + 32 | 0, S - me >> 2), S = e[5996], e[5996] = 0;
                      i: {
                        if ((S | 0) != 1) {
                          if (S = e[ke + 48 >> 2], me = e[ke + 44 >> 2], (S | 0) == (me | 0))
                            break t;
                          S = me;
                          n: {
                            for (; ; ) {
                              o: {
                                if (e[ke + 28 >> 2] = 0, e[ke + 20 >> 2] = 0, e[ke + 24 >> 2] = 0, Ar = e[C + 4 >> 2], me = e[C >> 2], yn = No(lo, 12), S = yn + S | 0, Ar - me >> 2 != e[S + 4 >> 2] - e[S >> 2] >> 3)
                                  break o;
                                br = 0, Ri = 1, Xr = 0;
                                a: {
                                  if ((me | 0) != (Ar | 0)) {
                                    s: {
                                      A: {
                                        u: {
                                          for (; ; ) {
                                            if (S = Xr << 3, Ro = zo[S + e[ke + 68 >> 2] >> 3], Xo = zo[S + e[ke + 56 >> 2] >> 3], me = e[(Xr << 2) + me >> 2], e[5996] = 0, me = Ic(50, me | 0, +Xo, +Ro, y | 0) | 0, Ar = e[5996], e[5996] = 0, (Ar | 0) == 1)
                                              break A;
                                            if (S = S + e[yn + e[ke + 44 >> 2] >> 2] | 0, Ar = e[S >> 2], S = e[S + 4 >> 2], Ur = e[me + 4 >> 2], me = e[me >> 2], e[5996] = 0, Xf(51, ke + 80 | 0, me | 0, Ur | 0, Ar | 0, S | 0), S = e[5996], e[5996] = 0, (S | 0) != 1) {
                                              Ar = e[ke + 28 >> 2];
                                              h: {
                                                if (Ar >>> 0 > br >>> 0) {
                                                  e[br + 8 >> 2] = 0, e[br >> 2] = 0, e[br + 4 >> 2] = 0, e[br >> 2] = e[ke + 80 >> 2], e[br + 4 >> 2] = e[ke + 84 >> 2], e[br + 8 >> 2] = e[ke + 88 >> 2], e[ke + 24 >> 2] = br + 12;
                                                  break h;
                                                }
                                                c: {
                                                  me = e[ke + 20 >> 2], Ur = (br - me | 0) / 12 | 0, S = Ur + 1 | 0;
                                                  f: {
                                                    if (S >>> 0 >= 357913942) {
                                                      e[5996] = 0, jo(52);
                                                      break f;
                                                    }
                                                    if (Ar = (Ar - me | 0) / 12 | 0, Qr = Ar << 1, S = Ar >>> 0 >= 178956970 ? 357913941 : S >>> 0 < Qr >>> 0 ? Qr : S, S >>> 0 < 357913942)
                                                      break c;
                                                    e[5996] = 0, jo(35);
                                                  }
                                                  if (l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                    break e;
                                                  break u;
                                                }
                                                if (e[5996] = 0, Qr = No(S, 12), Ar = no(3, Qr | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                  break u;
                                                S = Ar + No(Ur, 12) | 0, e[S >> 2] = e[ke + 80 >> 2], e[S + 4 >> 2] = e[ke + 84 >> 2], e[S + 8 >> 2] = e[ke + 88 >> 2], e[ke + 88 >> 2] = 0, e[ke + 80 >> 2] = 0, e[ke + 84 >> 2] = 0, Ar = Ar + Qr | 0, Ur = S + 12 | 0;
                                                c: {
                                                  if ((me | 0) == (br | 0)) {
                                                    e[ke + 28 >> 2] = Ar, e[ke + 24 >> 2] = Ur, e[ke + 20 >> 2] = S;
                                                    break c;
                                                  }
                                                  for (; S = S - 12 | 0, br = br - 12 | 0, e[S >> 2] = e[br >> 2], e[S + 4 >> 2] = e[br + 4 >> 2], e[S + 8 >> 2] = e[br + 8 >> 2], e[br + 8 >> 2] = 0, e[br >> 2] = 0, e[br + 4 >> 2] = 0, (me | 0) != (br | 0); )
                                                    ;
                                                  if (e[ke + 28 >> 2] = Ar, me = e[ke + 24 >> 2], e[ke + 24 >> 2] = Ur, br = e[ke + 20 >> 2], e[ke + 20 >> 2] = S, (me | 0) == (br | 0))
                                                    break c;
                                                  for (; ; ) {
                                                    if (Qr = me - 12 | 0, Ur = e[Qr >> 2], Ur) {
                                                      if (En = me - 8 | 0, S = e[En >> 2], Ar = Ur, (S | 0) != (Ar | 0)) {
                                                        for (; ; ) {
                                                          S = S - 32 | 0, me = e[S + 4 >> 2];
                                                          f: {
                                                            if (!me || (Ar = e[me + 4 >> 2], e[me + 4 >> 2] = Ar - 1, Ar))
                                                              break f;
                                                            Yn[e[e[me >> 2] + 8 >> 2]](me), Ls(me);
                                                          }
                                                          if ((S | 0) == (Ur | 0))
                                                            break;
                                                        }
                                                        Ar = e[Qr >> 2];
                                                      }
                                                      e[En >> 2] = Ur, Tr(Ar);
                                                    }
                                                    if (me = Qr, (br | 0) == (me | 0))
                                                      break;
                                                  }
                                                }
                                                if (br && Tr(br), Ar = e[ke + 80 >> 2], !Ar)
                                                  break h;
                                                if (S = e[ke + 84 >> 2], me = Ar, (S | 0) != (me | 0)) {
                                                  for (; ; ) {
                                                    S = S - 32 | 0, me = e[S + 4 >> 2];
                                                    c: {
                                                      if (!me || (br = e[me + 4 >> 2], e[me + 4 >> 2] = br - 1, br))
                                                        break c;
                                                      Yn[e[e[me >> 2] + 8 >> 2]](me), Ls(me);
                                                    }
                                                    if ((S | 0) == (Ar | 0))
                                                      break;
                                                  }
                                                  me = e[ke + 80 >> 2];
                                                }
                                                e[ke + 84 >> 2] = Ar, Tr(me);
                                              }
                                              if (br = e[ke + 24 >> 2], S = br - 12 | 0, Ri = No(e[S + 4 >> 2] - e[S >> 2] >> 5, Ri), Xr = Xr + 1 | 0, me = e[C >> 2], Xr >>> 0 >= e[C + 4 >> 2] - me >> 2 >>> 0)
                                                break s;
                                              continue;
                                            }
                                            break;
                                          }
                                          S = gi() | 0;
                                          break n;
                                        }
                                        S = gi() | 0, Pc(ke + 80 | 0);
                                        break n;
                                      }
                                      S = gi() | 0;
                                      break n;
                                    }
                                    if (!Ri)
                                      break a;
                                  }
                                  Ur = 0;
                                  s: {
                                    A: {
                                      for (; ; ) {
                                        if (br = e[ke + 32 >> 2], e[C + 4 >> 2] != e[C >> 2])
                                          for (S = 0, Ar = e[ke + 20 >> 2], me = Ur; Qr = No(S, 12), Xr = Qr + Ar | 0, Ar = e[Xr >> 2], e[(S << 2) + br >> 2] = Ar + ((me >>> 0) % (e[Xr + 4 >> 2] - Ar >> 5 >>> 0) << 5), Xr = me, Ar = e[ke + 20 >> 2], me = Qr + Ar | 0, me = (Xr >>> 0) / (e[me + 4 >> 2] - e[me >> 2] >> 5 >>> 0) | 0, S = S + 1 | 0, S >>> 0 < e[C + 4 >> 2] - e[C >> 2] >> 2 >>> 0; )
                                            ;
                                        if (e[ke + 104 >> 2] = 0, e[ke + 96 >> 2] = 0, e[ke + 100 >> 2] = 0, S = br, yn = e[ke + 36 >> 2], (S | 0) != (yn | 0)) {
                                          u: {
                                            for (; ; ) {
                                              h: {
                                                Qr = e[br >> 2], S = e[ke + 100 >> 2];
                                                c: {
                                                  if ((S | 0) != e[ke + 104 >> 2]) {
                                                    e[S >> 2] = e[Qr >> 2], me = e[Qr + 4 >> 2], e[S + 4 >> 2] = me, me && (e[me + 4 >> 2] = e[me + 4 >> 2] + 1), e[ke + 100 >> 2] = S + 8;
                                                    break c;
                                                  }
                                                  f: {
                                                    Ar = e[ke + 96 >> 2], me = S - Ar | 0, En = me >> 3, Xr = En + 1 | 0;
                                                    p: {
                                                      if (Xr >>> 0 >= 536870912) {
                                                        e[5996] = 0, jo(59);
                                                        break p;
                                                      }
                                                      if (Wn = me >> 2, me = me >>> 0 >= 2147483640 ? 536870911 : Xr >>> 0 < Wn >>> 0 ? Wn : Xr, me >>> 0 < 536870912)
                                                        break f;
                                                      e[5996] = 0, jo(35);
                                                    }
                                                    if (l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                      break e;
                                                    S = gi() | 0;
                                                    break s;
                                                  }
                                                  if (e[5996] = 0, Wn = me << 3, Xr = no(3, Wn | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                    break h;
                                                  me = Xr + (En << 3) | 0, e[me >> 2] = e[Qr >> 2], Qr = e[Qr + 4 >> 2], e[me + 4 >> 2] = Qr, Qr && (e[Qr + 4 >> 2] = e[Qr + 4 >> 2] + 1, S = e[ke + 100 >> 2]), Qr = Xr + Wn | 0, Xr = me + 8 | 0;
                                                  f: {
                                                    if ((S | 0) == (Ar | 0)) {
                                                      e[ke + 104 >> 2] = Qr, e[ke + 100 >> 2] = Xr, e[ke + 96 >> 2] = me;
                                                      break f;
                                                    }
                                                    for (; me = me - 8 | 0, S = S - 8 | 0, e[me >> 2] = e[S >> 2], e[me + 4 >> 2] = e[S + 4 >> 2], e[S >> 2] = 0, e[S + 4 >> 2] = 0, (S | 0) != (Ar | 0); )
                                                      ;
                                                    if (e[ke + 104 >> 2] = Qr, S = e[ke + 100 >> 2], e[ke + 100 >> 2] = Xr, Ar = e[ke + 96 >> 2], e[ke + 96 >> 2] = me, (S | 0) == (Ar | 0))
                                                      break f;
                                                    for (; ; ) {
                                                      S = S - 8 | 0, me = e[S + 4 >> 2];
                                                      p: {
                                                        if (!me || (Qr = e[me + 4 >> 2], e[me + 4 >> 2] = Qr - 1, Qr))
                                                          break p;
                                                        Yn[e[e[me >> 2] + 8 >> 2]](me), Ls(me);
                                                      }
                                                      if ((S | 0) == (Ar | 0))
                                                        break;
                                                    }
                                                  }
                                                  if (!Ar)
                                                    break c;
                                                  Tr(Ar);
                                                }
                                                if (br = br + 4 | 0, (yn | 0) != (br | 0))
                                                  continue;
                                                break u;
                                              }
                                              break;
                                            }
                                            S = gi() | 0;
                                            break s;
                                          }
                                          br = e[ke + 36 >> 2], S = e[ke + 32 >> 2];
                                        }
                                        if (e[5996] = 0, Gf(63, ke + 80 | 0, I | 0, S | 0, br | 0, +Q), S = e[5996], e[5996] = 0, (S | 0) == 1 || (e[5996] = 0, Ar = no(3, 104) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1))
                                          break A;
                                        if (e[Ar >> 2] = 7e3, e[Ar + 4 >> 2] = 0, e[Ar + 8 >> 2] = 0, e[5996] = 0, e[ke + 116 >> 2] = e[ke + 96 >> 2], S = e[ke + 104 >> 2], me = e[ke + 100 >> 2], e[ke + 104 >> 2] = 0, e[ke + 120 >> 2] = me, e[ke + 124 >> 2] = S, e[ke + 96 >> 2] = 0, e[ke + 100 >> 2] = 0, Qr = mf(64, Ar + 12 | 0, I | 0, ke + 116 | 0, 0) | 0, S = e[5996], e[5996] = 0, (S | 0) != 1) {
                                          if (me = e[ke + 116 >> 2], me) {
                                            if (S = e[ke + 120 >> 2], (me | 0) != (S | 0)) {
                                              for (; ; ) {
                                                S = S - 8 | 0, br = e[S + 4 >> 2];
                                                u: {
                                                  if (!br || (Xr = e[br + 4 >> 2], e[br + 4 >> 2] = Xr - 1, Xr))
                                                    break u;
                                                  Yn[e[e[br >> 2] + 8 >> 2]](br), Ls(br);
                                                }
                                                if ((S | 0) == (me | 0))
                                                  break;
                                              }
                                              me = e[ke + 116 >> 2];
                                            }
                                            Tr(me);
                                          }
                                          if (e[ke + 112 >> 2] = Ar, e[ke + 108 >> 2] = Qr, e[5996] = 0, S = e[ke + 112 >> 2], e[ke + 8 >> 2] = e[ke + 108 >> 2], e[ke + 12 >> 2] = S, Ms(61, l | 0, ke + 80 | 0, ke + 8 | 0), S = e[5996], e[5996] = 0, (S | 0) == 1)
                                            break A;
                                          if (me = e[ke + 96 >> 2], me) {
                                            if (S = e[ke + 100 >> 2], (me | 0) != (S | 0)) {
                                              for (; ; ) {
                                                S = S - 8 | 0, Ar = e[S + 4 >> 2];
                                                u: {
                                                  if (!Ar || (br = e[Ar + 4 >> 2], e[Ar + 4 >> 2] = br - 1, br))
                                                    break u;
                                                  Yn[e[e[Ar >> 2] + 8 >> 2]](Ar), Ls(Ar);
                                                }
                                                if ((S | 0) == (me | 0))
                                                  break;
                                              }
                                              me = e[ke + 96 >> 2];
                                            }
                                            Tr(me);
                                          }
                                          if (Ur = Ur + 1 | 0, (Ri | 0) != (Ur | 0))
                                            continue;
                                          break a;
                                        }
                                        break;
                                      }
                                      S = gi() | 0, Za(ke + 116 | 0), Tr(Ar);
                                      break s;
                                    }
                                    S = gi() | 0;
                                  }
                                  Za(ke + 96 | 0);
                                  break n;
                                }
                                if (Ar = e[ke + 20 >> 2], Ar) {
                                  if (S = e[ke + 24 >> 2], (Ar | 0) != (S | 0)) {
                                    for (; ; ) {
                                      if (Ur = S - 12 | 0, br = e[Ur >> 2], br) {
                                        if (Qr = S - 8 | 0, S = e[Qr >> 2], me = br, (S | 0) != (me | 0)) {
                                          for (; ; ) {
                                            S = S - 32 | 0, me = e[S + 4 >> 2];
                                            a: {
                                              if (!me || (Ri = e[me + 4 >> 2], e[me + 4 >> 2] = Ri - 1, Ri))
                                                break a;
                                              Yn[e[e[me >> 2] + 8 >> 2]](me), Ls(me);
                                            }
                                            if ((S | 0) == (br | 0))
                                              break;
                                          }
                                          me = e[Ur >> 2];
                                        }
                                        e[Qr >> 2] = br, Tr(me);
                                      }
                                      if (S = Ur, (Ar | 0) == (S | 0))
                                        break;
                                    }
                                    Ar = e[ke + 20 >> 2];
                                  }
                                  Tr(Ar);
                                }
                                if (lo = lo + 1 | 0, S = e[ke + 44 >> 2], lo >>> 0 < (e[ke + 48 >> 2] - S | 0) / 12 >>> 0)
                                  continue;
                                break t;
                              }
                              break;
                            }
                            if (e[5996] = 0, ia(44, 5170, 1900, 642, 2497), l = e[5996], e[5996] = 0, (l | 0) != 1)
                              break e;
                            S = gi() | 0;
                          }
                          qc(ke + 20 | 0);
                          break i;
                        }
                        S = gi() | 0;
                      }
                      l = e[ke + 32 >> 2], l && Tr(l), Hh(ke + 44 | 0);
                      break r;
                    }
                    S = gi() | 0;
                  }
                  ph(ke + 56 | 0), ss(S | 0), jn();
                }
                if (l = e[ke + 32 >> 2], l && (Tr(l), S = e[ke + 44 >> 2]), S) {
                  if (me = S, Ar = e[ke + 48 >> 2], (Ar | 0) != (S | 0)) {
                    for (; l = Ar - 12 | 0, y = e[l >> 2], y && (e[Ar - 8 >> 2] = y, Tr(y)), Ar = l, (Ar | 0) != (S | 0); )
                      ;
                    me = e[ke + 44 >> 2];
                  }
                  e[ke + 48 >> 2] = S, Tr(me);
                }
                l = e[ke + 68 >> 2], l && (e[ke + 72 >> 2] = l, Tr(l)), l = e[ke + 56 >> 2], l && (e[ke + 60 >> 2] = l, Tr(l)), bi = ke + 128 | 0;
                return;
              }
              jn();
            }
            function nl(l, y, I, C, Q, S, me, ke, Ar, br, Qr) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0, me = me | 0, ke = ke | 0, Ar = Ar | 0, br = br | 0, Qr = Qr | 0;
              var Ur = 0, Xr = 0, Ri = 0, yn = 0, En = 0, Wn = 0, lo = 0, Ro = 0, Xo = 0, bs = 0, Os = 0, Gs = 0, aa = 0;
              Ur = bi - 528 | 0, bi = Ur, e[Ur + 520 >> 2] = Qr, e[Ur + 524 >> 2] = y;
              e: {
                t: {
                  if (Dc(l, Ur + 524 | 0)) {
                    e[S >> 2] = e[S >> 2] | 4, l = 0;
                    break t;
                  }
                  if (e[Ur + 72 >> 2] = 220, Xo = Ur + 104 | 0, e[Xo >> 2] = Ur + 112, Ro = Ur + 72 | 0, e[Xo + 4 >> 2] = e[Ro >> 2], yn = e[Xo >> 2], e[Ur + 100 >> 2] = yn, e[Ur + 96 >> 2] = yn + 400, e[Ro >> 2] = 0, e[Ro + 4 >> 2] = 0, e[Ro + 8 >> 2] = 0, En = Ur + 60 | 0, e[En >> 2] = 0, e[En + 4 >> 2] = 0, e[En + 8 >> 2] = 0, Xr = Ur + 48 | 0, e[Xr >> 2] = 0, e[Xr + 4 >> 2] = 0, e[Xr + 8 >> 2] = 0, Ri = Ur + 36 | 0, e[Ri >> 2] = 0, e[Ri + 4 >> 2] = 0, e[Ri + 8 >> 2] = 0, Wn = Ur + 24 | 0, e[Wn >> 2] = 0, e[Wn + 4 >> 2] = 0, e[Wn + 8 >> 2] = 0, y = e[C >> 2], e[5996] = 0, gs(229, I | 0, y | 0, Ur + 92 | 0, Ur + 88 | 0, Ur + 84 | 0, Ro | 0, En | 0, Xr | 0, Ri | 0, Ur + 20 | 0), y = e[5996], e[5996] = 0, (y | 0) != 1)
                    for (e[br >> 2] = e[Ar >> 2], Os = Q & 512, bs = e[Ur + 20 >> 2], Q = 0; ; ) {
                      r: {
                        i: {
                          n: {
                            o: {
                              a: {
                                if ((Q | 0) == 4)
                                  break a;
                                if (e[5996] = 0, y = wn(202, l | 0, Ur + 524 | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                  break e;
                                if (y)
                                  break a;
                                s: {
                                  A: {
                                    u: {
                                      h: {
                                        c:
                                          switch (Se[(Ur + 92 | 0) + Q | 0]) {
                                            case 1:
                                              if ((Q | 0) == 3)
                                                break r;
                                              if (y = e[l >> 2], e[5996] = 0, y = no(203, y | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1 || (e[5996] = 0, y = Ko(230, ke | 0, 1, y | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1))
                                                break e;
                                              if (y) {
                                                if (e[5996] = 0, Co(231, Ur + 12 | 0, l | 0), y = e[5996], e[5996] = 0, (y | 0) != 1 && (e[5996] = 0, Co(232, Wn | 0, e[Ur + 12 >> 2]), y = e[5996], e[5996] = 0, (y | 0) != 1))
                                                  break h;
                                                break e;
                                              }
                                              e[S >> 2] = e[S >> 2] | 4, l = 0;
                                              break i;
                                            case 4:
                                              break s;
                                            case 2:
                                              break A;
                                            case 3:
                                              break u;
                                            case 0:
                                              break c;
                                            default:
                                              break r;
                                          }
                                        if ((Q | 0) == 3)
                                          break r;
                                      }
                                      for (; ; ) {
                                        if (e[5996] = 0, y = wn(202, l | 0, Ur + 524 | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                          break e;
                                        if (y)
                                          break r;
                                        if (y = e[l >> 2], e[5996] = 0, y = no(203, y | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1 || (e[5996] = 0, y = Ko(230, ke | 0, 1, y | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1))
                                          break e;
                                        if (!y)
                                          break r;
                                        if (e[5996] = 0, Co(231, Ur + 12 | 0, l | 0), y = e[5996], e[5996] = 0, !((y | 0) != 1 && (e[5996] = 0, Co(232, Wn | 0, e[Ur + 12 >> 2]), y = e[5996], e[5996] = 0, (y | 0) != 1)))
                                          break;
                                      }
                                      break e;
                                    }
                                    u: {
                                      if (y = Je[Xr + 11 | 0], !((y & 128) >>> 7 | 0 ? e[Xr + 4 >> 2] : y & 127))
                                        break u;
                                      if (y = e[l >> 2], e[5996] = 0, y = no(203, y | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                        break e;
                                      if (e[((Je[Xr + 11 | 0] & 128) >>> 7 | 0 ? e[Xr >> 2] : Xr) >> 2] != (y | 0))
                                        break u;
                                      if (e[5996] = 0, no(205, l | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                        break e;
                                      Se[me | 0] = 0, y = Je[Xr + 11 | 0], lo = ((y & 128) >>> 7 | 0 ? e[Xr + 4 >> 2] : y & 127) >>> 0 > 1 ? Xr : lo;
                                      break r;
                                    }
                                    u: {
                                      h: {
                                        if (Qr = e[Ri + 4 >> 2], y = Je[Ri + 11 | 0], (y & 128) >>> 7 | 0 ? Qr : y & 127) {
                                          if (y = e[l >> 2], e[5996] = 0, y = no(203, y | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                            break e;
                                          if (e[((Je[Ri + 11 | 0] & 128) >>> 7 | 0 ? e[Ri >> 2] : Ri) >> 2] == (y | 0))
                                            break h;
                                          Qr = e[Ri + 4 >> 2], y = Je[Ri + 11 | 0];
                                        }
                                        if (I = Je[Xr + 11 | 0], I = (I & 128) >>> 7 | 0 ? e[Xr + 4 >> 2] : I & 127, !I | !((y & 128) >>> 7 | 0 ? Qr : y & 127))
                                          break u;
                                        e[S >> 2] = e[S >> 2] | 4, l = 0;
                                        break i;
                                      }
                                      if (e[5996] = 0, no(205, l | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                        break e;
                                      Se[me | 0] = 1, y = Je[Ri + 11 | 0], lo = ((y & 128) >>> 7 | 0 ? e[Ri + 4 >> 2] : y & 127) >>> 0 > 1 ? Ri : lo;
                                      break r;
                                    }
                                    if (y = (y & 128) >>> 7 | 0 ? Qr : y & 127, !(y | I))
                                      break r;
                                    Se[me | 0] = !y;
                                    break r;
                                  }
                                  if (!(lo | Q >>> 0 < 2 | ((Q | 0) == 2 & Je[Ur + 95 | 0] != 0 | Os))) {
                                    lo = 0;
                                    break r;
                                  }
                                  e[Ur + 12 >> 2] = lc(En);
                                  A: {
                                    if (!Q | Je[(Q + Ur | 0) + 91 | 0] > 1)
                                      break A;
                                    u: {
                                      for (; ; ) {
                                        if (I = hu(En), y = e[Ur + 12 >> 2], (I | 0) == (y | 0))
                                          break u;
                                        if (y = e[y >> 2], e[5996] = 0, y = Ko(230, ke | 0, 1, y | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) != 1) {
                                          if (!y)
                                            break u;
                                          e[Ur + 12 >> 2] = e[Ur + 12 >> 2] + 4;
                                          continue;
                                        }
                                        break;
                                      }
                                      break e;
                                    }
                                    if (y = lc(En), y = e[Ur + 12 >> 2] - y >> 2, I = Je[Wn + 11 | 0], y >>> 0 <= ((I & 128) >>> 7 | 0 ? e[Wn + 4 >> 2] : I & 127) >>> 0) {
                                      for (I = T1(hu(Wn), 0 - y | 0), C = hu(Wn), Qr = lc(En), y = bi - 16 | 0, bi = y, e[y + 8 >> 2] = Qr, e[y + 12 >> 2] = I; ; ) {
                                        if (Qr = (I | 0) != (C | 0), !(!Qr | e[I >> 2] != e[e[y + 8 >> 2] >> 2])) {
                                          e[y + 12 >> 2] = e[y + 12 >> 2] + 4, e[y + 8 >> 2] = e[y + 8 >> 2] + 4, I = e[y + 12 >> 2];
                                          continue;
                                        }
                                        break;
                                      }
                                      if (bi = y + 16 | 0, !Qr)
                                        break A;
                                    }
                                    e[Ur + 8 >> 2] = lc(En), e[Ur + 12 >> 2] = e[Ur + 8 >> 2];
                                  }
                                  e[Ur + 8 >> 2] = e[Ur + 12 >> 2];
                                  A: {
                                    for (; ; ) {
                                      if ((hu(En) | 0) == e[Ur + 8 >> 2])
                                        break A;
                                      e[5996] = 0, y = wn(202, l | 0, Ur + 524 | 0) | 0, I = e[5996], e[5996] = 0;
                                      u: {
                                        if ((I | 0) == 1)
                                          break u;
                                        if (y)
                                          break A;
                                        if (y = e[l >> 2], e[5996] = 0, y = no(203, y | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                          break u;
                                        if (e[e[Ur + 8 >> 2] >> 2] != (y | 0))
                                          break A;
                                        if (e[5996] = 0, no(205, l | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                          break e;
                                        e[Ur + 8 >> 2] = e[Ur + 8 >> 2] + 4;
                                        continue;
                                      }
                                      break;
                                    }
                                    break e;
                                  }
                                  if (!Os || (hu(En) | 0) == e[Ur + 8 >> 2])
                                    break r;
                                  e[S >> 2] = e[S >> 2] | 4, l = 0;
                                  break i;
                                }
                                y = 0, Gs = e[Ur + 84 >> 2], I = yn;
                                s: {
                                  for (; ; ) {
                                    A: {
                                      if (e[5996] = 0, C = wn(202, l | 0, Ur + 524 | 0) | 0, Qr = e[5996], e[5996] = 0, (Qr | 0) == 1)
                                        break A;
                                      if (C)
                                        break s;
                                      if (C = e[l >> 2], e[5996] = 0, Qr = no(203, C | 0) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1 || (e[5996] = 0, C = Ko(230, ke | 0, 64, Qr | 0) | 0, aa = e[5996], e[5996] = 0, (aa | 0) == 1))
                                        break e;
                                      u: {
                                        if (C) {
                                          if (C = e[br >> 2], (C | 0) == e[Ur + 520 >> 2]) {
                                            if (e[5996] = 0, Ms(233, Ar | 0, br | 0, Ur + 520 | 0), C = e[5996], e[5996] = 0, (C | 0) == 1)
                                              break e;
                                            C = e[br >> 2];
                                          }
                                          e[br >> 2] = C + 4, e[C >> 2] = Qr, y = y + 1 | 0;
                                          break u;
                                        }
                                        if (C = Je[Ro + 11 | 0], !((C & 128) >>> 7 | 0 ? e[Ro + 4 >> 2] : C & 127) | !y | (Qr | 0) != (Gs | 0))
                                          break s;
                                        if (e[Ur + 96 >> 2] == (yn | 0)) {
                                          if (e[5996] = 0, Ms(226, Xo | 0, Ur + 100 | 0, Ur + 96 | 0), I = e[5996], e[5996] = 0, (I | 0) == 1)
                                            break e;
                                          yn = e[Ur + 100 >> 2];
                                        }
                                        I = yn + 4 | 0, e[Ur + 100 >> 2] = I, e[yn >> 2] = y, yn = I, y = 0;
                                      }
                                      if (e[5996] = 0, no(205, l | 0) | 0, C = e[5996], e[5996] = 0, (C | 0) != 1)
                                        continue;
                                    }
                                    break;
                                  }
                                  break e;
                                }
                                if (!y | e[Xo >> 2] == (I | 0))
                                  break o;
                                if (e[Ur + 96 >> 2] == (I | 0)) {
                                  if (e[5996] = 0, Ms(226, Xo | 0, Ur + 100 | 0, Ur + 96 | 0), I = e[5996], e[5996] = 0, (I | 0) == 1)
                                    break e;
                                  I = e[Ur + 100 >> 2];
                                }
                                yn = I + 4 | 0, e[Ur + 100 >> 2] = yn, e[I >> 2] = y;
                                break n;
                              }
                              e[Ur + 20 >> 2] = bs;
                              a: {
                                if (!lo)
                                  break a;
                                for (Qr = 1; ; ) {
                                  if (y = Je[lo + 11 | 0], ((y & 128) >>> 7 | 0 ? e[lo + 4 >> 2] : y & 127) >>> 0 <= Qr >>> 0)
                                    break a;
                                  e[5996] = 0, y = wn(202, l | 0, Ur + 524 | 0) | 0, I = e[5996], e[5996] = 0;
                                  s: {
                                    if ((I | 0) == 1)
                                      break s;
                                    A: {
                                      if (!y) {
                                        if (y = e[l >> 2], e[5996] = 0, y = no(203, y | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                          break s;
                                        if (e[(Qr << 2) + ((Je[lo + 11 | 0] & 128) >>> 7 | 0 ? e[lo >> 2] : lo) >> 2] == (y | 0))
                                          break A;
                                      }
                                      e[S >> 2] = e[S >> 2] | 4, l = 0;
                                      break i;
                                    }
                                    if (e[5996] = 0, no(205, l | 0) | 0, y = e[5996], e[5996] = 0, Qr = Qr + 1 | 0, (y | 0) != 1)
                                      continue;
                                  }
                                  break;
                                }
                                break e;
                              }
                              if (l = 1, y = e[Xo >> 2], (y | 0) == (yn | 0))
                                break i;
                              if (l = 0, e[Ur + 12 >> 2] = 0, bf(Ro, y, yn, Ur + 12 | 0), e[Ur + 12 >> 2]) {
                                e[S >> 2] = e[S >> 2] | 4;
                                break i;
                              }
                              l = 1;
                              break i;
                            }
                            yn = I;
                          }
                          n: {
                            if ((bs | 0) <= 0)
                              break n;
                            if (e[5996] = 0, y = wn(202, l | 0, Ur + 524 | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                              break e;
                            o: {
                              if (!y) {
                                if (y = e[l >> 2], e[5996] = 0, y = no(203, y | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                  break e;
                                if (e[Ur + 88 >> 2] == (y | 0))
                                  break o;
                              }
                              e[S >> 2] = e[S >> 2] | 4, l = 0;
                              break i;
                            }
                            if (e[5996] = 0, y = no(205, l | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                              break e;
                            for (; ; ) {
                              if ((bs | 0) <= 0) {
                                bs = 0;
                                break n;
                              }
                              e[5996] = 0, I = wn(202, y | 0, Ur + 524 | 0) | 0, C = e[5996], e[5996] = 0;
                              o: {
                                if ((C | 0) == 1)
                                  break o;
                                a: {
                                  if (!I) {
                                    if (I = e[y >> 2], e[5996] = 0, I = no(203, I | 0) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1 || (e[5996] = 0, I = Ko(230, ke | 0, 64, I | 0) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1))
                                      break o;
                                    if (I)
                                      break a;
                                  }
                                  e[S >> 2] = e[S >> 2] | 4, l = 0;
                                  break i;
                                }
                                if (e[br >> 2] == e[Ur + 520 >> 2] && (e[5996] = 0, Ms(233, Ar | 0, br | 0, Ur + 520 | 0), I = e[5996], e[5996] = 0, (I | 0) == 1) || (I = e[y >> 2], e[5996] = 0, I = no(203, I | 0) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1))
                                  break o;
                                if (C = e[br >> 2], e[br >> 2] = C + 4, e[C >> 2] = I, e[5996] = 0, no(205, y | 0) | 0, I = e[5996], e[5996] = 0, bs = bs - 1 | 0, (I | 0) != 1)
                                  continue;
                              }
                              break;
                            }
                            break e;
                          }
                          if (e[br >> 2] != e[Ar >> 2])
                            break r;
                          e[S >> 2] = e[S >> 2] | 4, l = 0;
                        }
                        Yo(Wn), Yo(Ri), Yo(Xr), Yo(En), Yo(Ro), ka(Xo);
                        break t;
                      }
                      Q = Q + 1 | 0;
                    }
                  break e;
                }
                return bi = Ur + 528 | 0, l | 0;
              }
              l = gi() | 0, Yo(Wn), Yo(Ri), Yo(Xr), Yo(En), Yo(Ro), ka(Xo), ss(l | 0), jn();
            }
            function Gu(l, y, I, C, Q, S, me, ke, Ar, br, Qr) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0, me = me | 0, ke = ke | 0, Ar = Ar | 0, br = br | 0, Qr = Qr | 0;
              var Ur = 0, Xr = 0, Ri = 0, yn = 0, En = 0, Wn = 0, lo = 0, Ro = 0, Xo = 0, bs = 0, Os = 0, Gs = 0, aa = 0, Ma = 0, rf = 0;
              Ur = bi - 528 | 0, bi = Ur, e[Ur + 520 >> 2] = Qr, e[Ur + 524 >> 2] = y;
              e: {
                t: {
                  if (Tc(l, Ur + 524 | 0)) {
                    e[S >> 2] = e[S >> 2] | 4, l = 0;
                    break t;
                  }
                  if (e[Ur + 76 >> 2] = 220, Xo = Ur + 104 | 0, e[Xo >> 2] = Ur + 112, Ro = Ur + 76 | 0, e[Xo + 4 >> 2] = e[Ro >> 2], yn = e[Xo >> 2], e[Ur + 100 >> 2] = yn, e[Ur + 96 >> 2] = yn + 400, e[Ro >> 2] = 0, e[Ro + 4 >> 2] = 0, e[Ro + 8 >> 2] = 0, En = Ur - -64 | 0, e[En >> 2] = 0, e[En + 4 >> 2] = 0, e[En + 8 >> 2] = 0, Xr = Ur + 52 | 0, e[Xr >> 2] = 0, e[Xr + 4 >> 2] = 0, e[Xr + 8 >> 2] = 0, Ri = Ur + 40 | 0, e[Ri >> 2] = 0, e[Ri + 4 >> 2] = 0, e[Ri + 8 >> 2] = 0, Wn = Ur + 28 | 0, e[Wn >> 2] = 0, e[Wn + 4 >> 2] = 0, e[Wn + 8 >> 2] = 0, y = e[C >> 2], e[5996] = 0, gs(223, I | 0, y | 0, Ur + 92 | 0, Ur + 91 | 0, Ur + 90 | 0, Ro | 0, En | 0, Xr | 0, Ri | 0, Ur + 24 | 0), y = e[5996], e[5996] = 0, (y | 0) != 1)
                    for (e[br >> 2] = e[Ar >> 2], Gs = Q & 512, bs = e[Ur + 24 >> 2], aa = Je[Ur + 95 | 0], Ma = Je[Ur + 91 | 0], rf = Je[Ur + 90 | 0], C = yn, Q = 0; ; ) {
                      r: {
                        i: {
                          n: {
                            o: {
                              if ((Q | 0) == 4)
                                break o;
                              if (e[5996] = 0, y = wn(186, l | 0, Ur + 524 | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                break e;
                              if (y)
                                break o;
                              y = 0;
                              a: {
                                s: {
                                  A: {
                                    u: {
                                      h:
                                        switch (Se[(Ur + 92 | 0) + Q | 0]) {
                                          case 1:
                                            if ((Q | 0) == 3)
                                              break r;
                                            if (y = e[l >> 2], e[5996] = 0, y = no(187, y | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                              break e;
                                            if (I = e[ke + 8 >> 2], e[I + ((y & 255) << 2) >> 2] & 1 & (y | 0) >= 0) {
                                              if (e[5996] = 0, Co(224, Ur + 16 | 0, l | 0), y = e[5996], e[5996] = 0, (y | 0) != 1 && (e[5996] = 0, Co(98, Wn | 0, Se[Ur + 16 | 0]), y = e[5996], e[5996] = 0, (y | 0) != 1))
                                                break u;
                                              break e;
                                            }
                                            e[S >> 2] = e[S >> 2] | 4, l = 0;
                                            break i;
                                          case 4:
                                            break a;
                                          case 2:
                                            break s;
                                          case 3:
                                            break A;
                                          case 0:
                                            break h;
                                          default:
                                            break r;
                                        }
                                      if ((Q | 0) == 3)
                                        break r;
                                    }
                                    for (; ; ) {
                                      if (e[5996] = 0, y = wn(186, l | 0, Ur + 524 | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                        break e;
                                      if (y)
                                        break r;
                                      if (y = e[l >> 2], e[5996] = 0, y = no(187, y | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                        break e;
                                      if (I = e[ke + 8 >> 2], !(e[I + ((y & 255) << 2) >> 2] & 1 & (y | 0) >= 0))
                                        break r;
                                      if (e[5996] = 0, Co(224, Ur + 16 | 0, l | 0), y = e[5996], e[5996] = 0, !((y | 0) != 1 && (e[5996] = 0, Co(98, Wn | 0, Se[Ur + 16 | 0]), y = e[5996], e[5996] = 0, (y | 0) != 1)))
                                        break;
                                    }
                                    break e;
                                  }
                                  A: {
                                    if (y = Je[Xr + 11 | 0], !((y & 128) >>> 7 | 0 ? e[Xr + 4 >> 2] : y & 127))
                                      break A;
                                    if (y = e[l >> 2], e[5996] = 0, y = no(187, y | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                      break e;
                                    if (Je[((Je[Xr + 11 | 0] & 128) >>> 7 | 0 ? e[Xr >> 2] : Xr) | 0] != (y & 255))
                                      break A;
                                    if (e[5996] = 0, no(189, l | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                      break e;
                                    Se[me | 0] = 0, y = Je[Xr + 11 | 0], lo = ((y & 128) >>> 7 | 0 ? e[Xr + 4 >> 2] : y & 127) >>> 0 > 1 ? Xr : lo;
                                    break r;
                                  }
                                  A: {
                                    u: {
                                      if (Qr = e[Ri + 4 >> 2], y = Je[Ri + 11 | 0], (y & 128) >>> 7 | 0 ? Qr : y & 127) {
                                        if (y = e[l >> 2], e[5996] = 0, y = no(187, y | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                          break e;
                                        if (Je[((Je[Ri + 11 | 0] & 128) >>> 7 | 0 ? e[Ri >> 2] : Ri) | 0] == (y & 255))
                                          break u;
                                        Qr = e[Ri + 4 >> 2], y = Je[Ri + 11 | 0];
                                      }
                                      if (I = Je[Xr + 11 | 0], I = (I & 128) >>> 7 | 0 ? e[Xr + 4 >> 2] : I & 127, !I | !((y & 128) >>> 7 | 0 ? Qr : y & 127))
                                        break A;
                                      e[S >> 2] = e[S >> 2] | 4, l = 0;
                                      break i;
                                    }
                                    if (e[5996] = 0, no(189, l | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                      break e;
                                    Se[me | 0] = 1, y = Je[Ri + 11 | 0], lo = ((y & 128) >>> 7 | 0 ? e[Ri + 4 >> 2] : y & 127) >>> 0 > 1 ? Ri : lo;
                                    break r;
                                  }
                                  if (y = (y & 128) >>> 7 | 0 ? Qr : y & 127, !(y | I))
                                    break r;
                                  Se[me | 0] = !y;
                                  break r;
                                }
                                if (!(lo | Q >>> 0 < 2 | ((Q | 0) == 2 & (aa | 0) != 0 | Gs))) {
                                  lo = 0;
                                  break r;
                                }
                                e[Ur + 16 >> 2] = lc(En);
                                s: {
                                  if (!Q | Je[(Q + Ur | 0) + 91 | 0] > 1)
                                    break s;
                                  for (; ; ) {
                                    A: {
                                      if (I = lu(En), y = e[Ur + 16 >> 2], (I | 0) == (y | 0) || (I = e[ke + 8 >> 2], y = Se[y | 0], (y | 0) >= 0 ? y = e[I + ((y & 255) << 2) >> 2] & 1 : y = 0, !y))
                                        break A;
                                      e[Ur + 16 >> 2] = e[Ur + 16 >> 2] + 1;
                                      continue;
                                    }
                                    break;
                                  }
                                  if (y = lc(En), y = e[Ur + 16 >> 2] - y | 0, I = Je[Wn + 11 | 0], y >>> 0 <= ((I & 128) >>> 7 | 0 ? e[Wn + 4 >> 2] : I & 127) >>> 0) {
                                    for (I = D1(lu(Wn), 0 - y | 0), Qr = lu(Wn), Os = lc(En), y = bi - 16 | 0, bi = y, e[y + 8 >> 2] = Os, e[y + 12 >> 2] = I; ; ) {
                                      if (Os = (I | 0) != (Qr | 0), !(!Os | Je[I | 0] != Je[e[y + 8 >> 2]])) {
                                        e[y + 12 >> 2] = e[y + 12 >> 2] + 1, e[y + 8 >> 2] = e[y + 8 >> 2] + 1, I = e[y + 12 >> 2];
                                        continue;
                                      }
                                      break;
                                    }
                                    if (bi = y + 16 | 0, !Os)
                                      break s;
                                  }
                                  e[Ur + 12 >> 2] = lc(En), e[Ur + 16 >> 2] = e[Ur + 12 >> 2];
                                }
                                e[Ur + 12 >> 2] = e[Ur + 16 >> 2];
                                s: {
                                  for (; ; ) {
                                    if ((lu(En) | 0) == e[Ur + 12 >> 2])
                                      break s;
                                    e[5996] = 0, y = wn(186, l | 0, Ur + 524 | 0) | 0, I = e[5996], e[5996] = 0;
                                    A: {
                                      if ((I | 0) == 1)
                                        break A;
                                      if (y)
                                        break s;
                                      if (y = e[l >> 2], e[5996] = 0, y = no(187, y | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                        break A;
                                      if (Je[e[Ur + 12 >> 2]] != (y & 255))
                                        break s;
                                      if (e[5996] = 0, no(189, l | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                        break e;
                                      e[Ur + 12 >> 2] = e[Ur + 12 >> 2] + 1;
                                      continue;
                                    }
                                    break;
                                  }
                                  break e;
                                }
                                if (!Gs || (lu(En) | 0) == e[Ur + 12 >> 2])
                                  break r;
                                e[S >> 2] = e[S >> 2] | 4, l = 0;
                                break i;
                              }
                              a: {
                                for (; ; ) {
                                  s: {
                                    if (e[5996] = 0, I = wn(186, l | 0, Ur + 524 | 0) | 0, Qr = e[5996], e[5996] = 0, (Qr | 0) == 1)
                                      break s;
                                    if (I)
                                      break a;
                                    if (I = e[l >> 2], e[5996] = 0, Qr = no(187, I | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                      break e;
                                    I = e[ke + 8 >> 2];
                                    A: {
                                      if ((Qr | 0) >= 0 && e[I + ((Qr & 255) << 2) >> 2] & 64) {
                                        if (I = e[br >> 2], (I | 0) == e[Ur + 520 >> 2]) {
                                          if (e[5996] = 0, Ms(225, Ar | 0, br | 0, Ur + 520 | 0), I = e[5996], e[5996] = 0, (I | 0) == 1)
                                            break e;
                                          I = e[br >> 2];
                                        }
                                        e[br >> 2] = I + 1, Se[I | 0] = Qr, y = y + 1 | 0;
                                        break A;
                                      }
                                      if (I = Je[Ro + 11 | 0], !((I & 128) >>> 7 | 0 ? e[Ro + 4 >> 2] : I & 127) | !y | (Qr & 255) != (rf | 0))
                                        break a;
                                      if (e[Ur + 96 >> 2] == (C | 0)) {
                                        if (e[5996] = 0, Ms(226, Xo | 0, Ur + 100 | 0, Ur + 96 | 0), I = e[5996], e[5996] = 0, (I | 0) == 1)
                                          break e;
                                        C = e[Ur + 100 >> 2];
                                      }
                                      yn = C + 4 | 0, e[Ur + 100 >> 2] = yn, e[C >> 2] = y, C = yn, y = 0;
                                    }
                                    if (e[5996] = 0, no(189, l | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) != 1)
                                      continue;
                                  }
                                  break;
                                }
                                break e;
                              }
                              if (!(!y | e[Xo >> 2] == (yn | 0))) {
                                if (e[Ur + 96 >> 2] == (yn | 0)) {
                                  if (e[5996] = 0, Ms(226, Xo | 0, Ur + 100 | 0, Ur + 96 | 0), I = e[5996], e[5996] = 0, (I | 0) == 1)
                                    break e;
                                  yn = e[Ur + 100 >> 2];
                                }
                                I = yn + 4 | 0, e[Ur + 100 >> 2] = I, e[yn >> 2] = y, yn = I;
                              }
                              if ((bs | 0) <= 0)
                                break n;
                              if (e[5996] = 0, y = wn(186, l | 0, Ur + 524 | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                break e;
                              a: {
                                if (!y) {
                                  if (y = e[l >> 2], e[5996] = 0, y = no(187, y | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                    break e;
                                  if ((y & 255) == (Ma | 0))
                                    break a;
                                }
                                e[S >> 2] = e[S >> 2] | 4, l = 0;
                                break i;
                              }
                              if (e[5996] = 0, y = no(189, l | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                break e;
                              for (; ; ) {
                                if ((bs | 0) <= 0) {
                                  bs = 0;
                                  break n;
                                }
                                e[5996] = 0, I = wn(186, y | 0, Ur + 524 | 0) | 0, C = e[5996], e[5996] = 0;
                                a: {
                                  if ((C | 0) == 1)
                                    break a;
                                  s: {
                                    if (!I) {
                                      if (I = e[y >> 2], e[5996] = 0, I = no(187, I | 0) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                        break a;
                                      if (C = e[ke + 8 >> 2], (I | 0) >= 0 && e[C + ((I & 255) << 2) >> 2] & 64)
                                        break s;
                                    }
                                    e[S >> 2] = e[S >> 2] | 4, l = 0;
                                    break i;
                                  }
                                  if (e[br >> 2] == e[Ur + 520 >> 2] && (e[5996] = 0, Ms(225, Ar | 0, br | 0, Ur + 520 | 0), I = e[5996], e[5996] = 0, (I | 0) == 1) || (I = e[y >> 2], e[5996] = 0, I = no(187, I | 0) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1))
                                    break a;
                                  if (C = e[br >> 2], e[br >> 2] = C + 1, Se[C | 0] = I, e[5996] = 0, no(189, y | 0) | 0, I = e[5996], e[5996] = 0, bs = bs - 1 | 0, (I | 0) != 1)
                                    continue;
                                }
                                break;
                              }
                              break e;
                            }
                            e[Ur + 24 >> 2] = bs;
                            o: {
                              if (!lo)
                                break o;
                              for (Qr = 1; ; ) {
                                if (y = Je[lo + 11 | 0], ((y & 128) >>> 7 | 0 ? e[lo + 4 >> 2] : y & 127) >>> 0 <= Qr >>> 0)
                                  break o;
                                e[5996] = 0, y = wn(186, l | 0, Ur + 524 | 0) | 0, I = e[5996], e[5996] = 0;
                                a: {
                                  if ((I | 0) == 1)
                                    break a;
                                  s: {
                                    if (!y) {
                                      if (y = e[l >> 2], e[5996] = 0, y = no(187, y | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                        break a;
                                      if (Je[((Je[lo + 11 | 0] & 128) >>> 7 | 0 ? e[lo >> 2] : lo) + Qr | 0] == (y & 255))
                                        break s;
                                    }
                                    e[S >> 2] = e[S >> 2] | 4, l = 0;
                                    break i;
                                  }
                                  if (e[5996] = 0, no(189, l | 0) | 0, y = e[5996], e[5996] = 0, Qr = Qr + 1 | 0, (y | 0) != 1)
                                    continue;
                                }
                                break;
                              }
                              break e;
                            }
                            if (l = 1, y = e[Xo >> 2], (y | 0) == (yn | 0))
                              break i;
                            if (l = 0, e[Ur + 16 >> 2] = 0, bf(Ro, y, yn, Ur + 16 | 0), e[Ur + 16 >> 2]) {
                              e[S >> 2] = e[S >> 2] | 4;
                              break i;
                            }
                            l = 1;
                            break i;
                          }
                          if (C = yn, e[br >> 2] != e[Ar >> 2])
                            break r;
                          e[S >> 2] = e[S >> 2] | 4, l = 0;
                        }
                        Yo(Wn), Yo(Ri), Yo(Xr), Yo(En), Yo(Ro), ka(Xo);
                        break t;
                      }
                      Q = Q + 1 | 0;
                    }
                  break e;
                }
                return bi = Ur + 528 | 0, l | 0;
              }
              l = gi() | 0, Yo(Wn), Yo(Ri), Yo(Xr), Yo(En), Yo(Ro), ka(Xo), ss(l | 0), jn();
            }
            function ol(l, y) {
              l = l | 0, y = y | 0;
              var I = 0, C = 0, Q = 0, S = 0, me = 0, ke = 0, Ar = 0, br = 0, Qr = 0, Ur = 0, Xr = 0, Ri = 0, yn = 0, En = 0, Wn = 0, lo = 0, Ro = 0;
              e: {
                t: {
                  r: {
                    i: {
                      n: {
                        o: {
                          a:
                            switch (e[y >> 2]) {
                              case 0:
                                e[l + 12 >> 2] = 1, e[l + 16 >> 2] = 0, e[l + 4 >> 2] = 0, e[l + 8 >> 2] = 0, e[l >> 2] = 0;
                                return;
                              case 2:
                                e[l + 12 >> 2] = 1, e[l + 16 >> 2] = 0;
                                break t;
                              case 3:
                                e[l + 12 >> 2] = 1, e[l + 16 >> 2] = 0, e[l + 4 >> 2] = 1, e[l + 8 >> 2] = 0, e[l >> 2] = 3;
                                return;
                              case 4:
                              case 5:
                                e[l + 12 >> 2] = 0, e[l + 16 >> 2] = 0, e[l + 4 >> 2] = 1, e[l + 8 >> 2] = 0, e[l >> 2] = 1;
                                return;
                              case 6:
                              case 7:
                              case 8:
                              case 9:
                                e[l + 12 >> 2] = 0, e[l + 16 >> 2] = 0, e[l + 4 >> 2] = 1, e[l + 8 >> 2] = 0, e[l >> 2] = 4;
                                return;
                              case 17:
                                y = e[y + 32 >> 2], I = e[y + 8 >> 2], ke = e[I + 52 >> 2], y = e[y >> 2], S = e[y + 52 >> 2], Q = Je[y + 48 | 0], me = Je[I + 48 | 0], I = e[I + 44 >> 2], y = e[y + 44 >> 2], e[l + 12 >> 2] = 0, e[l + 16 >> 2] = 0, e[l >> 2] = y + I;
                                break e;
                              case 18:
                                y = e[y + 32 >> 2], Xr = e[y + 8 >> 2], ke = e[Xr + 52 >> 2], br = e[y >> 2], S = e[br + 52 >> 2], Q = Je[br + 48 | 0], me = Je[Xr + 48 | 0], Ar = e[Xr + 60 >> 2], C = e[br + 60 >> 2], I = Je[br + 56 | 0], y = Je[Xr + 56 | 0], e[l >> 2] = (e[br + 44 >> 2] + e[Xr + 44 >> 2] | 0) + 1, I = (I | 0) != 0 & (y | 0) != 0, y = I & 0, e[l + 12 >> 2] = y | I, e[l + 16 >> 2] = I ? C + Ar | 0 : 0;
                                break e;
                              case 19:
                                y = e[y + 32 >> 2], ke = e[y >> 2], me = e[ke + 60 >> 2], S = Je[ke + 56 | 0] != 0, I = e[y + 8 >> 2], Ur = S & Je[I + 48 | 0] != 0, Q = Ur ? me + e[I + 52 >> 2] | 0 : 0, y = (e[ke + 44 >> 2] + e[I + 44 >> 2] | 0) + 1 | 0, Ar = e[I + 60 >> 2], C = Je[I + 56 | 0], !Je[ke + 48 | 0] | !C || (I = Ar + e[ke + 52 >> 2] | 0, Q = Ur ? I >>> 0 > Q >>> 0 ? I : Q : I, Ur = 1), e[l >> 2] = y, e[l + 4 >> 2] = Ur, e[l + 8 >> 2] = Q, Q = S & (C | 0) != 0, y = Q & 0, e[l + 12 >> 2] = y | Q, e[l + 16 >> 2] = Q ? me + Ar | 0 : 0;
                                return;
                              case 21:
                                y = e[y + 32 >> 2], I = e[y >> 2], br = e[I + 60 >> 2], Xr = e[y + 8 >> 2], Q = br + e[Xr + 52 >> 2] | 0, ke = Je[I + 56 | 0], y = Je[Xr + 48 | 0] != 0 & (ke | 0) != 0, me = (e[I + 44 >> 2] + e[Xr + 44 >> 2] | 0) + 3 | 0, C = y ? Q : 0;
                                s: {
                                  if (!Je[I + 48 | 0])
                                    break s;
                                  if (!y) {
                                    y = e[I + 48 >> 2], S = y & -256, C = e[I + 52 >> 2];
                                    break s;
                                  }
                                  y = 1, I = e[I + 52 >> 2], C = I >>> 0 > Q >>> 0 ? I : Q;
                                }
                                Ar = e[Xr + 60 >> 2], Q = Je[Xr + 56 | 0], e[l >> 2] = me, I = y & 255, y = 0, e[l + 4 >> 2] = I | (S | y), e[l + 8 >> 2] = C | En, I = (ke | 0) != 0 & (Q | 0) != 0, y = I ? y : 0, e[l + 12 >> 2] = y | I, e[l + 16 >> 2] = I ? Ar + br | 0 : 0;
                                return;
                              case 20:
                                y = e[y + 32 >> 2], Ar = e[y >> 2], I = e[y + 8 >> 2], C = e[Ar + 60 >> 2] + e[I + 52 >> 2] | 0, y = Je[I + 48 | 0] != 0 & Je[Ar + 56 | 0] != 0, Q = (e[Ar + 44 >> 2] + e[I + 44 >> 2] | 0) + 2 | 0, I = y ? C : 0;
                                s: {
                                  if (!Je[Ar + 48 | 0])
                                    break s;
                                  if (!y) {
                                    y = e[Ar + 48 >> 2], S = y & -256, I = e[Ar + 52 >> 2];
                                    break s;
                                  }
                                  y = 1, I = e[Ar + 52 >> 2], I = I >>> 0 > C >>> 0 ? I : C;
                                }
                                e[l + 12 >> 2] = 0, e[l + 16 >> 2] = 0, e[l >> 2] = Q, e[l + 4 >> 2] = S | y & 255, e[l + 8 >> 2] = I | En;
                                return;
                              case 22:
                                y = e[y + 32 >> 2], C = e[y >> 2], br = e[y + 8 >> 2], S = e[C + 44 >> 2] + e[br + 44 >> 2] | 0;
                                s: {
                                  if (!Je[C + 48 | 0]) {
                                    y = e[br + 48 >> 2], ke = y & -256, Q = e[br + 52 >> 2];
                                    break s;
                                  }
                                  if (!Je[br + 48 | 0]) {
                                    y = e[C + 48 >> 2], ke = y & -256, Q = e[C + 52 >> 2];
                                    break s;
                                  }
                                  y = 1, Q = e[C + 52 >> 2], I = e[br + 52 >> 2], Q = I >>> 0 < Q >>> 0 ? Q : I;
                                }
                                Ar = S + 3 | 0;
                                s: {
                                  if (!Je[C + 56 | 0]) {
                                    S = e[br + 56 >> 2], me = S & -256, I = e[br + 60 >> 2];
                                    break s;
                                  }
                                  if (!Je[br + 56 | 0]) {
                                    S = e[C + 56 >> 2], me = S & -256, I = e[C + 60 >> 2];
                                    break s;
                                  }
                                  S = 1, C = e[C + 60 >> 2], I = e[br + 60 >> 2], I = I >>> 0 < C >>> 0 ? C : I;
                                }
                                e[l >> 2] = Ar, e[l + 12 >> 2] = S & 255 | me & -256, C = 0, e[l + 16 >> 2] = C | (I | C), e[l + 4 >> 2] = y & 255 | ke & -256, S = 0, e[l + 8 >> 2] = S | (Q | S);
                                return;
                              case 23:
                                y = e[y + 32 >> 2], ke = e[y + 16 >> 2], S = e[y >> 2], me = e[S + 60 >> 2], Ar = Je[S + 56 | 0] != 0, C = Ar & Je[ke + 48 | 0] != 0, Q = C ? e[ke + 52 >> 2] + me | 0 : 0, y = e[y + 8 >> 2], I = (e[ke + 44 >> 2] + (e[S + 44 >> 2] + e[y + 44 >> 2] | 0) | 0) + 3 | 0, !Je[y + 48 | 0] | !Je[S + 48 | 0] || (y = e[S + 52 >> 2] + e[y + 52 >> 2] | 0, Q = C ? y >>> 0 > Q >>> 0 ? y : Q : y, C = 1), S = e[ke + 60 >> 2], y = Je[ke + 56 | 0], e[l >> 2] = I, e[l + 4 >> 2] = C, e[l + 8 >> 2] = Q, Q = Ar & (y | 0) != 0, y = Q & 0, e[l + 12 >> 2] = y | Q, e[l + 16 >> 2] = Q ? S + me | 0 : 0;
                                return;
                              case 25:
                                I = e[y + 12 >> 2], y = e[y + 8 >> 2], e[l >> 2] = 1, y = (I - y | 0) / 12 | 0, I = 1, e[l + 12 >> 2] = I, e[l + 16 >> 2] = y, e[l + 4 >> 2] = I, e[l + 8 >> 2] = y;
                                return;
                              case 11:
                              case 12:
                              case 16:
                                C = e[e[y + 32 >> 2] >> 2], S = e[C + 48 >> 2], Q = e[C + 52 >> 2], I = e[C + 44 >> 2], y = e[C + 60 >> 2], e[l + 12 >> 2] = e[C + 56 >> 2], e[l + 16 >> 2] = y, e[l + 4 >> 2] = S, e[l + 8 >> 2] = Q, e[l >> 2] = I + 1;
                                return;
                              case 10:
                                C = e[e[y + 32 >> 2] >> 2], S = e[C + 48 >> 2], Q = e[C + 52 >> 2], I = e[C + 44 >> 2], y = e[C + 60 >> 2], e[l + 12 >> 2] = e[C + 56 >> 2], e[l + 16 >> 2] = y, e[l + 4 >> 2] = S, e[l + 8 >> 2] = Q, e[l >> 2] = I + 2;
                                return;
                              case 13:
                                y = e[e[y + 32 >> 2] >> 2], Q = e[y + 48 >> 2], I = e[y + 52 >> 2], y = e[y + 44 >> 2], e[l + 12 >> 2] = 1, e[l + 16 >> 2] = 0, e[l + 4 >> 2] = Q, e[l + 8 >> 2] = I, e[l >> 2] = y + 3;
                                return;
                              case 15:
                                y = e[e[y + 32 >> 2] >> 2], Q = e[y + 48 >> 2], I = e[y + 52 >> 2], y = e[y + 44 >> 2], e[l + 12 >> 2] = 1, e[l + 16 >> 2] = 0, e[l + 4 >> 2] = Q, e[l + 8 >> 2] = I, e[l >> 2] = y + 4;
                                return;
                              case 14:
                                I = e[e[y + 32 >> 2] >> 2], C = e[I + 44 >> 2], S = e[I + 80 >> 2], Q = Mr(1239, 1), y = e[e[y + 32 >> 2] >> 2], I = e[y + 48 >> 2], y = e[y + 52 >> 2], e[l + 12 >> 2] = 0, e[l + 16 >> 2] = 0, e[l + 4 >> 2] = I, e[l + 8 >> 2] = y, e[l >> 2] = C + !(Q & (S ^ -1));
                                return;
                              case 24:
                                if (I = ga(8), e[I >> 2] = 1, e[I + 4 >> 2] = 0, Ur = I + 8 | 0, Ri = e[y + 32 >> 2], En = e[y + 36 >> 2], (Ri | 0) != (En | 0))
                                  for (; ; ) {
                                    Q = e[Ri >> 2], ke = e[Q + 60 >> 2], me = Je[Q + 56 | 0], C = e[I + 4 >> 2], Ar = I, S = Je[I | 0], Xr = e[Q + 44 >> 2], e[5996] = 0, Q = no(3, 8) | 0, I = e[5996], e[5996] = 0;
                                    s: {
                                      A: {
                                        if ((I | 0) != 1) {
                                          if (I = C + ke | 0, C = (S | 0) != 0 & (me | 0) != 0, S = C & 0, e[Q >> 2] = C | S, e[Q + 4 >> 2] = C ? I : 0, me = Q + 8 | 0, I = Ur - Ar | 0, lo = I >> 3, I >>> 0 >= 9)
                                            break A;
                                          S = me;
                                          break s;
                                        }
                                        S = gi() | 0, I = Ar;
                                        break n;
                                      }
                                      for (br = lo >>> 0 <= 2 ? 2 : lo, Ur = 1, S = me; ; ) {
                                        Wn = e[Ri >> 2], I = Ar + (Ur << 3) | 0, Qr = e[Wn + 60 >> 2] + e[I + 4 >> 2] | 0, C = I - 8 | 0, yn = Je[C | 0] != 0 & Je[Wn + 48 | 0] != 0, ke = Je[I | 0] != 0 & Je[Wn + 56 | 0] != 0, I = ke ? Qr : 0, C = yn ? e[Wn + 52 >> 2] + e[C + 4 >> 2] | 0 : 0, I = ke ? yn ? I >>> 0 > C >>> 0 ? I : C : Qr : C, yn = ke | yn;
                                        A: {
                                          if (S >>> 0 < me >>> 0) {
                                            e[S >> 2] = yn, e[S + 4 >> 2] = I, C = S;
                                            break A;
                                          }
                                          if (ke = S - Q >> 3, Qr = ke + 1 | 0, Qr >>> 0 >= 536870912) {
                                            if (e[5996] = 0, jo(93), l = e[5996], e[5996] = 0, (l | 0) == 1)
                                              break o;
                                            break r;
                                          }
                                          me = me - Q | 0, C = me >> 2, Qr = me >>> 0 >= 2147483640 ? 536870911 : C >>> 0 > Qr >>> 0 ? C : Qr;
                                          u: {
                                            if (!Qr) {
                                              me = 0;
                                              break u;
                                            }
                                            if (Qr >>> 0 >= 536870912) {
                                              if (e[5996] = 0, jo(35), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                break r;
                                              break o;
                                            }
                                            if (e[5996] = 0, me = no(3, Qr << 3) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                              break o;
                                          }
                                          C = (ke << 3) + me | 0, e[C >> 2] = yn, e[C + 4 >> 2] = I, me = (Qr << 3) + me | 0, I = C;
                                          u: {
                                            if ((Q | 0) != (S | 0)) {
                                              for (; S = S - 8 | 0, ke = e[S + 4 >> 2], I = I - 8 | 0, e[I >> 2] = e[S >> 2], e[I + 4 >> 2] = ke, (Q | 0) != (S | 0); )
                                                ;
                                              if (!Q)
                                                break u;
                                            }
                                            Tr(Q);
                                          }
                                          Q = I;
                                        }
                                        if (S = C + 8 | 0, Ur = Ur + 1 | 0, (br | 0) == (Ur | 0))
                                          break;
                                      }
                                    }
                                    C = (Ar + (lo << 3) | 0) - 8 | 0, I = e[Ri >> 2], Qr = Je[C | 0] != 0 & Je[I + 48 | 0] != 0, C = Qr ? e[I + 52 >> 2] + e[C + 4 >> 2] | 0 : 0;
                                    s: {
                                      if (S >>> 0 < me >>> 0) {
                                        e[S >> 2] = Qr, e[S + 4 >> 2] = C, Ur = S + 8 | 0, I = Q;
                                        break s;
                                      }
                                      A: {
                                        u: {
                                          ke = S - Q >> 3, br = ke + 1 | 0;
                                          h: {
                                            if (br >>> 0 >= 536870912) {
                                              e[5996] = 0, jo(93);
                                              break h;
                                            }
                                            if (me = me - Q | 0, I = me >> 2, I = me >>> 0 >= 2147483640 ? 536870911 : I >>> 0 > br >>> 0 ? I : br, !I) {
                                              I = 0;
                                              break A;
                                            }
                                            if (I >>> 0 < 536870912)
                                              break u;
                                            e[5996] = 0, jo(35);
                                          }
                                          if (l = e[5996], e[5996] = 0, (l | 0) != 1)
                                            break r;
                                          break o;
                                        }
                                        if (e[5996] = 0, I = no(3, I << 3) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                          break o;
                                      }
                                      if (I = (ke << 3) + I | 0, e[I >> 2] = Qr, e[I + 4 >> 2] = C, Ur = I + 8 | 0, (Q | 0) != (S | 0)) {
                                        for (; S = S - 8 | 0, C = e[S + 4 >> 2], I = I - 8 | 0, e[I >> 2] = e[S >> 2], e[I + 4 >> 2] = C, (Q | 0) != (S | 0); )
                                          ;
                                        if (!Q)
                                          break s;
                                      }
                                      Tr(Q);
                                    }
                                    if (Ro = (Xr + Ro | 0) + 1 | 0, Tr(Ar), Ri = Ri + 8 | 0, (En | 0) == (Ri | 0))
                                      break;
                                  }
                                if (y = e[y + 4 >> 2], y >>> 0 <= Ur - I >> 3 >>> 0) {
                                  y = (y << 3) + I | 0, S = e[y >> 2], Q = e[y + 4 >> 2], y = e[I + 4 >> 2], e[l + 12 >> 2] = e[I >> 2], e[l + 16 >> 2] = y, e[l + 4 >> 2] = S, e[l + 8 >> 2] = Q, e[l >> 2] = Ro, Tr(I);
                                  return;
                                }
                                if (e[5996] = 0, ia(44, 5118, 2210, 799, 1422), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                  break r;
                                if (S = gi() | 0, !I)
                                  break i;
                                break n;
                              default:
                                Nf(2350, 2210, 803, 1422), jn();
                              case 1:
                                break a;
                            }
                          e[l + 12 >> 2] = 0, e[l + 16 >> 2] = 0;
                          break t;
                        }
                        if (S = gi() | 0, !Q) {
                          I = Ar;
                          break n;
                        }
                        Tr(Q), I = Ar;
                      }
                      Tr(I);
                    }
                    ss(S | 0), jn();
                  }
                  jn();
                }
                e[l + 4 >> 2] = 1, e[l + 8 >> 2] = 0, e[l >> 2] = 0;
                return;
              }
              Q = (Q | 0) != 0 & (me | 0) != 0, y = Q & 0, e[l + 4 >> 2] = y | Q, e[l + 8 >> 2] = Q ? S + ke | 0 : 0;
            }
            function Zr(l, y, I) {
              l = l | 0, y = y | 0, I = I | 0;
              var C = 0, Q = 0, S = 0, me = 0, ke = 0;
              Q = bi - 80 | 0, bi = Q, C = ga(32), e[Q + 68 >> 2] = C, e[Q + 72 >> 2] = 19, e[Q + 76 >> 2] = -2147483616, S = Je[5568] | Je[5569] << 8 | (Je[5570] << 16 | Je[5571] << 24), Se[C + 15 | 0] = S, Se[C + 16 | 0] = S >>> 8, Se[C + 17 | 0] = S >>> 16, Se[C + 18 | 0] = S >>> 24, S = Je[5565] | Je[5566] << 8 | (Je[5567] << 16 | Je[5568] << 24), me = Je[5561] | Je[5562] << 8 | (Je[5563] << 16 | Je[5564] << 24), Se[C + 8 | 0] = me, Se[C + 9 | 0] = me >>> 8, Se[C + 10 | 0] = me >>> 16, Se[C + 11 | 0] = me >>> 24, Se[C + 12 | 0] = S, Se[C + 13 | 0] = S >>> 8, Se[C + 14 | 0] = S >>> 16, Se[C + 15 | 0] = S >>> 24, S = Je[5557] | Je[5558] << 8 | (Je[5559] << 16 | Je[5560] << 24), me = Je[5553] | Je[5554] << 8 | (Je[5555] << 16 | Je[5556] << 24), Se[C | 0] = me, Se[C + 1 | 0] = me >>> 8, Se[C + 2 | 0] = me >>> 16, Se[C + 3 | 0] = me >>> 24, Se[C + 4 | 0] = S, Se[C + 5 | 0] = S >>> 8, Se[C + 6 | 0] = S >>> 16, Se[C + 7 | 0] = S >>> 24, Se[C + 19 | 0] = 0;
              e: {
                t: {
                  r: {
                    i: {
                      n: {
                        o: {
                          a: {
                            s: {
                              A: {
                                u: {
                                  h: {
                                    c: {
                                      f: {
                                        p: {
                                          d: {
                                            g: {
                                              C = e[e[y >> 2] + 80 >> 2];
                                              v: {
                                                if (!C) {
                                                  if (e[5996] = 0, wn(97, Q + 68 | 0, 2603) | 0, C = e[5996], e[5996] = 0, (C | 0) != 1)
                                                    break v;
                                                  break t;
                                                }
                                                if (e[5996] = 0, S = wn(54, 3557, 1) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                  break g;
                                                if (!((C ^ -1) & S) && (e[5996] = 0, Co(98, Q + 68 | 0, 66), C = e[5996], e[5996] = 0, (C | 0) == 1))
                                                  break t;
                                                if (C = e[e[y >> 2] + 80 >> 2], e[5996] = 0, S = wn(54, 2796, 1) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                  break d;
                                                if (!((C ^ -1) & S) && (e[5996] = 0, Co(98, Q + 68 | 0, 86), C = e[5996], e[5996] = 0, (C | 0) == 1))
                                                  break t;
                                                if (C = e[e[y >> 2] + 80 >> 2], e[5996] = 0, S = wn(54, 2777, 1) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                  break p;
                                                if (!((C ^ -1) & S) && (e[5996] = 0, Co(98, Q + 68 | 0, 87), C = e[5996], e[5996] = 0, (C | 0) == 1))
                                                  break t;
                                                if (C = e[e[y >> 2] + 80 >> 2], e[5996] = 0, S = wn(54, 3310, 1) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                  break f;
                                                if (!((C ^ -1) & S) && (e[5996] = 0, Co(98, Q + 68 | 0, 75), C = e[5996], e[5996] = 0, (C | 0) == 1))
                                                  break t;
                                                if (C = e[e[y >> 2] + 80 >> 2], e[5996] = 0, S = wn(54, 1029, 1) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                  break c;
                                                if (!((C ^ -1) & S) && (e[5996] = 0, Co(98, Q + 68 | 0, 122), C = e[5996], e[5996] = 0, (C | 0) == 1))
                                                  break t;
                                                if (C = e[e[y >> 2] + 80 >> 2], e[5996] = 0, S = wn(54, 1959, 1) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                  break h;
                                                if (!((C ^ -1) & S) && (e[5996] = 0, Co(98, Q + 68 | 0, 111), C = e[5996], e[5996] = 0, (C | 0) == 1))
                                                  break t;
                                                if (C = e[e[y >> 2] + 80 >> 2], e[5996] = 0, S = wn(54, 2029, 1) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                  break u;
                                                if (!((C ^ -1) & S) && (e[5996] = 0, Co(98, Q + 68 | 0, 110), C = e[5996], e[5996] = 0, (C | 0) == 1))
                                                  break t;
                                                if (C = e[e[y >> 2] + 80 >> 2], e[5996] = 0, S = wn(54, 2522, 1) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                  break A;
                                                if (!((C ^ -1) & S) && (e[5996] = 0, Co(98, Q + 68 | 0, 100), C = e[5996], e[5996] = 0, (C | 0) == 1))
                                                  break t;
                                                if (C = e[e[y >> 2] + 80 >> 2], e[5996] = 0, S = wn(54, 2315, 1) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                  break s;
                                                if (!((C ^ -1) & S) && (e[5996] = 0, Co(98, Q + 68 | 0, 102), C = e[5996], e[5996] = 0, (C | 0) == 1))
                                                  break t;
                                                if (C = e[e[y >> 2] + 80 >> 2], e[5996] = 0, S = wn(54, 2451, 1) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                  break a;
                                                if (!((C ^ -1) & S) && (e[5996] = 0, Co(98, Q + 68 | 0, 101), C = e[5996], e[5996] = 0, (C | 0) == 1))
                                                  break t;
                                                if (C = e[e[y >> 2] + 80 >> 2], e[5996] = 0, S = wn(54, 2049, 1) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                  break o;
                                                if (!((C ^ -1) & S) && (e[5996] = 0, Co(98, Q + 68 | 0, 109), C = e[5996], e[5996] = 0, (C | 0) == 1))
                                                  break t;
                                                if (C = e[e[y >> 2] + 80 >> 2], e[5996] = 0, S = wn(54, 1295, 1) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                  break n;
                                                if (!((C ^ -1) & S) && (e[5996] = 0, Co(98, Q + 68 | 0, 117), C = e[5996], e[5996] = 0, (C | 0) == 1))
                                                  break t;
                                                if (C = e[e[y >> 2] + 80 >> 2], e[5996] = 0, S = wn(54, 1681, 1) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                  break i;
                                                if (!((C ^ -1) & S) && (e[5996] = 0, Co(98, Q + 68 | 0, 115), C = e[5996], e[5996] = 0, (C | 0) == 1))
                                                  break t;
                                                if (C = e[e[y >> 2] + 80 >> 2], e[5996] = 0, S = wn(54, 2165, 1) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                  break r;
                                                if ((C ^ -1) & S)
                                                  break v;
                                                if (e[5996] = 0, Co(98, Q + 68 | 0, 107), C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                  break t;
                                              }
                                              C = e[e[y >> 2] + 84 >> 2], e[5996] = 0, S = Q + 44 | 0, Co(115, S | 0, C | 0), C = e[5996], e[5996] = 0;
                                              v: {
                                                _: {
                                                  R: {
                                                    k: {
                                                      S: {
                                                        E: {
                                                          w: {
                                                            I: {
                                                              l: {
                                                                T: {
                                                                  m: {
                                                                    C: {
                                                                      D: {
                                                                        b: {
                                                                          B: {
                                                                            if ((C | 0) != 1) {
                                                                              if (e[5996] = 0, C = Ko(99, S | 0, 0, 5487) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                break B;
                                                                              if (e[Q - -64 >> 2] = e[C + 8 >> 2], S = e[C + 4 >> 2], e[Q + 56 >> 2] = e[C >> 2], e[Q + 60 >> 2] = S, e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[C + 8 >> 2] = 0, e[5996] = 0, S = Je[Q + 67 | 0], me = S << 24 >> 24 < 0, S = Ko(100, Q + 68 | 0, (me ? e[Q + 56 >> 2] : Q + 56 | 0) | 0, (me ? e[Q + 60 >> 2] : S) | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                                                break b;
                                                                              if (Se[Q + 67 | 0] < 0 && Tr(e[Q + 56 >> 2]), Se[C + 11 | 0] < 0 && Tr(e[C >> 2]), C = e[y >> 2], me = e[C + 52 >> 2], C = e[C + 44 >> 2], e[5996] = 0, ke = Q + 32 | 0, Co(164, ke | 0, C + me | 0), C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                                break C;
                                                                              if (e[5996] = 0, C = Ko(99, ke | 0, 0, 5459) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                                                break m;
                                                                              if (e[Q - -64 >> 2] = e[C + 8 >> 2], me = e[C + 4 >> 2], e[Q + 56 >> 2] = e[C >> 2], e[Q + 60 >> 2] = me, e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[C + 8 >> 2] = 0, e[5996] = 0, ke = S, S = Je[Q + 67 | 0], me = S << 24 >> 24 < 0, S = Ko(100, ke | 0, (me ? e[Q + 56 >> 2] : Q + 56 | 0) | 0, (me ? e[Q + 60 >> 2] : S) | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                                                                break T;
                                                                              if (Se[Q + 67 | 0] < 0 && Tr(e[Q + 56 >> 2]), Se[C + 11 | 0] < 0 && Tr(e[C >> 2]), y = e[e[y >> 2] + 68 >> 2], e[5996] = 0, C = Q + 20 | 0, Co(164, C | 0, y + 1 | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                break I;
                                                                              if (e[5996] = 0, y = Ko(99, C | 0, 0, 5524) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                                                                                break w;
                                                                              if (e[Q - -64 >> 2] = e[y + 8 >> 2], C = e[y + 4 >> 2], e[Q + 56 >> 2] = e[y >> 2], e[Q + 60 >> 2] = C, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, e[5996] = 0, ke = S, C = Je[Q + 67 | 0], S = C << 24 >> 24 < 0, C = Ko(100, ke | 0, (S ? e[Q + 56 >> 2] : Q + 56 | 0) | 0, (S ? e[Q + 60 >> 2] : C) | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                break E;
                                                                              if (Se[Q + 67 | 0] < 0 && Tr(e[Q + 56 >> 2]), Se[y + 11 | 0] < 0 && Tr(e[y >> 2]), e[5996] = 0, C = wn(97, C | 0, 3759) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                break k;
                                                                              if (e[Q + 16 >> 2] = e[C + 8 >> 2], y = e[C + 4 >> 2], e[Q + 8 >> 2] = e[C >> 2], e[Q + 12 >> 2] = y, e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[C + 8 >> 2] = 0, S = e[I >> 2], me = e[I + 4 >> 2], y = Je[I + 11 | 0], e[5996] = 0, ke = I, I = y << 24 >> 24 < 0, y = Ko(100, Q + 8 | 0, (I ? S : ke) | 0, (I ? me : y) | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                                                                break R;
                                                                              if (e[Q - -64 >> 2] = e[y + 8 >> 2], I = e[y + 4 >> 2], e[Q + 56 >> 2] = e[y >> 2], e[Q + 60 >> 2] = I, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, e[5996] = 0, I = wn(97, Q + 56 | 0, 3559) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                break _;
                                                                              S = e[I + 4 >> 2], e[l >> 2] = e[I >> 2], e[l + 4 >> 2] = S, e[l + 8 >> 2] = e[I + 8 >> 2], e[I >> 2] = 0, e[I + 4 >> 2] = 0, e[I + 8 >> 2] = 0, Se[y + 11 | 0] < 0 && Tr(e[y >> 2]), Se[C + 11 | 0] < 0 && Tr(e[C >> 2]), bi = Q + 80 | 0;
                                                                              return;
                                                                            }
                                                                            y = gi() | 0;
                                                                            break e;
                                                                          }
                                                                          y = gi() | 0;
                                                                          break D;
                                                                        }
                                                                        if (y = gi() | 0, Se[Q + 67 | 0] >= 0)
                                                                          break D;
                                                                        Tr(e[Q + 56 >> 2]);
                                                                      }
                                                                      if (Se[Q + 55 | 0] >= 0)
                                                                        break e;
                                                                      Tr(e[Q + 44 >> 2]);
                                                                      break e;
                                                                    }
                                                                    y = gi() | 0;
                                                                    break e;
                                                                  }
                                                                  y = gi() | 0;
                                                                  break l;
                                                                }
                                                                if (y = gi() | 0, Se[Q + 67 | 0] >= 0)
                                                                  break l;
                                                                Tr(e[Q + 56 >> 2]);
                                                              }
                                                              if (Se[Q + 43 | 0] >= 0)
                                                                break e;
                                                              Tr(e[Q + 32 >> 2]);
                                                              break e;
                                                            }
                                                            y = gi() | 0;
                                                            break e;
                                                          }
                                                          y = gi() | 0;
                                                          break S;
                                                        }
                                                        if (y = gi() | 0, Se[Q + 67 | 0] >= 0)
                                                          break S;
                                                        Tr(e[Q + 56 >> 2]);
                                                      }
                                                      if (Se[Q + 31 | 0] >= 0)
                                                        break e;
                                                      Tr(e[Q + 20 >> 2]);
                                                      break e;
                                                    }
                                                    y = gi() | 0;
                                                    break e;
                                                  }
                                                  y = gi() | 0;
                                                  break v;
                                                }
                                                if (y = gi() | 0, Se[Q + 67 | 0] >= 0)
                                                  break v;
                                                Tr(e[Q + 56 >> 2]);
                                              }
                                              if (Se[Q + 19 | 0] >= 0)
                                                break e;
                                              Tr(e[Q + 8 >> 2]);
                                              break e;
                                            }
                                            y = gi() | 0;
                                            break e;
                                          }
                                          y = gi() | 0;
                                          break e;
                                        }
                                        y = gi() | 0;
                                        break e;
                                      }
                                      y = gi() | 0;
                                      break e;
                                    }
                                    y = gi() | 0;
                                    break e;
                                  }
                                  y = gi() | 0;
                                  break e;
                                }
                                y = gi() | 0;
                                break e;
                              }
                              y = gi() | 0;
                              break e;
                            }
                            y = gi() | 0;
                            break e;
                          }
                          y = gi() | 0;
                          break e;
                        }
                        y = gi() | 0;
                        break e;
                      }
                      y = gi() | 0;
                      break e;
                    }
                    y = gi() | 0;
                    break e;
                  }
                  y = gi() | 0;
                  break e;
                }
                y = gi() | 0;
              }
              Se[Q + 79 | 0] < 0 && Tr(e[Q + 68 >> 2]), ss(y | 0), jn();
            }
            function Jc(l, y, I, C, Q, S) {
              l = l | 0, y = +y, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0;
              var me = 0, ke = 0, Ar = 0, br = 0, Qr = 0, Ur = 0, Xr = 0, Ri = 0, yn = 0, En = 0, Wn = 0, lo = 0, Ro = 0, Xo = 0, bs = 0, Os = 0, Gs = 0, aa = 0, Ma = 0;
              Xr = bi - 560 | 0, bi = Xr, e[Xr + 44 >> 2] = 0, Ta(+y), me = oa(1) | 0, oa(0) | 0;
              e: {
                if ((me | 0) < 0) {
                  Ro = 1, Gs = 1222, y = -y, Ta(+y), me = oa(1) | 0, oa(0) | 0;
                  break e;
                }
                if (Q & 2048) {
                  Ro = 1, Gs = 1225;
                  break e;
                }
                Ro = Q & 1, Gs = Ro ? 1228 : 1223, Ma = !Ro;
              }
              e: {
                if ((me & 2146435072) == 2146435072) {
                  me = Ro + 3 | 0, Lf(l, 32, I, me, Q & -65537), Of(l, Gs, Ro), C = S & 32, Of(l, y != y ? C ? 2020 : 3082 : C ? 2300 : 3355, 3), Lf(l, 32, I, me, Q ^ 8192), yn = (I | 0) < (me | 0) ? me : I;
                  break e;
                }
                bs = Xr + 16 | 0;
                t: {
                  r: {
                    i: {
                      if (y = ad(y, Xr + 44 | 0), y = y + y, y != 0) {
                        if (me = e[Xr + 44 >> 2], e[Xr + 44 >> 2] = me - 1, Os = S | 32, (Os | 0) != 97)
                          break i;
                        break t;
                      }
                      if (Os = S | 32, (Os | 0) == 97)
                        break t;
                      br = e[Xr + 44 >> 2], Ur = (C | 0) < 0 ? 6 : C;
                      break r;
                    }
                    br = me - 29 | 0, e[Xr + 44 >> 2] = br, y = y * 268435456, Ur = (C | 0) < 0 ? 6 : C;
                  }
                  for (Wn = (Xr + 48 | 0) + ((br | 0) >= 0 ? 288 : 0) | 0, ke = Wn; y < 4294967296 & y >= 0 ? C = ~~y >>> 0 : C = 0, e[ke >> 2] = C, ke = ke + 4 | 0, y = (y - +(C >>> 0)) * 1e9, y != 0; )
                    ;
                  r: {
                    if ((br | 0) <= 0) {
                      C = br, me = ke, Ar = Wn;
                      break r;
                    }
                    for (Ar = Wn, C = br; ; ) {
                      Qr = (C | 0) >= 29 ? 29 : C, me = ke - 4 | 0;
                      i: {
                        if (Ar >>> 0 > me >>> 0)
                          break i;
                        for (Ri = 0; C = e[me >> 2], yn = Qr & 31, aa = Ri, (Qr & 63) >>> 0 >= 32 ? (Ri = C << yn, C = 0) : (Ri = (1 << yn) - 1 & C >>> 32 - yn, C = C << yn), yn = aa + C | 0, Ri = Ri + En | 0, Ri = wc(yn, C >>> 0 > yn >>> 0 ? Ri + 1 | 0 : Ri, 1e9), C = Ua(Ri, Ci, -1e9, 0) + yn | 0, e[me >> 2] = C, me = me - 4 | 0, Ar >>> 0 <= me >>> 0; )
                          ;
                        if (!Ri)
                          break i;
                        Ar = Ar - 4 | 0, e[Ar >> 2] = Ri;
                      }
                      for (; me = ke, Ar >>> 0 < me >>> 0 && (ke = me - 4 | 0, !e[ke >> 2]); )
                        ;
                      if (C = e[Xr + 44 >> 2] - Qr | 0, e[Xr + 44 >> 2] = C, ke = me, !((C | 0) > 0))
                        break;
                    }
                  }
                  if ((C | 0) < 0)
                    for (Xo = ((Ur + 25 >>> 0) / 9 | 0) + 1 | 0, En = (Os | 0) == 102; ; ) {
                      C = 0 - C | 0, yn = (C | 0) >= 9 ? 9 : C;
                      r: {
                        if (me >>> 0 <= Ar >>> 0) {
                          ke = e[Ar >> 2];
                          break r;
                        }
                        for (Ri = 1e9 >>> yn | 0, Qr = -1 << yn ^ -1, C = 0, ke = Ar; aa = C, C = e[ke >> 2], e[ke >> 2] = aa + (C >>> yn | 0), C = No(Ri, C & Qr), ke = ke + 4 | 0, ke >>> 0 < me >>> 0; )
                          ;
                        if (ke = e[Ar >> 2], !C)
                          break r;
                        e[me >> 2] = C, me = me + 4 | 0;
                      }
                      if (C = yn + e[Xr + 44 >> 2] | 0, e[Xr + 44 >> 2] = C, Ar = (!ke << 2) + Ar | 0, ke = En ? Wn : Ar, me = me - ke >> 2 > (Xo | 0) ? ke + (Xo << 2) | 0 : me, !((C | 0) < 0))
                        break;
                    }
                  C = 0;
                  r: {
                    if (me >>> 0 <= Ar >>> 0 || (C = No(Wn - Ar >> 2, 9), ke = 10, Qr = e[Ar >> 2], Qr >>> 0 < 10))
                      break r;
                    for (; C = C + 1 | 0, ke = No(ke, 10), Qr >>> 0 >= ke >>> 0; )
                      ;
                  }
                  if (ke = (Ur - ((Os | 0) != 102 ? C : 0) | 0) - ((Os | 0) == 103 & (Ur | 0) != 0) | 0, (ke | 0) < (No(me - Wn >> 2, 9) - 9 | 0)) {
                    if (Ri = ke + 9216 | 0, Qr = (Ri | 0) / 9 | 0, br = ((((br | 0) < 0 ? 4 : 292) + Xr | 0) + (Qr << 2) | 0) - 4048 | 0, ke = 10, yn = Ri + No(Qr, -9) | 0, (yn | 0) <= 7)
                      for (; ke = No(ke, 10), yn = yn + 1 | 0, (yn | 0) != 8; )
                        ;
                    Ri = e[br >> 2], Xo = (Ri >>> 0) / (ke >>> 0) | 0, En = No(Xo, ke), Qr = br + 4 | 0;
                    r: {
                      if ((Ri | 0) == (En | 0) & (Qr | 0) == (me | 0))
                        break r;
                      Ri = Ri - En | 0;
                      i: {
                        if (!(Xo & 1) && (y = 9007199254740992, !(Se[br - 4 | 0] & 1) | ((ke | 0) != 1e9 | Ar >>> 0 >= br >>> 0)))
                          break i;
                        y = 9007199254740994;
                      }
                      if (lo = (me | 0) == (Qr | 0) ? 1 : 1.5, Qr = ke >>> 1 | 0, lo = Qr >>> 0 > Ri >>> 0 ? 0.5 : (Qr | 0) == (Ri | 0) ? lo : 1.5, Je[Gs | 0] != 45 | Ma || (lo = -lo, y = -y), e[br >> 2] = En, y + lo == y)
                        break r;
                      if (C = ke + En | 0, e[br >> 2] = C, C >>> 0 >= 1e9)
                        for (; e[br >> 2] = 0, br = br - 4 | 0, br >>> 0 < Ar >>> 0 && (Ar = Ar - 4 | 0, e[Ar >> 2] = 0), C = e[br >> 2] + 1 | 0, e[br >> 2] = C, C >>> 0 > 999999999; )
                          ;
                      if (C = No(Wn - Ar >> 2, 9), ke = 10, Qr = e[Ar >> 2], Qr >>> 0 < 10)
                        break r;
                      for (; C = C + 1 | 0, ke = No(ke, 10), Qr >>> 0 >= ke >>> 0; )
                        ;
                    }
                    ke = br + 4 | 0, me = me >>> 0 > ke >>> 0 ? ke : me;
                  }
                  for (; Qr = me, Ri = me >>> 0 <= Ar >>> 0, !Ri && (me = me - 4 | 0, !e[me >> 2]); )
                    ;
                  r: {
                    if ((Os | 0) != 103) {
                      br = Q & 8;
                      break r;
                    }
                    if (ke = Ur || 1, me = (ke | 0) > (C | 0) & (C | 0) > -5, Ur = (me ? C ^ -1 : -1) + ke | 0, S = (me ? -1 : -2) + S | 0, br = Q & 8, br)
                      break r;
                    me = -9;
                    i: {
                      if (Ri || (br = e[Qr - 4 >> 2], !br) || (yn = 10, me = 0, (br >>> 0) % 10 | 0))
                        break i;
                      for (; ke = me, me = me + 1 | 0, yn = No(yn, 10), !((br >>> 0) % (yn >>> 0) | 0); )
                        ;
                      me = ke ^ -1;
                    }
                    if (ke = No(Qr - Wn >> 2, 9), (S & -33) == 70) {
                      br = 0, me = (me + ke | 0) - 9 | 0, me = (me | 0) > 0 ? me : 0, Ur = (me | 0) > (Ur | 0) ? Ur : me;
                      break r;
                    }
                    br = 0, me = ((C + ke | 0) + me | 0) - 9 | 0, me = (me | 0) > 0 ? me : 0, Ur = (me | 0) > (Ur | 0) ? Ur : me;
                  }
                  if (yn = -1, Ri = br | Ur, ((Ri ? 2147483645 : 2147483646) | 0) < (Ur | 0))
                    break e;
                  En = (((Ri | 0) != 0) + Ur | 0) + 1 | 0, ke = S & -33;
                  r: {
                    if ((ke | 0) == 70) {
                      if ((En ^ 2147483647) < (C | 0))
                        break e;
                      me = (C | 0) > 0 ? C : 0;
                      break r;
                    }
                    if (me = C >> 31, me = Ah((me ^ C) - me | 0, 0, bs), (bs - me | 0) <= 1)
                      for (; me = me - 1 | 0, Se[me | 0] = 48, (bs - me | 0) < 2; )
                        ;
                    if (Xo = me - 2 | 0, Se[Xo | 0] = S, Se[me - 1 | 0] = (C | 0) < 0 ? 45 : 43, me = bs - Xo | 0, (me | 0) > (En ^ 2147483647))
                      break e;
                  }
                  if (C = me + En | 0, (C | 0) > (Ro ^ 2147483647))
                    break e;
                  En = C + Ro | 0, Lf(l, 32, I, En, Q), Of(l, Gs, Ro), Lf(l, 48, I, En, Q ^ 65536);
                  r: {
                    i: {
                      n: {
                        if ((ke | 0) == 70) {
                          for (S = Xr + 16 | 0, C = S | 8, br = S | 9, ke = Ar >>> 0 > Wn >>> 0 ? Wn : Ar, Ar = ke; ; ) {
                            me = Ah(e[Ar >> 2], 0, br);
                            o: {
                              if ((ke | 0) != (Ar | 0)) {
                                if (Xr + 16 >>> 0 >= me >>> 0)
                                  break o;
                                for (; me = me - 1 | 0, Se[me | 0] = 48, Xr + 16 >>> 0 < me >>> 0; )
                                  ;
                                break o;
                              }
                              if ((me | 0) != (br | 0))
                                break o;
                              Se[Xr + 24 | 0] = 48, me = C;
                            }
                            if (Of(l, me, br - me | 0), Ar = Ar + 4 | 0, !(Wn >>> 0 >= Ar >>> 0))
                              break;
                          }
                          if (Ri && Of(l, 4352, 1), (Ur | 0) <= 0 | Ar >>> 0 >= Qr >>> 0)
                            break n;
                          for (; ; ) {
                            if (me = Ah(e[Ar >> 2], 0, br), me >>> 0 > Xr + 16 >>> 0)
                              for (; me = me - 1 | 0, Se[me | 0] = 48, Xr + 16 >>> 0 < me >>> 0; )
                                ;
                            if (Of(l, me, (Ur | 0) >= 9 ? 9 : Ur), me = Ur - 9 | 0, Ar = Ar + 4 | 0, Qr >>> 0 <= Ar >>> 0)
                              break i;
                            if (C = (Ur | 0) > 9, Ur = me, !C)
                              break;
                          }
                          break i;
                        }
                        o: {
                          if ((Ur | 0) < 0)
                            break o;
                          for (Wn = Ar >>> 0 < Qr >>> 0 ? Qr : Ar + 4 | 0, S = Xr + 16 | 0, C = S | 8, Qr = S | 9, ke = Ar; ; ) {
                            me = Ah(e[ke >> 2], 0, Qr), (Qr | 0) == (me | 0) && (Se[Xr + 24 | 0] = 48, me = C);
                            a: {
                              if ((ke | 0) != (Ar | 0)) {
                                if (Xr + 16 >>> 0 >= me >>> 0)
                                  break a;
                                for (; me = me - 1 | 0, Se[me | 0] = 48, Xr + 16 >>> 0 < me >>> 0; )
                                  ;
                                break a;
                              }
                              if (Of(l, me, 1), me = me + 1 | 0, !(br | Ur))
                                break a;
                              Of(l, 4352, 1);
                            }
                            if (S = Qr - me | 0, Of(l, me, (S | 0) < (Ur | 0) ? S : Ur), Ur = Ur - S | 0, ke = ke + 4 | 0, Wn >>> 0 <= ke >>> 0)
                              break o;
                            if (!((Ur | 0) >= 0))
                              break;
                          }
                        }
                        Lf(l, 48, Ur + 18 | 0, 18, 0), Of(l, Xo, bs - Xo | 0);
                        break r;
                      }
                      me = Ur;
                    }
                    Lf(l, 48, me + 9 | 0, 9, 0);
                  }
                  Lf(l, 32, I, En, Q ^ 8192), yn = (I | 0) < (En | 0) ? En : I;
                  break e;
                }
                br = (S << 26 >> 31 & 9) + Gs | 0;
                t: {
                  if (C >>> 0 > 11)
                    break t;
                  for (me = 12 - C | 0, lo = 16; lo = lo * 16, me = me - 1 | 0, !!me; )
                    ;
                  if (Je[br | 0] == 45) {
                    y = -(lo + (-y - lo));
                    break t;
                  }
                  y = y + lo - lo;
                }
                for (Wn = Ro | 2, Ar = S & 32, ke = e[Xr + 44 >> 2], me = ke >> 31, me = Ah((me ^ ke) - me | 0, 0, bs), (bs | 0) == (me | 0) && (Se[Xr + 15 | 0] = 48, me = Xr + 15 | 0), Ur = me - 2 | 0, Se[Ur | 0] = S + 15, Se[me - 1 | 0] = (ke | 0) < 0 ? 45 : 43, me = Q & 8, ke = Xr + 16 | 0; S = ke, Mf(y) < 2147483648 ? Qr = ~~y : Qr = -2147483648, Se[ke | 0] = Ar | Je[Qr + 7488 | 0], y = (y - +(Qr | 0)) * 16, ke = S + 1 | 0, !((C | 0) > 0 | me) & y == 0 | (ke - (Xr + 16 | 0) | 0) != 1 || (Se[S + 1 | 0] = 46, ke = S + 2 | 0), y != 0; )
                  ;
                if (yn = -1, me = bs - Ur | 0, S = me + Wn | 0, (2147483645 - S | 0) < (C | 0))
                  break e;
                Qr = S, S = Xr + 16 | 0, Ar = ke - S | 0, C = C && (Ar - 2 | 0) < (C | 0) ? C + 2 | 0 : Ar, ke = Qr + C | 0, Lf(l, 32, I, ke, Q), Of(l, br, Wn), Lf(l, 48, I, ke, Q ^ 65536), Of(l, S, Ar), Lf(l, 48, C - Ar | 0, 0, 0), Of(l, Ur, me), Lf(l, 32, I, ke, Q ^ 8192), yn = (I | 0) < (ke | 0) ? ke : I;
              }
              return bi = Xr + 560 | 0, yn | 0;
            }
            function zc(l, y) {
              l = l | 0, y = y | 0;
              var I = 0, C = 0, Q = 0, S = 0, me = 0, ke = 0, Ar = 0, br = 0, Qr = 0, Ur = 0, Xr = 0, Ri = 0, yn = 0, En = 0, Wn = 0;
              e: {
                t: {
                  r: {
                    i: {
                      n: {
                        o: {
                          a:
                            switch (e[y >> 2]) {
                              case 1:
                              case 4:
                              case 5:
                                e[l + 8 >> 2] = 0, e[l + 12 >> 2] = 0, e[l >> 2] = 1, e[l + 4 >> 2] = 0;
                                return;
                              case 2:
                                e[l + 8 >> 2] = 1, e[l + 12 >> 2] = 1;
                                break e;
                              case 3:
                                e[l + 8 >> 2] = 1, e[l + 12 >> 2] = 2, e[l >> 2] = 1, e[l + 4 >> 2] = 2;
                                return;
                              case 6:
                              case 7:
                              case 8:
                              case 9:
                                e[l + 8 >> 2] = 0, e[l + 12 >> 2] = 0;
                                break e;
                              case 23:
                                C = e[y + 32 >> 2], y = e[C + 16 >> 2], I = e[C >> 2], Q = e[I + 76 >> 2], br = Je[I + 72 | 0] != 0, Ar = br & Je[y + 64 | 0] != 0, S = Ar ? e[y + 68 >> 2] + Q | 0 : 0;
                                s: {
                                  if (!Je[I + 64 | 0] || (C = e[C + 8 >> 2], !Je[C + 64 | 0]))
                                    break s;
                                  I = e[C + 68 >> 2] + e[I + 68 >> 2] | 0, S = Ar ? I >>> 0 > S >>> 0 ? I : S : I, Ar = 1;
                                }
                                C = e[y + 76 >> 2], y = Je[y + 72 | 0], e[l >> 2] = Ar, e[l + 4 >> 2] = S, y = br & (y | 0) != 0, I = y & 0, e[l + 8 >> 2] = y | I, e[l + 12 >> 2] = y ? C + Q | 0 : 0;
                                return;
                              case 17:
                                y = e[y + 32 >> 2], I = e[y + 8 >> 2], C = e[I + 68 >> 2], y = e[y >> 2], S = e[y + 68 >> 2], y = Je[y + 64 | 0], Q = Je[I + 64 | 0], e[l + 8 >> 2] = 0, e[l + 12 >> 2] = 0, I = C + S | 0, y = (y | 0) != 0 & (Q | 0) != 0, C = y & 0, e[l >> 2] = y | C, e[l + 4 >> 2] = y ? I : 0;
                                return;
                              case 18:
                                I = e[y + 32 >> 2], y = e[I + 8 >> 2], S = e[y + 68 >> 2], C = e[I >> 2], Q = e[C + 68 >> 2], br = Je[C + 64 | 0], me = Je[y + 64 | 0], I = e[y + 76 >> 2] + e[C + 76 >> 2] | 0, y = Je[C + 72 | 0] != 0 & Je[y + 72 | 0] != 0, C = y & 0, e[l + 8 >> 2] = y | C, e[l + 12 >> 2] = y ? I : 0, y = (br | 0) != 0 & (me | 0) != 0, C = y & 0, e[l >> 2] = y | C, e[l + 4 >> 2] = y ? Q + S | 0 : 0;
                                return;
                              case 19:
                                I = e[y + 32 >> 2], y = e[I + 8 >> 2], S = e[y + 76 >> 2], br = Je[y + 72 | 0] != 0, C = e[I >> 2], Ar = br & Je[C + 64 | 0] != 0, I = Ar ? S + e[C + 68 >> 2] | 0 : 0, Q = e[C + 76 >> 2], me = Je[C + 72 | 0], !me | !Je[y + 64 | 0] || (y = Q + e[y + 68 >> 2] | 0, I = Ar ? y >>> 0 > I >>> 0 ? y : I : y, Ar = 1), e[l >> 2] = Ar, e[l + 4 >> 2] = I, y = br & (me | 0) != 0, C = y & 0, e[l + 8 >> 2] = y | C, e[l + 12 >> 2] = y ? Q + S | 0 : 0;
                                return;
                              case 20:
                                y = e[y + 32 >> 2], Q = e[y + 8 >> 2], I = e[y >> 2], C = e[Q + 68 >> 2] + e[I + 76 >> 2] | 0, y = Je[I + 72 | 0] != 0 & Je[Q + 64 | 0] != 0, Q = y ? C : 0;
                                s: {
                                  if (!Je[I + 64 | 0])
                                    break s;
                                  if (!y) {
                                    y = e[I + 64 >> 2], S = y & -256, Q = e[I + 68 >> 2];
                                    break s;
                                  }
                                  y = 1, I = e[I + 68 >> 2], Q = I >>> 0 > C >>> 0 ? I : C;
                                }
                                I = Q, e[l + 8 >> 2] = 0, e[l + 12 >> 2] = 0, e[l >> 2] = S | y & 255, e[l + 4 >> 2] = I | br;
                                return;
                              case 21:
                                y = e[y + 32 >> 2], C = e[y + 8 >> 2], I = e[y >> 2], me = e[I + 76 >> 2], Q = e[C + 68 >> 2] + me | 0, Ar = Je[I + 72 | 0], y = (Ar | 0) != 0 & Je[C + 64 | 0] != 0, ke = y ? Q : 0;
                                s: {
                                  if (!Je[I + 64 | 0])
                                    break s;
                                  if (!y) {
                                    y = e[I + 64 >> 2], S = y & -256, ke = e[I + 68 >> 2];
                                    break s;
                                  }
                                  y = 1, I = e[I + 68 >> 2], ke = I >>> 0 > Q >>> 0 ? I : Q;
                                }
                                Q = ke, I = e[C + 76 >> 2], C = Je[C + 72 | 0], ke = y & 255, y = 0, e[l >> 2] = ke | (S | y), e[l + 4 >> 2] = Q | br, Q = I + me | 0, I = y, y = (Ar | 0) != 0 & (C | 0) != 0, I = y ? I : 0, e[l + 8 >> 2] = y | I, e[l + 12 >> 2] = y ? Q : 0;
                                return;
                              case 22:
                                C = e[y + 32 >> 2], y = e[C + 8 >> 2], S = Je[y + 64 | 0], I = S ? e[y + 68 >> 2] + 1 | 0 : 0, Q = e[C >> 2], Je[Q + 64 | 0] && (C = e[Q + 68 >> 2] + 1 | 0, I = S ? I >>> 0 < C >>> 0 ? C : I : C, S = 1), br = e[y + 76 >> 2] + 1 | 0, y = Je[y + 72 | 0], C = y ? br : 0, Je[Q + 72 | 0] && (Q = e[Q + 76 >> 2] + 1 | 0, C = y ? C >>> 0 < Q >>> 0 ? Q : C : Q, y = 1), br = y, y = 0, e[l + 8 >> 2] = br | y, e[l + 12 >> 2] = C, e[l >> 2] = y | S, e[l + 4 >> 2] = I;
                                return;
                              case 25:
                                I = e[y + 4 >> 2] + 1 | 0, y = 1, e[l + 8 >> 2] = y, e[l + 12 >> 2] = I;
                                break t;
                              case 10:
                              case 11:
                              case 12:
                              case 16:
                                y = e[e[y + 32 >> 2] >> 2], I = e[y + 68 >> 2], e[l >> 2] = e[y + 64 >> 2], e[l + 4 >> 2] = I, I = e[y + 76 >> 2], e[l + 8 >> 2] = e[y + 72 >> 2], e[l + 12 >> 2] = I;
                                return;
                              case 13:
                                y = e[e[y + 32 >> 2] >> 2], I = e[y + 68 >> 2], y = Je[y + 64 | 0], e[l + 8 >> 2] = 1, e[l + 12 >> 2] = 1, br = y, y = !y, e[l >> 2] = br | y & 0, e[l + 4 >> 2] = y ? 0 : I + 1 | 0;
                                return;
                              case 14:
                                I = e[e[y + 32 >> 2] >> 2], y = e[I + 64 >> 2], I = e[I + 68 >> 2], e[l + 8 >> 2] = 0, e[l + 12 >> 2] = 0;
                                break t;
                              case 15:
                                I = e[e[y + 32 >> 2] >> 2], y = e[I + 64 >> 2], I = e[I + 68 >> 2], e[l + 8 >> 2] = 1, e[l + 12 >> 2] = 1;
                                break t;
                              case 24:
                                if (I = ga(8), e[I >> 2] = 1, e[I + 4 >> 2] = 0, Ar = I + 8 | 0, Ur = e[y + 32 >> 2], yn = e[y + 36 >> 2], (Ur | 0) != (yn | 0))
                                  for (; ; ) {
                                    C = e[Ur >> 2], Q = e[C + 76 >> 2], C = Je[C + 72 | 0], me = e[I + 4 >> 2], br = I, Qr = Je[I | 0], e[5996] = 0, S = no(3, 8) | 0, I = e[5996], e[5996] = 0;
                                    s: {
                                      A: {
                                        if ((I | 0) != 1) {
                                          if (I = Q + me | 0, C = (Qr | 0) != 0 & (C | 0) != 0, Q = C & 0, e[S >> 2] = C | Q, e[S + 4 >> 2] = C ? I : 0, me = S + 8 | 0, I = Ar - br | 0, Qr = I >> 3, I >>> 0 >= 9)
                                            break A;
                                          C = me;
                                          break s;
                                        }
                                        C = gi() | 0, I = br;
                                        break n;
                                      }
                                      for (Wn = Qr >>> 0 <= 2 ? 2 : Qr, Ar = 1, C = me; ; ) {
                                        I = e[Ur >> 2], ke = br + (Ar << 3) | 0, Xr = e[I + 76 >> 2] + e[ke + 4 >> 2] | 0, Ri = ke - 8 | 0, Q = Je[Ri | 0] != 0 & Je[I + 64 | 0] != 0, ke = Je[ke | 0] != 0 & Je[I + 72 | 0] != 0, En = ke ? Xr : 0, I = Q ? e[I + 68 >> 2] + e[Ri + 4 >> 2] | 0 : 0, I = ke ? Q ? I >>> 0 < En >>> 0 ? En : I : Xr : I, Xr = Q | ke;
                                        A: {
                                          if (C >>> 0 < me >>> 0) {
                                            e[C >> 2] = Xr, e[C + 4 >> 2] = I, Q = C;
                                            break A;
                                          }
                                          if (Ri = C - S >> 3, Q = Ri + 1 | 0, Q >>> 0 >= 536870912) {
                                            if (e[5996] = 0, jo(93), l = e[5996], e[5996] = 0, (l | 0) == 1)
                                              break o;
                                            break r;
                                          }
                                          me = me - S | 0, ke = me >> 2, ke = me >>> 0 >= 2147483640 ? 536870911 : Q >>> 0 < ke >>> 0 ? ke : Q;
                                          u: {
                                            if (!ke) {
                                              me = 0;
                                              break u;
                                            }
                                            if (ke >>> 0 >= 536870912) {
                                              if (e[5996] = 0, jo(35), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                                break r;
                                              break o;
                                            }
                                            if (e[5996] = 0, me = no(3, ke << 3) | 0, Q = e[5996], e[5996] = 0, (Q | 0) == 1)
                                              break o;
                                          }
                                          Q = (Ri << 3) + me | 0, e[Q >> 2] = Xr, e[Q + 4 >> 2] = I, me = (ke << 3) + me | 0, I = Q;
                                          u: {
                                            if ((C | 0) != (S | 0)) {
                                              for (; C = C - 8 | 0, ke = e[C + 4 >> 2], I = I - 8 | 0, e[I >> 2] = e[C >> 2], e[I + 4 >> 2] = ke, (C | 0) != (S | 0); )
                                                ;
                                              if (!S)
                                                break u;
                                            }
                                            Tr(S);
                                          }
                                          S = I;
                                        }
                                        if (C = Q + 8 | 0, Ar = Ar + 1 | 0, (Wn | 0) == (Ar | 0))
                                          break;
                                      }
                                    }
                                    I = (br + (Qr << 3) | 0) - 8 | 0, Q = e[Ur >> 2], Ar = Je[I | 0] != 0 & Je[Q + 64 | 0] != 0, Q = Ar ? e[Q + 68 >> 2] + e[I + 4 >> 2] | 0 : 0;
                                    s: {
                                      if (C >>> 0 < me >>> 0) {
                                        e[C >> 2] = Ar, e[C + 4 >> 2] = Q, Ar = C + 8 | 0, I = S;
                                        break s;
                                      }
                                      A: {
                                        u: {
                                          Qr = C - S >> 3, I = Qr + 1 | 0;
                                          h: {
                                            if (I >>> 0 >= 536870912) {
                                              e[5996] = 0, jo(93);
                                              break h;
                                            }
                                            if (me = me - S | 0, ke = me >> 2, I = me >>> 0 >= 2147483640 ? 536870911 : I >>> 0 < ke >>> 0 ? ke : I, !I) {
                                              I = 0;
                                              break A;
                                            }
                                            if (I >>> 0 < 536870912)
                                              break u;
                                            e[5996] = 0, jo(35);
                                          }
                                          if (l = e[5996], e[5996] = 0, (l | 0) != 1)
                                            break r;
                                          break o;
                                        }
                                        if (e[5996] = 0, I = no(3, I << 3) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                          break o;
                                      }
                                      if (I = (Qr << 3) + I | 0, e[I >> 2] = Ar, e[I + 4 >> 2] = Q, Ar = I + 8 | 0, (C | 0) != (S | 0)) {
                                        for (; C = C - 8 | 0, Q = e[C + 4 >> 2], I = I - 8 | 0, e[I >> 2] = e[C >> 2], e[I + 4 >> 2] = Q, (C | 0) != (S | 0); )
                                          ;
                                        if (!S)
                                          break s;
                                      }
                                      Tr(S);
                                    }
                                    if (Tr(br), Ur = Ur + 8 | 0, (yn | 0) == (Ur | 0))
                                      break;
                                  }
                                if (y = e[y + 4 >> 2], y >>> 0 <= Ar - I >> 3 >>> 0) {
                                  y = (y << 3) + I | 0, C = e[y >> 2], y = e[y + 4 >> 2], S = e[I + 4 >> 2], e[l + 8 >> 2] = e[I >> 2], e[l + 12 >> 2] = S, e[l >> 2] = C, e[l + 4 >> 2] = y, Tr(I);
                                  return;
                                }
                                if (e[5996] = 0, ia(44, 5118, 2210, 850, 2317), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                  break r;
                                if (C = gi() | 0, !I)
                                  break i;
                                break n;
                              default:
                                Nf(2350, 2210, 854, 2317), jn();
                              case 0:
                                break a;
                            }
                          e[l + 8 >> 2] = 1, e[l + 12 >> 2] = 0, e[l >> 2] = 0, e[l + 4 >> 2] = 0;
                          return;
                        }
                        if (C = gi() | 0, !S) {
                          I = br;
                          break n;
                        }
                        Tr(S), I = br;
                      }
                      Tr(I);
                    }
                    ss(C | 0), jn();
                  }
                  jn();
                }
                e[l >> 2] = y, e[l + 4 >> 2] = I;
                return;
              }
              e[l >> 2] = 1, e[l + 4 >> 2] = 1;
            }
            function kh(l, y, I, C, Q) {
              var S = 0, me = 0, ke = 0, Ar = 0, br = 0, Qr = 0, Ur = 0, Xr = 0, Ri = 0, yn = 0, En = 0, Wn = 0, lo = 0, Ro = 0, Xo = 0, bs = 0, Os = 0, Gs = 0, aa = 0;
              ke = bi - 80 | 0, bi = ke, e[ke + 76 >> 2] = y, aa = ke + 55 | 0, Wn = ke + 56 | 0;
              e: {
                t: {
                  r: {
                    i: for (; ; ) {
                      S = 0;
                      n: for (; ; ) {
                        if (Qr = y, (En ^ 2147483647) < (S | 0))
                          break r;
                        En = S + En | 0;
                        o: {
                          a: {
                            s: {
                              if (S = y, me = Je[S | 0], me)
                                for (; ; ) {
                                  A: {
                                    y = me & 255;
                                    u: {
                                      if (!y) {
                                        y = S;
                                        break u;
                                      }
                                      if ((y | 0) != 37)
                                        break A;
                                      for (me = S; ; ) {
                                        if (Je[me + 1 | 0] != 37) {
                                          y = me;
                                          break u;
                                        }
                                        if (S = S + 1 | 0, Ur = Je[me + 2 | 0], y = me + 2 | 0, me = y, (Ur | 0) != 37)
                                          break;
                                      }
                                    }
                                    if (S = S - Qr | 0, Gs = En ^ 2147483647, (S | 0) > (Gs | 0))
                                      break r;
                                    if (l && Of(l, Qr, S), S)
                                      continue n;
                                    e[ke + 76 >> 2] = y, S = y + 1 | 0, yn = -1, me = Se[y + 1 | 0], Je[y + 2 | 0] != 36 | me - 48 >>> 0 >= 10 || (yn = me - 48 | 0, lo = 1, S = y + 3 | 0), e[ke + 76 >> 2] = S, Xr = 0, me = Se[S | 0], y = me - 32 | 0;
                                    u: {
                                      if (y >>> 0 > 31) {
                                        Ur = S;
                                        break u;
                                      }
                                      if (Ur = S, y = 1 << y, !(y & 75913))
                                        break u;
                                      for (; ; ) {
                                        if (Ur = S + 1 | 0, e[ke + 76 >> 2] = Ur, Xr = y | Xr, me = Se[S + 1 | 0], y = me - 32 | 0, y >>> 0 >= 32)
                                          break u;
                                        if (S = Ur, y = 1 << y, !(y & 75913))
                                          break;
                                      }
                                    }
                                    u: {
                                      if ((me | 0) == 42) {
                                        y = Se[Ur + 1 | 0];
                                        h: {
                                          if (!(Je[Ur + 2 | 0] != 36 | y - 48 >>> 0 >= 10)) {
                                            y = y - 48 | 0;
                                            c: {
                                              if (!l) {
                                                e[(y << 2) + Q >> 2] = 10, Ri = 0;
                                                break c;
                                              }
                                              Ri = e[(y << 3) + C >> 2];
                                            }
                                            y = Ur + 3 | 0, lo = 1;
                                            break h;
                                          }
                                          if (lo)
                                            break s;
                                          if (y = Ur + 1 | 0, !l) {
                                            e[ke + 76 >> 2] = y, lo = 0, Ri = 0;
                                            break u;
                                          }
                                          S = e[I >> 2], e[I >> 2] = S + 4, Ri = e[S >> 2], lo = 0;
                                        }
                                        if (e[ke + 76 >> 2] = y, (Ri | 0) >= 0)
                                          break u;
                                        Ri = 0 - Ri | 0, Xr = Xr | 8192;
                                        break u;
                                      }
                                      if (Ri = dd(ke + 76 | 0), (Ri | 0) < 0)
                                        break r;
                                      y = e[ke + 76 >> 2];
                                    }
                                    S = 0, Ar = -1, me = 0;
                                    u: {
                                      if (Je[y | 0] != 46)
                                        break u;
                                      if (Je[y + 1 | 0] == 42) {
                                        me = Se[y + 2 | 0];
                                        h: {
                                          if (!(Je[y + 3 | 0] != 36 | me - 48 >>> 0 >= 10)) {
                                            me = me - 48 | 0, y = y + 4 | 0;
                                            c: {
                                              if (!l) {
                                                e[(me << 2) + Q >> 2] = 10, Ar = 0;
                                                break c;
                                              }
                                              Ar = e[(me << 3) + C >> 2];
                                            }
                                            break h;
                                          }
                                          if (lo)
                                            break s;
                                          if (y = y + 2 | 0, Ar = 0, !l)
                                            break h;
                                          me = e[I >> 2], e[I >> 2] = me + 4, Ar = e[me >> 2];
                                        }
                                        e[ke + 76 >> 2] = y, me = (Ar ^ -1) >>> 31 | 0;
                                        break u;
                                      }
                                      e[ke + 76 >> 2] = y + 1, Ar = dd(ke + 76 | 0), y = e[ke + 76 >> 2], me = 1;
                                    }
                                    for (Xo = me; ; ) {
                                      if (Ro = S, br = 28, bs = y, me = Se[y | 0], me - 123 >>> 0 < 4294967238)
                                        break t;
                                      if (y = y + 1 | 0, S = Je[(me + No(S, 58) | 0) + 6959 | 0], !(S - 1 >>> 0 < 8))
                                        break;
                                    }
                                    e[ke + 76 >> 2] = y;
                                    u: {
                                      if ((S | 0) != 27) {
                                        if (!S)
                                          break t;
                                        if ((yn | 0) >= 0) {
                                          if (!l) {
                                            e[(yn << 2) + Q >> 2] = S;
                                            continue i;
                                          }
                                          S = (yn << 3) + C | 0, me = e[S + 4 >> 2], e[ke + 64 >> 2] = e[S >> 2], e[ke + 68 >> 2] = me;
                                          break u;
                                        }
                                        if (!l)
                                          break o;
                                        cr(ke - -64 | 0, S, I);
                                        break u;
                                      }
                                      if ((yn | 0) >= 0)
                                        break t;
                                      if (S = 0, !l)
                                        continue n;
                                    }
                                    if (br = -1, Je[l | 0] & 32)
                                      break e;
                                    me = Xr & -65537, Xr = Xr & 8192 ? me : Xr, yn = 0, Os = 1212, Ur = Wn;
                                    u: {
                                      h: {
                                        c: {
                                          f: {
                                            p: {
                                              d: {
                                                g: {
                                                  v: {
                                                    _: {
                                                      R: {
                                                        k: {
                                                          S: {
                                                            E: {
                                                              w: {
                                                                I: {
                                                                  l:
                                                                    switch (S = Se[bs | 0], S = Ro && (S & 15) == 3 ? S & -33 : S, S - 88 | 0) {
                                                                      case 11:
                                                                        break u;
                                                                      case 9:
                                                                      case 13:
                                                                      case 14:
                                                                      case 15:
                                                                        break h;
                                                                      case 27:
                                                                        break g;
                                                                      case 12:
                                                                      case 17:
                                                                        break R;
                                                                      case 23:
                                                                        break k;
                                                                      case 0:
                                                                      case 32:
                                                                        break S;
                                                                      case 24:
                                                                        break E;
                                                                      case 22:
                                                                        break w;
                                                                      case 29:
                                                                        break I;
                                                                      case 1:
                                                                      case 2:
                                                                      case 3:
                                                                      case 4:
                                                                      case 5:
                                                                      case 6:
                                                                      case 7:
                                                                      case 8:
                                                                      case 10:
                                                                      case 16:
                                                                      case 18:
                                                                      case 19:
                                                                      case 20:
                                                                      case 21:
                                                                      case 25:
                                                                      case 26:
                                                                      case 28:
                                                                      case 30:
                                                                      case 31:
                                                                        break a;
                                                                      default:
                                                                        break l;
                                                                    }
                                                                  l:
                                                                    switch (S - 65 | 0) {
                                                                      case 0:
                                                                      case 4:
                                                                      case 5:
                                                                      case 6:
                                                                        break h;
                                                                      case 2:
                                                                        break p;
                                                                      case 1:
                                                                      case 3:
                                                                        break a;
                                                                      default:
                                                                        break l;
                                                                    }
                                                                  if ((S | 0) == 83)
                                                                    break d;
                                                                  break a;
                                                                }
                                                                me = e[ke + 64 >> 2], br = e[ke + 68 >> 2], S = 1212;
                                                                break _;
                                                              }
                                                              S = 0;
                                                              w:
                                                                switch (Ro & 255) {
                                                                  case 0:
                                                                    e[e[ke + 64 >> 2] >> 2] = En;
                                                                    continue n;
                                                                  case 1:
                                                                    e[e[ke + 64 >> 2] >> 2] = En;
                                                                    continue n;
                                                                  case 2:
                                                                    me = e[ke + 64 >> 2], e[me >> 2] = En, e[me + 4 >> 2] = En >> 31;
                                                                    continue n;
                                                                  case 3:
                                                                    ea[e[ke + 64 >> 2] >> 1] = En;
                                                                    continue n;
                                                                  case 4:
                                                                    Se[e[ke + 64 >> 2]] = En;
                                                                    continue n;
                                                                  case 6:
                                                                    e[e[ke + 64 >> 2] >> 2] = En;
                                                                    continue n;
                                                                  case 7:
                                                                    break w;
                                                                  default:
                                                                    continue n;
                                                                }
                                                              me = e[ke + 64 >> 2], e[me >> 2] = En, e[me + 4 >> 2] = En >> 31;
                                                              continue n;
                                                            }
                                                            Ar = Ar >>> 0 <= 8 ? 8 : Ar, Xr = Xr | 8, S = 120;
                                                          }
                                                          if (Qr = Wn, bs = S & 32, me = e[ke + 64 >> 2], br = e[ke + 68 >> 2], me | br)
                                                            for (; Qr = Qr - 1 | 0, Se[Qr | 0] = bs | Je[(me & 15) + 7488 | 0], Ro = !br & me >>> 0 > 15 | (br | 0) != 0, me = (br & 15) << 28 | me >>> 4, br = br >>> 4 | 0, !!Ro; )
                                                              ;
                                                          if (!(e[ke + 64 >> 2] | e[ke + 68 >> 2]) | !(Xr & 8))
                                                            break v;
                                                          Os = (S >>> 4 | 0) + 1212 | 0, yn = 2;
                                                          break v;
                                                        }
                                                        if (S = Wn, Qr = e[ke + 68 >> 2], br = Qr, me = e[ke + 64 >> 2], Qr | me)
                                                          for (; S = S - 1 | 0, Se[S | 0] = me & 7 | 48, Ro = !br & me >>> 0 > 7 | (br | 0) != 0, me = (br & 7) << 29 | me >>> 3, br = br >>> 3 | 0, !!Ro; )
                                                            ;
                                                        if (Qr = S, !(Xr & 8))
                                                          break v;
                                                        S = Wn - S | 0, Ar = (S | 0) < (Ar | 0) ? Ar : S + 1 | 0;
                                                        break v;
                                                      }
                                                      if (me = e[ke + 64 >> 2], S = e[ke + 68 >> 2], br = S, (S | 0) < 0) {
                                                        Qr = 0 - (S + ((me | 0) != 0) | 0) | 0, br = Qr, me = 0 - me | 0, e[ke + 64 >> 2] = me, e[ke + 68 >> 2] = Qr, yn = 1, S = 1212;
                                                        break _;
                                                      }
                                                      if (Xr & 2048) {
                                                        yn = 1, S = 1213;
                                                        break _;
                                                      }
                                                      yn = Xr & 1, S = yn ? 1214 : 1212;
                                                    }
                                                    Os = S, Qr = Ah(me, br, Wn);
                                                  }
                                                  if ((Ar | 0) < 0 && Xo)
                                                    break r;
                                                  if (Xr = Xo ? Xr & -65537 : Xr, S = e[ke + 64 >> 2], me = e[ke + 68 >> 2], !(Ar | (S | me) != 0)) {
                                                    Qr = Wn, Ar = 0;
                                                    break a;
                                                  }
                                                  S = !(S | me) + (Wn - Qr | 0) | 0, Ar = (S | 0) < (Ar | 0) ? Ar : S;
                                                  break a;
                                                }
                                                if (S = e[ke + 64 >> 2], Qr = S || 4806, S = Qr, Ur = Ar >>> 0 >= 2147483647 ? 2147483647 : Ar, br = Hs(S, 0, Ur), S = br ? br - S | 0 : Ur, Ur = S + Qr | 0, (Ar | 0) >= 0) {
                                                  Xr = me, Ar = S;
                                                  break a;
                                                }
                                                if (Xr = me, Ar = S, Je[Ur | 0])
                                                  break r;
                                                break a;
                                              }
                                              if (Ar) {
                                                me = e[ke + 64 >> 2];
                                                break f;
                                              }
                                              S = 0, Lf(l, 32, Ri, 0, Xr);
                                              break c;
                                            }
                                            e[ke + 12 >> 2] = 0, e[ke + 8 >> 2] = e[ke + 64 >> 2], me = ke + 8 | 0, e[ke + 64 >> 2] = me, Ar = -1;
                                          }
                                          S = 0;
                                          f: {
                                            for (; ; ) {
                                              if (Qr = e[me >> 2], !Qr)
                                                break f;
                                              if (Qr = bp(ke + 4 | 0, Qr), Ur = (Qr | 0) < 0, !(Ur | Qr >>> 0 > Ar - S >>> 0)) {
                                                if (me = me + 4 | 0, S = S + Qr | 0, Ar >>> 0 > S >>> 0)
                                                  continue;
                                                break f;
                                              }
                                              break;
                                            }
                                            if (Ur)
                                              break e;
                                          }
                                          if (br = 61, (S | 0) < 0)
                                            break t;
                                          if (Lf(l, 32, Ri, S, Xr), !S) {
                                            S = 0;
                                            break c;
                                          }
                                          for (Ur = 0, me = e[ke + 64 >> 2]; ; ) {
                                            if (Qr = e[me >> 2], !Qr || (br = ke + 4 | 0, Qr = bp(br, Qr), Ur = Qr + Ur | 0, Ur >>> 0 > S >>> 0))
                                              break c;
                                            if (Of(l, br, Qr), me = me + 4 | 0, !(S >>> 0 > Ur >>> 0))
                                              break;
                                          }
                                        }
                                        Lf(l, 32, Ri, S, Xr ^ 8192), S = (S | 0) < (Ri | 0) ? Ri : S;
                                        continue n;
                                      }
                                      if ((Ar | 0) < 0 && Xo)
                                        break r;
                                      if (br = 61, S = Jc(l, zo[ke + 64 >> 3], Ri, Ar, Xr, S), (S | 0) >= 0)
                                        continue n;
                                      break t;
                                    }
                                    Se[ke + 55 | 0] = e[ke + 64 >> 2], Ar = 1, Qr = aa, Xr = me;
                                    break a;
                                  }
                                  me = Je[S + 1 | 0], S = S + 1 | 0;
                                }
                              if (br = En, l)
                                break e;
                              if (!lo)
                                break o;
                              for (S = 1; ; ) {
                                if (l = e[(S << 2) + Q >> 2], l) {
                                  if (cr((S << 3) + C | 0, l, I), br = 1, S = S + 1 | 0, (S | 0) != 10)
                                    continue;
                                  break e;
                                }
                                break;
                              }
                              if (br = 1, S >>> 0 >= 10)
                                break e;
                              for (; ; ) {
                                if (e[(S << 2) + Q >> 2])
                                  break s;
                                if (S = S + 1 | 0, (S | 0) == 10)
                                  break;
                              }
                              break e;
                            }
                            br = 28;
                            break t;
                          }
                          if (Ur = Ur - Qr | 0, Ar = (Ar | 0) > (Ur | 0) ? Ar : Ur, (Ar | 0) > (yn ^ 2147483647))
                            break r;
                          if (br = 61, me = Ar + yn | 0, S = (me | 0) < (Ri | 0) ? Ri : me, (Gs | 0) < (S | 0))
                            break t;
                          Lf(l, 32, S, me, Xr), Of(l, Os, yn), Lf(l, 48, S, me, Xr ^ 65536), Lf(l, 48, Ar, Ur, 0), Of(l, Qr, Ur), Lf(l, 32, S, me, Xr ^ 8192);
                          continue;
                        }
                        break;
                      }
                      break;
                    }
                    br = 0;
                    break e;
                  }
                  br = 61;
                }
                e[5732] = br, br = -1;
              }
              return bi = ke + 80 | 0, br;
            }
            function al(l) {
              l = l | 0;
              var y = 0, I = 0, C = 0, Q = 0, S = 0;
              e: {
                if (l >>> 0 <= 211) {
                  C = e[Ad(7504, 7696, l) >> 2];
                  break e;
                }
                for (l >>> 0 >= 4294967292 && (l = ro(8), e[5996] = 0, C = no(167, l | 0) | 0, Q = e[5996], e[5996] = 0, (Q | 0) != 1 && (E2(C | 0, 22716, 92), jn()), C = gi() | 0, ef(l), ss(C | 0), jn()), S = (l >>> 0) / 210 | 0, C = No(S, 210), Q = Ad(7696, 7888, l - C | 0) - 7696 >> 2; ; ) {
                  for (C = e[(Q << 2) + 7696 >> 2] + C | 0, l = 5; ; ) {
                    t: {
                      if ((l | 0) == 47) {
                        for (l = 211; ; ) {
                          if (y = (C >>> 0) / (l >>> 0) | 0, y >>> 0 < l >>> 0)
                            break e;
                          if ((No(l, y) | 0) == (C | 0))
                            break t;
                          if (y = l + 10 | 0, I = (C >>> 0) / (y >>> 0) | 0, y >>> 0 > I >>> 0)
                            break e;
                          if ((No(y, I) | 0) == (C | 0))
                            break t;
                          if (y = l + 12 | 0, I = (C >>> 0) / (y >>> 0) | 0, y >>> 0 > I >>> 0)
                            break e;
                          if ((No(y, I) | 0) == (C | 0))
                            break t;
                          if (y = l + 16 | 0, I = (C >>> 0) / (y >>> 0) | 0, y >>> 0 > I >>> 0)
                            break e;
                          if ((No(y, I) | 0) == (C | 0))
                            break t;
                          if (y = l + 18 | 0, I = (C >>> 0) / (y >>> 0) | 0, y >>> 0 > I >>> 0)
                            break e;
                          if ((No(y, I) | 0) == (C | 0))
                            break t;
                          if (y = l + 22 | 0, I = (C >>> 0) / (y >>> 0) | 0, y >>> 0 > I >>> 0)
                            break e;
                          if ((No(y, I) | 0) == (C | 0))
                            break t;
                          if (y = l + 28 | 0, I = (C >>> 0) / (y >>> 0) | 0, y >>> 0 > I >>> 0)
                            break e;
                          if ((No(y, I) | 0) == (C | 0))
                            break t;
                          if (y = l + 30 | 0, I = (C >>> 0) / (y >>> 0) | 0, y >>> 0 > I >>> 0)
                            break e;
                          if ((No(y, I) | 0) == (C | 0))
                            break t;
                          if (y = l + 36 | 0, I = (C >>> 0) / (y >>> 0) | 0, y >>> 0 > I >>> 0)
                            break e;
                          if ((No(y, I) | 0) == (C | 0))
                            break t;
                          if (y = l + 40 | 0, I = (C >>> 0) / (y >>> 0) | 0, y >>> 0 > I >>> 0)
                            break e;
                          if ((No(y, I) | 0) == (C | 0))
                            break t;
                          if (y = l + 42 | 0, I = (C >>> 0) / (y >>> 0) | 0, y >>> 0 > I >>> 0)
                            break e;
                          if ((No(y, I) | 0) == (C | 0))
                            break t;
                          if (y = l + 46 | 0, I = (C >>> 0) / (y >>> 0) | 0, y >>> 0 > I >>> 0)
                            break e;
                          if ((No(y, I) | 0) == (C | 0))
                            break t;
                          if (y = l + 52 | 0, I = (C >>> 0) / (y >>> 0) | 0, y >>> 0 > I >>> 0)
                            break e;
                          if ((No(y, I) | 0) == (C | 0))
                            break t;
                          if (y = l + 58 | 0, I = (C >>> 0) / (y >>> 0) | 0, y >>> 0 > I >>> 0)
                            break e;
                          if ((No(y, I) | 0) == (C | 0))
                            break t;
                          if (y = l + 60 | 0, I = (C >>> 0) / (y >>> 0) | 0, y >>> 0 > I >>> 0)
                            break e;
                          if ((No(y, I) | 0) == (C | 0))
                            break t;
                          if (y = l + 66 | 0, I = (C >>> 0) / (y >>> 0) | 0, y >>> 0 > I >>> 0)
                            break e;
                          if ((No(y, I) | 0) == (C | 0))
                            break t;
                          if (y = l + 70 | 0, I = (C >>> 0) / (y >>> 0) | 0, y >>> 0 > I >>> 0)
                            break e;
                          if ((No(y, I) | 0) == (C | 0))
                            break t;
                          if (y = l + 72 | 0, I = (C >>> 0) / (y >>> 0) | 0, y >>> 0 > I >>> 0)
                            break e;
                          if ((No(y, I) | 0) == (C | 0))
                            break t;
                          if (y = l + 78 | 0, I = (C >>> 0) / (y >>> 0) | 0, y >>> 0 > I >>> 0)
                            break e;
                          if ((No(y, I) | 0) == (C | 0))
                            break t;
                          if (y = l + 82 | 0, I = (C >>> 0) / (y >>> 0) | 0, y >>> 0 > I >>> 0)
                            break e;
                          if ((No(y, I) | 0) == (C | 0))
                            break t;
                          if (y = l + 88 | 0, I = (C >>> 0) / (y >>> 0) | 0, y >>> 0 > I >>> 0)
                            break e;
                          if ((No(y, I) | 0) == (C | 0))
                            break t;
                          if (y = l + 96 | 0, I = (C >>> 0) / (y >>> 0) | 0, y >>> 0 > I >>> 0)
                            break e;
                          if ((No(y, I) | 0) == (C | 0))
                            break t;
                          if (y = l + 100 | 0, I = (C >>> 0) / (y >>> 0) | 0, y >>> 0 > I >>> 0)
                            break e;
                          if ((No(y, I) | 0) == (C | 0))
                            break t;
                          if (y = l + 102 | 0, I = (C >>> 0) / (y >>> 0) | 0, y >>> 0 > I >>> 0)
                            break e;
                          if ((No(y, I) | 0) == (C | 0))
                            break t;
                          if (y = l + 106 | 0, I = (C >>> 0) / (y >>> 0) | 0, y >>> 0 > I >>> 0)
                            break e;
                          if ((No(y, I) | 0) == (C | 0))
                            break t;
                          if (y = l + 108 | 0, I = (C >>> 0) / (y >>> 0) | 0, y >>> 0 > I >>> 0)
                            break e;
                          if ((No(y, I) | 0) == (C | 0))
                            break t;
                          if (y = l + 112 | 0, I = (C >>> 0) / (y >>> 0) | 0, y >>> 0 > I >>> 0)
                            break e;
                          if ((No(y, I) | 0) == (C | 0))
                            break t;
                          if (y = l + 120 | 0, I = (C >>> 0) / (y >>> 0) | 0, y >>> 0 > I >>> 0)
                            break e;
                          if ((No(y, I) | 0) == (C | 0))
                            break t;
                          if (y = l + 126 | 0, I = (C >>> 0) / (y >>> 0) | 0, y >>> 0 > I >>> 0)
                            break e;
                          if ((No(y, I) | 0) == (C | 0))
                            break t;
                          if (y = l + 130 | 0, I = (C >>> 0) / (y >>> 0) | 0, y >>> 0 > I >>> 0)
                            break e;
                          if ((No(y, I) | 0) == (C | 0))
                            break t;
                          if (y = l + 136 | 0, I = (C >>> 0) / (y >>> 0) | 0, y >>> 0 > I >>> 0)
                            break e;
                          if ((No(y, I) | 0) == (C | 0))
                            break t;
                          if (y = l + 138 | 0, I = (C >>> 0) / (y >>> 0) | 0, y >>> 0 > I >>> 0)
                            break e;
                          if ((No(y, I) | 0) == (C | 0))
                            break t;
                          if (y = l + 142 | 0, I = (C >>> 0) / (y >>> 0) | 0, y >>> 0 > I >>> 0)
                            break e;
                          if ((No(y, I) | 0) == (C | 0))
                            break t;
                          if (y = l + 148 | 0, I = (C >>> 0) / (y >>> 0) | 0, y >>> 0 > I >>> 0)
                            break e;
                          if ((No(y, I) | 0) == (C | 0))
                            break t;
                          if (y = l + 150 | 0, I = (C >>> 0) / (y >>> 0) | 0, y >>> 0 > I >>> 0)
                            break e;
                          if ((No(y, I) | 0) == (C | 0))
                            break t;
                          if (y = l + 156 | 0, I = (C >>> 0) / (y >>> 0) | 0, y >>> 0 > I >>> 0)
                            break e;
                          if ((No(y, I) | 0) == (C | 0))
                            break t;
                          if (y = l + 162 | 0, I = (C >>> 0) / (y >>> 0) | 0, y >>> 0 > I >>> 0)
                            break e;
                          if ((No(y, I) | 0) == (C | 0))
                            break t;
                          if (y = l + 166 | 0, I = (C >>> 0) / (y >>> 0) | 0, y >>> 0 > I >>> 0)
                            break e;
                          if ((No(y, I) | 0) == (C | 0))
                            break t;
                          if (y = l + 168 | 0, I = (C >>> 0) / (y >>> 0) | 0, y >>> 0 > I >>> 0)
                            break e;
                          if ((No(y, I) | 0) == (C | 0))
                            break t;
                          if (y = l + 172 | 0, I = (C >>> 0) / (y >>> 0) | 0, y >>> 0 > I >>> 0)
                            break e;
                          if ((No(y, I) | 0) == (C | 0))
                            break t;
                          if (y = l + 178 | 0, I = (C >>> 0) / (y >>> 0) | 0, y >>> 0 > I >>> 0)
                            break e;
                          if ((No(y, I) | 0) == (C | 0))
                            break t;
                          if (y = l + 180 | 0, I = (C >>> 0) / (y >>> 0) | 0, y >>> 0 > I >>> 0)
                            break e;
                          if ((No(y, I) | 0) == (C | 0))
                            break t;
                          if (y = l + 186 | 0, I = (C >>> 0) / (y >>> 0) | 0, y >>> 0 > I >>> 0)
                            break e;
                          if ((No(y, I) | 0) == (C | 0))
                            break t;
                          if (y = l + 190 | 0, I = (C >>> 0) / (y >>> 0) | 0, y >>> 0 > I >>> 0)
                            break e;
                          if ((No(y, I) | 0) == (C | 0))
                            break t;
                          if (y = l + 192 | 0, I = (C >>> 0) / (y >>> 0) | 0, y >>> 0 > I >>> 0)
                            break e;
                          if ((No(y, I) | 0) == (C | 0))
                            break t;
                          if (y = l + 196 | 0, I = (C >>> 0) / (y >>> 0) | 0, y >>> 0 > I >>> 0)
                            break e;
                          if ((No(y, I) | 0) == (C | 0))
                            break t;
                          if (y = l + 198 | 0, I = (C >>> 0) / (y >>> 0) | 0, y >>> 0 > I >>> 0)
                            break e;
                          if ((No(y, I) | 0) == (C | 0))
                            break t;
                          if (y = l + 208 | 0, I = (C >>> 0) / (y >>> 0) | 0, y >>> 0 > I >>> 0)
                            break e;
                          if (l = l + 210 | 0, (No(y, I) | 0) == (C | 0))
                            break;
                        }
                        break t;
                      }
                      if (y = e[(l << 2) + 7504 >> 2], I = (C >>> 0) / (y >>> 0) | 0, y >>> 0 > I >>> 0)
                        break e;
                      if (l = l + 1 | 0, (No(y, I) | 0) != (C | 0))
                        continue;
                    }
                    break;
                  }
                  C = Q + 1 | 0, l = (C | 0) == 48, Q = l ? 0 : C, S = l + S | 0, C = No(S, 210);
                }
              }
              return C | 0;
            }
            function Xa(l, y, I, C, Q, S, me, ke, Ar) {
              var br = 0, Qr = 0, Ur = 0, Xr = 0, Ri = 0, yn = 0, En = 0, Wn = 0, lo = 0, Ro = 0, Xo = 0, bs = 0, Os = 0, Gs = 0, aa = 0, Ma = 0, rf = 0, af = 0, lf = 0, wf = 0, Rf = 0, zf = 0, xc = 0, Oc = 0, Yc = 0, ou = 0, mu = 0, vu = 0, wu = 0, Lu = 0, qu = 0, Hu = 0, W1 = 0, J1 = 0;
              Qr = bi - 96 | 0, bi = Qr, bs = Ar & 65535, yn = (Q ^ Ar) & -2147483648, lo = Q & 65535, Ma = lo, W1 = Ar >>> 16 & 32767, J1 = Q >>> 16 & 32767;
              e: {
                t: {
                  if (W1 - 32767 >>> 0 > 4294934529 & J1 - 32767 >>> 0 >= 4294934530)
                    break t;
                  if (Ro = Q & 2147483647, Wn = Ro, br = C, !(!C & (Wn | 0) == 2147418112 ? !(y | I) : Wn >>> 0 < 2147418112)) {
                    Xr = C, yn = Q | 32768;
                    break e;
                  }
                  if (Ro = Ar & 2147483647, En = Ro, Q = ke, !(!Q & (En | 0) == 2147418112 ? !(S | me) : En >>> 0 < 2147418112)) {
                    Xr = Q, yn = Ar | 32768, y = S, I = me;
                    break e;
                  }
                  if (!(y | br | (Wn ^ 2147418112 | I))) {
                    if (!(Q | S | (me | En))) {
                      yn = 2147450880, y = 0, I = 0;
                      break e;
                    }
                    yn = yn | 2147418112, y = 0, I = 0;
                    break e;
                  }
                  if (!(Q | S | (En ^ 2147418112 | me))) {
                    if (Q = y | br, C = I | Wn, y = 0, I = 0, !(C | Q)) {
                      yn = 2147450880;
                      break e;
                    }
                    yn = yn | 2147418112;
                    break e;
                  }
                  if (!(y | br | (I | Wn))) {
                    y = 0, I = 0;
                    break e;
                  }
                  if (!(Q | S | (me | En))) {
                    y = 0, I = 0;
                    break e;
                  }
                  if ((Wn | 0) == 65535 | Wn >>> 0 < 65535 && (br = !(C | lo), Ar = br ? y : C, Ro = br << 6, Q = Ha(Ar) + 32 | 0, Ar = Ha(br ? I : lo), Ar = Ro + ((Ar | 0) == 32 ? Q : Ar) | 0, Es(Qr + 80 | 0, y, I, C, lo, Ar - 15 | 0), Xo = 16 - Ar | 0, C = e[Qr + 88 >> 2], Ma = e[Qr + 92 >> 2], I = e[Qr + 84 >> 2], y = e[Qr + 80 >> 2]), En >>> 0 > 65535)
                    break t;
                  Ar = !(ke | bs), Q = Ar ? S : ke, lo = Ar << 6, br = Ha(Q) + 32 | 0, Q = Ha(Ar ? me : bs), Q = lo + ((Q | 0) == 32 ? br : Q) | 0, Es(Qr - -64 | 0, S, me, ke, bs, Q - 15 | 0), Xo = (Xo - Q | 0) + 16 | 0, ke = e[Qr + 72 >> 2], bs = e[Qr + 76 >> 2], S = e[Qr + 64 >> 2], me = e[Qr + 68 >> 2];
                }
                Q = S, S = me << 15 | S >>> 17, Ar = Q << 15, Q = 0, Os = Ar & -32768, mu = I, Ro = Ua(Os, Q, I, 0), Q = Ci, rf = Q, vu = S, Wn = y, I = Ua(S, 0, y, 0), y = I + Ro | 0, S = Ci + Q | 0, Ar = y, I = y >>> 0 < I >>> 0 ? S + 1 | 0 : S, S = y, br = 0, y = Ua(Wn, Ur, Os, Ur), En = br + y | 0, Q = Ci + S | 0, Q = y >>> 0 > En >>> 0 ? Q + 1 | 0 : Q, lo = Q, wu = (S | 0) == (Q | 0) & br >>> 0 > En >>> 0 | Q >>> 0 < S >>> 0, Lu = C, Gs = Ua(Os, Ur, C, 0), qu = Ci, y = Ua(mu, Ur, vu, Ur), aa = y + Gs | 0, br = Ci + qu | 0, br = y >>> 0 > aa >>> 0 ? br + 1 | 0 : br, y = bs << 15 | ke >>> 17, af = ke << 15 | me >>> 17, C = Ua(af, 0, Wn, Ur), lf = C + aa | 0, S = Ci + br | 0, S = C >>> 0 > lf >>> 0 ? S + 1 | 0 : S, wf = S, C = (I | 0) == (rf | 0) & Ar >>> 0 < Ro >>> 0 | I >>> 0 < rf >>> 0, Rf = I + lf | 0, S = C + S | 0, S = I >>> 0 > Rf >>> 0 ? S + 1 | 0 : S, bs = S, me = Rf, I = S, zf = Ma | 65536, Ma = Ua(Os, Ur, zf, Ri), Hu = Ci, C = Ua(Lu, Xr, vu, Ur), xc = C + Ma | 0, Q = Ci + Hu | 0, Q = C >>> 0 > xc >>> 0 ? Q + 1 | 0 : Q, Ar = Q, Oc = y | -2147483648, y = Ua(Oc, 0, Wn, Ur), Yc = y + xc | 0, S = Ci + Q | 0, S = y >>> 0 > Yc >>> 0 ? S + 1 | 0 : S, C = Ua(af, Xr, mu, Ur), y = C + Yc | 0, ou = S, S = S + Ci | 0, rf = y, Ro = y >>> 0 < C >>> 0 ? S + 1 | 0 : S, S = y, y = 0, Wn = y + me | 0, Q = I + S | 0, Q = y >>> 0 > Wn >>> 0 ? Q + 1 | 0 : Q, Os = Q, S = Q, y = Wn + wu | 0, I = y >>> 0 < Wn >>> 0 ? S + 1 | 0 : S, Xo = ((J1 + W1 | 0) + Xo | 0) - 16383 | 0, C = Ua(Oc, Xr, mu, Ur), ke = Ci, Q = Ua(zf, Xr, vu, Ur), me = Q + C | 0, S = Ci + ke | 0, S = Q >>> 0 > me >>> 0 ? S + 1 | 0 : S, Ri = (ke | 0) == (S | 0) & C >>> 0 > me >>> 0 | S >>> 0 < ke >>> 0, ke = S, Q = Ua(af, Xr, Lu, Xr), C = Q + me | 0, S = Ci + S | 0, S = C >>> 0 < Q >>> 0 ? S + 1 | 0 : S, Q = S, me = (S | 0) == (ke | 0) & C >>> 0 < me >>> 0 | S >>> 0 < ke >>> 0, S = 0, ke = me, me = me + Ri | 0, S = ke >>> 0 > me >>> 0 ? 1 : S, ke = me, me = Ua(Oc, Xr, zf, Xr), ke = ke + me | 0, S = Ci + S | 0, wu = ke, me = me >>> 0 > ke >>> 0 ? S + 1 | 0 : S, ke = C, Ur = Q, Q = (br | 0) == (qu | 0) & Gs >>> 0 > aa >>> 0 | br >>> 0 < qu >>> 0, S = 0, br = (br | 0) == (wf | 0) & aa >>> 0 > lf >>> 0 | br >>> 0 > wf >>> 0, Ri = br, br = Q + br | 0, Q = (Ri >>> 0 > br >>> 0 ? 1 : S) + Ur | 0, S = me, C = C + br | 0, Q = C >>> 0 < br >>> 0 ? Q + 1 | 0 : Q, Ri = Q, Gs = C, C = (Q | 0) == (Ur | 0) & C >>> 0 < ke >>> 0 | Q >>> 0 < Ur >>> 0, Q = C, C = C + wu | 0, S = Q >>> 0 > C >>> 0 ? S + 1 | 0 : S, br = C, ke = S, Q = Ua(af, Xr, zf, Xr), Ur = Ci, me = Ua(Oc, Xr, Lu, Xr), C = me + Q | 0, S = Ci + Ur | 0, S = C >>> 0 < me >>> 0 ? S + 1 | 0 : S, me = S, S = (Ur | 0) == (S | 0) & C >>> 0 < Q >>> 0 | S >>> 0 < Ur >>> 0, aa = me + br | 0, Q = S + ke | 0, Q = me >>> 0 > aa >>> 0 ? Q + 1 | 0 : Q, Ur = aa, ke = Q, br = C, Q = 0, C = Q + Gs | 0, S = br + Ri | 0, S = C >>> 0 < Q >>> 0 ? S + 1 | 0 : S, Q = S, me = (Ri | 0) == (S | 0) & C >>> 0 < Gs >>> 0 | S >>> 0 < Ri >>> 0, S = ke, ke = me, me = me + Ur | 0, S = ke >>> 0 > me >>> 0 ? S + 1 | 0 : S, Gs = me, me = S, ke = C, br = Q, Q = (Ro | 0) == (ou | 0) & rf >>> 0 < Yc >>> 0 | Ro >>> 0 < ou >>> 0, C = (Ar | 0) == (Hu | 0) & Ma >>> 0 > xc >>> 0 | Ar >>> 0 < Hu >>> 0, Ar = (Ar | 0) == (ou | 0) & xc >>> 0 > Yc >>> 0 | Ar >>> 0 > ou >>> 0, C = C + Ar | 0, C = C + Q | 0, Ri = Ro, Ar = Ri + ke | 0, Q = C + br | 0, S = me, C = Ar, Q = C >>> 0 < Ri >>> 0 ? Q + 1 | 0 : Q, ke = (Q | 0) == (br | 0) & ke >>> 0 > C >>> 0 | Q >>> 0 < br >>> 0, me = ke + Gs | 0, S = ke >>> 0 > me >>> 0 ? S + 1 | 0 : S, br = me, me = S, ke = C, S = 0, Ar = Q, Ri = (bs | 0) == (Os | 0) & Wn >>> 0 < Rf >>> 0 | bs >>> 0 > Os >>> 0, Ur = Ri, Ri = Ri + ((bs | 0) == (wf | 0) & lf >>> 0 > Rf >>> 0 | bs >>> 0 < wf >>> 0) | 0, Q = Q + (Ur >>> 0 > Ri >>> 0 ? 1 : S) | 0, S = me, C = C + Ri | 0, Q = C >>> 0 < Ri >>> 0 ? Q + 1 | 0 : Q, ke = (Q | 0) == (Ar | 0) & C >>> 0 < ke >>> 0 | Q >>> 0 < Ar >>> 0, me = ke, ke = ke + br | 0, S = me >>> 0 > ke >>> 0 ? S + 1 | 0 : S, Ar = S;
                t: {
                  if (S & 65536) {
                    Xo = Xo + 1 | 0;
                    break t;
                  }
                  br = lo >>> 31 | 0, me = 0, S = Ar << 1 | ke >>> 31, ke = ke << 1 | Q >>> 31, Ar = S, S = Q << 1 | C >>> 31, C = C << 1 | I >>> 31, Q = S, S = lo << 1 | En >>> 31, En = En << 1, lo = S, S = I << 1 | y >>> 31, y = y << 1 | br, I = S | me;
                }
                if ((Xo | 0) >= 32767) {
                  yn = yn | 2147418112, y = 0, I = 0;
                  break e;
                }
                t: {
                  if ((Xo | 0) <= 0) {
                    if (me = 1 - Xo | 0, me >>> 0 <= 127) {
                      S = Xo + 127 | 0, Es(Qr + 48 | 0, En, lo, y, I, S), Es(Qr + 32 | 0, C, Q, ke, Ar, S), fn(Qr + 16 | 0, En, lo, y, I, me), fn(Qr, C, Q, ke, Ar, me), En = e[Qr + 32 >> 2] | e[Qr + 16 >> 2] | (e[Qr + 48 >> 2] | e[Qr + 56 >> 2] | (e[Qr + 52 >> 2] | e[Qr + 60 >> 2])) != 0, lo = e[Qr + 36 >> 2] | e[Qr + 20 >> 2], y = e[Qr + 40 >> 2] | e[Qr + 24 >> 2], I = e[Qr + 44 >> 2] | e[Qr + 28 >> 2], C = e[Qr >> 2], Q = e[Qr + 4 >> 2], me = e[Qr + 8 >> 2], S = e[Qr + 12 >> 2];
                      break t;
                    }
                    y = 0, I = 0;
                    break e;
                  }
                  me = ke, S = Ar & 65535 | Xo << 16;
                }
                if (Xr = me | Xr, yn = S | yn, !(!y & (I | 0) == -2147483648 ? !(En | lo) : (I | 0) > 0 | (I | 0) >= 0)) {
                  y = C + 1 | 0, br = y ? Q : Q + 1 | 0, Q = yn, I = br, C = !(br | y), Xr = C + Xr | 0, yn = C >>> 0 > Xr >>> 0 ? Q + 1 | 0 : Q;
                  break e;
                }
                if (y | En | (I ^ -2147483648 | lo)) {
                  y = C, I = Q;
                  break e;
                }
                S = Q, y = C & 1, I = y, y = y + C | 0, I = I >>> 0 > y >>> 0 ? S + 1 | 0 : S, C = (S | 0) == (I | 0) & y >>> 0 < C >>> 0 | I >>> 0 < S >>> 0, S = yn, Xr = C + Xr | 0, yn = Xr >>> 0 < C >>> 0 ? S + 1 | 0 : S;
              }
              e[l >> 2] = y, e[l + 4 >> 2] = I, e[l + 8 >> 2] = Xr, e[l + 12 >> 2] = yn, bi = Qr + 96 | 0;
            }
            function Sh() {
              var l = 0, y = 0, I = 0;
              if (Je[25020])
                return e[6254];
              e[6663] = 0, e[6662] = 22008, e[6662] = 14144, e[6662] = 12664, l = bi - 16 | 0, bi = l, e[6664] = 0, e[6665] = 0, e[6666] = 0, Se[26792] = 0, e[l + 4 >> 2] = 26656, I = e[l + 4 >> 2], y = l + 8 | 0, Se[y + 4 | 0] = 0, e[y >> 2] = I, e[5996] = 0, La(273, 26656), I = e[5996], e[5996] = 0;
              e: {
                if ((I | 0) != 1) {
                  cd(26656, 30), Se[y + 4 | 0] = 1, Rp(y), bi = l + 16 | 0;
                  break e;
                }
                y = gi() | 0, Rp(l + 8 | 0), ss(y | 0), jn();
              }
              e[5996] = 0, y = wn(30, 26800, 3538) | 0, l = e[5996], e[5996] = 0;
              e: {
                t: {
                  r: {
                    if ((l | 0) != 1) {
                      if (Kp(26656), e[6581] = 0, e[6580] = 22008, e[6580] = 14144, e[6580] = 15252, e[5996] = 0, La(240, 26648), l = e[5996], e[5996] = 0, (l | 0) == 1 || (e[6583] = 0, e[6582] = 22008, e[6582] = 14144, e[6582] = 15284, e[5996] = 0, La(241, 26648), l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[6585] = 0, e[6584] = 22008, e[6584] = 14144, Se[26348] = 0, e[6586] = 0, e[6584] = 12684, e[6586] = 12736, e[5996] = 0, La(242, 26648), l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[6589] = 0, e[6588] = 22008, e[6588] = 14144, e[6588] = 14200, e[5996] = 0, La(243, 26648), l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[6591] = 0, e[6590] = 22008, e[6590] = 14144, e[6590] = 14348, e[5996] = 0, La(244, 26648), l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, jo(245), l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, La(246, 26648), l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[6597] = 0, e[6596] = 22008, e[6596] = 14144, e[6596] = 14496, e[5996] = 0, La(247, 26648), l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[6599] = 0, e[6598] = 22008, e[6598] = 14144, e[6598] = 14728, e[5996] = 0, La(248, 26648), l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[6601] = 0, e[6600] = 22008, e[6600] = 14144, e[6600] = 14612, e[5996] = 0, La(249, 26648), l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[6603] = 0, e[6602] = 22008, e[6602] = 14144, e[6602] = 14844, e[5996] = 0, La(250, 26648), l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[6605] = 0, e[6604] = 22008, e[6604] = 14144, ea[13212] = 11310, e[6604] = 13816, e[6607] = 0, e[6608] = 0, e[6609] = 0, e[5996] = 0, La(251, 26648), l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[6611] = 0, e[6610] = 22008, e[6610] = 14144, e[6612] = 46, e[6613] = 44, e[6610] = 13856, e[6614] = 0, e[6615] = 0, e[6616] = 0, e[5996] = 0, La(252, 26648), l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[6619] = 0, e[6618] = 22008, e[6618] = 14144, e[6618] = 15316, e[5996] = 0, La(253, 26648), l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[6621] = 0, e[6620] = 22008, e[6620] = 14144, e[6620] = 15560, e[5996] = 0, La(254, 26648), l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[6623] = 0, e[6622] = 22008, e[6622] = 14144, e[6622] = 15772, e[5996] = 0, La(255, 26648), l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[6625] = 0, e[6624] = 22008, e[6624] = 14144, e[6624] = 16004, e[5996] = 0, La(256, 26648), l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[6627] = 0, e[6626] = 22008, e[6626] = 14144, e[6626] = 16988, e[5996] = 0, La(257, 26648), l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[6629] = 0, e[6628] = 22008, e[6628] = 14144, e[6628] = 17136, e[5996] = 0, La(258, 26648), l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[6631] = 0, e[6630] = 22008, e[6630] = 14144, e[6630] = 17252, e[5996] = 0, La(259, 26648), l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[6633] = 0, e[6632] = 22008, e[6632] = 14144, e[6632] = 17368, e[5996] = 0, La(260, 26648), l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[6635] = 0, e[6634] = 22008, e[6634] = 14144, e[6634] = 17484, e[5996] = 0, La(261, 26648), l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[6637] = 0, e[6636] = 22008, e[6636] = 14144, e[6636] = 17648, e[5996] = 0, La(262, 26648), l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[6639] = 0, e[6638] = 22008, e[6638] = 14144, e[6638] = 17812, e[5996] = 0, La(263, 26648), l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[6641] = 0, e[6640] = 22008, e[6640] = 14144, e[6640] = 17976, e[5996] = 0, La(264, 26648), l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[6643] = 0, e[6642] = 22008, e[6642] = 14144, e[6644] = 19232, e[6644] = 16252, e[6642] = 16204, e[5996] = 0, La(265, 26648), l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[6647] = 0, e[6646] = 22008, e[6646] = 14144, e[6648] = 19268, e[6648] = 16516, e[6646] = 16468, e[5996] = 0, La(266, 26648), l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, jo(267), l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, La(268, 26648), l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, jo(269), l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[5996] = 0, La(270, 26648), l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[6659] = 0, e[6658] = 22008, e[6658] = 14144, e[6658] = 18140, e[5996] = 0, La(271, 26648), l = e[5996], e[5996] = 0, (l | 0) == 1) || (e[6661] = 0, e[6660] = 22008, e[6660] = 14144, e[6660] = 18260, e[5996] = 0, La(272, 26648), l = e[5996], e[5996] = 0, (l | 0) == 1))
                        break r;
                      break e;
                    }
                    l = gi() | 0;
                    break t;
                  }
                  l = gi() | 0, Yo(y);
                }
                sp(26656), ss(l | 0), jn();
              }
              return e[6253] = 26648, Se[25020] = 1, e[6254] = 25012, 25012;
            }
            function Th(l, y, I, C, Q, S, me, ke) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0, me = me | 0, ke = ke | 0;
              var Ar = 0, br = 0, Qr = 0;
              ke = bi - 48 | 0, bi = ke, e[ke + 44 >> 2] = y, e[Q >> 2] = 0, Ar = e[C + 28 >> 2], e[ke >> 2] = Ar, e[Ar + 4 >> 2] = e[Ar + 4 >> 2] + 1, e[5996] = 0, Ar = no(197, e[ke >> 2]) | 0, br = e[5996], e[5996] = 0;
              e: {
                t: {
                  r: {
                    i: {
                      n: {
                        o: {
                          a: {
                            s: {
                              A: {
                                u: {
                                  h: {
                                    c: {
                                      f: {
                                        p: {
                                          d: {
                                            g: {
                                              v: {
                                                _: {
                                                  R: {
                                                    k: {
                                                      S: {
                                                        E: {
                                                          w: {
                                                            I: {
                                                              l: {
                                                                T: {
                                                                  m: {
                                                                    if ((br | 0) != 1)
                                                                      switch (br = e[ke >> 2], Qr = e[br + 4 >> 2] - 1 | 0, e[br + 4 >> 2] = Qr, (Qr | 0) == -1 && Yn[e[e[br >> 2] + 8 >> 2]](br), me - 65 | 0) {
                                                                        case 54:
                                                                          break u;
                                                                        case 19:
                                                                          break h;
                                                                        case 18:
                                                                          break c;
                                                                        case 17:
                                                                          break f;
                                                                        case 49:
                                                                          break p;
                                                                        case 47:
                                                                          break d;
                                                                        case 45:
                                                                        case 51:
                                                                          break g;
                                                                        case 12:
                                                                          break v;
                                                                        case 44:
                                                                          break _;
                                                                        case 41:
                                                                          break R;
                                                                        case 8:
                                                                          break k;
                                                                        case 7:
                                                                          break S;
                                                                        case 5:
                                                                          break E;
                                                                        case 3:
                                                                          break w;
                                                                        case 35:
                                                                        case 36:
                                                                          break I;
                                                                        case 34:
                                                                          break l;
                                                                        case 1:
                                                                        case 33:
                                                                        case 39:
                                                                          break T;
                                                                        case 0:
                                                                        case 32:
                                                                          break m;
                                                                        case 2:
                                                                        case 4:
                                                                        case 6:
                                                                        case 9:
                                                                        case 10:
                                                                        case 11:
                                                                        case 13:
                                                                        case 14:
                                                                        case 15:
                                                                        case 16:
                                                                        case 20:
                                                                        case 21:
                                                                        case 22:
                                                                        case 25:
                                                                        case 26:
                                                                        case 27:
                                                                        case 28:
                                                                        case 29:
                                                                        case 30:
                                                                        case 31:
                                                                        case 37:
                                                                        case 38:
                                                                        case 40:
                                                                        case 42:
                                                                        case 43:
                                                                        case 46:
                                                                        case 48:
                                                                        case 50:
                                                                        case 52:
                                                                        case 53:
                                                                          break i;
                                                                        case 24:
                                                                          break o;
                                                                        case 56:
                                                                          break a;
                                                                        case 23:
                                                                          break s;
                                                                        case 55:
                                                                          break A;
                                                                        default:
                                                                          break n;
                                                                      }
                                                                    I = gi() | 0, l = e[ke >> 2], y = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = y, (y | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), ss(I | 0), jn();
                                                                  }
                                                                  Od(l, S + 24 | 0, ke + 44 | 0, I, Q, Ar);
                                                                  break t;
                                                                }
                                                                Md(l, S + 16 | 0, ke + 44 | 0, I, Q, Ar);
                                                                break t;
                                                              }
                                                              me = Yn[e[e[l + 8 >> 2] + 12 >> 2]](l + 8 | 0) | 0, Ar = Je[me + 11 | 0], br = l, Qr = y, y = (Ar & 128) >>> 7 | 0, l = y ? e[me >> 2] : me, e[ke + 44 >> 2] = yc(br, Qr, I, C, Q, S, l, l + ((y ? e[me + 4 >> 2] : Ar & 127) << 2) | 0);
                                                              break t;
                                                            }
                                                            l = to(ke + 44 | 0, I, Q, Ar, 2), y = e[Q >> 2];
                                                            I: {
                                                              if (!(l - 1 >>> 0 > 30 | y & 4)) {
                                                                e[S + 12 >> 2] = l;
                                                                break I;
                                                              }
                                                              e[Q >> 2] = y | 4;
                                                            }
                                                            break t;
                                                          }
                                                          me = e[3127], e[ke + 24 >> 2] = e[3126], e[ke + 28 >> 2] = me, me = e[3125], e[ke + 16 >> 2] = e[3124], e[ke + 20 >> 2] = me, me = e[3123], e[ke + 8 >> 2] = e[3122], e[ke + 12 >> 2] = me, me = e[3121], e[ke >> 2] = e[3120], e[ke + 4 >> 2] = me, e[ke + 44 >> 2] = yc(l, y, I, C, Q, S, ke, ke + 32 | 0);
                                                          break t;
                                                        }
                                                        me = e[3135], e[ke + 24 >> 2] = e[3134], e[ke + 28 >> 2] = me, me = e[3133], e[ke + 16 >> 2] = e[3132], e[ke + 20 >> 2] = me, me = e[3131], e[ke + 8 >> 2] = e[3130], e[ke + 12 >> 2] = me, me = e[3129], e[ke >> 2] = e[3128], e[ke + 4 >> 2] = me, e[ke + 44 >> 2] = yc(l, y, I, C, Q, S, ke, ke + 32 | 0);
                                                        break t;
                                                      }
                                                      l = to(ke + 44 | 0, I, Q, Ar, 2), y = e[Q >> 2];
                                                      S: {
                                                        if (!((l | 0) > 23 | y & 4)) {
                                                          e[S + 8 >> 2] = l;
                                                          break S;
                                                        }
                                                        e[Q >> 2] = y | 4;
                                                      }
                                                      break t;
                                                    }
                                                    l = to(ke + 44 | 0, I, Q, Ar, 2), y = e[Q >> 2];
                                                    k: {
                                                      if (!(l - 1 >>> 0 > 11 | y & 4)) {
                                                        e[S + 8 >> 2] = l;
                                                        break k;
                                                      }
                                                      e[Q >> 2] = y | 4;
                                                    }
                                                    break t;
                                                  }
                                                  l = to(ke + 44 | 0, I, Q, Ar, 3), y = e[Q >> 2];
                                                  R: {
                                                    if (!((l | 0) > 365 | y & 4)) {
                                                      e[S + 28 >> 2] = l;
                                                      break R;
                                                    }
                                                    e[Q >> 2] = y | 4;
                                                  }
                                                  break t;
                                                }
                                                y = to(ke + 44 | 0, I, Q, Ar, 2) - 1 | 0, l = e[Q >> 2];
                                                _: {
                                                  if (!(y >>> 0 > 11 | l & 4)) {
                                                    e[S + 16 >> 2] = y;
                                                    break _;
                                                  }
                                                  e[Q >> 2] = l | 4;
                                                }
                                                break t;
                                              }
                                              l = to(ke + 44 | 0, I, Q, Ar, 2), y = e[Q >> 2];
                                              v: {
                                                if (!((l | 0) > 59 | y & 4)) {
                                                  e[S + 4 >> 2] = l;
                                                  break v;
                                                }
                                                e[Q >> 2] = y | 4;
                                              }
                                              break t;
                                            }
                                            for (l = ke + 44 | 0, y = bi - 16 | 0, bi = y, e[y + 12 >> 2] = I; ; ) {
                                              g: {
                                                if (Dc(l, y + 12 | 0))
                                                  break g;
                                                I = e[l >> 2], C = e[I + 12 >> 2];
                                                v: {
                                                  if ((C | 0) == e[I + 16 >> 2]) {
                                                    I = Yn[e[e[I >> 2] + 36 >> 2]](I) | 0;
                                                    break v;
                                                  }
                                                  I = e[C >> 2];
                                                }
                                                if (!(Yn[e[e[Ar >> 2] + 12 >> 2]](Ar, 1, I) | 0))
                                                  break g;
                                                vh(l);
                                                continue;
                                              }
                                              break;
                                            }
                                            Dc(l, y + 12 | 0) && (e[Q >> 2] = e[Q >> 2] | 2), bi = y + 16 | 0;
                                            break t;
                                          }
                                          C = ke + 44 | 0, l = Yn[e[e[l + 8 >> 2] + 8 >> 2]](l + 8 | 0) | 0, y = Je[l + 11 | 0], me = (y & 128) >>> 7 | 0 ? e[l + 4 >> 2] : y & 127, y = Je[l + 23 | 0];
                                          d: {
                                            if ((me | 0) == (0 - ((y & 128) >>> 7 | 0 ? e[l + 16 >> 2] : y & 127) | 0)) {
                                              e[Q >> 2] = e[Q >> 2] | 4;
                                              break d;
                                            }
                                            if (I = _u(C, I, l, l + 24 | 0, Ar, Q, 0), y = e[S + 8 >> 2], !((I | 0) != (l | 0) | (y | 0) != 12)) {
                                              e[S + 8 >> 2] = 0;
                                              break d;
                                            }
                                            (I - l | 0) != 12 | (y | 0) > 11 || (e[S + 8 >> 2] = y + 12);
                                          }
                                          break t;
                                        }
                                        me = Sa(ke, 12544, 44), e[me + 44 >> 2] = yc(l, y, I, C, Q, S, me, me + 44 | 0);
                                        break t;
                                      }
                                      e[ke + 16 >> 2] = e[3152], me = e[3151], e[ke + 8 >> 2] = e[3150], e[ke + 12 >> 2] = me, me = e[3149], e[ke >> 2] = e[3148], e[ke + 4 >> 2] = me, e[ke + 44 >> 2] = yc(l, y, I, C, Q, S, ke, ke + 20 | 0);
                                      break t;
                                    }
                                    l = to(ke + 44 | 0, I, Q, Ar, 2), y = e[Q >> 2];
                                    c: {
                                      if (!((l | 0) > 60 | y & 4)) {
                                        e[S >> 2] = l;
                                        break c;
                                      }
                                      e[Q >> 2] = y | 4;
                                    }
                                    break t;
                                  }
                                  me = e[3163], e[ke + 24 >> 2] = e[3162], e[ke + 28 >> 2] = me, me = e[3161], e[ke + 16 >> 2] = e[3160], e[ke + 20 >> 2] = me, me = e[3159], e[ke + 8 >> 2] = e[3158], e[ke + 12 >> 2] = me, me = e[3157], e[ke >> 2] = e[3156], e[ke + 4 >> 2] = me, e[ke + 44 >> 2] = yc(l, y, I, C, Q, S, ke, ke + 32 | 0);
                                  break t;
                                }
                                l = to(ke + 44 | 0, I, Q, Ar, 1), y = e[Q >> 2];
                                u: {
                                  if (!((l | 0) > 6 | y & 4)) {
                                    e[S + 24 >> 2] = l;
                                    break u;
                                  }
                                  e[Q >> 2] = y | 4;
                                }
                                break t;
                              }
                              l = Yn[e[e[l >> 2] + 20 >> 2]](l, y, I, C, Q, S) | 0;
                              break e;
                            }
                            me = Yn[e[e[l + 8 >> 2] + 24 >> 2]](l + 8 | 0) | 0, Ar = Je[me + 11 | 0], br = l, Qr = y, y = (Ar & 128) >>> 7 | 0, l = y ? e[me >> 2] : me, e[ke + 44 >> 2] = yc(br, Qr, I, C, Q, S, l, l + ((y ? e[me + 4 >> 2] : Ar & 127) << 2) | 0);
                            break t;
                          }
                          Kd(S + 20 | 0, ke + 44 | 0, I, Q, Ar);
                          break t;
                        }
                        l = to(ke + 44 | 0, I, Q, Ar, 4), Je[Q | 0] & 4 || (e[S + 20 >> 2] = l - 1900);
                        break t;
                      }
                      if ((me | 0) == 37)
                        break r;
                    }
                    e[Q >> 2] = e[Q >> 2] | 4;
                    break t;
                  }
                  l = bi - 16 | 0, bi = l, e[l + 12 >> 2] = I, y = 6, C = ke + 44 | 0, me = l + 12 | 0;
                  r: {
                    i: {
                      if (Dc(C, me))
                        break i;
                      y = 4, I = e[C >> 2], S = e[I + 12 >> 2];
                      n: {
                        if ((S | 0) == e[I + 16 >> 2]) {
                          I = Yn[e[e[I >> 2] + 36 >> 2]](I) | 0;
                          break n;
                        }
                        I = e[S >> 2];
                      }
                      if ((Yn[e[e[Ar >> 2] + 52 >> 2]](Ar, I, 0) | 0) != 37)
                        break i;
                      if (y = 2, !Dc(vh(C), me))
                        break r;
                    }
                    e[Q >> 2] = e[Q >> 2] | y;
                  }
                  bi = l + 16 | 0;
                }
                l = e[ke + 44 >> 2];
              }
              return bi = ke + 48 | 0, l | 0;
            }
            function Sf(l, y) {
              l = l | 0, y = y | 0;
              var I = 0, C = 0, Q = 0, S = 0, me = 0, ke = 0, Ar = 0;
              me = e[y + 4 >> 2] - e[y >> 2] | 0;
              e: {
                if (me >>> 0 <= 75) {
                  I = Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24), C = I - 29 | 0, Q = I >>> 0 < 29 ? I : C, S = Q + 1 | 0, S >>> 0 > (I >>> 0 <= 28 ? 28 : Je[l + 4 | 0] | Je[l + 5 | 0] << 8 | (Je[l + 6 | 0] << 16 | Je[l + 7 | 0] << 24)) >>> 0 && (D2(l, S + (S >>> 1 | 0) | 0), I = Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24), C = I - 29 | 0), ke = I >>> 0 < 29, S = Q + (ke ? l + 4 | 0 : Je[l + 8 | 0] | Je[l + 9 | 0] << 8 | (Je[l + 10 | 0] << 16 | Je[l + 11 | 0] << 24)) | 0, ve(S + 1 | 0, S, (ke ? I : C) - Q | 0), I = (Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24)) + 1 | 0, Se[l | 0] = I, Se[l + 1 | 0] = I >>> 8, Se[l + 2 | 0] = I >>> 16, Se[l + 3 | 0] = I >>> 24, Se[S | 0] = me;
                  break e;
                }
                if (me >>> 0 <= 255) {
                  I = Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24), C = I - 29 | 0, Q = I >>> 0 < 29 ? I : C, S = Q + 1 | 0, S >>> 0 > (I >>> 0 <= 28 ? 28 : Je[l + 4 | 0] | Je[l + 5 | 0] << 8 | (Je[l + 6 | 0] << 16 | Je[l + 7 | 0] << 24)) >>> 0 && (D2(l, S + (S >>> 1 | 0) | 0), I = Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24), C = I - 29 | 0), ke = l + 4 | 0, me = I >>> 0 < 29, S = Q + (me ? ke : Je[l + 8 | 0] | Je[l + 9 | 0] << 8 | (Je[l + 10 | 0] << 16 | Je[l + 11 | 0] << 24)) | 0, ve(S + 1 | 0, S, (me ? I : C) - Q | 0), I = (Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24)) + 1 | 0, Se[l | 0] = I, Se[l + 1 | 0] = I >>> 8, Se[l + 2 | 0] = I >>> 16, Se[l + 3 | 0] = I >>> 24, Se[S | 0] = 76, me = e[y + 4 >> 2] - e[y >> 2] | 0, I = Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24), C = I - 29 | 0, Q = I >>> 0 < 29 ? I : C, S = Q + 1 | 0, S >>> 0 > (I >>> 0 <= 28 ? 28 : Je[l + 4 | 0] | Je[l + 5 | 0] << 8 | (Je[l + 6 | 0] << 16 | Je[l + 7 | 0] << 24)) >>> 0 && (D2(l, S + (S >>> 1 | 0) | 0), I = Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24), C = I - 29 | 0), Ar = ke, ke = I >>> 0 < 29, S = Q + (ke ? Ar : Je[l + 8 | 0] | Je[l + 9 | 0] << 8 | (Je[l + 10 | 0] << 16 | Je[l + 11 | 0] << 24)) | 0, ve(S + 1 | 0, S, (ke ? I : C) - Q | 0), I = (Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24)) + 1 | 0, Se[l | 0] = I, Se[l + 1 | 0] = I >>> 8, Se[l + 2 | 0] = I >>> 16, Se[l + 3 | 0] = I >>> 24, Se[S | 0] = me;
                  break e;
                }
                if (I = Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24), Q = I - 29 | 0, S = I >>> 0 < 29 ? I : Q, C = S + 1 | 0, Ar = I >>> 0 <= 28 ? 28 : Je[l + 4 | 0] | Je[l + 5 | 0] << 8 | (Je[l + 6 | 0] << 16 | Je[l + 7 | 0] << 24), ke = l + 4 | 0, me >>> 0 <= 65535) {
                  C >>> 0 > Ar >>> 0 && (D2(l, C + (C >>> 1 | 0) | 0), I = Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24), Q = I - 29 | 0), me = I >>> 0 < 29, C = S + (me ? ke : Je[l + 8 | 0] | Je[l + 9 | 0] << 8 | (Je[l + 10 | 0] << 16 | Je[l + 11 | 0] << 24)) | 0, ve(C + 1 | 0, C, (me ? I : Q) - S | 0), I = (Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24)) + 1 | 0, Se[l | 0] = I, Se[l + 1 | 0] = I >>> 8, Se[l + 2 | 0] = I >>> 16, Se[l + 3 | 0] = I >>> 24, Se[C | 0] = 77, S = e[y + 4 >> 2] - e[y >> 2] | 0, I = Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24), C = I - 29 | 0, me = I >>> 0 < 29 ? I : C, Q = me + 2 | 0, Q >>> 0 > (I >>> 0 <= 28 ? 28 : Je[l + 4 | 0] | Je[l + 5 | 0] << 8 | (Je[l + 6 | 0] << 16 | Je[l + 7 | 0] << 24)) >>> 0 && (D2(l, Q + (Q >>> 1 | 0) | 0), I = Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24), C = I - 29 | 0), Ar = ke, ke = I >>> 0 < 29, Q = me + (ke ? Ar : Je[l + 8 | 0] | Je[l + 9 | 0] << 8 | (Je[l + 10 | 0] << 16 | Je[l + 11 | 0] << 24)) | 0, ve(Q + 2 | 0, Q, (ke ? I : C) - me | 0), I = (Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24)) + 2 | 0, Se[l | 0] = I, Se[l + 1 | 0] = I >>> 8, Se[l + 2 | 0] = I >>> 16, Se[l + 3 | 0] = I >>> 24, Se[Q | 0] = S, Se[Q + 1 | 0] = S >>> 8;
                  break e;
                }
                C >>> 0 > Ar >>> 0 && (D2(l, C + (C >>> 1 | 0) | 0), I = Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24), Q = I - 29 | 0), me = I >>> 0 < 29, C = S + (me ? ke : Je[l + 8 | 0] | Je[l + 9 | 0] << 8 | (Je[l + 10 | 0] << 16 | Je[l + 11 | 0] << 24)) | 0, ve(C + 1 | 0, C, (me ? I : Q) - S | 0), I = (Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24)) + 1 | 0, Se[l | 0] = I, Se[l + 1 | 0] = I >>> 8, Se[l + 2 | 0] = I >>> 16, Se[l + 3 | 0] = I >>> 24, Se[C | 0] = 78, S = e[y + 4 >> 2] - e[y >> 2] | 0, I = Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24), C = I - 29 | 0, me = I >>> 0 < 29 ? I : C, Q = me + 4 | 0, Q >>> 0 > (I >>> 0 <= 28 ? 28 : Je[l + 4 | 0] | Je[l + 5 | 0] << 8 | (Je[l + 6 | 0] << 16 | Je[l + 7 | 0] << 24)) >>> 0 && (D2(l, Q + (Q >>> 1 | 0) | 0), I = Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24), C = I - 29 | 0), Ar = ke, ke = I >>> 0 < 29, Q = me + (ke ? Ar : Je[l + 8 | 0] | Je[l + 9 | 0] << 8 | (Je[l + 10 | 0] << 16 | Je[l + 11 | 0] << 24)) | 0, ve(Q + 4 | 0, Q, (ke ? I : C) - me | 0), I = (Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24)) + 4 | 0, Se[l | 0] = I, Se[l + 1 | 0] = I >>> 8, Se[l + 2 | 0] = I >>> 16, Se[l + 3 | 0] = I >>> 24, Se[Q | 0] = S, Se[Q + 1 | 0] = S >>> 8, Se[Q + 2 | 0] = S >>> 16, Se[Q + 3 | 0] = S >>> 24;
              }
              C = Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24), Q = C - 29 | 0, S = e[y + 4 >> 2], y = e[y >> 2], ke = S - y | 0, me = C >>> 0 < 29 ? C : Q, I = ke + me | 0, I >>> 0 > (C >>> 0 <= 28 ? 28 : Je[l + 4 | 0] | Je[l + 5 | 0] << 8 | (Je[l + 6 | 0] << 16 | Je[l + 7 | 0] << 24)) >>> 0 && (D2(l, I + (I >>> 1 | 0) | 0), C = Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24), Q = C - 29 | 0), Ar = C >>> 0 < 29, I = me + (Ar ? l + 4 | 0 : Je[l + 8 | 0] | Je[l + 9 | 0] << 8 | (Je[l + 10 | 0] << 16 | Je[l + 11 | 0] << 24)) | 0, ve(ke + I | 0, I, (Ar ? C : Q) - me | 0), C = ke + (Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24)) | 0, Se[l | 0] = C, Se[l + 1 | 0] = C >>> 8, Se[l + 2 | 0] = C >>> 16, Se[l + 3 | 0] = C >>> 24;
              e: {
                if ((y | 0) == (S | 0))
                  break e;
                if (Q = S + (y ^ -1) | 0, ke = ke & 7, ke)
                  for (C = 0; Se[I | 0] = Je[y | 0], y = y + 1 | 0, I = I + 1 | 0, C = C + 1 | 0, (ke | 0) != (C | 0); )
                    ;
                if (Q >>> 0 < 7)
                  break e;
                for (; Se[I | 0] = Je[y | 0], Se[I + 1 | 0] = Je[y + 1 | 0], Se[I + 2 | 0] = Je[y + 2 | 0], Se[I + 3 | 0] = Je[y + 3 | 0], Se[I + 4 | 0] = Je[y + 4 | 0], Se[I + 5 | 0] = Je[y + 5 | 0], Se[I + 6 | 0] = Je[y + 6 | 0], Se[I + 7 | 0] = Je[y + 7 | 0], I = I + 8 | 0, y = y + 8 | 0, (S | 0) != (y | 0); )
                  ;
              }
              return l | 0;
            }
            function fl(l, y, I, C, Q, S, me, ke) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0, me = me | 0, ke = ke | 0;
              var Ar = 0, br = 0, Qr = 0;
              ke = bi - 16 | 0, bi = ke, e[ke + 12 >> 2] = y, e[Q >> 2] = 0, Ar = e[C + 28 >> 2], e[ke >> 2] = Ar, e[Ar + 4 >> 2] = e[Ar + 4 >> 2] + 1, e[5996] = 0, Ar = no(170, e[ke >> 2]) | 0, br = e[5996], e[5996] = 0;
              e: {
                t: {
                  r: {
                    i: {
                      n: {
                        o: {
                          a: {
                            s: {
                              A: {
                                u: {
                                  h: {
                                    c: {
                                      f: {
                                        p: {
                                          d: {
                                            g: {
                                              v: {
                                                _: {
                                                  R: {
                                                    k: {
                                                      S: {
                                                        E: {
                                                          w: {
                                                            I: {
                                                              l: {
                                                                T: {
                                                                  m: {
                                                                    if ((br | 0) != 1)
                                                                      switch (br = e[ke >> 2], Qr = e[br + 4 >> 2] - 1 | 0, e[br + 4 >> 2] = Qr, (Qr | 0) == -1 && Yn[e[e[br >> 2] + 8 >> 2]](br), me - 65 | 0) {
                                                                        case 54:
                                                                          break u;
                                                                        case 19:
                                                                          break h;
                                                                        case 18:
                                                                          break c;
                                                                        case 17:
                                                                          break f;
                                                                        case 49:
                                                                          break p;
                                                                        case 47:
                                                                          break d;
                                                                        case 45:
                                                                        case 51:
                                                                          break g;
                                                                        case 12:
                                                                          break v;
                                                                        case 44:
                                                                          break _;
                                                                        case 41:
                                                                          break R;
                                                                        case 8:
                                                                          break k;
                                                                        case 7:
                                                                          break S;
                                                                        case 5:
                                                                          break E;
                                                                        case 3:
                                                                          break w;
                                                                        case 35:
                                                                        case 36:
                                                                          break I;
                                                                        case 34:
                                                                          break l;
                                                                        case 1:
                                                                        case 33:
                                                                        case 39:
                                                                          break T;
                                                                        case 0:
                                                                        case 32:
                                                                          break m;
                                                                        case 2:
                                                                        case 4:
                                                                        case 6:
                                                                        case 9:
                                                                        case 10:
                                                                        case 11:
                                                                        case 13:
                                                                        case 14:
                                                                        case 15:
                                                                        case 16:
                                                                        case 20:
                                                                        case 21:
                                                                        case 22:
                                                                        case 25:
                                                                        case 26:
                                                                        case 27:
                                                                        case 28:
                                                                        case 29:
                                                                        case 30:
                                                                        case 31:
                                                                        case 37:
                                                                        case 38:
                                                                        case 40:
                                                                        case 42:
                                                                        case 43:
                                                                        case 46:
                                                                        case 48:
                                                                        case 50:
                                                                        case 52:
                                                                        case 53:
                                                                          break i;
                                                                        case 24:
                                                                          break o;
                                                                        case 56:
                                                                          break a;
                                                                        case 23:
                                                                          break s;
                                                                        case 55:
                                                                          break A;
                                                                        default:
                                                                          break n;
                                                                      }
                                                                    I = gi() | 0, l = e[ke >> 2], y = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = y, (y | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), ss(I | 0), jn();
                                                                  }
                                                                  Nd(l, S + 24 | 0, ke + 12 | 0, I, Q, Ar);
                                                                  break t;
                                                                }
                                                                Pd(l, S + 16 | 0, ke + 12 | 0, I, Q, Ar);
                                                                break t;
                                                              }
                                                              me = Yn[e[e[l + 8 >> 2] + 12 >> 2]](l + 8 | 0) | 0, Ar = Je[me + 11 | 0], br = l, Qr = y, y = (Ar & 128) >>> 7 | 0, l = y ? e[me >> 2] : me, e[ke + 12 >> 2] = Ec(br, Qr, I, C, Q, S, l, l + (y ? e[me + 4 >> 2] : Ar & 127) | 0);
                                                              break t;
                                                            }
                                                            l = Br(ke + 12 | 0, I, Q, Ar, 2), y = e[Q >> 2];
                                                            I: {
                                                              if (!(l - 1 >>> 0 > 30 | y & 4)) {
                                                                e[S + 12 >> 2] = l;
                                                                break I;
                                                              }
                                                              e[Q >> 2] = y | 4;
                                                            }
                                                            break t;
                                                          }
                                                          e[ke >> 2] = 623865125, e[ke + 4 >> 2] = 2032480100, e[ke + 12 >> 2] = Ec(l, y, I, C, Q, S, ke, ke + 8 | 0);
                                                          break t;
                                                        }
                                                        e[ke >> 2] = 623728933, e[ke + 4 >> 2] = 1680158061, e[ke + 12 >> 2] = Ec(l, y, I, C, Q, S, ke, ke + 8 | 0);
                                                        break t;
                                                      }
                                                      l = Br(ke + 12 | 0, I, Q, Ar, 2), y = e[Q >> 2];
                                                      S: {
                                                        if (!((l | 0) > 23 | y & 4)) {
                                                          e[S + 8 >> 2] = l;
                                                          break S;
                                                        }
                                                        e[Q >> 2] = y | 4;
                                                      }
                                                      break t;
                                                    }
                                                    l = Br(ke + 12 | 0, I, Q, Ar, 2), y = e[Q >> 2];
                                                    k: {
                                                      if (!(l - 1 >>> 0 > 11 | y & 4)) {
                                                        e[S + 8 >> 2] = l;
                                                        break k;
                                                      }
                                                      e[Q >> 2] = y | 4;
                                                    }
                                                    break t;
                                                  }
                                                  l = Br(ke + 12 | 0, I, Q, Ar, 3), y = e[Q >> 2];
                                                  R: {
                                                    if (!((l | 0) > 365 | y & 4)) {
                                                      e[S + 28 >> 2] = l;
                                                      break R;
                                                    }
                                                    e[Q >> 2] = y | 4;
                                                  }
                                                  break t;
                                                }
                                                y = Br(ke + 12 | 0, I, Q, Ar, 2) - 1 | 0, l = e[Q >> 2];
                                                _: {
                                                  if (!(y >>> 0 > 11 | l & 4)) {
                                                    e[S + 16 >> 2] = y;
                                                    break _;
                                                  }
                                                  e[Q >> 2] = l | 4;
                                                }
                                                break t;
                                              }
                                              l = Br(ke + 12 | 0, I, Q, Ar, 2), y = e[Q >> 2];
                                              v: {
                                                if (!((l | 0) > 59 | y & 4)) {
                                                  e[S + 4 >> 2] = l;
                                                  break v;
                                                }
                                                e[Q >> 2] = y | 4;
                                              }
                                              break t;
                                            }
                                            for (l = ke + 12 | 0, y = bi - 16 | 0, bi = y, e[y + 12 >> 2] = I; ; ) {
                                              g: {
                                                if (Tc(l, y + 12 | 0))
                                                  break g;
                                                I = e[l >> 2], C = e[I + 12 >> 2];
                                                v: {
                                                  if ((C | 0) == e[I + 16 >> 2]) {
                                                    I = Yn[e[e[I >> 2] + 36 >> 2]](I) | 0;
                                                    break v;
                                                  }
                                                  I = Je[C | 0];
                                                }
                                                if (C = e[Ar + 8 >> 2], I = I << 24 >> 24, (I | 0) >= 0 ? I = e[C + ((I & 255) << 2) >> 2] & 1 : I = 0, !I)
                                                  break g;
                                                mh(l);
                                                continue;
                                              }
                                              break;
                                            }
                                            Tc(l, y + 12 | 0) && (e[Q >> 2] = e[Q >> 2] | 2), bi = y + 16 | 0;
                                            break t;
                                          }
                                          C = ke + 12 | 0, l = Yn[e[e[l + 8 >> 2] + 8 >> 2]](l + 8 | 0) | 0, y = Je[l + 11 | 0], me = (y & 128) >>> 7 | 0 ? e[l + 4 >> 2] : y & 127, y = Je[l + 23 | 0];
                                          d: {
                                            if ((me | 0) == (0 - ((y & 128) >>> 7 | 0 ? e[l + 16 >> 2] : y & 127) | 0)) {
                                              e[Q >> 2] = e[Q >> 2] | 4;
                                              break d;
                                            }
                                            if (I = Cc(C, I, l, l + 24 | 0, Ar, Q, 0), y = e[S + 8 >> 2], !((I | 0) != (l | 0) | (y | 0) != 12)) {
                                              e[S + 8 >> 2] = 0;
                                              break d;
                                            }
                                            (I - l | 0) != 12 | (y | 0) > 11 || (e[S + 8 >> 2] = y + 12);
                                          }
                                          break t;
                                        }
                                        me = Je[12456] | Je[12457] << 8 | (Je[12458] << 16 | Je[12459] << 24), Se[ke + 7 | 0] = me, Se[ke + 8 | 0] = me >>> 8, Se[ke + 9 | 0] = me >>> 16, Se[ke + 10 | 0] = me >>> 24, me = Je[12453] | Je[12454] << 8 | (Je[12455] << 16 | Je[12456] << 24), e[ke >> 2] = Je[12449] | Je[12450] << 8 | (Je[12451] << 16 | Je[12452] << 24), e[ke + 4 >> 2] = me, e[ke + 12 >> 2] = Ec(l, y, I, C, Q, S, ke, ke + 11 | 0);
                                        break t;
                                      }
                                      Se[ke + 4 | 0] = Je[12464], e[ke >> 2] = Je[12460] | Je[12461] << 8 | (Je[12462] << 16 | Je[12463] << 24), e[ke + 12 >> 2] = Ec(l, y, I, C, Q, S, ke, ke + 5 | 0);
                                      break t;
                                    }
                                    l = Br(ke + 12 | 0, I, Q, Ar, 2), y = e[Q >> 2];
                                    c: {
                                      if (!((l | 0) > 60 | y & 4)) {
                                        e[S >> 2] = l;
                                        break c;
                                      }
                                      e[Q >> 2] = y | 4;
                                    }
                                    break t;
                                  }
                                  e[ke >> 2] = 624576549, e[ke + 4 >> 2] = 1394948685, e[ke + 12 >> 2] = Ec(l, y, I, C, Q, S, ke, ke + 8 | 0);
                                  break t;
                                }
                                l = Br(ke + 12 | 0, I, Q, Ar, 1), y = e[Q >> 2];
                                u: {
                                  if (!((l | 0) > 6 | y & 4)) {
                                    e[S + 24 >> 2] = l;
                                    break u;
                                  }
                                  e[Q >> 2] = y | 4;
                                }
                                break t;
                              }
                              l = Yn[e[e[l >> 2] + 20 >> 2]](l, y, I, C, Q, S) | 0;
                              break e;
                            }
                            me = Yn[e[e[l + 8 >> 2] + 24 >> 2]](l + 8 | 0) | 0, Ar = Je[me + 11 | 0], br = l, Qr = y, y = (Ar & 128) >>> 7 | 0, l = y ? e[me >> 2] : me, e[ke + 12 >> 2] = Ec(br, Qr, I, C, Q, S, l, l + (y ? e[me + 4 >> 2] : Ar & 127) | 0);
                            break t;
                          }
                          jd(S + 20 | 0, ke + 12 | 0, I, Q, Ar);
                          break t;
                        }
                        l = Br(ke + 12 | 0, I, Q, Ar, 4), Je[Q | 0] & 4 || (e[S + 20 >> 2] = l - 1900);
                        break t;
                      }
                      if ((me | 0) == 37)
                        break r;
                    }
                    e[Q >> 2] = e[Q >> 2] | 4;
                    break t;
                  }
                  l = bi - 16 | 0, bi = l, e[l + 12 >> 2] = I, y = 6, C = ke + 12 | 0, me = l + 12 | 0;
                  r: {
                    i: {
                      if (Tc(C, me))
                        break i;
                      y = 4, I = e[C >> 2], S = e[I + 12 >> 2];
                      n: {
                        if ((S | 0) == e[I + 16 >> 2]) {
                          I = Yn[e[e[I >> 2] + 36 >> 2]](I) | 0;
                          break n;
                        }
                        I = Je[S | 0];
                      }
                      if ((Yn[e[e[Ar >> 2] + 36 >> 2]](Ar, I << 24 >> 24, 0) | 0) != 37)
                        break i;
                      if (y = 2, !Tc(mh(C), me))
                        break r;
                    }
                    e[Q >> 2] = e[Q >> 2] | y;
                  }
                  bi = l + 16 | 0;
                }
                l = e[ke + 12 >> 2];
              }
              return bi = ke + 16 | 0, l | 0;
            }
            function bc(l, y, I, C, Q, S) {
              var me = 0, ke = 0, Ar = 0, br = 0, Qr = 0, Ur = 0, Xr = 0, Ri = 0;
              me = bi - 32 | 0, bi = me, Je[24588] || (e[6145] = 0, e[6146] = 0, e[6143] = 0, e[6144] = 0, e[6141] = 0, e[6142] = 0, Se[24588] = 1), Ar = 1 - Q;
              e: {
                t: {
                  r: {
                    i: {
                      n: {
                        o:
                          switch (y | 0) {
                            case 10:
                            case 11:
                            case 12:
                            case 16:
                              if (y = ga(8), e[me + 20 >> 2] = y, S = y + 8 | 0, e[me + 28 >> 2] = S, zo[y >> 3] = I, e[me + 24 >> 2] = S, e[5996] = 0, S = no(3, 8) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                                break t;
                              if (e[me + 8 >> 2] = S, ke = S + 8 | 0, e[me + 16 >> 2] = ke, zo[S >> 3] = C, e[5996] = 0, e[me + 12 >> 2] = ke, Ko(65, l | 0, me + 20 | 0, me + 8 | 0) | 0, l = e[5996], e[5996] = 0, (l | 0) != 1) {
                                Tr(S), Tr(y);
                                break n;
                              }
                              break r;
                            case 13:
                            case 14:
                            case 15:
                              if (y = ga(8), e[me + 20 >> 2] = y, S = y + 8 | 0, e[me + 28 >> 2] = S, zo[y >> 3] = I, e[me + 24 >> 2] = S, e[5996] = 0, S = no(3, 8) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                                break t;
                              if (e[me + 8 >> 2] = S, ke = S + 8 | 0, e[me + 16 >> 2] = ke, e[S >> 2] = 0, e[S + 4 >> 2] = 0, e[5996] = 0, e[me + 12 >> 2] = ke, Ko(65, l | 0, me + 20 | 0, me + 8 | 0) | 0, l = e[5996], e[5996] = 0, (l | 0) != 1) {
                                Tr(S), Tr(y);
                                break n;
                              }
                              break r;
                            case 17:
                            case 18:
                              if (y = ga(16), e[me + 20 >> 2] = y, S = y + 16 | 0, e[me + 28 >> 2] = S, zo[y + 8 >> 3] = I, zo[y >> 3] = I, e[me + 24 >> 2] = S, e[5996] = 0, S = no(3, 16) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                                break t;
                              if (e[me + 8 >> 2] = S, ke = S + 16 | 0, e[me + 16 >> 2] = ke, zo[S + 8 >> 3] = C, zo[S >> 3] = C, e[5996] = 0, e[me + 12 >> 2] = ke, Ko(65, l | 0, me + 20 | 0, me + 8 | 0) | 0, l = e[5996], e[5996] = 0, (l | 0) != 1) {
                                Tr(S), Tr(y);
                                break n;
                              }
                              break r;
                            case 19:
                              if (y = ga(16), e[me + 20 >> 2] = y, S = y + 16 | 0, e[me + 28 >> 2] = S, Ar = Ar * I, zo[y + 8 >> 3] = Ar, I = I * Q, zo[y >> 3] = I, e[me + 24 >> 2] = S, e[5996] = 0, S = no(3, 16) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                                break t;
                              if (e[me + 8 >> 2] = S, ke = S + 16 | 0, e[me + 16 >> 2] = ke, zo[S + 8 >> 3] = I + C, zo[S >> 3] = Ar + C, e[5996] = 0, e[me + 12 >> 2] = ke, Ko(65, l | 0, me + 20 | 0, me + 8 | 0) | 0, l = e[5996], e[5996] = 0, (l | 0) != 1) {
                                Tr(S), Tr(y);
                                break n;
                              }
                              break r;
                            case 21:
                              if (y = ga(16), e[me + 20 >> 2] = y, S = y + 16 | 0, e[me + 28 >> 2] = S, Ar = Ar * I, zo[y + 8 >> 3] = Ar, zo[y >> 3] = I * Q, e[me + 24 >> 2] = S, e[5996] = 0, S = no(3, 16) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                                break t;
                              if (e[me + 8 >> 2] = S, ke = S + 16 | 0, e[me + 16 >> 2] = ke, zo[S + 8 >> 3] = C, zo[S >> 3] = Ar + C, e[5996] = 0, e[me + 12 >> 2] = ke, Ko(65, l | 0, me + 20 | 0, me + 8 | 0) | 0, l = e[5996], e[5996] = 0, (l | 0) != 1) {
                                Tr(S), Tr(y);
                                break n;
                              }
                              break r;
                            case 20:
                              if (y = ga(16), e[me + 20 >> 2] = y, S = y + 16 | 0, e[me + 28 >> 2] = S, C = Ar * I, zo[y + 8 >> 3] = C, zo[y >> 3] = I * Q, e[me + 24 >> 2] = S, e[5996] = 0, S = no(3, 16) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                                break t;
                              if (e[me + 8 >> 2] = S, ke = S + 16 | 0, e[me + 16 >> 2] = ke, e[S + 8 >> 2] = 0, e[S + 12 >> 2] = 0, zo[S >> 3] = C, e[5996] = 0, e[me + 12 >> 2] = ke, Ko(65, l | 0, me + 20 | 0, me + 8 | 0) | 0, l = e[5996], e[5996] = 0, (l | 0) != 1) {
                                Tr(S), Tr(y);
                                break n;
                              }
                              break r;
                            case 22:
                              if (y = ga(16), e[me + 20 >> 2] = y, ke = y + 16 | 0, e[me + 28 >> 2] = ke, zo[y + 8 >> 3] = Ar * I, zo[y >> 3] = I * Q, e[me + 24 >> 2] = ke, e[5996] = 0, ke = no(3, 16) | 0, br = e[5996], e[5996] = 0, (br | 0) == 1)
                                break t;
                              if (e[me + 8 >> 2] = ke, br = ke + 16 | 0, e[me + 16 >> 2] = br, zo[ke + 8 >> 3] = (S | 0) == 1 ? C : 0, zo[ke >> 3] = S ? 0 : C, e[5996] = 0, e[me + 12 >> 2] = br, Ko(65, l | 0, me + 20 | 0, me + 8 | 0) | 0, l = e[5996], e[5996] = 0, (l | 0) != 1) {
                                Tr(ke), Tr(y);
                                break n;
                              }
                              l = gi() | 0, Tr(ke);
                              break e;
                            case 23:
                              if (y = ga(24), e[me + 20 >> 2] = y, S = y + 24 | 0, e[me + 28 >> 2] = S, Ar = Ar * I, zo[y + 16 >> 3] = Ar, I = I * Q, zo[y + 8 >> 3] = I, zo[y >> 3] = I, e[me + 24 >> 2] = S, e[5996] = 0, S = no(3, 24) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                                break t;
                              if (e[me + 8 >> 2] = S, ke = S + 24 | 0, e[me + 16 >> 2] = ke, zo[S + 16 >> 3] = C, e[S + 8 >> 2] = 0, e[S + 12 >> 2] = 0, zo[S >> 3] = Ar + C, e[5996] = 0, e[me + 12 >> 2] = ke, Ko(65, l | 0, me + 20 | 0, me + 8 | 0) | 0, l = e[5996], e[5996] = 0, (l | 0) != 1) {
                                Tr(S), Tr(y);
                                break n;
                              }
                              break r;
                            case 24:
                              a: {
                                s: {
                                  if (!S) {
                                    S = 0;
                                    break s;
                                  }
                                  if (S >>> 0 >= 536870912)
                                    break i;
                                  if (Q = I * Q, ke = S << 3, Qr = ga(ke), y = Qr, Ur = S & 7, Ur)
                                    for (; zo[y >> 3] = Q, y = y + 8 | 0, br = br + 1 | 0, (Ur | 0) != (br | 0); )
                                      ;
                                  if (Xr = ke + Qr | 0, Ri = S - 1 & 536870911, Ri >>> 0 >= 7)
                                    for (; zo[y + 56 >> 3] = Q, zo[y + 48 >> 3] = Q, zo[y + 40 >> 3] = Q, zo[y + 32 >> 3] = Q, zo[y + 24 >> 3] = Q, zo[y + 16 >> 3] = Q, zo[y + 8 >> 3] = Q, zo[y >> 3] = Q, y = y - -64 | 0, (Xr | 0) != (y | 0); )
                                      ;
                                  if (br = 0, e[5996] = 0, ke = no(3, ke | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                    break a;
                                  if (I = I * Ar + C, y = ke, Ur)
                                    for (; zo[y >> 3] = I, y = y + 8 | 0, br = br + 1 | 0, (Ur | 0) != (br | 0); )
                                      ;
                                  if (S = (S << 3) + ke | 0, Ri >>> 0 < 7)
                                    break s;
                                  for (; zo[y + 56 >> 3] = I, zo[y + 48 >> 3] = I, zo[y + 40 >> 3] = I, zo[y + 32 >> 3] = I, zo[y + 24 >> 3] = I, zo[y + 16 >> 3] = I, zo[y + 8 >> 3] = I, zo[y >> 3] = I, y = y - -64 | 0, (S | 0) != (y | 0); )
                                    ;
                                }
                                e[l + 12 >> 2] = ke, e[l + 8 >> 2] = Xr, e[l + 4 >> 2] = Xr, e[l >> 2] = Qr, e[l + 20 >> 2] = S, e[l + 16 >> 2] = S;
                                break n;
                              }
                              l = gi() | 0, Tr(Qr), ss(l | 0), jn();
                            default:
                              Nf(2350, 1900, 558, 1676), jn();
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                            case 8:
                            case 9:
                            case 25:
                              break o;
                          }
                        nh(l);
                      }
                      bi = me + 32 | 0;
                      return;
                    }
                    tf(), jn();
                  }
                  l = gi() | 0, Tr(S);
                  break e;
                }
                l = gi() | 0;
              }
              Tr(y), ss(l | 0), jn();
            }
            function Rc(l, y, I) {
              l = l | 0, y = y | 0, I = I | 0;
              var C = 0, Q = 0, S = 0, me = 0, ke = 0, Ar = 0, br = 0, Qr = 0, Ur = 0;
              e: {
                t: {
                  Q = e[I >> 2], C = e[Q + 80 >> 2];
                  r: {
                    if (!C | qs[Q + 84 >> 2] > 3600 | (e[Q + 52 >> 2] + e[Q + 44 >> 2] >>> 0 > 201 | qs[Q + 68 >> 2] > 100))
                      break r;
                    if (e[5996] = 0, ke = wn(54, 2049, 1) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                      break t;
                    if ((C ^ -1) & ke)
                      break r;
                    if (C = e[Q + 80 >> 2], e[5996] = 0, ke = wn(54, 2165, 1) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                      break t;
                    if (Je[Q + 88 | 0] | (C ^ -1) & ke || (Ar = zo[l + 24 >> 3], Qr = Ar == 0 ? 0 : Ar * zo[y + 8 >> 3], Ar = zo[l + 16 >> 3], me = e[Q + 84 >> 2], Ar = Qr + ((Ar == 0 ? 0 : Ar * zo[y >> 3]) + +(me >>> 0)), Ar > 1e4))
                      break r;
                    S = e[Q + 80 >> 2];
                    i: {
                      n: {
                        if (C = e[l >> 2], ke = e[l + 4 >> 2], (C | 0) == (ke | 0))
                          break n;
                        for (Q = C; ; ) {
                          br = e[Q >> 2];
                          o: {
                            if (S & (e[br + 80 >> 2] ^ -1))
                              break o;
                            if (Qr = zo[Q + 24 >> 3], Qr < Ar)
                              break r;
                            if (Ar < Qr)
                              break o;
                            if (me >>> 0 <= qs[br + 84 >> 2])
                              break r;
                          }
                          if (Q = Q + 32 | 0, (ke | 0) == (Q | 0))
                            break;
                        }
                        for (Q = S ^ -1; ; ) {
                          br = e[C >> 2];
                          o: {
                            if (Q & e[br + 80 >> 2] || (Qr = zo[C + 24 >> 3], Qr < Ar))
                              break o;
                            if (me >>> 0 >= qs[br + 84 >> 2] | Ar < Qr)
                              break n;
                          }
                          if (C = C + 32 | 0, (ke | 0) == (C | 0))
                            break;
                        }
                        Q = ke;
                        break i;
                      }
                      if ((C | 0) == (ke | 0)) {
                        Q = ke;
                        break i;
                      }
                      me = C + 32 | 0;
                      n: {
                        if ((me | 0) == (ke | 0)) {
                          Q = C;
                          break n;
                        }
                        for (br = S ^ -1, Q = C; ; ) {
                          S = C, C = me, me = e[S + 32 >> 2];
                          o: {
                            a: {
                              if (br & e[me + 80 >> 2] || (Qr = zo[S + 56 >> 3], Qr < Ar))
                                break a;
                              if (qs[me + 84 >> 2] <= qs[e[I >> 2] + 84 >> 2] | Ar < Qr)
                                break o;
                            }
                            Ur = e[S + 36 >> 2], e[C >> 2] = 0, e[S + 36 >> 2] = 0, e[Q >> 2] = me, me = e[Q + 4 >> 2], e[Q + 4 >> 2] = Ur;
                            a: {
                              if (!me || (Ur = e[me + 4 >> 2], e[me + 4 >> 2] = Ur - 1, Ur))
                                break a;
                              Yn[e[e[me >> 2] + 8 >> 2]](me), Ls(me);
                            }
                            me = e[S + 60 >> 2], e[Q + 24 >> 2] = e[S + 56 >> 2], e[Q + 28 >> 2] = me, me = e[S + 52 >> 2], e[Q + 16 >> 2] = e[S + 48 >> 2], e[Q + 20 >> 2] = me, me = e[S + 44 >> 2], e[Q + 8 >> 2] = e[S + 40 >> 2], e[Q + 12 >> 2] = me, Q = Q + 32 | 0;
                          }
                          if (me = C + 32 | 0, (me | 0) == (ke | 0))
                            break;
                        }
                        ke = e[l + 4 >> 2];
                      }
                      if ((Q | 0) == (ke | 0)) {
                        Q = ke;
                        break i;
                      }
                      if (C = (ke - Q | 0) + Q | 0, (ke | 0) != (C | 0)) {
                        for (; ; ) {
                          me = e[C >> 2], br = e[C + 4 >> 2], e[C >> 2] = 0, e[C + 4 >> 2] = 0, S = e[Q + 4 >> 2], e[Q >> 2] = me, e[Q + 4 >> 2] = br;
                          n: {
                            if (!S || (me = e[S + 4 >> 2], e[S + 4 >> 2] = me - 1, me))
                              break n;
                            Yn[e[e[S >> 2] + 8 >> 2]](S), Ls(S);
                          }
                          if (S = e[C + 12 >> 2], e[Q + 8 >> 2] = e[C + 8 >> 2], e[Q + 12 >> 2] = S, S = e[C + 28 >> 2], e[Q + 24 >> 2] = e[C + 24 >> 2], e[Q + 28 >> 2] = S, S = e[C + 20 >> 2], e[Q + 16 >> 2] = e[C + 16 >> 2], e[Q + 20 >> 2] = S, Q = Q + 32 | 0, C = C + 32 | 0, (ke | 0) == (C | 0))
                            break;
                        }
                        ke = e[l + 4 >> 2];
                      }
                      if ((Q | 0) != (ke | 0))
                        for (; ; ) {
                          ke = ke - 32 | 0, C = e[ke + 4 >> 2];
                          n: {
                            if (!C || (S = e[C + 4 >> 2], e[C + 4 >> 2] = S - 1, S))
                              break n;
                            Yn[e[e[C >> 2] + 8 >> 2]](C), Ls(C);
                          }
                          if ((Q | 0) == (ke | 0))
                            break;
                        }
                      e[l + 4 >> 2] = Q;
                    }
                    S = e[l + 8 >> 2];
                    i: {
                      if (S >>> 0 > Q >>> 0) {
                        e[Q >> 2] = e[I >> 2], e[Q + 4 >> 2] = e[I + 4 >> 2], e[I >> 2] = 0, e[I + 4 >> 2] = 0, C = e[y + 12 >> 2], e[Q + 16 >> 2] = e[y + 8 >> 2], e[Q + 20 >> 2] = C, C = e[y + 4 >> 2], e[Q + 8 >> 2] = e[y >> 2], e[Q + 12 >> 2] = C, zo[Q + 24 >> 3] = Ar, e[l + 4 >> 2] = Q + 32;
                        break i;
                      }
                      if (ke = e[l >> 2], me = Q - ke >> 5, C = me + 1 | 0, C >>> 0 >= 134217728) {
                        if (e[5996] = 0, jo(62), l = e[5996], e[5996] = 0, (l | 0) == 1)
                          break t;
                        break e;
                      }
                      if (S = S - ke | 0, br = S >> 4, C = S >>> 0 >= 2147483616 ? 134217727 : C >>> 0 < br >>> 0 ? br : C, C >>> 0 >= 134217728) {
                        if (e[5996] = 0, jo(35), l = e[5996], e[5996] = 0, (l | 0) != 1)
                          break e;
                        break t;
                      }
                      if (e[5996] = 0, br = C << 5, S = no(3, br | 0) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                        break t;
                      C = S + (me << 5) | 0, e[C >> 2] = e[I >> 2], e[C + 4 >> 2] = e[I + 4 >> 2], e[I >> 2] = 0, e[I + 4 >> 2] = 0, me = e[y + 12 >> 2], e[C + 16 >> 2] = e[y + 8 >> 2], e[C + 20 >> 2] = me, me = e[y + 4 >> 2], e[C + 8 >> 2] = e[y >> 2], e[C + 12 >> 2] = me, zo[C + 24 >> 3] = Ar, y = S + br | 0, S = C + 32 | 0;
                      n: {
                        if ((Q | 0) != (ke | 0)) {
                          for (; C = C - 32 | 0, Q = Q - 32 | 0, e[C >> 2] = e[Q >> 2], e[C + 4 >> 2] = e[Q + 4 >> 2], e[Q >> 2] = 0, e[Q + 4 >> 2] = 0, me = e[Q + 28 >> 2], e[C + 24 >> 2] = e[Q + 24 >> 2], e[C + 28 >> 2] = me, me = e[Q + 20 >> 2], e[C + 16 >> 2] = e[Q + 16 >> 2], e[C + 20 >> 2] = me, me = e[Q + 12 >> 2], e[C + 8 >> 2] = e[Q + 8 >> 2], e[C + 12 >> 2] = me, (Q | 0) != (ke | 0); )
                            ;
                          if (e[l + 8 >> 2] = y, y = e[l + 4 >> 2], e[l + 4 >> 2] = S, Q = e[l >> 2], e[l >> 2] = C, (y | 0) == (Q | 0))
                            break n;
                          for (; ; ) {
                            y = y - 32 | 0, C = e[y + 4 >> 2];
                            o: {
                              if (!C || (ke = e[C + 4 >> 2], e[C + 4 >> 2] = ke - 1, ke))
                                break o;
                              Yn[e[e[C >> 2] + 8 >> 2]](C), Ls(C);
                            }
                            if ((y | 0) == (Q | 0))
                              break;
                          }
                          break n;
                        }
                        e[l + 8 >> 2] = y, e[l + 4 >> 2] = S, e[l >> 2] = C;
                      }
                      if (!Q)
                        break i;
                      Tr(Q);
                    }
                    e[l + 32 >> 2] = e[l + 32 >> 2] + 1;
                  }
                  l = e[I + 4 >> 2];
                  r: {
                    if (!l || (y = e[l + 4 >> 2], e[l + 4 >> 2] = y - 1, y))
                      break r;
                    Yn[e[e[l >> 2] + 8 >> 2]](l), Ls(l);
                  }
                  return;
                }
                l = gi() | 0, l2(I), ss(l | 0), jn();
              }
              jn();
            }
            function cl(l, y, I) {
              l = l | 0, y = y | 0, I = I | 0;
              var C = 0, Q = 0, S = 0, me = 0, ke = 0, Ar = Oa(0), br = 0, Qr = 0, Ur = 0, Xr = 0, Ri = Oa(0), yn = 0;
              C = No(l, 1540483477), C = No(C >>> 24 ^ C, 1540483477) ^ 1866966612, C = No(C >>> 13 ^ C, 1540483477), me = C >>> 15 ^ C;
              e: {
                t: {
                  r: {
                    i: {
                      ke = e[y + 4 >> 2];
                      n: {
                        if (!ke)
                          break n;
                        Q = e[y >> 2], Qr = op(ke), C = ke - 1 & me;
                        o: {
                          if (Qr >>> 0 <= 1 || (C = me, C >>> 0 < ke >>> 0))
                            break o;
                          C = (C >>> 0) % (ke >>> 0) | 0;
                        }
                        if (S = C, C = e[Q + (S << 2) >> 2], !C || (C = e[C >> 2], !C))
                          break n;
                        if (Qr >>> 0 <= 1) {
                          for (Q = ke - 1 | 0; ; ) {
                            ke = e[C + 4 >> 2];
                            o: {
                              if ((ke | 0) != (me | 0)) {
                                if ((S | 0) == (Q & ke))
                                  break o;
                                break n;
                              }
                              if (e[C + 8 >> 2] == (l | 0))
                                break i;
                            }
                            if (C = e[C >> 2], !C)
                              break;
                          }
                          break n;
                        }
                        for (; ; ) {
                          Q = e[C + 4 >> 2];
                          o: {
                            if ((Q | 0) != (me | 0)) {
                              if (Q >>> 0 >= ke >>> 0 && (Q = (Q >>> 0) % (ke >>> 0) | 0), (Q | 0) == (S | 0))
                                break o;
                              break n;
                            }
                            if (e[C + 8 >> 2] == (l | 0))
                              break i;
                          }
                          if (C = e[C >> 2], !C)
                            break;
                        }
                      }
                      if (Xr = wh(l, y, I), !Xr)
                        return 0;
                      if (C = e[y + 4 >> 2], !C)
                        break r;
                      if (Q = C - 1 | 0, Q & C) {
                        if (I = C >>> 0 <= me >>> 0 ? (me >>> 0) % (C >>> 0) | 0 : me, S = e[e[y >> 2] + (I << 2) >> 2], !S)
                          break r;
                        for (; ; ) {
                          if (S = e[S >> 2], !S || (Q = e[S + 4 >> 2], (Q | 0) != (me | 0) && (C >>> 0 <= Q >>> 0 && (Q = (Q >>> 0) % (C >>> 0) | 0), (I | 0) != (Q | 0))))
                            break r;
                          if (e[S + 8 >> 2] == (l | 0))
                            break;
                        }
                        break t;
                      }
                      if (I = Q & me, S = e[e[y >> 2] + (I << 2) >> 2], !S)
                        break r;
                      for (; ; ) {
                        if (S = e[S >> 2], !S || (ke = e[S + 4 >> 2], (ke | 0) != (me | 0) & (Q & ke) != (I | 0)))
                          break r;
                        if (e[S + 8 >> 2] == (l | 0))
                          break;
                      }
                      break t;
                    }
                    return e[C + 12 >> 2];
                  }
                  ke = ga(16), e[ke + 8 >> 2] = l, e[ke + 4 >> 2] = me, e[ke >> 2] = 0, e[ke + 12 >> 2] = Xr, Qr = y + 8 | 0, Ri = Oa(e[y + 12 >> 2] + 1 >>> 0), Ar = df[y + 16 >> 2];
                  r: {
                    if (!(!C | Ri > Oa(Ar * Oa(C >>> 0)))) {
                      me = I;
                      break r;
                    }
                    Q = 2, I = (C - 1 & C) != 0 | C >>> 0 < 3 | C << 1, Ar = Oa(Cu(Oa(Ri / Ar)));
                    i: {
                      if (Ar < Oa(4294967296) & Ar >= Oa(0)) {
                        l = ~~Ar >>> 0;
                        break i;
                      }
                      l = 0;
                    }
                    l = l >>> 0 < I >>> 0 ? I : l;
                    i: {
                      if ((l | 0) == 1)
                        break i;
                      if (!(l & l - 1)) {
                        Q = l;
                        break i;
                      }
                      if (e[5996] = 0, Q = no(43, l | 0) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1)
                        break e;
                      C = e[y + 4 >> 2];
                    }
                    i: {
                      n: {
                        if (C >>> 0 >= Q >>> 0) {
                          if (C >>> 0 <= Q >>> 0)
                            break i;
                          I = C >>> 0 < 3, Ar = Oa(Cu(Oa(Oa(qs[y + 12 >> 2]) / df[y + 16 >> 2])));
                          o: {
                            if (Ar < Oa(4294967296) & Ar >= Oa(0)) {
                              l = ~~Ar >>> 0;
                              break o;
                            }
                            l = 0;
                          }
                          o: {
                            a: {
                              if (I || op(C) >>> 0 > 1)
                                break a;
                              l = l >>> 0 < 2 ? l : 1 << 32 - Ha(l - 1 | 0);
                              break o;
                            }
                            if (e[5996] = 0, l = no(43, l | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                              break e;
                          }
                          if (Q = l >>> 0 < Q >>> 0 ? Q : l, Q >>> 0 >= C >>> 0) {
                            C = e[y + 4 >> 2];
                            break i;
                          }
                          if (!Q)
                            break n;
                        }
                        if (Q >>> 0 >= 1073741824) {
                          if (e[5996] = 0, jo(35), l = e[5996], e[5996] = 0, (l | 0) == 1)
                            break e;
                          jn();
                        }
                        if (e[5996] = 0, I = no(3, Q << 2) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1)
                          break e;
                        if (l = e[y >> 2], e[y >> 2] = I, l && Tr(l), e[y + 4 >> 2] = Q, S = 0, C = 0, br = Q - 1 | 0, br >>> 0 >= 3)
                          for (I = Q & -4; l = C << 2, e[l + e[y >> 2] >> 2] = 0, e[e[y >> 2] + (l | 4) >> 2] = 0, e[e[y >> 2] + (l | 8) >> 2] = 0, e[e[y >> 2] + (l | 12) >> 2] = 0, C = C + 4 | 0, (I | 0) != (C | 0); )
                            ;
                        if (l = Q & 3, l)
                          for (; e[e[y >> 2] + (C << 2) >> 2] = 0, C = C + 1 | 0, S = S + 1 | 0, (l | 0) != (S | 0); )
                            ;
                        if (C = e[y + 8 >> 2], !C) {
                          C = Q;
                          break i;
                        }
                        I = e[C + 4 >> 2];
                        o: {
                          if (Q - 1 & Q) {
                            if (I = I >>> 0 >= Q >>> 0 ? (I >>> 0) % (Q >>> 0) | 0 : I, e[e[y >> 2] + (I << 2) >> 2] = Qr, S = e[C >> 2], S)
                              break o;
                            C = Q;
                            break i;
                          }
                          if (I = I & br, e[e[y >> 2] + (I << 2) >> 2] = Qr, l = e[C >> 2], !l) {
                            C = Q;
                            break i;
                          }
                          for (; ; ) {
                            S = br & e[l + 4 >> 2];
                            a: {
                              if ((S | 0) == (I | 0)) {
                                C = l;
                                break a;
                              }
                              if (Ur = S << 2, yn = Ur + e[y >> 2] | 0, e[yn >> 2]) {
                                e[C >> 2] = e[l >> 2], e[l >> 2] = e[e[Ur + e[y >> 2] >> 2] >> 2], e[e[Ur + e[y >> 2] >> 2] >> 2] = l;
                                break a;
                              }
                              e[yn >> 2] = C, C = l, I = S;
                            }
                            if (l = e[C >> 2], !l)
                              break;
                          }
                          C = Q;
                          break i;
                        }
                        for (; ; ) {
                          l = e[S + 4 >> 2], Q >>> 0 <= l >>> 0 && (l = (l >>> 0) % (Q >>> 0) | 0);
                          o: {
                            if ((l | 0) == (I | 0)) {
                              C = S;
                              break o;
                            }
                            if (br = l << 2, Ur = br + e[y >> 2] | 0, !e[Ur >> 2]) {
                              e[Ur >> 2] = C, C = S, I = l;
                              break o;
                            }
                            e[C >> 2] = e[S >> 2], e[S >> 2] = e[e[br + e[y >> 2] >> 2] >> 2], e[e[br + e[y >> 2] >> 2] >> 2] = S;
                          }
                          if (S = e[C >> 2], !S)
                            break;
                        }
                        C = Q;
                        break i;
                      }
                      l = e[y >> 2], C = 0, e[y >> 2] = 0, l && Tr(l), e[y + 4 >> 2] = 0;
                    }
                    if (l = C - 1 | 0, !(l & C)) {
                      me = l & me;
                      break r;
                    }
                    if (C >>> 0 > me >>> 0)
                      break r;
                    me = (me >>> 0) % (C >>> 0) | 0;
                  }
                  l = e[y >> 2] + (me << 2) | 0, me = e[l >> 2];
                  r: {
                    i: {
                      if (!me) {
                        if (e[ke >> 2] = e[y + 8 >> 2], e[y + 8 >> 2] = ke, e[l >> 2] = Qr, l = e[ke >> 2], !l)
                          break r;
                        me = e[l + 4 >> 2], l = C - 1 | 0;
                        n: {
                          if (!(l & C)) {
                            me = l & me;
                            break n;
                          }
                          if (C >>> 0 > me >>> 0)
                            break n;
                          me = (me >>> 0) % (C >>> 0) | 0;
                        }
                        me = e[y >> 2] + (me << 2) | 0;
                        break i;
                      }
                      e[ke >> 2] = e[me >> 2];
                    }
                    e[me >> 2] = ke;
                  }
                  e[y + 12 >> 2] = e[y + 12 >> 2] + 1;
                }
                return Xr | 0;
              }
              l = gi() | 0, Tr(ke), ss(l | 0), jn();
            }
            function ul(l, y, I, C, Q) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0;
              var S = 0, me = 0, ke = 0, Ar = 0, br = 0, Qr = 0, Ur = 0, Xr = 0, Ri = 0, yn = 0, En = 0;
              Ar = bi - 16 | 0, bi = Ar, e[Ar + 8 >> 2] = 0, e[Ar + 12 >> 2] = 0, Qr = Ar + 8 | 0, e[Ar + 4 >> 2] = Qr;
              e: {
                t: {
                  r: {
                    i: {
                      n: {
                        if ((y | 0) != (I | 0))
                          for (; ; ) {
                            br = e[y >> 2], me = e[br + 80 >> 2];
                            o: {
                              if ((me ^ -1) & C)
                                break o;
                              Ur = Q & me, ke = Qr, me = ke;
                              a: {
                                Xr = e[Ar + 8 >> 2], S = Xr;
                                s: {
                                  if (!S)
                                    break s;
                                  for (; ; ) {
                                    if (me = S, S = e[me + 16 >> 2], S >>> 0 > Ur >>> 0) {
                                      if (ke = me, S = e[me >> 2], S)
                                        continue;
                                      break s;
                                    }
                                    if (S >>> 0 >= Ur >>> 0)
                                      break a;
                                    if (S = e[me + 4 >> 2], !S)
                                      break;
                                  }
                                  ke = me + 4 | 0;
                                }
                                if (e[5996] = 0, S = no(3, 56) | 0, En = e[5996], e[5996] = 0, (En | 0) == 1)
                                  break n;
                                e[S + 16 >> 2] = Ur, e[S + 24 >> 2] = br, br = e[y + 4 >> 2], e[S + 28 >> 2] = br, br && (e[br + 4 >> 2] = e[br + 4 >> 2] + 1), br = e[y + 12 >> 2], e[S + 32 >> 2] = e[y + 8 >> 2], e[S + 36 >> 2] = br, br = e[y + 28 >> 2], e[S + 48 >> 2] = e[y + 24 >> 2], e[S + 52 >> 2] = br, br = e[y + 20 >> 2], e[S + 40 >> 2] = e[y + 16 >> 2], e[S + 44 >> 2] = br, e[S + 8 >> 2] = me, e[S >> 2] = 0, e[S + 4 >> 2] = 0, e[ke >> 2] = S, me = e[e[Ar + 4 >> 2] >> 2], me && (e[Ar + 4 >> 2] = me, S = e[ke >> 2]), Pu(e[Ar + 8 >> 2], S), e[Ar + 12 >> 2] = e[Ar + 12 >> 2] + 1;
                                break o;
                              }
                              if (Ri = zo[y + 24 >> 3], yn = zo[me + 48 >> 3], !(Ri < yn) & (qs[br + 84 >> 2] <= qs[e[me + 24 >> 2] + 84 >> 2] | Ri > yn))
                                break o;
                              ke = e[y + 4 >> 2], ke && (e[ke + 4 >> 2] = e[ke + 4 >> 2] + 1), e[me + 24 >> 2] = br, S = e[me + 28 >> 2], e[me + 28 >> 2] = ke;
                              a: {
                                if (!S || (ke = e[S + 4 >> 2], e[S + 4 >> 2] = ke - 1, ke))
                                  break a;
                                Yn[e[e[S >> 2] + 8 >> 2]](S), Ls(S);
                              }
                              S = e[y + 12 >> 2], e[me + 32 >> 2] = e[y + 8 >> 2], e[me + 36 >> 2] = S, S = e[y + 28 >> 2], e[me + 48 >> 2] = e[y + 24 >> 2], e[me + 52 >> 2] = S, S = e[y + 20 >> 2], e[me + 40 >> 2] = e[y + 16 >> 2], e[me + 44 >> 2] = S;
                            }
                            if (y = y + 32 | 0, (I | 0) == (y | 0))
                              break i;
                          }
                        e[l + 8 >> 2] = 0, e[l >> 2] = 0, e[l + 4 >> 2] = 0;
                        break e;
                      }
                      me = gi() | 0;
                      break r;
                    }
                    if (C = e[Ar + 4 >> 2], e[l + 8 >> 2] = 0, e[l >> 2] = 0, e[l + 4 >> 2] = 0, (C | 0) == (Qr | 0))
                      break e;
                    for (; ; ) {
                      i: {
                        me = e[l + 4 >> 2];
                        n: {
                          if ((me | 0) != e[l + 8 >> 2]) {
                            e[me >> 2] = e[C + 24 >> 2], y = e[C + 28 >> 2], e[me + 4 >> 2] = y, y && (e[y + 4 >> 2] = e[y + 4 >> 2] + 1), y = e[C + 52 >> 2], e[me + 24 >> 2] = e[C + 48 >> 2], e[me + 28 >> 2] = y, y = e[C + 44 >> 2], e[me + 16 >> 2] = e[C + 40 >> 2], e[me + 20 >> 2] = y, y = e[C + 36 >> 2], e[me + 8 >> 2] = e[C + 32 >> 2], e[me + 12 >> 2] = y, e[l + 4 >> 2] = me + 32;
                            break n;
                          }
                          if (y = e[l >> 2], I = me - y | 0, S = I >> 5, Q = S + 1 | 0, Q >>> 0 >= 134217728) {
                            if (e[5996] = 0, jo(62), y = e[5996], e[5996] = 0, (y | 0) == 1)
                              break i;
                            break t;
                          }
                          ke = I >> 4, Q = I >>> 0 >= 2147483616 ? 134217727 : Q >>> 0 < ke >>> 0 ? ke : Q;
                          o: {
                            if (!Q) {
                              I = 0;
                              break o;
                            }
                            if (Q >>> 0 >= 134217728) {
                              if (e[5996] = 0, jo(35), y = e[5996], e[5996] = 0, (y | 0) != 1)
                                break t;
                              break i;
                            }
                            if (e[5996] = 0, I = no(3, Q << 5) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                              break i;
                          }
                          S = (S << 5) + I | 0, e[S >> 2] = e[C + 24 >> 2], ke = e[C + 28 >> 2], e[S + 4 >> 2] = ke, ke && (e[ke + 4 >> 2] = e[ke + 4 >> 2] + 1, me = e[l + 4 >> 2], y = e[l >> 2]), I = (Q << 5) + I | 0, Q = e[C + 36 >> 2], e[S + 8 >> 2] = e[C + 32 >> 2], e[S + 12 >> 2] = Q, Q = e[C + 52 >> 2], e[S + 24 >> 2] = e[C + 48 >> 2], e[S + 28 >> 2] = Q, Q = e[C + 44 >> 2], e[S + 16 >> 2] = e[C + 40 >> 2], e[S + 20 >> 2] = Q, Q = S + 32 | 0;
                          o: {
                            if ((y | 0) == (me | 0)) {
                              e[l + 8 >> 2] = I, e[l + 4 >> 2] = Q, e[l >> 2] = S;
                              break o;
                            }
                            for (; S = S - 32 | 0, me = me - 32 | 0, e[S >> 2] = e[me >> 2], e[S + 4 >> 2] = e[me + 4 >> 2], e[me >> 2] = 0, e[me + 4 >> 2] = 0, ke = e[me + 28 >> 2], e[S + 24 >> 2] = e[me + 24 >> 2], e[S + 28 >> 2] = ke, ke = e[me + 20 >> 2], e[S + 16 >> 2] = e[me + 16 >> 2], e[S + 20 >> 2] = ke, ke = e[me + 12 >> 2], e[S + 8 >> 2] = e[me + 8 >> 2], e[S + 12 >> 2] = ke, (y | 0) != (me | 0); )
                              ;
                            if (e[l + 8 >> 2] = I, me = e[l + 4 >> 2], e[l + 4 >> 2] = Q, y = e[l >> 2], e[l >> 2] = S, (y | 0) == (me | 0))
                              break o;
                            for (; ; ) {
                              me = me - 32 | 0, I = e[me + 4 >> 2];
                              a: {
                                if (!I || (Q = e[I + 4 >> 2], e[I + 4 >> 2] = Q - 1, Q))
                                  break a;
                                Yn[e[e[I >> 2] + 8 >> 2]](I), Ls(I);
                              }
                              if ((y | 0) == (me | 0))
                                break;
                            }
                          }
                          if (!y)
                            break n;
                          Tr(y);
                        }
                        S = e[C + 4 >> 2];
                        n: {
                          if (S) {
                            for (; ; )
                              if (me = S, S = e[me >> 2], !S)
                                break n;
                          }
                          for (; me = e[C + 8 >> 2], y = e[me >> 2] != (C | 0), C = me, !!y; )
                            ;
                        }
                        if (C = me, (me | 0) != (Qr | 0))
                          continue;
                        break e;
                      }
                      break;
                    }
                    me = gi() | 0, Pc(l), Xr = e[Ar + 8 >> 2];
                  }
                  Jl(Xr), ss(me | 0), jn();
                }
                jn();
              }
              Jl(e[Ar + 8 >> 2]), bi = Ar + 16 | 0;
            }
            function Ef(l, y, I, C, Q, S, me, ke, Ar) {
              var br = 0, Qr = 0, Ur = 0, Xr = 0, Ri = 0, yn = 0, En = 0, Wn = 0, lo = 0, Ro = 0, Xo = 0;
              br = bi - 112 | 0, bi = br, Qr = Ar & 2147483647;
              e: {
                t: {
                  if (Xr = Q & 2147483647, Ur = 2147418112, Ri = !(y | I), !(C | Xr ? Xr - Ur >>> 0 < 2147549184 : Ri) && (En = Qr - Ur | 0, !ke & (En | 0) == -2147418112 ? S | me : (En | 0) == -2147418112 & (ke | 0) != 0 | En >>> 0 > 2147549184))
                    break t;
                  if (!(!C & (Xr | 0) == 2147418112 ? Ri : Xr >>> 0 < 2147418112)) {
                    ke = C, Ar = Q | 32768, S = y, me = I;
                    break e;
                  }
                  if (!(!ke & (Qr | 0) == 2147418112 ? !(S | me) : Qr >>> 0 < 2147418112)) {
                    Ar = Ar | 32768;
                    break e;
                  }
                  if (!(y | C | (Xr ^ 2147418112 | I))) {
                    Ur = C, C = !(y ^ S | C ^ ke | (I ^ me | Q ^ Ar ^ -2147483648)), ke = C ? 0 : Ur, Ar = C ? 2147450880 : Q, S = C ? 0 : y, me = C ? 0 : I;
                    break e;
                  }
                  if (Ur = S | ke, !(Ur | (Qr ^ 2147418112 | me)))
                    break e;
                  if (!(y | C | (I | Xr))) {
                    if (me | Qr | Ur)
                      break e;
                    S = y & S, me = I & me, ke = C & ke, Ar = Q & Ar;
                    break e;
                  }
                  if (S | ke | (me | Qr))
                    break t;
                  S = y, me = I, ke = C, Ar = Q;
                  break e;
                }
                Ur = (Qr | 0) == (Xr | 0), Ro = Ur & (C | 0) == (ke | 0) ? (I | 0) == (me | 0) & y >>> 0 < S >>> 0 | I >>> 0 < me >>> 0 : Ur & C >>> 0 < ke >>> 0 | Qr >>> 0 > Xr >>> 0, Ri = Ro, Xr = Ri ? S : y, En = Ri ? me : I, Ur = Ri ? Ar : Q, Xo = Ur, Ri = Ri ? ke : C, Wn = Ur & 65535, C = Ro ? C : ke, Q = Ro ? Q : Ar, lo = Q, Ur = Q >>> 16 & 32767, yn = Xo >>> 16 & 32767, yn || (Q = !(Ri | Wn), Ar = Q, Qr = Q ? Xr : Ri, Q = Q << 6, Ar = Ha(Ar ? En : Wn), Q = Q + ((Ar | 0) == 32 ? Ha(Qr) + 32 | 0 : Ar) | 0, Es(br + 96 | 0, Xr, En, Ri, Wn, Q - 15 | 0), Ri = e[br + 104 >> 2], Wn = e[br + 108 >> 2], En = e[br + 100 >> 2], yn = 16 - Q | 0, Xr = e[br + 96 >> 2]), S = Ro ? y : S, me = Ro ? I : me, ke = C, Ar = lo & 65535, Ur || (y = !(C | Ar), Q = y, Qr = y ? S : C, y = y << 6, Q = Ha(Q ? me : Ar), y = y + ((Q | 0) == 32 ? Ha(Qr) + 32 | 0 : Q) | 0, Es(br + 80 | 0, S, me, C, Ar, y - 15 | 0), Ur = 16 - y | 0, ke = e[br + 88 >> 2], Ar = e[br + 92 >> 2], me = e[br + 84 >> 2], S = e[br + 80 >> 2]), I = Ar << 3 | ke >>> 29, y = ke << 3 | me >>> 29, I = I | 524288, Q = Wn << 3 | Ri >>> 29, Wn = Ri << 3 | En >>> 29, ke = Q, Ar = lo ^ Xo, Qr = me << 3 | S >>> 29, C = S << 3;
                t: {
                  if ((Ur | 0) == (yn | 0))
                    break t;
                  if (Q = yn - Ur | 0, Q >>> 0 > 127) {
                    y = 0, I = 0, Qr = 0, C = 1;
                    break t;
                  }
                  Es(br - -64 | 0, C, Qr, y, I, 128 - Q | 0), fn(br + 48 | 0, C, Qr, y, I, Q), y = e[br + 56 >> 2], I = e[br + 60 >> 2], Qr = e[br + 52 >> 2], C = e[br + 48 >> 2] | (e[br + 64 >> 2] | e[br + 72 >> 2] | (e[br + 68 >> 2] | e[br + 76 >> 2])) != 0;
                }
                Ri = C, Ur = Qr, lo = ke | 524288, Qr = En << 3 | Xr >>> 29, Xr = Xr << 3;
                t: {
                  if ((Ar | 0) < 0) {
                    if (S = 0, me = 0, ke = 0, Ar = 0, !(Xr ^ Ri | y ^ Wn | (Qr ^ Ur | I ^ lo)))
                      break e;
                    if (C = Xr - Ri | 0, Q = Qr - ((Xr >>> 0 < Ri >>> 0) + Ur | 0) | 0, S = Wn - y | 0, me = (Qr | 0) == (Ur | 0) & Xr >>> 0 < Ri >>> 0 | Qr >>> 0 < Ur >>> 0, ke = S - me | 0, y = (lo - ((y >>> 0 > Wn >>> 0) + I | 0) | 0) - (S >>> 0 < me >>> 0) | 0, Ar = y, y >>> 0 > 524287)
                      break t;
                    I = !(y | ke), me = I, Ar = me ? C : ke, I = me << 6, me = Ha(me ? Q : y), I = I + ((me | 0) == 32 ? Ha(Ar) + 32 | 0 : me) | 0, S = y, y = I - 12 | 0, Es(br + 32 | 0, C, Q, ke, S, y), yn = yn - y | 0, ke = e[br + 40 >> 2], Ar = e[br + 44 >> 2], C = e[br + 32 >> 2], Q = e[br + 36 >> 2];
                    break t;
                  }
                  if (Qr = Qr + Ur | 0, C = Xr + Ri | 0, Q = C >>> 0 < Xr >>> 0 ? Qr + 1 | 0 : Qr, S = (Ur | 0) == (Q | 0) & C >>> 0 < Ri >>> 0 | Q >>> 0 < Ur >>> 0, Qr = I + lo | 0, y = y + Wn | 0, Qr = y >>> 0 < Wn >>> 0 ? Qr + 1 | 0 : Qr, ke = y + S | 0, Ar = ke >>> 0 < y >>> 0 ? Qr + 1 | 0 : Qr, !(Ar & 1048576))
                    break t;
                  C = Ri & 1 | ((Q & 1) << 31 | C >>> 1), Q = ke << 31 | Q >>> 1, yn = yn + 1 | 0, ke = (Ar & 1) << 31 | ke >>> 1, Ar = Ar >>> 1 | 0;
                }
                if (I = 0, y = Xo & -2147483648, En = y, (yn | 0) >= 32767) {
                  ke = I, Ar = y | 2147418112, S = 0, me = 0;
                  break e;
                }
                Ur = 0;
                t: {
                  if ((yn | 0) > 0) {
                    Ur = yn;
                    break t;
                  }
                  Es(br + 16 | 0, C, Q, ke, Ar, yn + 127 | 0), fn(br, C, Q, ke, Ar, 1 - yn | 0), C = e[br >> 2] | (e[br + 16 >> 2] | e[br + 24 >> 2] | (e[br + 20 >> 2] | e[br + 28 >> 2])) != 0, Q = e[br + 4 >> 2], ke = e[br + 8 >> 2], Ar = e[br + 12 >> 2];
                }
                Xr = C & 7, C = (Q & 7) << 29 | C >>> 3, S = (Xr >>> 0 > 4) + C | 0, y = ke << 29 | Q >>> 3, me = C >>> 0 > S >>> 0 ? y + 1 | 0 : y, C = (y | 0) == (me | 0) & C >>> 0 > S >>> 0 | y >>> 0 > me >>> 0, y = I | ((Ar & 7) << 29 | ke >>> 3), ke = C + y | 0, Ar = En | (Ar >>> 3 & 65535 | Ur << 16), Ar = y >>> 0 > ke >>> 0 ? Ar + 1 | 0 : Ar;
                t: {
                  if ((Xr | 0) == 4) {
                    y = 0, Qr = me + y | 0, C = S, I = S & 1, S = S + I | 0, me = C >>> 0 > S >>> 0 ? Qr + 1 | 0 : Qr, y = (y | 0) == (me | 0) & I >>> 0 > S >>> 0 | y >>> 0 > me >>> 0, ke = y + ke | 0, Ar = y >>> 0 > ke >>> 0 ? Ar + 1 | 0 : Ar;
                    break t;
                  }
                  if (!Xr)
                    break e;
                }
              }
              e[l >> 2] = S, e[l + 4 >> 2] = me, e[l + 8 >> 2] = ke, e[l + 12 >> 2] = Ar, bi = br + 112 | 0;
            }
            function Al(l, y, I) {
              l = l | 0, y = y | 0, I = I | 0;
              var C = 0, Q = 0, S = 0, me = 0, ke = 0, Ar = 0, br = 0, Qr = 0, Ur = 0, Xr = 0, Ri = 0, yn = 0;
              me = bi - 16 | 0, bi = me;
              e: {
                if (S = I - !y | 0, !((!S & y - 1 >>> 0 > 15 | (S | 0) != 0) & (y & I) != -1)) {
                  C = Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24), Q = C - 29 | 0, I = (C >>> 0 < 29 ? C : Q) + 1 | 0, I >>> 0 > (C >>> 0 <= 28 ? 28 : Je[l + 4 | 0] | Je[l + 5 | 0] << 8 | (Je[l + 6 | 0] << 16 | Je[l + 7 | 0] << 24)) >>> 0 && (D2(l, I + (I >>> 1 | 0) | 0), C = Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24), Q = C - 29 | 0), I = C >>> 0 < 29, Se[(I ? l + 4 | 0 : Je[l + 8 | 0] | Je[l + 9 | 0] << 8 | (Je[l + 10 | 0] << 16 | Je[l + 11 | 0] << 24)) + (I ? C : Q) | 0] = y + 80, y = (Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24)) + 1 | 0, Se[l | 0] = y, Se[l + 1 | 0] = y >>> 8, Se[l + 2 | 0] = y >>> 16, Se[l + 3 | 0] = y >>> 24;
                  break e;
                }
                if (!(y | I)) {
                  C = Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24), Q = C - 29 | 0, y = (C >>> 0 < 29 ? C : Q) + 1 | 0, y >>> 0 > (C >>> 0 <= 28 ? 28 : Je[l + 4 | 0] | Je[l + 5 | 0] << 8 | (Je[l + 6 | 0] << 16 | Je[l + 7 | 0] << 24)) >>> 0 && (D2(l, y + (y >>> 1 | 0) | 0), C = Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24), Q = C - 29 | 0), y = C >>> 0 < 29, Se[(y ? l + 4 | 0 : Je[l + 8 | 0] | Je[l + 9 | 0] << 8 | (Je[l + 10 | 0] << 16 | Je[l + 11 | 0] << 24)) + (y ? C : Q) | 0] = 0, y = (Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24)) + 1 | 0, Se[l | 0] = y, Se[l + 1 | 0] = y >>> 8, Se[l + 2 | 0] = y >>> 16, Se[l + 3 | 0] = y >>> 24;
                  break e;
                }
                e[me + 12 >> 2] = 0, e[me + 4 >> 2] = 0, e[me + 8 >> 2] = 0, S = y, y = I >> 31, S = S ^ y, ke = S - y | 0, y = (y ^ I) - ((S >>> 0 < y >>> 0) + y | 0) | 0;
                t: {
                  r: {
                    i: {
                      for (; ; ) {
                        br = y, Qr = ke;
                        n: {
                          if (C >>> 0 < Q >>> 0) {
                            Se[C | 0] = ke, S = C;
                            break n;
                          }
                          if (Xr = C - Ar | 0, ke = Xr + 1 | 0, (ke | 0) < 0) {
                            if (e[5996] = 0, jo(8), l = e[5996], e[5996] = 0, (l | 0) == 1)
                              break i;
                            break t;
                          }
                          S = Q - Ar | 0, y = S << 1, Ri = S >>> 0 >= 1073741823 ? 2147483647 : y >>> 0 > ke >>> 0 ? y : ke;
                          o: {
                            if (!Ri) {
                              ke = 0;
                              break o;
                            }
                            if (e[5996] = 0, ke = no(3, Ri | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                              break i;
                          }
                          if (S = ke + Xr | 0, Se[S | 0] = Qr, (C | 0) == (Ar | 0))
                            y = S;
                          else {
                            if (yn = (Ar ^ -1) + C | 0, Ur = 0, Q = S, y = Xr & 3, y)
                              for (; Q = Q - 1 | 0, C = C - 1 | 0, Se[Q | 0] = Je[C | 0], Ur = Ur + 1 | 0, (y | 0) != (Ur | 0); )
                                ;
                            if (yn >>> 0 >= 3)
                              for (; Se[Q - 1 | 0] = Je[C - 1 | 0], Se[Q - 2 | 0] = Je[C - 2 | 0], Se[Q - 3 | 0] = Je[C - 3 | 0], Q = Q - 4 | 0, C = C - 4 | 0, Se[Q | 0] = Je[C | 0], (C | 0) != (Ar | 0); )
                                ;
                            C = Ar, y = ke;
                          }
                          if (Ar = y, Q = ke + Ri | 0, !C)
                            break n;
                          Tr(C);
                        }
                        if (y = br >>> 8 | 0, ke = (br & 255) << 24 | Qr >>> 8, C = S + 1 | 0, !(!br & Qr >>> 0 >= 256 | br))
                          break;
                      }
                      e[me + 8 >> 2] = C, e[me + 4 >> 2] = Ar, e[me + 12 >> 2] = Q;
                      n: {
                        o: {
                          a: {
                            if (y = Se[S | 0], (y | 0) < 0) {
                              if (ke = I >>> 24 & 128, C >>> 0 < Q >>> 0) {
                                Se[S + 1 | 0] = ke, e[me + 8 >> 2] = S + 2;
                                break n;
                              }
                              if (Qr = C - Ar | 0, S = Qr + 1 | 0, (S | 0) < 0) {
                                if (e[5996] = 0, jo(8), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                  break t;
                                break i;
                              }
                              I = Q - Ar | 0, y = I << 1, I = I >>> 0 >= 1073741823 ? 2147483647 : y >>> 0 > S >>> 0 ? y : S;
                              s: {
                                if (!I) {
                                  S = 0;
                                  break s;
                                }
                                if (e[5996] = 0, S = no(3, I | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                  break i;
                              }
                              if (Q = S + Qr | 0, Se[Q | 0] = ke, br = I + S | 0, ke = Q + 1 | 0, (C | 0) == (Ar | 0))
                                break a;
                              if (I = (Ar ^ -1) + C | 0, y = Qr & 3, y)
                                for (Ur = 0; Q = Q - 1 | 0, C = C - 1 | 0, Se[Q | 0] = Je[C | 0], Ur = Ur + 1 | 0, (y | 0) != (Ur | 0); )
                                  ;
                              if (I >>> 0 >= 3)
                                for (; Se[Q - 1 | 0] = Je[C - 1 | 0], Se[Q - 2 | 0] = Je[C - 2 | 0], Se[Q - 3 | 0] = Je[C - 3 | 0], Q = Q - 4 | 0, C = C - 4 | 0, Se[Q | 0] = Je[C | 0], (C | 0) != (Ar | 0); )
                                  ;
                              if (e[me + 12 >> 2] = br, e[me + 8 >> 2] = ke, e[me + 4 >> 2] = S, !Ar)
                                break n;
                              break o;
                            }
                            if ((I | 0) > 0 | (I | 0) >= 0)
                              break n;
                            Se[S | 0] = y | 128;
                            break n;
                          }
                          e[me + 12 >> 2] = br, e[me + 8 >> 2] = ke, e[me + 4 >> 2] = Q;
                        }
                        Tr(Ar);
                      }
                      if (e[5996] = 0, wn(19, l | 0, me + 4 | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) != 1) {
                        if (y = e[me + 4 >> 2], !y)
                          break e;
                        Tr(y);
                        break e;
                      }
                      if (C = gi() | 0, l = e[me + 4 >> 2], !l)
                        break r;
                      Tr(l), ss(C | 0), jn();
                    }
                    if (C = gi() | 0, !Ar)
                      break r;
                    Tr(Ar);
                  }
                  ss(C | 0), jn();
                }
                jn();
              }
              return bi = me + 16 | 0, l | 0;
            }
            function $u(l, y, I, C) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0;
              var Q = 0, S = 0, me = 0, ke = 0, Ar = 0, br = 0, Qr = 0, Ur = 0;
              Se[l | 0] = 0, Se[l + 1 | 0] = 0, Se[l + 2 | 0] = 0, Se[l + 3 | 0] = 0, Se[l + 4 | 0] = 0, Se[l + 5 | 0] = 0, Se[l + 6 | 0] = 0, Se[l + 7 | 0] = 0, Se[l + 24 | 0] = 0, Se[l + 25 | 0] = 0, Se[l + 26 | 0] = 0, Se[l + 27 | 0] = 0, Se[l + 28 | 0] = 0, Se[l + 29 | 0] = 0, Se[l + 30 | 0] = 0, Se[l + 31 | 0] = 0, Se[l + 16 | 0] = 0, Se[l + 17 | 0] = 0, Se[l + 18 | 0] = 0, Se[l + 19 | 0] = 0, Se[l + 20 | 0] = 0, Se[l + 21 | 0] = 0, Se[l + 22 | 0] = 0, Se[l + 23 | 0] = 0, Se[l + 8 | 0] = 0, Se[l + 9 | 0] = 0, Se[l + 10 | 0] = 0, Se[l + 11 | 0] = 0, Se[l + 12 | 0] = 0, Se[l + 13 | 0] = 0, Se[l + 14 | 0] = 0, Se[l + 15 | 0] = 0, Qr = Je[y + 8 | 0] | Je[y + 9 | 0] << 8 | (Je[y + 10 | 0] << 16 | Je[y + 11 | 0] << 24), S = -29, me = Je[y | 0] | Je[y + 1 | 0] << 8 | (Je[y + 2 | 0] << 16 | Je[y + 3 | 0] << 24), Ar = me >>> 0 < 29;
              e: {
                if (me = Ar ? me : me - 29 | 0, me >>> 0 >= 29) {
                  if (e[5996] = 0, Co(124, l | 0, me + (me >>> 1 | 0) | 0), S = e[5996], e[5996] = 0, (S | 0) == 1)
                    break e;
                  Q = Je[l + 8 | 0] | Je[l + 9 | 0] << 8 | (Je[l + 10 | 0] << 16 | Je[l + 11 | 0] << 24), ke = Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24), S = ke - 29 | 0;
                }
                br = l + 4 | 0, Ur = ke >>> 0 < 29, Q = Ur ? br : Q, ve(me + Q | 0, Q, Ur ? ke : S), S = me + (Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24)) | 0, Se[l | 0] = S, Se[l + 1 | 0] = S >>> 8, Se[l + 2 | 0] = S >>> 16, Se[l + 3 | 0] = S >>> 24;
                t: {
                  if (!me)
                    break t;
                  S = Ar ? y + 4 | 0 : Qr, Ar = me & 7;
                  r: {
                    if (!Ar) {
                      y = S;
                      break r;
                    }
                    for (ke = 0, y = S; Se[Q | 0] = Je[y | 0], y = y + 1 | 0, Q = Q + 1 | 0, ke = ke + 1 | 0, (Ar | 0) != (ke | 0); )
                      ;
                  }
                  if (me >>> 0 < 8)
                    break t;
                  for (S = S + me | 0; Se[Q | 0] = Je[y | 0], Se[Q + 1 | 0] = Je[y + 1 | 0], Se[Q + 2 | 0] = Je[y + 2 | 0], Se[Q + 3 | 0] = Je[y + 3 | 0], Se[Q + 4 | 0] = Je[y + 4 | 0], Se[Q + 5 | 0] = Je[y + 5 | 0], Se[Q + 6 | 0] = Je[y + 6 | 0], Se[Q + 7 | 0] = Je[y + 7 | 0], Q = Q + 8 | 0, y = y + 8 | 0, (S | 0) != (y | 0); )
                    ;
                }
                if (Qr = Je[I + 8 | 0] | Je[I + 9 | 0] << 8 | (Je[I + 10 | 0] << 16 | Je[I + 11 | 0] << 24), Q = Je[I | 0] | Je[I + 1 | 0] << 8 | (Je[I + 2 | 0] << 16 | Je[I + 3 | 0] << 24), ke = Q >>> 0 < 29, y = Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24), S = y - 29 | 0, me = ke ? Q : Q - 29 | 0, Ar = y >>> 0 < 29 ? y : S, Q = me + Ar | 0, Q >>> 0 > (y >>> 0 <= 28 ? 28 : Je[l + 4 | 0] | Je[l + 5 | 0] << 8 | (Je[l + 6 | 0] << 16 | Je[l + 7 | 0] << 24)) >>> 0) {
                  if (e[5996] = 0, Co(124, l | 0, Q + (Q >>> 1 | 0) | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                    break e;
                  y = Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24), S = y - 29 | 0;
                }
                Q = br, br = y >>> 0 < 29, Q = Ar + (br ? Q : Je[l + 8 | 0] | Je[l + 9 | 0] << 8 | (Je[l + 10 | 0] << 16 | Je[l + 11 | 0] << 24)) | 0, ve(me + Q | 0, Q, (br ? y : S) - Ar | 0), y = me + (Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24)) | 0, Se[l | 0] = y, Se[l + 1 | 0] = y >>> 8, Se[l + 2 | 0] = y >>> 16, Se[l + 3 | 0] = y >>> 24;
                t: {
                  if (!me)
                    break t;
                  I = ke ? I + 4 | 0 : Qr, S = me & 7;
                  r: {
                    if (!S) {
                      y = I;
                      break r;
                    }
                    for (ke = 0, y = I; Se[Q | 0] = Je[y | 0], y = y + 1 | 0, Q = Q + 1 | 0, ke = ke + 1 | 0, (S | 0) != (ke | 0); )
                      ;
                  }
                  if (me >>> 0 < 8)
                    break t;
                  for (I = I + me | 0; Se[Q | 0] = Je[y | 0], Se[Q + 1 | 0] = Je[y + 1 | 0], Se[Q + 2 | 0] = Je[y + 2 | 0], Se[Q + 3 | 0] = Je[y + 3 | 0], Se[Q + 4 | 0] = Je[y + 4 | 0], Se[Q + 5 | 0] = Je[y + 5 | 0], Se[Q + 6 | 0] = Je[y + 6 | 0], Se[Q + 7 | 0] = Je[y + 7 | 0], Q = Q + 8 | 0, y = y + 8 | 0, (I | 0) != (y | 0); )
                    ;
                }
                if (y = e[C >> 2], e[5996] = 0, wn(127, l | 0, y | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                  break e;
                return;
              }
              y = gi() | 0, (Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24)) >>> 0 >= 29 && (Tr(Je[l + 8 | 0] | Je[l + 9 | 0] << 8 | (Je[l + 10 | 0] << 16 | Je[l + 11 | 0] << 24)), Se[l + 8 | 0] = 0, Se[l + 9 | 0] = 0, Se[l + 10 | 0] = 0, Se[l + 11 | 0] = 0), ss(y | 0), jn();
            }
            function ll(l, y, I, C, Q) {
              l = l | 0, y = y | 0, I = I | 0, C = +C, Q = Q | 0;
              var S = 0, me = 0, ke = 0, Ar = 0, br = 0, Qr = 0, Ur = 0, Xr = 0, Ri = 0, yn = 0;
              S = bi + -64 | 0, bi = S, e[S + 40 >> 2] = 0, e[S + 32 >> 2] = 0, e[S + 36 >> 2] = 0, Qr = e[I >> 2], Ri = e[I + 4 >> 2];
              e: {
                t: {
                  if ((Qr | 0) == (Ri | 0)) {
                    I = Qr;
                    break t;
                  }
                  r: {
                    i: {
                      for (; ; ) {
                        n: {
                          br = e[Qr >> 2], me = e[S + 36 >> 2];
                          o: {
                            if ((me | 0) != e[S + 40 >> 2]) {
                              e[me >> 2] = e[br >> 2], Ar = e[br + 4 >> 2], e[me + 4 >> 2] = Ar, Ar && (e[Ar + 4 >> 2] = e[Ar + 4 >> 2] + 1), e[S + 36 >> 2] = me + 8;
                              break o;
                            }
                            a: {
                              Ar = e[S + 32 >> 2], ke = me - Ar | 0, yn = ke >> 3, Ur = yn + 1 | 0;
                              s: {
                                if (Ur >>> 0 >= 536870912) {
                                  if (e[5996] = 0, jo(59), l = e[5996], e[5996] = 0, (l | 0) == 1)
                                    break s;
                                  break i;
                                }
                                if (Xr = ke >> 2, ke = ke >>> 0 >= 2147483640 ? 536870911 : Ur >>> 0 < Xr >>> 0 ? Xr : Ur, ke >>> 0 < 536870912)
                                  break a;
                                if (e[5996] = 0, jo(35), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                  break i;
                              }
                              me = gi() | 0;
                              break e;
                            }
                            if (e[5996] = 0, Xr = ke << 3, Ur = no(3, Xr | 0) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                              break n;
                            ke = Ur + (yn << 3) | 0, e[ke >> 2] = e[br >> 2], br = e[br + 4 >> 2], e[ke + 4 >> 2] = br, br && (e[br + 4 >> 2] = e[br + 4 >> 2] + 1, me = e[S + 36 >> 2]), br = Ur + Xr | 0, Ur = ke + 8 | 0;
                            a: {
                              if ((me | 0) == (Ar | 0)) {
                                e[S + 40 >> 2] = br, e[S + 36 >> 2] = Ur, e[S + 32 >> 2] = ke;
                                break a;
                              }
                              for (; ke = ke - 8 | 0, me = me - 8 | 0, e[ke >> 2] = e[me >> 2], e[ke + 4 >> 2] = e[me + 4 >> 2], e[me >> 2] = 0, e[me + 4 >> 2] = 0, (me | 0) != (Ar | 0); )
                                ;
                              if (e[S + 40 >> 2] = br, me = e[S + 36 >> 2], e[S + 36 >> 2] = Ur, Ar = e[S + 32 >> 2], e[S + 32 >> 2] = ke, (me | 0) == (Ar | 0))
                                break a;
                              for (; ; ) {
                                me = me - 8 | 0, ke = e[me + 4 >> 2];
                                s: {
                                  if (!ke || (br = e[ke + 4 >> 2], e[ke + 4 >> 2] = br - 1, br))
                                    break s;
                                  Yn[e[e[ke >> 2] + 8 >> 2]](ke), Ls(ke);
                                }
                                if ((me | 0) == (Ar | 0))
                                  break;
                              }
                            }
                            if (!Ar)
                              break o;
                            Tr(Ar);
                          }
                          if (Qr = Qr + 4 | 0, (Ri | 0) != (Qr | 0))
                            continue;
                          break r;
                        }
                        break;
                      }
                      me = gi() | 0;
                      break e;
                    }
                    jn();
                  }
                  Qr = e[I + 4 >> 2], I = e[I >> 2];
                }
                e[5996] = 0, Gf(63, S + 16 | 0, y | 0, I | 0, Qr | 0, +C), I = e[5996], e[5996] = 0;
                t: {
                  if ((I | 0) == 1 || (e[5996] = 0, I = no(3, 104) | 0, Qr = e[5996], e[5996] = 0, (Qr | 0) == 1))
                    break t;
                  if (e[I >> 2] = 7e3, e[I + 4 >> 2] = 0, e[I + 8 >> 2] = 0, e[S + 52 >> 2] = e[S + 32 >> 2], Qr = e[S + 40 >> 2], me = e[S + 36 >> 2], e[S + 40 >> 2] = 0, e[S + 56 >> 2] = me, e[S + 60 >> 2] = Qr, e[S + 32 >> 2] = 0, e[S + 36 >> 2] = 0, Q = e[Q >> 2], e[5996] = 0, Qr = mf(64, I + 12 | 0, y | 0, S + 52 | 0, Q | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) != 1) {
                    if (y = e[S + 52 >> 2], y) {
                      if (me = e[S + 56 >> 2], (y | 0) != (me | 0)) {
                        for (; ; ) {
                          me = me - 8 | 0, Q = e[me + 4 >> 2];
                          r: {
                            if (!Q || (Ar = e[Q + 4 >> 2], e[Q + 4 >> 2] = Ar - 1, Ar))
                              break r;
                            Yn[e[e[Q >> 2] + 8 >> 2]](Q), Ls(Q);
                          }
                          if ((y | 0) == (me | 0))
                            break;
                        }
                        y = e[S + 52 >> 2];
                      }
                      Tr(y);
                    }
                    if (e[S + 48 >> 2] = I, e[S + 44 >> 2] = Qr, e[5996] = 0, y = e[S + 48 >> 2], e[S + 8 >> 2] = e[S + 44 >> 2], e[S + 12 >> 2] = y, Ms(61, l | 0, S + 16 | 0, S + 8 | 0), l = e[5996], e[5996] = 0, (l | 0) == 1)
                      break t;
                    if (l = e[S + 32 >> 2], l) {
                      if (me = e[S + 36 >> 2], (l | 0) != (me | 0)) {
                        for (; ; ) {
                          me = me - 8 | 0, y = e[me + 4 >> 2];
                          r: {
                            if (!y || (I = e[y + 4 >> 2], e[y + 4 >> 2] = I - 1, I))
                              break r;
                            Yn[e[e[y >> 2] + 8 >> 2]](y), Ls(y);
                          }
                          if ((l | 0) == (me | 0))
                            break;
                        }
                        l = e[S + 32 >> 2];
                      }
                      Tr(l);
                    }
                    bi = S - -64 | 0;
                    return;
                  }
                  me = gi() | 0, Za(S + 52 | 0), Tr(I);
                  break e;
                }
                me = gi() | 0;
              }
              Za(S + 32 | 0), ss(me | 0), jn();
            }
            function Dh(l, y, I, C) {
              l = l | 0, y = +y, I = +I, C = C | 0;
              var Q = 0, S = 0, me = 0, ke = 0, Ar = 0, br = 0, Qr = 0, Ur = 0;
              me = bi - 48 | 0, bi = me;
              e: {
                t: {
                  if (e[l >> 2] == 21) {
                    br = C + 4 | 0;
                    r: {
                      i: {
                        n: {
                          o: {
                            if (Q = e[C + 4 >> 2], !Q)
                              break o;
                            for (S = br; ; ) {
                              a: {
                                s: {
                                  A: {
                                    if (Ar = e[Q + 16 >> 2], Ar >>> 0 < l >>> 0)
                                      break A;
                                    if (l >>> 0 < Ar >>> 0)
                                      break s;
                                    if (Qr = zo[Q + 24 >> 3], Qr < y)
                                      break A;
                                    if (y < Qr)
                                      break s;
                                    ke = zo[Q + 32 >> 3] < I, Ar = ke ? Q + 4 | 0 : Q, S = ke ? S : Q;
                                    break a;
                                  }
                                  Ar = Q + 4 | 0;
                                  break a;
                                }
                                Ar = Q, S = Q;
                              }
                              if (Q = e[Ar >> 2], !Q)
                                break;
                            }
                            if ((S | 0) == (br | 0) || (Q = e[S + 16 >> 2], Q >>> 0 > l >>> 0))
                              break o;
                            a: {
                              if (l >>> 0 > Q >>> 0)
                                break a;
                              if (Qr = zo[S + 24 >> 3], Qr > y)
                                break o;
                              if (y > Qr)
                                break a;
                              if (zo[S + 32 >> 3] > I)
                                break o;
                            }
                            if (zo[S + 56 >> 3] != y)
                              break n;
                            if (zo[S - -64 >> 3] != I)
                              break i;
                            Ur = S + 40 | 0;
                            break e;
                          }
                          if (e[me + 40 >> 2] = 0, zo[me + 32 >> 3] = I, zo[me + 24 >> 3] = y, e[me + 16 >> 2] = 0, e[me + 8 >> 2] = 0, e[me + 12 >> 2] = 0, Q = e[l + 4 >> 2], (Q | 0) == e[l + 8 >> 2]) {
                            if (e[5996] = 0, ia(44, 4277, 1900, 673, 1984), l = e[5996], e[5996] = 0, (l | 0) != 1)
                              break r;
                            break t;
                          }
                          if (Q = e[Q >> 2], e[5996] = 0, Ms(45, Q | 0, me + 8 | 0, C | 0), Q = e[5996], e[5996] = 0, (Q | 0) == 1)
                            break t;
                          o: {
                            a: {
                              Q = br, Ar = e[Q >> 2];
                              s: {
                                if (!Ar)
                                  break s;
                                for (; ; ) {
                                  A: {
                                    u: {
                                      Q = Ar, S = e[Q + 16 >> 2];
                                      h: {
                                        if (S >>> 0 > l >>> 0)
                                          break h;
                                        if (l >>> 0 > S >>> 0)
                                          break A;
                                        if (Qr = zo[Q + 24 >> 3], Qr > y)
                                          break h;
                                        if (y > Qr)
                                          break A;
                                        if (Qr = zo[Q + 32 >> 3], !(Qr > I))
                                          break u;
                                      }
                                      if (br = Q, Ar = e[Q >> 2], Ar)
                                        continue;
                                      break s;
                                    }
                                    if (!(I > Qr))
                                      break a;
                                  }
                                  if (Ar = e[Q + 4 >> 2], !Ar)
                                    break;
                                }
                                br = Q + 4 | 0;
                              }
                              if (e[5996] = 0, ke = no(3, 80) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                break t;
                              if (e[ke + 16 >> 2] = l, zo[ke + 32 >> 3] = I, zo[ke + 24 >> 3] = y, Ur = ke + 40 | 0, e[Ur >> 2] = e[me + 8 >> 2], e[ke + 44 >> 2] = e[me + 12 >> 2], e[ke + 48 >> 2] = e[me + 16 >> 2], e[me + 16 >> 2] = 0, e[me + 8 >> 2] = 0, e[me + 12 >> 2] = 0, e[ke + 72 >> 2] = e[me + 40 >> 2], Ar = e[me + 36 >> 2], S = ke - -64 | 0, e[S >> 2] = e[me + 32 >> 2], e[S + 4 >> 2] = Ar, S = e[me + 28 >> 2], e[ke + 56 >> 2] = e[me + 24 >> 2], e[ke + 60 >> 2] = S, e[ke + 8 >> 2] = Q, e[ke >> 2] = 0, e[ke + 4 >> 2] = 0, e[br >> 2] = ke, Q = ke, S = e[e[C >> 2] >> 2], S && (e[C >> 2] = S, Q = e[br >> 2]), Pu(e[C + 4 >> 2], Q), e[C + 8 >> 2] = e[C + 8 >> 2] + 1, br = e[l + 4 >> 2], e[l + 8 >> 2] - br >>> 0 >= 5)
                                for (S = e[ke + 72 >> 2], Ar = 1, Q = 1; ; ) {
                                  if (br = e[(Q << 2) + br >> 2], e[5996] = 0, Ms(45, br | 0, Ur | 0, C | 0), br = e[5996], e[5996] = 0, (br | 0) == 1)
                                    break o;
                                  if (br = S, S = e[ke + 72 >> 2], Ar = (br | 0) == (S | 0) ? Ar : Q, Q = Q + 1 | 0, br = e[l + 4 >> 2], Q = (Q | 0) == e[l + 8 >> 2] - br >> 2 ? 1 : Q, (Ar | 0) == (Q | 0))
                                    break;
                                }
                              if (C = e[me + 8 >> 2], !C)
                                break e;
                              if (l = e[me + 12 >> 2], (C | 0) != (l | 0)) {
                                for (; ; ) {
                                  l = l - 32 | 0, Q = e[l + 4 >> 2];
                                  s: {
                                    if (!Q || (S = e[Q + 4 >> 2], e[Q + 4 >> 2] = S - 1, S))
                                      break s;
                                    Yn[e[e[Q >> 2] + 8 >> 2]](Q), Ls(Q);
                                  }
                                  if ((l | 0) == (C | 0))
                                    break;
                                }
                                C = e[me + 8 >> 2];
                              }
                              Tr(C);
                              break e;
                            }
                            if (e[5996] = 0, ia(44, 2453, 1900, 676, 1984), l = e[5996], e[5996] = 0, (l | 0) != 1)
                              break r;
                            break t;
                          }
                          break t;
                        }
                        Nf(1940, 1900, 668, 1984), jn();
                      }
                      Nf(1841, 1900, 669, 1984);
                    }
                    jn();
                  }
                  Nf(3430, 1900, 664, 1984), jn();
                }
                l = gi() | 0, Pc(me + 8 | 0), ss(l | 0), jn();
              }
              return bi = me + 48 | 0, Ur | 0;
            }
            function dl(l, y, I, C, Q, S, me, ke, Ar) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0, me = me | 0, ke = ke | 0, Ar = Ar | 0;
              var br = 0, Qr = 0, Ur = 0, Xr = 0, Ri = 0, yn = 0, En = 0, Wn = 0, lo = 0;
              br = bi - 1056 | 0, bi = br, e[br + 16 >> 2] = S, e[br + 20 >> 2] = me, e[br + 24 >> 2] = ke, e[br + 28 >> 2] = Ar, l = br + 944 | 0, e[br + 940 >> 2] = l, Ur = r1(l, 100, 2304, br + 16 | 0), e[br + 48 >> 2] = 184, Ri = br + 520 | 0, e[Ri >> 2] = 0, e[Ri + 4 >> 2] = e[br + 48 >> 2], e[br + 48 >> 2] = 184, Xr = br + 512 | 0, e[Xr >> 2] = 0, e[Xr + 4 >> 2] = e[br + 48 >> 2];
              e: {
                t: {
                  r: {
                    i: {
                      if (Ur >>> 0 < 100) {
                        ke = br + 528 | 0;
                        break i;
                      }
                      if (l = fi(), e[br >> 2] = S, e[br + 4 >> 2] = me, e[br + 8 >> 2] = ke, e[br + 12 >> 2] = Ar, Ur = Hc(br + 940 | 0, l, 2304, br), (Ur | 0) != -1 && (l = e[br + 940 >> 2], _f(Ri, l), _f(Xr, vf(Ur << 2)), ke = e[Xr >> 2], ke))
                        break i;
                      if (e[5996] = 0, jo(185), l = e[5996], e[5996] = 0, (l | 0) != 1)
                        break e;
                      Ur = gi() | 0;
                      break r;
                    }
                    S = e[C + 28 >> 2], e[br + 508 >> 2] = S, e[S + 4 >> 2] = e[S + 4 >> 2] + 1, e[5996] = 0, lo = no(197, e[br + 508 >> 2]) | 0, S = e[5996], e[5996] = 0;
                    i: {
                      n: {
                        o: {
                          a: {
                            s: {
                              A: {
                                if ((S | 0) == 1 || (e[5996] = 0, ia(208, lo | 0, l | 0, l + Ur | 0, ke | 0), S = e[5996], e[5996] = 0, (S | 0) == 1))
                                  break A;
                                if (En = (Ur | 0) > 0 ? Je[l | 0] == 45 : En, me = br + 484 | 0, e[me >> 2] = 0, e[me + 4 >> 2] = 0, e[me + 8 >> 2] = 0, l = br + 472 | 0, e[l >> 2] = 0, e[l + 4 >> 2] = 0, e[l + 8 >> 2] = 0, S = br + 460 | 0, e[S >> 2] = 0, e[S + 4 >> 2] = 0, e[S + 8 >> 2] = 0, e[5996] = 0, gs(238, I | 0, En | 0, e[br + 508 >> 2], br + 504 | 0, br + 500 | 0, br + 496 | 0, me | 0, l | 0, S | 0, br + 456 | 0), I = e[5996], e[5996] = 0, (I | 0) == 1)
                                  break s;
                                e[br + 36 >> 2] = 184, I = br + 40 | 0, e[I >> 2] = 0, e[I + 4 >> 2] = e[br + 36 >> 2], Ar = br + 48 | 0, yn = e[br + 456 >> 2];
                                u: {
                                  if ((yn | 0) < (Ur | 0)) {
                                    Qr = Je[S + 11 | 0], Wn = (Ur - yn << 1) + ((Qr & 128) >>> 7 | 0 ? e[S + 4 >> 2] : Qr & 127) | 0, Qr = Je[l + 11 | 0], Qr = (Wn + ((Qr & 128) >>> 7 | 0 ? e[l + 4 >> 2] : Qr & 127) | 0) + 1 | 0;
                                    break u;
                                  }
                                  Qr = Je[S + 11 | 0], Wn = (Qr & 128) >>> 7 | 0 ? e[S + 4 >> 2] : Qr & 127, Qr = Je[l + 11 | 0], Qr = (Wn + ((Qr & 128) >>> 7 | 0 ? e[l + 4 >> 2] : Qr & 127) | 0) + 2 | 0;
                                }
                                if (Qr = Qr + yn | 0, Qr >>> 0 < 101 || (_f(I, vf(Qr << 2)), Ar = e[I >> 2], Ar))
                                  break a;
                                if (e[5996] = 0, jo(185), y = e[5996], e[5996] = 0, (y | 0) != 1)
                                  break e;
                                break o;
                              }
                              Ur = gi() | 0;
                              break i;
                            }
                            Ur = gi() | 0;
                            break n;
                          }
                          if (Qr = e[C + 4 >> 2], e[5996] = 0, Wc(239, Ar | 0, br + 36 | 0, br + 32 | 0, Qr | 0, ke | 0, (Ur << 2) + ke | 0, lo | 0, En | 0, br + 504 | 0, e[br + 500 >> 2], e[br + 496 >> 2], me | 0, l | 0, S | 0, yn | 0), ke = e[5996], e[5996] = 0, (ke | 0) != 1 && (e[5996] = 0, C = Cf(219, y | 0, Ar | 0, e[br + 36 >> 2], e[br + 32 >> 2], C | 0, Q | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) != 1))
                            break t;
                        }
                        Ur = gi() | 0, ka(I);
                      }
                      Yo(S), Yo(l), Yo(me);
                    }
                    l = e[br + 508 >> 2], y = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = y, (y | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l);
                  }
                  ka(Xr), ka(Ri), ss(Ur | 0), jn();
                }
                return ka(I), Yo(S), Yo(l), Yo(me), l = e[br + 508 >> 2], y = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = y, (y | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), ka(Xr), ka(Ri), bi = br + 1056 | 0, C | 0;
              }
              jn();
            }
            function Fc(l, y) {
              l = l | 0, y = y | 0;
              var I = 0, C = 0, Q = 0, S = 0;
              if (I = e[l + 4 >> 2], C = e[l + 8 >> 2], I >>> 0 < C >>> 0) {
                C = e[y >> 2], e[I + 12 >> 2] = 0, e[I + 4 >> 2] = 0, e[I + 8 >> 2] = 0, e[I >> 2] = C, e[I + 4 >> 2] = e[y + 4 >> 2], e[I + 8 >> 2] = e[y + 8 >> 2], e[I + 12 >> 2] = e[y + 12 >> 2], e[y + 12 >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, e[I + 24 >> 2] = 0, e[I + 16 >> 2] = 0, e[I + 20 >> 2] = 0, e[I + 16 >> 2] = e[y + 16 >> 2], e[I + 20 >> 2] = e[y + 20 >> 2], e[I + 24 >> 2] = e[y + 24 >> 2], e[y + 24 >> 2] = 0, e[y + 16 >> 2] = 0, e[y + 20 >> 2] = 0, e[I + 36 >> 2] = 0, e[I + 28 >> 2] = 0, e[I + 32 >> 2] = 0, e[I + 28 >> 2] = e[y + 28 >> 2], e[I + 32 >> 2] = e[y + 32 >> 2], e[I + 36 >> 2] = e[y + 36 >> 2], e[y + 36 >> 2] = 0, e[y + 28 >> 2] = 0, e[y + 32 >> 2] = 0, e[I + 48 >> 2] = 0, e[I + 40 >> 2] = 0, e[I + 44 >> 2] = 0, e[I + 40 >> 2] = e[y + 40 >> 2], e[I + 44 >> 2] = e[y + 44 >> 2], e[I + 48 >> 2] = e[y + 48 >> 2], e[y + 48 >> 2] = 0, e[y + 40 >> 2] = 0, e[y + 44 >> 2] = 0, e[I + 52 >> 2] = e[y + 52 >> 2], e[l + 4 >> 2] = I + 56;
                return;
              }
              e: {
                t: {
                  r: {
                    if (Q = e[l >> 2], S = (I - Q | 0) / 56 | 0, I = S + 1 | 0, I >>> 0 < 76695845) {
                      if (C = (C - Q | 0) / 56 | 0, Q = C << 1, I = C >>> 0 >= 38347922 ? 76695844 : I >>> 0 < Q >>> 0 ? Q : I, I >>> 0 >= 76695845)
                        break r;
                      if (C = No(I, 56), Q = ga(C), I = Q + No(S, 56) | 0, e[I >> 2] = e[y >> 2], e[I + 4 >> 2] = e[y + 4 >> 2], e[I + 8 >> 2] = e[y + 8 >> 2], e[I + 12 >> 2] = e[y + 12 >> 2], e[y + 12 >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, e[I + 16 >> 2] = e[y + 16 >> 2], e[I + 20 >> 2] = e[y + 20 >> 2], e[I + 24 >> 2] = e[y + 24 >> 2], e[y + 24 >> 2] = 0, e[y + 16 >> 2] = 0, e[y + 20 >> 2] = 0, e[I + 28 >> 2] = e[y + 28 >> 2], e[I + 32 >> 2] = e[y + 32 >> 2], e[I + 36 >> 2] = e[y + 36 >> 2], e[y + 36 >> 2] = 0, e[y + 28 >> 2] = 0, e[y + 32 >> 2] = 0, e[I + 40 >> 2] = e[y + 40 >> 2], e[I + 44 >> 2] = e[y + 44 >> 2], e[I + 48 >> 2] = e[y + 48 >> 2], e[y + 48 >> 2] = 0, e[y + 40 >> 2] = 0, e[y + 44 >> 2] = 0, e[I + 52 >> 2] = e[y + 52 >> 2], C = C + Q | 0, Q = I + 56 | 0, y = e[l + 4 >> 2], S = e[l >> 2], (y | 0) == (S | 0))
                        break t;
                      for (; I = I - 56 | 0, y = y - 56 | 0, e[I >> 2] = e[y >> 2], e[I + 4 >> 2] = e[y + 4 >> 2], e[I + 8 >> 2] = e[y + 8 >> 2], e[I + 12 >> 2] = e[y + 12 >> 2], e[y + 12 >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, e[I + 16 >> 2] = e[y + 16 >> 2], e[I + 20 >> 2] = e[y + 20 >> 2], e[I + 24 >> 2] = e[y + 24 >> 2], e[y + 24 >> 2] = 0, e[y + 16 >> 2] = 0, e[y + 20 >> 2] = 0, e[I + 28 >> 2] = e[y + 28 >> 2], e[I + 32 >> 2] = e[y + 32 >> 2], e[I + 36 >> 2] = e[y + 36 >> 2], e[y + 36 >> 2] = 0, e[y + 28 >> 2] = 0, e[y + 32 >> 2] = 0, e[I + 40 >> 2] = e[y + 40 >> 2], e[I + 44 >> 2] = e[y + 44 >> 2], e[I + 48 >> 2] = e[y + 48 >> 2], e[y + 48 >> 2] = 0, e[y + 40 >> 2] = 0, e[y + 44 >> 2] = 0, e[I + 52 >> 2] = e[y + 52 >> 2], (y | 0) != (S | 0); )
                        ;
                      if (e[l + 8 >> 2] = C, C = e[l + 4 >> 2], e[l + 4 >> 2] = Q, y = e[l >> 2], e[l >> 2] = I, (y | 0) == (C | 0))
                        break e;
                      for (; C = ff(C - 56 | 0), (C | 0) != (y | 0); )
                        ;
                      break e;
                    }
                    tf(), jn();
                  }
                  kc(), jn();
                }
                e[l + 8 >> 2] = C, e[l + 4 >> 2] = Q, e[l >> 2] = I;
              }
              y && Tr(y);
            }
            function pl(l, y, I, C, Q, S, me, ke, Ar) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0, me = me | 0, ke = ke | 0, Ar = Ar | 0;
              var br = 0, Qr = 0, Ur = 0, Xr = 0, Ri = 0, yn = 0, En = 0, Wn = 0, lo = 0;
              br = bi - 448 | 0, bi = br, e[br + 16 >> 2] = S, e[br + 20 >> 2] = me, e[br + 24 >> 2] = ke, e[br + 28 >> 2] = Ar, l = br + 336 | 0, e[br + 332 >> 2] = l, Ur = r1(l, 100, 2304, br + 16 | 0), e[br + 48 >> 2] = 184, Ri = br + 216 | 0, e[Ri >> 2] = 0, e[Ri + 4 >> 2] = e[br + 48 >> 2], e[br + 48 >> 2] = 184, Xr = br + 208 | 0, e[Xr >> 2] = 0, e[Xr + 4 >> 2] = e[br + 48 >> 2];
              e: {
                t: {
                  r: {
                    i: {
                      if (Ur >>> 0 < 100) {
                        ke = br + 224 | 0;
                        break i;
                      }
                      if (l = fi(), e[br >> 2] = S, e[br + 4 >> 2] = me, e[br + 8 >> 2] = ke, e[br + 12 >> 2] = Ar, Ur = Hc(br + 332 | 0, l, 2304, br), (Ur | 0) != -1 && (l = e[br + 332 >> 2], _f(Ri, l), _f(Xr, vf(Ur)), ke = e[Xr >> 2], ke))
                        break i;
                      if (e[5996] = 0, jo(185), l = e[5996], e[5996] = 0, (l | 0) != 1)
                        break e;
                      Ur = gi() | 0;
                      break r;
                    }
                    S = e[C + 28 >> 2], e[br + 204 >> 2] = S, e[S + 4 >> 2] = e[S + 4 >> 2] + 1, e[5996] = 0, lo = no(170, e[br + 204 >> 2]) | 0, S = e[5996], e[5996] = 0;
                    i: {
                      n: {
                        o: {
                          a: {
                            s: {
                              A: {
                                if ((S | 0) == 1 || (e[5996] = 0, ia(195, lo | 0, l | 0, l + Ur | 0, ke | 0), S = e[5996], e[5996] = 0, (S | 0) == 1))
                                  break A;
                                if (En = (Ur | 0) > 0 ? Je[l | 0] == 45 : En, me = br + 184 | 0, e[me >> 2] = 0, e[me + 4 >> 2] = 0, e[me + 8 >> 2] = 0, l = br + 172 | 0, e[l >> 2] = 0, e[l + 4 >> 2] = 0, e[l + 8 >> 2] = 0, S = br + 160 | 0, e[S >> 2] = 0, e[S + 4 >> 2] = 0, e[S + 8 >> 2] = 0, e[5996] = 0, gs(236, I | 0, En | 0, e[br + 204 >> 2], br + 200 | 0, br + 199 | 0, br + 198 | 0, me | 0, l | 0, S | 0, br + 156 | 0), I = e[5996], e[5996] = 0, (I | 0) == 1)
                                  break s;
                                e[br + 36 >> 2] = 184, I = br + 40 | 0, e[I >> 2] = 0, e[I + 4 >> 2] = e[br + 36 >> 2], Ar = br + 48 | 0, yn = e[br + 156 >> 2];
                                u: {
                                  if ((yn | 0) < (Ur | 0)) {
                                    Qr = Je[S + 11 | 0], Wn = (Ur - yn << 1) + ((Qr & 128) >>> 7 | 0 ? e[S + 4 >> 2] : Qr & 127) | 0, Qr = Je[l + 11 | 0], Qr = (Wn + ((Qr & 128) >>> 7 | 0 ? e[l + 4 >> 2] : Qr & 127) | 0) + 1 | 0;
                                    break u;
                                  }
                                  Qr = Je[S + 11 | 0], Wn = (Qr & 128) >>> 7 | 0 ? e[S + 4 >> 2] : Qr & 127, Qr = Je[l + 11 | 0], Qr = (Wn + ((Qr & 128) >>> 7 | 0 ? e[l + 4 >> 2] : Qr & 127) | 0) + 2 | 0;
                                }
                                if (Qr = Qr + yn | 0, Qr >>> 0 < 101 || (_f(I, vf(Qr)), Ar = e[I >> 2], Ar))
                                  break a;
                                if (e[5996] = 0, jo(185), y = e[5996], e[5996] = 0, (y | 0) != 1)
                                  break e;
                                break o;
                              }
                              Ur = gi() | 0;
                              break i;
                            }
                            Ur = gi() | 0;
                            break n;
                          }
                          if (Qr = e[C + 4 >> 2], e[5996] = 0, Wc(237, Ar | 0, br + 36 | 0, br + 32 | 0, Qr | 0, ke | 0, ke + Ur | 0, lo | 0, En | 0, br + 200 | 0, Se[br + 199 | 0], Se[br + 198 | 0], me | 0, l | 0, S | 0, yn | 0), ke = e[5996], e[5996] = 0, (ke | 0) != 1 && (e[5996] = 0, C = Cf(213, y | 0, Ar | 0, e[br + 36 >> 2], e[br + 32 >> 2], C | 0, Q | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) != 1))
                            break t;
                        }
                        Ur = gi() | 0, ka(I);
                      }
                      Yo(S), Yo(l), Yo(me);
                    }
                    l = e[br + 204 >> 2], y = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = y, (y | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l);
                  }
                  ka(Xr), ka(Ri), ss(Ur | 0), jn();
                }
                return ka(I), Yo(S), Yo(l), Yo(me), l = e[br + 204 >> 2], y = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = y, (y | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), ka(Xr), ka(Ri), bi = br + 448 | 0, C | 0;
              }
              jn();
            }
            function Yu(l, y, I, C, Q) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = +Q;
              var S = 0, me = 0, ke = 0, Ar = 0, br = 0;
              e: {
                t: {
                  if (!(y - 19 >>> 0 >= 7 & Q != 0)) {
                    S = 1 - Q;
                    r:
                      switch (y | 0) {
                        case 24:
                          if ((I | 0) != (C | 0))
                            for (; y = e[I >> 2], ke = ke + zo[y + 8 >> 3], me = me + zo[y + 16 >> 3], I = I + 4 | 0, (C | 0) != (I | 0); )
                              ;
                          zo[l + 8 >> 3] = me, zo[l >> 3] = (S == 0 ? 0 : S * me) + (Q == 0 ? 0 : ke * Q);
                          return;
                        case 3:
                          e[l + 8 >> 2] = 0, e[l + 12 >> 2] = 1078034432, e[l >> 2] = 0, e[l + 4 >> 2] = 1079689216;
                          return;
                        case 6:
                        case 7:
                        case 8:
                        case 9:
                          e[l + 8 >> 2] = 0, e[l + 12 >> 2] = 1077968896, e[l >> 2] = 0, e[l + 4 >> 2] = 1077968896;
                          return;
                        case 10:
                        case 11:
                        case 12:
                        case 16:
                          y = e[I >> 2], I = e[y + 12 >> 2], e[l >> 2] = e[y + 8 >> 2], e[l + 4 >> 2] = I, I = e[y + 20 >> 2], e[l + 8 >> 2] = e[y + 16 >> 2], e[l + 12 >> 2] = I;
                          return;
                        case 13:
                          Q = zo[e[I >> 2] + 8 >> 3], e[l + 8 >> 2] = 0, e[l + 12 >> 2] = 1072693248, zo[l >> 3] = Q + 2;
                          return;
                        case 14:
                          Q = zo[e[I >> 2] + 8 >> 3], e[l + 8 >> 2] = 0, e[l + 12 >> 2] = 2146435072, zo[l >> 3] = Q;
                          return;
                        case 15:
                          Q = zo[e[I >> 2] + 8 >> 3], e[l + 8 >> 2] = 0, e[l + 12 >> 2] = 1072693248, zo[l >> 3] = Q;
                          return;
                        case 0:
                          e[l + 8 >> 2] = 0, e[l + 12 >> 2] = 0, e[l >> 2] = 0, e[l + 4 >> 2] = 2146435072;
                          return;
                        case 17:
                          Q = zo[e[I + 4 >> 2] + 8 >> 3], S = zo[e[I >> 2] + 8 >> 3], e[l + 8 >> 2] = 0, e[l + 12 >> 2] = 2146435072, zo[l >> 3] = S + Q;
                          return;
                        case 18:
                          y = e[I + 4 >> 2], Q = zo[y + 16 >> 3], I = e[I >> 2], S = zo[I + 16 >> 3], zo[l >> 3] = zo[I + 8 >> 3] + zo[y + 8 >> 3], zo[l + 8 >> 3] = S + Q;
                          return;
                        case 19:
                          y = e[I >> 2], me = zo[y + 8 >> 3], I = e[I + 4 >> 2], ke = zo[I + 8 >> 3], Ar = zo[I + 16 >> 3], br = zo[y + 16 >> 3], zo[l + 8 >> 3] = Ar + br, zo[l >> 3] = (Q == 0 ? 0 : (me + Ar) * Q) + (S == 0 ? 0 : S * (br + ke));
                          return;
                        case 20:
                        case 21:
                          y = e[I + 4 >> 2], me = zo[y + 8 >> 3], I = e[I >> 2], ke = zo[I + 8 >> 3], Ar = zo[I + 16 >> 3], zo[l + 8 >> 3] = Ar + zo[y + 16 >> 3], zo[l >> 3] = (Q == 0 ? 0 : ke * Q) + (S == 0 ? 0 : S * (Ar + me));
                          return;
                        case 22:
                          y = e[I >> 2], me = zo[y + 8 >> 3], I = e[I + 4 >> 2], ke = zo[I + 8 >> 3], Ar = zo[I + 16 >> 3] + 1, br = zo[y + 16 >> 3] + 2, zo[l + 8 >> 3] = Ar < br ? Ar : br, zo[l >> 3] = (Q == 0 ? 0 : (me + 2) * Q) + (S == 0 ? 0 : S * (ke + 1));
                          return;
                        case 23:
                          y = e[I + 8 >> 2], me = zo[y + 8 >> 3], ke = zo[e[I + 4 >> 2] + 8 >> 3], I = e[I >> 2], Ar = zo[I + 8 >> 3], br = zo[I + 16 >> 3], zo[l + 8 >> 3] = br + zo[y + 16 >> 3], zo[l >> 3] = (Q == 0 ? 0 : (Ar + ke) * Q) + (S == 0 ? 0 : S * (br + me));
                          return;
                        default:
                          if (l = ro(8), e[5996] = 0, y = wn(91, l | 0, 1318) | 0, I = e[5996], e[5996] = 0, (I | 0) != 1)
                            break t;
                          y = gi() | 0, ef(l), ss(y | 0), jn();
                        case 1:
                        case 4:
                        case 5:
                          break e;
                        case 2:
                          break r;
                      }
                    e[l + 8 >> 2] = 0, e[l + 12 >> 2] = 1072693248, e[l >> 2] = 0, e[l + 4 >> 2] = 1079132160;
                    return;
                  }
                  Nf(4323, 1900, 476, 1746), jn();
                }
                E2(y | 0, 22664, 92), jn();
              }
              e[l + 8 >> 2] = 0, e[l + 12 >> 2] = 2146435072, e[l >> 2] = 0, e[l + 4 >> 2] = 0;
            }
            function xh(l, y, I, C, Q, S, me, ke, Ar) {
              var br = 0, Qr = 0, Ur = 0, Xr = 0, Ri = 0, yn = 0, En = 0, Wn = 0, lo = 0, Ro = 0, Xo = 0;
              br = bi - 128 | 0, bi = br;
              e: {
                t: {
                  r: {
                    if (!So(S, me, ke, Ar, 0, 0, 0, 0))
                      break r;
                    Qr = Ar & 65535, Ri = Ar >>> 16 & 32767;
                    i:
                      n: {
                        if ((Ri | 0) != 32767) {
                          if (Ur = 4, Ri)
                            break n;
                          Ur = S | ke | (me | Qr) ? 3 : 2;
                          break i;
                        }
                        Ur = !(S | ke | (me | Qr));
                      }
                    if (Ro = Q >>> 16 | 0, yn = Ro & 32767, (yn | 0) == 32767)
                      break r;
                    if (Ur)
                      break t;
                  }
                  Xa(br + 16 | 0, y, I, C, Q, S, me, ke, Ar), y = e[br + 16 >> 2], C = e[br + 20 >> 2], Q = e[br + 24 >> 2], I = e[br + 28 >> 2], _h(br, y, C, Q, I, y, C, Q, I), C = e[br + 8 >> 2], Q = e[br + 12 >> 2], ke = e[br >> 2], Ar = e[br + 4 >> 2];
                  break e;
                }
                if (Ur = C, En = Q & 2147483647, Qr = En, Ri = ke, Xr = Ar & 2147483647, (So(y, I, Ur, Qr, S, me, ke, Xr) | 0) <= 0) {
                  if (So(y, I, Ur, Qr, S, me, ke, Xr)) {
                    ke = y, Ar = I;
                    break e;
                  }
                  Xa(br + 112 | 0, y, I, C, Q, 0, 0, 0, 0), C = e[br + 120 >> 2], Q = e[br + 124 >> 2], ke = e[br + 112 >> 2], Ar = e[br + 116 >> 2];
                  break e;
                }
                if (Wn = Ar >>> 16 & 32767, yn ? (Ar = I, ke = y) : (Xa(br + 96 | 0, y, I, Ur, En, 0, 0, 0, 1081540608), Ur = e[br + 104 >> 2], ke = e[br + 108 >> 2], En = ke, yn = (ke >>> 16 | 0) - 120 | 0, Ar = e[br + 100 >> 2], ke = e[br + 96 >> 2]), Wn || (Xa(br + 80 | 0, S, me, Ri, Xr, 0, 0, 0, 1081540608), Ri = e[br + 88 >> 2], S = e[br + 92 >> 2], Xr = S, Wn = (S >>> 16 | 0) - 120 | 0, me = e[br + 84 >> 2], S = e[br + 80 >> 2]), lo = Ri, Xo = Xr & 65535 | 65536, En = En & 65535 | 65536, (yn | 0) > (Wn | 0)) {
                  for (; ; ) {
                    Xr = Ur - lo | 0, Qr = (me | 0) == (Ar | 0) & S >>> 0 > ke >>> 0 | me >>> 0 > Ar >>> 0, Ri = Xr - Qr | 0, Qr = (En - ((Ur >>> 0 < lo >>> 0) + Xo | 0) | 0) - (Qr >>> 0 > Xr >>> 0) | 0;
                    t: {
                      if ((Qr | 0) > 0 | (Qr | 0) >= 0) {
                        if (Ur = ke, ke = ke - S | 0, Ar = Ar - ((S >>> 0 > Ur >>> 0) + me | 0) | 0, !(ke | Ri | (Ar | Qr))) {
                          Xa(br + 32 | 0, y, I, C, Q, 0, 0, 0, 0), C = e[br + 40 >> 2], Q = e[br + 44 >> 2], ke = e[br + 32 >> 2], Ar = e[br + 36 >> 2];
                          break e;
                        }
                        Qr = Qr << 1 | Ri >>> 31, Ur = Ri << 1 | Ar >>> 31;
                        break t;
                      }
                      Qr = En << 1 | Ur >>> 31, Ur = Ur << 1 | Ar >>> 31;
                    }
                    if (En = Qr, Qr = Ar << 1 | ke >>> 31, ke = ke << 1, Ar = Qr, yn = yn - 1 | 0, !((yn | 0) > (Wn | 0)))
                      break;
                  }
                  yn = Wn;
                }
                Xr = Ur - lo | 0, Qr = (me | 0) == (Ar | 0) & S >>> 0 > ke >>> 0 | me >>> 0 > Ar >>> 0, Ri = Xr - Qr | 0, Qr = (En - ((Ur >>> 0 < lo >>> 0) + Xo | 0) | 0) - (Qr >>> 0 > Xr >>> 0) | 0, Xr = Qr;
                t: {
                  if ((Qr | 0) < 0) {
                    Ri = Ur, Xr = En;
                    break t;
                  }
                  if (Ur = ke, ke = ke - S | 0, Ar = Ar - ((S >>> 0 > Ur >>> 0) + me | 0) | 0, ke | Ri | (Ar | Xr))
                    break t;
                  Xa(br + 48 | 0, y, I, C, Q, 0, 0, 0, 0), C = e[br + 56 >> 2], Q = e[br + 60 >> 2], ke = e[br + 48 >> 2], Ar = e[br + 52 >> 2];
                  break e;
                }
                if ((Xr | 0) == 65535 | Xr >>> 0 < 65535)
                  for (; y = Ar >>> 31 | 0, yn = yn - 1 | 0, En = Ar << 1 | ke >>> 31, ke = ke << 1, Ar = En, I = y, y = Xr << 1 | Ri >>> 31, Ri = I | Ri << 1, Xr = y, y >>> 0 < 65536; )
                    ;
                if (y = Ro & 32768, (yn | 0) <= 0) {
                  Xa(br - -64 | 0, ke, Ar, Ri, Xr & 65535 | (y | yn + 120) << 16, 0, 0, 0, 1065811968), C = e[br + 72 >> 2], Q = e[br + 76 >> 2], ke = e[br + 64 >> 2], Ar = e[br + 68 >> 2];
                  break e;
                }
                C = Ri, Q = Xr & 65535 | (y | yn) << 16;
              }
              e[l >> 2] = ke, e[l + 4 >> 2] = Ar, e[l + 8 >> 2] = C, e[l + 12 >> 2] = Q, bi = br + 128 | 0;
            }
            function au(l, y) {
              l = l | 0, y = y | 0;
              var I = 0, C = 0, Q = 0, S = 0, me = 0, ke = 0, Ar = 0;
              ke = e[y >> 2], S = Je[y + 11 | 0], me = S << 24 >> 24, I = (me | 0) < 0, Ar = e[y + 4 >> 2], C = I ? Ar : S;
              e: {
                if ((C | 0) < 9)
                  break e;
                for (S = I ? ke : y, Q = S + C | 0; ; ) {
                  for (I = S; ; ) {
                    if (I = Hs(I, 115, C - 8 | 0), !I)
                      break e;
                    if (Wf(I, 4824, 9)) {
                      if (I = I + 1 | 0, C = Q - I | 0, (C | 0) >= 9)
                        continue;
                      break e;
                    }
                    break;
                  }
                  if ((I | 0) == (Q | 0) || (I = I - S | 0, (I | 0) == -1))
                    break e;
                  if (E(y, I, 9, 5034), ke = e[y >> 2], I = Je[y + 11 | 0], me = I << 24 >> 24, Q = (me | 0) < 0, S = Q ? ke : y, Ar = e[y + 4 >> 2], C = Q ? Ar : I, Q = S + C | 0, !((C | 0) > 8))
                    break;
                }
              }
              I = me << 24 >> 24, C = (I | 0) < 0 ? Ar : me & 255;
              e: {
                if ((C | 0) < 10)
                  break e;
                for (S = (I | 0) < 0 ? ke : y, Q = S + C | 0; ; ) {
                  for (I = S; ; ) {
                    if (I = Hs(I, 104, C - 9 | 0), !I)
                      break e;
                    if (Wf(I, 4813, 10)) {
                      if (I = I + 1 | 0, C = Q - I | 0, (C | 0) >= 10)
                        continue;
                      break e;
                    }
                    break;
                  }
                  if ((I | 0) == (Q | 0) || (I = I - S | 0, (I | 0) == -1))
                    break e;
                  if (E(y, I, 10, 4960), ke = e[y >> 2], I = Je[y + 11 | 0], me = I << 24 >> 24, Q = (me | 0) < 0, S = Q ? ke : y, Ar = e[y + 4 >> 2], C = Q ? Ar : I, Q = S + C | 0, !((C | 0) > 9))
                    break;
                }
              }
              I = me << 24 >> 24 < 0, C = I ? Ar : me & 255;
              e: {
                if ((C | 0) < 12)
                  break e;
                for (S = I ? ke : y, Q = S + C | 0; ; ) {
                  for (I = S; ; ) {
                    if (I = Hs(I, 114, C - 11 | 0), !I)
                      break e;
                    if (Wf(I, 4845, 12)) {
                      if (I = I + 1 | 0, C = Q - I | 0, (C | 0) >= 12)
                        continue;
                      break e;
                    }
                    break;
                  }
                  if ((I | 0) == (Q | 0) || (I = I - S | 0, (I | 0) == -1))
                    break e;
                  if (E(y, I, 12, 4908), ke = e[y >> 2], I = Je[y + 11 | 0], me = I << 24 >> 24, Q = (me | 0) < 0, S = Q ? ke : y, Ar = e[y + 4 >> 2], C = Q ? Ar : I, Q = S + C | 0, !((C | 0) > 11))
                    break;
                }
              }
              I = me << 24 >> 24, C = (I | 0) < 0 ? Ar : me & 255;
              e: {
                if ((C | 0) < 10)
                  break e;
                for (S = (I | 0) < 0 ? ke : y, Q = S + C | 0; ; ) {
                  for (I = S; ; ) {
                    if (I = Hs(I, 104, C - 9 | 0), !I)
                      break e;
                    if (Wf(I, 4834, 10)) {
                      if (I = I + 1 | 0, C = Q - I | 0, (C | 0) >= 10)
                        continue;
                      break e;
                    }
                    break;
                  }
                  if ((I | 0) == (Q | 0) || (I = I - S | 0, (I | 0) == -1))
                    break e;
                  if (E(y, I, 10, 4858), ke = e[y >> 2], I = Je[y + 11 | 0], me = I << 24 >> 24, Q = (me | 0) < 0, S = Q ? ke : y, Ar = e[y + 4 >> 2], C = Q ? Ar : I, Q = S + C | 0, !((C | 0) > 9))
                    break;
                }
              }
              I = me << 24 >> 24 < 0, C = I ? Ar : me & 255;
              e: {
                if ((C | 0) <= 0)
                  break e;
                for (Q = I ? ke : y, me = Q + C | 0; ; ) {
                  for (I = Q; ; ) {
                    if (I = Hs(I, 32, C), !I)
                      break e;
                    if (Je[I | 0] != 32) {
                      if (I = I + 1 | 0, C = me - I | 0, (C | 0) > 0)
                        continue;
                      break e;
                    }
                    break;
                  }
                  if ((I | 0) == (me | 0) || (I = I - Q | 0, (I | 0) == -1))
                    break e;
                  if (E(y, I, 1, 5575), I = Je[y + 11 | 0], S = I << 24 >> 24 < 0, Q = S ? e[y >> 2] : y, C = S ? e[y + 4 >> 2] : I, me = Q + C | 0, !((C | 0) > 0))
                    break;
                }
              }
              I = e[y + 4 >> 2], e[l >> 2] = e[y >> 2], e[l + 4 >> 2] = I, e[l + 8 >> 2] = e[y + 8 >> 2], e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0;
            }
            function fa(l, y, I, C, Q, S, me) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0, me = me | 0;
              var ke = 0, Ar = 0, br = 0, Qr = 0, Ur = 0, Xr = 0, Ri = 0, yn = 0, En = 0, Wn = 0;
              Qr = bi - 16 | 0, bi = Qr, Ur = L1(e[me >> 2]), yn = H1(e[me >> 2]), me = yn, Yn[e[e[me >> 2] + 20 >> 2]](Qr + 4 | 0, me), e[S >> 2] = C;
              e: {
                t: {
                  r:
                    switch (Ar = l, me = Je[Ar | 0], me - 43 | 0) {
                      case 0:
                      case 2:
                        break r;
                      default:
                        break t;
                    }
                  if (e[5996] = 0, me = wn(216, Ur | 0, me << 24 >> 24) | 0, Ar = e[5996], e[5996] = 0, (Ar | 0) == 1)
                    break e;
                  Ar = e[S >> 2], e[S >> 2] = Ar + 4, e[Ar >> 2] = me, Ar = l + 1 | 0;
                }
                t: {
                  if (me = Ar, !((I - me | 0) <= 1 | Je[me | 0] != 48 | (Je[me + 1 | 0] | 32) != 120)) {
                    if (e[5996] = 0, Ar = wn(216, Ur | 0, 48) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1 || (ke = e[S >> 2], e[S >> 2] = ke + 4, e[ke >> 2] = Ar, Ar = Se[me + 1 | 0], e[5996] = 0, Ar = wn(216, Ur | 0, Ar | 0) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1))
                      break e;
                    for (ke = e[S >> 2], e[S >> 2] = ke + 4, e[ke >> 2] = Ar, Ar = me + 2 | 0, me = Ar; ; ) {
                      if (I >>> 0 <= me >>> 0 || (ke = Se[me | 0], fi(), !(ke - 48 >>> 0 < 10 | (ke | 32) - 97 >>> 0 < 6)))
                        break t;
                      me = me + 1 | 0;
                    }
                  }
                  for (; ; ) {
                    if (I >>> 0 <= me >>> 0 || (ke = Se[me | 0], fi(), ke - 48 >>> 0 >= 10))
                      break t;
                    me = me + 1 | 0;
                  }
                }
                t: {
                  if (ke = Je[Qr + 15 | 0], !((ke & 128) >>> 7 | 0 ? e[Qr + 8 >> 2] : ke & 127)) {
                    if (ke = e[S >> 2], e[5996] = 0, ia(208, Ur | 0, Ar | 0, me | 0, ke | 0), ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                      break e;
                    e[S >> 2] = e[S >> 2] + (me - Ar << 2);
                    break t;
                  }
                  if (Uu(Ar, me), e[5996] = 0, Wn = no(206, yn | 0) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                    break e;
                  for (ke = Ar; ; ) {
                    if (me >>> 0 <= ke >>> 0) {
                      Xl((Ar - l << 2) + C | 0, e[S >> 2]);
                      break t;
                    }
                    if (br = Qr + 4 | 0, Xr = (Je[br + 11 | 0] & 128) >>> 7 | 0, Se[(Xr ? e[br >> 2] : br) + Ri | 0] <= 0 | Se[(Xr ? e[br >> 2] : br) + Ri | 0] != (En | 0) || (br = e[S >> 2], e[S >> 2] = br + 4, e[br >> 2] = Wn, En = 0, br = Je[Qr + 15 | 0], Ri = (((br & 128) >>> 7 | 0 ? e[Qr + 8 >> 2] : br & 127) - 1 >>> 0 > Ri >>> 0) + Ri | 0), br = Se[ke | 0], e[5996] = 0, br = wn(216, Ur | 0, br | 0) | 0, Xr = e[5996], e[5996] = 0, (Xr | 0) != 1) {
                      Xr = e[S >> 2], e[S >> 2] = Xr + 4, e[Xr >> 2] = br, ke = ke + 1 | 0, En = En + 1 | 0;
                      continue;
                    }
                    break;
                  }
                  break e;
                }
                t: {
                  for (; ; ) {
                    if (I >>> 0 > me >>> 0) {
                      if (Ar = Je[me | 0], (Ar | 0) == 46) {
                        if (e[5996] = 0, Ar = no(209, yn | 0) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                          break e;
                        br = e[S >> 2], ke = br + 4 | 0, e[S >> 2] = ke, e[br >> 2] = Ar, me = me + 1 | 0;
                        break t;
                      }
                      if (e[5996] = 0, Ar = wn(216, Ur | 0, Ar << 24 >> 24) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                        break e;
                      ke = e[S >> 2], e[S >> 2] = ke + 4, e[ke >> 2] = Ar, me = me + 1 | 0;
                      continue;
                    }
                    break;
                  }
                  ke = e[S >> 2];
                }
                if (e[5996] = 0, ia(208, Ur | 0, me | 0, I | 0, ke | 0), Ar = e[5996], e[5996] = 0, (Ar | 0) == 1)
                  break e;
                Ar = S, S = e[S >> 2] + (I - me << 2) | 0, e[Ar >> 2] = S, e[Q >> 2] = (y | 0) == (I | 0) ? S : (y - l << 2) + C | 0, Yo(Qr + 4 | 0), bi = Qr + 16 | 0;
                return;
              }
              l = gi() | 0, Yo(Qr + 4 | 0), ss(l | 0), jn();
            }
            function Rh(l, y, I, C, Q, S, me) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0, me = me | 0;
              var ke = 0, Ar = 0, br = 0, Qr = 0, Ur = 0, Xr = 0, Ri = 0, yn = 0, En = 0, Wn = 0;
              Qr = bi - 16 | 0, bi = Qr, Ur = Q1(e[me >> 2]), yn = q1(e[me >> 2]), me = yn, Yn[e[e[me >> 2] + 20 >> 2]](Qr + 4 | 0, me), e[S >> 2] = C;
              e: {
                t: {
                  r:
                    switch (Ar = l, me = Je[Ar | 0], me - 43 | 0) {
                      case 0:
                      case 2:
                        break r;
                      default:
                        break t;
                    }
                  if (e[5996] = 0, me = wn(171, Ur | 0, me << 24 >> 24) | 0, Ar = e[5996], e[5996] = 0, (Ar | 0) == 1)
                    break e;
                  Ar = e[S >> 2], e[S >> 2] = Ar + 1, Se[Ar | 0] = me, Ar = l + 1 | 0;
                }
                t: {
                  if (me = Ar, !((I - me | 0) <= 1 | Je[me | 0] != 48 | (Je[me + 1 | 0] | 32) != 120)) {
                    if (e[5996] = 0, Ar = wn(171, Ur | 0, 48) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1 || (ke = e[S >> 2], e[S >> 2] = ke + 1, Se[ke | 0] = Ar, Ar = Se[me + 1 | 0], e[5996] = 0, Ar = wn(171, Ur | 0, Ar | 0) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1))
                      break e;
                    for (ke = e[S >> 2], e[S >> 2] = ke + 1, Se[ke | 0] = Ar, Ar = me + 2 | 0, me = Ar; ; ) {
                      if (I >>> 0 <= me >>> 0 || (ke = Se[me | 0], fi(), !(ke - 48 >>> 0 < 10 | (ke | 32) - 97 >>> 0 < 6)))
                        break t;
                      me = me + 1 | 0;
                    }
                  }
                  for (; ; ) {
                    if (I >>> 0 <= me >>> 0 || (ke = Se[me | 0], fi(), ke - 48 >>> 0 >= 10))
                      break t;
                    me = me + 1 | 0;
                  }
                }
                t: {
                  if (ke = Je[Qr + 15 | 0], !((ke & 128) >>> 7 | 0 ? e[Qr + 8 >> 2] : ke & 127)) {
                    if (ke = e[S >> 2], e[5996] = 0, ia(195, Ur | 0, Ar | 0, me | 0, ke | 0), ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                      break e;
                    e[S >> 2] = e[S >> 2] + (me - Ar | 0);
                    break t;
                  }
                  if (Uu(Ar, me), e[5996] = 0, Wn = no(193, yn | 0) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                    break e;
                  for (ke = Ar; ; ) {
                    if (me >>> 0 <= ke >>> 0) {
                      Uu((Ar - l | 0) + C | 0, e[S >> 2]);
                      break t;
                    }
                    if (br = Qr + 4 | 0, Xr = (Je[br + 11 | 0] & 128) >>> 7 | 0, Se[(Xr ? e[br >> 2] : br) + Ri | 0] <= 0 | Se[(Xr ? e[br >> 2] : br) + Ri | 0] != (En | 0) || (br = e[S >> 2], e[S >> 2] = br + 1, Se[br | 0] = Wn, En = 0, br = Je[Qr + 15 | 0], Ri = (((br & 128) >>> 7 | 0 ? e[Qr + 8 >> 2] : br & 127) - 1 >>> 0 > Ri >>> 0) + Ri | 0), br = Se[ke | 0], e[5996] = 0, br = wn(171, Ur | 0, br | 0) | 0, Xr = e[5996], e[5996] = 0, (Xr | 0) != 1) {
                      Xr = e[S >> 2], e[S >> 2] = Xr + 1, Se[Xr | 0] = br, ke = ke + 1 | 0, En = En + 1 | 0;
                      continue;
                    }
                    break;
                  }
                  break e;
                }
                for (; ; ) {
                  t: {
                    if (I >>> 0 > me >>> 0) {
                      if (Ar = Je[me | 0], (Ar | 0) != 46)
                        break t;
                      if (e[5996] = 0, Ar = no(196, yn | 0) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                        break e;
                      ke = e[S >> 2], e[S >> 2] = ke + 1, Se[ke | 0] = Ar, me = me + 1 | 0;
                    }
                    if (Ar = e[S >> 2], e[5996] = 0, ia(195, Ur | 0, me | 0, I | 0, Ar | 0), Ar = e[5996], e[5996] = 0, (Ar | 0) == 1)
                      break e;
                    Ar = S, S = e[S >> 2] + (I - me | 0) | 0, e[Ar >> 2] = S, e[Q >> 2] = (y | 0) == (I | 0) ? S : (y - l | 0) + C | 0, Yo(Qr + 4 | 0), bi = Qr + 16 | 0;
                    return;
                  }
                  if (e[5996] = 0, Ar = wn(171, Ur | 0, Ar << 24 >> 24) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                    break e;
                  ke = e[S >> 2], e[S >> 2] = ke + 1, Se[ke | 0] = Ar, me = me + 1 | 0;
                }
              }
              l = gi() | 0, Yo(Qr + 4 | 0), ss(l | 0), jn();
            }
            function Ph(l, y, I, C) {
              var Q = 0, S = 0, me = 0, ke = 0, Ar = 0;
              Q = e[y >> 2];
              e: {
                t: {
                  r: {
                    i: {
                      n: {
                        o: {
                          a: {
                            s: {
                              A: {
                                u: {
                                  h: {
                                    c: {
                                      if (!C || (me = e[C >> 2], !me))
                                        break c;
                                      if (!l) {
                                        C = I;
                                        break u;
                                      }
                                      e[C >> 2] = 0, C = I;
                                      break h;
                                    }
                                    c: {
                                      if (!e[e[6178] >> 2]) {
                                        if (!l)
                                          break c;
                                        if (!I)
                                          break e;
                                        for (me = I; ; ) {
                                          if (C = Se[Q | 0], C) {
                                            if (e[l >> 2] = C & 57343, l = l + 4 | 0, Q = Q + 1 | 0, me = me - 1 | 0, me)
                                              continue;
                                            break e;
                                          }
                                          break;
                                        }
                                        return e[l >> 2] = 0, e[y >> 2] = 0, I - me | 0;
                                      }
                                      if (C = I, !l)
                                        break A;
                                      break a;
                                    }
                                    return Jf(Q);
                                  }
                                  S = 1;
                                  break a;
                                }
                                S = 0;
                                break s;
                              }
                              S = 1;
                            }
                            for (; ; ) {
                              if (!S) {
                                if (S = Je[Q | 0] >>> 3 | 0, (S - 16 | S + (me >> 26)) >>> 0 > 7)
                                  break o;
                                S = Q + 1 | 0;
                                s: {
                                  if (!(me & 33554432))
                                    break s;
                                  if ((Je[S | 0] & 192) != 128) {
                                    Q = Q - 1 | 0;
                                    break i;
                                  }
                                  if (S = Q + 2 | 0, !(me & 524288))
                                    break s;
                                  if ((Je[S | 0] & 192) != 128) {
                                    Q = Q - 1 | 0;
                                    break i;
                                  }
                                  S = Q + 3 | 0;
                                }
                                Q = S, C = C - 1 | 0, S = 1;
                                continue;
                              }
                              for (; ; ) {
                                me = Je[Q | 0];
                                s: {
                                  if (Q & 3 | me - 1 >>> 0 > 126 || (me = e[Q >> 2], (me | me - 16843009) & -2139062144))
                                    break s;
                                  for (; C = C - 4 | 0, me = e[Q + 4 >> 2], Q = Q + 4 | 0, !((me - 16843009 | me) & -2139062144); )
                                    ;
                                }
                                if (S = me & 255, S - 1 >>> 0 <= 126) {
                                  C = C - 1 | 0, Q = Q + 1 | 0;
                                  continue;
                                }
                                break;
                              }
                              if (S = S - 194 | 0, S >>> 0 > 50)
                                break n;
                              Q = Q + 1 | 0, me = e[(S << 2) + 12208 >> 2], S = 0;
                            }
                          }
                          for (; ; ) {
                            if (!S) {
                              if (!C)
                                break e;
                              for (; ; ) {
                                a: {
                                  S = Je[Q | 0], ke = S - 1 | 0;
                                  s: {
                                    A: {
                                      if (ke >>> 0 > 126) {
                                        me = S;
                                        break A;
                                      }
                                      if (Q & 3 | C >>> 0 < 5)
                                        break s;
                                      u: {
                                        for (; ; ) {
                                          if (me = e[Q >> 2], (me | me - 16843009) & -2139062144)
                                            break u;
                                          if (e[l >> 2] = me & 255, e[l + 4 >> 2] = Je[Q + 1 | 0], e[l + 8 >> 2] = Je[Q + 2 | 0], e[l + 12 >> 2] = Je[Q + 3 | 0], l = l + 16 | 0, Q = Q + 4 | 0, C = C - 4 | 0, !(C >>> 0 > 4))
                                            break;
                                        }
                                        me = Je[Q | 0];
                                      }
                                      S = me & 255, ke = S - 1 | 0;
                                    }
                                    if (ke >>> 0 > 126)
                                      break a;
                                  }
                                  if (e[l >> 2] = S, l = l + 4 | 0, Q = Q + 1 | 0, C = C - 1 | 0, C)
                                    continue;
                                  break e;
                                }
                                break;
                              }
                              if (S = S - 194 | 0, S >>> 0 > 50)
                                break n;
                              Q = Q + 1 | 0, me = e[(S << 2) + 12208 >> 2], S = 1;
                              continue;
                            }
                            if (Ar = Je[Q | 0], S = Ar >>> 3 | 0, (S - 16 | S + (me >> 26)) >>> 0 > 7)
                              break o;
                            a: {
                              s: {
                                ke = Q + 1 | 0, S = Ar - 128 | me << 6;
                                A: {
                                  if ((S | 0) >= 0)
                                    break A;
                                  if (Ar = Je[ke | 0] - 128 | 0, Ar >>> 0 > 63)
                                    break s;
                                  if (ke = Q + 2 | 0, S = Ar | S << 6, (S | 0) >= 0)
                                    break A;
                                  if (ke = Je[ke | 0] - 128 | 0, ke >>> 0 > 63)
                                    break s;
                                  S = ke | S << 6, ke = Q + 3 | 0;
                                }
                                Q = ke, e[l >> 2] = S, C = C - 1 | 0, l = l + 4 | 0;
                                break a;
                              }
                              e[5732] = 25, Q = Q - 1 | 0;
                              break r;
                            }
                            S = 0;
                          }
                        }
                        if (Q = Q - 1 | 0, me)
                          break i;
                        me = Je[Q | 0];
                      }
                      if (me & 255)
                        break i;
                      return l && (e[l >> 2] = 0, e[y >> 2] = 0), I - C | 0;
                    }
                    if (e[5732] = 25, !l)
                      break t;
                  }
                  e[y >> 2] = Q;
                }
                return -1;
              }
              return e[y >> 2] = Q, I;
            }
            function gl(l, y, I, C, Q, S) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0;
              var me = 0, ke = 0;
              l = bi - 256 | 0, bi = l, e[l + 248 >> 2] = I, e[l + 252 >> 2] = y, ke = l + 196 | 0, e[ke >> 2] = 0, e[ke + 4 >> 2] = 0, e[ke + 8 >> 2] = 0, me = l + 16 | 0, y = e[C + 28 >> 2], e[me >> 2] = y, e[y + 4 >> 2] = e[y + 4 >> 2] + 1, e[5996] = 0, y = no(170, e[l + 16 >> 2]) | 0, I = e[5996], e[5996] = 0;
              e: {
                t: {
                  if ((I | 0) == 1 || (e[5996] = 0, ia(195, y | 0, 12416, 12442, l + 208 | 0), y = e[5996], e[5996] = 0, (y | 0) == 1))
                    break t;
                  if (y = e[l + 16 >> 2], I = e[y + 4 >> 2] - 1 | 0, e[y + 4 >> 2] = I, (I | 0) == -1 && Yn[e[e[y >> 2] + 8 >> 2]](y), I = l + 184 | 0, e[I >> 2] = 0, e[I + 4 >> 2] = 0, e[I + 8 >> 2] = 0, y = (Je[I + 11 | 0] & 128) >>> 7 | 0 ? (e[I + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, Co(172, I | 0, y | 0), y = e[5996], e[5996] = 0, (y | 0) != 1)
                    r:
                      for (y = (Je[I + 11 | 0] & 128) >>> 7 | 0 ? e[I >> 2] : I, e[l + 180 >> 2] = y, e[l + 12 >> 2] = me, e[l + 8 >> 2] = 0; ; ) {
                        i: {
                          if (e[5996] = 0, me = wn(186, l + 252 | 0, l + 248 | 0) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                            break i;
                          C = e[l + 180 >> 2];
                          n: {
                            if (!me) {
                              if (me = C, C = Je[I + 11 | 0], C = (C & 128) >>> 7 | 0 ? e[I + 4 >> 2] : C & 127, (me | 0) == (C + y | 0)) {
                                if (e[5996] = 0, Co(172, I | 0, C << 1), y = e[5996], e[5996] = 0, (y | 0) == 1 || (y = (Je[I + 11 | 0] & 128) >>> 7 | 0 ? (e[I + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, Co(172, I | 0, y | 0), y = e[5996], e[5996] = 0, (y | 0) == 1))
                                  break r;
                                y = (Je[I + 11 | 0] & 128) >>> 7 | 0 ? e[I >> 2] : I, e[l + 180 >> 2] = C + y;
                              }
                              if (e[5996] = 0, C = no(187, e[l + 252 >> 2]) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                break i;
                              if (!Mi(C, 16, y, l + 180 | 0, l + 8 | 0, 0, e[ke + 4 >> 2], Je[ke + 11 | 0], l + 16 | 0, l + 12 | 0, l + 208 | 0))
                                break n;
                              C = e[l + 180 >> 2];
                            }
                            if (e[5996] = 0, Co(172, I | 0, C - y | 0), y = e[5996], e[5996] = 0, (y | 0) == 1 || (y = e[I >> 2], C = (Je[I + 11 | 0] & 128) >>> 7 | 0, me = fi(), e[l >> 2] = S, (bd(C ? y : I, me, l) | 0) != 1 && (e[Q >> 2] = 4), e[5996] = 0, y = wn(186, l + 252 | 0, l + 248 | 0) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1))
                              break i;
                            return y && (e[Q >> 2] = e[Q >> 2] | 2), y = e[l + 252 >> 2], Yo(I), Yo(ke), bi = l + 256 | 0, y | 0;
                          }
                          if (e[5996] = 0, no(189, l + 252 | 0) | 0, C = e[5996], e[5996] = 0, (C | 0) != 1)
                            continue;
                        }
                        break;
                      }
                  y = gi() | 0, Yo(I);
                  break e;
                }
                y = gi() | 0, l = e[l + 16 >> 2], I = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = I, (I | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l);
              }
              Yo(ke), ss(y | 0), jn();
            }
            function yl(l, y, I, C, Q, S) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0;
              var me = 0, ke = 0;
              l = bi - 320 | 0, bi = l, e[l + 312 >> 2] = I, e[l + 316 >> 2] = y, ke = l + 196 | 0, e[ke >> 2] = 0, e[ke + 4 >> 2] = 0, e[ke + 8 >> 2] = 0, me = l + 16 | 0, y = e[C + 28 >> 2], e[me >> 2] = y, e[y + 4 >> 2] = e[y + 4 >> 2] + 1, e[5996] = 0, y = no(197, e[l + 16 >> 2]) | 0, I = e[5996], e[5996] = 0;
              e: {
                t: {
                  if ((I | 0) == 1 || (e[5996] = 0, ia(208, y | 0, 12416, 12442, l + 208 | 0), y = e[5996], e[5996] = 0, (y | 0) == 1))
                    break t;
                  if (y = e[l + 16 >> 2], I = e[y + 4 >> 2] - 1 | 0, e[y + 4 >> 2] = I, (I | 0) == -1 && Yn[e[e[y >> 2] + 8 >> 2]](y), I = l + 184 | 0, e[I >> 2] = 0, e[I + 4 >> 2] = 0, e[I + 8 >> 2] = 0, y = (Je[I + 11 | 0] & 128) >>> 7 | 0 ? (e[I + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, Co(172, I | 0, y | 0), y = e[5996], e[5996] = 0, (y | 0) != 1)
                    r:
                      for (y = (Je[I + 11 | 0] & 128) >>> 7 | 0 ? e[I >> 2] : I, e[l + 180 >> 2] = y, e[l + 12 >> 2] = me, e[l + 8 >> 2] = 0; ; ) {
                        i: {
                          if (e[5996] = 0, me = wn(202, l + 316 | 0, l + 312 | 0) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                            break i;
                          C = e[l + 180 >> 2];
                          n: {
                            if (!me) {
                              if (me = C, C = Je[I + 11 | 0], C = (C & 128) >>> 7 | 0 ? e[I + 4 >> 2] : C & 127, (me | 0) == (C + y | 0)) {
                                if (e[5996] = 0, Co(172, I | 0, C << 1), y = e[5996], e[5996] = 0, (y | 0) == 1 || (y = (Je[I + 11 | 0] & 128) >>> 7 | 0 ? (e[I + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, Co(172, I | 0, y | 0), y = e[5996], e[5996] = 0, (y | 0) == 1))
                                  break r;
                                y = (Je[I + 11 | 0] & 128) >>> 7 | 0 ? e[I >> 2] : I, e[l + 180 >> 2] = C + y;
                              }
                              if (e[5996] = 0, C = no(203, e[l + 316 >> 2]) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                                break i;
                              if (!Wi(C, 16, y, l + 180 | 0, l + 8 | 0, 0, e[ke + 4 >> 2], Je[ke + 11 | 0], l + 16 | 0, l + 12 | 0, l + 208 | 0))
                                break n;
                              C = e[l + 180 >> 2];
                            }
                            if (e[5996] = 0, Co(172, I | 0, C - y | 0), y = e[5996], e[5996] = 0, (y | 0) == 1 || (y = e[I >> 2], C = (Je[I + 11 | 0] & 128) >>> 7 | 0, me = fi(), e[l >> 2] = S, (bd(C ? y : I, me, l) | 0) != 1 && (e[Q >> 2] = 4), e[5996] = 0, y = wn(202, l + 316 | 0, l + 312 | 0) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1))
                              break i;
                            return y && (e[Q >> 2] = e[Q >> 2] | 2), y = e[l + 316 >> 2], Yo(I), Yo(ke), bi = l + 320 | 0, y | 0;
                          }
                          if (e[5996] = 0, no(205, l + 316 | 0) | 0, C = e[5996], e[5996] = 0, (C | 0) != 1)
                            continue;
                        }
                        break;
                      }
                  y = gi() | 0, Yo(I);
                  break e;
                }
                y = gi() | 0, l = e[l + 16 >> 2], I = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = I, (I | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l);
              }
              Yo(ke), ss(y | 0), jn();
            }
            function Ca(l, y, I, C, Q, S) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0;
              var me = 0, ke = 0, Ar = 0, br = 0, Qr = 0, Ur = 0, Xr = 0, Ri = 0, yn = 0, En = 0;
              l = bi - 480 | 0, bi = l, me = e[C + 28 >> 2], e[l + 476 >> 2] = me, e[me + 4 >> 2] = e[me + 4 >> 2] + 1, e[5996] = 0, yn = no(197, e[l + 476 >> 2]) | 0, me = e[5996], e[5996] = 0;
              e: {
                t: {
                  r: {
                    i: {
                      n: {
                        if ((me | 0) != 1) {
                          if (Ar = Je[S + 11 | 0], me = (Ar & 128) >>> 7 | 0, me ? e[S + 4 >> 2] : Ar & 127) {
                            if (me = e[(me ? e[S >> 2] : S) >> 2], e[5996] = 0, Ar = wn(216, yn | 0, 45) | 0, Qr = e[5996], e[5996] = 0, (Qr | 0) == 1)
                              break n;
                            En = (me | 0) == (Ar | 0);
                          }
                          if (Qr = l + 452 | 0, e[Qr >> 2] = 0, e[Qr + 4 >> 2] = 0, e[Qr + 8 >> 2] = 0, me = l + 440 | 0, e[me >> 2] = 0, e[me + 4 >> 2] = 0, e[me + 8 >> 2] = 0, Ar = l + 428 | 0, e[Ar >> 2] = 0, e[Ar + 4 >> 2] = 0, e[Ar + 8 >> 2] = 0, e[5996] = 0, gs(238, I | 0, En | 0, e[l + 476 >> 2], l + 472 | 0, l + 468 | 0, l + 464 | 0, Qr | 0, me | 0, Ar | 0, l + 424 | 0), I = e[5996], e[5996] = 0, (I | 0) == 1)
                            break i;
                          e[l + 4 >> 2] = 184, Ur = l + 8 | 0, e[Ur >> 2] = 0, e[Ur + 4 >> 2] = e[l + 4 >> 2], I = l + 16 | 0, br = Je[S + 11 | 0], br = (br & 128) >>> 7 | 0 ? e[S + 4 >> 2] : br & 127, Xr = e[l + 424 >> 2];
                          o: {
                            if ((br | 0) > (Xr | 0)) {
                              ke = Je[Ar + 11 | 0], Ri = (br - Xr << 1) + ((ke & 128) >>> 7 | 0 ? e[Ar + 4 >> 2] : ke & 127) | 0, ke = Je[me + 11 | 0], ke = (Ri + ((ke & 128) >>> 7 | 0 ? e[me + 4 >> 2] : ke & 127) | 0) + 1 | 0;
                              break o;
                            }
                            ke = Je[Ar + 11 | 0], Ri = (ke & 128) >>> 7 | 0 ? e[Ar + 4 >> 2] : ke & 127, ke = Je[me + 11 | 0], ke = (Ri + ((ke & 128) >>> 7 | 0 ? e[me + 4 >> 2] : ke & 127) | 0) + 2 | 0;
                          }
                          o: {
                            if (ke = ke + Xr | 0, ke >>> 0 >= 101) {
                              if (_f(Ur, vf(ke << 2)), I = e[Ur >> 2], !I)
                                break o;
                              br = Je[S + 11 | 0], br = (br & 128) >>> 7 | 0 ? e[S + 4 >> 2] : br & 127;
                            }
                            if (ke = e[C + 4 >> 2], S = (Je[S + 11 | 0] & 128) >>> 7 | 0 ? e[S >> 2] : S, e[5996] = 0, Wc(239, I | 0, l + 4 | 0, l | 0, ke | 0, S | 0, S + (br << 2) | 0, yn | 0, En | 0, l + 472 | 0, e[l + 468 >> 2], e[l + 464 >> 2], Qr | 0, me | 0, Ar | 0, Xr | 0), S = e[5996], e[5996] = 0, (S | 0) == 1 || (e[5996] = 0, C = Cf(219, y | 0, I | 0, e[l + 4 >> 2], e[l >> 2], C | 0, Q | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1))
                              break r;
                            return ka(Ur), Yo(Ar), Yo(me), Yo(Qr), y = e[l + 476 >> 2], I = e[y + 4 >> 2] - 1 | 0, e[y + 4 >> 2] = I, (I | 0) == -1 && Yn[e[e[y >> 2] + 8 >> 2]](y), bi = l + 480 | 0, C | 0;
                          }
                          if (e[5996] = 0, jo(185), y = e[5996], e[5996] = 0, (y | 0) == 1)
                            break r;
                          jn();
                        }
                        S = gi() | 0;
                        break e;
                      }
                      S = gi() | 0;
                      break e;
                    }
                    S = gi() | 0;
                    break t;
                  }
                  S = gi() | 0, ka(Ur);
                }
                Yo(Ar), Yo(me), Yo(Qr);
              }
              l = e[l + 476 >> 2], y = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = y, (y | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), ss(S | 0), jn();
            }
            function Bu(l, y, I, C, Q, S) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0;
              var me = 0, ke = 0, Ar = 0, br = 0, Qr = 0, Ur = 0, Xr = 0, Ri = 0, yn = 0, En = 0;
              l = bi - 176 | 0, bi = l, me = e[C + 28 >> 2], e[l + 172 >> 2] = me, e[me + 4 >> 2] = e[me + 4 >> 2] + 1, e[5996] = 0, yn = no(170, e[l + 172 >> 2]) | 0, me = e[5996], e[5996] = 0;
              e: {
                t: {
                  r: {
                    i: {
                      n: {
                        if ((me | 0) != 1) {
                          if (Ar = Je[S + 11 | 0], me = (Ar & 128) >>> 7 | 0, me ? e[S + 4 >> 2] : Ar & 127) {
                            if (me = Je[(me ? e[S >> 2] : S) | 0], e[5996] = 0, Ar = wn(171, yn | 0, 45) | 0, Qr = e[5996], e[5996] = 0, (Qr | 0) == 1)
                              break n;
                            En = (Ar & 255) == (me | 0);
                          }
                          if (Qr = l + 152 | 0, e[Qr >> 2] = 0, e[Qr + 4 >> 2] = 0, e[Qr + 8 >> 2] = 0, me = l + 140 | 0, e[me >> 2] = 0, e[me + 4 >> 2] = 0, e[me + 8 >> 2] = 0, Ar = l + 128 | 0, e[Ar >> 2] = 0, e[Ar + 4 >> 2] = 0, e[Ar + 8 >> 2] = 0, e[5996] = 0, gs(236, I | 0, En | 0, e[l + 172 >> 2], l + 168 | 0, l + 167 | 0, l + 166 | 0, Qr | 0, me | 0, Ar | 0, l + 124 | 0), I = e[5996], e[5996] = 0, (I | 0) == 1)
                            break i;
                          e[l + 4 >> 2] = 184, Ur = l + 8 | 0, e[Ur >> 2] = 0, e[Ur + 4 >> 2] = e[l + 4 >> 2], I = l + 16 | 0, br = Je[S + 11 | 0], br = (br & 128) >>> 7 | 0 ? e[S + 4 >> 2] : br & 127, Xr = e[l + 124 >> 2];
                          o: {
                            if ((br | 0) > (Xr | 0)) {
                              ke = Je[Ar + 11 | 0], Ri = (br - Xr << 1) + ((ke & 128) >>> 7 | 0 ? e[Ar + 4 >> 2] : ke & 127) | 0, ke = Je[me + 11 | 0], ke = (Ri + ((ke & 128) >>> 7 | 0 ? e[me + 4 >> 2] : ke & 127) | 0) + 1 | 0;
                              break o;
                            }
                            ke = Je[Ar + 11 | 0], Ri = (ke & 128) >>> 7 | 0 ? e[Ar + 4 >> 2] : ke & 127, ke = Je[me + 11 | 0], ke = (Ri + ((ke & 128) >>> 7 | 0 ? e[me + 4 >> 2] : ke & 127) | 0) + 2 | 0;
                          }
                          o: {
                            if (ke = ke + Xr | 0, ke >>> 0 >= 101) {
                              if (_f(Ur, vf(ke)), I = e[Ur >> 2], !I)
                                break o;
                              br = Je[S + 11 | 0], br = (br & 128) >>> 7 | 0 ? e[S + 4 >> 2] : br & 127;
                            }
                            if (ke = e[C + 4 >> 2], S = (Je[S + 11 | 0] & 128) >>> 7 | 0 ? e[S >> 2] : S, e[5996] = 0, Wc(237, I | 0, l + 4 | 0, l | 0, ke | 0, S | 0, S + br | 0, yn | 0, En | 0, l + 168 | 0, Se[l + 167 | 0], Se[l + 166 | 0], Qr | 0, me | 0, Ar | 0, Xr | 0), S = e[5996], e[5996] = 0, (S | 0) == 1 || (e[5996] = 0, C = Cf(213, y | 0, I | 0, e[l + 4 >> 2], e[l >> 2], C | 0, Q | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1))
                              break r;
                            return ka(Ur), Yo(Ar), Yo(me), Yo(Qr), y = e[l + 172 >> 2], I = e[y + 4 >> 2] - 1 | 0, e[y + 4 >> 2] = I, (I | 0) == -1 && Yn[e[e[y >> 2] + 8 >> 2]](y), bi = l + 176 | 0, C | 0;
                          }
                          if (e[5996] = 0, jo(185), y = e[5996], e[5996] = 0, (y | 0) == 1)
                            break r;
                          jn();
                        }
                        S = gi() | 0;
                        break e;
                      }
                      S = gi() | 0;
                      break e;
                    }
                    S = gi() | 0;
                    break t;
                  }
                  S = gi() | 0, ka(Ur);
                }
                Yo(Ar), Yo(me), Yo(Qr);
              }
              l = e[l + 172 >> 2], y = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = y, (y | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), ss(S | 0), jn();
            }
            function ml(l, y, I, C, Q, S, me, ke, Ar, br, Qr, Ur, Xr, Ri, yn) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0, me = me | 0, ke = ke | 0, Ar = Ar | 0, br = br | 0, Qr = Qr | 0, Ur = Ur | 0, Xr = Xr | 0, Ri = Ri | 0, yn = yn | 0;
              var En = 0, Wn = 0, lo = 0, Ro = 0, Xo = 0, bs = 0, Os = 0, Gs = 0, aa = 0;
              for (e[I >> 2] = l, Os = C & 512, Gs = ke << 2; ; ) {
                if ((bs | 0) == 4)
                  Q = Je[Ri + 11 | 0], ((Q & 128) >>> 7 | 0 ? e[Ri + 4 >> 2] : Q & 127) >>> 0 > 1 && (e[I >> 2] = rd(T1(lc(Ri), 1), hu(Ri), e[I >> 2])), C = C & 176, (C | 0) != 16 && ((C | 0) == 32 && (l = e[I >> 2]), e[y >> 2] = l);
                else {
                  e: {
                    t:
                      switch (Se[Ar + bs | 0]) {
                        case 0:
                          e[y >> 2] = e[I >> 2];
                          break e;
                        case 1:
                          e[y >> 2] = e[I >> 2], ke = Yn[e[e[me >> 2] + 44 >> 2]](me, 32) | 0, En = e[I >> 2], e[I >> 2] = En + 4, e[En >> 2] = ke;
                          break e;
                        case 3:
                          if (ke = Je[Ri + 11 | 0], lo = ke & 127, ke = (ke & 128) >>> 7 | 0, !(ke ? e[Ri + 4 >> 2] : lo))
                            break e;
                          ke = e[(ke ? e[Ri >> 2] : Ri) >> 2], En = e[I >> 2], e[I >> 2] = En + 4, e[En >> 2] = ke;
                          break e;
                        case 2:
                          if (!Os || (ke = Je[Xr + 11 | 0], !((ke & 128) >>> 7 | 0 ? e[Xr + 4 >> 2] : ke & 127)))
                            break e;
                          e[I >> 2] = rd(lc(Xr), hu(Xr), e[I >> 2]);
                          break e;
                        case 4:
                          break t;
                        default:
                          break e;
                      }
                    for (aa = e[I >> 2], Q = Q + Gs | 0, ke = Q; ; ) {
                      t: {
                        if (S >>> 0 <= ke >>> 0 || !(Yn[e[e[me >> 2] + 12 >> 2]](me, 64, e[ke >> 2]) | 0))
                          break t;
                        ke = ke + 4 | 0;
                        continue;
                      }
                      break;
                    }
                    if ((yn | 0) > 0) {
                      for (En = e[I >> 2], Wn = yn; ; ) {
                        if (!(!Wn | Q >>> 0 >= ke >>> 0)) {
                          Wn = Wn - 1 | 0, ke = ke - 4 | 0, Ro = e[ke >> 2], lo = En + 4 | 0, e[I >> 2] = lo, e[En >> 2] = Ro, En = lo;
                          continue;
                        }
                        break;
                      }
                      t: {
                        if (!Wn) {
                          Ro = 0;
                          break t;
                        }
                        Ro = Yn[e[e[me >> 2] + 44 >> 2]](me, 48) | 0, En = e[I >> 2];
                      }
                      for (; ; ) {
                        if (lo = En + 4 | 0, (Wn | 0) > 0) {
                          e[En >> 2] = Ro, Wn = Wn - 1 | 0, En = lo;
                          continue;
                        }
                        break;
                      }
                      e[I >> 2] = lo, e[En >> 2] = br;
                    }
                    t: {
                      if ((Q | 0) == (ke | 0)) {
                        En = Yn[e[e[me >> 2] + 44 >> 2]](me, 48) | 0, Wn = e[I >> 2], ke = Wn + 4 | 0, e[I >> 2] = ke, e[Wn >> 2] = En;
                        break t;
                      }
                      for (Ro = -1, En = Je[Ur + 11 | 0], lo = (En & 128) >>> 7 | 0, (lo ? e[Ur + 4 >> 2] : En & 127) && (Ro = Se[(lo ? e[Ur >> 2] : Ur) | 0]), Wn = 0, Xo = 0; ; ) {
                        if ((Q | 0) != (ke | 0)) {
                          lo = e[I >> 2];
                          r: {
                            if ((Wn | 0) != (Ro | 0)) {
                              En = lo, lo = Wn;
                              break r;
                            }
                            if (En = lo + 4 | 0, e[I >> 2] = En, e[lo >> 2] = Qr, lo = 0, Xo = Xo + 1 | 0, Ro = Je[Ur + 11 | 0], Xo >>> 0 >= ((Ro & 128) >>> 7 | 0 ? e[Ur + 4 >> 2] : Ro & 127) >>> 0) {
                              Ro = Wn;
                              break r;
                            }
                            if (Ro = -1, Wn = ((Je[Ur + 11 | 0] & 128) >>> 7 | 0 ? e[Ur >> 2] : Ur) + Xo | 0, Je[Wn | 0] == 127)
                              break r;
                            Ro = Se[Wn | 0];
                          }
                          ke = ke - 4 | 0, Wn = e[ke >> 2], e[I >> 2] = En + 4, e[En >> 2] = Wn, Wn = lo + 1 | 0;
                          continue;
                        }
                        break;
                      }
                      ke = e[I >> 2];
                    }
                    Xl(aa, ke);
                  }
                  bs = bs + 1 | 0;
                  continue;
                }
                break;
              }
            }
            function vl(l, y, I, C, Q, S, me, ke, Ar, br, Qr, Ur, Xr, Ri, yn) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0, me = me | 0, ke = ke | 0, Ar = Ar | 0, br = br | 0, Qr = Qr | 0, Ur = Ur | 0, Xr = Xr | 0, Ri = Ri | 0, yn = yn | 0;
              var En = 0, Wn = 0, lo = 0, Ro = 0, Xo = 0, bs = 0, Os = 0, Gs = 0, aa = 0;
              for (e[I >> 2] = l, Gs = C & 512; ; ) {
                if ((bs | 0) == 4)
                  Q = Je[Ri + 11 | 0], ((Q & 128) >>> 7 | 0 ? e[Ri + 4 >> 2] : Q & 127) >>> 0 > 1 && (e[I >> 2] = nd(D1(lc(Ri), 1), lu(Ri), e[I >> 2])), C = C & 176, (C | 0) != 16 && ((C | 0) == 32 && (l = e[I >> 2]), e[y >> 2] = l);
                else {
                  e: {
                    t:
                      switch (Se[Ar + bs | 0]) {
                        case 0:
                          e[y >> 2] = e[I >> 2];
                          break e;
                        case 1:
                          e[y >> 2] = e[I >> 2], En = Yn[e[e[me >> 2] + 28 >> 2]](me, 32) | 0, Wn = e[I >> 2], e[I >> 2] = Wn + 1, Se[Wn | 0] = En;
                          break e;
                        case 3:
                          if (En = Je[Ri + 11 | 0], Wn = (En & 128) >>> 7 | 0, !(Wn ? e[Ri + 4 >> 2] : En & 127))
                            break e;
                          En = Je[(Wn ? e[Ri >> 2] : Ri) | 0], Wn = e[I >> 2], e[I >> 2] = Wn + 1, Se[Wn | 0] = En;
                          break e;
                        case 2:
                          if (!Gs || (En = Je[Xr + 11 | 0], !((En & 128) >>> 7 | 0 ? e[Xr + 4 >> 2] : En & 127)))
                            break e;
                          e[I >> 2] = nd(lc(Xr), lu(Xr), e[I >> 2]);
                          break e;
                        case 4:
                          break t;
                        default:
                          break e;
                      }
                    for (Wn = e[me + 8 >> 2], aa = e[I >> 2], Q = Q + ke | 0, lo = Q; ; ) {
                      t: {
                        if (S >>> 0 <= lo >>> 0 || (En = Se[lo | 0], (En | 0) >= 0 ? En = (e[Wn + ((En & 255) << 2) >> 2] & 64) != 0 : En = 0, !En))
                          break t;
                        lo = lo + 1 | 0;
                        continue;
                      }
                      break;
                    }
                    if (En = yn, (En | 0) > 0) {
                      for (; ; ) {
                        if (!(!En | Q >>> 0 >= lo >>> 0)) {
                          En = En - 1 | 0, lo = lo - 1 | 0, Wn = Je[lo | 0], Ro = e[I >> 2], e[I >> 2] = Ro + 1, Se[Ro | 0] = Wn;
                          continue;
                        }
                        break;
                      }
                      for (En ? Wn = Yn[e[e[me >> 2] + 28 >> 2]](me, 48) | 0 : Wn = 0; ; ) {
                        if (Ro = e[I >> 2], e[I >> 2] = Ro + 1, (En | 0) > 0) {
                          Se[Ro | 0] = Wn, En = En - 1 | 0;
                          continue;
                        }
                        break;
                      }
                      Se[Ro | 0] = br;
                    }
                    t: {
                      if ((Q | 0) == (lo | 0)) {
                        En = Yn[e[e[me >> 2] + 28 >> 2]](me, 48) | 0, Wn = e[I >> 2], e[I >> 2] = Wn + 1, Se[Wn | 0] = En;
                        break t;
                      }
                      for (Wn = -1, En = Je[Ur + 11 | 0], Ro = En & 127, En = (En & 128) >>> 7 | 0, (En ? e[Ur + 4 >> 2] : Ro) && (Wn = Se[(En ? e[Ur >> 2] : Ur) | 0]), En = 0, Xo = 0; ; ) {
                        if ((Q | 0) == (lo | 0))
                          break t;
                        r: {
                          if ((En | 0) != (Wn | 0)) {
                            Ro = En;
                            break r;
                          }
                          if (Wn = e[I >> 2], e[I >> 2] = Wn + 1, Se[Wn | 0] = Qr, Ro = 0, Xo = Xo + 1 | 0, Wn = Je[Ur + 11 | 0], Xo >>> 0 >= ((Wn & 128) >>> 7 | 0 ? e[Ur + 4 >> 2] : Wn & 127) >>> 0) {
                            Wn = En;
                            break r;
                          }
                          if (Wn = -1, En = ((Je[Ur + 11 | 0] & 128) >>> 7 | 0 ? e[Ur >> 2] : Ur) + Xo | 0, Je[En | 0] == 127)
                            break r;
                          Wn = Se[En | 0];
                        }
                        lo = lo - 1 | 0, En = Je[lo | 0], Os = e[I >> 2], e[I >> 2] = Os + 1, Se[Os | 0] = En, En = Ro + 1 | 0;
                      }
                    }
                    Uu(aa, e[I >> 2]);
                  }
                  bs = bs + 1 | 0;
                  continue;
                }
                break;
              }
            }
            function wl(l, y, I, C, Q, S, me, ke) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0, me = me | 0, ke = ke | 0;
              var Ar = 0, br = 0, Qr = 0, Ur = 0, Xr = 0, Ri = 0, yn = 0, En = 0, Wn = 0, lo = 0, Ro = 0, Xo = 0, bs = 0, Os = 0;
              for (lo = bi - 16 | 0, bi = lo, br = I; ; ) {
                e: {
                  if ((C | 0) == (br | 0)) {
                    br = C;
                    break e;
                  }
                  if (!Je[br | 0])
                    break e;
                  br = br + 1 | 0;
                  continue;
                }
                break;
              }
              for (e[ke >> 2] = S, e[Q >> 2] = I; ; ) {
                e: {
                  t: {
                    r: {
                      if ((I | 0) == (C | 0) | (S | 0) == (me | 0))
                        break r;
                      Ar = e[y + 4 >> 2], e[lo + 8 >> 2] = e[y >> 2], e[lo + 12 >> 2] = Ar, Ro = bi - 16 | 0, bi = Ro, Os = Nc(Ro + 12 | 0, e[l + 8 >> 2]), Xr = br - I | 0, Qr = 0, Ri = 0, yn = bi - 1040 | 0, bi = yn, Wn = e[Q >> 2], e[yn + 12 >> 2] = Wn, En = S || yn + 16 | 0, Ur = S ? me - S >> 2 : 256;
                      i: {
                        n: {
                          o: {
                            if (!(!Wn | !Ur)) {
                              for (; ; ) {
                                if (Ar = Xr >>> 2 | 0, !(Xr >>> 0 > 131 | Ar >>> 0 >= Ur >>> 0)) {
                                  Ar = Wn;
                                  break n;
                                }
                                if (Xo = Ph(En, yn + 12 | 0, Ar >>> 0 < Ur >>> 0 ? Ar : Ur, y), Ar = e[yn + 12 >> 2], (Xo | 0) == -1) {
                                  Ur = 0, Qr = -1;
                                  break o;
                                }
                                if (bs = (yn + 16 | 0) != (En | 0) ? Xo : 0, Ur = Ur - bs | 0, En = (bs << 2) + En | 0, Xr = Ar ? (Xr + Wn | 0) - Ar | 0 : 0, Qr = Qr + Xo | 0, !Ar)
                                  break o;
                                if (Wn = Ar, !Ur)
                                  break;
                              }
                              break o;
                            }
                            Ar = Wn;
                          }
                          if (!Ar)
                            break i;
                        }
                        if (!(!Ur | !Xr)) {
                          for (Ri = Ar, Ar = Qr; ; ) {
                            n: {
                              Qr = fo(En, Ri, Xr, y);
                              o: {
                                if (Qr + 2 >>> 0 <= 2) {
                                  a:
                                    switch (Qr + 1 | 0) {
                                      case 1:
                                        Ri = 0;
                                        break o;
                                      case 0:
                                        break i;
                                      default:
                                        break a;
                                    }
                                  e[y >> 2] = 0;
                                  break o;
                                }
                                if (Ri = Qr + Ri | 0, e[yn + 12 >> 2] = Ri, Ar = Ar + 1 | 0, Ur = Ur - 1 | 0, Ur)
                                  break n;
                              }
                              Qr = Ar;
                              break i;
                            }
                            if (En = En + 4 | 0, Xr = Xr - Qr | 0, Qr = Ar, !Xr)
                              break;
                          }
                          break i;
                        }
                        Ri = Ar;
                      }
                      S && (e[Q >> 2] = Ri), bi = yn + 1040 | 0, Ar = e[Os >> 2], Ar && (e[6178] = (Ar | 0) == -1 ? 24816 : Ar), bi = Ro + 16 | 0;
                      i: {
                        n: {
                          o: {
                            a: {
                              if ((Qr | 0) == -1) {
                                for (; ; ) {
                                  s: {
                                    if (e[ke >> 2] = S, e[Q >> 2] == (I | 0))
                                      break s;
                                    me = 1;
                                    A: {
                                      u: {
                                        h:
                                          switch (y = Rd(S, I, br - I | 0, lo + 8 | 0, e[l + 8 >> 2]), y + 2 | 0) {
                                            case 0:
                                              break n;
                                            case 2:
                                              break A;
                                            case 1:
                                              break h;
                                            default:
                                              break u;
                                          }
                                        e[Q >> 2] = I;
                                        break a;
                                      }
                                      me = y;
                                    }
                                    I = I + me | 0, S = e[ke >> 2] + 4 | 0;
                                    continue;
                                  }
                                  break;
                                }
                                e[Q >> 2] = I;
                                break r;
                              }
                              if (S = e[ke >> 2] + (Qr << 2) | 0, e[ke >> 2] = S, (S | 0) == (me | 0))
                                break i;
                              if (I = e[Q >> 2], (C | 0) == (br | 0)) {
                                br = C;
                                continue;
                              }
                              if (!Rd(S, I, 1, y, e[l + 8 >> 2]))
                                break o;
                            }
                            l = 2;
                            break t;
                          }
                          for (e[ke >> 2] = e[ke >> 2] + 4, I = e[Q >> 2] + 1 | 0, e[Q >> 2] = I, br = I; ; ) {
                            if ((C | 0) == (br | 0)) {
                              br = C;
                              break e;
                            }
                            if (!Je[br | 0])
                              break e;
                            br = br + 1 | 0;
                          }
                        }
                        e[Q >> 2] = I, l = 1;
                        break t;
                      }
                      I = e[Q >> 2];
                    }
                    l = (I | 0) != (C | 0);
                  }
                  return bi = lo + 16 | 0, l | 0;
                }
                S = e[ke >> 2];
              }
            }
            function Cc(l, y, I, C, Q, S, me) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0, me = me | 0;
              var ke = 0, Ar = 0, br = 0, Qr = 0, Ur = 0, Xr = 0, Ri = 0, yn = 0, En = 0, Wn = 0, lo = 0, Ro = 0;
              br = bi - 128 | 0, bi = br, e[br + 124 >> 2] = y, e[br + 4 >> 2] = 184, y = br + 8 | 0, e[y >> 2] = 0, e[y + 4 >> 2] = e[br + 4 >> 2], yn = y, Qr = br + 16 | 0, Ur = (C - I | 0) / 12 | 0;
              e: {
                t: {
                  if (Ur >>> 0 >= 101) {
                    if (Qr = vf(Ur), !Qr) {
                      if (e[5996] = 0, jo(185), l = e[5996], e[5996] = 0, (l | 0) != 1)
                        break e;
                      break t;
                    }
                    _f(yn, Qr);
                  }
                  ke = Qr, y = I;
                  r: {
                    i: {
                      for (; ; ) {
                        if ((y | 0) == (C | 0))
                          n: for (; ; ) {
                            o: {
                              if (e[5996] = 0, ke = wn(186, l | 0, br + 124 | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                break o;
                              if ((!Ur | ke) == 1) {
                                if (e[5996] = 0, y = wn(186, l | 0, br + 124 | 0) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1)
                                  break r;
                                if (!y)
                                  break i;
                                e[S >> 2] = e[S >> 2] | 2;
                                break i;
                              }
                              y = e[l >> 2], e[5996] = 0, En = no(187, y | 0) | 0, y = e[5996], e[5996] = 0;
                              a: {
                                if ((y | 0) != 1 && (me || (e[5996] = 0, En = wn(188, Q | 0, En | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) != 1)))
                                  break a;
                                break t;
                              }
                              for (Ar = Wn + 1 | 0, Ro = 0, ke = Qr, y = I; ; ) {
                                if ((y | 0) == (C | 0)) {
                                  if (Wn = Ar, !Ro)
                                    continue n;
                                  if (e[5996] = 0, no(189, l | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) != 1) {
                                    if (ke = Qr, y = I, Ur + Xr >>> 0 < 2)
                                      continue n;
                                    for (; ; ) {
                                      if ((y | 0) == (C | 0))
                                        continue n;
                                      a: {
                                        if (Je[ke | 0] != 2 || (Ar = Je[y + 11 | 0], (((Ar & 128) >>> 7 | 0 ? e[y + 4 >> 2] : Ar & 127) | 0) == (Wn | 0)))
                                          break a;
                                        Se[ke | 0] = 0, Xr = Xr - 1 | 0;
                                      }
                                      ke = ke + 1 | 0, y = y + 12 | 0;
                                    }
                                  }
                                  break t;
                                }
                                a: {
                                  if (Je[ke | 0] != 1)
                                    break a;
                                  lo = Je[((Je[y + 11 | 0] & 128) >>> 7 | 0 ? e[y >> 2] : y) + Wn | 0];
                                  s: {
                                    if (me || (e[5996] = 0, lo = wn(188, Q | 0, lo << 24 >> 24) | 0, Ri = e[5996], e[5996] = 0, (Ri | 0) != 1))
                                      break s;
                                    break t;
                                  }
                                  s: {
                                    if ((En & 255) == (lo & 255)) {
                                      if (Ro = 1, Ri = Je[y + 11 | 0], (Ar | 0) != (((Ri & 128) >>> 7 | 0 ? e[y + 4 >> 2] : Ri & 127) | 0))
                                        break a;
                                      Se[ke | 0] = 2, Xr = Xr + 1 | 0;
                                      break s;
                                    }
                                    Se[ke | 0] = 0;
                                  }
                                  Ur = Ur - 1 | 0;
                                }
                                ke = ke + 1 | 0, y = y + 12 | 0;
                              }
                            }
                            break;
                          }
                        else {
                          Ar = Je[y + 11 | 0], Ar = !((Ar & 128) >>> 7 | 0 ? e[y + 4 >> 2] : Ar & 127), Se[ke | 0] = Ar ? 2 : 1, Xr = Ar + Xr | 0, Ur = Ur - Ar | 0, ke = ke + 1 | 0, y = y + 12 | 0;
                          continue;
                        }
                        break;
                      }
                      break t;
                    }
                    i: {
                      n: {
                        for (; ; ) {
                          if ((I | 0) == (C | 0))
                            break n;
                          if (Je[Qr | 0] != 2) {
                            Qr = Qr + 1 | 0, I = I + 12 | 0;
                            continue;
                          }
                          break;
                        }
                        C = I;
                        break i;
                      }
                      e[S >> 2] = e[S >> 2] | 4;
                    }
                    return ka(yn), bi = br + 128 | 0, C | 0;
                  }
                }
                l = gi() | 0, ka(yn), ss(l | 0);
              }
              jn();
            }
            function _u(l, y, I, C, Q, S, me) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0, me = me | 0;
              var ke = 0, Ar = 0, br = 0, Qr = 0, Ur = 0, Xr = 0, Ri = 0, yn = 0, En = 0, Wn = 0, lo = 0, Ro = 0;
              br = bi - 128 | 0, bi = br, e[br + 124 >> 2] = y, e[br + 4 >> 2] = 184, y = br + 8 | 0, e[y >> 2] = 0, e[y + 4 >> 2] = e[br + 4 >> 2], yn = y, Qr = br + 16 | 0, Ur = (C - I | 0) / 12 | 0;
              e: {
                t: {
                  if (Ur >>> 0 >= 101) {
                    if (Qr = vf(Ur), !Qr) {
                      if (e[5996] = 0, jo(185), l = e[5996], e[5996] = 0, (l | 0) != 1)
                        break e;
                      break t;
                    }
                    _f(yn, Qr);
                  }
                  ke = Qr, y = I;
                  r: {
                    i: {
                      for (; ; ) {
                        if ((y | 0) == (C | 0))
                          n: for (; ; ) {
                            o: {
                              if (e[5996] = 0, ke = wn(202, l | 0, br + 124 | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                break o;
                              if ((!Ur | ke) == 1) {
                                if (e[5996] = 0, y = wn(202, l | 0, br + 124 | 0) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1)
                                  break r;
                                if (!y)
                                  break i;
                                e[S >> 2] = e[S >> 2] | 2;
                                break i;
                              }
                              y = e[l >> 2], e[5996] = 0, En = no(203, y | 0) | 0, y = e[5996], e[5996] = 0;
                              a: {
                                if ((y | 0) != 1 && (me || (e[5996] = 0, En = wn(204, Q | 0, En | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) != 1)))
                                  break a;
                                break t;
                              }
                              for (Ar = Wn + 1 | 0, Ro = 0, ke = Qr, y = I; ; ) {
                                if ((y | 0) == (C | 0)) {
                                  if (Wn = Ar, !Ro)
                                    continue n;
                                  if (e[5996] = 0, no(205, l | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) != 1) {
                                    if (ke = Qr, y = I, Ur + Xr >>> 0 < 2)
                                      continue n;
                                    for (; ; ) {
                                      if ((y | 0) == (C | 0))
                                        continue n;
                                      a: {
                                        if (Je[ke | 0] != 2 || (Ar = Je[y + 11 | 0], (((Ar & 128) >>> 7 | 0 ? e[y + 4 >> 2] : Ar & 127) | 0) == (Wn | 0)))
                                          break a;
                                        Se[ke | 0] = 0, Xr = Xr - 1 | 0;
                                      }
                                      ke = ke + 1 | 0, y = y + 12 | 0;
                                    }
                                  }
                                  break t;
                                }
                                a: {
                                  if (Je[ke | 0] != 1)
                                    break a;
                                  lo = e[(Wn << 2) + ((Je[y + 11 | 0] & 128) >>> 7 | 0 ? e[y >> 2] : y) >> 2];
                                  s: {
                                    if (me || (e[5996] = 0, lo = wn(204, Q | 0, lo | 0) | 0, Ri = e[5996], e[5996] = 0, (Ri | 0) != 1))
                                      break s;
                                    break t;
                                  }
                                  s: {
                                    if ((En | 0) == (lo | 0)) {
                                      if (Ro = 1, Ri = Je[y + 11 | 0], (Ar | 0) != (((Ri & 128) >>> 7 | 0 ? e[y + 4 >> 2] : Ri & 127) | 0))
                                        break a;
                                      Se[ke | 0] = 2, Xr = Xr + 1 | 0;
                                      break s;
                                    }
                                    Se[ke | 0] = 0;
                                  }
                                  Ur = Ur - 1 | 0;
                                }
                                ke = ke + 1 | 0, y = y + 12 | 0;
                              }
                            }
                            break;
                          }
                        else {
                          Ar = Je[y + 11 | 0], Ar = !((Ar & 128) >>> 7 | 0 ? e[y + 4 >> 2] : Ar & 127), Se[ke | 0] = Ar ? 2 : 1, Xr = Ar + Xr | 0, Ur = Ur - Ar | 0, ke = ke + 1 | 0, y = y + 12 | 0;
                          continue;
                        }
                        break;
                      }
                      break t;
                    }
                    i: {
                      n: {
                        for (; ; ) {
                          if ((I | 0) == (C | 0))
                            break n;
                          if (Je[Qr | 0] != 2) {
                            Qr = Qr + 1 | 0, I = I + 12 | 0;
                            continue;
                          }
                          break;
                        }
                        C = I;
                        break i;
                      }
                      e[S >> 2] = e[S >> 2] | 4;
                    }
                    return ka(yn), bi = br + 128 | 0, C | 0;
                  }
                }
                l = gi() | 0, ka(yn), ss(l | 0);
              }
              jn();
            }
            function Vu(l, y, I, C, Q, S, me) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0, me = me | 0;
              var ke = 0, Ar = 0, br = 0, Qr = 0;
              ke = bi - 624 | 0, bi = ke, e[ke + 616 >> 2] = I, e[ke + 620 >> 2] = y, e[ke + 16 >> 2] = 220, Ar = ke + 200 | 0, e[Ar >> 2] = ke + 208, l = ke + 16 | 0, e[Ar + 4 >> 2] = e[l >> 2], br = ke + 192 | 0, y = e[Q + 28 >> 2], e[br >> 2] = y, e[y + 4 >> 2] = e[y + 4 >> 2] + 1, e[5996] = 0, Qr = no(197, e[ke + 192 >> 2]) | 0, y = e[5996], e[5996] = 0;
              e: {
                t: {
                  r: {
                    i: {
                      n: {
                        o: {
                          a: {
                            if ((y | 0) != 1) {
                              if (Se[ke + 191 | 0] = 0, y = e[Q + 4 >> 2], e[5996] = 0, y = Uc(228, ke + 620 | 0, I | 0, C | 0, br | 0, y | 0, S | 0, ke + 191 | 0, Qr | 0, Ar | 0, ke + 196 | 0, ke + 608 | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                break i;
                              if (!y)
                                break n;
                              if (y = Je[3833] | Je[3834] << 8 | (Je[3835] << 16 | Je[3836] << 24), Se[ke + 183 | 0] = y, Se[ke + 184 | 0] = y >>> 8, Se[ke + 185 | 0] = y >>> 16, Se[ke + 186 | 0] = y >>> 24, y = Je[3830] | Je[3831] << 8 | (Je[3832] << 16 | Je[3833] << 24), e[ke + 176 >> 2] = Je[3826] | Je[3827] << 8 | (Je[3828] << 16 | Je[3829] << 24), e[ke + 180 >> 2] = y, e[5996] = 0, ia(208, Qr | 0, ke + 176 | 0, ke + 186 | 0, ke + 128 | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                break a;
                              if (e[ke + 4 >> 2] = 184, C = ke + 8 | 0, e[C >> 2] = 0, e[C + 4 >> 2] = e[ke + 4 >> 2], Q = l, y = e[ke + 196 >> 2], l = y - e[Ar >> 2] | 0, (l | 0) < 393 || (_f(C, vf((l >> 2) + 2 | 0)), Q = e[C >> 2], Q))
                                break o;
                              if (e[5996] = 0, jo(185), l = e[5996], e[5996] = 0, (l | 0) == 1)
                                break r;
                              break e;
                            }
                            I = gi() | 0;
                            break t;
                          }
                          I = gi() | 0;
                          break t;
                        }
                        for (Je[ke + 191 | 0] && (Se[Q | 0] = 45, Q = Q + 1 | 0), I = e[Ar >> 2]; ; ) {
                          if (y >>> 0 <= I >>> 0) {
                            if (Se[Q | 0] = 0, e[ke >> 2] = me, (Jd(ke + 16 | 0, ke) | 0) != 1) {
                              if (e[5996] = 0, La(222, 1730), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                break e;
                              break r;
                            }
                            ka(C);
                          } else {
                            l = ke + 128 | 0, Se[Q | 0] = Je[(ke + 176 | 0) + (B1(l, l + 40 | 0, e[I >> 2]) - l >> 2) | 0], Q = Q + 1 | 0, I = I + 4 | 0, y = e[ke + 196 >> 2];
                            continue;
                          }
                          break;
                        }
                      }
                      if (e[5996] = 0, l = wn(202, ke + 620 | 0, ke + 616 | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                        break i;
                      return l && (e[S >> 2] = e[S >> 2] | 2), I = e[ke + 620 >> 2], l = e[ke + 192 >> 2], y = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = y, (y | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), ka(Ar), bi = ke + 624 | 0, I | 0;
                    }
                    I = gi() | 0;
                    break t;
                  }
                  I = gi() | 0, ka(C);
                }
                l = e[ke + 192 >> 2], y = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = y, (y | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), ka(Ar), ss(I | 0), jn();
              }
              jn();
            }
            function Wu(l, y) {
              l = l | 0, y = y | 0;
              var I = 0, C = 0, Q = 0, S = 0, me = 0, ke = 0, Ar = 0, br = 0;
              if (Q = e[l + 4 >> 2], I = e[l >> 2], C = Q - I >> 2, C >>> 0 < y >>> 0) {
                ke = bi - 32 | 0, bi = ke, S = y - C | 0;
                e: {
                  if (S >>> 0 <= e[l + 8 >> 2] - Q >> 2 >>> 0) {
                    cd(l, S);
                    break e;
                  }
                  me = l + 16 | 0, C = ke + 12 | 0, I = bi - 16 | 0, bi = I, Q = S + (Q - e[l >> 2] >> 2) | 0, e[I + 12 >> 2] = Q;
                  t: {
                    if (y = _d(), Q >>> 0 <= y >>> 0) {
                      Q = e[l + 8 >> 2] - e[l >> 2] >> 2, Q >>> 0 < y >>> 1 >>> 0 && (e[I + 8 >> 2] = Q << 1, y = e[(qs[I + 8 >> 2] < qs[I + 12 >> 2] ? I + 12 | 0 : I + 8 | 0) >> 2]), bi = I + 16 | 0;
                      break t;
                    }
                    tf(), jn();
                  }
                  Ar = e[l + 4 >> 2] - e[l >> 2] >> 2, Q = bi - 16 | 0, bi = Q, e[C + 12 >> 2] = 0, e[C + 16 >> 2] = me;
                  t: {
                    if (!y) {
                      I = 0, y = 0;
                      break t;
                    }
                    $d(Q + 8 | 0, e[C + 16 >> 2], y), I = e[Q + 8 >> 2], y = e[Q + 12 >> 2];
                  }
                  for (e[C >> 2] = I, me = I + (Ar << 2) | 0, e[C + 8 >> 2] = me, e[C + 4 >> 2] = me, e[C + 12 >> 2] = I + (y << 2), bi = Q + 16 | 0, I = bi - 16 | 0, bi = I, e[I + 4 >> 2] = e[C + 8 >> 2], y = e[C + 8 >> 2], e[I + 12 >> 2] = C + 8, e[I + 8 >> 2] = y + (S << 2), y = e[I + 4 >> 2]; ; ) {
                    if (e[I + 8 >> 2] != (y | 0)) {
                      e[y >> 2] = 0, y = e[I + 4 >> 2] + 4 | 0, e[I + 4 >> 2] = y;
                      continue;
                    }
                    break;
                  }
                  for (e[e[I + 12 >> 2] >> 2] = e[I + 4 >> 2], bi = I + 16 | 0, Q = bi - 16 | 0, bi = Q, e[Q + 12 >> 2] = e[l + 4 >> 2], e[Q + 8 >> 2] = e[l >> 2], e[Q + 4 >> 2] = e[C + 4 >> 2], S = e[Q + 12 >> 2], Ar = e[Q + 4 >> 2], me = bi - 16 | 0, bi = me, y = bi - 32 | 0, bi = y, I = bi - 16 | 0, bi = I, e[I + 12 >> 2] = e[Q + 8 >> 2], e[y + 24 >> 2] = S, e[y + 28 >> 2] = e[I + 12 >> 2], bi = I + 16 | 0, S = e[y + 24 >> 2], br = e[y + 28 >> 2], I = bi - 16 | 0, bi = I, e[I + 8 >> 2] = Ar, e[I + 12 >> 2] = S; ; ) {
                    if ((S | 0) != (br | 0)) {
                      e[e[I + 8 >> 2] - 4 >> 2] = e[S - 4 >> 2], e[I + 12 >> 2] = e[I + 12 >> 2] - 4, e[I + 8 >> 2] = e[I + 8 >> 2] - 4, S = e[I + 12 >> 2];
                      continue;
                    }
                    break;
                  }
                  for (e[y + 16 >> 2] = S, e[y + 20 >> 2] = e[I + 8 >> 2], bi = I + 16 | 0, I = e[y + 16 >> 2], e[y + 12 >> 2] = e[y + 20 >> 2], e[me + 8 >> 2] = I, e[me + 12 >> 2] = e[y + 12 >> 2], bi = y + 32 | 0, bi = me + 16 | 0, e[C + 4 >> 2] = e[me + 12 >> 2], y = e[l >> 2], e[l >> 2] = e[C + 4 >> 2], e[C + 4 >> 2] = y, y = e[l + 4 >> 2], e[l + 4 >> 2] = e[C + 8 >> 2], e[C + 8 >> 2] = y, y = e[l + 8 >> 2], e[l + 8 >> 2] = e[C + 12 >> 2], e[C + 12 >> 2] = y, e[C >> 2] = e[C + 4 >> 2], bi = Q + 16 | 0, y = e[C + 4 >> 2], l = e[C + 8 >> 2]; ; ) {
                    if ((l | 0) != (y | 0)) {
                      l = l - 4 | 0, e[C + 8 >> 2] = l;
                      continue;
                    }
                    break;
                  }
                  l = e[C >> 2], l && fp(e[C + 16 >> 2], l);
                }
                bi = ke + 32 | 0;
                return;
              }
              y >>> 0 < C >>> 0 && Yd(l, I + (y << 2) | 0);
            }
            function Il(l, y, I, C, Q, S, me) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0, me = me | 0;
              var ke = 0, Ar = 0, br = 0, Qr = 0;
              ke = bi - 272 | 0, bi = ke, e[ke + 264 >> 2] = I, e[ke + 268 >> 2] = y, e[ke + 16 >> 2] = 220, Ar = ke + 152 | 0, e[Ar >> 2] = ke + 160, l = ke + 16 | 0, e[Ar + 4 >> 2] = e[l >> 2], br = ke + 144 | 0, y = e[Q + 28 >> 2], e[br >> 2] = y, e[y + 4 >> 2] = e[y + 4 >> 2] + 1, e[5996] = 0, Qr = no(170, e[ke + 144 >> 2]) | 0, y = e[5996], e[5996] = 0;
              e: {
                t: {
                  r: {
                    i: {
                      n: {
                        o: {
                          a: {
                            if ((y | 0) != 1) {
                              if (Se[ke + 143 | 0] = 0, y = e[Q + 4 >> 2], e[5996] = 0, y = Uc(221, ke + 268 | 0, I | 0, C | 0, br | 0, y | 0, S | 0, ke + 143 | 0, Qr | 0, Ar | 0, ke + 148 | 0, ke + 260 | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                                break i;
                              if (!y)
                                break n;
                              if (y = Je[3833] | Je[3834] << 8 | (Je[3835] << 16 | Je[3836] << 24), Se[ke + 135 | 0] = y, Se[ke + 136 | 0] = y >>> 8, Se[ke + 137 | 0] = y >>> 16, Se[ke + 138 | 0] = y >>> 24, y = Je[3830] | Je[3831] << 8 | (Je[3832] << 16 | Je[3833] << 24), e[ke + 128 >> 2] = Je[3826] | Je[3827] << 8 | (Je[3828] << 16 | Je[3829] << 24), e[ke + 132 >> 2] = y, e[5996] = 0, ia(195, Qr | 0, ke + 128 | 0, ke + 138 | 0, ke + 118 | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                break a;
                              if (e[ke + 4 >> 2] = 184, C = ke + 8 | 0, e[C >> 2] = 0, e[C + 4 >> 2] = e[ke + 4 >> 2], Q = l, y = e[ke + 148 >> 2], l = y - e[Ar >> 2] | 0, (l | 0) < 99 || (_f(C, vf(l + 2 | 0)), Q = e[C >> 2], Q))
                                break o;
                              if (e[5996] = 0, jo(185), l = e[5996], e[5996] = 0, (l | 0) == 1)
                                break r;
                              break e;
                            }
                            I = gi() | 0;
                            break t;
                          }
                          I = gi() | 0;
                          break t;
                        }
                        for (Je[ke + 143 | 0] && (Se[Q | 0] = 45, Q = Q + 1 | 0), I = e[Ar >> 2]; ; ) {
                          if (y >>> 0 <= I >>> 0) {
                            if (Se[Q | 0] = 0, e[ke >> 2] = me, (Jd(ke + 16 | 0, ke) | 0) != 1) {
                              if (e[5996] = 0, La(222, 1730), l = e[5996], e[5996] = 0, (l | 0) != 1)
                                break e;
                              break r;
                            }
                            ka(C);
                          } else {
                            l = ke + 118 | 0, Se[Q | 0] = Je[((E1(l, l + 10 | 0, Je[I | 0]) - ke | 0) + ke | 0) + 10 | 0], Q = Q + 1 | 0, I = I + 1 | 0, y = e[ke + 148 >> 2];
                            continue;
                          }
                          break;
                        }
                      }
                      if (e[5996] = 0, l = wn(186, ke + 268 | 0, ke + 264 | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                        break i;
                      return l && (e[S >> 2] = e[S >> 2] | 2), I = e[ke + 268 >> 2], l = e[ke + 144 >> 2], y = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = y, (y | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), ka(Ar), bi = ke + 272 | 0, I | 0;
                    }
                    I = gi() | 0;
                    break t;
                  }
                  I = gi() | 0, ka(C);
                }
                l = e[ke + 144 >> 2], y = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = y, (y | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), ka(Ar), ss(I | 0), jn();
              }
              jn();
            }
            function Ju(l, y, I, C, Q, S) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0;
              var me = 0, ke = 0, Ar = 0;
              C = e[C + 28 >> 2], l = bi - 272 | 0, bi = l, e[l + 264 >> 2] = I, e[l + 268 >> 2] = y, Pr(l + 208 | 0, C, l + 224 | 0, l + 223 | 0, l + 222 | 0), C = l + 196 | 0, e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[C + 8 >> 2] = 0, y = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? (e[C + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, Co(172, C | 0, y | 0), y = e[5996], e[5996] = 0;
              e: {
                t: {
                  r: {
                    if ((y | 0) != 1) {
                      for (I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? e[C >> 2] : C, e[l + 192 >> 2] = I, e[l + 28 >> 2] = l + 32, e[l + 24 >> 2] = 0, Se[l + 23 | 0] = 1, Se[l + 22 | 0] = 69, me = Je[l + 222 | 0] << 24 >> 24, Ar = Je[l + 223 | 0] << 24 >> 24; ; ) {
                        i: {
                          if (e[5996] = 0, y = wn(186, l + 268 | 0, l + 264 | 0) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                            break i;
                          if (y)
                            break r;
                          if (y = Je[C + 11 | 0], y = (y & 128) >>> 7 | 0 ? e[C + 4 >> 2] : y & 127, e[l + 192 >> 2] == (y + I | 0)) {
                            if (e[5996] = 0, Co(172, C | 0, y << 1), I = e[5996], e[5996] = 0, (I | 0) == 1 || (I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? (e[C + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, Co(172, C | 0, I | 0), I = e[5996], e[5996] = 0, (I | 0) == 1))
                              break t;
                            I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? e[C >> 2] : C, e[l + 192 >> 2] = y + I;
                          }
                          if (e[5996] = 0, y = no(187, e[l + 268 >> 2]) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                            break i;
                          if (PA(y, l + 23 | 0, l + 22 | 0, I, l + 192 | 0, Ar, me, l + 208 | 0, l + 32 | 0, l + 28 | 0, l + 24 | 0, l + 224 | 0))
                            break r;
                          if (e[5996] = 0, no(189, l + 268 | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) != 1)
                            continue;
                        }
                        break;
                      }
                      break t;
                    }
                    break t;
                  }
                  y = Je[l + 219 | 0];
                  r: {
                    if (!((y & 128) >>> 7 | 0 ? e[l + 212 >> 2] : y & 127) | !Je[l + 23 | 0] || (y = e[l + 28 >> 2], (y - (l + 32 | 0) | 0) > 159))
                      break r;
                    e[l + 28 >> 2] = y + 4, e[y >> 2] = e[l + 24 >> 2];
                  }
                  if (Yf(l, I, e[l + 192 >> 2], Q), y = e[l >> 2], I = e[l + 4 >> 2], me = e[l + 12 >> 2], e[S + 8 >> 2] = e[l + 8 >> 2], e[S + 12 >> 2] = me, e[S >> 2] = y, e[S + 4 >> 2] = I, bf(l + 208 | 0, l + 32 | 0, e[l + 28 >> 2], Q), e[5996] = 0, y = wn(186, l + 268 | 0, l + 264 | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) != 1) {
                    y && (e[Q >> 2] = e[Q >> 2] | 2), y = e[l + 268 >> 2], Yo(C), Yo(l + 208 | 0), bi = l + 272 | 0;
                    break e;
                  }
                }
                y = gi() | 0, Yo(C), Yo(l + 208 | 0), ss(y | 0), jn();
              }
              return y | 0;
            }
            function ao(l, y, I, C, Q, S) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0;
              var me = 0, ke = 0, Ar = 0;
              C = e[C + 28 >> 2], l = bi - 384 | 0, bi = l, e[l + 376 >> 2] = I, e[l + 380 >> 2] = y, gr(l + 220 | 0, C, l + 240 | 0, l + 236 | 0, l + 232 | 0), C = l + 208 | 0, e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[C + 8 >> 2] = 0, y = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? (e[C + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, Co(172, C | 0, y | 0), y = e[5996], e[5996] = 0;
              e: {
                t: {
                  r: {
                    if ((y | 0) != 1) {
                      for (I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? e[C >> 2] : C, e[l + 204 >> 2] = I, e[l + 28 >> 2] = l + 32, e[l + 24 >> 2] = 0, Se[l + 23 | 0] = 1, Se[l + 22 | 0] = 69, me = e[l + 232 >> 2], Ar = e[l + 236 >> 2]; ; ) {
                        i: {
                          if (e[5996] = 0, y = wn(202, l + 380 | 0, l + 376 | 0) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                            break i;
                          if (y)
                            break r;
                          if (y = Je[C + 11 | 0], y = (y & 128) >>> 7 | 0 ? e[C + 4 >> 2] : y & 127, e[l + 204 >> 2] == (y + I | 0)) {
                            if (e[5996] = 0, Co(172, C | 0, y << 1), I = e[5996], e[5996] = 0, (I | 0) == 1 || (I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? (e[C + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, Co(172, C | 0, I | 0), I = e[5996], e[5996] = 0, (I | 0) == 1))
                              break t;
                            I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? e[C >> 2] : C, e[l + 204 >> 2] = y + I;
                          }
                          if (e[5996] = 0, y = no(203, e[l + 380 >> 2]) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                            break i;
                          if (eh(y, l + 23 | 0, l + 22 | 0, I, l + 204 | 0, Ar, me, l + 220 | 0, l + 32 | 0, l + 28 | 0, l + 24 | 0, l + 240 | 0))
                            break r;
                          if (e[5996] = 0, no(205, l + 380 | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) != 1)
                            continue;
                        }
                        break;
                      }
                      break t;
                    }
                    break t;
                  }
                  y = Je[l + 231 | 0];
                  r: {
                    if (!((y & 128) >>> 7 | 0 ? e[l + 224 >> 2] : y & 127) | !Je[l + 23 | 0] || (y = e[l + 28 >> 2], (y - (l + 32 | 0) | 0) > 159))
                      break r;
                    e[l + 28 >> 2] = y + 4, e[y >> 2] = e[l + 24 >> 2];
                  }
                  if (Yf(l, I, e[l + 204 >> 2], Q), y = e[l >> 2], I = e[l + 4 >> 2], me = e[l + 12 >> 2], e[S + 8 >> 2] = e[l + 8 >> 2], e[S + 12 >> 2] = me, e[S >> 2] = y, e[S + 4 >> 2] = I, bf(l + 220 | 0, l + 32 | 0, e[l + 28 >> 2], Q), e[5996] = 0, y = wn(202, l + 380 | 0, l + 376 | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) != 1) {
                    y && (e[Q >> 2] = e[Q >> 2] | 2), y = e[l + 380 >> 2], Yo(C), Yo(l + 220 | 0), bi = l + 384 | 0;
                    break e;
                  }
                }
                y = gi() | 0, Yo(C), Yo(l + 220 | 0), ss(y | 0), jn();
              }
              return y | 0;
            }
            function zu(l, y, I, C, Q, S, me, ke) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0, me = me | 0, ke = ke | 0;
              var Ar = 0, br = 0, Qr = 0, Ur = 0, Xr = 0, Ri = 0;
              Ri = y, Ar = bi - 256 | 0, bi = Ar, e[Ar + 248 >> 2] = 37, e[Ar + 252 >> 2] = 0, y = Ar + 248 | 0, Ur = Gl(y | 1, 3264, e[I + 4 >> 2]), br = Ar + 208 | 0, e[Ar + 204 >> 2] = br, l = fi();
              e: {
                if (Ur) {
                  Qr = e[I + 8 >> 2], Xr = Ar - -64 | 0, e[Xr >> 2] = me, e[Xr + 4 >> 2] = ke, e[Ar + 56 >> 2] = Q, e[Ar + 60 >> 2] = S, e[Ar + 48 >> 2] = Qr, br = qf(br, 30, l, y, Ar + 48 | 0);
                  break e;
                }
                e[Ar + 80 >> 2] = Q, e[Ar + 84 >> 2] = S, e[Ar + 88 >> 2] = me, e[Ar + 92 >> 2] = ke, br = qf(Ar + 208 | 0, 30, l, Ar + 248 | 0, Ar + 80 | 0);
              }
              e[Ar + 128 >> 2] = 184, Qr = Ar + 196 | 0, e[Qr >> 2] = 0, e[Qr + 4 >> 2] = e[Ar + 128 >> 2], y = Ar + 208 | 0, l = y;
              e: {
                t: {
                  r: {
                    i: {
                      if ((br | 0) >= 30) {
                        l = fi();
                        n: {
                          if (Ur) {
                            br = e[I + 8 >> 2], e[Ar + 16 >> 2] = me, e[Ar + 20 >> 2] = ke, e[Ar + 8 >> 2] = Q, e[Ar + 12 >> 2] = S, e[Ar >> 2] = br, br = Hc(Ar + 204 | 0, l, Ar + 248 | 0, Ar);
                            break n;
                          }
                          e[Ar + 32 >> 2] = Q, e[Ar + 36 >> 2] = S, e[Ar + 40 >> 2] = me, e[Ar + 44 >> 2] = ke, br = Hc(Ar + 204 | 0, l, Ar + 248 | 0, Ar + 32 | 0);
                        }
                        if ((br | 0) == -1) {
                          if (e[5996] = 0, jo(185), l = e[5996], e[5996] = 0, (l | 0) == 1)
                            break r;
                          break i;
                        }
                        l = e[Ar + 204 >> 2], _f(Qr, l);
                      }
                      me = l + br | 0, ke = uc(l, me, e[I + 4 >> 2]), e[Ar + 116 >> 2] = 184, Q = Ar + 120 | 0, e[Q >> 2] = 0, e[Q + 4 >> 2] = e[Ar + 116 >> 2];
                      n: {
                        o: {
                          if ((Ar + 208 | 0) == (l | 0)) {
                            br = Ar + 128 | 0;
                            break o;
                          }
                          if (br = vf(br << 1), !br) {
                            if (e[5996] = 0, jo(185), l = e[5996], e[5996] = 0, (l | 0) != 1)
                              break i;
                            l = gi() | 0;
                            break n;
                          }
                          _f(Q, br), y = l;
                        }
                        l = Ar + 108 | 0, S = e[I + 28 >> 2], e[l >> 2] = S, e[S + 4 >> 2] = e[S + 4 >> 2] + 1, e[5996] = 0, jf(212, y | 0, ke | 0, me | 0, br | 0, Ar + 116 | 0, Ar + 112 | 0, l | 0), y = e[5996], e[5996] = 0;
                        o: {
                          if ((y | 0) != 1) {
                            if (l = e[l >> 2], y = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = y, (y | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), e[5996] = 0, l = Cf(213, Ri | 0, br | 0, e[Ar + 116 >> 2], e[Ar + 112 >> 2], I | 0, C | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                              break o;
                            ka(Q), ka(Qr), bi = Ar + 256 | 0;
                            break e;
                          }
                          l = gi() | 0, y = e[Ar + 108 >> 2], I = e[y + 4 >> 2] - 1 | 0, e[y + 4 >> 2] = I, (I | 0) == -1 && Yn[e[e[y >> 2] + 8 >> 2]](y);
                          break n;
                        }
                        l = gi() | 0;
                      }
                      ka(Q);
                      break t;
                    }
                    jn();
                  }
                  l = gi() | 0;
                }
                ka(Qr), ss(l | 0), jn();
              }
              return l | 0;
            }
            function Xu(l, y, I, C, Q, S, me, ke) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0, me = me | 0, ke = ke | 0;
              var Ar = 0, br = 0, Qr = 0, Ur = 0, Xr = 0, Ri = 0;
              Ri = y, Ar = bi - 416 | 0, bi = Ar, e[Ar + 408 >> 2] = 37, e[Ar + 412 >> 2] = 0, y = Ar + 408 | 0, Ur = Gl(y | 1, 3264, e[I + 4 >> 2]), br = Ar + 368 | 0, e[Ar + 364 >> 2] = br, l = fi();
              e: {
                if (Ur) {
                  Qr = e[I + 8 >> 2], Xr = Ar - -64 | 0, e[Xr >> 2] = me, e[Xr + 4 >> 2] = ke, e[Ar + 56 >> 2] = Q, e[Ar + 60 >> 2] = S, e[Ar + 48 >> 2] = Qr, br = qf(br, 30, l, y, Ar + 48 | 0);
                  break e;
                }
                e[Ar + 80 >> 2] = Q, e[Ar + 84 >> 2] = S, e[Ar + 88 >> 2] = me, e[Ar + 92 >> 2] = ke, br = qf(Ar + 368 | 0, 30, l, Ar + 408 | 0, Ar + 80 | 0);
              }
              e[Ar + 128 >> 2] = 184, Qr = Ar + 356 | 0, e[Qr >> 2] = 0, e[Qr + 4 >> 2] = e[Ar + 128 >> 2], y = Ar + 368 | 0, l = y;
              e: {
                t: {
                  r: {
                    i: {
                      if ((br | 0) >= 30) {
                        l = fi();
                        n: {
                          if (Ur) {
                            br = e[I + 8 >> 2], e[Ar + 16 >> 2] = me, e[Ar + 20 >> 2] = ke, e[Ar + 8 >> 2] = Q, e[Ar + 12 >> 2] = S, e[Ar >> 2] = br, br = Hc(Ar + 364 | 0, l, Ar + 408 | 0, Ar);
                            break n;
                          }
                          e[Ar + 32 >> 2] = Q, e[Ar + 36 >> 2] = S, e[Ar + 40 >> 2] = me, e[Ar + 44 >> 2] = ke, br = Hc(Ar + 364 | 0, l, Ar + 408 | 0, Ar + 32 | 0);
                        }
                        if ((br | 0) == -1) {
                          if (e[5996] = 0, jo(185), l = e[5996], e[5996] = 0, (l | 0) == 1)
                            break r;
                          break i;
                        }
                        l = e[Ar + 364 >> 2], _f(Qr, l);
                      }
                      me = l + br | 0, ke = uc(l, me, e[I + 4 >> 2]), e[Ar + 116 >> 2] = 184, Q = Ar + 120 | 0, e[Q >> 2] = 0, e[Q + 4 >> 2] = e[Ar + 116 >> 2];
                      n: {
                        o: {
                          if ((Ar + 368 | 0) == (l | 0)) {
                            br = Ar + 128 | 0;
                            break o;
                          }
                          if (br = vf(br << 3), !br) {
                            if (e[5996] = 0, jo(185), l = e[5996], e[5996] = 0, (l | 0) != 1)
                              break i;
                            l = gi() | 0;
                            break n;
                          }
                          _f(Q, br), y = l;
                        }
                        l = Ar + 108 | 0, S = e[I + 28 >> 2], e[l >> 2] = S, e[S + 4 >> 2] = e[S + 4 >> 2] + 1, e[5996] = 0, jf(218, y | 0, ke | 0, me | 0, br | 0, Ar + 116 | 0, Ar + 112 | 0, l | 0), y = e[5996], e[5996] = 0;
                        o: {
                          if ((y | 0) != 1) {
                            if (l = e[l >> 2], y = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = y, (y | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), e[5996] = 0, l = Cf(219, Ri | 0, br | 0, e[Ar + 116 >> 2], e[Ar + 112 >> 2], I | 0, C | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                              break o;
                            ka(Q), ka(Qr), bi = Ar + 416 | 0;
                            break e;
                          }
                          l = gi() | 0, y = e[Ar + 108 >> 2], I = e[y + 4 >> 2] - 1 | 0, e[y + 4 >> 2] = I, (I | 0) == -1 && Yn[e[e[y >> 2] + 8 >> 2]](y);
                          break n;
                        }
                        l = gi() | 0;
                      }
                      ka(Q);
                      break t;
                    }
                    jn();
                  }
                  l = gi() | 0;
                }
                ka(Qr), ss(l | 0), jn();
              }
              return l | 0;
            }
            function Zu(l, y, I) {
              var C = 0, Q = 0, S = 0, me = 0, ke = 0, Ar = 0, br = 0;
              Se[l | 0] = 0, Se[l + 1 | 0] = 0, Se[l + 2 | 0] = 0, Se[l + 3 | 0] = 0, Se[l + 4 | 0] = 0, Se[l + 5 | 0] = 0, Se[l + 6 | 0] = 0, Se[l + 7 | 0] = 0, Se[l + 24 | 0] = 0, Se[l + 25 | 0] = 0, Se[l + 26 | 0] = 0, Se[l + 27 | 0] = 0, Se[l + 28 | 0] = 0, Se[l + 29 | 0] = 0, Se[l + 30 | 0] = 0, Se[l + 31 | 0] = 0, Se[l + 16 | 0] = 0, Se[l + 17 | 0] = 0, Se[l + 18 | 0] = 0, Se[l + 19 | 0] = 0, Se[l + 20 | 0] = 0, Se[l + 21 | 0] = 0, Se[l + 22 | 0] = 0, Se[l + 23 | 0] = 0, Se[l + 8 | 0] = 0, Se[l + 9 | 0] = 0, Se[l + 10 | 0] = 0, Se[l + 11 | 0] = 0, Se[l + 12 | 0] = 0, Se[l + 13 | 0] = 0, Se[l + 14 | 0] = 0, Se[l + 15 | 0] = 0, br = Je[y + 8 | 0] | Je[y + 9 | 0] << 8 | (Je[y + 10 | 0] << 16 | Je[y + 11 | 0] << 24), Q = -29, S = Je[y | 0] | Je[y + 1 | 0] << 8 | (Je[y + 2 | 0] << 16 | Je[y + 3 | 0] << 24), ke = S >>> 0 < 29;
              e: {
                if (S = ke ? S : S - 29 | 0, S >>> 0 >= 29) {
                  if (e[5996] = 0, Co(124, l | 0, S + (S >>> 1 | 0) | 0), Q = e[5996], e[5996] = 0, (Q | 0) == 1)
                    break e;
                  C = Je[l + 8 | 0] | Je[l + 9 | 0] << 8 | (Je[l + 10 | 0] << 16 | Je[l + 11 | 0] << 24), me = Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24), Q = me - 29 | 0;
                }
                Ar = me >>> 0 < 29, C = Ar ? l + 4 | 0 : C, ve(S + C | 0, C, Ar ? me : Q), Q = S + (Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24)) | 0, Se[l | 0] = Q, Se[l + 1 | 0] = Q >>> 8, Se[l + 2 | 0] = Q >>> 16, Se[l + 3 | 0] = Q >>> 24;
                t: {
                  if (!S)
                    break t;
                  Q = ke ? y + 4 | 0 : br, ke = S & 7;
                  r: {
                    if (!ke) {
                      y = Q;
                      break r;
                    }
                    for (me = 0, y = Q; Se[C | 0] = Je[y | 0], y = y + 1 | 0, C = C + 1 | 0, me = me + 1 | 0, (ke | 0) != (me | 0); )
                      ;
                  }
                  if (S >>> 0 < 8)
                    break t;
                  for (Q = Q + S | 0; Se[C | 0] = Je[y | 0], Se[C + 1 | 0] = Je[y + 1 | 0], Se[C + 2 | 0] = Je[y + 2 | 0], Se[C + 3 | 0] = Je[y + 3 | 0], Se[C + 4 | 0] = Je[y + 4 | 0], Se[C + 5 | 0] = Je[y + 5 | 0], Se[C + 6 | 0] = Je[y + 6 | 0], Se[C + 7 | 0] = Je[y + 7 | 0], C = C + 8 | 0, y = y + 8 | 0, (Q | 0) != (y | 0); )
                    ;
                }
                if (y = e[I >> 2], e[5996] = 0, wn(127, l | 0, y | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                  break e;
                return;
              }
              y = gi() | 0, (Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24)) >>> 0 >= 29 && (Tr(Je[l + 8 | 0] | Je[l + 9 | 0] << 8 | (Je[l + 10 | 0] << 16 | Je[l + 11 | 0] << 24)), Se[l + 8 | 0] = 0, Se[l + 9 | 0] = 0, Se[l + 10 | 0] = 0, Se[l + 11 | 0] = 0), ss(y | 0), jn();
            }
            function Lc(l, y, I, C, Q, S) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0;
              var me = 0, ke = 0, Ar = 0;
              C = e[C + 28 >> 2], l = bi - 256 | 0, bi = l, e[l + 248 >> 2] = I, e[l + 252 >> 2] = y, Pr(l + 192 | 0, C, l + 208 | 0, l + 207 | 0, l + 206 | 0), C = l + 180 | 0, e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[C + 8 >> 2] = 0, y = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? (e[C + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, Co(172, C | 0, y | 0), y = e[5996], e[5996] = 0;
              e: {
                t: {
                  r: {
                    if ((y | 0) != 1) {
                      for (I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? e[C >> 2] : C, e[l + 176 >> 2] = I, e[l + 12 >> 2] = l + 16, e[l + 8 >> 2] = 0, Se[l + 7 | 0] = 1, Se[l + 6 | 0] = 69, ke = Je[l + 206 | 0] << 24 >> 24, Ar = Je[l + 207 | 0] << 24 >> 24; ; ) {
                        i: {
                          if (e[5996] = 0, y = wn(186, l + 252 | 0, l + 248 | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                            break i;
                          if (y)
                            break r;
                          if (y = Je[C + 11 | 0], y = (y & 128) >>> 7 | 0 ? e[C + 4 >> 2] : y & 127, e[l + 176 >> 2] == (y + I | 0)) {
                            if (e[5996] = 0, Co(172, C | 0, y << 1), I = e[5996], e[5996] = 0, (I | 0) == 1 || (I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? (e[C + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, Co(172, C | 0, I | 0), I = e[5996], e[5996] = 0, (I | 0) == 1))
                              break t;
                            I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? e[C >> 2] : C, e[l + 176 >> 2] = y + I;
                          }
                          if (e[5996] = 0, y = no(187, e[l + 252 >> 2]) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                            break i;
                          if (PA(y, l + 7 | 0, l + 6 | 0, I, l + 176 | 0, Ar, ke, l + 192 | 0, l + 16 | 0, l + 12 | 0, l + 8 | 0, l + 208 | 0))
                            break r;
                          if (e[5996] = 0, no(189, l + 252 | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) != 1)
                            continue;
                        }
                        break;
                      }
                      break t;
                    }
                    break t;
                  }
                  y = Je[l + 203 | 0];
                  r: {
                    if (!((y & 128) >>> 7 | 0 ? e[l + 196 >> 2] : y & 127) | !Je[l + 7 | 0] || (y = e[l + 12 >> 2], (y - (l + 16 | 0) | 0) > 159))
                      break r;
                    e[l + 12 >> 2] = y + 4, e[y >> 2] = e[l + 8 >> 2];
                  }
                  if (df[S >> 2] = z1(I, e[l + 176 >> 2], Q), bf(l + 192 | 0, l + 16 | 0, e[l + 12 >> 2], Q), e[5996] = 0, y = wn(186, l + 252 | 0, l + 248 | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) != 1) {
                    y && (e[Q >> 2] = e[Q >> 2] | 2), y = e[l + 252 >> 2], Yo(C), Yo(l + 192 | 0), bi = l + 256 | 0;
                    break e;
                  }
                }
                y = gi() | 0, Yo(C), Yo(l + 192 | 0), ss(y | 0), jn();
              }
              return y | 0;
            }
            function ku(l, y, I, C, Q, S) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0;
              var me = 0, ke = 0, Ar = 0;
              C = e[C + 28 >> 2], l = bi - 256 | 0, bi = l, e[l + 248 >> 2] = I, e[l + 252 >> 2] = y, Pr(l + 192 | 0, C, l + 208 | 0, l + 207 | 0, l + 206 | 0), C = l + 180 | 0, e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[C + 8 >> 2] = 0, y = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? (e[C + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, Co(172, C | 0, y | 0), y = e[5996], e[5996] = 0;
              e: {
                t: {
                  r: {
                    if ((y | 0) != 1) {
                      for (I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? e[C >> 2] : C, e[l + 176 >> 2] = I, e[l + 12 >> 2] = l + 16, e[l + 8 >> 2] = 0, Se[l + 7 | 0] = 1, Se[l + 6 | 0] = 69, ke = Je[l + 206 | 0] << 24 >> 24, Ar = Je[l + 207 | 0] << 24 >> 24; ; ) {
                        i: {
                          if (e[5996] = 0, y = wn(186, l + 252 | 0, l + 248 | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                            break i;
                          if (y)
                            break r;
                          if (y = Je[C + 11 | 0], y = (y & 128) >>> 7 | 0 ? e[C + 4 >> 2] : y & 127, e[l + 176 >> 2] == (y + I | 0)) {
                            if (e[5996] = 0, Co(172, C | 0, y << 1), I = e[5996], e[5996] = 0, (I | 0) == 1 || (I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? (e[C + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, Co(172, C | 0, I | 0), I = e[5996], e[5996] = 0, (I | 0) == 1))
                              break t;
                            I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? e[C >> 2] : C, e[l + 176 >> 2] = y + I;
                          }
                          if (e[5996] = 0, y = no(187, e[l + 252 >> 2]) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                            break i;
                          if (PA(y, l + 7 | 0, l + 6 | 0, I, l + 176 | 0, Ar, ke, l + 192 | 0, l + 16 | 0, l + 12 | 0, l + 8 | 0, l + 208 | 0))
                            break r;
                          if (e[5996] = 0, no(189, l + 252 | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) != 1)
                            continue;
                        }
                        break;
                      }
                      break t;
                    }
                    break t;
                  }
                  y = Je[l + 203 | 0];
                  r: {
                    if (!((y & 128) >>> 7 | 0 ? e[l + 196 >> 2] : y & 127) | !Je[l + 7 | 0] || (y = e[l + 12 >> 2], (y - (l + 16 | 0) | 0) > 159))
                      break r;
                    e[l + 12 >> 2] = y + 4, e[y >> 2] = e[l + 8 >> 2];
                  }
                  if (zo[S >> 3] = X1(I, e[l + 176 >> 2], Q), bf(l + 192 | 0, l + 16 | 0, e[l + 12 >> 2], Q), e[5996] = 0, y = wn(186, l + 252 | 0, l + 248 | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) != 1) {
                    y && (e[Q >> 2] = e[Q >> 2] | 2), y = e[l + 252 >> 2], Yo(C), Yo(l + 192 | 0), bi = l + 256 | 0;
                    break e;
                  }
                }
                y = gi() | 0, Yo(C), Yo(l + 192 | 0), ss(y | 0), jn();
              }
              return y | 0;
            }
            function Ec(l, y, I, C, Q, S, me, ke) {
              var Ar = 0, br = 0, Qr = 0;
              if (Ar = bi - 16 | 0, bi = Ar, e[Ar + 8 >> 2] = I, e[Ar + 12 >> 2] = y, y = e[C + 28 >> 2], e[Ar + 4 >> 2] = y, e[y + 4 >> 2] = e[y + 4 >> 2] + 1, I = 0, e[5996] = 0, br = no(170, e[Ar + 4 >> 2]) | 0, y = e[5996], e[5996] = 0, (y | 0) != 1) {
                y = e[Ar + 4 >> 2], Qr = e[y + 4 >> 2] - 1 | 0, e[y + 4 >> 2] = Qr, (Qr | 0) == -1 && Yn[e[e[y >> 2] + 8 >> 2]](y), e[Q >> 2] = 0;
                e: {
                  for (; ; ) {
                    if (I | (me | 0) == (ke | 0))
                      break e;
                    t: {
                      if (Tc(Ar + 12 | 0, Ar + 8 | 0))
                        break t;
                      r: {
                        if ((Yn[e[e[br >> 2] + 36 >> 2]](br, Se[me | 0], 0) | 0) == 37) {
                          if ((me + 1 | 0) == (ke | 0))
                            break t;
                          I = Yn[e[e[br >> 2] + 36 >> 2]](br, Se[me + 1 | 0], 0) | 0;
                          i: {
                            if (!((I | 0) == 69 | (I & 255) == 48)) {
                              y = 0, Qr = 1;
                              break i;
                            }
                            if ((me + 2 | 0) == (ke | 0))
                              break t;
                            y = I, I = Yn[e[e[br >> 2] + 36 >> 2]](br, Se[me + 2 | 0], 0) | 0, Qr = 2;
                          }
                          e[Ar + 12 >> 2] = Yn[e[e[l >> 2] + 36 >> 2]](l, e[Ar + 12 >> 2], e[Ar + 8 >> 2], C, Q, S, I, y), me = (me + Qr | 0) + 1 | 0;
                          break r;
                        }
                        if (y = e[br + 8 >> 2], I = Se[me | 0], (I | 0) >= 0 ? I = e[y + ((I & 255) << 2) >> 2] & 1 : I = 0, I) {
                          for (; ; ) {
                            i: {
                              if (me = me + 1 | 0, (ke | 0) == (me | 0)) {
                                me = ke;
                                break i;
                              }
                              if (I = Se[me | 0], (I | 0) >= 0 ? I = e[y + ((I & 255) << 2) >> 2] & 1 : I = 0, I)
                                continue;
                            }
                            break;
                          }
                          for (; ; ) {
                            if (Qr = Ar + 12 | 0, Tc(Qr, Ar + 8 | 0))
                              break r;
                            y = e[Ar + 12 >> 2], I = e[y + 12 >> 2];
                            i: {
                              if ((I | 0) == e[y + 16 >> 2]) {
                                y = Yn[e[e[y >> 2] + 36 >> 2]](y) | 0;
                                break i;
                              }
                              y = Je[I | 0];
                            }
                            if (I = e[br + 8 >> 2], y = y << 24 >> 24, (y | 0) >= 0 ? y = e[I + ((y & 255) << 2) >> 2] & 1 : y = 0, !y)
                              break r;
                            mh(Qr);
                          }
                        }
                        y = e[Ar + 12 >> 2], I = e[y + 12 >> 2];
                        i: {
                          if ((I | 0) == e[y + 16 >> 2]) {
                            y = Yn[e[e[y >> 2] + 36 >> 2]](y) | 0;
                            break i;
                          }
                          y = Je[I | 0];
                        }
                        if ((Yn[e[e[br >> 2] + 12 >> 2]](br, y << 24 >> 24) | 0) == (Yn[e[e[br >> 2] + 12 >> 2]](br, Se[me | 0]) | 0)) {
                          me = me + 1 | 0, mh(Ar + 12 | 0);
                          break r;
                        }
                        e[Q >> 2] = 4;
                      }
                      I = e[Q >> 2];
                      continue;
                    }
                    break;
                  }
                  e[Q >> 2] = 4;
                }
                return Tc(Ar + 12 | 0, Ar + 8 | 0) && (e[Q >> 2] = e[Q >> 2] | 2), bi = Ar + 16 | 0, e[Ar + 12 >> 2];
              }
              I = gi() | 0, l = e[Ar + 4 >> 2], y = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = y, (y | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), ss(I | 0), jn();
            }
            function bl(l, y, I, C, Q, S) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0;
              var me = 0, ke = 0, Ar = 0;
              C = e[C + 28 >> 2], l = bi - 368 | 0, bi = l, e[l + 360 >> 2] = I, e[l + 364 >> 2] = y, gr(l + 204 | 0, C, l + 224 | 0, l + 220 | 0, l + 216 | 0), C = l + 192 | 0, e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[C + 8 >> 2] = 0, y = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? (e[C + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, Co(172, C | 0, y | 0), y = e[5996], e[5996] = 0;
              e: {
                t: {
                  r: {
                    if ((y | 0) != 1) {
                      for (I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? e[C >> 2] : C, e[l + 188 >> 2] = I, e[l + 12 >> 2] = l + 16, e[l + 8 >> 2] = 0, Se[l + 7 | 0] = 1, Se[l + 6 | 0] = 69, ke = e[l + 216 >> 2], Ar = e[l + 220 >> 2]; ; ) {
                        i: {
                          if (e[5996] = 0, y = wn(202, l + 364 | 0, l + 360 | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                            break i;
                          if (y)
                            break r;
                          if (y = Je[C + 11 | 0], y = (y & 128) >>> 7 | 0 ? e[C + 4 >> 2] : y & 127, e[l + 188 >> 2] == (y + I | 0)) {
                            if (e[5996] = 0, Co(172, C | 0, y << 1), I = e[5996], e[5996] = 0, (I | 0) == 1 || (I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? (e[C + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, Co(172, C | 0, I | 0), I = e[5996], e[5996] = 0, (I | 0) == 1))
                              break t;
                            I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? e[C >> 2] : C, e[l + 188 >> 2] = y + I;
                          }
                          if (e[5996] = 0, y = no(203, e[l + 364 >> 2]) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                            break i;
                          if (eh(y, l + 7 | 0, l + 6 | 0, I, l + 188 | 0, Ar, ke, l + 204 | 0, l + 16 | 0, l + 12 | 0, l + 8 | 0, l + 224 | 0))
                            break r;
                          if (e[5996] = 0, no(205, l + 364 | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) != 1)
                            continue;
                        }
                        break;
                      }
                      break t;
                    }
                    break t;
                  }
                  y = Je[l + 215 | 0];
                  r: {
                    if (!((y & 128) >>> 7 | 0 ? e[l + 208 >> 2] : y & 127) | !Je[l + 7 | 0] || (y = e[l + 12 >> 2], (y - (l + 16 | 0) | 0) > 159))
                      break r;
                    e[l + 12 >> 2] = y + 4, e[y >> 2] = e[l + 8 >> 2];
                  }
                  if (df[S >> 2] = z1(I, e[l + 188 >> 2], Q), bf(l + 204 | 0, l + 16 | 0, e[l + 12 >> 2], Q), e[5996] = 0, y = wn(202, l + 364 | 0, l + 360 | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) != 1) {
                    y && (e[Q >> 2] = e[Q >> 2] | 2), y = e[l + 364 >> 2], Yo(C), Yo(l + 204 | 0), bi = l + 368 | 0;
                    break e;
                  }
                }
                y = gi() | 0, Yo(C), Yo(l + 204 | 0), ss(y | 0), jn();
              }
              return y | 0;
            }
            function Cl(l, y, I, C, Q, S) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0;
              var me = 0, ke = 0, Ar = 0;
              C = e[C + 28 >> 2], l = bi - 368 | 0, bi = l, e[l + 360 >> 2] = I, e[l + 364 >> 2] = y, gr(l + 204 | 0, C, l + 224 | 0, l + 220 | 0, l + 216 | 0), C = l + 192 | 0, e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[C + 8 >> 2] = 0, y = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? (e[C + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, Co(172, C | 0, y | 0), y = e[5996], e[5996] = 0;
              e: {
                t: {
                  r: {
                    if ((y | 0) != 1) {
                      for (I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? e[C >> 2] : C, e[l + 188 >> 2] = I, e[l + 12 >> 2] = l + 16, e[l + 8 >> 2] = 0, Se[l + 7 | 0] = 1, Se[l + 6 | 0] = 69, ke = e[l + 216 >> 2], Ar = e[l + 220 >> 2]; ; ) {
                        i: {
                          if (e[5996] = 0, y = wn(202, l + 364 | 0, l + 360 | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                            break i;
                          if (y)
                            break r;
                          if (y = Je[C + 11 | 0], y = (y & 128) >>> 7 | 0 ? e[C + 4 >> 2] : y & 127, e[l + 188 >> 2] == (y + I | 0)) {
                            if (e[5996] = 0, Co(172, C | 0, y << 1), I = e[5996], e[5996] = 0, (I | 0) == 1 || (I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? (e[C + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, Co(172, C | 0, I | 0), I = e[5996], e[5996] = 0, (I | 0) == 1))
                              break t;
                            I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? e[C >> 2] : C, e[l + 188 >> 2] = y + I;
                          }
                          if (e[5996] = 0, y = no(203, e[l + 364 >> 2]) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                            break i;
                          if (eh(y, l + 7 | 0, l + 6 | 0, I, l + 188 | 0, Ar, ke, l + 204 | 0, l + 16 | 0, l + 12 | 0, l + 8 | 0, l + 224 | 0))
                            break r;
                          if (e[5996] = 0, no(205, l + 364 | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) != 1)
                            continue;
                        }
                        break;
                      }
                      break t;
                    }
                    break t;
                  }
                  y = Je[l + 215 | 0];
                  r: {
                    if (!((y & 128) >>> 7 | 0 ? e[l + 208 >> 2] : y & 127) | !Je[l + 7 | 0] || (y = e[l + 12 >> 2], (y - (l + 16 | 0) | 0) > 159))
                      break r;
                    e[l + 12 >> 2] = y + 4, e[y >> 2] = e[l + 8 >> 2];
                  }
                  if (zo[S >> 3] = X1(I, e[l + 188 >> 2], Q), bf(l + 204 | 0, l + 16 | 0, e[l + 12 >> 2], Q), e[5996] = 0, y = wn(202, l + 364 | 0, l + 360 | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) != 1) {
                    y && (e[Q >> 2] = e[Q >> 2] | 2), y = e[l + 364 >> 2], Yo(C), Yo(l + 204 | 0), bi = l + 368 | 0;
                    break e;
                  }
                }
                y = gi() | 0, Yo(C), Yo(l + 204 | 0), ss(y | 0), jn();
              }
              return y | 0;
            }
            function Su(l, y) {
              var I = 0, C = 0, Q = 0, S = 0, me = 0, ke = 0, Ar = 0;
              e: {
                t: {
                  if (l - 1 & l | y >>> 0 > 4294967239)
                    break t;
                  for (; ; ) {
                    l = l >>> 0 <= 8 ? 8 : l, Q = e[5995], S = e[5994], y = y >>> 0 <= 8 ? 8 : y + 3 & -4;
                    r: {
                      if (y >>> 0 <= 127) {
                        me = (y >>> 3 | 0) - 1 | 0;
                        break r;
                      }
                      if (C = Ha(y), me = ((y >>> 29 - C ^ 4) - (C << 2) | 0) + 110 | 0, y >>> 0 <= 4095)
                        break r;
                      C = ((y >>> 30 - C ^ 2) - (C << 1) | 0) + 71 | 0, me = C >>> 0 >= 63 ? 63 : C;
                    }
                    if (I = me & 31, (me & 63) >>> 0 >= 32 ? (C = 0, I = Q >>> I | 0) : (C = Q >>> I | 0, I = ((1 << I) - 1 & Q) << 32 - I | S >>> I), I | C) {
                      for (; ; ) {
                        Q = I;
                        r: {
                          if (C | Q) {
                            S = C - 1 | 0, ke = S + 1 | 0, I = S, S = Q - 1 | 0, ke = (S | 0) != -1 ? ke : I, I = Ha(C ^ ke), I = (I | 0) == 32 ? Ha(Q ^ S) + 32 | 0 : I, S = 63 - I | 0, Ci = 0 - (I >>> 0 > 63) | 0;
                            break r;
                          }
                          Ci = 0, S = 64;
                        }
                        ke = S, S = ke & 31, (ke & 63) >>> 0 >= 32 ? (I = 0, S = C >>> S | 0) : (I = C >>> S | 0, S = ((1 << S) - 1 & C) << 32 - S | Q >>> S), C = I, me = me + ke | 0, ke = me << 4, Q = e[ke + 22952 >> 2], Ar = ke + 22944 | 0;
                        r: {
                          if ((Q | 0) != (Ar | 0)) {
                            if (I = ru(Q, l, y), I)
                              break t;
                            I = e[Q + 4 >> 2], e[I + 8 >> 2] = e[Q + 8 >> 2], e[e[Q + 8 >> 2] + 4 >> 2] = I, e[Q + 8 >> 2] = Ar, I = ke + 22948 | 0, e[Q + 4 >> 2] = e[I >> 2], e[I >> 2] = Q, e[e[Q + 4 >> 2] + 8 >> 2] = Q, me = me + 1 | 0, I = (C & 1) << 31 | S >>> 1, C = C >>> 1 | 0;
                            break r;
                          }
                          I = e[5995], e[5994] = e[5994] & u1(-2, -1, me), e[5995] = Ci & I, I = S ^ 1;
                        }
                        if (!(C | I))
                          break;
                      }
                      S = e[5994], Q = e[5995];
                    }
                    r: {
                      if (Q | S) {
                        C = Ha(Q), ke = 63 - ((C | 0) == 32 ? Ha(S) + 32 | 0 : C) | 0, I = ke << 4, C = e[I + 22952 >> 2];
                        i: {
                          if (!Q & S >>> 0 < 1073741824 || (me = 99, Q = I + 22944 | 0, (Q | 0) == (C | 0)))
                            break i;
                          for (; ; ) {
                            if (!me)
                              break i;
                            if (I = ru(C, l, y), I)
                              break t;
                            if (me = me - 1 | 0, C = e[C + 8 >> 2], (Q | 0) == (C | 0))
                              break;
                          }
                          C = Q;
                        }
                        if (ih(y + 48 | 0))
                          break r;
                        if (!C || (Q = (ke << 4) + 22944 | 0, (Q | 0) == (C | 0)))
                          break e;
                        for (; ; ) {
                          if (I = ru(C, l, y), I)
                            break t;
                          if (C = e[C + 8 >> 2], (Q | 0) == (C | 0))
                            break;
                        }
                        break e;
                      }
                      if (!ih(y + 48 | 0))
                        break e;
                    }
                    if (I = 0, l - 1 & l)
                      break t;
                    if (!(y >>> 0 <= 4294967239))
                      break;
                  }
                }
                return I;
              }
              return 0;
            }
            function El(l, y, I, C, Q, S) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0;
              var me = 0, ke = 0, Ar = 0;
              l = bi - 336 | 0, bi = l, e[l + 328 >> 2] = I, e[l + 332 >> 2] = y, y = jc(e[C + 4 >> 2]), Ar = _a(e[C + 28 >> 2], l + 208 | 0), Qn(l + 196 | 0, e[C + 28 >> 2], l + 324 | 0), C = l + 184 | 0, e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[C + 8 >> 2] = 0, I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? (e[C + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, Co(172, C | 0, I | 0), I = e[5996], e[5996] = 0;
              e: {
                t: {
                  r: {
                    if ((I | 0) != 1) {
                      for (I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? e[C >> 2] : C, e[l + 180 >> 2] = I, e[l + 12 >> 2] = l + 16, e[l + 8 >> 2] = 0; ; ) {
                        i: {
                          if (e[5996] = 0, me = wn(202, l + 332 | 0, l + 328 | 0) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                            break i;
                          if (me)
                            break r;
                          if (me = Je[C + 11 | 0], me = (me & 128) >>> 7 | 0 ? e[C + 4 >> 2] : me & 127, e[l + 180 >> 2] == (me + I | 0)) {
                            if (e[5996] = 0, Co(172, C | 0, me << 1), I = e[5996], e[5996] = 0, (I | 0) == 1 || (I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? (e[C + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, Co(172, C | 0, I | 0), I = e[5996], e[5996] = 0, (I | 0) == 1))
                              break t;
                            I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? e[C >> 2] : C, e[l + 180 >> 2] = me + I;
                          }
                          if (e[5996] = 0, me = no(203, e[l + 332 >> 2]) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                            break i;
                          if (Wi(me, y, I, l + 180 | 0, l + 8 | 0, e[l + 324 >> 2], e[l + 200 >> 2], Je[l + 207 | 0], l + 16 | 0, l + 12 | 0, Ar))
                            break r;
                          if (e[5996] = 0, no(205, l + 332 | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) != 1)
                            continue;
                        }
                        break;
                      }
                      break t;
                    }
                    break t;
                  }
                  me = Je[l + 207 | 0];
                  r: {
                    if (!((me & 128) >>> 7 | 0 ? e[l + 200 >> 2] : me & 127) || (me = e[l + 12 >> 2], (me - (l + 16 | 0) | 0) > 159))
                      break r;
                    e[l + 12 >> 2] = me + 4, e[me >> 2] = e[l + 8 >> 2];
                  }
                  if (e[S >> 2] = ed(I, e[l + 180 >> 2], Q, y), e[S + 4 >> 2] = Ci, bf(l + 196 | 0, l + 16 | 0, e[l + 12 >> 2], Q), e[5996] = 0, y = wn(202, l + 332 | 0, l + 328 | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) != 1) {
                    y && (e[Q >> 2] = e[Q >> 2] | 2), y = e[l + 332 >> 2], Yo(C), Yo(l + 196 | 0), bi = l + 336 | 0;
                    break e;
                  }
                }
                y = gi() | 0, Yo(C), Yo(l + 196 | 0), ss(y | 0), jn();
              }
              return y | 0;
            }
            function Bl(l, y, I, C, Q, S) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0;
              var me = 0, ke = 0, Ar = 0;
              l = bi - 336 | 0, bi = l, e[l + 328 >> 2] = I, e[l + 332 >> 2] = y, y = jc(e[C + 4 >> 2]), Ar = _a(e[C + 28 >> 2], l + 208 | 0), Qn(l + 196 | 0, e[C + 28 >> 2], l + 324 | 0), C = l + 184 | 0, e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[C + 8 >> 2] = 0, I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? (e[C + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, Co(172, C | 0, I | 0), I = e[5996], e[5996] = 0;
              e: {
                t: {
                  r: {
                    if ((I | 0) != 1) {
                      for (I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? e[C >> 2] : C, e[l + 180 >> 2] = I, e[l + 12 >> 2] = l + 16, e[l + 8 >> 2] = 0; ; ) {
                        i: {
                          if (e[5996] = 0, me = wn(202, l + 332 | 0, l + 328 | 0) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                            break i;
                          if (me)
                            break r;
                          if (me = Je[C + 11 | 0], me = (me & 128) >>> 7 | 0 ? e[C + 4 >> 2] : me & 127, e[l + 180 >> 2] == (me + I | 0)) {
                            if (e[5996] = 0, Co(172, C | 0, me << 1), I = e[5996], e[5996] = 0, (I | 0) == 1 || (I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? (e[C + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, Co(172, C | 0, I | 0), I = e[5996], e[5996] = 0, (I | 0) == 1))
                              break t;
                            I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? e[C >> 2] : C, e[l + 180 >> 2] = me + I;
                          }
                          if (e[5996] = 0, me = no(203, e[l + 332 >> 2]) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                            break i;
                          if (Wi(me, y, I, l + 180 | 0, l + 8 | 0, e[l + 324 >> 2], e[l + 200 >> 2], Je[l + 207 | 0], l + 16 | 0, l + 12 | 0, Ar))
                            break r;
                          if (e[5996] = 0, no(205, l + 332 | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) != 1)
                            continue;
                        }
                        break;
                      }
                      break t;
                    }
                    break t;
                  }
                  me = Je[l + 207 | 0];
                  r: {
                    if (!((me & 128) >>> 7 | 0 ? e[l + 200 >> 2] : me & 127) || (me = e[l + 12 >> 2], (me - (l + 16 | 0) | 0) > 159))
                      break r;
                    e[l + 12 >> 2] = me + 4, e[me >> 2] = e[l + 8 >> 2];
                  }
                  if (e[S >> 2] = ma(I, e[l + 180 >> 2], Q, y), e[S + 4 >> 2] = Ci, bf(l + 196 | 0, l + 16 | 0, e[l + 12 >> 2], Q), e[5996] = 0, y = wn(202, l + 332 | 0, l + 328 | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) != 1) {
                    y && (e[Q >> 2] = e[Q >> 2] | 2), y = e[l + 332 >> 2], Yo(C), Yo(l + 196 | 0), bi = l + 336 | 0;
                    break e;
                  }
                }
                y = gi() | 0, Yo(C), Yo(l + 196 | 0), ss(y | 0), jn();
              }
              return y | 0;
            }
            function Tu(l, y, I, C, Q, S) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0;
              var me = 0, ke = 0, Ar = 0;
              l = bi - 336 | 0, bi = l, e[l + 328 >> 2] = I, e[l + 332 >> 2] = y, y = jc(e[C + 4 >> 2]), Ar = _a(e[C + 28 >> 2], l + 208 | 0), Qn(l + 196 | 0, e[C + 28 >> 2], l + 324 | 0), C = l + 184 | 0, e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[C + 8 >> 2] = 0, I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? (e[C + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, Co(172, C | 0, I | 0), I = e[5996], e[5996] = 0;
              e: {
                t: {
                  r: {
                    if ((I | 0) != 1) {
                      for (I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? e[C >> 2] : C, e[l + 180 >> 2] = I, e[l + 12 >> 2] = l + 16, e[l + 8 >> 2] = 0; ; ) {
                        i: {
                          if (e[5996] = 0, me = wn(202, l + 332 | 0, l + 328 | 0) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                            break i;
                          if (me)
                            break r;
                          if (me = Je[C + 11 | 0], me = (me & 128) >>> 7 | 0 ? e[C + 4 >> 2] : me & 127, e[l + 180 >> 2] == (me + I | 0)) {
                            if (e[5996] = 0, Co(172, C | 0, me << 1), I = e[5996], e[5996] = 0, (I | 0) == 1 || (I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? (e[C + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, Co(172, C | 0, I | 0), I = e[5996], e[5996] = 0, (I | 0) == 1))
                              break t;
                            I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? e[C >> 2] : C, e[l + 180 >> 2] = me + I;
                          }
                          if (e[5996] = 0, me = no(203, e[l + 332 >> 2]) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                            break i;
                          if (Wi(me, y, I, l + 180 | 0, l + 8 | 0, e[l + 324 >> 2], e[l + 200 >> 2], Je[l + 207 | 0], l + 16 | 0, l + 12 | 0, Ar))
                            break r;
                          if (e[5996] = 0, no(205, l + 332 | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) != 1)
                            continue;
                        }
                        break;
                      }
                      break t;
                    }
                    break t;
                  }
                  me = Je[l + 207 | 0];
                  r: {
                    if (!((me & 128) >>> 7 | 0 ? e[l + 200 >> 2] : me & 127) || (me = e[l + 12 >> 2], (me - (l + 16 | 0) | 0) > 159))
                      break r;
                    e[l + 12 >> 2] = me + 4, e[me >> 2] = e[l + 8 >> 2];
                  }
                  if (e[S >> 2] = Po(I, e[l + 180 >> 2], Q, y), bf(l + 196 | 0, l + 16 | 0, e[l + 12 >> 2], Q), e[5996] = 0, y = wn(202, l + 332 | 0, l + 328 | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) != 1) {
                    y && (e[Q >> 2] = e[Q >> 2] | 2), y = e[l + 332 >> 2], Yo(C), Yo(l + 196 | 0), bi = l + 336 | 0;
                    break e;
                  }
                }
                y = gi() | 0, Yo(C), Yo(l + 196 | 0), ss(y | 0), jn();
              }
              return y | 0;
            }
            function Du(l, y, I, C, Q, S) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0;
              var me = 0, ke = 0, Ar = 0;
              l = bi - 336 | 0, bi = l, e[l + 328 >> 2] = I, e[l + 332 >> 2] = y, y = jc(e[C + 4 >> 2]), Ar = _a(e[C + 28 >> 2], l + 208 | 0), Qn(l + 196 | 0, e[C + 28 >> 2], l + 324 | 0), C = l + 184 | 0, e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[C + 8 >> 2] = 0, I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? (e[C + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, Co(172, C | 0, I | 0), I = e[5996], e[5996] = 0;
              e: {
                t: {
                  r: {
                    if ((I | 0) != 1) {
                      for (I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? e[C >> 2] : C, e[l + 180 >> 2] = I, e[l + 12 >> 2] = l + 16, e[l + 8 >> 2] = 0; ; ) {
                        i: {
                          if (e[5996] = 0, me = wn(202, l + 332 | 0, l + 328 | 0) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                            break i;
                          if (me)
                            break r;
                          if (me = Je[C + 11 | 0], me = (me & 128) >>> 7 | 0 ? e[C + 4 >> 2] : me & 127, e[l + 180 >> 2] == (me + I | 0)) {
                            if (e[5996] = 0, Co(172, C | 0, me << 1), I = e[5996], e[5996] = 0, (I | 0) == 1 || (I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? (e[C + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, Co(172, C | 0, I | 0), I = e[5996], e[5996] = 0, (I | 0) == 1))
                              break t;
                            I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? e[C >> 2] : C, e[l + 180 >> 2] = me + I;
                          }
                          if (e[5996] = 0, me = no(203, e[l + 332 >> 2]) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                            break i;
                          if (Wi(me, y, I, l + 180 | 0, l + 8 | 0, e[l + 324 >> 2], e[l + 200 >> 2], Je[l + 207 | 0], l + 16 | 0, l + 12 | 0, Ar))
                            break r;
                          if (e[5996] = 0, no(205, l + 332 | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) != 1)
                            continue;
                        }
                        break;
                      }
                      break t;
                    }
                    break t;
                  }
                  me = Je[l + 207 | 0];
                  r: {
                    if (!((me & 128) >>> 7 | 0 ? e[l + 200 >> 2] : me & 127) || (me = e[l + 12 >> 2], (me - (l + 16 | 0) | 0) > 159))
                      break r;
                    e[l + 12 >> 2] = me + 4, e[me >> 2] = e[l + 8 >> 2];
                  }
                  if (ea[S >> 1] = ua(I, e[l + 180 >> 2], Q, y), bf(l + 196 | 0, l + 16 | 0, e[l + 12 >> 2], Q), e[5996] = 0, y = wn(202, l + 332 | 0, l + 328 | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) != 1) {
                    y && (e[Q >> 2] = e[Q >> 2] | 2), y = e[l + 332 >> 2], Yo(C), Yo(l + 196 | 0), bi = l + 336 | 0;
                    break e;
                  }
                }
                y = gi() | 0, Yo(C), Yo(l + 196 | 0), ss(y | 0), jn();
              }
              return y | 0;
            }
            function fu(l, y, I, C, Q, S) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0;
              var me = 0, ke = 0, Ar = 0;
              l = bi - 336 | 0, bi = l, e[l + 328 >> 2] = I, e[l + 332 >> 2] = y, y = jc(e[C + 4 >> 2]), Ar = _a(e[C + 28 >> 2], l + 208 | 0), Qn(l + 196 | 0, e[C + 28 >> 2], l + 324 | 0), C = l + 184 | 0, e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[C + 8 >> 2] = 0, I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? (e[C + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, Co(172, C | 0, I | 0), I = e[5996], e[5996] = 0;
              e: {
                t: {
                  r: {
                    if ((I | 0) != 1) {
                      for (I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? e[C >> 2] : C, e[l + 180 >> 2] = I, e[l + 12 >> 2] = l + 16, e[l + 8 >> 2] = 0; ; ) {
                        i: {
                          if (e[5996] = 0, me = wn(202, l + 332 | 0, l + 328 | 0) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                            break i;
                          if (me)
                            break r;
                          if (me = Je[C + 11 | 0], me = (me & 128) >>> 7 | 0 ? e[C + 4 >> 2] : me & 127, e[l + 180 >> 2] == (me + I | 0)) {
                            if (e[5996] = 0, Co(172, C | 0, me << 1), I = e[5996], e[5996] = 0, (I | 0) == 1 || (I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? (e[C + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, Co(172, C | 0, I | 0), I = e[5996], e[5996] = 0, (I | 0) == 1))
                              break t;
                            I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? e[C >> 2] : C, e[l + 180 >> 2] = me + I;
                          }
                          if (e[5996] = 0, me = no(203, e[l + 332 >> 2]) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                            break i;
                          if (Wi(me, y, I, l + 180 | 0, l + 8 | 0, e[l + 324 >> 2], e[l + 200 >> 2], Je[l + 207 | 0], l + 16 | 0, l + 12 | 0, Ar))
                            break r;
                          if (e[5996] = 0, no(205, l + 332 | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) != 1)
                            continue;
                        }
                        break;
                      }
                      break t;
                    }
                    break t;
                  }
                  me = Je[l + 207 | 0];
                  r: {
                    if (!((me & 128) >>> 7 | 0 ? e[l + 200 >> 2] : me & 127) || (me = e[l + 12 >> 2], (me - (l + 16 | 0) | 0) > 159))
                      break r;
                    e[l + 12 >> 2] = me + 4, e[me >> 2] = e[l + 8 >> 2];
                  }
                  if (e[S >> 2] = Vf(I, e[l + 180 >> 2], Q, y), bf(l + 196 | 0, l + 16 | 0, e[l + 12 >> 2], Q), e[5996] = 0, y = wn(202, l + 332 | 0, l + 328 | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) != 1) {
                    y && (e[Q >> 2] = e[Q >> 2] | 2), y = e[l + 332 >> 2], Yo(C), Yo(l + 196 | 0), bi = l + 336 | 0;
                    break e;
                  }
                }
                y = gi() | 0, Yo(C), Yo(l + 196 | 0), ss(y | 0), jn();
              }
              return y | 0;
            }
            function _l(l, y, I, C, Q, S) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0;
              var me = 0, ke = 0;
              me = e[C + 4 >> 2], C = e[C + 28 >> 2], l = bi - 224 | 0, bi = l, e[l + 216 >> 2] = I, e[l + 220 >> 2] = y, y = jc(me), zn(l + 200 | 0, C, l + 215 | 0), C = l + 188 | 0, e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[C + 8 >> 2] = 0, I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? (e[C + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, Co(172, C | 0, I | 0), I = e[5996], e[5996] = 0;
              e: {
                t: {
                  r: {
                    if ((I | 0) != 1) {
                      for (I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? e[C >> 2] : C, e[l + 184 >> 2] = I, e[l + 12 >> 2] = l + 16, e[l + 8 >> 2] = 0; ; ) {
                        i: {
                          if (e[5996] = 0, me = wn(186, l + 220 | 0, l + 216 | 0) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                            break i;
                          if (me)
                            break r;
                          if (me = Je[C + 11 | 0], me = (me & 128) >>> 7 | 0 ? e[C + 4 >> 2] : me & 127, e[l + 184 >> 2] == (me + I | 0)) {
                            if (e[5996] = 0, Co(172, C | 0, me << 1), I = e[5996], e[5996] = 0, (I | 0) == 1 || (I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? (e[C + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, Co(172, C | 0, I | 0), I = e[5996], e[5996] = 0, (I | 0) == 1))
                              break t;
                            I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? e[C >> 2] : C, e[l + 184 >> 2] = me + I;
                          }
                          if (e[5996] = 0, me = no(187, e[l + 220 >> 2]) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                            break i;
                          if (Mi(me, y, I, l + 184 | 0, l + 8 | 0, Se[l + 215 | 0], e[l + 204 >> 2], Je[l + 211 | 0], l + 16 | 0, l + 12 | 0, 12416))
                            break r;
                          if (e[5996] = 0, no(189, l + 220 | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) != 1)
                            continue;
                        }
                        break;
                      }
                      break t;
                    }
                    break t;
                  }
                  me = Je[l + 211 | 0];
                  r: {
                    if (!((me & 128) >>> 7 | 0 ? e[l + 204 >> 2] : me & 127) || (me = e[l + 12 >> 2], (me - (l + 16 | 0) | 0) > 159))
                      break r;
                    e[l + 12 >> 2] = me + 4, e[me >> 2] = e[l + 8 >> 2];
                  }
                  if (e[S >> 2] = ed(I, e[l + 184 >> 2], Q, y), e[S + 4 >> 2] = Ci, bf(l + 200 | 0, l + 16 | 0, e[l + 12 >> 2], Q), e[5996] = 0, y = wn(186, l + 220 | 0, l + 216 | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) != 1) {
                    y && (e[Q >> 2] = e[Q >> 2] | 2), y = e[l + 220 >> 2], Yo(C), Yo(l + 200 | 0), bi = l + 224 | 0;
                    break e;
                  }
                }
                y = gi() | 0, Yo(C), Yo(l + 200 | 0), ss(y | 0), jn();
              }
              return y | 0;
            }
            function kl(l, y, I, C, Q, S) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0;
              var me = 0, ke = 0;
              me = e[C + 4 >> 2], C = e[C + 28 >> 2], l = bi - 224 | 0, bi = l, e[l + 216 >> 2] = I, e[l + 220 >> 2] = y, y = jc(me), zn(l + 200 | 0, C, l + 215 | 0), C = l + 188 | 0, e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[C + 8 >> 2] = 0, I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? (e[C + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, Co(172, C | 0, I | 0), I = e[5996], e[5996] = 0;
              e: {
                t: {
                  r: {
                    if ((I | 0) != 1) {
                      for (I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? e[C >> 2] : C, e[l + 184 >> 2] = I, e[l + 12 >> 2] = l + 16, e[l + 8 >> 2] = 0; ; ) {
                        i: {
                          if (e[5996] = 0, me = wn(186, l + 220 | 0, l + 216 | 0) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                            break i;
                          if (me)
                            break r;
                          if (me = Je[C + 11 | 0], me = (me & 128) >>> 7 | 0 ? e[C + 4 >> 2] : me & 127, e[l + 184 >> 2] == (me + I | 0)) {
                            if (e[5996] = 0, Co(172, C | 0, me << 1), I = e[5996], e[5996] = 0, (I | 0) == 1 || (I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? (e[C + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, Co(172, C | 0, I | 0), I = e[5996], e[5996] = 0, (I | 0) == 1))
                              break t;
                            I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? e[C >> 2] : C, e[l + 184 >> 2] = me + I;
                          }
                          if (e[5996] = 0, me = no(187, e[l + 220 >> 2]) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                            break i;
                          if (Mi(me, y, I, l + 184 | 0, l + 8 | 0, Se[l + 215 | 0], e[l + 204 >> 2], Je[l + 211 | 0], l + 16 | 0, l + 12 | 0, 12416))
                            break r;
                          if (e[5996] = 0, no(189, l + 220 | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) != 1)
                            continue;
                        }
                        break;
                      }
                      break t;
                    }
                    break t;
                  }
                  me = Je[l + 211 | 0];
                  r: {
                    if (!((me & 128) >>> 7 | 0 ? e[l + 204 >> 2] : me & 127) || (me = e[l + 12 >> 2], (me - (l + 16 | 0) | 0) > 159))
                      break r;
                    e[l + 12 >> 2] = me + 4, e[me >> 2] = e[l + 8 >> 2];
                  }
                  if (e[S >> 2] = ma(I, e[l + 184 >> 2], Q, y), e[S + 4 >> 2] = Ci, bf(l + 200 | 0, l + 16 | 0, e[l + 12 >> 2], Q), e[5996] = 0, y = wn(186, l + 220 | 0, l + 216 | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) != 1) {
                    y && (e[Q >> 2] = e[Q >> 2] | 2), y = e[l + 220 >> 2], Yo(C), Yo(l + 200 | 0), bi = l + 224 | 0;
                    break e;
                  }
                }
                y = gi() | 0, Yo(C), Yo(l + 200 | 0), ss(y | 0), jn();
              }
              return y | 0;
            }
            function Xc(l, y) {
              var I = 0, C = 0, Q = 0, S = 0, me = 0, ke = 0, Ar = 0, br = 0, Qr = 0;
              e: {
                if (!l) {
                  l = Su(8, y);
                  break e;
                }
                if (!y) {
                  Tr(l), l = 0;
                  break e;
                }
                t: {
                  if (y >>> 0 > 4294967239)
                    break t;
                  ke = y >>> 0 <= 8 ? 8 : y + 3 & -4, y = ke + 8 | 0;
                  r: {
                    i: {
                      Qr = l - 4 | 0, S = Qr, Q = e[S >> 2], I = Q + S | 0, br = e[I >> 2], me = br + I | 0;
                      n: {
                        o: {
                          if (e[me - 4 >> 2] != (br | 0)) {
                            if (C = y + S | 0, C + 16 >>> 0 <= me >>> 0) {
                              Q = e[I + 4 >> 2], e[Q + 8 >> 2] = e[I + 8 >> 2], e[e[I + 8 >> 2] + 4 >> 2] = Q, I = me - C | 0, e[C >> 2] = I, e[(C + (I & -4) | 0) - 4 >> 2] = I | 1, Q = e[C >> 2] - 8 | 0;
                              a: {
                                if (Q >>> 0 <= 127) {
                                  I = (Q >>> 3 | 0) - 1 | 0;
                                  break a;
                                }
                                if (me = Ha(Q), I = ((Q >>> 29 - me ^ 4) - (me << 2) | 0) + 110 | 0, Q >>> 0 <= 4095)
                                  break a;
                                I = ((Q >>> 30 - me ^ 2) - (me << 1) | 0) + 71 | 0, I = I >>> 0 >= 63 ? 63 : I;
                              }
                              Q = I << 4, e[C + 4 >> 2] = Q + 22944, Q = Q + 22952 | 0, e[C + 8 >> 2] = e[Q >> 2], e[Q >> 2] = C, e[e[C + 8 >> 2] + 4 >> 2] = C, Q = e[5995], C = I & 31, (I & 63) >>> 0 >= 32 ? (I = 1 << C, me = 0) : (me = 1 << C, I = me - 1 & 1 >>> 32 - C), e[5994] = me | e[5994], e[5995] = I | Q, e[S >> 2] = y;
                              break i;
                            }
                            if (C >>> 0 > me >>> 0)
                              break o;
                            y = e[I + 4 >> 2], e[y + 8 >> 2] = e[I + 8 >> 2], e[e[I + 8 >> 2] + 4 >> 2] = y, y = Q + br | 0, e[S >> 2] = y;
                            break i;
                          }
                          if (Q >>> 0 >= y + 16 >>> 0) {
                            e[S >> 2] = y, e[(S + (y & -4) | 0) - 4 >> 2] = y, C = y + S | 0, y = Q - y | 0, e[C >> 2] = y, e[(C + (y & -4) | 0) - 4 >> 2] = y | 1, I = e[C >> 2] - 8 | 0;
                            a: {
                              if (I >>> 0 <= 127) {
                                y = (I >>> 3 | 0) - 1 | 0;
                                break a;
                              }
                              if (S = Ha(I), y = ((I >>> 29 - S ^ 4) - (S << 2) | 0) + 110 | 0, I >>> 0 <= 4095)
                                break a;
                              y = ((I >>> 30 - S ^ 2) - (S << 1) | 0) + 71 | 0, y = y >>> 0 >= 63 ? 63 : y;
                            }
                            I = y << 4, e[C + 4 >> 2] = I + 22944, I = I + 22952 | 0, e[C + 8 >> 2] = e[I >> 2], e[I >> 2] = C, e[e[C + 8 >> 2] + 4 >> 2] = C, I = e[5995], C = y & 31, (y & 63) >>> 0 >= 32 ? (y = 1 << C, Q = 0) : (Q = 1 << C, y = Q - 1 & 1 >>> 32 - C), e[5994] = Q | e[5994], e[5995] = y | I, C = 1;
                            break r;
                          }
                          if (C = 1, y >>> 0 <= Q >>> 0)
                            break n;
                        }
                        C = 0;
                      }
                      break r;
                    }
                    e[(S + (y & -4) | 0) - 4 >> 2] = y, C = 1;
                  }
                  if (C)
                    break e;
                  if (y = Su(8, ke), !y)
                    break t;
                  Ar = e[Qr >> 2] - 8 | 0, Sa(y, l, ke >>> 0 < Ar >>> 0 ? ke : Ar), Tr(l), Ar = y;
                }
                l = Ar;
              }
              return l;
            }
            function Zc(l, y) {
              l = l | 0, y = y | 0;
              var I = 0, C = 0, Q = 0, S = 0, me = 0, ke = 0, Ar = 0;
              C = bi - 160 | 0, bi = C, e[C + 72 >> 2] = 8356, e[C + 16 >> 2] = 8336, ke = C + 72 | 0, I = ke, e[I + 20 >> 2] = 0, Q = C + 20 | 0, e[I + 24 >> 2] = Q, e[I + 12 >> 2] = 0, e[I + 4 >> 2] = 4098, e[I + 8 >> 2] = 6, e[I + 16 >> 2] = !Q, jr(I + 32 | 0, 0, 40), Cd(I + 28 | 0), e[C + 72 >> 2] = 8316, e[C + 16 >> 2] = 8296, e[C + 144 >> 2] = 0, e[C + 148 >> 2] = -1, e[Q >> 2] = 7896, Cd(Q + 4 | 0), e[Q + 24 >> 2] = 0, e[Q + 28 >> 2] = 0, e[Q + 16 >> 2] = 0, e[Q + 20 >> 2] = 0, e[Q + 8 >> 2] = 0, e[Q + 12 >> 2] = 0, e[Q >> 2] = 7960, e[C + 60 >> 2] = 0, e[C + 64 >> 2] = 0, e[C + 52 >> 2] = 0, e[C + 56 >> 2] = 0, e[C + 68 >> 2] = 16, I = e[e[C + 16 >> 2] - 12 >> 2], e[5996] = 0, me = yi(129) | 0, S = e[5996], e[5996] = 0;
              e: {
                t: {
                  if ((S | 0) == 1)
                    break t;
                  S = I + (C + 16 | 0) | 0, I = e[S + 28 >> 2], e[C + 12 >> 2] = I, e[I + 4 >> 2] = e[I + 4 >> 2] + 1, e[5996] = 0, Ms(130, C + 156 | 0, S | 0, me | 0), I = e[5996], e[5996] = 0;
                  r: {
                    if ((I | 0) == 1)
                      break r;
                    if (I = e[C + 156 >> 2], Ar = e[I + 4 >> 2] - 1 | 0, e[I + 4 >> 2] = Ar, (Ar | 0) == -1 && Yn[e[e[I >> 2] + 8 >> 2]](I), I = e[S + 24 >> 2], I) {
                      if (S = e[e[I >> 2] + 8 >> 2], e[5996] = 0, Co(S | 0, I | 0, me | 0), S = e[5996], e[5996] = 0, (S | 0) == 1)
                        break r;
                      S = e[I + 4 >> 2], e[C + 152 >> 2] = S, e[S + 4 >> 2] = e[S + 4 >> 2] + 1, Ed(I + 4 | 0, me), I = e[C + 152 >> 2], me = e[I + 4 >> 2] - 1 | 0, e[I + 4 >> 2] = me, (me | 0) == -1 && Yn[e[e[I >> 2] + 8 >> 2]](I);
                    }
                    if (I = e[C + 12 >> 2], me = e[I + 4 >> 2] - 1 | 0, e[I + 4 >> 2] = me, (me | 0) == -1 && Yn[e[e[I >> 2] + 8 >> 2]](I), y = e[y >> 2], e[5996] = 0, y = wn(131, C + 16 | 0, y | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1 || (e[5996] = 0, Co(132, l | 0, Q | 0), l = e[5996], e[5996] = 0, (l | 0) == 1))
                      break t;
                    e[y >> 2] = 8296, e[C + 72 >> 2] = 8316, e[Q >> 2] = 7960, Se[y + 47 | 0] < 0 && Tr(e[C + 52 >> 2]), $h(Q), Y1(ke), bi = C + 160 | 0;
                    return;
                  }
                  l = gi() | 0, y = e[C + 12 >> 2], Q = e[y + 4 >> 2] - 1 | 0, e[y + 4 >> 2] = Q, (Q | 0) == -1 && Yn[e[e[y >> 2] + 8 >> 2]](y);
                  break e;
                }
                l = gi() | 0;
              }
              Zl(C + 16 | 0), ss(l | 0), jn();
            }
            function cu(l, y, I, C, Q, S) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0;
              var me = 0, ke = 0;
              me = e[C + 4 >> 2], C = e[C + 28 >> 2], l = bi - 224 | 0, bi = l, e[l + 216 >> 2] = I, e[l + 220 >> 2] = y, y = jc(me), zn(l + 200 | 0, C, l + 215 | 0), C = l + 188 | 0, e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[C + 8 >> 2] = 0, I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? (e[C + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, Co(172, C | 0, I | 0), I = e[5996], e[5996] = 0;
              e: {
                t: {
                  r: {
                    if ((I | 0) != 1) {
                      for (I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? e[C >> 2] : C, e[l + 184 >> 2] = I, e[l + 12 >> 2] = l + 16, e[l + 8 >> 2] = 0; ; ) {
                        i: {
                          if (e[5996] = 0, me = wn(186, l + 220 | 0, l + 216 | 0) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                            break i;
                          if (me)
                            break r;
                          if (me = Je[C + 11 | 0], me = (me & 128) >>> 7 | 0 ? e[C + 4 >> 2] : me & 127, e[l + 184 >> 2] == (me + I | 0)) {
                            if (e[5996] = 0, Co(172, C | 0, me << 1), I = e[5996], e[5996] = 0, (I | 0) == 1 || (I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? (e[C + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, Co(172, C | 0, I | 0), I = e[5996], e[5996] = 0, (I | 0) == 1))
                              break t;
                            I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? e[C >> 2] : C, e[l + 184 >> 2] = me + I;
                          }
                          if (e[5996] = 0, me = no(187, e[l + 220 >> 2]) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                            break i;
                          if (Mi(me, y, I, l + 184 | 0, l + 8 | 0, Se[l + 215 | 0], e[l + 204 >> 2], Je[l + 211 | 0], l + 16 | 0, l + 12 | 0, 12416))
                            break r;
                          if (e[5996] = 0, no(189, l + 220 | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) != 1)
                            continue;
                        }
                        break;
                      }
                      break t;
                    }
                    break t;
                  }
                  me = Je[l + 211 | 0];
                  r: {
                    if (!((me & 128) >>> 7 | 0 ? e[l + 204 >> 2] : me & 127) || (me = e[l + 12 >> 2], (me - (l + 16 | 0) | 0) > 159))
                      break r;
                    e[l + 12 >> 2] = me + 4, e[me >> 2] = e[l + 8 >> 2];
                  }
                  if (e[S >> 2] = Vf(I, e[l + 184 >> 2], Q, y), bf(l + 200 | 0, l + 16 | 0, e[l + 12 >> 2], Q), e[5996] = 0, y = wn(186, l + 220 | 0, l + 216 | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) != 1) {
                    y && (e[Q >> 2] = e[Q >> 2] | 2), y = e[l + 220 >> 2], Yo(C), Yo(l + 200 | 0), bi = l + 224 | 0;
                    break e;
                  }
                }
                y = gi() | 0, Yo(C), Yo(l + 200 | 0), ss(y | 0), jn();
              }
              return y | 0;
            }
            function Sl(l, y, I, C, Q, S) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0;
              var me = 0, ke = 0;
              me = e[C + 4 >> 2], C = e[C + 28 >> 2], l = bi - 224 | 0, bi = l, e[l + 216 >> 2] = I, e[l + 220 >> 2] = y, y = jc(me), zn(l + 200 | 0, C, l + 215 | 0), C = l + 188 | 0, e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[C + 8 >> 2] = 0, I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? (e[C + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, Co(172, C | 0, I | 0), I = e[5996], e[5996] = 0;
              e: {
                t: {
                  r: {
                    if ((I | 0) != 1) {
                      for (I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? e[C >> 2] : C, e[l + 184 >> 2] = I, e[l + 12 >> 2] = l + 16, e[l + 8 >> 2] = 0; ; ) {
                        i: {
                          if (e[5996] = 0, me = wn(186, l + 220 | 0, l + 216 | 0) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                            break i;
                          if (me)
                            break r;
                          if (me = Je[C + 11 | 0], me = (me & 128) >>> 7 | 0 ? e[C + 4 >> 2] : me & 127, e[l + 184 >> 2] == (me + I | 0)) {
                            if (e[5996] = 0, Co(172, C | 0, me << 1), I = e[5996], e[5996] = 0, (I | 0) == 1 || (I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? (e[C + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, Co(172, C | 0, I | 0), I = e[5996], e[5996] = 0, (I | 0) == 1))
                              break t;
                            I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? e[C >> 2] : C, e[l + 184 >> 2] = me + I;
                          }
                          if (e[5996] = 0, me = no(187, e[l + 220 >> 2]) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                            break i;
                          if (Mi(me, y, I, l + 184 | 0, l + 8 | 0, Se[l + 215 | 0], e[l + 204 >> 2], Je[l + 211 | 0], l + 16 | 0, l + 12 | 0, 12416))
                            break r;
                          if (e[5996] = 0, no(189, l + 220 | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) != 1)
                            continue;
                        }
                        break;
                      }
                      break t;
                    }
                    break t;
                  }
                  me = Je[l + 211 | 0];
                  r: {
                    if (!((me & 128) >>> 7 | 0 ? e[l + 204 >> 2] : me & 127) || (me = e[l + 12 >> 2], (me - (l + 16 | 0) | 0) > 159))
                      break r;
                    e[l + 12 >> 2] = me + 4, e[me >> 2] = e[l + 8 >> 2];
                  }
                  if (e[S >> 2] = Po(I, e[l + 184 >> 2], Q, y), bf(l + 200 | 0, l + 16 | 0, e[l + 12 >> 2], Q), e[5996] = 0, y = wn(186, l + 220 | 0, l + 216 | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) != 1) {
                    y && (e[Q >> 2] = e[Q >> 2] | 2), y = e[l + 220 >> 2], Yo(C), Yo(l + 200 | 0), bi = l + 224 | 0;
                    break e;
                  }
                }
                y = gi() | 0, Yo(C), Yo(l + 200 | 0), ss(y | 0), jn();
              }
              return y | 0;
            }
            function eA(l, y, I, C, Q, S) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0;
              var me = 0, ke = 0;
              me = e[C + 4 >> 2], C = e[C + 28 >> 2], l = bi - 224 | 0, bi = l, e[l + 216 >> 2] = I, e[l + 220 >> 2] = y, y = jc(me), zn(l + 200 | 0, C, l + 215 | 0), C = l + 188 | 0, e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[C + 8 >> 2] = 0, I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? (e[C + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, Co(172, C | 0, I | 0), I = e[5996], e[5996] = 0;
              e: {
                t: {
                  r: {
                    if ((I | 0) != 1) {
                      for (I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? e[C >> 2] : C, e[l + 184 >> 2] = I, e[l + 12 >> 2] = l + 16, e[l + 8 >> 2] = 0; ; ) {
                        i: {
                          if (e[5996] = 0, me = wn(186, l + 220 | 0, l + 216 | 0) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                            break i;
                          if (me)
                            break r;
                          if (me = Je[C + 11 | 0], me = (me & 128) >>> 7 | 0 ? e[C + 4 >> 2] : me & 127, e[l + 184 >> 2] == (me + I | 0)) {
                            if (e[5996] = 0, Co(172, C | 0, me << 1), I = e[5996], e[5996] = 0, (I | 0) == 1 || (I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? (e[C + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, Co(172, C | 0, I | 0), I = e[5996], e[5996] = 0, (I | 0) == 1))
                              break t;
                            I = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? e[C >> 2] : C, e[l + 184 >> 2] = me + I;
                          }
                          if (e[5996] = 0, me = no(187, e[l + 220 >> 2]) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                            break i;
                          if (Mi(me, y, I, l + 184 | 0, l + 8 | 0, Se[l + 215 | 0], e[l + 204 >> 2], Je[l + 211 | 0], l + 16 | 0, l + 12 | 0, 12416))
                            break r;
                          if (e[5996] = 0, no(189, l + 220 | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) != 1)
                            continue;
                        }
                        break;
                      }
                      break t;
                    }
                    break t;
                  }
                  me = Je[l + 211 | 0];
                  r: {
                    if (!((me & 128) >>> 7 | 0 ? e[l + 204 >> 2] : me & 127) || (me = e[l + 12 >> 2], (me - (l + 16 | 0) | 0) > 159))
                      break r;
                    e[l + 12 >> 2] = me + 4, e[me >> 2] = e[l + 8 >> 2];
                  }
                  if (ea[S >> 1] = ua(I, e[l + 184 >> 2], Q, y), bf(l + 200 | 0, l + 16 | 0, e[l + 12 >> 2], Q), e[5996] = 0, y = wn(186, l + 220 | 0, l + 216 | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) != 1) {
                    y && (e[Q >> 2] = e[Q >> 2] | 2), y = e[l + 220 >> 2], Yo(C), Yo(l + 200 | 0), bi = l + 224 | 0;
                    break e;
                  }
                }
                y = gi() | 0, Yo(C), Yo(l + 200 | 0), ss(y | 0), jn();
              }
              return y | 0;
            }
            function yc(l, y, I, C, Q, S, me, ke) {
              var Ar = 0, br = 0, Qr = 0;
              if (Ar = bi - 16 | 0, bi = Ar, e[Ar + 8 >> 2] = I, e[Ar + 12 >> 2] = y, y = e[C + 28 >> 2], e[Ar + 4 >> 2] = y, e[y + 4 >> 2] = e[y + 4 >> 2] + 1, y = 0, e[5996] = 0, br = no(197, e[Ar + 4 >> 2]) | 0, I = e[5996], e[5996] = 0, (I | 0) != 1) {
                I = e[Ar + 4 >> 2], Qr = e[I + 4 >> 2] - 1 | 0, e[I + 4 >> 2] = Qr, (Qr | 0) == -1 && Yn[e[e[I >> 2] + 8 >> 2]](I), e[Q >> 2] = 0;
                e: {
                  for (; ; ) {
                    if (y | (me | 0) == (ke | 0))
                      break e;
                    t: {
                      if (Dc(Ar + 12 | 0, Ar + 8 | 0))
                        break t;
                      r: {
                        if ((Yn[e[e[br >> 2] + 52 >> 2]](br, e[me >> 2], 0) | 0) == 37) {
                          if ((me + 4 | 0) == (ke | 0))
                            break t;
                          y = Yn[e[e[br >> 2] + 52 >> 2]](br, e[me + 4 >> 2], 0) | 0;
                          i: {
                            if (!((y | 0) == 69 | (y & 255) == 48)) {
                              I = 0, Qr = 1;
                              break i;
                            }
                            if ((me + 8 | 0) == (ke | 0))
                              break t;
                            I = y, y = Yn[e[e[br >> 2] + 52 >> 2]](br, e[me + 8 >> 2], 0) | 0, Qr = 2;
                          }
                          e[Ar + 12 >> 2] = Yn[e[e[l >> 2] + 36 >> 2]](l, e[Ar + 12 >> 2], e[Ar + 8 >> 2], C, Q, S, y, I), me = ((Qr << 2) + me | 0) + 4 | 0;
                          break r;
                        }
                        if (Yn[e[e[br >> 2] + 12 >> 2]](br, 1, e[me >> 2]) | 0) {
                          for (; ; ) {
                            i: {
                              if (me = me + 4 | 0, (ke | 0) == (me | 0)) {
                                me = ke;
                                break i;
                              }
                              if (Yn[e[e[br >> 2] + 12 >> 2]](br, 1, e[me >> 2]) | 0)
                                continue;
                            }
                            break;
                          }
                          for (; ; ) {
                            if (Qr = Ar + 12 | 0, Dc(Qr, Ar + 8 | 0))
                              break r;
                            y = e[Ar + 12 >> 2], I = e[y + 12 >> 2];
                            i: {
                              if ((I | 0) == e[y + 16 >> 2]) {
                                y = Yn[e[e[y >> 2] + 36 >> 2]](y) | 0;
                                break i;
                              }
                              y = e[I >> 2];
                            }
                            if (!(Yn[e[e[br >> 2] + 12 >> 2]](br, 1, y) | 0))
                              break r;
                            vh(Qr);
                          }
                        }
                        y = e[Ar + 12 >> 2], I = e[y + 12 >> 2];
                        i: {
                          if ((I | 0) == e[y + 16 >> 2]) {
                            y = Yn[e[e[y >> 2] + 36 >> 2]](y) | 0;
                            break i;
                          }
                          y = e[I >> 2];
                        }
                        if ((Yn[e[e[br >> 2] + 28 >> 2]](br, y) | 0) == (Yn[e[e[br >> 2] + 28 >> 2]](br, e[me >> 2]) | 0)) {
                          me = me + 4 | 0, vh(Ar + 12 | 0);
                          break r;
                        }
                        e[Q >> 2] = 4;
                      }
                      y = e[Q >> 2];
                      continue;
                    }
                    break;
                  }
                  e[Q >> 2] = 4;
                }
                return Dc(Ar + 12 | 0, Ar + 8 | 0) && (e[Q >> 2] = e[Q >> 2] | 2), bi = Ar + 16 | 0, e[Ar + 12 >> 2];
              }
              I = gi() | 0, l = e[Ar + 4 >> 2], y = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = y, (y | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), ss(I | 0), jn();
            }
            function xu(l, y, I, C, Q) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = +Q;
              var S = 0, me = 0, ke = 0, Ar = 0, br = 0, Qr = 0, Ur = 0, Xr = 0;
              Ur = y, S = bi - 208 | 0, bi = S, e[S + 200 >> 2] = 37, e[S + 204 >> 2] = 0, y = S + 200 | 0, ke = Gl(y | 1, 5575, e[I + 4 >> 2]), me = S + 160 | 0, e[S + 156 >> 2] = me, l = fi();
              e: {
                if (ke) {
                  Ar = e[I + 8 >> 2], zo[S + 40 >> 3] = Q, e[S + 32 >> 2] = Ar, me = qf(me, 30, l, y, S + 32 | 0);
                  break e;
                }
                zo[S + 48 >> 3] = Q, me = qf(S + 160 | 0, 30, l, S + 200 | 0, S + 48 | 0);
              }
              e[S + 80 >> 2] = 184, Ar = S + 148 | 0, e[Ar >> 2] = 0, e[Ar + 4 >> 2] = e[S + 80 >> 2], y = S + 160 | 0, l = y;
              e: {
                t: {
                  r: {
                    i: {
                      if ((me | 0) >= 30) {
                        l = fi();
                        n: {
                          if (ke) {
                            me = e[I + 8 >> 2], zo[S + 8 >> 3] = Q, e[S >> 2] = me, me = Hc(S + 156 | 0, l, S + 200 | 0, S);
                            break n;
                          }
                          zo[S + 16 >> 3] = Q, me = Hc(S + 156 | 0, l, S + 200 | 0, S + 16 | 0);
                        }
                        if ((me | 0) == -1) {
                          if (e[5996] = 0, jo(185), l = e[5996], e[5996] = 0, (l | 0) == 1)
                            break r;
                          break i;
                        }
                        l = e[S + 156 >> 2], _f(Ar, l);
                      }
                      Qr = l + me | 0, Xr = uc(l, Qr, e[I + 4 >> 2]), e[S + 68 >> 2] = 184, ke = S + 72 | 0, e[ke >> 2] = 0, e[ke + 4 >> 2] = e[S + 68 >> 2];
                      n: {
                        o: {
                          if ((S + 160 | 0) == (l | 0)) {
                            me = S + 80 | 0;
                            break o;
                          }
                          if (me = vf(me << 1), !me) {
                            if (e[5996] = 0, jo(185), l = e[5996], e[5996] = 0, (l | 0) != 1)
                              break i;
                            l = gi() | 0;
                            break n;
                          }
                          _f(ke, me), y = l;
                        }
                        l = S + 60 | 0, br = e[I + 28 >> 2], e[l >> 2] = br, e[br + 4 >> 2] = e[br + 4 >> 2] + 1, e[5996] = 0, jf(212, y | 0, Xr | 0, Qr | 0, me | 0, S + 68 | 0, S - -64 | 0, l | 0), y = e[5996], e[5996] = 0;
                        o: {
                          if ((y | 0) != 1) {
                            if (l = e[l >> 2], y = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = y, (y | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), e[5996] = 0, l = Cf(213, Ur | 0, me | 0, e[S + 68 >> 2], e[S + 64 >> 2], I | 0, C | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                              break o;
                            ka(ke), ka(Ar), bi = S + 208 | 0;
                            break e;
                          }
                          l = gi() | 0, y = e[S + 60 >> 2], I = e[y + 4 >> 2] - 1 | 0, e[y + 4 >> 2] = I, (I | 0) == -1 && Yn[e[e[y >> 2] + 8 >> 2]](y);
                          break n;
                        }
                        l = gi() | 0;
                      }
                      ka(ke);
                      break t;
                    }
                    jn();
                  }
                  l = gi() | 0;
                }
                ka(Ar), ss(l | 0), jn();
              }
              return l | 0;
            }
            function Mh(l, y, I, C, Q) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = +Q;
              var S = 0, me = 0, ke = 0, Ar = 0, br = 0, Qr = 0, Ur = 0, Xr = 0;
              Ur = y, S = bi - 368 | 0, bi = S, e[S + 360 >> 2] = 37, e[S + 364 >> 2] = 0, y = S + 360 | 0, ke = Gl(y | 1, 5575, e[I + 4 >> 2]), me = S + 320 | 0, e[S + 316 >> 2] = me, l = fi();
              e: {
                if (ke) {
                  Ar = e[I + 8 >> 2], zo[S + 40 >> 3] = Q, e[S + 32 >> 2] = Ar, me = qf(me, 30, l, y, S + 32 | 0);
                  break e;
                }
                zo[S + 48 >> 3] = Q, me = qf(S + 320 | 0, 30, l, S + 360 | 0, S + 48 | 0);
              }
              e[S + 80 >> 2] = 184, Ar = S + 308 | 0, e[Ar >> 2] = 0, e[Ar + 4 >> 2] = e[S + 80 >> 2], y = S + 320 | 0, l = y;
              e: {
                t: {
                  r: {
                    i: {
                      if ((me | 0) >= 30) {
                        l = fi();
                        n: {
                          if (ke) {
                            me = e[I + 8 >> 2], zo[S + 8 >> 3] = Q, e[S >> 2] = me, me = Hc(S + 316 | 0, l, S + 360 | 0, S);
                            break n;
                          }
                          zo[S + 16 >> 3] = Q, me = Hc(S + 316 | 0, l, S + 360 | 0, S + 16 | 0);
                        }
                        if ((me | 0) == -1) {
                          if (e[5996] = 0, jo(185), l = e[5996], e[5996] = 0, (l | 0) == 1)
                            break r;
                          break i;
                        }
                        l = e[S + 316 >> 2], _f(Ar, l);
                      }
                      Qr = l + me | 0, Xr = uc(l, Qr, e[I + 4 >> 2]), e[S + 68 >> 2] = 184, ke = S + 72 | 0, e[ke >> 2] = 0, e[ke + 4 >> 2] = e[S + 68 >> 2];
                      n: {
                        o: {
                          if ((S + 320 | 0) == (l | 0)) {
                            me = S + 80 | 0;
                            break o;
                          }
                          if (me = vf(me << 3), !me) {
                            if (e[5996] = 0, jo(185), l = e[5996], e[5996] = 0, (l | 0) != 1)
                              break i;
                            l = gi() | 0;
                            break n;
                          }
                          _f(ke, me), y = l;
                        }
                        l = S + 60 | 0, br = e[I + 28 >> 2], e[l >> 2] = br, e[br + 4 >> 2] = e[br + 4 >> 2] + 1, e[5996] = 0, jf(218, y | 0, Xr | 0, Qr | 0, me | 0, S + 68 | 0, S - -64 | 0, l | 0), y = e[5996], e[5996] = 0;
                        o: {
                          if ((y | 0) != 1) {
                            if (l = e[l >> 2], y = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = y, (y | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), e[5996] = 0, l = Cf(219, Ur | 0, me | 0, e[S + 68 >> 2], e[S + 64 >> 2], I | 0, C | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                              break o;
                            ka(ke), ka(Ar), bi = S + 368 | 0;
                            break e;
                          }
                          l = gi() | 0, y = e[S + 60 >> 2], I = e[y + 4 >> 2] - 1 | 0, e[y + 4 >> 2] = I, (I | 0) == -1 && Yn[e[e[y >> 2] + 8 >> 2]](y);
                          break n;
                        }
                        l = gi() | 0;
                      }
                      ka(ke);
                      break t;
                    }
                    jn();
                  }
                  l = gi() | 0;
                }
                ka(Ar), ss(l | 0), jn();
              }
              return l | 0;
            }
            function Wa(l, y, I, C, Q, S, me, ke) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0, me = me | 0, ke = ke | 0;
              var Ar = 0, br = 0, Qr = 0, Ur = 0, Xr = 0, Ri = 0, yn = 0, En = 0, Wn = 0, lo = 0, Ro = 0;
              for (Ri = bi - 16 | 0, bi = Ri, y = I; ; ) {
                e: {
                  if ((y | 0) == (C | 0)) {
                    y = C;
                    break e;
                  }
                  if (!e[y >> 2])
                    break e;
                  y = y + 4 | 0;
                  continue;
                }
                break;
              }
              for (e[ke >> 2] = S, e[Q >> 2] = I; ; ) {
                e: {
                  t: {
                    if (!((I | 0) == (C | 0) | (S | 0) == (me | 0))) {
                      Wn = 1, lo = bi - 16 | 0, bi = lo, Ro = Nc(lo + 12 | 0, e[l + 8 >> 2]), Ar = S, br = me - Ar | 0, Xr = 0, yn = bi - 16 | 0, bi = yn, Qr = e[Q >> 2], En = y - I >> 2;
                      r: {
                        if (!Qr | !En)
                          break r;
                        for (br = Ar ? br : 0; ; ) {
                          if (Ur = sf(br >>> 0 < 4 ? yn + 12 | 0 : Ar, e[Qr >> 2]), (Ur | 0) == -1) {
                            Xr = -1;
                            break r;
                          }
                          if (Ar) {
                            if (br >>> 0 <= 3) {
                              if (br >>> 0 < Ur >>> 0)
                                break r;
                              Sa(Ar, yn + 12 | 0, Ur);
                            }
                            br = br - Ur | 0, Ar = Ar + Ur | 0;
                          } else
                            Ar = 0;
                          if (!e[Qr >> 2]) {
                            Qr = 0;
                            break r;
                          }
                          if (Xr = Xr + Ur | 0, Qr = Qr + 4 | 0, En = En - 1 | 0, !En)
                            break;
                        }
                      }
                      Ar && (e[Q >> 2] = Qr), bi = yn + 16 | 0, Ar = e[Ro >> 2], Ar && (e[6178] = (Ar | 0) == -1 ? 24816 : Ar), bi = lo + 16 | 0;
                      r: {
                        i: {
                          n: {
                            o:
                              switch (Xr + 1 | 0) {
                                case 0:
                                  for (e[ke >> 2] = S; ; ) {
                                    a: {
                                      if (e[Q >> 2] == (I | 0) || (y = b1(S, e[I >> 2], e[l + 8 >> 2]), (y | 0) == -1))
                                        break a;
                                      S = y + e[ke >> 2] | 0, e[ke >> 2] = S, I = I + 4 | 0;
                                      continue;
                                    }
                                    break;
                                  }
                                  e[Q >> 2] = I;
                                  break n;
                                case 1:
                                  break t;
                                default:
                                  break o;
                              }
                            if (S = Xr + e[ke >> 2] | 0, e[ke >> 2] = S, (S | 0) == (me | 0))
                              break r;
                            if ((y | 0) == (C | 0)) {
                              I = e[Q >> 2], y = C;
                              continue;
                            }
                            if (y = b1(Ri + 12 | 0, 0, e[l + 8 >> 2]), (y | 0) != -1)
                              break i;
                          }
                          Wn = 2;
                          break t;
                        }
                        if (I = Ri + 12 | 0, me - e[ke >> 2] >>> 0 < y >>> 0)
                          break t;
                        for (; ; ) {
                          if (y) {
                            S = Je[I | 0], Ar = e[ke >> 2], e[ke >> 2] = Ar + 1, Se[Ar | 0] = S, y = y - 1 | 0, I = I + 1 | 0;
                            continue;
                          }
                          break;
                        }
                        for (I = e[Q >> 2] + 4 | 0, e[Q >> 2] = I, y = I; ; ) {
                          if ((y | 0) == (C | 0)) {
                            y = C;
                            break e;
                          }
                          if (!e[y >> 2])
                            break e;
                          y = y + 4 | 0;
                        }
                      }
                      I = e[Q >> 2];
                    }
                    Wn = (I | 0) != (C | 0);
                  }
                  return bi = Ri + 16 | 0, Wn | 0;
                }
                S = e[ke >> 2];
              }
            }
            function eu(l, y, I, C, Q, S, me) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0, me = me | 0;
              var ke = 0, Ar = 0, br = 0, Qr = 0, Ur = 0, Xr = 0, Ri = 0, yn = 0;
              Qr = bi - 16 | 0, bi = Qr, Xr = L1(e[me >> 2]), me = H1(e[me >> 2]), Yn[e[e[me >> 2] + 20 >> 2]](Qr + 4 | 0, me);
              e: {
                br = Je[Qr + 15 | 0];
                t: {
                  if (!((br & 128) >>> 7 | 0 ? e[Qr + 8 >> 2] : br & 127)) {
                    if (e[5996] = 0, ia(208, Xr | 0, l | 0, I | 0, C | 0), me = e[5996], e[5996] = 0, (me | 0) == 1)
                      break t;
                    me = (I - l << 2) + C | 0, e[S >> 2] = me;
                    break e;
                  }
                  e[S >> 2] = C;
                  r: {
                    i:
                      switch (br = l, Ar = Je[br | 0], Ar - 43 | 0) {
                        case 0:
                        case 2:
                          break i;
                        default:
                          break r;
                      }
                    if (e[5996] = 0, br = wn(216, Xr | 0, Ar << 24 >> 24) | 0, Ar = e[5996], e[5996] = 0, (Ar | 0) == 1)
                      break t;
                    Ar = e[S >> 2], e[S >> 2] = Ar + 4, e[Ar >> 2] = br, br = l + 1 | 0;
                  }
                  if (!(Je[br | 0] != 48 | (I - br | 0) < 2 | (Je[br + 1 | 0] | 32) != 120)) {
                    if (e[5996] = 0, Ar = wn(216, Xr | 0, 48) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1 || (ke = e[S >> 2], e[S >> 2] = ke + 4, e[ke >> 2] = Ar, Ar = Se[br + 1 | 0], e[5996] = 0, Ar = wn(216, Xr | 0, Ar | 0) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1))
                      break t;
                    ke = e[S >> 2], e[S >> 2] = ke + 4, e[ke >> 2] = Ar, br = br + 2 | 0;
                  }
                  if (Uu(br, I), e[5996] = 0, yn = no(206, me | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                    break t;
                  for (Ar = 0, me = br; ; ) {
                    if (I >>> 0 <= me >>> 0) {
                      Xl((br - l << 2) + C | 0, e[S >> 2]), me = e[S >> 2];
                      break e;
                    }
                    if (ke = Qr + 4 | 0, Ur = (Je[ke + 11 | 0] & 128) >>> 7 | 0, !Je[(Ur ? e[ke >> 2] : ke) + Ar | 0] | Se[(Ur ? e[ke >> 2] : ke) + Ar | 0] != (Ri | 0) || (ke = e[S >> 2], e[S >> 2] = ke + 4, e[ke >> 2] = yn, Ri = 0, Ur = Ar, Ar = Je[Qr + 15 | 0], Ar = Ur + (Ur >>> 0 < ((Ar & 128) >>> 7 | 0 ? e[Qr + 8 >> 2] : Ar & 127) - 1 >>> 0) | 0), ke = Se[me | 0], e[5996] = 0, ke = wn(216, Xr | 0, ke | 0) | 0, Ur = e[5996], e[5996] = 0, (Ur | 0) != 1) {
                      Ur = e[S >> 2], e[S >> 2] = Ur + 4, e[Ur >> 2] = ke, me = me + 1 | 0, Ri = Ri + 1 | 0;
                      continue;
                    }
                    break;
                  }
                }
                l = gi() | 0, Yo(Qr + 4 | 0), ss(l | 0), jn();
              }
              e[Q >> 2] = (y | 0) == (I | 0) ? me : (y - l << 2) + C | 0, Yo(Qr + 4 | 0), bi = Qr + 16 | 0;
            }
            function Tl(l, y, I, C, Q, S, me) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0, me = me | 0;
              var ke = 0, Ar = 0, br = 0, Qr = 0, Ur = 0, Xr = 0, Ri = 0, yn = 0;
              Qr = bi - 16 | 0, bi = Qr, Xr = Q1(e[me >> 2]), me = q1(e[me >> 2]), Yn[e[e[me >> 2] + 20 >> 2]](Qr + 4 | 0, me);
              e: {
                br = Je[Qr + 15 | 0];
                t: {
                  if (!((br & 128) >>> 7 | 0 ? e[Qr + 8 >> 2] : br & 127)) {
                    if (e[5996] = 0, ia(195, Xr | 0, l | 0, I | 0, C | 0), me = e[5996], e[5996] = 0, (me | 0) == 1)
                      break t;
                    me = (I - l | 0) + C | 0, e[S >> 2] = me;
                    break e;
                  }
                  e[S >> 2] = C;
                  r: {
                    i:
                      switch (br = l, Ar = Je[br | 0], Ar - 43 | 0) {
                        case 0:
                        case 2:
                          break i;
                        default:
                          break r;
                      }
                    if (e[5996] = 0, br = wn(171, Xr | 0, Ar << 24 >> 24) | 0, Ar = e[5996], e[5996] = 0, (Ar | 0) == 1)
                      break t;
                    Ar = e[S >> 2], e[S >> 2] = Ar + 1, Se[Ar | 0] = br, br = l + 1 | 0;
                  }
                  if (!(Je[br | 0] != 48 | (I - br | 0) < 2 | (Je[br + 1 | 0] | 32) != 120)) {
                    if (e[5996] = 0, Ar = wn(171, Xr | 0, 48) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1 || (ke = e[S >> 2], e[S >> 2] = ke + 1, Se[ke | 0] = Ar, Ar = Se[br + 1 | 0], e[5996] = 0, Ar = wn(171, Xr | 0, Ar | 0) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1))
                      break t;
                    ke = e[S >> 2], e[S >> 2] = ke + 1, Se[ke | 0] = Ar, br = br + 2 | 0;
                  }
                  if (Uu(br, I), e[5996] = 0, yn = no(193, me | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                    break t;
                  for (Ar = 0, me = br; ; ) {
                    if (I >>> 0 <= me >>> 0) {
                      Uu((br - l | 0) + C | 0, e[S >> 2]), me = e[S >> 2];
                      break e;
                    }
                    if (ke = Qr + 4 | 0, Ur = (Je[ke + 11 | 0] & 128) >>> 7 | 0, !Je[(Ur ? e[ke >> 2] : ke) + Ar | 0] | Se[(Ur ? e[ke >> 2] : ke) + Ar | 0] != (Ri | 0) || (ke = e[S >> 2], e[S >> 2] = ke + 1, Se[ke | 0] = yn, Ri = 0, Ur = Ar, Ar = Je[Qr + 15 | 0], Ar = Ur + (Ur >>> 0 < ((Ar & 128) >>> 7 | 0 ? e[Qr + 8 >> 2] : Ar & 127) - 1 >>> 0) | 0), ke = Se[me | 0], e[5996] = 0, ke = wn(171, Xr | 0, ke | 0) | 0, Ur = e[5996], e[5996] = 0, (Ur | 0) != 1) {
                      Ur = e[S >> 2], e[S >> 2] = Ur + 1, Se[Ur | 0] = ke, me = me + 1 | 0, Ri = Ri + 1 | 0;
                      continue;
                    }
                    break;
                  }
                }
                l = gi() | 0, Yo(Qr + 4 | 0), ss(l | 0), jn();
              }
              e[Q >> 2] = (y | 0) == (I | 0) ? me : (y - l | 0) + C | 0, Yo(Qr + 4 | 0), bi = Qr + 16 | 0;
            }
            function Ru(l, y, I, C, Q, S, me, ke) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0, me = me | 0, ke = ke | 0;
              var Ar = 0, br = 0, Qr = 0;
              l = bi - 16 | 0, bi = l, e[l + 12 >> 2] = I, e[l + 8 >> 2] = S, e[l + 12 >> 2] = I, e[l + 8 >> 2] = S;
              e: {
                t: {
                  r: {
                    for (; ; ) {
                      if (I = e[l + 12 >> 2], !(I >>> 0 >= C >>> 0 | S >>> 0 >= me >>> 0)) {
                        Ar = Se[I | 0], br = Ar & 255;
                        i: {
                          if ((Ar | 0) >= 0) {
                            ea[S >> 1] = br, y = I + 1 | 0;
                            break i;
                          }
                          if (y = 2, Ar >>> 0 < 4294967234)
                            break t;
                          if (Ar >>> 0 <= 4294967263) {
                            if ((C - I | 0) < 2)
                              break r;
                            if (Ar = Je[I + 1 | 0], (Ar & 192) != 128)
                              break e;
                            ea[S >> 1] = Ar & 63 | br << 6 & 1984, y = I + 2 | 0;
                            break i;
                          }
                          if (Ar >>> 0 <= 4294967279) {
                            if ((C - I | 0) < 3)
                              break r;
                            Qr = Je[I + 2 | 0], Ar = Je[I + 1 | 0];
                            n: {
                              o: {
                                if ((br | 0) != 237) {
                                  if ((br | 0) != 224)
                                    break o;
                                  if ((Ar & 224) == 160)
                                    break n;
                                  break e;
                                }
                                if ((Ar & 224) == 128)
                                  break n;
                                break e;
                              }
                              if ((Ar & 192) != 128)
                                break e;
                            }
                            if ((Qr & 192) != 128)
                              break e;
                            ea[S >> 1] = Qr & 63 | ((Ar & 63) << 6 | br << 12), y = I + 3 | 0;
                            break i;
                          }
                          if (Ar >>> 0 > 4294967284)
                            break t;
                          if (y = 1, (C - I | 0) < 4)
                            break e;
                          Qr = Je[I + 3 | 0], Ar = Je[I + 2 | 0], I = Je[I + 1 | 0];
                          n: {
                            o:
                              switch (br - 240 | 0) {
                                case 0:
                                  if ((I + 112 & 255) >>> 0 >= 48)
                                    break t;
                                  break n;
                                case 4:
                                  if ((I & 240) != 128)
                                    break t;
                                  break n;
                                default:
                                  break o;
                              }
                            if ((I & 192) != 128)
                              break t;
                          }
                          if ((Ar & 192) != 128 | (Qr & 192) != 128)
                            break t;
                          if ((me - S | 0) < 4 || (y = 2, br = br & 7, (I << 12 & 196608 | br << 18) >>> 0 > 1114111))
                            break e;
                          y = I << 2, ea[S >> 1] = (Ar >>> 4 & 3 | (y & 192 | br << 8 | y & 60)) + 16320 | 55296, e[l + 8 >> 2] = S + 2, ea[S + 2 >> 1] = Ar << 6 & 960 | Qr & 63 | 56320, y = e[l + 12 >> 2] + 4 | 0;
                        }
                        e[l + 12 >> 2] = y, S = e[l + 8 >> 2] + 2 | 0, e[l + 8 >> 2] = S;
                        continue;
                      }
                      break;
                    }
                    y = I >>> 0 < C >>> 0;
                    break e;
                  }
                  y = 1;
                  break e;
                }
                y = 2;
              }
              return e[Q >> 2] = e[l + 12 >> 2], e[ke >> 2] = e[l + 8 >> 2], bi = l + 16 | 0, y | 0;
            }
            function Dl(l, y, I, C, Q, S) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0;
              var me = 0, ke = 0;
              me = bi - 32 | 0, bi = me, e[me + 28 >> 2] = y;
              e: {
                t: {
                  if (!(Se[C + 4 | 0] & 1)) {
                    e[me >> 2] = -1, y = Yn[e[e[l >> 2] + 16 >> 2]](l, y, I, C, Q, me) | 0;
                    r:
                      switch (e[me >> 2]) {
                        case 1:
                          Se[S | 0] = 1;
                          break e;
                        case 0:
                          break t;
                        default:
                          break r;
                      }
                    Se[S | 0] = 1, e[Q >> 2] = 4;
                    break e;
                  }
                  l = e[C + 28 >> 2], e[me >> 2] = l, e[l + 4 >> 2] = e[l + 4 >> 2] + 1, e[5996] = 0, ke = no(197, e[me >> 2]) | 0, l = e[5996], e[5996] = 0;
                  r: {
                    i: {
                      n: {
                        o: {
                          if ((l | 0) != 1) {
                            if (l = e[me >> 2], y = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = y, (y | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), l = e[C + 28 >> 2], e[me >> 2] = l, e[l + 4 >> 2] = e[l + 4 >> 2] + 1, e[5996] = 0, y = no(198, e[me >> 2]) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1)
                              break o;
                            if (l = e[me >> 2], C = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = C, (C | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), e[5996] = 0, Co(199, me | 0, y | 0), l = e[5996], e[5996] = 0, (l | 0) == 1) {
                              y = gi() | 0;
                              break r;
                            }
                            if (e[5996] = 0, Co(200, me | 12, y | 0), l = e[5996], e[5996] = 0, (l | 0) == 1)
                              break n;
                            if (e[5996] = 0, C = me + 24 | 0, l = Bi(201, me + 28 | 0, I | 0, me | 0, C | 0, ke | 0, Q | 0, 1) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                              break i;
                            for (Se[S | 0] = (l | 0) == (me | 0), y = e[me + 28 >> 2]; C = Yo(C - 12 | 0), (me | 0) != (C | 0); )
                              ;
                            break e;
                          }
                          y = gi() | 0, l = e[me >> 2], I = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = I, (I | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l);
                          break r;
                        }
                        y = gi() | 0, l = e[me >> 2], I = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = I, (I | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l);
                        break r;
                      }
                      y = gi() | 0, Yo(me);
                      break r;
                    }
                    for (y = gi() | 0; C = Yo(C - 12 | 0), (me | 0) != (C | 0); )
                      ;
                  }
                  ss(y | 0), jn();
                }
                Se[S | 0] = 0;
              }
              return bi = me + 32 | 0, y | 0;
            }
            function Nh(l, y, I, C, Q, S) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0;
              var me = 0, ke = 0;
              me = bi - 32 | 0, bi = me, e[me + 28 >> 2] = y;
              e: {
                t: {
                  if (!(Se[C + 4 | 0] & 1)) {
                    e[me >> 2] = -1, y = Yn[e[e[l >> 2] + 16 >> 2]](l, y, I, C, Q, me) | 0;
                    r:
                      switch (e[me >> 2]) {
                        case 1:
                          Se[S | 0] = 1;
                          break e;
                        case 0:
                          break t;
                        default:
                          break r;
                      }
                    Se[S | 0] = 1, e[Q >> 2] = 4;
                    break e;
                  }
                  l = e[C + 28 >> 2], e[me >> 2] = l, e[l + 4 >> 2] = e[l + 4 >> 2] + 1, e[5996] = 0, ke = no(170, e[me >> 2]) | 0, l = e[5996], e[5996] = 0;
                  r: {
                    i: {
                      n: {
                        o: {
                          if ((l | 0) != 1) {
                            if (l = e[me >> 2], y = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = y, (y | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), l = e[C + 28 >> 2], e[me >> 2] = l, e[l + 4 >> 2] = e[l + 4 >> 2] + 1, e[5996] = 0, y = no(180, e[me >> 2]) | 0, l = e[5996], e[5996] = 0, (l | 0) == 1)
                              break o;
                            if (l = e[me >> 2], C = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = C, (C | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), e[5996] = 0, Co(181, me | 0, y | 0), l = e[5996], e[5996] = 0, (l | 0) == 1) {
                              y = gi() | 0;
                              break r;
                            }
                            if (e[5996] = 0, Co(182, me | 12, y | 0), l = e[5996], e[5996] = 0, (l | 0) == 1)
                              break n;
                            if (e[5996] = 0, C = me + 24 | 0, l = Bi(183, me + 28 | 0, I | 0, me | 0, C | 0, ke | 0, Q | 0, 1) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                              break i;
                            for (Se[S | 0] = (l | 0) == (me | 0), y = e[me + 28 >> 2]; C = Yo(C - 12 | 0), (me | 0) != (C | 0); )
                              ;
                            break e;
                          }
                          y = gi() | 0, l = e[me >> 2], I = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = I, (I | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l);
                          break r;
                        }
                        y = gi() | 0, l = e[me >> 2], I = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = I, (I | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l);
                        break r;
                      }
                      y = gi() | 0, Yo(me);
                      break r;
                    }
                    for (y = gi() | 0; C = Yo(C - 12 | 0), (me | 0) != (C | 0); )
                      ;
                  }
                  ss(y | 0), jn();
                }
                Se[S | 0] = 0;
              }
              return bi = me + 32 | 0, y | 0;
            }
            function sA(l, y, I, C) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0;
              var Q = 0, S = 0, me = 0, ke = 0, Ar = 0;
              Q = bi - 32 | 0, bi = Q;
              e: {
                t: {
                  r: {
                    if ((I | 0) <= 0)
                      break r;
                    for (; ; ) {
                      if (ke = y + me | 0, Je[ke | 0] != 41) {
                        if (me = me + 1 | 0, (I | 0) != (me | 0))
                          continue;
                        break r;
                      }
                      break;
                    }
                    if (me)
                      break t;
                  }
                  Se[l + 16 | 0] = 0, Se[l | 0] = 0;
                  break e;
                }
                if (me >>> 0 < 2147483632) {
                  t: {
                    if (me >>> 0 <= 10) {
                      Se[Q + 31 | 0] = me, I = Q + 20 | 0;
                      break t;
                    }
                    S = (me | 15) + 1 | 0, I = ga(S), e[Q + 28 >> 2] = S | -2147483648, e[Q + 20 >> 2] = I, e[Q + 24 >> 2] = me;
                  }
                  if (Ar = me & 7, Ar)
                    for (S = 0; Se[I | 0] = Je[y | 0], I = I + 1 | 0, y = y + 1 | 0, S = S + 1 | 0, (Ar | 0) != (S | 0); )
                      ;
                  if (me >>> 0 >= 8)
                    for (; Se[I | 0] = Je[y | 0], Se[I + 1 | 0] = Je[y + 1 | 0], Se[I + 2 | 0] = Je[y + 2 | 0], Se[I + 3 | 0] = Je[y + 3 | 0], Se[I + 4 | 0] = Je[y + 4 | 0], Se[I + 5 | 0] = Je[y + 5 | 0], Se[I + 6 | 0] = Je[y + 6 | 0], Se[I + 7 | 0] = Je[y + 7 | 0], I = I + 8 | 0, y = y + 8 | 0, (ke | 0) != (y | 0); )
                      ;
                  Se[I | 0] = 0, S = Je[Q + 31 | 0], I = S << 24 >> 24, y = (I | 0) < 0;
                  t: {
                    r: {
                      i: {
                        S = y ? e[Q + 24 >> 2] : S;
                        n: {
                          if (!S)
                            break n;
                          for (y = y ? e[Q + 20 >> 2] : Q + 20 | 0, ke = S + y | 0; ; ) {
                            if (Se[Je[y | 0] + 5584 | 0] < 0)
                              break n;
                            if (y = y + 1 | 0, (ke | 0) == (y | 0))
                              break;
                          }
                          if (!(S & 1))
                            break i;
                        }
                        Se[l + 16 | 0] = 0, Se[l | 0] = 0;
                        break r;
                      }
                      if (e[5996] = 0, Co(31, Q + 8 | 0, Q + 20 | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                        break t;
                      I = e[Q + 12 >> 2], y = e[Q + 8 >> 2];
                      i: {
                        if ((I - y | 0) == (C | 0)) {
                          C = e[Q + 16 >> 2], Se[l + 16 | 0] = 1, e[l + 12 >> 2] = me, e[l + 8 >> 2] = C, e[l + 4 >> 2] = I, e[l >> 2] = y;
                          break i;
                        }
                        if (Se[l + 16 | 0] = 0, Se[l | 0] = 0, !y)
                          break i;
                        Tr(y);
                      }
                      I = Je[Q + 31 | 0];
                    }
                    if (I << 24 >> 24 >= 0)
                      break e;
                    Tr(e[Q + 20 >> 2]);
                    break e;
                  }
                  l = gi() | 0, Se[Q + 31 | 0] < 0 && Tr(e[Q + 20 >> 2]), ss(l | 0), jn();
                }
                xf(), jn();
              }
              bi = Q + 32 | 0;
            }
            function lA(l, y, I, C, Q, S, me) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0, me = me | 0;
              var ke = 0, Ar = 0, br = 0, Qr = 0;
              if (l = bi - 144 | 0, bi = l, e[l + 136 >> 2] = I, e[l + 140 >> 2] = y, e[l + 20 >> 2] = 220, y = l + 24 | 0, e[y >> 2] = l + 32, Ar = l + 20 | 0, e[y + 4 >> 2] = e[Ar >> 2], br = l + 16 | 0, ke = e[Q + 28 >> 2], e[br >> 2] = ke, e[ke + 4 >> 2] = e[ke + 4 >> 2] + 1, e[5996] = 0, ke = no(170, e[l + 16 >> 2]) | 0, Qr = e[5996], e[5996] = 0, (Qr | 0) != 1)
                e: {
                  if (Se[l + 15 | 0] = 0, Q = e[Q + 4 >> 2], e[5996] = 0, I = Uc(221, l + 140 | 0, I | 0, C | 0, br | 0, Q | 0, S | 0, l + 15 | 0, ke | 0, y | 0, Ar | 0, l + 132 | 0) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                    break e;
                  t: {
                    r: {
                      if (!I)
                        break r;
                      i: {
                        if ((Je[me + 11 | 0] & 128) >>> 7 | 0) {
                          Se[e[me >> 2]] = 0, e[me + 4 >> 2] = 0;
                          break i;
                        }
                        Se[me | 0] = 0, Se[me + 11 | 0] = 0;
                      }
                      if (Je[l + 15 | 0] && (e[5996] = 0, I = wn(171, ke | 0, 45) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1 || (e[5996] = 0, Co(98, me | 0, I | 0), I = e[5996], e[5996] = 0, (I | 0) == 1)))
                        break e;
                      if (e[5996] = 0, C = wn(171, ke | 0, 48) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                        break t;
                      for (Q = e[l + 20 >> 2], ke = Q - 1 | 0, I = e[y >> 2], C = C & 255; ; ) {
                        if (!((C | 0) != Je[I | 0] | I >>> 0 >= ke >>> 0)) {
                          I = I + 1 | 0;
                          continue;
                        }
                        break;
                      }
                      if (e[5996] = 0, Ko(227, me | 0, I | 0, Q | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) != 1)
                        break r;
                      break e;
                    }
                    if (e[5996] = 0, I = wn(186, l + 140 | 0, l + 136 | 0) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                      break e;
                    return I && (e[S >> 2] = e[S >> 2] | 2), Q = e[l + 140 >> 2], I = e[l + 16 >> 2], C = e[I + 4 >> 2] - 1 | 0, e[I + 4 >> 2] = C, (C | 0) == -1 && Yn[e[e[I >> 2] + 8 >> 2]](I), ka(y), bi = l + 144 | 0, Q | 0;
                  }
                }
              C = gi() | 0, l = e[l + 16 >> 2], I = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = I, (I | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), ka(y), ss(C | 0), jn();
            }
            function ac(l, y, I, C, Q, S, me) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0, me = me | 0;
              var ke = 0, Ar = 0, br = 0, Qr = 0;
              if (l = bi - 448 | 0, bi = l, e[l + 440 >> 2] = I, e[l + 444 >> 2] = y, e[l + 20 >> 2] = 220, y = l + 24 | 0, e[y >> 2] = l + 32, Ar = l + 20 | 0, e[y + 4 >> 2] = e[Ar >> 2], br = l + 16 | 0, ke = e[Q + 28 >> 2], e[br >> 2] = ke, e[ke + 4 >> 2] = e[ke + 4 >> 2] + 1, e[5996] = 0, ke = no(197, e[l + 16 >> 2]) | 0, Qr = e[5996], e[5996] = 0, (Qr | 0) != 1)
                e: {
                  if (Se[l + 15 | 0] = 0, Q = e[Q + 4 >> 2], e[5996] = 0, I = Uc(228, l + 444 | 0, I | 0, C | 0, br | 0, Q | 0, S | 0, l + 15 | 0, ke | 0, y | 0, Ar | 0, l + 432 | 0) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                    break e;
                  t: {
                    r: {
                      if (!I)
                        break r;
                      i: {
                        if ((Je[me + 11 | 0] & 128) >>> 7 | 0) {
                          e[e[me >> 2] >> 2] = 0, e[me + 4 >> 2] = 0;
                          break i;
                        }
                        e[me >> 2] = 0, Se[me + 11 | 0] = 0;
                      }
                      if (Je[l + 15 | 0] && (e[5996] = 0, I = wn(216, ke | 0, 45) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1 || (e[5996] = 0, Co(232, me | 0, I | 0), I = e[5996], e[5996] = 0, (I | 0) == 1)))
                        break e;
                      if (e[5996] = 0, C = wn(216, ke | 0, 48) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                        break t;
                      for (Q = e[l + 20 >> 2], ke = Q - 4 | 0, I = e[y >> 2]; ; ) {
                        if (!((C | 0) != e[I >> 2] | I >>> 0 >= ke >>> 0)) {
                          I = I + 4 | 0;
                          continue;
                        }
                        break;
                      }
                      if (e[5996] = 0, Ko(234, me | 0, I | 0, Q | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) != 1)
                        break r;
                      break e;
                    }
                    if (e[5996] = 0, I = wn(202, l + 444 | 0, l + 440 | 0) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                      break e;
                    return I && (e[S >> 2] = e[S >> 2] | 2), Q = e[l + 444 >> 2], I = e[l + 16 >> 2], C = e[I + 4 >> 2] - 1 | 0, e[I + 4 >> 2] = C, (C | 0) == -1 && Yn[e[e[I >> 2] + 8 >> 2]](I), ka(y), bi = l + 448 | 0, Q | 0;
                  }
                }
              C = gi() | 0, l = e[l + 16 >> 2], I = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = I, (I | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), ka(y), ss(C | 0), jn();
            }
            function fc(l, y, I, C, Q) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0;
              var S = 0, me = 0, ke = 0;
              if (hc(l, e[y + 8 >> 2], Q)) {
                e[y + 28 >> 2] == 1 | e[y + 4 >> 2] != (I | 0) || (e[y + 28 >> 2] = C);
                return;
              }
              e: {
                if (hc(l, e[y >> 2], Q)) {
                  if (!(e[y + 16 >> 2] != (I | 0) & e[y + 20 >> 2] != (I | 0))) {
                    if ((C | 0) != 1)
                      break e;
                    e[y + 32 >> 2] = 1;
                    return;
                  }
                  e[y + 32 >> 2] = C;
                  t: {
                    if (e[y + 44 >> 2] == 4)
                      break t;
                    S = l + 16 | 0, ke = S + (e[l + 12 >> 2] << 3) | 0, C = 0;
                    r: {
                      i: {
                        for (; ; ) {
                          n: {
                            if (S >>> 0 >= ke >>> 0 || (ea[y + 52 >> 1] = 0, k1(e[S >> 2], e[S + 4 >> 2], y, I, I, 1, Q), Je[y + 54 | 0]))
                              break n;
                            o: {
                              if (!Je[y + 53 | 0])
                                break o;
                              if (Je[y + 52 | 0]) {
                                if (e[y + 24 >> 2] != 1 && (C = 1, me = 1, Je[l + 8 | 0] & 2))
                                  break o;
                                e[y + 44 >> 2] = 3;
                                return;
                              }
                              if (C = 1, !(Se[l + 8 | 0] & 1))
                                break i;
                            }
                            S = S + 8 | 0;
                            continue;
                          }
                          break;
                        }
                        if (!C)
                          break r;
                      }
                      if (e[y + 44 >> 2] = 3, !me)
                        break t;
                      break e;
                    }
                    if (e[y + 44 >> 2] = 4, me)
                      break e;
                  }
                  if (e[y + 20 >> 2] = I, e[y + 40 >> 2] = e[y + 40 >> 2] + 1, e[y + 36 >> 2] != 1 | e[y + 24 >> 2] != 2)
                    break e;
                  Se[y + 54 | 0] = 1;
                  return;
                }
                if (me = e[l + 12 >> 2], e1(e[l + 16 >> 2], e[l + 20 >> 2], y, I, C, Q), S = l + 24 | 0, me = (l + 16 | 0) + (me << 3) | 0, S >>> 0 >= me >>> 0)
                  break e;
                if (l = e[l + 8 >> 2], !(!(l & 2) & e[y + 36 >> 2] != 1)) {
                  for (; ; ) {
                    if (Je[y + 54 | 0])
                      break e;
                    if (e1(e[S >> 2], e[S + 4 >> 2], y, I, C, Q), S = S + 8 | 0, !(me >>> 0 > S >>> 0))
                      break;
                  }
                  break e;
                }
                if (!(l & 1))
                  for (; ; ) {
                    if (Je[y + 54 | 0] | e[y + 36 >> 2] == 1)
                      break e;
                    if (e1(e[S >> 2], e[S + 4 >> 2], y, I, C, Q), S = S + 8 | 0, !(me >>> 0 > S >>> 0))
                      break e;
                  }
                for (; ; ) {
                  if (Je[y + 54 | 0] | e[y + 36 >> 2] == 1 & e[y + 24 >> 2] == 1)
                    break e;
                  if (e1(e[S >> 2], e[S + 4 >> 2], y, I, C, Q), S = S + 8 | 0, !(me >>> 0 > S >>> 0))
                    break;
                }
              }
            }
            function dA(l, y, I, C, Q, S, me, ke) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0, me = me | 0, ke = ke | 0;
              var Ar = 0;
              l = bi - 16 | 0, bi = l, e[l + 12 >> 2] = I, e[l + 8 >> 2] = S, e[l + 12 >> 2] = I, e[l + 8 >> 2] = S, I = e[l + 12 >> 2];
              e: {
                for (; ; ) {
                  if (I >>> 0 >= C >>> 0) {
                    S = 0;
                    break e;
                  }
                  t: {
                    y = N2[I >> 1];
                    r: {
                      if (y >>> 0 <= 127) {
                        if (S = 1, I = e[l + 8 >> 2], (me - I | 0) <= 0)
                          break e;
                        e[l + 8 >> 2] = I + 1, Se[I | 0] = y;
                        break r;
                      }
                      if (y >>> 0 <= 2047) {
                        if (I = e[l + 8 >> 2], (me - I | 0) < 2)
                          break t;
                        e[l + 8 >> 2] = I + 1, Se[I | 0] = y >>> 6 | 192, I = e[l + 8 >> 2], e[l + 8 >> 2] = I + 1, Se[I | 0] = y & 63 | 128;
                        break r;
                      }
                      if (y >>> 0 <= 55295) {
                        if (I = e[l + 8 >> 2], (me - I | 0) < 3)
                          break t;
                        e[l + 8 >> 2] = I + 1, Se[I | 0] = y >>> 12 | 224, I = e[l + 8 >> 2], e[l + 8 >> 2] = I + 1, Se[I | 0] = y >>> 6 & 63 | 128, I = e[l + 8 >> 2], e[l + 8 >> 2] = I + 1, Se[I | 0] = y & 63 | 128;
                        break r;
                      }
                      i: {
                        n: {
                          if (y >>> 0 <= 56319) {
                            if (S = 1, (C - I | 0) < 4)
                              break e;
                            if (Ar = N2[I + 2 >> 1], (Ar & 64512) != 56320)
                              break n;
                            if ((me - e[l + 8 >> 2] | 0) < 4)
                              break e;
                            e[l + 12 >> 2] = I + 2, I = e[l + 8 >> 2], e[l + 8 >> 2] = I + 1, S = I, I = (y >>> 6 & 15) + 1 | 0, Se[S | 0] = I >>> 2 | 240, S = e[l + 8 >> 2], e[l + 8 >> 2] = S + 1, Se[S | 0] = I << 4 & 48 | y >>> 2 & 15 | 128, I = e[l + 8 >> 2], e[l + 8 >> 2] = I + 1, Se[I | 0] = Ar >>> 6 & 15 | y << 4 & 48 | 128, y = e[l + 8 >> 2], e[l + 8 >> 2] = y + 1, Se[y | 0] = Ar & 63 | 128;
                            break r;
                          }
                          if (y >>> 0 >= 57344)
                            break i;
                        }
                        S = 2;
                        break e;
                      }
                      if (I = e[l + 8 >> 2], (me - I | 0) < 3)
                        break t;
                      e[l + 8 >> 2] = I + 1, Se[I | 0] = y >>> 12 | 224, I = e[l + 8 >> 2], e[l + 8 >> 2] = I + 1, Se[I | 0] = y >>> 6 & 63 | 128, I = e[l + 8 >> 2], e[l + 8 >> 2] = I + 1, Se[I | 0] = y & 63 | 128;
                    }
                    I = e[l + 12 >> 2] + 2 | 0, e[l + 12 >> 2] = I;
                    continue;
                  }
                  break;
                }
                S = 1;
              }
              return e[Q >> 2] = e[l + 12 >> 2], e[ke >> 2] = e[l + 8 >> 2], bi = l + 16 | 0, S | 0;
            }
            function pA(l, y) {
              l = l | 0, y = y | 0;
              var I = 0, C = 0, Q = 0, S = 0, me = 0, ke = 0;
              if (I = e[l + 4 >> 2], C = e[l + 8 >> 2], I >>> 0 < C >>> 0) {
                e[I >> 2] = e[y >> 2], e[I + 4 >> 2] = e[y + 4 >> 2], e[y >> 2] = 0, e[y + 4 >> 2] = 0, Q = e[y + 28 >> 2], e[I + 24 >> 2] = e[y + 24 >> 2], e[I + 28 >> 2] = Q, Q = e[y + 20 >> 2], e[I + 16 >> 2] = e[y + 16 >> 2], e[I + 20 >> 2] = Q, Q = e[y + 12 >> 2], e[I + 8 >> 2] = e[y + 8 >> 2], e[I + 12 >> 2] = Q, e[l + 4 >> 2] = I + 32;
                return;
              }
              e: {
                if (ke = e[l >> 2], S = I - ke >> 5, Q = S + 1 | 0, Q >>> 0 < 134217728) {
                  if (C = C - ke | 0, me = C >> 4, me = C >>> 0 >= 2147483616 ? 134217727 : Q >>> 0 < me >>> 0 ? me : Q, me) {
                    if (me >>> 0 >= 134217728)
                      break e;
                    Q = ga(me << 5);
                  } else
                    Q = 0;
                  if (C = Q + (S << 5) | 0, e[C >> 2] = e[y >> 2], e[C + 4 >> 2] = e[y + 4 >> 2], e[y >> 2] = 0, e[y + 4 >> 2] = 0, S = e[y + 28 >> 2], e[C + 24 >> 2] = e[y + 24 >> 2], e[C + 28 >> 2] = S, S = e[y + 20 >> 2], e[C + 16 >> 2] = e[y + 16 >> 2], e[C + 20 >> 2] = S, S = e[y + 12 >> 2], e[C + 8 >> 2] = e[y + 8 >> 2], e[C + 12 >> 2] = S, S = C + 32 | 0, (I | 0) != (ke | 0))
                    for (; C = C - 32 | 0, I = I - 32 | 0, e[C >> 2] = e[I >> 2], e[C + 4 >> 2] = e[I + 4 >> 2], e[I >> 2] = 0, e[I + 4 >> 2] = 0, y = e[I + 28 >> 2], e[C + 24 >> 2] = e[I + 24 >> 2], e[C + 28 >> 2] = y, y = e[I + 20 >> 2], e[C + 16 >> 2] = e[I + 16 >> 2], e[C + 20 >> 2] = y, y = e[I + 12 >> 2], e[C + 8 >> 2] = e[I + 8 >> 2], e[C + 12 >> 2] = y, (I | 0) != (ke | 0); )
                      ;
                  if (e[l + 8 >> 2] = Q + (me << 5), y = e[l >> 2], e[l >> 2] = C, I = e[l + 4 >> 2], e[l + 4 >> 2] = S, (y | 0) != (I | 0))
                    for (; ; ) {
                      I = I - 32 | 0, l = e[I + 4 >> 2];
                      t: {
                        if (!l || (Q = e[l + 4 >> 2], e[l + 4 >> 2] = Q - 1, Q))
                          break t;
                        Yn[e[e[l >> 2] + 8 >> 2]](l), Ls(l);
                      }
                      if ((y | 0) == (I | 0))
                        break;
                    }
                  y && Tr(y);
                  return;
                }
                tf(), jn();
              }
              kc(), jn();
            }
            function Da(l, y) {
              var I = 0, C = 0, Q = 0, S = 0, me = 0;
              e: {
                t: {
                  r: {
                    i: {
                      n: {
                        o: {
                          I = e[l + 4 >> 2];
                          a: {
                            if ((I | 0) != e[l + 104 >> 2]) {
                              e[l + 4 >> 2] = I + 1, I = Je[I | 0];
                              break a;
                            }
                            I = Fa(l);
                          }
                          switch (I - 43 | 0) {
                            case 0:
                            case 2:
                              break o;
                            default:
                              break n;
                          }
                        }
                        me = (I | 0) == 45, y = !y, I = e[l + 4 >> 2];
                        o: {
                          if ((I | 0) != e[l + 104 >> 2]) {
                            e[l + 4 >> 2] = I + 1, I = Je[I | 0];
                            break o;
                          }
                          I = Fa(l);
                        }
                        if (C = I - 58 | 0, y | C >>> 0 > 4294967285)
                          break i;
                        if (y = e[l + 116 >> 2], (y | 0) > 0 | (y | 0) >= 0)
                          break r;
                        break e;
                      }
                      C = I - 58 | 0;
                    }
                    if (C >>> 0 <= 4294967285) {
                      if (e[l + 116 >> 2] < 0)
                        break e;
                      break t;
                    }
                    i: {
                      if (I - 48 >>> 0 >= 10)
                        break i;
                      for (; ; ) {
                        Q = (No(Q, 10) + I | 0) - 48 | 0, S = (Q | 0) < 214748364, I = e[l + 4 >> 2];
                        n: {
                          if ((I | 0) != e[l + 104 >> 2]) {
                            e[l + 4 >> 2] = I + 1, I = Je[I | 0];
                            break n;
                          }
                          I = Fa(l);
                        }
                        if (y = I - 48 | 0, !(S & y >>> 0 <= 9))
                          break;
                      }
                      if (S = Q >> 31, y >>> 0 >= 10)
                        break i;
                      for (; ; ) {
                        y = I, I = Ua(Q, S, 10, 0), C = y + I | 0, y = Ci, Q = C - 48 | 0, C = (I >>> 0 > C >>> 0 ? y + 1 | 0 : y) - (C >>> 0 < 48) | 0, S = C, C = Q >>> 0 < 2061584302 & (C | 0) <= 21474836 | (C | 0) < 21474836, I = e[l + 4 >> 2];
                        n: {
                          if ((I | 0) != e[l + 104 >> 2]) {
                            e[l + 4 >> 2] = I + 1, I = Je[I | 0];
                            break n;
                          }
                          I = Fa(l);
                        }
                        if (y = I - 48 | 0, !(C & y >>> 0 <= 9))
                          break;
                      }
                      if (y >>> 0 >= 10)
                        break i;
                      for (; ; ) {
                        y = e[l + 4 >> 2];
                        n: {
                          if ((y | 0) != e[l + 104 >> 2]) {
                            e[l + 4 >> 2] = y + 1, y = Je[y | 0];
                            break n;
                          }
                          y = Fa(l);
                        }
                        if (!(y - 48 >>> 0 < 10))
                          break;
                      }
                    }
                    return y = e[l + 116 >> 2], (y | 0) > 0 | (y | 0) >= 0 && (e[l + 4 >> 2] = e[l + 4 >> 2] - 1), Ci = me ? 0 - (((Q | 0) != 0) + S | 0) | 0 : S, me ? 0 - Q | 0 : Q;
                  }
                  e[l + 4 >> 2] = e[l + 4 >> 2] - 1;
                }
                e[l + 4 >> 2] = e[l + 4 >> 2] - 1;
              }
              return Ci = -2147483648, 0;
            }
            function tu(l, y, I, C, Q, S, me, ke) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0, me = me | 0, ke = ke | 0;
              var Ar = 0, br = 0, Qr = 0, Ur = 0, Xr = 0;
              l = bi - 16 | 0, bi = l, e[l + 12 >> 2] = I, e[l + 8 >> 2] = S, e[l + 12 >> 2] = I, e[l + 8 >> 2] = S;
              e: {
                t: {
                  for (; ; ) {
                    if (y = e[l + 12 >> 2], !(C >>> 0 <= y >>> 0 | S >>> 0 >= me >>> 0)) {
                      Ar = Se[y | 0], I = Ar & 255;
                      r: {
                        if ((Ar | 0) >= 0) {
                          Ar = 1;
                          break r;
                        }
                        if (Qr = 2, Ar >>> 0 < 4294967234)
                          break e;
                        if (Ar >>> 0 <= 4294967263) {
                          if ((C - y | 0) < 2)
                            break t;
                          if (Ar = Je[y + 1 | 0], (Ar & 192) != 128)
                            break e;
                          I = Ar & 63 | I << 6 & 1984, Ar = 2;
                          break r;
                        }
                        if (Ar >>> 0 <= 4294967279) {
                          if ((C - y | 0) < 3)
                            break t;
                          br = Je[y + 2 | 0], Ar = Je[y + 1 | 0];
                          i: {
                            n: {
                              if ((I | 0) != 237) {
                                if ((I | 0) != 224)
                                  break n;
                                if ((Ar & 224) == 160)
                                  break i;
                                break e;
                              }
                              if ((Ar & 224) == 128)
                                break i;
                              break e;
                            }
                            if ((Ar & 192) != 128)
                              break e;
                          }
                          if ((br & 192) != 128)
                            break e;
                          I = br & 63 | (I << 12 & 61440 | (Ar & 63) << 6), Ar = 3;
                          break r;
                        }
                        if (Ar >>> 0 > 4294967284)
                          break e;
                        if ((C - y | 0) < 4)
                          break t;
                        Ur = Je[y + 3 | 0], Xr = Je[y + 2 | 0], br = Je[y + 1 | 0];
                        i: {
                          n:
                            switch (I - 240 | 0) {
                              case 0:
                                if ((br + 112 & 255) >>> 0 < 48)
                                  break i;
                                break e;
                              case 4:
                                if ((br & 240) == 128)
                                  break i;
                                break e;
                              default:
                                break n;
                            }
                          if ((br & 192) != 128)
                            break e;
                        }
                        if ((Xr & 192) != 128 | (Ur & 192) != 128 || (Ar = 4, I = Ur & 63 | (Xr << 6 & 4032 | (I << 18 & 1835008 | (br & 63) << 12)), I >>> 0 > 1114111))
                          break e;
                      }
                      e[S >> 2] = I, e[l + 12 >> 2] = y + Ar, S = e[l + 8 >> 2] + 4 | 0, e[l + 8 >> 2] = S;
                      continue;
                    }
                    break;
                  }
                  Qr = y >>> 0 < C >>> 0;
                  break e;
                }
                Qr = 1;
              }
              return e[Q >> 2] = e[l + 12 >> 2], e[ke >> 2] = e[l + 8 >> 2], bi = l + 16 | 0, Qr | 0;
            }
            function xl(l, y, I, C, Q) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0;
              var S = 0, me = 0, ke = 0, Ar = 0, br = 0;
              S = bi - 32 | 0, bi = S, e[l + 8 >> 2] = 0, e[l + 12 >> 2] = 0, e[l + 4 >> 2] = Q, e[l >> 2] = y, e[l + 16 >> 2] = 0, e[l + 8 >> 2] = e[C >> 2], e[l + 12 >> 2] = e[C + 4 >> 2], e[l + 16 >> 2] = e[C + 8 >> 2], e[C + 8 >> 2] = 0, e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[l + 36 >> 2] = 0, e[l + 40 >> 2] = 0, e[l + 28 >> 2] = 0, e[l + 32 >> 2] = 0, e[l + 20 >> 2] = 0, e[l + 24 >> 2] = 0, e[l + 32 >> 2] = e[I >> 2], e[l + 36 >> 2] = e[I + 4 >> 2], e[l + 40 >> 2] = e[I + 8 >> 2], e[I + 8 >> 2] = 0, e[I >> 2] = 0, e[I + 4 >> 2] = 0, e[5996] = 0, Co(86, l + 44 | 0, l | 0), y = e[5996], e[5996] = 0;
              e: {
                if ((y | 0) == 1 || (e[5996] = 0, Co(87, l - -64 | 0, l | 0), y = e[5996], e[5996] = 0, (y | 0) == 1) || (I = 0, e[5996] = 0, y = no(88, l | 0) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1))
                  break e;
                if (e[l + 80 >> 2] = y, y = e[l + 32 >> 2], Q = e[l + 36 >> 2], (y | 0) == (Q | 0))
                  C = 0;
                else {
                  for (C = y; I = e[e[C >> 2] + 84 >> 2] + I | 0, C = C + 8 | 0, (Q | 0) != (C | 0); )
                    ;
                  C = e[e[y >> 2] + 80 >> 2];
                }
                if (me = e[l + 4 >> 2], ke = e[l >> 2], Ar = e[l + 8 >> 2], br = e[l + 12 >> 2], e[5996] = 0, y = Cf(89, ke | 0, C | 0, I | 0, me | 0, Q - y >> 3, (br - Ar | 0) / 12 | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1 || (e[l + 84 >> 2] = y, e[5996] = 0, e[S + 28 >> 2] = l, Ms(90, S + 12 | 0, l | 0, S + 28 | 0), y = e[5996], e[5996] = 0, (y | 0) == 1))
                  break e;
                return y = Je[S + 24 | 0], y && Kf(e[S + 16 >> 2]), Se[l + 88 | 0] = y ^ 1, bi = S + 32 | 0, l | 0;
              }
              I = gi() | 0, Za(l + 32 | 0), y = e[l + 20 >> 2], y && (e[l + 24 >> 2] = y, Tr(y)), hf(l + 8 | 0), ss(I | 0), jn();
            }
            function Rl(l, y, I) {
              l = l | 0, y = y | 0, I = I | 0;
              var C = 0, Q = 0, S = 0, me = 0, ke = 0, Ar = 0, br = 0, Qr = 0, Ur = 0, Xr = 0;
              me = bi - 32 | 0, bi = me, C = ga(104), e[C >> 2] = 7e3, e[C + 4 >> 2] = 0, e[C + 8 >> 2] = 0, Q = e[I + 8 >> 2], e[I + 8 >> 2] = 0, S = e[I >> 2], ke = e[I + 4 >> 2], e[I >> 2] = 0, e[I + 4 >> 2] = 0, e[C + 16 >> 2] = 0, e[C + 20 >> 2] = 0, e[C + 12 >> 2] = y, e[C + 24 >> 2] = 0, e[C + 28 >> 2] = 0, e[C + 52 >> 2] = 0, Ar = C + 44 | 0, y = Ar, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[C + 40 >> 2] = Q, e[C + 32 >> 2] = S, e[C + 36 >> 2] = ke, e[5996] = 0, S = C + 12 | 0, Co(86, C + 56 | 0, S | 0), y = e[5996], e[5996] = 0;
              e: {
                if ((y | 0) == 1 || (e[5996] = 0, Co(87, C + 76 | 0, S | 0), y = e[5996], e[5996] = 0, (y | 0) == 1) || (y = 0, e[5996] = 0, I = no(88, S | 0) | 0, Q = e[5996], e[5996] = 0, (Q | 0) == 1))
                  break e;
                if (e[C + 92 >> 2] = I, ke = e[C + 48 >> 2], Q = e[C + 44 >> 2], (ke | 0) == (Q | 0))
                  I = 0;
                else {
                  for (I = Q; y = e[e[I >> 2] + 84 >> 2] + y | 0, I = I + 8 | 0, (ke | 0) != (I | 0); )
                    ;
                  I = e[e[Q >> 2] + 80 >> 2];
                }
                if (br = e[C + 16 >> 2], Qr = e[C + 12 >> 2], Ur = e[C + 20 >> 2], Xr = e[C + 24 >> 2], e[5996] = 0, y = Cf(89, Qr | 0, I | 0, y | 0, br | 0, ke - Q >> 3, (Xr - Ur | 0) / 12 | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1 || (e[C + 96 >> 2] = y, e[5996] = 0, e[me + 28 >> 2] = S, Ms(90, me + 12 | 0, S | 0, me + 28 | 0), y = e[5996], e[5996] = 0, (y | 0) == 1))
                  break e;
                y = Je[me + 24 | 0], y && Kf(e[me + 16 >> 2]), Se[C + 100 | 0] = y ^ 1, e[l + 4 >> 2] = C, e[l >> 2] = S, bi = me + 32 | 0;
                return;
              }
              y = gi() | 0, Za(Ar), l = e[C + 32 >> 2], l && (e[C + 36 >> 2] = l, Tr(l)), hf(C + 20 | 0), Tr(C), ss(y | 0), jn();
            }
            function Oh(l, y, I, C, Q, S) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0;
              var me = 0, ke = 0;
              me = bi - 32 | 0, bi = me, ke = 1;
              e: {
                t: {
                  r: {
                    i:
                      switch (l | 0) {
                        case 3:
                          ke = 24;
                          break r;
                        case 4:
                        case 5:
                          if (e[me + 24 >> 2] = 0, e[me + 28 >> 2] = 0, e[me + 16 >> 2] = 0, e[me + 20 >> 2] = 0, e[me + 8 >> 2] = 0, e[me + 12 >> 2] = 0, e[me >> 2] = 0, e[me + 4 >> 2] = 0, e[5996] = 0, l = gu(me, C, 0), y = e[5996], e[5996] = 0, (y | 0) == 1) {
                            if (ke = gi() | 0, qs[me >> 2] < 29)
                              break e;
                            break t;
                          }
                          if (l = e[l >> 2], y = l >>> 0 < 29, ke = (y ? l : l - 29 | 0) + 1 | 0, y)
                            break r;
                          Tr(e[me + 8 >> 2]);
                          break r;
                        case 6:
                        case 7:
                          ke = 39;
                          break r;
                        case 8:
                        case 9:
                          ke = 27;
                          break r;
                        case 25:
                          ke = (No(S, 34) | C >>> 0 > 16) + (S >>> 0 > 16 ? 4 : 3) | 0;
                          break r;
                        case 17:
                          ke = I;
                          break r;
                        case 14:
                          ke = !(Mr(1239, 1) & (y ^ -1)) + I | 0;
                          break r;
                        case 11:
                        case 12:
                        case 16:
                        case 18:
                        case 19:
                          ke = I + 1 | 0;
                          break r;
                        case 10:
                        case 20:
                          ke = I + 2 | 0;
                          break r;
                        case 13:
                        case 21:
                        case 22:
                        case 23:
                          ke = I + 3 | 0;
                          break r;
                        case 15:
                          ke = I + 4 | 0;
                          break r;
                        case 24:
                          if (e[me + 24 >> 2] = 0, e[me + 28 >> 2] = 0, e[me + 16 >> 2] = 0, e[me + 20 >> 2] = 0, e[me + 8 >> 2] = 0, e[me + 12 >> 2] = 0, e[me >> 2] = 0, e[me + 4 >> 2] = 0, e[5996] = 0, l = gu(me, C, 0), y = e[5996], e[5996] = 0, (y | 0) == 1) {
                            if (ke = gi() | 0, qs[me >> 2] >= 29)
                              break t;
                            break e;
                          }
                          if (l = e[l >> 2], y = l >>> 0 < 29, ke = (I + Q | 0) + (y ? l : l - 29 | 0) | 0, y)
                            break r;
                          Tr(e[me + 8 >> 2]);
                          break r;
                        default:
                          Nf(2350, 1859, 280, 2003), jn();
                        case 0:
                        case 1:
                          break r;
                        case 2:
                          break i;
                      }
                    ke = 34;
                  }
                  return bi = me + 32 | 0, ke | 0;
                }
                Tr(e[me + 8 >> 2]);
              }
              ss(ke | 0), jn();
            }
            function Pl(l, y, I) {
              l = l | 0, y = y | 0, I = I | 0;
              var C = 0, Q = 0, S = 0, me = 0, ke = 0, Ar = 0, br = 0;
              if (me = e[l + 8 >> 2], Q = e[l + 4 >> 2], me - Q >>> 0 >= y >>> 0) {
                if (C = Q, ke = y & 7, ke)
                  for (; Se[C | 0] = Je[I | 0], C = C + 1 | 0, S = S + 1 | 0, (ke | 0) != (S | 0); )
                    ;
                for (y = y + Q | 0; Se[C | 0] = Je[I | 0], Se[C + 1 | 0] = Je[I | 0], Se[C + 2 | 0] = Je[I | 0], Se[C + 3 | 0] = Je[I | 0], Se[C + 4 | 0] = Je[I | 0], Se[C + 5 | 0] = Je[I | 0], Se[C + 6 | 0] = Je[I | 0], Se[C + 7 | 0] = Je[I | 0], C = C + 8 | 0, (y | 0) != (C | 0); )
                  ;
                e[l + 4 >> 2] = y;
                return;
              }
              if (C = e[l >> 2], S = Q - C | 0, Ar = S + y | 0, (Ar | 0) >= 0) {
                if (me = me - C | 0, C = me << 1, Ar = me >>> 0 >= 1073741823 ? 2147483647 : C >>> 0 > Ar >>> 0 ? C : Ar, Ar && (br = ga(Ar)), S = S + br | 0, C = S, me = y & 7, me)
                  for (; Se[C | 0] = Je[I | 0], C = C + 1 | 0, ke = ke + 1 | 0, (me | 0) != (ke | 0); )
                    ;
                for (ke = y + S | 0; Se[C | 0] = Je[I | 0], Se[C + 1 | 0] = Je[I | 0], Se[C + 2 | 0] = Je[I | 0], Se[C + 3 | 0] = Je[I | 0], Se[C + 4 | 0] = Je[I | 0], Se[C + 5 | 0] = Je[I | 0], Se[C + 6 | 0] = Je[I | 0], Se[C + 7 | 0] = Je[I | 0], C = C + 8 | 0, (ke | 0) != (C | 0); )
                  ;
                if (me = e[l >> 2], (me | 0) != (Q | 0)) {
                  if (C = (me ^ -1) + Q | 0, y = Q - me & 3, y)
                    for (I = 0; S = S - 1 | 0, Q = Q - 1 | 0, Se[S | 0] = Je[Q | 0], I = I + 1 | 0, (y | 0) != (I | 0); )
                      ;
                  if (C >>> 0 >= 3)
                    for (; Se[S - 1 | 0] = Je[Q - 1 | 0], Se[S - 2 | 0] = Je[Q - 2 | 0], Se[S - 3 | 0] = Je[Q - 3 | 0], S = S - 4 | 0, Q = Q - 4 | 0, Se[S | 0] = Je[Q | 0], (Q | 0) != (me | 0); )
                      ;
                  Q = e[l >> 2];
                }
                e[l + 8 >> 2] = Ar + br, e[l + 4 >> 2] = ke, e[l >> 2] = S, Q && Tr(Q);
                return;
              }
              tf(), jn();
            }
            function wA(l, y, I, C, Q) {
              var S = 0, me = 0, ke = 0, Ar = 0, br = 0, Qr = 0, Ur = 0, Xr = 0, Ri = 0, yn = 0, En = 0;
              Xr = bi - 16 | 0, bi = Xr, me = Je[l | 0];
              e: {
                if (!me) {
                  S = l;
                  break e;
                }
                S = l;
                t: {
                  for (; ; ) {
                    if (Ar = me << 24 >> 24, !((Ar | 0) == 32 | Ar - 9 >>> 0 < 5))
                      break t;
                    if (me = Je[S + 1 | 0], S = S + 1 | 0, !me)
                      break;
                  }
                  break e;
                }
                t:
                  switch (me = me & 255, me - 43 | 0) {
                    case 0:
                    case 2:
                      break t;
                    default:
                      break e;
                  }
                br = (me | 0) == 45 ? -1 : 0, S = S + 1 | 0;
              }
              e: {
                if (!((I | 16) != 16 | Je[S | 0] != 48)) {
                  if (yn = 1, (Je[S + 1 | 0] & 223) == 88) {
                    S = S + 2 | 0, Ar = 16;
                    break e;
                  }
                  S = S + 1 | 0, Ar = I || 8;
                  break e;
                }
                Ar = I || 10;
              }
              for (I = 0; ; ) {
                e: {
                  me = -48, Qr = Se[S | 0];
                  t: {
                    if ((Qr - 48 & 255) >>> 0 < 10 || (me = -87, (Qr - 97 & 255) >>> 0 < 26))
                      break t;
                    if (me = -55, (Qr - 65 & 255) >>> 0 > 25)
                      break e;
                  }
                  if (Ri = me + Qr | 0, (Ri | 0) >= (Ar | 0))
                    break e;
                  Ja(Xr, Ar, 0, 0, 0, Ur, ke, 0, 0), me = 1;
                  t: {
                    if (e[Xr + 8 >> 2] | e[Xr + 12 >> 2] || (En = Ua(Ur, ke, Ar, 0), Qr = Ci, (Qr | 0) == -1 & (Ri ^ -1) >>> 0 < En >>> 0))
                      break t;
                    ke = Qr, Ur = Ri + En | 0, ke = Ur >>> 0 < Ri >>> 0 ? ke + 1 | 0 : ke, yn = 1, me = I;
                  }
                  S = S + 1 | 0, I = me;
                  continue;
                }
                break;
              }
              y && (e[y >> 2] = yn ? S : l);
              e: {
                t: {
                  r: {
                    if (I) {
                      e[5732] = 68, l = C & 1, br = l ? 0 : br, Ur = C, ke = Q;
                      break r;
                    }
                    if ((Q | 0) == (ke | 0) & C >>> 0 > Ur >>> 0 | Q >>> 0 > ke >>> 0)
                      break t;
                    l = C & 1;
                  }
                  if (!(l | br)) {
                    e[5732] = 68, l = C, C = l - 1 | 0, Q = Q - !l | 0;
                    break e;
                  }
                  if ((Q | 0) == (ke | 0) & C >>> 0 >= Ur >>> 0 | Q >>> 0 > ke >>> 0)
                    break t;
                  e[5732] = 68;
                  break e;
                }
                l = br ^ Ur, C = l - br | 0, y = br >> 31, Q = (y ^ ke) - ((l >>> 0 < br >>> 0) + y | 0) | 0;
              }
              return bi = Xr + 16 | 0, Ci = Q, C;
            }
            function Ml(l, y, I, C, Q, S, me, ke, Ar, br) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0, me = me | 0, ke = ke | 0, Ar = Ar | 0, br = br | 0;
              var Qr = 0;
              Qr = bi - 16 | 0, bi = Qr;
              e: {
                if (l) {
                  l = Np(I);
                  t: {
                    if (y) {
                      y = Qr + 4 | 0, Yn[e[e[l >> 2] + 44 >> 2]](y, l), I = e[Qr + 4 >> 2], Se[C | 0] = I, Se[C + 1 | 0] = I >>> 8, Se[C + 2 | 0] = I >>> 16, Se[C + 3 | 0] = I >>> 24, Yn[e[e[l >> 2] + 32 >> 2]](y, l);
                      break t;
                    }
                    y = Qr + 4 | 0, Yn[e[e[l >> 2] + 40 >> 2]](y, l), I = e[Qr + 4 >> 2], Se[C | 0] = I, Se[C + 1 | 0] = I >>> 8, Se[C + 2 | 0] = I >>> 16, Se[C + 3 | 0] = I >>> 24, Yn[e[e[l >> 2] + 28 >> 2]](y, l);
                  }
                  Kc(Ar, y), Yo(y), e[Q >> 2] = Yn[e[e[l >> 2] + 12 >> 2]](l), e[S >> 2] = Yn[e[e[l >> 2] + 16 >> 2]](l), y = Qr + 4 | 0, Yn[e[e[l >> 2] + 20 >> 2]](y, l), Hf(me, y), Yo(y), Yn[e[e[l >> 2] + 24 >> 2]](y, l), Kc(ke, y), Yo(y), l = Yn[e[e[l >> 2] + 36 >> 2]](l) | 0;
                  break e;
                }
                l = Up(I);
                t: {
                  if (y) {
                    y = Qr + 4 | 0, Yn[e[e[l >> 2] + 44 >> 2]](y, l), I = e[Qr + 4 >> 2], Se[C | 0] = I, Se[C + 1 | 0] = I >>> 8, Se[C + 2 | 0] = I >>> 16, Se[C + 3 | 0] = I >>> 24, Yn[e[e[l >> 2] + 32 >> 2]](y, l);
                    break t;
                  }
                  y = Qr + 4 | 0, Yn[e[e[l >> 2] + 40 >> 2]](y, l), I = e[Qr + 4 >> 2], Se[C | 0] = I, Se[C + 1 | 0] = I >>> 8, Se[C + 2 | 0] = I >>> 16, Se[C + 3 | 0] = I >>> 24, Yn[e[e[l >> 2] + 28 >> 2]](y, l);
                }
                Kc(Ar, y), Yo(y), e[Q >> 2] = Yn[e[e[l >> 2] + 12 >> 2]](l), e[S >> 2] = Yn[e[e[l >> 2] + 16 >> 2]](l), y = Qr + 4 | 0, Yn[e[e[l >> 2] + 20 >> 2]](y, l), Hf(me, y), Yo(y), Yn[e[e[l >> 2] + 24 >> 2]](y, l), Kc(ke, y), Yo(y), l = Yn[e[e[l >> 2] + 36 >> 2]](l) | 0;
              }
              e[br >> 2] = l, bi = Qr + 16 | 0;
            }
            function Sa(l, y, I) {
              var C = 0, Q = 0, S = 0;
              if (I >>> 0 >= 512)
                return oo(l | 0, y | 0, I | 0), l;
              Q = l + I | 0;
              e: {
                if (!((l ^ y) & 3)) {
                  t: {
                    if (!(l & 3)) {
                      I = l;
                      break t;
                    }
                    if (!I) {
                      I = l;
                      break t;
                    }
                    for (I = l; ; ) {
                      if (Se[I | 0] = Je[y | 0], y = y + 1 | 0, I = I + 1 | 0, !(I & 3))
                        break t;
                      if (!(I >>> 0 < Q >>> 0))
                        break;
                    }
                  }
                  C = Q & -4;
                  t: {
                    if (C >>> 0 < 64 || (S = C + -64 | 0, S >>> 0 < I >>> 0))
                      break t;
                    for (; e[I >> 2] = e[y >> 2], e[I + 4 >> 2] = e[y + 4 >> 2], e[I + 8 >> 2] = e[y + 8 >> 2], e[I + 12 >> 2] = e[y + 12 >> 2], e[I + 16 >> 2] = e[y + 16 >> 2], e[I + 20 >> 2] = e[y + 20 >> 2], e[I + 24 >> 2] = e[y + 24 >> 2], e[I + 28 >> 2] = e[y + 28 >> 2], e[I + 32 >> 2] = e[y + 32 >> 2], e[I + 36 >> 2] = e[y + 36 >> 2], e[I + 40 >> 2] = e[y + 40 >> 2], e[I + 44 >> 2] = e[y + 44 >> 2], e[I + 48 >> 2] = e[y + 48 >> 2], e[I + 52 >> 2] = e[y + 52 >> 2], e[I + 56 >> 2] = e[y + 56 >> 2], e[I + 60 >> 2] = e[y + 60 >> 2], y = y - -64 | 0, I = I - -64 | 0, S >>> 0 >= I >>> 0; )
                      ;
                  }
                  if (I >>> 0 >= C >>> 0)
                    break e;
                  for (; e[I >> 2] = e[y >> 2], y = y + 4 | 0, I = I + 4 | 0, C >>> 0 > I >>> 0; )
                    ;
                  break e;
                }
                if (Q >>> 0 < 4) {
                  I = l;
                  break e;
                }
                if (C = Q - 4 | 0, C >>> 0 < l >>> 0) {
                  I = l;
                  break e;
                }
                for (I = l; Se[I | 0] = Je[y | 0], Se[I + 1 | 0] = Je[y + 1 | 0], Se[I + 2 | 0] = Je[y + 2 | 0], Se[I + 3 | 0] = Je[y + 3 | 0], y = y + 4 | 0, I = I + 4 | 0, C >>> 0 >= I >>> 0; )
                  ;
              }
              if (I >>> 0 < Q >>> 0)
                for (; Se[I | 0] = Je[y | 0], y = y + 1 | 0, I = I + 1 | 0, (Q | 0) != (I | 0); )
                  ;
              return l;
            }
            function Nl(l, y, I, C, Q, S, me, ke, Ar, br) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0, me = me | 0, ke = ke | 0, Ar = Ar | 0, br = br | 0;
              var Qr = 0;
              Qr = bi - 16 | 0, bi = Qr;
              e: {
                if (l) {
                  l = Pp(I);
                  t: {
                    if (y) {
                      y = Qr + 4 | 0, Yn[e[e[l >> 2] + 44 >> 2]](y, l), I = e[Qr + 4 >> 2], Se[C | 0] = I, Se[C + 1 | 0] = I >>> 8, Se[C + 2 | 0] = I >>> 16, Se[C + 3 | 0] = I >>> 24, Yn[e[e[l >> 2] + 32 >> 2]](y, l);
                      break t;
                    }
                    y = Qr + 4 | 0, Yn[e[e[l >> 2] + 40 >> 2]](y, l), I = e[Qr + 4 >> 2], Se[C | 0] = I, Se[C + 1 | 0] = I >>> 8, Se[C + 2 | 0] = I >>> 16, Se[C + 3 | 0] = I >>> 24, Yn[e[e[l >> 2] + 28 >> 2]](y, l);
                  }
                  Hf(Ar, y), Yo(y), Se[Q | 0] = Yn[e[e[l >> 2] + 12 >> 2]](l), Se[S | 0] = Yn[e[e[l >> 2] + 16 >> 2]](l), y = Qr + 4 | 0, Yn[e[e[l >> 2] + 20 >> 2]](y, l), Hf(me, y), Yo(y), Yn[e[e[l >> 2] + 24 >> 2]](y, l), Hf(ke, y), Yo(y), l = Yn[e[e[l >> 2] + 36 >> 2]](l) | 0;
                  break e;
                }
                l = Mp(I);
                t: {
                  if (y) {
                    y = Qr + 4 | 0, Yn[e[e[l >> 2] + 44 >> 2]](y, l), I = e[Qr + 4 >> 2], Se[C | 0] = I, Se[C + 1 | 0] = I >>> 8, Se[C + 2 | 0] = I >>> 16, Se[C + 3 | 0] = I >>> 24, Yn[e[e[l >> 2] + 32 >> 2]](y, l);
                    break t;
                  }
                  y = Qr + 4 | 0, Yn[e[e[l >> 2] + 40 >> 2]](y, l), I = e[Qr + 4 >> 2], Se[C | 0] = I, Se[C + 1 | 0] = I >>> 8, Se[C + 2 | 0] = I >>> 16, Se[C + 3 | 0] = I >>> 24, Yn[e[e[l >> 2] + 28 >> 2]](y, l);
                }
                Hf(Ar, y), Yo(y), Se[Q | 0] = Yn[e[e[l >> 2] + 12 >> 2]](l), Se[S | 0] = Yn[e[e[l >> 2] + 16 >> 2]](l), y = Qr + 4 | 0, Yn[e[e[l >> 2] + 20 >> 2]](y, l), Hf(me, y), Yo(y), Yn[e[e[l >> 2] + 24 >> 2]](y, l), Hf(ke, y), Yo(y), l = Yn[e[e[l >> 2] + 36 >> 2]](l) | 0;
              }
              e[br >> 2] = l, bi = Qr + 16 | 0;
            }
            function mc(l, y, I, C) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0;
              var Q = 0, S = 0, me = 0, ke = 0, Ar = 0, br = 0, Qr = 0;
              Q = bi - 32 | 0, bi = Q, e[l + 8 >> 2] = 0, e[l + 12 >> 2] = 0, e[l + 4 >> 2] = C, e[l >> 2] = y, e[l + 16 >> 2] = 0, e[l + 20 >> 2] = 0, e[l + 24 >> 2] = 0, e[l + 28 >> 2] = 0, me = l + 32 | 0, y = me, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[l + 40 >> 2] = 0, e[y >> 2] = e[I >> 2], e[l + 36 >> 2] = e[I + 4 >> 2], e[l + 40 >> 2] = e[I + 8 >> 2], e[I + 8 >> 2] = 0, e[I >> 2] = 0, e[I + 4 >> 2] = 0, e[5996] = 0, Co(86, l + 44 | 0, l | 0), y = e[5996], e[5996] = 0;
              e: {
                if ((y | 0) == 1 || (e[5996] = 0, Co(87, l - -64 | 0, l | 0), y = e[5996], e[5996] = 0, (y | 0) == 1) || (C = 0, e[5996] = 0, y = no(88, l | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1))
                  break e;
                if (e[l + 80 >> 2] = y, S = e[l + 36 >> 2], y = e[l + 32 >> 2], (S | 0) == (y | 0))
                  I = 0;
                else {
                  for (I = y; C = e[e[I >> 2] + 84 >> 2] + C | 0, I = I + 8 | 0, (S | 0) != (I | 0); )
                    ;
                  I = e[e[y >> 2] + 80 >> 2];
                }
                if (ke = e[l + 4 >> 2], Ar = e[l >> 2], br = e[l + 8 >> 2], Qr = e[l + 12 >> 2], e[5996] = 0, y = Cf(89, Ar | 0, I | 0, C | 0, ke | 0, S - y >> 3, (Qr - br | 0) / 12 | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1 || (e[l + 84 >> 2] = y, e[5996] = 0, e[Q + 28 >> 2] = l, Ms(90, Q + 12 | 0, l | 0, Q + 28 | 0), y = e[5996], e[5996] = 0, (y | 0) == 1))
                  break e;
                return y = Je[Q + 24 | 0], y && Kf(e[Q + 16 >> 2]), Se[l + 88 | 0] = y ^ 1, bi = Q + 32 | 0, l | 0;
              }
              I = gi() | 0, Za(me), y = e[l + 20 >> 2], y && (e[l + 24 >> 2] = y, Tr(y)), hf(l + 8 | 0), ss(I | 0), jn();
            }
            function vc(l, y, I, C) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0;
              var Q = 0, S = 0, me = 0, ke = 0, Ar = 0, br = 0;
              Q = bi - 32 | 0, bi = Q, e[l + 8 >> 2] = 0, e[l + 12 >> 2] = 0, e[l + 4 >> 2] = C, e[l >> 2] = y, e[l + 16 >> 2] = 0, e[l + 8 >> 2] = e[I >> 2], e[l + 12 >> 2] = e[I + 4 >> 2], e[l + 16 >> 2] = e[I + 8 >> 2], e[I + 8 >> 2] = 0, e[I >> 2] = 0, e[I + 4 >> 2] = 0, e[l + 36 >> 2] = 0, e[l + 40 >> 2] = 0, e[l + 28 >> 2] = 0, e[l + 32 >> 2] = 0, e[l + 20 >> 2] = 0, e[l + 24 >> 2] = 0, e[5996] = 0, Co(86, l + 44 | 0, l | 0), y = e[5996], e[5996] = 0;
              e: {
                if ((y | 0) == 1 || (e[5996] = 0, Co(87, l - -64 | 0, l | 0), y = e[5996], e[5996] = 0, (y | 0) == 1) || (C = 0, e[5996] = 0, y = no(88, l | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1))
                  break e;
                if (e[l + 80 >> 2] = y, S = e[l + 36 >> 2], y = e[l + 32 >> 2], (S | 0) == (y | 0))
                  I = 0;
                else {
                  for (I = y; C = e[e[I >> 2] + 84 >> 2] + C | 0, I = I + 8 | 0, (S | 0) != (I | 0); )
                    ;
                  I = e[e[y >> 2] + 80 >> 2];
                }
                if (me = e[l + 4 >> 2], ke = e[l >> 2], Ar = e[l + 8 >> 2], br = e[l + 12 >> 2], e[5996] = 0, y = Cf(89, ke | 0, I | 0, C | 0, me | 0, S - y >> 3, (br - Ar | 0) / 12 | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1 || (e[l + 84 >> 2] = y, e[5996] = 0, e[Q + 28 >> 2] = l, Ms(90, Q + 12 | 0, l | 0, Q + 28 | 0), y = e[5996], e[5996] = 0, (y | 0) == 1))
                  break e;
                return y = Je[Q + 24 | 0], y && Kf(e[Q + 16 >> 2]), Se[l + 88 | 0] = y ^ 1, bi = Q + 32 | 0, l | 0;
              }
              I = gi() | 0, Za(l + 32 | 0), y = e[l + 20 >> 2], y && (e[l + 24 >> 2] = y, Tr(y)), hf(l + 8 | 0), ss(I | 0), jn();
            }
            function Qf(l, y) {
              l = l | 0, y = y | 0;
              var I = 0, C = 0, Q = 0, S = 0, me = 0, ke = 0;
              C = bi - 16 | 0, bi = C, e[5996] = 0, S = wn(134, C + 8 | 0, l | 0) | 0, I = e[5996], e[5996] = 0;
              e: {
                t: {
                  r: {
                    if ((I | 0) != 1) {
                      i: {
                        if (!Je[S | 0])
                          break i;
                        I = e[(e[e[l >> 2] - 12 >> 2] + l | 0) + 28 >> 2], e[C + 4 >> 2] = I, e[I + 4 >> 2] = e[I + 4 >> 2] + 1, e[5996] = 0, ke = no(135, e[C + 4 >> 2]) | 0, I = e[5996], e[5996] = 0;
                        n: {
                          o: {
                            if ((I | 0) != 1) {
                              if (I = e[C + 4 >> 2], Q = e[I + 4 >> 2] - 1 | 0, e[I + 4 >> 2] = Q, (Q | 0) == -1 && Yn[e[e[I >> 2] + 8 >> 2]](I), e[C + 4 >> 2] = e[(e[e[l >> 2] - 12 >> 2] + l | 0) + 24 >> 2], I = e[e[l >> 2] - 12 >> 2], e[5996] = 0, I = l + I | 0, Q = no(136, I | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1 || (me = e[C + 4 >> 2], e[5996] = 0, y = i2(137, ke | 0, me | 0, I | 0, Q | 0, y | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1))
                                break o;
                              if (y || (y = e[e[l >> 2] - 12 >> 2], e[5996] = 0, Co(138, l + y | 0, 5), y = e[5996], e[5996] = 0, (y | 0) != 1))
                                break i;
                              y = Ws(0) | 0;
                              break n;
                            }
                            y = Ws(0) | 0, I = e[C + 4 >> 2], Q = e[I + 4 >> 2] - 1 | 0, e[I + 4 >> 2] = Q, (Q | 0) == -1 && Yn[e[e[I >> 2] + 8 >> 2]](I);
                            break n;
                          }
                          y = Ws(0) | 0;
                        }
                        ca(S);
                        break r;
                      }
                      ca(S);
                      break t;
                    }
                    y = Ws(0) | 0;
                  }
                  if (Zf(y | 0) | 0, y = e[e[l >> 2] - 12 >> 2], e[5996] = 0, La(139, l + y | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                    break e;
                  $a();
                }
                return bi = C + 16 | 0, l | 0;
              }
              l = gi() | 0, e[5996] = 0, jo(110), y = e[5996], e[5996] = 0, (y | 0) != 1 && (ss(l | 0), jn()), Ws(0) | 0, _c(), jn();
            }
            function Ol(l, y, I) {
              l = l | 0, y = y | 0, I = I | 0;
              var C = 0, Q = 0, S = 0, me = 0, ke = 0, Ar = 0, br = 0;
              Q = bi - 32 | 0, bi = Q, e[l + 8 >> 2] = 0, e[l >> 2] = 0, e[l + 4 >> 2] = 0, Se[Q + 4 | 0] = 0, e[Q >> 2] = l;
              e: {
                t: {
                  r: {
                    i: {
                      n: {
                        if (I) {
                          if (I >>> 0 >= 357913942) {
                            if (e[5996] = 0, jo(47), l = e[5996], e[5996] = 0, (l | 0) == 1)
                              break r;
                            break e;
                          }
                          if (e[5996] = 0, I = No(I, 12), me = no(3, I | 0) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                            break r;
                          for (e[l + 4 >> 2] = me, e[l >> 2] = me, e[l + 8 >> 2] = I + me, e[Q + 24 >> 2] = me, Se[Q + 20 | 0] = 0, e[Q + 8 >> 2] = l + 8, br = y + I | 0, e[Q + 16 >> 2] = Q + 28, e[Q + 12 >> 2] = Q + 24, C = me; ; ) {
                            if (e[C + 8 >> 2] = 0, e[C >> 2] = 0, e[C + 4 >> 2] = 0, S = e[y >> 2], I = e[y + 4 >> 2], (S | 0) != (I | 0)) {
                              if (ke = I - S | 0, (ke | 0) < 0) {
                                if (e[5996] = 0, e[Q + 28 >> 2] = C, jo(84), y = e[5996], e[5996] = 0, (y | 0) != 1)
                                  break e;
                                if (I = gi() | 0, y = e[C >> 2], !y)
                                  break i;
                                e[C + 4 >> 2] = y, Tr(y);
                                break i;
                              }
                              if (e[5996] = 0, I = no(3, ke | 0) | 0, Ar = e[5996], e[5996] = 0, (Ar | 0) == 1)
                                break n;
                              if (e[C + 4 >> 2] = I, e[C >> 2] = I, e[C + 8 >> 2] = (ke & -8) + I, ke = e[y + 4 >> 2], (ke | 0) != (S | 0))
                                for (; Ar = e[S + 4 >> 2], e[I >> 2] = e[S >> 2], e[I + 4 >> 2] = Ar, I = I + 8 | 0, S = S + 8 | 0, (ke | 0) != (S | 0); )
                                  ;
                              e[C + 4 >> 2] = I;
                            }
                            if (C = C + 12 | 0, y = y + 12 | 0, (br | 0) == (y | 0))
                              break;
                          }
                          e[l + 4 >> 2] = C;
                        }
                        return bi = Q + 32 | 0, l | 0;
                      }
                      I = gi() | 0, e[Q + 28 >> 2] = C;
                    }
                    y1(Q + 8 | 0), e[l + 4 >> 2] = me;
                    break t;
                  }
                  I = gi() | 0;
                }
                lh(Q), ss(I | 0), jn();
              }
              jn();
            }
            function Uh(l, y) {
              l = l | 0, y = y | 0;
              var I = 0, C = 0, Q = 0, S = 0, me = 0, ke = 0, Ar = 0, br = 0, Qr = 0;
              ke = e[y >> 2], I = Se[y + 11 | 0], e[l + 8 >> 2] = 0, e[l >> 2] = 0, e[l + 4 >> 2] = 0, y = (I | 0) < 0 ? ke : y, I = 0, ke = 0;
              e: {
                t: {
                  r: {
                    for (; ; ) {
                      for (Q = C, me = I, S = ke; ; ) {
                        if (I = Je[y | 0], !(I - 9 >>> 0 >= 5 & (I | 0) != 32)) {
                          y = y + 1 | 0;
                          continue;
                        }
                        if (C = Je[I + 5584 | 0], (C | 0) == 255 || (I = Je[Je[y + 1 | 0] + 5584 | 0], (I | 0) == 255))
                          break e;
                        if (y = y + 2 | 0, ke = I | C << 4, (Q | 0) != (S | 0)) {
                          Se[S | 0] = ke, S = S + 1 | 0, e[l + 4 >> 2] = S;
                          continue;
                        }
                        break;
                      }
                      if (Ar = S - me | 0, C = Ar + 1 | 0, (C | 0) < 0) {
                        if (e[5996] = 0, jo(8), y = e[5996], e[5996] = 0, (y | 0) == 1)
                          break r;
                        jn();
                      }
                      i: {
                        I = Ar << 1, C = Ar >>> 0 >= 1073741823 ? 2147483647 : I >>> 0 > C >>> 0 ? I : C;
                        n: {
                          if (!C) {
                            br = 0;
                            break n;
                          }
                          if (e[5996] = 0, br = no(3, C | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                            break i;
                        }
                        if (I = Ar + br | 0, Se[I | 0] = ke, C = C + br | 0, ke = I + 1 | 0, (Q | 0) != (me | 0)) {
                          if (Qr = (me ^ -1) + S | 0, S = 0, Ar = Ar & 3, Ar)
                            for (; I = I - 1 | 0, Q = Q - 1 | 0, Se[I | 0] = Je[Q | 0], S = S + 1 | 0, (Ar | 0) != (S | 0); )
                              ;
                          if (Qr >>> 0 >= 3)
                            for (; Se[I - 1 | 0] = Je[Q - 1 | 0], Se[I - 2 | 0] = Je[Q - 2 | 0], Se[I - 3 | 0] = Je[Q - 3 | 0], I = I - 4 | 0, Q = Q - 4 | 0, Se[I | 0] = Je[Q | 0], (Q | 0) != (me | 0); )
                              ;
                          I = br;
                        }
                        if (e[l + 8 >> 2] = C, e[l + 4 >> 2] = ke, e[l >> 2] = I, !me)
                          continue;
                        Tr(me);
                        continue;
                      }
                      break;
                    }
                    y = gi() | 0;
                    break t;
                  }
                  y = gi() | 0, me = e[l >> 2];
                }
                me && (e[l + 4 >> 2] = me, Tr(me)), ss(y | 0), jn();
              }
            }
            function uu(l, y, I, C, Q, S) {
              var me = 0, ke = 0;
              if (Se[l | 0] = 0, Se[l + 1 | 0] = 0, Se[l + 2 | 0] = 0, Se[l + 3 | 0] = 0, Se[l + 4 | 0] = 0, Se[l + 5 | 0] = 0, Se[l + 6 | 0] = 0, Se[l + 7 | 0] = 0, Se[l + 24 | 0] = 0, Se[l + 25 | 0] = 0, Se[l + 26 | 0] = 0, Se[l + 27 | 0] = 0, Se[l + 28 | 0] = 0, Se[l + 29 | 0] = 0, Se[l + 30 | 0] = 0, Se[l + 31 | 0] = 0, Se[l + 16 | 0] = 0, Se[l + 17 | 0] = 0, Se[l + 18 | 0] = 0, Se[l + 19 | 0] = 0, Se[l + 20 | 0] = 0, Se[l + 21 | 0] = 0, Se[l + 22 | 0] = 0, Se[l + 23 | 0] = 0, Se[l + 8 | 0] = 0, Se[l + 9 | 0] = 0, Se[l + 10 | 0] = 0, Se[l + 11 | 0] = 0, Se[l + 12 | 0] = 0, Se[l + 13 | 0] = 0, Se[l + 14 | 0] = 0, Se[l + 15 | 0] = 0, e[5996] = 0, me = wn(127, l | 0, 130) | 0, ke = e[5996], e[5996] = 0, (ke | 0) != 1)
                e: {
                  if (y = e[y >> 2], e[5996] = 0, y = gu(me, y, y >> 31), me = e[5996], e[5996] = 0, (me | 0) == 1 || (I = e[I >> 2], e[5996] = 0, y = wn(127, y | 0, I | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1) || (I = e[C >> 2], e[5996] = 0, y = wn(127, y | 0, I | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1) || (e[5996] = 0, y = wn(19, y | 0, Q | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1) || (I = e[S >> 2], e[5996] = 0, wn(127, y | 0, I | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1))
                    break e;
                  return;
                }
              y = gi() | 0, (Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24)) >>> 0 >= 29 && (Tr(Je[l + 8 | 0] | Je[l + 9 | 0] << 8 | (Je[l + 10 | 0] << 16 | Je[l + 11 | 0] << 24)), Se[l + 8 | 0] = 0, Se[l + 9 | 0] = 0, Se[l + 10 | 0] = 0, Se[l + 11 | 0] = 0), ss(y | 0), jn();
            }
            function PA(l, y, I, C, Q, S, me, ke, Ar, br, Qr, Ur) {
              e: {
                t: {
                  if ((l | 0) == (S | 0)) {
                    if (!Je[y | 0])
                      break e;
                    if (S = 0, Se[y | 0] = 0, l = e[Q >> 2], e[Q >> 2] = l + 1, Se[l | 0] = 46, l = Je[ke + 11 | 0], !((l & 128) >>> 7 | 0 ? e[ke + 4 >> 2] : l & 127) || (l = e[br >> 2], (l - Ar | 0) > 159))
                      break t;
                    return y = e[Qr >> 2], e[br >> 2] = l + 4, e[l >> 2] = y, 0;
                  }
                  r: {
                    if ((l | 0) != (me | 0) || (S = Je[ke + 11 | 0], !((S & 128) >>> 7 | 0 ? e[ke + 4 >> 2] : S & 127)))
                      break r;
                    if (!Je[y | 0])
                      break e;
                    if (S = 0, l = e[br >> 2], (l - Ar | 0) > 159)
                      break t;
                    return y = e[Qr >> 2], e[br >> 2] = l + 4, e[l >> 2] = y, e[Qr >> 2] = 0, 0;
                  }
                  if (S = -1, me = E1(Ur, Ur + 32 | 0, l) - Ur | 0, (me | 0) > 31)
                    break t;
                  l = Se[me + 12416 | 0];
                  r: {
                    i:
                      switch ((me & -2) - 22 | 0) {
                        case 2:
                          if (y = e[Q >> 2], (y | 0) != (C | 0) && (C = Se[y - 1 | 0], I = Se[I | 0], ((C - 97 >>> 0 < 26 ? C & 95 : C) | 0) != ((I - 97 >>> 0 < 26 ? I & 95 : I) | 0)))
                            break t;
                          return e[Q >> 2] = y + 1, Se[y | 0] = l, 0;
                        case 0:
                          Se[I | 0] = 80;
                          break r;
                        default:
                          break i;
                      }
                    if (C = l - 97 >>> 0 < 26 ? l & 95 : l, (C | 0) != Se[I | 0] || (Se[I | 0] = C - 65 >>> 0 < 26 ? C | 32 : C, !Je[y | 0]) || (Se[y | 0] = 0, y = Je[ke + 11 | 0], !((y & 128) >>> 7 | 0 ? e[ke + 4 >> 2] : y & 127)) || (y = e[br >> 2], (y - Ar | 0) > 159))
                      break r;
                    I = e[Qr >> 2], e[br >> 2] = y + 4, e[y >> 2] = I;
                  }
                  if (y = e[Q >> 2], e[Q >> 2] = y + 1, Se[y | 0] = l, S = 0, (me | 0) > 21)
                    break t;
                  e[Qr >> 2] = e[Qr >> 2] + 1;
                }
                return S;
              }
              return -1;
            }
            function eh(l, y, I, C, Q, S, me, ke, Ar, br, Qr, Ur) {
              e: {
                t: {
                  if ((l | 0) == (S | 0)) {
                    if (!Je[y | 0])
                      break e;
                    if (S = 0, Se[y | 0] = 0, l = e[Q >> 2], e[Q >> 2] = l + 1, Se[l | 0] = 46, l = Je[ke + 11 | 0], !((l & 128) >>> 7 | 0 ? e[ke + 4 >> 2] : l & 127) || (l = e[br >> 2], (l - Ar | 0) > 159))
                      break t;
                    return y = e[Qr >> 2], e[br >> 2] = l + 4, e[l >> 2] = y, 0;
                  }
                  r: {
                    if ((l | 0) != (me | 0) || (S = Je[ke + 11 | 0], !((S & 128) >>> 7 | 0 ? e[ke + 4 >> 2] : S & 127)))
                      break r;
                    if (!Je[y | 0])
                      break e;
                    if (S = 0, l = e[br >> 2], (l - Ar | 0) > 159)
                      break t;
                    return y = e[Qr >> 2], e[br >> 2] = l + 4, e[l >> 2] = y, e[Qr >> 2] = 0, 0;
                  }
                  if (S = -1, me = B1(Ur, Ur + 128 | 0, l) - Ur | 0, (me | 0) > 124)
                    break t;
                  l = Se[(me >> 2) + 12416 | 0];
                  r: {
                    i: {
                      if (Ur = me & -5, (Ur | 0) != 88) {
                        if ((Ur | 0) != 96)
                          break i;
                        if (y = e[Q >> 2], (y | 0) != (C | 0) && (C = Se[y - 1 | 0], I = Se[I | 0], ((C - 97 >>> 0 < 26 ? C & 95 : C) | 0) != ((I - 97 >>> 0 < 26 ? I & 95 : I) | 0)))
                          break t;
                        return e[Q >> 2] = y + 1, Se[y | 0] = l, 0;
                      }
                      Se[I | 0] = 80;
                      break r;
                    }
                    if (C = l - 97 >>> 0 < 26 ? l & 95 : l, (C | 0) != Se[I | 0] || (Se[I | 0] = C - 65 >>> 0 < 26 ? C | 32 : C, !Je[y | 0]) || (Se[y | 0] = 0, y = Je[ke + 11 | 0], !((y & 128) >>> 7 | 0 ? e[ke + 4 >> 2] : y & 127)) || (y = e[br >> 2], (y - Ar | 0) > 159))
                      break r;
                    I = e[Qr >> 2], e[br >> 2] = y + 4, e[y >> 2] = I;
                  }
                  if (y = e[Q >> 2], e[Q >> 2] = y + 1, Se[y | 0] = l, S = 0, (me | 0) > 84)
                    break t;
                  e[Qr >> 2] = e[Qr >> 2] + 1;
                }
                return S;
              }
              return -1;
            }
            function cf(l, y, I) {
              l = l | 0, y = y | 0, I = I | 0;
              var C = 0, Q = 0, S = 0, me = 0, ke = 0, Ar = 0, br = 0, Qr = 0, Ur = 0, Xr = 0, Ri = 0, yn = 0, En = 0, Wn = 0, lo = 0, Ro = 0;
              if ((I | 0) != 1) {
                Ur = bi - 1040 | 0, bi = Ur, Wn = e[5732];
                e: {
                  t: {
                    if (me = Ur + 16 | 0, Ri = N2[((I >>> 0 <= 153 ? I : 0) << 1) + 21296 >> 1] + 19372 | 0, y = e[e[6178] + 20 >> 2], y) {
                      ke = e[y + 4 >> 2], C = e[y >> 2], S = e[C >> 2] + 1794895138 | 0, Ar = Qu(e[C + 8 >> 2], S), br = Qu(e[C + 12 >> 2], S), Q = Qu(e[C + 16 >> 2], S);
                      r: {
                        if (ke >>> 2 >>> 0 <= Ar >>> 0 || (y = ke - (Ar << 2) | 0, (Q | br) & 3 | (y >>> 0 <= br >>> 0 | y >>> 0 <= Q >>> 0)))
                          break r;
                        for (lo = Q >>> 2 | 0, Ro = br >>> 2 | 0; ; ) {
                          if (Xr = Ar >>> 1 | 0, br = Xr + yn | 0, Q = br << 1, y = C + (Q + Ro << 2) | 0, En = Qu(e[y >> 2], S), y = Qu(e[y + 4 >> 2], S), y >>> 0 >= ke >>> 0 | ke - y >>> 0 <= En >>> 0 | Je[C + (y + En | 0) | 0])
                            break r;
                          if (y = jh(Ri, y + C | 0), !y) {
                            if (y = C + (Q + lo << 2) | 0, Q = Qu(e[y >> 2], S), y = Qu(e[y + 4 >> 2], S), y >>> 0 >= ke >>> 0 | Q >>> 0 >= ke - y >>> 0)
                              break r;
                            Qr = Je[C + (y + Q | 0) | 0] ? 0 : y + C | 0;
                            break r;
                          }
                          if ((Ar | 0) == 1)
                            break r;
                          y = (y | 0) < 0, Ar = y ? Xr : Ar - Xr | 0, yn = y ? yn : br;
                        }
                      }
                    }
                    Qr = Qr || Ri, y = Jf(Qr);
                    r: {
                      if (y >>> 0 >= 1024) {
                        Sa(me, Qr, 1023), Se[me + 1023 | 0] = 0, y = 68;
                        break r;
                      }
                      Sa(me, Qr, y + 1 | 0), y = 0;
                    }
                    if (y) {
                      if ((y | 0) != 28)
                        break t;
                      y = 5575;
                    } else
                      y = me;
                    break e;
                  }
                  pc(), jn();
                }
                Je[y | 0] || (e[Ur >> 2] = I, r1(me, 1024, 2507, Ur), y = me), e[5732] = Wn, Ac(l, y), bi = Ur + 1040 | 0;
                return;
              }
              Ac(l, 1694);
            }
            function Ul(l, y, I, C) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0;
              var Q = 0, S = 0, me = 0, ke = 0, Ar = 0, br = 0;
              S = bi - 32 | 0, bi = S, e[S + 28 >> 2] = C, e[S + 24 >> 2] = C, Se[S + 20 | 0] = 0, e[S + 8 >> 2] = l, e[S + 16 >> 2] = S + 28, e[S + 12 >> 2] = S + 24;
              e: {
                t: {
                  r: {
                    if ((y | 0) != (I | 0))
                      for (; ; ) {
                        if (e[C + 8 >> 2] = 0, e[C >> 2] = 0, e[C + 4 >> 2] = 0, l = e[y + 4 >> 2], Q = e[y >> 2], (l | 0) != (Q | 0)) {
                          if (Q = l - Q | 0, (Q | 0) < 0) {
                            if (e[5996] = 0, jo(8), l = e[5996], e[5996] = 0, (l | 0) == 1)
                              break r;
                            jn();
                          }
                          if (e[5996] = 0, l = no(3, Q | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                            break t;
                          e[C + 4 >> 2] = l, e[C >> 2] = l, e[C + 8 >> 2] = l + Q, Q = e[y >> 2], me = e[y + 4 >> 2];
                          i: {
                            if ((Q | 0) == (me | 0))
                              break i;
                            if (br = (Q ^ -1) + me | 0, ke = 0, Ar = me - Q & 7, Ar)
                              for (; Se[l | 0] = Je[Q | 0], l = l + 1 | 0, Q = Q + 1 | 0, ke = ke + 1 | 0, (Ar | 0) != (ke | 0); )
                                ;
                            if (br >>> 0 < 7)
                              break i;
                            for (; Se[l | 0] = Je[Q | 0], Se[l + 1 | 0] = Je[Q + 1 | 0], Se[l + 2 | 0] = Je[Q + 2 | 0], Se[l + 3 | 0] = Je[Q + 3 | 0], Se[l + 4 | 0] = Je[Q + 4 | 0], Se[l + 5 | 0] = Je[Q + 5 | 0], Se[l + 6 | 0] = Je[Q + 6 | 0], Se[l + 7 | 0] = Je[Q + 7 | 0], l = l + 8 | 0, Q = Q + 8 | 0, (me | 0) != (Q | 0); )
                              ;
                          }
                          e[C + 4 >> 2] = l;
                        }
                        if (C = C + 12 | 0, e[S + 28 >> 2] = C, y = y + 12 | 0, (I | 0) == (y | 0))
                          break;
                      }
                    return bi = S + 32 | 0, C | 0;
                  }
                  if (l = gi() | 0, y = e[C >> 2], !y)
                    break e;
                  e[C + 4 >> 2] = y, Tr(y);
                  break e;
                }
                l = gi() | 0;
              }
              y1(S + 8 | 0), ss(l | 0), jn();
            }
            function Pu(l, y) {
              var I = 0, C = 0, Q = 0;
              I = (l | 0) == (y | 0), Se[y + 12 | 0] = I;
              e: {
                if (I)
                  break e;
                for (; ; ) {
                  if (C = e[y + 8 >> 2], Je[C + 12 | 0])
                    break e;
                  t: {
                    if (I = e[C + 8 >> 2], Q = e[I >> 2], (Q | 0) == (C | 0)) {
                      if (Q = e[I + 4 >> 2], !(!Q | Je[Q + 12 | 0]))
                        break t;
                      r: {
                        if (e[C >> 2] == (y | 0)) {
                          y = C;
                          break r;
                        }
                        y = e[C + 4 >> 2], l = e[y >> 2], e[C + 4 >> 2] = l, l && (e[l + 8 >> 2] = C, I = e[C + 8 >> 2]), e[y + 8 >> 2] = I, l = e[C + 8 >> 2], e[((e[l >> 2] != (C | 0)) << 2) + l >> 2] = y, e[y >> 2] = C, e[C + 8 >> 2] = y, I = e[y + 8 >> 2], C = e[I >> 2];
                      }
                      Se[y + 12 | 0] = 1, Se[I + 12 | 0] = 0, l = e[C + 4 >> 2], e[I >> 2] = l, l && (e[l + 8 >> 2] = I), e[C + 8 >> 2] = e[I + 8 >> 2], l = e[I + 8 >> 2], e[((e[l >> 2] != (I | 0)) << 2) + l >> 2] = C, e[C + 4 >> 2] = I, e[I + 8 >> 2] = C;
                      return;
                    }
                    if (!(Je[Q + 12 | 0] | !Q))
                      break t;
                    r: {
                      if (e[C >> 2] != (y | 0)) {
                        y = C;
                        break r;
                      }
                      l = e[y + 4 >> 2], e[C >> 2] = l, l && (e[l + 8 >> 2] = C, I = e[C + 8 >> 2]), e[y + 8 >> 2] = I, l = e[C + 8 >> 2], e[((e[l >> 2] != (C | 0)) << 2) + l >> 2] = y, e[y + 4 >> 2] = C, e[C + 8 >> 2] = y, I = e[y + 8 >> 2];
                    }
                    Se[y + 12 | 0] = 1, Se[I + 12 | 0] = 0, l = e[I + 4 >> 2], y = e[l >> 2], e[I + 4 >> 2] = y, y && (e[y + 8 >> 2] = I), e[l + 8 >> 2] = e[I + 8 >> 2], y = e[I + 8 >> 2], e[((e[y >> 2] != (I | 0)) << 2) + y >> 2] = l, e[l >> 2] = I, e[I + 8 >> 2] = l;
                    break e;
                  }
                  if (Se[C + 12 | 0] = 1, Se[I + 12 | 0] = (l | 0) == (I | 0), Se[Q + 12 | 0] = 1, y = I, (l | 0) == (I | 0))
                    break;
                }
              }
            }
            function Ql(l, y, I) {
              l = l | 0, y = y | 0, I = I | 0;
              var C = 0, Q = 0, S = 0;
              e[l + 8 >> 2] = 0, e[l >> 2] = 0, e[l + 4 >> 2] = 0;
              e: {
                t: {
                  r: {
                    i: {
                      n: {
                        o: {
                          if (Q = e[y + 4 >> 2], C = e[y >> 2], (Q | 0) != (C | 0)) {
                            if (C = Q - C | 0, (C | 0) < 0) {
                              if (e[5996] = 0, jo(85), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                break o;
                              break e;
                            }
                            if (e[5996] = 0, Q = no(3, C | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                              break o;
                            if (e[l + 4 >> 2] = Q, e[l >> 2] = Q, e[l + 8 >> 2] = (C & -8) + Q, C = e[y >> 2], y = e[y + 4 >> 2], (C | 0) != (y | 0))
                              for (; zo[Q >> 3] = zo[C >> 3], Q = Q + 8 | 0, C = C + 8 | 0, (y | 0) != (C | 0); )
                                ;
                            e[l + 4 >> 2] = Q;
                          }
                          if (e[l + 12 >> 2] = 0, e[l + 16 >> 2] = 0, e[l + 20 >> 2] = 0, y = e[I + 4 >> 2], Q = e[I >> 2], (y | 0) == (Q | 0))
                            break i;
                          if (y = y - Q | 0, (y | 0) >= 0)
                            break n;
                          if (e[5996] = 0, jo(85), y = e[5996], e[5996] = 0, (y | 0) != 1)
                            break e;
                          break r;
                        }
                        C = gi() | 0;
                        break t;
                      }
                      if (e[5996] = 0, Q = no(3, y | 0) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1)
                        break r;
                      if (e[l + 16 >> 2] = Q, e[l + 12 >> 2] = Q, e[l + 20 >> 2] = (y & -8) + Q, C = e[I >> 2], y = e[I + 4 >> 2], (C | 0) != (y | 0))
                        for (; zo[Q >> 3] = zo[C >> 3], Q = Q + 8 | 0, C = C + 8 | 0, (y | 0) != (C | 0); )
                          ;
                      e[l + 16 >> 2] = Q;
                    }
                    return l | 0;
                  }
                  if (C = gi() | 0, y = e[l + 12 >> 2], !y)
                    break t;
                  e[l + 16 >> 2] = y, Tr(y);
                }
                y = e[l >> 2], y && (e[l + 4 >> 2] = y, Tr(y)), ss(C | 0), jn();
              }
              jn();
            }
            function _s(l, y, I) {
              l = l | 0, y = y | 0, I = I | 0;
              var C = 0, Q = 0, S = 0, me = 0, ke = 0, Ar = 0, br = 0, Qr = 0;
              C = bi - 32 | 0, bi = C, e[l + 8 >> 2] = 0, e[l + 12 >> 2] = 0, e[l + 4 >> 2] = I, e[l >> 2] = y, e[l + 16 >> 2] = 0, e[l + 20 >> 2] = 0, e[l + 24 >> 2] = 0, e[l + 28 >> 2] = 0, S = l + 32 | 0, e[S >> 2] = 0, e[S + 4 >> 2] = 0, e[l + 40 >> 2] = 0, e[5996] = 0, Co(86, l + 44 | 0, l | 0), y = e[5996], e[5996] = 0;
              e: {
                if ((y | 0) == 1 || (e[5996] = 0, Co(87, l - -64 | 0, l | 0), y = e[5996], e[5996] = 0, (y | 0) == 1) || (y = 0, e[5996] = 0, I = no(88, l | 0) | 0, Q = e[5996], e[5996] = 0, (Q | 0) == 1))
                  break e;
                if (e[l + 80 >> 2] = I, Q = e[l + 32 >> 2], me = e[l + 36 >> 2], (Q | 0) == (me | 0))
                  I = 0;
                else {
                  for (I = Q; y = e[e[I >> 2] + 84 >> 2] + y | 0, I = I + 8 | 0, (me | 0) != (I | 0); )
                    ;
                  I = e[e[Q >> 2] + 80 >> 2];
                }
                if (ke = e[l + 4 >> 2], Ar = e[l >> 2], br = e[l + 8 >> 2], Qr = e[l + 12 >> 2], e[5996] = 0, y = Cf(89, Ar | 0, I | 0, y | 0, ke | 0, me - Q >> 3, (Qr - br | 0) / 12 | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1 || (e[l + 84 >> 2] = y, e[5996] = 0, e[C + 28 >> 2] = l, Ms(90, C + 12 | 0, l | 0, C + 28 | 0), y = e[5996], e[5996] = 0, (y | 0) == 1))
                  break e;
                return y = Je[C + 24 | 0], y && Kf(e[C + 16 >> 2]), Se[l + 88 | 0] = y ^ 1, bi = C + 32 | 0, l | 0;
              }
              I = gi() | 0, Za(S), y = e[l + 20 >> 2], y && (e[l + 24 >> 2] = y, Tr(y)), hf(l + 8 | 0), ss(I | 0), jn();
            }
            function Fl(l, y, I) {
              l = l | 0, y = y | 0, I = I | 0;
              var C = 0, Q = 0, S = 0, me = 0, ke = 0, Ar = 0;
              e[l + 8 >> 2] = 0, e[l >> 2] = 0, e[l + 4 >> 2] = 0;
              e: {
                if (I) {
                  if (I >>> 0 >= 536870912) {
                    if (e[5996] = 0, jo(84), y = e[5996], e[5996] = 0, (y | 0) == 1)
                      break e;
                    jn();
                  }
                  if (e[5996] = 0, Q = I << 3, C = no(3, Q | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                    break e;
                  e[l + 4 >> 2] = C, e[l >> 2] = C, e[l + 8 >> 2] = C + Q, S = I - 1 & 536870911, me = I & 7;
                  t: {
                    if (!me) {
                      I = y;
                      break t;
                    }
                    for (I = y; Ar = e[I + 4 >> 2], e[C >> 2] = e[I >> 2], e[C + 4 >> 2] = Ar, C = C + 8 | 0, I = I + 8 | 0, ke = ke + 1 | 0, (ke | 0) != (me | 0); )
                      ;
                  }
                  if (S >>> 0 >= 7)
                    for (y = y + Q | 0; Q = e[I + 4 >> 2], e[C >> 2] = e[I >> 2], e[C + 4 >> 2] = Q, Q = e[I + 12 >> 2], e[C + 8 >> 2] = e[I + 8 >> 2], e[C + 12 >> 2] = Q, Q = e[I + 20 >> 2], e[C + 16 >> 2] = e[I + 16 >> 2], e[C + 20 >> 2] = Q, Q = e[I + 28 >> 2], e[C + 24 >> 2] = e[I + 24 >> 2], e[C + 28 >> 2] = Q, Q = e[I + 36 >> 2], e[C + 32 >> 2] = e[I + 32 >> 2], e[C + 36 >> 2] = Q, Q = e[I + 44 >> 2], e[C + 40 >> 2] = e[I + 40 >> 2], e[C + 44 >> 2] = Q, Q = e[I + 52 >> 2], e[C + 48 >> 2] = e[I + 48 >> 2], e[C + 52 >> 2] = Q, Q = e[I + 60 >> 2], e[C + 56 >> 2] = e[I + 56 >> 2], e[C + 60 >> 2] = Q, C = C - -64 | 0, I = I - -64 | 0, (y | 0) != (I | 0); )
                      ;
                  e[l + 4 >> 2] = C;
                }
                return l | 0;
              }
              I = gi() | 0, y = e[l >> 2], y && (e[l + 4 >> 2] = y, Tr(y)), ss(I | 0), jn();
            }
            function th(l, y, I, C) {
              var Q = 0, S = 0, me = 0, ke = 0;
              me = bi - 32 | 0, bi = me, Q = C & 2147483647, ke = Q, S = Q - 1006698496 | 0, Q = Q - 1140785152 | 0;
              e: {
                if ((S | 0) == (Q | 0) & 0 | Q >>> 0 > S >>> 0) {
                  if (Q = I << 4 | y >>> 28, I = C << 4 | I >>> 28, y = y & 268435455, (y | 0) == 134217728 & (l | 0) != 0 | y >>> 0 > 134217728) {
                    S = I + 1073741824 | 0, Q = Q + 1 | 0, S = Q ? S : S + 1 | 0;
                    break e;
                  }
                  if (S = I + 1073741824 | 0, l | (y | 0) != 134217728)
                    break e;
                  l = Q & 1, Q = l + Q | 0, S = l >>> 0 > Q >>> 0 ? S + 1 | 0 : S;
                  break e;
                }
                if (!(!I & (ke | 0) == 2147418112 ? !(l | y) : ke >>> 0 < 2147418112)) {
                  l = C << 4 | I >>> 28, Q = I << 4 | y >>> 28, S = l & 524287 | 2146959360;
                  break e;
                }
                if (Q = 0, S = 2146435072, ke >>> 0 > 1140785151 || (S = 0, ke = ke >>> 16 | 0, ke >>> 0 < 15249))
                  break e;
                if (Q = C & 65535 | 65536, Es(me + 16 | 0, l, y, I, Q, ke - 15233 | 0), fn(me, l, y, I, Q, 15361 - ke | 0), y = e[me + 8 >> 2], Q = y << 4, y = e[me + 12 >> 2] << 4 | y >>> 28, I = e[me >> 2], S = e[me + 4 >> 2], ke = S, Q = S >>> 28 | Q, S = y, l = ke & 268435455, y = I | (e[me + 16 >> 2] | e[me + 24 >> 2] | (e[me + 20 >> 2] | e[me + 28 >> 2])) != 0, (l | 0) == 134217728 & (y | 0) != 0 | l >>> 0 > 134217728) {
                  Q = Q + 1 | 0, S = Q ? S : S + 1 | 0;
                  break e;
                }
                if (y | (l | 0) != 134217728)
                  break e;
                l = Q, Q = Q + (Q & 1) | 0, S = l >>> 0 > Q >>> 0 ? S + 1 | 0 : S;
              }
              return bi = me + 32 | 0, wa(0, Q | 0), wa(1, C & -2147483648 | S), +Pa();
            }
            function Qh(l, y) {
              l = l | 0, y = y | 0;
              var I = 0, C = 0, Q = 0, S = 0, me = 0, ke = 0, Ar = 0, br = 0;
              if (C = bi - 16 | 0, bi = C, e[C + 12 >> 2] = y, y >>> 0 < 2147483632) {
                e: {
                  if (((Je[l + 11 | 0] & 128) >>> 7 | 0 ? (e[l + 8 >> 2] & 2147483647) - 1 | 0 : 10) >>> 0 >= y >>> 0 || (y = Je[l + 11 | 0], e[C + 8 >> 2] = (y & 128) >>> 7 | 0 ? e[l + 4 >> 2] : y & 127, I = e[(qs[C + 12 >> 2] < qs[C + 8 >> 2] ? C + 8 | 0 : C + 12 | 0) >> 2], I >>> 0 >= 11 ? (I = I + 16 & -16, Q = I - 1 | 0, I = (Q | 0) == 11 ? I : Q) : I = 10, (I | 0) == (((Je[l + 11 | 0] & 128) >>> 7 | 0 ? (e[l + 8 >> 2] & 2147483647) - 1 | 0 : 10) | 0)))
                    break e;
                  S = bi - 16 | 0, bi = S, y = Je[l + 11 | 0], Q = (y & 128) >>> 7 | 0 ? e[l + 4 >> 2] : y & 127;
                  t: {
                    r: {
                      Ar = I >>> 0 < 11;
                      i: {
                        if (Ar) {
                          br = 1, me = I + 1 | 0, ke = e[l >> 2], I = Q, y = l;
                          break i;
                        }
                        me = I + 1 | 0;
                        n: {
                          if (I >>> 0 > ((Je[l + 11 | 0] & 128) >>> 7 | 0 ? (e[l + 8 >> 2] & 2147483647) - 1 | 0 : 10) >>> 0) {
                            gh(S + 8 | 0, me);
                            break n;
                          }
                          if (e[5996] = 0, Co(289, S + 8 | 0, me | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                            break r;
                        }
                        me = e[S + 12 >> 2], I = Je[l + 11 | 0], y = (I & 128) >>> 7 | 0, br = y, ke = y ? e[l >> 2] : l, I = y ? e[l + 4 >> 2] : I & 127, y = e[S + 8 >> 2];
                      }
                      if (y = Gc(y, ke, I + 1 | 0), br && Tr(ke), !Ar) {
                        e[l + 8 >> 2] = me | -2147483648, e[l + 4 >> 2] = Q, e[l >> 2] = y;
                        break t;
                      }
                      Se[l + 11 | 0] = Q;
                      break t;
                    }
                    Zf(Ws(0) | 0) | 0, $a();
                  }
                  bi = S + 16 | 0;
                }
                bi = C + 16 | 0;
                return;
              }
              xf(), jn();
            }
            function ih(l) {
              var y = 0, I = 0, C = 0, Q = 0, S = 0;
              C = e[5726], I = l + 7 & -8, y = C + I | 0;
              e: {
                t: {
                  if (y >>> 0 <= C >>> 0 && I || y >>> 0 > d8() << 16 >>> 0 && !(Zs(y | 0) | 0))
                    break t;
                  e[5726] = y;
                  break e;
                }
                e[5732] = 48, C = -1;
              }
              if ((C | 0) != -1) {
                l = l + C | 0, e[l - 4 >> 2] = 16, I = l - 16 | 0, e[I >> 2] = 16, y = e[5992], y ? S = e[y + 8 >> 2] : S = 0;
                e: {
                  t: {
                    if ((S | 0) == (C | 0)) {
                      if (Q = C - (e[C - 4 >> 2] & -2) | 0, S = e[Q - 4 >> 2], e[y + 8 >> 2] = l, l = Q - (S & -2) | 0, y = -16, !(Se[(l + e[l >> 2] | 0) - 4 | 0] & 1))
                        break t;
                      y = e[l + 4 >> 2], e[y + 8 >> 2] = e[l + 8 >> 2], e[e[l + 8 >> 2] + 4 >> 2] = y, y = I - l | 0, e[l >> 2] = y;
                      break e;
                    }
                    e[C + 12 >> 2] = 16, e[C >> 2] = 16, e[C + 8 >> 2] = l, e[C + 4 >> 2] = y, e[5992] = C, y = 16;
                  }
                  l = y + C | 0, y = I - l | 0, e[l >> 2] = y;
                }
                e[((y & -4) + l | 0) - 4 >> 2] = y | 1, I = e[l >> 2] - 8 | 0;
                e: {
                  if (I >>> 0 <= 127) {
                    y = (I >>> 3 | 0) - 1 | 0;
                    break e;
                  }
                  if (Q = Ha(I), y = ((I >>> 29 - Q ^ 4) - (Q << 2) | 0) + 110 | 0, I >>> 0 <= 4095)
                    break e;
                  y = ((I >>> 30 - Q ^ 2) - (Q << 1) | 0) + 71 | 0, y = y >>> 0 >= 63 ? 63 : y;
                }
                I = y << 4, e[l + 4 >> 2] = I + 22944, I = I + 22952 | 0, e[l + 8 >> 2] = e[I >> 2], e[I >> 2] = l, e[e[l + 8 >> 2] + 4 >> 2] = l, I = e[5994], Q = e[5995], l = y & 31, (y & 63) >>> 0 >= 32 ? (y = 1 << l, S = 0) : (S = 1 << l, y = S - 1 & 1 >>> 32 - l), e[5994] = S | I, e[5995] = y | Q;
              }
              return (C | 0) != -1;
            }
            function Fh(l, y, I, C, Q, S, me, ke) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0, me = me | 0, ke = ke | 0, l = bi - 16 | 0, bi = l, e[l + 12 >> 2] = I, e[l + 8 >> 2] = S, e[l + 12 >> 2] = I, e[l + 8 >> 2] = S, y = e[l + 12 >> 2];
              e: {
                for (; ; ) {
                  if (y >>> 0 >= C >>> 0) {
                    I = 0;
                    break e;
                  }
                  if (I = 2, y = e[y >> 2], y >>> 0 > 1114111 | (y & -2048) == 55296)
                    break e;
                  t: {
                    r: {
                      if (y >>> 0 <= 127) {
                        if (I = 1, S = e[l + 8 >> 2], (me - S | 0) <= 0)
                          break e;
                        e[l + 8 >> 2] = S + 1, Se[S | 0] = y;
                        break r;
                      }
                      if (y >>> 0 <= 2047) {
                        if (I = e[l + 8 >> 2], (me - I | 0) < 2)
                          break t;
                        e[l + 8 >> 2] = I + 1, Se[I | 0] = y >>> 6 | 192, I = e[l + 8 >> 2], e[l + 8 >> 2] = I + 1, Se[I | 0] = y & 63 | 128;
                        break r;
                      }
                      if (I = e[l + 8 >> 2], S = me - I | 0, y >>> 0 <= 65535) {
                        if ((S | 0) < 3)
                          break t;
                        e[l + 8 >> 2] = I + 1, Se[I | 0] = y >>> 12 | 224, I = e[l + 8 >> 2], e[l + 8 >> 2] = I + 1, Se[I | 0] = y >>> 6 & 63 | 128, I = e[l + 8 >> 2], e[l + 8 >> 2] = I + 1, Se[I | 0] = y & 63 | 128;
                        break r;
                      }
                      if ((S | 0) < 4)
                        break t;
                      e[l + 8 >> 2] = I + 1, Se[I | 0] = y >>> 18 | 240, I = e[l + 8 >> 2], e[l + 8 >> 2] = I + 1, Se[I | 0] = y >>> 12 & 63 | 128, I = e[l + 8 >> 2], e[l + 8 >> 2] = I + 1, Se[I | 0] = y >>> 6 & 63 | 128, I = e[l + 8 >> 2], e[l + 8 >> 2] = I + 1, Se[I | 0] = y & 63 | 128;
                    }
                    y = e[l + 12 >> 2] + 4 | 0, e[l + 12 >> 2] = y;
                    continue;
                  }
                  break;
                }
                I = 1;
              }
              return e[Q >> 2] = e[l + 12 >> 2], e[ke >> 2] = e[l + 8 >> 2], bi = l + 16 | 0, I | 0;
            }
            function nh(l) {
              var y = 0, I = 0, C = 0, Q = 0, S = 0;
              e[l + 8 >> 2] = 0, e[l >> 2] = 0, e[l + 4 >> 2] = 0;
              e: {
                t: {
                  r: {
                    i: {
                      n: {
                        o: {
                          if (I = e[6141], C = e[6142], (I | 0) != (C | 0)) {
                            if (Q = C - I | 0, (Q | 0) < 0) {
                              if (e[5996] = 0, jo(85), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                break o;
                              break e;
                            }
                            if (e[5996] = 0, y = no(3, Q | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                              break o;
                            for (e[l + 4 >> 2] = y, e[l >> 2] = y, e[l + 8 >> 2] = (Q & -8) + y; zo[y >> 3] = zo[I >> 3], y = y + 8 | 0, I = I + 8 | 0, (C | 0) != (I | 0); )
                              ;
                            e[l + 4 >> 2] = y;
                          }
                          if (e[l + 12 >> 2] = 0, e[l + 16 >> 2] = 0, e[l + 20 >> 2] = 0, I = e[6144], C = e[6145], (I | 0) == (C | 0))
                            break i;
                          if (Q = C - I | 0, (Q | 0) >= 0)
                            break n;
                          if (e[5996] = 0, jo(85), y = e[5996], e[5996] = 0, (y | 0) != 1)
                            break e;
                          break r;
                        }
                        I = gi() | 0;
                        break t;
                      }
                      if (e[5996] = 0, y = no(3, Q | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                        break r;
                      for (e[l + 16 >> 2] = y, e[l + 12 >> 2] = y, e[l + 20 >> 2] = (Q & -8) + y; zo[y >> 3] = zo[I >> 3], y = y + 8 | 0, I = I + 8 | 0, (C | 0) != (I | 0); )
                        ;
                      e[l + 16 >> 2] = y;
                    }
                    return l;
                  }
                  if (I = gi() | 0, y = e[l + 12 >> 2], !y)
                    break t;
                  e[l + 16 >> 2] = y, Tr(y);
                }
                y = e[l >> 2], y && (e[l + 4 >> 2] = y, Tr(y)), ss(I | 0), jn();
              }
              jn();
            }
            function oh(l, y, I, C, Q) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0;
              var S = 0, me = 0, ke = 0, Ar = 0;
              for (y = 0, l = I; ; ) {
                e: {
                  if (l >>> 0 >= C >>> 0 | y >>> 0 >= Q >>> 0)
                    break e;
                  me = 1, S = Se[l | 0];
                  t: {
                    if ((S | 0) >= 0)
                      break t;
                    if (S >>> 0 < 4294967234)
                      break e;
                    if (S >>> 0 <= 4294967263) {
                      if ((C - l | 0) < 2 || (me = 2, (Je[l + 1 | 0] & 192) != 128))
                        break e;
                      break t;
                    }
                    if (me = S & 255, S >>> 0 <= 4294967279) {
                      if ((C - l | 0) < 3)
                        break e;
                      ke = Je[l + 2 | 0], S = Je[l + 1 | 0];
                      r: {
                        i: {
                          if ((me | 0) != 237) {
                            if ((me | 0) != 224)
                              break i;
                            if ((S & 224) == 160)
                              break r;
                            break e;
                          }
                          if ((S & 224) != 128)
                            break e;
                          break r;
                        }
                        if ((S & 192) != 128)
                          break e;
                      }
                      if (me = 3, (ke & 192) != 128)
                        break e;
                      break t;
                    }
                    if ((C - l | 0) < 4 | S >>> 0 > 4294967284 | Q - y >>> 0 < 2)
                      break e;
                    ke = Je[l + 3 | 0], Ar = Je[l + 2 | 0], S = Je[l + 1 | 0];
                    r: {
                      i:
                        switch (me - 240 | 0) {
                          case 0:
                            if ((S + 112 & 255) >>> 0 >= 48)
                              break e;
                            break r;
                          case 4:
                            if ((S & 240) != 128)
                              break e;
                            break r;
                          default:
                            break i;
                        }
                      if ((S & 192) != 128)
                        break e;
                    }
                    if ((Ar & 192) != 128 | (ke & 192) != 128 | (me << 18 & 1835008 | (S & 48) << 12) >>> 0 > 1114111)
                      break e;
                    y = y + 1 | 0, me = 4;
                  }
                  y = y + 1 | 0, l = l + me | 0;
                  continue;
                }
                break;
              }
              return l - I | 0;
            }
            function Mu(l, y) {
              l = l | 0, y = y | 0;
              var I = 0, C = 0, Q = 0, S = 0, me = 0, ke = 0;
              I = bi - 32 | 0, bi = I, e[l + 8 >> 2] = 0, e[l >> 2] = 0, e[l + 4 >> 2] = 0, Se[I + 4 | 0] = 0, e[I >> 2] = l, Q = e[y + 4 >> 2], S = e[y >> 2], me = Q - S | 0, C = (me | 0) / 12 | 0;
              e: {
                t: {
                  r: {
                    if ((Q | 0) != (S | 0)) {
                      if (C >>> 0 >= 357913942) {
                        if (e[5996] = 0, jo(41), l = e[5996], e[5996] = 0, (l | 0) == 1)
                          break r;
                        jn();
                      }
                      if (e[5996] = 0, Q = no(3, me | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                        break r;
                      e[l + 4 >> 2] = Q, e[l >> 2] = Q, e[l + 8 >> 2] = Q + No(C, 12), S = e[y + 4 >> 2], y = e[y >> 2], e[I + 28 >> 2] = Q, e[I + 24 >> 2] = Q, Se[I + 20 | 0] = 0, e[I + 8 >> 2] = l + 8, e[I + 16 >> 2] = I + 28, e[I + 12 >> 2] = I + 24;
                      i: {
                        if ((y | 0) == (S | 0)) {
                          C = Q;
                          break i;
                        }
                        for (C = Q; ; ) {
                          n: {
                            if (Se[y + 11 | 0] >= 0) {
                              me = e[y + 4 >> 2], e[C >> 2] = e[y >> 2], e[C + 4 >> 2] = me, e[C + 8 >> 2] = e[y + 8 >> 2];
                              break n;
                            }
                            if (me = e[y + 4 >> 2], ke = e[y >> 2], e[5996] = 0, Ms(40, C | 0, ke | 0, me | 0), C = e[5996], e[5996] = 0, (C | 0) == 1)
                              break t;
                            C = e[I + 28 >> 2];
                          }
                          if (C = C + 12 | 0, e[I + 28 >> 2] = C, y = y + 12 | 0, (S | 0) == (y | 0))
                            break;
                        }
                      }
                      e[l + 4 >> 2] = C;
                    }
                    return bi = I + 32 | 0, l | 0;
                  }
                  y = gi() | 0;
                  break e;
                }
                y = gi() | 0, pd(I + 8 | 0), e[l + 4 >> 2] = Q;
              }
              fd(I), ss(y | 0), jn();
            }
            function pf(l, y, I, C, Q) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0;
              var S = 0, me = 0, ke = 0, Ar = 0;
              for (l = I; ; ) {
                e: {
                  if (Q >>> 0 <= Ar >>> 0 | l >>> 0 >= C >>> 0)
                    break e;
                  S = 1, y = Se[l | 0];
                  t: {
                    if ((y | 0) >= 0)
                      break t;
                    if (y >>> 0 < 4294967234)
                      break e;
                    if (y >>> 0 <= 4294967263) {
                      if ((C - l | 0) < 2 || (S = 2, (Je[l + 1 | 0] & 192) != 128))
                        break e;
                      break t;
                    }
                    if (me = y & 255, y >>> 0 <= 4294967279) {
                      if ((C - l | 0) < 3)
                        break e;
                      ke = Je[l + 2 | 0], y = Je[l + 1 | 0];
                      r: {
                        i: {
                          if ((me | 0) != 237) {
                            if ((me | 0) != 224)
                              break i;
                            if ((y & 224) == 160)
                              break r;
                            break e;
                          }
                          if ((y & 224) != 128)
                            break e;
                          break r;
                        }
                        if ((y & 192) != 128)
                          break e;
                      }
                      if (S = 3, (ke & 192) != 128)
                        break e;
                      break t;
                    }
                    if ((C - l | 0) < 4 | y >>> 0 > 4294967284)
                      break e;
                    S = Je[l + 3 | 0], ke = Je[l + 2 | 0], y = Je[l + 1 | 0];
                    r: {
                      i:
                        switch (me - 240 | 0) {
                          case 0:
                            if ((y + 112 & 255) >>> 0 >= 48)
                              break e;
                            break r;
                          case 4:
                            if ((y & 240) != 128)
                              break e;
                            break r;
                          default:
                            break i;
                        }
                      if ((y & 192) != 128)
                        break e;
                    }
                    if ((ke & 192) != 128 | (S & 192) != 128 || (S = 4, (me << 18 & 1835008 | (y & 48) << 12) >>> 0 > 1114111))
                      break e;
                  }
                  Ar = Ar + 1 | 0, l = l + S | 0;
                  continue;
                }
                break;
              }
              return l - I | 0;
            }
            function Ra(l, y, I, C, Q, S, me, ke, Ar, br) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0, me = me | 0, ke = ke | 0, Ar = Ar | 0, br = br | 0;
              var Qr = 0, Ur = 0;
              Qr = bi - 16 | 0, bi = Qr, Ur = br;
              e: {
                if (l) {
                  br = Qr + 4 | 0, l = Pp(y), Yn[e[e[l >> 2] + 44 >> 2]](br, l), y = e[Qr + 4 >> 2], Se[I | 0] = y, Se[I + 1 | 0] = y >>> 8, Se[I + 2 | 0] = y >>> 16, Se[I + 3 | 0] = y >>> 24, Yn[e[e[l >> 2] + 32 >> 2]](br, l), Hf(Ar, br), Yo(br), Yn[e[e[l >> 2] + 28 >> 2]](br, l), Hf(ke, br), Yo(br), Se[C | 0] = Yn[e[e[l >> 2] + 12 >> 2]](l), Se[Q | 0] = Yn[e[e[l >> 2] + 16 >> 2]](l), Yn[e[e[l >> 2] + 20 >> 2]](br, l), Hf(S, br), Yo(br), Yn[e[e[l >> 2] + 24 >> 2]](br, l), Hf(me, br), Yo(Qr + 4 | 0), l = Yn[e[e[l >> 2] + 36 >> 2]](l) | 0;
                  break e;
                }
                br = Qr + 4 | 0, l = Mp(y), Yn[e[e[l >> 2] + 44 >> 2]](br, l), y = e[Qr + 4 >> 2], Se[I | 0] = y, Se[I + 1 | 0] = y >>> 8, Se[I + 2 | 0] = y >>> 16, Se[I + 3 | 0] = y >>> 24, Yn[e[e[l >> 2] + 32 >> 2]](br, l), Hf(Ar, br), Yo(br), Yn[e[e[l >> 2] + 28 >> 2]](br, l), Hf(ke, br), Yo(br), Se[C | 0] = Yn[e[e[l >> 2] + 12 >> 2]](l), Se[Q | 0] = Yn[e[e[l >> 2] + 16 >> 2]](l), Yn[e[e[l >> 2] + 20 >> 2]](br, l), Hf(S, br), Yo(br), Yn[e[e[l >> 2] + 24 >> 2]](br, l), Hf(me, br), Yo(Qr + 4 | 0), l = Yn[e[e[l >> 2] + 36 >> 2]](l) | 0;
              }
              e[Ur >> 2] = l, bi = Qr + 16 | 0;
            }
            function Js(l, y, I, C, Q, S, me, ke, Ar, br) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0, me = me | 0, ke = ke | 0, Ar = Ar | 0, br = br | 0;
              var Qr = 0, Ur = 0;
              Qr = bi - 16 | 0, bi = Qr, Ur = br;
              e: {
                if (l) {
                  br = Qr + 4 | 0, l = Np(y), Yn[e[e[l >> 2] + 44 >> 2]](br, l), y = e[Qr + 4 >> 2], Se[I | 0] = y, Se[I + 1 | 0] = y >>> 8, Se[I + 2 | 0] = y >>> 16, Se[I + 3 | 0] = y >>> 24, Yn[e[e[l >> 2] + 32 >> 2]](br, l), Kc(Ar, br), Yo(br), Yn[e[e[l >> 2] + 28 >> 2]](br, l), Kc(ke, br), Yo(br), e[C >> 2] = Yn[e[e[l >> 2] + 12 >> 2]](l), e[Q >> 2] = Yn[e[e[l >> 2] + 16 >> 2]](l), Yn[e[e[l >> 2] + 20 >> 2]](br, l), Hf(S, br), Yo(br), Yn[e[e[l >> 2] + 24 >> 2]](br, l), Kc(me, br), Yo(br), l = Yn[e[e[l >> 2] + 36 >> 2]](l) | 0;
                  break e;
                }
                br = Qr + 4 | 0, l = Up(y), Yn[e[e[l >> 2] + 44 >> 2]](br, l), y = e[Qr + 4 >> 2], Se[I | 0] = y, Se[I + 1 | 0] = y >>> 8, Se[I + 2 | 0] = y >>> 16, Se[I + 3 | 0] = y >>> 24, Yn[e[e[l >> 2] + 32 >> 2]](br, l), Kc(Ar, br), Yo(br), Yn[e[e[l >> 2] + 28 >> 2]](br, l), Kc(ke, br), Yo(br), e[C >> 2] = Yn[e[e[l >> 2] + 12 >> 2]](l), e[Q >> 2] = Yn[e[e[l >> 2] + 16 >> 2]](l), Yn[e[e[l >> 2] + 20 >> 2]](br, l), Hf(S, br), Yo(br), Yn[e[e[l >> 2] + 24 >> 2]](br, l), Kc(me, br), Yo(br), l = Yn[e[e[l >> 2] + 36 >> 2]](l) | 0;
              }
              e[Ur >> 2] = l, bi = Qr + 16 | 0;
            }
            function Fa(l) {
              var y = 0, I = 0, C = 0, Q = 0, S = 0, me = 0, ke = 0, Ar = 0, br = 0;
              y = e[l + 112 >> 2], C = e[l + 116 >> 2], me = (y | C) != 0, ke = y, I = e[l + 4 >> 2], S = e[l + 44 >> 2], y = I - S | 0, Ar = y, Q = y + e[l + 120 >> 2] | 0, y = e[l + 124 >> 2] + (y >> 31) | 0;
              e: {
                if (y = Q >>> 0 < Ar >>> 0 ? y + 1 | 0 : y, !(((y | 0) >= (C | 0) & Q >>> 0 >= ke >>> 0 | (y | 0) > (C | 0)) & me)) {
                  C = bi - 16 | 0, bi = C, I = -1;
                  t: {
                    if (sd(l) || (Yn[e[l + 32 >> 2]](l, C + 15 | 0, 1) | 0) != 1)
                      break t;
                    I = Je[C + 15 | 0];
                  }
                  if (bi = C + 16 | 0, C = I, (I | 0) >= 0)
                    break e;
                  S = e[l + 44 >> 2], I = e[l + 4 >> 2];
                }
                return e[l + 112 >> 2] = -1, e[l + 116 >> 2] = -1, e[l + 104 >> 2] = I, C = S - I | 0, I = C + Q | 0, y = (C >> 31) + y | 0, e[l + 120 >> 2] = I, e[l + 124 >> 2] = I >>> 0 < C >>> 0 ? y + 1 | 0 : y, -1;
              }
              I = Q + 1 | 0, y = I ? y : y + 1 | 0, ke = e[l + 4 >> 2], S = e[l + 8 >> 2], Q = e[l + 116 >> 2], Ar = Q, me = e[l + 112 >> 2];
              e: {
                if (!(Q | me) || (Q = me - I | 0, me = Ar - (y + (I >>> 0 > me >>> 0) | 0) | 0, br = S - ke | 0, Ar = br >> 31, (me | 0) >= (Ar | 0) & Q >>> 0 >= br >>> 0 | (me | 0) > (Ar | 0)))
                  break e;
                S = Q + ke | 0;
              }
              return e[l + 104 >> 2] = S, Q = e[l + 44 >> 2], S = Q - ke | 0, I = S + I | 0, y = (S >> 31) + y | 0, e[l + 120 >> 2] = I, e[l + 124 >> 2] = I >>> 0 < S >>> 0 ? y + 1 | 0 : y, Q >>> 0 >= ke >>> 0 && (Se[ke - 1 | 0] = C), C;
            }
            function Ll(l, y) {
              l = l | 0, y = y | 0;
              var I = 0, C = 0, Q = 0, S = 0, me = 0, ke = 0, Ar = 0, br = 0, Qr = 0;
              me = bi - 16 | 0, bi = me;
              e: {
                t: {
                  if ((y | 0) != -1) {
                    if (Ar = e[l + 8 >> 2], br = e[l + 12 >> 2], C = e[l + 24 >> 2], (C | 0) == e[l + 28 >> 2]) {
                      if (Q = -1, !(Je[l + 48 | 0] & 16))
                        break e;
                      if (Qr = e[l + 44 >> 2], ke = e[l + 20 >> 2], e[5996] = 0, I = l + 32 | 0, Co(98, I | 0, 0), S = e[5996], e[5996] = 0, (S | 0) == 1 || (S = (Je[I + 11 | 0] & 128) >>> 7 | 0 ? (e[I + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, Co(172, I | 0, S | 0), S = e[5996], e[5996] = 0, (S | 0) == 1))
                        break t;
                      I = (Je[I + 11 | 0] & 128) >>> 7 | 0 ? e[I >> 2] : I, Q = Je[l + 43 | 0], e[l + 28 >> 2] = I + ((Q & 128) >>> 7 | 0 ? e[l + 36 >> 2] : Q & 127), e[l + 20 >> 2] = I, e[l + 24 >> 2] = I, e[l + 24 >> 2] = e[l + 24 >> 2] + (C - ke | 0), e[l + 44 >> 2] = e[l + 20 >> 2] + (Qr - ke | 0), C = e[l + 24 >> 2];
                    }
                    e[me + 12 >> 2] = C + 1, C = l + 44 | 0, I = me + 12 | 0, I = e[(qs[I >> 2] < qs[C >> 2] ? C : I) >> 2], e[l + 44 >> 2] = I, Je[l + 48 | 0] & 8 && (C = l + 32 | 0, C = (Je[C + 11 | 0] & 128) >>> 7 | 0 ? e[C >> 2] : C, e[l + 16 >> 2] = I, e[l + 12 >> 2] = C + (br - Ar | 0), e[l + 8 >> 2] = C), Q = xd(l, y << 24 >> 24);
                    break e;
                  }
                  Q = (y | 0) != -1 ? y : 0;
                  break e;
                }
                Zf(Ws(0) | 0) | 0, $a();
              }
              return bi = me + 16 | 0, Q | 0;
            }
            function Lh(l, y, I, C) {
              var Q = 0, S = 0, me = 0, ke = 0;
              me = bi - 32 | 0, bi = me, S = C & 2147483647, Q = S - 1065418752 | 0, ke = S - 1082064896 | 0;
              e: {
                if ((Q | 0) == (ke | 0) & 0 | Q >>> 0 < ke >>> 0) {
                  if (S = (C & 33554431) << 7 | I >>> 25, Q = 0, ke = Q, I = I & 33554431, !(!Q & (I | 0) == 16777216 ? !(l | y) : !Q & I >>> 0 < 16777216)) {
                    Q = S + 1073741825 | 0;
                    break e;
                  }
                  if (Q = S + 1073741824 | 0, I ^ 16777216 | l | (y | ke))
                    break e;
                  Q = (S & 1) + Q | 0;
                  break e;
                }
                if (!(!I & (S | 0) == 2147418112 ? !(l | y) : S >>> 0 < 2147418112)) {
                  Q = ((C & 33554431) << 7 | I >>> 25) & 4194303 | 2143289344;
                  break e;
                }
                if (Q = 2139095040, S >>> 0 > 1082064895 || (Q = 0, S = S >>> 16 | 0, S >>> 0 < 16145))
                  break e;
                if (Q = C & 65535 | 65536, Es(me + 16 | 0, l, y, I, Q, S - 16129 | 0), fn(me, l, y, I, Q, 16257 - S | 0), l = e[me + 8 >> 2], Q = (e[me + 12 >> 2] & 33554431) << 7 | l >>> 25, I = e[me >> 2] | (e[me + 16 >> 2] | e[me + 24 >> 2] | (e[me + 20 >> 2] | e[me + 28 >> 2])) != 0, S = e[me + 4 >> 2], y = 0, l = l & 33554431, !(!y & (l | 0) == 16777216 ? !(I | S) : !y & l >>> 0 < 16777216)) {
                  Q = Q + 1 | 0;
                  break e;
                }
                if (l ^ 16777216 | I | (y | S))
                  break e;
                Q = (Q & 1) + Q | 0;
              }
              return bi = me + 32 | 0, wa(2, C & -2147483648 | Q), ta();
            }
            function wc(l, y, I) {
              var C = 0, Q = 0, S = 0, me = 0, ke = 0, Ar = 0, br = 0, Qr = 0, Ur = 0;
              e: {
                t: {
                  r: {
                    i: {
                      n: {
                        o: {
                          a: {
                            s: {
                              A: {
                                u: {
                                  if (y) {
                                    if (!I)
                                      break u;
                                    break A;
                                  }
                                  Ci = 0, l = (l >>> 0) / (I >>> 0) | 0;
                                  break e;
                                }
                                if (!l)
                                  break s;
                                break a;
                              }
                              if (!(I - 1 & I))
                                break o;
                              S = (Ha(I) + 33 | 0) - Ha(y) | 0, me = 0 - S | 0;
                              break i;
                            }
                            Ci = 0, l = (y >>> 0) / 0 | 0;
                            break e;
                          }
                          if (C = 32 - Ha(y) | 0, C >>> 0 < 31)
                            break n;
                          break r;
                        }
                        if ((I | 0) == 1)
                          break t;
                        S = I ? 31 - Ha(I - 1 ^ I) | 0 : 32, I = S & 31, (S & 63) >>> 0 >= 32 ? l = y >>> I | 0 : (C = y >>> I | 0, l = ((1 << I) - 1 & y) << 32 - I | l >>> I), Ci = C;
                        break e;
                      }
                      S = C + 1 | 0, me = 63 - C | 0;
                    }
                    if (C = S & 63, Q = C & 31, C >>> 0 >= 32 ? (C = 0, ke = y >>> Q | 0) : (C = y >>> Q | 0, ke = ((1 << Q) - 1 & y) << 32 - Q | l >>> Q), me = me & 63, Q = me & 31, me >>> 0 >= 32 ? (y = l << Q, l = 0) : (y = (1 << Q) - 1 & l >>> 32 - Q | y << Q, l = l << Q), S)
                      for (me = I - 1 | 0, Ur = (me | 0) == -1 ? -1 : 0; Ar = C << 1 | ke >>> 31, C = ke << 1 | y >>> 31, Q = Ur - (Ar + (C >>> 0 > me >>> 0) | 0) >> 31, br = I & Q, ke = C - br | 0, C = Ar - (C >>> 0 < br >>> 0) | 0, y = y << 1 | l >>> 31, l = Qr | l << 1, Qr = Q & 1, S = S - 1 | 0, !!S; )
                        ;
                    Ci = y << 1 | l >>> 31, l = Qr | l << 1;
                    break e;
                  }
                  l = 0, y = 0;
                }
                Ci = y;
              }
              return l;
            }
            function ql(l, y, I, C, Q, S) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0;
              var me = 0, ke = 0, Ar = 0, br = 0, Qr = 0, Ur = 0, Xr = 0, Ri = 0, yn = 0;
              Ar = e[y + 44 >> 2], br = e[y + 24 >> 2], Ar >>> 0 < br >>> 0 && (e[y + 44 >> 2] = br, Ar = br), Xr = -1, Ri = -1, yn = S & 24;
              e: {
                if (!yn | (Q | 0) == 1 & (yn | 0) == 24)
                  break e;
                Ar && (me = y + 32 | 0, me = Ar - ((Je[me + 11 | 0] & 128) >>> 7 | 0 ? e[me >> 2] : me) | 0, Qr = me >> 31);
                t: {
                  r:
                    switch (Q | 0) {
                      case 1:
                        if (S & 8) {
                          ke = e[y + 12 >> 2] - e[y + 8 >> 2] | 0, Ur = ke >> 31;
                          break t;
                        }
                        ke = br - e[y + 20 >> 2] | 0, Ur = ke >> 31;
                        break t;
                      case 0:
                        break t;
                      case 2:
                        break r;
                      default:
                        break e;
                    }
                  ke = me, Ur = Qr;
                }
                if (C = C + Ur | 0, I = I + ke | 0, C = ke >>> 0 > I >>> 0 ? C + 1 | 0 : C, (C | 0) < 0 | (I >>> 0 > me >>> 0 & (C | 0) >= (Qr | 0) | (C | 0) > (Qr | 0)))
                  break e;
                Q = S & 8;
                t: {
                  if (!(I | C))
                    break t;
                  if (!e[y + 12 >> 2] && Q)
                    break e;
                  if (!(S & 16))
                    break t;
                  if (!br)
                    break e;
                }
                Q && (Q = e[y + 8 >> 2], e[y + 16 >> 2] = Ar, e[y + 12 >> 2] = I + Q, e[y + 8 >> 2] = Q), S & 16 && (Q = e[y + 20 >> 2], e[y + 28 >> 2] = e[y + 28 >> 2], e[y + 20 >> 2] = Q, e[y + 24 >> 2] = Q, e[y + 24 >> 2] = I + e[y + 24 >> 2]), Xr = I, Ri = C;
              }
              e[l + 8 >> 2] = Xr, e[l + 12 >> 2] = Ri, e[l >> 2] = 0, e[l + 4 >> 2] = 0;
            }
            function rc(l) {
              var y = 0, I = 0, C = 0, Q = 0, S = 0, me = 0, ke = 0, Ar = 0, br = 0;
              y = l;
              e: {
                if (y & 3)
                  for (; ; ) {
                    if (I = Je[y | 0], !I | (I | 0) == 61)
                      break e;
                    if (y = y + 1 | 0, !(y & 3))
                      break;
                  }
                I = e[y >> 2];
                t: {
                  if ((I ^ -1) & I - 16843009 & -2139062144)
                    break t;
                  for (; ; ) {
                    if ((I ^ 1027423549) - 16843009 & (I ^ -1) & -2139062144)
                      break t;
                    if (I = e[y + 4 >> 2], y = y + 4 | 0, !!(I - 16843009 & (I ^ -1) & -2139062144))
                      break;
                  }
                }
                for (; I = y, C = Je[y | 0], !!((C | 0) != 61 && (y = y + 1 | 0, C)); )
                  ;
                y = I;
              }
              if ((l | 0) == (y | 0))
                return 0;
              S = y - l | 0;
              e: {
                if (Je[S + l | 0] || (Q = e[6181], !Q) || (y = e[Q >> 2], !y))
                  break e;
                for (; ; ) {
                  t: {
                    me = l, I = y, ke = S, C = 0;
                    r: {
                      if (!S)
                        break r;
                      if (C = Je[l | 0], C)
                        i: {
                          for (; ; ) {
                            if (Ar = Je[I | 0], (Ar | 0) != (C | 0) | !Ar || (ke = ke - 1 | 0, !ke))
                              break i;
                            if (I = I + 1 | 0, C = Je[me + 1 | 0], me = me + 1 | 0, !C)
                              break;
                          }
                          C = 0;
                        }
                      else
                        C = 0;
                      C = C - Je[I | 0] | 0;
                    }
                    if (!C && (y = y + S | 0, Je[y | 0] == 61))
                      break t;
                    if (y = e[Q + 4 >> 2], Q = Q + 4 | 0, y)
                      continue;
                    break e;
                  }
                  break;
                }
                br = y + 1 | 0;
              }
              return br;
            }
            function D2(l, y) {
              l = l | 0, y = y | 0;
              var I = 0, C = 0;
              C = Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24);
              e: {
                t: {
                  r: {
                    if (y >>> 0 <= 28) {
                      if (C >>> 0 < 29)
                        break r;
                      y = Je[l + 8 | 0] | Je[l + 9 | 0] << 8 | (Je[l + 10 | 0] << 16 | Je[l + 11 | 0] << 24), Sa(l + 4 | 0, y, C - 29 | 0), Tr(y), y = (Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24)) - 29 | 0, Se[l | 0] = y, Se[l + 1 | 0] = y >>> 8, Se[l + 2 | 0] = y >>> 16, Se[l + 3 | 0] = y >>> 24;
                      return;
                    }
                    if (C >>> 0 >= 29) {
                      if (I = Xc(Je[l + 8 | 0] | Je[l + 9 | 0] << 8 | (Je[l + 10 | 0] << 16 | Je[l + 11 | 0] << 24), y), Se[l + 8 | 0] = I, Se[l + 9 | 0] = I >>> 8, Se[l + 10 | 0] = I >>> 16, Se[l + 11 | 0] = I >>> 24, !I)
                        break t;
                      Se[l + 4 | 0] = y, Se[l + 5 | 0] = y >>> 8, Se[l + 6 | 0] = y >>> 16, Se[l + 7 | 0] = y >>> 24;
                      return;
                    }
                    if (I = vf(y), !I)
                      break e;
                    I = Sa(I, l + 4 | 0, C), Se[l + 4 | 0] = y, Se[l + 5 | 0] = y >>> 8, Se[l + 6 | 0] = y >>> 16, Se[l + 7 | 0] = y >>> 24, Se[l + 8 | 0] = I, Se[l + 9 | 0] = I >>> 8, Se[l + 10 | 0] = I >>> 16, Se[l + 11 | 0] = I >>> 24, y = C + 29 | 0, Se[l | 0] = y, Se[l + 1 | 0] = y >>> 8, Se[l + 2 | 0] = y >>> 16, Se[l + 3 | 0] = y >>> 24;
                  }
                  return;
                }
                Nf(1370, 2249, 181, 1040), jn();
              }
              Nf(1357, 2249, 185, 1040), jn();
            }
            function Bc(l, y, I, C) {
              var Q = 0, S = 0, me = 0;
              Q = bi - 160 | 0, bi = Q, S = y ? l : Q + 158 | 0, e[Q + 148 >> 2] = S, l = -1, me = y - 1 | 0, e[Q + 152 >> 2] = y >>> 0 >= me >>> 0 ? me : 0, Q = jr(Q, 0, 144), e[Q + 76 >> 2] = -1, e[Q + 36 >> 2] = 179, e[Q + 80 >> 2] = -1, e[Q + 44 >> 2] = Q + 159, e[Q + 84 >> 2] = Q + 148;
              e: {
                if ((y | 0) < 0) {
                  e[5732] = 61;
                  break e;
                }
                Se[S | 0] = 0, S = 0, y = bi - 208 | 0, bi = y, e[y + 204 >> 2] = C, l = y + 160 | 0, jr(l, 0, 40), e[y + 200 >> 2] = e[y + 204 >> 2];
                t: {
                  if ((kh(0, I, y + 200 | 0, y + 80 | 0, l) | 0) < 0) {
                    l = -1;
                    break t;
                  }
                  C = e[Q + 76 >> 2] >= 0, me = e[Q >> 2], e[Q >> 2] = me & -33;
                  r: {
                    i: {
                      n: {
                        if (!e[Q + 48 >> 2]) {
                          e[Q + 48 >> 2] = 80, e[Q + 28 >> 2] = 0, e[Q + 16 >> 2] = 0, e[Q + 20 >> 2] = 0, S = e[Q + 44 >> 2], e[Q + 44 >> 2] = y;
                          break n;
                        }
                        if (e[Q + 16 >> 2])
                          break i;
                      }
                      if (l = -1, yd(Q))
                        break r;
                    }
                    l = kh(Q, I, y + 200 | 0, y + 80 | 0, y + 160 | 0);
                  }
                  if (I = l, S && (Yn[e[Q + 36 >> 2]](Q, 0, 0) | 0, e[Q + 48 >> 2] = 0, e[Q + 44 >> 2] = S, e[Q + 28 >> 2] = 0, l = e[Q + 20 >> 2], e[Q + 16 >> 2] = 0, e[Q + 20 >> 2] = 0, I = l ? I : -1), l = e[Q >> 2], e[Q >> 2] = l | me & 32, l = l & 32 ? -1 : I, !C)
                    break t;
                }
                bi = y + 208 | 0;
              }
              return bi = Q + 160 | 0, l;
            }
            function ah(l, y, I, C, Q, S, me) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0, me = me | 0;
              var ke = 0, Ar = 0;
              for (ke = bi - 416 | 0, bi = ke, C = ke + 416 | 0, e[ke + 12 >> 2] = C, I = bi - 144 | 0, bi = I, e[I + 28 >> 2] = I + 132, Ar = I + 32 | 0, ld(e[l + 8 >> 2], Ar, I + 28 | 0, Q, S, me), e[I + 16 >> 2] = 0, e[I + 20 >> 2] = 0, e[I + 12 >> 2] = Ar, Q = ke + 16 | 0, me = e[ke + 12 >> 2] - Q >> 2, S = bi - 16 | 0, bi = S, l = Nc(S + 12 | 0, e[l + 8 >> 2]), me = Ph(Q, I + 12 | 0, me, I + 16 | 0), l = e[l >> 2], l && (e[6178] = (l | 0) == -1 ? 24816 : l), bi = S + 16 | 0, (me | 0) == -1 && (Bd(2472), jn()), e[ke + 12 >> 2] = Q + (me << 2), bi = I + 144 | 0, I = bi - 16 | 0, bi = I, l = bi - 32 | 0, bi = l, S = bi - 16 | 0, bi = S, e[S + 12 >> 2] = e[ke + 12 >> 2], e[l + 24 >> 2] = Q, e[l + 28 >> 2] = e[S + 12 >> 2], bi = S + 16 | 0, S = e[l + 24 >> 2], me = e[l + 28 >> 2], Q = bi - 16 | 0, bi = Q, e[Q + 12 >> 2] = y; ; ) {
                if ((S | 0) != (me | 0)) {
                  hd(Q + 12 | 0, e[S >> 2]), S = S + 4 | 0;
                  continue;
                }
                break;
              }
              return e[l + 16 >> 2] = me, e[l + 20 >> 2] = e[Q + 12 >> 2], bi = Q + 16 | 0, y = e[l + 16 >> 2], e[l + 12 >> 2] = e[l + 20 >> 2], e[I + 8 >> 2] = y, e[I + 12 >> 2] = e[l + 12 >> 2], bi = l + 32 | 0, bi = I + 16 | 0, bi = C, e[I + 12 >> 2];
            }
            function $f(l, y) {
              l = l | 0, y = y | 0;
              var I = 0, C = 0, Q = 0, S = 0, me = 0, ke = 0, Ar = 0;
              Q = bi - 32 | 0, bi = Q, ke = Q + 32 | 0, I = ke, C = Q + 21 | 0, S = I - C | 0;
              e: {
                if ((S | 0) <= 9 && (Ar = S, S = No(32 - Ha(y | 1) | 0, 1233) >>> 12 | 0, me = 61, (Ar | 0) < ((qs[(S << 2) + 21616 >> 2] <= y >>> 0) + S | 0)))
                  break e;
                t: {
                  if (y >>> 0 <= 999999) {
                    if (y >>> 0 <= 9999) {
                      if (y >>> 0 <= 99) {
                        if (y >>> 0 <= 9) {
                          Se[C | 0] = y + 48, I = C + 1 | 0;
                          break t;
                        }
                        I = Fu(C, y);
                        break t;
                      }
                      if (y >>> 0 <= 999) {
                        I = (y >>> 0) / 100 | 0, Se[C | 0] = I + 48, I = Fu(C + 1 | 0, No(I, -100) + y | 0);
                        break t;
                      }
                      I = P1(C, y);
                      break t;
                    }
                    if (y >>> 0 <= 99999) {
                      I = (y >>> 0) / 1e4 | 0, Se[C | 0] = I + 48, I = P1(C + 1 | 0, No(I, -1e4) + y | 0);
                      break t;
                    }
                    I = M1(C, y);
                    break t;
                  }
                  if (y >>> 0 <= 99999999) {
                    if (y >>> 0 <= 9999999) {
                      I = (y >>> 0) / 1e6 | 0, Se[C | 0] = I + 48, I = M1(C + 1 | 0, No(I, -1e6) + y | 0);
                      break t;
                    }
                    I = N1(C, y);
                    break t;
                  }
                  if (y >>> 0 <= 999999999) {
                    I = (y >>> 0) / 1e8 | 0, Se[C | 0] = I + 48, I = N1(C + 1 | 0, No(I, -1e8) + y | 0);
                    break t;
                  }
                  I = (y >>> 0) / 1e8 | 0, I = N1(Fu(C, I), No(I, -1e8) + y | 0);
                }
                me = 0;
              }
              e[Q + 16 >> 2] = me, e[Q + 12 >> 2] = I, iu(l, C, e[Q + 12 >> 2]), bi = ke;
            }
            function ru(l, y, I) {
              var C = 0, Q = 0, S = 0, me = 0;
              if (C = l + 4 | 0, Q = (C + y | 0) - 1 & 0 - y, y = e[l >> 2], Q + I >>> 0 <= (y + l | 0) - 4 >>> 0) {
                S = e[l + 4 >> 2], e[S + 8 >> 2] = e[l + 8 >> 2], e[e[l + 8 >> 2] + 4 >> 2] = S, (C | 0) != (Q | 0) && (Q = Q - C | 0, S = l - (e[l - 4 >> 2] & -2) | 0, C = Q + e[S >> 2] | 0, e[S >> 2] = C, e[(S + (C & -4) | 0) - 4 >> 2] = C, l = l + Q | 0, y = y - Q | 0, e[l >> 2] = y);
                e: {
                  if (I + 24 >>> 0 <= y >>> 0) {
                    C = (l + I | 0) + 8 | 0, y = (y - I | 0) - 8 | 0, e[C >> 2] = y, e[(C + (y & -4) | 0) - 4 >> 2] = y | 1, Q = e[C >> 2] - 8 | 0;
                    t: {
                      if (Q >>> 0 <= 127) {
                        y = (Q >>> 3 | 0) - 1 | 0;
                        break t;
                      }
                      if (S = Ha(Q), y = ((Q >>> 29 - S ^ 4) - (S << 2) | 0) + 110 | 0, Q >>> 0 <= 4095)
                        break t;
                      y = ((Q >>> 30 - S ^ 2) - (S << 1) | 0) + 71 | 0, y = y >>> 0 >= 63 ? 63 : y;
                    }
                    Q = y << 4, e[C + 4 >> 2] = Q + 22944, Q = Q + 22952 | 0, e[C + 8 >> 2] = e[Q >> 2], e[Q >> 2] = C, e[e[C + 8 >> 2] + 4 >> 2] = C, Q = e[5994], S = e[5995], C = y & 31, (y & 63) >>> 0 >= 32 ? (y = 1 << C, C = 0) : (me = 1 << C, y = me - 1 & 1 >>> 32 - C, C = me), e[5994] = C | Q, e[5995] = y | S, y = I + 8 | 0, e[l >> 2] = y, e[((y & -4) + l | 0) - 4 >> 2] = y;
                    break e;
                  }
                  e[(l + y | 0) - 4 >> 2] = y;
                }
                l = l + 4 | 0;
              } else
                l = 0;
              return l;
            }
            function qh(l, y) {
              l = l | 0, y = y | 0;
              var I = 0, C = 0, Q = 0, S = 0, me = 0;
              e: {
                t: {
                  r: {
                    if (C = e[l >> 2], S = (e[l + 4 >> 2] - C | 0) / 12 | 0, I = S + 1 | 0, I >>> 0 < 357913942) {
                      if (C = (e[l + 8 >> 2] - C | 0) / 12 | 0, me = C << 1, C = C >>> 0 >= 178956970 ? 357913941 : I >>> 0 < me >>> 0 ? me : I, C) {
                        if (C >>> 0 >= 357913942)
                          break r;
                        Q = ga(No(C, 12));
                      }
                      if (I = No(S, 12) + Q | 0, S = e[y + 4 >> 2], e[I >> 2] = e[y >> 2], e[I + 4 >> 2] = S, e[I + 8 >> 2] = e[y + 8 >> 2], e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, Q = No(C, 12) + Q | 0, C = I + 12 | 0, y = e[l + 4 >> 2], S = e[l >> 2], (y | 0) == (S | 0))
                        break t;
                      for (; y = y - 12 | 0, me = e[y + 4 >> 2], I = I - 12 | 0, e[I >> 2] = e[y >> 2], e[I + 4 >> 2] = me, e[I + 8 >> 2] = e[y + 8 >> 2], e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, (y | 0) != (S | 0); )
                        ;
                      if (e[l + 8 >> 2] = Q, Q = e[l + 4 >> 2], e[l + 4 >> 2] = C, y = e[l >> 2], e[l >> 2] = I, (y | 0) == (Q | 0))
                        break e;
                      for (; l = Q - 12 | 0, Se[Q - 1 | 0] < 0 && Tr(e[l >> 2]), Q = l, (l | 0) != (y | 0); )
                        ;
                      break e;
                    }
                    tf(), jn();
                  }
                  kc(), jn();
                }
                e[l + 8 >> 2] = Q, e[l + 4 >> 2] = C, e[l >> 2] = I;
              }
              y && Tr(y);
            }
            function Yf(l, y, I, C) {
              var Q = 0, S = 0, me = 0, ke = 0, Ar = 0, br = 0, Qr = 0, Ur = 0, Xr = 0, Ri = 0, yn = 0;
              Ar = bi - 32 | 0, bi = Ar;
              e: {
                t: {
                  r: {
                    if ((y | 0) != (I | 0)) {
                      if (Qr = e[5732], e[5732] = 0, me = bi - 16 | 0, bi = me, fi(), S = bi - 16 | 0, bi = S, Q = bi - 16 | 0, bi = Q, d1(Q, y, Ar + 28 | 0, 2), ke = e[Q >> 2], br = e[Q + 4 >> 2], y = S, S = e[Q + 12 >> 2], e[y + 8 >> 2] = e[Q + 8 >> 2], e[y + 12 >> 2] = S, e[y >> 2] = ke, e[y + 4 >> 2] = br, bi = Q + 16 | 0, S = e[y >> 2], ke = e[y + 4 >> 2], Q = me, me = e[y + 12 >> 2], e[Q + 8 >> 2] = e[y + 8 >> 2], e[Q + 12 >> 2] = me, e[Q >> 2] = S, e[Q + 4 >> 2] = ke, bi = y + 16 | 0, me = e[Q >> 2], S = e[Q + 4 >> 2], ke = e[Q + 12 >> 2], y = Ar, e[y + 16 >> 2] = e[Q + 8 >> 2], e[y + 20 >> 2] = ke, e[y + 8 >> 2] = me, e[y + 12 >> 2] = S, bi = Q + 16 | 0, Q = e[y + 16 >> 2], S = e[y + 20 >> 2], me = e[y + 8 >> 2], ke = e[y + 12 >> 2], br = e[5732], !br)
                        break r;
                      if (e[y + 28 >> 2] != (I | 0))
                        break t;
                      if (Ur = me, Xr = ke, Ri = Q, yn = S, (br | 0) != 68)
                        break e;
                      break t;
                    }
                    e[C >> 2] = 4;
                    break e;
                  }
                  if (e[5732] = Qr, e[Ar + 28 >> 2] == (I | 0))
                    break e;
                }
                e[C >> 2] = 4, me = Ur, ke = Xr, Q = Ri, S = yn;
              }
              e[l >> 2] = me, e[l + 4 >> 2] = ke, e[l + 8 >> 2] = Q, e[l + 12 >> 2] = S, bi = Ar + 32 | 0;
            }
            function Hl(l, y, I, C) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0;
              var Q = 0, S = 0, me = 0, ke = 0, Ar = 0, br = 0;
              if (S = e[l + 4 >> 2], Q = e[l + 8 >> 2], S >>> 0 < Q >>> 0) {
                e[S >> 2] = y, e[S + 8 >> 2] = I, e[S + 12 >> 2] = I >> 31, y = e[C + 4 >> 2], e[S + 16 >> 2] = e[C >> 2], e[S + 20 >> 2] = y, e[l + 4 >> 2] = S + 24;
                return;
              }
              e: {
                if (Ar = e[l >> 2], me = (S - Ar | 0) / 24 | 0, ke = me + 1 | 0, ke >>> 0 < 178956971) {
                  if (br = No(me, 24), Q = (Q - Ar | 0) / 24 | 0, me = Q << 1, me = Q >>> 0 >= 89478485 ? 178956970 : me >>> 0 > ke >>> 0 ? me : ke, me) {
                    if (me >>> 0 >= 178956971)
                      break e;
                    ke = ga(No(me, 24));
                  } else
                    ke = 0;
                  if (Q = br + ke | 0, e[Q + 8 >> 2] = I, e[Q + 12 >> 2] = I >> 31, e[Q >> 2] = y, y = e[C + 4 >> 2], e[Q + 16 >> 2] = e[C >> 2], e[Q + 20 >> 2] = y, y = Q + 24 | 0, (S | 0) != (Ar | 0)) {
                    for (; S = S - 24 | 0, C = e[S + 4 >> 2], Q = Q - 24 | 0, e[Q >> 2] = e[S >> 2], e[Q + 4 >> 2] = C, I = e[S + 20 >> 2], e[Q + 16 >> 2] = e[S + 16 >> 2], e[Q + 20 >> 2] = I, I = e[S + 12 >> 2], e[Q + 8 >> 2] = e[S + 8 >> 2], e[Q + 12 >> 2] = I, (S | 0) != (Ar | 0); )
                      ;
                    S = e[l >> 2];
                  }
                  e[l + 8 >> 2] = ke + No(me, 24), e[l + 4 >> 2] = y, e[l >> 2] = Q, S && Tr(S);
                  return;
                }
                tf(), jn();
              }
              kc(), jn();
            }
            function Nu(l, y, I, C, Q) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0;
              var S = 0;
              S = bi - 32 | 0, bi = S, e[S + 28 >> 2] = y;
              e: {
                if (!(Se[I + 4 | 0] & 1)) {
                  I = Yn[e[e[l >> 2] + 24 >> 2]](l, y, I, C, Q) | 0;
                  break e;
                }
                C = S + 16 | 0, l = e[I + 28 >> 2], e[C >> 2] = l, e[l + 4 >> 2] = e[l + 4 >> 2] + 1, e[5996] = 0, l = no(198, e[S + 16 >> 2]) | 0, y = e[5996], e[5996] = 0;
                t: {
                  if ((y | 0) != 1) {
                    y = e[C >> 2], I = e[y + 4 >> 2] - 1 | 0, e[y + 4 >> 2] = I, (I | 0) == -1 && Yn[e[e[y >> 2] + 8 >> 2]](y);
                    r: {
                      if (Q) {
                        Yn[e[e[l >> 2] + 24 >> 2]](C, l);
                        break r;
                      }
                      Yn[e[e[l >> 2] + 28 >> 2]](S + 16 | 0, l);
                    }
                    for (e[S + 12 >> 2] = lc(S + 16 | 0); ; ) {
                      if (l = S + 16 | 0, I = hu(l), y = e[S + 12 >> 2], (I | 0) == (y | 0)) {
                        I = e[S + 28 >> 2], Yo(l);
                        break e;
                      }
                      if (l = e[y >> 2], e[5996] = 0, wn(214, S + 28 | 0, l | 0) | 0, l = e[5996], e[5996] = 0, (l | 0) != 1) {
                        e[S + 12 >> 2] = e[S + 12 >> 2] + 4;
                        continue;
                      }
                      break;
                    }
                    I = gi() | 0, Yo(S + 16 | 0);
                    break t;
                  }
                  I = gi() | 0, l = e[S + 16 >> 2], y = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = y, (y | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l);
                }
                ss(I | 0), jn();
              }
              return bi = S + 32 | 0, I | 0;
            }
            function Af(l, y, I, C, Q) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0;
              var S = 0;
              S = bi - 32 | 0, bi = S, e[S + 28 >> 2] = y;
              e: {
                if (!(Se[I + 4 | 0] & 1)) {
                  I = Yn[e[e[l >> 2] + 24 >> 2]](l, y, I, C, Q) | 0;
                  break e;
                }
                C = S + 16 | 0, l = e[I + 28 >> 2], e[C >> 2] = l, e[l + 4 >> 2] = e[l + 4 >> 2] + 1, e[5996] = 0, l = no(180, e[S + 16 >> 2]) | 0, y = e[5996], e[5996] = 0;
                t: {
                  if ((y | 0) != 1) {
                    y = e[C >> 2], I = e[y + 4 >> 2] - 1 | 0, e[y + 4 >> 2] = I, (I | 0) == -1 && Yn[e[e[y >> 2] + 8 >> 2]](y);
                    r: {
                      if (Q) {
                        Yn[e[e[l >> 2] + 24 >> 2]](C, l);
                        break r;
                      }
                      Yn[e[e[l >> 2] + 28 >> 2]](S + 16 | 0, l);
                    }
                    for (e[S + 12 >> 2] = lc(S + 16 | 0); ; ) {
                      if (l = S + 16 | 0, I = lu(l), y = e[S + 12 >> 2], (I | 0) == (y | 0)) {
                        I = e[S + 28 >> 2], Yo(l);
                        break e;
                      }
                      if (l = Se[y | 0], e[5996] = 0, wn(210, S + 28 | 0, l | 0) | 0, l = e[5996], e[5996] = 0, (l | 0) != 1) {
                        e[S + 12 >> 2] = e[S + 12 >> 2] + 1;
                        continue;
                      }
                      break;
                    }
                    I = gi() | 0, Yo(S + 16 | 0);
                    break t;
                  }
                  I = gi() | 0, l = e[S + 16 >> 2], y = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = y, (y | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l);
                }
                ss(I | 0), jn();
              }
              return bi = S + 32 | 0, I | 0;
            }
            function jl(l, y, I, C) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0;
              var Q = 0, S = 0, me = 0, ke = 0;
              S = bi - 32 | 0, bi = S, e[S + 24 >> 2] = C, Se[S + 20 | 0] = 0, e[S + 8 >> 2] = l, e[S + 16 >> 2] = S + 28, e[S + 12 >> 2] = S + 24;
              e: {
                t: {
                  r: {
                    if ((y | 0) != (I | 0))
                      for (; ; ) {
                        if (e[C + 8 >> 2] = 0, e[C >> 2] = 0, e[C + 4 >> 2] = 0, l = e[y + 4 >> 2], Q = e[y >> 2], (l | 0) != (Q | 0)) {
                          if (Q = l - Q | 0, (Q | 0) < 0) {
                            if (e[5996] = 0, e[S + 28 >> 2] = C, jo(84), l = e[5996], e[5996] = 0, (l | 0) == 1)
                              break r;
                            jn();
                          }
                          if (e[5996] = 0, l = no(3, Q | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                            break t;
                          if (e[C + 4 >> 2] = l, e[C >> 2] = l, e[C + 8 >> 2] = (Q & -8) + l, Q = e[y >> 2], me = e[y + 4 >> 2], (Q | 0) != (me | 0))
                            for (; ke = e[Q + 4 >> 2], e[l >> 2] = e[Q >> 2], e[l + 4 >> 2] = ke, l = l + 8 | 0, Q = Q + 8 | 0, (me | 0) != (Q | 0); )
                              ;
                          e[C + 4 >> 2] = l;
                        }
                        if (C = C + 12 | 0, y = y + 12 | 0, (I | 0) == (y | 0))
                          break;
                      }
                    return bi = S + 32 | 0, C | 0;
                  }
                  if (l = gi() | 0, y = e[C >> 2], !y)
                    break e;
                  e[C + 4 >> 2] = y, Tr(y);
                  break e;
                }
                l = gi() | 0, e[S + 28 >> 2] = C;
              }
              y1(S + 8 | 0), ss(l | 0), jn();
            }
            function k(l, y, I, C) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0;
              var Q = 0, S = 0, me = 0, ke = 0, Ar = 0, br = 0;
              if (S = e[l + 4 >> 2], Q = e[l + 8 >> 2], S >>> 0 < Q >>> 0) {
                e[S >> 2] = y, e[S + 16 >> 2] = C, e[S + 20 >> 2] = C >> 31, e[S + 8 >> 2] = I, e[S + 12 >> 2] = I >> 31, e[l + 4 >> 2] = S + 24;
                return;
              }
              e: {
                if (Ar = e[l >> 2], me = (S - Ar | 0) / 24 | 0, ke = me + 1 | 0, ke >>> 0 < 178956971) {
                  if (br = No(me, 24), Q = (Q - Ar | 0) / 24 | 0, me = Q << 1, me = Q >>> 0 >= 89478485 ? 178956970 : me >>> 0 > ke >>> 0 ? me : ke, me) {
                    if (me >>> 0 >= 178956971)
                      break e;
                    ke = ga(No(me, 24));
                  } else
                    ke = 0;
                  if (Q = br + ke | 0, e[Q + 16 >> 2] = C, e[Q + 20 >> 2] = C >> 31, e[Q + 8 >> 2] = I, e[Q + 12 >> 2] = I >> 31, e[Q >> 2] = y, y = Q + 24 | 0, (S | 0) != (Ar | 0)) {
                    for (; S = S - 24 | 0, C = e[S + 4 >> 2], Q = Q - 24 | 0, e[Q >> 2] = e[S >> 2], e[Q + 4 >> 2] = C, I = e[S + 20 >> 2], e[Q + 16 >> 2] = e[S + 16 >> 2], e[Q + 20 >> 2] = I, I = e[S + 12 >> 2], e[Q + 8 >> 2] = e[S + 8 >> 2], e[Q + 12 >> 2] = I, (S | 0) != (Ar | 0); )
                      ;
                    S = e[l >> 2];
                  }
                  e[l + 8 >> 2] = ke + No(me, 24), e[l + 4 >> 2] = y, e[l >> 2] = Q, S && Tr(S);
                  return;
                }
                tf(), jn();
              }
              kc(), jn();
            }
            function E(l, y, I, C) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0;
              var Q = 0, S = 0, me = 0, ke = 0, Ar = 0, br = 0;
              me = C, C = Jf(C), Ar = bi - 16 | 0, bi = Ar, e[Ar + 12 >> 2] = I, I = l;
              e: {
                t: {
                  if (Q = e[l + 4 >> 2], l = Je[l + 11 | 0], ke = (l & 128) >>> 7 | 0 ? Q : l & 127, ke >>> 0 >= y >>> 0) {
                    if (Q = ke - y | 0, e[Ar + 8 >> 2] = Q, l = Ar + 8 | 0, S = Ar + 12 | 0, l = e[(qs[l >> 2] < qs[S >> 2] ? l : S) >> 2], S = (Je[I + 11 | 0] & 128) >>> 7 | 0 ? (e[I + 8 >> 2] & 2147483647) - 1 | 0 : 10, l + (S - ke | 0) >>> 0 >= C >>> 0) {
                      S = (Je[I + 11 | 0] & 128) >>> 7 | 0 ? e[I >> 2] : I;
                      r: {
                        if ((l | 0) == (C | 0)) {
                          l = C;
                          break r;
                        }
                        if ((l | 0) == (Q | 0)) {
                          l = Q;
                          break r;
                        }
                        if (br = Q - l | 0, Q = y + S | 0, l >>> 0 > C >>> 0)
                          break t;
                        i: {
                          if (S + ke >>> 0 <= me >>> 0 | Q >>> 0 >= me >>> 0)
                            break i;
                          if (l + Q >>> 0 <= me >>> 0) {
                            me = (C - l | 0) + me | 0;
                            break i;
                          }
                          yu(Q, me, l), Q = C - l | 0, me = C + me | 0, y = l + y | 0, l = 0, C = Q;
                        }
                        Q = y + S | 0, yu(Q + C | 0, l + Q | 0, br);
                      }
                      yu(y + S | 0, me, C), t1(I, S, (C + ke | 0) - l | 0);
                      break e;
                    }
                    ms(I, S, C + ke - (l + S) | 0, ke, y, l, C, me);
                    break e;
                  }
                  I1(), jn();
                }
                y = yu(Q, me, C), yu(y + C | 0, l + y | 0, br), t1(I, S, (C + ke | 0) - l | 0);
              }
              bi = Ar + 16 | 0;
            }
            function T(l, y, I) {
              l = l | 0, y = y | 0, I = I | 0;
              var C = 0, Q = 0, S = 0, me = 0, ke = 0, Ar = 0;
              ke = bi - 16 | 0, bi = ke, C = Je[l + 11 | 0], Q = C & 127, C = (C & 128) >>> 7 | 0, Q = C ? e[l + 4 >> 2] : Q, C = C ? (e[l + 8 >> 2] & 2147483647) - 1 | 0 : 1, S = I - y >> 2;
              e: {
                if (!S)
                  break e;
                t: {
                  if (me = Je[l + 11 | 0], Ar = (me & 128) >>> 7 | 0 ? e[l >> 2] : l, Ar >>> 0 <= y >>> 0 ? me = (((me & 128) >>> 7 | 0 ? e[l + 4 >> 2] : me & 127) << 2) + Ar >>> 0 >= y >>> 0 : me = 0, !me)
                    for (C - Q >>> 0 < S >>> 0 && Fs(l, C, (Q - C | 0) + S | 0, Q, Q), C = (Q << 2) + ((Je[l + 11 | 0] & 128) >>> 7 | 0 ? e[l >> 2] : l) | 0; ; ) {
                      if ((y | 0) == (I | 0))
                        break t;
                      e[C >> 2] = e[y >> 2], y = y + 4 | 0, C = C + 4 | 0;
                    }
                  if (y = Ou(ke + 4 | 0, y, I), I = Je[y + 11 | 0], S = (I & 128) >>> 7 | 0, C = S ? e[y >> 2] : y, Q = e[y + 4 >> 2], e[5996] = 0, Ko(235, l | 0, C | 0, (S ? Q : I & 127) | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) != 1) {
                    Yo(y);
                    break e;
                  }
                  l = gi() | 0, Yo(y), ss(l | 0), jn();
                }
                e[C >> 2] = 0, y = Q + S | 0;
                t: {
                  if ((Je[l + 11 | 0] & 128) >>> 7 | 0) {
                    e[l + 4 >> 2] = y;
                    break t;
                  }
                  Se[l + 11 | 0] = y;
                }
              }
              return bi = ke + 16 | 0, l | 0;
            }
            function M(l, y) {
              l = l | 0, y = y | 0;
              var I = 0, C = 0, Q = 0, S = 0;
              if (e[l + 4 >> 2] = y, Se[l | 0] = 0, y = e[e[y >> 2] - 12 >> 2] + y | 0, !e[y + 16 >> 2]) {
                if (y = e[y + 72 >> 2], y)
                  e: {
                    Q = bi - 16 | 0, bi = Q;
                    t: {
                      r: {
                        if (!e[(y + e[e[y >> 2] - 12 >> 2] | 0) + 24 >> 2])
                          break r;
                        e[5996] = 0, C = wn(134, Q + 8 | 0, y | 0) | 0, I = e[5996], e[5996] = 0;
                        i: {
                          if ((I | 0) != 1) {
                            n: {
                              if (!Je[C | 0] || (I = e[(y + e[e[y >> 2] - 12 >> 2] | 0) + 24 >> 2], e[5996] = 0, I = no(169, I | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) != 1 && ((I | 0) != -1 || (I = e[e[y >> 2] - 12 >> 2], e[5996] = 0, Co(138, y + I | 0, 1), I = e[5996], e[5996] = 0, (I | 0) != 1))))
                                break n;
                              I = Ws(0) | 0, ca(C);
                              break i;
                            }
                            ca(C);
                            break r;
                          }
                          I = Ws(0) | 0;
                        }
                        if (Zf(I | 0) | 0, C = e[e[y >> 2] - 12 >> 2], e[5996] = 0, La(139, y + C | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                          break t;
                        $a();
                      }
                      bi = Q + 16 | 0;
                      break e;
                    }
                    l = gi() | 0, e[5996] = 0, jo(110), y = e[5996], e[5996] = 0, (y | 0) != 1 && (ss(l | 0), jn()), Ws(0) | 0, _c(), jn();
                  }
                Se[l | 0] = 1;
              }
              return l | 0;
            }
            function ye(l, y, I) {
              l = l | 0, y = y | 0, I = I | 0;
              var C = 0, Q = 0, S = 0;
              C = bi - 32 | 0, bi = C;
              e: {
                t: {
                  r: {
                    if ((I | 0) <= 0)
                      break r;
                    for (; ; ) {
                      if (Je[y + Q | 0] != 41) {
                        if (Q = Q + 1 | 0, (I | 0) != (Q | 0))
                          continue;
                        break r;
                      }
                      break;
                    }
                    if (Q)
                      break t;
                  }
                  Se[l + 16 | 0] = 0, Se[l | 0] = 0;
                  break e;
                }
                t: {
                  r: {
                    if (Q >>> 0 <= 17) {
                      if (Q >>> 0 > 10)
                        break r;
                      Se[C + 31 | 0] = Q, I = C + 20 | 0;
                      break t;
                    }
                    Se[l + 16 | 0] = 0, Se[l | 0] = 0;
                    break e;
                  }
                  S = (Q | 15) + 1 | 0, I = ga(S), e[C + 28 >> 2] = S | -2147483648, e[C + 20 >> 2] = I, e[C + 24 >> 2] = Q;
                }
                Se[Sa(I, y, Q) + Q | 0] = 0, I = e[C + 20 >> 2], y = Je[C + 27 | 0] | Je[C + 28 | 0] << 8 | (Je[C + 29 | 0] << 16 | Je[C + 30 | 0] << 24), Se[C + 15 | 0] = y, Se[C + 16 | 0] = y >>> 8, Se[C + 17 | 0] = y >>> 16, Se[C + 18 | 0] = y >>> 24, e[C + 12 >> 2] = e[C + 24 >> 2], S = Je[C + 31 | 0], e[l >> 2] = I, e[l + 4 >> 2] = e[C + 12 >> 2], y = Je[C + 15 | 0] | Je[C + 16 | 0] << 8 | (Je[C + 17 | 0] << 16 | Je[C + 18 | 0] << 24), Se[l + 7 | 0] = y, Se[l + 8 | 0] = y >>> 8, Se[l + 9 | 0] = y >>> 16, Se[l + 10 | 0] = y >>> 24, Se[l + 16 | 0] = 1, e[l + 12 >> 2] = Q, Se[l + 11 | 0] = S;
              }
              bi = C + 32 | 0;
            }
            function Ne(l, y, I, C, Q, S) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0;
              var me = 0, ke = 0, Ar = 0, br = 0;
              me = bi - 16 | 0, bi = me;
              e: {
                t: {
                  r: {
                    if (!l || (Ar = e[Q + 12 >> 2], br = I - y | 0, (br | 0) > 0 && (Yn[e[e[l >> 2] + 48 >> 2]](l, y, br) | 0) != (br | 0)))
                      break r;
                    if (y = C - y | 0, y = (y | 0) < (Ar | 0) ? Ar - y | 0 : 0, (y | 0) > 0) {
                      if (y >>> 0 >= 2147483632)
                        break e;
                      i: {
                        if (y >>> 0 >= 11) {
                          Ar = (y | 15) + 1 | 0, ke = ga(Ar), e[me + 12 >> 2] = Ar | -2147483648, e[me + 4 >> 2] = ke, e[me + 8 >> 2] = y;
                          break i;
                        }
                        Se[me + 15 | 0] = y, ke = me + 4 | 0;
                      }
                      if (Se[jr(ke, S, y) + y | 0] = 0, S = e[e[l >> 2] + 48 >> 2], e[5996] = 0, S = Ko(S | 0, l | 0, (Se[me + 15 | 0] < 0 ? e[me + 4 >> 2] : me + 4 | 0) | 0, y | 0) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                        break t;
                      if (Se[me + 15 | 0] < 0 && Tr(e[me + 4 >> 2]), ke = 0, (y | 0) != (S | 0))
                        break r;
                    }
                    if (y = C - I | 0, (y | 0) > 0 && (Yn[e[e[l >> 2] + 48 >> 2]](l, I, y) | 0) != (y | 0))
                      break r;
                    e[Q + 12 >> 2] = 0, ke = l;
                  }
                  return bi = me + 16 | 0, ke | 0;
                }
                l = gi() | 0, Se[me + 15 | 0] < 0 && Tr(e[me + 4 >> 2]), ss(l | 0), jn();
              }
              xf(), jn();
            }
            function pr(l, y, I) {
              l = l | 0, y = y | 0, I = I | 0;
              var C = 0, Q = 0, S = 0, me = 0, ke = 0, Ar = 0;
              ke = bi - 16 | 0, bi = ke, C = Je[l + 11 | 0], Q = C & 127, C = (C & 128) >>> 7 | 0, Q = C ? e[l + 4 >> 2] : Q, C = C ? (e[l + 8 >> 2] & 2147483647) - 1 | 0 : 10, S = I - y | 0;
              e: {
                if (!S)
                  break e;
                t: {
                  if (me = Je[l + 11 | 0], Ar = (me & 128) >>> 7 | 0 ? e[l >> 2] : l, Ar >>> 0 <= y >>> 0 ? me = ((me & 128) >>> 7 | 0 ? e[l + 4 >> 2] : me & 127) + Ar >>> 0 >= y >>> 0 : me = 0, !me)
                    for (C - Q >>> 0 < S >>> 0 && Qs(l, C, (Q - C | 0) + S | 0, Q, Q), C = Q + ((Je[l + 11 | 0] & 128) >>> 7 | 0 ? e[l >> 2] : l) | 0; ; ) {
                      if ((y | 0) == (I | 0))
                        break t;
                      Se[C | 0] = Je[y | 0], y = y + 1 | 0, C = C + 1 | 0;
                    }
                  if (y = iu(ke + 4 | 0, y, I), I = Je[y + 11 | 0], S = (I & 128) >>> 7 | 0, C = S ? e[y >> 2] : y, Q = e[y + 4 >> 2], e[5996] = 0, Ko(100, l | 0, C | 0, (S ? Q : I & 127) | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) != 1) {
                    Yo(y);
                    break e;
                  }
                  l = gi() | 0, Yo(y), ss(l | 0), jn();
                }
                Se[C | 0] = 0, y = Q + S | 0;
                t: {
                  if ((Je[l + 11 | 0] & 128) >>> 7 | 0) {
                    e[l + 4 >> 2] = y;
                    break t;
                  }
                  Se[l + 11 | 0] = y;
                }
              }
              return bi = ke + 16 | 0, l | 0;
            }
            function ve(l, y, I) {
              var C = 0, Q = 0;
              e: {
                if ((l | 0) == (y | 0))
                  break e;
                if (Q = l + I | 0, y - Q >>> 0 <= 0 - (I << 1) >>> 0)
                  return Sa(l, y, I);
                C = (l ^ y) & 3;
                t: {
                  r: {
                    if (l >>> 0 < y >>> 0) {
                      if (C) {
                        C = l;
                        break t;
                      }
                      if (!(l & 3)) {
                        C = l;
                        break r;
                      }
                      for (C = l; ; ) {
                        if (!I)
                          break e;
                        if (Se[C | 0] = Je[y | 0], y = y + 1 | 0, I = I - 1 | 0, C = C + 1 | 0, !(C & 3))
                          break;
                      }
                      break r;
                    }
                    i: {
                      if (C)
                        break i;
                      if (Q & 3)
                        for (; ; ) {
                          if (!I)
                            break e;
                          if (I = I - 1 | 0, C = I + l | 0, Se[C | 0] = Je[y + I | 0], !(C & 3))
                            break;
                        }
                      if (I >>> 0 <= 3)
                        break i;
                      for (; I = I - 4 | 0, e[I + l >> 2] = e[y + I >> 2], I >>> 0 > 3; )
                        ;
                    }
                    if (!I)
                      break e;
                    for (; I = I - 1 | 0, Se[I + l | 0] = Je[y + I | 0], !!I; )
                      ;
                    break e;
                  }
                  if (I >>> 0 <= 3)
                    break t;
                  for (; e[C >> 2] = e[y >> 2], y = y + 4 | 0, C = C + 4 | 0, I = I - 4 | 0, I >>> 0 > 3; )
                    ;
                }
                if (!I)
                  break e;
                for (; Se[C | 0] = Je[y | 0], C = C + 1 | 0, y = y + 1 | 0, I = I - 1 | 0, !!I; )
                  ;
              }
              return l;
            }
            function cr(l, y, I) {
              e:
                switch (y - 9 | 0) {
                  case 0:
                    y = e[I >> 2], e[I >> 2] = y + 4, e[l >> 2] = e[y >> 2];
                    return;
                  case 6:
                    y = e[I >> 2], e[I >> 2] = y + 4, y = ea[y >> 1], e[l >> 2] = y, e[l + 4 >> 2] = y >> 31;
                    return;
                  case 7:
                    y = e[I >> 2], e[I >> 2] = y + 4, e[l >> 2] = N2[y >> 1], e[l + 4 >> 2] = 0;
                    return;
                  case 8:
                    y = e[I >> 2], e[I >> 2] = y + 4, y = Se[y | 0], e[l >> 2] = y, e[l + 4 >> 2] = y >> 31;
                    return;
                  case 9:
                    y = e[I >> 2], e[I >> 2] = y + 4, e[l >> 2] = Je[y | 0], e[l + 4 >> 2] = 0;
                    return;
                  case 16:
                    y = e[I >> 2] + 7 & -8, e[I >> 2] = y + 8, zo[l >> 3] = zo[y >> 3];
                    return;
                  case 17:
                    Fd(l, I);
                  default:
                    return;
                  case 1:
                  case 4:
                  case 14:
                    y = e[I >> 2], e[I >> 2] = y + 4, y = e[y >> 2], e[l >> 2] = y, e[l + 4 >> 2] = y >> 31;
                    return;
                  case 2:
                  case 5:
                  case 11:
                  case 15:
                    y = e[I >> 2], e[I >> 2] = y + 4, e[l >> 2] = e[y >> 2], e[l + 4 >> 2] = 0;
                    return;
                  case 3:
                  case 10:
                  case 12:
                  case 13:
                    break e;
                }
              y = e[I >> 2] + 7 & -8, e[I >> 2] = y + 8, I = e[y + 4 >> 2], e[l >> 2] = e[y >> 2], e[l + 4 >> 2] = I;
            }
            function gr(l, y, I, C, Q) {
              var S = 0, me = 0;
              S = bi - 16 | 0, bi = S, e[S + 12 >> 2] = y, e[y + 4 >> 2] = e[y + 4 >> 2] + 1, e[5996] = 0, y = no(197, e[S + 12 >> 2]) | 0, me = e[5996], e[5996] = 0;
              e: {
                if ((me | 0) == 1 || (e[5996] = 0, ia(208, y | 0, 12416, 12448, I | 0), y = e[5996], e[5996] = 0, (y | 0) == 1) || (e[5996] = 0, y = no(198, e[S + 12 >> 2]) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1) || (e[5996] = 0, I = no(209, y | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1) || (e[C >> 2] = I, e[5996] = 0, I = no(206, y | 0) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1) || (e[Q >> 2] = I, e[5996] = 0, Co(207, l | 0, y | 0), l = e[5996], e[5996] = 0, (l | 0) == 1))
                  break e;
                l = e[S + 12 >> 2], y = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = y, (y | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), bi = S + 16 | 0;
                return;
              }
              I = gi() | 0, l = e[S + 12 >> 2], y = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = y, (y | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), ss(I | 0), jn();
            }
            function Pr(l, y, I, C, Q) {
              var S = 0, me = 0;
              S = bi - 16 | 0, bi = S, e[S + 12 >> 2] = y, e[y + 4 >> 2] = e[y + 4 >> 2] + 1, e[5996] = 0, y = no(170, e[S + 12 >> 2]) | 0, me = e[5996], e[5996] = 0;
              e: {
                if ((me | 0) == 1 || (e[5996] = 0, ia(195, y | 0, 12416, 12448, I | 0), y = e[5996], e[5996] = 0, (y | 0) == 1) || (e[5996] = 0, y = no(180, e[S + 12 >> 2]) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1) || (e[5996] = 0, I = no(196, y | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1) || (Se[C | 0] = I, e[5996] = 0, I = no(193, y | 0) | 0, C = e[5996], e[5996] = 0, (C | 0) == 1) || (Se[Q | 0] = I, e[5996] = 0, Co(194, l | 0, y | 0), l = e[5996], e[5996] = 0, (l | 0) == 1))
                  break e;
                l = e[S + 12 >> 2], y = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = y, (y | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), bi = S + 16 | 0;
                return;
              }
              I = gi() | 0, l = e[S + 12 >> 2], y = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = y, (y | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), ss(I | 0), jn();
            }
            function Nr(l, y, I, C, Q, S) {
              var me = 0;
              me = bi - 80 | 0, bi = me;
              e: {
                if ((S | 0) >= 16384) {
                  if (Xa(me + 32 | 0, y, I, C, Q, 0, 0, 0, 2147352576), C = e[me + 40 >> 2], Q = e[me + 44 >> 2], y = e[me + 32 >> 2], I = e[me + 36 >> 2], S >>> 0 < 32767) {
                    S = S - 16383 | 0;
                    break e;
                  }
                  Xa(me + 16 | 0, y, I, C, Q, 0, 0, 0, 2147352576), S = ((S | 0) >= 49149 ? 49149 : S) - 32766 | 0, C = e[me + 24 >> 2], Q = e[me + 28 >> 2], y = e[me + 16 >> 2], I = e[me + 20 >> 2];
                  break e;
                }
                if ((S | 0) > -16383)
                  break e;
                if (Xa(me - -64 | 0, y, I, C, Q, 0, 0, 0, 7471104), C = e[me + 72 >> 2], Q = e[me + 76 >> 2], y = e[me + 64 >> 2], I = e[me + 68 >> 2], S >>> 0 > 4294934644) {
                  S = S + 16269 | 0;
                  break e;
                }
                Xa(me + 48 | 0, y, I, C, Q, 0, 0, 0, 7471104), S = ((S | 0) <= -48920 ? -48920 : S) + 32538 | 0, C = e[me + 56 >> 2], Q = e[me + 60 >> 2], y = e[me + 48 >> 2], I = e[me + 52 >> 2];
              }
              Xa(me, y, I, C, Q, 0, 0, 0, S + 16383 << 16), y = e[me + 12 >> 2], e[l + 8 >> 2] = e[me + 8 >> 2], e[l + 12 >> 2] = y, y = e[me + 4 >> 2], e[l >> 2] = e[me >> 2], e[l + 4 >> 2] = y, bi = me + 80 | 0;
            }
            function Br(l, y, I, C, Q) {
              var S = 0, me = 0, ke = 0, Ar = 0;
              ke = bi - 16 | 0, bi = ke, e[ke + 12 >> 2] = y, y = 0, me = 6;
              e: {
                t: {
                  if (Tc(l, ke + 12 | 0))
                    break t;
                  me = e[l >> 2], S = e[me + 12 >> 2];
                  r: {
                    if ((S | 0) == e[me + 16 >> 2]) {
                      S = Yn[e[e[me >> 2] + 36 >> 2]](me) | 0;
                      break r;
                    }
                    S = Je[S | 0];
                  }
                  if (me = 4, Ar = e[C + 8 >> 2], S = S << 24 >> 24, (S | 0) >= 0 ? Ar = (e[((S & 255) << 2) + Ar >> 2] & 64) != 0 : Ar = 0, !Ar)
                    break t;
                  for (y = Yn[e[e[C >> 2] + 36 >> 2]](C, S, 0) | 0; ; ) {
                    r: {
                      if (y = y - 48 | 0, S = mh(l), Tc(S, ke + 12 | 0) | (Q | 0) < 2)
                        break r;
                      me = e[S >> 2], S = e[me + 12 >> 2];
                      i: {
                        if ((S | 0) == e[me + 16 >> 2]) {
                          me = Yn[e[e[me >> 2] + 36 >> 2]](me) | 0;
                          break i;
                        }
                        me = Je[S | 0];
                      }
                      if (S = e[C + 8 >> 2], me = me << 24 >> 24, (me | 0) >= 0 ? S = (e[S + ((me & 255) << 2) >> 2] & 64) != 0 : S = 0, !S)
                        break e;
                      Q = Q - 1 | 0, y = (Yn[e[e[C >> 2] + 36 >> 2]](C, me, 0) | 0) + No(y, 10) | 0;
                      continue;
                    }
                    break;
                  }
                  if (me = 2, !Tc(S, ke + 12 | 0))
                    break e;
                }
                e[I >> 2] = e[I >> 2] | me;
              }
              return bi = ke + 16 | 0, y;
            }
            function Mr(l, y) {
              l = l | 0, y = y | 0;
              var I = 0, C = 0;
              e: {
                if ((y | 0) > 0)
                  for (C = l + y | 0; ; ) {
                    y = 1;
                    t: {
                      r:
                        switch (Je[l | 0] - 66 | 0) {
                          default:
                            if (l = ro(8), e[5996] = 0, y = wn(17, l | 0, 2064) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1)
                              break e;
                            E2(y | 0, 22528, 7), jn();
                          case 20:
                            y = 2;
                            break t;
                          case 9:
                            y = 4;
                            break t;
                          case 21:
                            y = 8;
                            break t;
                          case 56:
                            y = 16;
                            break t;
                          case 45:
                            y = 32;
                            break t;
                          case 44:
                            y = 64;
                            break t;
                          case 34:
                            y = 128;
                            break t;
                          case 51:
                            y = 256;
                            break t;
                          case 35:
                            y = 512;
                            break t;
                          case 36:
                            y = 1024;
                            break t;
                          case 49:
                            y = 2048;
                            break t;
                          case 43:
                            y = 4096;
                            break t;
                          case 54:
                            y = 8192;
                            break t;
                          case 37:
                            y = 16384;
                            break t;
                          case 38:
                            y = 32768;
                            break t;
                          case 39:
                            y = 65536;
                            break t;
                          case 40:
                            y = 131072;
                            break t;
                          case 0:
                            break t;
                          case 41:
                            break r;
                        }
                      y = 262144;
                    }
                    if (I = y | I, l = l + 1 | 0, !(C >>> 0 > l >>> 0))
                      break;
                  }
                return I | 0;
              }
              y = gi() | 0, ef(l), ss(y | 0), jn();
            }
            function jr(l, y, I) {
              var C = 0, Q = 0, S = 0, me = 0;
              e: {
                if (!I || (Se[l | 0] = y, C = l + I | 0, Se[C - 1 | 0] = y, I >>> 0 < 3) || (Se[l + 2 | 0] = y, Se[l + 1 | 0] = y, Se[C - 3 | 0] = y, Se[C - 2 | 0] = y, I >>> 0 < 7) || (Se[l + 3 | 0] = y, Se[C - 4 | 0] = y, I >>> 0 < 9) || (C = 0 - l & 3, Q = C + l | 0, y = No(y & 255, 16843009), e[Q >> 2] = y, C = I - C & -4, I = C + Q | 0, e[I - 4 >> 2] = y, C >>> 0 < 9) || (e[Q + 8 >> 2] = y, e[Q + 4 >> 2] = y, e[I - 8 >> 2] = y, e[I - 12 >> 2] = y, C >>> 0 < 25) || (e[Q + 24 >> 2] = y, e[Q + 20 >> 2] = y, e[Q + 16 >> 2] = y, e[Q + 12 >> 2] = y, e[I - 16 >> 2] = y, e[I - 20 >> 2] = y, e[I - 24 >> 2] = y, e[I - 28 >> 2] = y, me = Q & 4 | 24, I = C - me | 0, I >>> 0 < 32))
                  break e;
                for (C = Ua(y, 0, 1, 1), S = Ci, y = Q + me | 0; e[y + 24 >> 2] = C, e[y + 28 >> 2] = S, e[y + 16 >> 2] = C, e[y + 20 >> 2] = S, e[y + 8 >> 2] = C, e[y + 12 >> 2] = S, e[y >> 2] = C, e[y + 4 >> 2] = S, y = y + 32 | 0, I = I - 32 | 0, I >>> 0 > 31; )
                  ;
              }
              return l;
            }
            function ti(l, y) {
              l = l | 0, y = y | 0;
              var I = 0, C = 0, Q = 0, S = 0, me = 0, ke = 0;
              e: {
                if (C = e[l + 4 >> 2], ke = e[l >> 2], S = C - ke >> 3, I = S + 1 | 0, I >>> 0 < 536870912) {
                  if (me = e[l + 8 >> 2] - ke | 0, Q = me >> 2, I = me >>> 0 >= 2147483640 ? 536870911 : I >>> 0 < Q >>> 0 ? Q : I, I >>> 0 >= 536870912)
                    break e;
                  if (Q = S << 3, S = I << 3, me = ga(S), I = Q + me | 0, e[I >> 2] = e[y >> 2], e[I + 4 >> 2] = e[y + 4 >> 2], e[y >> 2] = 0, e[y + 4 >> 2] = 0, Q = I + 8 | 0, (C | 0) != (ke | 0))
                    for (; I = I - 8 | 0, C = C - 8 | 0, e[I >> 2] = e[C >> 2], e[I + 4 >> 2] = e[C + 4 >> 2], e[C >> 2] = 0, e[C + 4 >> 2] = 0, (C | 0) != (ke | 0); )
                      ;
                  if (e[l + 8 >> 2] = S + me, y = e[l >> 2], e[l >> 2] = I, C = e[l + 4 >> 2], e[l + 4 >> 2] = Q, (y | 0) != (C | 0))
                    for (; ; ) {
                      C = C - 8 | 0, l = e[C + 4 >> 2];
                      t: {
                        if (!l || (I = e[l + 4 >> 2], e[l + 4 >> 2] = I - 1, I))
                          break t;
                        Yn[e[e[l >> 2] + 8 >> 2]](l), Ls(l);
                      }
                      if ((y | 0) == (C | 0))
                        break;
                    }
                  y && Tr(y);
                  return;
                }
                tf(), jn();
              }
              kc(), jn();
            }
            function fi() {
              var l = 0, y = 0, I = 0, C = 0;
              if (Je[25008])
                return e[6251];
              I = bi - 32 | 0, bi = I;
              e: {
                t: {
                  for (; ; ) {
                    if (y = I + 8 | 0, C = li(l, 1 << l & 2147483647 ? 3538 : 5575), e[y + (l << 2) >> 2] = C, (C | 0) == -1)
                      break t;
                    if (l = l + 1 | 0, (l | 0) == 6)
                      break;
                  }
                  if (l = 19324, !Wf(y, 19324, 24) || (l = 19348, !Wf(y, 19348, 24)))
                    break e;
                  if (l = 0, !Je[24780]) {
                    for (; e[(l << 2) + 24732 >> 2] = li(l, 5575), l = l + 1 | 0, (l | 0) != 6; )
                      ;
                    Se[24780] = 1, e[6189] = e[6183];
                  }
                  if (l = 24732, y = I + 8 | 0, !Wf(y, 24732, 24) || (l = 24756, !Wf(y, 24756, 24)))
                    break e;
                  if (l = vf(24), !l)
                    break t;
                  y = e[I + 12 >> 2], e[l >> 2] = e[I + 8 >> 2], e[l + 4 >> 2] = y, y = e[I + 28 >> 2], e[l + 16 >> 2] = e[I + 24 >> 2], e[l + 20 >> 2] = y, y = e[I + 20 >> 2], e[l + 8 >> 2] = e[I + 16 >> 2], e[l + 12 >> 2] = y;
                  break e;
                }
                l = 0;
              }
              return bi = I + 32 | 0, Se[25008] = 1, e[6251] = l, l;
            }
            function Jr(l, y) {
              var I = 0, C = 0, Q = 0, S = 0;
              I = bi + -64 | 0, bi = I, C = e[l >> 2], Q = e[C - 4 >> 2], S = e[C - 8 >> 2], e[I + 28 >> 2] = 0, e[I + 32 >> 2] = 0, e[I + 36 >> 2] = 0, e[I + 40 >> 2] = 0, e[I + 44 >> 2] = 0, e[I + 48 >> 2] = 0, e[I + 52 >> 2] = 0, e[I + 56 >> 2] = 0, C = 0, Se[I + 59 | 0] = 0, Se[I + 60 | 0] = 0, Se[I + 61 | 0] = 0, Se[I + 62 | 0] = 0, e[I + 20 >> 2] = 0, e[I + 24 >> 2] = 0, e[I + 16 >> 2] = 22056, e[I + 12 >> 2] = l, e[I + 8 >> 2] = y, l = l + S | 0;
              e: {
                if (hc(Q, y, 0)) {
                  e[I + 56 >> 2] = 1, Yn[e[e[Q >> 2] + 20 >> 2]](Q, I + 8 | 0, l, l, 1, 0), C = e[I + 32 >> 2] == 1 ? l : 0;
                  break e;
                }
                Yn[e[e[Q >> 2] + 24 >> 2]](Q, I + 8 | 0, l, 1, 0);
                t:
                  switch (e[I + 44 >> 2]) {
                    case 0:
                      C = e[I + 48 >> 2] == 1 && e[I + 36 >> 2] == 1 && e[I + 40 >> 2] == 1 ? e[I + 28 >> 2] : 0;
                      break e;
                    case 1:
                      break t;
                    default:
                      break e;
                  }
                if (e[I + 32 >> 2] != 1 && e[I + 48 >> 2] | e[I + 36 >> 2] != 1 | e[I + 40 >> 2] != 1)
                  break e;
                C = e[I + 24 >> 2];
              }
              return bi = I - -64 | 0, C;
            }
            function li(l, y) {
              var I = 0, C = 0, Q = 0;
              e: {
                if (Je[y | 0] || (y = rc(3169), Je[y | 0] && y) || (y = rc(No(l, 12) + 9024 | 0), Je[y | 0] && y) || (y = rc(3321), Je[y | 0] && y))
                  break e;
                y = 3845;
              }
              e: {
                for (; ; ) {
                  if (C = Je[y + I | 0], !(!C | (C | 0) == 47)) {
                    if (C = 23, I = I + 1 | 0, (I | 0) != 23)
                      continue;
                    break e;
                  }
                  break;
                }
                C = I;
              }
              Q = 3845;
              e: {
                t: {
                  I = Je[y | 0];
                  r: {
                    i: {
                      if (!(Je[y + C | 0] | (I | 0) == 46) && (Q = y, (I | 0) != 67))
                        break i;
                      if (!Je[Q + 1 | 0])
                        break r;
                    }
                    if (!jh(Q, 3845))
                      break r;
                    if (jh(Q, 2764))
                      break t;
                  }
                  if (!l && (I = 9096, Je[Q + 1 | 0] == 46))
                    break e;
                  return 0;
                }
                if (I = e[6182], I)
                  for (; ; ) {
                    if (!jh(Q, I + 8 | 0))
                      break e;
                    if (I = e[I + 32 >> 2], !I)
                      break;
                  }
                I = vf(36), I && (e[I + 4 >> 2] = 20, e[I >> 2] = 8992, y = I + 8 | 0, Sa(y, Q, C), Se[y + C | 0] = 0, e[I + 32 >> 2] = e[6182], e[6182] = I), I = l | I ? I : 9096;
              }
              return I;
            }
            function Tr(l) {
              var y = 0, I = 0, C = 0, Q = 0, S = 0;
              if (l) {
                y = l - 4 | 0, Q = e[y >> 2], C = Q, I = y, S = e[l - 8 >> 2], l = S & -2, (l | 0) != (S | 0) && (I = y - l | 0, S = e[I + 4 >> 2], e[S + 8 >> 2] = e[I + 8 >> 2], e[e[I + 8 >> 2] + 4 >> 2] = S, C = l + C | 0), l = y + Q | 0, y = e[l >> 2], (y | 0) != e[(l + y | 0) - 4 >> 2] && (Q = e[l + 4 >> 2], e[Q + 8 >> 2] = e[l + 8 >> 2], e[e[l + 8 >> 2] + 4 >> 2] = Q, C = y + C | 0), e[I >> 2] = C, e[((C & -4) + I | 0) - 4 >> 2] = C | 1, y = e[I >> 2] - 8 | 0;
                e: {
                  if (y >>> 0 <= 127) {
                    l = (y >>> 3 | 0) - 1 | 0;
                    break e;
                  }
                  if (C = Ha(y), l = ((y >>> 29 - C ^ 4) - (C << 2) | 0) + 110 | 0, y >>> 0 <= 4095)
                    break e;
                  l = ((y >>> 30 - C ^ 2) - (C << 1) | 0) + 71 | 0, l = l >>> 0 >= 63 ? 63 : l;
                }
                y = l << 4, e[I + 4 >> 2] = y + 22944, y = y + 22952 | 0, e[I + 8 >> 2] = e[y >> 2], e[y >> 2] = I, e[e[I + 8 >> 2] + 4 >> 2] = I, y = e[5994], C = e[5995], I = l & 31, (l & 63) >>> 0 >= 32 ? (l = 1 << I, Q = 0) : (Q = 1 << I, l = Q - 1 & 1 >>> 32 - I), e[5994] = Q | y, e[5995] = l | C;
              }
            }
            function Mi(l, y, I, C, Q, S, me, ke, Ar, br, Qr) {
              var Ur = 0, Xr = 0, Ri = 0;
              e: {
                t: {
                  if (Ur = e[C >> 2], (Ur | 0) != (I | 0) || (Xr = 43, Ri = l & 255, (Ri | 0) != Je[Qr + 24 | 0] && (Xr = 45, Je[Qr + 25 | 0] != (Ri | 0))))
                    break t;
                  e[C >> 2] = I + 1, Se[I | 0] = Xr;
                  break e;
                }
                t: {
                  if (!(!((ke & 128) >>> 7 | 0 ? me : ke & 127) | (l | 0) != (S | 0))) {
                    if (ke = 0, l = e[br >> 2], (l - Ar | 0) > 159)
                      break t;
                    y = e[Q >> 2], e[br >> 2] = l + 4, e[l >> 2] = y;
                    break e;
                  }
                  if (ke = -1, l = E1(Qr, Qr + 26 | 0, l) - Qr | 0, (l | 0) > 23)
                    break t;
                  r: {
                    i:
                      switch (y - 8 | 0) {
                        case 0:
                        case 2:
                          if ((l | 0) < (y | 0))
                            break r;
                          break t;
                        case 1:
                          break r;
                        default:
                          break i;
                      }
                    if ((y | 0) != 16 | (l | 0) < 22)
                      break r;
                    if ((I | 0) == (Ur | 0) | (Ur - I | 0) > 2 | Je[Ur - 1 | 0] != 48)
                      break t;
                    return e[Q >> 2] = 0, e[C >> 2] = Ur + 1, Se[Ur | 0] = Je[l + 12416 | 0], 0;
                  }
                  e[C >> 2] = Ur + 1, Se[Ur | 0] = Je[l + 12416 | 0], e[Q >> 2] = e[Q >> 2] + 1, ke = 0;
                }
                return ke;
              }
              return e[Q >> 2] = 0, 0;
            }
            function Wi(l, y, I, C, Q, S, me, ke, Ar, br, Qr) {
              var Ur = 0, Xr = 0;
              e: {
                t: {
                  if (Ur = e[C >> 2], (Ur | 0) != (I | 0) || (Xr = 43, e[Qr + 96 >> 2] != (l | 0) && (Xr = 45, e[Qr + 100 >> 2] != (l | 0))))
                    break t;
                  e[C >> 2] = I + 1, Se[I | 0] = Xr;
                  break e;
                }
                t: {
                  if (!(!((ke & 128) >>> 7 | 0 ? me : ke & 127) | (l | 0) != (S | 0))) {
                    if (ke = 0, l = e[br >> 2], (l - Ar | 0) > 159)
                      break t;
                    y = e[Q >> 2], e[br >> 2] = l + 4, e[l >> 2] = y;
                    break e;
                  }
                  if (ke = -1, S = B1(Qr, Qr + 104 | 0, l) - Qr | 0, (S | 0) > 92)
                    break t;
                  l = S >> 2;
                  r: {
                    i:
                      switch (y - 8 | 0) {
                        case 0:
                        case 2:
                          if ((l | 0) < (y | 0))
                            break r;
                          break t;
                        case 1:
                          break r;
                        default:
                          break i;
                      }
                    if ((y | 0) != 16 | (S | 0) < 88)
                      break r;
                    if ((I | 0) == (Ur | 0) | (Ur - I | 0) > 2 | Je[Ur - 1 | 0] != 48)
                      break t;
                    return e[Q >> 2] = 0, e[C >> 2] = Ur + 1, Se[Ur | 0] = Je[l + 12416 | 0], 0;
                  }
                  e[C >> 2] = Ur + 1, Se[Ur | 0] = Je[l + 12416 | 0], e[Q >> 2] = e[Q >> 2] + 1, ke = 0;
                }
                return ke;
              }
              return e[Q >> 2] = 0, 0;
            }
            function vn(l, y) {
              l = l | 0, y = y | 0;
              var I = 0, C = 0, Q = 0, S = 0, me = 0, ke = 0;
              if (I = e[l + 4 >> 2], C = e[l + 8 >> 2], I >>> 0 < C >>> 0) {
                e[I >> 2] = y, e[l + 4 >> 2] = I + 4;
                return;
              }
              e: {
                t: {
                  r: {
                    if (me = e[l >> 2], Q = I - me >> 2, S = Q + 1 | 0, S >>> 0 < 1073741824) {
                      if (ke = Q << 2, C = C - me | 0, Q = C >> 1, C = C >>> 0 >= 2147483644 ? 1073741823 : S >>> 0 < Q >>> 0 ? Q : S, C) {
                        if (C >>> 0 >= 1073741824)
                          break r;
                        Q = ga(C << 2);
                      } else
                        Q = 0;
                      if (S = ke + Q | 0, e[S >> 2] = y, y = Q + (C << 2) | 0, C = S + 4 | 0, (I | 0) == (me | 0))
                        break t;
                      for (; I = I - 4 | 0, Q = e[I >> 2], e[I >> 2] = 0, S = S - 4 | 0, e[S >> 2] = Q, (I | 0) != (me | 0); )
                        ;
                      if (e[l + 8 >> 2] = y, y = e[l + 4 >> 2], e[l + 4 >> 2] = C, I = e[l >> 2], e[l >> 2] = S, (y | 0) == (I | 0))
                        break e;
                      for (; y = y - 4 | 0, Wl(y), (y | 0) != (I | 0); )
                        ;
                      break e;
                    }
                    tf(), jn();
                  }
                  kc(), jn();
                }
                e[l + 8 >> 2] = y, e[l + 4 >> 2] = C, e[l >> 2] = S;
              }
              I && Tr(I);
            }
            function Tn(l, y) {
              l = l | 0, y = y | 0;
              var I = 0, C = 0, Q = 0, S = 0, me = 0;
              e: {
                if (y >>> 0 >= 256) {
                  if (l = ro(8), e[5996] = 0, y = wn(91, l | 0, 2394) | 0, I = e[5996], e[5996] = 0, (I | 0) != 1)
                    break e;
                  y = gi() | 0, ef(l), ss(y | 0), jn();
                }
                return I = Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24), Q = I - 29 | 0, S = I >>> 0 < 29 ? I : Q, C = S + 1 | 0, C >>> 0 > (I >>> 0 <= 28 ? 28 : Je[l + 4 | 0] | Je[l + 5 | 0] << 8 | (Je[l + 6 | 0] << 16 | Je[l + 7 | 0] << 24)) >>> 0 && (D2(l, C + (C >>> 1 | 0) | 0), I = Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24), Q = I - 29 | 0), me = I >>> 0 < 29, C = (me ? l + 4 | 0 : Je[l + 8 | 0] | Je[l + 9 | 0] << 8 | (Je[l + 10 | 0] << 16 | Je[l + 11 | 0] << 24)) + S | 0, ve(C + 1 | 0, C, (me ? I : Q) - S | 0), I = (Je[l | 0] | Je[l + 1 | 0] << 8 | (Je[l + 2 | 0] << 16 | Je[l + 3 | 0] << 24)) + 1 | 0, Se[l | 0] = I, Se[l + 1 | 0] = I >>> 8, Se[l + 2 | 0] = I >>> 16, Se[l + 3 | 0] = I >>> 24, Se[C | 0] = y, l | 0;
              }
              E2(y | 0, 22664, 92), jn();
            }
            function Ni(l, y, I, C, Q, S) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0;
              var me = 0, ke = 0, Ar = 0;
              me = bi - 256 | 0, bi = me, e[me + 248 >> 2] = 37, e[me + 252 >> 2] = 0, ke = me + 248 | 0, Au(ke | 1, 2055, 1, e[I + 4 >> 2]), Ar = fi(), e[me >> 2] = Q, e[me + 4 >> 2] = S, l = me + 224 | 0, Q = qf(l, 24, Ar, ke, me) + l | 0, Ar = uc(l, Q, e[I + 4 >> 2]), S = me + 20 | 0, ke = e[I + 28 >> 2], e[S >> 2] = ke, e[ke + 4 >> 2] = e[ke + 4 >> 2] + 1, e[5996] = 0, ke = me + 32 | 0, jf(215, l | 0, Ar | 0, Q | 0, ke | 0, me + 28 | 0, me + 24 | 0, S | 0), l = e[5996], e[5996] = 0;
              e: {
                if ((l | 0) != 1) {
                  l = e[S >> 2], Q = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = Q, (Q | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), l = ai(y, ke, e[me + 28 >> 2], e[me + 24 >> 2], I, C), bi = me + 256 | 0;
                  break e;
                }
                I = gi() | 0, l = e[me + 20 >> 2], y = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = y, (y | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), ss(I | 0), jn();
              }
              return l | 0;
            }
            function Yi(l, y, I, C, Q, S) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0;
              var me = 0, ke = 0, Ar = 0;
              me = bi - 256 | 0, bi = me, e[me + 248 >> 2] = 37, e[me + 252 >> 2] = 0, ke = me + 248 | 0, Au(ke | 1, 2055, 0, e[I + 4 >> 2]), Ar = fi(), e[me >> 2] = Q, e[me + 4 >> 2] = S, l = me + 224 | 0, Q = qf(l, 24, Ar, ke, me) + l | 0, Ar = uc(l, Q, e[I + 4 >> 2]), S = me + 20 | 0, ke = e[I + 28 >> 2], e[S >> 2] = ke, e[ke + 4 >> 2] = e[ke + 4 >> 2] + 1, e[5996] = 0, ke = me + 32 | 0, jf(215, l | 0, Ar | 0, Q | 0, ke | 0, me + 28 | 0, me + 24 | 0, S | 0), l = e[5996], e[5996] = 0;
              e: {
                if ((l | 0) != 1) {
                  l = e[S >> 2], Q = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = Q, (Q | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), l = ai(y, ke, e[me + 28 >> 2], e[me + 24 >> 2], I, C), bi = me + 256 | 0;
                  break e;
                }
                I = gi() | 0, l = e[me + 20 >> 2], y = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = y, (y | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), ss(I | 0), jn();
              }
              return l | 0;
            }
            function Xi(l, y, I, C, Q, S) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0;
              var me = 0, ke = 0, Ar = 0;
              me = bi - 112 | 0, bi = me, e[me + 104 >> 2] = 37, e[me + 108 >> 2] = 0, ke = me + 104 | 0, Au(ke | 1, 2055, 1, e[I + 4 >> 2]), Ar = fi(), e[me >> 2] = Q, e[me + 4 >> 2] = S, l = me + 80 | 0, Q = qf(l, 24, Ar, ke, me) + l | 0, Ar = uc(l, Q, e[I + 4 >> 2]), S = me + 20 | 0, ke = e[I + 28 >> 2], e[S >> 2] = ke, e[ke + 4 >> 2] = e[ke + 4 >> 2] + 1, e[5996] = 0, ke = me + 32 | 0, jf(211, l | 0, Ar | 0, Q | 0, ke | 0, me + 28 | 0, me + 24 | 0, S | 0), l = e[5996], e[5996] = 0;
              e: {
                if ((l | 0) != 1) {
                  l = e[S >> 2], Q = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = Q, (Q | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), l = Ne(y, ke, e[me + 28 >> 2], e[me + 24 >> 2], I, C), bi = me + 112 | 0;
                  break e;
                }
                I = gi() | 0, l = e[me + 20 >> 2], y = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = y, (y | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), ss(I | 0), jn();
              }
              return l | 0;
            }
            function $n(l, y, I, C, Q, S) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0;
              var me = 0, ke = 0, Ar = 0;
              me = bi - 112 | 0, bi = me, e[me + 104 >> 2] = 37, e[me + 108 >> 2] = 0, ke = me + 104 | 0, Au(ke | 1, 2055, 0, e[I + 4 >> 2]), Ar = fi(), e[me >> 2] = Q, e[me + 4 >> 2] = S, l = me + 80 | 0, Q = qf(l, 24, Ar, ke, me) + l | 0, Ar = uc(l, Q, e[I + 4 >> 2]), S = me + 20 | 0, ke = e[I + 28 >> 2], e[S >> 2] = ke, e[ke + 4 >> 2] = e[ke + 4 >> 2] + 1, e[5996] = 0, ke = me + 32 | 0, jf(211, l | 0, Ar | 0, Q | 0, ke | 0, me + 28 | 0, me + 24 | 0, S | 0), l = e[5996], e[5996] = 0;
              e: {
                if ((l | 0) != 1) {
                  l = e[S >> 2], Q = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = Q, (Q | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), l = Ne(y, ke, e[me + 28 >> 2], e[me + 24 >> 2], I, C), bi = me + 112 | 0;
                  break e;
                }
                I = gi() | 0, l = e[me + 20 >> 2], y = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = y, (y | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), ss(I | 0), jn();
              }
              return l | 0;
            }
            function Zn(l, y, I, C, Q, S) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0;
              var me = 0, ke = 0, Ar = 0, br = 0, Qr = 0, Ur = 0;
              if (hc(l, e[y + 8 >> 2], S)) {
                h1(y, I, C, Q);
                return;
              }
              me = Je[y + 53 | 0], Ar = e[l + 12 >> 2], Se[y + 53 | 0] = 0, ke = Je[y + 52 | 0], Se[y + 52 | 0] = 0, k1(e[l + 16 >> 2], e[l + 20 >> 2], y, I, C, Q, S), br = Je[y + 52 | 0], ke = (ke | br) != 0, Qr = Je[y + 53 | 0], Ur = (me | Qr) != 0, me = l + 24 | 0, Ar = (l + 16 | 0) + (Ar << 3) | 0;
              e: {
                if (me >>> 0 >= Ar >>> 0)
                  break e;
                for (; ; ) {
                  if (Je[y + 54 | 0])
                    break e;
                  t: {
                    if (br) {
                      if (e[y + 24 >> 2] == 1)
                        break e;
                      if (Je[l + 8 | 0] & 2)
                        break t;
                      break e;
                    }
                    if (!Qr)
                      break t;
                    if (!(Se[l + 8 | 0] & 1))
                      break e;
                  }
                  if (ea[y + 52 >> 1] = 0, k1(e[me >> 2], e[me + 4 >> 2], y, I, C, Q, S), Qr = Je[y + 53 | 0], Ur = (Qr | Ur) != 0, br = Je[y + 52 | 0], ke = (br | ke) != 0, me = me + 8 | 0, !(Ar >>> 0 > me >>> 0))
                    break;
                }
              }
              Se[y + 53 | 0] = Ur, Se[y + 52 | 0] = ke;
            }
            function to(l, y, I, C, Q) {
              var S = 0, me = 0, ke = 0, Ar = 0;
              ke = bi - 16 | 0, bi = ke, e[ke + 12 >> 2] = y, y = 0, me = 6;
              e: {
                t: {
                  if (Dc(l, ke + 12 | 0))
                    break t;
                  me = 4, S = e[l >> 2], Ar = e[S + 12 >> 2];
                  r: {
                    if ((Ar | 0) == e[S + 16 >> 2]) {
                      S = Yn[e[e[S >> 2] + 36 >> 2]](S) | 0;
                      break r;
                    }
                    S = e[Ar >> 2];
                  }
                  if (!(Yn[e[e[C >> 2] + 12 >> 2]](C, 64, S) | 0))
                    break t;
                  for (y = Yn[e[e[C >> 2] + 52 >> 2]](C, S, 0) | 0; ; ) {
                    r: {
                      if (y = y - 48 | 0, S = vh(l), Dc(S, ke + 12 | 0) | (Q | 0) < 2)
                        break r;
                      me = e[S >> 2], S = e[me + 12 >> 2];
                      i: {
                        if ((S | 0) == e[me + 16 >> 2]) {
                          me = Yn[e[e[me >> 2] + 36 >> 2]](me) | 0;
                          break i;
                        }
                        me = e[S >> 2];
                      }
                      if (!(Yn[e[e[C >> 2] + 12 >> 2]](C, 64, me) | 0))
                        break e;
                      Q = Q - 1 | 0, y = (Yn[e[e[C >> 2] + 52 >> 2]](C, me, 0) | 0) + No(y, 10) | 0;
                      continue;
                    }
                    break;
                  }
                  if (me = 2, !Dc(S, ke + 12 | 0))
                    break e;
                }
                e[I >> 2] = e[I >> 2] | me;
              }
              return bi = ke + 16 | 0, y;
            }
            function fo(l, y, I, C) {
              var Q = 0, S = 0, me = 0, ke = 0;
              me = C || 24720, C = e[me >> 2];
              e: {
                t: {
                  r: {
                    if (!y) {
                      if (C)
                        break r;
                      return 0;
                    }
                    if (Q = -2, !I)
                      break t;
                    i: {
                      if (C) {
                        Q = I;
                        break i;
                      }
                      if (C = Je[y | 0], S = C << 24 >> 24, (S | 0) >= 0)
                        return l && (e[l >> 2] = C), (S | 0) != 0;
                      if (!e[e[6178] >> 2]) {
                        if (Q = 1, !l)
                          break t;
                        return e[l >> 2] = S & 57343, 1;
                      }
                      if (C = C - 194 | 0, C >>> 0 > 50)
                        break r;
                      if (C = e[(C << 2) + 12208 >> 2], Q = I - 1 | 0, !Q)
                        break e;
                      y = y + 1 | 0;
                    }
                    if (S = Je[y | 0], ke = S >>> 3 | 0, (ke - 16 | (C >> 26) + ke) >>> 0 > 7)
                      break r;
                    for (; ; ) {
                      if (Q = Q - 1 | 0, C = S - 128 | C << 6, (C | 0) >= 0)
                        return e[me >> 2] = 0, l && (e[l >> 2] = C), I - Q | 0;
                      if (!Q)
                        break e;
                      if (y = y + 1 | 0, S = Je[y | 0], (S & 192) != 128)
                        break;
                    }
                  }
                  e[me >> 2] = 0, e[5732] = 25, Q = -1;
                }
                return Q;
              }
              return e[me >> 2] = C, -2;
            }
            function wo(l, y, I, C, Q) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0;
              var S = 0, me = 0, ke = 0, Ar = 0;
              S = bi - 144 | 0, bi = S, e[S + 136 >> 2] = 37, e[S + 140 >> 2] = 0, ke = S + 136 | 0, Au(ke | 1, 2096, 1, e[I + 4 >> 2]), me = fi(), e[S >> 2] = Q, l = S + 123 | 0, Q = qf(l, 13, me, ke, S) + l | 0, Ar = uc(l, Q, e[I + 4 >> 2]), ke = S + 4 | 0, me = e[I + 28 >> 2], e[ke >> 2] = me, e[me + 4 >> 2] = e[me + 4 >> 2] + 1, e[5996] = 0, me = S + 16 | 0, jf(215, l | 0, Ar | 0, Q | 0, me | 0, S + 12 | 0, S + 8 | 0, ke | 0), l = e[5996], e[5996] = 0;
              e: {
                if ((l | 0) != 1) {
                  l = e[ke >> 2], Q = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = Q, (Q | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), l = ai(y, me, e[S + 12 >> 2], e[S + 8 >> 2], I, C), bi = S + 144 | 0;
                  break e;
                }
                I = gi() | 0, l = e[S + 4 >> 2], y = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = y, (y | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), ss(I | 0), jn();
              }
              return l | 0;
            }
            function bo(l, y, I, C, Q) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0;
              var S = 0, me = 0, ke = 0, Ar = 0;
              S = bi - 144 | 0, bi = S, e[S + 136 >> 2] = 37, e[S + 140 >> 2] = 0, ke = S + 136 | 0, Au(ke | 1, 2096, 0, e[I + 4 >> 2]), me = fi(), e[S >> 2] = Q, l = S + 123 | 0, Q = qf(l, 13, me, ke, S) + l | 0, Ar = uc(l, Q, e[I + 4 >> 2]), ke = S + 4 | 0, me = e[I + 28 >> 2], e[ke >> 2] = me, e[me + 4 >> 2] = e[me + 4 >> 2] + 1, e[5996] = 0, me = S + 16 | 0, jf(215, l | 0, Ar | 0, Q | 0, me | 0, S + 12 | 0, S + 8 | 0, ke | 0), l = e[5996], e[5996] = 0;
              e: {
                if ((l | 0) != 1) {
                  l = e[ke >> 2], Q = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = Q, (Q | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), l = ai(y, me, e[S + 12 >> 2], e[S + 8 >> 2], I, C), bi = S + 144 | 0;
                  break e;
                }
                I = gi() | 0, l = e[S + 4 >> 2], y = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = y, (y | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), ss(I | 0), jn();
              }
              return l | 0;
            }
            function go(l, y, I, C, Q) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0;
              var S = 0, me = 0, ke = 0, Ar = 0;
              S = bi + -64 | 0, bi = S, e[S + 56 >> 2] = 37, e[S + 60 >> 2] = 0, ke = S + 56 | 0, Au(ke | 1, 2096, 1, e[I + 4 >> 2]), me = fi(), e[S >> 2] = Q, l = S + 43 | 0, Q = qf(l, 13, me, ke, S) + l | 0, Ar = uc(l, Q, e[I + 4 >> 2]), ke = S + 4 | 0, me = e[I + 28 >> 2], e[ke >> 2] = me, e[me + 4 >> 2] = e[me + 4 >> 2] + 1, e[5996] = 0, me = S + 16 | 0, jf(211, l | 0, Ar | 0, Q | 0, me | 0, S + 12 | 0, S + 8 | 0, ke | 0), l = e[5996], e[5996] = 0;
              e: {
                if ((l | 0) != 1) {
                  l = e[ke >> 2], Q = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = Q, (Q | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), l = Ne(y, me, e[S + 12 >> 2], e[S + 8 >> 2], I, C), bi = S - -64 | 0;
                  break e;
                }
                I = gi() | 0, l = e[S + 4 >> 2], y = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = y, (y | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), ss(I | 0), jn();
              }
              return l | 0;
            }
            function qn(l, y, I, C, Q) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0;
              var S = 0, me = 0, ke = 0, Ar = 0;
              S = bi + -64 | 0, bi = S, e[S + 56 >> 2] = 37, e[S + 60 >> 2] = 0, ke = S + 56 | 0, Au(ke | 1, 2096, 0, e[I + 4 >> 2]), me = fi(), e[S >> 2] = Q, l = S + 43 | 0, Q = qf(l, 13, me, ke, S) + l | 0, Ar = uc(l, Q, e[I + 4 >> 2]), ke = S + 4 | 0, me = e[I + 28 >> 2], e[ke >> 2] = me, e[me + 4 >> 2] = e[me + 4 >> 2] + 1, e[5996] = 0, me = S + 16 | 0, jf(211, l | 0, Ar | 0, Q | 0, me | 0, S + 12 | 0, S + 8 | 0, ke | 0), l = e[5996], e[5996] = 0;
              e: {
                if ((l | 0) != 1) {
                  l = e[ke >> 2], Q = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = Q, (Q | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), l = Ne(y, me, e[S + 12 >> 2], e[S + 8 >> 2], I, C), bi = S - -64 | 0;
                  break e;
                }
                I = gi() | 0, l = e[S + 4 >> 2], y = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = y, (y | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), ss(I | 0), jn();
              }
              return l | 0;
            }
            function io(l, y, I) {
              l = l | 0, y = y | 0, I = I | 0;
              var C = 0, Q = 0, S = 0, me = 0;
              e[I >> 2] = 0;
              e: {
                if (Q = e[y + 4 >> 2], !Q)
                  break e;
                S = e[y >> 2];
                t: {
                  r: {
                    i: {
                      for (; ; ) {
                        if (C = Se[S | 0], me = e[I >> 2], (C | 0) < ((me ? 48 : 49) | 0) | (C | 0) > 57)
                          break i;
                        if (C = (C + No(me, 10) | 0) - 48 | 0, e[I >> 2] = C >>> 0 >= 65535 ? 65535 : C, Q = Q - 1 | 0, e[y + 4 >> 2] = Q, S = S + 1 | 0, e[y >> 2] = S, !Q)
                          break;
                      }
                      if (e[I >> 2])
                        break r;
                      break e;
                    }
                    if (!me)
                      break e;
                    if ((C | 0) == 64)
                      break t;
                  }
                  e[l >> 2] = 0, e[l + 4 >> 2] = 0, e[l + 48 >> 2] = 0, e[l + 52 >> 2] = 0, e[l + 40 >> 2] = 0, e[l + 44 >> 2] = 0, e[l + 32 >> 2] = 0, e[l + 36 >> 2] = 0, e[l + 24 >> 2] = 0, e[l + 28 >> 2] = 0, e[l + 16 >> 2] = 0, e[l + 20 >> 2] = 0, e[l + 8 >> 2] = 0, e[l + 12 >> 2] = 0;
                  return;
                }
                e[y + 4 >> 2] = Q - 1, e[y >> 2] = S + 1, Ku(l, y);
                return;
              }
              e[I >> 2] = 1, Ku(l, y);
            }
            function So(l, y, I, C, Q, S, me, ke) {
              var Ar = 0, br = 0, Qr = 0, Ur = 0;
              br = 1, Ar = C & 2147483647, Ur = Ar, Qr = (Ar | 0) == 2147418112;
              e: {
                if ((Qr & !I ? l | y : Qr & (I | 0) != 0 | Ar >>> 0 > 2147418112) || (Ar = ke & 2147483647, !me & (Ar | 0) == 2147418112 ? Q | S : (Ar | 0) == 2147418112 & (me | 0) != 0 | Ar >>> 0 > 2147418112))
                  break e;
                if (!(l | Q | (I | me) | (y | S | (Ar | Ur))))
                  return 0;
                if (br = C & ke, (br | 0) > 0 | (br | 0) >= 0) {
                  if (br = -1, (I | 0) == (me | 0) & (C | 0) == (ke | 0) ? (y | 0) == (S | 0) & l >>> 0 < Q >>> 0 | y >>> 0 < S >>> 0 : I >>> 0 < me >>> 0 & (C | 0) <= (ke | 0) | (C | 0) < (ke | 0))
                    break e;
                  return (l ^ Q | I ^ me | (y ^ S | C ^ ke)) != 0;
                }
                if (br = -1, (I | 0) == (me | 0) & (C | 0) == (ke | 0) ? (y | 0) == (S | 0) & l >>> 0 > Q >>> 0 | y >>> 0 > S >>> 0 : I >>> 0 > me >>> 0 & (C | 0) >= (ke | 0) | (C | 0) > (ke | 0))
                  break e;
                br = (l ^ Q | I ^ me | (y ^ S | C ^ ke)) != 0;
              }
              return br;
            }
            function qo(l, y) {
              l = l | 0, y = y | 0;
              var I = 0, C = 0, Q = 0, S = 0, me = 0, ke = 0;
              e: {
                t: {
                  Q = e[l + 4 >> 2], S = e[l >> 2], C = Q - S >> 2;
                  r: {
                    if (C >>> 0 < y >>> 0) {
                      if (me = y - C | 0, I = e[l + 8 >> 2], me >>> 0 <= I - Q >> 2 >>> 0) {
                        y = l, l = me << 2, e[y + 4 >> 2] = jr(Q, 0, l) + l;
                        return;
                      }
                      if (y >>> 0 >= 1073741824)
                        break t;
                      if (I = I - S | 0, ke = I >> 1, y = I >>> 0 >= 2147483644 ? 1073741823 : y >>> 0 < ke >>> 0 ? ke : y, y >>> 0 >= 1073741824)
                        break e;
                      if (I = y << 2, y = ga(I), I = y + I | 0, y = y + (C << 2) | 0, C = me << 2, C = jr(y, 0, C) + C | 0, (Q | 0) != (S | 0))
                        for (; y = y - 4 | 0, Q = Q - 4 | 0, e[y >> 2] = e[Q >> 2], (Q | 0) != (S | 0); )
                          ;
                      if (e[l + 8 >> 2] = I, e[l + 4 >> 2] = C, e[l >> 2] = y, !S)
                        break r;
                      Tr(S);
                      return;
                    }
                    if (y >>> 0 >= C >>> 0)
                      break r;
                    e[l + 4 >> 2] = (y << 2) + S;
                  }
                  return;
                }
                tf(), jn();
              }
              kc(), jn();
            }
            function Ln(l, y, I, C, Q) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0;
              var S = 0, me = 0, ke = 0, Ar = 0, br = 0, Qr = 0;
              if (l = bi - 208 | 0, bi = l, me = fi(), e[l >> 2] = Q, Q = l + 176 | 0, ke = qf(Q, 20, me, 1937, l), me = ke + Q | 0, Ar = uc(Q, me, e[I + 4 >> 2]), S = e[I + 28 >> 2], e[l + 12 >> 2] = S, e[S + 4 >> 2] = e[S + 4 >> 2] + 1, e[5996] = 0, br = no(197, e[l + 12 >> 2]) | 0, S = e[5996], e[5996] = 0, (S | 0) != 1)
                return S = e[l + 12 >> 2], Qr = e[S + 4 >> 2] - 1 | 0, e[S + 4 >> 2] = Qr, (Qr | 0) == -1 && Yn[e[e[S >> 2] + 8 >> 2]](S), S = Q, Q = l + 16 | 0, Yn[e[e[br >> 2] + 48 >> 2]](br, S, me, Q) | 0, S = y, y = Q + (ke << 2) | 0, y = ai(S, Q, (me | 0) == (Ar | 0) ? y : (l + (Ar - l << 2) | 0) - 688 | 0, y, I, C), bi = l + 208 | 0, y | 0;
              I = gi() | 0, l = e[l + 12 >> 2], y = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = y, (y | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), ss(I | 0), jn();
            }
            function ro(l) {
              var y = 0, I = 0, C = 0, Q = 0, S = 0;
              if (S = l + 27 & -4, l = S, y = l >>> 0 <= 1 ? 1 : l, l = y, I = l + 15 & -16, l = l >>> 0 < I >>> 0 ? I : l, l & 15 ? l = 0 : l = Su(16, l), !l)
                e:
                  for (I = 0, l = e[6705], l || (e[6705] = 26844, ea[13423] = 125, ea[13422] = 128, l = e[6705]), C = (y + 3 >>> 2 | 0) + 1 | 0; ; ) {
                    y = 0;
                    t: {
                      if (!l | (l | 0) == 27344)
                        l = y;
                      else {
                        if (y = N2[l + 2 >> 1], Q = C + (y >>> 0 > C >>> 0 ? y - C & 3 : 0) | 0, Q >>> 0 < y >>> 0) {
                          I = y - Q | 0, ea[l + 2 >> 1] = I, l = ((I & 65535) << 2) + l | 0, ea[l + 2 >> 1] = Q, ea[l >> 1] = 0, l = l + 4 | 0;
                          break e;
                        }
                        if (y >>> 0 < C >>> 0)
                          break t;
                        y = N2[l >> 1];
                        r: {
                          if (!I) {
                            e[6705] = (y << 2) + 26832;
                            break r;
                          }
                          ea[I >> 1] = y;
                        }
                        ea[l >> 1] = 0, l = l + 4 | 0;
                      }
                      break e;
                    }
                    I = l, l = (N2[l >> 1] << 2) + 26832 | 0;
                  }
              return l || (_c(), jn()), jr(l, 0, S) + 24 | 0;
            }
            function Qo(l, y, I, C, Q) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0;
              var S = 0, me = 0, ke = 0, Ar = 0, br = 0, Qr = 0;
              if (l = bi - 96 | 0, bi = l, me = fi(), e[l >> 2] = Q, Q = l - -64 | 0, ke = qf(Q, 20, me, 1937, l), me = ke + Q | 0, Ar = uc(Q, me, e[I + 4 >> 2]), S = e[I + 28 >> 2], e[l + 12 >> 2] = S, e[S + 4 >> 2] = e[S + 4 >> 2] + 1, e[5996] = 0, br = no(170, e[l + 12 >> 2]) | 0, S = e[5996], e[5996] = 0, (S | 0) != 1)
                return S = e[l + 12 >> 2], Qr = e[S + 4 >> 2] - 1 | 0, e[S + 4 >> 2] = Qr, (Qr | 0) == -1 && Yn[e[e[S >> 2] + 8 >> 2]](S), S = Q, Q = l + 16 | 0, Yn[e[e[br >> 2] + 32 >> 2]](br, S, me, Q) | 0, S = y, y = Q + ke | 0, y = Ne(S, Q, (me | 0) == (Ar | 0) ? y : (l + (Ar - l | 0) | 0) - 48 | 0, y, I, C), bi = l + 96 | 0, y | 0;
              I = gi() | 0, l = e[l + 12 >> 2], y = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = y, (y | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), ss(I | 0), jn();
            }
            function Vo(l, y, I, C, Q, S, me, ke) {
              var Ar = 0, br = 0, Qr = 0, Ur = 0;
              if (Ar = bi - 16 | 0, bi = Ar, 1073741806 - y >>> 0 >= I >>> 0) {
                Qr = (Je[l + 11 | 0] & 128) >>> 7 | 0 ? e[l >> 2] : l, br = Ar + 4 | 0, Ur = br, y >>> 0 <= 536870886 ? (e[Ar + 12 >> 2] = y << 1, e[Ar + 4 >> 2] = y + I, I = e[(qs[br >> 2] < qs[Ar + 12 >> 2] ? Ar + 12 | 0 : br) >> 2], I >>> 0 >= 2 ? (br = I + 4 & -4, I = br - 1 | 0, I = (I | 0) == 2 ? br : I) : I = 1, I = I + 1 | 0) : I = 1073741807, yh(Ur, I), I = e[Ar + 4 >> 2], Q && du(I, Qr, Q), me && du(I + (Q << 2) | 0, ke, me), br = Q + S | 0, ke = C - br | 0, (C | 0) != (br | 0) && (C = Q << 2, du((C + I | 0) + (me << 2) | 0, (C + Qr | 0) + (S << 2) | 0, ke)), (y | 0) != 1 && Tr(Qr), e[l >> 2] = I, e[l + 8 >> 2] = e[Ar + 8 >> 2] | -2147483648, y = l, l = ke + (Q + me | 0) | 0, e[y + 4 >> 2] = l, e[I + (l << 2) >> 2] = 0, bi = Ar + 16 | 0;
                return;
              }
              xf(), jn();
            }
            function as(l, y, I) {
              l = l | 0, y = y | 0, I = I | 0;
              var C = 0, Q = 0, S = 0, me = 0;
              if (Q = I - y | 0, Q >>> 0 < 2147483632) {
                e: {
                  if (Q >>> 0 <= 10) {
                    Se[l + 11 | 0] = Q, C = l;
                    break e;
                  }
                  S = (Q | 15) + 1 | 0, C = ga(S), e[l + 8 >> 2] = S | -2147483648, e[l >> 2] = C, e[l + 4 >> 2] = Q;
                }
                e: {
                  if ((y | 0) == (I | 0))
                    break e;
                  if (S = (y ^ -1) + I | 0, me = Q & 7, me)
                    for (Q = 0; Se[C | 0] = Je[y | 0], C = C + 1 | 0, y = y + 1 | 0, Q = Q + 1 | 0, (me | 0) != (Q | 0); )
                      ;
                  if (S >>> 0 < 7)
                    break e;
                  for (; Se[C | 0] = Je[y | 0], Se[C + 1 | 0] = Je[y + 1 | 0], Se[C + 2 | 0] = Je[y + 2 | 0], Se[C + 3 | 0] = Je[y + 3 | 0], Se[C + 4 | 0] = Je[y + 4 | 0], Se[C + 5 | 0] = Je[y + 5 | 0], Se[C + 6 | 0] = Je[y + 6 | 0], Se[C + 7 | 0] = Je[y + 7 | 0], C = C + 8 | 0, y = y + 8 | 0, (I | 0) != (y | 0); )
                    ;
                }
                return Se[C | 0] = 0, l | 0;
              }
              xf(), jn();
            }
            function cs(l, y, I, C) {
              var Q = 0, S = 0, me = 0;
              if (Q = bi - 32 | 0, bi = Q, I >>> 0 < 2147483632) {
                e: {
                  t: {
                    if (I >>> 0 >= 11) {
                      me = (I | 15) + 1 | 0, S = ga(me), e[Q + 16 >> 2] = me | -2147483648, e[Q + 8 >> 2] = S, e[Q + 12 >> 2] = I;
                      break t;
                    }
                    if (Se[Q + 19 | 0] = I, S = Q + 8 | 0, !I)
                      break e;
                  }
                  S = Sa(S, y, I) + I | 0;
                }
                Se[S | 0] = 0, e[5996] = 0, Co(31, Q + 20 | 0, Q + 8 | 0), y = e[5996], e[5996] = 0;
                e: {
                  t: {
                    if ((y | 0) != 1) {
                      if (Se[Q + 19 | 0] < 0 && Tr(e[Q + 8 >> 2]), I = e[Q + 24 >> 2], y = e[Q + 20 >> 2], (I - y | 0) != (C | 0))
                        break t;
                      e[l + 4 >> 2] = I, e[l >> 2] = y, e[l + 8 >> 2] = e[Q + 28 >> 2];
                      break e;
                    }
                    l = gi() | 0, Se[Q + 19 | 0] < 0 && Tr(e[Q + 8 >> 2]), ss(l | 0), jn();
                  }
                  if (e[l + 8 >> 2] = 0, e[l >> 2] = 0, e[l + 4 >> 2] = 0, !y)
                    break e;
                  Tr(y);
                }
                bi = Q + 32 | 0;
                return;
              }
              xf(), jn();
            }
            function ms(l, y, I, C, Q, S, me, ke) {
              var Ar = 0, br = 0, Qr = 0, Ur = 0;
              if (Ar = bi - 16 | 0, bi = Ar, 2147483630 - y >>> 0 >= I >>> 0) {
                Qr = (Je[l + 11 | 0] & 128) >>> 7 | 0 ? e[l >> 2] : l, br = Ar + 4 | 0, Ur = br, y >>> 0 <= 1073741798 ? (e[Ar + 12 >> 2] = y << 1, e[Ar + 4 >> 2] = y + I, I = e[(qs[br >> 2] < qs[Ar + 12 >> 2] ? Ar + 12 | 0 : br) >> 2], I >>> 0 >= 11 ? (br = I + 16 & -16, I = br - 1 | 0, I = (I | 0) == 11 ? br : I) : I = 10, I = I + 1 | 0) : I = 2147483631, gh(Ur, I), I = e[Ar + 4 >> 2], Q && Gc(I, Qr, Q), me && Gc(I + Q | 0, ke, me), br = Q + S | 0, ke = C - br | 0, (C | 0) != (br | 0) && Gc((I + Q | 0) + me | 0, (Q + Qr | 0) + S | 0, ke), (y | 0) != 10 && Tr(Qr), e[l >> 2] = I, e[l + 8 >> 2] = e[Ar + 8 >> 2] | -2147483648, y = l, l = ke + (Q + me | 0) | 0, e[y + 4 >> 2] = l, Se[l + I | 0] = 0, bi = Ar + 16 | 0;
                return;
              }
              xf(), jn();
            }
            function ai(l, y, I, C, Q, S) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0;
              var me = 0, ke = 0, Ar = 0, br = 0;
              Ar = bi - 16 | 0, bi = Ar;
              e: {
                t: {
                  if (!l || (me = e[Q + 12 >> 2], ke = I - y | 0, (ke | 0) > 0 && (ke = ke >>> 2 | 0, (Yn[e[e[l >> 2] + 48 >> 2]](l, y, ke) | 0) != (ke | 0))))
                    break t;
                  if (y = C - y >> 2, me = (y | 0) < (me | 0) ? me - y | 0 : 0, (me | 0) > 0) {
                    if (y = Bf(Ar + 4 | 0, me, S), S = (Je[y + 11 | 0] & 128) >>> 7 | 0 ? e[y >> 2] : y, e[5996] = 0, S = Ko(217, l | 0, S | 0, me | 0) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                      break e;
                    if (Yo(y), (S | 0) != (me | 0))
                      break t;
                  }
                  if (y = C - I | 0, (y | 0) > 0 && (y = y >>> 2 | 0, (Yn[e[e[l >> 2] + 48 >> 2]](l, I, y) | 0) != (y | 0)))
                    break t;
                  e[Q + 12 >> 2] = 0, br = l;
                }
                return bi = Ar + 16 | 0, br | 0;
              }
              l = gi() | 0, Yo(y), ss(l | 0), jn();
            }
            function ci(l, y, I, C, Q) {
              if (l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, hc(l, e[y + 8 >> 2], Q)) {
                e[y + 28 >> 2] == 1 | e[y + 4 >> 2] != (I | 0) || (e[y + 28 >> 2] = C);
                return;
              }
              e: {
                if (hc(l, e[y >> 2], Q)) {
                  if (!(e[y + 16 >> 2] != (I | 0) & e[y + 20 >> 2] != (I | 0))) {
                    if ((C | 0) != 1)
                      break e;
                    e[y + 32 >> 2] = 1;
                    return;
                  }
                  e[y + 32 >> 2] = C;
                  t: {
                    if (e[y + 44 >> 2] == 4)
                      break t;
                    if (ea[y + 52 >> 1] = 0, l = e[l + 8 >> 2], Yn[e[e[l >> 2] + 20 >> 2]](l, y, I, I, 1, Q), Je[y + 53 | 0]) {
                      if (e[y + 44 >> 2] = 3, !Je[y + 52 | 0])
                        break t;
                      break e;
                    }
                    e[y + 44 >> 2] = 4;
                  }
                  if (e[y + 20 >> 2] = I, e[y + 40 >> 2] = e[y + 40 >> 2] + 1, e[y + 36 >> 2] != 1 | e[y + 24 >> 2] != 2)
                    break e;
                  Se[y + 54 | 0] = 1;
                  return;
                }
                l = e[l + 8 >> 2], Yn[e[e[l >> 2] + 24 >> 2]](l, y, I, C, Q);
              }
            }
            function Fi(l) {
              var y = 0, I = 0, C = 0, Q = 0;
              if (Q = bi - 16 | 0, bi = Q, y = Q + 4 | 0, e[y + 4 >> 2] = 190, e[y >> 2] = l, e[y + 8 >> 2] = 0, C = bi - 16 | 0, bi = C, e[l >> 2] != -1)
                e: {
                  for (I = C + 12 | 0, e[I >> 2] = y, y = C + 8 | 0, e[y >> 2] = I; I = e[l >> 2], (I | 0) == 1; )
                    ;
                  t: {
                    if (!I) {
                      if (e[l >> 2] = 1, y = e[e[y >> 2] >> 2], e[5996] = 0, La(191, y | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                        break t;
                      e[l >> 2] = -1;
                    }
                    break e;
                  }
                  Zf(Ws(0) | 0) | 0, e[l >> 2] = 0, e[5996] = 0, jo(192), l = e[5996], e[5996] = 0;
                  t: {
                    if ((l | 0) == 1) {
                      if (l = gi() | 0, e[5996] = 0, jo(110), y = e[5996], e[5996] = 0, (y | 0) != 1)
                        break t;
                      Ws(0) | 0, _c();
                    }
                    jn();
                  }
                  ss(l | 0), jn();
                }
              return bi = C + 16 | 0, bi = Q + 16 | 0, e[l + 4 >> 2] - 1 | 0;
            }
            function Eo(l, y, I, C, Q, S, me) {
              for (l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0, me = me | 0, I = bi - 128 | 0, bi = I, e[I + 12 >> 2] = I + 116, C = e[l + 8 >> 2], l = I + 16 | 0, ld(C, l, I + 12 | 0, Q, S, me), Q = bi - 16 | 0, bi = Q, me = bi - 32 | 0, bi = me, C = bi - 16 | 0, bi = C, e[C + 12 >> 2] = e[I + 12 >> 2], e[me + 24 >> 2] = l, e[me + 28 >> 2] = e[C + 12 >> 2], bi = C + 16 | 0, S = e[me + 24 >> 2], l = e[me + 28 >> 2], C = bi - 16 | 0, bi = C, e[C + 12 >> 2] = y; ; ) {
                if ((l | 0) != (S | 0)) {
                  Hd(C + 12 | 0, Se[S | 0]), S = S + 1 | 0;
                  continue;
                }
                break;
              }
              return e[me + 16 >> 2] = l, e[me + 20 >> 2] = e[C + 12 >> 2], bi = C + 16 | 0, l = e[me + 16 >> 2], e[me + 12 >> 2] = e[me + 20 >> 2], e[Q + 8 >> 2] = l, e[Q + 12 >> 2] = e[me + 12 >> 2], bi = me + 32 | 0, bi = Q + 16 | 0, bi = I + 128 | 0, e[Q + 12 >> 2];
            }
            function is(l, y, I, C) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0;
              var Q = 0, S = 0;
              e[l + 8 >> 2] = 0, e[l >> 2] = 0, e[l + 4 >> 2] = 0, e[5996] = 0, Q = no(3, 24) | 0, S = e[5996], e[5996] = 0;
              e: {
                if ((S | 0) != 1) {
                  if (e[l + 4 >> 2] = Q, e[l >> 2] = Q, S = Q + 24 | 0, e[l + 8 >> 2] = S, e[Q >> 2] = e[y >> 2], e[Q + 4 >> 2] = e[y + 4 >> 2], e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[l + 4 >> 2] = Q + 8, e[Q + 8 >> 2] = e[I >> 2], e[Q + 12 >> 2] = e[I + 4 >> 2], e[I >> 2] = 0, e[I + 4 >> 2] = 0, y = Q + 16 | 0, e[l + 4 >> 2] = y, y >>> 0 < S >>> 0) {
                    e[y >> 2] = e[C >> 2], e[y + 4 >> 2] = e[C + 4 >> 2], e[C >> 2] = 0, e[C + 4 >> 2] = 0, e[l + 4 >> 2] = y + 8;
                    break e;
                  }
                  if (e[5996] = 0, Co(162, l | 0, C | 0), y = e[5996], e[5996] = 0, (y | 0) != 1)
                    break e;
                }
                y = gi() | 0, Za(l), ss(y | 0), jn();
              }
            }
            function ws(l, y, I) {
              l = l | 0, y = y | 0, I = I | 0;
              var C = 0, Q = 0, S = 0;
              if (C = bi - 16 | 0, bi = C, e[l >> 2] = 7e3, e[l + 4 >> 2] = 0, e[l + 8 >> 2] = 0, e[C + 4 >> 2] = e[I >> 2], e[C + 8 >> 2] = e[I + 4 >> 2], e[C + 12 >> 2] = e[I + 8 >> 2], e[I + 8 >> 2] = 0, e[I >> 2] = 0, e[I + 4 >> 2] = 0, e[5996] = 0, mf(64, l + 12 | 0, y | 0, C + 4 | 0, 0) | 0, y = e[5996], e[5996] = 0, (y | 0) != 1) {
                if (y = e[C + 4 >> 2], y) {
                  if (I = e[C + 8 >> 2], (y | 0) != (I | 0)) {
                    for (; ; ) {
                      I = I - 8 | 0, Q = e[I + 4 >> 2];
                      e: {
                        if (!Q || (S = e[Q + 4 >> 2], e[Q + 4 >> 2] = S - 1, S))
                          break e;
                        Yn[e[e[Q >> 2] + 8 >> 2]](Q), Ls(Q);
                      }
                      if ((y | 0) == (I | 0))
                        break;
                    }
                    y = e[C + 4 >> 2];
                  }
                  Tr(y);
                }
                return bi = C + 16 | 0, l | 0;
              }
              l = gi() | 0, Za(C + 4 | 0), ss(l | 0), jn();
            }
            function ys(l, y) {
              var I = 0, C = 0, Q = 0, S = 0, me = 0, ke = 0, Ar = 0;
              Q = bi - 16 | 0, bi = Q, Ta(+y), me = oa(1) | 0, I = oa(0) | 0, C = me & 2147483647, S = C + -1048576 | 0;
              e: {
                if ((S | 0) == 2145386495 | S >>> 0 < 2145386495) {
                  ke = I << 28, I = (C & 15) << 28 | I >>> 4, C = (C >>> 4 | 0) + 1006632960 | 0;
                  break e;
                }
                if ((C | 0) == 2146435072 | C >>> 0 > 2146435072) {
                  ke = I << 28, I = (me & 15) << 28 | I >>> 4, C = me >>> 4 | 2147418112;
                  break e;
                }
                if (!(I | C)) {
                  I = 0, C = 0;
                  break e;
                }
                S = I, I = C ? Ha(C) : Ha(I) + 32 | 0, Es(Q, S, C, 0, 0, I + 49 | 0), Ar = e[Q >> 2], ke = e[Q + 4 >> 2], S = 15372 - I << 16, I = e[Q + 8 >> 2], C = S | e[Q + 12 >> 2] ^ 65536;
              }
              e[l >> 2] = Ar, e[l + 4 >> 2] = ke, e[l + 8 >> 2] = I, e[l + 12 >> 2] = me & -2147483648 | C, bi = Q + 16 | 0;
            }
            function Is(l) {
              l = l | 0;
              var y = 0, I = 0, C = 0, Q = 0;
              if (I = e[l + 76 >> 2], (I | 0) == -1) {
                I = l, C = bi - 16 | 0, bi = C, l = e[l + 28 >> 2], e[C + 12 >> 2] = l, e[l + 4 >> 2] = e[l + 4 >> 2] + 1, e[5996] = 0, l = no(170, e[C + 12 >> 2]) | 0, y = e[5996], e[5996] = 0;
                e: {
                  t: {
                    if ((y | 0) == 1 || (e[5996] = 0, l = wn(171, l | 0, 32) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1))
                      break t;
                    y = e[C + 12 >> 2], Q = e[y + 4 >> 2] - 1 | 0, e[y + 4 >> 2] = Q, (Q | 0) == -1 && Yn[e[e[y >> 2] + 8 >> 2]](y), bi = C + 16 | 0;
                    break e;
                  }
                  y = gi() | 0, l = e[C + 12 >> 2], I = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = I, (I | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), ss(y | 0), jn();
                }
                y = I, I = l, e[y + 76 >> 2] = l;
              }
              return I << 24 >> 24;
            }
            function ks(l, y) {
              l = l | 0, y = y | 0;
              var I = 0, C = 0, Q = 0, S = 0, me = 0, ke = 0;
              if (I = e[l + 4 >> 2], C = e[l + 8 >> 2], I >>> 0 < C >>> 0) {
                e[I >> 2] = y, e[l + 4 >> 2] = I + 4;
                return;
              }
              e: {
                if (me = e[l >> 2], Q = I - me >> 2, S = Q + 1 | 0, S >>> 0 < 1073741824) {
                  if (ke = Q << 2, C = C - me | 0, Q = C >> 1, Q = C >>> 0 >= 2147483644 ? 1073741823 : Q >>> 0 > S >>> 0 ? Q : S, Q) {
                    if (Q >>> 0 >= 1073741824)
                      break e;
                    S = ga(Q << 2);
                  } else
                    S = 0;
                  if (C = ke + S | 0, e[C >> 2] = y, y = C + 4 | 0, (I | 0) != (me | 0)) {
                    for (; C = C - 4 | 0, I = I - 4 | 0, e[C >> 2] = e[I >> 2], (I | 0) != (me | 0); )
                      ;
                    I = e[l >> 2];
                  }
                  e[l + 8 >> 2] = S + (Q << 2), e[l + 4 >> 2] = y, e[l >> 2] = C, I && Tr(I);
                  return;
                }
                tf(), jn();
              }
              kc(), jn();
            }
            function Ps(l, y, I, C, Q) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0;
              var S = 0, me = 0;
              if (Q = bi - 16 | 0, bi = Q, S = ga(104), e[S >> 2] = 7e3, e[S + 4 >> 2] = 0, e[S + 8 >> 2] = 0, e[Q + 4 >> 2] = e[I >> 2], e[Q + 8 >> 2] = e[I + 4 >> 2], e[Q + 12 >> 2] = e[I + 8 >> 2], e[I + 8 >> 2] = 0, e[I >> 2] = 0, e[I + 4 >> 2] = 0, e[5996] = 0, me = mf(163, S + 12 | 0, y | 0, Q + 4 | 0, C | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) != 1) {
                if (C = e[Q + 4 >> 2], C) {
                  if (y = e[Q + 8 >> 2], (C | 0) != (y | 0))
                    for (; I = y - 12 | 0, Se[y - 1 | 0] < 0 && Tr(e[I >> 2]), y = I, (I | 0) != (C | 0); )
                      ;
                  Tr(C);
                }
                e[l + 4 >> 2] = S, e[l >> 2] = me, bi = Q + 16 | 0;
                return;
              }
              l = gi() | 0, hf(Q + 4 | 0), Tr(S), ss(l | 0), jn();
            }
            function Po(l, y, I, C) {
              var Q = 0, S = 0, me = 0;
              Q = bi - 16 | 0, bi = Q;
              e: {
                t: {
                  if ((l | 0) != (y | 0))
                    r: {
                      me = e[5732], e[5732] = 0, fi(), l = Sp(l, Q + 12 | 0, C), C = Ci;
                      i: {
                        if (S = e[5732], S) {
                          if (e[Q + 12 >> 2] != (y | 0))
                            break r;
                          if ((S | 0) != 68)
                            break i;
                          if (e[I >> 2] = 4, y = 2147483647, !!l & (C | 0) >= 0 | (C | 0) > 0)
                            break e;
                          break t;
                        }
                        if (e[5732] = me, e[Q + 12 >> 2] == (y | 0))
                          break i;
                        break r;
                      }
                      if ((C | 0) < 0 & l >>> 0 <= 2147483647 | (C | 0) < -1) {
                        e[I >> 2] = 4;
                        break t;
                      }
                      if ((C | 0) >= 0 & l >>> 0 >= 2147483648 | (C | 0) > 0) {
                        e[I >> 2] = 4, y = 2147483647;
                        break e;
                      }
                      y = l;
                      break e;
                    }
                  e[I >> 2] = 4, y = 0;
                  break e;
                }
                y = -2147483648;
              }
              return bi = Q + 16 | 0, y;
            }
            function fn(l, y, I, C, Q, S) {
              var me = 0, ke = 0, Ar = 0, br = 0;
              e: {
                if (S & 64) {
                  I = S + -64 | 0, y = I & 31, (I & 63) >>> 0 >= 32 ? (I = 0, y = Q >>> y | 0) : (I = Q >>> y | 0, y = ((1 << y) - 1 & Q) << 32 - y | C >>> y), C = 0, Q = 0;
                  break e;
                }
                if (!S)
                  break e;
                Ar = C, ke = 64 - S | 0, me = ke & 31, (ke & 63) >>> 0 >= 32 ? (ke = C << me, br = 0) : (ke = (1 << me) - 1 & Ar >>> 32 - me | Q << me, br = Ar << me), Ar = y, y = S & 31, (S & 63) >>> 0 >= 32 ? (me = 0, y = I >>> y | 0) : (me = I >>> y | 0, y = ((1 << y) - 1 & I) << 32 - y | Ar >>> y), y = br | y, I = me | ke, me = C, C = S & 31, (S & 63) >>> 0 >= 32 ? (ke = 0, C = Q >>> C | 0) : (ke = Q >>> C | 0, C = ((1 << C) - 1 & Q) << 32 - C | me >>> C), Q = ke;
              }
              e[l >> 2] = y, e[l + 4 >> 2] = I, e[l + 8 >> 2] = C, e[l + 12 >> 2] = Q;
            }
            function Qn(l, y, I) {
              var C = 0, Q = 0, S = 0;
              C = bi - 16 | 0, bi = C, e[C + 12 >> 2] = y, e[y + 4 >> 2] = e[y + 4 >> 2] + 1, e[5996] = 0, y = no(198, e[C + 12 >> 2]) | 0, Q = e[5996], e[5996] = 0;
              e: {
                if ((Q | 0) == 1 || (e[5996] = 0, Q = no(206, y | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1) || (e[I >> 2] = Q, e[5996] = 0, Co(207, l | 0, y | 0), l = e[5996], e[5996] = 0, (l | 0) == 1))
                  break e;
                l = e[C + 12 >> 2], y = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = y, (y | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), bi = C + 16 | 0;
                return;
              }
              I = gi() | 0, l = e[C + 12 >> 2], y = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = y, (y | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), ss(I | 0), jn();
            }
            function zn(l, y, I) {
              var C = 0, Q = 0, S = 0;
              C = bi - 16 | 0, bi = C, e[C + 12 >> 2] = y, e[y + 4 >> 2] = e[y + 4 >> 2] + 1, e[5996] = 0, y = no(180, e[C + 12 >> 2]) | 0, Q = e[5996], e[5996] = 0;
              e: {
                if ((Q | 0) == 1 || (e[5996] = 0, Q = no(193, y | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1) || (Se[I | 0] = Q, e[5996] = 0, Co(194, l | 0, y | 0), l = e[5996], e[5996] = 0, (l | 0) == 1))
                  break e;
                l = e[C + 12 >> 2], y = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = y, (y | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), bi = C + 16 | 0;
                return;
              }
              I = gi() | 0, l = e[C + 12 >> 2], y = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = y, (y | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), ss(I | 0), jn();
            }
            function es(l) {
              return Je[25148] ? e[6286] : (Je[26240] || (Se[26240] = 1), ja(25952, 18680), ja(25964, 18712), ja(25976, 18748), ja(25988, 18772), ja(26e3, 18796), ja(26012, 18812), ja(26024, 18832), ja(26036, 18852), ja(26048, 18880), ja(26060, 18920), ja(26072, 18952), ja(26084, 18988), ja(26096, 19024), ja(26108, 19040), ja(26120, 19056), ja(26132, 19072), ja(26144, 18796), ja(26156, 19088), ja(26168, 19104), ja(26180, 19120), ja(26192, 19136), ja(26204, 19152), ja(26216, 19168), ja(26228, 19184), Se[25148] = 1, e[6286] = 25952, 25952);
            }
            function us(l, y, I) {
              l = l | 0, y = y | 0, I = I | 0;
              var C = 0, Q = 0, S = 0, me = 0, ke = 0;
              S = Jf(I);
              e: {
                if (C = Je[l + 11 | 0], Q = C & 127, C = (C & 128) >>> 7 | 0, Q = C ? e[l + 4 >> 2] : Q, Q >>> 0 >= y >>> 0) {
                  if (C = C ? (e[l + 8 >> 2] & 2147483647) - 1 | 0 : 10, C - Q >>> 0 >= S >>> 0) {
                    if (!S)
                      break e;
                    C = (Je[l + 11 | 0] & 128) >>> 7 | 0 ? e[l >> 2] : l, ke = C + y | 0, (y | 0) != (Q | 0) && (me = y + C | 0, yu(me + S | 0, me, Q - y | 0), I = (I >>> 0 >= me >>> 0 && C + Q >>> 0 > I >>> 0 ? S : 0) + I | 0), yu(ke, I, S), y = S + Q | 0;
                    t: {
                      if ((Je[l + 11 | 0] & 128) >>> 7 | 0) {
                        e[l + 4 >> 2] = y;
                        break t;
                      }
                      Se[l + 11 | 0] = y;
                    }
                    Se[y + C | 0] = 0;
                    break e;
                  }
                  ms(l, C, (S + Q | 0) - C | 0, Q, y, 0, S, I);
                  break e;
                }
                I1(), jn();
              }
              return l | 0;
            }
            function Cs(l, y) {
              l = l | 0, y = y | 0;
              var I = 0, C = 0, Q = 0, S = 0, me = 0, ke = 0;
              if (Q = e[l + 4 >> 2], (Q | 0) != e[l + 8 >> 2]) {
                e[Q >> 2] = y, e[l + 4 >> 2] = Q + 4;
                return;
              }
              e: {
                if (me = e[l >> 2], S = Q - me | 0, I = S >> 2, C = I + 1 | 0, C >>> 0 < 1073741824) {
                  if (ke = I << 2, I = S >> 1, I = S >>> 0 >= 2147483644 ? 1073741823 : I >>> 0 > C >>> 0 ? I : C, I) {
                    if (I >>> 0 >= 1073741824)
                      break e;
                    S = ga(I << 2);
                  } else
                    S = 0;
                  if (C = ke + S | 0, e[C >> 2] = y, y = C + 4 | 0, (Q | 0) != (me | 0))
                    for (; C = C - 4 | 0, Q = Q - 4 | 0, e[C >> 2] = e[Q >> 2], (Q | 0) != (me | 0); )
                      ;
                  e[l + 8 >> 2] = S + (I << 2), e[l + 4 >> 2] = y, e[l >> 2] = C, me && Tr(me);
                  return;
                }
                tf(), jn();
              }
              kc(), jn();
            }
            function Es(l, y, I, C, Q, S) {
              var me = 0, ke = 0, Ar = 0;
              e: {
                if (S & 64) {
                  Q = S + -64 | 0, S = y, C = Q & 31, (Q & 63) >>> 0 >= 32 ? (Q = S << C, C = 0) : (Q = (1 << C) - 1 & S >>> 32 - C | I << C, C = S << C), y = 0, I = 0;
                  break e;
                }
                if (!S)
                  break e;
                ke = C, me = S & 31, (S & 63) >>> 0 >= 32 ? (Ar = C << me, ke = 0) : (Ar = (1 << me) - 1 & ke >>> 32 - me | Q << me, ke = ke << me), me = y, Q = 64 - S | 0, C = Q & 31, (Q & 63) >>> 0 >= 32 ? (Q = 0, C = I >>> C | 0) : (Q = I >>> C | 0, C = ((1 << C) - 1 & I) << 32 - C | me >>> C), C = ke | C, Q = Q | Ar, ke = y, me = S & 31, (S & 63) >>> 0 >= 32 ? (Ar = y << me, y = 0) : (Ar = (1 << me) - 1 & ke >>> 32 - me | I << me, y = ke << me), I = Ar;
              }
              e[l >> 2] = y, e[l + 4 >> 2] = I, e[l + 8 >> 2] = C, e[l + 12 >> 2] = Q;
            }
            function Rs(l) {
              l = l | 0;
              var y = 0, I = 0, C = 0, Q = 0;
              if (Q = e[l + 44 >> 2], Q) {
                if (y = Q, C = e[l + 48 >> 2], (y | 0) != (C | 0)) {
                  for (; ; ) {
                    C = C - 8 | 0, I = e[C + 4 >> 2];
                    e: {
                      if (!I || (y = e[I + 4 >> 2], e[I + 4 >> 2] = y - 1, y))
                        break e;
                      Yn[e[e[I >> 2] + 8 >> 2]](I), Ls(I);
                    }
                    if ((C | 0) == (Q | 0))
                      break;
                  }
                  y = e[l + 44 >> 2];
                }
                e[l + 48 >> 2] = Q, Tr(y);
              }
              if (y = e[l + 32 >> 2], y && (e[l + 36 >> 2] = y, Tr(y)), I = e[l + 20 >> 2], I) {
                if (C = I, y = e[l + 24 >> 2], (I | 0) != (y | 0)) {
                  for (; Q = y - 12 | 0, Se[y - 1 | 0] < 0 && Tr(e[Q >> 2]), y = Q, (I | 0) != (y | 0); )
                    ;
                  C = e[l + 20 >> 2];
                }
                e[l + 24 >> 2] = I, Tr(C);
              }
            }
            function Ds(l, y, I, C) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0;
              var Q = 0, S = 0;
              Q = bi - 16 | 0, bi = Q, e[Q >> 2] = I, e[Q + 4 >> 2] = C, e[Q + 8 >> 2] = I, e[Q + 12 >> 2] = C, I = bi - 32 | 0, bi = I, y = Ac(I + 8 | 0, y), e[5996] = 0, C = I + 20 | 0, Ms(174, C | 0, Q | 0, y | 0), S = e[5996], e[5996] = 0;
              e: {
                t: {
                  r: {
                    if ((S | 0) != 1) {
                      if (e[5996] = 0, l = wn(175, l | 0, C | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                        break r;
                      Yo(C), Yo(y), e[l >> 2] = 21872, y = e[Q + 4 >> 2], e[l + 8 >> 2] = e[Q >> 2], e[l + 12 >> 2] = y, bi = I + 32 | 0;
                      break e;
                    }
                    l = gi() | 0;
                    break t;
                  }
                  l = gi() | 0, Yo(I + 20 | 0);
                }
                Yo(y), ss(l | 0), jn();
              }
              return e[l >> 2] = 8492, bi = Q + 16 | 0, l | 0;
            }
            function Ns(l) {
              return Je[25140] ? e[6284] : (Je[25936] || (Se[25936] = 1), Ga(25648, 1065), Ga(25660, 1056), Ga(25672, 2204), Ga(25684, 2058), Ga(25696, 1135), Ga(25708, 2381), Ga(25720, 1073), Ga(25732, 1297), Ga(25744, 1802), Ga(25756, 1785), Ga(25768, 1793), Ga(25780, 1812), Ga(25792, 2024), Ga(25804, 2543), Ga(25816, 1837), Ga(25828, 1683), Ga(25840, 1135), Ga(25852, 1965), Ga(25864, 2051), Ga(25876, 2280), Ga(25888, 1924), Ga(25900, 1386), Ga(25912, 1263), Ga(25924, 2539), Se[25140] = 1, e[6284] = 25648, 25648);
            }
            function Fs(l, y, I, C, Q) {
              var S = 0, me = 0, ke = 0, Ar = 0;
              if (S = bi - 16 | 0, bi = S, 1073741807 - y >>> 0 >= I >>> 0) {
                ke = (Je[l + 11 | 0] & 128) >>> 7 | 0 ? e[l >> 2] : l, me = S + 4 | 0, Ar = me, y >>> 0 <= 536870886 ? (e[S + 12 >> 2] = y << 1, e[S + 4 >> 2] = y + I, I = e[(qs[me >> 2] < qs[S + 12 >> 2] ? S + 12 | 0 : me) >> 2], I >>> 0 >= 2 ? (me = I + 4 & -4, I = me - 1 | 0, I = (I | 0) == 2 ? me : I) : I = 1, I = I + 1 | 0) : I = 1073741807, yh(Ar, I), I = e[S + 4 >> 2], Q && du(I, ke, Q), (C | 0) != (Q | 0) && (me = Q << 2, du(me + I | 0, me + ke | 0, C - Q | 0)), (y | 0) != 1 && Tr(ke), e[l >> 2] = I, e[l + 8 >> 2] = e[S + 8 >> 2] | -2147483648, bi = S + 16 | 0;
                return;
              }
              xf(), jn();
            }
            function Qs(l, y, I, C, Q) {
              var S = 0, me = 0, ke = 0, Ar = 0;
              if (S = bi - 16 | 0, bi = S, 2147483631 - y >>> 0 >= I >>> 0) {
                ke = (Je[l + 11 | 0] & 128) >>> 7 | 0 ? e[l >> 2] : l, me = S + 4 | 0, Ar = me, y >>> 0 <= 1073741798 ? (e[S + 12 >> 2] = y << 1, e[S + 4 >> 2] = y + I, I = e[(qs[me >> 2] < qs[S + 12 >> 2] ? S + 12 | 0 : me) >> 2], I >>> 0 >= 11 ? (me = I + 16 & -16, I = me - 1 | 0, I = (I | 0) == 11 ? me : I) : I = 10, I = I + 1 | 0) : I = 2147483631, gh(Ar, I), I = e[S + 4 >> 2], Q && Gc(I, ke, Q), (C | 0) != (Q | 0) && Gc(I + Q | 0, Q + ke | 0, C - Q | 0), (y | 0) != 10 && Tr(ke), e[l >> 2] = I, e[l + 8 >> 2] = e[S + 8 >> 2] | -2147483648, bi = S + 16 | 0;
                return;
              }
              xf(), jn();
            }
            function Ys(l, y, I) {
              l = l | 0, y = y | 0, I = I | 0;
              var C = 0, Q = 0, S = 0, me = 0, ke = 0;
              for (Q = bi - 16 | 0, bi = Q; ; ) {
                e: {
                  if ((I | 0) <= (S | 0))
                    break e;
                  me = e[l + 16 >> 2], C = e[l + 12 >> 2];
                  t: {
                    if (me >>> 0 > C >>> 0) {
                      e[Q + 12 >> 2] = 2147483647, e[Q + 8 >> 2] = me - C, e[Q + 4 >> 2] = I - S, ke = y, me = C, y = Q + 4 | 0, C = Q + 8 | 0, y = e[y >> 2] < e[C >> 2] ? y : C, C = Q + 12 | 0, C = e[(e[y >> 2] < e[C >> 2] ? y : C) >> 2], y = Gc(ke, me, C), e[l + 12 >> 2] = e[l + 12 >> 2] + C, y = y + C | 0;
                      break t;
                    }
                    if (C = Yn[e[e[l >> 2] + 40 >> 2]](l) | 0, (C | 0) == -1)
                      break e;
                    Se[y | 0] = C << 24 >> 24, C = 1, y = y + 1 | 0;
                  }
                  S = C + S | 0;
                  continue;
                }
                break;
              }
              return bi = Q + 16 | 0, S | 0;
            }
            function Vs(l, y, I, C) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0;
              var Q = 0, S = 0, me = 0;
              Q = ga(56);
              e: {
                t: {
                  if ((I | 0) == (C | 0)) {
                    C = 0, I = 0;
                    break t;
                  }
                  if (S = C - I | 0, (S | 0) < 0) {
                    if (e[5996] = 0, jo(8), l = e[5996], e[5996] = 0, (l | 0) == 1)
                      break e;
                    jn();
                  }
                  if (e[5996] = 0, C = no(3, S | 0) | 0, me = e[5996], e[5996] = 0, (me | 0) == 1)
                    break e;
                  I = Sa(C, I, S) + S | 0;
                }
                return e[Q + 4 >> 2] = 0, e[Q + 8 >> 2] = 0, e[Q >> 2] = y, e[Q + 40 >> 2] = 0, e[Q + 44 >> 2] = 0, e[Q + 28 >> 2] = C, e[Q + 12 >> 2] = 0, e[Q + 16 >> 2] = 0, e[Q + 20 >> 2] = 0, e[Q + 24 >> 2] = 0, e[Q + 36 >> 2] = I, e[Q + 32 >> 2] = I, vn(l, Q), Q | 0;
              }
              l = gi() | 0, Tr(Q), ss(l | 0), jn();
            }
            function Hs(l, y, I) {
              var C = 0, Q = 0;
              C = (I | 0) != 0;
              e: {
                t: {
                  r: {
                    if (!(l & 3) | !I)
                      break r;
                    for (Q = y & 255; ; ) {
                      if ((Q | 0) == Je[l | 0])
                        break t;
                      if (I = I - 1 | 0, C = (I | 0) != 0, l = l + 1 | 0, !(l & 3))
                        break r;
                      if (!I)
                        break;
                    }
                  }
                  if (!C)
                    break e;
                  if (C = y & 255, !((C | 0) == Je[l | 0] | I >>> 0 < 4))
                    for (C = No(C, 16843009); ; ) {
                      if (Q = C ^ e[l >> 2], (Q ^ -1) & Q - 16843009 & -2139062144)
                        break t;
                      if (l = l + 4 | 0, I = I - 4 | 0, !(I >>> 0 > 3))
                        break;
                    }
                  if (!I)
                    break e;
                }
                for (y = y & 255; ; ) {
                  if ((y | 0) == Je[l | 0])
                    return l;
                  if (l = l + 1 | 0, I = I - 1 | 0, !I)
                    break;
                }
              }
              return 0;
            }
            function ra(l, y, I, C, Q, S) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0;
              var me = 0;
              e: {
                if (!((Je[S + 11 | 0] & 128) >>> 7 | 0)) {
                  y = e[S + 4 >> 2], e[l >> 2] = e[S >> 2], e[l + 4 >> 2] = y, e[l + 8 >> 2] = e[S + 8 >> 2];
                  break e;
                }
                Q = e[S >> 2], C = bi - 16 | 0, bi = C;
                t: {
                  r: {
                    I = e[S + 4 >> 2];
                    i: {
                      if (I >>> 0 < 2) {
                        Se[l + 11 | 0] = I;
                        break i;
                      }
                      if (I >>> 0 >= 1073741808)
                        break r;
                      me = C + 8 | 0, I >>> 0 >= 2 ? (S = I + 4 & -4, y = S - 1 | 0, y = (y | 0) == 2 ? S : y) : y = 1, yh(me, y + 1 | 0), y = e[C + 8 >> 2], e[l >> 2] = y, e[l + 8 >> 2] = e[C + 12 >> 2] | -2147483648, e[l + 4 >> 2] = I, l = y;
                    }
                    du(l, Q, I + 1 | 0), bi = C + 16 | 0;
                    break t;
                  }
                  xf(), jn();
                }
              }
            }
            function ca(l) {
              var y = 0, I = 0;
              e: {
                y = e[l + 4 >> 2], y = e[e[y >> 2] - 12 >> 2] + y | 0;
                t: {
                  if (!e[y + 24 >> 2] | e[y + 16 >> 2] | !(Je[y + 5 | 0] & 32) || (Pn() | 0) > 0 || (y = e[l + 4 >> 2], y = e[(e[e[y >> 2] - 12 >> 2] + y | 0) + 24 >> 2], e[5996] = 0, y = no(169, y | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) != 1 && ((y | 0) != -1 || (l = e[l + 4 >> 2], y = e[e[l >> 2] - 12 >> 2], e[5996] = 0, Co(138, l + y | 0, 1), l = e[5996], e[5996] = 0, (l | 0) != 1))))
                    break t;
                  if (Zf(Ws(0) | 0) | 0, e[5996] = 0, jo(110), l = e[5996], e[5996] = 0, (l | 0) == 1)
                    break e;
                }
                return;
              }
              Ws(0) | 0, _c(), jn();
            }
            function ua(l, y, I, C) {
              var Q = 0, S = 0, me = 0, ke = 0;
              Q = bi - 16 | 0, bi = Q;
              e: {
                t: {
                  if ((l | 0) != (y | 0))
                    r: {
                      i: {
                        if (S = Je[l | 0], (S | 0) != 45 || (l = l + 1 | 0, (y | 0) != (l | 0)))
                          break i;
                        break r;
                      }
                      ke = e[5732], e[5732] = 0, fi(), l = K1(l, Q + 12 | 0, C), C = Ci, me = e[5732];
                      i: {
                        if (me) {
                          if (e[Q + 12 >> 2] != (y | 0))
                            break r;
                          if (!C & l >>> 0 > 65535 | C | (me | 0) == 68)
                            break i;
                          break t;
                        }
                        if (e[5732] = ke, e[Q + 12 >> 2] != (y | 0))
                          break r;
                        if (!C & l >>> 0 < 65536)
                          break t;
                      }
                      e[I >> 2] = 4, l = 65535;
                      break e;
                    }
                  e[I >> 2] = 4, l = 0;
                  break e;
                }
                l = (S | 0) == 45 ? 0 - l | 0 : l;
              }
              return bi = Q + 16 | 0, l & 65535;
            }
            function la(l, y) {
              var I = 0, C = 0, Q = 0, S = 0, me = 0, ke = 0;
              Q = bi - 16 | 0, bi = Q, C = Je[l + 11 | 0], I = C << 24 >> 24, I = (I | 0) < 0, C = I ? e[l + 4 >> 2] : C;
              e: {
                if (!C || (I = I ? e[l >> 2] : l, me = Je[I | 0], S = me - 9 & 255, S >>> 0 < 24 & (8388639 >>> S & 1)) || (S = Je[(I + C | 0) - 1 | 0] - 9 | 0, (S & 255) >>> 0 < 24 & (8388639 >>> S & 1)) || (me | 0) == 45 | (Jf(I) | 0) != (C | 0) || (e[Q + 12 >> 2] = 0, e[5732] = 0, l = Ep(Se[l + 11 | 0] < 0 ? e[l >> 2] : l, Q + 12 | 0, 10), I = Ci, y && (e[y >> 2] = l, e[y + 4 >> 2] = I), l = e[Q + 12 >> 2], !l | Je[l | 0]))
                  break e;
                ke = !e[5732];
              }
              return bi = Q + 16 | 0, ke;
            }
            function ma(l, y, I, C) {
              var Q = 0, S = 0, me = 0, ke = 0;
              Q = bi - 16 | 0, bi = Q;
              e: {
                if ((l | 0) != (y | 0))
                  t: {
                    r: {
                      if (S = Je[l | 0], (S | 0) != 45 || (l = l + 1 | 0, (y | 0) != (l | 0)))
                        break r;
                      break t;
                    }
                    ke = e[5732], e[5732] = 0, fi(), l = K1(l, Q + 12 | 0, C), C = Ci;
                    r: {
                      if (me = e[5732], me) {
                        if (e[Q + 12 >> 2] != (y | 0))
                          break t;
                        if ((me | 0) != 68)
                          break r;
                        e[I >> 2] = 4, l = -1, y = -1;
                        break e;
                      }
                      if (e[5732] = ke, e[Q + 12 >> 2] == (y | 0))
                        break r;
                      break t;
                    }
                    y = l, I = (S | 0) == 45, l = I ? 0 - y | 0 : y, y = I ? 0 - (C + ((y | 0) != 0) | 0) | 0 : C;
                    break e;
                  }
                e[I >> 2] = 4, l = 0, y = 0;
              }
              return bi = Q + 16 | 0, Ci = y, l;
            }
            function Ba(l, y, I) {
              l = l | 0, y = y | 0, I = I | 0;
              var C = 0, Q = 0;
              if (C = bi - 16 | 0, bi = C, e[l >> 2] = 7e3, e[l + 4 >> 2] = 0, e[l + 8 >> 2] = 0, e[C + 4 >> 2] = e[I >> 2], e[C + 8 >> 2] = e[I + 4 >> 2], e[C + 12 >> 2] = e[I + 8 >> 2], e[I + 8 >> 2] = 0, e[I >> 2] = 0, e[I + 4 >> 2] = 0, e[5996] = 0, mf(163, l + 12 | 0, y | 0, C + 4 | 0, 0) | 0, y = e[5996], e[5996] = 0, (y | 0) != 1) {
                if (Q = e[C + 4 >> 2], Q) {
                  if (y = e[C + 8 >> 2], (Q | 0) != (y | 0))
                    for (; I = y - 12 | 0, Se[y - 1 | 0] < 0 && Tr(e[I >> 2]), y = I, (I | 0) != (Q | 0); )
                      ;
                  Tr(Q);
                }
                return bi = C + 16 | 0, l | 0;
              }
              l = gi() | 0, hf(C + 4 | 0), ss(l | 0), jn();
            }
            function Ea(l, y) {
              var I = 0, C = 0, Q = 0, S = 0, me = 0;
              Q = bi - 16 | 0, bi = Q, C = Je[l + 11 | 0], I = C << 24 >> 24, I = (I | 0) < 0, C = I ? e[l + 4 >> 2] : C;
              e: {
                if (!C || (I = I ? e[l >> 2] : l, S = Je[I | 0] - 9 & 255, S >>> 0 < 24 & (8388639 >>> S & 1)) || (S = Je[(I + C | 0) - 1 | 0] - 9 | 0, (S & 255) >>> 0 < 24 & (8388639 >>> S & 1)) || (Jf(I) | 0) != (C | 0) || (e[Q + 12 >> 2] = 0, e[5732] = 0, l = mp(Se[l + 11 | 0] < 0 ? e[l >> 2] : l, Q + 12 | 0, 10), I = Ci, y && (e[y >> 2] = l, e[y + 4 >> 2] = I), l = e[Q + 12 >> 2], !l | Je[l | 0]))
                  break e;
                me = !e[5732];
              }
              return bi = Q + 16 | 0, me;
            }
            function _a(l, y) {
              var I = 0, C = 0;
              I = bi - 16 | 0, bi = I, e[I + 12 >> 2] = l, e[l + 4 >> 2] = e[l + 4 >> 2] + 1, e[5996] = 0, l = no(197, e[I + 12 >> 2]) | 0, C = e[5996], e[5996] = 0;
              e: {
                t: {
                  if ((C | 0) == 1 || (e[5996] = 0, ia(208, l | 0, 12416, 12442, y | 0), l = e[5996], e[5996] = 0, (l | 0) == 1))
                    break t;
                  l = e[I + 12 >> 2], C = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = C, (C | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), bi = I + 16 | 0;
                  break e;
                }
                C = gi() | 0, l = e[I + 12 >> 2], y = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = y, (y | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), ss(C | 0), jn();
              }
              return y;
            }
            function xa(l, y, I, C, Q, S) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0;
              var me = 0, ke = 0;
              if (me = bi - 16 | 0, bi = me, e[me + 12 >> 2] = y, y = e[C + 28 >> 2], e[me + 8 >> 2] = y, e[y + 4 >> 2] = e[y + 4 >> 2] + 1, e[5996] = 0, ke = no(170, e[me + 8 >> 2]) | 0, y = e[5996], e[5996] = 0, (y | 0) != 1)
                return y = e[me + 8 >> 2], C = e[y + 4 >> 2] - 1 | 0, e[y + 4 >> 2] = C, (C | 0) == -1 && Yn[e[e[y >> 2] + 8 >> 2]](y), Nd(l, S + 24 | 0, me + 12 | 0, I, Q, ke), bi = me + 16 | 0, e[me + 12 >> 2];
              I = gi() | 0, l = e[me + 8 >> 2], y = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = y, (y | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), ss(I | 0), jn();
            }
            function Ka(l, y, I, C, Q, S) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0;
              var me = 0, ke = 0;
              if (me = bi - 16 | 0, bi = me, e[me + 12 >> 2] = y, y = e[C + 28 >> 2], e[me + 8 >> 2] = y, e[y + 4 >> 2] = e[y + 4 >> 2] + 1, e[5996] = 0, ke = no(170, e[me + 8 >> 2]) | 0, y = e[5996], e[5996] = 0, (y | 0) != 1)
                return y = e[me + 8 >> 2], C = e[y + 4 >> 2] - 1 | 0, e[y + 4 >> 2] = C, (C | 0) == -1 && Yn[e[e[y >> 2] + 8 >> 2]](y), Pd(l, S + 16 | 0, me + 12 | 0, I, Q, ke), bi = me + 16 | 0, e[me + 12 >> 2];
              I = gi() | 0, l = e[me + 8 >> 2], y = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = y, (y | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), ss(I | 0), jn();
            }
            function nf(l, y, I, C, Q, S) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0;
              var me = 0, ke = 0;
              if (me = bi - 16 | 0, bi = me, e[me + 12 >> 2] = y, y = e[C + 28 >> 2], e[me + 8 >> 2] = y, e[y + 4 >> 2] = e[y + 4 >> 2] + 1, e[5996] = 0, ke = no(197, e[me + 8 >> 2]) | 0, y = e[5996], e[5996] = 0, (y | 0) != 1)
                return y = e[me + 8 >> 2], C = e[y + 4 >> 2] - 1 | 0, e[y + 4 >> 2] = C, (C | 0) == -1 && Yn[e[e[y >> 2] + 8 >> 2]](y), Od(l, S + 24 | 0, me + 12 | 0, I, Q, ke), bi = me + 16 | 0, e[me + 12 >> 2];
              I = gi() | 0, l = e[me + 8 >> 2], y = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = y, (y | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), ss(I | 0), jn();
            }
            function of(l, y, I, C, Q, S) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0;
              var me = 0, ke = 0;
              if (me = bi - 16 | 0, bi = me, e[me + 12 >> 2] = y, y = e[C + 28 >> 2], e[me + 8 >> 2] = y, e[y + 4 >> 2] = e[y + 4 >> 2] + 1, e[5996] = 0, ke = no(197, e[me + 8 >> 2]) | 0, y = e[5996], e[5996] = 0, (y | 0) != 1)
                return y = e[me + 8 >> 2], C = e[y + 4 >> 2] - 1 | 0, e[y + 4 >> 2] = C, (C | 0) == -1 && Yn[e[e[y >> 2] + 8 >> 2]](y), Md(l, S + 16 | 0, me + 12 | 0, I, Q, ke), bi = me + 16 | 0, e[me + 12 >> 2];
              I = gi() | 0, l = e[me + 8 >> 2], y = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = y, (y | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), ss(I | 0), jn();
            }
            function sf(l, y) {
              e: {
                if (l) {
                  if (y >>> 0 <= 127)
                    break e;
                  t: {
                    if (!e[e[6178] >> 2]) {
                      if ((y & -128) == 57216)
                        break e;
                      break t;
                    }
                    if (y >>> 0 <= 2047)
                      return Se[l + 1 | 0] = y & 63 | 128, Se[l | 0] = y >>> 6 | 192, 2;
                    if (!((y & -8192) != 57344 & y >>> 0 >= 55296))
                      return Se[l + 2 | 0] = y & 63 | 128, Se[l | 0] = y >>> 12 | 224, Se[l + 1 | 0] = y >>> 6 & 63 | 128, 3;
                    if (y - 65536 >>> 0 <= 1048575)
                      return Se[l + 3 | 0] = y & 63 | 128, Se[l | 0] = y >>> 18 | 240, Se[l + 2 | 0] = y >>> 6 & 63 | 128, Se[l + 1 | 0] = y >>> 12 & 63 | 128, 4;
                  }
                  e[5732] = 25, l = -1;
                } else
                  l = 1;
                return l;
              }
              return Se[l | 0] = y, 1;
            }
            function ef(l) {
              var y = 0, I = 0, C = 0, Q = 0, S = 0;
              e: {
                if (C = l - 24 | 0, l = C, l >>> 0 < 27344 & l >>> 0 >= 26832) {
                  for (y = l - 4 | 0, Q = e[6705], I = Q; ; ) {
                    if (l = I, !(!l | (l | 0) == 27344)) {
                      if (I = N2[l + 2 >> 1], (l + (I << 2) | 0) == (y | 0)) {
                        ea[l + 2 >> 1] = I + N2[C - 2 >> 1];
                        break e;
                      }
                      if ((l | 0) == ((N2[y + 2 >> 1] << 2) + y | 0)) {
                        if (I = C - 2 | 0, ea[I >> 1] = N2[l + 2 >> 1] + N2[I >> 1], !S) {
                          e[6705] = y, ea[y >> 1] = N2[l >> 1];
                          break e;
                        }
                        ea[S >> 1] = y - 26832 >>> 2;
                        break e;
                      } else {
                        I = (N2[l >> 1] << 2) + 26832 | 0, S = l;
                        continue;
                      }
                    }
                    break;
                  }
                  ea[y >> 1] = Q - 26832 >>> 2, e[6705] = y;
                  break e;
                }
                Tr(C);
              }
            }
            function gf(l, y, I, C, Q) {
              var S = 0, me = 0, ke = 0;
              ke = -1, me = C & 2147483647, S = (me | 0) == 2147418112;
              e: {
                if ((S & !I ? l | y : S & (I | 0) != 0 | me >>> 0 > 2147418112) || (S = Q & 2147483647, ((S | 0) == 2147418112 & 0 | S >>> 0 > 2147418112) & (S | 0) != 2147418112))
                  break e;
                if (!(l | I | (S | me | y)))
                  return 0;
                if (S = C & Q, (S | 0) > 0 | (S | 0) >= 0) {
                  if (((I | 0) != 0 | (C | 0) != (Q | 0)) & (C | 0) < (Q | 0))
                    break e;
                  return (l | I | (C ^ Q | y)) != 0;
                }
                if (!I & (C | 0) == (Q | 0) ? l | y : (I | 0) != 0 & (C | 0) >= (Q | 0) | (C | 0) > (Q | 0))
                  break e;
                ke = (l | I | (C ^ Q | y)) != 0;
              }
              return ke;
            }
            function yf(l, y, I, C, Q, S) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0;
              var me = 0;
              if (l = bi - 16 | 0, bi = l, e[l + 12 >> 2] = y, y = e[C + 28 >> 2], e[l + 8 >> 2] = y, e[y + 4 >> 2] = e[y + 4 >> 2] + 1, e[5996] = 0, me = no(170, e[l + 8 >> 2]) | 0, y = e[5996], e[5996] = 0, (y | 0) != 1)
                return y = e[l + 8 >> 2], C = e[y + 4 >> 2] - 1 | 0, e[y + 4 >> 2] = C, (C | 0) == -1 && Yn[e[e[y >> 2] + 8 >> 2]](y), jd(S + 20 | 0, l + 12 | 0, I, Q, me), bi = l + 16 | 0, e[l + 12 >> 2];
              I = gi() | 0, l = e[l + 8 >> 2], y = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = y, (y | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), ss(I | 0), jn();
            }
            function Df(l, y, I, C, Q, S) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0;
              var me = 0;
              if (l = bi - 16 | 0, bi = l, e[l + 12 >> 2] = y, y = e[C + 28 >> 2], e[l + 8 >> 2] = y, e[y + 4 >> 2] = e[y + 4 >> 2] + 1, e[5996] = 0, me = no(197, e[l + 8 >> 2]) | 0, y = e[5996], e[5996] = 0, (y | 0) != 1)
                return y = e[l + 8 >> 2], C = e[y + 4 >> 2] - 1 | 0, e[y + 4 >> 2] = C, (C | 0) == -1 && Yn[e[e[y >> 2] + 8 >> 2]](y), Kd(S + 20 | 0, l + 12 | 0, I, Q, me), bi = l + 16 | 0, e[l + 12 >> 2];
              I = gi() | 0, l = e[l + 8 >> 2], y = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = y, (y | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), ss(I | 0), jn();
            }
            function Bf(l, y, I) {
              var C = 0, Q = 0, S = 0, me = 0, ke = 0;
              Q = l, me = bi - 16 | 0, bi = me;
              e: {
                if (y >>> 0 < 1073741808) {
                  t: {
                    if (y >>> 0 < 2) {
                      Se[Q + 11 | 0] = y;
                      break t;
                    }
                    ke = me + 8 | 0, y >>> 0 >= 2 ? (S = y + 4 & -4, C = S - 1 | 0, C = (C | 0) == 2 ? S : C) : C = 1, yh(ke, C + 1 | 0), C = e[me + 8 >> 2], e[Q >> 2] = C, e[Q + 8 >> 2] = e[me + 12 >> 2] | -2147483648, e[Q + 4 >> 2] = y, Q = C;
                  }
                  for (S = bi - 16 | 0, bi = S, e[S + 12 >> 2] = I, I = Q, C = y; ; ) {
                    if (C) {
                      e[I >> 2] = e[S + 12 >> 2], C = C - 1 | 0, I = I + 4 | 0;
                      continue;
                    }
                    break;
                  }
                  bi = S + 16 | 0, e[(y << 2) + Q >> 2] = 0, bi = me + 16 | 0;
                  break e;
                }
                xf(), jn();
              }
              return l;
            }
            function Ja(l, y, I, C, Q, S, me, ke, Ar) {
              var br = 0, Qr = 0, Ur = 0, Xr = 0;
              Ar = Ua(y, I, ke, Ar), ke = Ci, Q = Ua(C, Q, S, me), Ar = Q + Ar | 0, C = Ci + ke | 0, ke = Q >>> 0 > Ar >>> 0 ? C + 1 | 0 : C, br = me, Q = 0, Qr = I, C = 0, I = Ua(me, Q, I, C), me = I + Ar | 0, Ar = Ci + ke | 0, Ur = me, I = I >>> 0 > me >>> 0 ? Ar + 1 | 0 : Ar, me = Ua(S, 0, y, 0), ke = Ci, Ar = 0, C = Ua(S, Ar, Qr, C), ke = ke + C | 0, S = Ci + Ar | 0, S = C >>> 0 > ke >>> 0 ? S + 1 | 0 : S, Ar = S + Ur | 0, C = I, S = S >>> 0 > Ar >>> 0 ? C + 1 | 0 : C, y = Ua(y, Xr, br, Q) + ke | 0, Q = Ci, Q = y >>> 0 < ke >>> 0 ? Q + 1 | 0 : Q, ke = Q + Ar | 0, Ar = S, e[l + 8 >> 2] = ke, e[l + 12 >> 2] = Q >>> 0 > ke >>> 0 ? Ar + 1 | 0 : Ar, e[l >> 2] = me, e[l + 4 >> 2] = y;
            }
            function Vf(l, y, I, C) {
              var Q = 0, S = 0, me = 0, ke = 0;
              Q = bi - 16 | 0, bi = Q;
              e: {
                t: {
                  if ((l | 0) != (y | 0))
                    r: {
                      i: {
                        if (S = Je[l | 0], (S | 0) != 45 || (l = l + 1 | 0, (y | 0) != (l | 0)))
                          break i;
                        break r;
                      }
                      ke = e[5732], e[5732] = 0, fi(), l = K1(l, Q + 12 | 0, C), C = Ci, me = e[5732];
                      i: {
                        if (me) {
                          if (e[Q + 12 >> 2] != (y | 0))
                            break r;
                          if ((me | 0) == 68 | C)
                            break i;
                          break t;
                        }
                        if (e[5732] = ke, e[Q + 12 >> 2] != (y | 0))
                          break r;
                        if (!C)
                          break t;
                      }
                      e[I >> 2] = 4, l = -1;
                      break e;
                    }
                  e[I >> 2] = 4, l = 0;
                  break e;
                }
                l = (S | 0) == 45 ? 0 - l | 0 : l;
              }
              return bi = Q + 16 | 0, l;
            }
            function Ff(l, y) {
              l = l | 0, y = y | 0;
              var I = 0, C = 0;
              e: {
                if (C = Je[l + 11 | 0], I = C & 127, C = (C & 128) >>> 7 | 0, I = C ? e[l + 4 >> 2] : I, I >>> 0 < y >>> 0) {
                  if (y = y - I | 0, y) {
                    C = C ? (e[l + 8 >> 2] & 2147483647) - 1 | 0 : 10, I = Je[l + 11 | 0], I = (I & 128) >>> 7 | 0 ? e[l + 4 >> 2] : I & 127, C - I >>> 0 < y >>> 0 && Qs(l, C, I + (y - C | 0) | 0, I, I), C = (Je[l + 11 | 0] & 128) >>> 7 | 0 ? e[l >> 2] : l, Td(C + I | 0, y, 0), y = y + I | 0;
                    t: {
                      if ((Je[l + 11 | 0] & 128) >>> 7 | 0) {
                        e[l + 4 >> 2] = y;
                        break t;
                      }
                      Se[l + 11 | 0] = y;
                    }
                    Se[y + C | 0] = 0;
                  }
                  break e;
                }
                t1(l, (Je[l + 11 | 0] & 128) >>> 7 | 0 ? e[l >> 2] : l, y);
              }
            }
            function Qa(l, y, I) {
              var C = 0, Q = 0, S = 0;
              Q = bi - 16 | 0, bi = Q, e[y + 4 >> 2] = e[y + 4 >> 2] + 1, S = l + 8 | 0, C = Q + 12 | 0, e[C >> 2] = y;
              e: {
                if (y = e[l + 12 >> 2], l = e[l + 8 >> 2], y - l >> 2 >>> 0 <= I >>> 0) {
                  if (e[5996] = 0, Co(274, S | 0, I + 1 | 0), l = e[5996], e[5996] = 0, (l | 0) == 1)
                    break e;
                  l = e[S >> 2];
                }
                l = (I << 2) + l | 0, y = e[l >> 2], y && (l = e[y + 4 >> 2] - 1 | 0, e[y + 4 >> 2] = l, (l | 0) == -1 && Yn[e[e[y >> 2] + 8 >> 2]](y), l = e[S >> 2] + (I << 2) | 0), y = e[C >> 2], e[C >> 2] = 0, e[l >> 2] = y, qd(C), bi = Q + 16 | 0;
                return;
              }
              l = gi() | 0, qd(C), ss(l | 0), jn();
            }
            function ic(l, y, I) {
              l = l | 0, y = y | 0, I = I | 0;
              var C = 0, Q = 0, S = 0;
              C = bi - 16 | 0, bi = C;
              e: {
                t: {
                  r: {
                    if ((y | 0) != (I | 0) && (I = I - y | 0, (I | 0) < 18))
                      break r;
                    Se[l + 12 | 0] = 0, Se[l | 0] = 0;
                    break t;
                  }
                  if (I >>> 0 >= 2147483632)
                    break e;
                  r: {
                    if (I >>> 0 <= 10) {
                      Se[C + 15 | 0] = I, Q = C + 4 | 0;
                      break r;
                    }
                    S = (I | 15) + 1 | 0, Q = ga(S), e[C + 12 >> 2] = S | -2147483648, e[C + 4 >> 2] = Q, e[C + 8 >> 2] = I;
                  }
                  Se[Sa(Q, y, I) + I | 0] = 0, e[l + 8 >> 2] = e[C + 12 >> 2], y = e[C + 8 >> 2], e[l >> 2] = e[C + 4 >> 2], e[l + 4 >> 2] = y, Se[l + 12 | 0] = 1;
                }
                bi = C + 16 | 0;
                return;
              }
              xf(), jn();
            }
            function nc(l, y, I) {
              l = l | 0, y = y | 0, I = I | 0;
              var C = 0, Q = 0, S = 0;
              Q = bi - 16 | 0, bi = Q;
              e: {
                if (S = e[y >> 2], S) {
                  if (C = Je[I + 11 | 0], ((C & 128) >>> 7 | 0 ? e[I + 4 >> 2] : C & 127) && (Ip(I, 5570), S = e[y >> 2]), C = Q + 4 | 0, y = e[y + 4 >> 2], Yn[e[e[y >> 2] + 24 >> 2]](C, y, S), e[5996] = 0, wn(290, I | 0, C | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                    break e;
                  Yo(C);
                }
                y = e[I + 4 >> 2], e[l >> 2] = e[I >> 2], e[l + 4 >> 2] = y, e[l + 8 >> 2] = e[I + 8 >> 2], e[I >> 2] = 0, e[I + 4 >> 2] = 0, e[I + 8 >> 2] = 0, bi = Q + 16 | 0;
                return;
              }
              l = gi() | 0, Yo(Q + 4 | 0), ss(l | 0), jn();
            }
            function ff(l) {
              var y = 0, I = 0, C = 0;
              if (y = e[l + 40 >> 2], y && (e[l + 44 >> 2] = y, Tr(y)), I = e[l + 28 >> 2], I) {
                if (C = I, y = e[l + 32 >> 2], (I | 0) != (y | 0)) {
                  for (; C = y - 12 | 0, Se[y - 1 | 0] < 0 && Tr(e[C >> 2]), y = C, (I | 0) != (y | 0); )
                    ;
                  C = e[l + 28 >> 2];
                }
                e[l + 32 >> 2] = I, Tr(C);
              }
              if (y = e[l + 16 >> 2], y && (e[l + 20 >> 2] = y, Tr(y)), I = e[l + 4 >> 2], I) {
                if (y = I, C = e[l + 8 >> 2], (y | 0) != (C | 0)) {
                  for (; C = ff(C - 56 | 0), (I | 0) != (C | 0); )
                    ;
                  y = e[l + 4 >> 2];
                }
                e[l + 8 >> 2] = I, Tr(y);
              }
              return l;
            }
            function bf(l, y, I, C) {
              var Q = 0, S = 0, me = 0;
              e: {
                if (Q = Je[l + 11 | 0], !((Q & 128) >>> 7 | 0 ? e[l + 4 >> 2] : Q & 127) | (I - y | 0) < 5)
                  break e;
                Xl(y, I), Q = I - 4 | 0, I = (Je[l + 11 | 0] & 128) >>> 7 | 0 ? e[l >> 2] : l, S = e[l + 4 >> 2], l = Je[l + 11 | 0], me = I + ((l & 128) >>> 7 | 0 ? S : l & 127) | 0;
                t: {
                  for (; ; ) {
                    r: {
                      if (l = Se[I | 0], S = l - 127 | 0, y >>> 0 >= Q >>> 0)
                        break r;
                      if ((l | 0) != e[y >> 2] & (S & 255) >>> 0 >= 130)
                        break t;
                      y = y + 4 | 0, I = ((me - I | 0) > 1) + I | 0;
                      continue;
                    }
                    break;
                  }
                  if ((S & 255) >>> 0 < 130 | l >>> 0 > e[Q >> 2] - 1 >>> 0)
                    break e;
                }
                e[C >> 2] = 4;
              }
            }
            function qc(l) {
              var y = 0, I = 0, C = 0, Q = 0, S = 0, me = 0, ke = 0;
              if (C = e[l >> 2], C) {
                if (y = C, I = e[l + 4 >> 2], (y | 0) != (I | 0)) {
                  for (; ; ) {
                    if (S = I - 12 | 0, Q = e[S >> 2], Q) {
                      if (y = Q, me = I - 8 | 0, I = e[me >> 2], (y | 0) != (I | 0)) {
                        for (; ; ) {
                          I = I - 32 | 0, y = e[I + 4 >> 2];
                          e: {
                            if (!y || (ke = e[y + 4 >> 2], e[y + 4 >> 2] = ke - 1, ke))
                              break e;
                            Yn[e[e[y >> 2] + 8 >> 2]](y), Ls(y);
                          }
                          if ((I | 0) == (Q | 0))
                            break;
                        }
                        y = e[S >> 2];
                      }
                      e[me >> 2] = Q, Tr(y);
                    }
                    if (I = S, (C | 0) == (I | 0))
                      break;
                  }
                  y = e[l >> 2];
                }
                e[l + 4 >> 2] = C, Tr(y);
              }
            }
            function iu(l, y, I) {
              var C = 0, Q = 0, S = 0, me = 0, ke = 0, Ar = 0;
              C = l, me = bi - 16 | 0, bi = me;
              e: {
                if (S = I - y | 0, S >>> 0 < 2147483632) {
                  t: {
                    if (S >>> 0 < 11) {
                      Se[C + 11 | 0] = S;
                      break t;
                    }
                    Ar = me + 8 | 0, S >>> 0 >= 11 ? (ke = S + 16 & -16, Q = ke - 1 | 0, Q = (Q | 0) == 11 ? ke : Q) : Q = 10, gh(Ar, Q + 1 | 0), Q = e[me + 8 >> 2], e[C >> 2] = Q, e[C + 8 >> 2] = e[me + 12 >> 2] | -2147483648, e[C + 4 >> 2] = S, C = Q;
                  }
                  for (; ; ) {
                    if ((y | 0) != (I | 0)) {
                      Se[C | 0] = Je[y | 0], C = C + 1 | 0, y = y + 1 | 0;
                      continue;
                    }
                    break;
                  }
                  Se[C | 0] = 0, bi = me + 16 | 0;
                  break e;
                }
                xf(), jn();
              }
              return l;
            }
            function Ou(l, y, I) {
              var C = 0, Q = 0, S = 0, me = 0, ke = 0, Ar = 0;
              C = l, me = bi - 16 | 0, bi = me;
              e: {
                if (S = I - y >> 2, S >>> 0 < 1073741808) {
                  t: {
                    if (S >>> 0 < 2) {
                      Se[C + 11 | 0] = S;
                      break t;
                    }
                    Ar = me + 8 | 0, S >>> 0 >= 2 ? (ke = S + 4 & -4, Q = ke - 1 | 0, Q = (Q | 0) == 2 ? ke : Q) : Q = 1, yh(Ar, Q + 1 | 0), Q = e[me + 8 >> 2], e[C >> 2] = Q, e[C + 8 >> 2] = e[me + 12 >> 2] | -2147483648, e[C + 4 >> 2] = S, C = Q;
                  }
                  for (; ; ) {
                    if ((y | 0) != (I | 0)) {
                      e[C >> 2] = e[y >> 2], C = C + 4 | 0, y = y + 4 | 0;
                      continue;
                    }
                    break;
                  }
                  e[C >> 2] = 0, bi = me + 16 | 0;
                  break e;
                }
                xf(), jn();
              }
              return l;
            }
            function fh(l, y) {
              l = l | 0, y = y | 0;
              var I = 0, C = 0;
              y = !e[l + 24 >> 2] | (e[l + 16 >> 2] | y), e[l + 16 >> 2] = y, y & e[l + 20 >> 2] && (l = bi - 16 | 0, bi = l, I = ro(16), l = l + 8 | 0, y = bi - 16 | 0, bi = y, Je[24716] || (Se[24716] = 1), e[y + 12 >> 2] = 22908, e[y + 8 >> 2] = 1, C = e[y + 12 >> 2], e[l >> 2] = e[y + 8 >> 2], e[l + 4 >> 2] = C, bi = y + 16 | 0, y = e[l + 4 >> 2], l = e[l >> 2], e[5996] = 0, l = mo(176, I | 0, 1821, l | 0, y | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) != 1 && (E2(l | 0, 8576, 177), jn()), l = gi() | 0, ef(I), ss(l | 0), jn());
            }
            function Wp(l, y, I) {
              l = l | 0, y = y | 0, I = I | 0;
              var C = 0, Q = 0, S = 0, me = 0, ke = 0;
              for (Q = bi - 16 | 0, bi = Q; ; ) {
                e: {
                  if ((I | 0) <= (S | 0))
                    break e;
                  if (C = e[l + 24 >> 2], me = e[l + 28 >> 2], C >>> 0 >= me >>> 0) {
                    if ((Yn[e[e[l >> 2] + 52 >> 2]](l, Je[y | 0]) | 0) == -1)
                      break e;
                    S = S + 1 | 0, y = y + 1 | 0;
                  } else
                    e[Q + 12 >> 2] = me - C, e[Q + 8 >> 2] = I - S, ke = C, C = Q + 8 | 0, me = Q + 12 | 0, C = e[(e[C >> 2] < e[me >> 2] ? C : me) >> 2], Gc(ke, y, C), e[l + 24 >> 2] = C + e[l + 24 >> 2], S = C + S | 0, y = y + C | 0;
                  continue;
                }
                break;
              }
              return bi = Q + 16 | 0, S | 0;
            }
            function u1(l, y, I) {
              var C = 0, Q = 0, S = 0, me = 0;
              return me = I & 63, S = me, Q = S & 31, S >>> 0 >= 32 ? S = -1 >>> Q | 0 : (C = -1 >>> Q | 0, S = C | (1 << Q) - 1 << 32 - Q), S = S & l, C = y & C, Q = me & 31, me >>> 0 >= 32 ? (C = S << Q, me = 0) : (C = (1 << Q) - 1 & S >>> 32 - Q | C << Q, me = S << Q), S = C, Q = 0 - I & 63, C = Q & 31, Q >>> 0 >= 32 ? (C = -1 << C, I = 0) : (I = -1 << C, C = I | (1 << C) - 1 & -1 >>> 32 - C), l = I & l, y = y & C, C = Q & 31, Q >>> 0 >= 32 ? (I = 0, l = y >>> C | 0) : (I = y >>> C | 0, l = ((1 << C) - 1 & y) << 32 - C | l >>> C), l = l | me, Ci = I | S, l;
            }
            function Of(l, y, I) {
              var C = 0, Q = 0, S = 0;
              if (!(Je[l | 0] & 32))
                e: {
                  C = y, y = l, l = e[y + 16 >> 2];
                  t: {
                    if (!l) {
                      if (yd(y))
                        break t;
                      l = e[y + 16 >> 2];
                    }
                    if (S = e[y + 20 >> 2], l - S >>> 0 < I >>> 0) {
                      Yn[e[y + 36 >> 2]](y, C, I) | 0;
                      break e;
                    }
                    r: {
                      if (e[y + 80 >> 2] < 0)
                        break r;
                      for (l = I; ; ) {
                        if (Q = l, !l)
                          break r;
                        if (l = l - 1 | 0, Je[C + l | 0] == 10)
                          break;
                      }
                      if (Yn[e[y + 36 >> 2]](y, C, Q) >>> 0 < Q >>> 0)
                        break t;
                      C = C + Q | 0, I = I - Q | 0, S = e[y + 20 >> 2];
                    }
                    Sa(S, C, I), e[y + 20 >> 2] = e[y + 20 >> 2] + I;
                  }
                }
            }
            function Jp(l, y) {
              l = l | 0, y = y | 0;
              var I = 0, C = 0, Q = 0, S = 0, me = 0;
              Q = e[l + 44 >> 2], I = e[l + 24 >> 2], Q >>> 0 < I >>> 0 && (e[l + 44 >> 2] = I, Q = I), I = e[l + 12 >> 2], S = e[l + 8 >> 2], C = -1;
              e: {
                if (I >>> 0 <= S >>> 0)
                  break e;
                if ((y | 0) == -1)
                  return e[l + 16 >> 2] = Q, e[l + 12 >> 2] = I - 1, e[l + 8 >> 2] = S, ((y | 0) != -1 ? y : 0) | 0;
                if (me = y << 24 >> 24, !(e[l + 48 >> 2] & 16) && (C = -1, (me | 0) != Se[I - 1 | 0]))
                  break e;
                e[l + 16 >> 2] = Q, e[l + 12 >> 2] = I - 1, e[l + 8 >> 2] = S, Se[e[l + 12 >> 2]] = me, C = y;
              }
              return C | 0;
            }
            function zp(l, y, I) {
              l = l | 0, y = y | 0, I = +I;
              var C = 0, Q = 0, S = 0;
              for (S = bi - 16 | 0, bi = S, C = Je[y + 11 | 0], C = (C & 128) >>> 7 | 0 ? e[y + 4 >> 2] : C & 127; ; ) {
                e: {
                  Q = (Je[y + 11 | 0] & 128) >>> 7 | 0 ? e[y >> 2] : y, zo[S >> 3] = I, Q = r1(Q, C + 1 | 0, 2314, S);
                  t: {
                    if ((Q | 0) >= 0) {
                      if (C >>> 0 >= Q >>> 0)
                        break e;
                      C = Q;
                      break t;
                    }
                    C = C << 1 | 1;
                  }
                  Ff(y, C);
                  continue;
                }
                break;
              }
              Ff(y, Q), C = e[y + 4 >> 2], e[l >> 2] = e[y >> 2], e[l + 4 >> 2] = C, e[l + 8 >> 2] = e[y + 8 >> 2], e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, bi = S + 16 | 0;
            }
            function z1(l, y, I) {
              var C = 0, Q = 0, S = Oa(0), me = 0, ke = Oa(0);
              Q = bi - 16 | 0, bi = Q;
              e: {
                t: {
                  r: {
                    if ((l | 0) != (y | 0)) {
                      if (me = e[5732], e[5732] = 0, fi(), C = bi - 16 | 0, bi = C, d1(C, l, Q + 12 | 0, 0), S = Lh(e[C >> 2], e[C + 4 >> 2], e[C + 8 >> 2], e[C + 12 >> 2]), bi = C + 16 | 0, l = e[5732], !l)
                        break r;
                      if (e[Q + 12 >> 2] != (y | 0))
                        break t;
                      if (ke = S, (l | 0) != 68)
                        break e;
                      break t;
                    }
                    e[I >> 2] = 4;
                    break e;
                  }
                  if (e[5732] = me, e[Q + 12 >> 2] == (y | 0))
                    break e;
                }
                e[I >> 2] = 4, S = ke;
              }
              return bi = Q + 16 | 0, S;
            }
            function X1(l, y, I) {
              var C = 0, Q = 0, S = 0, me = 0, ke = 0;
              Q = bi - 16 | 0, bi = Q;
              e: {
                t: {
                  r: {
                    if ((l | 0) != (y | 0)) {
                      if (me = e[5732], e[5732] = 0, fi(), C = bi - 16 | 0, bi = C, d1(C, l, Q + 12 | 0, 1), S = th(e[C >> 2], e[C + 4 >> 2], e[C + 8 >> 2], e[C + 12 >> 2]), bi = C + 16 | 0, l = e[5732], !l)
                        break r;
                      if (e[Q + 12 >> 2] != (y | 0))
                        break t;
                      if (ke = S, (l | 0) != 68)
                        break e;
                      break t;
                    }
                    e[I >> 2] = 4;
                    break e;
                  }
                  if (e[5732] = me, e[Q + 12 >> 2] == (y | 0))
                    break e;
                }
                e[I >> 2] = 4, S = ke;
              }
              return bi = Q + 16 | 0, S;
            }
            function Xp(l, y, I) {
              l = l | 0, y = y | 0, I = I | 0;
              var C = 0, Q = 0, S = 0;
              Q = (Je[l + 11 | 0] & 128) >>> 7 | 0 ? (e[l + 8 >> 2] & 2147483647) - 1 | 0 : 1, S = Je[l + 11 | 0], C = S, C = (C & 128) >>> 7 | 0 ? e[l + 4 >> 2] : C & 127;
              e: {
                if (Q - C >>> 0 >= I >>> 0) {
                  if (!I)
                    break e;
                  Q = (S & 128) >>> 7 | 0 ? e[l >> 2] : l, du(Q + (C << 2) | 0, y, I), y = I + C | 0;
                  t: {
                    if ((Je[l + 11 | 0] & 128) >>> 7 | 0) {
                      e[l + 4 >> 2] = y;
                      break t;
                    }
                    Se[l + 11 | 0] = y;
                  }
                  return e[Q + (y << 2) >> 2] = 0, l | 0;
                }
                Vo(l, Q, C + (I - Q | 0) | 0, C, C, 0, I, y);
              }
              return l | 0;
            }
            function Zp(l, y, I, C, Q) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0;
              for (var S = 0, me = 0, ke = 0, Ar = 0, br = 0, Qr = 0; ; ) {
                e: {
                  if ((I | 0) == (C | 0) | Q >>> 0 <= Ar >>> 0)
                    break e;
                  me = 1, ke = bi - 16 | 0, bi = ke, S = Nc(ke + 12 | 0, e[l + 8 >> 2]), br = fo(0, I, C - I | 0, y || 24840), S = e[S >> 2], S && (e[6178] = (S | 0) == -1 ? 24816 : S), bi = ke + 16 | 0;
                  t:
                    switch (br + 2 | 0) {
                      default:
                        me = br;
                        break;
                      case 0:
                      case 1:
                        break e;
                      case 2:
                        break t;
                    }
                  Ar = Ar + 1 | 0, Qr = me + Qr | 0, I = I + me | 0;
                  continue;
                }
                break;
              }
              return Qr | 0;
            }
            function Gl(l, y, I) {
              var C = 0, Q = 0;
              for (I & 2048 && (Se[l | 0] = 43, l = l + 1 | 0), I & 1024 && (Se[l | 0] = 35, l = l + 1 | 0), C = I & 260, (C | 0) != 260 && (Se[l | 0] = 46, Se[l + 1 | 0] = 42, l = l + 2 | 0), I = I & 16384; ; ) {
                if (Q = Je[y | 0], Q) {
                  Se[l | 0] = Q, l = l + 1 | 0, y = y + 1 | 0;
                  continue;
                }
                break;
              }
              e: {
                t: {
                  if ((C | 0) != 256) {
                    if ((C | 0) != 4)
                      break t;
                    y = I ? 70 : 102;
                    break e;
                  }
                  y = I ? 69 : 101;
                  break e;
                }
                if (y = I ? 65 : 97, (C | 0) == 260)
                  break e;
                y = I ? 71 : 103;
              }
              return Se[l | 0] = y, (C | 0) != 260;
            }
            function A1(l, y, I) {
              l = l | 0, y = y | 0, I = I | 0;
              var C = 0, Q = 0, S = 0;
              Q = (Je[l + 11 | 0] & 128) >>> 7 | 0 ? (e[l + 8 >> 2] & 2147483647) - 1 | 0 : 10, S = Je[l + 11 | 0], C = S, C = (C & 128) >>> 7 | 0 ? e[l + 4 >> 2] : C & 127;
              e: {
                if (Q - C >>> 0 >= I >>> 0) {
                  if (!I)
                    break e;
                  Q = (S & 128) >>> 7 | 0 ? e[l >> 2] : l, Gc(Q + C | 0, y, I), y = I + C | 0;
                  t: {
                    if ((Je[l + 11 | 0] & 128) >>> 7 | 0) {
                      e[l + 4 >> 2] = y;
                      break t;
                    }
                    Se[l + 11 | 0] = y;
                  }
                  return Se[y + Q | 0] = 0, l | 0;
                }
                ms(l, Q, C + (I - Q | 0) | 0, C, C, 0, I, y);
              }
              return l | 0;
            }
            function eg(l, y, I, C, Q) {
              if (l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, hc(l, e[y + 8 >> 2], Q)) {
                e[y + 28 >> 2] == 1 | e[y + 4 >> 2] != (I | 0) || (e[y + 28 >> 2] = C);
                return;
              }
              e: {
                if (!hc(l, e[y >> 2], Q))
                  break e;
                if (!(e[y + 16 >> 2] != (I | 0) & e[y + 20 >> 2] != (I | 0))) {
                  if ((C | 0) != 1)
                    break e;
                  e[y + 32 >> 2] = 1;
                  return;
                }
                e[y + 20 >> 2] = I, e[y + 32 >> 2] = C, e[y + 40 >> 2] = e[y + 40 >> 2] + 1, e[y + 36 >> 2] != 1 | e[y + 24 >> 2] != 2 || (Se[y + 54 | 0] = 1), e[y + 44 >> 2] = 4;
              }
            }
            function Z1(l, y, I) {
              l = l | 0, y = y | 0, I = I | 0;
              var C = 0, Q = 0, S = 0, me = 0, ke = 0, Ar = 0;
              if (Q = bi - 16 | 0, bi = Q, Ar = e[y >> 2], C = e[I >> 2], me = e[l >> 2], S = C - me | 0, S = S >>> 0 >= 2147483647 ? -1 : (C | 0) == (me | 0) ? 4 : S << 1, C = e[l + 4 >> 2] == 220, ke = Xc(C ? 0 : me, S), ke) {
                C || (e[l >> 2] = 0), e[Q + 4 >> 2] = 184, C = Q + 8 | 0, e[C >> 2] = ke, e[C + 4 >> 2] = e[Q + 4 >> 2], l = rp(l, C), ka(C), e[y >> 2] = e[l >> 2] + (Ar - me | 0), e[I >> 2] = e[l >> 2] + (S & -4), bi = Q + 16 | 0;
                return;
              }
              R1(), jn();
            }
            function tg(l, y) {
              l = l | 0, y = +y;
              var I = 0, C = 0, Q = 0;
              if (C = bi - 16 | 0, bi = C, I = C + 4 | 0, e[I >> 2] = 0, e[I + 4 >> 2] = 0, e[I + 8 >> 2] = 0, Q = (Je[I + 11 | 0] & 128) >>> 7 | 0 ? (e[I + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, Co(172, I | 0, Q | 0), Q = e[5996], e[5996] = 0, (Q | 0) == 1 && (l = gi() | 0, Yo(I), ss(l | 0), jn()), e[5996] = 0, Us(120, l | 0, I | 0, +y), l = e[5996], e[5996] = 0, (l | 0) != 1) {
                Yo(I), bi = C + 16 | 0;
                return;
              }
              l = gi() | 0, Yo(C + 4 | 0), ss(l | 0), jn();
            }
            function $l(l, y) {
              var I = 0, C = 0, Q = 0, S = 0, me = 0, ke = 0;
              I = Je[l + 11 | 0], C = I << 24 >> 24, S = e[y + 4 >> 2], C = (C | 0) < 0, I = C ? e[l + 4 >> 2] : I;
              e: {
                if (S >>> 0 < I + 2 >>> 0 || (Q = e[y >> 2], me = I + Q | 0, Je[me | 0] != 40 | Je[(Q + S | 0) - 1 | 0] != 41))
                  break e;
                if (I)
                  for (l = C ? e[l >> 2] : l, C = I + l | 0; ; ) {
                    if (Je[l | 0] != Je[Q | 0])
                      return 0;
                    if (Q = Q + 1 | 0, l = l + 1 | 0, (C | 0) == (l | 0))
                      break;
                  }
                e[y + 4 >> 2] = (S - I | 0) - 2, ke = 1, e[y >> 2] = me + 1;
              }
              return ke;
            }
            function ed(l, y, I, C) {
              var Q = 0, S = 0, me = 0;
              Q = bi - 16 | 0, bi = Q;
              e: {
                if ((l | 0) != (y | 0)) {
                  me = e[5732], e[5732] = 0, fi(), l = Sp(l, Q + 12 | 0, C), C = Ci, S = e[5732];
                  t: {
                    if (S) {
                      if (e[Q + 12 >> 2] != (y | 0))
                        break t;
                      if ((S | 0) != 68)
                        break e;
                      e[I >> 2] = 4, y = !!l & (C | 0) >= 0 | (C | 0) > 0, l = y ? -1 : 0, C = y ? 2147483647 : -2147483648;
                      break e;
                    }
                    if (e[5732] = me, e[Q + 12 >> 2] == (y | 0))
                      break e;
                  }
                }
                e[I >> 2] = 4, l = 0, C = 0;
              }
              return bi = Q + 16 | 0, Ci = C, l;
            }
            function rg(l, y, I) {
              l = l | 0, y = y | 0, I = I | 0;
              var C = 0, Q = 0, S = 0, me = 0, ke = 0;
              return Q = e[l + 84 >> 2], S = e[Q >> 2], C = e[Q + 4 >> 2], ke = e[l + 28 >> 2], me = e[l + 20 >> 2] - ke | 0, me = C >>> 0 < me >>> 0 ? C : me, me && (Sa(S, ke, me), S = me + e[Q >> 2] | 0, e[Q >> 2] = S, C = e[Q + 4 >> 2] - me | 0, e[Q + 4 >> 2] = C), C = I >>> 0 > C >>> 0 ? C : I, C && (Sa(S, y, C), S = C + e[Q >> 2] | 0, e[Q >> 2] = S, e[Q + 4 >> 2] = e[Q + 4 >> 2] - C), Se[S | 0] = 0, y = e[l + 44 >> 2], e[l + 28 >> 2] = y, e[l + 20 >> 2] = y, I | 0;
            }
            function ig(l, y, I) {
              l = l | 0, y = y | 0, I = I | 0;
              var C = 0, Q = 0, S = 0, me = 0, ke = 0, Ar = 0;
              if (Q = bi - 16 | 0, bi = Q, Ar = e[y >> 2], me = e[l >> 2], C = e[I >> 2] - me | 0, S = C << 1, S = C >>> 0 >= 2147483647 ? -1 : S >>> 0 <= 1 ? 1 : S, C = e[l + 4 >> 2] == 220, ke = Xc(C ? 0 : me, S), ke) {
                C || (e[l >> 2] = 0), e[Q + 4 >> 2] = 184, C = Q + 8 | 0, e[C >> 2] = ke, e[C + 4 >> 2] = e[Q + 4 >> 2], l = rp(l, C), ka(C), e[y >> 2] = e[l >> 2] + (Ar - me | 0), e[I >> 2] = S + e[l >> 2], bi = Q + 16 | 0;
                return;
              }
              R1(), jn();
            }
            function h1(l, y, I, C) {
              Se[l + 53 | 0] = 1;
              e: {
                if (e[l + 4 >> 2] != (I | 0))
                  break e;
                Se[l + 52 | 0] = 1, I = e[l + 16 >> 2];
                t: {
                  if (!I) {
                    if (e[l + 36 >> 2] = 1, e[l + 24 >> 2] = C, e[l + 16 >> 2] = y, (C | 0) != 1)
                      break e;
                    if (e[l + 48 >> 2] == 1)
                      break t;
                    break e;
                  }
                  if ((y | 0) == (I | 0)) {
                    if (I = e[l + 24 >> 2], (I | 0) == 2 && (e[l + 24 >> 2] = C, I = C), e[l + 48 >> 2] != 1)
                      break e;
                    if ((I | 0) == 1)
                      break t;
                    break e;
                  }
                  e[l + 36 >> 2] = e[l + 36 >> 2] + 1;
                }
                Se[l + 54 | 0] = 1;
              }
            }
            function ng(l, y, I) {
              l = l | 0, y = y | 0, I = I | 0;
              var C = 0, Q = 0;
              C = bi + -64 | 0, bi = C, Q = 1;
              e: {
                if (hc(l, y, 0) || (Q = 0, !y) || (y = Jr(y, 22104), Q = 0, !y))
                  break e;
                jr(C + 12 | 0, 0, 52), e[C + 56 >> 2] = 1, e[C + 20 >> 2] = -1, e[C + 16 >> 2] = l, e[C + 8 >> 2] = y, Yn[e[e[y >> 2] + 28 >> 2]](y, C + 8 | 0, e[I >> 2], 1), l = e[C + 32 >> 2], (l | 0) == 1 && (e[I >> 2] = e[C + 24 >> 2]), Q = (l | 0) == 1;
              }
              return l = Q, bi = C - -64 | 0, l | 0;
            }
            function og(l) {
              return Je[25132] ? e[6282] : (Je[25640] || (Se[25640] = 1), ja(25472, 18340), ja(25484, 18368), ja(25496, 18396), ja(25508, 18428), ja(25520, 18468), ja(25532, 18504), ja(25544, 18532), ja(25556, 18568), ja(25568, 18584), ja(25580, 18600), ja(25592, 18616), ja(25604, 18632), ja(25616, 18648), ja(25628, 18664), Se[25132] = 1, e[6282] = 25472, 25472);
            }
            function sg(l) {
              l = l | 0;
              var y = 0, I = 0;
              y = e[l + 80 >> 2];
              e: {
                if (!y | qs[l + 84 >> 2] > 3600 || Mr(3557, 1) & (y ^ -1) || (y = e[l + 80 >> 2], !y | qs[l + 84 >> 2] > 3600 | (e[l + 52 >> 2] + e[l + 44 >> 2] >>> 0 > 201 | qs[l + 68 >> 2] > 100)) || Mr(2049, 1) & (y ^ -1) || (y = e[l + 80 >> 2], Mr(2165, 1) & (y ^ -1) | Je[l + 88 | 0]))
                  break e;
                l = e[l + 80 >> 2], I = !(Mr(1681, 1) & (l ^ -1));
              }
              return I | 0;
            }
            function Yl(l, y, I) {
              l = l | 0, y = y | 0, I = I | 0;
              var C = 0, Q = 0, S = 0, me = 0;
              Q = bi - 16 | 0, bi = Q;
              e: {
                t: {
                  if (I >>> 0 < 11) {
                    Se[l + 11 | 0] = I;
                    break t;
                  }
                  if (I >>> 0 >= 2147483632)
                    break e;
                  me = Q + 8 | 0, I >>> 0 >= 11 ? (S = I + 16 & -16, C = S - 1 | 0, C = (C | 0) == 11 ? S : C) : C = 10, gh(me, C + 1 | 0), C = e[Q + 8 >> 2], e[l >> 2] = C, e[l + 8 >> 2] = e[Q + 12 >> 2] | -2147483648, e[l + 4 >> 2] = I, l = C;
                }
                Gc(l, y, I + 1 | 0), bi = Q + 16 | 0;
                return;
              }
              xf(), jn();
            }
            function ja(l, y) {
              var I = 0, C = 0, Q = 0, S = 0;
              e: {
                if (I = Vd(y), C = (Je[l + 11 | 0] & 128) >>> 7 | 0 ? (e[l + 8 >> 2] & 2147483647) - 1 | 0 : 1, I >>> 0 <= C >>> 0) {
                  y = ve((Je[l + 11 | 0] & 128) >>> 7 | 0 ? e[l >> 2] : l, y, I << 2);
                  t: {
                    if ((Je[l + 11 | 0] & 128) >>> 7 | 0) {
                      e[l + 4 >> 2] = I;
                      break t;
                    }
                    Se[l + 11 | 0] = I;
                  }
                  e[(I << 2) + y >> 2] = 0;
                  break e;
                }
                Q = l, S = e[l + 4 >> 2], l = Je[l + 11 | 0], l = (l & 128) >>> 7 | 0 ? S : l & 127, Vo(Q, C, I - C | 0, l, 0, l, I, y);
              }
            }
            function td(l) {
              var y = 0, I = 0, C = 0;
              if (C = e[l >> 2], C) {
                if (y = e[l + 4 >> 2], I = C, (y | 0) != (I | 0)) {
                  for (; I = y - 32 | 0, (Je[I | 0] | Je[I + 1 | 0] << 8 | (Je[I + 2 | 0] << 16 | Je[I + 3 | 0] << 24)) >>> 0 >= 29 && (y = y - 24 | 0, Tr(Je[y | 0] | Je[y + 1 | 0] << 8 | (Je[y + 2 | 0] << 16 | Je[y + 3 | 0] << 24)), Se[y | 0] = 0, Se[y + 1 | 0] = 0, Se[y + 2 | 0] = 0, Se[y + 3 | 0] = 0), y = I, (C | 0) != (y | 0); )
                    ;
                  I = e[l >> 2];
                }
                e[l + 4 >> 2] = C, Tr(I);
              }
            }
            function ag(l, y) {
              l = l | 0, y = y | 0;
              var I = 0, C = 0;
              return Se[l + 6 | 0] = 0, ea[l + 4 >> 1] = 0, e[l >> 2] = 1, I = e[y >> 2], C = e[y + 4 >> 2], e[l + 20 >> 2] = 0, e[l + 12 >> 2] = 0, e[l + 16 >> 2] = 0, e[l + 8 >> 2] = (C - I | 0) + 1, I = ga(12), e[l + 16 >> 2] = I, e[l + 12 >> 2] = I, C = I + 12 | 0, e[l + 20 >> 2] = C, e[I >> 2] = e[y >> 2], e[I + 4 >> 2] = e[y + 4 >> 2], e[I + 8 >> 2] = e[y + 8 >> 2], e[y + 8 >> 2] = 0, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[l + 16 >> 2] = C, l | 0;
            }
            function fg(l, y, I, C) {
              l = l | 0, y = y | 0, I = I | 0, C = +C;
              var Q = 0, S = 0, me = 0, ke = 0;
              return Q = ga(56), S = e[I + 8 >> 2], e[I + 8 >> 2] = 0, me = e[I >> 2], ke = e[I + 4 >> 2], e[I >> 2] = 0, e[I + 4 >> 2] = 0, e[Q + 16 >> 2] = 0, e[Q + 20 >> 2] = 0, e[Q + 12 >> 2] = S, e[Q + 4 >> 2] = me, e[Q + 8 >> 2] = ke, e[Q >> 2] = y, e[Q + 24 >> 2] = 0, e[Q + 28 >> 2] = 0, e[Q + 32 >> 2] = 0, e[Q + 36 >> 2] = 0, e[Q + 40 >> 2] = 0, e[Q + 44 >> 2] = 0, zo[Q + 48 >> 3] = C, vn(l, Q), Q | 0;
            }
            function cg(l) {
              return Je[25124] ? e[6280] : (Je[25464] || (Se[25464] = 1), Ga(25296, 1114), Ga(25308, 1121), Ga(25320, 1087), Ga(25332, 1095), Ga(25344, 1078), Ga(25356, 1128), Ga(25368, 1105), Ga(25380, 1961), Ga(25392, 1999), Ga(25404, 2336), Ga(25416, 2493), Ga(25428, 1273), Ga(25440, 2172), Ga(25452, 1390), Se[25124] = 1, e[6280] = 25296, 25296);
            }
            function uh(l, y) {
              var I = 0, C = 0, Q = 0, S = 0, me = 0;
              e: {
                if (I = Vd(y), Q = bi - 16 | 0, bi = Q, I >>> 0 < 1073741808) {
                  t: {
                    if (I >>> 0 < 2) {
                      Se[l + 11 | 0] = I;
                      break t;
                    }
                    me = Q + 8 | 0, I >>> 0 >= 2 ? (S = I + 4 & -4, C = S - 1 | 0, C = (C | 0) == 2 ? S : C) : C = 1, yh(me, C + 1 | 0), C = e[Q + 8 >> 2], e[l >> 2] = C, e[l + 8 >> 2] = e[Q + 12 >> 2] | -2147483648, e[l + 4 >> 2] = I, l = C;
                  }
                  e[du(l, y, I) + (I << 2) >> 2] = 0, bi = Q + 16 | 0;
                  break e;
                }
                xf(), jn();
              }
            }
            function Hc(l, y, I, C) {
              var Q = 0, S = 0, me = 0, ke = 0;
              Q = bi - 16 | 0, bi = Q, e[Q + 12 >> 2] = C, me = Nc(Q + 8 | 0, y), y = bi - 16 | 0, bi = y, C = e[Q + 12 >> 2], e[y + 12 >> 2] = C, e[y + 8 >> 2] = C, S = -1, C = Bc(0, 0, I, C);
              e: {
                if ((C | 0) < 0 || (ke = l, C = C + 1 | 0, l = vf(C), e[ke >> 2] = l, !l))
                  break e;
                S = Bc(l, C, I, e[y + 12 >> 2]);
              }
              return bi = y + 16 | 0, l = e[me >> 2], l && (e[6178] = (l | 0) == -1 ? 24816 : l), bi = Q + 16 | 0, S;
            }
            function ug(l, y, I) {
              l = l | 0, y = y | 0, I = +I;
              var C = 0, Q = 0, S = 0, me = 0;
              return C = ga(56), Q = e[y + 8 >> 2], e[y + 8 >> 2] = 0, S = e[y >> 2], me = e[y + 4 >> 2], e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[C + 16 >> 2] = 0, e[C + 20 >> 2] = 0, e[C + 12 >> 2] = Q, e[C + 4 >> 2] = S, e[C + 8 >> 2] = me, e[C >> 2] = 12, e[C + 24 >> 2] = 0, e[C + 28 >> 2] = 0, e[C + 32 >> 2] = 0, e[C + 36 >> 2] = 0, e[C + 40 >> 2] = 0, e[C + 44 >> 2] = 0, zo[C + 48 >> 3] = I, vn(l, C), C | 0;
            }
            function l1(l) {
              var y = 0;
              y = 1;
              e: {
                if ((l | 0) >= 1024) {
                  if (y = 898846567431158e293, l >>> 0 < 2047) {
                    l = l - 1023 | 0;
                    break e;
                  }
                  y = 1 / 0, l = ((l | 0) >= 3069 ? 3069 : l) - 2046 | 0;
                  break e;
                }
                if ((l | 0) > -1023)
                  break e;
                if (y = 2004168360008973e-307, l >>> 0 > 4294965304) {
                  l = l + 969 | 0;
                  break e;
                }
                y = 0, l = ((l | 0) <= -2960 ? -2960 : l) + 1938 | 0;
              }
              return wa(0, 0), wa(1, l + 1023 << 20), y * +Pa();
            }
            function Vl(l) {
              var y = 0, I = 0, C = 0, Q = 0;
              if (l) {
                if (Vl(e[l >> 2]), Vl(e[l + 4 >> 2]), C = e[l + 40 >> 2], C) {
                  if (y = C, I = e[l + 44 >> 2], (y | 0) != (I | 0)) {
                    for (; ; ) {
                      I = I - 32 | 0, y = e[I + 4 >> 2];
                      e: {
                        if (!y || (Q = e[y + 4 >> 2], e[y + 4 >> 2] = Q - 1, Q))
                          break e;
                        Yn[e[e[y >> 2] + 8 >> 2]](y), Ls(y);
                      }
                      if ((C | 0) == (I | 0))
                        break;
                    }
                    y = e[l + 40 >> 2];
                  }
                  e[l + 44 >> 2] = C, Tr(y);
                }
                Tr(l);
              }
            }
            function Ag(l, y, I, C, Q) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0;
              var S = 0, me = 0;
              me = bi - 16 | 0, bi = me, e[Q >> 2] = I, y = me + 12 | 0, l = b1(y, 0, e[l + 8 >> 2]), S = 2;
              e: {
                if (l + 1 >>> 0 < 2 || (I = l - 1 | 0, S = 1, I >>> 0 > C - e[Q >> 2] >>> 0))
                  break e;
                for (; ; ) {
                  if (I) {
                    l = Je[y | 0], C = e[Q >> 2], e[Q >> 2] = C + 1, Se[C | 0] = l, I = I - 1 | 0, y = y + 1 | 0;
                    continue;
                  }
                  break;
                }
                S = 0;
              }
              return l = S, bi = me + 16 | 0, l | 0;
            }
            function Au(l, y, I, C) {
              var Q = 0;
              e: {
                if (!(C & 2048) || (Q = C & 74, !I | ((Q | 0) == 8 | (Q | 0) == 64)))
                  break e;
                Se[l | 0] = 43, l = l + 1 | 0;
              }
              for (C & 512 && (Se[l | 0] = 35, l = l + 1 | 0); ; ) {
                if (Q = Je[y | 0], Q) {
                  Se[l | 0] = Q, l = l + 1 | 0, y = y + 1 | 0;
                  continue;
                }
                break;
              }
              Q = C & 74, y = 111;
              e: {
                if ((Q | 0) == 64 || (y = C & 16384 ? 88 : 120, (Q | 0) == 8))
                  break e;
                y = I ? 100 : 117;
              }
              Se[l | 0] = y;
            }
            function Wl(l) {
              var y = 0, I = 0, C = 0;
              if (y = e[l >> 2], e[l >> 2] = 0, y) {
                if (l = e[y + 28 >> 2], l && (e[y + 32 >> 2] = l, Tr(l)), I = e[y + 16 >> 2], I) {
                  if (l = I, C = e[y + 20 >> 2], (l | 0) != (C | 0)) {
                    for (; l = C - 12 | 0, Se[C - 1 | 0] < 0 && Tr(e[l >> 2]), C = l, (l | 0) != (I | 0); )
                      ;
                    l = e[y + 16 >> 2];
                  }
                  e[y + 20 >> 2] = I, Tr(l);
                }
                l = e[y + 4 >> 2], l && (e[y + 8 >> 2] = l, Tr(l)), Tr(y);
              }
            }
            function hg(l, y) {
              l = l | 0, y = y | 0;
              var I = 0, C = 0, Q = 0;
              if (e[l + 8 >> 2] = 0, e[l >> 2] = 0, e[l + 4 >> 2] = 0, e[5996] = 0, I = no(3, 12) | 0, C = e[5996], e[5996] = 0, (C | 0) != 1) {
                e[l >> 2] = I, C = I + 12 | 0, e[l + 8 >> 2] = C, e[I + 8 >> 2] = e[y + 8 >> 2], Q = e[y + 4 >> 2], e[I >> 2] = e[y >> 2], e[I + 4 >> 2] = Q, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, e[l + 4 >> 2] = C;
                return;
              }
              y = gi() | 0, hf(l), ss(y | 0), jn();
            }
            function lg(l, y, I, C, Q, S) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0;
              var me = 0, ke = 0;
              return me = bi - 32 | 0, bi = me, ke = e[3163], e[me + 24 >> 2] = e[3162], e[me + 28 >> 2] = ke, ke = e[3161], e[me + 16 >> 2] = e[3160], e[me + 20 >> 2] = ke, ke = e[3159], e[me + 8 >> 2] = e[3158], e[me + 12 >> 2] = ke, ke = e[3157], e[me >> 2] = e[3156], e[me + 4 >> 2] = ke, ke = l, l = me + 32 | 0, y = yc(ke, y, I, C, Q, S, me, l), bi = l, y | 0;
            }
            function dg(l) {
              l = l | 0;
              var y = 0, I = 0, C = 0, Q = 0;
              I = e[l + 44 >> 2], y = e[l + 24 >> 2], I >>> 0 < y >>> 0 && (e[l + 44 >> 2] = y, I = y), C = -1;
              e: {
                if (!(Je[l + 48 | 0] & 8) || (y = e[l + 16 >> 2], y >>> 0 < I >>> 0 && (Q = e[l + 8 >> 2], y = e[l + 12 >> 2], e[l + 16 >> 2] = I, e[l + 12 >> 2] = y, e[l + 8 >> 2] = Q, y = e[l + 16 >> 2]), l = e[l + 12 >> 2], l >>> 0 >= y >>> 0))
                  break e;
                C = Je[l | 0];
              }
              return C | 0;
            }
            function pg(l, y, I, C) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0;
              var Q = 0, S = 0;
              if (hc(l, e[y + 8 >> 2], 0)) {
                g1(y, I, C);
                return;
              }
              S = e[l + 12 >> 2], Sd(e[l + 16 >> 2], e[l + 20 >> 2], y, I, C), Q = l + 24 | 0, l = (l + 16 | 0) + (S << 3) | 0;
              e: {
                if (Q >>> 0 >= l >>> 0)
                  break e;
                for (; ; ) {
                  if (Sd(e[Q >> 2], e[Q + 4 >> 2], y, I, C), Je[y + 54 | 0])
                    break e;
                  if (Q = Q + 8 | 0, !(l >>> 0 > Q >>> 0))
                    break;
                }
              }
            }
            function Uf(l, y) {
              var I = 0, C = 0, Q = 0, S = 0, me = 0;
              if (C = Je[l + 11 | 0], I = C << 24 >> 24, I = (I | 0) < 0, Q = I ? e[l + 4 >> 2] : C, S = e[y + 4 >> 2], Q >>> 0 <= S >>> 0) {
                if (C = e[y >> 2], Q)
                  for (l = I ? e[l >> 2] : l, me = Q + l | 0, I = C; ; ) {
                    if (Je[l | 0] != Je[I | 0])
                      return 0;
                    if (I = I + 1 | 0, l = l + 1 | 0, (me | 0) == (l | 0))
                      break;
                  }
                e[y + 4 >> 2] = S - Q, e[y >> 2] = C + Q, l = 1;
              } else
                l = 0;
              return l;
            }
            function Jf(l) {
              var y = 0, I = 0, C = 0;
              e: {
                t: {
                  if (y = l, !(y & 3))
                    break t;
                  if (!Je[y | 0])
                    return 0;
                  for (; ; ) {
                    if (y = y + 1 | 0, !(y & 3))
                      break t;
                    if (!Je[y | 0])
                      break;
                  }
                  break e;
                }
                for (; I = y, y = y + 4 | 0, C = e[I >> 2], !((C ^ -1) & C - 16843009 & -2139062144); )
                  ;
                for (; y = I, I = y + 1 | 0, !!Je[y | 0]; )
                  ;
              }
              return y - l | 0;
            }
            function Wf(l, y, I) {
              var C = 0, Q = 0;
              e: {
                t: {
                  if (I >>> 0 >= 4) {
                    if ((l | y) & 3)
                      break t;
                    for (; ; ) {
                      if (e[l >> 2] != e[y >> 2])
                        break t;
                      if (y = y + 4 | 0, l = l + 4 | 0, I = I - 4 | 0, !(I >>> 0 > 3))
                        break;
                    }
                  }
                  if (!I)
                    break e;
                }
                for (; ; ) {
                  if (C = Je[l | 0], Q = Je[y | 0], (C | 0) == (Q | 0)) {
                    if (y = y + 1 | 0, l = l + 1 | 0, I = I - 1 | 0, I)
                      continue;
                    break e;
                  }
                  break;
                }
                return C - Q | 0;
              }
              return 0;
            }
            function gg(l, y) {
              l = l | 0, y = y | 0;
              var I = 0, C = 0;
              e: {
                t: {
                  I = Je[l + 11 | 0];
                  r: {
                    i: {
                      if ((I & 128) >>> 7 | 0) {
                        if (C = (e[l + 8 >> 2] & 2147483647) - 1 | 0, I = e[l + 4 >> 2], (C | 0) == (I | 0))
                          break i;
                        break r;
                      }
                      if (C = 1, I = I & 127, (I | 0) != 1)
                        break t;
                    }
                    Fs(l, C, 1, C, C), I = C;
                  }
                  C = e[l >> 2], e[l + 4 >> 2] = I + 1;
                  break e;
                }
                Se[l + 11 | 0] = I + 1, C = l;
              }
              l = (I << 2) + C | 0, e[l >> 2] = y, e[l + 4 >> 2] = 0;
            }
            function cc(l, y) {
              var I = 0, C = 0, Q = 0, S = 0;
              C = bi - 16 | 0, bi = C;
              e: {
                if (!y) {
                  y = 0;
                  break e;
                }
                I = y >> 31, Q = (I ^ y) - I | 0, I = Ha(Q), Es(C, Q, 0, 0, 0, I + 81 | 0), Q = 0 + e[C + 8 >> 2] | 0, I = (e[C + 12 >> 2] ^ 65536) + (16414 - I << 16) | 0, I = Q >>> 0 < S >>> 0 ? I + 1 | 0 : I, S = y & -2147483648 | I, I = e[C + 4 >> 2], y = e[C >> 2];
              }
              e[l >> 2] = y, e[l + 4 >> 2] = I, e[l + 8 >> 2] = Q, e[l + 12 >> 2] = S, bi = C + 16 | 0;
            }
            function rd(l, y, I) {
              var C = 0, Q = 0, S = 0;
              return Q = bi - 16 | 0, bi = Q, C = bi - 32 | 0, bi = C, S = bi - 16 | 0, bi = S, e[S + 12 >> 2] = y, e[C + 24 >> 2] = l, e[C + 28 >> 2] = e[S + 12 >> 2], bi = S + 16 | 0, C1(C + 16 | 0, e[C + 24 >> 2], e[C + 28 >> 2], I), l = T1(l, e[C + 16 >> 2] - l >> 2), e[C + 12 >> 2] = e[C + 20 >> 2], e[Q + 8 >> 2] = l, e[Q + 12 >> 2] = e[C + 12 >> 2], bi = C + 32 | 0, bi = Q + 16 | 0, e[Q + 12 >> 2];
            }
            function d1(l, y, I, C) {
              var Q = 0, S = 0, me = 0, ke = 0;
              Q = bi - 160 | 0, bi = Q, e[Q + 60 >> 2] = y, e[Q + 20 >> 2] = y, e[Q + 24 >> 2] = -1, S = Q + 16 | 0, Mc(S, 0, 0), bh(Q, S, C, 1), C = e[Q + 8 >> 2], me = e[Q + 12 >> 2], S = e[Q >> 2], ke = e[Q + 4 >> 2], I && (e[I >> 2] = ((e[Q + 20 >> 2] + e[Q + 136 >> 2] | 0) - e[Q + 60 >> 2] | 0) + y), e[l + 8 >> 2] = C, e[l + 12 >> 2] = me, e[l >> 2] = S, e[l + 4 >> 2] = ke, bi = Q + 160 | 0;
            }
            function nd(l, y, I) {
              var C = 0, Q = 0, S = 0;
              return Q = bi - 16 | 0, bi = Q, C = bi - 32 | 0, bi = C, S = bi - 16 | 0, bi = S, e[S + 12 >> 2] = y, e[C + 24 >> 2] = l, e[C + 28 >> 2] = e[S + 12 >> 2], bi = S + 16 | 0, C1(C + 16 | 0, e[C + 24 >> 2], e[C + 28 >> 2], I), l = D1(l, e[C + 16 >> 2] - l | 0), e[C + 12 >> 2] = e[C + 20 >> 2], e[Q + 8 >> 2] = l, e[Q + 12 >> 2] = e[C + 12 >> 2], bi = C + 32 | 0, bi = Q + 16 | 0, e[Q + 12 >> 2];
            }
            function yg(l, y) {
              l = l | 0, y = y | 0;
              var I = 0, C = 0;
              e: {
                t: {
                  I = Je[l + 11 | 0];
                  r: {
                    i: {
                      if ((I & 128) >>> 7 | 0) {
                        if (C = (e[l + 8 >> 2] & 2147483647) - 1 | 0, I = e[l + 4 >> 2], (C | 0) == (I | 0))
                          break i;
                        break r;
                      }
                      if (C = 10, I = I & 127, (I | 0) != 10)
                        break t;
                    }
                    Qs(l, C, 1, C, C), I = C;
                  }
                  C = e[l >> 2], e[l + 4 >> 2] = I + 1;
                  break e;
                }
                Se[l + 11 | 0] = I + 1, C = l;
              }
              l = C + I | 0, Se[l | 0] = y, Se[l + 1 | 0] = 0;
            }
            function mg(l, y, I, C, Q) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0;
              var S = 0, me = 0, ke = 0;
              ke = (Q - C | 0) + y | 0;
              e: {
                for (; ; ) {
                  if ((C | 0) != (Q | 0)) {
                    if (l = -1, (y | 0) == (I | 0) || (S = Se[y | 0], me = Se[C | 0], (S | 0) < (me | 0)))
                      break e;
                    if ((S | 0) > (me | 0))
                      return 1;
                    C = C + 1 | 0, y = y + 1 | 0;
                    continue;
                  }
                  break;
                }
                l = (I | 0) != (ke | 0);
              }
              return l | 0;
            }
            function p1(l) {
              l = l | 0;
              var y = 0, I = 0;
              if (e[l >> 2] = 8512, e[5996] = 0, Co(133, l | 0, 0), y = e[5996], e[5996] = 0, (y | 0) != 1)
                return y = e[l + 28 >> 2], I = e[y + 4 >> 2] - 1 | 0, e[y + 4 >> 2] = I, (I | 0) == -1 && Yn[e[e[y >> 2] + 8 >> 2]](y), Tr(e[l + 32 >> 2]), Tr(e[l + 36 >> 2]), Tr(e[l + 48 >> 2]), Tr(e[l + 60 >> 2]), l | 0;
              Ws(0) | 0, _c(), jn();
            }
            function Ah(l, y, I) {
              var C = 0, Q = 0, S = 0;
              e: {
                if (!y) {
                  C = l;
                  break e;
                }
                for (; C = wc(l, y, 10), Q = Ci, l = Ua(C, Q, 246, 0) + l | 0, I = I - 1 | 0, Se[I | 0] = l | 48, S = y >>> 0 > 9, l = C, y = Q, !!S; )
                  ;
              }
              if (C)
                for (; I = I - 1 | 0, l = (C >>> 0) / 10 | 0, Se[I | 0] = No(l, 246) + C | 48, y = C >>> 0 > 9, C = l, !!y; )
                  ;
              return I;
            }
            function Pc(l) {
              var y = 0, I = 0, C = 0, Q = 0;
              if (C = e[l >> 2], C) {
                if (y = C, I = e[l + 4 >> 2], (y | 0) != (I | 0)) {
                  for (; ; ) {
                    I = I - 32 | 0, y = e[I + 4 >> 2];
                    e: {
                      if (!y || (Q = e[y + 4 >> 2], e[y + 4 >> 2] = Q - 1, Q))
                        break e;
                      Yn[e[e[y >> 2] + 8 >> 2]](y), Ls(y);
                    }
                    if ((C | 0) == (I | 0))
                      break;
                  }
                  y = e[l >> 2];
                }
                e[l + 4 >> 2] = C, Tr(y);
              }
            }
            function Za(l) {
              var y = 0, I = 0, C = 0, Q = 0;
              if (C = e[l >> 2], C) {
                if (y = C, I = e[l + 4 >> 2], (y | 0) != (I | 0)) {
                  for (; ; ) {
                    I = I - 8 | 0, y = e[I + 4 >> 2];
                    e: {
                      if (!y || (Q = e[y + 4 >> 2], e[y + 4 >> 2] = Q - 1, Q))
                        break e;
                      Yn[e[e[y >> 2] + 8 >> 2]](y), Ls(y);
                    }
                    if ((C | 0) == (I | 0))
                      break;
                  }
                  y = e[l >> 2];
                }
                e[l + 4 >> 2] = C, Tr(y);
              }
            }
            function hh(l, y) {
              var I = 0, C = 0, Q = 0, S = 0;
              I = bi - 16 | 0, bi = I;
              e: {
                if (!y) {
                  y = 0;
                  break e;
                }
                C = y, y = Ha(y), Es(I, C, 0, 0, 0, y + 81 | 0), C = 0 + e[I + 8 >> 2] | 0, y = (e[I + 12 >> 2] ^ 65536) + (16414 - y << 16) | 0, S = Q >>> 0 > C >>> 0 ? y + 1 | 0 : y, Q = e[I + 4 >> 2], y = e[I >> 2];
              }
              e[l >> 2] = y, e[l + 4 >> 2] = Q, e[l + 8 >> 2] = C, e[l + 12 >> 2] = S, bi = I + 16 | 0;
            }
            function vg(l, y, I) {
              l = l | 0, y = y | 0, I = I | 0;
              var C = 0;
              C = e[y + 28 >> 2], e[l >> 2] = C, e[C + 4 >> 2] = e[C + 4 >> 2] + 1, Ed(y + 28 | 0, I), e[5996] = 0, Co(133, y | 0, 1), y = e[5996], e[5996] = 0, (y | 0) == 1 && (I = gi() | 0, l = e[l >> 2], y = e[l + 4 >> 2] - 1 | 0, e[l + 4 >> 2] = y, (y | 0) == -1 && Yn[e[e[l >> 2] + 8 >> 2]](l), ss(I | 0), jn());
            }
            function wg(l, y, I, C, Q) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0;
              var S = 0, me = 0;
              e: {
                for (; ; ) {
                  if ((C | 0) != (Q | 0)) {
                    if (l = -1, (y | 0) == (I | 0) || (S = e[y >> 2], me = e[C >> 2], (S | 0) < (me | 0)))
                      break e;
                    if ((S | 0) > (me | 0))
                      return 1;
                    C = C + 4 | 0, y = y + 4 | 0;
                    continue;
                  }
                  break;
                }
                l = (y | 0) != (I | 0);
              }
              return l | 0;
            }
            function od(l) {
              l = l | 0;
              var y = 0, I = 0, C = 0, Q = 0;
              for (e[l >> 2] = 12664, Q = l + 8 | 0; ; ) {
                if (y = e[l + 8 >> 2], e[l + 12 >> 2] - y >> 2 >>> 0 > I >>> 0) {
                  y = e[y + (I << 2) >> 2], y && (C = e[y + 4 >> 2] - 1 | 0, e[y + 4 >> 2] = C, (C | 0) == -1 && Yn[e[e[y >> 2] + 8 >> 2]](y)), I = I + 1 | 0;
                  continue;
                }
                break;
              }
              return Yo(l + 152 | 0), sp(Q), l | 0;
            }
            function lh(l) {
              var y = 0, I = 0, C = 0, Q = 0, S = 0;
              e: {
                if (Je[l + 4 | 0] || (Q = e[l >> 2], y = e[Q >> 2], !y))
                  break e;
                if (I = y, C = e[Q + 4 >> 2], (C | 0) != (y | 0)) {
                  for (; I = C - 12 | 0, S = e[I >> 2], S && (e[C - 8 >> 2] = S, Tr(S)), C = I, (C | 0) != (y | 0); )
                    ;
                  I = e[e[l >> 2] >> 2];
                }
                e[Q + 4 >> 2] = y, Tr(I);
              }
            }
            function sd(l) {
              var y = 0, I = 0;
              return y = e[l + 72 >> 2], e[l + 72 >> 2] = y - 1 | y, e[l + 20 >> 2] != e[l + 28 >> 2] && Yn[e[l + 36 >> 2]](l, 0, 0) | 0, e[l + 28 >> 2] = 0, e[l + 16 >> 2] = 0, e[l + 20 >> 2] = 0, y = e[l >> 2], y & 4 ? (e[l >> 2] = y | 32, -1) : (I = e[l + 44 >> 2] + e[l + 48 >> 2] | 0, e[l + 8 >> 2] = I, e[l + 4 >> 2] = I, y << 27 >> 31);
            }
            function Ga(l, y) {
              var I = 0, C = 0, Q = 0, S = 0;
              e: {
                if (I = Jf(y), C = (Je[l + 11 | 0] & 128) >>> 7 | 0 ? (e[l + 8 >> 2] & 2147483647) - 1 | 0 : 10, I >>> 0 <= C >>> 0) {
                  t1(l, yu((Je[l + 11 | 0] & 128) >>> 7 | 0 ? e[l >> 2] : l, y, I), I);
                  break e;
                }
                Q = l, S = e[l + 4 >> 2], l = Je[l + 11 | 0], l = (l & 128) >>> 7 | 0 ? S : l & 127, ms(Q, C, I - C | 0, l, 0, l, I, y);
              }
            }
            function Mc(l, y, I) {
              var C = 0, Q = 0, S = 0, me = 0;
              e[l + 112 >> 2] = y, e[l + 116 >> 2] = I, Q = e[l + 4 >> 2], C = e[l + 44 >> 2] - Q | 0, e[l + 120 >> 2] = C, e[l + 124 >> 2] = C >> 31, C = e[l + 8 >> 2];
              e: {
                if (!(y | I) || (S = C - Q | 0, me = S >> 31, (I | 0) >= (me | 0) & y >>> 0 >= S >>> 0 | (I | 0) > (me | 0)))
                  break e;
                C = y + Q | 0;
              }
              e[l + 104 >> 2] = C;
            }
            function ad(l, y) {
              var I = 0, C = 0, Q = 0;
              if (Ta(+l), C = oa(1) | 0, Q = oa(0) | 0, I = C >>> 20 & 2047, (I | 0) != 2047) {
                if (!I)
                  return l == 0 ? I = 0 : (l = ad(l * 18446744073709552e3, y), I = e[y >> 2] + -64 | 0), e[y >> 2] = I, l;
                e[y >> 2] = I - 1022, wa(0, Q | 0), wa(1, C & -2146435073 | 1071644672), l = +Pa();
              }
              return l;
            }
            function fd(l) {
              var y = 0, I = 0, C = 0, Q = 0;
              e: {
                if (Je[l + 4 | 0] || (Q = e[l >> 2], y = e[Q >> 2], !y))
                  break e;
                if (I = y, C = e[Q + 4 >> 2], (y | 0) != (C | 0)) {
                  for (; I = C - 12 | 0, Se[C - 1 | 0] < 0 && Tr(e[I >> 2]), C = I, (C | 0) != (y | 0); )
                    ;
                  I = e[e[l >> 2] >> 2];
                }
                e[Q + 4 >> 2] = y, Tr(I);
              }
            }
            function cd(l, y) {
              var I = 0, C = 0;
              for (C = bi - 16 | 0, bi = C, I = C + 4 | 0, e[I >> 2] = l, l = e[l + 4 >> 2], e[I + 4 >> 2] = l, e[I + 8 >> 2] = l + (y << 2), y = e[I + 4 >> 2], l = e[I + 8 >> 2]; ; ) {
                if ((l | 0) == (y | 0))
                  e[e[I >> 2] + 4 >> 2] = e[I + 4 >> 2], bi = C + 16 | 0;
                else {
                  e[y >> 2] = 0, y = y + 4 | 0, e[I + 4 >> 2] = y;
                  continue;
                }
                break;
              }
            }
            function _c() {
              var l = 0;
              l = e[5728], e[5996] = 0, jo(l | 0), l = e[5996], e[5996] = 0;
              e: {
                if ((l | 0) != 1 && (e[5996] = 0, jo(291), l = e[5996], e[5996] = 0, (l | 0) != 1) || (Zf(Ws(0) | 0) | 0, e[5996] = 0, jo(291), l = e[5996], e[5996] = 0, (l | 0) != 1))
                  break e;
                Ws(0) | 0, _c();
              }
              jn();
            }
            function ud(l, y, I, C) {
              var Q = 0, S = 0;
              Q = bi - 32 | 0, bi = Q, S = bi - 16 | 0, bi = S, e[S + 12 >> 2] = I, e[Q + 24 >> 2] = y, e[Q + 28 >> 2] = e[S + 12 >> 2], bi = S + 16 | 0, C1(Q + 16 | 0, e[Q + 24 >> 2], e[Q + 28 >> 2], C), y = e[Q + 16 >> 2], e[Q + 12 >> 2] = e[Q + 20 >> 2], e[l >> 2] = y, e[l + 4 >> 2] = e[Q + 12 >> 2], bi = Q + 32 | 0;
            }
            function uc(l, y, I) {
              if (I = I & 176, (I | 0) == 32)
                return y;
              e: {
                if ((I | 0) != 16)
                  break e;
                t: {
                  r:
                    switch (I = Je[l | 0], I - 43 | 0) {
                      case 0:
                      case 2:
                        break r;
                      default:
                        break t;
                    }
                  return l + 1 | 0;
                }
                if ((I | 0) != 48 | (y - l | 0) < 2 | (Je[l + 1 | 0] | 32) != 120)
                  break e;
                l = l + 2 | 0;
              }
              return l;
            }
            function Ig(l, y) {
              l = l | 0, y = y | 0;
              var I = 0, C = 0;
              if (I = e[y + 48 >> 2], I & 16) {
                C = e[y + 44 >> 2], I = e[y + 24 >> 2], C >>> 0 < I >>> 0 && (e[y + 44 >> 2] = I, C = I), iu(l, e[y + 20 >> 2], C);
                return;
              }
              if (I & 8) {
                iu(l, e[y + 8 >> 2], e[y + 16 >> 2]);
                return;
              }
              e[l >> 2] = 0, e[l + 4 >> 2] = 0, e[l + 8 >> 2] = 0;
            }
            function bg(l) {
              l = l | 0;
              var y = 0, I = 0;
              e: {
                t: {
                  if (!l || (y = l - 24 | 0, I = e[y >> 2] - 1 | 0, e[y >> 2] = I, Je[y + 13 | 0] | I))
                    break t;
                  if (y = e[y + 8 >> 2], y && (e[5996] = 0, no(y | 0, l | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1))
                    break e;
                  ef(l);
                }
                return;
              }
              Ws(0) | 0, _c(), jn();
            }
            function Ad(l, y, I) {
              var C = 0, Q = 0, S = 0, me = 0;
              for (C = bi - 16 | 0, bi = C, y = y - l >> 2; ; ) {
                if (y) {
                  e[C + 12 >> 2] = l, Q = y >>> 1 | 0, e[C + 12 >> 2] = e[C + 12 >> 2] + (Q << 2), S = e[C + 12 >> 2], me = qs[S >> 2] < I >>> 0, l = me ? S + 4 | 0 : l, y = me ? (Q ^ -1) + y | 0 : Q;
                  continue;
                }
                break;
              }
              return bi = C + 16 | 0, l;
            }
            function Ac(l, y) {
              l = l | 0, y = y | 0;
              var I = 0, C = 0, Q = 0;
              if (I = Jf(y), I >>> 0 < 2147483632) {
                e: {
                  if (I >>> 0 <= 10) {
                    Se[l + 11 | 0] = I, C = l;
                    break e;
                  }
                  Q = (I | 15) + 1 | 0, C = ga(Q), e[l + 8 >> 2] = Q | -2147483648, e[l >> 2] = C, e[l + 4 >> 2] = I;
                }
                return Se[ve(C, y, I) + I | 0] = 0, l | 0;
              }
              xf(), jn();
            }
            function Cg(l, y, I, C, Q, S) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0;
              var me = 0, ke = 0, Ar = 0, br = 0;
              return me = Yn[e[e[l + 8 >> 2] + 20 >> 2]](l + 8 | 0) | 0, ke = Je[me + 11 | 0], Ar = l, br = y, y = (ke & 128) >>> 7 | 0, l = y ? e[me >> 2] : me, yc(Ar, br, I, C, Q, S, l, l + ((y ? e[me + 4 >> 2] : ke & 127) << 2) | 0) | 0;
            }
            function Eg(l, y, I) {
              l = l | 0, y = y | 0, I = I | 0;
              var C = 0, Q = 0;
              e: {
                if (Je[y | 0] != 47)
                  for (; ; ) {
                    if ((I | 0) == (C | 0)) {
                      Q = Mr(y, I), y = 0;
                      break e;
                    }
                    if (C = C + 1 | 0, Je[C + y | 0] == 47)
                      break;
                  }
                Q = Mr(y, C), y = Mr((y + C | 0) + 1 | 0, (C ^ -1) + I | 0);
              }
              e[l + 4 >> 2] = y, e[l >> 2] = Q;
            }
            function Ua(l, y, I, C) {
              var Q = 0, S = 0, me = 0, ke = 0, Ar = 0, br = 0;
              return Q = I >>> 16 | 0, S = l >>> 16 | 0, br = No(Q, S), me = I & 65535, ke = l & 65535, Ar = No(me, ke), S = (Ar >>> 16 | 0) + No(S, me) | 0, Q = (S & 65535) + No(Q, ke) | 0, Ci = (No(y, I) + br | 0) + No(l, C) + (S >>> 16) + (Q >>> 16) | 0, Ar & 65535 | Q << 16;
            }
            function Bg(l, y, I, C, Q, S) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0;
              var me = 0, ke = 0, Ar = 0, br = 0;
              return me = Yn[e[e[l + 8 >> 2] + 20 >> 2]](l + 8 | 0) | 0, ke = Je[me + 11 | 0], Ar = l, br = y, y = (ke & 128) >>> 7 | 0, l = y ? e[me >> 2] : me, Ec(Ar, br, I, C, Q, S, l, l + (y ? e[me + 4 >> 2] : ke & 127) | 0) | 0;
            }
            function hd(l, y) {
              l = l | 0, y = y | 0;
              var I = 0, C = 0;
              I = e[l >> 2];
              e: {
                if (!I)
                  break e;
                C = e[I + 24 >> 2];
                t: {
                  if ((C | 0) == e[I + 28 >> 2]) {
                    y = Yn[e[e[I >> 2] + 52 >> 2]](I, y) | 0;
                    break t;
                  }
                  e[I + 24 >> 2] = C + 4, e[C >> 2] = y;
                }
                if ((y | 0) != -1)
                  break e;
                e[l >> 2] = 0;
              }
              return l | 0;
            }
            function _g(l, y, I, C) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, C = ga(104), e[C >> 2] = 7e3, e[C + 4 >> 2] = 0, e[C + 8 >> 2] = 0, e[5996] = 0, y = Ko(143, C + 12 | 0, y | 0, I | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1 && (l = gi() | 0, Tr(C), ss(l | 0), jn()), e[l + 4 >> 2] = C, e[l >> 2] = y;
            }
            function g1(l, y, I) {
              var C = 0;
              if (C = e[l + 16 >> 2], !C) {
                e[l + 36 >> 2] = 1, e[l + 24 >> 2] = I, e[l + 16 >> 2] = y;
                return;
              }
              e: {
                if ((y | 0) == (C | 0)) {
                  if (e[l + 24 >> 2] != 2)
                    break e;
                  e[l + 24 >> 2] = I;
                  return;
                }
                Se[l + 54 | 0] = 1, e[l + 24 >> 2] = 2, e[l + 36 >> 2] = e[l + 36 >> 2] + 1;
              }
            }
            function y1(l) {
              var y = 0, I = 0, C = 0;
              e: {
                if (Je[l + 12 | 0] || (y = e[e[l + 8 >> 2] >> 2], C = e[e[l + 4 >> 2] >> 2], (y | 0) == (C | 0)))
                  break e;
                for (; l = y - 12 | 0, I = e[l >> 2], I && (e[y - 8 >> 2] = I, Tr(I)), y = l, (l | 0) != (C | 0); )
                  ;
              }
            }
            function ld(l, y, I, C, Q, S) {
              var me = 0;
              me = bi - 16 | 0, bi = me, Se[me + 15 | 0] = 0, Se[me + 14 | 0] = S, Se[me + 13 | 0] = Q, Se[me + 12 | 0] = 37, S && (Q = Je[me + 13 | 0], Se[me + 13 | 0] = Je[me + 14 | 0], Se[me + 14 | 0] = Q), e[I >> 2] = (pa(y | 0, e[I >> 2] - y | 0, me + 12 | 0, C | 0, l | 0) | 0) + y, bi = me + 16 | 0;
            }
            function Lf(l, y, I, C, Q) {
              var S = 0;
              if (S = bi - 256 | 0, bi = S, !(Q & 73728 | (I | 0) <= (C | 0))) {
                if (C = I - C | 0, I = C >>> 0 < 256, jr(S, y & 255, I ? C : 256), !I)
                  for (; Of(l, S, 256), C = C - 256 | 0, C >>> 0 > 255; )
                    ;
                Of(l, S, C);
              }
              bi = S + 256 | 0;
            }
            function Hh(l) {
              var y = 0, I = 0, C = 0, Q = 0;
              if (y = e[l >> 2], y) {
                if (I = y, C = e[l + 4 >> 2], (C | 0) != (y | 0)) {
                  for (; I = C - 12 | 0, Q = e[I >> 2], Q && (e[C - 8 >> 2] = Q, Tr(Q)), C = I, (C | 0) != (y | 0); )
                    ;
                  I = e[l >> 2];
                }
                e[l + 4 >> 2] = y, Tr(I);
              }
            }
            function kg(l) {
              l = l | 0;
              var y = 0, I = 0, C = 0;
              if (l = e[6019], l) {
                if (y = l, I = e[6020], (I | 0) != (l | 0)) {
                  for (; y = I - 12 | 0, C = e[y >> 2], C && (e[I - 8 >> 2] = C, Tr(C)), I = y, (I | 0) != (l | 0); )
                    ;
                  y = e[6019];
                }
                e[6020] = l, Tr(y);
              }
            }
            function Sg(l) {
              l = l | 0;
              var y = 0, I = 0, C = 0;
              if (l = e[6049], l) {
                if (y = l, I = e[6050], (I | 0) != (l | 0)) {
                  for (; y = I - 12 | 0, C = e[y >> 2], C && (e[I - 8 >> 2] = C, Tr(C)), I = y, (I | 0) != (l | 0); )
                    ;
                  y = e[6049];
                }
                e[6050] = l, Tr(y);
              }
            }
            function Tg(l) {
              l = l | 0;
              var y = 0, I = 0, C = 0;
              if (l = e[6151], l) {
                if (y = l, I = e[6152], (I | 0) != (l | 0)) {
                  for (; y = I - 12 | 0, C = e[y >> 2], C && (e[I - 8 >> 2] = C, Tr(C)), I = y, (I | 0) != (l | 0); )
                    ;
                  y = e[6151];
                }
                e[6152] = l, Tr(y);
              }
            }
            function Dg(l) {
              l = l | 0;
              var y = 0, I = 0, C = 0;
              if (l = e[6055], l) {
                if (y = l, I = e[6056], (I | 0) != (l | 0)) {
                  for (; y = I - 12 | 0, C = e[y >> 2], C && (e[I - 8 >> 2] = C, Tr(C)), I = y, (I | 0) != (l | 0); )
                    ;
                  y = e[6055];
                }
                e[6056] = l, Tr(y);
              }
            }
            function xg(l) {
              l = l | 0;
              var y = 0, I = 0, C = 0;
              if (l = e[6157], l) {
                if (y = l, I = e[6158], (I | 0) != (l | 0)) {
                  for (; y = I - 12 | 0, C = e[y >> 2], C && (e[I - 8 >> 2] = C, Tr(C)), I = y, (I | 0) != (l | 0); )
                    ;
                  y = e[6157];
                }
                e[6158] = l, Tr(y);
              }
            }
            function Rg(l) {
              l = l | 0;
              var y = 0, I = 0, C = 0;
              if (l = e[6061], l) {
                if (y = l, I = e[6062], (I | 0) != (l | 0)) {
                  for (; y = I - 12 | 0, C = e[y >> 2], C && (e[I - 8 >> 2] = C, Tr(C)), I = y, (I | 0) != (l | 0); )
                    ;
                  y = e[6061];
                }
                e[6062] = l, Tr(y);
              }
            }
            function Pg(l) {
              l = l | 0;
              var y = 0, I = 0, C = 0;
              if (l = e[6163], l) {
                if (y = l, I = e[6164], (I | 0) != (l | 0)) {
                  for (; y = I - 12 | 0, C = e[y >> 2], C && (e[I - 8 >> 2] = C, Tr(C)), I = y, (I | 0) != (l | 0); )
                    ;
                  y = e[6163];
                }
                e[6164] = l, Tr(y);
              }
            }
            function Mg(l) {
              l = l | 0;
              var y = 0, I = 0, C = 0;
              if (l = e[6067], l) {
                if (y = l, I = e[6068], (I | 0) != (l | 0)) {
                  for (; y = I - 12 | 0, C = e[y >> 2], C && (e[I - 8 >> 2] = C, Tr(C)), I = y, (I | 0) != (l | 0); )
                    ;
                  y = e[6067];
                }
                e[6068] = l, Tr(y);
              }
            }
            function Ng(l) {
              l = l | 0;
              var y = 0, I = 0, C = 0;
              if (l = e[6169], l) {
                if (y = l, I = e[6170], (I | 0) != (l | 0)) {
                  for (; y = I - 12 | 0, C = e[y >> 2], C && (e[I - 8 >> 2] = C, Tr(C)), I = y, (I | 0) != (l | 0); )
                    ;
                  y = e[6169];
                }
                e[6170] = l, Tr(y);
              }
            }
            function Og(l) {
              l = l | 0;
              var y = 0, I = 0, C = 0;
              if (l = e[6073], l) {
                if (y = l, I = e[6074], (I | 0) != (l | 0)) {
                  for (; y = I - 12 | 0, C = e[y >> 2], C && (e[I - 8 >> 2] = C, Tr(C)), I = y, (I | 0) != (l | 0); )
                    ;
                  y = e[6073];
                }
                e[6074] = l, Tr(y);
              }
            }
            function Ug(l) {
              l = l | 0;
              var y = 0, I = 0, C = 0;
              if (l = e[6175], l) {
                if (y = l, I = e[6176], (I | 0) != (l | 0)) {
                  for (; y = I - 12 | 0, C = e[y >> 2], C && (e[I - 8 >> 2] = C, Tr(C)), I = y, (I | 0) != (l | 0); )
                    ;
                  y = e[6175];
                }
                e[6176] = l, Tr(y);
              }
            }
            function Qg(l) {
              l = l | 0;
              var y = 0, I = 0, C = 0;
              if (l = e[6025], l) {
                if (y = l, I = e[6026], (I | 0) != (l | 0)) {
                  for (; y = I - 12 | 0, C = e[y >> 2], C && (e[I - 8 >> 2] = C, Tr(C)), I = y, (I | 0) != (l | 0); )
                    ;
                  y = e[6025];
                }
                e[6026] = l, Tr(y);
              }
            }
            function Fg(l) {
              l = l | 0;
              var y = 0, I = 0, C = 0;
              if (l = e[6031], l) {
                if (y = l, I = e[6032], (I | 0) != (l | 0)) {
                  for (; y = I - 12 | 0, C = e[y >> 2], C && (e[I - 8 >> 2] = C, Tr(C)), I = y, (I | 0) != (l | 0); )
                    ;
                  y = e[6031];
                }
                e[6032] = l, Tr(y);
              }
            }
            function Lg(l) {
              l = l | 0;
              var y = 0, I = 0, C = 0;
              if (l = e[6081], l) {
                if (y = l, I = e[6082], (I | 0) != (l | 0)) {
                  for (; y = I - 12 | 0, C = e[y >> 2], C && (e[I - 8 >> 2] = C, Tr(C)), I = y, (I | 0) != (l | 0); )
                    ;
                  y = e[6081];
                }
                e[6082] = l, Tr(y);
              }
            }
            function qg(l) {
              l = l | 0;
              var y = 0, I = 0, C = 0;
              if (l = e[6037], l) {
                if (y = l, I = e[6038], (I | 0) != (l | 0)) {
                  for (; y = I - 12 | 0, C = e[y >> 2], C && (e[I - 8 >> 2] = C, Tr(C)), I = y, (I | 0) != (l | 0); )
                    ;
                  y = e[6037];
                }
                e[6038] = l, Tr(y);
              }
            }
            function Hg(l) {
              l = l | 0;
              var y = 0, I = 0, C = 0;
              if (l = e[6085], l) {
                if (y = l, I = e[6086], (I | 0) != (l | 0)) {
                  for (; y = I - 12 | 0, C = e[y >> 2], C && (e[I - 8 >> 2] = C, Tr(C)), I = y, (I | 0) != (l | 0); )
                    ;
                  y = e[6085];
                }
                e[6086] = l, Tr(y);
              }
            }
            function Kg(l) {
              l = l | 0;
              var y = 0, I = 0, C = 0;
              if (l = e[6089], l) {
                if (y = l, I = e[6090], (I | 0) != (l | 0)) {
                  for (; y = I - 12 | 0, C = e[y >> 2], C && (e[I - 8 >> 2] = C, Tr(C)), I = y, (I | 0) != (l | 0); )
                    ;
                  y = e[6089];
                }
                e[6090] = l, Tr(y);
              }
            }
            function jg(l) {
              l = l | 0;
              var y = 0, I = 0, C = 0;
              if (l = e[6093], l) {
                if (y = l, I = e[6094], (I | 0) != (l | 0)) {
                  for (; y = I - 12 | 0, C = e[y >> 2], C && (e[I - 8 >> 2] = C, Tr(C)), I = y, (I | 0) != (l | 0); )
                    ;
                  y = e[6093];
                }
                e[6094] = l, Tr(y);
              }
            }
            function Gg(l) {
              l = l | 0;
              var y = 0, I = 0, C = 0;
              if (l = e[6097], l) {
                if (y = l, I = e[6098], (I | 0) != (l | 0)) {
                  for (; y = I - 12 | 0, C = e[y >> 2], C && (e[I - 8 >> 2] = C, Tr(C)), I = y, (I | 0) != (l | 0); )
                    ;
                  y = e[6097];
                }
                e[6098] = l, Tr(y);
              }
            }
            function $g(l) {
              l = l | 0;
              var y = 0, I = 0, C = 0;
              if (l = e[6101], l) {
                if (y = l, I = e[6102], (I | 0) != (l | 0)) {
                  for (; y = I - 12 | 0, C = e[y >> 2], C && (e[I - 8 >> 2] = C, Tr(C)), I = y, (I | 0) != (l | 0); )
                    ;
                  y = e[6101];
                }
                e[6102] = l, Tr(y);
              }
            }
            function Yg(l) {
              l = l | 0;
              var y = 0, I = 0, C = 0;
              if (l = e[6105], l) {
                if (y = l, I = e[6106], (I | 0) != (l | 0)) {
                  for (; y = I - 12 | 0, C = e[y >> 2], C && (e[I - 8 >> 2] = C, Tr(C)), I = y, (I | 0) != (l | 0); )
                    ;
                  y = e[6105];
                }
                e[6106] = l, Tr(y);
              }
            }
            function Vg(l) {
              l = l | 0;
              var y = 0, I = 0, C = 0;
              if (l = e[6043], l) {
                if (y = l, I = e[6044], (I | 0) != (l | 0)) {
                  for (; y = I - 12 | 0, C = e[y >> 2], C && (e[I - 8 >> 2] = C, Tr(C)), I = y, (I | 0) != (l | 0); )
                    ;
                  y = e[6043];
                }
                e[6044] = l, Tr(y);
              }
            }
            function dd(l) {
              var y = 0, I = 0, C = 0;
              for (C = e[l >> 2]; ; ) {
                if (I = Se[C | 0], I - 48 >>> 0 < 10) {
                  C = C + 1 | 0, e[l >> 2] = C, y >>> 0 <= 214748364 ? (I = I - 48 | 0, y = No(y, 10), y = (I | 0) > (y ^ 2147483647) ? -1 : I + y | 0) : y = -1;
                  continue;
                }
                break;
              }
              return y;
            }
            function Wg(l) {
              l = l | 0;
              var y = 0, I = 0, C = 0;
              if (l = e[6109], l) {
                if (y = l, I = e[6110], (I | 0) != (l | 0)) {
                  for (; y = I - 12 | 0, C = e[y >> 2], C && (e[I - 8 >> 2] = C, Tr(C)), I = y, (I | 0) != (l | 0); )
                    ;
                  y = e[6109];
                }
                e[6110] = l, Tr(y);
              }
            }
            function Jg(l) {
              l = l | 0;
              var y = 0, I = 0, C = 0;
              if (l = e[6113], l) {
                if (y = l, I = e[6114], (I | 0) != (l | 0)) {
                  for (; y = I - 12 | 0, C = e[y >> 2], C && (e[I - 8 >> 2] = C, Tr(C)), I = y, (I | 0) != (l | 0); )
                    ;
                  y = e[6113];
                }
                e[6114] = l, Tr(y);
              }
            }
            function zg(l) {
              l = l | 0;
              var y = 0, I = 0, C = 0;
              if (l = e[6117], l) {
                if (y = l, I = e[6118], (I | 0) != (l | 0)) {
                  for (; y = I - 12 | 0, C = e[y >> 2], C && (e[I - 8 >> 2] = C, Tr(C)), I = y, (I | 0) != (l | 0); )
                    ;
                  y = e[6117];
                }
                e[6118] = l, Tr(y);
              }
            }
            function Xg(l) {
              l = l | 0;
              var y = 0, I = 0, C = 0;
              if (l = e[6121], l) {
                if (y = l, I = e[6122], (I | 0) != (l | 0)) {
                  for (; y = I - 12 | 0, C = e[y >> 2], C && (e[I - 8 >> 2] = C, Tr(C)), I = y, (I | 0) != (l | 0); )
                    ;
                  y = e[6121];
                }
                e[6122] = l, Tr(y);
              }
            }
            function Zg(l) {
              l = l | 0;
              var y = 0, I = 0, C = 0;
              if (l = e[6125], l) {
                if (y = l, I = e[6126], (I | 0) != (l | 0)) {
                  for (; y = I - 12 | 0, C = e[y >> 2], C && (e[I - 8 >> 2] = C, Tr(C)), I = y, (I | 0) != (l | 0); )
                    ;
                  y = e[6125];
                }
                e[6126] = l, Tr(y);
              }
            }
            function e4(l) {
              l = l | 0;
              var y = 0, I = 0, C = 0;
              if (l = e[6129], l) {
                if (y = l, I = e[6130], (I | 0) != (l | 0)) {
                  for (; y = I - 12 | 0, C = e[y >> 2], C && (e[I - 8 >> 2] = C, Tr(C)), I = y, (I | 0) != (l | 0); )
                    ;
                  y = e[6129];
                }
                e[6130] = l, Tr(y);
              }
            }
            function t4(l) {
              l = l | 0;
              var y = 0, I = 0, C = 0;
              if (l = e[6133], l) {
                if (y = l, I = e[6134], (I | 0) != (l | 0)) {
                  for (; y = I - 12 | 0, C = e[y >> 2], C && (e[I - 8 >> 2] = C, Tr(C)), I = y, (I | 0) != (l | 0); )
                    ;
                  y = e[6133];
                }
                e[6134] = l, Tr(y);
              }
            }
            function r4(l) {
              l = l | 0;
              var y = 0, I = 0, C = 0;
              if (l = e[6137], l) {
                if (y = l, I = e[6138], (I | 0) != (l | 0)) {
                  for (; y = I - 12 | 0, C = e[y >> 2], C && (e[I - 8 >> 2] = C, Tr(C)), I = y, (I | 0) != (l | 0); )
                    ;
                  y = e[6137];
                }
                e[6138] = l, Tr(y);
              }
            }
            function pd(l) {
              var y = 0, I = 0;
              e: {
                if (Je[l + 12 | 0] || (y = e[e[l + 8 >> 2] >> 2], I = e[e[l + 4 >> 2] >> 2], (y | 0) == (I | 0)))
                  break e;
                for (; l = y - 12 | 0, Se[y - 1 | 0] < 0 && Tr(e[l >> 2]), y = l, (l | 0) != (I | 0); )
                  ;
              }
            }
            function nu(l, y) {
              var I = 0;
              return y = Fi(y), I = e[l + 12 >> 2], l = e[l + 8 >> 2], y >>> 0 < I - l >> 2 >>> 0 ? I = e[l + (y << 2) >> 2] != 0 : I = 0, I || (l = ro(4), e[l >> 2] = 22892, e[l >> 2] = 22736, E2(l | 0, 22872, 173), jn()), e[l + (y << 2) >> 2];
            }
            function hf(l) {
              var y = 0, I = 0, C = 0;
              if (y = e[l >> 2], y) {
                if (I = y, C = e[l + 4 >> 2], (y | 0) != (C | 0)) {
                  for (; I = C - 12 | 0, Se[C - 1 | 0] < 0 && Tr(e[I >> 2]), C = I, (C | 0) != (y | 0); )
                    ;
                  I = e[l >> 2];
                }
                e[l + 4 >> 2] = y, Tr(I);
              }
            }
            function gd(l, y, I, C) {
              e: {
                if (!l)
                  break e;
                t:
                  switch (y + 2 | 0) {
                    case 0:
                      Se[l | 0] = I;
                      return;
                    case 1:
                      ea[l >> 1] = I;
                      return;
                    case 2:
                    case 3:
                      e[l >> 2] = I;
                      return;
                    case 5:
                      break t;
                    default:
                      break e;
                  }
                e[l >> 2] = I, e[l + 4 >> 2] = C;
              }
            }
            function yd(l) {
              var y = 0;
              return y = e[l + 72 >> 2], e[l + 72 >> 2] = y - 1 | y, y = e[l >> 2], y & 8 ? (e[l >> 2] = y | 32, -1) : (e[l + 4 >> 2] = 0, e[l + 8 >> 2] = 0, y = e[l + 44 >> 2], e[l + 28 >> 2] = y, e[l + 20 >> 2] = y, e[l + 16 >> 2] = y + e[l + 48 >> 2], 0);
            }
            function m1(l, y, I, C, Q, S, me, ke, Ar) {
              var br = 0;
              br = bi - 16 | 0, bi = br, Ef(br, y, I, C, Q, S, me, ke, Ar ^ -2147483648), C = e[br >> 2], I = e[br + 4 >> 2], y = e[br + 12 >> 2], e[l + 8 >> 2] = e[br + 8 >> 2], e[l + 12 >> 2] = y, e[l >> 2] = C, e[l + 4 >> 2] = I, bi = br + 16 | 0;
            }
            function ga(l) {
              l = l | 0;
              var y = 0;
              l = l >>> 0 <= 1 ? 1 : l;
              e: {
                for (; ; ) {
                  if (y = vf(l), y)
                    break e;
                  if (y = e[6704], y) {
                    Yn[y | 0]();
                    continue;
                  }
                  break;
                }
                l = ro(4), e[l >> 2] = 22892, e[l >> 2] = 22364, E2(l | 0, 22448, 5), jn();
              }
              return y | 0;
            }
            function jh(l, y) {
              var I = 0, C = 0;
              I = Je[l | 0], C = Je[y | 0];
              e: {
                if (!I | (I | 0) != (C | 0))
                  break e;
                for (; ; ) {
                  if (C = Je[y + 1 | 0], I = Je[l + 1 | 0], !I)
                    break e;
                  if (y = y + 1 | 0, l = l + 1 | 0, (I | 0) != (C | 0))
                    break;
                }
              }
              return I - C | 0;
            }
            function i4(l, y, I) {
              l = l | 0, y = y | 0, I = I | 0;
              var C = 0, Q = 0, S = 0;
              return Q = e[l + 84 >> 2], C = I + 256 | 0, S = Hs(Q, 0, C), C = S ? S - Q | 0 : C, I = I >>> 0 > C >>> 0 ? C : I, Sa(y, Q, I), y = Q + C | 0, e[l + 84 >> 2] = y, e[l + 8 >> 2] = y, e[l + 4 >> 2] = I + Q, I | 0;
            }
            function n4(l, y, I, C, Q, S) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0;
              var me = 0, ke = 0;
              return me = bi - 16 | 0, bi = me, e[me + 8 >> 2] = 624576549, e[me + 12 >> 2] = 1394948685, ke = l, l = me + 16 | 0, y = Ec(ke, y, I, C, Q, S, me + 8 | 0, l), bi = l, y | 0;
            }
            function o4(l, y, I, C) {
              for (l = l | 0, y = y | 0, I = I | 0, C = C | 0; ; ) {
                if ((y | 0) != (I | 0)) {
                  l = e[y >> 2], l >>> 0 <= 127 ? l = e[(l << 2) + 12736 >> 2] : l = 0, e[C >> 2] = l, C = C + 4 | 0, y = y + 4 | 0;
                  continue;
                }
                break;
              }
              return I | 0;
            }
            function md(l) {
              var y = 0, I = 0;
              if (y = e[l >> 2], y) {
                I = e[y + 12 >> 2];
                e: {
                  if ((I | 0) == e[y + 16 >> 2]) {
                    y = Yn[e[e[y >> 2] + 36 >> 2]](y) | 0;
                    break e;
                  }
                  y = e[I >> 2];
                }
                if ((y | 0) != -1)
                  return !e[l >> 2];
                e[l >> 2] = 0;
              }
              return 1;
            }
            function vd(l) {
              var y = 0, I = 0;
              if (y = e[l >> 2], y) {
                I = e[y + 12 >> 2];
                e: {
                  if ((I | 0) == e[y + 16 >> 2]) {
                    y = Yn[e[e[y >> 2] + 36 >> 2]](y) | 0;
                    break e;
                  }
                  y = Je[I | 0];
                }
                if ((y | 0) != -1)
                  return !e[l >> 2];
                e[l >> 2] = 0;
              }
              return 1;
            }
            function wd(l) {
              var y = 0, I = 0, C = 0;
              if (y = e[l >> 2], y) {
                if (C = y, I = e[l + 4 >> 2], (I | 0) != (y | 0)) {
                  for (; I = I - 12 | 0, Kf(e[I + 4 >> 2]), (y | 0) != (I | 0); )
                    ;
                  C = e[l >> 2];
                }
                e[l + 4 >> 2] = y, Tr(C);
              }
            }
            function s4(l, y, I) {
              l = l | 0, y = y | 0, I = I | 0;
              var C = 0;
              C = ga(104), e[5996] = 0, y = Ko(147, C | 0, y | 0, I | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) == 1 && (l = gi() | 0, Tr(C), ss(l | 0), jn()), e[l + 4 >> 2] = y, e[l >> 2] = y + 12;
            }
            function a4(l, y, I, C) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0;
              e: {
                for (; ; ) {
                  if ((I | 0) == (C | 0))
                    break e;
                  if (l = e[I >> 2], !(l >>> 0 > 127 | !(e[(l << 2) + 12736 >> 2] & y))) {
                    I = I + 4 | 0;
                    continue;
                  }
                  break;
                }
                C = I;
              }
              return C | 0;
            }
            function f4(l, y, I, C) {
              for (l = l | 0, y = y | 0, I = I | 0, C = C | 0; ; ) {
                e: {
                  if ((I | 0) != (C | 0)) {
                    if (l = e[I >> 2], l >>> 0 > 127 | !(e[(l << 2) + 12736 >> 2] & y))
                      break e;
                  } else
                    I = C;
                  return I | 0;
                }
                I = I + 4 | 0;
              }
            }
            function c4(l) {
              l = l | 0;
              var y = 0, I = 0;
              return y = bi - 16 | 0, bi = y, I = e[Nc(y + 12 | 0, e[l + 8 >> 2]) >> 2], I && (e[6178] = (I | 0) == -1 ? 24816 : I), bi = y + 16 | 0, l = e[l + 8 >> 2], l ? (Dd(l) | 0) == 1 | 0 : 1;
            }
            function Jl(l) {
              var y = 0, I = 0;
              if (l) {
                Jl(e[l >> 2]), Jl(e[l + 4 >> 2]), y = e[l + 28 >> 2];
                e: {
                  if (!y || (I = e[y + 4 >> 2], e[y + 4 >> 2] = I - 1, I))
                    break e;
                  Yn[e[e[y >> 2] + 8 >> 2]](y), Ls(y);
                }
                Tr(l);
              }
            }
            function u4(l) {
              l = l | 0;
              var y = 0, I = 0;
              y = bi - 16 | 0, bi = y, _d() >>> 0 <= 29 && (tf(), jn()), $d(y + 8 | 0, l + 16 | 0, 30), I = e[y + 8 >> 2], e[l + 4 >> 2] = I, e[l >> 2] = I, e[l + 8 >> 2] = (e[y + 12 >> 2] << 2) + I, bi = y + 16 | 0;
            }
            function Gh(l) {
              var y = 0, I = 0, C = 0;
              if (y = e[l >> 2], y) {
                if (C = y, I = e[l + 4 >> 2], (I | 0) != (y | 0)) {
                  for (; I = ff(I - 56 | 0), (I | 0) != (y | 0); )
                    ;
                  C = e[l >> 2];
                }
                e[l + 4 >> 2] = y, Tr(C);
              }
            }
            function A4(l) {
              l = l | 0;
              var y = 0, I = 0;
              if (l = e[6076], l) {
                if (I = l, y = e[6077], (y | 0) != (l | 0)) {
                  for (; y = y - 4 | 0, Wl(y), (l | 0) != (y | 0); )
                    ;
                  I = e[6076];
                }
                e[6077] = l, Tr(I);
              }
            }
            function h4(l, y, I) {
              l = l | 0, y = y | 0, I = I | 0;
              var C = 0;
              return C = bi - 16 | 0, bi = C, e[C + 12 >> 2] = e[I >> 2], l = Yn[e[e[l >> 2] + 16 >> 2]](l, y, C + 12 | 0) | 0, l && (e[I >> 2] = e[C + 12 >> 2]), bi = C + 16 | 0, l | 0;
            }
            function l4(l, y, I) {
              l = l | 0, y = y | 0, I = I | 0;
              var C = 0;
              for (l = 0; ; ) {
                if ((y | 0) != (I | 0)) {
                  l = e[y >> 2] + (l << 4) | 0, C = l & -268435456, l = (C | C >>> 24) ^ l, y = y + 4 | 0;
                  continue;
                }
                break;
              }
              return l | 0;
            }
            function d4(l, y, I, C, Q) {
              return l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, l = bi - 16 | 0, bi = l, e[l + 12 >> 2] = Q, e[l + 8 >> 2] = C - I, bi = l + 16 | 0, y = l + 8 | 0, l = l + 12 | 0, e[(qs[y >> 2] < qs[l >> 2] ? y : l) >> 2];
            }
            function qf(l, y, I, C, Q) {
              var S = 0;
              return S = bi - 16 | 0, bi = S, e[S + 12 >> 2] = Q, I = Nc(S + 8 | 0, I), y = Bc(l, y, C, e[S + 12 >> 2]), l = e[I >> 2], l && (e[6178] = (l | 0) == -1 ? 24816 : l), bi = S + 16 | 0, y;
            }
            function p4(l, y, I) {
              l = l | 0, y = y | 0, I = I | 0;
              var C = 0;
              for (l = 0; ; ) {
                if ((y | 0) != (I | 0)) {
                  l = Se[y | 0] + (l << 4) | 0, C = l & -268435456, l = (C | C >>> 24) ^ l, y = y + 1 | 0;
                  continue;
                }
                break;
              }
              return l | 0;
            }
            function g4(l, y) {
              l = l | 0, y = y | 0;
              var I = 0;
              if (I = e[l + 4 >> 2], I >>> 0 < qs[l + 8 >> 2]) {
                e[I >> 2] = e[y >> 2], e[I + 4 >> 2] = e[y + 4 >> 2], e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[l + 4 >> 2] = I + 8;
                return;
              }
              ti(l, y);
            }
            function _f(l, y) {
              var I = 0;
              I = e[l >> 2], e[l >> 2] = y;
              e: {
                if (I && (l = e[l + 4 >> 2], e[5996] = 0, La(l | 0, I | 0), l = e[5996], e[5996] = 0, (l | 0) == 1))
                  break e;
                return;
              }
              Ws(0) | 0, _c(), jn();
            }
            function bd(l, y, I) {
              var C = 0;
              return C = bi - 16 | 0, bi = C, e[C + 12 >> 2] = I, y = Nc(C + 8 | 0, y), I = Eh(l, 1937, e[C + 12 >> 2]), l = e[y >> 2], l && (e[6178] = (l | 0) == -1 ? 24816 : l), bi = C + 16 | 0, I;
            }
            function y4(l, y, I) {
              for (l = l | 0, y = y | 0, I = I | 0; ; ) {
                if ((y | 0) != (I | 0)) {
                  l = e[y >> 2], l >>> 0 <= 127 && (l = e[(l << 2) + 11184 >> 2]), e[y >> 2] = l, y = y + 4 | 0;
                  continue;
                }
                break;
              }
              return I | 0;
            }
            function Cd(l) {
              var y = 0, I = 0;
              if (e[5996] = 0, I = yi(168) | 0, y = e[5996], e[5996] = 0, (y | 0) != 1) {
                y = l, l = e[I >> 2], e[y >> 2] = l, e[l + 4 >> 2] = e[l + 4 >> 2] + 1;
                return;
              }
              Ws(0) | 0, _c(), jn();
            }
            function m4(l, y, I) {
              for (l = l | 0, y = y | 0, I = I | 0; ; ) {
                if ((y | 0) != (I | 0)) {
                  l = e[y >> 2], l >>> 0 <= 127 && (l = e[(l << 2) + 9648 >> 2]), e[y >> 2] = l, y = y + 4 | 0;
                  continue;
                }
                break;
              }
              return I | 0;
            }
            function hu(l) {
              var y = 0, I = 0, C = 0;
              return y = bi - 16 | 0, bi = y, I = Je[l + 11 | 0], C = (I & 128) >>> 7 | 0, e[y + 12 >> 2] = (C ? e[l >> 2] : l) + ((C ? e[l + 4 >> 2] : I & 127) << 2), bi = y + 16 | 0, e[y + 12 >> 2];
            }
            function w4(l, y, I, C, Q) {
              for (l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0; ; ) {
                if ((y | 0) != (I | 0)) {
                  l = e[y >> 2], Se[Q | 0] = l >>> 0 < 128 ? l : C, Q = Q + 1 | 0, y = y + 4 | 0;
                  continue;
                }
                break;
              }
              return I | 0;
            }
            function Ed(l, y) {
              var I = 0, C = 0;
              I = e[y >> 2], e[I + 4 >> 2] = e[I + 4 >> 2] + 1, I = e[l >> 2], C = e[I + 4 >> 2] - 1 | 0, e[I + 4 >> 2] = C, (C | 0) == -1 && Yn[e[e[I >> 2] + 8 >> 2]](I), e[l >> 2] = e[y >> 2];
            }
            function Xl(l, y) {
              var I = 0;
              e: {
                if ((l | 0) == (y | 0))
                  break e;
                for (; ; ) {
                  if (y = y - 4 | 0, y >>> 0 <= l >>> 0)
                    break e;
                  I = e[l >> 2], e[l >> 2] = e[y >> 2], e[y >> 2] = I, l = l + 4 | 0;
                }
              }
            }
            function I4(l, y, I) {
              l = l | 0, y = y | 0, I = I | 0;
              var C = 0;
              return C = bi - 16 | 0, bi = C, Yn[e[e[l >> 2] + 12 >> 2]](C + 8 | 0, l, y), bi = C + 16 | 0, e[C + 12 >> 2] == e[I + 4 >> 2] & e[C + 8 >> 2] == e[I >> 2];
            }
            function Bd(l) {
              l = l | 0;
              var y = 0, I = 0;
              y = ro(8), e[5996] = 0, l = wn(91, y | 0, l | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) != 1 && (E2(l | 0, 22664, 92), jn()), l = gi() | 0, ef(y), ss(l | 0), jn();
            }
            function b4(l, y, I) {
              for (l = l | 0, y = y | 0, I = I | 0; ; ) {
                if ((y | 0) != (I | 0)) {
                  l = Se[y | 0], (l | 0) >= 0 && (l = e[(l << 2) + 11184 >> 2]), Se[y | 0] = l, y = y + 1 | 0;
                  continue;
                }
                break;
              }
              return I | 0;
            }
            function C4(l, y, I, C, Q) {
              for (l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0; ; ) {
                if ((y | 0) != (I | 0)) {
                  l = Se[y | 0], Se[Q | 0] = (l | 0) < 0 ? C : l, Q = Q + 1 | 0, y = y + 1 | 0;
                  continue;
                }
                break;
              }
              return I | 0;
            }
            function E4(l, y, I) {
              for (l = l | 0, y = y | 0, I = I | 0; ; ) {
                if ((y | 0) != (I | 0)) {
                  l = Se[y | 0], (l | 0) >= 0 && (l = e[(l << 2) + 9648 >> 2]), Se[y | 0] = l, y = y + 1 | 0;
                  continue;
                }
                break;
              }
              return I | 0;
            }
            function B4(l, y, I, C, Q, S) {
              if (l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0, hc(l, e[y + 8 >> 2], S)) {
                h1(y, I, C, Q);
                return;
              }
              l = e[l + 8 >> 2], Yn[e[e[l >> 2] + 20 >> 2]](l, y, I, C, Q, S);
            }
            function lu(l) {
              var y = 0, I = 0, C = 0;
              return y = bi - 16 | 0, bi = y, I = Je[l + 11 | 0], C = (I & 128) >>> 7 | 0, e[y + 12 >> 2] = (C ? e[l >> 2] : l) + (C ? e[l + 4 >> 2] : I & 127), bi = y + 16 | 0, e[y + 12 >> 2];
            }
            function _4(l, y) {
              l = l | 0, y = y | 0;
              var I = 0, C = 0;
              for (I = e[l + 40 >> 2]; ; ) {
                if (I) {
                  I = I - 1 | 0, C = I << 2, Yn[e[e[l + 32 >> 2] + C >> 2]](y, l, e[C + e[l + 36 >> 2] >> 2]);
                  continue;
                }
                break;
              }
            }
            function Uu(l, y) {
              var I = 0;
              e: {
                if ((l | 0) == (y | 0))
                  break e;
                for (; ; ) {
                  if (y = y - 1 | 0, y >>> 0 <= l >>> 0)
                    break e;
                  I = Je[l | 0], Se[l | 0] = Je[y | 0], Se[y | 0] = I, l = l + 1 | 0;
                }
              }
            }
            function _d() {
              var l = 0, y = 0;
              return l = bi - 16 | 0, bi = l, e[l + 12 >> 2] = 1073741823, e[l + 8 >> 2] = 2147483647, bi = l + 16 | 0, y = l + 8 | 0, l = l + 12 | 0, e[(qs[y >> 2] < qs[l >> 2] ? y : l) >> 2];
            }
            function Kc(l, y) {
              var I = 0;
              (Je[l + 11 | 0] & 128) >>> 7 | 0 && Tr(e[l >> 2]), I = e[y + 4 >> 2], e[l >> 2] = e[y >> 2], e[l + 4 >> 2] = I, e[l + 8 >> 2] = e[y + 8 >> 2], Se[y + 11 | 0] = 0, e[y >> 2] = 0;
            }
            function w1(l, y) {
              var I = 0;
              if (!((Je[y + 11 | 0] & 128) >>> 7 | 0)) {
                I = e[y + 4 >> 2], e[l >> 2] = e[y >> 2], e[l + 4 >> 2] = I, e[l + 8 >> 2] = e[y + 8 >> 2];
                return;
              }
              Yl(l, e[y >> 2], e[y + 4 >> 2]);
            }
            function k4(l) {
              return Je[25164] ? e[6290] : (Je[26312] || (Se[26312] = 1), ja(26288, 19200), ja(26300, 19212), Se[25164] = 1, e[6290] = 26288, 26288);
            }
            function Hf(l, y) {
              var I = 0;
              (Je[l + 11 | 0] & 128) >>> 7 | 0 && Tr(e[l >> 2]), I = e[y + 4 >> 2], e[l >> 2] = e[y >> 2], e[l + 4 >> 2] = I, e[l + 8 >> 2] = e[y + 8 >> 2], Se[y + 11 | 0] = 0, Se[y | 0] = 0;
            }
            function I1() {
              var l = 0, y = 0, I = 0;
              y = ro(8), e[5996] = 0, l = no(125, y | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) != 1 && (E2(l | 0, 22632, 7), jn()), l = gi() | 0, ef(y), ss(l | 0), jn();
            }
            function S4(l) {
              return Je[25156] ? e[6288] : (Je[26280] || (Se[26280] = 1), Ga(26256, 3116), Ga(26268, 3113), Se[25156] = 1, e[6288] = 26256, 26256);
            }
            function kd(l) {
              var y = 0, I = 0;
              y = ro(8), e[5996] = 0, l = wn(6, y | 0, l | 0) | 0, I = e[5996], e[5996] = 0, (I | 0) != 1 && (E2(l | 0, 22580, 7), jn()), l = gi() | 0, ef(y), ss(l | 0), jn();
            }
            function Sd(l, y, I, C, Q) {
              var S = 0;
              S = I, I = 0;
              e: {
                if (!C || (I = y >> 8, !(y & 1)))
                  break e;
                I = e[I + e[C >> 2] >> 2];
              }
              Yn[e[e[l >> 2] + 28 >> 2]](l, S, I + C | 0, y & 2 ? Q : 2);
            }
            function Td(l, y, I) {
              var C = 0;
              for (C = bi - 16 | 0, bi = C, Se[C + 15 | 0] = I, I = l; ; ) {
                if (y) {
                  Se[I | 0] = Je[C + 15 | 0], y = y - 1 | 0, I = I + 1 | 0;
                  continue;
                }
                break;
              }
              return bi = C + 16 | 0, l;
            }
            function Dd(l) {
              var y = 0, I = 0;
              return y = bi - 16 | 0, bi = y, l = Nc(y + 12 | 0, l), I = e[e[6178] >> 2] ? 4 : 1, l = e[l >> 2], l && (e[6178] = (l | 0) == -1 ? 24816 : l), bi = y + 16 | 0, I;
            }
            function xd(l, y) {
              var I = 0;
              return I = e[l + 24 >> 2], (I | 0) == e[l + 28 >> 2] ? Yn[e[e[l >> 2] + 52 >> 2]](l, y & 255) | 0 : (e[l + 24 >> 2] = I + 1, Se[I | 0] = y, y & 255);
            }
            function Rd(l, y, I, C, Q) {
              var S = 0;
              return S = bi - 16 | 0, bi = S, Q = Nc(S + 12 | 0, Q), y = fo(l, y, I, C), l = e[Q >> 2], l && (e[6178] = (l | 0) == -1 ? 24816 : l), bi = S + 16 | 0, y;
            }
            function $h(l) {
              l = l | 0;
              var y = 0, I = 0;
              return e[l >> 2] = 7896, y = e[l + 4 >> 2], I = e[y + 4 >> 2] - 1 | 0, e[y + 4 >> 2] = I, (I | 0) == -1 && Yn[e[e[y >> 2] + 8 >> 2]](y), l | 0;
            }
            function T4() {
              var l = 0;
              return Je[25032] ? e[6257] : (l = e[Sh() >> 2], e[6256] = l, e[l + 4 >> 2] = e[l + 4 >> 2] + 1, Se[25032] = 1, e[6257] = 25024, 25024);
            }
            function D4(l) {
              Se[24063] < 0 && Tr(e[6013]), Se[24051] < 0 && Tr(e[6010]), Se[24039] < 0 && Tr(e[6007]), Se[24027] < 0 && Tr(e[6004]);
            }
            function x4(l) {
              l = l | 0;
              var y = 0;
              y = e[l + 12 >> 2];
              e: {
                if ((y | 0) == e[l + 16 >> 2]) {
                  l = Yn[e[e[l >> 2] + 36 >> 2]](l) | 0;
                  break e;
                }
                l = Je[y | 0];
              }
              return l << 24 >> 24;
            }
            function R4(l, y, I, C) {
              for (y = y | 0, I = I | 0, C = C | 0; ; ) {
                if ((y | 0) != (I | 0)) {
                  e[C >> 2] = Se[y | 0], C = C + 4 | 0, y = y + 1 | 0;
                  continue;
                }
                break;
              }
              return I | 0;
            }
            function Zl(l) {
              return l = l | 0, e[l + 56 >> 2] = 8316, e[l >> 2] = 8296, e[l + 4 >> 2] = 7960, Se[l + 47 | 0] < 0 && Tr(e[l + 36 >> 2]), $h(l + 4 | 0), Y1(l + 56 | 0), l | 0;
            }
            function b1(l, y, I) {
              var C = 0;
              return C = bi - 16 | 0, bi = C, I = Nc(C + 12 | 0, I), y = sf(l, y), l = e[I >> 2], l && (e[6178] = (l | 0) == -1 ? 24816 : l), bi = C + 16 | 0, y;
            }
            function Pd(l, y, I, C, Q, S) {
              l = Yn[e[e[l + 8 >> 2] + 4 >> 2]](l + 8 | 0) | 0, l = Cc(I, C, l, l + 288 | 0, S, Q, 0) - l | 0, (l | 0) <= 287 && (e[y >> 2] = ((l | 0) / 12 | 0) % 12);
            }
            function Md(l, y, I, C, Q, S) {
              l = Yn[e[e[l + 8 >> 2] + 4 >> 2]](l + 8 | 0) | 0, l = _u(I, C, l, l + 288 | 0, S, Q, 0) - l | 0, (l | 0) <= 287 && (e[y >> 2] = ((l | 0) / 12 | 0) % 12);
            }
            function P4(l) {
              l = l | 0;
              var y = 0;
              return (Yn[e[e[l >> 2] + 36 >> 2]](l) | 0) != -1 ? (y = l, l = e[l + 12 >> 2], e[y + 12 >> 2] = l + 1, l = Je[l | 0]) : l = -1, l | 0;
            }
            function M4(l, y, I, C) {
              for (y = y | 0, I = I | 0, C = C | 0; ; ) {
                if ((y | 0) != (I | 0)) {
                  Se[C | 0] = Je[y | 0], C = C + 1 | 0, y = y + 1 | 0;
                  continue;
                }
                break;
              }
              return I | 0;
            }
            function Ls(l) {
              var y = 0, I = 0;
              e: {
                if (y = l + 8 | 0, e[y >> 2] && (I = y, y = e[y >> 2] - 1 | 0, e[I >> 2] = y, (y | 0) != -1))
                  break e;
                Yn[e[e[l >> 2] + 16 >> 2]](l);
              }
            }
            function N4(l, y, I, C) {
              if (l = l | 0, y = y | 0, I = I | 0, C = C | 0, hc(l, e[y + 8 >> 2], 0)) {
                g1(y, I, C);
                return;
              }
              l = e[l + 8 >> 2], Yn[e[e[l >> 2] + 28 >> 2]](l, y, I, C);
            }
            function Nd(l, y, I, C, Q, S) {
              l = Yn[e[e[l + 8 >> 2] >> 2]](l + 8 | 0) | 0, l = Cc(I, C, l, l + 168 | 0, S, Q, 0) - l | 0, (l | 0) <= 167 && (e[y >> 2] = ((l | 0) / 12 | 0) % 7);
            }
            function Od(l, y, I, C, Q, S) {
              l = Yn[e[e[l + 8 >> 2] >> 2]](l + 8 | 0) | 0, l = _u(I, C, l, l + 168 | 0, S, Q, 0) - l | 0, (l | 0) <= 167 && (e[y >> 2] = ((l | 0) / 12 | 0) % 7);
            }
            function C1(l, y, I, C) {
              var Q = 0, S = 0;
              Q = bi - 16 | 0, bi = Q, S = y, y = I - y | 0, e[Q + 12 >> 2] = ve(C, S, y) + y, e[l >> 2] = I, e[l + 4 >> 2] = e[Q + 12 >> 2], bi = Q + 16 | 0;
            }
            function O4(l) {
              l = l | 0;
              var y = 0;
              y = e[l + 12 >> 2];
              e: {
                if ((y | 0) == e[l + 16 >> 2]) {
                  l = Yn[e[e[l >> 2] + 36 >> 2]](l) | 0;
                  break e;
                }
                l = e[y >> 2];
              }
              return l | 0;
            }
            function l2(l) {
              var y = 0;
              e: {
                if (l = e[l + 4 >> 2], !l || (y = e[l + 4 >> 2], e[l + 4 >> 2] = y - 1, y))
                  break e;
                Yn[e[e[l >> 2] + 8 >> 2]](l), Ls(l);
              }
            }
            function U4(l, y) {
              l = l | 0, y = y | 0;
              var I = 0;
              return I = l, l = Je[y + 11 | 0], A1(I, (l & 128) >>> 7 | 0 ? e[y >> 2] : y, (l & 128) >>> 7 | 0 ? e[y + 4 >> 2] : l & 127) | 0;
            }
            function Ud(l) {
              var y = 0;
              return y = e[l + 12 >> 2], (y | 0) == e[l + 16 >> 2] ? Yn[e[e[l >> 2] + 40 >> 2]](l) | 0 : (e[l + 12 >> 2] = y + 4, e[y >> 2]);
            }
            function Qd(l) {
              var y = 0;
              return y = e[l + 12 >> 2], (y | 0) == e[l + 16 >> 2] ? Yn[e[e[l >> 2] + 40 >> 2]](l) | 0 : (e[l + 12 >> 2] = y + 1, Je[y | 0]);
            }
            function Fd(l, y) {
              l = l | 0, y = y | 0;
              var I = 0;
              I = y, y = e[y >> 2] + 7 & -8, e[I >> 2] = y + 16, zo[l >> 3] = th(e[y >> 2], e[y + 4 >> 2], e[y + 8 >> 2], e[y + 12 >> 2]);
            }
            function E1(l, y, I) {
              for (I = I & 255; ; ) {
                e: {
                  if ((l | 0) != (y | 0)) {
                    if ((I | 0) != Je[l | 0])
                      break e;
                  } else
                    l = y;
                  return l;
                }
                l = l + 1 | 0;
              }
            }
            function Q4(l) {
              l = l | 0;
              var y = 0, I = 0;
              I = e[l + 4 >> 2], y = e[l >> 2], l = e[l + 8 >> 2], y = y + (l >> 1) | 0, l & 1 && (I = e[I + e[y >> 2] >> 2]), Yn[I | 0](y);
            }
            function Ld(l, y, I, C, Q, S, me, ke, Ar) {
              e[l >> 2] = y, e[l + 4 >> 2] = I, e[l + 8 >> 2] = C, e[l + 12 >> 2] = Q & 65535 | (Ar >>> 16 & 32768 | Q >>> 16 & 32767) << 16;
            }
            function qd(l) {
              var y = 0;
              y = e[l >> 2], e[l >> 2] = 0, y && (l = e[y + 4 >> 2] - 1 | 0, e[y + 4 >> 2] = l, (l | 0) == -1 && Yn[e[e[y >> 2] + 8 >> 2]](y));
            }
            function Hd(l, y) {
              l = l | 0, y = y | 0;
              var I = 0;
              I = e[l >> 2];
              e: {
                if (!I || (xd(I, y) | 0) != -1)
                  break e;
                e[l >> 2] = 0;
              }
              return l | 0;
            }
            function B1(l, y, I) {
              for (; ; ) {
                e: {
                  if ((l | 0) != (y | 0)) {
                    if (e[l >> 2] != (I | 0))
                      break e;
                  } else
                    l = y;
                  return l;
                }
                l = l + 4 | 0;
              }
            }
            function k1(l, y, I, C, Q, S, me) {
              var ke = 0;
              ke = y >> 8, y & 1 && (ke = e[e[Q >> 2] + ke >> 2]), Yn[e[e[l >> 2] + 20 >> 2]](l, I, C, Q + ke | 0, y & 2 ? S : 2, me);
            }
            function S1(l, y) {
              var I = 0, C = 0;
              I = Jf(y), C = ga(I + 13 | 0), e[C + 8 >> 2] = 0, e[C + 4 >> 2] = I, e[C >> 2] = I, e[l >> 2] = Sa(C + 12 | 0, y, I + 1 | 0);
            }
            function hc(l, y, I) {
              return I ? (l | 0) == (y | 0) ? 1 : !jh(e[l + 4 >> 2], e[y + 4 >> 2]) : e[l + 4 >> 2] == e[y + 4 >> 2];
            }
            function F4(l, y, I, C, Q, S) {
              l = l | 0, e[l + 8 >> 2] = -1, e[l + 12 >> 2] = -1, e[l >> 2] = 0, e[l + 4 >> 2] = 0;
            }
            function L4(l, y) {
              return l = l | 0, y = y | 0, e[l >> 2] = 22892, e[l >> 2] = 22500, S1(l + 4 | 0, (Je[y + 11 | 0] & 128) >>> 7 | 0 ? e[y >> 2] : y), l | 0;
            }
            function T1(l, y) {
              var I = 0;
              return I = bi - 16 | 0, bi = I, e[I + 12 >> 2] = l, l = I + 12 | 0, e[l >> 2] = e[l >> 2] + (y << 2), bi = I + 16 | 0, e[l >> 2];
            }
            function Kd(l, y, I, C, Q) {
              y = to(y, I, C, Q, 4), Je[C | 0] & 4 || (e[l >> 2] = ((y | 0) < 69 ? y + 2e3 | 0 : (y | 0) < 100 ? y + 1900 | 0 : y) - 1900);
            }
            function lc(l) {
              var y = 0;
              return y = bi - 16 | 0, bi = y, e[y + 12 >> 2] = (Je[l + 11 | 0] & 128) >>> 7 | 0 ? e[l >> 2] : l, bi = y + 16 | 0, e[y + 12 >> 2];
            }
            function jd(l, y, I, C, Q) {
              y = Br(y, I, C, Q, 4), Je[C | 0] & 4 || (e[l >> 2] = ((y | 0) < 69 ? y + 2e3 | 0 : (y | 0) < 100 ? y + 1900 | 0 : y) - 1900);
            }
            function e1(l, y, I, C, Q, S) {
              var me = 0;
              me = y >> 8, y & 1 && (me = e[e[C >> 2] + me >> 2]), Yn[e[e[l >> 2] + 24 >> 2]](l, I, C + me | 0, y & 2 ? Q : 2, S);
            }
            function Gd(l, y, I, C, Q, S, me, ke) {
              return I = I | 0, Q = Q | 0, S = S | 0, ke = ke | 0, e[Q >> 2] = I, e[ke >> 2] = S, 3;
            }
            function D1(l, y) {
              var I = 0;
              return I = bi - 16 | 0, bi = I, e[I + 12 >> 2] = l, l = I + 12 | 0, e[l >> 2] = e[l >> 2] + y, bi = I + 16 | 0, e[l >> 2];
            }
            function jc(l) {
              e: {
                if (l = l & 74, l) {
                  if ((l | 0) == 64)
                    return 8;
                  if ((l | 0) != 8)
                    break e;
                  return 16;
                }
                return 0;
              }
              return 10;
            }
            function Nc(l, y) {
              var I = 0;
              return I = e[6178], y && (e[6178] = (y | 0) == -1 ? 24816 : y), e[l >> 2] = (I | 0) == 24816 ? -1 : I, l;
            }
            function $d(l, y, I) {
              e: {
                if (!(Je[y + 120 | 0] | I >>> 0 > 30)) {
                  Se[y + 120 | 0] = 1;
                  break e;
                }
                y = up(I);
              }
              e[l + 4 >> 2] = I, e[l >> 2] = y;
            }
            function Yd(l, y) {
              e[l + 4 >> 2], e[l + 4 >> 2] = y;
            }
            function q4(l, y, I, C) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Yn[e[e[y >> 2] + 16 >> 2]](l, y, e[I + 8 >> 2], e[I + 12 >> 2], 0, C);
            }
            function ph(l) {
              var y = 0;
              y = e[l + 12 >> 2], y && (e[l + 16 >> 2] = y, Tr(y)), y = e[l >> 2], y && (e[l + 4 >> 2] = y, Tr(y));
            }
            function H4(l, y, I, C, Q, S) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0, hc(l, e[y + 8 >> 2], S) && h1(y, I, C, Q);
            }
            function K4(l, y, I, C) {
              l = l | 0, e[l + 8 >> 2] = -1, e[l + 12 >> 2] = -1, e[l >> 2] = 0, e[l + 4 >> 2] = 0;
            }
            function j4(l, y, I, C, Q) {
              return l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, Yn[e[e[l >> 2] + 24 >> 2]](l, y, I, C, Q) | 0;
            }
            function Vd(l) {
              var y = 0, I = 0;
              for (I = l; y = I, I = y + 4 | 0, !!e[y >> 2]; )
                ;
              return y - l >> 2;
            }
            function Wd(l) {
              l = l | 0;
              var y = 0;
              return e[l >> 2] = 12684, y = e[l + 8 >> 2], !y | !Je[l + 12 | 0] || Tr(y), l | 0;
            }
            function kc() {
              var l = 0;
              l = ro(4), e[l >> 2] = 22892, e[l >> 2] = 22364, e[l >> 2] = 22384, E2(l | 0, 22460, 5), jn();
            }
            function t1(l, y, I) {
              e: {
                if ((Je[l + 11 | 0] & 128) >>> 7 | 0) {
                  e[l + 4 >> 2] = I;
                  break e;
                }
                Se[l + 11 | 0] = I;
              }
              Se[y + I | 0] = 0;
            }
            function r1(l, y, I, C) {
              var Q = 0;
              return Q = bi - 16 | 0, bi = Q, e[Q + 12 >> 2] = C, l = Bc(l, y, I, C), bi = Q + 16 | 0, l;
            }
            function Jd(l, y) {
              var I = 0;
              return I = bi - 16 | 0, bi = I, e[I + 12 >> 2] = y, l = Eh(l, 2310, y), bi = I + 16 | 0, l;
            }
            function zd(l) {
              (l | 0) != 0 & (l | 0) != 19324 & (l | 0) != 19348 & (l | 0) != 24732 & (l | 0) != 24756 && Tr(l);
            }
            function G4(l, y) {
              l = l | 0, y = y | 0;
              var I = 0;
              I = Qd(e[y >> 2]), e[l + 4 >> 2] = e[y >> 2], Se[l | 0] = I << 24 >> 24;
            }
            function Xd(l, y) {
              l = l | 0, y = y | 0, y = bi - 16 | 0, bi = y, Se[l + 11 | 0] = 1, Se[Td(l, 1, 45) + 1 | 0] = 0, bi = y + 16 | 0;
            }
            function du(l, y, I) {
              var C = 0;
              return C = bi - 16 | 0, bi = C, ud(C + 8 | 0, y, (I << 2) + y | 0, l), bi = C + 16 | 0, l;
            }
            function $4(l, y) {
              return y = y | 0, (y | 0) >= 0 && (y = e[((y & 255) << 2) + 11184 >> 2]), y << 24 >> 24;
            }
            function Y4(l) {
              l = l | 0, l = e[6144], l && (e[6145] = l, Tr(l)), l = e[6141], l && (e[6142] = l, Tr(l));
            }
            function Zd(l, y, I) {
              var C = 0;
              return C = bi - 16 | 0, bi = C, ud(C + 8 | 0, l, y, I), bi = C + 16 | 0, e[C + 12 >> 2];
            }
            function V4(l, y) {
              return y = y | 0, (y | 0) >= 0 && (y = e[((y & 255) << 2) + 9648 >> 2]), y << 24 >> 24;
            }
            function ep(l) {
              var y = 0;
              l = e[l >> 2] - 12 | 0, y = e[l + 8 >> 2] - 1 | 0, e[l + 8 >> 2] = y, (y | 0) < 0 && Tr(l);
            }
            function Kf(l) {
              l && (Kf(e[l >> 2]), Kf(e[l + 4 >> 2]), Se[l + 27 | 0] < 0 && Tr(e[l + 16 >> 2]), Tr(l));
            }
            function W4(l) {
              for (l = l | 0, l = 26312; l = Yo(l - 12 | 0), (l | 0) != 26288; )
                ;
            }
            function J4(l) {
              for (l = l | 0, l = 26240; l = Yo(l - 12 | 0), (l | 0) != 25952; )
                ;
            }
            function z4(l) {
              for (l = l | 0, l = 25640; l = Yo(l - 12 | 0), (l | 0) != 25472; )
                ;
            }
            function X4(l) {
              for (l = l | 0, l = 26280; l = Yo(l - 12 | 0), (l | 0) != 26256; )
                ;
            }
            function Z4(l) {
              for (l = l | 0, l = 25936; l = Yo(l - 12 | 0), (l | 0) != 25648; )
                ;
            }
            function ey(l) {
              for (l = l | 0, l = 25464; l = Yo(l - 12 | 0), (l | 0) != 25296; )
                ;
            }
            function tp(l) {
              return l = l | 0, e[l >> 2] = 13768, e[l + 8 >> 2] != (fi() | 0) && zd(e[l + 8 >> 2]), l | 0;
            }
            function rp(l, y) {
              var I = 0;
              return I = e[y >> 2], e[y >> 2] = 0, _f(l, I), e[l + 4 >> 2] = e[y + 4 >> 2], l;
            }
            function ip(l) {
              var y = 0;
              y = e[l >> 2], e[y >> 2] && (Kp(y), l = e[l >> 2], fp(l + 16 | 0, e[l >> 2]));
            }
            function ty(l, y, I) {
              return y = y | 0, I = I | 0, (e[(I << 2) + 12736 >> 2] & y) != 0 & I >>> 0 <= 127;
            }
            function ry(l, y, I, C, Q, S) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, S = S | 0, Yn[l | 0](y, I, C, Q, S);
            }
            function x1(l, y) {
              return l = l | 0, y = y | 0, e[l >> 2] = 22892, e[l >> 2] = 22480, S1(l + 4 | 0, y), l | 0;
            }
            function np(l, y) {
              return l = l | 0, y = y | 0, e[l >> 2] = 22892, e[l >> 2] = 22500, S1(l + 4 | 0, y), l | 0;
            }
            function iy(l, y, I, C, Q) {
              return l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, Yn[l | 0](y, I, C, Q) | 0;
            }
            function ny(l, y) {
              l = l | 0, y = y | 0;
              var I = 0;
              I = Ud(e[y >> 2]), e[l + 4 >> 2] = e[y >> 2], e[l >> 2] = I;
            }
            function oy() {
              e[6593] = 0, e[6592] = 22008, e[6592] = 14144, e[6592] = 13768, e[6594] = fi();
            }
            function op(l) {
              for (var y = 0; ; ) {
                if (l) {
                  l = l - 1 & l, y = y + 1 | 0;
                  continue;
                }
                break;
              }
              return y;
            }
            function R1() {
              var l = 0;
              l = ro(4), e[l >> 2] = 22892, e[l >> 2] = 22364, E2(l | 0, 22448, 5), jn();
            }
            function sy(l, y, I, C) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, hc(l, e[y + 8 >> 2], 0) && g1(y, I, C);
            }
            function P1(l, y) {
              var I = 0;
              return I = l, l = (y >>> 0) / 100 | 0, Fu(Fu(I, l), No(l, -100) + y | 0);
            }
            function M1(l, y) {
              var I = 0;
              return I = l, l = (y >>> 0) / 1e4 | 0, P1(Fu(I, l), No(l, -1e4) + y | 0);
            }
            function N1(l, y) {
              var I = 0;
              return I = l, l = (y >>> 0) / 1e6 | 0, M1(Fu(I, l), No(l, -1e6) + y | 0);
            }
            function ay(l, y, I, C) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Yn[e[e[l >> 2] + 32 >> 2]](l, y, I, C) | 0;
            }
            function fy(l, y, I, C) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Yn[e[e[l >> 2] + 48 >> 2]](l, y, I, C) | 0;
            }
            function sp(l) {
              var y = 0, I = 0;
              y = bi - 16 | 0, bi = y, I = y + 12 | 0, e[I >> 2] = l, ip(I), bi = y + 16 | 0;
            }
            function cy(l, y) {
              return y = y | 0, y >>> 0 <= 127 && (y = e[(y << 2) + 11184 >> 2]), y | 0;
            }
            function uy(l, y, I) {
              return l = l | 0, y = y | 0, I = I | 0, e[y + 4 >> 2] == (l | 0) & e[y >> 2] == (I | 0);
            }
            function Ay() {
              e[6651] = 0, e[6650] = 22008, e[6650] = 14144, jp(26608), e[6650] = 16704;
            }
            function hy() {
              e[6655] = 0, e[6654] = 22008, e[6654] = 14144, jp(26624), e[6654] = 16860;
            }
            function ly(l, y) {
              return y = y | 0, y >>> 0 <= 127 && (y = e[(y << 2) + 9648 >> 2]), y | 0;
            }
            function dy(l) {
              return Je[25260] || (uh(25248, 14004), Se[25260] = 1), 25248;
            }
            function py(l) {
              return Je[25292] || (uh(25280, 14088), Se[25292] = 1), 25280;
            }
            function gy(l) {
              return Je[25196] || (uh(25184, 13932), Se[25196] = 1), 25184;
            }
            function yy(l) {
              return Je[25228] || (uh(25216, 13968), Se[25228] = 1), 25216;
            }
            function my(l, y, I) {
              return l = l | 0, y = y | 0, I = I | 0, Yn[e[e[l >> 2] + 12 >> 2]](l, y, I) | 0;
            }
            function vy(l, y, I) {
              return l = l | 0, y = y | 0, I = I | 0, Yn[e[e[l >> 2] + 48 >> 2]](l, y, I) | 0;
            }
            function wy(l) {
              return Je[25244] || (Ac(25232, 2743), Se[25244] = 1), 25232;
            }
            function Iy(l) {
              return Je[25276] || (Ac(25264, 1928), Se[25276] = 1), 25264;
            }
            function by(l) {
              return Je[25180] || (Ac(25168, 1139), Se[25180] = 1), 25168;
            }
            function Cy(l) {
              return Je[25212] || (Ac(25200, 2881), Se[25212] = 1), 25200;
            }
            function Yh(l, y, I, C, Q) {
              return I = I | 0, Q = Q | 0, e[Q >> 2] = I, 3;
            }
            function pu(l, y) {
              l = l | 0, Se[l | 0] = 2, Se[l + 1 | 0] = 3, Se[l + 2 | 0] = 0, Se[l + 3 | 0] = 4;
            }
            function Ey(l) {
              l = l | 0, e[l + 16 >> 2] = e[l + 16 >> 2] | 1, Se[l + 20 | 0] & 1 && (Ai(), jn());
            }
            function ap(l, y, I, C, Q) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Q = Q | 0, Yn[l | 0](y, I, C, Q);
            }
            function O1(l) {
              return l = l | 0, e[l + 8 >> 2] != (fi() | 0) && zd(e[l + 8 >> 2]), l | 0;
            }
            function By(l, y, I, C) {
              return l = l | 0, y = y | 0, I = I | 0, C = C | 0, Yn[l | 0](y, I, C) | 0;
            }
            function _y(l, y, I, C, Q, S) {
              l = l | 0, S = S | 0, w1(l, S);
            }
            function Qu(l, y) {
              return y ? l << 24 | (l & 65280) << 8 | (l >>> 8 & 65280 | l >>> 24) : l;
            }
            function ky(l, y, I) {
              return y = y | 0, I = I | 0, (y >>> 0 < 128 ? y : I) << 24 >> 24;
            }
            function gh(l, y) {
              l = l | 0, y = y | 0;
              var I = 0;
              I = ga(y), e[l + 4 >> 2] = y, e[l >> 2] = I;
            }
            function fp(l, y) {
              e: {
                if ((l | 0) == (y | 0)) {
                  Se[y + 120 | 0] = 0;
                  break e;
                }
                Tr(y);
              }
            }
            function Sy(l) {
              l = l | 0;
              var y = 0;
              y = e[6259] + 1 | 0, e[6259] = y, e[l + 4 >> 2] = y;
            }
            function cp(l, y) {
              return l = l | 0, y = y | 0, Yn[e[e[l >> 2] + 28 >> 2]](l, y) | 0;
            }
            function Ty(l, y) {
              return l = l | 0, y = y | 0, l = x1(l, y), e[l >> 2] = 22548, l | 0;
            }
            function Dy(l, y) {
              return l = l | 0, y = y | 0, Yn[e[e[l >> 2] + 44 >> 2]](l, y) | 0;
            }
            function xy(l, y) {
              return l = l | 0, y = y | 0, Yn[e[e[l >> 2] + 12 >> 2]](l, y) | 0;
            }
            function Ry(l) {
              return l = l | 0, l ? (Jr(l, 22200) | 0) != 0 | 0 : 0;
            }
            function Py(l) {
              return l = l | 0, l = e[l + 8 >> 2], l ? Dd(l) | 0 : 1;
            }
            function My(l, y) {
              l = l | 0, y = y | 0, e[5996] || (e[5996] = l, e[5997] = y);
            }
            function Sc(l, y) {
              l = l | 0, e[l >> 2] = 0, e[l + 4 >> 2] = 0, e[l + 8 >> 2] = 0;
            }
            function Yo(l) {
              return (Je[l + 11 | 0] & 128) >>> 7 | 0 && Tr(e[l >> 2]), l;
            }
            function up(l) {
              return l >>> 0 >= 1073741824 && (kc(), jn()), ga(l << 2);
            }
            function Ny(l, y, I, C) {
              l = l | 0, y = y | 0, I = I | 0, C = C | 0, Yn[l | 0](y, I, C);
            }
            function Ap(l) {
              return l = l | 0, e[l >> 2] = 7960, Yo(l + 32 | 0), $h(l) | 0;
            }
            function Oy(l, y, I) {
              return y = y | 0, I = I | 0, ((y | 0) < 0 ? I : y) | 0;
            }
            function Uy(l) {
              return l = l | 0, l = x1(l, 2284), e[l >> 2] = 22600, l | 0;
            }
            function Qy(l, y, I) {
              l = l | 0, y = y | 0, I = I | 0, e[l + 4 >> 2] = y, e[l >> 2] = I;
            }
            function Fy(l) {
              return l = l | 0, l = np(l, 1241), e[l >> 2] = 22684, l | 0;
            }
            function hp(l) {
              return l = l | 0, e[l >> 2] = 13856, Yo(l + 16 | 0), l | 0;
            }
            function lp(l) {
              return l = l | 0, e[l >> 2] = 13816, Yo(l + 12 | 0), l | 0;
            }
            function U1(l) {
              return l = l | 0, e[l >> 2] = 22500, ep(l + 4 | 0), l | 0;
            }
            function dp(l) {
              return l = l | 0, e[l >> 2] = 22480, ep(l + 4 | 0), l | 0;
            }
            function Fu(l, y) {
              return y = (y << 1) + 21664 | 0, Zd(y, y + 2 | 0, l);
            }
            function Ly(l) {
              return l = l | 0, F1(e[e[l >> 2] - 12 >> 2] + l | 0) | 0;
            }
            function pp(l, y) {
              l = l | 0, y = y | 0, Yn[e[e[y >> 2] + 24 >> 2]](l, y);
            }
            function gp(l, y) {
              l = l | 0, y = y | 0, Yn[e[e[y >> 2] + 28 >> 2]](l, y);
            }
            function qy(l) {
              return l = l | 0, Zl(e[e[l >> 2] - 12 >> 2] + l | 0) | 0;
            }
            function yp(l, y) {
              l = l | 0, y = y | 0, Yn[e[e[y >> 2] + 20 >> 2]](l, y);
            }
            function Hy(l) {
              l = l | 0, l && (l = l - 24 | 0, e[l >> 2] = e[l >> 2] + 1);
            }
            function Ky(l, y, I, C) {
              l = l | 0, I = I | 0, C = C | 0, as(l, I, C);
            }
            function jy(l, y, I, C) {
              l = l | 0, I = I | 0, C = C | 0, Ou(l, I, C);
            }
            function yh(l, y) {
              var I = 0;
              I = up(y), e[l + 4 >> 2] = y, e[l >> 2] = I;
            }
            function Gy(l) {
              return l = l | 0, Yn[e[e[l >> 2] + 24 >> 2]](l) | 0;
            }
            function mp(l, y, I) {
              return l = wA(l, y, I, 0, -2147483648), l;
            }
            function vp(l) {
              return l = l | 0, Yn[e[e[l >> 2] + 16 >> 2]](l) | 0;
            }
            function wp(l) {
              return l = l | 0, Yn[e[e[l >> 2] + 12 >> 2]](l) | 0;
            }
            function Ip(l, y) {
              return l = l | 0, y = y | 0, A1(l, y, Jf(y)) | 0;
            }
            function Tc(l, y) {
              return l = l | 0, y = y | 0, vd(l) ^ vd(y) ^ 1;
            }
            function Dc(l, y) {
              return l = l | 0, y = y | 0, md(l) ^ md(y) ^ 1;
            }
            function $y(l) {
              Se[24003] < 0 && Tr(e[5998]);
            }
            function Yy(l) {
              return l = l | 0, l = bi - l & -16, bi = l, l | 0;
            }
            function bp(l, y) {
              return l ? sf(l, y) : 0;
            }
            function Vy(l, y, I) {
              return l = l | 0, l | 0;
            }
            function gu(l, y, I) {
              return Ss(18, l | 0, y | 0, I | 0) | 0;
            }
            function Cp(l, y, I) {
              return -1;
            }
            function Wy(l) {
              l = l | 0, Qp(e[e[l >> 2] - 12 >> 2] + l | 0);
            }
            function Ep(l, y, I) {
              return l = wA(l, y, I, -1, -1), l;
            }
            function Jy(l) {
              l = l | 0, Lp(e[e[l >> 2] - 12 >> 2] + l | 0);
            }
            function i1(l, y, I, C) {
              Jo(152, l | 0, y | 0, I | 0, C | 0);
            }
            function Bp(l, y, I, C) {
              $o(155, l | 0, y | 0, I | 0, C | 0);
            }
            function zy(l) {
              return l = l | 0, e[l >> 2] = 7e3, l | 0;
            }
            function Xy(l) {
              l = l | 0, Yn[e[e[l >> 2] + 4 >> 2]](l);
            }
            function mh(l) {
              return l = l | 0, Qd(e[l >> 2]), l | 0;
            }
            function vh(l) {
              return l = l | 0, Ud(e[l >> 2]), l | 0;
            }
            function Zy(l) {
              l = l | 0, Qa(l, 26616, Fi(24916));
            }
            function e6(l) {
              l = l | 0, Qa(l, 26632, Fi(24988));
            }
            function t6(l) {
              l = l | 0, Qa(l, 26640, Fi(24996));
            }
            function r6(l) {
              l = l | 0, Qa(l, 26320, Fi(24844));
            }
            function i6(l) {
              l = l | 0, Qa(l, 26328, Fi(24852));
            }
            function n6(l) {
              l = l | 0, Qa(l, 26352, Fi(25040));
            }
            function o6(l) {
              l = l | 0, Qa(l, 26360, Fi(25056));
            }
            function s6(l) {
              l = l | 0, Qa(l, 26368, Fi(25064));
            }
            function a6(l) {
              l = l | 0, Qa(l, 26384, Fi(25072));
            }
            function f6(l) {
              l = l | 0, Qa(l, 26392, Fi(25088));
            }
            function c6(l) {
              l = l | 0, Qa(l, 26400, Fi(25080));
            }
            function u6(l) {
              l = l | 0, Qa(l, 26408, Fi(25096));
            }
            function A6(l) {
              l = l | 0, Qa(l, 26416, Fi(25104));
            }
            function h6(l) {
              l = l | 0, Qa(l, 26440, Fi(25112));
            }
            function l6(l) {
              l = l | 0, Qa(l, 26472, Fi(24860));
            }
            function d6(l) {
              l = l | 0, Qa(l, 26480, Fi(24868));
            }
            function p6(l) {
              l = l | 0, Qa(l, 26488, Fi(24876));
            }
            function g6(l) {
              l = l | 0, Qa(l, 26496, Fi(24884));
            }
            function y6(l) {
              l = l | 0, Qa(l, 26504, Fi(24924));
            }
            function m6(l) {
              l = l | 0, Qa(l, 26512, Fi(24932));
            }
            function v6(l) {
              l = l | 0, Qa(l, 26520, Fi(24940));
            }
            function w6(l) {
              l = l | 0, Qa(l, 26528, Fi(24948));
            }
            function I6(l) {
              l = l | 0, Qa(l, 26536, Fi(24956));
            }
            function b6(l) {
              l = l | 0, Qa(l, 26544, Fi(24964));
            }
            function C6(l) {
              l = l | 0, Qa(l, 26552, Fi(24972));
            }
            function E6(l) {
              l = l | 0, Qa(l, 26560, Fi(24980));
            }
            function B6(l) {
              l = l | 0, Qa(l, 26568, Fi(24892));
            }
            function _6(l) {
              l = l | 0, Qa(l, 26584, Fi(24900));
            }
            function k6(l) {
              l = l | 0, Qa(l, 26600, Fi(24908));
            }
            function S6(l) {
              l = l | 0, Qa(l, 26336, Fi(25048));
            }
            function Q1(l) {
              return l = l | 0, nu(l, 25048) | 0;
            }
            function F1(l) {
              return l = l | 0, Y1(l + 4 | 0), l | 0;
            }
            function L1(l) {
              return l = l | 0, nu(l, 25040) | 0;
            }
            function T6(l) {
              return l = l | 0, nu(l, 24876) | 0;
            }
            function Gc(l, y, I) {
              return Zd(y, y + I | 0, l), l;
            }
            function q1(l) {
              return l = l | 0, nu(l, 25104) | 0;
            }
            function H1(l) {
              return l = l | 0, nu(l, 25112) | 0;
            }
            function D6(l, y) {
              l = l | 0, y = y | 0, w1(l, y + 16 | 0);
            }
            function x6(l, y) {
              l = l | 0, y = y | 0, w1(l, y + 12 | 0);
            }
            function R6(l, y) {
              l = l | 0, uh(l, 13888);
            }
            function P6(l, y) {
              l = l | 0, uh(l, 13908);
            }
            function _p(l, y) {
              return y = y | 0, y | 0;
            }
            function kp(l, y) {
              l = l | 0, Bf(l, 1, 45);
            }
            function K1(l, y, I) {
              return l = Ep(l, y, I), l;
            }
            function Sp(l, y, I) {
              return l = mp(l, y, I), l;
            }
            function M6(l, y) {
              l = l | 0, Ac(l, 2331);
            }
            function N6(l, y) {
              l = l | 0, Ac(l, 2350);
            }
            function n1(l) {
              return 2147483647;
            }
            function O6(l) {
              return l = l | 0, e[l + 12 >> 2];
            }
            function vf(l) {
              return l = l | 0, Su(8, l) | 0;
            }
            function U6(l) {
              return l = l | 0, e[l + 8 >> 2];
            }
            function Tp(l, y) {
              return -1;
            }
            function Dp(l) {
              return l = l | 0, e[l + 4 >> 2];
            }
            function Q6(l, y) {
              return 0;
            }
            function F6(l) {
              return l = l | 0, Se[l + 8 | 0];
            }
            function L6(l) {
              return l = l | 0, Se[l + 9 | 0];
            }
            function yu(l, y, I) {
              return ve(l, y, I);
            }
            function xp(l) {
              return l = l | 0, U1(l) | 0;
            }
            function Rp(l) {
              Je[l + 4 | 0] || ip(l);
            }
            function Pp(l) {
              return nu(l, 24932);
            }
            function Mp(l) {
              return nu(l, 24924);
            }
            function Np(l) {
              return nu(l, 24948);
            }
            function Up(l) {
              return nu(l, 24940);
            }
            function q6(l) {
              return 2176;
            }
            function H6(l) {
              return 1304;
            }
            function K6(l) {
              return 2042;
            }
            function j6(l) {
              return 1969;
            }
            function G6(l) {
              return 2524;
            }
            function o1(l) {
              return 127;
            }
            function $c(l) {
              return l = l | 0, l | 0;
            }
            function Qp(l) {
              l = l | 0, Tr(F1(l));
            }
            function s1(l) {
              l = l | 0, Tr(U1(l));
            }
            function $6(l) {
              Yo(25248);
            }
            function Y6(l) {
              Yo(25280);
            }
            function V6(l) {
              l = l | 0, Tr(Wd(l));
            }
            function Lp(l) {
              l = l | 0, Tr(Zl(l));
            }
            function W6(l) {
              Yo(25184);
            }
            function J6(l) {
              Yo(25216);
            }
            function z6(l) {
              l = l | 0, Tr(od(l));
            }
            function X6(l) {
              Yo(25232);
            }
            function Z6(l) {
              l = l | 0, Tr(Ap(l));
            }
            function e8(l) {
              Yo(25168);
            }
            function t8(l) {
              Yo(25200);
            }
            function qp(l) {
              l = l | 0, Tr(O1(l));
            }
            function r8(l) {
              l = l | 0, Tr(hp(l));
            }
            function i8(l) {
              l = l | 0, Tr(p1(l));
            }
            function n8(l) {
              l = l | 0, Tr(lp(l));
            }
            function o8(l) {
              l = l | 0, Tr(tp(l));
            }
            function j1(l) {
              l = l | 0, Tr(dp(l));
            }
            function s8(l) {
              l = l | 0, Tr($h(l));
            }
            function a8(l) {
              Yo(25264);
            }
            function f8(l) {
              return -1;
            }
            function a1(l) {
              return 4;
            }
            function G1(l) {
              return 1;
            }
            function oc(l) {
              return 0;
            }
            function Hp(l) {
              return 2;
            }
            function $1(l, y) {
            }
            function Kp(l) {
              Yd(l, e[l >> 2]);
            }
            function jp(l) {
              e[l >> 2] = fi();
            }
            function xf() {
              kd(2284), jn();
            }
            function tf() {
              kd(1687), jn();
            }
            function za(l) {
              l = l | 0, Tr(l);
            }
            function c8(l) {
              l = l | 0, Ia = l;
            }
            function u8() {
              return bi | 0;
            }
            function A8(l) {
              l = l | 0, bi = l;
            }
            function h8(l) {
              jn();
            }
            function ka(l) {
              _f(l, 0);
            }
            function l8() {
              Gp(), jn();
            }
            function Gp() {
              pc(), jn();
            }
            function Y1(l) {
              p1(l);
            }
            function V1(l) {
            }
            Lo = Je, Xs();
            var Yn = ts([null, $y, xf, ga, D4, $c, Ty, dp, tf, ag, kg, tf, Ul, Qg, Fg, qg, Vg, x1, Al, Sf, Sg, Dg, Rg, Mg, Og, A4, io, Fc, Cs, Ku, Ac, Uh, Mu, vn, tf, kc, Vs, cl, fg, ks, Yl, tf, ug, al, Nf, Qc, rl, tf, jl, qo, Dh, ul, tf, ll, Mr, pA, tf, gc, Y4, tf, xl, Rc, tf, Yu, mc, Ql, Ol, Lg, Eg, Fl, Hg, Kg, jg, Gg, $g, Yg, Wg, Jg, zg, Xg, Zg, e4, t4, r4, tf, tf, ol, zc, Zh, Oh, tl, np, U1, tf, tf, tf, tf, Ip, yg, us, A1, Qh, sc, Tg, xg, Pg, Ng, Ug, I1, au, $a, wh, tf, Jh, E, $f, tg, ju, sg, Zc, zp, tf, zh, tf, D2, Uy, Pl, Tn, $u, Sh, vg, Qf, Ig, _4, M, T6, Is, j4, fh, Ey, Wh, Xh, tf, _s, ti, is, ws, Ba, ye, hg, s4, g4, sA, Rl, as, _g, ic, qh, Ps, Hl, k, Zr, ti, vc, $f, Jc, Fd, Fy, T4, Gy, Q1, cp, Ff, $c, nc, L4, Ds, xp, i4, rg, q1, pp, gp, Cc, za, R1, Tc, x4, xy, mh, Sy, Q4, Ai, vp, yp, ay, wp, L1, H1, pp, gp, _u, Dc, O4, cp, vh, vp, yp, fy, wp, Hd, Tl, Rh, Ne, hd, eu, Dy, vy, fa, ai, V1, Gu, Bd, Ra, G4, ig, Z1, pr, nl, Js, my, ny, gg, Z1, T, Xp, Nl, vl, Ml, ml, r6, i6, S6, n6, o6, oy, s6, a6, f6, c6, u6, A6, h6, l6, d6, p6, g6, y6, m6, v6, w6, I6, b6, C6, E6, B6, _6, Ay, k6, hy, Zy, e6, t6, u4, Wu, z4, J4, W4, $6, Y6, W6, J6, ey, Z4, X4, X6, a8, e8, t8, gh, U4, Gp, zy, za, Rs, Q6, za, $h, s8, $1, Vy, F4, K4, oc, oc, Ys, f8, P4, Tp, Wp, Tp, Ap, Z6, ql, q4, dg, Jp, Ll, Zl, Lp, qy, Jy, F1, Qp, Ly, Wy, $c, za, K6, Qy, I4, uy, cf, s1, Dp, p1, i8, od, z6, Xy, Wd, V6, $4, b4, V4, E4, _p, M4, Oy, C4, tp, o8, Wa, wl, Ag, c4, oc, Zp, Py, lp, n8, F6, L6, x6, M6, N6, hp, r8, U6, O6, D6, R6, P6, $c, za, za, ty, o4, f4, a4, cy, y4, ly, m4, _p, R4, ky, w4, za, Gd, Gd, Yh, G1, G1, d4, G1, za, dA, Ru, Yh, oc, oc, oh, a1, za, dA, Ru, Yh, oc, oc, oh, a1, za, Fh, tu, Yh, oc, oc, pf, a1, za, Fh, tu, Yh, oc, oc, pf, a1, $c, za, mg, Ky, p4, $c, za, wg, jy, l4, za, Nh, Sl, _l, eA, cu, cu, kl, Lc, ku, Ju, gl, za, Dl, Tu, El, Du, fu, fu, Bl, bl, Cl, ao, yl, za, Af, go, Xi, qn, $n, xu, zu, Qo, za, Nu, wo, Ni, bo, Yi, Mh, Xu, Ln, $c, za, Hp, n4, Bg, xa, Ka, yf, fl, cg, Ns, S4, wy, Iy, by, Cy, $c, za, Hp, lg, Cg, nf, of, Df, Th, og, es, k4, dy, py, gy, yy, O1, qp, Eo, O1, qp, ah, za, o1, o1, Sc, Sc, Sc, Xd, oc, pu, pu, za, o1, o1, Sc, Sc, Sc, Xd, oc, pu, pu, za, n1, n1, Sc, Sc, Sc, kp, oc, pu, pu, za, n1, n1, Sc, Sc, Sc, kp, oc, pu, pu, za, Il, lA, za, Vu, ac, za, pl, Bu, za, dl, Ca, za, Cp, _y, $1, za, Cp, ra, $1, xp, s1, $c, h8, l8, pc, $c, za, V1, V1, ng, Zn, fc, pg, za, G6, za, q6, j1, Dp, s1, j1, j1, s1, za, H6, za, H4, eg, sy, za, B4, ci, N4, za, j6]);
            function d8() {
              return Va.byteLength / 65536 | 0;
            }
            return { Y: el, Z: za, _: vf, $: Ih, aa: il, ba: Yn, ca: My, da: c8, ea: u8, fa: A8, ga: Yy, ha: bg, ia: Hy, ja: h4, ka: Ry, la: By, ma: Ny, na: ap, oa: ap, pa: ry, qa: iy };
          }
          return ba(Uo);
        }(po);
      }, instantiate: function(Ao, po) {
        return { then: function(_o) {
          var Uo = new He.Module(Ao);
          _o({ instance: new He.Instance(Uo, po) });
        } };
      }, RuntimeError: Error };
      be = [], typeof He != "object" && Hr("no native wasm support detected");
      var Pe, nr = !1;
      function ir(Ao, po) {
        Ao || Hr(po);
      }
      var or, lr, Ir, xr;
      function kr() {
        var Ao = Pe.buffer;
        A.HEAP8 = or = new Int8Array(Ao), A.HEAP16 = new Int16Array(Ao), A.HEAPU8 = lr = new Uint8Array(Ao), A.HEAPU16 = new Uint16Array(Ao), A.HEAP32 = Ir = new Int32Array(Ao), A.HEAPU32 = xr = new Uint32Array(Ao), A.HEAPF32 = new Float32Array(Ao), A.HEAPF64 = new Float64Array(Ao);
      }
      var Ce = A.INITIAL_MEMORY || 16777216;
      ir(Ce >= 65536, "INITIAL_MEMORY should be larger than STACK_SIZE, was " + Ce + "! (STACK_SIZE=65536)"), A.wasmMemory ? Pe = A.wasmMemory : Pe = new He.Memory({ initial: Ce / 65536, maximum: Ce / 65536 }), kr(), Ce = Pe.buffer.byteLength;
      var tr, Fe = [], Sr = [], er = [];
      function Ie() {
        if (A.preRun)
          for (typeof A.preRun == "function" && (A.preRun = [A.preRun]); A.preRun.length; )
            ar(A.preRun.shift());
        mn(Fe);
      }
      function xe() {
        mn(Sr);
      }
      function rr() {
        if (A.postRun)
          for (typeof A.postRun == "function" && (A.postRun = [A.postRun]); A.postRun.length; )
            _r(A.postRun.shift());
        mn(er);
      }
      function ar(Ao) {
        Fe.unshift(Ao);
      }
      function yr(Ao) {
        Sr.unshift(Ao);
      }
      function _r(Ao) {
        er.unshift(Ao);
      }
      var Or = 0, vr = null;
      function Te(Ao) {
        Or++, A.monitorRunDependencies && A.monitorRunDependencies(Or);
      }
      function Cr(Ao) {
        if (Or--, A.monitorRunDependencies && A.monitorRunDependencies(Or), Or == 0 && vr) {
          var po = vr;
          vr = null, po();
        }
      }
      function Hr(Ao) {
        A.onAbort && A.onAbort(Ao), Ao = "Aborted(" + Ao + ")", Ee(Ao), nr = !0, Ao += ". Build with -sASSERTIONS for more info.";
        var po = new He.RuntimeError(Ao);
        throw F(po), po;
      }
      var si = "data:application/octet-stream;base64,";
      function ui(Ao) {
        return Ao.startsWith(si);
      }
      var Li;
      Li = "bindings.wasm", ui(Li) || (Li = $(Li));
      function Qi(Ao) {
        if (Ao == Li && be)
          return new Uint8Array(be);
        var po = ns(Ao);
        if (po)
          return po;
        throw "sync fetching of the wasm failed: you can preload it to Module['wasmBinary'] manually, or emcc.py will do that for you when generating HTML (but not JS)";
      }
      function wi(Ao, po) {
        var _o, Uo = Qi(Ao);
        _o = new He.Module(Uo);
        var ts = new He.Instance(_o, po);
        return [ts, _o];
      }
      function Ji() {
        var Ao = { a: vi };
        function po(Uo, ts) {
          var Lo = Uo.exports;
          return xi = Lo, tr = xi.ba, yr(xi.Y), Cr(), Lo;
        }
        if (Te(), A.instantiateWasm)
          try {
            return A.instantiateWasm(Ao, po);
          } catch (Uo) {
            Ee(`Module.instantiateWasm callback failed with error: ${Uo}`), F(Uo);
          }
        var _o = wi(Li, Ao);
        return po(_o[0]);
      }
      var mn = (Ao) => {
        for (; Ao.length > 0; )
          Ao.shift()(A);
      }, pi = typeof TextDecoder < "u" ? new TextDecoder("utf8") : void 0, ei = (Ao, po, _o) => {
        for (var Uo = po + _o, ts = po; Ao[ts] && !(ts >= Uo); ) ++ts;
        if (ts - po > 16 && Ao.buffer && pi)
          return pi.decode(Ao.subarray(po, ts));
        for (var Lo = ""; po < ts; ) {
          var Wo = Ao[po++];
          if (!(Wo & 128)) {
            Lo += String.fromCharCode(Wo);
            continue;
          }
          var ps = Ao[po++] & 63;
          if ((Wo & 224) == 192) {
            Lo += String.fromCharCode((Wo & 31) << 6 | ps);
            continue;
          }
          var Bs = Ao[po++] & 63;
          if ((Wo & 240) == 224 ? Wo = (Wo & 15) << 12 | ps << 6 | Bs : Wo = (Wo & 7) << 18 | ps << 12 | Bs << 6 | Ao[po++] & 63, Wo < 65536)
            Lo += String.fromCharCode(Wo);
          else {
            var Xs = Wo - 65536;
            Lo += String.fromCharCode(55296 | Xs >> 10, 56320 | Xs & 1023);
          }
        }
        return Lo;
      }, Vr = (Ao, po) => Ao ? ei(lr, Ao, po) : "", qr = (Ao, po, _o, Uo) => {
        Hr(`Assertion failed: ${Vr(Ao)}, at: ` + [po ? Vr(po) : "unknown filename", _o, Uo ? Vr(Uo) : "unknown function"]);
      }, Zi = [], Wr = 0, ri = (Ao) => {
        var po = new Di(Ao);
        return po.get_caught() || (po.set_caught(!0), Wr--), po.set_rethrown(!1), Zi.push(po), Cn(po.excPtr), po.get_exception_ptr();
      }, _i = 0, Er = () => {
        Lr(0, 0);
        var Ao = Zi.pop();
        ji(Ao.excPtr), _i = 0;
      };
      function Di(Ao) {
        this.excPtr = Ao, this.ptr = Ao - 24, this.set_type = function(po) {
          xr[this.ptr + 4 >> 2] = po;
        }, this.get_type = function() {
          return xr[this.ptr + 4 >> 2];
        }, this.set_destructor = function(po) {
          xr[this.ptr + 8 >> 2] = po;
        }, this.get_destructor = function() {
          return xr[this.ptr + 8 >> 2];
        }, this.set_caught = function(po) {
          po = po ? 1 : 0, or[this.ptr + 12 >> 0] = po;
        }, this.get_caught = function() {
          return or[this.ptr + 12 >> 0] != 0;
        }, this.set_rethrown = function(po) {
          po = po ? 1 : 0, or[this.ptr + 13 >> 0] = po;
        }, this.get_rethrown = function() {
          return or[this.ptr + 13 >> 0] != 0;
        }, this.init = function(po, _o) {
          this.set_adjusted_ptr(0), this.set_type(po), this.set_destructor(_o);
        }, this.set_adjusted_ptr = function(po) {
          xr[this.ptr + 16 >> 2] = po;
        }, this.get_adjusted_ptr = function() {
          return xr[this.ptr + 16 >> 2];
        }, this.get_exception_ptr = function() {
          var po = B(this.get_type());
          if (po)
            return xr[this.excPtr >> 2];
          var _o = this.get_adjusted_ptr();
          return _o !== 0 ? _o : this.excPtr;
        };
      }
      var _n = (Ao) => {
        throw _i || (_i = Ao), _i;
      }, On = (Ao) => {
        var po = _i;
        if (!po)
          return dn(0), 0;
        var _o = new Di(po);
        _o.set_adjusted_ptr(po);
        var Uo = _o.get_type();
        if (!Uo)
          return dn(0), po;
        for (var ts in Ao) {
          var Lo = Ao[ts];
          if (Lo === 0 || Lo === Uo)
            break;
          var Wo = _o.ptr + 16;
          if (Mn(Lo, Uo, Wo))
            return dn(Lo), po;
        }
        return dn(Uo), po;
      }, so = () => On([]), Do = (Ao) => On([Ao]), gn = (Ao, po) => On([Ao, po]), Gn = () => {
        var Ao = Zi.pop();
        Ao || Hr("no exception to throw");
        var po = Ao.excPtr;
        throw Ao.get_rethrown() || (Zi.push(Ao), Ao.set_rethrown(!0), Ao.set_caught(!1), Wr++), _i = po, _i;
      }, pn = (Ao, po, _o) => {
        var Uo = new Di(Ao);
        throw Uo.init(po, _o), _i = Ao, Wr++, _i;
      }, hn = () => Wr, Rn = () => {
        Hr("");
      }, vo = (Ao, po, _o) => lr.copyWithin(Ao, po, po + _o), Hi = (Ao) => {
        Hr("OOM");
      }, di = (Ao) => {
        lr.length, Hi();
      }, Ui = {}, ln = () => L || "./this.program", Un = () => {
        if (!Un.strings) {
          var Ao = (typeof navigator == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8", po = { USER: "web_user", LOGNAME: "web_user", PATH: "/", PWD: "/", HOME: "/home/web_user", LANG: Ao, _: ln() };
          for (var _o in Ui)
            Ui[_o] === void 0 ? delete po[_o] : po[_o] = Ui[_o];
          var Uo = [];
          for (var _o in po)
            Uo.push(`${_o}=${po[_o]}`);
          Un.strings = Uo;
        }
        return Un.strings;
      }, Bo = (Ao, po) => {
        for (var _o = 0; _o < Ao.length; ++_o)
          or[po++ >> 0] = Ao.charCodeAt(_o);
        or[po >> 0] = 0;
      }, co = (Ao, po) => {
        var _o = 0;
        return Un().forEach((Uo, ts) => {
          var Lo = po + _o;
          xr[Ao + ts * 4 >> 2] = Lo, Bo(Uo, Lo), _o += Uo.length + 1;
        }), 0;
      }, To = (Ao, po) => {
        var _o = Un();
        xr[Ao >> 2] = _o.length;
        var Uo = 0;
        return _o.forEach((ts) => Uo += ts.length + 1), xr[po >> 2] = Uo, 0;
      }, xs = (Ao) => Ao, Fo = (Ao) => Ao % 4 === 0 && (Ao % 100 !== 0 || Ao % 400 === 0), Zo = (Ao, po) => {
        for (var _o = 0, Uo = 0; Uo <= po; _o += Ao[Uo++])
          ;
        return _o;
      }, $s = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], rs = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], ls = (Ao, po) => {
        for (var _o = new Date(Ao.getTime()); po > 0; ) {
          var Uo = Fo(_o.getFullYear()), ts = _o.getMonth(), Lo = (Uo ? $s : rs)[ts];
          if (po > Lo - _o.getDate())
            po -= Lo - _o.getDate() + 1, _o.setDate(1), ts < 11 ? _o.setMonth(ts + 1) : (_o.setMonth(0), _o.setFullYear(_o.getFullYear() + 1));
          else
            return _o.setDate(_o.getDate() + po), _o;
        }
        return _o;
      }, na = (Ao) => {
        for (var po = 0, _o = 0; _o < Ao.length; ++_o) {
          var Uo = Ao.charCodeAt(_o);
          Uo <= 127 ? po++ : Uo <= 2047 ? po += 2 : Uo >= 55296 && Uo <= 57343 ? (po += 4, ++_o) : po += 3;
        }
        return po;
      }, os = (Ao, po, _o, Uo) => {
        if (!(Uo > 0)) return 0;
        for (var ts = _o, Lo = _o + Uo - 1, Wo = 0; Wo < Ao.length; ++Wo) {
          var ps = Ao.charCodeAt(Wo);
          if (ps >= 55296 && ps <= 57343) {
            var Bs = Ao.charCodeAt(++Wo);
            ps = 65536 + ((ps & 1023) << 10) | Bs & 1023;
          }
          if (ps <= 127) {
            if (_o >= Lo) break;
            po[_o++] = ps;
          } else if (ps <= 2047) {
            if (_o + 1 >= Lo) break;
            po[_o++] = 192 | ps >> 6, po[_o++] = 128 | ps & 63;
          } else if (ps <= 65535) {
            if (_o + 2 >= Lo) break;
            po[_o++] = 224 | ps >> 12, po[_o++] = 128 | ps >> 6 & 63, po[_o++] = 128 | ps & 63;
          } else {
            if (_o + 3 >= Lo) break;
            po[_o++] = 240 | ps >> 18, po[_o++] = 128 | ps >> 12 & 63, po[_o++] = 128 | ps >> 6 & 63, po[_o++] = 128 | ps & 63;
          }
        }
        return po[_o] = 0, _o - ts;
      };
      function fs(Ao, po, _o) {
        var Uo = na(Ao) + 1, ts = new Array(Uo);
        return os(Ao, ts, 0, ts.length), ts;
      }
      var da = (Ao, po) => {
        or.set(Ao, po);
      }, Bn = (Ao, po, _o, Uo) => {
        var ts = xr[Uo + 40 >> 2], Lo = { tm_sec: Ir[Uo >> 2], tm_min: Ir[Uo + 4 >> 2], tm_hour: Ir[Uo + 8 >> 2], tm_mday: Ir[Uo + 12 >> 2], tm_mon: Ir[Uo + 16 >> 2], tm_year: Ir[Uo + 20 >> 2], tm_wday: Ir[Uo + 24 >> 2], tm_yday: Ir[Uo + 28 >> 2], tm_isdst: Ir[Uo + 32 >> 2], tm_gmtoff: Ir[Uo + 36 >> 2], tm_zone: ts ? Vr(ts) : "" }, Wo = Vr(_o), ps = { "%c": "%a %b %d %H:%M:%S %Y", "%D": "%m/%d/%y", "%F": "%Y-%m-%d", "%h": "%b", "%r": "%I:%M:%S %p", "%R": "%H:%M", "%T": "%H:%M:%S", "%x": "%m/%d/%y", "%X": "%H:%M:%S", "%Ec": "%c", "%EC": "%C", "%Ex": "%m/%d/%y", "%EX": "%H:%M:%S", "%Ey": "%y", "%EY": "%Y", "%Od": "%d", "%Oe": "%e", "%OH": "%H", "%OI": "%I", "%Om": "%m", "%OM": "%M", "%OS": "%S", "%Ou": "%u", "%OU": "%U", "%OV": "%V", "%Ow": "%w", "%OW": "%W", "%Oy": "%y" };
        for (var Bs in ps)
          Wo = Wo.replace(new RegExp(Bs, "g"), ps[Bs]);
        var Xs = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], js = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        function ya(jn, ta, Na) {
          for (var ba = typeof jn == "number" ? jn.toString() : jn || ""; ba.length < ta; )
            ba = Na[0] + ba;
          return ba;
        }
        function sa(jn, ta) {
          return ya(jn, ta, "0");
        }
        function va(jn, ta) {
          function Na(Aa) {
            return Aa < 0 ? -1 : Aa > 0 ? 1 : 0;
          }
          var ba;
          return (ba = Na(jn.getFullYear() - ta.getFullYear())) === 0 && (ba = Na(jn.getMonth() - ta.getMonth())) === 0 && (ba = Na(jn.getDate() - ta.getDate())), ba;
        }
        function oa(jn) {
          switch (jn.getDay()) {
            case 0:
              return new Date(jn.getFullYear() - 1, 11, 29);
            case 1:
              return jn;
            case 2:
              return new Date(jn.getFullYear(), 0, 3);
            case 3:
              return new Date(jn.getFullYear(), 0, 2);
            case 4:
              return new Date(jn.getFullYear(), 0, 1);
            case 5:
              return new Date(jn.getFullYear() - 1, 11, 31);
            case 6:
              return new Date(jn.getFullYear() - 1, 11, 30);
          }
        }
        function wa(jn) {
          var ta = ls(new Date(jn.tm_year + 1900, 0, 1), jn.tm_yday), Na = new Date(ta.getFullYear(), 0, 4), ba = new Date(ta.getFullYear() + 1, 0, 4), Aa = oa(Na), zs = oa(ba);
          return va(Aa, ta) <= 0 ? va(zs, ta) <= 0 ? ta.getFullYear() + 1 : ta.getFullYear() : ta.getFullYear() - 1;
        }
        var Pa = { "%a": (jn) => Xs[jn.tm_wday].substring(0, 3), "%A": (jn) => Xs[jn.tm_wday], "%b": (jn) => js[jn.tm_mon].substring(0, 3), "%B": (jn) => js[jn.tm_mon], "%C": (jn) => {
          var ta = jn.tm_year + 1900;
          return sa(ta / 100 | 0, 2);
        }, "%d": (jn) => sa(jn.tm_mday, 2), "%e": (jn) => ya(jn.tm_mday, 2, " "), "%g": (jn) => wa(jn).toString().substring(2), "%G": (jn) => wa(jn), "%H": (jn) => sa(jn.tm_hour, 2), "%I": (jn) => {
          var ta = jn.tm_hour;
          return ta == 0 ? ta = 12 : ta > 12 && (ta -= 12), sa(ta, 2);
        }, "%j": (jn) => sa(jn.tm_mday + Zo(Fo(jn.tm_year + 1900) ? $s : rs, jn.tm_mon - 1), 3), "%m": (jn) => sa(jn.tm_mon + 1, 2), "%M": (jn) => sa(jn.tm_min, 2), "%n": () => `
`, "%p": (jn) => jn.tm_hour >= 0 && jn.tm_hour < 12 ? "AM" : "PM", "%S": (jn) => sa(jn.tm_sec, 2), "%t": () => "	", "%u": (jn) => jn.tm_wday || 7, "%U": (jn) => {
          var ta = jn.tm_yday + 7 - jn.tm_wday;
          return sa(Math.floor(ta / 7), 2);
        }, "%V": (jn) => {
          var ta = Math.floor((jn.tm_yday + 7 - (jn.tm_wday + 6) % 7) / 7);
          if ((jn.tm_wday + 371 - jn.tm_yday - 2) % 7 <= 2 && ta++, ta) {
            if (ta == 53) {
              var ba = (jn.tm_wday + 371 - jn.tm_yday) % 7;
              ba != 4 && (ba != 3 || !Fo(jn.tm_year)) && (ta = 1);
            }
          } else {
            ta = 52;
            var Na = (jn.tm_wday + 7 - jn.tm_yday - 1) % 7;
            (Na == 4 || Na == 5 && Fo(jn.tm_year % 400 - 1)) && ta++;
          }
          return sa(ta, 2);
        }, "%w": (jn) => jn.tm_wday, "%W": (jn) => {
          var ta = jn.tm_yday + 7 - (jn.tm_wday + 6) % 7;
          return sa(Math.floor(ta / 7), 2);
        }, "%y": (jn) => (jn.tm_year + 1900).toString().substring(2), "%Y": (jn) => jn.tm_year + 1900, "%z": (jn) => {
          var ta = jn.tm_gmtoff, Na = ta >= 0;
          return ta = Math.abs(ta) / 60, ta = ta / 60 * 100 + ta % 60, (Na ? "+" : "-") + ("0000" + ta).slice(-4);
        }, "%Z": (jn) => jn.tm_zone, "%%": () => "%" };
        Wo = Wo.replace(/%%/g, "\0\0");
        for (var Bs in Pa)
          Wo.includes(Bs) && (Wo = Wo.replace(new RegExp(Bs, "g"), Pa[Bs](Lo)));
        Wo = Wo.replace(/\0\0/g, "%");
        var Ta = fs(Wo);
        return Ta.length > po ? 0 : (da(Ta, Ao), Ta.length - 1);
      }, hi = (Ao, po, _o, Uo, ts) => Bn(Ao, po, _o, Uo), Ii = [], Gi = (Ao) => {
        var po = Ii[Ao];
        return po || (Ao >= Ii.length && (Ii.length = Ao + 1), Ii[Ao] = po = tr.get(Ao)), po;
      }, kn = (Ao) => {
        var po = A["_" + Ao];
        return po;
      }, ho = (Ao, po, _o) => os(Ao, lr, po, _o), eo = (Ao) => {
        var po = na(Ao) + 1, _o = Yr(po);
        return ho(Ao, _o, po), _o;
      }, Ei = (Ao, po, _o, Uo, ts) => {
        var Lo = { string: (oa) => {
          var wa = 0;
          return oa != null && oa !== 0 && (wa = eo(oa)), wa;
        }, array: (oa) => {
          var wa = Yr(oa.length);
          return da(oa, wa), wa;
        } };
        function Wo(oa) {
          return po === "string" ? Vr(oa) : po === "boolean" ? !!oa : oa;
        }
        var ps = kn(Ao), Bs = [], Xs = 0;
        if (Uo)
          for (var js = 0; js < Uo.length; js++) {
            var ya = Lo[_o[js]];
            ya ? (Xs === 0 && (Xs = xn()), Bs[js] = ya(Uo[js])) : Bs[js] = Uo[js];
          }
        var sa = ps.apply(null, Bs);
        function va(oa) {
          return Xs !== 0 && oi(Xs), Wo(oa);
        }
        return sa = va(sa), sa;
      }, vs = (Ao, po, _o, Uo) => {
        var ts = !_o || _o.every((Wo) => Wo === "number" || Wo === "boolean"), Lo = po !== "string";
        return Lo && ts && !Uo ? kn(Ao) : function() {
          return Ei(Ao, po, _o, arguments);
        };
      }, vi = { p: qr, t: ri, v: Er, b: so, j: Do, V: gn, E: Gn, r: pn, L: hn, h: _n, D: Rn, M: vo, U: di, J: co, K: To, G: In, d: Me, u: $r, c: fr, W: Fr, f: wr, C: Qe, m: dr, B: Oi, o: zi, F: Sn, y: Vn, N: Ho, S: Io, g: Be, l: Ti, H: un, e: Rr, T: yo, i: Dr, I: mi, k: Gr, z: $i, n: Si, s: ni, q: Kn, w: Xn, x: uo, O: Oo, P: qi, R: xo, Q: Mo, A: xs, a: Pe, X: hi }, xi = Ji();
      xi.Y, xi.__errno_location, xi.__cxa_free_exception, A._free = xi.Z, A._malloc = xi._, A._miniscript_compile = xi.$, A._miniscript_analyze = xi.aa;
      var Lr = xi.ca, dn = xi.da, xn = xi.ea, oi = xi.fa, Yr = xi.ga, ji = xi.ha, Cn = xi.ia, Mn = xi.ja, B = xi.ka, o = A.dynCall_iij = xi.la, m = A.dynCall_vij = xi.ma, d = A.dynCall_viji = xi.na, v = A.dynCall_viij = xi.oa, he = A.dynCall_viiij = xi.pa, we = A.dynCall_iiij = xi.qa;
      function Be(Ao) {
        var po = xn();
        try {
          Gi(Ao)();
        } catch (_o) {
          if (oi(po), _o !== _o + 0) throw _o;
          Lr(1, 0);
        }
      }
      function Me(Ao, po) {
        var _o = xn();
        try {
          return Gi(Ao)(po);
        } catch (Uo) {
          if (oi(_o), Uo !== Uo + 0) throw Uo;
          Lr(1, 0);
        }
      }
      function fr(Ao, po, _o) {
        var Uo = xn();
        try {
          return Gi(Ao)(po, _o);
        } catch (ts) {
          if (oi(Uo), ts !== ts + 0) throw ts;
          Lr(1, 0);
        }
      }
      function wr(Ao, po, _o, Uo) {
        var ts = xn();
        try {
          return Gi(Ao)(po, _o, Uo);
        } catch (Lo) {
          if (oi(ts), Lo !== Lo + 0) throw Lo;
          Lr(1, 0);
        }
      }
      function dr(Ao, po, _o, Uo, ts) {
        var Lo = xn();
        try {
          return Gi(Ao)(po, _o, Uo, ts);
        } catch (Wo) {
          if (oi(Lo), Wo !== Wo + 0) throw Wo;
          Lr(1, 0);
        }
      }
      function Dr(Ao, po, _o, Uo) {
        var ts = xn();
        try {
          Gi(Ao)(po, _o, Uo);
        } catch (Lo) {
          if (oi(ts), Lo !== Lo + 0) throw Lo;
          Lr(1, 0);
        }
      }
      function Rr(Ao, po, _o) {
        var Uo = xn();
        try {
          Gi(Ao)(po, _o);
        } catch (ts) {
          if (oi(Uo), ts !== ts + 0) throw ts;
          Lr(1, 0);
        }
      }
      function Qe(Ao, po, _o, Uo, ts) {
        var Lo = xn();
        try {
          return Gi(Ao)(po, _o, Uo, ts);
        } catch (Wo) {
          if (oi(Lo), Wo !== Wo + 0) throw Wo;
          Lr(1, 0);
        }
      }
      function Fr(Ao, po, _o, Uo) {
        var ts = xn();
        try {
          return Gi(Ao)(po, _o, Uo);
        } catch (Lo) {
          if (oi(ts), Lo !== Lo + 0) throw Lo;
          Lr(1, 0);
        }
      }
      function Gr(Ao, po, _o, Uo, ts) {
        var Lo = xn();
        try {
          Gi(Ao)(po, _o, Uo, ts);
        } catch (Wo) {
          if (oi(Lo), Wo !== Wo + 0) throw Wo;
          Lr(1, 0);
        }
      }
      function $r(Ao, po, _o, Uo, ts) {
        var Lo = xn();
        try {
          return Gi(Ao)(po, _o, Uo, ts);
        } catch (Wo) {
          if (oi(Lo), Wo !== Wo + 0) throw Wo;
          Lr(1, 0);
        }
      }
      function ni(Ao, po, _o, Uo, ts, Lo) {
        var Wo = xn();
        try {
          Gi(Ao)(po, _o, Uo, ts, Lo);
        } catch (ps) {
          if (oi(Wo), ps !== ps + 0) throw ps;
          Lr(1, 0);
        }
      }
      function mi(Ao, po, _o, Uo, ts, Lo) {
        var Wo = xn();
        try {
          Gi(Ao)(po, _o, Uo, ts, Lo);
        } catch (ps) {
          if (oi(Wo), ps !== ps + 0) throw ps;
          Lr(1, 0);
        }
      }
      function Si(Ao, po, _o, Uo, ts, Lo, Wo) {
        var ps = xn();
        try {
          Gi(Ao)(po, _o, Uo, ts, Lo, Wo);
        } catch (Bs) {
          if (oi(ps), Bs !== Bs + 0) throw Bs;
          Lr(1, 0);
        }
      }
      function Oi(Ao, po, _o, Uo, ts, Lo) {
        var Wo = xn();
        try {
          return Gi(Ao)(po, _o, Uo, ts, Lo);
        } catch (ps) {
          if (oi(Wo), ps !== ps + 0) throw ps;
          Lr(1, 0);
        }
      }
      function $i(Ao, po, _o, Uo, ts, Lo) {
        var Wo = xn();
        try {
          Gi(Ao)(po, _o, Uo, ts, Lo);
        } catch (ps) {
          if (oi(Wo), ps !== ps + 0) throw ps;
          Lr(1, 0);
        }
      }
      function zi(Ao, po, _o, Uo, ts, Lo, Wo) {
        var ps = xn();
        try {
          return Gi(Ao)(po, _o, Uo, ts, Lo, Wo);
        } catch (Bs) {
          if (oi(ps), Bs !== Bs + 0) throw Bs;
          Lr(1, 0);
        }
      }
      function un(Ao, po, _o) {
        var Uo = xn();
        try {
          Gi(Ao)(po, _o);
        } catch (ts) {
          if (oi(Uo), ts !== ts + 0) throw ts;
          Lr(1, 0);
        }
      }
      function In(Ao) {
        var po = xn();
        try {
          return Gi(Ao)();
        } catch (_o) {
          if (oi(po), _o !== _o + 0) throw _o;
          Lr(1, 0);
        }
      }
      function Ti(Ao, po) {
        var _o = xn();
        try {
          Gi(Ao)(po);
        } catch (Uo) {
          if (oi(_o), Uo !== Uo + 0) throw Uo;
          Lr(1, 0);
        }
      }
      function Sn(Ao, po, _o, Uo, ts, Lo, Wo, ps) {
        var Bs = xn();
        try {
          return Gi(Ao)(po, _o, Uo, ts, Lo, Wo, ps);
        } catch (Xs) {
          if (oi(Bs), Xs !== Xs + 0) throw Xs;
          Lr(1, 0);
        }
      }
      function Kn(Ao, po, _o, Uo, ts, Lo, Wo, ps) {
        var Bs = xn();
        try {
          Gi(Ao)(po, _o, Uo, ts, Lo, Wo, ps);
        } catch (Xs) {
          if (oi(Bs), Xs !== Xs + 0) throw Xs;
          Lr(1, 0);
        }
      }
      function Vn(Ao, po, _o, Uo, ts, Lo, Wo, ps, Bs, Xs, js, ya) {
        var sa = xn();
        try {
          return Gi(Ao)(po, _o, Uo, ts, Lo, Wo, ps, Bs, Xs, js, ya);
        } catch (va) {
          if (oi(sa), va !== va + 0) throw va;
          Lr(1, 0);
        }
      }
      function Xn(Ao, po, _o, Uo, ts, Lo, Wo, ps, Bs, Xs, js) {
        var ya = xn();
        try {
          Gi(Ao)(po, _o, Uo, ts, Lo, Wo, ps, Bs, Xs, js);
        } catch (sa) {
          if (oi(ya), sa !== sa + 0) throw sa;
          Lr(1, 0);
        }
      }
      function uo(Ao, po, _o, Uo, ts, Lo, Wo, ps, Bs, Xs, js, ya, sa, va, oa, wa) {
        var Pa = xn();
        try {
          Gi(Ao)(po, _o, Uo, ts, Lo, Wo, ps, Bs, Xs, js, ya, sa, va, oa, wa);
        } catch (Ta) {
          if (oi(Pa), Ta !== Ta + 0) throw Ta;
          Lr(1, 0);
        }
      }
      function yo(Ao, po, _o, Uo) {
        var ts = xn();
        try {
          Gi(Ao)(po, _o, Uo);
        } catch (Lo) {
          if (oi(ts), Lo !== Lo + 0) throw Lo;
          Lr(1, 0);
        }
      }
      function Io(Ao, po, _o, Uo) {
        var ts = xn();
        try {
          return o(Ao, po, _o, Uo);
        } catch (Lo) {
          if (oi(ts), Lo !== Lo + 0) throw Lo;
          Lr(1, 0);
        }
      }
      function xo(Ao, po, _o, Uo) {
        var ts = xn();
        try {
          m(Ao, po, _o, Uo);
        } catch (Lo) {
          if (oi(ts), Lo !== Lo + 0) throw Lo;
          Lr(1, 0);
        }
      }
      function Mo(Ao, po, _o, Uo, ts) {
        var Lo = xn();
        try {
          d(Ao, po, _o, Uo, ts);
        } catch (Wo) {
          if (oi(Lo), Wo !== Wo + 0) throw Wo;
          Lr(1, 0);
        }
      }
      function qi(Ao, po, _o, Uo, ts) {
        var Lo = xn();
        try {
          v(Ao, po, _o, Uo, ts);
        } catch (Wo) {
          if (oi(Lo), Wo !== Wo + 0) throw Wo;
          Lr(1, 0);
        }
      }
      function Oo(Ao, po, _o, Uo, ts, Lo) {
        var Wo = xn();
        try {
          he(Ao, po, _o, Uo, ts, Lo);
        } catch (ps) {
          if (oi(Wo), ps !== ps + 0) throw ps;
          Lr(1, 0);
        }
      }
      function Ho(Ao, po, _o, Uo, ts) {
        var Lo = xn();
        try {
          return we(Ao, po, _o, Uo, ts);
        } catch (Wo) {
          if (oi(Lo), Wo !== Wo + 0) throw Wo;
          Lr(1, 0);
        }
      }
      function Go(Ao) {
        try {
          for (var po = atob(Ao), _o = new Uint8Array(po.length), Uo = 0; Uo < po.length; ++Uo)
            _o[Uo] = po.charCodeAt(Uo);
          return _o;
        } catch {
          throw new Error("Converting base64 string to bytes failed.");
        }
      }
      function ns(Ao) {
        if (ui(Ao))
          return Go(Ao.slice(si.length));
      }
      A.cwrap = vs, A.UTF8ToString = Vr;
      var ds;
      vr = function Ao() {
        ds || Ts(), ds || (vr = Ao);
      };
      function Ts() {
        if (Or > 0 || (Ie(), Or > 0))
          return;
        function Ao() {
          ds || (ds = !0, A.calledRun = !0, !nr && (xe(), b(A), A.onRuntimeInitialized && A.onRuntimeInitialized(), rr()));
        }
        A.setStatus ? (A.setStatus("Running..."), setTimeout(function() {
          setTimeout(function() {
            A.setStatus("");
          }, 1), Ao();
        }, 1)) : Ao();
      }
      if (A.preInit)
        for (typeof A.preInit == "function" && (A.preInit = [A.preInit]); A.preInit.length > 0; )
          A.preInit.pop()();
      return Ts(), a;
    };
  })();
  n.exports = u;
});
const Module = bindings(), em_miniscript_compile = Module.cwrap("miniscript_compile", "none", [
  "string",
  "number",
  "number",
  "number",
  "number",
  "number",
  "number"
]), em_miniscript_analyze = Module.cwrap("miniscript_analyze", "none", [
  "string",
  "number",
  "number",
  "number",
  "number"
]), cleanAsm = (n) => n.trim().replace(/\n/g, " ").replace(/ +(?= )/g, ""), compilePolicy = (n) => {
  const c = Module._malloc(1e4), u = Module._malloc(500), p = Module._malloc(1e5), a = Module._malloc(10), A = Module._malloc(10);
  em_miniscript_compile(
    n,
    c,
    1e4,
    u,
    500,
    p,
    1e5,
    a,
    10,
    A,
    10
  );
  const b = {
    miniscript: Module.UTF8ToString(c),
    asm: cleanAsm(Module.UTF8ToString(p)),
    issane: Module.UTF8ToString(a) === "true",
    issanesublevel: Module.UTF8ToString(A) === "true"
  };
  return Module._free(c), Module._free(u), Module._free(p), Module._free(a), Module._free(A), b;
}, compileMiniscript = (n) => {
  const c = Module._malloc(5e4), u = Module._malloc(1e5), p = Module._malloc(10), a = Module._malloc(10);
  em_miniscript_analyze(
    n,
    c,
    5e4,
    u,
    1e5,
    p,
    10,
    a,
    10
  );
  const A = Module.UTF8ToString(u), b = Module.UTF8ToString(p), F = Module.UTF8ToString(a);
  return Module._free(c), Module._free(u), Module._free(p), Module._free(a), {
    asm: cleanAsm(A),
    issane: b === "true",
    issanesublevel: F === "true"
  };
};
function witnessWU(n) {
  const c = n.split(" ");
  let u = 0;
  for (const p of c)
    if (p !== "") if (p.startsWith("<sig"))
      u += 74;
    else if (p.startsWith("<sha256_preimage(") || p.startsWith("<hash256_preimage(") || p.startsWith("<ripemd160_preimage(") || p.startsWith("<hash160_preimage(") || p.startsWith("<random_preimage()>"))
      u += 33;
    else if (p.startsWith("<"))
      u += 34;
    else if (p === "1" || p === "0")
      u += 1;
    else
      throw new Error(`Invalid witness substring ${p}`);
  return u;
}
function malleabilityAnalysis(n) {
  n = n.map((p) => (p = { ...p }, p.signatures = p.asm.split(" ").filter((a) => a.startsWith("<sig")), p.signatures.length === 0 && (p.dontuse = !0), p.asm.includes("<random_preimage()>") && (p.dontuse = !0), p)).sort((p, a) => witnessWU(p.asm) - witnessWU(a.asm));
  for (const p of n)
    for (const a of n)
      a !== p && //for the same nLockTime and nSequence
      a.nLockTime === p.nLockTime && a.nSequence === p.nSequence && //is otherSat.signatures equal or a subset of sat.signatures?
      a.signatures.every((A) => p.signatures.includes(A)) && (p.dontuse = !0);
  const c = n.filter((p) => !p.dontuse), u = n.filter((p) => p.dontuse);
  for (const p of [c, u])
    p.forEach((a) => {
      delete a.signatures, delete a.dontuse;
    });
  return { nonMalleableSats: c, malleableSats: u };
}
function isScalarArg(n, c) {
  switch (n) {
    case "pk_k":
    case "pk_h":
    case "older":
    case "after":
    case "sha256":
    case "ripemd160":
    case "hash256":
    case "hash160":
    case "multi":
      return !0;
    case "thresh":
      if (c === 0) return !0;
  }
  return !1;
}
const evaluate$1 = (n) => {
  if (typeof n != "string")
    throw new Error("Invalid expression: " + n);
  for (; n.match(/^[a-z]{2,}:/); )
    n = n.replace(
      /^[a-z]{2,}:/,
      (b) => b.replace(b[0], b[0] + ":")
    );
  n = n.replace(/^pk\(/, "c:pk_k(").replace(/^pkh\(/, "c:pk_h(").replace(
    /^and_n\(.*\)/,
    (b) => b.replace("and_n", "andor").replace(/\)$/, ",0)")
  ).replace(/^t:(.*)/, (b) => b.replace("t:", "and_v(") + ",1)").replace(/^l:(.*)/, (b) => b.replace("l:", "or_i(0,") + ")").replace(/^u:(.*)/, (b) => b.replace("u:", "or_i(") + ",0)");
  const c = String.raw`([^\(:]*)`, u = n.match(c);
  if (!u) throw new Error("Invalid expression: " + n);
  const p = u[0];
  if (typeof satisfactionsMaker[p] != "function")
    throw new Error(p + " not implemented");
  let a;
  n[p.length] === "(" ? a = n.substring(p.length + 1, n.length - 1) : n[p.length] === ":" && (a = n.substring(p.length + 1));
  const A = [];
  if (a) {
    let b = -1, F = 0, le = 0;
    for (let L = 0; L < a.length; L++)
      if (a[L] === "(" && F++, a[L] === ")" && F--, F === 0) {
        let pe;
        a[L] === "," ? (pe = a.substring(b + 1, L), b = L) : L === a.length - 1 && (pe = a.substring(b + 1)), pe && (isScalarArg(p, le) ? A.push(pe) : A.push(evaluate$1(pe)), le++);
      }
  }
  return satisfactionsMaker[p](...A);
}, satisfier = (n, c = {}) => {
  let { unknowns: u, knowns: p } = c;
  const { issane: a, issanesublevel: A } = compileMiniscript(n);
  if (!a)
    throw new Error(`Miniscript ${n} is not sane.`);
  if (typeof u > "u" && typeof p > "u")
    u = [];
  else {
    if (typeof u < "u" && typeof p < "u")
      throw new Error("Cannot pass both knowns and unknowns");
    if (p && !Array.isArray(p) || u && !Array.isArray(u))
      throw new Error("Incorrect types for unknowns / knowns");
  }
  const b = [], F = [];
  return (evaluate$1(n).sats || []).map((L) => {
    typeof L.nSequence > "u" && delete L.nSequence, typeof L.nLockTime > "u" && delete L.nLockTime, L.asm = L.asm.replace(/  +/g, " ").trim(), u ? u.some((pe) => L.asm.includes(pe)) ? F.push(L) : b.push(L) : p.reduce(
      ($, Ee) => $.replace(Ee, ""),
      L.asm
    ).match(
      /<sig\(|<sha256_preimage\(|<hash256_preimage\(|<ripemd160_preimage\(|<hash160_preimage\(/
    ) ? F.push(L) : b.push(L);
  }), { ...malleabilityAnalysis(b), unknownSats: F };
};
dist.compileMiniscript = compileMiniscript;
dist.compilePolicy = compilePolicy;
dist.satisfier = satisfier;
var __createBinding$6 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(n, c, u, p) {
  p === void 0 && (p = u);
  var a = Object.getOwnPropertyDescriptor(c, u);
  (!a || ("get" in a ? !c.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
    return c[u];
  } }), Object.defineProperty(n, p, a);
} : function(n, c, u, p) {
  p === void 0 && (p = u), n[p] = c[u];
}), __setModuleDefault$6 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(n, c) {
  Object.defineProperty(n, "default", { enumerable: !0, value: c });
} : function(n, c) {
  n.default = c;
}), __importStar$6 = commonjsGlobal && commonjsGlobal.__importStar || function(n) {
  if (n && n.__esModule) return n;
  var c = {};
  if (n != null) for (var u in n) u !== "default" && Object.prototype.hasOwnProperty.call(n, u) && __createBinding$6(c, n, u);
  return __setModuleDefault$6(c, n), c;
};
Object.defineProperty(miniscript, "__esModule", { value: !0 });
miniscript.numberEncodeAsm = miniscript.satisfyMiniscript = miniscript.miniscript2Script = miniscript.expandMiniscript = void 0;
const bitcoinjs_lib_1$7 = src$j, keyExpressions_1$2 = keyExpressions, RE$1 = __importStar$6(re), miniscript_1$1 = dist;
function expandMiniscript({ miniscript: n, isSegwit: c, network: u = bitcoinjs_lib_1$7.networks.bitcoin, ECPair: p, BIP32: a }) {
  const A = {}, b = n.replace(RegExp(RE$1.reKeyExp, "g"), (le) => {
    const L = "@" + Object.keys(A).length;
    return A[L] = (0, keyExpressions_1$2.parseKeyExpression)({
      keyExpression: le,
      isSegwit: c,
      network: u,
      ECPair: p,
      BIP32: a
    }), L;
  }), F = Object.values(A).filter((le) => le.keyExpression.indexOf("*") === -1).map((le) => {
    if (!le.pubkey)
      throw new Error(`Error: keyExpression ${le.keyExpression} does not have a pubkey`);
    return le.pubkey.toString("hex");
  });
  if (new Set(F).size !== F.length)
    throw new Error(`Error: miniscript ${n} is not sane: contains duplicate public keys.`);
  return { expandedMiniscript: b, expansionMap: A };
}
miniscript.expandMiniscript = expandMiniscript;
function substituteAsm({ expandedAsm: n, expansionMap: c }) {
  let u = Object.keys(c).reduce((p, a) => {
    var b;
    const A = (b = c[a]) == null ? void 0 : b.pubkey;
    if (!A)
      throw new Error(`Error: invalid expansionMap for ${a}`);
    return p.replaceAll(`<${a}>`, `<${A.toString("hex")}>`).replaceAll(`<HASH160(${a})>`, `<${bitcoinjs_lib_1$7.crypto.hash160(A).toString("hex")}>`);
  }, n);
  return u = u.trim().replace(/\s+/g, " ").replace(/(<\d+>)|\b\d+\b/g, (p) => p.startsWith("<") ? p : numberEncodeAsm(Number(p))).replace(/[<>]/g, ""), u;
}
function miniscript2Script({ expandedMiniscript: n, expansionMap: c }) {
  const u = (0, miniscript_1$1.compileMiniscript)(n);
  if (u.issane !== !0)
    throw new Error(`Error: Miniscript ${n} is not sane`);
  return bitcoinjs_lib_1$7.script.fromASM(substituteAsm({ expandedAsm: u.asm, expansionMap: c }));
}
miniscript.miniscript2Script = miniscript2Script;
function satisfyMiniscript({ expandedMiniscript: n, expansionMap: c, signatures: u = [], preimages: p = [], timeConstraints: a }) {
  const A = {};
  p.forEach((be) => {
    A["<" + be.digest.replace("(", "_preimage(") + ">"] = "<" + be.preimage + ">";
  });
  const b = {};
  u.forEach((be) => {
    const He = be.pubkey.toString("hex"), Pe = Object.keys(c).find((nr) => {
      var ir, or;
      return ((or = (ir = c[nr]) == null ? void 0 : ir.pubkey) == null ? void 0 : or.toString("hex")) === He;
    });
    b["<sig(" + Pe + ")>"] = "<" + be.signature.toString("hex") + ">";
  });
  const F = { ...A, ...b }, le = Object.keys(F), { nonMalleableSats: L } = (0, miniscript_1$1.satisfier)(n, { knowns: le });
  if (!Array.isArray(L) || !L[0])
    throw new Error(`Error: unresolvable miniscript ${n}`);
  let pe;
  if (!a)
    pe = L[0];
  else if (pe = L.find((be) => be.nSequence === a.nSequence && be.nLockTime === a.nLockTime), pe === void 0)
    throw new Error(`Error: unresolvable miniscript ${n}. Could not find solutions for sequence ${a.nSequence} & locktime=${a.nLockTime}. Signatures are applied to a hash that depends on sequence and locktime. Did you provide all the signatures wrt the signers keys declared and include all preimages?`);
  let $ = pe.asm;
  for (const be in F) {
    const He = F[be];
    if (!He || He === "<>")
      throw new Error("Error: invalid expandedKnownsMap");
    $ = $.replaceAll(be, He);
  }
  return {
    scriptSatisfaction: bitcoinjs_lib_1$7.script.fromASM(substituteAsm({ expandedAsm: $, expansionMap: c })),
    nLockTime: pe.nLockTime,
    nSequence: pe.nSequence
  };
}
miniscript.satisfyMiniscript = satisfyMiniscript;
function numberEncodeAsm(n) {
  if (Number.isSafeInteger(n) === !1)
    throw new Error(`Error: invalid number ${n}`);
  return n === 0 ? "OP_0" : bitcoinjs_lib_1$7.script.number.encode(n).toString("hex");
}
miniscript.numberEncodeAsm = numberEncodeAsm;
var __createBinding$5 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(n, c, u, p) {
  p === void 0 && (p = u);
  var a = Object.getOwnPropertyDescriptor(c, u);
  (!a || ("get" in a ? !c.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
    return c[u];
  } }), Object.defineProperty(n, p, a);
} : function(n, c, u, p) {
  p === void 0 && (p = u), n[p] = c[u];
}), __setModuleDefault$5 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(n, c) {
  Object.defineProperty(n, "default", { enumerable: !0, value: c });
} : function(n, c) {
  n.default = c;
}), __importStar$5 = commonjsGlobal && commonjsGlobal.__importStar || function(n) {
  if (n && n.__esModule) return n;
  var c = {};
  if (n != null) for (var u in n) u !== "default" && Object.prototype.hasOwnProperty.call(n, u) && __createBinding$5(c, n, u);
  return __setModuleDefault$5(c, n), c;
}, __classPrivateFieldSet = commonjsGlobal && commonjsGlobal.__classPrivateFieldSet || function(n, c, u, p, a) {
  if (p === "m") throw new TypeError("Private method is not writable");
  if (p === "a" && !a) throw new TypeError("Private accessor was defined without a setter");
  if (typeof c == "function" ? n !== c || !a : !c.has(n)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return p === "a" ? a.call(n, u) : a ? a.value = u : c.set(n, u), u;
}, __classPrivateFieldGet = commonjsGlobal && commonjsGlobal.__classPrivateFieldGet || function(n, c, u, p) {
  if (u === "a" && !p) throw new TypeError("Private accessor was defined without a getter");
  if (typeof c == "function" ? n !== c || !p : !c.has(n)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return u === "m" ? p : u === "a" ? p.call(n) : p ? p.value : c.get(n);
};
Object.defineProperty(descriptors$1, "__esModule", { value: !0 });
descriptors$1.DescriptorsFactory = void 0;
const bitcoinjs_lib_1$6 = src$j, { p2sh, p2wpkh, p2pkh, p2pk, p2wsh, p2tr } = bitcoinjs_lib_1$6.payments, bip32_1$1 = src$2, ecpair_1 = src, psbt_1 = psbt$1, checksum_1 = checksum, keyExpressions_1$1 = keyExpressions, RE = __importStar$5(re), miniscript_1 = miniscript, MAX_SCRIPT_ELEMENT_SIZE = 520, MAX_STANDARD_P2WSH_SCRIPT_SIZE = 3600, MAX_OPS_PER_SCRIPT = 201;
function countNonPushOnlyOPs(n) {
  const c = bitcoinjs_lib_1$6.script.decompile(n);
  if (!c)
    throw new Error(`Error: cound not decompile ${n}`);
  return c.filter((u) => typeof u == "number" && u > bitcoinjs_lib_1$6.script.OPS.OP_16).length;
}
function evaluate({ expression: n, checksumRequired: c, index: u }) {
  const p = n.match(String.raw`(${RE.reChecksum})$`);
  if (p === null && c === !0)
    throw new Error(`Error: descriptor ${n} has not checksum`);
  let a = n;
  if (p !== null) {
    const A = p[0].substring(1);
    if (a = n.substring(0, n.length - p[0].length), A !== (0, checksum_1.DescriptorChecksum)(a))
      throw new Error(`Error: invalid descriptor checksum for ${n}`);
  }
  if (u !== void 0) {
    const A = a.match(/\*/g);
    if (A && A.length > 0)
      a = a.replaceAll("*", u.toString());
    else
      throw new Error(`Error: index passed for non-ranged descriptor: ${n}`);
  }
  return a;
}
function DescriptorsFactory(n) {
  var c, u, p, a, A, b, F, le, L, pe, $, Ee, be, He;
  const Pe = (0, bip32_1$1.BIP32Factory)(n), nr = (0, ecpair_1.ECPairFactory)(n), ir = (kr, Ce, tr) => nr.fromPublicKey(kr).verify(Ce, tr), or = ({ keyExpression: kr, isSegwit: Ce, network: tr = bitcoinjs_lib_1$6.networks.bitcoin }) => (0, keyExpressions_1$1.parseKeyExpression)({
    keyExpression: kr,
    network: tr,
    ...typeof Ce == "boolean" ? { isSegwit: Ce } : {},
    ECPair: nr,
    BIP32: Pe
  }), lr = ({ expression: kr, index: Ce, checksumRequired: tr = !1, network: Fe = bitcoinjs_lib_1$6.networks.bitcoin, allowMiniscriptInP2SH: Sr = !1 }) => {
    var Hr, si, ui, Li, Qi, wi, Ji, mn, pi, ei;
    let er, Ie, xe, rr, ar, yr, _r, Or;
    const vr = kr.indexOf("*") !== -1;
    if (Ce !== void 0 && (!Number.isInteger(Ce) || Ce < 0))
      throw new Error(`Error: invalid index ${Ce}`);
    const Te = evaluate({
      expression: kr,
      ...Ce !== void 0 ? { index: Ce } : {},
      checksumRequired: tr
    }), Cr = Te.indexOf("*") !== -1;
    if (Te.match(RE.reAddrAnchored)) {
      if (vr)
        throw new Error("Error: addr() cannot be ranged");
      const Vr = (Hr = Te.match(RE.reAddrAnchored)) == null ? void 0 : Hr[1];
      if (!Vr)
        throw new Error(`Error: could not get an address in ${kr}`);
      let qr;
      try {
        qr = bitcoinjs_lib_1$6.address.toOutputScript(Vr, Fe);
      } catch {
        throw new Error(`Error: invalid address ${Vr}`);
      }
      try {
        yr = p2pkh({ output: qr, network: Fe });
      } catch {
      }
      try {
        yr = p2sh({ output: qr, network: Fe });
      } catch {
      }
      try {
        yr = p2wpkh({ output: qr, network: Fe });
      } catch {
      }
      try {
        yr = p2wsh({ output: qr, network: Fe });
      } catch {
      }
      try {
        yr = p2tr({ output: qr, network: Fe });
      } catch {
      }
      if (!yr)
        throw new Error(`Error: invalid address ${Vr}`);
    } else if (Te.match(RE.rePkAnchored)) {
      rr = !1;
      const Vr = (si = Te.match(RE.reKeyExp)) == null ? void 0 : si[0];
      if (!Vr)
        throw new Error("Error: keyExpression could not me extracted");
      if (Te !== `pk(${Vr})`)
        throw new Error(`Error: invalid expression ${kr}`);
      er = "pk(@0)";
      const qr = or({ keyExpression: Vr, network: Fe, isSegwit: rr });
      if (xe = { "@0": qr }, !Cr) {
        const Zi = qr.pubkey;
        if (!Zi)
          throw new Error(`Error: could not extract a pubkey from ${kr}`);
        yr = p2pk({ pubkey: Zi, network: Fe });
      }
    } else if (Te.match(RE.rePkhAnchored)) {
      rr = !1;
      const Vr = (ui = Te.match(RE.reKeyExp)) == null ? void 0 : ui[0];
      if (!Vr)
        throw new Error("Error: keyExpression could not me extracted");
      if (Te !== `pkh(${Vr})`)
        throw new Error(`Error: invalid expression ${kr}`);
      er = "pkh(@0)";
      const qr = or({ keyExpression: Vr, network: Fe, isSegwit: rr });
      if (xe = { "@0": qr }, !Cr) {
        const Zi = qr.pubkey;
        if (!Zi)
          throw new Error(`Error: could not extract a pubkey from ${kr}`);
        yr = p2pkh({ pubkey: Zi, network: Fe });
      }
    } else if (Te.match(RE.reShWpkhAnchored)) {
      rr = !0;
      const Vr = (Li = Te.match(RE.reKeyExp)) == null ? void 0 : Li[0];
      if (!Vr)
        throw new Error("Error: keyExpression could not me extracted");
      if (Te !== `sh(wpkh(${Vr}))`)
        throw new Error(`Error: invalid expression ${kr}`);
      er = "sh(wpkh(@0))";
      const qr = or({ keyExpression: Vr, network: Fe, isSegwit: rr });
      if (xe = { "@0": qr }, !Cr) {
        const Zi = qr.pubkey;
        if (!Zi)
          throw new Error(`Error: could not extract a pubkey from ${kr}`);
        if (yr = p2sh({ redeem: p2wpkh({ pubkey: Zi, network: Fe }), network: Fe }), Or = (Qi = yr.redeem) == null ? void 0 : Qi.output, !Or)
          throw new Error(`Error: could not calculate redeemScript for ${kr}`);
      }
    } else if (Te.match(RE.reWpkhAnchored)) {
      rr = !0;
      const Vr = (wi = Te.match(RE.reKeyExp)) == null ? void 0 : wi[0];
      if (!Vr)
        throw new Error("Error: keyExpression could not me extracted");
      if (Te !== `wpkh(${Vr})`)
        throw new Error(`Error: invalid expression ${kr}`);
      er = "wpkh(@0)";
      const qr = or({ keyExpression: Vr, network: Fe, isSegwit: rr });
      if (xe = { "@0": qr }, !Cr) {
        const Zi = qr.pubkey;
        if (!Zi)
          throw new Error(`Error: could not extract a pubkey from ${kr}`);
        yr = p2wpkh({ pubkey: Zi, network: Fe });
      }
    } else if (Te.match(RE.reShWshMiniscriptAnchored)) {
      if (rr = !0, Ie = (Ji = Te.match(RE.reShWshMiniscriptAnchored)) == null ? void 0 : Ji[1], !Ie)
        throw new Error(`Error: could not get miniscript in ${kr}`);
      if ({ expandedMiniscript: ar, expansionMap: xe } = Ir({
        miniscript: Ie,
        isSegwit: rr,
        network: Fe
      }), er = `sh(wsh(${ar}))`, !Cr) {
        const Vr = (0, miniscript_1.miniscript2Script)({ expandedMiniscript: ar, expansionMap: xe });
        if (_r = Vr, Vr.byteLength > MAX_STANDARD_P2WSH_SCRIPT_SIZE)
          throw new Error(`Error: script is too large, ${Vr.byteLength} bytes is larger than ${MAX_STANDARD_P2WSH_SCRIPT_SIZE} bytes`);
        const qr = countNonPushOnlyOPs(Vr);
        if (qr > MAX_OPS_PER_SCRIPT)
          throw new Error(`Error: too many non-push ops, ${qr} non-push ops is larger than ${MAX_OPS_PER_SCRIPT}`);
        if (yr = p2sh({
          redeem: p2wsh({ redeem: { output: Vr, network: Fe }, network: Fe }),
          network: Fe
        }), Or = (mn = yr.redeem) == null ? void 0 : mn.output, !Or)
          throw new Error(`Error: could not calculate redeemScript for ${kr}`);
      }
    } else if (Te.match(RE.reShMiniscriptAnchored)) {
      if (rr = !1, Ie = (pi = Te.match(RE.reShMiniscriptAnchored)) == null ? void 0 : pi[1], !Ie)
        throw new Error(`Error: could not get miniscript in ${kr}`);
      if (Sr === !1 && //These top-level expressions within sh are allowed within sh.
      //They can be parsed with miniscript2Script, but first we must make sure
      //that other expressions are not accepted (unless forced with allowMiniscriptInP2SH).
      Ie.search(/^(pk\(|pkh\(|wpkh\(|combo\(|multi\(|sortedmulti\(|multi_a\(|sortedmulti_a\()/) !== 0)
        throw new Error("Error: Miniscript expressions can only be used in wsh");
      if ({ expandedMiniscript: ar, expansionMap: xe } = Ir({
        miniscript: Ie,
        isSegwit: rr,
        network: Fe
      }), er = `sh(${ar})`, !Cr) {
        const Vr = (0, miniscript_1.miniscript2Script)({ expandedMiniscript: ar, expansionMap: xe });
        if (Or = Vr, Vr.byteLength > MAX_SCRIPT_ELEMENT_SIZE)
          throw new Error(`Error: P2SH script is too large, ${Vr.byteLength} bytes is larger than ${MAX_SCRIPT_ELEMENT_SIZE} bytes`);
        const qr = countNonPushOnlyOPs(Vr);
        if (qr > MAX_OPS_PER_SCRIPT)
          throw new Error(`Error: too many non-push ops, ${qr} non-push ops is larger than ${MAX_OPS_PER_SCRIPT}`);
        yr = p2sh({ redeem: { output: Vr, network: Fe }, network: Fe });
      }
    } else if (Te.match(RE.reWshMiniscriptAnchored)) {
      if (rr = !0, Ie = (ei = Te.match(RE.reWshMiniscriptAnchored)) == null ? void 0 : ei[1], !Ie)
        throw new Error(`Error: could not get miniscript in ${kr}`);
      if ({ expandedMiniscript: ar, expansionMap: xe } = Ir({
        miniscript: Ie,
        isSegwit: rr,
        network: Fe
      }), er = `wsh(${ar})`, !Cr) {
        const Vr = (0, miniscript_1.miniscript2Script)({ expandedMiniscript: ar, expansionMap: xe });
        if (_r = Vr, Vr.byteLength > MAX_STANDARD_P2WSH_SCRIPT_SIZE)
          throw new Error(`Error: script is too large, ${Vr.byteLength} bytes is larger than ${MAX_STANDARD_P2WSH_SCRIPT_SIZE} bytes`);
        const qr = countNonPushOnlyOPs(Vr);
        if (qr > MAX_OPS_PER_SCRIPT)
          throw new Error(`Error: too many non-push ops, ${qr} non-push ops is larger than ${MAX_OPS_PER_SCRIPT}`);
        yr = p2wsh({ redeem: { output: Vr, network: Fe }, network: Fe });
      }
    } else
      throw new Error(`Error: Could not parse descriptor ${kr}`);
    return {
      ...yr !== void 0 ? { payment: yr } : {},
      ...er !== void 0 ? { expandedExpression: er } : {},
      ...Ie !== void 0 ? { miniscript: Ie } : {},
      ...xe !== void 0 ? { expansionMap: xe } : {},
      ...rr !== void 0 ? { isSegwit: rr } : {},
      ...ar !== void 0 ? { expandedMiniscript: ar } : {},
      ...Or !== void 0 ? { redeemScript: Or } : {},
      ..._r !== void 0 ? { witnessScript: _r } : {},
      isRanged: vr,
      canonicalExpression: Te
    };
  };
  function Ir({ miniscript: kr, isSegwit: Ce, network: tr = bitcoinjs_lib_1$6.networks.bitcoin }) {
    return (0, miniscript_1.expandMiniscript)({
      miniscript: kr,
      isSegwit: Ce,
      network: tr,
      BIP32: Pe,
      ECPair: nr
    });
  }
  class xr {
    /**
     * @param options
     * @throws {Error} - when descriptor is invalid
     */
    constructor({ expression: Ce, index: tr, checksumRequired: Fe = !1, allowMiniscriptInP2SH: Sr = !1, network: er = bitcoinjs_lib_1$6.networks.bitcoin, preimages: Ie = [], signersPubKeys: xe }) {
      if (c.add(this), u.set(this, void 0), p.set(this, []), a.set(this, void 0), A.set(this, void 0), b.set(this, void 0), F.set(this, void 0), le.set(this, void 0), L.set(this, void 0), pe.set(this, void 0), $.set(this, void 0), Ee.set(this, void 0), __classPrivateFieldSet(this, Ee, er, "f"), __classPrivateFieldSet(this, p, Ie, "f"), typeof Ce != "string")
        throw new Error("Error: invalid descriptor type");
      const rr = lr({
        expression: Ce,
        ...tr !== void 0 ? { index: tr } : {},
        checksumRequired: Fe,
        network: er,
        allowMiniscriptInP2SH: Sr
      });
      if (rr.isRanged && tr === void 0)
        throw new Error("Error: index was not provided for ranged descriptor");
      if (!rr.payment)
        throw new Error(`Error: could not extract a payment from ${Ce}`);
      if (__classPrivateFieldSet(this, u, rr.payment, "f"), rr.expandedExpression !== void 0 && __classPrivateFieldSet(this, L, rr.expandedExpression, "f"), rr.miniscript !== void 0 && __classPrivateFieldSet(this, A, rr.miniscript, "f"), rr.expansionMap !== void 0 && __classPrivateFieldSet(this, $, rr.expansionMap, "f"), rr.isSegwit !== void 0 && __classPrivateFieldSet(this, le, rr.isSegwit, "f"), rr.expandedMiniscript !== void 0 && __classPrivateFieldSet(this, pe, rr.expandedMiniscript, "f"), rr.redeemScript !== void 0 && __classPrivateFieldSet(this, F, rr.redeemScript, "f"), rr.witnessScript !== void 0 && __classPrivateFieldSet(this, b, rr.witnessScript, "f"), xe)
        __classPrivateFieldSet(this, a, xe, "f");
      else if (__classPrivateFieldGet(this, $, "f"))
        __classPrivateFieldSet(this, a, Object.values(__classPrivateFieldGet(this, $, "f")).map((ar) => {
          const yr = ar.pubkey;
          if (!yr)
            throw new Error(`Error: could not extract a pubkey from ${Ce}`);
          return yr;
        }), "f");
      else {
        if (!rr.canonicalExpression.match(RE.reAddrAnchored))
          throw new Error(`Error: expansionMap not available for expression ${Ce} that is not an address`);
        __classPrivateFieldSet(this, a, [this.getScriptPubKey()], "f");
      }
    }
    getPayment() {
      return __classPrivateFieldGet(this, u, "f");
    }
    /**
     * Returns the Bitcoin Address
     */
    getAddress() {
      if (!__classPrivateFieldGet(this, u, "f").address)
        throw new Error("Error: could extract an address from the payment");
      return __classPrivateFieldGet(this, u, "f").address;
    }
    getScriptPubKey() {
      if (!__classPrivateFieldGet(this, u, "f").output)
        throw new Error("Error: could extract output.script from the payment");
      return __classPrivateFieldGet(this, u, "f").output;
    }
    /**
     * Returns the compiled script satisfaction
     * @param {PartialSig[]} signatures An array of signatures using this format: `interface PartialSig { pubkey: Buffer; signature: Buffer; }`
     * @returns {Buffer}
     */
    getScriptSatisfaction(Ce) {
      const tr = __classPrivateFieldGet(this, A, "f"), Fe = __classPrivateFieldGet(this, pe, "f"), Sr = __classPrivateFieldGet(this, $, "f");
      if (tr === void 0 || Fe === void 0 || Sr === void 0)
        throw new Error(`Error: cannot get satisfaction from not expanded miniscript ${tr}`);
      const er = (0, miniscript_1.satisfyMiniscript)({
        expandedMiniscript: Fe,
        expansionMap: Sr,
        signatures: Ce,
        preimages: __classPrivateFieldGet(this, p, "f"),
        //Here we pass the TimeConstraints obtained using signersPubKeys to
        //verify that the solutions found using the final signatures have not
        //changed
        timeConstraints: {
          nLockTime: this.getLockTime(),
          nSequence: this.getSequence()
        }
      }).scriptSatisfaction;
      if (!er)
        throw new Error("Error: could not produce a valid satisfaction");
      return er;
    }
    getSequence() {
      var Ce;
      return (Ce = __classPrivateFieldGet(this, c, "m", be).call(this)) == null ? void 0 : Ce.nSequence;
    }
    getLockTime() {
      var Ce;
      return (Ce = __classPrivateFieldGet(this, c, "m", be).call(this)) == null ? void 0 : Ce.nLockTime;
    }
    getWitnessScript() {
      return __classPrivateFieldGet(this, b, "f");
    }
    getRedeemScript() {
      return __classPrivateFieldGet(this, F, "f");
    }
    getNetwork() {
      return __classPrivateFieldGet(this, Ee, "f");
    }
    isSegwit() {
      return __classPrivateFieldGet(this, le, "f");
    }
    /**
     * Updates a Psbt where the descriptor describes an utxo.
     * The txHex (nonWitnessUtxo) and vout of the utxo must be passed.
     *
     * updatePsbt adds an input to the psbt and updates the tx locktime if needed.
     * It also adds a new input to the Psbt based on txHex
     * It returns the number of the input that is added.
     * psbt and vout are mandatory. Also pass txHex.
     *
     * The following is not recommended but, alternatively, ONLY for Segwit inputs,
     * you can pass txId and value, instead of txHex.
     * If you do so, it is your responsibility to make sure that `value` is
     * correct to avoid possible fee vulnerability attacks:
     * https://github.com/bitcoinjs/bitcoinjs-lib/issues/1625
     * Note that HW wallets require the full txHex also for Segwit anyways:
     * https://blog.trezor.io/details-of-firmware-updates-for-trezor-one-version-1-9-1-and-trezor-model-t-version-2-3-1-1eba8f60f2dd
     *
     * In doubt, simply pass txHex (and you can skip passing txId and value) and
     * you shall be fine.
     */
    updatePsbt({
      psbt: Ce,
      txHex: tr,
      txId: Fe,
      value: Sr,
      vout: er
      //vector output index
    }) {
      tr === void 0 && console.warn("Warning: missing txHex may allow fee attacks");
      const Ie = this.isSegwit();
      if (Ie === void 0)
        throw new Error("Error: could not determine whether this is a segwit descriptor");
      return (0, psbt_1.updatePsbt)({
        psbt: Ce,
        vout: er,
        ...tr !== void 0 ? { txHex: tr } : {},
        ...Fe !== void 0 ? { txId: Fe } : {},
        ...Sr !== void 0 ? { value: Sr } : {},
        sequence: this.getSequence(),
        locktime: this.getLockTime(),
        keysInfo: __classPrivateFieldGet(this, $, "f") ? Object.values(__classPrivateFieldGet(this, $, "f")) : [],
        scriptPubKey: this.getScriptPubKey(),
        isSegwit: Ie,
        witnessScript: this.getWitnessScript(),
        redeemScript: this.getRedeemScript()
      });
    }
    finalizePsbtInput({ index: Ce, psbt: tr, validate: Fe = !0 }) {
      var er;
      if (Fe && !tr.validateSignaturesOfInput(Ce, ir))
        throw new Error(`Error: invalid signatures on input ${Ce}`);
      const Sr = (er = tr.data.inputs[Ce]) == null ? void 0 : er.partialSig;
      if (!Sr)
        throw new Error("Error: cannot finalize without signatures");
      if (__classPrivateFieldGet(this, c, "m", He).call(this, { index: Ce, psbt: tr }), !__classPrivateFieldGet(this, A, "f"))
        tr.finalizeInput(Ce);
      else {
        const Ie = this.getScriptSatisfaction(Sr);
        tr.finalizeInput(Ce, (0, psbt_1.finalScriptsFuncFactory)(Ie, __classPrivateFieldGet(this, Ee, "f")));
      }
    }
    expand() {
      return {
        ...__classPrivateFieldGet(this, L, "f") !== void 0 ? { expandedExpression: __classPrivateFieldGet(this, L, "f") } : {},
        ...__classPrivateFieldGet(this, A, "f") !== void 0 ? { miniscript: __classPrivateFieldGet(this, A, "f") } : {},
        ...__classPrivateFieldGet(this, pe, "f") !== void 0 ? { expandedMiniscript: __classPrivateFieldGet(this, pe, "f") } : {},
        ...__classPrivateFieldGet(this, $, "f") !== void 0 ? { expansionMap: __classPrivateFieldGet(this, $, "f") } : {}
      };
    }
  }
  return u = /* @__PURE__ */ new WeakMap(), p = /* @__PURE__ */ new WeakMap(), a = /* @__PURE__ */ new WeakMap(), A = /* @__PURE__ */ new WeakMap(), b = /* @__PURE__ */ new WeakMap(), F = /* @__PURE__ */ new WeakMap(), le = /* @__PURE__ */ new WeakMap(), L = /* @__PURE__ */ new WeakMap(), pe = /* @__PURE__ */ new WeakMap(), $ = /* @__PURE__ */ new WeakMap(), Ee = /* @__PURE__ */ new WeakMap(), c = /* @__PURE__ */ new WeakSet(), be = function() {
    const Ce = __classPrivateFieldGet(this, A, "f"), tr = __classPrivateFieldGet(this, p, "f"), Fe = __classPrivateFieldGet(this, pe, "f"), Sr = __classPrivateFieldGet(this, $, "f"), er = __classPrivateFieldGet(this, a, "f");
    if (Ce) {
      if (Fe === void 0 || Sr === void 0)
        throw new Error(`Error: cannot get time constraints from not expanded miniscript ${Ce}`);
      const Ie = er.map((ar) => ({
        pubkey: ar,
        signature: Buffer$f.alloc(64, 0)
      })), { nLockTime: xe, nSequence: rr } = (0, miniscript_1.satisfyMiniscript)({
        expandedMiniscript: Fe,
        expansionMap: Sr,
        signatures: Ie,
        preimages: tr
      });
      return { nLockTime: xe, nSequence: rr };
    } else
      return;
  }, He = function({ psbt: Ce, index: tr }) {
    const Fe = Ce.data.inputs[tr], Sr = Ce.txInputs[tr];
    if (!Fe || !Sr)
      throw new Error("Error: invalid input or txInput");
    const { sequence: er, index: Ie } = Sr;
    let xe;
    if (Fe.witnessUtxo)
      xe = Fe.witnessUtxo.script;
    else {
      if (!Fe.nonWitnessUtxo)
        throw new Error("Error: input should have either witnessUtxo or nonWitnessUtxo");
      const _r = bitcoinjs_lib_1$6.Transaction.fromBuffer(Fe.nonWitnessUtxo).outs[Ie];
      if (!_r)
        throw new Error("Error: utxo should exist");
      xe = _r.script;
    }
    const rr = this.getLockTime() || 0;
    let ar = this.getSequence();
    if (ar === void 0 && rr !== 0 && (ar = 4294967294), ar === void 0 && rr === 0 && (ar = 4294967295), Buffer$f.compare(xe, this.getScriptPubKey()) !== 0 || ar !== er || rr !== Ce.locktime || this.getWitnessScript() !== Fe.witnessScript || this.getRedeemScript() !== Fe.redeemScript)
      throw new Error(`Error: cannot finalize psbt index ${tr} since it does not correspond to this descriptor`);
  }, { Descriptor: xr, parseKeyExpression: or, expand: lr, ECPair: nr, BIP32: Pe };
}
descriptors$1.DescriptorsFactory = DescriptorsFactory;
var signers = {};
Object.defineProperty(signers, "__esModule", { value: !0 });
signers.signLedger = signers.signInputLedger = signers.signBIP32 = signers.signInputBIP32 = signers.signECPair = signers.signInputECPair = void 0;
const ledger_1 = ledger;
function signInputECPair({ psbt: n, index: c, ecpair: u }) {
  n.signInput(c, u);
}
signers.signInputECPair = signInputECPair;
function signECPair({ psbt: n, ecpair: c }) {
  n.signAllInputs(c);
}
signers.signECPair = signECPair;
function signInputBIP32({ psbt: n, index: c, node: u }) {
  n.signInputHD(c, u);
}
signers.signInputBIP32 = signInputBIP32;
function signBIP32({ psbt: n, masterNode: c }) {
  n.signAllInputsHD(c);
}
signers.signBIP32 = signBIP32;
const ledgerSignaturesForInputIndex = (n, c) => c.filter(([u]) => u === n).map(([u, p]) => ({
  pubkey: p.pubkey,
  signature: p.signature
}));
async function signInputLedger({ psbt: n, index: c, descriptor: u, ledgerClient: p, ledgerState: a }) {
  const { PsbtV2: A, DefaultWalletPolicy: b, WalletPolicy: F, AppClient: le } = await (0, ledger_1.importAndValidateLedgerBitcoin)(p);
  if (!(p instanceof le))
    throw new Error("Error: pass a valid ledgerClient");
  const L = await (0, ledger_1.descriptorToLedgerFormat)({
    descriptor: u,
    ledgerClient: p,
    ledgerState: a
  });
  if (!L)
    throw new Error("Error: descriptor does not have a ledger input");
  const { ledgerTemplate: pe, keyRoots: $ } = L;
  let Ee;
  if (await (0, ledger_1.ledgerPolicyFromStandard)({
    descriptor: u,
    ledgerClient: p,
    ledgerState: a
  }))
    Ee = await p.signPsbt(new A().fromBitcoinJS(n), new b(pe, $[0]), null);
  else {
    const He = await (0, ledger_1.ledgerPolicyFromState)({
      descriptor: u,
      ledgerClient: p,
      ledgerState: a
    });
    if (!He || !He.policyName || !He.policyHmac)
      throw new Error("Error: the descriptor's policy is not registered");
    const Pe = new F(He.policyName, pe, $);
    Ee = await p.signPsbt(new A().fromBitcoinJS(n), Pe, He.policyHmac);
  }
  n.updateInput(c, {
    partialSig: ledgerSignaturesForInputIndex(c, Ee)
  });
}
signers.signInputLedger = signInputLedger;
async function signLedger({ psbt: n, descriptors: c, ledgerClient: u, ledgerState: p }) {
  const { PsbtV2: a, DefaultWalletPolicy: A, WalletPolicy: b, AppClient: F } = await (0, ledger_1.importAndValidateLedgerBitcoin)(u);
  if (!(u instanceof F))
    throw new Error("Error: pass a valid ledgerClient");
  const le = [];
  for (const pe of c) {
    const $ = await (0, ledger_1.ledgerPolicyFromState)({
      descriptor: pe,
      ledgerClient: u,
      ledgerState: p
    }) || await (0, ledger_1.ledgerPolicyFromStandard)({
      descriptor: pe,
      ledgerClient: u,
      ledgerState: p
    });
    $ && le.push($);
  }
  if (le.length === 0)
    throw new Error("Error: there are no inputs which could be signed");
  const L = [];
  for (const pe of le)
    L.find(($) => (0, ledger_1.comparePolicies)($, pe)) || L.push(pe);
  for (const pe of L) {
    let $;
    if (pe.policyName && pe.policyHmac && pe.policyId) {
      const Ee = new b(pe.policyName, pe.ledgerTemplate, pe.keyRoots);
      $ = await u.signPsbt(new a().fromBitcoinJS(n), Ee, pe.policyHmac);
    } else
      $ = await u.signPsbt(new a().fromBitcoinJS(n), new A(pe.ledgerTemplate, pe.keyRoots[0]), null);
    for (const [Ee, ,] of $)
      n.updateInput(Ee, {
        partialSig: ledgerSignaturesForInputIndex(Ee, $)
      });
  }
}
signers.signLedger = signLedger;
var scriptExpressions = {};
Object.defineProperty(scriptExpressions, "__esModule", { value: !0 });
scriptExpressions.wpkhLedger = scriptExpressions.shWpkhLedger = scriptExpressions.pkhLedger = scriptExpressions.wpkhBIP32 = scriptExpressions.shWpkhBIP32 = scriptExpressions.pkhBIP32 = void 0;
const bitcoinjs_lib_1$5 = src$j, keyExpressions_1 = keyExpressions;
function assertStandardKeyPath(n) {
  if (!/^\/[01]\/(\d+|\*)$/.test(n))
    throw new Error("Error: Key path must be in the format '/change/index', where change is either 0 or 1 and index is a non-negative integer.");
}
function standardExpressionsBIP32Maker(n, c) {
  function u({ masterNode: p, network: a = bitcoinjs_lib_1$5.networks.bitcoin, keyPath: A, account: b, change: F, index: le, isPublic: L = !0 }) {
    const pe = `/${n}'/${a === bitcoinjs_lib_1$5.networks.bitcoin ? 0 : 1}'/${b}'`;
    A !== void 0 && assertStandardKeyPath(A);
    const $ = (0, keyExpressions_1.keyExpressionBIP32)({
      masterNode: p,
      originPath: pe,
      keyPath: A,
      change: F,
      index: le,
      isPublic: L
    });
    return c.replace("KEYEXPRESSION", $);
  }
  return u;
}
scriptExpressions.pkhBIP32 = standardExpressionsBIP32Maker(44, "pkh(KEYEXPRESSION)");
scriptExpressions.shWpkhBIP32 = standardExpressionsBIP32Maker(49, "sh(wpkh(KEYEXPRESSION))");
scriptExpressions.wpkhBIP32 = standardExpressionsBIP32Maker(84, "wpkh(KEYEXPRESSION)");
function standardExpressionsLedgerMaker(n, c) {
  async function u({ ledgerClient: p, ledgerState: a, network: A = bitcoinjs_lib_1$5.networks.bitcoin, account: b, keyPath: F, change: le, index: L }) {
    const pe = `/${n}'/${A === bitcoinjs_lib_1$5.networks.bitcoin ? 0 : 1}'/${b}'`;
    F !== void 0 && assertStandardKeyPath(F);
    const $ = await (0, keyExpressions_1.keyExpressionLedger)({
      ledgerClient: p,
      ledgerState: a,
      originPath: pe,
      keyPath: F,
      change: le,
      index: L
    });
    return c.replace("KEYEXPRESSION", $);
  }
  return u;
}
scriptExpressions.pkhLedger = standardExpressionsLedgerMaker(44, "pkh(KEYEXPRESSION)");
scriptExpressions.shWpkhLedger = standardExpressionsLedgerMaker(49, "sh(wpkh(KEYEXPRESSION))");
scriptExpressions.wpkhLedger = standardExpressionsLedgerMaker(84, "wpkh(KEYEXPRESSION)");
(function(n) {
  var c = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function($, Ee, be, He) {
    He === void 0 && (He = be);
    var Pe = Object.getOwnPropertyDescriptor(Ee, be);
    (!Pe || ("get" in Pe ? !Ee.__esModule : Pe.writable || Pe.configurable)) && (Pe = { enumerable: !0, get: function() {
      return Ee[be];
    } }), Object.defineProperty($, He, Pe);
  } : function($, Ee, be, He) {
    He === void 0 && (He = be), $[He] = Ee[be];
  }), u = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function($, Ee) {
    Object.defineProperty($, "default", { enumerable: !0, value: Ee });
  } : function($, Ee) {
    $.default = Ee;
  }), p = commonjsGlobal && commonjsGlobal.__importStar || function($) {
    if ($ && $.__esModule) return $;
    var Ee = {};
    if ($ != null) for (var be in $) be !== "default" && Object.prototype.hasOwnProperty.call($, be) && c(Ee, $, be);
    return u(Ee, $), Ee;
  };
  Object.defineProperty(n, "__esModule", { value: !0 }), n.ledger = n.scriptExpressions = n.keyExpressionLedger = n.keyExpressionBIP32 = n.finalizePsbt = n.signers = n.checksum = n.DescriptorsFactory = void 0;
  var a = descriptors$1;
  Object.defineProperty(n, "DescriptorsFactory", { enumerable: !0, get: function() {
    return a.DescriptorsFactory;
  } });
  var A = checksum;
  Object.defineProperty(n, "checksum", { enumerable: !0, get: function() {
    return A.DescriptorChecksum;
  } });
  const b = p(signers);
  n.signers = b;
  function F({ psbt: $, descriptors: Ee, validate: be = !0 }) {
    Ee.forEach((He, Pe) => He.finalizePsbtInput({ index: Pe, psbt: $, validate: be }));
  }
  n.finalizePsbt = F;
  var le = keyExpressions;
  Object.defineProperty(n, "keyExpressionBIP32", { enumerable: !0, get: function() {
    return le.keyExpressionBIP32;
  } }), Object.defineProperty(n, "keyExpressionLedger", { enumerable: !0, get: function() {
    return le.keyExpressionLedger;
  } });
  const L = p(scriptExpressions);
  n.scriptExpressions = L;
  const pe = ledger;
  n.ledger = {
    getLedgerMasterFingerPrint: pe.getLedgerMasterFingerPrint,
    getLedgerXpub: pe.getLedgerXpub,
    registerLedgerWallet: pe.registerLedgerWallet,
    assertLedgerApp: pe.assertLedgerApp
  };
})(dist$1);
var bip32 = {}, __importDefault$1 = commonjsGlobal && commonjsGlobal.__importDefault || function(n) {
  return n && n.__esModule ? n : { default: n };
};
Object.defineProperty(bip32, "__esModule", { value: !0 });
bip32.hardenedPathOf = bip32.getXpubComponents = bip32.pubkeyFromXpub = bip32.pathStringToArray = bip32.pathArrayToString = bip32.bip32asBuffer = bip32.pathElementsToBuffer = void 0;
const bip32_path_1 = __importDefault$1(bip32Path), bs58check_1 = __importDefault$1(bs58check$k);
function pathElementsToBuffer(n) {
  const c = Buffer$f.alloc(1 + n.length * 4);
  return c[0] = n.length, n.forEach((u, p) => {
    c.writeUInt32BE(u, 1 + 4 * p);
  }), c;
}
bip32.pathElementsToBuffer = pathElementsToBuffer;
function bip32asBuffer(n) {
  const c = n ? pathStringToArray(n) : [];
  return pathElementsToBuffer(c);
}
bip32.bip32asBuffer = bip32asBuffer;
function pathArrayToString(n) {
  return n.length == 0 ? "m" : bip32_path_1.default.fromPathArray(n).toString();
}
bip32.pathArrayToString = pathArrayToString;
function pathStringToArray(n) {
  return n == "m" || n == "" ? [] : bip32_path_1.default.fromString(n).toPathArray();
}
bip32.pathStringToArray = pathStringToArray;
function pubkeyFromXpub(n) {
  const c = Buffer$f.from(bs58check_1.default.decode(n));
  return c.slice(c.length - 33);
}
bip32.pubkeyFromXpub = pubkeyFromXpub;
function getXpubComponents(n) {
  const c = Buffer$f.from(bs58check_1.default.decode(n));
  return {
    chaincode: c.slice(13, 45),
    pubkey: c.slice(c.length - 33),
    version: c.readUInt32BE(0)
  };
}
bip32.getXpubComponents = getXpubComponents;
function hardenedPathOf(n) {
  for (let c = n.length - 1; c >= 0; c--)
    if (n[c] >= 2147483648)
      return n.slice(0, c + 1);
  return [];
}
bip32.hardenedPathOf = hardenedPathOf;
var clientCommands = {}, buffertools = {}, varint = {};
Object.defineProperty(varint, "__esModule", { value: !0 });
varint.createVarint = varint.parseVarint = varint.sanitizeBigintToNumber = void 0;
function bigintToSmallEndian(n, c, u, p) {
  for (let a = 0; a < c; a++) {
    if (u[a + p] == null)
      throw Error("Buffer too small");
    u[a + p] = Number(n % BigInt(256)), n = n >> BigInt(8);
  }
}
function smallEndianToBigint(n, c, u) {
  let p = BigInt(0);
  for (let a = 0; a < u; a++) {
    if (n[a + c] == null)
      throw Error("Buffer too small");
    p += BigInt(n[a + c]) << BigInt(a * 8);
  }
  return p;
}
function sanitizeBigintToNumber(n) {
  if (n < 0)
    throw RangeError("Negative bigint is not a valid varint");
  if (n > Number.MAX_SAFE_INTEGER)
    throw RangeError("Too large for a Number");
  return Number(n);
}
varint.sanitizeBigintToNumber = sanitizeBigintToNumber;
function getVarintSize(n) {
  if (typeof n == "number" && (n = sanitizeBigintToNumber(n)), n < BigInt(0))
    throw new RangeError("Negative numbers are not supported");
  if (n >= BigInt(1) << BigInt(64))
    throw new RangeError("Too large for a Bitcoin-style varint");
  return n < BigInt(253) ? 1 : n <= BigInt(65535) ? 3 : n <= BigInt(4294967295) ? 5 : 9;
}
function parseVarint(n, c) {
  if (c < 0)
    throw RangeError("Negative offset is invalid");
  if (n[c] == null)
    throw Error("Buffer too small");
  if (n[c] < 253)
    return [BigInt(n[c]), 1];
  {
    let u;
    return n[c] === 253 ? u = 2 : n[c] === 254 ? u = 4 : u = 8, [smallEndianToBigint(n, c + 1, u), u + 1];
  }
}
varint.parseVarint = parseVarint;
function createVarint(n) {
  typeof n == "number" && (n = sanitizeBigintToNumber(n));
  const c = getVarintSize(n);
  n = BigInt(n);
  const u = Buffer$f.alloc(c);
  return c == 1 ? u[0] = Number(n) : (c == 3 ? u[0] = 253 : c === 5 ? u[0] = 254 : u[0] = 255, bigintToSmallEndian(n, c - 1, u, 1)), u;
}
varint.createVarint = createVarint;
Object.defineProperty(buffertools, "__esModule", { value: !0 });
buffertools.BufferReader = buffertools.BufferWriter = buffertools.numberToLE = buffertools.unsafeFrom64bitLE = buffertools.unsafeTo64bitLE = void 0;
const varint_1$3 = varint;
function unsafeTo64bitLE(n) {
  if (n > Number.MAX_SAFE_INTEGER)
    throw new Error("Can't convert numbers > MAX_SAFE_INT");
  const c = Buffer$f.alloc(8, 0);
  for (let u = 0; u < c.length; u++) {
    const p = n & 255;
    c[u] = p, n = (n - p) / 256;
  }
  return c;
}
buffertools.unsafeTo64bitLE = unsafeTo64bitLE;
function unsafeFrom64bitLE(n) {
  let c = 0;
  if (n.length != 8)
    throw new Error("Expected Bufffer of lenght 8");
  if (n[7] != 0)
    throw new Error("Can't encode numbers > MAX_SAFE_INT");
  if (n[6] > 31)
    throw new Error("Can't encode numbers > MAX_SAFE_INT");
  for (let u = n.length - 1; u >= 0; u--)
    c = c * 256 + n[u];
  return c;
}
buffertools.unsafeFrom64bitLE = unsafeFrom64bitLE;
function numberToLE(n, c = 32) {
  if (!Number.isInteger(n) || n < 0)
    throw new RangeError("value must be a non-negative integer");
  if (!Number.isInteger(c) || c < 1)
    throw new RangeError("byteLen must be a positive integer");
  const u = Math.pow(256, c);
  if (n >= u)
    throw new RangeError(`value too large to fit in ${c} bytes (max ${u - 1})`);
  const p = Buffer$f.alloc(c);
  let a = n;
  for (let A = 0; A < c; A++)
    p[A] = a % 256, a = Math.floor(a / 256);
  return p;
}
buffertools.numberToLE = numberToLE;
class BufferWriter {
  constructor() {
    this.bufs = [];
  }
  write(c, u) {
    const p = Buffer$f.alloc(c);
    u(p), this.bufs.push(p);
  }
  writeUInt8(c) {
    this.write(1, (u) => u.writeUInt8(c, 0));
  }
  writeInt32(c) {
    this.write(4, (u) => u.writeInt32LE(c, 0));
  }
  writeUInt32(c) {
    this.write(4, (u) => u.writeUInt32LE(c, 0));
  }
  writeUInt64(c) {
    const u = unsafeTo64bitLE(c);
    this.writeSlice(u);
  }
  writeVarInt(c) {
    this.bufs.push((0, varint_1$3.createVarint)(c));
  }
  writeSlice(c) {
    this.bufs.push(Buffer$f.from(c));
  }
  writeVarSlice(c) {
    this.writeVarInt(c.length), this.writeSlice(c);
  }
  buffer() {
    return Buffer$f.concat(this.bufs);
  }
}
buffertools.BufferWriter = BufferWriter;
class BufferReader {
  constructor(c, u = 0) {
    this.buffer = c, this.offset = u;
  }
  available() {
    return this.buffer.length - this.offset;
  }
  readUInt8() {
    const c = this.buffer.readUInt8(this.offset);
    return this.offset++, c;
  }
  readInt32() {
    const c = this.buffer.readInt32LE(this.offset);
    return this.offset += 4, c;
  }
  readUInt32() {
    const c = this.buffer.readUInt32LE(this.offset);
    return this.offset += 4, c;
  }
  readUInt64() {
    const c = this.readSlice(8);
    return unsafeFrom64bitLE(c);
  }
  readVarInt() {
    const [c, u] = (0, varint_1$3.parseVarint)(this.buffer, this.offset);
    return this.offset += u, c;
  }
  readSlice(c) {
    if (this.buffer.length < this.offset + c)
      throw new Error("Cannot read slice out of bounds");
    const u = this.buffer.slice(this.offset, this.offset + c);
    return this.offset += c, u;
  }
  readVarSlice() {
    const c = (0, varint_1$3.sanitizeBigintToNumber)(this.readVarInt());
    return this.readSlice(c);
  }
  readVector() {
    const c = this.readVarInt(), u = [];
    for (let p = 0; p < c; p++)
      u.push(this.readVarSlice());
    return u;
  }
}
buffertools.BufferReader = BufferReader;
var merkle = {};
Object.defineProperty(merkle, "__esModule", { value: !0 });
merkle.hashLeaf = merkle.Merkle = void 0;
const bitcoinjs_lib_1$4 = src$j;
class Merkle {
  constructor(c, u = bitcoinjs_lib_1$4.crypto.sha256) {
    this.leaves = c, this.h = u;
    const p = this.calculateRoot(c);
    this.rootNode = p.root, this.leafNodes = p.leaves;
  }
  getRoot() {
    return this.rootNode.hash;
  }
  size() {
    return this.leaves.length;
  }
  getLeaves() {
    return this.leaves;
  }
  getLeafHash(c) {
    return this.leafNodes[c].hash;
  }
  getProof(c) {
    if (c >= this.leaves.length)
      throw Error("Index out of bounds");
    return proveNode(this.leafNodes[c]);
  }
  calculateRoot(c) {
    const u = c.length;
    if (u == 0)
      return {
        root: new Node(void 0, void 0, Buffer$f.alloc(32, 0)),
        leaves: []
      };
    if (u == 1) {
      const pe = new Node(void 0, void 0, c[0]);
      return { root: pe, leaves: [pe] };
    }
    const p = highestPowerOf2LessThan(u), a = this.calculateRoot(c.slice(0, p)), A = this.calculateRoot(c.slice(p)), b = a.root, F = A.root, le = this.hashNode(b.hash, F.hash), L = new Node(b, F, le);
    return b.parent = L, F.parent = L, { root: L, leaves: a.leaves.concat(A.leaves) };
  }
  hashNode(c, u) {
    return this.h(Buffer$f.concat([Buffer$f.from([1]), c, u]));
  }
}
merkle.Merkle = Merkle;
function hashLeaf(n, c = bitcoinjs_lib_1$4.crypto.sha256) {
  return hashConcat(Buffer$f.from([0]), n, c);
}
merkle.hashLeaf = hashLeaf;
function hashConcat(n, c, u) {
  return u(Buffer$f.concat([n, c]));
}
class Node {
  constructor(c, u, p) {
    this.leftChild = c, this.rightChild = u, this.hash = p;
  }
  isLeaf() {
    return this.leftChild == null;
  }
}
function proveNode(n) {
  if (!n.parent)
    return [];
  if (n.parent.leftChild == n) {
    if (!n.parent.rightChild)
      throw new Error("Expected right child to exist");
    return [n.parent.rightChild.hash, ...proveNode(n.parent)];
  } else {
    if (!n.parent.leftChild)
      throw new Error("Expected left child to exist");
    return [n.parent.leftChild.hash, ...proveNode(n.parent)];
  }
}
function highestPowerOf2LessThan(n) {
  if (n < 2)
    throw Error("Expected n >= 2");
  return isPowerOf2(n) ? n / 2 : 1 << Math.floor(Math.log2(n));
}
function isPowerOf2(n) {
  return (n & n - 1) == 0;
}
Object.defineProperty(clientCommands, "__esModule", { value: !0 });
clientCommands.ClientCommandInterpreter = clientCommands.GetMoreElementsCommand = clientCommands.GetMerkleLeafIndexCommand = clientCommands.GetMerkleLeafProofCommand = clientCommands.GetPreimageCommand = clientCommands.YieldCommand = void 0;
const bitcoinjs_lib_1$3 = src$j, buffertools_1$1 = buffertools, merkle_1$3 = merkle, varint_1$2 = varint;
var ClientCommandCode;
(function(n) {
  n[n.YIELD = 16] = "YIELD", n[n.GET_PREIMAGE = 64] = "GET_PREIMAGE", n[n.GET_MERKLE_LEAF_PROOF = 65] = "GET_MERKLE_LEAF_PROOF", n[n.GET_MERKLE_LEAF_INDEX = 66] = "GET_MERKLE_LEAF_INDEX", n[n.GET_MORE_ELEMENTS = 160] = "GET_MORE_ELEMENTS";
})(ClientCommandCode || (ClientCommandCode = {}));
class ClientCommand {
}
class YieldCommand extends ClientCommand {
  constructor(c, u) {
    super(), this.progressCallback = u, this.code = ClientCommandCode.YIELD, this.results = c;
  }
  execute(c) {
    return this.results.push(Buffer$f.from(c.subarray(1))), this.progressCallback && this.progressCallback(), Buffer$f.from("");
  }
}
clientCommands.YieldCommand = YieldCommand;
class GetPreimageCommand extends ClientCommand {
  constructor(c, u) {
    super(), this.code = ClientCommandCode.GET_PREIMAGE, this.known_preimages = c, this.queue = u;
  }
  execute(c) {
    const u = Buffer$f.from(c.subarray(1));
    if (u.length != 33)
      throw new Error("Invalid request, unexpected trailing data");
    if (u[0] != 0)
      throw new Error("Unsupported request, the first byte should be 0");
    const p = Buffer$f.alloc(32);
    for (let b = 0; b < 32; b++)
      p[b] = u[1 + b];
    const a = p.toString("hex"), A = this.known_preimages.get(a);
    if (A != null) {
      const b = (0, varint_1$2.createVarint)(A.length), F = 255 - b.length - 1, le = Math.min(F, A.length);
      if (le < A.length)
        for (let L = le; L < A.length; L++)
          this.queue.push(Buffer$f.from([A[L]]));
      return Buffer$f.concat([
        b,
        Buffer$f.from([le]),
        Buffer$f.from(A.subarray(0, le))
      ]);
    }
    throw Error(`Requested unknown preimage for: ${a}`);
  }
}
clientCommands.GetPreimageCommand = GetPreimageCommand;
class GetMerkleLeafProofCommand extends ClientCommand {
  constructor(c, u) {
    super(), this.code = ClientCommandCode.GET_MERKLE_LEAF_PROOF, this.known_trees = c, this.queue = u;
  }
  execute(c) {
    const u = Buffer$f.from(c.subarray(1));
    if (u.length < 34)
      throw new Error("Invalid request, expected at least 34 bytes");
    const p = new buffertools_1$1.BufferReader(u), A = p.readSlice(32).toString("hex");
    let b, F;
    try {
      b = (0, varint_1$2.sanitizeBigintToNumber)(p.readVarInt()), F = (0, varint_1$2.sanitizeBigintToNumber)(p.readVarInt());
    } catch {
      throw new Error("Invalid request, couldn't parse tree_size or leaf_index");
    }
    const le = this.known_trees.get(A);
    if (!le)
      throw Error(`Requested Merkle leaf proof for unknown tree: ${A}`);
    if (F >= b || le.size() != b)
      throw Error("Invalid index or tree size.");
    if (this.queue.length != 0)
      throw Error("This command should not execute when the queue is not empty.");
    const L = le.getProof(F), pe = Math.min(Math.floor(221 / 32), L.length), $ = L.length - pe;
    return $ > 0 && this.queue.push(...L.slice(-$)), Buffer$f.concat([
      le.getLeafHash(F),
      Buffer$f.from([L.length]),
      Buffer$f.from([pe]),
      ...L.slice(0, pe)
    ]);
  }
}
clientCommands.GetMerkleLeafProofCommand = GetMerkleLeafProofCommand;
class GetMerkleLeafIndexCommand extends ClientCommand {
  constructor(c) {
    super(), this.code = ClientCommandCode.GET_MERKLE_LEAF_INDEX, this.known_trees = c;
  }
  execute(c) {
    const u = Buffer$f.from(c.subarray(1));
    if (u.length != 64)
      throw new Error("Invalid request, unexpected trailing data");
    const p = Buffer$f.alloc(32);
    for (let pe = 0; pe < 32; pe++)
      p[pe] = u.readUInt8(pe);
    const a = p.toString("hex"), A = Buffer$f.alloc(32);
    for (let pe = 0; pe < 32; pe++)
      A[pe] = u.readUInt8(32 + pe);
    const b = A.toString("hex"), F = this.known_trees.get(a);
    if (!F)
      throw Error(`Requested Merkle leaf index for unknown root: ${a}`);
    let le = 0, L = 0;
    for (let pe = 0; pe < F.size(); pe++)
      if (F.getLeafHash(pe).toString("hex") == b) {
        L = 1, le = pe;
        break;
      }
    return Buffer$f.concat([Buffer$f.from([L]), (0, varint_1$2.createVarint)(le)]);
  }
}
clientCommands.GetMerkleLeafIndexCommand = GetMerkleLeafIndexCommand;
class GetMoreElementsCommand extends ClientCommand {
  constructor(c) {
    super(), this.code = ClientCommandCode.GET_MORE_ELEMENTS, this.queue = c;
  }
  execute(c) {
    if (c.length != 1)
      throw new Error("Invalid request, unexpected trailing data");
    if (this.queue.length === 0)
      throw new Error("No elements to get");
    const u = this.queue[0].length;
    if (this.queue.some((b) => b.length != u))
      throw new Error("The queue contains elements with different byte length, which is not expected");
    const p = Math.floor(253 / u), a = Math.min(p, this.queue.length), A = this.queue.splice(0, a);
    return Buffer$f.concat([
      Buffer$f.from([a]),
      Buffer$f.from([u]),
      ...A
    ]);
  }
}
clientCommands.GetMoreElementsCommand = GetMoreElementsCommand;
class ClientCommandInterpreter {
  constructor(c) {
    this.roots = /* @__PURE__ */ new Map(), this.preimages = /* @__PURE__ */ new Map(), this.yielded = [], this.queue = [], this.commands = /* @__PURE__ */ new Map();
    const u = [
      new YieldCommand(this.yielded, c),
      new GetPreimageCommand(this.preimages, this.queue),
      new GetMerkleLeafIndexCommand(this.roots),
      new GetMerkleLeafProofCommand(this.roots, this.queue),
      new GetMoreElementsCommand(this.queue)
    ];
    for (const p of u) {
      if (this.commands.has(p.code))
        throw new Error(`Multiple commands with code ${p.code}`);
      this.commands.set(p.code, p);
    }
  }
  getYielded() {
    return this.yielded;
  }
  addKnownPreimage(c) {
    this.preimages.set(bitcoinjs_lib_1$3.crypto.sha256(c).toString("hex"), c);
  }
  addKnownList(c) {
    for (const p of c) {
      const a = Buffer$f.concat([Buffer$f.from([0]), p]);
      this.addKnownPreimage(a);
    }
    const u = new merkle_1$3.Merkle(c.map((p) => (0, merkle_1$3.hashLeaf)(p)));
    this.roots.set(u.getRoot().toString("hex"), u);
  }
  addKnownMapping(c) {
    this.addKnownList(c.keys), this.addKnownList(c.values);
  }
  addKnownWalletPolicy(c) {
    this.addKnownPreimage(c.serialize()), this.addKnownList(c.keys.map((u) => Buffer$f.from(u, "ascii"))), this.addKnownPreimage(Buffer$f.from(c.descriptorTemplate));
  }
  execute(c) {
    if (c.length == 0)
      throw new Error("Unexpected empty command");
    const u = c[0], p = this.commands.get(u);
    if (!p)
      throw new Error(`Unexpected command code ${u}`);
    return p.execute(c);
  }
}
clientCommands.ClientCommandInterpreter = ClientCommandInterpreter;
var merkelizedPsbt = {}, merkleMap = {};
Object.defineProperty(merkleMap, "__esModule", { value: !0 });
merkleMap.MerkleMap = void 0;
const merkle_1$2 = merkle, varint_1$1 = varint;
class MerkleMap {
  /**
   * @param keys Sorted list of (unhashed) keys
   * @param values values, in corresponding order as the keys, and of equal length
   */
  constructor(c, u) {
    if (c.length != u.length)
      throw new Error("keys and values should have the same length");
    for (let p = 0; p < c.length - 1; p++)
      if (c[p].toString("hex") >= c[p + 1].toString("hex"))
        throw new Error("keys must be in strictly increasing order");
    this.keys = c, this.keysTree = new merkle_1$2.Merkle(c.map((p) => (0, merkle_1$2.hashLeaf)(p))), this.values = u, this.valuesTree = new merkle_1$2.Merkle(u.map((p) => (0, merkle_1$2.hashLeaf)(p)));
  }
  commitment() {
    return Buffer$f.concat([
      (0, varint_1$1.createVarint)(this.keys.length),
      this.keysTree.getRoot(),
      this.valuesTree.getRoot()
    ]);
  }
}
merkleMap.MerkleMap = MerkleMap;
var psbtv2 = {};
(function(n) {
  var c = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(tr, Fe, Sr, er) {
    er === void 0 && (er = Sr);
    var Ie = Object.getOwnPropertyDescriptor(Fe, Sr);
    (!Ie || ("get" in Ie ? !Fe.__esModule : Ie.writable || Ie.configurable)) && (Ie = { enumerable: !0, get: function() {
      return Fe[Sr];
    } }), Object.defineProperty(tr, er, Ie);
  } : function(tr, Fe, Sr, er) {
    er === void 0 && (er = Sr), tr[er] = Fe[Sr];
  }), u = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(tr, Fe) {
    Object.defineProperty(tr, "default", { enumerable: !0, value: Fe });
  } : function(tr, Fe) {
    tr.default = Fe;
  }), p = commonjsGlobal && commonjsGlobal.__importStar || function(tr) {
    if (tr && tr.__esModule) return tr;
    var Fe = {};
    if (tr != null) for (var Sr in tr) Sr !== "default" && Object.prototype.hasOwnProperty.call(tr, Sr) && c(Fe, tr, Sr);
    return u(Fe, tr), Fe;
  };
  Object.defineProperty(n, "__esModule", { value: !0 }), n.PsbtV2 = n.NoSuchEntry = n.psbtOut = n.psbtIn = n.psbtGlobal = void 0;
  const a = p(src$j), A = buffertools, b = varint;
  var F;
  (function(tr) {
    tr[tr.UNSIGNED_TX = 0] = "UNSIGNED_TX", tr[tr.XPUB = 1] = "XPUB", tr[tr.TX_VERSION = 2] = "TX_VERSION", tr[tr.FALLBACK_LOCKTIME = 3] = "FALLBACK_LOCKTIME", tr[tr.INPUT_COUNT = 4] = "INPUT_COUNT", tr[tr.OUTPUT_COUNT = 5] = "OUTPUT_COUNT", tr[tr.TX_MODIFIABLE = 6] = "TX_MODIFIABLE", tr[tr.VERSION = 251] = "VERSION";
  })(F = n.psbtGlobal || (n.psbtGlobal = {}));
  var le;
  (function(tr) {
    tr[tr.NON_WITNESS_UTXO = 0] = "NON_WITNESS_UTXO", tr[tr.WITNESS_UTXO = 1] = "WITNESS_UTXO", tr[tr.PARTIAL_SIG = 2] = "PARTIAL_SIG", tr[tr.SIGHASH_TYPE = 3] = "SIGHASH_TYPE", tr[tr.REDEEM_SCRIPT = 4] = "REDEEM_SCRIPT", tr[tr.WITNESS_SCRIPT = 5] = "WITNESS_SCRIPT", tr[tr.BIP32_DERIVATION = 6] = "BIP32_DERIVATION", tr[tr.FINAL_SCRIPTSIG = 7] = "FINAL_SCRIPTSIG", tr[tr.FINAL_SCRIPTWITNESS = 8] = "FINAL_SCRIPTWITNESS", tr[tr.PREVIOUS_TXID = 14] = "PREVIOUS_TXID", tr[tr.OUTPUT_INDEX = 15] = "OUTPUT_INDEX", tr[tr.SEQUENCE = 16] = "SEQUENCE", tr[tr.TAP_KEY_SIG = 19] = "TAP_KEY_SIG", tr[tr.TAP_BIP32_DERIVATION = 22] = "TAP_BIP32_DERIVATION";
  })(le = n.psbtIn || (n.psbtIn = {}));
  var L;
  (function(tr) {
    tr[tr.REDEEM_SCRIPT = 0] = "REDEEM_SCRIPT", tr[tr.WITNESS_SCRIPT = 1] = "WITNESS_SCRIPT", tr[tr.BIP_32_DERIVATION = 2] = "BIP_32_DERIVATION", tr[tr.AMOUNT = 3] = "AMOUNT", tr[tr.SCRIPT = 4] = "SCRIPT", tr[tr.TAP_BIP32_DERIVATION = 7] = "TAP_BIP32_DERIVATION";
  })(L = n.psbtOut || (n.psbtOut = {}));
  const pe = Buffer$f.from([112, 115, 98, 116, 255]);
  class $ extends Error {
  }
  n.NoSuchEntry = $;
  class Ee {
    constructor() {
      this.globalMap = /* @__PURE__ */ new Map(), this.inputMaps = [], this.outputMaps = [];
    }
    setGlobalTxVersion(Fe) {
      this.setGlobal(F.TX_VERSION, Ir(Fe));
    }
    getGlobalTxVersion() {
      return this.getGlobal(F.TX_VERSION).readUInt32LE(0);
    }
    setGlobalFallbackLocktime(Fe) {
      this.setGlobal(F.FALLBACK_LOCKTIME, Ir(Fe));
    }
    getGlobalFallbackLocktime() {
      var Fe;
      return (Fe = this.getGlobalOptional(F.FALLBACK_LOCKTIME)) === null || Fe === void 0 ? void 0 : Fe.readUInt32LE(0);
    }
    setGlobalInputCount(Fe) {
      this.setGlobal(F.INPUT_COUNT, kr(Fe));
    }
    getGlobalInputCount() {
      return Ce(this.getGlobal(F.INPUT_COUNT));
    }
    setGlobalOutputCount(Fe) {
      this.setGlobal(F.OUTPUT_COUNT, kr(Fe));
    }
    getGlobalOutputCount() {
      return Ce(this.getGlobal(F.OUTPUT_COUNT));
    }
    setGlobalTxModifiable(Fe) {
      this.setGlobal(F.TX_MODIFIABLE, Fe);
    }
    getGlobalTxModifiable() {
      return this.getGlobalOptional(F.TX_MODIFIABLE);
    }
    setGlobalPsbtVersion(Fe) {
      this.setGlobal(F.VERSION, Ir(Fe));
    }
    getGlobalPsbtVersion() {
      return this.getGlobal(F.VERSION).readUInt32LE(0);
    }
    setInputNonWitnessUtxo(Fe, Sr) {
      this.setInput(Fe, le.NON_WITNESS_UTXO, or(), Sr);
    }
    getInputNonWitnessUtxo(Fe) {
      return this.getInputOptional(Fe, le.NON_WITNESS_UTXO, or());
    }
    setInputWitnessUtxo(Fe, Sr, er) {
      const Ie = new A.BufferWriter();
      Ie.writeSlice(xr(Sr)), Ie.writeVarSlice(er), this.setInput(Fe, le.WITNESS_UTXO, or(), Ie.buffer());
    }
    getInputWitnessUtxo(Fe) {
      const Sr = this.getInputOptional(Fe, le.WITNESS_UTXO, or());
      if (!Sr)
        return;
      const er = new A.BufferReader(Sr);
      return {
        amount: (0, A.unsafeFrom64bitLE)(er.readSlice(8)),
        scriptPubKey: er.readVarSlice()
      };
    }
    setInputPartialSig(Fe, Sr, er) {
      this.setInput(Fe, le.PARTIAL_SIG, Sr, er);
    }
    getInputPartialSig(Fe, Sr) {
      return this.getInputOptional(Fe, le.PARTIAL_SIG, Sr);
    }
    setInputSighashType(Fe, Sr) {
      this.setInput(Fe, le.SIGHASH_TYPE, or(), Ir(Sr));
    }
    getInputSighashType(Fe) {
      const Sr = this.getInputOptional(Fe, le.SIGHASH_TYPE, or());
      if (Sr)
        return Sr.readUInt32LE(0);
    }
    setInputRedeemScript(Fe, Sr) {
      this.setInput(Fe, le.REDEEM_SCRIPT, or(), Sr);
    }
    getInputRedeemScript(Fe) {
      return this.getInputOptional(Fe, le.REDEEM_SCRIPT, or());
    }
    setInputWitnessScript(Fe, Sr) {
      this.setInput(Fe, le.WITNESS_SCRIPT, or(), Sr);
    }
    getInputWitnessScript(Fe) {
      return this.getInputOptional(Fe, le.WITNESS_SCRIPT, or());
    }
    setInputBip32Derivation(Fe, Sr, er, Ie) {
      if (Sr.length != 33)
        throw new Error("Invalid pubkey length: " + Sr.length);
      this.setInput(Fe, le.BIP32_DERIVATION, Sr, this.encodeBip32Derivation(er, Ie));
    }
    getInputBip32Derivation(Fe, Sr) {
      const er = this.getInputOptional(Fe, le.BIP32_DERIVATION, Sr);
      if (er)
        return this.decodeBip32Derivation(er);
    }
    setInputFinalScriptsig(Fe, Sr) {
      this.setInput(Fe, le.FINAL_SCRIPTSIG, or(), Sr);
    }
    getInputFinalScriptsig(Fe) {
      return this.getInputOptional(Fe, le.FINAL_SCRIPTSIG, or());
    }
    setInputFinalScriptwitness(Fe, Sr) {
      this.setInput(Fe, le.FINAL_SCRIPTWITNESS, or(), Sr);
    }
    getInputFinalScriptwitness(Fe) {
      return this.getInput(Fe, le.FINAL_SCRIPTWITNESS, or());
    }
    setInputPreviousTxId(Fe, Sr) {
      this.setInput(Fe, le.PREVIOUS_TXID, or(), Sr);
    }
    getInputPreviousTxid(Fe) {
      return this.getInput(Fe, le.PREVIOUS_TXID, or());
    }
    setInputOutputIndex(Fe, Sr) {
      this.setInput(Fe, le.OUTPUT_INDEX, or(), Ir(Sr));
    }
    getInputOutputIndex(Fe) {
      return this.getInput(Fe, le.OUTPUT_INDEX, or()).readUInt32LE(0);
    }
    setInputSequence(Fe, Sr) {
      this.setInput(Fe, le.SEQUENCE, or(), Ir(Sr));
    }
    getInputSequence(Fe) {
      var Sr, er;
      return (er = (Sr = this.getInputOptional(Fe, le.SEQUENCE, or())) === null || Sr === void 0 ? void 0 : Sr.readUInt32LE(0)) !== null && er !== void 0 ? er : 4294967295;
    }
    setInputTapKeySig(Fe, Sr) {
      this.setInput(Fe, le.TAP_KEY_SIG, or(), Sr);
    }
    getInputTapKeySig(Fe) {
      return this.getInputOptional(Fe, le.TAP_KEY_SIG, or());
    }
    setInputTapBip32Derivation(Fe, Sr, er, Ie, xe) {
      if (Sr.length != 32)
        throw new Error("Invalid pubkey length: " + Sr.length);
      const rr = this.encodeTapBip32Derivation(er, Ie, xe);
      this.setInput(Fe, le.TAP_BIP32_DERIVATION, Sr, rr);
    }
    getInputTapBip32Derivation(Fe, Sr) {
      const er = this.getInput(Fe, le.TAP_BIP32_DERIVATION, Sr);
      return this.decodeTapBip32Derivation(er);
    }
    getInputKeyDatas(Fe, Sr) {
      return this.getKeyDatas(this.inputMaps[Fe], Sr);
    }
    setOutputRedeemScript(Fe, Sr) {
      this.setOutput(Fe, L.REDEEM_SCRIPT, or(), Sr);
    }
    getOutputRedeemScript(Fe) {
      return this.getOutput(Fe, L.REDEEM_SCRIPT, or());
    }
    setOutputBip32Derivation(Fe, Sr, er, Ie) {
      this.setOutput(Fe, L.BIP_32_DERIVATION, Sr, this.encodeBip32Derivation(er, Ie));
    }
    getOutputBip32Derivation(Fe, Sr) {
      const er = this.getOutput(Fe, L.BIP_32_DERIVATION, Sr);
      return this.decodeBip32Derivation(er);
    }
    setOutputAmount(Fe, Sr) {
      this.setOutput(Fe, L.AMOUNT, or(), xr(Sr));
    }
    getOutputAmount(Fe) {
      const Sr = this.getOutput(Fe, L.AMOUNT, or());
      return (0, A.unsafeFrom64bitLE)(Sr);
    }
    setOutputScript(Fe, Sr) {
      this.setOutput(Fe, L.SCRIPT, or(), Sr);
    }
    getOutputScript(Fe) {
      return this.getOutput(Fe, L.SCRIPT, or());
    }
    setOutputTapBip32Derivation(Fe, Sr, er, Ie, xe) {
      const rr = this.encodeTapBip32Derivation(er, Ie, xe);
      this.setOutput(Fe, L.TAP_BIP32_DERIVATION, Sr, rr);
    }
    getOutputTapBip32Derivation(Fe, Sr) {
      const er = this.getOutput(Fe, L.TAP_BIP32_DERIVATION, Sr);
      return this.decodeTapBip32Derivation(er);
    }
    deleteInputEntries(Fe, Sr) {
      this.inputMaps[Fe].forEach((Ie, xe, rr) => {
        this.isKeyType(xe, Sr) && rr.delete(xe);
      });
    }
    copy(Fe) {
      this.copyMap(this.globalMap, Fe.globalMap), this.copyMaps(this.inputMaps, Fe.inputMaps), this.copyMaps(this.outputMaps, Fe.outputMaps);
    }
    copyMaps(Fe, Sr) {
      Fe.forEach((er, Ie) => {
        const xe = /* @__PURE__ */ new Map();
        this.copyMap(er, xe), Sr[Ie] = xe;
      });
    }
    copyMap(Fe, Sr) {
      Fe.forEach((er, Ie) => Sr.set(Ie, Buffer$f.from(er)));
    }
    serialize() {
      const Fe = new A.BufferWriter();
      return Fe.writeSlice(pe), ir(Fe, this.globalMap), this.inputMaps.forEach((Sr) => {
        ir(Fe, Sr);
      }), this.outputMaps.forEach((Sr) => {
        ir(Fe, Sr);
      }), Fe.buffer();
    }
    deserialize(Fe) {
      const Sr = new A.BufferReader(Fe);
      if (!Sr.readSlice(5).equals(pe))
        throw new Error("Invalid magic bytes");
      for (; this.readKeyPair(this.globalMap, Sr); )
        ;
      let er;
      try {
        er = this.getGlobalPsbtVersion();
      } catch {
        er = 0;
      }
      if (er !== 0 && er !== 2)
        throw new Error("Only PSBTs of version 0 or 2 are supported");
      let Ie, xe;
      if (er == 0) {
        const rr = this.getGlobal(F.UNSIGNED_TX), ar = a.Transaction.fromBuffer(rr);
        Ie = ar.ins.length, xe = ar.outs.length;
      } else
        Ie = this.getGlobalInputCount(), xe = this.getGlobalOutputCount();
      for (let rr = 0; rr < Ie; rr++)
        for (this.inputMaps[rr] = /* @__PURE__ */ new Map(); this.readKeyPair(this.inputMaps[rr], Sr); )
          ;
      for (let rr = 0; rr < xe; rr++)
        for (this.outputMaps[rr] = /* @__PURE__ */ new Map(); this.readKeyPair(this.outputMaps[rr], Sr); )
          ;
      this.normalizeToV2();
    }
    normalizeToV2() {
      var Fe;
      const Sr = (Fe = this.getGlobalOptional(F.VERSION)) === null || Fe === void 0 ? void 0 : Fe.readInt32LE(0);
      if (Sr === 2)
        return;
      if (Sr !== void 0)
        throw new Error("Invalid or unsupported value for PSBT_GLOBAL_VERSION");
      const er = this.getGlobal(F.UNSIGNED_TX), Ie = a.Transaction.fromBuffer(er);
      this.setGlobalPsbtVersion(2), this.setGlobalTxVersion(Ie.version), this.setGlobalFallbackLocktime(Ie.locktime), this.setGlobalInputCount(Ie.ins.length), this.setGlobalOutputCount(Ie.outs.length);
      for (let xe = 0; xe < Ie.ins.length; xe++)
        this.setInputPreviousTxId(xe, Ie.ins[xe].hash), this.setInputOutputIndex(xe, Ie.ins[xe].index), this.setInputSequence(xe, Ie.ins[xe].sequence);
      for (let xe = 0; xe < Ie.outs.length; xe++)
        this.setOutputAmount(xe, Ie.outs[xe].value), this.setOutputScript(xe, Ie.outs[xe].script);
      this.globalMap.delete(F.UNSIGNED_TX.toString(16).padStart(2, "0"));
    }
    /**
     * Imports a BitcoinJS (bitcoinjs-lib) Psbt object.
     * https://github.com/bitcoinjs/bitcoinjs-lib/blob/master/ts_src/psbt.ts
     *
     * Prepares the fields required for signing a Psbt on a Ledger
     * device. It should be used exclusively before calling
     * `appClient.signPsbt()` and not as a general Psbt conversion method.
     *
     * Note: This method supports all the policies that the Ledger is able to
     * sign, with the exception of taproot: tr(@0).
     */
    fromBitcoinJS(Fe) {
      function Sr(er) {
        let Ie;
        try {
          a.payments.p2tr({ output: er.witnessUtxo.script }), Ie = !0;
        } catch {
          Ie = !1;
        }
        return er && !!(er.tapInternalKey || er.tapMerkleRoot || er.tapLeafScript && er.tapLeafScript.length || er.tapBip32Derivation && er.tapBip32Derivation.length || Ie);
      }
      return this.setGlobalPsbtVersion(2), this.setGlobalTxVersion(Fe.version), this.setGlobalInputCount(Fe.data.inputs.length), this.setGlobalOutputCount(Fe.txOutputs.length), Fe.locktime !== void 0 && this.setGlobalFallbackLocktime(Fe.locktime), Fe.data.inputs.forEach((er, Ie) => {
        if (Sr(er))
          throw new Error("Taproot inputs not supported");
        this.setInputPreviousTxId(Ie, Fe.txInputs[Ie].hash), Fe.txInputs[Ie].sequence !== void 0 && this.setInputSequence(Ie, Fe.txInputs[Ie].sequence), this.setInputOutputIndex(Ie, Fe.txInputs[Ie].index), er.sighashType !== void 0 && this.setInputSighashType(Ie, er.sighashType), er.nonWitnessUtxo && this.setInputNonWitnessUtxo(Ie, er.nonWitnessUtxo), er.witnessUtxo && this.setInputWitnessUtxo(Ie, er.witnessUtxo.value, er.witnessUtxo.script), er.witnessScript && this.setInputWitnessScript(Ie, er.witnessScript), er.redeemScript && this.setInputRedeemScript(Ie, er.redeemScript), Fe.data.inputs[Ie].bip32Derivation.forEach((xe) => {
          if (!/^m\//i.test(xe.path))
            throw new Error("Invalid input bip32 derivation");
          const rr = xe.path.replace(/m\//i, "").split("/").map((ar) => ar.match(/['h]/i) ? parseInt(ar) + 2147483648 : Number(ar));
          this.setInputBip32Derivation(Ie, xe.pubkey, xe.masterFingerprint, rr);
        });
      }), Fe.txOutputs.forEach((er, Ie) => {
        this.setOutputAmount(Ie, er.value), this.setOutputScript(Ie, er.script);
      }), this;
    }
    readKeyPair(Fe, Sr) {
      const er = (0, b.sanitizeBigintToNumber)(Sr.readVarInt());
      if (er == 0)
        return !1;
      const Ie = Sr.readUInt8(), xe = Sr.readSlice(er - 1), rr = Sr.readVarSlice();
      return lr(Fe, Ie, xe, rr), !0;
    }
    getKeyDatas(Fe, Sr) {
      const er = [];
      return Fe.forEach((Ie, xe) => {
        this.isKeyType(xe, [Sr]) && er.push(Buffer$f.from(xe.substring(2), "hex"));
      }), er;
    }
    isKeyType(Fe, Sr) {
      const er = Buffer$f.from(Fe.substring(0, 2), "hex").readUInt8(0);
      return Sr.some((Ie) => Ie == er);
    }
    setGlobal(Fe, Sr) {
      const er = new He(Fe, Buffer$f.from([]));
      this.globalMap.set(er.toString(), Sr);
    }
    getGlobal(Fe) {
      return be(this.globalMap, Fe, or(), !1);
    }
    getGlobalOptional(Fe) {
      return be(this.globalMap, Fe, or(), !0);
    }
    setInput(Fe, Sr, er, Ie) {
      lr(this.getMap(Fe, this.inputMaps), Sr, er, Ie);
    }
    getInput(Fe, Sr, er) {
      return be(this.inputMaps[Fe], Sr, er, !1);
    }
    getInputOptional(Fe, Sr, er) {
      return be(this.inputMaps[Fe], Sr, er, !0);
    }
    setOutput(Fe, Sr, er, Ie) {
      lr(this.getMap(Fe, this.outputMaps), Sr, er, Ie);
    }
    getOutput(Fe, Sr, er) {
      return be(this.outputMaps[Fe], Sr, er, !1);
    }
    getMap(Fe, Sr) {
      return Sr[Fe] ? Sr[Fe] : Sr[Fe] = /* @__PURE__ */ new Map();
    }
    encodeBip32Derivation(Fe, Sr) {
      const er = new A.BufferWriter();
      return this.writeBip32Derivation(er, Fe, Sr), er.buffer();
    }
    decodeBip32Derivation(Fe) {
      const Sr = new A.BufferReader(Fe);
      return this.readBip32Derivation(Sr);
    }
    writeBip32Derivation(Fe, Sr, er) {
      Fe.writeSlice(Sr), er.forEach((Ie) => {
        Fe.writeUInt32(Ie);
      });
    }
    readBip32Derivation(Fe) {
      const Sr = Fe.readSlice(4), er = [];
      for (; Fe.offset < Fe.buffer.length; )
        er.push(Fe.readUInt32());
      return { masterFingerprint: Sr, path: er };
    }
    encodeTapBip32Derivation(Fe, Sr, er) {
      const Ie = new A.BufferWriter();
      return Ie.writeVarInt(Fe.length), Fe.forEach((xe) => {
        Ie.writeSlice(xe);
      }), this.writeBip32Derivation(Ie, Sr, er), Ie.buffer();
    }
    decodeTapBip32Derivation(Fe) {
      const Sr = new A.BufferReader(Fe), er = (0, b.sanitizeBigintToNumber)(Sr.readVarInt()), Ie = [];
      for (let rr = 0; rr < er; rr++)
        Ie.push(Sr.readSlice(32));
      const xe = this.readBip32Derivation(Sr);
      return Object.assign({ hashes: Ie }, xe);
    }
  }
  n.PsbtV2 = Ee;
  function be(tr, Fe, Sr, er) {
    if (!tr)
      throw Error("No such map");
    const Ie = new He(Fe, Sr), xe = tr.get(Ie.toString());
    if (!xe) {
      if (er)
        return;
      throw new $(Ie.toString());
    }
    return Buffer$f.from(xe);
  }
  class He {
    constructor(Fe, Sr) {
      this.keyType = Fe, this.keyData = Sr;
    }
    toString() {
      const Fe = new A.BufferWriter();
      return this.toBuffer(Fe), Fe.buffer().toString("hex");
    }
    serialize(Fe) {
      Fe.writeVarInt(1 + this.keyData.length), this.toBuffer(Fe);
    }
    toBuffer(Fe) {
      Fe.writeUInt8(this.keyType), Fe.writeSlice(this.keyData);
    }
  }
  class Pe {
    constructor(Fe, Sr) {
      this.key = Fe, this.value = Sr;
    }
    serialize(Fe) {
      this.key.serialize(Fe), Fe.writeVarSlice(this.value);
    }
  }
  function nr(tr) {
    return new He(tr.readUInt8(0), tr.slice(1));
  }
  function ir(tr, Fe) {
    for (let [Sr, er] of [...Fe].sort(([Ie], [xe]) => Ie.localeCompare(xe)))
      new Pe(nr(Buffer$f.from(Sr, "hex")), er).serialize(tr);
    tr.writeUInt8(0);
  }
  function or() {
    return Buffer$f.from([]);
  }
  function lr(tr, Fe, Sr, er) {
    const Ie = new He(Fe, Sr);
    tr.set(Ie.toString(), er);
  }
  function Ir(tr) {
    const Fe = Buffer$f.alloc(4);
    return Fe.writeUInt32LE(tr, 0), Fe;
  }
  function xr(tr) {
    return (0, A.unsafeTo64bitLE)(tr);
  }
  function kr(tr) {
    const Fe = new A.BufferWriter();
    return Fe.writeVarInt(tr), Fe.buffer();
  }
  function Ce(tr) {
    return (0, b.sanitizeBigintToNumber)(new A.BufferReader(tr).readVarInt());
  }
})(psbtv2);
Object.defineProperty(merkelizedPsbt, "__esModule", { value: !0 });
merkelizedPsbt.MerkelizedPsbt = void 0;
const merkleMap_1 = merkleMap, psbtv2_1$1 = psbtv2;
class MerkelizedPsbt extends psbtv2_1$1.PsbtV2 {
  constructor(c) {
    super(), this.inputMerkleMaps = [], this.outputMerkleMaps = [], c.copy(this), this.globalMerkleMap = MerkelizedPsbt.createMerkleMap(this.globalMap);
    for (let u = 0; u < this.getGlobalInputCount(); u++)
      this.inputMerkleMaps.push(MerkelizedPsbt.createMerkleMap(this.inputMaps[u]));
    this.inputMapCommitments = [...this.inputMerkleMaps.values()].map((u) => u.commitment());
    for (let u = 0; u < this.getGlobalOutputCount(); u++)
      this.outputMerkleMaps.push(MerkelizedPsbt.createMerkleMap(this.outputMaps[u]));
    this.outputMapCommitments = [...this.outputMerkleMaps.values()].map((u) => u.commitment());
  }
  // These public functions are for MerkelizedPsbt.
  getGlobalSize() {
    return this.globalMap.size;
  }
  getGlobalKeysValuesRoot() {
    return this.globalMerkleMap.commitment();
  }
  static createMerkleMap(c) {
    const u = [...c.keys()].sort(), p = u.map((A) => {
      const b = c.get(A);
      if (!b)
        throw new Error("No value for key " + A);
      return b;
    }), a = u.map((A) => Buffer$f.from(A, "hex"));
    return new merkleMap_1.MerkleMap(a, p);
  }
}
merkelizedPsbt.MerkelizedPsbt = MerkelizedPsbt;
var __createBinding$4 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(n, c, u, p) {
  p === void 0 && (p = u);
  var a = Object.getOwnPropertyDescriptor(c, u);
  (!a || ("get" in a ? !c.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
    return c[u];
  } }), Object.defineProperty(n, p, a);
} : function(n, c, u, p) {
  p === void 0 && (p = u), n[p] = c[u];
}), __setModuleDefault$4 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(n, c) {
  Object.defineProperty(n, "default", { enumerable: !0, value: c });
} : function(n, c) {
  n.default = c;
}), __importStar$4 = commonjsGlobal && commonjsGlobal.__importStar || function(n) {
  if (n && n.__esModule) return n;
  var c = {};
  if (n != null) for (var u in n) u !== "default" && Object.prototype.hasOwnProperty.call(n, u) && __createBinding$4(c, n, u);
  return __setModuleDefault$4(c, n), c;
};
Object.defineProperty(appClient$1, "__esModule", { value: !0 });
appClient$1.AppClient = appClient$1.PartialSignature = void 0;
const descriptors = __importStar$4(dist$1), secp256k1$1 = __importStar$4(dist$x), { Descriptor } = descriptors.DescriptorsFactory(secp256k1$1), bitcoinjs_lib_1$2 = src$j, bip32_1 = bip32, clientCommands_1 = clientCommands, merkelizedPsbt_1 = merkelizedPsbt, merkle_1$1 = merkle, psbtv2_1 = psbtv2, varint_1 = varint, CLA_BTC = 225, CLA_FRAMEWORK = 248, CURRENT_PROTOCOL_VERSION = 1;
var BitcoinIns;
(function(n) {
  n[n.GET_PUBKEY = 0] = "GET_PUBKEY", n[n.REGISTER_WALLET = 2] = "REGISTER_WALLET", n[n.GET_WALLET_ADDRESS = 3] = "GET_WALLET_ADDRESS", n[n.SIGN_PSBT = 4] = "SIGN_PSBT", n[n.GET_MASTER_FINGERPRINT = 5] = "GET_MASTER_FINGERPRINT", n[n.SIGN_MESSAGE = 16] = "SIGN_MESSAGE";
})(BitcoinIns || (BitcoinIns = {}));
var FrameworkIns;
(function(n) {
  n[n.CONTINUE_INTERRUPTED = 1] = "CONTINUE_INTERRUPTED";
})(FrameworkIns || (FrameworkIns = {}));
class PartialSignature {
  constructor(c, u, p) {
    this.pubkey = c, this.signature = u, this.tapleafHash = p;
  }
}
appClient$1.PartialSignature = PartialSignature;
function makePartialSignature(n, c) {
  if (n.length == 64)
    return new PartialSignature(n.slice(0, 32), c, n.slice(32, 64));
  if (n.length == 32 || n.length == 33)
    return new PartialSignature(n, c);
  throw new Error(`Invalid length for pubkeyAugm: ${n.length} bytes.`);
}
let AppClient$1 = class {
  constructor(c) {
    this.transport = c;
  }
  async makeRequest(c, u, p) {
    let a = await this.transport.send(CLA_BTC, c, 0, CURRENT_PROTOCOL_VERSION, u, [36864, 57344]);
    for (; a.readUInt16BE(a.length - 2) === 57344; ) {
      if (!p)
        throw new Error("Unexpected SW_INTERRUPTED_EXECUTION");
      const A = a.slice(0, -2), b = p.execute(A);
      a = await this.transport.send(CLA_FRAMEWORK, FrameworkIns.CONTINUE_INTERRUPTED, 0, 0, b, [36864, 57344]);
    }
    return a.slice(0, -2);
  }
  /**
   * Returns an object containing the currently running app's name, version and the device status flags.
   *
   * @returns an object with app name, version and device status flags.
   */
  async getAppAndVersion() {
    const c = await this.transport.send(176, 1, 0, 0);
    let u = 0;
    if (c[u++] !== 1)
      throw new Error("Unexpected response");
    const a = c[u++], A = c.slice(u, u += a).toString("ascii"), b = c[u++], F = c.slice(u, u += b).toString("ascii"), le = c[u++], L = c.slice(u, u += le);
    return {
      name: A,
      version: F,
      flags: L
    };
  }
  /**
   * Requests the BIP-32 extended pubkey to the hardware wallet.
   * If `display` is `false`, only standard paths will be accepted; an error is returned if an unusual path is
   * requested.
   * If `display` is `true`, the requested path is shown on screen for user verification; unusual paths can be
   * requested, and a warning is shown to the user in that case.
   *
   * @param path the requested BIP-32 path as a string
   * @param display `false` to silently retrieve a pubkey for a standard path, `true` to display the path on screen
   * @returns the base58-encoded serialized extended pubkey (xpub)
   */
  async getExtendedPubkey(c, u = !1) {
    const p = (0, bip32_1.pathStringToArray)(c);
    if (p.length > 6)
      throw new Error("Path too long. At most 6 levels allowed.");
    return (await this.makeRequest(BitcoinIns.GET_PUBKEY, Buffer$f.concat([
      Buffer$f.from(u ? [1] : [0]),
      (0, bip32_1.pathElementsToBuffer)(p)
    ]))).toString("ascii");
  }
  /**
   * Registers a `WalletPolicy`, after interactive verification from the user.
   * On success, after user's approval, this function returns the id (which is the same that can be computed with
   * `walletPolicy.getid()`), followed by the 32-byte hmac. The client should store the hmac to use it for future
   * requests to `getWalletAddress` or `signPsbt` using this `WalletPolicy`.
   *
   * @param walletPolicy the `WalletPolicy` to register
   * @returns a pair of two 32-byte arrays: the id of the Wallet Policy, followed by the policy hmac
   */
  async registerWallet(c) {
    const u = new clientCommands_1.ClientCommandInterpreter();
    u.addKnownWalletPolicy(c);
    const p = c.serialize(), a = await this.makeRequest(BitcoinIns.REGISTER_WALLET, Buffer$f.concat([
      (0, varint_1.createVarint)(p.length),
      p
    ]), u);
    if (a.length != 64)
      throw Error(`Invalid response length. Expected 64 bytes, got ${a.length}`);
    const A = a.subarray(0, 32), b = a.subarray(32), F = await this.getWalletAddress(c, b, 0, 0, !1);
    return await this.validateAddress(F, c, 0, 0), [A, b];
  }
  /**
   * Returns the address of `walletPolicy` for the given `change` and `addressIndex`.
   *
   * @param walletPolicy the `WalletPolicy` to use
   * @param walletHMAC the 32-byte hmac returned during wallet registration for a registered policy; otherwise
   * `null` for a standard policy
   * @param change `0` for a normal receive address, `1` for a change address
   * @param addressIndex the address index to retrieve
   * @param display `True` to show the address on screen, `False` to retrieve it silently
   * @returns the address, as an ascii string.
   */
  async getWalletAddress(c, u, p, a, A) {
    if (p !== 0 && p !== 1)
      throw new Error("Change can only be 0 or 1");
    if (a < 0 || !Number.isInteger(a))
      throw new Error("Invalid address index");
    if (u != null && u.length != 32)
      throw new Error("Invalid HMAC length");
    const b = new clientCommands_1.ClientCommandInterpreter();
    b.addKnownWalletPolicy(c);
    const F = Buffer$f.alloc(4);
    F.writeUInt32BE(a, 0);
    const L = (await this.makeRequest(BitcoinIns.GET_WALLET_ADDRESS, Buffer$f.concat([
      Buffer$f.from(A ? [1] : [0]),
      c.getId(),
      u || Buffer$f.alloc(32, 0),
      Buffer$f.from([p]),
      F
    ]), b)).toString("ascii");
    return await this.validateAddress(L, c, p, a), L;
  }
  /**
   * Signs a psbt using a (standard or registered) `WalletPolicy`. This is an interactive command, as user validation
   * is necessary using the device's secure screen.
   * On success, a map of input indexes and signatures is returned.
   * @param psbt a base64-encoded string, or a psbt in a binary Buffer. Using the `PsbtV2` type is deprecated.
   * @param walletPolicy the `WalletPolicy` to use for signing
   * @param walletHMAC the 32-byte hmac obtained during wallet policy registration, or `null` for a standard policy
   * @param progressCallback optionally, a callback that will be called every time a signature is produced during
   * the signing process. The callback does not receive any argument, but can be used to track progress.
   * @returns an array of of tuples with 2 elements containing:
   *    - the index of the input being signed;
   *    - an instance of PartialSignature
   */
  async signPsbt(c, u, p, a) {
    if (typeof c == "string" && (c = Buffer$f.from(c, "base64")), Buffer$f.isBuffer(c)) {
      const $ = new psbtv2_1.PsbtV2();
      $.deserialize(c), c = $;
    }
    const A = new merkelizedPsbt_1.MerkelizedPsbt(c);
    if (p != null && p.length != 32)
      throw new Error("Invalid HMAC length");
    const b = new clientCommands_1.ClientCommandInterpreter(a);
    b.addKnownWalletPolicy(u), b.addKnownMapping(A.globalMerkleMap);
    for (const $ of A.inputMerkleMaps)
      b.addKnownMapping($);
    for (const $ of A.outputMerkleMaps)
      b.addKnownMapping($);
    b.addKnownList(A.inputMapCommitments);
    const F = new merkle_1$1.Merkle(A.inputMapCommitments.map(($) => (0, merkle_1$1.hashLeaf)($))).getRoot();
    b.addKnownList(A.outputMapCommitments);
    const le = new merkle_1$1.Merkle(A.outputMapCommitments.map(($) => (0, merkle_1$1.hashLeaf)($))).getRoot();
    await this.makeRequest(BitcoinIns.SIGN_PSBT, Buffer$f.concat([
      A.getGlobalKeysValuesRoot(),
      (0, varint_1.createVarint)(A.getGlobalInputCount()),
      F,
      (0, varint_1.createVarint)(A.getGlobalOutputCount()),
      le,
      u.getId(),
      p || Buffer$f.alloc(32, 0)
    ]), b);
    const L = b.getYielded(), pe = [];
    for (const $ of L) {
      const [Ee, be] = (0, varint_1.parseVarint)($, 0), He = $[be], Pe = $.subarray(be + 1, be + 1 + He), nr = $.subarray(be + 1 + He), ir = makePartialSignature(Pe, nr);
      pe.push([Number(Ee), ir]);
    }
    return pe;
  }
  /**
   * Returns the fingerprint of the master public key, as per BIP-32 standard.
   * @returns the master key fingerprint as a string of 8 hexadecimal digits.
   */
  async getMasterFingerprint() {
    return (await this.makeRequest(BitcoinIns.GET_MASTER_FINGERPRINT, Buffer$f.from([]))).toString("hex");
  }
  /**
   * Signs a message using the legacy Bitcoin Message Signing standard. The signed message is
   * the double-sha256 hash of the concatenation of:
   * - "\x18Bitcoin Signed Message:\n";
   * - the length of `message`, encoded as a Bitcoin-style variable length integer;
   * - `message`.
   *
   * @param message the serialized message to sign
   * @param path the BIP-32 path of the key used to sign the message
   * @returns base64-encoded signature of the message.
   */
  async signMessage(c, u) {
    const p = (0, bip32_1.pathStringToArray)(u), a = new clientCommands_1.ClientCommandInterpreter(), A = Math.ceil(c.length / 64), b = [];
    for (let L = 0; L < A; L++)
      b.push(c.subarray(64 * L, 64 * L + 64));
    a.addKnownList(b);
    const F = new merkle_1$1.Merkle(b.map((L) => (0, merkle_1$1.hashLeaf)(L))).getRoot();
    return (await this.makeRequest(BitcoinIns.SIGN_MESSAGE, Buffer$f.concat([
      (0, bip32_1.pathElementsToBuffer)(p),
      (0, varint_1.createVarint)(c.length),
      F
    ]), a)).toString("base64");
  }
  /* Performs any additional check on the generated address before returning it.*/
  async validateAddress(c, u, p, a) {
    if (p !== 0 && p !== 1)
      throw new Error("Change can only be 0 or 1");
    const A = p === 1;
    if (a < 0 || !Number.isInteger(a))
      throw new Error("Invalid address index");
    const b = await this.getAppAndVersion();
    let F;
    if (b.name === "Babylon BTC Test")
      F = bitcoinjs_lib_1$2.networks.testnet;
    else if (b.name === "Babylon BTC Staking")
      F = bitcoinjs_lib_1$2.networks.bitcoin;
    else
      throw new Error(`Invalid app: ${b.name}. Expected 'Babylon BTC Test' or 'Babylon BTC Staking'.`);
    let le = u.descriptorTemplate;
    le = le.replace(/\/\*\*/g, "/<0;1>/*");
    const L = new RegExp("/<(\\d+);(\\d+)>", "g");
    let pe;
    for (; (pe = L.exec(le)) !== null; ) {
      const [be, He] = [parseInt(pe[1], 10), parseInt(pe[2], 10)];
      le = le.replace(`/<${be};${He}>`, `/${A ? He : be}`);
    }
    le = le.replace(/\/\*/g, `/${a}`);
    for (let be = u.keys.length - 1; be >= 0; be--)
      le = le.replace(new RegExp(`@${be}`, "g"), u.keys[be]);
    let $ = !0, Ee;
    try {
      Ee = new Descriptor({
        expression: le,
        network: F
      }).getAddress();
    } catch {
      $ = !1;
    }
    if ($ && c !== Ee)
      throw new Error(`Third party address validation mismatch: ${c} != ${Ee}`);
  }
};
appClient$1.AppClient = AppClient$1;
appClient$1.default = AppClient$1;
var policy = {};
Object.defineProperty(policy, "__esModule", { value: !0 });
policy.DefaultWalletPolicy = policy.WalletPolicy = void 0;
const bitcoinjs_lib_1$1 = src$j, buffertools_1 = buffertools, merkle_1 = merkle, WALLET_POLICY_V2 = 2;
class WalletPolicy {
  /**
   * Creates and instance of a wallet policy.
   * @param name an ascii string, up to 16 bytes long; it must be an empty string for default wallet policies
   * @param descriptorTemplate the wallet policy template
   * @param keys and array of the keys, with the key derivation information
   */
  constructor(c, u, p) {
    this.name = c, this.descriptorTemplate = u, this.keys = p;
  }
  /**
   * Returns the unique 32-bytes id of this wallet policy.
   */
  getId() {
    return bitcoinjs_lib_1$1.crypto.sha256(this.serialize());
  }
  /**
   * Serializes the wallet policy for transmission via the hardware wallet protocol.
   * @returns the serialized wallet policy
   */
  serialize() {
    const c = this.keys.map((a) => Buffer$f.from(a, "ascii")), u = new merkle_1.Merkle(c.map((a) => (0, merkle_1.hashLeaf)(a))), p = new buffertools_1.BufferWriter();
    return p.writeUInt8(WALLET_POLICY_V2), p.writeVarSlice(Buffer$f.from(this.name, "ascii")), p.writeVarInt(this.descriptorTemplate.length), p.writeSlice(bitcoinjs_lib_1$1.crypto.sha256(Buffer$f.from(this.descriptorTemplate))), p.writeVarInt(this.keys.length), p.writeSlice(u.getRoot()), p.buffer();
  }
}
policy.WalletPolicy = WalletPolicy;
class DefaultWalletPolicy extends WalletPolicy {
  constructor(c, u) {
    super("", c, [u]);
  }
}
policy.DefaultWalletPolicy = DefaultWalletPolicy;
var babylon = {}, main = {};
function number$3(n) {
  if (!Number.isSafeInteger(n) || n < 0)
    throw new Error(`Wrong positive integer: ${n}`);
}
function bool$3(n) {
  if (typeof n != "boolean")
    throw new Error(`Expected boolean, not ${n}`);
}
function bytes$3(n, ...c) {
  if (!(n instanceof Uint8Array))
    throw new TypeError("Expected Uint8Array");
  if (c.length > 0 && !c.includes(n.length))
    throw new TypeError(`Expected Uint8Array of length ${c}, not of length=${n.length}`);
}
function hash$4(n) {
  if (typeof n != "function" || typeof n.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  number$3(n.outputLen), number$3(n.blockLen);
}
function exists$3(n, c = !0) {
  if (n.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (c && n.finished)
    throw new Error("Hash#digest() has already been called");
}
function output$3(n, c) {
  bytes$3(n);
  const u = c.outputLen;
  if (n.length < u)
    throw new Error(`digestInto() expects output buffer of length at least ${u}`);
}
const assert$1$2 = {
  number: number$3,
  bool: bool$3,
  bytes: bytes$3,
  hash: hash$4,
  exists: exists$3,
  output: output$3
};
var assert$2$1 = assert$1$2;
const createView$3 = (n) => new DataView(n.buffer, n.byteOffset, n.byteLength), rotr$3 = (n, c) => n << 32 - c | n >>> c, isLE$3 = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
if (!isLE$3)
  throw new Error("Non little-endian hardware is not supported");
Array.from({ length: 256 }, (n, c) => c.toString(16).padStart(2, "0"));
function utf8ToBytes$4(n) {
  if (typeof n != "string")
    throw new TypeError(`utf8ToBytes expected string, got ${typeof n}`);
  return new TextEncoder().encode(n);
}
function toBytes$5(n) {
  if (typeof n == "string" && (n = utf8ToBytes$4(n)), !(n instanceof Uint8Array))
    throw new TypeError(`Expected input type is Uint8Array (got ${typeof n})`);
  return n;
}
let Hash$3 = class {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
};
function wrapConstructor$3(n) {
  const c = (p) => n().update(toBytes$5(p)).digest(), u = n();
  return c.outputLen = u.outputLen, c.blockLen = u.blockLen, c.create = () => n(), c;
}
function setBigUint64$3(n, c, u, p) {
  if (typeof n.setBigUint64 == "function")
    return n.setBigUint64(c, u, p);
  const a = BigInt(32), A = BigInt(4294967295), b = Number(u >> a & A), F = Number(u & A), le = p ? 4 : 0, L = p ? 0 : 4;
  n.setUint32(c + le, b, p), n.setUint32(c + L, F, p);
}
let SHA2$3 = class extends Hash$3 {
  constructor(c, u, p, a) {
    super(), this.blockLen = c, this.outputLen = u, this.padOffset = p, this.isLE = a, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(c), this.view = createView$3(this.buffer);
  }
  update(c) {
    assert$2$1.exists(this);
    const { view: u, buffer: p, blockLen: a } = this;
    c = toBytes$5(c);
    const A = c.length;
    for (let b = 0; b < A; ) {
      const F = Math.min(a - this.pos, A - b);
      if (F === a) {
        const le = createView$3(c);
        for (; a <= A - b; b += a)
          this.process(le, b);
        continue;
      }
      p.set(c.subarray(b, b + F), this.pos), this.pos += F, b += F, this.pos === a && (this.process(u, 0), this.pos = 0);
    }
    return this.length += c.length, this.roundClean(), this;
  }
  digestInto(c) {
    assert$2$1.exists(this), assert$2$1.output(c, this), this.finished = !0;
    const { buffer: u, view: p, blockLen: a, isLE: A } = this;
    let { pos: b } = this;
    u[b++] = 128, this.buffer.subarray(b).fill(0), this.padOffset > a - b && (this.process(p, 0), b = 0);
    for (let $ = b; $ < a; $++)
      u[$] = 0;
    setBigUint64$3(p, a - 8, BigInt(this.length * 8), A), this.process(p, 0);
    const F = createView$3(c), le = this.outputLen;
    if (le % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const L = le / 4, pe = this.get();
    if (L > pe.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let $ = 0; $ < L; $++)
      F.setUint32(4 * $, pe[$], A);
  }
  digest() {
    const { buffer: c, outputLen: u } = this;
    this.digestInto(c);
    const p = c.slice(0, u);
    return this.destroy(), p;
  }
  _cloneInto(c) {
    c || (c = new this.constructor()), c.set(...this.get());
    const { blockLen: u, buffer: p, length: a, finished: A, destroyed: b, pos: F } = this;
    return c.length = a, c.pos = F, c.finished = A, c.destroyed = b, a % u && c.buffer.set(p), c;
  }
};
const Chi$3 = (n, c, u) => n & c ^ ~n & u, Maj$3 = (n, c, u) => n & c ^ n & u ^ c & u, SHA256_K$3 = new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), IV$3 = new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), SHA256_W$3 = new Uint32Array(64);
let SHA256$3 = class extends SHA2$3 {
  constructor() {
    super(64, 32, 8, !1), this.A = IV$3[0] | 0, this.B = IV$3[1] | 0, this.C = IV$3[2] | 0, this.D = IV$3[3] | 0, this.E = IV$3[4] | 0, this.F = IV$3[5] | 0, this.G = IV$3[6] | 0, this.H = IV$3[7] | 0;
  }
  get() {
    const { A: c, B: u, C: p, D: a, E: A, F: b, G: F, H: le } = this;
    return [c, u, p, a, A, b, F, le];
  }
  // prettier-ignore
  set(c, u, p, a, A, b, F, le) {
    this.A = c | 0, this.B = u | 0, this.C = p | 0, this.D = a | 0, this.E = A | 0, this.F = b | 0, this.G = F | 0, this.H = le | 0;
  }
  process(c, u) {
    for (let $ = 0; $ < 16; $++, u += 4)
      SHA256_W$3[$] = c.getUint32(u, !1);
    for (let $ = 16; $ < 64; $++) {
      const Ee = SHA256_W$3[$ - 15], be = SHA256_W$3[$ - 2], He = rotr$3(Ee, 7) ^ rotr$3(Ee, 18) ^ Ee >>> 3, Pe = rotr$3(be, 17) ^ rotr$3(be, 19) ^ be >>> 10;
      SHA256_W$3[$] = Pe + SHA256_W$3[$ - 7] + He + SHA256_W$3[$ - 16] | 0;
    }
    let { A: p, B: a, C: A, D: b, E: F, F: le, G: L, H: pe } = this;
    for (let $ = 0; $ < 64; $++) {
      const Ee = rotr$3(F, 6) ^ rotr$3(F, 11) ^ rotr$3(F, 25), be = pe + Ee + Chi$3(F, le, L) + SHA256_K$3[$] + SHA256_W$3[$] | 0, Pe = (rotr$3(p, 2) ^ rotr$3(p, 13) ^ rotr$3(p, 22)) + Maj$3(p, a, A) | 0;
      pe = L, L = le, le = F, F = b + be | 0, b = A, A = a, a = p, p = be + Pe | 0;
    }
    p = p + this.A | 0, a = a + this.B | 0, A = A + this.C | 0, b = b + this.D | 0, F = F + this.E | 0, le = le + this.F | 0, L = L + this.G | 0, pe = pe + this.H | 0, this.set(p, a, A, b, F, le, L, pe);
  }
  roundClean() {
    SHA256_W$3.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
}, SHA224$3 = class extends SHA256$3 {
  constructor() {
    super(), this.A = -1056596264, this.B = 914150663, this.C = 812702999, this.D = -150054599, this.E = -4191439, this.F = 1750603025, this.G = 1694076839, this.H = -1090891868, this.outputLen = 28;
  }
};
const sha256$4 = wrapConstructor$3(() => new SHA256$3());
wrapConstructor$3(() => new SHA224$3());
function within_size$1(n, c) {
  if (n.length > c)
    throw new TypeError(`Data is larger than array size: ${n.length} > ${c}`);
}
function is_hex$1(n) {
  if (n.match(/[^a-fA-f0-9]/) !== null)
    throw new TypeError("Invalid characters in hex string: " + n);
  if (n.length % 2 !== 0)
    throw new Error(`Length of hex string is invalid: ${n.length}`);
}
function is_safe_num$1(n) {
  if (n > Number.MAX_SAFE_INTEGER)
    throw new TypeError("Number exceeds safe bounds!");
}
const { getRandomValues: getRandomValues$1 } = crypto ?? globalThis.crypto ?? window.crypto;
function random$2(n = 32) {
  if (typeof getRandomValues$1 == "function")
    return crypto.getRandomValues(new Uint8Array(n));
  throw new Error("Crypto module missing getRandomValues!");
}
function set_buffer$1(n, c, u = "be") {
  c === void 0 && (c = n.length), within_size$1(n, c);
  const p = new Uint8Array(c).fill(0), a = u === "be" ? 0 : c - n.length;
  return p.set(n, a), p;
}
function join_array$1(n) {
  let c, u = 0;
  const p = n.reduce((A, b) => A + b.length, 0), a = new Uint8Array(p);
  for (c = 0; c < n.length; c++) {
    const A = n[c];
    a.set(A, u), u += A.length;
  }
  return a;
}
const ec$2$1 = new TextEncoder(), ALPHABETS$1 = [
  {
    name: "base58",
    charset: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
  }
];
function getAlphabet$1(n) {
  for (const c of ALPHABETS$1)
    if (c.name === n)
      return c.charset;
  throw TypeError("Charset does not exist: " + n);
}
function encode$1$2(n, c, u = !1) {
  typeof n == "string" && (n = ec$2$1.encode(n));
  const p = getAlphabet$1(c), a = p.length, A = [];
  let b = "", F, le = 0, L, pe;
  for (F = 0; F < n.length; F++)
    for (le = 0, L = n[F], b += L > 0 || (b.length ^ F) > 0 ? "" : "1"; le in A || L > 0; )
      pe = A[le], pe = pe > 0 ? pe * 256 + L : L, L = pe / a | 0, A[le] = pe % a, le++;
  for (; le-- > 0; )
    b += p[A[le]];
  return u && b.length % 4 > 0 ? b + "=".repeat(4 - b.length % 4) : b;
}
function decode$1$2(n, c) {
  const u = getAlphabet$1(c), p = u.length, a = [], A = [];
  n = n.replace("=", "");
  let b, F = 0, le, L;
  for (b = 0; b < n.length; b++) {
    if (F = 0, le = u.indexOf(n[b]), le < 0)
      throw new Error(`Character range out of bounds: ${le}`);
    for (le > 0 || (A.length ^ b) > 0 || A.push(0); F in a || le > 0; )
      L = a[F], L = L > 0 ? L * p + le : le, le = L >> 8, a[F] = L % 256, F++;
  }
  for (; F-- > 0; )
    A.push(a[F]);
  return new Uint8Array(A);
}
function hash256$2(n) {
  return sha256$4(sha256$4(n));
}
function addChecksum$1(n) {
  const c = hash256$2(n);
  return join_array$1([n, c.slice(0, 4)]);
}
function checkTheSum$1(n) {
  const c = n.slice(0, -4), u = n.slice(-4);
  if (hash256$2(c).slice(0, 4).toString() !== u.toString())
    throw new Error("Invalid checksum!");
  return c;
}
const BaseX$1 = {
  encode: encode$1$2,
  decode: decode$1$2
}, Base58C$1 = {
  encode: (n) => {
    const c = addChecksum$1(n);
    return BaseX$1.encode(c, "base58");
  },
  decode: (n) => {
    const c = BaseX$1.decode(n, "base58");
    return checkTheSum$1(c);
  }
}, CHARSET$1 = "qpzry9x8gf2tvdw0s3jn54khce6mua7l", GENERATOR$1 = [996825010, 642813549, 513874426, 1027748829, 705979059], ENCODINGS$1 = [
  { version: 0, name: "bech32", const: 1 },
  { version: 1, name: "bech32m", const: 734539939 }
];
function polymod$1(n) {
  let c = 1;
  for (let u = 0; u < n.length; ++u) {
    const p = c >> 25;
    c = (c & 33554431) << 5 ^ n[u];
    for (let a = 0; a < 5; ++a)
      p >> a & 1 && (c ^= GENERATOR$1[a]);
  }
  return c;
}
function hrpExpand$1(n) {
  const c = [];
  let u;
  for (u = 0; u < n.length; ++u)
    c.push(n.charCodeAt(u) >> 5);
  for (c.push(0), u = 0; u < n.length; ++u)
    c.push(n.charCodeAt(u) & 31);
  return c;
}
function verifyChecksum$1(n, c, u) {
  const p = hrpExpand$1(n).concat(c);
  return polymod$1(p) === u.const;
}
function createChecksum$1(n, c, u) {
  const p = hrpExpand$1(n).concat(c).concat([0, 0, 0, 0, 0, 0]), a = polymod$1(p) ^ u.const, A = [];
  for (let b = 0; b < 6; ++b)
    A.push(a >> 5 * (5 - b) & 31);
  return A;
}
function convertBits$1(n, c, u, p = !0) {
  const a = [];
  let A = 0, b = 0;
  const F = (1 << u) - 1, le = (1 << c + u - 1) - 1;
  for (const L of n) {
    if (L < 0 || L >> c > 0)
      throw new Error("Failed to perform base conversion. Invalid value: " + String(L));
    for (A = (A << c | L) & le, b += c; b >= u; )
      b -= u, a.push(A >> b & F);
  }
  if (p)
    b > 0 && a.push(A << u - b & F);
  else if (b >= c || (A << u - b & F) > 0)
    throw new Error("Failed to perform base conversion. Invalid Size!");
  return a;
}
function encode$6(n, c, u) {
  const p = c.concat(createChecksum$1(n, c, u));
  let a = n + "1";
  for (let A = 0; A < p.length; ++A)
    a += CHARSET$1.charAt(p[A]);
  return a;
}
function decode$6(n) {
  if (!checkBounds$1(n))
    throw new Error("Encoded string goes out of bounds!");
  if (n = n.toLowerCase(), !checkSeparatorPos$1(n))
    throw new Error("Encoded string has invalid separator!");
  const c = [], u = n.lastIndexOf("1"), p = n.substring(0, u);
  for (let A = u + 1; A < n.length; ++A) {
    const b = CHARSET$1.indexOf(n.charAt(A));
    if (b === -1)
      throw new Error("Character idx out of bounds: " + String(A));
    c.push(b);
  }
  const a = ENCODINGS$1.find((A) => A.version === c[0]) ?? ENCODINGS$1[0];
  if (!verifyChecksum$1(p, c, a))
    throw new Error("Checksum verification failed!");
  return [p, c.slice(0, c.length - 6)];
}
function checkBounds$1(n) {
  let c, u, p = !1, a = !1;
  for (c = 0; c < n.length; ++c) {
    if (u = n.charCodeAt(c), u < 33 || u > 126)
      return !1;
    u >= 97 && u <= 122 && (p = !0), u >= 65 && u <= 90 && (a = !0);
  }
  return !(p && a);
}
function checkSeparatorPos$1(n) {
  const c = n.lastIndexOf("1");
  return !(c < 1 || c + 7 > n.length || n.length > 90);
}
function b32encode$1(n, c = "bc", u = 0) {
  const p = [u, ...convertBits$1([...n], 8, 5)], a = ENCODINGS$1.find((b) => b.version === u) ?? ENCODINGS$1[0], A = encode$6(c, p, a);
  return b32decode$1(A), A;
}
function b32decode$1(n) {
  n = n.toLowerCase();
  const c = n.split("1", 1)[0], [u, p] = decode$6(n), a = convertBits$1(p.slice(1), 5, 8, !1), A = a.length;
  switch (!0) {
    case c !== u:
      throw new Error("Returned hrp string is invalid.");
    case (a === null || A < 2 || A > 40):
      throw new Error("Decoded string is invalid or out of spec.");
    case p[0] > 16:
      throw new Error("Returned version bit is out of range.");
    default:
      return Uint8Array.from(a);
  }
}
function getVersion$2(n) {
  n = n.toLowerCase();
  const [c, u] = decode$6(n);
  return u[0];
}
const Bech32$1 = {
  encode: b32encode$1,
  decode: b32decode$1,
  version: getVersion$2
}, BASE64_MAP$1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", B64URL_MAP$1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_", ec$1$1 = new TextEncoder();
function b64encode$1(n, c = !1, u = !0) {
  typeof n == "string" && (n = ec$1$1.encode(n));
  const p = c ? B64URL_MAP$1 : BASE64_MAP$1;
  let a = "", A = 0, b = 0;
  for (let F = 0; F < n.length; F++)
    for (b = b << 8 | n[F], A += 8; A >= 6; )
      A -= 6, a += p[b >> A & 63];
  if (A > 0)
    for (b <<= 6 - A, a += p[b & 63]; A < 6; )
      a += u ? "=" : "", A += 2;
  return a;
}
function b64decode$1(n, c = !1) {
  const u = c || n.includes("-") || n.includes("_") ? B64URL_MAP$1.split("") : BASE64_MAP$1.split("");
  n = n.replace(/=+$/, "");
  const p = n.split("");
  let a = 0, A = 0;
  const b = [];
  for (let F = 0; F < p.length; F++) {
    const le = p[F], L = u.indexOf(le);
    if (L === -1)
      throw new Error("Invalid character: " + le);
    a += 6, A <<= 6, A |= L, a >= 8 && (a -= 8, b.push(A >>> a & 255));
  }
  return new Uint8Array(b);
}
const Base64$1 = {
  encode: b64encode$1,
  decode: b64decode$1
}, B64URL$1 = {
  encode: (n) => b64encode$1(n, !0, !1),
  decode: (n) => b64decode$1(n, !0)
}, _0n = BigInt(0), _255n$1 = BigInt(255), _256n$1 = BigInt(256);
function big_size$1(n) {
  if (n <= 0xffn)
    return 1;
  if (n <= 0xffffn)
    return 2;
  if (n <= 0xffffffffn)
    return 4;
  if (n <= 0xffffffffffffffffn)
    return 8;
  if (n <= 0xffffffffffffffffffffffffffffffffn)
    return 16;
  if (n <= 0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffn)
    return 32;
  throw new TypeError("Must specify a fixed buffer size for bigints greater than 32 bytes.");
}
function bigToBytes$1(n, c, u = "be") {
  c === void 0 && (c = big_size$1(n));
  const p = u === "le", a = new ArrayBuffer(c), A = new DataView(a);
  let b = p ? 0 : c - 1;
  for (; n > _0n; ) {
    const F = n & _255n$1, le = Number(F);
    p ? A.setUint8(b++, le) : A.setUint8(b--, le), n = (n - F) / _256n$1;
  }
  return new Uint8Array(a);
}
function bytesToBig$1(n) {
  let c = BigInt(0);
  for (let u = n.length - 1; u >= 0; u--)
    c = c * _256n$1 + BigInt(n[u]);
  return BigInt(c);
}
function binToBytes$1(n) {
  const c = n.split("").map(Number);
  if (c.length % 8 !== 0)
    throw new Error(`Binary array is invalid length: ${n.length}`);
  const u = new Uint8Array(c.length / 8);
  for (let p = 0, a = 0; p < c.length; p += 8, a++) {
    let A = 0;
    for (let b = 0; b < 8; b++)
      A |= c[p + b] << 7 - b;
    u[a] = A;
  }
  return u;
}
function bytesToBin$1(n) {
  const c = new Array(n.length * 8);
  let u = 0;
  for (const p of n) {
    if (p > 255)
      throw new Error(`Invalid byte value: ${p}. Byte values must be between 0 and 255.`);
    for (let a = 7; a >= 0; a--, u++)
      c[u] = p >> a & 1;
  }
  return c.join("");
}
function num_size$1(n) {
  if (n <= 255)
    return 1;
  if (n <= 65535)
    return 2;
  if (n <= 4294967295)
    return 4;
  throw new TypeError("Numbers larger than 4 bytes must specify a fixed size!");
}
function numToBytes$1(n, c, u = "be") {
  c === void 0 && (c = num_size$1(n));
  const p = u === "le", a = new ArrayBuffer(c), A = new DataView(a);
  let b = p ? 0 : c - 1;
  for (; n > 0; ) {
    const F = n & 255;
    p ? A.setUint8(b++, n) : A.setUint8(b--, n), n = (n - F) / 256;
  }
  return new Uint8Array(a);
}
function bytesToNum$1(n) {
  let c = 0;
  for (let u = n.length - 1; u >= 0; u--)
    c = c * 256 + n[u], is_safe_num$1(c);
  return c;
}
const ec$3 = new TextEncoder(), dc$1 = new TextDecoder();
function strToBytes$1(n) {
  return ec$3.encode(n);
}
function bytesToStr$1(n) {
  return dc$1.decode(n);
}
function hex_size$1(n, c) {
  is_hex$1(n);
  const u = n.length / 2;
  if (c === void 0 && (c = u), u > c)
    throw new TypeError(`Hex string is larger than array size: ${u} > ${c}`);
  return c;
}
function hexToBytes$2(n, c, u = "le") {
  c = hex_size$1(n, c);
  const p = u === "le", a = new ArrayBuffer(c), A = new DataView(a);
  let b = p ? 0 : c - 1;
  for (let F = 0; F < n.length; F += 2) {
    const le = n.substring(F, F + 2), L = parseInt(le, 16);
    p ? A.setUint8(b++, L) : A.setUint8(b--, L);
  }
  return new Uint8Array(a);
}
function bytesToHex$2(n) {
  let c = "";
  for (let u = 0; u < n.length; u++)
    c += n[u].toString(16).padStart(2, "0");
  return c;
}
function jsonToBytes$1(n) {
  const c = JSON.stringify(n, (u, p) => typeof p == "bigint" ? `${p}n` : p);
  return strToBytes$1(c);
}
function buffer$1(n, c, u) {
  if (n instanceof ArrayBuffer)
    return new Uint8Array(n);
  if (n instanceof Uint8Array)
    return set_buffer$1(n, c, u);
  if (typeof n == "string")
    return hexToBytes$2(n, c, u);
  if (typeof n == "bigint")
    return bigToBytes$1(n, c, u);
  if (typeof n == "number")
    return numToBytes$1(n, c, u);
  if (typeof n == "boolean")
    return Uint8Array.of(n ? 1 : 0);
  throw TypeError("Unsupported format:" + typeof n);
}
var qa;
let Buff$1 = (qa = class extends Uint8Array {
  static random(c = 32) {
    const u = random$2(c);
    return new qa(u, c);
  }
  constructor(c, u, p) {
    const a = buffer$1(c, u, p);
    super(a);
  }
  get arr() {
    return [...this];
  }
  get num() {
    return this.toNum();
  }
  get big() {
    return this.toBig();
  }
  get str() {
    return this.toStr();
  }
  get hex() {
    return this.toHex();
  }
  get raw() {
    return new Uint8Array(this);
  }
  get bin() {
    return this.toBin();
  }
  get b58chk() {
    return this.tob58chk();
  }
  get base64() {
    return this.toBase64();
  }
  get b64url() {
    return this.toB64url();
  }
  get digest() {
    return this.toHash();
  }
  get id() {
    return this.toHash().hex;
  }
  get stream() {
    return new Stream$1(this);
  }
  toNum(c = "be") {
    const u = c === "be" ? this.reverse() : this;
    return bytesToNum$1(u);
  }
  toBin() {
    return bytesToBin$1(this);
  }
  toBig(c = "be") {
    const u = c === "be" ? this.reverse() : this;
    return bytesToBig$1(u);
  }
  toHash() {
    const c = sha256$4(this);
    return new qa(c);
  }
  toJson() {
    const c = bytesToStr$1(this);
    return JSON.parse(c);
  }
  toBech32(c, u = 0) {
    return Bech32$1.encode(this, c, u);
  }
  toStr() {
    return bytesToStr$1(this);
  }
  toHex() {
    return bytesToHex$2(this);
  }
  toBytes() {
    return new Uint8Array(this);
  }
  tob58chk() {
    return Base58C$1.encode(this);
  }
  toBase64() {
    return Base64$1.encode(this);
  }
  toB64url() {
    return B64URL$1.encode(this);
  }
  prepend(c) {
    return qa.join([qa.bytes(c), this]);
  }
  append(c) {
    return qa.join([this, qa.bytes(c)]);
  }
  slice(c, u) {
    const p = new Uint8Array(this).slice(c, u);
    return new qa(p);
  }
  subarray(c, u) {
    const p = new Uint8Array(this).subarray(c, u);
    return new qa(p);
  }
  reverse() {
    const c = new Uint8Array(this).reverse();
    return new qa(c);
  }
  write(c, u) {
    const p = qa.bytes(c);
    this.set(p, u);
  }
  prefixSize(c) {
    const u = qa.varInt(this.length, c);
    return qa.join([u, this]);
  }
  static from(c) {
    return new qa(Uint8Array.from(c));
  }
  static of(...c) {
    return new qa(Uint8Array.of(...c));
  }
  static join(c) {
    const u = c.map((a) => qa.bytes(a)), p = join_array$1(u);
    return new qa(p);
  }
  static varInt(c, u) {
    if (c < 253)
      return qa.num(c, 1);
    if (c < 65536)
      return qa.of(253, ...qa.num(c, 2, u));
    if (c < 4294967296)
      return qa.of(254, ...qa.num(c, 4, u));
    if (BigInt(c) < 0x10000000000000000n)
      return qa.of(255, ...qa.num(c, 8, u));
    throw new Error(`Value is too large: ${c}`);
  }
}, qa.num = numToBuff$1, qa.big = bigToBuff$1, qa.bin = binToBuff$1, qa.raw = rawToBuff$1, qa.str = strToBuff$1, qa.hex = hexToBuff$1, qa.bytes = bytesToBuff$1, qa.json = jsonToBuff$1, qa.base64 = base64ToBuff$1, qa.b64url = b64urlToBuff$1, qa.bech32 = bech32ToBuff$1, qa.b58chk = b58chkToBuff$1, qa.encode = strToBytes$1, qa.decode = bytesToStr$1, qa);
function numToBuff$1(n, c, u) {
  return new Buff$1(n, c, u);
}
function binToBuff$1(n, c, u) {
  return new Buff$1(binToBytes$1(n), c, u);
}
function bigToBuff$1(n, c, u) {
  return new Buff$1(n, c, u);
}
function rawToBuff$1(n, c, u) {
  return new Buff$1(n, c, u);
}
function strToBuff$1(n, c, u) {
  return new Buff$1(strToBytes$1(n), c, u);
}
function hexToBuff$1(n, c, u) {
  return new Buff$1(n, c, u);
}
function bytesToBuff$1(n, c, u) {
  return new Buff$1(n, c, u);
}
function jsonToBuff$1(n) {
  return new Buff$1(jsonToBytes$1(n));
}
function base64ToBuff$1(n) {
  return new Buff$1(Base64$1.decode(n));
}
function b64urlToBuff$1(n) {
  return new Buff$1(B64URL$1.decode(n));
}
function bech32ToBuff$1(n) {
  return new Buff$1(Bech32$1.decode(n));
}
function b58chkToBuff$1(n) {
  return new Buff$1(Base58C$1.decode(n));
}
let Stream$1 = class {
  constructor(c) {
    this.data = Buff$1.bytes(c), this.size = this.data.length;
  }
  peek(c) {
    if (c > this.size)
      throw new Error(`Size greater than stream: ${c} > ${this.size}`);
    return new Buff$1(this.data.slice(0, c));
  }
  read(c) {
    c = c ?? this.readSize();
    const u = this.peek(c);
    return this.data = this.data.slice(c), this.size = this.data.length, u;
  }
  readSize(c) {
    const u = this.read(1).num;
    switch (!0) {
      case (u >= 0 && u < 253):
        return u;
      case u === 253:
        return this.read(2).toNum(c);
      case u === 254:
        return this.read(4).toNum(c);
      case u === 255:
        return this.read(8).toNum(c);
      default:
        throw new Error(`Varint is out of range: ${u}`);
    }
  }
};
function checkSize(n, c) {
  const u = Buff$1.bytes(n);
  if (u.length !== c)
    throw new Error(`Invalid input size: ${u.hex} !== ${c}`);
}
function safeThrow(n, c) {
  if (c)
    throw new Error(n);
  return !1;
}
function hashTag(n, ...c) {
  const u = Buff$1.str(n).digest.raw, p = c.map((a) => Buff$1.bytes(a));
  return Buff$1.join([u, u, Buff$1.join(p)]).digest;
}
const OPCODE_MAP = {
  OP_0: 0,
  OP_PUSHDATA1: 76,
  OP_PUSHDATA2: 77,
  OP_PUSHDATA4: 78,
  OP_1NEGATE: 79,
  OP_SUCCESS80: 80,
  OP_1: 81,
  OP_2: 82,
  OP_3: 83,
  OP_4: 84,
  OP_5: 85,
  OP_6: 86,
  OP_7: 87,
  OP_8: 88,
  OP_9: 89,
  OP_10: 90,
  OP_11: 91,
  OP_12: 92,
  OP_13: 93,
  OP_14: 94,
  OP_15: 95,
  OP_16: 96,
  OP_NOP: 97,
  OP_SUCCESS98: 98,
  OP_IF: 99,
  OP_NOTIF: 100,
  OP_ELSE: 103,
  OP_ENDIF: 104,
  OP_VERIFY: 105,
  OP_RETURN: 106,
  OP_TOALTSTACK: 107,
  OP_FROMALTSTACK: 108,
  OP_2DROP: 109,
  OP_2DUP: 110,
  OP_3DUP: 111,
  OP_2OVER: 112,
  OP_2ROT: 113,
  OP_2SWAP: 114,
  OP_IFDUP: 115,
  OP_DEPTH: 116,
  OP_DROP: 117,
  OP_DUP: 118,
  OP_NIP: 119,
  OP_OVER: 120,
  OP_PICK: 121,
  OP_ROLL: 122,
  OP_ROT: 123,
  OP_SWAP: 124,
  OP_TUCK: 125,
  OP_SUCCESS126: 126,
  OP_SUCCESS127: 127,
  OP_SUCCESS128: 128,
  OP_SUCCESS129: 129,
  OP_SIZE: 130,
  OP_SUCCESS131: 131,
  OP_SUCCESS132: 132,
  OP_SUCCESS133: 133,
  OP_SUCCESS134: 134,
  OP_EQUAL: 135,
  OP_EQUALVERIFY: 136,
  OP_SUCCESS137: 137,
  OP_SUCCESS138: 138,
  OP_1ADD: 139,
  OP_1SUB: 140,
  OP_SUCCESS141: 141,
  OP_SUCCESS142: 142,
  OP_NEGATE: 143,
  OP_ABS: 144,
  OP_NOT: 145,
  OP_0NOTEQUAL: 146,
  OP_ADD: 147,
  OP_SUB: 148,
  OP_SUCCESS149: 149,
  OP_SUCCESS150: 150,
  OP_SUCCESS151: 151,
  OP_SUCCESS152: 152,
  OP_SUCCESS153: 153,
  OP_BOOLAND: 154,
  OP_BOOLOR: 155,
  OP_NUMEQUAL: 156,
  OP_NUMEQUALVERIFY: 157,
  OP_NUMNOTEQUAL: 158,
  OP_LESSTHAN: 159,
  OP_GREATERTHAN: 160,
  OP_LESSTHANOREQUAL: 161,
  OP_GREATERTHANOREQUAL: 162,
  OP_MIN: 163,
  OP_MAX: 164,
  OP_WITHIN: 165,
  OP_RIPEMD160: 166,
  OP_SHA1: 167,
  OP_SHA256: 168,
  OP_HASH160: 169,
  OP_HASH256: 170,
  OP_CODESEPARATOR: 171,
  OP_CHECKSIG: 172,
  OP_CHECKSIGVERIFY: 173,
  OP_CHECKMULTISIG: 174,
  OP_CHECKMULTISIGVERIFY: 175,
  OP_NOP1: 176,
  OP_CHECKLOCKTIMEVERIFY: 177,
  OP_CHECKSEQUENCEVERIFY: 178,
  OP_NOP4: 179,
  OP_NOP5: 180,
  OP_NOP6: 181,
  OP_NOP7: 182,
  OP_NOP8: 183,
  OP_NOP9: 184,
  OP_NOP10: 185,
  OP_CHECKSIGADD: 186,
  OP_SUCCESS187: 187,
  OP_SUCCESS188: 188,
  OP_SUCCESS189: 189,
  OP_SUCCESS190: 190,
  OP_SUCCESS191: 191,
  OP_SUCCESS192: 192,
  OP_SUCCESS193: 193,
  OP_SUCCESS194: 194,
  OP_SUCCESS195: 195,
  OP_SUCCESS196: 196,
  OP_SUCCESS197: 197,
  OP_SUCCESS198: 198,
  OP_SUCCESS199: 199,
  OP_SUCCESS200: 200,
  OP_SUCCESS201: 201,
  OP_SUCCESS202: 202,
  OP_SUCCESS203: 203,
  OP_SUCCESS204: 204,
  OP_SUCCESS205: 205,
  OP_SUCCESS206: 206,
  OP_SUCCESS207: 207,
  OP_SUCCESS208: 208,
  OP_SUCCESS209: 209,
  OP_SUCCESS210: 210,
  OP_SUCCESS211: 211,
  OP_SUCCESS212: 212,
  OP_SUCCESS213: 213,
  OP_SUCCESS214: 214,
  OP_SUCCESS215: 215,
  OP_SUCCESS216: 216,
  OP_SUCCESS217: 217,
  OP_SUCCESS218: 218,
  OP_SUCCESS219: 219,
  OP_SUCCESS220: 220,
  OP_SUCCESS221: 221,
  OP_SUCCESS222: 222,
  OP_SUCCESS223: 223,
  OP_SUCCESS224: 224,
  OP_SUCCESS225: 225,
  OP_SUCCESS226: 226,
  OP_SUCCESS227: 227,
  OP_SUCCESS228: 228,
  OP_SUCCESS229: 229,
  OP_SUCCESS230: 230,
  OP_SUCCESS231: 231,
  OP_SUCCESS232: 232,
  OP_SUCCESS233: 233,
  OP_SUCCESS234: 234,
  OP_SUCCESS235: 235,
  OP_SUCCESS236: 236,
  OP_SUCCESS237: 237,
  OP_SUCCESS238: 238,
  OP_SUCCESS239: 239,
  OP_SUCCESS240: 240,
  OP_SUCCESS241: 241,
  OP_SUCCESS242: 242,
  OP_SUCCESS243: 243,
  OP_SUCCESS244: 244,
  OP_SUCCESS245: 245,
  OP_SUCCESS246: 246,
  OP_SUCCESS247: 247,
  OP_SUCCESS248: 248,
  OP_SUCCESS249: 249,
  OP_SUCCESS250: 250,
  OP_SUCCESS251: 251,
  OP_SUCCESS252: 252,
  OP_SUCCESS253: 253,
  OP_SUCCESS254: 254
};
function getOpLabel(n) {
  if (n > 186 && n < 255)
    return "OP_SUCCESS" + String(n);
  for (const [c, u] of Object.entries(OPCODE_MAP))
    if (u === n)
      return c;
  throw new Error("OPCODE not found:" + String(n));
}
function getOpCode(n) {
  for (const [c, u] of Object.entries(OPCODE_MAP))
    if (c === n)
      return Number(u);
  throw new Error("OPCODE not found:" + n);
}
function getWordType(n) {
  switch (!0) {
    case n === 0:
      return "opcode";
    case (n >= 1 && n <= 75):
      return "varint";
    case n === 76:
      return "pushdata1";
    case n === 77:
      return "pushdata2";
    case n === 78:
      return "pushdata4";
    case n <= 254:
      return "opcode";
    default:
      throw new Error(`Invalid word range: ${n}`);
  }
}
function isValidWord(n) {
  const p = [];
  switch (!0) {
    case typeof n != "number":
      return !1;
    case n === 0:
      return !0;
    case p.includes(n):
      return !1;
    case (75 < n && n < 254):
      return !0;
    default:
      return !1;
  }
}
function isHex(n) {
  return typeof n == "string" && n.length % 2 === 0 && /[0-9a-fA-F]/.test(n);
}
function isBytes$1(n) {
  return isHex(n) || n instanceof Uint8Array;
}
const MAX_WORD_SIZE = 520;
function encodeScript(n = [], c = !0) {
  let u = Buff$1.num(0);
  return Array.isArray(n) && (u = Buff$1.raw(encodeWords(n))), isHex(n) && (u = Buff$1.hex(n)), n instanceof Uint8Array && (u = Buff$1.raw(n)), c && (u = u.prefixSize("le")), u;
}
function encodeWords(n) {
  const c = [];
  for (const u of n)
    c.push(encodeWord(u));
  return c.length > 0 ? Buff$1.join(c) : new Uint8Array();
}
function encodeWord(n) {
  let c = new Uint8Array();
  if (typeof n == "string") {
    if (n.startsWith("OP_"))
      return Buff$1.num(getOpCode(n), 1);
    isHex(n) ? c = Buff$1.hex(n) : c = Buff$1.str(n);
  } else
    c = Buff$1.bytes(n);
  if (c.length === 1)
    return c[0] !== 0 && c[0] <= 16 ? (c[0] += 80, c) : (c[0] > 128 && c[0] <= 255 && (c = new Uint8Array([c[0], 0])), Buff$1.join([encodeSize(c.length), c]));
  if (c.length > MAX_WORD_SIZE) {
    const u = splitWord(c);
    return encodeWords(u);
  } else
    return Buff$1.join([encodeSize(c.length), c]);
}
function encodeSize(n) {
  const c = Buff$1.num(76, 1), u = Buff$1.num(77, 1);
  switch (!0) {
    case n <= 75:
      return Buff$1.num(n);
    case (n > 75 && n < 256):
      return Buff$1.join([c, Buff$1.num(n, 1, "le")]);
    case (n >= 256 && n <= MAX_WORD_SIZE):
      return Buff$1.join([u, Buff$1.num(n, 2, "le")]);
    default:
      throw new Error("Invalid word size:" + n.toString());
  }
}
function splitWord(n) {
  const c = [], u = new Stream$1(n);
  for (; u.size > MAX_WORD_SIZE; )
    c.push(u.read(MAX_WORD_SIZE));
  return c.push(u.read(u.size)), c;
}
function decodeScript(n, c = !1) {
  let u = Buff$1.bytes(n);
  if (c) {
    const a = u.stream.readSize("le");
    if (u = u.slice(1), u.length !== a)
      throw new Error(`Varint does not match stream size: ${a} !== ${u.length}`);
  }
  return decodeWords(u);
}
function decodeWords(n) {
  const c = new Stream$1(n), u = [], p = c.size;
  let a, A, b, F = 0;
  for (; F < p; )
    switch (a = c.read(1).num, A = getWordType(a), F++, A) {
      case "varint":
        u.push(c.read(a).hex), F += a;
        break;
      case "pushdata1":
        b = c.read(1).reverse().num, u.push(c.read(b).hex), F += b + 1;
        break;
      case "pushdata2":
        b = c.read(2).reverse().num, u.push(c.read(b).hex), F += b + 2;
        break;
      case "pushdata4":
        b = c.read(4).reverse().num, u.push(c.read(b).hex), F += b + 4;
        break;
      case "opcode":
        if (!isValidWord(a))
          throw new Error(`Invalid OPCODE: ${a}`);
        u.push(getOpLabel(a));
        break;
      default:
        throw new Error(`Word type undefined: ${a}`);
    }
  return u;
}
function toAsm(n, c) {
  if (Array.isArray(n) && (n = encodeScript(n, c)), n instanceof Uint8Array || isHex(n))
    return decodeScript(n, c);
  throw new Error("Invalid format: " + typeof n);
}
function toBytes$4(n, c) {
  if ((n instanceof Uint8Array || isHex(n)) && (n = decodeScript(n, c)), Array.isArray(n))
    return encodeScript(n, c);
  throw new Error("Invalid format: " + typeof n);
}
function toParam(n) {
  if (!Array.isArray(n))
    return Buff$1.bytes(n);
  throw new Error("Invalid format: " + typeof n);
}
const FmtScript = {
  toAsm,
  toBytes: toBytes$4,
  toParam
}, Script = {
  encode: encodeScript,
  decode: decodeScript,
  fmt: FmtScript
};
function number$2(n) {
  if (!Number.isSafeInteger(n) || n < 0)
    throw new Error(`Wrong positive integer: ${n}`);
}
function bool$2(n) {
  if (typeof n != "boolean")
    throw new Error(`Expected boolean, not ${n}`);
}
function bytes$2(n, ...c) {
  if (!(n instanceof Uint8Array))
    throw new TypeError("Expected Uint8Array");
  if (c.length > 0 && !c.includes(n.length))
    throw new TypeError(`Expected Uint8Array of length ${c}, not of length=${n.length}`);
}
function hash$3(n) {
  if (typeof n != "function" || typeof n.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  number$2(n.outputLen), number$2(n.blockLen);
}
function exists$2(n, c = !0) {
  if (n.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (c && n.finished)
    throw new Error("Hash#digest() has already been called");
}
function output$2(n, c) {
  bytes$2(n);
  const u = c.outputLen;
  if (n.length < u)
    throw new Error(`digestInto() expects output buffer of length at least ${u}`);
}
const assert$3 = {
  number: number$2,
  bool: bool$2,
  bytes: bytes$2,
  hash: hash$3,
  exists: exists$2,
  output: output$2
};
var assert$4 = assert$3;
const crypto$1$1 = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0;
const createView$2 = (n) => new DataView(n.buffer, n.byteOffset, n.byteLength), rotr$2 = (n, c) => n << 32 - c | n >>> c, isLE$2 = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
if (!isLE$2)
  throw new Error("Non little-endian hardware is not supported");
Array.from({ length: 256 }, (n, c) => c.toString(16).padStart(2, "0"));
function utf8ToBytes$3(n) {
  if (typeof n != "string")
    throw new TypeError(`utf8ToBytes expected string, got ${typeof n}`);
  return new TextEncoder().encode(n);
}
function toBytes$2(n) {
  if (typeof n == "string" && (n = utf8ToBytes$3(n)), !(n instanceof Uint8Array))
    throw new TypeError(`Expected input type is Uint8Array (got ${typeof n})`);
  return n;
}
function concatBytes$1(...n) {
  if (!n.every((p) => p instanceof Uint8Array))
    throw new Error("Uint8Array list expected");
  if (n.length === 1)
    return n[0];
  const c = n.reduce((p, a) => p + a.length, 0), u = new Uint8Array(c);
  for (let p = 0, a = 0; p < n.length; p++) {
    const A = n[p];
    u.set(A, a), a += A.length;
  }
  return u;
}
let Hash$2 = class {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
};
function wrapConstructor$2(n) {
  const c = (p) => n().update(toBytes$2(p)).digest(), u = n();
  return c.outputLen = u.outputLen, c.blockLen = u.blockLen, c.create = () => n(), c;
}
function randomBytes(n = 32) {
  if (crypto$1$1 && typeof crypto$1$1.getRandomValues == "function")
    return crypto$1$1.getRandomValues(new Uint8Array(n));
  throw new Error("crypto.getRandomValues must be defined");
}
function setBigUint64$2(n, c, u, p) {
  if (typeof n.setBigUint64 == "function")
    return n.setBigUint64(c, u, p);
  const a = BigInt(32), A = BigInt(4294967295), b = Number(u >> a & A), F = Number(u & A), le = p ? 4 : 0, L = p ? 0 : 4;
  n.setUint32(c + le, b, p), n.setUint32(c + L, F, p);
}
let SHA2$2 = class extends Hash$2 {
  constructor(c, u, p, a) {
    super(), this.blockLen = c, this.outputLen = u, this.padOffset = p, this.isLE = a, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(c), this.view = createView$2(this.buffer);
  }
  update(c) {
    assert$4.exists(this);
    const { view: u, buffer: p, blockLen: a } = this;
    c = toBytes$2(c);
    const A = c.length;
    for (let b = 0; b < A; ) {
      const F = Math.min(a - this.pos, A - b);
      if (F === a) {
        const le = createView$2(c);
        for (; a <= A - b; b += a)
          this.process(le, b);
        continue;
      }
      p.set(c.subarray(b, b + F), this.pos), this.pos += F, b += F, this.pos === a && (this.process(u, 0), this.pos = 0);
    }
    return this.length += c.length, this.roundClean(), this;
  }
  digestInto(c) {
    assert$4.exists(this), assert$4.output(c, this), this.finished = !0;
    const { buffer: u, view: p, blockLen: a, isLE: A } = this;
    let { pos: b } = this;
    u[b++] = 128, this.buffer.subarray(b).fill(0), this.padOffset > a - b && (this.process(p, 0), b = 0);
    for (let $ = b; $ < a; $++)
      u[$] = 0;
    setBigUint64$2(p, a - 8, BigInt(this.length * 8), A), this.process(p, 0);
    const F = createView$2(c), le = this.outputLen;
    if (le % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const L = le / 4, pe = this.get();
    if (L > pe.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let $ = 0; $ < L; $++)
      F.setUint32(4 * $, pe[$], A);
  }
  digest() {
    const { buffer: c, outputLen: u } = this;
    this.digestInto(c);
    const p = c.slice(0, u);
    return this.destroy(), p;
  }
  _cloneInto(c) {
    c || (c = new this.constructor()), c.set(...this.get());
    const { blockLen: u, buffer: p, length: a, finished: A, destroyed: b, pos: F } = this;
    return c.length = a, c.pos = F, c.finished = A, c.destroyed = b, a % u && c.buffer.set(p), c;
  }
};
const Chi$2 = (n, c, u) => n & c ^ ~n & u, Maj$2 = (n, c, u) => n & c ^ n & u ^ c & u, SHA256_K$2 = new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), IV$2 = new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), SHA256_W$2 = new Uint32Array(64);
let SHA256$2 = class extends SHA2$2 {
  constructor() {
    super(64, 32, 8, !1), this.A = IV$2[0] | 0, this.B = IV$2[1] | 0, this.C = IV$2[2] | 0, this.D = IV$2[3] | 0, this.E = IV$2[4] | 0, this.F = IV$2[5] | 0, this.G = IV$2[6] | 0, this.H = IV$2[7] | 0;
  }
  get() {
    const { A: c, B: u, C: p, D: a, E: A, F: b, G: F, H: le } = this;
    return [c, u, p, a, A, b, F, le];
  }
  // prettier-ignore
  set(c, u, p, a, A, b, F, le) {
    this.A = c | 0, this.B = u | 0, this.C = p | 0, this.D = a | 0, this.E = A | 0, this.F = b | 0, this.G = F | 0, this.H = le | 0;
  }
  process(c, u) {
    for (let $ = 0; $ < 16; $++, u += 4)
      SHA256_W$2[$] = c.getUint32(u, !1);
    for (let $ = 16; $ < 64; $++) {
      const Ee = SHA256_W$2[$ - 15], be = SHA256_W$2[$ - 2], He = rotr$2(Ee, 7) ^ rotr$2(Ee, 18) ^ Ee >>> 3, Pe = rotr$2(be, 17) ^ rotr$2(be, 19) ^ be >>> 10;
      SHA256_W$2[$] = Pe + SHA256_W$2[$ - 7] + He + SHA256_W$2[$ - 16] | 0;
    }
    let { A: p, B: a, C: A, D: b, E: F, F: le, G: L, H: pe } = this;
    for (let $ = 0; $ < 64; $++) {
      const Ee = rotr$2(F, 6) ^ rotr$2(F, 11) ^ rotr$2(F, 25), be = pe + Ee + Chi$2(F, le, L) + SHA256_K$2[$] + SHA256_W$2[$] | 0, Pe = (rotr$2(p, 2) ^ rotr$2(p, 13) ^ rotr$2(p, 22)) + Maj$2(p, a, A) | 0;
      pe = L, L = le, le = F, F = b + be | 0, b = A, A = a, a = p, p = be + Pe | 0;
    }
    p = p + this.A | 0, a = a + this.B | 0, A = A + this.C | 0, b = b + this.D | 0, F = F + this.E | 0, le = le + this.F | 0, L = L + this.G | 0, pe = pe + this.H | 0, this.set(p, a, A, b, F, le, L, pe);
  }
  roundClean() {
    SHA256_W$2.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
}, SHA224$2 = class extends SHA256$2 {
  constructor() {
    super(), this.A = -1056596264, this.B = 914150663, this.C = 812702999, this.D = -150054599, this.E = -4191439, this.F = 1750603025, this.G = 1694076839, this.H = -1090891868, this.outputLen = 28;
  }
};
const sha256$3 = wrapConstructor$2(() => new SHA256$2());
wrapConstructor$2(() => new SHA224$2());
const _0n$8 = BigInt(0), _1n$5 = BigInt(1), _2n$4 = BigInt(2), u8a$1 = (n) => n instanceof Uint8Array, hexes = Array.from({ length: 256 }, (n, c) => c.toString(16).padStart(2, "0"));
function bytesToHex$1(n) {
  if (!u8a$1(n))
    throw new Error("Uint8Array expected");
  let c = "";
  for (let u = 0; u < n.length; u++)
    c += hexes[n[u]];
  return c;
}
function numberToHexUnpadded(n) {
  const c = n.toString(16);
  return c.length & 1 ? `0${c}` : c;
}
function hexToNumber(n) {
  if (typeof n != "string")
    throw new Error("hex string expected, got " + typeof n);
  return BigInt(n === "" ? "0" : `0x${n}`);
}
function hexToBytes$1(n) {
  if (typeof n != "string")
    throw new Error("hex string expected, got " + typeof n);
  if (n.length % 2)
    throw new Error("hex string is invalid: unpadded " + n.length);
  const c = new Uint8Array(n.length / 2);
  for (let u = 0; u < c.length; u++) {
    const p = u * 2, a = n.slice(p, p + 2), A = Number.parseInt(a, 16);
    if (Number.isNaN(A) || A < 0)
      throw new Error("invalid byte sequence");
    c[u] = A;
  }
  return c;
}
function bytesToNumberBE(n) {
  return hexToNumber(bytesToHex$1(n));
}
function bytesToNumberLE(n) {
  if (!u8a$1(n))
    throw new Error("Uint8Array expected");
  return hexToNumber(bytesToHex$1(Uint8Array.from(n).reverse()));
}
const numberToBytesBE = (n, c) => hexToBytes$1(n.toString(16).padStart(c * 2, "0")), numberToBytesLE = (n, c) => numberToBytesBE(n, c).reverse(), numberToVarBytesBE = (n) => hexToBytes$1(numberToHexUnpadded(n));
function ensureBytes(n, c, u) {
  let p;
  if (typeof c == "string")
    try {
      p = hexToBytes$1(c);
    } catch (A) {
      throw new Error(`${n} must be valid hex string, got "${c}". Cause: ${A}`);
    }
  else if (u8a$1(c))
    p = Uint8Array.from(c);
  else
    throw new Error(`${n} must be hex string or Uint8Array`);
  const a = p.length;
  if (typeof u == "number" && a !== u)
    throw new Error(`${n} expected ${u} bytes, got ${a}`);
  return p;
}
function concatBytes(...n) {
  const c = new Uint8Array(n.reduce((p, a) => p + a.length, 0));
  let u = 0;
  return n.forEach((p) => {
    if (!u8a$1(p))
      throw new Error("Uint8Array expected");
    c.set(p, u), u += p.length;
  }), c;
}
function equalBytes(n, c) {
  if (n.length !== c.length)
    return !1;
  for (let u = 0; u < n.length; u++)
    if (n[u] !== c[u])
      return !1;
  return !0;
}
function utf8ToBytes$2(n) {
  if (typeof n != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof n}`);
  return new TextEncoder().encode(n);
}
function bitLen(n) {
  let c;
  for (c = 0; n > 0n; n >>= _1n$5, c += 1)
    ;
  return c;
}
const bitGet = (n, c) => n >> BigInt(c) & 1n, bitSet = (n, c, u) => n | (u ? _1n$5 : _0n$8) << BigInt(c), bitMask = (n) => (_2n$4 << BigInt(n - 1)) - _1n$5, u8n = (n) => new Uint8Array(n), u8fr = (n) => Uint8Array.from(n);
function createHmacDrbg(n, c, u) {
  if (typeof n != "number" || n < 2)
    throw new Error("hashLen must be a number");
  if (typeof c != "number" || c < 2)
    throw new Error("qByteLen must be a number");
  if (typeof u != "function")
    throw new Error("hmacFn must be a function");
  let p = u8n(n), a = u8n(n), A = 0;
  const b = () => {
    p.fill(1), a.fill(0), A = 0;
  }, F = (...$) => u(a, p, ...$), le = ($ = u8n()) => {
    a = F(u8fr([0]), $), p = F(), $.length !== 0 && (a = F(u8fr([1]), $), p = F());
  }, L = () => {
    if (A++ >= 1e3)
      throw new Error("drbg: tried 1000 values");
    let $ = 0;
    const Ee = [];
    for (; $ < c; ) {
      p = F();
      const be = p.slice();
      Ee.push(be), $ += p.length;
    }
    return concatBytes(...Ee);
  };
  return ($, Ee) => {
    b(), le($);
    let be;
    for (; !(be = Ee(L())); )
      le();
    return b(), be;
  };
}
const validatorFns = {
  bigint: (n) => typeof n == "bigint",
  function: (n) => typeof n == "function",
  boolean: (n) => typeof n == "boolean",
  string: (n) => typeof n == "string",
  isSafeInteger: (n) => Number.isSafeInteger(n),
  array: (n) => Array.isArray(n),
  field: (n, c) => c.Fp.isValid(n),
  hash: (n) => typeof n == "function" && Number.isSafeInteger(n.outputLen)
};
function validateObject(n, c, u = {}) {
  const p = (a, A, b) => {
    const F = validatorFns[A];
    if (typeof F != "function")
      throw new Error(`Invalid validator "${A}", expected function`);
    const le = n[a];
    if (!(b && le === void 0) && !F(le, n))
      throw new Error(`Invalid param ${String(a)}=${le} (${typeof le}), expected ${A}`);
  };
  for (const [a, A] of Object.entries(c))
    p(a, A, !1);
  for (const [a, A] of Object.entries(u))
    p(a, A, !0);
  return n;
}
var ut = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  bitGet,
  bitLen,
  bitMask,
  bitSet,
  bytesToHex: bytesToHex$1,
  bytesToNumberBE,
  bytesToNumberLE,
  concatBytes,
  createHmacDrbg,
  ensureBytes,
  equalBytes,
  hexToBytes: hexToBytes$1,
  hexToNumber,
  numberToBytesBE,
  numberToBytesLE,
  numberToHexUnpadded,
  numberToVarBytesBE,
  utf8ToBytes: utf8ToBytes$2,
  validateObject
});
const _0n$7 = BigInt(0), _1n$4 = BigInt(1), _2n$3 = BigInt(2), _3n$2 = BigInt(3), _4n$2 = BigInt(4), _5n = BigInt(5), _8n = BigInt(8);
BigInt(9);
BigInt(16);
function mod(n, c) {
  const u = n % c;
  return u >= _0n$7 ? u : c + u;
}
function pow(n, c, u) {
  if (u <= _0n$7 || c < _0n$7)
    throw new Error("Expected power/modulo > 0");
  if (u === _1n$4)
    return _0n$7;
  let p = _1n$4;
  for (; c > _0n$7; )
    c & _1n$4 && (p = p * n % u), n = n * n % u, c >>= _1n$4;
  return p;
}
function pow2(n, c, u) {
  let p = n;
  for (; c-- > _0n$7; )
    p *= p, p %= u;
  return p;
}
function invert(n, c) {
  if (n === _0n$7 || c <= _0n$7)
    throw new Error(`invert: expected positive integers, got n=${n} mod=${c}`);
  let u = mod(n, c), p = c, a = _0n$7, A = _1n$4;
  for (; u !== _0n$7; ) {
    const F = p / u, le = p % u, L = a - A * F;
    p = u, u = le, a = A, A = L;
  }
  if (p !== _1n$4)
    throw new Error("invert: does not exist");
  return mod(a, c);
}
function tonelliShanks(n) {
  const c = (n - _1n$4) / _2n$3;
  let u, p, a;
  for (u = n - _1n$4, p = 0; u % _2n$3 === _0n$7; u /= _2n$3, p++)
    ;
  for (a = _2n$3; a < n && pow(a, c, n) !== n - _1n$4; a++)
    ;
  if (p === 1) {
    const b = (n + _1n$4) / _4n$2;
    return function(le, L) {
      const pe = le.pow(L, b);
      if (!le.eql(le.sqr(pe), L))
        throw new Error("Cannot find square root");
      return pe;
    };
  }
  const A = (u + _1n$4) / _2n$3;
  return function(F, le) {
    if (F.pow(le, c) === F.neg(F.ONE))
      throw new Error("Cannot find square root");
    let L = p, pe = F.pow(F.mul(F.ONE, a), u), $ = F.pow(le, A), Ee = F.pow(le, u);
    for (; !F.eql(Ee, F.ONE); ) {
      if (F.eql(Ee, F.ZERO))
        return F.ZERO;
      let be = 1;
      for (let Pe = F.sqr(Ee); be < L && !F.eql(Pe, F.ONE); be++)
        Pe = F.sqr(Pe);
      const He = F.pow(pe, _1n$4 << BigInt(L - be - 1));
      pe = F.sqr(He), $ = F.mul($, He), Ee = F.mul(Ee, pe), L = be;
    }
    return $;
  };
}
function FpSqrt(n) {
  if (n % _4n$2 === _3n$2) {
    const c = (n + _1n$4) / _4n$2;
    return function(p, a) {
      const A = p.pow(a, c);
      if (!p.eql(p.sqr(A), a))
        throw new Error("Cannot find square root");
      return A;
    };
  }
  if (n % _8n === _5n) {
    const c = (n - _5n) / _8n;
    return function(p, a) {
      const A = p.mul(a, _2n$3), b = p.pow(A, c), F = p.mul(a, b), le = p.mul(p.mul(F, _2n$3), b), L = p.mul(F, p.sub(le, p.ONE));
      if (!p.eql(p.sqr(L), a))
        throw new Error("Cannot find square root");
      return L;
    };
  }
  return tonelliShanks(n);
}
const FIELD_FIELDS = [
  "create",
  "isValid",
  "is0",
  "neg",
  "inv",
  "sqrt",
  "sqr",
  "eql",
  "add",
  "sub",
  "mul",
  "pow",
  "div",
  "addN",
  "subN",
  "mulN",
  "sqrN"
];
function validateField(n) {
  const c = {
    ORDER: "bigint",
    MASK: "bigint",
    BYTES: "isSafeInteger",
    BITS: "isSafeInteger"
  }, u = FIELD_FIELDS.reduce((p, a) => (p[a] = "function", p), c);
  return validateObject(n, u);
}
function FpPow(n, c, u) {
  if (u < _0n$7)
    throw new Error("Expected power > 0");
  if (u === _0n$7)
    return n.ONE;
  if (u === _1n$4)
    return c;
  let p = n.ONE, a = c;
  for (; u > _0n$7; )
    u & _1n$4 && (p = n.mul(p, a)), a = n.sqr(a), u >>= _1n$4;
  return p;
}
function FpInvertBatch(n, c) {
  const u = new Array(c.length), p = c.reduce((A, b, F) => n.is0(b) ? A : (u[F] = A, n.mul(A, b)), n.ONE), a = n.inv(p);
  return c.reduceRight((A, b, F) => n.is0(b) ? A : (u[F] = n.mul(A, u[F]), n.mul(A, b)), a), u;
}
function nLength(n, c) {
  const u = c !== void 0 ? c : n.toString(2).length, p = Math.ceil(u / 8);
  return { nBitLength: u, nByteLength: p };
}
function Field$1(n, c, u = !1, p = {}) {
  if (n <= _0n$7)
    throw new Error(`Expected Fp ORDER > 0, got ${n}`);
  const { nBitLength: a, nByteLength: A } = nLength(n, c);
  if (A > 2048)
    throw new Error("Field lengths over 2048 bytes are not supported");
  const b = FpSqrt(n), F = Object.freeze({
    ORDER: n,
    BITS: a,
    BYTES: A,
    MASK: bitMask(a),
    ZERO: _0n$7,
    ONE: _1n$4,
    create: (le) => mod(le, n),
    isValid: (le) => {
      if (typeof le != "bigint")
        throw new Error(`Invalid field element: expected bigint, got ${typeof le}`);
      return _0n$7 <= le && le < n;
    },
    is0: (le) => le === _0n$7,
    isOdd: (le) => (le & _1n$4) === _1n$4,
    neg: (le) => mod(-le, n),
    eql: (le, L) => le === L,
    sqr: (le) => mod(le * le, n),
    add: (le, L) => mod(le + L, n),
    sub: (le, L) => mod(le - L, n),
    mul: (le, L) => mod(le * L, n),
    pow: (le, L) => FpPow(F, le, L),
    div: (le, L) => mod(le * invert(L, n), n),
    // Same as above, but doesn't normalize
    sqrN: (le) => le * le,
    addN: (le, L) => le + L,
    subN: (le, L) => le - L,
    mulN: (le, L) => le * L,
    inv: (le) => invert(le, n),
    sqrt: p.sqrt || ((le) => b(F, le)),
    invertBatch: (le) => FpInvertBatch(F, le),
    // TODO: do we really need constant cmov?
    // We don't have const-time bigints anyway, so probably will be not very useful
    cmov: (le, L, pe) => pe ? L : le,
    toBytes: (le) => u ? numberToBytesLE(le, A) : numberToBytesBE(le, A),
    fromBytes: (le) => {
      if (le.length !== A)
        throw new Error(`Fp.fromBytes: expected ${A}, got ${le.length}`);
      return u ? bytesToNumberLE(le) : bytesToNumberBE(le);
    }
  });
  return Object.freeze(F);
}
function hashToPrivateScalar(n, c, u = !1) {
  n = ensureBytes("privateHash", n);
  const p = n.length, a = nLength(c).nByteLength + 8;
  if (a < 24 || p < a || p > 1024)
    throw new Error(`hashToPrivateScalar: expected ${a}-1024 bytes of input, got ${p}`);
  const A = u ? bytesToNumberLE(n) : bytesToNumberBE(n);
  return mod(A, c - _1n$4) + _1n$4;
}
const _0n$6 = BigInt(0), _1n$3 = BigInt(1);
function wNAF(n, c) {
  const u = (a, A) => {
    const b = A.negate();
    return a ? b : A;
  }, p = (a) => {
    const A = Math.ceil(c / a) + 1, b = 2 ** (a - 1);
    return { windows: A, windowSize: b };
  };
  return {
    constTimeNegate: u,
    // non-const time multiplication ladder
    unsafeLadder(a, A) {
      let b = n.ZERO, F = a;
      for (; A > _0n$6; )
        A & _1n$3 && (b = b.add(F)), F = F.double(), A >>= _1n$3;
      return b;
    },
    /**
     * Creates a wNAF precomputation window. Used for caching.
     * Default window size is set by `utils.precompute()` and is equal to 8.
     * Number of precomputed points depends on the curve size:
     * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
     * - 𝑊 is the window size
     * - 𝑛 is the bitlength of the curve order.
     * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
     * @returns precomputed point tables flattened to a single array
     */
    precomputeWindow(a, A) {
      const { windows: b, windowSize: F } = p(A), le = [];
      let L = a, pe = L;
      for (let $ = 0; $ < b; $++) {
        pe = L, le.push(pe);
        for (let Ee = 1; Ee < F; Ee++)
          pe = pe.add(L), le.push(pe);
        L = pe.double();
      }
      return le;
    },
    /**
     * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
     * @param W window size
     * @param precomputes precomputed tables
     * @param n scalar (we don't check here, but should be less than curve order)
     * @returns real and fake (for const-time) points
     */
    wNAF(a, A, b) {
      const { windows: F, windowSize: le } = p(a);
      let L = n.ZERO, pe = n.BASE;
      const $ = BigInt(2 ** a - 1), Ee = 2 ** a, be = BigInt(a);
      for (let He = 0; He < F; He++) {
        const Pe = He * le;
        let nr = Number(b & $);
        b >>= be, nr > le && (nr -= Ee, b += _1n$3);
        const ir = Pe, or = Pe + Math.abs(nr) - 1, lr = He % 2 !== 0, Ir = nr < 0;
        nr === 0 ? pe = pe.add(u(lr, A[ir])) : L = L.add(u(Ir, A[or]));
      }
      return { p: L, f: pe };
    },
    wNAFCached(a, A, b, F) {
      const le = a._WINDOW_SIZE || 1;
      let L = A.get(a);
      return L || (L = this.precomputeWindow(a, le), le !== 1 && A.set(a, F(L))), this.wNAF(le, L, b);
    }
  };
}
function validateBasic(n) {
  return validateField(n.Fp), validateObject(n, {
    n: "bigint",
    h: "bigint",
    Gx: "field",
    Gy: "field"
  }, {
    nBitLength: "isSafeInteger",
    nByteLength: "isSafeInteger"
  }), Object.freeze({
    ...nLength(n.n, n.nBitLength),
    ...n,
    p: n.Fp.ORDER
  });
}
function validatePointOpts(n) {
  const c = validateBasic(n);
  validateObject(c, {
    a: "field",
    b: "field"
  }, {
    allowedPrivateKeyLengths: "array",
    wrapPrivateKey: "boolean",
    isTorsionFree: "function",
    clearCofactor: "function",
    allowInfinityPoint: "boolean",
    fromBytes: "function",
    toBytes: "function"
  });
  const { endo: u, Fp: p, a } = c;
  if (u) {
    if (!p.eql(a, p.ZERO))
      throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
    if (typeof u != "object" || typeof u.beta != "bigint" || typeof u.splitScalar != "function")
      throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
  }
  return Object.freeze({ ...c });
}
const { bytesToNumberBE: b2n, hexToBytes: h2b } = ut, DER = {
  // asn.1 DER encoding utils
  Err: class extends Error {
    constructor(c = "") {
      super(c);
    }
  },
  _parseInt(n) {
    const { Err: c } = DER;
    if (n.length < 2 || n[0] !== 2)
      throw new c("Invalid signature integer tag");
    const u = n[1], p = n.subarray(2, u + 2);
    if (!u || p.length !== u)
      throw new c("Invalid signature integer: wrong length");
    if (p[0] === 0 && p[1] <= 127)
      throw new c("Invalid signature integer: trailing length");
    return { d: b2n(p), l: n.subarray(u + 2) };
  },
  toSig(n) {
    const { Err: c } = DER, u = typeof n == "string" ? h2b(n) : n;
    if (!(u instanceof Uint8Array))
      throw new Error("ui8a expected");
    let p = u.length;
    if (p < 2 || u[0] != 48)
      throw new c("Invalid signature tag");
    if (u[1] !== p - 2)
      throw new c("Invalid signature: incorrect length");
    const { d: a, l: A } = DER._parseInt(u.subarray(2)), { d: b, l: F } = DER._parseInt(A);
    if (F.length)
      throw new c("Invalid signature: left bytes after parsing");
    return { r: a, s: b };
  },
  hexFromSig(n) {
    const c = (L) => Number.parseInt(L[0], 16) >= 8 ? "00" + L : L, u = (L) => {
      const pe = L.toString(16);
      return pe.length & 1 ? `0${pe}` : pe;
    }, p = c(u(n.s)), a = c(u(n.r)), A = p.length / 2, b = a.length / 2, F = u(A), le = u(b);
    return `30${u(b + A + 4)}02${le}${a}02${F}${p}`;
  }
}, _0n$5 = BigInt(0), _1n$2 = BigInt(1), _2n$2 = BigInt(2), _3n$1 = BigInt(3), _4n$1 = BigInt(4);
function weierstrassPoints(n) {
  const c = validatePointOpts(n), { Fp: u } = c, p = c.toBytes || ((He, Pe, nr) => {
    const ir = Pe.toAffine();
    return concatBytes(Uint8Array.from([4]), u.toBytes(ir.x), u.toBytes(ir.y));
  }), a = c.fromBytes || ((He) => {
    const Pe = He.subarray(1), nr = u.fromBytes(Pe.subarray(0, u.BYTES)), ir = u.fromBytes(Pe.subarray(u.BYTES, 2 * u.BYTES));
    return { x: nr, y: ir };
  });
  function A(He) {
    const { a: Pe, b: nr } = c, ir = u.sqr(He), or = u.mul(ir, He);
    return u.add(u.add(or, u.mul(He, Pe)), nr);
  }
  function b(He) {
    return typeof He == "bigint" && _0n$5 < He && He < c.n;
  }
  function F(He) {
    if (!b(He))
      throw new Error("Expected valid bigint: 0 < bigint < curve.n");
  }
  function le(He) {
    const { allowedPrivateKeyLengths: Pe, nByteLength: nr, wrapPrivateKey: ir, n: or } = c;
    if (Pe && typeof He != "bigint") {
      if (He instanceof Uint8Array && (He = bytesToHex$1(He)), typeof He != "string" || !Pe.includes(He.length))
        throw new Error("Invalid key");
      He = He.padStart(nr * 2, "0");
    }
    let lr;
    try {
      lr = typeof He == "bigint" ? He : bytesToNumberBE(ensureBytes("private key", He, nr));
    } catch {
      throw new Error(`private key must be ${nr} bytes, hex or bigint, not ${typeof He}`);
    }
    return ir && (lr = mod(lr, or)), F(lr), lr;
  }
  const L = /* @__PURE__ */ new Map();
  function pe(He) {
    if (!(He instanceof $))
      throw new Error("ProjectivePoint expected");
  }
  class $ {
    constructor(Pe, nr, ir) {
      if (this.px = Pe, this.py = nr, this.pz = ir, Pe == null || !u.isValid(Pe))
        throw new Error("x required");
      if (nr == null || !u.isValid(nr))
        throw new Error("y required");
      if (ir == null || !u.isValid(ir))
        throw new Error("z required");
    }
    // Does not validate if the point is on-curve.
    // Use fromHex instead, or call assertValidity() later.
    static fromAffine(Pe) {
      const { x: nr, y: ir } = Pe || {};
      if (!Pe || !u.isValid(nr) || !u.isValid(ir))
        throw new Error("invalid affine point");
      if (Pe instanceof $)
        throw new Error("projective point not allowed");
      const or = (lr) => u.eql(lr, u.ZERO);
      return or(nr) && or(ir) ? $.ZERO : new $(nr, ir, u.ONE);
    }
    get x() {
      return this.toAffine().x;
    }
    get y() {
      return this.toAffine().y;
    }
    /**
     * Takes a bunch of Projective Points but executes only one
     * inversion on all of them. Inversion is very slow operation,
     * so this improves performance massively.
     * Optimization: converts a list of projective points to a list of identical points with Z=1.
     */
    static normalizeZ(Pe) {
      const nr = u.invertBatch(Pe.map((ir) => ir.pz));
      return Pe.map((ir, or) => ir.toAffine(nr[or])).map($.fromAffine);
    }
    /**
     * Converts hash string or Uint8Array to Point.
     * @param hex short/long ECDSA hex
     */
    static fromHex(Pe) {
      const nr = $.fromAffine(a(ensureBytes("pointHex", Pe)));
      return nr.assertValidity(), nr;
    }
    // Multiplies generator point by privateKey.
    static fromPrivateKey(Pe) {
      return $.BASE.multiply(le(Pe));
    }
    // "Private method", don't use it directly
    _setWindowSize(Pe) {
      this._WINDOW_SIZE = Pe, L.delete(this);
    }
    // A point on curve is valid if it conforms to equation.
    assertValidity() {
      if (this.is0()) {
        if (c.allowInfinityPoint)
          return;
        throw new Error("bad point: ZERO");
      }
      const { x: Pe, y: nr } = this.toAffine();
      if (!u.isValid(Pe) || !u.isValid(nr))
        throw new Error("bad point: x or y not FE");
      const ir = u.sqr(nr), or = A(Pe);
      if (!u.eql(ir, or))
        throw new Error("bad point: equation left != right");
      if (!this.isTorsionFree())
        throw new Error("bad point: not in prime-order subgroup");
    }
    hasEvenY() {
      const { y: Pe } = this.toAffine();
      if (u.isOdd)
        return !u.isOdd(Pe);
      throw new Error("Field doesn't support isOdd");
    }
    /**
     * Compare one point to another.
     */
    equals(Pe) {
      pe(Pe);
      const { px: nr, py: ir, pz: or } = this, { px: lr, py: Ir, pz: xr } = Pe, kr = u.eql(u.mul(nr, xr), u.mul(lr, or)), Ce = u.eql(u.mul(ir, xr), u.mul(Ir, or));
      return kr && Ce;
    }
    /**
     * Flips point to one corresponding to (x, -y) in Affine coordinates.
     */
    negate() {
      return new $(this.px, u.neg(this.py), this.pz);
    }
    // Renes-Costello-Batina exception-free doubling formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 3
    // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
    double() {
      const { a: Pe, b: nr } = c, ir = u.mul(nr, _3n$1), { px: or, py: lr, pz: Ir } = this;
      let xr = u.ZERO, kr = u.ZERO, Ce = u.ZERO, tr = u.mul(or, or), Fe = u.mul(lr, lr), Sr = u.mul(Ir, Ir), er = u.mul(or, lr);
      return er = u.add(er, er), Ce = u.mul(or, Ir), Ce = u.add(Ce, Ce), xr = u.mul(Pe, Ce), kr = u.mul(ir, Sr), kr = u.add(xr, kr), xr = u.sub(Fe, kr), kr = u.add(Fe, kr), kr = u.mul(xr, kr), xr = u.mul(er, xr), Ce = u.mul(ir, Ce), Sr = u.mul(Pe, Sr), er = u.sub(tr, Sr), er = u.mul(Pe, er), er = u.add(er, Ce), Ce = u.add(tr, tr), tr = u.add(Ce, tr), tr = u.add(tr, Sr), tr = u.mul(tr, er), kr = u.add(kr, tr), Sr = u.mul(lr, Ir), Sr = u.add(Sr, Sr), tr = u.mul(Sr, er), xr = u.sub(xr, tr), Ce = u.mul(Sr, Fe), Ce = u.add(Ce, Ce), Ce = u.add(Ce, Ce), new $(xr, kr, Ce);
    }
    // Renes-Costello-Batina exception-free addition formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 1
    // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
    add(Pe) {
      pe(Pe);
      const { px: nr, py: ir, pz: or } = this, { px: lr, py: Ir, pz: xr } = Pe;
      let kr = u.ZERO, Ce = u.ZERO, tr = u.ZERO;
      const Fe = c.a, Sr = u.mul(c.b, _3n$1);
      let er = u.mul(nr, lr), Ie = u.mul(ir, Ir), xe = u.mul(or, xr), rr = u.add(nr, ir), ar = u.add(lr, Ir);
      rr = u.mul(rr, ar), ar = u.add(er, Ie), rr = u.sub(rr, ar), ar = u.add(nr, or);
      let yr = u.add(lr, xr);
      return ar = u.mul(ar, yr), yr = u.add(er, xe), ar = u.sub(ar, yr), yr = u.add(ir, or), kr = u.add(Ir, xr), yr = u.mul(yr, kr), kr = u.add(Ie, xe), yr = u.sub(yr, kr), tr = u.mul(Fe, ar), kr = u.mul(Sr, xe), tr = u.add(kr, tr), kr = u.sub(Ie, tr), tr = u.add(Ie, tr), Ce = u.mul(kr, tr), Ie = u.add(er, er), Ie = u.add(Ie, er), xe = u.mul(Fe, xe), ar = u.mul(Sr, ar), Ie = u.add(Ie, xe), xe = u.sub(er, xe), xe = u.mul(Fe, xe), ar = u.add(ar, xe), er = u.mul(Ie, ar), Ce = u.add(Ce, er), er = u.mul(yr, ar), kr = u.mul(rr, kr), kr = u.sub(kr, er), er = u.mul(rr, Ie), tr = u.mul(yr, tr), tr = u.add(tr, er), new $(kr, Ce, tr);
    }
    subtract(Pe) {
      return this.add(Pe.negate());
    }
    is0() {
      return this.equals($.ZERO);
    }
    wNAF(Pe) {
      return be.wNAFCached(this, L, Pe, (nr) => {
        const ir = u.invertBatch(nr.map((or) => or.pz));
        return nr.map((or, lr) => or.toAffine(ir[lr])).map($.fromAffine);
      });
    }
    /**
     * Non-constant-time multiplication. Uses double-and-add algorithm.
     * It's faster, but should only be used when you don't care about
     * an exposed private key e.g. sig verification, which works over *public* keys.
     */
    multiplyUnsafe(Pe) {
      const nr = $.ZERO;
      if (Pe === _0n$5)
        return nr;
      if (F(Pe), Pe === _1n$2)
        return this;
      const { endo: ir } = c;
      if (!ir)
        return be.unsafeLadder(this, Pe);
      let { k1neg: or, k1: lr, k2neg: Ir, k2: xr } = ir.splitScalar(Pe), kr = nr, Ce = nr, tr = this;
      for (; lr > _0n$5 || xr > _0n$5; )
        lr & _1n$2 && (kr = kr.add(tr)), xr & _1n$2 && (Ce = Ce.add(tr)), tr = tr.double(), lr >>= _1n$2, xr >>= _1n$2;
      return or && (kr = kr.negate()), Ir && (Ce = Ce.negate()), Ce = new $(u.mul(Ce.px, ir.beta), Ce.py, Ce.pz), kr.add(Ce);
    }
    /**
     * Constant time multiplication.
     * Uses wNAF method. Windowed method may be 10% faster,
     * but takes 2x longer to generate and consumes 2x memory.
     * Uses precomputes when available.
     * Uses endomorphism for Koblitz curves.
     * @param scalar by which the point would be multiplied
     * @returns New point
     */
    multiply(Pe) {
      F(Pe);
      let nr = Pe, ir, or;
      const { endo: lr } = c;
      if (lr) {
        const { k1neg: Ir, k1: xr, k2neg: kr, k2: Ce } = lr.splitScalar(nr);
        let { p: tr, f: Fe } = this.wNAF(xr), { p: Sr, f: er } = this.wNAF(Ce);
        tr = be.constTimeNegate(Ir, tr), Sr = be.constTimeNegate(kr, Sr), Sr = new $(u.mul(Sr.px, lr.beta), Sr.py, Sr.pz), ir = tr.add(Sr), or = Fe.add(er);
      } else {
        const { p: Ir, f: xr } = this.wNAF(nr);
        ir = Ir, or = xr;
      }
      return $.normalizeZ([ir, or])[0];
    }
    /**
     * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
     * Not using Strauss-Shamir trick: precomputation tables are faster.
     * The trick could be useful if both P and Q are not G (not in our case).
     * @returns non-zero affine point
     */
    multiplyAndAddUnsafe(Pe, nr, ir) {
      const or = $.BASE, lr = (xr, kr) => kr === _0n$5 || kr === _1n$2 || !xr.equals(or) ? xr.multiplyUnsafe(kr) : xr.multiply(kr), Ir = lr(this, nr).add(lr(Pe, ir));
      return Ir.is0() ? void 0 : Ir;
    }
    // Converts Projective point to affine (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    // (x, y, z) ∋ (x=x/z, y=y/z)
    toAffine(Pe) {
      const { px: nr, py: ir, pz: or } = this, lr = this.is0();
      Pe == null && (Pe = lr ? u.ONE : u.inv(or));
      const Ir = u.mul(nr, Pe), xr = u.mul(ir, Pe), kr = u.mul(or, Pe);
      if (lr)
        return { x: u.ZERO, y: u.ZERO };
      if (!u.eql(kr, u.ONE))
        throw new Error("invZ was invalid");
      return { x: Ir, y: xr };
    }
    isTorsionFree() {
      const { h: Pe, isTorsionFree: nr } = c;
      if (Pe === _1n$2)
        return !0;
      if (nr)
        return nr($, this);
      throw new Error("isTorsionFree() has not been declared for the elliptic curve");
    }
    clearCofactor() {
      const { h: Pe, clearCofactor: nr } = c;
      return Pe === _1n$2 ? this : nr ? nr($, this) : this.multiplyUnsafe(c.h);
    }
    toRawBytes(Pe = !0) {
      return this.assertValidity(), p($, this, Pe);
    }
    toHex(Pe = !0) {
      return bytesToHex$1(this.toRawBytes(Pe));
    }
  }
  $.BASE = new $(c.Gx, c.Gy, u.ONE), $.ZERO = new $(u.ZERO, u.ONE, u.ZERO);
  const Ee = c.nBitLength, be = wNAF($, c.endo ? Math.ceil(Ee / 2) : Ee);
  return {
    CURVE: c,
    ProjectivePoint: $,
    normPrivateKeyToScalar: le,
    weierstrassEquation: A,
    isWithinCurveOrder: b
  };
}
function validateOpts(n) {
  const c = validateBasic(n);
  return validateObject(c, {
    hash: "hash",
    hmac: "function",
    randomBytes: "function"
  }, {
    bits2int: "function",
    bits2int_modN: "function",
    lowS: "boolean"
  }), Object.freeze({ lowS: !0, ...c });
}
function weierstrass(n) {
  const c = validateOpts(n), { Fp: u, n: p } = c, a = u.BYTES + 1, A = 2 * u.BYTES + 1;
  function b(ar) {
    return _0n$5 < ar && ar < u.ORDER;
  }
  function F(ar) {
    return mod(ar, p);
  }
  function le(ar) {
    return invert(ar, p);
  }
  const { ProjectivePoint: L, normPrivateKeyToScalar: pe, weierstrassEquation: $, isWithinCurveOrder: Ee } = weierstrassPoints({
    ...c,
    toBytes(ar, yr, _r) {
      const Or = yr.toAffine(), vr = u.toBytes(Or.x), Te = concatBytes;
      return _r ? Te(Uint8Array.from([yr.hasEvenY() ? 2 : 3]), vr) : Te(Uint8Array.from([4]), vr, u.toBytes(Or.y));
    },
    fromBytes(ar) {
      const yr = ar.length, _r = ar[0], Or = ar.subarray(1);
      if (yr === a && (_r === 2 || _r === 3)) {
        const vr = bytesToNumberBE(Or);
        if (!b(vr))
          throw new Error("Point is not on curve");
        const Te = $(vr);
        let Cr = u.sqrt(Te);
        const Hr = (Cr & _1n$2) === _1n$2;
        return (_r & 1) === 1 !== Hr && (Cr = u.neg(Cr)), { x: vr, y: Cr };
      } else if (yr === A && _r === 4) {
        const vr = u.fromBytes(Or.subarray(0, u.BYTES)), Te = u.fromBytes(Or.subarray(u.BYTES, 2 * u.BYTES));
        return { x: vr, y: Te };
      } else
        throw new Error(`Point of length ${yr} was invalid. Expected ${a} compressed bytes or ${A} uncompressed bytes`);
    }
  }), be = (ar) => bytesToHex$1(numberToBytesBE(ar, c.nByteLength));
  function He(ar) {
    const yr = p >> _1n$2;
    return ar > yr;
  }
  function Pe(ar) {
    return He(ar) ? F(-ar) : ar;
  }
  const nr = (ar, yr, _r) => bytesToNumberBE(ar.slice(yr, _r));
  class ir {
    constructor(yr, _r, Or) {
      this.r = yr, this.s = _r, this.recovery = Or, this.assertValidity();
    }
    // pair (bytes of r, bytes of s)
    static fromCompact(yr) {
      const _r = c.nByteLength;
      return yr = ensureBytes("compactSignature", yr, _r * 2), new ir(nr(yr, 0, _r), nr(yr, _r, 2 * _r));
    }
    // DER encoded ECDSA signature
    // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
    static fromDER(yr) {
      const { r: _r, s: Or } = DER.toSig(ensureBytes("DER", yr));
      return new ir(_r, Or);
    }
    assertValidity() {
      if (!Ee(this.r))
        throw new Error("r must be 0 < r < CURVE.n");
      if (!Ee(this.s))
        throw new Error("s must be 0 < s < CURVE.n");
    }
    addRecoveryBit(yr) {
      return new ir(this.r, this.s, yr);
    }
    recoverPublicKey(yr) {
      const { r: _r, s: Or, recovery: vr } = this, Te = Ce(ensureBytes("msgHash", yr));
      if (vr == null || ![0, 1, 2, 3].includes(vr))
        throw new Error("recovery id invalid");
      const Cr = vr === 2 || vr === 3 ? _r + c.n : _r;
      if (Cr >= u.ORDER)
        throw new Error("recovery id 2 or 3 invalid");
      const Hr = vr & 1 ? "03" : "02", si = L.fromHex(Hr + be(Cr)), ui = le(Cr), Li = F(-Te * ui), Qi = F(Or * ui), wi = L.BASE.multiplyAndAddUnsafe(si, Li, Qi);
      if (!wi)
        throw new Error("point at infinify");
      return wi.assertValidity(), wi;
    }
    // Signatures should be low-s, to prevent malleability.
    hasHighS() {
      return He(this.s);
    }
    normalizeS() {
      return this.hasHighS() ? new ir(this.r, F(-this.s), this.recovery) : this;
    }
    // DER-encoded
    toDERRawBytes() {
      return hexToBytes$1(this.toDERHex());
    }
    toDERHex() {
      return DER.hexFromSig({ r: this.r, s: this.s });
    }
    // padded bytes of r, then padded bytes of s
    toCompactRawBytes() {
      return hexToBytes$1(this.toCompactHex());
    }
    toCompactHex() {
      return be(this.r) + be(this.s);
    }
  }
  const or = {
    isValidPrivateKey(ar) {
      try {
        return pe(ar), !0;
      } catch {
        return !1;
      }
    },
    normPrivateKeyToScalar: pe,
    /**
     * Produces cryptographically secure private key from random of size (nBitLength+64)
     * as per FIPS 186 B.4.1 with modulo bias being neglible.
     */
    randomPrivateKey: () => {
      const ar = c.randomBytes(u.BYTES + 8), yr = hashToPrivateScalar(ar, p);
      return numberToBytesBE(yr, c.nByteLength);
    },
    /**
     * Creates precompute table for an arbitrary EC point. Makes point "cached".
     * Allows to massively speed-up `point.multiply(scalar)`.
     * @returns cached point
     * @example
     * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
     * fast.multiply(privKey); // much faster ECDH now
     */
    precompute(ar = 8, yr = L.BASE) {
      return yr._setWindowSize(ar), yr.multiply(BigInt(3)), yr;
    }
  };
  function lr(ar, yr = !0) {
    return L.fromPrivateKey(ar).toRawBytes(yr);
  }
  function Ir(ar) {
    const yr = ar instanceof Uint8Array, _r = typeof ar == "string", Or = (yr || _r) && ar.length;
    return yr ? Or === a || Or === A : _r ? Or === 2 * a || Or === 2 * A : ar instanceof L;
  }
  function xr(ar, yr, _r = !0) {
    if (Ir(ar))
      throw new Error("first arg must be private key");
    if (!Ir(yr))
      throw new Error("second arg must be public key");
    return L.fromHex(yr).multiply(pe(ar)).toRawBytes(_r);
  }
  const kr = c.bits2int || function(ar) {
    const yr = bytesToNumberBE(ar), _r = ar.length * 8 - c.nBitLength;
    return _r > 0 ? yr >> BigInt(_r) : yr;
  }, Ce = c.bits2int_modN || function(ar) {
    return F(kr(ar));
  }, tr = bitMask(c.nBitLength);
  function Fe(ar) {
    if (typeof ar != "bigint")
      throw new Error("bigint expected");
    if (!(_0n$5 <= ar && ar < tr))
      throw new Error(`bigint expected < 2^${c.nBitLength}`);
    return numberToBytesBE(ar, c.nByteLength);
  }
  function Sr(ar, yr, _r = er) {
    if (["recovered", "canonical"].some((mn) => mn in _r))
      throw new Error("sign() legacy options not supported");
    const { hash: Or, randomBytes: vr } = c;
    let { lowS: Te, prehash: Cr, extraEntropy: Hr } = _r;
    Te == null && (Te = !0), ar = ensureBytes("msgHash", ar), Cr && (ar = ensureBytes("prehashed msgHash", Or(ar)));
    const si = Ce(ar), ui = pe(yr), Li = [Fe(ui), Fe(si)];
    if (Hr != null) {
      const mn = Hr === !0 ? vr(u.BYTES) : Hr;
      Li.push(ensureBytes("extraEntropy", mn, u.BYTES));
    }
    const Qi = concatBytes(...Li), wi = si;
    function Ji(mn) {
      const pi = kr(mn);
      if (!Ee(pi))
        return;
      const ei = le(pi), Vr = L.BASE.multiply(pi).toAffine(), qr = F(Vr.x);
      if (qr === _0n$5)
        return;
      const Zi = F(ei * F(wi + qr * ui));
      if (Zi === _0n$5)
        return;
      let Wr = (Vr.x === qr ? 0 : 2) | Number(Vr.y & _1n$2), ri = Zi;
      return Te && He(Zi) && (ri = Pe(Zi), Wr ^= 1), new ir(qr, ri, Wr);
    }
    return { seed: Qi, k2sig: Ji };
  }
  const er = { lowS: c.lowS, prehash: !1 }, Ie = { lowS: c.lowS, prehash: !1 };
  function xe(ar, yr, _r = er) {
    const { seed: Or, k2sig: vr } = Sr(ar, yr, _r);
    return createHmacDrbg(c.hash.outputLen, c.nByteLength, c.hmac)(Or, vr);
  }
  L.BASE._setWindowSize(8);
  function rr(ar, yr, _r, Or = Ie) {
    var Vr;
    const vr = ar;
    if (yr = ensureBytes("msgHash", yr), _r = ensureBytes("publicKey", _r), "strict" in Or)
      throw new Error("options.strict was renamed to lowS");
    const { lowS: Te, prehash: Cr } = Or;
    let Hr, si;
    try {
      if (typeof vr == "string" || vr instanceof Uint8Array)
        try {
          Hr = ir.fromDER(vr);
        } catch (qr) {
          if (!(qr instanceof DER.Err))
            throw qr;
          Hr = ir.fromCompact(vr);
        }
      else if (typeof vr == "object" && typeof vr.r == "bigint" && typeof vr.s == "bigint") {
        const { r: qr, s: Zi } = vr;
        Hr = new ir(qr, Zi);
      } else
        throw new Error("PARSE");
      si = L.fromHex(_r);
    } catch (qr) {
      if (qr.message === "PARSE")
        throw new Error("signature must be Signature instance, Uint8Array or hex string");
      return !1;
    }
    if (Te && Hr.hasHighS())
      return !1;
    Cr && (yr = c.hash(yr));
    const { r: ui, s: Li } = Hr, Qi = Ce(yr), wi = le(Li), Ji = F(Qi * wi), mn = F(ui * wi), pi = (Vr = L.BASE.multiplyAndAddUnsafe(si, Ji, mn)) == null ? void 0 : Vr.toAffine();
    return pi ? F(pi.x) === ui : !1;
  }
  return {
    CURVE: c,
    getPublicKey: lr,
    getSharedSecret: xr,
    sign: xe,
    verify: rr,
    ProjectivePoint: L,
    Signature: ir,
    utils: or
  };
}
function SWUFpSqrtRatio(n, c) {
  const u = n.ORDER;
  let p = _0n$5;
  for (let Ee = u - _1n$2; Ee % _2n$2 === _0n$5; Ee /= _2n$2)
    p += _1n$2;
  const a = p, A = (u - _1n$2) / _2n$2 ** a, b = (A - _1n$2) / _2n$2, F = _2n$2 ** a - _1n$2, le = _2n$2 ** (a - _1n$2), L = n.pow(c, A), pe = n.pow(c, (A + _1n$2) / _2n$2);
  let $ = (Ee, be) => {
    let He = L, Pe = n.pow(be, F), nr = n.sqr(Pe);
    nr = n.mul(nr, be);
    let ir = n.mul(Ee, nr);
    ir = n.pow(ir, b), ir = n.mul(ir, Pe), Pe = n.mul(ir, be), nr = n.mul(ir, Ee);
    let or = n.mul(nr, Pe);
    ir = n.pow(or, le);
    let lr = n.eql(ir, n.ONE);
    Pe = n.mul(nr, pe), ir = n.mul(or, He), nr = n.cmov(Pe, nr, lr), or = n.cmov(ir, or, lr);
    for (let Ir = a; Ir > 1; Ir--) {
      let xr = _2n$2 ** (Ir - _2n$2), kr = n.pow(or, xr);
      const Ce = n.eql(kr, n.ONE);
      Pe = n.mul(nr, He), He = n.mul(He, He), kr = n.mul(or, He), nr = n.cmov(Pe, nr, Ce), or = n.cmov(kr, or, Ce);
    }
    return { isValid: lr, value: nr };
  };
  if (n.ORDER % _4n$1 === _3n$1) {
    const Ee = (n.ORDER - _3n$1) / _4n$1, be = n.sqrt(n.neg(c));
    $ = (He, Pe) => {
      let nr = n.sqr(Pe);
      const ir = n.mul(He, Pe);
      nr = n.mul(nr, ir);
      let or = n.pow(nr, Ee);
      or = n.mul(or, ir);
      const lr = n.mul(or, be), Ir = n.mul(n.sqr(or), Pe), xr = n.eql(Ir, He);
      let kr = n.cmov(lr, or, xr);
      return { isValid: xr, value: kr };
    };
  }
  return $;
}
function mapToCurveSimpleSWU(n, c) {
  if (validateField(n), !n.isValid(c.A) || !n.isValid(c.B) || !n.isValid(c.Z))
    throw new Error("mapToCurveSimpleSWU: invalid opts");
  const u = SWUFpSqrtRatio(n, c.Z);
  if (!n.isOdd)
    throw new Error("Fp.isOdd is not implemented!");
  return (p) => {
    let a, A, b, F, le, L, pe, $;
    a = n.sqr(p), a = n.mul(a, c.Z), A = n.sqr(a), A = n.add(A, a), b = n.add(A, n.ONE), b = n.mul(b, c.B), F = n.cmov(c.Z, n.neg(A), !n.eql(A, n.ZERO)), F = n.mul(F, c.A), A = n.sqr(b), L = n.sqr(F), le = n.mul(L, c.A), A = n.add(A, le), A = n.mul(A, b), L = n.mul(L, F), le = n.mul(L, c.B), A = n.add(A, le), pe = n.mul(a, b);
    const { isValid: Ee, value: be } = u(A, L);
    $ = n.mul(a, p), $ = n.mul($, be), pe = n.cmov(pe, b, Ee), $ = n.cmov($, be, Ee);
    const He = n.isOdd(p) === n.isOdd($);
    return $ = n.cmov(n.neg($), $, He), pe = n.div(pe, F), { x: pe, y: $ };
  };
}
function validateDST(n) {
  if (n instanceof Uint8Array)
    return n;
  if (typeof n == "string")
    return utf8ToBytes$2(n);
  throw new Error("DST must be Uint8Array or string");
}
const os2ip = bytesToNumberBE;
function i2osp(n, c) {
  if (n < 0 || n >= 1 << 8 * c)
    throw new Error(`bad I2OSP call: value=${n} length=${c}`);
  const u = Array.from({ length: c }).fill(0);
  for (let p = c - 1; p >= 0; p--)
    u[p] = n & 255, n >>>= 8;
  return new Uint8Array(u);
}
function strxor(n, c) {
  const u = new Uint8Array(n.length);
  for (let p = 0; p < n.length; p++)
    u[p] = n[p] ^ c[p];
  return u;
}
function isBytes(n) {
  if (!(n instanceof Uint8Array))
    throw new Error("Uint8Array expected");
}
function isNum(n) {
  if (!Number.isSafeInteger(n))
    throw new Error("number expected");
}
function expand_message_xmd(n, c, u, p) {
  isBytes(n), isBytes(c), isNum(u), c.length > 255 && (c = p(concatBytes(utf8ToBytes$2("H2C-OVERSIZE-DST-"), c)));
  const { outputLen: a, blockLen: A } = p, b = Math.ceil(u / a);
  if (b > 255)
    throw new Error("Invalid xmd length");
  const F = concatBytes(c, i2osp(c.length, 1)), le = i2osp(0, A), L = i2osp(u, 2), pe = new Array(b), $ = p(concatBytes(le, n, L, i2osp(0, 1), F));
  pe[0] = p(concatBytes($, i2osp(1, 1), F));
  for (let be = 1; be <= b; be++) {
    const He = [strxor($, pe[be - 1]), i2osp(be + 1, 1), F];
    pe[be] = p(concatBytes(...He));
  }
  return concatBytes(...pe).slice(0, u);
}
function expand_message_xof(n, c, u, p, a) {
  if (isBytes(n), isBytes(c), isNum(u), c.length > 255) {
    const A = Math.ceil(2 * p / 8);
    c = a.create({ dkLen: A }).update(utf8ToBytes$2("H2C-OVERSIZE-DST-")).update(c).digest();
  }
  if (u > 65535 || c.length > 255)
    throw new Error("expand_message_xof: invalid lenInBytes");
  return a.create({ dkLen: u }).update(n).update(i2osp(u, 2)).update(c).update(i2osp(c.length, 1)).digest();
}
function hash_to_field(n, c, u) {
  validateObject(u, {
    DST: "string",
    p: "bigint",
    m: "isSafeInteger",
    k: "isSafeInteger",
    hash: "hash"
  });
  const { p, k: a, m: A, hash: b, expand: F, DST: le } = u;
  isBytes(n), isNum(c);
  const L = validateDST(le), pe = p.toString(2).length, $ = Math.ceil((pe + a) / 8), Ee = c * A * $;
  let be;
  if (F === "xmd")
    be = expand_message_xmd(n, L, Ee, b);
  else if (F === "xof")
    be = expand_message_xof(n, L, Ee, a, b);
  else if (F === void 0)
    be = n;
  else
    throw new Error('expand must be "xmd", "xof" or undefined');
  const He = new Array(c);
  for (let Pe = 0; Pe < c; Pe++) {
    const nr = new Array(A);
    for (let ir = 0; ir < A; ir++) {
      const or = $ * (ir + Pe * A), lr = be.subarray(or, or + $);
      nr[ir] = mod(os2ip(lr), p);
    }
    He[Pe] = nr;
  }
  return He;
}
function isogenyMap(n, c) {
  const u = c.map((p) => Array.from(p).reverse());
  return (p, a) => {
    const [A, b, F, le] = u.map((L) => L.reduce((pe, $) => n.add(n.mul(pe, p), $)));
    return p = n.div(A, b), a = n.mul(a, n.div(F, le)), { x: p, y: a };
  };
}
function createHasher(n, c, u) {
  if (typeof c != "function")
    throw new Error("mapToCurve() must be defined");
  return {
    // Encodes byte string to elliptic curve
    // https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-hash-to-curve-16#section-3
    hashToCurve(p, a) {
      const A = hash_to_field(p, 2, { ...u, DST: u.DST, ...a }), b = n.fromAffine(c(A[0])), F = n.fromAffine(c(A[1])), le = b.add(F).clearCofactor();
      return le.assertValidity(), le;
    },
    // https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-hash-to-curve-16#section-3
    encodeToCurve(p, a) {
      const A = hash_to_field(p, 1, { ...u, DST: u.encodeDST, ...a }), b = n.fromAffine(c(A[0])).clearCofactor();
      return b.assertValidity(), b;
    }
  };
}
let HMAC$1 = class extends Hash$2 {
  constructor(c, u) {
    super(), this.finished = !1, this.destroyed = !1, assert$4.hash(c);
    const p = toBytes$2(u);
    if (this.iHash = c.create(), typeof this.iHash.update != "function")
      throw new TypeError("Expected instance of class which extends utils.Hash");
    this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
    const a = this.blockLen, A = new Uint8Array(a);
    A.set(p.length > a ? c.create().update(p).digest() : p);
    for (let b = 0; b < A.length; b++)
      A[b] ^= 54;
    this.iHash.update(A), this.oHash = c.create();
    for (let b = 0; b < A.length; b++)
      A[b] ^= 106;
    this.oHash.update(A), A.fill(0);
  }
  update(c) {
    return assert$4.exists(this), this.iHash.update(c), this;
  }
  digestInto(c) {
    assert$4.exists(this), assert$4.bytes(c, this.outputLen), this.finished = !0, this.iHash.digestInto(c), this.oHash.update(c), this.oHash.digestInto(c), this.destroy();
  }
  digest() {
    const c = new Uint8Array(this.oHash.outputLen);
    return this.digestInto(c), c;
  }
  _cloneInto(c) {
    c || (c = Object.create(Object.getPrototypeOf(this), {}));
    const { oHash: u, iHash: p, finished: a, destroyed: A, blockLen: b, outputLen: F } = this;
    return c = c, c.finished = a, c.destroyed = A, c.blockLen = b, c.outputLen = F, c.oHash = u._cloneInto(c.oHash), c.iHash = p._cloneInto(c.iHash), c;
  }
  destroy() {
    this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
  }
};
const hmac$2 = (n, c, u) => new HMAC$1(n, c).update(u).digest();
hmac$2.create = (n, c) => new HMAC$1(n, c);
function getHash(n) {
  return {
    hash: n,
    hmac: (c, ...u) => hmac$2(n, c, concatBytes$1(...u)),
    randomBytes
  };
}
function createCurve(n, c) {
  const u = (p) => weierstrass({ ...n, ...getHash(p) });
  return Object.freeze({ ...u(c), create: u });
}
const secp256k1P = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"), secp256k1N = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), _1n$1 = BigInt(1), _2n$1 = BigInt(2), divNearest = (n, c) => (n + c / _2n$1) / c;
function sqrtMod(n) {
  const c = secp256k1P, u = BigInt(3), p = BigInt(6), a = BigInt(11), A = BigInt(22), b = BigInt(23), F = BigInt(44), le = BigInt(88), L = n * n * n % c, pe = L * L * n % c, $ = pow2(pe, u, c) * pe % c, Ee = pow2($, u, c) * pe % c, be = pow2(Ee, _2n$1, c) * L % c, He = pow2(be, a, c) * be % c, Pe = pow2(He, A, c) * He % c, nr = pow2(Pe, F, c) * Pe % c, ir = pow2(nr, le, c) * nr % c, or = pow2(ir, F, c) * Pe % c, lr = pow2(or, u, c) * pe % c, Ir = pow2(lr, b, c) * He % c, xr = pow2(Ir, p, c) * L % c, kr = pow2(xr, _2n$1, c);
  if (!Fp.eql(Fp.sqr(kr), n))
    throw new Error("Cannot find square root");
  return kr;
}
const Fp = Field$1(secp256k1P, void 0, void 0, { sqrt: sqrtMod }), secp256k1 = createCurve({
  a: BigInt(0),
  b: BigInt(7),
  Fp,
  n: secp256k1N,
  // Base point (x, y) aka generator point
  Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
  Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
  h: BigInt(1),
  lowS: !0,
  /**
   * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
   * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
   * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
   * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
   */
  endo: {
    beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
    splitScalar: (n) => {
      const c = secp256k1N, u = BigInt("0x3086d221a7d46bcde86c90e49284eb15"), p = -_1n$1 * BigInt("0xe4437ed6010e88286f547fa90abfe4c3"), a = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), A = u, b = BigInt("0x100000000000000000000000000000000"), F = divNearest(A * n, c), le = divNearest(-p * n, c);
      let L = mod(n - F * u - le * a, c), pe = mod(-F * p - le * A, c);
      const $ = L > b, Ee = pe > b;
      if ($ && (L = c - L), Ee && (pe = c - pe), L > b || pe > b)
        throw new Error("splitScalar: Endomorphism failed, k=" + n);
      return { k1neg: $, k1: L, k2neg: Ee, k2: pe };
    }
  }
}, sha256$3), _0n$4 = BigInt(0), fe = (n) => typeof n == "bigint" && _0n$4 < n && n < secp256k1P, ge = (n) => typeof n == "bigint" && _0n$4 < n && n < secp256k1N, TAGGED_HASH_PREFIXES = {};
function taggedHash$1(n, ...c) {
  let u = TAGGED_HASH_PREFIXES[n];
  if (u === void 0) {
    const p = sha256$3(Uint8Array.from(n, (a) => a.charCodeAt(0)));
    u = concatBytes(p, p), TAGGED_HASH_PREFIXES[n] = u;
  }
  return sha256$3(concatBytes(u, ...c));
}
const pointToBytes = (n) => n.toRawBytes(!0).slice(1), numTo32b = (n) => numberToBytesBE(n, 32), modP$1 = (n) => mod(n, secp256k1P), modN$1 = (n) => mod(n, secp256k1N), Point$2 = secp256k1.ProjectivePoint, GmulAdd = (n, c, u) => Point$2.BASE.multiplyAndAddUnsafe(n, c, u);
function schnorrGetExtPubKey(n) {
  let c = secp256k1.utils.normPrivateKeyToScalar(n), u = Point$2.fromPrivateKey(c);
  return { scalar: u.hasEvenY() ? c : modN$1(-c), bytes: pointToBytes(u) };
}
function lift_x(n) {
  if (!fe(n))
    throw new Error("bad x: need 0 < x < p");
  const c = modP$1(n * n), u = modP$1(c * n + BigInt(7));
  let p = sqrtMod(u);
  p % _2n$1 !== _0n$4 && (p = modP$1(-p));
  const a = new Point$2(n, p, _1n$1);
  return a.assertValidity(), a;
}
function challenge(...n) {
  return modN$1(bytesToNumberBE(taggedHash$1("BIP0340/challenge", ...n)));
}
function schnorrGetPublicKey(n) {
  return schnorrGetExtPubKey(n).bytes;
}
function schnorrSign(n, c, u = randomBytes(32)) {
  const p = ensureBytes("message", n), { bytes: a, scalar: A } = schnorrGetExtPubKey(c), b = ensureBytes("auxRand", u, 32), F = numTo32b(A ^ bytesToNumberBE(taggedHash$1("BIP0340/aux", b))), le = taggedHash$1("BIP0340/nonce", F, a, p), L = modN$1(bytesToNumberBE(le));
  if (L === _0n$4)
    throw new Error("sign failed: k is zero");
  const { bytes: pe, scalar: $ } = schnorrGetExtPubKey(L), Ee = challenge(pe, a, p), be = new Uint8Array(64);
  if (be.set(pe, 0), be.set(numTo32b(modN$1($ + Ee * A)), 32), !schnorrVerify(be, p, a))
    throw new Error("sign: Invalid signature produced");
  return be;
}
function schnorrVerify(n, c, u) {
  const p = ensureBytes("signature", n, 64), a = ensureBytes("message", c), A = ensureBytes("publicKey", u, 32);
  try {
    const b = lift_x(bytesToNumberBE(A)), F = bytesToNumberBE(p.subarray(0, 32));
    if (!fe(F))
      return !1;
    const le = bytesToNumberBE(p.subarray(32, 64));
    if (!ge(le))
      return !1;
    const L = challenge(numTo32b(F), pointToBytes(b), a), pe = GmulAdd(b, le, modN$1(-L));
    return !(!pe || !pe.hasEvenY() || pe.toAffine().x !== F);
  } catch {
    return !1;
  }
}
const schnorr = {
  getPublicKey: schnorrGetPublicKey,
  sign: schnorrSign,
  verify: schnorrVerify,
  utils: {
    randomPrivateKey: secp256k1.utils.randomPrivateKey,
    lift_x,
    pointToBytes,
    numberToBytesBE,
    bytesToNumberBE,
    taggedHash: taggedHash$1,
    mod
  }
}, isoMap = isogenyMap(Fp, [
  // xNum
  [
    "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
    "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
    "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
    "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
  ],
  // xDen
  [
    "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
    "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
    "0x0000000000000000000000000000000000000000000000000000000000000001"
    // LAST 1
  ],
  // yNum
  [
    "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
    "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
    "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
    "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
  ],
  // yDen
  [
    "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
    "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
    "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
    "0x0000000000000000000000000000000000000000000000000000000000000001"
    // LAST 1
  ]
].map((n) => n.map((c) => BigInt(c)))), mapSWU = mapToCurveSimpleSWU(Fp, {
  A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
  B: BigInt("1771"),
  Z: Fp.create(BigInt("-11"))
});
createHasher(secp256k1.ProjectivePoint, (n) => {
  const { x: c, y: u } = mapSWU(Fp.create(n[0]));
  return isoMap(c, u);
}, {
  DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
  encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
  p: Fp.ORDER,
  m: 1,
  k: 128,
  expand: "xmd",
  hash: sha256$3
});
function number$1(n) {
  if (!Number.isSafeInteger(n) || n < 0)
    throw new Error(`Wrong positive integer: ${n}`);
}
function bool$1(n) {
  if (typeof n != "boolean")
    throw new Error(`Expected boolean, not ${n}`);
}
function bytes$1(n, ...c) {
  if (!(n instanceof Uint8Array))
    throw new TypeError("Expected Uint8Array");
  if (c.length > 0 && !c.includes(n.length))
    throw new TypeError(`Expected Uint8Array of length ${c}, not of length=${n.length}`);
}
function hash$2(n) {
  if (typeof n != "function" || typeof n.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  number$1(n.outputLen), number$1(n.blockLen);
}
function exists$1(n, c = !0) {
  if (n.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (c && n.finished)
    throw new Error("Hash#digest() has already been called");
}
function output$1(n, c) {
  bytes$1(n);
  const u = c.outputLen;
  if (n.length < u)
    throw new Error(`digestInto() expects output buffer of length at least ${u}`);
}
const assert$1$1 = {
  number: number$1,
  bool: bool$1,
  bytes: bytes$1,
  hash: hash$2,
  exists: exists$1,
  output: output$1
};
var assert$2 = assert$1$1;
const createView$1 = (n) => new DataView(n.buffer, n.byteOffset, n.byteLength), rotr$1 = (n, c) => n << 32 - c | n >>> c, isLE$1 = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
if (!isLE$1)
  throw new Error("Non little-endian hardware is not supported");
Array.from({ length: 256 }, (n, c) => c.toString(16).padStart(2, "0"));
function utf8ToBytes$1(n) {
  if (typeof n != "string")
    throw new TypeError(`utf8ToBytes expected string, got ${typeof n}`);
  return new TextEncoder().encode(n);
}
function toBytes$1(n) {
  if (typeof n == "string" && (n = utf8ToBytes$1(n)), !(n instanceof Uint8Array))
    throw new TypeError(`Expected input type is Uint8Array (got ${typeof n})`);
  return n;
}
let Hash$1 = class {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
};
function wrapConstructor$1(n) {
  const c = (p) => n().update(toBytes$1(p)).digest(), u = n();
  return c.outputLen = u.outputLen, c.blockLen = u.blockLen, c.create = () => n(), c;
}
function setBigUint64$1(n, c, u, p) {
  if (typeof n.setBigUint64 == "function")
    return n.setBigUint64(c, u, p);
  const a = BigInt(32), A = BigInt(4294967295), b = Number(u >> a & A), F = Number(u & A), le = p ? 4 : 0, L = p ? 0 : 4;
  n.setUint32(c + le, b, p), n.setUint32(c + L, F, p);
}
let SHA2$1 = class extends Hash$1 {
  constructor(c, u, p, a) {
    super(), this.blockLen = c, this.outputLen = u, this.padOffset = p, this.isLE = a, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(c), this.view = createView$1(this.buffer);
  }
  update(c) {
    assert$2.exists(this);
    const { view: u, buffer: p, blockLen: a } = this;
    c = toBytes$1(c);
    const A = c.length;
    for (let b = 0; b < A; ) {
      const F = Math.min(a - this.pos, A - b);
      if (F === a) {
        const le = createView$1(c);
        for (; a <= A - b; b += a)
          this.process(le, b);
        continue;
      }
      p.set(c.subarray(b, b + F), this.pos), this.pos += F, b += F, this.pos === a && (this.process(u, 0), this.pos = 0);
    }
    return this.length += c.length, this.roundClean(), this;
  }
  digestInto(c) {
    assert$2.exists(this), assert$2.output(c, this), this.finished = !0;
    const { buffer: u, view: p, blockLen: a, isLE: A } = this;
    let { pos: b } = this;
    u[b++] = 128, this.buffer.subarray(b).fill(0), this.padOffset > a - b && (this.process(p, 0), b = 0);
    for (let $ = b; $ < a; $++)
      u[$] = 0;
    setBigUint64$1(p, a - 8, BigInt(this.length * 8), A), this.process(p, 0);
    const F = createView$1(c), le = this.outputLen;
    if (le % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const L = le / 4, pe = this.get();
    if (L > pe.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let $ = 0; $ < L; $++)
      F.setUint32(4 * $, pe[$], A);
  }
  digest() {
    const { buffer: c, outputLen: u } = this;
    this.digestInto(c);
    const p = c.slice(0, u);
    return this.destroy(), p;
  }
  _cloneInto(c) {
    c || (c = new this.constructor()), c.set(...this.get());
    const { blockLen: u, buffer: p, length: a, finished: A, destroyed: b, pos: F } = this;
    return c.length = a, c.pos = F, c.finished = A, c.destroyed = b, a % u && c.buffer.set(p), c;
  }
};
const Chi$1 = (n, c, u) => n & c ^ ~n & u, Maj$1 = (n, c, u) => n & c ^ n & u ^ c & u, SHA256_K$1 = new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), IV$1 = new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), SHA256_W$1 = new Uint32Array(64);
let SHA256$1 = class extends SHA2$1 {
  constructor() {
    super(64, 32, 8, !1), this.A = IV$1[0] | 0, this.B = IV$1[1] | 0, this.C = IV$1[2] | 0, this.D = IV$1[3] | 0, this.E = IV$1[4] | 0, this.F = IV$1[5] | 0, this.G = IV$1[6] | 0, this.H = IV$1[7] | 0;
  }
  get() {
    const { A: c, B: u, C: p, D: a, E: A, F: b, G: F, H: le } = this;
    return [c, u, p, a, A, b, F, le];
  }
  // prettier-ignore
  set(c, u, p, a, A, b, F, le) {
    this.A = c | 0, this.B = u | 0, this.C = p | 0, this.D = a | 0, this.E = A | 0, this.F = b | 0, this.G = F | 0, this.H = le | 0;
  }
  process(c, u) {
    for (let $ = 0; $ < 16; $++, u += 4)
      SHA256_W$1[$] = c.getUint32(u, !1);
    for (let $ = 16; $ < 64; $++) {
      const Ee = SHA256_W$1[$ - 15], be = SHA256_W$1[$ - 2], He = rotr$1(Ee, 7) ^ rotr$1(Ee, 18) ^ Ee >>> 3, Pe = rotr$1(be, 17) ^ rotr$1(be, 19) ^ be >>> 10;
      SHA256_W$1[$] = Pe + SHA256_W$1[$ - 7] + He + SHA256_W$1[$ - 16] | 0;
    }
    let { A: p, B: a, C: A, D: b, E: F, F: le, G: L, H: pe } = this;
    for (let $ = 0; $ < 64; $++) {
      const Ee = rotr$1(F, 6) ^ rotr$1(F, 11) ^ rotr$1(F, 25), be = pe + Ee + Chi$1(F, le, L) + SHA256_K$1[$] + SHA256_W$1[$] | 0, Pe = (rotr$1(p, 2) ^ rotr$1(p, 13) ^ rotr$1(p, 22)) + Maj$1(p, a, A) | 0;
      pe = L, L = le, le = F, F = b + be | 0, b = A, A = a, a = p, p = be + Pe | 0;
    }
    p = p + this.A | 0, a = a + this.B | 0, A = A + this.C | 0, b = b + this.D | 0, F = F + this.E | 0, le = le + this.F | 0, L = L + this.G | 0, pe = pe + this.H | 0, this.set(p, a, A, b, F, le, L, pe);
  }
  roundClean() {
    SHA256_W$1.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
}, SHA224$1 = class extends SHA256$1 {
  constructor() {
    super(), this.A = -1056596264, this.B = 914150663, this.C = 812702999, this.D = -150054599, this.E = -4191439, this.F = 1750603025, this.G = 1694076839, this.H = -1090891868, this.outputLen = 28;
  }
};
const sha256$2 = wrapConstructor$1(() => new SHA256$1());
wrapConstructor$1(() => new SHA224$1());
function within_size(n, c) {
  if (n.length > c)
    throw new TypeError(`Data is larger than array size: ${n.length} > ${c}`);
}
function is_hex(n) {
  if (n.match(/[^a-fA-f0-9]/) !== null)
    throw new TypeError("Invalid characters in hex string: " + n);
  if (n.length % 2 !== 0)
    throw new Error(`Length of hex string is invalid: ${n.length}`);
}
function is_safe_num(n) {
  if (n > Number.MAX_SAFE_INTEGER)
    throw new TypeError("Number exceeds safe bounds!");
}
const { getRandomValues } = crypto ?? globalThis.crypto ?? window.crypto;
function random$1(n = 32) {
  if (typeof getRandomValues == "function")
    return crypto.getRandomValues(new Uint8Array(n));
  throw new Error("Crypto module missing getRandomValues!");
}
function set_buffer(n, c, u = "be") {
  c === void 0 && (c = n.length), within_size(n, c);
  const p = new Uint8Array(c).fill(0), a = u === "be" ? 0 : c - n.length;
  return p.set(n, a), p;
}
function join_array(n) {
  let c, u = 0;
  const p = n.reduce((A, b) => A + b.length, 0), a = new Uint8Array(p);
  for (c = 0; c < n.length; c++) {
    const A = n[c];
    a.set(A, u), u += A.length;
  }
  return a;
}
const ec$2 = new TextEncoder(), ALPHABETS = [
  {
    name: "base58",
    charset: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
  }
];
function getAlphabet(n) {
  for (const c of ALPHABETS)
    if (c.name === n)
      return c.charset;
  throw TypeError("Charset does not exist: " + n);
}
function encode$1$1(n, c, u = !1) {
  typeof n == "string" && (n = ec$2.encode(n));
  const p = getAlphabet(c), a = p.length, A = [];
  let b = "", F, le = 0, L, pe;
  for (F = 0; F < n.length; F++)
    for (le = 0, L = n[F], b += L > 0 || (b.length ^ F) > 0 ? "" : "1"; le in A || L > 0; )
      pe = A[le], pe = pe > 0 ? pe * 256 + L : L, L = pe / a | 0, A[le] = pe % a, le++;
  for (; le-- > 0; )
    b += p[A[le]];
  return u && b.length % 4 > 0 ? b + "=".repeat(4 - b.length % 4) : b;
}
function decode$1$1(n, c) {
  const u = getAlphabet(c), p = u.length, a = [], A = [];
  n = n.replace("=", "");
  let b, F = 0, le, L;
  for (b = 0; b < n.length; b++) {
    if (F = 0, le = u.indexOf(n[b]), le < 0)
      throw new Error(`Character range out of bounds: ${le}`);
    for (le > 0 || (A.length ^ b) > 0 || A.push(0); F in a || le > 0; )
      L = a[F], L = L > 0 ? L * p + le : le, le = L >> 8, a[F] = L % 256, F++;
  }
  for (; F-- > 0; )
    A.push(a[F]);
  return new Uint8Array(A);
}
function hash256$1(n) {
  return sha256$2(sha256$2(n));
}
function addChecksum(n) {
  const c = hash256$1(n);
  return join_array([n, c.slice(0, 4)]);
}
function checkTheSum(n) {
  const c = n.slice(0, -4), u = n.slice(-4);
  if (hash256$1(c).slice(0, 4).toString() !== u.toString())
    throw new Error("Invalid checksum!");
  return c;
}
const BaseX = {
  encode: encode$1$1,
  decode: decode$1$1
}, Base58C = {
  encode: (n) => {
    const c = addChecksum(n);
    return BaseX.encode(c, "base58");
  },
  decode: (n) => {
    const c = BaseX.decode(n, "base58");
    return checkTheSum(c);
  }
}, CHARSET = "qpzry9x8gf2tvdw0s3jn54khce6mua7l", GENERATOR = [996825010, 642813549, 513874426, 1027748829, 705979059], ENCODINGS = [
  { version: 0, name: "bech32", const: 1 },
  { version: 1, name: "bech32m", const: 734539939 }
];
function polymod(n) {
  let c = 1;
  for (let u = 0; u < n.length; ++u) {
    const p = c >> 25;
    c = (c & 33554431) << 5 ^ n[u];
    for (let a = 0; a < 5; ++a)
      p >> a & 1 && (c ^= GENERATOR[a]);
  }
  return c;
}
function hrpExpand(n) {
  const c = [];
  let u;
  for (u = 0; u < n.length; ++u)
    c.push(n.charCodeAt(u) >> 5);
  for (c.push(0), u = 0; u < n.length; ++u)
    c.push(n.charCodeAt(u) & 31);
  return c;
}
function verifyChecksum(n, c, u) {
  const p = hrpExpand(n).concat(c);
  return polymod(p) === u.const;
}
function createChecksum(n, c, u) {
  const p = hrpExpand(n).concat(c).concat([0, 0, 0, 0, 0, 0]), a = polymod(p) ^ u.const, A = [];
  for (let b = 0; b < 6; ++b)
    A.push(a >> 5 * (5 - b) & 31);
  return A;
}
function convertBits(n, c, u, p = !0) {
  const a = [];
  let A = 0, b = 0;
  const F = (1 << u) - 1, le = (1 << c + u - 1) - 1;
  for (const L of n) {
    if (L < 0 || L >> c > 0)
      throw new Error("Failed to perform base conversion. Invalid value: " + String(L));
    for (A = (A << c | L) & le, b += c; b >= u; )
      b -= u, a.push(A >> b & F);
  }
  if (p)
    b > 0 && a.push(A << u - b & F);
  else if (b >= c || (A << u - b & F) > 0)
    throw new Error("Failed to perform base conversion. Invalid Size!");
  return a;
}
function encode$5(n, c, u) {
  const p = c.concat(createChecksum(n, c, u));
  let a = n + "1";
  for (let A = 0; A < p.length; ++A)
    a += CHARSET.charAt(p[A]);
  return a;
}
function decode$5(n) {
  if (!checkBounds(n))
    throw new Error("Encoded string goes out of bounds!");
  if (n = n.toLowerCase(), !checkSeparatorPos(n))
    throw new Error("Encoded string has invalid separator!");
  const c = [], u = n.lastIndexOf("1"), p = n.substring(0, u);
  for (let A = u + 1; A < n.length; ++A) {
    const b = CHARSET.indexOf(n.charAt(A));
    if (b === -1)
      throw new Error("Character idx out of bounds: " + String(A));
    c.push(b);
  }
  const a = ENCODINGS.find((A) => A.version === c[0]) ?? ENCODINGS[0];
  if (!verifyChecksum(p, c, a))
    throw new Error("Checksum verification failed!");
  return [p, c.slice(0, c.length - 6)];
}
function checkBounds(n) {
  let c, u, p = !1, a = !1;
  for (c = 0; c < n.length; ++c) {
    if (u = n.charCodeAt(c), u < 33 || u > 126)
      return !1;
    u >= 97 && u <= 122 && (p = !0), u >= 65 && u <= 90 && (a = !0);
  }
  return !(p && a);
}
function checkSeparatorPos(n) {
  const c = n.lastIndexOf("1");
  return !(c < 1 || c + 7 > n.length || n.length > 90);
}
function b32encode(n, c = "bc", u = 0) {
  const p = [u, ...convertBits([...n], 8, 5)], a = ENCODINGS.find((b) => b.version === u) ?? ENCODINGS[0], A = encode$5(c, p, a);
  return b32decode(A), A;
}
function b32decode(n) {
  n = n.toLowerCase();
  const c = n.split("1", 1)[0], [u, p] = decode$5(n), a = convertBits(p.slice(1), 5, 8, !1), A = a.length;
  switch (!0) {
    case c !== u:
      throw new Error("Returned hrp string is invalid.");
    case (a === null || A < 2 || A > 40):
      throw new Error("Decoded string is invalid or out of spec.");
    case p[0] > 16:
      throw new Error("Returned version bit is out of range.");
    default:
      return Uint8Array.from(a);
  }
}
function getVersion$1(n) {
  n = n.toLowerCase();
  const [c, u] = decode$5(n);
  return u[0];
}
const Bech32 = {
  encode: b32encode,
  decode: b32decode,
  version: getVersion$1
}, BASE64_MAP = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", B64URL_MAP = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_", ec$1 = new TextEncoder();
function b64encode(n, c = !1, u = !0) {
  typeof n == "string" && (n = ec$1.encode(n));
  const p = c ? B64URL_MAP : BASE64_MAP;
  let a = "", A = 0, b = 0;
  for (let F = 0; F < n.length; F++)
    for (b = b << 8 | n[F], A += 8; A >= 6; )
      A -= 6, a += p[b >> A & 63];
  if (A > 0)
    for (b <<= 6 - A, a += p[b & 63]; A < 6; )
      a += u ? "=" : "", A += 2;
  return a;
}
function b64decode(n, c = !1) {
  const u = c || n.includes("-") || n.includes("_") ? B64URL_MAP.split("") : BASE64_MAP.split("");
  n = n.replace(/=+$/, "");
  const p = n.split("");
  let a = 0, A = 0;
  const b = [];
  for (let F = 0; F < p.length; F++) {
    const le = p[F], L = u.indexOf(le);
    if (L === -1)
      throw new Error("Invalid character: " + le);
    a += 6, A <<= 6, A |= L, a >= 8 && (a -= 8, b.push(A >>> a & 255));
  }
  return new Uint8Array(b);
}
const Base64 = {
  encode: b64encode,
  decode: b64decode
}, B64URL = {
  encode: (n) => b64encode(n, !0, !1),
  decode: (n) => b64decode(n, !0)
}, _0n$3 = BigInt(0), _255n = BigInt(255), _256n = BigInt(256);
function big_size(n) {
  if (n <= 0xffn)
    return 1;
  if (n <= 0xffffn)
    return 2;
  if (n <= 0xffffffffn)
    return 4;
  if (n <= 0xffffffffffffffffn)
    return 8;
  if (n <= 0xffffffffffffffffffffffffffffffffn)
    return 16;
  if (n <= 0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffn)
    return 32;
  throw new TypeError("Must specify a fixed buffer size for bigints greater than 32 bytes.");
}
function bigToBytes(n, c, u = "be") {
  c === void 0 && (c = big_size(n));
  const p = u === "le", a = new ArrayBuffer(c), A = new DataView(a);
  let b = p ? 0 : c - 1;
  for (; n > _0n$3; ) {
    const F = n & _255n, le = Number(F);
    p ? A.setUint8(b++, le) : A.setUint8(b--, le), n = (n - F) / _256n;
  }
  return new Uint8Array(a);
}
function bytesToBig(n) {
  let c = BigInt(0);
  for (let u = n.length - 1; u >= 0; u--)
    c = c * _256n + BigInt(n[u]);
  return BigInt(c);
}
function binToBytes(n) {
  const c = n.split("").map(Number);
  if (c.length % 8 !== 0)
    throw new Error(`Binary array is invalid length: ${n.length}`);
  const u = new Uint8Array(c.length / 8);
  for (let p = 0, a = 0; p < c.length; p += 8, a++) {
    let A = 0;
    for (let b = 0; b < 8; b++)
      A |= c[p + b] << 7 - b;
    u[a] = A;
  }
  return u;
}
function bytesToBin(n) {
  const c = new Array(n.length * 8);
  let u = 0;
  for (const p of n) {
    if (p > 255)
      throw new Error(`Invalid byte value: ${p}. Byte values must be between 0 and 255.`);
    for (let a = 7; a >= 0; a--, u++)
      c[u] = p >> a & 1;
  }
  return c.join("");
}
function num_size(n) {
  if (n <= 255)
    return 1;
  if (n <= 65535)
    return 2;
  if (n <= 4294967295)
    return 4;
  throw new TypeError("Numbers larger than 4 bytes must specify a fixed size!");
}
function numToBytes(n, c, u = "be") {
  c === void 0 && (c = num_size(n));
  const p = u === "le", a = new ArrayBuffer(c), A = new DataView(a);
  let b = p ? 0 : c - 1;
  for (; n > 0; ) {
    const F = n & 255;
    p ? A.setUint8(b++, n) : A.setUint8(b--, n), n = (n - F) / 256;
  }
  return new Uint8Array(a);
}
function bytesToNum(n) {
  let c = 0;
  for (let u = n.length - 1; u >= 0; u--)
    c = c * 256 + n[u], is_safe_num(c);
  return c;
}
const ec = new TextEncoder(), dc = new TextDecoder();
function strToBytes(n) {
  return ec.encode(n);
}
function bytesToStr(n) {
  return dc.decode(n);
}
function hex_size(n, c) {
  is_hex(n);
  const u = n.length / 2;
  if (c === void 0 && (c = u), u > c)
    throw new TypeError(`Hex string is larger than array size: ${u} > ${c}`);
  return c;
}
function hexToBytes(n, c, u = "le") {
  c = hex_size(n, c);
  const p = u === "le", a = new ArrayBuffer(c), A = new DataView(a);
  let b = p ? 0 : c - 1;
  for (let F = 0; F < n.length; F += 2) {
    const le = n.substring(F, F + 2), L = parseInt(le, 16);
    p ? A.setUint8(b++, L) : A.setUint8(b--, L);
  }
  return new Uint8Array(a);
}
function bytesToHex(n) {
  let c = "";
  for (let u = 0; u < n.length; u++)
    c += n[u].toString(16).padStart(2, "0");
  return c;
}
function jsonToBytes(n) {
  const c = JSON.stringify(n, (u, p) => typeof p == "bigint" ? `${p}n` : p);
  return strToBytes(c);
}
function buffer(n, c, u) {
  if (n instanceof ArrayBuffer)
    return new Uint8Array(n);
  if (n instanceof Uint8Array)
    return set_buffer(n, c, u);
  if (typeof n == "string")
    return hexToBytes(n, c, u);
  if (typeof n == "bigint")
    return bigToBytes(n, c, u);
  if (typeof n == "number")
    return numToBytes(n, c, u);
  if (typeof n == "boolean")
    return Uint8Array.of(n ? 1 : 0);
  throw TypeError("Unsupported format:" + typeof n);
}
const Ya = class Ya extends Uint8Array {
  static random(c = 32) {
    const u = random$1(c);
    return new Ya(u, c);
  }
  constructor(c, u, p) {
    const a = buffer(c, u, p);
    super(a);
  }
  get arr() {
    return [...this];
  }
  get num() {
    return this.toNum();
  }
  get big() {
    return this.toBig();
  }
  get str() {
    return this.toStr();
  }
  get hex() {
    return this.toHex();
  }
  get raw() {
    return new Uint8Array(this);
  }
  get bin() {
    return this.toBin();
  }
  get b58chk() {
    return this.tob58chk();
  }
  get base64() {
    return this.toBase64();
  }
  get b64url() {
    return this.toB64url();
  }
  get digest() {
    return this.toHash();
  }
  get id() {
    return this.toHash().hex;
  }
  get stream() {
    return new Stream(this);
  }
  toNum(c = "be") {
    const u = c === "be" ? this.reverse() : this;
    return bytesToNum(u);
  }
  toBin() {
    return bytesToBin(this);
  }
  toBig(c = "be") {
    const u = c === "be" ? this.reverse() : this;
    return bytesToBig(u);
  }
  toHash() {
    const c = sha256$2(this);
    return new Ya(c);
  }
  toJson() {
    const c = bytesToStr(this);
    return JSON.parse(c);
  }
  toBech32(c, u = 0) {
    return Bech32.encode(this, c, u);
  }
  toStr() {
    return bytesToStr(this);
  }
  toHex() {
    return bytesToHex(this);
  }
  toBytes() {
    return new Uint8Array(this);
  }
  tob58chk() {
    return Base58C.encode(this);
  }
  toBase64() {
    return Base64.encode(this);
  }
  toB64url() {
    return B64URL.encode(this);
  }
  prepend(c) {
    return Ya.join([Ya.bytes(c), this]);
  }
  append(c) {
    return Ya.join([this, Ya.bytes(c)]);
  }
  slice(c, u) {
    const p = new Uint8Array(this).slice(c, u);
    return new Ya(p);
  }
  subarray(c, u) {
    const p = new Uint8Array(this).subarray(c, u);
    return new Ya(p);
  }
  reverse() {
    const c = new Uint8Array(this).reverse();
    return new Ya(c);
  }
  write(c, u) {
    const p = Ya.bytes(c);
    this.set(p, u);
  }
  prefixSize(c) {
    const u = Ya.varInt(this.length, c);
    return Ya.join([u, this]);
  }
  static from(c) {
    return new Ya(Uint8Array.from(c));
  }
  static of(...c) {
    return new Ya(Uint8Array.of(...c));
  }
  static join(c) {
    const u = c.map((a) => Ya.bytes(a)), p = join_array(u);
    return new Ya(p);
  }
  static varInt(c, u) {
    if (c < 253)
      return Ya.num(c, 1);
    if (c < 65536)
      return Ya.of(253, ...Ya.num(c, 2, u));
    if (c < 4294967296)
      return Ya.of(254, ...Ya.num(c, 4, u));
    if (BigInt(c) < 0x10000000000000000n)
      return Ya.of(255, ...Ya.num(c, 8, u));
    throw new Error(`Value is too large: ${c}`);
  }
};
Ya.num = numToBuff, Ya.big = bigToBuff, Ya.bin = binToBuff, Ya.raw = rawToBuff, Ya.str = strToBuff, Ya.hex = hexToBuff, Ya.bytes = bytesToBuff, Ya.json = jsonToBuff, Ya.base64 = base64ToBuff, Ya.b64url = b64urlToBuff, Ya.bech32 = bech32ToBuff, Ya.b58chk = b58chkToBuff, Ya.encode = strToBytes, Ya.decode = bytesToStr;
let Buff = Ya;
function numToBuff(n, c, u) {
  return new Buff(n, c, u);
}
function binToBuff(n, c, u) {
  return new Buff(binToBytes(n), c, u);
}
function bigToBuff(n, c, u) {
  return new Buff(n, c, u);
}
function rawToBuff(n, c, u) {
  return new Buff(n, c, u);
}
function strToBuff(n, c, u) {
  return new Buff(strToBytes(n), c, u);
}
function hexToBuff(n, c, u) {
  return new Buff(n, c, u);
}
function bytesToBuff(n, c, u) {
  return new Buff(n, c, u);
}
function jsonToBuff(n) {
  return new Buff(jsonToBytes(n));
}
function base64ToBuff(n) {
  return new Buff(Base64.decode(n));
}
function b64urlToBuff(n) {
  return new Buff(B64URL.decode(n));
}
function bech32ToBuff(n) {
  return new Buff(Bech32.decode(n));
}
function b58chkToBuff(n) {
  return new Buff(Base58C.decode(n));
}
class Stream {
  constructor(c) {
    this.data = Buff.bytes(c), this.size = this.data.length;
  }
  peek(c) {
    if (c > this.size)
      throw new Error(`Size greater than stream: ${c} > ${this.size}`);
    return new Buff(this.data.slice(0, c));
  }
  read(c) {
    c = c ?? this.readSize();
    const u = this.peek(c);
    return this.data = this.data.slice(c), this.size = this.data.length, u;
  }
  readSize(c) {
    const u = this.read(1).num;
    switch (!0) {
      case (u >= 0 && u < 253):
        return u;
      case u === 253:
        return this.read(2).toNum(c);
      case u === 254:
        return this.read(4).toNum(c);
      case u === 255:
        return this.read(8).toNum(c);
      default:
        throw new Error(`Varint is out of range: ${u}`);
    }
  }
}
const curve = secp256k1.CURVE, N$1 = curve.n, P$1 = curve.p, G = { x: curve.Gx, y: curve.Gy }, _0n$2 = BigInt(0), _1n = BigInt(1), _2n = BigInt(2), _3n = BigInt(3), _4n = BigInt(4), CONST = { N: N$1, P: P$1, G, _0n: _0n$2, _1n, _2n, _3n, _4n }, ecc = Field$1(N$1, 32, !0), modN = (n) => mod(n, N$1);
function fail(n, c = !1) {
  if (c)
    throw new Error(n);
  return !1;
}
function random(n) {
  return Buff.random(n);
}
function mod_bytes(n) {
  const c = Buff.bytes(n).big;
  return Buff.big(modN(c), 32);
}
var utl = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  fail,
  mod_bytes,
  random
});
const { N, P, _0n: _0n$1 } = CONST;
function size(n, c, u) {
  const p = Buff.bytes(n);
  return p.length !== c ? fail(`Invalid byte size: ${p.hex} !== ${c}`, u) : !0;
}
function in_field(n, c) {
  return typeof n == "bigint" && _0n$1 < n && n < N || fail("x value is not in the field!", c), !0;
}
const NoblePoint = secp256k1.ProjectivePoint, Tf = class Tf extends Uint8Array {
  static mod(c) {
    return new Tf(c);
  }
  static is_valid(c, u) {
    const p = Buff.bytes(c, 32).big;
    return in_field(p, u);
  }
  constructor(c) {
    let u = normalizeField(c);
    u = modN(u), Tf.is_valid(u, !0), super(Buff.big(u, 32), 32);
  }
  get buff() {
    return new Buff(this);
  }
  get raw() {
    return this.buff.raw;
  }
  get big() {
    return this.buff.big;
  }
  get hex() {
    return this.buff.hex;
  }
  get point() {
    return this.generate();
  }
  get hasOddY() {
    return this.point.hasOddY;
  }
  get negated() {
    return this.hasOddY ? this.negate() : this;
  }
  gt(c) {
    return new Tf(c).big > this.big;
  }
  lt(c) {
    return new Tf(c).big < this.big;
  }
  eq(c) {
    return new Tf(c).big === this.big;
  }
  ne(c) {
    return new Tf(c).big !== this.big;
  }
  add(c) {
    const u = Tf.mod(c), p = ecc.add(this.big, u.big);
    return new Tf(p);
  }
  sub(c) {
    const u = Tf.mod(c), p = ecc.sub(this.big, u.big);
    return new Tf(p);
  }
  mul(c) {
    const u = Tf.mod(c), p = ecc.mul(this.big, u.big);
    return new Tf(p);
  }
  pow(c) {
    const u = Tf.mod(c), p = ecc.pow(this.big, u.big);
    return new Tf(p);
  }
  div(c) {
    const u = Tf.mod(c), p = ecc.div(this.big, u.big);
    return new Tf(p);
  }
  negate() {
    return new Tf(Tf.N - this.big);
  }
  generate() {
    const u = secp256k1.ProjectivePoint.BASE.multiply(this.big);
    return Point.import(u);
  }
};
Tf.N = secp256k1.CURVE.n;
let Field = Tf;
const If = class If {
  static from_x(c) {
    let u = normalizePoint(c);
    u.length === 32 && (u = u.prepend(2)), size(u, 33);
    const p = NoblePoint.fromHex(u.hex);
    return p.assertValidity(), new If(p.x, p.y);
  }
  static generate(c) {
    const u = Field.mod(c), p = If.base.multiply(u.big);
    return If.import(p);
  }
  static import(c) {
    const u = c instanceof If ? { x: c.x.big, y: c.y.big } : { x: c.x, y: c.y };
    return new If(u.x, u.y);
  }
  constructor(c, u) {
    this._p = new NoblePoint(c, u, 1n), this.p.assertValidity();
  }
  get p() {
    return this._p;
  }
  get x() {
    return Buff.big(this.p.x, 32);
  }
  get y() {
    return Buff.big(this.p.y, 32);
  }
  get buff() {
    return Buff.raw(this.p.toRawBytes(!0));
  }
  get raw() {
    return this.buff.raw;
  }
  get hex() {
    return this.buff.hex;
  }
  get hasEvenY() {
    return this.p.hasEvenY();
  }
  get hasOddY() {
    return !this.p.hasEvenY();
  }
  eq(c) {
    const u = c instanceof If ? c : If.from_x(c);
    return this.x.big === u.x.big && this.y.big === u.y.big;
  }
  add(c) {
    return c instanceof If ? If.import(this.p.add(c.p)) : If.import(this.p.add(If.generate(c).p));
  }
  sub(c) {
    return c instanceof If ? If.import(this.p.subtract(c.p)) : If.import(this.p.subtract(If.generate(c).p));
  }
  mul(c) {
    return c instanceof If ? If.import(this.p.multiply(c.x.big)) : If.import(this.p.multiply(Field.mod(c).big));
  }
  negate() {
    return If.import(this.p.negate());
  }
};
If.P = CONST.P, If.G = CONST.G, If.base = secp256k1.ProjectivePoint.BASE;
let Point = If;
function normalizeField(n) {
  if (n instanceof Field)
    return n.big;
  if (n instanceof Point)
    return n.x.big;
  if (n instanceof Uint8Array)
    return Buff.raw(n).big;
  if (typeof n == "string")
    return Buff.hex(n).big;
  if (typeof n == "number")
    return Buff.num(n).big;
  if (typeof n == "bigint")
    return BigInt(n);
  throw TypeError("Invalid input type:" + typeof n);
}
function normalizePoint(n) {
  if (n instanceof Field)
    return n.point.buff;
  if (n instanceof Point)
    return n.buff;
  if (n instanceof Uint8Array || typeof n == "string")
    return Buff.bytes(n);
  if (typeof n == "number" || typeof n == "bigint")
    return Buff.bytes(n, 32);
  throw new TypeError(`Unknown type: ${typeof n}`);
}
function number(n) {
  if (!Number.isSafeInteger(n) || n < 0)
    throw new Error(`Wrong positive integer: ${n}`);
}
function bool(n) {
  if (typeof n != "boolean")
    throw new Error(`Expected boolean, not ${n}`);
}
function bytes(n, ...c) {
  if (!(n instanceof Uint8Array))
    throw new Error("Expected Uint8Array");
  if (c.length > 0 && !c.includes(n.length))
    throw new Error(`Expected Uint8Array of length ${c}, not of length=${n.length}`);
}
function hash$1(n) {
  if (typeof n != "function" || typeof n.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  number(n.outputLen), number(n.blockLen);
}
function exists(n, c = !0) {
  if (n.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (c && n.finished)
    throw new Error("Hash#digest() has already been called");
}
function output(n, c) {
  bytes(n);
  const u = c.outputLen;
  if (n.length < u)
    throw new Error(`digestInto() expects output buffer of length at least ${u}`);
}
const assert = {
  number,
  bool,
  bytes,
  hash: hash$1,
  exists,
  output
};
var assert$1 = assert;
const u8a = (n) => n instanceof Uint8Array, createView = (n) => new DataView(n.buffer, n.byteOffset, n.byteLength), rotr = (n, c) => n << 32 - c | n >>> c, isLE = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
if (!isLE)
  throw new Error("Non little-endian hardware is not supported");
Array.from({ length: 256 }, (n, c) => c.toString(16).padStart(2, "0"));
function utf8ToBytes(n) {
  if (typeof n != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof n}`);
  return new Uint8Array(new TextEncoder().encode(n));
}
function toBytes$3(n) {
  if (typeof n == "string" && (n = utf8ToBytes(n)), !u8a(n))
    throw new Error(`expected Uint8Array, got ${typeof n}`);
  return n;
}
class Hash {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
}
function wrapConstructor(n) {
  const c = (p) => n().update(toBytes$3(p)).digest(), u = n();
  return c.outputLen = u.outputLen, c.blockLen = u.blockLen, c.create = () => n(), c;
}
function setBigUint64(n, c, u, p) {
  if (typeof n.setBigUint64 == "function")
    return n.setBigUint64(c, u, p);
  const a = BigInt(32), A = BigInt(4294967295), b = Number(u >> a & A), F = Number(u & A), le = p ? 4 : 0, L = p ? 0 : 4;
  n.setUint32(c + le, b, p), n.setUint32(c + L, F, p);
}
class SHA2 extends Hash {
  constructor(c, u, p, a) {
    super(), this.blockLen = c, this.outputLen = u, this.padOffset = p, this.isLE = a, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(c), this.view = createView(this.buffer);
  }
  update(c) {
    assert$1.exists(this);
    const { view: u, buffer: p, blockLen: a } = this;
    c = toBytes$3(c);
    const A = c.length;
    for (let b = 0; b < A; ) {
      const F = Math.min(a - this.pos, A - b);
      if (F === a) {
        const le = createView(c);
        for (; a <= A - b; b += a)
          this.process(le, b);
        continue;
      }
      p.set(c.subarray(b, b + F), this.pos), this.pos += F, b += F, this.pos === a && (this.process(u, 0), this.pos = 0);
    }
    return this.length += c.length, this.roundClean(), this;
  }
  digestInto(c) {
    assert$1.exists(this), assert$1.output(c, this), this.finished = !0;
    const { buffer: u, view: p, blockLen: a, isLE: A } = this;
    let { pos: b } = this;
    u[b++] = 128, this.buffer.subarray(b).fill(0), this.padOffset > a - b && (this.process(p, 0), b = 0);
    for (let $ = b; $ < a; $++)
      u[$] = 0;
    setBigUint64(p, a - 8, BigInt(this.length * 8), A), this.process(p, 0);
    const F = createView(c), le = this.outputLen;
    if (le % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const L = le / 4, pe = this.get();
    if (L > pe.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let $ = 0; $ < L; $++)
      F.setUint32(4 * $, pe[$], A);
  }
  digest() {
    const { buffer: c, outputLen: u } = this;
    this.digestInto(c);
    const p = c.slice(0, u);
    return this.destroy(), p;
  }
  _cloneInto(c) {
    c || (c = new this.constructor()), c.set(...this.get());
    const { blockLen: u, buffer: p, length: a, finished: A, destroyed: b, pos: F } = this;
    return c.length = a, c.pos = F, c.finished = A, c.destroyed = b, a % u && c.buffer.set(p), c;
  }
}
const Chi = (n, c, u) => n & c ^ ~n & u, Maj = (n, c, u) => n & c ^ n & u ^ c & u, SHA256_K = new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), IV = new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), SHA256_W = new Uint32Array(64);
class SHA256 extends SHA2 {
  constructor() {
    super(64, 32, 8, !1), this.A = IV[0] | 0, this.B = IV[1] | 0, this.C = IV[2] | 0, this.D = IV[3] | 0, this.E = IV[4] | 0, this.F = IV[5] | 0, this.G = IV[6] | 0, this.H = IV[7] | 0;
  }
  get() {
    const { A: c, B: u, C: p, D: a, E: A, F: b, G: F, H: le } = this;
    return [c, u, p, a, A, b, F, le];
  }
  // prettier-ignore
  set(c, u, p, a, A, b, F, le) {
    this.A = c | 0, this.B = u | 0, this.C = p | 0, this.D = a | 0, this.E = A | 0, this.F = b | 0, this.G = F | 0, this.H = le | 0;
  }
  process(c, u) {
    for (let $ = 0; $ < 16; $++, u += 4)
      SHA256_W[$] = c.getUint32(u, !1);
    for (let $ = 16; $ < 64; $++) {
      const Ee = SHA256_W[$ - 15], be = SHA256_W[$ - 2], He = rotr(Ee, 7) ^ rotr(Ee, 18) ^ Ee >>> 3, Pe = rotr(be, 17) ^ rotr(be, 19) ^ be >>> 10;
      SHA256_W[$] = Pe + SHA256_W[$ - 7] + He + SHA256_W[$ - 16] | 0;
    }
    let { A: p, B: a, C: A, D: b, E: F, F: le, G: L, H: pe } = this;
    for (let $ = 0; $ < 64; $++) {
      const Ee = rotr(F, 6) ^ rotr(F, 11) ^ rotr(F, 25), be = pe + Ee + Chi(F, le, L) + SHA256_K[$] + SHA256_W[$] | 0, Pe = (rotr(p, 2) ^ rotr(p, 13) ^ rotr(p, 22)) + Maj(p, a, A) | 0;
      pe = L, L = le, le = F, F = b + be | 0, b = A, A = a, a = p, p = be + Pe | 0;
    }
    p = p + this.A | 0, a = a + this.B | 0, A = A + this.C | 0, b = b + this.D | 0, F = F + this.E | 0, le = le + this.F | 0, L = L + this.G | 0, pe = pe + this.H | 0, this.set(p, a, A, b, F, le, L, pe);
  }
  roundClean() {
    SHA256_W.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
}
class SHA224 extends SHA256 {
  constructor() {
    super(), this.A = -1056596264, this.B = 914150663, this.C = 812702999, this.D = -150054599, this.E = -4191439, this.F = 1750603025, this.G = 1694076839, this.H = -1090891868, this.outputLen = 28;
  }
}
const sha256$1 = wrapConstructor(() => new SHA256());
wrapConstructor(() => new SHA224());
const U32_MASK64 = BigInt(2 ** 32 - 1), _32n = BigInt(32);
function fromBig(n, c = !1) {
  return c ? { h: Number(n & U32_MASK64), l: Number(n >> _32n & U32_MASK64) } : { h: Number(n >> _32n & U32_MASK64) | 0, l: Number(n & U32_MASK64) | 0 };
}
function split(n, c = !1) {
  let u = new Uint32Array(n.length), p = new Uint32Array(n.length);
  for (let a = 0; a < n.length; a++) {
    const { h: A, l: b } = fromBig(n[a], c);
    [u[a], p[a]] = [A, b];
  }
  return [u, p];
}
const toBig = (n, c) => BigInt(n >>> 0) << _32n | BigInt(c >>> 0), shrSH = (n, c, u) => n >>> u, shrSL = (n, c, u) => n << 32 - u | c >>> u, rotrSH = (n, c, u) => n >>> u | c << 32 - u, rotrSL = (n, c, u) => n << 32 - u | c >>> u, rotrBH = (n, c, u) => n << 64 - u | c >>> u - 32, rotrBL = (n, c, u) => n >>> u - 32 | c << 64 - u, rotr32H = (n, c) => c, rotr32L = (n, c) => n, rotlSH = (n, c, u) => n << u | c >>> 32 - u, rotlSL = (n, c, u) => c << u | n >>> 32 - u, rotlBH = (n, c, u) => c << u - 32 | n >>> 64 - u, rotlBL = (n, c, u) => n << u - 32 | c >>> 64 - u;
function add(n, c, u, p) {
  const a = (c >>> 0) + (p >>> 0);
  return { h: n + u + (a / 2 ** 32 | 0) | 0, l: a | 0 };
}
const add3L = (n, c, u) => (n >>> 0) + (c >>> 0) + (u >>> 0), add3H = (n, c, u, p) => c + u + p + (n / 2 ** 32 | 0) | 0, add4L = (n, c, u, p) => (n >>> 0) + (c >>> 0) + (u >>> 0) + (p >>> 0), add4H = (n, c, u, p, a) => c + u + p + a + (n / 2 ** 32 | 0) | 0, add5L = (n, c, u, p, a) => (n >>> 0) + (c >>> 0) + (u >>> 0) + (p >>> 0) + (a >>> 0), add5H = (n, c, u, p, a, A) => c + u + p + a + A + (n / 2 ** 32 | 0) | 0, u64 = {
  fromBig,
  split,
  toBig,
  shrSH,
  shrSL,
  rotrSH,
  rotrSL,
  rotrBH,
  rotrBL,
  rotr32H,
  rotr32L,
  rotlSH,
  rotlSL,
  rotlBH,
  rotlBL,
  add,
  add3L,
  add3H,
  add4L,
  add4H,
  add5H,
  add5L
};
var u64$1 = u64;
const [SHA512_Kh, SHA512_Kl] = u64$1.split([
  "0x428a2f98d728ae22",
  "0x7137449123ef65cd",
  "0xb5c0fbcfec4d3b2f",
  "0xe9b5dba58189dbbc",
  "0x3956c25bf348b538",
  "0x59f111f1b605d019",
  "0x923f82a4af194f9b",
  "0xab1c5ed5da6d8118",
  "0xd807aa98a3030242",
  "0x12835b0145706fbe",
  "0x243185be4ee4b28c",
  "0x550c7dc3d5ffb4e2",
  "0x72be5d74f27b896f",
  "0x80deb1fe3b1696b1",
  "0x9bdc06a725c71235",
  "0xc19bf174cf692694",
  "0xe49b69c19ef14ad2",
  "0xefbe4786384f25e3",
  "0x0fc19dc68b8cd5b5",
  "0x240ca1cc77ac9c65",
  "0x2de92c6f592b0275",
  "0x4a7484aa6ea6e483",
  "0x5cb0a9dcbd41fbd4",
  "0x76f988da831153b5",
  "0x983e5152ee66dfab",
  "0xa831c66d2db43210",
  "0xb00327c898fb213f",
  "0xbf597fc7beef0ee4",
  "0xc6e00bf33da88fc2",
  "0xd5a79147930aa725",
  "0x06ca6351e003826f",
  "0x142929670a0e6e70",
  "0x27b70a8546d22ffc",
  "0x2e1b21385c26c926",
  "0x4d2c6dfc5ac42aed",
  "0x53380d139d95b3df",
  "0x650a73548baf63de",
  "0x766a0abb3c77b2a8",
  "0x81c2c92e47edaee6",
  "0x92722c851482353b",
  "0xa2bfe8a14cf10364",
  "0xa81a664bbc423001",
  "0xc24b8b70d0f89791",
  "0xc76c51a30654be30",
  "0xd192e819d6ef5218",
  "0xd69906245565a910",
  "0xf40e35855771202a",
  "0x106aa07032bbd1b8",
  "0x19a4c116b8d2d0c8",
  "0x1e376c085141ab53",
  "0x2748774cdf8eeb99",
  "0x34b0bcb5e19b48a8",
  "0x391c0cb3c5c95a63",
  "0x4ed8aa4ae3418acb",
  "0x5b9cca4f7763e373",
  "0x682e6ff3d6b2b8a3",
  "0x748f82ee5defb2fc",
  "0x78a5636f43172f60",
  "0x84c87814a1f0ab72",
  "0x8cc702081a6439ec",
  "0x90befffa23631e28",
  "0xa4506cebde82bde9",
  "0xbef9a3f7b2c67915",
  "0xc67178f2e372532b",
  "0xca273eceea26619c",
  "0xd186b8c721c0c207",
  "0xeada7dd6cde0eb1e",
  "0xf57d4f7fee6ed178",
  "0x06f067aa72176fba",
  "0x0a637dc5a2c898a6",
  "0x113f9804bef90dae",
  "0x1b710b35131c471b",
  "0x28db77f523047d84",
  "0x32caab7b40c72493",
  "0x3c9ebe0a15c9bebc",
  "0x431d67c49c100d4c",
  "0x4cc5d4becb3e42b6",
  "0x597f299cfc657e2a",
  "0x5fcb6fab3ad6faec",
  "0x6c44198c4a475817"
].map((n) => BigInt(n))), SHA512_W_H = new Uint32Array(80), SHA512_W_L = new Uint32Array(80);
class SHA512 extends SHA2 {
  constructor() {
    super(128, 64, 16, !1), this.Ah = 1779033703, this.Al = -205731576, this.Bh = -1150833019, this.Bl = -2067093701, this.Ch = 1013904242, this.Cl = -23791573, this.Dh = -1521486534, this.Dl = 1595750129, this.Eh = 1359893119, this.El = -1377402159, this.Fh = -1694144372, this.Fl = 725511199, this.Gh = 528734635, this.Gl = -79577749, this.Hh = 1541459225, this.Hl = 327033209;
  }
  // prettier-ignore
  get() {
    const { Ah: c, Al: u, Bh: p, Bl: a, Ch: A, Cl: b, Dh: F, Dl: le, Eh: L, El: pe, Fh: $, Fl: Ee, Gh: be, Gl: He, Hh: Pe, Hl: nr } = this;
    return [c, u, p, a, A, b, F, le, L, pe, $, Ee, be, He, Pe, nr];
  }
  // prettier-ignore
  set(c, u, p, a, A, b, F, le, L, pe, $, Ee, be, He, Pe, nr) {
    this.Ah = c | 0, this.Al = u | 0, this.Bh = p | 0, this.Bl = a | 0, this.Ch = A | 0, this.Cl = b | 0, this.Dh = F | 0, this.Dl = le | 0, this.Eh = L | 0, this.El = pe | 0, this.Fh = $ | 0, this.Fl = Ee | 0, this.Gh = be | 0, this.Gl = He | 0, this.Hh = Pe | 0, this.Hl = nr | 0;
  }
  process(c, u) {
    for (let lr = 0; lr < 16; lr++, u += 4)
      SHA512_W_H[lr] = c.getUint32(u), SHA512_W_L[lr] = c.getUint32(u += 4);
    for (let lr = 16; lr < 80; lr++) {
      const Ir = SHA512_W_H[lr - 15] | 0, xr = SHA512_W_L[lr - 15] | 0, kr = u64$1.rotrSH(Ir, xr, 1) ^ u64$1.rotrSH(Ir, xr, 8) ^ u64$1.shrSH(Ir, xr, 7), Ce = u64$1.rotrSL(Ir, xr, 1) ^ u64$1.rotrSL(Ir, xr, 8) ^ u64$1.shrSL(Ir, xr, 7), tr = SHA512_W_H[lr - 2] | 0, Fe = SHA512_W_L[lr - 2] | 0, Sr = u64$1.rotrSH(tr, Fe, 19) ^ u64$1.rotrBH(tr, Fe, 61) ^ u64$1.shrSH(tr, Fe, 6), er = u64$1.rotrSL(tr, Fe, 19) ^ u64$1.rotrBL(tr, Fe, 61) ^ u64$1.shrSL(tr, Fe, 6), Ie = u64$1.add4L(Ce, er, SHA512_W_L[lr - 7], SHA512_W_L[lr - 16]), xe = u64$1.add4H(Ie, kr, Sr, SHA512_W_H[lr - 7], SHA512_W_H[lr - 16]);
      SHA512_W_H[lr] = xe | 0, SHA512_W_L[lr] = Ie | 0;
    }
    let { Ah: p, Al: a, Bh: A, Bl: b, Ch: F, Cl: le, Dh: L, Dl: pe, Eh: $, El: Ee, Fh: be, Fl: He, Gh: Pe, Gl: nr, Hh: ir, Hl: or } = this;
    for (let lr = 0; lr < 80; lr++) {
      const Ir = u64$1.rotrSH($, Ee, 14) ^ u64$1.rotrSH($, Ee, 18) ^ u64$1.rotrBH($, Ee, 41), xr = u64$1.rotrSL($, Ee, 14) ^ u64$1.rotrSL($, Ee, 18) ^ u64$1.rotrBL($, Ee, 41), kr = $ & be ^ ~$ & Pe, Ce = Ee & He ^ ~Ee & nr, tr = u64$1.add5L(or, xr, Ce, SHA512_Kl[lr], SHA512_W_L[lr]), Fe = u64$1.add5H(tr, ir, Ir, kr, SHA512_Kh[lr], SHA512_W_H[lr]), Sr = tr | 0, er = u64$1.rotrSH(p, a, 28) ^ u64$1.rotrBH(p, a, 34) ^ u64$1.rotrBH(p, a, 39), Ie = u64$1.rotrSL(p, a, 28) ^ u64$1.rotrBL(p, a, 34) ^ u64$1.rotrBL(p, a, 39), xe = p & A ^ p & F ^ A & F, rr = a & b ^ a & le ^ b & le;
      ir = Pe | 0, or = nr | 0, Pe = be | 0, nr = He | 0, be = $ | 0, He = Ee | 0, { h: $, l: Ee } = u64$1.add(L | 0, pe | 0, Fe | 0, Sr | 0), L = F | 0, pe = le | 0, F = A | 0, le = b | 0, A = p | 0, b = a | 0;
      const ar = u64$1.add3L(Sr, Ie, rr);
      p = u64$1.add3H(ar, Fe, er, xe), a = ar | 0;
    }
    ({ h: p, l: a } = u64$1.add(this.Ah | 0, this.Al | 0, p | 0, a | 0)), { h: A, l: b } = u64$1.add(this.Bh | 0, this.Bl | 0, A | 0, b | 0), { h: F, l: le } = u64$1.add(this.Ch | 0, this.Cl | 0, F | 0, le | 0), { h: L, l: pe } = u64$1.add(this.Dh | 0, this.Dl | 0, L | 0, pe | 0), { h: $, l: Ee } = u64$1.add(this.Eh | 0, this.El | 0, $ | 0, Ee | 0), { h: be, l: He } = u64$1.add(this.Fh | 0, this.Fl | 0, be | 0, He | 0), { h: Pe, l: nr } = u64$1.add(this.Gh | 0, this.Gl | 0, Pe | 0, nr | 0), { h: ir, l: or } = u64$1.add(this.Hh | 0, this.Hl | 0, ir | 0, or | 0), this.set(p, a, A, b, F, le, L, pe, $, Ee, be, He, Pe, nr, ir, or);
  }
  roundClean() {
    SHA512_W_H.fill(0), SHA512_W_L.fill(0);
  }
  destroy() {
    this.buffer.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
  }
}
class SHA512_224 extends SHA512 {
  constructor() {
    super(), this.Ah = -1942145080, this.Al = 424955298, this.Bh = 1944164710, this.Bl = -1982016298, this.Ch = 502970286, this.Cl = 855612546, this.Dh = 1738396948, this.Dl = 1479516111, this.Eh = 258812777, this.El = 2077511080, this.Fh = 2011393907, this.Fl = 79989058, this.Gh = 1067287976, this.Gl = 1780299464, this.Hh = 286451373, this.Hl = -1848208735, this.outputLen = 28;
  }
}
class SHA512_256 extends SHA512 {
  constructor() {
    super(), this.Ah = 573645204, this.Al = -64227540, this.Bh = -1621794909, this.Bl = -934517566, this.Ch = 596883563, this.Cl = 1867755857, this.Dh = -1774684391, this.Dl = 1497426621, this.Eh = -1775747358, this.El = -1467023389, this.Fh = -1101128155, this.Fl = 1401305490, this.Gh = 721525244, this.Gl = 746961066, this.Hh = 246885852, this.Hl = -2117784414, this.outputLen = 32;
  }
}
class SHA384 extends SHA512 {
  constructor() {
    super(), this.Ah = -876896931, this.Al = -1056596264, this.Bh = 1654270250, this.Bl = 914150663, this.Ch = -1856437926, this.Cl = 812702999, this.Dh = 355462360, this.Dl = -150054599, this.Eh = 1731405415, this.El = -4191439, this.Fh = -1900787065, this.Fl = 1750603025, this.Gh = -619958771, this.Gl = 1694076839, this.Hh = 1203062813, this.Hl = -1090891868, this.outputLen = 48;
  }
}
const sha512$1 = wrapConstructor(() => new SHA512());
wrapConstructor(() => new SHA512_224());
wrapConstructor(() => new SHA512_256());
wrapConstructor(() => new SHA384());
const Rho = new Uint8Array([7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8]), Id = Uint8Array.from({ length: 16 }, (n, c) => c), Pi = Id.map((n) => (9 * n + 5) % 16);
let idxL = [Id], idxR = [Pi];
for (let n = 0; n < 4; n++)
  for (let c of [idxL, idxR])
    c.push(c[n].map((u) => Rho[u]));
const shifts = [
  [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8],
  [12, 13, 11, 15, 6, 9, 9, 7, 12, 15, 11, 13, 7, 8, 7, 7],
  [13, 15, 14, 11, 7, 7, 6, 8, 13, 14, 13, 12, 5, 5, 6, 9],
  [14, 11, 12, 14, 8, 6, 5, 5, 15, 12, 15, 14, 9, 9, 8, 6],
  [15, 12, 13, 13, 9, 5, 8, 6, 14, 11, 12, 11, 8, 6, 5, 5]
].map((n) => new Uint8Array(n)), shiftsL = idxL.map((n, c) => n.map((u) => shifts[c][u])), shiftsR = idxR.map((n, c) => n.map((u) => shifts[c][u])), Kl = new Uint32Array([0, 1518500249, 1859775393, 2400959708, 2840853838]), Kr = new Uint32Array([1352829926, 1548603684, 1836072691, 2053994217, 0]), rotl = (n, c) => n << c | n >>> 32 - c;
function f(n, c, u, p) {
  return n === 0 ? c ^ u ^ p : n === 1 ? c & u | ~c & p : n === 2 ? (c | ~u) ^ p : n === 3 ? c & p | u & ~p : c ^ (u | ~p);
}
const BUF = new Uint32Array(16);
class RIPEMD160 extends SHA2 {
  constructor() {
    super(64, 20, 8, !0), this.h0 = 1732584193, this.h1 = -271733879, this.h2 = -1732584194, this.h3 = 271733878, this.h4 = -1009589776;
  }
  get() {
    const { h0: c, h1: u, h2: p, h3: a, h4: A } = this;
    return [c, u, p, a, A];
  }
  set(c, u, p, a, A) {
    this.h0 = c | 0, this.h1 = u | 0, this.h2 = p | 0, this.h3 = a | 0, this.h4 = A | 0;
  }
  process(c, u) {
    for (let be = 0; be < 16; be++, u += 4)
      BUF[be] = c.getUint32(u, !0);
    let p = this.h0 | 0, a = p, A = this.h1 | 0, b = A, F = this.h2 | 0, le = F, L = this.h3 | 0, pe = L, $ = this.h4 | 0, Ee = $;
    for (let be = 0; be < 5; be++) {
      const He = 4 - be, Pe = Kl[be], nr = Kr[be], ir = idxL[be], or = idxR[be], lr = shiftsL[be], Ir = shiftsR[be];
      for (let xr = 0; xr < 16; xr++) {
        const kr = rotl(p + f(be, A, F, L) + BUF[ir[xr]] + Pe, lr[xr]) + $ | 0;
        p = $, $ = L, L = rotl(F, 10) | 0, F = A, A = kr;
      }
      for (let xr = 0; xr < 16; xr++) {
        const kr = rotl(a + f(He, b, le, pe) + BUF[or[xr]] + nr, Ir[xr]) + Ee | 0;
        a = Ee, Ee = pe, pe = rotl(le, 10) | 0, le = b, b = kr;
      }
    }
    this.set(this.h1 + F + pe | 0, this.h2 + L + Ee | 0, this.h3 + $ + a | 0, this.h4 + p + b | 0, this.h0 + A + le | 0);
  }
  roundClean() {
    BUF.fill(0);
  }
  destroy() {
    this.destroyed = !0, this.buffer.fill(0), this.set(0, 0, 0, 0, 0);
  }
}
const ripemd160 = wrapConstructor(() => new RIPEMD160());
class HMAC extends Hash {
  constructor(c, u) {
    super(), this.finished = !1, this.destroyed = !1, assert$1.hash(c);
    const p = toBytes$3(u);
    if (this.iHash = c.create(), typeof this.iHash.update != "function")
      throw new Error("Expected instance of class which extends utils.Hash");
    this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
    const a = this.blockLen, A = new Uint8Array(a);
    A.set(p.length > a ? c.create().update(p).digest() : p);
    for (let b = 0; b < A.length; b++)
      A[b] ^= 54;
    this.iHash.update(A), this.oHash = c.create();
    for (let b = 0; b < A.length; b++)
      A[b] ^= 106;
    this.oHash.update(A), A.fill(0);
  }
  update(c) {
    return assert$1.exists(this), this.iHash.update(c), this;
  }
  digestInto(c) {
    assert$1.exists(this), assert$1.bytes(c, this.outputLen), this.finished = !0, this.iHash.digestInto(c), this.oHash.update(c), this.oHash.digestInto(c), this.destroy();
  }
  digest() {
    const c = new Uint8Array(this.oHash.outputLen);
    return this.digestInto(c), c;
  }
  _cloneInto(c) {
    c || (c = Object.create(Object.getPrototypeOf(this), {}));
    const { oHash: u, iHash: p, finished: a, destroyed: A, blockLen: b, outputLen: F } = this;
    return c = c, c.finished = a, c.destroyed = A, c.blockLen = b, c.outputLen = F, c.oHash = u._cloneInto(c.oHash), c.iHash = p._cloneInto(c.iHash), c;
  }
  destroy() {
    this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
  }
}
const hmac$1 = (n, c, u) => new HMAC(n, c).update(u).digest();
hmac$1.create = (n, c) => new HMAC(n, c);
function sha256(n) {
  const c = Buff.bytes(n);
  return Buff.raw(sha256$1(c));
}
function hash256$3(n) {
  const c = Buff.bytes(n);
  return Buff.raw(sha256$1(sha256$1(c)));
}
function hash160(n) {
  const c = Buff.bytes(n);
  return Buff.raw(ripemd160(sha256$1(c)));
}
function hmac512(n, c) {
  const u = Buff.bytes(n), p = Buff.bytes(c);
  return Buff.raw(hmac$1(sha512$1, u, p));
}
function hashtag(n) {
  const c = Buff.str(n).digest;
  return Buff.join([c, c]);
}
function genSecretKey(n = 32) {
  return getSecretKey(random(n));
}
function getSecretKey(n) {
  return Field.mod(n).buff;
}
function getPublicKey(n, c = !1) {
  const u = Field.mod(n).point;
  return c ? u.x : u.buff;
}
function getSharedKey(n, c) {
  const u = Point.from_x(c), p = Field.mod(n);
  return u.mul(p).buff;
}
function getSharedCode(n, c, u = "ecdh/code") {
  const p = hashtag(u), a = getSecretKey(n), A = getPublicKey(a), b = Buff.bytes(c), F = getSharedKey(a, b), le = [A.hex, b.hex];
  return le.sort(), hmac512(F, Buff.join([p, ...le]));
}
function is_even_pub(n) {
  const c = Buff.bytes(n);
  switch (!0) {
    case c.length === 32:
      return !0;
    case (c.length === 33 && c[0] === 2):
      return !0;
    case (c.length === 33 && c[0] === 3):
      return !1;
    default:
      throw new TypeError(`Invalid public key: ${c.hex}`);
  }
}
function xonly_pub(n) {
  const c = Buff.bytes(n);
  switch (c.length) {
    case 32:
      return c;
    case 33:
      return c.slice(1, 33);
    default:
      throw new Error(`Invalid key length: ${c.length}`);
  }
}
var key = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  genSecretKey,
  getPublicKey,
  getSecretKey,
  getSharedCode,
  getSharedKey,
  is_even_pub,
  xonly_pub
});
Buff.random(32);
const noble = { secp: secp256k1, schnorr }, util$1 = { ...key, ...utl };
function hash160pkh(n) {
  const c = Buff$1.bytes(n);
  return checkSize(c, 33), hash160(c);
}
function hash160sh(n) {
  const c = Script.fmt.toBytes(n, !1);
  return hash160(c);
}
function sha256sh(n) {
  const c = Script.fmt.toBytes(n, !1);
  return sha256(c);
}
function check$4(n, c = "main") {
  const u = c === "main" ? ["1"] : ["m", "n"];
  for (const p of u)
    if (n.startsWith(p))
      return !0;
  return !1;
}
function encode$4(n, c = "main") {
  const u = Buff$1.bytes(n), p = c === "main" ? Buff$1.num(0) : Buff$1.num(111);
  return checkSize(n, 20), u.prepend(p).tob58chk();
}
function decode$4(n, c = "main") {
  if (!check$4(n, c))
    throw new TypeError("Invalid p2pkh address!");
  return Buff$1.b58chk(n).slice(1);
}
function scriptPubKey$4(n) {
  const c = Buff$1.bytes(n);
  return checkSize(c, 20), ["OP_DUP", "OP_HASH160", c.hex, "OP_EQUALVERIFY", "OP_CHECKSIG"];
}
function fromPubKey$2(n, c) {
  const u = hash160pkh(n);
  return encode$4(u, c);
}
const P2PKH = { check: check$4, encode: encode$4, decode: decode$4, hash: hash160pkh, scriptPubKey: scriptPubKey$4, fromPubKey: fromPubKey$2 };
function check$3(n, c = "main") {
  const u = c === "main" ? ["3"] : ["2"];
  for (const p of u)
    if (n.startsWith(p))
      return !0;
  return !1;
}
function encode$3(n, c = "main") {
  const u = c === "main" ? Buff$1.num(5) : Buff$1.num(196), p = Buff$1.bytes(n);
  return checkSize(p, 20), p.prepend(u).tob58chk();
}
function decode$3(n, c = "main") {
  if (!check$3(n, c))
    throw new TypeError(`Invalid p2sh address for network ${c}:` + n);
  return Buff$1.b58chk(n).slice(1);
}
function scriptPubKey$3(n) {
  return ["OP_HASH160", Buff$1.bytes(n).hex, "OP_EQUAL"];
}
function fromScript$1(n, c) {
  const u = hash160sh(n);
  return encode$3(u, c);
}
const P2SH = { check: check$3, encode: encode$3, decode: decode$3, hash: hash160sh, scriptPubKey: scriptPubKey$3, fromScript: fromScript$1 }, BECH32_PREFIXES = {
  main: "bc",
  testnet: "tb",
  signet: "tb",
  regtest: "bcrt"
}, VALID_PREFIXES$2 = ["bc1q", "tb1q", "bcrt1q"];
function check$2(n) {
  for (const c of VALID_PREFIXES$2)
    if (n.startsWith(c))
      return !0;
  return !1;
}
function encode$2(n, c = "main") {
  const u = BECH32_PREFIXES[c], p = Buff$1.bytes(n);
  return checkSize(p, 20), p.toBech32(u, 0);
}
function decode$2(n) {
  if (!check$2(n))
    throw new TypeError("Invalid segwit address!");
  return Buff$1.bech32(n);
}
function scriptPubKey$2(n) {
  const c = Buff$1.bytes(n);
  return checkSize(c, 20), ["OP_0", c.hex];
}
function fromPubKey$1(n, c) {
  const u = hash160pkh(n);
  return encode$2(u, c);
}
const P2WPKH = { check: check$2, encode: encode$2, decode: decode$2, hash: hash160pkh, scriptPubKey: scriptPubKey$2, fromPubKey: fromPubKey$1 }, VALID_PREFIXES$1 = ["bc1q", "tb1q", "bcrt1q"];
function check$1(n) {
  for (const c of VALID_PREFIXES$1)
    if (n.startsWith(c))
      return !0;
  return !1;
}
function encode$1(n, c = "main") {
  const u = BECH32_PREFIXES[c], p = Buff$1.bytes(n);
  return checkSize(p, 32), p.toBech32(u, 0);
}
function decode$1(n) {
  if (!check$1(n))
    throw new TypeError("Invalid segwit address!");
  return Buff$1.bech32(n);
}
function scriptPubKey$1(n) {
  const c = Buff$1.bytes(n);
  return checkSize(c, 32), ["OP_0", c.hex];
}
function fromScript(n, c) {
  const u = sha256sh(n);
  return encode$1(u, c);
}
const P2WSH = { check: check$1, encode: encode$1, decode: decode$1, hash: sha256sh, scriptPubKey: scriptPubKey$1, fromScript };
function xOnlyPub(n) {
  const c = Buff$1.bytes(n);
  return c.length > 32 ? c.slice(1, 33) : c;
}
const VALID_PREFIXES = ["bc1p", "tb1p", "bcrt1p"];
function check(n) {
  for (const c of VALID_PREFIXES)
    if (n.startsWith(c))
      return !0;
  return !1;
}
function encode(n, c = "main") {
  const u = BECH32_PREFIXES[c], p = Buff$1.bytes(n);
  return checkSize(p, 32), p.toBech32(u, 1);
}
function decode(n) {
  if (!check(n))
    throw new TypeError("Invalid taproot address!");
  return Buff$1.bech32(n);
}
function scriptPubKey(n) {
  const c = Buff$1.bytes(n);
  return checkSize(c, 32), ["OP_1", c.hex];
}
function fromPubKey(n, c) {
  const u = xOnlyPub(n);
  return encode(u, c);
}
const P2TR = { check, encode, decode, scriptPubKey, fromPubKey }, DEFAULT_TX = {
  version: 2,
  vin: [],
  vout: [],
  locktime: 0
}, DEFAULT_VIN = {
  scriptSig: [],
  sequence: 4294967293,
  witness: []
}, DEFAULT_VOUT = {
  value: 0n,
  scriptPubKey: []
};
function createTx(n) {
  const c = { ...DEFAULT_TX, ...n };
  return c.vin = c.vin.map((u) => ({ ...DEFAULT_VIN, ...u })), c.vout = c.vout.map((u) => ({ ...DEFAULT_VOUT, ...u })), c;
}
function encodeTx(n, c) {
  const { version: u, vin: p, vout: a, locktime: A } = createTx(n), b = c !== !0 && checkForWitness(p), F = [encodeVersion(u)];
  b && F.push(Buff$1.hex("0001")), F.push(encodeInputs(p)), F.push(encodeOutputs(a));
  for (const le of p)
    b && F.push(encodeWitness(le.witness));
  return F.push(encodeLocktime(A)), Buff$1.join(F);
}
function checkForWitness(n) {
  for (const c of n) {
    const { witness: u } = c;
    if (typeof u == "string" || u instanceof Uint8Array || Array.isArray(u) && u.length > 0)
      return !0;
  }
  return !1;
}
function encodeVersion(n) {
  return Buff$1.num(n, 4).reverse();
}
function encodeTxid(n) {
  return Buff$1.hex(n, 32).reverse();
}
function encodePrevOut(n) {
  return Buff$1.num(n, 4).reverse();
}
function encodeSequence(n) {
  if (typeof n == "string")
    return Buff$1.hex(n, 4).reverse();
  if (typeof n == "number")
    return Buff$1.num(n, 4).reverse();
  throw new Error("Unrecognized format: " + String(n));
}
function encodeInputs(n) {
  const c = [Buff$1.varInt(n.length, "le")];
  for (const u of n) {
    const { txid: p, vout: a, scriptSig: A, sequence: b } = u;
    c.push(encodeTxid(p)), c.push(encodePrevOut(a)), c.push(encodeScript(A, !0)), c.push(encodeSequence(b));
  }
  return Buff$1.join(c);
}
function encodeValue(n) {
  if (typeof n == "number") {
    if (n % 1 !== 0)
      throw new Error("Value must be an integer:" + String(n));
    return Buff$1.num(n, 8).reverse();
  }
  return Buff$1.big(n, 8).reverse();
}
function encodeOutputs(n) {
  const c = [Buff$1.varInt(n.length, "le")];
  for (const u of n)
    c.push(encodeOutput(u));
  return Buff$1.join(c);
}
function encodeOutput(n) {
  const { value: c, scriptPubKey: u } = n, p = [];
  return p.push(encodeValue(c)), p.push(encodeScript(u, !0)), Buff$1.join(p);
}
function encodeWitness(n = []) {
  const c = [];
  if (Array.isArray(n)) {
    const u = Buff$1.varInt(n.length);
    c.push(u);
    for (const p of n)
      c.push(encodeData(p));
    return Buff$1.join(c);
  } else
    return Buff$1.bytes(n);
}
function encodeData(n) {
  return isEmpty(n) ? new Buff$1(0) : encodeScript(n, !0);
}
function isEmpty(n) {
  if (Array.isArray(n))
    return n.length === 0;
  if (typeof n == "string" && n === "")
    return !0;
  const c = Buff$1.bytes(n);
  return c.length === 1 && c[0] === 0;
}
function encodeLocktime(n) {
  if (typeof n == "string")
    return Buff$1.hex(n, 4);
  if (typeof n == "number")
    return Buff$1.num(n, 4).reverse();
  throw new Error("Unrecognized format: " + String(n));
}
function decodeTx(n) {
  typeof n == "string" && (n = Buff$1.hex(n).raw);
  const c = new Stream$1(n), u = readVersion(c), p = checkWitnessFlag(c), a = readInputs(c), A = readOutputs(c);
  if (p)
    for (const F of a)
      F.witness = readWitness$1(c);
  const b = readLocktime(c);
  return { version: u, vin: a, vout: A, locktime: b };
}
function readVersion(n) {
  return n.read(4).reverse().toNum();
}
function checkWitnessFlag(n) {
  const [c, u] = [...n.peek(2)];
  if (c === 0) {
    if (n.read(2), u === 1)
      return !0;
    throw new Error(`Invalid witness flag: ${u}`);
  }
  return !1;
}
function readInputs(n) {
  const c = [], u = n.readSize("le");
  for (let p = 0; p < u; p++)
    c.push(readInput(n));
  return c;
}
function readInput(n) {
  return {
    txid: n.read(32).reverse().toHex(),
    vout: n.read(4).reverse().toNum(),
    scriptSig: readScript(n),
    sequence: n.read(4).reverse().toHex(),
    witness: []
  };
}
function readOutputs(n) {
  const c = [], u = n.readSize("le");
  for (let p = 0; p < u; p++)
    c.push(readOutput(n));
  return c;
}
function readOutput(n) {
  return {
    value: n.read(8).reverse().big,
    scriptPubKey: readScript(n)
  };
}
function readWitness$1(n) {
  const c = [], u = n.readSize();
  for (let p = 0; p < u; p++) {
    const a = readData(n);
    c.push(a ?? "");
  }
  return c;
}
function readData(n, c) {
  const u = n.readSize("le");
  return u > 0 ? n.read(u).hex : null;
}
function readScript(n, c) {
  const u = readData(n);
  return u !== null ? u : [];
}
function readLocktime(n) {
  return n.read(4).reverse().toNum();
}
function toJson(n) {
  if (isBytes$1(n))
    return decodeTx(n);
  if (typeof n == "object" && !(n instanceof Uint8Array))
    return encodeTx(n), createTx(n);
  throw new Error("Invalid format: " + typeof n);
}
function toBytes(n) {
  if (isBytes$1(n))
    return decodeTx(n), Buff$1.bytes(n);
  if (typeof n == "object")
    return encodeTx(n);
  throw new Error("Invalid format: " + typeof n);
}
const TxFmt = {
  toBytes,
  toJson
}, OUTPUT_TYPES = [
  ["p2pkh", /^76a914(?<hash>\w{40})88ac$/],
  ["p2sh", /^a914(?<hash>\w{40})87$/],
  ["p2w-pkh", /^0014(?<hash>\w{40})$/],
  ["p2w-sh", /^0020(?<hash>\w{64})$/],
  ["p2tr", /^5120(?<hash>\w{64})$/]
], LEAF_VERSIONS = [
  192,
  194,
  196,
  198,
  200,
  202,
  204,
  206,
  208,
  210,
  212,
  214,
  216,
  218,
  220,
  222,
  224,
  226,
  228,
  230,
  232,
  234,
  236,
  238,
  240,
  242,
  244,
  246,
  248,
  250,
  252,
  254,
  102,
  126,
  128,
  132,
  150,
  152,
  186,
  188,
  190
];
function parseAnnex(n) {
  let c = n.at(-1);
  return isHex(c) && (c = Buff$1.hex(c)), n.length > 1 && c instanceof Uint8Array && c[0] === 80 ? (n.pop(), Buff$1.raw(c)) : null;
}
function parseBlock(n) {
  let c = n.at(-1);
  return isHex(c) && (c = Buff$1.hex(c)), n.length > 1 && c instanceof Uint8Array && c.length > 32 && LEAF_VERSIONS.includes(c[0] & 254) ? (n.pop(), Buff$1.raw(c)) : null;
}
function parseWitScript(n) {
  if (n.length > 1) {
    const c = n.at(-1);
    try {
      const u = Script.fmt.toBytes(c);
      return n.pop(), u;
    } catch {
      return null;
    }
  }
  return null;
}
function parseParams(n) {
  const c = [];
  for (const u of n)
    if (isHex(u) || u instanceof Uint8Array || typeof u == "number")
      c.push(Buff$1.bytes(u));
    else
      throw new Error("unrecognized value: " + String(u));
  return c;
}
function readWitness(n = []) {
  const c = [...n], u = parseAnnex(c), p = parseBlock(c), a = parseWitScript(c), A = parseParams(c);
  return { annex: u, cblock: p, script: a, params: A };
}
function readScriptPubKey(n) {
  const c = Script.fmt.toBytes(n, !1).hex;
  for (const [u, p] of OUTPUT_TYPES) {
    const a = u, { groups: A } = p.exec(c) ?? {}, { hash: b } = A ?? {};
    if (isHex(b))
      return { type: a, data: Buff$1.hex(b) };
  }
  return { type: "raw", data: Buff$1.hex(c) };
}
function getTxid(n) {
  const c = TxFmt.toJson(n), u = encodeTx(c, !0);
  return hash256$3(u).reverse().hex;
}
function getTxSize(n) {
  const c = TxFmt.toJson(n), u = encodeTx(c, !0).length, p = encodeTx(c, !1).length, a = u * 3 + p, A = a % 4 > 0 ? 1 : 0, b = Math.floor(a / 4) + A;
  return { size: p, bsize: u, vsize: b, weight: a };
}
const Tx = {
  create: createTx,
  encode: encodeTx,
  decode: decodeTx,
  fmt: TxFmt,
  util: {
    getTxSize,
    getTxid,
    readScriptPubKey,
    readWitness
  }
}, ADDRESS_TYPES = [
  ["1", "p2pkh", "main", 20, "base58"],
  ["3", "p2sh", "main", 20, "base58"],
  ["m", "p2pkh", "testnet", 20, "base58"],
  ["n", "p2pkh", "testnet", 20, "base58"],
  ["2", "p2sh", "testnet", 20, "base58"],
  ["bc1q", "p2w-pkh", "main", 20, "bech32"],
  ["tb1q", "p2w-pkh", "testnet", 20, "bech32"],
  ["bcrt1q", "p2w-pkh", "regtest", 20, "bech32"],
  ["bc1q", "p2w-sh", "main", 32, "bech32"],
  ["tb1q", "p2w-sh", "testnet", 32, "bech32"],
  ["bcrt1q", "p2w-sh", "regtest", 32, "bech32"],
  ["bc1p", "p2tr", "main", 32, "bech32m"],
  ["tb1p", "p2tr", "testnet", 32, "bech32m"],
  ["bcrt1p", "p2tr", "regtest", 32, "bech32m"]
];
function decodeFormat(n, c) {
  switch (c) {
    case "base58":
      return Buff$1.b58chk(n).slice(1);
    case "bech32":
      return Buff$1.bech32(n);
    case "bech32m":
      return Buff$1.bech32(n);
    default:
      throw new Error("Invalid address format: " + c);
  }
}
function getData(n) {
  for (const c of ADDRESS_TYPES) {
    const [u, p, a, A, b] = c;
    if (n.startsWith(u) && decodeFormat(n, b).length === A)
      return c;
  }
  throw new Error("Invalid address: " + n);
}
function getTool(n) {
  switch (n) {
    case "p2pkh":
      return P2PKH;
    case "p2sh":
      return P2SH;
    case "p2w-pkh":
      return P2WPKH;
    case "p2w-sh":
      return P2WSH;
    case "p2tr":
      return P2TR;
    default:
      throw new Error("Invalid address type: " + n);
  }
}
function decodeAddress(n) {
  const [c, u, p] = getData(n), a = getTool(u), A = a.decode(n, p), b = a.scriptPubKey(A);
  return { prefix: c, type: u, network: p, data: A, script: b };
}
function fromScriptPubKey(n, c) {
  const { type: u, data: p } = Tx.util.readScriptPubKey(n);
  return getTool(u).encode(p, c);
}
function toScriptPubKey(n) {
  const { script: c } = decodeAddress(n);
  return Script.fmt.toAsm(c, !1);
}
const Address = {
  p2pkh: P2PKH,
  p2sh: P2SH,
  p2wpkh: P2WPKH,
  p2wsh: P2WSH,
  p2tr: P2TR,
  decode: decodeAddress,
  fromScriptPubKey,
  toScriptPubKey
}, VALID_HASH_TYPES$1 = [1, 2, 3];
function hashTx$1(n, c, u = {}) {
  const { sigflag: p = 1 } = u, a = (p & 128) === 128, A = p % 128;
  if (!VALID_HASH_TYPES$1.includes(A))
    throw new Error("Invalid hash type: " + String(p));
  const b = Tx.fmt.toJson(n), { version: F, vin: le, vout: L, locktime: pe } = b, { txid: $, vout: Ee, prevout: be, sequence: He } = le[c], { value: Pe } = be ?? {};
  if (Pe === void 0)
    throw new Error("Prevout value is empty!");
  let nr = u.script;
  if (nr === void 0 && u.pubkey !== void 0 && (nr = `76a914${hash160(u.pubkey).hex}88ac`), nr === void 0)
    throw new Error("No pubkey / script has been set!");
  if (Script.fmt.toAsm(nr).includes("OP_CODESEPARATOR"))
    throw new Error("This library does not currently support the use of OP_CODESEPARATOR in segwit scripts.");
  const ir = [
    encodeVersion(F),
    hashPrevouts(le, a),
    hashSequence$1(le, A, a),
    encodeTxid($),
    encodePrevOut(Ee),
    Script.encode(nr, !0),
    encodeValue(Pe),
    encodeSequence(He),
    hashOutputs$1(L, c, A),
    encodeLocktime(pe),
    Buff$1.num(p, 4).reverse()
  ];
  return hash256$3(Buff$1.join(ir));
}
function hashPrevouts(n, c) {
  if (c === !0)
    return Buff$1.num(0, 32);
  const u = [];
  for (const { txid: p, vout: a } of n)
    u.push(encodeTxid(p)), u.push(encodePrevOut(a));
  return hash256$3(Buff$1.join(u));
}
function hashSequence$1(n, c, u) {
  if (u || c !== 1)
    return Buff$1.num(0, 32);
  const p = [];
  for (const { sequence: a } of n)
    p.push(encodeSequence(a));
  return hash256$3(Buff$1.join(p));
}
function hashOutputs$1(n, c, u) {
  const p = [];
  if (u === 1) {
    for (const { value: a, scriptPubKey: A } of n)
      p.push(encodeValue(a)), p.push(Script.encode(A, !0));
    return hash256$3(Buff$1.join(p));
  }
  if (u === 3 && c < n.length) {
    const { value: a, scriptPubKey: A } = n[c];
    return p.push(encodeValue(a)), p.push(Script.encode(A, !0)), hash256$3(Buff$1.join(p));
  }
  return Buff$1.num(0, 32);
}
function signTx$1(n, c, u, p = {}) {
  const { sigflag: a = 1 } = p, A = hashTx$1(c, u, p), b = noble.secp.sign(A, n).toDERRawBytes(!0);
  return Buff$1.join([b, a]);
}
function verifyTx$1(n, c, u = {}) {
  const p = Tx.fmt.toJson(n), { throws: a = !1 } = u, { witness: A = [] } = p.vin[c], b = Tx.util.readWitness(A), { script: F, params: le } = b;
  let L = null;
  if (le.length < 1)
    return safeThrow("Invalid witness data: " + String(A), a);
  if (u.script === void 0 && F !== null && (u.script = F), u.pubkey !== void 0)
    L = Buff$1.bytes(u.pubkey);
  else if (le.length > 1 && le[1].length === 33)
    L = Buff$1.bytes(le[1]);
  else
    return safeThrow("No pubkey provided!", a);
  const pe = Script.fmt.toParam(le[0]), $ = pe.slice(0, -1), Ee = pe.slice(-1)[0], be = hashTx$1(p, c, { ...u, sigflag: Ee });
  return noble.secp.verify($, be, L) ? !0 : safeThrow("Invalid signature!", a);
}
const SWSigner = {
  hash: hashTx$1,
  sign: signTx$1,
  verify: verifyTx$1
}, VALID_HASH_TYPES = [0, 1, 2, 3, 129, 130, 131];
function hashTx(n, c, u = {}) {
  const { extension: p, sigflag: a = 0, extflag: A = 0, key_version: b = 0, separator_pos: F = 4294967295 } = u, le = Tx.fmt.toJson(n), { version: L, vin: pe, vout: $, locktime: Ee } = le;
  if (c >= pe.length)
    throw new Error("Index out of bounds: " + String(c));
  if (!VALID_HASH_TYPES.includes(a))
    throw new Error("Invalid hash type: " + String(a));
  if (A < 0 || A > 127)
    throw new Error("Extention flag out of range: " + String(A));
  const { txid: be, vout: He, sequence: Pe, witness: nr = [] } = pe[c], ir = (a & 128) === 128, or = getAnnexData(nr), lr = or !== void 0 ? 1 : 0, xr = (A + (p !== void 0 ? 1 : 0)) * 2 + lr, kr = Buff$1.str("TapSighash").digest, Ce = [
    kr,
    kr,
    Buff$1.num(0, 1),
    Buff$1.num(a, 1),
    encodeVersion(L),
    encodeLocktime(Ee)
  ];
  if (!ir) {
    const tr = pe.map((Fe) => getPrevout(Fe));
    Ce.push(hashOutpoints(pe), hashAmounts(tr), hashScripts(tr), hashSequence(pe));
  }
  if (((a & 3) < 2 || (a & 3) > 3) && Ce.push(hashOutputs($)), Ce.push(Buff$1.num(xr, 1)), ir) {
    const { value: tr, scriptPubKey: Fe } = getPrevout(pe[c]);
    Ce.push(encodeTxid(be), encodePrevOut(He), encodeValue(tr), Script.encode(Fe, !0), encodeSequence(Pe));
  } else
    Ce.push(Buff$1.num(c, 4).reverse());
  return or !== void 0 && Ce.push(or), (a & 3) === 3 && Ce.push(hashOutput($[c])), p !== void 0 && Ce.push(Buff$1.bytes(p), Buff$1.num(b), Buff$1.num(F, 4, "le")), Buff$1.join(Ce).digest;
}
function hashOutpoints(n) {
  const c = [];
  for (const { txid: u, vout: p } of n)
    c.push(encodeTxid(u)), c.push(encodePrevOut(p));
  return Buff$1.join(c).digest;
}
function hashSequence(n) {
  const c = [];
  for (const { sequence: u } of n)
    c.push(encodeSequence(u));
  return Buff$1.join(c).digest;
}
function hashAmounts(n) {
  const c = [];
  for (const { value: u } of n)
    c.push(encodeValue(u));
  return Buff$1.join(c).digest;
}
function hashScripts(n) {
  const c = [];
  for (const { scriptPubKey: u } of n)
    c.push(encodeScript(u, !0));
  return Buff$1.join(c).digest;
}
function hashOutputs(n) {
  const c = [];
  for (const { value: u, scriptPubKey: p } of n)
    c.push(encodeValue(u)), c.push(Script.encode(p, !0));
  return Buff$1.join(c).digest;
}
function hashOutput(n) {
  return Buff$1.join([
    encodeValue(n.value),
    Script.encode(n.scriptPubKey, !0)
  ]).digest;
}
function getAnnexData(n) {
  if (n === void 0 || n.length < 2)
    return;
  let c = n.at(-1);
  if (typeof c == "string" && (c = Buff$1.hex(c)), c instanceof Uint8Array && c[0] === 80)
    return Buff$1.raw(c).prefixSize("be").digest;
}
function getPrevout(n) {
  if (n.prevout === void 0)
    throw new Error("Prevout data missing for input: " + String(n.txid));
  return n.prevout;
}
const FIELD_SIZE = 0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2fn, CURVE_ORDER = 0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141n;
function signTx(n, c, u, p = {}) {
  const { sigflag: a = 0 } = p, A = hashTx(c, u, p), b = sign(n, A);
  return a === 0 ? Buff$1.raw(b) : Buff$1.join([b, a]);
}
function sign(n, c, u = Buff$1.random(32)) {
  const p = Buff$1.bytes(c), a = new Field(n), A = a.point, b = A.hasEvenY ? a.big : a.negated.big, F = hashTag("BIP0340/aux", Buff$1.bytes(u)), le = b ^ F.big, L = hashTag("BIP0340/nonce", le, A.x.raw, p), pe = new Field(L), $ = pe.point, Ee = $.hasEvenY ? pe.big : pe.negated.big, be = new Field(hashTag("BIP0340/challenge", $.x.raw, A.x.raw, p)), He = new Field(Ee + be.big * b);
  return Buff$1.join([$.x.raw, He.raw]);
}
function verify(n, c, u, p = !1) {
  const a = Point.from_x(xOnlyPub(u)), A = Buff$1.bytes(c), b = Buff$1.bytes(n).stream;
  b.size < 64 && safeThrow("Signature length is too small: " + String(b.size), p);
  const F = b.read(32);
  F.big > FIELD_SIZE && safeThrow("Signature r value greater than field size!", p);
  const le = b.read(32);
  le.big > CURVE_ORDER && safeThrow("Signature s value greater than curve order!", p);
  const L = new Field(hashTag("BIP0340/challenge", F.raw, a.x.raw, A)), pe = new Field(le).point, $ = a.mul(L.big), Ee = pe.sub($);
  return Ee.hasOddY && safeThrow("Signature R value has odd Y coordinate!", p), Ee.x.big === 0n && safeThrow("Signature R value is infinite!", p), Ee.x.big === F.big;
}
const DEFAULT_VERSION$1 = 192;
function getTapTag(n) {
  const c = Buff$1.str(n).digest;
  return Buff$1.join([c, c]);
}
function getTapLeaf(n, c = DEFAULT_VERSION$1) {
  return Buff$1.join([
    getTapTag("TapLeaf"),
    getVersion(c),
    Buff$1.bytes(n)
  ]).digest.hex;
}
function getTapScript(n, c) {
  return getTapLeaf(Script.fmt.toBytes(n), c);
}
function getTapBranch(n, c) {
  return c < n && ([n, c] = [c, n]), Buff$1.join([
    getTapTag("TapBranch"),
    Buff$1.hex(n).raw,
    Buff$1.hex(c).raw
  ]).digest.hex;
}
function getTapRoot(n) {
  return Buff$1.hex(merkleize(n)[0]);
}
function merkleize(n, c, u = []) {
  const p = [], a = [];
  if (n.length < 1)
    throw new Error("Tree is empty!");
  for (let A = 0; A < n.length; A++) {
    const b = n[A];
    if (Array.isArray(b)) {
      const [F, le, L] = merkleize(b, c);
      c = le, p.push(F);
      for (const pe of L)
        u.push(pe);
    } else
      p.push(b);
  }
  if (p.length === 1)
    return [p[0], c, u];
  p.sort(), p.length % 2 !== 0 && p.push(p[p.length - 1]);
  for (let A = 0; A < p.length - 1; A += 2) {
    const b = getTapBranch(p[A], p[A + 1]);
    a.push(b), typeof c == "string" && (c === p[A] ? (u.push(p[A + 1]), c = b) : c === p[A + 1] && (u.push(p[A]), c = b));
  }
  return merkleize(a, c, u);
}
function getVersion(n = 192) {
  return n & 254;
}
function getTapTweak(n, c = new Uint8Array(), u = !1) {
  const p = u ? new Field(n).point.x.raw : xOnlyPub(n);
  return Buff$1.join([getTapTag("TapTweak"), p, Buff$1.bytes(c)]).digest;
}
function getTweakedKey(n, c, u = !1) {
  c === void 0 && (c = new Uint8Array());
  const p = Buff$1.bytes(n), a = getTapTweak(n, c, u);
  return u ? tweakSecKey(p, a) : tweakPubKey(p, a);
}
function getTweakedPub(n, c) {
  return getTweakedKey(n, c);
}
function getTweakedSec(n, c) {
  return getTweakedKey(n, c, !0);
}
function tweakSecKey(n, c) {
  let u = new Field(n);
  return u.point.hasOddY && (u = u.negate()), Buff$1.raw(u.add(c).raw);
}
function tweakPubKey(n, c) {
  n = xOnlyPub(n);
  const p = Point.from_x(n).add(c);
  return Buff$1.raw(p.raw);
}
function getScriptOnlyPubkey() {
  const n = Buff$1.hex("0479be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8");
  return Point.from_x(n.digest).x;
}
const SCRIPT_PUBKEY = getScriptOnlyPubkey(), DEFAULT_VERSION = 192;
function getTapSecKey(n, c = {}) {
  return getTapKey(n, { ...c, isPrivate: !0 });
}
function getTapPubKey(n, c = {}) {
  return getTapKey(n, { ...c, isPrivate: !1 });
}
function getTapKey(n, c = {}) {
  const { isPrivate: u = !1, tree: p = [], version: a = DEFAULT_VERSION } = c, A = u ? util$1.getPublicKey(n, !0) : xOnlyPub(n);
  let { target: b } = c;
  b !== void 0 && (b = Buff$1.bytes(b).hex);
  let F, le = [];
  if (p.length > 0) {
    const [be, He, Pe] = merkleize(p, b);
    le = Pe, F = getTweakedKey(n, be, u);
  } else
    b !== void 0 ? F = getTweakedKey(n, b, u) : F = getTweakedKey(n, void 0, u);
  const L = u ? util$1.getPublicKey(F)[0] : F[0], $ = [Buff$1.num(a + readParityBit(L)), A];
  le.length > 0 && le.forEach((be) => $.push(Buff$1.hex(be)));
  const Ee = Buff$1.join($);
  if (b !== void 0 && !checkPath(F, b, Ee, c))
    throw new Error("Path checking failed! Unable to generate path.");
  return [xOnlyPub(F).hex, Ee.hex];
}
function checkPath(n, c, u, p = {}) {
  const { isPrivate: a = !1, throws: A = !1 } = p, { parity: b, paths: F, intkey: le } = readCtrlBlock(u), L = a ? util$1.getPublicKey(n, !0) : xOnlyPub(n), pe = Buff$1.join([b, L]);
  if (pe.length !== 33)
    return safeThrow("Invalid tapkey: " + pe.hex, A);
  let $ = Buff$1.bytes(c).hex;
  for (const be of F)
    $ = getTapBranch($, be);
  const Ee = getTweakedKey(le, $);
  return Buff$1.raw(Ee).hex === Buff$1.raw(pe).hex;
}
function readCtrlBlock(n) {
  const c = new Stream$1(Buff$1.bytes(n)), u = c.read(1).num, p = c.read(32), [a, A] = u % 2 === 0 ? [u, 2] : [u - 1, 3], b = [];
  for (; c.size >= 32; )
    b.push(c.read(32).hex);
  if (c.size !== 0)
    throw new Error("Non-empty buffer on control block: " + String(c));
  return { intkey: p, paths: b, parity: A, version: a };
}
function readParityBit(n = 2) {
  if (n === 0 || n === 1)
    return n;
  if (n === 2 || n === "02")
    return 0;
  if (n === 3 || n === "03")
    return 1;
  throw new Error("Invalid parity bit: " + String(n));
}
function verifyTx(n, c, u = {}) {
  const p = Tx.fmt.toJson(n), { throws: a = !1 } = u, { prevout: A, witness: b = [] } = p.vin[c], F = Tx.util.readWitness(b), { cblock: le, script: L, params: pe } = F;
  let $;
  if (pe.length < 1)
    return safeThrow("Invalid witness data: " + String(b), a);
  const { scriptPubKey: Ee } = A ?? {};
  if (Ee === void 0)
    return safeThrow("Prevout scriptPubKey is empty!", a);
  const { type: be, data: He } = Tx.util.readScriptPubKey(Ee);
  if (be !== "p2tr")
    return safeThrow("Prevout script is not a valid taproot output:" + He.hex, a);
  if (He.length !== 32)
    return safeThrow("Invalid tapkey length: " + String(He.length), a);
  if (le !== null && L !== null) {
    const lr = le[0] & 254, Ir = getTapLeaf(L, lr);
    if (u.extension = Ir, !checkPath(He, Ir, le, { throws: a }))
      return safeThrow("cblock verification failed!", a);
  }
  u.pubkey !== void 0 ? $ = Buff$1.bytes(u.pubkey) : pe.length > 1 && pe[1].length === 32 ? $ = Buff$1.bytes(pe[1]) : $ = Buff$1.bytes(He);
  const Pe = Script.fmt.toParam(pe[0]), nr = new Stream$1(Pe), ir = nr.read(64).raw;
  if (nr.size === 1 && (u.sigflag = nr.read(1).num, u.sigflag === 0))
    return safeThrow("0x00 is not a valid appended sigflag!", a);
  const or = hashTx(p, c, u);
  return verify(ir, or, $, a) ? !0 : safeThrow("Invalid signature!", a);
}
const TRSigner = {
  hash: hashTx,
  sign: signTx,
  verify: verifyTx
}, Signer = {
  segwit: SWSigner,
  taproot: TRSigner
}, TapTree = {
  getTag: getTapTag,
  getLeaf: getTapLeaf,
  getBranch: getTapBranch,
  getRoot: getTapRoot
}, TapUtil = {
  readCtrlBlock,
  readParityBit
}, TapTweak = {
  getPubKey: getTweakedPub,
  getSecKey: getTweakedSec,
  getTweak: getTapTweak,
  tweakSecKey,
  tweakPubKey
}, Tap = {
  getPubKey: getTapPubKey,
  getSecKey: getTapSecKey,
  encodeScript: getTapScript,
  checkPath,
  tree: TapTree,
  tweak: TapTweak,
  util: TapUtil,
  SCRIPT_PUBKEY
};
class TxScript {
  constructor(c) {
    this._buff = Buff$1.raw(encodeScript(c));
  }
  get raw() {
    return this._buff.raw;
  }
  get hex() {
    return this._buff.hex;
  }
  get asm() {
    return decodeScript(this._buff);
  }
  getHash(c, u) {
    switch (c) {
      case "p2w":
        return hash256$3(this._buff).hex;
      case "p2sh":
        return hash160(this._buff).hex;
      case "p2tr":
        return TapTree.getLeaf(this._buff, u);
      default:
        throw new Error("Unrecognized format: " + c);
    }
  }
  toJSON() {
    return this.asm ?? [];
  }
}
const MAX_VAL = 4294967295, NO_LOCK = 1 << 31, TIME_MOD = 512, LOCK_TYPE = 1 << 22;
class TxSequence {
  constructor(c) {
    typeof c == "string" ? this.value = parseInt(c, 16) : this.value = c;
  }
  get isReplaceable() {
    return this.value < MAX_VAL;
  }
  get isLocked() {
    return !(this.value !== MAX_VAL || this.value & NO_LOCK);
  }
  get isTimelock() {
    return (this.value & LOCK_TYPE) !== 0;
  }
  get timestamp() {
    return this.isLocked ? this.isTimelock ? this.value * TIME_MOD : this.value * TIME_MOD * 600 : 0;
  }
  set timestamp(c) {
    this.value = Math.ceil(c / TIME_MOD);
  }
  get blockheight() {
    return this.isLocked ? this.isTimelock ? Math.ceil(this.value * TIME_MOD / 600) : this.value : 0;
  }
  set blockheight(c) {
    this.value = c;
  }
  get estDate() {
    return this.isTimelock ? new Date(Date.now() + this.value * TIME_MOD * 1e3) : new Date(Date.now() + this.value * 600 * 1e3);
  }
  set estDate(c) {
    const u = c.getTime() - Date.now();
    this.value = u > TIME_MOD * 1e3 ? Math.ceil(u / 1e3 / TIME_MOD) : 1;
  }
  toJSON() {
    return this.value;
  }
}
let TxOutput$1 = class {
  constructor(c) {
    this.value = BigInt(c.value), this.scriptPubKey = new TxScript(c.scriptPubKey);
  }
  get type() {
    const { type: c } = readScriptPubKey(this.scriptPubKey.raw);
    return c;
  }
};
class TxWitness {
  constructor(c, u) {
    this._data = c, this._meta = readWitness(c), this.format = u;
  }
  get length() {
    return this._data.length;
  }
  get annex() {
    const c = this._meta.annex;
    return c !== null ? Buff$1.raw(c).hex : void 0;
  }
  get cblock() {
    const c = this._meta.cblock;
    return c !== null ? Buff$1.raw(c).hex : void 0;
  }
  get script() {
    const c = this._meta.script;
    return c !== null ? Script.decode(c) : void 0;
  }
  get params() {
    return this._meta.params;
  }
  toJSON() {
    return this._data;
  }
}
let TxInput$1 = class {
  constructor(c, u) {
    this._tx = c, this.idx = u;
  }
  get data() {
    return this._tx.vin[this.idx];
  }
  get txid() {
    return this.data.txid;
  }
  get vout() {
    return this.data.vout;
  }
  get prevout() {
    return this.data.prevout !== void 0 ? new TxOutput$1(this.data.prevout) : void 0;
  }
  get scriptSig() {
    return new TxScript(this.data.scriptSig);
  }
  get sequence() {
    return new TxSequence(this.data.sequence);
  }
  get witness() {
    return new TxWitness(this.data.witness);
  }
  get type() {
    if (this.prevout !== void 0) {
      const c = this.prevout.scriptPubKey.raw, { type: u } = readScriptPubKey(c);
      if (u === "p2sh") {
        const p = this.scriptSig.asm;
        if (p[0] === "OP_0") {
          if (p[1].length === 20)
            return "p2w-p2pkh";
          if (p[1].length === 32)
            return "p2w-p2sh";
        }
        return "p2sh";
      }
      return u;
    }
    return "raw";
  }
  sign(c, u) {
    if (this.type.startsWith("p2w"))
      return Signer.segwit.sign(c, this._tx, this.idx, u);
    if (this.type.startsWith("p2tr"))
      return Signer.taproot.sign(c, this._tx, this.idx, u);
    throw this.type.startsWith("p2pkh") || this.type.startsWith("p2sh") ? new Error("This library does not support signing legacy transactions.") : new Error("Unable to sign this input type:" + String(this.type));
  }
};
const LOCKTIME_THRESHOLD = 5e8;
class TxLocktime {
  constructor(c = 0) {
    this.value = Buff$1.bytes(c).num;
  }
  get isTimelock() {
    return this.value > LOCKTIME_THRESHOLD;
  }
  get timestamp() {
    return this.isTimelock ? this.value : this.value * 600;
  }
  set timestamp(c) {
    this.value = c;
  }
  get blockheight() {
    return this.isTimelock ? Math.floor(this.value / 600) : this.value;
  }
  set blockheight(c) {
    this.value = c;
  }
  get estDate() {
    return this.isTimelock ? new Date(Date.now() + this.value * 1e3) : new Date(Date.now() + this.value * 600 * 1e3);
  }
  set estDate(c) {
    this.value = Math.floor((c.getTime() - Date.now()) / 1e3);
  }
  toJSON() {
    return this.value;
  }
}
var util;
(function(n) {
  n.assertEqual = (a) => a;
  function c(a) {
  }
  n.assertIs = c;
  function u(a) {
    throw new Error();
  }
  n.assertNever = u, n.arrayToEnum = (a) => {
    const A = {};
    for (const b of a)
      A[b] = b;
    return A;
  }, n.getValidEnumValues = (a) => {
    const A = n.objectKeys(a).filter((F) => typeof a[a[F]] != "number"), b = {};
    for (const F of A)
      b[F] = a[F];
    return n.objectValues(b);
  }, n.objectValues = (a) => n.objectKeys(a).map(function(A) {
    return a[A];
  }), n.objectKeys = typeof Object.keys == "function" ? (a) => Object.keys(a) : (a) => {
    const A = [];
    for (const b in a)
      Object.prototype.hasOwnProperty.call(a, b) && A.push(b);
    return A;
  }, n.find = (a, A) => {
    for (const b of a)
      if (A(b))
        return b;
  }, n.isInteger = typeof Number.isInteger == "function" ? (a) => Number.isInteger(a) : (a) => typeof a == "number" && isFinite(a) && Math.floor(a) === a;
  function p(a, A = " | ") {
    return a.map((b) => typeof b == "string" ? `'${b}'` : b).join(A);
  }
  n.joinValues = p, n.jsonStringifyReplacer = (a, A) => typeof A == "bigint" ? A.toString() : A;
})(util || (util = {}));
var objectUtil;
(function(n) {
  n.mergeShapes = (c, u) => ({
    ...c,
    ...u
    // second overwrites first
  });
})(objectUtil || (objectUtil = {}));
const ZodParsedType = util.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), getParsedType = (n) => {
  switch (typeof n) {
    case "undefined":
      return ZodParsedType.undefined;
    case "string":
      return ZodParsedType.string;
    case "number":
      return isNaN(n) ? ZodParsedType.nan : ZodParsedType.number;
    case "boolean":
      return ZodParsedType.boolean;
    case "function":
      return ZodParsedType.function;
    case "bigint":
      return ZodParsedType.bigint;
    case "symbol":
      return ZodParsedType.symbol;
    case "object":
      return Array.isArray(n) ? ZodParsedType.array : n === null ? ZodParsedType.null : n.then && typeof n.then == "function" && n.catch && typeof n.catch == "function" ? ZodParsedType.promise : typeof Map < "u" && n instanceof Map ? ZodParsedType.map : typeof Set < "u" && n instanceof Set ? ZodParsedType.set : typeof Date < "u" && n instanceof Date ? ZodParsedType.date : ZodParsedType.object;
    default:
      return ZodParsedType.unknown;
  }
}, ZodIssueCode = util.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), quotelessJson = (n) => JSON.stringify(n, null, 2).replace(/"([^"]+)":/g, "$1:");
class ZodError extends Error {
  constructor(c) {
    super(), this.issues = [], this.addIssue = (p) => {
      this.issues = [...this.issues, p];
    }, this.addIssues = (p = []) => {
      this.issues = [...this.issues, ...p];
    };
    const u = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, u) : this.__proto__ = u, this.name = "ZodError", this.issues = c;
  }
  get errors() {
    return this.issues;
  }
  format(c) {
    const u = c || function(A) {
      return A.message;
    }, p = { _errors: [] }, a = (A) => {
      for (const b of A.issues)
        if (b.code === "invalid_union")
          b.unionErrors.map(a);
        else if (b.code === "invalid_return_type")
          a(b.returnTypeError);
        else if (b.code === "invalid_arguments")
          a(b.argumentsError);
        else if (b.path.length === 0)
          p._errors.push(u(b));
        else {
          let F = p, le = 0;
          for (; le < b.path.length; ) {
            const L = b.path[le];
            le === b.path.length - 1 ? (F[L] = F[L] || { _errors: [] }, F[L]._errors.push(u(b))) : F[L] = F[L] || { _errors: [] }, F = F[L], le++;
          }
        }
    };
    return a(this), p;
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, util.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(c = (u) => u.message) {
    const u = {}, p = [];
    for (const a of this.issues)
      a.path.length > 0 ? (u[a.path[0]] = u[a.path[0]] || [], u[a.path[0]].push(c(a))) : p.push(c(a));
    return { formErrors: p, fieldErrors: u };
  }
  get formErrors() {
    return this.flatten();
  }
}
ZodError.create = (n) => new ZodError(n);
const errorMap = (n, c) => {
  let u;
  switch (n.code) {
    case ZodIssueCode.invalid_type:
      n.received === ZodParsedType.undefined ? u = "Required" : u = `Expected ${n.expected}, received ${n.received}`;
      break;
    case ZodIssueCode.invalid_literal:
      u = `Invalid literal value, expected ${JSON.stringify(n.expected, util.jsonStringifyReplacer)}`;
      break;
    case ZodIssueCode.unrecognized_keys:
      u = `Unrecognized key(s) in object: ${util.joinValues(n.keys, ", ")}`;
      break;
    case ZodIssueCode.invalid_union:
      u = "Invalid input";
      break;
    case ZodIssueCode.invalid_union_discriminator:
      u = `Invalid discriminator value. Expected ${util.joinValues(n.options)}`;
      break;
    case ZodIssueCode.invalid_enum_value:
      u = `Invalid enum value. Expected ${util.joinValues(n.options)}, received '${n.received}'`;
      break;
    case ZodIssueCode.invalid_arguments:
      u = "Invalid function arguments";
      break;
    case ZodIssueCode.invalid_return_type:
      u = "Invalid function return type";
      break;
    case ZodIssueCode.invalid_date:
      u = "Invalid date";
      break;
    case ZodIssueCode.invalid_string:
      typeof n.validation == "object" ? "includes" in n.validation ? (u = `Invalid input: must include "${n.validation.includes}"`, typeof n.validation.position == "number" && (u = `${u} at one or more positions greater than or equal to ${n.validation.position}`)) : "startsWith" in n.validation ? u = `Invalid input: must start with "${n.validation.startsWith}"` : "endsWith" in n.validation ? u = `Invalid input: must end with "${n.validation.endsWith}"` : util.assertNever(n.validation) : n.validation !== "regex" ? u = `Invalid ${n.validation}` : u = "Invalid";
      break;
    case ZodIssueCode.too_small:
      n.type === "array" ? u = `Array must contain ${n.exact ? "exactly" : n.inclusive ? "at least" : "more than"} ${n.minimum} element(s)` : n.type === "string" ? u = `String must contain ${n.exact ? "exactly" : n.inclusive ? "at least" : "over"} ${n.minimum} character(s)` : n.type === "number" ? u = `Number must be ${n.exact ? "exactly equal to " : n.inclusive ? "greater than or equal to " : "greater than "}${n.minimum}` : n.type === "date" ? u = `Date must be ${n.exact ? "exactly equal to " : n.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(n.minimum))}` : u = "Invalid input";
      break;
    case ZodIssueCode.too_big:
      n.type === "array" ? u = `Array must contain ${n.exact ? "exactly" : n.inclusive ? "at most" : "less than"} ${n.maximum} element(s)` : n.type === "string" ? u = `String must contain ${n.exact ? "exactly" : n.inclusive ? "at most" : "under"} ${n.maximum} character(s)` : n.type === "number" ? u = `Number must be ${n.exact ? "exactly" : n.inclusive ? "less than or equal to" : "less than"} ${n.maximum}` : n.type === "bigint" ? u = `BigInt must be ${n.exact ? "exactly" : n.inclusive ? "less than or equal to" : "less than"} ${n.maximum}` : n.type === "date" ? u = `Date must be ${n.exact ? "exactly" : n.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(n.maximum))}` : u = "Invalid input";
      break;
    case ZodIssueCode.custom:
      u = "Invalid input";
      break;
    case ZodIssueCode.invalid_intersection_types:
      u = "Intersection results could not be merged";
      break;
    case ZodIssueCode.not_multiple_of:
      u = `Number must be a multiple of ${n.multipleOf}`;
      break;
    case ZodIssueCode.not_finite:
      u = "Number must be finite";
      break;
    default:
      u = c.defaultError, util.assertNever(n);
  }
  return { message: u };
};
let overrideErrorMap = errorMap;
function setErrorMap(n) {
  overrideErrorMap = n;
}
function getErrorMap() {
  return overrideErrorMap;
}
const makeIssue = (n) => {
  const { data: c, path: u, errorMaps: p, issueData: a } = n, A = [...u, ...a.path || []], b = {
    ...a,
    path: A
  };
  let F = "";
  const le = p.filter((L) => !!L).slice().reverse();
  for (const L of le)
    F = L(b, { data: c, defaultError: F }).message;
  return {
    ...a,
    path: A,
    message: a.message || F
  };
}, EMPTY_PATH = [];
function addIssueToContext(n, c) {
  const u = makeIssue({
    issueData: c,
    data: n.data,
    path: n.path,
    errorMaps: [
      n.common.contextualErrorMap,
      n.schemaErrorMap,
      getErrorMap(),
      errorMap
      // then global default map
    ].filter((p) => !!p)
  });
  n.common.issues.push(u);
}
class ParseStatus {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(c, u) {
    const p = [];
    for (const a of u) {
      if (a.status === "aborted")
        return INVALID;
      a.status === "dirty" && c.dirty(), p.push(a.value);
    }
    return { status: c.value, value: p };
  }
  static async mergeObjectAsync(c, u) {
    const p = [];
    for (const a of u)
      p.push({
        key: await a.key,
        value: await a.value
      });
    return ParseStatus.mergeObjectSync(c, p);
  }
  static mergeObjectSync(c, u) {
    const p = {};
    for (const a of u) {
      const { key: A, value: b } = a;
      if (A.status === "aborted" || b.status === "aborted")
        return INVALID;
      A.status === "dirty" && c.dirty(), b.status === "dirty" && c.dirty(), (typeof b.value < "u" || a.alwaysSet) && (p[A.value] = b.value);
    }
    return { status: c.value, value: p };
  }
}
const INVALID = Object.freeze({
  status: "aborted"
}), DIRTY = (n) => ({ status: "dirty", value: n }), OK = (n) => ({ status: "valid", value: n }), isAborted = (n) => n.status === "aborted", isDirty = (n) => n.status === "dirty", isValid = (n) => n.status === "valid", isAsync = (n) => typeof Promise < "u" && n instanceof Promise;
var errorUtil;
(function(n) {
  n.errToObj = (c) => typeof c == "string" ? { message: c } : c || {}, n.toString = (c) => typeof c == "string" ? c : c == null ? void 0 : c.message;
})(errorUtil || (errorUtil = {}));
class ParseInputLazyPath {
  constructor(c, u, p, a) {
    this._cachedPath = [], this.parent = c, this.data = u, this._path = p, this._key = a;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const handleResult = (n, c) => {
  if (isValid(c))
    return { success: !0, data: c.value };
  if (!n.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const u = new ZodError(n.common.issues);
      return this._error = u, this._error;
    }
  };
};
function processCreateParams(n) {
  if (!n)
    return {};
  const { errorMap: c, invalid_type_error: u, required_error: p, description: a } = n;
  if (c && (u || p))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return c ? { errorMap: c, description: a } : { errorMap: (b, F) => b.code !== "invalid_type" ? { message: F.defaultError } : typeof F.data > "u" ? { message: p ?? F.defaultError } : { message: u ?? F.defaultError }, description: a };
}
class ZodType {
  constructor(c) {
    this.spa = this.safeParseAsync, this._def = c, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this);
  }
  get description() {
    return this._def.description;
  }
  _getType(c) {
    return getParsedType(c.data);
  }
  _getOrReturnCtx(c, u) {
    return u || {
      common: c.parent.common,
      data: c.data,
      parsedType: getParsedType(c.data),
      schemaErrorMap: this._def.errorMap,
      path: c.path,
      parent: c.parent
    };
  }
  _processInputParams(c) {
    return {
      status: new ParseStatus(),
      ctx: {
        common: c.parent.common,
        data: c.data,
        parsedType: getParsedType(c.data),
        schemaErrorMap: this._def.errorMap,
        path: c.path,
        parent: c.parent
      }
    };
  }
  _parseSync(c) {
    const u = this._parse(c);
    if (isAsync(u))
      throw new Error("Synchronous parse encountered promise.");
    return u;
  }
  _parseAsync(c) {
    const u = this._parse(c);
    return Promise.resolve(u);
  }
  parse(c, u) {
    const p = this.safeParse(c, u);
    if (p.success)
      return p.data;
    throw p.error;
  }
  safeParse(c, u) {
    var p;
    const a = {
      common: {
        issues: [],
        async: (p = u == null ? void 0 : u.async) !== null && p !== void 0 ? p : !1,
        contextualErrorMap: u == null ? void 0 : u.errorMap
      },
      path: (u == null ? void 0 : u.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: c,
      parsedType: getParsedType(c)
    }, A = this._parseSync({ data: c, path: a.path, parent: a });
    return handleResult(a, A);
  }
  async parseAsync(c, u) {
    const p = await this.safeParseAsync(c, u);
    if (p.success)
      return p.data;
    throw p.error;
  }
  async safeParseAsync(c, u) {
    const p = {
      common: {
        issues: [],
        contextualErrorMap: u == null ? void 0 : u.errorMap,
        async: !0
      },
      path: (u == null ? void 0 : u.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: c,
      parsedType: getParsedType(c)
    }, a = this._parse({ data: c, path: p.path, parent: p }), A = await (isAsync(a) ? a : Promise.resolve(a));
    return handleResult(p, A);
  }
  refine(c, u) {
    const p = (a) => typeof u == "string" || typeof u > "u" ? { message: u } : typeof u == "function" ? u(a) : u;
    return this._refinement((a, A) => {
      const b = c(a), F = () => A.addIssue({
        code: ZodIssueCode.custom,
        ...p(a)
      });
      return typeof Promise < "u" && b instanceof Promise ? b.then((le) => le ? !0 : (F(), !1)) : b ? !0 : (F(), !1);
    });
  }
  refinement(c, u) {
    return this._refinement((p, a) => c(p) ? !0 : (a.addIssue(typeof u == "function" ? u(p, a) : u), !1));
  }
  _refinement(c) {
    return new ZodEffects({
      schema: this,
      typeName: ZodFirstPartyTypeKind.ZodEffects,
      effect: { type: "refinement", refinement: c }
    });
  }
  superRefine(c) {
    return this._refinement(c);
  }
  optional() {
    return ZodOptional.create(this, this._def);
  }
  nullable() {
    return ZodNullable.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return ZodArray.create(this, this._def);
  }
  promise() {
    return ZodPromise.create(this, this._def);
  }
  or(c) {
    return ZodUnion.create([this, c], this._def);
  }
  and(c) {
    return ZodIntersection.create(this, c, this._def);
  }
  transform(c) {
    return new ZodEffects({
      ...processCreateParams(this._def),
      schema: this,
      typeName: ZodFirstPartyTypeKind.ZodEffects,
      effect: { type: "transform", transform: c }
    });
  }
  default(c) {
    const u = typeof c == "function" ? c : () => c;
    return new ZodDefault({
      ...processCreateParams(this._def),
      innerType: this,
      defaultValue: u,
      typeName: ZodFirstPartyTypeKind.ZodDefault
    });
  }
  brand() {
    return new ZodBranded({
      typeName: ZodFirstPartyTypeKind.ZodBranded,
      type: this,
      ...processCreateParams(this._def)
    });
  }
  catch(c) {
    const u = typeof c == "function" ? c : () => c;
    return new ZodCatch({
      ...processCreateParams(this._def),
      innerType: this,
      catchValue: u,
      typeName: ZodFirstPartyTypeKind.ZodCatch
    });
  }
  describe(c) {
    const u = this.constructor;
    return new u({
      ...this._def,
      description: c
    });
  }
  pipe(c) {
    return ZodPipeline.create(this, c);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const cuidRegex = /^c[^\s-]{8,}$/i, cuid2Regex = /^[a-z][a-z0-9]*$/, ulidRegex = /[0-9A-HJKMNP-TV-Z]{26}/, uuidRegex = /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i, emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/, emojiRegex = new RegExp("^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$", "u"), ipv4Regex = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/, ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/, datetimeRegex = (n) => n.precision ? n.offset ? new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${n.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`) : new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${n.precision}}Z$`) : n.precision === 0 ? n.offset ? new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$") : new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$") : n.offset ? new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$") : new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$");
function isValidIP(n, c) {
  return !!((c === "v4" || !c) && ipv4Regex.test(n) || (c === "v6" || !c) && ipv6Regex.test(n));
}
class ZodString extends ZodType {
  constructor() {
    super(...arguments), this._regex = (c, u, p) => this.refinement((a) => c.test(a), {
      validation: u,
      code: ZodIssueCode.invalid_string,
      ...errorUtil.errToObj(p)
    }), this.nonempty = (c) => this.min(1, errorUtil.errToObj(c)), this.trim = () => new ZodString({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    }), this.toLowerCase = () => new ZodString({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    }), this.toUpperCase = () => new ZodString({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  _parse(c) {
    if (this._def.coerce && (c.data = String(c.data)), this._getType(c) !== ZodParsedType.string) {
      const A = this._getOrReturnCtx(c);
      return addIssueToContext(
        A,
        {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.string,
          received: A.parsedType
        }
        //
      ), INVALID;
    }
    const p = new ParseStatus();
    let a;
    for (const A of this._def.checks)
      if (A.kind === "min")
        c.data.length < A.value && (a = this._getOrReturnCtx(c, a), addIssueToContext(a, {
          code: ZodIssueCode.too_small,
          minimum: A.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: A.message
        }), p.dirty());
      else if (A.kind === "max")
        c.data.length > A.value && (a = this._getOrReturnCtx(c, a), addIssueToContext(a, {
          code: ZodIssueCode.too_big,
          maximum: A.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: A.message
        }), p.dirty());
      else if (A.kind === "length") {
        const b = c.data.length > A.value, F = c.data.length < A.value;
        (b || F) && (a = this._getOrReturnCtx(c, a), b ? addIssueToContext(a, {
          code: ZodIssueCode.too_big,
          maximum: A.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: A.message
        }) : F && addIssueToContext(a, {
          code: ZodIssueCode.too_small,
          minimum: A.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: A.message
        }), p.dirty());
      } else if (A.kind === "email")
        emailRegex.test(c.data) || (a = this._getOrReturnCtx(c, a), addIssueToContext(a, {
          validation: "email",
          code: ZodIssueCode.invalid_string,
          message: A.message
        }), p.dirty());
      else if (A.kind === "emoji")
        emojiRegex.test(c.data) || (a = this._getOrReturnCtx(c, a), addIssueToContext(a, {
          validation: "emoji",
          code: ZodIssueCode.invalid_string,
          message: A.message
        }), p.dirty());
      else if (A.kind === "uuid")
        uuidRegex.test(c.data) || (a = this._getOrReturnCtx(c, a), addIssueToContext(a, {
          validation: "uuid",
          code: ZodIssueCode.invalid_string,
          message: A.message
        }), p.dirty());
      else if (A.kind === "cuid")
        cuidRegex.test(c.data) || (a = this._getOrReturnCtx(c, a), addIssueToContext(a, {
          validation: "cuid",
          code: ZodIssueCode.invalid_string,
          message: A.message
        }), p.dirty());
      else if (A.kind === "cuid2")
        cuid2Regex.test(c.data) || (a = this._getOrReturnCtx(c, a), addIssueToContext(a, {
          validation: "cuid2",
          code: ZodIssueCode.invalid_string,
          message: A.message
        }), p.dirty());
      else if (A.kind === "ulid")
        ulidRegex.test(c.data) || (a = this._getOrReturnCtx(c, a), addIssueToContext(a, {
          validation: "ulid",
          code: ZodIssueCode.invalid_string,
          message: A.message
        }), p.dirty());
      else if (A.kind === "url")
        try {
          new URL(c.data);
        } catch {
          a = this._getOrReturnCtx(c, a), addIssueToContext(a, {
            validation: "url",
            code: ZodIssueCode.invalid_string,
            message: A.message
          }), p.dirty();
        }
      else A.kind === "regex" ? (A.regex.lastIndex = 0, A.regex.test(c.data) || (a = this._getOrReturnCtx(c, a), addIssueToContext(a, {
        validation: "regex",
        code: ZodIssueCode.invalid_string,
        message: A.message
      }), p.dirty())) : A.kind === "trim" ? c.data = c.data.trim() : A.kind === "includes" ? c.data.includes(A.value, A.position) || (a = this._getOrReturnCtx(c, a), addIssueToContext(a, {
        code: ZodIssueCode.invalid_string,
        validation: { includes: A.value, position: A.position },
        message: A.message
      }), p.dirty()) : A.kind === "toLowerCase" ? c.data = c.data.toLowerCase() : A.kind === "toUpperCase" ? c.data = c.data.toUpperCase() : A.kind === "startsWith" ? c.data.startsWith(A.value) || (a = this._getOrReturnCtx(c, a), addIssueToContext(a, {
        code: ZodIssueCode.invalid_string,
        validation: { startsWith: A.value },
        message: A.message
      }), p.dirty()) : A.kind === "endsWith" ? c.data.endsWith(A.value) || (a = this._getOrReturnCtx(c, a), addIssueToContext(a, {
        code: ZodIssueCode.invalid_string,
        validation: { endsWith: A.value },
        message: A.message
      }), p.dirty()) : A.kind === "datetime" ? datetimeRegex(A).test(c.data) || (a = this._getOrReturnCtx(c, a), addIssueToContext(a, {
        code: ZodIssueCode.invalid_string,
        validation: "datetime",
        message: A.message
      }), p.dirty()) : A.kind === "ip" ? isValidIP(c.data, A.version) || (a = this._getOrReturnCtx(c, a), addIssueToContext(a, {
        validation: "ip",
        code: ZodIssueCode.invalid_string,
        message: A.message
      }), p.dirty()) : util.assertNever(A);
    return { status: p.value, value: c.data };
  }
  _addCheck(c) {
    return new ZodString({
      ...this._def,
      checks: [...this._def.checks, c]
    });
  }
  email(c) {
    return this._addCheck({ kind: "email", ...errorUtil.errToObj(c) });
  }
  url(c) {
    return this._addCheck({ kind: "url", ...errorUtil.errToObj(c) });
  }
  emoji(c) {
    return this._addCheck({ kind: "emoji", ...errorUtil.errToObj(c) });
  }
  uuid(c) {
    return this._addCheck({ kind: "uuid", ...errorUtil.errToObj(c) });
  }
  cuid(c) {
    return this._addCheck({ kind: "cuid", ...errorUtil.errToObj(c) });
  }
  cuid2(c) {
    return this._addCheck({ kind: "cuid2", ...errorUtil.errToObj(c) });
  }
  ulid(c) {
    return this._addCheck({ kind: "ulid", ...errorUtil.errToObj(c) });
  }
  ip(c) {
    return this._addCheck({ kind: "ip", ...errorUtil.errToObj(c) });
  }
  datetime(c) {
    var u;
    return typeof c == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      message: c
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (c == null ? void 0 : c.precision) > "u" ? null : c == null ? void 0 : c.precision,
      offset: (u = c == null ? void 0 : c.offset) !== null && u !== void 0 ? u : !1,
      ...errorUtil.errToObj(c == null ? void 0 : c.message)
    });
  }
  regex(c, u) {
    return this._addCheck({
      kind: "regex",
      regex: c,
      ...errorUtil.errToObj(u)
    });
  }
  includes(c, u) {
    return this._addCheck({
      kind: "includes",
      value: c,
      position: u == null ? void 0 : u.position,
      ...errorUtil.errToObj(u == null ? void 0 : u.message)
    });
  }
  startsWith(c, u) {
    return this._addCheck({
      kind: "startsWith",
      value: c,
      ...errorUtil.errToObj(u)
    });
  }
  endsWith(c, u) {
    return this._addCheck({
      kind: "endsWith",
      value: c,
      ...errorUtil.errToObj(u)
    });
  }
  min(c, u) {
    return this._addCheck({
      kind: "min",
      value: c,
      ...errorUtil.errToObj(u)
    });
  }
  max(c, u) {
    return this._addCheck({
      kind: "max",
      value: c,
      ...errorUtil.errToObj(u)
    });
  }
  length(c, u) {
    return this._addCheck({
      kind: "length",
      value: c,
      ...errorUtil.errToObj(u)
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((c) => c.kind === "datetime");
  }
  get isEmail() {
    return !!this._def.checks.find((c) => c.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((c) => c.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((c) => c.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((c) => c.kind === "uuid");
  }
  get isCUID() {
    return !!this._def.checks.find((c) => c.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((c) => c.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((c) => c.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((c) => c.kind === "ip");
  }
  get minLength() {
    let c = null;
    for (const u of this._def.checks)
      u.kind === "min" && (c === null || u.value > c) && (c = u.value);
    return c;
  }
  get maxLength() {
    let c = null;
    for (const u of this._def.checks)
      u.kind === "max" && (c === null || u.value < c) && (c = u.value);
    return c;
  }
}
ZodString.create = (n) => {
  var c;
  return new ZodString({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodString,
    coerce: (c = n == null ? void 0 : n.coerce) !== null && c !== void 0 ? c : !1,
    ...processCreateParams(n)
  });
};
function floatSafeRemainder(n, c) {
  const u = (n.toString().split(".")[1] || "").length, p = (c.toString().split(".")[1] || "").length, a = u > p ? u : p, A = parseInt(n.toFixed(a).replace(".", "")), b = parseInt(c.toFixed(a).replace(".", ""));
  return A % b / Math.pow(10, a);
}
class ZodNumber extends ZodType {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(c) {
    if (this._def.coerce && (c.data = Number(c.data)), this._getType(c) !== ZodParsedType.number) {
      const A = this._getOrReturnCtx(c);
      return addIssueToContext(A, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.number,
        received: A.parsedType
      }), INVALID;
    }
    let p;
    const a = new ParseStatus();
    for (const A of this._def.checks)
      A.kind === "int" ? util.isInteger(c.data) || (p = this._getOrReturnCtx(c, p), addIssueToContext(p, {
        code: ZodIssueCode.invalid_type,
        expected: "integer",
        received: "float",
        message: A.message
      }), a.dirty()) : A.kind === "min" ? (A.inclusive ? c.data < A.value : c.data <= A.value) && (p = this._getOrReturnCtx(c, p), addIssueToContext(p, {
        code: ZodIssueCode.too_small,
        minimum: A.value,
        type: "number",
        inclusive: A.inclusive,
        exact: !1,
        message: A.message
      }), a.dirty()) : A.kind === "max" ? (A.inclusive ? c.data > A.value : c.data >= A.value) && (p = this._getOrReturnCtx(c, p), addIssueToContext(p, {
        code: ZodIssueCode.too_big,
        maximum: A.value,
        type: "number",
        inclusive: A.inclusive,
        exact: !1,
        message: A.message
      }), a.dirty()) : A.kind === "multipleOf" ? floatSafeRemainder(c.data, A.value) !== 0 && (p = this._getOrReturnCtx(c, p), addIssueToContext(p, {
        code: ZodIssueCode.not_multiple_of,
        multipleOf: A.value,
        message: A.message
      }), a.dirty()) : A.kind === "finite" ? Number.isFinite(c.data) || (p = this._getOrReturnCtx(c, p), addIssueToContext(p, {
        code: ZodIssueCode.not_finite,
        message: A.message
      }), a.dirty()) : util.assertNever(A);
    return { status: a.value, value: c.data };
  }
  gte(c, u) {
    return this.setLimit("min", c, !0, errorUtil.toString(u));
  }
  gt(c, u) {
    return this.setLimit("min", c, !1, errorUtil.toString(u));
  }
  lte(c, u) {
    return this.setLimit("max", c, !0, errorUtil.toString(u));
  }
  lt(c, u) {
    return this.setLimit("max", c, !1, errorUtil.toString(u));
  }
  setLimit(c, u, p, a) {
    return new ZodNumber({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: c,
          value: u,
          inclusive: p,
          message: errorUtil.toString(a)
        }
      ]
    });
  }
  _addCheck(c) {
    return new ZodNumber({
      ...this._def,
      checks: [...this._def.checks, c]
    });
  }
  int(c) {
    return this._addCheck({
      kind: "int",
      message: errorUtil.toString(c)
    });
  }
  positive(c) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: errorUtil.toString(c)
    });
  }
  negative(c) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: errorUtil.toString(c)
    });
  }
  nonpositive(c) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: errorUtil.toString(c)
    });
  }
  nonnegative(c) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: errorUtil.toString(c)
    });
  }
  multipleOf(c, u) {
    return this._addCheck({
      kind: "multipleOf",
      value: c,
      message: errorUtil.toString(u)
    });
  }
  finite(c) {
    return this._addCheck({
      kind: "finite",
      message: errorUtil.toString(c)
    });
  }
  safe(c) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: errorUtil.toString(c)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: errorUtil.toString(c)
    });
  }
  get minValue() {
    let c = null;
    for (const u of this._def.checks)
      u.kind === "min" && (c === null || u.value > c) && (c = u.value);
    return c;
  }
  get maxValue() {
    let c = null;
    for (const u of this._def.checks)
      u.kind === "max" && (c === null || u.value < c) && (c = u.value);
    return c;
  }
  get isInt() {
    return !!this._def.checks.find((c) => c.kind === "int" || c.kind === "multipleOf" && util.isInteger(c.value));
  }
  get isFinite() {
    let c = null, u = null;
    for (const p of this._def.checks) {
      if (p.kind === "finite" || p.kind === "int" || p.kind === "multipleOf")
        return !0;
      p.kind === "min" ? (u === null || p.value > u) && (u = p.value) : p.kind === "max" && (c === null || p.value < c) && (c = p.value);
    }
    return Number.isFinite(u) && Number.isFinite(c);
  }
}
ZodNumber.create = (n) => new ZodNumber({
  checks: [],
  typeName: ZodFirstPartyTypeKind.ZodNumber,
  coerce: (n == null ? void 0 : n.coerce) || !1,
  ...processCreateParams(n)
});
class ZodBigInt extends ZodType {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(c) {
    if (this._def.coerce && (c.data = BigInt(c.data)), this._getType(c) !== ZodParsedType.bigint) {
      const A = this._getOrReturnCtx(c);
      return addIssueToContext(A, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.bigint,
        received: A.parsedType
      }), INVALID;
    }
    let p;
    const a = new ParseStatus();
    for (const A of this._def.checks)
      A.kind === "min" ? (A.inclusive ? c.data < A.value : c.data <= A.value) && (p = this._getOrReturnCtx(c, p), addIssueToContext(p, {
        code: ZodIssueCode.too_small,
        type: "bigint",
        minimum: A.value,
        inclusive: A.inclusive,
        message: A.message
      }), a.dirty()) : A.kind === "max" ? (A.inclusive ? c.data > A.value : c.data >= A.value) && (p = this._getOrReturnCtx(c, p), addIssueToContext(p, {
        code: ZodIssueCode.too_big,
        type: "bigint",
        maximum: A.value,
        inclusive: A.inclusive,
        message: A.message
      }), a.dirty()) : A.kind === "multipleOf" ? c.data % A.value !== BigInt(0) && (p = this._getOrReturnCtx(c, p), addIssueToContext(p, {
        code: ZodIssueCode.not_multiple_of,
        multipleOf: A.value,
        message: A.message
      }), a.dirty()) : util.assertNever(A);
    return { status: a.value, value: c.data };
  }
  gte(c, u) {
    return this.setLimit("min", c, !0, errorUtil.toString(u));
  }
  gt(c, u) {
    return this.setLimit("min", c, !1, errorUtil.toString(u));
  }
  lte(c, u) {
    return this.setLimit("max", c, !0, errorUtil.toString(u));
  }
  lt(c, u) {
    return this.setLimit("max", c, !1, errorUtil.toString(u));
  }
  setLimit(c, u, p, a) {
    return new ZodBigInt({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: c,
          value: u,
          inclusive: p,
          message: errorUtil.toString(a)
        }
      ]
    });
  }
  _addCheck(c) {
    return new ZodBigInt({
      ...this._def,
      checks: [...this._def.checks, c]
    });
  }
  positive(c) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: errorUtil.toString(c)
    });
  }
  negative(c) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: errorUtil.toString(c)
    });
  }
  nonpositive(c) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: errorUtil.toString(c)
    });
  }
  nonnegative(c) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: errorUtil.toString(c)
    });
  }
  multipleOf(c, u) {
    return this._addCheck({
      kind: "multipleOf",
      value: c,
      message: errorUtil.toString(u)
    });
  }
  get minValue() {
    let c = null;
    for (const u of this._def.checks)
      u.kind === "min" && (c === null || u.value > c) && (c = u.value);
    return c;
  }
  get maxValue() {
    let c = null;
    for (const u of this._def.checks)
      u.kind === "max" && (c === null || u.value < c) && (c = u.value);
    return c;
  }
}
ZodBigInt.create = (n) => {
  var c;
  return new ZodBigInt({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodBigInt,
    coerce: (c = n == null ? void 0 : n.coerce) !== null && c !== void 0 ? c : !1,
    ...processCreateParams(n)
  });
};
class ZodBoolean extends ZodType {
  _parse(c) {
    if (this._def.coerce && (c.data = !!c.data), this._getType(c) !== ZodParsedType.boolean) {
      const p = this._getOrReturnCtx(c);
      return addIssueToContext(p, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.boolean,
        received: p.parsedType
      }), INVALID;
    }
    return OK(c.data);
  }
}
ZodBoolean.create = (n) => new ZodBoolean({
  typeName: ZodFirstPartyTypeKind.ZodBoolean,
  coerce: (n == null ? void 0 : n.coerce) || !1,
  ...processCreateParams(n)
});
class ZodDate extends ZodType {
  _parse(c) {
    if (this._def.coerce && (c.data = new Date(c.data)), this._getType(c) !== ZodParsedType.date) {
      const A = this._getOrReturnCtx(c);
      return addIssueToContext(A, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.date,
        received: A.parsedType
      }), INVALID;
    }
    if (isNaN(c.data.getTime())) {
      const A = this._getOrReturnCtx(c);
      return addIssueToContext(A, {
        code: ZodIssueCode.invalid_date
      }), INVALID;
    }
    const p = new ParseStatus();
    let a;
    for (const A of this._def.checks)
      A.kind === "min" ? c.data.getTime() < A.value && (a = this._getOrReturnCtx(c, a), addIssueToContext(a, {
        code: ZodIssueCode.too_small,
        message: A.message,
        inclusive: !0,
        exact: !1,
        minimum: A.value,
        type: "date"
      }), p.dirty()) : A.kind === "max" ? c.data.getTime() > A.value && (a = this._getOrReturnCtx(c, a), addIssueToContext(a, {
        code: ZodIssueCode.too_big,
        message: A.message,
        inclusive: !0,
        exact: !1,
        maximum: A.value,
        type: "date"
      }), p.dirty()) : util.assertNever(A);
    return {
      status: p.value,
      value: new Date(c.data.getTime())
    };
  }
  _addCheck(c) {
    return new ZodDate({
      ...this._def,
      checks: [...this._def.checks, c]
    });
  }
  min(c, u) {
    return this._addCheck({
      kind: "min",
      value: c.getTime(),
      message: errorUtil.toString(u)
    });
  }
  max(c, u) {
    return this._addCheck({
      kind: "max",
      value: c.getTime(),
      message: errorUtil.toString(u)
    });
  }
  get minDate() {
    let c = null;
    for (const u of this._def.checks)
      u.kind === "min" && (c === null || u.value > c) && (c = u.value);
    return c != null ? new Date(c) : null;
  }
  get maxDate() {
    let c = null;
    for (const u of this._def.checks)
      u.kind === "max" && (c === null || u.value < c) && (c = u.value);
    return c != null ? new Date(c) : null;
  }
}
ZodDate.create = (n) => new ZodDate({
  checks: [],
  coerce: (n == null ? void 0 : n.coerce) || !1,
  typeName: ZodFirstPartyTypeKind.ZodDate,
  ...processCreateParams(n)
});
class ZodSymbol extends ZodType {
  _parse(c) {
    if (this._getType(c) !== ZodParsedType.symbol) {
      const p = this._getOrReturnCtx(c);
      return addIssueToContext(p, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.symbol,
        received: p.parsedType
      }), INVALID;
    }
    return OK(c.data);
  }
}
ZodSymbol.create = (n) => new ZodSymbol({
  typeName: ZodFirstPartyTypeKind.ZodSymbol,
  ...processCreateParams(n)
});
class ZodUndefined extends ZodType {
  _parse(c) {
    if (this._getType(c) !== ZodParsedType.undefined) {
      const p = this._getOrReturnCtx(c);
      return addIssueToContext(p, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.undefined,
        received: p.parsedType
      }), INVALID;
    }
    return OK(c.data);
  }
}
ZodUndefined.create = (n) => new ZodUndefined({
  typeName: ZodFirstPartyTypeKind.ZodUndefined,
  ...processCreateParams(n)
});
class ZodNull extends ZodType {
  _parse(c) {
    if (this._getType(c) !== ZodParsedType.null) {
      const p = this._getOrReturnCtx(c);
      return addIssueToContext(p, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.null,
        received: p.parsedType
      }), INVALID;
    }
    return OK(c.data);
  }
}
ZodNull.create = (n) => new ZodNull({
  typeName: ZodFirstPartyTypeKind.ZodNull,
  ...processCreateParams(n)
});
class ZodAny extends ZodType {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(c) {
    return OK(c.data);
  }
}
ZodAny.create = (n) => new ZodAny({
  typeName: ZodFirstPartyTypeKind.ZodAny,
  ...processCreateParams(n)
});
class ZodUnknown extends ZodType {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(c) {
    return OK(c.data);
  }
}
ZodUnknown.create = (n) => new ZodUnknown({
  typeName: ZodFirstPartyTypeKind.ZodUnknown,
  ...processCreateParams(n)
});
class ZodNever extends ZodType {
  _parse(c) {
    const u = this._getOrReturnCtx(c);
    return addIssueToContext(u, {
      code: ZodIssueCode.invalid_type,
      expected: ZodParsedType.never,
      received: u.parsedType
    }), INVALID;
  }
}
ZodNever.create = (n) => new ZodNever({
  typeName: ZodFirstPartyTypeKind.ZodNever,
  ...processCreateParams(n)
});
class ZodVoid extends ZodType {
  _parse(c) {
    if (this._getType(c) !== ZodParsedType.undefined) {
      const p = this._getOrReturnCtx(c);
      return addIssueToContext(p, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.void,
        received: p.parsedType
      }), INVALID;
    }
    return OK(c.data);
  }
}
ZodVoid.create = (n) => new ZodVoid({
  typeName: ZodFirstPartyTypeKind.ZodVoid,
  ...processCreateParams(n)
});
class ZodArray extends ZodType {
  _parse(c) {
    const { ctx: u, status: p } = this._processInputParams(c), a = this._def;
    if (u.parsedType !== ZodParsedType.array)
      return addIssueToContext(u, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.array,
        received: u.parsedType
      }), INVALID;
    if (a.exactLength !== null) {
      const b = u.data.length > a.exactLength.value, F = u.data.length < a.exactLength.value;
      (b || F) && (addIssueToContext(u, {
        code: b ? ZodIssueCode.too_big : ZodIssueCode.too_small,
        minimum: F ? a.exactLength.value : void 0,
        maximum: b ? a.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: a.exactLength.message
      }), p.dirty());
    }
    if (a.minLength !== null && u.data.length < a.minLength.value && (addIssueToContext(u, {
      code: ZodIssueCode.too_small,
      minimum: a.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.minLength.message
    }), p.dirty()), a.maxLength !== null && u.data.length > a.maxLength.value && (addIssueToContext(u, {
      code: ZodIssueCode.too_big,
      maximum: a.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.maxLength.message
    }), p.dirty()), u.common.async)
      return Promise.all([...u.data].map((b, F) => a.type._parseAsync(new ParseInputLazyPath(u, b, u.path, F)))).then((b) => ParseStatus.mergeArray(p, b));
    const A = [...u.data].map((b, F) => a.type._parseSync(new ParseInputLazyPath(u, b, u.path, F)));
    return ParseStatus.mergeArray(p, A);
  }
  get element() {
    return this._def.type;
  }
  min(c, u) {
    return new ZodArray({
      ...this._def,
      minLength: { value: c, message: errorUtil.toString(u) }
    });
  }
  max(c, u) {
    return new ZodArray({
      ...this._def,
      maxLength: { value: c, message: errorUtil.toString(u) }
    });
  }
  length(c, u) {
    return new ZodArray({
      ...this._def,
      exactLength: { value: c, message: errorUtil.toString(u) }
    });
  }
  nonempty(c) {
    return this.min(1, c);
  }
}
ZodArray.create = (n, c) => new ZodArray({
  type: n,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: ZodFirstPartyTypeKind.ZodArray,
  ...processCreateParams(c)
});
function deepPartialify(n) {
  if (n instanceof ZodObject) {
    const c = {};
    for (const u in n.shape) {
      const p = n.shape[u];
      c[u] = ZodOptional.create(deepPartialify(p));
    }
    return new ZodObject({
      ...n._def,
      shape: () => c
    });
  } else return n instanceof ZodArray ? new ZodArray({
    ...n._def,
    type: deepPartialify(n.element)
  }) : n instanceof ZodOptional ? ZodOptional.create(deepPartialify(n.unwrap())) : n instanceof ZodNullable ? ZodNullable.create(deepPartialify(n.unwrap())) : n instanceof ZodTuple ? ZodTuple.create(n.items.map((c) => deepPartialify(c))) : n;
}
class ZodObject extends ZodType {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const c = this._def.shape(), u = util.objectKeys(c);
    return this._cached = { shape: c, keys: u };
  }
  _parse(c) {
    if (this._getType(c) !== ZodParsedType.object) {
      const L = this._getOrReturnCtx(c);
      return addIssueToContext(L, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: L.parsedType
      }), INVALID;
    }
    const { status: p, ctx: a } = this._processInputParams(c), { shape: A, keys: b } = this._getCached(), F = [];
    if (!(this._def.catchall instanceof ZodNever && this._def.unknownKeys === "strip"))
      for (const L in a.data)
        b.includes(L) || F.push(L);
    const le = [];
    for (const L of b) {
      const pe = A[L], $ = a.data[L];
      le.push({
        key: { status: "valid", value: L },
        value: pe._parse(new ParseInputLazyPath(a, $, a.path, L)),
        alwaysSet: L in a.data
      });
    }
    if (this._def.catchall instanceof ZodNever) {
      const L = this._def.unknownKeys;
      if (L === "passthrough")
        for (const pe of F)
          le.push({
            key: { status: "valid", value: pe },
            value: { status: "valid", value: a.data[pe] }
          });
      else if (L === "strict")
        F.length > 0 && (addIssueToContext(a, {
          code: ZodIssueCode.unrecognized_keys,
          keys: F
        }), p.dirty());
      else if (L !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const L = this._def.catchall;
      for (const pe of F) {
        const $ = a.data[pe];
        le.push({
          key: { status: "valid", value: pe },
          value: L._parse(
            new ParseInputLazyPath(a, $, a.path, pe)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: pe in a.data
        });
      }
    }
    return a.common.async ? Promise.resolve().then(async () => {
      const L = [];
      for (const pe of le) {
        const $ = await pe.key;
        L.push({
          key: $,
          value: await pe.value,
          alwaysSet: pe.alwaysSet
        });
      }
      return L;
    }).then((L) => ParseStatus.mergeObjectSync(p, L)) : ParseStatus.mergeObjectSync(p, le);
  }
  get shape() {
    return this._def.shape();
  }
  strict(c) {
    return new ZodObject({
      ...this._def,
      unknownKeys: "strict",
      ...c !== void 0 ? {
        errorMap: (u, p) => {
          var a, A, b, F;
          const le = (b = (A = (a = this._def).errorMap) === null || A === void 0 ? void 0 : A.call(a, u, p).message) !== null && b !== void 0 ? b : p.defaultError;
          return u.code === "unrecognized_keys" ? {
            message: (F = errorUtil.errToObj(c).message) !== null && F !== void 0 ? F : le
          } : {
            message: le
          };
        }
      } : {}
    });
  }
  strip() {
    return new ZodObject({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new ZodObject({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(c) {
    return new ZodObject({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...c
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(c) {
    return new ZodObject({
      unknownKeys: c._def.unknownKeys,
      catchall: c._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...c._def.shape()
      }),
      typeName: ZodFirstPartyTypeKind.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(c, u) {
    return this.augment({ [c]: u });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(c) {
    return new ZodObject({
      ...this._def,
      catchall: c
    });
  }
  pick(c) {
    const u = {};
    return util.objectKeys(c).forEach((p) => {
      c[p] && this.shape[p] && (u[p] = this.shape[p]);
    }), new ZodObject({
      ...this._def,
      shape: () => u
    });
  }
  omit(c) {
    const u = {};
    return util.objectKeys(this.shape).forEach((p) => {
      c[p] || (u[p] = this.shape[p]);
    }), new ZodObject({
      ...this._def,
      shape: () => u
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return deepPartialify(this);
  }
  partial(c) {
    const u = {};
    return util.objectKeys(this.shape).forEach((p) => {
      const a = this.shape[p];
      c && !c[p] ? u[p] = a : u[p] = a.optional();
    }), new ZodObject({
      ...this._def,
      shape: () => u
    });
  }
  required(c) {
    const u = {};
    return util.objectKeys(this.shape).forEach((p) => {
      if (c && !c[p])
        u[p] = this.shape[p];
      else {
        let A = this.shape[p];
        for (; A instanceof ZodOptional; )
          A = A._def.innerType;
        u[p] = A;
      }
    }), new ZodObject({
      ...this._def,
      shape: () => u
    });
  }
  keyof() {
    return createZodEnum(util.objectKeys(this.shape));
  }
}
ZodObject.create = (n, c) => new ZodObject({
  shape: () => n,
  unknownKeys: "strip",
  catchall: ZodNever.create(),
  typeName: ZodFirstPartyTypeKind.ZodObject,
  ...processCreateParams(c)
});
ZodObject.strictCreate = (n, c) => new ZodObject({
  shape: () => n,
  unknownKeys: "strict",
  catchall: ZodNever.create(),
  typeName: ZodFirstPartyTypeKind.ZodObject,
  ...processCreateParams(c)
});
ZodObject.lazycreate = (n, c) => new ZodObject({
  shape: n,
  unknownKeys: "strip",
  catchall: ZodNever.create(),
  typeName: ZodFirstPartyTypeKind.ZodObject,
  ...processCreateParams(c)
});
class ZodUnion extends ZodType {
  _parse(c) {
    const { ctx: u } = this._processInputParams(c), p = this._def.options;
    function a(A) {
      for (const F of A)
        if (F.result.status === "valid")
          return F.result;
      for (const F of A)
        if (F.result.status === "dirty")
          return u.common.issues.push(...F.ctx.common.issues), F.result;
      const b = A.map((F) => new ZodError(F.ctx.common.issues));
      return addIssueToContext(u, {
        code: ZodIssueCode.invalid_union,
        unionErrors: b
      }), INVALID;
    }
    if (u.common.async)
      return Promise.all(p.map(async (A) => {
        const b = {
          ...u,
          common: {
            ...u.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await A._parseAsync({
            data: u.data,
            path: u.path,
            parent: b
          }),
          ctx: b
        };
      })).then(a);
    {
      let A;
      const b = [];
      for (const le of p) {
        const L = {
          ...u,
          common: {
            ...u.common,
            issues: []
          },
          parent: null
        }, pe = le._parseSync({
          data: u.data,
          path: u.path,
          parent: L
        });
        if (pe.status === "valid")
          return pe;
        pe.status === "dirty" && !A && (A = { result: pe, ctx: L }), L.common.issues.length && b.push(L.common.issues);
      }
      if (A)
        return u.common.issues.push(...A.ctx.common.issues), A.result;
      const F = b.map((le) => new ZodError(le));
      return addIssueToContext(u, {
        code: ZodIssueCode.invalid_union,
        unionErrors: F
      }), INVALID;
    }
  }
  get options() {
    return this._def.options;
  }
}
ZodUnion.create = (n, c) => new ZodUnion({
  options: n,
  typeName: ZodFirstPartyTypeKind.ZodUnion,
  ...processCreateParams(c)
});
const getDiscriminator = (n) => n instanceof ZodLazy ? getDiscriminator(n.schema) : n instanceof ZodEffects ? getDiscriminator(n.innerType()) : n instanceof ZodLiteral ? [n.value] : n instanceof ZodEnum ? n.options : n instanceof ZodNativeEnum ? Object.keys(n.enum) : n instanceof ZodDefault ? getDiscriminator(n._def.innerType) : n instanceof ZodUndefined ? [void 0] : n instanceof ZodNull ? [null] : null;
class ZodDiscriminatedUnion extends ZodType {
  _parse(c) {
    const { ctx: u } = this._processInputParams(c);
    if (u.parsedType !== ZodParsedType.object)
      return addIssueToContext(u, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: u.parsedType
      }), INVALID;
    const p = this.discriminator, a = u.data[p], A = this.optionsMap.get(a);
    return A ? u.common.async ? A._parseAsync({
      data: u.data,
      path: u.path,
      parent: u
    }) : A._parseSync({
      data: u.data,
      path: u.path,
      parent: u
    }) : (addIssueToContext(u, {
      code: ZodIssueCode.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [p]
    }), INVALID);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(c, u, p) {
    const a = /* @__PURE__ */ new Map();
    for (const A of u) {
      const b = getDiscriminator(A.shape[c]);
      if (!b)
        throw new Error(`A discriminator value for key \`${c}\` could not be extracted from all schema options`);
      for (const F of b) {
        if (a.has(F))
          throw new Error(`Discriminator property ${String(c)} has duplicate value ${String(F)}`);
        a.set(F, A);
      }
    }
    return new ZodDiscriminatedUnion({
      typeName: ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
      discriminator: c,
      options: u,
      optionsMap: a,
      ...processCreateParams(p)
    });
  }
}
function mergeValues(n, c) {
  const u = getParsedType(n), p = getParsedType(c);
  if (n === c)
    return { valid: !0, data: n };
  if (u === ZodParsedType.object && p === ZodParsedType.object) {
    const a = util.objectKeys(c), A = util.objectKeys(n).filter((F) => a.indexOf(F) !== -1), b = { ...n, ...c };
    for (const F of A) {
      const le = mergeValues(n[F], c[F]);
      if (!le.valid)
        return { valid: !1 };
      b[F] = le.data;
    }
    return { valid: !0, data: b };
  } else if (u === ZodParsedType.array && p === ZodParsedType.array) {
    if (n.length !== c.length)
      return { valid: !1 };
    const a = [];
    for (let A = 0; A < n.length; A++) {
      const b = n[A], F = c[A], le = mergeValues(b, F);
      if (!le.valid)
        return { valid: !1 };
      a.push(le.data);
    }
    return { valid: !0, data: a };
  } else return u === ZodParsedType.date && p === ZodParsedType.date && +n == +c ? { valid: !0, data: n } : { valid: !1 };
}
class ZodIntersection extends ZodType {
  _parse(c) {
    const { status: u, ctx: p } = this._processInputParams(c), a = (A, b) => {
      if (isAborted(A) || isAborted(b))
        return INVALID;
      const F = mergeValues(A.value, b.value);
      return F.valid ? ((isDirty(A) || isDirty(b)) && u.dirty(), { status: u.value, value: F.data }) : (addIssueToContext(p, {
        code: ZodIssueCode.invalid_intersection_types
      }), INVALID);
    };
    return p.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: p.data,
        path: p.path,
        parent: p
      }),
      this._def.right._parseAsync({
        data: p.data,
        path: p.path,
        parent: p
      })
    ]).then(([A, b]) => a(A, b)) : a(this._def.left._parseSync({
      data: p.data,
      path: p.path,
      parent: p
    }), this._def.right._parseSync({
      data: p.data,
      path: p.path,
      parent: p
    }));
  }
}
ZodIntersection.create = (n, c, u) => new ZodIntersection({
  left: n,
  right: c,
  typeName: ZodFirstPartyTypeKind.ZodIntersection,
  ...processCreateParams(u)
});
class ZodTuple extends ZodType {
  _parse(c) {
    const { status: u, ctx: p } = this._processInputParams(c);
    if (p.parsedType !== ZodParsedType.array)
      return addIssueToContext(p, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.array,
        received: p.parsedType
      }), INVALID;
    if (p.data.length < this._def.items.length)
      return addIssueToContext(p, {
        code: ZodIssueCode.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), INVALID;
    !this._def.rest && p.data.length > this._def.items.length && (addIssueToContext(p, {
      code: ZodIssueCode.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), u.dirty());
    const A = [...p.data].map((b, F) => {
      const le = this._def.items[F] || this._def.rest;
      return le ? le._parse(new ParseInputLazyPath(p, b, p.path, F)) : null;
    }).filter((b) => !!b);
    return p.common.async ? Promise.all(A).then((b) => ParseStatus.mergeArray(u, b)) : ParseStatus.mergeArray(u, A);
  }
  get items() {
    return this._def.items;
  }
  rest(c) {
    return new ZodTuple({
      ...this._def,
      rest: c
    });
  }
}
ZodTuple.create = (n, c) => {
  if (!Array.isArray(n))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new ZodTuple({
    items: n,
    typeName: ZodFirstPartyTypeKind.ZodTuple,
    rest: null,
    ...processCreateParams(c)
  });
};
class ZodRecord extends ZodType {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(c) {
    const { status: u, ctx: p } = this._processInputParams(c);
    if (p.parsedType !== ZodParsedType.object)
      return addIssueToContext(p, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: p.parsedType
      }), INVALID;
    const a = [], A = this._def.keyType, b = this._def.valueType;
    for (const F in p.data)
      a.push({
        key: A._parse(new ParseInputLazyPath(p, F, p.path, F)),
        value: b._parse(new ParseInputLazyPath(p, p.data[F], p.path, F))
      });
    return p.common.async ? ParseStatus.mergeObjectAsync(u, a) : ParseStatus.mergeObjectSync(u, a);
  }
  get element() {
    return this._def.valueType;
  }
  static create(c, u, p) {
    return u instanceof ZodType ? new ZodRecord({
      keyType: c,
      valueType: u,
      typeName: ZodFirstPartyTypeKind.ZodRecord,
      ...processCreateParams(p)
    }) : new ZodRecord({
      keyType: ZodString.create(),
      valueType: c,
      typeName: ZodFirstPartyTypeKind.ZodRecord,
      ...processCreateParams(u)
    });
  }
}
class ZodMap extends ZodType {
  _parse(c) {
    const { status: u, ctx: p } = this._processInputParams(c);
    if (p.parsedType !== ZodParsedType.map)
      return addIssueToContext(p, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.map,
        received: p.parsedType
      }), INVALID;
    const a = this._def.keyType, A = this._def.valueType, b = [...p.data.entries()].map(([F, le], L) => ({
      key: a._parse(new ParseInputLazyPath(p, F, p.path, [L, "key"])),
      value: A._parse(new ParseInputLazyPath(p, le, p.path, [L, "value"]))
    }));
    if (p.common.async) {
      const F = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const le of b) {
          const L = await le.key, pe = await le.value;
          if (L.status === "aborted" || pe.status === "aborted")
            return INVALID;
          (L.status === "dirty" || pe.status === "dirty") && u.dirty(), F.set(L.value, pe.value);
        }
        return { status: u.value, value: F };
      });
    } else {
      const F = /* @__PURE__ */ new Map();
      for (const le of b) {
        const L = le.key, pe = le.value;
        if (L.status === "aborted" || pe.status === "aborted")
          return INVALID;
        (L.status === "dirty" || pe.status === "dirty") && u.dirty(), F.set(L.value, pe.value);
      }
      return { status: u.value, value: F };
    }
  }
}
ZodMap.create = (n, c, u) => new ZodMap({
  valueType: c,
  keyType: n,
  typeName: ZodFirstPartyTypeKind.ZodMap,
  ...processCreateParams(u)
});
class ZodSet extends ZodType {
  _parse(c) {
    const { status: u, ctx: p } = this._processInputParams(c);
    if (p.parsedType !== ZodParsedType.set)
      return addIssueToContext(p, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.set,
        received: p.parsedType
      }), INVALID;
    const a = this._def;
    a.minSize !== null && p.data.size < a.minSize.value && (addIssueToContext(p, {
      code: ZodIssueCode.too_small,
      minimum: a.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.minSize.message
    }), u.dirty()), a.maxSize !== null && p.data.size > a.maxSize.value && (addIssueToContext(p, {
      code: ZodIssueCode.too_big,
      maximum: a.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.maxSize.message
    }), u.dirty());
    const A = this._def.valueType;
    function b(le) {
      const L = /* @__PURE__ */ new Set();
      for (const pe of le) {
        if (pe.status === "aborted")
          return INVALID;
        pe.status === "dirty" && u.dirty(), L.add(pe.value);
      }
      return { status: u.value, value: L };
    }
    const F = [...p.data.values()].map((le, L) => A._parse(new ParseInputLazyPath(p, le, p.path, L)));
    return p.common.async ? Promise.all(F).then((le) => b(le)) : b(F);
  }
  min(c, u) {
    return new ZodSet({
      ...this._def,
      minSize: { value: c, message: errorUtil.toString(u) }
    });
  }
  max(c, u) {
    return new ZodSet({
      ...this._def,
      maxSize: { value: c, message: errorUtil.toString(u) }
    });
  }
  size(c, u) {
    return this.min(c, u).max(c, u);
  }
  nonempty(c) {
    return this.min(1, c);
  }
}
ZodSet.create = (n, c) => new ZodSet({
  valueType: n,
  minSize: null,
  maxSize: null,
  typeName: ZodFirstPartyTypeKind.ZodSet,
  ...processCreateParams(c)
});
class ZodFunction extends ZodType {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(c) {
    const { ctx: u } = this._processInputParams(c);
    if (u.parsedType !== ZodParsedType.function)
      return addIssueToContext(u, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.function,
        received: u.parsedType
      }), INVALID;
    function p(F, le) {
      return makeIssue({
        data: F,
        path: u.path,
        errorMaps: [
          u.common.contextualErrorMap,
          u.schemaErrorMap,
          getErrorMap(),
          errorMap
        ].filter((L) => !!L),
        issueData: {
          code: ZodIssueCode.invalid_arguments,
          argumentsError: le
        }
      });
    }
    function a(F, le) {
      return makeIssue({
        data: F,
        path: u.path,
        errorMaps: [
          u.common.contextualErrorMap,
          u.schemaErrorMap,
          getErrorMap(),
          errorMap
        ].filter((L) => !!L),
        issueData: {
          code: ZodIssueCode.invalid_return_type,
          returnTypeError: le
        }
      });
    }
    const A = { errorMap: u.common.contextualErrorMap }, b = u.data;
    return this._def.returns instanceof ZodPromise ? OK(async (...F) => {
      const le = new ZodError([]), L = await this._def.args.parseAsync(F, A).catch((Ee) => {
        throw le.addIssue(p(F, Ee)), le;
      }), pe = await b(...L);
      return await this._def.returns._def.type.parseAsync(pe, A).catch((Ee) => {
        throw le.addIssue(a(pe, Ee)), le;
      });
    }) : OK((...F) => {
      const le = this._def.args.safeParse(F, A);
      if (!le.success)
        throw new ZodError([p(F, le.error)]);
      const L = b(...le.data), pe = this._def.returns.safeParse(L, A);
      if (!pe.success)
        throw new ZodError([a(L, pe.error)]);
      return pe.data;
    });
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...c) {
    return new ZodFunction({
      ...this._def,
      args: ZodTuple.create(c).rest(ZodUnknown.create())
    });
  }
  returns(c) {
    return new ZodFunction({
      ...this._def,
      returns: c
    });
  }
  implement(c) {
    return this.parse(c);
  }
  strictImplement(c) {
    return this.parse(c);
  }
  static create(c, u, p) {
    return new ZodFunction({
      args: c || ZodTuple.create([]).rest(ZodUnknown.create()),
      returns: u || ZodUnknown.create(),
      typeName: ZodFirstPartyTypeKind.ZodFunction,
      ...processCreateParams(p)
    });
  }
}
class ZodLazy extends ZodType {
  get schema() {
    return this._def.getter();
  }
  _parse(c) {
    const { ctx: u } = this._processInputParams(c);
    return this._def.getter()._parse({ data: u.data, path: u.path, parent: u });
  }
}
ZodLazy.create = (n, c) => new ZodLazy({
  getter: n,
  typeName: ZodFirstPartyTypeKind.ZodLazy,
  ...processCreateParams(c)
});
class ZodLiteral extends ZodType {
  _parse(c) {
    if (c.data !== this._def.value) {
      const u = this._getOrReturnCtx(c);
      return addIssueToContext(u, {
        received: u.data,
        code: ZodIssueCode.invalid_literal,
        expected: this._def.value
      }), INVALID;
    }
    return { status: "valid", value: c.data };
  }
  get value() {
    return this._def.value;
  }
}
ZodLiteral.create = (n, c) => new ZodLiteral({
  value: n,
  typeName: ZodFirstPartyTypeKind.ZodLiteral,
  ...processCreateParams(c)
});
function createZodEnum(n, c) {
  return new ZodEnum({
    values: n,
    typeName: ZodFirstPartyTypeKind.ZodEnum,
    ...processCreateParams(c)
  });
}
class ZodEnum extends ZodType {
  _parse(c) {
    if (typeof c.data != "string") {
      const u = this._getOrReturnCtx(c), p = this._def.values;
      return addIssueToContext(u, {
        expected: util.joinValues(p),
        received: u.parsedType,
        code: ZodIssueCode.invalid_type
      }), INVALID;
    }
    if (this._def.values.indexOf(c.data) === -1) {
      const u = this._getOrReturnCtx(c), p = this._def.values;
      return addIssueToContext(u, {
        received: u.data,
        code: ZodIssueCode.invalid_enum_value,
        options: p
      }), INVALID;
    }
    return OK(c.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const c = {};
    for (const u of this._def.values)
      c[u] = u;
    return c;
  }
  get Values() {
    const c = {};
    for (const u of this._def.values)
      c[u] = u;
    return c;
  }
  get Enum() {
    const c = {};
    for (const u of this._def.values)
      c[u] = u;
    return c;
  }
  extract(c) {
    return ZodEnum.create(c);
  }
  exclude(c) {
    return ZodEnum.create(this.options.filter((u) => !c.includes(u)));
  }
}
ZodEnum.create = createZodEnum;
class ZodNativeEnum extends ZodType {
  _parse(c) {
    const u = util.getValidEnumValues(this._def.values), p = this._getOrReturnCtx(c);
    if (p.parsedType !== ZodParsedType.string && p.parsedType !== ZodParsedType.number) {
      const a = util.objectValues(u);
      return addIssueToContext(p, {
        expected: util.joinValues(a),
        received: p.parsedType,
        code: ZodIssueCode.invalid_type
      }), INVALID;
    }
    if (u.indexOf(c.data) === -1) {
      const a = util.objectValues(u);
      return addIssueToContext(p, {
        received: p.data,
        code: ZodIssueCode.invalid_enum_value,
        options: a
      }), INVALID;
    }
    return OK(c.data);
  }
  get enum() {
    return this._def.values;
  }
}
ZodNativeEnum.create = (n, c) => new ZodNativeEnum({
  values: n,
  typeName: ZodFirstPartyTypeKind.ZodNativeEnum,
  ...processCreateParams(c)
});
class ZodPromise extends ZodType {
  unwrap() {
    return this._def.type;
  }
  _parse(c) {
    const { ctx: u } = this._processInputParams(c);
    if (u.parsedType !== ZodParsedType.promise && u.common.async === !1)
      return addIssueToContext(u, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.promise,
        received: u.parsedType
      }), INVALID;
    const p = u.parsedType === ZodParsedType.promise ? u.data : Promise.resolve(u.data);
    return OK(p.then((a) => this._def.type.parseAsync(a, {
      path: u.path,
      errorMap: u.common.contextualErrorMap
    })));
  }
}
ZodPromise.create = (n, c) => new ZodPromise({
  type: n,
  typeName: ZodFirstPartyTypeKind.ZodPromise,
  ...processCreateParams(c)
});
class ZodEffects extends ZodType {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === ZodFirstPartyTypeKind.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(c) {
    const { status: u, ctx: p } = this._processInputParams(c), a = this._def.effect || null;
    if (a.type === "preprocess") {
      const b = a.transform(p.data);
      return p.common.async ? Promise.resolve(b).then((F) => this._def.schema._parseAsync({
        data: F,
        path: p.path,
        parent: p
      })) : this._def.schema._parseSync({
        data: b,
        path: p.path,
        parent: p
      });
    }
    const A = {
      addIssue: (b) => {
        addIssueToContext(p, b), b.fatal ? u.abort() : u.dirty();
      },
      get path() {
        return p.path;
      }
    };
    if (A.addIssue = A.addIssue.bind(A), a.type === "refinement") {
      const b = (F) => {
        const le = a.refinement(F, A);
        if (p.common.async)
          return Promise.resolve(le);
        if (le instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return F;
      };
      if (p.common.async === !1) {
        const F = this._def.schema._parseSync({
          data: p.data,
          path: p.path,
          parent: p
        });
        return F.status === "aborted" ? INVALID : (F.status === "dirty" && u.dirty(), b(F.value), { status: u.value, value: F.value });
      } else
        return this._def.schema._parseAsync({ data: p.data, path: p.path, parent: p }).then((F) => F.status === "aborted" ? INVALID : (F.status === "dirty" && u.dirty(), b(F.value).then(() => ({ status: u.value, value: F.value }))));
    }
    if (a.type === "transform")
      if (p.common.async === !1) {
        const b = this._def.schema._parseSync({
          data: p.data,
          path: p.path,
          parent: p
        });
        if (!isValid(b))
          return b;
        const F = a.transform(b.value, A);
        if (F instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: u.value, value: F };
      } else
        return this._def.schema._parseAsync({ data: p.data, path: p.path, parent: p }).then((b) => isValid(b) ? Promise.resolve(a.transform(b.value, A)).then((F) => ({ status: u.value, value: F })) : b);
    util.assertNever(a);
  }
}
ZodEffects.create = (n, c, u) => new ZodEffects({
  schema: n,
  typeName: ZodFirstPartyTypeKind.ZodEffects,
  effect: c,
  ...processCreateParams(u)
});
ZodEffects.createWithPreprocess = (n, c, u) => new ZodEffects({
  schema: c,
  effect: { type: "preprocess", transform: n },
  typeName: ZodFirstPartyTypeKind.ZodEffects,
  ...processCreateParams(u)
});
class ZodOptional extends ZodType {
  _parse(c) {
    return this._getType(c) === ZodParsedType.undefined ? OK(void 0) : this._def.innerType._parse(c);
  }
  unwrap() {
    return this._def.innerType;
  }
}
ZodOptional.create = (n, c) => new ZodOptional({
  innerType: n,
  typeName: ZodFirstPartyTypeKind.ZodOptional,
  ...processCreateParams(c)
});
class ZodNullable extends ZodType {
  _parse(c) {
    return this._getType(c) === ZodParsedType.null ? OK(null) : this._def.innerType._parse(c);
  }
  unwrap() {
    return this._def.innerType;
  }
}
ZodNullable.create = (n, c) => new ZodNullable({
  innerType: n,
  typeName: ZodFirstPartyTypeKind.ZodNullable,
  ...processCreateParams(c)
});
class ZodDefault extends ZodType {
  _parse(c) {
    const { ctx: u } = this._processInputParams(c);
    let p = u.data;
    return u.parsedType === ZodParsedType.undefined && (p = this._def.defaultValue()), this._def.innerType._parse({
      data: p,
      path: u.path,
      parent: u
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
ZodDefault.create = (n, c) => new ZodDefault({
  innerType: n,
  typeName: ZodFirstPartyTypeKind.ZodDefault,
  defaultValue: typeof c.default == "function" ? c.default : () => c.default,
  ...processCreateParams(c)
});
class ZodCatch extends ZodType {
  _parse(c) {
    const { ctx: u } = this._processInputParams(c), p = {
      ...u,
      common: {
        ...u.common,
        issues: []
      }
    }, a = this._def.innerType._parse({
      data: p.data,
      path: p.path,
      parent: {
        ...p
      }
    });
    return isAsync(a) ? a.then((A) => ({
      status: "valid",
      value: A.status === "valid" ? A.value : this._def.catchValue({
        get error() {
          return new ZodError(p.common.issues);
        },
        input: p.data
      })
    })) : {
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new ZodError(p.common.issues);
        },
        input: p.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
ZodCatch.create = (n, c) => new ZodCatch({
  innerType: n,
  typeName: ZodFirstPartyTypeKind.ZodCatch,
  catchValue: typeof c.catch == "function" ? c.catch : () => c.catch,
  ...processCreateParams(c)
});
class ZodNaN extends ZodType {
  _parse(c) {
    if (this._getType(c) !== ZodParsedType.nan) {
      const p = this._getOrReturnCtx(c);
      return addIssueToContext(p, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.nan,
        received: p.parsedType
      }), INVALID;
    }
    return { status: "valid", value: c.data };
  }
}
ZodNaN.create = (n) => new ZodNaN({
  typeName: ZodFirstPartyTypeKind.ZodNaN,
  ...processCreateParams(n)
});
const BRAND = Symbol("zod_brand");
class ZodBranded extends ZodType {
  _parse(c) {
    const { ctx: u } = this._processInputParams(c), p = u.data;
    return this._def.type._parse({
      data: p,
      path: u.path,
      parent: u
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class ZodPipeline extends ZodType {
  _parse(c) {
    const { status: u, ctx: p } = this._processInputParams(c);
    if (p.common.async)
      return (async () => {
        const A = await this._def.in._parseAsync({
          data: p.data,
          path: p.path,
          parent: p
        });
        return A.status === "aborted" ? INVALID : A.status === "dirty" ? (u.dirty(), DIRTY(A.value)) : this._def.out._parseAsync({
          data: A.value,
          path: p.path,
          parent: p
        });
      })();
    {
      const a = this._def.in._parseSync({
        data: p.data,
        path: p.path,
        parent: p
      });
      return a.status === "aborted" ? INVALID : a.status === "dirty" ? (u.dirty(), {
        status: "dirty",
        value: a.value
      }) : this._def.out._parseSync({
        data: a.value,
        path: p.path,
        parent: p
      });
    }
  }
  static create(c, u) {
    return new ZodPipeline({
      in: c,
      out: u,
      typeName: ZodFirstPartyTypeKind.ZodPipeline
    });
  }
}
const custom = (n, c = {}, u) => n ? ZodAny.create().superRefine((p, a) => {
  var A, b;
  if (!n(p)) {
    const F = typeof c == "function" ? c(p) : typeof c == "string" ? { message: c } : c, le = (b = (A = F.fatal) !== null && A !== void 0 ? A : u) !== null && b !== void 0 ? b : !0, L = typeof F == "string" ? { message: F } : F;
    a.addIssue({ code: "custom", ...L, fatal: le });
  }
}) : ZodAny.create(), late = {
  object: ZodObject.lazycreate
};
var ZodFirstPartyTypeKind;
(function(n) {
  n.ZodString = "ZodString", n.ZodNumber = "ZodNumber", n.ZodNaN = "ZodNaN", n.ZodBigInt = "ZodBigInt", n.ZodBoolean = "ZodBoolean", n.ZodDate = "ZodDate", n.ZodSymbol = "ZodSymbol", n.ZodUndefined = "ZodUndefined", n.ZodNull = "ZodNull", n.ZodAny = "ZodAny", n.ZodUnknown = "ZodUnknown", n.ZodNever = "ZodNever", n.ZodVoid = "ZodVoid", n.ZodArray = "ZodArray", n.ZodObject = "ZodObject", n.ZodUnion = "ZodUnion", n.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", n.ZodIntersection = "ZodIntersection", n.ZodTuple = "ZodTuple", n.ZodRecord = "ZodRecord", n.ZodMap = "ZodMap", n.ZodSet = "ZodSet", n.ZodFunction = "ZodFunction", n.ZodLazy = "ZodLazy", n.ZodLiteral = "ZodLiteral", n.ZodEnum = "ZodEnum", n.ZodEffects = "ZodEffects", n.ZodNativeEnum = "ZodNativeEnum", n.ZodOptional = "ZodOptional", n.ZodNullable = "ZodNullable", n.ZodDefault = "ZodDefault", n.ZodCatch = "ZodCatch", n.ZodPromise = "ZodPromise", n.ZodBranded = "ZodBranded", n.ZodPipeline = "ZodPipeline";
})(ZodFirstPartyTypeKind || (ZodFirstPartyTypeKind = {}));
const instanceOfType = (n, c = {
  message: `Input not instance of ${n.name}`
}) => custom((u) => u instanceof n, c), stringType = ZodString.create, numberType = ZodNumber.create, nanType = ZodNaN.create, bigIntType = ZodBigInt.create, booleanType = ZodBoolean.create, dateType = ZodDate.create, symbolType = ZodSymbol.create, undefinedType = ZodUndefined.create, nullType = ZodNull.create, anyType = ZodAny.create, unknownType = ZodUnknown.create, neverType = ZodNever.create, voidType = ZodVoid.create, arrayType = ZodArray.create, objectType = ZodObject.create, strictObjectType = ZodObject.strictCreate, unionType = ZodUnion.create, discriminatedUnionType = ZodDiscriminatedUnion.create, intersectionType = ZodIntersection.create, tupleType = ZodTuple.create, recordType = ZodRecord.create, mapType = ZodMap.create, setType = ZodSet.create, functionType = ZodFunction.create, lazyType = ZodLazy.create, literalType = ZodLiteral.create, enumType = ZodEnum.create, nativeEnumType = ZodNativeEnum.create, promiseType = ZodPromise.create, effectsType = ZodEffects.create, optionalType = ZodOptional.create, nullableType = ZodNullable.create, preprocessType = ZodEffects.createWithPreprocess, pipelineType = ZodPipeline.create, ostring = () => stringType().optional(), onumber = () => numberType().optional(), oboolean = () => booleanType().optional(), coerce = {
  string: (n) => ZodString.create({ ...n, coerce: !0 }),
  number: (n) => ZodNumber.create({ ...n, coerce: !0 }),
  boolean: (n) => ZodBoolean.create({
    ...n,
    coerce: !0
  }),
  bigint: (n) => ZodBigInt.create({ ...n, coerce: !0 }),
  date: (n) => ZodDate.create({ ...n, coerce: !0 })
}, NEVER = INVALID;
var z = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: errorMap,
  setErrorMap,
  getErrorMap,
  makeIssue,
  EMPTY_PATH,
  addIssueToContext,
  ParseStatus,
  INVALID,
  DIRTY,
  OK,
  isAborted,
  isDirty,
  isValid,
  isAsync,
  get util() {
    return util;
  },
  get objectUtil() {
    return objectUtil;
  },
  ZodParsedType,
  getParsedType,
  ZodType,
  ZodString,
  ZodNumber,
  ZodBigInt,
  ZodBoolean,
  ZodDate,
  ZodSymbol,
  ZodUndefined,
  ZodNull,
  ZodAny,
  ZodUnknown,
  ZodNever,
  ZodVoid,
  ZodArray,
  ZodObject,
  ZodUnion,
  ZodDiscriminatedUnion,
  ZodIntersection,
  ZodTuple,
  ZodRecord,
  ZodMap,
  ZodSet,
  ZodFunction,
  ZodLazy,
  ZodLiteral,
  ZodEnum,
  ZodNativeEnum,
  ZodPromise,
  ZodEffects,
  ZodTransformer: ZodEffects,
  ZodOptional,
  ZodNullable,
  ZodDefault,
  ZodCatch,
  ZodNaN,
  BRAND,
  ZodBranded,
  ZodPipeline,
  custom,
  Schema: ZodType,
  ZodSchema: ZodType,
  late,
  get ZodFirstPartyTypeKind() {
    return ZodFirstPartyTypeKind;
  },
  coerce,
  any: anyType,
  array: arrayType,
  bigint: bigIntType,
  boolean: booleanType,
  date: dateType,
  discriminatedUnion: discriminatedUnionType,
  effect: effectsType,
  enum: enumType,
  function: functionType,
  instanceof: instanceOfType,
  intersection: intersectionType,
  lazy: lazyType,
  literal: literalType,
  map: mapType,
  nan: nanType,
  nativeEnum: nativeEnumType,
  never: neverType,
  null: nullType,
  nullable: nullableType,
  number: numberType,
  object: objectType,
  oboolean,
  onumber,
  optional: optionalType,
  ostring,
  pipeline: pipelineType,
  preprocess: preprocessType,
  promise: promiseType,
  record: recordType,
  set: setType,
  strictObject: strictObjectType,
  string: stringType,
  symbol: symbolType,
  transformer: effectsType,
  tuple: tupleType,
  undefined: undefinedType,
  union: unionType,
  unknown: unknownType,
  void: voidType,
  NEVER,
  ZodIssueCode,
  quotelessJson,
  ZodError
});
const hexstr = z.string().regex(/^[a-fA-F0-9]$/), hash = z.string().regex(/^[a-fA-F0-9]{64}$/), uint32 = z.number().min(0).max(4294967295), uint64 = z.bigint(), byteArr = z.instanceof(Uint8Array), asmcode = z.union([hexstr, uint32, z.string(), byteArr]).array(), script = z.union([asmcode, hexstr, byteArr]), witness = z.array(script), TxOutput = z.object({
  value: z.union([uint32, uint64]),
  scriptPubKey: script
}), TxInput = z.object({
  txid: hash,
  vout: uint32,
  scriptSig: script,
  sequence: uint32,
  prevout: TxOutput.optional(),
  witness
}), TxData = z.object({
  version: uint32,
  vin: z.array(TxInput),
  vout: z.array(TxOutput),
  locktime: uint32
}), Schema = {
  TxData,
  TxInput,
  TxOutput,
  witness,
  script,
  hexstr,
  hash,
  uint32,
  uint64
};
class Transaction {
  constructor(c) {
    typeof c == "string" && (c = Buff$1.hex(c)), c instanceof Uint8Array && (c = Tx.decode(c));
    const u = Schema.TxData;
    this._data = u.parse(Tx.create(c));
  }
  get data() {
    return this._data;
  }
  get version() {
    return this.data.version;
  }
  get vin() {
    return this.data.vin.map((c, u) => new TxInput$1(this.data, u));
  }
  get vout() {
    return this.data.vout.map((c) => new TxOutput$1(c));
  }
  get locktime() {
    return new TxLocktime(this.data.locktime);
  }
  get base() {
    return Tx.encode(this.data, !0);
  }
  get buff() {
    return Tx.encode(this.data);
  }
  get raw() {
    return this.buff.raw;
  }
  get hex() {
    return this.buff.hex;
  }
  get size() {
    return this.raw.length;
  }
  get bsize() {
    return this.base.length;
  }
  get weight() {
    return this.bsize * 3 + this.size;
  }
  get vsize() {
    const c = this.weight % 4 > 0 ? 1 : 0;
    return Math.floor(this.weight / 4) + c;
  }
  get hash() {
    return hash256$3(this.buff).reverse().hex;
  }
  get txid() {
    return hash256$3(this.base).reverse().hex;
  }
  async export() {
    const { size: c, weight: u, vsize: p, hex: a } = this, A = this.txid, b = this.hash;
    return { txid: A, hash: b, ...this.data, size: c, weight: u, vsize: p, hex: a };
  }
}
main.Address = Address;
main.Input = TxInput$1;
main.Output = TxOutput$1;
main.Script = Script;
main.Sequence = TxSequence;
main.Signer = Signer;
main.Tap = Tap;
main.Transaction = Transaction;
main.Tx = Tx;
main.Witness = TxWitness;
var build = {}, ascii = {};
Object.defineProperty(ascii, "__esModule", { value: !0 });
ascii.fromAscii = ascii.toAscii = void 0;
function toAscii(n) {
  const c = (u) => u.split("").map((p) => {
    const a = p.charCodeAt(0);
    if (a < 32 || a > 126)
      throw new Error("Cannot encode character that is out of printable ASCII range: " + a);
    return a;
  });
  return Uint8Array.from(c(n));
}
ascii.toAscii = toAscii;
function fromAscii(n) {
  return ((u) => u.map((p) => {
    if (p < 32 || p > 126)
      throw new Error("Cannot decode character that is out of printable ASCII range: " + p);
    return String.fromCharCode(p);
  }))(Array.from(n)).join("");
}
ascii.fromAscii = fromAscii;
var base64 = {}, __createBinding$3 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(n, c, u, p) {
  p === void 0 && (p = u);
  var a = Object.getOwnPropertyDescriptor(c, u);
  (!a || ("get" in a ? !c.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
    return c[u];
  } }), Object.defineProperty(n, p, a);
} : function(n, c, u, p) {
  p === void 0 && (p = u), n[p] = c[u];
}), __setModuleDefault$3 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(n, c) {
  Object.defineProperty(n, "default", { enumerable: !0, value: c });
} : function(n, c) {
  n.default = c;
}), __importStar$3 = commonjsGlobal && commonjsGlobal.__importStar || function(n) {
  if (n && n.__esModule) return n;
  var c = {};
  if (n != null) for (var u in n) u !== "default" && Object.prototype.hasOwnProperty.call(n, u) && __createBinding$3(c, n, u);
  return __setModuleDefault$3(c, n), c;
};
Object.defineProperty(base64, "__esModule", { value: !0 });
base64.fromBase64 = base64.toBase64 = void 0;
const base64js = __importStar$3(base64Js);
function toBase64(n) {
  return base64js.fromByteArray(n);
}
base64.toBase64 = toBase64;
function fromBase64(n) {
  if (!n.match(/^[a-zA-Z0-9+/]*={0,2}$/))
    throw new Error("Invalid base64 string format");
  return base64js.toByteArray(n);
}
base64.fromBase64 = fromBase64;
var bech32$1 = {}, __createBinding$2 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(n, c, u, p) {
  p === void 0 && (p = u);
  var a = Object.getOwnPropertyDescriptor(c, u);
  (!a || ("get" in a ? !c.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
    return c[u];
  } }), Object.defineProperty(n, p, a);
} : function(n, c, u, p) {
  p === void 0 && (p = u), n[p] = c[u];
}), __setModuleDefault$2 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(n, c) {
  Object.defineProperty(n, "default", { enumerable: !0, value: c });
} : function(n, c) {
  n.default = c;
}), __importStar$2 = commonjsGlobal && commonjsGlobal.__importStar || function(n) {
  if (n && n.__esModule) return n;
  var c = {};
  if (n != null) for (var u in n) u !== "default" && Object.prototype.hasOwnProperty.call(n, u) && __createBinding$2(c, n, u);
  return __setModuleDefault$2(c, n), c;
};
Object.defineProperty(bech32$1, "__esModule", { value: !0 });
bech32$1.normalizeBech32 = bech32$1.fromBech32 = bech32$1.toBech32 = void 0;
const bech32 = __importStar$2(bech32$4);
function toBech32(n, c, u) {
  return bech32.encode(n, bech32.toWords(c), u);
}
bech32$1.toBech32 = toBech32;
function fromBech32(n, c = 1 / 0) {
  const u = bech32.decode(n, c);
  return {
    prefix: u.prefix,
    data: new Uint8Array(bech32.fromWords(u.words))
  };
}
bech32$1.fromBech32 = fromBech32;
function normalizeBech32(n) {
  const { prefix: c, data: u } = fromBech32(n);
  return toBech32(c, u);
}
bech32$1.normalizeBech32 = normalizeBech32;
var hex = {};
Object.defineProperty(hex, "__esModule", { value: !0 });
hex.fromHex = hex.toHex = void 0;
function toHex(n) {
  let c = "";
  for (const u of n)
    c += ("0" + u.toString(16)).slice(-2);
  return c;
}
hex.toHex = toHex;
function fromHex(n) {
  if (n.length % 2 !== 0)
    throw new Error("hex string length must be a multiple of 2");
  const c = new Uint8Array(n.length / 2);
  for (let u = 0; u < c.length; u++) {
    const p = 2 * u, a = n.slice(p, p + 2);
    if (!a.match(/[0-9a-f]{2}/i))
      throw new Error("hex string contains invalid characters");
    c[u] = parseInt(a, 16);
  }
  return c;
}
hex.fromHex = fromHex;
var rfc3339 = {};
Object.defineProperty(rfc3339, "__esModule", { value: !0 });
rfc3339.toRfc3339 = rfc3339.fromRfc3339 = void 0;
const rfc3339Matcher = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(\.\d{1,9})?((?:[+-]\d{2}:\d{2})|Z)$/;
function padded(n, c = 2) {
  return n.toString().padStart(c, "0");
}
function fromRfc3339(n) {
  const c = rfc3339Matcher.exec(n);
  if (!c)
    throw new Error("Date string is not in RFC3339 format");
  const u = +c[1], p = +c[2], a = +c[3], A = +c[4], b = +c[5], F = +c[6], le = c[7] ? Math.floor(+c[7] * 1e3) : 0;
  let L, pe, $;
  c[8] === "Z" ? (L = 1, pe = 0, $ = 0) : (L = c[8].substring(0, 1) === "-" ? -1 : 1, pe = +c[8].substring(1, 3), $ = +c[8].substring(4, 6));
  const Ee = L * (pe * 60 + $) * 60, be = /* @__PURE__ */ new Date();
  return be.setUTCFullYear(u, p - 1, a), be.setUTCHours(A, b, F, le), new Date(be.getTime() - Ee * 1e3);
}
rfc3339.fromRfc3339 = fromRfc3339;
function toRfc3339(n) {
  const c = n.getUTCFullYear(), u = padded(n.getUTCMonth() + 1), p = padded(n.getUTCDate()), a = padded(n.getUTCHours()), A = padded(n.getUTCMinutes()), b = padded(n.getUTCSeconds()), F = padded(n.getUTCMilliseconds(), 3);
  return `${c}-${u}-${p}T${a}:${A}:${b}.${F}Z`;
}
rfc3339.toRfc3339 = toRfc3339;
var utf8 = {};
Object.defineProperty(utf8, "__esModule", { value: !0 });
utf8.fromUtf8 = utf8.toUtf8 = void 0;
function toUtf8(n) {
  return new TextEncoder().encode(n);
}
utf8.toUtf8 = toUtf8;
function fromUtf8(n, c = !1) {
  const u = !c;
  return new TextDecoder("utf-8", { fatal: u }).decode(n);
}
utf8.fromUtf8 = fromUtf8;
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.toUtf8 = n.fromUtf8 = n.toRfc3339 = n.fromRfc3339 = n.toHex = n.fromHex = n.toBech32 = n.normalizeBech32 = n.fromBech32 = n.toBase64 = n.fromBase64 = n.toAscii = n.fromAscii = void 0;
  var c = ascii;
  Object.defineProperty(n, "fromAscii", { enumerable: !0, get: function() {
    return c.fromAscii;
  } }), Object.defineProperty(n, "toAscii", { enumerable: !0, get: function() {
    return c.toAscii;
  } });
  var u = base64;
  Object.defineProperty(n, "fromBase64", { enumerable: !0, get: function() {
    return u.fromBase64;
  } }), Object.defineProperty(n, "toBase64", { enumerable: !0, get: function() {
    return u.toBase64;
  } });
  var p = bech32$1;
  Object.defineProperty(n, "fromBech32", { enumerable: !0, get: function() {
    return p.fromBech32;
  } }), Object.defineProperty(n, "normalizeBech32", { enumerable: !0, get: function() {
    return p.normalizeBech32;
  } }), Object.defineProperty(n, "toBech32", { enumerable: !0, get: function() {
    return p.toBech32;
  } });
  var a = hex;
  Object.defineProperty(n, "fromHex", { enumerable: !0, get: function() {
    return a.fromHex;
  } }), Object.defineProperty(n, "toHex", { enumerable: !0, get: function() {
    return a.toHex;
  } });
  var A = rfc3339;
  Object.defineProperty(n, "fromRfc3339", { enumerable: !0, get: function() {
    return A.fromRfc3339;
  } }), Object.defineProperty(n, "toRfc3339", { enumerable: !0, get: function() {
    return A.toRfc3339;
  } });
  var b = utf8;
  Object.defineProperty(n, "fromUtf8", { enumerable: !0, get: function() {
    return b.fromUtf8;
  } }), Object.defineProperty(n, "toUtf8", { enumerable: !0, get: function() {
    return b.toUtf8;
  } });
})(build);
const require$$4 = /* @__PURE__ */ getAugmentedNamespace(esm);
var bip322 = {}, types = {};
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.MagicCode = n.MessageSigningProtocols = n.AddressType = void 0, function(c) {
    c.p2pkh = "p2pkh", c.p2sh = "p2sh", c.p2wpkh = "p2wpkh", c.p2wsh = "p2wsh", c.p2tr = "p2tr";
  }(n.AddressType || (n.AddressType = {})), function(c) {
    c.ECDSA = "ECDSA", c.BIP322 = "BIP322";
  }(n.MessageSigningProtocols || (n.MessageSigningProtocols = {})), function(c) {
    c.LEAFHASH_DISPLAY_FP = "69846d00", c.LEAFHASH_CHECK_ONLY_FP = "3b9f9680", c.FINALITY_PUB_FP = "ff119473", c.BIP322_MESSAGE_FP = "83871619", c.BIP322_TAP_PUBKEY_FP = "25270417";
  }(n.MagicCode || (n.MagicCode = {}));
})(types);
var hasRequiredBip322;
function requireBip322() {
  if (hasRequiredBip322) return bip322;
  hasRequiredBip322 = 1;
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(tr, Fe, Sr, er) {
    er === void 0 && (er = Sr);
    var Ie = Object.getOwnPropertyDescriptor(Fe, Sr);
    (!Ie || ("get" in Ie ? !Fe.__esModule : Ie.writable || Ie.configurable)) && (Ie = { enumerable: !0, get: function() {
      return Fe[Sr];
    } }), Object.defineProperty(tr, er, Ie);
  } : function(tr, Fe, Sr, er) {
    er === void 0 && (er = Sr), tr[er] = Fe[Sr];
  }), c = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(tr, Fe) {
    Object.defineProperty(tr, "default", { enumerable: !0, value: Fe });
  } : function(tr, Fe) {
    tr.default = Fe;
  }), u = commonjsGlobal && commonjsGlobal.__importStar || function(tr) {
    if (tr && tr.__esModule) return tr;
    var Fe = {};
    if (tr != null) for (var Sr in tr) Sr !== "default" && Object.prototype.hasOwnProperty.call(tr, Sr) && n(Fe, tr, Sr);
    return c(Fe, tr), Fe;
  };
  Object.defineProperty(bip322, "__esModule", { value: !0 }), bip322.createTaprootBip322Signature = bip322.createSegwitBip322Signature = bip322.bip0322Hash = void 0;
  const p = u(dist$x), a = src$j, A = src$2, b = varuintBitcoin, F = requireMain(), le = requireBabylon(), L = types, pe = (0, A.BIP32Factory)(p), $ = (tr) => Buffer$f.concat([(0, b.encode)(tr.byteLength), tr]), Ee = Buffer$f.from("0000000000000000000000000000000000000000000000000000000000000000", "hex"), be = 4294967295, He = 0;
  function Pe(tr) {
    const { sha256: Fe } = a.crypto, er = Fe(Buffer$f.from("BIP0322-signed-message"));
    return Fe(Buffer$f.concat([er, er, Buffer$f.from(tr)])).toString("hex");
  }
  bip322.bip0322Hash = Pe;
  const nr = async (tr, Fe, Sr, er, Ie, xe) => {
    const rr = Buffer$f.concat([
      Buffer$f.from("0020", "hex"),
      Buffer$f.from(Pe(Sr), "hex")
    ]), ar = new a.Transaction();
    ar.version = 0, ar.addInput(Ee, be, He, rr), ar.addOutput(er, 0);
    const yr = new a.Psbt();
    yr.setVersion(0), yr.addInput(Object.assign({ hash: ar.getHash(), index: 0, sequence: 0, witnessUtxo: {
      script: er,
      value: 0
    } }, Ie)), yr.addOutput({ script: Buffer$f.from("6a", "hex"), value: 0 });
    const _r = await tr.signPsbt(yr.toBase64(), Fe, null);
    for (const Hr of _r)
      xe ? yr.updateInput(Hr[0], {
        partialSig: [Hr[1]]
      }) : yr.updateInput(Hr[0], {
        tapKeySig: Hr[1].signature
      });
    yr.finalizeAllInputs();
    const Or = yr.extractTransaction(), vr = (0, b.encode)(Or.ins[0].witness.length);
    return {
      signature: Buffer$f.concat([
        vr,
        ...Or.ins[0].witness.map((Hr) => $(Hr))
      ]).toString("base64"),
      protocol: L.MessageSigningProtocols.BIP322
    };
  };
  function ir(tr, Fe, Sr) {
    const er = Sr ? a.networks.testnet : a.networks.bitcoin, { publicKey: Ie } = pe.fromBase58(tr, er).derivePath(`0/${Fe}`);
    return Ie;
  }
  function or(tr, Fe, Sr = !1) {
    (0, a.initEccLib)(p);
    const er = ir(tr, Fe, Sr), Ie = Sr ? a.networks.testnet : a.networks.bitcoin, xe = a.payments.p2wpkh({ pubkey: er, network: Ie }), rr = xe.address;
    if (!rr)
      throw new Error("Address is null");
    if (!xe.output)
      throw new Error("p2wpkh output is null");
    return {
      publicKey: er,
      address: rr,
      witnessScript: xe.output
    };
  }
  async function lr({ message: tr, app: Fe, derivationPath: Sr = "m/84'/0'/0'", isTestnet: er = !1 }) {
    const Ie = await Fe.getMasterFingerprint(), xe = await Fe.getExtendedPubkey(Sr), { publicKey: rr, witnessScript: ar } = or(xe, 0, er), yr = {
      path: `${Sr}/0/0`,
      pubkey: rr,
      masterFingerprint: Buffer$f.from(Ie, "hex")
    }, _r = new F.WalletPolicy("Sign message", "wpkh(@0/**)", [
      `[${Sr.replace("m/", `${Ie}/`)}]${xe}`
    ]);
    return nr(Fe, _r, tr, ar, {
      bip32Derivation: [yr]
    }, !0);
  }
  bip322.createSegwitBip322Signature = lr;
  function Ir(tr, Fe, Sr = !1) {
    (0, a.initEccLib)(p);
    const er = ir(tr, Fe, Sr), Ie = a.payments.p2tr({
      internalPubkey: er.slice(1),
      network: Sr ? a.networks.testnet : a.networks.bitcoin
    });
    if (!Ie.output || !Ie.address || !Ie.internalPubkey)
      throw new Error("p2tr output, address or internalPubkey is null");
    return {
      publicKey: er,
      address: Ie.address,
      internalPubkey: Ie.internalPubkey,
      taprootScript: Ie.output
    };
  }
  function xr(tr) {
    let er = (tr.length / 2).toString(16).padStart(2, "0") + tr;
    const Ie = 64 - er.length;
    return Ie > 0 && (er += "fc".repeat(Ie / 2)), er;
  }
  function kr(tr) {
    let Fe = "";
    for (let Sr = 0; Sr < tr.length; Sr += 2) {
      const er = tr[Sr].toString(16).padStart(2, "0"), Ie = Sr + 1 < tr.length ? tr[Sr + 1].toString(16).padStart(2, "0") : "";
      Fe += er + Ie;
    }
    return xr(Fe);
  }
  async function Ce({ message: tr, app: Fe, derivationPath: Sr = "m/86'/0'/0'", isTestnet: er = !1 }) {
    const Ie = await Fe.getMasterFingerprint(), xe = await Fe.getExtendedPubkey(Sr), { internalPubkey: rr, taprootScript: ar } = Ir(xe, 0, er), yr = {
      path: `${Sr}/0/0`,
      pubkey: rr,
      masterFingerprint: Buffer$f.from(Ie, "hex"),
      leafHashes: []
    }, _r = (0, le.validadteAddress)(tr);
    if (!_r)
      throw new Error("The message should be a valid bbn address.");
    const Or = new F.WalletPolicy("Sign message", "tr(@0/**,and_v(pk_k(@1/**),pk_k(@2/**)))", [
      `[${Sr.replace("m/", `${Ie}/`)}]${xe}`,
      `[${Sr.replace("m/", `${L.MagicCode.BIP322_MESSAGE_FP}/`)}]${(0, le.formatKey)(kr(_r), er)}`,
      `[${Sr.replace("m/", `${L.MagicCode.BIP322_TAP_PUBKEY_FP}/`)}]${(0, le.formatKey)(ar.slice(2), er)}`
    ]);
    return nr(Fe, Or, tr, ar, {
      tapBip32Derivation: [yr],
      tapInternalKey: rr
    }, !1);
  }
  return bip322.createTaprootBip322Signature = Ce, bip322;
}
var psbt = {}, __createBinding$1 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(n, c, u, p) {
  p === void 0 && (p = u);
  var a = Object.getOwnPropertyDescriptor(c, u);
  (!a || ("get" in a ? !c.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
    return c[u];
  } }), Object.defineProperty(n, p, a);
} : function(n, c, u, p) {
  p === void 0 && (p = u), n[p] = c[u];
}), __setModuleDefault$1 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(n, c) {
  Object.defineProperty(n, "default", { enumerable: !0, value: c });
} : function(n, c) {
  n.default = c;
}), __importStar$1 = commonjsGlobal && commonjsGlobal.__importStar || function(n) {
  if (n && n.__esModule) return n;
  var c = {};
  if (n != null) for (var u in n) u !== "default" && Object.prototype.hasOwnProperty.call(n, u) && __createBinding$1(c, n, u);
  return __setModuleDefault$1(c, n), c;
};
Object.defineProperty(psbt, "__esModule", { value: !0 });
psbt.getLeafHash = psbt.getTaprootScript = void 0;
const crypto$2 = __importStar$1(requireCryptoBrowserify()), bitcoinjs_lib_1 = src$j;
function getTaprootScript(n) {
  const c = Buffer$f.from(n, "base64"), u = bitcoinjs_lib_1.Psbt.fromBuffer(c);
  for (const p of u.data.inputs)
    if (p.tapLeafScript && p.tapLeafScript.length > 0)
      for (const a of p.tapLeafScript)
        return a.script;
}
psbt.getTaprootScript = getTaprootScript;
function taggedHash(n, c) {
  const u = crypto$2.createHash("sha256").update(n).digest();
  return crypto$2.createHash("sha256").update(Buffer$f.concat([u, u, c])).digest();
}
function encodeVarint(n) {
  if (n < 253)
    return Buffer$f.from([n]);
  if (n <= 65535) {
    const c = Buffer$f.alloc(3);
    return c.writeUInt8(253, 0), c.writeUInt16LE(n, 1), c;
  } else if (n <= 4294967295) {
    const c = Buffer$f.alloc(5);
    return c.writeUInt8(254, 0), c.writeUInt32LE(n, 1), c;
  } else {
    const c = Buffer$f.alloc(9);
    return c.writeUInt8(255, 0), c.writeUInt32LE(n, 1), c.writeBigUInt64LE(BigInt(n), 5), c;
  }
}
function getLeafHash(n) {
  const c = Buffer$f.from([192]), u = n.length, p = encodeVarint(u), a = Buffer$f.concat([c, p, n]);
  return taggedHash(Buffer$f.from("TapLeaf"), a);
}
psbt.getLeafHash = getLeafHash;
var xpub = {}, __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(n, c, u, p) {
  p === void 0 && (p = u);
  var a = Object.getOwnPropertyDescriptor(c, u);
  (!a || ("get" in a ? !c.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
    return c[u];
  } }), Object.defineProperty(n, p, a);
} : function(n, c, u, p) {
  p === void 0 && (p = u), n[p] = c[u];
}), __setModuleDefault = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(n, c) {
  Object.defineProperty(n, "default", { enumerable: !0, value: c });
} : function(n, c) {
  n.default = c;
}), __importStar = commonjsGlobal && commonjsGlobal.__importStar || function(n) {
  if (n && n.__esModule) return n;
  var c = {};
  if (n != null) for (var u in n) u !== "default" && Object.prototype.hasOwnProperty.call(n, u) && __createBinding(c, n, u);
  return __setModuleDefault(c, n), c;
}, __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function(n) {
  return n && n.__esModule ? n : { default: n };
};
Object.defineProperty(xpub, "__esModule", { value: !0 });
xpub.createExtendedPubkey = void 0;
const crypto$1 = __importStar(requireCryptoBrowserify()), bs58_1 = __importDefault(bs58$f);
function hash256(n) {
  return crypto$1.createHash("sha256").update(crypto$1.createHash("sha256").update(n).digest()).digest();
}
function createExtendedPubkey(n, c = 0, u = Buffer$f.from("00000000", "hex"), p = 0, a = Buffer$f.from("0000000000000000000000000000000000000000000000000000000000000000", "hex"), A) {
  let b;
  if (n === "Mainnet")
    b = Buffer$f.from("0488b21e", "hex");
  else if (n === "Testnet")
    b = Buffer$f.from("043587cf", "hex");
  else
    throw new Error("Invalid network. Use 'Mainnet' or 'Testnet'.");
  const F = Buffer$f.concat([
    b,
    Buffer$f.from([c]),
    u,
    Buffer$f.from([
      p >> 24,
      p >> 16 & 255,
      p >> 8 & 255,
      p & 255
    ]),
    a,
    A
    // 33 bytes: compressed public key
  ]), le = hash256(F).slice(0, 4);
  return bs58_1.default.encode(Buffer$f.concat([F, le]));
}
xpub.createExtendedPubkey = createExtendedPubkey;
var hasRequiredBabylon;
function requireBabylon() {
  if (hasRequiredBabylon) return babylon;
  hasRequiredBabylon = 1;
  var n = commonjsGlobal && commonjsGlobal.__importDefault || function(yr) {
    return yr && yr.__esModule ? yr : { default: yr };
  };
  Object.defineProperty(babylon, "__esModule", { value: !0 }), babylon.tryParsePsbt = babylon.stakingTxPolicy = babylon.timelockPathPolicy = babylon.unbondingPathPolicy = babylon.slashingPathPolicy = babylon.formatKey = babylon.computeLeafHash = babylon.signMessage = babylon.validadteAddress = babylon.signPsbt = void 0;
  const c = requireCryptoBrowserify(), u = main, p = build, a = require$$3, A = require$$4, b = n(appClient$1), F = buffertools, le = policy, L = requireBip322(), pe = psbt, $ = types, Ee = xpub;
  async function be({ transport: yr, psbt: _r, policy: Or }) {
    const vr = new b.default(yr), Te = _r instanceof Uint8Array ? a.base64.encode(_r) : _r, Cr = await vr.signPsbt(Te, Or, null), Hr = !!(0, pe.getTaprootScript)(Te), si = A.Transaction.fromPSBT(a.base64.decode(Te));
    for (const ui of Cr) {
      const Li = ui[0];
      Hr ? si.updateInput(Li, {
        tapScriptSig: [
          [
            {
              pubKey: ui[1].pubkey,
              leafHash: ui[1].tapleafHash
            },
            ui[1].signature
          ]
        ]
      }, !0) : si.updateInput(Li, {
        tapKeySig: ui[1].signature
      }, !0);
    }
    return si;
  }
  babylon.signPsbt = be;
  function He(yr) {
    try {
      const { prefix: _r, data: Or } = (0, p.fromBech32)(yr);
      if (_r == "bbn" && Or.length === 20)
        return Or;
    } catch {
    }
  }
  babylon.validadteAddress = He;
  async function Pe(yr) {
    var _r;
    const Or = (_r = yr.derivationPath) !== null && _r !== void 0 ? _r : "m/86'/0'/0'";
    if (!He(yr.message))
      throw new Error("The message should be a valid bbn address.");
    if (yr.type === "bip322-simple") {
      const { transport: Hr, message: si, addressType: ui = $.AddressType.p2tr, isTestnet: Li = !1 } = yr;
      return ir({
        transport: Hr,
        message: si,
        addressType: ui,
        derivationPath: Or,
        isTestnet: Li
      });
    }
    const { transport: Te, message: Cr } = yr;
    return nr({
      transport: Te,
      message: Cr,
      derivationPath: Or
    });
  }
  babylon.signMessage = Pe;
  async function nr({ transport: yr, message: _r, derivationPath: Or = "m/86'/0'/0'" }) {
    return {
      signature: await new b.default(yr).signMessage(Buffer$f.from(_r), `${Or}/0/0`),
      protocol: $.MessageSigningProtocols.ECDSA
    };
  }
  async function ir({ transport: yr, message: _r, addressType: Or = $.AddressType.p2tr, derivationPath: vr = "m/86'/0'/0'", isTestnet: Te = !1 }) {
    const Cr = new b.default(yr);
    return Or === $.AddressType.p2tr ? (0, L.createTaprootBip322Signature)({
      message: _r,
      app: Cr,
      derivationPath: vr,
      isTestnet: Te
    }) : (0, L.createSegwitBip322Signature)({
      message: _r,
      app: Cr,
      derivationPath: vr,
      isTestnet: Te
    });
  }
  function or(yr) {
    const _r = yr instanceof Uint8Array ? a.base64.encode(yr) : yr, Or = (0, pe.getTaprootScript)(_r);
    if (!Or)
      throw new Error("The psbt does not contain a taproot script.");
    return (0, pe.getLeafHash)(Or);
  }
  babylon.computeLeafHash = or;
  function lr(yr, _r) {
    const Or = yr instanceof Buffer$f ? yr : Buffer$f.from(yr, "hex");
    return (0, Ee.createExtendedPubkey)(_r ? "Testnet" : "Mainnet", 0, Buffer$f.from("00000000", "hex"), 0, (0, c.createHash)("sha256").update(Or).digest().subarray(0, 32), Buffer$f.concat([Buffer$f.from("02", "hex"), Or]));
  }
  babylon.formatKey = lr;
  async function Ir(yr, _r) {
    const Or = new b.default(yr), vr = await Or.getMasterFingerprint(), Te = await Or.getExtendedPubkey(_r);
    return [vr, Te];
  }
  function xr(yr) {
    if (!yr || yr.length === 0)
      throw new Error("Must provide at least one finality provider.");
    if (yr.length > 1)
      throw new Error("Currently only a single finality provider is supported.");
    return yr[0];
  }
  function kr(yr, _r) {
    if (yr < 2)
      throw new Error(`Invalid value for covenantThreshold: ${yr}. It should be greater than or equal to 2.`);
    const Or = _r ? _r.length : 0;
    if (Or < 2)
      throw new Error(`covenantPks must have at least 2 elements. Current length: ${Or}`);
    if (Or < yr)
      throw new Error(`The length of covenantPks (${Or}) is less than the required covenantThreshold (${yr}).`);
    if (new Set(_r).size < Or)
      throw new Error("All covenantPks must be unique");
    return _r.map((vr) => Buffer$f.from(vr, "hex")).sort(Buffer$f.compare).map((vr) => vr.toString("hex"));
  }
  async function Ce({ policyName: yr = "Consent to slashing", transport: _r, params: Or, derivationPath: vr, displayLeafHash: Te = !0, isTestnet: Cr = !1 }) {
    vr = vr || `m/86'/${Cr ? 1 : 0}'/0'`;
    const { leafHash: Hr, timelockBlocks: si, finalityProviders: ui, covenantThreshold: Li, covenantPks: Qi, slashingPkScriptHex: wi, slashingFeeSat: Ji } = Or, [mn, pi] = await Ir(_r, vr), ei = [], Vr = Te ? $.MagicCode.LEAFHASH_DISPLAY_FP : $.MagicCode.LEAFHASH_CHECK_ONLY_FP;
    ei.push(`[${vr.replace("m/", `${Vr}/`)}]${lr(Hr, Cr)}`), ei.push(`[${vr.replace("m/", `${mn}/`)}]${pi}`);
    const qr = xr(ui);
    ei.push(`[${vr.replace("m/", `${$.MagicCode.FINALITY_PUB_FP}/`)}]${lr(qr, Cr)}`);
    const Zi = kr(Li, Qi), Wr = Zi.length;
    for (let _i = 0; _i < Wr; _i++) {
      const Er = Zi[_i];
      ei.push(lr(Er, Cr));
    }
    ei.push(lr(wi.padEnd(64, "0"), Cr)), ei.push(lr((0, F.numberToLE)(Ji), Cr));
    const ri = `tr(@0/**,and_v(and_v(pk_k(@1/**),and_v(pk_k(@2/**),multi_a(${Li},${Array.from({ length: Wr }, (_i, Er) => Er).map((_i) => `@${3 + _i}/**`).join(",")},@${3 + Wr}/**,@${3 + Wr + 1}/**))),older(${si})))`;
    return new le.WalletPolicy(yr, ri, ei);
  }
  babylon.slashingPathPolicy = Ce;
  async function tr({ policyName: yr = "Unbonding", transport: _r, params: Or, derivationPath: vr, displayLeafHash: Te = !0, isTestnet: Cr = !1 }) {
    vr = vr || `m/86'/${Cr ? 1 : 0}'/0'`;
    const { leafHash: Hr, timelockBlocks: si, finalityProviders: ui, covenantThreshold: Li, covenantPks: Qi, unbondingFeeSat: wi } = Or, [Ji, mn] = await Ir(_r, vr), pi = [], ei = Te ? $.MagicCode.LEAFHASH_DISPLAY_FP : $.MagicCode.LEAFHASH_CHECK_ONLY_FP;
    pi.push(`[${vr.replace("m/", `${ei}/`)}]${lr(Hr, Cr)}`), pi.push(`[${vr.replace("m/", `${Ji}/`)}]${mn}`);
    const Vr = xr(ui);
    pi.push(`[${vr.replace("m/", `${$.MagicCode.FINALITY_PUB_FP}/`)}]${lr(Vr, Cr)}`);
    const qr = kr(Li, Qi), Zi = qr.length;
    for (let ri = 0; ri < Zi; ri++) {
      const _i = qr[ri];
      pi.push(lr(_i, Cr));
    }
    pi.push(lr((0, F.numberToLE)(wi), Cr));
    const Wr = `tr(@0/**,and_v(and_v(pk_k(@1/**),and_v(pk_k(@2/**),multi_a(${Li},${Array.from({ length: Zi }, (ri, _i) => _i).map((ri) => `@${3 + ri}/**`).join(",")},@${3 + Zi}/**))),older(${si})))`;
    return new le.WalletPolicy(yr, Wr, pi);
  }
  babylon.unbondingPathPolicy = tr;
  async function Fe({ policyName: yr = "Withdraw", transport: _r, params: Or, derivationPath: vr, displayLeafHash: Te = !0, isTestnet: Cr = !1 }) {
    vr = vr || `m/86'/${Cr ? 1 : 0}'/0'`;
    const { leafHash: Hr, timelockBlocks: si } = Or, [ui, Li] = await Ir(_r, vr), Qi = [], wi = Te ? $.MagicCode.LEAFHASH_DISPLAY_FP : $.MagicCode.LEAFHASH_CHECK_ONLY_FP;
    Qi.push(`[${vr.replace("m/", `${wi}/`)}]${lr(Hr, Cr)}`), Qi.push(`[${vr.replace("m/", `${ui}/`)}]${Li}`);
    const Ji = `tr(@0/**,and_v(pk_k(@1/**),older(${si})))`;
    return new le.WalletPolicy(yr, Ji, Qi);
  }
  babylon.timelockPathPolicy = Fe;
  async function Sr({ policyName: yr = "Staking transaction", transport: _r, params: Or, derivationPath: vr, isTestnet: Te = !1 }) {
    vr = vr || `m/86'/${Te ? 1 : 0}'/0'`;
    const { timelockBlocks: Cr, finalityProviders: Hr, covenantThreshold: si, covenantPks: ui } = Or, [Li, Qi] = await Ir(_r, vr), wi = [];
    wi.push("[69846d00/86'/1'/0']tpubD6NzVbkrYhZ4WLczPJWReQycCJdd6YVWXubbVUFnJ5KgU5MDQrD998ZJLSmaB7GVcCnJSDWprxmrGkJ6SvgQC6QAffVpqSvonXmeizXcrkN"), wi.push(`[${vr.replace("m/", `${Li}/`)}]${Qi}`);
    const Ji = xr(Hr);
    wi.push(`[${vr.replace("m/", `${$.MagicCode.FINALITY_PUB_FP}/`)}]${lr(Ji, Te)}`);
    const mn = kr(si, ui), pi = mn.length;
    for (let Vr = 0; Vr < pi; Vr++) {
      const qr = mn[Vr];
      wi.push(lr(qr, Te));
    }
    const ei = `tr(@0/**,and_v(and_v(pk_k(@1/**),and_v(pk_k(@2/**),multi_a(${si},${Array.from({ length: pi }, (Vr, qr) => qr).map((Vr) => `@${3 + Vr}/**`).join(",")}))),older(${Cr})))`;
    return new le.WalletPolicy(yr, ei, wi);
  }
  babylon.stakingTxPolicy = Sr;
  const er = /^([a-f0-9]{64}) OP_CHECKSIGVERIFY OP_(0|[1-9]|1[0-6]) OP_CHECKSEQUENCEVERIFY$/, Ie = /^([a-f0-9]{64}) OP_CHECKSIGVERIFY ([a-f0-9]{2,6}) OP_CHECKSEQUENCEVERIFY$/;
  function xe(yr) {
    var _r, Or;
    if (yr.length % 2 !== 0)
      throw new Error("Invalid timelock: odd-length hex string");
    return (Or = (_r = yr.match(/.{2}/g)) === null || _r === void 0 ? void 0 : _r.reverse().join("")) !== null && Or !== void 0 ? Or : "";
  }
  function rr(yr) {
    const _r = yr.join(" ");
    let Or = _r.match(er);
    if (Or) {
      const [, Hr, si] = Or;
      return [Hr, Number(si).toString(16)];
    }
    if (Or = _r.match(Ie), !Or)
      return;
    const [vr, Te, Cr] = Or;
    return [Te, xe(Cr)];
  }
  async function ar(yr, _r, Or = !1, vr) {
    const Te = `m/86'/${Or ? 1 : 0}'/0'`, Cr = (0, pe.getTaprootScript)(_r);
    if (!Cr)
      throw new Error("No script found in psbt");
    vr = vr || or(_r);
    const Hr = u.Script.decode(Cr), si = rr(Hr);
    if (si)
      return Fe({
        transport: yr,
        params: {
          leafHash: vr,
          timelockBlocks: +`0x${si[si.length - 1]}`
        },
        derivationPath: Te,
        isTestnet: Or
      });
  }
  return babylon.tryParsePsbt = ar, babylon;
}
var hasRequiredMain;
function requireMain() {
  return hasRequiredMain || (hasRequiredMain = 1, function(n) {
    var c = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(le, L, pe, $) {
      $ === void 0 && ($ = pe);
      var Ee = Object.getOwnPropertyDescriptor(L, pe);
      (!Ee || ("get" in Ee ? !L.__esModule : Ee.writable || Ee.configurable)) && (Ee = { enumerable: !0, get: function() {
        return L[pe];
      } }), Object.defineProperty(le, $, Ee);
    } : function(le, L, pe, $) {
      $ === void 0 && ($ = pe), le[$] = L[pe];
    }), u = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(le, L) {
      Object.defineProperty(le, "default", { enumerable: !0, value: L });
    } : function(le, L) {
      le.default = L;
    }), p = commonjsGlobal && commonjsGlobal.__importStar || function(le) {
      if (le && le.__esModule) return le;
      var L = {};
      if (le != null) for (var pe in le) pe !== "default" && Object.prototype.hasOwnProperty.call(le, pe) && c(L, le, pe);
      return u(L, le), L;
    };
    Object.defineProperty(n, "__esModule", { value: !0 }), n.tryParsePsbt = n.signPsbt = n.stakingTxPolicy = n.timelockPathPolicy = n.unbondingPathPolicy = n.slashingPathPolicy = n.computeLeafHash = n.signMessage = n.PartialSignature = n.PsbtV2 = n.AppClient = n.WalletPolicy = n.DefaultWalletPolicy = void 0;
    const a = p(appClient$1);
    n.AppClient = a.default, Object.defineProperty(n, "PartialSignature", { enumerable: !0, get: function() {
      return a.PartialSignature;
    } });
    const A = policy;
    Object.defineProperty(n, "DefaultWalletPolicy", { enumerable: !0, get: function() {
      return A.DefaultWalletPolicy;
    } }), Object.defineProperty(n, "WalletPolicy", { enumerable: !0, get: function() {
      return A.WalletPolicy;
    } });
    const b = requireBabylon();
    Object.defineProperty(n, "computeLeafHash", { enumerable: !0, get: function() {
      return b.computeLeafHash;
    } }), Object.defineProperty(n, "signMessage", { enumerable: !0, get: function() {
      return b.signMessage;
    } }), Object.defineProperty(n, "tryParsePsbt", { enumerable: !0, get: function() {
      return b.tryParsePsbt;
    } }), Object.defineProperty(n, "signPsbt", { enumerable: !0, get: function() {
      return b.signPsbt;
    } }), Object.defineProperty(n, "slashingPathPolicy", { enumerable: !0, get: function() {
      return b.slashingPathPolicy;
    } }), Object.defineProperty(n, "stakingTxPolicy", { enumerable: !0, get: function() {
      return b.stakingTxPolicy;
    } }), Object.defineProperty(n, "timelockPathPolicy", { enumerable: !0, get: function() {
      return b.timelockPathPolicy;
    } }), Object.defineProperty(n, "unbondingPathPolicy", { enumerable: !0, get: function() {
      return b.unbondingPathPolicy;
    } });
    const F = psbtv2;
    Object.defineProperty(n, "PsbtV2", { enumerable: !0, get: function() {
      return F.PsbtV2;
    } }), n.default = a.default;
  }(main$2)), main$2;
}
var mainExports = requireMain();
const AppClient = /* @__PURE__ */ getDefaultExportFromCjs(mainExports);
var ActionName = /* @__PURE__ */ ((n) => (n.SIGN_BTC_STAKING_TRANSACTION = "sign-btc-staking-transaction", n.SIGN_BTC_UNBONDING_TRANSACTION = "sign-btc-unbonding-transaction", n.SIGN_BTC_WITHDRAW_TRANSACTION = "sign-btc-withdraw-transaction", n.SIGN_BTC_SLASHING_TRANSACTION = "sign-btc-slashing-transaction", n.SIGN_BTC_UNBONDING_SLASHING_TRANSACTION = "sign-btc-unbonding-slashing-transaction", n))(ActionName || {});
const BABYLON_SIGNING_CONTRACTS = {
  STAKING: "babylon:staking",
  UNBONDING: "babylon:unbonding",
  SLASHING: "babylon:slashing",
  SLASHING_BURN: "babylon:slashing-burn",
  WITHDRAW: "babylon:withdraw"
}, sortPkHexes = (n) => n.map((c) => Buffer$f.from(c, "hex")).sort(Buffer$f.compare).map((c) => c.toString("hex")), UNBONDING_POLICY = "Unbonding", SLASHING_POLICY = "Consent to slashing", UNBONDING_SLASHING_POLICY = "Consent to unbonding slashing", STAKING_POLICY = "Staking transaction", WITHDRAWAL_POLICY = "Withdraw", getPolicyForTransaction = async (n, c, u, p, {
  contracts: a,
  action: A
}) => {
  const b = c !== Network.MAINNET;
  switch (A.name) {
    case ActionName.SIGN_BTC_STAKING_TRANSACTION:
      return getStakingPolicy(a, u, n, b);
    case ActionName.SIGN_BTC_UNBONDING_TRANSACTION:
      return getUnbondingPolicy(a, u, n, b, p);
    case ActionName.SIGN_BTC_SLASHING_TRANSACTION:
      return getSlashingPolicy(a, u, n, b, p);
    case ActionName.SIGN_BTC_UNBONDING_SLASHING_TRANSACTION:
      return getUnbondingSlashingPolicy(a, u, n, b, p);
    case ActionName.SIGN_BTC_WITHDRAW_TRANSACTION:
      return getWithdrawPolicy(a, u, p, n, b);
    default:
      throw new Error(`Unknown action: ${A.name}`);
  }
}, getStakingPolicy = (n, c, u, p) => {
  const a = n.find((L) => L.id === BABYLON_SIGNING_CONTRACTS.STAKING);
  if (!a)
    throw new Error("Staking contract is required");
  const { finalityProviders: A, covenantThreshold: b, covenantPks: F, stakingDuration: le } = a.params;
  return mainExports.stakingTxPolicy({
    policyName: STAKING_POLICY,
    transport: u,
    params: {
      finalityProviders: A,
      covenantThreshold: b,
      covenantPks: sortPkHexes(F),
      timelockBlocks: le
    },
    derivationPath: c,
    isTestnet: p
  });
}, getUnbondingPolicy = (n, c, u, p, a) => {
  const A = n.find((Ee) => Ee.id === BABYLON_SIGNING_CONTRACTS.UNBONDING);
  if (!A)
    throw new Error("Unbonding contract is required");
  const b = mainExports.computeLeafHash(a);
  if (!b)
    throw new Error("Could not compute leaf hash");
  const { finalityProviders: F, covenantThreshold: le, covenantPks: L, unbondingTimeBlocks: pe, unbondingFeeSat: $ } = A.params;
  return mainExports.unbondingPathPolicy({
    policyName: UNBONDING_POLICY,
    transport: u,
    params: {
      finalityProviders: F,
      covenantThreshold: le,
      covenantPks: sortPkHexes(L),
      leafHash: b,
      timelockBlocks: pe,
      unbondingFeeSat: $
    },
    derivationPath: c,
    isTestnet: p
  });
}, getSlashingPolicy = (n, c, u, p, a) => {
  const A = n.find((Pe) => Pe.id === BABYLON_SIGNING_CONTRACTS.SLASHING);
  if (!A)
    throw new Error("Slashing contract is required in slashing transaction");
  const b = n.find((Pe) => Pe.id === BABYLON_SIGNING_CONTRACTS.STAKING);
  if (!b)
    throw new Error("Staking contract is required in slashing transaction");
  const F = n.find((Pe) => Pe.id === BABYLON_SIGNING_CONTRACTS.SLASHING_BURN);
  if (!F)
    throw new Error("Slashing burn contract is required in unbonding slashing transaction");
  const { unbondingTimeBlocks: le, slashingFeeSat: L } = A.params, { covenantPks: pe, finalityProviders: $, covenantThreshold: Ee } = b.params, { slashingPkScriptHex: be } = F.params, He = mainExports.computeLeafHash(a);
  if (!He)
    throw new Error("Could not compute leaf hash");
  return mainExports.slashingPathPolicy({
    policyName: SLASHING_POLICY,
    transport: u,
    params: {
      leafHash: He,
      timelockBlocks: le,
      finalityProviders: $,
      covenantThreshold: Ee,
      covenantPks: sortPkHexes(pe),
      slashingPkScriptHex: be,
      slashingFeeSat: L
    },
    derivationPath: c,
    isTestnet: p
  });
}, getUnbondingSlashingPolicy = (n, c, u, p, a) => {
  const A = n.find((Pe) => Pe.id === BABYLON_SIGNING_CONTRACTS.SLASHING);
  if (!A)
    throw new Error("Slashing contract is required in unbonding slashing transaction");
  const b = n.find((Pe) => Pe.id === BABYLON_SIGNING_CONTRACTS.UNBONDING);
  if (!b)
    throw new Error("Unbonding contract is required in unbonding slashing transaction");
  const F = n.find((Pe) => Pe.id === BABYLON_SIGNING_CONTRACTS.SLASHING_BURN);
  if (!F)
    throw new Error("Slashing burn contract is required in unbonding slashing transaction");
  const { unbondingTimeBlocks: le, slashingFeeSat: L } = A.params, { covenantPks: pe, finalityProviders: $, covenantThreshold: Ee } = b.params, { slashingPkScriptHex: be } = F.params, He = mainExports.computeLeafHash(a);
  if (!He)
    throw new Error("Could not compute leaf hash");
  return mainExports.slashingPathPolicy({
    policyName: UNBONDING_SLASHING_POLICY,
    transport: u,
    params: {
      leafHash: He,
      timelockBlocks: le,
      finalityProviders: $,
      covenantThreshold: Ee,
      covenantPks: sortPkHexes(pe),
      slashingPkScriptHex: be,
      slashingFeeSat: L
    },
    derivationPath: c,
    isTestnet: p
  });
}, getWithdrawPolicy = (n, c, u, p, a) => {
  const A = n.find((le) => le.id === BABYLON_SIGNING_CONTRACTS.WITHDRAW);
  if (!A)
    throw new Error("Withdraw timelock expired contract is required");
  const { timelockBlocks: b } = A.params, F = mainExports.computeLeafHash(u);
  if (!F)
    throw new Error("Could not compute leaf hash");
  return mainExports.timelockPathPolicy({
    policyName: WITHDRAWAL_POLICY,
    transport: p,
    params: {
      leafHash: F,
      timelockBlocks: b
    },
    derivationPath: c,
    isTestnet: a
  });
}, WALLET_PROVIDER_NAME$3 = "Ledger";
class LedgerProvider {
  constructor(c, u) {
    As(this, "ledgerWalletInfo");
    As(this, "config");
    As(this, "connectWallet", async () => {
      const c = await this.createAppClient(), u = await c.getMasterFingerprint(), p = this.getDerivationPath(), a = await c.getExtendedPubkey(p), A = await this.getWalletPolicy(c, u, p);
      if (!A) throw new Error("Could not retrieve the policy");
      const { address: b, publicKeyHex: F } = await this.getTaprootAccount(
        c,
        A,
        a
      );
      this.ledgerWalletInfo = {
        app: c,
        policy: A,
        mfp: u,
        extendedPublicKey: a,
        path: p,
        address: b,
        publicKeyHex: F
      };
    });
    As(this, "getAddress", async () => {
      var c;
      if (!((c = this.ledgerWalletInfo) != null && c.address)) throw new Error("Could not retrieve the address");
      return this.ledgerWalletInfo.address;
    });
    As(this, "getPublicKeyHex", async () => {
      var c;
      if (!((c = this.ledgerWalletInfo) != null && c.publicKeyHex)) throw new Error("Could not retrieve the BTC public key");
      return this.ledgerWalletInfo.publicKeyHex;
    });
    As(this, "signPsbt", async (c, u) => {
      var L, pe, $;
      if (!((L = this.ledgerWalletInfo) != null && L.address) || !((pe = this.ledgerWalletInfo) != null && pe.publicKeyHex))
        throw new Error("Ledger is not connected");
      if (!c) throw new Error("psbt hex is required");
      const p = Buffer$1$1.from(c, "hex").toString("base64"), a = this.ledgerWalletInfo.app.transport;
      if (!a || !(a instanceof Transport))
        throw new Error("Transport is required to sign psbt");
      if (!this.ledgerWalletInfo.path)
        throw new Error("Derivation path is required to sign psbt");
      if (!(u != null && u.contracts) || (u == null ? void 0 : u.contracts.length) === 0)
        throw new Error("Contracts are required to sign psbt in ledger");
      if (!(($ = u == null ? void 0 : u.action) != null && $.name))
        throw new Error("Action name is required to sign psbt in ledger");
      const A = await getPolicyForTransaction(
        a,
        this.config.network,
        this.ledgerWalletInfo.path,
        p,
        {
          contracts: u.contracts,
          action: u.action
        }
      ), b = await mainExports.signPsbt({
        transport: a,
        psbt: p,
        policy: A
      }), F = Transaction$1.fromPSBT(b.toPSBT(), {
        allowUnknownInputs: !0,
        allowUnknownOutputs: !0
      });
      return F.finalize(), Buffer$1$1.from(F.toPSBT()).toString("hex");
    });
    As(this, "signPsbts", async (c, u) => {
      var a, A, b;
      if (!((a = this.ledgerWalletInfo) != null && a.address) || !((A = this.ledgerWalletInfo) != null && A.publicKeyHex) || !((b = this.ledgerWalletInfo) != null && b.policy))
        throw new Error("Ledger is not connected");
      if (!c || !Array.isArray(c) || c.length === 0)
        throw new Error("psbts hexes are required");
      const p = [];
      for (let F = 0; F < c.length; F++) {
        const le = c[F], L = u ? u[F] : void 0;
        if (!le)
          throw new Error(`psbt hex at index ${F} is required`);
        if (typeof le != "string")
          throw new Error(`psbt hex at index ${F} must be a string`);
        const pe = await this.signPsbt(le, L);
        p.push(pe);
      }
      return p;
    });
    As(this, "getNetwork", async () => this.config.network);
    As(this, "signMessage", async (c, u) => {
      var A, b, F;
      if (!((A = this.ledgerWalletInfo) != null && A.app.transport) || !((b = this.ledgerWalletInfo) != null && b.path))
        throw new Error("Ledger is not connected");
      const p = this.config.network !== Network.MAINNET;
      return (await mainExports.signMessage({
        transport: (F = this.ledgerWalletInfo) == null ? void 0 : F.app.transport,
        message: c,
        type: u,
        isTestnet: p,
        derivationPath: this.ledgerWalletInfo.path
      })).signature;
    });
    As(this, "getInscriptions", async () => {
      throw new Error("Method not implemented.");
    });
    // Not implemented because of the hardware wallet nature
    As(this, "on", () => {
    });
    As(this, "off", () => {
    });
    As(this, "getWalletProviderName", async () => WALLET_PROVIDER_NAME$3);
    As(this, "getWalletProviderIcon", async () => logo$3);
    this.config = u;
  }
  // Create a transport instance for Ledger devices
  // It first tries to create a WebUSB transport
  // and if that fails, it falls back to WebHID
  async createTransport() {
    try {
      return await TransportWebUSB.create();
    } catch (c) {
      try {
        return await TransportWebHID.create();
      } catch (u) {
        throw new Error(
          `Could not connect to Ledger device: ${c.message || c}, ${u.message || u}`
        );
      }
    }
  }
  // Get the network derivation index based on the network
  // 0 for MAINNET, 1 for TESTNET
  getNetworkDerivationIndex() {
    return this.config.network === Network.MAINNET ? 0 : 1;
  }
  getDerivationPath() {
    return `m/86'/${this.getNetworkDerivationIndex()}'/0'`;
  }
  // Create a new AppClient instance using the transport
  async createAppClient() {
    const c = await this.createTransport();
    return new AppClient(c);
  }
  async getWalletPolicy(c, u, p) {
    const a = await c.getExtendedPubkey(p);
    if (!a)
      throw new Error("Could not retrieve the extended public key for policy");
    const A = this.getNetworkDerivationIndex(), b = new mainExports.DefaultWalletPolicy("tr(@0/**)", `[${u}/86'/${A}'/0']${a}`);
    if (!b)
      throw new Error("Could not create the wallet policy");
    return b;
  }
  async getTaprootAccount(c, u, p) {
    const a = await c.getWalletAddress(
      u,
      null,
      0,
      // 0 - normal, 1 - change
      0,
      // address index
      !0
      // show address on the wallet's screen
    ), A = await this.getNetwork(), b = getPublicKeyFromXpub(p, "M/0/0", toNetwork(A));
    return { address: a, publicKeyHex: b.toString("hex") };
  }
}
const metadata$5 = {
  id: "ledget_btc",
  name: WALLET_PROVIDER_NAME$3,
  icon: logo$3,
  docs: "https://www.ledger.com/ledger-live",
  createProvider: (n, c) => new LedgerProvider(n, c),
  networks: [Network.SIGNET, Network.MAINNET],
  label: "Hardware wallet"
}, logo$2 = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'?%3e%3csvg%20width='225px'%20height='224px'%20viewBox='0%200%20225%20224'%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3ctitle%3eokx%3c/title%3e%3cg%20id='Page-1'%20stroke='none'%20strokeWidth='1'%20fill='none'%20fill-rule='evenodd'%3e%3cg%20id='okx'%20transform='translate(0.401000,%200.006000)'%20fill='%23000000'%20fill-rule='nonzero'%3e%3cpath%20d='M144.382,74.667%20L79.673,74.667%20C76.924,74.667%2074.695,76.895%2074.695,79.644%20L74.695,144.354%20C74.695,147.103%2076.924,149.332%2079.673,149.332%20L144.382,149.332%20C147.131,149.332%20149.36,147.103%20149.36,144.354%20L149.36,79.644%20C149.36,76.895%20147.131,74.667%20144.382,74.667%20Z'%20id='Path'%3e%3c/path%3e%3cpath%20d='M69.687,0%20L4.978,0%20C2.229,0%200,2.228%200,4.978%20L0,69.687%20C0,72.436%202.229,74.665%204.978,74.665%20L69.687,74.665%20C72.437,74.665%2074.665,72.436%2074.665,69.687%20L74.665,4.978%20C74.665,2.228%2072.437,0%2069.687,0%20Z'%20id='Path'%3e%3c/path%3e%3cpath%20d='M219.017,0%20L154.307,0%20C151.558,0%20149.329,2.228%20149.329,4.978%20L149.329,69.687%20C149.329,72.436%20151.558,74.665%20154.307,74.665%20L219.017,74.665%20C221.766,74.665%20223.994,72.436%20223.994,69.687%20L223.994,4.978%20C223.994,2.228%20221.766,0%20219.017,0%20Z'%20id='Path'%3e%3c/path%3e%3cpath%20d='M69.687,149.328%20L4.978,149.328%20C2.229,149.328%200,151.556%200,154.305%20L0,219.015%20C0,221.764%202.229,223.993%204.978,223.993%20L69.687,223.993%20C72.437,223.993%2074.665,221.764%2074.665,219.015%20L74.665,154.305%20C74.665,151.556%2072.437,149.328%2069.687,149.328%20Z'%20id='Path'%3e%3c/path%3e%3cpath%20d='M219.017,149.328%20L154.307,149.328%20C151.558,149.328%20149.329,151.556%20149.329,154.305%20L149.329,219.015%20C149.329,221.764%20151.558,223.993%20154.307,223.993%20L219.017,223.993%20C221.766,223.993%20223.994,221.764%20223.994,219.015%20L223.994,154.305%20C223.994,151.556%20221.766,149.328%20219.017,149.328%20Z'%20id='Path'%3e%3c/path%3e%3c/g%3e%3c/g%3e%3c/svg%3e", PROVIDER_NAMES = {
  [Network.MAINNET]: "bitcoin",
  [Network.TESTNET]: "bitcoinTestnet",
  [Network.SIGNET]: "bitcoinSignet"
}, WALLET_PROVIDER_NAME$2 = "OKX";
class OKXProvider {
  constructor(c, u) {
    As(this, "provider");
    As(this, "walletInfo");
    As(this, "config");
    As(this, "connectWallet", async () => {
      var a;
      let c;
      try {
        c = await this.provider.connect();
      } catch (A) {
        throw (a = A == null ? void 0 : A.message) != null && a.includes("rejected") ? new WalletError({
          code: ERROR_CODES.CONNECTION_REJECTED,
          message: "Connection to OKX Wallet was rejected",
          wallet: WALLET_PROVIDER_NAME$2
        }) : new WalletError({
          code: ERROR_CODES.CONNECTION_FAILED,
          message: (A == null ? void 0 : A.message) || "Failed to connect to OKX Wallet",
          wallet: WALLET_PROVIDER_NAME$2
        });
      }
      const { address: u, compressedPublicKey: p } = c;
      if (p && u)
        this.walletInfo = {
          publicKeyHex: p,
          address: u
        };
      else
        throw new WalletError({
          code: ERROR_CODES.CONNECTION_FAILED,
          message: "Could not connect to OKX Wallet",
          wallet: WALLET_PROVIDER_NAME$2
        });
    });
    As(this, "getAddress", async () => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "OKX Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$2
        });
      return this.walletInfo.address;
    });
    As(this, "getPublicKeyHex", async () => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "OKX Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$2
        });
      return this.walletInfo.publicKeyHex;
    });
    As(this, "signPsbt", async (c) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "OKX Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$2
        });
      return await this.provider.signPsbt(c);
    });
    As(this, "signPsbts", async (c) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "OKX Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$2
        });
      return await this.provider.signPsbts(c);
    });
    As(this, "getNetwork", async () => {
      if (!this.config.network)
        throw new WalletError({
          code: ERROR_CODES.INVALID_PARAMS,
          // Or a new code like CONFIG_ERROR
          message: "Network not set in config",
          wallet: WALLET_PROVIDER_NAME$2
        });
      return this.config.network;
    });
    As(this, "signMessage", async (c, u) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "OKX Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$2
        });
      return await this.provider.signMessage(c, u);
    });
    // Inscriptions are only available on OKX Wallet BTC mainnet (i.e okxWallet.bitcoin)
    As(this, "getInscriptions", async () => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "OKX Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$2
        });
      if (this.config.network !== Network.MAINNET)
        throw new WalletError({
          code: ERROR_CODES.INSCRIPTIONS_UNSUPPORTED_NETWORK,
          message: "Inscriptions are only available on OKX Wallet BTC mainnet",
          wallet: WALLET_PROVIDER_NAME$2,
          chainId: this.config.network
        });
      const c = 100, u = 100, p = [];
      let a = 0, A = 0;
      try {
        for (; A < c; ) {
          const { list: b } = await this.provider.getInscriptions(a, u), F = b.map((le) => {
            const [L, pe] = le.output.split(":");
            return {
              txid: L,
              vout: pe
            };
          });
          if (p.push(...F), b.length < u)
            break;
          if (a += u, A++, A >= c)
            throw new WalletError({
              code: ERROR_CODES.MAX_ITERATION_EXCEEDED,
              message: "Exceeded maximum iterations when fetching inscriptions",
              wallet: WALLET_PROVIDER_NAME$2
            });
        }
      } catch {
        throw new WalletError({
          code: ERROR_CODES.INSCRIPTION_FETCH_ERROR,
          message: "Failed to get inscriptions from OKX Wallet",
          wallet: WALLET_PROVIDER_NAME$2
        });
      }
      return p;
    });
    As(this, "on", (c, u) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "OKX Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$2
        });
      if (c === "accountChanged")
        return this.provider.on(c, u);
    });
    As(this, "off", (c, u) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "OKX Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$2
        });
      if (c === "accountChanged")
        return this.provider.off(c, u);
    });
    As(this, "getWalletProviderName", async () => WALLET_PROVIDER_NAME$2);
    As(this, "getWalletProviderIcon", async () => logo$2);
    if (this.config = u, !c)
      throw new WalletError({
        code: ERROR_CODES.EXTENSION_NOT_FOUND,
        message: "OKX Wallet extension not found",
        wallet: WALLET_PROVIDER_NAME$2
      });
    const p = PROVIDER_NAMES[u.network];
    if (!p)
      throw new WalletError({
        code: ERROR_CODES.UNSUPPORTED_NETWORK,
        message: "Unsupported network",
        wallet: WALLET_PROVIDER_NAME$2
      });
    this.provider = c[p];
  }
}
const metadata$4 = {
  id: "okx",
  name: WALLET_PROVIDER_NAME$2,
  icon: logo$2,
  docs: "https://www.okx.com/web3",
  wallet: "okxwallet",
  createProvider: (n, c) => new OKXProvider(n, c),
  networks: [Network.MAINNET, Network.SIGNET]
}, logo$1 = "data:image/svg+xml,%3csvg%20width='288'%20height='288'%20viewBox='72%2072%20144%20144'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M144%20216C193.706%20216%20216%20193.706%20216%20144C216%2094.2944%20193.706%2072%20144%2072C94.2944%2072%2072%2094.2944%2072%20144C72%20193.706%2094.2944%20216%20144%20216ZM130.475%20102.531H150.505V135.538H138.086V113.156H126.961L130.475%20102.531ZM144%20185.469C156.616%20185.469%20166.844%20175.242%20166.844%20162.626C166.844%20150.01%20156.616%20139.783%20144%20139.783C131.384%20139.783%20121.157%20150.01%20121.157%20162.626C121.157%20175.242%20131.384%20185.469%20144%20185.469ZM144%20175.099C150.889%20175.099%20156.473%20169.515%20156.473%20162.626C156.473%20155.738%20150.889%20150.153%20144%20150.153C137.112%20150.153%20131.528%20155.738%20131.528%20162.626C131.528%20169.515%20137.112%20175.099%20144%20175.099Z'%20fill='black'%20style='fill:black;fill-opacity:1;'/%3e%3c/svg%3e", INTERNAL_NETWORK_NAMES = {
  [Network.MAINNET]: "livenet",
  [Network.TESTNET]: "testnet",
  [Network.SIGNET]: "signet"
}, WALLET_PROVIDER_NAME$1 = "OneKey";
class OneKeyProvider {
  constructor(c, u) {
    As(this, "provider");
    As(this, "walletInfo");
    As(this, "config");
    As(this, "connectWallet", async () => {
      var p;
      try {
        await this.provider.connectWallet();
      } catch (a) {
        throw (p = a == null ? void 0 : a.message) != null && p.includes("rejected") ? new WalletError({
          code: ERROR_CODES.CONNECTION_REJECTED,
          message: "Connection to OneKey Wallet was rejected",
          wallet: WALLET_PROVIDER_NAME$1
        }) : new WalletError({
          code: ERROR_CODES.CONNECTION_FAILED,
          message: (a == null ? void 0 : a.message) || "Failed to connect to OneKey Wallet",
          wallet: WALLET_PROVIDER_NAME$1
        });
      }
      const c = await this.provider.getAddress(), u = await this.provider.getPublicKeyHex();
      if (u && c)
        this.walletInfo = {
          publicKeyHex: u,
          address: c
        };
      else
        throw new WalletError({
          code: ERROR_CODES.CONNECTION_FAILED,
          message: "Could not connect to OneKey Wallet",
          wallet: WALLET_PROVIDER_NAME$1
        });
    });
    As(this, "getAddress", async () => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "OneKey Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$1
        });
      return this.walletInfo.address;
    });
    As(this, "getPublicKeyHex", async () => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "OneKey Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$1
        });
      return this.walletInfo.publicKeyHex;
    });
    As(this, "signPsbt", async (c) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "OneKey Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$1
        });
      if (!c)
        throw new WalletError({
          code: ERROR_CODES.PSBT_HEX_REQUIRED,
          message: "psbt hex is required",
          wallet: WALLET_PROVIDER_NAME$1
        });
      return this.provider.signPsbt(c);
    });
    As(this, "signPsbts", async (c) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "OneKey Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$1
        });
      if (!c || !Array.isArray(c) || c.length === 0)
        throw new WalletError({
          code: ERROR_CODES.PSBTS_HEXES_REQUIRED,
          message: "psbts hexes are required and must be a non-empty array",
          wallet: WALLET_PROVIDER_NAME$1
        });
      return this.provider.signPsbts(c);
    });
    As(this, "getNetwork", async () => {
      const c = await this.provider.getNetwork();
      for (const [u, p] of Object.entries(INTERNAL_NETWORK_NAMES)) {
        if (p === "testnet")
          return Network.SIGNET;
        if (p === c)
          return u;
      }
      throw new WalletError({
        code: ERROR_CODES.UNSUPPORTED_NETWORK,
        message: "Unsupported network from OneKey Wallet",
        wallet: WALLET_PROVIDER_NAME$1
      });
    });
    As(this, "signMessage", async (c, u) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "OneKey Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$1
        });
      return await this.provider.signMessage(c, u);
    });
    // Inscriptions are only available on OneKey Wallet BTC mainnet
    As(this, "getInscriptions", async () => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "OneKey Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$1
        });
      if (this.config.network !== Network.MAINNET)
        throw new WalletError({
          code: ERROR_CODES.INSCRIPTIONS_UNSUPPORTED_NETWORK,
          message: "Inscriptions are only available on OneKey Wallet BTC Mainnet",
          wallet: WALLET_PROVIDER_NAME$1,
          chainId: this.config.network
        });
      const c = 100, u = 100, p = [];
      let a = 0, A = 0;
      try {
        for (; A < c; ) {
          const { list: b } = await this.provider.getInscriptions(a, u), F = b.map((le) => {
            const [L, pe] = le.output.split(":");
            return {
              txid: L,
              vout: pe
            };
          });
          if (p.push(...F), b.length < u)
            break;
          if (a += u, A++, A >= c)
            throw new WalletError({
              code: ERROR_CODES.MAX_ITERATION_EXCEEDED,
              message: "Exceeded maximum iterations when fetching inscriptions",
              wallet: WALLET_PROVIDER_NAME$1
            });
        }
      } catch {
        throw new WalletError({
          code: ERROR_CODES.INSCRIPTION_FETCH_ERROR,
          message: "Failed to get inscriptions from OneKey Wallet",
          wallet: WALLET_PROVIDER_NAME$1
        });
      }
      return p;
    });
    As(this, "on", (c, u) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "OneKey Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$1
        });
      if (c === "accountChanged")
        return this.provider.on(c, u);
    });
    As(this, "off", (c, u) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "OneKey Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$1
        });
      if (c === "accountChanged")
        return this.provider.off(c, u);
    });
    As(this, "getWalletProviderName", async () => WALLET_PROVIDER_NAME$1);
    As(this, "getWalletProviderIcon", async () => logo$1);
    if (this.config = u, !(c != null && c.btcwallet))
      throw new WalletError({
        code: ERROR_CODES.EXTENSION_NOT_FOUND,
        message: "OneKey Wallet extension not found",
        wallet: WALLET_PROVIDER_NAME$1
      });
    this.provider = c.btcwallet;
  }
}
const metadata$3 = {
  id: "onekey",
  name: WALLET_PROVIDER_NAME$1,
  icon: logo$1,
  docs: "https://onekey.so/download",
  wallet: "$onekey",
  createProvider: (n, c) => new OneKeyProvider(n, c),
  networks: [Network.MAINNET, Network.SIGNET]
}, logo = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='59'%20height='59'%3e%3cdefs%3e%3clinearGradient%20id='a'%20x1='91.9%25'%20x2='5.127%25'%20y1='28.561%25'%20y2='67.452%25'%3e%3cstop%20offset='0%25'%20stop-color='%23070100'/%3e%3cstop%20offset='36%25'%20stop-color='%2377390D'/%3e%3cstop%20offset='67%25'%20stop-color='%23EA8101'/%3e%3cstop%20offset='100%25'%20stop-color='%23F4B852'/%3e%3c/linearGradient%3e%3clinearGradient%20id='b'%20x1='10.514%25'%20x2='111.046%25'%20y1='63.228%25'%20y2='37.55%25'%3e%3cstop%20offset='0%25'%20stop-color='%23070100'/%3e%3cstop%20offset='37%25'%20stop-color='%2377390D'/%3e%3cstop%20offset='67%25'%20stop-color='%23EA8101'/%3e%3cstop%20offset='100%25'%20stop-color='%23F4FB52'/%3e%3c/linearGradient%3e%3cradialGradient%20id='c'%20cx='49.933%25'%20cy='50.067%25'%20r='50%25'%20fx='49.933%25'%20fy='50.067%25'%3e%3cstop%20offset='0%25'%20stop-color='%23F4B852'/%3e%3cstop%20offset='33%25'%20stop-color='%23EA8101'/%3e%3cstop%20offset='64%25'%20stop-color='%2377390D'/%3e%3cstop%20offset='100%25'%20stop-color='%23070100'/%3e%3c/radialGradient%3e%3c/defs%3e%3cg%20fill='none'%20fill-rule='nonzero'%20transform='translate(7%201)'%3e%3cpath%20fill='url(%23a)'%20d='m31.764%205.2%2011.761%2011.745c1%20.997%201.492%202.006%201.475%203.027-.018%201.014-.446%201.947-1.29%202.787-.879.88-1.827%201.33-2.845%201.347-1.017.018-2.023-.478-3.03-1.475L25.81%2010.617c-1.365-1.364-2.683-2.332-3.955-2.898-1.267-.566-2.602-.653-4.002-.268-1.399.385-2.902%201.382-4.51%202.991-2.22%202.217-3.278%204.298-3.168%206.246.11%201.948%201.208%203.96%203.301%206.054L25.6%2034.854c1.012%201.01%201.51%202.018%201.492%203.021-.017%201.003-.45%201.936-1.307%202.788-.855.851-1.792%201.3-2.821%201.335-1.024.035-2.041-.455-3.053-1.464L8.16%2028.79c-1.913-1.913-3.295-3.72-4.145-5.423-.85-1.703-1.168-3.633-.949-5.785.197-1.843.787-3.628%201.758-5.36.977-1.732%202.37-3.499%204.18-5.313%202.157-2.157%204.216-3.808%206.182-4.957C17.153.803%2019.049.161%2020.882.027c1.833-.134%203.643.233%205.435%201.102%201.787.869%203.603%202.222%205.453%204.07h-.006Z'/%3e%3cpath%20fill='url(%23b)'%20d='M13.234%2051.841%201.474%2040.188c-1-.99-1.49-1.99-1.474-3.003.018-1.012.446-1.932%201.29-2.766.878-.873%201.827-1.319%202.844-1.336%201.018-.017%202.024.469%203.03%201.464l12.025%2011.919c1.37%201.354%202.682%202.314%203.954%202.876%201.272.56%202.602.648%204%20.266%201.4-.382%202.903-1.372%204.51-2.968%202.22-2.2%203.278-4.265%203.169-6.197-.11-1.933-1.209-3.935-3.302-6.006l-6.457-6.347c-1.012-1.001-1.51-2.002-1.492-2.998.017-.995.451-1.92%201.307-2.765.855-.845%201.792-1.29%202.82-1.325%201.024-.035%202.042.451%203.053%201.452l6.088%205.983c1.914%201.898%203.296%203.691%204.145%205.38.85%201.69%201.168%203.605.949%205.74-.197%201.829-.787%203.6-1.758%205.318-.977%201.718-2.37%203.471-4.18%205.27-2.156%202.142-4.214%203.78-6.18%204.919-1.966%201.14-3.862%201.776-5.695%201.91-1.832.132-3.642-.232-5.434-1.094-1.787-.862-3.608-2.205-5.452-4.039Z'/%3e%3ccircle%20cx='20'%20cy='18'%20r='4'%20fill='url(%23c)'/%3e%3c/g%3e%3c/svg%3e", WALLET_PROVIDER_NAME = "Unisat";
class UnisatProvider {
  constructor(c, u) {
    As(this, "provider");
    As(this, "walletInfo");
    As(this, "config");
    As(this, "connectWallet", async () => {
      var a;
      let c;
      try {
        c = await this.provider.requestAccounts();
      } catch (A) {
        throw (a = A == null ? void 0 : A.message) != null && a.includes("rejected") ? new WalletError({
          code: ERROR_CODES.CONNECTION_REJECTED,
          message: "Connection to Unisat Wallet was rejected",
          wallet: WALLET_PROVIDER_NAME
        }) : new WalletError({
          code: ERROR_CODES.CONNECTION_FAILED,
          message: (A == null ? void 0 : A.message) || "Failed to request accounts from Unisat Wallet",
          wallet: WALLET_PROVIDER_NAME
        });
      }
      const u = c[0], p = await this.provider.getPublicKey();
      if (p && u)
        this.walletInfo = {
          publicKeyHex: p,
          address: u
        };
      else
        throw new WalletError({
          code: ERROR_CODES.CONNECTION_FAILED,
          message: "Could not connect to Unisat Wallet",
          wallet: WALLET_PROVIDER_NAME
        });
    });
    As(this, "getAddress", async () => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Unisat Wallet not connected",
          wallet: WALLET_PROVIDER_NAME
        });
      return this.walletInfo.address;
    });
    As(this, "getPublicKeyHex", async () => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Unisat Wallet not connected",
          wallet: WALLET_PROVIDER_NAME
        });
      return this.walletInfo.publicKeyHex;
    });
    As(this, "signPsbt", async (c, u) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Unisat Wallet not connected",
          wallet: WALLET_PROVIDER_NAME
        });
      if (!c)
        throw new WalletError({
          code: ERROR_CODES.PSBT_HEX_REQUIRED,
          message: "psbt hex is required",
          wallet: WALLET_PROVIDER_NAME
        });
      const p = await this.getNetwork();
      try {
        const A = {
          ...this.getSignPsbtDefaultOptions(c, p),
          ...u
        };
        return await this.provider.signPsbt(c, A);
      } catch (a) {
        throw new WalletError({
          code: ERROR_CODES.SIGNATURE_EXTRACT_ERROR,
          message: (a == null ? void 0 : a.message) || "Failed to sign PSBT with Unisat Wallet",
          wallet: WALLET_PROVIDER_NAME
        });
      }
    });
    // Order of PSBTs in the array must be the same as the order of options
    As(this, "signPsbts", async (c, u) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Unisat Wallet not connected",
          wallet: WALLET_PROVIDER_NAME
        });
      if (!c || !Array.isArray(c) || c.length === 0)
        throw new WalletError({
          code: ERROR_CODES.PSBTS_HEXES_REQUIRED,
          message: "psbts hexes are required and must be a non-empty array",
          wallet: WALLET_PROVIDER_NAME
        });
      const p = await this.getNetwork();
      try {
        const a = c.map((b) => this.getSignPsbtDefaultOptions(b, p)), A = u == null ? void 0 : u.map((b, F) => ({
          ...a[F],
          ...b
        }));
        return await this.provider.signPsbts(c, A);
      } catch (a) {
        throw new WalletError({
          code: ERROR_CODES.SIGNATURE_EXTRACT_ERROR,
          message: (a == null ? void 0 : a.message) || "Failed to sign PSBTs with Unisat Wallet",
          wallet: WALLET_PROVIDER_NAME
        });
      }
    });
    As(this, "getNetwork", async () => {
      switch ((await this.provider.getChain()).enum) {
        case "BITCOIN_MAINNET":
          return Network.MAINNET;
        case "BITCOIN_SIGNET":
          return Network.SIGNET;
        case "BITCOIN_TESTNET":
          return Network.SIGNET;
        default:
          throw new WalletError({
            code: ERROR_CODES.UNSUPPORTED_NETWORK,
            message: "Unsupported network from Unisat Wallet",
            wallet: WALLET_PROVIDER_NAME
          });
      }
    });
    As(this, "signMessage", async (c, u) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Unisat Wallet not connected",
          wallet: WALLET_PROVIDER_NAME
        });
      return await this.provider.signMessage(c, u);
    });
    As(this, "getInscriptions", async () => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Unisat Wallet not connected",
          wallet: WALLET_PROVIDER_NAME
        });
      if (this.config.network !== Network.MAINNET)
        throw new WalletError({
          code: ERROR_CODES.INSCRIPTIONS_UNSUPPORTED_NETWORK,
          message: "Inscriptions are only available on Unisat Wallet BTC Mainnet",
          wallet: WALLET_PROVIDER_NAME,
          chainId: this.config.network
        });
      const c = 100, u = 100, p = [];
      let a = 0, A = 0;
      try {
        for (; A < c; ) {
          const { list: b } = await this.provider.getInscriptions(a, u), F = b.map((le) => {
            const [L, pe] = le.output.split(":");
            return {
              txid: L,
              vout: pe
            };
          });
          if (p.push(...F), b.length < u)
            break;
          if (a += u, A++, A >= c)
            throw new WalletError({
              code: ERROR_CODES.MAX_ITERATION_EXCEEDED,
              message: "Exceeded maximum iterations when fetching inscriptions",
              wallet: WALLET_PROVIDER_NAME
            });
        }
      } catch {
        throw new WalletError({
          code: ERROR_CODES.INSCRIPTION_FETCH_ERROR,
          message: "Failed to get inscriptions from Unisat Wallet",
          wallet: WALLET_PROVIDER_NAME
        });
      }
      return p;
    });
    As(this, "on", (c, u) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Unisat Wallet not connected",
          wallet: WALLET_PROVIDER_NAME
        });
      if (c === "accountChanged")
        return this.provider.on("accountsChanged", u);
    });
    As(this, "off", (c, u) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Unisat Wallet not connected",
          wallet: WALLET_PROVIDER_NAME
        });
      if (c === "accountChanged")
        return this.provider.removeListener("accountsChanged", u);
    });
    As(this, "getWalletProviderName", async () => WALLET_PROVIDER_NAME);
    As(this, "getWalletProviderIcon", async () => logo);
    if (this.config = u, !c)
      throw new WalletError({
        code: ERROR_CODES.EXTENSION_NOT_FOUND,
        message: "Unisat Wallet extension not found",
        wallet: WALLET_PROVIDER_NAME
      });
    this.provider = c;
  }
  getSignPsbtDefaultOptions(c, u) {
    const p = [];
    return src$j.Psbt.fromHex(c).data.inputs.forEach((A, b) => {
      var L, pe;
      let F = !1;
      if (A.witnessUtxo && A.witnessUtxo.script) {
        let $ = src$j.networks.bitcoin;
        (u === Network.TESTNET || u === Network.SIGNET) && ($ = src$j.networks.testnet);
        let Ee;
        try {
          Ee = src$j.address.fromOutputScript(A.witnessUtxo.script, $);
        } catch (Pe) {
          if (Pe instanceof Error && Pe.message.toLowerCase().includes("has no matching address"))
            initBTCCurve(), Ee = src$j.address.fromOutputScript(A.witnessUtxo.script, $);
          else
            throw new WalletError({
              code: ERROR_CODES.UNKNOWN_ERROR,
              // Or a more specific address generation error
              message: (Pe == null ? void 0 : Pe.message) || "Failed to determine address from output script",
              wallet: WALLET_PROVIDER_NAME
            });
        }
        const be = Ee.indexOf("tb1p") === 0 || Ee.indexOf("bc1p") === 0, He = Ee === ((L = this.walletInfo) == null ? void 0 : L.address);
        be && He && (F = !0);
      }
      A.finalScriptSig || A.finalScriptWitness || p.push({
        index: b,
        publicKey: (pe = this.walletInfo) == null ? void 0 : pe.publicKeyHex,
        sighashTypes: void 0,
        useTweakedSigner: F
      });
    }), {
      autoFinalized: !0,
      toSignInputs: p
    };
  }
}
const metadata$2 = {
  id: "unisat",
  name: WALLET_PROVIDER_NAME,
  icon: logo,
  docs: "https://unisat.io/download",
  wallet: (n) => n.unisat_wallet ?? n.unisat,
  createProvider: (n, c) => new UnisatProvider(n, c),
  networks: [Network.MAINNET, Network.SIGNET]
}, metadata$1 = {
  chain: "BTC",
  name: "Bitcoin",
  icon,
  wallets: [metadata$4, metadata$7, metadata$3, metadata$2, metadata$5, metadata$6]
}, metadata = { BTC: metadata$1, BBN: metadata$8 };
function usePersistState(n, c, u) {
  function p() {
    const b = u;
    if (typeof c > "u")
      return b;
    const F = c.getItem(n);
    return (F ? JSON.parse(F) : null) ?? b;
  }
  const [a, A] = useState(p);
  return useEffect(
    function() {
      c.setItem(n, JSON.stringify(a ?? ""));
    },
    [n, c, a]
  ), [a, A];
}
const Context$2 = createContext({ lockInscriptions: !0, showAgain: !0 });
function InscriptionProvider({ children: n, context: c }) {
  const [u, p] = usePersistState("bwc-inscription-modal-show-again", c.localStorage, !0), [a, A] = usePersistState(
    "bwc-inscription-modal-lock",
    c.localStorage,
    !0
  ), b = useMemo(
    () => ({
      showAgain: u,
      lockInscriptions: a,
      toggleLockInscriptions: A,
      toggleShowAgain: p
    }),
    [u, a, A, p]
  );
  return /* @__PURE__ */ jsx(Context$2.Provider, { value: b, children: n });
}
const useInscriptionProvider = () => useContext(Context$2), defaultState$2 = {
  confirmed: !1,
  visible: !1,
  screen: { type: "TERMS_OF_SERVICE" },
  chains: {},
  selectedWallets: {}
}, StateContext = createContext(defaultState$2);
function StateProvider({ children: n, chains: c }) {
  const [u, p] = useState(defaultState$2);
  useEffect(() => {
    p((b) => ({ ...b, chains: c.reduce((F, le) => ({ ...F, [le.id]: le }), {}) }));
  }, [c]);
  const a = useMemo(
    () => ({
      open: () => {
        p((b) => ({ ...b, visible: !0 }));
      },
      close: () => {
        p((b) => ({ ...b, visible: !1 }));
      },
      reset: () => {
        p(({ chains: b }) => ({ ...defaultState$2, chains: b }));
      },
      displayLoader: (b = "") => {
        p((F) => ({ ...F, screen: { type: "LOADER", params: { message: b } } }));
      },
      displayTermsOfService: () => {
        p((b) => ({ ...b, screen: { type: "TERMS_OF_SERVICE" } }));
      },
      displayChains: () => {
        p((b) => ({ ...b, screen: { type: "CHAINS" } }));
      },
      displayWallets: (b) => {
        p((F) => ({ ...F, screen: { type: "WALLETS", params: { chain: b } } }));
      },
      displayInscriptions: () => {
        p((b) => ({ ...b, screen: { type: "INSCRIPTIONS" } }));
      },
      displayError: (b) => {
        p((F) => ({ ...F, screen: { type: "ERROR", params: b } }));
      },
      selectWallet: (b, F) => {
        p((le) => ({
          ...le,
          selectedWallets: { ...le.selectedWallets, [b]: F }
        }));
      },
      removeWallet: (b) => {
        p((F) => ({
          ...F,
          selectedWallets: { ...F.selectedWallets, [b]: void 0 }
        }));
      },
      confirm: () => {
        p((b) => ({ ...b, confirmed: !0 }));
      }
    }),
    []
  ), A = useMemo(
    () => ({
      ...u,
      ...a
    }),
    [u, a]
  );
  return /* @__PURE__ */ jsx(StateContext.Provider, { value: A, children: n });
}
const defaultState$1 = {
  BTC: null,
  BBN: null
}, Context$1 = createContext(defaultState$1);
function ChainProvider({
  persistent: n,
  storage: c,
  children: u,
  context: p,
  config: a,
  onError: A,
  disabledWallets: b
}) {
  const [F, le] = useState(defaultState$1), L = useCallback(async () => {
    const $ = a.filter((be) => metadata[be.chain]).map(
      ({ chain: be, config: He }) => createWalletConnector({
        persistent: n,
        metadata: metadata[be],
        context: p,
        config: He,
        accountStorage: c,
        disabledWallets: b
      })
    );
    return (await Promise.all($)).reduce((be, He) => ({ ...be, [He.id]: He }), {});
  }, [n]);
  useEffect(() => {
    L().then(($) => {
      le($);
    }).catch(A);
  }, [le, L, A]);
  const pe = useMemo(() => Object.values(F).filter(Boolean), [F]);
  return /* @__PURE__ */ jsx(InscriptionProvider, { context: p, children: /* @__PURE__ */ jsx(StateProvider, { chains: pe, children: /* @__PURE__ */ jsx(Context$1.Provider, { value: F, children: u }) }) });
}
const useChainProviders = () => useContext(Context$1), Context = createContext({});
function LifeCycleHooksProvider({ children: n, value: c }) {
  const u = useMemo(() => c ?? {}, [c]);
  return /* @__PURE__ */ jsx(Context.Provider, { value: u, children: n });
}
const useLifeCycleHooks = () => useContext(Context), CONFIG_ADAPTERS = {
  BTC: (n) => ({
    id: 1,
    name: n.networkName,
    type: "bitcoin",
    network: n.network,
    backendUrls: {
      mempoolUrl: n.mempoolApiUrl + "/api/"
    }
  }),
  BBN: (n) => ({
    id: 2,
    name: n.chainData.chainName,
    type: "cosmos",
    network: n.chainId,
    modularData: n.chainData,
    backendUrls: {
      rpcUrl: n.rpc
    },
    logo: n.chainData.chainSymbolImageUrl
  })
}, TomoConnectionProvider = ({ children: n, theme: c, config: u }) => {
  const p = useMemo(
    () => u.reduce(
      (a, A) => {
        var b;
        return { ...a, [A.chain]: (b = CONFIG_ADAPTERS[A.chain]) == null ? void 0 : b.call(CONFIG_ADAPTERS, A.config) };
      },
      {}
    ),
    [u]
  );
  return /* @__PURE__ */ jsx(
    Dn,
    {
      autoReconnect: !1,
      bitcoinChains: [p.BTC],
      chainTypes: ["bitcoin", "cosmos"],
      cosmosChains: [p.BBN],
      style: {
        rounded: "medium",
        theme: c,
        primaryColor: "#FF7C2A"
      },
      children: n
    }
  );
}, CONNECTED_ACCOUNTS_KEY = "baby-connected-wallet-accounts", createAccountStorage = (n) => ({
  get: (c) => {
    const u = localStorage.getItem(CONNECTED_ACCOUNTS_KEY) ? JSON.parse(localStorage.getItem(CONNECTED_ACCOUNTS_KEY) || "{}") : {};
    if (!(u._timestamp && Date.now() - u._timestamp > n))
      return u[c];
  },
  has: (c) => {
    const u = localStorage.getItem(CONNECTED_ACCOUNTS_KEY) ? JSON.parse(localStorage.getItem(CONNECTED_ACCOUNTS_KEY) || "{}") : {};
    return u._timestamp && Date.now() - u._timestamp > n ? !1 : !!u[c];
  },
  set: (c, u) => {
    const p = localStorage.getItem(CONNECTED_ACCOUNTS_KEY) ? JSON.parse(localStorage.getItem(CONNECTED_ACCOUNTS_KEY) || "{}") : {};
    p[c] = u, p._timestamp = Date.now(), localStorage.setItem(CONNECTED_ACCOUNTS_KEY, JSON.stringify(p));
  },
  delete: (c) => {
    const u = localStorage.getItem(CONNECTED_ACCOUNTS_KEY) ? JSON.parse(localStorage.getItem(CONNECTED_ACCOUNTS_KEY) || "{}") : {}, p = Reflect.deleteProperty(u, c);
    return localStorage.setItem(CONNECTED_ACCOUNTS_KEY, JSON.stringify(u)), p;
  }
});
function useChainConnector(n) {
  const c = useChainProviders();
  return (c == null ? void 0 : c[n]) ?? null;
}
const createProvider$1 = (n) => ({
  connectWallet: async () => void await n.connectWallet(),
  getAddress: () => n.getAddress(),
  getPublicKeyHex: () => n.getPublicKeyHex(),
  getWalletProviderName: () => n.getWalletProviderName(),
  getWalletProviderIcon: () => n.getWalletProviderIcon(),
  getOfflineSigner: () => n.getOfflineSigner(),
  on: () => {
  },
  off: () => {
  }
}), TomoBBNConnector = memo(({ persistent: n, storage: c }) => {
  const u = Fn(), p = Nn("cosmos"), { cosmosProvider: a } = Hn(), A = Jn(), b = _0(), F = useChainConnector("BBN"), le = useMemo(() => {
    const { connected: pe, walletId: $ } = u.cosmos ?? {};
    return pe && $ ? p.find((Ee) => Ee.id === $) ?? null : null;
  }, [u.cosmos, p]), L = useCallback(
    async (pe, $) => {
      if (!F) return;
      const Ee = createExternalWallet({
        id: `tomo.${pe.id}`,
        name: pe.name,
        icon: pe.img,
        provider: createProvider$1($)
      });
      await F.connect(Ee);
    },
    [F]
  );
  return useEffect(() => {
    if (!n) return;
    const pe = c.get("BBN");
    if (!pe || !pe.startsWith("tomo.")) return;
    const $ = pe.replace("tomo.", ""), Ee = p.find((be) => be.id === $);
    Ee && b(Ee);
  }, [p, n, c]), useEffect(() => {
    le && a && L(le, a);
  }, [le, a, L]), useEffect(() => F ? F.on("disconnect", ($) => {
    $.id.startsWith("tomo.") && A.disconnect();
  }) : void 0, [F, A]), null;
});
TomoBBNConnector.displayName = "TomoBBNConnector";
const createProvider = (n) => ({
  connectWallet: async () => void await n.connectWallet(),
  getAddress: () => n.getAddress(),
  getPublicKeyHex: () => n.getPublicKeyHex(),
  signPsbt: (c, u) => n.signPsbt(c, u),
  signPsbts: (c, u) => n.signPsbts(c, u),
  getNetwork: () => n.getNetwork(),
  signMessage: (c, u) => n.signMessage(c, u),
  on: (c, u) => n.on(c, u),
  off: (c, u) => n.off(c, u),
  getWalletProviderName: () => n.getWalletProviderName(),
  getWalletProviderIcon: () => n.getWalletProviderIcon(),
  getInscriptions: () => n.getInscriptions().then(
    (c) => (c.list || []).map((u) => ({
      txid: u.inscriptionId,
      vout: u.outputValue
    }))
  )
}), TomoBTCConnector = memo(({ persistent: n, storage: c }) => {
  const u = Fn(), p = Nn("bitcoin"), { bitcoinProvider: a } = Hn(), A = Jn(), b = _0(), F = useChainConnector("BTC"), le = useMemo(() => {
    const { connected: pe, walletId: $ } = u.bitcoin ?? {};
    return pe && $ ? p.find((Ee) => Ee.id === $) ?? null : null;
  }, [u.bitcoin, p]), L = useCallback(
    async (pe, $) => {
      if (!F) return;
      const Ee = createExternalWallet({
        id: `tomo.${pe.id}`,
        name: pe.name,
        icon: pe.img,
        provider: createProvider($)
      });
      await F.connect(Ee);
    },
    [F]
  );
  return useEffect(() => {
    if (!n) return;
    const pe = c.get("BTC");
    if (!pe || !pe.startsWith("tomo.")) return;
    const $ = pe.replace("tomo.", ""), Ee = p.find((be) => be.id === $);
    Ee && b(Ee);
  }, [p, n, c]), useEffect(() => {
    le && a && L(le, a);
  }, [le, a, L]), useEffect(() => F ? F.on("disconnect", ($) => {
    $.id.startsWith("tomo.") && A.disconnect();
  }) : void 0, [F, A]), null;
});
TomoBTCConnector.displayName = "TomoBTCConnector";
var freeGlobal = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal, freeSelf = typeof self == "object" && self && self.Object === Object && self;
freeGlobal || freeSelf || Function("return this")();
var useIsomorphicLayoutEffect = typeof window < "u" ? useLayoutEffect : useEffect, IS_SERVER2 = typeof window > "u";
function useMediaQuery(n, {
  defaultValue: c = !1,
  initializeWithValue: u = !0
} = {}) {
  const p = (F) => IS_SERVER2 ? c : window.matchMedia(F).matches, [a, A] = useState(() => u ? p(n) : c);
  function b() {
    A(p(n));
  }
  return useIsomorphicLayoutEffect(() => {
    const F = window.matchMedia(n);
    return b(), F.addListener ? F.addListener(b) : F.addEventListener("change", b), () => {
      F.removeListener ? F.removeListener(b) : F.removeEventListener("change", b);
    };
  }, [n]), a;
}
const useIsMobileView = () => useMediaQuery("(max-width: 768px)");
function ResponsiveDialog(n) {
  const u = useIsMobileView() ? MobileDialog : Dialog;
  return /* @__PURE__ */ jsx(u, { ...n });
}
const useWidgetState = () => useContext(StateContext);
function useWalletConnect() {
  const { confirmed: n, chains: c, selectedWallets: u, open: p, reset: a } = useWidgetState(), A = useChainProviders(), b = useCallback(() => {
    a == null || a(), p == null || p();
  }, [p, a]), F = useCallback(async () => {
    for (const L of Object.values(A))
      L && await L.disconnect();
    a == null || a();
  }, [A, a]), le = useMemo(() => Object.values(c).filter(Boolean).map(($) => u[$.id]).every(Boolean), [c, u]);
  return {
    selected: le,
    connected: le && n,
    open: b,
    disconnect: F
  };
}
function useWalletConnectors({ persistent: n, accountStorage: c, onError: u }) {
  const p = useChainProviders(), {
    visible: a,
    selectWallet: A,
    removeWallet: b,
    displayLoader: F,
    displayChains: le,
    displayInscriptions: L,
    displayError: pe,
    confirm: $,
    close: Ee,
    reset: be
  } = useWidgetState(), { showAgain: He } = useInscriptionProvider(), { verifyBTCAddress: Pe, acceptTermsOfService: nr } = useLifeCycleHooks();
  useEffect(() => {
    if (!a) return;
    const Ir = Object.values(p).filter(Boolean).map(
      (xr) => xr.on("connecting", (kr) => {
        F == null || F(kr);
      })
    );
    return () => Ir.forEach((xr) => xr());
  }, [a, F, p]), useEffect(() => {
    const lr = Object.values(p).filter(Boolean), Ir = {
      BTC: (kr) => async (Ce) => {
        var tr, Fe, Sr;
        try {
          if (!Ce || !Ce.account || (A == null || A("BTC", Ce), n && c.set(kr.id, Ce.id), !a)) return;
          validateAddress(kr.config.network, Ce.account.address), await (nr == null ? void 0 : nr({
            address: Ce.account.address,
            public_key: Ce.account.publicKeyHex
          }));
          const er = () => void (He ? L == null ? void 0 : L() : le == null ? void 0 : le());
          if (!validateAddressWithPK(
            ((tr = Ce.account) == null ? void 0 : tr.address) ?? "",
            ((Fe = Ce.account) == null ? void 0 : Fe.publicKeyHex) ?? "",
            kr.config.network
          )) {
            pe == null || pe({
              title: "Public Key Mismatch",
              description: "The Bitcoin address and Public Key for this wallet do not match. Please contact your wallet provider for support.",
              onSubmit: er,
              onCancel: () => {
                kr.disconnect(), b == null || b(kr.id), le == null || le();
              }
            });
            return;
          }
          if (Pe && !await Pe(((Sr = Ce.account) == null ? void 0 : Sr.address) ?? "")) {
            pe == null || pe({
              title: "Staking Currently Unavailable",
              description: "Staking is temporarily disabled due to network downtime. New stakes are paused until the network resumes.",
              submitButton: "",
              cancelButton: "Done",
              onCancel: async () => {
                kr.disconnect(), b == null || b(kr.id), le == null || le();
              }
            });
            return;
          }
          er();
        } catch (er) {
          kr.disconnect(), b == null || b(kr.id), pe == null || pe({
            title: "Connection Failed",
            description: er.message,
            submitButton: "",
            cancelButton: "Done",
            onCancel: async () => {
              le == null || le();
            }
          });
        }
      },
      BBN: (kr) => (Ce) => {
        Ce && (A == null || A(kr.id, Ce), n && c.set(kr.id, Ce.id)), le == null || le();
      }
    }, xr = lr.map(
      (kr) => {
        var Ce;
        return kr.on("connect", (Ce = Ir[kr.id]) == null ? void 0 : Ce.call(Ir, kr));
      }
    );
    return lr.forEach((kr) => {
      A == null || A(kr.id, kr.connectedWallet);
    }), () => xr.forEach((kr) => kr());
  }, [
    u,
    A,
    b,
    L,
    le,
    Pe,
    be,
    Ee,
    p,
    He,
    n,
    a
  ]), useEffect(() => {
    const Ir = Object.values(p).filter(Boolean).map(
      (xr) => xr.on("disconnect", (kr) => {
        kr && (b == null || b(xr.id), le == null || le(), n && c.delete(xr.id));
      })
    );
    return () => Ir.forEach((xr) => xr());
  }, [b, le, p, n]), useEffect(() => {
    const Ir = Object.values(p).filter(Boolean).map(
      (xr) => xr.on("error", (kr) => {
        u == null || u(kr), le == null || le();
      })
    );
    return () => Ir.forEach((xr) => xr());
  }, [u, le, p]), useEffect(() => {
    const lr = Object.values(p).filter(Boolean);
    n && lr.length && lr.every((Ir) => c.has(Ir.id)) && ($ == null || $(), le == null || le());
  }, [n, p, $, le]);
  const ir = useCallback(
    async (lr, Ir) => {
      const xr = p[lr.id];
      await (xr == null ? void 0 : xr.connect(Ir.id));
    },
    [p]
  ), or = useCallback(
    async (lr) => {
      const Ir = p[lr];
      await (Ir == null ? void 0 : Ir.disconnect());
    },
    [p]
  );
  return { connect: ir, disconnect: or };
}
function useWalletWidgets(n, c, u) {
  const p = useCallback(
    (a, A) => /* @__PURE__ */ jsx(Fragment, { children: A.map(({ id: b, widget: F }) => /* @__PURE__ */ jsx(
      F,
      {
        id: b,
        connector: n[a],
        createWallet: createExternalWallet,
        onError: u
      },
      b
    )) }),
    [n, u]
  );
  return useMemo(
    () => c.reduce(
      (a, A) => ({
        ...a,
        [A.chain]: p(A.chain, A.connectors ?? [])
      }),
      {}
    ),
    [p, c]
  );
}
function ChainButton({ className: n, disabled: c, alt: u, logo: p, title: a, children: A, onClick: b }) {
  const F = typeof p == "string" ? /* @__PURE__ */ jsx(Avatar, { url: p, alt: u }) : /* @__PURE__ */ jsx(Avatar, { children: p });
  return /* @__PURE__ */ jsxs(
    Text,
    {
      disabled: c,
      as: c ? "div" : "button",
      className: twMerge(
        "flex w-full flex-col gap-2.5 rounded border border-secondary-strokeLight bg-surface p-4 text-accent-primary",
        c ? "pointer-events-none" : "pointer-events-auto",
        c ? "cursor-default" : "cursor-pointer",
        n
      ),
      onClick: b,
      children: [
        /* @__PURE__ */ jsxs("div", { className: "flex w-full items-center gap-2.5", children: [
          /* @__PURE__ */ jsx("div", { className: "flex items-center", children: F }),
          a,
          !c && /* @__PURE__ */ jsx(
            "svg",
            {
              xmlns: "http://www.w3.org/2000/svg",
              width: "24",
              height: "24",
              viewBox: "0 0 24 24",
              fill: "none",
              className: "ml-auto block",
              children: /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M8.58984 16.59L13.1698 12L8.58984 7.41L9.99984 6L15.9998 12L9.99984 18L8.58984 16.59Z",
                  fill: "currentColor"
                }
              )
            }
          )
        ] }),
        A && /* @__PURE__ */ jsx("div", { className: "pointer-events-auto w-full", onClick: (le) => le.stopPropagation(), children: A })
      ]
    }
  );
}
const formatAddress = (n, c = 8) => n.length <= c ? n : c === 0 ? "..." : `${n.slice(0, c / 2)}...${n.slice(-c / 2)}`, ConnectedWallet = memo(
  ({ className: n, chainId: c, logo: u, name: p, address: a, onDisconnect: A }) => /* @__PURE__ */ jsxs(
    "div",
    {
      className: twMerge("flex shrink-0 items-center gap-2.5 rounded border border-secondary-main/30 p-2", n),
      children: [
        /* @__PURE__ */ jsx(Avatar, { variant: "rounded", size: "medium", url: u }),
        /* @__PURE__ */ jsxs("div", { className: "flex flex-1 flex-col items-start", children: [
          /* @__PURE__ */ jsx(Text, { as: "div", variant: "body2", className: "leading-4 text-accent-primary", children: p }),
          !!a && /* @__PURE__ */ jsx(Text, { as: "div", variant: "caption", className: "leading-4 text-accent-secondary", children: formatAddress(a) })
        ] }),
        /* @__PURE__ */ jsx("button", { className: "shrink-0 cursor-pointer", onClick: () => void (A == null ? void 0 : A(c)), children: /* @__PURE__ */ jsx(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            className: "text-secondary-main",
            fill: "none",
            children: /* @__PURE__ */ jsx(
              "path",
              {
                d: "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z",
                fill: "currentColor"
              }
            )
          }
        ) })
      ]
    }
  )
), Chains = memo(
  ({
    disabled: n = !1,
    chains: c,
    selectedWallets: u = {},
    className: p,
    onClose: a,
    onConfirm: A,
    onSelectChain: b,
    onDisconnectWallet: F
  }) => /* @__PURE__ */ jsxs("div", { className: twMerge("flex flex-1 flex-col text-accent-primary", p), children: [
    /* @__PURE__ */ jsx(DialogHeader, { className: "mb-10", title: "Connect Wallets", onClose: a, children: /* @__PURE__ */ jsx(Text, { className: "text-accent-secondary", children: "Connect to both Bitcoin and Babylon Chain Wallets" }) }),
    /* @__PURE__ */ jsx(DialogBody, { className: "flex flex-col gap-6", children: c.map((le) => {
      var pe;
      const L = u[le.id];
      return /* @__PURE__ */ jsx(
        ChainButton,
        {
          disabled: !!L,
          title: `Select ${le.name} Wallet`,
          logo: le.icon,
          alt: le.name,
          onClick: () => void (b == null ? void 0 : b(le)),
          children: L && /* @__PURE__ */ jsx(
            ConnectedWallet,
            {
              chainId: le.id,
              logo: L.icon,
              name: L.name,
              address: ((pe = L.account) == null ? void 0 : pe.address) ?? "",
              onDisconnect: F
            }
          )
        },
        le.id
      );
    }) }),
    /* @__PURE__ */ jsxs(DialogFooter, { className: "mt-auto flex gap-4 pt-10", children: [
      /* @__PURE__ */ jsx(Button, { variant: "outlined", fluid: !0, onClick: a, children: "Cancel" }),
      /* @__PURE__ */ jsx(Button, { disabled: n, fluid: !0, onClick: A, children: "Done" })
    ] })
  ] })
);
function ChainsContainer(n) {
  const { chains: c, selectedWallets: u, displayWallets: p } = useWidgetState(), { selected: a } = useWalletConnect(), A = useMemo(() => Object.values(c), [c]), b = useCallback(
    (F) => {
      p == null || p(F.id);
    },
    [p]
  );
  return /* @__PURE__ */ jsx(
    Chains,
    {
      disabled: !a,
      chains: A,
      selectedWallets: u,
      onSelectChain: b,
      ...n
    }
  );
}
const DEFAULT_ICON = /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "52", height: "52", viewBox: "0 0 52 52", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    d: "M2.16675 46.5837H49.8334L26.0001 5.41699L2.16675 46.5837ZM28.1667 40.0837H23.8334V35.7503H28.1667V40.0837ZM28.1667 31.417H23.8334V22.7503H28.1667V31.417Z",
    fill: "#387085"
  }
) });
function Error$1({
  className: n,
  icon: c = DEFAULT_ICON,
  title: u,
  description: p,
  cancelButton: a = "Cancel",
  submitButton: A = /* @__PURE__ */ jsxs(Fragment, { children: [
    "Continue ",
    /* @__PURE__ */ jsx("span", { className: "hidden md:inline", children: "Anyway" })
  ] }),
  onCancel: b,
  onSubmit: F
}) {
  return /* @__PURE__ */ jsxs("div", { className: n, children: [
    /* @__PURE__ */ jsxs(DialogBody, { className: "py-16 text-center", children: [
      /* @__PURE__ */ jsx("div", { className: "mb-6 inline-flex h-20 w-20 items-center justify-center bg-primary-contrast text-primary-light", children: c }),
      /* @__PURE__ */ jsx(Heading, { variant: "h4", className: "mb-4 text-accent-primary", children: u }),
      /* @__PURE__ */ jsx(Text, { as: "div", className: "text-accent-secondary", children: p })
    ] }),
    /* @__PURE__ */ jsxs(DialogFooter, { className: "flex gap-4", children: [
      a && /* @__PURE__ */ jsx(Button, { variant: "outlined", fluid: !0, onClick: b, children: a }),
      A && /* @__PURE__ */ jsx(Button, { fluid: !0, onClick: F, children: A })
    ] })
  ] });
}
function ErrorContainer({ className: n }) {
  const { screen: c } = useWidgetState(), { icon: u, title: p, description: a, cancelButton: A, submitButton: b, onCancel: F, onSubmit: le } = c.params ?? {};
  return /* @__PURE__ */ jsx(
    Error$1,
    {
      className: n,
      icon: u,
      title: p,
      description: a,
      cancelButton: A,
      submitButton: b,
      onCancel: F,
      onSubmit: le
    }
  );
}
function FieldControl({ label: n, className: c, children: u }) {
  return /* @__PURE__ */ jsxs(
    "label",
    {
      className: twMerge(
        "flex cursor-pointer gap-4 rounded border border-secondary-strokeLight text-accent-primary p-4",
        c
      ),
      children: [
        u,
        n
      ]
    }
  );
}
function Inscriptions({ className: n, config: c, onSubmit: u }) {
  const [p = !0, a] = useState(), [A = !0, b] = useState();
  if (!c) return null;
  const { coinName: F } = c;
  return /* @__PURE__ */ jsxs("div", { className: twMerge("flex flex-1 flex-col", n), children: [
    /* @__PURE__ */ jsx(
      DialogHeader,
      {
        title: `Manage ${F} Inscriptions`,
        className: "mb-4 text-accent-primary",
        onClose: () => void (u == null ? void 0 : u(p, A))
      }
    ),
    /* @__PURE__ */ jsxs(DialogBody, { children: [
      /* @__PURE__ */ jsxs(Text, { className: "mb-8 text-accent-secondary", children: [
        "By default, we will not use ",
        F,
        " that contains Inscriptions - such as Ordinals, NFTs, or Runes - in your stakeable balance. This helps prevent any accidental loss of your Inscriptions due to staking, unbonding, or withdrawal fees."
      ] }),
      /* @__PURE__ */ jsxs(Text, { className: "mb-10 text-accent-secondary", children: [
        "If you would like to include ",
        F,
        " with Inscriptions in your stakeable balance, please select the option below."
      ] }),
      /* @__PURE__ */ jsxs("form", { action: "", children: [
        /* @__PURE__ */ jsx(
          FieldControl,
          {
            label: /* @__PURE__ */ jsxs("div", { children: [
              /* @__PURE__ */ jsx("strong", { className: "mr-2", children: "Do not use" }),
              " ",
              F,
              " with Inscriptions for staking. (Recommended)"
            ] }),
            className: "mb-8",
            children: /* @__PURE__ */ jsx(Radio, { name: "inscriptions", checked: p, onChange: () => a(!0) })
          }
        ),
        /* @__PURE__ */ jsx(
          FieldControl,
          {
            label: /* @__PURE__ */ jsxs("div", { children: [
              /* @__PURE__ */ jsx("strong", { className: "mr-2", children: "Use" }),
              " ",
              F,
              " with Inscriptions in my stakable balance."
            ] }),
            className: "mb-8",
            children: /* @__PURE__ */ jsx(Radio, { name: "inscriptions", checked: !p, onChange: () => a(!1) })
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ jsxs(DialogFooter, { className: "mt-auto pt-10", children: [
      /* @__PURE__ */ jsx(
        Checkbox,
        {
          checked: !A,
          label: "Do not show again",
          labelClassName: "mb-6",
          onChange: (le) => b(!le)
        }
      ),
      /* @__PURE__ */ jsx(Button, { fluid: !0, onClick: () => void (u == null ? void 0 : u(p, A)), children: "Save" })
    ] })
  ] });
}
function InscriptionsContainer({ className: n, onSubmit: c }) {
  var p;
  const { chains: u } = useWidgetState();
  return /* @__PURE__ */ jsx(Inscriptions, { className: n, onSubmit: c, config: (p = u.BTC) == null ? void 0 : p.config });
}
function LoaderScreen({ className: n, title: c }) {
  return /* @__PURE__ */ jsxs("div", { className: twMerge("flex flex-col items-center justify-center gap-6", n), children: [
    /* @__PURE__ */ jsx("div", { className: "flex items-center justify-center bg-primary-contrast p-6", children: /* @__PURE__ */ jsx(Loader, { className: "text-primary-light" }) }),
    c && /* @__PURE__ */ jsx(Heading, { variant: "h4", className: "capitalize text-accent-primary", children: c })
  ] });
}
const defaultState = {
  termsOfUse: !1,
  inscriptions: !1,
  staking: !1
};
function TermsOfService({ className: n, onClose: c, onSubmit: u }) {
  const [p, a] = useState(defaultState), A = useMemo(() => Object.values(p).every((F) => F), [p]), b = useCallback(
    (F) => (le = !1) => {
      a((L) => ({ ...L, [F]: le }));
    },
    []
  );
  return /* @__PURE__ */ jsxs("div", { className: twMerge("flex flex-1 flex-col", n), children: [
    /* @__PURE__ */ jsx(DialogHeader, { className: "mb-10 text-accent-primary", title: "Connect Wallets", onClose: c, children: /* @__PURE__ */ jsx(Text, { className: "text-accent-secondary", children: "Please read and accept the following terms" }) }),
    /* @__PURE__ */ jsxs(DialogBody, { children: [
      /* @__PURE__ */ jsx(
        FieldControl,
        {
          label: /* @__PURE__ */ jsxs("div", { className: "block", children: [
            "I certify that I have read and accept the updated",
            " ",
            /* @__PURE__ */ jsx(
              "a",
              {
                href: "https://babylonlabs.io/terms-of-use",
                target: "_blank",
                rel: "noopener noreferrer",
                className: "underline",
                children: "Terms of Use"
              }
            ),
            " ",
            "and",
            " ",
            /* @__PURE__ */ jsx(
              "a",
              {
                href: "https://babylonlabs.io/privacy-policy",
                target: "_blank",
                rel: "noopener noreferrer",
                className: "underline",
                children: "Privacy Policy"
              }
            ),
            "."
          ] }),
          className: "mb-8",
          children: /* @__PURE__ */ jsx(Checkbox, { checked: p.termsOfUse, onChange: b("termsOfUse") })
        }
      ),
      /* @__PURE__ */ jsx(
        FieldControl,
        {
          label: "I certify that I wish to stake bitcoin and agree that doing so may cause some or all of the bitcoin ordinals, NFTs, Runes, and other inscriptions in the connected bitcoin wallet to be lost. I acknowledge that this interface will not detect all Inscriptions.",
          className: "mb-8",
          children: /* @__PURE__ */ jsx(Checkbox, { checked: p.inscriptions, onChange: b("inscriptions") })
        }
      ),
      /* @__PURE__ */ jsx(FieldControl, { label: "I acknowledge that the following are the only hardware wallets supporting Bitcoin Staking: (1) Keystone -- via QR code and (2) OneKey -- via the OneKey Chrome extension and the hardware devices (a) OneKey Pro and (b) OneKey Classic 1s (experimental, 3.10.1 firmware or higher) using Taproot only. Using any other hardware wallet through any means (such as connection to a software/extension/mobile wallet) can lead to permanent inability to withdraw the stake.", children: /* @__PURE__ */ jsx(Checkbox, { checked: p.staking, onChange: b("staking") }) })
    ] }),
    /* @__PURE__ */ jsx(DialogFooter, { className: "mt-auto pt-10", children: /* @__PURE__ */ jsx(Button, { disabled: !A, fluid: !0, onClick: u, children: "Next" }) })
  ] });
}
function TermsOfServiceContainer(n) {
  var u;
  const { chains: c } = useWidgetState();
  return /* @__PURE__ */ jsx(TermsOfService, { ...n, config: (u = c.BTC) == null ? void 0 : u.config });
}
function WalletButton({
  className: n,
  disabled: c = !1,
  name: u,
  logo: p,
  label: a,
  fallbackLink: A,
  installed: b = !0,
  onClick: F
}) {
  const le = b ? { as: "button", disabled: c, onClick: F } : { as: "a", href: A, target: "_blank" };
  return /* @__PURE__ */ jsxs(
    Text,
    {
      className: twMerge(
        "flex h-14 w-full cursor-pointer items-center gap-2.5 rounded border border-secondary-strokeLight text-accent-primary px-2",
        c ? "cursor-default" : "cursor-pointer",
        n
      ),
      ...le,
      children: [
        /* @__PURE__ */ jsx(Avatar, { variant: "rounded", className: "shrink-0", alt: u, url: p }),
        u,
        a && /* @__PURE__ */ jsx(Chip, { className: "ml-auto shrink-0", children: a })
      ]
    }
  );
}
const Wallets = memo(({ chain: n, className: c, append: u, onClose: p, onBack: a, onSelectWallet: A }) => {
  const b = useMemo(
    () => n.wallets.filter((F) => F.id === "injectable" ? F.installed : !0),
    [n]
  );
  return /* @__PURE__ */ jsxs("div", { className: twMerge("flex flex-1 flex-col", c), children: [
    /* @__PURE__ */ jsx(DialogHeader, { className: "text-accent-primary mb-10", title: "Select Wallet", onClose: p, children: /* @__PURE__ */ jsxs(Text, { className: "text-accent-secondary", children: [
      "Connect a ",
      n.name,
      " Wallet"
    ] }) }),
    /* @__PURE__ */ jsxs(DialogBody, { children: [
      /* @__PURE__ */ jsx("div", { className: twMerge("grid gap-6", b.length > 1 ? "grid-cols-1 md:grid-cols-2" : "grid-cols-1"), children: b.map((F) => /* @__PURE__ */ jsx(
        WalletButton,
        {
          installed: F.installed,
          name: F.name,
          logo: F.icon,
          label: F.label,
          fallbackLink: F.docs,
          onClick: () => A == null ? void 0 : A(n, F)
        },
        F.id
      )) }),
      u
    ] }),
    /* @__PURE__ */ jsx(DialogFooter, { className: "mt-auto pt-10", children: /* @__PURE__ */ jsx(Button, { variant: "outlined", fluid: !0, onClick: a, children: "Back" }) })
  ] });
});
function WalletsContainer({ widgets: n = {}, ...c }) {
  var le;
  const { chains: u, screen: p, displayChains: a } = useWidgetState(), A = ((le = p.params) == null ? void 0 : le.chain) ?? "", b = u == null ? void 0 : u[A], F = n == null ? void 0 : n[A];
  return /* @__PURE__ */ jsx(Wallets, { append: F, chain: b, onBack: a, ...c });
}
const SCREENS = {
  TERMS_OF_SERVICE: ({ className: n, onClose: c, onAccepTermsOfService: u }) => /* @__PURE__ */ jsx(TermsOfServiceContainer, { className: n, onClose: c, onSubmit: u }),
  CHAINS: ({ className: n, onClose: c, onConfirm: u, onDisconnectWallet: p }) => /* @__PURE__ */ jsx(ChainsContainer, { className: n, onClose: c, onConfirm: u, onDisconnectWallet: p }),
  WALLETS: ({ className: n, widgets: c, onClose: u, onSelectWallet: p }) => /* @__PURE__ */ jsx(WalletsContainer, { widgets: c, className: n, onClose: u, onSelectWallet: p }),
  INSCRIPTIONS: ({ className: n, onToggleInscriptions: c }) => /* @__PURE__ */ jsx(InscriptionsContainer, { className: n, onSubmit: c }),
  LOADER: ({ className: n, current: c }) => {
    var u;
    return /* @__PURE__ */ jsx(LoaderScreen, { className: n, title: (u = c == null ? void 0 : c.params) == null ? void 0 : u.message });
  },
  ERROR: () => /* @__PURE__ */ jsx(ErrorContainer, { className: "min-h-0 md:w-[600px]" }),
  EMPTY: ({ className: n }) => /* @__PURE__ */ jsx("div", { className: n })
};
function Screen(n) {
  const c = SCREENS[n.current.type] ?? SCREENS.EMPTY;
  return /* @__PURE__ */ jsx(c, { ...n });
}
const ANIMATION_DELAY = 1e3;
function WalletDialog({ persistent: n, storage: c, config: u, onError: p }) {
  const { visible: a, screen: A, confirmed: b, close: F, confirm: le, displayChains: L } = useWidgetState(), { toggleShowAgain: pe, toggleLockInscriptions: $ } = useInscriptionProvider(), Ee = useChainProviders(), be = useWalletWidgets(Ee, u, p), { connect: He, disconnect: Pe } = useWalletConnectors({ persistent: n, accountStorage: c, onError: p }), { disconnect: nr } = useWalletConnect(), ir = useCallback(() => {
    L == null || L();
  }, [L]), or = useCallback(
    (xr, kr) => {
      pe == null || pe(kr), $ == null || $(xr), L == null || L();
    },
    [pe, $, L]
  ), lr = useCallback(() => {
    F == null || F(), b || setTimeout(nr, ANIMATION_DELAY);
  }, [F, nr, b]), Ir = useCallback(() => {
    le == null || le(), F == null || F();
  }, [le]);
  return /* @__PURE__ */ jsx(ResponsiveDialog, { className: "min-h-[80%]", open: a, onClose: lr, children: /* @__PURE__ */ jsx(
    Screen,
    {
      current: A,
      widgets: be,
      className: "min-h-0 md:size-[600px]",
      onClose: lr,
      onConfirm: Ir,
      onSelectWallet: He,
      onAccepTermsOfService: ir,
      onToggleInscriptions: or,
      onDisconnectWallet: Pe
    }
  ) });
}
const BBN_TESTNET_RPC_URL = "https://rpc-dapp.testnet.babylonlabs.io/", BBN_TESTNET_LCD_URL = "https://lcd-dapp.testnet.babylonlabs.io/", bbnTestnet = {
  chainId: "bbn-test-5",
  chainName: "Babylon Testnet",
  chainSymbolImageUrl: "https://raw.githubusercontent.com/chainapsis/keplr-chain-registry/main/images/bbn-test/chain.png",
  rpc: BBN_TESTNET_RPC_URL,
  rest: BBN_TESTNET_LCD_URL,
  nodeProvider: {
    name: "Babylonlabs",
    email: "contact@babylonlabs.io",
    website: "https://babylonlabs.io/"
  },
  bip44: {
    coinType: 118
  },
  bech32Config: {
    bech32PrefixAccAddr: "bbn",
    bech32PrefixAccPub: "bbnpub",
    bech32PrefixValAddr: "bbnvaloper",
    bech32PrefixValPub: "bbnvaloperpub",
    bech32PrefixConsAddr: "bbnvalcons",
    bech32PrefixConsPub: "bbnvalconspub"
  },
  currencies: [
    {
      coinDenom: "BABY",
      coinMinimalDenom: "ubbn",
      coinDecimals: 6,
      coinImageUrl: "https://raw.githubusercontent.com/chainapsis/keplr-chain-registry/main/images/bbn-test/chain.png"
    }
  ],
  feeCurrencies: [
    {
      coinDenom: "BABY",
      coinMinimalDenom: "ubbn",
      coinDecimals: 6,
      coinImageUrl: "https://raw.githubusercontent.com/chainapsis/keplr-chain-registry/main/images/bbn-test/chain.png",
      gasPriceStep: {
        low: 7e-3,
        average: 7e-3,
        high: 0.01
      }
    }
  ],
  stakeCurrency: {
    coinDenom: "BABY",
    coinMinimalDenom: "ubbn",
    coinDecimals: 6,
    coinImageUrl: "https://raw.githubusercontent.com/chainapsis/keplr-chain-registry/main/images/bbn-test/chain.png"
  },
  features: ["cosmwasm"]
}, ONE_HOUR = 60 * 60 * 1e3;
Network.SIGNET, bbnTestnet.currencies[0].coinDenom, bbnTestnet.chainName, bbnTestnet.currencies[0].coinDenom, bbnTestnet.chainId;
function WalletProvider({
  ttl: n = ONE_HOUR,
  persistent: c = !1,
  theme: u,
  lifecycleHooks: p,
  children: a,
  config: A,
  context: b = window,
  onError: F,
  disabledWallets: le
}) {
  const L = useMemo(() => createAccountStorage(n), [n]);
  return /* @__PURE__ */ jsx(TomoConnectionProvider, { theme: u, config: A, children: /* @__PURE__ */ jsx(LifeCycleHooksProvider, { value: p, children: /* @__PURE__ */ jsxs(
    ChainProvider,
    {
      persistent: c,
      storage: L,
      context: b,
      config: A,
      onError: F,
      disabledWallets: le,
      children: [
        a,
        /* @__PURE__ */ jsx(TomoBTCConnector, { persistent: c, storage: L }),
        /* @__PURE__ */ jsx(TomoBBNConnector, { persistent: c, storage: L }),
        /* @__PURE__ */ jsx(WalletDialog, { persistent: c, storage: L, config: A, onError: F })
      ]
    }
  ) }) });
}
export {
  ExternalWallets,
  Network,
  StateContext,
  StateProvider,
  WalletProvider,
  createExternalWallet,
  useChainConnector,
  useInscriptionProvider,
  useWalletConnect,
  useWidgetState
};
//# sourceMappingURL=index.es.js.map
